(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6ObR8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $4f509bf21ce2142e$export$ffb0004e005737fa; }, function (v) { return $4f509bf21ce2142e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $4f509bf21ce2142e$export$34b9dba7ce09269b; }, function (v) { return $4f509bf21ce2142e$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $4f509bf21ce2142e$export$25062201e9e25d76; }, function (v) { return $4f509bf21ce2142e$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4f509bf21ce2142e$export$ffb0004e005737fa;
var $4f509bf21ce2142e$export$34b9dba7ce09269b;
var $4f509bf21ce2142e$export$25062201e9e25d76;
"use strict";

var $exYeM = parcelRequire("exYeM");
var $4f509bf21ce2142e$var$k = Symbol.for("react.element"), $4f509bf21ce2142e$var$l = Symbol.for("react.fragment"), $4f509bf21ce2142e$var$m = Object.prototype.hasOwnProperty, $4f509bf21ce2142e$var$n = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $4f509bf21ce2142e$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4f509bf21ce2142e$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$4f509bf21ce2142e$var$m.call(a, b) && !$4f509bf21ce2142e$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $4f509bf21ce2142e$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $4f509bf21ce2142e$var$n.current
    };
}
$4f509bf21ce2142e$export$ffb0004e005737fa = $4f509bf21ce2142e$var$l;
$4f509bf21ce2142e$export$34b9dba7ce09269b = $4f509bf21ce2142e$var$q;
$4f509bf21ce2142e$export$25062201e9e25d76 = $4f509bf21ce2142e$var$q;

});
parcelRegister("exYeM", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bzfnW"));

});
parcelRegister("bzfnW", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $86bee5c140ae1e47$export$dca3b0875bd9a954; }, function (v) { return $86bee5c140ae1e47$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $86bee5c140ae1e47$export$16fa2f45be04daa8; }, function (v) { return $86bee5c140ae1e47$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $86bee5c140ae1e47$export$ffb0004e005737fa; }, function (v) { return $86bee5c140ae1e47$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $86bee5c140ae1e47$export$e2c29f18771995cb; }, function (v) { return $86bee5c140ae1e47$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $86bee5c140ae1e47$export$221d75b3f55bb0bd; }, function (v) { return $86bee5c140ae1e47$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $86bee5c140ae1e47$export$5f8d39834fd61797; }, function (v) { return $86bee5c140ae1e47$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $86bee5c140ae1e47$export$74bf444e3cd11ea5; }, function (v) { return $86bee5c140ae1e47$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $86bee5c140ae1e47$export$ae55be85d98224ed; }, function (v) { return $86bee5c140ae1e47$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $86bee5c140ae1e47$export$e530037191fcd5d7; }, function (v) { return $86bee5c140ae1e47$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $86bee5c140ae1e47$export$fd42f52fd3ae1109; }, function (v) { return $86bee5c140ae1e47$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $86bee5c140ae1e47$export$c8a8987d4410bf2d; }, function (v) { return $86bee5c140ae1e47$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $86bee5c140ae1e47$export$d38cd72104c1f0e9; }, function (v) { return $86bee5c140ae1e47$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43; }, function (v) { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $86bee5c140ae1e47$export$257a8862b851cb5b; }, function (v) { return $86bee5c140ae1e47$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $86bee5c140ae1e47$export$a8257692ac88316c; }, function (v) { return $86bee5c140ae1e47$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $86bee5c140ae1e47$export$488013bae63b21da; }, function (v) { return $86bee5c140ae1e47$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $86bee5c140ae1e47$export$7c73462e0d25e514; }, function (v) { return $86bee5c140ae1e47$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $86bee5c140ae1e47$export$7568632d0d33d16d; }, function (v) { return $86bee5c140ae1e47$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $86bee5c140ae1e47$export$88948ce120ea2619; }, function (v) { return $86bee5c140ae1e47$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $86bee5c140ae1e47$export$35808ee640e87ca7; }, function (v) { return $86bee5c140ae1e47$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $86bee5c140ae1e47$export$fae74005e78b1a27; }, function (v) { return $86bee5c140ae1e47$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e; }, function (v) { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf; }, function (v) { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $86bee5c140ae1e47$export$6d9c69b0de29b591; }, function (v) { return $86bee5c140ae1e47$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $86bee5c140ae1e47$export$f680877a34711e37; }, function (v) { return $86bee5c140ae1e47$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $86bee5c140ae1e47$export$d5a552a76deda3c2; }, function (v) { return $86bee5c140ae1e47$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $86bee5c140ae1e47$export$aaabe4eda9ed9969; }, function (v) { return $86bee5c140ae1e47$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $86bee5c140ae1e47$export$e5c5a5f917a5871c; }, function (v) { return $86bee5c140ae1e47$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $86bee5c140ae1e47$export$1538c33de8887b59; }, function (v) { return $86bee5c140ae1e47$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $86bee5c140ae1e47$export$13e3392192263954; }, function (v) { return $86bee5c140ae1e47$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $86bee5c140ae1e47$export$b8f5890fc79d6aca; }, function (v) { return $86bee5c140ae1e47$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $86bee5c140ae1e47$export$60241385465d0a34; }, function (v) { return $86bee5c140ae1e47$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $86bee5c140ae1e47$export$306c0aa65ff9ec16; }, function (v) { return $86bee5c140ae1e47$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $86bee5c140ae1e47$export$7b286972b8d8ccbf; }, function (v) { return $86bee5c140ae1e47$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $86bee5c140ae1e47$export$83d89fbfd8236492; }, function (v) { return $86bee5c140ae1e47$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $86bee5c140ae1e47$export$dca3b0875bd9a954;
var $86bee5c140ae1e47$export$16fa2f45be04daa8;
var $86bee5c140ae1e47$export$ffb0004e005737fa;
var $86bee5c140ae1e47$export$e2c29f18771995cb;
var $86bee5c140ae1e47$export$221d75b3f55bb0bd;
var $86bee5c140ae1e47$export$5f8d39834fd61797;
var $86bee5c140ae1e47$export$74bf444e3cd11ea5;
var $86bee5c140ae1e47$export$ae55be85d98224ed;
var $86bee5c140ae1e47$export$e530037191fcd5d7;
var $86bee5c140ae1e47$export$fd42f52fd3ae1109;
var $86bee5c140ae1e47$export$c8a8987d4410bf2d;
var $86bee5c140ae1e47$export$d38cd72104c1f0e9;
var $86bee5c140ae1e47$export$7d1e3a5e95ceca43;
var $86bee5c140ae1e47$export$257a8862b851cb5b;
var $86bee5c140ae1e47$export$a8257692ac88316c;
var $86bee5c140ae1e47$export$488013bae63b21da;
var $86bee5c140ae1e47$export$7c73462e0d25e514;
var $86bee5c140ae1e47$export$7568632d0d33d16d;
var $86bee5c140ae1e47$export$88948ce120ea2619;
var $86bee5c140ae1e47$export$35808ee640e87ca7;
var $86bee5c140ae1e47$export$fae74005e78b1a27;
var $86bee5c140ae1e47$export$dc8fbce3eb94dc1e;
var $86bee5c140ae1e47$export$6a7bc4e911dc01cf;
var $86bee5c140ae1e47$export$6d9c69b0de29b591;
var $86bee5c140ae1e47$export$f680877a34711e37;
var $86bee5c140ae1e47$export$d5a552a76deda3c2;
var $86bee5c140ae1e47$export$aaabe4eda9ed9969;
var $86bee5c140ae1e47$export$e5c5a5f917a5871c;
var $86bee5c140ae1e47$export$1538c33de8887b59;
var $86bee5c140ae1e47$export$13e3392192263954;
var $86bee5c140ae1e47$export$b8f5890fc79d6aca;
var $86bee5c140ae1e47$export$60241385465d0a34;
var $86bee5c140ae1e47$export$306c0aa65ff9ec16;
var $86bee5c140ae1e47$export$7b286972b8d8ccbf;
var $86bee5c140ae1e47$export$83d89fbfd8236492;
"use strict";
var $86bee5c140ae1e47$var$l = Symbol.for("react.element"), $86bee5c140ae1e47$var$n = Symbol.for("react.portal"), $86bee5c140ae1e47$var$p = Symbol.for("react.fragment"), $86bee5c140ae1e47$var$q = Symbol.for("react.strict_mode"), $86bee5c140ae1e47$var$r = Symbol.for("react.profiler"), $86bee5c140ae1e47$var$t = Symbol.for("react.provider"), $86bee5c140ae1e47$var$u = Symbol.for("react.context"), $86bee5c140ae1e47$var$v = Symbol.for("react.forward_ref"), $86bee5c140ae1e47$var$w = Symbol.for("react.suspense"), $86bee5c140ae1e47$var$x = Symbol.for("react.memo"), $86bee5c140ae1e47$var$y = Symbol.for("react.lazy"), $86bee5c140ae1e47$var$z = Symbol.iterator;
function $86bee5c140ae1e47$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $86bee5c140ae1e47$var$z && a[$86bee5c140ae1e47$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $86bee5c140ae1e47$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $86bee5c140ae1e47$var$C = Object.assign, $86bee5c140ae1e47$var$D = {};
function $86bee5c140ae1e47$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
$86bee5c140ae1e47$var$E.prototype.isReactComponent = {};
$86bee5c140ae1e47$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$86bee5c140ae1e47$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $86bee5c140ae1e47$var$F() {}
$86bee5c140ae1e47$var$F.prototype = $86bee5c140ae1e47$var$E.prototype;
function $86bee5c140ae1e47$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
var $86bee5c140ae1e47$var$H = $86bee5c140ae1e47$var$G.prototype = new $86bee5c140ae1e47$var$F;
$86bee5c140ae1e47$var$H.constructor = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$var$C($86bee5c140ae1e47$var$H, $86bee5c140ae1e47$var$E.prototype);
$86bee5c140ae1e47$var$H.isPureReactComponent = !0;
var $86bee5c140ae1e47$var$I = Array.isArray, $86bee5c140ae1e47$var$J = Object.prototype.hasOwnProperty, $86bee5c140ae1e47$var$K = {
    current: null
}, $86bee5c140ae1e47$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $86bee5c140ae1e47$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$86bee5c140ae1e47$var$J.call(b, d) && !$86bee5c140ae1e47$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $86bee5c140ae1e47$var$K.current
    };
}
function $86bee5c140ae1e47$var$N(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $86bee5c140ae1e47$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $86bee5c140ae1e47$var$l;
}
function $86bee5c140ae1e47$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $86bee5c140ae1e47$var$P = /\/+/g;
function $86bee5c140ae1e47$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $86bee5c140ae1e47$var$escape("" + a.key) : b.toString(36);
}
function $86bee5c140ae1e47$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $86bee5c140ae1e47$var$l:
                case $86bee5c140ae1e47$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $86bee5c140ae1e47$var$Q(h, 0) : d, $86bee5c140ae1e47$var$I(c) ? (e = "", null != a && (e = a.replace($86bee5c140ae1e47$var$P, "$&/") + "/"), $86bee5c140ae1e47$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($86bee5c140ae1e47$var$O(c) && (c = $86bee5c140ae1e47$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($86bee5c140ae1e47$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($86bee5c140ae1e47$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $86bee5c140ae1e47$var$Q(k, g);
        h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    }
    else if (f = $86bee5c140ae1e47$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $86bee5c140ae1e47$var$Q(k, g++), h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $86bee5c140ae1e47$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $86bee5c140ae1e47$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $86bee5c140ae1e47$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $86bee5c140ae1e47$var$U = {
    current: null
}, $86bee5c140ae1e47$var$V = {
    transition: null
}, $86bee5c140ae1e47$var$W = {
    ReactCurrentDispatcher: $86bee5c140ae1e47$var$U,
    ReactCurrentBatchConfig: $86bee5c140ae1e47$var$V,
    ReactCurrentOwner: $86bee5c140ae1e47$var$K
};
$86bee5c140ae1e47$export$dca3b0875bd9a954 = {
    map: $86bee5c140ae1e47$var$S,
    forEach: function(a, b, e) {
        $86bee5c140ae1e47$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $86bee5c140ae1e47$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $86bee5c140ae1e47$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$86bee5c140ae1e47$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$86bee5c140ae1e47$export$16fa2f45be04daa8 = $86bee5c140ae1e47$var$E;
$86bee5c140ae1e47$export$ffb0004e005737fa = $86bee5c140ae1e47$var$p;
$86bee5c140ae1e47$export$e2c29f18771995cb = $86bee5c140ae1e47$var$r;
$86bee5c140ae1e47$export$221d75b3f55bb0bd = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$export$5f8d39834fd61797 = $86bee5c140ae1e47$var$q;
$86bee5c140ae1e47$export$74bf444e3cd11ea5 = $86bee5c140ae1e47$var$w;
$86bee5c140ae1e47$export$ae55be85d98224ed = $86bee5c140ae1e47$var$W;
$86bee5c140ae1e47$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $86bee5c140ae1e47$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $86bee5c140ae1e47$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$86bee5c140ae1e47$var$J.call(b, f) && !$86bee5c140ae1e47$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$86bee5c140ae1e47$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $86bee5c140ae1e47$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $86bee5c140ae1e47$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$86bee5c140ae1e47$export$c8a8987d4410bf2d = $86bee5c140ae1e47$var$M;
$86bee5c140ae1e47$export$d38cd72104c1f0e9 = function(a) {
    var b = $86bee5c140ae1e47$var$M.bind(null, a);
    b.type = a;
    return b;
};
$86bee5c140ae1e47$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$86bee5c140ae1e47$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$v,
        render: a
    };
};
$86bee5c140ae1e47$export$a8257692ac88316c = $86bee5c140ae1e47$var$O;
$86bee5c140ae1e47$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $86bee5c140ae1e47$var$T
    };
};
$86bee5c140ae1e47$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$86bee5c140ae1e47$export$7568632d0d33d16d = function(a) {
    var b = $86bee5c140ae1e47$var$V.transition;
    $86bee5c140ae1e47$var$V.transition = {};
    try {
        a();
    } finally{
        $86bee5c140ae1e47$var$V.transition = b;
    }
};
$86bee5c140ae1e47$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$86bee5c140ae1e47$export$35808ee640e87ca7 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useCallback(a, b);
};
$86bee5c140ae1e47$export$fae74005e78b1a27 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useContext(a);
};
$86bee5c140ae1e47$export$dc8fbce3eb94dc1e = function() {};
$86bee5c140ae1e47$export$6a7bc4e911dc01cf = function(a) {
    return $86bee5c140ae1e47$var$U.current.useDeferredValue(a);
};
$86bee5c140ae1e47$export$6d9c69b0de29b591 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useEffect(a, b);
};
$86bee5c140ae1e47$export$f680877a34711e37 = function() {
    return $86bee5c140ae1e47$var$U.current.useId();
};
$86bee5c140ae1e47$export$d5a552a76deda3c2 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useImperativeHandle(a, b, e);
};
$86bee5c140ae1e47$export$aaabe4eda9ed9969 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useInsertionEffect(a, b);
};
$86bee5c140ae1e47$export$e5c5a5f917a5871c = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useLayoutEffect(a, b);
};
$86bee5c140ae1e47$export$1538c33de8887b59 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useMemo(a, b);
};
$86bee5c140ae1e47$export$13e3392192263954 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useReducer(a, b, e);
};
$86bee5c140ae1e47$export$b8f5890fc79d6aca = function(a) {
    return $86bee5c140ae1e47$var$U.current.useRef(a);
};
$86bee5c140ae1e47$export$60241385465d0a34 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useState(a);
};
$86bee5c140ae1e47$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useSyncExternalStore(a, b, e);
};
$86bee5c140ae1e47$export$7b286972b8d8ccbf = function() {
    return $86bee5c140ae1e47$var$U.current.useTransition();
};
$86bee5c140ae1e47$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("h8vP0", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c79bde28d689cb05$export$ae55be85d98224ed; }, function (v) { return $c79bde28d689cb05$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $c79bde28d689cb05$export$d39a5bbd09211389; }, function (v) { return $c79bde28d689cb05$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $c79bde28d689cb05$export$882461b6382ed46c; }, function (v) { return $c79bde28d689cb05$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $c79bde28d689cb05$export$466bfc07425424d5; }, function (v) { return $c79bde28d689cb05$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $c79bde28d689cb05$export$cd75ccfd720a3cd4; }, function (v) { return $c79bde28d689cb05$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $c79bde28d689cb05$export$fa8d919ba61d84db; }, function (v) { return $c79bde28d689cb05$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $c79bde28d689cb05$export$757ceba2d55c277e; }, function (v) { return $c79bde28d689cb05$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $c79bde28d689cb05$export$b3890eb0ae9dca99; }, function (v) { return $c79bde28d689cb05$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $c79bde28d689cb05$export$502457920280e6be; }, function (v) { return $c79bde28d689cb05$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $c79bde28d689cb05$export$c78a37762a8d58e1; }, function (v) { return $c79bde28d689cb05$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $c79bde28d689cb05$export$dc54d992c10e8a18; }, function (v) { return $c79bde28d689cb05$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $c79bde28d689cb05$export$83d89fbfd8236492; }, function (v) { return $c79bde28d689cb05$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $c79bde28d689cb05$export$ae55be85d98224ed;
var $c79bde28d689cb05$export$d39a5bbd09211389;
var $c79bde28d689cb05$export$882461b6382ed46c;
var $c79bde28d689cb05$export$466bfc07425424d5;
var $c79bde28d689cb05$export$cd75ccfd720a3cd4;
var $c79bde28d689cb05$export$fa8d919ba61d84db;
var $c79bde28d689cb05$export$757ceba2d55c277e;
var $c79bde28d689cb05$export$b3890eb0ae9dca99;
var $c79bde28d689cb05$export$502457920280e6be;
var $c79bde28d689cb05$export$c78a37762a8d58e1;
var $c79bde28d689cb05$export$dc54d992c10e8a18;
var $c79bde28d689cb05$export$83d89fbfd8236492;
"use strict";

var $exYeM = parcelRequire("exYeM");

var $ibqfJ = parcelRequire("ibqfJ");
function $c79bde28d689cb05$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c79bde28d689cb05$var$da = new Set, $c79bde28d689cb05$var$ea = {};
function $c79bde28d689cb05$var$fa(a, b) {
    $c79bde28d689cb05$var$ha(a, b);
    $c79bde28d689cb05$var$ha(a + "Capture", b);
}
function $c79bde28d689cb05$var$ha(a, b) {
    $c79bde28d689cb05$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$da.add(b[a]);
}
var $c79bde28d689cb05$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c79bde28d689cb05$var$ja = Object.prototype.hasOwnProperty, $c79bde28d689cb05$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $c79bde28d689cb05$var$la = {}, $c79bde28d689cb05$var$ma = {};
function $c79bde28d689cb05$var$oa(a) {
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$ma, a)) return !0;
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$la, a)) return !1;
    if ($c79bde28d689cb05$var$ka.test(a)) return $c79bde28d689cb05$var$ma[a] = !0;
    $c79bde28d689cb05$var$la[a] = !0;
    return !1;
}
function $c79bde28d689cb05$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $c79bde28d689cb05$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $c79bde28d689cb05$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $c79bde28d689cb05$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $c79bde28d689cb05$var$ra = /[\-:]([a-z])/g;
function $c79bde28d689cb05$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$c79bde28d689cb05$var$z.xlinkHref = new $c79bde28d689cb05$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $c79bde28d689cb05$var$ta(a, b, c, d) {
    var e = $c79bde28d689cb05$var$z.hasOwnProperty(b) ? $c79bde28d689cb05$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $c79bde28d689cb05$var$qa(b, c, e, d) && (c = null), d || null === e ? $c79bde28d689cb05$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $c79bde28d689cb05$var$ua = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $c79bde28d689cb05$var$va = Symbol.for("react.element"), $c79bde28d689cb05$var$wa = Symbol.for("react.portal"), $c79bde28d689cb05$var$ya = Symbol.for("react.fragment"), $c79bde28d689cb05$var$za = Symbol.for("react.strict_mode"), $c79bde28d689cb05$var$Aa = Symbol.for("react.profiler"), $c79bde28d689cb05$var$Ba = Symbol.for("react.provider"), $c79bde28d689cb05$var$Ca = Symbol.for("react.context"), $c79bde28d689cb05$var$Da = Symbol.for("react.forward_ref"), $c79bde28d689cb05$var$Ea = Symbol.for("react.suspense"), $c79bde28d689cb05$var$Fa = Symbol.for("react.suspense_list"), $c79bde28d689cb05$var$Ga = Symbol.for("react.memo"), $c79bde28d689cb05$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $c79bde28d689cb05$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $c79bde28d689cb05$var$Ja = Symbol.iterator;
function $c79bde28d689cb05$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c79bde28d689cb05$var$Ja && a[$c79bde28d689cb05$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c79bde28d689cb05$var$A = Object.assign, $c79bde28d689cb05$var$La;
function $c79bde28d689cb05$var$Ma(a) {
    if (void 0 === $c79bde28d689cb05$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $c79bde28d689cb05$var$La = b && b[1] || "";
    }
    return "\n" + $c79bde28d689cb05$var$La + a;
}
var $c79bde28d689cb05$var$Na = !1;
function $c79bde28d689cb05$var$Oa(a, b) {
    if (!a || $c79bde28d689cb05$var$Na) return "";
    $c79bde28d689cb05$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $c79bde28d689cb05$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $c79bde28d689cb05$var$Ma(a) : "";
}
function $c79bde28d689cb05$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $c79bde28d689cb05$var$Ma(a.type);
        case 16:
            return $c79bde28d689cb05$var$Ma("Lazy");
        case 13:
            return $c79bde28d689cb05$var$Ma("Suspense");
        case 19:
            return $c79bde28d689cb05$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $c79bde28d689cb05$var$Oa(a.type, !1), a;
        case 11:
            return a = $c79bde28d689cb05$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $c79bde28d689cb05$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $c79bde28d689cb05$var$ya:
            return "Fragment";
        case $c79bde28d689cb05$var$wa:
            return "Portal";
        case $c79bde28d689cb05$var$Aa:
            return "Profiler";
        case $c79bde28d689cb05$var$za:
            return "StrictMode";
        case $c79bde28d689cb05$var$Ea:
            return "Suspense";
        case $c79bde28d689cb05$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $c79bde28d689cb05$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $c79bde28d689cb05$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $c79bde28d689cb05$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $c79bde28d689cb05$var$Ga:
            return b = a.displayName || null, null !== b ? b : $c79bde28d689cb05$var$Qa(a.type) || "Memo";
        case $c79bde28d689cb05$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $c79bde28d689cb05$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $c79bde28d689cb05$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $c79bde28d689cb05$var$Qa(b);
        case 8:
            return b === $c79bde28d689cb05$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $c79bde28d689cb05$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $c79bde28d689cb05$var$Ua(a) {
    var b = $c79bde28d689cb05$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $c79bde28d689cb05$var$Va(a) {
    a._valueTracker || (a._valueTracker = $c79bde28d689cb05$var$Ua(a));
}
function $c79bde28d689cb05$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $c79bde28d689cb05$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $c79bde28d689cb05$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $c79bde28d689cb05$var$Ya(a, b) {
    var c = b.checked;
    return $c79bde28d689cb05$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $c79bde28d689cb05$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $c79bde28d689cb05$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $c79bde28d689cb05$var$ab(a, b) {
    b = b.checked;
    null != b && $c79bde28d689cb05$var$ta(a, "checked", b, !1);
}
function $c79bde28d689cb05$var$bb(a, b) {
    $c79bde28d689cb05$var$ab(a, b);
    var c = $c79bde28d689cb05$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $c79bde28d689cb05$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $c79bde28d689cb05$var$cb(a, b.type, $c79bde28d689cb05$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $c79bde28d689cb05$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $c79bde28d689cb05$var$cb(a, b, c) {
    if ("number" !== b || $c79bde28d689cb05$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $c79bde28d689cb05$var$eb = Array.isArray;
function $c79bde28d689cb05$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $c79bde28d689cb05$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $c79bde28d689cb05$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($c79bde28d689cb05$var$p(91));
    return $c79bde28d689cb05$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $c79bde28d689cb05$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($c79bde28d689cb05$var$p(92));
            if ($c79bde28d689cb05$var$eb(c)) {
                if (1 < c.length) throw Error($c79bde28d689cb05$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $c79bde28d689cb05$var$Sa(c)
    };
}
function $c79bde28d689cb05$var$ib(a, b) {
    var c = $c79bde28d689cb05$var$Sa(b.value), d = $c79bde28d689cb05$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $c79bde28d689cb05$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $c79bde28d689cb05$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $c79bde28d689cb05$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $c79bde28d689cb05$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $c79bde28d689cb05$var$mb, $c79bde28d689cb05$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $c79bde28d689cb05$var$mb = $c79bde28d689cb05$var$mb || document.createElement("div");
        $c79bde28d689cb05$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $c79bde28d689cb05$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $c79bde28d689cb05$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $c79bde28d689cb05$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $c79bde28d689cb05$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($c79bde28d689cb05$var$pb).forEach(function(a) {
    $c79bde28d689cb05$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $c79bde28d689cb05$var$pb[b] = $c79bde28d689cb05$var$pb[a];
    });
});
function $c79bde28d689cb05$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $c79bde28d689cb05$var$pb.hasOwnProperty(a) && $c79bde28d689cb05$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $c79bde28d689cb05$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $c79bde28d689cb05$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $c79bde28d689cb05$var$tb = $c79bde28d689cb05$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $c79bde28d689cb05$var$ub(a, b) {
    if (b) {
        if ($c79bde28d689cb05$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($c79bde28d689cb05$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($c79bde28d689cb05$var$p(62));
    }
}
function $c79bde28d689cb05$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c79bde28d689cb05$var$wb = null;
function $c79bde28d689cb05$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $c79bde28d689cb05$var$yb = null, $c79bde28d689cb05$var$zb = null, $c79bde28d689cb05$var$Ab = null;
function $c79bde28d689cb05$var$Bb(a) {
    if (a = $c79bde28d689cb05$var$Cb(a)) {
        if ("function" !== typeof $c79bde28d689cb05$var$yb) throw Error($c79bde28d689cb05$var$p(280));
        var b = a.stateNode;
        b && (b = $c79bde28d689cb05$var$Db(b), $c79bde28d689cb05$var$yb(a.stateNode, a.type, b));
    }
}
function $c79bde28d689cb05$var$Eb(a) {
    $c79bde28d689cb05$var$zb ? $c79bde28d689cb05$var$Ab ? $c79bde28d689cb05$var$Ab.push(a) : $c79bde28d689cb05$var$Ab = [
        a
    ] : $c79bde28d689cb05$var$zb = a;
}
function $c79bde28d689cb05$var$Fb() {
    if ($c79bde28d689cb05$var$zb) {
        var a = $c79bde28d689cb05$var$zb, b = $c79bde28d689cb05$var$Ab;
        $c79bde28d689cb05$var$Ab = $c79bde28d689cb05$var$zb = null;
        $c79bde28d689cb05$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$Bb(b[a]);
    }
}
function $c79bde28d689cb05$var$Gb(a, b) {
    return a(b);
}
function $c79bde28d689cb05$var$Hb() {}
var $c79bde28d689cb05$var$Ib = !1;
function $c79bde28d689cb05$var$Jb(a, b, c) {
    if ($c79bde28d689cb05$var$Ib) return a(b, c);
    $c79bde28d689cb05$var$Ib = !0;
    try {
        return $c79bde28d689cb05$var$Gb(a, b, c);
    } finally{
        if ($c79bde28d689cb05$var$Ib = !1, null !== $c79bde28d689cb05$var$zb || null !== $c79bde28d689cb05$var$Ab) $c79bde28d689cb05$var$Hb(), $c79bde28d689cb05$var$Fb();
    }
}
function $c79bde28d689cb05$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $c79bde28d689cb05$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($c79bde28d689cb05$var$p(231, b, typeof c));
    return c;
}
var $c79bde28d689cb05$var$Lb = !1;
if ($c79bde28d689cb05$var$ia) try {
    var $c79bde28d689cb05$var$Mb = {};
    Object.defineProperty($c79bde28d689cb05$var$Mb, "passive", {
        get: function() {
            $c79bde28d689cb05$var$Lb = !0;
        }
    });
    window.addEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
    window.removeEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
} catch (a) {
    $c79bde28d689cb05$var$Lb = !1;
}
function $c79bde28d689cb05$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $c79bde28d689cb05$var$Ob = !1, $c79bde28d689cb05$var$Pb = null, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, $c79bde28d689cb05$var$Sb = {
    onError: function(a) {
        $c79bde28d689cb05$var$Ob = !0;
        $c79bde28d689cb05$var$Pb = a;
    }
};
function $c79bde28d689cb05$var$Tb(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Ob = !1;
    $c79bde28d689cb05$var$Pb = null;
    $c79bde28d689cb05$var$Nb.apply($c79bde28d689cb05$var$Sb, arguments);
}
function $c79bde28d689cb05$var$Ub(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Tb.apply(this, arguments);
    if ($c79bde28d689cb05$var$Ob) {
        if ($c79bde28d689cb05$var$Ob) {
            var l = $c79bde28d689cb05$var$Pb;
            $c79bde28d689cb05$var$Ob = !1;
            $c79bde28d689cb05$var$Pb = null;
        } else throw Error($c79bde28d689cb05$var$p(198));
        $c79bde28d689cb05$var$Qb || ($c79bde28d689cb05$var$Qb = !0, $c79bde28d689cb05$var$Rb = l);
    }
}
function $c79bde28d689cb05$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $c79bde28d689cb05$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $c79bde28d689cb05$var$Xb(a) {
    if ($c79bde28d689cb05$var$Vb(a) !== a) throw Error($c79bde28d689cb05$var$p(188));
}
function $c79bde28d689cb05$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $c79bde28d689cb05$var$Vb(a);
        if (null === b) throw Error($c79bde28d689cb05$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $c79bde28d689cb05$var$Xb(e), a;
                if (f === d) return $c79bde28d689cb05$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($c79bde28d689cb05$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($c79bde28d689cb05$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($c79bde28d689cb05$var$p(190));
    }
    if (3 !== c.tag) throw Error($c79bde28d689cb05$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $c79bde28d689cb05$var$Zb(a) {
    a = $c79bde28d689cb05$var$Yb(a);
    return null !== a ? $c79bde28d689cb05$var$$b(a) : null;
}
function $c79bde28d689cb05$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $c79bde28d689cb05$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$ac = $ibqfJ.unstable_scheduleCallback, $c79bde28d689cb05$var$bc = $ibqfJ.unstable_cancelCallback, $c79bde28d689cb05$var$cc = $ibqfJ.unstable_shouldYield, $c79bde28d689cb05$var$dc = $ibqfJ.unstable_requestPaint, $c79bde28d689cb05$var$B = $ibqfJ.unstable_now, $c79bde28d689cb05$var$ec = $ibqfJ.unstable_getCurrentPriorityLevel, $c79bde28d689cb05$var$fc = $ibqfJ.unstable_ImmediatePriority, $c79bde28d689cb05$var$gc = $ibqfJ.unstable_UserBlockingPriority, $c79bde28d689cb05$var$hc = $ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$ic = $ibqfJ.unstable_LowPriority, $c79bde28d689cb05$var$jc = $ibqfJ.unstable_IdlePriority, $c79bde28d689cb05$var$kc = null, $c79bde28d689cb05$var$lc = null;
function $c79bde28d689cb05$var$mc(a) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberRoot) try {
        $c79bde28d689cb05$var$lc.onCommitFiberRoot($c79bde28d689cb05$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $c79bde28d689cb05$var$oc = Math.clz32 ? Math.clz32 : $c79bde28d689cb05$var$nc, $c79bde28d689cb05$var$pc = Math.log, $c79bde28d689cb05$var$qc = Math.LN2;
function $c79bde28d689cb05$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($c79bde28d689cb05$var$pc(a) / $c79bde28d689cb05$var$qc | 0) | 0;
}
var $c79bde28d689cb05$var$rc = 64, $c79bde28d689cb05$var$sc = 4194304;
function $c79bde28d689cb05$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $c79bde28d689cb05$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $c79bde28d689cb05$var$tc(h) : (f &= g, 0 !== f && (d = $c79bde28d689cb05$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $c79bde28d689cb05$var$tc(g) : 0 !== f && (d = $c79bde28d689cb05$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $c79bde28d689cb05$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $c79bde28d689cb05$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c79bde28d689cb05$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $c79bde28d689cb05$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $c79bde28d689cb05$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $c79bde28d689cb05$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $c79bde28d689cb05$var$yc() {
    var a = $c79bde28d689cb05$var$rc;
    $c79bde28d689cb05$var$rc <<= 1;
    0 === ($c79bde28d689cb05$var$rc & 4194240) && ($c79bde28d689cb05$var$rc = 64);
    return a;
}
function $c79bde28d689cb05$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c79bde28d689cb05$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $c79bde28d689cb05$var$oc(b);
    a[b] = c;
}
function $c79bde28d689cb05$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $c79bde28d689cb05$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $c79bde28d689cb05$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $c79bde28d689cb05$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $c79bde28d689cb05$var$C = 0;
function $c79bde28d689cb05$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $c79bde28d689cb05$var$Ec, $c79bde28d689cb05$var$Fc, $c79bde28d689cb05$var$Gc, $c79bde28d689cb05$var$Hc, $c79bde28d689cb05$var$Ic, $c79bde28d689cb05$var$Jc = !1, $c79bde28d689cb05$var$Kc = [], $c79bde28d689cb05$var$Lc = null, $c79bde28d689cb05$var$Mc = null, $c79bde28d689cb05$var$Nc = null, $c79bde28d689cb05$var$Oc = new Map, $c79bde28d689cb05$var$Pc = new Map, $c79bde28d689cb05$var$Qc = [], $c79bde28d689cb05$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $c79bde28d689cb05$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $c79bde28d689cb05$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $c79bde28d689cb05$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $c79bde28d689cb05$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $c79bde28d689cb05$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c79bde28d689cb05$var$Pc.delete(b.pointerId);
    }
}
function $c79bde28d689cb05$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $c79bde28d689cb05$var$Cb(b), null !== b && $c79bde28d689cb05$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $c79bde28d689cb05$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $c79bde28d689cb05$var$Lc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $c79bde28d689cb05$var$Mc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $c79bde28d689cb05$var$Nc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $c79bde28d689cb05$var$Oc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $c79bde28d689cb05$var$Pc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $c79bde28d689cb05$var$Vc(a) {
    var b = $c79bde28d689cb05$var$Wc(a.target);
    if (null !== b) {
        var c = $c79bde28d689cb05$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $c79bde28d689cb05$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $c79bde28d689cb05$var$Ic(a.priority, function() {
                        $c79bde28d689cb05$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $c79bde28d689cb05$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $c79bde28d689cb05$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $c79bde28d689cb05$var$wb = d;
            c.target.dispatchEvent(d);
            $c79bde28d689cb05$var$wb = null;
        } else return b = $c79bde28d689cb05$var$Cb(c), null !== b && $c79bde28d689cb05$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $c79bde28d689cb05$var$Zc(a, b, c) {
    $c79bde28d689cb05$var$Xc(a) && c.delete(b);
}
function $c79bde28d689cb05$var$$c() {
    $c79bde28d689cb05$var$Jc = !1;
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Lc) && ($c79bde28d689cb05$var$Lc = null);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Mc) && ($c79bde28d689cb05$var$Mc = null);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Nc) && ($c79bde28d689cb05$var$Nc = null);
    $c79bde28d689cb05$var$Oc.forEach($c79bde28d689cb05$var$Zc);
    $c79bde28d689cb05$var$Pc.forEach($c79bde28d689cb05$var$Zc);
}
function $c79bde28d689cb05$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $c79bde28d689cb05$var$Jc || ($c79bde28d689cb05$var$Jc = !0, $ibqfJ.unstable_scheduleCallback($ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$$c)));
}
function $c79bde28d689cb05$var$bd(a) {
    function b(b) {
        return $c79bde28d689cb05$var$ad(b, a);
    }
    if (0 < $c79bde28d689cb05$var$Kc.length) {
        $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Kc[0], a);
        for(var c = 1; c < $c79bde28d689cb05$var$Kc.length; c++){
            var d = $c79bde28d689cb05$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Lc, a);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Mc, a);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Nc, a);
    $c79bde28d689cb05$var$Oc.forEach(b);
    $c79bde28d689cb05$var$Pc.forEach(b);
    for(c = 0; c < $c79bde28d689cb05$var$Qc.length; c++)d = $c79bde28d689cb05$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $c79bde28d689cb05$var$Qc.length && (c = $c79bde28d689cb05$var$Qc[0], null === c.blockedOn);)$c79bde28d689cb05$var$Vc(c), null === c.blockedOn && $c79bde28d689cb05$var$Qc.shift();
}
var $c79bde28d689cb05$var$cd = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$dd = !0;
function $c79bde28d689cb05$var$ed(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$gd(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 4, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$fd(a, b, c, d) {
    if ($c79bde28d689cb05$var$dd) {
        var e = $c79bde28d689cb05$var$Yc(a, b, c, d);
        if (null === e) $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c), $c79bde28d689cb05$var$Sc(a, d);
        else if ($c79bde28d689cb05$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($c79bde28d689cb05$var$Sc(a, d), b & 4 && -1 < $c79bde28d689cb05$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $c79bde28d689cb05$var$Cb(e);
                null !== f && $c79bde28d689cb05$var$Ec(f);
                f = $c79bde28d689cb05$var$Yc(a, b, c, d);
                null === f && $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $c79bde28d689cb05$var$hd(a, b, d, null, c);
    }
}
var $c79bde28d689cb05$var$id = null;
function $c79bde28d689cb05$var$Yc(a, b, c, d) {
    $c79bde28d689cb05$var$id = null;
    a = $c79bde28d689cb05$var$xb(d);
    a = $c79bde28d689cb05$var$Wc(a);
    if (null !== a) {
        if (b = $c79bde28d689cb05$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $c79bde28d689cb05$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $c79bde28d689cb05$var$id = a;
    return null;
}
function $c79bde28d689cb05$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($c79bde28d689cb05$var$ec()){
                case $c79bde28d689cb05$var$fc:
                    return 1;
                case $c79bde28d689cb05$var$gc:
                    return 4;
                case $c79bde28d689cb05$var$hc:
                case $c79bde28d689cb05$var$ic:
                    return 16;
                case $c79bde28d689cb05$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ld = null, $c79bde28d689cb05$var$md = null;
function $c79bde28d689cb05$var$nd() {
    if ($c79bde28d689cb05$var$md) return $c79bde28d689cb05$var$md;
    var a, b = $c79bde28d689cb05$var$ld, c = b.length, d, e = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $c79bde28d689cb05$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $c79bde28d689cb05$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $c79bde28d689cb05$var$pd() {
    return !0;
}
function $c79bde28d689cb05$var$qd() {
    return !1;
}
function $c79bde28d689cb05$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $c79bde28d689cb05$var$pd : $c79bde28d689cb05$var$qd;
        this.isPropagationStopped = $c79bde28d689cb05$var$qd;
        return this;
    }
    $c79bde28d689cb05$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $c79bde28d689cb05$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $c79bde28d689cb05$var$pd);
        },
        persist: function() {},
        isPersistent: $c79bde28d689cb05$var$pd
    });
    return b;
}
var $c79bde28d689cb05$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c79bde28d689cb05$var$td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$sd), $c79bde28d689cb05$var$ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    view: 0,
    detail: 0
}), $c79bde28d689cb05$var$vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$ud), $c79bde28d689cb05$var$wd, $c79bde28d689cb05$var$xd, $c79bde28d689cb05$var$yd, $c79bde28d689cb05$var$Ad = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $c79bde28d689cb05$var$yd && ($c79bde28d689cb05$var$yd && "mousemove" === a.type ? ($c79bde28d689cb05$var$wd = a.screenX - $c79bde28d689cb05$var$yd.screenX, $c79bde28d689cb05$var$xd = a.screenY - $c79bde28d689cb05$var$yd.screenY) : $c79bde28d689cb05$var$xd = $c79bde28d689cb05$var$wd = 0, $c79bde28d689cb05$var$yd = a);
        return $c79bde28d689cb05$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $c79bde28d689cb05$var$xd;
    }
}), $c79bde28d689cb05$var$Bd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ad), $c79bde28d689cb05$var$Cd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    dataTransfer: 0
}), $c79bde28d689cb05$var$Dd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Cd), $c79bde28d689cb05$var$Ed = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    relatedTarget: 0
}), $c79bde28d689cb05$var$Fd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ed), $c79bde28d689cb05$var$Gd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Hd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Gd), $c79bde28d689cb05$var$Id = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $c79bde28d689cb05$var$Jd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Id), $c79bde28d689cb05$var$Kd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    data: 0
}), $c79bde28d689cb05$var$Ld = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Kd), $c79bde28d689cb05$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c79bde28d689cb05$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c79bde28d689cb05$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c79bde28d689cb05$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $c79bde28d689cb05$var$Od[a]) ? !!b[a] : !1;
}
function $c79bde28d689cb05$var$zd() {
    return $c79bde28d689cb05$var$Pd;
}
var $c79bde28d689cb05$var$Qd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $c79bde28d689cb05$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $c79bde28d689cb05$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $c79bde28d689cb05$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $c79bde28d689cb05$var$Rd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Qd), $c79bde28d689cb05$var$Sd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c79bde28d689cb05$var$Td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Sd), $c79bde28d689cb05$var$Ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd
}), $c79bde28d689cb05$var$Vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ud), $c79bde28d689cb05$var$Wd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Xd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Wd), $c79bde28d689cb05$var$Yd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c79bde28d689cb05$var$Zd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Yd), $c79bde28d689cb05$var$$d = [
    9,
    13,
    27,
    32
], $c79bde28d689cb05$var$ae = $c79bde28d689cb05$var$ia && "CompositionEvent" in window, $c79bde28d689cb05$var$be = null;
$c79bde28d689cb05$var$ia && "documentMode" in document && ($c79bde28d689cb05$var$be = document.documentMode);
var $c79bde28d689cb05$var$ce = $c79bde28d689cb05$var$ia && "TextEvent" in window && !$c79bde28d689cb05$var$be, $c79bde28d689cb05$var$de = $c79bde28d689cb05$var$ia && (!$c79bde28d689cb05$var$ae || $c79bde28d689cb05$var$be && 8 < $c79bde28d689cb05$var$be && 11 >= $c79bde28d689cb05$var$be), $c79bde28d689cb05$var$ee = String.fromCharCode(32), $c79bde28d689cb05$var$fe = !1;
function $c79bde28d689cb05$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $c79bde28d689cb05$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $c79bde28d689cb05$var$ie = !1;
function $c79bde28d689cb05$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $c79bde28d689cb05$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $c79bde28d689cb05$var$fe = !0;
            return $c79bde28d689cb05$var$ee;
        case "textInput":
            return a = b.data, a === $c79bde28d689cb05$var$ee && $c79bde28d689cb05$var$fe ? null : a;
        default:
            return null;
    }
}
function $c79bde28d689cb05$var$ke(a, b) {
    if ($c79bde28d689cb05$var$ie) return "compositionend" === a || !$c79bde28d689cb05$var$ae && $c79bde28d689cb05$var$ge(a, b) ? (a = $c79bde28d689cb05$var$nd(), $c79bde28d689cb05$var$md = $c79bde28d689cb05$var$ld = $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $c79bde28d689cb05$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c79bde28d689cb05$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$c79bde28d689cb05$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $c79bde28d689cb05$var$ne(a, b, c, d) {
    $c79bde28d689cb05$var$Eb(d);
    b = $c79bde28d689cb05$var$oe(b, "onChange");
    0 < b.length && (c = new $c79bde28d689cb05$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $c79bde28d689cb05$var$pe = null, $c79bde28d689cb05$var$qe = null;
function $c79bde28d689cb05$var$re(a) {
    $c79bde28d689cb05$var$se(a, 0);
}
function $c79bde28d689cb05$var$te(a) {
    var b = $c79bde28d689cb05$var$ue(a);
    if ($c79bde28d689cb05$var$Wa(b)) return a;
}
function $c79bde28d689cb05$var$ve(a, b) {
    if ("change" === a) return b;
}
var $c79bde28d689cb05$var$we = !1;
if ($c79bde28d689cb05$var$ia) {
    var $c79bde28d689cb05$var$xe;
    if ($c79bde28d689cb05$var$ia) {
        var $c79bde28d689cb05$var$ye = "oninput" in document;
        if (!$c79bde28d689cb05$var$ye) {
            var $c79bde28d689cb05$var$ze = document.createElement("div");
            $c79bde28d689cb05$var$ze.setAttribute("oninput", "return;");
            $c79bde28d689cb05$var$ye = "function" === typeof $c79bde28d689cb05$var$ze.oninput;
        }
        $c79bde28d689cb05$var$xe = $c79bde28d689cb05$var$ye;
    } else $c79bde28d689cb05$var$xe = !1;
    $c79bde28d689cb05$var$we = $c79bde28d689cb05$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $c79bde28d689cb05$var$Ae() {
    $c79bde28d689cb05$var$pe && ($c79bde28d689cb05$var$pe.detachEvent("onpropertychange", $c79bde28d689cb05$var$Be), $c79bde28d689cb05$var$qe = $c79bde28d689cb05$var$pe = null);
}
function $c79bde28d689cb05$var$Be(a) {
    if ("value" === a.propertyName && $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe)) {
        var b = [];
        $c79bde28d689cb05$var$ne(b, $c79bde28d689cb05$var$qe, a, $c79bde28d689cb05$var$xb(a));
        $c79bde28d689cb05$var$Jb($c79bde28d689cb05$var$re, b);
    }
}
function $c79bde28d689cb05$var$Ce(a, b, c) {
    "focusin" === a ? ($c79bde28d689cb05$var$Ae(), $c79bde28d689cb05$var$pe = b, $c79bde28d689cb05$var$qe = c, $c79bde28d689cb05$var$pe.attachEvent("onpropertychange", $c79bde28d689cb05$var$Be)) : "focusout" === a && $c79bde28d689cb05$var$Ae();
}
function $c79bde28d689cb05$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe);
}
function $c79bde28d689cb05$var$Ee(a, b) {
    if ("click" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c79bde28d689cb05$var$He = "function" === typeof Object.is ? Object.is : $c79bde28d689cb05$var$Ge;
function $c79bde28d689cb05$var$Ie(a, b) {
    if ($c79bde28d689cb05$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$c79bde28d689cb05$var$ja.call(b, e) || !$c79bde28d689cb05$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $c79bde28d689cb05$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $c79bde28d689cb05$var$Ke(a, b) {
    var c = $c79bde28d689cb05$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $c79bde28d689cb05$var$Je(c);
    }
}
function $c79bde28d689cb05$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $c79bde28d689cb05$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $c79bde28d689cb05$var$Me() {
    for(var a = window, b = $c79bde28d689cb05$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $c79bde28d689cb05$var$Xa(a.document);
    }
    return b;
}
function $c79bde28d689cb05$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $c79bde28d689cb05$var$Oe(a) {
    var b = $c79bde28d689cb05$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $c79bde28d689cb05$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $c79bde28d689cb05$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $c79bde28d689cb05$var$Ke(c, f);
                var g = $c79bde28d689cb05$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $c79bde28d689cb05$var$Pe = $c79bde28d689cb05$var$ia && "documentMode" in document && 11 >= document.documentMode, $c79bde28d689cb05$var$Qe = null, $c79bde28d689cb05$var$Re = null, $c79bde28d689cb05$var$Se = null, $c79bde28d689cb05$var$Te = !1;
function $c79bde28d689cb05$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $c79bde28d689cb05$var$Te || null == $c79bde28d689cb05$var$Qe || $c79bde28d689cb05$var$Qe !== $c79bde28d689cb05$var$Xa(d) || (d = $c79bde28d689cb05$var$Qe, "selectionStart" in d && $c79bde28d689cb05$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $c79bde28d689cb05$var$Se && $c79bde28d689cb05$var$Ie($c79bde28d689cb05$var$Se, d) || ($c79bde28d689cb05$var$Se = d, d = $c79bde28d689cb05$var$oe($c79bde28d689cb05$var$Re, "onSelect"), 0 < d.length && (b = new $c79bde28d689cb05$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $c79bde28d689cb05$var$Qe)));
}
function $c79bde28d689cb05$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $c79bde28d689cb05$var$We = {
    animationend: $c79bde28d689cb05$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $c79bde28d689cb05$var$Ve("Animation", "AnimationIteration"),
    animationstart: $c79bde28d689cb05$var$Ve("Animation", "AnimationStart"),
    transitionend: $c79bde28d689cb05$var$Ve("Transition", "TransitionEnd")
}, $c79bde28d689cb05$var$Xe = {}, $c79bde28d689cb05$var$Ye = {};
$c79bde28d689cb05$var$ia && ($c79bde28d689cb05$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $c79bde28d689cb05$var$We.animationend.animation, delete $c79bde28d689cb05$var$We.animationiteration.animation, delete $c79bde28d689cb05$var$We.animationstart.animation), "TransitionEvent" in window || delete $c79bde28d689cb05$var$We.transitionend.transition);
function $c79bde28d689cb05$var$Ze(a) {
    if ($c79bde28d689cb05$var$Xe[a]) return $c79bde28d689cb05$var$Xe[a];
    if (!$c79bde28d689cb05$var$We[a]) return a;
    var b = $c79bde28d689cb05$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $c79bde28d689cb05$var$Ye) return $c79bde28d689cb05$var$Xe[a] = b[c];
    return a;
}
var $c79bde28d689cb05$var$$e = $c79bde28d689cb05$var$Ze("animationend"), $c79bde28d689cb05$var$af = $c79bde28d689cb05$var$Ze("animationiteration"), $c79bde28d689cb05$var$bf = $c79bde28d689cb05$var$Ze("animationstart"), $c79bde28d689cb05$var$cf = $c79bde28d689cb05$var$Ze("transitionend"), $c79bde28d689cb05$var$df = new Map, $c79bde28d689cb05$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $c79bde28d689cb05$var$ff(a, b) {
    $c79bde28d689cb05$var$df.set(a, b);
    $c79bde28d689cb05$var$fa(b, [
        a
    ]);
}
for(var $c79bde28d689cb05$var$gf = 0; $c79bde28d689cb05$var$gf < $c79bde28d689cb05$var$ef.length; $c79bde28d689cb05$var$gf++){
    var $c79bde28d689cb05$var$hf = $c79bde28d689cb05$var$ef[$c79bde28d689cb05$var$gf], $c79bde28d689cb05$var$jf = $c79bde28d689cb05$var$hf.toLowerCase(), $c79bde28d689cb05$var$kf = $c79bde28d689cb05$var$hf[0].toUpperCase() + $c79bde28d689cb05$var$hf.slice(1);
    $c79bde28d689cb05$var$ff($c79bde28d689cb05$var$jf, "on" + $c79bde28d689cb05$var$kf);
}
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$$e, "onAnimationEnd");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$af, "onAnimationIteration");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$bf, "onAnimationStart");
$c79bde28d689cb05$var$ff("dblclick", "onDoubleClick");
$c79bde28d689cb05$var$ff("focusin", "onFocus");
$c79bde28d689cb05$var$ff("focusout", "onBlur");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$cf, "onTransitionEnd");
$c79bde28d689cb05$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c79bde28d689cb05$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c79bde28d689cb05$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c79bde28d689cb05$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($c79bde28d689cb05$var$lf));
function $c79bde28d689cb05$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $c79bde28d689cb05$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $c79bde28d689cb05$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($c79bde28d689cb05$var$Qb) throw a = $c79bde28d689cb05$var$Rb, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, a;
}
function $c79bde28d689cb05$var$D(a, b) {
    var c = b[$c79bde28d689cb05$var$of];
    void 0 === c && (c = b[$c79bde28d689cb05$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($c79bde28d689cb05$var$pf(b, a, 2, !1), c.add(d));
}
function $c79bde28d689cb05$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $c79bde28d689cb05$var$pf(c, a, d, b);
}
var $c79bde28d689cb05$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $c79bde28d689cb05$var$sf(a) {
    if (!a[$c79bde28d689cb05$var$rf]) {
        a[$c79bde28d689cb05$var$rf] = !0;
        $c79bde28d689cb05$var$da.forEach(function(b) {
            "selectionchange" !== b && ($c79bde28d689cb05$var$mf.has(b) || $c79bde28d689cb05$var$qf(b, !1, a), $c79bde28d689cb05$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$c79bde28d689cb05$var$rf] || (b[$c79bde28d689cb05$var$rf] = !0, $c79bde28d689cb05$var$qf("selectionchange", !1, b));
    }
}
function $c79bde28d689cb05$var$pf(a, b, c, d) {
    switch($c79bde28d689cb05$var$jd(b)){
        case 1:
            var e = $c79bde28d689cb05$var$ed;
            break;
        case 4:
            e = $c79bde28d689cb05$var$gd;
            break;
        default:
            e = $c79bde28d689cb05$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$c79bde28d689cb05$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $c79bde28d689cb05$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $c79bde28d689cb05$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $c79bde28d689cb05$var$Jb(function() {
        var d = f, e = $c79bde28d689cb05$var$xb(c), g = [];
        a: {
            var h = $c79bde28d689cb05$var$df.get(a);
            if (void 0 !== h) {
                var k = $c79bde28d689cb05$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $c79bde28d689cb05$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $c79bde28d689cb05$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $c79bde28d689cb05$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $c79bde28d689cb05$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $c79bde28d689cb05$var$Vd;
                        break;
                    case $c79bde28d689cb05$var$$e:
                    case $c79bde28d689cb05$var$af:
                    case $c79bde28d689cb05$var$bf:
                        k = $c79bde28d689cb05$var$Hd;
                        break;
                    case $c79bde28d689cb05$var$cf:
                        k = $c79bde28d689cb05$var$Xd;
                        break;
                    case "scroll":
                        k = $c79bde28d689cb05$var$vd;
                        break;
                    case "wheel":
                        k = $c79bde28d689cb05$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $c79bde28d689cb05$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $c79bde28d689cb05$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $c79bde28d689cb05$var$Kb(w, x), null != F && t.push($c79bde28d689cb05$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $c79bde28d689cb05$var$wb && (n = c.relatedTarget || c.fromElement) && ($c79bde28d689cb05$var$Wc(n) || n[$c79bde28d689cb05$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $c79bde28d689cb05$var$Wc(n) : null, null !== n && (J = $c79bde28d689cb05$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $c79bde28d689cb05$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $c79bde28d689cb05$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $c79bde28d689cb05$var$ue(k);
                        u = null == n ? h : $c79bde28d689cb05$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $c79bde28d689cb05$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $c79bde28d689cb05$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $c79bde28d689cb05$var$vf(F))u++;
                            for(; 0 < w - u;)t = $c79bde28d689cb05$var$vf(t), w--;
                            for(; 0 < u - w;)x = $c79bde28d689cb05$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $c79bde28d689cb05$var$vf(t);
                                x = $c79bde28d689cb05$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $c79bde28d689cb05$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $c79bde28d689cb05$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $c79bde28d689cb05$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $c79bde28d689cb05$var$ve;
                else if ($c79bde28d689cb05$var$me(h)) {
                    if ($c79bde28d689cb05$var$we) na = $c79bde28d689cb05$var$Fe;
                    else {
                        na = $c79bde28d689cb05$var$De;
                        var xa = $c79bde28d689cb05$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $c79bde28d689cb05$var$Ee);
                if (na && (na = na(a, d))) {
                    $c79bde28d689cb05$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $c79bde28d689cb05$var$cb(h, "number", h.value);
            }
            xa = d ? $c79bde28d689cb05$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($c79bde28d689cb05$var$me(xa) || "true" === xa.contentEditable) $c79bde28d689cb05$var$Qe = xa, $c79bde28d689cb05$var$Re = d, $c79bde28d689cb05$var$Se = null;
                    break;
                case "focusout":
                    $c79bde28d689cb05$var$Se = $c79bde28d689cb05$var$Re = $c79bde28d689cb05$var$Qe = null;
                    break;
                case "mousedown":
                    $c79bde28d689cb05$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c79bde28d689cb05$var$Te = !1;
                    $c79bde28d689cb05$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($c79bde28d689cb05$var$Pe) break;
                case "keydown":
                case "keyup":
                    $c79bde28d689cb05$var$Ue(g, c, e);
            }
            var $a;
            if ($c79bde28d689cb05$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $c79bde28d689cb05$var$ie ? $c79bde28d689cb05$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($c79bde28d689cb05$var$de && "ko" !== c.locale && ($c79bde28d689cb05$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $c79bde28d689cb05$var$ie && ($a = $c79bde28d689cb05$var$nd()) : ($c79bde28d689cb05$var$kd = e, $c79bde28d689cb05$var$ld = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, $c79bde28d689cb05$var$ie = !0)), xa = $c79bde28d689cb05$var$oe(d, ba), 0 < xa.length && (ba = new $c79bde28d689cb05$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $c79bde28d689cb05$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $c79bde28d689cb05$var$ce ? $c79bde28d689cb05$var$je(a, c) : $c79bde28d689cb05$var$ke(a, c)) d = $c79bde28d689cb05$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $c79bde28d689cb05$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $c79bde28d689cb05$var$se(g, b);
    });
}
function $c79bde28d689cb05$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $c79bde28d689cb05$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $c79bde28d689cb05$var$Kb(a, c), null != f && d.unshift($c79bde28d689cb05$var$tf(a, f, e)), f = $c79bde28d689cb05$var$Kb(a, b), null != f && d.push($c79bde28d689cb05$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $c79bde28d689cb05$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $c79bde28d689cb05$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.unshift($c79bde28d689cb05$var$tf(c, k, h))) : e || (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.push($c79bde28d689cb05$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $c79bde28d689cb05$var$xf = /\r\n?/g, $c79bde28d689cb05$var$yf = /\u0000|\uFFFD/g;
function $c79bde28d689cb05$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($c79bde28d689cb05$var$xf, "\n").replace($c79bde28d689cb05$var$yf, "");
}
function $c79bde28d689cb05$var$Af(a, b, c) {
    b = $c79bde28d689cb05$var$zf(b);
    if ($c79bde28d689cb05$var$zf(a) !== b && c) throw Error($c79bde28d689cb05$var$p(425));
}
function $c79bde28d689cb05$var$Bf() {}
var $c79bde28d689cb05$var$Cf = null, $c79bde28d689cb05$var$Df = null;
function $c79bde28d689cb05$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $c79bde28d689cb05$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $c79bde28d689cb05$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $c79bde28d689cb05$var$Hf = "function" === typeof Promise ? Promise : void 0, $c79bde28d689cb05$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c79bde28d689cb05$var$Hf ? function(a) {
    return $c79bde28d689cb05$var$Hf.resolve(null).then(a).catch($c79bde28d689cb05$var$If);
} : $c79bde28d689cb05$var$Ff;
function $c79bde28d689cb05$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $c79bde28d689cb05$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $c79bde28d689cb05$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $c79bde28d689cb05$var$bd(b);
}
function $c79bde28d689cb05$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $c79bde28d689cb05$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Nf = Math.random().toString(36).slice(2), $c79bde28d689cb05$var$Of = "__reactFiber$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Pf = "__reactProps$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$uf = "__reactContainer$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$of = "__reactEvents$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Qf = "__reactListeners$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Rf = "__reactHandles$" + $c79bde28d689cb05$var$Nf;
function $c79bde28d689cb05$var$Wc(a) {
    var b = a[$c79bde28d689cb05$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$c79bde28d689cb05$var$uf] || c[$c79bde28d689cb05$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $c79bde28d689cb05$var$Mf(a); null !== a;){
                if (c = a[$c79bde28d689cb05$var$Of]) return c;
                a = $c79bde28d689cb05$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $c79bde28d689cb05$var$Cb(a) {
    a = a[$c79bde28d689cb05$var$Of] || a[$c79bde28d689cb05$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $c79bde28d689cb05$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($c79bde28d689cb05$var$p(33));
}
function $c79bde28d689cb05$var$Db(a) {
    return a[$c79bde28d689cb05$var$Pf] || null;
}
var $c79bde28d689cb05$var$Sf = [], $c79bde28d689cb05$var$Tf = -1;
function $c79bde28d689cb05$var$Uf(a) {
    return {
        current: a
    };
}
function $c79bde28d689cb05$var$E(a) {
    0 > $c79bde28d689cb05$var$Tf || (a.current = $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf], $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = null, $c79bde28d689cb05$var$Tf--);
}
function $c79bde28d689cb05$var$G(a, b) {
    $c79bde28d689cb05$var$Tf++;
    $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = a.current;
    a.current = b;
}
var $c79bde28d689cb05$var$Vf = {}, $c79bde28d689cb05$var$H = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Vf), $c79bde28d689cb05$var$Wf = $c79bde28d689cb05$var$Uf(!1), $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$Vf;
function $c79bde28d689cb05$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $c79bde28d689cb05$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $c79bde28d689cb05$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $c79bde28d689cb05$var$$f() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
}
function $c79bde28d689cb05$var$ag(a, b, c) {
    if ($c79bde28d689cb05$var$H.current !== $c79bde28d689cb05$var$Vf) throw Error($c79bde28d689cb05$var$p(168));
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
function $c79bde28d689cb05$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($c79bde28d689cb05$var$p(108, $c79bde28d689cb05$var$Ra(a) || "Unknown", e));
    return $c79bde28d689cb05$var$A({}, c, d);
}
function $c79bde28d689cb05$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $c79bde28d689cb05$var$Vf;
    $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$H.current;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, $c79bde28d689cb05$var$Wf.current);
    return !0;
}
function $c79bde28d689cb05$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($c79bde28d689cb05$var$p(169));
    c ? (a = $c79bde28d689cb05$var$bg(a, b, $c79bde28d689cb05$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a)) : $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
var $c79bde28d689cb05$var$eg = null, $c79bde28d689cb05$var$fg = !1, $c79bde28d689cb05$var$gg = !1;
function $c79bde28d689cb05$var$hg(a) {
    null === $c79bde28d689cb05$var$eg ? $c79bde28d689cb05$var$eg = [
        a
    ] : $c79bde28d689cb05$var$eg.push(a);
}
function $c79bde28d689cb05$var$ig(a) {
    $c79bde28d689cb05$var$fg = !0;
    $c79bde28d689cb05$var$hg(a);
}
function $c79bde28d689cb05$var$jg() {
    if (!$c79bde28d689cb05$var$gg && null !== $c79bde28d689cb05$var$eg) {
        $c79bde28d689cb05$var$gg = !0;
        var a = 0, b = $c79bde28d689cb05$var$C;
        try {
            var c = $c79bde28d689cb05$var$eg;
            for($c79bde28d689cb05$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $c79bde28d689cb05$var$eg = null;
            $c79bde28d689cb05$var$fg = !1;
        } catch (e) {
            throw null !== $c79bde28d689cb05$var$eg && ($c79bde28d689cb05$var$eg = $c79bde28d689cb05$var$eg.slice(a + 1)), $c79bde28d689cb05$var$ac($c79bde28d689cb05$var$fc, $c79bde28d689cb05$var$jg), e;
        } finally{
            $c79bde28d689cb05$var$C = b, $c79bde28d689cb05$var$gg = !1;
        }
    }
    return null;
}
var $c79bde28d689cb05$var$kg = [], $c79bde28d689cb05$var$lg = 0, $c79bde28d689cb05$var$mg = null, $c79bde28d689cb05$var$ng = 0, $c79bde28d689cb05$var$og = [], $c79bde28d689cb05$var$pg = 0, $c79bde28d689cb05$var$qg = null, $c79bde28d689cb05$var$rg = 1, $c79bde28d689cb05$var$sg = "";
function $c79bde28d689cb05$var$tg(a, b) {
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$ng;
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$mg;
    $c79bde28d689cb05$var$mg = a;
    $c79bde28d689cb05$var$ng = b;
}
function $c79bde28d689cb05$var$ug(a, b, c) {
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg;
    $c79bde28d689cb05$var$qg = a;
    var d = $c79bde28d689cb05$var$rg;
    a = $c79bde28d689cb05$var$sg;
    var e = 32 - $c79bde28d689cb05$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $c79bde28d689cb05$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $c79bde28d689cb05$var$rg = 1 << 32 - $c79bde28d689cb05$var$oc(b) + e | c << e | d;
        $c79bde28d689cb05$var$sg = f + a;
    } else $c79bde28d689cb05$var$rg = 1 << f | c << e | d, $c79bde28d689cb05$var$sg = a;
}
function $c79bde28d689cb05$var$vg(a) {
    null !== a.return && ($c79bde28d689cb05$var$tg(a, 1), $c79bde28d689cb05$var$ug(a, 1, 0));
}
function $c79bde28d689cb05$var$wg(a) {
    for(; a === $c79bde28d689cb05$var$mg;)$c79bde28d689cb05$var$mg = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null, $c79bde28d689cb05$var$ng = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null;
    for(; a === $c79bde28d689cb05$var$qg;)$c79bde28d689cb05$var$qg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$sg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$rg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null;
}
var $c79bde28d689cb05$var$xg = null, $c79bde28d689cb05$var$yg = null, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$zg = null;
function $c79bde28d689cb05$var$Ag(a, b) {
    var c = $c79bde28d689cb05$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $c79bde28d689cb05$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $c79bde28d689cb05$var$qg ? {
                id: $c79bde28d689cb05$var$rg,
                overflow: $c79bde28d689cb05$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $c79bde28d689cb05$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $c79bde28d689cb05$var$Eg(a) {
    if ($c79bde28d689cb05$var$I) {
        var b = $c79bde28d689cb05$var$yg;
        if (b) {
            var c = b;
            if (!$c79bde28d689cb05$var$Cg(a, b)) {
                if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
                b = $c79bde28d689cb05$var$Lf(c.nextSibling);
                var d = $c79bde28d689cb05$var$xg;
                b && $c79bde28d689cb05$var$Cg(a, b) ? $c79bde28d689cb05$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$xg = a);
            }
        } else {
            if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $c79bde28d689cb05$var$I = !1;
            $c79bde28d689cb05$var$xg = a;
        }
    }
}
function $c79bde28d689cb05$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $c79bde28d689cb05$var$xg = a;
}
function $c79bde28d689cb05$var$Gg(a) {
    if (a !== $c79bde28d689cb05$var$xg) return !1;
    if (!$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$Fg(a), $c79bde28d689cb05$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$c79bde28d689cb05$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $c79bde28d689cb05$var$yg)) {
        if ($c79bde28d689cb05$var$Dg(a)) throw $c79bde28d689cb05$var$Hg(), Error($c79bde28d689cb05$var$p(418));
        for(; b;)$c79bde28d689cb05$var$Ag(a, b), b = $c79bde28d689cb05$var$Lf(b.nextSibling);
    }
    $c79bde28d689cb05$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($c79bde28d689cb05$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $c79bde28d689cb05$var$yg = null;
        }
    } else $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg ? $c79bde28d689cb05$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $c79bde28d689cb05$var$Hg() {
    for(var a = $c79bde28d689cb05$var$yg; a;)a = $c79bde28d689cb05$var$Lf(a.nextSibling);
}
function $c79bde28d689cb05$var$Ig() {
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg = null;
    $c79bde28d689cb05$var$I = !1;
}
function $c79bde28d689cb05$var$Jg(a) {
    null === $c79bde28d689cb05$var$zg ? $c79bde28d689cb05$var$zg = [
        a
    ] : $c79bde28d689cb05$var$zg.push(a);
}
var $c79bde28d689cb05$var$Kg = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig;
function $c79bde28d689cb05$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $c79bde28d689cb05$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $c79bde28d689cb05$var$Mg = $c79bde28d689cb05$var$Uf(null), $c79bde28d689cb05$var$Ng = null, $c79bde28d689cb05$var$Og = null, $c79bde28d689cb05$var$Pg = null;
function $c79bde28d689cb05$var$Qg() {
    $c79bde28d689cb05$var$Pg = $c79bde28d689cb05$var$Og = $c79bde28d689cb05$var$Ng = null;
}
function $c79bde28d689cb05$var$Rg(a) {
    var b = $c79bde28d689cb05$var$Mg.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Mg);
    a._currentValue = b;
}
function $c79bde28d689cb05$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $c79bde28d689cb05$var$Tg(a, b) {
    $c79bde28d689cb05$var$Ng = a;
    $c79bde28d689cb05$var$Pg = $c79bde28d689cb05$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($c79bde28d689cb05$var$Ug = !0), a.firstContext = null);
}
function $c79bde28d689cb05$var$Vg(a) {
    var b = a._currentValue;
    if ($c79bde28d689cb05$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $c79bde28d689cb05$var$Og) {
            if (null === $c79bde28d689cb05$var$Ng) throw Error($c79bde28d689cb05$var$p(308));
            $c79bde28d689cb05$var$Og = a;
            $c79bde28d689cb05$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $c79bde28d689cb05$var$Og = $c79bde28d689cb05$var$Og.next = a;
    }
    return b;
}
var $c79bde28d689cb05$var$Wg = null;
function $c79bde28d689cb05$var$Xg(a) {
    null === $c79bde28d689cb05$var$Wg ? $c79bde28d689cb05$var$Wg = [
        a
    ] : $c79bde28d689cb05$var$Wg.push(a);
}
function $c79bde28d689cb05$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $c79bde28d689cb05$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $c79bde28d689cb05$var$Zg(a, d);
}
function $c79bde28d689cb05$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $c79bde28d689cb05$var$$g = !1;
function $c79bde28d689cb05$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $c79bde28d689cb05$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $c79bde28d689cb05$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c79bde28d689cb05$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($c79bde28d689cb05$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $c79bde28d689cb05$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $c79bde28d689cb05$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $c79bde28d689cb05$var$Zg(a, c);
}
function $c79bde28d689cb05$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
function $c79bde28d689cb05$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $c79bde28d689cb05$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $c79bde28d689cb05$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $c79bde28d689cb05$var$A({}, q, r);
                            break a;
                        case 2:
                            $c79bde28d689cb05$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $c79bde28d689cb05$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $c79bde28d689cb05$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($c79bde28d689cb05$var$p(191, e));
            e.call(d);
        }
    }
}
var $c79bde28d689cb05$var$jh = (new $exYeM.Component).refs;
function $c79bde28d689cb05$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $c79bde28d689cb05$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $c79bde28d689cb05$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $c79bde28d689cb05$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$L(), e = $c79bde28d689cb05$var$lh(a), f = $c79bde28d689cb05$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$dh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, e, d), $c79bde28d689cb05$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$L(), e = $c79bde28d689cb05$var$lh(a), f = $c79bde28d689cb05$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$dh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, e, d), $c79bde28d689cb05$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $c79bde28d689cb05$var$L(), d = $c79bde28d689cb05$var$lh(a), e = $c79bde28d689cb05$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $c79bde28d689cb05$var$dh(a, e, d);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, d, c), $c79bde28d689cb05$var$eh(b, a, d));
    }
};
function $c79bde28d689cb05$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$c79bde28d689cb05$var$Ie(c, d) || !$c79bde28d689cb05$var$Ie(e, f) : !0;
}
function $c79bde28d689cb05$var$ph(a, b, c) {
    var d = !1, e = $c79bde28d689cb05$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $c79bde28d689cb05$var$Vg(f) : (e = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $c79bde28d689cb05$var$Yf(a, e) : $c79bde28d689cb05$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $c79bde28d689cb05$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $c79bde28d689cb05$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $c79bde28d689cb05$var$nh.enqueueReplaceState(b, b.state, null);
}
function $c79bde28d689cb05$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $c79bde28d689cb05$var$jh;
    $c79bde28d689cb05$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $c79bde28d689cb05$var$Vg(f) : (f = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, e.context = $c79bde28d689cb05$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($c79bde28d689cb05$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $c79bde28d689cb05$var$nh.enqueueReplaceState(e, e.state, null), $c79bde28d689cb05$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $c79bde28d689cb05$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($c79bde28d689cb05$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($c79bde28d689cb05$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $c79bde28d689cb05$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($c79bde28d689cb05$var$p(284));
        if (!c._owner) throw Error($c79bde28d689cb05$var$p(290, a));
    }
    return a;
}
function $c79bde28d689cb05$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($c79bde28d689cb05$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $c79bde28d689cb05$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $c79bde28d689cb05$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $c79bde28d689cb05$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $c79bde28d689cb05$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $c79bde28d689cb05$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $c79bde28d689cb05$var$sh(a, b, c), d.return = a, d;
        d = $c79bde28d689cb05$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $c79bde28d689cb05$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $c79bde28d689cb05$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $c79bde28d689cb05$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $c79bde28d689cb05$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c = $c79bde28d689cb05$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $c79bde28d689cb05$var$sh(a, null, b), c.return = a, c;
                case $c79bde28d689cb05$var$wa:
                    return b = $c79bde28d689cb05$var$zh(b, a.mode, c), b.return = a, b;
                case $c79bde28d689cb05$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($c79bde28d689cb05$var$eb(b) || $c79bde28d689cb05$var$Ka(b)) return b = $c79bde28d689cb05$var$Ah(b, a.mode, c, null), b.return = a, b;
            $c79bde28d689cb05$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $c79bde28d689cb05$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $c79bde28d689cb05$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($c79bde28d689cb05$var$eb(c) || $c79bde28d689cb05$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $c79bde28d689cb05$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $c79bde28d689cb05$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $c79bde28d689cb05$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($c79bde28d689cb05$var$eb(d) || $c79bde28d689cb05$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $c79bde28d689cb05$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $c79bde28d689cb05$var$Ka(h);
        if ("function" !== typeof l) throw Error($c79bde28d689cb05$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($c79bde28d689cb05$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $c79bde28d689cb05$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $c79bde28d689cb05$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $c79bde28d689cb05$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $c79bde28d689cb05$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $c79bde28d689cb05$var$ya ? (d = $c79bde28d689cb05$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $c79bde28d689cb05$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $c79bde28d689cb05$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $c79bde28d689cb05$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $c79bde28d689cb05$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $c79bde28d689cb05$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($c79bde28d689cb05$var$eb(f)) return n(a, d, f, h);
            if ($c79bde28d689cb05$var$Ka(f)) return t(a, d, f, h);
            $c79bde28d689cb05$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $c79bde28d689cb05$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $c79bde28d689cb05$var$Bh = $c79bde28d689cb05$var$vh(!0), $c79bde28d689cb05$var$Ch = $c79bde28d689cb05$var$vh(!1), $c79bde28d689cb05$var$Dh = {}, $c79bde28d689cb05$var$Eh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh), $c79bde28d689cb05$var$Fh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh), $c79bde28d689cb05$var$Gh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh);
function $c79bde28d689cb05$var$Hh(a) {
    if (a === $c79bde28d689cb05$var$Dh) throw Error($c79bde28d689cb05$var$p(174));
    return a;
}
function $c79bde28d689cb05$var$Ih(a, b) {
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Gh, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Fh, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, $c79bde28d689cb05$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $c79bde28d689cb05$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $c79bde28d689cb05$var$lb(b, a);
    }
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, b);
}
function $c79bde28d689cb05$var$Jh() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Fh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Gh);
}
function $c79bde28d689cb05$var$Kh(a) {
    $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
    var b = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
    var c = $c79bde28d689cb05$var$lb(b, a.type);
    b !== c && ($c79bde28d689cb05$var$G($c79bde28d689cb05$var$Fh, a), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, c));
}
function $c79bde28d689cb05$var$Lh(a) {
    $c79bde28d689cb05$var$Fh.current === a && ($c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Fh));
}
var $c79bde28d689cb05$var$M = $c79bde28d689cb05$var$Uf(0);
function $c79bde28d689cb05$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Nh = [];
function $c79bde28d689cb05$var$Oh() {
    for(var a = 0; a < $c79bde28d689cb05$var$Nh.length; a++)$c79bde28d689cb05$var$Nh[a]._workInProgressVersionPrimary = null;
    $c79bde28d689cb05$var$Nh.length = 0;
}
var $c79bde28d689cb05$var$Ph = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$Qh = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$Rh = 0, $c79bde28d689cb05$var$N = null, $c79bde28d689cb05$var$O = null, $c79bde28d689cb05$var$P = null, $c79bde28d689cb05$var$Sh = !1, $c79bde28d689cb05$var$Th = !1, $c79bde28d689cb05$var$Uh = 0, $c79bde28d689cb05$var$Vh = 0;
function $c79bde28d689cb05$var$Q() {
    throw Error($c79bde28d689cb05$var$p(321));
}
function $c79bde28d689cb05$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$c79bde28d689cb05$var$He(a[c], b[c])) return !1;
    return !0;
}
function $c79bde28d689cb05$var$Xh(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$Rh = f;
    $c79bde28d689cb05$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $c79bde28d689cb05$var$Ph.current = null === a || null === a.memoizedState ? $c79bde28d689cb05$var$Yh : $c79bde28d689cb05$var$Zh;
    a = c(d, e);
    if ($c79bde28d689cb05$var$Th) {
        f = 0;
        do {
            $c79bde28d689cb05$var$Th = !1;
            $c79bde28d689cb05$var$Uh = 0;
            if (25 <= f) throw Error($c79bde28d689cb05$var$p(301));
            f += 1;
            $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = null;
            b.updateQueue = null;
            $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$$h;
            a = c(d, e);
        }while ($c79bde28d689cb05$var$Th);
    }
    $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$ai;
    b = null !== $c79bde28d689cb05$var$O && null !== $c79bde28d689cb05$var$O.next;
    $c79bde28d689cb05$var$Rh = 0;
    $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = null;
    $c79bde28d689cb05$var$Sh = !1;
    if (b) throw Error($c79bde28d689cb05$var$p(300));
    return a;
}
function $c79bde28d689cb05$var$bi() {
    var a = 0 !== $c79bde28d689cb05$var$Uh;
    $c79bde28d689cb05$var$Uh = 0;
    return a;
}
function $c79bde28d689cb05$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState = $c79bde28d689cb05$var$P = a : $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$P.next = a;
    return $c79bde28d689cb05$var$P;
}
function $c79bde28d689cb05$var$di() {
    if (null === $c79bde28d689cb05$var$O) {
        var a = $c79bde28d689cb05$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $c79bde28d689cb05$var$O.next;
    var b = null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState : $c79bde28d689cb05$var$P.next;
    if (null !== b) $c79bde28d689cb05$var$P = b, $c79bde28d689cb05$var$O = a;
    else {
        if (null === a) throw Error($c79bde28d689cb05$var$p(310));
        $c79bde28d689cb05$var$O = a;
        a = {
            memoizedState: $c79bde28d689cb05$var$O.memoizedState,
            baseState: $c79bde28d689cb05$var$O.baseState,
            baseQueue: $c79bde28d689cb05$var$O.baseQueue,
            queue: $c79bde28d689cb05$var$O.queue,
            next: null
        };
        null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState = $c79bde28d689cb05$var$P = a : $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$P.next = a;
    }
    return $c79bde28d689cb05$var$P;
}
function $c79bde28d689cb05$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $c79bde28d689cb05$var$fi(a) {
    var b = $c79bde28d689cb05$var$di(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = $c79bde28d689cb05$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($c79bde28d689cb05$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $c79bde28d689cb05$var$N.lanes |= m;
                $c79bde28d689cb05$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $c79bde28d689cb05$var$He(d, b.memoizedState) || ($c79bde28d689cb05$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $c79bde28d689cb05$var$N.lanes |= f, $c79bde28d689cb05$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $c79bde28d689cb05$var$gi(a) {
    var b = $c79bde28d689cb05$var$di(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $c79bde28d689cb05$var$He(f, b.memoizedState) || ($c79bde28d689cb05$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $c79bde28d689cb05$var$hi() {}
function $c79bde28d689cb05$var$ii(a, b) {
    var c = $c79bde28d689cb05$var$N, d = $c79bde28d689cb05$var$di(), e = b(), f = !$c79bde28d689cb05$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $c79bde28d689cb05$var$Ug = !0);
    d = d.queue;
    $c79bde28d689cb05$var$ji($c79bde28d689cb05$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $c79bde28d689cb05$var$P && $c79bde28d689cb05$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $c79bde28d689cb05$var$li(9, $c79bde28d689cb05$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $c79bde28d689cb05$var$R) throw Error($c79bde28d689cb05$var$p(349));
        0 !== ($c79bde28d689cb05$var$Rh & 30) || $c79bde28d689cb05$var$ni(c, b, e);
    }
    return e;
}
function $c79bde28d689cb05$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $c79bde28d689cb05$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $c79bde28d689cb05$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $c79bde28d689cb05$var$oi(b) && $c79bde28d689cb05$var$pi(a);
}
function $c79bde28d689cb05$var$ki(a, b, c) {
    return c(function() {
        $c79bde28d689cb05$var$oi(b) && $c79bde28d689cb05$var$pi(a);
    });
}
function $c79bde28d689cb05$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$c79bde28d689cb05$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $c79bde28d689cb05$var$pi(a) {
    var b = $c79bde28d689cb05$var$Zg(a, 1);
    null !== b && $c79bde28d689cb05$var$mh(b, a, 1, -1);
}
function $c79bde28d689cb05$var$qi(a) {
    var b = $c79bde28d689cb05$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c79bde28d689cb05$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $c79bde28d689cb05$var$ri.bind(null, $c79bde28d689cb05$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $c79bde28d689cb05$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $c79bde28d689cb05$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $c79bde28d689cb05$var$si() {
    return $c79bde28d689cb05$var$di().memoizedState;
}
function $c79bde28d689cb05$var$ti(a, b, c, d) {
    var e = $c79bde28d689cb05$var$ci();
    $c79bde28d689cb05$var$N.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $c79bde28d689cb05$var$ui(a, b, c, d) {
    var e = $c79bde28d689cb05$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $c79bde28d689cb05$var$O) {
        var g = $c79bde28d689cb05$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $c79bde28d689cb05$var$Wh(d, g.deps)) {
            e.memoizedState = $c79bde28d689cb05$var$li(b, c, f, d);
            return;
        }
    }
    $c79bde28d689cb05$var$N.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$li(1 | b, c, f, d);
}
function $c79bde28d689cb05$var$vi(a, b) {
    return $c79bde28d689cb05$var$ti(8390656, 8, a, b);
}
function $c79bde28d689cb05$var$ji(a, b) {
    return $c79bde28d689cb05$var$ui(2048, 8, a, b);
}
function $c79bde28d689cb05$var$wi(a, b) {
    return $c79bde28d689cb05$var$ui(4, 2, a, b);
}
function $c79bde28d689cb05$var$xi(a, b) {
    return $c79bde28d689cb05$var$ui(4, 4, a, b);
}
function $c79bde28d689cb05$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $c79bde28d689cb05$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $c79bde28d689cb05$var$ui(4, 4, $c79bde28d689cb05$var$yi.bind(null, b, a), c);
}
function $c79bde28d689cb05$var$Ai() {}
function $c79bde28d689cb05$var$Bi(a, b) {
    var c = $c79bde28d689cb05$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$Ci(a, b) {
    var c = $c79bde28d689cb05$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$Di(a, b, c) {
    if (0 === ($c79bde28d689cb05$var$Rh & 21)) return a.baseState && (a.baseState = !1, $c79bde28d689cb05$var$Ug = !0), a.memoizedState = c;
    $c79bde28d689cb05$var$He(c, b) || (c = $c79bde28d689cb05$var$yc(), $c79bde28d689cb05$var$N.lanes |= c, $c79bde28d689cb05$var$hh |= c, a.baseState = !0);
    return b;
}
function $c79bde28d689cb05$var$Ei(a, b) {
    var c = $c79bde28d689cb05$var$C;
    $c79bde28d689cb05$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $c79bde28d689cb05$var$Qh.transition;
    $c79bde28d689cb05$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$Qh.transition = d;
    }
}
function $c79bde28d689cb05$var$Fi() {
    return $c79bde28d689cb05$var$di().memoizedState;
}
function $c79bde28d689cb05$var$Gi(a, b, c) {
    var d = $c79bde28d689cb05$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$Hi(a)) $c79bde28d689cb05$var$Ii(b, c);
    else if (c = $c79bde28d689cb05$var$Yg(a, b, c, d), null !== c) {
        var e = $c79bde28d689cb05$var$L();
        $c79bde28d689cb05$var$mh(c, a, d, e);
        $c79bde28d689cb05$var$Ji(c, b, d);
    }
}
function $c79bde28d689cb05$var$ri(a, b, c) {
    var d = $c79bde28d689cb05$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$Hi(a)) $c79bde28d689cb05$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($c79bde28d689cb05$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $c79bde28d689cb05$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $c79bde28d689cb05$var$Yg(a, b, e, d);
        null !== c && (e = $c79bde28d689cb05$var$L(), $c79bde28d689cb05$var$mh(c, a, d, e), $c79bde28d689cb05$var$Ji(c, b, d));
    }
}
function $c79bde28d689cb05$var$Hi(a) {
    var b = a.alternate;
    return a === $c79bde28d689cb05$var$N || null !== b && b === $c79bde28d689cb05$var$N;
}
function $c79bde28d689cb05$var$Ii(a, b) {
    $c79bde28d689cb05$var$Th = $c79bde28d689cb05$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $c79bde28d689cb05$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
var $c79bde28d689cb05$var$ai = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Q,
    useContext: $c79bde28d689cb05$var$Q,
    useEffect: $c79bde28d689cb05$var$Q,
    useImperativeHandle: $c79bde28d689cb05$var$Q,
    useInsertionEffect: $c79bde28d689cb05$var$Q,
    useLayoutEffect: $c79bde28d689cb05$var$Q,
    useMemo: $c79bde28d689cb05$var$Q,
    useReducer: $c79bde28d689cb05$var$Q,
    useRef: $c79bde28d689cb05$var$Q,
    useState: $c79bde28d689cb05$var$Q,
    useDebugValue: $c79bde28d689cb05$var$Q,
    useDeferredValue: $c79bde28d689cb05$var$Q,
    useTransition: $c79bde28d689cb05$var$Q,
    useMutableSource: $c79bde28d689cb05$var$Q,
    useSyncExternalStore: $c79bde28d689cb05$var$Q,
    useId: $c79bde28d689cb05$var$Q,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Yh = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: function(a, b) {
        $c79bde28d689cb05$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $c79bde28d689cb05$var$ti(4194308, 4, $c79bde28d689cb05$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $c79bde28d689cb05$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $c79bde28d689cb05$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $c79bde28d689cb05$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $c79bde28d689cb05$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $c79bde28d689cb05$var$Gi.bind(null, $c79bde28d689cb05$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $c79bde28d689cb05$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $c79bde28d689cb05$var$qi,
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        return $c79bde28d689cb05$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$qi(!1), b = a[0];
        a = $c79bde28d689cb05$var$Ei.bind(null, a[1]);
        $c79bde28d689cb05$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $c79bde28d689cb05$var$N, e = $c79bde28d689cb05$var$ci();
        if ($c79bde28d689cb05$var$I) {
            if (void 0 === c) throw Error($c79bde28d689cb05$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $c79bde28d689cb05$var$R) throw Error($c79bde28d689cb05$var$p(349));
            0 !== ($c79bde28d689cb05$var$Rh & 30) || $c79bde28d689cb05$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $c79bde28d689cb05$var$vi($c79bde28d689cb05$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $c79bde28d689cb05$var$li(9, $c79bde28d689cb05$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $c79bde28d689cb05$var$ci(), b = $c79bde28d689cb05$var$R.identifierPrefix;
        if ($c79bde28d689cb05$var$I) {
            var c = $c79bde28d689cb05$var$sg;
            var d = $c79bde28d689cb05$var$rg;
            c = (d & ~(1 << 32 - $c79bde28d689cb05$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $c79bde28d689cb05$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $c79bde28d689cb05$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Zh = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Bi,
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$ji,
    useImperativeHandle: $c79bde28d689cb05$var$zi,
    useInsertionEffect: $c79bde28d689cb05$var$wi,
    useLayoutEffect: $c79bde28d689cb05$var$xi,
    useMemo: $c79bde28d689cb05$var$Ci,
    useReducer: $c79bde28d689cb05$var$fi,
    useRef: $c79bde28d689cb05$var$si,
    useState: function() {
        return $c79bde28d689cb05$var$fi($c79bde28d689cb05$var$ei);
    },
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$di();
        return $c79bde28d689cb05$var$Di(b, $c79bde28d689cb05$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$fi($c79bde28d689cb05$var$ei)[0], b = $c79bde28d689cb05$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$hi,
    useSyncExternalStore: $c79bde28d689cb05$var$ii,
    useId: $c79bde28d689cb05$var$Fi,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$$h = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Bi,
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$ji,
    useImperativeHandle: $c79bde28d689cb05$var$zi,
    useInsertionEffect: $c79bde28d689cb05$var$wi,
    useLayoutEffect: $c79bde28d689cb05$var$xi,
    useMemo: $c79bde28d689cb05$var$Ci,
    useReducer: $c79bde28d689cb05$var$gi,
    useRef: $c79bde28d689cb05$var$si,
    useState: function() {
        return $c79bde28d689cb05$var$gi($c79bde28d689cb05$var$ei);
    },
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$di();
        return null === $c79bde28d689cb05$var$O ? b.memoizedState = a : $c79bde28d689cb05$var$Di(b, $c79bde28d689cb05$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$gi($c79bde28d689cb05$var$ei)[0], b = $c79bde28d689cb05$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$hi,
    useSyncExternalStore: $c79bde28d689cb05$var$ii,
    useId: $c79bde28d689cb05$var$Fi,
    unstable_isNewReconciler: !1
};
function $c79bde28d689cb05$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $c79bde28d689cb05$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $c79bde28d689cb05$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $c79bde28d689cb05$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $c79bde28d689cb05$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $c79bde28d689cb05$var$Oi(a, b, c) {
    c = $c79bde28d689cb05$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $c79bde28d689cb05$var$Pi || ($c79bde28d689cb05$var$Pi = !0, $c79bde28d689cb05$var$Qi = d);
        $c79bde28d689cb05$var$Mi(a, b);
    };
    return c;
}
function $c79bde28d689cb05$var$Ri(a, b, c) {
    c = $c79bde28d689cb05$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $c79bde28d689cb05$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $c79bde28d689cb05$var$Mi(a, b);
        "function" !== typeof d && (null === $c79bde28d689cb05$var$Si ? $c79bde28d689cb05$var$Si = new Set([
            this
        ]) : $c79bde28d689cb05$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $c79bde28d689cb05$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $c79bde28d689cb05$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $c79bde28d689cb05$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $c79bde28d689cb05$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $c79bde28d689cb05$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $c79bde28d689cb05$var$ch(-1, 1), b.tag = 2, $c79bde28d689cb05$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $c79bde28d689cb05$var$Xi = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$Ug = !1;
function $c79bde28d689cb05$var$Yi(a, b, c, d) {
    b.child = null === a ? $c79bde28d689cb05$var$Ch(b, null, c, d) : $c79bde28d689cb05$var$Bh(b, a.child, c, d);
}
function $c79bde28d689cb05$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $c79bde28d689cb05$var$Tg(b, e);
    d = $c79bde28d689cb05$var$Xh(a, b, c, d, f, e);
    c = $c79bde28d689cb05$var$bi();
    if (null !== a && !$c79bde28d689cb05$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$$i(a, b, e);
    $c79bde28d689cb05$var$I && c && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Yi(a, b, d, e);
    return b.child;
}
function $c79bde28d689cb05$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$c79bde28d689cb05$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $c79bde28d689cb05$var$cj(a, b, f, d, e);
        a = $c79bde28d689cb05$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $c79bde28d689cb05$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $c79bde28d689cb05$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $c79bde28d689cb05$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $c79bde28d689cb05$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($c79bde28d689cb05$var$Ie(f, d) && a.ref === b.ref) {
            if ($c79bde28d689cb05$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($c79bde28d689cb05$var$Ug = !0);
            else return b.lanes = a.lanes, $c79bde28d689cb05$var$$i(a, b, e);
        }
    }
    return $c79bde28d689cb05$var$dj(a, b, c, d, e);
}
function $c79bde28d689cb05$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj);
            $c79bde28d689cb05$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= d;
    $c79bde28d689cb05$var$Yi(a, b, e, c);
    return b.child;
}
function $c79bde28d689cb05$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $c79bde28d689cb05$var$dj(a, b, c, d, e) {
    var f = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current;
    f = $c79bde28d689cb05$var$Yf(b, f);
    $c79bde28d689cb05$var$Tg(b, e);
    c = $c79bde28d689cb05$var$Xh(a, b, c, d, f, e);
    d = $c79bde28d689cb05$var$bi();
    if (null !== a && !$c79bde28d689cb05$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$$i(a, b, e);
    $c79bde28d689cb05$var$I && d && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Yi(a, b, c, e);
    return b.child;
}
function $c79bde28d689cb05$var$ij(a, b, c, d, e) {
    if ($c79bde28d689cb05$var$Zf(c)) {
        var f = !0;
        $c79bde28d689cb05$var$cg(b);
    } else f = !1;
    $c79bde28d689cb05$var$Tg(b, e);
    if (null === b.stateNode) $c79bde28d689cb05$var$jj(a, b), $c79bde28d689cb05$var$ph(b, c, d), $c79bde28d689cb05$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $c79bde28d689cb05$var$Vg(l) : (l = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, l = $c79bde28d689cb05$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $c79bde28d689cb05$var$qh(b, g, d, l);
        $c79bde28d689cb05$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$$g ? ("function" === typeof m && ($c79bde28d689cb05$var$kh(b, c, m, d), k = b.memoizedState), (h = $c79bde28d689cb05$var$$g || $c79bde28d689cb05$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $c79bde28d689cb05$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $c79bde28d689cb05$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $c79bde28d689cb05$var$Vg(k) : (k = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, k = $c79bde28d689cb05$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $c79bde28d689cb05$var$qh(b, g, d, k);
        $c79bde28d689cb05$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$$g ? ("function" === typeof y && ($c79bde28d689cb05$var$kh(b, c, y, d), n = b.memoizedState), (l = $c79bde28d689cb05$var$$g || $c79bde28d689cb05$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $c79bde28d689cb05$var$kj(a, b, c, d, f, e);
}
function $c79bde28d689cb05$var$kj(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $c79bde28d689cb05$var$dg(b, c, !1), $c79bde28d689cb05$var$$i(a, b, f);
    d = b.stateNode;
    $c79bde28d689cb05$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $c79bde28d689cb05$var$Bh(b, a.child, null, f), b.child = $c79bde28d689cb05$var$Bh(b, null, h, f)) : $c79bde28d689cb05$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $c79bde28d689cb05$var$dg(b, c, !0);
    return b.child;
}
function $c79bde28d689cb05$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $c79bde28d689cb05$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $c79bde28d689cb05$var$ag(a, b.context, !1);
    $c79bde28d689cb05$var$Ih(a, b.containerInfo);
}
function $c79bde28d689cb05$var$mj(a, b, c, d, e) {
    $c79bde28d689cb05$var$Ig();
    $c79bde28d689cb05$var$Jg(e);
    b.flags |= 256;
    $c79bde28d689cb05$var$Yi(a, b, c, d);
    return b.child;
}
var $c79bde28d689cb05$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $c79bde28d689cb05$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $c79bde28d689cb05$var$pj(a, b, c) {
    var d = b.pendingProps, e = $c79bde28d689cb05$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, e & 1);
    if (null === a) {
        $c79bde28d689cb05$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $c79bde28d689cb05$var$qj(g, d, 0, null), a = $c79bde28d689cb05$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $c79bde28d689cb05$var$oj(c), b.memoizedState = $c79bde28d689cb05$var$nj, a) : $c79bde28d689cb05$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $c79bde28d689cb05$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $c79bde28d689cb05$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $c79bde28d689cb05$var$wh(h, f) : (f = $c79bde28d689cb05$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $c79bde28d689cb05$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $c79bde28d689cb05$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $c79bde28d689cb05$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $c79bde28d689cb05$var$rj(a, b) {
    b = $c79bde28d689cb05$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $c79bde28d689cb05$var$tj(a, b, c, d) {
    null !== d && $c79bde28d689cb05$var$Jg(d);
    $c79bde28d689cb05$var$Bh(b, a.child, null, c);
    a = $c79bde28d689cb05$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $c79bde28d689cb05$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $c79bde28d689cb05$var$Li(Error($c79bde28d689cb05$var$p(422))), $c79bde28d689cb05$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $c79bde28d689cb05$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $c79bde28d689cb05$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $c79bde28d689cb05$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $c79bde28d689cb05$var$oj(g);
        b.memoizedState = $c79bde28d689cb05$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $c79bde28d689cb05$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($c79bde28d689cb05$var$p(419));
        d = $c79bde28d689cb05$var$Li(f, d, void 0);
        return $c79bde28d689cb05$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($c79bde28d689cb05$var$Ug || h) {
        d = $c79bde28d689cb05$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $c79bde28d689cb05$var$Zg(a, e), $c79bde28d689cb05$var$mh(d, a, e, -1));
        }
        $c79bde28d689cb05$var$uj();
        d = $c79bde28d689cb05$var$Li(Error($c79bde28d689cb05$var$p(421)));
        return $c79bde28d689cb05$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $c79bde28d689cb05$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(e.nextSibling);
    $c79bde28d689cb05$var$xg = b;
    $c79bde28d689cb05$var$I = !0;
    $c79bde28d689cb05$var$zg = null;
    null !== a && ($c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg, $c79bde28d689cb05$var$rg = a.id, $c79bde28d689cb05$var$sg = a.overflow, $c79bde28d689cb05$var$qg = b);
    b = $c79bde28d689cb05$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $c79bde28d689cb05$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $c79bde28d689cb05$var$Sg(a.return, b, c);
}
function $c79bde28d689cb05$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $c79bde28d689cb05$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $c79bde28d689cb05$var$Yi(a, b, d.children, c);
    d = $c79bde28d689cb05$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $c79bde28d689cb05$var$wj(a, c, b);
            else if (19 === a.tag) $c79bde28d689cb05$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $c79bde28d689cb05$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $c79bde28d689cb05$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $c79bde28d689cb05$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $c79bde28d689cb05$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $c79bde28d689cb05$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $c79bde28d689cb05$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $c79bde28d689cb05$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($c79bde28d689cb05$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $c79bde28d689cb05$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $c79bde28d689cb05$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $c79bde28d689cb05$var$lj(b);
            $c79bde28d689cb05$var$Ig();
            break;
        case 5:
            $c79bde28d689cb05$var$Kh(b);
            break;
        case 1:
            $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$cg(b);
            break;
        case 4:
            $c79bde28d689cb05$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $c79bde28d689cb05$var$pj(a, b, c);
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1);
                a = $c79bde28d689cb05$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $c79bde28d689cb05$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $c79bde28d689cb05$var$ej(a, b, c);
    }
    return $c79bde28d689cb05$var$$i(a, b, c);
}
var $c79bde28d689cb05$var$Aj, $c79bde28d689cb05$var$Bj, $c79bde28d689cb05$var$Cj, $c79bde28d689cb05$var$Dj;
$c79bde28d689cb05$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$c79bde28d689cb05$var$Bj = function() {};
$c79bde28d689cb05$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $c79bde28d689cb05$var$Ya(a, e);
                d = $c79bde28d689cb05$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $c79bde28d689cb05$var$A({}, e, {
                    value: void 0
                });
                d = $c79bde28d689cb05$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $c79bde28d689cb05$var$gb(a, e);
                d = $c79bde28d689cb05$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
        }
        $c79bde28d689cb05$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $c79bde28d689cb05$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$c79bde28d689cb05$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $c79bde28d689cb05$var$Ej(a, b) {
    if (!$c79bde28d689cb05$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $c79bde28d689cb05$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $c79bde28d689cb05$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c79bde28d689cb05$var$S(b), null;
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 3:
            d = b.stateNode;
            $c79bde28d689cb05$var$Jh();
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
            $c79bde28d689cb05$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $c79bde28d689cb05$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Gj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null));
            $c79bde28d689cb05$var$Bj(a, b);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 5:
            $c79bde28d689cb05$var$Lh(b);
            var e = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $c79bde28d689cb05$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                    $c79bde28d689cb05$var$S(b);
                    return null;
                }
                a = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    d[$c79bde28d689cb05$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $c79bde28d689cb05$var$D("cancel", d);
                            $c79bde28d689cb05$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], d);
                            break;
                        case "source":
                            $c79bde28d689cb05$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $c79bde28d689cb05$var$D("error", d);
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "details":
                            $c79bde28d689cb05$var$D("toggle", d);
                            break;
                        case "input":
                            $c79bde28d689cb05$var$Za(d, f);
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$hb(d, f), $c79bde28d689cb05$var$D("invalid", d);
                    }
                    $c79bde28d689cb05$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $c79bde28d689cb05$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $c79bde28d689cb05$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $c79bde28d689cb05$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $c79bde28d689cb05$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$c79bde28d689cb05$var$Of] = b;
                    a[$c79bde28d689cb05$var$Pf] = d;
                    $c79bde28d689cb05$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $c79bde28d689cb05$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $c79bde28d689cb05$var$D("cancel", a);
                                $c79bde28d689cb05$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $c79bde28d689cb05$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $c79bde28d689cb05$var$D("error", a);
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $c79bde28d689cb05$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $c79bde28d689cb05$var$Za(a, d);
                                e = $c79bde28d689cb05$var$Ya(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $c79bde28d689cb05$var$A({}, d, {
                                    value: void 0
                                });
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$hb(a, d);
                                e = $c79bde28d689cb05$var$gb(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $c79bde28d689cb05$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $c79bde28d689cb05$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $c79bde28d689cb05$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $c79bde28d689cb05$var$ob(a, k) : "number" === typeof k && $c79bde28d689cb05$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($c79bde28d689cb05$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $c79bde28d689cb05$var$D("scroll", a) : null != k && $c79bde28d689cb05$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $c79bde28d689cb05$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $c79bde28d689cb05$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $c79bde28d689cb05$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $c79bde28d689cb05$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                c = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
                $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $c79bde28d689cb05$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$c79bde28d689cb05$var$Of] = b, b.stateNode = d;
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($c79bde28d689cb05$var$I && null !== $c79bde28d689cb05$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $c79bde28d689cb05$var$Hg(), $c79bde28d689cb05$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $c79bde28d689cb05$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($c79bde28d689cb05$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($c79bde28d689cb05$var$p(317));
                        f[$c79bde28d689cb05$var$Of] = b;
                    } else $c79bde28d689cb05$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $c79bde28d689cb05$var$S(b);
                    f = !1;
                } else null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Gj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($c79bde28d689cb05$var$M.current & 1) ? 0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 3) : $c79bde28d689cb05$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 4:
            return $c79bde28d689cb05$var$Jh(), $c79bde28d689cb05$var$Bj(a, b), null === a && $c79bde28d689cb05$var$sf(b.stateNode.containerInfo), $c79bde28d689cb05$var$S(b), null;
        case 10:
            return $c79bde28d689cb05$var$Rg(b.type._context), $c79bde28d689cb05$var$S(b), null;
        case 17:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 19:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            f = b.memoizedState;
            if (null === f) return $c79bde28d689cb05$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $c79bde28d689cb05$var$Ej(f, !1);
                else {
                    if (0 !== $c79bde28d689cb05$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $c79bde28d689cb05$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $c79bde28d689cb05$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $c79bde28d689cb05$var$B() > $c79bde28d689cb05$var$Hj && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $c79bde28d689cb05$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $c79bde28d689cb05$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$S(b), null;
                    } else 2 * $c79bde28d689cb05$var$B() - f.renderingStartTime > $c79bde28d689cb05$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $c79bde28d689cb05$var$B(), b.sibling = null, c = $c79bde28d689cb05$var$M.current, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, d ? c & 1 | 2 : c & 1), b;
            $c79bde28d689cb05$var$S(b);
            return null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($c79bde28d689cb05$var$gj & 1073741824) && ($c79bde28d689cb05$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $c79bde28d689cb05$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
}
function $c79bde28d689cb05$var$Jj(a, b) {
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $c79bde28d689cb05$var$Jh(), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $c79bde28d689cb05$var$Lh(b), null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($c79bde28d689cb05$var$p(340));
                $c79bde28d689cb05$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M), null;
        case 4:
            return $c79bde28d689cb05$var$Jh(), null;
        case 10:
            return $c79bde28d689cb05$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$Kj = !1, $c79bde28d689cb05$var$U = !1, $c79bde28d689cb05$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $c79bde28d689cb05$var$V = null;
function $c79bde28d689cb05$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $c79bde28d689cb05$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $c79bde28d689cb05$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $c79bde28d689cb05$var$W(a, b, d);
    }
}
var $c79bde28d689cb05$var$Oj = !1;
function $c79bde28d689cb05$var$Pj(a, b) {
    $c79bde28d689cb05$var$Cf = $c79bde28d689cb05$var$dd;
    a = $c79bde28d689cb05$var$Me();
    if ($c79bde28d689cb05$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $c79bde28d689cb05$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $c79bde28d689cb05$var$dd = !1;
    for($c79bde28d689cb05$var$V = b; null !== $c79bde28d689cb05$var$V;)if (b = $c79bde28d689cb05$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $c79bde28d689cb05$var$V = a;
    else for(; null !== $c79bde28d689cb05$var$V;){
        b = $c79bde28d689cb05$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $c79bde28d689cb05$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(163));
            }
        } catch (F) {
            $c79bde28d689cb05$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $c79bde28d689cb05$var$V = a;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
    n = $c79bde28d689cb05$var$Oj;
    $c79bde28d689cb05$var$Oj = !1;
    return n;
}
function $c79bde28d689cb05$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $c79bde28d689cb05$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $c79bde28d689cb05$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $c79bde28d689cb05$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $c79bde28d689cb05$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $c79bde28d689cb05$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$c79bde28d689cb05$var$Of], delete b[$c79bde28d689cb05$var$Pf], delete b[$c79bde28d689cb05$var$of], delete b[$c79bde28d689cb05$var$Qf], delete b[$c79bde28d689cb05$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $c79bde28d689cb05$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $c79bde28d689cb05$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $c79bde28d689cb05$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $c79bde28d689cb05$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $c79bde28d689cb05$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling;
}
function $c79bde28d689cb05$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Xj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Xj(a, b, c), a = a.sibling;
}
var $c79bde28d689cb05$var$X = null, $c79bde28d689cb05$var$Yj = !1;
function $c79bde28d689cb05$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$c79bde28d689cb05$var$ak(a, b, c), c = c.sibling;
}
function $c79bde28d689cb05$var$ak(a, b, c) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberUnmount) try {
        $c79bde28d689cb05$var$lc.onCommitFiberUnmount($c79bde28d689cb05$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Mj(c, b);
        case 6:
            var d = $c79bde28d689cb05$var$X, e = $c79bde28d689cb05$var$Yj;
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Zj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Yj = e;
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Yj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $c79bde28d689cb05$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Yj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? $c79bde28d689cb05$var$Kf(a.parentNode, c) : 1 === a.nodeType && $c79bde28d689cb05$var$Kf(a, c), $c79bde28d689cb05$var$bd(a)) : $c79bde28d689cb05$var$Kf($c79bde28d689cb05$var$X, c.stateNode));
            break;
        case 4:
            d = $c79bde28d689cb05$var$X;
            e = $c79bde28d689cb05$var$Yj;
            $c79bde28d689cb05$var$X = c.stateNode.containerInfo;
            $c79bde28d689cb05$var$Yj = !0;
            $c79bde28d689cb05$var$Zj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$c79bde28d689cb05$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $c79bde28d689cb05$var$Nj(c, b, g) : 0 !== (f & 4) && $c79bde28d689cb05$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 1:
            if (!$c79bde28d689cb05$var$U && ($c79bde28d689cb05$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $c79bde28d689cb05$var$W(c, b, h);
            }
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 21:
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($c79bde28d689cb05$var$U = (d = $c79bde28d689cb05$var$U) || null !== c.memoizedState, $c79bde28d689cb05$var$Zj(a, b, c), $c79bde28d689cb05$var$U = d) : $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        default:
            $c79bde28d689cb05$var$Zj(a, b, c);
    }
}
function $c79bde28d689cb05$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $c79bde28d689cb05$var$Lj);
        b.forEach(function(b) {
            var d = $c79bde28d689cb05$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $c79bde28d689cb05$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $c79bde28d689cb05$var$X = h.stateNode;
                        $c79bde28d689cb05$var$Yj = !1;
                        break a;
                    case 3:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Yj = !0;
                        break a;
                    case 4:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $c79bde28d689cb05$var$X) throw Error($c79bde28d689cb05$var$p(160));
            $c79bde28d689cb05$var$ak(f, g, e);
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $c79bde28d689cb05$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$c79bde28d689cb05$var$ek(b, a), b = b.sibling;
}
function $c79bde28d689cb05$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4) {
                try {
                    $c79bde28d689cb05$var$Qj(3, a, a.return), $c79bde28d689cb05$var$Rj(3, a);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
                try {
                    $c79bde28d689cb05$var$Qj(5, a, a.return);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Mj(c, c.return);
            break;
        case 5:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $c79bde28d689cb05$var$ob(e, "");
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $c79bde28d689cb05$var$ab(e, f);
                    $c79bde28d689cb05$var$vb(h, g);
                    var l = $c79bde28d689cb05$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $c79bde28d689cb05$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $c79bde28d689cb05$var$nb(e, q) : "children" === m ? $c79bde28d689cb05$var$ob(e, q) : $c79bde28d689cb05$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $c79bde28d689cb05$var$bb(e, f);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $c79bde28d689cb05$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $c79bde28d689cb05$var$fb(e, !!f.multiple, f.defaultValue, !0) : $c79bde28d689cb05$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$c79bde28d689cb05$var$Pf] = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($c79bde28d689cb05$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $c79bde28d689cb05$var$bd(b.containerInfo);
            } catch (t) {
                $c79bde28d689cb05$var$W(a, a.return, t);
            }
            break;
        case 4:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            break;
        case 13:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($c79bde28d689cb05$var$gk = $c79bde28d689cb05$var$B()));
            d & 4 && $c79bde28d689cb05$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($c79bde28d689cb05$var$U = (l = $c79bde28d689cb05$var$U) || m, $c79bde28d689cb05$var$dk(b, a), $c79bde28d689cb05$var$U = l) : $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($c79bde28d689cb05$var$V = a, m = a.child; null !== m;){
                    for(q = $c79bde28d689cb05$var$V = m; null !== $c79bde28d689cb05$var$V;){
                        r = $c79bde28d689cb05$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $c79bde28d689cb05$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $c79bde28d689cb05$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $c79bde28d689cb05$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $c79bde28d689cb05$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $c79bde28d689cb05$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $c79bde28d689cb05$var$V = y) : $c79bde28d689cb05$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $c79bde28d689cb05$var$rb("display", g));
                            } catch (t) {
                                $c79bde28d689cb05$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $c79bde28d689cb05$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 4 && $c79bde28d689cb05$var$bk(a);
            break;
        case 21:
            break;
        default:
            $c79bde28d689cb05$var$dk(b, a), $c79bde28d689cb05$var$fk(a);
    }
}
function $c79bde28d689cb05$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($c79bde28d689cb05$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($c79bde28d689cb05$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($c79bde28d689cb05$var$ob(e, ""), d.flags &= -33);
                    var f = $c79bde28d689cb05$var$Vj(a);
                    $c79bde28d689cb05$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $c79bde28d689cb05$var$Vj(a);
                    $c79bde28d689cb05$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(161));
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $c79bde28d689cb05$var$ik(a, b, c) {
    $c79bde28d689cb05$var$V = a;
    $c79bde28d689cb05$var$jk(a, b, c);
}
function $c79bde28d689cb05$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $c79bde28d689cb05$var$V;){
        var e = $c79bde28d689cb05$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $c79bde28d689cb05$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $c79bde28d689cb05$var$U;
                h = $c79bde28d689cb05$var$Kj;
                var l = $c79bde28d689cb05$var$U;
                $c79bde28d689cb05$var$Kj = g;
                if (($c79bde28d689cb05$var$U = k) && !l) for($c79bde28d689cb05$var$V = e; null !== $c79bde28d689cb05$var$V;)g = $c79bde28d689cb05$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $c79bde28d689cb05$var$kk(e) : null !== k ? (k.return = g, $c79bde28d689cb05$var$V = k) : $c79bde28d689cb05$var$kk(e);
                for(; null !== f;)$c79bde28d689cb05$var$V = f, $c79bde28d689cb05$var$jk(f, b, c), f = f.sibling;
                $c79bde28d689cb05$var$V = e;
                $c79bde28d689cb05$var$Kj = h;
                $c79bde28d689cb05$var$U = l;
            }
            $c79bde28d689cb05$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $c79bde28d689cb05$var$V = f) : $c79bde28d689cb05$var$lk(a, b, c);
    }
}
function $c79bde28d689cb05$var$lk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$c79bde28d689cb05$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $c79bde28d689cb05$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $c79bde28d689cb05$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $c79bde28d689cb05$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $c79bde28d689cb05$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($c79bde28d689cb05$var$p(163));
                }
                $c79bde28d689cb05$var$U || b.flags & 512 && $c79bde28d689cb05$var$Sj(b);
            } catch (r) {
                $c79bde28d689cb05$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$hk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$kk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $c79bde28d689cb05$var$Rj(4, b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $c79bde28d689cb05$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $c79bde28d689cb05$var$Sj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $c79bde28d689cb05$var$Sj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(b, b.return, k);
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $c79bde28d689cb05$var$V = h;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
var $c79bde28d689cb05$var$mk = Math.ceil, $c79bde28d689cb05$var$nk = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$ok = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$pk = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$K = 0, $c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Y = null, $c79bde28d689cb05$var$Z = 0, $c79bde28d689cb05$var$gj = 0, $c79bde28d689cb05$var$fj = $c79bde28d689cb05$var$Uf(0), $c79bde28d689cb05$var$T = 0, $c79bde28d689cb05$var$qk = null, $c79bde28d689cb05$var$hh = 0, $c79bde28d689cb05$var$rk = 0, $c79bde28d689cb05$var$sk = 0, $c79bde28d689cb05$var$tk = null, $c79bde28d689cb05$var$uk = null, $c79bde28d689cb05$var$gk = 0, $c79bde28d689cb05$var$Hj = Infinity, $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Pi = !1, $c79bde28d689cb05$var$Qi = null, $c79bde28d689cb05$var$Si = null, $c79bde28d689cb05$var$wk = !1, $c79bde28d689cb05$var$xk = null, $c79bde28d689cb05$var$yk = 0, $c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = null, $c79bde28d689cb05$var$Bk = -1, $c79bde28d689cb05$var$Ck = 0;
function $c79bde28d689cb05$var$L() {
    return 0 !== ($c79bde28d689cb05$var$K & 6) ? $c79bde28d689cb05$var$B() : -1 !== $c79bde28d689cb05$var$Bk ? $c79bde28d689cb05$var$Bk : $c79bde28d689cb05$var$Bk = $c79bde28d689cb05$var$B();
}
function $c79bde28d689cb05$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($c79bde28d689cb05$var$K & 2) && 0 !== $c79bde28d689cb05$var$Z) return $c79bde28d689cb05$var$Z & -$c79bde28d689cb05$var$Z;
    if (null !== $c79bde28d689cb05$var$Kg.transition) return 0 === $c79bde28d689cb05$var$Ck && ($c79bde28d689cb05$var$Ck = $c79bde28d689cb05$var$yc()), $c79bde28d689cb05$var$Ck;
    a = $c79bde28d689cb05$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $c79bde28d689cb05$var$jd(a.type);
    return a;
}
function $c79bde28d689cb05$var$mh(a, b, c, d) {
    if (50 < $c79bde28d689cb05$var$zk) throw $c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = null, Error($c79bde28d689cb05$var$p(185));
    $c79bde28d689cb05$var$Ac(a, c, d);
    if (0 === ($c79bde28d689cb05$var$K & 2) || a !== $c79bde28d689cb05$var$R) a === $c79bde28d689cb05$var$R && (0 === ($c79bde28d689cb05$var$K & 2) && ($c79bde28d689cb05$var$rk |= c), 4 === $c79bde28d689cb05$var$T && $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$Z)), $c79bde28d689cb05$var$Ek(a, d), 1 === c && 0 === $c79bde28d689cb05$var$K && 0 === (b.mode & 1) && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
}
function $c79bde28d689cb05$var$Ek(a, b) {
    var c = a.callbackNode;
    $c79bde28d689cb05$var$wc(a, b);
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$R ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) null !== c && $c79bde28d689cb05$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $c79bde28d689cb05$var$bc(c);
        if (1 === b) 0 === a.tag ? $c79bde28d689cb05$var$ig($c79bde28d689cb05$var$Fk.bind(null, a)) : $c79bde28d689cb05$var$hg($c79bde28d689cb05$var$Fk.bind(null, a)), $c79bde28d689cb05$var$Jf(function() {
            0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
        }), c = null;
        else {
            switch($c79bde28d689cb05$var$Dc(d)){
                case 1:
                    c = $c79bde28d689cb05$var$fc;
                    break;
                case 4:
                    c = $c79bde28d689cb05$var$gc;
                    break;
                case 16:
                    c = $c79bde28d689cb05$var$hc;
                    break;
                case 536870912:
                    c = $c79bde28d689cb05$var$jc;
                    break;
                default:
                    c = $c79bde28d689cb05$var$hc;
            }
            c = $c79bde28d689cb05$var$Gk(c, $c79bde28d689cb05$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $c79bde28d689cb05$var$Hk(a, b) {
    $c79bde28d689cb05$var$Bk = -1;
    $c79bde28d689cb05$var$Ck = 0;
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    var c = a.callbackNode;
    if ($c79bde28d689cb05$var$Ik() && a.callbackNode !== c) return null;
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$R ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $c79bde28d689cb05$var$Jk(a, d);
    else {
        b = d;
        var e = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 2;
        var f = $c79bde28d689cb05$var$Kk();
        if ($c79bde28d689cb05$var$R !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$Lk(a, b);
        for(;;)try {
            $c79bde28d689cb05$var$Mk();
            break;
        } catch (h) {
            $c79bde28d689cb05$var$Nk(a, h);
        }
        $c79bde28d689cb05$var$Qg();
        $c79bde28d689cb05$var$nk.current = f;
        $c79bde28d689cb05$var$K = e;
        null !== $c79bde28d689cb05$var$Y ? b = 0 : ($c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Z = 0, b = $c79bde28d689cb05$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $c79bde28d689cb05$var$xc(a), 0 !== e && (d = e, b = $c79bde28d689cb05$var$Ok(a, e)));
        if (1 === b) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, d), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
        if (6 === b) $c79bde28d689cb05$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$c79bde28d689cb05$var$Pk(e) && (b = $c79bde28d689cb05$var$Jk(a, d), 2 === b && (f = $c79bde28d689cb05$var$xc(a), 0 !== f && (d = f, b = $c79bde28d689cb05$var$Ok(a, f))), 1 === b)) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, d), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($c79bde28d689cb05$var$p(345));
                case 2:
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 3:
                    $c79bde28d689cb05$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $c79bde28d689cb05$var$gk + 500 - $c79bde28d689cb05$var$B(), 10 < b)) {
                        if (0 !== $c79bde28d689cb05$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $c79bde28d689cb05$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Qk.bind(null, a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk), b);
                        break;
                    }
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 4:
                    $c79bde28d689cb05$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $c79bde28d689cb05$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $c79bde28d689cb05$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $c79bde28d689cb05$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Qk.bind(null, a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk), d);
                        break;
                    }
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 5:
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(329));
            }
        }
    }
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    return a.callbackNode === c ? $c79bde28d689cb05$var$Hk.bind(null, a) : null;
}
function $c79bde28d689cb05$var$Ok(a, b) {
    var c = $c79bde28d689cb05$var$tk;
    a.current.memoizedState.isDehydrated && ($c79bde28d689cb05$var$Lk(a, b).flags |= 256);
    a = $c79bde28d689cb05$var$Jk(a, b);
    2 !== a && (b = $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$uk = c, null !== b && $c79bde28d689cb05$var$Gj(b));
    return a;
}
function $c79bde28d689cb05$var$Gj(a) {
    null === $c79bde28d689cb05$var$uk ? $c79bde28d689cb05$var$uk = a : $c79bde28d689cb05$var$uk.push.apply($c79bde28d689cb05$var$uk, a);
}
function $c79bde28d689cb05$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$c79bde28d689cb05$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $c79bde28d689cb05$var$Dk(a, b) {
    b &= ~$c79bde28d689cb05$var$sk;
    b &= ~$c79bde28d689cb05$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $c79bde28d689cb05$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $c79bde28d689cb05$var$Fk(a) {
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    $c79bde28d689cb05$var$Ik();
    var b = $c79bde28d689cb05$var$uc(a, 0);
    if (0 === (b & 1)) return $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), null;
    var c = $c79bde28d689cb05$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $c79bde28d689cb05$var$xc(a);
        0 !== d && (b = d, c = $c79bde28d689cb05$var$Ok(a, d));
    }
    if (1 === c) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, b), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
    if (6 === c) throw Error($c79bde28d689cb05$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    return null;
}
function $c79bde28d689cb05$var$Rk(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    try {
        return a(b);
    } finally{
        $c79bde28d689cb05$var$K = c, 0 === $c79bde28d689cb05$var$K && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
    }
}
function $c79bde28d689cb05$var$Sk(a) {
    null !== $c79bde28d689cb05$var$xk && 0 === $c79bde28d689cb05$var$xk.tag && 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$Ik();
    var b = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    var c = $c79bde28d689cb05$var$pk.transition, d = $c79bde28d689cb05$var$C;
    try {
        if ($c79bde28d689cb05$var$pk.transition = null, $c79bde28d689cb05$var$C = 1, a) return a();
    } finally{
        $c79bde28d689cb05$var$C = d, $c79bde28d689cb05$var$pk.transition = c, $c79bde28d689cb05$var$K = b, 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
    }
}
function $c79bde28d689cb05$var$Ij() {
    $c79bde28d689cb05$var$gj = $c79bde28d689cb05$var$fj.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$fj);
}
function $c79bde28d689cb05$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $c79bde28d689cb05$var$Gf(c));
    if (null !== $c79bde28d689cb05$var$Y) for(c = $c79bde28d689cb05$var$Y.return; null !== c;){
        var d = c;
        $c79bde28d689cb05$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $c79bde28d689cb05$var$$f();
                break;
            case 3:
                $c79bde28d689cb05$var$Jh();
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
                $c79bde28d689cb05$var$Oh();
                break;
            case 5:
                $c79bde28d689cb05$var$Lh(d);
                break;
            case 4:
                $c79bde28d689cb05$var$Jh();
                break;
            case 13:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
                break;
            case 19:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
                break;
            case 10:
                $c79bde28d689cb05$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $c79bde28d689cb05$var$Ij();
        }
        c = c.return;
    }
    $c79bde28d689cb05$var$R = a;
    $c79bde28d689cb05$var$Y = a = $c79bde28d689cb05$var$wh(a.current, null);
    $c79bde28d689cb05$var$Z = $c79bde28d689cb05$var$gj = b;
    $c79bde28d689cb05$var$T = 0;
    $c79bde28d689cb05$var$qk = null;
    $c79bde28d689cb05$var$sk = $c79bde28d689cb05$var$rk = $c79bde28d689cb05$var$hh = 0;
    $c79bde28d689cb05$var$uk = $c79bde28d689cb05$var$tk = null;
    if (null !== $c79bde28d689cb05$var$Wg) {
        for(b = 0; b < $c79bde28d689cb05$var$Wg.length; b++)if (c = $c79bde28d689cb05$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $c79bde28d689cb05$var$Wg = null;
    }
    return a;
}
function $c79bde28d689cb05$var$Nk(a, b) {
    do {
        var c = $c79bde28d689cb05$var$Y;
        try {
            $c79bde28d689cb05$var$Qg();
            $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$ai;
            if ($c79bde28d689cb05$var$Sh) {
                for(var d = $c79bde28d689cb05$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $c79bde28d689cb05$var$Sh = !1;
            }
            $c79bde28d689cb05$var$Rh = 0;
            $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = null;
            $c79bde28d689cb05$var$Th = !1;
            $c79bde28d689cb05$var$Uh = 0;
            $c79bde28d689cb05$var$ok.current = null;
            if (null === c || null === c.return) {
                $c79bde28d689cb05$var$T = 1;
                $c79bde28d689cb05$var$qk = b;
                $c79bde28d689cb05$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $c79bde28d689cb05$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $c79bde28d689cb05$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $c79bde28d689cb05$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $c79bde28d689cb05$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $c79bde28d689cb05$var$Ti(f, l, b);
                            $c79bde28d689cb05$var$uj();
                            break a;
                        }
                        k = Error($c79bde28d689cb05$var$p(426));
                    }
                } else if ($c79bde28d689cb05$var$I && h.mode & 1) {
                    var J = $c79bde28d689cb05$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $c79bde28d689cb05$var$Wi(J, g, h, f, b);
                        $c79bde28d689cb05$var$Jg($c79bde28d689cb05$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $c79bde28d689cb05$var$Ki(k, h);
                4 !== $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 2);
                null === $c79bde28d689cb05$var$tk ? $c79bde28d689cb05$var$tk = [
                    f
                ] : $c79bde28d689cb05$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $c79bde28d689cb05$var$Oi(f, k, b);
                            $c79bde28d689cb05$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $c79bde28d689cb05$var$Si || !$c79bde28d689cb05$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $c79bde28d689cb05$var$Ri(f, h, b);
                                $c79bde28d689cb05$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $c79bde28d689cb05$var$Tk(c);
        } catch (na) {
            b = na;
            $c79bde28d689cb05$var$Y === c && null !== c && ($c79bde28d689cb05$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $c79bde28d689cb05$var$Kk() {
    var a = $c79bde28d689cb05$var$nk.current;
    $c79bde28d689cb05$var$nk.current = $c79bde28d689cb05$var$ai;
    return null === a ? $c79bde28d689cb05$var$ai : a;
}
function $c79bde28d689cb05$var$uj() {
    if (0 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T || 2 === $c79bde28d689cb05$var$T) $c79bde28d689cb05$var$T = 4;
    null === $c79bde28d689cb05$var$R || 0 === ($c79bde28d689cb05$var$hh & 268435455) && 0 === ($c79bde28d689cb05$var$rk & 268435455) || $c79bde28d689cb05$var$Dk($c79bde28d689cb05$var$R, $c79bde28d689cb05$var$Z);
}
function $c79bde28d689cb05$var$Jk(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 2;
    var d = $c79bde28d689cb05$var$Kk();
    if ($c79bde28d689cb05$var$R !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Lk(a, b);
    for(;;)try {
        $c79bde28d689cb05$var$Uk();
        break;
    } catch (e) {
        $c79bde28d689cb05$var$Nk(a, e);
    }
    $c79bde28d689cb05$var$Qg();
    $c79bde28d689cb05$var$K = c;
    $c79bde28d689cb05$var$nk.current = d;
    if (null !== $c79bde28d689cb05$var$Y) throw Error($c79bde28d689cb05$var$p(261));
    $c79bde28d689cb05$var$R = null;
    $c79bde28d689cb05$var$Z = 0;
    return $c79bde28d689cb05$var$T;
}
function $c79bde28d689cb05$var$Uk() {
    for(; null !== $c79bde28d689cb05$var$Y;)$c79bde28d689cb05$var$Vk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Mk() {
    for(; null !== $c79bde28d689cb05$var$Y && !$c79bde28d689cb05$var$cc();)$c79bde28d689cb05$var$Vk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Vk(a) {
    var b = $c79bde28d689cb05$var$Wk(a.alternate, a, $c79bde28d689cb05$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $c79bde28d689cb05$var$Tk(a) : $c79bde28d689cb05$var$Y = b;
    $c79bde28d689cb05$var$ok.current = null;
}
function $c79bde28d689cb05$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $c79bde28d689cb05$var$Fj(c, b, $c79bde28d689cb05$var$gj), null !== c) {
                $c79bde28d689cb05$var$Y = c;
                return;
            }
        } else {
            c = $c79bde28d689cb05$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $c79bde28d689cb05$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $c79bde28d689cb05$var$T = 6;
                $c79bde28d689cb05$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $c79bde28d689cb05$var$Y = b;
            return;
        }
        $c79bde28d689cb05$var$Y = b = a;
    }while (null !== b);
    0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 5);
}
function $c79bde28d689cb05$var$Qk(a, b, c) {
    var d = $c79bde28d689cb05$var$C, e = $c79bde28d689cb05$var$pk.transition;
    try {
        $c79bde28d689cb05$var$pk.transition = null, $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$Xk(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$pk.transition = e, $c79bde28d689cb05$var$C = d;
    }
    return null;
}
function $c79bde28d689cb05$var$Xk(a, b, c, d) {
    do $c79bde28d689cb05$var$Ik();
    while (null !== $c79bde28d689cb05$var$xk);
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($c79bde28d689cb05$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $c79bde28d689cb05$var$Bc(a, f);
    a === $c79bde28d689cb05$var$R && ($c79bde28d689cb05$var$Y = $c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $c79bde28d689cb05$var$wk || ($c79bde28d689cb05$var$wk = !0, $c79bde28d689cb05$var$Gk($c79bde28d689cb05$var$hc, function() {
        $c79bde28d689cb05$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $c79bde28d689cb05$var$pk.transition;
        $c79bde28d689cb05$var$pk.transition = null;
        var g = $c79bde28d689cb05$var$C;
        $c79bde28d689cb05$var$C = 1;
        var h = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 4;
        $c79bde28d689cb05$var$ok.current = null;
        $c79bde28d689cb05$var$Pj(a, c);
        $c79bde28d689cb05$var$ek(c, a);
        $c79bde28d689cb05$var$Oe($c79bde28d689cb05$var$Df);
        $c79bde28d689cb05$var$dd = !!$c79bde28d689cb05$var$Cf;
        $c79bde28d689cb05$var$Df = $c79bde28d689cb05$var$Cf = null;
        a.current = c;
        $c79bde28d689cb05$var$ik(c, a, e);
        $c79bde28d689cb05$var$dc();
        $c79bde28d689cb05$var$K = h;
        $c79bde28d689cb05$var$C = g;
        $c79bde28d689cb05$var$pk.transition = f;
    } else a.current = c;
    $c79bde28d689cb05$var$wk && ($c79bde28d689cb05$var$wk = !1, $c79bde28d689cb05$var$xk = a, $c79bde28d689cb05$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($c79bde28d689cb05$var$Si = null);
    $c79bde28d689cb05$var$mc(c.stateNode, d);
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($c79bde28d689cb05$var$Pi) throw $c79bde28d689cb05$var$Pi = !1, a = $c79bde28d689cb05$var$Qi, $c79bde28d689cb05$var$Qi = null, a;
    0 !== ($c79bde28d689cb05$var$yk & 1) && 0 !== a.tag && $c79bde28d689cb05$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $c79bde28d689cb05$var$Ak ? $c79bde28d689cb05$var$zk++ : ($c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = a) : $c79bde28d689cb05$var$zk = 0;
    $c79bde28d689cb05$var$jg();
    return null;
}
function $c79bde28d689cb05$var$Ik() {
    if (null !== $c79bde28d689cb05$var$xk) {
        var a = $c79bde28d689cb05$var$Dc($c79bde28d689cb05$var$yk), b = $c79bde28d689cb05$var$pk.transition, c = $c79bde28d689cb05$var$C;
        try {
            $c79bde28d689cb05$var$pk.transition = null;
            $c79bde28d689cb05$var$C = 16 > a ? 16 : a;
            if (null === $c79bde28d689cb05$var$xk) var d = !1;
            else {
                a = $c79bde28d689cb05$var$xk;
                $c79bde28d689cb05$var$xk = null;
                $c79bde28d689cb05$var$yk = 0;
                if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(331));
                var e = $c79bde28d689cb05$var$K;
                $c79bde28d689cb05$var$K |= 4;
                for($c79bde28d689cb05$var$V = a.current; null !== $c79bde28d689cb05$var$V;){
                    var f = $c79bde28d689cb05$var$V, g = f.child;
                    if (0 !== ($c79bde28d689cb05$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($c79bde28d689cb05$var$V = l; null !== $c79bde28d689cb05$var$V;){
                                    var m = $c79bde28d689cb05$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $c79bde28d689cb05$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $c79bde28d689cb05$var$V = q;
                                    else for(; null !== $c79bde28d689cb05$var$V;){
                                        m = $c79bde28d689cb05$var$V;
                                        var r = m.sibling, y = m.return;
                                        $c79bde28d689cb05$var$Tj(m);
                                        if (m === l) {
                                            $c79bde28d689cb05$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $c79bde28d689cb05$var$V = r;
                                            break;
                                        }
                                        $c79bde28d689cb05$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $c79bde28d689cb05$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $c79bde28d689cb05$var$V = g;
                    else b: for(; null !== $c79bde28d689cb05$var$V;){
                        f = $c79bde28d689cb05$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $c79bde28d689cb05$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $c79bde28d689cb05$var$V = x;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = f.return;
                    }
                }
                var w = a.current;
                for($c79bde28d689cb05$var$V = w; null !== $c79bde28d689cb05$var$V;){
                    g = $c79bde28d689cb05$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $c79bde28d689cb05$var$V = u;
                    else b: for(g = w; null !== $c79bde28d689cb05$var$V;){
                        h = $c79bde28d689cb05$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $c79bde28d689cb05$var$Rj(9, h);
                            }
                        } catch (na) {
                            $c79bde28d689cb05$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $c79bde28d689cb05$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $c79bde28d689cb05$var$V = F;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = h.return;
                    }
                }
                $c79bde28d689cb05$var$K = e;
                $c79bde28d689cb05$var$jg();
                if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onPostCommitFiberRoot) try {
                    $c79bde28d689cb05$var$lc.onPostCommitFiberRoot($c79bde28d689cb05$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$pk.transition = b;
        }
    }
    return !1;
}
function $c79bde28d689cb05$var$Yk(a, b, c) {
    b = $c79bde28d689cb05$var$Ki(c, b);
    b = $c79bde28d689cb05$var$Oi(a, b, 1);
    a = $c79bde28d689cb05$var$dh(a, b, 1);
    b = $c79bde28d689cb05$var$L();
    null !== a && ($c79bde28d689cb05$var$Ac(a, 1, b), $c79bde28d689cb05$var$Ek(a, b));
}
function $c79bde28d689cb05$var$W(a, b, c) {
    if (3 === a.tag) $c79bde28d689cb05$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $c79bde28d689cb05$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $c79bde28d689cb05$var$Si || !$c79bde28d689cb05$var$Si.has(d))) {
                a = $c79bde28d689cb05$var$Ki(c, a);
                a = $c79bde28d689cb05$var$Ri(b, a, 1);
                b = $c79bde28d689cb05$var$dh(b, a, 1);
                a = $c79bde28d689cb05$var$L();
                null !== b && ($c79bde28d689cb05$var$Ac(b, 1, a), $c79bde28d689cb05$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $c79bde28d689cb05$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $c79bde28d689cb05$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $c79bde28d689cb05$var$R === a && ($c79bde28d689cb05$var$Z & c) === c && (4 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$Z & 130023424) === $c79bde28d689cb05$var$Z && 500 > $c79bde28d689cb05$var$B() - $c79bde28d689cb05$var$gk ? $c79bde28d689cb05$var$Lk(a, 0) : $c79bde28d689cb05$var$sk |= c);
    $c79bde28d689cb05$var$Ek(a, b);
}
function $c79bde28d689cb05$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $c79bde28d689cb05$var$sc, $c79bde28d689cb05$var$sc <<= 1, 0 === ($c79bde28d689cb05$var$sc & 130023424) && ($c79bde28d689cb05$var$sc = 4194304)));
    var c = $c79bde28d689cb05$var$L();
    a = $c79bde28d689cb05$var$Zg(a, b);
    null !== a && ($c79bde28d689cb05$var$Ac(a, b, c), $c79bde28d689cb05$var$Ek(a, c));
}
function $c79bde28d689cb05$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $c79bde28d689cb05$var$Zk(a, c);
}
function $c79bde28d689cb05$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($c79bde28d689cb05$var$p(314));
    }
    null !== d && d.delete(b);
    $c79bde28d689cb05$var$Zk(a, c);
}
var $c79bde28d689cb05$var$Wk;
$c79bde28d689cb05$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $c79bde28d689cb05$var$Wf.current) $c79bde28d689cb05$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $c79bde28d689cb05$var$Ug = !1, $c79bde28d689cb05$var$zj(a, b, c);
            $c79bde28d689cb05$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $c79bde28d689cb05$var$Ug = !1, $c79bde28d689cb05$var$I && 0 !== (b.flags & 1048576) && $c79bde28d689cb05$var$ug(b, $c79bde28d689cb05$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $c79bde28d689cb05$var$jj(a, b);
            a = b.pendingProps;
            var e = $c79bde28d689cb05$var$Yf(b, $c79bde28d689cb05$var$H.current);
            $c79bde28d689cb05$var$Tg(b, c);
            e = $c79bde28d689cb05$var$Xh(null, b, d, a, e, c);
            var f = $c79bde28d689cb05$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $c79bde28d689cb05$var$Zf(d) ? (f = !0, $c79bde28d689cb05$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $c79bde28d689cb05$var$ah(b), e.updater = $c79bde28d689cb05$var$nh, b.stateNode = e, e._reactInternals = b, $c79bde28d689cb05$var$rh(b, d, a, c), b = $c79bde28d689cb05$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $c79bde28d689cb05$var$I && f && $c79bde28d689cb05$var$vg(b), $c79bde28d689cb05$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $c79bde28d689cb05$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $c79bde28d689cb05$var$$k(d);
                a = $c79bde28d689cb05$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $c79bde28d689cb05$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $c79bde28d689cb05$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $c79bde28d689cb05$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $c79bde28d689cb05$var$aj(null, b, d, $c79bde28d689cb05$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($c79bde28d689cb05$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $c79bde28d689cb05$var$lj(b);
                if (null === a) throw Error($c79bde28d689cb05$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $c79bde28d689cb05$var$bh(a, b);
                $c79bde28d689cb05$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(423)), b);
                        b = $c79bde28d689cb05$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(424)), b);
                        b = $c79bde28d689cb05$var$mj(a, b, d, c, e);
                        break a;
                    } else for($c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.stateNode.containerInfo.firstChild), $c79bde28d689cb05$var$xg = b, $c79bde28d689cb05$var$I = !0, $c79bde28d689cb05$var$zg = null, c = $c79bde28d689cb05$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $c79bde28d689cb05$var$Ig();
                    if (d === e) {
                        b = $c79bde28d689cb05$var$$i(a, b, c);
                        break a;
                    }
                    $c79bde28d689cb05$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $c79bde28d689cb05$var$Kh(b), null === a && $c79bde28d689cb05$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $c79bde28d689cb05$var$Ef(d, e) ? g = null : null !== f && $c79bde28d689cb05$var$Ef(d, f) && (b.flags |= 32), $c79bde28d689cb05$var$hj(a, b), $c79bde28d689cb05$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $c79bde28d689cb05$var$Eg(b), null;
        case 13:
            return $c79bde28d689cb05$var$pj(a, b, c);
        case 4:
            return $c79bde28d689cb05$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $c79bde28d689cb05$var$Bh(b, null, d, c) : $c79bde28d689cb05$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$Zi(a, b, d, e, c);
        case 7:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($c79bde28d689cb05$var$He(f.value, g)) {
                        if (f.children === e.children && !$c79bde28d689cb05$var$Wf.current) {
                            b = $c79bde28d689cb05$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $c79bde28d689cb05$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $c79bde28d689cb05$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($c79bde28d689cb05$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $c79bde28d689cb05$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $c79bde28d689cb05$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $c79bde28d689cb05$var$Tg(b, c), e = $c79bde28d689cb05$var$Vg(e), d = d(e), b.flags |= 1, $c79bde28d689cb05$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $c79bde28d689cb05$var$Lg(d, b.pendingProps), e = $c79bde28d689cb05$var$Lg(d.type, e), $c79bde28d689cb05$var$aj(a, b, d, e, c);
        case 15:
            return $c79bde28d689cb05$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$jj(a, b), b.tag = 1, $c79bde28d689cb05$var$Zf(d) ? (a = !0, $c79bde28d689cb05$var$cg(b)) : a = !1, $c79bde28d689cb05$var$Tg(b, c), $c79bde28d689cb05$var$ph(b, d, e), $c79bde28d689cb05$var$rh(b, d, e, c), $c79bde28d689cb05$var$kj(null, b, d, !0, a, c);
        case 19:
            return $c79bde28d689cb05$var$yj(a, b, c);
        case 22:
            return $c79bde28d689cb05$var$ej(a, b, c);
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
};
function $c79bde28d689cb05$var$Gk(a, b) {
    return $c79bde28d689cb05$var$ac(a, b);
}
function $c79bde28d689cb05$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c79bde28d689cb05$var$Bg(a, b, c, d) {
    return new $c79bde28d689cb05$var$al(a, b, c, d);
}
function $c79bde28d689cb05$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $c79bde28d689cb05$var$$k(a) {
    if ("function" === typeof a) return $c79bde28d689cb05$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $c79bde28d689cb05$var$Da) return 11;
        if (a === $c79bde28d689cb05$var$Ga) return 14;
    }
    return 2;
}
function $c79bde28d689cb05$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $c79bde28d689cb05$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $c79bde28d689cb05$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $c79bde28d689cb05$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $c79bde28d689cb05$var$ya:
            return $c79bde28d689cb05$var$Ah(c.children, e, f, b);
        case $c79bde28d689cb05$var$za:
            g = 8;
            e |= 8;
            break;
        case $c79bde28d689cb05$var$Aa:
            return a = $c79bde28d689cb05$var$Bg(12, c, b, e | 2), a.elementType = $c79bde28d689cb05$var$Aa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ea:
            return a = $c79bde28d689cb05$var$Bg(13, c, b, e), a.elementType = $c79bde28d689cb05$var$Ea, a.lanes = f, a;
        case $c79bde28d689cb05$var$Fa:
            return a = $c79bde28d689cb05$var$Bg(19, c, b, e), a.elementType = $c79bde28d689cb05$var$Fa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ia:
            return $c79bde28d689cb05$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $c79bde28d689cb05$var$Ba:
                    g = 10;
                    break a;
                case $c79bde28d689cb05$var$Ca:
                    g = 9;
                    break a;
                case $c79bde28d689cb05$var$Da:
                    g = 11;
                    break a;
                case $c79bde28d689cb05$var$Ga:
                    g = 14;
                    break a;
                case $c79bde28d689cb05$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($c79bde28d689cb05$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $c79bde28d689cb05$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $c79bde28d689cb05$var$Ah(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$qj(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(22, a, d, b);
    a.elementType = $c79bde28d689cb05$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $c79bde28d689cb05$var$xh(a, b, c) {
    a = $c79bde28d689cb05$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$zh(a, b, c) {
    b = $c79bde28d689cb05$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $c79bde28d689cb05$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $c79bde28d689cb05$var$zc(0);
    this.expirationTimes = $c79bde28d689cb05$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c79bde28d689cb05$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $c79bde28d689cb05$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $c79bde28d689cb05$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $c79bde28d689cb05$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $c79bde28d689cb05$var$ah(f);
    return a;
}
function $c79bde28d689cb05$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c79bde28d689cb05$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $c79bde28d689cb05$var$el(a) {
    if (!a) return $c79bde28d689cb05$var$Vf;
    a = a._reactInternals;
    a: {
        if ($c79bde28d689cb05$var$Vb(a) !== a || 1 !== a.tag) throw Error($c79bde28d689cb05$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($c79bde28d689cb05$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($c79bde28d689cb05$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($c79bde28d689cb05$var$Zf(c)) return $c79bde28d689cb05$var$bg(a, c, b);
    }
    return b;
}
function $c79bde28d689cb05$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $c79bde28d689cb05$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $c79bde28d689cb05$var$el(null);
    c = a.current;
    d = $c79bde28d689cb05$var$L();
    e = $c79bde28d689cb05$var$lh(c);
    f = $c79bde28d689cb05$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $c79bde28d689cb05$var$dh(c, f, e);
    a.current.lanes = e;
    $c79bde28d689cb05$var$Ac(a, e, d);
    $c79bde28d689cb05$var$Ek(a, d);
    return a;
}
function $c79bde28d689cb05$var$gl(a, b, c, d) {
    var e = b.current, f = $c79bde28d689cb05$var$L(), g = $c79bde28d689cb05$var$lh(e);
    c = $c79bde28d689cb05$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $c79bde28d689cb05$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $c79bde28d689cb05$var$dh(e, b, g);
    null !== a && ($c79bde28d689cb05$var$mh(a, e, g, f), $c79bde28d689cb05$var$eh(a, e, g));
    return g;
}
function $c79bde28d689cb05$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $c79bde28d689cb05$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $c79bde28d689cb05$var$jl(a, b) {
    $c79bde28d689cb05$var$il(a, b);
    (a = a.alternate) && $c79bde28d689cb05$var$il(a, b);
}
function $c79bde28d689cb05$var$kl() {
    return null;
}
var $c79bde28d689cb05$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $c79bde28d689cb05$var$ml(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$nl.prototype.render = $c79bde28d689cb05$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($c79bde28d689cb05$var$p(409));
    $c79bde28d689cb05$var$gl(a, b, null, null);
};
$c79bde28d689cb05$var$nl.prototype.unmount = $c79bde28d689cb05$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $c79bde28d689cb05$var$Sk(function() {
            $c79bde28d689cb05$var$gl(null, a, null, null);
        });
        b[$c79bde28d689cb05$var$uf] = null;
    }
};
function $c79bde28d689cb05$var$nl(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $c79bde28d689cb05$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $c79bde28d689cb05$var$Qc.length && 0 !== b && b < $c79bde28d689cb05$var$Qc[c].priority; c++);
        $c79bde28d689cb05$var$Qc.splice(c, 0, a);
        0 === c && $c79bde28d689cb05$var$Vc(a);
    }
};
function $c79bde28d689cb05$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $c79bde28d689cb05$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $c79bde28d689cb05$var$ql() {}
function $c79bde28d689cb05$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $c79bde28d689cb05$var$hl(g);
                f.call(a);
            };
        }
        var g = $c79bde28d689cb05$var$fl(b, d, a, 0, null, !1, !1, "", $c79bde28d689cb05$var$ql);
        a._reactRootContainer = g;
        a[$c79bde28d689cb05$var$uf] = g.current;
        $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
        $c79bde28d689cb05$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $c79bde28d689cb05$var$hl(k);
            h.call(a);
        };
    }
    var k = $c79bde28d689cb05$var$cl(a, 0, !1, null, null, !1, !1, "", $c79bde28d689cb05$var$ql);
    a._reactRootContainer = k;
    a[$c79bde28d689cb05$var$uf] = k.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    $c79bde28d689cb05$var$Sk(function() {
        $c79bde28d689cb05$var$gl(b, k, c, d);
    });
    return k;
}
function $c79bde28d689cb05$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $c79bde28d689cb05$var$hl(g);
                h.call(a);
            };
        }
        $c79bde28d689cb05$var$gl(b, g, a, e);
    } else g = $c79bde28d689cb05$var$rl(c, b, a, e, d);
    return $c79bde28d689cb05$var$hl(g);
}
$c79bde28d689cb05$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $c79bde28d689cb05$var$tc(b.pendingLanes);
                0 !== c && ($c79bde28d689cb05$var$Cc(b, c | 1), $c79bde28d689cb05$var$Ek(b, $c79bde28d689cb05$var$B()), 0 === ($c79bde28d689cb05$var$K & 6) && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$jg()));
            }
            break;
        case 13:
            $c79bde28d689cb05$var$Sk(function() {
                var b = $c79bde28d689cb05$var$Zg(a, 1);
                if (null !== b) {
                    var c = $c79bde28d689cb05$var$L();
                    $c79bde28d689cb05$var$mh(b, a, 1, c);
                }
            }), $c79bde28d689cb05$var$jl(a, 1);
    }
};
$c79bde28d689cb05$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $c79bde28d689cb05$var$L();
            $c79bde28d689cb05$var$mh(b, a, 134217728, c);
        }
        $c79bde28d689cb05$var$jl(a, 134217728);
    }
};
$c79bde28d689cb05$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$lh(a), c = $c79bde28d689cb05$var$Zg(a, b);
        if (null !== c) {
            var d = $c79bde28d689cb05$var$L();
            $c79bde28d689cb05$var$mh(c, a, b, d);
        }
        $c79bde28d689cb05$var$jl(a, b);
    }
};
$c79bde28d689cb05$var$Hc = function() {
    return $c79bde28d689cb05$var$C;
};
$c79bde28d689cb05$var$Ic = function(a, b) {
    var c = $c79bde28d689cb05$var$C;
    try {
        return $c79bde28d689cb05$var$C = a, b();
    } finally{
        $c79bde28d689cb05$var$C = c;
    }
};
$c79bde28d689cb05$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $c79bde28d689cb05$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $c79bde28d689cb05$var$Db(d);
                        if (!e) throw Error($c79bde28d689cb05$var$p(90));
                        $c79bde28d689cb05$var$Wa(d);
                        $c79bde28d689cb05$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $c79bde28d689cb05$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $c79bde28d689cb05$var$fb(a, !!c.multiple, b, !1);
    }
};
$c79bde28d689cb05$var$Gb = $c79bde28d689cb05$var$Rk;
$c79bde28d689cb05$var$Hb = $c79bde28d689cb05$var$Sk;
var $c79bde28d689cb05$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $c79bde28d689cb05$var$Cb,
        $c79bde28d689cb05$var$ue,
        $c79bde28d689cb05$var$Db,
        $c79bde28d689cb05$var$Eb,
        $c79bde28d689cb05$var$Fb,
        $c79bde28d689cb05$var$Rk
    ]
}, $c79bde28d689cb05$var$ul = {
    findFiberByHostInstance: $c79bde28d689cb05$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $c79bde28d689cb05$var$vl = {
    bundleType: $c79bde28d689cb05$var$ul.bundleType,
    version: $c79bde28d689cb05$var$ul.version,
    rendererPackageName: $c79bde28d689cb05$var$ul.rendererPackageName,
    rendererConfig: $c79bde28d689cb05$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $c79bde28d689cb05$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $c79bde28d689cb05$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $c79bde28d689cb05$var$ul.findFiberByHostInstance || $c79bde28d689cb05$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c79bde28d689cb05$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c79bde28d689cb05$var$wl.isDisabled && $c79bde28d689cb05$var$wl.supportsFiber) try {
        $c79bde28d689cb05$var$kc = $c79bde28d689cb05$var$wl.inject($c79bde28d689cb05$var$vl), $c79bde28d689cb05$var$lc = $c79bde28d689cb05$var$wl;
    } catch (a) {}
}
$c79bde28d689cb05$export$ae55be85d98224ed = $c79bde28d689cb05$var$tl;
$c79bde28d689cb05$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$c79bde28d689cb05$var$ol(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$dl(a, b, null, c);
};
$c79bde28d689cb05$export$882461b6382ed46c = function(a, b) {
    if (!$c79bde28d689cb05$var$ol(a)) throw Error($c79bde28d689cb05$var$p(299));
    var c = !1, d = "", e = $c79bde28d689cb05$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $c79bde28d689cb05$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $c79bde28d689cb05$var$ml(b);
};
$c79bde28d689cb05$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($c79bde28d689cb05$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($c79bde28d689cb05$var$p(268, a));
    }
    a = $c79bde28d689cb05$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$c79bde28d689cb05$export$cd75ccfd720a3cd4 = function(a) {
    return $c79bde28d689cb05$var$Sk(a);
};
$c79bde28d689cb05$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$c79bde28d689cb05$var$pl(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$sl(null, a, b, !0, c);
};
$c79bde28d689cb05$export$757ceba2d55c277e = function(a, b, c) {
    if (!$c79bde28d689cb05$var$ol(a)) throw Error($c79bde28d689cb05$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $c79bde28d689cb05$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $c79bde28d689cb05$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $c79bde28d689cb05$var$nl(b);
};
$c79bde28d689cb05$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$c79bde28d689cb05$var$pl(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$sl(null, a, b, !1, c);
};
$c79bde28d689cb05$export$502457920280e6be = function(a) {
    if (!$c79bde28d689cb05$var$pl(a)) throw Error($c79bde28d689cb05$var$p(40));
    return a._reactRootContainer ? ($c79bde28d689cb05$var$Sk(function() {
        $c79bde28d689cb05$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$c79bde28d689cb05$var$uf] = null;
        });
    }), !0) : !1;
};
$c79bde28d689cb05$export$c78a37762a8d58e1 = $c79bde28d689cb05$var$Rk;
$c79bde28d689cb05$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$c79bde28d689cb05$var$pl(c)) throw Error($c79bde28d689cb05$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($c79bde28d689cb05$var$p(38));
    return $c79bde28d689cb05$var$sl(a, b, c, !1, d);
};
$c79bde28d689cb05$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("ibqfJ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dnqd8"));

});
parcelRegister("dnqd8", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $9bd1c1496009b220$export$c4744153514ff05d; }, function (v) { return $9bd1c1496009b220$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7; }, function (v) { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $9bd1c1496009b220$export$e26fe2ed2fa76875; }, function (v) { return $9bd1c1496009b220$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $9bd1c1496009b220$export$502329bbf4b505b1; }, function (v) { return $9bd1c1496009b220$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $9bd1c1496009b220$export$6e3807111c4874c4; }, function (v) { return $9bd1c1496009b220$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $9bd1c1496009b220$export$c27134553091fb3a; }, function (v) { return $9bd1c1496009b220$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $9bd1c1496009b220$export$33ee1acdc04fd2a2; }, function (v) { return $9bd1c1496009b220$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $9bd1c1496009b220$export$b00a404bbd5edef2; }, function (v) { return $9bd1c1496009b220$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $9bd1c1496009b220$export$8352ce38b91d0c62; }, function (v) { return $9bd1c1496009b220$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $9bd1c1496009b220$export$d66a1c1c77bd778b; }, function (v) { return $9bd1c1496009b220$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $9bd1c1496009b220$export$d3dfb8e4810cb555; }, function (v) { return $9bd1c1496009b220$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $9bd1c1496009b220$export$839f9183b0465a69; }, function (v) { return $9bd1c1496009b220$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $9bd1c1496009b220$export$72fdf0e06517287b; }, function (v) { return $9bd1c1496009b220$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $9bd1c1496009b220$export$4b844e58a3e414b4; }, function (v) { return $9bd1c1496009b220$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $9bd1c1496009b220$export$816d2913ae6b83b1; }, function (v) { return $9bd1c1496009b220$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $9bd1c1496009b220$export$61bcfe829111a1d0; }, function (v) { return $9bd1c1496009b220$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $9bd1c1496009b220$export$7ee8c9beb337bc3f; }, function (v) { return $9bd1c1496009b220$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $9bd1c1496009b220$export$b5836b71941fa3ed; }, function (v) { return $9bd1c1496009b220$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $9bd1c1496009b220$export$cf845f2c119da08a; }, function (v) { return $9bd1c1496009b220$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9bd1c1496009b220$export$c4744153514ff05d;
var $9bd1c1496009b220$export$3e506c1ccc9cc1a7;
var $9bd1c1496009b220$export$e26fe2ed2fa76875;
var $9bd1c1496009b220$export$502329bbf4b505b1;
var $9bd1c1496009b220$export$6e3807111c4874c4;
var $9bd1c1496009b220$export$c27134553091fb3a;
var $9bd1c1496009b220$export$33ee1acdc04fd2a2;
var $9bd1c1496009b220$export$b00a404bbd5edef2;
var $9bd1c1496009b220$export$8352ce38b91d0c62;
var $9bd1c1496009b220$export$d66a1c1c77bd778b;
var $9bd1c1496009b220$export$d3dfb8e4810cb555;
var $9bd1c1496009b220$export$839f9183b0465a69;
var $9bd1c1496009b220$export$72fdf0e06517287b;
var $9bd1c1496009b220$export$4b844e58a3e414b4;
var $9bd1c1496009b220$export$816d2913ae6b83b1;
var $9bd1c1496009b220$export$61bcfe829111a1d0;
var $9bd1c1496009b220$export$7ee8c9beb337bc3f;
var $9bd1c1496009b220$export$b5836b71941fa3ed;
var $9bd1c1496009b220$export$cf845f2c119da08a;
"use strict";
function $9bd1c1496009b220$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $9bd1c1496009b220$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $9bd1c1496009b220$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $9bd1c1496009b220$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $9bd1c1496009b220$var$g(C, c)) n < e && 0 > $9bd1c1496009b220$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $9bd1c1496009b220$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $9bd1c1496009b220$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $9bd1c1496009b220$var$l = performance;
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$l.now();
    };
} else {
    var $9bd1c1496009b220$var$p = Date, $9bd1c1496009b220$var$q = $9bd1c1496009b220$var$p.now();
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$p.now() - $9bd1c1496009b220$var$q;
    };
}
var $9bd1c1496009b220$var$r = [], $9bd1c1496009b220$var$t = [], $9bd1c1496009b220$var$u = 1, $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = 3, $9bd1c1496009b220$var$z = !1, $9bd1c1496009b220$var$A = !1, $9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$D = "function" === typeof setTimeout ? setTimeout : null, $9bd1c1496009b220$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $9bd1c1496009b220$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $9bd1c1496009b220$var$G(a) {
    for(var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t); null !== b;){
        if (null === b.callback) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t);
        else if (b.startTime <= a) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t), b.sortIndex = b.expirationTime, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, b);
        else break;
        b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
    }
}
function $9bd1c1496009b220$var$H(a) {
    $9bd1c1496009b220$var$B = !1;
    $9bd1c1496009b220$var$G(a);
    if (!$9bd1c1496009b220$var$A) {
        if (null !== $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r)) $9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J);
        else {
            var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== b && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, b.startTime - a);
        }
    }
}
function $9bd1c1496009b220$var$J(a, b) {
    $9bd1c1496009b220$var$A = !1;
    $9bd1c1496009b220$var$B && ($9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1);
    $9bd1c1496009b220$var$z = !0;
    var c = $9bd1c1496009b220$var$y;
    try {
        $9bd1c1496009b220$var$G(b);
        for($9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r); null !== $9bd1c1496009b220$var$v && (!($9bd1c1496009b220$var$v.expirationTime > b) || a && !$9bd1c1496009b220$var$M());){
            var d = $9bd1c1496009b220$var$v.callback;
            if ("function" === typeof d) {
                $9bd1c1496009b220$var$v.callback = null;
                $9bd1c1496009b220$var$y = $9bd1c1496009b220$var$v.priorityLevel;
                var e = d($9bd1c1496009b220$var$v.expirationTime <= b);
                b = $9bd1c1496009b220$export$c4744153514ff05d();
                "function" === typeof e ? $9bd1c1496009b220$var$v.callback = e : $9bd1c1496009b220$var$v === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
                $9bd1c1496009b220$var$G(b);
            } else $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
            $9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
        }
        if (null !== $9bd1c1496009b220$var$v) var w = !0;
        else {
            var m = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== m && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = c, $9bd1c1496009b220$var$z = !1;
    }
}
var $9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null, $9bd1c1496009b220$var$L = -1, $9bd1c1496009b220$var$P = 5, $9bd1c1496009b220$var$Q = -1;
function $9bd1c1496009b220$var$M() {
    return $9bd1c1496009b220$export$c4744153514ff05d() - $9bd1c1496009b220$var$Q < $9bd1c1496009b220$var$P ? !1 : !0;
}
function $9bd1c1496009b220$var$R() {
    if (null !== $9bd1c1496009b220$var$O) {
        var a = $9bd1c1496009b220$export$c4744153514ff05d();
        $9bd1c1496009b220$var$Q = a;
        var b = !0;
        try {
            b = $9bd1c1496009b220$var$O(!0, a);
        } finally{
            b ? $9bd1c1496009b220$var$S() : ($9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null);
        }
    } else $9bd1c1496009b220$var$N = !1;
}
var $9bd1c1496009b220$var$S;
if ("function" === typeof $9bd1c1496009b220$var$F) $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$F($9bd1c1496009b220$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $9bd1c1496009b220$var$T = new MessageChannel, $9bd1c1496009b220$var$U = $9bd1c1496009b220$var$T.port2;
    $9bd1c1496009b220$var$T.port1.onmessage = $9bd1c1496009b220$var$R;
    $9bd1c1496009b220$var$S = function() {
        $9bd1c1496009b220$var$U.postMessage(null);
    };
} else $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$D($9bd1c1496009b220$var$R, 0);
};
function $9bd1c1496009b220$var$I(a) {
    $9bd1c1496009b220$var$O = a;
    $9bd1c1496009b220$var$N || ($9bd1c1496009b220$var$N = !0, $9bd1c1496009b220$var$S());
}
function $9bd1c1496009b220$var$K(a, b) {
    $9bd1c1496009b220$var$L = $9bd1c1496009b220$var$D(function() {
        a($9bd1c1496009b220$export$c4744153514ff05d());
    }, b);
}
$9bd1c1496009b220$export$3e506c1ccc9cc1a7 = 5;
$9bd1c1496009b220$export$e26fe2ed2fa76875 = 1;
$9bd1c1496009b220$export$502329bbf4b505b1 = 4;
$9bd1c1496009b220$export$6e3807111c4874c4 = 3;
$9bd1c1496009b220$export$c27134553091fb3a = null;
$9bd1c1496009b220$export$33ee1acdc04fd2a2 = 2;
$9bd1c1496009b220$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$9bd1c1496009b220$export$8352ce38b91d0c62 = function() {
    $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J));
};
$9bd1c1496009b220$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $9bd1c1496009b220$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$9bd1c1496009b220$export$d3dfb8e4810cb555 = function() {
    return $9bd1c1496009b220$var$y;
};
$9bd1c1496009b220$export$839f9183b0465a69 = function() {
    return $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
};
$9bd1c1496009b220$export$72fdf0e06517287b = function(a) {
    switch($9bd1c1496009b220$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $9bd1c1496009b220$var$y;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = b;
    try {
        return a();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$4b844e58a3e414b4 = function() {};
$9bd1c1496009b220$export$816d2913ae6b83b1 = function() {};
$9bd1c1496009b220$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = a;
    try {
        return b();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $9bd1c1496009b220$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $9bd1c1496009b220$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$t, a), null === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && a === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t) && ($9bd1c1496009b220$var$B ? ($9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1) : $9bd1c1496009b220$var$B = !0, $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, c - d))) : (a.sortIndex = e, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, a), $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J)));
    return a;
};
$9bd1c1496009b220$export$b5836b71941fa3ed = $9bd1c1496009b220$var$M;
$9bd1c1496009b220$export$cf845f2c119da08a = function(a) {
    var b = $9bd1c1496009b220$var$y;
    return function() {
        var c = $9bd1c1496009b220$var$y;
        $9bd1c1496009b220$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $9bd1c1496009b220$var$y = c;
        }
    };
};

});



parcelRegister("jpdgm", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $L7tyD = parcelRequire("L7tyD");
function $e20aa3d84dea372f$var$emptyFunction() {}
function $e20aa3d84dea372f$var$emptyFunctionWithReset() {}
$e20aa3d84dea372f$var$emptyFunctionWithReset.resetWarningCache = $e20aa3d84dea372f$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $L7tyD) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $e20aa3d84dea372f$var$emptyFunctionWithReset,
        resetWarningCache: $e20aa3d84dea372f$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("L7tyD", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $08da306d15728f79$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $08da306d15728f79$var$ReactPropTypesSecret;

});


parcelRegister("gO0OJ", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $c3c1f324fb391005$export$2b8d127b894957b9; }, function (v) { return $c3c1f324fb391005$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $c3c1f324fb391005$export$cea3a54a6425200c; }, function (v) { return $c3c1f324fb391005$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $c3c1f324fb391005$export$a7c73072b1a182ae; }, function (v) { return $c3c1f324fb391005$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $c3c1f324fb391005$export$9f27bc3417b4524d; }, function (v) { return $c3c1f324fb391005$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $c3c1f324fb391005$export$db77ccec0bb4ccac; }, function (v) { return $c3c1f324fb391005$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $c3c1f324fb391005$export$8392c0c9d3dcbd35; }, function (v) { return $c3c1f324fb391005$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c3c1f324fb391005$export$ffb0004e005737fa; }, function (v) { return $c3c1f324fb391005$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $c3c1f324fb391005$export$b624eff549462981; }, function (v) { return $c3c1f324fb391005$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $c3c1f324fb391005$export$7897aa7841a5380c; }, function (v) { return $c3c1f324fb391005$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $c3c1f324fb391005$export$602eac185826482c; }, function (v) { return $c3c1f324fb391005$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $c3c1f324fb391005$export$e2c29f18771995cb; }, function (v) { return $c3c1f324fb391005$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c3c1f324fb391005$export$5f8d39834fd61797; }, function (v) { return $c3c1f324fb391005$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c3c1f324fb391005$export$74bf444e3cd11ea5; }, function (v) { return $c3c1f324fb391005$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $c3c1f324fb391005$export$92387174baf9b227; }, function (v) { return $c3c1f324fb391005$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $c3c1f324fb391005$export$ec112efeb987d9c6; }, function (v) { return $c3c1f324fb391005$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $c3c1f324fb391005$export$b706b080d889d2c9; }, function (v) { return $c3c1f324fb391005$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $c3c1f324fb391005$export$5be5a87408f70ddc; }, function (v) { return $c3c1f324fb391005$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $c3c1f324fb391005$export$45a5e7f76e0caa8d; }, function (v) { return $c3c1f324fb391005$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $c3c1f324fb391005$export$455c2e768291efa6; }, function (v) { return $c3c1f324fb391005$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $c3c1f324fb391005$export$9522e17588c12572; }, function (v) { return $c3c1f324fb391005$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $c3c1f324fb391005$export$2110ac352bb060b9; }, function (v) { return $c3c1f324fb391005$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $c3c1f324fb391005$export$56885ab8b9c456ab; }, function (v) { return $c3c1f324fb391005$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $c3c1f324fb391005$export$d927fcb6adf8f9de; }, function (v) { return $c3c1f324fb391005$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $c3c1f324fb391005$export$b82d16f27459e05a; }, function (v) { return $c3c1f324fb391005$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $c3c1f324fb391005$export$522c17b4f5e123e8; }, function (v) { return $c3c1f324fb391005$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $c3c1f324fb391005$export$1aabd8a0274ecfd6; }, function (v) { return $c3c1f324fb391005$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $c3c1f324fb391005$export$9b621391a187a31a; }, function (v) { return $c3c1f324fb391005$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $c3c1f324fb391005$export$f5bbd400c2f4426f; }, function (v) { return $c3c1f324fb391005$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c3c1f324fb391005$export$2b8d127b894957b9;
var $c3c1f324fb391005$export$cea3a54a6425200c;
var $c3c1f324fb391005$export$a7c73072b1a182ae;
var $c3c1f324fb391005$export$9f27bc3417b4524d;
var $c3c1f324fb391005$export$db77ccec0bb4ccac;
var $c3c1f324fb391005$export$8392c0c9d3dcbd35;
var $c3c1f324fb391005$export$ffb0004e005737fa;
var $c3c1f324fb391005$export$b624eff549462981;
var $c3c1f324fb391005$export$7897aa7841a5380c;
var $c3c1f324fb391005$export$602eac185826482c;
var $c3c1f324fb391005$export$e2c29f18771995cb;
var $c3c1f324fb391005$export$5f8d39834fd61797;
var $c3c1f324fb391005$export$74bf444e3cd11ea5;
var $c3c1f324fb391005$export$92387174baf9b227;
var $c3c1f324fb391005$export$ec112efeb987d9c6;
var $c3c1f324fb391005$export$b706b080d889d2c9;
var $c3c1f324fb391005$export$5be5a87408f70ddc;
var $c3c1f324fb391005$export$45a5e7f76e0caa8d;
var $c3c1f324fb391005$export$455c2e768291efa6;
var $c3c1f324fb391005$export$9522e17588c12572;
var $c3c1f324fb391005$export$2110ac352bb060b9;
var $c3c1f324fb391005$export$56885ab8b9c456ab;
var $c3c1f324fb391005$export$d927fcb6adf8f9de;
var $c3c1f324fb391005$export$b82d16f27459e05a;
var $c3c1f324fb391005$export$522c17b4f5e123e8;
var $c3c1f324fb391005$export$1aabd8a0274ecfd6;
var $c3c1f324fb391005$export$9b621391a187a31a;
var $c3c1f324fb391005$export$f5bbd400c2f4426f;
"use strict";
var $c3c1f324fb391005$var$b = "function" === typeof Symbol && Symbol.for, $c3c1f324fb391005$var$c = $c3c1f324fb391005$var$b ? Symbol.for("react.element") : 60103, $c3c1f324fb391005$var$d = $c3c1f324fb391005$var$b ? Symbol.for("react.portal") : 60106, $c3c1f324fb391005$var$e = $c3c1f324fb391005$var$b ? Symbol.for("react.fragment") : 60107, $c3c1f324fb391005$var$f = $c3c1f324fb391005$var$b ? Symbol.for("react.strict_mode") : 60108, $c3c1f324fb391005$var$g = $c3c1f324fb391005$var$b ? Symbol.for("react.profiler") : 60114, $c3c1f324fb391005$var$h = $c3c1f324fb391005$var$b ? Symbol.for("react.provider") : 60109, $c3c1f324fb391005$var$k = $c3c1f324fb391005$var$b ? Symbol.for("react.context") : 60110, $c3c1f324fb391005$var$l = $c3c1f324fb391005$var$b ? Symbol.for("react.async_mode") : 60111, $c3c1f324fb391005$var$m = $c3c1f324fb391005$var$b ? Symbol.for("react.concurrent_mode") : 60111, $c3c1f324fb391005$var$n = $c3c1f324fb391005$var$b ? Symbol.for("react.forward_ref") : 60112, $c3c1f324fb391005$var$p = $c3c1f324fb391005$var$b ? Symbol.for("react.suspense") : 60113, $c3c1f324fb391005$var$q = $c3c1f324fb391005$var$b ? Symbol.for("react.suspense_list") : 60120, $c3c1f324fb391005$var$r = $c3c1f324fb391005$var$b ? Symbol.for("react.memo") : 60115, $c3c1f324fb391005$var$t = $c3c1f324fb391005$var$b ? Symbol.for("react.lazy") : 60116, $c3c1f324fb391005$var$v = $c3c1f324fb391005$var$b ? Symbol.for("react.block") : 60121, $c3c1f324fb391005$var$w = $c3c1f324fb391005$var$b ? Symbol.for("react.fundamental") : 60117, $c3c1f324fb391005$var$x = $c3c1f324fb391005$var$b ? Symbol.for("react.responder") : 60118, $c3c1f324fb391005$var$y = $c3c1f324fb391005$var$b ? Symbol.for("react.scope") : 60119;
function $c3c1f324fb391005$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $c3c1f324fb391005$var$c:
                switch(a = a.type, a){
                    case $c3c1f324fb391005$var$l:
                    case $c3c1f324fb391005$var$m:
                    case $c3c1f324fb391005$var$e:
                    case $c3c1f324fb391005$var$g:
                    case $c3c1f324fb391005$var$f:
                    case $c3c1f324fb391005$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $c3c1f324fb391005$var$k:
                            case $c3c1f324fb391005$var$n:
                            case $c3c1f324fb391005$var$t:
                            case $c3c1f324fb391005$var$r:
                            case $c3c1f324fb391005$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $c3c1f324fb391005$var$d:
                return u;
        }
    }
}
function $c3c1f324fb391005$var$A(a) {
    return $c3c1f324fb391005$var$z(a) === $c3c1f324fb391005$var$m;
}
$c3c1f324fb391005$export$2b8d127b894957b9 = $c3c1f324fb391005$var$l;
$c3c1f324fb391005$export$cea3a54a6425200c = $c3c1f324fb391005$var$m;
$c3c1f324fb391005$export$a7c73072b1a182ae = $c3c1f324fb391005$var$k;
$c3c1f324fb391005$export$9f27bc3417b4524d = $c3c1f324fb391005$var$h;
$c3c1f324fb391005$export$db77ccec0bb4ccac = $c3c1f324fb391005$var$c;
$c3c1f324fb391005$export$8392c0c9d3dcbd35 = $c3c1f324fb391005$var$n;
$c3c1f324fb391005$export$ffb0004e005737fa = $c3c1f324fb391005$var$e;
$c3c1f324fb391005$export$b624eff549462981 = $c3c1f324fb391005$var$t;
$c3c1f324fb391005$export$7897aa7841a5380c = $c3c1f324fb391005$var$r;
$c3c1f324fb391005$export$602eac185826482c = $c3c1f324fb391005$var$d;
$c3c1f324fb391005$export$e2c29f18771995cb = $c3c1f324fb391005$var$g;
$c3c1f324fb391005$export$5f8d39834fd61797 = $c3c1f324fb391005$var$f;
$c3c1f324fb391005$export$74bf444e3cd11ea5 = $c3c1f324fb391005$var$p;
$c3c1f324fb391005$export$92387174baf9b227 = function(a) {
    return $c3c1f324fb391005$var$A(a) || $c3c1f324fb391005$var$z(a) === $c3c1f324fb391005$var$l;
};
$c3c1f324fb391005$export$ec112efeb987d9c6 = $c3c1f324fb391005$var$A;
$c3c1f324fb391005$export$b706b080d889d2c9 = function(a) {
    return $c3c1f324fb391005$var$z(a) === $c3c1f324fb391005$var$k;
};
$c3c1f324fb391005$export$5be5a87408f70ddc = function(a) {
    return $c3c1f324fb391005$var$z(a) === $c3c1f324fb391005$var$h;
};
$c3c1f324fb391005$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c3c1f324fb391005$var$c;
};
$c3c1f324fb391005$export$455c2e768291efa6 = function(a) {
    return $c3c1f324fb391005$var$z(a) === $c3c1f324fb391005$var$n;
};
$c3c1f324fb391005$export$9522e17588c12572 = function(a) {
    return $c3c1f324fb391005$var$z(a) === $c3c1f324fb391005$var$e;
};
$c3c1f324fb391005$export$2110ac352bb060b9 = function(a) {
    return $c3c1f324fb391005$var$z(a) === $c3c1f324fb391005$var$t;
};
$c3c1f324fb391005$export$56885ab8b9c456ab = function(a) {
    return $c3c1f324fb391005$var$z(a) === $c3c1f324fb391005$var$r;
};
$c3c1f324fb391005$export$d927fcb6adf8f9de = function(a) {
    return $c3c1f324fb391005$var$z(a) === $c3c1f324fb391005$var$d;
};
$c3c1f324fb391005$export$b82d16f27459e05a = function(a) {
    return $c3c1f324fb391005$var$z(a) === $c3c1f324fb391005$var$g;
};
$c3c1f324fb391005$export$522c17b4f5e123e8 = function(a) {
    return $c3c1f324fb391005$var$z(a) === $c3c1f324fb391005$var$f;
};
$c3c1f324fb391005$export$1aabd8a0274ecfd6 = function(a) {
    return $c3c1f324fb391005$var$z(a) === $c3c1f324fb391005$var$p;
};
$c3c1f324fb391005$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $c3c1f324fb391005$var$e || a === $c3c1f324fb391005$var$m || a === $c3c1f324fb391005$var$g || a === $c3c1f324fb391005$var$f || a === $c3c1f324fb391005$var$p || a === $c3c1f324fb391005$var$q || "object" === typeof a && null !== a && (a.$$typeof === $c3c1f324fb391005$var$t || a.$$typeof === $c3c1f324fb391005$var$r || a.$$typeof === $c3c1f324fb391005$var$h || a.$$typeof === $c3c1f324fb391005$var$k || a.$$typeof === $c3c1f324fb391005$var$n || a.$$typeof === $c3c1f324fb391005$var$w || a.$$typeof === $c3c1f324fb391005$var$x || a.$$typeof === $c3c1f324fb391005$var$y || a.$$typeof === $c3c1f324fb391005$var$v);
};
$c3c1f324fb391005$export$f5bbd400c2f4426f = $c3c1f324fb391005$var$z;

});

parcelRegister("efvJ0", function(module, exports) {
function $a5fb134ebbf9434b$var$_extends() {
    return module.exports = $a5fb134ebbf9434b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $a5fb134ebbf9434b$var$_extends.apply(null, arguments);
}
module.exports = $a5fb134ebbf9434b$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8Y5iV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("2TX6h")).default; });

var $2TX6h = parcelRequire("2TX6h");

});
parcelRegister("2TX6h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21ce8feea67be993$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $21ce8feea67be993$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});


parcelRegister("bUa33", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("g5OQF")).default; });

var $g5OQF = parcelRequire("g5OQF");

});
parcelRegister("g5OQF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb748e6bbedbe10a$export$2e2bcd8739ae039; });
function $bb748e6bbedbe10a$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $bb748e6bbedbe10a$export$2e2bcd8739ae039 = $bb748e6bbedbe10a$var$clamp;

});


parcelRegister("7RpPE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $5b91855aa0f83d1d$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $5b91855aa0f83d1d$export$e00380445f2b9e0c; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("7szRs")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("geqbO")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("geqbO")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("5abSN")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("cXmXD")).default; });
/**
 * @mui/styled-engine v5.16.4
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $wAUet = parcelRequire("wAUet");

var $geqbO = parcelRequire("geqbO");
var $7szRs = parcelRequire("7szRs");

var $5abSN = parcelRequire("5abSN");

var $cXmXD = parcelRequire("cXmXD");
"use client";
function $5b91855aa0f83d1d$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $wAUet.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $5b91855aa0f83d1d$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("wAUet", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $061f9e0809401139$export$2e2bcd8739ae039; });

var $dUvWG = parcelRequire("dUvWG");
parcelRequire("efvJ0");
parcelRequire("exYeM");
parcelRequire("3U6by");

parcelRequire("l9TJr");
parcelRequire("fTtVz");
parcelRequire("8mmyy");
var $061f9e0809401139$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $061f9e0809401139$export$2e2bcd8739ae039 = (0, $dUvWG.default).bind();
$061f9e0809401139$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $061f9e0809401139$export$2e2bcd8739ae039[tagName] = $061f9e0809401139$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("dUvWG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a209490bd8a73d9e$export$2e2bcd8739ae039; });

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $3U6by = parcelRequire("3U6by");
parcelRequire("geqbO");
var $7szRs = parcelRequire("7szRs");

var $l9TJr = parcelRequire("l9TJr");

var $fTtVz = parcelRequire("fTtVz");

var $8mmyy = parcelRequire("8mmyy");
var $a209490bd8a73d9e$var$testOmitPropsOnStringTag = (0, $3U6by.default);
var $a209490bd8a73d9e$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $a209490bd8a73d9e$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $a209490bd8a73d9e$var$testOmitPropsOnStringTag : $a209490bd8a73d9e$var$testOmitPropsOnComponent;
};
var $a209490bd8a73d9e$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $a209490bd8a73d9e$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $a209490bd8a73d9e$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $l9TJr.registerStyles)(cache, serialized, isStringTag);
    (0, $8mmyy.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $l9TJr.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $a209490bd8a73d9e$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $a209490bd8a73d9e$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $a209490bd8a73d9e$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $7szRs.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $exYeM.useContext((0, $7szRs.T));
            }
            if (typeof props.className === "string") className = (0, $l9TJr.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $fTtVz.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $a209490bd8a73d9e$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, /*#__PURE__*/ $exYeM.createElement($a209490bd8a73d9e$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $exYeM.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $aJx1R.default)({}, options, nextOptions, {
                shouldForwardProp: $a209490bd8a73d9e$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("aJx1R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d07ba38ace95d14$export$2e2bcd8739ae039; });
function $7d07ba38ace95d14$export$2e2bcd8739ae039() {
    return $7d07ba38ace95d14$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7d07ba38ace95d14$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("3U6by", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d7b665dfc4c324e$export$2e2bcd8739ae039; });

var $3xeCd = parcelRequire("3xeCd");
var $2d7b665dfc4c324e$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $2d7b665dfc4c324e$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $3xeCd.default)(function(prop) {
    return $2d7b665dfc4c324e$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("3xeCd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $292fca7ef59d5404$export$2e2bcd8739ae039; });
function $292fca7ef59d5404$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("geqbO", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $bd1244d1d0386fba$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $bd1244d1d0386fba$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $bd1244d1d0386fba$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("7szRs")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("7szRs")).w; });

var $7szRs = parcelRequire("7szRs");

var $exYeM = parcelRequire("exYeM");

var $l9TJr = parcelRequire("l9TJr");

var $8mmyy = parcelRequire("8mmyy");

var $fTtVz = parcelRequire("fTtVz");
parcelRequire("8YN4E");
parcelRequire("efvJ0");
parcelRequire("3u9AZ");

parcelRequire("5n5FB");
var $bd1244d1d0386fba$var$pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $bd1244d1d0386fba$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $7szRs.h).call(props, "css")) // $FlowFixMe
    return $exYeM.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $7szRs.E);
    createElementArgArray[1] = (0, $7szRs.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $exYeM.createElement.apply(null, createElementArgArray);
};
var $bd1244d1d0386fba$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $bd1244d1d0386fba$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $7szRs.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $fTtVz.serializeStyles)([
        styles
    ], undefined, $exYeM.useContext((0, $7szRs.T)));
    if (!(0, $7szRs.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $exYeM.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $exYeM.useRef();
    (0, $8mmyy.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $8mmyy.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $l9TJr.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $bd1244d1d0386fba$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $fTtVz.serializeStyles)(args);
}
var $bd1244d1d0386fba$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $bd1244d1d0386fba$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $bd1244d1d0386fba$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $bd1244d1d0386fba$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $l9TJr.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $bd1244d1d0386fba$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $8mmyy.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $l9TJr.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $bd1244d1d0386fba$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $7szRs.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $fTtVz.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $l9TJr.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $bd1244d1d0386fba$var$merge(cache.registered, css, $bd1244d1d0386fba$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $exYeM.useContext((0, $7szRs.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, /*#__PURE__*/ $exYeM.createElement($bd1244d1d0386fba$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $bd1244d1d0386fba$var$isBrowser, $bd1244d1d0386fba$var$isTestEnv, $bd1244d1d0386fba$var$globalContext, $bd1244d1d0386fba$var$globalKey;

});
parcelRegister("7szRs", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $56e6f73b82cc76e5$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $56e6f73b82cc76e5$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "C", function () { return $56e6f73b82cc76e5$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $56e6f73b82cc76e5$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $56e6f73b82cc76e5$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $56e6f73b82cc76e5$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $56e6f73b82cc76e5$export$a9c23c6ac3fc3eca; });

var $exYeM = parcelRequire("exYeM");

var $8YN4E = parcelRequire("8YN4E");

var $aJx1R = parcelRequire("aJx1R");

var $3u9AZ = parcelRequire("3u9AZ");

var $lV4fX = parcelRequire("lV4fX");

var $l9TJr = parcelRequire("l9TJr");

var $fTtVz = parcelRequire("fTtVz");

var $8mmyy = parcelRequire("8mmyy");
var $56e6f73b82cc76e5$export$23f2a1d2818174ef = true;
var $56e6f73b82cc76e5$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $56e6f73b82cc76e5$var$EmotionCacheContext = /* #__PURE__ */ $exYeM.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $8YN4E.default)({
    key: "css"
}) : null);
var $56e6f73b82cc76e5$export$e7094788287c5e9b = $56e6f73b82cc76e5$var$EmotionCacheContext.Provider;
var $56e6f73b82cc76e5$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $exYeM.useContext)($56e6f73b82cc76e5$var$EmotionCacheContext);
};
var $56e6f73b82cc76e5$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $exYeM.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $exYeM.useContext)($56e6f73b82cc76e5$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$56e6f73b82cc76e5$export$23f2a1d2818174ef) $56e6f73b82cc76e5$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $exYeM.useContext)($56e6f73b82cc76e5$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $8YN4E.default)({
                key: "css"
            });
            return /*#__PURE__*/ $exYeM.createElement($56e6f73b82cc76e5$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $56e6f73b82cc76e5$export$971d5caa766a69d7 = /* #__PURE__ */ $exYeM.createContext({});
var $56e6f73b82cc76e5$export$3b14a55fb2447963 = function useTheme() {
    return $exYeM.useContext($56e6f73b82cc76e5$export$971d5caa766a69d7);
};
var $56e6f73b82cc76e5$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $aJx1R.default)({}, outerTheme, theme);
};
var $56e6f73b82cc76e5$var$createCacheWithTheme = /* #__PURE__ */ (0, $3u9AZ.default)(function(outerTheme) {
    return (0, $3u9AZ.default)(function(theme) {
        return $56e6f73b82cc76e5$var$getTheme(outerTheme, theme);
    });
});
var $56e6f73b82cc76e5$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $exYeM.useContext($56e6f73b82cc76e5$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $56e6f73b82cc76e5$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $exYeM.createElement($56e6f73b82cc76e5$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $56e6f73b82cc76e5$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $exYeM.useContext($56e6f73b82cc76e5$export$971d5caa766a69d7);
        return /*#__PURE__*/ $exYeM.createElement(Component, (0, $aJx1R.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $exYeM.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $lV4fX.default)(WithTheme, Component);
}
var $56e6f73b82cc76e5$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $56e6f73b82cc76e5$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $56e6f73b82cc76e5$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $56e6f73b82cc76e5$var$getLastPart(match[1]);
    return undefined;
};
var $56e6f73b82cc76e5$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $56e6f73b82cc76e5$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $56e6f73b82cc76e5$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $56e6f73b82cc76e5$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($56e6f73b82cc76e5$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $56e6f73b82cc76e5$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $56e6f73b82cc76e5$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $56e6f73b82cc76e5$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $56e6f73b82cc76e5$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($56e6f73b82cc76e5$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$56e6f73b82cc76e5$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $56e6f73b82cc76e5$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $l9TJr.registerStyles)(cache, serialized, isStringTag);
    (0, $8mmyy.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $l9TJr.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $56e6f73b82cc76e5$var$Emotion = /* #__PURE__ */ $56e6f73b82cc76e5$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$56e6f73b82cc76e5$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $l9TJr.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $fTtVz.serializeStyles)(registeredStyles, undefined, $exYeM.useContext($56e6f73b82cc76e5$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($56e6f73b82cc76e5$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $56e6f73b82cc76e5$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, /*#__PURE__*/ $exYeM.createElement($56e6f73b82cc76e5$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $exYeM.createElement(WrappedComponent, newProps));
});
var $56e6f73b82cc76e5$export$a9c23c6ac3fc3eca = $56e6f73b82cc76e5$var$Emotion;

});
parcelRegister("8YN4E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6899fe6450b22db7$export$2e2bcd8739ae039; });

var $bcZxO = parcelRequire("bcZxO");

var $lsm0P = parcelRequire("lsm0P");
parcelRequire("3u9AZ");
parcelRequire("3xeCd");
var $6899fe6450b22db7$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $lsm0P.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $lsm0P.token)(character)) break;
        (0, $lsm0P.next)();
    }
    return (0, $lsm0P.slice)(begin, (0, $lsm0P.position));
};
var $6899fe6450b22db7$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $lsm0P.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $lsm0P.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $6899fe6450b22db7$var$identifierWithPointTracking((0, $lsm0P.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $lsm0P.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $lsm0P.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $lsm0P.from)(character);
    }
    while (character = (0, $lsm0P.next)());
    return parsed;
};
var $6899fe6450b22db7$var$getRules = function getRules(value, points) {
    return (0, $lsm0P.dealloc)($6899fe6450b22db7$var$toRules((0, $lsm0P.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $6899fe6450b22db7$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $6899fe6450b22db7$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$6899fe6450b22db7$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $6899fe6450b22db7$var$fixedElements.set(element, true);
    var points = [];
    var rules = $6899fe6450b22db7$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $6899fe6450b22db7$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $6899fe6450b22db7$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $6899fe6450b22db7$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($6899fe6450b22db7$var$ignoreFlag) > -1;
};
var $6899fe6450b22db7$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($6899fe6450b22db7$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $6899fe6450b22db7$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $6899fe6450b22db7$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$6899fe6450b22db7$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $6899fe6450b22db7$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $6899fe6450b22db7$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$6899fe6450b22db7$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $6899fe6450b22db7$var$nullifyElement(element);
    } else if ($6899fe6450b22db7$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $6899fe6450b22db7$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $6899fe6450b22db7$var$prefix(value, length) {
    switch((0, $lsm0P.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $lsm0P.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $lsm0P.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MOZ) + value + (0, $lsm0P.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MS) + value + value;
        // order
        case 6165:
            return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.replace)(value, /(\w+).+(:[^]+)/, (0, $lsm0P.WEBKIT) + "box-$1$2" + (0, $lsm0P.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MS) + "flex-item-" + (0, $lsm0P.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MS) + "flex-line-pack" + (0, $lsm0P.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MS) + (0, $lsm0P.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MS) + (0, $lsm0P.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $lsm0P.WEBKIT) + "box-" + (0, $lsm0P.replace)(value, "-grow", "") + (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MS) + (0, $lsm0P.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $lsm0P.WEBKIT) + (0, $lsm0P.replace)(value, /([^-])(transform)/g, "$1" + (0, $lsm0P.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $lsm0P.replace)((0, $lsm0P.replace)((0, $lsm0P.replace)(value, /(zoom-|grab)/, (0, $lsm0P.WEBKIT) + "$1"), /(image-set)/, (0, $lsm0P.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $lsm0P.replace)(value, /(image-set\([^]*)/, (0, $lsm0P.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $lsm0P.replace)((0, $lsm0P.replace)(value, /(.+:)(flex-)?(.*)/, (0, $lsm0P.WEBKIT) + "box-pack:$3" + (0, $lsm0P.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $lsm0P.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $lsm0P.replace)(value, /(.+)-inline(.+)/, (0, $lsm0P.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $lsm0P.strlen)(value) - 1 - length > 6) switch((0, $lsm0P.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $lsm0P.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $lsm0P.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $lsm0P.WEBKIT) + "$2-$3" + "$1" + (0, $lsm0P.MOZ) + ((0, $lsm0P.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $lsm0P.indexof)(value, "stretch") ? $6899fe6450b22db7$var$prefix((0, $lsm0P.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $lsm0P.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $lsm0P.charat)(value, (0, $lsm0P.strlen)(value) - 3 - (~(0, $lsm0P.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $lsm0P.replace)(value, ":", ":" + (0, $lsm0P.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $lsm0P.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $lsm0P.WEBKIT) + ((0, $lsm0P.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $lsm0P.WEBKIT) + "$2$3" + "$1" + (0, $lsm0P.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $lsm0P.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MS) + (0, $lsm0P.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MS) + (0, $lsm0P.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MS) + (0, $lsm0P.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $lsm0P.WEBKIT) + value + (0, $lsm0P.MS) + value + value;
    }
    return value;
}
var $6899fe6450b22db7$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $lsm0P.DECLARATION:
                element["return"] = $6899fe6450b22db7$var$prefix(element.value, element.length);
                break;
            case 0, $lsm0P.KEYFRAMES:
                return (0, $lsm0P.serialize)([
                    (0, $lsm0P.copy)(element, {
                        value: (0, $lsm0P.replace)(element.value, "@", "@" + (0, $lsm0P.WEBKIT))
                    })
                ], callback);
            case 0, $lsm0P.RULESET:
                if (element.length) return (0, $lsm0P.combine)(element.props, function(value) {
                    switch((0, $lsm0P.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $lsm0P.serialize)([
                                (0, $lsm0P.copy)(element, {
                                    props: [
                                        (0, $lsm0P.replace)(value, /:(read-\w+)/, ":" + (0, $lsm0P.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $lsm0P.serialize)([
                                (0, $lsm0P.copy)(element, {
                                    props: [
                                        (0, $lsm0P.replace)(value, /:(plac\w+)/, ":" + (0, $lsm0P.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $lsm0P.copy)(element, {
                                    props: [
                                        (0, $lsm0P.replace)(value, /:(plac\w+)/, ":" + (0, $lsm0P.MOZ) + "$1")
                                    ]
                                }),
                                (0, $lsm0P.copy)(element, {
                                    props: [
                                        (0, $lsm0P.replace)(value, /:(plac\w+)/, (0, $lsm0P.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $6899fe6450b22db7$var$defaultStylisPlugins = [
    $6899fe6450b22db7$var$prefixer
];
var $6899fe6450b22db7$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $6899fe6450b22db7$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $6899fe6450b22db7$var$compat,
        $6899fe6450b22db7$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $lsm0P.stringify),
        (0, $lsm0P.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $lsm0P.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $lsm0P.serialize)((0, $lsm0P.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $bcZxO.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("bcZxO", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $82908e25f3ddcfe8$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $82908e25f3ddcfe8$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $82908e25f3ddcfe8$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $82908e25f3ddcfe8$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($82908e25f3ddcfe8$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $82908e25f3ddcfe8$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("lsm0P", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $98c7a0c432789d27$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $98c7a0c432789d27$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $98c7a0c432789d27$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $98c7a0c432789d27$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $98c7a0c432789d27$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $98c7a0c432789d27$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $98c7a0c432789d27$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $98c7a0c432789d27$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $98c7a0c432789d27$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $98c7a0c432789d27$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $98c7a0c432789d27$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $98c7a0c432789d27$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $98c7a0c432789d27$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $98c7a0c432789d27$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $98c7a0c432789d27$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $98c7a0c432789d27$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $98c7a0c432789d27$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $98c7a0c432789d27$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $98c7a0c432789d27$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $98c7a0c432789d27$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $98c7a0c432789d27$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $98c7a0c432789d27$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $98c7a0c432789d27$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $98c7a0c432789d27$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $98c7a0c432789d27$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $98c7a0c432789d27$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $98c7a0c432789d27$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $98c7a0c432789d27$export$38bcb760f1d4871c; });
var $98c7a0c432789d27$export$71ad59f2e432cfe8 = "-ms-";
var $98c7a0c432789d27$export$2c0f367103c8d01c = "-moz-";
var $98c7a0c432789d27$export$39dfd62a25e0fe93 = "-webkit-";
var $98c7a0c432789d27$export$a29989082612d0d9 = "comm";
var $98c7a0c432789d27$export$aa3a2e812ca8570d = "rule";
var $98c7a0c432789d27$export$527d108ccf083c2b = "decl";
var $98c7a0c432789d27$export$d3d35020fa5b54f0 = "@page";
var $98c7a0c432789d27$export$500415a86c544f73 = "@media";
var $98c7a0c432789d27$export$a763edbf796b780a = "@import";
var $98c7a0c432789d27$export$2790aeb8b4e5c826 = "@charset";
var $98c7a0c432789d27$export$1cc683e23b84b133 = "@viewport";
var $98c7a0c432789d27$export$9447a5efea57e862 = "@supports";
var $98c7a0c432789d27$export$ef011b4e114b1fba = "@document";
var $98c7a0c432789d27$export$6aad947bda0f3f46 = "@namespace";
var $98c7a0c432789d27$export$b44a8529a35fcb60 = "@keyframes";
var $98c7a0c432789d27$export$2c16de31893252e6 = "@font-face";
var $98c7a0c432789d27$export$3d846dd52e150c6f = "@counter-style";
var $98c7a0c432789d27$export$22314bfbb57653fe = "@font-feature-values";
var $98c7a0c432789d27$export$d773506282b3cfe6 = "@layer";
var $98c7a0c432789d27$export$2335f513bbd82c6d = Math.abs;
var $98c7a0c432789d27$export$6788812c4e6611e6 = String.fromCharCode;
var $98c7a0c432789d27$export$e6e34fd1f2686227 = Object.assign;
function $98c7a0c432789d27$export$d6af199866bfb566(e, r) {
    return $98c7a0c432789d27$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $98c7a0c432789d27$export$a9db5e087081082d(e, 0)) << 2 ^ $98c7a0c432789d27$export$a9db5e087081082d(e, 1)) << 2 ^ $98c7a0c432789d27$export$a9db5e087081082d(e, 2)) << 2 ^ $98c7a0c432789d27$export$a9db5e087081082d(e, 3) : 0;
}
function $98c7a0c432789d27$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $98c7a0c432789d27$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $98c7a0c432789d27$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $98c7a0c432789d27$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $98c7a0c432789d27$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $98c7a0c432789d27$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $98c7a0c432789d27$export$36776f635604f274(e) {
    return e.length;
}
function $98c7a0c432789d27$export$f9084667e487ed46(e) {
    return e.length;
}
function $98c7a0c432789d27$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $98c7a0c432789d27$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $98c7a0c432789d27$export$53f1d5ea8de3d7c = 1;
var $98c7a0c432789d27$export$4e0c71f277ca26b3 = 1;
var $98c7a0c432789d27$export$f24224f1c91d8156 = 0;
var $98c7a0c432789d27$export$5880b8b5730aff45 = 0;
var $98c7a0c432789d27$export$c0306caf338ac095 = 0;
var $98c7a0c432789d27$export$30a86d91af8ff6e6 = "";
function $98c7a0c432789d27$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $98c7a0c432789d27$export$53f1d5ea8de3d7c,
        column: $98c7a0c432789d27$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $98c7a0c432789d27$export$784d13d8ee351f07(e, r) {
    return $98c7a0c432789d27$export$e6e34fd1f2686227($98c7a0c432789d27$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $98c7a0c432789d27$export$eba6f6f03b0a92e7() {
    return $98c7a0c432789d27$export$c0306caf338ac095;
}
function $98c7a0c432789d27$export$232faf9add678146() {
    $98c7a0c432789d27$export$c0306caf338ac095 = $98c7a0c432789d27$export$5880b8b5730aff45 > 0 ? $98c7a0c432789d27$export$a9db5e087081082d($98c7a0c432789d27$export$30a86d91af8ff6e6, --$98c7a0c432789d27$export$5880b8b5730aff45) : 0;
    if ($98c7a0c432789d27$export$4e0c71f277ca26b3--, $98c7a0c432789d27$export$c0306caf338ac095 === 10) $98c7a0c432789d27$export$4e0c71f277ca26b3 = 1, $98c7a0c432789d27$export$53f1d5ea8de3d7c--;
    return $98c7a0c432789d27$export$c0306caf338ac095;
}
function $98c7a0c432789d27$export$48cfd1e771a65c4f() {
    $98c7a0c432789d27$export$c0306caf338ac095 = $98c7a0c432789d27$export$5880b8b5730aff45 < $98c7a0c432789d27$export$f24224f1c91d8156 ? $98c7a0c432789d27$export$a9db5e087081082d($98c7a0c432789d27$export$30a86d91af8ff6e6, $98c7a0c432789d27$export$5880b8b5730aff45++) : 0;
    if ($98c7a0c432789d27$export$4e0c71f277ca26b3++, $98c7a0c432789d27$export$c0306caf338ac095 === 10) $98c7a0c432789d27$export$4e0c71f277ca26b3 = 1, $98c7a0c432789d27$export$53f1d5ea8de3d7c++;
    return $98c7a0c432789d27$export$c0306caf338ac095;
}
function $98c7a0c432789d27$export$4d3fb11e950abb9e() {
    return $98c7a0c432789d27$export$a9db5e087081082d($98c7a0c432789d27$export$30a86d91af8ff6e6, $98c7a0c432789d27$export$5880b8b5730aff45);
}
function $98c7a0c432789d27$export$e88cb2efb12ae807() {
    return $98c7a0c432789d27$export$5880b8b5730aff45;
}
function $98c7a0c432789d27$export$58adb3bec8346d0f(e, r) {
    return $98c7a0c432789d27$export$2f35ab04d2335697($98c7a0c432789d27$export$30a86d91af8ff6e6, e, r);
}
function $98c7a0c432789d27$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $98c7a0c432789d27$export$2de70f21292aac9e(e) {
    return $98c7a0c432789d27$export$53f1d5ea8de3d7c = $98c7a0c432789d27$export$4e0c71f277ca26b3 = 1, $98c7a0c432789d27$export$f24224f1c91d8156 = $98c7a0c432789d27$export$36776f635604f274($98c7a0c432789d27$export$30a86d91af8ff6e6 = e), $98c7a0c432789d27$export$5880b8b5730aff45 = 0, [];
}
function $98c7a0c432789d27$export$45918ac1574455b1(e) {
    return $98c7a0c432789d27$export$30a86d91af8ff6e6 = "", e;
}
function $98c7a0c432789d27$export$410ac95b9ec204b8(e) {
    return $98c7a0c432789d27$export$87c2784dc9fc4ab($98c7a0c432789d27$export$58adb3bec8346d0f($98c7a0c432789d27$export$5880b8b5730aff45 - 1, $98c7a0c432789d27$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $98c7a0c432789d27$export$660b2ee2d4fb4eff(e) {
    return $98c7a0c432789d27$export$45918ac1574455b1($98c7a0c432789d27$export$5f8c09e3ae6f64e1($98c7a0c432789d27$export$2de70f21292aac9e(e)));
}
function $98c7a0c432789d27$export$7af1228ff777d175(e) {
    while($98c7a0c432789d27$export$c0306caf338ac095 = $98c7a0c432789d27$export$4d3fb11e950abb9e())if ($98c7a0c432789d27$export$c0306caf338ac095 < 33) $98c7a0c432789d27$export$48cfd1e771a65c4f();
    else break;
    return $98c7a0c432789d27$export$9e1725a4cfeada27(e) > 2 || $98c7a0c432789d27$export$9e1725a4cfeada27($98c7a0c432789d27$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $98c7a0c432789d27$export$5f8c09e3ae6f64e1(e) {
    while($98c7a0c432789d27$export$48cfd1e771a65c4f())switch($98c7a0c432789d27$export$9e1725a4cfeada27($98c7a0c432789d27$export$c0306caf338ac095)){
        case 0:
            $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$c2ab62c7bf24634($98c7a0c432789d27$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$410ac95b9ec204b8($98c7a0c432789d27$export$c0306caf338ac095), e);
            break;
        default:
            $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$6788812c4e6611e6($98c7a0c432789d27$export$c0306caf338ac095), e);
    }
    return e;
}
function $98c7a0c432789d27$export$955ba06d119e085e(e, r) {
    while(--r && $98c7a0c432789d27$export$48cfd1e771a65c4f())if ($98c7a0c432789d27$export$c0306caf338ac095 < 48 || $98c7a0c432789d27$export$c0306caf338ac095 > 102 || $98c7a0c432789d27$export$c0306caf338ac095 > 57 && $98c7a0c432789d27$export$c0306caf338ac095 < 65 || $98c7a0c432789d27$export$c0306caf338ac095 > 70 && $98c7a0c432789d27$export$c0306caf338ac095 < 97) break;
    return $98c7a0c432789d27$export$58adb3bec8346d0f(e, $98c7a0c432789d27$export$e88cb2efb12ae807() + (r < 6 && $98c7a0c432789d27$export$4d3fb11e950abb9e() == 32 && $98c7a0c432789d27$export$48cfd1e771a65c4f() == 32));
}
function $98c7a0c432789d27$export$c889f2fcc19dbf12(e) {
    while($98c7a0c432789d27$export$48cfd1e771a65c4f())switch($98c7a0c432789d27$export$c0306caf338ac095){
        case e:
            return $98c7a0c432789d27$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $98c7a0c432789d27$export$c889f2fcc19dbf12($98c7a0c432789d27$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $98c7a0c432789d27$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $98c7a0c432789d27$export$48cfd1e771a65c4f();
            break;
    }
    return $98c7a0c432789d27$export$5880b8b5730aff45;
}
function $98c7a0c432789d27$export$4254d4e2b3745c4c(e, r) {
    while($98c7a0c432789d27$export$48cfd1e771a65c4f())if (e + $98c7a0c432789d27$export$c0306caf338ac095 === 57) break;
    else if (e + $98c7a0c432789d27$export$c0306caf338ac095 === 84 && $98c7a0c432789d27$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $98c7a0c432789d27$export$58adb3bec8346d0f(r, $98c7a0c432789d27$export$5880b8b5730aff45 - 1) + "*" + $98c7a0c432789d27$export$6788812c4e6611e6(e === 47 ? e : $98c7a0c432789d27$export$48cfd1e771a65c4f());
}
function $98c7a0c432789d27$export$c2ab62c7bf24634(e) {
    while(!$98c7a0c432789d27$export$9e1725a4cfeada27($98c7a0c432789d27$export$4d3fb11e950abb9e()))$98c7a0c432789d27$export$48cfd1e771a65c4f();
    return $98c7a0c432789d27$export$58adb3bec8346d0f(e, $98c7a0c432789d27$export$5880b8b5730aff45);
}
function $98c7a0c432789d27$export$ef7acd7185315e22(e) {
    return $98c7a0c432789d27$export$45918ac1574455b1($98c7a0c432789d27$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $98c7a0c432789d27$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $98c7a0c432789d27$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $98c7a0c432789d27$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $98c7a0c432789d27$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($98c7a0c432789d27$export$f8e21b1e77979a08(j += $98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $98c7a0c432789d27$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $98c7a0c432789d27$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $98c7a0c432789d27$export$955ba06d119e085e($98c7a0c432789d27$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($98c7a0c432789d27$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$4a34f930e789283c($98c7a0c432789d27$export$4254d4e2b3745c4c($98c7a0c432789d27$export$48cfd1e771a65c4f(), $98c7a0c432789d27$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $98c7a0c432789d27$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $98c7a0c432789d27$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $98c7a0c432789d27$export$36776f635604f274(j) - l) $98c7a0c432789d27$export$10d8903dec122b9d(p > 32 ? $98c7a0c432789d27$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $98c7a0c432789d27$export$f8483753829ec8f3($98c7a0c432789d27$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $98c7a0c432789d27$export$10d8903dec122b9d(y = $98c7a0c432789d27$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $98c7a0c432789d27$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $98c7a0c432789d27$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $98c7a0c432789d27$export$98e6a39c04603d36(e, y, y, n && $98c7a0c432789d27$export$10d8903dec122b9d($98c7a0c432789d27$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $98c7a0c432789d27$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $98c7a0c432789d27$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $98c7a0c432789d27$export$232faf9add678146() == 125) continue;
            }
            switch(j += $98c7a0c432789d27$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($98c7a0c432789d27$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($98c7a0c432789d27$export$4d3fb11e950abb9e() === 45) j += $98c7a0c432789d27$export$410ac95b9ec204b8($98c7a0c432789d27$export$48cfd1e771a65c4f());
                    v = $98c7a0c432789d27$export$4d3fb11e950abb9e(), o = l = $98c7a0c432789d27$export$36776f635604f274(g = j += $98c7a0c432789d27$export$c2ab62c7bf24634($98c7a0c432789d27$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $98c7a0c432789d27$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $98c7a0c432789d27$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $98c7a0c432789d27$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $98c7a0c432789d27$export$2f35ab04d2335697(e, v + 1, v = $98c7a0c432789d27$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $98c7a0c432789d27$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $98c7a0c432789d27$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $98c7a0c432789d27$export$35059013cd4a06db(e, r, a, s === 0 ? $98c7a0c432789d27$export$aa3a2e812ca8570d : i, f, o, l);
}
function $98c7a0c432789d27$export$4a34f930e789283c(e, r, a) {
    return $98c7a0c432789d27$export$35059013cd4a06db(e, r, a, $98c7a0c432789d27$export$a29989082612d0d9, $98c7a0c432789d27$export$6788812c4e6611e6($98c7a0c432789d27$export$eba6f6f03b0a92e7()), $98c7a0c432789d27$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $98c7a0c432789d27$export$f8483753829ec8f3(e, r, a, n) {
    return $98c7a0c432789d27$export$35059013cd4a06db(e, r, a, $98c7a0c432789d27$export$527d108ccf083c2b, $98c7a0c432789d27$export$2f35ab04d2335697(e, 0, n), $98c7a0c432789d27$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $98c7a0c432789d27$export$82e9f45cca5ba907(n, c, s) {
    switch($98c7a0c432789d27$export$d6af199866bfb566(n, c)){
        case 5103:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $98c7a0c432789d27$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$2c0f367103c8d01c + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($98c7a0c432789d27$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "box-$1$2" + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-item-" + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$98c7a0c432789d27$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $98c7a0c432789d27$export$71ad59f2e432cfe8 + "grid-row-" + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-line-pack" + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + "box-" + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "-grow", "") + $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $98c7a0c432789d27$export$39dfd62a25e0fe93 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "box-pack:$3" + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $98c7a0c432789d27$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$98c7a0c432789d27$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $98c7a0c432789d27$export$71ad59f2e432cfe8 + "grid-column-align" + $98c7a0c432789d27$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $98c7a0c432789d27$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$98c7a0c432789d27$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$98c7a0c432789d27$export$f8e21b1e77979a08(s, "span") ? $98c7a0c432789d27$export$4659b591c19bdf3d(s, /\d+/) : +$98c7a0c432789d27$export$4659b591c19bdf3d(s, /\d+/) - +$98c7a0c432789d27$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $98c7a0c432789d27$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $98c7a0c432789d27$export$71ad59f2e432cfe8 + $98c7a0c432789d27$export$77ad94ebf1c2b9ed($98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($98c7a0c432789d27$export$36776f635604f274(n) - 1 - c > 6) switch($98c7a0c432789d27$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($98c7a0c432789d27$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $98c7a0c432789d27$export$2c0f367103c8d01c + ($98c7a0c432789d27$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$98c7a0c432789d27$export$f8e21b1e77979a08(n, "stretch") ? $98c7a0c432789d27$export$82e9f45cca5ba907($98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $98c7a0c432789d27$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $98c7a0c432789d27$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($98c7a0c432789d27$export$a9db5e087081082d(n, c + 6) === 121) return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, ":", ":" + $98c7a0c432789d27$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($98c7a0c432789d27$export$a9db5e087081082d(n, $98c7a0c432789d27$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + ($98c7a0c432789d27$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $98c7a0c432789d27$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, ":", ":" + $98c7a0c432789d27$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $98c7a0c432789d27$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $98c7a0c432789d27$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $98c7a0c432789d27$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $98c7a0c432789d27$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $98c7a0c432789d27$export$a763edbf796b780a:
        case $98c7a0c432789d27$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $98c7a0c432789d27$export$a29989082612d0d9:
            return "";
        case $98c7a0c432789d27$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $98c7a0c432789d27$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $98c7a0c432789d27$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $98c7a0c432789d27$export$36776f635604f274(a = $98c7a0c432789d27$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $98c7a0c432789d27$export$5a7767152ae0305f(e) {
    var r = $98c7a0c432789d27$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $98c7a0c432789d27$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $98c7a0c432789d27$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $98c7a0c432789d27$export$527d108ccf083c2b:
                n.return = $98c7a0c432789d27$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $98c7a0c432789d27$export$b44a8529a35fcb60:
                return $98c7a0c432789d27$export$dfdc1655ccc5b9cb([
                    $98c7a0c432789d27$export$784d13d8ee351f07(n, {
                        value: $98c7a0c432789d27$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $98c7a0c432789d27$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $98c7a0c432789d27$export$aa3a2e812ca8570d:
                if (n.length) return $98c7a0c432789d27$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($98c7a0c432789d27$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $98c7a0c432789d27$export$dfdc1655ccc5b9cb([
                                $98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                    props: [
                                        $98c7a0c432789d27$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $98c7a0c432789d27$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $98c7a0c432789d27$export$dfdc1655ccc5b9cb([
                                $98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                    props: [
                                        $98c7a0c432789d27$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $98c7a0c432789d27$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                    props: [
                                        $98c7a0c432789d27$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $98c7a0c432789d27$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $98c7a0c432789d27$export$784d13d8ee351f07(n, {
                                    props: [
                                        $98c7a0c432789d27$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $98c7a0c432789d27$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $98c7a0c432789d27$export$76a88f7de6507443(e) {
    switch(e.type){
        case $98c7a0c432789d27$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $98c7a0c432789d27$export$1be1fc439b849fdf($98c7a0c432789d27$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($98c7a0c432789d27$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $98c7a0c432789d27$export$2f35ab04d2335697(r, 1, $98c7a0c432789d27$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $98c7a0c432789d27$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $98c7a0c432789d27$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $98c7a0c432789d27$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("3u9AZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $289b9de9542c5514$export$2e2bcd8739ae039; });
var $289b9de9542c5514$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});


parcelRegister("lV4fX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff52391680bbdf5c$export$2e2bcd8739ae039; });

var $5n5FB = parcelRequire("5n5FB");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $ff52391680bbdf5c$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5n5FB)))(targetComponent, sourceComponent);
};

});
parcelRegister("5n5FB", function(module, exports) {
"use strict";

var $bfCid = parcelRequire("bfCid");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $3e937fab5d08b2fc$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $3e937fab5d08b2fc$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $3e937fab5d08b2fc$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $3e937fab5d08b2fc$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $3e937fab5d08b2fc$var$TYPE_STATICS = {};
$3e937fab5d08b2fc$var$TYPE_STATICS[$bfCid.ForwardRef] = $3e937fab5d08b2fc$var$FORWARD_REF_STATICS;
$3e937fab5d08b2fc$var$TYPE_STATICS[$bfCid.Memo] = $3e937fab5d08b2fc$var$MEMO_STATICS;
function $3e937fab5d08b2fc$var$getStatics(component) {
    // React v16.11 and below
    if ($bfCid.isMemo(component)) return $3e937fab5d08b2fc$var$MEMO_STATICS;
     // React v16.12 and above
    return $3e937fab5d08b2fc$var$TYPE_STATICS[component["$$typeof"]] || $3e937fab5d08b2fc$var$REACT_STATICS;
}
var $3e937fab5d08b2fc$var$defineProperty = Object.defineProperty;
var $3e937fab5d08b2fc$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $3e937fab5d08b2fc$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3e937fab5d08b2fc$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $3e937fab5d08b2fc$var$getPrototypeOf = Object.getPrototypeOf;
var $3e937fab5d08b2fc$var$objectPrototype = Object.prototype;
function $3e937fab5d08b2fc$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($3e937fab5d08b2fc$var$objectPrototype) {
            var inheritedComponent = $3e937fab5d08b2fc$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $3e937fab5d08b2fc$var$objectPrototype) $3e937fab5d08b2fc$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $3e937fab5d08b2fc$var$getOwnPropertyNames(sourceComponent);
        if ($3e937fab5d08b2fc$var$getOwnPropertySymbols) keys = keys.concat($3e937fab5d08b2fc$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $3e937fab5d08b2fc$var$getStatics(targetComponent);
        var sourceStatics = $3e937fab5d08b2fc$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$3e937fab5d08b2fc$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $3e937fab5d08b2fc$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $3e937fab5d08b2fc$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $3e937fab5d08b2fc$var$hoistNonReactStatics;

});
parcelRegister("bfCid", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gO0OJ"));

});



parcelRegister("l9TJr", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $f675ab6948c73ede$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $f675ab6948c73ede$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $f675ab6948c73ede$export$6f077d94b33a01aa; });
var $f675ab6948c73ede$var$isBrowser = true;
function $f675ab6948c73ede$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $f675ab6948c73ede$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $f675ab6948c73ede$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $f675ab6948c73ede$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $f675ab6948c73ede$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("fTtVz", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $b92335153ccd04a2$export$6321afa313b251b5; });

var $lQ91k = parcelRequire("lQ91k");

var $iHmjH = parcelRequire("iHmjH");

var $3xeCd = parcelRequire("3xeCd");
var $b92335153ccd04a2$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $b92335153ccd04a2$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $b92335153ccd04a2$var$hyphenateRegex = /[A-Z]|^ms/g;
var $b92335153ccd04a2$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $b92335153ccd04a2$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $b92335153ccd04a2$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $b92335153ccd04a2$var$processStyleName = /* #__PURE__ */ (0, $3xeCd.default)(function(styleName) {
    return $b92335153ccd04a2$var$isCustomProperty(styleName) ? styleName : styleName.replace($b92335153ccd04a2$var$hyphenateRegex, "-$&").toLowerCase();
});
var $b92335153ccd04a2$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($b92335153ccd04a2$var$animationRegex, function(match, p1, p2) {
                $b92335153ccd04a2$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $b92335153ccd04a2$var$cursor
                };
                return p1;
            });
    }
    if ((0, $iHmjH.default)[key] !== 1 && !$b92335153ccd04a2$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $b92335153ccd04a2$var$contentValuePattern, $b92335153ccd04a2$var$contentValues, $b92335153ccd04a2$var$oldProcessStyleValue, $b92335153ccd04a2$var$msPattern, $b92335153ccd04a2$var$hyphenPattern, $b92335153ccd04a2$var$hyphenatedCache;
var $b92335153ccd04a2$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $b92335153ccd04a2$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $b92335153ccd04a2$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $b92335153ccd04a2$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $b92335153ccd04a2$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $b92335153ccd04a2$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $b92335153ccd04a2$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $b92335153ccd04a2$var$cursor;
                var result = interpolation(mergedProps);
                $b92335153ccd04a2$var$cursor = previousCursor;
                return $b92335153ccd04a2$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $b92335153ccd04a2$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $b92335153ccd04a2$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($b92335153ccd04a2$var$isProcessableValue(value)) string += $b92335153ccd04a2$var$processStyleName(_key) + ":" + $b92335153ccd04a2$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($b92335153ccd04a2$var$isProcessableValue(value[_i])) string += $b92335153ccd04a2$var$processStyleName(_key) + ":" + $b92335153ccd04a2$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $b92335153ccd04a2$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $b92335153ccd04a2$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $b92335153ccd04a2$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $b92335153ccd04a2$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $b92335153ccd04a2$var$cursor;
var $b92335153ccd04a2$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $b92335153ccd04a2$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $b92335153ccd04a2$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $b92335153ccd04a2$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $b92335153ccd04a2$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $b92335153ccd04a2$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $lQ91k.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $b92335153ccd04a2$var$cursor
    };
};

});
parcelRegister("lQ91k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe6573913f214e4d$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $fe6573913f214e4d$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("iHmjH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9cd8dcf50c5790f$export$2e2bcd8739ae039; });
var $d9cd8dcf50c5790f$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("8mmyy", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $6161e001f7582192$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $6161e001f7582192$export$811a713a7276cb9d; });

var $exYeM = parcelRequire("exYeM");
var $6161e001f7582192$var$syncFallback = function syncFallback(create) {
    return create();
};
var $6161e001f7582192$var$useInsertionEffect = $exYeM.useInsertionEffect ? $exYeM.useInsertionEffect : false;
var $6161e001f7582192$export$db21c7ffa21794e7 = $6161e001f7582192$var$useInsertionEffect || $6161e001f7582192$var$syncFallback;
var $6161e001f7582192$export$811a713a7276cb9d = $6161e001f7582192$var$useInsertionEffect || $exYeM.useLayoutEffect;

});





parcelRegister("5abSN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c271a96953a4030$export$2e2bcd8739ae039; });
parcelRequire("exYeM");


var $7szRs = parcelRequire("7szRs");

var $8YN4E = parcelRequire("8YN4E");

var $aSiaI = parcelRequire("aSiaI");
"use client";
let $3c271a96953a4030$var$cache;
if (typeof document === "object") $3c271a96953a4030$var$cache = (0, $8YN4E.default)({
    key: "css",
    prepend: true
});
function $3c271a96953a4030$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, children: children } = props;
    return injectFirst && $3c271a96953a4030$var$cache ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7szRs.C), {
        value: $3c271a96953a4030$var$cache,
        children: children
    }) : children;
}

});
parcelRegister("aSiaI", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6ObR8"));

});


parcelRegister("cXmXD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96ecce4c0ca424a0$export$2e2bcd8739ae039; });
parcelRequire("exYeM");


var $geqbO = parcelRequire("geqbO");

var $aSiaI = parcelRequire("aSiaI");
"use client";
function $96ecce4c0ca424a0$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $96ecce4c0ca424a0$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($96ecce4c0ca424a0$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $geqbO.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("gqEFx", function(module, exports) {
function $bf5e9f09faf23ac5$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $bf5e9f09faf23ac5$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("MPurY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("jesoU")).default; });

var $jesoU = parcelRequire("jesoU");

});
parcelRegister("jesoU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0055aef01c6dd36$export$2e2bcd8739ae039; });

var $2TX6h = parcelRequire("2TX6h");
function $e0055aef01c6dd36$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $2TX6h.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("9H6ZV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("hnjMB")).default; });

var $hnjMB = parcelRequire("hnjMB");
$parcel$exportWildcard(module.exports, $hnjMB);

});
parcelRegister("hnjMB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", function () { return $ca63ee22269fa47e$export$aad197c7121a6651; });
$parcel$export(module.exports, "default", function () { return $ca63ee22269fa47e$export$2e2bcd8739ae039; });

var $bSFE1 = parcelRequire("bSFE1");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $ca63ee22269fa47e$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $ca63ee22269fa47e$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($ca63ee22269fa47e$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || "";
}
function $ca63ee22269fa47e$var$getFunctionComponentName(Component, fallback = "") {
    return Component.displayName || Component.name || $ca63ee22269fa47e$export$aad197c7121a6651(Component) || fallback;
}
function $ca63ee22269fa47e$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $ca63ee22269fa47e$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function $ca63ee22269fa47e$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === "string") return Component;
    if (typeof Component === "function") return $ca63ee22269fa47e$var$getFunctionComponentName(Component, "Component");
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === "object") switch(Component.$$typeof){
        case 0, $bSFE1.ForwardRef:
            return $ca63ee22269fa47e$var$getWrappedName(Component, Component.render, "ForwardRef");
        case 0, $bSFE1.Memo:
            return $ca63ee22269fa47e$var$getWrappedName(Component, Component.type, "memo");
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("bSFE1", function(module, exports) {
"use strict";

module.exports = (parcelRequire("beWdq"));

});
parcelRegister("beWdq", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $82ee28eaccf33045$export$a7c73072b1a182ae; }, function (v) { return $82ee28eaccf33045$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $82ee28eaccf33045$export$9f27bc3417b4524d; }, function (v) { return $82ee28eaccf33045$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $82ee28eaccf33045$export$db77ccec0bb4ccac; }, function (v) { return $82ee28eaccf33045$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $82ee28eaccf33045$export$8392c0c9d3dcbd35; }, function (v) { return $82ee28eaccf33045$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $82ee28eaccf33045$export$ffb0004e005737fa; }, function (v) { return $82ee28eaccf33045$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $82ee28eaccf33045$export$b624eff549462981; }, function (v) { return $82ee28eaccf33045$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $82ee28eaccf33045$export$7897aa7841a5380c; }, function (v) { return $82ee28eaccf33045$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $82ee28eaccf33045$export$602eac185826482c; }, function (v) { return $82ee28eaccf33045$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $82ee28eaccf33045$export$e2c29f18771995cb; }, function (v) { return $82ee28eaccf33045$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $82ee28eaccf33045$export$5f8d39834fd61797; }, function (v) { return $82ee28eaccf33045$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $82ee28eaccf33045$export$74bf444e3cd11ea5; }, function (v) { return $82ee28eaccf33045$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $82ee28eaccf33045$export$998bcd577473dd93; }, function (v) { return $82ee28eaccf33045$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $82ee28eaccf33045$export$92387174baf9b227; }, function (v) { return $82ee28eaccf33045$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $82ee28eaccf33045$export$ec112efeb987d9c6; }, function (v) { return $82ee28eaccf33045$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $82ee28eaccf33045$export$b706b080d889d2c9; }, function (v) { return $82ee28eaccf33045$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $82ee28eaccf33045$export$5be5a87408f70ddc; }, function (v) { return $82ee28eaccf33045$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $82ee28eaccf33045$export$45a5e7f76e0caa8d; }, function (v) { return $82ee28eaccf33045$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $82ee28eaccf33045$export$455c2e768291efa6; }, function (v) { return $82ee28eaccf33045$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $82ee28eaccf33045$export$9522e17588c12572; }, function (v) { return $82ee28eaccf33045$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $82ee28eaccf33045$export$2110ac352bb060b9; }, function (v) { return $82ee28eaccf33045$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $82ee28eaccf33045$export$56885ab8b9c456ab; }, function (v) { return $82ee28eaccf33045$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $82ee28eaccf33045$export$d927fcb6adf8f9de; }, function (v) { return $82ee28eaccf33045$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $82ee28eaccf33045$export$b82d16f27459e05a; }, function (v) { return $82ee28eaccf33045$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $82ee28eaccf33045$export$522c17b4f5e123e8; }, function (v) { return $82ee28eaccf33045$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $82ee28eaccf33045$export$1aabd8a0274ecfd6; }, function (v) { return $82ee28eaccf33045$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $82ee28eaccf33045$export$3d6c20d97e46b957; }, function (v) { return $82ee28eaccf33045$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $82ee28eaccf33045$export$9b621391a187a31a; }, function (v) { return $82ee28eaccf33045$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $82ee28eaccf33045$export$f5bbd400c2f4426f; }, function (v) { return $82ee28eaccf33045$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $82ee28eaccf33045$export$a7c73072b1a182ae;
var $82ee28eaccf33045$export$9f27bc3417b4524d;
var $82ee28eaccf33045$export$db77ccec0bb4ccac;
var $82ee28eaccf33045$export$8392c0c9d3dcbd35;
var $82ee28eaccf33045$export$ffb0004e005737fa;
var $82ee28eaccf33045$export$b624eff549462981;
var $82ee28eaccf33045$export$7897aa7841a5380c;
var $82ee28eaccf33045$export$602eac185826482c;
var $82ee28eaccf33045$export$e2c29f18771995cb;
var $82ee28eaccf33045$export$5f8d39834fd61797;
var $82ee28eaccf33045$export$74bf444e3cd11ea5;
var $82ee28eaccf33045$export$998bcd577473dd93;
var $82ee28eaccf33045$export$92387174baf9b227;
var $82ee28eaccf33045$export$ec112efeb987d9c6;
var $82ee28eaccf33045$export$b706b080d889d2c9;
var $82ee28eaccf33045$export$5be5a87408f70ddc;
var $82ee28eaccf33045$export$45a5e7f76e0caa8d;
var $82ee28eaccf33045$export$455c2e768291efa6;
var $82ee28eaccf33045$export$9522e17588c12572;
var $82ee28eaccf33045$export$2110ac352bb060b9;
var $82ee28eaccf33045$export$56885ab8b9c456ab;
var $82ee28eaccf33045$export$d927fcb6adf8f9de;
var $82ee28eaccf33045$export$b82d16f27459e05a;
var $82ee28eaccf33045$export$522c17b4f5e123e8;
var $82ee28eaccf33045$export$1aabd8a0274ecfd6;
var $82ee28eaccf33045$export$3d6c20d97e46b957;
var $82ee28eaccf33045$export$9b621391a187a31a;
var $82ee28eaccf33045$export$f5bbd400c2f4426f;
"use strict";
var $82ee28eaccf33045$var$b = Symbol.for("react.element"), $82ee28eaccf33045$var$c = Symbol.for("react.portal"), $82ee28eaccf33045$var$d = Symbol.for("react.fragment"), $82ee28eaccf33045$var$e = Symbol.for("react.strict_mode"), $82ee28eaccf33045$var$f = Symbol.for("react.profiler"), $82ee28eaccf33045$var$g = Symbol.for("react.provider"), $82ee28eaccf33045$var$h = Symbol.for("react.context"), $82ee28eaccf33045$var$k = Symbol.for("react.server_context"), $82ee28eaccf33045$var$l = Symbol.for("react.forward_ref"), $82ee28eaccf33045$var$m = Symbol.for("react.suspense"), $82ee28eaccf33045$var$n = Symbol.for("react.suspense_list"), $82ee28eaccf33045$var$p = Symbol.for("react.memo"), $82ee28eaccf33045$var$q = Symbol.for("react.lazy"), $82ee28eaccf33045$var$t = Symbol.for("react.offscreen"), $82ee28eaccf33045$var$u;
$82ee28eaccf33045$var$u = Symbol.for("react.module.reference");
function $82ee28eaccf33045$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $82ee28eaccf33045$var$b:
                switch(a = a.type, a){
                    case $82ee28eaccf33045$var$d:
                    case $82ee28eaccf33045$var$f:
                    case $82ee28eaccf33045$var$e:
                    case $82ee28eaccf33045$var$m:
                    case $82ee28eaccf33045$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $82ee28eaccf33045$var$k:
                            case $82ee28eaccf33045$var$h:
                            case $82ee28eaccf33045$var$l:
                            case $82ee28eaccf33045$var$q:
                            case $82ee28eaccf33045$var$p:
                            case $82ee28eaccf33045$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $82ee28eaccf33045$var$c:
                return r;
        }
    }
}
$82ee28eaccf33045$export$a7c73072b1a182ae = $82ee28eaccf33045$var$h;
$82ee28eaccf33045$export$9f27bc3417b4524d = $82ee28eaccf33045$var$g;
$82ee28eaccf33045$export$db77ccec0bb4ccac = $82ee28eaccf33045$var$b;
$82ee28eaccf33045$export$8392c0c9d3dcbd35 = $82ee28eaccf33045$var$l;
$82ee28eaccf33045$export$ffb0004e005737fa = $82ee28eaccf33045$var$d;
$82ee28eaccf33045$export$b624eff549462981 = $82ee28eaccf33045$var$q;
$82ee28eaccf33045$export$7897aa7841a5380c = $82ee28eaccf33045$var$p;
$82ee28eaccf33045$export$602eac185826482c = $82ee28eaccf33045$var$c;
$82ee28eaccf33045$export$e2c29f18771995cb = $82ee28eaccf33045$var$f;
$82ee28eaccf33045$export$5f8d39834fd61797 = $82ee28eaccf33045$var$e;
$82ee28eaccf33045$export$74bf444e3cd11ea5 = $82ee28eaccf33045$var$m;
$82ee28eaccf33045$export$998bcd577473dd93 = $82ee28eaccf33045$var$n;
$82ee28eaccf33045$export$92387174baf9b227 = function() {
    return !1;
};
$82ee28eaccf33045$export$ec112efeb987d9c6 = function() {
    return !1;
};
$82ee28eaccf33045$export$b706b080d889d2c9 = function(a) {
    return $82ee28eaccf33045$var$v(a) === $82ee28eaccf33045$var$h;
};
$82ee28eaccf33045$export$5be5a87408f70ddc = function(a) {
    return $82ee28eaccf33045$var$v(a) === $82ee28eaccf33045$var$g;
};
$82ee28eaccf33045$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $82ee28eaccf33045$var$b;
};
$82ee28eaccf33045$export$455c2e768291efa6 = function(a) {
    return $82ee28eaccf33045$var$v(a) === $82ee28eaccf33045$var$l;
};
$82ee28eaccf33045$export$9522e17588c12572 = function(a) {
    return $82ee28eaccf33045$var$v(a) === $82ee28eaccf33045$var$d;
};
$82ee28eaccf33045$export$2110ac352bb060b9 = function(a) {
    return $82ee28eaccf33045$var$v(a) === $82ee28eaccf33045$var$q;
};
$82ee28eaccf33045$export$56885ab8b9c456ab = function(a) {
    return $82ee28eaccf33045$var$v(a) === $82ee28eaccf33045$var$p;
};
$82ee28eaccf33045$export$d927fcb6adf8f9de = function(a) {
    return $82ee28eaccf33045$var$v(a) === $82ee28eaccf33045$var$c;
};
$82ee28eaccf33045$export$b82d16f27459e05a = function(a) {
    return $82ee28eaccf33045$var$v(a) === $82ee28eaccf33045$var$f;
};
$82ee28eaccf33045$export$522c17b4f5e123e8 = function(a) {
    return $82ee28eaccf33045$var$v(a) === $82ee28eaccf33045$var$e;
};
$82ee28eaccf33045$export$1aabd8a0274ecfd6 = function(a) {
    return $82ee28eaccf33045$var$v(a) === $82ee28eaccf33045$var$m;
};
$82ee28eaccf33045$export$3d6c20d97e46b957 = function(a) {
    return $82ee28eaccf33045$var$v(a) === $82ee28eaccf33045$var$n;
};
$82ee28eaccf33045$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $82ee28eaccf33045$var$d || a === $82ee28eaccf33045$var$f || a === $82ee28eaccf33045$var$e || a === $82ee28eaccf33045$var$m || a === $82ee28eaccf33045$var$n || a === $82ee28eaccf33045$var$t || "object" === typeof a && null !== a && (a.$$typeof === $82ee28eaccf33045$var$q || a.$$typeof === $82ee28eaccf33045$var$p || a.$$typeof === $82ee28eaccf33045$var$g || a.$$typeof === $82ee28eaccf33045$var$h || a.$$typeof === $82ee28eaccf33045$var$l || a.$$typeof === $82ee28eaccf33045$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$82ee28eaccf33045$export$f5bbd400c2f4426f = $82ee28eaccf33045$var$v;

});




parcelRegister("e08Y5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("26Kcc")).default; });
$parcel$export(module.exports, "private_createBreakpoints", function () { return (parcelRequire("3ICsA")).default; });
$parcel$export(module.exports, "unstable_applyStyles", function () { return (parcelRequire("hNhoK")).default; });

var $26Kcc = parcelRequire("26Kcc");

var $3ICsA = parcelRequire("3ICsA");

var $hNhoK = parcelRequire("hNhoK");

});
parcelRegister("26Kcc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $188ff9d90be79aa4$export$2e2bcd8739ae039; });

var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $1cT6v = parcelRequire("1cT6v");

var $3ICsA = parcelRequire("3ICsA");

var $eoAxn = parcelRequire("eoAxn");

var $azYFX = parcelRequire("azYFX");

var $3b4hp = parcelRequire("3b4hp");

var $7CkUk = parcelRequire("7CkUk");

var $hNhoK = parcelRequire("hNhoK");
const $188ff9d90be79aa4$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $188ff9d90be79aa4$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $3L80X.default)(options, $188ff9d90be79aa4$var$_excluded);
    const breakpoints = (0, $3ICsA.default)(breakpointsInput);
    const spacing = (0, $azYFX.default)(spacingInput);
    let muiTheme = (0, $1cT6v.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $aJx1R.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $aJx1R.default)({}, (0, $eoAxn.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $hNhoK.default);
    muiTheme = args.reduce((acc, argument)=>(0, $1cT6v.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $aJx1R.default)({}, (0, $7CkUk.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $3b4hp.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $188ff9d90be79aa4$export$2e2bcd8739ae039 = $188ff9d90be79aa4$var$createTheme;

});
parcelRegister("3L80X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bcbfa5ccfc3d1d2$export$2e2bcd8739ae039; });
function $2bcbfa5ccfc3d1d2$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("1cT6v", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $0e11a7e7c37e54e6$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $0e11a7e7c37e54e6$export$2e2bcd8739ae039; });

var $aJx1R = parcelRequire("aJx1R");
function $0e11a7e7c37e54e6$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $0e11a7e7c37e54e6$var$deepClone(source) {
    if (!$0e11a7e7c37e54e6$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $0e11a7e7c37e54e6$var$deepClone(source[key]);
    });
    return output;
}
function $0e11a7e7c37e54e6$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $aJx1R.default)({}, target) : target;
    if ($0e11a7e7c37e54e6$export$53b83ca8eaab0383(target) && $0e11a7e7c37e54e6$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if ($0e11a7e7c37e54e6$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $0e11a7e7c37e54e6$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $0e11a7e7c37e54e6$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $0e11a7e7c37e54e6$export$53b83ca8eaab0383(source[key]) ? $0e11a7e7c37e54e6$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("3ICsA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b53508da4642a63$export$2e2bcd8739ae039; });

var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");
const $2b53508da4642a63$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $2b53508da4642a63$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $2b53508da4642a63$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $aJx1R.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $2b53508da4642a63$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $3L80X.default)(breakpoints, $2b53508da4642a63$var$_excluded);
    const sortedValues = $2b53508da4642a63$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $aJx1R.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("eoAxn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7afa625e6034f46$export$2e2bcd8739ae039; });
const $a7afa625e6034f46$var$shape = {
    borderRadius: 4
};
var $a7afa625e6034f46$export$2e2bcd8739ae039 = $a7afa625e6034f46$var$shape;

});

parcelRegister("azYFX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b3c3d32bf62d229$export$2e2bcd8739ae039; });

var $gdl2x = parcelRequire("gdl2x");
function $7b3c3d32bf62d229$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $gdl2x.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("gdl2x", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $bcde2e567c2735e9$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $bcde2e567c2735e9$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $bcde2e567c2735e9$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $bcde2e567c2735e9$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $bcde2e567c2735e9$export$6f98e8eaf0be1996; });


var $pXCWs = parcelRequire("pXCWs");

var $4GR9L = parcelRequire("4GR9L");

var $jwuHE = parcelRequire("jwuHE");

var $dISoE = parcelRequire("dISoE");
const $bcde2e567c2735e9$var$properties = {
    m: "margin",
    p: "padding"
};
const $bcde2e567c2735e9$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $bcde2e567c2735e9$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $bcde2e567c2735e9$var$getCssProperties = (0, $dISoE.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($bcde2e567c2735e9$var$aliases[prop]) prop = $bcde2e567c2735e9$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $bcde2e567c2735e9$var$properties[a];
    const direction = $bcde2e567c2735e9$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $bcde2e567c2735e9$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $bcde2e567c2735e9$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $bcde2e567c2735e9$var$spacingKeys = [
    ...$bcde2e567c2735e9$export$aab52a0dde05ad8a,
    ...$bcde2e567c2735e9$export$f8397d44f03ab6ad
];
function $bcde2e567c2735e9$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $4GR9L.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $bcde2e567c2735e9$export$1def6f833384e3d1(theme) {
    return $bcde2e567c2735e9$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $bcde2e567c2735e9$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $bcde2e567c2735e9$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $bcde2e567c2735e9$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $bcde2e567c2735e9$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $bcde2e567c2735e9$var$getCssProperties(prop);
    const styleFromPropValue = $bcde2e567c2735e9$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $pXCWs.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $bcde2e567c2735e9$var$style(props, keys) {
    const transformer = $bcde2e567c2735e9$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$bcde2e567c2735e9$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $jwuHE.default), {});
}
function $bcde2e567c2735e9$export$7ede87f9b603dd3c(props) {
    return $bcde2e567c2735e9$var$style(props, $bcde2e567c2735e9$export$aab52a0dde05ad8a);
}
$bcde2e567c2735e9$export$7ede87f9b603dd3c.propTypes = {};
$bcde2e567c2735e9$export$7ede87f9b603dd3c.filterProps = $bcde2e567c2735e9$export$aab52a0dde05ad8a;
function $bcde2e567c2735e9$export$6f98e8eaf0be1996(props) {
    return $bcde2e567c2735e9$var$style(props, $bcde2e567c2735e9$export$f8397d44f03ab6ad);
}
$bcde2e567c2735e9$export$6f98e8eaf0be1996.propTypes = {};
$bcde2e567c2735e9$export$6f98e8eaf0be1996.filterProps = $bcde2e567c2735e9$export$f8397d44f03ab6ad;
function $bcde2e567c2735e9$var$spacing(props) {
    return $bcde2e567c2735e9$var$style(props, $bcde2e567c2735e9$var$spacingKeys);
}
$bcde2e567c2735e9$var$spacing.propTypes = {};
$bcde2e567c2735e9$var$spacing.filterProps = $bcde2e567c2735e9$var$spacingKeys;
var $bcde2e567c2735e9$export$2e2bcd8739ae039 = $bcde2e567c2735e9$var$spacing;

});
parcelRegister("pXCWs", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $04e0969cdee1aba3$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $04e0969cdee1aba3$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $04e0969cdee1aba3$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $04e0969cdee1aba3$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $04e0969cdee1aba3$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $04e0969cdee1aba3$export$980e6a259d807490; });

var $aJx1R = parcelRequire("aJx1R");


var $1cT6v = parcelRequire("1cT6v");

var $jwuHE = parcelRequire("jwuHE");
const $04e0969cdee1aba3$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $04e0969cdee1aba3$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$04e0969cdee1aba3$export$68c286be0e7e55b7[key]}px)`
};
function $04e0969cdee1aba3$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $04e0969cdee1aba3$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $04e0969cdee1aba3$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $04e0969cdee1aba3$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $04e0969cdee1aba3$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $04e0969cdee1aba3$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $aJx1R.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $jwuHE.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $04e0969cdee1aba3$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $04e0969cdee1aba3$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $04e0969cdee1aba3$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $04e0969cdee1aba3$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $1cT6v.default)(prev, next), {});
    return $04e0969cdee1aba3$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $04e0969cdee1aba3$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $04e0969cdee1aba3$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $04e0969cdee1aba3$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $04e0969cdee1aba3$export$2e2bcd8739ae039 = $04e0969cdee1aba3$var$breakpoints;

});
parcelRegister("jwuHE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e368d27c30b8008c$export$2e2bcd8739ae039; });

var $1cT6v = parcelRequire("1cT6v");
function $e368d27c30b8008c$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $1cT6v.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $e368d27c30b8008c$export$2e2bcd8739ae039 = $e368d27c30b8008c$var$merge;

});


parcelRegister("4GR9L", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $36a45171103bb362$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $36a45171103bb362$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $36a45171103bb362$export$2e2bcd8739ae039; });

var $jesoU = parcelRequire("jesoU");


var $pXCWs = parcelRequire("pXCWs");
function $36a45171103bb362$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $36a45171103bb362$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $36a45171103bb362$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $36a45171103bb362$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $36a45171103bb362$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $36a45171103bb362$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $36a45171103bb362$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $jesoU.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $pXCWs.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $36a45171103bb362$export$2e2bcd8739ae039 = $36a45171103bb362$var$style;

});

parcelRegister("dISoE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fd9947684ccaaf3$export$2e2bcd8739ae039; });
function $9fd9947684ccaaf3$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("3b4hp", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return $2505b80d7eb9a5f3$export$7d53d8bf2911e013; });
$parcel$export(module.exports, "default", function () { return $2505b80d7eb9a5f3$export$2e2bcd8739ae039; });

var $jesoU = parcelRequire("jesoU");

var $jwuHE = parcelRequire("jwuHE");

var $4GR9L = parcelRequire("4GR9L");

var $pXCWs = parcelRequire("pXCWs");

var $7CkUk = parcelRequire("7CkUk");
function $2505b80d7eb9a5f3$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $2505b80d7eb9a5f3$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $2505b80d7eb9a5f3$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $4GR9L.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $4GR9L.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $4GR9L.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $jesoU.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $pXCWs.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $7CkUk.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $pXCWs.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $2505b80d7eb9a5f3$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $jwuHE.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $pXCWs.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($2505b80d7eb9a5f3$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $jwuHE.default)(css, breakpointsValues);
                        }
                    } else css = (0, $jwuHE.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $pXCWs.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $2505b80d7eb9a5f3$var$styleFunctionSx = $2505b80d7eb9a5f3$export$7d53d8bf2911e013();
$2505b80d7eb9a5f3$var$styleFunctionSx.filterProps = [
    "sx"
];
var $2505b80d7eb9a5f3$export$2e2bcd8739ae039 = $2505b80d7eb9a5f3$var$styleFunctionSx;

});
parcelRegister("7CkUk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58bc4cccc98e3cfa$export$2e2bcd8739ae039; });

var $gdl2x = parcelRequire("gdl2x");

var $eeyC2 = parcelRequire("eeyC2");

var $gi35K = parcelRequire("gi35K");

var $fD20H = parcelRequire("fD20H");

var $1gfLG = parcelRequire("1gfLG");
const $58bc4cccc98e3cfa$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $eeyC2.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $eeyC2.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $eeyC2.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $eeyC2.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $eeyC2.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $eeyC2.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $eeyC2.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $fD20H.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $fD20H.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $fD20H.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $gdl2x.padding)
    },
    pt: {
        style: (0, $gdl2x.padding)
    },
    pr: {
        style: (0, $gdl2x.padding)
    },
    pb: {
        style: (0, $gdl2x.padding)
    },
    pl: {
        style: (0, $gdl2x.padding)
    },
    px: {
        style: (0, $gdl2x.padding)
    },
    py: {
        style: (0, $gdl2x.padding)
    },
    padding: {
        style: (0, $gdl2x.padding)
    },
    paddingTop: {
        style: (0, $gdl2x.padding)
    },
    paddingRight: {
        style: (0, $gdl2x.padding)
    },
    paddingBottom: {
        style: (0, $gdl2x.padding)
    },
    paddingLeft: {
        style: (0, $gdl2x.padding)
    },
    paddingX: {
        style: (0, $gdl2x.padding)
    },
    paddingY: {
        style: (0, $gdl2x.padding)
    },
    paddingInline: {
        style: (0, $gdl2x.padding)
    },
    paddingInlineStart: {
        style: (0, $gdl2x.padding)
    },
    paddingInlineEnd: {
        style: (0, $gdl2x.padding)
    },
    paddingBlock: {
        style: (0, $gdl2x.padding)
    },
    paddingBlockStart: {
        style: (0, $gdl2x.padding)
    },
    paddingBlockEnd: {
        style: (0, $gdl2x.padding)
    },
    m: {
        style: (0, $gdl2x.margin)
    },
    mt: {
        style: (0, $gdl2x.margin)
    },
    mr: {
        style: (0, $gdl2x.margin)
    },
    mb: {
        style: (0, $gdl2x.margin)
    },
    ml: {
        style: (0, $gdl2x.margin)
    },
    mx: {
        style: (0, $gdl2x.margin)
    },
    my: {
        style: (0, $gdl2x.margin)
    },
    margin: {
        style: (0, $gdl2x.margin)
    },
    marginTop: {
        style: (0, $gdl2x.margin)
    },
    marginRight: {
        style: (0, $gdl2x.margin)
    },
    marginBottom: {
        style: (0, $gdl2x.margin)
    },
    marginLeft: {
        style: (0, $gdl2x.margin)
    },
    marginX: {
        style: (0, $gdl2x.margin)
    },
    marginY: {
        style: (0, $gdl2x.margin)
    },
    marginInline: {
        style: (0, $gdl2x.margin)
    },
    marginInlineStart: {
        style: (0, $gdl2x.margin)
    },
    marginInlineEnd: {
        style: (0, $gdl2x.margin)
    },
    marginBlock: {
        style: (0, $gdl2x.margin)
    },
    marginBlockStart: {
        style: (0, $gdl2x.margin)
    },
    marginBlockEnd: {
        style: (0, $gdl2x.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $gi35K.gap)
    },
    rowGap: {
        style: (0, $gi35K.rowGap)
    },
    columnGap: {
        style: (0, $gi35K.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $1gfLG.sizingTransform)
    },
    maxWidth: {
        style: (0, $1gfLG.maxWidth)
    },
    minWidth: {
        transform: (0, $1gfLG.sizingTransform)
    },
    height: {
        transform: (0, $1gfLG.sizingTransform)
    },
    maxHeight: {
        transform: (0, $1gfLG.sizingTransform)
    },
    minHeight: {
        transform: (0, $1gfLG.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $58bc4cccc98e3cfa$export$2e2bcd8739ae039 = $58bc4cccc98e3cfa$var$defaultSxConfig;

});
parcelRegister("eeyC2", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $a5cd38d5b3551be3$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $a5cd38d5b3551be3$export$7a57f79000377ca2; });


var $4GR9L = parcelRequire("4GR9L");

var $58Hqp = parcelRequire("58Hqp");

var $gdl2x = parcelRequire("gdl2x");

var $pXCWs = parcelRequire("pXCWs");
function $a5cd38d5b3551be3$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $a5cd38d5b3551be3$var$createBorderStyle(prop, transform) {
    return (0, $4GR9L.default)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $a5cd38d5b3551be3$export$1edee58a52776cd9 = $a5cd38d5b3551be3$var$createBorderStyle("border", $a5cd38d5b3551be3$export$34e2febe53ae29cc);
const $a5cd38d5b3551be3$export$f9a7b6bd24892946 = $a5cd38d5b3551be3$var$createBorderStyle("borderTop", $a5cd38d5b3551be3$export$34e2febe53ae29cc);
const $a5cd38d5b3551be3$export$5abca33e6be905d2 = $a5cd38d5b3551be3$var$createBorderStyle("borderRight", $a5cd38d5b3551be3$export$34e2febe53ae29cc);
const $a5cd38d5b3551be3$export$e2ce9f12a980a822 = $a5cd38d5b3551be3$var$createBorderStyle("borderBottom", $a5cd38d5b3551be3$export$34e2febe53ae29cc);
const $a5cd38d5b3551be3$export$47658cca1a909427 = $a5cd38d5b3551be3$var$createBorderStyle("borderLeft", $a5cd38d5b3551be3$export$34e2febe53ae29cc);
const $a5cd38d5b3551be3$export$e7fb0694ba2404fc = $a5cd38d5b3551be3$var$createBorderStyle("borderColor");
const $a5cd38d5b3551be3$export$126a92c968acdb85 = $a5cd38d5b3551be3$var$createBorderStyle("borderTopColor");
const $a5cd38d5b3551be3$export$85cc51cb8fbb8c0e = $a5cd38d5b3551be3$var$createBorderStyle("borderRightColor");
const $a5cd38d5b3551be3$export$340b0327727f6d1a = $a5cd38d5b3551be3$var$createBorderStyle("borderBottomColor");
const $a5cd38d5b3551be3$export$60beef91a985b4bf = $a5cd38d5b3551be3$var$createBorderStyle("borderLeftColor");
const $a5cd38d5b3551be3$export$f9258c55612cbed7 = $a5cd38d5b3551be3$var$createBorderStyle("outline", $a5cd38d5b3551be3$export$34e2febe53ae29cc);
const $a5cd38d5b3551be3$export$621fe586efeb64b9 = $a5cd38d5b3551be3$var$createBorderStyle("outlineColor");
const $a5cd38d5b3551be3$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $gdl2x.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $gdl2x.getValue)(transformer, propValue)
            });
        return (0, $pXCWs.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$a5cd38d5b3551be3$export$7a57f79000377ca2.propTypes = {};
$a5cd38d5b3551be3$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $a5cd38d5b3551be3$var$borders = (0, $58Hqp.default)($a5cd38d5b3551be3$export$1edee58a52776cd9, $a5cd38d5b3551be3$export$f9a7b6bd24892946, $a5cd38d5b3551be3$export$5abca33e6be905d2, $a5cd38d5b3551be3$export$e2ce9f12a980a822, $a5cd38d5b3551be3$export$47658cca1a909427, $a5cd38d5b3551be3$export$e7fb0694ba2404fc, $a5cd38d5b3551be3$export$126a92c968acdb85, $a5cd38d5b3551be3$export$85cc51cb8fbb8c0e, $a5cd38d5b3551be3$export$340b0327727f6d1a, $a5cd38d5b3551be3$export$60beef91a985b4bf, $a5cd38d5b3551be3$export$7a57f79000377ca2, $a5cd38d5b3551be3$export$f9258c55612cbed7, $a5cd38d5b3551be3$export$621fe586efeb64b9);
var $a5cd38d5b3551be3$export$2e2bcd8739ae039 = $a5cd38d5b3551be3$var$borders;

});
parcelRegister("58Hqp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bdf6269b6deaa59$export$2e2bcd8739ae039; });

var $jwuHE = parcelRequire("jwuHE");
function $3bdf6269b6deaa59$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $jwuHE.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $3bdf6269b6deaa59$export$2e2bcd8739ae039 = $3bdf6269b6deaa59$var$compose;

});


parcelRegister("gi35K", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $bdc0b9bfc25c6452$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $bdc0b9bfc25c6452$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $bdc0b9bfc25c6452$export$8a833ffa5f5dbeda; });

var $4GR9L = parcelRequire("4GR9L");

var $58Hqp = parcelRequire("58Hqp");

var $gdl2x = parcelRequire("gdl2x");

var $pXCWs = parcelRequire("pXCWs");

const $bdc0b9bfc25c6452$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $gdl2x.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $gdl2x.getValue)(transformer, propValue)
            });
        return (0, $pXCWs.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$bdc0b9bfc25c6452$export$5df9adcb0db95e1e.propTypes = {};
$bdc0b9bfc25c6452$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $bdc0b9bfc25c6452$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $gdl2x.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $gdl2x.getValue)(transformer, propValue)
            });
        return (0, $pXCWs.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$bdc0b9bfc25c6452$export$ec60d70ff941a580.propTypes = {};
$bdc0b9bfc25c6452$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $bdc0b9bfc25c6452$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $gdl2x.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $gdl2x.getValue)(transformer, propValue)
            });
        return (0, $pXCWs.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$bdc0b9bfc25c6452$export$8a833ffa5f5dbeda.propTypes = {};
$bdc0b9bfc25c6452$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $bdc0b9bfc25c6452$export$baf44164ca3a34e8 = (0, $4GR9L.default)({
    prop: "gridColumn"
});
const $bdc0b9bfc25c6452$export$8f7213a1cd01e832 = (0, $4GR9L.default)({
    prop: "gridRow"
});
const $bdc0b9bfc25c6452$export$b0e0abbc49ba668 = (0, $4GR9L.default)({
    prop: "gridAutoFlow"
});
const $bdc0b9bfc25c6452$export$bcd8b929d4b4142 = (0, $4GR9L.default)({
    prop: "gridAutoColumns"
});
const $bdc0b9bfc25c6452$export$e5039a674e14c828 = (0, $4GR9L.default)({
    prop: "gridAutoRows"
});
const $bdc0b9bfc25c6452$export$42bd9088661ffb03 = (0, $4GR9L.default)({
    prop: "gridTemplateColumns"
});
const $bdc0b9bfc25c6452$export$920682ae05b999bc = (0, $4GR9L.default)({
    prop: "gridTemplateRows"
});
const $bdc0b9bfc25c6452$export$1b88fbdd482fd33a = (0, $4GR9L.default)({
    prop: "gridTemplateAreas"
});
const $bdc0b9bfc25c6452$export$bdb486e40d52d26f = (0, $4GR9L.default)({
    prop: "gridArea"
});
const $bdc0b9bfc25c6452$var$grid = (0, $58Hqp.default)($bdc0b9bfc25c6452$export$5df9adcb0db95e1e, $bdc0b9bfc25c6452$export$ec60d70ff941a580, $bdc0b9bfc25c6452$export$8a833ffa5f5dbeda, $bdc0b9bfc25c6452$export$baf44164ca3a34e8, $bdc0b9bfc25c6452$export$8f7213a1cd01e832, $bdc0b9bfc25c6452$export$b0e0abbc49ba668, $bdc0b9bfc25c6452$export$bcd8b929d4b4142, $bdc0b9bfc25c6452$export$e5039a674e14c828, $bdc0b9bfc25c6452$export$42bd9088661ffb03, $bdc0b9bfc25c6452$export$920682ae05b999bc, $bdc0b9bfc25c6452$export$1b88fbdd482fd33a, $bdc0b9bfc25c6452$export$bdb486e40d52d26f);
var $bdc0b9bfc25c6452$export$2e2bcd8739ae039 = $bdc0b9bfc25c6452$var$grid;

});

parcelRegister("fD20H", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $b60c0ebac49fc276$export$dbaffd4420ea0ac6; });

var $4GR9L = parcelRequire("4GR9L");

var $58Hqp = parcelRequire("58Hqp");
function $b60c0ebac49fc276$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $b60c0ebac49fc276$export$35e9368ef982300f = (0, $4GR9L.default)({
    prop: "color",
    themeKey: "palette",
    transform: $b60c0ebac49fc276$export$dbaffd4420ea0ac6
});
const $b60c0ebac49fc276$export$2506f56c10355b33 = (0, $4GR9L.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $b60c0ebac49fc276$export$dbaffd4420ea0ac6
});
const $b60c0ebac49fc276$export$8c5a050822fd698c = (0, $4GR9L.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $b60c0ebac49fc276$export$dbaffd4420ea0ac6
});
const $b60c0ebac49fc276$var$palette = (0, $58Hqp.default)($b60c0ebac49fc276$export$35e9368ef982300f, $b60c0ebac49fc276$export$2506f56c10355b33, $b60c0ebac49fc276$export$8c5a050822fd698c);
var $b60c0ebac49fc276$export$2e2bcd8739ae039 = $b60c0ebac49fc276$var$palette;

});

parcelRegister("1gfLG", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $0eb3844e49990ef2$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $0eb3844e49990ef2$export$488fda99655ff65a; });

var $4GR9L = parcelRequire("4GR9L");

var $58Hqp = parcelRequire("58Hqp");

var $pXCWs = parcelRequire("pXCWs");
function $0eb3844e49990ef2$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $0eb3844e49990ef2$export$7e3df82ee760448c = (0, $4GR9L.default)({
    prop: "width",
    transform: $0eb3844e49990ef2$export$8afece71750ec241
});
const $0eb3844e49990ef2$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $pXCWs.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $0eb3844e49990ef2$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $pXCWs.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$0eb3844e49990ef2$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $0eb3844e49990ef2$export$ee148fbbe8357dd2 = (0, $4GR9L.default)({
    prop: "minWidth",
    transform: $0eb3844e49990ef2$export$8afece71750ec241
});
const $0eb3844e49990ef2$export$ac607276a8fe9f0a = (0, $4GR9L.default)({
    prop: "height",
    transform: $0eb3844e49990ef2$export$8afece71750ec241
});
const $0eb3844e49990ef2$export$dc0d8bd0b94f8570 = (0, $4GR9L.default)({
    prop: "maxHeight",
    transform: $0eb3844e49990ef2$export$8afece71750ec241
});
const $0eb3844e49990ef2$export$a43cf604e12f3b17 = (0, $4GR9L.default)({
    prop: "minHeight",
    transform: $0eb3844e49990ef2$export$8afece71750ec241
});
const $0eb3844e49990ef2$export$ffed9f14fb65e276 = (0, $4GR9L.default)({
    prop: "size",
    cssProperty: "width",
    transform: $0eb3844e49990ef2$export$8afece71750ec241
});
const $0eb3844e49990ef2$export$905076ed6620e671 = (0, $4GR9L.default)({
    prop: "size",
    cssProperty: "height",
    transform: $0eb3844e49990ef2$export$8afece71750ec241
});
const $0eb3844e49990ef2$export$6ccc93f785106a58 = (0, $4GR9L.default)({
    prop: "boxSizing"
});
const $0eb3844e49990ef2$var$sizing = (0, $58Hqp.default)($0eb3844e49990ef2$export$7e3df82ee760448c, $0eb3844e49990ef2$export$488fda99655ff65a, $0eb3844e49990ef2$export$ee148fbbe8357dd2, $0eb3844e49990ef2$export$ac607276a8fe9f0a, $0eb3844e49990ef2$export$dc0d8bd0b94f8570, $0eb3844e49990ef2$export$a43cf604e12f3b17, $0eb3844e49990ef2$export$6ccc93f785106a58);
var $0eb3844e49990ef2$export$2e2bcd8739ae039 = $0eb3844e49990ef2$var$sizing;

});



parcelRegister("hNhoK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf44822cf7939f0a$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $cf44822cf7939f0a$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("lgtp8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("3b4hp")).default; });
$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return (parcelRequire("3b4hp")).unstable_createStyleFunctionSx; });
$parcel$export(module.exports, "extendSxProp", function () { return (parcelRequire("aJf2l")).default; });
$parcel$export(module.exports, "unstable_defaultSxConfig", function () { return (parcelRequire("7CkUk")).default; });

var $3b4hp = parcelRequire("3b4hp");

var $aJf2l = parcelRequire("aJf2l");

var $7CkUk = parcelRequire("7CkUk");

});
parcelRegister("aJf2l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cf9c55720146ca2$export$2e2bcd8739ae039; });

var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $1cT6v = parcelRequire("1cT6v");

var $7CkUk = parcelRequire("7CkUk");
const $7cf9c55720146ca2$var$_excluded = [
    "sx"
];
const $7cf9c55720146ca2$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $7CkUk.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $7cf9c55720146ca2$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $3L80X.default)(props, $7cf9c55720146ca2$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $7cf9c55720146ca2$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $1cT6v.isPlainObject)(result)) return systemProps;
        return (0, $aJx1R.default)({}, systemProps, result);
    };
    else finalSx = (0, $aJx1R.default)({}, systemProps, inSx);
    return (0, $aJx1R.default)({}, otherProps, {
        sx: finalSx
    });
}

});


parcelRegister("eXuaq", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bPz57.default;
    }
});

var $bPz57 = parcelRequire("bPz57");

});
parcelRegister("bPz57", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89cfab9cd7059c88$export$2e2bcd8739ae039; });

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $h3MX3 = parcelRequire("h3MX3");

var $aSiaI = parcelRequire("aSiaI");
"use client";
function $89cfab9cd7059c88$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $h3MX3.default), (0, $aJx1R.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $h3MX3.default).muiName;
    return /*#__PURE__*/ $exYeM.memo(/*#__PURE__*/ $exYeM.forwardRef(Component));
}

});
parcelRegister("h3MX3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6b8b036fbdb4313$export$2e2bcd8739ae039; });

var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $fXwzw = parcelRequire("fXwzw");

var $7PWLt = parcelRequire("7PWLt");

var $jawKn = parcelRequire("jawKn");

var $9JeVt = parcelRequire("9JeVt");

var $aSiaI = parcelRequire("aSiaI");
"use client";
const $c6b8b036fbdb4313$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $c6b8b036fbdb4313$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $fXwzw.default)(color)}`,
            `fontSize${(0, $fXwzw.default)(fontSize)}`
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $9JeVt.getSvgIconUtilityClass), classes);
};
const $c6b8b036fbdb4313$var$SvgIconRoot = (0, $jawKn.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $fXwzw.default)(ownerState.color)}`],
            styles[`fontSize${(0, $fXwzw.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $c6b8b036fbdb4313$var$SvgIcon = /*#__PURE__*/ $exYeM.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $3L80X.default)(props, $c6b8b036fbdb4313$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $exYeM.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $aJx1R.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $c6b8b036fbdb4313$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($c6b8b036fbdb4313$var$SvgIconRoot, (0, $aJx1R.default)({
        as: component,
        className: (0, $4qr5a.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $aSiaI.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$c6b8b036fbdb4313$var$SvgIcon.muiName = "SvgIcon";
var $c6b8b036fbdb4313$export$2e2bcd8739ae039 = $c6b8b036fbdb4313$var$SvgIcon;

});
parcelRegister("4qr5a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fecb99b999628060$export$2e2bcd8739ae039; });
function $fecb99b999628060$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $fecb99b999628060$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $fecb99b999628060$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $fecb99b999628060$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $fecb99b999628060$export$2e2bcd8739ae039 = $fecb99b999628060$export$4f5d2d50c9deca37;

});

parcelRegister("2f0D3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a1d785e268af998$export$2e2bcd8739ae039; });
function $1a1d785e268af998$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRegister("fXwzw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9e5a1d3bbfb9bbe$export$2e2bcd8739ae039; });

var $jesoU = parcelRequire("jesoU");
var $b9e5a1d3bbfb9bbe$export$2e2bcd8739ae039 = (0, $jesoU.default);

});

parcelRegister("7PWLt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b4ae145dd21c617$export$2e2bcd8739ae039; });

var $dZquJ = parcelRequire("dZquJ");

var $5n7Fs = parcelRequire("5n7Fs");

var $pePt2 = parcelRequire("pePt2");
"use client";
function $5b4ae145dd21c617$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $dZquJ.default)({
        props: props,
        name: name,
        defaultTheme: $5n7Fs.default,
        themeId: (0, $pePt2.default)
    });
}

});
parcelRegister("dZquJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2f58624ff362108$export$2e2bcd8739ae039; });

var $4ivqW = parcelRequire("4ivqW");

var $8IwTu = parcelRequire("8IwTu");
"use client";
function $a2f58624ff362108$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $8IwTu.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $4ivqW.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRegister("4ivqW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $321139eed5dcf42d$export$2e2bcd8739ae039; });

var $99M00 = parcelRequire("99M00");
function $321139eed5dcf42d$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $99M00.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("99M00", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6aaa2ff50751d579$export$2e2bcd8739ae039; });

var $aJx1R = parcelRequire("aJx1R");
function $6aaa2ff50751d579$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $aJx1R.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $aJx1R.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $aJx1R.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $6aaa2ff50751d579$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRegister("8IwTu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $658bf2d653e24d45$export$2e2bcd8739ae039; });

var $26Kcc = parcelRequire("26Kcc");

var $ar2vM = parcelRequire("ar2vM");
"use client";
const $658bf2d653e24d45$export$35e57303dbd8a66 = (0, $26Kcc.default)();
function $658bf2d653e24d45$var$useTheme(defaultTheme = $658bf2d653e24d45$export$35e57303dbd8a66) {
    return (0, $ar2vM.default)(defaultTheme);
}
var $658bf2d653e24d45$export$2e2bcd8739ae039 = $658bf2d653e24d45$var$useTheme;

});
parcelRegister("ar2vM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $798e5fb9bba4154b$export$2e2bcd8739ae039; });

var $exYeM = parcelRequire("exYeM");
parcelRequire("geqbO");
var $7szRs = parcelRequire("7szRs");
"use client";
function $798e5fb9bba4154b$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $798e5fb9bba4154b$var$useTheme(defaultTheme = null) {
    const contextTheme = $exYeM.useContext((0, $7szRs.T));
    return !contextTheme || $798e5fb9bba4154b$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $798e5fb9bba4154b$export$2e2bcd8739ae039 = $798e5fb9bba4154b$var$useTheme;

});



parcelRegister("5n7Fs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e950c62aa1a477a$export$2e2bcd8739ae039; });

var $6TTLz = parcelRequire("6TTLz");
"use client";
const $3e950c62aa1a477a$var$defaultTheme = (0, $6TTLz.default)();
var $3e950c62aa1a477a$export$2e2bcd8739ae039 = $3e950c62aa1a477a$var$defaultTheme;

});
parcelRegister("6TTLz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $506323245f469e57$export$2e2bcd8739ae039; });

var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $2TX6h = parcelRequire("2TX6h");

var $1cT6v = parcelRequire("1cT6v");

var $3b4hp = parcelRequire("3b4hp");
var $7CkUk = parcelRequire("7CkUk");

var $26Kcc = parcelRequire("26Kcc");


var $fFHCU = parcelRequire("fFHCU");

var $fNhPV = parcelRequire("fNhPV");

var $jhMdJ = parcelRequire("jhMdJ");

var $3Xn0k = parcelRequire("3Xn0k");

var $6gaNH = parcelRequire("6gaNH");

var $3ucxZ = parcelRequire("3ucxZ");
const $506323245f469e57$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $506323245f469e57$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $3L80X.default)(options, $506323245f469e57$var$_excluded);
    if (options.vars) throw new Error((0, $2TX6h.default)(18));
    const palette = (0, $fNhPV.default)(paletteInput);
    const systemTheme = (0, $26Kcc.default)(options);
    let muiTheme = (0, $1cT6v.default)(systemTheme, {
        mixins: (0, $fFHCU.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $3Xn0k.default).slice(),
        typography: (0, $jhMdJ.default)(palette, typographyInput),
        transitions: (0, $6gaNH.default)(transitionsInput),
        zIndex: (0, $aJx1R.default)({}, (0, $3ucxZ.default))
    });
    muiTheme = (0, $1cT6v.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $1cT6v.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $aJx1R.default)({}, (0, $7CkUk.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $3b4hp.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $506323245f469e57$var$warnedOnce = false;
function $506323245f469e57$export$c469355549431d9b(...args) {
    return $506323245f469e57$var$createTheme(...args);
}
var $506323245f469e57$export$2e2bcd8739ae039 = $506323245f469e57$var$createTheme;

});
parcelRegister("fFHCU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b68c86a894d2fbfe$export$2e2bcd8739ae039; });

var $aJx1R = parcelRequire("aJx1R");
function $b68c86a894d2fbfe$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $aJx1R.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("fNhPV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7f9449411597dbe$export$2e2bcd8739ae039; });

var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $2TX6h = parcelRequire("2TX6h");

var $1cT6v = parcelRequire("1cT6v");

var $8L988 = parcelRequire("8L988");

var $cnWvK = parcelRequire("cnWvK");

var $2Vcdw = parcelRequire("2Vcdw");

var $5pffS = parcelRequire("5pffS");

var $8ZCyU = parcelRequire("8ZCyU");

var $izTEH = parcelRequire("izTEH");

var $e9pCF = parcelRequire("e9pCF");

var $if5gU = parcelRequire("if5gU");

var $iQjIf = parcelRequire("iQjIf");
const $b7f9449411597dbe$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $b7f9449411597dbe$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $cnWvK.default).white,
        default: (0, $cnWvK.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $b7f9449411597dbe$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $cnWvK.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $cnWvK.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $b7f9449411597dbe$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $8L988.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $8L988.darken)(intent.main, tonalOffsetDark);
    }
}
function $b7f9449411597dbe$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $e9pCF.default)[200],
        light: (0, $e9pCF.default)[50],
        dark: (0, $e9pCF.default)[400]
    };
    return {
        main: (0, $e9pCF.default)[700],
        light: (0, $e9pCF.default)[400],
        dark: (0, $e9pCF.default)[800]
    };
}
function $b7f9449411597dbe$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $5pffS.default)[200],
        light: (0, $5pffS.default)[50],
        dark: (0, $5pffS.default)[400]
    };
    return {
        main: (0, $5pffS.default)[500],
        light: (0, $5pffS.default)[300],
        dark: (0, $5pffS.default)[700]
    };
}
function $b7f9449411597dbe$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $8ZCyU.default)[500],
        light: (0, $8ZCyU.default)[300],
        dark: (0, $8ZCyU.default)[700]
    };
    return {
        main: (0, $8ZCyU.default)[700],
        light: (0, $8ZCyU.default)[400],
        dark: (0, $8ZCyU.default)[800]
    };
}
function $b7f9449411597dbe$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $if5gU.default)[400],
        light: (0, $if5gU.default)[300],
        dark: (0, $if5gU.default)[700]
    };
    return {
        main: (0, $if5gU.default)[700],
        light: (0, $if5gU.default)[500],
        dark: (0, $if5gU.default)[900]
    };
}
function $b7f9449411597dbe$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $iQjIf.default)[400],
        light: (0, $iQjIf.default)[300],
        dark: (0, $iQjIf.default)[700]
    };
    return {
        main: (0, $iQjIf.default)[800],
        light: (0, $iQjIf.default)[500],
        dark: (0, $iQjIf.default)[900]
    };
}
function $b7f9449411597dbe$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $izTEH.default)[400],
        light: (0, $izTEH.default)[300],
        dark: (0, $izTEH.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $izTEH.default)[500],
        dark: (0, $izTEH.default)[900]
    };
}
function $b7f9449411597dbe$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $3L80X.default)(palette, $b7f9449411597dbe$var$_excluded);
    const primary = palette.primary || $b7f9449411597dbe$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $b7f9449411597dbe$var$getDefaultSecondary(mode);
    const error = palette.error || $b7f9449411597dbe$var$getDefaultError(mode);
    const info = palette.info || $b7f9449411597dbe$var$getDefaultInfo(mode);
    const success = palette.success || $b7f9449411597dbe$var$getDefaultSuccess(mode);
    const warning = palette.warning || $b7f9449411597dbe$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $8L988.getContrastRatio)(background, $b7f9449411597dbe$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $b7f9449411597dbe$export$55ce6f3a06c59543.text.primary : $b7f9449411597dbe$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $aJx1R.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $2TX6h.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $2TX6h.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $b7f9449411597dbe$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $b7f9449411597dbe$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $b7f9449411597dbe$export$55ce6f3a06c59543,
        light: $b7f9449411597dbe$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $1cT6v.default)((0, $aJx1R.default)({
        // A collection of common colors.
        common: (0, $aJx1R.default)({}, (0, $cnWvK.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $2Vcdw.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("8L988", function(module, exports) {
"use strict";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $6609cb9216736098$var$alpha;
module.exports.blend = $6609cb9216736098$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $6609cb9216736098$var$darken;
module.exports.decomposeColor = $6609cb9216736098$var$decomposeColor;
module.exports.emphasize = $6609cb9216736098$var$emphasize;
module.exports.getContrastRatio = $6609cb9216736098$var$getContrastRatio;
module.exports.getLuminance = $6609cb9216736098$var$getLuminance;
module.exports.hexToRgb = $6609cb9216736098$var$hexToRgb;
module.exports.hslToRgb = $6609cb9216736098$var$hslToRgb;
module.exports.lighten = $6609cb9216736098$var$lighten;
module.exports.private_safeAlpha = $6609cb9216736098$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $6609cb9216736098$var$private_safeDarken;
module.exports.private_safeEmphasize = $6609cb9216736098$var$private_safeEmphasize;
module.exports.private_safeLighten = $6609cb9216736098$var$private_safeLighten;
module.exports.recomposeColor = $6609cb9216736098$var$recomposeColor;
module.exports.rgbToHex = $6609cb9216736098$var$rgbToHex;

var $6609cb9216736098$var$_formatMuiErrorMessage2 = $iQtbn((parcelRequire("8Y5iV")));

var $6609cb9216736098$var$_clamp = $iQtbn((parcelRequire("bUa33")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $6609cb9216736098$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $6609cb9216736098$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $6609cb9216736098$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $6609cb9216736098$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $6609cb9216736098$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $6609cb9216736098$var$decomposeColor($6609cb9216736098$var$hexToRgb(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $6609cb9216736098$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $6609cb9216736098$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $6609cb9216736098$var$colorChannel = (color)=>{
    const decomposedColor = $6609cb9216736098$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
module.exports.colorChannel = $6609cb9216736098$var$colorChannel;
const $6609cb9216736098$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $6609cb9216736098$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $6609cb9216736098$var$private_safeColorChannel;
function $6609cb9216736098$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $6609cb9216736098$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $6609cb9216736098$var$decomposeColor(color);
    return `#${values.map((n, i)=>$6609cb9216736098$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $6609cb9216736098$var$hslToRgb(color) {
    color = $6609cb9216736098$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $6609cb9216736098$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $6609cb9216736098$var$getLuminance(color) {
    color = $6609cb9216736098$var$decomposeColor(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $6609cb9216736098$var$decomposeColor($6609cb9216736098$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $6609cb9216736098$var$getContrastRatio(foreground, background) {
    const lumA = $6609cb9216736098$var$getLuminance(foreground);
    const lumB = $6609cb9216736098$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $6609cb9216736098$var$alpha(color, value) {
    color = $6609cb9216736098$var$decomposeColor(color);
    value = $6609cb9216736098$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $6609cb9216736098$var$recomposeColor(color);
}
function $6609cb9216736098$var$private_safeAlpha(color, value, warning) {
    try {
        return $6609cb9216736098$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $6609cb9216736098$var$darken(color, coefficient) {
    color = $6609cb9216736098$var$decomposeColor(color);
    coefficient = $6609cb9216736098$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $6609cb9216736098$var$recomposeColor(color);
}
function $6609cb9216736098$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $6609cb9216736098$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $6609cb9216736098$var$lighten(color, coefficient) {
    color = $6609cb9216736098$var$decomposeColor(color);
    coefficient = $6609cb9216736098$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $6609cb9216736098$var$recomposeColor(color);
}
function $6609cb9216736098$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $6609cb9216736098$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $6609cb9216736098$var$emphasize(color, coefficient = 0.15) {
    return $6609cb9216736098$var$getLuminance(color) > 0.5 ? $6609cb9216736098$var$darken(color, coefficient) : $6609cb9216736098$var$lighten(color, coefficient);
}
function $6609cb9216736098$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $6609cb9216736098$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $6609cb9216736098$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $6609cb9216736098$var$decomposeColor(background);
    const overlayColor = $6609cb9216736098$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $6609cb9216736098$var$recomposeColor({
        type: "rgb",
        values: rgb
    });
}

});
parcelRegister("iQtbn", function(module, exports) {
function $db83b85f8546cca5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $db83b85f8546cca5$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("cnWvK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90450515aa02e860$export$2e2bcd8739ae039; });
const $90450515aa02e860$var$common = {
    black: "#000",
    white: "#fff"
};
var $90450515aa02e860$export$2e2bcd8739ae039 = $90450515aa02e860$var$common;

});

parcelRegister("2Vcdw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $220a61b576e1ae32$export$2e2bcd8739ae039; });
const $220a61b576e1ae32$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $220a61b576e1ae32$export$2e2bcd8739ae039 = $220a61b576e1ae32$var$grey;

});

parcelRegister("5pffS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3efb1edeb7a7902d$export$2e2bcd8739ae039; });
const $3efb1edeb7a7902d$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $3efb1edeb7a7902d$export$2e2bcd8739ae039 = $3efb1edeb7a7902d$var$purple;

});

parcelRegister("8ZCyU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68c1eedd2d52b347$export$2e2bcd8739ae039; });
const $68c1eedd2d52b347$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $68c1eedd2d52b347$export$2e2bcd8739ae039 = $68c1eedd2d52b347$var$red;

});

parcelRegister("izTEH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d866aae13c960917$export$2e2bcd8739ae039; });
const $d866aae13c960917$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $d866aae13c960917$export$2e2bcd8739ae039 = $d866aae13c960917$var$orange;

});

parcelRegister("e9pCF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4d5c816b0ae036c$export$2e2bcd8739ae039; });
const $a4d5c816b0ae036c$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $a4d5c816b0ae036c$export$2e2bcd8739ae039 = $a4d5c816b0ae036c$var$blue;

});

parcelRegister("if5gU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d47db79153d2dfc6$export$2e2bcd8739ae039; });
const $d47db79153d2dfc6$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $d47db79153d2dfc6$export$2e2bcd8739ae039 = $d47db79153d2dfc6$var$lightBlue;

});

parcelRegister("iQjIf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db7c5fdc9d54f8af$export$2e2bcd8739ae039; });
const $db7c5fdc9d54f8af$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $db7c5fdc9d54f8af$export$2e2bcd8739ae039 = $db7c5fdc9d54f8af$var$green;

});


parcelRegister("jhMdJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0a502721cef0247$export$2e2bcd8739ae039; });

var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $1cT6v = parcelRequire("1cT6v");
const $e0a502721cef0247$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $e0a502721cef0247$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $e0a502721cef0247$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $e0a502721cef0247$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $e0a502721cef0247$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $e0a502721cef0247$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $3L80X.default)(_ref, $e0a502721cef0247$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $aJx1R.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $e0a502721cef0247$var$defaultFontFamily ? {
            letterSpacing: `${$e0a502721cef0247$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $e0a502721cef0247$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $e0a502721cef0247$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $1cT6v.default)((0, $aJx1R.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("3Xn0k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e18b9f98a972921$export$2e2bcd8739ae039; });
const $2e18b9f98a972921$var$shadowKeyUmbraOpacity = 0.2;
const $2e18b9f98a972921$var$shadowKeyPenumbraOpacity = 0.14;
const $2e18b9f98a972921$var$shadowAmbientShadowOpacity = 0.12;
function $2e18b9f98a972921$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$2e18b9f98a972921$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$2e18b9f98a972921$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$2e18b9f98a972921$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $2e18b9f98a972921$var$shadows = [
    "none",
    $2e18b9f98a972921$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $2e18b9f98a972921$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $2e18b9f98a972921$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $2e18b9f98a972921$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $2e18b9f98a972921$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $2e18b9f98a972921$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $2e18b9f98a972921$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $2e18b9f98a972921$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $2e18b9f98a972921$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $2e18b9f98a972921$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $2e18b9f98a972921$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $2e18b9f98a972921$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $2e18b9f98a972921$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $2e18b9f98a972921$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $2e18b9f98a972921$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $2e18b9f98a972921$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $2e18b9f98a972921$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $2e18b9f98a972921$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $2e18b9f98a972921$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $2e18b9f98a972921$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $2e18b9f98a972921$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $2e18b9f98a972921$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $2e18b9f98a972921$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $2e18b9f98a972921$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $2e18b9f98a972921$export$2e2bcd8739ae039 = $2e18b9f98a972921$var$shadows;

});

parcelRegister("6gaNH", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $48ec9d75fb9cfc14$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $48ec9d75fb9cfc14$export$2e2bcd8739ae039; });

var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");
const $48ec9d75fb9cfc14$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $48ec9d75fb9cfc14$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $48ec9d75fb9cfc14$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $48ec9d75fb9cfc14$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $48ec9d75fb9cfc14$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $48ec9d75fb9cfc14$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $aJx1R.default)({}, $48ec9d75fb9cfc14$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $aJx1R.default)({}, $48ec9d75fb9cfc14$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $3L80X.default)(options, $48ec9d75fb9cfc14$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $48ec9d75fb9cfc14$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $48ec9d75fb9cfc14$var$formatMs(delay)}`).join(",");
    };
    return (0, $aJx1R.default)({
        getAutoHeightDuration: $48ec9d75fb9cfc14$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("3ucxZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $289de81233c7fa15$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $289de81233c7fa15$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $289de81233c7fa15$export$2e2bcd8739ae039 = $289de81233c7fa15$var$zIndex;

});



parcelRegister("pePt2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04bdd6ab07d988ab$export$2e2bcd8739ae039; });
var $04bdd6ab07d988ab$export$2e2bcd8739ae039 = "$$material";

});


parcelRegister("jawKn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df485a5f746b8b3f$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "rootShouldForwardProp", function () { return (parcelRequire("bJ6Mf")).default; });

var $hWpff = parcelRequire("hWpff");

var $5n7Fs = parcelRequire("5n7Fs");

var $pePt2 = parcelRequire("pePt2");

var $bJ6Mf = parcelRequire("bJ6Mf");

var $iclFT = parcelRequire("iclFT");
"use client";
const $df485a5f746b8b3f$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($hWpff)))({
    themeId: (0, $pePt2.default),
    defaultTheme: $5n7Fs.default,
    rootShouldForwardProp: $bJ6Mf.default
});
var $df485a5f746b8b3f$export$2e2bcd8739ae039 = $df485a5f746b8b3f$var$styled;

});
parcelRegister("hWpff", function(module, exports) {
"use strict";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d0fb6f94a1220faf$var$createStyled;
module.exports.shouldForwardProp = $d0fb6f94a1220faf$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $d0fb6f94a1220faf$var$_extends2 = $iQtbn((parcelRequire("efvJ0")));

var $d0fb6f94a1220faf$var$_objectWithoutPropertiesLoose2 = $iQtbn((parcelRequire("gqEFx")));

var $d0fb6f94a1220faf$var$_styledEngine = $d0fb6f94a1220faf$var$_interopRequireWildcard((parcelRequire("7RpPE")));

var $1cT6v = parcelRequire("1cT6v");

var $d0fb6f94a1220faf$var$_capitalize = $iQtbn((parcelRequire("MPurY")));

var $d0fb6f94a1220faf$var$_getDisplayName = $iQtbn((parcelRequire("9H6ZV")));

var $d0fb6f94a1220faf$var$_createTheme = $iQtbn((parcelRequire("e08Y5")));

var $d0fb6f94a1220faf$var$_styleFunctionSx = $iQtbn((parcelRequire("lgtp8")));
const $d0fb6f94a1220faf$var$_excluded = [
    "ownerState"
], $d0fb6f94a1220faf$var$_excluded2 = [
    "variants"
], $d0fb6f94a1220faf$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $d0fb6f94a1220faf$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d0fb6f94a1220faf$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $d0fb6f94a1220faf$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $d0fb6f94a1220faf$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $d0fb6f94a1220faf$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $d0fb6f94a1220faf$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $d0fb6f94a1220faf$var$shouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $d0fb6f94a1220faf$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $d0fb6f94a1220faf$var$_createTheme.default)();
const $d0fb6f94a1220faf$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $d0fb6f94a1220faf$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $d0fb6f94a1220faf$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $d0fb6f94a1220faf$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $d0fb6f94a1220faf$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $d0fb6f94a1220faf$var$_objectWithoutPropertiesLoose2.default)(_ref, $d0fb6f94a1220faf$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $d0fb6f94a1220faf$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$d0fb6f94a1220faf$var$processStyleArg(resolvedStyle, (0, $d0fb6f94a1220faf$var$_extends2.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $d0fb6f94a1220faf$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $d0fb6f94a1220faf$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $d0fb6f94a1220faf$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $d0fb6f94a1220faf$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $d0fb6f94a1220faf$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $d0fb6f94a1220faf$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $d0fb6f94a1220faf$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $d0fb6f94a1220faf$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $d0fb6f94a1220faf$var$_styleFunctionSx.default)((0, $d0fb6f94a1220faf$var$_extends2.default)({}, props, {
            theme: $d0fb6f94a1220faf$var$resolveTheme((0, $d0fb6f94a1220faf$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $d0fb6f94a1220faf$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $d0fb6f94a1220faf$var$defaultOverridesResolver($d0fb6f94a1220faf$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $d0fb6f94a1220faf$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $d0fb6f94a1220faf$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $d0fb6f94a1220faf$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($d0fb6f94a1220faf$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $d0fb6f94a1220faf$var$_styledEngine.default)(tag, (0, $d0fb6f94a1220faf$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $1cT6v.isPlainObject)(stylesArg)) return (props)=>$d0fb6f94a1220faf$var$processStyleArg(stylesArg, (0, $d0fb6f94a1220faf$var$_extends2.default)({}, props, {
                    theme: $d0fb6f94a1220faf$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $d0fb6f94a1220faf$var$resolveTheme((0, $d0fb6f94a1220faf$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $d0fb6f94a1220faf$var$processStyleArg(slotStyle, (0, $d0fb6f94a1220faf$var$_extends2.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $d0fb6f94a1220faf$var$resolveTheme((0, $d0fb6f94a1220faf$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $d0fb6f94a1220faf$var$processStyleArg({
                    variants: themeVariants
                }, (0, $d0fb6f94a1220faf$var$_extends2.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});

parcelRegister("bJ6Mf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88992778d49f0a70$export$2e2bcd8739ae039; });

var $iclFT = parcelRequire("iclFT");
const $88992778d49f0a70$var$rootShouldForwardProp = (prop)=>(0, $iclFT.default)(prop) && prop !== "classes";
var $88992778d49f0a70$export$2e2bcd8739ae039 = $88992778d49f0a70$var$rootShouldForwardProp;

});
parcelRegister("iclFT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3fa291f9c8adf22$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $d3fa291f9c8adf22$var$slotShouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
var $d3fa291f9c8adf22$export$2e2bcd8739ae039 = $d3fa291f9c8adf22$var$slotShouldForwardProp;

});



parcelRegister("9JeVt", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $7153e5080fbd0706$export$c7c50641356bdfa5; });

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $7153e5080fbd0706$export$c7c50641356bdfa5(slot) {
    return (0, $dC5O8.default)("MuiSvgIcon", slot);
}
const $7153e5080fbd0706$var$svgIconClasses = (0, $kY7HX.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $7153e5080fbd0706$export$2e2bcd8739ae039 = $7153e5080fbd0706$var$svgIconClasses;

});
parcelRegister("kY7HX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f43f63e5f889d393$export$2e2bcd8739ae039; });

var $dC5O8 = parcelRequire("dC5O8");
function $f43f63e5f889d393$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $dC5O8.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("dC5O8", function(module, exports) {

$parcel$export(module.exports, "globalStateClasses", function () { return $9e935439d6e6a324$export$9d6b9120de57c54; });
$parcel$export(module.exports, "default", function () { return $9e935439d6e6a324$export$2e2bcd8739ae039; });

var $5NAbk = parcelRequire("5NAbk");
const $9e935439d6e6a324$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $9e935439d6e6a324$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $9e935439d6e6a324$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $5NAbk.default).generate(componentName)}-${slot}`;
}
function $9e935439d6e6a324$export$34c0130b1f3e8ae3(slot) {
    return $9e935439d6e6a324$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("5NAbk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $438d98454ee81b6f$export$2e2bcd8739ae039; });
const $438d98454ee81b6f$var$defaultGenerator = (componentName)=>componentName;
const $438d98454ee81b6f$var$createClassNameGenerator = ()=>{
    let generate = $438d98454ee81b6f$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $438d98454ee81b6f$var$defaultGenerator;
        }
    };
};
const $438d98454ee81b6f$var$ClassNameGenerator = $438d98454ee81b6f$var$createClassNameGenerator();
var $438d98454ee81b6f$export$2e2bcd8739ae039 = $438d98454ee81b6f$var$ClassNameGenerator;

});







parcelRegister("72eOO", function(module, exports) {

var $7dGQP = parcelRequire("7dGQP");
var $51f436f817307279$require$MAX_SAFE_COMPONENT_LENGTH = $7dGQP.MAX_SAFE_COMPONENT_LENGTH;
var $51f436f817307279$require$MAX_SAFE_BUILD_LENGTH = $7dGQP.MAX_SAFE_BUILD_LENGTH;
var $51f436f817307279$require$MAX_LENGTH = $7dGQP.MAX_LENGTH;

var $kaZvw = parcelRequire("kaZvw");
exports = module.exports = {};
// The actual regexps go on exports.re
const re = exports.re = [];
const safeRe = exports.safeRe = [];
const src = exports.src = [];
const t = exports.t = {};
let R = 0;
const LETTERDASHNUMBER = "[a-zA-Z0-9-]";
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
const safeRegexReplacements = [
    [
        "\\s",
        1
    ],
    [
        "\\d",
        $51f436f817307279$require$MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        $51f436f817307279$require$MAX_SAFE_BUILD_LENGTH
    ]
];
const makeSafeRegex = (value)=>{
    for (const [token, max] of safeRegexReplacements)value = value.split(`${token}*`).join(`${token}{0,${max}}`).split(`${token}+`).join(`${token}{1,${max}}`);
    return value;
};
const createToken = (name, value, isGlobal)=>{
    const safe = makeSafeRegex(value);
    const index = R++;
    $kaZvw(name, index, value);
    t[name] = index;
    src[index] = value;
    re[index] = new RegExp(value, isGlobal ? "g" : undefined);
    safeRe[index] = new RegExp(safe, isGlobal ? "g" : undefined);
};
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
createToken("NUMERICIDENTIFIER", "0|[1-9]\\d*");
createToken("NUMERICIDENTIFIERLOOSE", "\\d+");
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
createToken("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`);
// ## Main Version
// Three dot-separated numeric identifiers.
createToken("MAINVERSION", `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})`);
createToken("MAINVERSIONLOOSE", `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
createToken("PRERELEASEIDENTIFIER", `(?:${src[t.NUMERICIDENTIFIER]}|${src[t.NONNUMERICIDENTIFIER]})`);
createToken("PRERELEASEIDENTIFIERLOOSE", `(?:${src[t.NUMERICIDENTIFIERLOOSE]}|${src[t.NONNUMERICIDENTIFIER]})`);
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
createToken("PRERELEASE", `(?:-(${src[t.PRERELEASEIDENTIFIER]}(?:\\.${src[t.PRERELEASEIDENTIFIER]})*))`);
createToken("PRERELEASELOOSE", `(?:-?(${src[t.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t.PRERELEASEIDENTIFIERLOOSE]})*))`);
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
createToken("BUILDIDENTIFIER", `${LETTERDASHNUMBER}+`);
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
createToken("BUILD", `(?:\\+(${src[t.BUILDIDENTIFIER]}(?:\\.${src[t.BUILDIDENTIFIER]})*))`);
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
createToken("FULLPLAIN", `v?${src[t.MAINVERSION]}${src[t.PRERELEASE]}?${src[t.BUILD]}?`);
createToken("FULL", `^${src[t.FULLPLAIN]}$`);
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
createToken("LOOSEPLAIN", `[v=\\s]*${src[t.MAINVERSIONLOOSE]}${src[t.PRERELEASELOOSE]}?${src[t.BUILD]}?`);
createToken("LOOSE", `^${src[t.LOOSEPLAIN]}$`);
createToken("GTLT", "((?:<|>)?=?)");
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
createToken("XRANGEIDENTIFIERLOOSE", `${src[t.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
createToken("XRANGEIDENTIFIER", `${src[t.NUMERICIDENTIFIER]}|x|X|\\*`);
createToken("XRANGEPLAIN", `[v=\\s]*(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:${src[t.PRERELEASE]})?${src[t.BUILD]}?` + `)?)?`);
createToken("XRANGEPLAINLOOSE", `[v=\\s]*(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:${src[t.PRERELEASELOOSE]})?${src[t.BUILD]}?` + `)?)?`);
createToken("XRANGE", `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAIN]}$`);
createToken("XRANGELOOSE", `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAINLOOSE]}$`);
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
createToken("COERCEPLAIN", `${"(^|[^\\d])(\\d{1,"}${$51f436f817307279$require$MAX_SAFE_COMPONENT_LENGTH}})` + `(?:\\.(\\d{1,${$51f436f817307279$require$MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:\\.(\\d{1,${$51f436f817307279$require$MAX_SAFE_COMPONENT_LENGTH}}))?`);
createToken("COERCE", `${src[t.COERCEPLAIN]}(?:$|[^\\d])`);
createToken("COERCEFULL", src[t.COERCEPLAIN] + `(?:${src[t.PRERELEASE]})?` + `(?:${src[t.BUILD]})?` + `(?:$|[^\\d])`);
createToken("COERCERTL", src[t.COERCE], true);
createToken("COERCERTLFULL", src[t.COERCEFULL], true);
// Tilde ranges.
// Meaning is "reasonably at or greater than"
createToken("LONETILDE", "(?:~>?)");
createToken("TILDETRIM", `(\\s*)${src[t.LONETILDE]}\\s+`, true);
exports.tildeTrimReplace = "$1~";
createToken("TILDE", `^${src[t.LONETILDE]}${src[t.XRANGEPLAIN]}$`);
createToken("TILDELOOSE", `^${src[t.LONETILDE]}${src[t.XRANGEPLAINLOOSE]}$`);
// Caret ranges.
// Meaning is "at least and backwards compatible with"
createToken("LONECARET", "(?:\\^)");
createToken("CARETTRIM", `(\\s*)${src[t.LONECARET]}\\s+`, true);
exports.caretTrimReplace = "$1^";
createToken("CARET", `^${src[t.LONECARET]}${src[t.XRANGEPLAIN]}$`);
createToken("CARETLOOSE", `^${src[t.LONECARET]}${src[t.XRANGEPLAINLOOSE]}$`);
// A simple gt/lt/eq thing, or just "" to indicate "any version"
createToken("COMPARATORLOOSE", `^${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]})$|^$`);
createToken("COMPARATOR", `^${src[t.GTLT]}\\s*(${src[t.FULLPLAIN]})$|^$`);
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
createToken("COMPARATORTRIM", `(\\s*)${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]}|${src[t.XRANGEPLAIN]})`, true);
exports.comparatorTrimReplace = "$1$2$3";
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
createToken("HYPHENRANGE", `^\\s*(${src[t.XRANGEPLAIN]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAIN]})` + `\\s*$`);
createToken("HYPHENRANGELOOSE", `^\\s*(${src[t.XRANGEPLAINLOOSE]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAINLOOSE]})` + `\\s*$`);
// Star ranges basically just allow anything at all.
createToken("STAR", "(<|>)?=?\\s*\\*");
// >=0.0.0 is like a star
createToken("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$");
createToken("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");

});
parcelRegister("7dGQP", function(module, exports) {
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
const $541afc9df911c34e$var$SEMVER_SPEC_VERSION = "2.0.0";
const $541afc9df911c34e$var$MAX_LENGTH = 256;
const $541afc9df911c34e$var$MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
const $541afc9df911c34e$var$MAX_SAFE_COMPONENT_LENGTH = 16;
// Max safe length for a build identifier. The max length minus 6 characters for
// the shortest version with a build 0.0.0+BUILD.
const $541afc9df911c34e$var$MAX_SAFE_BUILD_LENGTH = $541afc9df911c34e$var$MAX_LENGTH - 6;
const $541afc9df911c34e$var$RELEASE_TYPES = [
    "major",
    "premajor",
    "minor",
    "preminor",
    "patch",
    "prepatch",
    "prerelease"
];
module.exports = {
    MAX_LENGTH: $541afc9df911c34e$var$MAX_LENGTH,
    MAX_SAFE_COMPONENT_LENGTH: $541afc9df911c34e$var$MAX_SAFE_COMPONENT_LENGTH,
    MAX_SAFE_BUILD_LENGTH: $541afc9df911c34e$var$MAX_SAFE_BUILD_LENGTH,
    MAX_SAFE_INTEGER: $541afc9df911c34e$var$MAX_SAFE_INTEGER,
    RELEASE_TYPES: $541afc9df911c34e$var$RELEASE_TYPES,
    SEMVER_SPEC_VERSION: $541afc9df911c34e$var$SEMVER_SPEC_VERSION,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
};

});

parcelRegister("kaZvw", function(module, exports) {

var $6qd2L = parcelRequire("6qd2L");
const $eb0473e70cfe57db$var$debug = (typeof $6qd2L === "object" && $6qd2L.env && undefined, ()=>{});
module.exports = $eb0473e70cfe57db$var$debug;

});
parcelRegister("6qd2L", function(module, exports) {
// shim for using process in browser
var $4acf49f6c3e67aec$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4acf49f6c3e67aec$var$cachedSetTimeout;
var $4acf49f6c3e67aec$var$cachedClearTimeout;
function $4acf49f6c3e67aec$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $4acf49f6c3e67aec$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        else $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        else $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    }
})();
function $4acf49f6c3e67aec$var$runTimeout(fun) {
    if ($4acf49f6c3e67aec$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedSetTimeout === $4acf49f6c3e67aec$var$defaultSetTimout || !$4acf49f6c3e67aec$var$cachedSetTimeout) && setTimeout) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4acf49f6c3e67aec$var$runClearTimeout(marker) {
    if ($4acf49f6c3e67aec$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedClearTimeout === $4acf49f6c3e67aec$var$defaultClearTimeout || !$4acf49f6c3e67aec$var$cachedClearTimeout) && clearTimeout) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4acf49f6c3e67aec$var$queue = [];
var $4acf49f6c3e67aec$var$draining = false;
var $4acf49f6c3e67aec$var$currentQueue;
var $4acf49f6c3e67aec$var$queueIndex = -1;
function $4acf49f6c3e67aec$var$cleanUpNextTick() {
    if (!$4acf49f6c3e67aec$var$draining || !$4acf49f6c3e67aec$var$currentQueue) return;
    $4acf49f6c3e67aec$var$draining = false;
    if ($4acf49f6c3e67aec$var$currentQueue.length) $4acf49f6c3e67aec$var$queue = $4acf49f6c3e67aec$var$currentQueue.concat($4acf49f6c3e67aec$var$queue);
    else $4acf49f6c3e67aec$var$queueIndex = -1;
    if ($4acf49f6c3e67aec$var$queue.length) $4acf49f6c3e67aec$var$drainQueue();
}
function $4acf49f6c3e67aec$var$drainQueue() {
    if ($4acf49f6c3e67aec$var$draining) return;
    var timeout = $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$cleanUpNextTick);
    $4acf49f6c3e67aec$var$draining = true;
    var len = $4acf49f6c3e67aec$var$queue.length;
    while(len){
        $4acf49f6c3e67aec$var$currentQueue = $4acf49f6c3e67aec$var$queue;
        $4acf49f6c3e67aec$var$queue = [];
        while(++$4acf49f6c3e67aec$var$queueIndex < len)if ($4acf49f6c3e67aec$var$currentQueue) $4acf49f6c3e67aec$var$currentQueue[$4acf49f6c3e67aec$var$queueIndex].run();
        $4acf49f6c3e67aec$var$queueIndex = -1;
        len = $4acf49f6c3e67aec$var$queue.length;
    }
    $4acf49f6c3e67aec$var$currentQueue = null;
    $4acf49f6c3e67aec$var$draining = false;
    $4acf49f6c3e67aec$var$runClearTimeout(timeout);
}
$4acf49f6c3e67aec$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4acf49f6c3e67aec$var$queue.push(new $4acf49f6c3e67aec$var$Item(fun, args));
    if ($4acf49f6c3e67aec$var$queue.length === 1 && !$4acf49f6c3e67aec$var$draining) $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$drainQueue);
};
// v8 likes predictible objects
function $4acf49f6c3e67aec$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4acf49f6c3e67aec$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4acf49f6c3e67aec$var$process.title = "browser";
$4acf49f6c3e67aec$var$process.browser = true;
$4acf49f6c3e67aec$var$process.env = {};
$4acf49f6c3e67aec$var$process.argv = [];
$4acf49f6c3e67aec$var$process.version = ""; // empty string to avoid regexp issues
$4acf49f6c3e67aec$var$process.versions = {};
function $4acf49f6c3e67aec$var$noop() {}
$4acf49f6c3e67aec$var$process.on = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.addListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.once = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.off = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeAllListeners = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.emit = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependOnceListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.listeners = function(name) {
    return [];
};
$4acf49f6c3e67aec$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$4acf49f6c3e67aec$var$process.cwd = function() {
    return "/";
};
$4acf49f6c3e67aec$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$4acf49f6c3e67aec$var$process.umask = function() {
    return 0;
};

});



parcelRegister("jVFZf", function(module, exports) {
"use strict";
// This file was originally written by @drudru (https://github.com/drudru/ansi_up), MIT, 2011
var $e823e8e5b4ee035b$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $e823e8e5b4ee035b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $e823e8e5b4ee035b$var$ANSI_COLORS = [
    [
        {
            color: "0, 0, 0",
            "class": "ansi-black"
        },
        {
            color: "187, 0, 0",
            "class": "ansi-red"
        },
        {
            color: "0, 187, 0",
            "class": "ansi-green"
        },
        {
            color: "187, 187, 0",
            "class": "ansi-yellow"
        },
        {
            color: "0, 0, 187",
            "class": "ansi-blue"
        },
        {
            color: "187, 0, 187",
            "class": "ansi-magenta"
        },
        {
            color: "0, 187, 187",
            "class": "ansi-cyan"
        },
        {
            color: "255,255,255",
            "class": "ansi-white"
        }
    ],
    [
        {
            color: "85, 85, 85",
            "class": "ansi-bright-black"
        },
        {
            color: "255, 85, 85",
            "class": "ansi-bright-red"
        },
        {
            color: "0, 255, 0",
            "class": "ansi-bright-green"
        },
        {
            color: "255, 255, 85",
            "class": "ansi-bright-yellow"
        },
        {
            color: "85, 85, 255",
            "class": "ansi-bright-blue"
        },
        {
            color: "255, 85, 255",
            "class": "ansi-bright-magenta"
        },
        {
            color: "85, 255, 255",
            "class": "ansi-bright-cyan"
        },
        {
            color: "255, 255, 255",
            "class": "ansi-bright-white"
        }
    ]
];
var $e823e8e5b4ee035b$var$Anser = function() {
    $e823e8e5b4ee035b$var$_createClass(Anser, null, [
        {
            key: "escapeForHtml",
            /**
         * Anser.escapeForHtml
         * Escape the input HTML.
         *
         * This does the minimum escaping of text to make it compliant with HTML.
         * In particular, the '&','<', and '>' characters are escaped. This should
         * be run prior to `ansiToHtml`.
         *
         * @name Anser.escapeForHtml
         * @function
         * @param {String} txt The input text (containing the ANSI snippets).
         * @returns {String} The escaped html.
         */ value: function escapeForHtml(txt) {
                return new Anser().escapeForHtml(txt);
            }
        },
        {
            key: "linkify",
            value: function linkify(txt) {
                return new Anser().linkify(txt);
            }
        },
        {
            key: "ansiToHtml",
            value: function ansiToHtml(txt, options) {
                return new Anser().ansiToHtml(txt, options);
            }
        },
        {
            key: "ansiToJson",
            value: function ansiToJson(txt, options) {
                return new Anser().ansiToJson(txt, options);
            }
        },
        {
            key: "ansiToText",
            value: function ansiToText(txt) {
                return new Anser().ansiToText(txt);
            }
        }
    ]);
    function Anser() {
        $e823e8e5b4ee035b$var$_classCallCheck(this, Anser);
        this.fg = this.bg = this.fg_truecolor = this.bg_truecolor = null;
        this.bright = 0;
        this.decorations = [];
    }
    /**
     * setupPalette
     * Sets up the palette.
     *
     * @name setupPalette
     * @function
     */ $e823e8e5b4ee035b$var$_createClass(Anser, [
        {
            key: "setupPalette",
            value: function setupPalette() {
                this.PALETTE_COLORS = [];
                // Index 0..15 : System color
                for(var i = 0; i < 2; ++i)for(var j = 0; j < 8; ++j)this.PALETTE_COLORS.push($e823e8e5b4ee035b$var$ANSI_COLORS[i][j].color);
                // Index 16..231 : RGB 6x6x6
                // https://gist.github.com/jasonm23/2868981#file-xterm-256color-yaml
                var levels = [
                    0,
                    95,
                    135,
                    175,
                    215,
                    255
                ];
                var format = function format(r, g, b) {
                    return levels[r] + ", " + levels[g] + ", " + levels[b];
                };
                var r = void 0, g = void 0, b = void 0;
                for(var _r = 0; _r < 6; ++_r){
                    for(var _g = 0; _g < 6; ++_g)for(var _b = 0; _b < 6; ++_b)this.PALETTE_COLORS.push(format(_r, _g, _b));
                }
                // Index 232..255 : Grayscale
                var level = 8;
                for(var _i = 0; _i < 24; ++_i, level += 10)this.PALETTE_COLORS.push(format(level, level, level));
            }
        },
        {
            key: "escapeForHtml",
            value: function escapeForHtml(txt) {
                return txt.replace(/[&<>\"]/gm, function(str) {
                    return str == "&" ? "&amp;" : str == '"' ? "&quot;" : str == "<" ? "&lt;" : str == ">" ? "&gt;" : "";
                });
            }
        },
        {
            key: "linkify",
            value: function linkify(txt) {
                return txt.replace(/(https?:\/\/[^\s]+)/gm, function(str) {
                    return '<a href="' + str + '">' + str + "</a>";
                });
            }
        },
        {
            key: "ansiToHtml",
            value: function ansiToHtml(txt, options) {
                return this.process(txt, options, true);
            }
        },
        {
            key: "ansiToJson",
            value: function ansiToJson(txt, options) {
                options = options || {};
                options.json = true;
                options.clearLine = false;
                return this.process(txt, options, true);
            }
        },
        {
            key: "ansiToText",
            value: function ansiToText(txt) {
                return this.process(txt, {}, false);
            }
        },
        {
            key: "process",
            value: function process(txt, options, markup) {
                var _this = this;
                var self = this;
                var raw_text_chunks = txt.split(/\033\[/);
                var first_chunk = raw_text_chunks.shift(); // the first chunk is not the result of the split
                if (options === undefined || options === null) options = {};
                options.clearLine = /\r/.test(txt); // check for Carriage Return
                var color_chunks = raw_text_chunks.map(function(chunk) {
                    return _this.processChunk(chunk, options, markup);
                });
                if (options && options.json) {
                    var first = self.processChunkJson("");
                    first.content = first_chunk;
                    first.clearLine = options.clearLine;
                    color_chunks.unshift(first);
                    if (options.remove_empty) color_chunks = color_chunks.filter(function(c) {
                        return !c.isEmpty();
                    });
                    return color_chunks;
                } else color_chunks.unshift(first_chunk);
                return color_chunks.join("");
            }
        },
        {
            key: "processChunkJson",
            value: function processChunkJson(text, options, markup) {
                // Are we using classes or styles?
                options = typeof options == "undefined" ? {} : options;
                var use_classes = options.use_classes = typeof options.use_classes != "undefined" && options.use_classes;
                var key = options.key = use_classes ? "class" : "color";
                var result = {
                    content: text,
                    fg: null,
                    bg: null,
                    fg_truecolor: null,
                    bg_truecolor: null,
                    isInverted: false,
                    clearLine: options.clearLine,
                    decoration: null,
                    decorations: [],
                    was_processed: false,
                    isEmpty: function isEmpty() {
                        return !result.content;
                    }
                };
                // Each "chunk" is the text after the CSI (ESC + "[") and before the next CSI/EOF.
                //
                // This regex matches four groups within a chunk.
                //
                // The first and third groups match code type.
                // We supported only SGR command. It has empty first group and "m" in third.
                //
                // The second group matches all of the number+semicolon command sequences
                // before the "m" (or other trailing) character.
                // These are the graphics or SGR commands.
                //
                // The last group is the text (including newlines) that is colored by
                // the other group"s commands.
                var matches = text.match(/^([!\x3c-\x3f]*)([\d;]*)([\x20-\x2c]*[\x40-\x7e])([\s\S]*)/m);
                if (!matches) return result;
                var orig_txt = result.content = matches[4];
                var nums = matches[2].split(";");
                // We currently support only "SGR" (Select Graphic Rendition)
                // Simply ignore if not a SGR command.
                if (matches[1] !== "" || matches[3] !== "m") return result;
                if (!markup) return result;
                var self = this;
                while(nums.length > 0){
                    var num_str = nums.shift();
                    var num = parseInt(num_str);
                    if (isNaN(num) || num === 0) {
                        self.fg = self.bg = null;
                        self.decorations = [];
                    } else if (num === 1) self.decorations.push("bold");
                    else if (num === 2) self.decorations.push("dim");
                    else if (num === 3) self.decorations.push("italic");
                    else if (num === 4) self.decorations.push("underline");
                    else if (num === 5) self.decorations.push("blink");
                    else if (num === 7) self.decorations.push("reverse");
                    else if (num === 8) self.decorations.push("hidden");
                    else if (num === 9) self.decorations.push("strikethrough");
                    else if (num === 21) self.removeDecoration("bold");
                    else if (num === 22) {
                        self.removeDecoration("bold");
                        self.removeDecoration("dim");
                    } else if (num === 23) self.removeDecoration("italic");
                    else if (num === 24) self.removeDecoration("underline");
                    else if (num === 25) self.removeDecoration("blink");
                    else if (num === 27) self.removeDecoration("reverse");
                    else if (num === 28) self.removeDecoration("hidden");
                    else if (num === 29) self.removeDecoration("strikethrough");
                    else if (num === 39) self.fg = null;
                    else if (num === 49) self.bg = null;
                    else if (num >= 30 && num < 38) self.fg = $e823e8e5b4ee035b$var$ANSI_COLORS[0][num % 10][key];
                    else if (num >= 90 && num < 98) self.fg = $e823e8e5b4ee035b$var$ANSI_COLORS[1][num % 10][key];
                    else if (num >= 40 && num < 48) self.bg = $e823e8e5b4ee035b$var$ANSI_COLORS[0][num % 10][key];
                    else if (num >= 100 && num < 108) self.bg = $e823e8e5b4ee035b$var$ANSI_COLORS[1][num % 10][key];
                    else if (num === 38 || num === 48) {
                        // extend color (38=fg, 48=bg)
                        var is_foreground = num === 38;
                        if (nums.length >= 1) {
                            var mode = nums.shift();
                            if (mode === "5" && nums.length >= 1) {
                                // palette color
                                var palette_index = parseInt(nums.shift());
                                if (palette_index >= 0 && palette_index <= 255) {
                                    if (!use_classes) {
                                        if (!this.PALETTE_COLORS) self.setupPalette();
                                        if (is_foreground) self.fg = this.PALETTE_COLORS[palette_index];
                                        else self.bg = this.PALETTE_COLORS[palette_index];
                                    } else {
                                        var klass = palette_index >= 16 ? "ansi-palette-" + palette_index : $e823e8e5b4ee035b$var$ANSI_COLORS[palette_index > 7 ? 1 : 0][palette_index % 8]["class"];
                                        if (is_foreground) self.fg = klass;
                                        else self.bg = klass;
                                    }
                                }
                            } else if (mode === "2" && nums.length >= 3) {
                                // true color
                                var r = parseInt(nums.shift());
                                var g = parseInt(nums.shift());
                                var b = parseInt(nums.shift());
                                if (r >= 0 && r <= 255 && g >= 0 && g <= 255 && b >= 0 && b <= 255) {
                                    var color = r + ", " + g + ", " + b;
                                    if (!use_classes) {
                                        if (is_foreground) self.fg = color;
                                        else self.bg = color;
                                    } else if (is_foreground) {
                                        self.fg = "ansi-truecolor";
                                        self.fg_truecolor = color;
                                    } else {
                                        self.bg = "ansi-truecolor";
                                        self.bg_truecolor = color;
                                    }
                                }
                            }
                        }
                    }
                }
                if (self.fg === null && self.bg === null && self.decorations.length === 0) return result;
                else {
                    var styles = [];
                    var classes = [];
                    var data = {};
                    result.fg = self.fg;
                    result.bg = self.bg;
                    result.fg_truecolor = self.fg_truecolor;
                    result.bg_truecolor = self.bg_truecolor;
                    result.decorations = self.decorations;
                    result.decoration = self.decorations.slice(-1).pop() || null;
                    result.was_processed = true;
                    return result;
                }
            }
        },
        {
            key: "processChunk",
            value: function processChunk(text, options, markup) {
                var _this2 = this;
                options = options || {};
                var jsonChunk = this.processChunkJson(text, options, markup);
                var use_classes = options.use_classes;
                // "reverse" decoration reverses foreground and background colors
                jsonChunk.decorations = jsonChunk.decorations.filter(function(decoration) {
                    if (decoration === "reverse") {
                        // when reversing, missing colors are defaulted to black (bg) and white (fg)
                        if (!jsonChunk.fg) jsonChunk.fg = $e823e8e5b4ee035b$var$ANSI_COLORS[0][7][use_classes ? "class" : "color"];
                        if (!jsonChunk.bg) jsonChunk.bg = $e823e8e5b4ee035b$var$ANSI_COLORS[0][0][use_classes ? "class" : "color"];
                        var tmpFg = jsonChunk.fg;
                        jsonChunk.fg = jsonChunk.bg;
                        jsonChunk.bg = tmpFg;
                        var tmpFgTrue = jsonChunk.fg_truecolor;
                        jsonChunk.fg_truecolor = jsonChunk.bg_truecolor;
                        jsonChunk.bg_truecolor = tmpFgTrue;
                        jsonChunk.isInverted = true;
                        return false;
                    }
                    return true;
                });
                if (options.json) return jsonChunk;
                if (jsonChunk.isEmpty()) return "";
                if (!jsonChunk.was_processed) return jsonChunk.content;
                var colors = [];
                var decorations = [];
                var textDecorations = [];
                var data = {};
                var render_data = function render_data(data) {
                    var fragments = [];
                    var key = void 0;
                    for(key in data)if (data.hasOwnProperty(key)) fragments.push("data-" + key + '="' + _this2.escapeForHtml(data[key]) + '"');
                    return fragments.length > 0 ? " " + fragments.join(" ") : "";
                };
                if (jsonChunk.isInverted) data["ansi-is-inverted"] = "true";
                if (jsonChunk.fg) {
                    if (use_classes) {
                        colors.push(jsonChunk.fg + "-fg");
                        if (jsonChunk.fg_truecolor !== null) {
                            data["ansi-truecolor-fg"] = jsonChunk.fg_truecolor;
                            jsonChunk.fg_truecolor = null;
                        }
                    } else colors.push("color:rgb(" + jsonChunk.fg + ")");
                }
                if (jsonChunk.bg) {
                    if (use_classes) {
                        colors.push(jsonChunk.bg + "-bg");
                        if (jsonChunk.bg_truecolor !== null) {
                            data["ansi-truecolor-bg"] = jsonChunk.bg_truecolor;
                            jsonChunk.bg_truecolor = null;
                        }
                    } else colors.push("background-color:rgb(" + jsonChunk.bg + ")");
                }
                jsonChunk.decorations.forEach(function(decoration) {
                    // use classes
                    if (use_classes) {
                        decorations.push("ansi-" + decoration);
                        return;
                    }
                    // use styles
                    if (decoration === "bold") decorations.push("font-weight:bold");
                    else if (decoration === "dim") decorations.push("opacity:0.5");
                    else if (decoration === "italic") decorations.push("font-style:italic");
                    else if (decoration === "hidden") decorations.push("visibility:hidden");
                    else if (decoration === "strikethrough") textDecorations.push("line-through");
                    else // underline and blink are treated here
                    textDecorations.push(decoration);
                });
                if (textDecorations.length) decorations.push("text-decoration:" + textDecorations.join(" "));
                if (use_classes) return '<span class="' + colors.concat(decorations).join(" ") + '"' + render_data(data) + ">" + jsonChunk.content + "</span>";
                else return '<span style="' + colors.concat(decorations).join(";") + '"' + render_data(data) + ">" + jsonChunk.content + "</span>";
            }
        },
        {
            key: "removeDecoration",
            value: function removeDecoration(decoration) {
                var index = this.decorations.indexOf(decoration);
                if (index >= 0) this.decorations.splice(index, 1);
            }
        }
    ]);
    return Anser;
}();
module.exports = $e823e8e5b4ee035b$var$Anser;

});

parcelRegister("1tQWc", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "darker", function () { return darker; });
$parcel$export(module.exports, "brighter", function () { return brighter; });
$parcel$export(module.exports, "default", function () { return color; });
$parcel$export(module.exports, "hslConvert", function () { return hslConvert; });
$parcel$export(module.exports, "Rgb", function () { return Rgb; });
$parcel$export(module.exports, "rgbConvert", function () { return rgbConvert; });
$parcel$export(module.exports, "rgb", function () { return rgb; });
$parcel$export(module.exports, "hsl", function () { return hsl; });

var $imKCb = parcelRequire("imKCb");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $imKCb.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $imKCb.default)(Rgb, rgb, (0, $imKCb.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $imKCb.default)(Hsl, hsl, (0, $imKCb.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("imKCb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5ee70cd754aa323$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $d5ee70cd754aa323$export$8b58be045bf06082; });
function $d5ee70cd754aa323$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $d5ee70cd754aa323$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("dYto6", function(module, exports) {

$parcel$export(module.exports, "point", function () { return point; });
$parcel$export(module.exports, "default", function () { return $a2c7acbb2a027d43$export$2e2bcd8739ae039; });

var $4yPBQ = parcelRequire("4yPBQ");

var $emMsn = parcelRequire("emMsn");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, $4yPBQ.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, $4yPBQ.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $a2c7acbb2a027d43$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, $emMsn.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});
parcelRegister("4yPBQ", function(module, exports) {

$parcel$export(module.exports, "cos", function () { return $35225ef339569c07$export$50d414a77b60d802; });
$parcel$export(module.exports, "min", function () { return $35225ef339569c07$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "sin", function () { return $35225ef339569c07$export$5de3937cb4b592ed; });
$parcel$export(module.exports, "sqrt", function () { return $35225ef339569c07$export$eba8049fb5020b81; });
$parcel$export(module.exports, "epsilon", function () { return $35225ef339569c07$export$6c421550c66a327d; });
$parcel$export(module.exports, "pi", function () { return $35225ef339569c07$export$18c7bea995a110f; });
$parcel$export(module.exports, "tau", function () { return $35225ef339569c07$export$a4b4b4d4d776fe92; });
const $35225ef339569c07$export$2335f513bbd82c6d = Math.abs;
const $35225ef339569c07$export$b8b770ee6a0d9760 = Math.atan2;
const $35225ef339569c07$export$50d414a77b60d802 = Math.cos;
const $35225ef339569c07$export$8960430cfd85939f = Math.max;
const $35225ef339569c07$export$96ec731ed4dcb222 = Math.min;
const $35225ef339569c07$export$5de3937cb4b592ed = Math.sin;
const $35225ef339569c07$export$eba8049fb5020b81 = Math.sqrt;
const $35225ef339569c07$export$6c421550c66a327d = 1e-12;
const $35225ef339569c07$export$18c7bea995a110f = Math.PI;
const $35225ef339569c07$export$e51408a300e8929a = $35225ef339569c07$export$18c7bea995a110f / 2;
const $35225ef339569c07$export$a4b4b4d4d776fe92 = 2 * $35225ef339569c07$export$18c7bea995a110f;
function $35225ef339569c07$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $35225ef339569c07$export$18c7bea995a110f : Math.acos(x);
}
function $35225ef339569c07$export$41726bdb1fc63f(x) {
    return x >= 1 ? $35225ef339569c07$export$e51408a300e8929a : x <= -1 ? -$35225ef339569c07$export$e51408a300e8929a : Math.asin(x);
}

});

parcelRegister("emMsn", function(module, exports) {

$parcel$export(module.exports, "point", function () { return $a758b53c9d8352e2$export$105684a3041cb6f3; });
$parcel$export(module.exports, "Cardinal", function () { return $a758b53c9d8352e2$export$ee51ff373511cbeb; });
$parcel$export(module.exports, "default", function () { return $a758b53c9d8352e2$export$2e2bcd8739ae039; });
function $a758b53c9d8352e2$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $a758b53c9d8352e2$export$ee51ff373511cbeb(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$a758b53c9d8352e2$export$ee51ff373511cbeb.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $a758b53c9d8352e2$export$105684a3041cb6f3(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                $a758b53c9d8352e2$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $a758b53c9d8352e2$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $a758b53c9d8352e2$export$ee51ff373511cbeb(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});


parcelRegister("4vs1M", function(module, exports) {

var $8ThvE = parcelRequire("8ThvE");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $8ThvE.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});
parcelRegister("8ThvE", function(module, exports) {

var $lyxRX = parcelRequire("lyxRX");
/** Detect free variable `self`. */ var $67910ad3df1b1086$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $67910ad3df1b1086$var$root = $lyxRX || $67910ad3df1b1086$var$freeSelf || Function("return this")();
module.exports = $67910ad3df1b1086$var$root;

});
parcelRegister("lyxRX", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $fb170ba8a9c2191f$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $fb170ba8a9c2191f$var$freeGlobal;

});



parcelRegister("7HKs8", function(module, exports) {

var $8ThvE = parcelRequire("8ThvE");

var $jjS2x = parcelRequire("jjS2x");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $8ThvE.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $jjS2x;
module.exports = isBuffer;

});
parcelRegister("jjS2x", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $e109b5e12b59d0d6$var$stubFalse() {
    return false;
}
module.exports = $e109b5e12b59d0d6$var$stubFalse;

});


parcelRegister("7vc1R", function(module, exports) {

var $lyxRX = parcelRequire("lyxRX");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $lyxRX.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("bisEj", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $839799496b62fb71$var$ReactIs, $839799496b62fb71$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("jpdgm"))();

});


var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");
var $7bd215913159ea08$export$882461b6382ed46c;
var $7bd215913159ea08$export$757ceba2d55c277e;
"use strict";
var $97dc602bd7e23afa$exports = {};
"use strict";
function $97dc602bd7e23afa$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($97dc602bd7e23afa$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$97dc602bd7e23afa$var$checkDCE();

$97dc602bd7e23afa$exports = (parcelRequire("h8vP0"));


var $7bd215913159ea08$var$i;
$7bd215913159ea08$export$882461b6382ed46c = $97dc602bd7e23afa$exports.createRoot;
$7bd215913159ea08$export$757ceba2d55c277e = $97dc602bd7e23afa$exports.hydrateRoot;



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $7PWLt = parcelRequire("7PWLt");

var $aJx1R = parcelRequire("aJx1R");
parcelRequire("exYeM");

parcelRequire("exYeM");


var $cXmXD = parcelRequire("cXmXD");

var $8IwTu = parcelRequire("8IwTu");

var $aSiaI = parcelRequire("aSiaI");
"use client";
function $d65cb028dbe61145$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $8IwTu.default)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cXmXD.default), {
        styles: globalStyles
    });
}
var $d65cb028dbe61145$export$2e2bcd8739ae039 = $d65cb028dbe61145$var$GlobalStyles;



var $5n7Fs = parcelRequire("5n7Fs");

var $pePt2 = parcelRequire("pePt2");

var $aSiaI = parcelRequire("aSiaI");
"use client";
function $4c9e7d92b5ff7371$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d65cb028dbe61145$export$2e2bcd8739ae039), (0, $aJx1R.default)({}, props, {
        defaultTheme: (0, $5n7Fs.default),
        themeId: (0, $pePt2.default)
    }));
}
var $4c9e7d92b5ff7371$export$2e2bcd8739ae039 = $4c9e7d92b5ff7371$var$GlobalStyles;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $3cdc7b4c43f973c1$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>(0, $aJx1R.default)({
        WebkitFontSmoothing: "antialiased",
        // Antialiasing.
        MozOsxFontSmoothing: "grayscale",
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: "border-box",
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: "100%"
    }, enableColorScheme && !theme.vars && {
        colorScheme: theme.palette.mode
    });
const $3cdc7b4c43f973c1$export$32180ef41b15b513 = (theme)=>(0, $aJx1R.default)({
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.default,
        "@media print": {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $3cdc7b4c43f973c1$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    var _theme$components;
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, "")] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    let defaultStyles = (0, $aJx1R.default)({
        html: $3cdc7b4c43f973c1$export$c0bb0b647f701bb5(theme, enableColorScheme),
        "*, *::before, *::after": {
            boxSizing: "inherit"
        },
        "strong, b": {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, $aJx1R.default)({
            margin: 0
        }, $3cdc7b4c43f973c1$export$32180ef41b15b513(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            "&::backdrop": {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        })
    }, colorSchemeStyles);
    const themeOverrides = (_theme$components = theme.components) == null || (_theme$components = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $3cdc7b4c43f973c1$var$CssBaseline(inProps) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiCssBaseline"
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4c9e7d92b5ff7371$export$2e2bcd8739ae039), {
                styles: (theme)=>$3cdc7b4c43f973c1$export$9dd6ff9ea0189349(theme, enableColorScheme)
            }),
            children
        ]
    });
}
var $3cdc7b4c43f973c1$export$2e2bcd8739ae039 = $3cdc7b4c43f973c1$var$CssBaseline;



var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");
/**
 * React Router DOM v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $exYeM = parcelRequire("exYeM");

/**
 * @remix-run/router v1.15.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $d09e32d367368ff7$var$_extends() {
    $d09e32d367368ff7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d09e32d367368ff7$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $d09e32d367368ff7$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($d09e32d367368ff7$export$e19cd5f9376f8cee || ($d09e32d367368ff7$export$e19cd5f9376f8cee = {}));
const $d09e32d367368ff7$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $d09e32d367368ff7$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $d09e32d367368ff7$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $d09e32d367368ff7$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $d09e32d367368ff7$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $d09e32d367368ff7$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $d09e32d367368ff7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $d09e32d367368ff7$export$fe53371bee54353d(to);
    }
    return $d09e32d367368ff7$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $d09e32d367368ff7$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $d09e32d367368ff7$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $d09e32d367368ff7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $d09e32d367368ff7$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $d09e32d367368ff7$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $d09e32d367368ff7$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $d09e32d367368ff7$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $d09e32d367368ff7$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $d09e32d367368ff7$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $d09e32d367368ff7$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $d09e32d367368ff7$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $d09e32d367368ff7$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $d09e32d367368ff7$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $d09e32d367368ff7$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $d09e32d367368ff7$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $d09e32d367368ff7$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($d09e32d367368ff7$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
        let location = $d09e32d367368ff7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $d09e32d367368ff7$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace;
        let location = $d09e32d367368ff7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $d09e32d367368ff7$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $d09e32d367368ff7$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $d09e32d367368ff7$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($d09e32d367368ff7$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($d09e32d367368ff7$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $d09e32d367368ff7$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($d09e32d367368ff7$var$ResultType || ($d09e32d367368ff7$var$ResultType = {}));
const $d09e32d367368ff7$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $d09e32d367368ff7$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $d09e32d367368ff7$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $d09e32d367368ff7$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $d09e32d367368ff7$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($d09e32d367368ff7$var$isIndexRoute(route)) {
            let indexRoute = $d09e32d367368ff7$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $d09e32d367368ff7$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $d09e32d367368ff7$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $d09e32d367368ff7$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $d09e32d367368ff7$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $d09e32d367368ff7$var$flattenRoutes(routes);
    $d09e32d367368ff7$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $d09e32d367368ff7$var$decodePath(pathname);
        matches = $d09e32d367368ff7$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $d09e32d367368ff7$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $d09e32d367368ff7$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $d09e32d367368ff7$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $d09e32d367368ff7$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $d09e32d367368ff7$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $d09e32d367368ff7$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $d09e32d367368ff7$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $d09e32d367368ff7$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $d09e32d367368ff7$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $d09e32d367368ff7$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $d09e32d367368ff7$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $d09e32d367368ff7$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $d09e32d367368ff7$var$paramRe = /^:[\w-]+$/;
const $d09e32d367368ff7$var$dynamicSegmentValue = 3;
const $d09e32d367368ff7$var$indexRouteValue = 2;
const $d09e32d367368ff7$var$emptySegmentValue = 1;
const $d09e32d367368ff7$var$staticSegmentValue = 10;
const $d09e32d367368ff7$var$splatPenalty = -2;
const $d09e32d367368ff7$var$isSplat = (s)=>s === "*";
function $d09e32d367368ff7$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($d09e32d367368ff7$var$isSplat)) initialScore += $d09e32d367368ff7$var$splatPenalty;
    if (index) initialScore += $d09e32d367368ff7$var$indexRouteValue;
    return segments.filter((s)=>!$d09e32d367368ff7$var$isSplat(s)).reduce((score, segment)=>score + ($d09e32d367368ff7$var$paramRe.test(segment) ? $d09e32d367368ff7$var$dynamicSegmentValue : segment === "" ? $d09e32d367368ff7$var$emptySegmentValue : $d09e32d367368ff7$var$staticSegmentValue), initialScore);
}
function $d09e32d367368ff7$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $d09e32d367368ff7$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $d09e32d367368ff7$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $d09e32d367368ff7$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $d09e32d367368ff7$export$a5c6d149b50c1d86($d09e32d367368ff7$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $d09e32d367368ff7$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $d09e32d367368ff7$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $d09e32d367368ff7$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $d09e32d367368ff7$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $d09e32d367368ff7$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $d09e32d367368ff7$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $d09e32d367368ff7$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $d09e32d367368ff7$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $d09e32d367368ff7$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $d09e32d367368ff7$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $d09e32d367368ff7$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $d09e32d367368ff7$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $d09e32d367368ff7$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $d09e32d367368ff7$var$normalizeSearch(search),
        hash: $d09e32d367368ff7$var$normalizeHash(hash)
    };
}
function $d09e32d367368ff7$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $d09e32d367368ff7$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $d09e32d367368ff7$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $d09e32d367368ff7$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $d09e32d367368ff7$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $d09e32d367368ff7$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $d09e32d367368ff7$export$8ccf933b0513f8d0(toArg);
    else {
        to = $d09e32d367368ff7$var$_extends({}, toArg);
        $d09e32d367368ff7$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $d09e32d367368ff7$var$getInvalidPathError("?", "pathname", "search", to));
        $d09e32d367368ff7$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $d09e32d367368ff7$var$getInvalidPathError("#", "pathname", "hash", to));
        $d09e32d367368ff7$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $d09e32d367368ff7$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $d09e32d367368ff7$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $d09e32d367368ff7$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $d09e32d367368ff7$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $d09e32d367368ff7$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $d09e32d367368ff7$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $d09e32d367368ff7$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $d09e32d367368ff7$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $d09e32d367368ff7$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $d09e32d367368ff7$export$42a99a7a4bc0e76a extends Error {
}
class $d09e32d367368ff7$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $d09e32d367368ff7$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $d09e32d367368ff7$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $d09e32d367368ff7$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $d09e32d367368ff7$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $d09e32d367368ff7$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $d09e32d367368ff7$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $d09e32d367368ff7$var$unwrapTrackedPromise(value) {
    if (!$d09e32d367368ff7$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $d09e32d367368ff7$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $d09e32d367368ff7$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $d09e32d367368ff7$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $d09e32d367368ff7$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $d09e32d367368ff7$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $d09e32d367368ff7$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $d09e32d367368ff7$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $d09e32d367368ff7$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $d09e32d367368ff7$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $d09e32d367368ff7$var$validMutationMethods = new Set($d09e32d367368ff7$var$validMutationMethodsArr);
const $d09e32d367368ff7$var$validRequestMethodsArr = [
    "get",
    ...$d09e32d367368ff7$var$validMutationMethodsArr
];
const $d09e32d367368ff7$var$validRequestMethods = new Set($d09e32d367368ff7$var$validRequestMethodsArr);
const $d09e32d367368ff7$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $d09e32d367368ff7$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $d09e32d367368ff7$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $d09e32d367368ff7$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $d09e32d367368ff7$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $d09e32d367368ff7$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $d09e32d367368ff7$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $d09e32d367368ff7$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $d09e32d367368ff7$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $d09e32d367368ff7$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $d09e32d367368ff7$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $d09e32d367368ff7$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $d09e32d367368ff7$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $d09e32d367368ff7$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $d09e32d367368ff7$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $d09e32d367368ff7$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $d09e32d367368ff7$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $d09e32d367368ff7$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $d09e32d367368ff7$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $d09e32d367368ff7$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$d09e32d367368ff7$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($d09e32d367368ff7$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $d09e32d367368ff7$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $d09e32d367368ff7$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $d09e32d367368ff7$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $d09e32d367368ff7$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $d09e32d367368ff7$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $d09e32d367368ff7$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($d09e32d367368ff7$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $d09e32d367368ff7$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $d09e32d367368ff7$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $d09e32d367368ff7$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $d09e32d367368ff7$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $d09e32d367368ff7$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $d09e32d367368ff7$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $d09e32d367368ff7$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $d09e32d367368ff7$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $d09e32d367368ff7$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $d09e32d367368ff7$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $d09e32d367368ff7$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $d09e32d367368ff7$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $d09e32d367368ff7$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$d09e32d367368ff7$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $d09e32d367368ff7$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $d09e32d367368ff7$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $d09e32d367368ff7$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $d09e32d367368ff7$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $d09e32d367368ff7$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $d09e32d367368ff7$var$ResultType.error,
            error: $d09e32d367368ff7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $d09e32d367368ff7$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($d09e32d367368ff7$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($d09e32d367368ff7$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($d09e32d367368ff7$var$isDeferredResult(result)) throw $d09e32d367368ff7$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $d09e32d367368ff7$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $d09e32d367368ff7$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $d09e32d367368ff7$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $d09e32d367368ff7$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $d09e32d367368ff7$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($d09e32d367368ff7$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $d09e32d367368ff7$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $d09e32d367368ff7$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $d09e32d367368ff7$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $d09e32d367368ff7$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $d09e32d367368ff7$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $d09e32d367368ff7$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $d09e32d367368ff7$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $d09e32d367368ff7$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $d09e32d367368ff7$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $d09e32d367368ff7$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $d09e32d367368ff7$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $d09e32d367368ff7$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $d09e32d367368ff7$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($d09e32d367368ff7$var$isRedirectResult(actionResult) || $d09e32d367368ff7$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $d09e32d367368ff7$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($d09e32d367368ff7$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $d09e32d367368ff7$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $d09e32d367368ff7$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($d09e32d367368ff7$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($d09e32d367368ff7$var$isDeferredResult(actionResult)) throw $d09e32d367368ff7$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $d09e32d367368ff7$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $d09e32d367368ff7$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $d09e32d367368ff7$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $d09e32d367368ff7$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $d09e32d367368ff7$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $d09e32d367368ff7$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $d09e32d367368ff7$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $d09e32d367368ff7$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $d09e32d367368ff7$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $d09e32d367368ff7$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $d09e32d367368ff7$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $d09e32d367368ff7$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $d09e32d367368ff7$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $d09e32d367368ff7$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($d09e32d367368ff7$var$isDeferredResult(result)) result = await $d09e32d367368ff7$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $d09e32d367368ff7$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($d09e32d367368ff7$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $d09e32d367368ff7$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($d09e32d367368ff7$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $d09e32d367368ff7$export$3e9cee6b33872309(!$d09e32d367368ff7$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $d09e32d367368ff7$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $d09e32d367368ff7$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $d09e32d367368ff7$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($d09e32d367368ff7$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $d09e32d367368ff7$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace : $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $d09e32d367368ff7$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($d09e32d367368ff7$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $d09e32d367368ff7$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $d09e32d367368ff7$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $d09e32d367368ff7$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$d09e32d367368ff7$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $d09e32d367368ff7$var$callLoaderOrAction("loader", $d09e32d367368ff7$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $d09e32d367368ff7$var$ResultType.error,
                        error: $d09e32d367368ff7$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $d09e32d367368ff7$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $d09e32d367368ff7$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $d09e32d367368ff7$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $d09e32d367368ff7$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $d09e32d367368ff7$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $d09e32d367368ff7$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $d09e32d367368ff7$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $d09e32d367368ff7$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $d09e32d367368ff7$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $d09e32d367368ff7$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $d09e32d367368ff7$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $d09e32d367368ff7$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$d09e32d367368ff7$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $d09e32d367368ff7$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $d09e32d367368ff7$export$4d0306f8f6a4585b = Symbol("deferred");
function $d09e32d367368ff7$export$3336b097a6fbc59a(routes, opts) {
    $d09e32d367368ff7$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $d09e32d367368ff7$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $d09e32d367368ff7$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $d09e32d367368ff7$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $d09e32d367368ff7$var$createLocation("", $d09e32d367368ff7$export$fe53371bee54353d(url), null, "default");
        let matches = $d09e32d367368ff7$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$d09e32d367368ff7$var$isValidMethod(method) && method !== "HEAD") {
            let error = $d09e32d367368ff7$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $d09e32d367368ff7$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $d09e32d367368ff7$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $d09e32d367368ff7$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($d09e32d367368ff7$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $d09e32d367368ff7$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $d09e32d367368ff7$var$createLocation("", $d09e32d367368ff7$export$fe53371bee54353d(url), null, "default");
        let matches = $d09e32d367368ff7$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$d09e32d367368ff7$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $d09e32d367368ff7$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $d09e32d367368ff7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $d09e32d367368ff7$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $d09e32d367368ff7$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $d09e32d367368ff7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($d09e32d367368ff7$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$d09e32d367368ff7$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $d09e32d367368ff7$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($d09e32d367368ff7$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $d09e32d367368ff7$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $d09e32d367368ff7$var$isResponse(result) ? result : $d09e32d367368ff7$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($d09e32d367368ff7$var$isQueryRouteResponse(e)) {
                if (e.type === $d09e32d367368ff7$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($d09e32d367368ff7$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $d09e32d367368ff7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $d09e32d367368ff7$var$ResultType.error,
                error: error
            };
        } else {
            result = await $d09e32d367368ff7$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $d09e32d367368ff7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($d09e32d367368ff7$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($d09e32d367368ff7$var$isDeferredResult(result)) {
            let error = $d09e32d367368ff7$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $d09e32d367368ff7$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($d09e32d367368ff7$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($d09e32d367368ff7$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $d09e32d367368ff7$var$_extends({}, context, {
                statusCode: $d09e32d367368ff7$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $d09e32d367368ff7$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $d09e32d367368ff7$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $d09e32d367368ff7$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $d09e32d367368ff7$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $d09e32d367368ff7$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$d09e32d367368ff7$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $d09e32d367368ff7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $d09e32d367368ff7$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $d09e32d367368ff7$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $d09e32d367368ff7$export$fec11da027c70692(routes, context, error) {
    let newContext = $d09e32d367368ff7$var$_extends({}, context, {
        statusCode: $d09e32d367368ff7$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $d09e32d367368ff7$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $d09e32d367368ff7$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $d09e32d367368ff7$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $d09e32d367368ff7$export$cae722b0cc860f13(to ? to : ".", $d09e32d367368ff7$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $d09e32d367368ff7$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$d09e32d367368ff7$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $d09e32d367368ff7$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $d09e32d367368ff7$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $d09e32d367368ff7$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$d09e32d367368ff7$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$d09e32d367368ff7$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $d09e32d367368ff7$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $d09e32d367368ff7$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $d09e32d367368ff7$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$d09e32d367368ff7$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$d09e32d367368ff7$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $d09e32d367368ff7$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $d09e32d367368ff7$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $d09e32d367368ff7$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $d09e32d367368ff7$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $d09e32d367368ff7$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($d09e32d367368ff7$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $d09e32d367368ff7$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $d09e32d367368ff7$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $d09e32d367368ff7$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $d09e32d367368ff7$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $d09e32d367368ff7$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $d09e32d367368ff7$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($d09e32d367368ff7$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $d09e32d367368ff7$var$shouldRevalidateLoader(match, $d09e32d367368ff7$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $d09e32d367368ff7$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $d09e32d367368ff7$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $d09e32d367368ff7$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $d09e32d367368ff7$var$shouldRevalidateLoader(fetcherMatch, $d09e32d367368ff7$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $d09e32d367368ff7$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $d09e32d367368ff7$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $d09e32d367368ff7$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $d09e32d367368ff7$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $d09e32d367368ff7$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $d09e32d367368ff7$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$d09e32d367368ff7$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $d09e32d367368ff7$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $d09e32d367368ff7$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $d09e32d367368ff7$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $d09e32d367368ff7$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $d09e32d367368ff7$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $d09e32d367368ff7$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $d09e32d367368ff7$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $d09e32d367368ff7$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $d09e32d367368ff7$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($d09e32d367368ff7$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($d09e32d367368ff7$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $d09e32d367368ff7$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$d09e32d367368ff7$var$ABSOLUTE_URL_REGEX.test(location)) location = $d09e32d367368ff7$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $d09e32d367368ff7$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $d09e32d367368ff7$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $d09e32d367368ff7$var$ResultType.error ? $d09e32d367368ff7$var$ResultType.error : $d09e32d367368ff7$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $d09e32d367368ff7$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $d09e32d367368ff7$var$ResultType.error) return {
            type: resultType,
            error: new $d09e32d367368ff7$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $d09e32d367368ff7$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $d09e32d367368ff7$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($d09e32d367368ff7$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $d09e32d367368ff7$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $d09e32d367368ff7$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $d09e32d367368ff7$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($d09e32d367368ff7$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $d09e32d367368ff7$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $d09e32d367368ff7$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $d09e32d367368ff7$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $d09e32d367368ff7$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $d09e32d367368ff7$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $d09e32d367368ff7$export$3e9cee6b33872309(!$d09e32d367368ff7$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($d09e32d367368ff7$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $d09e32d367368ff7$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($d09e32d367368ff7$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $d09e32d367368ff7$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $d09e32d367368ff7$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $d09e32d367368ff7$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($d09e32d367368ff7$var$isErrorResult(result)) {
            let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $d09e32d367368ff7$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($d09e32d367368ff7$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $d09e32d367368ff7$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($d09e32d367368ff7$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $d09e32d367368ff7$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $d09e32d367368ff7$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $d09e32d367368ff7$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $d09e32d367368ff7$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $d09e32d367368ff7$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $d09e32d367368ff7$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $d09e32d367368ff7$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $d09e32d367368ff7$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $d09e32d367368ff7$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($d09e32d367368ff7$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $d09e32d367368ff7$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(path) : path;
    return $d09e32d367368ff7$export$fe53371bee54353d($d09e32d367368ff7$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $d09e32d367368ff7$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $d09e32d367368ff7$var$isDeferredResult(result) {
    return result.type === $d09e32d367368ff7$var$ResultType.deferred;
}
function $d09e32d367368ff7$var$isErrorResult(result) {
    return result.type === $d09e32d367368ff7$var$ResultType.error;
}
function $d09e32d367368ff7$var$isRedirectResult(result) {
    return (result && result.type) === $d09e32d367368ff7$var$ResultType.redirect;
}
function $d09e32d367368ff7$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $d09e32d367368ff7$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $d09e32d367368ff7$var$isRedirectResponse(result) {
    if (!$d09e32d367368ff7$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $d09e32d367368ff7$var$isQueryRouteResponse(obj) {
    return obj && $d09e32d367368ff7$var$isResponse(obj.response) && (obj.type === $d09e32d367368ff7$var$ResultType.data || obj.type === $d09e32d367368ff7$var$ResultType.error);
}
function $d09e32d367368ff7$var$isValidMethod(method) {
    return $d09e32d367368ff7$var$validRequestMethods.has(method.toLowerCase());
}
function $d09e32d367368ff7$var$isMutationMethod(method) {
    return $d09e32d367368ff7$var$validMutationMethods.has(method.toLowerCase());
}
async function $d09e32d367368ff7$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$d09e32d367368ff7$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($d09e32d367368ff7$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $d09e32d367368ff7$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $d09e32d367368ff7$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $d09e32d367368ff7$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $d09e32d367368ff7$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $d09e32d367368ff7$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $d09e32d367368ff7$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $d09e32d367368ff7$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $d09e32d367368ff7$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $d09e32d367368ff7$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $d09e32d367368ff7$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $d09e32d367368ff7$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $d09e32d367368ff7$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $d09e32d367368ff7$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $d09e32d367368ff7$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $d09e32d367368ff7$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $d09e32d367368ff7$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $d09e32d367368ff7$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($d09e32d367368ff7$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $d09e32d367368ff7$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($d09e32d367368ff7$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $d09e32d367368ff7$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $exYeM = parcelRequire("exYeM");

function $b0e6fcd50b7ef685$var$_extends() {
    $b0e6fcd50b7ef685$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b0e6fcd50b7ef685$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $b0e6fcd50b7ef685$export$3add0d5dce533e2e = /*#__PURE__*/ $exYeM.createContext(null);
const $b0e6fcd50b7ef685$export$145dfa71566a64dc = /*#__PURE__*/ $exYeM.createContext(null);
const $b0e6fcd50b7ef685$var$AwaitContext = /*#__PURE__*/ $exYeM.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $b0e6fcd50b7ef685$export$26749e8557646306 = /*#__PURE__*/ $exYeM.createContext(null);
const $b0e6fcd50b7ef685$export$c7914228fb69b0f5 = /*#__PURE__*/ $exYeM.createContext(null);
const $b0e6fcd50b7ef685$export$9072aa6dd1f93057 = /*#__PURE__*/ $exYeM.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $b0e6fcd50b7ef685$var$RouteErrorContext = /*#__PURE__*/ $exYeM.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $b0e6fcd50b7ef685$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $d09e32d367368ff7$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $b0e6fcd50b7ef685$export$9c954a9d03d32f4a() {
    return $exYeM.useContext($b0e6fcd50b7ef685$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $b0e6fcd50b7ef685$export$45d76561a5302f2b() {
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return $exYeM.useContext($b0e6fcd50b7ef685$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $b0e6fcd50b7ef685$export$1b3f31771c5d07c() {
    return $exYeM.useContext($b0e6fcd50b7ef685$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $b0e6fcd50b7ef685$export$6c330e8992e8a295(pattern) {
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    return $exYeM.useMemo(()=>(0, $d09e32d367368ff7$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $b0e6fcd50b7ef685$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $b0e6fcd50b7ef685$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $exYeM.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $b0e6fcd50b7ef685$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $b0e6fcd50b7ef685$var$useNavigateStable() : $b0e6fcd50b7ef685$var$useNavigateUnstable();
}
function $b0e6fcd50b7ef685$var$useNavigateUnstable() {
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let dataRouterContext = $exYeM.useContext($b0e6fcd50b7ef685$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306);
    let { matches: matches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $d09e32d367368ff7$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $exYeM.useRef(false);
    $b0e6fcd50b7ef685$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $exYeM.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $d09e32d367368ff7$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $d09e32d367368ff7$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $b0e6fcd50b7ef685$var$OutletContext = /*#__PURE__*/ $exYeM.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $b0e6fcd50b7ef685$export$4138103a3ae699cc() {
    return $exYeM.useContext($b0e6fcd50b7ef685$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $b0e6fcd50b7ef685$export$a3be3530d8e40d0b(context) {
    let outlet = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $b0e6fcd50b7ef685$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306);
    let { matches: matches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $d09e32d367368ff7$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $exYeM.useMemo(()=>(0, $d09e32d367368ff7$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $b0e6fcd50b7ef685$export$5d3fca4a98652595(routes, locationArg) {
    return $b0e6fcd50b7ef685$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $b0e6fcd50b7ef685$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306);
    let { matches: parentMatches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $d09e32d367368ff7$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $d09e32d367368ff7$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $b0e6fcd50b7ef685$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $d09e32d367368ff7$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $d09e32d367368ff7$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $b0e6fcd50b7ef685$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $d09e32d367368ff7$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $b0e6fcd50b7ef685$var$DefaultErrorComponent() {
    let error = $b0e6fcd50b7ef685$export$ed527bf60f6e05f2();
    let message = (0, $d09e32d367368ff7$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, /*#__PURE__*/ $exYeM.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $exYeM.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $exYeM.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $b0e6fcd50b7ef685$var$defaultErrorElement = /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$DefaultErrorComponent, null);
class $b0e6fcd50b7ef685$var$RenderErrorBoundary extends $exYeM.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $b0e6fcd50b7ef685$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $exYeM.useContext($b0e6fcd50b7ef685$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $b0e6fcd50b7ef685$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $b0e6fcd50b7ef685$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $b0e6fcd50b7ef685$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $exYeM.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $b0e6fcd50b7ef685$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($b0e6fcd50b7ef685$var$DataRouterHook || {});
var $b0e6fcd50b7ef685$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($b0e6fcd50b7ef685$var$DataRouterStateHook || {});
function $b0e6fcd50b7ef685$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $b0e6fcd50b7ef685$var$useDataRouterContext(hookName) {
    let ctx = $exYeM.useContext($b0e6fcd50b7ef685$export$3add0d5dce533e2e);
    !ctx && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return ctx;
}
function $b0e6fcd50b7ef685$var$useDataRouterState(hookName) {
    let state = $exYeM.useContext($b0e6fcd50b7ef685$export$145dfa71566a64dc);
    !state && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return state;
}
function $b0e6fcd50b7ef685$var$useRouteContext(hookName) {
    let route = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    !route && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $b0e6fcd50b7ef685$var$useCurrentRouteId(hookName) {
    let route = $b0e6fcd50b7ef685$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $b0e6fcd50b7ef685$export$5fc8298006ad9e58() {
    return $b0e6fcd50b7ef685$var$useCurrentRouteId($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $b0e6fcd50b7ef685$export$d0fd4b7106de2769() {
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $b0e6fcd50b7ef685$export$600dc272ed516c15() {
    let dataRouterContext = $b0e6fcd50b7ef685$var$useDataRouterContext($b0e6fcd50b7ef685$var$DataRouterHook.UseRevalidator);
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRevalidator);
    return $exYeM.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $b0e6fcd50b7ef685$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseMatches);
    return $exYeM.useMemo(()=>matches.map((m)=>(0, $d09e32d367368ff7$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $b0e6fcd50b7ef685$export$1448a5050d252c4d() {
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseLoaderData);
    let routeId = $b0e6fcd50b7ef685$var$useCurrentRouteId($b0e6fcd50b7ef685$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $b0e6fcd50b7ef685$export$fd5d37484eab868d(routeId) {
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $b0e6fcd50b7ef685$export$fdc00f3f26066d5e() {
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseActionData);
    let routeId = $b0e6fcd50b7ef685$var$useCurrentRouteId($b0e6fcd50b7ef685$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $b0e6fcd50b7ef685$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $exYeM.useContext($b0e6fcd50b7ef685$var$RouteErrorContext);
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRouteError);
    let routeId = $b0e6fcd50b7ef685$var$useCurrentRouteId($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $b0e6fcd50b7ef685$export$78a72ddb39bdd145() {
    let value = $exYeM.useContext($b0e6fcd50b7ef685$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $b0e6fcd50b7ef685$export$17f53340677d5831() {
    let value = $exYeM.useContext($b0e6fcd50b7ef685$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $b0e6fcd50b7ef685$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $b0e6fcd50b7ef685$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $b0e6fcd50b7ef685$var$useDataRouterContext($b0e6fcd50b7ef685$var$DataRouterHook.UseBlocker);
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $exYeM.useState("");
    let blockerFunction = $exYeM.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $b0e6fcd50b7ef685$var$_extends({}, currentLocation, {
                pathname: (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $b0e6fcd50b7ef685$var$_extends({}, nextLocation, {
                pathname: (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $exYeM.useEffect(()=>{
        let key = String(++$b0e6fcd50b7ef685$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $exYeM.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $d09e32d367368ff7$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $b0e6fcd50b7ef685$var$useNavigateStable() {
    let { router: router } = $b0e6fcd50b7ef685$var$useDataRouterContext($b0e6fcd50b7ef685$var$DataRouterHook.UseNavigateStable);
    let id = $b0e6fcd50b7ef685$var$useCurrentRouteId($b0e6fcd50b7ef685$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $exYeM.useRef(false);
    $b0e6fcd50b7ef685$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $exYeM.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $b0e6fcd50b7ef685$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $b0e6fcd50b7ef685$var$alreadyWarned = {};
function $b0e6fcd50b7ef685$var$warningOnce(key, cond, message) {
    if (!cond && !$b0e6fcd50b7ef685$var$alreadyWarned[key]) $b0e6fcd50b7ef685$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $b0e6fcd50b7ef685$var$START_TRANSITION = "startTransition";
const $b0e6fcd50b7ef685$var$startTransitionImpl = $exYeM[$b0e6fcd50b7ef685$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $b0e6fcd50b7ef685$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $exYeM.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        if (v7_startTransition && $b0e6fcd50b7ef685$var$startTransitionImpl) $b0e6fcd50b7ef685$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $exYeM.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $exYeM.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $exYeM.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $exYeM.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $b0e6fcd50b7ef685$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $b0e6fcd50b7ef685$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $b0e6fcd50b7ef685$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $exYeM.useRef();
    if (historyRef.current == null) historyRef.current = (0, $d09e32d367368ff7$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        v7_startTransition && $b0e6fcd50b7ef685$var$startTransitionImpl ? $b0e6fcd50b7ef685$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $b0e6fcd50b7ef685$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306);
    let { matches: matches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    let navigate = $b0e6fcd50b7ef685$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $d09e32d367368ff7$export$cae722b0cc860f13)(to, (0, $d09e32d367368ff7$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $exYeM.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $b0e6fcd50b7ef685$export$910ae8079b2c2852(props) {
    return $b0e6fcd50b7ef685$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $b0e6fcd50b7ef685$export$e7b0ac011bb776c6(_props) {
    (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $b0e6fcd50b7ef685$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $d09e32d367368ff7$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $exYeM.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $b0e6fcd50b7ef685$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $d09e32d367368ff7$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $exYeM.useMemo(()=>{
        let trailingPathname = (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $b0e6fcd50b7ef685$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $b0e6fcd50b7ef685$export$5d3fca4a98652595($b0e6fcd50b7ef685$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $b0e6fcd50b7ef685$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$ResolveAwait, null, children));
}
var $b0e6fcd50b7ef685$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($b0e6fcd50b7ef685$var$AwaitRenderStatus || {});
const $b0e6fcd50b7ef685$var$neverSettledPromise = new Promise(()=>{});
class $b0e6fcd50b7ef685$var$AwaitErrorBoundary extends $exYeM.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $b0e6fcd50b7ef685$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $b0e6fcd50b7ef685$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $b0e6fcd50b7ef685$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $b0e6fcd50b7ef685$var$AwaitRenderStatus.error : promise._data !== undefined ? $b0e6fcd50b7ef685$var$AwaitRenderStatus.success : $b0e6fcd50b7ef685$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $b0e6fcd50b7ef685$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $b0e6fcd50b7ef685$var$AwaitRenderStatus.error && promise._error instanceof (0, $d09e32d367368ff7$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $b0e6fcd50b7ef685$var$neverSettledPromise;
        if (status === $b0e6fcd50b7ef685$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $b0e6fcd50b7ef685$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $b0e6fcd50b7ef685$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $b0e6fcd50b7ef685$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $b0e6fcd50b7ef685$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $b0e6fcd50b7ef685$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $exYeM.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $exYeM.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $exYeM.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $b0e6fcd50b7ef685$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $b0e6fcd50b7ef685$export$e7b0ac011bb776c6) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $b0e6fcd50b7ef685$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $b0e6fcd50b7ef685$export$daf73786167a7f72(matches) {
    return $b0e6fcd50b7ef685$var$_renderMatches(matches);
}
function $b0e6fcd50b7ef685$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $exYeM.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $exYeM.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $exYeM.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $b0e6fcd50b7ef685$export$f30f7e456d254e83(routes, opts) {
    return (0, $d09e32d367368ff7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b0e6fcd50b7ef685$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $d09e32d367368ff7$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $b0e6fcd50b7ef685$export$52b333d321859367
    }).initialize();
}



function $2cc1d3688dd37f6f$var$_extends() {
    $2cc1d3688dd37f6f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2cc1d3688dd37f6f$var$_extends.apply(this, arguments);
}
function $2cc1d3688dd37f6f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $2cc1d3688dd37f6f$var$defaultMethod = "get";
const $2cc1d3688dd37f6f$var$defaultEncType = "application/x-www-form-urlencoded";
function $2cc1d3688dd37f6f$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $2cc1d3688dd37f6f$var$isButtonElement(object) {
    return $2cc1d3688dd37f6f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $2cc1d3688dd37f6f$var$isFormElement(object) {
    return $2cc1d3688dd37f6f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $2cc1d3688dd37f6f$var$isInputElement(object) {
    return $2cc1d3688dd37f6f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $2cc1d3688dd37f6f$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $2cc1d3688dd37f6f$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$2cc1d3688dd37f6f$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $2cc1d3688dd37f6f$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $2cc1d3688dd37f6f$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $2cc1d3688dd37f6f$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $2cc1d3688dd37f6f$var$_formDataSupportsSubmitter = null;
function $2cc1d3688dd37f6f$var$isFormDataSubmitterSupported() {
    if ($2cc1d3688dd37f6f$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $2cc1d3688dd37f6f$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $2cc1d3688dd37f6f$var$_formDataSupportsSubmitter = true;
    }
    return $2cc1d3688dd37f6f$var$_formDataSupportsSubmitter;
}
const $2cc1d3688dd37f6f$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $2cc1d3688dd37f6f$var$getFormEncType(encType) {
    if (encType != null && !$2cc1d3688dd37f6f$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $2cc1d3688dd37f6f$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($2cc1d3688dd37f6f$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $2cc1d3688dd37f6f$var$defaultMethod;
        encType = $2cc1d3688dd37f6f$var$getFormEncType(target.getAttribute("enctype")) || $2cc1d3688dd37f6f$var$defaultEncType;
        formData = new FormData(target);
    } else if ($2cc1d3688dd37f6f$var$isButtonElement(target) || $2cc1d3688dd37f6f$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $2cc1d3688dd37f6f$var$defaultMethod;
        encType = $2cc1d3688dd37f6f$var$getFormEncType(target.getAttribute("formenctype")) || $2cc1d3688dd37f6f$var$getFormEncType(form.getAttribute("enctype")) || $2cc1d3688dd37f6f$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$2cc1d3688dd37f6f$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($2cc1d3688dd37f6f$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $2cc1d3688dd37f6f$var$defaultMethod;
        action = null;
        encType = $2cc1d3688dd37f6f$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $2cc1d3688dd37f6f$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $2cc1d3688dd37f6f$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $2cc1d3688dd37f6f$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $2cc1d3688dd37f6f$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $2cc1d3688dd37f6f$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $2cc1d3688dd37f6f$export$1f3f55432a00e06d(routes, opts) {
    return (0, $d09e32d367368ff7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $2cc1d3688dd37f6f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $d09e32d367368ff7$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $2cc1d3688dd37f6f$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $b0e6fcd50b7ef685$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $2cc1d3688dd37f6f$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $d09e32d367368ff7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $2cc1d3688dd37f6f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $d09e32d367368ff7$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $2cc1d3688dd37f6f$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $b0e6fcd50b7ef685$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $2cc1d3688dd37f6f$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $2cc1d3688dd37f6f$var$_extends({}, state, {
        errors: $2cc1d3688dd37f6f$var$deserializeErrors(state.errors)
    });
    return state;
}
function $2cc1d3688dd37f6f$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $d09e32d367368ff7$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $2cc1d3688dd37f6f$export$7ad602f0e94e62d1 = /*#__PURE__*/ $exYeM.createContext({
    isTransitioning: false
});
const $2cc1d3688dd37f6f$export$148fd98d095596d4 = /*#__PURE__*/ $exYeM.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $2cc1d3688dd37f6f$var$START_TRANSITION = "startTransition";
const $2cc1d3688dd37f6f$var$startTransitionImpl = $exYeM[$2cc1d3688dd37f6f$var$START_TRANSITION];
const $2cc1d3688dd37f6f$var$FLUSH_SYNC = "flushSync";
const $2cc1d3688dd37f6f$var$flushSyncImpl = $97dc602bd7e23afa$exports[$2cc1d3688dd37f6f$var$FLUSH_SYNC];
const $2cc1d3688dd37f6f$var$USE_ID = "useId";
const $2cc1d3688dd37f6f$var$useIdImpl = $exYeM[$2cc1d3688dd37f6f$var$USE_ID];
function $2cc1d3688dd37f6f$var$startTransitionSafe(cb) {
    if ($2cc1d3688dd37f6f$var$startTransitionImpl) $2cc1d3688dd37f6f$var$startTransitionImpl(cb);
    else cb();
}
function $2cc1d3688dd37f6f$var$flushSyncSafe(cb) {
    if ($2cc1d3688dd37f6f$var$flushSyncImpl) $2cc1d3688dd37f6f$var$flushSyncImpl(cb);
    else cb();
}
class $2cc1d3688dd37f6f$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $2cc1d3688dd37f6f$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $exYeM.useState(router.state);
    let [pendingState, setPendingState] = $exYeM.useState();
    let [vtContext, setVtContext] = $exYeM.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $exYeM.useState();
    let [transition, setTransition] = $exYeM.useState();
    let [interruption, setInterruption] = $exYeM.useState();
    let fetcherData = $exYeM.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $exYeM.useCallback((cb)=>{
        if (v7_startTransition) $2cc1d3688dd37f6f$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $exYeM.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $2cc1d3688dd37f6f$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $2cc1d3688dd37f6f$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $2cc1d3688dd37f6f$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $2cc1d3688dd37f6f$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $2cc1d3688dd37f6f$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $exYeM.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $exYeM.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $2cc1d3688dd37f6f$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $exYeM.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $exYeM.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $exYeM.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $exYeM.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $exYeM.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $exYeM.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, /*#__PURE__*/ $exYeM.createElement((0, $b0e6fcd50b7ef685$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $exYeM.createElement((0, $b0e6fcd50b7ef685$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $exYeM.createElement($2cc1d3688dd37f6f$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $exYeM.createElement($2cc1d3688dd37f6f$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $exYeM.createElement((0, $b0e6fcd50b7ef685$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $exYeM.createElement($2cc1d3688dd37f6f$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $2cc1d3688dd37f6f$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $b0e6fcd50b7ef685$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $2cc1d3688dd37f6f$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $exYeM.useRef();
    if (historyRef.current == null) historyRef.current = (0, $d09e32d367368ff7$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        v7_startTransition && $2cc1d3688dd37f6f$var$startTransitionImpl ? $2cc1d3688dd37f6f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $exYeM.createElement((0, $b0e6fcd50b7ef685$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $2cc1d3688dd37f6f$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $exYeM.useRef();
    if (historyRef.current == null) historyRef.current = (0, $d09e32d367368ff7$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        v7_startTransition && $2cc1d3688dd37f6f$var$startTransitionImpl ? $2cc1d3688dd37f6f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $exYeM.createElement((0, $b0e6fcd50b7ef685$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $2cc1d3688dd37f6f$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        v7_startTransition && $2cc1d3688dd37f6f$var$startTransitionImpl ? $2cc1d3688dd37f6f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $exYeM.createElement((0, $b0e6fcd50b7ef685$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $2cc1d3688dd37f6f$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $2cc1d3688dd37f6f$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a = /*#__PURE__*/ $exYeM.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $2cc1d3688dd37f6f$var$_objectWithoutPropertiesLoose(_ref7, $2cc1d3688dd37f6f$var$_excluded);
    let { basename: basename } = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $2cc1d3688dd37f6f$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($2cc1d3688dd37f6f$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $b0e6fcd50b7ef685$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $2cc1d3688dd37f6f$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $exYeM.createElement("a", $2cc1d3688dd37f6f$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d = /*#__PURE__*/ $exYeM.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $2cc1d3688dd37f6f$var$_objectWithoutPropertiesLoose(_ref8, $2cc1d3688dd37f6f$var$_excluded2);
    let path = (0, $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    let routerState = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $2cc1d3688dd37f6f$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $exYeM.createElement($2cc1d3688dd37f6f$export$a6c7ac8248d6e38a, $2cc1d3688dd37f6f$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $2cc1d3688dd37f6f$export$a7fed597f4b8afd8 = /*#__PURE__*/ $exYeM.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $2cc1d3688dd37f6f$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $2cc1d3688dd37f6f$var$_objectWithoutPropertiesLoose(_ref9, $2cc1d3688dd37f6f$var$_excluded3);
    let submit = $2cc1d3688dd37f6f$export$47c85c6e3a081d3();
    let formAction = $2cc1d3688dd37f6f$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $exYeM.createElement("form", $2cc1d3688dd37f6f$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $2cc1d3688dd37f6f$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $2cc1d3688dd37f6f$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $2cc1d3688dd37f6f$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($2cc1d3688dd37f6f$var$DataRouterHook || ($2cc1d3688dd37f6f$var$DataRouterHook = {}));
var $2cc1d3688dd37f6f$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($2cc1d3688dd37f6f$var$DataRouterStateHook || ($2cc1d3688dd37f6f$var$DataRouterStateHook = {}));
// Internal hooks
function $2cc1d3688dd37f6f$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $2cc1d3688dd37f6f$var$useDataRouterContext(hookName) {
    let ctx = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$3add0d5dce533e2e));
    !ctx && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return ctx;
}
function $2cc1d3688dd37f6f$var$useDataRouterState(hookName) {
    let state = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$145dfa71566a64dc));
    !state && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $2cc1d3688dd37f6f$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    let location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    let path = (0, $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $exYeM.useCallback((event)=>{
        if ($2cc1d3688dd37f6f$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $d09e32d367368ff7$export$fe53371bee54353d)(location) === (0, $d09e32d367368ff7$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $2cc1d3688dd37f6f$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $exYeM.useRef($2cc1d3688dd37f6f$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $exYeM.useRef(false);
    let location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    let searchParams = $exYeM.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $2cc1d3688dd37f6f$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    let setSearchParams = $exYeM.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $2cc1d3688dd37f6f$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $2cc1d3688dd37f6f$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $2cc1d3688dd37f6f$var$fetcherId = 0;
let $2cc1d3688dd37f6f$var$getUniqueFetcherId = ()=>"__" + String(++$2cc1d3688dd37f6f$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $2cc1d3688dd37f6f$export$47c85c6e3a081d3() {
    let { router: router } = $2cc1d3688dd37f6f$var$useDataRouterContext($2cc1d3688dd37f6f$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$26749e8557646306));
    let currentRouteId = (0, $b0e6fcd50b7ef685$export$5fc8298006ad9e58)();
    return $exYeM.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $2cc1d3688dd37f6f$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $2cc1d3688dd37f6f$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $2cc1d3688dd37f6f$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $2cc1d3688dd37f6f$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$26749e8557646306));
    let routeContext = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$9072aa6dd1f93057));
    !routeContext && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $2cc1d3688dd37f6f$var$_extends({}, (0, $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $d09e32d367368ff7$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $d09e32d367368ff7$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $2cc1d3688dd37f6f$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $2cc1d3688dd37f6f$var$useDataRouterContext($2cc1d3688dd37f6f$var$DataRouterHook.UseFetcher);
    let state = $2cc1d3688dd37f6f$var$useDataRouterState($2cc1d3688dd37f6f$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $exYeM.useContext($2cc1d3688dd37f6f$export$148fd98d095596d4);
    let route = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    !route && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $2cc1d3688dd37f6f$var$useIdImpl ? $2cc1d3688dd37f6f$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $exYeM.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($2cc1d3688dd37f6f$var$getUniqueFetcherId());
    // Registration/cleanup
    $exYeM.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $exYeM.useCallback((href, opts)=>{
        !routeId && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $2cc1d3688dd37f6f$export$47c85c6e3a081d3();
    let submit = $exYeM.useCallback((target, opts)=>{
        submitImpl(target, $2cc1d3688dd37f6f$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $exYeM.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $exYeM.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $exYeM.createElement($2cc1d3688dd37f6f$export$a7fed597f4b8afd8, $2cc1d3688dd37f6f$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $d09e32d367368ff7$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $exYeM.useMemo(()=>$2cc1d3688dd37f6f$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $2cc1d3688dd37f6f$export$fa996778a3a31087() {
    let state = $2cc1d3688dd37f6f$var$useDataRouterState($2cc1d3688dd37f6f$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $2cc1d3688dd37f6f$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $2cc1d3688dd37f6f$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $2cc1d3688dd37f6f$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $2cc1d3688dd37f6f$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $2cc1d3688dd37f6f$var$useDataRouterContext($2cc1d3688dd37f6f$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $2cc1d3688dd37f6f$var$useDataRouterState($2cc1d3688dd37f6f$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$26749e8557646306));
    let location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    let matches = (0, $b0e6fcd50b7ef685$export$2378eb7f5ff86053)();
    let navigation = (0, $b0e6fcd50b7ef685$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $exYeM.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $2cc1d3688dd37f6f$var$usePageHide($exYeM.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $2cc1d3688dd37f6f$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $2cc1d3688dd37f6f$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($2cc1d3688dd37f6f$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $exYeM.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $2cc1d3688dd37f6f$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $2cc1d3688dd37f6f$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $exYeM.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($2cc1d3688dd37f6f$var$_extends({}, location, {
                    pathname: (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($2cc1d3688dd37f6f$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $exYeM.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $2cc1d3688dd37f6f$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $exYeM.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $2cc1d3688dd37f6f$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $exYeM.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $2cc1d3688dd37f6f$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $b0e6fcd50b7ef685$export$b273b3273281a049)(when);
    $exYeM.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $exYeM.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $2cc1d3688dd37f6f$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $exYeM.useContext($2cc1d3688dd37f6f$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let { basename: basename } = $2cc1d3688dd37f6f$var$useDataRouterContext($2cc1d3688dd37f6f$var$DataRouterHook.useViewTransitionState);
    let path = (0, $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $d09e32d367368ff7$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $d09e32d367368ff7$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");

var $4qr5a = parcelRequire("4qr5a");

var $7RpPE = parcelRequire("7RpPE");

var $3b4hp = parcelRequire("3b4hp");
var $aJf2l = parcelRequire("aJf2l");

var $8IwTu = parcelRequire("8IwTu");

var $aSiaI = parcelRequire("aSiaI");
"use client";
const $5899c6e3353e1865$var$_excluded = [
    "className",
    "component"
];
function $5899c6e3353e1865$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName } = options;
    const BoxRoot = (0, $7RpPE.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $3b4hp.default));
    const Box = /*#__PURE__*/ $exYeM.forwardRef(function Box(inProps, ref) {
        const theme = (0, $8IwTu.default)(defaultTheme);
        const _extendSxProp = (0, $aJf2l.default)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $3L80X.default)(_extendSxProp, $5899c6e3353e1865$var$_excluded);
        return /*#__PURE__*/ (0, $aSiaI.jsx)(BoxRoot, (0, $aJx1R.default)({
            as: component,
            ref: ref,
            className: (0, $4qr5a.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $5NAbk = parcelRequire("5NAbk");

var $6TTLz = parcelRequire("6TTLz");

var $pePt2 = parcelRequire("pePt2");

var $kY7HX = parcelRequire("kY7HX");
const $89bc8ca76d561c3e$var$boxClasses = (0, $kY7HX.default)("MuiBox", [
    "root"
]);
var $89bc8ca76d561c3e$export$2e2bcd8739ae039 = $89bc8ca76d561c3e$var$boxClasses;


"use client";
const $13ce9942b64fe3e4$var$defaultTheme = (0, $6TTLz.default)();
const $13ce9942b64fe3e4$var$Box = (0, $5899c6e3353e1865$export$2e2bcd8739ae039)({
    themeId: (0, $pePt2.default),
    defaultTheme: $13ce9942b64fe3e4$var$defaultTheme,
    defaultClassName: (0, $89bc8ca76d561c3e$export$2e2bcd8739ae039).root,
    generateClassName: (0, $5NAbk.default).generate
});
var $13ce9942b64fe3e4$export$2e2bcd8739ae039 = $13ce9942b64fe3e4$var$Box;


/* eslint-disable react/no-unstable-nested-components */ 
var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");



var $2f0D3 = parcelRequire("2f0D3");

var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");

var $exYeM = parcelRequire("exYeM");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $07cd8eb63b27fd4d$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


"use client";
function $21de68ba780e9ec5$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $exYeM.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $07cd8eb63b27fd4d$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


"use client";
var $69ecd4eca0914ac9$export$2e2bcd8739ae039 = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039);



var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $c4c3f9798cb7fddc$var$useEnhancedEffect = typeof window !== "undefined" ? $exYeM.useLayoutEffect : $exYeM.useEffect;
var $c4c3f9798cb7fddc$export$2e2bcd8739ae039 = $c4c3f9798cb7fddc$var$useEnhancedEffect;


"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $4d8fa1c1fa1ae4cf$var$useEventCallback(fn) {
    const ref = $exYeM.useRef(fn);
    (0, $c4c3f9798cb7fddc$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $exYeM.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039 = $4d8fa1c1fa1ae4cf$var$useEventCallback;


"use client";
var $d00700b704925555$export$2e2bcd8739ae039 = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039);



var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
"use client";
const $9044c847cb8b2879$var$UNINITIALIZED = {};
function $9044c847cb8b2879$export$2e2bcd8739ae039(init, initArg) {
    const ref = $exYeM.useRef($9044c847cb8b2879$var$UNINITIALIZED);
    if (ref.current === $9044c847cb8b2879$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $exYeM = parcelRequire("exYeM");
"use client";
const $b333eb832b2d7dc2$var$EMPTY = [];
function $b333eb832b2d7dc2$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $exYeM.useEffect(fn, $b333eb832b2d7dc2$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


"use client";
class $72fb5758a7c9ec4b$export$786b4da70f00938b {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $72fb5758a7c9ec4b$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function $72fb5758a7c9ec4b$export$2e2bcd8739ae039() {
    const timeout = (0, $9044c847cb8b2879$export$2e2bcd8739ae039)($72fb5758a7c9ec4b$export$786b4da70f00938b.create).current;
    (0, $b333eb832b2d7dc2$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


"use client";
let $c165a4ae7d98def4$var$hadKeyboardEvent = true;
let $c165a4ae7d98def4$var$hadFocusVisibleRecently = false;
const $c165a4ae7d98def4$var$hadFocusVisibleRecentlyTimeout = new (0, $72fb5758a7c9ec4b$export$786b4da70f00938b)();
const $c165a4ae7d98def4$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $c165a4ae7d98def4$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $c165a4ae7d98def4$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $c165a4ae7d98def4$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $c165a4ae7d98def4$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $c165a4ae7d98def4$var$handlePointerDown() {
    $c165a4ae7d98def4$var$hadKeyboardEvent = false;
}
function $c165a4ae7d98def4$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($c165a4ae7d98def4$var$hadFocusVisibleRecently) $c165a4ae7d98def4$var$hadKeyboardEvent = true;
    }
}
function $c165a4ae7d98def4$var$prepare(doc) {
    doc.addEventListener("keydown", $c165a4ae7d98def4$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $c165a4ae7d98def4$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $c165a4ae7d98def4$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $c165a4ae7d98def4$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $c165a4ae7d98def4$var$handleVisibilityChange, true);
}
function $c165a4ae7d98def4$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $c165a4ae7d98def4$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $c165a4ae7d98def4$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $c165a4ae7d98def4$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $c165a4ae7d98def4$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $c165a4ae7d98def4$var$handleVisibilityChange, true);
}
function $c165a4ae7d98def4$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $c165a4ae7d98def4$var$hadKeyboardEvent || $c165a4ae7d98def4$var$focusTriggersKeyboardModality(target);
}
function $c165a4ae7d98def4$export$2e2bcd8739ae039() {
    const ref = $exYeM.useCallback((node)=>{
        if (node != null) $c165a4ae7d98def4$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $exYeM.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $c165a4ae7d98def4$var$hadFocusVisibleRecently = true;
            $c165a4ae7d98def4$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $c165a4ae7d98def4$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($c165a4ae7d98def4$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


"use client";
var $d231bcdf65c325cd$export$2e2bcd8739ae039 = (0, $c165a4ae7d98def4$export$2e2bcd8739ae039);



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");
function $8b81dd4f51678982$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $438ae88f4b206ba2$export$2e2bcd8739ae039(t, e) {
    return $438ae88f4b206ba2$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $438ae88f4b206ba2$export$2e2bcd8739ae039(t, e);
}


function $6ace560ed589c934$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $438ae88f4b206ba2$export$2e2bcd8739ae039)(t, o);
}




var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
var $9bfbeb4757462139$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(null);



var $exYeM = parcelRequire("exYeM");
function $bd1984c0bc2a5747$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $exYeM.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $exYeM.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $bd1984c0bc2a5747$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $bd1984c0bc2a5747$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $bd1984c0bc2a5747$export$fa71e2345c31d7a2(props, onExited) {
    return $bd1984c0bc2a5747$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $exYeM.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $bd1984c0bc2a5747$var$getProp(child, "appear", props),
            enter: $bd1984c0bc2a5747$var$getProp(child, "enter", props),
            exit: $bd1984c0bc2a5747$var$getProp(child, "exit", props)
        });
    });
}
function $bd1984c0bc2a5747$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $bd1984c0bc2a5747$export$bbc8a025727ea824(nextProps.children);
    var children = $bd1984c0bc2a5747$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $exYeM.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $exYeM.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $exYeM.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $bd1984c0bc2a5747$var$getProp(child, "exit", nextProps),
            enter: $bd1984c0bc2a5747$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $exYeM.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $exYeM.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $exYeM.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $bd1984c0bc2a5747$var$getProp(child, "exit", nextProps),
            enter: $bd1984c0bc2a5747$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $151b5217152ca66c$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $151b5217152ca66c$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $151b5217152ca66c$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $6ace560ed589c934$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $8b81dd4f51678982$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $bd1984c0bc2a5747$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $bd1984c0bc2a5747$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $bd1984c0bc2a5747$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $aJx1R.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $3L80X.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $151b5217152ca66c$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9bfbeb4757462139$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9bfbeb4757462139$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Component);
$151b5217152ca66c$var$TransitionGroup.propTypes = {};
$151b5217152ca66c$var$TransitionGroup.defaultProps = $151b5217152ca66c$var$defaultProps;
var $151b5217152ca66c$export$2e2bcd8739ae039 = $151b5217152ca66c$var$TransitionGroup;



var $4qr5a = parcelRequire("4qr5a");

var $geqbO = parcelRequire("geqbO");


var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $aSiaI = parcelRequire("aSiaI");
"use client";
function $00b8ec9dbff61a4f$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $exYeM.useState(false);
    const rippleClassName = (0, $4qr5a.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $4qr5a.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $exYeM.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
            className: childClassName
        })
    });
}
var $00b8ec9dbff61a4f$export$2e2bcd8739ae039 = $00b8ec9dbff61a4f$var$Ripple;



var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $3fc417d20b599abc$export$b464606f735ab902(slot) {
    return (0, $dC5O8.default)("MuiTouchRipple", slot);
}
const $3fc417d20b599abc$var$touchRippleClasses = (0, $kY7HX.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $3fc417d20b599abc$export$2e2bcd8739ae039 = $3fc417d20b599abc$var$touchRippleClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $a49c7d64774a801b$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $a49c7d64774a801b$var$_ = (t)=>t, $a49c7d64774a801b$var$_t, $a49c7d64774a801b$var$_t2, $a49c7d64774a801b$var$_t3, $a49c7d64774a801b$var$_t4;
const $a49c7d64774a801b$var$DURATION = 550;
const $a49c7d64774a801b$export$95d0c9356b2231a3 = 80;
const $a49c7d64774a801b$var$enterKeyframe = (0, $geqbO.keyframes)($a49c7d64774a801b$var$_t || ($a49c7d64774a801b$var$_t = $a49c7d64774a801b$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $a49c7d64774a801b$var$exitKeyframe = (0, $geqbO.keyframes)($a49c7d64774a801b$var$_t2 || ($a49c7d64774a801b$var$_t2 = $a49c7d64774a801b$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $a49c7d64774a801b$var$pulsateKeyframe = (0, $geqbO.keyframes)($a49c7d64774a801b$var$_t3 || ($a49c7d64774a801b$var$_t3 = $a49c7d64774a801b$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $a49c7d64774a801b$export$f6b7418508c72c25 = (0, $jawKn.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $a49c7d64774a801b$export$676cfe7b12693c4b = (0, $jawKn.default)((0, $00b8ec9dbff61a4f$export$2e2bcd8739ae039), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($a49c7d64774a801b$var$_t4 || ($a49c7d64774a801b$var$_t4 = $a49c7d64774a801b$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $3fc417d20b599abc$export$2e2bcd8739ae039).rippleVisible, $a49c7d64774a801b$var$enterKeyframe, $a49c7d64774a801b$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $3fc417d20b599abc$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $3fc417d20b599abc$export$2e2bcd8739ae039).child, (0, $3fc417d20b599abc$export$2e2bcd8739ae039).childLeaving, $a49c7d64774a801b$var$exitKeyframe, $a49c7d64774a801b$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $3fc417d20b599abc$export$2e2bcd8739ae039).childPulsate, $a49c7d64774a801b$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $a49c7d64774a801b$var$TouchRipple = /*#__PURE__*/ $exYeM.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $3L80X.default)(props, $a49c7d64774a801b$var$_excluded);
    const [ripples, setRipples] = $exYeM.useState([]);
    const nextKey = $exYeM.useRef(0);
    const rippleCallback = $exYeM.useRef(null);
    $exYeM.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $exYeM.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $72fb5758a7c9ec4b$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $exYeM.useRef(null);
    const container = $exYeM.useRef(null);
    const startCommit = $exYeM.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $aSiaI.jsx)($a49c7d64774a801b$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $4qr5a.default)(classes.ripple, (0, $3fc417d20b599abc$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $4qr5a.default)(classes.rippleVisible, (0, $3fc417d20b599abc$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $4qr5a.default)(classes.ripplePulsate, (0, $3fc417d20b599abc$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $4qr5a.default)(classes.child, (0, $3fc417d20b599abc$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $4qr5a.default)(classes.childLeaving, (0, $3fc417d20b599abc$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $4qr5a.default)(classes.childPulsate, (0, $3fc417d20b599abc$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $a49c7d64774a801b$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $exYeM.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($a49c7d64774a801b$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $exYeM.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $exYeM.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $exYeM.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($a49c7d64774a801b$export$f6b7418508c72c25, (0, $aJx1R.default)({
        className: (0, $4qr5a.default)((0, $3fc417d20b599abc$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $151b5217152ca66c$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $a49c7d64774a801b$export$2e2bcd8739ae039 = $a49c7d64774a801b$var$TouchRipple;



var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $37ce174a4be752fe$export$fccb0498dcd99783(slot) {
    return (0, $dC5O8.default)("MuiButtonBase", slot);
}
const $37ce174a4be752fe$var$buttonBaseClasses = (0, $kY7HX.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $37ce174a4be752fe$export$2e2bcd8739ae039 = $37ce174a4be752fe$var$buttonBaseClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $8c6774266c067eb9$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $8c6774266c067eb9$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $2f0D3.default)(slots, (0, $37ce174a4be752fe$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $8c6774266c067eb9$export$7ec0dcc5e3cdcd36 = (0, $jawKn.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $37ce174a4be752fe$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $8c6774266c067eb9$var$ButtonBase = /*#__PURE__*/ $exYeM.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $3L80X.default)(props, $8c6774266c067eb9$var$_excluded);
    const buttonRef = $exYeM.useRef(null);
    const rippleRef = $exYeM.useRef(null);
    const handleRippleRef = (0, $69ecd4eca0914ac9$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $d231bcdf65c325cd$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $exYeM.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $exYeM.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $exYeM.useState(false);
    $exYeM.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $exYeM.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $d00700b704925555$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $d00700b704925555$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $exYeM.useRef(false);
    const handleKeyDown = (0, $d00700b704925555$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $d00700b704925555$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $69ecd4eca0914ac9$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $aJx1R.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $8c6774266c067eb9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($8c6774266c067eb9$export$7ec0dcc5e3cdcd36, (0, $aJx1R.default)({
        as: ComponentProp,
        className: (0, $4qr5a.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $aSiaI.jsx)((0, $a49c7d64774a801b$export$2e2bcd8739ae039), (0, $aJx1R.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $8c6774266c067eb9$export$2e2bcd8739ae039 = $8c6774266c067eb9$var$ButtonBase;



var $fXwzw = parcelRequire("fXwzw");

var $7PWLt = parcelRequire("7PWLt");

var $jawKn = parcelRequire("jawKn");


var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $7bba13dfda3adde5$export$72aef224d6115253(slot) {
    return (0, $dC5O8.default)("MuiTab", slot);
}
const $7bba13dfda3adde5$var$tabClasses = (0, $kY7HX.default)("MuiTab", [
    "root",
    "labelIcon",
    "textColorInherit",
    "textColorPrimary",
    "textColorSecondary",
    "selected",
    "disabled",
    "fullWidth",
    "wrapped",
    "iconWrapper"
]);
var $7bba13dfda3adde5$export$2e2bcd8739ae039 = $7bba13dfda3adde5$var$tabClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $8db679d8467240be$var$_excluded = [
    "className",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "icon",
    "iconPosition",
    "indicator",
    "label",
    "onChange",
    "onClick",
    "onFocus",
    "selected",
    "selectionFollowsFocus",
    "textColor",
    "value",
    "wrapped"
];
const $8db679d8467240be$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            icon && label && "labelIcon",
            `textColor${(0, $fXwzw.default)(textColor)}`,
            fullWidth && "fullWidth",
            wrapped && "wrapped",
            selected && "selected",
            disabled && "disabled"
        ],
        iconWrapper: [
            "iconWrapper"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $7bba13dfda3adde5$export$72aef224d6115253), classes);
};
const $8db679d8467240be$var$TabRoot = (0, $jawKn.default)((0, $8c6774266c067eb9$export$2e2bcd8739ae039), {
    name: "MuiTab",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $fXwzw.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({}, theme.typography.button, {
        maxWidth: 360,
        minWidth: 90,
        position: "relative",
        minHeight: 48,
        flexShrink: 0,
        padding: "12px 16px",
        overflow: "hidden",
        whiteSpace: "normal",
        textAlign: "center"
    }, ownerState.label && {
        flexDirection: ownerState.iconPosition === "top" || ownerState.iconPosition === "bottom" ? "column" : "row"
    }, {
        lineHeight: 1.25
    }, ownerState.icon && ownerState.label && {
        minHeight: 72,
        paddingTop: 9,
        paddingBottom: 9,
        [`& > .${(0, $7bba13dfda3adde5$export$2e2bcd8739ae039).iconWrapper}`]: (0, $aJx1R.default)({}, ownerState.iconPosition === "top" && {
            marginBottom: 6
        }, ownerState.iconPosition === "bottom" && {
            marginTop: 6
        }, ownerState.iconPosition === "start" && {
            marginRight: theme.spacing(1)
        }, ownerState.iconPosition === "end" && {
            marginLeft: theme.spacing(1)
        })
    }, ownerState.textColor === "inherit" && {
        color: "inherit",
        opacity: 0.6,
        // same opacity as theme.palette.text.secondary
        [`&.${(0, $7bba13dfda3adde5$export$2e2bcd8739ae039).selected}`]: {
            opacity: 1
        },
        [`&.${(0, $7bba13dfda3adde5$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.textColor === "primary" && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $7bba13dfda3adde5$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $7bba13dfda3adde5$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.textColor === "secondary" && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $7bba13dfda3adde5$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.secondary.main
        },
        [`&.${(0, $7bba13dfda3adde5$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.fullWidth && {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: "none"
    }, ownerState.wrapped && {
        fontSize: theme.typography.pxToRem(12)
    }));
const $8db679d8467240be$var$Tab = /*#__PURE__*/ $exYeM.forwardRef(function Tab(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiTab"
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = "top", indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = "inherit", value: value, wrapped: wrapped = false } = props, other = (0, $3L80X.default)(props, $8db679d8467240be$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    });
    const classes = $8db679d8467240be$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $exYeM.isValidElement(iconProp) ? /*#__PURE__*/ $exYeM.cloneElement(iconProp, {
        className: (0, $4qr5a.default)(classes.iconWrapper, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($8db679d8467240be$var$TabRoot, (0, $aJx1R.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $4qr5a.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1
    }, other, {
        children: [
            iconPosition === "top" || iconPosition === "start" ? /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    }));
});
var $8db679d8467240be$export$2e2bcd8739ae039 = $8db679d8467240be$var$Tab;



var $exYeM = parcelRequire("exYeM");


var $aSiaI = parcelRequire("aSiaI");
"use client";
const $75a69f56048afb85$var$Context = /*#__PURE__*/ $exYeM.createContext(null);
function $75a69f56048afb85$var$useUniquePrefix() {
    const [id, setId] = $exYeM.useState(null);
    $exYeM.useEffect(()=>{
        setId(`mui-p-${Math.round(Math.random() * 1e5)}`);
    }, []);
    return id;
}
function $75a69f56048afb85$export$2e2bcd8739ae039(props) {
    const { children: children, value: value } = props;
    const idPrefix = $75a69f56048afb85$var$useUniquePrefix();
    const context = $exYeM.useMemo(()=>{
        return {
            idPrefix: idPrefix,
            value: value
        };
    }, [
        idPrefix,
        value
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($75a69f56048afb85$var$Context.Provider, {
        value: context,
        children: children
    });
}
function $75a69f56048afb85$export$5a3bad273ac578e0() {
    return $exYeM.useContext($75a69f56048afb85$var$Context);
}
function $75a69f56048afb85$export$629f80328afcade5(context, value) {
    const { idPrefix: idPrefix } = context;
    if (idPrefix === null) return null;
    return `${context.idPrefix}-P-${value}`;
}
function $75a69f56048afb85$export$46f6d19d28231cb8(context, value) {
    const { idPrefix: idPrefix } = context;
    if (idPrefix === null) return null;
    return `${context.idPrefix}-T-${value}`;
}



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");
parcelRequire("bSFE1");


var $4qr5a = parcelRequire("4qr5a");


var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");


var $aJx1R = parcelRequire("aJx1R");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $6d812737487786ea$export$e28348cc2430497(element) {
    return typeof element === "string";
}


function $0ce6f43677b2e28e$export$b089efb01a7bdf50(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $6d812737487786ea$export$e28348cc2430497)(elementType)) return otherProps;
    return (0, $aJx1R.default)({}, otherProps, {
        ownerState: (0, $aJx1R.default)({}, otherProps.ownerState, ownerState)
    });
}



var $aJx1R = parcelRequire("aJx1R");

var $4qr5a = parcelRequire("4qr5a");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $2e067879f82a8818$export$24d5698b57eff81c(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $b70358986ddabc94$export$2ac0fa4d3a39be45(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


function $de8324a7f8ed16f3$export$b01d1e419b049226(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $4qr5a.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $aJx1R.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $aJx1R.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $2e067879f82a8818$export$24d5698b57eff81c)((0, $aJx1R.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $b70358986ddabc94$export$2ac0fa4d3a39be45)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $b70358986ddabc94$export$2ac0fa4d3a39be45)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $4qr5a.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $aJx1R.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $aJx1R.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $269e73534f97f715$export$308c24034cde71de(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}


"use client";
const $49b1f8e5a9993ff9$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
function $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $3L80X.default)(parameters, $49b1f8e5a9993ff9$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $269e73534f97f715$export$308c24034cde71de)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $de8324a7f8ed16f3$export$b01d1e419b049226)((0, $aJx1R.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $0ce6f43677b2e28e$export$b089efb01a7bdf50)(elementType, (0, $aJx1R.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}



var $2f0D3 = parcelRequire("2f0D3");

var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $aSiaI = parcelRequire("aSiaI");
const $f6d0b5039025b20a$var$_excluded = [
    "value"
];
const $f6d0b5039025b20a$var$RtlContext = /*#__PURE__*/ $exYeM.createContext();
function $f6d0b5039025b20a$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $3L80X.default)(_ref, $f6d0b5039025b20a$var$_excluded);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($f6d0b5039025b20a$var$RtlContext.Provider, (0, $aJx1R.default)({
        value: value != null ? value : true
    }, props));
}
const $f6d0b5039025b20a$export$b2dd014b6c321cb = ()=>{
    const value = $exYeM.useContext($f6d0b5039025b20a$var$RtlContext);
    return value != null ? value : false;
};
var $f6d0b5039025b20a$export$2e2bcd8739ae039 = $f6d0b5039025b20a$var$RtlProvider;



var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");
parcelRequire("exYeM");

var $8IwTu = parcelRequire("8IwTu");

var $5n7Fs = parcelRequire("5n7Fs");

var $pePt2 = parcelRequire("pePt2");
"use client";
function $3b0ffd30506eb290$export$2e2bcd8739ae039() {
    const theme = (0, $8IwTu.default)((0, $5n7Fs.default));
    return theme[0, $pePt2.default] || theme;
}


// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $e9d013e2a17c2ab4$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $398f0b8aef852a12$export$2e2bcd8739ae039 = (0, $e9d013e2a17c2ab4$export$2e2bcd8739ae039);


// Source from https://github.com/alitaheri/normalize-scroll-left
let $79701f59cd63314a$var$cachedType;
function $79701f59cd63314a$export$a10970ffb6510128() {
    if ($79701f59cd63314a$var$cachedType) return $79701f59cd63314a$var$cachedType;
    const dummy = document.createElement("div");
    const container = document.createElement("div");
    container.style.width = "10px";
    container.style.height = "1px";
    dummy.appendChild(container);
    dummy.dir = "rtl";
    dummy.style.fontSize = "14px";
    dummy.style.width = "4px";
    dummy.style.height = "1px";
    dummy.style.position = "absolute";
    dummy.style.top = "-1000px";
    dummy.style.overflow = "scroll";
    document.body.appendChild(dummy);
    $79701f59cd63314a$var$cachedType = "reverse";
    if (dummy.scrollLeft > 0) $79701f59cd63314a$var$cachedType = "default";
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $79701f59cd63314a$var$cachedType = "negative";
    }
    document.body.removeChild(dummy);
    return $79701f59cd63314a$var$cachedType;
}
function $79701f59cd63314a$export$3c615b88e5d7e4f6(element, direction) {
    const scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== "rtl") return scrollLeft;
    const type = $79701f59cd63314a$export$a10970ffb6510128();
    switch(type){
        case "negative":
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case "reverse":
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}


function $f3c5f43e0efe7ed8$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $f3c5f43e0efe7ed8$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $f3c5f43e0efe7ed8$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error("Animation cancelled"));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error("Element already at target position"));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


function $0d47b1cc144b9266$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $9a18bdeaa27f655f$export$2e2bcd8739ae039(node) {
    const doc = (0, $0d47b1cc144b9266$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $181be504c47027d1$export$2e2bcd8739ae039 = (0, $9a18bdeaa27f655f$export$2e2bcd8739ae039);


"use client";
var $3e56c60e7cf2a296$export$2e2bcd8739ae039 = (0, $c4c3f9798cb7fddc$export$2e2bcd8739ae039);



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $3c2a0dd82bab22bd$var$_excluded = [
    "onChange"
];
const $3c2a0dd82bab22bd$var$styles = {
    width: 99,
    height: 99,
    position: "absolute",
    top: -9999,
    overflow: "scroll"
};
function $3c2a0dd82bab22bd$export$2e2bcd8739ae039(props) {
    const { onChange: onChange } = props, other = (0, $3L80X.default)(props, $3c2a0dd82bab22bd$var$_excluded);
    const scrollbarHeight = $exYeM.useRef();
    const nodeRef = $exYeM.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $3e56c60e7cf2a296$export$2e2bcd8739ae039)(()=>{
        const handleResize = (0, $398f0b8aef852a12$export$2e2bcd8739ae039)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $181be504c47027d1$export$2e2bcd8739ae039)(nodeRef.current);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        onChange
    ]);
    $exYeM.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("div", (0, $aJx1R.default)({
        style: $3c2a0dd82bab22bd$var$styles,
        ref: nodeRef
    }, other));
}



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");


var $2f0D3 = parcelRequire("2f0D3");

parcelRequire("exYeM");

var $bPz57 = parcelRequire("bPz57");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $25392bed25b56063$export$2e2bcd8739ae039 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft");


parcelRequire("exYeM");

var $bPz57 = parcelRequire("bPz57");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $c872eae48424b2c4$export$2e2bcd8739ae039 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");




var $7PWLt = parcelRequire("7PWLt");

var $jawKn = parcelRequire("jawKn");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $ae9ef2f4727ba61d$export$34861783d3c2eef8(slot) {
    return (0, $dC5O8.default)("MuiTabScrollButton", slot);
}
const $ae9ef2f4727ba61d$var$tabScrollButtonClasses = (0, $kY7HX.default)("MuiTabScrollButton", [
    "root",
    "vertical",
    "horizontal",
    "disabled"
]);
var $ae9ef2f4727ba61d$export$2e2bcd8739ae039 = $ae9ef2f4727ba61d$var$tabScrollButtonClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $f138dae0a2b8c24e$var$_excluded = [
    "className",
    "slots",
    "slotProps",
    "direction",
    "orientation",
    "disabled"
];
const $f138dae0a2b8c24e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            disabled && "disabled"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $ae9ef2f4727ba61d$export$34861783d3c2eef8), classes);
};
const $f138dae0a2b8c24e$var$TabScrollButtonRoot = (0, $jawKn.default)((0, $8c6774266c067eb9$export$2e2bcd8739ae039), {
    name: "MuiTabScrollButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $aJx1R.default)({
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        [`&.${(0, $ae9ef2f4727ba61d$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 0
        }
    }, ownerState.orientation === "vertical" && {
        width: "100%",
        height: 40,
        "& svg": {
            transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
        }
    }));
const $f138dae0a2b8c24e$var$TabScrollButton = /*#__PURE__*/ $exYeM.forwardRef(function TabScrollButton(inProps, ref) {
    var _slots$StartScrollBut, _slots$EndScrollButto;
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiTabScrollButton"
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction } = props, other = (0, $3L80X.default)(props, $f138dae0a2b8c24e$var$_excluded);
    const isRtl = (0, $f6d0b5039025b20a$export$b2dd014b6c321cb)();
    const ownerState = (0, $aJx1R.default)({
        isRtl: isRtl
    }, props);
    const classes = $f138dae0a2b8c24e$var$useUtilityClasses(ownerState);
    const StartButtonIcon = (_slots$StartScrollBut = slots.StartScrollButtonIcon) != null ? _slots$StartScrollBut : (0, $25392bed25b56063$export$2e2bcd8739ae039);
    const EndButtonIcon = (_slots$EndScrollButto = slots.EndScrollButtonIcon) != null ? _slots$EndScrollButto : (0, $c872eae48424b2c4$export$2e2bcd8739ae039);
    const startButtonIconProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: "small"
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: "small"
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)($f138dae0a2b8c24e$var$TabScrollButtonRoot, (0, $aJx1R.default)({
        component: "div",
        className: (0, $4qr5a.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null
    }, other, {
        children: direction === "left" ? /*#__PURE__*/ (0, $aSiaI.jsx)(StartButtonIcon, (0, $aJx1R.default)({}, startButtonIconProps)) : /*#__PURE__*/ (0, $aSiaI.jsx)(EndButtonIcon, (0, $aJx1R.default)({}, endButtonIconProps))
    }));
});
var $f138dae0a2b8c24e$export$2e2bcd8739ae039 = $f138dae0a2b8c24e$var$TabScrollButton;




var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $27be272ccbc55083$export$cdd93bd054dec359(slot) {
    return (0, $dC5O8.default)("MuiTabs", slot);
}
const $27be272ccbc55083$var$tabsClasses = (0, $kY7HX.default)("MuiTabs", [
    "root",
    "vertical",
    "flexContainer",
    "flexContainerVertical",
    "centered",
    "scroller",
    "fixed",
    "scrollableX",
    "scrollableY",
    "hideScrollbar",
    "scrollButtons",
    "scrollButtonsHideMobile",
    "indicator"
]);
var $27be272ccbc55083$export$2e2bcd8739ae039 = $27be272ccbc55083$var$tabsClasses;



var $0a69054a0e524d5d$export$2e2bcd8739ae039 = (0, $0d47b1cc144b9266$export$2e2bcd8739ae039);




var $aSiaI = parcelRequire("aSiaI");
"use client";
const $c92bb10ff1efdcba$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "action",
    "centered",
    "children",
    "className",
    "component",
    "allowScrollButtonsMobile",
    "indicatorColor",
    "onChange",
    "orientation",
    "ScrollButtonComponent",
    "scrollButtons",
    "selectionFollowsFocus",
    "slots",
    "slotProps",
    "TabIndicatorProps",
    "TabScrollButtonProps",
    "textColor",
    "value",
    "variant",
    "visibleScrollbar"
];
const $c92bb10ff1efdcba$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $c92bb10ff1efdcba$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $c92bb10ff1efdcba$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $c92bb10ff1efdcba$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            vertical && "vertical"
        ],
        scroller: [
            "scroller",
            fixed && "fixed",
            hideScrollbar && "hideScrollbar",
            scrollableX && "scrollableX",
            scrollableY && "scrollableY"
        ],
        flexContainer: [
            "flexContainer",
            vertical && "flexContainerVertical",
            centered && "centered"
        ],
        indicator: [
            "indicator"
        ],
        scrollButtons: [
            "scrollButtons",
            scrollButtonsHideMobile && "scrollButtonsHideMobile"
        ],
        scrollableX: [
            scrollableX && "scrollableX"
        ],
        hideScrollbar: [
            hideScrollbar && "hideScrollbar"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $27be272ccbc55083$export$cdd93bd054dec359), classes);
};
const $c92bb10ff1efdcba$var$TabsRoot = (0, $jawKn.default)("div", {
    name: "MuiTabs",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $27be272ccbc55083$export$2e2bcd8739ae039).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $27be272ccbc55083$export$2e2bcd8739ae039).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $aJx1R.default)({
        overflow: "hidden",
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        display: "flex"
    }, ownerState.vertical && {
        flexDirection: "column"
    }, ownerState.scrollButtonsHideMobile && {
        [`& .${(0, $27be272ccbc55083$export$2e2bcd8739ae039).scrollButtons}`]: {
            [theme.breakpoints.down("sm")]: {
                display: "none"
            }
        }
    }));
const $c92bb10ff1efdcba$var$TabsScroller = (0, $jawKn.default)("div", {
    name: "MuiTabs",
    slot: "Scroller",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})(({ ownerState: ownerState })=>(0, $aJx1R.default)({
        position: "relative",
        display: "inline-block",
        flex: "1 1 auto",
        whiteSpace: "nowrap"
    }, ownerState.fixed && {
        overflowX: "hidden",
        width: "100%"
    }, ownerState.hideScrollbar && {
        // Hide dimensionless scrollbar on macOS
        scrollbarWidth: "none",
        // Firefox
        "&::-webkit-scrollbar": {
            display: "none" // Safari + Chrome
        }
    }, ownerState.scrollableX && {
        overflowX: "auto",
        overflowY: "hidden"
    }, ownerState.scrollableY && {
        overflowY: "auto",
        overflowX: "hidden"
    }));
const $c92bb10ff1efdcba$var$FlexContainer = (0, $jawKn.default)("div", {
    name: "MuiTabs",
    slot: "FlexContainer",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})(({ ownerState: ownerState })=>(0, $aJx1R.default)({
        display: "flex"
    }, ownerState.vertical && {
        flexDirection: "column"
    }, ownerState.centered && {
        justifyContent: "center"
    }));
const $c92bb10ff1efdcba$var$TabsIndicator = (0, $jawKn.default)("span", {
    name: "MuiTabs",
    slot: "Indicator",
    overridesResolver: (props, styles)=>styles.indicator
})(({ ownerState: ownerState, theme: theme })=>(0, $aJx1R.default)({
        position: "absolute",
        height: 2,
        bottom: 0,
        width: "100%",
        transition: theme.transitions.create()
    }, ownerState.indicatorColor === "primary" && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }, ownerState.indicatorColor === "secondary" && {
        backgroundColor: (theme.vars || theme).palette.secondary.main
    }, ownerState.vertical && {
        height: "100%",
        width: 2,
        right: 0
    }));
const $c92bb10ff1efdcba$var$TabsScrollbarSize = (0, $jawKn.default)((0, $3c2a0dd82bab22bd$export$2e2bcd8739ae039))({
    overflowX: "auto",
    overflowY: "hidden",
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: "none",
    // Firefox
    "&::-webkit-scrollbar": {
        display: "none" // Safari + Chrome
    }
});
const $c92bb10ff1efdcba$var$defaultIndicatorStyle = {};
let $c92bb10ff1efdcba$var$warnedOnceTabPresent = false;
const $c92bb10ff1efdcba$var$Tabs = /*#__PURE__*/ $exYeM.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiTabs"
    });
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const isRtl = (0, $f6d0b5039025b20a$export$b2dd014b6c321cb)();
    const { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = "div", allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = "primary", onChange: onChange, orientation: orientation = "horizontal", ScrollButtonComponent: ScrollButtonComponent = (0, $f138dae0a2b8c24e$export$2e2bcd8739ae039), scrollButtons: scrollButtons = "auto", selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: TabScrollButtonProps = {}, textColor: textColor = "primary", value: value, variant: variant = "standard", visibleScrollbar: visibleScrollbar = false } = props, other = (0, $3L80X.default)(props, $c92bb10ff1efdcba$var$_excluded);
    const scrollable = variant === "scrollable";
    const vertical = orientation === "vertical";
    const scrollStart = vertical ? "scrollTop" : "scrollLeft";
    const start = vertical ? "top" : "left";
    const end = vertical ? "bottom" : "right";
    const clientSize = vertical ? "clientHeight" : "clientWidth";
    const size = vertical ? "height" : "width";
    const ownerState = (0, $aJx1R.default)({}, props, {
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    });
    const classes = $c92bb10ff1efdcba$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $exYeM.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $exYeM.useState($c92bb10ff1efdcba$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $exYeM.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $exYeM.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $exYeM.useState(false);
    const [scrollerStyle, setScrollerStyle] = $exYeM.useState({
        overflow: "hidden",
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $exYeM.useRef(null);
    const tabListRef = $exYeM.useRef(null);
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $79701f59cd63314a$export$3c615b88e5d7e4f6)(tabsNode, isRtl ? "rtl" : "ltr"),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $d00700b704925555$export$2e2bcd8739ae039)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = "top";
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? "right" : "left";
            if (tabMeta && tabsMeta) {
                const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
            }
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        // IE11 support, replace with Number.isNaN
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $f3c5f43e0efe7ed8$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1);
            // Fix for Edge
            scrollValue *= isRtl && (0, $79701f59cd63314a$export$a10970ffb6510128)() === "reverse" ? -1 : 1;
        }
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $exYeM.useCallback((scrollbarWidth)=>{
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, []);
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $aSiaI.jsx)($c92bb10ff1efdcba$var$TabsScrollbarSize, {
            onChange: handleScrollbarSizeChange,
            className: (0, $4qr5a.default)(classes.scrollableX, classes.hideScrollbar)
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === "auto" && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $aSiaI.jsx)(ScrollButtonComponent, (0, $aJx1R.default)({
            slots: {
                StartScrollButtonIcon: slots.StartScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? "right" : "left",
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll
        }, TabScrollButtonProps, {
            className: (0, $4qr5a.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $aSiaI.jsx)(ScrollButtonComponent, (0, $aJx1R.default)({
            slots: {
                EndScrollButtonIcon: slots.EndScrollButtonIcon
            },
            slotProps: {
                endScrollButtonIcon: endScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? "left" : "right",
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll
        }, TabScrollButtonProps, {
            className: (0, $4qr5a.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $d00700b704925555$export$2e2bcd8739ae039)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $d00700b704925555$export$2e2bcd8739ae039)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $exYeM.useEffect(()=>{
        const handleResize = (0, $398f0b8aef852a12$export$2e2bcd8739ae039)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    var _resizeObserver2;
                    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $181be504c47027d1$export$2e2bcd8739ae039)(tabsRef.current);
        win.addEventListener("resize", handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== "undefined") {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            var _mutationObserver, _resizeObserver3;
            handleResize.clear();
            win.removeEventListener("resize", handleResize);
            (_mutationObserver = mutationObserver) == null || _mutationObserver.disconnect();
            (_resizeObserver3 = resizeObserver) == null || _resizeObserver3.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $exYeM.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== "undefined" && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp == null ? void 0 : childrenProp.length
    ]);
    $exYeM.useEffect(()=>{
        setMounted(true);
    }, []);
    $exYeM.useEffect(()=>{
        updateIndicatorState();
    });
    $exYeM.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($c92bb10ff1efdcba$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $exYeM.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const indicator = /*#__PURE__*/ (0, $aSiaI.jsx)($c92bb10ff1efdcba$var$TabsIndicator, (0, $aJx1R.default)({}, TabIndicatorProps, {
        className: (0, $4qr5a.default)(classes.indicator, TabIndicatorProps.className),
        ownerState: ownerState,
        style: (0, $aJx1R.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    let childIndex = 0;
    const children = $exYeM.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $exYeM.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $exYeM.cloneElement(child, (0, $aJx1R.default)({
            fullWidth: variant === "fullWidth",
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        }, childIndex === 1 && value === false && !child.props.tabIndex ? {
            tabIndex: 0
        } : {}));
    });
    const handleKeyDown = (event)=>{
        const list = tabListRef.current;
        const currentFocus = (0, $0a69054a0e524d5d$export$2e2bcd8739ae039)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute("role");
        if (role !== "tab") return;
        let previousItemKey = orientation === "horizontal" ? "ArrowLeft" : "ArrowUp";
        let nextItemKey = orientation === "horizontal" ? "ArrowRight" : "ArrowDown";
        if (orientation === "horizontal" && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = "ArrowRight";
            nextItemKey = "ArrowLeft";
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $c92bb10ff1efdcba$var$moveFocus(list, currentFocus, $c92bb10ff1efdcba$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $c92bb10ff1efdcba$var$moveFocus(list, currentFocus, $c92bb10ff1efdcba$var$nextItem);
                break;
            case "Home":
                event.preventDefault();
                $c92bb10ff1efdcba$var$moveFocus(list, null, $c92bb10ff1efdcba$var$nextItem);
                break;
            case "End":
                event.preventDefault();
                $c92bb10ff1efdcba$var$moveFocus(list, null, $c92bb10ff1efdcba$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($c92bb10ff1efdcba$var$TabsRoot, (0, $aJx1R.default)({
        className: (0, $4qr5a.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        as: component
    }, other, {
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $aSiaI.jsxs)($c92bb10ff1efdcba$var$TabsScroller, {
                className: classes.scroller,
                ownerState: ownerState,
                style: {
                    overflow: scrollerStyle.overflow,
                    [vertical ? `margin${isRtl ? "Left" : "Right"}` : "marginBottom"]: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
                },
                ref: tabsRef,
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)($c92bb10ff1efdcba$var$FlexContainer, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === "vertical" ? "vertical" : null,
                        className: classes.flexContainer,
                        ownerState: ownerState,
                        onKeyDown: handleKeyDown,
                        ref: tabListRef,
                        role: "tablist",
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    }));
});
var $c92bb10ff1efdcba$export$2e2bcd8739ae039 = $c92bb10ff1efdcba$var$Tabs;




var $aSiaI = parcelRequire("aSiaI");
"use client";
const $d0439740c0b4ed74$var$_excluded = [
    "children"
];
const $d0439740c0b4ed74$var$TabList = /*#__PURE__*/ $exYeM.forwardRef(function TabList(props, ref) {
    const { children: childrenProp } = props, other = (0, $3L80X.default)(props, $d0439740c0b4ed74$var$_excluded);
    const context = (0, $75a69f56048afb85$export$5a3bad273ac578e0)();
    if (context === null) throw new TypeError("No TabContext provided");
    const children = $exYeM.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $exYeM.isValidElement(child)) return null;
        return /*#__PURE__*/ $exYeM.cloneElement(child, {
            // SOMEDAY: `Tabs` will set those themselves
            "aria-controls": (0, $75a69f56048afb85$export$629f80328afcade5)(context, child.props.value),
            id: (0, $75a69f56048afb85$export$46f6d19d28231cb8)(context, child.props.value)
        });
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c92bb10ff1efdcba$export$2e2bcd8739ae039), (0, $aJx1R.default)({}, other, {
        ref: ref,
        value: context.value,
        children: children
    }));
});
var $d0439740c0b4ed74$export$2e2bcd8739ae039 = $d0439740c0b4ed74$var$TabList;



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $2f0D3 = parcelRequire("2f0D3");

var $dC5O8 = parcelRequire("dC5O8");

var $kY7HX = parcelRequire("kY7HX");
function $27589cf92b5078ea$export$cfb3da2e74936ec(slot) {
    return (0, $dC5O8.default)("MuiTabPanel", slot);
}
const $27589cf92b5078ea$var$tabPanelClasses = (0, $kY7HX.default)("MuiTabPanel", [
    "root"
]);
var $27589cf92b5078ea$export$2e2bcd8739ae039 = $27589cf92b5078ea$var$tabPanelClasses;




var $aSiaI = parcelRequire("aSiaI");
"use client";
const $3ec252815a085386$var$_excluded = [
    "children",
    "className",
    "value"
];
const $3ec252815a085386$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $27589cf92b5078ea$export$cfb3da2e74936ec), classes);
};
const $3ec252815a085386$var$TabPanelRoot = (0, $jawKn.default)("div", {
    name: "MuiTabPanel",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        padding: theme.spacing(3)
    }));
const $3ec252815a085386$var$TabPanel = /*#__PURE__*/ $exYeM.forwardRef(function TabPanel(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiTabPanel"
    });
    const { children: children, className: className, value: value } = props, other = (0, $3L80X.default)(props, $3ec252815a085386$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props);
    const classes = $3ec252815a085386$var$useUtilityClasses(ownerState);
    const context = (0, $75a69f56048afb85$export$5a3bad273ac578e0)();
    if (context === null) throw new TypeError("No TabContext provided");
    const id = (0, $75a69f56048afb85$export$629f80328afcade5)(context, value);
    const tabId = (0, $75a69f56048afb85$export$46f6d19d28231cb8)(context, value);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($3ec252815a085386$var$TabPanelRoot, (0, $aJx1R.default)({
        "aria-labelledby": tabId,
        className: (0, $4qr5a.default)(classes.root, className),
        hidden: value !== context.value,
        id: id,
        ref: ref,
        role: "tabpanel",
        ownerState: ownerState
    }, other, {
        children: value === context.value && children
    }));
});
var $3ec252815a085386$export$2e2bcd8739ae039 = $3ec252815a085386$var$TabPanel;



var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");


var $2f0D3 = parcelRequire("2f0D3");

var $fXwzw = parcelRequire("fXwzw");

var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $aJf2l = parcelRequire("aJf2l");

var $2f0D3 = parcelRequire("2f0D3");

var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");

var $fXwzw = parcelRequire("fXwzw");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $d3712bc2e139dec9$export$24c1f8f60cbac79e(slot) {
    return (0, $dC5O8.default)("MuiTypography", slot);
}
const $d3712bc2e139dec9$var$typographyClasses = (0, $kY7HX.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $d3712bc2e139dec9$export$2e2bcd8739ae039 = $d3712bc2e139dec9$var$typographyClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $680629a13f949ba0$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $680629a13f949ba0$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $fXwzw.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $d3712bc2e139dec9$export$24c1f8f60cbac79e), classes);
};
const $680629a13f949ba0$export$140e2f5526d3cad8 = (0, $jawKn.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $fXwzw.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        margin: 0
    }, ownerState.variant === "inherit" && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit"
    }, ownerState.variant !== "inherit" && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $680629a13f949ba0$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $680629a13f949ba0$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $680629a13f949ba0$var$transformDeprecatedColors = (color)=>{
    return $680629a13f949ba0$var$colorTransformations[color] || color;
};
const $680629a13f949ba0$var$Typography = /*#__PURE__*/ $exYeM.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $680629a13f949ba0$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $aJf2l.default)((0, $aJx1R.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $680629a13f949ba0$var$defaultVariantMapping } = props, other = (0, $3L80X.default)(props, $680629a13f949ba0$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $680629a13f949ba0$var$defaultVariantMapping[variant]) || "span";
    const classes = $680629a13f949ba0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($680629a13f949ba0$export$140e2f5526d3cad8, (0, $aJx1R.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $4qr5a.default)(classes.root, className)
    }, other));
});
var $680629a13f949ba0$export$2e2bcd8739ae039 = $680629a13f949ba0$var$Typography;



var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $aed8a238b76cb050$export$d6efab9620b78fec(slot) {
    return (0, $dC5O8.default)("MuiLink", slot);
}
const $aed8a238b76cb050$var$linkClasses = (0, $kY7HX.default)("MuiLink", [
    "root",
    "underlineNone",
    "underlineHover",
    "underlineAlways",
    "button",
    "focusVisible"
]);
var $aed8a238b76cb050$export$2e2bcd8739ae039 = $aed8a238b76cb050$var$linkClasses;



var $4GR9L = parcelRequire("4GR9L");

var $8L988 = parcelRequire("8L988");
const $6ed1720bb428d2f6$export$c4e140d5d351182b = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $6ed1720bb428d2f6$var$transformDeprecatedColors = (color)=>{
    return $6ed1720bb428d2f6$export$c4e140d5d351182b[color] || color;
};
const $6ed1720bb428d2f6$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = $6ed1720bb428d2f6$var$transformDeprecatedColors(ownerState.color);
    const color = (0, $4GR9L.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $4GR9L.getPath)(theme, `palette.${transformedColor}Channel`);
    if ("vars" in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $8L988.alpha)(color, 0.4);
};
var $6ed1720bb428d2f6$export$2e2bcd8739ae039 = $6ed1720bb428d2f6$var$getTextDecoration;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $c14ca1eac99fe440$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $c14ca1eac99fe440$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            "root",
            `underline${(0, $fXwzw.default)(underline)}`,
            component === "button" && "button",
            focusVisible && "focusVisible"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $aed8a238b76cb050$export$d6efab9620b78fec), classes);
};
const $c14ca1eac99fe440$var$LinkRoot = (0, $jawKn.default)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
    name: "MuiLink",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $fXwzw.default)(ownerState.underline)}`],
            ownerState.component === "button" && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $aJx1R.default)({}, ownerState.underline === "none" && {
        textDecoration: "none"
    }, ownerState.underline === "hover" && {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    }, ownerState.underline === "always" && (0, $aJx1R.default)({
        textDecoration: "underline"
    }, ownerState.color !== "inherit" && {
        textDecorationColor: (0, $6ed1720bb428d2f6$export$2e2bcd8739ae039)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        "&:hover": {
            textDecorationColor: "inherit"
        }
    }), ownerState.component === "button" && {
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        [`&.${(0, $aed8a238b76cb050$export$2e2bcd8739ae039).focusVisible}`]: {
            outline: "auto"
        }
    });
});
const $c14ca1eac99fe440$var$Link = /*#__PURE__*/ $exYeM.forwardRef(function Link(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiLink"
    });
    const { className: className, color: color = "primary", component: component = "a", onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = "always", variant: variant = "inherit", sx: sx } = props, other = (0, $3L80X.default)(props, $c14ca1eac99fe440$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $d231bcdf65c325cd$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $exYeM.useState(false);
    const handlerRef = (0, $69ecd4eca0914ac9$export$2e2bcd8739ae039)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $aJx1R.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $c14ca1eac99fe440$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($c14ca1eac99fe440$var$LinkRoot, (0, $aJx1R.default)({
        color: color,
        className: (0, $4qr5a.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, $6ed1720bb428d2f6$export$c4e140d5d351182b)).includes(color) ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
var $c14ca1eac99fe440$export$2e2bcd8739ae039 = $c14ca1eac99fe440$var$Link;



const $93231a89f687f087$export$ddc5e865495e96fb = ()=>/*#__PURE__*/ (0, $aSiaI.jsx)("h1", {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c14ca1eac99fe440$export$2e2bcd8739ae039), {
            component: (0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a),
            to: "/",
            children: "\uD83D\uDEA2 Nym Harbour Master"
        })
    });


/* eslint-disable react/no-unstable-nested-components */ 
var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $bac751230e4fc222$var$defaultOptions = {};
function $bac751230e4fc222$export$430a3269e24b912e() {
    return $bac751230e4fc222$var$defaultOptions;
}
function $bac751230e4fc222$export$95365be1b0704abc(newOptions) {
    $bac751230e4fc222$var$defaultOptions = newOptions;
}


function $78d3e8b7d5e47526$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $78d3e8b7d5e47526$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $78d3e8b7d5e47526$export$2e2bcd8739ae039(o);
}


function $b320e4b5494ae3f6$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $2285621ea3fa8491$export$2e2bcd8739ae039(argument) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $78d3e8b7d5e47526$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $f319ee1b0fdb288a$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}





function $0c02c7faee7ab2f0$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}







function $f23682b0b5b2d802$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}




function $1da06aa14904949d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}



function $1eff655f63a9bbd9$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    return (0, $f23682b0b5b2d802$export$2e2bcd8739ae039)(date).getTime() === (0, $1da06aa14904949d$export$2e2bcd8739ae039)(date).getTime();
}


function $f26794150f1b1a6c$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = (0, $f319ee1b0fdb288a$export$2e2bcd8739ae039)(dateLeft, dateRight);
    var difference = Math.abs((0, $0c02c7faee7ab2f0$export$2e2bcd8739ae039)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $f319ee1b0fdb288a$export$2e2bcd8739ae039)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $1eff655f63a9bbd9$export$2e2bcd8739ae039)((0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateLeft)) && difference === 1 && (0, $f319ee1b0fdb288a$export$2e2bcd8739ae039)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}




function $c03b34c4f5393ff7$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    return (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dateLeft).getTime() - (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dateRight).getTime();
}



var $40cb9277785070a4$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $40cb9277785070a4$var$defaultRoundingMethod = "trunc";
function $40cb9277785070a4$export$b6474a47258c1211(method) {
    return method ? $40cb9277785070a4$var$roundingMap[method] : $40cb9277785070a4$var$roundingMap[$40cb9277785070a4$var$defaultRoundingMethod];
}


function $cf34d7234eab092f$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $c03b34c4f5393ff7$export$2e2bcd8739ae039)(dateLeft, dateRight) / 1000;
    return (0, $40cb9277785070a4$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}


var $9d3b8f1bbb60dc8e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $9d3b8f1bbb60dc8e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $9d3b8f1bbb60dc8e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $9d3b8f1bbb60dc8e$export$2e2bcd8739ae039 = $9d3b8f1bbb60dc8e$var$formatDistance;


function $772b9d5c5acb67c6$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $adadf9b5f344c056$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $adadf9b5f344c056$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $adadf9b5f344c056$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $adadf9b5f344c056$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $adadf9b5f344c056$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $adadf9b5f344c056$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $adadf9b5f344c056$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $adadf9b5f344c056$export$2e2bcd8739ae039 = $adadf9b5f344c056$var$formatLong;


var $27b07b6969b3b18a$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $27b07b6969b3b18a$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $27b07b6969b3b18a$var$formatRelativeLocale[token];
};
var $27b07b6969b3b18a$export$2e2bcd8739ae039 = $27b07b6969b3b18a$var$formatRelative;


function $2ca886d2c8d77e4d$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $17da716efdeaa8e3$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $17da716efdeaa8e3$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $17da716efdeaa8e3$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $17da716efdeaa8e3$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $17da716efdeaa8e3$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $17da716efdeaa8e3$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $17da716efdeaa8e3$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $17da716efdeaa8e3$var$localize = {
    ordinalNumber: $17da716efdeaa8e3$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $17da716efdeaa8e3$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $17da716efdeaa8e3$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $17da716efdeaa8e3$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $17da716efdeaa8e3$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $17da716efdeaa8e3$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $17da716efdeaa8e3$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $17da716efdeaa8e3$export$2e2bcd8739ae039 = $17da716efdeaa8e3$var$localize;


function $d8d845ab692d6dea$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $d8d845ab692d6dea$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $d8d845ab692d6dea$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $d8d845ab692d6dea$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $d8d845ab692d6dea$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $85cdfad058df8fd3$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $a0618466070b1817$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $a0618466070b1817$var$parseOrdinalNumberPattern = /\d+/i;
var $a0618466070b1817$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $a0618466070b1817$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $a0618466070b1817$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $a0618466070b1817$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $a0618466070b1817$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $a0618466070b1817$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $a0618466070b1817$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $a0618466070b1817$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $a0618466070b1817$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $a0618466070b1817$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $a0618466070b1817$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $a0618466070b1817$var$matchOrdinalNumberPattern,
        parsePattern: $a0618466070b1817$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a0618466070b1817$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a0618466070b1817$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a0618466070b1817$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a0618466070b1817$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a0618466070b1817$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a0618466070b1817$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a0618466070b1817$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a0618466070b1817$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a0618466070b1817$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $a0618466070b1817$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $a0618466070b1817$export$2e2bcd8739ae039 = $a0618466070b1817$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $b4f914fe53c31e55$var$locale = {
    code: "en-US",
    formatDistance: (0, $9d3b8f1bbb60dc8e$export$2e2bcd8739ae039),
    formatLong: (0, $adadf9b5f344c056$export$2e2bcd8739ae039),
    formatRelative: (0, $27b07b6969b3b18a$export$2e2bcd8739ae039),
    localize: (0, $17da716efdeaa8e3$export$2e2bcd8739ae039),
    match: (0, $a0618466070b1817$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $b4f914fe53c31e55$export$2e2bcd8739ae039 = $b4f914fe53c31e55$var$locale;


var $118b19c6d90f072d$export$2e2bcd8739ae039 = (0, $b4f914fe53c31e55$export$2e2bcd8739ae039);



function $c58087165184dc10$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}


function $2af75fecfbb4da0a$export$2e2bcd8739ae039(object) {
    return (0, $c58087165184dc10$export$2e2bcd8739ae039)({}, object);
}



/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $34df346d5c5052d9$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}



var $671507671fa5a6e8$var$MINUTES_IN_DAY = 1440;
var $671507671fa5a6e8$var$MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var $671507671fa5a6e8$var$MINUTES_IN_MONTH = 43200;
var $671507671fa5a6e8$var$MINUTES_IN_TWO_MONTHS = 86400;
function $671507671fa5a6e8$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale;
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $bac751230e4fc222$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $118b19c6d90f072d$export$2e2bcd8739ae039);
    if (!locale.formatDistance) throw new RangeError("locale must contain formatDistance property");
    var comparison = (0, $f319ee1b0fdb288a$export$2e2bcd8739ae039)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    var localizeOptions = (0, $c58087165184dc10$export$2e2bcd8739ae039)((0, $2af75fecfbb4da0a$export$2e2bcd8739ae039)(options), {
        addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyBaseDate);
        dateRight = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    } else {
        dateLeft = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
        dateRight = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyBaseDate);
    }
    var seconds = (0, $cf34d7234eab092f$export$2e2bcd8739ae039)(dateRight, dateLeft);
    var offsetInSeconds = ((0, $34df346d5c5052d9$export$2e2bcd8739ae039)(dateRight) - (0, $34df346d5c5052d9$export$2e2bcd8739ae039)(dateLeft)) / 1000;
    var minutes = Math.round((seconds - offsetInSeconds) / 60);
    var months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options !== null && options !== void 0 && options.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < $671507671fa5a6e8$var$MINUTES_IN_DAY) {
        var hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < $671507671fa5a6e8$var$MINUTES_IN_ALMOST_TWO_DAYS) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < $671507671fa5a6e8$var$MINUTES_IN_MONTH) {
        var days = Math.round(minutes / $671507671fa5a6e8$var$MINUTES_IN_DAY);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $671507671fa5a6e8$var$MINUTES_IN_TWO_MONTHS) {
        months = Math.round(minutes / $671507671fa5a6e8$var$MINUTES_IN_MONTH);
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $f26794150f1b1a6c$export$2e2bcd8739ae039)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        var nearestMonth = Math.round(minutes / $671507671fa5a6e8$var$MINUTES_IN_MONTH);
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        var monthsSinceStartOfYear = months % 12;
        var years = Math.floor(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}



function $08c0c798d1b2bf8a$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    return (0, $671507671fa5a6e8$export$2e2bcd8739ae039)(dirtyDate, Date.now(), options);
}


/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ // Is this type a tuple?
// If this type is a tuple, what indices are allowed?
///
function $829253db717f8f1b$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $829253db717f8f1b$export$8793edee2d425525() {
//
}
function $829253db717f8f1b$export$2b5605d8069324bd(key, instance) {
    return (updater)=>{
        instance.setState((old)=>{
            return {
                ...old,
                [key]: $829253db717f8f1b$export$7f095f455ad5af3f(updater, old[key])
            };
        });
    };
}
function $829253db717f8f1b$export$f6e2535fb5126e54(d) {
    return d instanceof Function;
}
function $829253db717f8f1b$export$5cd576d1827d40c8(d) {
    return Array.isArray(d) && d.every((val)=>typeof val === "number");
}
function $829253db717f8f1b$export$bf4548421d1b2c8(arr, getChildren) {
    const flat = [];
    const recurse = (subArr)=>{
        subArr.forEach((item)=>{
            flat.push(item);
            const children = getChildren(item);
            if (children != null && children.length) recurse(children);
        });
    };
    recurse(arr);
    return flat;
}
function $829253db717f8f1b$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = [];
    let result;
    return (depArgs)=>{
        let depTime;
        if (opts.key && opts.debug) depTime = Date.now();
        const newDeps = getDeps(depArgs);
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && opts.debug) resultTime = Date.now();
        result = fn(...newDeps);
        opts == null || opts.onChange == null || opts.onChange(result);
        if (opts.key && opts.debug) {
            if (opts != null && opts.debug()) {
                const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
                const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
                const resultFpsPercentage = resultEndTime / 16;
                const pad = (str, num)=>{
                    str = String(str);
                    while(str.length < num)str = " " + str;
                    return str;
                };
                console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
            }
        }
        return result;
    };
}
function $829253db717f8f1b$export$b1f82222dc43996c(tableOptions, debugLevel, key, onChange) {
    return {
        debug: ()=>{
            var _tableOptions$debugAl;
            return (_tableOptions$debugAl = tableOptions == null ? void 0 : tableOptions.debugAll) != null ? _tableOptions$debugAl : tableOptions[debugLevel];
        },
        key: false,
        onChange: onChange
    };
}
function $829253db717f8f1b$export$1bfa986e9c92c0b5(table, columnDef, depth, parent) {
    var _ref, _resolvedColumnDef$id;
    const defaultColumn = table._getDefaultColumnDef();
    const resolvedColumnDef = {
        ...defaultColumn,
        ...columnDef
    };
    const accessorKey = resolvedColumnDef.accessorKey;
    let id = (_ref = (_resolvedColumnDef$id = resolvedColumnDef.id) != null ? _resolvedColumnDef$id : accessorKey ? accessorKey.replace(".", "_") : undefined) != null ? _ref : typeof resolvedColumnDef.header === "string" ? resolvedColumnDef.header : undefined;
    let accessorFn;
    if (resolvedColumnDef.accessorFn) accessorFn = resolvedColumnDef.accessorFn;
    else if (accessorKey) {
        // Support deep accessor keys
        if (accessorKey.includes(".")) accessorFn = (originalRow)=>{
            let result = originalRow;
            for (const key of accessorKey.split(".")){
                var _result;
                result = (_result = result) == null ? void 0 : _result[key];
            }
            return result;
        };
        else accessorFn = (originalRow)=>originalRow[resolvedColumnDef.accessorKey];
    }
    if (!id) throw new Error();
    let column = {
        id: `${String(id)}`,
        accessorFn: accessorFn,
        parent: parent,
        depth: depth,
        columnDef: resolvedColumnDef,
        columns: [],
        getFlatColumns: $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                true
            ], ()=>{
            var _column$columns;
            return [
                column,
                ...(_column$columns = column.columns) == null ? void 0 : _column$columns.flatMap((d)=>d.getFlatColumns())
            ];
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugColumns", "column.getFlatColumns")),
        getLeafColumns: $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table._getOrderColumnsFn()
            ], (orderColumns)=>{
            var _column$columns2;
            if ((_column$columns2 = column.columns) != null && _column$columns2.length) {
                let leafColumns = column.columns.flatMap((column)=>column.getLeafColumns());
                return orderColumns(leafColumns);
            }
            return [
                column
            ];
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugColumns", "column.getLeafColumns"))
    };
    for (const feature of table._features)feature.createColumn == null || feature.createColumn(column, table);
    // Yes, we have to convert table to uknown, because we know more than the compiler here.
    return column;
}
const $829253db717f8f1b$var$debug = "debugHeaders";
//
function $829253db717f8f1b$var$createHeader(table, column, options) {
    var _options$id;
    const id = (_options$id = options.id) != null ? _options$id : column.id;
    let header = {
        id: id,
        column: column,
        index: options.index,
        isPlaceholder: !!options.isPlaceholder,
        placeholderId: options.placeholderId,
        depth: options.depth,
        subHeaders: [],
        colSpan: 0,
        rowSpan: 0,
        headerGroup: null,
        getLeafHeaders: ()=>{
            const leafHeaders = [];
            const recurseHeader = (h)=>{
                if (h.subHeaders && h.subHeaders.length) h.subHeaders.map(recurseHeader);
                leafHeaders.push(h);
            };
            recurseHeader(header);
            return leafHeaders;
        },
        getContext: ()=>({
                table: table,
                header: header,
                column: column
            })
    };
    table._features.forEach((feature)=>{
        feature.createHeader == null || feature.createHeader(header, table);
    });
    return header;
}
const $829253db717f8f1b$export$79b704688b15c0f4 = {
    createTable: (table)=>{
        // Header Groups
        table.getHeaderGroups = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, left, right)=>{
            var _left$map$filter, _right$map$filter;
            const leftColumns = (_left$map$filter = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter : [];
            const rightColumns = (_right$map$filter = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter : [];
            const centerColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
            const headerGroups = $829253db717f8f1b$export$d8c3a8af36458fc3(allColumns, [
                ...leftColumns,
                ...centerColumns,
                ...rightColumns
            ], table);
            return headerGroups;
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getHeaderGroups"));
        table.getCenterHeaderGroups = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, left, right)=>{
            leafColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
            return $829253db717f8f1b$export$d8c3a8af36458fc3(allColumns, leafColumns, table, "center");
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getCenterHeaderGroups"));
        table.getLeftHeaderGroups = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left
            ], (allColumns, leafColumns, left)=>{
            var _left$map$filter2;
            const orderedLeafColumns = (_left$map$filter2 = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter2 : [];
            return $829253db717f8f1b$export$d8c3a8af36458fc3(allColumns, orderedLeafColumns, table, "left");
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getLeftHeaderGroups"));
        table.getRightHeaderGroups = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.right
            ], (allColumns, leafColumns, right)=>{
            var _right$map$filter2;
            const orderedLeafColumns = (_right$map$filter2 = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter2 : [];
            return $829253db717f8f1b$export$d8c3a8af36458fc3(allColumns, orderedLeafColumns, table, "right");
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getRightHeaderGroups"));
        // Footer Groups
        table.getFooterGroups = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getFooterGroups"));
        table.getLeftFooterGroups = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getLeftFooterGroups"));
        table.getCenterFooterGroups = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getCenterHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getCenterFooterGroups"));
        table.getRightFooterGroups = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getRightHeaderGroups()
            ], (headerGroups)=>{
            return [
                ...headerGroups
            ].reverse();
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getRightFooterGroups"));
        // Flat Headers
        table.getFlatHeaders = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getHeaderGroups()
            ], (headerGroups)=>{
            return headerGroups.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getFlatHeaders"));
        table.getLeftFlatHeaders = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getLeftFlatHeaders"));
        table.getCenterFlatHeaders = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getCenterHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getCenterFlatHeaders"));
        table.getRightFlatHeaders = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getRightHeaderGroups()
            ], (left)=>{
            return left.map((headerGroup)=>{
                return headerGroup.headers;
            }).flat();
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getRightFlatHeaders"));
        // Leaf Headers
        table.getCenterLeafHeaders = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getCenterFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders;
                return !((_header$subHeaders = header.subHeaders) != null && _header$subHeaders.length);
            });
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getCenterLeafHeaders"));
        table.getLeftLeafHeaders = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getLeftFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders2;
                return !((_header$subHeaders2 = header.subHeaders) != null && _header$subHeaders2.length);
            });
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getLeftLeafHeaders"));
        table.getRightLeafHeaders = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getRightFlatHeaders()
            ], (flatHeaders)=>{
            return flatHeaders.filter((header)=>{
                var _header$subHeaders3;
                return !((_header$subHeaders3 = header.subHeaders) != null && _header$subHeaders3.length);
            });
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getRightLeafHeaders"));
        table.getLeafHeaders = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getLeftHeaderGroups(),
                table.getCenterHeaderGroups(),
                table.getRightHeaderGroups()
            ], (left, center, right)=>{
            var _left$0$headers, _left$, _center$0$headers, _center$, _right$0$headers, _right$;
            return [
                ...(_left$0$headers = (_left$ = left[0]) == null ? void 0 : _left$.headers) != null ? _left$0$headers : [],
                ...(_center$0$headers = (_center$ = center[0]) == null ? void 0 : _center$.headers) != null ? _center$0$headers : [],
                ...(_right$0$headers = (_right$ = right[0]) == null ? void 0 : _right$.headers) != null ? _right$0$headers : []
            ].map((header)=>{
                return header.getLeafHeaders();
            }).flat();
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, $829253db717f8f1b$var$debug, "getLeafHeaders"));
    }
};
function $829253db717f8f1b$export$d8c3a8af36458fc3(allColumns, columnsToGroup, table, headerFamily) {
    var _headerGroups$0$heade, _headerGroups$;
    // Find the max depth of the columns:
    // build the leaf column row
    // build each buffer row going up
    //    placeholder for non-existent level
    //    real column for existing level
    let maxDepth = 0;
    const findMaxDepth = function(columns, depth) {
        if (depth === void 0) depth = 1;
        maxDepth = Math.max(maxDepth, depth);
        columns.filter((column)=>column.getIsVisible()).forEach((column)=>{
            var _column$columns;
            if ((_column$columns = column.columns) != null && _column$columns.length) findMaxDepth(column.columns, depth + 1);
        }, 0);
    };
    findMaxDepth(allColumns);
    let headerGroups = [];
    const createHeaderGroup = (headersToGroup, depth)=>{
        // The header group we are creating
        const headerGroup = {
            depth: depth,
            id: [
                headerFamily,
                `${depth}`
            ].filter(Boolean).join("_"),
            headers: []
        };
        // The parent columns we're going to scan next
        const pendingParentHeaders = [];
        // Scan each column for parents
        headersToGroup.forEach((headerToGroup)=>{
            // What is the latest (last) parent column?
            const latestPendingParentHeader = [
                ...pendingParentHeaders
            ].reverse()[0];
            const isLeafHeader = headerToGroup.column.depth === headerGroup.depth;
            let column;
            let isPlaceholder = false;
            if (isLeafHeader && headerToGroup.column.parent) // The parent header is new
            column = headerToGroup.column.parent;
            else {
                // The parent header is repeated
                column = headerToGroup.column;
                isPlaceholder = true;
            }
            if (latestPendingParentHeader && (latestPendingParentHeader == null ? void 0 : latestPendingParentHeader.column) === column) // This column is repeated. Add it as a sub header to the next batch
            latestPendingParentHeader.subHeaders.push(headerToGroup);
            else {
                // This is a new header. Let's create it
                const header = $829253db717f8f1b$var$createHeader(table, column, {
                    id: [
                        headerFamily,
                        depth,
                        column.id,
                        headerToGroup == null ? void 0 : headerToGroup.id
                    ].filter(Boolean).join("_"),
                    isPlaceholder: isPlaceholder,
                    placeholderId: isPlaceholder ? `${pendingParentHeaders.filter((d)=>d.column === column).length}` : undefined,
                    depth: depth,
                    index: pendingParentHeaders.length
                });
                // Add the headerToGroup as a subHeader of the new header
                header.subHeaders.push(headerToGroup);
                // Add the new header to the pendingParentHeaders to get grouped
                // in the next batch
                pendingParentHeaders.push(header);
            }
            headerGroup.headers.push(headerToGroup);
            headerToGroup.headerGroup = headerGroup;
        });
        headerGroups.push(headerGroup);
        if (depth > 0) createHeaderGroup(pendingParentHeaders, depth - 1);
    };
    const bottomHeaders = columnsToGroup.map((column, index)=>$829253db717f8f1b$var$createHeader(table, column, {
            depth: maxDepth,
            index: index
        }));
    createHeaderGroup(bottomHeaders, maxDepth - 1);
    headerGroups.reverse();
    // headerGroups = headerGroups.filter(headerGroup => {
    //   return !headerGroup.headers.every(header => header.isPlaceholder)
    // })
    const recurseHeadersForSpans = (headers)=>{
        const filteredHeaders = headers.filter((header)=>header.column.getIsVisible());
        return filteredHeaders.map((header)=>{
            let colSpan = 0;
            let rowSpan = 0;
            let childRowSpans = [
                0
            ];
            if (header.subHeaders && header.subHeaders.length) {
                childRowSpans = [];
                recurseHeadersForSpans(header.subHeaders).forEach((_ref)=>{
                    let { colSpan: childColSpan, rowSpan: childRowSpan } = _ref;
                    colSpan += childColSpan;
                    childRowSpans.push(childRowSpan);
                });
            } else colSpan = 1;
            const minChildRowSpan = Math.min(...childRowSpans);
            rowSpan = rowSpan + minChildRowSpan;
            header.colSpan = colSpan;
            header.rowSpan = rowSpan;
            return {
                colSpan: colSpan,
                rowSpan: rowSpan
            };
        });
    };
    recurseHeadersForSpans((_headerGroups$0$heade = (_headerGroups$ = headerGroups[0]) == null ? void 0 : _headerGroups$.headers) != null ? _headerGroups$0$heade : []);
    return headerGroups;
}
//
//
const $829253db717f8f1b$export$2f660993f4eb1f29 = {
    size: 150,
    minSize: 20,
    maxSize: Number.MAX_SAFE_INTEGER
};
const $829253db717f8f1b$var$getDefaultColumnSizingInfoState = ()=>({
        startOffset: null,
        startSize: null,
        deltaOffset: null,
        deltaPercentage: null,
        isResizingColumn: false,
        columnSizingStart: []
    });
const $829253db717f8f1b$export$9916c85814812d4a = {
    getDefaultColumnDef: ()=>{
        return $829253db717f8f1b$export$2f660993f4eb1f29;
    },
    getInitialState: (state)=>{
        return {
            columnSizing: {},
            columnSizingInfo: $829253db717f8f1b$var$getDefaultColumnSizingInfoState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            columnResizeMode: "onEnd",
            columnResizeDirection: "ltr",
            onColumnSizingChange: $829253db717f8f1b$export$2b5605d8069324bd("columnSizing", table),
            onColumnSizingInfoChange: $829253db717f8f1b$export$2b5605d8069324bd("columnSizingInfo", table)
        };
    },
    createColumn: (column, table)=>{
        column.getSize = ()=>{
            var _column$columnDef$min, _ref, _column$columnDef$max;
            const columnSize = table.getState().columnSizing[column.id];
            return Math.min(Math.max((_column$columnDef$min = column.columnDef.minSize) != null ? _column$columnDef$min : $829253db717f8f1b$export$2f660993f4eb1f29.minSize, (_ref = columnSize != null ? columnSize : column.columnDef.size) != null ? _ref : $829253db717f8f1b$export$2f660993f4eb1f29.size), (_column$columnDef$max = column.columnDef.maxSize) != null ? _column$columnDef$max : $829253db717f8f1b$export$2f660993f4eb1f29.maxSize);
        };
        column.getStart = $829253db717f8f1b$export$7c73462e0d25e514((position)=>[
                position,
                $829253db717f8f1b$export$1d7c103713892a11(table, position),
                table.getState().columnSizing
            ], (position, columns)=>columns.slice(0, column.getIndex(position)).reduce((sum, column)=>sum + column.getSize(), 0), $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugColumns", "getStart"));
        column.getAfter = $829253db717f8f1b$export$7c73462e0d25e514((position)=>[
                position,
                $829253db717f8f1b$export$1d7c103713892a11(table, position),
                table.getState().columnSizing
            ], (position, columns)=>columns.slice(column.getIndex(position) + 1).reduce((sum, column)=>sum + column.getSize(), 0), $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugColumns", "getAfter"));
        column.resetSize = ()=>{
            table.setColumnSizing((_ref2)=>{
                let { [column.id]: _, ...rest } = _ref2;
                return rest;
            });
        };
        column.getCanResize = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableResizing) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnResizing) != null ? _table$options$enable : true);
        };
        column.getIsResizing = ()=>{
            return table.getState().columnSizingInfo.isResizingColumn === column.id;
        };
    },
    createHeader: (header, table)=>{
        header.getSize = ()=>{
            let sum = 0;
            const recurse = (header)=>{
                if (header.subHeaders.length) header.subHeaders.forEach(recurse);
                else {
                    var _header$column$getSiz;
                    sum += (_header$column$getSiz = header.column.getSize()) != null ? _header$column$getSiz : 0;
                }
            };
            recurse(header);
            return sum;
        };
        header.getStart = ()=>{
            if (header.index > 0) {
                const prevSiblingHeader = header.headerGroup.headers[header.index - 1];
                return prevSiblingHeader.getStart() + prevSiblingHeader.getSize();
            }
            return 0;
        };
        header.getResizeHandler = (_contextDocument)=>{
            const column = table.getColumn(header.column.id);
            const canResize = column == null ? void 0 : column.getCanResize();
            return (e)=>{
                if (!column || !canResize) return;
                e.persist == null || e.persist();
                if ($829253db717f8f1b$var$isTouchStartEvent(e)) {
                    // lets not respond to multiple touches (e.g. 2 or 3 fingers)
                    if (e.touches && e.touches.length > 1) return;
                }
                const startSize = header.getSize();
                const columnSizingStart = header ? header.getLeafHeaders().map((d)=>[
                        d.column.id,
                        d.column.getSize()
                    ]) : [
                    [
                        column.id,
                        column.getSize()
                    ]
                ];
                const clientX = $829253db717f8f1b$var$isTouchStartEvent(e) ? Math.round(e.touches[0].clientX) : e.clientX;
                const newColumnSizing = {};
                const updateOffset = (eventType, clientXPos)=>{
                    if (typeof clientXPos !== "number") return;
                    table.setColumnSizingInfo((old)=>{
                        var _old$startOffset, _old$startSize;
                        const deltaDirection = table.options.columnResizeDirection === "rtl" ? -1 : 1;
                        const deltaOffset = (clientXPos - ((_old$startOffset = old == null ? void 0 : old.startOffset) != null ? _old$startOffset : 0)) * deltaDirection;
                        const deltaPercentage = Math.max(deltaOffset / ((_old$startSize = old == null ? void 0 : old.startSize) != null ? _old$startSize : 0), -0.999999);
                        old.columnSizingStart.forEach((_ref3)=>{
                            let [columnId, headerSize] = _ref3;
                            newColumnSizing[columnId] = Math.round(Math.max(headerSize + headerSize * deltaPercentage, 0) * 100) / 100;
                        });
                        return {
                            ...old,
                            deltaOffset: deltaOffset,
                            deltaPercentage: deltaPercentage
                        };
                    });
                    if (table.options.columnResizeMode === "onChange" || eventType === "end") table.setColumnSizing((old)=>({
                            ...old,
                            ...newColumnSizing
                        }));
                };
                const onMove = (clientXPos)=>updateOffset("move", clientXPos);
                const onEnd = (clientXPos)=>{
                    updateOffset("end", clientXPos);
                    table.setColumnSizingInfo((old)=>({
                            ...old,
                            isResizingColumn: false,
                            startOffset: null,
                            startSize: null,
                            deltaOffset: null,
                            deltaPercentage: null,
                            columnSizingStart: []
                        }));
                };
                const contextDocument = _contextDocument || typeof document !== "undefined" ? document : null;
                const mouseEvents = {
                    moveHandler: (e)=>onMove(e.clientX),
                    upHandler: (e)=>{
                        contextDocument == null || contextDocument.removeEventListener("mousemove", mouseEvents.moveHandler);
                        contextDocument == null || contextDocument.removeEventListener("mouseup", mouseEvents.upHandler);
                        onEnd(e.clientX);
                    }
                };
                const touchEvents = {
                    moveHandler: (e)=>{
                        if (e.cancelable) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        onMove(e.touches[0].clientX);
                        return false;
                    },
                    upHandler: (e)=>{
                        var _e$touches$;
                        contextDocument == null || contextDocument.removeEventListener("touchmove", touchEvents.moveHandler);
                        contextDocument == null || contextDocument.removeEventListener("touchend", touchEvents.upHandler);
                        if (e.cancelable) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        onEnd((_e$touches$ = e.touches[0]) == null ? void 0 : _e$touches$.clientX);
                    }
                };
                const passiveIfSupported = $829253db717f8f1b$export$4927b5943c7c0b4() ? {
                    passive: false
                } : false;
                if ($829253db717f8f1b$var$isTouchStartEvent(e)) {
                    contextDocument == null || contextDocument.addEventListener("touchmove", touchEvents.moveHandler, passiveIfSupported);
                    contextDocument == null || contextDocument.addEventListener("touchend", touchEvents.upHandler, passiveIfSupported);
                } else {
                    contextDocument == null || contextDocument.addEventListener("mousemove", mouseEvents.moveHandler, passiveIfSupported);
                    contextDocument == null || contextDocument.addEventListener("mouseup", mouseEvents.upHandler, passiveIfSupported);
                }
                table.setColumnSizingInfo((old)=>({
                        ...old,
                        startOffset: clientX,
                        startSize: startSize,
                        deltaOffset: 0,
                        deltaPercentage: 0,
                        columnSizingStart: columnSizingStart,
                        isResizingColumn: column.id
                    }));
            };
        };
    },
    createTable: (table)=>{
        table.setColumnSizing = (updater)=>table.options.onColumnSizingChange == null ? void 0 : table.options.onColumnSizingChange(updater);
        table.setColumnSizingInfo = (updater)=>table.options.onColumnSizingInfoChange == null ? void 0 : table.options.onColumnSizingInfoChange(updater);
        table.resetColumnSizing = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnSizing(defaultState ? {} : (_table$initialState$c = table.initialState.columnSizing) != null ? _table$initialState$c : {});
        };
        table.resetHeaderSizeInfo = (defaultState)=>{
            var _table$initialState$c2;
            table.setColumnSizingInfo(defaultState ? $829253db717f8f1b$var$getDefaultColumnSizingInfoState() : (_table$initialState$c2 = table.initialState.columnSizingInfo) != null ? _table$initialState$c2 : $829253db717f8f1b$var$getDefaultColumnSizingInfoState());
        };
        table.getTotalSize = ()=>{
            var _table$getHeaderGroup, _table$getHeaderGroup2;
            return (_table$getHeaderGroup = (_table$getHeaderGroup2 = table.getHeaderGroups()[0]) == null ? void 0 : _table$getHeaderGroup2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getHeaderGroup : 0;
        };
        table.getLeftTotalSize = ()=>{
            var _table$getLeftHeaderG, _table$getLeftHeaderG2;
            return (_table$getLeftHeaderG = (_table$getLeftHeaderG2 = table.getLeftHeaderGroups()[0]) == null ? void 0 : _table$getLeftHeaderG2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getLeftHeaderG : 0;
        };
        table.getCenterTotalSize = ()=>{
            var _table$getCenterHeade, _table$getCenterHeade2;
            return (_table$getCenterHeade = (_table$getCenterHeade2 = table.getCenterHeaderGroups()[0]) == null ? void 0 : _table$getCenterHeade2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getCenterHeade : 0;
        };
        table.getRightTotalSize = ()=>{
            var _table$getRightHeader, _table$getRightHeader2;
            return (_table$getRightHeader = (_table$getRightHeader2 = table.getRightHeaderGroups()[0]) == null ? void 0 : _table$getRightHeader2.headers.reduce((sum, header)=>{
                return sum + header.getSize();
            }, 0)) != null ? _table$getRightHeader : 0;
        };
    }
};
let $829253db717f8f1b$var$passiveSupported = null;
function $829253db717f8f1b$export$4927b5943c7c0b4() {
    if (typeof $829253db717f8f1b$var$passiveSupported === "boolean") return $829253db717f8f1b$var$passiveSupported;
    let supported = false;
    try {
        const options = {
            get passive () {
                supported = true;
                return false;
            }
        };
        const noop = ()=>{};
        window.addEventListener("test", noop, options);
        window.removeEventListener("test", noop);
    } catch (err) {
        supported = false;
    }
    $829253db717f8f1b$var$passiveSupported = supported;
    return $829253db717f8f1b$var$passiveSupported;
}
function $829253db717f8f1b$var$isTouchStartEvent(e) {
    return e.type === "touchstart";
}
//
const $829253db717f8f1b$export$c9bad30efcce6e0c = {
    getInitialState: (state)=>{
        return {
            expanded: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onExpandedChange: $829253db717f8f1b$export$2b5605d8069324bd("expanded", table),
            paginateExpandedRows: true
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        table._autoResetExpanded = ()=>{
            var _ref, _table$options$autoRe;
            if (!registered) {
                table._queue(()=>{
                    registered = true;
                });
                return;
            }
            if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetExpanded) != null ? _ref : !table.options.manualExpanding) {
                if (queued) return;
                queued = true;
                table._queue(()=>{
                    table.resetExpanded();
                    queued = false;
                });
            }
        };
        table.setExpanded = (updater)=>table.options.onExpandedChange == null ? void 0 : table.options.onExpandedChange(updater);
        table.toggleAllRowsExpanded = (expanded)=>{
            if (expanded != null ? expanded : !table.getIsAllRowsExpanded()) table.setExpanded(true);
            else table.setExpanded({});
        };
        table.resetExpanded = (defaultState)=>{
            var _table$initialState$e, _table$initialState;
            table.setExpanded(defaultState ? {} : (_table$initialState$e = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.expanded) != null ? _table$initialState$e : {});
        };
        table.getCanSomeRowsExpand = ()=>{
            return table.getPrePaginationRowModel().flatRows.some((row)=>row.getCanExpand());
        };
        table.getToggleAllRowsExpandedHandler = ()=>{
            return (e)=>{
                e.persist == null || e.persist();
                table.toggleAllRowsExpanded();
            };
        };
        table.getIsSomeRowsExpanded = ()=>{
            const expanded = table.getState().expanded;
            return expanded === true || Object.values(expanded).some(Boolean);
        };
        table.getIsAllRowsExpanded = ()=>{
            const expanded = table.getState().expanded;
            // If expanded is true, save some cycles and return true
            if (typeof expanded === "boolean") return expanded === true;
            if (!Object.keys(expanded).length) return false;
            // If any row is not expanded, return false
            if (table.getRowModel().flatRows.some((row)=>!row.getIsExpanded())) return false;
            // They must all be expanded :shrug:
            return true;
        };
        table.getExpandedDepth = ()=>{
            let maxDepth = 0;
            const rowIds = table.getState().expanded === true ? Object.keys(table.getRowModel().rowsById) : Object.keys(table.getState().expanded);
            rowIds.forEach((id)=>{
                const splitId = id.split(".");
                maxDepth = Math.max(maxDepth, splitId.length);
            });
            return maxDepth;
        };
        table.getPreExpandedRowModel = ()=>table.getSortedRowModel();
        table.getExpandedRowModel = ()=>{
            if (!table._getExpandedRowModel && table.options.getExpandedRowModel) table._getExpandedRowModel = table.options.getExpandedRowModel(table);
            if (table.options.manualExpanding || !table._getExpandedRowModel) return table.getPreExpandedRowModel();
            return table._getExpandedRowModel();
        };
    },
    createRow: (row, table)=>{
        row.toggleExpanded = (expanded)=>{
            table.setExpanded((old)=>{
                var _expanded;
                const exists = old === true ? true : !!(old != null && old[row.id]);
                let oldExpanded = {};
                if (old === true) Object.keys(table.getRowModel().rowsById).forEach((rowId)=>{
                    oldExpanded[rowId] = true;
                });
                else oldExpanded = old;
                expanded = (_expanded = expanded) != null ? _expanded : !exists;
                if (!exists && expanded) return {
                    ...oldExpanded,
                    [row.id]: true
                };
                if (exists && !expanded) {
                    const { [row.id]: _, ...rest } = oldExpanded;
                    return rest;
                }
                return old;
            });
        };
        row.getIsExpanded = ()=>{
            var _table$options$getIsR;
            const expanded = table.getState().expanded;
            return !!((_table$options$getIsR = table.options.getIsRowExpanded == null ? void 0 : table.options.getIsRowExpanded(row)) != null ? _table$options$getIsR : expanded === true || (expanded == null ? void 0 : expanded[row.id]));
        };
        row.getCanExpand = ()=>{
            var _table$options$getRow, _table$options$enable, _row$subRows;
            return (_table$options$getRow = table.options.getRowCanExpand == null ? void 0 : table.options.getRowCanExpand(row)) != null ? _table$options$getRow : ((_table$options$enable = table.options.enableExpanding) != null ? _table$options$enable : true) && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
        };
        row.getIsAllParentsExpanded = ()=>{
            let isFullyExpanded = true;
            let currentRow = row;
            while(isFullyExpanded && currentRow.parentId){
                currentRow = table.getRow(currentRow.parentId, true);
                isFullyExpanded = currentRow.getIsExpanded();
            }
            return isFullyExpanded;
        };
        row.getToggleExpandedHandler = ()=>{
            const canExpand = row.getCanExpand();
            return ()=>{
                if (!canExpand) return;
                row.toggleExpanded();
            };
        };
    }
};
const $829253db717f8f1b$var$includesString = (row, columnId, filterValue)=>{
    var _row$getValue;
    const search = filterValue.toLowerCase();
    return Boolean((_row$getValue = row.getValue(columnId)) == null || (_row$getValue = _row$getValue.toString()) == null || (_row$getValue = _row$getValue.toLowerCase()) == null ? void 0 : _row$getValue.includes(search));
};
$829253db717f8f1b$var$includesString.autoRemove = (val)=>$829253db717f8f1b$var$testFalsey(val);
const $829253db717f8f1b$var$includesStringSensitive = (row, columnId, filterValue)=>{
    var _row$getValue2;
    return Boolean((_row$getValue2 = row.getValue(columnId)) == null || (_row$getValue2 = _row$getValue2.toString()) == null ? void 0 : _row$getValue2.includes(filterValue));
};
$829253db717f8f1b$var$includesStringSensitive.autoRemove = (val)=>$829253db717f8f1b$var$testFalsey(val);
const $829253db717f8f1b$var$equalsString = (row, columnId, filterValue)=>{
    var _row$getValue3;
    return ((_row$getValue3 = row.getValue(columnId)) == null || (_row$getValue3 = _row$getValue3.toString()) == null ? void 0 : _row$getValue3.toLowerCase()) === (filterValue == null ? void 0 : filterValue.toLowerCase());
};
$829253db717f8f1b$var$equalsString.autoRemove = (val)=>$829253db717f8f1b$var$testFalsey(val);
const $829253db717f8f1b$var$arrIncludes = (row, columnId, filterValue)=>{
    var _row$getValue4;
    return (_row$getValue4 = row.getValue(columnId)) == null ? void 0 : _row$getValue4.includes(filterValue);
};
$829253db717f8f1b$var$arrIncludes.autoRemove = (val)=>$829253db717f8f1b$var$testFalsey(val) || !(val != null && val.length);
const $829253db717f8f1b$var$arrIncludesAll = (row, columnId, filterValue)=>{
    return !filterValue.some((val)=>{
        var _row$getValue5;
        return !((_row$getValue5 = row.getValue(columnId)) != null && _row$getValue5.includes(val));
    });
};
$829253db717f8f1b$var$arrIncludesAll.autoRemove = (val)=>$829253db717f8f1b$var$testFalsey(val) || !(val != null && val.length);
const $829253db717f8f1b$var$arrIncludesSome = (row, columnId, filterValue)=>{
    return filterValue.some((val)=>{
        var _row$getValue6;
        return (_row$getValue6 = row.getValue(columnId)) == null ? void 0 : _row$getValue6.includes(val);
    });
};
$829253db717f8f1b$var$arrIncludesSome.autoRemove = (val)=>$829253db717f8f1b$var$testFalsey(val) || !(val != null && val.length);
const $829253db717f8f1b$var$equals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) === filterValue;
};
$829253db717f8f1b$var$equals.autoRemove = (val)=>$829253db717f8f1b$var$testFalsey(val);
const $829253db717f8f1b$var$weakEquals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) == filterValue;
};
$829253db717f8f1b$var$weakEquals.autoRemove = (val)=>$829253db717f8f1b$var$testFalsey(val);
const $829253db717f8f1b$var$inNumberRange = (row, columnId, filterValue)=>{
    let [min, max] = filterValue;
    const rowValue = row.getValue(columnId);
    return rowValue >= min && rowValue <= max;
};
$829253db717f8f1b$var$inNumberRange.resolveFilterValue = (val)=>{
    let [unsafeMin, unsafeMax] = val;
    let parsedMin = typeof unsafeMin !== "number" ? parseFloat(unsafeMin) : unsafeMin;
    let parsedMax = typeof unsafeMax !== "number" ? parseFloat(unsafeMax) : unsafeMax;
    let min = unsafeMin === null || Number.isNaN(parsedMin) ? -Infinity : parsedMin;
    let max = unsafeMax === null || Number.isNaN(parsedMax) ? Infinity : parsedMax;
    if (min > max) {
        const temp = min;
        min = max;
        max = temp;
    }
    return [
        min,
        max
    ];
};
$829253db717f8f1b$var$inNumberRange.autoRemove = (val)=>$829253db717f8f1b$var$testFalsey(val) || $829253db717f8f1b$var$testFalsey(val[0]) && $829253db717f8f1b$var$testFalsey(val[1]);
// Export
const $829253db717f8f1b$export$6ad8312e296ec316 = {
    includesString: $829253db717f8f1b$var$includesString,
    includesStringSensitive: $829253db717f8f1b$var$includesStringSensitive,
    equalsString: $829253db717f8f1b$var$equalsString,
    arrIncludes: $829253db717f8f1b$var$arrIncludes,
    arrIncludesAll: $829253db717f8f1b$var$arrIncludesAll,
    arrIncludesSome: $829253db717f8f1b$var$arrIncludesSome,
    equals: $829253db717f8f1b$var$equals,
    weakEquals: $829253db717f8f1b$var$weakEquals,
    inNumberRange: $829253db717f8f1b$var$inNumberRange
};
// Utils
function $829253db717f8f1b$var$testFalsey(val) {
    return val === undefined || val === null || val === "";
}
//
const $829253db717f8f1b$export$92a576f896a9bf72 = {
    getDefaultColumnDef: ()=>{
        return {
            filterFn: "auto"
        };
    },
    getInitialState: (state)=>{
        return {
            columnFilters: [],
            globalFilter: undefined,
            // filtersProgress: 1,
            // facetProgress: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnFiltersChange: $829253db717f8f1b$export$2b5605d8069324bd("columnFilters", table),
            onGlobalFilterChange: $829253db717f8f1b$export$2b5605d8069324bd("globalFilter", table),
            filterFromLeafRows: false,
            maxLeafRowFilterDepth: 100,
            globalFilterFn: "auto",
            getColumnCanGlobalFilter: (column)=>{
                var _table$getCoreRowMode;
                const value = (_table$getCoreRowMode = table.getCoreRowModel().flatRows[0]) == null || (_table$getCoreRowMode = _table$getCoreRowMode._getAllCellsByColumnId()[column.id]) == null ? void 0 : _table$getCoreRowMode.getValue();
                return typeof value === "string" || typeof value === "number";
            }
        };
    },
    createColumn: (column, table)=>{
        column.getAutoFilterFn = ()=>{
            const firstRow = table.getCoreRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === "string") return $829253db717f8f1b$export$6ad8312e296ec316.includesString;
            if (typeof value === "number") return $829253db717f8f1b$export$6ad8312e296ec316.inNumberRange;
            if (typeof value === "boolean") return $829253db717f8f1b$export$6ad8312e296ec316.equals;
            if (value !== null && typeof value === "object") return $829253db717f8f1b$export$6ad8312e296ec316.equals;
            if (Array.isArray(value)) return $829253db717f8f1b$export$6ad8312e296ec316.arrIncludes;
            return $829253db717f8f1b$export$6ad8312e296ec316.weakEquals;
        };
        column.getFilterFn = ()=>{
            var _table$options$filter, _table$options$filter2;
            return $829253db717f8f1b$export$f6e2535fb5126e54(column.columnDef.filterFn) ? column.columnDef.filterFn : column.columnDef.filterFn === "auto" ? column.getAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[column.columnDef.filterFn]) != null ? _table$options$filter : $829253db717f8f1b$export$6ad8312e296ec316[column.columnDef.filterFn];
        };
        column.getCanFilter = ()=>{
            var _column$columnDef$ena, _table$options$enable, _table$options$enable2;
            return ((_column$columnDef$ena = column.columnDef.enableColumnFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnFilters) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && !!column.accessorFn;
        };
        column.getCanGlobalFilter = ()=>{
            var _column$columnDef$ena2, _table$options$enable3, _table$options$enable4, _table$options$getCol;
            return ((_column$columnDef$ena2 = column.columnDef.enableGlobalFilter) != null ? _column$columnDef$ena2 : true) && ((_table$options$enable3 = table.options.enableGlobalFilter) != null ? _table$options$enable3 : true) && ((_table$options$enable4 = table.options.enableFilters) != null ? _table$options$enable4 : true) && ((_table$options$getCol = table.options.getColumnCanGlobalFilter == null ? void 0 : table.options.getColumnCanGlobalFilter(column)) != null ? _table$options$getCol : true) && !!column.accessorFn;
        };
        column.getIsFiltered = ()=>column.getFilterIndex() > -1;
        column.getFilterValue = ()=>{
            var _table$getState$colum;
            return (_table$getState$colum = table.getState().columnFilters) == null || (_table$getState$colum = _table$getState$colum.find((d)=>d.id === column.id)) == null ? void 0 : _table$getState$colum.value;
        };
        column.getFilterIndex = ()=>{
            var _table$getState$colum2, _table$getState$colum3;
            return (_table$getState$colum2 = (_table$getState$colum3 = table.getState().columnFilters) == null ? void 0 : _table$getState$colum3.findIndex((d)=>d.id === column.id)) != null ? _table$getState$colum2 : -1;
        };
        column.setFilterValue = (value)=>{
            table.setColumnFilters((old)=>{
                const filterFn = column.getFilterFn();
                const previousfilter = old == null ? void 0 : old.find((d)=>d.id === column.id);
                const newFilter = $829253db717f8f1b$export$7f095f455ad5af3f(value, previousfilter ? previousfilter.value : undefined);
                //
                if ($829253db717f8f1b$export$5b01eb94d7ce58a8(filterFn, newFilter, column)) {
                    var _old$filter;
                    return (_old$filter = old == null ? void 0 : old.filter((d)=>d.id !== column.id)) != null ? _old$filter : [];
                }
                const newFilterObj = {
                    id: column.id,
                    value: newFilter
                };
                if (previousfilter) {
                    var _old$map;
                    return (_old$map = old == null ? void 0 : old.map((d)=>{
                        if (d.id === column.id) return newFilterObj;
                        return d;
                    })) != null ? _old$map : [];
                }
                if (old != null && old.length) return [
                    ...old,
                    newFilterObj
                ];
                return [
                    newFilterObj
                ];
            });
        };
        column._getFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, column.id);
        column.getFacetedRowModel = ()=>{
            if (!column._getFacetedRowModel) return table.getPreFilteredRowModel();
            return column._getFacetedRowModel();
        };
        column._getFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, column.id);
        column.getFacetedUniqueValues = ()=>{
            if (!column._getFacetedUniqueValues) return new Map();
            return column._getFacetedUniqueValues();
        };
        column._getFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, column.id);
        column.getFacetedMinMaxValues = ()=>{
            if (!column._getFacetedMinMaxValues) return undefined;
            return column._getFacetedMinMaxValues();
        };
    // () => [column.getFacetedRowModel()],
    // facetedRowModel => getRowModelMinMaxValues(facetedRowModel, column.id),
    },
    createRow: (row, table)=>{
        row.columnFilters = {};
        row.columnFiltersMeta = {};
    },
    createTable: (table)=>{
        table.getGlobalAutoFilterFn = ()=>{
            return $829253db717f8f1b$export$6ad8312e296ec316.includesString;
        };
        table.getGlobalFilterFn = ()=>{
            var _table$options$filter3, _table$options$filter4;
            const { globalFilterFn: globalFilterFn } = table.options;
            return $829253db717f8f1b$export$f6e2535fb5126e54(globalFilterFn) ? globalFilterFn : globalFilterFn === "auto" ? table.getGlobalAutoFilterFn() : (_table$options$filter3 = (_table$options$filter4 = table.options.filterFns) == null ? void 0 : _table$options$filter4[globalFilterFn]) != null ? _table$options$filter3 : $829253db717f8f1b$export$6ad8312e296ec316[globalFilterFn];
        };
        table.setColumnFilters = (updater)=>{
            const leafColumns = table.getAllLeafColumns();
            const updateFn = (old)=>{
                var _functionalUpdate;
                return (_functionalUpdate = $829253db717f8f1b$export$7f095f455ad5af3f(updater, old)) == null ? void 0 : _functionalUpdate.filter((filter)=>{
                    const column = leafColumns.find((d)=>d.id === filter.id);
                    if (column) {
                        const filterFn = column.getFilterFn();
                        if ($829253db717f8f1b$export$5b01eb94d7ce58a8(filterFn, filter.value, column)) return false;
                    }
                    return true;
                });
            };
            table.options.onColumnFiltersChange == null || table.options.onColumnFiltersChange(updateFn);
        };
        table.setGlobalFilter = (updater)=>{
            table.options.onGlobalFilterChange == null || table.options.onGlobalFilterChange(updater);
        };
        table.resetGlobalFilter = (defaultState)=>{
            table.setGlobalFilter(defaultState ? undefined : table.initialState.globalFilter);
        };
        table.resetColumnFilters = (defaultState)=>{
            var _table$initialState$c, _table$initialState;
            table.setColumnFilters(defaultState ? [] : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnFilters) != null ? _table$initialState$c : []);
        };
        table.getPreFilteredRowModel = ()=>table.getCoreRowModel();
        table.getFilteredRowModel = ()=>{
            if (!table._getFilteredRowModel && table.options.getFilteredRowModel) table._getFilteredRowModel = table.options.getFilteredRowModel(table);
            if (table.options.manualFiltering || !table._getFilteredRowModel) return table.getPreFilteredRowModel();
            return table._getFilteredRowModel();
        };
        table._getGlobalFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, "__global__");
        table.getGlobalFacetedRowModel = ()=>{
            if (table.options.manualFiltering || !table._getGlobalFacetedRowModel) return table.getPreFilteredRowModel();
            return table._getGlobalFacetedRowModel();
        };
        table._getGlobalFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, "__global__");
        table.getGlobalFacetedUniqueValues = ()=>{
            if (!table._getGlobalFacetedUniqueValues) return new Map();
            return table._getGlobalFacetedUniqueValues();
        };
        table._getGlobalFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, "__global__");
        table.getGlobalFacetedMinMaxValues = ()=>{
            if (!table._getGlobalFacetedMinMaxValues) return;
            return table._getGlobalFacetedMinMaxValues();
        };
    }
};
function $829253db717f8f1b$export$5b01eb94d7ce58a8(filterFn, value, column) {
    return (filterFn && filterFn.autoRemove ? filterFn.autoRemove(value, column) : false) || typeof value === "undefined" || typeof value === "string" && !value;
}
const $829253db717f8f1b$var$sum = (columnId, _leafRows, childRows)=>{
    // It's faster to just add the aggregations together instead of
    // process leaf nodes individually
    return childRows.reduce((sum, next)=>{
        const nextValue = next.getValue(columnId);
        return sum + (typeof nextValue === "number" ? nextValue : 0);
    }, 0);
};
const $829253db717f8f1b$var$min = (columnId, _leafRows, childRows)=>{
    let min;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (min > value || min === undefined && value >= value)) min = value;
    });
    return min;
};
const $829253db717f8f1b$var$max = (columnId, _leafRows, childRows)=>{
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (max < value || max === undefined && value >= value)) max = value;
    });
    return max;
};
const $829253db717f8f1b$var$extent = (columnId, _leafRows, childRows)=>{
    let min;
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    });
    return [
        min,
        max
    ];
};
const $829253db717f8f1b$var$mean = (columnId, leafRows)=>{
    let count = 0;
    let sum = 0;
    leafRows.forEach((row)=>{
        let value = row.getValue(columnId);
        if (value != null && (value = +value) >= value) ++count, sum += value;
    });
    if (count) return sum / count;
    return;
};
const $829253db717f8f1b$var$median = (columnId, leafRows)=>{
    if (!leafRows.length) return;
    const values = leafRows.map((row)=>row.getValue(columnId));
    if (!$829253db717f8f1b$export$5cd576d1827d40c8(values)) return;
    if (values.length === 1) return values[0];
    const mid = Math.floor(values.length / 2);
    const nums = values.sort((a, b)=>a - b);
    return values.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
};
const $829253db717f8f1b$var$unique = (columnId, leafRows)=>{
    return Array.from(new Set(leafRows.map((d)=>d.getValue(columnId))).values());
};
const $829253db717f8f1b$var$uniqueCount = (columnId, leafRows)=>{
    return new Set(leafRows.map((d)=>d.getValue(columnId))).size;
};
const $829253db717f8f1b$var$count = (_columnId, leafRows)=>{
    return leafRows.length;
};
const $829253db717f8f1b$export$3aa4339120b8b25b = {
    sum: $829253db717f8f1b$var$sum,
    min: $829253db717f8f1b$var$min,
    max: $829253db717f8f1b$var$max,
    extent: $829253db717f8f1b$var$extent,
    mean: $829253db717f8f1b$var$mean,
    median: $829253db717f8f1b$var$median,
    unique: $829253db717f8f1b$var$unique,
    uniqueCount: $829253db717f8f1b$var$uniqueCount,
    count: $829253db717f8f1b$var$count
};
//
const $829253db717f8f1b$export$3885c0af90651e94 = {
    getDefaultColumnDef: ()=>{
        return {
            aggregatedCell: (props)=>{
                var _toString, _props$getValue;
                return (_toString = (_props$getValue = props.getValue()) == null || _props$getValue.toString == null ? void 0 : _props$getValue.toString()) != null ? _toString : null;
            },
            aggregationFn: "auto"
        };
    },
    getInitialState: (state)=>{
        return {
            grouping: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onGroupingChange: $829253db717f8f1b$export$2b5605d8069324bd("grouping", table),
            groupedColumnMode: "reorder"
        };
    },
    createColumn: (column, table)=>{
        column.toggleGrouping = ()=>{
            table.setGrouping((old)=>{
                // Find any existing grouping for this column
                if (old != null && old.includes(column.id)) return old.filter((d)=>d !== column.id);
                return [
                    ...old != null ? old : [],
                    column.id
                ];
            });
        };
        column.getCanGroup = ()=>{
            var _ref, _ref2, _ref3, _column$columnDef$ena;
            return (_ref = (_ref2 = (_ref3 = (_column$columnDef$ena = column.columnDef.enableGrouping) != null ? _column$columnDef$ena : true) != null ? _ref3 : table.options.enableGrouping) != null ? _ref2 : true) != null ? _ref : !!column.accessorFn;
        };
        column.getIsGrouped = ()=>{
            var _table$getState$group;
            return (_table$getState$group = table.getState().grouping) == null ? void 0 : _table$getState$group.includes(column.id);
        };
        column.getGroupedIndex = ()=>{
            var _table$getState$group2;
            return (_table$getState$group2 = table.getState().grouping) == null ? void 0 : _table$getState$group2.indexOf(column.id);
        };
        column.getToggleGroupingHandler = ()=>{
            const canGroup = column.getCanGroup();
            return ()=>{
                if (!canGroup) return;
                column.toggleGrouping();
            };
        };
        column.getAutoAggregationFn = ()=>{
            const firstRow = table.getCoreRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === "number") return $829253db717f8f1b$export$3aa4339120b8b25b.sum;
            if (Object.prototype.toString.call(value) === "[object Date]") return $829253db717f8f1b$export$3aa4339120b8b25b.extent;
        };
        column.getAggregationFn = ()=>{
            var _table$options$aggreg, _table$options$aggreg2;
            if (!column) throw new Error();
            return $829253db717f8f1b$export$f6e2535fb5126e54(column.columnDef.aggregationFn) ? column.columnDef.aggregationFn : column.columnDef.aggregationFn === "auto" ? column.getAutoAggregationFn() : (_table$options$aggreg = (_table$options$aggreg2 = table.options.aggregationFns) == null ? void 0 : _table$options$aggreg2[column.columnDef.aggregationFn]) != null ? _table$options$aggreg : $829253db717f8f1b$export$3aa4339120b8b25b[column.columnDef.aggregationFn];
        };
    },
    createTable: (table)=>{
        table.setGrouping = (updater)=>table.options.onGroupingChange == null ? void 0 : table.options.onGroupingChange(updater);
        table.resetGrouping = (defaultState)=>{
            var _table$initialState$g, _table$initialState;
            table.setGrouping(defaultState ? [] : (_table$initialState$g = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.grouping) != null ? _table$initialState$g : []);
        };
        table.getPreGroupedRowModel = ()=>table.getFilteredRowModel();
        table.getGroupedRowModel = ()=>{
            if (!table._getGroupedRowModel && table.options.getGroupedRowModel) table._getGroupedRowModel = table.options.getGroupedRowModel(table);
            if (table.options.manualGrouping || !table._getGroupedRowModel) return table.getPreGroupedRowModel();
            return table._getGroupedRowModel();
        };
    },
    createRow: (row, table)=>{
        row.getIsGrouped = ()=>!!row.groupingColumnId;
        row.getGroupingValue = (columnId)=>{
            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.columnDef.getGroupingValue)) return row.getValue(columnId);
            row._groupingValuesCache[columnId] = column.columnDef.getGroupingValue(row.original);
            return row._groupingValuesCache[columnId];
        };
        row._groupingValuesCache = {};
    },
    createCell: (cell, column, row, table)=>{
        cell.getIsGrouped = ()=>column.getIsGrouped() && column.id === row.groupingColumnId;
        cell.getIsPlaceholder = ()=>!cell.getIsGrouped() && column.getIsGrouped();
        cell.getIsAggregated = ()=>{
            var _row$subRows;
            return !cell.getIsGrouped() && !cell.getIsPlaceholder() && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
        };
    }
};
function $829253db717f8f1b$export$ac763d2b0470e663(leafColumns, grouping, groupedColumnMode) {
    if (!(grouping != null && grouping.length) || !groupedColumnMode) return leafColumns;
    const nonGroupingColumns = leafColumns.filter((col)=>!grouping.includes(col.id));
    if (groupedColumnMode === "remove") return nonGroupingColumns;
    const groupingColumns = grouping.map((g)=>leafColumns.find((col)=>col.id === g)).filter(Boolean);
    return [
        ...groupingColumns,
        ...nonGroupingColumns
    ];
}
//
const $829253db717f8f1b$export$549aff5da5ccfd97 = {
    getInitialState: (state)=>{
        return {
            columnOrder: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnOrderChange: $829253db717f8f1b$export$2b5605d8069324bd("columnOrder", table)
        };
    },
    createColumn: (column, table)=>{
        column.getIndex = $829253db717f8f1b$export$7c73462e0d25e514((position)=>[
                $829253db717f8f1b$export$1d7c103713892a11(table, position)
            ], (columns)=>columns.findIndex((d)=>d.id === column.id), $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugColumns", "getIndex"));
        column.getIsFirstColumn = (position)=>{
            var _columns$;
            const columns = $829253db717f8f1b$export$1d7c103713892a11(table, position);
            return ((_columns$ = columns[0]) == null ? void 0 : _columns$.id) === column.id;
        };
        column.getIsLastColumn = (position)=>{
            var _columns;
            const columns = $829253db717f8f1b$export$1d7c103713892a11(table, position);
            return ((_columns = columns[columns.length - 1]) == null ? void 0 : _columns.id) === column.id;
        };
    },
    createTable: (table)=>{
        table.setColumnOrder = (updater)=>table.options.onColumnOrderChange == null ? void 0 : table.options.onColumnOrderChange(updater);
        table.resetColumnOrder = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnOrder(defaultState ? [] : (_table$initialState$c = table.initialState.columnOrder) != null ? _table$initialState$c : []);
        };
        table._getOrderColumnsFn = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getState().columnOrder,
                table.getState().grouping,
                table.options.groupedColumnMode
            ], (columnOrder, grouping, groupedColumnMode)=>(columns)=>{
                // Sort grouped columns to the start of the column list
                // before the headers are built
                let orderedColumns = [];
                // If there is no order, return the normal columns
                if (!(columnOrder != null && columnOrder.length)) orderedColumns = columns;
                else {
                    const columnOrderCopy = [
                        ...columnOrder
                    ];
                    // If there is an order, make a copy of the columns
                    const columnsCopy = [
                        ...columns
                    ];
                    // And make a new ordered array of the columns
                    // Loop over the columns and place them in order into the new array
                    while(columnsCopy.length && columnOrderCopy.length){
                        const targetColumnId = columnOrderCopy.shift();
                        const foundIndex = columnsCopy.findIndex((d)=>d.id === targetColumnId);
                        if (foundIndex > -1) orderedColumns.push(columnsCopy.splice(foundIndex, 1)[0]);
                    }
                    // If there are any columns left, add them to the end
                    orderedColumns = [
                        ...orderedColumns,
                        ...columnsCopy
                    ];
                }
                return $829253db717f8f1b$export$ac763d2b0470e663(orderedColumns, grouping, groupedColumnMode);
            }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "_getOrderColumnsFn"));
    }
};
//
const $829253db717f8f1b$var$defaultPageIndex = 0;
const $829253db717f8f1b$var$defaultPageSize = 10;
const $829253db717f8f1b$var$getDefaultPaginationState = ()=>({
        pageIndex: $829253db717f8f1b$var$defaultPageIndex,
        pageSize: $829253db717f8f1b$var$defaultPageSize
    });
const $829253db717f8f1b$export$68f5e1453c188a82 = {
    getInitialState: (state)=>{
        return {
            ...state,
            pagination: {
                ...$829253db717f8f1b$var$getDefaultPaginationState(),
                ...state == null ? void 0 : state.pagination
            }
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onPaginationChange: $829253db717f8f1b$export$2b5605d8069324bd("pagination", table)
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        table._autoResetPageIndex = ()=>{
            var _ref, _table$options$autoRe;
            if (!registered) {
                table._queue(()=>{
                    registered = true;
                });
                return;
            }
            if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetPageIndex) != null ? _ref : !table.options.manualPagination) {
                if (queued) return;
                queued = true;
                table._queue(()=>{
                    table.resetPageIndex();
                    queued = false;
                });
            }
        };
        table.setPagination = (updater)=>{
            const safeUpdater = (old)=>{
                let newState = $829253db717f8f1b$export$7f095f455ad5af3f(updater, old);
                return newState;
            };
            return table.options.onPaginationChange == null ? void 0 : table.options.onPaginationChange(safeUpdater);
        };
        table.resetPagination = (defaultState)=>{
            var _table$initialState$p;
            table.setPagination(defaultState ? $829253db717f8f1b$var$getDefaultPaginationState() : (_table$initialState$p = table.initialState.pagination) != null ? _table$initialState$p : $829253db717f8f1b$var$getDefaultPaginationState());
        };
        table.setPageIndex = (updater)=>{
            table.setPagination((old)=>{
                let pageIndex = $829253db717f8f1b$export$7f095f455ad5af3f(updater, old.pageIndex);
                const maxPageIndex = typeof table.options.pageCount === "undefined" || table.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : table.options.pageCount - 1;
                pageIndex = Math.max(0, Math.min(pageIndex, maxPageIndex));
                return {
                    ...old,
                    pageIndex: pageIndex
                };
            });
        };
        table.resetPageIndex = (defaultState)=>{
            var _table$initialState$p2, _table$initialState;
            table.setPageIndex(defaultState ? $829253db717f8f1b$var$defaultPageIndex : (_table$initialState$p2 = (_table$initialState = table.initialState) == null || (_table$initialState = _table$initialState.pagination) == null ? void 0 : _table$initialState.pageIndex) != null ? _table$initialState$p2 : $829253db717f8f1b$var$defaultPageIndex);
        };
        table.resetPageSize = (defaultState)=>{
            var _table$initialState$p3, _table$initialState2;
            table.setPageSize(defaultState ? $829253db717f8f1b$var$defaultPageSize : (_table$initialState$p3 = (_table$initialState2 = table.initialState) == null || (_table$initialState2 = _table$initialState2.pagination) == null ? void 0 : _table$initialState2.pageSize) != null ? _table$initialState$p3 : $829253db717f8f1b$var$defaultPageSize);
        };
        table.setPageSize = (updater)=>{
            table.setPagination((old)=>{
                const pageSize = Math.max(1, $829253db717f8f1b$export$7f095f455ad5af3f(updater, old.pageSize));
                const topRowIndex = old.pageSize * old.pageIndex;
                const pageIndex = Math.floor(topRowIndex / pageSize);
                return {
                    ...old,
                    pageIndex: pageIndex,
                    pageSize: pageSize
                };
            });
        };
        //deprecated
        table.setPageCount = (updater)=>table.setPagination((old)=>{
                var _table$options$pageCo;
                let newPageCount = $829253db717f8f1b$export$7f095f455ad5af3f(updater, (_table$options$pageCo = table.options.pageCount) != null ? _table$options$pageCo : -1);
                if (typeof newPageCount === "number") newPageCount = Math.max(-1, newPageCount);
                return {
                    ...old,
                    pageCount: newPageCount
                };
            });
        table.getPageOptions = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getPageCount()
            ], (pageCount)=>{
            let pageOptions = [];
            if (pageCount && pageCount > 0) pageOptions = [
                ...new Array(pageCount)
            ].fill(null).map((_, i)=>i);
            return pageOptions;
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getPageOptions"));
        table.getCanPreviousPage = ()=>table.getState().pagination.pageIndex > 0;
        table.getCanNextPage = ()=>{
            const { pageIndex: pageIndex } = table.getState().pagination;
            const pageCount = table.getPageCount();
            if (pageCount === -1) return true;
            if (pageCount === 0) return false;
            return pageIndex < pageCount - 1;
        };
        table.previousPage = ()=>{
            return table.setPageIndex((old)=>old - 1);
        };
        table.nextPage = ()=>{
            return table.setPageIndex((old)=>{
                return old + 1;
            });
        };
        table.firstPage = ()=>{
            return table.setPageIndex(0);
        };
        table.lastPage = ()=>{
            return table.setPageIndex(table.getPageCount() - 1);
        };
        table.getPrePaginationRowModel = ()=>table.getExpandedRowModel();
        table.getPaginationRowModel = ()=>{
            if (!table._getPaginationRowModel && table.options.getPaginationRowModel) table._getPaginationRowModel = table.options.getPaginationRowModel(table);
            if (table.options.manualPagination || !table._getPaginationRowModel) return table.getPrePaginationRowModel();
            return table._getPaginationRowModel();
        };
        table.getPageCount = ()=>{
            var _table$options$pageCo2;
            return (_table$options$pageCo2 = table.options.pageCount) != null ? _table$options$pageCo2 : Math.ceil(table.getRowCount() / table.getState().pagination.pageSize);
        };
        table.getRowCount = ()=>{
            var _table$options$rowCou;
            return (_table$options$rowCou = table.options.rowCount) != null ? _table$options$rowCou : table.getPrePaginationRowModel().rows.length;
        };
    }
};
//
const $829253db717f8f1b$var$getDefaultColumnPinningState = ()=>({
        left: [],
        right: []
    });
const $829253db717f8f1b$var$getDefaultRowPinningState = ()=>({
        top: [],
        bottom: []
    });
const $829253db717f8f1b$export$5289f180505593b3 = {
    getInitialState: (state)=>{
        return {
            columnPinning: $829253db717f8f1b$var$getDefaultColumnPinningState(),
            rowPinning: $829253db717f8f1b$var$getDefaultRowPinningState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnPinningChange: $829253db717f8f1b$export$2b5605d8069324bd("columnPinning", table),
            onRowPinningChange: $829253db717f8f1b$export$2b5605d8069324bd("rowPinning", table)
        };
    },
    createColumn: (column, table)=>{
        column.pin = (position)=>{
            const columnIds = column.getLeafColumns().map((d)=>d.id).filter(Boolean);
            table.setColumnPinning((old)=>{
                var _old$left3, _old$right3;
                if (position === "right") {
                    var _old$left, _old$right;
                    return {
                        left: ((_old$left = old == null ? void 0 : old.left) != null ? _old$left : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                        right: [
                            ...((_old$right = old == null ? void 0 : old.right) != null ? _old$right : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                            ...columnIds
                        ]
                    };
                }
                if (position === "left") {
                    var _old$left2, _old$right2;
                    return {
                        left: [
                            ...((_old$left2 = old == null ? void 0 : old.left) != null ? _old$left2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                            ...columnIds
                        ],
                        right: ((_old$right2 = old == null ? void 0 : old.right) != null ? _old$right2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                    };
                }
                return {
                    left: ((_old$left3 = old == null ? void 0 : old.left) != null ? _old$left3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                    right: ((_old$right3 = old == null ? void 0 : old.right) != null ? _old$right3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                };
            });
        };
        column.getCanPin = ()=>{
            const leafColumns = column.getLeafColumns();
            return leafColumns.some((d)=>{
                var _d$columnDef$enablePi, _ref, _table$options$enable;
                return ((_d$columnDef$enablePi = d.columnDef.enablePinning) != null ? _d$columnDef$enablePi : true) && ((_ref = (_table$options$enable = table.options.enableColumnPinning) != null ? _table$options$enable : table.options.enablePinning) != null ? _ref : true);
            });
        };
        column.getIsPinned = ()=>{
            const leafColumnIds = column.getLeafColumns().map((d)=>d.id);
            const { left: left, right: right } = table.getState().columnPinning;
            const isLeft = leafColumnIds.some((d)=>left == null ? void 0 : left.includes(d));
            const isRight = leafColumnIds.some((d)=>right == null ? void 0 : right.includes(d));
            return isLeft ? "left" : isRight ? "right" : false;
        };
        column.getPinnedIndex = ()=>{
            var _table$getState$colum, _table$getState$colum2;
            const position = column.getIsPinned();
            return position ? (_table$getState$colum = (_table$getState$colum2 = table.getState().columnPinning) == null || (_table$getState$colum2 = _table$getState$colum2[position]) == null ? void 0 : _table$getState$colum2.indexOf(column.id)) != null ? _table$getState$colum : -1 : 0;
        };
    },
    createRow: (row, table)=>{
        row.pin = (position, includeLeafRows, includeParentRows)=>{
            const leafRowIds = includeLeafRows ? row.getLeafRows().map((_ref2)=>{
                let { id: id } = _ref2;
                return id;
            }) : [];
            const parentRowIds = includeParentRows ? row.getParentRows().map((_ref3)=>{
                let { id: id } = _ref3;
                return id;
            }) : [];
            const rowIds = new Set([
                ...parentRowIds,
                row.id,
                ...leafRowIds
            ]);
            table.setRowPinning((old)=>{
                var _old$top3, _old$bottom3;
                if (position === "bottom") {
                    var _old$top, _old$bottom;
                    return {
                        top: ((_old$top = old == null ? void 0 : old.top) != null ? _old$top : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                        bottom: [
                            ...((_old$bottom = old == null ? void 0 : old.bottom) != null ? _old$bottom : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                            ...Array.from(rowIds)
                        ]
                    };
                }
                if (position === "top") {
                    var _old$top2, _old$bottom2;
                    return {
                        top: [
                            ...((_old$top2 = old == null ? void 0 : old.top) != null ? _old$top2 : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                            ...Array.from(rowIds)
                        ],
                        bottom: ((_old$bottom2 = old == null ? void 0 : old.bottom) != null ? _old$bottom2 : []).filter((d)=>!(rowIds != null && rowIds.has(d)))
                    };
                }
                return {
                    top: ((_old$top3 = old == null ? void 0 : old.top) != null ? _old$top3 : []).filter((d)=>!(rowIds != null && rowIds.has(d))),
                    bottom: ((_old$bottom3 = old == null ? void 0 : old.bottom) != null ? _old$bottom3 : []).filter((d)=>!(rowIds != null && rowIds.has(d)))
                };
            });
        };
        row.getCanPin = ()=>{
            var _ref4;
            const { enableRowPinning: enableRowPinning, enablePinning: enablePinning } = table.options;
            if (typeof enableRowPinning === "function") return enableRowPinning(row);
            return (_ref4 = enableRowPinning != null ? enableRowPinning : enablePinning) != null ? _ref4 : true;
        };
        row.getIsPinned = ()=>{
            const rowIds = [
                row.id
            ];
            const { top: top, bottom: bottom } = table.getState().rowPinning;
            const isTop = rowIds.some((d)=>top == null ? void 0 : top.includes(d));
            const isBottom = rowIds.some((d)=>bottom == null ? void 0 : bottom.includes(d));
            return isTop ? "top" : isBottom ? "bottom" : false;
        };
        row.getPinnedIndex = ()=>{
            var _table$_getPinnedRows, _visiblePinnedRowIds$;
            const position = row.getIsPinned();
            if (!position) return -1;
            const visiblePinnedRowIds = (_table$_getPinnedRows = table._getPinnedRows(position)) == null ? void 0 : _table$_getPinnedRows.map((_ref5)=>{
                let { id: id } = _ref5;
                return id;
            });
            return (_visiblePinnedRowIds$ = visiblePinnedRowIds == null ? void 0 : visiblePinnedRowIds.indexOf(row.id)) != null ? _visiblePinnedRowIds$ : -1;
        };
        row.getCenterVisibleCells = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allCells, left, right)=>{
            const leftAndRight = [
                ...left != null ? left : [],
                ...right != null ? right : []
            ];
            return allCells.filter((d)=>!leftAndRight.includes(d.column.id));
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugRows", "getCenterVisibleCells"));
        row.getLeftVisibleCells = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.left
            ], (allCells, left)=>{
            const cells = (left != null ? left : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                    ...d,
                    position: "left"
                }));
            return cells;
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugRows", "getLeftVisibleCells"));
        row.getRightVisibleCells = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                row._getAllVisibleCells(),
                table.getState().columnPinning.right
            ], (allCells, right)=>{
            const cells = (right != null ? right : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                    ...d,
                    position: "right"
                }));
            return cells;
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugRows", "getRightVisibleCells"));
    },
    createTable: (table)=>{
        table.setColumnPinning = (updater)=>table.options.onColumnPinningChange == null ? void 0 : table.options.onColumnPinningChange(updater);
        table.resetColumnPinning = (defaultState)=>{
            var _table$initialState$c, _table$initialState;
            return table.setColumnPinning(defaultState ? $829253db717f8f1b$var$getDefaultColumnPinningState() : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnPinning) != null ? _table$initialState$c : $829253db717f8f1b$var$getDefaultColumnPinningState());
        };
        table.getIsSomeColumnsPinned = (position)=>{
            var _pinningState$positio;
            const pinningState = table.getState().columnPinning;
            if (!position) {
                var _pinningState$left, _pinningState$right;
                return Boolean(((_pinningState$left = pinningState.left) == null ? void 0 : _pinningState$left.length) || ((_pinningState$right = pinningState.right) == null ? void 0 : _pinningState$right.length));
            }
            return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
        };
        table.getLeftLeafColumns = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.left
            ], (allColumns, left)=>{
            return (left != null ? left : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugColumns", "getLeftLeafColumns"));
        table.getRightLeafColumns = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.right
            ], (allColumns, right)=>{
            return (right != null ? right : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugColumns", "getRightLeafColumns"));
        table.getCenterLeafColumns = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ], (allColumns, left, right)=>{
            const leftAndRight = [
                ...left != null ? left : [],
                ...right != null ? right : []
            ];
            return allColumns.filter((d)=>!leftAndRight.includes(d.id));
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugColumns", "getCenterLeafColumns"));
        table.setRowPinning = (updater)=>table.options.onRowPinningChange == null ? void 0 : table.options.onRowPinningChange(updater);
        table.resetRowPinning = (defaultState)=>{
            var _table$initialState$r, _table$initialState2;
            return table.setRowPinning(defaultState ? $829253db717f8f1b$var$getDefaultRowPinningState() : (_table$initialState$r = (_table$initialState2 = table.initialState) == null ? void 0 : _table$initialState2.rowPinning) != null ? _table$initialState$r : $829253db717f8f1b$var$getDefaultRowPinningState());
        };
        table.getIsSomeRowsPinned = (position)=>{
            var _pinningState$positio2;
            const pinningState = table.getState().rowPinning;
            if (!position) {
                var _pinningState$top, _pinningState$bottom;
                return Boolean(((_pinningState$top = pinningState.top) == null ? void 0 : _pinningState$top.length) || ((_pinningState$bottom = pinningState.bottom) == null ? void 0 : _pinningState$bottom.length));
            }
            return Boolean((_pinningState$positio2 = pinningState[position]) == null ? void 0 : _pinningState$positio2.length);
        };
        table._getPinnedRows = $829253db717f8f1b$export$7c73462e0d25e514((position)=>[
                table.getRowModel().rows,
                table.getState().rowPinning[position],
                position
            ], (visibleRows, pinnedRowIds, position)=>{
            var _table$options$keepPi;
            const rows = ((_table$options$keepPi = table.options.keepPinnedRows) != null ? _table$options$keepPi : true) ? //get all rows that are pinned even if they would not be otherwise visible
            //account for expanded parent rows, but not pagination or filtering
            (pinnedRowIds != null ? pinnedRowIds : []).map((rowId)=>{
                const row = table.getRow(rowId, true);
                return row.getIsAllParentsExpanded() ? row : null;
            }) : //else get only visible rows that are pinned
            (pinnedRowIds != null ? pinnedRowIds : []).map((rowId)=>visibleRows.find((row)=>row.id === rowId));
            return rows.filter(Boolean).map((d)=>({
                    ...d,
                    position: position
                }));
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugRows", "_getPinnedRows"));
        table.getTopRows = ()=>table._getPinnedRows("top");
        table.getBottomRows = ()=>table._getPinnedRows("bottom");
        table.getCenterRows = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getRowModel().rows,
                table.getState().rowPinning.top,
                table.getState().rowPinning.bottom
            ], (allRows, top, bottom)=>{
            const topAndBottom = new Set([
                ...top != null ? top : [],
                ...bottom != null ? bottom : []
            ]);
            return allRows.filter((d)=>!topAndBottom.has(d.id));
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugRows", "getCenterRows"));
    }
};
//
const $829253db717f8f1b$export$e8905133e7bf3121 = {
    getInitialState: (state)=>{
        return {
            rowSelection: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onRowSelectionChange: $829253db717f8f1b$export$2b5605d8069324bd("rowSelection", table),
            enableRowSelection: true,
            enableMultiRowSelection: true,
            enableSubRowSelection: true
        };
    },
    createTable: (table)=>{
        table.setRowSelection = (updater)=>table.options.onRowSelectionChange == null ? void 0 : table.options.onRowSelectionChange(updater);
        table.resetRowSelection = (defaultState)=>{
            var _table$initialState$r;
            return table.setRowSelection(defaultState ? {} : (_table$initialState$r = table.initialState.rowSelection) != null ? _table$initialState$r : {});
        };
        table.toggleAllRowsSelected = (value)=>{
            table.setRowSelection((old)=>{
                value = typeof value !== "undefined" ? value : !table.getIsAllRowsSelected();
                const rowSelection = {
                    ...old
                };
                const preGroupedFlatRows = table.getPreGroupedRowModel().flatRows;
                // We don't use `mutateRowIsSelected` here for performance reasons.
                // All of the rows are flat already, so it wouldn't be worth it
                if (value) preGroupedFlatRows.forEach((row)=>{
                    if (!row.getCanSelect()) return;
                    rowSelection[row.id] = true;
                });
                else preGroupedFlatRows.forEach((row)=>{
                    delete rowSelection[row.id];
                });
                return rowSelection;
            });
        };
        table.toggleAllPageRowsSelected = (value)=>table.setRowSelection((old)=>{
                const resolvedValue = typeof value !== "undefined" ? value : !table.getIsAllPageRowsSelected();
                const rowSelection = {
                    ...old
                };
                table.getRowModel().rows.forEach((row)=>{
                    $829253db717f8f1b$var$mutateRowIsSelected(rowSelection, row.id, resolvedValue, true, table);
                });
                return rowSelection;
            });
        // addRowSelectionRange: rowId => {
        //   const {
        //     rows,
        //     rowsById,
        //     options: { selectGroupingRows, selectSubRows },
        //   } = table
        //   const findSelectedRow = (rows: Row[]) => {
        //     let found
        //     rows.find(d => {
        //       if (d.getIsSelected()) {
        //         found = d
        //         return true
        //       }
        //       const subFound = findSelectedRow(d.subRows || [])
        //       if (subFound) {
        //         found = subFound
        //         return true
        //       }
        //       return false
        //     })
        //     return found
        //   }
        //   const firstRow = findSelectedRow(rows) || rows[0]
        //   const lastRow = rowsById[rowId]
        //   let include = false
        //   const selectedRowIds = {}
        //   const addRow = (row: Row) => {
        //     mutateRowIsSelected(selectedRowIds, row.id, true, {
        //       rowsById,
        //       selectGroupingRows: selectGroupingRows!,
        //       selectSubRows: selectSubRows!,
        //     })
        //   }
        //   table.rows.forEach(row => {
        //     const isFirstRow = row.id === firstRow.id
        //     const isLastRow = row.id === lastRow.id
        //     if (isFirstRow || isLastRow) {
        //       if (!include) {
        //         include = true
        //       } else if (include) {
        //         addRow(row)
        //         include = false
        //       }
        //     }
        //     if (include) {
        //       addRow(row)
        //     }
        //   })
        //   table.setRowSelection(selectedRowIds)
        // },
        table.getPreSelectedRowModel = ()=>table.getCoreRowModel();
        table.getSelectedRowModel = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getCoreRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $829253db717f8f1b$export$f150e72530556b0b(table, rowModel);
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getSelectedRowModel"));
        table.getFilteredSelectedRowModel = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getFilteredRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $829253db717f8f1b$export$f150e72530556b0b(table, rowModel);
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getFilteredSelectedRowModel"));
        table.getGroupedSelectedRowModel = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getState().rowSelection,
                table.getSortedRowModel()
            ], (rowSelection, rowModel)=>{
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return $829253db717f8f1b$export$f150e72530556b0b(table, rowModel);
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getGroupedSelectedRowModel"));
        ///
        // getGroupingRowCanSelect: rowId => {
        //   const row = table.getRow(rowId)
        //   if (!row) {
        //     throw new Error()
        //   }
        //   if (typeof table.options.enableGroupingRowSelection === 'function') {
        //     return table.options.enableGroupingRowSelection(row)
        //   }
        //   return table.options.enableGroupingRowSelection ?? false
        // },
        table.getIsAllRowsSelected = ()=>{
            const preGroupedFlatRows = table.getFilteredRowModel().flatRows;
            const { rowSelection: rowSelection } = table.getState();
            let isAllRowsSelected = Boolean(preGroupedFlatRows.length && Object.keys(rowSelection).length);
            if (isAllRowsSelected) {
                if (preGroupedFlatRows.some((row)=>row.getCanSelect() && !rowSelection[row.id])) isAllRowsSelected = false;
            }
            return isAllRowsSelected;
        };
        table.getIsAllPageRowsSelected = ()=>{
            const paginationFlatRows = table.getPaginationRowModel().flatRows.filter((row)=>row.getCanSelect());
            const { rowSelection: rowSelection } = table.getState();
            let isAllPageRowsSelected = !!paginationFlatRows.length;
            if (isAllPageRowsSelected && paginationFlatRows.some((row)=>!rowSelection[row.id])) isAllPageRowsSelected = false;
            return isAllPageRowsSelected;
        };
        table.getIsSomeRowsSelected = ()=>{
            var _table$getState$rowSe;
            const totalSelected = Object.keys((_table$getState$rowSe = table.getState().rowSelection) != null ? _table$getState$rowSe : {}).length;
            return totalSelected > 0 && totalSelected < table.getFilteredRowModel().flatRows.length;
        };
        table.getIsSomePageRowsSelected = ()=>{
            const paginationFlatRows = table.getPaginationRowModel().flatRows;
            return table.getIsAllPageRowsSelected() ? false : paginationFlatRows.filter((row)=>row.getCanSelect()).some((d)=>d.getIsSelected() || d.getIsSomeSelected());
        };
        table.getToggleAllRowsSelectedHandler = ()=>{
            return (e)=>{
                table.toggleAllRowsSelected(e.target.checked);
            };
        };
        table.getToggleAllPageRowsSelectedHandler = ()=>{
            return (e)=>{
                table.toggleAllPageRowsSelected(e.target.checked);
            };
        };
    },
    createRow: (row, table)=>{
        row.toggleSelected = (value, opts)=>{
            const isSelected = row.getIsSelected();
            table.setRowSelection((old)=>{
                var _opts$selectChildren;
                value = typeof value !== "undefined" ? value : !isSelected;
                if (row.getCanSelect() && isSelected === value) return old;
                const selectedRowIds = {
                    ...old
                };
                $829253db717f8f1b$var$mutateRowIsSelected(selectedRowIds, row.id, value, (_opts$selectChildren = opts == null ? void 0 : opts.selectChildren) != null ? _opts$selectChildren : true, table);
                return selectedRowIds;
            });
        };
        row.getIsSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $829253db717f8f1b$export$710e11cf672b86c(row, rowSelection);
        };
        row.getIsSomeSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $829253db717f8f1b$export$8f4c46e5d7907334(row, rowSelection) === "some";
        };
        row.getIsAllSubRowsSelected = ()=>{
            const { rowSelection: rowSelection } = table.getState();
            return $829253db717f8f1b$export$8f4c46e5d7907334(row, rowSelection) === "all";
        };
        row.getCanSelect = ()=>{
            var _table$options$enable;
            if (typeof table.options.enableRowSelection === "function") return table.options.enableRowSelection(row);
            return (_table$options$enable = table.options.enableRowSelection) != null ? _table$options$enable : true;
        };
        row.getCanSelectSubRows = ()=>{
            var _table$options$enable2;
            if (typeof table.options.enableSubRowSelection === "function") return table.options.enableSubRowSelection(row);
            return (_table$options$enable2 = table.options.enableSubRowSelection) != null ? _table$options$enable2 : true;
        };
        row.getCanMultiSelect = ()=>{
            var _table$options$enable3;
            if (typeof table.options.enableMultiRowSelection === "function") return table.options.enableMultiRowSelection(row);
            return (_table$options$enable3 = table.options.enableMultiRowSelection) != null ? _table$options$enable3 : true;
        };
        row.getToggleSelectedHandler = ()=>{
            const canSelect = row.getCanSelect();
            return (e)=>{
                var _target;
                if (!canSelect) return;
                row.toggleSelected((_target = e.target) == null ? void 0 : _target.checked);
            };
        };
    }
};
const $829253db717f8f1b$var$mutateRowIsSelected = (selectedRowIds, id, value, includeChildren, table)=>{
    var _row$subRows;
    const row = table.getRow(id, true);
    // const isGrouped = row.getIsGrouped()
    // if ( // TODO: enforce grouping row selection rules
    //   !isGrouped ||
    //   (isGrouped && table.options.enableGroupingRowSelection)
    // ) {
    if (value) {
        if (!row.getCanMultiSelect()) Object.keys(selectedRowIds).forEach((key)=>delete selectedRowIds[key]);
        if (row.getCanSelect()) selectedRowIds[id] = true;
    } else delete selectedRowIds[id];
    // }
    if (includeChildren && (_row$subRows = row.subRows) != null && _row$subRows.length && row.getCanSelectSubRows()) row.subRows.forEach((row)=>$829253db717f8f1b$var$mutateRowIsSelected(selectedRowIds, row.id, value, includeChildren, table));
};
function $829253db717f8f1b$export$f150e72530556b0b(table, rowModel) {
    const rowSelection = table.getState().rowSelection;
    const newSelectedFlatRows = [];
    const newSelectedRowsById = {};
    // Filters top level and nested rows
    const recurseRows = function(rows, depth) {
        return rows.map((row)=>{
            var _row$subRows2;
            const isSelected = $829253db717f8f1b$export$710e11cf672b86c(row, rowSelection);
            if (isSelected) {
                newSelectedFlatRows.push(row);
                newSelectedRowsById[row.id] = row;
            }
            if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length) row = {
                ...row,
                subRows: recurseRows(row.subRows)
            };
            if (isSelected) return row;
        }).filter(Boolean);
    };
    return {
        rows: recurseRows(rowModel.rows),
        flatRows: newSelectedFlatRows,
        rowsById: newSelectedRowsById
    };
}
function $829253db717f8f1b$export$710e11cf672b86c(row, selection) {
    var _selection$row$id;
    return (_selection$row$id = selection[row.id]) != null ? _selection$row$id : false;
}
function $829253db717f8f1b$export$8f4c46e5d7907334(row, selection, table) {
    var _row$subRows3;
    if (!((_row$subRows3 = row.subRows) != null && _row$subRows3.length)) return false;
    let allChildrenSelected = true;
    let someSelected = false;
    row.subRows.forEach((subRow)=>{
        // Bail out early if we know both of these
        if (someSelected && !allChildrenSelected) return;
        if (subRow.getCanSelect()) {
            if ($829253db717f8f1b$export$710e11cf672b86c(subRow, selection)) someSelected = true;
            else allChildrenSelected = false;
        }
        // Check row selection of nested subrows
        if (subRow.subRows && subRow.subRows.length) {
            const subRowChildrenSelected = $829253db717f8f1b$export$8f4c46e5d7907334(subRow, selection);
            if (subRowChildrenSelected === "all") someSelected = true;
            else if (subRowChildrenSelected === "some") {
                someSelected = true;
                allChildrenSelected = false;
            } else allChildrenSelected = false;
        }
    });
    return allChildrenSelected ? "all" : someSelected ? "some" : false;
}
const $829253db717f8f1b$export$8758689f50bddb9f = /([0-9]+)/gm;
const $829253db717f8f1b$var$alphanumeric = (rowA, rowB, columnId)=>{
    return $829253db717f8f1b$var$compareAlphanumeric($829253db717f8f1b$var$toString(rowA.getValue(columnId)).toLowerCase(), $829253db717f8f1b$var$toString(rowB.getValue(columnId)).toLowerCase());
};
const $829253db717f8f1b$var$alphanumericCaseSensitive = (rowA, rowB, columnId)=>{
    return $829253db717f8f1b$var$compareAlphanumeric($829253db717f8f1b$var$toString(rowA.getValue(columnId)), $829253db717f8f1b$var$toString(rowB.getValue(columnId)));
};
// The text filter is more basic (less numeric support)
// but is much faster
const $829253db717f8f1b$var$text = (rowA, rowB, columnId)=>{
    return $829253db717f8f1b$var$compareBasic($829253db717f8f1b$var$toString(rowA.getValue(columnId)).toLowerCase(), $829253db717f8f1b$var$toString(rowB.getValue(columnId)).toLowerCase());
};
// The text filter is more basic (less numeric support)
// but is much faster
const $829253db717f8f1b$var$textCaseSensitive = (rowA, rowB, columnId)=>{
    return $829253db717f8f1b$var$compareBasic($829253db717f8f1b$var$toString(rowA.getValue(columnId)), $829253db717f8f1b$var$toString(rowB.getValue(columnId)));
};
const $829253db717f8f1b$var$datetime = (rowA, rowB, columnId)=>{
    const a = rowA.getValue(columnId);
    const b = rowB.getValue(columnId);
    // Can handle nullish values
    // Use > and < because == (and ===) doesn't work with
    // Date objects (would require calling getTime()).
    return a > b ? 1 : a < b ? -1 : 0;
};
const $829253db717f8f1b$var$basic = (rowA, rowB, columnId)=>{
    return $829253db717f8f1b$var$compareBasic(rowA.getValue(columnId), rowB.getValue(columnId));
};
// Utils
function $829253db717f8f1b$var$compareBasic(a, b) {
    return a === b ? 0 : a > b ? 1 : -1;
}
function $829253db717f8f1b$var$toString(a) {
    if (typeof a === "number") {
        if (isNaN(a) || a === Infinity || a === -Infinity) return "";
        return String(a);
    }
    if (typeof a === "string") return a;
    return "";
}
// Mixed sorting is slow, but very inclusive of many edge cases.
// It handles numbers, mixed alphanumeric combinations, and even
// null, undefined, and Infinity
function $829253db717f8f1b$var$compareAlphanumeric(aStr, bStr) {
    // Split on number groups, but keep the delimiter
    // Then remove falsey split values
    const a = aStr.split($829253db717f8f1b$export$8758689f50bddb9f).filter(Boolean);
    const b = bStr.split($829253db717f8f1b$export$8758689f50bddb9f).filter(Boolean);
    // While
    while(a.length && b.length){
        const aa = a.shift();
        const bb = b.shift();
        const an = parseInt(aa, 10);
        const bn = parseInt(bb, 10);
        const combo = [
            an,
            bn
        ].sort();
        // Both are string
        if (isNaN(combo[0])) {
            if (aa > bb) return 1;
            if (bb > aa) return -1;
            continue;
        }
        // One is a string, one is a number
        if (isNaN(combo[1])) return isNaN(an) ? -1 : 1;
        // Both are numbers
        if (an > bn) return 1;
        if (bn > an) return -1;
    }
    return a.length - b.length;
}
// Exports
const $829253db717f8f1b$export$47423a4cd813a815 = {
    alphanumeric: $829253db717f8f1b$var$alphanumeric,
    alphanumericCaseSensitive: $829253db717f8f1b$var$alphanumericCaseSensitive,
    text: $829253db717f8f1b$var$text,
    textCaseSensitive: $829253db717f8f1b$var$textCaseSensitive,
    datetime: $829253db717f8f1b$var$datetime,
    basic: $829253db717f8f1b$var$basic
};
//
const $829253db717f8f1b$export$9707dace2bc98438 = {
    getInitialState: (state)=>{
        return {
            sorting: [],
            ...state
        };
    },
    getDefaultColumnDef: ()=>{
        return {
            sortingFn: "auto",
            sortUndefined: 1
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onSortingChange: $829253db717f8f1b$export$2b5605d8069324bd("sorting", table),
            isMultiSortEvent: (e)=>{
                return e.shiftKey;
            }
        };
    },
    createColumn: (column, table)=>{
        column.getAutoSortingFn = ()=>{
            const firstRows = table.getFilteredRowModel().flatRows.slice(10);
            let isString = false;
            for (const row of firstRows){
                const value = row == null ? void 0 : row.getValue(column.id);
                if (Object.prototype.toString.call(value) === "[object Date]") return $829253db717f8f1b$export$47423a4cd813a815.datetime;
                if (typeof value === "string") {
                    isString = true;
                    if (value.split($829253db717f8f1b$export$8758689f50bddb9f).length > 1) return $829253db717f8f1b$export$47423a4cd813a815.alphanumeric;
                }
            }
            if (isString) return $829253db717f8f1b$export$47423a4cd813a815.text;
            return $829253db717f8f1b$export$47423a4cd813a815.basic;
        };
        column.getAutoSortDir = ()=>{
            const firstRow = table.getFilteredRowModel().flatRows[0];
            const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === "string") return "asc";
            return "desc";
        };
        column.getSortingFn = ()=>{
            var _table$options$sortin, _table$options$sortin2;
            if (!column) throw new Error();
            return $829253db717f8f1b$export$f6e2535fb5126e54(column.columnDef.sortingFn) ? column.columnDef.sortingFn : column.columnDef.sortingFn === "auto" ? column.getAutoSortingFn() : (_table$options$sortin = (_table$options$sortin2 = table.options.sortingFns) == null ? void 0 : _table$options$sortin2[column.columnDef.sortingFn]) != null ? _table$options$sortin : $829253db717f8f1b$export$47423a4cd813a815[column.columnDef.sortingFn];
        };
        column.toggleSorting = (desc, multi)=>{
            // if (column.columns.length) {
            //   column.columns.forEach((c, i) => {
            //     if (c.id) {
            //       table.toggleColumnSorting(c.id, undefined, multi || !!i)
            //     }
            //   })
            //   return
            // }
            // this needs to be outside of table.setSorting to be in sync with rerender
            const nextSortingOrder = column.getNextSortingOrder();
            const hasManualValue = typeof desc !== "undefined" && desc !== null;
            table.setSorting((old)=>{
                // Find any existing sorting for this column
                const existingSorting = old == null ? void 0 : old.find((d)=>d.id === column.id);
                const existingIndex = old == null ? void 0 : old.findIndex((d)=>d.id === column.id);
                let newSorting = [];
                // What should we do with this sort action?
                let sortAction;
                let nextDesc = hasManualValue ? desc : nextSortingOrder === "desc";
                // Multi-mode
                if (old != null && old.length && column.getCanMultiSort() && multi) {
                    if (existingSorting) sortAction = "toggle";
                    else sortAction = "add";
                } else {
                    // Normal mode
                    if (old != null && old.length && existingIndex !== old.length - 1) sortAction = "replace";
                    else if (existingSorting) sortAction = "toggle";
                    else sortAction = "replace";
                }
                // Handle toggle states that will remove the sorting
                if (sortAction === "toggle") {
                    // If we are "actually" toggling (not a manual set value), should we remove the sorting?
                    if (!hasManualValue) // Is our intention to remove?
                    {
                        if (!nextSortingOrder) sortAction = "remove";
                    }
                }
                if (sortAction === "add") {
                    var _table$options$maxMul;
                    newSorting = [
                        ...old,
                        {
                            id: column.id,
                            desc: nextDesc
                        }
                    ];
                    // Take latest n columns
                    newSorting.splice(0, newSorting.length - ((_table$options$maxMul = table.options.maxMultiSortColCount) != null ? _table$options$maxMul : Number.MAX_SAFE_INTEGER));
                } else if (sortAction === "toggle") // This flips (or sets) the
                newSorting = old.map((d)=>{
                    if (d.id === column.id) return {
                        ...d,
                        desc: nextDesc
                    };
                    return d;
                });
                else if (sortAction === "remove") newSorting = old.filter((d)=>d.id !== column.id);
                else newSorting = [
                    {
                        id: column.id,
                        desc: nextDesc
                    }
                ];
                return newSorting;
            });
        };
        column.getFirstSortDir = ()=>{
            var _ref, _column$columnDef$sor;
            const sortDescFirst = (_ref = (_column$columnDef$sor = column.columnDef.sortDescFirst) != null ? _column$columnDef$sor : table.options.sortDescFirst) != null ? _ref : column.getAutoSortDir() === "desc";
            return sortDescFirst ? "desc" : "asc";
        };
        column.getNextSortingOrder = (multi)=>{
            var _table$options$enable, _table$options$enable2;
            const firstSortDirection = column.getFirstSortDir();
            const isSorted = column.getIsSorted();
            if (!isSorted) return firstSortDirection;
            if (isSorted !== firstSortDirection && ((_table$options$enable = table.options.enableSortingRemoval) != null ? _table$options$enable : true) && // If enableSortRemove, enable in general
            (multi ? (_table$options$enable2 = table.options.enableMultiRemove) != null ? _table$options$enable2 : true : true // If multi, don't allow if enableMultiRemove))
            )) return false;
            return isSorted === "desc" ? "asc" : "desc";
        };
        column.getCanSort = ()=>{
            var _column$columnDef$ena, _table$options$enable3;
            return ((_column$columnDef$ena = column.columnDef.enableSorting) != null ? _column$columnDef$ena : true) && ((_table$options$enable3 = table.options.enableSorting) != null ? _table$options$enable3 : true) && !!column.accessorFn;
        };
        column.getCanMultiSort = ()=>{
            var _ref2, _column$columnDef$ena2;
            return (_ref2 = (_column$columnDef$ena2 = column.columnDef.enableMultiSort) != null ? _column$columnDef$ena2 : table.options.enableMultiSort) != null ? _ref2 : !!column.accessorFn;
        };
        column.getIsSorted = ()=>{
            var _table$getState$sorti;
            const columnSort = (_table$getState$sorti = table.getState().sorting) == null ? void 0 : _table$getState$sorti.find((d)=>d.id === column.id);
            return !columnSort ? false : columnSort.desc ? "desc" : "asc";
        };
        column.getSortIndex = ()=>{
            var _table$getState$sorti2, _table$getState$sorti3;
            return (_table$getState$sorti2 = (_table$getState$sorti3 = table.getState().sorting) == null ? void 0 : _table$getState$sorti3.findIndex((d)=>d.id === column.id)) != null ? _table$getState$sorti2 : -1;
        };
        column.clearSorting = ()=>{
            //clear sorting for just 1 column
            table.setSorting((old)=>old != null && old.length ? old.filter((d)=>d.id !== column.id) : []);
        };
        column.getToggleSortingHandler = ()=>{
            const canSort = column.getCanSort();
            return (e)=>{
                if (!canSort) return;
                e.persist == null || e.persist();
                column.toggleSorting == null || column.toggleSorting(undefined, column.getCanMultiSort() ? table.options.isMultiSortEvent == null ? void 0 : table.options.isMultiSortEvent(e) : false);
            };
        };
    },
    createTable: (table)=>{
        table.setSorting = (updater)=>table.options.onSortingChange == null ? void 0 : table.options.onSortingChange(updater);
        table.resetSorting = (defaultState)=>{
            var _table$initialState$s, _table$initialState;
            table.setSorting(defaultState ? [] : (_table$initialState$s = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.sorting) != null ? _table$initialState$s : []);
        };
        table.getPreSortedRowModel = ()=>table.getGroupedRowModel();
        table.getSortedRowModel = ()=>{
            if (!table._getSortedRowModel && table.options.getSortedRowModel) table._getSortedRowModel = table.options.getSortedRowModel(table);
            if (table.options.manualSorting || !table._getSortedRowModel) return table.getPreSortedRowModel();
            return table._getSortedRowModel();
        };
    }
};
//
const $829253db717f8f1b$export$5afe92775e3e701d = {
    getInitialState: (state)=>{
        return {
            columnVisibility: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnVisibilityChange: $829253db717f8f1b$export$2b5605d8069324bd("columnVisibility", table)
        };
    },
    createColumn: (column, table)=>{
        column.toggleVisibility = (value)=>{
            if (column.getCanHide()) table.setColumnVisibility((old)=>({
                    ...old,
                    [column.id]: value != null ? value : !column.getIsVisible()
                }));
        };
        column.getIsVisible = ()=>{
            var _ref, _table$getState$colum;
            const childColumns = column.columns;
            return (_ref = childColumns.length ? childColumns.some((c)=>c.getIsVisible()) : (_table$getState$colum = table.getState().columnVisibility) == null ? void 0 : _table$getState$colum[column.id]) != null ? _ref : true;
        };
        column.getCanHide = ()=>{
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableHiding) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableHiding) != null ? _table$options$enable : true);
        };
        column.getToggleVisibilityHandler = ()=>{
            return (e)=>{
                column.toggleVisibility == null || column.toggleVisibility(e.target.checked);
            };
        };
    },
    createRow: (row, table)=>{
        row._getAllVisibleCells = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                row.getAllCells(),
                table.getState().columnVisibility
            ], (cells)=>{
            return cells.filter((cell)=>cell.column.getIsVisible());
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugRows", "_getAllVisibleCells"));
        row.getVisibleCells = $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                row.getLeftVisibleCells(),
                row.getCenterVisibleCells(),
                row.getRightVisibleCells()
            ], (left, center, right)=>[
                ...left,
                ...center,
                ...right
            ], $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugRows", "getVisibleCells"));
    },
    createTable: (table)=>{
        const makeVisibleColumnsMethod = (key, getColumns)=>{
            return $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                    getColumns(),
                    getColumns().filter((d)=>d.getIsVisible()).map((d)=>d.id).join("_")
                ], (columns)=>{
                return columns.filter((d)=>d.getIsVisible == null ? void 0 : d.getIsVisible());
            }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugColumns", key));
        };
        table.getVisibleFlatColumns = makeVisibleColumnsMethod("getVisibleFlatColumns", ()=>table.getAllFlatColumns());
        table.getVisibleLeafColumns = makeVisibleColumnsMethod("getVisibleLeafColumns", ()=>table.getAllLeafColumns());
        table.getLeftVisibleLeafColumns = makeVisibleColumnsMethod("getLeftVisibleLeafColumns", ()=>table.getLeftLeafColumns());
        table.getRightVisibleLeafColumns = makeVisibleColumnsMethod("getRightVisibleLeafColumns", ()=>table.getRightLeafColumns());
        table.getCenterVisibleLeafColumns = makeVisibleColumnsMethod("getCenterVisibleLeafColumns", ()=>table.getCenterLeafColumns());
        table.setColumnVisibility = (updater)=>table.options.onColumnVisibilityChange == null ? void 0 : table.options.onColumnVisibilityChange(updater);
        table.resetColumnVisibility = (defaultState)=>{
            var _table$initialState$c;
            table.setColumnVisibility(defaultState ? {} : (_table$initialState$c = table.initialState.columnVisibility) != null ? _table$initialState$c : {});
        };
        table.toggleAllColumnsVisible = (value)=>{
            var _value;
            value = (_value = value) != null ? _value : !table.getIsAllColumnsVisible();
            table.setColumnVisibility(table.getAllLeafColumns().reduce((obj, column)=>({
                    ...obj,
                    [column.id]: !value ? !(column.getCanHide != null && column.getCanHide()) : value
                }), {}));
        };
        table.getIsAllColumnsVisible = ()=>!table.getAllLeafColumns().some((column)=>!(column.getIsVisible != null && column.getIsVisible()));
        table.getIsSomeColumnsVisible = ()=>table.getAllLeafColumns().some((column)=>column.getIsVisible == null ? void 0 : column.getIsVisible());
        table.getToggleAllColumnsVisibilityHandler = ()=>{
            return (e)=>{
                var _target;
                table.toggleAllColumnsVisible((_target = e.target) == null ? void 0 : _target.checked);
            };
        };
    }
};
function $829253db717f8f1b$export$1d7c103713892a11(table, position) {
    return !position ? table.getVisibleLeafColumns() : position === "center" ? table.getCenterVisibleLeafColumns() : position === "left" ? table.getLeftVisibleLeafColumns() : table.getRightVisibleLeafColumns();
}
const $829253db717f8f1b$var$features = [
    $829253db717f8f1b$export$79b704688b15c0f4,
    $829253db717f8f1b$export$5afe92775e3e701d,
    $829253db717f8f1b$export$549aff5da5ccfd97,
    $829253db717f8f1b$export$5289f180505593b3,
    $829253db717f8f1b$export$92a576f896a9bf72,
    $829253db717f8f1b$export$9707dace2bc98438,
    $829253db717f8f1b$export$3885c0af90651e94,
    $829253db717f8f1b$export$c9bad30efcce6e0c,
    $829253db717f8f1b$export$68f5e1453c188a82,
    $829253db717f8f1b$export$e8905133e7bf3121,
    $829253db717f8f1b$export$9916c85814812d4a
];
//
function $829253db717f8f1b$export$33bbb3ec7652e187(options) {
    var _options$initialState;
    if (options.debugAll || options.debugTable) console.info("Creating Table Instance...");
    let table = {
        _features: $829253db717f8f1b$var$features
    };
    const defaultOptions = table._features.reduce((obj, feature)=>{
        return Object.assign(obj, feature.getDefaultOptions == null ? void 0 : feature.getDefaultOptions(table));
    }, {});
    const mergeOptions = (options)=>{
        if (table.options.mergeOptions) return table.options.mergeOptions(defaultOptions, options);
        return {
            ...defaultOptions,
            ...options
        };
    };
    const coreInitialState = {};
    let initialState = {
        ...coreInitialState,
        ...(_options$initialState = options.initialState) != null ? _options$initialState : {}
    };
    table._features.forEach((feature)=>{
        var _feature$getInitialSt;
        initialState = (_feature$getInitialSt = feature.getInitialState == null ? void 0 : feature.getInitialState(initialState)) != null ? _feature$getInitialSt : initialState;
    });
    const queued = [];
    let queuedTimeout = false;
    const coreInstance = {
        _features: $829253db717f8f1b$var$features,
        options: {
            ...defaultOptions,
            ...options
        },
        initialState: initialState,
        _queue: (cb)=>{
            queued.push(cb);
            if (!queuedTimeout) {
                queuedTimeout = true;
                // Schedule a microtask to run the queued callbacks after
                // the current call stack (render, etc) has finished.
                Promise.resolve().then(()=>{
                    while(queued.length)queued.shift()();
                    queuedTimeout = false;
                }).catch((error)=>setTimeout(()=>{
                        throw error;
                    }));
            }
        },
        reset: ()=>{
            table.setState(table.initialState);
        },
        setOptions: (updater)=>{
            const newOptions = $829253db717f8f1b$export$7f095f455ad5af3f(updater, table.options);
            table.options = mergeOptions(newOptions);
        },
        getState: ()=>{
            return table.options.state;
        },
        setState: (updater)=>{
            table.options.onStateChange == null || table.options.onStateChange(updater);
        },
        _getRowId: (row, index, parent)=>{
            var _table$options$getRow;
            return (_table$options$getRow = table.options.getRowId == null ? void 0 : table.options.getRowId(row, index, parent)) != null ? _table$options$getRow : `${parent ? [
                parent.id,
                index
            ].join(".") : index}`;
        },
        getCoreRowModel: ()=>{
            if (!table._getCoreRowModel) table._getCoreRowModel = table.options.getCoreRowModel(table);
            return table._getCoreRowModel();
        },
        // The final calls start at the bottom of the model,
        // expanded rows, which then work their way up
        getRowModel: ()=>{
            return table.getPaginationRowModel();
        },
        //in next version, we should just pass in the row model as the optional 2nd arg
        getRow: (id, searchAll)=>{
            let row = (searchAll ? table.getPrePaginationRowModel() : table.getRowModel()).rowsById[id];
            if (!row) {
                row = table.getCoreRowModel().rowsById[id];
                if (!row) throw new Error();
            }
            return row;
        },
        _getDefaultColumnDef: $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.options.defaultColumn
            ], (defaultColumn)=>{
            var _defaultColumn;
            defaultColumn = (_defaultColumn = defaultColumn) != null ? _defaultColumn : {};
            return {
                header: (props)=>{
                    const resolvedColumnDef = props.header.column.columnDef;
                    if (resolvedColumnDef.accessorKey) return resolvedColumnDef.accessorKey;
                    if (resolvedColumnDef.accessorFn) return resolvedColumnDef.id;
                    return null;
                },
                // footer: props => props.header.column.id,
                cell: (props)=>{
                    var _props$renderValue$to, _props$renderValue;
                    return (_props$renderValue$to = (_props$renderValue = props.renderValue()) == null || _props$renderValue.toString == null ? void 0 : _props$renderValue.toString()) != null ? _props$renderValue$to : null;
                },
                ...table._features.reduce((obj, feature)=>{
                    return Object.assign(obj, feature.getDefaultColumnDef == null ? void 0 : feature.getDefaultColumnDef());
                }, {}),
                ...defaultColumn
            };
        }, $829253db717f8f1b$export$b1f82222dc43996c(options, "debugColumns", "_getDefaultColumnDef")),
        _getColumnDefs: ()=>table.options.columns,
        getAllColumns: $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table._getColumnDefs()
            ], (columnDefs)=>{
            const recurseColumns = function(columnDefs, parent, depth) {
                if (depth === void 0) depth = 0;
                return columnDefs.map((columnDef)=>{
                    const column = $829253db717f8f1b$export$1bfa986e9c92c0b5(table, columnDef, depth, parent);
                    const groupingColumnDef = columnDef;
                    column.columns = groupingColumnDef.columns ? recurseColumns(groupingColumnDef.columns, column, depth + 1) : [];
                    return column;
                });
            };
            return recurseColumns(columnDefs);
        }, $829253db717f8f1b$export$b1f82222dc43996c(options, "debugColumns", "getAllColumns")),
        getAllFlatColumns: $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getAllColumns()
            ], (allColumns)=>{
            return allColumns.flatMap((column)=>{
                return column.getFlatColumns();
            });
        }, $829253db717f8f1b$export$b1f82222dc43996c(options, "debugColumns", "getAllFlatColumns")),
        _getAllFlatColumnsById: $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getAllFlatColumns()
            ], (flatColumns)=>{
            return flatColumns.reduce((acc, column)=>{
                acc[column.id] = column;
                return acc;
            }, {});
        }, $829253db717f8f1b$export$b1f82222dc43996c(options, "debugColumns", "getAllFlatColumnsById")),
        getAllLeafColumns: $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table._getOrderColumnsFn()
            ], (allColumns, orderColumns)=>{
            let leafColumns = allColumns.flatMap((column)=>column.getLeafColumns());
            return orderColumns(leafColumns);
        }, $829253db717f8f1b$export$b1f82222dc43996c(options, "debugColumns", "getAllLeafColumns")),
        getColumn: (columnId)=>{
            const column = table._getAllFlatColumnsById()[columnId];
            return column;
        }
    };
    Object.assign(table, coreInstance);
    for(let index = 0; index < table._features.length; index++){
        const feature = table._features[index];
        feature == null || feature.createTable == null || feature.createTable(table);
    }
    return table;
}
function $829253db717f8f1b$export$3cb21b6b1233300e(table, row, column, columnId) {
    const getRenderValue = ()=>{
        var _cell$getValue;
        return (_cell$getValue = cell.getValue()) != null ? _cell$getValue : table.options.renderFallbackValue;
    };
    const cell = {
        id: `${row.id}_${column.id}`,
        row: row,
        column: column,
        getValue: ()=>row.getValue(columnId),
        renderValue: getRenderValue,
        getContext: $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table,
                column,
                row,
                cell
            ], (table, column, row, cell)=>({
                table: table,
                column: column,
                row: row,
                cell: cell,
                getValue: cell.getValue,
                renderValue: cell.renderValue
            }), $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugCells", "cell.getContext"))
    };
    table._features.forEach((feature)=>{
        feature.createCell == null || feature.createCell(cell, column, row, table);
    }, {});
    return cell;
}
const $829253db717f8f1b$export$3442c5d213434705 = (table, id, original, rowIndex, depth, subRows, parentId)=>{
    let row = {
        id: id,
        index: rowIndex,
        original: original,
        depth: depth,
        parentId: parentId,
        _valuesCache: {},
        _uniqueValuesCache: {},
        getValue: (columnId)=>{
            if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            row._valuesCache[columnId] = column.accessorFn(row.original, rowIndex);
            return row._valuesCache[columnId];
        },
        getUniqueValues: (columnId)=>{
            if (row._uniqueValuesCache.hasOwnProperty(columnId)) return row._uniqueValuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            if (!column.columnDef.getUniqueValues) {
                row._uniqueValuesCache[columnId] = [
                    row.getValue(columnId)
                ];
                return row._uniqueValuesCache[columnId];
            }
            row._uniqueValuesCache[columnId] = column.columnDef.getUniqueValues(row.original, rowIndex);
            return row._uniqueValuesCache[columnId];
        },
        renderValue: (columnId)=>{
            var _row$getValue;
            return (_row$getValue = row.getValue(columnId)) != null ? _row$getValue : table.options.renderFallbackValue;
        },
        subRows: subRows != null ? subRows : [],
        getLeafRows: ()=>$829253db717f8f1b$export$bf4548421d1b2c8(row.subRows, (d)=>d.subRows),
        getParentRow: ()=>row.parentId ? table.getRow(row.parentId, true) : undefined,
        getParentRows: ()=>{
            let parentRows = [];
            let currentRow = row;
            while(true){
                const parentRow = currentRow.getParentRow();
                if (!parentRow) break;
                parentRows.push(parentRow);
                currentRow = parentRow;
            }
            return parentRows.reverse();
        },
        getAllCells: $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns()
            ], (leafColumns)=>{
            return leafColumns.map((column)=>{
                return $829253db717f8f1b$export$3cb21b6b1233300e(table, row, column, column.id);
            });
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugRows", "getAllCells")),
        _getAllCellsByColumnId: $829253db717f8f1b$export$7c73462e0d25e514(()=>[
                row.getAllCells()
            ], (allCells)=>{
            return allCells.reduce((acc, cell)=>{
                acc[cell.column.id] = cell;
                return acc;
            }, {});
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugRows", "getAllCellsByColumnId"))
    };
    for(let i = 0; i < table._features.length; i++){
        const feature = table._features[i];
        feature == null || feature.createRow == null || feature.createRow(row, table);
    }
    return row;
};
// type Person = {
//   firstName: string
//   lastName: string
//   age: number
//   visits: number
//   status: string
//   progress: number
//   createdAt: Date
//   nested: {
//     foo: [
//       {
//         bar: 'bar'
//       }
//     ]
//     bar: { subBar: boolean }[]
//     baz: {
//       foo: 'foo'
//       bar: {
//         baz: 'baz'
//       }
//     }
//   }
// }
// const test: DeepKeys<Person> = 'nested.foo.0.bar'
// const test2: DeepKeys<Person> = 'nested.bar'
// const helper = createColumnHelper<Person>()
// helper.accessor('nested.foo', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.foo.0.bar', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.bar', {
//   cell: info => info.getValue(),
// })
function $829253db717f8f1b$export$4b44a5cb9651fe5e() {
    return {
        accessor: (accessor, column)=>{
            return typeof accessor === "function" ? {
                ...column,
                accessorFn: accessor
            } : {
                ...column,
                accessorKey: accessor
            };
        },
        display: (column)=>column,
        group: (column)=>column
    };
}
function $829253db717f8f1b$export$32d0bc001e828250() {
    return (table)=>$829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.options.data
            ], (data)=>{
            const rowModel = {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            const accessRows = function(originalRows, depth, parentRow) {
                if (depth === void 0) depth = 0;
                const rows = [];
                for(let i = 0; i < originalRows.length; i++){
                    // This could be an expensive check at scale, so we should move it somewhere else, but where?
                    // if (!id) {
                    //   if (process.env.NODE_ENV !== 'production') {
                    //     throw new Error(`getRowId expected an ID, but got ${id}`)
                    //   }
                    // }
                    // Make the row
                    const row = $829253db717f8f1b$export$3442c5d213434705(table, table._getRowId(originalRows[i], i, parentRow), originalRows[i], i, depth, undefined, parentRow == null ? void 0 : parentRow.id);
                    // Keep track of every row in a flat array
                    rowModel.flatRows.push(row);
                    // Also keep track of every row by its ID
                    rowModel.rowsById[row.id] = row;
                    // Push table row into parent
                    rows.push(row);
                    // Get the original subrows
                    if (table.options.getSubRows) {
                        var _row$originalSubRows;
                        row.originalSubRows = table.options.getSubRows(originalRows[i], i);
                        // Then recursively access them
                        if ((_row$originalSubRows = row.originalSubRows) != null && _row$originalSubRows.length) row.subRows = accessRows(row.originalSubRows, depth + 1, row);
                    }
                }
                return rows;
            };
            rowModel.rows = accessRows(data);
            return rowModel;
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getRowModel", ()=>table._autoResetPageIndex()));
}
function $829253db717f8f1b$var$filterRows(rows, filterRowImpl, table) {
    if (table.options.filterFromLeafRows) return $829253db717f8f1b$var$filterRowModelFromLeafs(rows, filterRowImpl, table);
    return $829253db717f8f1b$var$filterRowModelFromRoot(rows, filterRowImpl, table);
}
function $829253db717f8f1b$var$filterRowModelFromLeafs(rowsToFilter, filterRow, table) {
    var _table$options$maxLea;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea : 100;
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        const rows = [];
        // Filter from children up first
        for(let i = 0; i < rowsToFilter.length; i++){
            var _row$subRows;
            let row = rowsToFilter[i];
            const newRow = $829253db717f8f1b$export$3442c5d213434705(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
            newRow.columnFilters = row.columnFilters;
            if ((_row$subRows = row.subRows) != null && _row$subRows.length && depth < maxDepth) {
                newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                row = newRow;
                if (filterRow(row) && !newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                    continue;
                }
                if (filterRow(row) || newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                    continue;
                }
            } else {
                row = newRow;
                if (filterRow(row)) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                }
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function $829253db717f8f1b$var$filterRowModelFromRoot(rowsToFilter, filterRow, table) {
    var _table$options$maxLea2;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea2 = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea2 : 100;
    // Filters top level and nested rows
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        // Filter from parents downward first
        const rows = [];
        // Apply the filter to any subRows
        for(let i = 0; i < rowsToFilter.length; i++){
            let row = rowsToFilter[i];
            const pass = filterRow(row);
            if (pass) {
                var _row$subRows2;
                if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length && depth < maxDepth) {
                    const newRow = $829253db717f8f1b$export$3442c5d213434705(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
                    newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                    row = newRow;
                }
                rows.push(row);
                newFilteredFlatRows.push(row);
                newFilteredRowsById[row.id] = row;
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function $829253db717f8f1b$export$26f255a2756e1638() {
    return (table)=>$829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter
            ], (rowModel, columnFilters, globalFilter)=>{
            if (!rowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) {
                for(let i = 0; i < rowModel.flatRows.length; i++){
                    rowModel.flatRows[i].columnFilters = {};
                    rowModel.flatRows[i].columnFiltersMeta = {};
                }
                return rowModel;
            }
            const resolvedColumnFilters = [];
            const resolvedGlobalFilters = [];
            (columnFilters != null ? columnFilters : []).forEach((d)=>{
                var _filterFn$resolveFilt;
                const column = table.getColumn(d.id);
                if (!column) return;
                const filterFn = column.getFilterFn();
                if (!filterFn) return;
                resolvedColumnFilters.push({
                    id: d.id,
                    filterFn: filterFn,
                    resolvedValue: (_filterFn$resolveFilt = filterFn.resolveFilterValue == null ? void 0 : filterFn.resolveFilterValue(d.value)) != null ? _filterFn$resolveFilt : d.value
                });
            });
            const filterableIds = columnFilters.map((d)=>d.id);
            const globalFilterFn = table.getGlobalFilterFn();
            const globallyFilterableColumns = table.getAllLeafColumns().filter((column)=>column.getCanGlobalFilter());
            if (globalFilter && globalFilterFn && globallyFilterableColumns.length) {
                filterableIds.push("__global__");
                globallyFilterableColumns.forEach((column)=>{
                    var _globalFilterFn$resol;
                    resolvedGlobalFilters.push({
                        id: column.id,
                        filterFn: globalFilterFn,
                        resolvedValue: (_globalFilterFn$resol = globalFilterFn.resolveFilterValue == null ? void 0 : globalFilterFn.resolveFilterValue(globalFilter)) != null ? _globalFilterFn$resol : globalFilter
                    });
                });
            }
            let currentColumnFilter;
            let currentGlobalFilter;
            // Flag the prefiltered row model with each filter state
            for(let j = 0; j < rowModel.flatRows.length; j++){
                const row = rowModel.flatRows[j];
                row.columnFilters = {};
                if (resolvedColumnFilters.length) for(let i = 0; i < resolvedColumnFilters.length; i++){
                    currentColumnFilter = resolvedColumnFilters[i];
                    const id = currentColumnFilter.id;
                    // Tag the row with the column filter state
                    row.columnFilters[id] = currentColumnFilter.filterFn(row, id, currentColumnFilter.resolvedValue, (filterMeta)=>{
                        row.columnFiltersMeta[id] = filterMeta;
                    });
                }
                if (resolvedGlobalFilters.length) {
                    for(let i = 0; i < resolvedGlobalFilters.length; i++){
                        currentGlobalFilter = resolvedGlobalFilters[i];
                        const id = currentGlobalFilter.id;
                        // Tag the row with the first truthy global filter state
                        if (currentGlobalFilter.filterFn(row, id, currentGlobalFilter.resolvedValue, (filterMeta)=>{
                            row.columnFiltersMeta[id] = filterMeta;
                        })) {
                            row.columnFilters.__global__ = true;
                            break;
                        }
                    }
                    if (row.columnFilters.__global__ !== true) row.columnFilters.__global__ = false;
                }
            }
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            // Filter final rows using all of the active filters
            return $829253db717f8f1b$var$filterRows(rowModel.rows, filterRowsImpl, table);
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getFilteredRowModel", ()=>table._autoResetPageIndex()));
}
function $829253db717f8f1b$export$3519aa0e35dc33b4() {
    return (table, columnId)=>$829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter,
                table.getFilteredRowModel()
            ], (preRowModel, columnFilters, globalFilter)=>{
            if (!preRowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) return preRowModel;
            const filterableIds = [
                ...columnFilters.map((d)=>d.id).filter((d)=>d !== columnId),
                globalFilter ? "__global__" : undefined
            ].filter(Boolean);
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            return $829253db717f8f1b$var$filterRows(preRowModel.rows, filterRowsImpl, table);
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getFacetedRowModel"));
}
function $829253db717f8f1b$export$1fb5d0c1edc37de2() {
    return (table, columnId)=>$829253db717f8f1b$export$7c73462e0d25e514(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            if (!facetedRowModel) return new Map();
            let facetedUniqueValues = new Map();
            for(let i = 0; i < facetedRowModel.flatRows.length; i++){
                const values = facetedRowModel.flatRows[i].getUniqueValues(columnId);
                for(let j = 0; j < values.length; j++){
                    const value = values[j];
                    if (facetedUniqueValues.has(value)) {
                        var _facetedUniqueValues$;
                        facetedUniqueValues.set(value, ((_facetedUniqueValues$ = facetedUniqueValues.get(value)) != null ? _facetedUniqueValues$ : 0) + 1);
                    } else facetedUniqueValues.set(value, 1);
                }
            }
            return facetedUniqueValues;
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", `getFacetedUniqueValues_${columnId}`));
}
function $829253db717f8f1b$export$d17dd32c9eab9fc7() {
    return (table, columnId)=>$829253db717f8f1b$export$7c73462e0d25e514(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            var _facetedRowModel$flat;
            if (!facetedRowModel) return undefined;
            const firstValue = (_facetedRowModel$flat = facetedRowModel.flatRows[0]) == null ? void 0 : _facetedRowModel$flat.getUniqueValues(columnId);
            if (typeof firstValue === "undefined") return undefined;
            let facetedMinMaxValues = [
                firstValue,
                firstValue
            ];
            for(let i = 0; i < facetedRowModel.flatRows.length; i++){
                const values = facetedRowModel.flatRows[i].getUniqueValues(columnId);
                for(let j = 0; j < values.length; j++){
                    const value = values[j];
                    if (value < facetedMinMaxValues[0]) facetedMinMaxValues[0] = value;
                    else if (value > facetedMinMaxValues[1]) facetedMinMaxValues[1] = value;
                }
            }
            return facetedMinMaxValues;
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getFacetedMinMaxValues"));
}
function $829253db717f8f1b$export$4ca93ca80835d8c1() {
    return (table)=>$829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getState().sorting,
                table.getPreSortedRowModel()
            ], (sorting, rowModel)=>{
            if (!rowModel.rows.length || !(sorting != null && sorting.length)) return rowModel;
            const sortingState = table.getState().sorting;
            const sortedFlatRows = [];
            // Filter out sortings that correspond to non existing columns
            const availableSorting = sortingState.filter((sort)=>{
                var _table$getColumn;
                return (_table$getColumn = table.getColumn(sort.id)) == null ? void 0 : _table$getColumn.getCanSort();
            });
            const columnInfoById = {};
            availableSorting.forEach((sortEntry)=>{
                const column = table.getColumn(sortEntry.id);
                if (!column) return;
                columnInfoById[sortEntry.id] = {
                    sortUndefined: column.columnDef.sortUndefined,
                    invertSorting: column.columnDef.invertSorting,
                    sortingFn: column.getSortingFn()
                };
            });
            const sortData = (rows)=>{
                // This will also perform a stable sorting using the row index
                // if needed.
                const sortedData = rows.map((row)=>({
                        ...row
                    }));
                sortedData.sort((rowA, rowB)=>{
                    for(let i = 0; i < availableSorting.length; i += 1){
                        var _sortEntry$desc;
                        const sortEntry = availableSorting[i];
                        const columnInfo = columnInfoById[sortEntry.id];
                        const isDesc = (_sortEntry$desc = sortEntry == null ? void 0 : sortEntry.desc) != null ? _sortEntry$desc : false;
                        let sortInt = 0;
                        // All sorting ints should always return in ascending order
                        if (columnInfo.sortUndefined) {
                            const aValue = rowA.getValue(sortEntry.id);
                            const bValue = rowB.getValue(sortEntry.id);
                            const aUndefined = aValue === undefined;
                            const bUndefined = bValue === undefined;
                            if (aUndefined || bUndefined) sortInt = aUndefined && bUndefined ? 0 : aUndefined ? columnInfo.sortUndefined : -columnInfo.sortUndefined;
                        }
                        if (sortInt === 0) sortInt = columnInfo.sortingFn(rowA, rowB, sortEntry.id);
                        // If sorting is non-zero, take care of desc and inversion
                        if (sortInt !== 0) {
                            if (isDesc) sortInt *= -1;
                            if (columnInfo.invertSorting) sortInt *= -1;
                            return sortInt;
                        }
                    }
                    return rowA.index - rowB.index;
                });
                // If there are sub-rows, sort them
                sortedData.forEach((row)=>{
                    var _row$subRows;
                    sortedFlatRows.push(row);
                    if ((_row$subRows = row.subRows) != null && _row$subRows.length) row.subRows = sortData(row.subRows);
                });
                return sortedData;
            };
            return {
                rows: sortData(rowModel.rows),
                flatRows: sortedFlatRows,
                rowsById: rowModel.rowsById
            };
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getSortedRowModel", ()=>table._autoResetPageIndex()));
}
function $829253db717f8f1b$export$2b7f4b57ce71b81() {
    return (table)=>$829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getState().grouping,
                table.getPreGroupedRowModel()
            ], (grouping, rowModel)=>{
            if (!rowModel.rows.length || !grouping.length) return rowModel;
            // Filter the grouping list down to columns that exist
            const existingGrouping = grouping.filter((columnId)=>table.getColumn(columnId));
            const groupedFlatRows = [];
            const groupedRowsById = {};
            // const onlyGroupedFlatRows: Row[] = [];
            // const onlyGroupedRowsById: Record<RowId, Row> = {};
            // const nonGroupedFlatRows: Row[] = [];
            // const nonGroupedRowsById: Record<RowId, Row> = {};
            // Recursively group the data
            const groupUpRecursively = function(rows, depth, parentId) {
                if (depth === void 0) depth = 0;
                // Grouping depth has been been met
                // Stop grouping and simply rewrite thd depth and row relationships
                if (depth >= existingGrouping.length) return rows.map((row)=>{
                    row.depth = depth;
                    groupedFlatRows.push(row);
                    groupedRowsById[row.id] = row;
                    if (row.subRows) row.subRows = groupUpRecursively(row.subRows, depth + 1, row.id);
                    return row;
                });
                const columnId = existingGrouping[depth];
                // Group the rows together for this level
                const rowGroupsMap = $829253db717f8f1b$var$groupBy(rows, columnId);
                // Peform aggregations for each group
                const aggregatedGroupedRows = Array.from(rowGroupsMap.entries()).map((_ref, index)=>{
                    let [groupingValue, groupedRows] = _ref;
                    let id = `${columnId}:${groupingValue}`;
                    id = parentId ? `${parentId}>${id}` : id;
                    // First, Recurse to group sub rows before aggregation
                    const subRows = groupUpRecursively(groupedRows, depth + 1, id);
                    // Flatten the leaf rows of the rows in this group
                    const leafRows = depth ? $829253db717f8f1b$export$bf4548421d1b2c8(groupedRows, (row)=>row.subRows) : groupedRows;
                    const row = $829253db717f8f1b$export$3442c5d213434705(table, id, leafRows[0].original, index, depth, undefined, parentId);
                    Object.assign(row, {
                        groupingColumnId: columnId,
                        groupingValue: groupingValue,
                        subRows: subRows,
                        leafRows: leafRows,
                        getValue: (columnId)=>{
                            // Don't aggregate columns that are in the grouping
                            if (existingGrouping.includes(columnId)) {
                                if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
                                if (groupedRows[0]) {
                                    var _groupedRows$0$getVal;
                                    row._valuesCache[columnId] = (_groupedRows$0$getVal = groupedRows[0].getValue(columnId)) != null ? _groupedRows$0$getVal : undefined;
                                }
                                return row._valuesCache[columnId];
                            }
                            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
                            // Aggregate the values
                            const column = table.getColumn(columnId);
                            const aggregateFn = column == null ? void 0 : column.getAggregationFn();
                            if (aggregateFn) {
                                row._groupingValuesCache[columnId] = aggregateFn(columnId, leafRows, groupedRows);
                                return row._groupingValuesCache[columnId];
                            }
                        }
                    });
                    subRows.forEach((subRow)=>{
                        groupedFlatRows.push(subRow);
                        groupedRowsById[subRow.id] = subRow;
                    // if (subRow.getIsGrouped?.()) {
                    //   onlyGroupedFlatRows.push(subRow);
                    //   onlyGroupedRowsById[subRow.id] = subRow;
                    // } else {
                    //   nonGroupedFlatRows.push(subRow);
                    //   nonGroupedRowsById[subRow.id] = subRow;
                    // }
                    });
                    return row;
                });
                return aggregatedGroupedRows;
            };
            const groupedRows = groupUpRecursively(rowModel.rows, 0);
            groupedRows.forEach((subRow)=>{
                groupedFlatRows.push(subRow);
                groupedRowsById[subRow.id] = subRow;
            // if (subRow.getIsGrouped?.()) {
            //   onlyGroupedFlatRows.push(subRow);
            //   onlyGroupedRowsById[subRow.id] = subRow;
            // } else {
            //   nonGroupedFlatRows.push(subRow);
            //   nonGroupedRowsById[subRow.id] = subRow;
            // }
            });
            return {
                rows: groupedRows,
                flatRows: groupedFlatRows,
                rowsById: groupedRowsById
            };
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getGroupedRowModel", ()=>{
            table._queue(()=>{
                table._autoResetExpanded();
                table._autoResetPageIndex();
            });
        }));
}
function $829253db717f8f1b$var$groupBy(rows, columnId) {
    const groupMap = new Map();
    return rows.reduce((map, row)=>{
        const resKey = `${row.getGroupingValue(columnId)}`;
        const previous = map.get(resKey);
        if (!previous) map.set(resKey, [
            row
        ]);
        else previous.push(row);
        return map;
    }, groupMap);
}
function $829253db717f8f1b$export$53cfec7b1b8d1fcd() {
    return (table)=>$829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getState().expanded,
                table.getPreExpandedRowModel(),
                table.options.paginateExpandedRows
            ], (expanded, rowModel, paginateExpandedRows)=>{
            if (!rowModel.rows.length || expanded !== true && !Object.keys(expanded != null ? expanded : {}).length) return rowModel;
            if (!paginateExpandedRows) // Only expand rows at this point if they are being paginated
            return rowModel;
            return $829253db717f8f1b$export$1293f966cdb38633(rowModel);
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getExpandedRowModel"));
}
function $829253db717f8f1b$export$1293f966cdb38633(rowModel) {
    const expandedRows = [];
    const handleRow = (row)=>{
        var _row$subRows;
        expandedRows.push(row);
        if ((_row$subRows = row.subRows) != null && _row$subRows.length && row.getIsExpanded()) row.subRows.forEach(handleRow);
    };
    rowModel.rows.forEach(handleRow);
    return {
        rows: expandedRows,
        flatRows: rowModel.flatRows,
        rowsById: rowModel.rowsById
    };
}
function $829253db717f8f1b$export$ddfd3662e196c265(opts) {
    return (table)=>$829253db717f8f1b$export$7c73462e0d25e514(()=>[
                table.getState().pagination,
                table.getPrePaginationRowModel(),
                table.options.paginateExpandedRows ? undefined : table.getState().expanded
            ], (pagination, rowModel)=>{
            if (!rowModel.rows.length) return rowModel;
            const { pageSize: pageSize, pageIndex: pageIndex } = pagination;
            let { rows: rows, flatRows: flatRows, rowsById: rowsById } = rowModel;
            const pageStart = pageSize * pageIndex;
            const pageEnd = pageStart + pageSize;
            rows = rows.slice(pageStart, pageEnd);
            let paginatedRowModel;
            if (!table.options.paginateExpandedRows) paginatedRowModel = $829253db717f8f1b$export$1293f966cdb38633({
                rows: rows,
                flatRows: flatRows,
                rowsById: rowsById
            });
            else paginatedRowModel = {
                rows: rows,
                flatRows: flatRows,
                rowsById: rowsById
            };
            paginatedRowModel.flatRows = [];
            const handleRow = (row)=>{
                paginatedRowModel.flatRows.push(row);
                if (row.subRows.length) row.subRows.forEach(handleRow);
            };
            paginatedRowModel.rows.forEach(handleRow);
            return paginatedRowModel;
        }, $829253db717f8f1b$export$b1f82222dc43996c(table.options, "debugTable", "getPaginationRowModel"));
}

/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ 
var $exYeM = parcelRequire("exYeM");

//
/**
 * If rendering headers, cells, or footers with custom markup, use flexRender instead of `cell.getValue()` or `cell.renderValue()`.
 */ function $6f12815be8ba8421$export$f2385bb6e3ac4b4f(Comp, props) {
    return !Comp ? null : $6f12815be8ba8421$var$isReactComponent(Comp) ? /*#__PURE__*/ $exYeM.createElement(Comp, props) : Comp;
}
function $6f12815be8ba8421$var$isReactComponent(component) {
    return $6f12815be8ba8421$var$isClassComponent(component) || typeof component === "function" || $6f12815be8ba8421$var$isExoticComponent(component);
}
function $6f12815be8ba8421$var$isClassComponent(component) {
    return typeof component === "function" && (()=>{
        const proto = Object.getPrototypeOf(component);
        return proto.prototype && proto.prototype.isReactComponent;
    })();
}
function $6f12815be8ba8421$var$isExoticComponent(component) {
    return typeof component === "object" && typeof component.$$typeof === "symbol" && [
        "react.memo",
        "react.forward_ref"
    ].includes(component.$$typeof.description);
}
function $6f12815be8ba8421$export$25eaeb3743e6b31f(options) {
    // Compose in the generic options to the user options
    const resolvedOptions = {
        state: {},
        // Dummy state
        onStateChange: ()=>{},
        // noop
        renderFallbackValue: null,
        ...options
    };
    // Create a new table and store it in state
    const [tableRef] = $exYeM.useState(()=>({
            current: (0, $829253db717f8f1b$export$33bbb3ec7652e187)(resolvedOptions)
        }));
    // By default, manage table state here using the table's initial state
    const [state, setState] = $exYeM.useState(()=>tableRef.current.initialState);
    // Compose the default state above with any user state. This will allow the user
    // to only control a subset of the state if desired.
    tableRef.current.setOptions((prev)=>({
            ...prev,
            ...options,
            state: {
                ...state,
                ...options.state
            },
            // Similarly, we'll maintain both our internal state and any user-provided
            // state.
            onStateChange: (updater)=>{
                setState(updater);
                options.onStateChange == null || options.onStateChange(updater);
            }
        }));
    return tableRef.current;
}



var $exYeM = parcelRequire("exYeM");
/**
   * match-sorter-utils
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ const $aaaefe1363178c1f$var$characterMap = {
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    \u1EA4: "A",
    \u1EAE: "A",
    \u1EB2: "A",
    \u1EB4: "A",
    \u1EB6: "A",
    "\xc6": "AE",
    \u1EA6: "A",
    \u1EB0: "A",
    \u0202: "A",
    "\xc7": "C",
    \u1E08: "C",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    \u1EBE: "E",
    \u1E16: "E",
    \u1EC0: "E",
    \u1E14: "E",
    \u1E1C: "E",
    \u0206: "E",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    \u1E2E: "I",
    \u020A: "I",
    "\xd0": "D",
    "\xd1": "N",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    \u1ED0: "O",
    \u1E4C: "O",
    \u1E52: "O",
    \u020E: "O",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xdd": "Y",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    \u1EA5: "a",
    \u1EAF: "a",
    \u1EB3: "a",
    \u1EB5: "a",
    \u1EB7: "a",
    "\xe6": "ae",
    \u1EA7: "a",
    \u1EB1: "a",
    \u0203: "a",
    "\xe7": "c",
    \u1E09: "c",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    \u1EBF: "e",
    \u1E17: "e",
    \u1EC1: "e",
    \u1E15: "e",
    \u1E1D: "e",
    \u0207: "e",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    \u1E2F: "i",
    \u020B: "i",
    "\xf0": "d",
    "\xf1": "n",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    \u1ED1: "o",
    \u1E4D: "o",
    \u1E53: "o",
    \u020F: "o",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xfd": "y",
    "\xff": "y",
    \u0100: "A",
    \u0101: "a",
    \u0102: "A",
    \u0103: "a",
    \u0104: "A",
    \u0105: "a",
    \u0106: "C",
    \u0107: "c",
    \u0108: "C",
    \u0109: "c",
    \u010A: "C",
    \u010B: "c",
    \u010C: "C",
    \u010D: "c",
    C\u0306: "C",
    c\u0306: "c",
    \u010E: "D",
    \u010F: "d",
    \u0110: "D",
    \u0111: "d",
    \u0112: "E",
    \u0113: "e",
    \u0114: "E",
    \u0115: "e",
    \u0116: "E",
    \u0117: "e",
    \u0118: "E",
    \u0119: "e",
    \u011A: "E",
    \u011B: "e",
    \u011C: "G",
    \u01F4: "G",
    \u011D: "g",
    \u01F5: "g",
    \u011E: "G",
    \u011F: "g",
    \u0120: "G",
    \u0121: "g",
    \u0122: "G",
    \u0123: "g",
    \u0124: "H",
    \u0125: "h",
    \u0126: "H",
    \u0127: "h",
    \u1E2A: "H",
    \u1E2B: "h",
    \u0128: "I",
    \u0129: "i",
    \u012A: "I",
    \u012B: "i",
    \u012C: "I",
    \u012D: "i",
    \u012E: "I",
    \u012F: "i",
    \u0130: "I",
    \u0131: "i",
    \u0132: "IJ",
    \u0133: "ij",
    \u0134: "J",
    \u0135: "j",
    \u0136: "K",
    \u0137: "k",
    \u1E30: "K",
    \u1E31: "k",
    K\u0306: "K",
    k\u0306: "k",
    \u0139: "L",
    \u013A: "l",
    \u013B: "L",
    \u013C: "l",
    \u013D: "L",
    \u013E: "l",
    \u013F: "L",
    \u0140: "l",
    \u0141: "l",
    \u0142: "l",
    \u1E3E: "M",
    \u1E3F: "m",
    M\u0306: "M",
    m\u0306: "m",
    \u0143: "N",
    \u0144: "n",
    \u0145: "N",
    \u0146: "n",
    \u0147: "N",
    \u0148: "n",
    \u0149: "n",
    N\u0306: "N",
    n\u0306: "n",
    \u014C: "O",
    \u014D: "o",
    \u014E: "O",
    \u014F: "o",
    \u0150: "O",
    \u0151: "o",
    \u0152: "OE",
    \u0153: "oe",
    P\u0306: "P",
    p\u0306: "p",
    \u0154: "R",
    \u0155: "r",
    \u0156: "R",
    \u0157: "r",
    \u0158: "R",
    \u0159: "r",
    R\u0306: "R",
    r\u0306: "r",
    \u0212: "R",
    \u0213: "r",
    \u015A: "S",
    \u015B: "s",
    \u015C: "S",
    \u015D: "s",
    \u015E: "S",
    \u0218: "S",
    \u0219: "s",
    \u015F: "s",
    \u0160: "S",
    \u0161: "s",
    \u0162: "T",
    \u0163: "t",
    \u021B: "t",
    \u021A: "T",
    \u0164: "T",
    \u0165: "t",
    \u0166: "T",
    \u0167: "t",
    T\u0306: "T",
    t\u0306: "t",
    \u0168: "U",
    \u0169: "u",
    \u016A: "U",
    \u016B: "u",
    \u016C: "U",
    \u016D: "u",
    \u016E: "U",
    \u016F: "u",
    \u0170: "U",
    \u0171: "u",
    \u0172: "U",
    \u0173: "u",
    \u0216: "U",
    \u0217: "u",
    V\u0306: "V",
    v\u0306: "v",
    \u0174: "W",
    \u0175: "w",
    \u1E82: "W",
    \u1E83: "w",
    X\u0306: "X",
    x\u0306: "x",
    \u0176: "Y",
    \u0177: "y",
    \u0178: "Y",
    Y\u0306: "Y",
    y\u0306: "y",
    \u0179: "Z",
    \u017A: "z",
    \u017B: "Z",
    \u017C: "z",
    \u017D: "Z",
    \u017E: "z",
    \u017F: "s",
    \u0192: "f",
    \u01A0: "O",
    \u01A1: "o",
    \u01AF: "U",
    \u01B0: "u",
    \u01CD: "A",
    \u01CE: "a",
    \u01CF: "I",
    \u01D0: "i",
    \u01D1: "O",
    \u01D2: "o",
    \u01D3: "U",
    \u01D4: "u",
    \u01D5: "U",
    \u01D6: "u",
    \u01D7: "U",
    \u01D8: "u",
    \u01D9: "U",
    \u01DA: "u",
    \u01DB: "U",
    \u01DC: "u",
    \u1EE8: "U",
    \u1EE9: "u",
    \u1E78: "U",
    \u1E79: "u",
    \u01FA: "A",
    \u01FB: "a",
    \u01FC: "AE",
    \u01FD: "ae",
    \u01FE: "O",
    \u01FF: "o",
    "\xde": "TH",
    "\xfe": "th",
    \u1E54: "P",
    \u1E55: "p",
    \u1E64: "S",
    \u1E65: "s",
    X\u0301: "X",
    x\u0301: "x",
    \u0403: "\u0413",
    \u0453: "\u0433",
    \u040C: "\u041A",
    \u045C: "\u043A",
    A\u030B: "A",
    a\u030B: "a",
    E\u030B: "E",
    e\u030B: "e",
    I\u030B: "I",
    i\u030B: "i",
    \u01F8: "N",
    \u01F9: "n",
    \u1ED2: "O",
    \u1ED3: "o",
    \u1E50: "O",
    \u1E51: "o",
    \u1EEA: "U",
    \u1EEB: "u",
    \u1E80: "W",
    \u1E81: "w",
    \u1EF2: "Y",
    \u1EF3: "y",
    \u0200: "A",
    \u0201: "a",
    \u0204: "E",
    \u0205: "e",
    \u0208: "I",
    \u0209: "i",
    \u020C: "O",
    \u020D: "o",
    \u0210: "R",
    \u0211: "r",
    \u0214: "U",
    \u0215: "u",
    B\u030C: "B",
    b\u030C: "b",
    \u010C\u0323: "C",
    \u010D\u0323: "c",
    "\xca\u030C": "E",
    "\xea\u030C": "e",
    F\u030C: "F",
    f\u030C: "f",
    \u01E6: "G",
    \u01E7: "g",
    \u021E: "H",
    \u021F: "h",
    J\u030C: "J",
    \u01F0: "j",
    \u01E8: "K",
    \u01E9: "k",
    M\u030C: "M",
    m\u030C: "m",
    P\u030C: "P",
    p\u030C: "p",
    Q\u030C: "Q",
    q\u030C: "q",
    \u0158\u0329: "R",
    \u0159\u0329: "r",
    \u1E66: "S",
    \u1E67: "s",
    V\u030C: "V",
    v\u030C: "v",
    W\u030C: "W",
    w\u030C: "w",
    X\u030C: "X",
    x\u030C: "x",
    Y\u030C: "Y",
    y\u030C: "y",
    A\u0327: "A",
    a\u0327: "a",
    B\u0327: "B",
    b\u0327: "b",
    \u1E10: "D",
    \u1E11: "d",
    \u0228: "E",
    \u0229: "e",
    \u0190\u0327: "E",
    \u025B\u0327: "e",
    \u1E28: "H",
    \u1E29: "h",
    I\u0327: "I",
    i\u0327: "i",
    \u0197\u0327: "I",
    \u0268\u0327: "i",
    M\u0327: "M",
    m\u0327: "m",
    O\u0327: "O",
    o\u0327: "o",
    Q\u0327: "Q",
    q\u0327: "q",
    U\u0327: "U",
    u\u0327: "u",
    X\u0327: "X",
    x\u0327: "x",
    Z\u0327: "Z",
    z\u0327: "z"
};
const $aaaefe1363178c1f$var$chars = Object.keys($aaaefe1363178c1f$var$characterMap).join("|");
const $aaaefe1363178c1f$var$allAccents = new RegExp($aaaefe1363178c1f$var$chars, "g");
function $aaaefe1363178c1f$var$removeAccents(str) {
    return str.replace($aaaefe1363178c1f$var$allAccents, (match)=>{
        return $aaaefe1363178c1f$var$characterMap[match];
    });
}
/**
 * @name match-sorter
 * @license MIT license.
 * @copyright (c) 2099 Kent C. Dodds
 * @author Kent C. Dodds <me@kentcdodds.com> (https://kentcdodds.com)
 */ const $aaaefe1363178c1f$export$809b0b82a3f0b8b5 = {
    CASE_SENSITIVE_EQUAL: 7,
    EQUAL: 6,
    STARTS_WITH: 5,
    WORD_STARTS_WITH: 4,
    CONTAINS: 3,
    ACRONYM: 2,
    MATCHES: 1,
    NO_MATCH: 0
};
/**
 * Gets the highest ranking for value for the given item based on its values for the given keys
 * @param {*} item - the item to rank
 * @param {Array} keys - the keys to get values from the item for the ranking
 * @param {String} value - the value to rank against
 * @param {Object} options - options to control the ranking
 * @return {{rank: Number, accessorIndex: Number, accessorThreshold: Number}} - the highest ranking
 */ function $aaaefe1363178c1f$export$2bf9c99d6a293bc8(item, value, options) {
    var _options$threshold;
    options = options || {};
    options.threshold = (_options$threshold = options.threshold) != null ? _options$threshold : $aaaefe1363178c1f$export$809b0b82a3f0b8b5.MATCHES;
    if (!options.accessors) {
        // if keys is not specified, then we assume the item given is ready to be matched
        const rank = $aaaefe1363178c1f$var$getMatchRanking(item, value, options);
        return {
            // ends up being duplicate of 'item' in matches but consistent
            rankedValue: item,
            rank: rank,
            accessorIndex: -1,
            accessorThreshold: options.threshold,
            passed: rank >= options.threshold
        };
    }
    const valuesToRank = $aaaefe1363178c1f$var$getAllValuesToRank(item, options.accessors);
    const rankingInfo = {
        rankedValue: item,
        rank: $aaaefe1363178c1f$export$809b0b82a3f0b8b5.NO_MATCH,
        accessorIndex: -1,
        accessorThreshold: options.threshold,
        passed: false
    };
    for(let i = 0; i < valuesToRank.length; i++){
        const rankValue = valuesToRank[i];
        let newRank = $aaaefe1363178c1f$var$getMatchRanking(rankValue.itemValue, value, options);
        const { minRanking: minRanking, maxRanking: maxRanking, threshold: threshold = options.threshold } = rankValue.attributes;
        if (newRank < minRanking && newRank >= $aaaefe1363178c1f$export$809b0b82a3f0b8b5.MATCHES) newRank = minRanking;
        else if (newRank > maxRanking) newRank = maxRanking;
        newRank = Math.min(newRank, maxRanking);
        if (newRank >= threshold && newRank > rankingInfo.rank) {
            rankingInfo.rank = newRank;
            rankingInfo.passed = true;
            rankingInfo.accessorIndex = i;
            rankingInfo.accessorThreshold = threshold;
            rankingInfo.rankedValue = rankValue.itemValue;
        }
    }
    return rankingInfo;
}
/**
 * Gives a rankings score based on how well the two strings match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @param {Object} options - options for the match (like keepDiacritics for comparison)
 * @returns {Number} the ranking for how well stringToRank matches testString
 */ function $aaaefe1363178c1f$var$getMatchRanking(testString, stringToRank, options) {
    testString = $aaaefe1363178c1f$var$prepareValueForComparison(testString, options);
    stringToRank = $aaaefe1363178c1f$var$prepareValueForComparison(stringToRank, options);
    // too long
    if (stringToRank.length > testString.length) return $aaaefe1363178c1f$export$809b0b82a3f0b8b5.NO_MATCH;
    // case sensitive equals
    if (testString === stringToRank) return $aaaefe1363178c1f$export$809b0b82a3f0b8b5.CASE_SENSITIVE_EQUAL;
    // Lower casing before further comparison
    testString = testString.toLowerCase();
    stringToRank = stringToRank.toLowerCase();
    // case insensitive equals
    if (testString === stringToRank) return $aaaefe1363178c1f$export$809b0b82a3f0b8b5.EQUAL;
    // starts with
    if (testString.startsWith(stringToRank)) return $aaaefe1363178c1f$export$809b0b82a3f0b8b5.STARTS_WITH;
    // word starts with
    if (testString.includes(` ${stringToRank}`)) return $aaaefe1363178c1f$export$809b0b82a3f0b8b5.WORD_STARTS_WITH;
    // contains
    if (testString.includes(stringToRank)) return $aaaefe1363178c1f$export$809b0b82a3f0b8b5.CONTAINS;
    else if (stringToRank.length === 1) // If the only character in the given stringToRank
    //   isn't even contained in the testString, then
    //   it's definitely not a match.
    return $aaaefe1363178c1f$export$809b0b82a3f0b8b5.NO_MATCH;
    // acronym
    if ($aaaefe1363178c1f$var$getAcronym(testString).includes(stringToRank)) return $aaaefe1363178c1f$export$809b0b82a3f0b8b5.ACRONYM;
    // will return a number between rankings.MATCHES and
    // rankings.MATCHES + 1 depending  on how close of a match it is.
    return $aaaefe1363178c1f$var$getClosenessRanking(testString, stringToRank);
}
/**
 * Generates an acronym for a string.
 *
 * @param {String} string the string for which to produce the acronym
 * @returns {String} the acronym
 */ function $aaaefe1363178c1f$var$getAcronym(string) {
    let acronym = "";
    const wordsInString = string.split(" ");
    wordsInString.forEach((wordInString)=>{
        const splitByHyphenWords = wordInString.split("-");
        splitByHyphenWords.forEach((splitByHyphenWord)=>{
            acronym += splitByHyphenWord.substr(0, 1);
        });
    });
    return acronym;
}
/**
 * Returns a score based on how spread apart the
 * characters from the stringToRank are within the testString.
 * A number close to rankings.MATCHES represents a loose match. A number close
 * to rankings.MATCHES + 1 represents a tighter match.
 * @param {String} testString - the string to test against
 * @param {String} stringToRank - the string to rank
 * @returns {Number} the number between rankings.MATCHES and
 * rankings.MATCHES + 1 for how well stringToRank matches testString
 */ function $aaaefe1363178c1f$var$getClosenessRanking(testString, stringToRank) {
    let matchingInOrderCharCount = 0;
    let charNumber = 0;
    function findMatchingCharacter(matchChar, string, index) {
        for(let j = index, J = string.length; j < J; j++){
            const stringChar = string[j];
            if (stringChar === matchChar) {
                matchingInOrderCharCount += 1;
                return j + 1;
            }
        }
        return -1;
    }
    function getRanking(spread) {
        const spreadPercentage = 1 / spread;
        const inOrderPercentage = matchingInOrderCharCount / stringToRank.length;
        const ranking = $aaaefe1363178c1f$export$809b0b82a3f0b8b5.MATCHES + inOrderPercentage * spreadPercentage;
        return ranking;
    }
    const firstIndex = findMatchingCharacter(stringToRank[0], testString, 0);
    if (firstIndex < 0) return $aaaefe1363178c1f$export$809b0b82a3f0b8b5.NO_MATCH;
    charNumber = firstIndex;
    for(let i = 1, I = stringToRank.length; i < I; i++){
        const matchChar = stringToRank[i];
        charNumber = findMatchingCharacter(matchChar, testString, charNumber);
        const found = charNumber > -1;
        if (!found) return $aaaefe1363178c1f$export$809b0b82a3f0b8b5.NO_MATCH;
    }
    const spread = charNumber - firstIndex;
    return getRanking(spread);
}
/**
 * Sorts items that have a rank, index, and accessorIndex
 * @param {Object} a - the first item to sort
 * @param {Object} b - the second item to sort
 * @return {Number} -1 if a should come first, 1 if b should come first, 0 if equal
 */ function $aaaefe1363178c1f$export$b0c6b3a142decb5a(a, b) {
    return a.rank === b.rank ? 0 : a.rank > b.rank ? -1 : 1;
}
/**
 * Prepares value for comparison by stringifying it, removing diacritics (if specified)
 * @param {String} value - the value to clean
 * @param {Object} options - {keepDiacritics: whether to remove diacritics}
 * @return {String} the prepared value
 */ function $aaaefe1363178c1f$var$prepareValueForComparison(value, _ref) {
    let { keepDiacritics: keepDiacritics } = _ref;
    // value might not actually be a string at this point (we don't get to choose)
    // so part of preparing the value for comparison is ensure that it is a string
    value = `${value}`; // toString
    if (!keepDiacritics) value = $aaaefe1363178c1f$var$removeAccents(value);
    return value;
}
/**
 * Gets value for key in item at arbitrarily nested keypath
 * @param {Object} item - the item
 * @param {Object|Function} key - the potentially nested keypath or property callback
 * @return {Array} - an array containing the value(s) at the nested keypath
 */ function $aaaefe1363178c1f$var$getItemValues(item, accessor) {
    let accessorFn = accessor;
    if (typeof accessor === "object") accessorFn = accessor.accessor;
    const value = accessorFn(item);
    // because `value` can also be undefined
    if (value == null) return [];
    if (Array.isArray(value)) return value;
    return [
        String(value)
    ];
}
/**
 * Gets all the values for the given keys in the given item and returns an array of those values
 * @param item - the item from which the values will be retrieved
 * @param keys - the keys to use to retrieve the values
 * @return objects with {itemValue, attributes}
 */ function $aaaefe1363178c1f$var$getAllValuesToRank(item, accessors) {
    const allValues = [];
    for(let j = 0, J = accessors.length; j < J; j++){
        const accessor = accessors[j];
        const attributes = $aaaefe1363178c1f$var$getAccessorAttributes(accessor);
        const itemValues = $aaaefe1363178c1f$var$getItemValues(item, accessor);
        for(let i = 0, I = itemValues.length; i < I; i++)allValues.push({
            itemValue: itemValues[i],
            attributes: attributes
        });
    }
    return allValues;
}
const $aaaefe1363178c1f$var$defaultKeyAttributes = {
    maxRanking: Infinity,
    minRanking: -Infinity
};
/**
 * Gets all the attributes for the given accessor
 * @param accessor - the accessor from which the attributes will be retrieved
 * @return object containing the accessor's attributes
 */ function $aaaefe1363178c1f$var$getAccessorAttributes(accessor) {
    if (typeof accessor === "function") return $aaaefe1363178c1f$var$defaultKeyAttributes;
    return {
        ...$aaaefe1363178c1f$var$defaultKeyAttributes,
        ...accessor
    };
}



var $aSiaI = parcelRequire("aSiaI");

var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");


var $2f0D3 = parcelRequire("2f0D3");

var $8L988 = parcelRequire("8L988");

var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");


var $fXwzw = parcelRequire("fXwzw");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $a835d3595b29f35e$export$5e8702d71474f093(slot) {
    return (0, $dC5O8.default)("MuiIconButton", slot);
}
const $a835d3595b29f35e$var$iconButtonClasses = (0, $kY7HX.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $a835d3595b29f35e$export$2e2bcd8739ae039 = $a835d3595b29f35e$var$iconButtonClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $96b952e1d26b1f04$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $96b952e1d26b1f04$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $fXwzw.default)(color)}`,
            edge && `edge${(0, $fXwzw.default)(edge)}`,
            `size${(0, $fXwzw.default)(size)}`
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $a835d3595b29f35e$export$5e8702d71474f093), classes);
};
const $96b952e1d26b1f04$var$IconButtonRoot = (0, $jawKn.default)((0, $8c6774266c067eb9$export$2e2bcd8739ae039), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $fXwzw.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $fXwzw.default)(ownerState.edge)}`],
            styles[`size${(0, $fXwzw.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8L988.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $aJx1R.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $aJx1R.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, $aJx1R.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8L988.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $a835d3595b29f35e$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $96b952e1d26b1f04$var$IconButton = /*#__PURE__*/ $exYeM.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = "medium" } = props, other = (0, $3L80X.default)(props, $96b952e1d26b1f04$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $96b952e1d26b1f04$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($96b952e1d26b1f04$var$IconButtonRoot, (0, $aJx1R.default)({
        className: (0, $4qr5a.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $96b952e1d26b1f04$export$2e2bcd8739ae039 = $96b952e1d26b1f04$var$IconButton;



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");




var $2f0D3 = parcelRequire("2f0D3");

var $8L988 = parcelRequire("8L988");


var $jawKn = parcelRequire("jawKn");


var $7PWLt = parcelRequire("7PWLt");

var $fXwzw = parcelRequire("fXwzw");

var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");




var $3L80X = parcelRequire("3L80X");



var $exYeM = parcelRequire("exYeM");

var $b22ce5fe690cd1e9$export$2e2bcd8739ae039 = {
    disabled: false
};




var $b46d92a9d09371d6$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $b1fed440e66ae1d8$export$bb38bb9a1161268 = "unmounted";
var $b1fed440e66ae1d8$export$84cbff306f539230 = "exited";
var $b1fed440e66ae1d8$export$df38205c966be359 = "entering";
var $b1fed440e66ae1d8$export$78e9e6e3e014d60a = "entered";
var $b1fed440e66ae1d8$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $b1fed440e66ae1d8$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $6ace560ed589c934$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $b1fed440e66ae1d8$export$84cbff306f539230;
                _this.appearStatus = $b1fed440e66ae1d8$export$df38205c966be359;
            } else initialStatus = $b1fed440e66ae1d8$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $b1fed440e66ae1d8$export$bb38bb9a1161268;
        else initialStatus = $b1fed440e66ae1d8$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $b1fed440e66ae1d8$export$bb38bb9a1161268) return {
            status: $b1fed440e66ae1d8$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $b1fed440e66ae1d8$export$df38205c966be359 && status !== $b1fed440e66ae1d8$export$78e9e6e3e014d60a) nextStatus = $b1fed440e66ae1d8$export$df38205c966be359;
            } else if (status === $b1fed440e66ae1d8$export$df38205c966be359 || status === $b1fed440e66ae1d8$export$78e9e6e3e014d60a) nextStatus = $b1fed440e66ae1d8$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $b1fed440e66ae1d8$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($97dc602bd7e23afa$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $b46d92a9d09371d6$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $b1fed440e66ae1d8$export$84cbff306f539230) this.setState({
            status: $b1fed440e66ae1d8$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($97dc602bd7e23afa$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $b22ce5fe690cd1e9$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $b1fed440e66ae1d8$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $b1fed440e66ae1d8$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $b1fed440e66ae1d8$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($97dc602bd7e23afa$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $b22ce5fe690cd1e9$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $b1fed440e66ae1d8$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $b1fed440e66ae1d8$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $b1fed440e66ae1d8$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($97dc602bd7e23afa$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $b1fed440e66ae1d8$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $3L80X.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $9bfbeb4757462139$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Component);
$b1fed440e66ae1d8$var$Transition.contextType = (0, $9bfbeb4757462139$export$2e2bcd8739ae039);
$b1fed440e66ae1d8$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $b1fed440e66ae1d8$var$noop() {}
$b1fed440e66ae1d8$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $b1fed440e66ae1d8$var$noop,
    onEntering: $b1fed440e66ae1d8$var$noop,
    onEntered: $b1fed440e66ae1d8$var$noop,
    onExit: $b1fed440e66ae1d8$var$noop,
    onExiting: $b1fed440e66ae1d8$var$noop,
    onExited: $b1fed440e66ae1d8$var$noop
};
$b1fed440e66ae1d8$var$Transition.UNMOUNTED = $b1fed440e66ae1d8$export$bb38bb9a1161268;
$b1fed440e66ae1d8$var$Transition.EXITED = $b1fed440e66ae1d8$export$84cbff306f539230;
$b1fed440e66ae1d8$var$Transition.ENTERING = $b1fed440e66ae1d8$export$df38205c966be359;
$b1fed440e66ae1d8$var$Transition.ENTERED = $b1fed440e66ae1d8$export$78e9e6e3e014d60a;
$b1fed440e66ae1d8$var$Transition.EXITING = $b1fed440e66ae1d8$export$4aacc83d4d59139f;
var $b1fed440e66ae1d8$export$2e2bcd8739ae039 = $b1fed440e66ae1d8$var$Transition;



const $439a83a81b60056a$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $439a83a81b60056a$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $aSiaI = parcelRequire("aSiaI");
"use client";
const $0b476d905dd3781d$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $0b476d905dd3781d$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $0b476d905dd3781d$var$styles = {
    entering: {
        opacity: 1,
        transform: $0b476d905dd3781d$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $0b476d905dd3781d$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $0b476d905dd3781d$var$Grow = /*#__PURE__*/ $exYeM.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $b1fed440e66ae1d8$export$2e2bcd8739ae039) } = props, other = (0, $3L80X.default)(props, $0b476d905dd3781d$var$_excluded);
    const timer = (0, $72fb5758a7c9ec4b$export$2e2bcd8739ae039)();
    const autoTimeout = $exYeM.useRef();
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const nodeRef = $exYeM.useRef(null);
    const handleRef = (0, $69ecd4eca0914ac9$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $439a83a81b60056a$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $439a83a81b60056a$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $0b476d905dd3781d$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $439a83a81b60056a$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $0b476d905dd3781d$var$isWebKit154 ? duration : duration * 0.666,
                delay: $0b476d905dd3781d$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $0b476d905dd3781d$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)(TransitionComponent, (0, $aJx1R.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $exYeM.cloneElement(children, (0, $aJx1R.default)({
                style: (0, $aJx1R.default)({
                    opacity: 0,
                    transform: $0b476d905dd3781d$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $0b476d905dd3781d$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$0b476d905dd3781d$var$Grow.muiSupportAuto = true;
var $0b476d905dd3781d$export$2e2bcd8739ae039 = $0b476d905dd3781d$var$Grow;



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");

function $2835f189066da699$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $6be351e83d6bf643$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $6be351e83d6bf643$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $6be351e83d6bf643$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $8d1d6c453d67c9ab$export$8960430cfd85939f = Math.max;
var $8d1d6c453d67c9ab$export$96ec731ed4dcb222 = Math.min;
var $8d1d6c453d67c9ab$export$2077e0241d6afd3c = Math.round;



function $9641053f99441231$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $b49248e188a52b8b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
}


function $1b9ce20ada6267ed$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? (0, $2835f189066da699$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b49248e188a52b8b$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $0acc17feb41c51bd$export$2e2bcd8739ae039(node) {
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $c829ab0279467772$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $b71097fc0b0e5f5c$export$2e2bcd8739ae039(node) {
    if (node === (0, $2835f189066da699$export$2e2bcd8739ae039)(node) || !(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(node)) return (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(node);
    else return (0, $c829ab0279467772$export$2e2bcd8739ae039)(node);
}


function $13064aa41dd611dc$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $37f38c85c1edad4d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $e951d80a0194865c$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)((0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element)).left + (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $270edfbc2bfbd22f$export$2e2bcd8739ae039(element) {
    return (0, $2835f189066da699$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $9873d63ab8539814$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $b01cf64433a5b37b$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $b01cf64433a5b37b$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent) && $b01cf64433a5b37b$var$isElementScaled(offsetParent);
    var documentElement = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $9873d63ab8539814$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $b71097fc0b0e5f5c$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e951d80a0194865c$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $ad01075005a54bff$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $c16bae6800ecc025$export$2e2bcd8739ae039(element) {
    if ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $6be351e83d6bf643$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $c48b941fd834c962$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(node) && (0, $9873d63ab8539814$export$2e2bcd8739ae039)(node)) return node;
    return $c48b941fd834c962$export$2e2bcd8739ae039((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(node));
}





function $295d0ca7e8ef250a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $c48b941fd834c962$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $9873d63ab8539814$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($295d0ca7e8ef250a$export$2e2bcd8739ae039((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(target)));
}







function $27c48183f07ddbe8$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) >= 0;
}




function $3df2d470c30a409e$var$getTrueOffsetParent(element) {
    if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $3df2d470c30a409e$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
    if (isIE && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $c16bae6800ecc025$export$2e2bcd8739ae039)(element);
    if ((0, $6be351e83d6bf643$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $3df2d470c30a409e$export$2e2bcd8739ae039(element) {
    var window = (0, $2835f189066da699$export$2e2bcd8739ae039)(element);
    var offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $27c48183f07ddbe8$export$2e2bcd8739ae039)(offsetParent) && (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $3df2d470c30a409e$var$getContainingBlock(element) || window;
}


var $935c50c8659545b7$export$1e95b668f3b82d = "top";
var $935c50c8659545b7$export$40e543e69a8b3fbb = "bottom";
var $935c50c8659545b7$export$79ffe56a765070d2 = "right";
var $935c50c8659545b7$export$eabcd2c8791e7bf4 = "left";
var $935c50c8659545b7$export$dfb5619354ba860 = "auto";
var $935c50c8659545b7$export$aec2ce47c367b8c3 = [
    $935c50c8659545b7$export$1e95b668f3b82d,
    $935c50c8659545b7$export$40e543e69a8b3fbb,
    $935c50c8659545b7$export$79ffe56a765070d2,
    $935c50c8659545b7$export$eabcd2c8791e7bf4
];
var $935c50c8659545b7$export$b3571188c770cc5a = "start";
var $935c50c8659545b7$export$bd5df0f255a350f8 = "end";
var $935c50c8659545b7$export$390fd549c5303b4d = "clippingParents";
var $935c50c8659545b7$export$d7b7311ec04a3e8f = "viewport";
var $935c50c8659545b7$export$ae5ab1c730825774 = "popper";
var $935c50c8659545b7$export$ca50aac9f3ba507f = "reference";
var $935c50c8659545b7$export$368f9a87e87fa4e1 = /*#__PURE__*/ $935c50c8659545b7$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []);
var $935c50c8659545b7$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($935c50c8659545b7$export$aec2ce47c367b8c3, [
    $935c50c8659545b7$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $935c50c8659545b7$export$421679a7c3d56e = "beforeRead";
var $935c50c8659545b7$export$aafa59e2e03f2942 = "read";
var $935c50c8659545b7$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $935c50c8659545b7$export$c65e99957a05207c = "beforeMain";
var $935c50c8659545b7$export$f22da7240b7add18 = "main";
var $935c50c8659545b7$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $935c50c8659545b7$export$8d4d2d70e7d46032 = "beforeWrite";
var $935c50c8659545b7$export$68d8715fc104d294 = "write";
var $935c50c8659545b7$export$70a6e5159acce2e6 = "afterWrite";
var $935c50c8659545b7$export$d087d3878fdf71d5 = [
    $935c50c8659545b7$export$421679a7c3d56e,
    $935c50c8659545b7$export$aafa59e2e03f2942,
    $935c50c8659545b7$export$6964f6c886723980,
    $935c50c8659545b7$export$c65e99957a05207c,
    $935c50c8659545b7$export$f22da7240b7add18,
    $935c50c8659545b7$export$bab79516f2d662fe,
    $935c50c8659545b7$export$8d4d2d70e7d46032,
    $935c50c8659545b7$export$68d8715fc104d294,
    $935c50c8659545b7$export$70a6e5159acce2e6
];


function $455dca0e08f2a815$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $455dca0e08f2a815$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $455dca0e08f2a815$var$order(modifiers); // order based on phase
    return (0, $935c50c8659545b7$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $6d2b77c34ff005f5$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $81912adbd60ec5c0$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $1839837374f95732$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $1839837374f95732$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $1839837374f95732$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $1839837374f95732$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $1839837374f95732$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(reference) ? (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $455dca0e08f2a815$export$2e2bcd8739ae039)((0, $81912adbd60ec5c0$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$1839837374f95732$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $b01cf64433a5b37b$export$2e2bcd8739ae039)(reference, (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $ad01075005a54bff$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $6d2b77c34ff005f5$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$1839837374f95732$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $1839837374f95732$export$8f7491d57c8f97a9 = /*#__PURE__*/ $1839837374f95732$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $fa02e10eb4995658$var$passive = {
    passive: true
};
function $fa02e10eb4995658$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $2835f189066da699$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $fa02e10eb4995658$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $fa02e10eb4995658$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $fa02e10eb4995658$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $fa02e10eb4995658$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $fa02e10eb4995658$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $fa02e10eb4995658$var$effect,
    data: {}
};



function $6653967f933aaf29$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $66a6b9b7896d6ec4$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $271a905a3adf884c$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $4f7414566eeea71a$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $935c50c8659545b7$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $935c50c8659545b7$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $935c50c8659545b7$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $935c50c8659545b7$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $935c50c8659545b7$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $935c50c8659545b7$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $ee48a1861d343976$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $4f7414566eeea71a$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ee48a1861d343976$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $ee48a1861d343976$var$popperOffsets,
    data: {}
};










var $063d2297888fea12$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $063d2297888fea12$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $063d2297888fea12$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
    var sideY = (0, $935c50c8659545b7$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $2835f189066da699$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(popper);
            if ((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $935c50c8659545b7$export$1e95b668f3b82d) || (placement === (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) || placement === (0, $935c50c8659545b7$export$79ffe56a765070d2)) && variation === (0, $935c50c8659545b7$export$bd5df0f255a350f8)) {
            sideY = (0, $935c50c8659545b7$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) || (placement === (0, $935c50c8659545b7$export$1e95b668f3b82d) || placement === (0, $935c50c8659545b7$export$40e543e69a8b3fbb)) && variation === (0, $935c50c8659545b7$export$bd5df0f255a350f8)) {
            sideX = (0, $935c50c8659545b7$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $063d2297888fea12$var$unsetSides);
    var _ref4 = roundOffsets === true ? $063d2297888fea12$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $2835f189066da699$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $063d2297888fea12$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $063d2297888fea12$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $063d2297888fea12$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $312913fa2edc14b2$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || !(0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $312913fa2edc14b2$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || !(0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $312913fa2edc14b2$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $312913fa2edc14b2$var$applyStyles,
    effect: $312913fa2edc14b2$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $8d644778f0e020f0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $8d644778f0e020f0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $935c50c8659545b7$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $8d644778f0e020f0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8d644778f0e020f0$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $8d644778f0e020f0$var$offset
};


var $d79ddf39683d3f91$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $d79ddf39683d3f91$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $d79ddf39683d3f91$var$hash[matched];
    });
}



var $5887002dcefa0743$var$hash = {
    start: "end",
    end: "start"
};
function $5887002dcefa0743$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $5887002dcefa0743$var$hash[matched];
    });
}







function $7da9d5689cacb0a6$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(element);
    var html = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b49248e188a52b8b$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e951d80a0194865c$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $ab4ea6dd03061fae$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e951d80a0194865c$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $122a9b90bb37fc73$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $6be351e83d6bf643$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $1cd357ee33805adc$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $93ee5964b4e9d426$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $935c50c8659545b7$export$d7b7311ec04a3e8f) ? (0, $1cd357ee33805adc$export$2e2bcd8739ae039)((0, $7da9d5689cacb0a6$export$2e2bcd8739ae039)(element, strategy)) : (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clippingParent) ? $93ee5964b4e9d426$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $1cd357ee33805adc$export$2e2bcd8739ae039)((0, $ab4ea6dd03061fae$export$2e2bcd8739ae039)((0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $93ee5964b4e9d426$var$getClippingParents(element) {
    var clippingParents = (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) ? (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clippingParent) && (0, $122a9b90bb37fc73$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $13064aa41dd611dc$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $93ee5964b4e9d426$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $93ee5964b4e9d426$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $93ee5964b4e9d426$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $5dd4eac14cb3a9cb$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $0ad6ec2b432662d8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $5dd4eac14cb3a9cb$export$2e2bcd8739ae039)(), paddingObject);
}


function $e3a5d8ce75f76756$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $70321b611e132ecc$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $935c50c8659545b7$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $935c50c8659545b7$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $935c50c8659545b7$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $0ad6ec2b432662d8$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $e3a5d8ce75f76756$export$2e2bcd8739ae039)(padding, (0, $935c50c8659545b7$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) ? (0, $935c50c8659545b7$export$ca50aac9f3ba507f) : (0, $935c50c8659545b7$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $93ee5964b4e9d426$export$2e2bcd8739ae039)((0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $4f7414566eeea71a$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $1cd357ee33805adc$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $935c50c8659545b7$export$79ffe56a765070d2),
                (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $935c50c8659545b7$export$1e95b668f3b82d),
                (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $bec6b628c79c2a3d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $935c50c8659545b7$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $935c50c8659545b7$export$368f9a87e87fa4e1) : (0, $935c50c8659545b7$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $935c50c8659545b7$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $dabd09962ff7b702$var$getExpandedFallbackPlacements(placement) {
    if ((0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(placement);
    return [
        (0, $5887002dcefa0743$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $5887002dcefa0743$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $dabd09962ff7b702$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $dabd09962ff7b702$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$dfb5619354ba860) ? (0, $bec6b628c79c2a3d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$b3571188c770cc5a);
        var isVertical = [
            (0, $935c50c8659545b7$export$1e95b668f3b82d),
            (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $935c50c8659545b7$export$79ffe56a765070d2) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $dabd09962ff7b702$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $dabd09962ff7b702$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $e82c9e5baaa8e9af$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max) {
    return (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(min, (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(value, max));
}
function $4faf3481d1df2f95$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $4804c92787f86449$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $e82c9e5baaa8e9af$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $935c50c8659545b7$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $935c50c8659545b7$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $ad01075005a54bff$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $5dd4eac14cb3a9cb$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(tether ? (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $935c50c8659545b7$export$1e95b668f3b82d),
            (0, $935c50c8659545b7$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $4faf3481d1df2f95$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4804c92787f86449$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $4804c92787f86449$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $20e743289f291887$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $0ad6ec2b432662d8$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $e3a5d8ce75f76756$export$2e2bcd8739ae039)(padding, (0, $935c50c8659545b7$export$aec2ce47c367b8c3)));
};
function $20e743289f291887$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $20e743289f291887$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $ad01075005a54bff$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $20e743289f291887$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $122a9b90bb37fc73$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $20e743289f291887$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $20e743289f291887$var$arrow,
    effect: $20e743289f291887$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $7d3d400f3b7c97f3$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $7d3d400f3b7c97f3$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $935c50c8659545b7$export$1e95b668f3b82d),
        (0, $935c50c8659545b7$export$79ffe56a765070d2),
        (0, $935c50c8659545b7$export$40e543e69a8b3fbb),
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $7d3d400f3b7c97f3$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $7d3d400f3b7c97f3$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $7d3d400f3b7c97f3$var$hide
};




var $98a9ef6d31ff03cd$export$d34966752335dd47 = [
    (0, $fa02e10eb4995658$export$2e2bcd8739ae039),
    (0, $ee48a1861d343976$export$2e2bcd8739ae039),
    (0, $063d2297888fea12$export$2e2bcd8739ae039),
    (0, $312913fa2edc14b2$export$2e2bcd8739ae039),
    (0, $8d644778f0e020f0$export$2e2bcd8739ae039),
    (0, $dabd09962ff7b702$export$2e2bcd8739ae039),
    (0, $4804c92787f86449$export$2e2bcd8739ae039),
    (0, $20e743289f291887$export$2e2bcd8739ae039),
    (0, $7d3d400f3b7c97f3$export$2e2bcd8739ae039)
];
var $98a9ef6d31ff03cd$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $1839837374f95732$export$ed5e13716264f202)({
    defaultModifiers: $98a9ef6d31ff03cd$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $2f0D3 = parcelRequire("2f0D3");

var $exYeM = parcelRequire("exYeM");




var $aSiaI = parcelRequire("aSiaI");
"use client";
function $a99d22fd25a4c1ba$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */ const $a99d22fd25a4c1ba$export$602eac185826482c = /*#__PURE__*/ $exYeM.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $exYeM.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(/*#__PURE__*/ $exYeM.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $c4c3f9798cb7fddc$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($a99d22fd25a4c1ba$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $c4c3f9798cb7fddc$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $07cd8eb63b27fd4d$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $07cd8eb63b27fd4d$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $exYeM.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $exYeM.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $aSiaI.jsx)($exYeM.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $aSiaI.jsx)($exYeM.Fragment, {
        children: mountNode ? /*#__PURE__*/ $97dc602bd7e23afa$exports.createPortal(children, mountNode) : mountNode
    });
});



var $dC5O8 = parcelRequire("dC5O8");
const $e4e3f1be328b4007$var$GLOBAL_CLASS_PREFIX = "base";
function $e4e3f1be328b4007$var$buildStateClass(state) {
    return `${$e4e3f1be328b4007$var$GLOBAL_CLASS_PREFIX}--${state}`;
}
function $e4e3f1be328b4007$var$buildSlotClass(componentName, slot) {
    return `${$e4e3f1be328b4007$var$GLOBAL_CLASS_PREFIX}-${componentName}-${slot}`;
}
function $e4e3f1be328b4007$export$1d132570e11858b0(componentName, slot) {
    const globalStateClass = (0, $dC5O8.globalStateClasses)[slot];
    return globalStateClass ? $e4e3f1be328b4007$var$buildStateClass(globalStateClass) : $e4e3f1be328b4007$var$buildSlotClass(componentName, slot);
}
function $e4e3f1be328b4007$export$34c0130b1f3e8ae3(slot) {
    return (0, $dC5O8.globalStateClasses)[slot] !== undefined;
}



function $2f06743a8c71d384$export$de4f15803c389669(componentName, slots) {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $e4e3f1be328b4007$export$1d132570e11858b0)(componentName, slot);
    });
    return result;
}


const $3e1a279be42285d9$var$COMPONENT_NAME = "Popper";
function $3e1a279be42285d9$export$1b69b6cd0fa638a1(slot) {
    return (0, $e4e3f1be328b4007$export$1d132570e11858b0)($3e1a279be42285d9$var$COMPONENT_NAME, slot);
}
const $3e1a279be42285d9$export$b6aa214021e734b0 = (0, $2f06743a8c71d384$export$de4f15803c389669)($3e1a279be42285d9$var$COMPONENT_NAME, [
    "root"
]);




var $exYeM = parcelRequire("exYeM");

var $aSiaI = parcelRequire("aSiaI");
"use client";
const $32ab1fd9d338fb00$var$defaultContextValue = {
    disableDefaultClasses: false
};
const $32ab1fd9d338fb00$var$ClassNameConfiguratorContext = /*#__PURE__*/ $exYeM.createContext($32ab1fd9d338fb00$var$defaultContextValue);
function $32ab1fd9d338fb00$export$b0f7603cd2f9ee15(generateUtilityClass) {
    const { disableDefaultClasses: disableDefaultClasses } = $exYeM.useContext($32ab1fd9d338fb00$var$ClassNameConfiguratorContext);
    return (slot)=>{
        if (disableDefaultClasses) return "";
        return generateUtilityClass(slot);
    };
}
function $32ab1fd9d338fb00$export$2efe1f5e70172ae9(props) {
    const { disableDefaultClasses: disableDefaultClasses, children: children } = props;
    const contextValue = $exYeM.useMemo(()=>({
            disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
        }), [
        disableDefaultClasses
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($32ab1fd9d338fb00$var$ClassNameConfiguratorContext.Provider, {
        value: contextValue,
        children: children
    });
}



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $52cebc1858d4dde2$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $52cebc1858d4dde2$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $52cebc1858d4dde2$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $52cebc1858d4dde2$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function $52cebc1858d4dde2$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $52cebc1858d4dde2$var$isVirtualElement(element) {
    return !$52cebc1858d4dde2$var$isHTMLElement(element);
}
const $52cebc1858d4dde2$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $32ab1fd9d338fb00$export$b0f7603cd2f9ee15)((0, $3e1a279be42285d9$export$1b69b6cd0fa638a1)));
};
const $52cebc1858d4dde2$var$defaultPopperOptions = {};
const $52cebc1858d4dde2$var$PopperTooltip = /*#__PURE__*/ $exYeM.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $3L80X.default)(props, $52cebc1858d4dde2$var$_excluded);
    const tooltipRef = $exYeM.useRef(null);
    const ownRef = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $exYeM.useRef(null);
    const handlePopperRef = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $exYeM.useRef(handlePopperRef);
    (0, $c4c3f9798cb7fddc$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $exYeM.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $52cebc1858d4dde2$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $exYeM.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $exYeM.useState($52cebc1858d4dde2$var$resolveAnchorEl(anchorEl));
    $exYeM.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $exYeM.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($52cebc1858d4dde2$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $c4c3f9798cb7fddc$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $98a9ef6d31ff03cd$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $aJx1R.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $52cebc1858d4dde2$var$useUtilityClasses();
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)(Root, (0, $aJx1R.default)({}, rootProps, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 *
 * Demos:
 *
 * - [Popper](https://mui.com/base-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/base-ui/react-popper/components-api/#popper)
 */ const $52cebc1858d4dde2$export$badac9ada3a0bdf9 = /*#__PURE__*/ $exYeM.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = "ltr", disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = "bottom", popperOptions: popperOptions = $52cebc1858d4dde2$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $3L80X.default)(props, $52cebc1858d4dde2$var$_excluded2);
    const [exited, setExited] = $exYeM.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $52cebc1858d4dde2$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $52cebc1858d4dde2$var$isHTMLElement(resolvedAnchorEl) ? (0, $0d47b1cc144b9266$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $0d47b1cc144b9266$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? "none" : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a99d22fd25a4c1ba$export$602eac185826482c), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($52cebc1858d4dde2$var$PopperTooltip, (0, $aJx1R.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $aJx1R.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});


var $9e2a55e452ed1762$exports = {};
"use strict";
"use client";
Object.defineProperty($9e2a55e452ed1762$exports, "__esModule", {
    value: true
});
$9e2a55e452ed1762$exports.default = void 0;

var $9e2a55e452ed1762$var$React = $9e2a55e452ed1762$var$_interopRequireWildcard((parcelRequire("exYeM")));
parcelRequire("geqbO");
var $7szRs = parcelRequire("7szRs");
function $9e2a55e452ed1762$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9e2a55e452ed1762$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $9e2a55e452ed1762$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $9e2a55e452ed1762$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $9e2a55e452ed1762$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $9e2a55e452ed1762$var$useTheme(defaultTheme = null) {
    const contextTheme = $9e2a55e452ed1762$var$React.useContext($7szRs.T);
    return !contextTheme || $9e2a55e452ed1762$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $9e2a55e452ed1762$var$_default = $9e2a55e452ed1762$exports.default = $9e2a55e452ed1762$var$useTheme;






var $exYeM = parcelRequire("exYeM");

var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $aSiaI = parcelRequire("aSiaI");
"use client";
const $5c4432cbbd879abf$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $5c4432cbbd879abf$var$PopperRoot = (0, $jawKn.default)((0, $52cebc1858d4dde2$export$badac9ada3a0bdf9), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $5c4432cbbd879abf$var$Popper = /*#__PURE__*/ $exYeM.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, (/*@__PURE__*/$parcel$interopDefault($9e2a55e452ed1762$exports)))();
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiPopper"
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $3L80X.default)(props, $5c4432cbbd879abf$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $aJx1R.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($5c4432cbbd879abf$var$PopperRoot, (0, $aJx1R.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $5c4432cbbd879abf$export$2e2bcd8739ae039 = $5c4432cbbd879abf$var$Popper;





var $exYeM = parcelRequire("exYeM");
"use client";
let $43c7ad0c22f8e14a$var$globalId = 0;
function $43c7ad0c22f8e14a$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $exYeM.useState(idOverride);
    const id = idOverride || defaultId;
    $exYeM.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $43c7ad0c22f8e14a$var$globalId += 1;
            setDefaultId(`mui-${$43c7ad0c22f8e14a$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $43c7ad0c22f8e14a$var$maybeReactUseId = $exYeM["useId".toString()];
function $43c7ad0c22f8e14a$export$2e2bcd8739ae039(idOverride) {
    if ($43c7ad0c22f8e14a$var$maybeReactUseId !== undefined) {
        const reactId = $43c7ad0c22f8e14a$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $43c7ad0c22f8e14a$var$useGlobalId(idOverride);
}


"use client";
var $2a26638fe29e10dc$export$2e2bcd8739ae039 = (0, $43c7ad0c22f8e14a$export$2e2bcd8739ae039);




var $exYeM = parcelRequire("exYeM");
"use client";
function $d86ef59ee77e84fd$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $exYeM.useRef(controlled !== undefined);
    const [valueState, setValue] = $exYeM.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $exYeM.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


"use client";
var $1d509214da7db874$export$2e2bcd8739ae039 = (0, $d86ef59ee77e84fd$export$2e2bcd8739ae039);



var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $398b111a0d579b06$export$837848f5f6cee923(slot) {
    return (0, $dC5O8.default)("MuiTooltip", slot);
}
const $398b111a0d579b06$var$tooltipClasses = (0, $kY7HX.default)("MuiTooltip", [
    "popper",
    "popperInteractive",
    "popperArrow",
    "popperClose",
    "tooltip",
    "tooltipArrow",
    "touch",
    "tooltipPlacementLeft",
    "tooltipPlacementRight",
    "tooltipPlacementTop",
    "tooltipPlacementBottom",
    "arrow"
]);
var $398b111a0d579b06$export$2e2bcd8739ae039 = $398b111a0d579b06$var$tooltipClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $c962e347330081ad$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $c962e347330081ad$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $c962e347330081ad$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            "popper",
            !disableInteractive && "popperInteractive",
            arrow && "popperArrow"
        ],
        tooltip: [
            "tooltip",
            arrow && "tooltipArrow",
            touch && "touch",
            `tooltipPlacement${(0, $fXwzw.default)(placement.split("-")[0])}`
        ],
        arrow: [
            "arrow"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $398b111a0d579b06$export$837848f5f6cee923), classes);
};
const $c962e347330081ad$var$TooltipPopper = (0, $jawKn.default)((0, $5c4432cbbd879abf$export$2e2bcd8739ae039), {
    name: "MuiTooltip",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $aJx1R.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: "none"
    }, !ownerState.disableInteractive && {
        pointerEvents: "auto"
    }, !open && {
        pointerEvents: "none"
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $398b111a0d579b06$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: "-0.71em",
            "&::before": {
                transformOrigin: "0 100%"
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $398b111a0d579b06$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: "-0.71em",
            "&::before": {
                transformOrigin: "100% 0"
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $398b111a0d579b06$export$2e2bcd8739ae039).arrow}`]: (0, $aJx1R.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: "-0.71em"
        } : {
            right: 0,
            marginRight: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "100% 100%"
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $398b111a0d579b06$export$2e2bcd8739ae039).arrow}`]: (0, $aJx1R.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: "-0.71em"
        } : {
            left: 0,
            marginLeft: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "0 0"
            }
        })
    }));
const $c962e347330081ad$var$TooltipTooltip = (0, $jawKn.default)("div", {
    name: "MuiTooltip",
    slot: "Tooltip",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $fXwzw.default)(ownerState.placement.split("-")[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $8L988.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: "4px 8px",
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: "break-word",
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: "relative",
        margin: 0
    }, ownerState.touch && {
        padding: "8px 16px",
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$c962e347330081ad$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $398b111a0d579b06$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $aJx1R.default)({
            transformOrigin: "right center"
        }, !ownerState.isRtl ? (0, $aJx1R.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        }) : (0, $aJx1R.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        })),
        [`.${(0, $398b111a0d579b06$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $aJx1R.default)({
            transformOrigin: "left center"
        }, !ownerState.isRtl ? (0, $aJx1R.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        }) : (0, $aJx1R.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        })),
        [`.${(0, $398b111a0d579b06$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $aJx1R.default)({
            transformOrigin: "center bottom",
            marginBottom: "14px"
        }, ownerState.touch && {
            marginBottom: "24px"
        }),
        [`.${(0, $398b111a0d579b06$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $aJx1R.default)({
            transformOrigin: "center top",
            marginTop: "14px"
        }, ownerState.touch && {
            marginTop: "24px"
        })
    }));
const $c962e347330081ad$var$TooltipArrow = (0, $jawKn.default)("span", {
    name: "MuiTooltip",
    slot: "Arrow",
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: "hidden",
        position: "absolute",
        width: "1em",
        height: "0.71em" /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: "border-box",
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $8L988.alpha)(theme.palette.grey[700], 0.9),
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)"
        }
    }));
let $c962e347330081ad$var$hystersisOpen = false;
const $c962e347330081ad$var$hystersisTimer = new (0, $72fb5758a7c9ec4b$export$786b4da70f00938b)();
let $c962e347330081ad$var$cursorPosition = {
    x: 0,
    y: 0
};
function $c962e347330081ad$export$b9ee5a7ace0541f8() {
    $c962e347330081ad$var$hystersisOpen = false;
    $c962e347330081ad$var$hystersisTimer.clear();
}
function $c962e347330081ad$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $c962e347330081ad$var$Tooltip = /*#__PURE__*/ $exYeM.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiTooltip"
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = "bottom", PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $0b476d905dd3781d$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $3L80X.default)(props, $c962e347330081ad$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $exYeM.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const isRtl = (0, $f6d0b5039025b20a$export$b2dd014b6c321cb)();
    const [childNode, setChildNode] = $exYeM.useState();
    const [arrowRef, setArrowRef] = $exYeM.useState(null);
    const ignoreNonTouchEvents = $exYeM.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $72fb5758a7c9ec4b$export$2e2bcd8739ae039)();
    const enterTimer = (0, $72fb5758a7c9ec4b$export$2e2bcd8739ae039)();
    const leaveTimer = (0, $72fb5758a7c9ec4b$export$2e2bcd8739ae039)();
    const touchTimer = (0, $72fb5758a7c9ec4b$export$2e2bcd8739ae039)();
    const [openState, setOpenState] = (0, $1d509214da7db874$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: "Tooltip",
        state: "open"
    });
    let open = openState;
    const id = (0, $2a26638fe29e10dc$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $exYeM.useRef();
    const stopTouchInteraction = (0, $d00700b704925555$export$2e2bcd8739ae039)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $exYeM.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $c962e347330081ad$var$hystersisTimer.clear();
        $c962e347330081ad$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $d00700b704925555$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $c962e347330081ad$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $c962e347330081ad$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute("title");
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $c962e347330081ad$var$hystersisOpen && enterNextDelay) enterTimer.start($c962e347330081ad$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $d231bcdf65c325cd$export$2e2bcd8739ae039)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $exYeM.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = "none";
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $exYeM.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") handleClose(nativeEvent);
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $69ecd4eca0914ac9$export$2e2bcd8739ae039)(children.ref, focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $exYeM.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $c962e347330081ad$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === "string";
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps["aria-describedby"] = open ? id : null;
    } else {
        nameOrDescProps["aria-label"] = titleIsString ? title : null;
        nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $aJx1R.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $4qr5a.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $c962e347330081ad$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $c962e347330081ad$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $c962e347330081ad$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $c962e347330081ad$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $exYeM.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: "arrow",
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $aJx1R.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $aJx1R.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $c962e347330081ad$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $c962e347330081ad$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $0b476d905dd3781d$export$2e2bcd8739ae039);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $c962e347330081ad$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $c962e347330081ad$var$TooltipArrow;
    const popperProps = (0, $0ce6f43677b2e28e$export$b089efb01a7bdf50)(PopperComponent, (0, $aJx1R.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $4qr5a.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $0ce6f43677b2e28e$export$b089efb01a7bdf50)(TransitionComponent, (0, $aJx1R.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $0ce6f43677b2e28e$export$b089efb01a7bdf50)(TooltipComponent, (0, $aJx1R.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $4qr5a.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $0ce6f43677b2e28e$export$b089efb01a7bdf50)(ArrowComponent, (0, $aJx1R.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $4qr5a.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
        children: [
            /*#__PURE__*/ $exYeM.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $aSiaI.jsx)(PopperComponent, (0, $aJx1R.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $5c4432cbbd879abf$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $c962e347330081ad$var$cursorPosition.y,
                            left: $c962e347330081ad$var$cursorPosition.x,
                            right: $c962e347330081ad$var$cursorPosition.x,
                            bottom: $c962e347330081ad$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $aSiaI.jsx)(TransitionComponent, (0, $aJx1R.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)(TooltipComponent, (0, $aJx1R.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $aSiaI.jsx)(ArrowComponent, (0, $aJx1R.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $c962e347330081ad$export$2e2bcd8739ae039 = $c962e347330081ad$var$Tooltip;




var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $99M00 = parcelRequire("99M00");

var $2f0D3 = parcelRequire("2f0D3");

var $8L988 = parcelRequire("8L988");

var $jawKn = parcelRequire("jawKn");
var $bJ6Mf = parcelRequire("bJ6Mf");

var $7PWLt = parcelRequire("7PWLt");


var $fXwzw = parcelRequire("fXwzw");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $d841dfcf6c976e24$export$5a6f9035944c8119(slot) {
    return (0, $dC5O8.default)("MuiButton", slot);
}
const $d841dfcf6c976e24$var$buttonClasses = (0, $kY7HX.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorError",
    "colorInfo",
    "colorWarning",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "icon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $d841dfcf6c976e24$export$2e2bcd8739ae039 = $d841dfcf6c976e24$var$buttonClasses;



var $exYeM = parcelRequire("exYeM");
/**
 * @ignore - internal component.
 */ const $73c1067317650586$var$ButtonGroupContext = /*#__PURE__*/ $exYeM.createContext({});
var $73c1067317650586$export$2e2bcd8739ae039 = $73c1067317650586$var$ButtonGroupContext;



var $exYeM = parcelRequire("exYeM");
/**
 * @ignore - internal component.
 */ const $1474f2915bd50cfb$var$ButtonGroupButtonContext = /*#__PURE__*/ $exYeM.createContext(undefined);
var $1474f2915bd50cfb$export$2e2bcd8739ae039 = $1474f2915bd50cfb$var$ButtonGroupButtonContext;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $980dfff3cab72cf4$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $980dfff3cab72cf4$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $fXwzw.default)(color)}`,
            `size${(0, $fXwzw.default)(size)}`,
            `${variant}Size${(0, $fXwzw.default)(size)}`,
            `color${(0, $fXwzw.default)(color)}`,
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "icon",
            "startIcon",
            `iconSize${(0, $fXwzw.default)(size)}`
        ],
        endIcon: [
            "icon",
            "endIcon",
            `iconSize${(0, $fXwzw.default)(size)}`
        ]
    };
    const composedClasses = (0, $2f0D3.default)(slots, (0, $d841dfcf6c976e24$export$5a6f9035944c8119), classes);
    return (0, $aJx1R.default)({}, classes, composedClasses);
};
const $980dfff3cab72cf4$var$commonIconStyles = (ownerState)=>(0, $aJx1R.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $980dfff3cab72cf4$var$ButtonRoot = (0, $jawKn.default)((0, $8c6774266c067eb9$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $bJ6Mf.default)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $fXwzw.default)(ownerState.color)}`],
            styles[`size${(0, $fXwzw.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $fXwzw.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $aJx1R.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $aJx1R.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8L988.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8L988.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8L988.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $aJx1R.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $d841dfcf6c976e24$export$2e2bcd8739ae039).focusVisible}`]: (0, $aJx1R.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $d841dfcf6c976e24$export$2e2bcd8739ae039).disabled}`]: (0, $aJx1R.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $8L988.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $d841dfcf6c976e24$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $d841dfcf6c976e24$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: "none"
        }
    });
const $980dfff3cab72cf4$var$ButtonStartIcon = (0, $jawKn.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $fXwzw.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $aJx1R.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $980dfff3cab72cf4$var$commonIconStyles(ownerState)));
const $980dfff3cab72cf4$var$ButtonEndIcon = (0, $jawKn.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $fXwzw.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $aJx1R.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $980dfff3cab72cf4$var$commonIconStyles(ownerState)));
const $980dfff3cab72cf4$var$Button = /*#__PURE__*/ $exYeM.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $exYeM.useContext((0, $73c1067317650586$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $exYeM.useContext((0, $1474f2915bd50cfb$export$2e2bcd8739ae039));
    const resolvedProps = (0, $99M00.default)(contextProps, inProps);
    const props = (0, $7PWLt.default)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text" } = props, other = (0, $3L80X.default)(props, $980dfff3cab72cf4$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $980dfff3cab72cf4$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $aSiaI.jsx)($980dfff3cab72cf4$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $aSiaI.jsx)($980dfff3cab72cf4$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || "";
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($980dfff3cab72cf4$var$ButtonRoot, (0, $aJx1R.default)({
        ownerState: ownerState,
        className: (0, $4qr5a.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $4qr5a.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $980dfff3cab72cf4$export$2e2bcd8739ae039 = $980dfff3cab72cf4$var$Button;



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");


var $2f0D3 = parcelRequire("2f0D3");

var $geqbO = parcelRequire("geqbO");

var $fXwzw = parcelRequire("fXwzw");

var $7PWLt = parcelRequire("7PWLt");

var $jawKn = parcelRequire("jawKn");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $b92a4420ffe59ea8$export$29cad1383b3f235d(slot) {
    return (0, $dC5O8.default)("MuiCircularProgress", slot);
}
const $b92a4420ffe59ea8$var$circularProgressClasses = (0, $kY7HX.default)("MuiCircularProgress", [
    "root",
    "determinate",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "svg",
    "circle",
    "circleDeterminate",
    "circleIndeterminate",
    "circleDisableShrink"
]);
var $b92a4420ffe59ea8$export$2e2bcd8739ae039 = $b92a4420ffe59ea8$var$circularProgressClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $8a947ac56b8361c3$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $8a947ac56b8361c3$var$_ = (t)=>t, $8a947ac56b8361c3$var$_t, $8a947ac56b8361c3$var$_t2, $8a947ac56b8361c3$var$_t3, $8a947ac56b8361c3$var$_t4;
const $8a947ac56b8361c3$var$SIZE = 44;
const $8a947ac56b8361c3$var$circularRotateKeyframe = (0, $geqbO.keyframes)($8a947ac56b8361c3$var$_t || ($8a947ac56b8361c3$var$_t = $8a947ac56b8361c3$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $8a947ac56b8361c3$var$circularDashKeyframe = (0, $geqbO.keyframes)($8a947ac56b8361c3$var$_t2 || ($8a947ac56b8361c3$var$_t2 = $8a947ac56b8361c3$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $8a947ac56b8361c3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `color${(0, $fXwzw.default)(color)}`
        ],
        svg: [
            "svg"
        ],
        circle: [
            "circle",
            `circle${(0, $fXwzw.default)(variant)}`,
            disableShrink && "circleDisableShrink"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $b92a4420ffe59ea8$export$29cad1383b3f235d), classes);
};
const $8a947ac56b8361c3$var$CircularProgressRoot = (0, $jawKn.default)("span", {
    name: "MuiCircularProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $fXwzw.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $aJx1R.default)({
        display: "inline-block"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("transform")
    }, ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && (0, $geqbO.css)($8a947ac56b8361c3$var$_t3 || ($8a947ac56b8361c3$var$_t3 = $8a947ac56b8361c3$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $8a947ac56b8361c3$var$circularRotateKeyframe));
const $8a947ac56b8361c3$var$CircularProgressSVG = (0, $jawKn.default)("svg", {
    name: "MuiCircularProgress",
    slot: "Svg",
    overridesResolver: (props, styles)=>styles.svg
})({
    display: "block" // Keeps the progress centered
});
const $8a947ac56b8361c3$var$CircularProgressCircle = (0, $jawKn.default)("circle", {
    name: "MuiCircularProgress",
    slot: "Circle",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $fXwzw.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $aJx1R.default)({
        stroke: "currentColor"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("stroke-dashoffset")
    }, ownerState.variant === "indeterminate" && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: "80px, 200px",
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && !ownerState.disableShrink && (0, $geqbO.css)($8a947ac56b8361c3$var$_t4 || ($8a947ac56b8361c3$var$_t4 = $8a947ac56b8361c3$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $8a947ac56b8361c3$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $8a947ac56b8361c3$var$CircularProgress = /*#__PURE__*/ $exYeM.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiCircularProgress"
    });
    const { className: className, color: color = "primary", disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = "indeterminate" } = props, other = (0, $3L80X.default)(props, $8a947ac56b8361c3$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $8a947ac56b8361c3$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === "determinate") {
        const circumference = 2 * Math.PI * (($8a947ac56b8361c3$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ (0, $aSiaI.jsx)($8a947ac56b8361c3$var$CircularProgressRoot, (0, $aJx1R.default)({
        className: (0, $4qr5a.default)(classes.root, className),
        style: (0, $aJx1R.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($8a947ac56b8361c3$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$8a947ac56b8361c3$var$SIZE / 2} ${$8a947ac56b8361c3$var$SIZE / 2} ${$8a947ac56b8361c3$var$SIZE} ${$8a947ac56b8361c3$var$SIZE}`,
            children: /*#__PURE__*/ (0, $aSiaI.jsx)($8a947ac56b8361c3$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $8a947ac56b8361c3$var$SIZE,
                cy: $8a947ac56b8361c3$var$SIZE,
                r: ($8a947ac56b8361c3$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $8a947ac56b8361c3$export$2e2bcd8739ae039 = $8a947ac56b8361c3$var$CircularProgress;



var $2TX6h = parcelRequire("2TX6h");

var $g5OQF = parcelRequire("g5OQF");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $69eec9e6c105674b$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $g5OQF.default)(value, min, max);
}
function $69eec9e6c105674b$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $69eec9e6c105674b$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $69eec9e6c105674b$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $69eec9e6c105674b$export$677b39864803984e($69eec9e6c105674b$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $2TX6h.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $2TX6h.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $69eec9e6c105674b$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $69eec9e6c105674b$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $69eec9e6c105674b$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $69eec9e6c105674b$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $69eec9e6c105674b$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $69eec9e6c105674b$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $69eec9e6c105674b$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$69eec9e6c105674b$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $69eec9e6c105674b$export$29fb7152bd3f781a(color) {
    color = $69eec9e6c105674b$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $69eec9e6c105674b$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $69eec9e6c105674b$export$c852d90bf7403b62(color) {
    color = $69eec9e6c105674b$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $69eec9e6c105674b$export$677b39864803984e($69eec9e6c105674b$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $69eec9e6c105674b$export$d061e26956a60b0a(foreground, background) {
    const lumA = $69eec9e6c105674b$export$c852d90bf7403b62(foreground);
    const lumB = $69eec9e6c105674b$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $69eec9e6c105674b$export$58f0f39f63f3cf42(color, value) {
    color = $69eec9e6c105674b$export$677b39864803984e(color);
    value = $69eec9e6c105674b$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $69eec9e6c105674b$export$211a73f2b8c10ce4(color);
}
function $69eec9e6c105674b$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $69eec9e6c105674b$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $69eec9e6c105674b$export$4b073707ff63303(color, coefficient) {
    color = $69eec9e6c105674b$export$677b39864803984e(color);
    coefficient = $69eec9e6c105674b$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $69eec9e6c105674b$export$211a73f2b8c10ce4(color);
}
function $69eec9e6c105674b$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $69eec9e6c105674b$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $69eec9e6c105674b$export$c0816ed86df316af(color, coefficient) {
    color = $69eec9e6c105674b$export$677b39864803984e(color);
    coefficient = $69eec9e6c105674b$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $69eec9e6c105674b$export$211a73f2b8c10ce4(color);
}
function $69eec9e6c105674b$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $69eec9e6c105674b$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $69eec9e6c105674b$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $69eec9e6c105674b$export$c852d90bf7403b62(color) > 0.5 ? $69eec9e6c105674b$export$4b073707ff63303(color, coefficient) : $69eec9e6c105674b$export$c0816ed86df316af(color, coefficient);
}
function $69eec9e6c105674b$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $69eec9e6c105674b$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $69eec9e6c105674b$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $69eec9e6c105674b$export$677b39864803984e(background);
    const overlayColor = $69eec9e6c105674b$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $69eec9e6c105674b$export$211a73f2b8c10ce4({
        type: "rgb",
        values: rgb
    });
}



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");
parcelRequire("bSFE1");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");




var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");
parcelRequire("bSFE1");



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");

var $exYeM = parcelRequire("exYeM");
"use client";
/**
 * @ignore - internal component.
 */ const $8b8465e0061b533a$var$ListContext = /*#__PURE__*/ $exYeM.createContext({});
var $8b8465e0061b533a$export$2e2bcd8739ae039 = $8b8465e0061b533a$var$ListContext;



var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $8e09afbcec503df7$export$c6bd6795ed6e3203(slot) {
    return (0, $dC5O8.default)("MuiList", slot);
}
const $8e09afbcec503df7$var$listClasses = (0, $kY7HX.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $8e09afbcec503df7$export$2e2bcd8739ae039 = $8e09afbcec503df7$var$listClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $1217f3be3073ef0b$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $1217f3be3073ef0b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $8e09afbcec503df7$export$c6bd6795ed6e3203), classes);
};
const $1217f3be3073ef0b$var$ListRoot = (0, $jawKn.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $aJx1R.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $1217f3be3073ef0b$var$List = /*#__PURE__*/ $exYeM.forwardRef(function List(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children, className: className, component: component = "ul", dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $3L80X.default)(props, $1217f3be3073ef0b$var$_excluded);
    const context = $exYeM.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $aJx1R.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $1217f3be3073ef0b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8b8465e0061b533a$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)($1217f3be3073ef0b$var$ListRoot, (0, $aJx1R.default)({
            as: component,
            className: (0, $4qr5a.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $1217f3be3073ef0b$export$2e2bcd8739ae039 = $1217f3be3073ef0b$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $7fec2c46e3a8a8aa$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


var $57965e4b6e599666$export$2e2bcd8739ae039 = (0, $7fec2c46e3a8a8aa$export$2e2bcd8739ae039);





var $aSiaI = parcelRequire("aSiaI");
"use client";
const $9bf3612007aa5fca$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $9bf3612007aa5fca$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $9bf3612007aa5fca$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $9bf3612007aa5fca$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $9bf3612007aa5fca$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$9bf3612007aa5fca$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $9bf3612007aa5fca$var$MenuList = /*#__PURE__*/ $exYeM.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = "selectedMenu" } = props, other = (0, $3L80X.default)(props, $9bf3612007aa5fca$var$_excluded);
    const listRef = $exYeM.useRef(null);
    const textCriteriaRef = $exYeM.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $3e56c60e7cf2a296$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $exYeM.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $57965e4b6e599666$export$2e2bcd8739ae039)((0, $0a69054a0e524d5d$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $0a69054a0e524d5d$export$2e2bcd8739ae039)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $9bf3612007aa5fca$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $9bf3612007aa5fca$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $9bf3612007aa5fca$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $9bf3612007aa5fca$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $9bf3612007aa5fca$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $9bf3612007aa5fca$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $9bf3612007aa5fca$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $9bf3612007aa5fca$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $9bf3612007aa5fca$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $9bf3612007aa5fca$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $9bf3612007aa5fca$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $69ecd4eca0914ac9$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $exYeM.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $exYeM.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $exYeM.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $exYeM.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1217f3be3073ef0b$export$2e2bcd8739ae039), (0, $aJx1R.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $9bf3612007aa5fca$export$2e2bcd8739ae039 = $9bf3612007aa5fca$var$MenuList;



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");


var $2f0D3 = parcelRequire("2f0D3");






var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");






var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");




var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $2fdfe54adbfbf19f$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}




// Is a vertical scrollbar displayed?
function $24b4d8932a455036$var$isOverflowing(container) {
    const doc = (0, $0d47b1cc144b9266$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $9a18bdeaa27f655f$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $24b4d8932a455036$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $24b4d8932a455036$var$getPaddingRight(element) {
    return parseInt((0, $9a18bdeaa27f655f$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $24b4d8932a455036$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $24b4d8932a455036$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$24b4d8932a455036$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $24b4d8932a455036$export$e1bd0c6150f13d96(element, show);
    });
}
function $24b4d8932a455036$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $24b4d8932a455036$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($24b4d8932a455036$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $7fec2c46e3a8a8aa$export$2e2bcd8739ae039)((0, $0d47b1cc144b9266$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$24b4d8932a455036$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $0d47b1cc144b9266$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$24b4d8932a455036$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $0d47b1cc144b9266$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $9a18bdeaa27f655f$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $24b4d8932a455036$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $24b4d8932a455036$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $24b4d8932a455036$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $24b4d8932a455036$var$getHiddenSiblings(container);
        $24b4d8932a455036$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $24b4d8932a455036$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $24b4d8932a455036$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $24b4d8932a455036$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $24b4d8932a455036$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $24b4d8932a455036$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $24b4d8932a455036$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $24b4d8932a455036$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


"use client";
function $876094ab5efe6dba$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $876094ab5efe6dba$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $876094ab5efe6dba$var$defaultManager = new (0, $24b4d8932a455036$export$ce11c4ecd08cea67)();
function $876094ab5efe6dba$export$33ffd74ebf07f060(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $876094ab5efe6dba$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $exYeM.useRef({});
    const mountNodeRef = $exYeM.useRef(null);
    const modalRef = $exYeM.useRef(null);
    const handleRef = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $exYeM.useState(!open);
    const hasTransition = $876094ab5efe6dba$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $0d47b1cc144b9266$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $876094ab5efe6dba$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $exYeM.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $24b4d8932a455036$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $exYeM.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $exYeM.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $exYeM.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== "Escape" || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, "escapeKeyDown");
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, "backdropClick");
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $2e067879f82a8818$export$24d5698b57eff81c)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $aJx1R.default)({}, propsEventHandlers, otherHandlers);
        return (0, $aJx1R.default)({
            role: "presentation"
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $aJx1R.default)({
            "aria-hidden": true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $2fdfe54adbfbf19f$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $2fdfe54adbfbf19f$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}



var $2f0D3 = parcelRequire("2f0D3");

var $exYeM = parcelRequire("exYeM");



var $aSiaI = parcelRequire("aSiaI");
"use client";
// Inspired by https://github.com/focus-trap/tabbable
const $99bcabd76da68fe9$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $99bcabd76da68fe9$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $99bcabd76da68fe9$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $99bcabd76da68fe9$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $99bcabd76da68fe9$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $99bcabd76da68fe9$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($99bcabd76da68fe9$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $99bcabd76da68fe9$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$99bcabd76da68fe9$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $99bcabd76da68fe9$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base-ui/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base-ui/react-focus-trap/components-api/#focus-trap)
 */ function $99bcabd76da68fe9$export$34eba2437817a67b(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $99bcabd76da68fe9$var$defaultGetTabbable, isEnabled: isEnabled = $99bcabd76da68fe9$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $exYeM.useRef(false);
    const sentinelStart = $exYeM.useRef(null);
    const sentinelEnd = $exYeM.useRef(null);
    const nodeToRestore = $exYeM.useRef(null);
    const reactFocusEventTarget = $exYeM.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $exYeM.useRef(false);
    const rootRef = $exYeM.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(children.ref, rootRef);
    const lastKeydown = $exYeM.useRef(null);
    $exYeM.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $exYeM.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $0d47b1cc144b9266$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $exYeM.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $0d47b1cc144b9266$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $exYeM.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}




var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");

var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");

var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");







var $aSiaI = parcelRequire("aSiaI");
"use client";
const $b8c58e7700914c7f$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $b8c58e7700914c7f$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $b8c58e7700914c7f$var$Fade = /*#__PURE__*/ $exYeM.forwardRef(function Fade(props, ref) {
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $b1fed440e66ae1d8$export$2e2bcd8739ae039) } = props, other = (0, $3L80X.default)(props, $b8c58e7700914c7f$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $exYeM.useRef(null);
    const handleRef = (0, $69ecd4eca0914ac9$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $439a83a81b60056a$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $439a83a81b60056a$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $439a83a81b60056a$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)(TransitionComponent, (0, $aJx1R.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $exYeM.cloneElement(children, (0, $aJx1R.default)({
                style: (0, $aJx1R.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $b8c58e7700914c7f$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $b8c58e7700914c7f$export$2e2bcd8739ae039 = $b8c58e7700914c7f$var$Fade;



var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $005a5a603fb06f1d$export$9927a91fd93152bd(slot) {
    return (0, $dC5O8.default)("MuiBackdrop", slot);
}
const $005a5a603fb06f1d$var$backdropClasses = (0, $kY7HX.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $005a5a603fb06f1d$export$2e2bcd8739ae039 = $005a5a603fb06f1d$var$backdropClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $1bb3b0214ed923c7$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $1bb3b0214ed923c7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $005a5a603fb06f1d$export$9927a91fd93152bd), classes);
};
const $1bb3b0214ed923c7$var$BackdropRoot = (0, $jawKn.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $aJx1R.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $1bb3b0214ed923c7$var$Backdrop = /*#__PURE__*/ $exYeM.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, className: className, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $b8c58e7700914c7f$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $3L80X.default)(props, $1bb3b0214ed923c7$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $1bb3b0214ed923c7$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $aSiaI.jsx)(TransitionComponent, (0, $aJx1R.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($1bb3b0214ed923c7$var$BackdropRoot, (0, $aJx1R.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $4qr5a.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $aJx1R.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $1bb3b0214ed923c7$export$2e2bcd8739ae039 = $1bb3b0214ed923c7$var$Backdrop;



var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $13ea1156678cc3ef$export$67960e22b12a638d(slot) {
    return (0, $dC5O8.default)("MuiModal", slot);
}
const $13ea1156678cc3ef$var$modalClasses = (0, $kY7HX.default)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $13ea1156678cc3ef$export$2e2bcd8739ae039 = $13ea1156678cc3ef$var$modalClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $99d9e21ea1255c01$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $99d9e21ea1255c01$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $13ea1156678cc3ef$export$67960e22b12a638d), classes);
};
const $99d9e21ea1255c01$var$ModalRoot = (0, $jawKn.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $99d9e21ea1255c01$var$ModalBackdrop = (0, $jawKn.default)((0, $1bb3b0214ed923c7$export$2e2bcd8739ae039), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $99d9e21ea1255c01$var$Modal = /*#__PURE__*/ $exYeM.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $7PWLt.default)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $99d9e21ea1255c01$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $3L80X.default)(props, $99d9e21ea1255c01$var$_excluded);
    const propsWithDefaults = (0, $aJx1R.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $876094ab5efe6dba$export$33ffd74ebf07f060)((0, $aJx1R.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $aJx1R.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $99d9e21ea1255c01$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $99d9e21ea1255c01$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $4qr5a.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $aJx1R.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $4qr5a.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a99d22fd25a4c1ba$export$602eac185826482c), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)(RootSlot, (0, $aJx1R.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $aSiaI.jsx)(BackdropSlot, (0, $aJx1R.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $99bcabd76da68fe9$export$34eba2437817a67b), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $exYeM.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $99d9e21ea1255c01$export$2e2bcd8739ae039 = $99d9e21ea1255c01$var$Modal;



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");



var $2f0D3 = parcelRequire("2f0D3");

var $8L988 = parcelRequire("8L988");

var $jawKn = parcelRequire("jawKn");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $e68ba7794733bfb5$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $e68ba7794733bfb5$export$2e2bcd8739ae039 = $e68ba7794733bfb5$var$getOverlayAlpha;



var $7PWLt = parcelRequire("7PWLt");


var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $202613d120dd5f4d$export$29cdb466b9b6f20b(slot) {
    return (0, $dC5O8.default)("MuiPaper", slot);
}
const $202613d120dd5f4d$var$paperClasses = (0, $kY7HX.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $202613d120dd5f4d$export$2e2bcd8739ae039 = $202613d120dd5f4d$var$paperClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $e479e3bd14e95ba2$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $e479e3bd14e95ba2$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $202613d120dd5f4d$export$29cdb466b9b6f20b), classes);
};
const $e479e3bd14e95ba2$var$PaperRoot = (0, $jawKn.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $aJx1R.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $aJx1R.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $8L988.alpha)("#fff", (0, $e68ba7794733bfb5$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $8L988.alpha)("#fff", (0, $e68ba7794733bfb5$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $e479e3bd14e95ba2$var$Paper = /*#__PURE__*/ $exYeM.forwardRef(function Paper(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation" } = props, other = (0, $3L80X.default)(props, $e479e3bd14e95ba2$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $e479e3bd14e95ba2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($e479e3bd14e95ba2$var$PaperRoot, (0, $aJx1R.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $4qr5a.default)(classes.root, className),
        ref: ref
    }, other));
});
var $e479e3bd14e95ba2$export$2e2bcd8739ae039 = $e479e3bd14e95ba2$var$Paper;



var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $bb75de1cf2397a94$export$88f455dd56c95edb(slot) {
    return (0, $dC5O8.default)("MuiPopover", slot);
}
const $bb75de1cf2397a94$var$popoverClasses = (0, $kY7HX.default)("MuiPopover", [
    "root",
    "paper"
]);
var $bb75de1cf2397a94$export$2e2bcd8739ae039 = $bb75de1cf2397a94$var$popoverClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $5864cf953251acd1$var$_excluded = [
    "onEntering"
], $5864cf953251acd1$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $5864cf953251acd1$var$_excluded3 = [
    "slotProps"
];
function $5864cf953251acd1$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $5864cf953251acd1$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $5864cf953251acd1$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $5864cf953251acd1$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $5864cf953251acd1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $bb75de1cf2397a94$export$88f455dd56c95edb), classes);
};
const $5864cf953251acd1$export$bcce13685275fc99 = (0, $jawKn.default)((0, $99d9e21ea1255c01$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $5864cf953251acd1$export$821346c38a2d9390 = (0, $jawKn.default)((0, $e479e3bd14e95ba2$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $5864cf953251acd1$var$Popover = /*#__PURE__*/ $exYeM.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = "anchorEl", children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent: TransitionComponent = (0, $0b476d905dd3781d$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $3L80X.default)(props.TransitionProps, $5864cf953251acd1$var$_excluded), other = (0, $3L80X.default)(props, $5864cf953251acd1$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $exYeM.useRef();
    const handlePaperRef = (0, $69ecd4eca0914ac9$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $aJx1R.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $5864cf953251acd1$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $exYeM.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $5864cf953251acd1$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $0a69054a0e524d5d$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $5864cf953251acd1$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $5864cf953251acd1$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $exYeM.useCallback((elemRect)=>{
        return {
            vertical: $5864cf953251acd1$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $5864cf953251acd1$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $exYeM.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $5864cf953251acd1$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $181be504c47027d1$export$2e2bcd8739ae039)($5864cf953251acd1$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $5864cf953251acd1$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $exYeM.useState(open);
    const setPositioningStyles = $exYeM.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $exYeM.useEffect(()=>{
        if (disableScrollLock) window.addEventListener("scroll", setPositioningStyles);
        return ()=>window.removeEventListener("scroll", setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $exYeM.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $exYeM.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $exYeM.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $398f0b8aef852a12$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $181be504c47027d1$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $0a69054a0e524d5d$export$2e2bcd8739ae039)($5864cf953251acd1$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $5864cf953251acd1$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $5864cf953251acd1$export$821346c38a2d9390;
    const paperProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: (0, $aJx1R.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $aJx1R.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $4qr5a.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $4qr5a.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $3L80X.default)(_useSlotProps, $5864cf953251acd1$var$_excluded3);
    return /*#__PURE__*/ (0, $aSiaI.jsx)(RootSlot, (0, $aJx1R.default)({}, rootProps, !(0, $6d812737487786ea$export$e28348cc2430497)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)(TransitionComponent, (0, $aJx1R.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $aSiaI.jsx)(PaperSlot, (0, $aJx1R.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $5864cf953251acd1$export$2e2bcd8739ae039 = $5864cf953251acd1$var$Popover;



var $jawKn = parcelRequire("jawKn");
var $bJ6Mf = parcelRequire("bJ6Mf");

var $7PWLt = parcelRequire("7PWLt");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $4f0f0970f6f33866$export$2cf86a63a84fe23d(slot) {
    return (0, $dC5O8.default)("MuiMenu", slot);
}
const $4f0f0970f6f33866$var$menuClasses = (0, $kY7HX.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $4f0f0970f6f33866$export$2e2bcd8739ae039 = $4f0f0970f6f33866$var$menuClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $cf82f57fc51895ad$var$_excluded = [
    "onEntering"
], $cf82f57fc51895ad$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $cf82f57fc51895ad$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $cf82f57fc51895ad$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $cf82f57fc51895ad$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $4f0f0970f6f33866$export$2cf86a63a84fe23d), classes);
};
const $cf82f57fc51895ad$var$MenuRoot = (0, $jawKn.default)((0, $5864cf953251acd1$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $bJ6Mf.default)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $cf82f57fc51895ad$export$4f7c51a5920c9f33 = (0, $jawKn.default)((0, $5864cf953251acd1$export$821346c38a2d9390), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $cf82f57fc51895ad$var$MenuMenuList = (0, $jawKn.default)((0, $9bf3612007aa5fca$export$2e2bcd8739ae039), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $cf82f57fc51895ad$var$Menu = /*#__PURE__*/ $exYeM.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = "auto", TransitionProps: { onEntering: onEntering } = {}, variant: variant = "selectedMenu", slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $3L80X.default)(props.TransitionProps, $cf82f57fc51895ad$var$_excluded), other = (0, $3L80X.default)(props, $cf82f57fc51895ad$var$_excluded2);
    const isRtl = (0, $f6d0b5039025b20a$export$b2dd014b6c321cb)();
    const ownerState = (0, $aJx1R.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $cf82f57fc51895ad$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $exYeM.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? "rtl" : "ltr"
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $exYeM.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $exYeM.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $cf82f57fc51895ad$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)($cf82f57fc51895ad$var$MenuRoot, (0, $aJx1R.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $cf82f57fc51895ad$var$RTL_ORIGIN : $cf82f57fc51895ad$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $aJx1R.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($cf82f57fc51895ad$var$MenuMenuList, (0, $aJx1R.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $4qr5a.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $cf82f57fc51895ad$export$2e2bcd8739ae039 = $cf82f57fc51895ad$var$Menu;



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $f15b009311ff3143$export$81478e24460c57f2(slot) {
    return (0, $dC5O8.default)("MuiListItemIcon", slot);
}
const $f15b009311ff3143$var$listItemIconClasses = (0, $kY7HX.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $f15b009311ff3143$export$2e2bcd8739ae039 = $f15b009311ff3143$var$listItemIconClasses;




var $aSiaI = parcelRequire("aSiaI");
"use client";
const $2b564c102ca4210b$var$_excluded = [
    "className"
];
const $2b564c102ca4210b$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            alignItems === "flex-start" && "alignItemsFlexStart"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $f15b009311ff3143$export$81478e24460c57f2), classes);
};
const $2b564c102ca4210b$var$ListItemIconRoot = (0, $jawKn.default)("div", {
    name: "MuiListItemIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: "inline-flex"
    }, ownerState.alignItems === "flex-start" && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $2b564c102ca4210b$var$ListItemIcon = /*#__PURE__*/ $exYeM.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiListItemIcon"
    });
    const { className: className } = props, other = (0, $3L80X.default)(props, $2b564c102ca4210b$var$_excluded);
    const context = $exYeM.useContext((0, $8b8465e0061b533a$export$2e2bcd8739ae039));
    const ownerState = (0, $aJx1R.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $2b564c102ca4210b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($2b564c102ca4210b$var$ListItemIconRoot, (0, $aJx1R.default)({
        className: (0, $4qr5a.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $2b564c102ca4210b$export$2e2bcd8739ae039 = $2b564c102ca4210b$var$ListItemIcon;



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $8L988 = parcelRequire("8L988");

var $jawKn = parcelRequire("jawKn");
var $bJ6Mf = parcelRequire("bJ6Mf");

var $7PWLt = parcelRequire("7PWLt");





var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $cc7e41c75876879f$export$46f01d01378ec5a2(slot) {
    return (0, $dC5O8.default)("MuiDivider", slot);
}
const $cc7e41c75876879f$var$dividerClasses = (0, $kY7HX.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $cc7e41c75876879f$export$2e2bcd8739ae039 = $cc7e41c75876879f$var$dividerClasses;




var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $4e4c48a6be29522c$export$1061006a0db3aeb5(slot) {
    return (0, $dC5O8.default)("MuiListItemText", slot);
}
const $4e4c48a6be29522c$var$listItemTextClasses = (0, $kY7HX.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $4e4c48a6be29522c$export$2e2bcd8739ae039 = $4e4c48a6be29522c$var$listItemTextClasses;



var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $2b9b3e5060dcb98d$export$515f8c67b5305377(slot) {
    return (0, $dC5O8.default)("MuiMenuItem", slot);
}
const $2b9b3e5060dcb98d$var$menuItemClasses = (0, $kY7HX.default)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $2b9b3e5060dcb98d$export$2e2bcd8739ae039 = $2b9b3e5060dcb98d$var$menuItemClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $32731aa3cf1ce086$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $32731aa3cf1ce086$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $32731aa3cf1ce086$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $2f0D3.default)(slots, (0, $2b9b3e5060dcb98d$export$515f8c67b5305377), classes);
    return (0, $aJx1R.default)({}, classes, composedClasses);
};
const $32731aa3cf1ce086$var$MenuItemRoot = (0, $jawKn.default)((0, $8c6774266c067eb9$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $bJ6Mf.default)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $32731aa3cf1ce086$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({}, theme.typography.body1, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, {
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $2b9b3e5060dcb98d$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $8L988.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $2b9b3e5060dcb98d$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $8L988.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $2b9b3e5060dcb98d$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $8L988.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $8L988.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $2b9b3e5060dcb98d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $2b9b3e5060dcb98d$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $cc7e41c75876879f$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $cc7e41c75876879f$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $4e4c48a6be29522c$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $4e4c48a6be29522c$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $f15b009311ff3143$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up("sm")]: {
            minHeight: "auto"
        }
    }, ownerState.dense && (0, $aJx1R.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $f15b009311ff3143$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: "1.25rem"
        }
    })));
const $32731aa3cf1ce086$var$MenuItem = /*#__PURE__*/ $exYeM.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false, component: component = "li", dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = "menuitem", tabIndex: tabIndexProp, className: className } = props, other = (0, $3L80X.default)(props, $32731aa3cf1ce086$var$_excluded);
    const context = $exYeM.useContext((0, $8b8465e0061b533a$export$2e2bcd8739ae039));
    const childContext = $exYeM.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $exYeM.useRef(null);
    (0, $3e56c60e7cf2a296$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $aJx1R.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $32731aa3cf1ce086$var$useUtilityClasses(props);
    const handleRef = (0, $69ecd4eca0914ac9$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8b8465e0061b533a$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($32731aa3cf1ce086$var$MenuItemRoot, (0, $aJx1R.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $4qr5a.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $4qr5a.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $32731aa3cf1ce086$export$2e2bcd8739ae039 = $32731aa3cf1ce086$var$MenuItem;




var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $1cT6v = parcelRequire("1cT6v");

var $dC5O8 = parcelRequire("dC5O8");

var $2f0D3 = parcelRequire("2f0D3");

var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $7RpPE = parcelRequire("7RpPE");

var $1cT6v = parcelRequire("1cT6v");



var $26Kcc = parcelRequire("26Kcc");

var $3b4hp = parcelRequire("3b4hp");
const $b601c8f3fa89e057$var$_excluded = [
    "ownerState"
], $b601c8f3fa89e057$var$_excluded2 = [
    "variants"
], $b601c8f3fa89e057$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $b601c8f3fa89e057$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $b601c8f3fa89e057$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $b601c8f3fa89e057$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $b601c8f3fa89e057$export$35e57303dbd8a66 = (0, $26Kcc.default)();
const $b601c8f3fa89e057$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $b601c8f3fa89e057$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $b601c8f3fa89e057$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $b601c8f3fa89e057$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $b601c8f3fa89e057$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $3L80X.default)(_ref, $b601c8f3fa89e057$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $aJx1R.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$b601c8f3fa89e057$var$processStyleArg(resolvedStyle, (0, $aJx1R.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $3L80X.default)(resolvedStylesArg, $b601c8f3fa89e057$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $aJx1R.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $aJx1R.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $b601c8f3fa89e057$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $b601c8f3fa89e057$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $b601c8f3fa89e057$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $b601c8f3fa89e057$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $3b4hp.default)((0, $aJx1R.default)({}, props, {
            theme: $b601c8f3fa89e057$var$resolveTheme((0, $aJx1R.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $7RpPE.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $b601c8f3fa89e057$var$defaultOverridesResolver($b601c8f3fa89e057$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $3L80X.default)(inputOptions, $b601c8f3fa89e057$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $b601c8f3fa89e057$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($b601c8f3fa89e057$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $7RpPE.default)(tag, (0, $aJx1R.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $1cT6v.isPlainObject)(stylesArg)) return (props)=>$b601c8f3fa89e057$var$processStyleArg(stylesArg, (0, $aJx1R.default)({}, props, {
                    theme: $b601c8f3fa89e057$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $b601c8f3fa89e057$var$resolveTheme((0, $aJx1R.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $b601c8f3fa89e057$var$processStyleArg(slotStyle, (0, $aJx1R.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $b601c8f3fa89e057$var$resolveTheme((0, $aJx1R.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $b601c8f3fa89e057$var$processStyleArg({
                    variants: themeVariants
                }, (0, $aJx1R.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}


const $4e914c0f2c9015d4$var$styled = (0, $b601c8f3fa89e057$export$2e2bcd8739ae039)();
var $4e914c0f2c9015d4$export$2e2bcd8739ae039 = $4e914c0f2c9015d4$var$styled;



var $dZquJ = parcelRequire("dZquJ");

var $aJf2l = parcelRequire("aJf2l");

var $26Kcc = parcelRequire("26Kcc");

var $pXCWs = parcelRequire("pXCWs");

var $gdl2x = parcelRequire("gdl2x");

var $aSiaI = parcelRequire("aSiaI");
const $59a59994f633f7ee$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $59a59994f633f7ee$var$defaultTheme = (0, $26Kcc.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $59a59994f633f7ee$var$defaultCreateStyledComponent = (0, $4e914c0f2c9015d4$export$2e2bcd8739ae039)("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function $59a59994f633f7ee$var$useThemePropsDefault(props) {
    return (0, $dZquJ.default)({
        props: props,
        name: "MuiStack",
        defaultTheme: $59a59994f633f7ee$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $59a59994f633f7ee$var$joinChildren(children, separator) {
    const childrenArray = $exYeM.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $exYeM.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $59a59994f633f7ee$var$getSideFromDirection = (direction)=>{
    return ({
        row: "Left",
        "row-reverse": "Right",
        column: "Top",
        "column-reverse": "Bottom"
    })[direction];
};
const $59a59994f633f7ee$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $aJx1R.default)({
        display: "flex",
        flexDirection: "column"
    }, (0, $pXCWs.handleBreakpoints)({
        theme: theme
    }, (0, $pXCWs.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $gdl2x.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === "object" && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === "object" && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $pXCWs.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $pXCWs.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === "object") Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : "column";
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $gdl2x.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                "& > :not(style):not(style)": {
                    margin: 0
                },
                "& > :not(style) ~ :not(style)": {
                    [`margin${$59a59994f633f7ee$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $gdl2x.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $1cT6v.default)(styles, (0, $pXCWs.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $pXCWs.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $59a59994f633f7ee$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $59a59994f633f7ee$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $59a59994f633f7ee$var$useThemePropsDefault, componentName: componentName = "MuiStack" } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                "root"
            ]
        };
        return (0, $2f0D3.default)(slots, (slot)=>(0, $dC5O8.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($59a59994f633f7ee$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $exYeM.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $aJf2l.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = "div", direction: direction = "column", spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $3L80X.default)(props, $59a59994f633f7ee$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $aSiaI.jsx)(StackRoot, (0, $aJx1R.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $4qr5a.default)(classes.root, className)
        }, other, {
            children: divider ? $59a59994f633f7ee$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}



var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");
"use client";
const $e10e66deff206ed9$var$Stack = (0, $59a59994f633f7ee$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $jawKn.default)("div", {
        name: "MuiStack",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $7PWLt.default)({
            props: inProps,
            name: "MuiStack"
        })
});
var $e10e66deff206ed9$export$2e2bcd8739ae039 = $e10e66deff206ed9$var$Stack;



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");


var $2f0D3 = parcelRequire("2f0D3");

var $8L988 = parcelRequire("8L988");

var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");


var $2f0D3 = parcelRequire("2f0D3");

var $fXwzw = parcelRequire("fXwzw");

var $jawKn = parcelRequire("jawKn");
var $bJ6Mf = parcelRequire("bJ6Mf");


var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
/**
 * @ignore - internal component.
 */ const $58875f077a566e4b$var$FormControlContext = /*#__PURE__*/ $exYeM.createContext(undefined);
var $58875f077a566e4b$export$2e2bcd8739ae039 = $58875f077a566e4b$var$FormControlContext;


"use client";
function $cfe831b0e6d29047$export$2e2bcd8739ae039() {
    return $exYeM.useContext((0, $58875f077a566e4b$export$2e2bcd8739ae039));
}




var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $ce9bb0cc6664a1e0$export$baa0faa0c7ad8085(slot) {
    return (0, $dC5O8.default)("PrivateSwitchBase", slot);
}
const $ce9bb0cc6664a1e0$var$switchBaseClasses = (0, $kY7HX.default)("PrivateSwitchBase", [
    "root",
    "checked",
    "disabled",
    "input",
    "edgeStart",
    "edgeEnd"
]);
var $ce9bb0cc6664a1e0$export$2e2bcd8739ae039 = $ce9bb0cc6664a1e0$var$switchBaseClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $b2ee24326789fbdb$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $b2ee24326789fbdb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            "root",
            checked && "checked",
            disabled && "disabled",
            edge && `edge${(0, $fXwzw.default)(edge)}`
        ],
        input: [
            "input"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $ce9bb0cc6664a1e0$export$baa0faa0c7ad8085), classes);
};
const $b2ee24326789fbdb$var$SwitchBaseRoot = (0, $jawKn.default)((0, $8c6774266c067eb9$export$2e2bcd8739ae039))(({ ownerState: ownerState })=>(0, $aJx1R.default)({
        padding: 9,
        borderRadius: "50%"
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }));
const $b2ee24326789fbdb$var$SwitchBaseInput = (0, $jawKn.default)("input", {
    shouldForwardProp: (0, $bJ6Mf.default)
})({
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $b2ee24326789fbdb$var$SwitchBase = /*#__PURE__*/ $exYeM.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $3L80X.default)(props, $b2ee24326789fbdb$var$_excluded);
    const [checked, setCheckedState] = (0, $1d509214da7db874$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    });
    const muiFormControl = (0, $cfe831b0e6d29047$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === "checkbox" || type === "radio";
    const ownerState = (0, $aJx1R.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $b2ee24326789fbdb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($b2ee24326789fbdb$var$SwitchBaseRoot, (0, $aJx1R.default)({
        component: "span",
        className: (0, $4qr5a.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)($b2ee24326789fbdb$var$SwitchBaseInput, (0, $aJx1R.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === "checkbox" && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $b2ee24326789fbdb$export$2e2bcd8739ae039 = $b2ee24326789fbdb$var$SwitchBase;


parcelRequire("exYeM");

var $bPz57 = parcelRequire("bPz57");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $8bcfc90c1b1c8484$export$2e2bcd8739ae039 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank");


parcelRequire("exYeM");

var $bPz57 = parcelRequire("bPz57");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $a6aa4c477f1ff14b$export$2e2bcd8739ae039 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox");


parcelRequire("exYeM");

var $bPz57 = parcelRequire("bPz57");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $2bb77b8048e42903$export$2e2bcd8739ae039 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");



var $fXwzw = parcelRequire("fXwzw");

var $7PWLt = parcelRequire("7PWLt");

var $jawKn = parcelRequire("jawKn");
var $bJ6Mf = parcelRequire("bJ6Mf");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $c3ca4efec9dc6a49$export$6c57c6e16b4063b(slot) {
    return (0, $dC5O8.default)("MuiCheckbox", slot);
}
const $c3ca4efec9dc6a49$var$checkboxClasses = (0, $kY7HX.default)("MuiCheckbox", [
    "root",
    "checked",
    "disabled",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium"
]);
var $c3ca4efec9dc6a49$export$2e2bcd8739ae039 = $c3ca4efec9dc6a49$var$checkboxClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $71e996631894f6ef$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $71e996631894f6ef$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            indeterminate && "indeterminate",
            `color${(0, $fXwzw.default)(color)}`,
            `size${(0, $fXwzw.default)(size)}`
        ]
    };
    const composedClasses = (0, $2f0D3.default)(slots, (0, $c3ca4efec9dc6a49$export$6c57c6e16b4063b), classes);
    return (0, $aJx1R.default)({}, classes, composedClasses);
};
const $71e996631894f6ef$var$CheckboxRoot = (0, $jawKn.default)((0, $b2ee24326789fbdb$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $bJ6Mf.default)(prop) || prop === "classes",
    name: "MuiCheckbox",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $fXwzw.default)(ownerState.size)}`],
            ownerState.color !== "default" && styles[`color${(0, $fXwzw.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === "default" ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8L988.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $c3ca4efec9dc6a49$export$2e2bcd8739ae039).checked}, &.${(0, $c3ca4efec9dc6a49$export$2e2bcd8739ae039).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $c3ca4efec9dc6a49$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $71e996631894f6ef$var$defaultCheckedIcon = /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a6aa4c477f1ff14b$export$2e2bcd8739ae039), {});
const $71e996631894f6ef$var$defaultIcon = /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8bcfc90c1b1c8484$export$2e2bcd8739ae039), {});
const $71e996631894f6ef$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2bb77b8048e42903$export$2e2bcd8739ae039), {});
const $71e996631894f6ef$var$Checkbox = /*#__PURE__*/ $exYeM.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiCheckbox"
    });
    const { checkedIcon: checkedIcon = $71e996631894f6ef$var$defaultCheckedIcon, color: color = "primary", icon: iconProp = $71e996631894f6ef$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $71e996631894f6ef$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = "medium", className: className } = props, other = (0, $3L80X.default)(props, $71e996631894f6ef$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $aJx1R.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $71e996631894f6ef$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($71e996631894f6ef$var$CheckboxRoot, (0, $aJx1R.default)({
        type: "checkbox",
        inputProps: (0, $aJx1R.default)({
            "data-indeterminate": indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $exYeM.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $exYeM.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $4qr5a.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $71e996631894f6ef$export$2e2bcd8739ae039 = $71e996631894f6ef$var$Checkbox;



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");


var $2f0D3 = parcelRequire("2f0D3");

var $8L988 = parcelRequire("8L988");


var $7PWLt = parcelRequire("7PWLt");

var $aJx1R = parcelRequire("aJx1R");
parcelRequire("exYeM");

parcelRequire("exYeM");

var $bPz57 = parcelRequire("bPz57");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $40b7d9d10f0d8ccd$export$2e2bcd8739ae039 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked");


parcelRequire("exYeM");

var $bPz57 = parcelRequire("bPz57");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $a5b2f2f029ffea70$export$2e2bcd8739ae039 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked");



var $jawKn = parcelRequire("jawKn");
var $bJ6Mf = parcelRequire("bJ6Mf");

var $aSiaI = parcelRequire("aSiaI");
"use client";
const $a50ca3348f4b908b$var$RadioButtonIconRoot = (0, $jawKn.default)("span", {
    shouldForwardProp: (0, $bJ6Mf.default)
})({
    position: "relative",
    display: "flex"
});
const $a50ca3348f4b908b$var$RadioButtonIconBackground = (0, $jawKn.default)((0, $40b7d9d10f0d8ccd$export$2e2bcd8739ae039))({
    // Scale applied to prevent dot misalignment in Safari
    transform: "scale(1)"
});
const $a50ca3348f4b908b$var$RadioButtonIconDot = (0, $jawKn.default)((0, $a5b2f2f029ffea70$export$2e2bcd8739ae039))(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        left: 0,
        position: "absolute",
        transform: "scale(0)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        })
    }, ownerState.checked && {
        transform: "scale(1)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.shortest
        })
    }));
/**
 * @ignore - internal component.
 */ function $a50ca3348f4b908b$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = (0, $aJx1R.default)({}, props, {
        checked: checked
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($a50ca3348f4b908b$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)($a50ca3348f4b908b$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)($a50ca3348f4b908b$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $a50ca3348f4b908b$export$2e2bcd8739ae039 = $a50ca3348f4b908b$var$RadioButtonIcon;



var $fXwzw = parcelRequire("fXwzw");

var $73108beb88437b68$export$2e2bcd8739ae039 = (0, $2fdfe54adbfbf19f$export$2e2bcd8739ae039);



var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
/**
 * @ignore - internal component.
 */ const $3547d9f765ab5e14$var$RadioGroupContext = /*#__PURE__*/ $exYeM.createContext(undefined);
var $3547d9f765ab5e14$export$2e2bcd8739ae039 = $3547d9f765ab5e14$var$RadioGroupContext;


"use client";
function $344f0cf7f499c680$export$2e2bcd8739ae039() {
    return $exYeM.useContext((0, $3547d9f765ab5e14$export$2e2bcd8739ae039));
}



var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $309c6d0eb09b5801$export$192f7b2363c77155(slot) {
    return (0, $dC5O8.default)("MuiRadio", slot);
}
const $309c6d0eb09b5801$var$radioClasses = (0, $kY7HX.default)("MuiRadio", [
    "root",
    "checked",
    "disabled",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall"
]);
var $309c6d0eb09b5801$export$2e2bcd8739ae039 = $309c6d0eb09b5801$var$radioClasses;



var $jawKn = parcelRequire("jawKn");
var $bJ6Mf = parcelRequire("bJ6Mf");

var $aSiaI = parcelRequire("aSiaI");
"use client";
const $ea4cbdb779e4e707$var$_excluded = [
    "checked",
    "checkedIcon",
    "color",
    "icon",
    "name",
    "onChange",
    "size",
    "className"
];
const $ea4cbdb779e4e707$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $fXwzw.default)(color)}`,
            size !== "medium" && `size${(0, $fXwzw.default)(size)}`
        ]
    };
    return (0, $aJx1R.default)({}, classes, (0, $2f0D3.default)(slots, (0, $309c6d0eb09b5801$export$192f7b2363c77155), classes));
};
const $ea4cbdb779e4e707$var$RadioRoot = (0, $jawKn.default)((0, $b2ee24326789fbdb$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $bJ6Mf.default)(prop) || prop === "classes",
    name: "MuiRadio",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== "medium" && styles[`size${(0, $fXwzw.default)(ownerState.size)}`],
            styles[`color${(0, $fXwzw.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === "default" ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8L988.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $309c6d0eb09b5801$export$2e2bcd8739ae039).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        }
    }, {
        [`&.${(0, $309c6d0eb09b5801$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
function $ea4cbdb779e4e707$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $ea4cbdb779e4e707$var$defaultCheckedIcon = /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a50ca3348f4b908b$export$2e2bcd8739ae039), {
    checked: true
});
const $ea4cbdb779e4e707$var$defaultIcon = /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a50ca3348f4b908b$export$2e2bcd8739ae039), {});
const $ea4cbdb779e4e707$var$Radio = /*#__PURE__*/ $exYeM.forwardRef(function Radio(inProps, ref) {
    var _defaultIcon$props$fo, _defaultCheckedIcon$p;
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiRadio"
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $ea4cbdb779e4e707$var$defaultCheckedIcon, color: color = "primary", icon: icon = $ea4cbdb779e4e707$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = "medium", className: className } = props, other = (0, $3L80X.default)(props, $ea4cbdb779e4e707$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        color: color,
        size: size
    });
    const classes = $ea4cbdb779e4e707$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $344f0cf7f499c680$export$2e2bcd8739ae039)();
    let checked = checkedProp;
    const onChange = (0, $73108beb88437b68$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === "undefined") checked = $ea4cbdb779e4e707$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === "undefined") name = radioGroup.name;
    }
    return /*#__PURE__*/ (0, $aSiaI.jsx)($ea4cbdb779e4e707$var$RadioRoot, (0, $aJx1R.default)({
        type: "radio",
        icon: /*#__PURE__*/ $exYeM.cloneElement(icon, {
            fontSize: (_defaultIcon$props$fo = $ea4cbdb779e4e707$var$defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
        }),
        checkedIcon: /*#__PURE__*/ $exYeM.cloneElement(checkedIcon, {
            fontSize: (_defaultCheckedIcon$p = $ea4cbdb779e4e707$var$defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
        }),
        ownerState: ownerState,
        classes: classes,
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref,
        className: (0, $4qr5a.default)(classes.root, className)
    }, other));
});
var $ea4cbdb779e4e707$export$2e2bcd8739ae039 = $ea4cbdb779e4e707$var$Radio;


var $5112857e1bcd1016$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($5112857e1bcd1016$exports, "__esModule", {
    value: true
});
$5112857e1bcd1016$exports.default = void 0;

var $5112857e1bcd1016$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $5112857e1bcd1016$var$_default = $5112857e1bcd1016$exports.default = (0, $5112857e1bcd1016$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8z"
}), "ArrowDownward");


var $8746997fc9b720f2$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($8746997fc9b720f2$exports, "__esModule", {
    value: true
});
$8746997fc9b720f2$exports.default = void 0;

var $8746997fc9b720f2$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $8746997fc9b720f2$var$_default = $8746997fc9b720f2$exports.default = (0, $8746997fc9b720f2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "m10 17 5-5-5-5z"
}), "ArrowRight");


var $60d7d5fa78396591$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($60d7d5fa78396591$exports, "__esModule", {
    value: true
});
$60d7d5fa78396591$exports.default = void 0;

var $60d7d5fa78396591$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $60d7d5fa78396591$var$_default = $60d7d5fa78396591$exports.default = (0, $60d7d5fa78396591$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z"
}), "Cancel");


var $c00d5190e3488a47$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($c00d5190e3488a47$exports, "__esModule", {
    value: true
});
$c00d5190e3488a47$exports.default = void 0;

var $c00d5190e3488a47$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $c00d5190e3488a47$var$_default = $c00d5190e3488a47$exports.default = (0, $c00d5190e3488a47$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "ChevronLeft");


var $dbc6bd8fdc5e4c56$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($dbc6bd8fdc5e4c56$exports, "__esModule", {
    value: true
});
$dbc6bd8fdc5e4c56$exports.default = void 0;

var $dbc6bd8fdc5e4c56$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $dbc6bd8fdc5e4c56$var$_default = $dbc6bd8fdc5e4c56$exports.default = (0, $dbc6bd8fdc5e4c56$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "ChevronRight");


var $43903a21cb6185bc$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($43903a21cb6185bc$exports, "__esModule", {
    value: true
});
$43903a21cb6185bc$exports.default = void 0;

var $43903a21cb6185bc$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $43903a21cb6185bc$var$_default = $43903a21cb6185bc$exports.default = (0, $43903a21cb6185bc$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M5 13h14v-2H5zm-2 4h14v-2H3zM7 7v2h14V7z"
}), "ClearAll");


var $83d99ee14fb596ff$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($83d99ee14fb596ff$exports, "__esModule", {
    value: true
});
$83d99ee14fb596ff$exports.default = void 0;

var $83d99ee14fb596ff$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $83d99ee14fb596ff$var$_default = $83d99ee14fb596ff$exports.default = (0, $83d99ee14fb596ff$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");


var $0e1f814edd2464e7$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($0e1f814edd2464e7$exports, "__esModule", {
    value: true
});
$0e1f814edd2464e7$exports.default = void 0;

var $0e1f814edd2464e7$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $0e1f814edd2464e7$var$_default = $0e1f814edd2464e7$exports.default = (0, $0e1f814edd2464e7$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), "ContentCopy");


var $2b42a4e3efe19567$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($2b42a4e3efe19567$exports, "__esModule", {
    value: true
});
$2b42a4e3efe19567$exports.default = void 0;

var $2b42a4e3efe19567$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $2b42a4e3efe19567$var$_default = $2b42a4e3efe19567$exports.default = (0, $2b42a4e3efe19567$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M3 3h18v2H3zm0 16h18v2H3z"
}), "DensityLarge");


var $4ddc56ce752c5656$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($4ddc56ce752c5656$exports, "__esModule", {
    value: true
});
$4ddc56ce752c5656$exports.default = void 0;

var $4ddc56ce752c5656$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $4ddc56ce752c5656$var$_default = $4ddc56ce752c5656$exports.default = (0, $4ddc56ce752c5656$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M3 3h18v2H3zm0 16h18v2H3zm0-8h18v2H3z"
}), "DensityMedium");


var $dcb9363effa006b6$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($dcb9363effa006b6$exports, "__esModule", {
    value: true
});
$dcb9363effa006b6$exports.default = void 0;

var $dcb9363effa006b6$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $dcb9363effa006b6$var$_default = $dcb9363effa006b6$exports.default = (0, $dcb9363effa006b6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M3 2h18v2H3zm0 18h18v2H3zm0-6h18v2H3zm0-6h18v2H3z"
}), "DensitySmall");


var $977fba31f26be5c0$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($977fba31f26be5c0$exports, "__esModule", {
    value: true
});
$977fba31f26be5c0$exports.default = void 0;

var $977fba31f26be5c0$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $977fba31f26be5c0$var$_default = $977fba31f26be5c0$exports.default = (0, $977fba31f26be5c0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M20 9H4v2h16zM4 15h16v-2H4z"
}), "DragHandle");


var $ac0d67057d1a5411$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($ac0d67057d1a5411$exports, "__esModule", {
    value: true
});
$ac0d67057d1a5411$exports.default = void 0;

var $ac0d67057d1a5411$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $ac0d67057d1a5411$var$_default = $ac0d67057d1a5411$exports.default = (0, $ac0d67057d1a5411$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
        d: "M8 8H6v7c0 1.1.9 2 2 2h9v-2H8z"
    }, "0"),
    /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
        d: "M20 3h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 8h-8V7h8zM4 12H2v7c0 1.1.9 2 2 2h9v-2H4z"
    }, "1")
], "DynamicFeed");


var $5b7579778695630b$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($5b7579778695630b$exports, "__esModule", {
    value: true
});
$5b7579778695630b$exports.default = void 0;

var $5b7579778695630b$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $5b7579778695630b$var$_default = $5b7579778695630b$exports.default = (0, $5b7579778695630b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), "Edit");


var $f886b3fb8270265c$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($f886b3fb8270265c$exports, "__esModule", {
    value: true
});
$f886b3fb8270265c$exports.default = void 0;

var $f886b3fb8270265c$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $f886b3fb8270265c$var$_default = $f886b3fb8270265c$exports.default = (0, $f886b3fb8270265c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");


var $7938f397ab0081b0$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($7938f397ab0081b0$exports, "__esModule", {
    value: true
});
$7938f397ab0081b0$exports.default = void 0;

var $7938f397ab0081b0$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $7938f397ab0081b0$var$_default = $7938f397ab0081b0$exports.default = (0, $7938f397ab0081b0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61"
}), "FilterAlt");


var $c65a30dfed2635c2$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($c65a30dfed2635c2$exports, "__esModule", {
    value: true
});
$c65a30dfed2635c2$exports.default = void 0;

var $c65a30dfed2635c2$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $c65a30dfed2635c2$var$_default = $c65a30dfed2635c2$exports.default = (0, $c65a30dfed2635c2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M10 18h4v-2h-4zM3 6v2h18V6zm3 7h12v-2H6z"
}), "FilterList");


var $52443ec225efd215$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($52443ec225efd215$exports, "__esModule", {
    value: true
});
$52443ec225efd215$exports.default = void 0;

var $52443ec225efd215$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $52443ec225efd215$var$_default = $52443ec225efd215$exports.default = (0, $52443ec225efd215$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M10.83 8H21V6H8.83zm5 5H18v-2h-4.17zM14 16.83V18h-4v-2h3.17l-3-3H6v-2h2.17l-3-3H3V6h.17L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41z"
}), "FilterListOff");


var $a58df43394eb0c4a$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($a58df43394eb0c4a$exports, "__esModule", {
    value: true
});
$a58df43394eb0c4a$exports.default = void 0;

var $a58df43394eb0c4a$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $a58df43394eb0c4a$var$_default = $a58df43394eb0c4a$exports.default = (0, $a58df43394eb0c4a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M18.41 16.59 13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage");


var $46d363505ccc3709$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($46d363505ccc3709$exports, "__esModule", {
    value: true
});
$46d363505ccc3709$exports.default = void 0;

var $46d363505ccc3709$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $46d363505ccc3709$var$_default = $46d363505ccc3709$exports.default = (0, $46d363505ccc3709$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M7 14H5v5h5v-2H7zm-2-4h2V7h3V5H5zm12 7h-3v2h5v-5h-2zM14 5v2h3v3h2V5z"
}), "Fullscreen");


var $6db53a4a680131b0$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($6db53a4a680131b0$exports, "__esModule", {
    value: true
});
$6db53a4a680131b0$exports.default = void 0;

var $6db53a4a680131b0$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $6db53a4a680131b0$var$_default = $6db53a4a680131b0$exports.default = (0, $6db53a4a680131b0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"
}), "FullscreenExit");


var $7cbf90241dfcba43$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($7cbf90241dfcba43$exports, "__esModule", {
    value: true
});
$7cbf90241dfcba43$exports.default = void 0;

var $7cbf90241dfcba43$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $7cbf90241dfcba43$var$_default = $7cbf90241dfcba43$exports.default = (0, $7cbf90241dfcba43$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
        d: "M18 6.41 16.59 5 12 9.58 7.41 5 6 6.41l6 6z"
    }, "0"),
    /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
        d: "m18 13-1.41-1.41L12 16.17l-4.59-4.58L6 13l6 6z"
    }, "1")
], "KeyboardDoubleArrowDown");


var $3403bd974326352d$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($3403bd974326352d$exports, "__esModule", {
    value: true
});
$3403bd974326352d$exports.default = void 0;

var $3403bd974326352d$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $3403bd974326352d$var$_default = $3403bd974326352d$exports.default = (0, $3403bd974326352d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M5.59 7.41 10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage");


var $a791bfd60ccffe5c$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($a791bfd60ccffe5c$exports, "__esModule", {
    value: true
});
$a791bfd60ccffe5c$exports.default = void 0;

var $a791bfd60ccffe5c$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $a791bfd60ccffe5c$var$_default = $a791bfd60ccffe5c$exports.default = (0, $a791bfd60ccffe5c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), "MoreHoriz");


var $77da07cd8804c984$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($77da07cd8804c984$exports, "__esModule", {
    value: true
});
$77da07cd8804c984$exports.default = void 0;

var $77da07cd8804c984$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $77da07cd8804c984$var$_default = $77da07cd8804c984$exports.default = (0, $77da07cd8804c984$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), "MoreVert");


var $660ec9bb22541201$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($660ec9bb22541201$exports, "__esModule", {
    value: true
});
$660ec9bb22541201$exports.default = void 0;

var $660ec9bb22541201$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $660ec9bb22541201$var$_default = $660ec9bb22541201$exports.default = (0, $660ec9bb22541201$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    fillRule: "evenodd",
    d: "M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3"
}), "PushPin");


var $a8ef35a31ad13503$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($a8ef35a31ad13503$exports, "__esModule", {
    value: true
});
$a8ef35a31ad13503$exports.default = void 0;

var $a8ef35a31ad13503$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $a8ef35a31ad13503$var$_default = $a8ef35a31ad13503$exports.default = (0, $a8ef35a31ad13503$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M12 5V2L8 6l4 4V7c3.31 0 6 2.69 6 6 0 2.97-2.17 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93 0-4.42-3.58-8-8-8m-6 8c0-1.65.67-3.15 1.76-4.24L6.34 7.34C4.9 8.79 4 10.79 4 13c0 4.08 3.05 7.44 7 7.93v-2.02c-2.83-.48-5-2.94-5-5.91"
}), "RestartAlt");


var $8a674ab1ec556e2e$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($8a674ab1ec556e2e$exports, "__esModule", {
    value: true
});
$8a674ab1ec556e2e$exports.default = void 0;

var $8a674ab1ec556e2e$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $8a674ab1ec556e2e$var$_default = $8a674ab1ec556e2e$exports.default = (0, $8a674ab1ec556e2e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3m3-10H5V5h10z"
}), "Save");


var $e0daa6fa57c30cfa$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($e0daa6fa57c30cfa$exports, "__esModule", {
    value: true
});
$e0daa6fa57c30cfa$exports.default = void 0;

var $e0daa6fa57c30cfa$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $e0daa6fa57c30cfa$var$_default = $e0daa6fa57c30cfa$exports.default = (0, $e0daa6fa57c30cfa$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), "Search");


var $747857be872ace67$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($747857be872ace67$exports, "__esModule", {
    value: true
});
$747857be872ace67$exports.default = void 0;

var $747857be872ace67$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $747857be872ace67$var$_default = $747857be872ace67$exports.default = (0, $747857be872ace67$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
        d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3 6.08 3 3.28 5.64 3.03 9h2.02C5.3 6.75 7.18 5 9.5 5 11.99 5 14 7.01 14 9.5S11.99 14 9.5 14c-.17 0-.33-.03-.5-.05v2.02c.17.02.33.03.5.03 1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19z"
    }, "0"),
    /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
        d: "M6.47 10.82 4 13.29l-2.47-2.47-.71.71L3.29 14 .82 16.47l.71.71L4 14.71l2.47 2.47.71-.71L4.71 14l2.47-2.47z"
    }, "1")
], "SearchOff");


var $cd936e4c5bed64be$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($cd936e4c5bed64be$exports, "__esModule", {
    value: true
});
$cd936e4c5bed64be$exports.default = void 0;

var $cd936e4c5bed64be$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $cd936e4c5bed64be$var$_default = $cd936e4c5bed64be$exports.default = (0, $cd936e4c5bed64be$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M3 18h6v-2H3zM3 6v2h18V6zm0 7h12v-2H3z"
}), "Sort");


var $c316df7762e301fb$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($c316df7762e301fb$exports, "__esModule", {
    value: true
});
$c316df7762e301fb$exports.default = void 0;

var $c316df7762e301fb$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $c316df7762e301fb$var$_default = $c316df7762e301fb$exports.default = (0, $c316df7762e301fb$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "m18 12 4-4-4-4v3H3v2h15zM6 12l-4 4 4 4v-3h15v-2H6z"
}), "SyncAlt");


var $b05df11e888ab937$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($b05df11e888ab937$exports, "__esModule", {
    value: true
});
$b05df11e888ab937$exports.default = void 0;

var $b05df11e888ab937$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $b05df11e888ab937$var$_default = $b05df11e888ab937$exports.default = (0, $b05df11e888ab937$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M14.67 5v14H9.33V5zm1 14H21V5h-5.33zm-7.34 0V5H3v14z"
}), "ViewColumn");


var $4d9db64c414b25e1$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($4d9db64c414b25e1$exports, "__esModule", {
    value: true
});
$4d9db64c414b25e1$exports.default = void 0;

var $4d9db64c414b25e1$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $4d9db64c414b25e1$var$_default = $4d9db64c414b25e1$exports.default = (0, $4d9db64c414b25e1$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7M2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2m4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3z"
}), "VisibilityOff");


function $74e607428ccb05fe$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = opts.initialDeps ?? [];
    let result;
    return ()=>{
        var _a, _b, _c, _d;
        let depTime;
        if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
        result = fn(...newDeps);
        if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
            const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            const resultFpsPercentage = resultEndTime / 16;
            const pad = (str, num)=>{
                str = String(str);
                while(str.length < num)str = " " + str;
                return str;
            };
            console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
        }
        (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
        return result;
    };
}
function $74e607428ccb05fe$export$9a1adf421b69c6a(value, msg) {
    if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
    else return value;
}
const $74e607428ccb05fe$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1;


const $fc28b436a2e934e3$export$76974b428a49f15b = (index)=>index;
const $fc28b436a2e934e3$export$7eb7cb13fd21e5e1 = (range)=>{
    const start = Math.max(range.startIndex - range.overscan, 0);
    const end = Math.min(range.endIndex + range.overscan, range.count - 1);
    const arr = [];
    for(let i = start; i <= end; i++)arr.push(i);
    return arr;
};
const $fc28b436a2e934e3$export$5a50ff2cde8c3802 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = (rect)=>{
        const { width: width, height: height } = rect;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler(element.getBoundingClientRect());
    if (typeof ResizeObserver === "undefined") return ()=>{};
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        if (entry == null ? void 0 : entry.borderBoxSize) {
            const box = entry.borderBoxSize[0];
            if (box) {
                handler({
                    width: box.inlineSize,
                    height: box.blockSize
                });
                return;
            }
        }
        handler(element.getBoundingClientRect());
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>{
        observer.unobserve(element);
    };
};
const $fc28b436a2e934e3$export$e911b82c7a99311 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener("resize", handler, {
        passive: true
    });
    return ()=>{
        element.removeEventListener("resize", handler);
    };
};
const $fc28b436a2e934e3$export$fbc040aee017375a = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb(element[instance.options.horizontal ? "scrollLeft" : "scrollTop"]);
    };
    handler();
    element.addEventListener("scroll", handler, {
        passive: true
    });
    return ()=>{
        element.removeEventListener("scroll", handler);
    };
};
const $fc28b436a2e934e3$export$518998f8c5d09287 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb(element[instance.options.horizontal ? "scrollX" : "scrollY"]);
    };
    handler();
    element.addEventListener("scroll", handler, {
        passive: true
    });
    return ()=>{
        element.removeEventListener("scroll", handler);
    };
};
const $fc28b436a2e934e3$export$6aa9c23c0f5932af = (element, entry, instance)=>{
    if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
            const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
            return size;
        }
    }
    return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
};
const $fc28b436a2e934e3$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
const $fc28b436a2e934e3$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
class $fc28b436a2e934e3$export$89be5a243e59c4b2 {
    constructor(opts){
        this.unsubs = [];
        this.scrollElement = null;
        this.isScrolling = false;
        this.isScrollingTimeoutId = null;
        this.scrollToIndexTimeoutId = null;
        this.measurementsCache = [];
        this.itemSizeCache = /* @__PURE__ */ new Map();
        this.pendingMeasuredCacheIndexes = [];
        this.scrollDirection = null;
        this.scrollAdjustments = 0;
        this.measureElementCache = /* @__PURE__ */ new Map();
        this.observer = /* @__PURE__ */ (()=>{
            let _ro = null;
            const get = ()=>{
                if (_ro) return _ro;
                else if (typeof ResizeObserver !== "undefined") return _ro = new ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        this._measureElement(entry.target, entry);
                    });
                });
                else return null;
            };
            return {
                disconnect: ()=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.disconnect();
                },
                observe: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.observe(target, {
                        box: "border-box"
                    });
                },
                unobserve: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.unobserve(target);
                }
            };
        })();
        this.range = null;
        this.setOptions = (opts2)=>{
            Object.entries(opts2).forEach(([key, value])=>{
                if (typeof value === "undefined") delete opts2[key];
            });
            this.options = {
                debug: false,
                initialOffset: 0,
                overscan: 1,
                paddingStart: 0,
                paddingEnd: 0,
                scrollPaddingStart: 0,
                scrollPaddingEnd: 0,
                horizontal: false,
                getItemKey: $fc28b436a2e934e3$export$76974b428a49f15b,
                rangeExtractor: $fc28b436a2e934e3$export$7eb7cb13fd21e5e1,
                onChange: ()=>{},
                measureElement: $fc28b436a2e934e3$export$6aa9c23c0f5932af,
                initialRect: {
                    width: 0,
                    height: 0
                },
                scrollMargin: 0,
                scrollingDelay: 150,
                indexAttribute: "data-index",
                initialMeasurementsCache: [],
                lanes: 1,
                ...opts2
            };
        };
        this.notify = (sync)=>{
            var _a, _b;
            (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
        };
        this.maybeNotify = (0, $74e607428ccb05fe$export$7c73462e0d25e514)(()=>{
            this.calculateRange();
            return [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ];
        }, (isScrolling)=>{
            this.notify(isScrolling);
        }, {
            key: false,
            debug: ()=>this.options.debug,
            initialDeps: [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ]
        });
        this.cleanup = ()=>{
            this.unsubs.filter(Boolean).forEach((d)=>d());
            this.unsubs = [];
            this.scrollElement = null;
        };
        this._didMount = ()=>{
            this.measureElementCache.forEach(this.observer.observe);
            return ()=>{
                this.observer.disconnect();
                this.cleanup();
            };
        };
        this._willUpdate = ()=>{
            const scrollElement = this.options.getScrollElement();
            if (this.scrollElement !== scrollElement) {
                this.cleanup();
                this.scrollElement = scrollElement;
                this._scrollToOffset(this.scrollOffset, {
                    adjustments: void 0,
                    behavior: void 0
                });
                this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                    this.scrollRect = rect;
                    this.maybeNotify();
                }));
                this.unsubs.push(this.options.observeElementOffset(this, (offset)=>{
                    this.scrollAdjustments = 0;
                    if (this.scrollOffset === offset) return;
                    if (this.isScrollingTimeoutId !== null) {
                        clearTimeout(this.isScrollingTimeoutId);
                        this.isScrollingTimeoutId = null;
                    }
                    this.isScrolling = true;
                    this.scrollDirection = this.scrollOffset < offset ? "forward" : "backward";
                    this.scrollOffset = offset;
                    this.maybeNotify();
                    this.isScrollingTimeoutId = setTimeout(()=>{
                        this.isScrollingTimeoutId = null;
                        this.isScrolling = false;
                        this.scrollDirection = null;
                        this.maybeNotify();
                    }, this.options.scrollingDelay);
                }));
            }
        };
        this.getSize = ()=>{
            return this.scrollRect[this.options.horizontal ? "width" : "height"];
        };
        this.memoOptions = (0, $74e607428ccb05fe$export$7c73462e0d25e514)(()=>[
                this.options.count,
                this.options.paddingStart,
                this.options.scrollMargin,
                this.options.getItemKey
            ], (count, paddingStart, scrollMargin, getItemKey)=>{
            this.pendingMeasuredCacheIndexes = [];
            return {
                count: count,
                paddingStart: paddingStart,
                scrollMargin: scrollMargin,
                getItemKey: getItemKey
            };
        }, {
            key: false
        });
        this.getFurthestMeasurement = (measurements, index)=>{
            const furthestMeasurementsFound = /* @__PURE__ */ new Map();
            const furthestMeasurements = /* @__PURE__ */ new Map();
            for(let m = index - 1; m >= 0; m--){
                const measurement = measurements[m];
                if (furthestMeasurementsFound.has(measurement.lane)) continue;
                const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                if (furthestMeasurementsFound.size === this.options.lanes) break;
            }
            return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                if (a.end === b.end) return a.index - b.index;
                return a.end - b.end;
            })[0] : void 0;
        };
        this.getMeasurements = (0, $74e607428ccb05fe$export$7c73462e0d25e514)(()=>[
                this.memoOptions(),
                this.itemSizeCache
            ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey }, itemSizeCache)=>{
            const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
            this.pendingMeasuredCacheIndexes = [];
            const measurements = this.measurementsCache.slice(0, min);
            for(let i = min; i < count; i++){
                const key = getItemKey(i);
                const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                const start = furthestMeasurement ? furthestMeasurement.end : paddingStart + scrollMargin;
                const measuredSize = itemSizeCache.get(key);
                const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                const end = start + size;
                const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                measurements[i] = {
                    index: i,
                    start: start,
                    size: size,
                    end: end,
                    key: key,
                    lane: lane
                };
            }
            this.measurementsCache = measurements;
            return measurements;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.calculateRange = (0, $74e607428ccb05fe$export$7c73462e0d25e514)(()=>[
                this.getMeasurements(),
                this.getSize(),
                this.scrollOffset
            ], (measurements, outerSize, scrollOffset)=>{
            return this.range = measurements.length > 0 && outerSize > 0 ? $fc28b436a2e934e3$var$calculateRange({
                measurements: measurements,
                outerSize: outerSize,
                scrollOffset: scrollOffset
            }) : null;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getIndexes = (0, $74e607428ccb05fe$export$7c73462e0d25e514)(()=>[
                this.options.rangeExtractor,
                this.calculateRange(),
                this.options.overscan,
                this.options.count
            ], (rangeExtractor, range, overscan, count)=>{
            return range === null ? [] : rangeExtractor({
                ...range,
                overscan: overscan,
                count: count
            });
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.indexFromElement = (node)=>{
            const attributeName = this.options.indexAttribute;
            const indexStr = node.getAttribute(attributeName);
            if (!indexStr) {
                console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                return -1;
            }
            return parseInt(indexStr, 10);
        };
        this._measureElement = (node, entry)=>{
            const item = this.measurementsCache[this.indexFromElement(node)];
            if (!item || !node.isConnected) {
                this.measureElementCache.forEach((cached, key)=>{
                    if (cached === node) {
                        this.observer.unobserve(node);
                        this.measureElementCache.delete(key);
                    }
                });
                return;
            }
            const prevNode = this.measureElementCache.get(item.key);
            if (prevNode !== node) {
                if (prevNode) this.observer.unobserve(prevNode);
                this.observer.observe(node);
                this.measureElementCache.set(item.key, node);
            }
            const measuredItemSize = this.options.measureElement(node, entry, this);
            this.resizeItem(item, measuredItemSize);
        };
        this.resizeItem = (item, size)=>{
            const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
            const delta = size - itemSize;
            if (delta !== 0) {
                if (item.start < this.scrollOffset + this.scrollAdjustments) this._scrollToOffset(this.scrollOffset, {
                    adjustments: this.scrollAdjustments += delta,
                    behavior: void 0
                });
                this.pendingMeasuredCacheIndexes.push(item.index);
                this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                this.notify(false);
            }
        };
        this.measureElement = (node)=>{
            if (!node) return;
            this._measureElement(node, void 0);
        };
        this.getVirtualItems = (0, $74e607428ccb05fe$export$7c73462e0d25e514)(()=>[
                this.getIndexes(),
                this.getMeasurements()
            ], (indexes, measurements)=>{
            const virtualItems = [];
            for(let k = 0, len = indexes.length; k < len; k++){
                const i = indexes[k];
                const measurement = measurements[i];
                virtualItems.push(measurement);
            }
            return virtualItems;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualItemForOffset = (offset)=>{
            const measurements = this.getMeasurements();
            return (0, $74e607428ccb05fe$export$9a1adf421b69c6a)(measurements[$fc28b436a2e934e3$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, $74e607428ccb05fe$export$9a1adf421b69c6a)(measurements[index]).start, offset)]);
        };
        this.getOffsetForAlignment = (toOffset, align)=>{
            const size = this.getSize();
            if (align === "auto") {
                if (toOffset <= this.scrollOffset) align = "start";
                else if (toOffset >= this.scrollOffset + size) align = "end";
                else align = "start";
            }
            if (align === "start") toOffset;
            else if (align === "end") toOffset = toOffset - size;
            else if (align === "center") toOffset = toOffset - size / 2;
            const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
            const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
            const maxOffset = scrollSize - this.getSize();
            return Math.max(Math.min(maxOffset, toOffset), 0);
        };
        this.getOffsetForIndex = (index, align = "auto")=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const measurement = (0, $74e607428ccb05fe$export$9a1adf421b69c6a)(this.getMeasurements()[index]);
            if (align === "auto") {
                if (measurement.end >= this.scrollOffset + this.getSize() - this.options.scrollPaddingEnd) align = "end";
                else if (measurement.start <= this.scrollOffset + this.options.scrollPaddingStart) align = "start";
                else return [
                    this.scrollOffset,
                    align
                ];
            }
            const toOffset = align === "end" ? measurement.end + this.options.scrollPaddingEnd : measurement.start - this.options.scrollPaddingStart;
            return [
                this.getOffsetForAlignment(toOffset, align),
                align
            ];
        };
        this.isDynamicMode = ()=>this.measureElementCache.size > 0;
        this.cancelScrollToIndex = ()=>{
            if (this.scrollToIndexTimeoutId !== null) {
                clearTimeout(this.scrollToIndexTimeoutId);
                this.scrollToIndexTimeoutId = null;
            }
        };
        this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            const [toOffset, align] = this.getOffsetForIndex(index, initialAlign);
            this._scrollToOffset(toOffset, {
                adjustments: void 0,
                behavior: behavior
            });
            if (behavior !== "smooth" && this.isDynamicMode()) this.scrollToIndexTimeoutId = setTimeout(()=>{
                this.scrollToIndexTimeoutId = null;
                const elementInDOM = this.measureElementCache.has(this.options.getItemKey(index));
                if (elementInDOM) {
                    const [toOffset2] = this.getOffsetForIndex(index, align);
                    if (!(0, $74e607428ccb05fe$export$8a4f1dcc58a69dbd)(toOffset2, this.scrollOffset)) this.scrollToIndex(index, {
                        align: align,
                        behavior: behavior
                    });
                } else this.scrollToIndex(index, {
                    align: align,
                    behavior: behavior
                });
            });
        };
        this.scrollBy = (delta, { behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.scrollOffset + delta, {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.getTotalSize = ()=>{
            var _a;
            const measurements = this.getMeasurements();
            let end;
            if (measurements.length === 0) end = this.options.paddingStart;
            else end = this.options.lanes === 1 ? ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0 : Math.max(...measurements.slice(-this.options.lanes).map((m)=>m.end));
            return end - this.options.scrollMargin + this.options.paddingEnd;
        };
        this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
            this.options.scrollToFn(offset, {
                behavior: behavior,
                adjustments: adjustments
            }, this);
        };
        this.measure = ()=>{
            this.itemSizeCache = /* @__PURE__ */ new Map();
            this.notify(false);
        };
        this.setOptions(opts);
        this.scrollRect = this.options.initialRect;
        this.scrollOffset = this.options.initialOffset;
        this.measurementsCache = this.options.initialMeasurementsCache;
        this.measurementsCache.forEach((item)=>{
            this.itemSizeCache.set(item.key, item.size);
        });
        this.maybeNotify();
    }
}
const $fc28b436a2e934e3$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $fc28b436a2e934e3$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset }) {
    const count = measurements.length - 1;
    const getOffset = (index)=>measurements[index].start;
    const startIndex = $fc28b436a2e934e3$var$findNearestBinarySearch(0, count, getOffset, scrollOffset);
    let endIndex = startIndex;
    while(endIndex < count && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}


var $exYeM = parcelRequire("exYeM");


const $baed1bf71a18e800$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $exYeM.useLayoutEffect : $exYeM.useEffect;
function $baed1bf71a18e800$var$useVirtualizerBase(options) {
    const rerender = $exYeM.useReducer(()=>({}), {})[1];
    const resolvedOptions = {
        ...options,
        onChange: (instance2, sync)=>{
            var _a;
            if (sync) (0, $97dc602bd7e23afa$exports.flushSync)(rerender);
            else rerender();
            (_a = options.onChange) == null || _a.call(options, instance2, sync);
        }
    };
    const [instance] = $exYeM.useState(()=>new (0, $fc28b436a2e934e3$export$89be5a243e59c4b2)(resolvedOptions));
    instance.setOptions(resolvedOptions);
    $exYeM.useEffect(()=>{
        return instance._didMount();
    }, []);
    $baed1bf71a18e800$var$useIsomorphicLayoutEffect(()=>{
        return instance._willUpdate();
    });
    return instance;
}
function $baed1bf71a18e800$export$dd6d526d88b5a137(options) {
    return $baed1bf71a18e800$var$useVirtualizerBase({
        observeElementRect: $fc28b436a2e934e3$export$5a50ff2cde8c3802,
        observeElementOffset: $fc28b436a2e934e3$export$fbc040aee017375a,
        scrollToFn: (0, $fc28b436a2e934e3$export$1cdb988e5ab69fe7),
        ...options
    });
}
function $baed1bf71a18e800$export$645722dcac657cb9(options) {
    return $baed1bf71a18e800$var$useVirtualizerBase({
        getScrollElement: ()=>typeof document !== "undefined" ? window : null,
        observeElementRect: (0, $fc28b436a2e934e3$export$e911b82c7a99311),
        observeElementOffset: (0, $fc28b436a2e934e3$export$518998f8c5d09287),
        scrollToFn: (0, $fc28b436a2e934e3$export$2162c5b3eeedd27),
        initialOffset: typeof document !== "undefined" ? window.scrollY : void 0,
        ...options
    });
}




var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $7PWLt = parcelRequire("7PWLt");

var $jawKn = parcelRequire("jawKn");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $97a33f032858372c$export$eed427986a7abdf9(slot) {
    return (0, $dC5O8.default)("MuiTableContainer", slot);
}
const $97a33f032858372c$var$tableContainerClasses = (0, $kY7HX.default)("MuiTableContainer", [
    "root"
]);
var $97a33f032858372c$export$2e2bcd8739ae039 = $97a33f032858372c$var$tableContainerClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $7c647d032b5c1ce4$var$_excluded = [
    "className",
    "component"
];
const $7c647d032b5c1ce4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $97a33f032858372c$export$eed427986a7abdf9), classes);
};
const $7c647d032b5c1ce4$var$TableContainerRoot = (0, $jawKn.default)("div", {
    name: "MuiTableContainer",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    width: "100%",
    overflowX: "auto"
});
const $7c647d032b5c1ce4$var$TableContainer = /*#__PURE__*/ $exYeM.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiTableContainer"
    });
    const { className: className, component: component = "div" } = props, other = (0, $3L80X.default)(props, $7c647d032b5c1ce4$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        component: component
    });
    const classes = $7c647d032b5c1ce4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($7c647d032b5c1ce4$var$TableContainerRoot, (0, $aJx1R.default)({
        ref: ref,
        as: component,
        className: (0, $4qr5a.default)(classes.root, className),
        ownerState: ownerState
    }, other));
});
var $7c647d032b5c1ce4$export$2e2bcd8739ae039 = $7c647d032b5c1ce4$var$TableContainer;



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $exYeM = parcelRequire("exYeM");
"use client";
/**
 * @ignore - internal component.
 */ const $38dfa640c5e1d9db$var$TableContext = /*#__PURE__*/ $exYeM.createContext();
var $38dfa640c5e1d9db$export$2e2bcd8739ae039 = $38dfa640c5e1d9db$var$TableContext;



var $7PWLt = parcelRequire("7PWLt");

var $jawKn = parcelRequire("jawKn");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $f6aca33267f66541$export$315cb19215f77ce0(slot) {
    return (0, $dC5O8.default)("MuiTable", slot);
}
const $f6aca33267f66541$var$tableClasses = (0, $kY7HX.default)("MuiTable", [
    "root",
    "stickyHeader"
]);
var $f6aca33267f66541$export$2e2bcd8739ae039 = $f6aca33267f66541$var$tableClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $f486dbc13fd8431d$var$_excluded = [
    "className",
    "component",
    "padding",
    "size",
    "stickyHeader"
];
const $f486dbc13fd8431d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            "root",
            stickyHeader && "stickyHeader"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $f6aca33267f66541$export$315cb19215f77ce0), classes);
};
const $f486dbc13fd8431d$var$TableRoot = (0, $jawKn.default)("table", {
    name: "MuiTable",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        display: "table",
        width: "100%",
        borderCollapse: "collapse",
        borderSpacing: 0,
        "& caption": (0, $aJx1R.default)({}, theme.typography.body2, {
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: "left",
            captionSide: "bottom"
        })
    }, ownerState.stickyHeader && {
        borderCollapse: "separate"
    }));
const $f486dbc13fd8431d$var$defaultComponent = "table";
const $f486dbc13fd8431d$var$Table = /*#__PURE__*/ $exYeM.forwardRef(function Table(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiTable"
    });
    const { className: className, component: component = $f486dbc13fd8431d$var$defaultComponent, padding: padding = "normal", size: size = "medium", stickyHeader: stickyHeader = false } = props, other = (0, $3L80X.default)(props, $f486dbc13fd8431d$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    });
    const classes = $f486dbc13fd8431d$var$useUtilityClasses(ownerState);
    const table = $exYeM.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $38dfa640c5e1d9db$export$2e2bcd8739ae039).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($f486dbc13fd8431d$var$TableRoot, (0, $aJx1R.default)({
            as: component,
            role: component === $f486dbc13fd8431d$var$defaultComponent ? null : "table",
            ref: ref,
            className: (0, $4qr5a.default)(classes.root, className),
            ownerState: ownerState
        }, other))
    });
});
var $f486dbc13fd8431d$export$2e2bcd8739ae039 = $f486dbc13fd8431d$var$Table;



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $exYeM = parcelRequire("exYeM");
/**
 * @ignore - internal component.
 */ const $1f71b295686f1b15$var$Tablelvl2Context = /*#__PURE__*/ $exYeM.createContext();
var $1f71b295686f1b15$export$2e2bcd8739ae039 = $1f71b295686f1b15$var$Tablelvl2Context;



var $7PWLt = parcelRequire("7PWLt");

var $jawKn = parcelRequire("jawKn");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $9c81723a0652f2c5$export$98bd2a9b566ec665(slot) {
    return (0, $dC5O8.default)("MuiTableBody", slot);
}
const $9c81723a0652f2c5$var$tableBodyClasses = (0, $kY7HX.default)("MuiTableBody", [
    "root"
]);
var $9c81723a0652f2c5$export$2e2bcd8739ae039 = $9c81723a0652f2c5$var$tableBodyClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $e5ef275ef7d6f0a3$var$_excluded = [
    "className",
    "component"
];
const $e5ef275ef7d6f0a3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $9c81723a0652f2c5$export$98bd2a9b566ec665), classes);
};
const $e5ef275ef7d6f0a3$var$TableBodyRoot = (0, $jawKn.default)("tbody", {
    name: "MuiTableBody",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "table-row-group"
});
const $e5ef275ef7d6f0a3$var$tablelvl2 = {
    variant: "body"
};
const $e5ef275ef7d6f0a3$var$defaultComponent = "tbody";
const $e5ef275ef7d6f0a3$var$TableBody = /*#__PURE__*/ $exYeM.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiTableBody"
    });
    const { className: className, component: component = $e5ef275ef7d6f0a3$var$defaultComponent } = props, other = (0, $3L80X.default)(props, $e5ef275ef7d6f0a3$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        component: component
    });
    const classes = $e5ef275ef7d6f0a3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1f71b295686f1b15$export$2e2bcd8739ae039).Provider, {
        value: $e5ef275ef7d6f0a3$var$tablelvl2,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($e5ef275ef7d6f0a3$var$TableBodyRoot, (0, $aJx1R.default)({
            className: (0, $4qr5a.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $e5ef275ef7d6f0a3$var$defaultComponent ? null : "rowgroup",
            ownerState: ownerState
        }, other))
    });
});
var $e5ef275ef7d6f0a3$export$2e2bcd8739ae039 = $e5ef275ef7d6f0a3$var$TableBody;




var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $8L988 = parcelRequire("8L988");


var $7PWLt = parcelRequire("7PWLt");

var $jawKn = parcelRequire("jawKn");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $4a45a8a97f2f0865$export$ba0a6d6c28940107(slot) {
    return (0, $dC5O8.default)("MuiTableRow", slot);
}
const $4a45a8a97f2f0865$var$tableRowClasses = (0, $kY7HX.default)("MuiTableRow", [
    "root",
    "selected",
    "hover",
    "head",
    "footer"
]);
var $4a45a8a97f2f0865$export$2e2bcd8739ae039 = $4a45a8a97f2f0865$var$tableRowClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $73c633ff2ee7f4a0$var$_excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const $73c633ff2ee7f4a0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected",
            hover && "hover",
            head && "head",
            footer && "footer"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $4a45a8a97f2f0865$export$ba0a6d6c28940107), classes);
};
const $73c633ff2ee7f4a0$var$TableRowRoot = (0, $jawKn.default)("tr", {
    name: "MuiTableRow",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme: theme })=>({
        color: "inherit",
        display: "table-row",
        verticalAlign: "middle",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $4a45a8a97f2f0865$export$2e2bcd8739ae039).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $4a45a8a97f2f0865$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $8L988.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $8L988.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const $73c633ff2ee7f4a0$var$defaultComponent = "tr";
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $73c633ff2ee7f4a0$var$TableRow = /*#__PURE__*/ $exYeM.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiTableRow"
    });
    const { className: className, component: component = $73c633ff2ee7f4a0$var$defaultComponent, hover: hover = false, selected: selected = false } = props, other = (0, $3L80X.default)(props, $73c633ff2ee7f4a0$var$_excluded);
    const tablelvl2 = $exYeM.useContext((0, $1f71b295686f1b15$export$2e2bcd8739ae039));
    const ownerState = (0, $aJx1R.default)({}, props, {
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === "head",
        footer: tablelvl2 && tablelvl2.variant === "footer"
    });
    const classes = $73c633ff2ee7f4a0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($73c633ff2ee7f4a0$var$TableRowRoot, (0, $aJx1R.default)({
        as: component,
        ref: ref,
        className: (0, $4qr5a.default)(classes.root, className),
        role: component === $73c633ff2ee7f4a0$var$defaultComponent ? null : "row",
        ownerState: ownerState
    }, other));
});
var $73c633ff2ee7f4a0$export$2e2bcd8739ae039 = $73c633ff2ee7f4a0$var$TableRow;



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $4qr5a = parcelRequire("4qr5a");


var $geqbO = parcelRequire("geqbO");

var $2f0D3 = parcelRequire("2f0D3");
function $88f518f0a61088a9$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $88f518f0a61088a9$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function $88f518f0a61088a9$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $88f518f0a61088a9$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $88f518f0a61088a9$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $88f518f0a61088a9$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== "px") {
            if (fromUnit === "em") pxLength = $88f518f0a61088a9$export$8af1d214c6c2f0f1(length) * $88f518f0a61088a9$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === "rem") pxLength = $88f518f0a61088a9$export$8af1d214c6c2f0f1(length) * $88f518f0a61088a9$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== "px") {
            if (toUnit === "em") outputLength = pxLength / $88f518f0a61088a9$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === "rem") outputLength = pxLength / $88f518f0a61088a9$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $88f518f0a61088a9$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $88f518f0a61088a9$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $88f518f0a61088a9$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = "rem", breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}



var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $7ac9dc5befa477c4$export$c987db9fc844f86(slot) {
    return (0, $dC5O8.default)("MuiSkeleton", slot);
}
const $7ac9dc5befa477c4$var$skeletonClasses = (0, $kY7HX.default)("MuiSkeleton", [
    "root",
    "text",
    "rectangular",
    "rounded",
    "circular",
    "pulse",
    "wave",
    "withChildren",
    "fitContent",
    "heightAuto"
]);
var $7ac9dc5befa477c4$export$2e2bcd8739ae039 = $7ac9dc5befa477c4$var$skeletonClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $107e9a83a039e2a0$var$_excluded = [
    "animation",
    "className",
    "component",
    "height",
    "style",
    "variant",
    "width"
];
let $107e9a83a039e2a0$var$_ = (t)=>t, $107e9a83a039e2a0$var$_t, $107e9a83a039e2a0$var$_t2, $107e9a83a039e2a0$var$_t3, $107e9a83a039e2a0$var$_t4;
const $107e9a83a039e2a0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            animation,
            hasChildren && "withChildren",
            hasChildren && !width && "fitContent",
            hasChildren && !height && "heightAuto"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $7ac9dc5befa477c4$export$c987db9fc844f86), classes);
};
const $107e9a83a039e2a0$var$pulseKeyframe = (0, $geqbO.keyframes)($107e9a83a039e2a0$var$_t || ($107e9a83a039e2a0$var$_t = $107e9a83a039e2a0$var$_`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`));
const $107e9a83a039e2a0$var$waveKeyframe = (0, $geqbO.keyframes)($107e9a83a039e2a0$var$_t2 || ($107e9a83a039e2a0$var$_t2 = $107e9a83a039e2a0$var$_`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`));
const $107e9a83a039e2a0$var$SkeletonRoot = (0, $jawKn.default)("span", {
    name: "MuiSkeleton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const radiusUnit = (0, $88f518f0a61088a9$export$65f2564e9a9b9222)(theme.shape.borderRadius) || "px";
    const radiusValue = (0, $88f518f0a61088a9$export$8af1d214c6c2f0f1)(theme.shape.borderRadius);
    return (0, $aJx1R.default)({
        display: "block",
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, $69eec9e6c105674b$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.mode === "light" ? 0.11 : 0.13),
        height: "1.2em"
    }, ownerState.variant === "text" && {
        marginTop: 0,
        marginBottom: 0,
        height: "auto",
        transformOrigin: "0 55%",
        transform: "scale(1, 0.60)",
        borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
        "&:empty:before": {
            content: '"\\00a0"'
        }
    }, ownerState.variant === "circular" && {
        borderRadius: "50%"
    }, ownerState.variant === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.hasChildren && {
        "& > *": {
            visibility: "hidden"
        }
    }, ownerState.hasChildren && !ownerState.width && {
        maxWidth: "fit-content"
    }, ownerState.hasChildren && !ownerState.height && {
        height: "auto"
    });
}, ({ ownerState: ownerState })=>ownerState.animation === "pulse" && (0, $geqbO.css)($107e9a83a039e2a0$var$_t3 || ($107e9a83a039e2a0$var$_t3 = $107e9a83a039e2a0$var$_`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), $107e9a83a039e2a0$var$pulseKeyframe), ({ ownerState: ownerState, theme: theme })=>ownerState.animation === "wave" && (0, $geqbO.css)($107e9a83a039e2a0$var$_t4 || ($107e9a83a039e2a0$var$_t4 = $107e9a83a039e2a0$var$_`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), $107e9a83a039e2a0$var$waveKeyframe, (theme.vars || theme).palette.action.hover));
const $107e9a83a039e2a0$var$Skeleton = /*#__PURE__*/ $exYeM.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiSkeleton"
    });
    const { animation: animation = "pulse", className: className, component: component = "span", height: height, style: style, variant: variant = "text", width: width } = props, other = (0, $3L80X.default)(props, $107e9a83a039e2a0$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    });
    const classes = $107e9a83a039e2a0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($107e9a83a039e2a0$var$SkeletonRoot, (0, $aJx1R.default)({
        as: component,
        ref: ref,
        className: (0, $4qr5a.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        style: (0, $aJx1R.default)({
            width: width,
            height: height
        }, style)
    }));
});
var $107e9a83a039e2a0$export$2e2bcd8739ae039 = $107e9a83a039e2a0$var$Skeleton;



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $8L988 = parcelRequire("8L988");

var $fXwzw = parcelRequire("fXwzw");



var $7PWLt = parcelRequire("7PWLt");

var $jawKn = parcelRequire("jawKn");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $4fe03bcdb060a325$export$33a0f07a16a10b1b(slot) {
    return (0, $dC5O8.default)("MuiTableCell", slot);
}
const $4fe03bcdb060a325$var$tableCellClasses = (0, $kY7HX.default)("MuiTableCell", [
    "root",
    "head",
    "body",
    "footer",
    "sizeSmall",
    "sizeMedium",
    "paddingCheckbox",
    "paddingNone",
    "alignLeft",
    "alignCenter",
    "alignRight",
    "alignJustify",
    "stickyHeader"
]);
var $4fe03bcdb060a325$export$2e2bcd8739ae039 = $4fe03bcdb060a325$var$tableCellClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $0d3e666d59021d3c$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $0d3e666d59021d3c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            stickyHeader && "stickyHeader",
            align !== "inherit" && `align${(0, $fXwzw.default)(align)}`,
            padding !== "normal" && `padding${(0, $fXwzw.default)(padding)}`,
            `size${(0, $fXwzw.default)(size)}`
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $4fe03bcdb060a325$export$33a0f07a16a10b1b), classes);
};
const $0d3e666d59021d3c$var$TableCellRoot = (0, $jawKn.default)("td", {
    name: "MuiTableCell",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $fXwzw.default)(ownerState.size)}`],
            ownerState.padding !== "normal" && styles[`padding${(0, $fXwzw.default)(ownerState.padding)}`],
            ownerState.align !== "inherit" && styles[`align${(0, $fXwzw.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({}, theme.typography.body2, {
        display: "table-cell",
        verticalAlign: "inherit",
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === "light" ? (0, $8L988.lighten)((0, $8L988.alpha)(theme.palette.divider, 1), 0.88) : (0, $8L988.darken)((0, $8L988.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: "left",
        padding: 16
    }, ownerState.variant === "head" && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === "body" && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === "footer" && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === "small" && {
        padding: "6px 16px",
        [`&.${(0, $4fe03bcdb060a325$export$2e2bcd8739ae039).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: "0 12px 0 16px",
            "& > *": {
                padding: 0
            }
        }
    }, ownerState.padding === "checkbox" && {
        width: 48,
        // prevent the checkbox column from growing
        padding: "0 0 0 4px"
    }, ownerState.padding === "none" && {
        padding: 0
    }, ownerState.align === "left" && {
        textAlign: "left"
    }, ownerState.align === "center" && {
        textAlign: "center"
    }, ownerState.align === "right" && {
        textAlign: "right",
        flexDirection: "row-reverse"
    }, ownerState.align === "justify" && {
        textAlign: "justify"
    }, ownerState.stickyHeader && {
        position: "sticky",
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $0d3e666d59021d3c$var$TableCell = /*#__PURE__*/ $exYeM.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiTableCell"
    });
    const { align: align = "inherit", className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp } = props, other = (0, $3L80X.default)(props, $0d3e666d59021d3c$var$_excluded);
    const table = $exYeM.useContext((0, $38dfa640c5e1d9db$export$2e2bcd8739ae039));
    const tablelvl2 = $exYeM.useContext((0, $1f71b295686f1b15$export$2e2bcd8739ae039));
    const isHeadCell = tablelvl2 && tablelvl2.variant === "head";
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? "th" : "td";
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === "td") scope = undefined;
    else if (!scope && isHeadCell) scope = "col";
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $aJx1R.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : "normal"),
        size: sizeProp || (table && table.size ? table.size : "medium"),
        sortDirection: sortDirection,
        stickyHeader: variant === "head" && table && table.stickyHeader,
        variant: variant
    });
    const classes = $0d3e666d59021d3c$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === "asc" ? "ascending" : "descending";
    return /*#__PURE__*/ (0, $aSiaI.jsx)($0d3e666d59021d3c$var$TableCellRoot, (0, $aJx1R.default)({
        as: component,
        ref: ref,
        className: (0, $4qr5a.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
var $0d3e666d59021d3c$export$2e2bcd8739ae039 = $0d3e666d59021d3c$var$TableCell;


let $1320fb82b5482877$var$IDX = 36;
let $1320fb82b5482877$var$HEX = "";
while($1320fb82b5482877$var$IDX--)$1320fb82b5482877$var$HEX += $1320fb82b5482877$var$IDX.toString(36);
function $1320fb82b5482877$var$uid(len = 11) {
    let str = "";
    let num = len;
    while(num--)str += $1320fb82b5482877$var$HEX[Math.random() * 36 | 0];
    return str;
}
const $1320fb82b5482877$var$escapeRegexp = (term)=>term.replace(/[|\\{}()[\]^$+*?.-]/g, (char)=>`\\${char}`);
const $1320fb82b5482877$var$termsToRegExpString = (terms)=>terms.replace(/\s{2,}/g, " ").split(" ").join("|");
const $1320fb82b5482877$var$regexpQuery = ({ terms: terms, matchExactly: matchExactly = false })=>{
    if (typeof terms !== "string") throw new TypeError("Expected a string");
    const escapedTerms = $1320fb82b5482877$var$escapeRegexp(terms.trim());
    return `(${matchExactly ? escapedTerms : $1320fb82b5482877$var$termsToRegExpString(escapedTerms)})`;
};
const $1320fb82b5482877$var$buildRegexp = ({ terms: terms, matchExactly: matchExactly = false })=>{
    try {
        const fromString = /^([/~@;%#'])(.*?)\1([gimsuy]*)$/.exec(terms);
        if (fromString) return new RegExp(fromString[2], fromString[3]);
        return new RegExp($1320fb82b5482877$var$regexpQuery({
            terms: terms,
            matchExactly: matchExactly
        }), "ig");
    } catch (e) {
        throw new TypeError("Expected terms to be either a string or a RegExp!");
    }
};
const $1320fb82b5482877$var$hasProp = (prop)=>(obj)=>obj !== null && typeof obj === "object" && prop in obj;
const $1320fb82b5482877$var$hasMatch = $1320fb82b5482877$var$hasProp("match");
const $1320fb82b5482877$var$chunkExists = (chunk)=>typeof chunk !== "undefined";
function $1320fb82b5482877$var$clip({ curr: curr, next: next, prev: prev, clipBy: clipBy = 3 }) {
    const words = curr.text.split(" ");
    const len = words.length;
    if (curr.match || clipBy >= len) return curr.text;
    const ellipsis = "...";
    if ($1320fb82b5482877$var$chunkExists(next) && $1320fb82b5482877$var$chunkExists(prev) && $1320fb82b5482877$var$hasMatch(prev) && $1320fb82b5482877$var$hasMatch(next)) {
        if (len > clipBy * 2) return [
            ...words.slice(0, clipBy),
            ellipsis,
            ...words.slice(-clipBy)
        ].join(" ");
        return curr.text;
    }
    if ($1320fb82b5482877$var$chunkExists(next) && $1320fb82b5482877$var$hasMatch(next)) return [
        ellipsis,
        ...words.slice(-clipBy)
    ].join(" ");
    if ($1320fb82b5482877$var$chunkExists(prev) && $1320fb82b5482877$var$hasMatch(prev)) return [
        ...words.slice(0, clipBy),
        ellipsis
    ].join(" ");
    return curr.text;
}
var $1320fb82b5482877$var$__defProp = Object.defineProperty;
var $1320fb82b5482877$var$__defProps = Object.defineProperties;
var $1320fb82b5482877$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $1320fb82b5482877$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $1320fb82b5482877$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $1320fb82b5482877$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $1320fb82b5482877$var$__defNormalProp = (obj, key, value)=>key in obj ? $1320fb82b5482877$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $1320fb82b5482877$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($1320fb82b5482877$var$__hasOwnProp.call(b, prop)) $1320fb82b5482877$var$__defNormalProp(a, prop, b[prop]);
    if ($1320fb82b5482877$var$__getOwnPropSymbols) {
        for (var prop of $1320fb82b5482877$var$__getOwnPropSymbols(b))if ($1320fb82b5482877$var$__propIsEnum.call(b, prop)) $1320fb82b5482877$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $1320fb82b5482877$var$__spreadProps = (a, b)=>$1320fb82b5482877$var$__defProps(a, $1320fb82b5482877$var$__getOwnPropDescs(b));
const $1320fb82b5482877$var$hasLength = (str)=>str.length > 0;
const $1320fb82b5482877$export$2e2bcd8739ae039 = ({ text: text, query: query, clipBy: clipBy, matchExactly: matchExactly = false })=>{
    const safeQuery = typeof query === "string" ? query.trim() : query;
    if (safeQuery === "") return [
        {
            key: $1320fb82b5482877$var$uid(),
            text: text,
            match: false
        }
    ];
    const searchRegexp = $1320fb82b5482877$var$buildRegexp({
        terms: query,
        matchExactly: matchExactly
    });
    return text.split(searchRegexp).filter($1320fb82b5482877$var$hasLength).map((str)=>({
            // Compose the object for a match
            key: $1320fb82b5482877$var$uid(),
            text: str,
            match: matchExactly ? str.toLowerCase() === safeQuery.toLowerCase() : searchRegexp.test(str)
        })).map((chunk, index, chunks)=>$1320fb82b5482877$var$__spreadValues($1320fb82b5482877$var$__spreadValues({}, chunk), typeof clipBy === "number" && {
            // We only overwrite the text if there is a clip
            text: $1320fb82b5482877$var$clip($1320fb82b5482877$var$__spreadProps($1320fb82b5482877$var$__spreadValues($1320fb82b5482877$var$__spreadValues({
                curr: chunk
            }, index < chunks.length - 1 && {
                next: chunks[index + 1]
            }), index > 0 && {
                prev: chunks[index - 1]
            }), {
                clipBy: // If this wasn't the first chunk, set the previous chunk
                clipBy
            }))
        }));
};



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");



var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");

var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $2f0D3 = parcelRequire("2f0D3");

var $1cT6v = parcelRequire("1cT6v");


var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $2TX6h = parcelRequire("2TX6h");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $1ff2c274af8572a8$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $1ff2c274af8572a8$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $1ff2c274af8572a8$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $1ff2c274af8572a8$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base-ui/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base-ui/react-textarea-autosize/components-api/#textarea-autosize)
 */ const $1ff2c274af8572a8$export$d1710922ecaf577a = /*#__PURE__*/ $exYeM.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $3L80X.default)(props, $1ff2c274af8572a8$var$_excluded);
    const { current: isControlled } = $exYeM.useRef(value != null);
    const inputRef = $exYeM.useRef(null);
    const handleRef = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(forwardedRef, inputRef);
    const shadowRef = $exYeM.useRef(null);
    const calculateTextareaStyles = $exYeM.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $9a18bdeaa27f655f$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0,
            overflowing: false
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = $1ff2c274af8572a8$var$getStyleValue(computedStyle.paddingBottom) + $1ff2c274af8572a8$var$getStyleValue(computedStyle.paddingTop);
        const border = $1ff2c274af8572a8$var$getStyleValue(computedStyle.borderBottomWidth) + $1ff2c274af8572a8$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const syncHeight = $exYeM.useCallback(()=>{
        const textareaStyles = calculateTextareaStyles();
        if ($1ff2c274af8572a8$var$isEmpty(textareaStyles)) return;
        const input = inputRef.current;
        input.style.height = `${textareaStyles.outerHeightStyle}px`;
        input.style.overflow = textareaStyles.overflowing ? "hidden" : "";
    }, [
        calculateTextareaStyles
    ]);
    (0, $c4c3f9798cb7fddc$export$2e2bcd8739ae039)(()=>{
        const handleResize = ()=>{
            syncHeight();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, $e9d013e2a17c2ab4$export$2e2bcd8739ae039)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, $9a18bdeaa27f655f$export$2e2bcd8739ae039)(input);
        containerWindow.addEventListener("resize", debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener("resize", debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight
    ]);
    (0, $c4c3f9798cb7fddc$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("textarea", (0, $aJx1R.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, $aSiaI.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $aJx1R.default)({}, $1ff2c274af8572a8$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});




var $2f0D3 = parcelRequire("2f0D3");
function $71d750ff2e8032c3$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}





var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");

var $fXwzw = parcelRequire("fXwzw");



// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $6476631591494042$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $6476631591494042$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($6476631591494042$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $6476631591494042$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
}
function $6476631591494042$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $0138cbd90ffadedd$export$ef57d5c8ca2278f6(slot) {
    return (0, $dC5O8.default)("MuiInputBase", slot);
}
const $0138cbd90ffadedd$var$inputBaseClasses = (0, $kY7HX.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $0138cbd90ffadedd$export$2e2bcd8739ae039 = $0138cbd90ffadedd$var$inputBaseClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $8c8dce286b606b90$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $8c8dce286b606b90$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $fXwzw.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $8c8dce286b606b90$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $8c8dce286b606b90$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $fXwzw.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size && size !== "medium" && `size${(0, $fXwzw.default)(size)}`,
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $0138cbd90ffadedd$export$ef57d5c8ca2278f6), classes);
};
const $8c8dce286b606b90$export$298a043133d72a38 = (0, $jawKn.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $8c8dce286b606b90$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $0138cbd90ffadedd$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, $aJx1R.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const $8c8dce286b606b90$export$a1ad29c901026019 = (0, $jawKn.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $8c8dce286b606b90$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    const placeholder = (0, $aJx1R.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $aJx1R.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $0138cbd90ffadedd$export$2e2bcd8739ae039).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $0138cbd90ffadedd$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const $8c8dce286b606b90$var$inputGlobalStyles = /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4c9e7d92b5ff7371$export$2e2bcd8739ae039), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $8c8dce286b606b90$var$InputBase = /*#__PURE__*/ $exYeM.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = "text", value: valueProp } = props, other = (0, $3L80X.default)(props, $8c8dce286b606b90$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $exYeM.useRef(value != null);
    const inputRef = $exYeM.useRef();
    const handleInputRefWarning = $exYeM.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $69ecd4eca0914ac9$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $exYeM.useState(false);
    const muiFormControl = (0, $cfe831b0e6d29047$export$2e2bcd8739ae039)();
    const fcs = (0, $71d750ff2e8032c3$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $exYeM.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $exYeM.useCallback((obj)=>{
        if ((0, $6476631591494042$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $3e56c60e7cf2a296$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $2TX6h.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $exYeM.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, $aJx1R.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $aJx1R.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $1ff2c274af8572a8$export$d1710922ecaf577a);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $exYeM.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $aJx1R.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $8c8dce286b606b90$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $8c8dce286b606b90$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $8c8dce286b606b90$export$a1ad29c901026019;
    inputProps = (0, $aJx1R.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $8c8dce286b606b90$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $aSiaI.jsxs)(Root, (0, $aJx1R.default)({}, rootProps, !(0, $6d812737487786ea$export$e28348cc2430497)(Root) && {
                ownerState: (0, $aJx1R.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $4qr5a.default)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $58875f077a566e4b$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)(Input, (0, $aJx1R.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $6d812737487786ea$export$e28348cc2430497)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $aJx1R.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $4qr5a.default)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $aJx1R.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $8c8dce286b606b90$export$2e2bcd8739ae039 = $8c8dce286b606b90$var$InputBase;



var $jawKn = parcelRequire("jawKn");
var $bJ6Mf = parcelRequire("bJ6Mf");

var $7PWLt = parcelRequire("7PWLt");

var $aJx1R = parcelRequire("aJx1R");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");

function $316ce8f6021402f0$export$cdb270390122322b(slot) {
    return (0, $dC5O8.default)("MuiInput", slot);
}
const $316ce8f6021402f0$var$inputClasses = (0, $aJx1R.default)({}, (0, $0138cbd90ffadedd$export$2e2bcd8739ae039), (0, $kY7HX.default)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $316ce8f6021402f0$export$2e2bcd8739ae039 = $316ce8f6021402f0$var$inputClasses;




var $aSiaI = parcelRequire("aSiaI");
"use client";
const $f2137283e6ce1bff$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $f2137283e6ce1bff$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $2f0D3.default)(slots, (0, $316ce8f6021402f0$export$cdb270390122322b), classes);
    return (0, $aJx1R.default)({}, classes, composedClasses);
};
const $f2137283e6ce1bff$var$InputRoot = (0, $jawKn.default)((0, $8c8dce286b606b90$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $bJ6Mf.default)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $8c8dce286b606b90$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $aJx1R.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $316ce8f6021402f0$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $316ce8f6021402f0$export$2e2bcd8739ae039).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $316ce8f6021402f0$export$2e2bcd8739ae039).disabled}, .${(0, $316ce8f6021402f0$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $316ce8f6021402f0$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const $f2137283e6ce1bff$var$InputInput = (0, $jawKn.default)((0, $8c8dce286b606b90$export$a1ad29c901026019), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $8c8dce286b606b90$export$cf507b112810e72d)
})({});
const $f2137283e6ce1bff$var$Input = /*#__PURE__*/ $exYeM.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $3L80X.default)(props, $f2137283e6ce1bff$var$_excluded);
    const classes = $f2137283e6ce1bff$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $1cT6v.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $f2137283e6ce1bff$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $f2137283e6ce1bff$var$InputInput;
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8c8dce286b606b90$export$2e2bcd8739ae039), (0, $aJx1R.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$f2137283e6ce1bff$var$Input.muiName = "Input";
var $f2137283e6ce1bff$export$2e2bcd8739ae039 = $f2137283e6ce1bff$var$Input;



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $1cT6v = parcelRequire("1cT6v");



var $2f0D3 = parcelRequire("2f0D3");


var $jawKn = parcelRequire("jawKn");
var $bJ6Mf = parcelRequire("bJ6Mf");

var $7PWLt = parcelRequire("7PWLt");

var $aJx1R = parcelRequire("aJx1R");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");

function $83dd8e76869e15c9$export$3331e419f1a48437(slot) {
    return (0, $dC5O8.default)("MuiFilledInput", slot);
}
const $83dd8e76869e15c9$var$filledInputClasses = (0, $aJx1R.default)({}, (0, $0138cbd90ffadedd$export$2e2bcd8739ae039), (0, $kY7HX.default)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $83dd8e76869e15c9$export$2e2bcd8739ae039 = $83dd8e76869e15c9$var$filledInputClasses;




var $aSiaI = parcelRequire("aSiaI");
"use client";
const $152b2c18fbdc050c$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $152b2c18fbdc050c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $2f0D3.default)(slots, (0, $83dd8e76869e15c9$export$3331e419f1a48437), classes);
    return (0, $aJx1R.default)({}, classes, composedClasses);
};
const $152b2c18fbdc050c$var$FilledInputRoot = (0, $jawKn.default)((0, $8c8dce286b606b90$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $bJ6Mf.default)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $8c8dce286b606b90$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return (0, $aJx1R.default)({
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $83dd8e76869e15c9$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $83dd8e76869e15c9$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $83dd8e76869e15c9$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $83dd8e76869e15c9$export$2e2bcd8739ae039).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $83dd8e76869e15c9$export$2e2bcd8739ae039).disabled}, .${(0, $83dd8e76869e15c9$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $83dd8e76869e15c9$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $aJx1R.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $152b2c18fbdc050c$var$FilledInputInput = (0, $jawKn.default)((0, $8c8dce286b606b90$export$a1ad29c901026019), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $8c8dce286b606b90$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $152b2c18fbdc050c$var$FilledInput = /*#__PURE__*/ $exYeM.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $3L80X.default)(props, $152b2c18fbdc050c$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $152b2c18fbdc050c$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $1cT6v.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $152b2c18fbdc050c$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $152b2c18fbdc050c$var$FilledInputInput;
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8c8dce286b606b90$export$2e2bcd8739ae039), (0, $aJx1R.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$152b2c18fbdc050c$var$FilledInput.muiName = "Input";
var $152b2c18fbdc050c$export$2e2bcd8739ae039 = $152b2c18fbdc050c$var$FilledInput;



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");



var $2f0D3 = parcelRequire("2f0D3");

var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");
parcelRequire("exYeM");


var $jawKn = parcelRequire("jawKn");
var $bJ6Mf = parcelRequire("bJ6Mf");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $d8cc4fb21d1c9f2c$var$_span;
const $d8cc4fb21d1c9f2c$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $d8cc4fb21d1c9f2c$var$NotchedOutlineRoot = (0, $jawKn.default)("fieldset", {
    shouldForwardProp: (0, $bJ6Mf.default)
})({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $d8cc4fb21d1c9f2c$var$NotchedOutlineLegend = (0, $jawKn.default)("legend", {
    shouldForwardProp: (0, $bJ6Mf.default)
})(({ ownerState: ownerState, theme: theme })=>(0, $aJx1R.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $aJx1R.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $d8cc4fb21d1c9f2c$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $3L80X.default)(props, $d8cc4fb21d1c9f2c$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $aJx1R.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)($d8cc4fb21d1c9f2c$var$NotchedOutlineRoot, (0, $aJx1R.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($d8cc4fb21d1c9f2c$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                children: label
            }) : $d8cc4fb21d1c9f2c$var$_span || ($d8cc4fb21d1c9f2c$var$_span = /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}





var $jawKn = parcelRequire("jawKn");
var $bJ6Mf = parcelRequire("bJ6Mf");

var $aJx1R = parcelRequire("aJx1R");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");

function $b036e9072dc229ae$export$89922944c7227687(slot) {
    return (0, $dC5O8.default)("MuiOutlinedInput", slot);
}
const $b036e9072dc229ae$var$outlinedInputClasses = (0, $aJx1R.default)({}, (0, $0138cbd90ffadedd$export$2e2bcd8739ae039), (0, $kY7HX.default)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $b036e9072dc229ae$export$2e2bcd8739ae039 = $b036e9072dc229ae$var$outlinedInputClasses;




var $7PWLt = parcelRequire("7PWLt");

var $aSiaI = parcelRequire("aSiaI");
"use client";
const $468fc26fb133d75b$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $468fc26fb133d75b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $2f0D3.default)(slots, (0, $b036e9072dc229ae$export$89922944c7227687), classes);
    return (0, $aJx1R.default)({}, classes, composedClasses);
};
const $468fc26fb133d75b$var$OutlinedInputRoot = (0, $jawKn.default)((0, $8c8dce286b606b90$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $bJ6Mf.default)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $8c8dce286b606b90$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, $aJx1R.default)({
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $b036e9072dc229ae$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $b036e9072dc229ae$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $b036e9072dc229ae$export$2e2bcd8739ae039).focused} .${(0, $b036e9072dc229ae$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $b036e9072dc229ae$export$2e2bcd8739ae039).error} .${(0, $b036e9072dc229ae$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $b036e9072dc229ae$export$2e2bcd8739ae039).disabled} .${(0, $b036e9072dc229ae$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $aJx1R.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const $468fc26fb133d75b$var$NotchedOutlineRoot = (0, $jawKn.default)((0, $d8cc4fb21d1c9f2c$export$2e2bcd8739ae039), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $468fc26fb133d75b$var$OutlinedInputInput = (0, $jawKn.default)((0, $8c8dce286b606b90$export$a1ad29c901026019), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $8c8dce286b606b90$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $468fc26fb133d75b$var$OutlinedInput = /*#__PURE__*/ $exYeM.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = "text" } = props, other = (0, $3L80X.default)(props, $468fc26fb133d75b$var$_excluded);
    const classes = $468fc26fb133d75b$var$useUtilityClasses(props);
    const muiFormControl = (0, $cfe831b0e6d29047$export$2e2bcd8739ae039)();
    const fcs = (0, $71d750ff2e8032c3$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "focused",
            "hiddenLabel",
            "size",
            "required"
        ]
    });
    const ownerState = (0, $aJx1R.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $468fc26fb133d75b$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $468fc26fb133d75b$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8c8dce286b606b90$export$2e2bcd8739ae039), (0, $aJx1R.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $aSiaI.jsx)($468fc26fb133d75b$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $aJx1R.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$468fc26fb133d75b$var$OutlinedInput.muiName = "Input";
var $468fc26fb133d75b$export$2e2bcd8739ae039 = $468fc26fb133d75b$var$OutlinedInput;



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $2f0D3 = parcelRequire("2f0D3");

var $4qr5a = parcelRequire("4qr5a");



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");



var $fXwzw = parcelRequire("fXwzw");

var $7PWLt = parcelRequire("7PWLt");

var $jawKn = parcelRequire("jawKn");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $f9f46f1a9d857ba2$export$f7d501e40371cd17(slot) {
    return (0, $dC5O8.default)("MuiFormLabel", slot);
}
const $f9f46f1a9d857ba2$var$formLabelClasses = (0, $kY7HX.default)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $f9f46f1a9d857ba2$export$2e2bcd8739ae039 = $f9f46f1a9d857ba2$var$formLabelClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $b1598877bc308984$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $b1598877bc308984$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $fXwzw.default)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $f9f46f1a9d857ba2$export$f7d501e40371cd17), classes);
};
const $b1598877bc308984$export$aa5bc7f8a4705b27 = (0, $jawKn.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $aJx1R.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        [`&.${(0, $f9f46f1a9d857ba2$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $f9f46f1a9d857ba2$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $f9f46f1a9d857ba2$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $b1598877bc308984$var$AsteriskComponent = (0, $jawKn.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $f9f46f1a9d857ba2$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $b1598877bc308984$var$FormLabel = /*#__PURE__*/ $exYeM.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children: children, className: className, component: component = "label" } = props, other = (0, $3L80X.default)(props, $b1598877bc308984$var$_excluded);
    const muiFormControl = (0, $cfe831b0e6d29047$export$2e2bcd8739ae039)();
    const fcs = (0, $71d750ff2e8032c3$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = (0, $aJx1R.default)({}, props, {
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $b1598877bc308984$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($b1598877bc308984$export$aa5bc7f8a4705b27, (0, $aJx1R.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $4qr5a.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $aSiaI.jsxs)($b1598877bc308984$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    "*"
                ]
            })
        ]
    }));
});
var $b1598877bc308984$export$2e2bcd8739ae039 = $b1598877bc308984$var$FormLabel;



var $7PWLt = parcelRequire("7PWLt");

var $fXwzw = parcelRequire("fXwzw");

var $jawKn = parcelRequire("jawKn");
var $bJ6Mf = parcelRequire("bJ6Mf");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $100baa972f02b76b$export$c1c4b4545ad2ea5f(slot) {
    return (0, $dC5O8.default)("MuiInputLabel", slot);
}
const $100baa972f02b76b$var$inputLabelClasses = (0, $kY7HX.default)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
var $100baa972f02b76b$export$2e2bcd8739ae039 = $100baa972f02b76b$var$inputLabelClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $0f13a85ecf68fcb2$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $0f13a85ecf68fcb2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size && size !== "normal" && `size${(0, $fXwzw.default)(size)}`,
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, $2f0D3.default)(slots, (0, $100baa972f02b76b$export$c1c4b4545ad2ea5f), classes);
    return (0, $aJx1R.default)({}, classes, composedClasses);
};
const $0f13a85ecf68fcb2$var$InputLabelRoot = (0, $jawKn.default)((0, $b1598877bc308984$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $bJ6Mf.default)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $f9f46f1a9d857ba2$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%"
    }, ownerState.formControl && {
        position: "absolute",
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: "translate(0, 20px) scale(1)"
    }, ownerState.size === "small" && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: "translate(0, 17px) scale(1)"
    }, ownerState.shrink && {
        transform: "translate(0, -1.5px) scale(0.75)",
        transformOrigin: "top left",
        maxWidth: "133%"
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            "color",
            "transform",
            "max-width"
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === "filled" && (0, $aJx1R.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(12px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 13px) scale(1)"
    }, ownerState.shrink && (0, $aJx1R.default)({
        userSelect: "none",
        pointerEvents: "auto",
        transform: "translate(12px, 7px) scale(0.75)",
        maxWidth: "calc(133% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 4px) scale(0.75)"
    })), ownerState.variant === "outlined" && (0, $aJx1R.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(14px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(14px, 9px) scale(1)"
    }, ownerState.shrink && {
        userSelect: "none",
        pointerEvents: "auto",
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: "calc(133% - 32px)",
        transform: "translate(14px, -9px) scale(0.75)"
    })));
const $0f13a85ecf68fcb2$var$InputLabel = /*#__PURE__*/ $exYeM.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $7PWLt.default)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $3L80X.default)(props, $0f13a85ecf68fcb2$var$_excluded);
    const muiFormControl = (0, $cfe831b0e6d29047$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $71d750ff2e8032c3$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "size",
            "variant",
            "required",
            "focused"
        ]
    });
    const ownerState = (0, $aJx1R.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $0f13a85ecf68fcb2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($0f13a85ecf68fcb2$var$InputLabelRoot, (0, $aJx1R.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $4qr5a.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $0f13a85ecf68fcb2$export$2e2bcd8739ae039 = $0f13a85ecf68fcb2$var$InputLabel;



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $7PWLt = parcelRequire("7PWLt");

var $jawKn = parcelRequire("jawKn");


var $fXwzw = parcelRequire("fXwzw");

var $exYeM = parcelRequire("exYeM");
function $6a3972843592c360$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $exYeM.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $2b84a4ecf9ea9611$export$2e2bcd8739ae039 = (0, $6a3972843592c360$export$2e2bcd8739ae039);




var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $971895a3890da804$export$149c8b8bab2289d1(slot) {
    return (0, $dC5O8.default)("MuiFormControl", slot);
}
const $971895a3890da804$var$formControlClasses = (0, $kY7HX.default)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $971895a3890da804$export$2e2bcd8739ae039 = $971895a3890da804$var$formControlClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $f455042ed80bed88$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $f455042ed80bed88$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, $fXwzw.default)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $971895a3890da804$export$149c8b8bab2289d1), classes);
};
const $f455042ed80bed88$var$FormControlRoot = (0, $jawKn.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $aJx1R.default)({}, styles.root, styles[`margin${(0, $fXwzw.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $aJx1R.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $f455042ed80bed88$var$FormControl = /*#__PURE__*/ $exYeM.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = "none", required: required = false, size: size = "medium", variant: variant = "outlined" } = props, other = (0, $3L80X.default)(props, $f455042ed80bed88$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $f455042ed80bed88$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $exYeM.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $exYeM.Children.forEach(children, (child)=>{
            if (!(0, $2b84a4ecf9ea9611$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, $2b84a4ecf9ea9611$export$2e2bcd8739ae039)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $6476631591494042$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $exYeM.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $exYeM.Children.forEach(children, (child)=>{
            if (!(0, $2b84a4ecf9ea9611$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $6476631591494042$export$d652b828d7fdeff8)(child.props, true) || (0, $6476631591494042$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $exYeM.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $exYeM.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $58875f077a566e4b$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($f455042ed80bed88$var$FormControlRoot, (0, $aJx1R.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $4qr5a.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $f455042ed80bed88$export$2e2bcd8739ae039 = $f455042ed80bed88$var$FormControl;



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");



var $jawKn = parcelRequire("jawKn");

var $fXwzw = parcelRequire("fXwzw");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $15de618b360a9d99$export$a394fa61b1d583a9(slot) {
    return (0, $dC5O8.default)("MuiFormHelperText", slot);
}
const $15de618b360a9d99$var$formHelperTextClasses = (0, $kY7HX.default)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
var $15de618b360a9d99$export$2e2bcd8739ae039 = $15de618b360a9d99$var$formHelperTextClasses;



var $7PWLt = parcelRequire("7PWLt");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $68258577de0527c4$var$_span;
const $68258577de0527c4$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $68258577de0527c4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && `size${(0, $fXwzw.default)(size)}`,
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $15de618b360a9d99$export$a394fa61b1d583a9), classes);
};
const $68258577de0527c4$var$FormHelperTextRoot = (0, $jawKn.default)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $fXwzw.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $15de618b360a9d99$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $15de618b360a9d99$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === "small" && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $68258577de0527c4$var$FormHelperText = /*#__PURE__*/ $exYeM.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    const { children: children, className: className, component: component = "p" } = props, other = (0, $3L80X.default)(props, $68258577de0527c4$var$_excluded);
    const muiFormControl = (0, $cfe831b0e6d29047$export$2e2bcd8739ae039)();
    const fcs = (0, $71d750ff2e8032c3$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    const ownerState = (0, $aJx1R.default)({}, props, {
        component: component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $68258577de0527c4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($68258577de0527c4$var$FormHelperTextRoot, (0, $aJx1R.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $4qr5a.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === " " ? $68258577de0527c4$var$_span || ($68258577de0527c4$var$_span = /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $68258577de0527c4$export$2e2bcd8739ae039 = $68258577de0527c4$var$FormHelperText;



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $1cT6v = parcelRequire("1cT6v");

var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $2TX6h = parcelRequire("2TX6h");

var $exYeM = parcelRequire("exYeM");
parcelRequire("bSFE1");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");




var $fXwzw = parcelRequire("fXwzw");


var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");


var $2f0D3 = parcelRequire("2f0D3");

var $fXwzw = parcelRequire("fXwzw");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $a753e516fa046bae$export$1ee13051fd9e2ab5(slot) {
    return (0, $dC5O8.default)("MuiNativeSelect", slot);
}
const $a753e516fa046bae$var$nativeSelectClasses = (0, $kY7HX.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $a753e516fa046bae$export$2e2bcd8739ae039 = $a753e516fa046bae$var$nativeSelectClasses;



var $jawKn = parcelRequire("jawKn");
var $bJ6Mf = parcelRequire("bJ6Mf");

var $aSiaI = parcelRequire("aSiaI");
"use client";
const $9bfd27fdd5f49298$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $9bfd27fdd5f49298$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $fXwzw.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $a753e516fa046bae$export$1ee13051fd9e2ab5), classes);
};
const $9bfd27fdd5f49298$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $aJx1R.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": (0, $aJx1R.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, $a753e516fa046bae$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:focus": {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const $9bfd27fdd5f49298$var$NativeSelectSelect = (0, $jawKn.default)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $bJ6Mf.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $a753e516fa046bae$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($9bfd27fdd5f49298$export$c1eccd1617458c87);
const $9bfd27fdd5f49298$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $aJx1R.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $a753e516fa046bae$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const $9bfd27fdd5f49298$var$NativeSelectIcon = (0, $jawKn.default)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $fXwzw.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($9bfd27fdd5f49298$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $9bfd27fdd5f49298$var$NativeSelectInput = /*#__PURE__*/ $exYeM.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = "standard" } = props, other = (0, $3L80X.default)(props, $9bfd27fdd5f49298$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $9bfd27fdd5f49298$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)($9bfd27fdd5f49298$var$NativeSelectSelect, (0, $aJx1R.default)({
                ownerState: ownerState,
                className: (0, $4qr5a.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $aSiaI.jsx)($9bfd27fdd5f49298$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $9bfd27fdd5f49298$export$2e2bcd8739ae039 = $9bfd27fdd5f49298$var$NativeSelectInput;




var $jawKn = parcelRequire("jawKn");
var $iclFT = parcelRequire("iclFT");



var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $581c329d0054d392$export$2c0c1ee5a3392e(slot) {
    return (0, $dC5O8.default)("MuiSelect", slot);
}
const $581c329d0054d392$var$selectClasses = (0, $kY7HX.default)("MuiSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $581c329d0054d392$export$2e2bcd8739ae039 = $581c329d0054d392$var$selectClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
var $1e20a1c5a9fb4839$var$_span;
const $1e20a1c5a9fb4839$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $1e20a1c5a9fb4839$var$SelectSelect = (0, $jawKn.default)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $581c329d0054d392$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $581c329d0054d392$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $581c329d0054d392$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $581c329d0054d392$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $9bfd27fdd5f49298$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $581c329d0054d392$export$2e2bcd8739ae039).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $1e20a1c5a9fb4839$var$SelectIcon = (0, $jawKn.default)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $fXwzw.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $9bfd27fdd5f49298$export$e7a817afd12a40d0));
const $1e20a1c5a9fb4839$var$SelectNativeInput = (0, $jawKn.default)("input", {
    shouldForwardProp: (prop)=>(0, $iclFT.default)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $1e20a1c5a9fb4839$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $1e20a1c5a9fb4839$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $1e20a1c5a9fb4839$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $fXwzw.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $581c329d0054d392$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $1e20a1c5a9fb4839$var$SelectInput = /*#__PURE__*/ $exYeM.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = "standard" } = props, other = (0, $3L80X.default)(props, $1e20a1c5a9fb4839$var$_excluded);
    const [value, setValueState] = (0, $1d509214da7db874$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $1d509214da7db874$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $exYeM.useRef(null);
    const displayRef = $exYeM.useRef(null);
    const [displayNode, setDisplayNode] = $exYeM.useState(null);
    const { current: isOpenControlled } = $exYeM.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $exYeM.useState();
    const handleRef = (0, $69ecd4eca0914ac9$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $exYeM.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $exYeM.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $exYeM.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $exYeM.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $exYeM.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $0a69054a0e524d5d$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $exYeM.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $6476631591494042$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $exYeM.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $2TX6h.default)(2));
            selected = value.some((v)=>$1e20a1c5a9fb4839$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $1e20a1c5a9fb4839$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $exYeM.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $aJx1R.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $1e20a1c5a9fb4839$var$useUtilityClasses(ownerState);
    const paperProps = (0, $aJx1R.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $43c7ad0c22f8e14a$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)($1e20a1c5a9fb4839$var$SelectSelect, (0, $aJx1R.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $4qr5a.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $1e20a1c5a9fb4839$var$isEmpty(display) ? $1e20a1c5a9fb4839$var$_span || ($1e20a1c5a9fb4839$var$_span = /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $aSiaI.jsx)($1e20a1c5a9fb4839$var$SelectNativeInput, (0, $aJx1R.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $aSiaI.jsx)($1e20a1c5a9fb4839$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cf82f57fc51895ad$export$2e2bcd8739ae039), (0, $aJx1R.default)({
                id: `menu-${name || ""}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $aJx1R.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    "aria-multiselectable": multiple ? "true" : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $aJx1R.default)({}, MenuProps.slotProps, {
                    paper: (0, $aJx1R.default)({}, paperProps, {
                        style: (0, $aJx1R.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $1e20a1c5a9fb4839$export$2e2bcd8739ae039 = $1e20a1c5a9fb4839$var$SelectInput;




parcelRequire("exYeM");

var $bPz57 = parcelRequire("bPz57");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $77a9aff961352e6f$export$2e2bcd8739ae039 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");







var $7PWLt = parcelRequire("7PWLt");


var $jawKn = parcelRequire("jawKn");
var $bJ6Mf = parcelRequire("bJ6Mf");

var $aSiaI = parcelRequire("aSiaI");
"use client";
const $feaa83d06931451d$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $feaa83d06931451d$var$_excluded2 = [
    "root"
];
const $feaa83d06931451d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $feaa83d06931451d$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $bJ6Mf.default)(prop) && prop !== "variant",
    slot: "Root"
};
const $feaa83d06931451d$var$StyledInput = (0, $jawKn.default)((0, $f2137283e6ce1bff$export$2e2bcd8739ae039), $feaa83d06931451d$var$styledRootConfig)("");
const $feaa83d06931451d$var$StyledOutlinedInput = (0, $jawKn.default)((0, $468fc26fb133d75b$export$2e2bcd8739ae039), $feaa83d06931451d$var$styledRootConfig)("");
const $feaa83d06931451d$var$StyledFilledInput = (0, $jawKn.default)((0, $152b2c18fbdc050c$export$2e2bcd8739ae039), $feaa83d06931451d$var$styledRootConfig)("");
const $feaa83d06931451d$var$Select = /*#__PURE__*/ $exYeM.forwardRef(function Select(inProps, ref) {
    const props = (0, $7PWLt.default)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $77a9aff961352e6f$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = "outlined" } = props, other = (0, $3L80X.default)(props, $feaa83d06931451d$var$_excluded);
    const inputComponent = native ? (0, $9bfd27fdd5f49298$export$2e2bcd8739ae039) : (0, $1e20a1c5a9fb4839$export$2e2bcd8739ae039);
    const muiFormControl = (0, $cfe831b0e6d29047$export$2e2bcd8739ae039)();
    const fcs = (0, $71d750ff2e8032c3$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $aJx1R.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $feaa83d06931451d$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $3L80X.default)(classes, $feaa83d06931451d$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $aSiaI.jsx)($feaa83d06931451d$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $aSiaI.jsx)($feaa83d06931451d$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $aSiaI.jsx)($feaa83d06931451d$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $69ecd4eca0914ac9$export$2e2bcd8739ae039)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($exYeM.Fragment, {
        children: /*#__PURE__*/ $exYeM.cloneElement(InputComponent, (0, $aJx1R.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $aJx1R.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $aJx1R.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $1cT6v.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $4qr5a.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$feaa83d06931451d$var$Select.muiName = "Select";
var $feaa83d06931451d$export$2e2bcd8739ae039 = $feaa83d06931451d$var$Select;



var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $11e0ae3dd02374e7$export$c1bdcbaf0596aeda(slot) {
    return (0, $dC5O8.default)("MuiTextField", slot);
}
const $11e0ae3dd02374e7$var$textFieldClasses = (0, $kY7HX.default)("MuiTextField", [
    "root"
]);
var $11e0ae3dd02374e7$export$2e2bcd8739ae039 = $11e0ae3dd02374e7$var$textFieldClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $18a733eef46a7fb6$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $18a733eef46a7fb6$var$variantComponent = {
    standard: (0, $f2137283e6ce1bff$export$2e2bcd8739ae039),
    filled: (0, $152b2c18fbdc050c$export$2e2bcd8739ae039),
    outlined: (0, $468fc26fb133d75b$export$2e2bcd8739ae039)
};
const $18a733eef46a7fb6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $11e0ae3dd02374e7$export$c1bdcbaf0596aeda), classes);
};
const $18a733eef46a7fb6$var$TextFieldRoot = (0, $jawKn.default)((0, $f455042ed80bed88$export$2e2bcd8739ae039), {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $18a733eef46a7fb6$var$TextField = /*#__PURE__*/ $exYeM.forwardRef(function TextField(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiTextField"
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = "primary", defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = "outlined" } = props, other = (0, $3L80X.default)(props, $18a733eef46a7fb6$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $18a733eef46a7fb6$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    const id = (0, $43c7ad0c22f8e14a$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $18a733eef46a7fb6$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $aSiaI.jsx)(InputComponent, (0, $aJx1R.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($18a733eef46a7fb6$var$TextFieldRoot, (0, $aJx1R.default)({
        className: (0, $4qr5a.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== "" && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0f13a85ecf68fcb2$export$2e2bcd8739ae039), (0, $aJx1R.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $feaa83d06931451d$export$2e2bcd8739ae039), (0, $aJx1R.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $68258577de0527c4$export$2e2bcd8739ae039), (0, $aJx1R.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $18a733eef46a7fb6$export$2e2bcd8739ae039 = $18a733eef46a7fb6$var$TextField;



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $4qr5a = parcelRequire("4qr5a");





var $2f0D3 = parcelRequire("2f0D3");

var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");

var $6gaNH = parcelRequire("6gaNH");




var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $910df0c63032ecfa$export$5162da8f798e0959(slot) {
    return (0, $dC5O8.default)("MuiCollapse", slot);
}
const $910df0c63032ecfa$var$collapseClasses = (0, $kY7HX.default)("MuiCollapse", [
    "root",
    "horizontal",
    "vertical",
    "entered",
    "hidden",
    "wrapper",
    "wrapperInner"
]);
var $910df0c63032ecfa$export$2e2bcd8739ae039 = $910df0c63032ecfa$var$collapseClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $8c4543c1f79a917c$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $8c4543c1f79a917c$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `${orientation}`
        ],
        entered: [
            "entered"
        ],
        hidden: [
            "hidden"
        ],
        wrapper: [
            "wrapper",
            `${orientation}`
        ],
        wrapperInner: [
            "wrapperInner",
            `${orientation}`
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $910df0c63032ecfa$export$5162da8f798e0959), classes);
};
const $8c4543c1f79a917c$var$CollapseRoot = (0, $jawKn.default)("div", {
    name: "MuiCollapse",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === "entered" && styles.entered,
            ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        height: 0,
        overflow: "hidden",
        transition: theme.transitions.create("height")
    }, ownerState.orientation === "horizontal" && {
        height: "auto",
        width: 0,
        transition: theme.transitions.create("width")
    }, ownerState.state === "entered" && (0, $aJx1R.default)({
        height: "auto",
        overflow: "visible"
    }, ownerState.orientation === "horizontal" && {
        width: "auto"
    }), ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && {
        visibility: "hidden"
    }));
const $8c4543c1f79a917c$var$CollapseWrapper = (0, $jawKn.default)("div", {
    name: "MuiCollapse",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $aJx1R.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: "flex",
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
const $8c4543c1f79a917c$var$CollapseWrapperInner = (0, $jawKn.default)("div", {
    name: "MuiCollapse",
    slot: "WrapperInner",
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $aJx1R.default)({
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $8c4543c1f79a917c$var$Collapse = /*#__PURE__*/ $exYeM.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiCollapse"
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = "0px", component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = "vertical", style: style, timeout: timeout = (0, $6gaNH.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $b1fed440e66ae1d8$export$2e2bcd8739ae039) } = props, other = (0, $3L80X.default)(props, $8c4543c1f79a917c$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $8c4543c1f79a917c$var$useUtilityClasses(ownerState);
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const timer = (0, $72fb5758a7c9ec4b$export$2e2bcd8739ae039)();
    const wrapperRef = $exYeM.useRef(null);
    const autoTransitionDuration = $exYeM.useRef();
    const collapsedSize = typeof collapsedSizeProp === "number" ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === "horizontal";
    const size = isHorizontal ? "width" : "height";
    const nodeRef = $exYeM.useRef(null);
    const handleRef = (0, $69ecd4eca0914ac9$export$2e2bcd8739ae039)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? "clientWidth" : "clientHeight"] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = "absolute";
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = "";
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $439a83a81b60056a$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        if (timeout === "auto") {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = "auto";
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $439a83a81b60056a$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        if (timeout === "auto") {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)(TransitionComponent, (0, $aJx1R.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $aSiaI.jsx)($8c4543c1f79a917c$var$CollapseRoot, (0, $aJx1R.default)({
                as: component,
                className: (0, $4qr5a.default)(classes.root, className, {
                    "entered": classes.entered,
                    "exited": !inProp && collapsedSize === "0px" && classes.hidden
                }[state]),
                style: (0, $aJx1R.default)({
                    [isHorizontal ? "minWidth" : "minHeight"]: collapsedSize
                }, style),
                ref: handleRef
            }, childProps, {
                // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
                // that might have been forwarded from the Transition component.
                ownerState: (0, $aJx1R.default)({}, ownerState, {
                    state: state
                }),
                children: /*#__PURE__*/ (0, $aSiaI.jsx)($8c4543c1f79a917c$var$CollapseWrapper, {
                    ownerState: (0, $aJx1R.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)($8c4543c1f79a917c$var$CollapseWrapperInner, {
                        ownerState: (0, $aJx1R.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$8c4543c1f79a917c$var$Collapse.muiSupportAuto = true;
var $8c4543c1f79a917c$export$2e2bcd8739ae039 = $8c4543c1f79a917c$var$Collapse;



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");


var $7PWLt = parcelRequire("7PWLt");

var $jawKn = parcelRequire("jawKn");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $7335031cb08d8222$export$abec0e5519905f2c(slot) {
    return (0, $dC5O8.default)("MuiTableFooter", slot);
}
const $7335031cb08d8222$var$tableFooterClasses = (0, $kY7HX.default)("MuiTableFooter", [
    "root"
]);
var $7335031cb08d8222$export$2e2bcd8739ae039 = $7335031cb08d8222$var$tableFooterClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $9a3e078eebef299d$var$_excluded = [
    "className",
    "component"
];
const $9a3e078eebef299d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $7335031cb08d8222$export$abec0e5519905f2c), classes);
};
const $9a3e078eebef299d$var$TableFooterRoot = (0, $jawKn.default)("tfoot", {
    name: "MuiTableFooter",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "table-footer-group"
});
const $9a3e078eebef299d$var$tablelvl2 = {
    variant: "footer"
};
const $9a3e078eebef299d$var$defaultComponent = "tfoot";
const $9a3e078eebef299d$var$TableFooter = /*#__PURE__*/ $exYeM.forwardRef(function TableFooter(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiTableFooter"
    });
    const { className: className, component: component = $9a3e078eebef299d$var$defaultComponent } = props, other = (0, $3L80X.default)(props, $9a3e078eebef299d$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        component: component
    });
    const classes = $9a3e078eebef299d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1f71b295686f1b15$export$2e2bcd8739ae039).Provider, {
        value: $9a3e078eebef299d$var$tablelvl2,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($9a3e078eebef299d$var$TableFooterRoot, (0, $aJx1R.default)({
            as: component,
            className: (0, $4qr5a.default)(classes.root, className),
            ref: ref,
            role: component === $9a3e078eebef299d$var$defaultComponent ? null : "rowgroup",
            ownerState: ownerState
        }, other))
    });
});
var $9a3e078eebef299d$export$2e2bcd8739ae039 = $9a3e078eebef299d$var$TableFooter;



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");


var $7PWLt = parcelRequire("7PWLt");

var $jawKn = parcelRequire("jawKn");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $5105ae3be4c41b7f$export$2e731cea2d1c2392(slot) {
    return (0, $dC5O8.default)("MuiTableHead", slot);
}
const $5105ae3be4c41b7f$var$tableHeadClasses = (0, $kY7HX.default)("MuiTableHead", [
    "root"
]);
var $5105ae3be4c41b7f$export$2e2bcd8739ae039 = $5105ae3be4c41b7f$var$tableHeadClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $44d2089cb08aa78c$var$_excluded = [
    "className",
    "component"
];
const $44d2089cb08aa78c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $5105ae3be4c41b7f$export$2e731cea2d1c2392), classes);
};
const $44d2089cb08aa78c$var$TableHeadRoot = (0, $jawKn.default)("thead", {
    name: "MuiTableHead",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "table-header-group"
});
const $44d2089cb08aa78c$var$tablelvl2 = {
    variant: "head"
};
const $44d2089cb08aa78c$var$defaultComponent = "thead";
const $44d2089cb08aa78c$var$TableHead = /*#__PURE__*/ $exYeM.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiTableHead"
    });
    const { className: className, component: component = $44d2089cb08aa78c$var$defaultComponent } = props, other = (0, $3L80X.default)(props, $44d2089cb08aa78c$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        component: component
    });
    const classes = $44d2089cb08aa78c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1f71b295686f1b15$export$2e2bcd8739ae039).Provider, {
        value: $44d2089cb08aa78c$var$tablelvl2,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($44d2089cb08aa78c$var$TableHeadRoot, (0, $aJx1R.default)({
            as: component,
            className: (0, $4qr5a.default)(classes.root, className),
            ref: ref,
            role: component === $44d2089cb08aa78c$var$defaultComponent ? null : "rowgroup",
            ownerState: ownerState
        }, other))
    });
});
var $44d2089cb08aa78c$export$2e2bcd8739ae039 = $44d2089cb08aa78c$var$TableHead;



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");


var $2f0D3 = parcelRequire("2f0D3");




var $fXwzw = parcelRequire("fXwzw");

var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $57a73fc7bfb89ce4$export$717666c39ec07e12(slot) {
    return (0, $dC5O8.default)("MuiFormControlLabel", slot);
}
const $57a73fc7bfb89ce4$var$formControlLabelClasses = (0, $kY7HX.default)("MuiFormControlLabel", [
    "root",
    "labelPlacementStart",
    "labelPlacementTop",
    "labelPlacementBottom",
    "disabled",
    "label",
    "error",
    "required",
    "asterisk"
]);
var $57a73fc7bfb89ce4$export$2e2bcd8739ae039 = $57a73fc7bfb89ce4$var$formControlLabelClasses;




var $aSiaI = parcelRequire("aSiaI");
"use client";
const $412387e41715fadc$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $412387e41715fadc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            `labelPlacement${(0, $fXwzw.default)(labelPlacement)}`,
            error && "error",
            required && "required"
        ],
        label: [
            "label",
            disabled && "disabled"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $57a73fc7bfb89ce4$export$717666c39ec07e12), classes);
};
const $412387e41715fadc$export$1b479270917a5676 = (0, $jawKn.default)("label", {
    name: "MuiFormControlLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $57a73fc7bfb89ce4$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $fXwzw.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        // For correct alignment with the text.
        verticalAlign: "middle",
        WebkitTapHighlightColor: "transparent",
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $57a73fc7bfb89ce4$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        }
    }, ownerState.labelPlacement === "start" && {
        flexDirection: "row-reverse",
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === "top" && {
        flexDirection: "column-reverse",
        marginLeft: 16
    }, ownerState.labelPlacement === "bottom" && {
        flexDirection: "column",
        marginLeft: 16
    }, {
        [`& .${(0, $57a73fc7bfb89ce4$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $57a73fc7bfb89ce4$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $412387e41715fadc$var$AsteriskComponent = (0, $jawKn.default)("span", {
    name: "MuiFormControlLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $57a73fc7bfb89ce4$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $412387e41715fadc$var$FormControlLabel = /*#__PURE__*/ $exYeM.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiFormControlLabel"
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = "end", required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $3L80X.default)(props, $412387e41715fadc$var$_excluded);
    const muiFormControl = (0, $cfe831b0e6d29047$export$2e2bcd8739ae039)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        "checked",
        "name",
        "onChange",
        "value",
        "inputRef"
    ].forEach((key)=>{
        if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") controlProps[key] = props[key];
    });
    const fcs = (0, $71d750ff2e8032c3$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $aJx1R.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $412387e41715fadc$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $680629a13f949ba0$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), (0, $aJx1R.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $4qr5a.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($412387e41715fadc$export$1b479270917a5676, (0, $aJx1R.default)({
        className: (0, $4qr5a.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $exYeM.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e10e66deff206ed9$export$2e2bcd8739ae039), {
                display: "block",
                children: [
                    label,
                    /*#__PURE__*/ (0, $aSiaI.jsxs)($412387e41715fadc$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            "*"
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $412387e41715fadc$export$2e2bcd8739ae039 = $412387e41715fadc$var$FormControlLabel;



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
"use client";
const $052899f53f587903$var$usePreviousProps = (value)=>{
    const ref = $exYeM.useRef({});
    $exYeM.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $052899f53f587903$export$2e2bcd8739ae039 = $052899f53f587903$var$usePreviousProps;


"use client";
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function $df2429e6efcbafda$var$stripDiacritics(string) {
    return typeof string.normalize !== "undefined" ? string.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : string;
}
function $df2429e6efcbafda$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = "any", stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $df2429e6efcbafda$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $df2429e6efcbafda$var$stripDiacritics(candidate);
            return matchFrom === "start" ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === "number" ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
// To replace with .findIndex() once we stop IE11 support.
function $df2429e6efcbafda$var$findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
const $df2429e6efcbafda$var$defaultFilterOptions = $df2429e6efcbafda$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $df2429e6efcbafda$var$pageSize = 5;
const $df2429e6efcbafda$var$defaultIsActiveElementInListbox = (listboxRef)=>{
    var _listboxRef$current$p;
    return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
function $df2429e6efcbafda$export$1e40b3ca02d92d21(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $df2429e6efcbafda$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = "Mui", autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = "useAutocomplete", defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $df2429e6efcbafda$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $43c7ad0c22f8e14a$export$2e2bcd8739ae039)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== "string") return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $exYeM.useRef(false);
    const firstFocus = $exYeM.useRef(true);
    const inputRef = $exYeM.useRef(null);
    const listboxRef = $exYeM.useRef(null);
    const [anchorEl, setAnchorEl] = $exYeM.useState(null);
    const [focusedTag, setFocusedTag] = $exYeM.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $exYeM.useRef(defaultHighlighted);
    const [value, setValueState] = (0, $d86ef59ee77e84fd$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $d86ef59ee77e84fd$export$2e2bcd8739ae039)({
        controlled: inputValueProp,
        default: "",
        name: componentName,
        state: "inputValue"
    });
    const [focused, setFocused] = $exYeM.useState(false);
    const resetInputValue = $exYeM.useCallback((event, newValue)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = "";
        else if (newValue == null) newInputValue = "";
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === "string" ? optionLabel : "";
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, "reset");
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $d86ef59ee77e84fd$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: "open"
    });
    const [inputPristine, setInputPristine] = $exYeM.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? "" : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $052899f53f587903$export$2e2bcd8739ae039)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $exYeM.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $exYeM.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute("aria-disabled") === "true";
            if (option && option.hasAttribute("tabindex") && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === "next") nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)(({ event: event, index: index, reason: reason = "auto" })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute("aria-activedescendant");
        else inputRef.current.setAttribute("aria-activedescendant", `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute("role") !== "listbox") listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === "keyboard") option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== "mouse" && reason !== "touch") {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)(({ event: event, diff: diff, direction: direction = "next", reason: reason = "auto" })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === "reset") return defaultHighlighted;
            if (diff === "start") return 0;
            if (diff === "end") return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== "reset") {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : "";
            const label2 = value2 ? getOptionLabel(value2) : "";
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return $df2429e6efcbafda$var$findIndex(filteredOptions, (option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $exYeM.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            highlightedIndexRef.current = previousHighlightedOptionIndex;
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: "reset"
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && $df2429e6efcbafda$var$findIndex(value, (val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = $df2429e6efcbafda$var$findIndex(filteredOptions, (optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: "reset"
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((node)=>{
        (0, $07cd8eb63b27fd4d$export$2e2bcd8739ae039)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $exYeM.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $exYeM.useRef(false);
    const selectNewValue = (event, option, reasonProp = "selectOption", origin = "options")=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = $df2429e6efcbafda$var$findIndex(newValue, (valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== "freeSolo") {
                newValue.splice(itemIndex, 1);
                reason = "removeOption";
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === "touch" && isTouch.current || blurOnSelect === "mouse" && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === "next" && nextFocus === value.length || direction === "previous" && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute("tabindex") || option.disabled || option.getAttribute("aria-disabled") === "true") nextFocus += direction === "next" ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === "") handleClose(event, "toggleInput");
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === "" && direction === "previous") nextTag = value.length - 1;
        } else {
            nextTag += direction === "next" ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState("");
        if (onInputChange) onInputChange(event, "", "clear");
        handleValue(event, multiple ? [] : null, "clear");
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && [
                "ArrowLeft",
                "ArrowRight"
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case "Home":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "start",
                            direction: "next",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "End":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "end",
                            direction: "previous",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "PageUp":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$df2429e6efcbafda$var$pageSize,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "PageDown":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $df2429e6efcbafda$var$pageSize,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowDown":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowUp":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowLeft":
                    handleFocusTag(event, "previous");
                    break;
                case "ArrowRight":
                    handleFocusTag(event, "next");
                    break;
                case "Enter":
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, "selectOption");
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== "" && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, "createOption", "freeSolo");
                    }
                    break;
                case "Escape":
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, "escape");
                    } else if (clearOnEscape && (inputValue !== "" || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case "Backspace":
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === "" && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                case "Delete":
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === "" && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], "blur");
        else if (autoSelect && freeSolo && inputValue !== "") selectNewValue(event, inputValue, "blur", "freeSolo");
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, "blur");
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, "input");
        }
        if (newValue === "") {
            if (!disableClearable && !multiple) handleValue(event, null, "clear");
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: "mouse"
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute("data-option-index")),
            reason: "touch"
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        selectNewValue(event, filteredOptions[index], "selectOption");
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, "removeOption", {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, "toggleInput");
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute("id") !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === "" || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, $aJx1R.default)({
                "aria-owns": listboxAvailable ? `${id}-listbox` : null
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                "aria-activedescendant": popupOpen ? "" : null,
                "aria-autocomplete": autoComplete ? "both" : "list",
                "aria-controls": listboxAvailable ? `${id}-listbox` : undefined,
                "aria-expanded": listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: "off",
                ref: inputRef,
                autoCapitalize: "none",
                spellCheck: "false",
                role: "combobox",
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: "button",
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: "button",
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>(0, $aJx1R.default)({
                key: index,
                "data-tag-index": index,
                tabIndex: -1
            }, !readOnly && {
                onDelete: handleTagDelete(index)
            }),
        getListboxProps: ()=>({
                role: "listbox",
                id: `${id}-listbox`,
                "aria-labelledby": `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            var _getOptionKey;
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: (_getOptionKey = getOptionKey == null ? void 0 : getOptionKey(option)) != null ? _getOptionKey : getOptionLabel(option),
                tabIndex: -1,
                role: "option",
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                "data-option-index": index,
                "aria-disabled": disabled,
                "aria-selected": selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}



var $2f0D3 = parcelRequire("2f0D3");

var $8L988 = parcelRequire("8L988");


var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");

var $fXwzw = parcelRequire("fXwzw");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $16a68cdebddb1872$export$6816d4fc0981ec7(slot) {
    return (0, $dC5O8.default)("MuiListSubheader", slot);
}
const $16a68cdebddb1872$var$listSubheaderClasses = (0, $kY7HX.default)("MuiListSubheader", [
    "root",
    "colorPrimary",
    "colorInherit",
    "gutters",
    "inset",
    "sticky"
]);
var $16a68cdebddb1872$export$2e2bcd8739ae039 = $16a68cdebddb1872$var$listSubheaderClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $42b3c38ff0dfe61c$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $42b3c38ff0dfe61c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "default" && `color${(0, $fXwzw.default)(color)}`,
            !disableGutters && "gutters",
            inset && "inset",
            !disableSticky && "sticky"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $16a68cdebddb1872$export$6816d4fc0981ec7), classes);
};
const $42b3c38ff0dfe61c$var$ListSubheaderRoot = (0, $jawKn.default)("li", {
    name: "MuiListSubheader",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $fXwzw.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        boxSizing: "border-box",
        lineHeight: "48px",
        listStyle: "none",
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === "primary" && {
        color: (theme.vars || theme).palette.primary.main
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: "sticky",
        top: 0,
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $42b3c38ff0dfe61c$var$ListSubheader = /*#__PURE__*/ $exYeM.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiListSubheader"
    });
    const { className: className, color: color = "default", component: component = "li", disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $3L80X.default)(props, $42b3c38ff0dfe61c$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $42b3c38ff0dfe61c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($42b3c38ff0dfe61c$var$ListSubheaderRoot, (0, $aJx1R.default)({
        as: component,
        className: (0, $4qr5a.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$42b3c38ff0dfe61c$var$ListSubheader.muiSkipListHighlight = true;
var $42b3c38ff0dfe61c$export$2e2bcd8739ae039 = $42b3c38ff0dfe61c$var$ListSubheader;





var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $8L988 = parcelRequire("8L988");
parcelRequire("exYeM");

var $bPz57 = parcelRequire("bPz57");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $f10fe96c6368dbe9$export$2e2bcd8739ae039 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");





var $fXwzw = parcelRequire("fXwzw");


var $7PWLt = parcelRequire("7PWLt");

var $jawKn = parcelRequire("jawKn");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $a258c6670d42d284$export$31444911e4ee6fdd(slot) {
    return (0, $dC5O8.default)("MuiChip", slot);
}
const $a258c6670d42d284$var$chipClasses = (0, $kY7HX.default)("MuiChip", [
    "root",
    "sizeSmall",
    "sizeMedium",
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "disabled",
    "clickable",
    "clickableColorPrimary",
    "clickableColorSecondary",
    "deletable",
    "deletableColorPrimary",
    "deletableColorSecondary",
    "outlined",
    "filled",
    "outlinedPrimary",
    "outlinedSecondary",
    "filledPrimary",
    "filledSecondary",
    "avatar",
    "avatarSmall",
    "avatarMedium",
    "avatarColorPrimary",
    "avatarColorSecondary",
    "icon",
    "iconSmall",
    "iconMedium",
    "iconColorPrimary",
    "iconColorSecondary",
    "label",
    "labelSmall",
    "labelMedium",
    "deleteIcon",
    "deleteIconSmall",
    "deleteIconMedium",
    "deleteIconColorPrimary",
    "deleteIconColorSecondary",
    "deleteIconOutlinedColorPrimary",
    "deleteIconOutlinedColorSecondary",
    "deleteIconFilledColorPrimary",
    "deleteIconFilledColorSecondary",
    "focusVisible"
]);
var $a258c6670d42d284$export$2e2bcd8739ae039 = $a258c6670d42d284$var$chipClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $8b19ed05d27c6095$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $8b19ed05d27c6095$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            disabled && "disabled",
            `size${(0, $fXwzw.default)(size)}`,
            `color${(0, $fXwzw.default)(color)}`,
            clickable && "clickable",
            clickable && `clickableColor${(0, $fXwzw.default)(color)}`,
            onDelete && "deletable",
            onDelete && `deletableColor${(0, $fXwzw.default)(color)}`,
            `${variant}${(0, $fXwzw.default)(color)}`
        ],
        label: [
            "label",
            `label${(0, $fXwzw.default)(size)}`
        ],
        avatar: [
            "avatar",
            `avatar${(0, $fXwzw.default)(size)}`,
            `avatarColor${(0, $fXwzw.default)(color)}`
        ],
        icon: [
            "icon",
            `icon${(0, $fXwzw.default)(size)}`,
            `iconColor${(0, $fXwzw.default)(iconColor)}`
        ],
        deleteIcon: [
            "deleteIcon",
            `deleteIcon${(0, $fXwzw.default)(size)}`,
            `deleteIconColor${(0, $fXwzw.default)(color)}`,
            `deleteIcon${(0, $fXwzw.default)(variant)}Color${(0, $fXwzw.default)(color)}`
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $a258c6670d42d284$export$31444911e4ee6fdd), classes);
};
const $8b19ed05d27c6095$var$ChipRoot = (0, $jawKn.default)("div", {
    name: "MuiChip",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $a258c6670d42d284$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $a258c6670d42d284$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $fXwzw.default)(size)}`]
            },
            {
                [`& .${(0, $a258c6670d42d284$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $fXwzw.default)(color)}`]
            },
            {
                [`& .${(0, $a258c6670d42d284$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $a258c6670d42d284$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $fXwzw.default)(size)}`]
            },
            {
                [`& .${(0, $a258c6670d42d284$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $fXwzw.default)(iconColor)}`]
            },
            {
                [`& .${(0, $a258c6670d42d284$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $a258c6670d42d284$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $fXwzw.default)(size)}`]
            },
            {
                [`& .${(0, $a258c6670d42d284$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $fXwzw.default)(color)}`]
            },
            {
                [`& .${(0, $a258c6670d42d284$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $fXwzw.default)(variant)}Color${(0, $fXwzw.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $fXwzw.default)(size)}`],
            styles[`color${(0, $fXwzw.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== "default" && styles[`clickableColor${(0, $fXwzw.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== "default" && styles[`deletableColor${(0, $fXwzw.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $fXwzw.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $aJx1R.default)({
        maxWidth: "100%",
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: "nowrap",
        transition: theme.transitions.create([
            "background-color",
            "box-shadow"
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: "unset",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: "none",
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: "middle",
        boxSizing: "border-box",
        [`&.${(0, $a258c6670d42d284$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: "none"
        },
        [`& .${(0, $a258c6670d42d284$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $a258c6670d42d284$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $a258c6670d42d284$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $a258c6670d42d284$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $a258c6670d42d284$export$2e2bcd8739ae039).icon}`]: (0, $aJx1R.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === "small" && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $aJx1R.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== "default" && {
            color: "inherit"
        })),
        [`& .${(0, $a258c6670d42d284$export$2e2bcd8739ae039).deleteIcon}`]: (0, $aJx1R.default)({
            WebkitTapHighlightColor: "transparent",
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $8L988.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: "pointer",
            margin: "0 5px 0 -6px",
            "&:hover": {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $8L988.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === "small" && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== "default" && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $8L988.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === "small" && {
        height: 24
    }, ownerState.color !== "default" && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $a258c6670d42d284$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $8L988.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== "default" && {
        [`&.${(0, $a258c6670d42d284$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({}, ownerState.clickable && {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $8L988.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $a258c6670d42d284$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $8L988.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        "&:active": {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== "default" && {
        [`&:hover, &.${(0, $a258c6670d42d284$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({}, ownerState.variant === "outlined" && {
        backgroundColor: "transparent",
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $a258c6670d42d284$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $a258c6670d42d284$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $a258c6670d42d284$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $a258c6670d42d284$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $a258c6670d42d284$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $a258c6670d42d284$export$2e2bcd8739ae039).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $a258c6670d42d284$export$2e2bcd8739ae039).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $a258c6670d42d284$export$2e2bcd8739ae039).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === "outlined" && ownerState.color !== "default" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $8L988.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $a258c6670d42d284$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8L988.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $a258c6670d42d284$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $8L988.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $a258c6670d42d284$export$2e2bcd8739ae039).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $8L988.alpha)(theme.palette[ownerState.color].main, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $8b19ed05d27c6095$var$ChipLabel = (0, $jawKn.default)("span", {
    name: "MuiChip",
    slot: "Label",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $fXwzw.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $aJx1R.default)({
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: "nowrap"
    }, ownerState.variant === "outlined" && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === "small" && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function $8b19ed05d27c6095$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $8b19ed05d27c6095$var$Chip = /*#__PURE__*/ $exYeM.forwardRef(function Chip(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiChip"
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = "default", component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = "medium", variant: variant = "filled", tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $3L80X.default)(props, $8b19ed05d27c6095$var$_excluded);
    const chipRef = $exYeM.useRef(null);
    const handleRef = (0, $69ecd4eca0914ac9$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $8b19ed05d27c6095$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $8b19ed05d27c6095$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === "Escape" && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $8c6774266c067eb9$export$2e2bcd8739ae039) : ComponentProp || "div";
    const ownerState = (0, $aJx1R.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $exYeM.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $8b19ed05d27c6095$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $8c6774266c067eb9$export$2e2bcd8739ae039) ? (0, $aJx1R.default)({
        component: ComponentProp || "div",
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $exYeM.isValidElement(deleteIconProp) ? /*#__PURE__*/ $exYeM.cloneElement(deleteIconProp, {
        className: (0, $4qr5a.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f10fe96c6368dbe9$export$2e2bcd8739ae039), {
        className: (0, $4qr5a.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $exYeM.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $exYeM.cloneElement(avatarProp, {
        className: (0, $4qr5a.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $exYeM.isValidElement(iconProp)) icon = /*#__PURE__*/ $exYeM.cloneElement(iconProp, {
        className: (0, $4qr5a.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($8b19ed05d27c6095$var$ChipRoot, (0, $aJx1R.default)({
        as: component,
        className: (0, $4qr5a.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $aSiaI.jsx)($8b19ed05d27c6095$var$ChipLabel, {
                className: (0, $4qr5a.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $8b19ed05d27c6095$export$2e2bcd8739ae039 = $8b19ed05d27c6095$var$Chip;






parcelRequire("exYeM");

var $bPz57 = parcelRequire("bPz57");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $8df7a3dd0a4a99f1$export$2e2bcd8739ae039 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");




var $7PWLt = parcelRequire("7PWLt");

var $jawKn = parcelRequire("jawKn");
function $800517e42ce363ac$export$ff8356348e0cc878(name) {
    return 0, $7PWLt.default;
}


var $jawKn = parcelRequire("jawKn");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $1ed54f5ccfa1e745$export$8ee01529667e66d9(slot) {
    return (0, $dC5O8.default)("MuiAutocomplete", slot);
}
const $1ed54f5ccfa1e745$var$autocompleteClasses = (0, $kY7HX.default)("MuiAutocomplete", [
    "root",
    "expanded",
    "fullWidth",
    "focused",
    "focusVisible",
    "tag",
    "tagSizeSmall",
    "tagSizeMedium",
    "hasPopupIcon",
    "hasClearIcon",
    "inputRoot",
    "input",
    "inputFocused",
    "endAdornment",
    "clearIndicator",
    "popupIndicator",
    "popupIndicatorOpen",
    "popper",
    "popperDisablePortal",
    "paper",
    "listbox",
    "loading",
    "noOptions",
    "option",
    "groupLabel",
    "groupUl"
]);
var $1ed54f5ccfa1e745$export$2e2bcd8739ae039 = $1ed54f5ccfa1e745$var$autocompleteClasses;



var $fXwzw = parcelRequire("fXwzw");


var $aSiaI = parcelRequire("aSiaI");
"use client";
var $a1a2ecef81af22aa$var$_ClearIcon, $a1a2ecef81af22aa$var$_ArrowDropDownIcon;
const $a1a2ecef81af22aa$var$_excluded = [
    "autoComplete",
    "autoHighlight",
    "autoSelect",
    "blurOnSelect",
    "ChipProps",
    "className",
    "clearIcon",
    "clearOnBlur",
    "clearOnEscape",
    "clearText",
    "closeText",
    "componentsProps",
    "defaultValue",
    "disableClearable",
    "disableCloseOnSelect",
    "disabled",
    "disabledItemsFocusable",
    "disableListWrap",
    "disablePortal",
    "filterOptions",
    "filterSelectedOptions",
    "forcePopupIcon",
    "freeSolo",
    "fullWidth",
    "getLimitTagsText",
    "getOptionDisabled",
    "getOptionKey",
    "getOptionLabel",
    "isOptionEqualToValue",
    "groupBy",
    "handleHomeEndKeys",
    "id",
    "includeInputInList",
    "inputValue",
    "limitTags",
    "ListboxComponent",
    "ListboxProps",
    "loading",
    "loadingText",
    "multiple",
    "noOptionsText",
    "onChange",
    "onClose",
    "onHighlightChange",
    "onInputChange",
    "onOpen",
    "open",
    "openOnFocus",
    "openText",
    "options",
    "PaperComponent",
    "PopperComponent",
    "popupIcon",
    "readOnly",
    "renderGroup",
    "renderInput",
    "renderOption",
    "renderTags",
    "selectOnFocus",
    "size",
    "slotProps",
    "value"
], $a1a2ecef81af22aa$var$_excluded2 = [
    "ref"
];
const $a1a2ecef81af22aa$var$useThemeProps = (0, $800517e42ce363ac$export$ff8356348e0cc878)("MuiAutocomplete");
const $a1a2ecef81af22aa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            expanded && "expanded",
            focused && "focused",
            fullWidth && "fullWidth",
            hasClearIcon && "hasClearIcon",
            hasPopupIcon && "hasPopupIcon"
        ],
        inputRoot: [
            "inputRoot"
        ],
        input: [
            "input",
            inputFocused && "inputFocused"
        ],
        tag: [
            "tag",
            `tagSize${(0, $fXwzw.default)(size)}`
        ],
        endAdornment: [
            "endAdornment"
        ],
        clearIndicator: [
            "clearIndicator"
        ],
        popupIndicator: [
            "popupIndicator",
            popupOpen && "popupIndicatorOpen"
        ],
        popper: [
            "popper",
            disablePortal && "popperDisablePortal"
        ],
        paper: [
            "paper"
        ],
        listbox: [
            "listbox"
        ],
        loading: [
            "loading"
        ],
        noOptions: [
            "noOptions"
        ],
        option: [
            "option"
        ],
        groupLabel: [
            "groupLabel"
        ],
        groupUl: [
            "groupUl"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $1ed54f5ccfa1e745$export$8ee01529667e66d9), classes);
};
const $a1a2ecef81af22aa$var$AutocompleteRoot = (0, $jawKn.default)("div", {
    name: "MuiAutocomplete",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).tag}`]: styles.tag
            },
            {
                [`& .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).tag}`]: styles[`tagSize${(0, $fXwzw.default)(size)}`]
            },
            {
                [`& .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).input}`]: styles.input
            },
            {
                [`& .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).focused} .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).clearIndicator}`]: {
        visibility: "visible"
    },
    /* Avoid double tap issue on iOS */ "@media (pointer: fine)": {
        [`&:hover .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).clearIndicator}`]: {
            visibility: "visible"
        }
    },
    [`& .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).tag}`]: {
        margin: 3,
        maxWidth: "calc(100% - 6px)"
    },
    [`& .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).inputRoot}`]: {
        flexWrap: "wrap",
        [`.${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${(0, $316ce8f6021402f0$export$2e2bcd8739ae039).root}`]: {
        paddingBottom: 1,
        "& .MuiInput-input": {
            padding: "4px 4px 4px 0px"
        }
    },
    [`& .${(0, $316ce8f6021402f0$export$2e2bcd8739ae039).root}.${(0, $0138cbd90ffadedd$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $316ce8f6021402f0$export$2e2bcd8739ae039).input}`]: {
            padding: "2px 4px 3px 0"
        }
    },
    [`& .${(0, $b036e9072dc229ae$export$2e2bcd8739ae039).root}`]: {
        padding: 9,
        [`.${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).input}`]: {
            padding: "7.5px 4px 7.5px 5px"
        },
        [`& .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $b036e9072dc229ae$export$2e2bcd8739ae039).root}.${(0, $0138cbd90ffadedd$export$2e2bcd8739ae039).sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).input}`]: {
            padding: "2.5px 4px 2.5px 8px"
        }
    },
    [`& .${(0, $83dd8e76869e15c9$export$2e2bcd8739ae039).root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $83dd8e76869e15c9$export$2e2bcd8739ae039).input}`]: {
            padding: "7px 4px"
        },
        [`& .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $83dd8e76869e15c9$export$2e2bcd8739ae039).root}.${(0, $0138cbd90ffadedd$export$2e2bcd8739ae039).sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${(0, $83dd8e76869e15c9$export$2e2bcd8739ae039).input}`]: {
            padding: "2.5px 4px"
        }
    },
    [`& .${(0, $0138cbd90ffadedd$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${(0, $83dd8e76869e15c9$export$2e2bcd8739ae039).root}.${(0, $0138cbd90ffadedd$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${(0, $83dd8e76869e15c9$export$2e2bcd8739ae039).root}.${(0, $0138cbd90ffadedd$export$2e2bcd8739ae039).hiddenLabel}.${(0, $0138cbd90ffadedd$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).input}`]: {
        flexGrow: 1,
        textOverflow: "ellipsis",
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: "100%"
            }
        },
        {
            props: {
                size: "small"
            },
            style: {
                [`& .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).tag}`]: {
                    margin: 2,
                    maxWidth: "calc(100% - 4px)"
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).input}`]: {
                    opacity: 1
                }
            }
        }
    ]
});
const $a1a2ecef81af22aa$var$AutocompleteEndAdornment = (0, $jawKn.default)("div", {
    name: "MuiAutocomplete",
    slot: "EndAdornment",
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translate(0, -50%)"
});
const $a1a2ecef81af22aa$var$AutocompleteClearIndicator = (0, $jawKn.default)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "ClearIndicator",
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: "hidden"
});
const $a1a2ecef81af22aa$var$AutocompletePopupIndicator = (0, $jawKn.default)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "PopupIndicator",
    overridesResolver: ({ ownerState: ownerState }, styles)=>(0, $aJx1R.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: "rotate(180deg)"
            }
        }
    ]
});
const $a1a2ecef81af22aa$var$AutocompletePopper = (0, $jawKn.default)((0, $5c4432cbbd879abf$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: "absolute"
                }
            }
        ]
    }));
const $a1a2ecef81af22aa$var$AutocompletePaper = (0, $jawKn.default)((0, $e479e3bd14e95ba2$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>(0, $aJx1R.default)({}, theme.typography.body1, {
        overflow: "auto"
    }));
const $a1a2ecef81af22aa$var$AutocompleteLoading = (0, $jawKn.default)("div", {
    name: "MuiAutocomplete",
    slot: "Loading",
    overridesResolver: (props, styles)=>styles.loading
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const $a1a2ecef81af22aa$var$AutocompleteNoOptions = (0, $jawKn.default)("div", {
    name: "MuiAutocomplete",
    slot: "NoOptions",
    overridesResolver: (props, styles)=>styles.noOptions
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const $a1a2ecef81af22aa$var$AutocompleteListbox = (0, $jawKn.default)("div", {
    name: "MuiAutocomplete",
    slot: "Listbox",
    overridesResolver: (props, styles)=>styles.listbox
})(({ theme: theme })=>({
        listStyle: "none",
        margin: 0,
        padding: "8px 0",
        maxHeight: "40vh",
        overflow: "auto",
        position: "relative",
        [`& .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).option}`]: {
            minHeight: 48,
            display: "flex",
            overflow: "hidden",
            justifyContent: "flex-start",
            alignItems: "center",
            cursor: "pointer",
            paddingTop: 6,
            boxSizing: "border-box",
            outline: "0",
            WebkitTapHighlightColor: "transparent",
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up("sm")]: {
                minHeight: "auto"
            },
            [`&.${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: "none"
            },
            [`&.${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $8L988.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $8L988.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $8L988.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    }));
const $a1a2ecef81af22aa$var$AutocompleteGroupLabel = (0, $jawKn.default)((0, $42b3c38ff0dfe61c$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "GroupLabel",
    overridesResolver: (props, styles)=>styles.groupLabel
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    }));
const $a1a2ecef81af22aa$var$AutocompleteGroupUl = (0, $jawKn.default)("ul", {
    name: "MuiAutocomplete",
    slot: "GroupUl",
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $1ed54f5ccfa1e745$export$2e2bcd8739ae039).option}`]: {
        paddingLeft: 24
    }
});
const $a1a2ecef81af22aa$var$Autocomplete = /*#__PURE__*/ $exYeM.forwardRef(function Autocomplete(inProps, ref) {
    var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
    const props = $a1a2ecef81af22aa$var$useThemeProps({
        props: inProps,
        name: "MuiAutocomplete"
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipProps, className: className, clearIcon: clearIcon = $a1a2ecef81af22aa$var$_ClearIcon || ($a1a2ecef81af22aa$var$_ClearIcon = /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8df7a3dd0a4a99f1$export$2e2bcd8739ae039), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = "Clear", closeText: closeText = "Close", componentsProps: componentsProps = {}, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = "auto", freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionLabel: getOptionLabelProp, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, includeInputInList: includeInputInList = false, limitTags: limitTags = -1, ListboxComponent: ListboxComponent = "ul", ListboxProps: ListboxProps, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = "No options", openOnFocus: openOnFocus = false, openText: openText = "Open", PaperComponent: PaperComponent = (0, $e479e3bd14e95ba2$export$2e2bcd8739ae039), PopperComponent: PopperComponent = (0, $5c4432cbbd879abf$export$2e2bcd8739ae039), popupIcon: popupIcon = $a1a2ecef81af22aa$var$_ArrowDropDownIcon || ($a1a2ecef81af22aa$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $aSiaI.jsx)((0, $77a9aff961352e6f$export$2e2bcd8739ae039), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = "medium", slotProps: slotProps = {} } = props, other = (0, $3L80X.default)(props, $a1a2ecef81af22aa$var$_excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $df2429e6efcbafda$export$1e40b3ca02d92d21)((0, $aJx1R.default)({}, props, {
        componentName: "Autocomplete"
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: externalListboxRef } = ListboxProps != null ? ListboxProps : {};
    const _getListboxProps = getListboxProps(), { ref: listboxRef } = _getListboxProps, otherListboxProps = (0, $3L80X.default)(_getListboxProps, $a1a2ecef81af22aa$var$_excluded2);
    const combinedListboxRef = (0, $69ecd4eca0914ac9$export$2e2bcd8739ae039)(listboxRef, externalListboxRef);
    const defaultGetOptionLabel = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    };
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = (0, $aJx1R.default)({}, props, {
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    });
    const classes = $a1a2ecef81af22aa$var$useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>(0, $aJx1R.default)({
                className: classes.tag,
                disabled: disabled
            }, getTagProps(params));
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $8b19ed05d27c6095$export$2e2bcd8739ae039), (0, $aJx1R.default)({
                label: getOptionLabel(option),
                size: size
            }, getCustomizedTagProps({
                index: index
            }), ChipProps)));
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $aSiaI.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)($a1a2ecef81af22aa$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)($a1a2ecef81af22aa$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        return /*#__PURE__*/ (0, $exYeM.createElement)("li", (0, $aJx1R.default)({}, props2, {
            key: props2.key
        }), getOptionLabel(option));
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption((0, $aJx1R.default)({}, optionProps, {
            className: classes.option
        }), option, {
            selected: optionProps["aria-selected"],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
    const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
    const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
    const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
    const renderAutocompletePopperChildren = (children)=>/*#__PURE__*/ (0, $aSiaI.jsx)($a1a2ecef81af22aa$var$AutocompletePopper, (0, $aJx1R.default)({
            as: PopperComponent,
            disablePortal: disablePortal,
            style: {
                width: anchorEl ? anchorEl.clientWidth : null
            },
            ownerState: ownerState,
            role: "presentation",
            anchorEl: anchorEl,
            open: popupOpen
        }, popperSlotProps, {
            className: (0, $4qr5a.default)(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
            children: /*#__PURE__*/ (0, $aSiaI.jsx)($a1a2ecef81af22aa$var$AutocompletePaper, (0, $aJx1R.default)({
                ownerState: ownerState,
                as: PaperComponent
            }, paperSlotProps, {
                className: (0, $4qr5a.default)(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
                children: children
            }))
        }));
    let autocompletePopper = null;
    if (groupedOptions.length > 0) autocompletePopper = renderAutocompletePopperChildren(/*#__PURE__*/ (0, $aSiaI.jsx)($a1a2ecef81af22aa$var$AutocompleteListbox, (0, $aJx1R.default)({
        as: ListboxComponent,
        className: classes.listbox,
        ownerState: ownerState
    }, otherListboxProps, ListboxProps, {
        ref: combinedListboxRef,
        children: groupedOptions.map((option, index)=>{
            if (groupBy) return renderGroup({
                key: option.key,
                group: option.group,
                children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
            });
            return renderListOption(option, index);
        })
    })));
    else if (loading && groupedOptions.length === 0) autocompletePopper = renderAutocompletePopperChildren(/*#__PURE__*/ (0, $aSiaI.jsx)($a1a2ecef81af22aa$var$AutocompleteLoading, {
        className: classes.loading,
        ownerState: ownerState,
        children: loadingText
    }));
    else if (groupedOptions.length === 0 && !freeSolo && !loading) autocompletePopper = renderAutocompletePopperChildren(/*#__PURE__*/ (0, $aSiaI.jsx)($a1a2ecef81af22aa$var$AutocompleteNoOptions, {
        className: classes.noOptions,
        ownerState: ownerState,
        role: "presentation",
        onMouseDown: (event)=>{
            // Prevent input blur when interacting with the "no options" content
            event.preventDefault();
        },
        children: noOptionsText
    }));
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)($a1a2ecef81af22aa$var$AutocompleteRoot, (0, $aJx1R.default)({
                ref: ref,
                className: (0, $4qr5a.default)(classes.root, className),
                ownerState: ownerState
            }, getRootProps(other), {
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === "small" ? "small" : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: (0, $aJx1R.default)({
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onClick: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        }
                    }, (hasClearIcon || hasPopupIcon) && {
                        endAdornment: /*#__PURE__*/ (0, $aSiaI.jsxs)($a1a2ecef81af22aa$var$AutocompleteEndAdornment, {
                            className: classes.endAdornment,
                            ownerState: ownerState,
                            children: [
                                hasClearIcon ? /*#__PURE__*/ (0, $aSiaI.jsx)($a1a2ecef81af22aa$var$AutocompleteClearIndicator, (0, $aJx1R.default)({}, getClearProps(), {
                                    "aria-label": clearText,
                                    title: clearText,
                                    ownerState: ownerState
                                }, clearIndicatorSlotProps, {
                                    className: (0, $4qr5a.default)(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
                                    children: clearIcon
                                })) : null,
                                hasPopupIcon ? /*#__PURE__*/ (0, $aSiaI.jsx)($a1a2ecef81af22aa$var$AutocompletePopupIndicator, (0, $aJx1R.default)({}, getPopupIndicatorProps(), {
                                    disabled: disabled,
                                    "aria-label": popupOpen ? closeText : openText,
                                    title: popupOpen ? closeText : openText,
                                    ownerState: ownerState
                                }, popupIndicatorSlotProps, {
                                    className: (0, $4qr5a.default)(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
                                    children: popupIcon
                                })) : null
                            ]
                        })
                    }),
                    inputProps: (0, $aJx1R.default)({
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly
                    }, getInputProps())
                })
            })),
            anchorEl ? autocompletePopper : null
        ]
    });
});
var $a1a2ecef81af22aa$export$2e2bcd8739ae039 = $a1a2ecef81af22aa$var$Autocomplete;




var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $fXwzw = parcelRequire("fXwzw");




var $jawKn = parcelRequire("jawKn");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $cc53d635c1fc0926$export$4b135a4b3a6c4550(slot) {
    return (0, $dC5O8.default)("MuiInputAdornment", slot);
}
const $cc53d635c1fc0926$var$inputAdornmentClasses = (0, $kY7HX.default)("MuiInputAdornment", [
    "root",
    "filled",
    "standard",
    "outlined",
    "positionStart",
    "positionEnd",
    "disablePointerEvents",
    "hiddenLabel",
    "sizeSmall"
]);
var $cc53d635c1fc0926$export$2e2bcd8739ae039 = $cc53d635c1fc0926$var$inputAdornmentClasses;



var $7PWLt = parcelRequire("7PWLt");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $60f459c5525ea035$var$_span;
const $60f459c5525ea035$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $60f459c5525ea035$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $fXwzw.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $60f459c5525ea035$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            disablePointerEvents && "disablePointerEvents",
            position && `position${(0, $fXwzw.default)(position)}`,
            variant,
            hiddenLabel && "hiddenLabel",
            size && `size${(0, $fXwzw.default)(size)}`
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $cc53d635c1fc0926$export$4b135a4b3a6c4550), classes);
};
const $60f459c5525ea035$var$InputAdornmentRoot = (0, $jawKn.default)("div", {
    name: "MuiInputAdornment",
    slot: "Root",
    overridesResolver: $60f459c5525ea035$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        display: "flex",
        height: "0.01em",
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: "2em",
        alignItems: "center",
        whiteSpace: "nowrap",
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === "filled" && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $cc53d635c1fc0926$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $cc53d635c1fc0926$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === "start" && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === "end" && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: "none"
    }));
const $60f459c5525ea035$var$InputAdornment = /*#__PURE__*/ $exYeM.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiInputAdornment"
    });
    const { children: children, className: className, component: component = "div", disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $3L80X.default)(props, $60f459c5525ea035$var$_excluded);
    const muiFormControl = (0, $cfe831b0e6d29047$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $aJx1R.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $60f459c5525ea035$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $58875f077a566e4b$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($60f459c5525ea035$var$InputAdornmentRoot, (0, $aJx1R.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $4qr5a.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === "string" && !disableTypography ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
                children: [
                    position === "start" ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $60f459c5525ea035$var$_span || ($60f459c5525ea035$var$_span = /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $60f459c5525ea035$export$2e2bcd8739ae039 = $60f459c5525ea035$var$InputAdornment;




var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");


var $4ivqW = parcelRequire("4ivqW");

var $ar2vM = parcelRequire("ar2vM");
"use client";
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $584e1e930413ffa8$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $exYeM.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $c4c3f9798cb7fddc$export$2e2bcd8739ae039)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $584e1e930413ffa8$var$maybeReactUseSyncExternalStore = $exYeM.useSyncExternalStore;
function $584e1e930413ffa8$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $exYeM.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $exYeM.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $exYeM.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $584e1e930413ffa8$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $584e1e930413ffa8$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $ar2vM.default)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $4ivqW.default)({
        name: "MuiUseMediaQuery",
        props: options,
        theme: theme
    });
    let query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, "");
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $584e1e930413ffa8$var$maybeReactUseSyncExternalStore !== undefined ? $584e1e930413ffa8$var$useMediaQueryNew : $584e1e930413ffa8$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}



var $7PWLt = parcelRequire("7PWLt");


var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $bisEj = parcelRequire("bisEj");


var $bisEj = parcelRequire("bisEj");
const $5470a96ab2e549fc$var$refType = (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object
]);
var $5470a96ab2e549fc$export$2e2bcd8739ae039 = $5470a96ab2e549fc$var$refType;



var $3L80X = parcelRequire("3L80X");
const $a33a4d7002be5215$export$f07872cd524bec98 = (views, expectedViews)=>{
    if (views.length !== expectedViews.length) return false;
    return expectedViews.every((expectedView)=>views.includes(expectedView));
};
const $a33a4d7002be5215$export$bdf8d867ddc968e = ({ openTo: openTo, defaultOpenTo: defaultOpenTo, views: views, defaultViews: defaultViews })=>{
    const viewsWithDefault = views ?? defaultViews;
    let openToWithDefault;
    if (openTo != null) openToWithDefault = openTo;
    else if (viewsWithDefault.includes(defaultOpenTo)) openToWithDefault = defaultOpenTo;
    else if (viewsWithDefault.length > 0) openToWithDefault = viewsWithDefault[0];
    else throw new Error("MUI X: The `views` prop must contain at least one view.");
    return {
        views: viewsWithDefault,
        openTo: openToWithDefault
    };
};


const $8c165bb53d94cf45$export$a98b123b8f29e004 = (utils, dateParam, timeParam)=>{
    let mergedDate = dateParam;
    mergedDate = utils.setHours(mergedDate, utils.getHours(timeParam));
    mergedDate = utils.setMinutes(mergedDate, utils.getMinutes(timeParam));
    mergedDate = utils.setSeconds(mergedDate, utils.getSeconds(timeParam));
    return mergedDate;
};
const $8c165bb53d94cf45$export$ca1f317ae8db2ee8 = ({ date: date, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, isDateDisabled: isDateDisabled, utils: utils, timezone: timezone })=>{
    const today = $8c165bb53d94cf45$export$a98b123b8f29e004(utils, utils.date(undefined, timezone), date);
    if (disablePast && utils.isBefore(minDate, today)) minDate = today;
    if (disableFuture && utils.isAfter(maxDate, today)) maxDate = today;
    let forward = date;
    let backward = date;
    if (utils.isBefore(date, minDate)) {
        forward = minDate;
        backward = null;
    }
    if (utils.isAfter(date, maxDate)) {
        if (backward) backward = maxDate;
        forward = null;
    }
    while(forward || backward){
        if (forward && utils.isAfter(forward, maxDate)) forward = null;
        if (backward && utils.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!isDateDisabled(forward)) return forward;
            forward = utils.addDays(forward, 1);
        }
        if (backward) {
            if (!isDateDisabled(backward)) return backward;
            backward = utils.addDays(backward, -1);
        }
    }
    return null;
};
const $8c165bb53d94cf45$export$36ca889e039badd5 = (utils, value)=>value == null || !utils.isValid(value) ? null : value;
const $8c165bb53d94cf45$export$eb73579ccade48fd = (utils, value, defaultValue)=>{
    if (value == null || !utils.isValid(value)) return defaultValue;
    return value;
};
const $8c165bb53d94cf45$export$8fabf9a4cbada414 = (utils, a, b)=>{
    if (!utils.isValid(a) && a != null && !utils.isValid(b) && b != null) return true;
    return utils.isEqual(a, b);
};
const $8c165bb53d94cf45$export$62591b96a734eacd = (utils, year)=>{
    const firstMonth = utils.startOfYear(year);
    const months = [
        firstMonth
    ];
    while(months.length < 12){
        const prevMonth = months[months.length - 1];
        months.push(utils.addMonths(prevMonth, 1));
    }
    return months;
};
const $8c165bb53d94cf45$export$1118e4272ea1e258 = (utils, timezone, valueType)=>valueType === "date" ? utils.startOfDay(utils.date(undefined, timezone)) : utils.date(undefined, timezone);
const $8c165bb53d94cf45$export$fae94c0a662107ef = (utils, meridiem)=>{
    const date = utils.setHours(utils.date(), meridiem === "am" ? 2 : 14);
    return utils.format(date, "meridiem");
};
const $8c165bb53d94cf45$var$dateViews = [
    "year",
    "month",
    "day"
];
const $8c165bb53d94cf45$export$b32dfef9f07dea64 = (view)=>$8c165bb53d94cf45$var$dateViews.includes(view);
const $8c165bb53d94cf45$export$bb1c921f313ec928 = (utils, { format: format, views: views }, isInToolbar)=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, $a33a4d7002be5215$export$f07872cd524bec98)(views, [
        "year"
    ])) return formats.year;
    if ((0, $a33a4d7002be5215$export$f07872cd524bec98)(views, [
        "month"
    ])) return formats.month;
    if ((0, $a33a4d7002be5215$export$f07872cd524bec98)(views, [
        "day"
    ])) return formats.dayOfMonth;
    if ((0, $a33a4d7002be5215$export$f07872cd524bec98)(views, [
        "month",
        "year"
    ])) return `${formats.month} ${formats.year}`;
    if ((0, $a33a4d7002be5215$export$f07872cd524bec98)(views, [
        "day",
        "month"
    ])) return `${formats.month} ${formats.dayOfMonth}`;
    if (isInToolbar) // Little localization hack (Google is doing the same for android native pickers):
    // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
    // For other locales using strings like "June 1", without weekday.
    return /en/.test(utils.getCurrentLocaleCode()) ? formats.normalDateWithWeekday : formats.normalDate;
    return formats.keyboardDate;
};
const $8c165bb53d94cf45$export$24c38139da66592d = (utils, date)=>{
    const start = utils.startOfWeek(date);
    return [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((diff)=>utils.addDays(start, diff));
};



const $9509391b55697f91$var$timeViews = [
    "hours",
    "minutes",
    "seconds"
];
const $9509391b55697f91$export$8f04d380cefd5a0d = (view)=>$9509391b55697f91$var$timeViews.includes(view);
const $9509391b55697f91$export$a3328136ac50623d = (view)=>$9509391b55697f91$var$timeViews.includes(view) || view === "meridiem";
const $9509391b55697f91$export$c3352ead7b032236 = (date, utils)=>{
    if (!date) return null;
    return utils.getHours(date) >= 12 ? "pm" : "am";
};
const $9509391b55697f91$export$4159dc823695870e = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? "pm" : "am";
        if (currentMeridiem !== meridiem) return meridiem === "am" ? value - 12 : value + 12;
    }
    return value;
};
const $9509391b55697f91$export$c368d4ff66779998 = (time, meridiem, ampm, utils)=>{
    const newHoursAmount = $9509391b55697f91$export$4159dc823695870e(utils.getHours(time), meridiem, ampm);
    return utils.setHours(time, newHoursAmount);
};
const $9509391b55697f91$export$888a1ce13aa61986 = (date, utils)=>{
    return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
};
const $9509391b55697f91$export$fb87c80b35a46b89 = (disableIgnoringDatePartForTimeValidation, utils)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return utils.isAfter(dateLeft, dateRight);
        return $9509391b55697f91$export$888a1ce13aa61986(dateLeft, utils) > $9509391b55697f91$export$888a1ce13aa61986(dateRight, utils);
    };
const $9509391b55697f91$export$3a6776b3863772fe = (utils, { format: format, views: views, ampm: ampm })=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, $a33a4d7002be5215$export$f07872cd524bec98)(views, [
        "hours"
    ])) return ampm ? `${formats.hours12h} ${formats.meridiem}` : formats.hours24h;
    if ((0, $a33a4d7002be5215$export$f07872cd524bec98)(views, [
        "minutes"
    ])) return formats.minutes;
    if ((0, $a33a4d7002be5215$export$f07872cd524bec98)(views, [
        "seconds"
    ])) return formats.seconds;
    if ((0, $a33a4d7002be5215$export$f07872cd524bec98)(views, [
        "minutes",
        "seconds"
    ])) return `${formats.minutes}:${formats.seconds}`;
    if ((0, $a33a4d7002be5215$export$f07872cd524bec98)(views, [
        "hours",
        "minutes",
        "seconds"
    ])) return ampm ? `${formats.hours12h}:${formats.minutes}:${formats.seconds} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}:${formats.seconds}`;
    return ampm ? `${formats.hours12h}:${formats.minutes} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}`;
};



const $bd0cf02b8b64cf79$export$8f74e8f4ed8ae0ac = {
    year: 1,
    month: 2,
    day: 3,
    hours: 4,
    minutes: 5,
    seconds: 6,
    milliseconds: 7
};
const $bd0cf02b8b64cf79$export$3f2547ddf892237a = (sections)=>Math.max(...sections.map((section)=>$bd0cf02b8b64cf79$export$8f74e8f4ed8ae0ac[section.type] ?? 1));
const $bd0cf02b8b64cf79$var$roundDate = (utils, granularity, date)=>{
    if (granularity === $bd0cf02b8b64cf79$export$8f74e8f4ed8ae0ac.year) return utils.startOfYear(date);
    if (granularity === $bd0cf02b8b64cf79$export$8f74e8f4ed8ae0ac.month) return utils.startOfMonth(date);
    if (granularity === $bd0cf02b8b64cf79$export$8f74e8f4ed8ae0ac.day) return utils.startOfDay(date);
    // We don't have startOfHour / startOfMinute / startOfSecond
    let roundedDate = date;
    if (granularity < $bd0cf02b8b64cf79$export$8f74e8f4ed8ae0ac.minutes) roundedDate = utils.setMinutes(roundedDate, 0);
    if (granularity < $bd0cf02b8b64cf79$export$8f74e8f4ed8ae0ac.seconds) roundedDate = utils.setSeconds(roundedDate, 0);
    if (granularity < $bd0cf02b8b64cf79$export$8f74e8f4ed8ae0ac.milliseconds) roundedDate = utils.setMilliseconds(roundedDate, 0);
    return roundedDate;
};
const $bd0cf02b8b64cf79$export$6a31d56794238e4e = ({ props: props, utils: utils, granularity: granularity, timezone: timezone, getTodayDate: inGetTodayDate })=>{
    let referenceDate = inGetTodayDate ? inGetTodayDate() : $bd0cf02b8b64cf79$var$roundDate(utils, granularity, (0, $8c165bb53d94cf45$export$1118e4272ea1e258)(utils, timezone));
    if (props.minDate != null && utils.isAfterDay(props.minDate, referenceDate)) referenceDate = $bd0cf02b8b64cf79$var$roundDate(utils, granularity, props.minDate);
    if (props.maxDate != null && utils.isBeforeDay(props.maxDate, referenceDate)) referenceDate = $bd0cf02b8b64cf79$var$roundDate(utils, granularity, props.maxDate);
    const isAfter = (0, $9509391b55697f91$export$fb87c80b35a46b89)(props.disableIgnoringDatePartForTimeValidation ?? false, utils);
    if (props.minTime != null && isAfter(props.minTime, referenceDate)) referenceDate = $bd0cf02b8b64cf79$var$roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : (0, $8c165bb53d94cf45$export$a98b123b8f29e004)(utils, referenceDate, props.minTime));
    if (props.maxTime != null && isAfter(referenceDate, props.maxTime)) referenceDate = $bd0cf02b8b64cf79$var$roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : (0, $8c165bb53d94cf45$export$a98b123b8f29e004)(utils, referenceDate, props.maxTime));
    return referenceDate;
};



const $26f4e5858fb820e2$export$2f3c5fac7a2a65f6 = (utils, formatToken)=>{
    const config = utils.formatTokenMap[formatToken];
    if (config == null) throw new Error([
        `MUI X: The token "${formatToken}" is not supported by the Date and Time Pickers.`,
        "Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported."
    ].join("\n"));
    if (typeof config === "string") return {
        type: config,
        contentType: config === "meridiem" ? "letter" : "digit",
        maxLength: undefined
    };
    return {
        type: config.sectionType,
        contentType: config.contentType,
        maxLength: config.maxLength
    };
};
const $26f4e5858fb820e2$var$getDeltaFromKeyCode = (keyCode)=>{
    switch(keyCode){
        case "ArrowUp":
            return 1;
        case "ArrowDown":
            return -1;
        case "PageUp":
            return 5;
        case "PageDown":
            return -5;
        default:
            return 0;
    }
};
const $26f4e5858fb820e2$export$c65c7173f879039f = (utils, timezone, format)=>{
    const elements = [];
    const now = utils.date(undefined, timezone);
    const startDate = utils.startOfWeek(now);
    const endDate = utils.endOfWeek(now);
    let current = startDate;
    while(utils.isBefore(current, endDate)){
        elements.push(current);
        current = utils.addDays(current, 1);
    }
    return elements.map((weekDay)=>utils.formatByString(weekDay, format));
};
const $26f4e5858fb820e2$export$3ee1e7e19c2b047a = (utils, timezone, sectionType, format)=>{
    switch(sectionType){
        case "month":
            return (0, $8c165bb53d94cf45$export$62591b96a734eacd)(utils, utils.date(undefined, timezone)).map((month)=>utils.formatByString(month, format));
        case "weekDay":
            return $26f4e5858fb820e2$export$c65c7173f879039f(utils, timezone, format);
        case "meridiem":
            {
                const now = utils.date(undefined, timezone);
                return [
                    utils.startOfDay(now),
                    utils.endOfDay(now)
                ].map((date)=>utils.formatByString(date, format));
            }
        default:
            return [];
    }
};
const $26f4e5858fb820e2$export$b918512475916205 = "s";
const $26f4e5858fb820e2$var$NON_LOCALIZED_DIGITS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
];
const $26f4e5858fb820e2$export$b42be9ae7016ef5d = (utils)=>{
    const today = utils.date(undefined);
    const formattedZero = utils.formatByString(utils.setSeconds(today, 0), $26f4e5858fb820e2$export$b918512475916205);
    if (formattedZero === "0") return $26f4e5858fb820e2$var$NON_LOCALIZED_DIGITS;
    return Array.from({
        length: 10
    }).map((_, index)=>utils.formatByString(utils.setSeconds(today, index), $26f4e5858fb820e2$export$b918512475916205));
};
const $26f4e5858fb820e2$export$7dd321105a319e8 = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === "0") return valueStr;
    const digits = [];
    let currentFormattedDigit = "";
    for(let i = 0; i < valueStr.length; i += 1){
        currentFormattedDigit += valueStr[i];
        const matchingDigitIndex = localizedDigits.indexOf(currentFormattedDigit);
        if (matchingDigitIndex > -1) {
            digits.push(matchingDigitIndex.toString());
            currentFormattedDigit = "";
        }
    }
    return digits.join("");
};
const $26f4e5858fb820e2$export$80dbbc19eba82070 = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === "0") return valueStr;
    return valueStr.split("").map((char)=>localizedDigits[Number(char)]).join("");
};
const $26f4e5858fb820e2$export$c28be6c4c9d8f124 = (valueStr, localizedDigits)=>{
    const nonLocalizedValueStr = $26f4e5858fb820e2$export$7dd321105a319e8(valueStr, localizedDigits);
    return !Number.isNaN(Number(nonLocalizedValueStr));
};
const $26f4e5858fb820e2$export$713c6d756c12fc27 = (valueStr, size)=>{
    let cleanValueStr = valueStr;
    // Remove the leading zeros
    cleanValueStr = Number(cleanValueStr).toString();
    // Add enough leading zeros to fill the section
    while(cleanValueStr.length < size)cleanValueStr = `0${cleanValueStr}`;
    return cleanValueStr;
};
const $26f4e5858fb820e2$export$ef88db4bceade9fd = (utils, value, sectionBoundaries, localizedDigits, section)=>{
    if (section.type === "day" && section.contentType === "digit-with-letter") {
        const date = utils.setDate(sectionBoundaries.longestMonth, value);
        return utils.formatByString(date, section.format);
    }
    // queryValue without leading `0` (`01` => `1`)
    let valueStr = value.toString();
    if (section.hasLeadingZerosInInput) valueStr = $26f4e5858fb820e2$export$713c6d756c12fc27(valueStr, section.maxLength);
    return $26f4e5858fb820e2$export$80dbbc19eba82070(valueStr, localizedDigits);
};
const $26f4e5858fb820e2$export$5ed0f22513e58fe3 = (utils, timezone, section, keyCode, sectionsValueBoundaries, localizedDigits, activeDate, stepsAttributes)=>{
    const delta = $26f4e5858fb820e2$var$getDeltaFromKeyCode(keyCode);
    const isStart = keyCode === "Home";
    const isEnd = keyCode === "End";
    const shouldSetAbsolute = section.value === "" || isStart || isEnd;
    const adjustDigitSection = ()=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: activeDate,
            format: section.format,
            contentType: section.contentType
        });
        const getCleanValue = (value)=>$26f4e5858fb820e2$export$ef88db4bceade9fd(utils, value, sectionBoundaries, localizedDigits, section);
        const step = section.type === "minutes" && stepsAttributes?.minutesStep ? stepsAttributes.minutesStep : 1;
        const currentSectionValue = parseInt($26f4e5858fb820e2$export$7dd321105a319e8(section.value, localizedDigits), 10);
        let newSectionValueNumber = currentSectionValue + delta * step;
        if (shouldSetAbsolute) {
            if (section.type === "year" && !isEnd && !isStart) return utils.formatByString(utils.date(undefined, timezone), section.format);
            if (delta > 0 || isStart) newSectionValueNumber = sectionBoundaries.minimum;
            else newSectionValueNumber = sectionBoundaries.maximum;
        }
        if (newSectionValueNumber % step !== 0) {
            if (delta < 0 || isStart) newSectionValueNumber += step - (step + newSectionValueNumber) % step; // for JS -3 % 5 = -3 (should be 2)
            if (delta > 0 || isEnd) newSectionValueNumber -= newSectionValueNumber % step;
        }
        if (newSectionValueNumber > sectionBoundaries.maximum) return getCleanValue(sectionBoundaries.minimum + (newSectionValueNumber - sectionBoundaries.maximum - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        if (newSectionValueNumber < sectionBoundaries.minimum) return getCleanValue(sectionBoundaries.maximum - (sectionBoundaries.minimum - newSectionValueNumber - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        return getCleanValue(newSectionValueNumber);
    };
    const adjustLetterSection = ()=>{
        const options = $26f4e5858fb820e2$export$3ee1e7e19c2b047a(utils, timezone, section.type, section.format);
        if (options.length === 0) return section.value;
        if (shouldSetAbsolute) {
            if (delta > 0 || isStart) return options[0];
            return options[options.length - 1];
        }
        const currentOptionIndex = options.indexOf(section.value);
        const newOptionIndex = (currentOptionIndex + options.length + delta) % options.length;
        return options[newOptionIndex];
    };
    if (section.contentType === "digit" || section.contentType === "digit-with-letter") return adjustDigitSection();
    return adjustLetterSection();
};
const $26f4e5858fb820e2$export$85daa91f6c6e875f = (section, target, localizedDigits)=>{
    let value = section.value || section.placeholder;
    const hasLeadingZeros = target === "non-input" ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
    if (target === "non-input" && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) value = Number($26f4e5858fb820e2$export$7dd321105a319e8(value, localizedDigits)).toString();
    // In the input, we add an empty character at the end of each section without leading zeros.
    // This makes sure that `onChange` will always be fired.
    // Otherwise, when your input value equals `1/dd/yyyy` (format `M/DD/YYYY` on DayJs),
    // If you press `1`, on the first section, the new value is also `1/dd/yyyy`,
    // So the browser will not fire the input `onChange`.
    const shouldAddInvisibleSpace = [
        "input-rtl",
        "input-ltr"
    ].includes(target) && section.contentType === "digit" && !hasLeadingZeros && value.length === 1;
    if (shouldAddInvisibleSpace) value = `${value}\u200e`;
    if (target === "input-rtl") value = `\u2068${value}\u2069`;
    return value;
};
const $26f4e5858fb820e2$export$2816862a602354ce = (utils, valueStr, currentFormat, newFormat)=>{
    return utils.formatByString(utils.parse(valueStr, currentFormat), newFormat);
};
const $26f4e5858fb820e2$var$isFourDigitYearFormat = (utils, timezone, format)=>utils.formatByString(utils.date(undefined, timezone), format).length === 4;
const $26f4e5858fb820e2$export$78b5830e2dd2de49 = (utils, timezone, contentType, sectionType, format)=>{
    if (contentType !== "digit") return false;
    const now = utils.date(undefined, timezone);
    switch(sectionType){
        // We can't use `changeSectionValueFormat`, because  `utils.parse('1', 'YYYY')` returns `1971` instead of `1`.
        case "year":
            {
                if ($26f4e5858fb820e2$var$isFourDigitYearFormat(utils, timezone, format)) {
                    const formatted0001 = utils.formatByString(utils.setYear(now, 1), format);
                    return formatted0001 === "0001";
                }
                const formatted2001 = utils.formatByString(utils.setYear(now, 2001), format);
                return formatted2001 === "01";
            }
        case "month":
            return utils.formatByString(utils.startOfYear(now), format).length > 1;
        case "day":
            return utils.formatByString(utils.startOfMonth(now), format).length > 1;
        case "weekDay":
            return utils.formatByString(utils.startOfWeek(now), format).length > 1;
        case "hours":
            return utils.formatByString(utils.setHours(now, 1), format).length > 1;
        case "minutes":
            return utils.formatByString(utils.setMinutes(now, 1), format).length > 1;
        case "seconds":
            return utils.formatByString(utils.setSeconds(now, 1), format).length > 1;
        default:
            throw new Error("Invalid section type");
    }
};
const $26f4e5858fb820e2$export$b0c1bfd065bfe742 = (utils, sections, localizedDigits)=>{
    // If we have both a day and a weekDay section,
    // Then we skip the weekDay in the parsing because libraries like dayjs can't parse complicated formats containing a weekDay.
    // dayjs(dayjs().format('dddd MMMM D YYYY'), 'dddd MMMM D YYYY')) // returns `Invalid Date` even if the format is valid.
    const shouldSkipWeekDays = sections.some((section)=>section.type === "day");
    const sectionFormats = [];
    const sectionValues = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const shouldSkip = shouldSkipWeekDays && section.type === "weekDay";
        if (!shouldSkip) {
            sectionFormats.push(section.format);
            sectionValues.push($26f4e5858fb820e2$export$85daa91f6c6e875f(section, "non-input", localizedDigits));
        }
    }
    const formatWithoutSeparator = sectionFormats.join(" ");
    const dateWithoutSeparatorStr = sectionValues.join(" ");
    return utils.parse(dateWithoutSeparatorStr, formatWithoutSeparator);
};
const $26f4e5858fb820e2$export$9e6af343db7dd2 = (sections)=>sections.map((section)=>{
        return `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`;
    }).join("");
const $26f4e5858fb820e2$export$7ffdf006c6dc825f = (sections, localizedDigits, isRTL)=>{
    const formattedSections = sections.map((section)=>{
        const dateValue = $26f4e5858fb820e2$export$85daa91f6c6e875f(section, isRTL ? "input-rtl" : "input-ltr", localizedDigits);
        return `${section.startSeparator}${dateValue}${section.endSeparator}`;
    });
    const dateStr = formattedSections.join("");
    if (!isRTL) return dateStr;
    // \u2066: start left-to-right isolation
    // \u2067: start right-to-left isolation
    // \u2068: start first strong character isolation
    // \u2069: pop isolation
    // wrap into an isolated group such that separators can split the string in smaller ones by adding \u2069\u2068
    return `\u2066${dateStr}\u2069`;
};
const $26f4e5858fb820e2$export$360600f456ea7d5f = (utils, localizedDigits, timezone)=>{
    const today = utils.date(undefined, timezone);
    const endOfYear = utils.endOfYear(today);
    const endOfDay = utils.endOfDay(today);
    const { maxDaysInMonth: maxDaysInMonth, longestMonth: longestMonth } = (0, $8c165bb53d94cf45$export$62591b96a734eacd)(utils, today).reduce((acc, month)=>{
        const daysInMonth = utils.getDaysInMonth(month);
        if (daysInMonth > acc.maxDaysInMonth) return {
            maxDaysInMonth: daysInMonth,
            longestMonth: month
        };
        return acc;
    }, {
        maxDaysInMonth: 0,
        longestMonth: null
    });
    return {
        year: ({ format: format })=>({
                minimum: 0,
                maximum: $26f4e5858fb820e2$var$isFourDigitYearFormat(utils, timezone, format) ? 9999 : 99
            }),
        month: ()=>({
                minimum: 1,
                // Assumption: All years have the same amount of months
                maximum: utils.getMonth(endOfYear) + 1
            }),
        day: ({ currentDate: currentDate })=>({
                minimum: 1,
                maximum: currentDate != null && utils.isValid(currentDate) ? utils.getDaysInMonth(currentDate) : maxDaysInMonth,
                longestMonth: longestMonth
            }),
        weekDay: ({ format: format, contentType: contentType })=>{
            if (contentType === "digit") {
                const daysInWeek = $26f4e5858fb820e2$export$c65c7173f879039f(utils, timezone, format).map(Number);
                return {
                    minimum: Math.min(...daysInWeek),
                    maximum: Math.max(...daysInWeek)
                };
            }
            return {
                minimum: 1,
                maximum: 7
            };
        },
        hours: ({ format: format })=>{
            const lastHourInDay = utils.getHours(endOfDay);
            const hasMeridiem = $26f4e5858fb820e2$export$7dd321105a319e8(utils.formatByString(utils.endOfDay(today), format), localizedDigits) !== lastHourInDay.toString();
            if (hasMeridiem) return {
                minimum: 1,
                maximum: Number($26f4e5858fb820e2$export$7dd321105a319e8(utils.formatByString(utils.startOfDay(today), format), localizedDigits))
            };
            return {
                minimum: 0,
                maximum: lastHourInDay
            };
        },
        minutes: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of minutes
                maximum: utils.getMinutes(endOfDay)
            }),
        seconds: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of seconds
                maximum: utils.getSeconds(endOfDay)
            }),
        meridiem: ()=>({
                minimum: 0,
                maximum: 1
            }),
        empty: ()=>({
                minimum: 0,
                maximum: 0
            })
    };
};
let $26f4e5858fb820e2$var$warnedOnceInvalidSection = false;
const $26f4e5858fb820e2$export$ef6fbc09372bd65c = (sections, valueType)=>{};
const $26f4e5858fb820e2$var$transferDateSectionValue = (utils, timezone, section, dateToTransferFrom, dateToTransferTo)=>{
    switch(section.type){
        case "year":
            return utils.setYear(dateToTransferTo, utils.getYear(dateToTransferFrom));
        case "month":
            return utils.setMonth(dateToTransferTo, utils.getMonth(dateToTransferFrom));
        case "weekDay":
            {
                const formattedDaysInWeek = $26f4e5858fb820e2$export$c65c7173f879039f(utils, timezone, section.format);
                const dayInWeekStrOfActiveDate = utils.formatByString(dateToTransferFrom, section.format);
                const dayInWeekOfActiveDate = formattedDaysInWeek.indexOf(dayInWeekStrOfActiveDate);
                const dayInWeekOfNewSectionValue = formattedDaysInWeek.indexOf(section.value);
                const diff = dayInWeekOfNewSectionValue - dayInWeekOfActiveDate;
                return utils.addDays(dateToTransferFrom, diff);
            }
        case "day":
            return utils.setDate(dateToTransferTo, utils.getDate(dateToTransferFrom));
        case "meridiem":
            {
                const isAM = utils.getHours(dateToTransferFrom) < 12;
                const mergedDateHours = utils.getHours(dateToTransferTo);
                if (isAM && mergedDateHours >= 12) return utils.addHours(dateToTransferTo, -12);
                if (!isAM && mergedDateHours < 12) return utils.addHours(dateToTransferTo, 12);
                return dateToTransferTo;
            }
        case "hours":
            return utils.setHours(dateToTransferTo, utils.getHours(dateToTransferFrom));
        case "minutes":
            return utils.setMinutes(dateToTransferTo, utils.getMinutes(dateToTransferFrom));
        case "seconds":
            return utils.setSeconds(dateToTransferTo, utils.getSeconds(dateToTransferFrom));
        default:
            return dateToTransferTo;
    }
};
const $26f4e5858fb820e2$var$reliableSectionModificationOrder = {
    year: 1,
    month: 2,
    day: 3,
    weekDay: 4,
    hours: 5,
    minutes: 6,
    seconds: 7,
    meridiem: 8,
    empty: 9
};
const $26f4e5858fb820e2$export$6c6df982c77f60a9 = (utils, timezone, dateToTransferFrom, sections, referenceDate, shouldLimitToEditedSections)=>// cloning sections before sort to avoid mutating it
    [
        ...sections
    ].sort((a, b)=>$26f4e5858fb820e2$var$reliableSectionModificationOrder[a.type] - $26f4e5858fb820e2$var$reliableSectionModificationOrder[b.type]).reduce((mergedDate, section)=>{
        if (!shouldLimitToEditedSections || section.modified) return $26f4e5858fb820e2$var$transferDateSectionValue(utils, timezone, section, dateToTransferFrom, mergedDate);
        return mergedDate;
    }, referenceDate);
const $26f4e5858fb820e2$export$a11b0059900ceec8 = ()=>navigator.userAgent.toLowerCase().indexOf("android") > -1;
const $26f4e5858fb820e2$export$7725fd6fe0a2aadf = (sections, shouldApplyRTL)=>{
    const neighbors = {};
    if (!shouldApplyRTL) {
        sections.forEach((_, index)=>{
            const leftIndex = index === 0 ? null : index - 1;
            const rightIndex = index === sections.length - 1 ? null : index + 1;
            neighbors[index] = {
                leftIndex: leftIndex,
                rightIndex: rightIndex
            };
        });
        return {
            neighbors: neighbors,
            startIndex: 0,
            endIndex: sections.length - 1
        };
    }
    const rtl2ltr = {};
    const ltr2rtl = {};
    let groupedSectionsStart = 0;
    let groupedSectionsEnd = 0;
    let RTLIndex = sections.length - 1;
    while(RTLIndex >= 0){
        groupedSectionsEnd = sections.findIndex(// eslint-disable-next-line @typescript-eslint/no-loop-func
        (section, index)=>index >= groupedSectionsStart && section.endSeparator?.includes(" ") && // Special case where the spaces were not there in the initial input
            section.endSeparator !== " / ");
        if (groupedSectionsEnd === -1) groupedSectionsEnd = sections.length - 1;
        for(let i = groupedSectionsEnd; i >= groupedSectionsStart; i -= 1){
            ltr2rtl[i] = RTLIndex;
            rtl2ltr[RTLIndex] = i;
            RTLIndex -= 1;
        }
        groupedSectionsStart = groupedSectionsEnd + 1;
    }
    sections.forEach((_, index)=>{
        const rtlIndex = ltr2rtl[index];
        const leftIndex = rtlIndex === 0 ? null : rtl2ltr[rtlIndex - 1];
        const rightIndex = rtlIndex === sections.length - 1 ? null : rtl2ltr[rtlIndex + 1];
        neighbors[index] = {
            leftIndex: leftIndex,
            rightIndex: rightIndex
        };
    });
    return {
        neighbors: neighbors,
        startIndex: rtl2ltr[0],
        endIndex: rtl2ltr[sections.length - 1]
    };
};
const $26f4e5858fb820e2$export$b31f27a6e35a0b27 = (selectedSections, sections)=>{
    if (selectedSections == null) return null;
    if (selectedSections === "all") return "all";
    if (typeof selectedSections === "string") return sections.findIndex((section)=>section.type === selectedSections);
    return selectedSections;
};
const $26f4e5858fb820e2$export$b5e30842500b6cab = (section, utils)=>{
    if (!section.value) return undefined;
    switch(section.type){
        case "month":
            {
                if (section.contentType === "digit") return utils.format(utils.setMonth(utils.date(), Number(section.value) - 1), "month");
                const parsedDate = utils.parse(section.value, section.format);
                return parsedDate ? utils.format(parsedDate, "month") : undefined;
            }
        case "day":
            return section.contentType === "digit" ? utils.format(utils.setDate(utils.startOfYear(utils.date()), Number(section.value)), "dayOfMonthFull") : section.value;
        case "weekDay":
            // TODO: improve by providing the label of the week day
            return undefined;
        default:
            return undefined;
    }
};
const $26f4e5858fb820e2$export$b46fd324c5adcf31 = (section, utils)=>{
    if (!section.value) return undefined;
    switch(section.type){
        case "weekDay":
            if (section.contentType === "letter") // TODO: improve by resolving the week day number from a letter week day
            return undefined;
            return Number(section.value);
        case "meridiem":
            {
                const parsedDate = utils.parse(`01:00 ${section.value}`, `${utils.formats.hours12h}:${utils.formats.minutes} ${section.format}`);
                if (parsedDate) return utils.getHours(parsedDate) >= 12 ? 1 : 0;
                return undefined;
            }
        case "day":
            return section.contentType === "digit-with-letter" ? parseInt(section.value, 10) : Number(section.value);
        case "month":
            {
                if (section.contentType === "digit") return Number(section.value);
                const parsedDate = utils.parse(section.value, section.format);
                return parsedDate ? utils.getMonth(parsedDate) + 1 : undefined;
            }
        default:
            return section.contentType !== "letter" ? Number(section.value) : undefined;
    }
};


const $efb258a9c0464e3f$var$_excluded = [
    "value",
    "referenceDate"
];
const $efb258a9c0464e3f$export$2764b246aa3b75ba = {
    emptyValue: null,
    getTodayValue: (0, $8c165bb53d94cf45$export$1118e4272ea1e258),
    getInitialReferenceValue: (_ref)=>{
        let { value: value, referenceDate: referenceDate } = _ref, params = (0, $3L80X.default)(_ref, $efb258a9c0464e3f$var$_excluded);
        if (value != null && params.utils.isValid(value)) return value;
        if (referenceDate != null) return referenceDate;
        return (0, $bd0cf02b8b64cf79$export$6a31d56794238e4e)(params);
    },
    cleanValue: (0, $8c165bb53d94cf45$export$36ca889e039badd5),
    areValuesEqual: (0, $8c165bb53d94cf45$export$8fabf9a4cbada414),
    isSameError: (a, b)=>a === b,
    hasError: (error)=>error != null,
    defaultErrorState: null,
    getTimezone: (utils, value)=>value == null || !utils.isValid(value) ? null : utils.getTimezone(value),
    setTimezone: (utils, timezone, value)=>value == null ? null : utils.setTimezone(value, timezone)
};
const $efb258a9c0464e3f$export$b602c94f557316b4 = {
    updateReferenceValue: (utils, value, prevReferenceValue)=>value == null || !utils.isValid(value) ? prevReferenceValue : value,
    getSectionsFromValue: (utils, date, prevSections, getSectionsFromDate)=>{
        const shouldReUsePrevDateSections = !utils.isValid(date) && !!prevSections;
        if (shouldReUsePrevDateSections) return prevSections;
        return getSectionsFromDate(date);
    },
    getV7HiddenInputValueFromSections: (0, $26f4e5858fb820e2$export$9e6af343db7dd2),
    getV6InputValueFromSections: (0, $26f4e5858fb820e2$export$7ffdf006c6dc825f),
    getActiveDateManager: (utils, state)=>({
            date: state.value,
            referenceDate: state.referenceValue,
            getSections: (sections)=>sections,
            getNewValuesFromNewActiveDate: (newActiveDate)=>({
                    value: newActiveDate,
                    referenceValue: newActiveDate == null || !utils.isValid(newActiveDate) ? state.referenceValue : newActiveDate
                })
        }),
    parseValueStr: (valueStr, referenceValue, parseDate)=>parseDate(valueStr.trim(), referenceValue)
};



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $7PWLt = parcelRequire("7PWLt");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $7PWLt = parcelRequire("7PWLt");

var $aSiaI = parcelRequire("aSiaI");
const $24be003479f5f381$var$_excluded = [
    "localeText"
];
const $24be003479f5f381$export$544976378534cf9 = /*#__PURE__*/ $exYeM.createContext(null);
const $24be003479f5f381$export$dc45bdc734ce6f1e = function LocalizationProvider(inProps) {
    const { localeText: inLocaleText } = inProps, otherInProps = (0, $3L80X.default)(inProps, $24be003479f5f381$var$_excluded);
    const { utils: parentUtils, localeText: parentLocaleText } = $exYeM.useContext($24be003479f5f381$export$544976378534cf9) ?? {
        utils: undefined,
        localeText: undefined
    };
    const props = (0, $7PWLt.default)({
        // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
        // We will then merge this theme value with our value manually
        props: otherInProps,
        name: "MuiLocalizationProvider"
    });
    const { children: children, dateAdapter: DateAdapter, dateFormats: dateFormats, dateLibInstance: dateLibInstance, adapterLocale: adapterLocale, localeText: themeLocaleText } = props;
    const localeText = $exYeM.useMemo(()=>(0, $aJx1R.default)({}, themeLocaleText, parentLocaleText, inLocaleText), [
        themeLocaleText,
        parentLocaleText,
        inLocaleText
    ]);
    const utils = $exYeM.useMemo(()=>{
        if (!DateAdapter) {
            if (parentUtils) return parentUtils;
            return null;
        }
        const adapter = new DateAdapter({
            locale: adapterLocale,
            formats: dateFormats,
            instance: dateLibInstance
        });
        if (!adapter.isMUIAdapter) throw new Error([
            "MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`",
            "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`",
            "More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation"
        ].join(`\n`));
        return adapter;
    }, [
        DateAdapter,
        adapterLocale,
        dateFormats,
        dateLibInstance,
        parentUtils
    ]);
    const defaultDates = $exYeM.useMemo(()=>{
        if (!utils) return null;
        return {
            minDate: utils.date("1900-01-01T00:00:00.000"),
            maxDate: utils.date("2099-12-31T00:00:00.000")
        };
    }, [
        utils
    ]);
    const contextValue = $exYeM.useMemo(()=>{
        return {
            utils: utils,
            defaultDates: defaultDates,
            localeText: localeText
        };
    }, [
        defaultDates,
        utils,
        localeText
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($24be003479f5f381$export$544976378534cf9.Provider, {
        value: contextValue,
        children: children
    });
};



var $aJx1R = parcelRequire("aJx1R");
const $92de991e9f6bf139$export$67c96d35a1b010b3 = (pickersTranslations)=>{
    return {
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: (0, $aJx1R.default)({}, pickersTranslations)
                }
            }
        }
    };
};


// This object is not Partial<PickersLocaleText> because it is the default values
const $4c96436bf4052f00$var$enUSPickers = {
    // Calendar navigation
    previousMonth: "Previous month",
    nextMonth: "Next month",
    // View navigation
    openPreviousView: "Open previous view",
    openNextView: "Open next view",
    calendarViewSwitchingButtonAriaLabel: (view)=>view === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view",
    // DateRange labels
    start: "Start",
    end: "End",
    startDate: "Start date",
    startTime: "Start time",
    endDate: "End date",
    endTime: "End time",
    // Action bar
    cancelButtonLabel: "Cancel",
    clearButtonLabel: "Clear",
    okButtonLabel: "OK",
    todayButtonLabel: "Today",
    // Toolbar titles
    datePickerToolbarTitle: "Select date",
    dateTimePickerToolbarTitle: "Select date & time",
    timePickerToolbarTitle: "Select time",
    dateRangePickerToolbarTitle: "Select date range",
    // Clock labels
    clockLabelText: (view, time, adapter)=>`Select ${view}. ${time === null ? "No time selected" : `Selected time is ${adapter.format(time, "fullTime")}`}`,
    hoursClockNumberText: (hours)=>`${hours} hours`,
    minutesClockNumberText: (minutes)=>`${minutes} minutes`,
    secondsClockNumberText: (seconds)=>`${seconds} seconds`,
    // Digital clock labels
    selectViewText: (view)=>`Select ${view}`,
    // Calendar labels
    calendarWeekNumberHeaderLabel: "Week number",
    calendarWeekNumberHeaderText: "#",
    calendarWeekNumberAriaLabelText: (weekNumber)=>`Week ${weekNumber}`,
    calendarWeekNumberText: (weekNumber)=>`${weekNumber}`,
    // Open picker labels
    openDatePickerDialogue: (value, utils)=>value !== null && utils.isValid(value) ? `Choose date, selected date is ${utils.format(value, "fullDate")}` : "Choose date",
    openTimePickerDialogue: (value, utils)=>value !== null && utils.isValid(value) ? `Choose time, selected time is ${utils.format(value, "fullTime")}` : "Choose time",
    fieldClearLabel: "Clear value",
    // Table labels
    timeTableLabel: "pick time",
    dateTableLabel: "pick date",
    // Field section placeholders
    fieldYearPlaceholder: (params)=>"Y".repeat(params.digitAmount),
    fieldMonthPlaceholder: (params)=>params.contentType === "letter" ? "MMMM" : "MM",
    fieldDayPlaceholder: ()=>"DD",
    fieldWeekDayPlaceholder: (params)=>params.contentType === "letter" ? "EEEE" : "EE",
    fieldHoursPlaceholder: ()=>"hh",
    fieldMinutesPlaceholder: ()=>"mm",
    fieldSecondsPlaceholder: ()=>"ss",
    fieldMeridiemPlaceholder: ()=>"aa",
    // View names
    year: "Year",
    month: "Month",
    day: "Day",
    weekDay: "Week day",
    hours: "Hours",
    minutes: "Minutes",
    seconds: "Seconds",
    meridiem: "Meridiem",
    // Common
    empty: "Empty"
};
const $4c96436bf4052f00$export$1af4c7e47ad72f44 = $4c96436bf4052f00$var$enUSPickers;
const $4c96436bf4052f00$export$137380d9ce54f7f = (0, $92de991e9f6bf139$export$67c96d35a1b010b3)($4c96436bf4052f00$var$enUSPickers);


const $58b82a9afc388fa3$export$4b5a24245de9f7f9 = ()=>{
    const localization = $exYeM.useContext((0, $24be003479f5f381$export$544976378534cf9));
    if (localization === null) throw new Error([
        "MUI X: Can not find the date and time pickers localization context.",
        "It looks like you forgot to wrap your component in LocalizationProvider.",
        "This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package"
    ].join("\n"));
    if (localization.utils === null) throw new Error([
        "MUI X: Can not find the date and time pickers adapter from its localization context.",
        "It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider."
    ].join("\n"));
    const localeText = $exYeM.useMemo(()=>(0, $aJx1R.default)({}, (0, $4c96436bf4052f00$export$1af4c7e47ad72f44), localization.localeText), [
        localization.localeText
    ]);
    return $exYeM.useMemo(()=>(0, $aJx1R.default)({}, localization, {
            localeText: localeText
        }), [
        localization,
        localeText
    ]);
};
const $58b82a9afc388fa3$export$1163b47e39508a46 = ()=>$58b82a9afc388fa3$export$4b5a24245de9f7f9().utils;
const $58b82a9afc388fa3$export$7c38da3a2e90fa83 = ()=>$58b82a9afc388fa3$export$4b5a24245de9f7f9().defaultDates;
const $58b82a9afc388fa3$export$24fdeaa0f591a73e = ()=>$58b82a9afc388fa3$export$4b5a24245de9f7f9().localeText;
const $58b82a9afc388fa3$export$3a404aece3dff2fa = (timezone)=>{
    const utils = $58b82a9afc388fa3$export$1163b47e39508a46();
    const now = $exYeM.useRef();
    if (now.current === undefined) now.current = utils.date(undefined, timezone);
    return now.current;
};





var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");

var $4qr5a = parcelRequire("4qr5a");



var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $2f0D3 = parcelRequire("2f0D3");

var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");

var $4qr5a = parcelRequire("4qr5a");


var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $2f0D3 = parcelRequire("2f0D3");

var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
function $c35a1ad7fd186900$export$b109c489973c3d80(slot) {
    return (0, $dC5O8.default)("MuiPickersToolbar", slot);
}
const $c35a1ad7fd186900$export$59f09e5e2b3d9913 = (0, $kY7HX.default)("MuiPickersToolbar", [
    "root",
    "content"
]);



var $aSiaI = parcelRequire("aSiaI");
const $63224012835b0abe$var$_excluded = [
    "children",
    "className",
    "toolbarTitle",
    "hidden",
    "titleId",
    "isLandscape",
    "classes",
    "landscapeDirection"
];
const $63224012835b0abe$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        content: [
            "content"
        ],
        penIconButton: [
            "penIconButton",
            isLandscape && "penIconButtonLandscape"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $c35a1ad7fd186900$export$b109c489973c3d80), classes);
};
const $63224012835b0abe$var$PickersToolbarRoot = (0, $jawKn.default)("div", {
    name: "MuiPickersToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "space-between",
        padding: theme.spacing(2, 3),
        variants: [
            {
                props: {
                    isLandscape: true
                },
                style: {
                    height: "auto",
                    maxWidth: 160,
                    padding: 16,
                    justifyContent: "flex-start",
                    flexWrap: "wrap"
                }
            }
        ]
    }));
const $63224012835b0abe$var$PickersToolbarContent = (0, $jawKn.default)("div", {
    name: "MuiPickersToolbar",
    slot: "Content",
    overridesResolver: (props, styles)=>styles.content
})({
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    flex: 1,
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    variants: [
        {
            props: {
                isLandscape: true
            },
            style: {
                justifyContent: "flex-start",
                alignItems: "flex-start",
                flexDirection: "column"
            }
        },
        {
            props: {
                isLandscape: true,
                landscapeDirection: "row"
            },
            style: {
                flexDirection: "row"
            }
        }
    ]
});
const $63224012835b0abe$export$eb3c4d84783d6feb = /*#__PURE__*/ $exYeM.forwardRef(function PickersToolbar(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiPickersToolbar"
    });
    const { children: children, className: className, toolbarTitle: toolbarTitle, hidden: hidden, titleId: titleId } = props, other = (0, $3L80X.default)(props, $63224012835b0abe$var$_excluded);
    const ownerState = props;
    const classes = $63224012835b0abe$var$useUtilityClasses(ownerState);
    if (hidden) return null;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($63224012835b0abe$var$PickersToolbarRoot, (0, $aJx1R.default)({
        ref: ref,
        className: (0, $4qr5a.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                color: "text.secondary",
                variant: "overline",
                id: titleId,
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)($63224012835b0abe$var$PickersToolbarContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            })
        ]
    }));
});




var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
function $e0c70b6d079985e7$export$a1c3879af2c3b694(slot) {
    return (0, $dC5O8.default)("MuiDatePickerToolbar", slot);
}
const $e0c70b6d079985e7$export$2e35fa7d24ef4179 = (0, $kY7HX.default)("MuiDatePickerToolbar", [
    "root",
    "title"
]);




var $aSiaI = parcelRequire("aSiaI");
const $2ba389147101b2cf$var$_excluded = [
    "value",
    "isLandscape",
    "onChange",
    "toolbarFormat",
    "toolbarPlaceholder",
    "views",
    "className",
    "onViewChange",
    "view"
];
const $2ba389147101b2cf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        title: [
            "title"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $e0c70b6d079985e7$export$a1c3879af2c3b694), classes);
};
const $2ba389147101b2cf$var$DatePickerToolbarRoot = (0, $jawKn.default)((0, $63224012835b0abe$export$eb3c4d84783d6feb), {
    name: "MuiDatePickerToolbar",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({});
const $2ba389147101b2cf$var$DatePickerToolbarTitle = (0, $jawKn.default)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
    name: "MuiDatePickerToolbar",
    slot: "Title",
    overridesResolver: (_, styles)=>styles.title
})({
    variants: [
        {
            props: {
                isLandscape: true
            },
            style: {
                margin: "auto 16px auto auto"
            }
        }
    ]
});
const $2ba389147101b2cf$export$21b7f8ea763109eb = /*#__PURE__*/ $exYeM.forwardRef(function DatePickerToolbar(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiDatePickerToolbar"
    });
    const { value: value, isLandscape: isLandscape, toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder = "\u2013\u2013", views: views, className: className } = props, other = (0, $3L80X.default)(props, $2ba389147101b2cf$var$_excluded);
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const localeText = (0, $58b82a9afc388fa3$export$24fdeaa0f591a73e)();
    const classes = $2ba389147101b2cf$var$useUtilityClasses(props);
    const dateText = $exYeM.useMemo(()=>{
        if (!value) return toolbarPlaceholder;
        const formatFromViews = (0, $8c165bb53d94cf45$export$bb1c921f313ec928)(utils, {
            format: toolbarFormat,
            views: views
        }, true);
        return utils.formatByString(value, formatFromViews);
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        utils,
        views
    ]);
    const ownerState = props;
    return /*#__PURE__*/ (0, $aSiaI.jsx)($2ba389147101b2cf$var$DatePickerToolbarRoot, (0, $aJx1R.default)({
        ref: ref,
        toolbarTitle: localeText.datePickerToolbarTitle,
        isLandscape: isLandscape,
        className: (0, $4qr5a.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($2ba389147101b2cf$var$DatePickerToolbarTitle, {
            variant: "h4",
            align: isLandscape ? "left" : "center",
            ownerState: ownerState,
            className: classes.title,
            children: dateText
        })
    }));
});


function $54a8b28ce04f6bc0$export$a552c17ed3587731(props, name) {
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const defaultDates = (0, $58b82a9afc388fa3$export$7c38da3a2e90fa83)();
    const themeProps = (0, $7PWLt.default)({
        props: props,
        name: name
    });
    const localeText = $exYeM.useMemo(()=>{
        if (themeProps.localeText?.toolbarTitle == null) return themeProps.localeText;
        return (0, $aJx1R.default)({}, themeProps.localeText, {
            datePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    return (0, $aJx1R.default)({}, themeProps, {
        localeText: localeText
    }, (0, $a33a4d7002be5215$export$bdf8d867ddc968e)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            "year",
            "day"
        ],
        defaultOpenTo: "day"
    }), {
        disableFuture: themeProps.disableFuture ?? false,
        disablePast: themeProps.disablePast ?? false,
        minDate: (0, $8c165bb53d94cf45$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $8c165bb53d94cf45$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate),
        slots: (0, $aJx1R.default)({
            toolbar: (0, $2ba389147101b2cf$export$21b7f8ea763109eb)
        }, themeProps.slots)
    });
}




const $b5cc8935c82cecb2$export$ffb3d0046ef3a2 = ({ props: props, value: value, adapter: adapter })=>{
    if (value === null) return null;
    const { shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, disablePast: disablePast, disableFuture: disableFuture, timezone: timezone } = props;
    const now = adapter.utils.date(undefined, timezone);
    const minDate = (0, $8c165bb53d94cf45$export$eb73579ccade48fd)(adapter.utils, props.minDate, adapter.defaultDates.minDate);
    const maxDate = (0, $8c165bb53d94cf45$export$eb73579ccade48fd)(adapter.utils, props.maxDate, adapter.defaultDates.maxDate);
    switch(true){
        case !adapter.utils.isValid(value):
            return "invalidDate";
        case Boolean(shouldDisableDate && shouldDisableDate(value)):
            return "shouldDisableDate";
        case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
            return "shouldDisableMonth";
        case Boolean(shouldDisableYear && shouldDisableYear(value)):
            return "shouldDisableYear";
        case Boolean(disableFuture && adapter.utils.isAfterDay(value, now)):
            return "disableFuture";
        case Boolean(disablePast && adapter.utils.isBeforeDay(value, now)):
            return "disablePast";
        case Boolean(minDate && adapter.utils.isBeforeDay(value, minDate)):
            return "minDate";
        case Boolean(maxDate && adapter.utils.isAfterDay(value, maxDate)):
            return "maxDate";
        default:
            return null;
    }
};



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");






var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");







var $2f0D3 = parcelRequire("2f0D3");

var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
function $261654cd300a7024$export$5519b4d4bf80ce6f(slot) {
    return (0, $dC5O8.default)("MuiPickersPopper", slot);
}
const $261654cd300a7024$export$46e9184c9b1af0ce = (0, $kY7HX.default)("MuiPickersPopper", [
    "root",
    "paper"
]);


/* Use it instead of .includes method for IE support */ function $b335fe84785961a2$export$22012a5c726bef55(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every((item)=>array.indexOf(item) !== -1);
    return array.indexOf(itemOrItems) !== -1;
}
const $b335fe84785961a2$export$4467fe8634707c85 = (innerFn, externalEvent)=>(event)=>{
        if (event.key === "Enter" || event.key === " ") {
            innerFn(event);
            // prevent any side effects
            event.preventDefault();
            event.stopPropagation();
        }
        if (externalEvent) externalEvent(event);
    };
const $b335fe84785961a2$export$2e03bc8dde24716b = (fn)=>{
    setTimeout(fn, 0);
};
const $b335fe84785961a2$export$cd4e5573fbe2b576 = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $b335fe84785961a2$export$cd4e5573fbe2b576(activeEl.shadowRoot);
    return activeEl;
};
const $b335fe84785961a2$export$9ae5b19305db48ce = "@media (pointer: fine)";



const $50aff0e6ae9692bf$var$PREFERS_REDUCED_MOTION = "@media (prefers-reduced-motion: reduce)";
// detect if user agent has Android version < 10 or iOS version < 13
const $50aff0e6ae9692bf$var$mobileVersionMatches = typeof navigator !== "undefined" && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i);
const $50aff0e6ae9692bf$var$androidVersion = $50aff0e6ae9692bf$var$mobileVersionMatches && $50aff0e6ae9692bf$var$mobileVersionMatches[1] ? parseInt($50aff0e6ae9692bf$var$mobileVersionMatches[1], 10) : null;
const $50aff0e6ae9692bf$var$iOSVersion = $50aff0e6ae9692bf$var$mobileVersionMatches && $50aff0e6ae9692bf$var$mobileVersionMatches[2] ? parseInt($50aff0e6ae9692bf$var$mobileVersionMatches[2], 10) : null;
const $50aff0e6ae9692bf$export$7e3b2a595fb375e5 = $50aff0e6ae9692bf$var$androidVersion && $50aff0e6ae9692bf$var$androidVersion < 10 || $50aff0e6ae9692bf$var$iOSVersion && $50aff0e6ae9692bf$var$iOSVersion < 13 || false;
const $50aff0e6ae9692bf$export$ce40fb97be7f02d9 = ()=>{
    const prefersReduced = (0, $584e1e930413ffa8$export$2e2bcd8739ae039)($50aff0e6ae9692bf$var$PREFERS_REDUCED_MOTION, {
        defaultMatches: false
    });
    return prefersReduced || $50aff0e6ae9692bf$export$7e3b2a595fb375e5;
};



var $aSiaI = parcelRequire("aSiaI");
const $cef6846a1b6167ab$var$_excluded = [
    "PaperComponent",
    "popperPlacement",
    "ownerState",
    "children",
    "paperSlotProps",
    "paperClasses",
    "onPaperClick",
    "onPaperTouchStart"
];
const $cef6846a1b6167ab$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $261654cd300a7024$export$5519b4d4bf80ce6f), classes);
};
const $cef6846a1b6167ab$var$PickersPopperRoot = (0, $jawKn.default)((0, $5c4432cbbd879abf$export$2e2bcd8739ae039), {
    name: "MuiPickersPopper",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal
    }));
const $cef6846a1b6167ab$var$PickersPopperPaper = (0, $jawKn.default)((0, $e479e3bd14e95ba2$export$2e2bcd8739ae039), {
    name: "MuiPickersPopper",
    slot: "Paper",
    overridesResolver: (_, styles)=>styles.paper
})({
    outline: 0,
    transformOrigin: "top center",
    variants: [
        {
            props: ({ placement: placement })=>[
                    "top",
                    "top-start",
                    "top-end"
                ].includes(placement),
            style: {
                transformOrigin: "bottom center"
            }
        }
    ]
});
function $cef6846a1b6167ab$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Based on @mui/material/ClickAwayListener without the customization.
 * We can probably strip away even more since children won't be portaled.
 * @param {boolean} active Only listen to clicks when the popper is opened.
 * @param {(event: MouseEvent | TouchEvent) => void} onClickAway The callback to call when clicking outside the popper.
 * @returns {Array} The ref and event handler to listen to the outside clicks.
 */ function $cef6846a1b6167ab$var$useClickAwayListener(active, onClickAway) {
    const movedRef = $exYeM.useRef(false);
    const syntheticEventRef = $exYeM.useRef(false);
    const nodeRef = $exYeM.useRef(null);
    const activatedRef = $exYeM.useRef(false);
    $exYeM.useEffect(()=>{
        if (!active) return undefined;
        // Ensure that this hook is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        function armClickAwayListener() {
            activatedRef.current = true;
        }
        document.addEventListener("mousedown", armClickAwayListener, true);
        document.addEventListener("touchstart", armClickAwayListener, true);
        return ()=>{
            document.removeEventListener("mousedown", armClickAwayListener, true);
            document.removeEventListener("touchstart", armClickAwayListener, true);
            activatedRef.current = false;
        };
    }, [
        active
    ]);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event)=>{
        if (!activatedRef.current) return;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $0d47b1cc144b9266$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!nodeRef.current || // is a TouchEvent?
        "clientX" in event && $cef6846a1b6167ab$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        if (!insideDOM && !insideReactTree) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const handleSynthetic = ()=>{
        syntheticEventRef.current = true;
    };
    $exYeM.useEffect(()=>{
        if (active) {
            const doc = (0, $0d47b1cc144b9266$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener("touchstart", handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener("touchstart", handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    $exYeM.useEffect(()=>{
        // TODO This behavior is not tested automatically
        // It's unclear whether this is due to different update semantics in test (batched in act() vs discrete on click).
        // Or if this is a timing related issues due to different Transition components
        // Once we get rid of all the manual scheduling (for example setTimeout(update, 0)) we can revisit this code+test.
        if (active) {
            const doc = (0, $0d47b1cc144b9266$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener("click", handleClickAway);
            return ()=>{
                doc.removeEventListener("click", handleClickAway);
                // cleanup `handleClickAway`
                syntheticEventRef.current = false;
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    return [
        nodeRef,
        handleSynthetic,
        handleSynthetic
    ];
}
const $cef6846a1b6167ab$var$PickersPopperPaperWrapper = /*#__PURE__*/ $exYeM.forwardRef((props, ref)=>{
    const { PaperComponent: PaperComponent, popperPlacement: popperPlacement, ownerState: inOwnerState, children: children, paperSlotProps: paperSlotProps, paperClasses: paperClasses, onPaperClick: onPaperClick, onPaperTouchStart: onPaperTouchStart } = props, other = (0, $3L80X.default)(props, $cef6846a1b6167ab$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, inOwnerState, {
        placement: popperPlacement
    });
    const paperProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: PaperComponent,
        externalSlotProps: paperSlotProps,
        additionalProps: {
            tabIndex: -1,
            elevation: 8,
            ref: ref
        },
        className: paperClasses,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)(PaperComponent, (0, $aJx1R.default)({}, other, paperProps, {
        onClick: (event)=>{
            onPaperClick(event);
            paperProps.onClick?.(event);
        },
        onTouchStart: (event)=>{
            onPaperTouchStart(event);
            paperProps.onTouchStart?.(event);
        },
        ownerState: ownerState,
        children: children
    }));
});
function $cef6846a1b6167ab$export$96ce8482474de8a5(inProps) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiPickersPopper"
    });
    const { anchorEl: anchorEl, children: children, containerRef: containerRef = null, shouldRestoreFocus: shouldRestoreFocus, onBlur: onBlur, onDismiss: onDismiss, open: open, role: role, placement: placement, slots: slots, slotProps: slotProps, reduceAnimations: inReduceAnimations } = props;
    $exYeM.useEffect(()=>{
        function handleKeyDown(nativeEvent) {
            if (open && nativeEvent.key === "Escape") onDismiss();
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        onDismiss,
        open
    ]);
    const lastFocusedElementRef = $exYeM.useRef(null);
    $exYeM.useEffect(()=>{
        if (role === "tooltip" || shouldRestoreFocus && !shouldRestoreFocus()) return;
        if (open) lastFocusedElementRef.current = (0, $b335fe84785961a2$export$cd4e5573fbe2b576)(document);
        else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) // make sure the button is flushed with updated label, before returning focus to it
        // avoids issue, where screen reader could fail to announce selected date after selection
        setTimeout(()=>{
            if (lastFocusedElementRef.current instanceof HTMLElement) lastFocusedElementRef.current.focus();
        });
    }, [
        open,
        role,
        shouldRestoreFocus
    ]);
    const [clickAwayRef, onPaperClick, onPaperTouchStart] = $cef6846a1b6167ab$var$useClickAwayListener(open, onBlur ?? onDismiss);
    const paperRef = $exYeM.useRef(null);
    const handleRef = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(paperRef, containerRef);
    const handlePaperRef = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(handleRef, clickAwayRef);
    const ownerState = props;
    const classes = $cef6846a1b6167ab$var$useUtilityClasses(ownerState);
    const defaultReduceAnimations = (0, $50aff0e6ae9692bf$export$ce40fb97be7f02d9)();
    const reduceAnimations = inReduceAnimations ?? defaultReduceAnimations;
    const handleKeyDown = (event)=>{
        if (event.key === "Escape") {
            // stop the propagation to avoid closing parent modal
            event.stopPropagation();
            onDismiss();
        }
    };
    const Transition = slots?.desktopTransition ?? reduceAnimations ? (0, $b8c58e7700914c7f$export$2e2bcd8739ae039) : (0, $0b476d905dd3781d$export$2e2bcd8739ae039);
    const FocusTrap = slots?.desktopTrapFocus ?? (0, $99bcabd76da68fe9$export$34eba2437817a67b);
    const Paper = slots?.desktopPaper ?? $cef6846a1b6167ab$var$PickersPopperPaper;
    const Popper = slots?.popper ?? $cef6846a1b6167ab$var$PickersPopperRoot;
    const popperProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: Popper,
        externalSlotProps: slotProps?.popper,
        additionalProps: {
            transition: true,
            role: role,
            open: open,
            anchorEl: anchorEl,
            placement: placement,
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: props
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)(Popper, (0, $aJx1R.default)({}, popperProps, {
        children: ({ TransitionProps: TransitionProps, placement: popperPlacement })=>/*#__PURE__*/ (0, $aSiaI.jsx)(FocusTrap, (0, $aJx1R.default)({
                open: open,
                disableAutoFocus: true,
                disableRestoreFocus: true,
                disableEnforceFocus: role === "tooltip",
                isEnabled: ()=>true
            }, slotProps?.desktopTrapFocus, {
                children: /*#__PURE__*/ (0, $aSiaI.jsx)(Transition, (0, $aJx1R.default)({}, TransitionProps, slotProps?.desktopTransition, {
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)($cef6846a1b6167ab$var$PickersPopperPaperWrapper, {
                        PaperComponent: Paper,
                        ownerState: ownerState,
                        popperPlacement: popperPlacement,
                        ref: handlePaperRef,
                        onPaperClick: onPaperClick,
                        onPaperTouchStart: onPaperTouchStart,
                        paperClasses: classes.paper,
                        paperSlotProps: slotProps?.desktopPaper,
                        children: children
                    })
                }))
            }))
    }));
}




var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
const $17ebc5a9e7063024$export$7d3a09d5141ab1f4 = ({ open: open, onOpen: onOpen, onClose: onClose })=>{
    const isControllingOpenProp = $exYeM.useRef(typeof open === "boolean").current;
    const [openState, setIsOpenState] = $exYeM.useState(false);
    // It is required to update inner state in useEffect in order to avoid situation when
    // Our component is not mounted yet, but `open` state is set to `true` (for example initially opened)
    $exYeM.useEffect(()=>{
        if (isControllingOpenProp) {
            if (typeof open !== "boolean") throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
            setIsOpenState(open);
        }
    }, [
        isControllingOpenProp,
        open
    ]);
    const setIsOpen = $exYeM.useCallback((newIsOpen)=>{
        if (!isControllingOpenProp) setIsOpenState(newIsOpen);
        if (newIsOpen && onOpen) onOpen();
        if (!newIsOpen && onClose) onClose();
    }, [
        isControllingOpenProp,
        onOpen,
        onClose
    ]);
    return {
        isOpen: openState,
        setIsOpen: setIsOpen
    };
};




var $exYeM = parcelRequire("exYeM");

function $c99b8fb6de4f8de2$export$87fe492f99f25a20(props, validate, isSameError, defaultErrorState) {
    const { value: value, onError: onError } = props;
    const adapter = (0, $58b82a9afc388fa3$export$4b5a24245de9f7f9)();
    const previousValidationErrorRef = $exYeM.useRef(defaultErrorState);
    const validationError = validate({
        adapter: adapter,
        value: value,
        props: props
    });
    $exYeM.useEffect(()=>{
        if (onError && !isSameError(validationError, previousValidationErrorRef.current)) onError(validationError, value);
        previousValidationErrorRef.current = validationError;
    }, [
        isSameError,
        onError,
        previousValidationErrorRef,
        validationError,
        value
    ]);
    return validationError;
}



var $exYeM = parcelRequire("exYeM");



const $3e4aef0ef80b275d$export$c7e050e908c1b2bc = ({ timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, onChange: onChange, valueManager: valueManager })=>{
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const firstDefaultValue = $exYeM.useRef(defaultValue);
    const inputValue = valueProp ?? firstDefaultValue.current ?? valueManager.emptyValue;
    const inputTimezone = $exYeM.useMemo(()=>valueManager.getTimezone(utils, inputValue), [
        utils,
        valueManager,
        inputValue
    ]);
    const setInputTimezone = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((newValue)=>{
        if (inputTimezone == null) return newValue;
        return valueManager.setTimezone(utils, inputTimezone, newValue);
    });
    const timezoneToRender = timezoneProp ?? inputTimezone ?? "default";
    const valueWithTimezoneToRender = $exYeM.useMemo(()=>valueManager.setTimezone(utils, timezoneToRender, inputValue), [
        valueManager,
        utils,
        timezoneToRender,
        inputValue
    ]);
    const handleValueChange = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((newValue, ...otherParams)=>{
        const newValueWithInputTimezone = setInputTimezone(newValue);
        onChange?.(newValueWithInputTimezone, ...otherParams);
    });
    return {
        value: valueWithTimezoneToRender,
        handleValueChange: handleValueChange,
        timezone: timezoneToRender
    };
};
const $3e4aef0ef80b275d$export$174d749f3b4c0f49 = ({ name: name, timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, onChange: onChangeProp, valueManager: valueManager })=>{
    const [valueWithInputTimezone, setValue] = (0, $d86ef59ee77e84fd$export$2e2bcd8739ae039)({
        name: name,
        state: "value",
        controlled: valueProp,
        default: defaultValue ?? valueManager.emptyValue
    });
    const onChange = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((newValue, ...otherParams)=>{
        setValue(newValue);
        onChangeProp?.(newValue, ...otherParams);
    });
    return $3e4aef0ef80b275d$export$c7e050e908c1b2bc({
        timezone: timezoneProp,
        value: valueWithInputTimezone,
        defaultValue: undefined,
        onChange: onChange,
        valueManager: valueManager
    });
};


/**
 * Decide if the new value should be published
 * The published value will be passed to `onChange` if defined.
 */ const $cc78ee2c8fd20122$var$shouldPublishValue = (params)=>{
    const { action: action, hasChanged: hasChanged, dateState: dateState, isControlled: isControlled } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    // The field is responsible for only calling `onChange` when needed.
    if (action.name === "setValueFromField") return true;
    if (action.name === "setValueFromAction") {
        // If the component is not controlled, and the value has not been modified since the mount,
        // Then we want to publish the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
        if (isCurrentValueTheDefaultValue && [
            "accept",
            "today",
            "clear"
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if (action.name === "setValueFromView" && action.selectionState !== "shallow") {
        // On the first view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if (action.name === "setValueFromShortcut") {
        // On the first view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    return false;
};
/**
 * Decide if the new value should be committed.
 * The committed value will be passed to `onAccept` if defined.
 * It will also be used as a reset target when calling the `cancel` picker action (when clicking on the "Cancel" button).
 */ const $cc78ee2c8fd20122$var$shouldCommitValue = (params)=>{
    const { action: action, hasChanged: hasChanged, dateState: dateState, isControlled: isControlled, closeOnSelect: closeOnSelect } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    if (action.name === "setValueFromAction") {
        // If the component is not controlled, and the value has not been modified since the mount,
        // Then we want to commit the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
        if (isCurrentValueTheDefaultValue && [
            "accept",
            "today",
            "clear"
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if (action.name === "setValueFromView" && action.selectionState === "finish" && closeOnSelect) {
        // On picker where the 1st view is also the last view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onAccept`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if (action.name === "setValueFromShortcut") return action.changeImportance === "accept" && hasChanged(dateState.lastCommittedValue);
    return false;
};
/**
 * Decide if the picker should be closed after the value is updated.
 */ const $cc78ee2c8fd20122$var$shouldClosePicker = (params)=>{
    const { action: action, closeOnSelect: closeOnSelect } = params;
    if (action.name === "setValueFromAction") return true;
    if (action.name === "setValueFromView") return action.selectionState === "finish" && closeOnSelect;
    if (action.name === "setValueFromShortcut") return action.changeImportance === "accept";
    return false;
};
const $cc78ee2c8fd20122$export$799b22a7b7fffaa3 = ({ props: props, valueManager: valueManager, valueType: valueType, wrapperVariant: wrapperVariant, validator: validator })=>{
    const { onAccept: onAccept, onChange: onChange, value: inValue, defaultValue: inDefaultValue, closeOnSelect: closeOnSelect = wrapperVariant === "desktop", timezone: timezoneProp } = props;
    const { current: defaultValue } = $exYeM.useRef(inDefaultValue);
    const { current: isControlled } = $exYeM.useRef(inValue !== undefined);
    /* eslint-enable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const adapter = (0, $58b82a9afc388fa3$export$4b5a24245de9f7f9)();
    const { isOpen: isOpen, setIsOpen: setIsOpen } = (0, $17ebc5a9e7063024$export$7d3a09d5141ab1f4)(props);
    const [dateState, setDateState] = $exYeM.useState(()=>{
        let initialValue;
        if (inValue !== undefined) initialValue = inValue;
        else if (defaultValue !== undefined) initialValue = defaultValue;
        else initialValue = valueManager.emptyValue;
        return {
            draft: initialValue,
            lastPublishedValue: initialValue,
            lastCommittedValue: initialValue,
            lastControlledValue: inValue,
            hasBeenModifiedSinceMount: false
        };
    });
    const { timezone: timezone, handleValueChange: handleValueChange } = (0, $3e4aef0ef80b275d$export$c7e050e908c1b2bc)({
        timezone: timezoneProp,
        value: inValue,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: valueManager
    });
    (0, $c99b8fb6de4f8de2$export$87fe492f99f25a20)((0, $aJx1R.default)({}, props, {
        value: dateState.draft,
        timezone: timezone
    }), validator, valueManager.isSameError, valueManager.defaultErrorState);
    const updateDate = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((action)=>{
        const updaterParams = {
            action: action,
            dateState: dateState,
            hasChanged: (comparison)=>!valueManager.areValuesEqual(utils, action.value, comparison),
            isControlled: isControlled,
            closeOnSelect: closeOnSelect
        };
        const shouldPublish = $cc78ee2c8fd20122$var$shouldPublishValue(updaterParams);
        const shouldCommit = $cc78ee2c8fd20122$var$shouldCommitValue(updaterParams);
        const shouldClose = $cc78ee2c8fd20122$var$shouldClosePicker(updaterParams);
        setDateState((prev)=>(0, $aJx1R.default)({}, prev, {
                draft: action.value,
                lastPublishedValue: shouldPublish ? action.value : prev.lastPublishedValue,
                lastCommittedValue: shouldCommit ? action.value : prev.lastCommittedValue,
                hasBeenModifiedSinceMount: true
            }));
        if (shouldPublish) {
            const validationError = action.name === "setValueFromField" ? action.context.validationError : validator({
                adapter: adapter,
                value: action.value,
                props: (0, $aJx1R.default)({}, props, {
                    value: action.value,
                    timezone: timezone
                })
            });
            const context = {
                validationError: validationError
            };
            if (action.name === "setValueFromShortcut") context.shortcut = action.shortcut;
            handleValueChange(action.value, context);
        }
        if (shouldCommit && onAccept) onAccept(action.value);
        if (shouldClose) setIsOpen(false);
    });
    if (inValue !== undefined && (dateState.lastControlledValue === undefined || !valueManager.areValuesEqual(utils, dateState.lastControlledValue, inValue))) {
        const isUpdateComingFromPicker = valueManager.areValuesEqual(utils, dateState.draft, inValue);
        setDateState((prev)=>(0, $aJx1R.default)({}, prev, {
                lastControlledValue: inValue
            }, isUpdateComingFromPicker ? {} : {
                lastCommittedValue: inValue,
                lastPublishedValue: inValue,
                draft: inValue,
                hasBeenModifiedSinceMount: true
            }));
    }
    const handleClear = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: valueManager.emptyValue,
            name: "setValueFromAction",
            pickerAction: "clear"
        });
    });
    const handleAccept = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: "setValueFromAction",
            pickerAction: "accept"
        });
    });
    const handleDismiss = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: "setValueFromAction",
            pickerAction: "dismiss"
        });
    });
    const handleCancel = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastCommittedValue,
            name: "setValueFromAction",
            pickerAction: "cancel"
        });
    });
    const handleSetToday = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: valueManager.getTodayValue(utils, timezone, valueType),
            name: "setValueFromAction",
            pickerAction: "today"
        });
    });
    const handleOpen = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event)=>{
        event.preventDefault();
        setIsOpen(true);
    });
    const handleClose = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event)=>{
        event?.preventDefault();
        setIsOpen(false);
    });
    const handleChange = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((newValue, selectionState = "partial")=>updateDate({
            name: "setValueFromView",
            value: newValue,
            selectionState: selectionState
        }));
    const handleSelectShortcut = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((newValue, changeImportance, shortcut)=>updateDate({
            name: "setValueFromShortcut",
            value: newValue,
            changeImportance: changeImportance,
            shortcut: shortcut
        }));
    const handleChangeFromField = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((newValue, context)=>updateDate({
            name: "setValueFromField",
            value: newValue,
            context: context
        }));
    const actions = {
        onClear: handleClear,
        onAccept: handleAccept,
        onDismiss: handleDismiss,
        onCancel: handleCancel,
        onSetToday: handleSetToday,
        onOpen: handleOpen,
        onClose: handleClose
    };
    const fieldResponse = {
        value: dateState.draft,
        onChange: handleChangeFromField
    };
    const viewValue = $exYeM.useMemo(()=>valueManager.cleanValue(utils, dateState.draft), [
        utils,
        valueManager,
        dateState.draft
    ]);
    const viewResponse = {
        value: viewValue,
        onChange: handleChange,
        onClose: handleClose,
        open: isOpen
    };
    const isValid = (testedValue)=>{
        const error = validator({
            adapter: adapter,
            value: testedValue,
            props: (0, $aJx1R.default)({}, props, {
                value: testedValue,
                timezone: timezone
            })
        });
        return !valueManager.hasError(error);
    };
    const layoutResponse = (0, $aJx1R.default)({}, actions, {
        value: viewValue,
        onChange: handleChange,
        onSelectShortcut: handleSelectShortcut,
        isValid: isValid
    });
    return {
        open: isOpen,
        fieldProps: fieldResponse,
        viewProps: viewResponse,
        layoutProps: layoutResponse,
        actions: actions
    };
};



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");



var $exYeM = parcelRequire("exYeM");


let $8d38a40b51f4c4fd$var$warnedOnceNotValidView = false;
function $8d38a40b51f4c4fd$export$9b46cba8f8ccd954({ onChange: onChange, onViewChange: onViewChange, openTo: openTo, view: inView, views: views, autoFocus: autoFocus, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange }) {
    const previousOpenTo = $exYeM.useRef(openTo);
    const previousViews = $exYeM.useRef(views);
    const defaultView = $exYeM.useRef(views.includes(openTo) ? openTo : views[0]);
    const [view, setView] = (0, $d86ef59ee77e84fd$export$2e2bcd8739ae039)({
        name: "useViews",
        state: "view",
        controlled: inView,
        default: defaultView.current
    });
    const defaultFocusedView = $exYeM.useRef(autoFocus ? view : null);
    const [focusedView, setFocusedView] = (0, $d86ef59ee77e84fd$export$2e2bcd8739ae039)({
        name: "useViews",
        state: "focusedView",
        controlled: inFocusedView,
        default: defaultFocusedView.current
    });
    $exYeM.useEffect(()=>{
        // Update the current view when `openTo` or `views` props change
        if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some((previousView)=>!views.includes(previousView))) {
            setView(views.includes(openTo) ? openTo : views[0]);
            previousViews.current = views;
            previousOpenTo.current = openTo;
        }
    }, [
        openTo,
        setView,
        view,
        views
    ]);
    const viewIndex = views.indexOf(view);
    const previousView = views[viewIndex - 1] ?? null;
    const nextView = views[viewIndex + 1] ?? null;
    const handleFocusedViewChange = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((viewToFocus, hasFocus)=>{
        if (hasFocus) // Focus event
        setFocusedView(viewToFocus);
        else // Blur event
        setFocusedView((prevFocusedView)=>viewToFocus === prevFocusedView ? null : prevFocusedView // If false the blur is due to view switching
        );
        onFocusedViewChange?.(viewToFocus, hasFocus);
    });
    const handleChangeView = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((newView)=>{
        // always keep the focused view in sync
        handleFocusedViewChange(newView, true);
        if (newView === view) return;
        setView(newView);
        if (onViewChange) onViewChange(newView);
    });
    const goToNextView = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)(()=>{
        if (nextView) handleChangeView(nextView);
    });
    const setValueAndGoToNextView = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((value, currentViewSelectionState, selectedView)=>{
        const isSelectionFinishedOnCurrentView = currentViewSelectionState === "finish";
        const hasMoreViews = selectedView ? // handles case like `DateTimePicker`, where a view might return a `finish` selection state
        // but when it's not the final view given all `views` -> overall selection state should be `partial`.
        views.indexOf(selectedView) < views.length - 1 : Boolean(nextView);
        const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? "partial" : currentViewSelectionState;
        onChange(value, globalSelectionState, selectedView);
        // Detects if the selected view is not the active one.
        // Can happen if multiple views are displayed, like in `DesktopDateTimePicker` or `MultiSectionDigitalClock`.
        if (selectedView && selectedView !== view) {
            const nextViewAfterSelected = views[views.indexOf(selectedView) + 1];
            if (nextViewAfterSelected) // move to next view after the selected one
            handleChangeView(nextViewAfterSelected);
        } else if (isSelectionFinishedOnCurrentView) goToNextView();
    });
    return {
        view: view,
        setView: handleChangeView,
        focusedView: focusedView,
        setFocusedView: handleFocusedViewChange,
        nextView: nextView,
        previousView: previousView,
        // Always return up-to-date default view instead of the initial one (i.e. defaultView.current)
        defaultView: views.includes(openTo) ? openTo : views[0],
        goToNextView: goToNextView,
        setValueAndGoToNextView: setValueAndGoToNextView
    };
}



const $a56ed5cbd4750523$var$_excluded = [
    "className",
    "sx"
];
const $a56ed5cbd4750523$export$c0a71b697a2df210 = ({ props: props, propsFromPickerValue: propsFromPickerValue, additionalViewProps: additionalViewProps, autoFocusView: autoFocusView, rendererInterceptor: rendererInterceptor, fieldRef: fieldRef })=>{
    const { onChange: onChange, open: open, onClose: onClose } = propsFromPickerValue;
    const { views: views, openTo: openTo, onViewChange: onViewChange, disableOpenPicker: disableOpenPicker, viewRenderers: viewRenderers, timezone: timezone } = props;
    const propsToForwardToView = (0, $3L80X.default)(props, $a56ed5cbd4750523$var$_excluded);
    const { view: view, setView: setView, defaultView: defaultView, focusedView: focusedView, setFocusedView: setFocusedView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $8d38a40b51f4c4fd$export$9b46cba8f8ccd954)({
        view: undefined,
        views: views,
        openTo: openTo,
        onChange: onChange,
        onViewChange: onViewChange,
        autoFocus: autoFocusView
    });
    const { hasUIView: hasUIView, viewModeLookup: viewModeLookup } = $exYeM.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            let viewMode;
            if (disableOpenPicker) viewMode = "field";
            else if (viewRenderers[viewForReduce] != null) viewMode = "UI";
            else viewMode = "field";
            acc.viewModeLookup[viewForReduce] = viewMode;
            if (viewMode === "UI") acc.hasUIView = true;
            return acc;
        }, {
            hasUIView: false,
            viewModeLookup: {}
        }), [
        disableOpenPicker,
        viewRenderers,
        views
    ]);
    const timeViewsCount = $exYeM.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            if (viewRenderers[viewForReduce] != null && (0, $9509391b55697f91$export$8f04d380cefd5a0d)(viewForReduce)) return acc + 1;
            return acc;
        }, 0), [
        viewRenderers,
        views
    ]);
    const currentViewMode = viewModeLookup[view];
    const shouldRestoreFocus = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)(()=>currentViewMode === "UI");
    const [popperView, setPopperView] = $exYeM.useState(currentViewMode === "UI" ? view : null);
    if (popperView !== view && viewModeLookup[view] === "UI") setPopperView(view);
    (0, $c4c3f9798cb7fddc$export$2e2bcd8739ae039)(()=>{
        // Handle case of `DateTimePicker` without time renderers
        if (currentViewMode === "field" && open) {
            onClose();
            setTimeout(()=>{
                // focusing the input before the range selection is done
                // calling it outside of timeout results in an inconsistent behavior between Safari And Chrome
                fieldRef?.current?.focusField(view);
            });
        }
    }, [
        view
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $c4c3f9798cb7fddc$export$2e2bcd8739ae039)(()=>{
        if (!open) return;
        let newView = view;
        // If the current view is a field view, go to the last popper view
        if (currentViewMode === "field" && popperView != null) newView = popperView;
        // If the current view is not the default view and both are UI views
        if (newView !== defaultView && viewModeLookup[newView] === "UI" && viewModeLookup[defaultView] === "UI") newView = defaultView;
        if (newView !== view) setView(newView);
        setFocusedView(newView, true);
    }, [
        open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const layoutProps = {
        views: views,
        view: popperView,
        onViewChange: setView
    };
    return {
        hasUIView: hasUIView,
        shouldRestoreFocus: shouldRestoreFocus,
        layoutProps: layoutProps,
        renderCurrentView: ()=>{
            if (popperView == null) return null;
            const renderer = viewRenderers[popperView];
            if (renderer == null) return null;
            const rendererProps = (0, $aJx1R.default)({}, propsToForwardToView, additionalViewProps, propsFromPickerValue, {
                views: views,
                timezone: timezone,
                onChange: setValueAndGoToNextView,
                view: popperView,
                onViewChange: setView,
                focusedView: focusedView,
                onFocusedViewChange: setFocusedView,
                showViewSwitcher: timeViewsCount > 1,
                timeViewsCount: timeViewsCount
            });
            if (rendererInterceptor) return rendererInterceptor(viewRenderers, popperView, rendererProps);
            return renderer(rendererProps);
        }
    };
};



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


function $20114314d8e5cfeb$var$getOrientation() {
    if (typeof window === "undefined") return "portrait";
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait";
    // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
    return "portrait";
}
const $20114314d8e5cfeb$export$6f60b24e37af6448 = (views, customOrientation)=>{
    const [orientation, setOrientation] = $exYeM.useState($20114314d8e5cfeb$var$getOrientation);
    (0, $c4c3f9798cb7fddc$export$2e2bcd8739ae039)(()=>{
        const eventHandler = ()=>{
            setOrientation($20114314d8e5cfeb$var$getOrientation());
        };
        window.addEventListener("orientationchange", eventHandler);
        return ()=>{
            window.removeEventListener("orientationchange", eventHandler);
        };
    }, []);
    if ((0, $b335fe84785961a2$export$22012a5c726bef55)(views, [
        "hours",
        "minutes",
        "seconds"
    ])) // could not display 13:34:44 in landscape mode
    return false;
    const orientationToUse = customOrientation || orientation;
    return orientationToUse === "landscape";
};


const $b23e0d0bb1458498$export$4e5139e5825b7b27 = ({ props: props, propsFromPickerValue: propsFromPickerValue, propsFromPickerViews: propsFromPickerViews, wrapperVariant: wrapperVariant })=>{
    const { orientation: orientation } = props;
    const isLandscape = (0, $20114314d8e5cfeb$export$6f60b24e37af6448)(propsFromPickerViews.views, orientation);
    const layoutProps = (0, $aJx1R.default)({}, propsFromPickerViews, propsFromPickerValue, {
        isLandscape: isLandscape,
        wrapperVariant: wrapperVariant,
        disabled: props.disabled,
        readOnly: props.readOnly
    });
    return {
        layoutProps: layoutProps
    };
};


const $58cb11e0bb0a919d$export$be61413ca3629f52 = (message)=>{
    let alreadyWarned = false;
    var deprecatedProps;
    return ()=>{};
};
const $58cb11e0bb0a919d$export$baf331755d84b871 = (message, gravity = "warning")=>{
    let alreadyWarned = false;
    const cleanMessage = Array.isArray(message) ? message.join("\n") : message;
    return ()=>{
        if (!alreadyWarned) {
            alreadyWarned = true;
            if (gravity === "error") console.error(cleanMessage);
            else console.warn(cleanMessage);
        }
    };
};


const $fe214b73a0b4d59a$var$warnRenderInputIsDefined = (0, $58cb11e0bb0a919d$export$baf331755d84b871)([
    "The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.",
    "You can replace it with the `textField` component slot in most cases.",
    "For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5)."
]);
const $fe214b73a0b4d59a$export$fc3313977ac596c4 = ({ props: props, valueManager: valueManager, valueType: valueType, wrapperVariant: wrapperVariant, additionalViewProps: additionalViewProps, validator: validator, autoFocusView: autoFocusView, rendererInterceptor: rendererInterceptor, fieldRef: fieldRef })=>{
    const pickerValueResponse = (0, $cc78ee2c8fd20122$export$799b22a7b7fffaa3)({
        props: props,
        valueManager: valueManager,
        valueType: valueType,
        wrapperVariant: wrapperVariant,
        validator: validator
    });
    const pickerViewsResponse = (0, $a56ed5cbd4750523$export$c0a71b697a2df210)({
        props: props,
        additionalViewProps: additionalViewProps,
        autoFocusView: autoFocusView,
        fieldRef: fieldRef,
        propsFromPickerValue: pickerValueResponse.viewProps,
        rendererInterceptor: rendererInterceptor
    });
    const pickerLayoutResponse = (0, $b23e0d0bb1458498$export$4e5139e5825b7b27)({
        props: props,
        wrapperVariant: wrapperVariant,
        propsFromPickerValue: pickerValueResponse.layoutProps,
        propsFromPickerViews: pickerViewsResponse.layoutProps
    });
    return {
        // Picker value
        open: pickerValueResponse.open,
        actions: pickerValueResponse.actions,
        fieldProps: pickerValueResponse.fieldProps,
        // Picker views
        renderCurrentView: pickerViewsResponse.renderCurrentView,
        hasUIView: pickerViewsResponse.hasUIView,
        shouldRestoreFocus: pickerViewsResponse.shouldRestoreFocus,
        // Picker layout
        layoutProps: pickerLayoutResponse.layoutProps
    };
};




var $exYeM = parcelRequire("exYeM");

var $bisEj = parcelRequire("bisEj");

var $4qr5a = parcelRequire("4qr5a");

var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $2f0D3 = parcelRequire("2f0D3");

var $dC5O8 = parcelRequire("dC5O8");

var $kY7HX = parcelRequire("kY7HX");
function $fd37cd49589c7ef4$export$1671c31de798d429(slot) {
    return (0, $dC5O8.default)("MuiPickersLayout", slot);
}
const $fd37cd49589c7ef4$export$7a6dac186703fe4c = (0, $kY7HX.default)("MuiPickersLayout", [
    "root",
    "landscape",
    "contentWrapper",
    "toolbar",
    "actionBar",
    "tabs",
    "shortcuts"
]);



var $aJx1R = parcelRequire("aJx1R");
parcelRequire("exYeM");


var $2f0D3 = parcelRequire("2f0D3");

var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");
parcelRequire("exYeM");



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $0ca8fbf4d8f73a22$export$5e57a444791c63be(slot) {
    return (0, $dC5O8.default)("MuiDialogActions", slot);
}
const $0ca8fbf4d8f73a22$var$dialogActionsClasses = (0, $kY7HX.default)("MuiDialogActions", [
    "root",
    "spacing"
]);
var $0ca8fbf4d8f73a22$export$2e2bcd8739ae039 = $0ca8fbf4d8f73a22$var$dialogActionsClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $8136e94a8ae83d0c$var$_excluded = [
    "className",
    "disableSpacing"
];
const $8136e94a8ae83d0c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $0ca8fbf4d8f73a22$export$5e57a444791c63be), classes);
};
const $8136e94a8ae83d0c$var$DialogActionsRoot = (0, $jawKn.default)("div", {
    name: "MuiDialogActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $aJx1R.default)({
        display: "flex",
        alignItems: "center",
        padding: 8,
        justifyContent: "flex-end",
        flex: "0 0 auto"
    }, !ownerState.disableSpacing && {
        "& > :not(style) ~ :not(style)": {
            marginLeft: 8
        }
    }));
const $8136e94a8ae83d0c$var$DialogActions = /*#__PURE__*/ $exYeM.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiDialogActions"
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $3L80X.default)(props, $8136e94a8ae83d0c$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $8136e94a8ae83d0c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($8136e94a8ae83d0c$var$DialogActionsRoot, (0, $aJx1R.default)({
        className: (0, $4qr5a.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $8136e94a8ae83d0c$export$2e2bcd8739ae039 = $8136e94a8ae83d0c$var$DialogActions;




var $aSiaI = parcelRequire("aSiaI");
const $04e6a830aa77d79d$var$_excluded = [
    "onAccept",
    "onClear",
    "onCancel",
    "onSetToday",
    "actions"
];
/**
 * Demos:
 *
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersActionBar API](https://mui.com/x/api/date-pickers/pickers-action-bar/)
 */ function $04e6a830aa77d79d$export$72ffda3bb7ecf665(props) {
    const { onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, actions: actions } = props, other = (0, $3L80X.default)(props, $04e6a830aa77d79d$var$_excluded);
    const localeText = (0, $58b82a9afc388fa3$export$24fdeaa0f591a73e)();
    if (actions == null || actions.length === 0) return null;
    const buttons = actions?.map((actionType)=>{
        switch(actionType){
            case "clear":
                return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $980dfff3cab72cf4$export$2e2bcd8739ae039), {
                    onClick: onClear,
                    children: localeText.clearButtonLabel
                }, actionType);
            case "cancel":
                return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $980dfff3cab72cf4$export$2e2bcd8739ae039), {
                    onClick: onCancel,
                    children: localeText.cancelButtonLabel
                }, actionType);
            case "accept":
                return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $980dfff3cab72cf4$export$2e2bcd8739ae039), {
                    onClick: onAccept,
                    children: localeText.okButtonLabel
                }, actionType);
            case "today":
                return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $980dfff3cab72cf4$export$2e2bcd8739ae039), {
                    onClick: onSetToday,
                    children: localeText.todayButtonLabel
                }, actionType);
            default:
                return null;
        }
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8136e94a8ae83d0c$export$2e2bcd8739ae039), (0, $aJx1R.default)({}, other, {
        children: buttons
    }));
}




var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");
parcelRequire("exYeM");



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");


var $2f0D3 = parcelRequire("2f0D3");



var $8L988 = parcelRequire("8L988");

var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");






var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $2b61985512eb204d$export$5682c366c0c669d9(slot) {
    return (0, $dC5O8.default)("MuiListItem", slot);
}
const $2b61985512eb204d$var$listItemClasses = (0, $kY7HX.default)("MuiListItem", [
    "root",
    "container",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "padding",
    "button",
    "secondaryAction",
    "selected"
]);
var $2b61985512eb204d$export$2e2bcd8739ae039 = $2b61985512eb204d$var$listItemClasses;



var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $94d34add1c81525d$export$c09531d8563c67a5(slot) {
    return (0, $dC5O8.default)("MuiListItemButton", slot);
}
const $94d34add1c81525d$var$listItemButtonClasses = (0, $kY7HX.default)("MuiListItemButton", [
    "root",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $94d34add1c81525d$export$2e2bcd8739ae039 = $94d34add1c81525d$var$listItemButtonClasses;



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");


var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $28a278943dc21d24$export$ccdb26aeba48a86e(slot) {
    return (0, $dC5O8.default)("MuiListItemSecondaryAction", slot);
}
const $28a278943dc21d24$var$listItemSecondaryActionClasses = (0, $kY7HX.default)("MuiListItemSecondaryAction", [
    "root",
    "disableGutters"
]);
var $28a278943dc21d24$export$2e2bcd8739ae039 = $28a278943dc21d24$var$listItemSecondaryActionClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $1d2b1bcbdb74cc2d$var$_excluded = [
    "className"
];
const $1d2b1bcbdb74cc2d$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disableGutters && "disableGutters"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $28a278943dc21d24$export$ccdb26aeba48a86e), classes);
};
const $1d2b1bcbdb74cc2d$var$ListItemSecondaryActionRoot = (0, $jawKn.default)("div", {
    name: "MuiListItemSecondaryAction",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState })=>(0, $aJx1R.default)({
        position: "absolute",
        right: 16,
        top: "50%",
        transform: "translateY(-50%)"
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $1d2b1bcbdb74cc2d$var$ListItemSecondaryAction = /*#__PURE__*/ $exYeM.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiListItemSecondaryAction"
    });
    const { className: className } = props, other = (0, $3L80X.default)(props, $1d2b1bcbdb74cc2d$var$_excluded);
    const context = $exYeM.useContext((0, $8b8465e0061b533a$export$2e2bcd8739ae039));
    const ownerState = (0, $aJx1R.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $1d2b1bcbdb74cc2d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($1d2b1bcbdb74cc2d$var$ListItemSecondaryActionRoot, (0, $aJx1R.default)({
        className: (0, $4qr5a.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$1d2b1bcbdb74cc2d$var$ListItemSecondaryAction.muiName = "ListItemSecondaryAction";
var $1d2b1bcbdb74cc2d$export$2e2bcd8739ae039 = $1d2b1bcbdb74cc2d$var$ListItemSecondaryAction;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $f2c5bbcc9da18cc0$var$_excluded = [
    "className"
], $f2c5bbcc9da18cc0$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const $f2c5bbcc9da18cc0$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $f2c5bbcc9da18cc0$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, button: button, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            !disableGutters && "gutters",
            !disablePadding && "padding",
            divider && "divider",
            disabled && "disabled",
            button && "button",
            alignItems === "flex-start" && "alignItemsFlexStart",
            hasSecondaryAction && "secondaryAction",
            selected && "selected"
        ],
        container: [
            "container"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $2b61985512eb204d$export$5682c366c0c669d9), classes);
};
const $f2c5bbcc9da18cc0$export$aed538f7519abe89 = (0, $jawKn.default)("div", {
    name: "MuiListItem",
    slot: "Root",
    overridesResolver: $f2c5bbcc9da18cc0$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        width: "100%",
        boxSizing: "border-box",
        textAlign: "left"
    }, !ownerState.disablePadding && (0, $aJx1R.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $94d34add1c81525d$export$2e2bcd8739ae039).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $2b61985512eb204d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $2b61985512eb204d$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $8L988.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $2b61985512eb204d$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $8L988.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $2b61985512eb204d$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === "flex-start" && {
        alignItems: "flex-start"
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, ownerState.button && {
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $2b61985512eb204d$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $8L988.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $8L988.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $f2c5bbcc9da18cc0$var$ListItemContainer = (0, $jawKn.default)("li", {
    name: "MuiListItem",
    slot: "Container",
    overridesResolver: (props, styles)=>styles.container
})({
    position: "relative"
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $f2c5bbcc9da18cc0$var$ListItem = /*#__PURE__*/ $exYeM.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiListItem"
    });
    const { alignItems: alignItems = "center", autoFocus: autoFocus = false, button: button = false, children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = "li", ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disabled: disabled = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, secondaryAction: secondaryAction, selected: selected = false, slotProps: slotProps = {}, slots: slots = {} } = props, ContainerProps = (0, $3L80X.default)(props.ContainerProps, $f2c5bbcc9da18cc0$var$_excluded), other = (0, $3L80X.default)(props, $f2c5bbcc9da18cc0$var$_excluded2);
    const context = $exYeM.useContext((0, $8b8465e0061b533a$export$2e2bcd8739ae039));
    const childContext = $exYeM.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $exYeM.useRef(null);
    (0, $3e56c60e7cf2a296$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = $exYeM.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $2b84a4ecf9ea9611$export$2e2bcd8739ae039)(children[children.length - 1], [
        "ListItemSecondaryAction"
    ]);
    const ownerState = (0, $aJx1R.default)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $f2c5bbcc9da18cc0$var$useUtilityClasses(ownerState);
    const handleRef = (0, $69ecd4eca0914ac9$export$2e2bcd8739ae039)(listItemRef, ref);
    const Root = slots.root || components.Root || $f2c5bbcc9da18cc0$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, $aJx1R.default)({
        className: (0, $4qr5a.default)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || "li";
    if (button) {
        componentProps.component = componentProp || "div";
        componentProps.focusVisibleClassName = (0, $4qr5a.default)((0, $2b61985512eb204d$export$2e2bcd8739ae039).focusVisible, focusVisibleClassName);
        Component = (0, $8c6774266c067eb9$export$2e2bcd8739ae039);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? "div" : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === "li") {
            if (Component === "li") Component = "div";
            else if (componentProps.component === "li") componentProps.component = "div";
        }
        return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8b8465e0061b533a$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $aSiaI.jsxs)($f2c5bbcc9da18cc0$var$ListItemContainer, (0, $aJx1R.default)({
                as: ContainerComponent,
                className: (0, $4qr5a.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)(Root, (0, $aJx1R.default)({}, rootProps, !(0, $6d812737487786ea$export$e28348cc2430497)(Root) && {
                        as: Component,
                        ownerState: (0, $aJx1R.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8b8465e0061b533a$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)(Root, (0, $aJx1R.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, $6d812737487786ea$export$e28348cc2430497)(Root) && {
            ownerState: (0, $aJx1R.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1d2b1bcbdb74cc2d$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
var $f2c5bbcc9da18cc0$export$2e2bcd8739ae039 = $f2c5bbcc9da18cc0$var$ListItem;



const $5c20cfc7ef711f44$export$3f0060ce4cc8f4d0 = 36;
const $5c20cfc7ef711f44$export$dde58b009b497666 = 2;
const $5c20cfc7ef711f44$export$ee46b8a74d6c94d3 = 320;
const $5c20cfc7ef711f44$export$73724491020e90c7 = 280;
const $5c20cfc7ef711f44$export$f2fef360e2df0cb7 = 336;
const $5c20cfc7ef711f44$export$1c2eabda4acea0e4 = 232;
const $5c20cfc7ef711f44$export$a462ceb9cfdb5d71 = 48;



var $aSiaI = parcelRequire("aSiaI");
const $8482d7f8ed6b3de0$var$_excluded = [
    "items",
    "changeImportance",
    "isLandscape",
    "onChange",
    "isValid"
], $8482d7f8ed6b3de0$var$_excluded2 = [
    "getValue"
];
/**
 * Demos:
 *
 * - [Shortcuts](https://mui.com/x/react-date-pickers/shortcuts/)
 *
 * API:
 *
 * - [PickersShortcuts API](https://mui.com/x/api/date-pickers/pickers-shortcuts/)
 */ function $8482d7f8ed6b3de0$export$8ba8fc65919fa1fe(props) {
    const { items: items, changeImportance: changeImportance = "accept", onChange: onChange, isValid: isValid } = props, other = (0, $3L80X.default)(props, $8482d7f8ed6b3de0$var$_excluded);
    if (items == null || items.length === 0) return null;
    const resolvedItems = items.map((_ref)=>{
        let { getValue: getValue } = _ref, item = (0, $3L80X.default)(_ref, $8482d7f8ed6b3de0$var$_excluded2);
        const newValue = getValue({
            isValid: isValid
        });
        return {
            label: item.label,
            onClick: ()=>{
                onChange(newValue, changeImportance, item);
            },
            disabled: !isValid(newValue)
        };
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1217f3be3073ef0b$export$2e2bcd8739ae039), (0, $aJx1R.default)({
        dense: true,
        sx: [
            {
                maxHeight: (0, $5c20cfc7ef711f44$export$f2fef360e2df0cb7),
                maxWidth: 200,
                overflow: "auto"
            },
            ...Array.isArray(other.sx) ? other.sx : [
                other.sx
            ]
        ]
    }, other, {
        children: resolvedItems.map((item)=>{
            return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f2c5bbcc9da18cc0$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8b19ed05d27c6095$export$2e2bcd8739ae039), (0, $aJx1R.default)({}, item))
            }, item.label);
        })
    }));
}



var $aSiaI = parcelRequire("aSiaI");
function $acda522799264968$var$toolbarHasView(toolbarProps) {
    return toolbarProps.view !== null;
}
const $acda522799264968$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            "root",
            isLandscape && "landscape"
        ],
        contentWrapper: [
            "contentWrapper"
        ],
        toolbar: [
            "toolbar"
        ],
        actionBar: [
            "actionBar"
        ],
        tabs: [
            "tabs"
        ],
        landscape: [
            "landscape"
        ],
        shortcuts: [
            "shortcuts"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $fd37cd49589c7ef4$export$1671c31de798d429), classes);
};
const $acda522799264968$var$usePickerLayout = (props)=>{
    const { wrapperVariant: wrapperVariant, onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, view: view, views: views, onViewChange: onViewChange, value: value, onChange: onChange, onSelectShortcut: onSelectShortcut, isValid: isValid, isLandscape: isLandscape, disabled: disabled, readOnly: readOnly, children: children, slots: slots, slotProps: slotProps } = props;
    const classes = $acda522799264968$var$useUtilityClasses(props);
    // Action bar
    const ActionBar = slots?.actionBar ?? (0, $04e6a830aa77d79d$export$72ffda3bb7ecf665);
    const actionBarProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: ActionBar,
        externalSlotProps: slotProps?.actionBar,
        additionalProps: {
            onAccept: onAccept,
            onClear: onClear,
            onCancel: onCancel,
            onSetToday: onSetToday,
            actions: wrapperVariant === "desktop" ? [] : [
                "cancel",
                "accept"
            ],
            className: classes.actionBar
        },
        ownerState: (0, $aJx1R.default)({}, props, {
            wrapperVariant: wrapperVariant
        })
    });
    const actionBar = /*#__PURE__*/ (0, $aSiaI.jsx)(ActionBar, (0, $aJx1R.default)({}, actionBarProps));
    // Toolbar
    const Toolbar = slots?.toolbar;
    const toolbarProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: Toolbar,
        externalSlotProps: slotProps?.toolbar,
        additionalProps: {
            isLandscape: isLandscape,
            onChange: onChange,
            value: value,
            view: view,
            onViewChange: onViewChange,
            views: views,
            disabled: disabled,
            readOnly: readOnly,
            className: classes.toolbar
        },
        ownerState: (0, $aJx1R.default)({}, props, {
            wrapperVariant: wrapperVariant
        })
    });
    const toolbar = $acda522799264968$var$toolbarHasView(toolbarProps) && !!Toolbar ? /*#__PURE__*/ (0, $aSiaI.jsx)(Toolbar, (0, $aJx1R.default)({}, toolbarProps)) : null;
    // Content
    const content = children;
    // Tabs
    const Tabs = slots?.tabs;
    const tabs = view && Tabs ? /*#__PURE__*/ (0, $aSiaI.jsx)(Tabs, (0, $aJx1R.default)({
        view: view,
        onViewChange: onViewChange,
        className: classes.tabs
    }, slotProps?.tabs)) : null;
    // Shortcuts
    const Shortcuts = slots?.shortcuts ?? (0, $8482d7f8ed6b3de0$export$8ba8fc65919fa1fe);
    const shortcutsProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: Shortcuts,
        externalSlotProps: slotProps?.shortcuts,
        additionalProps: {
            isValid: isValid,
            isLandscape: isLandscape,
            onChange: onSelectShortcut,
            className: classes.shortcuts
        },
        ownerState: {
            isValid: isValid,
            isLandscape: isLandscape,
            onChange: onSelectShortcut,
            className: classes.shortcuts,
            wrapperVariant: wrapperVariant
        }
    });
    const shortcuts = view && !!Shortcuts ? /*#__PURE__*/ (0, $aSiaI.jsx)(Shortcuts, (0, $aJx1R.default)({}, shortcutsProps)) : null;
    return {
        toolbar: toolbar,
        content: content,
        tabs: tabs,
        actionBar: actionBar,
        shortcuts: shortcuts
    };
};
var $acda522799264968$export$2e2bcd8739ae039 = $acda522799264968$var$usePickerLayout;



var $aSiaI = parcelRequire("aSiaI");
const $29c3cc0dfa80590a$var$useUtilityClasses = (ownerState)=>{
    const { isLandscape: isLandscape, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            isLandscape && "landscape"
        ],
        contentWrapper: [
            "contentWrapper"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $fd37cd49589c7ef4$export$1671c31de798d429), classes);
};
const $29c3cc0dfa80590a$export$9a9363506c13836 = (0, $jawKn.default)("div", {
    name: "MuiPickersLayout",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: "grid",
        gridAutoColumns: "max-content auto max-content",
        gridAutoRows: "max-content auto max-content",
        [`& .${(0, $fd37cd49589c7ef4$export$7a6dac186703fe4c).actionBar}`]: {
            gridColumn: "1 / 4",
            gridRow: 3
        },
        variants: [
            {
                props: {
                    isLandscape: true
                },
                style: {
                    [`& .${(0, $fd37cd49589c7ef4$export$7a6dac186703fe4c).toolbar}`]: {
                        gridColumn: theme.direction === "rtl" ? 3 : 1,
                        gridRow: "2 / 3"
                    },
                    [`.${(0, $fd37cd49589c7ef4$export$7a6dac186703fe4c).shortcuts}`]: {
                        gridColumn: "2 / 4",
                        gridRow: 1
                    }
                }
            },
            {
                props: {
                    isLandscape: false
                },
                style: {
                    [`& .${(0, $fd37cd49589c7ef4$export$7a6dac186703fe4c).toolbar}`]: {
                        gridColumn: "2 / 4",
                        gridRow: 1
                    },
                    [`& .${(0, $fd37cd49589c7ef4$export$7a6dac186703fe4c).shortcuts}`]: {
                        gridColumn: theme.direction === "rtl" ? 3 : 1,
                        gridRow: "2 / 3"
                    }
                }
            }
        ]
    }));
$29c3cc0dfa80590a$export$9a9363506c13836.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    as: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).elementType,
    ownerState: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).shape({
        isLandscape: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool.isRequired
    }).isRequired,
    sx: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object
    ])
};
const $29c3cc0dfa80590a$export$bc1494d918129235 = (0, $jawKn.default)("div", {
    name: "MuiPickersLayout",
    slot: "ContentWrapper",
    overridesResolver: (props, styles)=>styles.contentWrapper
})({
    gridColumn: 2,
    gridRow: 2,
    display: "flex",
    flexDirection: "column"
});
/**
 * Demos:
 *
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersLayout API](https://mui.com/x/api/date-pickers/pickers-layout/)
 */ const $29c3cc0dfa80590a$export$647f604ea2397c05 = function PickersLayout(inProps) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiPickersLayout"
    });
    const { toolbar: toolbar, content: content, tabs: tabs, actionBar: actionBar, shortcuts: shortcuts } = (0, $acda522799264968$export$2e2bcd8739ae039)(props);
    const { sx: sx, className: className, isLandscape: isLandscape, ref: ref, wrapperVariant: wrapperVariant } = props;
    const ownerState = props;
    const classes = $29c3cc0dfa80590a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($29c3cc0dfa80590a$export$9a9363506c13836, {
        ref: ref,
        sx: sx,
        className: (0, $4qr5a.default)(className, classes.root),
        ownerState: ownerState,
        children: [
            isLandscape ? shortcuts : toolbar,
            isLandscape ? toolbar : shortcuts,
            /*#__PURE__*/ (0, $aSiaI.jsx)($29c3cc0dfa80590a$export$bc1494d918129235, {
                className: classes.contentWrapper,
                children: wrapperVariant === "desktop" ? /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
                    children: [
                        content,
                        tabs
                    ]
                }) : /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
                    children: [
                        tabs,
                        content
                    ]
                })
            }),
            actionBar
        ]
    });
};



var $aSiaI = parcelRequire("aSiaI");
const $877e64d9c1b81de9$var$_excluded = [
    "props",
    "getOpenDialogAriaText"
], $877e64d9c1b81de9$var$_excluded2 = [
    "ownerState"
], $877e64d9c1b81de9$var$_excluded3 = [
    "ownerState"
];
const $877e64d9c1b81de9$export$b1b70bc56ac5be0e = (_ref)=>{
    let { props: props, getOpenDialogAriaText: getOpenDialogAriaText } = _ref, pickerParams = (0, $3L80X.default)(_ref, $877e64d9c1b81de9$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure, selectedSections: selectedSections, onSelectedSectionsChange: onSelectedSectionsChange, timezone: timezone, name: name, label: label, inputRef: inputRef, readOnly: readOnly, disabled: disabled, autoFocus: autoFocus, localeText: localeText, reduceAnimations: reduceAnimations } = props;
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const containerRef = $exYeM.useRef(null);
    const fieldRef = $exYeM.useRef(null);
    const labelId = (0, $43c7ad0c22f8e14a$export$2e2bcd8739ae039)();
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const { open: open, actions: actions, hasUIView: hasUIView, layoutProps: layoutProps, renderCurrentView: renderCurrentView, shouldRestoreFocus: shouldRestoreFocus, fieldProps: pickerFieldProps } = (0, $fe214b73a0b4d59a$export$fc3313977ac596c4)((0, $aJx1R.default)({}, pickerParams, {
        props: props,
        fieldRef: fieldRef,
        autoFocusView: true,
        additionalViewProps: {},
        wrapperVariant: "desktop"
    }));
    const InputAdornment = slots.inputAdornment ?? (0, $60f459c5525ea035$export$2e2bcd8739ae039);
    const _useSlotProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: InputAdornment,
        externalSlotProps: innerSlotProps?.inputAdornment,
        additionalProps: {
            position: "end"
        },
        ownerState: props
    }), inputAdornmentProps = (0, $3L80X.default)(_useSlotProps, $877e64d9c1b81de9$var$_excluded2);
    const OpenPickerButton = slots.openPickerButton ?? (0, $96b952e1d26b1f04$export$2e2bcd8739ae039);
    const _useSlotProps2 = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: OpenPickerButton,
        externalSlotProps: innerSlotProps?.openPickerButton,
        additionalProps: {
            disabled: disabled || readOnly,
            onClick: open ? actions.onClose : actions.onOpen,
            "aria-label": getOpenDialogAriaText(pickerFieldProps.value, utils),
            edge: inputAdornmentProps.position
        },
        ownerState: props
    }), openPickerButtonProps = (0, $3L80X.default)(_useSlotProps2, $877e64d9c1b81de9$var$_excluded3);
    const OpenPickerIcon = slots.openPickerIcon;
    const Field = slots.field;
    const fieldProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: (0, $aJx1R.default)({}, pickerFieldProps, isToolbarHidden && {
            id: labelId
        }, {
            readOnly: readOnly,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            selectedSections: selectedSections,
            onSelectedSectionsChange: onSelectedSectionsChange,
            timezone: timezone,
            label: label,
            name: name,
            autoFocus: autoFocus && !props.open,
            focused: open ? true : undefined
        }, inputRef ? {
            inputRef: inputRef
        } : {}),
        ownerState: props
    });
    // TODO: Move to `useSlotProps` when https://github.com/mui/material-ui/pull/35088 will be merged
    if (hasUIView) fieldProps.InputProps = (0, $aJx1R.default)({}, fieldProps.InputProps, {
        ref: containerRef,
        [`${inputAdornmentProps.position}Adornment`]: /*#__PURE__*/ (0, $aSiaI.jsx)(InputAdornment, (0, $aJx1R.default)({}, inputAdornmentProps, {
            children: /*#__PURE__*/ (0, $aSiaI.jsx)(OpenPickerButton, (0, $aJx1R.default)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, $aSiaI.jsx)(OpenPickerIcon, (0, $aJx1R.default)({}, innerSlotProps?.openPickerIcon))
            }))
        }))
    });
    const slotsForField = (0, $aJx1R.default)({
        textField: slots.textField,
        clearIcon: slots.clearIcon,
        clearButton: slots.clearButton
    }, fieldProps.slots);
    const Layout = slots.layout ?? (0, $29c3cc0dfa80590a$export$647f604ea2397c05);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $aJx1R.default)({}, innerSlotProps, {
        toolbar: (0, $aJx1R.default)({}, innerSlotProps?.toolbar, {
            titleId: labelId
        }),
        popper: (0, $aJx1R.default)({
            "aria-labelledby": labelledById
        }, innerSlotProps?.popper)
    });
    const handleFieldRef = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(fieldRef, fieldProps.unstableFieldRef);
    const renderPicker = ()=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $24be003479f5f381$export$dc45bdc734ce6f1e), {
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)(Field, (0, $aJx1R.default)({}, fieldProps, {
                    slots: slotsForField,
                    slotProps: slotProps,
                    unstableFieldRef: handleFieldRef
                })),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cef6846a1b6167ab$export$96ce8482474de8a5), (0, $aJx1R.default)({
                    role: "dialog",
                    placement: "bottom-start",
                    anchorEl: containerRef.current
                }, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    shouldRestoreFocus: shouldRestoreFocus,
                    reduceAnimations: reduceAnimations,
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)(Layout, (0, $aJx1R.default)({}, layoutProps, slotProps?.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};



var $bPz57 = parcelRequire("bPz57");

var $exYeM = parcelRequire("exYeM");

var $aSiaI = parcelRequire("aSiaI");
const $ea58bbb735a57109$export$ed0fe318cc298673 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
const $ea58bbb735a57109$export$8afed21ef5c2afa5 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft");
const $ea58bbb735a57109$export$9ca09caa9c849d9c = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight");
const $ea58bbb735a57109$export$5fda1783bb83f57b = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar");
const $ea58bbb735a57109$export$8099ab97743c966c = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
    children: [
        /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), "Clock");
const $ea58bbb735a57109$export$90a8eab2a2411720 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange");
const $ea58bbb735a57109$export$7e95adcf912503e3 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
    children: [
        /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $aSiaI.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), "Time");
const $ea58bbb735a57109$export$cefbac224a47f32 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");



var $7PWLt = parcelRequire("7PWLt");




var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");







var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");





var $aJx1R = parcelRequire("aJx1R");

const $58ff3e7ddcc9b139$var$expandFormat = ({ utils: utils, format: format })=>{
    // Expand the provided format
    let formatExpansionOverflow = 10;
    let prevFormat = format;
    let nextFormat = utils.expandFormat(format);
    while(nextFormat !== prevFormat){
        prevFormat = nextFormat;
        nextFormat = utils.expandFormat(prevFormat);
        formatExpansionOverflow -= 1;
        if (formatExpansionOverflow < 0) throw new Error("MUI X: The format expansion seems to be in an infinite loop. Please open an issue with the format passed to the picker component.");
    }
    return nextFormat;
};
const $58ff3e7ddcc9b139$var$getEscapedPartsFromFormat = ({ utils: utils, expandedFormat: expandedFormat })=>{
    const escapedParts = [];
    const { start: startChar, end: endChar } = utils.escapedCharacters;
    const regExp = new RegExp(`(\\${startChar}[^\\${endChar}]*\\${endChar})+`, "g");
    let match = null;
    // eslint-disable-next-line no-cond-assign
    while(match = regExp.exec(expandedFormat))escapedParts.push({
        start: match.index,
        end: regExp.lastIndex - 1
    });
    return escapedParts;
};
const $58ff3e7ddcc9b139$var$getSectionPlaceholder = (utils, timezone, localeText, sectionConfig, sectionFormat)=>{
    switch(sectionConfig.type){
        case "year":
            return localeText.fieldYearPlaceholder({
                digitAmount: utils.formatByString(utils.date(undefined, timezone), sectionFormat).length,
                format: sectionFormat
            });
        case "month":
            return localeText.fieldMonthPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case "day":
            return localeText.fieldDayPlaceholder({
                format: sectionFormat
            });
        case "weekDay":
            return localeText.fieldWeekDayPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case "hours":
            return localeText.fieldHoursPlaceholder({
                format: sectionFormat
            });
        case "minutes":
            return localeText.fieldMinutesPlaceholder({
                format: sectionFormat
            });
        case "seconds":
            return localeText.fieldSecondsPlaceholder({
                format: sectionFormat
            });
        case "meridiem":
            return localeText.fieldMeridiemPlaceholder({
                format: sectionFormat
            });
        default:
            return sectionFormat;
    }
};
const $58ff3e7ddcc9b139$var$createSection = ({ utils: utils, timezone: timezone, date: date, shouldRespectLeadingZeros: shouldRespectLeadingZeros, localeText: localeText, localizedDigits: localizedDigits, now: now, token: token, startSeparator: startSeparator })=>{
    if (token === "") throw new Error("MUI X: Should not call `commitToken` with an empty token");
    const sectionConfig = (0, $26f4e5858fb820e2$export$2f3c5fac7a2a65f6)(utils, token);
    const hasLeadingZerosInFormat = (0, $26f4e5858fb820e2$export$78b5830e2dd2de49)(utils, timezone, sectionConfig.contentType, sectionConfig.type, token);
    const hasLeadingZerosInInput = shouldRespectLeadingZeros ? hasLeadingZerosInFormat : sectionConfig.contentType === "digit";
    const isValidDate = date != null && utils.isValid(date);
    let sectionValue = isValidDate ? utils.formatByString(date, token) : "";
    let maxLength = null;
    if (hasLeadingZerosInInput) {
        if (hasLeadingZerosInFormat) maxLength = sectionValue === "" ? utils.formatByString(now, token).length : sectionValue.length;
        else {
            if (sectionConfig.maxLength == null) throw new Error(`MUI X: The token ${token} should have a 'maxDigitNumber' property on it's adapter`);
            maxLength = sectionConfig.maxLength;
            if (isValidDate) sectionValue = (0, $26f4e5858fb820e2$export$80dbbc19eba82070)((0, $26f4e5858fb820e2$export$713c6d756c12fc27)((0, $26f4e5858fb820e2$export$7dd321105a319e8)(sectionValue, localizedDigits), maxLength), localizedDigits);
        }
    }
    return (0, $aJx1R.default)({}, sectionConfig, {
        format: token,
        maxLength: maxLength,
        value: sectionValue,
        placeholder: $58ff3e7ddcc9b139$var$getSectionPlaceholder(utils, timezone, localeText, sectionConfig, token),
        hasLeadingZerosInFormat: hasLeadingZerosInFormat,
        hasLeadingZerosInInput: hasLeadingZerosInInput,
        startSeparator: startSeparator,
        endSeparator: "",
        modified: false
    });
};
const $58ff3e7ddcc9b139$var$buildSections = (params)=>{
    const { utils: utils, expandedFormat: expandedFormat, escapedParts: escapedParts } = params;
    const now = utils.date(undefined);
    const sections = [];
    let startSeparator = "";
    // This RegExp tests if the beginning of a string corresponds to a supported token
    const validTokens = Object.keys(utils.formatTokenMap).sort((a, b)=>b.length - a.length); // Sort to put longest word first
    const regExpFirstWordInFormat = /^([a-zA-Z]+)/;
    const regExpWordOnlyComposedOfTokens = new RegExp(`^(${validTokens.join("|")})*$`);
    const regExpFirstTokenInWord = new RegExp(`^(${validTokens.join("|")})`);
    const getEscapedPartOfCurrentChar = (i)=>escapedParts.find((escapeIndex)=>escapeIndex.start <= i && escapeIndex.end >= i);
    let i = 0;
    while(i < expandedFormat.length){
        const escapedPartOfCurrentChar = getEscapedPartOfCurrentChar(i);
        const isEscapedChar = escapedPartOfCurrentChar != null;
        const firstWordInFormat = regExpFirstWordInFormat.exec(expandedFormat.slice(i))?.[1];
        // The first word in the format is only composed of tokens.
        // We extract those tokens to create a new sections.
        if (!isEscapedChar && firstWordInFormat != null && regExpWordOnlyComposedOfTokens.test(firstWordInFormat)) {
            let word = firstWordInFormat;
            while(word.length > 0){
                const firstWord = regExpFirstTokenInWord.exec(word)[1];
                word = word.slice(firstWord.length);
                sections.push($58ff3e7ddcc9b139$var$createSection((0, $aJx1R.default)({}, params, {
                    now: now,
                    token: firstWord,
                    startSeparator: startSeparator
                })));
                startSeparator = "";
            }
            i += firstWordInFormat.length;
        } else {
            const char = expandedFormat[i];
            // If we are on the opening or closing character of an escaped part of the format,
            // Then we ignore this character.
            const isEscapeBoundary = isEscapedChar && escapedPartOfCurrentChar?.start === i || escapedPartOfCurrentChar?.end === i;
            if (!isEscapeBoundary) {
                if (sections.length === 0) startSeparator += char;
                else sections[sections.length - 1].endSeparator += char;
            }
            i += 1;
        }
    }
    if (sections.length === 0 && startSeparator.length > 0) sections.push({
        type: "empty",
        contentType: "letter",
        maxLength: null,
        format: "",
        value: "",
        placeholder: "",
        hasLeadingZerosInFormat: false,
        hasLeadingZerosInInput: false,
        startSeparator: startSeparator,
        endSeparator: "",
        modified: false
    });
    return sections;
};
const $58ff3e7ddcc9b139$var$postProcessSections = ({ isRTL: isRTL, formatDensity: formatDensity, sections: sections })=>{
    return sections.map((section)=>{
        const cleanSeparator = (separator)=>{
            let cleanedSeparator = separator;
            if (isRTL && cleanedSeparator !== null && cleanedSeparator.includes(" ")) cleanedSeparator = `\u2069${cleanedSeparator}\u2066`;
            if (formatDensity === "spacious" && [
                "/",
                ".",
                "-"
            ].includes(cleanedSeparator)) cleanedSeparator = ` ${cleanedSeparator} `;
            return cleanedSeparator;
        };
        section.startSeparator = cleanSeparator(section.startSeparator);
        section.endSeparator = cleanSeparator(section.endSeparator);
        return section;
    });
};
const $58ff3e7ddcc9b139$export$34084be60bfe3b3b = (params)=>{
    let expandedFormat = $58ff3e7ddcc9b139$var$expandFormat(params);
    if (params.isRTL && params.enableAccessibleFieldDOMStructure) expandedFormat = expandedFormat.split(" ").reverse().join(" ");
    const escapedParts = $58ff3e7ddcc9b139$var$getEscapedPartsFromFormat((0, $aJx1R.default)({}, params, {
        expandedFormat: expandedFormat
    }));
    const sections = $58ff3e7ddcc9b139$var$buildSections((0, $aJx1R.default)({}, params, {
        expandedFormat: expandedFormat,
        escapedParts: escapedParts
    }));
    return $58ff3e7ddcc9b139$var$postProcessSections((0, $aJx1R.default)({}, params, {
        sections: sections
    }));
};




const $ce9cefd79a6b3e38$export$4e8d6353e50062e7 = (params)=>{
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const localeText = (0, $58b82a9afc388fa3$export$24fdeaa0f591a73e)();
    const adapter = (0, $58b82a9afc388fa3$export$4b5a24245de9f7f9)();
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === "rtl";
    const { valueManager: valueManager, fieldValueManager: fieldValueManager, valueType: valueType, validator: validator, internalProps: internalProps, internalProps: { value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, onChange: onChange, format: format, formatDensity: formatDensity = "dense", selectedSections: selectedSectionsProp, onSelectedSectionsChange: onSelectedSectionsChange, shouldRespectLeadingZeros: shouldRespectLeadingZeros = false, timezone: timezoneProp, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure = false } } = params;
    const { timezone: timezone, value: valueFromTheOutside, handleValueChange: handleValueChange } = (0, $3e4aef0ef80b275d$export$c7e050e908c1b2bc)({
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: valueManager
    });
    const localizedDigits = $exYeM.useMemo(()=>(0, $26f4e5858fb820e2$export$b42be9ae7016ef5d)(utils), [
        utils
    ]);
    const sectionsValueBoundaries = $exYeM.useMemo(()=>(0, $26f4e5858fb820e2$export$360600f456ea7d5f)(utils, localizedDigits, timezone), [
        utils,
        localizedDigits,
        timezone
    ]);
    const getSectionsFromValue = $exYeM.useCallback((value, fallbackSections = null)=>fieldValueManager.getSectionsFromValue(utils, value, fallbackSections, (date)=>(0, $58ff3e7ddcc9b139$export$34084be60bfe3b3b)({
                utils: utils,
                timezone: timezone,
                localeText: localeText,
                localizedDigits: localizedDigits,
                format: format,
                date: date,
                formatDensity: formatDensity,
                shouldRespectLeadingZeros: shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
                isRTL: isRTL
            })), [
        fieldValueManager,
        format,
        localeText,
        localizedDigits,
        isRTL,
        shouldRespectLeadingZeros,
        utils,
        formatDensity,
        timezone,
        enableAccessibleFieldDOMStructure
    ]);
    const [state, setState] = $exYeM.useState(()=>{
        const sections = getSectionsFromValue(valueFromTheOutside);
        (0, $26f4e5858fb820e2$export$ef6fbc09372bd65c)(sections, valueType);
        const stateWithoutReferenceDate = {
            sections: sections,
            value: valueFromTheOutside,
            referenceValue: valueManager.emptyValue,
            tempValueStrAndroid: null
        };
        const granularity = (0, $bd0cf02b8b64cf79$export$3f2547ddf892237a)(sections);
        const referenceValue = valueManager.getInitialReferenceValue({
            referenceDate: referenceDateProp,
            value: valueFromTheOutside,
            utils: utils,
            props: internalProps,
            granularity: granularity,
            timezone: timezone
        });
        return (0, $aJx1R.default)({}, stateWithoutReferenceDate, {
            referenceValue: referenceValue
        });
    });
    const [selectedSections, innerSetSelectedSections] = (0, $d86ef59ee77e84fd$export$2e2bcd8739ae039)({
        controlled: selectedSectionsProp,
        default: null,
        name: "useField",
        state: "selectedSections"
    });
    const setSelectedSections = (newSelectedSections)=>{
        innerSetSelectedSections(newSelectedSections);
        onSelectedSectionsChange?.(newSelectedSections);
    };
    const parsedSelectedSections = $exYeM.useMemo(()=>(0, $26f4e5858fb820e2$export$b31f27a6e35a0b27)(selectedSections, state.sections), [
        selectedSections,
        state.sections
    ]);
    const activeSectionIndex = parsedSelectedSections === "all" ? 0 : parsedSelectedSections;
    const publishValue = ({ value: value, referenceValue: referenceValue, sections: sections })=>{
        setState((prevState)=>(0, $aJx1R.default)({}, prevState, {
                sections: sections,
                value: value,
                referenceValue: referenceValue,
                tempValueStrAndroid: null
            }));
        if (valueManager.areValuesEqual(utils, state.value, value)) return;
        const context = {
            validationError: validator({
                adapter: adapter,
                value: value,
                props: (0, $aJx1R.default)({}, internalProps, {
                    value: value,
                    timezone: timezone
                })
            })
        };
        handleValueChange(value, context);
    };
    const setSectionValue = (sectionIndex, newSectionValue)=>{
        const newSections = [
            ...state.sections
        ];
        newSections[sectionIndex] = (0, $aJx1R.default)({}, newSections[sectionIndex], {
            value: newSectionValue,
            modified: true
        });
        return newSections;
    };
    const clearValue = ()=>{
        publishValue({
            value: valueManager.emptyValue,
            referenceValue: state.referenceValue,
            sections: getSectionsFromValue(valueManager.emptyValue)
        });
    };
    const clearActiveSection = ()=>{
        if (activeSectionIndex == null) return;
        const activeSection = state.sections[activeSectionIndex];
        const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const nonEmptySectionCountBefore = activeDateManager.getSections(state.sections).filter((section)=>section.value !== "").length;
        const hasNoOtherNonEmptySections = nonEmptySectionCountBefore === (activeSection.value === "" ? 0 : 1);
        const newSections = setSectionValue(activeSectionIndex, "");
        const newActiveDate = hasNoOtherNonEmptySections ? null : utils.getInvalidDate();
        const newValues = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
        publishValue((0, $aJx1R.default)({}, newValues, {
            sections: newSections
        }));
    };
    const updateValueFromValueStr = (valueStr)=>{
        const parseDateStr = (dateStr, referenceDate)=>{
            const date = utils.parse(dateStr, format);
            if (date == null || !utils.isValid(date)) return null;
            const sections = (0, $58ff3e7ddcc9b139$export$34084be60bfe3b3b)({
                utils: utils,
                timezone: timezone,
                localeText: localeText,
                localizedDigits: localizedDigits,
                format: format,
                date: date,
                formatDensity: formatDensity,
                shouldRespectLeadingZeros: shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
                isRTL: isRTL
            });
            return (0, $26f4e5858fb820e2$export$6c6df982c77f60a9)(utils, timezone, date, sections, referenceDate, false);
        };
        const newValue = fieldValueManager.parseValueStr(valueStr, state.referenceValue, parseDateStr);
        const newReferenceValue = fieldValueManager.updateReferenceValue(utils, newValue, state.referenceValue);
        publishValue({
            value: newValue,
            referenceValue: newReferenceValue,
            sections: getSectionsFromValue(newValue, state.sections)
        });
    };
    const updateSectionValue = ({ activeSection: activeSection, newSectionValue: newSectionValue, shouldGoToNextSection: shouldGoToNextSection })=>{
        /**
     * 1. Decide which section should be focused
     */ if (shouldGoToNextSection && activeSectionIndex < state.sections.length - 1) setSelectedSections(activeSectionIndex + 1);
        /**
     * 2. Try to build a valid date from the new section value
     */ const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const newSections = setSectionValue(activeSectionIndex, newSectionValue);
        const newActiveDateSections = activeDateManager.getSections(newSections);
        const newActiveDate = (0, $26f4e5858fb820e2$export$b0c1bfd065bfe742)(utils, newActiveDateSections, localizedDigits);
        let values;
        let shouldPublish;
        /**
     * If the new date is valid,
     * Then we merge the value of the modified sections into the reference date.
     * This makes sure that we don't lose some information of the initial date (like the time on a date field).
     */ if (newActiveDate != null && utils.isValid(newActiveDate)) {
            const mergedDate = (0, $26f4e5858fb820e2$export$6c6df982c77f60a9)(utils, timezone, newActiveDate, newActiveDateSections, activeDateManager.referenceDate, true);
            values = activeDateManager.getNewValuesFromNewActiveDate(mergedDate);
            shouldPublish = true;
        } else {
            values = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
            shouldPublish = (newActiveDate != null && !utils.isValid(newActiveDate)) !== (activeDateManager.date != null && !utils.isValid(activeDateManager.date));
        }
        /**
     * Publish or update the internal state with the new value and sections.
     */ if (shouldPublish) return publishValue((0, $aJx1R.default)({}, values, {
            sections: newSections
        }));
        return setState((prevState)=>(0, $aJx1R.default)({}, prevState, values, {
                sections: newSections,
                tempValueStrAndroid: null
            }));
    };
    const setTempAndroidValueStr = (tempValueStrAndroid)=>setState((prev)=>(0, $aJx1R.default)({}, prev, {
                tempValueStrAndroid: tempValueStrAndroid
            }));
    $exYeM.useEffect(()=>{
        const sections = getSectionsFromValue(state.value);
        (0, $26f4e5858fb820e2$export$ef6fbc09372bd65c)(sections, valueType);
        setState((prevState)=>(0, $aJx1R.default)({}, prevState, {
                sections: sections
            }));
    }, [
        format,
        utils.locale,
        isRTL
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    $exYeM.useEffect(()=>{
        let shouldUpdate;
        if (!valueManager.areValuesEqual(utils, state.value, valueFromTheOutside)) shouldUpdate = true;
        else shouldUpdate = valueManager.getTimezone(utils, state.value) !== valueManager.getTimezone(utils, valueFromTheOutside);
        if (shouldUpdate) setState((prevState)=>(0, $aJx1R.default)({}, prevState, {
                value: valueFromTheOutside,
                referenceValue: fieldValueManager.updateReferenceValue(utils, valueFromTheOutside, prevState.referenceValue),
                sections: getSectionsFromValue(valueFromTheOutside)
            }));
    }, [
        valueFromTheOutside
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        state: state,
        activeSectionIndex: activeSectionIndex,
        parsedSelectedSections: parsedSelectedSections,
        setSelectedSections: setSelectedSections,
        clearValue: clearValue,
        clearActiveSection: clearActiveSection,
        updateSectionValue: updateSectionValue,
        updateValueFromValueStr: updateValueFromValueStr,
        setTempAndroidValueStr: setTempAndroidValueStr,
        getSectionsFromValue: getSectionsFromValue,
        sectionsValueBoundaries: sectionsValueBoundaries,
        localizedDigits: localizedDigits,
        timezone: timezone
    };
};



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");



/**
 * The letter editing and the numeric editing each define a `CharacterEditingApplier`.
 * This function decides what the new section value should be and if the focus should switch to the next section.
 *
 * If it returns `null`, then the section value is not updated and the focus does not move.
 */ /**
 * Function called by `applyQuery` which decides:
 * - what is the new section value ?
 * - should the query used to get this value be stored for the next key press ?
 *
 * If it returns `{ sectionValue: string; shouldGoToNextSection: boolean }`,
 * Then we store the query and update the section with the new value.
 *
 * If it returns `{ saveQuery: true` },
 * Then we store the query and don't update the section.
 *
 * If it returns `{ saveQuery: false },
 * Then we do nothing.
 */ const $6a5d3f6b34f82c01$var$QUERY_LIFE_DURATION_MS = 5000;
const $6a5d3f6b34f82c01$var$isQueryResponseWithoutValue = (response)=>response.saveQuery != null;
const $6a5d3f6b34f82c01$export$66d00048b8bb82f6 = ({ sections: sections, updateSectionValue: updateSectionValue, sectionsValueBoundaries: sectionsValueBoundaries, localizedDigits: localizedDigits, setTempAndroidValueStr: setTempAndroidValueStr, timezone: timezone })=>{
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const [query, setQuery] = $exYeM.useState(null);
    const resetQuery = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)(()=>setQuery(null));
    $exYeM.useEffect(()=>{
        if (query != null && sections[query.sectionIndex]?.type !== query.sectionType) resetQuery();
    }, [
        sections,
        query,
        resetQuery
    ]);
    $exYeM.useEffect(()=>{
        if (query != null) {
            const timeout = setTimeout(()=>resetQuery(), $6a5d3f6b34f82c01$var$QUERY_LIFE_DURATION_MS);
            return ()=>{
                clearTimeout(timeout);
            };
        }
        return ()=>{};
    }, [
        query,
        resetQuery
    ]);
    const applyQuery = ({ keyPressed: keyPressed, sectionIndex: sectionIndex }, getFirstSectionValueMatchingWithQuery, isValidQueryValue)=>{
        const cleanKeyPressed = keyPressed.toLowerCase();
        const activeSection = sections[sectionIndex];
        // The current query targets the section being editing
        // We can try to concatenate the value
        if (query != null && (!isValidQueryValue || isValidQueryValue(query.value)) && query.sectionIndex === sectionIndex) {
            const concatenatedQueryValue = `${query.value}${cleanKeyPressed}`;
            const queryResponse = getFirstSectionValueMatchingWithQuery(concatenatedQueryValue, activeSection);
            if (!$6a5d3f6b34f82c01$var$isQueryResponseWithoutValue(queryResponse)) {
                setQuery({
                    sectionIndex: sectionIndex,
                    value: concatenatedQueryValue,
                    sectionType: activeSection.type
                });
                return queryResponse;
            }
        }
        const queryResponse = getFirstSectionValueMatchingWithQuery(cleanKeyPressed, activeSection);
        if ($6a5d3f6b34f82c01$var$isQueryResponseWithoutValue(queryResponse) && !queryResponse.saveQuery) {
            resetQuery();
            return null;
        }
        setQuery({
            sectionIndex: sectionIndex,
            value: cleanKeyPressed,
            sectionType: activeSection.type
        });
        if ($6a5d3f6b34f82c01$var$isQueryResponseWithoutValue(queryResponse)) return null;
        return queryResponse;
    };
    const applyLetterEditing = (params)=>{
        const findMatchingOptions = (format, options, queryValue)=>{
            const matchingValues = options.filter((option)=>option.toLowerCase().startsWith(queryValue));
            if (matchingValues.length === 0) return {
                saveQuery: false
            };
            return {
                sectionValue: matchingValues[0],
                shouldGoToNextSection: matchingValues.length === 1
            };
        };
        const testQueryOnFormatAndFallbackFormat = (queryValue, activeSection, fallbackFormat, formatFallbackValue)=>{
            const getOptions = (format)=>(0, $26f4e5858fb820e2$export$3ee1e7e19c2b047a)(utils, timezone, activeSection.type, format);
            if (activeSection.contentType === "letter") return findMatchingOptions(activeSection.format, getOptions(activeSection.format), queryValue);
            // When editing a digit-format month / weekDay and the user presses a letter,
            // We can support the letter editing by using the letter-format month / weekDay and re-formatting the result.
            // We just have to make sure that the default month / weekDay format is a letter format,
            if (fallbackFormat && formatFallbackValue != null && (0, $26f4e5858fb820e2$export$2f3c5fac7a2a65f6)(utils, fallbackFormat).contentType === "letter") {
                const fallbackOptions = getOptions(fallbackFormat);
                const response = findMatchingOptions(fallbackFormat, fallbackOptions, queryValue);
                if ($6a5d3f6b34f82c01$var$isQueryResponseWithoutValue(response)) return {
                    saveQuery: false
                };
                return (0, $aJx1R.default)({}, response, {
                    sectionValue: formatFallbackValue(response.sectionValue, fallbackOptions)
                });
            }
            return {
                saveQuery: false
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            switch(activeSection.type){
                case "month":
                    {
                        const formatFallbackValue = (fallbackValue)=>(0, $26f4e5858fb820e2$export$2816862a602354ce)(utils, fallbackValue, utils.formats.month, activeSection.format);
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.month, formatFallbackValue);
                    }
                case "weekDay":
                    {
                        const formatFallbackValue = (fallbackValue, fallbackOptions)=>fallbackOptions.indexOf(fallbackValue).toString();
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.weekday, formatFallbackValue);
                    }
                case "meridiem":
                    return testQueryOnFormatAndFallbackFormat(queryValue, activeSection);
                default:
                    return {
                        saveQuery: false
                    };
            }
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery);
    };
    const applyNumericEditing = (params)=>{
        const getNewSectionValue = (queryValue, section)=>{
            const cleanQueryValue = (0, $26f4e5858fb820e2$export$7dd321105a319e8)(queryValue, localizedDigits);
            const queryValueNumber = Number(cleanQueryValue);
            const sectionBoundaries = sectionsValueBoundaries[section.type]({
                currentDate: null,
                format: section.format,
                contentType: section.contentType
            });
            if (queryValueNumber > sectionBoundaries.maximum) return {
                saveQuery: false
            };
            // If the user types `0` on a month section,
            // It is below the minimum, but we want to store the `0` in the query,
            // So that when he pressed `1`, it will store `01` and move to the next section.
            if (queryValueNumber < sectionBoundaries.minimum) return {
                saveQuery: true
            };
            const shouldGoToNextSection = queryValueNumber * 10 > sectionBoundaries.maximum || cleanQueryValue.length === sectionBoundaries.maximum.toString().length;
            const newSectionValue = (0, $26f4e5858fb820e2$export$ef88db4bceade9fd)(utils, queryValueNumber, sectionBoundaries, localizedDigits, section);
            return {
                sectionValue: newSectionValue,
                shouldGoToNextSection: shouldGoToNextSection
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            if (activeSection.contentType === "digit" || activeSection.contentType === "digit-with-letter") return getNewSectionValue(queryValue, activeSection);
            // When editing a letter-format month and the user presses a digit,
            // We can support the numeric editing by using the digit-format month and re-formatting the result.
            if (activeSection.type === "month") {
                const hasLeadingZerosInFormat = (0, $26f4e5858fb820e2$export$78b5830e2dd2de49)(utils, timezone, "digit", "month", "MM");
                const response = getNewSectionValue(queryValue, {
                    type: activeSection.type,
                    format: "MM",
                    hasLeadingZerosInFormat: hasLeadingZerosInFormat,
                    hasLeadingZerosInInput: true,
                    contentType: "digit",
                    maxLength: 2
                });
                if ($6a5d3f6b34f82c01$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $26f4e5858fb820e2$export$2816862a602354ce)(utils, response.sectionValue, "MM", activeSection.format);
                return (0, $aJx1R.default)({}, response, {
                    sectionValue: formattedValue
                });
            }
            // When editing a letter-format weekDay and the user presses a digit,
            // We can support the numeric editing by returning the nth day in the week day array.
            if (activeSection.type === "weekDay") {
                const response = getNewSectionValue(queryValue, activeSection);
                if ($6a5d3f6b34f82c01$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $26f4e5858fb820e2$export$c65c7173f879039f)(utils, timezone, activeSection.format)[Number(response.sectionValue) - 1];
                return (0, $aJx1R.default)({}, response, {
                    sectionValue: formattedValue
                });
            }
            return {
                saveQuery: false
            };
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery, (queryValue)=>(0, $26f4e5858fb820e2$export$c28be6c4c9d8f124)(queryValue, localizedDigits));
    };
    const applyCharacterEditing = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((params)=>{
        const activeSection = sections[params.sectionIndex];
        const isNumericEditing = (0, $26f4e5858fb820e2$export$c28be6c4c9d8f124)(params.keyPressed, localizedDigits);
        const response = isNumericEditing ? applyNumericEditing((0, $aJx1R.default)({}, params, {
            keyPressed: (0, $26f4e5858fb820e2$export$80dbbc19eba82070)(params.keyPressed, localizedDigits)
        })) : applyLetterEditing(params);
        if (response == null) {
            setTempAndroidValueStr(null);
            return;
        }
        updateSectionValue({
            activeSection: activeSection,
            newSectionValue: response.sectionValue,
            shouldGoToNextSection: response.shouldGoToNextSection
        });
    });
    return {
        applyCharacterEditing: applyCharacterEditing,
        resetCharacterQuery: resetQuery
    };
};



var $exYeM = parcelRequire("exYeM");







const $d28682e990fa9f1f$export$3b5f62b9baf9717e = (params)=>{
    const { internalProps: { disabled: disabled, readOnly: readOnly = false }, forwardedProps: { sectionListRef: inSectionListRef, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onInput: onInput, onPaste: onPaste, focused: focusedProp, autoFocus: autoFocus = false }, fieldValueManager: fieldValueManager, applyCharacterEditing: applyCharacterEditing, resetCharacterQuery: resetCharacterQuery, setSelectedSections: setSelectedSections, parsedSelectedSections: parsedSelectedSections, state: state, clearActiveSection: clearActiveSection, clearValue: clearValue, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr, sectionOrder: sectionOrder, areAllSectionsEmpty: areAllSectionsEmpty, sectionsValueBoundaries: sectionsValueBoundaries } = params;
    const sectionListRef = $exYeM.useRef(null);
    const handleSectionListRef = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(inSectionListRef, sectionListRef);
    const localeText = (0, $58b82a9afc388fa3$export$24fdeaa0f591a73e)();
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const id = (0, $43c7ad0c22f8e14a$export$2e2bcd8739ae039)();
    const [focused, setFocused] = $exYeM.useState(false);
    const interactions = $exYeM.useMemo(()=>({
            syncSelectionToDOM: ()=>{
                if (!sectionListRef.current) return;
                const selection = document.getSelection();
                if (!selection) return;
                if (parsedSelectedSections == null) {
                    // If the selection contains an element inside the field, we reset it.
                    if (selection.rangeCount > 0 && sectionListRef.current.getRoot().contains(selection.getRangeAt(0).startContainer)) selection.removeAllRanges();
                    if (focused) sectionListRef.current.getRoot().blur();
                    return;
                }
                // On multi input range pickers we want to update selection range only for the active input
                if (!sectionListRef.current.getRoot().contains((0, $b335fe84785961a2$export$cd4e5573fbe2b576)(document))) return;
                const range = new window.Range();
                let target;
                if (parsedSelectedSections === "all") target = sectionListRef.current.getRoot();
                else {
                    const section = state.sections[parsedSelectedSections];
                    if (section.type === "empty") target = sectionListRef.current.getSectionContainer(parsedSelectedSections);
                    else target = sectionListRef.current.getSectionContent(parsedSelectedSections);
                }
                range.selectNodeContents(target);
                target.focus();
                selection.removeAllRanges();
                selection.addRange(range);
            },
            getActiveSectionIndexFromDOM: ()=>{
                const activeElement = (0, $b335fe84785961a2$export$cd4e5573fbe2b576)(document);
                if (!activeElement || !sectionListRef.current || !sectionListRef.current.getRoot().contains(activeElement)) return null;
                return sectionListRef.current.getSectionIndexFromDOMElement(activeElement);
            },
            focusField: (newSelectedSections = 0)=>{
                if (!sectionListRef.current) return;
                const newParsedSelectedSections = (0, $26f4e5858fb820e2$export$b31f27a6e35a0b27)(newSelectedSections, state.sections);
                setFocused(true);
                sectionListRef.current.getSectionContent(newParsedSelectedSections).focus();
            },
            setSelectedSections: (newSelectedSections)=>{
                if (!sectionListRef.current) return;
                const newParsedSelectedSections = (0, $26f4e5858fb820e2$export$b31f27a6e35a0b27)(newSelectedSections, state.sections);
                const newActiveSectionIndex = newParsedSelectedSections === "all" ? 0 : newParsedSelectedSections;
                setFocused(newActiveSectionIndex !== null);
                setSelectedSections(newSelectedSections);
            },
            isFieldFocused: ()=>{
                const activeElement = (0, $b335fe84785961a2$export$cd4e5573fbe2b576)(document);
                return !!sectionListRef.current && sectionListRef.current.getRoot().contains(activeElement);
            }
        }), [
        parsedSelectedSections,
        setSelectedSections,
        state.sections,
        focused
    ]);
    /**
   * If a section content has been updated with a value we don't want to keep,
   * Then we need to imperatively revert it (we can't let React do it because the value did not change in his internal representation).
   */ const revertDOMSectionChange = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((sectionIndex)=>{
        if (!sectionListRef.current) return;
        const section = state.sections[sectionIndex];
        sectionListRef.current.getSectionContent(sectionIndex).innerHTML = section.value || section.placeholder;
        interactions.syncSelectionToDOM();
    });
    const handleContainerClick = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event, ...args)=>{
        // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
        // We avoid this by checking if the call of `handleContainerClick` is actually intended, or a side effect.
        if (event.isDefaultPrevented() || !sectionListRef.current) return;
        setFocused(true);
        onClick?.(event, ...args);
        if (parsedSelectedSections === "all") setTimeout(()=>{
            const cursorPosition = document.getSelection().getRangeAt(0).startOffset;
            if (cursorPosition === 0) {
                setSelectedSections(sectionOrder.startIndex);
                return;
            }
            let sectionIndex = 0;
            let cursorOnStartOfSection = 0;
            while(cursorOnStartOfSection < cursorPosition && sectionIndex < state.sections.length){
                const section = state.sections[sectionIndex];
                sectionIndex += 1;
                cursorOnStartOfSection += `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`.length;
            }
            setSelectedSections(sectionIndex - 1);
        });
        else if (!focused) {
            setFocused(true);
            setSelectedSections(sectionOrder.startIndex);
        } else {
            const hasClickedOnASection = sectionListRef.current.getRoot().contains(event.target);
            if (!hasClickedOnASection) setSelectedSections(sectionOrder.startIndex);
        }
    });
    const handleContainerInput = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event)=>{
        onInput?.(event);
        if (!sectionListRef.current || parsedSelectedSections !== "all") return;
        const target = event.target;
        const keyPressed = target.textContent ?? "";
        sectionListRef.current.getRoot().innerHTML = state.sections.map((section)=>`${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`).join("");
        interactions.syncSelectionToDOM();
        if (keyPressed.length === 0 || keyPressed.charCodeAt(0) === 10) {
            resetCharacterQuery();
            clearValue();
            setSelectedSections("all");
        } else if (keyPressed.length > 1) updateValueFromValueStr(keyPressed);
        else applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: 0
        });
    });
    const handleContainerPaste = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event)=>{
        onPaste?.(event);
        if (readOnly || parsedSelectedSections !== "all") {
            event.preventDefault();
            return;
        }
        const pastedValue = event.clipboardData.getData("text");
        event.preventDefault();
        resetCharacterQuery();
        updateValueFromValueStr(pastedValue);
    });
    const handleContainerFocus = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((...args)=>{
        onFocus?.(...args);
        if (focused || !sectionListRef.current) return;
        setFocused(true);
        const isFocusInsideASection = sectionListRef.current.getSectionIndexFromDOMElement((0, $b335fe84785961a2$export$cd4e5573fbe2b576)(document)) != null;
        if (!isFocusInsideASection) setSelectedSections(sectionOrder.startIndex);
    });
    const handleContainerBlur = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((...args)=>{
        onBlur?.(...args);
        setTimeout(()=>{
            if (!sectionListRef.current) return;
            const activeElement = (0, $b335fe84785961a2$export$cd4e5573fbe2b576)(document);
            const shouldBlur = !sectionListRef.current.getRoot().contains(activeElement);
            if (shouldBlur) {
                setFocused(false);
                setSelectedSections(null);
            }
        });
    });
    const getInputContainerClickHandler = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((sectionIndex)=>(event)=>{
            // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
            // We avoid this by checking if the call to this function is actually intended, or a side effect.
            if (event.isDefaultPrevented() || readOnly) return;
            setSelectedSections(sectionIndex);
        });
    const handleInputContentMouseUp = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event)=>{
        // Without this, the browser will remove the selected when clicking inside an already-selected section.
        event.preventDefault();
    });
    const getInputContentFocusHandler = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((sectionIndex)=>()=>{
            if (readOnly) return;
            setSelectedSections(sectionIndex);
        });
    const handleInputContentPaste = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event)=>{
        // prevent default to avoid the input `onInput` handler being called
        event.preventDefault();
        if (readOnly || typeof parsedSelectedSections !== "number") return;
        const activeSection = state.sections[parsedSelectedSections];
        const pastedValue = event.clipboardData.getData("text");
        const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
        const digitsOnly = /^[0-9]+$/.test(pastedValue);
        const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
        const isValidPastedValue = activeSection.contentType === "letter" && lettersOnly || activeSection.contentType === "digit" && digitsOnly || activeSection.contentType === "digit-with-letter" && digitsAndLetterOnly;
        if (isValidPastedValue) {
            resetCharacterQuery();
            updateSectionValue({
                activeSection: activeSection,
                newSectionValue: pastedValue,
                shouldGoToNextSection: true
            });
        } else if (!lettersOnly && !digitsOnly) {
            resetCharacterQuery();
            updateValueFromValueStr(pastedValue);
        }
    });
    const handleInputContentDragOver = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event)=>{
        event.preventDefault();
        event.dataTransfer.dropEffect = "none";
    });
    const handleInputContentInput = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event)=>{
        if (!sectionListRef.current) return;
        const target = event.target;
        const keyPressed = target.textContent ?? "";
        const sectionIndex = sectionListRef.current.getSectionIndexFromDOMElement(target);
        const section = state.sections[sectionIndex];
        if (readOnly || !sectionListRef.current) {
            revertDOMSectionChange(sectionIndex);
            return;
        }
        if (keyPressed.length === 0) {
            if (section.value === "") {
                revertDOMSectionChange(sectionIndex);
                return;
            }
            resetCharacterQuery();
            clearActiveSection();
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: sectionIndex
        });
        // The DOM value needs to remain the one React is expecting.
        revertDOMSectionChange(sectionIndex);
    });
    (0, $c4c3f9798cb7fddc$export$2e2bcd8739ae039)(()=>{
        if (!focused || !sectionListRef.current) return;
        if (parsedSelectedSections === "all") sectionListRef.current.getRoot().focus();
        else if (typeof parsedSelectedSections === "number") {
            const domElement = sectionListRef.current.getSectionContent(parsedSelectedSections);
            if (domElement) domElement.focus();
        }
    }, [
        parsedSelectedSections,
        focused
    ]);
    const sectionBoundaries = $exYeM.useMemo(()=>{
        return state.sections.reduce((acc, next)=>{
            acc[next.type] = sectionsValueBoundaries[next.type]({
                currentDate: null,
                contentType: next.contentType,
                format: next.format
            });
            return acc;
        }, {});
    }, [
        sectionsValueBoundaries,
        state.sections
    ]);
    const isContainerEditable = parsedSelectedSections === "all";
    const elements = $exYeM.useMemo(()=>{
        return state.sections.map((section, index)=>{
            const isEditable = !isContainerEditable && !disabled && !readOnly;
            return {
                container: {
                    "data-sectionindex": index,
                    onClick: getInputContainerClickHandler(index)
                },
                content: {
                    tabIndex: isContainerEditable || index > 0 ? -1 : 0,
                    contentEditable: !isContainerEditable && !disabled && !readOnly,
                    role: "spinbutton",
                    id: `${id}-${section.type}`,
                    "aria-labelledby": `${id}-${section.type}`,
                    "aria-readonly": readOnly,
                    "aria-valuenow": (0, $26f4e5858fb820e2$export$b46fd324c5adcf31)(section, utils),
                    "aria-valuemin": sectionBoundaries[section.type].minimum,
                    "aria-valuemax": sectionBoundaries[section.type].maximum,
                    "aria-valuetext": section.value ? (0, $26f4e5858fb820e2$export$b5e30842500b6cab)(section, utils) : localeText.empty,
                    "aria-label": localeText[section.type],
                    "aria-disabled": disabled,
                    spellCheck: isEditable ? false : undefined,
                    autoCapitalize: isEditable ? "off" : undefined,
                    autoCorrect: isEditable ? "off" : undefined,
                    [parseInt($exYeM.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: isEditable ? "next" : undefined,
                    children: section.value || section.placeholder,
                    onInput: handleInputContentInput,
                    onPaste: handleInputContentPaste,
                    onFocus: getInputContentFocusHandler(index),
                    onDragOver: handleInputContentDragOver,
                    onMouseUp: handleInputContentMouseUp,
                    inputMode: section.contentType === "letter" ? "text" : "numeric"
                },
                before: {
                    children: section.startSeparator
                },
                after: {
                    children: section.endSeparator
                }
            };
        });
    }, [
        state.sections,
        getInputContentFocusHandler,
        handleInputContentPaste,
        handleInputContentDragOver,
        handleInputContentInput,
        getInputContainerClickHandler,
        handleInputContentMouseUp,
        disabled,
        readOnly,
        isContainerEditable,
        localeText,
        utils,
        sectionBoundaries,
        id
    ]);
    const handleValueStrChange = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event)=>{
        updateValueFromValueStr(event.target.value);
    });
    const valueStr = $exYeM.useMemo(()=>areAllSectionsEmpty ? "" : fieldValueManager.getV7HiddenInputValueFromSections(state.sections), [
        areAllSectionsEmpty,
        state.sections,
        fieldValueManager
    ]);
    $exYeM.useEffect(()=>{
        if (sectionListRef.current == null) throw new Error([
            "MUI X: The `sectionListRef` prop has not been initialized by `PickersSectionList`",
            "You probably tried to pass a component to the `textField` slot that contains an `<input />` element instead of a `PickersSectionList`.",
            "",
            "If you want to keep using an `<input />` HTML element for the editing, please remove the `enableAccessibleFieldDOMStructure` prop from your picker or field component:",
            "",
            "<DatePicker slots={{ textField: MyCustomTextField }} />",
            "",
            "Learn more about the field accessible DOM structure on the MUI documentation: https://mui.com/x/react-date-pickers/fields/#fields-to-edit-a-single-element"
        ].join("\n"));
        if (autoFocus && sectionListRef.current) sectionListRef.current.getSectionContent(sectionOrder.startIndex).focus();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        interactions: interactions,
        returnedValue: {
            autoFocus: // Forwarded
            autoFocus,
            readOnly: readOnly,
            focused: focusedProp ?? focused,
            sectionListRef: handleSectionListRef,
            onBlur: handleContainerBlur,
            onClick: handleContainerClick,
            onFocus: handleContainerFocus,
            onInput: handleContainerInput,
            onPaste: handleContainerPaste,
            // Additional
            enableAccessibleFieldDOMStructure: true,
            elements: elements,
            // TODO v7: Try to set to undefined when there is a section selected.
            tabIndex: parsedSelectedSections === 0 ? -1 : 0,
            contentEditable: isContainerEditable,
            value: valueStr,
            onChange: handleValueStrChange,
            areAllSectionsEmpty: areAllSectionsEmpty
        }
    };
};



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");





const $7c6e90f9115dbbc9$var$cleanString = (dirtyString)=>dirtyString.replace(/[\u2066\u2067\u2068\u2069]/g, "");
const $7c6e90f9115dbbc9$export$8bb5d1c9951d10ca = (sections, localizedDigits, isRTL)=>{
    let position = 0;
    let positionInInput = isRTL ? 1 : 0;
    const newSections = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const renderedValue = (0, $26f4e5858fb820e2$export$85daa91f6c6e875f)(section, isRTL ? "input-rtl" : "input-ltr", localizedDigits);
        const sectionStr = `${section.startSeparator}${renderedValue}${section.endSeparator}`;
        const sectionLength = $7c6e90f9115dbbc9$var$cleanString(sectionStr).length;
        const sectionLengthInInput = sectionStr.length;
        // The ...InInput values consider the unicode characters but do include them in their indexes
        const cleanedValue = $7c6e90f9115dbbc9$var$cleanString(renderedValue);
        const startInInput = positionInInput + (cleanedValue === "" ? 0 : renderedValue.indexOf(cleanedValue[0])) + section.startSeparator.length;
        const endInInput = startInInput + cleanedValue.length;
        newSections.push((0, $aJx1R.default)({}, section, {
            start: position,
            end: position + sectionLength,
            startInInput: startInInput,
            endInInput: endInInput
        }));
        position += sectionLength;
        // Move position to the end of string associated to the current section
        positionInInput += sectionLengthInInput;
    }
    return newSections;
};
const $7c6e90f9115dbbc9$export$4995d3b7b56fcd3f = (params)=>{
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === "rtl";
    const focusTimeoutRef = $exYeM.useRef();
    const { forwardedProps: { onFocus: onFocus, onClick: onClick, onPaste: onPaste, onBlur: onBlur, inputRef: inputRefProp, placeholder: inPlaceholder }, internalProps: { readOnly: readOnly = false }, parsedSelectedSections: parsedSelectedSections, activeSectionIndex: activeSectionIndex, state: state, fieldValueManager: fieldValueManager, valueManager: valueManager, applyCharacterEditing: applyCharacterEditing, resetCharacterQuery: resetCharacterQuery, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr, clearActiveSection: clearActiveSection, clearValue: clearValue, setTempAndroidValueStr: setTempAndroidValueStr, setSelectedSections: setSelectedSections, getSectionsFromValue: getSectionsFromValue, areAllSectionsEmpty: areAllSectionsEmpty, localizedDigits: localizedDigits } = params;
    const inputRef = $exYeM.useRef(null);
    const handleRef = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(inputRefProp, inputRef);
    const sections = $exYeM.useMemo(()=>$7c6e90f9115dbbc9$export$8bb5d1c9951d10ca(state.sections, localizedDigits, isRTL), [
        state.sections,
        localizedDigits,
        isRTL
    ]);
    const interactions = $exYeM.useMemo(()=>({
            syncSelectionToDOM: ()=>{
                if (!inputRef.current) return;
                if (parsedSelectedSections == null) {
                    if (inputRef.current.scrollLeft) // Ensure that input content is not marked as selected.
                    // setting selection range to 0 causes issues in Safari.
                    // https://bugs.webkit.org/show_bug.cgi?id=224425
                    inputRef.current.scrollLeft = 0;
                    return;
                }
                // On multi input range pickers we want to update selection range only for the active input
                // This helps to avoid the focus jumping on Safari https://github.com/mui/mui-x/issues/9003
                // because WebKit implements the `setSelectionRange` based on the spec: https://bugs.webkit.org/show_bug.cgi?id=224425
                if (inputRef.current !== (0, $b335fe84785961a2$export$cd4e5573fbe2b576)(document)) return;
                // Fix scroll jumping on iOS browser: https://github.com/mui/mui-x/issues/8321
                const currentScrollTop = inputRef.current.scrollTop;
                if (parsedSelectedSections === "all") inputRef.current.select();
                else {
                    const selectedSection = sections[parsedSelectedSections];
                    const selectionStart = selectedSection.type === "empty" ? selectedSection.startInInput - selectedSection.startSeparator.length : selectedSection.startInInput;
                    const selectionEnd = selectedSection.type === "empty" ? selectedSection.endInInput + selectedSection.endSeparator.length : selectedSection.endInInput;
                    if (selectionStart !== inputRef.current.selectionStart || selectionEnd !== inputRef.current.selectionEnd) {
                        if (inputRef.current === (0, $b335fe84785961a2$export$cd4e5573fbe2b576)(document)) inputRef.current.setSelectionRange(selectionStart, selectionEnd);
                    }
                }
                // Even reading this variable seems to do the trick, but also setting it just to make use of it
                inputRef.current.scrollTop = currentScrollTop;
            },
            getActiveSectionIndexFromDOM: ()=>{
                const browserStartIndex = inputRef.current.selectionStart ?? 0;
                const browserEndIndex = inputRef.current.selectionEnd ?? 0;
                const isInputReadOnly = !!inputRef.current?.readOnly;
                if (browserStartIndex === 0 && browserEndIndex === 0 || isInputReadOnly) return null;
                const nextSectionIndex = browserStartIndex <= sections[0].startInInput ? 1 // Special case if browser index is in invisible characters at the beginning.
                 : sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
                return nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
            },
            focusField: (newSelectedSection = 0)=>{
                inputRef.current?.focus();
                setSelectedSections(newSelectedSection);
            },
            setSelectedSections: (newSelectedSections)=>setSelectedSections(newSelectedSections),
            isFieldFocused: ()=>inputRef.current === (0, $b335fe84785961a2$export$cd4e5573fbe2b576)(document)
        }), [
        inputRef,
        parsedSelectedSections,
        sections,
        setSelectedSections
    ]);
    const syncSelectionFromDOM = ()=>{
        if (readOnly) {
            setSelectedSections(null);
            return;
        }
        const browserStartIndex = inputRef.current.selectionStart ?? 0;
        let nextSectionIndex;
        if (browserStartIndex <= sections[0].startInInput) // Special case if browser index is in invisible characters at the beginning
        nextSectionIndex = 1;
        else if (browserStartIndex >= sections[sections.length - 1].endInInput) // If the click is after the last character of the input, then we want to select the 1st section.
        nextSectionIndex = 1;
        else nextSectionIndex = sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
        const sectionIndex = nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
        setSelectedSections(sectionIndex);
    };
    const handleInputFocus = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((...args)=>{
        onFocus?.(...args);
        // The ref is guaranteed to be resolved at this point.
        const input = inputRef.current;
        clearTimeout(focusTimeoutRef.current);
        focusTimeoutRef.current = setTimeout(()=>{
            // The ref changed, the component got remounted, the focus event is no longer relevant.
            if (!input || input !== inputRef.current) return;
            if (activeSectionIndex != null || readOnly) return;
            if (// avoid selecting all sections when focusing empty field without value
            input.value.length && Number(input.selectionEnd) - Number(input.selectionStart) === input.value.length) setSelectedSections("all");
            else syncSelectionFromDOM();
        });
    });
    const handleInputClick = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event, ...args)=>{
        // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
        // We avoid this by checking if the call of `handleInputClick` is actually intended, or a side effect.
        if (event.isDefaultPrevented()) return;
        onClick?.(event, ...args);
        syncSelectionFromDOM();
    });
    const handleInputPaste = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event)=>{
        onPaste?.(event);
        // prevent default to avoid the input `onChange` handler being called
        event.preventDefault();
        if (readOnly) return;
        const pastedValue = event.clipboardData.getData("text");
        if (typeof parsedSelectedSections === "number") {
            const activeSection = state.sections[parsedSelectedSections];
            const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
            const digitsOnly = /^[0-9]+$/.test(pastedValue);
            const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
            const isValidPastedValue = activeSection.contentType === "letter" && lettersOnly || activeSection.contentType === "digit" && digitsOnly || activeSection.contentType === "digit-with-letter" && digitsAndLetterOnly;
            if (isValidPastedValue) {
                resetCharacterQuery();
                updateSectionValue({
                    activeSection: activeSection,
                    newSectionValue: pastedValue,
                    shouldGoToNextSection: true
                });
                return;
            }
            if (lettersOnly || digitsOnly) // The pasted value corresponds to a single section, but not the expected type,
            // skip the modification
            return;
        }
        resetCharacterQuery();
        updateValueFromValueStr(pastedValue);
    });
    const handleContainerBlur = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((...args)=>{
        onBlur?.(...args);
        setSelectedSections(null);
    });
    const handleInputChange = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event)=>{
        if (readOnly) return;
        const targetValue = event.target.value;
        if (targetValue === "") {
            resetCharacterQuery();
            clearValue();
            return;
        }
        const eventData = event.nativeEvent.data;
        // Calling `.fill(04/11/2022)` in playwright will trigger a change event with the requested content to insert in `event.nativeEvent.data`
        // usual changes have only the currently typed character in the `event.nativeEvent.data`
        const shouldUseEventData = eventData && eventData.length > 1;
        const valueStr = shouldUseEventData ? eventData : targetValue;
        const cleanValueStr = $7c6e90f9115dbbc9$var$cleanString(valueStr);
        // If no section is selected or eventData should be used, we just try to parse the new value
        // This line is mostly triggered by imperative code / application tests.
        if (activeSectionIndex == null || shouldUseEventData) {
            updateValueFromValueStr(shouldUseEventData ? eventData : cleanValueStr);
            return;
        }
        let keyPressed;
        if (parsedSelectedSections === "all" && cleanValueStr.length === 1) keyPressed = cleanValueStr;
        else {
            const prevValueStr = $7c6e90f9115dbbc9$var$cleanString(fieldValueManager.getV6InputValueFromSections(sections, localizedDigits, isRTL));
            let startOfDiffIndex = -1;
            let endOfDiffIndex = -1;
            for(let i = 0; i < prevValueStr.length; i += 1){
                if (startOfDiffIndex === -1 && prevValueStr[i] !== cleanValueStr[i]) startOfDiffIndex = i;
                if (endOfDiffIndex === -1 && prevValueStr[prevValueStr.length - i - 1] !== cleanValueStr[cleanValueStr.length - i - 1]) endOfDiffIndex = i;
            }
            const activeSection = sections[activeSectionIndex];
            const hasDiffOutsideOfActiveSection = startOfDiffIndex < activeSection.start || prevValueStr.length - endOfDiffIndex - 1 > activeSection.end;
            if (hasDiffOutsideOfActiveSection) // TODO: Support if the new date is valid
            return;
            // The active section being selected, the browser has replaced its value with the key pressed by the user.
            const activeSectionEndRelativeToNewValue = cleanValueStr.length - prevValueStr.length + activeSection.end - $7c6e90f9115dbbc9$var$cleanString(activeSection.endSeparator || "").length;
            keyPressed = cleanValueStr.slice(activeSection.start + $7c6e90f9115dbbc9$var$cleanString(activeSection.startSeparator || "").length, activeSectionEndRelativeToNewValue);
        }
        if (keyPressed.length === 0) {
            if ((0, $26f4e5858fb820e2$export$a11b0059900ceec8)()) setTempAndroidValueStr(valueStr);
            else {
                resetCharacterQuery();
                clearActiveSection();
            }
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: activeSectionIndex
        });
    });
    const placeholder = $exYeM.useMemo(()=>{
        if (inPlaceholder) return inPlaceholder;
        return fieldValueManager.getV6InputValueFromSections(getSectionsFromValue(valueManager.emptyValue), localizedDigits, isRTL);
    }, [
        inPlaceholder,
        fieldValueManager,
        getSectionsFromValue,
        valueManager.emptyValue,
        localizedDigits,
        isRTL
    ]);
    const valueStr = $exYeM.useMemo(()=>state.tempValueStrAndroid ?? fieldValueManager.getV6InputValueFromSections(state.sections, localizedDigits, isRTL), [
        state.sections,
        fieldValueManager,
        state.tempValueStrAndroid,
        localizedDigits,
        isRTL
    ]);
    $exYeM.useEffect(()=>{
        // Select all the sections when focused on mount (`autoFocus = true` on the input)
        if (inputRef.current && inputRef.current === (0, $b335fe84785961a2$export$cd4e5573fbe2b576)(document)) setSelectedSections("all");
        return ()=>{
            clearTimeout(focusTimeoutRef.current);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const inputMode = $exYeM.useMemo(()=>{
        if (activeSectionIndex == null) return "text";
        if (state.sections[activeSectionIndex].contentType === "letter") return "text";
        return "numeric";
    }, [
        activeSectionIndex,
        state.sections
    ]);
    const inputHasFocus = inputRef.current && inputRef.current === (0, $b335fe84785961a2$export$cd4e5573fbe2b576)(document);
    const shouldShowPlaceholder = !inputHasFocus && areAllSectionsEmpty;
    return {
        interactions: interactions,
        returnedValue: {
            readOnly: // Forwarded
            readOnly,
            onBlur: handleContainerBlur,
            onClick: handleInputClick,
            onFocus: handleInputFocus,
            onPaste: handleInputPaste,
            inputRef: handleRef,
            // Additional
            enableAccessibleFieldDOMStructure: false,
            placeholder: placeholder,
            inputMode: inputMode,
            autoComplete: "off",
            value: shouldShowPlaceholder ? "" : valueStr,
            onChange: handleInputChange
        }
    };
};


const $7690ea9019a90c7e$export$294aa081a6c6f55d = (params)=>{
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const { internalProps: internalProps, internalProps: { unstableFieldRef: unstableFieldRef, minutesStep: minutesStep, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure = false, disabled: disabled = false, readOnly: readOnly = false }, forwardedProps: { onKeyDown: onKeyDown, error: error, clearable: clearable, onClear: onClear }, fieldValueManager: fieldValueManager, valueManager: valueManager, validator: validator } = params;
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === "rtl";
    const stateResponse = (0, $ce9cefd79a6b3e38$export$4e8d6353e50062e7)(params);
    const { state: state, activeSectionIndex: activeSectionIndex, parsedSelectedSections: parsedSelectedSections, setSelectedSections: setSelectedSections, clearValue: clearValue, clearActiveSection: clearActiveSection, updateSectionValue: updateSectionValue, setTempAndroidValueStr: setTempAndroidValueStr, sectionsValueBoundaries: sectionsValueBoundaries, localizedDigits: localizedDigits, timezone: timezone } = stateResponse;
    const characterEditingResponse = (0, $6a5d3f6b34f82c01$export$66d00048b8bb82f6)({
        sections: state.sections,
        updateSectionValue: updateSectionValue,
        sectionsValueBoundaries: sectionsValueBoundaries,
        localizedDigits: localizedDigits,
        setTempAndroidValueStr: setTempAndroidValueStr,
        timezone: timezone
    });
    const { resetCharacterQuery: resetCharacterQuery } = characterEditingResponse;
    const areAllSectionsEmpty = valueManager.areValuesEqual(utils, state.value, valueManager.emptyValue);
    const useFieldTextField = enableAccessibleFieldDOMStructure ? (0, $d28682e990fa9f1f$export$3b5f62b9baf9717e) : (0, $7c6e90f9115dbbc9$export$4995d3b7b56fcd3f);
    const sectionOrder = $exYeM.useMemo(()=>(0, $26f4e5858fb820e2$export$7725fd6fe0a2aadf)(state.sections, isRTL && !enableAccessibleFieldDOMStructure), [
        state.sections,
        isRTL,
        enableAccessibleFieldDOMStructure
    ]);
    const { returnedValue: returnedValue, interactions: interactions } = useFieldTextField((0, $aJx1R.default)({}, params, stateResponse, characterEditingResponse, {
        areAllSectionsEmpty: areAllSectionsEmpty,
        sectionOrder: sectionOrder
    }));
    const handleContainerKeyDown = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event)=>{
        onKeyDown?.(event);
        // eslint-disable-next-line default-case
        switch(true){
            // Select all
            case (event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "a" && !event.shiftKey && !event.altKey:
                // prevent default to make sure that the next line "select all" while updating
                // the internal state at the same time.
                event.preventDefault();
                setSelectedSections("all");
                break;
            case event.key === "Enter":
                event.preventDefault();
                break;
            // Move selection to next section
            case event.key === "ArrowRight":
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.startIndex);
                else if (parsedSelectedSections === "all") setSelectedSections(sectionOrder.endIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].rightIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Move selection to previous section
            case event.key === "ArrowLeft":
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.endIndex);
                else if (parsedSelectedSections === "all") setSelectedSections(sectionOrder.startIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].leftIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Reset the value of the selected section
            case event.key === "Delete":
                event.preventDefault();
                if (readOnly) break;
                if (parsedSelectedSections == null || parsedSelectedSections === "all") clearValue();
                else clearActiveSection();
                resetCharacterQuery();
                break;
            // Increment / decrement the selected section value
            case [
                "ArrowUp",
                "ArrowDown",
                "Home",
                "End",
                "PageUp",
                "PageDown"
            ].includes(event.key):
                {
                    event.preventDefault();
                    if (readOnly || activeSectionIndex == null) break;
                    const activeSection = state.sections[activeSectionIndex];
                    const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
                    const newSectionValue = (0, $26f4e5858fb820e2$export$5ed0f22513e58fe3)(utils, timezone, activeSection, event.key, sectionsValueBoundaries, localizedDigits, activeDateManager.date, {
                        minutesStep: minutesStep
                    });
                    updateSectionValue({
                        activeSection: activeSection,
                        newSectionValue: newSectionValue,
                        shouldGoToNextSection: false
                    });
                    break;
                }
        }
    });
    (0, $c4c3f9798cb7fddc$export$2e2bcd8739ae039)(()=>{
        interactions.syncSelectionToDOM();
    });
    const validationError = (0, $c99b8fb6de4f8de2$export$87fe492f99f25a20)((0, $aJx1R.default)({}, internalProps, {
        value: state.value,
        timezone: timezone
    }), validator, valueManager.isSameError, valueManager.defaultErrorState);
    const inputError = $exYeM.useMemo(()=>{
        // only override when `error` is undefined.
        // in case of multi input fields, the `error` value is provided externally and will always be defined.
        if (error !== undefined) return error;
        return valueManager.hasError(validationError);
    }, [
        valueManager,
        validationError,
        error
    ]);
    $exYeM.useEffect(()=>{
        if (!inputError && activeSectionIndex == null) resetCharacterQuery();
    }, [
        state.referenceValue,
        activeSectionIndex,
        inputError
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // If `tempValueStrAndroid` is still defined for some section when running `useEffect`,
    // Then `onChange` has only been called once, which means the user pressed `Backspace` to reset the section.
    // This causes a small flickering on Android,
    // But we can't use `useEnhancedEffect` which is always called before the second `onChange` call and then would cause false positives.
    $exYeM.useEffect(()=>{
        if (state.tempValueStrAndroid != null && activeSectionIndex != null) {
            resetCharacterQuery();
            clearActiveSection();
        }
    }, [
        state.sections
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    $exYeM.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: interactions.getActiveSectionIndexFromDOM,
            setSelectedSections: interactions.setSelectedSections,
            focusField: interactions.focusField,
            isFieldFocused: interactions.isFieldFocused
        }));
    const handleClearValue = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event, ...args)=>{
        event.preventDefault();
        onClear?.(event, ...args);
        clearValue();
        if (!interactions.isFieldFocused()) // setSelectedSections is called internally
        interactions.focusField(0);
        else setSelectedSections(sectionOrder.startIndex);
    });
    const commonForwardedProps = {
        onKeyDown: handleContainerKeyDown,
        onClear: handleClearValue,
        error: inputError,
        clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled)
    };
    const commonAdditionalProps = {
        disabled: disabled,
        readOnly: readOnly
    };
    return (0, $aJx1R.default)({}, params.forwardedProps, commonForwardedProps, commonAdditionalProps, returnedValue);
};




var $aJx1R = parcelRequire("aJx1R");
const $b4c6ee3828695005$export$430d9fc64cf058d6 = [
    "disablePast",
    "disableFuture",
    "minDate",
    "maxDate",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear"
];
const $b4c6ee3828695005$export$fd5e0f8b4115a8c7 = [
    "disablePast",
    "disableFuture",
    "minTime",
    "maxTime",
    "shouldDisableTime",
    "minutesStep",
    "ampm",
    "disableIgnoringDatePartForTimeValidation"
];
const $b4c6ee3828695005$export$1df62d3ba2121371 = [
    "minDateTime",
    "maxDateTime"
];
const $b4c6ee3828695005$var$VALIDATION_PROP_NAMES = [
    ...$b4c6ee3828695005$export$430d9fc64cf058d6,
    ...$b4c6ee3828695005$export$fd5e0f8b4115a8c7,
    ...$b4c6ee3828695005$export$1df62d3ba2121371
];
const $b4c6ee3828695005$export$5890f750904acddb = (props)=>$b4c6ee3828695005$var$VALIDATION_PROP_NAMES.reduce((extractedProps, propName)=>{
        if (props.hasOwnProperty(propName)) extractedProps[propName] = props[propName];
        return extractedProps;
    }, {});


const $853af466154b1a1f$var$SHARED_FIELD_INTERNAL_PROP_NAMES = [
    "value",
    "defaultValue",
    "referenceDate",
    "format",
    "formatDensity",
    "onChange",
    "timezone",
    "onError",
    "shouldRespectLeadingZeros",
    "selectedSections",
    "onSelectedSectionsChange",
    "unstableFieldRef",
    "enableAccessibleFieldDOMStructure",
    "disabled",
    "readOnly",
    "dateSeparator"
];
const $853af466154b1a1f$export$cdde224d2939fd84 = (props, valueType)=>{
    const forwardedProps = (0, $aJx1R.default)({}, props);
    const internalProps = {};
    const extractProp = (propName)=>{
        if (forwardedProps.hasOwnProperty(propName)) {
            // @ts-ignore
            internalProps[propName] = forwardedProps[propName];
            delete forwardedProps[propName];
        }
    };
    $853af466154b1a1f$var$SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(extractProp);
    if (valueType === "date") (0, $b4c6ee3828695005$export$430d9fc64cf058d6).forEach(extractProp);
    else if (valueType === "time") (0, $b4c6ee3828695005$export$fd5e0f8b4115a8c7).forEach(extractProp);
    else if (valueType === "date-time") {
        (0, $b4c6ee3828695005$export$430d9fc64cf058d6).forEach(extractProp);
        (0, $b4c6ee3828695005$export$fd5e0f8b4115a8c7).forEach(extractProp);
        (0, $b4c6ee3828695005$export$1df62d3ba2121371).forEach(extractProp);
    }
    return {
        forwardedProps: forwardedProps,
        internalProps: internalProps
    };
};



var $aJx1R = parcelRequire("aJx1R");


const $88316b2eb4f82d5f$export$c04f15aa68a6177a = (props)=>{
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const defaultDates = (0, $58b82a9afc388fa3$export$7c38da3a2e90fa83)();
    return (0, $aJx1R.default)({}, props, {
        disablePast: props.disablePast ?? false,
        disableFuture: props.disableFuture ?? false,
        format: props.format ?? utils.formats.keyboardDate,
        minDate: (0, $8c165bb53d94cf45$export$eb73579ccade48fd)(utils, props.minDate, defaultDates.minDate),
        maxDate: (0, $8c165bb53d94cf45$export$eb73579ccade48fd)(utils, props.maxDate, defaultDates.maxDate)
    });
};
const $88316b2eb4f82d5f$export$e740b972b66c04cd = (props)=>{
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const ampm = props.ampm ?? utils.is12HourCycleInCurrentLocale();
    const defaultFormat = ampm ? utils.formats.fullTime12h : utils.formats.fullTime24h;
    return (0, $aJx1R.default)({}, props, {
        disablePast: props.disablePast ?? false,
        disableFuture: props.disableFuture ?? false,
        format: props.format ?? defaultFormat
    });
};
const $88316b2eb4f82d5f$export$ae5b8d06aeae1db3 = (props)=>{
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const defaultDates = (0, $58b82a9afc388fa3$export$7c38da3a2e90fa83)();
    const ampm = props.ampm ?? utils.is12HourCycleInCurrentLocale();
    const defaultFormat = ampm ? utils.formats.keyboardDateTime12h : utils.formats.keyboardDateTime24h;
    return (0, $aJx1R.default)({}, props, {
        disablePast: props.disablePast ?? false,
        disableFuture: props.disableFuture ?? false,
        format: props.format ?? defaultFormat,
        disableIgnoringDatePartForTimeValidation: Boolean(props.minDateTime || props.maxDateTime),
        minDate: (0, $8c165bb53d94cf45$export$eb73579ccade48fd)(utils, props.minDateTime ?? props.minDate, defaultDates.minDate),
        maxDate: (0, $8c165bb53d94cf45$export$eb73579ccade48fd)(utils, props.maxDateTime ?? props.maxDate, defaultDates.maxDate),
        minTime: props.minDateTime ?? props.minTime,
        maxTime: props.maxDateTime ?? props.maxTime
    });
};


const $475e7df80a8efff3$export$5591b0b878c1a989 = (inProps)=>{
    const props = (0, $88316b2eb4f82d5f$export$c04f15aa68a6177a)(inProps);
    const { forwardedProps: forwardedProps, internalProps: internalProps } = (0, $853af466154b1a1f$export$cdde224d2939fd84)(props, "date");
    return (0, $7690ea9019a90c7e$export$294aa081a6c6f55d)({
        forwardedProps: forwardedProps,
        internalProps: internalProps,
        valueManager: (0, $efb258a9c0464e3f$export$2764b246aa3b75ba),
        fieldValueManager: (0, $efb258a9c0464e3f$export$b602c94f557316b4),
        validator: (0, $b5cc8935c82cecb2$export$ffb3d0046ef3a2),
        valueType: "date"
    });
};



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");






var $aSiaI = parcelRequire("aSiaI");
const $2933e748b8e88f5f$var$_excluded = [
    "clearable",
    "onClear",
    "InputProps",
    "sx",
    "slots",
    "slotProps"
], $2933e748b8e88f5f$var$_excluded2 = [
    "ownerState"
];
const $2933e748b8e88f5f$export$db9644cdb7e3d432 = (props)=>{
    const localeText = (0, $58b82a9afc388fa3$export$24fdeaa0f591a73e)();
    const { clearable: clearable, onClear: onClear, InputProps: InputProps, sx: sx, slots: slots, slotProps: slotProps } = props, other = (0, $3L80X.default)(props, $2933e748b8e88f5f$var$_excluded);
    const IconButton = slots?.clearButton ?? (0, $96b952e1d26b1f04$export$2e2bcd8739ae039);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: IconButton,
        externalSlotProps: slotProps?.clearButton,
        ownerState: {},
        className: "clearButton",
        additionalProps: {
            title: localeText.fieldClearLabel
        }
    }), iconButtonProps = (0, $3L80X.default)(_useSlotProps, $2933e748b8e88f5f$var$_excluded2);
    const EndClearIcon = slots?.clearIcon ?? (0, $ea58bbb735a57109$export$cefbac224a47f32);
    const endClearIconProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: EndClearIcon,
        externalSlotProps: slotProps?.clearIcon,
        ownerState: {}
    });
    return (0, $aJx1R.default)({}, other, {
        InputProps: (0, $aJx1R.default)({}, InputProps, {
            endAdornment: /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
                children: [
                    clearable && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $60f459c5525ea035$export$2e2bcd8739ae039), {
                        position: "end",
                        sx: {
                            marginRight: InputProps?.endAdornment ? -1 : -1.5
                        },
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)(IconButton, (0, $aJx1R.default)({}, iconButtonProps, {
                            onClick: onClear,
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)(EndClearIcon, (0, $aJx1R.default)({
                                fontSize: "small"
                            }, endClearIconProps))
                        }))
                    }),
                    InputProps?.endAdornment
                ]
            })
        }),
        sx: [
            {
                "& .clearButton": {
                    opacity: 1
                },
                "@media (pointer: fine)": {
                    "& .clearButton": {
                        opacity: 0
                    },
                    "&:hover, &:focus-within": {
                        ".clearButton": {
                            opacity: 1
                        }
                    }
                }
            },
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    });
};



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");



var $2f0D3 = parcelRequire("2f0D3");





var $dC5O8 = parcelRequire("dC5O8");

var $kY7HX = parcelRequire("kY7HX");
function $c569e7fd83cf2823$export$d99678ed7aad1677(slot) {
    return (0, $dC5O8.default)("MuiPickersTextField", slot);
}
const $c569e7fd83cf2823$export$284739773a7ae972 = (0, $kY7HX.default)("MuiPickersTextField", [
    "root",
    "focused",
    "disabled",
    "error",
    "required"
]);



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");



var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");


var $2f0D3 = parcelRequire("2f0D3");

var $aJx1R = parcelRequire("aJx1R");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");

var $dC5O8 = parcelRequire("dC5O8");

var $kY7HX = parcelRequire("kY7HX");
function $a0de6be6925ba956$export$3821cb625ac26962(slot) {
    return (0, $dC5O8.default)("MuiPickersInputBase", slot);
}
const $a0de6be6925ba956$export$f20b5ba262568322 = (0, $kY7HX.default)("MuiPickersInputBase", [
    "root",
    "focused",
    "disabled",
    "error",
    "notchedOutline",
    "sectionContent",
    "sectionBefore",
    "sectionAfter",
    "adornedStart",
    "adornedEnd",
    "input"
]);


function $b171ee876bda6a36$export$c0dd951a3959ac7f(slot) {
    return (0, $dC5O8.default)("MuiPickersOutlinedInput", slot);
}
const $b171ee876bda6a36$export$a7da60486bcc91df = (0, $aJx1R.default)({}, (0, $a0de6be6925ba956$export$f20b5ba262568322), (0, $kY7HX.default)("MuiPickersOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");
parcelRequire("exYeM");

var $jawKn = parcelRequire("jawKn");

var $aSiaI = parcelRequire("aSiaI");
const $08db97d4993932dc$var$_excluded = [
    "children",
    "className",
    "label",
    "notched",
    "shrink"
];
const $08db97d4993932dc$var$OutlineRoot = (0, $jawKn.default)("fieldset", {
    name: "MuiPickersOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        textAlign: "left",
        position: "absolute",
        bottom: 0,
        right: 0,
        top: -5,
        left: 0,
        margin: 0,
        padding: "0 8px",
        pointerEvents: "none",
        borderRadius: "inherit",
        borderStyle: "solid",
        borderWidth: 1,
        overflow: "hidden",
        minWidth: "0%",
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $08db97d4993932dc$var$OutlineLabel = (0, $jawKn.default)("span")(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: "inherit"
    }));
const $08db97d4993932dc$var$OutlineLegend = (0, $jawKn.default)("legend")(({ theme: theme })=>({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden",
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: {
                    withLabel: false
                },
                style: {
                    padding: 0,
                    lineHeight: "11px",
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create("width", {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    withLabel: true
                },
                style: {
                    display: "block",
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: "0.75em",
                    visibility: "hidden",
                    maxWidth: 0.01,
                    transition: theme.transitions.create("max-width", {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: "nowrap",
                    "& > span": {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: "inline-block",
                        opacity: 0,
                        visibility: "visible"
                    }
                }
            },
            {
                props: {
                    withLabel: true,
                    notched: true
                },
                style: {
                    maxWidth: "100%",
                    transition: theme.transitions.create("max-width", {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    }));
function $08db97d4993932dc$export$2e2bcd8739ae039(props) {
    const { className: className, label: label } = props, other = (0, $3L80X.default)(props, $08db97d4993932dc$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $aJx1R.default)({}, props, {
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)($08db97d4993932dc$var$OutlineRoot, (0, $aJx1R.default)({
        "aria-hidden": true,
        className: className
    }, other, {
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($08db97d4993932dc$var$OutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $aSiaI.jsx)($08db97d4993932dc$var$OutlineLabel, {
                children: label
            }) : /*#__PURE__*/ // notranslate needed while Google Translate will not fix zero-width space issue
            (0, $aSiaI.jsx)($08db97d4993932dc$var$OutlineLabel, {
                className: "notranslate",
                children: "\u200B"
            })
        })
    }));
}



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");



var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");



var $2f0D3 = parcelRequire("2f0D3");

var $jesoU = parcelRequire("jesoU");

const $a8f86375c8e8d1e6$var$visuallyHidden = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px"
};
var $a8f86375c8e8d1e6$export$2e2bcd8739ae039 = $a8f86375c8e8d1e6$var$visuallyHidden;




var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");



var $2f0D3 = parcelRequire("2f0D3");


var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $dC5O8 = parcelRequire("dC5O8");

var $kY7HX = parcelRequire("kY7HX");
function $fe656695d7e0a3fb$export$f891a98d04ce6513(slot) {
    return (0, $dC5O8.default)("MuiPickersSectionList", slot);
}
const $fe656695d7e0a3fb$export$8455939b33d2ee90 = (0, $kY7HX.default)("MuiPickersSectionList", [
    "root",
    "section",
    "sectionContent"
]);



var $aSiaI = parcelRequire("aSiaI");
const $69fad12f028d20d7$var$_excluded = [
    "slots",
    "slotProps",
    "elements",
    "sectionListRef"
];
const $69fad12f028d20d7$export$4ee86b293725486c = (0, $jawKn.default)("div", {
    name: "MuiPickersSectionList",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    direction: "ltr /*! @noflip */",
    outline: "none"
});
const $69fad12f028d20d7$export$30e7187e386feb4f = (0, $jawKn.default)("span", {
    name: "MuiPickersSectionList",
    slot: "Section",
    overridesResolver: (props, styles)=>styles.section
})({});
const $69fad12f028d20d7$export$c403b59604f63120 = (0, $jawKn.default)("span", {
    name: "MuiPickersSectionList",
    slot: "SectionSeparator",
    overridesResolver: (props, styles)=>styles.sectionSeparator
})({
    whiteSpace: "pre"
});
const $69fad12f028d20d7$export$1f2c61561fe3d6 = (0, $jawKn.default)("span", {
    name: "MuiPickersSectionList",
    slot: "SectionContent",
    overridesResolver: (props, styles)=>styles.sectionContent
})({
    outline: "none"
});
const $69fad12f028d20d7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        section: [
            "section"
        ],
        sectionContent: [
            "sectionContent"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $fe656695d7e0a3fb$export$f891a98d04ce6513), classes);
};
/**
 * Demos:
 *
 * - [Custom field](https://mui.com/x/react-date-pickers/custom-field/)
 *
 * API:
 *
 * - [PickersSectionList API](https://mui.com/x/api/date-pickers/pickers-section-list/)
 */ function $69fad12f028d20d7$var$PickersSection(props) {
    const { slots: slots, slotProps: slotProps, element: element, classes: classes } = props;
    const Section = slots?.section ?? $69fad12f028d20d7$export$30e7187e386feb4f;
    const sectionProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: Section,
        externalSlotProps: slotProps?.section,
        externalForwardedProps: element.container,
        className: classes.section,
        ownerState: {}
    });
    const SectionContent = slots?.sectionContent ?? $69fad12f028d20d7$export$1f2c61561fe3d6;
    const sectionContentProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: SectionContent,
        externalSlotProps: slotProps?.sectionContent,
        externalForwardedProps: element.content,
        additionalProps: {
            suppressContentEditableWarning: true
        },
        className: classes.sectionContent,
        ownerState: {}
    });
    const SectionSeparator = slots?.sectionSeparator ?? $69fad12f028d20d7$export$c403b59604f63120;
    const sectionSeparatorBeforeProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.before,
        ownerState: {
            position: "before"
        }
    });
    const sectionSeparatorAfterProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.after,
        ownerState: {
            position: "after"
        }
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)(Section, (0, $aJx1R.default)({}, sectionProps, {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)(SectionSeparator, (0, $aJx1R.default)({}, sectionSeparatorBeforeProps)),
            /*#__PURE__*/ (0, $aSiaI.jsx)(SectionContent, (0, $aJx1R.default)({}, sectionContentProps)),
            /*#__PURE__*/ (0, $aSiaI.jsx)(SectionSeparator, (0, $aJx1R.default)({}, sectionSeparatorAfterProps))
        ]
    }));
}
const $69fad12f028d20d7$export$847fd4b97819700 = /*#__PURE__*/ $exYeM.forwardRef(function PickersSectionList(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiPickersSectionList"
    });
    const { slots: slots, slotProps: slotProps, elements: elements, sectionListRef: sectionListRef } = props, other = (0, $3L80X.default)(props, $69fad12f028d20d7$var$_excluded);
    const classes = $69fad12f028d20d7$var$useUtilityClasses(props);
    const rootRef = $exYeM.useRef(null);
    const handleRootRef = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(ref, rootRef);
    const getRoot = (methodName)=>{
        if (!rootRef.current) throw new Error(`MUI X: Cannot call sectionListRef.${methodName} before the mount of the component.`);
        return rootRef.current;
    };
    $exYeM.useImperativeHandle(sectionListRef, ()=>({
            getRoot () {
                return getRoot("getRoot");
            },
            getSectionContainer (index) {
                const root = getRoot("getSectionContainer");
                return root.querySelector(`.${(0, $fe656695d7e0a3fb$export$8455939b33d2ee90).section}[data-sectionindex="${index}"]`);
            },
            getSectionContent (index) {
                const root = getRoot("getSectionContent");
                return root.querySelector(`.${(0, $fe656695d7e0a3fb$export$8455939b33d2ee90).section}[data-sectionindex="${index}"] .${(0, $fe656695d7e0a3fb$export$8455939b33d2ee90).sectionContent}`);
            },
            getSectionIndexFromDOMElement (element) {
                const root = getRoot("getSectionIndexFromDOMElement");
                if (element == null || !root.contains(element)) return null;
                let sectionContainer = null;
                if (element.classList.contains((0, $fe656695d7e0a3fb$export$8455939b33d2ee90).section)) sectionContainer = element;
                else if (element.classList.contains((0, $fe656695d7e0a3fb$export$8455939b33d2ee90).sectionContent)) sectionContainer = element.parentElement;
                if (sectionContainer == null) return null;
                return Number(sectionContainer.dataset.sectionindex);
            }
        }));
    const Root = slots?.root ?? $69fad12f028d20d7$export$4ee86b293725486c;
    const rootProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: Root,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: handleRootRef,
            suppressContentEditableWarning: true
        },
        className: classes.root,
        ownerState: {}
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)(Root, (0, $aJx1R.default)({}, rootProps, {
        children: rootProps.contentEditable ? elements.map(({ content: content, before: before, after: after })=>`${before.children}${content.children}${after.children}`).join("") : /*#__PURE__*/ (0, $aSiaI.jsx)($exYeM.Fragment, {
            children: elements.map((element, elementIndex)=>/*#__PURE__*/ (0, $aSiaI.jsx)($69fad12f028d20d7$var$PickersSection, {
                    slots: slots,
                    slotProps: slotProps,
                    element: element,
                    classes: classes
                }, elementIndex))
        })
    }));
});



var $aSiaI = parcelRequire("aSiaI");
const $2335ee16bae5d31a$var$_excluded = [
    "elements",
    "areAllSectionsEmpty",
    "defaultValue",
    "label",
    "value",
    "onChange",
    "id",
    "autoFocus",
    "endAdornment",
    "startAdornment",
    "renderSuffix",
    "slots",
    "slotProps",
    "contentEditable",
    "tabIndex",
    "onInput",
    "onPaste",
    "onKeyDown",
    "fullWidth",
    "name",
    "readOnly",
    "inputProps",
    "inputRef",
    "sectionListRef"
];
const $2335ee16bae5d31a$var$round = (value)=>Math.round(value * 1e5) / 1e5;
const $2335ee16bae5d31a$export$ddc18880178d980e = (0, $jawKn.default)("div", {
    name: "MuiPickersInputBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>(0, $aJx1R.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        cursor: "text",
        padding: 0,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        letterSpacing: `${$2335ee16bae5d31a$var$round(0.15 / 16)}em`,
        variants: [
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: "100%"
                }
            }
        ]
    }));
const $2335ee16bae5d31a$export$52f3fbbfe9321824 = (0, $jawKn.default)((0, $69fad12f028d20d7$export$4ee86b293725486c), {
    name: "MuiPickersInputBase",
    slot: "SectionsContainer",
    overridesResolver: (props, styles)=>styles.sectionsContainer
})(({ theme: theme })=>(0, $aJx1R.default)({
        padding: "4px 0 5px",
        fontFamily: theme.typography.fontFamily,
        fontSize: "inherit",
        lineHeight: "1.4375em",
        // 23px
        flexGrow: 1,
        outline: "none",
        display: "flex",
        flexWrap: "nowrap",
        overflow: "hidden",
        letterSpacing: "inherit",
        // Baseline behavior
        width: "182px"
    }, theme.direction === "rtl" && {
        textAlign: "right /*! @noflip */"
    }, {
        variants: [
            {
                props: {
                    size: "small"
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: {
                    adornedStart: false,
                    focused: false,
                    filled: false
                },
                style: {
                    color: "currentColor",
                    opacity: 0
                }
            },
            {
                // Can't use the object notation because label can be null or undefined
                props: ({ adornedStart: adornedStart, focused: focused, filled: filled, label: label })=>!adornedStart && !focused && !filled && label == null,
                style: theme.vars ? {
                    opacity: theme.vars.opacity.inputPlaceholder
                } : {
                    opacity: theme.palette.mode === "light" ? 0.42 : 0.5
                }
            }
        ]
    }));
const $2335ee16bae5d31a$var$PickersInputBaseSection = (0, $jawKn.default)((0, $69fad12f028d20d7$export$30e7187e386feb4f), {
    name: "MuiPickersInputBase",
    slot: "Section",
    overridesResolver: (props, styles)=>styles.section
})(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: "inherit",
        letterSpacing: "inherit",
        lineHeight: "1.4375em",
        // 23px
        display: "flex"
    }));
const $2335ee16bae5d31a$var$PickersInputBaseSectionContent = (0, $jawKn.default)((0, $69fad12f028d20d7$export$1f2c61561fe3d6), {
    name: "MuiPickersInputBase",
    slot: "SectionContent",
    overridesResolver: (props, styles)=>styles.content
})(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        lineHeight: "1.4375em",
        // 23px
        letterSpacing: "inherit",
        width: "fit-content",
        outline: "none"
    }));
const $2335ee16bae5d31a$var$PickersInputBaseSectionSeparator = (0, $jawKn.default)((0, $69fad12f028d20d7$export$c403b59604f63120), {
    name: "MuiPickersInputBase",
    slot: "Separator",
    overridesResolver: (props, styles)=>styles.separator
})(()=>({
        whiteSpace: "pre",
        letterSpacing: "inherit"
    }));
const $2335ee16bae5d31a$var$PickersInputBaseInput = (0, $jawKn.default)("input", {
    name: "MuiPickersInputBase",
    slot: "Input",
    overridesResolver: (props, styles)=>styles.hiddenInput
})((0, $aJx1R.default)({}, (0, $a8f86375c8e8d1e6$export$2e2bcd8739ae039)));
const $2335ee16bae5d31a$var$useUtilityClasses = (ownerState)=>{
    const { focused: focused, disabled: disabled, error: error, classes: classes, fullWidth: fullWidth, readOnly: readOnly, color: color, size: size, endAdornment: endAdornment, startAdornment: startAdornment } = ownerState;
    const slots = {
        root: [
            "root",
            focused && !disabled && "focused",
            disabled && "disabled",
            readOnly && "readOnly",
            error && "error",
            fullWidth && "fullWidth",
            `color${(0, $jesoU.default)(color)}`,
            size === "small" && "inputSizeSmall",
            Boolean(startAdornment) && "adornedStart",
            Boolean(endAdornment) && "adornedEnd"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ],
        sectionsContainer: [
            "sectionsContainer"
        ],
        sectionContent: [
            "sectionContent"
        ],
        sectionBefore: [
            "sectionBefore"
        ],
        sectionAfter: [
            "sectionAfter"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $a0de6be6925ba956$export$3821cb625ac26962), classes);
};
/**
 * @ignore - internal component.
 */ const $2335ee16bae5d31a$export$ff827734ba831074 = /*#__PURE__*/ $exYeM.forwardRef(function PickersInputBase(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiPickersInputBase"
    });
    const { elements: elements, areAllSectionsEmpty: areAllSectionsEmpty, value: value, onChange: onChange, id: id, endAdornment: endAdornment, startAdornment: startAdornment, renderSuffix: renderSuffix, slots: slots, slotProps: slotProps, contentEditable: contentEditable, tabIndex: tabIndex, onInput: onInput, onPaste: onPaste, onKeyDown: onKeyDown, name: name, readOnly: readOnly, inputProps: inputProps, inputRef: inputRef, sectionListRef: sectionListRef } = props, other = (0, $3L80X.default)(props, $2335ee16bae5d31a$var$_excluded);
    const rootRef = $exYeM.useRef(null);
    const handleRootRef = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(ref, rootRef);
    const handleInputRef = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(inputProps?.ref, inputRef);
    const muiFormControl = (0, $cfe831b0e6d29047$export$2e2bcd8739ae039)();
    if (!muiFormControl) throw new Error("MUI X: PickersInputBase should always be used inside a PickersTextField component");
    const handleInputFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (muiFormControl.disabled) {
            event.stopPropagation();
            return;
        }
        muiFormControl.onFocus?.(event);
    };
    $exYeM.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    $exYeM.useEffect(()=>{
        if (!muiFormControl) return;
        if (areAllSectionsEmpty) muiFormControl.onEmpty();
        else muiFormControl.onFilled();
    }, [
        muiFormControl,
        areAllSectionsEmpty
    ]);
    const ownerState = (0, $aJx1R.default)({}, props, muiFormControl);
    const classes = $2335ee16bae5d31a$var$useUtilityClasses(ownerState);
    const InputRoot = slots?.root || $2335ee16bae5d31a$export$ddc18880178d980e;
    const inputRootProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: InputRoot,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            "aria-invalid": muiFormControl.error,
            ref: handleRootRef
        },
        className: classes.root,
        ownerState: ownerState
    });
    const InputSectionsContainer = slots?.input || $2335ee16bae5d31a$export$52f3fbbfe9321824;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)(InputRoot, (0, $aJx1R.default)({}, inputRootProps, {
        children: [
            startAdornment,
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $69fad12f028d20d7$export$847fd4b97819700), {
                sectionListRef: sectionListRef,
                elements: elements,
                contentEditable: contentEditable,
                tabIndex: tabIndex,
                className: classes.sectionsContainer,
                onFocus: handleInputFocus,
                onBlur: muiFormControl.onBlur,
                onInput: onInput,
                onPaste: onPaste,
                onKeyDown: onKeyDown,
                slots: {
                    root: InputSectionsContainer,
                    section: $2335ee16bae5d31a$var$PickersInputBaseSection,
                    sectionContent: $2335ee16bae5d31a$var$PickersInputBaseSectionContent,
                    sectionSeparator: $2335ee16bae5d31a$var$PickersInputBaseSectionSeparator
                },
                slotProps: {
                    root: {
                        ownerState: ownerState
                    },
                    sectionContent: {
                        className: (0, $a0de6be6925ba956$export$f20b5ba262568322).sectionContent
                    },
                    sectionSeparator: ({ position: position })=>({
                            className: position === "before" ? (0, $a0de6be6925ba956$export$f20b5ba262568322).sectionBefore : (0, $a0de6be6925ba956$export$f20b5ba262568322).sectionAfter
                        })
                }
            }),
            endAdornment,
            renderSuffix ? renderSuffix((0, $aJx1R.default)({}, muiFormControl)) : null,
            /*#__PURE__*/ (0, $aSiaI.jsx)($2335ee16bae5d31a$var$PickersInputBaseInput, (0, $aJx1R.default)({
                name: name,
                className: classes.input,
                value: value,
                onChange: onChange,
                id: id,
                "aria-hidden": "true",
                tabIndex: -1,
                readOnly: readOnly,
                required: muiFormControl.required,
                disabled: muiFormControl.disabled
            }, inputProps, {
                ref: handleInputRef
            }))
        ]
    }));
});




var $aSiaI = parcelRequire("aSiaI");
const $4cf85e5b1f33ce5b$var$_excluded = [
    "label",
    "autoFocus",
    "ownerState",
    "notched"
];
const $4cf85e5b1f33ce5b$var$PickersOutlinedInputRoot = (0, $jawKn.default)((0, $2335ee16bae5d31a$export$ddc18880178d980e), {
    name: "MuiPickersOutlinedInput",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        padding: "0 14px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $b171ee876bda6a36$export$a7da60486bcc91df).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $b171ee876bda6a36$export$a7da60486bcc91df).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $b171ee876bda6a36$export$a7da60486bcc91df).focused} .${(0, $b171ee876bda6a36$export$a7da60486bcc91df).notchedOutline}`]: {
            borderStyle: "solid",
            borderWidth: 2
        },
        [`&.${(0, $b171ee876bda6a36$export$a7da60486bcc91df).disabled}`]: {
            [`& .${(0, $b171ee876bda6a36$export$a7da60486bcc91df).notchedOutline}`]: {
                borderColor: (theme.vars || theme).palette.action.disabled
            },
            "*": {
                color: (theme.vars || theme).palette.action.disabled
            }
        },
        [`&.${(0, $b171ee876bda6a36$export$a7da60486bcc91df).error} .${(0, $b171ee876bda6a36$export$a7da60486bcc91df).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        variants: Object.keys((theme.vars ?? theme).palette)// @ts-ignore
        .filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                props: {
                    color: color
                },
                style: {
                    [`&.${(0, $b171ee876bda6a36$export$a7da60486bcc91df).focused}:not(.${(0, $b171ee876bda6a36$export$a7da60486bcc91df).error}) .${(0, $b171ee876bda6a36$export$a7da60486bcc91df).notchedOutline}`]: {
                        // @ts-ignore
                        borderColor: (theme.vars || theme).palette[color].main
                    }
                }
            }))
    };
});
const $4cf85e5b1f33ce5b$var$PickersOutlinedInputSectionsContainer = (0, $jawKn.default)((0, $2335ee16bae5d31a$export$52f3fbbfe9321824), {
    name: "MuiPickersOutlinedInput",
    slot: "SectionsContainer",
    overridesResolver: (props, styles)=>styles.sectionsContainer
})({
    padding: "16.5px 0",
    variants: [
        {
            props: {
                size: "small"
            },
            style: {
                padding: "8.5px 0"
            }
        }
    ]
});
const $4cf85e5b1f33ce5b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $2f0D3.default)(slots, (0, $b171ee876bda6a36$export$c0dd951a3959ac7f), classes);
    return (0, $aJx1R.default)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $4cf85e5b1f33ce5b$export$44d4d00edb0c710f = /*#__PURE__*/ $exYeM.forwardRef(function PickersOutlinedInput(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiPickersOutlinedInput"
    });
    const { label: label, ownerState: ownerStateProp, notched: notched } = props, other = (0, $3L80X.default)(props, $4cf85e5b1f33ce5b$var$_excluded);
    const muiFormControl = (0, $cfe831b0e6d29047$export$2e2bcd8739ae039)();
    const ownerState = (0, $aJx1R.default)({}, props, ownerStateProp, muiFormControl, {
        color: muiFormControl?.color || "primary"
    });
    const classes = $4cf85e5b1f33ce5b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2335ee16bae5d31a$export$ff827734ba831074), (0, $aJx1R.default)({
        slots: {
            root: $4cf85e5b1f33ce5b$var$PickersOutlinedInputRoot,
            input: $4cf85e5b1f33ce5b$var$PickersOutlinedInputSectionsContainer
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $08db97d4993932dc$export$2e2bcd8739ae039), {
                shrink: Boolean(notched || state.adornedStart || state.focused || state.filled),
                notched: Boolean(notched || state.adornedStart || state.focused || state.filled),
                className: classes.notchedOutline,
                label: label != null && label !== "" && muiFormControl?.required ? /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        "*"
                    ]
                }) : label,
                ownerState: ownerState
            })
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
$4cf85e5b1f33ce5b$export$44d4d00edb0c710f.muiName = "Input";



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");



var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");



var $2f0D3 = parcelRequire("2f0D3");

var $aJx1R = parcelRequire("aJx1R");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");

function $0e498473c10cd0e8$export$6cb188bdacb35d0e(slot) {
    return (0, $dC5O8.default)("MuiPickersFilledInput", slot);
}
const $0e498473c10cd0e8$export$3964d3188824d772 = (0, $aJx1R.default)({}, (0, $a0de6be6925ba956$export$f20b5ba262568322), (0, $kY7HX.default)("MuiPickersFilledInput", [
    "root",
    "underline",
    "input"
]));





var $aSiaI = parcelRequire("aSiaI");
const $af20a6dfaa29dfdd$var$_excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "ownerState"
];
const $af20a6dfaa29dfdd$var$PickersFilledInputRoot = (0, $jawKn.default)((0, $2335ee16bae5d31a$export$ddc18880178d980e), {
    name: "MuiPickersFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $b601c8f3fa89e057$export$3ba67b570e26eea0)(prop) && prop !== "disableUnderline"
})(({ theme: theme })=>{
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return {
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $0e498473c10cd0e8$export$3964d3188824d772).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $0e498473c10cd0e8$export$3964d3188824d772).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette)// @ts-ignore
            .filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        "&::after": {
                            // @ts-ignore
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: {
                    disableUnderline: false
                },
                style: {
                    "&::after": {
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: "absolute",
                        right: 0,
                        transform: "scaleX(0)",
                        transition: theme.transitions.create("transform", {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: "none" // Transparent to the hover style.
                    },
                    [`&.${(0, $0e498473c10cd0e8$export$3964d3188824d772).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: "scaleX(1) translateX(0)"
                    },
                    [`&.${(0, $0e498473c10cd0e8$export$3964d3188824d772).error}`]: {
                        "&:before, &:after": {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    "&::before": {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: "absolute",
                        right: 0,
                        transition: theme.transitions.create("border-bottom-color", {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: "none" // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $0e498473c10cd0e8$export$3964d3188824d772).disabled}, .${(0, $0e498473c10cd0e8$export$3964d3188824d772).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $0e498473c10cd0e8$export$3964d3188824d772).disabled}:before`]: {
                        borderBottomStyle: "dotted"
                    }
                }
            },
            {
                props: ({ startAdornment: startAdornment })=>!!startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ endAdornment: endAdornment })=>!!endAdornment,
                style: {
                    paddingRight: 12
                }
            }
        ]
    };
});
const $af20a6dfaa29dfdd$var$PickersFilledSectionsContainer = (0, $jawKn.default)((0, $2335ee16bae5d31a$export$52f3fbbfe9321824), {
    name: "MuiPickersFilledInput",
    slot: "sectionsContainer",
    overridesResolver: (props, styles)=>styles.sectionsContainer
})({
    paddingTop: 25,
    paddingRight: 12,
    paddingBottom: 8,
    paddingLeft: 12,
    variants: [
        {
            props: {
                size: "small"
            },
            style: {
                paddingTop: 21,
                paddingBottom: 4
            }
        },
        {
            props: ({ startAdornment: startAdornment })=>!!startAdornment,
            style: {
                paddingLeft: 0
            }
        },
        {
            props: ({ endAdornment: endAdornment })=>!!endAdornment,
            style: {
                paddingRight: 0
            }
        },
        {
            props: {
                hiddenLabel: true
            },
            style: {
                paddingTop: 16,
                paddingBottom: 17
            }
        },
        {
            props: {
                hiddenLabel: true,
                size: "small"
            },
            style: {
                paddingTop: 8,
                paddingBottom: 9
            }
        }
    ]
});
const $af20a6dfaa29dfdd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $2f0D3.default)(slots, (0, $0e498473c10cd0e8$export$6cb188bdacb35d0e), classes);
    return (0, $aJx1R.default)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $af20a6dfaa29dfdd$export$8cc8c624890b5045 = /*#__PURE__*/ $exYeM.forwardRef(function PickersFilledInput(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiPickersFilledInput"
    });
    const { label: label, disableUnderline: disableUnderline = false, ownerState: ownerStateProp } = props, other = (0, $3L80X.default)(props, $af20a6dfaa29dfdd$var$_excluded);
    const muiFormControl = (0, $cfe831b0e6d29047$export$2e2bcd8739ae039)();
    const ownerState = (0, $aJx1R.default)({}, props, ownerStateProp, muiFormControl, {
        color: muiFormControl?.color || "primary"
    });
    const classes = $af20a6dfaa29dfdd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2335ee16bae5d31a$export$ff827734ba831074), (0, $aJx1R.default)({
        slots: {
            root: $af20a6dfaa29dfdd$var$PickersFilledInputRoot,
            input: $af20a6dfaa29dfdd$var$PickersFilledSectionsContainer
        },
        slotProps: {
            root: {
                disableUnderline: disableUnderline
            }
        }
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
$af20a6dfaa29dfdd$export$8cc8c624890b5045.muiName = "Input";



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");



var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");


var $2f0D3 = parcelRequire("2f0D3");

var $aJx1R = parcelRequire("aJx1R");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");

function $cd7b8b8c2f5b6ea7$export$defbb17803ff7cff(slot) {
    return (0, $dC5O8.default)("MuiPickersFilledInput", slot);
}
const $cd7b8b8c2f5b6ea7$export$f5c5ba079c8bb9dd = (0, $aJx1R.default)({}, (0, $a0de6be6925ba956$export$f20b5ba262568322), (0, $kY7HX.default)("MuiPickersInput", [
    "root",
    "input"
]));





var $aSiaI = parcelRequire("aSiaI");
const $c385500cfa852f7f$var$_excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "ownerState"
];
const $c385500cfa852f7f$var$PickersInputRoot = (0, $jawKn.default)((0, $2335ee16bae5d31a$export$ddc18880178d980e), {
    name: "MuiPickersInput",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        "label + &": {
            marginTop: 16
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette)// @ts-ignore
            .filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        "&::after": {
                            // @ts-ignore
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                })),
            {
                props: {
                    disableUnderline: false
                },
                style: {
                    "&::after": {
                        background: "red",
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: "absolute",
                        right: 0,
                        transform: "scaleX(0)",
                        transition: theme.transitions.create("transform", {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: "none" // Transparent to the hover style.
                    },
                    [`&.${(0, $cd7b8b8c2f5b6ea7$export$f5c5ba079c8bb9dd).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: "scaleX(1) translateX(0)"
                    },
                    [`&.${(0, $cd7b8b8c2f5b6ea7$export$f5c5ba079c8bb9dd).error}`]: {
                        "&:before, &:after": {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    "&::before": {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: "absolute",
                        right: 0,
                        transition: theme.transitions.create("border-bottom-color", {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: "none" // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $cd7b8b8c2f5b6ea7$export$f5c5ba079c8bb9dd).disabled}, .${(0, $cd7b8b8c2f5b6ea7$export$f5c5ba079c8bb9dd).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        "@media (hover: none)": {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $cd7b8b8c2f5b6ea7$export$f5c5ba079c8bb9dd).disabled}:before`]: {
                        borderBottomStyle: "dotted"
                    }
                }
            }
        ]
    };
});
const $c385500cfa852f7f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $2f0D3.default)(slots, (0, $cd7b8b8c2f5b6ea7$export$defbb17803ff7cff), classes);
    return (0, $aJx1R.default)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $c385500cfa852f7f$export$7c4ebb2cfaf4f474 = /*#__PURE__*/ $exYeM.forwardRef(function PickersInput(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiPickersInput"
    });
    const { label: label, disableUnderline: disableUnderline = false, ownerState: ownerStateProp } = props, other = (0, $3L80X.default)(props, $c385500cfa852f7f$var$_excluded);
    const muiFormControl = (0, $cfe831b0e6d29047$export$2e2bcd8739ae039)();
    const ownerState = (0, $aJx1R.default)({}, props, ownerStateProp, muiFormControl, {
        disableUnderline: disableUnderline,
        color: muiFormControl?.color || "primary"
    });
    const classes = $c385500cfa852f7f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2335ee16bae5d31a$export$ff827734ba831074), (0, $aJx1R.default)({
        slots: {
            root: $c385500cfa852f7f$var$PickersInputRoot
        }
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
$c385500cfa852f7f$export$7c4ebb2cfaf4f474.muiName = "Input";



var $aSiaI = parcelRequire("aSiaI");
const $84f942149d3b2e85$var$_excluded = [
    "onFocus",
    "onBlur",
    "className",
    "color",
    "disabled",
    "error",
    "variant",
    "required",
    "InputProps",
    "inputProps",
    "inputRef",
    "sectionListRef",
    "elements",
    "areAllSectionsEmpty",
    "onClick",
    "onKeyDown",
    "onKeyUp",
    "onPaste",
    "onInput",
    "endAdornment",
    "startAdornment",
    "tabIndex",
    "contentEditable",
    "focused",
    "value",
    "onChange",
    "fullWidth",
    "id",
    "name",
    "helperText",
    "FormHelperTextProps",
    "label",
    "InputLabelProps"
];
const $84f942149d3b2e85$var$VARIANT_COMPONENT = {
    standard: (0, $c385500cfa852f7f$export$7c4ebb2cfaf4f474),
    filled: (0, $af20a6dfaa29dfdd$export$8cc8c624890b5045),
    outlined: (0, $4cf85e5b1f33ce5b$export$44d4d00edb0c710f)
};
const $84f942149d3b2e85$var$PickersTextFieldRoot = (0, $jawKn.default)((0, $f455042ed80bed88$export$2e2bcd8739ae039), {
    name: "MuiPickersTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $84f942149d3b2e85$var$useUtilityClasses = (ownerState)=>{
    const { focused: focused, disabled: disabled, classes: classes, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            focused && !disabled && "focused",
            disabled && "disabled",
            required && "required"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $c569e7fd83cf2823$export$d99678ed7aad1677), classes);
};
const $84f942149d3b2e85$export$b3e9b101d92e4d4d = /*#__PURE__*/ $exYeM.forwardRef(function PickersTextField(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiPickersTextField"
    });
    const { onFocus: // Props used by FormControl
    onFocus, onBlur: onBlur, className: className, color: color = "primary", disabled: disabled = false, error: error = false, variant: variant = "outlined", required: required = false, InputProps: // Props used by PickersInput
    InputProps, inputProps: inputProps, inputRef: inputRef, sectionListRef: sectionListRef, elements: elements, areAllSectionsEmpty: areAllSectionsEmpty, onClick: onClick, onKeyDown: onKeyDown, onPaste: onPaste, onInput: onInput, endAdornment: endAdornment, startAdornment: startAdornment, tabIndex: tabIndex, contentEditable: contentEditable, focused: focused, value: value, onChange: onChange, fullWidth: fullWidth, id: idProp, name: name, helperText: // Props used by FormHelperText
    helperText, FormHelperTextProps: FormHelperTextProps, label: // Props used by InputLabel
    label, InputLabelProps: InputLabelProps } = props, other = (0, $3L80X.default)(props, $84f942149d3b2e85$var$_excluded);
    const rootRef = $exYeM.useRef(null);
    const handleRootRef = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(ref, rootRef);
    const id = (0, $43c7ad0c22f8e14a$export$2e2bcd8739ae039)(idProp);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const ownerState = (0, $aJx1R.default)({}, props, {
        color: color,
        disabled: disabled,
        error: error,
        focused: focused,
        required: required,
        variant: variant
    });
    const classes = $84f942149d3b2e85$var$useUtilityClasses(ownerState);
    const PickersInputComponent = $84f942149d3b2e85$var$VARIANT_COMPONENT[variant];
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($84f942149d3b2e85$var$PickersTextFieldRoot, (0, $aJx1R.default)({
        className: (0, $4qr5a.default)(classes.root, className),
        ref: handleRootRef,
        focused: focused,
        onFocus: onFocus,
        onBlur: onBlur,
        disabled: disabled,
        variant: variant,
        error: error,
        color: color,
        fullWidth: fullWidth,
        required: required,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0f13a85ecf68fcb2$export$2e2bcd8739ae039), (0, $aJx1R.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            /*#__PURE__*/ (0, $aSiaI.jsx)(PickersInputComponent, (0, $aJx1R.default)({
                elements: elements,
                areAllSectionsEmpty: areAllSectionsEmpty,
                onClick: onClick,
                onKeyDown: onKeyDown,
                onInput: onInput,
                onPaste: onPaste,
                endAdornment: endAdornment,
                startAdornment: startAdornment,
                tabIndex: tabIndex,
                contentEditable: contentEditable,
                value: value,
                onChange: onChange,
                id: id,
                fullWidth: fullWidth,
                inputProps: inputProps,
                inputRef: inputRef,
                sectionListRef: sectionListRef,
                label: label,
                name: name,
                role: "group",
                "aria-labelledby": inputLabelId
            }, InputProps)),
            helperText && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $68258577de0527c4$export$2e2bcd8739ae039), (0, $aJx1R.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");
const $b9597e90c73e1a8f$var$_excluded = [
    "enableAccessibleFieldDOMStructure"
], $b9597e90c73e1a8f$var$_excluded2 = [
    "InputProps",
    "readOnly"
], $b9597e90c73e1a8f$var$_excluded3 = [
    "onPaste",
    "onKeyDown",
    "inputMode",
    "readOnly",
    "InputProps",
    "inputProps",
    "inputRef"
];
const $b9597e90c73e1a8f$export$20bf15d9b24b4dad = (_ref)=>{
    let { enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure } = _ref, fieldResponse = (0, $3L80X.default)(_ref, $b9597e90c73e1a8f$var$_excluded);
    if (enableAccessibleFieldDOMStructure) {
        const { InputProps: InputProps, readOnly: readOnly } = fieldResponse, other = (0, $3L80X.default)(fieldResponse, $b9597e90c73e1a8f$var$_excluded2);
        return (0, $aJx1R.default)({}, other, {
            InputProps: (0, $aJx1R.default)({}, InputProps ?? {}, {
                readOnly: readOnly
            })
        });
    }
    const { onPaste: onPaste, onKeyDown: onKeyDown, inputMode: inputMode, readOnly: readOnly, InputProps: InputProps, inputProps: inputProps, inputRef: inputRef } = fieldResponse, other = (0, $3L80X.default)(fieldResponse, $b9597e90c73e1a8f$var$_excluded3);
    return (0, $aJx1R.default)({}, other, {
        InputProps: (0, $aJx1R.default)({}, InputProps ?? {}, {
            readOnly: readOnly
        }),
        inputProps: (0, $aJx1R.default)({}, inputProps ?? {}, {
            inputMode: inputMode,
            onPaste: onPaste,
            onKeyDown: onKeyDown,
            ref: inputRef
        })
    });
};



var $aSiaI = parcelRequire("aSiaI");
const $ddb41334d53f26fc$var$_excluded = [
    "slots",
    "slotProps",
    "InputProps",
    "inputProps"
];
/**
 * Demos:
 *
 * - [DateField](http://mui.com/x/react-date-pickers/date-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [DateField API](https://mui.com/x/api/date-pickers/date-field/)
 */ const $ddb41334d53f26fc$export$d9781c7894a82487 = /*#__PURE__*/ $exYeM.forwardRef(function DateField(inProps, inRef) {
    const themeProps = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiDateField"
    });
    const { slots: slots, slotProps: slotProps, InputProps: InputProps, inputProps: inputProps } = themeProps, other = (0, $3L80X.default)(themeProps, $ddb41334d53f26fc$var$_excluded);
    const ownerState = themeProps;
    const TextField = slots?.textField ?? (inProps.enableAccessibleFieldDOMStructure ? (0, $84f942149d3b2e85$export$b3e9b101d92e4d4d) : (0, $18a733eef46a7fb6$export$2e2bcd8739ae039));
    const textFieldProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: TextField,
        externalSlotProps: slotProps?.textField,
        externalForwardedProps: other,
        additionalProps: {
            ref: inRef
        },
        ownerState: ownerState
    });
    // TODO: Remove when mui/material-ui#35088 will be merged
    textFieldProps.inputProps = (0, $aJx1R.default)({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = (0, $aJx1R.default)({}, InputProps, textFieldProps.InputProps);
    const fieldResponse = (0, $475e7df80a8efff3$export$5591b0b878c1a989)(textFieldProps);
    const convertedFieldResponse = (0, $b9597e90c73e1a8f$export$20bf15d9b24b4dad)(fieldResponse);
    const processedFieldProps = (0, $2933e748b8e88f5f$export$db9644cdb7e3d432)((0, $aJx1R.default)({}, convertedFieldResponse, {
        slots: slots,
        slotProps: slotProps
    }));
    return /*#__PURE__*/ (0, $aSiaI.jsx)(TextField, (0, $aJx1R.default)({}, processedFieldProps));
});



parcelRequire("exYeM");

var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");


var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $2f0D3 = parcelRequire("2f0D3");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");


const $1b908537a77eb3c9$export$7d1a419f34475191 = ({ shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, minDate: minDate, maxDate: maxDate, disableFuture: disableFuture, disablePast: disablePast, timezone: timezone })=>{
    const adapter = (0, $58b82a9afc388fa3$export$4b5a24245de9f7f9)();
    return $exYeM.useCallback((day)=>(0, $b5cc8935c82cecb2$export$ffb3d0046ef3a2)({
            adapter: adapter,
            value: day,
            props: {
                shouldDisableDate: shouldDisableDate,
                shouldDisableMonth: shouldDisableMonth,
                shouldDisableYear: shouldDisableYear,
                minDate: minDate,
                maxDate: maxDate,
                disableFuture: disableFuture,
                disablePast: disablePast,
                timezone: timezone
            }
        }) !== null, [
        adapter,
        shouldDisableDate,
        shouldDisableMonth,
        shouldDisableYear,
        minDate,
        maxDate,
        disableFuture,
        disablePast,
        timezone
    ]);
};





const $05f0c4504392a719$export$2aba07ea6b6cf430 = (reduceAnimations, disableSwitchToMonthOnDayFocus, utils)=>(state, action)=>{
        switch(action.type){
            case "changeMonth":
                return (0, $aJx1R.default)({}, state, {
                    slideDirection: action.direction,
                    currentMonth: action.newMonth,
                    isMonthSwitchingAnimating: !reduceAnimations
                });
            case "finishMonthSwitchingAnimation":
                return (0, $aJx1R.default)({}, state, {
                    isMonthSwitchingAnimating: false
                });
            case "changeFocusedDay":
                {
                    if (state.focusedDay != null && action.focusedDay != null && utils.isSameDay(action.focusedDay, state.focusedDay)) return state;
                    const needMonthSwitch = action.focusedDay != null && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
                    return (0, $aJx1R.default)({}, state, {
                        focusedDay: action.focusedDay,
                        isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations && !action.withoutMonthSwitchingAnimation,
                        currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
                        slideDirection: action.focusedDay != null && utils.isAfterDay(action.focusedDay, state.currentMonth) ? "left" : "right"
                    });
                }
            default:
                throw new Error("missing support");
        }
    };
const $05f0c4504392a719$export$6d095e787d2b5e1f = (params)=>{
    const { value: value, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, disableSwitchToMonthOnDayFocus: disableSwitchToMonthOnDayFocus = false, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, timezone: timezone } = params;
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const reducerFn = $exYeM.useRef($05f0c4504392a719$export$2aba07ea6b6cf430(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;
    const referenceDate = $exYeM.useMemo(()=>{
        return (0, $efb258a9c0464e3f$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            timezone: timezone,
            props: params,
            referenceDate: referenceDateProp,
            granularity: (0, $bd0cf02b8b64cf79$export$8f74e8f4ed8ae0ac).day
        });
    }, [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const [calendarState, dispatch] = $exYeM.useReducer(reducerFn, {
        isMonthSwitchingAnimating: false,
        focusedDay: referenceDate,
        currentMonth: utils.startOfMonth(referenceDate),
        slideDirection: "left"
    });
    const handleChangeMonth = $exYeM.useCallback((payload)=>{
        dispatch((0, $aJx1R.default)({
            type: "changeMonth"
        }, payload));
        if (onMonthChange) onMonthChange(payload.newMonth);
    }, [
        onMonthChange
    ]);
    const changeMonth = $exYeM.useCallback((newDate)=>{
        const newDateRequested = newDate;
        if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) return;
        handleChangeMonth({
            newMonth: utils.startOfMonth(newDateRequested),
            direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? "left" : "right"
        });
    }, [
        calendarState.currentMonth,
        handleChangeMonth,
        utils
    ]);
    const isDateDisabled = (0, $1b908537a77eb3c9$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        minDate: minDate,
        maxDate: maxDate,
        disableFuture: disableFuture,
        disablePast: disablePast,
        timezone: timezone
    });
    const onMonthSwitchingAnimationEnd = $exYeM.useCallback(()=>{
        dispatch({
            type: "finishMonthSwitchingAnimation"
        });
    }, []);
    const changeFocusedDay = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((newFocusedDate, withoutMonthSwitchingAnimation)=>{
        if (!isDateDisabled(newFocusedDate)) dispatch({
            type: "changeFocusedDay",
            focusedDay: newFocusedDate,
            withoutMonthSwitchingAnimation: withoutMonthSwitchingAnimation
        });
    });
    return {
        referenceDate: referenceDate,
        calendarState: calendarState,
        changeMonth: changeMonth,
        changeFocusedDay: changeFocusedDay,
        isDateDisabled: isDateDisabled,
        onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
        handleChangeMonth: handleChangeMonth
    };
};



parcelRequire("exYeM");

var $4qr5a = parcelRequire("4qr5a");



var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $2f0D3 = parcelRequire("2f0D3");

var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
const $bc00be7734c54886$export$5b0bb0174eb448ca = (slot)=>(0, $dC5O8.default)("MuiPickersFadeTransitionGroup", slot);
const $bc00be7734c54886$export$1461f245817ac559 = (0, $kY7HX.default)("MuiPickersFadeTransitionGroup", [
    "root"
]);



var $aSiaI = parcelRequire("aSiaI");
const $80babe87e415f49f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $bc00be7734c54886$export$5b0bb0174eb448ca), classes);
};
const $80babe87e415f49f$var$PickersFadeTransitionGroupRoot = (0, $jawKn.default)((0, $151b5217152ca66c$export$2e2bcd8739ae039), {
    name: "MuiPickersFadeTransitionGroup",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({
    display: "block",
    position: "relative"
});
function $80babe87e415f49f$export$5262185daf493fee(inProps) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiPickersFadeTransitionGroup"
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props;
    const classes = $80babe87e415f49f$var$useUtilityClasses(props);
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    if (reduceAnimations) return children;
    return /*#__PURE__*/ (0, $aSiaI.jsx)($80babe87e415f49f$var$PickersFadeTransitionGroupRoot, {
        className: (0, $4qr5a.default)(classes.root, className),
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b8c58e7700914c7f$export$2e2bcd8739ae039), {
            appear: false,
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: {
                appear: theme.transitions.duration.enteringScreen,
                enter: theme.transitions.duration.enteringScreen,
                exit: 0
            },
            children: children
        }, transKey)
    });
}



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");




var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $2f0D3 = parcelRequire("2f0D3");

var $4qr5a = parcelRequire("4qr5a");

var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");


var $2f0D3 = parcelRequire("2f0D3");

var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");



var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
function $af784bf02ac62d80$export$4b25deb0350d3e53(slot) {
    return (0, $dC5O8.default)("MuiPickersDay", slot);
}
const $af784bf02ac62d80$export$68b221ad3c35e288 = (0, $kY7HX.default)("MuiPickersDay", [
    "root",
    "dayWithMargin",
    "dayOutsideMonth",
    "hiddenDaySpacingFiller",
    "today",
    "selected",
    "disabled"
]);



var $aSiaI = parcelRequire("aSiaI");
const $d6736e3c7da5c109$var$_excluded = [
    "autoFocus",
    "className",
    "day",
    "disabled",
    "disableHighlightToday",
    "disableMargin",
    "hidden",
    "isAnimating",
    "onClick",
    "onDaySelect",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "onMouseDown",
    "onMouseEnter",
    "outsideCurrentMonth",
    "selected",
    "showDaysOutsideCurrentMonth",
    "children",
    "today",
    "isFirstVisibleCell",
    "isLastVisibleCell"
];
const $d6736e3c7da5c109$var$useUtilityClasses = (ownerState)=>{
    const { selected: selected, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, today: today, disabled: disabled, outsideCurrentMonth: outsideCurrentMonth, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, classes: classes } = ownerState;
    const isHiddenDaySpacingFiller = outsideCurrentMonth && !showDaysOutsideCurrentMonth;
    const slots = {
        root: [
            "root",
            selected && !isHiddenDaySpacingFiller && "selected",
            disabled && "disabled",
            !disableMargin && "dayWithMargin",
            !disableHighlightToday && today && "today",
            outsideCurrentMonth && showDaysOutsideCurrentMonth && "dayOutsideMonth",
            isHiddenDaySpacingFiller && "hiddenDaySpacingFiller"
        ],
        hiddenDaySpacingFiller: [
            "hiddenDaySpacingFiller"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $af784bf02ac62d80$export$4b25deb0350d3e53), classes);
};
const $d6736e3c7da5c109$var$styleArg = ({ theme: theme })=>(0, $aJx1R.default)({}, theme.typography.caption, {
        width: (0, $5c20cfc7ef711f44$export$3f0060ce4cc8f4d0),
        height: (0, $5c20cfc7ef711f44$export$3f0060ce4cc8f4d0),
        borderRadius: "50%",
        padding: 0,
        // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
        backgroundColor: "transparent",
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.short
        }),
        color: (theme.vars || theme).palette.text.primary,
        "@media (pointer: fine)": {
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $69eec9e6c105674b$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        "&:focus": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $69eec9e6c105674b$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.focusOpacity),
            [`&.${(0, $af784bf02ac62d80$export$68b221ad3c35e288).selected}`]: {
                willChange: "background-color",
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $af784bf02ac62d80$export$68b221ad3c35e288).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            "&:hover": {
                willChange: "background-color",
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $af784bf02ac62d80$export$68b221ad3c35e288).disabled}:not(.${(0, $af784bf02ac62d80$export$68b221ad3c35e288).selected})`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $af784bf02ac62d80$export$68b221ad3c35e288).disabled}&.${(0, $af784bf02ac62d80$export$68b221ad3c35e288).selected}`]: {
            opacity: 0.6
        },
        variants: [
            {
                props: {
                    disableMargin: false
                },
                style: {
                    margin: `0 ${(0, $5c20cfc7ef711f44$export$dde58b009b497666)}px`
                }
            },
            {
                props: {
                    outsideCurrentMonth: true,
                    showDaysOutsideCurrentMonth: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary
                }
            },
            {
                props: {
                    disableHighlightToday: false,
                    today: true
                },
                style: {
                    [`&:not(.${(0, $af784bf02ac62d80$export$68b221ad3c35e288).selected})`]: {
                        border: `1px solid ${(theme.vars || theme).palette.text.secondary}`
                    }
                }
            }
        ]
    });
const $d6736e3c7da5c109$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        !ownerState.disableMargin && styles.dayWithMargin,
        !ownerState.disableHighlightToday && ownerState.today && styles.today,
        !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth,
        ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller
    ];
};
const $d6736e3c7da5c109$var$PickersDayRoot = (0, $jawKn.default)((0, $8c6774266c067eb9$export$2e2bcd8739ae039), {
    name: "MuiPickersDay",
    slot: "Root",
    overridesResolver: $d6736e3c7da5c109$var$overridesResolver
})($d6736e3c7da5c109$var$styleArg);
const $d6736e3c7da5c109$var$PickersDayFiller = (0, $jawKn.default)("div", {
    name: "MuiPickersDay",
    slot: "Root",
    overridesResolver: $d6736e3c7da5c109$var$overridesResolver
})(({ theme: theme })=>(0, $aJx1R.default)({}, $d6736e3c7da5c109$var$styleArg({
        theme: theme
    }), {
        // visibility: 'hidden' does not work here as it hides the element from screen readers as well
        opacity: 0,
        pointerEvents: "none"
    }));
const $d6736e3c7da5c109$var$noop = ()=>{};
const $d6736e3c7da5c109$var$PickersDayRaw = /*#__PURE__*/ $exYeM.forwardRef(function PickersDay(inProps, forwardedRef) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiPickersDay"
    });
    const { autoFocus: autoFocus = false, className: className, day: day, disabled: disabled = false, disableHighlightToday: disableHighlightToday = false, disableMargin: disableMargin = false, isAnimating: isAnimating, onClick: onClick, onDaySelect: onDaySelect, onFocus: onFocus = $d6736e3c7da5c109$var$noop, onBlur: onBlur = $d6736e3c7da5c109$var$noop, onKeyDown: onKeyDown = $d6736e3c7da5c109$var$noop, onMouseDown: onMouseDown = $d6736e3c7da5c109$var$noop, onMouseEnter: onMouseEnter = $d6736e3c7da5c109$var$noop, outsideCurrentMonth: outsideCurrentMonth, selected: selected = false, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth = false, children: children, today: isToday = false } = props, other = (0, $3L80X.default)(props, $d6736e3c7da5c109$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        autoFocus: autoFocus,
        disabled: disabled,
        disableHighlightToday: disableHighlightToday,
        disableMargin: disableMargin,
        selected: selected,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        today: isToday
    });
    const classes = $d6736e3c7da5c109$var$useUtilityClasses(ownerState);
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const ref = $exYeM.useRef(null);
    const handleRef = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(ref, forwardedRef);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $c4c3f9798cb7fddc$export$2e2bcd8739ae039)(()=>{
        if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) // ref.current being null would be a bug in MUI
        ref.current.focus();
    }, [
        autoFocus,
        disabled,
        isAnimating,
        outsideCurrentMonth
    ]);
    // For a day outside the current month, move the focus from mouseDown to mouseUp
    // Goal: have the onClick ends before sliding to the new month
    const handleMouseDown = (event)=>{
        onMouseDown(event);
        if (outsideCurrentMonth) event.preventDefault();
    };
    const handleClick = (event)=>{
        if (!disabled) onDaySelect(day);
        if (outsideCurrentMonth) event.currentTarget.focus();
        if (onClick) onClick(event);
    };
    if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) return /*#__PURE__*/ (0, $aSiaI.jsx)($d6736e3c7da5c109$var$PickersDayFiller, {
        className: (0, $4qr5a.default)(classes.root, classes.hiddenDaySpacingFiller, className),
        ownerState: ownerState,
        role: other.role
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)($d6736e3c7da5c109$var$PickersDayRoot, (0, $aJx1R.default)({
        className: (0, $4qr5a.default)(classes.root, className),
        ref: handleRef,
        centerRipple: true,
        disabled: disabled,
        tabIndex: selected ? 0 : -1,
        onKeyDown: (event)=>onKeyDown(event, day),
        onFocus: (event)=>onFocus(event, day),
        onBlur: (event)=>onBlur(event, day),
        onMouseEnter: (event)=>onMouseEnter(event, day),
        onClick: handleClick,
        onMouseDown: handleMouseDown
    }, other, {
        ownerState: ownerState,
        children: !children ? utils.format(day, "dayOfMonth") : children
    }));
});
const $d6736e3c7da5c109$export$d7378e6e864346fa = /*#__PURE__*/ $exYeM.memo($d6736e3c7da5c109$var$PickersDayRaw);





var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");

var $4qr5a = parcelRequire("4qr5a");

var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $2f0D3 = parcelRequire("2f0D3");

var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");


/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $dac5144581ac19d0$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $4018f2afa8f13b19$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $dac5144581ac19d0$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}


function $d006cad71e0b2459$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $d006cad71e0b2459$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $d006cad71e0b2459$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $d006cad71e0b2459$var$replaceClassName(element.className && element.className.baseVal || "", className));
}



var $exYeM = parcelRequire("exYeM");



var $3ed5ce29b15b1591$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $4018f2afa8f13b19$export$2e2bcd8739ae039)(node, c);
    });
};
var $3ed5ce29b15b1591$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $d006cad71e0b2459$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $3ed5ce29b15b1591$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $6ace560ed589c934$export$2e2bcd8739ae039)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") {
            if (node) (0, $b46d92a9d09371d6$export$7d26bbb1236dafd6)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $3ed5ce29b15b1591$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $3ed5ce29b15b1591$var$removeClass(node, baseClassName);
        if (activeClassName) $3ed5ce29b15b1591$var$removeClass(node, activeClassName);
        if (doneClassName) $3ed5ce29b15b1591$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $3L80X.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, $b1fed440e66ae1d8$export$2e2bcd8739ae039), (0, $aJx1R.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Component);
$3ed5ce29b15b1591$var$CSSTransition.defaultProps = {
    classNames: ""
};
$3ed5ce29b15b1591$var$CSSTransition.propTypes = {};
var $3ed5ce29b15b1591$export$2e2bcd8739ae039 = $3ed5ce29b15b1591$var$CSSTransition;



var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
const $d9e17823684d7693$export$e98c1b6c3bbc3c59 = (slot)=>(0, $dC5O8.default)("MuiPickersSlideTransition", slot);
const $d9e17823684d7693$export$d251a58673156a67 = (0, $kY7HX.default)("MuiPickersSlideTransition", [
    "root",
    "slideEnter-left",
    "slideEnter-right",
    "slideEnterActive",
    "slideExit",
    "slideExitActiveLeft-left",
    "slideExitActiveLeft-right"
]);



var $aSiaI = parcelRequire("aSiaI");
const $ca9b6d63ca241d11$var$_excluded = [
    "children",
    "className",
    "reduceAnimations",
    "slideDirection",
    "transKey",
    "classes"
];
const $ca9b6d63ca241d11$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, slideDirection: slideDirection } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        exit: [
            "slideExit"
        ],
        enterActive: [
            "slideEnterActive"
        ],
        enter: [
            `slideEnter-${slideDirection}`
        ],
        exitActive: [
            `slideExitActiveLeft-${slideDirection}`
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $d9e17823684d7693$export$e98c1b6c3bbc3c59), classes);
};
const $ca9b6d63ca241d11$var$PickersSlideTransitionRoot = (0, $jawKn.default)((0, $151b5217152ca66c$export$2e2bcd8739ae039), {
    name: "MuiPickersSlideTransition",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`.${(0, $d9e17823684d7693$export$d251a58673156a67)["slideEnter-left"]}`]: styles["slideEnter-left"]
            },
            {
                [`.${(0, $d9e17823684d7693$export$d251a58673156a67)["slideEnter-right"]}`]: styles["slideEnter-right"]
            },
            {
                [`.${(0, $d9e17823684d7693$export$d251a58673156a67).slideEnterActive}`]: styles.slideEnterActive
            },
            {
                [`.${(0, $d9e17823684d7693$export$d251a58673156a67).slideExit}`]: styles.slideExit
            },
            {
                [`.${(0, $d9e17823684d7693$export$d251a58673156a67)["slideExitActiveLeft-left"]}`]: styles["slideExitActiveLeft-left"]
            },
            {
                [`.${(0, $d9e17823684d7693$export$d251a58673156a67)["slideExitActiveLeft-right"]}`]: styles["slideExitActiveLeft-right"]
            }
        ]
})(({ theme: theme })=>{
    const slideTransition = theme.transitions.create("transform", {
        duration: theme.transitions.duration.complex,
        easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
    });
    return {
        display: "block",
        position: "relative",
        overflowX: "hidden",
        "& > *": {
            position: "absolute",
            top: 0,
            right: 0,
            left: 0
        },
        [`& .${(0, $d9e17823684d7693$export$d251a58673156a67)["slideEnter-left"]}`]: {
            willChange: "transform",
            transform: "translate(100%)",
            zIndex: 1
        },
        [`& .${(0, $d9e17823684d7693$export$d251a58673156a67)["slideEnter-right"]}`]: {
            willChange: "transform",
            transform: "translate(-100%)",
            zIndex: 1
        },
        [`& .${(0, $d9e17823684d7693$export$d251a58673156a67).slideEnterActive}`]: {
            transform: "translate(0%)",
            transition: slideTransition
        },
        [`& .${(0, $d9e17823684d7693$export$d251a58673156a67).slideExit}`]: {
            transform: "translate(0%)"
        },
        [`& .${(0, $d9e17823684d7693$export$d251a58673156a67)["slideExitActiveLeft-left"]}`]: {
            willChange: "transform",
            transform: "translate(-100%)",
            transition: slideTransition,
            zIndex: 0
        },
        [`& .${(0, $d9e17823684d7693$export$d251a58673156a67)["slideExitActiveLeft-right"]}`]: {
            willChange: "transform",
            transform: "translate(100%)",
            transition: slideTransition,
            zIndex: 0
        }
    };
});
function $ca9b6d63ca241d11$export$e868fcc7557d3a06(inProps) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiPickersSlideTransition"
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props, other = (0, $3L80X.default)(props, $ca9b6d63ca241d11$var$_excluded);
    const classes = $ca9b6d63ca241d11$var$useUtilityClasses(props);
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    if (reduceAnimations) return /*#__PURE__*/ (0, $aSiaI.jsx)("div", {
        className: (0, $4qr5a.default)(classes.root, className),
        children: children
    });
    const transitionClasses = {
        exit: classes.exit,
        enterActive: classes.enterActive,
        enter: classes.enter,
        exitActive: classes.exitActive
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)($ca9b6d63ca241d11$var$PickersSlideTransitionRoot, {
        className: (0, $4qr5a.default)(classes.root, className),
        childFactory: (element)=>/*#__PURE__*/ $exYeM.cloneElement(element, {
                classNames: transitionClasses
            }),
        role: "presentation",
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3ed5ce29b15b1591$export$2e2bcd8739ae039), (0, $aJx1R.default)({
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: theme.transitions.duration.complex,
            classNames: transitionClasses
        }, other, {
            children: children
        }), transKey)
    });
}





var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
const $cfee53fea7ea0f0c$export$fbe827982a69894a = (slot)=>(0, $dC5O8.default)("MuiDayCalendar", slot);
const $cfee53fea7ea0f0c$export$b3f91ee59da1294a = (0, $kY7HX.default)("MuiDayCalendar", [
    "root",
    "header",
    "weekDayLabel",
    "loadingContainer",
    "slideTransition",
    "monthContainer",
    "weekContainer",
    "weekNumberLabel",
    "weekNumber"
]);



var $aSiaI = parcelRequire("aSiaI");
const $6738f852f3a1e345$var$_excluded = [
    "parentProps",
    "day",
    "focusableDay",
    "selectedDays",
    "isDateDisabled",
    "currentMonthNumber",
    "isViewFocused"
], $6738f852f3a1e345$var$_excluded2 = [
    "ownerState"
];
const $6738f852f3a1e345$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        header: [
            "header"
        ],
        weekDayLabel: [
            "weekDayLabel"
        ],
        loadingContainer: [
            "loadingContainer"
        ],
        slideTransition: [
            "slideTransition"
        ],
        monthContainer: [
            "monthContainer"
        ],
        weekContainer: [
            "weekContainer"
        ],
        weekNumberLabel: [
            "weekNumberLabel"
        ],
        weekNumber: [
            "weekNumber"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $cfee53fea7ea0f0c$export$fbe827982a69894a), classes);
};
const $6738f852f3a1e345$var$weeksContainerHeight = ((0, $5c20cfc7ef711f44$export$3f0060ce4cc8f4d0) + (0, $5c20cfc7ef711f44$export$dde58b009b497666) * 2) * 6;
const $6738f852f3a1e345$var$PickersCalendarDayRoot = (0, $jawKn.default)("div", {
    name: "MuiDayCalendar",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({});
const $6738f852f3a1e345$var$PickersCalendarDayHeader = (0, $jawKn.default)("div", {
    name: "MuiDayCalendar",
    slot: "Header",
    overridesResolver: (_, styles)=>styles.header
})({
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $6738f852f3a1e345$var$PickersCalendarWeekDayLabel = (0, $jawKn.default)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
    name: "MuiDayCalendar",
    slot: "WeekDayLabel",
    overridesResolver: (_, styles)=>styles.weekDayLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: "0 2px",
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: (theme.vars || theme).palette.text.secondary
    }));
const $6738f852f3a1e345$var$PickersCalendarWeekNumberLabel = (0, $jawKn.default)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
    name: "MuiDayCalendar",
    slot: "WeekNumberLabel",
    overridesResolver: (_, styles)=>styles.weekNumberLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: "0 2px",
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: theme.palette.text.disabled
    }));
const $6738f852f3a1e345$var$PickersCalendarWeekNumber = (0, $jawKn.default)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
    name: "MuiDayCalendar",
    slot: "WeekNumber",
    overridesResolver: (_, styles)=>styles.weekNumber
})(({ theme: theme })=>(0, $aJx1R.default)({}, theme.typography.caption, {
        width: (0, $5c20cfc7ef711f44$export$3f0060ce4cc8f4d0),
        height: (0, $5c20cfc7ef711f44$export$3f0060ce4cc8f4d0),
        padding: 0,
        margin: `0 ${(0, $5c20cfc7ef711f44$export$dde58b009b497666)}px`,
        color: theme.palette.text.disabled,
        fontSize: "0.75rem",
        alignItems: "center",
        justifyContent: "center",
        display: "inline-flex"
    }));
const $6738f852f3a1e345$var$PickersCalendarLoadingContainer = (0, $jawKn.default)("div", {
    name: "MuiDayCalendar",
    slot: "LoadingContainer",
    overridesResolver: (_, styles)=>styles.loadingContainer
})({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: $6738f852f3a1e345$var$weeksContainerHeight
});
const $6738f852f3a1e345$var$PickersCalendarSlideTransition = (0, $jawKn.default)((0, $ca9b6d63ca241d11$export$e868fcc7557d3a06), {
    name: "MuiDayCalendar",
    slot: "SlideTransition",
    overridesResolver: (_, styles)=>styles.slideTransition
})({
    minHeight: $6738f852f3a1e345$var$weeksContainerHeight
});
const $6738f852f3a1e345$var$PickersCalendarWeekContainer = (0, $jawKn.default)("div", {
    name: "MuiDayCalendar",
    slot: "MonthContainer",
    overridesResolver: (_, styles)=>styles.monthContainer
})({
    overflow: "hidden"
});
const $6738f852f3a1e345$var$PickersCalendarWeek = (0, $jawKn.default)("div", {
    name: "MuiDayCalendar",
    slot: "WeekContainer",
    overridesResolver: (_, styles)=>styles.weekContainer
})({
    margin: `${(0, $5c20cfc7ef711f44$export$dde58b009b497666)}px 0`,
    display: "flex",
    justifyContent: "center"
});
function $6738f852f3a1e345$var$WrappedDay(_ref) {
    let { parentProps: parentProps, day: day, focusableDay: focusableDay, selectedDays: selectedDays, isDateDisabled: isDateDisabled, currentMonthNumber: currentMonthNumber, isViewFocused: isViewFocused } = _ref, other = (0, $3L80X.default)(_ref, $6738f852f3a1e345$var$_excluded);
    const { disabled: disabled, disableHighlightToday: disableHighlightToday, isMonthSwitchingAnimating: isMonthSwitchingAnimating, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, slots: slots, slotProps: slotProps, timezone: timezone } = parentProps;
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const now = (0, $58b82a9afc388fa3$export$3a404aece3dff2fa)(timezone);
    const isFocusableDay = focusableDay !== null && utils.isSameDay(day, focusableDay);
    const isSelected = selectedDays.some((selectedDay)=>utils.isSameDay(selectedDay, day));
    const isToday = utils.isSameDay(day, now);
    const Day = slots?.day ?? (0, $d6736e3c7da5c109$export$d7378e6e864346fa);
    // We don't want to pass to ownerState down, to avoid re-rendering all the day whenever a prop changes.
    const _useSlotProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: Day,
        externalSlotProps: slotProps?.day,
        additionalProps: (0, $aJx1R.default)({
            disableHighlightToday: disableHighlightToday,
            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
            role: "gridcell",
            isAnimating: isMonthSwitchingAnimating,
            // it is used in date range dragging logic by accessing `dataset.timestamp`
            "data-timestamp": utils.toJsDate(day).valueOf()
        }, other),
        ownerState: (0, $aJx1R.default)({}, parentProps, {
            day: day,
            selected: isSelected
        })
    }), dayProps = (0, $3L80X.default)(_useSlotProps, $6738f852f3a1e345$var$_excluded2);
    const isDisabled = $exYeM.useMemo(()=>disabled || isDateDisabled(day), [
        disabled,
        isDateDisabled,
        day
    ]);
    const outsideCurrentMonth = $exYeM.useMemo(()=>utils.getMonth(day) !== currentMonthNumber, [
        utils,
        day,
        currentMonthNumber
    ]);
    const isFirstVisibleCell = $exYeM.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, startOfMonth);
        return utils.isSameDay(day, utils.startOfWeek(startOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    const isLastVisibleCell = $exYeM.useMemo(()=>{
        const endOfMonth = utils.endOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, endOfMonth);
        return utils.isSameDay(day, utils.endOfWeek(endOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)(Day, (0, $aJx1R.default)({}, dayProps, {
        day: day,
        disabled: isDisabled,
        autoFocus: isViewFocused && isFocusableDay,
        today: isToday,
        outsideCurrentMonth: outsideCurrentMonth,
        isFirstVisibleCell: isFirstVisibleCell,
        isLastVisibleCell: isLastVisibleCell,
        selected: isSelected,
        tabIndex: isFocusableDay ? 0 : -1,
        "aria-selected": isSelected,
        "aria-current": isToday ? "date" : undefined
    }));
}
function $6738f852f3a1e345$export$8fb56b32a5df6314(inProps) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiDayCalendar"
    });
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const { onFocusedDayChange: onFocusedDayChange, className: className, currentMonth: currentMonth, selectedDays: selectedDays, focusedDay: focusedDay, loading: loading, onSelectedDaysChange: onSelectedDaysChange, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd, readOnly: readOnly, reduceAnimations: reduceAnimations, renderLoading: renderLoading = ()=>/*#__PURE__*/ (0, $aSiaI.jsx)("span", {
            children: "..."
        }), slideDirection: slideDirection, TransitionProps: TransitionProps, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, dayOfWeekFormatter: dayOfWeekFormatter = (date)=>utils.format(date, "weekdayShort").charAt(0).toUpperCase(), hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, gridLabelId: gridLabelId, displayWeekNumber: displayWeekNumber, fixedWeekNumber: fixedWeekNumber, autoFocus: autoFocus, timezone: timezone } = props;
    const now = (0, $58b82a9afc388fa3$export$3a404aece3dff2fa)(timezone);
    const classes = $6738f852f3a1e345$var$useUtilityClasses(props);
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === "rtl";
    const isDateDisabled = (0, $1b908537a77eb3c9$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        minDate: minDate,
        maxDate: maxDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    const localeText = (0, $58b82a9afc388fa3$export$24fdeaa0f591a73e)();
    const [internalHasFocus, setInternalHasFocus] = (0, $d86ef59ee77e84fd$export$2e2bcd8739ae039)({
        name: "DayCalendar",
        state: "hasFocus",
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const [internalFocusedDay, setInternalFocusedDay] = $exYeM.useState(()=>focusedDay || now);
    const handleDaySelect = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((day)=>{
        if (readOnly) return;
        onSelectedDaysChange(day);
    });
    const focusDay = (day)=>{
        if (!isDateDisabled(day)) {
            onFocusedDayChange(day);
            setInternalFocusedDay(day);
            onFocusedViewChange?.(true);
            setInternalHasFocus(true);
        }
    };
    const handleKeyDown = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event, day)=>{
        switch(event.key){
            case "ArrowUp":
                focusDay(utils.addDays(day, -7));
                event.preventDefault();
                break;
            case "ArrowDown":
                focusDay(utils.addDays(day, 7));
                event.preventDefault();
                break;
            case "ArrowLeft":
                {
                    const newFocusedDayDefault = utils.addDays(day, isRTL ? 1 : -1);
                    const nextAvailableMonth = utils.addMonths(day, isRTL ? 1 : -1);
                    const closestDayToFocus = (0, $8c165bb53d94cf45$export$ca1f317ae8db2ee8)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: isRTL ? newFocusedDayDefault : utils.startOfMonth(nextAvailableMonth),
                        maxDate: isRTL ? utils.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case "ArrowRight":
                {
                    const newFocusedDayDefault = utils.addDays(day, isRTL ? -1 : 1);
                    const nextAvailableMonth = utils.addMonths(day, isRTL ? -1 : 1);
                    const closestDayToFocus = (0, $8c165bb53d94cf45$export$ca1f317ae8db2ee8)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: isRTL ? utils.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        maxDate: isRTL ? newFocusedDayDefault : utils.endOfMonth(nextAvailableMonth),
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case "Home":
                focusDay(utils.startOfWeek(day));
                event.preventDefault();
                break;
            case "End":
                focusDay(utils.endOfWeek(day));
                event.preventDefault();
                break;
            case "PageUp":
                focusDay(utils.addMonths(day, 1));
                event.preventDefault();
                break;
            case "PageDown":
                focusDay(utils.addMonths(day, -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleFocus = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event, day)=>focusDay(day));
    const handleBlur = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event, day)=>{
        if (internalHasFocus && utils.isSameDay(internalFocusedDay, day)) onFocusedViewChange?.(false);
    });
    const currentMonthNumber = utils.getMonth(currentMonth);
    const currentYearNumber = utils.getYear(currentMonth);
    const validSelectedDays = $exYeM.useMemo(()=>selectedDays.filter((day)=>!!day).map((day)=>utils.startOfDay(day)), [
        utils,
        selectedDays
    ]);
    // need a new ref whenever the `key` of the transition changes: https://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
    const transitionKey = `${currentYearNumber}-${currentMonthNumber}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const slideNodeRef = $exYeM.useMemo(()=>/*#__PURE__*/ $exYeM.createRef(), [
        transitionKey
    ]);
    const startOfCurrentWeek = utils.startOfWeek(now);
    const focusableDay = $exYeM.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(currentMonth);
        const endOfMonth = utils.endOfMonth(currentMonth);
        if (isDateDisabled(internalFocusedDay) || utils.isAfterDay(internalFocusedDay, endOfMonth) || utils.isBeforeDay(internalFocusedDay, startOfMonth)) return (0, $8c165bb53d94cf45$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: internalFocusedDay,
            minDate: startOfMonth,
            maxDate: endOfMonth,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        });
        return internalFocusedDay;
    }, [
        currentMonth,
        disableFuture,
        disablePast,
        internalFocusedDay,
        isDateDisabled,
        utils,
        timezone
    ]);
    const weeksToDisplay = $exYeM.useMemo(()=>{
        const currentMonthWithTimezone = utils.setTimezone(currentMonth, timezone);
        const toDisplay = utils.getWeekArray(currentMonthWithTimezone);
        let nextMonth = utils.addMonths(currentMonthWithTimezone, 1);
        while(fixedWeekNumber && toDisplay.length < fixedWeekNumber){
            const additionalWeeks = utils.getWeekArray(nextMonth);
            const hasCommonWeek = utils.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
            additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach((week)=>{
                if (toDisplay.length < fixedWeekNumber) toDisplay.push(week);
            });
            nextMonth = utils.addMonths(nextMonth, 1);
        }
        return toDisplay;
    }, [
        currentMonth,
        fixedWeekNumber,
        utils,
        timezone
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($6738f852f3a1e345$var$PickersCalendarDayRoot, {
        role: "grid",
        "aria-labelledby": gridLabelId,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)($6738f852f3a1e345$var$PickersCalendarDayHeader, {
                role: "row",
                className: classes.header,
                children: [
                    displayWeekNumber && /*#__PURE__*/ (0, $aSiaI.jsx)($6738f852f3a1e345$var$PickersCalendarWeekNumberLabel, {
                        variant: "caption",
                        role: "columnheader",
                        "aria-label": localeText.calendarWeekNumberHeaderLabel,
                        className: classes.weekNumberLabel,
                        children: localeText.calendarWeekNumberHeaderText
                    }),
                    (0, $8c165bb53d94cf45$export$24c38139da66592d)(utils, now).map((weekday, i)=>/*#__PURE__*/ (0, $aSiaI.jsx)($6738f852f3a1e345$var$PickersCalendarWeekDayLabel, {
                            variant: "caption",
                            role: "columnheader",
                            "aria-label": utils.format(utils.addDays(startOfCurrentWeek, i), "weekday"),
                            className: classes.weekDayLabel,
                            children: dayOfWeekFormatter(weekday)
                        }, i.toString()))
                ]
            }),
            loading ? /*#__PURE__*/ (0, $aSiaI.jsx)($6738f852f3a1e345$var$PickersCalendarLoadingContainer, {
                className: classes.loadingContainer,
                children: renderLoading()
            }) : /*#__PURE__*/ (0, $aSiaI.jsx)($6738f852f3a1e345$var$PickersCalendarSlideTransition, (0, $aJx1R.default)({
                transKey: transitionKey,
                onExited: onMonthSwitchingAnimationEnd,
                reduceAnimations: reduceAnimations,
                slideDirection: slideDirection,
                className: (0, $4qr5a.default)(className, classes.slideTransition)
            }, TransitionProps, {
                nodeRef: slideNodeRef,
                children: /*#__PURE__*/ (0, $aSiaI.jsx)($6738f852f3a1e345$var$PickersCalendarWeekContainer, {
                    ref: slideNodeRef,
                    role: "rowgroup",
                    className: classes.monthContainer,
                    children: weeksToDisplay.map((week, index)=>/*#__PURE__*/ (0, $aSiaI.jsxs)($6738f852f3a1e345$var$PickersCalendarWeek, {
                            role: "row",
                            className: classes.weekContainer,
                            "aria-rowindex": index + 1,
                            children: [
                                displayWeekNumber && /*#__PURE__*/ (0, $aSiaI.jsx)($6738f852f3a1e345$var$PickersCalendarWeekNumber, {
                                    className: classes.weekNumber,
                                    role: "rowheader",
                                    "aria-label": localeText.calendarWeekNumberAriaLabelText(utils.getWeekNumber(week[0])),
                                    children: localeText.calendarWeekNumberText(utils.getWeekNumber(week[0]))
                                }),
                                week.map((day, dayIndex)=>/*#__PURE__*/ (0, $aSiaI.jsx)($6738f852f3a1e345$var$WrappedDay, {
                                        parentProps: props,
                                        day: day,
                                        selectedDays: validSelectedDays,
                                        focusableDay: focusableDay,
                                        onKeyDown: handleKeyDown,
                                        onFocus: handleFocus,
                                        onBlur: handleBlur,
                                        onDaySelect: handleDaySelect,
                                        isDateDisabled: isDateDisabled,
                                        currentMonthNumber: currentMonthNumber,
                                        isViewFocused: internalHasFocus,
                                        "aria-colindex": dayIndex + 1
                                    }, day.toString()))
                            ]
                        }, `week-${week[0]}`))
                })
            }))
        ]
    });
}



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $8IwTu = parcelRequire("8IwTu");

var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $2f0D3 = parcelRequire("2f0D3");

var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $2f0D3 = parcelRequire("2f0D3");

var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
function $e033c2c0be471ba1$export$db90a620ac957a73(slot) {
    return (0, $dC5O8.default)("MuiPickersMonth", slot);
}
const $e033c2c0be471ba1$export$911e3973fa70a12b = (0, $kY7HX.default)("MuiPickersMonth", [
    "root",
    "monthButton",
    "disabled",
    "selected"
]);



var $aSiaI = parcelRequire("aSiaI");
const $34c2b0a618ee8b83$var$_excluded = [
    "autoFocus",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "aria-label",
    "monthsPerRow"
];
const $34c2b0a618ee8b83$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        monthButton: [
            "monthButton",
            disabled && "disabled",
            selected && "selected"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $e033c2c0be471ba1$export$db90a620ac957a73), classes);
};
const $34c2b0a618ee8b83$var$PickersMonthRoot = (0, $jawKn.default)("div", {
    name: "MuiPickersMonth",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexBasis: "33.3%",
    variants: [
        {
            props: {
                monthsPerRow: 4
            },
            style: {
                flexBasis: "25%"
            }
        }
    ]
});
const $34c2b0a618ee8b83$var$PickersMonthButton = (0, $jawKn.default)("button", {
    name: "MuiPickersMonth",
    slot: "MonthButton",
    overridesResolver: (_, styles)=>[
            styles.monthButton,
            {
                [`&.${(0, $e033c2c0be471ba1$export$911e3973fa70a12b).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $e033c2c0be471ba1$export$911e3973fa70a12b).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $aJx1R.default)({
        color: "unset",
        backgroundColor: "transparent",
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: "8px 0",
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: "pointer",
        "&:focus": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $69eec9e6c105674b$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $69eec9e6c105674b$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        "&:disabled": {
            cursor: "auto",
            pointerEvents: "none"
        },
        [`&.${(0, $e033c2c0be471ba1$export$911e3973fa70a12b).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $e033c2c0be471ba1$export$911e3973fa70a12b).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            "&:focus, &:hover": {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $34c2b0a618ee8b83$export$bc52fdb7f02f591a = /*#__PURE__*/ $exYeM.memo(function PickersMonth(inProps) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiPickersMonth"
    });
    const { autoFocus: autoFocus, children: children, disabled: disabled, selected: selected, value: value, tabIndex: tabIndex, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, "aria-current": ariaCurrent, "aria-label": ariaLabel } = props, other = (0, $3L80X.default)(props, $34c2b0a618ee8b83$var$_excluded);
    const ref = $exYeM.useRef(null);
    const classes = $34c2b0a618ee8b83$var$useUtilityClasses(props);
    (0, $c4c3f9798cb7fddc$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) ref.current?.focus();
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($34c2b0a618ee8b83$var$PickersMonthRoot, (0, $aJx1R.default)({
        className: classes.root,
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($34c2b0a618ee8b83$var$PickersMonthButton, {
            ref: ref,
            disabled: disabled,
            type: "button",
            role: "radio",
            tabIndex: disabled ? -1 : tabIndex,
            "aria-current": ariaCurrent,
            "aria-checked": selected,
            "aria-label": ariaLabel,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value),
            className: classes.monthButton,
            ownerState: props,
            children: children
        })
    }));
});




var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
function $bc20f6f7d12ee955$export$da0c97315339ebd9(slot) {
    return (0, $dC5O8.default)("MuiMonthCalendar", slot);
}
const $bc20f6f7d12ee955$export$edf77d5566c7007c = (0, $kY7HX.default)("MuiMonthCalendar", [
    "root"
]);








var $aSiaI = parcelRequire("aSiaI");
const $1dc4dbb7f7bbc8b6$var$_excluded = [
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "shouldDisableMonth",
    "readOnly",
    "disableHighlightToday",
    "autoFocus",
    "onMonthFocus",
    "hasFocus",
    "onFocusedViewChange",
    "monthsPerRow",
    "timezone",
    "gridLabelId"
];
const $1dc4dbb7f7bbc8b6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $bc20f6f7d12ee955$export$da0c97315339ebd9), classes);
};
function $1dc4dbb7f7bbc8b6$export$5b6e066572408095(props, name) {
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const defaultDates = (0, $58b82a9afc388fa3$export$7c38da3a2e90fa83)();
    const themeProps = (0, $7PWLt.default)({
        props: props,
        name: name
    });
    return (0, $aJx1R.default)({
        disableFuture: false,
        disablePast: false
    }, themeProps, {
        minDate: (0, $8c165bb53d94cf45$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $8c165bb53d94cf45$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $1dc4dbb7f7bbc8b6$var$MonthCalendarRoot = (0, $jawKn.default)("div", {
    name: "MuiMonthCalendar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexWrap: "wrap",
    alignContent: "stretch",
    padding: "0 4px",
    width: (0, $5c20cfc7ef711f44$export$ee46b8a74d6c94d3),
    // avoid padding increasing width over defined
    boxSizing: "border-box"
});
const $1dc4dbb7f7bbc8b6$export$d7a7c85c0f5afc4a = /*#__PURE__*/ $exYeM.forwardRef(function MonthCalendar(inProps, ref) {
    const props = $1dc4dbb7f7bbc8b6$export$5b6e066572408095(inProps, "MuiMonthCalendar");
    const { className: className, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, shouldDisableMonth: shouldDisableMonth, readOnly: readOnly, autoFocus: autoFocus = false, onMonthFocus: onMonthFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, monthsPerRow: monthsPerRow = 3, timezone: timezoneProp, gridLabelId: gridLabelId } = props, other = (0, $3L80X.default)(props, $1dc4dbb7f7bbc8b6$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $3e4aef0ef80b275d$export$174d749f3b4c0f49)({
        name: "MonthCalendar",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $efb258a9c0464e3f$export$2764b246aa3b75ba)
    });
    const now = (0, $58b82a9afc388fa3$export$3a404aece3dff2fa)(timezone);
    const theme = (0, $8IwTu.default)();
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const referenceDate = $exYeM.useMemo(()=>(0, $efb258a9c0464e3f$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $bd0cf02b8b64cf79$export$8f74e8f4ed8ae0ac).month
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const ownerState = props;
    const classes = $1dc4dbb7f7bbc8b6$var$useUtilityClasses(ownerState);
    const todayMonth = $exYeM.useMemo(()=>utils.getMonth(now), [
        utils,
        now
    ]);
    const selectedMonth = $exYeM.useMemo(()=>{
        if (value != null) return utils.getMonth(value);
        return null;
    }, [
        value,
        utils
    ]);
    const [focusedMonth, setFocusedMonth] = $exYeM.useState(()=>selectedMonth || utils.getMonth(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, $d86ef59ee77e84fd$export$2e2bcd8739ae039)({
        name: "MonthCalendar",
        state: "hasFocus",
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isMonthDisabled = $exYeM.useCallback((dateToValidate)=>{
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        const monthToValidate = utils.startOfMonth(dateToValidate);
        if (utils.isBefore(monthToValidate, firstEnabledMonth)) return true;
        if (utils.isAfter(monthToValidate, lastEnabledMonth)) return true;
        if (!shouldDisableMonth) return false;
        return shouldDisableMonth(monthToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableMonth,
        utils
    ]);
    const handleMonthSelection = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event, month)=>{
        if (readOnly) return;
        const newDate = utils.setMonth(value ?? referenceDate, month);
        handleValueChange(newDate);
    });
    const focusMonth = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((month)=>{
        if (!isMonthDisabled(utils.setMonth(value ?? referenceDate, month))) {
            setFocusedMonth(month);
            changeHasFocus(true);
            if (onMonthFocus) onMonthFocus(month);
        }
    });
    $exYeM.useEffect(()=>{
        setFocusedMonth((prevFocusedMonth)=>selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
    }, [
        selectedMonth
    ]);
    const handleKeyDown = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event, month)=>{
        const monthsInYear = 12;
        const monthsInRow = 3;
        switch(event.key){
            case "ArrowUp":
                focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case "ArrowDown":
                focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case "ArrowLeft":
                focusMonth((monthsInYear + month + (theme.direction === "ltr" ? -1 : 1)) % monthsInYear);
                event.preventDefault();
                break;
            case "ArrowRight":
                focusMonth((monthsInYear + month + (theme.direction === "ltr" ? 1 : -1)) % monthsInYear);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleMonthFocus = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event, month)=>{
        focusMonth(month);
    });
    const handleMonthBlur = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event, month)=>{
        if (focusedMonth === month) changeHasFocus(false);
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)($1dc4dbb7f7bbc8b6$var$MonthCalendarRoot, (0, $aJx1R.default)({
        ref: ref,
        className: (0, $4qr5a.default)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId
    }, other, {
        children: (0, $8c165bb53d94cf45$export$62591b96a734eacd)(utils, value ?? referenceDate).map((month)=>{
            const monthNumber = utils.getMonth(month);
            const monthText = utils.format(month, "monthShort");
            const monthLabel = utils.format(month, "month");
            const isSelected = monthNumber === selectedMonth;
            const isDisabled = disabled || isMonthDisabled(month);
            return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $34c2b0a618ee8b83$export$bc52fdb7f02f591a), {
                selected: isSelected,
                value: monthNumber,
                onClick: handleMonthSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && monthNumber === focusedMonth,
                disabled: isDisabled,
                tabIndex: monthNumber === focusedMonth ? 0 : -1,
                onFocus: handleMonthFocus,
                onBlur: handleMonthBlur,
                "aria-current": todayMonth === monthNumber ? "date" : undefined,
                "aria-label": monthLabel,
                monthsPerRow: monthsPerRow,
                children: monthText
            }, monthText);
        })
    }));
});



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $8IwTu = parcelRequire("8IwTu");

var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $2f0D3 = parcelRequire("2f0D3");

var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
function $beaca66c73c86aa7$export$183c9f339a61cd79(slot) {
    return (0, $dC5O8.default)("MuiPickersYear", slot);
}
const $beaca66c73c86aa7$export$4ef58a3d9c6f4296 = (0, $kY7HX.default)("MuiPickersYear", [
    "root",
    "yearButton",
    "selected",
    "disabled"
]);



var $aSiaI = parcelRequire("aSiaI");
const $0e7d8952d849aa02$var$_excluded = [
    "autoFocus",
    "className",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "yearsPerRow"
];
const $0e7d8952d849aa02$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        yearButton: [
            "yearButton",
            disabled && "disabled",
            selected && "selected"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $beaca66c73c86aa7$export$183c9f339a61cd79), classes);
};
const $0e7d8952d849aa02$var$PickersYearRoot = (0, $jawKn.default)("div", {
    name: "MuiPickersYear",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexBasis: "33.3%",
    variants: [
        {
            props: {
                yearsPerRow: 4
            },
            style: {
                flexBasis: "25%"
            }
        }
    ]
});
const $0e7d8952d849aa02$var$PickersYearButton = (0, $jawKn.default)("button", {
    name: "MuiPickersYear",
    slot: "YearButton",
    overridesResolver: (_, styles)=>[
            styles.yearButton,
            {
                [`&.${(0, $beaca66c73c86aa7$export$4ef58a3d9c6f4296).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $beaca66c73c86aa7$export$4ef58a3d9c6f4296).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $aJx1R.default)({
        color: "unset",
        backgroundColor: "transparent",
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: "6px 0",
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: "pointer",
        "&:focus": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $69eec9e6c105674b$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.focusOpacity)
        },
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $69eec9e6c105674b$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        "&:disabled": {
            cursor: "auto",
            pointerEvents: "none"
        },
        [`&.${(0, $beaca66c73c86aa7$export$4ef58a3d9c6f4296).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $beaca66c73c86aa7$export$4ef58a3d9c6f4296).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            "&:focus, &:hover": {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $0e7d8952d849aa02$export$261f3fbd5fd5814d = /*#__PURE__*/ $exYeM.memo(function PickersYear(inProps) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiPickersYear"
    });
    const { autoFocus: autoFocus, className: className, children: children, disabled: disabled, selected: selected, value: value, tabIndex: tabIndex, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, "aria-current": ariaCurrent } = props, other = (0, $3L80X.default)(props, $0e7d8952d849aa02$var$_excluded);
    const ref = $exYeM.useRef(null);
    const classes = $0e7d8952d849aa02$var$useUtilityClasses(props);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    $exYeM.useEffect(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current.focus();
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($0e7d8952d849aa02$var$PickersYearRoot, (0, $aJx1R.default)({
        className: (0, $4qr5a.default)(classes.root, className),
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($0e7d8952d849aa02$var$PickersYearButton, {
            ref: ref,
            disabled: disabled,
            type: "button",
            role: "radio",
            tabIndex: disabled ? -1 : tabIndex,
            "aria-current": ariaCurrent,
            "aria-checked": selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value),
            className: classes.yearButton,
            ownerState: props,
            children: children
        })
    }));
});




var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
function $f05fd304a48b1d53$export$4477acc520094dec(slot) {
    return (0, $dC5O8.default)("MuiYearCalendar", slot);
}
const $f05fd304a48b1d53$export$e42d427cd9fe5fd7 = (0, $kY7HX.default)("MuiYearCalendar", [
    "root"
]);








var $aSiaI = parcelRequire("aSiaI");
const $4aaa7676c3db3943$var$_excluded = [
    "autoFocus",
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "readOnly",
    "shouldDisableYear",
    "disableHighlightToday",
    "onYearFocus",
    "hasFocus",
    "onFocusedViewChange",
    "yearsPerRow",
    "timezone",
    "gridLabelId"
];
const $4aaa7676c3db3943$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $f05fd304a48b1d53$export$4477acc520094dec), classes);
};
function $4aaa7676c3db3943$var$useYearCalendarDefaultizedProps(props, name) {
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const defaultDates = (0, $58b82a9afc388fa3$export$7c38da3a2e90fa83)();
    const themeProps = (0, $7PWLt.default)({
        props: props,
        name: name
    });
    return (0, $aJx1R.default)({
        disablePast: false,
        disableFuture: false
    }, themeProps, {
        yearsPerRow: themeProps.yearsPerRow ?? 3,
        minDate: (0, $8c165bb53d94cf45$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $8c165bb53d94cf45$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $4aaa7676c3db3943$var$YearCalendarRoot = (0, $jawKn.default)("div", {
    name: "MuiYearCalendar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    overflowY: "auto",
    height: "100%",
    padding: "0 4px",
    width: (0, $5c20cfc7ef711f44$export$ee46b8a74d6c94d3),
    maxHeight: (0, $5c20cfc7ef711f44$export$73724491020e90c7),
    // avoid padding increasing width over defined
    boxSizing: "border-box",
    position: "relative"
});
const $4aaa7676c3db3943$export$657f9200591b2b71 = /*#__PURE__*/ $exYeM.forwardRef(function YearCalendar(inProps, ref) {
    const props = $4aaa7676c3db3943$var$useYearCalendarDefaultizedProps(inProps, "MuiYearCalendar");
    const { autoFocus: autoFocus, className: className, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, readOnly: readOnly, shouldDisableYear: shouldDisableYear, onYearFocus: onYearFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, yearsPerRow: yearsPerRow, timezone: timezoneProp, gridLabelId: gridLabelId } = props, other = (0, $3L80X.default)(props, $4aaa7676c3db3943$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $3e4aef0ef80b275d$export$174d749f3b4c0f49)({
        name: "YearCalendar",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $efb258a9c0464e3f$export$2764b246aa3b75ba)
    });
    const now = (0, $58b82a9afc388fa3$export$3a404aece3dff2fa)(timezone);
    const theme = (0, $8IwTu.default)();
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const referenceDate = $exYeM.useMemo(()=>(0, $efb258a9c0464e3f$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $bd0cf02b8b64cf79$export$8f74e8f4ed8ae0ac).year
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const ownerState = props;
    const classes = $4aaa7676c3db3943$var$useUtilityClasses(ownerState);
    const todayYear = $exYeM.useMemo(()=>utils.getYear(now), [
        utils,
        now
    ]);
    const selectedYear = $exYeM.useMemo(()=>{
        if (value != null) return utils.getYear(value);
        return null;
    }, [
        value,
        utils
    ]);
    const [focusedYear, setFocusedYear] = $exYeM.useState(()=>selectedYear || utils.getYear(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, $d86ef59ee77e84fd$export$2e2bcd8739ae039)({
        name: "YearCalendar",
        state: "hasFocus",
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isYearDisabled = $exYeM.useCallback((dateToValidate)=>{
        if (disablePast && utils.isBeforeYear(dateToValidate, now)) return true;
        if (disableFuture && utils.isAfterYear(dateToValidate, now)) return true;
        if (minDate && utils.isBeforeYear(dateToValidate, minDate)) return true;
        if (maxDate && utils.isAfterYear(dateToValidate, maxDate)) return true;
        if (!shouldDisableYear) return false;
        const yearToValidate = utils.startOfYear(dateToValidate);
        return shouldDisableYear(yearToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableYear,
        utils
    ]);
    const handleYearSelection = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event, year)=>{
        if (readOnly) return;
        const newDate = utils.setYear(value ?? referenceDate, year);
        handleValueChange(newDate);
    });
    const focusYear = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((year)=>{
        if (!isYearDisabled(utils.setYear(value ?? referenceDate, year))) {
            setFocusedYear(year);
            changeHasFocus(true);
            onYearFocus?.(year);
        }
    });
    $exYeM.useEffect(()=>{
        setFocusedYear((prevFocusedYear)=>selectedYear !== null && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
    }, [
        selectedYear
    ]);
    const handleKeyDown = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event, year)=>{
        switch(event.key){
            case "ArrowUp":
                focusYear(year - yearsPerRow);
                event.preventDefault();
                break;
            case "ArrowDown":
                focusYear(year + yearsPerRow);
                event.preventDefault();
                break;
            case "ArrowLeft":
                focusYear(year + (theme.direction === "ltr" ? -1 : 1));
                event.preventDefault();
                break;
            case "ArrowRight":
                focusYear(year + (theme.direction === "ltr" ? 1 : -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleYearFocus = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event, year)=>{
        focusYear(year);
    });
    const handleYearBlur = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((event, year)=>{
        if (focusedYear === year) changeHasFocus(false);
    });
    const scrollerRef = $exYeM.useRef(null);
    const handleRef = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(ref, scrollerRef);
    $exYeM.useEffect(()=>{
        if (autoFocus || scrollerRef.current === null) return;
        const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
        if (!tabbableButton) return;
        // Taken from useScroll in x-data-grid, but vertically centered
        const offsetHeight = tabbableButton.offsetHeight;
        const offsetTop = tabbableButton.offsetTop;
        const clientHeight = scrollerRef.current.clientHeight;
        const scrollTop = scrollerRef.current.scrollTop;
        const elementBottom = offsetTop + offsetHeight;
        if (offsetHeight > clientHeight || offsetTop < scrollTop) // Button already visible
        return;
        scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($4aaa7676c3db3943$var$YearCalendarRoot, (0, $aJx1R.default)({
        ref: handleRef,
        className: (0, $4qr5a.default)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId
    }, other, {
        children: utils.getYearRange([
            minDate,
            maxDate
        ]).map((year)=>{
            const yearNumber = utils.getYear(year);
            const isSelected = yearNumber === selectedYear;
            const isDisabled = disabled || isYearDisabled(year);
            return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0e7d8952d849aa02$export$261f3fbd5fd5814d), {
                selected: isSelected,
                value: yearNumber,
                onClick: handleYearSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && yearNumber === focusedYear,
                disabled: isDisabled,
                tabIndex: yearNumber === focusedYear ? 0 : -1,
                onFocus: handleYearFocus,
                onBlur: handleYearBlur,
                "aria-current": todayYear === yearNumber ? "date" : undefined,
                yearsPerRow: yearsPerRow,
                children: utils.format(year, "year")
            }, utils.format(year, "year"));
        })
    }));
});




var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");


var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");


var $2f0D3 = parcelRequire("2f0D3");





var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");

var $4qr5a = parcelRequire("4qr5a");


var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $2f0D3 = parcelRequire("2f0D3");




var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
function $574be9d56cc13051$export$cef978c25740de90(slot) {
    return (0, $dC5O8.default)("MuiPickersArrowSwitcher", slot);
}
const $574be9d56cc13051$export$f8819209558cd362 = (0, $kY7HX.default)("MuiPickersArrowSwitcher", [
    "root",
    "spacer",
    "button"
]);



var $aSiaI = parcelRequire("aSiaI");
const $d0c9a6613cf3e3f5$var$_excluded = [
    "children",
    "className",
    "slots",
    "slotProps",
    "isNextDisabled",
    "isNextHidden",
    "onGoToNext",
    "nextLabel",
    "isPreviousDisabled",
    "isPreviousHidden",
    "onGoToPrevious",
    "previousLabel"
], $d0c9a6613cf3e3f5$var$_excluded2 = [
    "ownerState"
], $d0c9a6613cf3e3f5$var$_excluded3 = [
    "ownerState"
];
const $d0c9a6613cf3e3f5$var$PickersArrowSwitcherRoot = (0, $jawKn.default)("div", {
    name: "MuiPickersArrowSwitcher",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex"
});
const $d0c9a6613cf3e3f5$var$PickersArrowSwitcherSpacer = (0, $jawKn.default)("div", {
    name: "MuiPickersArrowSwitcher",
    slot: "Spacer",
    overridesResolver: (props, styles)=>styles.spacer
})(({ theme: theme })=>({
        width: theme.spacing(3)
    }));
const $d0c9a6613cf3e3f5$var$PickersArrowSwitcherButton = (0, $jawKn.default)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), {
    name: "MuiPickersArrowSwitcher",
    slot: "Button",
    overridesResolver: (props, styles)=>styles.button
})({
    variants: [
        {
            props: {
                hidden: true
            },
            style: {
                visibility: "hidden"
            }
        }
    ]
});
const $d0c9a6613cf3e3f5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        spacer: [
            "spacer"
        ],
        button: [
            "button"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $574be9d56cc13051$export$cef978c25740de90), classes);
};
const $d0c9a6613cf3e3f5$export$597b7cbdb7b2a24c = /*#__PURE__*/ $exYeM.forwardRef(function PickersArrowSwitcher(inProps, ref) {
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === "rtl";
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiPickersArrowSwitcher"
    });
    const { children: children, className: className, slots: slots, slotProps: slotProps, isNextDisabled: isNextDisabled, isNextHidden: isNextHidden, onGoToNext: onGoToNext, nextLabel: nextLabel, isPreviousDisabled: isPreviousDisabled, isPreviousHidden: isPreviousHidden, onGoToPrevious: onGoToPrevious, previousLabel: previousLabel } = props, other = (0, $3L80X.default)(props, $d0c9a6613cf3e3f5$var$_excluded);
    const ownerState = props;
    const classes = $d0c9a6613cf3e3f5$var$useUtilityClasses(ownerState);
    const nextProps = {
        isDisabled: isNextDisabled,
        isHidden: isNextHidden,
        goTo: onGoToNext,
        label: nextLabel
    };
    const previousProps = {
        isDisabled: isPreviousDisabled,
        isHidden: isPreviousHidden,
        goTo: onGoToPrevious,
        label: previousLabel
    };
    const PreviousIconButton = slots?.previousIconButton ?? $d0c9a6613cf3e3f5$var$PickersArrowSwitcherButton;
    const previousIconButtonProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: PreviousIconButton,
        externalSlotProps: slotProps?.previousIconButton,
        additionalProps: {
            size: "medium",
            title: previousProps.label,
            "aria-label": previousProps.label,
            disabled: previousProps.isDisabled,
            edge: "end",
            onClick: previousProps.goTo
        },
        ownerState: (0, $aJx1R.default)({}, ownerState, {
            hidden: previousProps.isHidden
        }),
        className: classes.button
    });
    const NextIconButton = slots?.nextIconButton ?? $d0c9a6613cf3e3f5$var$PickersArrowSwitcherButton;
    const nextIconButtonProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: NextIconButton,
        externalSlotProps: slotProps?.nextIconButton,
        additionalProps: {
            size: "medium",
            title: nextProps.label,
            "aria-label": nextProps.label,
            disabled: nextProps.isDisabled,
            edge: "start",
            onClick: nextProps.goTo
        },
        ownerState: (0, $aJx1R.default)({}, ownerState, {
            hidden: nextProps.isHidden
        }),
        className: classes.button
    });
    const LeftArrowIcon = slots?.leftArrowIcon ?? (0, $ea58bbb735a57109$export$8afed21ef5c2afa5);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: LeftArrowIcon,
        externalSlotProps: slotProps?.leftArrowIcon,
        additionalProps: {
            fontSize: "inherit"
        },
        ownerState: undefined
    }), leftArrowIconProps = (0, $3L80X.default)(_useSlotProps, $d0c9a6613cf3e3f5$var$_excluded2);
    const RightArrowIcon = slots?.rightArrowIcon ?? (0, $ea58bbb735a57109$export$9ca09caa9c849d9c);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps2 = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: RightArrowIcon,
        externalSlotProps: slotProps?.rightArrowIcon,
        additionalProps: {
            fontSize: "inherit"
        },
        ownerState: undefined
    }), rightArrowIconProps = (0, $3L80X.default)(_useSlotProps2, $d0c9a6613cf3e3f5$var$_excluded3);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($d0c9a6613cf3e3f5$var$PickersArrowSwitcherRoot, (0, $aJx1R.default)({
        ref: ref,
        className: (0, $4qr5a.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)(PreviousIconButton, (0, $aJx1R.default)({}, previousIconButtonProps, {
                children: isRTL ? /*#__PURE__*/ (0, $aSiaI.jsx)(RightArrowIcon, (0, $aJx1R.default)({}, rightArrowIconProps)) : /*#__PURE__*/ (0, $aSiaI.jsx)(LeftArrowIcon, (0, $aJx1R.default)({}, leftArrowIconProps))
            })),
            children ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                component: "span",
                children: children
            }) : /*#__PURE__*/ (0, $aSiaI.jsx)($d0c9a6613cf3e3f5$var$PickersArrowSwitcherSpacer, {
                className: classes.spacer,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)(NextIconButton, (0, $aJx1R.default)({}, nextIconButtonProps, {
                children: isRTL ? /*#__PURE__*/ (0, $aSiaI.jsx)(LeftArrowIcon, (0, $aJx1R.default)({}, leftArrowIconProps)) : /*#__PURE__*/ (0, $aSiaI.jsx)(RightArrowIcon, (0, $aJx1R.default)({}, rightArrowIconProps))
            }))
        ]
    }));
});



var $exYeM = parcelRequire("exYeM");


function $064b27bbd099f1fc$export$923e8cc135843169(month, { disableFuture: disableFuture, maxDate: maxDate, timezone: timezone }) {
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    return $exYeM.useMemo(()=>{
        const now = utils.date(undefined, timezone);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        return !utils.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        utils,
        timezone
    ]);
}
function $064b27bbd099f1fc$export$3b46d38ff4932cf7(month, { disablePast: disablePast, minDate: minDate, timezone: timezone }) {
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    return $exYeM.useMemo(()=>{
        const now = utils.date(undefined, timezone);
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        return !utils.isBefore(firstEnabledMonth, month);
    }, [
        disablePast,
        minDate,
        month,
        utils,
        timezone
    ]);
}
function $064b27bbd099f1fc$export$6aaabc31cb076d17(date, ampm, onChange, selectionState) {
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const meridiemMode = (0, $9509391b55697f91$export$c3352ead7b032236)(date, utils);
    const handleMeridiemChange = $exYeM.useCallback((mode)=>{
        const timeWithMeridiem = date == null ? null : (0, $9509391b55697f91$export$c368d4ff66779998)(date, mode, Boolean(ampm), utils);
        onChange(timeWithMeridiem, selectionState ?? "partial");
    }, [
        ampm,
        date,
        onChange,
        selectionState,
        utils
    ]);
    return {
        meridiemMode: meridiemMode,
        handleMeridiemChange: handleMeridiemChange
    };
}



var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
const $4e62a5ac45715f95$export$457ac4d3a1ad92b4 = (slot)=>(0, $dC5O8.default)("MuiPickersCalendarHeader", slot);
const $4e62a5ac45715f95$export$63db7afb9247cb91 = (0, $kY7HX.default)("MuiPickersCalendarHeader", [
    "root",
    "labelContainer",
    "label",
    "switchViewButton",
    "switchViewIcon"
]);



var $aSiaI = parcelRequire("aSiaI");
const $55a131b4c49c3649$var$_excluded = [
    "slots",
    "slotProps",
    "currentMonth",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onMonthChange",
    "onViewChange",
    "view",
    "reduceAnimations",
    "views",
    "labelId",
    "className",
    "timezone",
    "format"
], $55a131b4c49c3649$var$_excluded2 = [
    "ownerState"
];
const $55a131b4c49c3649$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        labelContainer: [
            "labelContainer"
        ],
        label: [
            "label"
        ],
        switchViewButton: [
            "switchViewButton"
        ],
        switchViewIcon: [
            "switchViewIcon"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $4e62a5ac45715f95$export$457ac4d3a1ad92b4), classes);
};
const $55a131b4c49c3649$var$PickersCalendarHeaderRoot = (0, $jawKn.default)("div", {
    name: "MuiPickersCalendarHeader",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({
    display: "flex",
    alignItems: "center",
    marginTop: 12,
    marginBottom: 4,
    paddingLeft: 24,
    paddingRight: 12,
    // prevent jumping in safari
    maxHeight: 40,
    minHeight: 40
});
const $55a131b4c49c3649$var$PickersCalendarHeaderLabelContainer = (0, $jawKn.default)("div", {
    name: "MuiPickersCalendarHeader",
    slot: "LabelContainer",
    overridesResolver: (_, styles)=>styles.labelContainer
})(({ theme: theme })=>(0, $aJx1R.default)({
        display: "flex",
        overflow: "hidden",
        alignItems: "center",
        cursor: "pointer",
        marginRight: "auto"
    }, theme.typography.body1, {
        fontWeight: theme.typography.fontWeightMedium
    }));
const $55a131b4c49c3649$var$PickersCalendarHeaderLabel = (0, $jawKn.default)("div", {
    name: "MuiPickersCalendarHeader",
    slot: "Label",
    overridesResolver: (_, styles)=>styles.label
})({
    marginRight: 6
});
const $55a131b4c49c3649$var$PickersCalendarHeaderSwitchViewButton = (0, $jawKn.default)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), {
    name: "MuiPickersCalendarHeader",
    slot: "SwitchViewButton",
    overridesResolver: (_, styles)=>styles.switchViewButton
})({
    marginRight: "auto",
    variants: [
        {
            props: {
                view: "year"
            },
            style: {
                [`.${(0, $4e62a5ac45715f95$export$63db7afb9247cb91).switchViewIcon}`]: {
                    transform: "rotate(180deg)"
                }
            }
        }
    ]
});
const $55a131b4c49c3649$var$PickersCalendarHeaderSwitchViewIcon = (0, $jawKn.default)((0, $ea58bbb735a57109$export$ed0fe318cc298673), {
    name: "MuiPickersCalendarHeader",
    slot: "SwitchViewIcon",
    overridesResolver: (_, styles)=>styles.switchViewIcon
})(({ theme: theme })=>({
        willChange: "transform",
        transition: theme.transitions.create("transform"),
        transform: "rotate(0deg)"
    }));
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * - [DateRangeCalendar](https://mui.com/x/react-date-pickers/date-range-calendar/)
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [PickersCalendarHeader API](https://mui.com/x/api/date-pickers/pickers-calendar-header/)
 */ const $55a131b4c49c3649$export$6801ffebb353f473 = /*#__PURE__*/ $exYeM.forwardRef(function PickersCalendarHeader(inProps, ref) {
    const localeText = (0, $58b82a9afc388fa3$export$24fdeaa0f591a73e)();
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiPickersCalendarHeader"
    });
    const { slots: slots, slotProps: slotProps, currentMonth: month, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onViewChange: onViewChange, view: view, reduceAnimations: reduceAnimations, views: views, labelId: labelId, className: className, timezone: timezone, format: format = `${utils.formats.month} ${utils.formats.year}` } = props, other = (0, $3L80X.default)(props, $55a131b4c49c3649$var$_excluded);
    const ownerState = props;
    const classes = $55a131b4c49c3649$var$useUtilityClasses(props);
    const SwitchViewButton = slots?.switchViewButton ?? $55a131b4c49c3649$var$PickersCalendarHeaderSwitchViewButton;
    const switchViewButtonProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: SwitchViewButton,
        externalSlotProps: slotProps?.switchViewButton,
        additionalProps: {
            size: "small",
            "aria-label": localeText.calendarViewSwitchingButtonAriaLabel(view)
        },
        ownerState: ownerState,
        className: classes.switchViewButton
    });
    const SwitchViewIcon = slots?.switchViewIcon ?? $55a131b4c49c3649$var$PickersCalendarHeaderSwitchViewIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: SwitchViewIcon,
        externalSlotProps: slotProps?.switchViewIcon,
        ownerState: undefined,
        className: classes.switchViewIcon
    }), switchViewIconProps = (0, $3L80X.default)(_useSlotProps, $55a131b4c49c3649$var$_excluded2);
    const selectNextMonth = ()=>onMonthChange(utils.addMonths(month, 1), "left");
    const selectPreviousMonth = ()=>onMonthChange(utils.addMonths(month, -1), "right");
    const isNextMonthDisabled = (0, $064b27bbd099f1fc$export$923e8cc135843169)(month, {
        disableFuture: disableFuture,
        maxDate: maxDate,
        timezone: timezone
    });
    const isPreviousMonthDisabled = (0, $064b27bbd099f1fc$export$3b46d38ff4932cf7)(month, {
        disablePast: disablePast,
        minDate: minDate,
        timezone: timezone
    });
    const handleToggleView = ()=>{
        if (views.length === 1 || !onViewChange || disabled) return;
        if (views.length === 2) onViewChange(views.find((el)=>el !== view) || views[0]);
        else {
            // switching only between first 2
            const nextIndexToOpen = views.indexOf(view) !== 0 ? 0 : 1;
            onViewChange(views[nextIndexToOpen]);
        }
    };
    // No need to display more information
    if (views.length === 1 && views[0] === "year") return null;
    const label = utils.formatByString(month, format);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($55a131b4c49c3649$var$PickersCalendarHeaderRoot, (0, $aJx1R.default)({}, other, {
        ownerState: ownerState,
        className: (0, $4qr5a.default)(className, classes.root),
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)($55a131b4c49c3649$var$PickersCalendarHeaderLabelContainer, {
                role: "presentation",
                onClick: handleToggleView,
                ownerState: ownerState,
                "aria-live": "polite",
                className: classes.labelContainer,
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $80babe87e415f49f$export$5262185daf493fee), {
                        reduceAnimations: reduceAnimations,
                        transKey: label,
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)($55a131b4c49c3649$var$PickersCalendarHeaderLabel, {
                            id: labelId,
                            ownerState: ownerState,
                            className: classes.label,
                            children: label
                        })
                    }),
                    views.length > 1 && !disabled && /*#__PURE__*/ (0, $aSiaI.jsx)(SwitchViewButton, (0, $aJx1R.default)({}, switchViewButtonProps, {
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)(SwitchViewIcon, (0, $aJx1R.default)({}, switchViewIconProps))
                    }))
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b8c58e7700914c7f$export$2e2bcd8739ae039), {
                in: view === "day",
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d0c9a6613cf3e3f5$export$597b7cbdb7b2a24c), {
                    slots: slots,
                    slotProps: slotProps,
                    onGoToPrevious: selectPreviousMonth,
                    isPreviousDisabled: isPreviousMonthDisabled,
                    previousLabel: localeText.previousMonth,
                    onGoToNext: selectNextMonth,
                    isNextDisabled: isNextMonthDisabled,
                    nextLabel: localeText.nextMonth
                })
            })
        ]
    }));
});




var $jawKn = parcelRequire("jawKn");

const $d78818d135bdbc3a$export$512b066b8abdfde4 = (0, $jawKn.default)("div")({
    overflow: "hidden",
    width: (0, $5c20cfc7ef711f44$export$ee46b8a74d6c94d3),
    maxHeight: (0, $5c20cfc7ef711f44$export$f2fef360e2df0cb7),
    display: "flex",
    flexDirection: "column",
    margin: "0 auto"
});




var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
const $6ca065108146c6c6$export$da8c2318897a6672 = (slot)=>(0, $dC5O8.default)("MuiDateCalendar", slot);
const $6ca065108146c6c6$export$d0237e2bb9598e8d = (0, $kY7HX.default)("MuiDateCalendar", [
    "root",
    "viewTransitionContainer"
]);






var $aSiaI = parcelRequire("aSiaI");
const $19d545aa2d1a4f7f$var$_excluded = [
    "autoFocus",
    "onViewChange",
    "value",
    "defaultValue",
    "referenceDate",
    "disableFuture",
    "disablePast",
    "onChange",
    "onYearChange",
    "onMonthChange",
    "reduceAnimations",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear",
    "view",
    "views",
    "openTo",
    "className",
    "disabled",
    "readOnly",
    "minDate",
    "maxDate",
    "disableHighlightToday",
    "focusedView",
    "onFocusedViewChange",
    "showDaysOutsideCurrentMonth",
    "fixedWeekNumber",
    "dayOfWeekFormatter",
    "slots",
    "slotProps",
    "loading",
    "renderLoading",
    "displayWeekNumber",
    "yearsPerRow",
    "monthsPerRow",
    "timezone"
];
const $19d545aa2d1a4f7f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        viewTransitionContainer: [
            "viewTransitionContainer"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $6ca065108146c6c6$export$da8c2318897a6672), classes);
};
function $19d545aa2d1a4f7f$var$useDateCalendarDefaultizedProps(props, name) {
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const defaultDates = (0, $58b82a9afc388fa3$export$7c38da3a2e90fa83)();
    const defaultReduceAnimations = (0, $50aff0e6ae9692bf$export$ce40fb97be7f02d9)();
    const themeProps = (0, $7PWLt.default)({
        props: props,
        name: name
    });
    return (0, $aJx1R.default)({}, themeProps, {
        loading: themeProps.loading ?? false,
        disablePast: themeProps.disablePast ?? false,
        disableFuture: themeProps.disableFuture ?? false,
        openTo: themeProps.openTo ?? "day",
        views: themeProps.views ?? [
            "year",
            "day"
        ],
        reduceAnimations: themeProps.reduceAnimations ?? defaultReduceAnimations,
        renderLoading: themeProps.renderLoading ?? (()=>/*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                children: "..."
            })),
        minDate: (0, $8c165bb53d94cf45$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $8c165bb53d94cf45$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $19d545aa2d1a4f7f$var$DateCalendarRoot = (0, $jawKn.default)((0, $d78818d135bdbc3a$export$512b066b8abdfde4), {
    name: "MuiDateCalendar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexDirection: "column",
    height: (0, $5c20cfc7ef711f44$export$f2fef360e2df0cb7)
});
const $19d545aa2d1a4f7f$var$DateCalendarViewTransitionContainer = (0, $jawKn.default)((0, $80babe87e415f49f$export$5262185daf493fee), {
    name: "MuiDateCalendar",
    slot: "ViewTransitionContainer",
    overridesResolver: (props, styles)=>styles.viewTransitionContainer
})({});
const $19d545aa2d1a4f7f$export$68078fe5d2bf8909 = /*#__PURE__*/ $exYeM.forwardRef(function DateCalendar(inProps, ref) {
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const id = (0, $43c7ad0c22f8e14a$export$2e2bcd8739ae039)();
    const props = $19d545aa2d1a4f7f$var$useDateCalendarDefaultizedProps(inProps, "MuiDateCalendar");
    const { autoFocus: autoFocus, onViewChange: onViewChange, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, onChange: onChange, onYearChange: onYearChange, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, view: inView, views: views, openTo: openTo, className: className, disabled: disabled, readOnly: readOnly, minDate: minDate, maxDate: maxDate, disableHighlightToday: disableHighlightToday, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, fixedWeekNumber: fixedWeekNumber, dayOfWeekFormatter: dayOfWeekFormatter, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, displayWeekNumber: displayWeekNumber, yearsPerRow: yearsPerRow, monthsPerRow: monthsPerRow, timezone: timezoneProp } = props, other = (0, $3L80X.default)(props, $19d545aa2d1a4f7f$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $3e4aef0ef80b275d$export$174d749f3b4c0f49)({
        name: "DateCalendar",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $efb258a9c0464e3f$export$2764b246aa3b75ba)
    });
    const { view: view, setView: setView, focusedView: focusedView, setFocusedView: setFocusedView, goToNextView: goToNextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $8d38a40b51f4c4fd$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onChange: handleValueChange,
        onViewChange: onViewChange,
        autoFocus: autoFocus,
        focusedView: inFocusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const { referenceDate: referenceDate, calendarState: calendarState, changeFocusedDay: changeFocusedDay, changeMonth: changeMonth, handleChangeMonth: handleChangeMonth, isDateDisabled: isDateDisabled, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd } = (0, $05f0c4504392a719$export$6d095e787d2b5e1f)({
        value: value,
        referenceDate: referenceDateProp,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    // When disabled, limit the view to the selected date
    const minDateWithDisabled = disabled && value || minDate;
    const maxDateWithDisabled = disabled && value || maxDate;
    const gridLabelId = `${id}-grid-label`;
    const hasFocus = focusedView !== null;
    const CalendarHeader = slots?.calendarHeader ?? (0, $55a131b4c49c3649$export$6801ffebb353f473);
    const calendarHeaderProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: CalendarHeader,
        externalSlotProps: slotProps?.calendarHeader,
        additionalProps: {
            views: views,
            view: view,
            currentMonth: calendarState.currentMonth,
            onViewChange: setView,
            onMonthChange: (newMonth, direction)=>handleChangeMonth({
                    newMonth: newMonth,
                    direction: direction
                }),
            minDate: minDateWithDisabled,
            maxDate: maxDateWithDisabled,
            disabled: disabled,
            disablePast: disablePast,
            disableFuture: disableFuture,
            reduceAnimations: reduceAnimations,
            timezone: timezone,
            labelId: gridLabelId,
            slots: slots,
            slotProps: slotProps
        },
        ownerState: props
    });
    const handleDateMonthChange = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((newDate)=>{
        const startOfMonth = utils.startOfMonth(newDate);
        const endOfMonth = utils.endOfMonth(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $8c165bb53d94cf45$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
            maxDate: utils.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, "finish");
            onMonthChange?.(startOfMonth);
        } else {
            goToNextView();
            changeMonth(startOfMonth);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleDateYearChange = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((newDate)=>{
        const startOfYear = utils.startOfYear(newDate);
        const endOfYear = utils.endOfYear(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $8c165bb53d94cf45$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfYear) ? startOfYear : minDate,
            maxDate: utils.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, "finish");
            onYearChange?.(closestEnabledDate);
        } else {
            goToNextView();
            changeMonth(startOfYear);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleSelectedDayChange = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((day)=>{
        if (day) // If there is a date already selected, then we want to keep its time
        return handleValueChange((0, $8c165bb53d94cf45$export$a98b123b8f29e004)(utils, day, value ?? referenceDate), "finish", view);
        return handleValueChange(day, "finish", view);
    });
    $exYeM.useEffect(()=>{
        if (value != null && utils.isValid(value)) changeMonth(value);
    }, [
        value
    ]); // eslint-disable-line
    const ownerState = props;
    const classes = $19d545aa2d1a4f7f$var$useUtilityClasses(ownerState);
    const baseDateValidationProps = {
        disablePast: disablePast,
        disableFuture: disableFuture,
        maxDate: maxDate,
        minDate: minDate
    };
    const commonViewProps = {
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        timezone: timezone,
        gridLabelId: gridLabelId
    };
    const prevOpenViewRef = $exYeM.useRef(view);
    $exYeM.useEffect(()=>{
        // If the view change and the focus was on the previous view
        // Then we update the focus.
        if (prevOpenViewRef.current === view) return;
        if (focusedView === prevOpenViewRef.current) setFocusedView(view, true);
        prevOpenViewRef.current = view;
    }, [
        focusedView,
        setFocusedView,
        view
    ]);
    const selectedDays = $exYeM.useMemo(()=>[
            value
        ], [
        value
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($19d545aa2d1a4f7f$var$DateCalendarRoot, (0, $aJx1R.default)({
        ref: ref,
        className: (0, $4qr5a.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)(CalendarHeader, (0, $aJx1R.default)({}, calendarHeaderProps)),
            /*#__PURE__*/ (0, $aSiaI.jsx)($19d545aa2d1a4f7f$var$DateCalendarViewTransitionContainer, {
                reduceAnimations: reduceAnimations,
                className: classes.viewTransitionContainer,
                transKey: view,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("div", {
                    children: [
                        view === "year" && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4aaa7676c3db3943$export$657f9200591b2b71), (0, $aJx1R.default)({}, baseDateValidationProps, commonViewProps, {
                            value: value,
                            onChange: handleDateYearChange,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView("year", isViewFocused),
                            yearsPerRow: yearsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === "month" && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1dc4dbb7f7bbc8b6$export$d7a7c85c0f5afc4a), (0, $aJx1R.default)({}, baseDateValidationProps, commonViewProps, {
                            hasFocus: hasFocus,
                            className: className,
                            value: value,
                            onChange: handleDateMonthChange,
                            shouldDisableMonth: shouldDisableMonth,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView("month", isViewFocused),
                            monthsPerRow: monthsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === "day" && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6738f852f3a1e345$export$8fb56b32a5df6314), (0, $aJx1R.default)({}, calendarState, baseDateValidationProps, commonViewProps, {
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            onFocusedDayChange: changeFocusedDay,
                            reduceAnimations: reduceAnimations,
                            selectedDays: selectedDays,
                            onSelectedDaysChange: handleSelectedDayChange,
                            shouldDisableDate: shouldDisableDate,
                            shouldDisableMonth: shouldDisableMonth,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView("day", isViewFocused),
                            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                            fixedWeekNumber: fixedWeekNumber,
                            dayOfWeekFormatter: dayOfWeekFormatter,
                            displayWeekNumber: displayWeekNumber,
                            slots: slots,
                            slotProps: slotProps,
                            loading: loading,
                            renderLoading: renderLoading
                        }))
                    ]
                })
            })
        ]
    }));
});




var $aSiaI = parcelRequire("aSiaI");
const $bcd6cc69a16346cb$export$69888ffe06193e5e = ({ view: view, onViewChange: onViewChange, views: views, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, reduceAnimations: reduceAnimations, onMonthChange: onMonthChange, monthsPerRow: monthsPerRow, onYearChange: onYearChange, yearsPerRow: yearsPerRow, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, disableHighlightToday: disableHighlightToday, readOnly: readOnly, disabled: disabled, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, dayOfWeekFormatter: dayOfWeekFormatter, sx: sx, autoFocus: autoFocus, fixedWeekNumber: fixedWeekNumber, displayWeekNumber: displayWeekNumber, timezone: timezone })=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $19d545aa2d1a4f7f$export$68078fe5d2bf8909), {
        view: view,
        onViewChange: onViewChange,
        views: views.filter((0, $8c165bb53d94cf45$export$b32dfef9f07dea64)),
        focusedView: focusedView && (0, $8c165bb53d94cf45$export$b32dfef9f07dea64)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        monthsPerRow: monthsPerRow,
        onYearChange: onYearChange,
        yearsPerRow: yearsPerRow,
        slots: slots,
        slotProps: slotProps,
        loading: loading,
        renderLoading: renderLoading,
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        dayOfWeekFormatter: dayOfWeekFormatter,
        sx: sx,
        autoFocus: autoFocus,
        fixedWeekNumber: fixedWeekNumber,
        displayWeekNumber: displayWeekNumber,
        timezone: timezone
    });



/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DesktopDatePicker API](https://mui.com/x/api/date-pickers/desktop-date-picker/)
 */ const $063ffb683c7813bf$export$5a73641f0156e1e4 = /*#__PURE__*/ $exYeM.forwardRef(function DesktopDatePicker(inProps, ref) {
    const localeText = (0, $58b82a9afc388fa3$export$24fdeaa0f591a73e)();
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, $54a8b28ce04f6bc0$export$a552c17ed3587731)(inProps, "MuiDesktopDatePicker");
    const viewRenderers = (0, $aJx1R.default)({
        day: (0, $bcd6cc69a16346cb$export$69888ffe06193e5e),
        month: (0, $bcd6cc69a16346cb$export$69888ffe06193e5e),
        year: (0, $bcd6cc69a16346cb$export$69888ffe06193e5e)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the desktop variant
    const props = (0, $aJx1R.default)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $8c165bb53d94cf45$export$bb1c921f313ec928)(utils, defaultizedProps, false),
        yearsPerRow: defaultizedProps.yearsPerRow ?? 4,
        slots: (0, $aJx1R.default)({
            openPickerIcon: (0, $ea58bbb735a57109$export$5fda1783bb83f57b),
            field: (0, $ddb41334d53f26fc$export$d9781c7894a82487)
        }, defaultizedProps.slots),
        slotProps: (0, $aJx1R.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $aJx1R.default)({}, (0, $269e73534f97f715$export$308c24034cde71de)(defaultizedProps.slotProps?.field, ownerState), (0, $b4c6ee3828695005$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                }),
            toolbar: (0, $aJx1R.default)({
                hidden: true
            }, defaultizedProps.slotProps?.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $877e64d9c1b81de9$export$b1b70bc56ac5be0e)({
        props: props,
        valueManager: (0, $efb258a9c0464e3f$export$2764b246aa3b75ba),
        valueType: "date",
        getOpenDialogAriaText: props.localeText?.openDatePickerDialogue ?? localeText.openDatePickerDialogue,
        validator: (0, $b5cc8935c82cecb2$export$ffb3d0046ef3a2)
    });
    return renderPicker();
});
$063ffb683c7813bf$export$5a73641f0156e1e4.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * @default false
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "dense",
        "spacious"
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $5470a96ab2e549fc$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Maximal selectable date.
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Minimal selectable date.
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "day",
        "month",
        "year"
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "landscape",
        "portrait"
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
            "all",
            "day",
            "empty",
            "hours",
            "meridiem",
            "minutes",
            "month",
            "seconds",
            "weekDay",
            "year"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "day",
        "month",
        "year"
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "day",
        "month",
        "year"
    ]).isRequired),
    /**
   * Years rendered per row.
   * @default 4
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        3,
        4
    ])
};



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $bisEj = parcelRequire("bisEj");



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");




var $aJx1R = parcelRequire("aJx1R");
parcelRequire("exYeM");

var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $9a2eab6144751a59$export$61b0ee1f05fb344e(slot) {
    return (0, $dC5O8.default)("MuiDialogContent", slot);
}
const $9a2eab6144751a59$var$dialogContentClasses = (0, $kY7HX.default)("MuiDialogContent", [
    "root",
    "dividers"
]);
var $9a2eab6144751a59$export$2e2bcd8739ae039 = $9a2eab6144751a59$var$dialogContentClasses;



var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $364e478f30577320$export$f5d2ec7e4c47e088(slot) {
    return (0, $dC5O8.default)("MuiDialogTitle", slot);
}
const $364e478f30577320$var$dialogTitleClasses = (0, $kY7HX.default)("MuiDialogTitle", [
    "root"
]);
var $364e478f30577320$export$2e2bcd8739ae039 = $364e478f30577320$var$dialogTitleClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $db43a68763104a7e$var$_excluded = [
    "className",
    "dividers"
];
const $db43a68763104a7e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            "root",
            dividers && "dividers"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $9a2eab6144751a59$export$61b0ee1f05fb344e), classes);
};
const $db43a68763104a7e$var$DialogContentRoot = (0, $jawKn.default)("div", {
    name: "MuiDialogContent",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        flex: "1 1 auto",
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        overflowY: "auto",
        padding: "20px 24px"
    }, ownerState.dividers ? {
        padding: "16px 24px",
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $364e478f30577320$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $db43a68763104a7e$var$DialogContent = /*#__PURE__*/ $exYeM.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiDialogContent"
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $3L80X.default)(props, $db43a68763104a7e$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        dividers: dividers
    });
    const classes = $db43a68763104a7e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($db43a68763104a7e$var$DialogContentRoot, (0, $aJx1R.default)({
        className: (0, $4qr5a.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $db43a68763104a7e$export$2e2bcd8739ae039 = $db43a68763104a7e$var$DialogContent;




var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");


var $fXwzw = parcelRequire("fXwzw");




var $7PWLt = parcelRequire("7PWLt");

var $jawKn = parcelRequire("jawKn");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $d8b574c70a47217a$export$2177af0aa15c34c2(slot) {
    return (0, $dC5O8.default)("MuiDialog", slot);
}
const $d8b574c70a47217a$var$dialogClasses = (0, $kY7HX.default)("MuiDialog", [
    "root",
    "scrollPaper",
    "scrollBody",
    "container",
    "paper",
    "paperScrollPaper",
    "paperScrollBody",
    "paperWidthFalse",
    "paperWidthXs",
    "paperWidthSm",
    "paperWidthMd",
    "paperWidthLg",
    "paperWidthXl",
    "paperFullWidth",
    "paperFullScreen"
]);
var $d8b574c70a47217a$export$2e2bcd8739ae039 = $d8b574c70a47217a$var$dialogClasses;



var $exYeM = parcelRequire("exYeM");
const $5b6ad8b1de22f5e0$var$DialogContext = /*#__PURE__*/ $exYeM.createContext({});
var $5b6ad8b1de22f5e0$export$2e2bcd8739ae039 = $5b6ad8b1de22f5e0$var$DialogContext;





var $aSiaI = parcelRequire("aSiaI");
"use client";
const $1a438903cf5e3275$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $1a438903cf5e3275$var$DialogBackdrop = (0, $jawKn.default)((0, $1bb3b0214ed923c7$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Backdrop",
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $1a438903cf5e3275$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container",
            `scroll${(0, $fXwzw.default)(scroll)}`
        ],
        paper: [
            "paper",
            `paperScroll${(0, $fXwzw.default)(scroll)}`,
            `paperWidth${(0, $fXwzw.default)(String(maxWidth))}`,
            fullWidth && "paperFullWidth",
            fullScreen && "paperFullScreen"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $d8b574c70a47217a$export$2177af0aa15c34c2), classes);
};
const $1a438903cf5e3275$var$DialogRoot = (0, $jawKn.default)((0, $99d9e21ea1255c01$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
    }
});
const $1a438903cf5e3275$var$DialogContainer = (0, $jawKn.default)("div", {
    name: "MuiDialog",
    slot: "Container",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $fXwzw.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $aJx1R.default)({
        height: "100%",
        "@media print": {
            height: "auto"
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === "paper" && {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.scroll === "body" && {
        overflowY: "auto",
        overflowX: "hidden",
        textAlign: "center",
        "&::after": {
            content: '""',
            display: "inline-block",
            verticalAlign: "middle",
            height: "100%",
            width: "0"
        }
    }));
const $1a438903cf5e3275$var$DialogPaper = (0, $jawKn.default)((0, $e479e3bd14e95ba2$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $fXwzw.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $fXwzw.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        margin: 32,
        position: "relative",
        overflowY: "auto",
        // Fix IE11 issue, to remove at some point.
        "@media print": {
            overflowY: "visible",
            boxShadow: "none"
        }
    }, ownerState.scroll === "paper" && {
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100% - 64px)"
    }, ownerState.scroll === "body" && {
        display: "inline-block",
        verticalAlign: "middle",
        textAlign: "left" // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: "calc(100% - 64px)"
    }, ownerState.maxWidth === "xs" && {
        maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $d8b574c70a47217a$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== "xs" && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $d8b574c70a47217a$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.fullWidth && {
        width: "calc(100% - 64px)"
    }, ownerState.fullScreen && {
        margin: 0,
        width: "100%",
        maxWidth: "100%",
        height: "100%",
        maxHeight: "none",
        borderRadius: 0,
        [`&.${(0, $d8b574c70a47217a$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: "100%"
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $1a438903cf5e3275$var$Dialog = /*#__PURE__*/ $exYeM.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiDialog"
    });
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { "aria-describedby": ariaDescribedby, "aria-labelledby": ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = "sm", onBackdropClick: onBackdropClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $e479e3bd14e95ba2$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = "paper", TransitionComponent: TransitionComponent = (0, $b8c58e7700914c7f$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $3L80X.default)(props, $1a438903cf5e3275$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $1a438903cf5e3275$var$useUtilityClasses(ownerState);
    const backdropClick = $exYeM.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const ariaLabelledby = (0, $43c7ad0c22f8e14a$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $exYeM.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($1a438903cf5e3275$var$DialogRoot, (0, $aJx1R.default)({
        className: (0, $4qr5a.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $1a438903cf5e3275$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $aJx1R.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)(TransitionComponent, (0, $aJx1R.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $aSiaI.jsx)($1a438903cf5e3275$var$DialogContainer, {
                className: (0, $4qr5a.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $aSiaI.jsx)($1a438903cf5e3275$var$DialogPaper, (0, $aJx1R.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $4qr5a.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $5b6ad8b1de22f5e0$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $1a438903cf5e3275$export$2e2bcd8739ae039 = $1a438903cf5e3275$var$Dialog;



var $jawKn = parcelRequire("jawKn");


var $aSiaI = parcelRequire("aSiaI");
const $86445d93f2b7cf6a$var$PickersModalDialogRoot = (0, $jawKn.default)((0, $1a438903cf5e3275$export$2e2bcd8739ae039))({
    [`& .${(0, $d8b574c70a47217a$export$2e2bcd8739ae039).container}`]: {
        outline: 0
    },
    [`& .${(0, $d8b574c70a47217a$export$2e2bcd8739ae039).paper}`]: {
        outline: 0,
        minWidth: (0, $5c20cfc7ef711f44$export$ee46b8a74d6c94d3)
    }
});
const $86445d93f2b7cf6a$var$PickersModalDialogContent = (0, $jawKn.default)((0, $db43a68763104a7e$export$2e2bcd8739ae039))({
    "&:first-of-type": {
        padding: 0
    }
});
function $86445d93f2b7cf6a$export$99f83c99e1491f77(props) {
    const { children: children, onDismiss: onDismiss, open: open, slots: slots, slotProps: slotProps } = props;
    const Dialog = slots?.dialog ?? $86445d93f2b7cf6a$var$PickersModalDialogRoot;
    const Transition = slots?.mobileTransition ?? (0, $b8c58e7700914c7f$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $aSiaI.jsx)(Dialog, (0, $aJx1R.default)({
        open: open,
        onClose: onDismiss
    }, slotProps?.dialog, {
        TransitionComponent: Transition,
        TransitionProps: slotProps?.mobileTransition,
        PaperComponent: slots?.mobilePaper,
        PaperProps: slotProps?.mobilePaper,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($86445d93f2b7cf6a$var$PickersModalDialogContent, {
            children: children
        })
    }));
}








var $aSiaI = parcelRequire("aSiaI");
const $352170f33fa9a6ec$var$_excluded = [
    "props",
    "getOpenDialogAriaText"
];
const $352170f33fa9a6ec$export$5ca0153a626a7dd7 = (_ref)=>{
    let { props: props, getOpenDialogAriaText: getOpenDialogAriaText } = _ref, pickerParams = (0, $3L80X.default)(_ref, $352170f33fa9a6ec$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure, selectedSections: selectedSections, onSelectedSectionsChange: onSelectedSectionsChange, timezone: timezone, name: name, label: label, inputRef: inputRef, readOnly: readOnly, disabled: disabled, localeText: localeText } = props;
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const fieldRef = $exYeM.useRef(null);
    const labelId = (0, $43c7ad0c22f8e14a$export$2e2bcd8739ae039)();
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const { open: open, actions: actions, layoutProps: layoutProps, renderCurrentView: renderCurrentView, fieldProps: pickerFieldProps } = (0, $fe214b73a0b4d59a$export$fc3313977ac596c4)((0, $aJx1R.default)({}, pickerParams, {
        props: props,
        fieldRef: fieldRef,
        autoFocusView: true,
        additionalViewProps: {},
        wrapperVariant: "mobile"
    }));
    const Field = slots.field;
    const fieldProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: (0, $aJx1R.default)({}, pickerFieldProps, isToolbarHidden && {
            id: labelId
        }, !(disabled || readOnly) && {
            onClick: actions.onOpen,
            onKeyDown: (0, $b335fe84785961a2$export$4467fe8634707c85)(actions.onOpen)
        }, {
            readOnly: readOnly ?? true,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            selectedSections: selectedSections,
            onSelectedSectionsChange: onSelectedSectionsChange,
            timezone: timezone,
            label: label,
            name: name
        }, inputRef ? {
            inputRef: inputRef
        } : {}),
        ownerState: props
    });
    // TODO: Move to `useSlotProps` when https://github.com/mui/material-ui/pull/35088 will be merged
    fieldProps.inputProps = (0, $aJx1R.default)({}, fieldProps.inputProps, {
        "aria-label": getOpenDialogAriaText(pickerFieldProps.value, utils)
    });
    const slotsForField = (0, $aJx1R.default)({
        textField: slots.textField
    }, fieldProps.slots);
    const Layout = slots.layout ?? (0, $29c3cc0dfa80590a$export$647f604ea2397c05);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $aJx1R.default)({}, innerSlotProps, {
        toolbar: (0, $aJx1R.default)({}, innerSlotProps?.toolbar, {
            titleId: labelId
        }),
        mobilePaper: (0, $aJx1R.default)({
            "aria-labelledby": labelledById
        }, innerSlotProps?.mobilePaper)
    });
    const handleFieldRef = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(fieldRef, fieldProps.unstableFieldRef);
    const renderPicker = ()=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $24be003479f5f381$export$dc45bdc734ce6f1e), {
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)(Field, (0, $aJx1R.default)({}, fieldProps, {
                    slots: slotsForField,
                    slotProps: slotProps,
                    unstableFieldRef: handleFieldRef
                })),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $86445d93f2b7cf6a$export$99f83c99e1491f77), (0, $aJx1R.default)({}, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)(Layout, (0, $aJx1R.default)({}, layoutProps, slotProps?.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};










/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileDatePicker API](https://mui.com/x/api/date-pickers/mobile-date-picker/)
 */ const $49296a566368fcb5$export$97b476d7a92fee62 = /*#__PURE__*/ $exYeM.forwardRef(function MobileDatePicker(inProps, ref) {
    const localeText = (0, $58b82a9afc388fa3$export$24fdeaa0f591a73e)();
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, $54a8b28ce04f6bc0$export$a552c17ed3587731)(inProps, "MuiMobileDatePicker");
    const viewRenderers = (0, $aJx1R.default)({
        day: (0, $bcd6cc69a16346cb$export$69888ffe06193e5e),
        month: (0, $bcd6cc69a16346cb$export$69888ffe06193e5e),
        year: (0, $bcd6cc69a16346cb$export$69888ffe06193e5e)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the mobile variant
    const props = (0, $aJx1R.default)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $8c165bb53d94cf45$export$bb1c921f313ec928)(utils, defaultizedProps, false),
        slots: (0, $aJx1R.default)({
            field: (0, $ddb41334d53f26fc$export$d9781c7894a82487)
        }, defaultizedProps.slots),
        slotProps: (0, $aJx1R.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $aJx1R.default)({}, (0, $269e73534f97f715$export$308c24034cde71de)(defaultizedProps.slotProps?.field, ownerState), (0, $b4c6ee3828695005$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                }),
            toolbar: (0, $aJx1R.default)({
                hidden: false
            }, defaultizedProps.slotProps?.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $352170f33fa9a6ec$export$5ca0153a626a7dd7)({
        props: props,
        valueManager: (0, $efb258a9c0464e3f$export$2764b246aa3b75ba),
        valueType: "date",
        getOpenDialogAriaText: props.localeText?.openDatePickerDialogue ?? localeText.openDatePickerDialogue,
        validator: (0, $b5cc8935c82cecb2$export$ffb3d0046ef3a2)
    });
    return renderPicker();
});
$49296a566368fcb5$export$97b476d7a92fee62.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * @default false
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "dense",
        "spacious"
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $5470a96ab2e549fc$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Maximal selectable date.
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Minimal selectable date.
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "day",
        "month",
        "year"
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "landscape",
        "portrait"
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
            "all",
            "day",
            "empty",
            "hours",
            "meridiem",
            "minutes",
            "month",
            "seconds",
            "weekDay",
            "year"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "day",
        "month",
        "year"
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "day",
        "month",
        "year"
    ]).isRequired),
    /**
   * Years rendered per row.
   * @default 3
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        3,
        4
    ])
};




var $aSiaI = parcelRequire("aSiaI");
const $989344a514e036e4$var$_excluded = [
    "desktopModeMediaQuery"
];
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DatePicker API](https://mui.com/x/api/date-pickers/date-picker/)
 */ const $989344a514e036e4$export$5109c6dd95d8fb00 = /*#__PURE__*/ $exYeM.forwardRef(function DatePicker(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiDatePicker"
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = (0, $b335fe84785961a2$export$9ae5b19305db48ce) } = props, other = (0, $3L80X.default)(props, $989344a514e036e4$var$_excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $584e1e930413ffa8$export$2e2bcd8739ae039)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $063ffb683c7813bf$export$5a73641f0156e1e4), (0, $aJx1R.default)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $49296a566368fcb5$export$97b476d7a92fee62), (0, $aJx1R.default)({
        ref: ref
    }, other));
});



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");



var $7PWLt = parcelRequire("7PWLt");


var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");

var $bisEj = parcelRequire("bisEj");



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $8L988 = parcelRequire("8L988");

var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");


var $aSiaI = parcelRequire("aSiaI");
"use client";
const $a59c125ed1ac1385$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $a59c125ed1ac1385$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            absolute && "absolute",
            variant,
            light && "light",
            orientation === "vertical" && "vertical",
            flexItem && "flexItem",
            children && "withChildren",
            children && orientation === "vertical" && "withChildrenVertical",
            textAlign === "right" && orientation !== "vertical" && "textAlignRight",
            textAlign === "left" && orientation !== "vertical" && "textAlignLeft"
        ],
        wrapper: [
            "wrapper",
            orientation === "vertical" && "wrapperVertical"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $cc7e41c75876879f$export$46f01d01378ec5a2), classes);
};
const $a59c125ed1ac1385$var$DividerRoot = (0, $jawKn.default)("div", {
    name: "MuiDivider",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === "vertical" && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === "vertical" && styles.withChildrenVertical,
            ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && styles.textAlignRight,
            ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: "solid",
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: "thin"
    }, ownerState.absolute && {
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%"
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $8L988.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === "inset" && {
        marginLeft: 72
    }, ownerState.variant === "middle" && ownerState.orientation === "horizontal" && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === "middle" && ownerState.orientation === "vertical" && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === "vertical" && {
        height: "100%",
        borderBottomWidth: 0,
        borderRightWidth: "thin"
    }, ownerState.flexItem && {
        alignSelf: "stretch",
        height: "auto"
    }), ({ ownerState: ownerState })=>(0, $aJx1R.default)({}, ownerState.children && {
        display: "flex",
        whiteSpace: "nowrap",
        textAlign: "center",
        border: 0,
        "&::before, &::after": {
            content: '""',
            alignSelf: "center"
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({}, ownerState.children && ownerState.orientation !== "vertical" && {
        "&::before, &::after": {
            width: "100%",
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({}, ownerState.children && ownerState.orientation === "vertical" && {
        flexDirection: "column",
        "&::before, &::after": {
            height: "100%",
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ ownerState: ownerState })=>(0, $aJx1R.default)({}, ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "90%"
        },
        "&::after": {
            width: "10%"
        }
    }, ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "10%"
        },
        "&::after": {
            width: "90%"
        }
    }));
const $a59c125ed1ac1385$var$DividerWrapper = (0, $jawKn.default)("span", {
    name: "MuiDivider",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === "vertical" && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        display: "inline-block",
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === "vertical" && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $a59c125ed1ac1385$var$Divider = /*#__PURE__*/ $exYeM.forwardRef(function Divider(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiDivider"
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? "div" : "hr", flexItem: flexItem = false, light: light = false, orientation: orientation = "horizontal", role: role = component !== "hr" ? "separator" : undefined, textAlign: textAlign = "center", variant: variant = "fullWidth" } = props, other = (0, $3L80X.default)(props, $a59c125ed1ac1385$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $a59c125ed1ac1385$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($a59c125ed1ac1385$var$DividerRoot, (0, $aJx1R.default)({
        as: component,
        className: (0, $4qr5a.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $aSiaI.jsx)($a59c125ed1ac1385$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $a59c125ed1ac1385$var$Divider.muiSkipListHighlight = true;
var $a59c125ed1ac1385$export$2e2bcd8739ae039 = $a59c125ed1ac1385$var$Divider;




var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");



var $7PWLt = parcelRequire("7PWLt");






const $f095ffad38756cf8$export$7bd013ac69eb590c = ({ adapter: adapter, value: value, props: props })=>{
    if (value === null) return null;
    const { minTime: minTime, maxTime: maxTime, minutesStep: minutesStep, shouldDisableTime: shouldDisableTime, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, disablePast: disablePast, disableFuture: disableFuture, timezone: timezone } = props;
    const now = adapter.utils.date(undefined, timezone);
    const isAfter = (0, $9509391b55697f91$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, adapter.utils);
    switch(true){
        case !adapter.utils.isValid(value):
            return "invalidDate";
        case Boolean(minTime && isAfter(minTime, value)):
            return "minTime";
        case Boolean(maxTime && isAfter(value, maxTime)):
            return "maxTime";
        case Boolean(disableFuture && adapter.utils.isAfter(value, now)):
            return "disableFuture";
        case Boolean(disablePast && adapter.utils.isBefore(value, now)):
            return "disablePast";
        case Boolean(shouldDisableTime && shouldDisableTime(value, "hours")):
            return "shouldDisableTime-hours";
        case Boolean(shouldDisableTime && shouldDisableTime(value, "minutes")):
            return "shouldDisableTime-minutes";
        case Boolean(shouldDisableTime && shouldDisableTime(value, "seconds")):
            return "shouldDisableTime-seconds";
        case Boolean(minutesStep && adapter.utils.getMinutes(value) % minutesStep !== 0):
            return "minutesStep";
        default:
            return null;
    }
};


const $c54e76c05355c08e$export$ed94a8ff1f54c4f = ({ props: props, value: value, adapter: adapter })=>{
    const dateValidationResult = (0, $b5cc8935c82cecb2$export$ffb3d0046ef3a2)({
        adapter: adapter,
        value: value,
        props: props
    });
    if (dateValidationResult !== null) return dateValidationResult;
    return (0, $f095ffad38756cf8$export$7bd013ac69eb590c)({
        adapter: adapter,
        value: value,
        props: props
    });
};




const $795bc665e9851735$export$2c2e7f1ceedfa8fa = (inProps)=>{
    const props = (0, $88316b2eb4f82d5f$export$ae5b8d06aeae1db3)(inProps);
    const { forwardedProps: forwardedProps, internalProps: internalProps } = (0, $853af466154b1a1f$export$cdde224d2939fd84)(props, "date-time");
    return (0, $7690ea9019a90c7e$export$294aa081a6c6f55d)({
        forwardedProps: forwardedProps,
        internalProps: internalProps,
        valueManager: (0, $efb258a9c0464e3f$export$2764b246aa3b75ba),
        fieldValueManager: (0, $efb258a9c0464e3f$export$b602c94f557316b4),
        validator: (0, $c54e76c05355c08e$export$ed94a8ff1f54c4f),
        valueType: "date-time"
    });
};






var $aSiaI = parcelRequire("aSiaI");
const $47a45eb129c83cdf$var$_excluded = [
    "slots",
    "slotProps",
    "InputProps",
    "inputProps"
];
/**
 * Demos:
 *
 * - [DateTimeField](http://mui.com/x/react-date-pickers/date-time-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [DateTimeField API](https://mui.com/x/api/date-pickers/date-time-field/)
 */ const $47a45eb129c83cdf$export$ae1ced156568f0b0 = /*#__PURE__*/ $exYeM.forwardRef(function DateTimeField(inProps, inRef) {
    const themeProps = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiDateTimeField"
    });
    const { slots: slots, slotProps: slotProps, InputProps: InputProps, inputProps: inputProps } = themeProps, other = (0, $3L80X.default)(themeProps, $47a45eb129c83cdf$var$_excluded);
    const ownerState = themeProps;
    const TextField = slots?.textField ?? (inProps.enableAccessibleFieldDOMStructure ? (0, $84f942149d3b2e85$export$b3e9b101d92e4d4d) : (0, $18a733eef46a7fb6$export$2e2bcd8739ae039));
    const textFieldProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: TextField,
        externalSlotProps: slotProps?.textField,
        externalForwardedProps: other,
        ownerState: ownerState,
        additionalProps: {
            ref: inRef
        }
    });
    // TODO: Remove when mui/material-ui#35088 will be merged
    textFieldProps.inputProps = (0, $aJx1R.default)({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = (0, $aJx1R.default)({}, InputProps, textFieldProps.InputProps);
    const fieldResponse = (0, $795bc665e9851735$export$2c2e7f1ceedfa8fa)(textFieldProps);
    const convertedFieldResponse = (0, $b9597e90c73e1a8f$export$20bf15d9b24b4dad)(fieldResponse);
    const processedFieldProps = (0, $2933e748b8e88f5f$export$db9644cdb7e3d432)((0, $aJx1R.default)({}, convertedFieldResponse, {
        slots: slots,
        slotProps: slotProps
    }));
    return /*#__PURE__*/ (0, $aSiaI.jsx)(TextField, (0, $aJx1R.default)({}, processedFieldProps));
});



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $7PWLt = parcelRequire("7PWLt");



var $exYeM = parcelRequire("exYeM");

var $4qr5a = parcelRequire("4qr5a");




var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $2f0D3 = parcelRequire("2f0D3");



var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
function $abebc2a4dc59b6fc$export$c994a6b377ce38df(slot) {
    return (0, $dC5O8.default)("MuiDateTimePickerTabs", slot);
}
const $abebc2a4dc59b6fc$export$a2a6922f6f97d267 = (0, $kY7HX.default)("MuiDateTimePickerTabs", [
    "root"
]);




var $aSiaI = parcelRequire("aSiaI");
const $6cd754d9a5d0f13e$var$viewToTab = (view)=>{
    if ((0, $8c165bb53d94cf45$export$b32dfef9f07dea64)(view)) return "date";
    return "time";
};
const $6cd754d9a5d0f13e$var$tabToView = (tab)=>{
    if (tab === "date") return "day";
    return "hours";
};
const $6cd754d9a5d0f13e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $abebc2a4dc59b6fc$export$c994a6b377ce38df), classes);
};
const $6cd754d9a5d0f13e$var$DateTimePickerTabsRoot = (0, $jawKn.default)((0, $c92bb10ff1efdcba$export$2e2bcd8739ae039), {
    name: "MuiDateTimePickerTabs",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        boxShadow: `0 -1px 0 0 inset ${(theme.vars || theme).palette.divider}`,
        "&:last-child": {
            boxShadow: `0 1px 0 0 inset ${(theme.vars || theme).palette.divider}`,
            [`& .${(0, $27be272ccbc55083$export$2e2bcd8739ae039).indicator}`]: {
                bottom: "auto",
                top: 0
            }
        }
    }));
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [DateTimePickerTabs API](https://mui.com/x/api/date-pickers/date-time-picker-tabs/)
 */ const $6cd754d9a5d0f13e$export$95dfad4074502244 = function DateTimePickerTabs(inProps) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiDateTimePickerTabs"
    });
    const { dateIcon: dateIcon = /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ea58bbb735a57109$export$90a8eab2a2411720), {}), onViewChange: onViewChange, timeIcon: timeIcon = /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ea58bbb735a57109$export$7e95adcf912503e3), {}), view: view, hidden: hidden = typeof window === "undefined" || window.innerHeight < 667, className: className, sx: sx } = props;
    const localeText = (0, $58b82a9afc388fa3$export$24fdeaa0f591a73e)();
    const classes = $6cd754d9a5d0f13e$var$useUtilityClasses(props);
    const handleChange = (event, value)=>{
        onViewChange($6cd754d9a5d0f13e$var$tabToView(value));
    };
    if (hidden) return null;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($6cd754d9a5d0f13e$var$DateTimePickerTabsRoot, {
        ownerState: props,
        variant: "fullWidth",
        value: $6cd754d9a5d0f13e$var$viewToTab(view),
        onChange: handleChange,
        className: (0, $4qr5a.default)(className, classes.root),
        sx: sx,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8db679d8467240be$export$2e2bcd8739ae039), {
                value: "date",
                "aria-label": localeText.dateTableLabel,
                icon: /*#__PURE__*/ (0, $aSiaI.jsx)($exYeM.Fragment, {
                    children: dateIcon
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8db679d8467240be$export$2e2bcd8739ae039), {
                value: "time",
                "aria-label": localeText.timeTableLabel,
                icon: /*#__PURE__*/ (0, $aSiaI.jsx)($exYeM.Fragment, {
                    children: timeIcon
                })
            })
        ]
    });
};



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $bisEj = parcelRequire("bisEj");

var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $2f0D3 = parcelRequire("2f0D3");

var $4qr5a = parcelRequire("4qr5a");

var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");

var $4qr5a = parcelRequire("4qr5a");


var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $2f0D3 = parcelRequire("2f0D3");

var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
function $447fb94fc0493ad3$export$2aab7addfa1bc589(slot) {
    return (0, $dC5O8.default)("MuiPickersToolbarText", slot);
}
const $447fb94fc0493ad3$export$4ca7b92014bf2e56 = (0, $kY7HX.default)("MuiPickersToolbarText", [
    "root",
    "selected"
]);



var $aSiaI = parcelRequire("aSiaI");
const $59ab981dcb971055$var$_excluded = [
    "className",
    "selected",
    "value"
];
const $59ab981dcb971055$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $447fb94fc0493ad3$export$2aab7addfa1bc589), classes);
};
const $59ab981dcb971055$var$PickersToolbarTextRoot = (0, $jawKn.default)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
    name: "MuiPickersToolbarText",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $447fb94fc0493ad3$export$4ca7b92014bf2e56).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>({
        transition: theme.transitions.create("color"),
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $447fb94fc0493ad3$export$4ca7b92014bf2e56).selected}`]: {
            color: (theme.vars || theme).palette.text.primary
        }
    }));
const $59ab981dcb971055$export$2006bc630443fa2 = /*#__PURE__*/ $exYeM.forwardRef(function PickersToolbarText(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiPickersToolbarText"
    });
    const { className: className, value: value } = props, other = (0, $3L80X.default)(props, $59ab981dcb971055$var$_excluded);
    const classes = $59ab981dcb971055$var$useUtilityClasses(props);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($59ab981dcb971055$var$PickersToolbarTextRoot, (0, $aJx1R.default)({
        ref: ref,
        className: (0, $4qr5a.default)(className, classes.root),
        component: "span"
    }, other, {
        children: value
    }));
});




var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");

var $4qr5a = parcelRequire("4qr5a");


var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $2f0D3 = parcelRequire("2f0D3");



var $aSiaI = parcelRequire("aSiaI");
const $35c12ca1dd6a73cd$var$_excluded = [
    "align",
    "className",
    "selected",
    "typographyClassName",
    "value",
    "variant",
    "width"
];
const $35c12ca1dd6a73cd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $c35a1ad7fd186900$export$b109c489973c3d80), classes);
};
const $35c12ca1dd6a73cd$var$PickersToolbarButtonRoot = (0, $jawKn.default)((0, $980dfff3cab72cf4$export$2e2bcd8739ae039), {
    name: "MuiPickersToolbarButton",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({
    padding: 0,
    minWidth: 16,
    textTransform: "none"
});
const $35c12ca1dd6a73cd$export$614ed940168c780c = /*#__PURE__*/ $exYeM.forwardRef(function PickersToolbarButton(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiPickersToolbarButton"
    });
    const { align: align, className: className, selected: selected, typographyClassName: typographyClassName, value: value, variant: variant, width: width } = props, other = (0, $3L80X.default)(props, $35c12ca1dd6a73cd$var$_excluded);
    const classes = $35c12ca1dd6a73cd$var$useUtilityClasses(props);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($35c12ca1dd6a73cd$var$PickersToolbarButtonRoot, (0, $aJx1R.default)({
        variant: "text",
        ref: ref,
        className: (0, $4qr5a.default)(className, classes.root)
    }, width ? {
        sx: {
            width: width
        }
    } : {}, other, {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $59ab981dcb971055$export$2006bc630443fa2), {
            align: align,
            className: typographyClassName,
            variant: variant,
            value: value,
            selected: selected
        })
    }));
});




var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
function $031cc7319d935a2b$export$c40f5731216f0c9d(slot) {
    return (0, $dC5O8.default)("MuiDateTimePickerToolbar", slot);
}
const $031cc7319d935a2b$export$82ac739c3153ffd4 = (0, $kY7HX.default)("MuiDateTimePickerToolbar", [
    "root",
    "dateContainer",
    "timeContainer",
    "timeDigitsContainer",
    "separator",
    "timeLabelReverse",
    "ampmSelection",
    "ampmLandscape",
    "ampmLabel"
]);








var $aSiaI = parcelRequire("aSiaI");
const $32acbb918edd3fd5$var$_excluded = [
    "ampm",
    "ampmInClock",
    "value",
    "onChange",
    "view",
    "isLandscape",
    "onViewChange",
    "toolbarFormat",
    "toolbarPlaceholder",
    "views",
    "disabled",
    "readOnly",
    "toolbarVariant",
    "toolbarTitle",
    "className"
];
const $32acbb918edd3fd5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, theme: theme, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        dateContainer: [
            "dateContainer"
        ],
        timeContainer: [
            "timeContainer",
            theme.direction === "rtl" && "timeLabelReverse"
        ],
        timeDigitsContainer: [
            "timeDigitsContainer",
            theme.direction === "rtl" && "timeLabelReverse"
        ],
        separator: [
            "separator"
        ],
        ampmSelection: [
            "ampmSelection",
            isLandscape && "ampmLandscape"
        ],
        ampmLabel: [
            "ampmLabel"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $031cc7319d935a2b$export$c40f5731216f0c9d), classes);
};
const $32acbb918edd3fd5$var$DateTimePickerToolbarRoot = (0, $jawKn.default)((0, $63224012835b0abe$export$eb3c4d84783d6feb), {
    name: "MuiDateTimePickerToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        paddingLeft: 16,
        paddingRight: 16,
        justifyContent: "space-around",
        position: "relative",
        variants: [
            {
                props: {
                    toolbarVariant: "desktop"
                },
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    [`& .${(0, $c35a1ad7fd186900$export$59f09e5e2b3d9913).content} .${(0, $447fb94fc0493ad3$export$4ca7b92014bf2e56).selected}`]: {
                        color: (theme.vars || theme).palette.primary.main,
                        fontWeight: theme.typography.fontWeightBold
                    }
                }
            },
            {
                props: {
                    toolbarVariant: "desktop",
                    isLandscape: true
                },
                style: {
                    borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    toolbarVariant: "desktop",
                    isLandscape: false
                },
                style: {
                    paddingLeft: 24,
                    paddingRight: 0
                }
            }
        ]
    }));
$32acbb918edd3fd5$var$DateTimePickerToolbarRoot.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    as: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).elementType,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    isLandscape: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool.isRequired,
    isMobileKeyboardViewOpen: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    landscapeDirection: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "column",
        "row"
    ]),
    ownerState: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object.isRequired,
    sx: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object
    ]),
    toggleMobileKeyboardView: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    toolbarTitle: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).node,
    viewType: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "date",
        "time"
    ])
};
const $32acbb918edd3fd5$var$DateTimePickerToolbarDateContainer = (0, $jawKn.default)("div", {
    name: "MuiDateTimePickerToolbar",
    slot: "DateContainer",
    overridesResolver: (props, styles)=>styles.dateContainer
})({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
});
const $32acbb918edd3fd5$var$DateTimePickerToolbarTimeContainer = (0, $jawKn.default)("div", {
    name: "MuiDateTimePickerToolbar",
    slot: "TimeContainer",
    overridesResolver: (props, styles)=>styles.timeContainer
})(({ theme: theme })=>{
    return (0, $aJx1R.default)({
        display: "flex",
        flexDirection: "row"
    }, theme.direction === "rtl" && {
        flexDirection: "row-reverse"
    }, {
        variants: [
            {
                props: ({ isLandscape: isLandscape, toolbarVariant: toolbarVariant })=>isLandscape && toolbarVariant !== "desktop",
                style: (0, $aJx1R.default)({
                    flexDirection: "column"
                }, theme.direction === "rtl" && {
                    flexDirection: "column-reverse"
                })
            },
            {
                props: {
                    toolbarVariant: "desktop",
                    isLandscape: false
                },
                style: {
                    gap: 9,
                    marginRight: 4,
                    alignSelf: "flex-end"
                }
            }
        ]
    });
});
const $32acbb918edd3fd5$var$DateTimePickerToolbarTimeDigitsContainer = (0, $jawKn.default)("div", {
    name: "MuiDateTimePickerToolbar",
    slot: "TimeDigitsContainer",
    overridesResolver: (props, styles)=>styles.timeDigitsContainer
})(({ theme: theme })=>(0, $aJx1R.default)({
        display: "flex"
    }, theme.direction === "rtl" && {
        flexDirection: "row-reverse"
    }, {
        variants: [
            {
                props: {
                    toolbarVariant: "desktop"
                },
                style: {
                    gap: 1.5
                }
            }
        ]
    }));
$32acbb918edd3fd5$var$DateTimePickerToolbarTimeContainer.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    as: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).elementType,
    ownerState: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object.isRequired,
    sx: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object
    ])
};
const $32acbb918edd3fd5$var$DateTimePickerToolbarSeparator = (0, $jawKn.default)((0, $59ab981dcb971055$export$2006bc630443fa2), {
    name: "MuiDateTimePickerToolbar",
    slot: "Separator",
    overridesResolver: (props, styles)=>styles.separator
})({
    margin: "0 4px 0 2px",
    cursor: "default",
    variants: [
        {
            props: {
                toolbarVariant: "desktop"
            },
            style: {
                margin: 0
            }
        }
    ]
});
// Taken from TimePickerToolbar
const $32acbb918edd3fd5$var$DateTimePickerToolbarAmPmSelection = (0, $jawKn.default)("div", {
    name: "MuiDateTimePickerToolbar",
    slot: "AmPmSelection",
    overridesResolver: (props, styles)=>[
            {
                [`.${(0, $031cc7319d935a2b$export$82ac739c3153ffd4).ampmLabel}`]: styles.ampmLabel
            },
            {
                [`&.${(0, $031cc7319d935a2b$export$82ac739c3153ffd4).ampmLandscape}`]: styles.ampmLandscape
            },
            styles.ampmSelection
        ]
})({
    display: "flex",
    flexDirection: "column",
    marginRight: "auto",
    marginLeft: 12,
    [`& .${(0, $031cc7319d935a2b$export$82ac739c3153ffd4).ampmLabel}`]: {
        fontSize: 17
    },
    variants: [
        {
            props: {
                isLandscape: true
            },
            style: {
                margin: "4px 0 auto",
                flexDirection: "row",
                justifyContent: "space-around",
                width: "100%"
            }
        }
    ]
});
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Custom components](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [DateTimePickerToolbar API](https://mui.com/x/api/date-pickers/date-time-picker-toolbar/)
 */ function $32acbb918edd3fd5$export$fe4ab7cbc0078243(inProps) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiDateTimePickerToolbar"
    });
    const { ampm: ampm, ampmInClock: ampmInClock, value: value, onChange: onChange, view: view, isLandscape: isLandscape, onViewChange: onViewChange, toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder = "\u2013\u2013", views: views, disabled: disabled, readOnly: readOnly, toolbarVariant: toolbarVariant = "mobile", toolbarTitle: inToolbarTitle, className: className } = props, other = (0, $3L80X.default)(props, $32acbb918edd3fd5$var$_excluded);
    const ownerState = props;
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $064b27bbd099f1fc$export$6aaabc31cb076d17)(value, ampm, onChange);
    const showAmPmControl = Boolean(ampm && !ampmInClock);
    const isDesktop = toolbarVariant === "desktop";
    const localeText = (0, $58b82a9afc388fa3$export$24fdeaa0f591a73e)();
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const classes = $32acbb918edd3fd5$var$useUtilityClasses((0, $aJx1R.default)({}, ownerState, {
        theme: theme
    }));
    const toolbarTitle = inToolbarTitle ?? localeText.dateTimePickerToolbarTitle;
    const formatHours = (time)=>ampm ? utils.format(time, "hours12h") : utils.format(time, "hours24h");
    const dateText = $exYeM.useMemo(()=>{
        if (!value) return toolbarPlaceholder;
        if (toolbarFormat) return utils.formatByString(value, toolbarFormat);
        return utils.format(value, "shortDate");
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        utils
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($32acbb918edd3fd5$var$DateTimePickerToolbarRoot, (0, $aJx1R.default)({
        isLandscape: isLandscape,
        className: (0, $4qr5a.default)(classes.root, className),
        toolbarTitle: toolbarTitle
    }, other, {
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)($32acbb918edd3fd5$var$DateTimePickerToolbarDateContainer, {
                className: classes.dateContainer,
                ownerState: ownerState,
                children: [
                    views.includes("year") && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $35c12ca1dd6a73cd$export$614ed940168c780c), {
                        tabIndex: -1,
                        variant: "subtitle1",
                        onClick: ()=>onViewChange("year"),
                        selected: view === "year",
                        value: value ? utils.format(value, "year") : "\u2013"
                    }),
                    views.includes("day") && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $35c12ca1dd6a73cd$export$614ed940168c780c), {
                        tabIndex: -1,
                        variant: isDesktop ? "h5" : "h4",
                        onClick: ()=>onViewChange("day"),
                        selected: view === "day",
                        value: dateText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)($32acbb918edd3fd5$var$DateTimePickerToolbarTimeContainer, {
                className: classes.timeContainer,
                ownerState: ownerState,
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)($32acbb918edd3fd5$var$DateTimePickerToolbarTimeDigitsContainer, {
                        className: classes.timeDigitsContainer,
                        ownerState: ownerState,
                        children: [
                            views.includes("hours") && /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $35c12ca1dd6a73cd$export$614ed940168c780c), {
                                        variant: isDesktop ? "h5" : "h3",
                                        width: isDesktop && !isLandscape ? (0, $5c20cfc7ef711f44$export$a462ceb9cfdb5d71) : undefined,
                                        onClick: ()=>onViewChange("hours"),
                                        selected: view === "hours",
                                        value: value ? formatHours(value) : "--"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)($32acbb918edd3fd5$var$DateTimePickerToolbarSeparator, {
                                        variant: isDesktop ? "h5" : "h3",
                                        value: ":",
                                        className: classes.separator,
                                        ownerState: ownerState
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $35c12ca1dd6a73cd$export$614ed940168c780c), {
                                        variant: isDesktop ? "h5" : "h3",
                                        width: isDesktop && !isLandscape ? (0, $5c20cfc7ef711f44$export$a462ceb9cfdb5d71) : undefined,
                                        onClick: ()=>onViewChange("minutes"),
                                        selected: view === "minutes" || !views.includes("minutes") && view === "hours",
                                        value: value ? utils.format(value, "minutes") : "--",
                                        disabled: !views.includes("minutes")
                                    })
                                ]
                            }),
                            views.includes("seconds") && /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)($32acbb918edd3fd5$var$DateTimePickerToolbarSeparator, {
                                        variant: isDesktop ? "h5" : "h3",
                                        value: ":",
                                        className: classes.separator,
                                        ownerState: ownerState
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $35c12ca1dd6a73cd$export$614ed940168c780c), {
                                        variant: isDesktop ? "h5" : "h3",
                                        width: isDesktop && !isLandscape ? (0, $5c20cfc7ef711f44$export$a462ceb9cfdb5d71) : undefined,
                                        onClick: ()=>onViewChange("seconds"),
                                        selected: view === "seconds",
                                        value: value ? utils.format(value, "seconds") : "--"
                                    })
                                ]
                            })
                        ]
                    }),
                    showAmPmControl && !isDesktop && /*#__PURE__*/ (0, $aSiaI.jsxs)($32acbb918edd3fd5$var$DateTimePickerToolbarAmPmSelection, {
                        className: classes.ampmSelection,
                        ownerState: ownerState,
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $35c12ca1dd6a73cd$export$614ed940168c780c), {
                                variant: "subtitle2",
                                selected: meridiemMode === "am",
                                typographyClassName: classes.ampmLabel,
                                value: (0, $8c165bb53d94cf45$export$fae94c0a662107ef)(utils, "am"),
                                onClick: readOnly ? undefined : ()=>handleMeridiemChange("am"),
                                disabled: disabled
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $35c12ca1dd6a73cd$export$614ed940168c780c), {
                                variant: "subtitle2",
                                selected: meridiemMode === "pm",
                                typographyClassName: classes.ampmLabel,
                                value: (0, $8c165bb53d94cf45$export$fae94c0a662107ef)(utils, "pm"),
                                onClick: readOnly ? undefined : ()=>handleMeridiemChange("pm"),
                                disabled: disabled
                            })
                        ]
                    }),
                    ampm && isDesktop && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $35c12ca1dd6a73cd$export$614ed940168c780c), {
                        variant: "h5",
                        onClick: ()=>onViewChange("meridiem"),
                        selected: view === "meridiem",
                        value: value && meridiemMode ? (0, $8c165bb53d94cf45$export$fae94c0a662107ef)(utils, meridiemMode) : "--",
                        width: (0, $5c20cfc7ef711f44$export$a462ceb9cfdb5d71)
                    })
                ]
            })
        ]
    }));
}



function $56f00f6f5078973e$export$6e4d96e87e6dc2d3(props, name) {
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const defaultDates = (0, $58b82a9afc388fa3$export$7c38da3a2e90fa83)();
    const themeProps = (0, $7PWLt.default)({
        props: props,
        name: name
    });
    const ampm = themeProps.ampm ?? utils.is12HourCycleInCurrentLocale();
    const localeText = $exYeM.useMemo(()=>{
        if (themeProps.localeText?.toolbarTitle == null) return themeProps.localeText;
        return (0, $aJx1R.default)({}, themeProps.localeText, {
            dateTimePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    return (0, $aJx1R.default)({}, themeProps, (0, $a33a4d7002be5215$export$bdf8d867ddc968e)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            "year",
            "day",
            "hours",
            "minutes"
        ],
        defaultOpenTo: "day"
    }), {
        ampm: ampm,
        localeText: localeText,
        orientation: themeProps.orientation ?? "portrait",
        // TODO: Remove from public API
        disableIgnoringDatePartForTimeValidation: themeProps.disableIgnoringDatePartForTimeValidation ?? Boolean(themeProps.minDateTime || themeProps.maxDateTime || // allow time clock to correctly check time validity: https://github.com/mui/mui-x/issues/8520
        themeProps.disablePast || themeProps.disableFuture),
        disableFuture: themeProps.disableFuture ?? false,
        disablePast: themeProps.disablePast ?? false,
        minDate: (0, $8c165bb53d94cf45$export$eb73579ccade48fd)(utils, themeProps.minDateTime ?? themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $8c165bb53d94cf45$export$eb73579ccade48fd)(utils, themeProps.maxDateTime ?? themeProps.maxDate, defaultDates.maxDate),
        minTime: themeProps.minDateTime ?? themeProps.minTime,
        maxTime: themeProps.maxDateTime ?? themeProps.maxTime,
        slots: (0, $aJx1R.default)({
            toolbar: (0, $32acbb918edd3fd5$export$fe4ab7cbc0078243),
            tabs: (0, $6cd754d9a5d0f13e$export$95dfad4074502244)
        }, themeProps.slots),
        slotProps: (0, $aJx1R.default)({}, themeProps.slotProps, {
            toolbar: (0, $aJx1R.default)({
                ampm: ampm
            }, themeProps.slotProps?.toolbar)
        })
    });
}









var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");


const $709ad9785bb95632$var$_excluded = [
    "views",
    "format"
];
const $709ad9785bb95632$export$ebf7b30b32db6f57 = (utils, _ref)=>{
    let { views: views, format: format } = _ref, other = (0, $3L80X.default)(_ref, $709ad9785bb95632$var$_excluded);
    if (format) return format;
    const dateViews = [];
    const timeViews = [];
    views.forEach((view)=>{
        if ((0, $9509391b55697f91$export$8f04d380cefd5a0d)(view)) timeViews.push(view);
        else dateViews.push(view);
    });
    if (timeViews.length === 0) return (0, $8c165bb53d94cf45$export$bb1c921f313ec928)(utils, (0, $aJx1R.default)({
        views: dateViews
    }, other), false);
    if (dateViews.length === 0) return (0, $9509391b55697f91$export$3a6776b3863772fe)(utils, (0, $aJx1R.default)({
        views: timeViews
    }, other));
    const timeFormat = (0, $9509391b55697f91$export$3a6776b3863772fe)(utils, (0, $aJx1R.default)({
        views: timeViews
    }, other));
    const dateFormat = (0, $8c165bb53d94cf45$export$bb1c921f313ec928)(utils, (0, $aJx1R.default)({
        views: dateViews
    }, other), false);
    return `${dateFormat} ${timeFormat}`;
};
const $709ad9785bb95632$var$resolveViews = (ampm, views, shouldUseSingleColumn)=>{
    if (shouldUseSingleColumn) return views.filter((view)=>!(0, $9509391b55697f91$export$a3328136ac50623d)(view) || view === "hours");
    return ampm ? [
        ...views,
        "meridiem"
    ] : views;
};
const $709ad9785bb95632$var$resolveShouldRenderTimeInASingleColumn = (timeSteps, threshold)=>1440 / ((timeSteps.hours ?? 1) * (timeSteps.minutes ?? 5)) <= threshold;
function $709ad9785bb95632$export$e2d664f2dd4d34bc({ thresholdToRenderTimeInASingleColumn: inThreshold, ampm: ampm, timeSteps: inTimeSteps, views: views }) {
    const thresholdToRenderTimeInASingleColumn = inThreshold ?? 24;
    const timeSteps = (0, $aJx1R.default)({
        hours: 1,
        minutes: 5,
        seconds: 5
    }, inTimeSteps);
    const shouldRenderTimeInASingleColumn = $709ad9785bb95632$var$resolveShouldRenderTimeInASingleColumn(timeSteps, thresholdToRenderTimeInASingleColumn);
    return {
        thresholdToRenderTimeInASingleColumn: thresholdToRenderTimeInASingleColumn,
        timeSteps: timeSteps,
        shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn,
        views: $709ad9785bb95632$var$resolveViews(ampm, views, shouldRenderTimeInASingleColumn)
    };
}


parcelRequire("exYeM");

var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");

var $4qr5a = parcelRequire("4qr5a");


var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $2f0D3 = parcelRequire("2f0D3");







var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
function $492116997c3274a4$export$148b188041a720e4(slot) {
    return (0, $dC5O8.default)("MuiTimeClock", slot);
}
const $492116997c3274a4$export$191dec874db3257b = (0, $kY7HX.default)("MuiTimeClock", [
    "root",
    "arrowSwitcher"
]);



var $exYeM = parcelRequire("exYeM");

var $4qr5a = parcelRequire("4qr5a");



var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $2f0D3 = parcelRequire("2f0D3");

var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");

var $4qr5a = parcelRequire("4qr5a");

var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $2f0D3 = parcelRequire("2f0D3");
const $c5bfbfa266dbebe4$export$8c8ec20d3854d7e6 = 220;
const $c5bfbfa266dbebe4$export$729c0e543e4dc21d = 36;
const $c5bfbfa266dbebe4$var$clockCenter = {
    x: $c5bfbfa266dbebe4$export$8c8ec20d3854d7e6 / 2,
    y: $c5bfbfa266dbebe4$export$8c8ec20d3854d7e6 / 2
};
const $c5bfbfa266dbebe4$var$baseClockPoint = {
    x: $c5bfbfa266dbebe4$var$clockCenter.x,
    y: 0
};
const $c5bfbfa266dbebe4$var$cx = $c5bfbfa266dbebe4$var$baseClockPoint.x - $c5bfbfa266dbebe4$var$clockCenter.x;
const $c5bfbfa266dbebe4$var$cy = $c5bfbfa266dbebe4$var$baseClockPoint.y - $c5bfbfa266dbebe4$var$clockCenter.y;
const $c5bfbfa266dbebe4$var$rad2deg = (rad)=>rad * (180 / Math.PI);
const $c5bfbfa266dbebe4$var$getAngleValue = (step, offsetX, offsetY)=>{
    const x = offsetX - $c5bfbfa266dbebe4$var$clockCenter.x;
    const y = offsetY - $c5bfbfa266dbebe4$var$clockCenter.y;
    const atan = Math.atan2($c5bfbfa266dbebe4$var$cx, $c5bfbfa266dbebe4$var$cy) - Math.atan2(x, y);
    let deg = $c5bfbfa266dbebe4$var$rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    const value = Math.floor(deg / step) || 0;
    const delta = x ** 2 + y ** 2;
    const distance = Math.sqrt(delta);
    return {
        value: value,
        distance: distance
    };
};
const $c5bfbfa266dbebe4$export$b7f1bc3ea3ac4145 = (offsetX, offsetY, step = 1)=>{
    const angleStep = step * 6;
    let { value: value } = $c5bfbfa266dbebe4$var$getAngleValue(angleStep, offsetX, offsetY);
    value = value * step % 60;
    return value;
};
const $c5bfbfa266dbebe4$export$257b40f71c07d58f = (offsetX, offsetY, ampm)=>{
    const { value: value, distance: distance } = $c5bfbfa266dbebe4$var$getAngleValue(30, offsetX, offsetY);
    let hour = value || 12;
    if (!ampm) {
        if (distance < $c5bfbfa266dbebe4$export$8c8ec20d3854d7e6 / 2 - $c5bfbfa266dbebe4$export$729c0e543e4dc21d) {
            hour += 12;
            hour %= 24;
        }
    } else hour %= 12;
    return hour;
};



var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
function $5dd5da142086734f$export$12faa62796978e2f(slot) {
    return (0, $dC5O8.default)("MuiClockPointer", slot);
}
const $5dd5da142086734f$export$64afeec9352615cb = (0, $kY7HX.default)("MuiClockPointer", [
    "root",
    "thumb"
]);



var $aSiaI = parcelRequire("aSiaI");
const $c64a69becc696b7d$var$_excluded = [
    "className",
    "hasSelected",
    "isInner",
    "type",
    "viewValue"
];
const $c64a69becc696b7d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        thumb: [
            "thumb"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $5dd5da142086734f$export$12faa62796978e2f), classes);
};
const $c64a69becc696b7d$var$ClockPointerRoot = (0, $jawKn.default)("div", {
    name: "MuiClockPointer",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        width: 2,
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: "absolute",
        left: "calc(50% - 1px)",
        bottom: "50%",
        transformOrigin: "center bottom 0px",
        variants: [
            {
                props: {
                    shouldAnimate: true
                },
                style: {
                    transition: theme.transitions.create([
                        "transform",
                        "height"
                    ])
                }
            }
        ]
    }));
const $c64a69becc696b7d$var$ClockPointerThumb = (0, $jawKn.default)("div", {
    name: "MuiClockPointer",
    slot: "Thumb",
    overridesResolver: (_, styles)=>styles.thumb
})(({ theme: theme })=>({
        width: 4,
        height: 4,
        backgroundColor: (theme.vars || theme).palette.primary.contrastText,
        borderRadius: "50%",
        position: "absolute",
        top: -21,
        left: `calc(50% - ${(0, $c5bfbfa266dbebe4$export$729c0e543e4dc21d) / 2}px)`,
        border: `${((0, $c5bfbfa266dbebe4$export$729c0e543e4dc21d) - 4) / 2}px solid ${(theme.vars || theme).palette.primary.main}`,
        boxSizing: "content-box",
        variants: [
            {
                props: {
                    hasSelected: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            }
        ]
    }));
function $c64a69becc696b7d$export$f257f213e6c08f97(inProps) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiClockPointer"
    });
    const { className: className, isInner: isInner, type: type, viewValue: viewValue } = props, other = (0, $3L80X.default)(props, $c64a69becc696b7d$var$_excluded);
    const previousType = $exYeM.useRef(type);
    $exYeM.useEffect(()=>{
        previousType.current = type;
    }, [
        type
    ]);
    const ownerState = (0, $aJx1R.default)({}, props, {
        shouldAnimate: previousType.current !== type
    });
    const classes = $c64a69becc696b7d$var$useUtilityClasses(ownerState);
    const getAngleStyle = ()=>{
        const max = type === "hours" ? 12 : 60;
        let angle = 360 / max * viewValue;
        if (type === "hours" && viewValue > 12) angle -= 360; // round up angle to max 360 degrees
        return {
            height: Math.round((isInner ? 0.26 : 0.4) * (0, $c5bfbfa266dbebe4$export$8c8ec20d3854d7e6)),
            transform: `rotateZ(${angle}deg)`
        };
    };
    return /*#__PURE__*/ (0, $aSiaI.jsx)($c64a69becc696b7d$var$ClockPointerRoot, (0, $aJx1R.default)({
        style: getAngleStyle(),
        className: (0, $4qr5a.default)(className, classes.root),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($c64a69becc696b7d$var$ClockPointerThumb, {
            ownerState: ownerState,
            className: classes.thumb
        })
    }));
}





var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
function $3ea1dfb6367ee110$export$e44ecab24167799b(slot) {
    return (0, $dC5O8.default)("MuiClock", slot);
}
const $3ea1dfb6367ee110$export$4626e3a61e161c64 = (0, $kY7HX.default)("MuiClock", [
    "root",
    "clock",
    "wrapper",
    "squareMask",
    "pin",
    "amButton",
    "pmButton",
    "meridiemText"
]);




var $aSiaI = parcelRequire("aSiaI");
const $75a7691730b75717$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        clock: [
            "clock"
        ],
        wrapper: [
            "wrapper"
        ],
        squareMask: [
            "squareMask"
        ],
        pin: [
            "pin"
        ],
        amButton: [
            "amButton"
        ],
        pmButton: [
            "pmButton"
        ],
        meridiemText: [
            "meridiemText"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $3ea1dfb6367ee110$export$e44ecab24167799b), classes);
};
const $75a7691730b75717$var$ClockRoot = (0, $jawKn.default)("div", {
    name: "MuiClock",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: theme.spacing(2)
    }));
const $75a7691730b75717$var$ClockClock = (0, $jawKn.default)("div", {
    name: "MuiClock",
    slot: "Clock",
    overridesResolver: (_, styles)=>styles.clock
})({
    backgroundColor: "rgba(0,0,0,.07)",
    borderRadius: "50%",
    height: 220,
    width: 220,
    flexShrink: 0,
    position: "relative",
    pointerEvents: "none"
});
const $75a7691730b75717$var$ClockWrapper = (0, $jawKn.default)("div", {
    name: "MuiClock",
    slot: "Wrapper",
    overridesResolver: (_, styles)=>styles.wrapper
})({
    "&:focus": {
        outline: "none"
    }
});
const $75a7691730b75717$var$ClockSquareMask = (0, $jawKn.default)("div", {
    name: "MuiClock",
    slot: "SquareMask",
    overridesResolver: (_, styles)=>styles.squareMask
})({
    width: "100%",
    height: "100%",
    position: "absolute",
    pointerEvents: "auto",
    outline: 0,
    // Disable scroll capabilities.
    touchAction: "none",
    userSelect: "none",
    variants: [
        {
            props: {
                disabled: false
            },
            style: {
                "@media (pointer: fine)": {
                    cursor: "pointer",
                    borderRadius: "50%"
                },
                "&:active": {
                    cursor: "move"
                }
            }
        }
    ]
});
const $75a7691730b75717$var$ClockPin = (0, $jawKn.default)("div", {
    name: "MuiClock",
    slot: "Pin",
    overridesResolver: (_, styles)=>styles.pin
})(({ theme: theme })=>({
        width: 6,
        height: 6,
        borderRadius: "50%",
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    }));
const $75a7691730b75717$var$ClockAmButton = (0, $jawKn.default)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), {
    name: "MuiClock",
    slot: "AmButton",
    overridesResolver: (_, styles)=>styles.amButton
})(({ theme: theme })=>({
        zIndex: 1,
        position: "absolute",
        bottom: 8,
        left: 8,
        paddingLeft: 4,
        paddingRight: 4,
        width: (0, $c5bfbfa266dbebe4$export$729c0e543e4dc21d),
        variants: [
            {
                props: {
                    meridiemMode: "am"
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main,
                    color: (theme.vars || theme).palette.primary.contrastText,
                    "&:hover": {
                        backgroundColor: (theme.vars || theme).palette.primary.light
                    }
                }
            }
        ]
    }));
const $75a7691730b75717$var$ClockPmButton = (0, $jawKn.default)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), {
    name: "MuiClock",
    slot: "PmButton",
    overridesResolver: (_, styles)=>styles.pmButton
})(({ theme: theme })=>({
        zIndex: 1,
        position: "absolute",
        bottom: 8,
        right: 8,
        paddingLeft: 4,
        paddingRight: 4,
        width: (0, $c5bfbfa266dbebe4$export$729c0e543e4dc21d),
        variants: [
            {
                props: {
                    meridiemMode: "pm"
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main,
                    color: (theme.vars || theme).palette.primary.contrastText,
                    "&:hover": {
                        backgroundColor: (theme.vars || theme).palette.primary.light
                    }
                }
            }
        ]
    }));
const $75a7691730b75717$var$ClockMeridiemText = (0, $jawKn.default)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
    name: "MuiClock",
    slot: "meridiemText",
    overridesResolver: (_, styles)=>styles.meridiemText
})({
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
});
function $75a7691730b75717$export$9735c82c4bae3302(inProps) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiClock"
    });
    const { ampm: ampm, ampmInClock: ampmInClock, autoFocus: autoFocus, children: children, value: value, handleMeridiemChange: handleMeridiemChange, isTimeDisabled: isTimeDisabled, meridiemMode: meridiemMode, minutesStep: minutesStep = 1, onChange: onChange, selectedId: selectedId, type: type, viewValue: viewValue, disabled: disabled = false, readOnly: readOnly, className: className } = props;
    const ownerState = props;
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const localeText = (0, $58b82a9afc388fa3$export$24fdeaa0f591a73e)();
    const isMoving = $exYeM.useRef(false);
    const classes = $75a7691730b75717$var$useUtilityClasses(ownerState);
    const isSelectedTimeDisabled = isTimeDisabled(viewValue, type);
    const isPointerInner = !ampm && type === "hours" && (viewValue < 1 || viewValue > 12);
    const handleValueChange = (newValue, isFinish)=>{
        if (disabled || readOnly) return;
        if (isTimeDisabled(newValue, type)) return;
        onChange(newValue, isFinish);
    };
    const setTime = (event, isFinish)=>{
        let { offsetX: offsetX, offsetY: offsetY } = event;
        if (offsetX === undefined) {
            const rect = event.target.getBoundingClientRect();
            offsetX = event.changedTouches[0].clientX - rect.left;
            offsetY = event.changedTouches[0].clientY - rect.top;
        }
        const newSelectedValue = type === "seconds" || type === "minutes" ? (0, $c5bfbfa266dbebe4$export$b7f1bc3ea3ac4145)(offsetX, offsetY, minutesStep) : (0, $c5bfbfa266dbebe4$export$257b40f71c07d58f)(offsetX, offsetY, Boolean(ampm));
        handleValueChange(newSelectedValue, isFinish);
    };
    const handleTouchMove = (event)=>{
        isMoving.current = true;
        setTime(event, "shallow");
    };
    const handleTouchEnd = (event)=>{
        if (isMoving.current) {
            setTime(event, "finish");
            isMoving.current = false;
        }
    };
    const handleMouseMove = (event)=>{
        // event.buttons & PRIMARY_MOUSE_BUTTON
        if (event.buttons > 0) setTime(event.nativeEvent, "shallow");
    };
    const handleMouseUp = (event)=>{
        if (isMoving.current) isMoving.current = false;
        setTime(event.nativeEvent, "finish");
    };
    const hasSelected = $exYeM.useMemo(()=>{
        if (type === "hours") return true;
        return viewValue % 5 === 0;
    }, [
        type,
        viewValue
    ]);
    const keyboardControlStep = type === "minutes" ? minutesStep : 1;
    const listboxRef = $exYeM.useRef(null);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $c4c3f9798cb7fddc$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) // The ref not being resolved would be a bug in MUI.
        listboxRef.current.focus();
    }, [
        autoFocus
    ]);
    const handleKeyDown = (event)=>{
        // TODO: Why this early exit?
        if (isMoving.current) return;
        switch(event.key){
            case "Home":
                // reset both hours and minutes
                handleValueChange(0, "partial");
                event.preventDefault();
                break;
            case "End":
                handleValueChange(type === "minutes" ? 59 : 23, "partial");
                event.preventDefault();
                break;
            case "ArrowUp":
                handleValueChange(viewValue + keyboardControlStep, "partial");
                event.preventDefault();
                break;
            case "ArrowDown":
                handleValueChange(viewValue - keyboardControlStep, "partial");
                event.preventDefault();
                break;
            default:
        }
    };
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($75a7691730b75717$var$ClockRoot, {
        className: (0, $4qr5a.default)(className, classes.root),
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)($75a7691730b75717$var$ClockClock, {
                className: classes.clock,
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)($75a7691730b75717$var$ClockSquareMask, {
                        onTouchMove: handleTouchMove,
                        onTouchEnd: handleTouchEnd,
                        onMouseUp: handleMouseUp,
                        onMouseMove: handleMouseMove,
                        ownerState: {
                            disabled: disabled
                        },
                        className: classes.squareMask
                    }),
                    !isSelectedTimeDisabled && /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)($75a7691730b75717$var$ClockPin, {
                                className: classes.pin
                            }),
                            value != null && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c64a69becc696b7d$export$f257f213e6c08f97), {
                                type: type,
                                viewValue: viewValue,
                                isInner: isPointerInner,
                                hasSelected: hasSelected
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)($75a7691730b75717$var$ClockWrapper, {
                        "aria-activedescendant": selectedId,
                        "aria-label": localeText.clockLabelText(type, value, utils),
                        ref: listboxRef,
                        role: "listbox",
                        onKeyDown: handleKeyDown,
                        tabIndex: 0,
                        className: classes.wrapper,
                        children: children
                    })
                ]
            }),
            ampm && ampmInClock && /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)($75a7691730b75717$var$ClockAmButton, {
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange("am"),
                        disabled: disabled || meridiemMode === null,
                        ownerState: ownerState,
                        className: classes.amButton,
                        title: (0, $8c165bb53d94cf45$export$fae94c0a662107ef)(utils, "am"),
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)($75a7691730b75717$var$ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: (0, $8c165bb53d94cf45$export$fae94c0a662107ef)(utils, "am")
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)($75a7691730b75717$var$ClockPmButton, {
                        disabled: disabled || meridiemMode === null,
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange("pm"),
                        ownerState: ownerState,
                        className: classes.pmButton,
                        title: (0, $8c165bb53d94cf45$export$fae94c0a662107ef)(utils, "pm"),
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)($75a7691730b75717$var$ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: (0, $8c165bb53d94cf45$export$fae94c0a662107ef)(utils, "pm")
                        })
                    })
                ]
            })
        ]
    });
}


parcelRequire("exYeM");

var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");
parcelRequire("exYeM");

var $4qr5a = parcelRequire("4qr5a");

var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $2f0D3 = parcelRequire("2f0D3");


var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
function $aed5de9c6f764db2$export$527226d166658911(slot) {
    return (0, $dC5O8.default)("MuiClockNumber", slot);
}
const $aed5de9c6f764db2$export$c8efb3a779c9844a = (0, $kY7HX.default)("MuiClockNumber", [
    "root",
    "selected",
    "disabled"
]);



var $aSiaI = parcelRequire("aSiaI");
const $144c93a2f072df7e$var$_excluded = [
    "className",
    "disabled",
    "index",
    "inner",
    "label",
    "selected"
];
const $144c93a2f072df7e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected",
            disabled && "disabled"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $aed5de9c6f764db2$export$527226d166658911), classes);
};
const $144c93a2f072df7e$var$ClockNumberRoot = (0, $jawKn.default)("span", {
    name: "MuiClockNumber",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $aed5de9c6f764db2$export$c8efb3a779c9844a).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $aed5de9c6f764db2$export$c8efb3a779c9844a).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>({
        height: (0, $c5bfbfa266dbebe4$export$729c0e543e4dc21d),
        width: (0, $c5bfbfa266dbebe4$export$729c0e543e4dc21d),
        position: "absolute",
        left: `calc((100% - ${0, $c5bfbfa266dbebe4$export$729c0e543e4dc21d}px) / 2)`,
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%",
        color: (theme.vars || theme).palette.text.primary,
        fontFamily: theme.typography.fontFamily,
        "&:focused": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        [`&.${(0, $aed5de9c6f764db2$export$c8efb3a779c9844a).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText
        },
        [`&.${(0, $aed5de9c6f764db2$export$c8efb3a779c9844a).disabled}`]: {
            pointerEvents: "none",
            color: (theme.vars || theme).palette.text.disabled
        },
        variants: [
            {
                props: {
                    inner: true
                },
                style: (0, $aJx1R.default)({}, theme.typography.body2, {
                    color: (theme.vars || theme).palette.text.secondary
                })
            }
        ]
    }));
function $144c93a2f072df7e$export$6d5c4c748c9cc92c(inProps) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiClockNumber"
    });
    const { className: className, disabled: disabled, index: index, inner: inner, label: label, selected: selected } = props, other = (0, $3L80X.default)(props, $144c93a2f072df7e$var$_excluded);
    const ownerState = props;
    const classes = $144c93a2f072df7e$var$useUtilityClasses(ownerState);
    const angle = index % 12 / 12 * Math.PI * 2 - Math.PI / 2;
    const length = ((0, $c5bfbfa266dbebe4$export$8c8ec20d3854d7e6) - (0, $c5bfbfa266dbebe4$export$729c0e543e4dc21d) - 2) / 2 * (inner ? 0.65 : 1);
    const x = Math.round(Math.cos(angle) * length);
    const y = Math.round(Math.sin(angle) * length);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($144c93a2f072df7e$var$ClockNumberRoot, (0, $aJx1R.default)({
        className: (0, $4qr5a.default)(className, classes.root),
        "aria-disabled": disabled ? true : undefined,
        "aria-selected": selected ? true : undefined,
        role: "option",
        style: {
            transform: `translate(${x}px, ${y + ((0, $c5bfbfa266dbebe4$export$8c8ec20d3854d7e6) - (0, $c5bfbfa266dbebe4$export$729c0e543e4dc21d)) / 2}px`
        },
        ownerState: ownerState
    }, other, {
        children: label
    }));
}



var $aSiaI = parcelRequire("aSiaI");
const $61e7db534302c9bd$export$10850582eda9a8c7 = ({ ampm: ampm, value: value, getClockNumberText: getClockNumberText, isDisabled: isDisabled, selectedId: selectedId, utils: utils })=>{
    const currentHours = value ? utils.getHours(value) : null;
    const hourNumbers = [];
    const startHour = ampm ? 1 : 0;
    const endHour = ampm ? 12 : 23;
    const isSelected = (hour)=>{
        if (currentHours === null) return false;
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    for(let hour = startHour; hour <= endHour; hour += 1){
        let label = hour.toString();
        if (hour === 0) label = "00";
        const inner = !ampm && (hour === 0 || hour > 12);
        label = utils.formatNumber(label);
        const selected = isSelected(hour);
        hourNumbers.push(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $144c93a2f072df7e$export$6d5c4c748c9cc92c), {
            id: selected ? selectedId : undefined,
            index: hour,
            inner: inner,
            selected: selected,
            disabled: isDisabled(hour),
            label: label,
            "aria-label": getClockNumberText(label)
        }, hour));
    }
    return hourNumbers;
};
const $61e7db534302c9bd$export$2c440057d7a731e4 = ({ utils: utils, value: value, isDisabled: isDisabled, getClockNumberText: getClockNumberText, selectedId: selectedId })=>{
    const f = utils.formatNumber;
    return [
        [
            5,
            f("05")
        ],
        [
            10,
            f("10")
        ],
        [
            15,
            f("15")
        ],
        [
            20,
            f("20")
        ],
        [
            25,
            f("25")
        ],
        [
            30,
            f("30")
        ],
        [
            35,
            f("35")
        ],
        [
            40,
            f("40")
        ],
        [
            45,
            f("45")
        ],
        [
            50,
            f("50")
        ],
        [
            55,
            f("55")
        ],
        [
            0,
            f("00")
        ]
    ].map(([numberValue, label], index)=>{
        const selected = numberValue === value;
        return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $144c93a2f072df7e$export$6d5c4c748c9cc92c), {
            label: label,
            id: selected ? selectedId : undefined,
            index: index + 1,
            inner: false,
            disabled: isDisabled(numberValue),
            selected: selected,
            "aria-label": getClockNumberText(label)
        }, numberValue);
    });
};





var $exYeM = parcelRequire("exYeM");



const $8339625ea7b294db$export$86ee3b7a301faaa3 = ({ value: value, referenceDate: referenceDateProp, utils: utils, props: props, timezone: timezone })=>{
    const referenceDate = $exYeM.useMemo(()=>(0, $efb258a9c0464e3f$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            referenceDate: referenceDateProp,
            granularity: (0, $bd0cf02b8b64cf79$export$8f74e8f4ed8ae0ac).day,
            timezone: timezone,
            getTodayDate: ()=>(0, $8c165bb53d94cf45$export$1118e4272ea1e258)(utils, timezone, "date")
        }), // We only want to compute the reference date on mount.
    [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    return value ?? referenceDate;
};



var $aSiaI = parcelRequire("aSiaI");
const $e07e830cb93afef8$var$_excluded = [
    "ampm",
    "ampmInClock",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "showViewSwitcher",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "timezone"
];
const $e07e830cb93afef8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        arrowSwitcher: [
            "arrowSwitcher"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $492116997c3274a4$export$148b188041a720e4), classes);
};
const $e07e830cb93afef8$var$TimeClockRoot = (0, $jawKn.default)((0, $d78818d135bdbc3a$export$512b066b8abdfde4), {
    name: "MuiTimeClock",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexDirection: "column",
    position: "relative"
});
const $e07e830cb93afef8$var$TimeClockArrowSwitcher = (0, $jawKn.default)((0, $d0c9a6613cf3e3f5$export$597b7cbdb7b2a24c), {
    name: "MuiTimeClock",
    slot: "ArrowSwitcher",
    overridesResolver: (props, styles)=>styles.arrowSwitcher
})({
    position: "absolute",
    right: 12,
    top: 15
});
const $e07e830cb93afef8$var$TIME_CLOCK_DEFAULT_VIEWS = [
    "hours",
    "minutes"
];
const $e07e830cb93afef8$export$7e96244e18c4be57 = /*#__PURE__*/ $exYeM.forwardRef(function TimeClock(inProps, ref) {
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiTimeClock"
    });
    const { ampm: ampm = utils.is12HourCycleInCurrentLocale(), ampmInClock: ampmInClock = false, autoFocus: autoFocus, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableTime: shouldDisableTime, showViewSwitcher: showViewSwitcher, onChange: onChange, view: inView, views: views = $e07e830cb93afef8$var$TIME_CLOCK_DEFAULT_VIEWS, openTo: openTo, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, className: className, disabled: disabled, readOnly: readOnly, timezone: timezoneProp } = props, other = (0, $3L80X.default)(props, $e07e830cb93afef8$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $3e4aef0ef80b275d$export$174d749f3b4c0f49)({
        name: "TimeClock",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $efb258a9c0464e3f$export$2764b246aa3b75ba)
    });
    const valueOrReferenceDate = (0, $8339625ea7b294db$export$86ee3b7a301faaa3)({
        value: value,
        referenceDate: referenceDateProp,
        utils: utils,
        props: props,
        timezone: timezone
    });
    const localeText = (0, $58b82a9afc388fa3$export$24fdeaa0f591a73e)();
    const now = (0, $58b82a9afc388fa3$export$3a404aece3dff2fa)(timezone);
    const { view: view, setView: setView, previousView: previousView, nextView: nextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $8d38a40b51f4c4fd$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $064b27bbd099f1fc$export$6aaabc31cb076d17)(valueOrReferenceDate, ampm, setValueAndGoToNextView);
    const isTimeDisabled = $exYeM.useCallback((rawValue, viewType)=>{
        const isAfter = (0, $9509391b55697f91$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, utils);
        const shouldCheckPastEnd = viewType === "hours" || viewType === "minutes" && views.includes("seconds");
        const containsValidTime = ({ start: start, end: end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableTime) switch(viewType){
                case "hours":
                    return !shouldDisableTime(utils.setHours(valueOrReferenceDate, timeValue), "hours");
                case "minutes":
                    return !shouldDisableTime(utils.setMinutes(valueOrReferenceDate, timeValue), "minutes");
                case "seconds":
                    return !shouldDisableTime(utils.setSeconds(valueOrReferenceDate, timeValue), "seconds");
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case "hours":
                {
                    const valueWithMeridiem = (0, $9509391b55697f91$export$4159dc823695870e)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = utils.setHours(valueOrReferenceDate, valueWithMeridiem);
                    const start = utils.setSeconds(utils.setMinutes(dateWithNewHours, 0), 0);
                    const end = utils.setSeconds(utils.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case "minutes":
                {
                    const dateWithNewMinutes = utils.setMinutes(valueOrReferenceDate, rawValue);
                    const start = utils.setSeconds(dateWithNewMinutes, 0);
                    const end = utils.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case "seconds":
                {
                    const dateWithNewSeconds = utils.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error("not supported");
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableTime,
        utils,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const selectedId = (0, $43c7ad0c22f8e14a$export$2e2bcd8739ae039)();
    const viewProps = $exYeM.useMemo(()=>{
        switch(view){
            case "hours":
                {
                    const handleHoursChange = (hourValue, isFinish)=>{
                        const valueWithMeridiem = (0, $9509391b55697f91$export$4159dc823695870e)(hourValue, meridiemMode, ampm);
                        setValueAndGoToNextView(utils.setHours(valueOrReferenceDate, valueWithMeridiem), isFinish, "hours");
                    };
                    return {
                        onChange: handleHoursChange,
                        viewValue: utils.getHours(valueOrReferenceDate),
                        children: (0, $61e7db534302c9bd$export$10850582eda9a8c7)({
                            value: value,
                            utils: utils,
                            ampm: ampm,
                            onChange: handleHoursChange,
                            getClockNumberText: localeText.hoursClockNumberText,
                            isDisabled: (hourValue)=>disabled || isTimeDisabled(hourValue, "hours"),
                            selectedId: selectedId
                        })
                    };
                }
            case "minutes":
                {
                    const minutesValue = utils.getMinutes(valueOrReferenceDate);
                    const handleMinutesChange = (minuteValue, isFinish)=>{
                        setValueAndGoToNextView(utils.setMinutes(valueOrReferenceDate, minuteValue), isFinish, "minutes");
                    };
                    return {
                        viewValue: minutesValue,
                        onChange: handleMinutesChange,
                        children: (0, $61e7db534302c9bd$export$2c440057d7a731e4)({
                            utils: utils,
                            value: minutesValue,
                            onChange: handleMinutesChange,
                            getClockNumberText: localeText.minutesClockNumberText,
                            isDisabled: (minuteValue)=>disabled || isTimeDisabled(minuteValue, "minutes"),
                            selectedId: selectedId
                        })
                    };
                }
            case "seconds":
                {
                    const secondsValue = utils.getSeconds(valueOrReferenceDate);
                    const handleSecondsChange = (secondValue, isFinish)=>{
                        setValueAndGoToNextView(utils.setSeconds(valueOrReferenceDate, secondValue), isFinish, "seconds");
                    };
                    return {
                        viewValue: secondsValue,
                        onChange: handleSecondsChange,
                        children: (0, $61e7db534302c9bd$export$2c440057d7a731e4)({
                            utils: utils,
                            value: secondsValue,
                            onChange: handleSecondsChange,
                            getClockNumberText: localeText.secondsClockNumberText,
                            isDisabled: (secondValue)=>disabled || isTimeDisabled(secondValue, "seconds"),
                            selectedId: selectedId
                        })
                    };
                }
            default:
                throw new Error("You must provide the type for ClockView");
        }
    }, [
        view,
        utils,
        value,
        ampm,
        localeText.hoursClockNumberText,
        localeText.minutesClockNumberText,
        localeText.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        isTimeDisabled,
        selectedId,
        disabled
    ]);
    const ownerState = props;
    const classes = $e07e830cb93afef8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($e07e830cb93afef8$var$TimeClockRoot, (0, $aJx1R.default)({
        ref: ref,
        className: (0, $4qr5a.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $75a7691730b75717$export$9735c82c4bae3302), (0, $aJx1R.default)({
                autoFocus: autoFocus ?? !!focusedView,
                ampmInClock: ampmInClock && views.includes("hours"),
                value: value,
                type: view,
                ampm: ampm,
                minutesStep: minutesStep,
                isTimeDisabled: isTimeDisabled,
                meridiemMode: meridiemMode,
                handleMeridiemChange: handleMeridiemChange,
                selectedId: selectedId,
                disabled: disabled,
                readOnly: readOnly
            }, viewProps)),
            showViewSwitcher && /*#__PURE__*/ (0, $aSiaI.jsx)($e07e830cb93afef8$var$TimeClockArrowSwitcher, {
                className: classes.arrowSwitcher,
                slots: slots,
                slotProps: slotProps,
                onGoToPrevious: ()=>setView(previousView),
                isPreviousDisabled: !previousView,
                previousLabel: localeText.openPreviousView,
                onGoToNext: ()=>setView(nextView),
                isNextDisabled: !nextView,
                nextLabel: localeText.openNextView,
                ownerState: ownerState
            })
        ]
    }));
});



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");

var $4qr5a = parcelRequire("4qr5a");



var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");


var $2f0D3 = parcelRequire("2f0D3");







var $dC5O8 = parcelRequire("dC5O8");

var $kY7HX = parcelRequire("kY7HX");
function $8c97f2c0b9520cf6$export$aeb645018b209578(slot) {
    return (0, $dC5O8.default)("MuiDigitalClock", slot);
}
const $8c97f2c0b9520cf6$export$baf91642e79c8163 = (0, $kY7HX.default)("MuiDigitalClock", [
    "root",
    "list",
    "item"
]);








var $aSiaI = parcelRequire("aSiaI");
const $f6d51ca99b6aa77e$var$_excluded = [
    "ampm",
    "timeStep",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "onChange",
    "view",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "views",
    "skipDisabled",
    "timezone"
];
const $f6d51ca99b6aa77e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        list: [
            "list"
        ],
        item: [
            "item"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $8c97f2c0b9520cf6$export$aeb645018b209578), classes);
};
const $f6d51ca99b6aa77e$var$DigitalClockRoot = (0, $jawKn.default)((0, $d78818d135bdbc3a$export$512b066b8abdfde4), {
    name: "MuiDigitalClock",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    overflowY: "auto",
    width: "100%",
    "@media (prefers-reduced-motion: no-preference)": {
        scrollBehavior: "auto"
    },
    maxHeight: (0, $5c20cfc7ef711f44$export$1c2eabda4acea0e4),
    variants: [
        {
            props: {
                alreadyRendered: true
            },
            style: {
                "@media (prefers-reduced-motion: no-preference)": {
                    scrollBehavior: "smooth"
                }
            }
        }
    ]
});
const $f6d51ca99b6aa77e$var$DigitalClockList = (0, $jawKn.default)((0, $9bf3612007aa5fca$export$2e2bcd8739ae039), {
    name: "MuiDigitalClock",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    padding: 0
});
const $f6d51ca99b6aa77e$var$DigitalClockItem = (0, $jawKn.default)((0, $32731aa3cf1ce086$export$2e2bcd8739ae039), {
    name: "MuiDigitalClock",
    slot: "Item",
    overridesResolver: (props, styles)=>styles.item
})(({ theme: theme })=>({
        padding: "8px 16px",
        margin: "2px 4px",
        "&:first-of-type": {
            marginTop: 4
        },
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $69eec9e6c105674b$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        "&.Mui-selected": {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            "&:focus-visible, &:hover": {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        "&.Mui-focusVisible": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $69eec9e6c105674b$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
const $f6d51ca99b6aa77e$export$9a2b219a5b06deb7 = /*#__PURE__*/ $exYeM.forwardRef(function DigitalClock(inProps, ref) {
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const containerRef = $exYeM.useRef(null);
    const handleRef = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(ref, containerRef);
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiDigitalClock"
    });
    const { ampm: ampm = utils.is12HourCycleInCurrentLocale(), timeStep: timeStep = 30, autoFocus: autoFocus, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableTime: shouldDisableTime, onChange: onChange, view: inView, openTo: openTo, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, className: className, disabled: disabled, readOnly: readOnly, views: views = [
        "hours"
    ], skipDisabled: skipDisabled = false, timezone: timezoneProp } = props, other = (0, $3L80X.default)(props, $f6d51ca99b6aa77e$var$_excluded);
    const { value: value, handleValueChange: handleRawValueChange, timezone: timezone } = (0, $3e4aef0ef80b275d$export$174d749f3b4c0f49)({
        name: "DigitalClock",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $efb258a9c0464e3f$export$2764b246aa3b75ba)
    });
    const localeText = (0, $58b82a9afc388fa3$export$24fdeaa0f591a73e)();
    const now = (0, $58b82a9afc388fa3$export$3a404aece3dff2fa)(timezone);
    const ownerState = $exYeM.useMemo(()=>(0, $aJx1R.default)({}, props, {
            alreadyRendered: !!containerRef.current
        }), [
        props
    ]);
    const classes = $f6d51ca99b6aa77e$var$useUtilityClasses(ownerState);
    const ClockItem = slots?.digitalClockItem ?? $f6d51ca99b6aa77e$var$DigitalClockItem;
    const clockItemProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: ClockItem,
        externalSlotProps: slotProps?.digitalClockItem,
        ownerState: {},
        className: classes.item
    });
    const valueOrReferenceDate = (0, $8339625ea7b294db$export$86ee3b7a301faaa3)({
        value: value,
        referenceDate: referenceDateProp,
        utils: utils,
        props: props,
        timezone: timezone
    });
    const handleValueChange = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((newValue)=>handleRawValueChange(newValue, "finish", "hours"));
    const { setValueAndGoToNextView: setValueAndGoToNextView } = (0, $8d38a40b51f4c4fd$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const handleItemSelect = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((newValue)=>{
        setValueAndGoToNextView(newValue, "finish");
    });
    $exYeM.useEffect(()=>{
        if (containerRef.current === null) return;
        const activeItem = containerRef.current.querySelector('[role="listbox"] [role="option"][tabindex="0"], [role="listbox"] [role="option"][aria-selected="true"]');
        if (!activeItem) return;
        const offsetTop = activeItem.offsetTop;
        if (autoFocus || !!focusedView) activeItem.focus();
        // Subtracting the 4px of extra margin intended for the first visible section item
        containerRef.current.scrollTop = offsetTop - 4;
    });
    const isTimeDisabled = $exYeM.useCallback((valueToCheck)=>{
        const isAfter = (0, $9509391b55697f91$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, utils);
        const containsValidTime = ()=>{
            if (minTime && isAfter(minTime, valueToCheck)) return false;
            if (maxTime && isAfter(valueToCheck, maxTime)) return false;
            if (disableFuture && isAfter(valueToCheck, now)) return false;
            if (disablePast && isAfter(now, valueToCheck)) return false;
            return true;
        };
        const isValidValue = ()=>{
            if (utils.getMinutes(valueToCheck) % minutesStep !== 0) return false;
            if (shouldDisableTime) return !shouldDisableTime(valueToCheck, "hours");
            return true;
        };
        return !containsValidTime() || !isValidValue();
    }, [
        disableIgnoringDatePartForTimeValidation,
        utils,
        minTime,
        maxTime,
        disableFuture,
        now,
        disablePast,
        minutesStep,
        shouldDisableTime
    ]);
    const timeOptions = $exYeM.useMemo(()=>{
        const startOfDay = utils.startOfDay(valueOrReferenceDate);
        return [
            startOfDay,
            ...Array.from({
                length: Math.ceil(1440 / timeStep) - 1
            }, (_, index)=>utils.addMinutes(startOfDay, timeStep * (index + 1)))
        ];
    }, [
        valueOrReferenceDate,
        timeStep,
        utils
    ]);
    const focusedOptionIndex = timeOptions.findIndex((option)=>utils.isEqual(option, valueOrReferenceDate));
    return /*#__PURE__*/ (0, $aSiaI.jsx)($f6d51ca99b6aa77e$var$DigitalClockRoot, (0, $aJx1R.default)({
        ref: handleRef,
        className: (0, $4qr5a.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($f6d51ca99b6aa77e$var$DigitalClockList, {
            role: "listbox",
            "aria-label": localeText.timePickerToolbarTitle,
            className: classes.list,
            children: timeOptions.map((option, index)=>{
                if (skipDisabled && isTimeDisabled(option)) return null;
                const isSelected = utils.isEqual(option, value);
                const formattedValue = utils.format(option, ampm ? "fullTime12h" : "fullTime24h");
                const tabIndex = focusedOptionIndex === index || focusedOptionIndex === -1 && index === 0 ? 0 : -1;
                return /*#__PURE__*/ (0, $aSiaI.jsx)(ClockItem, (0, $aJx1R.default)({
                    onClick: ()=>!readOnly && handleItemSelect(option),
                    selected: isSelected,
                    disabled: disabled || isTimeDisabled(option),
                    disableRipple: readOnly,
                    role: "option",
                    "aria-disabled": readOnly,
                    "aria-selected": isSelected,
                    tabIndex: tabIndex
                }, clockItemProps, {
                    children: formattedValue
                }), formattedValue);
            })
        })
    }));
});



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");

var $4qr5a = parcelRequire("4qr5a");


var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");


var $2f0D3 = parcelRequire("2f0D3");






var $dC5O8 = parcelRequire("dC5O8");

var $kY7HX = parcelRequire("kY7HX");
function $772562b11cd511e9$export$b828b7724b7b2890(slot) {
    return (0, $dC5O8.default)("MuiMultiSectionDigitalClock", slot);
}
const $772562b11cd511e9$export$f2277d947b8f7a8a = (0, $kY7HX.default)("MuiMultiSectionDigitalClock", [
    "root"
]);



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");

var $4qr5a = parcelRequire("4qr5a");

var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $2f0D3 = parcelRequire("2f0D3");




var $dC5O8 = parcelRequire("dC5O8");

var $kY7HX = parcelRequire("kY7HX");
function $2bd895433a76eb3d$export$ab23463cad6963ff(slot) {
    return (0, $dC5O8.default)("MuiMultiSectionDigitalClockSection", slot);
}
const $2bd895433a76eb3d$export$eaf2b63fa45eff23 = (0, $kY7HX.default)("MuiMultiSectionDigitalClockSection", [
    "root",
    "item"
]);




var $aSiaI = parcelRequire("aSiaI");
const $9fa164fbcaec4773$var$_excluded = [
    "autoFocus",
    "onChange",
    "className",
    "disabled",
    "readOnly",
    "items",
    "active",
    "slots",
    "slotProps",
    "skipDisabled"
];
const $9fa164fbcaec4773$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        item: [
            "item"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $2bd895433a76eb3d$export$ab23463cad6963ff), classes);
};
const $9fa164fbcaec4773$var$MultiSectionDigitalClockSectionRoot = (0, $jawKn.default)((0, $9bf3612007aa5fca$export$2e2bcd8739ae039), {
    name: "MuiMultiSectionDigitalClockSection",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        maxHeight: (0, $5c20cfc7ef711f44$export$1c2eabda4acea0e4),
        width: 56,
        padding: 0,
        overflow: "hidden",
        "@media (prefers-reduced-motion: no-preference)": {
            scrollBehavior: "auto"
        },
        "@media (pointer: fine)": {
            "&:hover": {
                overflowY: "auto"
            }
        },
        "@media (pointer: none), (pointer: coarse)": {
            overflowY: "auto"
        },
        "&:not(:first-of-type)": {
            borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
        },
        "&::after": {
            display: "block",
            content: '""',
            // subtracting the height of one item, extra margin and borders to make sure the max height is correct
            height: "calc(100% - 40px - 6px)"
        },
        variants: [
            {
                props: {
                    alreadyRendered: true
                },
                style: {
                    "@media (prefers-reduced-motion: no-preference)": {
                        scrollBehavior: "smooth"
                    }
                }
            }
        ]
    }));
const $9fa164fbcaec4773$var$MultiSectionDigitalClockSectionItem = (0, $jawKn.default)((0, $32731aa3cf1ce086$export$2e2bcd8739ae039), {
    name: "MuiMultiSectionDigitalClockSection",
    slot: "Item",
    overridesResolver: (_, styles)=>styles.item
})(({ theme: theme })=>({
        padding: 8,
        margin: "2px 4px",
        width: (0, $5c20cfc7ef711f44$export$a462ceb9cfdb5d71),
        justifyContent: "center",
        "&:first-of-type": {
            marginTop: 4
        },
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $69eec9e6c105674b$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        "&.Mui-selected": {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            "&:focus-visible, &:hover": {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        "&.Mui-focusVisible": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $69eec9e6c105674b$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
const $9fa164fbcaec4773$export$f971f93dc8464c = /*#__PURE__*/ $exYeM.forwardRef(function MultiSectionDigitalClockSection(inProps, ref) {
    const containerRef = $exYeM.useRef(null);
    const handleRef = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(ref, containerRef);
    const previousActive = $exYeM.useRef(null);
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiMultiSectionDigitalClockSection"
    });
    const { autoFocus: autoFocus, onChange: onChange, className: className, disabled: disabled, readOnly: readOnly, items: items, active: active, slots: slots, slotProps: slotProps, skipDisabled: skipDisabled } = props, other = (0, $3L80X.default)(props, $9fa164fbcaec4773$var$_excluded);
    const ownerState = $exYeM.useMemo(()=>(0, $aJx1R.default)({}, props, {
            alreadyRendered: !!containerRef.current
        }), [
        props
    ]);
    const classes = $9fa164fbcaec4773$var$useUtilityClasses(ownerState);
    const DigitalClockSectionItem = slots?.digitalClockSectionItem ?? $9fa164fbcaec4773$var$MultiSectionDigitalClockSectionItem;
    $exYeM.useEffect(()=>{
        if (containerRef.current === null) return;
        const activeItem = containerRef.current.querySelector('[role="option"][tabindex="0"], [role="option"][aria-selected="true"]');
        if (active && autoFocus && activeItem) activeItem.focus();
        if (!activeItem || previousActive.current === activeItem) return;
        previousActive.current = activeItem;
        const offsetTop = activeItem.offsetTop;
        // Subtracting the 4px of extra margin intended for the first visible section item
        containerRef.current.scrollTop = offsetTop - 4;
    });
    const focusedOptionIndex = items.findIndex((item)=>item.isFocused(item.value));
    return /*#__PURE__*/ (0, $aSiaI.jsx)($9fa164fbcaec4773$var$MultiSectionDigitalClockSectionRoot, (0, $aJx1R.default)({
        ref: handleRef,
        className: (0, $4qr5a.default)(classes.root, className),
        ownerState: ownerState,
        autoFocusItem: autoFocus && active,
        role: "listbox"
    }, other, {
        children: items.map((option, index)=>{
            const isItemDisabled = option.isDisabled?.(option.value);
            const isDisabled = disabled || isItemDisabled;
            if (skipDisabled && isDisabled) return null;
            const isSelected = option.isSelected(option.value);
            const tabIndex = focusedOptionIndex === index || focusedOptionIndex === -1 && index === 0 ? 0 : -1;
            return /*#__PURE__*/ (0, $aSiaI.jsx)(DigitalClockSectionItem, (0, $aJx1R.default)({
                onClick: ()=>!readOnly && onChange(option.value),
                selected: isSelected,
                disabled: isDisabled,
                disableRipple: readOnly,
                role: "option",
                "aria-disabled": readOnly || isDisabled || undefined,
                "aria-label": option.ariaLabel,
                "aria-selected": isSelected,
                tabIndex: tabIndex,
                className: classes.item
            }, slotProps?.digitalClockSectionItem, {
                children: option.label
            }), option.label);
        })
    }));
});


const $88ddfbe3fd8da00c$export$9101aa7ba362bb4e = ({ now: now, value: value, utils: utils, ampm: ampm, isDisabled: isDisabled, resolveAriaLabel: resolveAriaLabel, timeStep: timeStep, valueOrReferenceDate: valueOrReferenceDate })=>{
    const currentHours = value ? utils.getHours(value) : null;
    const result = [];
    const isSelected = (hour, overriddenCurrentHours)=>{
        const resolvedCurrentHours = overriddenCurrentHours ?? currentHours;
        if (resolvedCurrentHours === null) return false;
        if (ampm) {
            if (hour === 12) return resolvedCurrentHours === 12 || resolvedCurrentHours === 0;
            return resolvedCurrentHours === hour || resolvedCurrentHours - 12 === hour;
        }
        return resolvedCurrentHours === hour;
    };
    const isFocused = (hour)=>{
        return isSelected(hour, utils.getHours(valueOrReferenceDate));
    };
    const endHour = ampm ? 11 : 23;
    for(let hour = 0; hour <= endHour; hour += timeStep){
        let label = utils.format(utils.setHours(now, hour), ampm ? "hours12h" : "hours24h");
        const ariaLabel = resolveAriaLabel(parseInt(label, 10).toString());
        label = utils.formatNumber(label);
        result.push({
            value: hour,
            label: label,
            isSelected: isSelected,
            isDisabled: isDisabled,
            isFocused: isFocused,
            ariaLabel: ariaLabel
        });
    }
    return result;
};
const $88ddfbe3fd8da00c$export$e7b56db95f8a7b9c = ({ value: value, utils: utils, isDisabled: isDisabled, timeStep: timeStep, resolveLabel: resolveLabel, resolveAriaLabel: resolveAriaLabel, hasValue: hasValue = true })=>{
    const isSelected = (timeValue)=>{
        if (value === null) return false;
        return hasValue && value === timeValue;
    };
    const isFocused = (timeValue)=>{
        return value === timeValue;
    };
    return [
        ...Array.from({
            length: Math.ceil(60 / timeStep)
        }, (_, index)=>{
            const timeValue = timeStep * index;
            return {
                value: timeValue,
                label: utils.formatNumber(resolveLabel(timeValue)),
                isDisabled: isDisabled,
                isSelected: isSelected,
                isFocused: isFocused,
                ariaLabel: resolveAriaLabel(timeValue.toString())
            };
        })
    ];
};







var $aSiaI = parcelRequire("aSiaI");
const $f7a129bcb64ac509$var$_excluded = [
    "ampm",
    "timeSteps",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "skipDisabled",
    "timezone"
];
const $f7a129bcb64ac509$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $772562b11cd511e9$export$b828b7724b7b2890), classes);
};
const $f7a129bcb64ac509$var$MultiSectionDigitalClockRoot = (0, $jawKn.default)((0, $d78818d135bdbc3a$export$512b066b8abdfde4), {
    name: "MuiMultiSectionDigitalClock",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        display: "flex",
        flexDirection: "row",
        width: "100%",
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const $f7a129bcb64ac509$export$c48dada788ff933b = /*#__PURE__*/ $exYeM.forwardRef(function MultiSectionDigitalClock(inProps, ref) {
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiMultiSectionDigitalClock"
    });
    const { ampm: ampm = utils.is12HourCycleInCurrentLocale(), timeSteps: inTimeSteps, autoFocus: autoFocus, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableTime: shouldDisableTime, onChange: onChange, view: inView, views: inViews = [
        "hours",
        "minutes"
    ], openTo: openTo, onViewChange: onViewChange, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, className: className, disabled: disabled, readOnly: readOnly, skipDisabled: skipDisabled = false, timezone: timezoneProp } = props, other = (0, $3L80X.default)(props, $f7a129bcb64ac509$var$_excluded);
    const { value: value, handleValueChange: handleRawValueChange, timezone: timezone } = (0, $3e4aef0ef80b275d$export$174d749f3b4c0f49)({
        name: "MultiSectionDigitalClock",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $efb258a9c0464e3f$export$2764b246aa3b75ba)
    });
    const localeText = (0, $58b82a9afc388fa3$export$24fdeaa0f591a73e)();
    const now = (0, $58b82a9afc388fa3$export$3a404aece3dff2fa)(timezone);
    const timeSteps = $exYeM.useMemo(()=>(0, $aJx1R.default)({
            hours: 1,
            minutes: 5,
            seconds: 5
        }, inTimeSteps), [
        inTimeSteps
    ]);
    const valueOrReferenceDate = (0, $8339625ea7b294db$export$86ee3b7a301faaa3)({
        value: value,
        referenceDate: referenceDateProp,
        utils: utils,
        props: props,
        timezone: timezone
    });
    const handleValueChange = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((newValue, selectionState, selectedView)=>handleRawValueChange(newValue, selectionState, selectedView));
    const views = $exYeM.useMemo(()=>{
        if (!ampm || !inViews.includes("hours")) return inViews;
        return inViews.includes("meridiem") ? inViews : [
            ...inViews,
            "meridiem"
        ];
    }, [
        ampm,
        inViews
    ]);
    const { view: view, setValueAndGoToNextView: setValueAndGoToNextView, focusedView: focusedView } = (0, $8d38a40b51f4c4fd$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: inFocusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const handleMeridiemValueChange = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((newValue)=>{
        setValueAndGoToNextView(newValue, "finish", "meridiem");
    });
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $064b27bbd099f1fc$export$6aaabc31cb076d17)(valueOrReferenceDate, ampm, handleMeridiemValueChange, "finish");
    const isTimeDisabled = $exYeM.useCallback((rawValue, viewType)=>{
        const isAfter = (0, $9509391b55697f91$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, utils);
        const shouldCheckPastEnd = viewType === "hours" || viewType === "minutes" && views.includes("seconds");
        const containsValidTime = ({ start: start, end: end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableTime) switch(viewType){
                case "hours":
                    return !shouldDisableTime(utils.setHours(valueOrReferenceDate, timeValue), "hours");
                case "minutes":
                    return !shouldDisableTime(utils.setMinutes(valueOrReferenceDate, timeValue), "minutes");
                case "seconds":
                    return !shouldDisableTime(utils.setSeconds(valueOrReferenceDate, timeValue), "seconds");
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case "hours":
                {
                    const valueWithMeridiem = (0, $9509391b55697f91$export$4159dc823695870e)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = utils.setHours(valueOrReferenceDate, valueWithMeridiem);
                    const start = utils.setSeconds(utils.setMinutes(dateWithNewHours, 0), 0);
                    const end = utils.setSeconds(utils.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case "minutes":
                {
                    const dateWithNewMinutes = utils.setMinutes(valueOrReferenceDate, rawValue);
                    const start = utils.setSeconds(dateWithNewMinutes, 0);
                    const end = utils.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case "seconds":
                {
                    const dateWithNewSeconds = utils.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error("not supported");
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableTime,
        utils,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const buildViewProps = $exYeM.useCallback((viewToBuild)=>{
        switch(viewToBuild){
            case "hours":
                return {
                    onChange: (hours)=>{
                        const valueWithMeridiem = (0, $9509391b55697f91$export$4159dc823695870e)(hours, meridiemMode, ampm);
                        setValueAndGoToNextView(utils.setHours(valueOrReferenceDate, valueWithMeridiem), "finish", "hours");
                    },
                    items: (0, $88ddfbe3fd8da00c$export$9101aa7ba362bb4e)({
                        now: now,
                        value: value,
                        ampm: ampm,
                        utils: utils,
                        isDisabled: (hours)=>isTimeDisabled(hours, "hours"),
                        timeStep: timeSteps.hours,
                        resolveAriaLabel: localeText.hoursClockNumberText,
                        valueOrReferenceDate: valueOrReferenceDate
                    })
                };
            case "minutes":
                return {
                    onChange: (minutes)=>{
                        setValueAndGoToNextView(utils.setMinutes(valueOrReferenceDate, minutes), "finish", "minutes");
                    },
                    items: (0, $88ddfbe3fd8da00c$export$e7b56db95f8a7b9c)({
                        value: utils.getMinutes(valueOrReferenceDate),
                        utils: utils,
                        isDisabled: (minutes)=>isTimeDisabled(minutes, "minutes"),
                        resolveLabel: (minutes)=>utils.format(utils.setMinutes(now, minutes), "minutes"),
                        timeStep: timeSteps.minutes,
                        hasValue: !!value,
                        resolveAriaLabel: localeText.minutesClockNumberText
                    })
                };
            case "seconds":
                return {
                    onChange: (seconds)=>{
                        setValueAndGoToNextView(utils.setSeconds(valueOrReferenceDate, seconds), "finish", "seconds");
                    },
                    items: (0, $88ddfbe3fd8da00c$export$e7b56db95f8a7b9c)({
                        value: utils.getSeconds(valueOrReferenceDate),
                        utils: utils,
                        isDisabled: (seconds)=>isTimeDisabled(seconds, "seconds"),
                        resolveLabel: (seconds)=>utils.format(utils.setSeconds(now, seconds), "seconds"),
                        timeStep: timeSteps.seconds,
                        hasValue: !!value,
                        resolveAriaLabel: localeText.secondsClockNumberText
                    })
                };
            case "meridiem":
                {
                    const amLabel = (0, $8c165bb53d94cf45$export$fae94c0a662107ef)(utils, "am");
                    const pmLabel = (0, $8c165bb53d94cf45$export$fae94c0a662107ef)(utils, "pm");
                    return {
                        onChange: handleMeridiemChange,
                        items: [
                            {
                                value: "am",
                                label: amLabel,
                                isSelected: ()=>!!value && meridiemMode === "am",
                                isFocused: ()=>!!valueOrReferenceDate && meridiemMode === "am",
                                ariaLabel: amLabel
                            },
                            {
                                value: "pm",
                                label: pmLabel,
                                isSelected: ()=>!!value && meridiemMode === "pm",
                                isFocused: ()=>!!valueOrReferenceDate && meridiemMode === "pm",
                                ariaLabel: pmLabel
                            }
                        ]
                    };
                }
            default:
                throw new Error(`Unknown view: ${viewToBuild} found.`);
        }
    }, [
        now,
        value,
        ampm,
        utils,
        timeSteps.hours,
        timeSteps.minutes,
        timeSteps.seconds,
        localeText.hoursClockNumberText,
        localeText.minutesClockNumberText,
        localeText.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        isTimeDisabled,
        handleMeridiemChange
    ]);
    const viewTimeOptions = $exYeM.useMemo(()=>{
        return views.reduce((result, currentView)=>{
            return (0, $aJx1R.default)({}, result, {
                [currentView]: buildViewProps(currentView)
            });
        }, {});
    }, [
        views,
        buildViewProps
    ]);
    const ownerState = props;
    const classes = $f7a129bcb64ac509$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($f7a129bcb64ac509$var$MultiSectionDigitalClockRoot, (0, $aJx1R.default)({
        ref: ref,
        className: (0, $4qr5a.default)(classes.root, className),
        ownerState: ownerState,
        role: "group"
    }, other, {
        children: Object.entries(viewTimeOptions).map(([timeView, viewOptions])=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $9fa164fbcaec4773$export$f971f93dc8464c), {
                items: viewOptions.items,
                onChange: viewOptions.onChange,
                active: view === timeView,
                autoFocus: autoFocus ?? focusedView === timeView,
                disabled: disabled,
                readOnly: readOnly,
                slots: slots,
                slotProps: slotProps,
                skipDisabled: skipDisabled,
                "aria-label": localeText.selectViewText(timeView)
            }, timeView))
    }));
});




var $aSiaI = parcelRequire("aSiaI");
const $1109f6c527e2c3b9$export$a3ad21a1b07c504f = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, minutesStep: minutesStep, ampm: ampm, ampmInClock: ampmInClock, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, showViewSwitcher: showViewSwitcher, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timezone: timezone })=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $e07e830cb93afef8$export$7e96244e18c4be57), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView && (0, $9509391b55697f91$export$8f04d380cefd5a0d)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $9509391b55697f91$export$8f04d380cefd5a0d)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        ampmInClock: ampmInClock,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        showViewSwitcher: showViewSwitcher,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timezone: timezone
    });
const $1109f6c527e2c3b9$export$a2917c76dc0aa7e = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, minutesStep: minutesStep, ampm: ampm, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timeSteps: timeSteps, skipDisabled: skipDisabled, timezone: timezone })=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $f6d51ca99b6aa77e$export$9a2b219a5b06deb7), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $9509391b55697f91$export$8f04d380cefd5a0d)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeStep: timeSteps?.minutes,
        skipDisabled: skipDisabled,
        timezone: timezone
    });
const $1109f6c527e2c3b9$export$48a290886291c531 = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, minutesStep: minutesStep, ampm: ampm, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timeSteps: timeSteps, skipDisabled: skipDisabled, timezone: timezone })=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $f7a129bcb64ac509$export$c48dada788ff933b), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $9509391b55697f91$export$8f04d380cefd5a0d)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeSteps: timeSteps,
        skipDisabled: skipDisabled,
        timezone: timezone
    });





parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");



var $aSiaI = parcelRequire("aSiaI");
/**
 * @ignore - internal component.
 */ function $cfdf00703055286e$export$4066d2955a85e052(props) {
    const { toolbar: toolbar, tabs: tabs, content: content, actionBar: actionBar, shortcuts: shortcuts } = (0, $acda522799264968$export$2e2bcd8739ae039)(props);
    const { sx: sx, className: className, isLandscape: isLandscape, ref: ref } = props;
    const isActionBarVisible = actionBar && (actionBar.props.actions?.length ?? 0) > 0;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $29c3cc0dfa80590a$export$9a9363506c13836), {
        ref: ref,
        className: (0, $4qr5a.default)(className, (0, $fd37cd49589c7ef4$export$7a6dac186703fe4c).root),
        sx: [
            {
                [`& .${(0, $fd37cd49589c7ef4$export$7a6dac186703fe4c).tabs}`]: {
                    gridRow: 4,
                    gridColumn: "1 / 4"
                },
                [`& .${(0, $fd37cd49589c7ef4$export$7a6dac186703fe4c).actionBar}`]: {
                    gridRow: 5
                }
            },
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ],
        ownerState: props,
        children: [
            isLandscape ? shortcuts : toolbar,
            isLandscape ? toolbar : shortcuts,
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $29c3cc0dfa80590a$export$bc1494d918129235), {
                className: (0, $fd37cd49589c7ef4$export$7a6dac186703fe4c).contentWrapper,
                sx: {
                    display: "grid"
                },
                children: [
                    content,
                    tabs,
                    isActionBarVisible && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a59c125ed1ac1385$export$2e2bcd8739ae039), {
                        sx: {
                            gridRow: 3,
                            gridColumn: "1 / 4"
                        }
                    })
                ]
            }),
            actionBar
        ]
    });
}



var $aSiaI = parcelRequire("aSiaI");
const $03dd2f11ea771fae$var$_excluded = [
    "openTo",
    "focusedView",
    "timeViewsCount"
];
const $03dd2f11ea771fae$var$rendererInterceptor = function rendererInterceptor(inViewRenderers, popperView, rendererProps) {
    const { openTo: openTo, focusedView: focusedView, timeViewsCount: timeViewsCount } = rendererProps, otherProps = (0, $3L80X.default)(rendererProps, $03dd2f11ea771fae$var$_excluded);
    const finalProps = (0, $aJx1R.default)({}, otherProps, {
        focusedView: null,
        sx: [
            {
                [`&.${(0, $772562b11cd511e9$export$f2277d947b8f7a8a).root}`]: {
                    borderBottom: 0
                },
                [`&.${(0, $772562b11cd511e9$export$f2277d947b8f7a8a).root}, .${(0, $2bd895433a76eb3d$export$eaf2b63fa45eff23).root}, &.${(0, $8c97f2c0b9520cf6$export$baf91642e79c8163).root}`]: {
                    maxHeight: (0, $5c20cfc7ef711f44$export$f2fef360e2df0cb7)
                }
            }
        ]
    });
    const isTimeViewActive = (0, $9509391b55697f91$export$a3328136ac50623d)(popperView);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
        children: [
            inViewRenderers[!isTimeViewActive ? popperView : "day"]?.((0, $aJx1R.default)({}, rendererProps, {
                view: !isTimeViewActive ? popperView : "day",
                focusedView: focusedView && (0, $8c165bb53d94cf45$export$b32dfef9f07dea64)(focusedView) ? focusedView : null,
                views: rendererProps.views.filter((0, $8c165bb53d94cf45$export$b32dfef9f07dea64)),
                sx: [
                    {
                        gridColumn: 1
                    },
                    ...finalProps.sx
                ]
            })),
            timeViewsCount > 0 && /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a59c125ed1ac1385$export$2e2bcd8739ae039), {
                        orientation: "vertical",
                        sx: {
                            gridColumn: 2
                        }
                    }),
                    inViewRenderers[isTimeViewActive ? popperView : "hours"]?.((0, $aJx1R.default)({}, finalProps, {
                        view: isTimeViewActive ? popperView : "hours",
                        focusedView: focusedView && (0, $9509391b55697f91$export$a3328136ac50623d)(focusedView) ? focusedView : null,
                        openTo: (0, $9509391b55697f91$export$a3328136ac50623d)(openTo) ? openTo : "hours",
                        views: rendererProps.views.filter((0, $9509391b55697f91$export$a3328136ac50623d)),
                        sx: [
                            {
                                gridColumn: 3
                            },
                            ...finalProps.sx
                        ]
                    }))
                ]
            })
        ]
    });
};
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DesktopDateTimePicker API](https://mui.com/x/api/date-pickers/desktop-date-time-picker/)
 */ const $03dd2f11ea771fae$export$74e5e82f1557571f = /*#__PURE__*/ $exYeM.forwardRef(function DesktopDateTimePicker(inProps, ref) {
    const localeText = (0, $58b82a9afc388fa3$export$24fdeaa0f591a73e)();
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    // Props with the default values common to all date time pickers
    const defaultizedProps = (0, $56f00f6f5078973e$export$6e4d96e87e6dc2d3)(inProps, "MuiDesktopDateTimePicker");
    const { shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn, thresholdToRenderTimeInASingleColumn: thresholdToRenderTimeInASingleColumn, views: resolvedViews, timeSteps: timeSteps } = (0, $709ad9785bb95632$export$e2d664f2dd4d34bc)(defaultizedProps);
    const renderTimeView = shouldRenderTimeInASingleColumn ? (0, $1109f6c527e2c3b9$export$a2917c76dc0aa7e) : (0, $1109f6c527e2c3b9$export$48a290886291c531);
    const viewRenderers = (0, $aJx1R.default)({
        day: (0, $bcd6cc69a16346cb$export$69888ffe06193e5e),
        month: (0, $bcd6cc69a16346cb$export$69888ffe06193e5e),
        year: (0, $bcd6cc69a16346cb$export$69888ffe06193e5e),
        hours: renderTimeView,
        minutes: renderTimeView,
        seconds: renderTimeView,
        meridiem: renderTimeView
    }, defaultizedProps.viewRenderers);
    const ampmInClock = defaultizedProps.ampmInClock ?? true;
    // Need to avoid adding the `meridiem` view when unexpected renderer is specified
    const shouldHoursRendererContainMeridiemView = viewRenderers.hours?.name === (0, $1109f6c527e2c3b9$export$48a290886291c531).name;
    const views = !shouldHoursRendererContainMeridiemView ? resolvedViews.filter((view)=>view !== "meridiem") : resolvedViews;
    const actionBarActions = shouldRenderTimeInASingleColumn ? [] : [
        "accept"
    ];
    // Props with the default values specific to the desktop variant
    const props = (0, $aJx1R.default)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $709ad9785bb95632$export$ebf7b30b32db6f57)(utils, defaultizedProps),
        views: views,
        yearsPerRow: defaultizedProps.yearsPerRow ?? 4,
        ampmInClock: ampmInClock,
        timeSteps: timeSteps,
        thresholdToRenderTimeInASingleColumn: thresholdToRenderTimeInASingleColumn,
        shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn,
        slots: (0, $aJx1R.default)({
            field: (0, $47a45eb129c83cdf$export$ae1ced156568f0b0),
            layout: (0, $cfdf00703055286e$export$4066d2955a85e052),
            openPickerIcon: (0, $ea58bbb735a57109$export$5fda1783bb83f57b)
        }, defaultizedProps.slots),
        slotProps: (0, $aJx1R.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $aJx1R.default)({}, (0, $269e73534f97f715$export$308c24034cde71de)(defaultizedProps.slotProps?.field, ownerState), (0, $b4c6ee3828695005$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                }),
            toolbar: (0, $aJx1R.default)({
                hidden: true,
                ampmInClock: ampmInClock,
                toolbarVariant: "desktop"
            }, defaultizedProps.slotProps?.toolbar),
            tabs: (0, $aJx1R.default)({
                hidden: true
            }, defaultizedProps.slotProps?.tabs),
            actionBar: (ownerState)=>(0, $aJx1R.default)({
                    actions: actionBarActions
                }, (0, $269e73534f97f715$export$308c24034cde71de)(defaultizedProps.slotProps?.actionBar, ownerState))
        })
    });
    const { renderPicker: renderPicker } = (0, $877e64d9c1b81de9$export$b1b70bc56ac5be0e)({
        props: props,
        valueManager: (0, $efb258a9c0464e3f$export$2764b246aa3b75ba),
        valueType: "date-time",
        getOpenDialogAriaText: props.localeText?.openDatePickerDialogue ?? localeText.openDatePickerDialogue,
        validator: (0, $c54e76c05355c08e$export$ed94a8ff1f54c4f),
        rendererInterceptor: $03dd2f11ea771fae$var$rendererInterceptor
    });
    return renderPicker();
});
$03dd2f11ea771fae$export$74e5e82f1557571f.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */ ampm: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * @default false
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "dense",
        "spacious"
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $5470a96ab2e549fc$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Maximal selectable date.
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */ maxDateTime: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Minimal selectable date.
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */ minDateTime: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "day",
        "hours",
        "meridiem",
        "minutes",
        "month",
        "seconds",
        "year"
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "landscape",
        "portrait"
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
            "all",
            "day",
            "empty",
            "hours",
            "meridiem",
            "minutes",
            "month",
            "seconds",
            "weekDay",
            "year"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */ skipDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object
    ]),
    /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */ thresholdToRenderTimeInASingleColumn: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
    /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */ timeSteps: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).shape({
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number
    }),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "day",
        "hours",
        "meridiem",
        "minutes",
        "month",
        "seconds",
        "year"
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        meridiem: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "day",
        "hours",
        "minutes",
        "month",
        "seconds",
        "year"
    ]).isRequired),
    /**
   * Years rendered per row.
   * @default 4
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        3,
        4
    ])
};



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $bisEj = parcelRequire("bisEj");












/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileDateTimePicker API](https://mui.com/x/api/date-pickers/mobile-date-time-picker/)
 */ const $497bd1d6a75e466d$export$5b4e219fe76d27da = /*#__PURE__*/ $exYeM.forwardRef(function MobileDateTimePicker(inProps, ref) {
    const localeText = (0, $58b82a9afc388fa3$export$24fdeaa0f591a73e)();
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    // Props with the default values common to all date time pickers
    const defaultizedProps = (0, $56f00f6f5078973e$export$6e4d96e87e6dc2d3)(inProps, "MuiMobileDateTimePicker");
    const viewRenderers = (0, $aJx1R.default)({
        day: (0, $bcd6cc69a16346cb$export$69888ffe06193e5e),
        month: (0, $bcd6cc69a16346cb$export$69888ffe06193e5e),
        year: (0, $bcd6cc69a16346cb$export$69888ffe06193e5e),
        hours: (0, $1109f6c527e2c3b9$export$a3ad21a1b07c504f),
        minutes: (0, $1109f6c527e2c3b9$export$a3ad21a1b07c504f),
        seconds: (0, $1109f6c527e2c3b9$export$a3ad21a1b07c504f)
    }, defaultizedProps.viewRenderers);
    const ampmInClock = defaultizedProps.ampmInClock ?? false;
    // Props with the default values specific to the mobile variant
    const props = (0, $aJx1R.default)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $709ad9785bb95632$export$ebf7b30b32db6f57)(utils, defaultizedProps),
        ampmInClock: ampmInClock,
        slots: (0, $aJx1R.default)({
            field: (0, $47a45eb129c83cdf$export$ae1ced156568f0b0)
        }, defaultizedProps.slots),
        slotProps: (0, $aJx1R.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $aJx1R.default)({}, (0, $269e73534f97f715$export$308c24034cde71de)(defaultizedProps.slotProps?.field, ownerState), (0, $b4c6ee3828695005$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                }),
            toolbar: (0, $aJx1R.default)({
                hidden: false,
                ampmInClock: ampmInClock
            }, defaultizedProps.slotProps?.toolbar),
            tabs: (0, $aJx1R.default)({
                hidden: false
            }, defaultizedProps.slotProps?.tabs)
        })
    });
    const { renderPicker: renderPicker } = (0, $352170f33fa9a6ec$export$5ca0153a626a7dd7)({
        props: props,
        valueManager: (0, $efb258a9c0464e3f$export$2764b246aa3b75ba),
        valueType: "date-time",
        getOpenDialogAriaText: props.localeText?.openDatePickerDialogue ?? localeText.openDatePickerDialogue,
        validator: (0, $c54e76c05355c08e$export$ed94a8ff1f54c4f)
    });
    return renderPicker();
});
$497bd1d6a75e466d$export$5b4e219fe76d27da.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */ ampm: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * @default false
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "dense",
        "spacious"
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $5470a96ab2e549fc$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Maximal selectable date.
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */ maxDateTime: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Minimal selectable date.
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */ minDateTime: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "day",
        "hours",
        "minutes",
        "month",
        "seconds",
        "year"
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "landscape",
        "portrait"
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
            "all",
            "day",
            "empty",
            "hours",
            "meridiem",
            "minutes",
            "month",
            "seconds",
            "weekDay",
            "year"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "day",
        "hours",
        "minutes",
        "month",
        "seconds",
        "year"
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "day",
        "hours",
        "minutes",
        "month",
        "seconds",
        "year"
    ]).isRequired),
    /**
   * Years rendered per row.
   * @default 3
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        3,
        4
    ])
};




var $aSiaI = parcelRequire("aSiaI");
const $a498d00daced0ec6$var$_excluded = [
    "desktopModeMediaQuery"
];
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DateTimePicker API](https://mui.com/x/api/date-pickers/date-time-picker/)
 */ const $a498d00daced0ec6$export$ccdfd7928785632e = /*#__PURE__*/ $exYeM.forwardRef(function DateTimePicker(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiDateTimePicker"
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = (0, $b335fe84785961a2$export$9ae5b19305db48ce) } = props, other = (0, $3L80X.default)(props, $a498d00daced0ec6$var$_excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $584e1e930413ffa8$export$2e2bcd8739ae039)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $03dd2f11ea771fae$export$74e5e82f1557571f), (0, $aJx1R.default)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $497bd1d6a75e466d$export$5b4e219fe76d27da), (0, $aJx1R.default)({
        ref: ref
    }, other));
});



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");



var $7PWLt = parcelRequire("7PWLt");


var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $bisEj = parcelRequire("bisEj");




var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");



var $7PWLt = parcelRequire("7PWLt");







const $907b16462b98a63b$export$4c842f6a241dc825 = (inProps)=>{
    const props = (0, $88316b2eb4f82d5f$export$e740b972b66c04cd)(inProps);
    const { forwardedProps: forwardedProps, internalProps: internalProps } = (0, $853af466154b1a1f$export$cdde224d2939fd84)(props, "time");
    return (0, $7690ea9019a90c7e$export$294aa081a6c6f55d)({
        forwardedProps: forwardedProps,
        internalProps: internalProps,
        valueManager: (0, $efb258a9c0464e3f$export$2764b246aa3b75ba),
        fieldValueManager: (0, $efb258a9c0464e3f$export$b602c94f557316b4),
        validator: (0, $f095ffad38756cf8$export$7bd013ac69eb590c),
        valueType: "time"
    });
};






var $aSiaI = parcelRequire("aSiaI");
const $2fc756a03ce5c7c0$var$_excluded = [
    "slots",
    "slotProps",
    "InputProps",
    "inputProps"
];
/**
 * Demos:
 *
 * - [TimeField](http://mui.com/x/react-date-pickers/time-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [TimeField API](https://mui.com/x/api/date-pickers/time-field/)
 */ const $2fc756a03ce5c7c0$export$5eaee2322dd727eb = /*#__PURE__*/ $exYeM.forwardRef(function TimeField(inProps, inRef) {
    const themeProps = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiTimeField"
    });
    const { slots: slots, slotProps: slotProps, InputProps: InputProps, inputProps: inputProps } = themeProps, other = (0, $3L80X.default)(themeProps, $2fc756a03ce5c7c0$var$_excluded);
    const ownerState = themeProps;
    const TextField = slots?.textField ?? (inProps.enableAccessibleFieldDOMStructure ? (0, $84f942149d3b2e85$export$b3e9b101d92e4d4d) : (0, $18a733eef46a7fb6$export$2e2bcd8739ae039));
    const textFieldProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: TextField,
        externalSlotProps: slotProps?.textField,
        externalForwardedProps: other,
        ownerState: ownerState,
        additionalProps: {
            ref: inRef
        }
    });
    // TODO: Remove when mui/material-ui#35088 will be merged
    textFieldProps.inputProps = (0, $aJx1R.default)({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = (0, $aJx1R.default)({}, InputProps, textFieldProps.InputProps);
    const fieldResponse = (0, $907b16462b98a63b$export$4c842f6a241dc825)(textFieldProps);
    const convertedFieldResponse = (0, $b9597e90c73e1a8f$export$20bf15d9b24b4dad)(fieldResponse);
    const processedFieldProps = (0, $2933e748b8e88f5f$export$db9644cdb7e3d432)((0, $aJx1R.default)({}, convertedFieldResponse, {
        slots: slots,
        slotProps: slotProps
    }));
    return /*#__PURE__*/ (0, $aSiaI.jsx)(TextField, (0, $aJx1R.default)({}, processedFieldProps));
});



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $7PWLt = parcelRequire("7PWLt");


var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");
parcelRequire("exYeM");

var $4qr5a = parcelRequire("4qr5a");

var $bisEj = parcelRequire("bisEj");

var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");

var $2f0D3 = parcelRequire("2f0D3");







var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
function $506b71c12af7efd7$export$56e751cdf7deddcb(slot) {
    return (0, $dC5O8.default)("MuiTimePickerToolbar", slot);
}
const $506b71c12af7efd7$export$b6febfcac6caa550 = (0, $kY7HX.default)("MuiTimePickerToolbar", [
    "root",
    "separator",
    "hourMinuteLabel",
    "hourMinuteLabelLandscape",
    "hourMinuteLabelReverse",
    "ampmSelection",
    "ampmLandscape",
    "ampmLabel"
]);




var $aSiaI = parcelRequire("aSiaI");
const $e5cbcf19c918ed37$var$_excluded = [
    "ampm",
    "ampmInClock",
    "value",
    "isLandscape",
    "onChange",
    "view",
    "onViewChange",
    "views",
    "disabled",
    "readOnly",
    "className"
];
const $e5cbcf19c918ed37$var$useUtilityClasses = (ownerState)=>{
    const { theme: theme, isLandscape: isLandscape, classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        separator: [
            "separator"
        ],
        hourMinuteLabel: [
            "hourMinuteLabel",
            isLandscape && "hourMinuteLabelLandscape",
            theme.direction === "rtl" && "hourMinuteLabelReverse"
        ],
        ampmSelection: [
            "ampmSelection",
            isLandscape && "ampmLandscape"
        ],
        ampmLabel: [
            "ampmLabel"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $506b71c12af7efd7$export$56e751cdf7deddcb), classes);
};
const $e5cbcf19c918ed37$var$TimePickerToolbarRoot = (0, $jawKn.default)((0, $63224012835b0abe$export$eb3c4d84783d6feb), {
    name: "MuiTimePickerToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $e5cbcf19c918ed37$var$TimePickerToolbarSeparator = (0, $jawKn.default)((0, $59ab981dcb971055$export$2006bc630443fa2), {
    name: "MuiTimePickerToolbar",
    slot: "Separator",
    overridesResolver: (props, styles)=>styles.separator
})({
    outline: 0,
    margin: "0 4px 0 2px",
    cursor: "default"
});
const $e5cbcf19c918ed37$var$TimePickerToolbarHourMinuteLabel = (0, $jawKn.default)("div", {
    name: "MuiTimePickerToolbar",
    slot: "HourMinuteLabel",
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, $506b71c12af7efd7$export$b6febfcac6caa550).hourMinuteLabelLandscape}`]: styles.hourMinuteLabelLandscape,
                [`&.${(0, $506b71c12af7efd7$export$b6febfcac6caa550).hourMinuteLabelReverse}`]: styles.hourMinuteLabelReverse
            },
            styles.hourMinuteLabel
        ]
})(({ theme: theme })=>(0, $aJx1R.default)({
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-end"
    }, theme.direction === "rtl" && {
        flexDirection: "row-reverse"
    }, {
        variants: [
            {
                props: {
                    isLandscape: true
                },
                style: {
                    marginTop: "auto"
                }
            }
        ]
    }));
$e5cbcf19c918ed37$var$TimePickerToolbarHourMinuteLabel.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    as: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).elementType,
    ownerState: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object.isRequired,
    sx: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object
    ])
};
const $e5cbcf19c918ed37$var$TimePickerToolbarAmPmSelection = (0, $jawKn.default)("div", {
    name: "MuiTimePickerToolbar",
    slot: "AmPmSelection",
    overridesResolver: (props, styles)=>[
            {
                [`.${(0, $506b71c12af7efd7$export$b6febfcac6caa550).ampmLabel}`]: styles.ampmLabel
            },
            {
                [`&.${(0, $506b71c12af7efd7$export$b6febfcac6caa550).ampmLandscape}`]: styles.ampmLandscape
            },
            styles.ampmSelection
        ]
})({
    display: "flex",
    flexDirection: "column",
    marginRight: "auto",
    marginLeft: 12,
    [`& .${(0, $506b71c12af7efd7$export$b6febfcac6caa550).ampmLabel}`]: {
        fontSize: 17
    },
    variants: [
        {
            props: {
                isLandscape: true
            },
            style: {
                margin: "4px 0 auto",
                flexDirection: "row",
                justifyContent: "space-around",
                flexBasis: "100%"
            }
        }
    ]
});
$e5cbcf19c918ed37$var$TimePickerToolbarAmPmSelection.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    as: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).elementType,
    ownerState: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object.isRequired,
    sx: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object
    ])
};
/**
 * Demos:
 *
 * - [TimePicker](https://mui.com/x/react-date-pickers/time-picker/)
 * - [Custom components](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [TimePickerToolbar API](https://mui.com/x/api/date-pickers/time-picker-toolbar/)
 */ function $e5cbcf19c918ed37$export$76f7aa019fd43cd9(inProps) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiTimePickerToolbar"
    });
    const { ampm: ampm, ampmInClock: ampmInClock, value: value, isLandscape: isLandscape, onChange: onChange, view: view, onViewChange: onViewChange, views: views, disabled: disabled, readOnly: readOnly, className: className } = props, other = (0, $3L80X.default)(props, $e5cbcf19c918ed37$var$_excluded);
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const localeText = (0, $58b82a9afc388fa3$export$24fdeaa0f591a73e)();
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const showAmPmControl = Boolean(ampm && !ampmInClock && views.includes("hours"));
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $064b27bbd099f1fc$export$6aaabc31cb076d17)(value, ampm, onChange);
    const formatHours = (time)=>ampm ? utils.format(time, "hours12h") : utils.format(time, "hours24h");
    const ownerState = props;
    const classes = $e5cbcf19c918ed37$var$useUtilityClasses((0, $aJx1R.default)({}, ownerState, {
        theme: theme
    }));
    const separator = /*#__PURE__*/ (0, $aSiaI.jsx)($e5cbcf19c918ed37$var$TimePickerToolbarSeparator, {
        tabIndex: -1,
        value: ":",
        variant: "h3",
        selected: false,
        className: classes.separator
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($e5cbcf19c918ed37$var$TimePickerToolbarRoot, (0, $aJx1R.default)({
        landscapeDirection: "row",
        toolbarTitle: localeText.timePickerToolbarTitle,
        isLandscape: isLandscape,
        ownerState: ownerState,
        className: (0, $4qr5a.default)(classes.root, className)
    }, other, {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)($e5cbcf19c918ed37$var$TimePickerToolbarHourMinuteLabel, {
                className: classes.hourMinuteLabel,
                ownerState: ownerState,
                children: [
                    (0, $b335fe84785961a2$export$22012a5c726bef55)(views, "hours") && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $35c12ca1dd6a73cd$export$614ed940168c780c), {
                        tabIndex: -1,
                        variant: "h3",
                        onClick: ()=>onViewChange("hours"),
                        selected: view === "hours",
                        value: value ? formatHours(value) : "--"
                    }),
                    (0, $b335fe84785961a2$export$22012a5c726bef55)(views, [
                        "hours",
                        "minutes"
                    ]) && separator,
                    (0, $b335fe84785961a2$export$22012a5c726bef55)(views, "minutes") && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $35c12ca1dd6a73cd$export$614ed940168c780c), {
                        tabIndex: -1,
                        variant: "h3",
                        onClick: ()=>onViewChange("minutes"),
                        selected: view === "minutes",
                        value: value ? utils.format(value, "minutes") : "--"
                    }),
                    (0, $b335fe84785961a2$export$22012a5c726bef55)(views, [
                        "minutes",
                        "seconds"
                    ]) && separator,
                    (0, $b335fe84785961a2$export$22012a5c726bef55)(views, "seconds") && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $35c12ca1dd6a73cd$export$614ed940168c780c), {
                        variant: "h3",
                        onClick: ()=>onViewChange("seconds"),
                        selected: view === "seconds",
                        value: value ? utils.format(value, "seconds") : "--"
                    })
                ]
            }),
            showAmPmControl && /*#__PURE__*/ (0, $aSiaI.jsxs)($e5cbcf19c918ed37$var$TimePickerToolbarAmPmSelection, {
                className: classes.ampmSelection,
                ownerState: ownerState,
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $35c12ca1dd6a73cd$export$614ed940168c780c), {
                        disableRipple: true,
                        variant: "subtitle2",
                        selected: meridiemMode === "am",
                        typographyClassName: classes.ampmLabel,
                        value: (0, $8c165bb53d94cf45$export$fae94c0a662107ef)(utils, "am"),
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange("am"),
                        disabled: disabled
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $35c12ca1dd6a73cd$export$614ed940168c780c), {
                        disableRipple: true,
                        variant: "subtitle2",
                        selected: meridiemMode === "pm",
                        typographyClassName: classes.ampmLabel,
                        value: (0, $8c165bb53d94cf45$export$fae94c0a662107ef)(utils, "pm"),
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange("pm"),
                        disabled: disabled
                    })
                ]
            })
        ]
    }));
}



function $3e79cec9f350f7ae$export$586c31b46cc238ba(props, name) {
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    const themeProps = (0, $7PWLt.default)({
        props: props,
        name: name
    });
    const ampm = themeProps.ampm ?? utils.is12HourCycleInCurrentLocale();
    const localeText = $exYeM.useMemo(()=>{
        if (themeProps.localeText?.toolbarTitle == null) return themeProps.localeText;
        return (0, $aJx1R.default)({}, themeProps.localeText, {
            timePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    return (0, $aJx1R.default)({}, themeProps, {
        ampm: ampm,
        localeText: localeText
    }, (0, $a33a4d7002be5215$export$bdf8d867ddc968e)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            "hours",
            "minutes"
        ],
        defaultOpenTo: "hours"
    }), {
        disableFuture: themeProps.disableFuture ?? false,
        disablePast: themeProps.disablePast ?? false,
        slots: (0, $aJx1R.default)({
            toolbar: (0, $e5cbcf19c918ed37$export$76f7aa019fd43cd9)
        }, themeProps.slots),
        slotProps: (0, $aJx1R.default)({}, themeProps.slotProps, {
            toolbar: (0, $aJx1R.default)({
                ampm: ampm,
                ampmInClock: themeProps.ampmInClock
            }, themeProps.slotProps?.toolbar)
        })
    });
}










/**
 * Demos:
 *
 * - [TimePicker](https://mui.com/x/react-date-pickers/time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DesktopTimePicker API](https://mui.com/x/api/date-pickers/desktop-time-picker/)
 */ const $ce57bc9eebb348f5$export$c2eea9c279c6035b = /*#__PURE__*/ $exYeM.forwardRef(function DesktopTimePicker(inProps, ref) {
    const localeText = (0, $58b82a9afc388fa3$export$24fdeaa0f591a73e)();
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    // Props with the default values common to all time pickers
    const defaultizedProps = (0, $3e79cec9f350f7ae$export$586c31b46cc238ba)(inProps, "MuiDesktopTimePicker");
    const { shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn, views: resolvedViews, timeSteps: timeSteps } = (0, $709ad9785bb95632$export$e2d664f2dd4d34bc)(defaultizedProps);
    const renderTimeView = shouldRenderTimeInASingleColumn ? (0, $1109f6c527e2c3b9$export$a2917c76dc0aa7e) : (0, $1109f6c527e2c3b9$export$48a290886291c531);
    const viewRenderers = (0, $aJx1R.default)({
        hours: renderTimeView,
        minutes: renderTimeView,
        seconds: renderTimeView,
        meridiem: renderTimeView
    }, defaultizedProps.viewRenderers);
    const ampmInClock = defaultizedProps.ampmInClock ?? true;
    const actionBarActions = shouldRenderTimeInASingleColumn ? [] : [
        "accept"
    ];
    // Need to avoid adding the `meridiem` view when unexpected renderer is specified
    const shouldHoursRendererContainMeridiemView = viewRenderers.hours?.name === (0, $1109f6c527e2c3b9$export$48a290886291c531).name;
    const views = !shouldHoursRendererContainMeridiemView ? resolvedViews.filter((view)=>view !== "meridiem") : resolvedViews;
    // Props with the default values specific to the desktop variant
    const props = (0, $aJx1R.default)({}, defaultizedProps, {
        ampmInClock: ampmInClock,
        timeSteps: timeSteps,
        viewRenderers: viewRenderers,
        format: (0, $9509391b55697f91$export$3a6776b3863772fe)(utils, defaultizedProps),
        // Setting only `hours` time view in case of single column time picker
        // Allows for easy view lifecycle management
        views: shouldRenderTimeInASingleColumn ? [
            "hours"
        ] : views,
        slots: (0, $aJx1R.default)({
            field: (0, $2fc756a03ce5c7c0$export$5eaee2322dd727eb),
            openPickerIcon: (0, $ea58bbb735a57109$export$8099ab97743c966c)
        }, defaultizedProps.slots),
        slotProps: (0, $aJx1R.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $aJx1R.default)({}, (0, $269e73534f97f715$export$308c24034cde71de)(defaultizedProps.slotProps?.field, ownerState), (0, $b4c6ee3828695005$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                }),
            toolbar: (0, $aJx1R.default)({
                hidden: true,
                ampmInClock: ampmInClock
            }, defaultizedProps.slotProps?.toolbar),
            actionBar: (0, $aJx1R.default)({
                actions: actionBarActions
            }, defaultizedProps.slotProps?.actionBar)
        })
    });
    const { renderPicker: renderPicker } = (0, $877e64d9c1b81de9$export$b1b70bc56ac5be0e)({
        props: props,
        valueManager: (0, $efb258a9c0464e3f$export$2764b246aa3b75ba),
        valueType: "time",
        getOpenDialogAriaText: props.localeText?.openTimePickerDialogue ?? localeText.openTimePickerDialogue,
        validator: (0, $f095ffad38756cf8$export$7bd013ac69eb590c)
    });
    return renderPicker();
});
$ce57bc9eebb348f5$export$c2eea9c279c6035b.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */ ampm: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * @default false
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).any,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "dense",
        "spacious"
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $5470a96ab2e549fc$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).node,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "hours",
        "meridiem",
        "minutes",
        "seconds"
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "landscape",
        "portrait"
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
            "all",
            "day",
            "empty",
            "hours",
            "meridiem",
            "minutes",
            "month",
            "seconds",
            "weekDay",
            "year"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number
    ]),
    /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */ skipDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object
    ]),
    /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */ thresholdToRenderTimeInASingleColumn: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
    /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */ timeSteps: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).shape({
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number
    }),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "hours",
        "meridiem",
        "minutes",
        "seconds"
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).shape({
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        meridiem: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "hours",
        "minutes",
        "seconds"
    ]).isRequired)
};



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $bisEj = parcelRequire("bisEj");











/**
 * Demos:
 *
 * - [TimePicker](https://mui.com/x/react-date-pickers/time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileTimePicker API](https://mui.com/x/api/date-pickers/mobile-time-picker/)
 */ const $42027fa9f82f4afd$export$984018df37898b81 = /*#__PURE__*/ $exYeM.forwardRef(function MobileTimePicker(inProps, ref) {
    const localeText = (0, $58b82a9afc388fa3$export$24fdeaa0f591a73e)();
    const utils = (0, $58b82a9afc388fa3$export$1163b47e39508a46)();
    // Props with the default values common to all time pickers
    const defaultizedProps = (0, $3e79cec9f350f7ae$export$586c31b46cc238ba)(inProps, "MuiMobileTimePicker");
    const viewRenderers = (0, $aJx1R.default)({
        hours: (0, $1109f6c527e2c3b9$export$a3ad21a1b07c504f),
        minutes: (0, $1109f6c527e2c3b9$export$a3ad21a1b07c504f),
        seconds: (0, $1109f6c527e2c3b9$export$a3ad21a1b07c504f)
    }, defaultizedProps.viewRenderers);
    const ampmInClock = defaultizedProps.ampmInClock ?? false;
    // Props with the default values specific to the mobile variant
    const props = (0, $aJx1R.default)({}, defaultizedProps, {
        ampmInClock: ampmInClock,
        viewRenderers: viewRenderers,
        format: (0, $9509391b55697f91$export$3a6776b3863772fe)(utils, defaultizedProps),
        slots: (0, $aJx1R.default)({
            field: (0, $2fc756a03ce5c7c0$export$5eaee2322dd727eb)
        }, defaultizedProps.slots),
        slotProps: (0, $aJx1R.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $aJx1R.default)({}, (0, $269e73534f97f715$export$308c24034cde71de)(defaultizedProps.slotProps?.field, ownerState), (0, $b4c6ee3828695005$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                }),
            toolbar: (0, $aJx1R.default)({
                hidden: false,
                ampmInClock: ampmInClock
            }, defaultizedProps.slotProps?.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $352170f33fa9a6ec$export$5ca0153a626a7dd7)({
        props: props,
        valueManager: (0, $efb258a9c0464e3f$export$2764b246aa3b75ba),
        valueType: "time",
        getOpenDialogAriaText: props.localeText?.openTimePickerDialogue ?? localeText.openTimePickerDialogue,
        validator: (0, $f095ffad38756cf8$export$7bd013ac69eb590c)
    });
    return renderPicker();
});
$42027fa9f82f4afd$export$984018df37898b81.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */ ampm: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * @default false
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).any,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "dense",
        "spacious"
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $5470a96ab2e549fc$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).node,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "hours",
        "minutes",
        "seconds"
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "landscape",
        "portrait"
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
            "all",
            "day",
            "empty",
            "hours",
            "meridiem",
            "minutes",
            "month",
            "seconds",
            "weekDay",
            "year"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number
    ]),
    /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "hours",
        "minutes",
        "seconds"
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).shape({
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "hours",
        "minutes",
        "seconds"
    ]).isRequired)
};




var $aSiaI = parcelRequire("aSiaI");
const $d8b0b6b29e8c007d$var$_excluded = [
    "desktopModeMediaQuery"
];
/**
 * Demos:
 *
 * - [TimePicker](https://mui.com/x/react-date-pickers/time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [TimePicker API](https://mui.com/x/api/date-pickers/time-picker/)
 */ const $d8b0b6b29e8c007d$export$5f876910ea565cd3 = /*#__PURE__*/ $exYeM.forwardRef(function TimePicker(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiTimePicker"
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = (0, $b335fe84785961a2$export$9ae5b19305db48ce) } = props, other = (0, $3L80X.default)(props, $d8b0b6b29e8c007d$var$_excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $584e1e930413ffa8$export$2e2bcd8739ae039)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ce57bc9eebb348f5$export$c2eea9c279c6035b), (0, $aJx1R.default)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $42027fa9f82f4afd$export$984018df37898b81), (0, $aJx1R.default)({
        ref: ref
    }, other));
});




var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");



var $2f0D3 = parcelRequire("2f0D3");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $g5OQF = parcelRequire("g5OQF");
function $df9cdd9fc85cf733$export$94fd53d40f0652a(array1, array2, itemComparer = (a, b)=>a === b) {
    return array1.length === array2.length && array1.every((value, index)=>itemComparer(value, array2[index]));
}


"use client";
const $b7f1f90273f68f70$var$INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function $b7f1f90273f68f70$var$asc(a, b) {
    return a - b;
}
function $b7f1f90273f68f70$var$findClosest(values, currentValue) {
    var _values$reduce;
    const { index: closestIndex } = (_values$reduce = values.reduce((acc, value, index)=>{
        const distance = Math.abs(currentValue - value);
        if (acc === null || distance < acc.distance || distance === acc.distance) return {
            distance: distance,
            index: index
        };
        return acc;
    }, null)) != null ? _values$reduce : {};
    return closestIndex;
}
function $b7f1f90273f68f70$var$trackFinger(event, touchId) {
    // The event is TouchEvent
    if (touchId.current !== undefined && event.changedTouches) {
        const touchEvent = event;
        for(let i = 0; i < touchEvent.changedTouches.length; i += 1){
            const touch = touchEvent.changedTouches[i];
            if (touch.identifier === touchId.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    // The event is MouseEvent
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $b7f1f90273f68f70$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $b7f1f90273f68f70$var$percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function $b7f1f90273f68f70$var$getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        const parts = num.toExponential().split("e-");
        const matissaDecimalPart = parts[0].split(".")[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    const decimalPart = num.toString().split(".")[1];
    return decimalPart ? decimalPart.length : 0;
}
function $b7f1f90273f68f70$var$roundValueToStep(value, step, min) {
    const nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed($b7f1f90273f68f70$var$getDecimalPrecision(step)));
}
function $b7f1f90273f68f70$var$setValueIndex({ values: values, newValue: newValue, index: index }) {
    const output = values.slice();
    output[index] = newValue;
    return output.sort($b7f1f90273f68f70$var$asc);
}
function $b7f1f90273f68f70$var$focusThumb({ sliderRef: sliderRef, activeIndex: activeIndex, setActive: setActive }) {
    var _sliderRef$current, _doc$activeElement;
    const doc = (0, $0d47b1cc144b9266$export$2e2bcd8739ae039)(sliderRef.current);
    if (!((_sliderRef$current = sliderRef.current) != null && _sliderRef$current.contains(doc.activeElement)) || Number(doc == null || (_doc$activeElement = doc.activeElement) == null ? void 0 : _doc$activeElement.getAttribute("data-index")) !== activeIndex) {
        var _sliderRef$current2;
        (_sliderRef$current2 = sliderRef.current) == null || _sliderRef$current2.querySelector(`[type="range"][data-index="${activeIndex}"]`).focus();
    }
    if (setActive) setActive(activeIndex);
}
function $b7f1f90273f68f70$var$areValuesEqual(newValue, oldValue) {
    if (typeof newValue === "number" && typeof oldValue === "number") return newValue === oldValue;
    if (typeof newValue === "object" && typeof oldValue === "object") return (0, $df9cdd9fc85cf733$export$94fd53d40f0652a)(newValue, oldValue);
    return false;
}
const $b7f1f90273f68f70$var$axisProps = {
    horizontal: {
        offset: (percent)=>({
                left: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    "horizontal-reverse": {
        offset: (percent)=>({
                right: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    vertical: {
        offset: (percent)=>({
                bottom: `${percent}%`
            }),
        leap: (percent)=>({
                height: `${percent}%`
            })
    }
};
const $b7f1f90273f68f70$export$544bf02140fa9a77 = (x)=>x;
// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
let $b7f1f90273f68f70$var$cachedSupportsTouchActionNone;
function $b7f1f90273f68f70$var$doesSupportTouchActionNone() {
    if ($b7f1f90273f68f70$var$cachedSupportsTouchActionNone === undefined) {
        if (typeof CSS !== "undefined" && typeof CSS.supports === "function") $b7f1f90273f68f70$var$cachedSupportsTouchActionNone = CSS.supports("touch-action", "none");
        else $b7f1f90273f68f70$var$cachedSupportsTouchActionNone = true;
    }
    return $b7f1f90273f68f70$var$cachedSupportsTouchActionNone;
}
function $b7f1f90273f68f70$export$56b2c08e277f365(parameters) {
    const { "aria-labelledby": ariaLabelledby, defaultValue: defaultValue, disabled: disabled = false, disableSwap: disableSwap = false, isRtl: isRtl = false, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = "horizontal", rootRef: ref, scale: scale = $b7f1f90273f68f70$export$544bf02140fa9a77, step: step = 1, shiftStep: shiftStep = 10, tabIndex: tabIndex, value: valueProp } = parameters;
    const touchId = $exYeM.useRef();
    // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transferred when inversing a range slider.
    const [active, setActive] = $exYeM.useState(-1);
    const [open, setOpen] = $exYeM.useState(-1);
    const [dragging, setDragging] = $exYeM.useState(false);
    const moveCount = $exYeM.useRef(0);
    const [valueDerived, setValueState] = (0, $d86ef59ee77e84fd$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue != null ? defaultValue : min,
        name: "Slider"
    });
    const handleChange = onChange && ((event, value, thumbIndex)=>{
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        // @ts-ignore The nativeEvent is function, not object
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, "target", {
            writable: true,
            value: {
                value: value,
                name: name
            }
        });
        onChange(clonedEvent, value, thumbIndex);
    });
    const range = Array.isArray(valueDerived);
    let values = range ? valueDerived.slice().sort($b7f1f90273f68f70$var$asc) : [
        valueDerived
    ];
    values = values.map((value)=>value == null ? min : (0, $g5OQF.default)(value, min, max));
    const marks = marksProp === true && step !== null ? [
        ...Array(Math.floor((max - min) / step) + 1)
    ].map((_, index)=>({
            value: min + step * index
        })) : marksProp || [];
    const marksValues = marks.map((mark)=>mark.value);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $c165a4ae7d98def4$export$2e2bcd8739ae039)();
    const [focusedThumbIndex, setFocusedThumbIndex] = $exYeM.useState(-1);
    const sliderRef = $exYeM.useRef();
    const handleFocusRef = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(focusVisibleRef, sliderRef);
    const handleRef = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(ref, handleFocusRef);
    const createHandleHiddenInputFocus = (otherHandlers)=>(event)=>{
            var _otherHandlers$onFocu;
            const index = Number(event.currentTarget.getAttribute("data-index"));
            handleFocusVisible(event);
            if (isFocusVisibleRef.current === true) setFocusedThumbIndex(index);
            setOpen(index);
            otherHandlers == null || (_otherHandlers$onFocu = otherHandlers.onFocus) == null || _otherHandlers$onFocu.call(otherHandlers, event);
        };
    const createHandleHiddenInputBlur = (otherHandlers)=>(event)=>{
            var _otherHandlers$onBlur;
            handleBlurVisible(event);
            if (isFocusVisibleRef.current === false) setFocusedThumbIndex(-1);
            setOpen(-1);
            otherHandlers == null || (_otherHandlers$onBlur = otherHandlers.onBlur) == null || _otherHandlers$onBlur.call(otherHandlers, event);
        };
    const changeValue = (event, valueInput)=>{
        const index = Number(event.currentTarget.getAttribute("data-index"));
        const value = values[index];
        const marksIndex = marksValues.indexOf(value);
        let newValue = valueInput;
        if (marks && step == null) {
            const maxMarksValue = marksValues[marksValues.length - 1];
            if (newValue > maxMarksValue) newValue = maxMarksValue;
            else if (newValue < marksValues[0]) newValue = marksValues[0];
            else newValue = newValue < value ? marksValues[marksIndex - 1] : marksValues[marksIndex + 1];
        }
        newValue = (0, $g5OQF.default)(newValue, min, max);
        if (range) {
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $g5OQF.default)(newValue, values[index - 1] || -Infinity, values[index + 1] || Infinity);
            const previousValue = newValue;
            newValue = $b7f1f90273f68f70$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: index
            });
            let activeIndex = index;
            // Potentially swap the index if needed.
            if (!disableSwap) activeIndex = newValue.indexOf(previousValue);
            $b7f1f90273f68f70$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex
            });
        }
        setValueState(newValue);
        setFocusedThumbIndex(index);
        if (handleChange && !$b7f1f90273f68f70$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, index);
        if (onChangeCommitted) onChangeCommitted(event, newValue);
    };
    const createHandleHiddenInputKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            // The Shift + Up/Down keyboard shortcuts for moving the slider makes sense to be supported
            // only if the step is defined. If the step is null, this means tha the marks are used for specifying the valid values.
            if (step !== null) {
                const index = Number(event.currentTarget.getAttribute("data-index"));
                const value = values[index];
                let newValue = null;
                if ((event.key === "ArrowLeft" || event.key === "ArrowDown") && event.shiftKey || event.key === "PageDown") newValue = Math.max(value - shiftStep, min);
                else if ((event.key === "ArrowRight" || event.key === "ArrowUp") && event.shiftKey || event.key === "PageUp") newValue = Math.min(value + shiftStep, max);
                if (newValue !== null) {
                    changeValue(event, newValue);
                    event.preventDefault();
                }
            }
            otherHandlers == null || (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
        };
    (0, $c4c3f9798cb7fddc$export$2e2bcd8739ae039)(()=>{
        if (disabled && sliderRef.current.contains(document.activeElement)) {
            var _document$activeEleme;
            // This is necessary because Firefox and Safari will keep focus
            // on a disabled element:
            // https://codesandbox.io/p/sandbox/mui-pr-22247-forked-h151h?file=/src/App.js
            // @ts-ignore
            (_document$activeEleme = document.activeElement) == null || _document$activeEleme.blur();
        }
    }, [
        disabled
    ]);
    if (disabled && active !== -1) setActive(-1);
    if (disabled && focusedThumbIndex !== -1) setFocusedThumbIndex(-1);
    const createHandleHiddenInputChange = (otherHandlers)=>(event)=>{
            var _otherHandlers$onChan;
            (_otherHandlers$onChan = otherHandlers.onChange) == null || _otherHandlers$onChan.call(otherHandlers, event);
            // @ts-ignore
            changeValue(event, event.target.valueAsNumber);
        };
    const previousIndex = $exYeM.useRef();
    let axis = orientation;
    if (isRtl && orientation === "horizontal") axis += "-reverse";
    const getFingerNewValue = ({ finger: finger, move: move = false })=>{
        const { current: slider } = sliderRef;
        const { width: width, height: height, bottom: bottom, left: left } = slider.getBoundingClientRect();
        let percent;
        if (axis.indexOf("vertical") === 0) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.indexOf("-reverse") !== -1) percent = 1 - percent;
        let newValue;
        newValue = $b7f1f90273f68f70$var$percentToValue(percent, min, max);
        if (step) newValue = $b7f1f90273f68f70$var$roundValueToStep(newValue, step, min);
        else {
            const closestIndex = $b7f1f90273f68f70$var$findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = (0, $g5OQF.default)(newValue, min, max);
        let activeIndex = 0;
        if (range) {
            if (!move) activeIndex = $b7f1f90273f68f70$var$findClosest(values, newValue);
            else activeIndex = previousIndex.current;
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $g5OQF.default)(newValue, values[activeIndex - 1] || -Infinity, values[activeIndex + 1] || Infinity);
            const previousValue = newValue;
            newValue = $b7f1f90273f68f70$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: activeIndex
            });
            // Potentially swap the index if needed.
            if (!(disableSwap && move)) {
                activeIndex = newValue.indexOf(previousValue);
                previousIndex.current = activeIndex;
            }
        }
        return {
            newValue: newValue,
            activeIndex: activeIndex
        };
    };
    const handleTouchMove = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $b7f1f90273f68f70$var$trackFinger(nativeEvent, touchId);
        if (!finger) return;
        moveCount.current += 1;
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        // @ts-ignore buttons doesn't not exists on touch event
        if (nativeEvent.type === "mousemove" && nativeEvent.buttons === 0) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            handleTouchEnd(nativeEvent);
            return;
        }
        const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
            finger: finger,
            move: true
        });
        $b7f1f90273f68f70$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (!dragging && moveCount.current > $b7f1f90273f68f70$var$INTENTIONAL_DRAG_COUNT_THRESHOLD) setDragging(true);
        if (handleChange && !$b7f1f90273f68f70$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
    });
    const handleTouchEnd = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $b7f1f90273f68f70$var$trackFinger(nativeEvent, touchId);
        setDragging(false);
        if (!finger) return;
        const { newValue: newValue } = getFingerNewValue({
            finger: finger,
            move: true
        });
        setActive(-1);
        if (nativeEvent.type === "touchend") setOpen(-1);
        if (onChangeCommitted) onChangeCommitted(nativeEvent, newValue);
        touchId.current = undefined;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
    });
    const handleTouchStart = (0, $4d8fa1c1fa1ae4cf$export$2e2bcd8739ae039)((nativeEvent)=>{
        if (disabled) return;
        // If touch-action: none; is not supported we need to prevent the scroll manually.
        if (!$b7f1f90273f68f70$var$doesSupportTouchActionNone()) nativeEvent.preventDefault();
        const touch = nativeEvent.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const finger = $b7f1f90273f68f70$var$trackFinger(nativeEvent, touchId);
        if (finger !== false) {
            const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                finger: finger
            });
            $b7f1f90273f68f70$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex,
                setActive: setActive
            });
            setValueState(newValue);
            if (handleChange && !$b7f1f90273f68f70$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
        }
        moveCount.current = 0;
        const doc = (0, $0d47b1cc144b9266$export$2e2bcd8739ae039)(sliderRef.current);
        doc.addEventListener("touchmove", handleTouchMove, {
            passive: true
        });
        doc.addEventListener("touchend", handleTouchEnd, {
            passive: true
        });
    });
    const stopListening = $exYeM.useCallback(()=>{
        const doc = (0, $0d47b1cc144b9266$export$2e2bcd8739ae039)(sliderRef.current);
        doc.removeEventListener("mousemove", handleTouchMove);
        doc.removeEventListener("mouseup", handleTouchEnd);
        doc.removeEventListener("touchmove", handleTouchMove);
        doc.removeEventListener("touchend", handleTouchEnd);
    }, [
        handleTouchEnd,
        handleTouchMove
    ]);
    $exYeM.useEffect(()=>{
        const { current: slider } = sliderRef;
        slider.addEventListener("touchstart", handleTouchStart, {
            passive: $b7f1f90273f68f70$var$doesSupportTouchActionNone()
        });
        return ()=>{
            slider.removeEventListener("touchstart", handleTouchStart);
            stopListening();
        };
    }, [
        stopListening,
        handleTouchStart
    ]);
    $exYeM.useEffect(()=>{
        if (disabled) stopListening();
    }, [
        disabled,
        stopListening
    ]);
    const createHandleMouseDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous;
            (_otherHandlers$onMous = otherHandlers.onMouseDown) == null || _otherHandlers$onMous.call(otherHandlers, event);
            if (disabled) return;
            if (event.defaultPrevented) return;
            // Only handle left clicks
            if (event.button !== 0) return;
            // Avoid text selection
            event.preventDefault();
            const finger = $b7f1f90273f68f70$var$trackFinger(event, touchId);
            if (finger !== false) {
                const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                    finger: finger
                });
                $b7f1f90273f68f70$var$focusThumb({
                    sliderRef: sliderRef,
                    activeIndex: activeIndex,
                    setActive: setActive
                });
                setValueState(newValue);
                if (handleChange && !$b7f1f90273f68f70$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, activeIndex);
            }
            moveCount.current = 0;
            const doc = (0, $0d47b1cc144b9266$export$2e2bcd8739ae039)(sliderRef.current);
            doc.addEventListener("mousemove", handleTouchMove, {
                passive: true
            });
            doc.addEventListener("mouseup", handleTouchEnd);
        };
    const trackOffset = $b7f1f90273f68f70$export$83ce4bc8280540e6(range ? values[0] : min, min, max);
    const trackLeap = $b7f1f90273f68f70$export$83ce4bc8280540e6(values[values.length - 1], min, max) - trackOffset;
    const getRootProps = (externalProps = {})=>{
        const externalHandlers = (0, $2e067879f82a8818$export$24d5698b57eff81c)(externalProps);
        const ownEventHandlers = {
            onMouseDown: createHandleMouseDown(externalHandlers || {})
        };
        const mergedEventHandlers = (0, $aJx1R.default)({}, externalHandlers, ownEventHandlers);
        return (0, $aJx1R.default)({}, externalProps, {
            ref: handleRef
        }, mergedEventHandlers);
    };
    const createHandleMouseOver = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous2;
            (_otherHandlers$onMous2 = otherHandlers.onMouseOver) == null || _otherHandlers$onMous2.call(otherHandlers, event);
            const index = Number(event.currentTarget.getAttribute("data-index"));
            setOpen(index);
        };
    const createHandleMouseLeave = (otherHandlers)=>(event)=>{
            var _otherHandlers$onMous3;
            (_otherHandlers$onMous3 = otherHandlers.onMouseLeave) == null || _otherHandlers$onMous3.call(otherHandlers, event);
            setOpen(-1);
        };
    const getThumbProps = (externalProps = {})=>{
        const externalHandlers = (0, $2e067879f82a8818$export$24d5698b57eff81c)(externalProps);
        const ownEventHandlers = {
            onMouseOver: createHandleMouseOver(externalHandlers || {}),
            onMouseLeave: createHandleMouseLeave(externalHandlers || {})
        };
        return (0, $aJx1R.default)({}, externalProps, externalHandlers, ownEventHandlers);
    };
    const getThumbStyle = (index)=>{
        return {
            // So the non active thumb doesn't show its label on hover.
            pointerEvents: active !== -1 && active !== index ? "none" : undefined
        };
    };
    const getHiddenInputProps = (externalProps = {})=>{
        var _parameters$step;
        const externalHandlers = (0, $2e067879f82a8818$export$24d5698b57eff81c)(externalProps);
        const ownEventHandlers = {
            onChange: createHandleHiddenInputChange(externalHandlers || {}),
            onFocus: createHandleHiddenInputFocus(externalHandlers || {}),
            onBlur: createHandleHiddenInputBlur(externalHandlers || {}),
            onKeyDown: createHandleHiddenInputKeyDown(externalHandlers || {})
        };
        const mergedEventHandlers = (0, $aJx1R.default)({}, externalHandlers, ownEventHandlers);
        return (0, $aJx1R.default)({
            tabIndex: tabIndex,
            "aria-labelledby": ariaLabelledby,
            "aria-orientation": orientation,
            "aria-valuemax": scale(max),
            "aria-valuemin": scale(min),
            name: name,
            type: "range",
            min: parameters.min,
            max: parameters.max,
            step: parameters.step === null && parameters.marks ? "any" : (_parameters$step = parameters.step) != null ? _parameters$step : undefined,
            disabled: disabled
        }, externalProps, mergedEventHandlers, {
            style: (0, $aJx1R.default)({}, (0, $a8f86375c8e8d1e6$export$2e2bcd8739ae039), {
                direction: isRtl ? "rtl" : "ltr",
                // So that VoiceOver's focus indicator matches the thumb's dimensions
                width: "100%",
                height: "100%"
            })
        });
    };
    return {
        active: active,
        axis: axis,
        axisProps: $b7f1f90273f68f70$var$axisProps,
        dragging: dragging,
        focusedThumbIndex: focusedThumbIndex,
        getHiddenInputProps: getHiddenInputProps,
        getRootProps: getRootProps,
        getThumbProps: getThumbProps,
        marks: marks,
        open: open,
        range: range,
        rootRef: handleRef,
        trackLeap: trackLeap,
        trackOffset: trackOffset,
        values: values,
        getThumbStyle: getThumbStyle
    };
}



var $8L988 = parcelRequire("8L988");


var $jawKn = parcelRequire("jawKn");

var $iclFT = parcelRequire("iclFT");

const $849c99d613c8f9b2$var$shouldSpreadAdditionalProps = (Slot)=>{
    return !Slot || !(0, $6d812737487786ea$export$e28348cc2430497)(Slot);
};
var $849c99d613c8f9b2$export$2e2bcd8739ae039 = $849c99d613c8f9b2$var$shouldSpreadAdditionalProps;



var $fXwzw = parcelRequire("fXwzw");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $e70f9fef3062caa5$export$9f59f2622d5cbc2a(slot) {
    return (0, $dC5O8.default)("MuiSlider", slot);
}
const $e70f9fef3062caa5$var$sliderClasses = (0, $kY7HX.default)("MuiSlider", [
    "root",
    "active",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "disabled",
    "dragging",
    "focusVisible",
    "mark",
    "markActive",
    "marked",
    "markLabel",
    "markLabelActive",
    "rail",
    "sizeSmall",
    "thumb",
    "thumbColorPrimary",
    "thumbColorSecondary",
    "thumbColorError",
    "thumbColorSuccess",
    "thumbColorInfo",
    "thumbColorWarning",
    "track",
    "trackInverted",
    "trackFalse",
    "thumbSizeSmall",
    "valueLabel",
    "valueLabelOpen",
    "valueLabelCircle",
    "valueLabelLabel",
    "vertical"
]);
var $e70f9fef3062caa5$export$2e2bcd8739ae039 = $e70f9fef3062caa5$var$sliderClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $ed764273a0f791f9$var$useValueLabelClasses = (props)=>{
    const { open: open } = props;
    const utilityClasses = {
        offset: (0, $4qr5a.default)(open && (0, $e70f9fef3062caa5$export$2e2bcd8739ae039).valueLabelOpen),
        circle: (0, $e70f9fef3062caa5$export$2e2bcd8739ae039).valueLabelCircle,
        label: (0, $e70f9fef3062caa5$export$2e2bcd8739ae039).valueLabelLabel
    };
    return utilityClasses;
};
function $ed764273a0f791f9$export$2e2bcd8739ae039(props) {
    const { children: children, className: className, value: value } = props;
    const classes = $ed764273a0f791f9$var$useValueLabelClasses(props);
    if (!children) return null;
    return /*#__PURE__*/ $exYeM.cloneElement(children, {
        className: (0, $4qr5a.default)(children.props.className)
    }, /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
        children: [
            children.props.children,
            /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                className: (0, $4qr5a.default)(classes.offset, className),
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                    className: classes.circle,
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        className: classes.label,
                        children: value
                    })
                })
            })
        ]
    }));
}




var $aSiaI = parcelRequire("aSiaI");
"use client";
const $b4abdcb1f4222ad1$var$_excluded = [
    "aria-label",
    "aria-valuetext",
    "aria-labelledby",
    "component",
    "components",
    "componentsProps",
    "color",
    "classes",
    "className",
    "disableSwap",
    "disabled",
    "getAriaLabel",
    "getAriaValueText",
    "marks",
    "max",
    "min",
    "name",
    "onChange",
    "onChangeCommitted",
    "orientation",
    "shiftStep",
    "size",
    "step",
    "scale",
    "slotProps",
    "slots",
    "tabIndex",
    "track",
    "value",
    "valueLabelDisplay",
    "valueLabelFormat"
];
const $b4abdcb1f4222ad1$var$useThemeProps = (0, $800517e42ce363ac$export$ff8356348e0cc878)("MuiSlider");
function $b4abdcb1f4222ad1$var$Identity(x) {
    return x;
}
const $b4abdcb1f4222ad1$export$c1a21b3b4da66aa1 = (0, $jawKn.default)("span", {
    name: "MuiSlider",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $fXwzw.default)(ownerState.color)}`],
            ownerState.size !== "medium" && styles[`size${(0, $fXwzw.default)(ownerState.size)}`],
            ownerState.marked && styles.marked,
            ownerState.orientation === "vertical" && styles.vertical,
            ownerState.track === "inverted" && styles.trackInverted,
            ownerState.track === false && styles.trackFalse
        ];
    }
})(({ theme: theme })=>{
    var _theme$vars;
    return {
        borderRadius: 12,
        boxSizing: "content-box",
        display: "inline-block",
        position: "relative",
        cursor: "pointer",
        touchAction: "none",
        WebkitTapHighlightColor: "transparent",
        "@media print": {
            colorAdjust: "exact"
        },
        [`&.${(0, $e70f9fef3062caa5$export$2e2bcd8739ae039).disabled}`]: {
            pointerEvents: "none",
            cursor: "default",
            color: (theme.vars || theme).palette.grey[400]
        },
        [`&.${(0, $e70f9fef3062caa5$export$2e2bcd8739ae039).dragging}`]: {
            [`& .${(0, $e70f9fef3062caa5$export$2e2bcd8739ae039).thumb}, & .${(0, $e70f9fef3062caa5$export$2e2bcd8739ae039).track}`]: {
                transition: "none"
            }
        },
        variants: [
            ...Object.keys(((_theme$vars = theme.vars) != null ? _theme$vars : theme).palette).filter((key)=>{
                var _theme$vars2;
                return ((_theme$vars2 = theme.vars) != null ? _theme$vars2 : theme).palette[key].main;
            }).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    orientation: "horizontal"
                },
                style: {
                    height: 4,
                    width: "100%",
                    padding: "13px 0",
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    "@media (pointer: coarse)": {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: "20px 0"
                    }
                }
            },
            {
                props: {
                    orientation: "horizontal",
                    size: "small"
                },
                style: {
                    height: 2
                }
            },
            {
                props: {
                    orientation: "horizontal",
                    marked: true
                },
                style: {
                    marginBottom: 20
                }
            },
            {
                props: {
                    orientation: "vertical"
                },
                style: {
                    height: "100%",
                    width: 4,
                    padding: "0 13px",
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    "@media (pointer: coarse)": {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: "0 20px"
                    }
                }
            },
            {
                props: {
                    orientation: "vertical",
                    size: "small"
                },
                style: {
                    width: 2
                }
            },
            {
                props: {
                    orientation: "vertical",
                    marked: true
                },
                style: {
                    marginRight: 44
                }
            }
        ]
    };
});
const $b4abdcb1f4222ad1$export$b02fde61a3559c2 = (0, $jawKn.default)("span", {
    name: "MuiSlider",
    slot: "Rail",
    overridesResolver: (props, styles)=>styles.rail
})({
    display: "block",
    position: "absolute",
    borderRadius: "inherit",
    backgroundColor: "currentColor",
    opacity: 0.38,
    variants: [
        {
            props: {
                orientation: "horizontal"
            },
            style: {
                width: "100%",
                height: "inherit",
                top: "50%",
                transform: "translateY(-50%)"
            }
        },
        {
            props: {
                orientation: "vertical"
            },
            style: {
                height: "100%",
                width: "inherit",
                left: "50%",
                transform: "translateX(-50%)"
            }
        },
        {
            props: {
                track: "inverted"
            },
            style: {
                opacity: 1
            }
        }
    ]
});
const $b4abdcb1f4222ad1$export$105594979f116971 = (0, $jawKn.default)("span", {
    name: "MuiSlider",
    slot: "Track",
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>{
    var _theme$vars3;
    return {
        display: "block",
        position: "absolute",
        borderRadius: "inherit",
        border: "1px solid currentColor",
        backgroundColor: "currentColor",
        transition: theme.transitions.create([
            "left",
            "width",
            "bottom",
            "height"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    size: "small"
                },
                style: {
                    border: "none"
                }
            },
            {
                props: {
                    orientation: "horizontal"
                },
                style: {
                    height: "inherit",
                    top: "50%",
                    transform: "translateY(-50%)"
                }
            },
            {
                props: {
                    orientation: "vertical"
                },
                style: {
                    width: "inherit",
                    left: "50%",
                    transform: "translateX(-50%)"
                }
            },
            {
                props: {
                    track: false
                },
                style: {
                    display: "none"
                }
            },
            ...Object.keys(((_theme$vars3 = theme.vars) != null ? _theme$vars3 : theme).palette).filter((key)=>{
                var _theme$vars4;
                return ((_theme$vars4 = theme.vars) != null ? _theme$vars4 : theme).palette[key].main;
            }).map((color)=>({
                    props: {
                        color: color,
                        track: "inverted"
                    },
                    style: (0, $aJx1R.default)({}, theme.vars ? {
                        backgroundColor: theme.vars.palette.Slider[`${color}Track`],
                        borderColor: theme.vars.palette.Slider[`${color}Track`]
                    } : (0, $aJx1R.default)({
                        backgroundColor: (0, $8L988.lighten)(theme.palette[color].main, 0.62),
                        borderColor: (0, $8L988.lighten)(theme.palette[color].main, 0.62)
                    }, theme.applyStyles("dark", {
                        backgroundColor: (0, $8L988.darken)(theme.palette[color].main, 0.5)
                    }), theme.applyStyles("dark", {
                        borderColor: (0, $8L988.darken)(theme.palette[color].main, 0.5)
                    })))
                }))
        ]
    };
});
const $b4abdcb1f4222ad1$export$2c1b491743890dec = (0, $jawKn.default)("span", {
    name: "MuiSlider",
    slot: "Thumb",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.thumb,
            styles[`thumbColor${(0, $fXwzw.default)(ownerState.color)}`],
            ownerState.size !== "medium" && styles[`thumbSize${(0, $fXwzw.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>{
    var _theme$vars5;
    return {
        position: "absolute",
        width: 20,
        height: 20,
        boxSizing: "border-box",
        borderRadius: "50%",
        outline: 0,
        backgroundColor: "currentColor",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: theme.transitions.create([
            "box-shadow",
            "left",
            "bottom"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        "&::before": {
            position: "absolute",
            content: '""',
            borderRadius: "inherit",
            width: "100%",
            height: "100%",
            boxShadow: (theme.vars || theme).shadows[2]
        },
        "&::after": {
            position: "absolute",
            content: '""',
            borderRadius: "50%",
            // 42px is the hit target
            width: 42,
            height: 42,
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
        },
        [`&.${(0, $e70f9fef3062caa5$export$2e2bcd8739ae039).disabled}`]: {
            "&:hover": {
                boxShadow: "none"
            }
        },
        variants: [
            ...Object.keys(((_theme$vars5 = theme.vars) != null ? _theme$vars5 : theme).palette).filter((key)=>{
                var _theme$vars6;
                return ((_theme$vars6 = theme.vars) != null ? _theme$vars6 : theme).palette[key].main;
            }).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&:hover, &.${(0, $e70f9fef3062caa5$export$2e2bcd8739ae039).focusVisible}`]: (0, $aJx1R.default)({}, theme.vars ? {
                            boxShadow: `0px 0px 0px 8px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
                        } : {
                            boxShadow: `0px 0px 0px 8px ${(0, $8L988.alpha)(theme.palette[color].main, 0.16)}`
                        }, {
                            "@media (hover: none)": {
                                boxShadow: "none"
                            }
                        }),
                        [`&.${(0, $e70f9fef3062caa5$export$2e2bcd8739ae039).active}`]: (0, $aJx1R.default)({}, theme.vars ? {
                            boxShadow: `0px 0px 0px 14px rgba(${theme.vars.palette[color].mainChannel} / 0.16)}`
                        } : {
                            boxShadow: `0px 0px 0px 14px ${(0, $8L988.alpha)(theme.palette[color].main, 0.16)}`
                        })
                    }
                })),
            {
                props: {
                    size: "small"
                },
                style: {
                    width: 12,
                    height: 12,
                    "&::before": {
                        boxShadow: "none"
                    }
                }
            },
            {
                props: {
                    orientation: "horizontal"
                },
                style: {
                    top: "50%",
                    transform: "translate(-50%, -50%)"
                }
            },
            {
                props: {
                    orientation: "vertical"
                },
                style: {
                    left: "50%",
                    transform: "translate(-50%, 50%)"
                }
            }
        ]
    };
});
const $b4abdcb1f4222ad1$export$6453176f504d54f0 = (0, $jawKn.default)((0, $ed764273a0f791f9$export$2e2bcd8739ae039), {
    name: "MuiSlider",
    slot: "ValueLabel",
    overridesResolver: (props, styles)=>styles.valueLabel
})(({ theme: theme })=>(0, $aJx1R.default)({
        zIndex: 1,
        whiteSpace: "nowrap"
    }, theme.typography.body2, {
        fontWeight: 500,
        transition: theme.transitions.create([
            "transform"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        position: "absolute",
        backgroundColor: (theme.vars || theme).palette.grey[600],
        borderRadius: 2,
        color: (theme.vars || theme).palette.common.white,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0.25rem 0.75rem",
        variants: [
            {
                props: {
                    orientation: "horizontal"
                },
                style: {
                    transform: "translateY(-100%) scale(0)",
                    top: "-10px",
                    transformOrigin: "bottom center",
                    "&::before": {
                        position: "absolute",
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: "translate(-50%, 50%) rotate(45deg)",
                        backgroundColor: "inherit",
                        bottom: 0,
                        left: "50%"
                    },
                    [`&.${(0, $e70f9fef3062caa5$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: "translateY(-100%) scale(1)"
                    }
                }
            },
            {
                props: {
                    orientation: "vertical"
                },
                style: {
                    transform: "translateY(-50%) scale(0)",
                    right: "30px",
                    top: "50%",
                    transformOrigin: "right center",
                    "&::before": {
                        position: "absolute",
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: "translate(-50%, -50%) rotate(45deg)",
                        backgroundColor: "inherit",
                        right: -8,
                        top: "50%"
                    },
                    [`&.${(0, $e70f9fef3062caa5$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: "translateY(-50%) scale(1)"
                    }
                }
            },
            {
                props: {
                    size: "small"
                },
                style: {
                    fontSize: theme.typography.pxToRem(12),
                    padding: "0.25rem 0.5rem"
                }
            },
            {
                props: {
                    orientation: "vertical",
                    size: "small"
                },
                style: {
                    right: "20px"
                }
            }
        ]
    }));
const $b4abdcb1f4222ad1$export$6f85f6a3c5da6f62 = (0, $jawKn.default)("span", {
    name: "MuiSlider",
    slot: "Mark",
    shouldForwardProp: (prop)=>(0, $iclFT.default)(prop) && prop !== "markActive",
    overridesResolver: (props, styles)=>{
        const { markActive: markActive } = props;
        return [
            styles.mark,
            markActive && styles.markActive
        ];
    }
})(({ theme: theme })=>({
        position: "absolute",
        width: 2,
        height: 2,
        borderRadius: 1,
        backgroundColor: "currentColor",
        variants: [
            {
                props: {
                    orientation: "horizontal"
                },
                style: {
                    top: "50%",
                    transform: "translate(-1px, -50%)"
                }
            },
            {
                props: {
                    orientation: "vertical"
                },
                style: {
                    left: "50%",
                    transform: "translate(-50%, 1px)"
                }
            },
            {
                props: {
                    markActive: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.background.paper,
                    opacity: 0.8
                }
            }
        ]
    }));
const $b4abdcb1f4222ad1$export$e6cd369965e5aa95 = (0, $jawKn.default)("span", {
    name: "MuiSlider",
    slot: "MarkLabel",
    shouldForwardProp: (prop)=>(0, $iclFT.default)(prop) && prop !== "markLabelActive",
    overridesResolver: (props, styles)=>styles.markLabel
})(({ theme: theme })=>(0, $aJx1R.default)({}, theme.typography.body2, {
        color: (theme.vars || theme).palette.text.secondary,
        position: "absolute",
        whiteSpace: "nowrap",
        variants: [
            {
                props: {
                    orientation: "horizontal"
                },
                style: {
                    top: 30,
                    transform: "translateX(-50%)",
                    "@media (pointer: coarse)": {
                        top: 40
                    }
                }
            },
            {
                props: {
                    orientation: "vertical"
                },
                style: {
                    left: 36,
                    transform: "translateY(50%)",
                    "@media (pointer: coarse)": {
                        left: 44
                    }
                }
            },
            {
                props: {
                    markLabelActive: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            }
        ]
    }));
const $b4abdcb1f4222ad1$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dragging: dragging, marked: marked, orientation: orientation, track: track, classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            dragging && "dragging",
            marked && "marked",
            orientation === "vertical" && "vertical",
            track === "inverted" && "trackInverted",
            track === false && "trackFalse",
            color && `color${(0, $fXwzw.default)(color)}`,
            size && `size${(0, $fXwzw.default)(size)}`
        ],
        rail: [
            "rail"
        ],
        track: [
            "track"
        ],
        mark: [
            "mark"
        ],
        markActive: [
            "markActive"
        ],
        markLabel: [
            "markLabel"
        ],
        markLabelActive: [
            "markLabelActive"
        ],
        valueLabel: [
            "valueLabel"
        ],
        thumb: [
            "thumb",
            disabled && "disabled",
            size && `thumbSize${(0, $fXwzw.default)(size)}`,
            color && `thumbColor${(0, $fXwzw.default)(color)}`
        ],
        active: [
            "active"
        ],
        disabled: [
            "disabled"
        ],
        focusVisible: [
            "focusVisible"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $e70f9fef3062caa5$export$9f59f2622d5cbc2a), classes);
};
const $b4abdcb1f4222ad1$var$Forward = ({ children: children })=>children;
const $b4abdcb1f4222ad1$var$Slider = /*#__PURE__*/ $exYeM.forwardRef(function Slider(inputProps, ref) {
    var _ref, _slots$root, _ref2, _slots$rail, _ref3, _slots$track, _ref4, _slots$thumb, _ref5, _slots$valueLabel, _ref6, _slots$mark, _ref7, _slots$markLabel, _ref8, _slots$input, _slotProps$root, _slotProps$rail, _slotProps$track, _slotProps$thumb, _slotProps$valueLabel, _slotProps$mark, _slotProps$markLabel, _slotProps$input;
    const props = $b4abdcb1f4222ad1$var$useThemeProps({
        props: inputProps,
        name: "MuiSlider"
    });
    const isRtl = (0, $f6d0b5039025b20a$export$b2dd014b6c321cb)();
    const { "aria-label": ariaLabel, "aria-valuetext": ariaValuetext, "aria-labelledby": ariaLabelledby, component: // eslint-disable-next-line react/prop-types
    component = "span", components: components = {}, componentsProps: componentsProps = {}, color: color = "primary", classes: classesProp, className: className, disableSwap: disableSwap = false, disabled: disabled = false, getAriaLabel: getAriaLabel, getAriaValueText: getAriaValueText, marks: marksProp = false, max: max = 100, min: min = 0, orientation: orientation = "horizontal", shiftStep: shiftStep = 10, size: size = "medium", step: step = 1, scale: scale = $b4abdcb1f4222ad1$var$Identity, slotProps: slotProps, slots: slots, track: track = "normal", valueLabelDisplay: valueLabelDisplay = "off", valueLabelFormat: valueLabelFormat = $b4abdcb1f4222ad1$var$Identity } = props, other = (0, $3L80X.default)(props, $b4abdcb1f4222ad1$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        isRtl: isRtl,
        max: max,
        min: min,
        classes: classesProp,
        disabled: disabled,
        disableSwap: disableSwap,
        orientation: orientation,
        marks: marksProp,
        color: color,
        size: size,
        step: step,
        shiftStep: shiftStep,
        scale: scale,
        track: track,
        valueLabelDisplay: valueLabelDisplay,
        valueLabelFormat: valueLabelFormat
    });
    const { axisProps: axisProps, getRootProps: getRootProps, getHiddenInputProps: getHiddenInputProps, getThumbProps: getThumbProps, open: open, active: active, axis: axis, focusedThumbIndex: focusedThumbIndex, range: range, dragging: dragging, marks: marks, values: values, trackOffset: trackOffset, trackLeap: trackLeap, getThumbStyle: getThumbStyle } = (0, $b7f1f90273f68f70$export$56b2c08e277f365)((0, $aJx1R.default)({}, ownerState, {
        rootRef: ref
    }));
    ownerState.marked = marks.length > 0 && marks.some((mark)=>mark.label);
    ownerState.dragging = dragging;
    ownerState.focusedThumbIndex = focusedThumbIndex;
    const classes = $b4abdcb1f4222ad1$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $b4abdcb1f4222ad1$export$c1a21b3b4da66aa1;
    const RailSlot = (_ref2 = (_slots$rail = slots == null ? void 0 : slots.rail) != null ? _slots$rail : components.Rail) != null ? _ref2 : $b4abdcb1f4222ad1$export$b02fde61a3559c2;
    const TrackSlot = (_ref3 = (_slots$track = slots == null ? void 0 : slots.track) != null ? _slots$track : components.Track) != null ? _ref3 : $b4abdcb1f4222ad1$export$105594979f116971;
    const ThumbSlot = (_ref4 = (_slots$thumb = slots == null ? void 0 : slots.thumb) != null ? _slots$thumb : components.Thumb) != null ? _ref4 : $b4abdcb1f4222ad1$export$2c1b491743890dec;
    const ValueLabelSlot = (_ref5 = (_slots$valueLabel = slots == null ? void 0 : slots.valueLabel) != null ? _slots$valueLabel : components.ValueLabel) != null ? _ref5 : $b4abdcb1f4222ad1$export$6453176f504d54f0;
    const MarkSlot = (_ref6 = (_slots$mark = slots == null ? void 0 : slots.mark) != null ? _slots$mark : components.Mark) != null ? _ref6 : $b4abdcb1f4222ad1$export$6f85f6a3c5da6f62;
    const MarkLabelSlot = (_ref7 = (_slots$markLabel = slots == null ? void 0 : slots.markLabel) != null ? _slots$markLabel : components.MarkLabel) != null ? _ref7 : $b4abdcb1f4222ad1$export$e6cd369965e5aa95;
    const InputSlot = (_ref8 = (_slots$input = slots == null ? void 0 : slots.input) != null ? _slots$input : components.Input) != null ? _ref8 : "input";
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const railSlotProps = (_slotProps$rail = slotProps == null ? void 0 : slotProps.rail) != null ? _slotProps$rail : componentsProps.rail;
    const trackSlotProps = (_slotProps$track = slotProps == null ? void 0 : slotProps.track) != null ? _slotProps$track : componentsProps.track;
    const thumbSlotProps = (_slotProps$thumb = slotProps == null ? void 0 : slotProps.thumb) != null ? _slotProps$thumb : componentsProps.thumb;
    const valueLabelSlotProps = (_slotProps$valueLabel = slotProps == null ? void 0 : slotProps.valueLabel) != null ? _slotProps$valueLabel : componentsProps.valueLabel;
    const markSlotProps = (_slotProps$mark = slotProps == null ? void 0 : slotProps.mark) != null ? _slotProps$mark : componentsProps.mark;
    const markLabelSlotProps = (_slotProps$markLabel = slotProps == null ? void 0 : slotProps.markLabel) != null ? _slotProps$markLabel : componentsProps.markLabel;
    const inputSlotProps = (_slotProps$input = slotProps == null ? void 0 : slotProps.input) != null ? _slotProps$input : componentsProps.input;
    const rootProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        getSlotProps: getRootProps,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: (0, $aJx1R.default)({}, (0, $849c99d613c8f9b2$export$2e2bcd8739ae039)(RootSlot) && {
            as: component
        }),
        ownerState: (0, $aJx1R.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
        className: [
            classes.root,
            className
        ]
    });
    const railProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: RailSlot,
        externalSlotProps: railSlotProps,
        ownerState: ownerState,
        className: classes.rail
    });
    const trackProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: TrackSlot,
        externalSlotProps: trackSlotProps,
        additionalProps: {
            style: (0, $aJx1R.default)({}, axisProps[axis].offset(trackOffset), axisProps[axis].leap(trackLeap))
        },
        ownerState: (0, $aJx1R.default)({}, ownerState, trackSlotProps == null ? void 0 : trackSlotProps.ownerState),
        className: classes.track
    });
    const thumbProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: ThumbSlot,
        getSlotProps: getThumbProps,
        externalSlotProps: thumbSlotProps,
        ownerState: (0, $aJx1R.default)({}, ownerState, thumbSlotProps == null ? void 0 : thumbSlotProps.ownerState),
        className: classes.thumb
    });
    const valueLabelProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: ValueLabelSlot,
        externalSlotProps: valueLabelSlotProps,
        ownerState: (0, $aJx1R.default)({}, ownerState, valueLabelSlotProps == null ? void 0 : valueLabelSlotProps.ownerState),
        className: classes.valueLabel
    });
    const markProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: MarkSlot,
        externalSlotProps: markSlotProps,
        ownerState: ownerState,
        className: classes.mark
    });
    const markLabelProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: MarkLabelSlot,
        externalSlotProps: markLabelSlotProps,
        ownerState: ownerState,
        className: classes.markLabel
    });
    const inputSliderProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: InputSlot,
        getSlotProps: getHiddenInputProps,
        externalSlotProps: inputSlotProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)(RootSlot, (0, $aJx1R.default)({}, rootProps, {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)(RailSlot, (0, $aJx1R.default)({}, railProps)),
            /*#__PURE__*/ (0, $aSiaI.jsx)(TrackSlot, (0, $aJx1R.default)({}, trackProps)),
            marks.filter((mark)=>mark.value >= min && mark.value <= max).map((mark, index)=>{
                const percent = (0, $b7f1f90273f68f70$export$83ce4bc8280540e6)(mark.value, min, max);
                const style = axisProps[axis].offset(percent);
                let markActive;
                if (track === false) markActive = values.indexOf(mark.value) !== -1;
                else markActive = track === "normal" && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === "inverted" && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
                return /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)(MarkSlot, (0, $aJx1R.default)({
                            "data-index": index
                        }, markProps, !(0, $6d812737487786ea$export$e28348cc2430497)(MarkSlot) && {
                            markActive: markActive
                        }, {
                            style: (0, $aJx1R.default)({}, style, markProps.style),
                            className: (0, $4qr5a.default)(markProps.className, markActive && classes.markActive)
                        })),
                        mark.label != null ? /*#__PURE__*/ (0, $aSiaI.jsx)(MarkLabelSlot, (0, $aJx1R.default)({
                            "aria-hidden": true,
                            "data-index": index
                        }, markLabelProps, !(0, $6d812737487786ea$export$e28348cc2430497)(MarkLabelSlot) && {
                            markLabelActive: markActive
                        }, {
                            style: (0, $aJx1R.default)({}, style, markLabelProps.style),
                            className: (0, $4qr5a.default)(classes.markLabel, markLabelProps.className, markActive && classes.markLabelActive),
                            children: mark.label
                        })) : null
                    ]
                }, index);
            }),
            values.map((value, index)=>{
                const percent = (0, $b7f1f90273f68f70$export$83ce4bc8280540e6)(value, min, max);
                const style = axisProps[axis].offset(percent);
                const ValueLabelComponent = valueLabelDisplay === "off" ? $b4abdcb1f4222ad1$var$Forward : ValueLabelSlot;
                return /*#__PURE__*/ /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */ (0, $aSiaI.jsx)(ValueLabelComponent, (0, $aJx1R.default)({}, !(0, $6d812737487786ea$export$e28348cc2430497)(ValueLabelComponent) && {
                    valueLabelFormat: valueLabelFormat,
                    valueLabelDisplay: valueLabelDisplay,
                    value: typeof valueLabelFormat === "function" ? valueLabelFormat(scale(value), index) : valueLabelFormat,
                    index: index,
                    open: open === index || active === index || valueLabelDisplay === "on",
                    disabled: disabled
                }, valueLabelProps, {
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)(ThumbSlot, (0, $aJx1R.default)({
                        "data-index": index
                    }, thumbProps, {
                        className: (0, $4qr5a.default)(classes.thumb, thumbProps.className, active === index && classes.active, focusedThumbIndex === index && classes.focusVisible),
                        style: (0, $aJx1R.default)({}, style, getThumbStyle(index), thumbProps.style),
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)(InputSlot, (0, $aJx1R.default)({
                            "data-index": index,
                            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
                            "aria-valuenow": scale(value),
                            "aria-labelledby": ariaLabelledby,
                            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
                            value: values[index]
                        }, inputSliderProps))
                    }))
                }), index);
            })
        ]
    }));
});
var $b4abdcb1f4222ad1$export$2e2bcd8739ae039 = $b4abdcb1f4222ad1$var$Slider;






var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");


var $2f0D3 = parcelRequire("2f0D3");

"use client";
function $4062c183f6831379$export$6105a25a68f1d9ae(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero: showZero = false } = parameters;
    const prevProps = (0, $052899f53f587903$export$2e2bcd8739ae039)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent: badgeContent, max: max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue
    };
}




var $jawKn = parcelRequire("jawKn");

var $fXwzw = parcelRequire("fXwzw");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $423b642e043629c0$export$aaccef17e6dab084(slot) {
    return (0, $dC5O8.default)("MuiBadge", slot);
}
const $423b642e043629c0$var$badgeClasses = (0, $kY7HX.default)("MuiBadge", [
    "root",
    "badge",
    "dot",
    "standard",
    "anchorOriginTopRight",
    "anchorOriginBottomRight",
    "anchorOriginTopLeft",
    "anchorOriginBottomLeft",
    "invisible",
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "overlapRectangular",
    "overlapCircular",
    // TODO: v6 remove the overlap value from these class keys
    "anchorOriginTopLeftCircular",
    "anchorOriginTopLeftRectangular",
    "anchorOriginTopRightCircular",
    "anchorOriginTopRightRectangular",
    "anchorOriginBottomLeftCircular",
    "anchorOriginBottomLeftRectangular",
    "anchorOriginBottomRightCircular",
    "anchorOriginBottomRightRectangular"
]);
var $423b642e043629c0$export$2e2bcd8739ae039 = $423b642e043629c0$var$badgeClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $d40123128680762a$var$_excluded = [
    "anchorOrigin",
    "className",
    "classes",
    "component",
    "components",
    "componentsProps",
    "children",
    "overlap",
    "color",
    "invisible",
    "max",
    "badgeContent",
    "slots",
    "slotProps",
    "showZero",
    "variant"
];
const $d40123128680762a$var$RADIUS_STANDARD = 10;
const $d40123128680762a$var$RADIUS_DOT = 4;
const $d40123128680762a$var$useThemeProps = (0, $800517e42ce363ac$export$ff8356348e0cc878)("MuiBadge");
const $d40123128680762a$var$useUtilityClasses = (ownerState)=>{
    const { color: color, anchorOrigin: anchorOrigin, invisible: invisible, overlap: overlap, variant: variant, classes: classes = {} } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        badge: [
            "badge",
            variant,
            invisible && "invisible",
            `anchorOrigin${(0, $fXwzw.default)(anchorOrigin.vertical)}${(0, $fXwzw.default)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, $fXwzw.default)(anchorOrigin.vertical)}${(0, $fXwzw.default)(anchorOrigin.horizontal)}${(0, $fXwzw.default)(overlap)}`,
            `overlap${(0, $fXwzw.default)(overlap)}`,
            color !== "default" && `color${(0, $fXwzw.default)(color)}`
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $423b642e043629c0$export$aaccef17e6dab084), classes);
};
const $d40123128680762a$var$BadgeRoot = (0, $jawKn.default)("span", {
    name: "MuiBadge",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    position: "relative",
    display: "inline-flex",
    // For correct alignment with the text.
    verticalAlign: "middle",
    flexShrink: 0
});
const $d40123128680762a$var$BadgeBadge = (0, $jawKn.default)("span", {
    name: "MuiBadge",
    slot: "Badge",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, $fXwzw.default)(ownerState.anchorOrigin.vertical)}${(0, $fXwzw.default)(ownerState.anchorOrigin.horizontal)}${(0, $fXwzw.default)(ownerState.overlap)}`],
            ownerState.color !== "default" && styles[`color${(0, $fXwzw.default)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})(({ theme: theme })=>{
    var _theme$vars;
    return {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        position: "absolute",
        boxSizing: "border-box",
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: $d40123128680762a$var$RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: "0 6px",
        height: $d40123128680762a$var$RADIUS_STANDARD * 2,
        borderRadius: $d40123128680762a$var$RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        variants: [
            ...Object.keys(((_theme$vars = theme.vars) != null ? _theme$vars : theme).palette).filter((key)=>{
                var _theme$vars2, _theme$vars3;
                return ((_theme$vars2 = theme.vars) != null ? _theme$vars2 : theme).palette[key].main && ((_theme$vars3 = theme.vars) != null ? _theme$vars3 : theme).palette[key].contrastText;
            }).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText
                    }
                })),
            {
                props: {
                    variant: "dot"
                },
                style: {
                    borderRadius: $d40123128680762a$var$RADIUS_DOT,
                    height: $d40123128680762a$var$RADIUS_DOT * 2,
                    minWidth: $d40123128680762a$var$RADIUS_DOT * 2,
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "rectangular",
                style: {
                    top: 0,
                    right: 0,
                    transform: "scale(1) translate(50%, -50%)",
                    transformOrigin: "100% 0%",
                    [`&.${(0, $423b642e043629c0$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "rectangular",
                style: {
                    bottom: 0,
                    right: 0,
                    transform: "scale(1) translate(50%, 50%)",
                    transformOrigin: "100% 100%",
                    [`&.${(0, $423b642e043629c0$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(50%, 50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "rectangular",
                style: {
                    top: 0,
                    left: 0,
                    transform: "scale(1) translate(-50%, -50%)",
                    transformOrigin: "0% 0%",
                    [`&.${(0, $423b642e043629c0$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(-50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "rectangular",
                style: {
                    bottom: 0,
                    left: 0,
                    transform: "scale(1) translate(-50%, 50%)",
                    transformOrigin: "0% 100%",
                    [`&.${(0, $423b642e043629c0$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(-50%, 50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "circular",
                style: {
                    top: "14%",
                    right: "14%",
                    transform: "scale(1) translate(50%, -50%)",
                    transformOrigin: "100% 0%",
                    [`&.${(0, $423b642e043629c0$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "right" && ownerState.overlap === "circular",
                style: {
                    bottom: "14%",
                    right: "14%",
                    transform: "scale(1) translate(50%, 50%)",
                    transformOrigin: "100% 100%",
                    [`&.${(0, $423b642e043629c0$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(50%, 50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "top" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "circular",
                style: {
                    top: "14%",
                    left: "14%",
                    transform: "scale(1) translate(-50%, -50%)",
                    transformOrigin: "0% 0%",
                    [`&.${(0, $423b642e043629c0$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(-50%, -50%)"
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === "bottom" && ownerState.anchorOrigin.horizontal === "left" && ownerState.overlap === "circular",
                style: {
                    bottom: "14%",
                    left: "14%",
                    transform: "scale(1) translate(-50%, 50%)",
                    transformOrigin: "0% 100%",
                    [`&.${(0, $423b642e043629c0$export$2e2bcd8739ae039).invisible}`]: {
                        transform: "scale(0) translate(-50%, 50%)"
                    }
                }
            },
            {
                props: {
                    invisible: true
                },
                style: {
                    transition: theme.transitions.create("transform", {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.leavingScreen
                    })
                }
            }
        ]
    };
});
const $d40123128680762a$var$Badge = /*#__PURE__*/ $exYeM.forwardRef(function Badge(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$badge, _slotProps$root, _slotProps$badge;
    const props = $d40123128680762a$var$useThemeProps({
        props: inProps,
        name: "MuiBadge"
    });
    const { anchorOrigin: anchorOriginProp = {
        vertical: "top",
        horizontal: "right"
    }, className: className, component: component, components: components = {}, componentsProps: componentsProps = {}, children: children, overlap: overlapProp = "rectangular", color: colorProp = "default", invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots: slots, slotProps: slotProps, showZero: showZero = false, variant: variantProp = "standard" } = props, other = (0, $3L80X.default)(props, $d40123128680762a$var$_excluded);
    const { badgeContent: badgeContent, invisible: invisibleFromHook, max: max, displayValue: displayValueFromHook } = (0, $4062c183f6831379$export$6105a25a68f1d9ae)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero
    });
    const prevProps = (0, $052899f53f587903$export$2e2bcd8739ae039)({
        anchorOrigin: anchorOriginProp,
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== "dot";
    const { color: color = colorProp, overlap: overlap = overlapProp, anchorOrigin: anchorOrigin = anchorOriginProp, variant: variant = variantProp } = invisible ? prevProps : props;
    const displayValue = variant !== "dot" ? displayValueFromHook : undefined;
    const ownerState = (0, $aJx1R.default)({}, props, {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue,
        showZero: showZero,
        anchorOrigin: anchorOrigin,
        color: color,
        overlap: overlap,
        variant: variant
    });
    const classes = $d40123128680762a$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $d40123128680762a$var$BadgeRoot;
    const BadgeSlot = (_ref2 = (_slots$badge = slots == null ? void 0 : slots.badge) != null ? _slots$badge : components.Badge) != null ? _ref2 : $d40123128680762a$var$BadgeBadge;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const badgeSlotProps = (_slotProps$badge = slotProps == null ? void 0 : slotProps.badge) != null ? _slotProps$badge : componentsProps.badge;
    const rootProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $4qr5a.default)(rootSlotProps == null ? void 0 : rootSlotProps.className, classes.root, className)
    });
    const badgeProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: BadgeSlot,
        externalSlotProps: badgeSlotProps,
        ownerState: ownerState,
        className: (0, $4qr5a.default)(classes.badge, badgeSlotProps == null ? void 0 : badgeSlotProps.className)
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)(RootSlot, (0, $aJx1R.default)({}, rootProps, {
        children: [
            children,
            /*#__PURE__*/ (0, $aSiaI.jsx)(BadgeSlot, (0, $aJx1R.default)({}, badgeProps, {
                children: displayValue
            }))
        ]
    }));
});
var $d40123128680762a$export$2e2bcd8739ae039 = $d40123128680762a$var$Badge;



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $2f0D3 = parcelRequire("2f0D3");

var $4qr5a = parcelRequire("4qr5a");


var $exYeM = parcelRequire("exYeM");

parcelRequire("exYeM");

var $bPz57 = parcelRequire("bPz57");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $ad86b10c88974b32$export$2e2bcd8739ae039 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), "ArrowDownward");



var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");

var $fXwzw = parcelRequire("fXwzw");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $d7a093eb50dd3626$export$645d356c89a51794(slot) {
    return (0, $dC5O8.default)("MuiTableSortLabel", slot);
}
const $d7a093eb50dd3626$var$tableSortLabelClasses = (0, $kY7HX.default)("MuiTableSortLabel", [
    "root",
    "active",
    "icon",
    "iconDirectionDesc",
    "iconDirectionAsc"
]);
var $d7a093eb50dd3626$export$2e2bcd8739ae039 = $d7a093eb50dd3626$var$tableSortLabelClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $a9f2baef033a0713$var$_excluded = [
    "active",
    "children",
    "className",
    "direction",
    "hideSortIcon",
    "IconComponent"
];
const $a9f2baef033a0713$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, direction: direction, active: active } = ownerState;
    const slots = {
        root: [
            "root",
            active && "active"
        ],
        icon: [
            "icon",
            `iconDirection${(0, $fXwzw.default)(direction)}`
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $d7a093eb50dd3626$export$645d356c89a51794), classes);
};
const $a9f2baef033a0713$var$TableSortLabelRoot = (0, $jawKn.default)((0, $8c6774266c067eb9$export$2e2bcd8739ae039), {
    name: "MuiTableSortLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.active && styles.active
        ];
    }
})(({ theme: theme })=>({
        cursor: "pointer",
        display: "inline-flex",
        justifyContent: "flex-start",
        flexDirection: "inherit",
        alignItems: "center",
        "&:focus": {
            color: (theme.vars || theme).palette.text.secondary
        },
        "&:hover": {
            color: (theme.vars || theme).palette.text.secondary,
            [`& .${(0, $d7a093eb50dd3626$export$2e2bcd8739ae039).icon}`]: {
                opacity: 0.5
            }
        },
        [`&.${(0, $d7a093eb50dd3626$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            [`& .${(0, $d7a093eb50dd3626$export$2e2bcd8739ae039).icon}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.text.secondary
            }
        }
    }));
const $a9f2baef033a0713$var$TableSortLabelIcon = (0, $jawKn.default)("span", {
    name: "MuiTableSortLabel",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            styles[`iconDirection${(0, $fXwzw.default)(ownerState.direction)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        fontSize: 18,
        marginRight: 4,
        marginLeft: 4,
        opacity: 0,
        transition: theme.transitions.create([
            "opacity",
            "transform"
        ], {
            duration: theme.transitions.duration.shorter
        }),
        userSelect: "none"
    }, ownerState.direction === "desc" && {
        transform: "rotate(0deg)"
    }, ownerState.direction === "asc" && {
        transform: "rotate(180deg)"
    }));
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */ const $a9f2baef033a0713$var$TableSortLabel = /*#__PURE__*/ $exYeM.forwardRef(function TableSortLabel(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiTableSortLabel"
    });
    const { active: active = false, children: children, className: className, direction: direction = "asc", hideSortIcon: hideSortIcon = false, IconComponent: IconComponent = (0, $ad86b10c88974b32$export$2e2bcd8739ae039) } = props, other = (0, $3L80X.default)(props, $a9f2baef033a0713$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        active: active,
        direction: direction,
        hideSortIcon: hideSortIcon,
        IconComponent: IconComponent
    });
    const classes = $a9f2baef033a0713$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($a9f2baef033a0713$var$TableSortLabelRoot, (0, $aJx1R.default)({
        className: (0, $4qr5a.default)(classes.root, className),
        component: "span",
        disableRipple: true,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            children,
            hideSortIcon && !active ? null : /*#__PURE__*/ (0, $aSiaI.jsx)($a9f2baef033a0713$var$TableSortLabelIcon, {
                as: IconComponent,
                className: (0, $4qr5a.default)(classes.icon),
                ownerState: ownerState
            })
        ]
    }));
});
var $a9f2baef033a0713$export$2e2bcd8739ae039 = $a9f2baef033a0713$var$TableSortLabel;



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $8L988 = parcelRequire("8L988");

var $jawKn = parcelRequire("jawKn");

var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");


"use client";
const $4e0cf14a35a2787b$var$_excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], $4e0cf14a35a2787b$var$_excluded2 = [
    "component",
    "slots",
    "slotProps"
], $4e0cf14a35a2787b$var$_excluded3 = [
    "component"
];
function $4e0cf14a35a2787b$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps } = parameters, useSlotPropsParams = (0, $3L80X.default)(parameters, $4e0cf14a35a2787b$var$_excluded);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $3L80X.default)(externalForwardedProps, $4e0cf14a35a2787b$var$_excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $269e73534f97f715$export$308c24034cde71de)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $de8324a7f8ed16f3$export$b01d1e419b049226)((0, $aJx1R.default)({
        className: className
    }, useSlotPropsParams, {
        externalForwardedProps: name === "root" ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $3L80X.default)(_mergeSlotProps.props, $4e0cf14a35a2787b$var$_excluded3);
    const ref = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, $aJx1R.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === "root" ? slotComponent || rootComponent : slotComponent;
    const props = (0, $0ce6f43677b2e28e$export$b089efb01a7bdf50)(elementType, (0, $aJx1R.default)({}, name === "root" && !rootComponent && !slots[name] && internalForwardedProps, name !== "root" && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref: ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}



var $fXwzw = parcelRequire("fXwzw");


var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $fab42d22195964bb$export$69aecd24bc2cf7e3(slot) {
    return (0, $dC5O8.default)("MuiAlert", slot);
}
const $fab42d22195964bb$var$alertClasses = (0, $kY7HX.default)("MuiAlert", [
    "root",
    "action",
    "icon",
    "message",
    "filled",
    "colorSuccess",
    "colorInfo",
    "colorWarning",
    "colorError",
    "filledSuccess",
    "filledInfo",
    "filledWarning",
    "filledError",
    "outlined",
    "outlinedSuccess",
    "outlinedInfo",
    "outlinedWarning",
    "outlinedError",
    "standard",
    "standardSuccess",
    "standardInfo",
    "standardWarning",
    "standardError"
]);
var $fab42d22195964bb$export$2e2bcd8739ae039 = $fab42d22195964bb$var$alertClasses;



parcelRequire("exYeM");

var $bPz57 = parcelRequire("bPz57");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $18704606731c52be$export$2e2bcd8739ae039 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined");


parcelRequire("exYeM");

var $bPz57 = parcelRequire("bPz57");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $fa1ee0123bd4934a$export$2e2bcd8739ae039 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined");


parcelRequire("exYeM");

var $bPz57 = parcelRequire("bPz57");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $dee470203c6f0e9f$export$2e2bcd8739ae039 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline");


parcelRequire("exYeM");

var $bPz57 = parcelRequire("bPz57");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $cf6bbb22f7be676d$export$2e2bcd8739ae039 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined");




var $aSiaI = parcelRequire("aSiaI");
"use client";
const $e85329076f56f45f$var$_excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const $e85329076f56f45f$var$useThemeProps = (0, $800517e42ce363ac$export$ff8356348e0cc878)("MuiAlert");
const $e85329076f56f45f$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $fXwzw.default)(color || severity)}`,
            `${variant}${(0, $fXwzw.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            "icon"
        ],
        message: [
            "message"
        ],
        action: [
            "action"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $fab42d22195964bb$export$69aecd24bc2cf7e3), classes);
};
const $e85329076f56f45f$var$AlertRoot = (0, $jawKn.default)((0, $e479e3bd14e95ba2$export$2e2bcd8739ae039), {
    name: "MuiAlert",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $fXwzw.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme: theme })=>{
    const getColor = theme.palette.mode === "light" ? (0, $8L988.darken) : (0, $8L988.lighten);
    const getBackgroundColor = theme.palette.mode === "light" ? (0, $8L988.lighten) : (0, $8L988.darken);
    return (0, $aJx1R.default)({}, theme.typography.body2, {
        backgroundColor: "transparent",
        display: "flex",
        padding: "6px 16px",
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: "standard"
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $fab42d22195964bb$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: "outlined"
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $fab42d22195964bb$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.dark).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: "filled"
                    },
                    style: (0, $aJx1R.default)({
                        fontWeight: theme.typography.fontWeightMedium
                    }, theme.vars ? {
                        color: theme.vars.palette.Alert[`${color}FilledColor`],
                        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                    } : {
                        backgroundColor: theme.palette.mode === "dark" ? theme.palette[color].dark : theme.palette[color].main,
                        color: theme.palette.getContrastText(theme.palette[color].main)
                    })
                }))
        ]
    });
});
const $e85329076f56f45f$var$AlertIcon = (0, $jawKn.default)("div", {
    name: "MuiAlert",
    slot: "Icon",
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: "7px 0",
    display: "flex",
    fontSize: 22,
    opacity: 0.9
});
const $e85329076f56f45f$var$AlertMessage = (0, $jawKn.default)("div", {
    name: "MuiAlert",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0",
    minWidth: 0,
    overflow: "auto"
});
const $e85329076f56f45f$var$AlertAction = (0, $jawKn.default)("div", {
    name: "MuiAlert",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "flex-start",
    padding: "4px 0 0 16px",
    marginLeft: "auto",
    marginRight: -8
});
const $e85329076f56f45f$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $18704606731c52be$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $fa1ee0123bd4934a$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dee470203c6f0e9f$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $cf6bbb22f7be676d$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $e85329076f56f45f$var$Alert = /*#__PURE__*/ $exYeM.forwardRef(function Alert(inProps, ref) {
    const props = $e85329076f56f45f$var$useThemeProps({
        props: inProps,
        name: "MuiAlert"
    });
    const { action: action, children: children, className: className, closeText: closeText = "Close", color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $e85329076f56f45f$var$defaultIconMapping, onClose: onClose, role: role = "alert", severity: severity = "success", slotProps: slotProps = {}, slots: slots = {}, variant: variant = "standard" } = props, other = (0, $3L80X.default)(props, $e85329076f56f45f$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    });
    const classes = $e85329076f56f45f$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: (0, $aJx1R.default)({
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon
        }, slots),
        slotProps: (0, $aJx1R.default)({}, componentsProps, slotProps)
    };
    const [CloseButtonSlot, closeButtonProps] = (0, $4e0cf14a35a2787b$export$2e2bcd8739ae039)("closeButton", {
        elementType: (0, $96b952e1d26b1f04$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $4e0cf14a35a2787b$export$2e2bcd8739ae039)("closeIcon", {
        elementType: (0, $8df7a3dd0a4a99f1$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($e85329076f56f45f$var$AlertRoot, (0, $aJx1R.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $4qr5a.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $aSiaI.jsx)($e85329076f56f45f$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $e85329076f56f45f$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $aSiaI.jsx)($e85329076f56f45f$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $aSiaI.jsx)($e85329076f56f45f$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $aSiaI.jsx)($e85329076f56f45f$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $aSiaI.jsx)(CloseButtonSlot, (0, $aJx1R.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)(CloseIconSlot, (0, $aJx1R.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
var $e85329076f56f45f$export$2e2bcd8739ae039 = $e85329076f56f45f$var$Alert;



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $jawKn = parcelRequire("jawKn");


var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $cab9d2bc4023c848$export$5269a5bce2c2f987(slot) {
    return (0, $dC5O8.default)("MuiAlertTitle", slot);
}
const $cab9d2bc4023c848$var$alertTitleClasses = (0, $kY7HX.default)("MuiAlertTitle", [
    "root"
]);
var $cab9d2bc4023c848$export$2e2bcd8739ae039 = $cab9d2bc4023c848$var$alertTitleClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $6adb5c54f2023788$var$_excluded = [
    "className"
];
const $6adb5c54f2023788$var$useThemeProps = (0, $800517e42ce363ac$export$ff8356348e0cc878)("MuiAlertTitle");
const $6adb5c54f2023788$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $cab9d2bc4023c848$export$5269a5bce2c2f987), classes);
};
const $6adb5c54f2023788$var$AlertTitleRoot = (0, $jawKn.default)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
    name: "MuiAlertTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    return {
        fontWeight: theme.typography.fontWeightMedium,
        marginTop: -2
    };
});
const $6adb5c54f2023788$var$AlertTitle = /*#__PURE__*/ $exYeM.forwardRef(function AlertTitle(inProps, ref) {
    const props = $6adb5c54f2023788$var$useThemeProps({
        props: inProps,
        name: "MuiAlertTitle"
    });
    const { className: className } = props, other = (0, $3L80X.default)(props, $6adb5c54f2023788$var$_excluded);
    const ownerState = props;
    const classes = $6adb5c54f2023788$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($6adb5c54f2023788$var$AlertTitleRoot, (0, $aJx1R.default)({
        gutterBottom: true,
        component: "div",
        ownerState: ownerState,
        ref: ref,
        className: (0, $4qr5a.default)(classes.root, className)
    }, other));
});
var $6adb5c54f2023788$export$2e2bcd8739ae039 = $6adb5c54f2023788$var$AlertTitle;






var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");


var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $9d719da819853e75$var$_excluded = [
    "className",
    "id"
];
const $9d719da819853e75$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $364e478f30577320$export$f5d2ec7e4c47e088), classes);
};
const $9d719da819853e75$var$DialogTitleRoot = (0, $jawKn.default)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
    name: "MuiDialogTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    padding: "16px 24px",
    flex: "0 0 auto"
});
const $9d719da819853e75$var$DialogTitle = /*#__PURE__*/ $exYeM.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiDialogTitle"
    });
    const { className: className, id: idProp } = props, other = (0, $3L80X.default)(props, $9d719da819853e75$var$_excluded);
    const ownerState = props;
    const classes = $9d719da819853e75$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $exYeM.useContext((0, $5b6ad8b1de22f5e0$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $aSiaI.jsx)($9d719da819853e75$var$DialogTitleRoot, (0, $aJx1R.default)({
        component: "h2",
        className: (0, $4qr5a.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $9d719da819853e75$export$2e2bcd8739ae039 = $9d719da819853e75$var$DialogTitle;




var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $geqbO = parcelRequire("geqbO");

var $8L988 = parcelRequire("8L988");


var $fXwzw = parcelRequire("fXwzw");

var $jawKn = parcelRequire("jawKn");

var $7PWLt = parcelRequire("7PWLt");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $64b518bf9a1fd1ac$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $dC5O8.default)("MuiLinearProgress", slot);
}
const $64b518bf9a1fd1ac$var$linearProgressClasses = (0, $kY7HX.default)("MuiLinearProgress", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "determinate",
    "indeterminate",
    "buffer",
    "query",
    "dashed",
    "dashedColorPrimary",
    "dashedColorSecondary",
    "bar",
    "barColorPrimary",
    "barColorSecondary",
    "bar1Indeterminate",
    "bar1Determinate",
    "bar1Buffer",
    "bar2Indeterminate",
    "bar2Buffer"
]);
var $64b518bf9a1fd1ac$export$2e2bcd8739ae039 = $64b518bf9a1fd1ac$var$linearProgressClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $2de6e1f747941867$var$_excluded = [
    "className",
    "color",
    "value",
    "valueBuffer",
    "variant"
];
let $2de6e1f747941867$var$_ = (t)=>t, $2de6e1f747941867$var$_t, $2de6e1f747941867$var$_t2, $2de6e1f747941867$var$_t3, $2de6e1f747941867$var$_t4, $2de6e1f747941867$var$_t5, $2de6e1f747941867$var$_t6;
const $2de6e1f747941867$var$TRANSITION_DURATION = 4; // seconds
const $2de6e1f747941867$var$indeterminate1Keyframe = (0, $geqbO.keyframes)($2de6e1f747941867$var$_t || ($2de6e1f747941867$var$_t = $2de6e1f747941867$var$_`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`));
const $2de6e1f747941867$var$indeterminate2Keyframe = (0, $geqbO.keyframes)($2de6e1f747941867$var$_t2 || ($2de6e1f747941867$var$_t2 = $2de6e1f747941867$var$_`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`));
const $2de6e1f747941867$var$bufferKeyframe = (0, $geqbO.keyframes)($2de6e1f747941867$var$_t3 || ($2de6e1f747941867$var$_t3 = $2de6e1f747941867$var$_`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`));
const $2de6e1f747941867$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $fXwzw.default)(color)}`,
            variant
        ],
        dashed: [
            "dashed",
            `dashedColor${(0, $fXwzw.default)(color)}`
        ],
        bar1: [
            "bar",
            `barColor${(0, $fXwzw.default)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar1Indeterminate",
            variant === "determinate" && "bar1Determinate",
            variant === "buffer" && "bar1Buffer"
        ],
        bar2: [
            "bar",
            variant !== "buffer" && `barColor${(0, $fXwzw.default)(color)}`,
            variant === "buffer" && `color${(0, $fXwzw.default)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar2Indeterminate",
            variant === "buffer" && "bar2Buffer"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $64b518bf9a1fd1ac$export$bc8a6ea1eb17d7c6), classes);
};
const $2de6e1f747941867$var$getColorShade = (theme, color)=>{
    if (color === "inherit") return "currentColor";
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === "light" ? (0, $8L988.lighten)(theme.palette[color].main, 0.62) : (0, $8L988.darken)(theme.palette[color].main, 0.5);
};
const $2de6e1f747941867$var$LinearProgressRoot = (0, $jawKn.default)("span", {
    name: "MuiLinearProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $fXwzw.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $aJx1R.default)({
        position: "relative",
        overflow: "hidden",
        display: "block",
        height: 4,
        zIndex: 0,
        // Fix Safari's bug during composition of different paint.
        "@media print": {
            colorAdjust: "exact"
        },
        backgroundColor: $2de6e1f747941867$var$getColorShade(theme, ownerState.color)
    }, ownerState.color === "inherit" && ownerState.variant !== "buffer" && {
        backgroundColor: "none",
        "&::before": {
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "currentColor",
            opacity: 0.3
        }
    }, ownerState.variant === "buffer" && {
        backgroundColor: "transparent"
    }, ownerState.variant === "query" && {
        transform: "rotate(180deg)"
    }));
const $2de6e1f747941867$var$LinearProgressDashed = (0, $jawKn.default)("span", {
    name: "MuiLinearProgress",
    slot: "Dashed",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $fXwzw.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>{
    const backgroundColor = $2de6e1f747941867$var$getColorShade(theme, ownerState.color);
    return (0, $aJx1R.default)({
        position: "absolute",
        marginTop: 0,
        height: "100%",
        width: "100%"
    }, ownerState.color === "inherit" && {
        opacity: 0.3
    }, {
        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
        backgroundSize: "10px 10px",
        backgroundPosition: "0 -23px"
    });
}, (0, $geqbO.css)($2de6e1f747941867$var$_t4 || ($2de6e1f747941867$var$_t4 = $2de6e1f747941867$var$_`
    animation: ${0} 3s infinite linear;
  `), $2de6e1f747941867$var$bufferKeyframe));
const $2de6e1f747941867$var$LinearProgressBar1 = (0, $jawKn.default)("span", {
    name: "MuiLinearProgress",
    slot: "Bar1",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $fXwzw.default)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar1Indeterminate,
            ownerState.variant === "determinate" && styles.bar1Determinate,
            ownerState.variant === "buffer" && styles.bar1Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $aJx1R.default)({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left",
        backgroundColor: ownerState.color === "inherit" ? "currentColor" : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "determinate" && {
        transition: `transform .${$2de6e1f747941867$var$TRANSITION_DURATION}s linear`
    }, ownerState.variant === "buffer" && {
        zIndex: 1,
        transition: `transform .${$2de6e1f747941867$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === "indeterminate" || ownerState.variant === "query") && (0, $geqbO.css)($2de6e1f747941867$var$_t5 || ($2de6e1f747941867$var$_t5 = $2de6e1f747941867$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), $2de6e1f747941867$var$indeterminate1Keyframe));
const $2de6e1f747941867$var$LinearProgressBar2 = (0, $jawKn.default)("span", {
    name: "MuiLinearProgress",
    slot: "Bar2",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $fXwzw.default)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar2Indeterminate,
            ownerState.variant === "buffer" && styles.bar2Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $aJx1R.default)({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left"
    }, ownerState.variant !== "buffer" && {
        backgroundColor: ownerState.color === "inherit" ? "currentColor" : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        opacity: 0.3
    }, ownerState.variant === "buffer" && {
        backgroundColor: $2de6e1f747941867$var$getColorShade(theme, ownerState.color),
        transition: `transform .${$2de6e1f747941867$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === "indeterminate" || ownerState.variant === "query") && (0, $geqbO.css)($2de6e1f747941867$var$_t6 || ($2de6e1f747941867$var$_t6 = $2de6e1f747941867$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), $2de6e1f747941867$var$indeterminate2Keyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $2de6e1f747941867$var$LinearProgress = /*#__PURE__*/ $exYeM.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiLinearProgress"
    });
    const { className: className, color: color = "primary", value: value, valueBuffer: valueBuffer, variant: variant = "indeterminate" } = props, other = (0, $3L80X.default)(props, $2de6e1f747941867$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        color: color,
        variant: variant
    });
    const classes = $2de6e1f747941867$var$useUtilityClasses(ownerState);
    const isRtl = (0, $f6d0b5039025b20a$export$b2dd014b6c321cb)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === "determinate" || variant === "buffer") {
        if (value !== undefined) {
            rootProps["aria-valuenow"] = Math.round(value);
            rootProps["aria-valuemin"] = 0;
            rootProps["aria-valuemax"] = 100;
            let transform = value - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === "buffer") {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($2de6e1f747941867$var$LinearProgressRoot, (0, $aJx1R.default)({
        className: (0, $4qr5a.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar"
    }, rootProps, {
        ref: ref
    }, other, {
        children: [
            variant === "buffer" ? /*#__PURE__*/ (0, $aSiaI.jsx)($2de6e1f747941867$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $aSiaI.jsx)($2de6e1f747941867$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === "determinate" ? null : /*#__PURE__*/ (0, $aSiaI.jsx)($2de6e1f747941867$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    }));
});
var $2de6e1f747941867$export$2e2bcd8739ae039 = $2de6e1f747941867$var$LinearProgress;




var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");


var $7PWLt = parcelRequire("7PWLt");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $6a3a3474d2a5d021$export$427f1c1e2e839f85(slot) {
    return (0, $dC5O8.default)("MuiPagination", slot);
}
const $6a3a3474d2a5d021$var$paginationClasses = (0, $kY7HX.default)("MuiPagination", [
    "root",
    "ul",
    "outlined",
    "text"
]);
var $6a3a3474d2a5d021$export$2e2bcd8739ae039 = $6a3a3474d2a5d021$var$paginationClasses;



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

"use client";
const $8bb36e11bc11c052$var$_excluded = [
    "boundaryCount",
    "componentName",
    "count",
    "defaultPage",
    "disabled",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "showFirstButton",
    "showLastButton",
    "siblingCount"
];
function $8bb36e11bc11c052$export$2e2bcd8739ae039(props = {}) {
    // keep default values in sync with @default tags in Pagination.propTypes
    const { boundaryCount: boundaryCount = 1, componentName: componentName = "usePagination", count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, onChange: handleChange, page: pageProp, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1 } = props, other = (0, $3L80X.default)(props, $8bb36e11bc11c052$var$_excluded);
    const [page, setPageState] = (0, $d86ef59ee77e84fd$export$2e2bcd8739ae039)({
        controlled: pageProp,
        default: defaultPage,
        name: componentName,
        state: "page"
    });
    const handleClick = (event, value)=>{
        if (!pageProp) setPageState(value);
        if (handleChange) handleChange(event, value);
    };
    // https://dev.to/namirsab/comment/2050
    const range = (start, end)=>{
        const length = end - start + 1;
        return Array.from({
            length: length
        }, (_, i)=>start + i);
    };
    const startPages = range(1, Math.min(boundaryCount, count));
    const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    const siblingsStart = Math.max(Math.min(// Natural start
    page - siblingCount, // Lower boundary when page is high
    count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
    boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(// Natural end
    page + siblingCount, // Upper boundary when page is low
    boundaryCount + siblingCount * 2 + 2), // Less than endPages
    endPages.length > 0 ? endPages[0] - 2 : count - 1);
    // Basic list of items to render
    // for example itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
    const itemList = [
        ...showFirstButton ? [
            "first"
        ] : [],
        ...hidePrevButton ? [] : [
            "previous"
        ],
        ...startPages,
        // Start ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsStart > boundaryCount + 2 ? [
            "start-ellipsis"
        ] : boundaryCount + 1 < count - boundaryCount ? [
            boundaryCount + 1
        ] : [],
        // Sibling pages
        ...range(siblingsStart, siblingsEnd),
        // End ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsEnd < count - boundaryCount - 1 ? [
            "end-ellipsis"
        ] : count - boundaryCount > boundaryCount ? [
            count - boundaryCount
        ] : [],
        ...endPages,
        ...hideNextButton ? [] : [
            "next"
        ],
        ...showLastButton ? [
            "last"
        ] : []
    ];
    // Map the button type to its page number
    const buttonPage = (type)=>{
        switch(type){
            case "first":
                return 1;
            case "previous":
                return page - 1;
            case "next":
                return page + 1;
            case "last":
                return count;
            default:
                return null;
        }
    };
    // Convert the basic item list to PaginationItem props objects
    const items = itemList.map((item)=>{
        return typeof item === "number" ? {
            onClick: (event)=>{
                handleClick(event, item);
            },
            type: "page",
            page: item,
            selected: item === page,
            disabled: disabled,
            "aria-current": item === page ? "true" : undefined
        } : {
            onClick: (event)=>{
                handleClick(event, buttonPage(item));
            },
            type: item,
            page: buttonPage(item),
            selected: false,
            disabled: disabled || item.indexOf("ellipsis") === -1 && (item === "next" || item === "last" ? page >= count : page <= 1)
        };
    });
    return (0, $aJx1R.default)({
        items: items
    }, other);
}



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $2f0D3 = parcelRequire("2f0D3");

var $8L988 = parcelRequire("8L988");


var $7PWLt = parcelRequire("7PWLt");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $dc45c2c692f53412$export$e4ce0a775adf2f74(slot) {
    return (0, $dC5O8.default)("MuiPaginationItem", slot);
}
const $dc45c2c692f53412$var$paginationItemClasses = (0, $kY7HX.default)("MuiPaginationItem", [
    "root",
    "page",
    "sizeSmall",
    "sizeLarge",
    "text",
    "textPrimary",
    "textSecondary",
    "outlined",
    "outlinedPrimary",
    "outlinedSecondary",
    "rounded",
    "ellipsis",
    "firstLast",
    "previousNext",
    "focusVisible",
    "disabled",
    "selected",
    "icon",
    "colorPrimary",
    "colorSecondary"
]);
var $dc45c2c692f53412$export$2e2bcd8739ae039 = $dc45c2c692f53412$var$paginationItemClasses;




var $fXwzw = parcelRequire("fXwzw");
parcelRequire("exYeM");

var $bPz57 = parcelRequire("bPz57");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $1188c4452f6b4612$export$2e2bcd8739ae039 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage");


parcelRequire("exYeM");

var $bPz57 = parcelRequire("bPz57");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $a185a8dfdab5d54a$export$2e2bcd8739ae039 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage");


parcelRequire("exYeM");

var $bPz57 = parcelRequire("bPz57");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $0f3b1b55e38d7b29$export$2e2bcd8739ae039 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore");


parcelRequire("exYeM");

var $bPz57 = parcelRequire("bPz57");

var $aSiaI = parcelRequire("aSiaI");
"use client";
var $6ec02cd8f1518143$export$2e2bcd8739ae039 = (0, $bPz57.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext");



var $jawKn = parcelRequire("jawKn");

var $aSiaI = parcelRequire("aSiaI");
"use client";
const $f201c8eef94b5505$var$_excluded = [
    "className",
    "color",
    "component",
    "components",
    "disabled",
    "page",
    "selected",
    "shape",
    "size",
    "slots",
    "type",
    "variant"
];
const $f201c8eef94b5505$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[ownerState.variant],
        styles[`size${(0, $fXwzw.default)(ownerState.size)}`],
        ownerState.variant === "text" && styles[`text${(0, $fXwzw.default)(ownerState.color)}`],
        ownerState.variant === "outlined" && styles[`outlined${(0, $fXwzw.default)(ownerState.color)}`],
        ownerState.shape === "rounded" && styles.rounded,
        ownerState.type === "page" && styles.page,
        (ownerState.type === "start-ellipsis" || ownerState.type === "end-ellipsis") && styles.ellipsis,
        (ownerState.type === "previous" || ownerState.type === "next") && styles.previousNext,
        (ownerState.type === "first" || ownerState.type === "last") && styles.firstLast
    ];
};
const $f201c8eef94b5505$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, selected: selected, size: size, shape: shape, type: type, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            `size${(0, $fXwzw.default)(size)}`,
            variant,
            shape,
            color !== "standard" && `color${(0, $fXwzw.default)(color)}`,
            color !== "standard" && `${variant}${(0, $fXwzw.default)(color)}`,
            disabled && "disabled",
            selected && "selected",
            {
                page: "page",
                first: "firstLast",
                last: "firstLast",
                "start-ellipsis": "ellipsis",
                "end-ellipsis": "ellipsis",
                previous: "previousNext",
                next: "previousNext"
            }[type]
        ],
        icon: [
            "icon"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $dc45c2c692f53412$export$e4ce0a775adf2f74), classes);
};
const $f201c8eef94b5505$var$PaginationItemEllipsis = (0, $jawKn.default)("div", {
    name: "MuiPaginationItem",
    slot: "Root",
    overridesResolver: $f201c8eef94b5505$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: "center",
        boxSizing: "border-box",
        minWidth: 32,
        padding: "0 6px",
        margin: "0 3px",
        color: (theme.vars || theme).palette.text.primary,
        height: "auto",
        [`&.${(0, $dc45c2c692f53412$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.size === "small" && {
        minWidth: 26,
        borderRadius: 13,
        margin: "0 1px",
        padding: "0 4px"
    }, ownerState.size === "large" && {
        minWidth: 40,
        borderRadius: 20,
        padding: "0 10px",
        fontSize: theme.typography.pxToRem(15)
    }));
const $f201c8eef94b5505$var$PaginationItemPage = (0, $jawKn.default)((0, $8c6774266c067eb9$export$2e2bcd8739ae039), {
    name: "MuiPaginationItem",
    slot: "Root",
    overridesResolver: $f201c8eef94b5505$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: "center",
        boxSizing: "border-box",
        minWidth: 32,
        height: 32,
        padding: "0 6px",
        margin: "0 3px",
        color: (theme.vars || theme).palette.text.primary,
        [`&.${(0, $dc45c2c692f53412$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $dc45c2c692f53412$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        transition: theme.transitions.create([
            "color",
            "background-color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": {
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $dc45c2c692f53412$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: (theme.vars || theme).palette.action.selected,
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $8L988.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: (theme.vars || theme).palette.action.selected
                }
            },
            [`&.${(0, $dc45c2c692f53412$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $8L988.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            },
            [`&.${(0, $dc45c2c692f53412$export$2e2bcd8739ae039).disabled}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.action.disabled,
                backgroundColor: (theme.vars || theme).palette.action.selected
            }
        }
    }, ownerState.size === "small" && {
        minWidth: 26,
        height: 26,
        borderRadius: 13,
        margin: "0 1px",
        padding: "0 4px"
    }, ownerState.size === "large" && {
        minWidth: 40,
        height: 40,
        borderRadius: 20,
        padding: "0 10px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.shape === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }), ({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({}, ownerState.variant === "text" && {
        [`&.${(0, $dc45c2c692f53412$export$2e2bcd8739ae039).selected}`]: (0, $aJx1R.default)({}, ownerState.color !== "standard" && {
            color: (theme.vars || theme).palette[ownerState.color].contrastText,
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
            "&:hover": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: (theme.vars || theme).palette[ownerState.color].main
                }
            },
            [`&.${(0, $dc45c2c692f53412$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
            }
        }, {
            [`&.${(0, $dc45c2c692f53412$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }, ownerState.variant === "outlined" && {
        border: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
        [`&.${(0, $dc45c2c692f53412$export$2e2bcd8739ae039).selected}`]: (0, $aJx1R.default)({}, ownerState.color !== "standard" && {
            color: (theme.vars || theme).palette[ownerState.color].main,
            border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, $8L988.alpha)(theme.palette[ownerState.color].main, 0.5)}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.activatedOpacity})` : (0, $8L988.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity),
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $8L988.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            [`&.${(0, $dc45c2c692f53412$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $8L988.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity)
            }
        }, {
            [`&.${(0, $dc45c2c692f53412$export$2e2bcd8739ae039).disabled}`]: {
                borderColor: (theme.vars || theme).palette.action.disabledBackground,
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }));
const $f201c8eef94b5505$var$PaginationItemPageIcon = (0, $jawKn.default)("div", {
    name: "MuiPaginationItem",
    slot: "Icon",
    overridesResolver: (props, styles)=>styles.icon
})(({ theme: theme, ownerState: ownerState })=>(0, $aJx1R.default)({
        fontSize: theme.typography.pxToRem(20),
        margin: "0 -8px"
    }, ownerState.size === "small" && {
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        fontSize: theme.typography.pxToRem(22)
    }));
const $f201c8eef94b5505$var$PaginationItem = /*#__PURE__*/ $exYeM.forwardRef(function PaginationItem(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiPaginationItem"
    });
    const { className: className, color: color = "standard", component: component, components: components = {}, disabled: disabled = false, page: page, selected: selected = false, shape: shape = "circular", size: size = "medium", slots: slots = {}, type: type = "page", variant: variant = "text" } = props, other = (0, $3L80X.default)(props, $f201c8eef94b5505$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        color: color,
        disabled: disabled,
        selected: selected,
        shape: shape,
        size: size,
        type: type,
        variant: variant
    });
    const isRtl = (0, $f6d0b5039025b20a$export$b2dd014b6c321cb)();
    const classes = $f201c8eef94b5505$var$useUtilityClasses(ownerState);
    const normalizedIcons = isRtl ? {
        previous: slots.next || components.next || (0, $6ec02cd8f1518143$export$2e2bcd8739ae039),
        next: slots.previous || components.previous || (0, $0f3b1b55e38d7b29$export$2e2bcd8739ae039),
        last: slots.first || components.first || (0, $1188c4452f6b4612$export$2e2bcd8739ae039),
        first: slots.last || components.last || (0, $a185a8dfdab5d54a$export$2e2bcd8739ae039)
    } : {
        previous: slots.previous || components.previous || (0, $0f3b1b55e38d7b29$export$2e2bcd8739ae039),
        next: slots.next || components.next || (0, $6ec02cd8f1518143$export$2e2bcd8739ae039),
        first: slots.first || components.first || (0, $1188c4452f6b4612$export$2e2bcd8739ae039),
        last: slots.last || components.last || (0, $a185a8dfdab5d54a$export$2e2bcd8739ae039)
    };
    const Icon = normalizedIcons[type];
    return type === "start-ellipsis" || type === "end-ellipsis" ? /*#__PURE__*/ (0, $aSiaI.jsx)($f201c8eef94b5505$var$PaginationItemEllipsis, {
        ref: ref,
        ownerState: ownerState,
        className: (0, $4qr5a.default)(classes.root, className),
        children: "\u2026"
    }) : /*#__PURE__*/ (0, $aSiaI.jsxs)($f201c8eef94b5505$var$PaginationItemPage, (0, $aJx1R.default)({
        ref: ref,
        ownerState: ownerState,
        component: component,
        disabled: disabled,
        className: (0, $4qr5a.default)(classes.root, className)
    }, other, {
        children: [
            type === "page" && page,
            Icon ? /*#__PURE__*/ (0, $aSiaI.jsx)($f201c8eef94b5505$var$PaginationItemPageIcon, {
                as: Icon,
                ownerState: ownerState,
                className: classes.icon
            }) : null
        ]
    }));
});
var $f201c8eef94b5505$export$2e2bcd8739ae039 = $f201c8eef94b5505$var$PaginationItem;



var $jawKn = parcelRequire("jawKn");

var $aSiaI = parcelRequire("aSiaI");
"use client";
const $832dbfb3b6ab77fc$var$_excluded = [
    "boundaryCount",
    "className",
    "color",
    "count",
    "defaultPage",
    "disabled",
    "getItemAriaLabel",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "renderItem",
    "shape",
    "showFirstButton",
    "showLastButton",
    "siblingCount",
    "size",
    "variant"
];
const $832dbfb3b6ab77fc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant
        ],
        ul: [
            "ul"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $6a3a3474d2a5d021$export$427f1c1e2e839f85), classes);
};
const $832dbfb3b6ab77fc$var$PaginationRoot = (0, $jawKn.default)("nav", {
    name: "MuiPagination",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant]
        ];
    }
})({});
const $832dbfb3b6ab77fc$var$PaginationUl = (0, $jawKn.default)("ul", {
    name: "MuiPagination",
    slot: "Ul",
    overridesResolver: (props, styles)=>styles.ul
})({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: 0,
    margin: 0,
    listStyle: "none"
});
function $832dbfb3b6ab77fc$var$defaultGetAriaLabel(type, page, selected) {
    if (type === "page") return `${selected ? "" : "Go to "}page ${page}`;
    return `Go to ${type} page`;
}
const $832dbfb3b6ab77fc$var$Pagination = /*#__PURE__*/ $exYeM.forwardRef(function Pagination(inProps, ref) {
    const props = (0, $7PWLt.default)({
        props: inProps,
        name: "MuiPagination"
    });
    const { boundaryCount: boundaryCount = 1, className: className, color: color = "standard", count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $832dbfb3b6ab77fc$var$defaultGetAriaLabel, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, renderItem: renderItem = (item)=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $f201c8eef94b5505$export$2e2bcd8739ae039), (0, $aJx1R.default)({}, item)), shape: shape = "circular", showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1, size: size = "medium", variant: variant = "text" } = props, other = (0, $3L80X.default)(props, $832dbfb3b6ab77fc$var$_excluded);
    const { items: items } = (0, $8bb36e11bc11c052$export$2e2bcd8739ae039)((0, $aJx1R.default)({}, props, {
        componentName: "Pagination"
    }));
    const ownerState = (0, $aJx1R.default)({}, props, {
        boundaryCount: boundaryCount,
        color: color,
        count: count,
        defaultPage: defaultPage,
        disabled: disabled,
        getItemAriaLabel: getItemAriaLabel,
        hideNextButton: hideNextButton,
        hidePrevButton: hidePrevButton,
        renderItem: renderItem,
        shape: shape,
        showFirstButton: showFirstButton,
        showLastButton: showLastButton,
        siblingCount: siblingCount,
        size: size,
        variant: variant
    });
    const classes = $832dbfb3b6ab77fc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($832dbfb3b6ab77fc$var$PaginationRoot, (0, $aJx1R.default)({
        "aria-label": "pagination navigation",
        className: (0, $4qr5a.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($832dbfb3b6ab77fc$var$PaginationUl, {
            className: classes.ul,
            ownerState: ownerState,
            children: items.map((item, index)=>/*#__PURE__*/ (0, $aSiaI.jsx)("li", {
                    children: renderItem((0, $aJx1R.default)({}, item, {
                        color: color,
                        "aria-label": getItemAriaLabel(item.type, item.page, item.selected),
                        shape: shape,
                        size: size,
                        variant: variant
                    }))
                }, index))
        })
    }));
});
var $832dbfb3b6ab77fc$export$2e2bcd8739ae039 = $832dbfb3b6ab77fc$var$Pagination;






var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");


var $2f0D3 = parcelRequire("2f0D3");

var $8L988 = parcelRequire("8L988");

var $fXwzw = parcelRequire("fXwzw");


var $jawKn = parcelRequire("jawKn");

var $kY7HX = parcelRequire("kY7HX");

var $dC5O8 = parcelRequire("dC5O8");
function $87e06179ebdb6e56$export$39f6debbec19b3ba(slot) {
    return (0, $dC5O8.default)("MuiSwitch", slot);
}
const $87e06179ebdb6e56$var$switchClasses = (0, $kY7HX.default)("MuiSwitch", [
    "root",
    "edgeStart",
    "edgeEnd",
    "switchBase",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium",
    "checked",
    "disabled",
    "input",
    "thumb",
    "track"
]);
var $87e06179ebdb6e56$export$2e2bcd8739ae039 = $87e06179ebdb6e56$var$switchClasses;



var $aSiaI = parcelRequire("aSiaI");
"use client";
const $8482ce3784eb7280$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $8482ce3784eb7280$var$useThemeProps = (0, $800517e42ce363ac$export$ff8356348e0cc878)("MuiSwitch");
const $8482ce3784eb7280$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            edge && `edge${(0, $fXwzw.default)(edge)}`,
            `size${(0, $fXwzw.default)(size)}`
        ],
        switchBase: [
            "switchBase",
            `color${(0, $fXwzw.default)(color)}`,
            checked && "checked",
            disabled && "disabled"
        ],
        thumb: [
            "thumb"
        ],
        track: [
            "track"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $2f0D3.default)(slots, (0, $87e06179ebdb6e56$export$39f6debbec19b3ba), classes);
    return (0, $aJx1R.default)({}, classes, composedClasses);
};
const $8482ce3784eb7280$var$SwitchRoot = (0, $jawKn.default)("span", {
    name: "MuiSwitch",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $fXwzw.default)(ownerState.edge)}`],
            styles[`size${(0, $fXwzw.default)(ownerState.size)}`]
        ];
    }
})({
    display: "inline-flex",
    width: 58,
    height: 38,
    overflow: "hidden",
    padding: 12,
    boxSizing: "border-box",
    position: "relative",
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: "middle",
    // For correct alignment with the text.
    "@media print": {
        colorAdjust: "exact"
    },
    variants: [
        {
            props: {
                edge: "start"
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: "end"
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: "small"
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, $87e06179ebdb6e56$export$2e2bcd8739ae039).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, $87e06179ebdb6e56$export$2e2bcd8739ae039).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, $87e06179ebdb6e56$export$2e2bcd8739ae039).checked}`]: {
                        transform: "translateX(16px)"
                    }
                }
            }
        }
    ]
});
const $8482ce3784eb7280$var$SwitchSwitchBase = (0, $jawKn.default)((0, $b2ee24326789fbdb$export$2e2bcd8739ae039), {
    name: "MuiSwitch",
    slot: "SwitchBase",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $87e06179ebdb6e56$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== "default" && styles[`color${(0, $fXwzw.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme })=>({
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === "light" ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            "left",
            "transform"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $87e06179ebdb6e56$export$2e2bcd8739ae039).checked}`]: {
            transform: "translateX(20px)"
        },
        [`&.${(0, $87e06179ebdb6e56$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $87e06179ebdb6e56$export$2e2bcd8739ae039).checked} + .${(0, $87e06179ebdb6e56$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $87e06179ebdb6e56$export$2e2bcd8739ae039).disabled} + .${(0, $87e06179ebdb6e56$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === "light" ? 0.12 : 0.2}`
        },
        [`& .${(0, $87e06179ebdb6e56$export$2e2bcd8739ae039).input}`]: {
            left: "-100%",
            width: "300%"
        }
    }), ({ theme: theme })=>({
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8L988.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $87e06179ebdb6e56$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            "&:hover": {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8L988.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                "@media (hover: none)": {
                                    backgroundColor: "transparent"
                                }
                            },
                            [`&.${(0, $87e06179ebdb6e56$export$2e2bcd8739ae039).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === "light" ? (0, $8L988.lighten)(theme.palette[color].main, 0.62) : (0, $8L988.darken)(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, $87e06179ebdb6e56$export$2e2bcd8739ae039).checked} + .${(0, $87e06179ebdb6e56$export$2e2bcd8739ae039).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    }));
const $8482ce3784eb7280$var$SwitchTrack = (0, $jawKn.default)("span", {
    name: "MuiSwitch",
    slot: "Track",
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>({
        height: "100%",
        width: "100%",
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            "opacity",
            "background-color"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === "light" ? 0.38 : 0.3}`
    }));
const $8482ce3784eb7280$var$SwitchThumb = (0, $jawKn.default)("span", {
    name: "MuiSwitch",
    slot: "Thumb",
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: "currentColor",
        width: 20,
        height: 20,
        borderRadius: "50%"
    }));
const $8482ce3784eb7280$var$Switch = /*#__PURE__*/ $exYeM.forwardRef(function Switch(inProps, ref) {
    const props = $8482ce3784eb7280$var$useThemeProps({
        props: inProps,
        name: "MuiSwitch"
    });
    const { className: className, color: color = "primary", edge: edge = false, size: size = "medium", sx: sx } = props, other = (0, $3L80X.default)(props, $8482ce3784eb7280$var$_excluded);
    const ownerState = (0, $aJx1R.default)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $8482ce3784eb7280$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $aSiaI.jsx)($8482ce3784eb7280$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($8482ce3784eb7280$var$SwitchRoot, {
        className: (0, $4qr5a.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)($8482ce3784eb7280$var$SwitchSwitchBase, (0, $aJx1R.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $aJx1R.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $aSiaI.jsx)($8482ce3784eb7280$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
var $8482ce3784eb7280$export$2e2bcd8739ae039 = $8482ce3784eb7280$var$Switch;


const $35fd956d2f1c2be7$export$da3e7a4aacd802c = (columnDef)=>{
    var _a, _b, _c, _d;
    return (_d = (_a = columnDef.id) !== null && _a !== void 0 ? _a : (_c = (_b = columnDef.accessorKey) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b)) !== null && _d !== void 0 ? _d : columnDef.header;
};
const $35fd956d2f1c2be7$export$851defe8865cb834 = (columns)=>{
    const allLeafColumnDefs = [];
    const getLeafColumns = (cols)=>{
        cols.forEach((col)=>{
            if (col.columns) getLeafColumns(col.columns);
            else allLeafColumnDefs.push(col);
        });
    };
    getLeafColumns(columns);
    return allLeafColumnDefs;
};
const $35fd956d2f1c2be7$export$1147582dfae658c6 = ({ columnDefs: columnDefs, tableOptions: tableOptions })=>{
    const { aggregationFns: aggregationFns = {}, defaultDisplayColumn: defaultDisplayColumn, filterFns: filterFns = {}, sortingFns: sortingFns = {}, state: { columnFilterFns: columnFilterFns = {} } = {} } = tableOptions;
    return columnDefs.map((columnDef)=>{
        var _a, _b;
        //assign columnId
        if (!columnDef.id) columnDef.id = $35fd956d2f1c2be7$export$da3e7a4aacd802c(columnDef);
        //assign columnDefType
        if (!columnDef.columnDefType) columnDef.columnDefType = "data";
        if ((_a = columnDef.columns) === null || _a === void 0 ? void 0 : _a.length) {
            columnDef.columnDefType = "group";
            //recursively prepare columns if this is a group column
            columnDef.columns = $35fd956d2f1c2be7$export$1147582dfae658c6({
                columnDefs: columnDef.columns,
                tableOptions: tableOptions
            });
        } else if (columnDef.columnDefType === "data") {
            //assign aggregationFns if multiple aggregationFns are provided
            if (Array.isArray(columnDef.aggregationFn)) {
                const aggFns = columnDef.aggregationFn;
                columnDef.aggregationFn = (columnId, leafRows, childRows)=>aggFns.map((fn)=>{
                        var _a;
                        return (_a = aggregationFns[fn]) === null || _a === void 0 ? void 0 : _a.call(aggregationFns, columnId, leafRows, childRows);
                    });
            }
            //assign filterFns
            if (Object.keys(filterFns).includes(columnFilterFns[columnDef.id])) {
                columnDef.filterFn = (_b = filterFns[columnFilterFns[columnDef.id]]) !== null && _b !== void 0 ? _b : filterFns.fuzzy;
                columnDef._filterFn = columnFilterFns[columnDef.id];
            }
            //assign sortingFns
            if (Object.keys(sortingFns).includes(columnDef.sortingFn)) // @ts-ignore
            columnDef.sortingFn = sortingFns[columnDef.sortingFn];
        } else if (columnDef.columnDefType === "display") columnDef = Object.assign(Object.assign({}, defaultDisplayColumn), columnDef);
        return columnDef;
    });
};
const $35fd956d2f1c2be7$export$4780246288fde46d = (draggedColumn, targetColumn, columnOrder)=>{
    if (draggedColumn.getCanPin()) draggedColumn.pin(targetColumn.getIsPinned());
    const newColumnOrder = [
        ...columnOrder
    ];
    newColumnOrder.splice(newColumnOrder.indexOf(targetColumn.id), 0, newColumnOrder.splice(newColumnOrder.indexOf(draggedColumn.id), 1)[0]);
    return newColumnOrder;
};
const $35fd956d2f1c2be7$export$411d52172b940fad = (columnDef)=>{
    const { filterVariant: filterVariant } = columnDef;
    if (filterVariant === "multi-select") return "arrIncludesSome";
    if (filterVariant === null || filterVariant === void 0 ? void 0 : filterVariant.includes("range")) return "betweenInclusive";
    if (filterVariant === "select" || filterVariant === "checkbox") return "equals";
    return "fuzzy";
};
const $35fd956d2f1c2be7$export$863d009b6baa6754 = ({ header: header, table: table })=>{
    var _a;
    const { options: { columnFilterModeOptions: columnFilterModeOptions } } = table;
    const { column: column } = header;
    const { columnDef: columnDef } = column;
    const { filterVariant: filterVariant } = columnDef;
    const isDateFilter = !!((filterVariant === null || filterVariant === void 0 ? void 0 : filterVariant.startsWith("date")) || (filterVariant === null || filterVariant === void 0 ? void 0 : filterVariant.startsWith("time")));
    const isAutocompleteFilter = filterVariant === "autocomplete";
    const isRangeFilter = (filterVariant === null || filterVariant === void 0 ? void 0 : filterVariant.includes("range")) || [
        "between",
        "betweenInclusive",
        "inNumberRange"
    ].includes(columnDef._filterFn);
    const isSelectFilter = filterVariant === "select";
    const isMultiSelectFilter = filterVariant === "multi-select";
    const isTextboxFilter = [
        "autocomplete",
        "text"
    ].includes(filterVariant) || !isSelectFilter && !isMultiSelectFilter;
    const currentFilterOption = columnDef._filterFn;
    const allowedColumnFilterOptions = (_a = columnDef === null || columnDef === void 0 ? void 0 : columnDef.columnFilterModeOptions) !== null && _a !== void 0 ? _a : columnFilterModeOptions;
    const facetedUniqueValues = column.getFacetedUniqueValues();
    return {
        allowedColumnFilterOptions: allowedColumnFilterOptions,
        currentFilterOption: currentFilterOption,
        facetedUniqueValues: facetedUniqueValues,
        isAutocompleteFilter: isAutocompleteFilter,
        isDateFilter: isDateFilter,
        isMultiSelectFilter: isMultiSelectFilter,
        isRangeFilter: isRangeFilter,
        isSelectFilter: isSelectFilter,
        isTextboxFilter: isTextboxFilter
    };
};
const $35fd956d2f1c2be7$export$9530f32da83c3525 = ({ header: header, table: table })=>{
    const { column: column } = header;
    const { columnDef: columnDef } = column;
    const { facetedUniqueValues: facetedUniqueValues, isAutocompleteFilter: isAutocompleteFilter, isMultiSelectFilter: isMultiSelectFilter, isSelectFilter: isSelectFilter } = $35fd956d2f1c2be7$export$863d009b6baa6754({
        header: header,
        table: table
    });
    return (0, $exYeM.useMemo)(()=>{
        var _a;
        return (_a = columnDef.filterSelectOptions) !== null && _a !== void 0 ? _a : (isSelectFilter || isMultiSelectFilter || isAutocompleteFilter) && facetedUniqueValues ? Array.from(facetedUniqueValues.keys()).filter((value)=>value !== null && value !== undefined).sort((a, b)=>a.localeCompare(b)) : undefined;
    }, [
        columnDef.filterSelectOptions,
        facetedUniqueValues,
        isMultiSelectFilter,
        isSelectFilter
    ]);
};
const $35fd956d2f1c2be7$export$f2385bb6e3ac4b4f = (0, $6f12815be8ba8421$export$f2385bb6e3ac4b4f);
function $35fd956d2f1c2be7$export$2545f48052a107ad() {
    return {
        accessor: (accessor, column)=>{
            return typeof accessor === "function" ? Object.assign(Object.assign({}, column), {
                accessorFn: accessor
            }) : Object.assign(Object.assign({}, column), {
                accessorKey: accessor
            });
        },
        display: (column)=>column,
        group: (column)=>column
    };
}
const $35fd956d2f1c2be7$export$3442c5d213434705 = (table, originalRow, rowIndex = -1, depth = 0, subRows, parentId)=>(0, $829253db717f8f1b$export$3442c5d213434705)(table, "mrt-row-create", originalRow !== null && originalRow !== void 0 ? originalRow : Object.assign({}, ...$35fd956d2f1c2be7$export$851defe8865cb834(table.options.columns).map((col)=>({
            [$35fd956d2f1c2be7$export$da3e7a4aacd802c(col)]: ""
        }))), rowIndex, depth, subRows, parentId);
const $35fd956d2f1c2be7$var$parseFromValuesOrFunc = (fn, arg)=>fn instanceof Function ? fn(arg) : fn;
const $35fd956d2f1c2be7$var$getValueAndLabel = (option)=>{
    var _a, _b, _c;
    let label = "";
    let value = "";
    if (option) {
        if (typeof option !== "object") {
            label = option;
            value = option;
        } else {
            label = (_b = (_a = option.label) !== null && _a !== void 0 ? _a : option.text) !== null && _b !== void 0 ? _b : option.value;
            value = (_c = option.value) !== null && _c !== void 0 ? _c : label;
        }
    }
    return {
        label: label,
        value: value
    };
};
const $35fd956d2f1c2be7$export$ac9f81ed8d41453f = ({ cell: cell, table: table })=>{
    const { enableEditing: enableEditing } = table.options;
    const { column: { columnDef: columnDef }, row: row } = cell;
    return !cell.getIsPlaceholder() && $35fd956d2f1c2be7$var$parseFromValuesOrFunc(enableEditing, row) && $35fd956d2f1c2be7$var$parseFromValuesOrFunc(columnDef.enableEditing, row) !== false;
};
const $35fd956d2f1c2be7$export$250fde3c71e02f70 = ({ cell: cell, table: table })=>{
    const { options: { editDisplayMode: editDisplayMode }, refs: { editInputRefs: editInputRefs } } = table;
    const { column: column } = cell;
    if ($35fd956d2f1c2be7$export$ac9f81ed8d41453f({
        cell: cell,
        table: table
    }) && editDisplayMode === "cell") {
        table.setEditingCell(cell);
        queueMicrotask(()=>{
            var _a;
            const textField = editInputRefs.current[column.id];
            if (textField) {
                textField.focus();
                (_a = textField.select) === null || _a === void 0 || _a.call(textField);
            }
        });
    }
};
function $35fd956d2f1c2be7$export$726a68fac408657b({ header: header, id: id, size: size, tableOptions: tableOptions }) {
    const { defaultDisplayColumn: defaultDisplayColumn, displayColumnDefOptions: displayColumnDefOptions, localization: localization } = tableOptions;
    return Object.assign(Object.assign(Object.assign(Object.assign({}, defaultDisplayColumn), {
        header: header ? localization[header] : "",
        size: size
    }), displayColumnDefOptions === null || displayColumnDefOptions === void 0 ? void 0 : displayColumnDefOptions[id]), {
        id: id
    });
}
const $35fd956d2f1c2be7$export$1a520a1b96a270ad = (tableOptions)=>{
    const { enableRowPinning: enableRowPinning, rowPinningDisplayMode: rowPinningDisplayMode } = tableOptions;
    return !!(enableRowPinning && !(rowPinningDisplayMode === null || rowPinningDisplayMode === void 0 ? void 0 : rowPinningDisplayMode.startsWith("select")));
};
const $35fd956d2f1c2be7$export$e3aff359325a595c = (tableOptions)=>{
    const { enableRowDragging: enableRowDragging, enableRowOrdering: enableRowOrdering } = tableOptions;
    return !!(enableRowDragging || enableRowOrdering);
};
const $35fd956d2f1c2be7$export$e60b8abd112d1687 = (tableOptions)=>{
    const { enableExpanding: enableExpanding, enableGrouping: enableGrouping, renderDetailPanel: renderDetailPanel, state: { grouping: grouping } } = tableOptions;
    return !!(enableExpanding || enableGrouping && (grouping === null || grouping === void 0 ? void 0 : grouping.length) || renderDetailPanel);
};
const $35fd956d2f1c2be7$export$a2ed1098e0cc0675 = (tableOptions)=>{
    const { createDisplayMode: createDisplayMode, editDisplayMode: editDisplayMode, enableEditing: enableEditing, enableRowActions: enableRowActions, state: { creatingRow: creatingRow } } = tableOptions;
    return !!(enableRowActions || creatingRow && createDisplayMode === "row" || enableEditing && [
        "modal",
        "row"
    ].includes(editDisplayMode !== null && editDisplayMode !== void 0 ? editDisplayMode : ""));
};
const $35fd956d2f1c2be7$export$390e68ee95994286 = (tableOptions)=>!!tableOptions.enableRowSelection;
const $35fd956d2f1c2be7$export$98baa70312ecf1b7 = (tableOptions)=>!!tableOptions.enableRowNumbers;
const $35fd956d2f1c2be7$export$702b9b60c63a9db8 = (tableOptions)=>tableOptions.layoutMode === "grid-no-grow";
const $35fd956d2f1c2be7$export$f1d1bf2bfd09cfa2 = (tableOptions)=>[
        $35fd956d2f1c2be7$export$1a520a1b96a270ad(tableOptions) && "mrt-row-pin",
        $35fd956d2f1c2be7$export$e3aff359325a595c(tableOptions) && "mrt-row-drag",
        tableOptions.positionActionsColumn === "first" && $35fd956d2f1c2be7$export$a2ed1098e0cc0675(tableOptions) && "mrt-row-actions",
        tableOptions.positionExpandColumn === "first" && $35fd956d2f1c2be7$export$e60b8abd112d1687(tableOptions) && "mrt-row-expand",
        $35fd956d2f1c2be7$export$390e68ee95994286(tableOptions) && "mrt-row-select",
        $35fd956d2f1c2be7$export$98baa70312ecf1b7(tableOptions) && "mrt-row-numbers"
    ].filter(Boolean);
const $35fd956d2f1c2be7$export$a2f9906ecc2022e7 = (tableOptions)=>[
        tableOptions.positionActionsColumn === "last" && $35fd956d2f1c2be7$export$a2ed1098e0cc0675(tableOptions) && "mrt-row-actions",
        tableOptions.positionExpandColumn === "last" && $35fd956d2f1c2be7$export$e60b8abd112d1687(tableOptions) && "mrt-row-expand",
        $35fd956d2f1c2be7$export$702b9b60c63a9db8(tableOptions) && "mrt-row-spacer"
    ].filter(Boolean);
const $35fd956d2f1c2be7$export$be53169041fbd6c5 = (tableOptions, reset = false)=>{
    const { state: { columnOrder: currentColumnOrderIds = [] } } = tableOptions;
    const leadingDisplayColIds = $35fd956d2f1c2be7$export$f1d1bf2bfd09cfa2(tableOptions);
    const trailingDisplayColIds = $35fd956d2f1c2be7$export$a2f9906ecc2022e7(tableOptions);
    const defaultColumnDefIds = $35fd956d2f1c2be7$export$851defe8865cb834(tableOptions.columns).map((columnDef)=>$35fd956d2f1c2be7$export$da3e7a4aacd802c(columnDef));
    let allLeafColumnDefIds = reset ? defaultColumnDefIds : Array.from(new Set([
        ...currentColumnOrderIds,
        ...defaultColumnDefIds
    ]));
    allLeafColumnDefIds = allLeafColumnDefIds.filter((colId)=>!leadingDisplayColIds.includes(colId) && !trailingDisplayColIds.includes(colId));
    return [
        ...leadingDisplayColIds,
        ...allLeafColumnDefIds,
        ...trailingDisplayColIds
    ];
};
const $35fd956d2f1c2be7$var$fuzzy$1 = (rowA, rowB, columnId)=>{
    let dir = 0;
    if (rowA.columnFiltersMeta[columnId]) dir = (0, $aaaefe1363178c1f$export$b0c6b3a142decb5a)(rowA.columnFiltersMeta[columnId], rowB.columnFiltersMeta[columnId]);
    // Provide a fallback for when the item ranks are equal
    return dir === 0 ? (0, $829253db717f8f1b$export$47423a4cd813a815).alphanumeric(rowA, rowB, columnId) : dir;
};
const $35fd956d2f1c2be7$export$cfca3685708ab5fc = Object.assign(Object.assign({}, (0, $829253db717f8f1b$export$47423a4cd813a815)), {
    fuzzy: $35fd956d2f1c2be7$var$fuzzy$1
});
const $35fd956d2f1c2be7$export$feab53f78f968726 = (rowA, rowB)=>Math.max(...Object.values(rowB.columnFiltersMeta).map((v)=>v.rank)) - Math.max(...Object.values(rowA.columnFiltersMeta).map((v)=>v.rank));
const $35fd956d2f1c2be7$export$10f6207b5d9c35e5 = (table, all)=>{
    const { getCenterRows: getCenterRows, getPrePaginationRowModel: getPrePaginationRowModel, getRowModel: getRowModel, getState: getState, getTopRows: getTopRows, options: { createDisplayMode: createDisplayMode, enablePagination: enablePagination, enableRowPinning: enableRowPinning, manualPagination: manualPagination, positionCreatingRow: positionCreatingRow, rowPinningDisplayMode: rowPinningDisplayMode } } = table;
    const { creatingRow: creatingRow, pagination: pagination } = getState();
    const isRankingRows = $35fd956d2f1c2be7$export$6057c00341b4dc7d(table);
    let rows = [];
    if (!isRankingRows) rows = !enableRowPinning || (rowPinningDisplayMode === null || rowPinningDisplayMode === void 0 ? void 0 : rowPinningDisplayMode.includes("sticky")) ? all ? getPrePaginationRowModel().rows : getRowModel().rows : getCenterRows();
    else {
        // fuzzy ranking adjustments
        rows = getPrePaginationRowModel().rows.sort((a, b)=>$35fd956d2f1c2be7$export$feab53f78f968726(a, b));
        if (enablePagination && !manualPagination && !all) {
            const start = pagination.pageIndex * pagination.pageSize;
            rows = rows.slice(start, start + pagination.pageSize);
        }
        if (enableRowPinning && !(rowPinningDisplayMode === null || rowPinningDisplayMode === void 0 ? void 0 : rowPinningDisplayMode.includes("sticky"))) // "re-center-ize" the rows (no top or bottom pinned rows unless sticky)
        rows = rows.filter((row)=>!row.getIsPinned());
    }
    // row pinning adjustments
    if (enableRowPinning && (rowPinningDisplayMode === null || rowPinningDisplayMode === void 0 ? void 0 : rowPinningDisplayMode.includes("sticky"))) {
        const centerPinnedRowIds = rows.filter((row)=>row.getIsPinned()).map((r)=>r.id);
        rows = [
            ...getTopRows().filter((row)=>!centerPinnedRowIds.includes(row.id)),
            ...rows
        ];
    }
    // blank inserted creating row adjustments
    if (positionCreatingRow !== undefined && creatingRow && createDisplayMode === "row") {
        const creatingRowIndex = !isNaN(+positionCreatingRow) ? +positionCreatingRow : positionCreatingRow === "top" ? 0 : rows.length;
        rows = [
            ...rows.slice(0, creatingRowIndex),
            creatingRow,
            ...rows.slice(creatingRowIndex)
        ];
    }
    return rows;
};
const $35fd956d2f1c2be7$export$47258840a7b8ac2c = (table)=>{
    const { getState: getState, options: { enableGlobalFilterRankedResults: enableGlobalFilterRankedResults, manualExpanding: manualExpanding, manualFiltering: manualFiltering, manualGrouping: manualGrouping, manualSorting: manualSorting } } = table;
    const { expanded: expanded, globalFilterFn: globalFilterFn } = getState();
    return !manualExpanding && !manualFiltering && !manualGrouping && !manualSorting && enableGlobalFilterRankedResults && globalFilterFn === "fuzzy" && expanded !== true && !Object.values(expanded).some(Boolean);
};
const $35fd956d2f1c2be7$export$6057c00341b4dc7d = (table)=>{
    const { globalFilter: globalFilter, sorting: sorting } = table.getState();
    return $35fd956d2f1c2be7$export$47258840a7b8ac2c(table) && globalFilter && !Object.values(sorting).some(Boolean);
};
const $35fd956d2f1c2be7$export$95688405cf6a5004 = ({ row: row, table: table })=>{
    const { options: { enableRowSelection: enableRowSelection } } = table;
    return row.getIsSelected() || $35fd956d2f1c2be7$var$parseFromValuesOrFunc(enableRowSelection, row) && row.getCanSelectSubRows() && row.getIsAllSubRowsSelected();
};
const $35fd956d2f1c2be7$export$781f7bdc35feda71 = ({ row: row, staticRowIndex: staticRowIndex = 0, table: table })=>(event, value)=>{
        var _a;
        const { getState: getState, options: { enableBatchRowSelection: enableBatchRowSelection, enableMultiRowSelection: enableMultiRowSelection, enableRowPinning: enableRowPinning, manualPagination: manualPagination, rowPinningDisplayMode: rowPinningDisplayMode }, refs: { lastSelectedRowId: lastSelectedRowId } } = table;
        const { pagination: { pageIndex: pageIndex, pageSize: pageSize } } = getState();
        const paginationOffset = manualPagination ? 0 : pageSize * pageIndex;
        const wasCurrentRowChecked = $35fd956d2f1c2be7$export$95688405cf6a5004({
            row: row,
            table: table
        });
        // toggle selection of this row
        row.toggleSelected(value !== null && value !== void 0 ? value : !wasCurrentRowChecked);
        const changedRowIds = new Set([
            row.id
        ]);
        // if shift key is pressed, select all rows between last selected and this one
        if (enableBatchRowSelection && enableMultiRowSelection && event.nativeEvent.shiftKey && lastSelectedRowId.current !== null) {
            const rows = $35fd956d2f1c2be7$export$10f6207b5d9c35e5(table, true);
            const lastIndex = rows.findIndex((r)=>r.id === lastSelectedRowId.current);
            if (lastIndex !== -1) {
                const isLastIndexChecked = $35fd956d2f1c2be7$export$95688405cf6a5004({
                    row: rows === null || rows === void 0 ? void 0 : rows[lastIndex],
                    table: table
                });
                const currentIndex = staticRowIndex + paginationOffset;
                const [start, end] = lastIndex < currentIndex ? [
                    lastIndex,
                    currentIndex
                ] : [
                    currentIndex,
                    lastIndex
                ];
                // toggle selection of all rows between last selected and this one
                // but only if the last selected row is not the same as the current one
                if (wasCurrentRowChecked !== isLastIndexChecked) for(let i = start; i <= end; i++){
                    rows[i].toggleSelected(!wasCurrentRowChecked);
                    changedRowIds.add(rows[i].id);
                }
            }
        }
        // record the last selected row id
        lastSelectedRowId.current = row.id;
        // if all sub rows were selected, unselect them
        if (row.getCanSelectSubRows() && row.getIsAllSubRowsSelected()) (_a = row.subRows) === null || _a === void 0 || _a.forEach((r)=>r.toggleSelected(false));
        if (enableRowPinning && (rowPinningDisplayMode === null || rowPinningDisplayMode === void 0 ? void 0 : rowPinningDisplayMode.includes("select"))) changedRowIds.forEach((rowId)=>{
            const rowToTogglePin = table.getRow(rowId);
            rowToTogglePin.pin(!wasCurrentRowChecked //was not previously pinned or selected
             ? (rowPinningDisplayMode === null || rowPinningDisplayMode === void 0 ? void 0 : rowPinningDisplayMode.includes("bottom")) ? "bottom" : "top" : false);
        });
    };
const $35fd956d2f1c2be7$export$971e27a1f984fd93 = ({ table: table })=>(event, value, forceAll)=>{
        const { options: { enableRowPinning: enableRowPinning, rowPinningDisplayMode: rowPinningDisplayMode, selectAllMode: selectAllMode }, refs: { lastSelectedRowId: lastSelectedRowId } } = table;
        selectAllMode === "all" || forceAll ? table.toggleAllRowsSelected(value !== null && value !== void 0 ? value : event.target.checked) : table.toggleAllPageRowsSelected(value !== null && value !== void 0 ? value : event.target.checked);
        if (enableRowPinning && (rowPinningDisplayMode === null || rowPinningDisplayMode === void 0 ? void 0 : rowPinningDisplayMode.includes("select"))) table.setRowPinning({
            bottom: [],
            top: []
        });
        lastSelectedRowId.current = null;
    };
const $35fd956d2f1c2be7$export$b560094588c4318 = Object.assign({}, (0, $829253db717f8f1b$export$3aa4339120b8b25b));
const $35fd956d2f1c2be7$var$fuzzy = (row, columnId, filterValue, addMeta)=>{
    const itemRank = (0, $aaaefe1363178c1f$export$2bf9c99d6a293bc8)(row.getValue(columnId), filterValue, {
        threshold: (0, $aaaefe1363178c1f$export$809b0b82a3f0b8b5).MATCHES
    });
    addMeta(itemRank);
    return itemRank.passed;
};
$35fd956d2f1c2be7$var$fuzzy.autoRemove = (val)=>!val;
const $35fd956d2f1c2be7$var$contains = (row, id, filterValue)=>row.getValue(id).toString().toLowerCase().trim().includes(filterValue.toString().toLowerCase().trim());
$35fd956d2f1c2be7$var$contains.autoRemove = (val)=>!val;
const $35fd956d2f1c2be7$var$startsWith = (row, id, filterValue)=>row.getValue(id).toString().toLowerCase().trim().startsWith(filterValue.toString().toLowerCase().trim());
$35fd956d2f1c2be7$var$startsWith.autoRemove = (val)=>!val;
const $35fd956d2f1c2be7$var$endsWith = (row, id, filterValue)=>row.getValue(id).toString().toLowerCase().trim().endsWith(filterValue.toString().toLowerCase().trim());
$35fd956d2f1c2be7$var$endsWith.autoRemove = (val)=>!val;
const $35fd956d2f1c2be7$var$equals = (row, id, filterValue)=>row.getValue(id).toString().toLowerCase().trim() === (filterValue === null || filterValue === void 0 ? void 0 : filterValue.toString().toLowerCase().trim());
$35fd956d2f1c2be7$var$equals.autoRemove = (val)=>!val;
const $35fd956d2f1c2be7$var$notEquals = (row, id, filterValue)=>row.getValue(id).toString().toLowerCase().trim() !== filterValue.toString().toLowerCase().trim();
$35fd956d2f1c2be7$var$notEquals.autoRemove = (val)=>!val;
const $35fd956d2f1c2be7$var$greaterThan = (row, id, filterValue)=>!isNaN(+filterValue) && !isNaN(+row.getValue(id)) ? +row.getValue(id) > +filterValue : row.getValue(id).toString().toLowerCase().trim() > (filterValue === null || filterValue === void 0 ? void 0 : filterValue.toString().toLowerCase().trim());
$35fd956d2f1c2be7$var$greaterThan.autoRemove = (val)=>!val;
const $35fd956d2f1c2be7$var$greaterThanOrEqualTo = (row, id, filterValue)=>$35fd956d2f1c2be7$var$equals(row, id, filterValue) || $35fd956d2f1c2be7$var$greaterThan(row, id, filterValue);
$35fd956d2f1c2be7$var$greaterThanOrEqualTo.autoRemove = (val)=>!val;
const $35fd956d2f1c2be7$var$lessThan = (row, id, filterValue)=>!isNaN(+filterValue) && !isNaN(+row.getValue(id)) ? +row.getValue(id) < +filterValue : row.getValue(id).toString().toLowerCase().trim() < (filterValue === null || filterValue === void 0 ? void 0 : filterValue.toString().toLowerCase().trim());
$35fd956d2f1c2be7$var$lessThan.autoRemove = (val)=>!val;
const $35fd956d2f1c2be7$var$lessThanOrEqualTo = (row, id, filterValue)=>$35fd956d2f1c2be7$var$equals(row, id, filterValue) || $35fd956d2f1c2be7$var$lessThan(row, id, filterValue);
$35fd956d2f1c2be7$var$lessThanOrEqualTo.autoRemove = (val)=>!val;
const $35fd956d2f1c2be7$var$between = (row, id, filterValues)=>([
        "",
        undefined
    ].includes(filterValues[0]) || $35fd956d2f1c2be7$var$greaterThan(row, id, filterValues[0])) && (!isNaN(+filterValues[0]) && !isNaN(+filterValues[1]) && +filterValues[0] > +filterValues[1] || [
        "",
        undefined
    ].includes(filterValues[1]) || $35fd956d2f1c2be7$var$lessThan(row, id, filterValues[1]));
$35fd956d2f1c2be7$var$between.autoRemove = (val)=>!val;
const $35fd956d2f1c2be7$var$betweenInclusive = (row, id, filterValues)=>([
        "",
        undefined
    ].includes(filterValues[0]) || $35fd956d2f1c2be7$var$greaterThanOrEqualTo(row, id, filterValues[0])) && (!isNaN(+filterValues[0]) && !isNaN(+filterValues[1]) && +filterValues[0] > +filterValues[1] || [
        "",
        undefined
    ].includes(filterValues[1]) || $35fd956d2f1c2be7$var$lessThanOrEqualTo(row, id, filterValues[1]));
$35fd956d2f1c2be7$var$betweenInclusive.autoRemove = (val)=>!val;
const $35fd956d2f1c2be7$var$empty = (row, id, _filterValue)=>!row.getValue(id).toString().trim();
$35fd956d2f1c2be7$var$empty.autoRemove = (val)=>!val;
const $35fd956d2f1c2be7$var$notEmpty = (row, id, _filterValue)=>!!row.getValue(id).toString().trim();
$35fd956d2f1c2be7$var$notEmpty.autoRemove = (val)=>!val;
const $35fd956d2f1c2be7$export$81754f428e3b4fc7 = Object.assign(Object.assign({}, (0, $829253db717f8f1b$export$6ad8312e296ec316)), {
    between: $35fd956d2f1c2be7$var$between,
    betweenInclusive: $35fd956d2f1c2be7$var$betweenInclusive,
    contains: $35fd956d2f1c2be7$var$contains,
    empty: $35fd956d2f1c2be7$var$empty,
    endsWith: $35fd956d2f1c2be7$var$endsWith,
    equals: $35fd956d2f1c2be7$var$equals,
    fuzzy: $35fd956d2f1c2be7$var$fuzzy,
    greaterThan: $35fd956d2f1c2be7$var$greaterThan,
    greaterThanOrEqualTo: $35fd956d2f1c2be7$var$greaterThanOrEqualTo,
    lessThan: $35fd956d2f1c2be7$var$lessThan,
    lessThanOrEqualTo: $35fd956d2f1c2be7$var$lessThanOrEqualTo,
    notEmpty: $35fd956d2f1c2be7$var$notEmpty,
    notEquals: $35fd956d2f1c2be7$var$notEquals,
    startsWith: $35fd956d2f1c2be7$var$startsWith
});
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $35fd956d2f1c2be7$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
typeof SuppressedError === "function" && SuppressedError;
const $35fd956d2f1c2be7$export$e9ac3fa68bee6831 = (_a)=>{
    var { row: row, table: table, variant: variant = "icon" } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "row",
        "table",
        "variant"
    ]);
    const { getState: getState, options: { icons: { CancelIcon: CancelIcon, SaveIcon: SaveIcon }, localization: localization, onCreatingRowCancel: onCreatingRowCancel, onCreatingRowSave: onCreatingRowSave, onEditingRowCancel: onEditingRowCancel, onEditingRowSave: onEditingRowSave }, refs: { editInputRefs: editInputRefs }, setCreatingRow: setCreatingRow, setEditingRow: setEditingRow } = table;
    const { creatingRow: creatingRow, editingRow: editingRow, isSaving: isSaving } = getState();
    const isCreating = (creatingRow === null || creatingRow === void 0 ? void 0 : creatingRow.id) === row.id;
    const isEditing = (editingRow === null || editingRow === void 0 ? void 0 : editingRow.id) === row.id;
    const handleCancel = ()=>{
        if (isCreating) {
            onCreatingRowCancel === null || onCreatingRowCancel === void 0 || onCreatingRowCancel({
                row: row,
                table: table
            });
            setCreatingRow(null);
        } else if (isEditing) {
            onEditingRowCancel === null || onEditingRowCancel === void 0 || onEditingRowCancel({
                row: row,
                table: table
            });
            setEditingRow(null);
        }
        row._valuesCache = {}; //reset values cache
    };
    const handleSubmitRow = ()=>{
        var _a;
        //look for auto-filled input values
        (_a = Object.values(editInputRefs === null || editInputRefs === void 0 ? void 0 : editInputRefs.current).filter((inputRef)=>{
            var _a, _b;
            return row.id === ((_b = (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.name) === null || _a === void 0 ? void 0 : _a.split("_")) === null || _b === void 0 ? void 0 : _b[0]);
        })) === null || _a === void 0 || _a.forEach((input)=>{
            if (input.value !== undefined && Object.hasOwn(row === null || row === void 0 ? void 0 : row._valuesCache, input.name)) // @ts-ignore
            row._valuesCache[input.name] = input.value;
        });
        if (isCreating) onCreatingRowSave === null || onCreatingRowSave === void 0 || onCreatingRowSave({
            exitCreatingMode: ()=>setCreatingRow(null),
            row: row,
            table: table,
            values: row._valuesCache
        });
        else if (isEditing) onEditingRowSave === null || onEditingRowSave === void 0 || onEditingRowSave({
            exitEditingMode: ()=>setEditingRow(null),
            row: row,
            table: table,
            values: row === null || row === void 0 ? void 0 : row._valuesCache
        });
    };
    return (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        onClick: (e)=>e.stopPropagation(),
        sx: (theme)=>Object.assign({
                display: "flex",
                gap: "0.75rem"
            }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(rest === null || rest === void 0 ? void 0 : rest.sx, theme)),
        children: variant === "icon" ? (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
            children: [
                (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), {
                    title: localization.cancel,
                    children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), {
                        "aria-label": localization.cancel,
                        onClick: handleCancel,
                        children: (0, $aSiaI.jsx)(CancelIcon, {})
                    })
                }),
                (isCreating && onCreatingRowSave || isEditing && onEditingRowSave) && (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), {
                    title: localization.save,
                    children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), {
                        "aria-label": localization.save,
                        color: "info",
                        onClick: handleSubmitRow,
                        children: isSaving ? (0, $aSiaI.jsx)((0, $8a947ac56b8361c3$export$2e2bcd8739ae039), {
                            size: 18
                        }) : (0, $aSiaI.jsx)(SaveIcon, {})
                    })
                })
            ]
        }) : (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
            children: [
                (0, $aSiaI.jsx)((0, $980dfff3cab72cf4$export$2e2bcd8739ae039), {
                    onClick: handleCancel,
                    sx: {
                        minWidth: "100px"
                    },
                    children: localization.cancel
                }),
                (0, $aSiaI.jsxs)((0, $980dfff3cab72cf4$export$2e2bcd8739ae039), {
                    onClick: handleSubmitRow,
                    sx: {
                        minWidth: "100px"
                    },
                    variant: "contained",
                    children: [
                        isSaving && (0, $aSiaI.jsx)((0, $8a947ac56b8361c3$export$2e2bcd8739ae039), {
                            color: "inherit",
                            size: 18
                        }),
                        localization.save
                    ]
                })
            ]
        })
    });
};
const $35fd956d2f1c2be7$var$parseCSSVarId = (id)=>id.replace(/[^a-zA-Z0-9]/g, "_");
const $35fd956d2f1c2be7$var$getMRTTheme = (mrtTheme, muiTheme)=>{
    var _a;
    const mrtThemeOverrides = $35fd956d2f1c2be7$var$parseFromValuesOrFunc(mrtTheme, muiTheme);
    const baseBackgroundColor = (_a = mrtThemeOverrides === null || mrtThemeOverrides === void 0 ? void 0 : mrtThemeOverrides.baseBackgroundColor) !== null && _a !== void 0 ? _a : muiTheme.palette.mode === "dark" ? (0, $69eec9e6c105674b$export$c0816ed86df316af)(muiTheme.palette.background.default, 0.05) : muiTheme.palette.background.default;
    return Object.assign({
        baseBackgroundColor: baseBackgroundColor,
        draggingBorderColor: muiTheme.palette.primary.main,
        matchHighlightColor: muiTheme.palette.mode === "dark" ? (0, $69eec9e6c105674b$export$4b073707ff63303)(muiTheme.palette.warning.dark, 0.25) : (0, $69eec9e6c105674b$export$c0816ed86df316af)(muiTheme.palette.warning.light, 0.5),
        menuBackgroundColor: (0, $69eec9e6c105674b$export$c0816ed86df316af)(baseBackgroundColor, 0.07),
        pinnedRowBackgroundColor: (0, $69eec9e6c105674b$export$58f0f39f63f3cf42)(muiTheme.palette.primary.main, 0.1),
        selectedRowBackgroundColor: (0, $69eec9e6c105674b$export$58f0f39f63f3cf42)(muiTheme.palette.primary.main, 0.2)
    }, mrtThemeOverrides);
};
const $35fd956d2f1c2be7$var$commonCellBeforeAfterStyles = {
    content: '""',
    height: "100%",
    left: 0,
    position: "absolute",
    top: 0,
    width: "100%",
    zIndex: -1
};
const $35fd956d2f1c2be7$var$getCommonPinnedCellStyles = ({ column: column, table: table, theme: theme })=>{
    const { baseBackgroundColor: baseBackgroundColor } = table.options.mrtTheme;
    const isPinned = column === null || column === void 0 ? void 0 : column.getIsPinned();
    return {
        '&[data-pinned="true"]': {
            "&:before": Object.assign({
                backgroundColor: (0, $69eec9e6c105674b$export$58f0f39f63f3cf42)((0, $69eec9e6c105674b$export$4b073707ff63303)(baseBackgroundColor, theme.palette.mode === "dark" ? 0.05 : 0.01), 0.97),
                boxShadow: column ? isPinned === "left" && column.getIsLastColumn(isPinned) ? `-4px 0 4px -4px ${(0, $69eec9e6c105674b$export$58f0f39f63f3cf42)(theme.palette.grey[700], 0.5)} inset` : isPinned === "right" && column.getIsFirstColumn(isPinned) ? `4px 0 4px -4px ${(0, $69eec9e6c105674b$export$58f0f39f63f3cf42)(theme.palette.grey[700], 0.5)} inset` : undefined : undefined
            }, $35fd956d2f1c2be7$var$commonCellBeforeAfterStyles)
        }
    };
};
const $35fd956d2f1c2be7$var$getCommonMRTCellStyles = ({ column: column, header: header, table: table, tableCellProps: tableCellProps, theme: theme })=>{
    var _a, _b, _c, _d, _e, _f;
    const { getState: getState, options: { enableColumnVirtualization: enableColumnVirtualization, layoutMode: layoutMode } } = table;
    const { draggingColumn: draggingColumn } = getState();
    const { columnDef: columnDef } = column;
    const { columnDefType: columnDefType } = columnDef;
    const isColumnPinned = columnDef.columnDefType !== "group" && column.getIsPinned();
    const widthStyles = {
        minWidth: `max(calc(var(--${header ? "header" : "col"}-${$35fd956d2f1c2be7$var$parseCSSVarId((_a = header === null || header === void 0 ? void 0 : header.id) !== null && _a !== void 0 ? _a : column.id)}-size) * 1px), ${(_b = columnDef.minSize) !== null && _b !== void 0 ? _b : 30}px)`,
        width: `calc(var(--${header ? "header" : "col"}-${$35fd956d2f1c2be7$var$parseCSSVarId((_c = header === null || header === void 0 ? void 0 : header.id) !== null && _c !== void 0 ? _c : column.id)}-size) * 1px)`
    };
    if (layoutMode === "grid") widthStyles.flex = `${[
        0,
        false
    ].includes(columnDef.grow) ? 0 : `var(--${header ? "header" : "col"}-${$35fd956d2f1c2be7$var$parseCSSVarId((_d = header === null || header === void 0 ? void 0 : header.id) !== null && _d !== void 0 ? _d : column.id)}-size)`} 0 auto`;
    else if (layoutMode === "grid-no-grow") widthStyles.flex = `${+(columnDef.grow || 0)} 0 auto`;
    const pinnedStyles = isColumnPinned ? Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$getCommonPinnedCellStyles({
        column: column,
        table: table,
        theme: theme
    })), {
        left: isColumnPinned === "left" ? `${column.getStart("left")}px` : undefined,
        opacity: 0.97,
        position: "sticky",
        right: isColumnPinned === "right" ? `${column.getAfter("right")}px` : undefined
    }) : {};
    return Object.assign(Object.assign(Object.assign({
        backgroundColor: "inherit",
        backgroundImage: "inherit",
        display: (layoutMode === null || layoutMode === void 0 ? void 0 : layoutMode.startsWith("grid")) ? "flex" : undefined,
        justifyContent: columnDefType === "group" ? "center" : (layoutMode === null || layoutMode === void 0 ? void 0 : layoutMode.startsWith("grid")) ? tableCellProps.align : undefined,
        opacity: ((_e = table.getState().draggingColumn) === null || _e === void 0 ? void 0 : _e.id) === column.id || ((_f = table.getState().hoveredColumn) === null || _f === void 0 ? void 0 : _f.id) === column.id ? 0.5 : 1,
        position: "relative",
        transition: enableColumnVirtualization ? "none" : `padding 150ms ease-in-out`,
        zIndex: column.getIsResizing() || (draggingColumn === null || draggingColumn === void 0 ? void 0 : draggingColumn.id) === column.id ? 2 : columnDefType !== "group" && isColumnPinned ? 1 : 0
    }, pinnedStyles), widthStyles), $35fd956d2f1c2be7$var$parseFromValuesOrFunc(tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.sx, theme));
};
const $35fd956d2f1c2be7$var$getCommonToolbarStyles = ({ table: table })=>({
        alignItems: "flex-start",
        backgroundColor: table.options.mrtTheme.baseBackgroundColor,
        display: "grid",
        flexWrap: "wrap-reverse",
        minHeight: "3.5rem",
        overflow: "hidden",
        position: "relative",
        transition: "all 150ms ease-in-out",
        zIndex: 1
    });
const $35fd956d2f1c2be7$var$flipIconStyles = (theme)=>theme.direction === "rtl" ? {
        style: {
            transform: "scaleX(-1)"
        }
    } : undefined;
const $35fd956d2f1c2be7$var$getCommonTooltipProps = (placement)=>({
        disableInteractive: true,
        enterDelay: 1000,
        enterNextDelay: 1000,
        placement: placement
    });
const $35fd956d2f1c2be7$export$7a47075d9547bd75 = (_a)=>{
    var { icon: icon, label: label, onOpenSubMenu: onOpenSubMenu, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "icon",
        "label",
        "onOpenSubMenu",
        "table"
    ]);
    const { options: { icons: { ArrowRightIcon: ArrowRightIcon } } } = table;
    return (0, $aSiaI.jsxs)((0, $32731aa3cf1ce086$export$2e2bcd8739ae039), Object.assign({
        sx: {
            alignItems: "center",
            justifyContent: "space-between",
            minWidth: "120px",
            my: 0,
            py: "6px"
        }
    }, rest, {
        children: [
            (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                sx: {
                    alignItems: "center",
                    display: "flex"
                },
                children: [
                    (0, $aSiaI.jsx)((0, $2b564c102ca4210b$export$2e2bcd8739ae039), {
                        children: icon
                    }),
                    label
                ]
            }),
            onOpenSubMenu && (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), {
                onClick: onOpenSubMenu,
                onMouseEnter: onOpenSubMenu,
                size: "small",
                sx: {
                    p: 0
                },
                children: (0, $aSiaI.jsx)(ArrowRightIcon, {})
            })
        ]
    }));
};
const $35fd956d2f1c2be7$export$a80f83c83c0ca779 = (_a)=>{
    var { anchorEl: anchorEl, handleEdit: handleEdit, row: row, setAnchorEl: setAnchorEl, staticRowIndex: staticRowIndex, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "anchorEl",
        "handleEdit",
        "row",
        "setAnchorEl",
        "staticRowIndex",
        "table"
    ]);
    const { getState: getState, options: { editDisplayMode: editDisplayMode, enableEditing: enableEditing, icons: { EditIcon: EditIcon }, localization: localization, mrtTheme: { menuBackgroundColor: menuBackgroundColor }, renderRowActionMenuItems: renderRowActionMenuItems } } = table;
    const { density: density } = getState();
    return (0, $aSiaI.jsxs)((0, $cf82f57fc51895ad$export$2e2bcd8739ae039), Object.assign({
        MenuListProps: {
            dense: density === "compact",
            sx: {
                backgroundColor: menuBackgroundColor
            }
        },
        anchorEl: anchorEl,
        disableScrollLock: true,
        onClick: (event)=>event.stopPropagation(),
        onClose: ()=>setAnchorEl(null),
        open: !!anchorEl
    }, rest, {
        children: [
            $35fd956d2f1c2be7$var$parseFromValuesOrFunc(enableEditing, row) && [
                "modal",
                "row"
            ].includes(editDisplayMode) && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$7a47075d9547bd75, {
                icon: (0, $aSiaI.jsx)(EditIcon, {}),
                label: localization.edit,
                onClick: handleEdit,
                table: table
            }),
            renderRowActionMenuItems === null || renderRowActionMenuItems === void 0 ? void 0 : renderRowActionMenuItems({
                closeMenu: ()=>setAnchorEl(null),
                row: row,
                staticRowIndex: staticRowIndex,
                table: table
            })
        ]
    }));
};
const $35fd956d2f1c2be7$var$commonIconButtonStyles = {
    "&:hover": {
        opacity: 1
    },
    height: "2rem",
    ml: "10px",
    opacity: 0.5,
    transition: "opacity 150ms",
    width: "2rem"
};
const $35fd956d2f1c2be7$export$d1d7822219c6bc0 = (_a)=>{
    var { cell: cell, row: row, staticRowIndex: staticRowIndex, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "cell",
        "row",
        "staticRowIndex",
        "table"
    ]);
    const { getState: getState, options: { createDisplayMode: createDisplayMode, editDisplayMode: editDisplayMode, enableEditing: enableEditing, icons: { EditIcon: EditIcon, MoreHorizIcon: MoreHorizIcon }, localization: localization, renderRowActionMenuItems: renderRowActionMenuItems, renderRowActions: renderRowActions }, setEditingRow: setEditingRow } = table;
    const { creatingRow: creatingRow, editingRow: editingRow } = getState();
    const isCreating = (creatingRow === null || creatingRow === void 0 ? void 0 : creatingRow.id) === row.id;
    const isEditing = (editingRow === null || editingRow === void 0 ? void 0 : editingRow.id) === row.id;
    const showEditActionButtons = isCreating && createDisplayMode === "row" || isEditing && editDisplayMode === "row";
    const [anchorEl, setAnchorEl] = (0, $exYeM.useState)(null);
    const handleOpenRowActionMenu = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };
    const handleStartEditMode = (event)=>{
        event.stopPropagation();
        setEditingRow(Object.assign({}, row));
        setAnchorEl(null);
    };
    return (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: renderRowActions && !showEditActionButtons ? renderRowActions({
            cell: cell,
            row: row,
            staticRowIndex: staticRowIndex,
            table: table
        }) : showEditActionButtons ? (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$e9ac3fa68bee6831, {
            row: row,
            table: table
        }) : !renderRowActionMenuItems && $35fd956d2f1c2be7$var$parseFromValuesOrFunc(enableEditing, row) && [
            "modal",
            "row"
        ].includes(editDisplayMode) ? (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), {
            placement: "right",
            title: localization.edit,
            children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), Object.assign({
                "aria-label": localization.edit,
                onClick: handleStartEditMode,
                sx: $35fd956d2f1c2be7$var$commonIconButtonStyles
            }, rest, {
                children: (0, $aSiaI.jsx)(EditIcon, {})
            }))
        }) : renderRowActionMenuItems ? (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
            children: [
                (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), Object.assign({}, $35fd956d2f1c2be7$var$getCommonTooltipProps(), {
                    title: localization.rowActions,
                    children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), Object.assign({
                        "aria-label": localization.rowActions,
                        onClick: handleOpenRowActionMenu,
                        size: "small",
                        sx: $35fd956d2f1c2be7$var$commonIconButtonStyles
                    }, rest, {
                        children: (0, $aSiaI.jsx)(MoreHorizIcon, {})
                    }))
                })),
                (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$a80f83c83c0ca779, {
                    anchorEl: anchorEl,
                    handleEdit: handleStartEditMode,
                    row: row,
                    setAnchorEl: setAnchorEl,
                    staticRowIndex: staticRowIndex,
                    table: table
                })
            ]
        }) : null
    });
};
const $35fd956d2f1c2be7$var$getMRT_RowActionsColumnDef = (tableOptions)=>{
    return Object.assign({
        Cell: ({ cell: cell, row: row, staticRowIndex: staticRowIndex, table: table })=>(0, $aSiaI.jsx)($35fd956d2f1c2be7$export$d1d7822219c6bc0, {
                cell: cell,
                row: row,
                staticRowIndex: staticRowIndex,
                table: table
            })
    }, $35fd956d2f1c2be7$export$726a68fac408657b({
        header: "actions",
        id: "mrt-row-actions",
        size: 70,
        tableOptions: tableOptions
    }));
};
const $35fd956d2f1c2be7$export$84d0ca45a1213a16 = (_a)=>{
    var _b, _c;
    var { location: location, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "location",
        "table"
    ]);
    const { options: { icons: { DragHandleIcon: DragHandleIcon }, localization: localization } } = table;
    return (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), Object.assign({}, $35fd956d2f1c2be7$var$getCommonTooltipProps("top"), {
        title: (_b = rest === null || rest === void 0 ? void 0 : rest.title) !== null && _b !== void 0 ? _b : localization.move,
        children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), Object.assign({
            "aria-label": (_c = rest.title) !== null && _c !== void 0 ? _c : localization.move,
            disableRipple: true,
            draggable: "true",
            size: "small"
        }, rest, {
            onClick: (e)=>{
                var _a;
                e.stopPropagation();
                (_a = rest === null || rest === void 0 ? void 0 : rest.onClick) === null || _a === void 0 || _a.call(rest, e);
            },
            sx: (theme)=>Object.assign({
                    "&:active": {
                        cursor: "grabbing"
                    },
                    "&:hover": {
                        backgroundColor: "transparent",
                        opacity: 1
                    },
                    cursor: "grab",
                    m: "0 -0.1rem",
                    opacity: location === "row" ? 1 : 0.5,
                    p: "2px",
                    transition: "all 150ms ease-in-out"
                }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(rest === null || rest === void 0 ? void 0 : rest.sx, theme)),
            title: undefined,
            children: (0, $aSiaI.jsx)(DragHandleIcon, {})
        }))
    }));
};
const $35fd956d2f1c2be7$export$6e455bb03dd34304 = (_a)=>{
    var { row: row, rowRef: rowRef, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "row",
        "rowRef",
        "table"
    ]);
    const { options: { muiRowDragHandleProps: muiRowDragHandleProps } } = table;
    const iconButtonProps = Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiRowDragHandleProps, {
        row: row,
        table: table
    })), rest);
    const handleDragStart = (event)=>{
        var _a;
        (_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onDragStart) === null || _a === void 0 || _a.call(iconButtonProps, event);
        try {
            event.dataTransfer.setDragImage(rowRef.current, 0, 0);
        } catch (e) {
            console.error(e);
        }
        table.setDraggingRow(row);
    };
    const handleDragEnd = (event)=>{
        var _a;
        (_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onDragEnd) === null || _a === void 0 || _a.call(iconButtonProps, event);
        table.setDraggingRow(null);
        table.setHoveredRow(null);
    };
    return (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$84d0ca45a1213a16, Object.assign({}, iconButtonProps, {
        location: "row",
        onDragEnd: handleDragEnd,
        onDragStart: handleDragStart,
        table: table
    }));
};
const $35fd956d2f1c2be7$var$getMRT_RowDragColumnDef = (tableOptions)=>{
    return Object.assign({
        Cell: ({ row: row, rowRef: rowRef, table: table })=>(0, $aSiaI.jsx)($35fd956d2f1c2be7$export$6e455bb03dd34304, {
                row: row,
                rowRef: rowRef,
                table: table
            }),
        grow: false
    }, $35fd956d2f1c2be7$export$726a68fac408657b({
        header: "move",
        id: "mrt-row-drag",
        size: 60,
        tableOptions: tableOptions
    }));
};
const $35fd956d2f1c2be7$export$d349191d17930548 = (_a)=>{
    var _b, _c;
    var { table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "table"
    ]);
    const { getCanSomeRowsExpand: getCanSomeRowsExpand, getIsAllRowsExpanded: getIsAllRowsExpanded, getIsSomeRowsExpanded: getIsSomeRowsExpanded, getState: getState, options: { icons: { KeyboardDoubleArrowDownIcon: KeyboardDoubleArrowDownIcon }, localization: localization, muiExpandAllButtonProps: muiExpandAllButtonProps, renderDetailPanel: renderDetailPanel }, toggleAllRowsExpanded: toggleAllRowsExpanded } = table;
    const { density: density, isLoading: isLoading } = getState();
    const iconButtonProps = Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiExpandAllButtonProps, {
        table: table
    })), rest);
    const isAllRowsExpanded = getIsAllRowsExpanded();
    return (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), Object.assign({}, $35fd956d2f1c2be7$var$getCommonTooltipProps(), {
        title: (_b = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.title) !== null && _b !== void 0 ? _b : isAllRowsExpanded ? localization.collapseAll : localization.expandAll,
        children: (0, $aSiaI.jsx)("span", {
            children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), Object.assign({
                "aria-label": localization.expandAll,
                disabled: isLoading || !renderDetailPanel && !getCanSomeRowsExpand(),
                onClick: ()=>toggleAllRowsExpanded(!isAllRowsExpanded)
            }, iconButtonProps, {
                sx: (theme)=>Object.assign({
                        height: density === "compact" ? "1.75rem" : "2.25rem",
                        mt: density !== "compact" ? "-0.25rem" : undefined,
                        width: density === "compact" ? "1.75rem" : "2.25rem"
                    }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.sx, theme)),
                title: undefined,
                children: (_c = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.children) !== null && _c !== void 0 ? _c : (0, $aSiaI.jsx)(KeyboardDoubleArrowDownIcon, {
                    style: {
                        transform: `rotate(${isAllRowsExpanded ? -180 : getIsSomeRowsExpanded() ? -90 : 0}deg)`,
                        transition: "transform 150ms"
                    }
                })
            }))
        })
    }));
};
const $35fd956d2f1c2be7$export$25237f0a7e0a5aea = ({ row: row, staticRowIndex: staticRowIndex, table: table })=>{
    var _a, _b;
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const { getState: getState, options: { icons: { ExpandMoreIcon: ExpandMoreIcon }, localization: localization, muiExpandButtonProps: muiExpandButtonProps, positionExpandColumn: positionExpandColumn, renderDetailPanel: renderDetailPanel } } = table;
    const { density: density } = getState();
    const iconButtonProps = $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiExpandButtonProps, {
        row: row,
        staticRowIndex: staticRowIndex,
        table: table
    });
    const canExpand = row.getCanExpand();
    const isExpanded = row.getIsExpanded();
    const handleToggleExpand = (event)=>{
        var _a;
        event.stopPropagation();
        row.toggleExpanded();
        (_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onClick) === null || _a === void 0 || _a.call(iconButtonProps, event);
    };
    const detailPanel = !!(renderDetailPanel === null || renderDetailPanel === void 0 ? void 0 : renderDetailPanel({
        row: row,
        table: table
    }));
    return (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), Object.assign({
        disableHoverListener: !canExpand && !detailPanel
    }, $35fd956d2f1c2be7$var$getCommonTooltipProps(), {
        title: (_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.title) !== null && _a !== void 0 ? _a : isExpanded ? localization.collapse : localization.expand,
        children: (0, $aSiaI.jsx)("span", {
            children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), Object.assign({
                "aria-label": localization.expand,
                disabled: !canExpand && !detailPanel
            }, iconButtonProps, {
                onClick: handleToggleExpand,
                sx: (theme)=>Object.assign({
                        height: density === "compact" ? "1.75rem" : "2.25rem",
                        opacity: !canExpand && !detailPanel ? 0.3 : 1,
                        [theme.direction === "rtl" || positionExpandColumn === "last" ? "mr" : "ml"]: `${row.depth * 16}px`,
                        width: density === "compact" ? "1.75rem" : "2.25rem"
                    }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.sx, theme)),
                title: undefined,
                children: (_b = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.children) !== null && _b !== void 0 ? _b : (0, $aSiaI.jsx)(ExpandMoreIcon, {
                    style: {
                        transform: `rotate(${!canExpand && !renderDetailPanel ? positionExpandColumn === "last" || theme.direction === "rtl" ? 90 : -90 : isExpanded ? -180 : 0}deg)`,
                        transition: "transform 150ms"
                    }
                })
            }))
        })
    }));
};
const $35fd956d2f1c2be7$var$getMRT_RowExpandColumnDef = (tableOptions)=>{
    var _a;
    const { defaultColumn: defaultColumn, enableExpandAll: enableExpandAll, groupedColumnMode: groupedColumnMode, positionExpandColumn: positionExpandColumn, renderDetailPanel: renderDetailPanel, state: { grouping: grouping } } = tableOptions;
    const alignProps = positionExpandColumn === "last" ? {
        align: "right"
    } : undefined;
    return Object.assign({
        Cell: ({ cell: cell, column: column, row: row, staticRowIndex: staticRowIndex, table: table })=>{
            var _a, _b, _c;
            const expandButtonProps = {
                row: row,
                staticRowIndex: staticRowIndex,
                table: table
            };
            const subRowsLength = (_a = row.subRows) === null || _a === void 0 ? void 0 : _a.length;
            if (groupedColumnMode === "remove" && row.groupingColumnId) return (0, $aSiaI.jsxs)((0, $e10e66deff206ed9$export$2e2bcd8739ae039), {
                alignItems: "center",
                flexDirection: "row",
                gap: "0.25rem",
                children: [
                    (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$25237f0a7e0a5aea, Object.assign({}, expandButtonProps)),
                    (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), Object.assign({}, $35fd956d2f1c2be7$var$getCommonTooltipProps("right"), {
                        title: table.getColumn(row.groupingColumnId).columnDef.header,
                        children: (0, $aSiaI.jsx)("span", {
                            children: row.groupingValue
                        })
                    })),
                    !!subRowsLength && (0, $aSiaI.jsxs)("span", {
                        children: [
                            "(",
                            subRowsLength,
                            ")"
                        ]
                    })
                ]
            });
            else return (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                children: [
                    (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$25237f0a7e0a5aea, Object.assign({}, expandButtonProps)),
                    (_c = (_b = column.columnDef).GroupedCell) === null || _c === void 0 ? void 0 : _c.call(_b, {
                        cell: cell,
                        column: column,
                        row: row,
                        table: table
                    })
                ]
            });
        },
        Header: enableExpandAll ? ({ table: table })=>{
            var _a;
            return (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                children: [
                    (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$d349191d17930548, {
                        table: table
                    }),
                    groupedColumnMode === "remove" && ((_a = grouping === null || grouping === void 0 ? void 0 : grouping.map((groupedColumnId)=>table.getColumn(groupedColumnId).columnDef.header)) === null || _a === void 0 ? void 0 : _a.join(", "))
                ]
            });
        } : undefined,
        muiTableBodyCellProps: alignProps,
        muiTableHeadCellProps: alignProps
    }, $35fd956d2f1c2be7$export$726a68fac408657b({
        header: "expand",
        id: "mrt-row-expand",
        size: groupedColumnMode === "remove" ? (_a = defaultColumn === null || defaultColumn === void 0 ? void 0 : defaultColumn.size) !== null && _a !== void 0 ? _a : 180 : renderDetailPanel ? enableExpandAll ? 60 : 70 : 100,
        tableOptions: tableOptions
    }));
};
const $35fd956d2f1c2be7$var$getMRT_RowNumbersColumnDef = (tableOptions)=>{
    const { localization: localization, rowNumberDisplayMode: rowNumberDisplayMode } = tableOptions;
    const { pagination: { pageIndex: pageIndex, pageSize: pageSize } } = tableOptions.state;
    return Object.assign({
        Cell: ({ row: row, staticRowIndex: staticRowIndex })=>{
            var _a;
            return ((_a = rowNumberDisplayMode === "static" ? (staticRowIndex || 0) + (pageSize || 0) * (pageIndex || 0) : row.index) !== null && _a !== void 0 ? _a : 0) + 1;
        },
        Header: ()=>localization.rowNumber,
        grow: false
    }, $35fd956d2f1c2be7$export$726a68fac408657b({
        header: "rowNumbers",
        id: "mrt-row-numbers",
        size: 50,
        tableOptions: tableOptions
    }));
};
const $35fd956d2f1c2be7$export$aeca33f1d0739f86 = (_a)=>{
    var { pinningPosition: pinningPosition, row: row, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "pinningPosition",
        "row",
        "table"
    ]);
    const { options: { icons: { CloseIcon: CloseIcon, PushPinIcon: PushPinIcon }, localization: localization, rowPinningDisplayMode: rowPinningDisplayMode } } = table;
    const isPinned = row.getIsPinned();
    const [tooltipOpened, setTooltipOpened] = (0, $exYeM.useState)(false);
    const handleTogglePin = (event)=>{
        setTooltipOpened(false);
        event.stopPropagation();
        row.pin(isPinned ? false : pinningPosition);
    };
    return (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), Object.assign({}, $35fd956d2f1c2be7$var$getCommonTooltipProps(), {
        open: tooltipOpened,
        title: isPinned ? localization.unpin : localization.pin,
        children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), Object.assign({
            "aria-label": localization.pin,
            onClick: handleTogglePin,
            onMouseEnter: ()=>setTooltipOpened(true),
            onMouseLeave: ()=>setTooltipOpened(false),
            size: "small"
        }, rest, {
            sx: (theme)=>Object.assign({
                    height: "24px",
                    width: "24px"
                }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(rest === null || rest === void 0 ? void 0 : rest.sx, theme)),
            children: isPinned ? (0, $aSiaI.jsx)(CloseIcon, {}) : (0, $aSiaI.jsx)(PushPinIcon, {
                fontSize: "small",
                style: {
                    transform: `rotate(${rowPinningDisplayMode === "sticky" ? 135 : pinningPosition === "top" ? 180 : 0}deg)`
                }
            })
        }))
    }));
};
const $35fd956d2f1c2be7$export$6b99ae01e9dca3df = (_a)=>{
    var { row: row, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "row",
        "table"
    ]);
    const { getState: getState, options: { enableRowPinning: enableRowPinning, rowPinningDisplayMode: rowPinningDisplayMode } } = table;
    const { density: density } = getState();
    const canPin = $35fd956d2f1c2be7$var$parseFromValuesOrFunc(enableRowPinning, row);
    if (!canPin) return null;
    const rowPinButtonProps = Object.assign({
        row: row,
        table: table
    }, rest);
    if (rowPinningDisplayMode === "top-and-bottom" && !row.getIsPinned()) return (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        sx: {
            display: "flex",
            flexDirection: density === "compact" ? "row" : "column"
        },
        children: [
            (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$aeca33f1d0739f86, Object.assign({
                pinningPosition: "top"
            }, rowPinButtonProps)),
            (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$aeca33f1d0739f86, Object.assign({
                pinningPosition: "bottom"
            }, rowPinButtonProps))
        ]
    });
    return (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$aeca33f1d0739f86, Object.assign({
        pinningPosition: rowPinningDisplayMode === "bottom" ? "bottom" : "top"
    }, rowPinButtonProps));
};
const $35fd956d2f1c2be7$var$getMRT_RowPinningColumnDef = (tableOptions)=>{
    return Object.assign({
        Cell: ({ row: row, table: table })=>(0, $aSiaI.jsx)($35fd956d2f1c2be7$export$6b99ae01e9dca3df, {
                row: row,
                table: table
            }),
        grow: false
    }, $35fd956d2f1c2be7$export$726a68fac408657b({
        header: "pin",
        id: "mrt-row-pin",
        size: 60,
        tableOptions: tableOptions
    }));
};
const $35fd956d2f1c2be7$export$85257578ef187ebd = (_a)=>{
    var _b;
    var { row: row, staticRowIndex: staticRowIndex, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "row",
        "staticRowIndex",
        "table"
    ]);
    const { getState: getState, options: { enableMultiRowSelection: enableMultiRowSelection, localization: localization, muiSelectAllCheckboxProps: muiSelectAllCheckboxProps, muiSelectCheckboxProps: muiSelectCheckboxProps, selectAllMode: selectAllMode } } = table;
    const { density: density, isLoading: isLoading } = getState();
    const selectAll = !row;
    const allRowsSelected = selectAll ? selectAllMode === "page" ? table.getIsAllPageRowsSelected() : table.getIsAllRowsSelected() : undefined;
    const isChecked = selectAll ? allRowsSelected : $35fd956d2f1c2be7$export$95688405cf6a5004({
        row: row,
        table: table
    });
    const checkboxProps = Object.assign(Object.assign({}, selectAll ? $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiSelectAllCheckboxProps, {
        table: table
    }) : $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiSelectCheckboxProps, {
        row: row,
        staticRowIndex: staticRowIndex,
        table: table
    })), rest);
    const onSelectionChange = row ? $35fd956d2f1c2be7$export$781f7bdc35feda71({
        row: row,
        staticRowIndex: staticRowIndex,
        table: table
    }) : undefined;
    const onSelectAllChange = $35fd956d2f1c2be7$export$971e27a1f984fd93({
        table: table
    });
    const commonProps = Object.assign(Object.assign({
        "aria-label": selectAll ? localization.toggleSelectAll : localization.toggleSelectRow,
        checked: isChecked,
        disabled: isLoading || row && !row.getCanSelect() || (row === null || row === void 0 ? void 0 : row.id) === "mrt-row-create",
        inputProps: {
            "aria-label": selectAll ? localization.toggleSelectAll : localization.toggleSelectRow
        },
        onChange: (event)=>{
            event.stopPropagation();
            selectAll ? onSelectAllChange(event) : onSelectionChange(event);
        },
        size: density === "compact" ? "small" : "medium"
    }, checkboxProps), {
        onClick: (e)=>{
            var _a;
            e.stopPropagation();
            (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.onClick) === null || _a === void 0 || _a.call(checkboxProps, e);
        },
        sx: (theme)=>Object.assign({
                height: density === "compact" ? "1.75rem" : "2.5rem",
                m: density !== "compact" ? "-0.4rem" : undefined,
                width: density === "compact" ? "1.75rem" : "2.5rem",
                zIndex: 0
            }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.sx, theme)),
        title: undefined
    });
    return (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), Object.assign({}, $35fd956d2f1c2be7$var$getCommonTooltipProps(), {
        title: (_b = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.title) !== null && _b !== void 0 ? _b : selectAll ? localization.toggleSelectAll : localization.toggleSelectRow,
        children: enableMultiRowSelection === false ? (0, $aSiaI.jsx)((0, $ea4cbdb779e4e707$export$2e2bcd8739ae039), Object.assign({}, commonProps)) : (0, $aSiaI.jsx)((0, $71e996631894f6ef$export$2e2bcd8739ae039), Object.assign({
            indeterminate: !isChecked && selectAll ? table.getIsSomeRowsSelected() : (row === null || row === void 0 ? void 0 : row.getIsSomeSelected()) && row.getCanSelectSubRows()
        }, commonProps))
    }));
};
const $35fd956d2f1c2be7$var$getMRT_RowSelectColumnDef = (tableOptions)=>{
    const { enableMultiRowSelection: enableMultiRowSelection, enableSelectAll: enableSelectAll } = tableOptions;
    return Object.assign({
        Cell: ({ row: row, staticRowIndex: staticRowIndex, table: table })=>(0, $aSiaI.jsx)($35fd956d2f1c2be7$export$85257578ef187ebd, {
                row: row,
                staticRowIndex: staticRowIndex,
                table: table
            }),
        Header: enableSelectAll && enableMultiRowSelection ? ({ table: table })=>(0, $aSiaI.jsx)($35fd956d2f1c2be7$export$85257578ef187ebd, {
                table: table
            }) : undefined,
        grow: false
    }, $35fd956d2f1c2be7$export$726a68fac408657b({
        header: "select",
        id: "mrt-row-select",
        size: enableSelectAll ? 60 : 70,
        tableOptions: tableOptions
    }));
};
const $35fd956d2f1c2be7$var$MRT_Default_Icons = {
    ArrowDownwardIcon: (/*@__PURE__*/$parcel$interopDefault($5112857e1bcd1016$exports)),
    ArrowRightIcon: (/*@__PURE__*/$parcel$interopDefault($8746997fc9b720f2$exports)),
    CancelIcon: (/*@__PURE__*/$parcel$interopDefault($60d7d5fa78396591$exports)),
    ChevronLeftIcon: (/*@__PURE__*/$parcel$interopDefault($c00d5190e3488a47$exports)),
    ChevronRightIcon: (/*@__PURE__*/$parcel$interopDefault($dbc6bd8fdc5e4c56$exports)),
    ClearAllIcon: (/*@__PURE__*/$parcel$interopDefault($43903a21cb6185bc$exports)),
    CloseIcon: (/*@__PURE__*/$parcel$interopDefault($83d99ee14fb596ff$exports)),
    ContentCopy: (/*@__PURE__*/$parcel$interopDefault($0e1f814edd2464e7$exports)),
    DensityLargeIcon: (/*@__PURE__*/$parcel$interopDefault($2b42a4e3efe19567$exports)),
    DensityMediumIcon: (/*@__PURE__*/$parcel$interopDefault($4ddc56ce752c5656$exports)),
    DensitySmallIcon: (/*@__PURE__*/$parcel$interopDefault($dcb9363effa006b6$exports)),
    DragHandleIcon: (/*@__PURE__*/$parcel$interopDefault($977fba31f26be5c0$exports)),
    DynamicFeedIcon: (/*@__PURE__*/$parcel$interopDefault($ac0d67057d1a5411$exports)),
    EditIcon: (/*@__PURE__*/$parcel$interopDefault($5b7579778695630b$exports)),
    ExpandMoreIcon: (/*@__PURE__*/$parcel$interopDefault($f886b3fb8270265c$exports)),
    FilterAltIcon: (/*@__PURE__*/$parcel$interopDefault($7938f397ab0081b0$exports)),
    FilterListIcon: (/*@__PURE__*/$parcel$interopDefault($c65a30dfed2635c2$exports)),
    FilterListOffIcon: (/*@__PURE__*/$parcel$interopDefault($52443ec225efd215$exports)),
    FirstPageIcon: (/*@__PURE__*/$parcel$interopDefault($a58df43394eb0c4a$exports)),
    FullscreenExitIcon: (/*@__PURE__*/$parcel$interopDefault($6db53a4a680131b0$exports)),
    FullscreenIcon: (/*@__PURE__*/$parcel$interopDefault($46d363505ccc3709$exports)),
    KeyboardDoubleArrowDownIcon: (/*@__PURE__*/$parcel$interopDefault($7cbf90241dfcba43$exports)),
    LastPageIcon: (/*@__PURE__*/$parcel$interopDefault($3403bd974326352d$exports)),
    MoreHorizIcon: (/*@__PURE__*/$parcel$interopDefault($a791bfd60ccffe5c$exports)),
    MoreVertIcon: (/*@__PURE__*/$parcel$interopDefault($77da07cd8804c984$exports)),
    PushPinIcon: (/*@__PURE__*/$parcel$interopDefault($660ec9bb22541201$exports)),
    RestartAltIcon: (/*@__PURE__*/$parcel$interopDefault($a8ef35a31ad13503$exports)),
    SaveIcon: (/*@__PURE__*/$parcel$interopDefault($8a674ab1ec556e2e$exports)),
    SearchIcon: (/*@__PURE__*/$parcel$interopDefault($e0daa6fa57c30cfa$exports)),
    SearchOffIcon: (/*@__PURE__*/$parcel$interopDefault($747857be872ace67$exports)),
    SortIcon: (/*@__PURE__*/$parcel$interopDefault($cd936e4c5bed64be$exports)),
    SyncAltIcon: (/*@__PURE__*/$parcel$interopDefault($c316df7762e301fb$exports)),
    ViewColumnIcon: (/*@__PURE__*/$parcel$interopDefault($b05df11e888ab937$exports)),
    VisibilityOffIcon: (/*@__PURE__*/$parcel$interopDefault($4d9db64c414b25e1$exports))
};
const $35fd956d2f1c2be7$var$MRT_Localization_EN = {
    actions: "Actions",
    and: "and",
    cancel: "Cancel",
    changeFilterMode: "Change filter mode",
    changeSearchMode: "Change search mode",
    clearFilter: "Clear filter",
    clearSearch: "Clear search",
    clearSelection: "Clear selection",
    clearSort: "Clear sort",
    clickToCopy: "Click to copy",
    copy: "Copy",
    collapse: "Collapse",
    collapseAll: "Collapse all",
    columnActions: "Column Actions",
    copiedToClipboard: "Copied to clipboard",
    dropToGroupBy: "Drop to group by {column}",
    edit: "Edit",
    expand: "Expand",
    expandAll: "Expand all",
    filterArrIncludes: "Includes",
    filterArrIncludesAll: "Includes all",
    filterArrIncludesSome: "Includes",
    filterBetween: "Between",
    filterBetweenInclusive: "Between Inclusive",
    filterByColumn: "Filter by {column}",
    filterContains: "Contains",
    filterEmpty: "Empty",
    filterEndsWith: "Ends With",
    filterEquals: "Equals",
    filterEqualsString: "Equals",
    filterFuzzy: "Fuzzy",
    filterGreaterThan: "Greater Than",
    filterGreaterThanOrEqualTo: "Greater Than Or Equal To",
    filterInNumberRange: "Between",
    filterIncludesString: "Contains",
    filterIncludesStringSensitive: "Contains",
    filterLessThan: "Less Than",
    filterLessThanOrEqualTo: "Less Than Or Equal To",
    filterMode: "Filter Mode: {filterType}",
    filterNotEmpty: "Not Empty",
    filterNotEquals: "Not Equals",
    filterStartsWith: "Starts With",
    filterWeakEquals: "Equals",
    filteringByColumn: "Filtering by {column} - {filterType} {filterValue}",
    goToFirstPage: "Go to first page",
    goToLastPage: "Go to last page",
    goToNextPage: "Go to next page",
    goToPreviousPage: "Go to previous page",
    grab: "Grab",
    groupByColumn: "Group by {column}",
    groupedBy: "Grouped by ",
    hideAll: "Hide all",
    hideColumn: "Hide {column} column",
    max: "Max",
    min: "Min",
    move: "Move",
    noRecordsToDisplay: "No records to display",
    noResultsFound: "No results found",
    of: "of",
    or: "or",
    pin: "Pin",
    pinToLeft: "Pin to left",
    pinToRight: "Pin to right",
    resetColumnSize: "Reset column size",
    resetOrder: "Reset order",
    rowActions: "Row Actions",
    rowNumber: "#",
    rowNumbers: "Row Numbers",
    rowsPerPage: "Rows per page",
    save: "Save",
    search: "Search",
    selectedCountOfRowCountRowsSelected: "{selectedCount} of {rowCount} row(s) selected",
    select: "Select",
    showAll: "Show all",
    showAllColumns: "Show all columns",
    showHideColumns: "Show/Hide columns",
    showHideFilters: "Show/Hide filters",
    showHideSearch: "Show/Hide search",
    sortByColumnAsc: "Sort by {column} ascending",
    sortByColumnDesc: "Sort by {column} descending",
    sortedByColumnAsc: "Sorted by {column} ascending",
    sortedByColumnDesc: "Sorted by {column} descending",
    thenBy: ", then by ",
    toggleDensity: "Toggle density",
    toggleFullScreen: "Toggle full screen",
    toggleSelectAll: "Toggle select all",
    toggleSelectRow: "Toggle select row",
    toggleVisibility: "Toggle visibility",
    ungroupByColumn: "Ungroup by {column}",
    unpin: "Unpin",
    unpinAll: "Unpin all"
};
const $35fd956d2f1c2be7$export$9de485275e9a864b = {
    filterVariant: "text",
    maxSize: 1000,
    minSize: 40,
    size: 180
};
const $35fd956d2f1c2be7$export$ef49aebafe938818 = {
    columnDefType: "display",
    enableClickToCopy: false,
    enableColumnActions: false,
    enableColumnDragging: false,
    enableColumnFilter: false,
    enableColumnOrdering: false,
    enableEditing: false,
    enableGlobalFilter: false,
    enableGrouping: false,
    enableHiding: false,
    enableResizing: false,
    enableSorting: false
};
const $35fd956d2f1c2be7$export$d132b01ac0b4e971 = (_a)=>{
    var _b;
    var { aggregationFns: aggregationFns, autoResetExpanded: autoResetExpanded = false, columnFilterDisplayMode: columnFilterDisplayMode = "subheader", columnResizeDirection: columnResizeDirection, columnResizeMode: columnResizeMode = "onChange", createDisplayMode: createDisplayMode = "modal", defaultColumn: defaultColumn, defaultDisplayColumn: defaultDisplayColumn, editDisplayMode: editDisplayMode = "modal", enableBatchRowSelection: enableBatchRowSelection = true, enableBottomToolbar: enableBottomToolbar = true, enableColumnActions: enableColumnActions = true, enableColumnFilters: enableColumnFilters = true, enableColumnOrdering: enableColumnOrdering = false, enableColumnPinning: enableColumnPinning = false, enableColumnResizing: enableColumnResizing = false, enableColumnVirtualization: enableColumnVirtualization, enableDensityToggle: enableDensityToggle = true, enableExpandAll: enableExpandAll = true, enableExpanding: enableExpanding, enableFacetedValues: enableFacetedValues = false, enableFilterMatchHighlighting: enableFilterMatchHighlighting = true, enableFilters: enableFilters = true, enableFullScreenToggle: enableFullScreenToggle = true, enableGlobalFilter: enableGlobalFilter = true, enableGlobalFilterRankedResults: enableGlobalFilterRankedResults = true, enableGrouping: enableGrouping = false, enableHiding: enableHiding = true, enableMultiRowSelection: enableMultiRowSelection = true, enableMultiSort: enableMultiSort = true, enablePagination: enablePagination = true, enableRowPinning: enableRowPinning = false, enableRowSelection: enableRowSelection = false, enableRowVirtualization: enableRowVirtualization, enableSelectAll: enableSelectAll = true, enableSorting: enableSorting = true, enableStickyHeader: enableStickyHeader = false, enableTableFooter: enableTableFooter = true, enableTableHead: enableTableHead = true, enableToolbarInternalActions: enableToolbarInternalActions = true, enableTopToolbar: enableTopToolbar = true, filterFns: filterFns, icons: icons, layoutMode: layoutMode, localization: localization, manualFiltering: manualFiltering, manualGrouping: manualGrouping, manualPagination: manualPagination, manualSorting: manualSorting, mrtTheme: mrtTheme, paginationDisplayMode: paginationDisplayMode = "default", positionActionsColumn: positionActionsColumn = "first", positionCreatingRow: positionCreatingRow = "top", positionExpandColumn: positionExpandColumn = "first", positionGlobalFilter: positionGlobalFilter = "right", positionPagination: positionPagination = "bottom", positionToolbarAlertBanner: positionToolbarAlertBanner = "top", positionToolbarDropZone: positionToolbarDropZone = "top", rowNumberDisplayMode: rowNumberDisplayMode = "static", rowPinningDisplayMode: rowPinningDisplayMode = "sticky", selectAllMode: selectAllMode = "page", sortingFns: sortingFns } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "aggregationFns",
        "autoResetExpanded",
        "columnFilterDisplayMode",
        "columnResizeDirection",
        "columnResizeMode",
        "createDisplayMode",
        "defaultColumn",
        "defaultDisplayColumn",
        "editDisplayMode",
        "enableBatchRowSelection",
        "enableBottomToolbar",
        "enableColumnActions",
        "enableColumnFilters",
        "enableColumnOrdering",
        "enableColumnPinning",
        "enableColumnResizing",
        "enableColumnVirtualization",
        "enableDensityToggle",
        "enableExpandAll",
        "enableExpanding",
        "enableFacetedValues",
        "enableFilterMatchHighlighting",
        "enableFilters",
        "enableFullScreenToggle",
        "enableGlobalFilter",
        "enableGlobalFilterRankedResults",
        "enableGrouping",
        "enableHiding",
        "enableMultiRowSelection",
        "enableMultiSort",
        "enablePagination",
        "enableRowPinning",
        "enableRowSelection",
        "enableRowVirtualization",
        "enableSelectAll",
        "enableSorting",
        "enableStickyHeader",
        "enableTableFooter",
        "enableTableHead",
        "enableToolbarInternalActions",
        "enableTopToolbar",
        "filterFns",
        "icons",
        "layoutMode",
        "localization",
        "manualFiltering",
        "manualGrouping",
        "manualPagination",
        "manualSorting",
        "mrtTheme",
        "paginationDisplayMode",
        "positionActionsColumn",
        "positionCreatingRow",
        "positionExpandColumn",
        "positionGlobalFilter",
        "positionPagination",
        "positionToolbarAlertBanner",
        "positionToolbarDropZone",
        "rowNumberDisplayMode",
        "rowPinningDisplayMode",
        "selectAllMode",
        "sortingFns"
    ]);
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    icons = (0, $exYeM.useMemo)(()=>Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$MRT_Default_Icons), icons), [
        icons
    ]);
    localization = (0, $exYeM.useMemo)(()=>Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$MRT_Localization_EN), localization), [
        localization
    ]);
    mrtTheme = (0, $exYeM.useMemo)(()=>$35fd956d2f1c2be7$var$getMRTTheme(mrtTheme, theme), [
        mrtTheme,
        theme
    ]);
    aggregationFns = (0, $exYeM.useMemo)(()=>Object.assign(Object.assign({}, $35fd956d2f1c2be7$export$b560094588c4318), aggregationFns), []);
    filterFns = (0, $exYeM.useMemo)(()=>Object.assign(Object.assign({}, $35fd956d2f1c2be7$export$81754f428e3b4fc7), filterFns), []);
    sortingFns = (0, $exYeM.useMemo)(()=>Object.assign(Object.assign({}, $35fd956d2f1c2be7$export$cfca3685708ab5fc), sortingFns), []);
    defaultColumn = (0, $exYeM.useMemo)(()=>Object.assign(Object.assign({}, $35fd956d2f1c2be7$export$9de485275e9a864b), defaultColumn), [
        defaultColumn
    ]);
    defaultDisplayColumn = (0, $exYeM.useMemo)(()=>Object.assign(Object.assign({}, $35fd956d2f1c2be7$export$ef49aebafe938818), defaultDisplayColumn), [
        defaultDisplayColumn
    ]);
    //cannot be changed after initialization
    [enableColumnVirtualization, enableRowVirtualization] = (0, $exYeM.useMemo)(()=>[
            enableColumnVirtualization,
            enableRowVirtualization
        ], []);
    if (!columnResizeDirection) columnResizeDirection = theme.direction || "ltr";
    layoutMode = layoutMode || (enableColumnResizing ? "grid-no-grow" : "semantic");
    if (layoutMode === "semantic" && (enableRowVirtualization || enableColumnVirtualization)) layoutMode = "grid";
    if (enableRowVirtualization) enableStickyHeader = true;
    if (enablePagination === false && manualPagination === undefined) manualPagination = true;
    if (!((_b = rest.data) === null || _b === void 0 ? void 0 : _b.length)) {
        manualFiltering = true;
        manualGrouping = true;
        manualPagination = true;
        manualSorting = true;
    }
    return Object.assign({
        aggregationFns: aggregationFns,
        autoResetExpanded: autoResetExpanded,
        columnFilterDisplayMode: columnFilterDisplayMode,
        columnResizeDirection: columnResizeDirection,
        columnResizeMode: columnResizeMode,
        createDisplayMode: createDisplayMode,
        defaultColumn: defaultColumn,
        defaultDisplayColumn: defaultDisplayColumn,
        editDisplayMode: editDisplayMode,
        enableBatchRowSelection: enableBatchRowSelection,
        enableBottomToolbar: enableBottomToolbar,
        enableColumnActions: enableColumnActions,
        enableColumnFilters: enableColumnFilters,
        enableColumnOrdering: enableColumnOrdering,
        enableColumnPinning: enableColumnPinning,
        enableColumnResizing: enableColumnResizing,
        enableColumnVirtualization: enableColumnVirtualization,
        enableDensityToggle: enableDensityToggle,
        enableExpandAll: enableExpandAll,
        enableExpanding: enableExpanding,
        enableFacetedValues: enableFacetedValues,
        enableFilterMatchHighlighting: enableFilterMatchHighlighting,
        enableFilters: enableFilters,
        enableFullScreenToggle: enableFullScreenToggle,
        enableGlobalFilter: enableGlobalFilter,
        enableGlobalFilterRankedResults: enableGlobalFilterRankedResults,
        enableGrouping: enableGrouping,
        enableHiding: enableHiding,
        enableMultiRowSelection: enableMultiRowSelection,
        enableMultiSort: enableMultiSort,
        enablePagination: enablePagination,
        enableRowPinning: enableRowPinning,
        enableRowSelection: enableRowSelection,
        enableRowVirtualization: enableRowVirtualization,
        enableSelectAll: enableSelectAll,
        enableSorting: enableSorting,
        enableStickyHeader: enableStickyHeader,
        enableTableFooter: enableTableFooter,
        enableTableHead: enableTableHead,
        enableToolbarInternalActions: enableToolbarInternalActions,
        enableTopToolbar: enableTopToolbar,
        filterFns: filterFns,
        getCoreRowModel: (0, $829253db717f8f1b$export$32d0bc001e828250)(),
        getExpandedRowModel: enableExpanding || enableGrouping ? (0, $829253db717f8f1b$export$53cfec7b1b8d1fcd)() : undefined,
        getFacetedMinMaxValues: enableFacetedValues ? (0, $829253db717f8f1b$export$d17dd32c9eab9fc7)() : undefined,
        getFacetedRowModel: enableFacetedValues ? (0, $829253db717f8f1b$export$3519aa0e35dc33b4)() : undefined,
        getFacetedUniqueValues: enableFacetedValues ? (0, $829253db717f8f1b$export$1fb5d0c1edc37de2)() : undefined,
        getFilteredRowModel: enableColumnFilters || enableGlobalFilter || enableFilters ? (0, $829253db717f8f1b$export$26f255a2756e1638)() : undefined,
        getGroupedRowModel: enableGrouping ? (0, $829253db717f8f1b$export$2b7f4b57ce71b81)() : undefined,
        getPaginationRowModel: enablePagination ? (0, $829253db717f8f1b$export$ddfd3662e196c265)() : undefined,
        getSortedRowModel: enableSorting ? (0, $829253db717f8f1b$export$4ca93ca80835d8c1)() : undefined,
        getSubRows: (row)=>row === null || row === void 0 ? void 0 : row.subRows,
        icons: icons,
        layoutMode: layoutMode,
        localization: localization,
        manualFiltering: manualFiltering,
        manualGrouping: manualGrouping,
        manualPagination: manualPagination,
        manualSorting: manualSorting,
        mrtTheme: mrtTheme,
        paginationDisplayMode: paginationDisplayMode,
        positionActionsColumn: positionActionsColumn,
        positionCreatingRow: positionCreatingRow,
        positionExpandColumn: positionExpandColumn,
        positionGlobalFilter: positionGlobalFilter,
        positionPagination: positionPagination,
        positionToolbarAlertBanner: positionToolbarAlertBanner,
        positionToolbarDropZone: positionToolbarDropZone,
        rowNumberDisplayMode: rowNumberDisplayMode,
        rowPinningDisplayMode: rowPinningDisplayMode,
        selectAllMode: selectAllMode,
        sortingFns: sortingFns
    }, rest);
};
const $35fd956d2f1c2be7$var$blankColProps = {
    children: null,
    sx: {
        minWidth: 0,
        p: 0,
        width: 0
    }
};
const $35fd956d2f1c2be7$var$getMRT_RowSpacerColumnDef = (tableOptions)=>{
    return Object.assign(Object.assign(Object.assign(Object.assign({}, $35fd956d2f1c2be7$export$726a68fac408657b({
        id: "mrt-row-spacer",
        size: 0,
        tableOptions: tableOptions
    })), {
        grow: true
    }), $35fd956d2f1c2be7$export$ef49aebafe938818), {
        muiTableBodyCellProps: $35fd956d2f1c2be7$var$blankColProps,
        muiTableFooterCellProps: $35fd956d2f1c2be7$var$blankColProps,
        muiTableHeadCellProps: $35fd956d2f1c2be7$var$blankColProps
    });
};
const $35fd956d2f1c2be7$export$5c933a64445776e4 = (table)=>{
    const { getIsSomeRowsPinned: getIsSomeRowsPinned, getPrePaginationRowModel: getPrePaginationRowModel, getState: getState, options: { enablePagination: enablePagination, enableRowPinning: enableRowPinning, rowCount: rowCount } } = table;
    const { columnOrder: columnOrder, density: density, globalFilter: globalFilter, isFullScreen: isFullScreen, isLoading: isLoading, pagination: pagination, showSkeletons: showSkeletons, sorting: sorting } = getState();
    const totalColumnCount = table.options.columns.length;
    const totalRowCount = rowCount !== null && rowCount !== void 0 ? rowCount : getPrePaginationRowModel().rows.length;
    const rerender = (0, $exYeM.useReducer)(()=>({}), {})[1];
    const initialBodyHeight = (0, $exYeM.useRef)();
    const previousTop = (0, $exYeM.useRef)();
    (0, $exYeM.useEffect)(()=>{
        if (typeof window !== "undefined") initialBodyHeight.current = document.body.style.height;
    }, []);
    //hide scrollbars when table is in full screen mode, preserve body scroll position after full screen exit
    (0, $exYeM.useEffect)(()=>{
        if (typeof window !== "undefined") {
            if (isFullScreen) {
                previousTop.current = document.body.getBoundingClientRect().top; //save scroll position
                document.body.style.height = "100dvh"; //hide page scrollbars when table is in full screen mode
            } else {
                document.body.style.height = initialBodyHeight.current;
                if (!previousTop.current) return;
                //restore scroll position
                window.scrollTo({
                    behavior: "instant",
                    top: -1 * previousTop.current
                });
            }
        }
    }, [
        isFullScreen
    ]);
    //recalculate column order when columns change or features are toggled on/off
    (0, $exYeM.useEffect)(()=>{
        if (totalColumnCount !== columnOrder.length) table.setColumnOrder($35fd956d2f1c2be7$export$be53169041fbd6c5(table.options));
    }, [
        totalColumnCount
    ]);
    //if page index is out of bounds, set it to the last page
    (0, $exYeM.useEffect)(()=>{
        if (!enablePagination || isLoading || showSkeletons) return;
        const { pageIndex: pageIndex, pageSize: pageSize } = pagination;
        const firstVisibleRowIndex = pageIndex * pageSize;
        if (firstVisibleRowIndex >= totalRowCount) table.setPageIndex(Math.ceil(totalRowCount / pageSize) - 1);
    }, [
        totalRowCount
    ]);
    //turn off sort when global filter is looking for ranked results
    const appliedSort = (0, $exYeM.useRef)(sorting);
    (0, $exYeM.useEffect)(()=>{
        if (sorting.length) appliedSort.current = sorting;
    }, [
        sorting
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (!$35fd956d2f1c2be7$export$47258840a7b8ac2c(table)) return;
        if (globalFilter) table.setSorting([]);
        else table.setSorting(()=>appliedSort.current || []);
    }, [
        globalFilter
    ]);
    //fix pinned row top style when density changes
    (0, $exYeM.useEffect)(()=>{
        if (enableRowPinning && getIsSomeRowsPinned()) setTimeout(()=>{
            rerender();
        }, 150);
    }, [
        density
    ]);
};
/**
 * The MRT hook that wraps the TanStack useReactTable hook and adds additional functionality
 * @param definedTableOptions - table options with proper defaults set
 * @returns the MRT table instance
 */ const $35fd956d2f1c2be7$export$f3abed63ab3c4547 = (definedTableOptions)=>{
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10;
    const lastSelectedRowId = (0, $exYeM.useRef)(null);
    const actionCellRef = (0, $exYeM.useRef)(null);
    const bottomToolbarRef = (0, $exYeM.useRef)(null);
    const editInputRefs = (0, $exYeM.useRef)({});
    const filterInputRefs = (0, $exYeM.useRef)({});
    const searchInputRef = (0, $exYeM.useRef)(null);
    const tableContainerRef = (0, $exYeM.useRef)(null);
    const tableHeadCellRefs = (0, $exYeM.useRef)({});
    const tablePaperRef = (0, $exYeM.useRef)(null);
    const topToolbarRef = (0, $exYeM.useRef)(null);
    const tableHeadRef = (0, $exYeM.useRef)(null);
    const tableFooterRef = (0, $exYeM.useRef)(null);
    //transform initial state with proper column order
    const initialState = (0, $exYeM.useMemo)(()=>{
        var _a, _b, _c;
        const initState = (_a = definedTableOptions.initialState) !== null && _a !== void 0 ? _a : {};
        initState.columnOrder = (_b = initState.columnOrder) !== null && _b !== void 0 ? _b : $35fd956d2f1c2be7$export$be53169041fbd6c5(Object.assign(Object.assign({}, definedTableOptions), {
            state: Object.assign(Object.assign({}, definedTableOptions.initialState), definedTableOptions.state)
        }));
        initState.globalFilterFn = (_c = definedTableOptions.globalFilterFn) !== null && _c !== void 0 ? _c : "fuzzy";
        return initState;
    }, []);
    definedTableOptions.initialState = initialState;
    const [actionCell, setActionCell] = (0, $exYeM.useState)((_a = initialState.actionCell) !== null && _a !== void 0 ? _a : null);
    const [creatingRow, _setCreatingRow] = (0, $exYeM.useState)((_b = initialState.creatingRow) !== null && _b !== void 0 ? _b : null);
    const [columnFilterFns, setColumnFilterFns] = (0, $exYeM.useState)(()=>Object.assign({}, ...$35fd956d2f1c2be7$export$851defe8865cb834(definedTableOptions.columns).map((col)=>{
            var _a, _b, _c, _d;
            return {
                [$35fd956d2f1c2be7$export$da3e7a4aacd802c(col)]: col.filterFn instanceof Function ? (_a = col.filterFn.name) !== null && _a !== void 0 ? _a : "custom" : (_d = (_b = col.filterFn) !== null && _b !== void 0 ? _b : (_c = initialState === null || initialState === void 0 ? void 0 : initialState.columnFilterFns) === null || _c === void 0 ? void 0 : _c[$35fd956d2f1c2be7$export$da3e7a4aacd802c(col)]) !== null && _d !== void 0 ? _d : $35fd956d2f1c2be7$export$411d52172b940fad(col)
            };
        })));
    const [columnOrder, onColumnOrderChange] = (0, $exYeM.useState)((_c = initialState.columnOrder) !== null && _c !== void 0 ? _c : []);
    const [columnSizingInfo, onColumnSizingInfoChange] = (0, $exYeM.useState)((_d = initialState.columnSizingInfo) !== null && _d !== void 0 ? _d : {});
    const [density, setDensity] = (0, $exYeM.useState)((_e = initialState === null || initialState === void 0 ? void 0 : initialState.density) !== null && _e !== void 0 ? _e : "comfortable");
    const [draggingColumn, setDraggingColumn] = (0, $exYeM.useState)((_f = initialState.draggingColumn) !== null && _f !== void 0 ? _f : null);
    const [draggingRow, setDraggingRow] = (0, $exYeM.useState)((_g = initialState.draggingRow) !== null && _g !== void 0 ? _g : null);
    const [editingCell, setEditingCell] = (0, $exYeM.useState)((_h = initialState.editingCell) !== null && _h !== void 0 ? _h : null);
    const [editingRow, setEditingRow] = (0, $exYeM.useState)((_j = initialState.editingRow) !== null && _j !== void 0 ? _j : null);
    const [globalFilterFn, setGlobalFilterFn] = (0, $exYeM.useState)((_k = initialState.globalFilterFn) !== null && _k !== void 0 ? _k : "fuzzy");
    const [grouping, onGroupingChange] = (0, $exYeM.useState)((_l = initialState.grouping) !== null && _l !== void 0 ? _l : []);
    const [hoveredColumn, setHoveredColumn] = (0, $exYeM.useState)((_m = initialState.hoveredColumn) !== null && _m !== void 0 ? _m : null);
    const [hoveredRow, setHoveredRow] = (0, $exYeM.useState)((_o = initialState.hoveredRow) !== null && _o !== void 0 ? _o : null);
    const [isFullScreen, setIsFullScreen] = (0, $exYeM.useState)((_p = initialState === null || initialState === void 0 ? void 0 : initialState.isFullScreen) !== null && _p !== void 0 ? _p : false);
    const [pagination, onPaginationChange] = (0, $exYeM.useState)((_q = initialState === null || initialState === void 0 ? void 0 : initialState.pagination) !== null && _q !== void 0 ? _q : {
        pageIndex: 0,
        pageSize: 10
    });
    const [showAlertBanner, setShowAlertBanner] = (0, $exYeM.useState)((_r = initialState === null || initialState === void 0 ? void 0 : initialState.showAlertBanner) !== null && _r !== void 0 ? _r : false);
    const [showColumnFilters, setShowColumnFilters] = (0, $exYeM.useState)((_s = initialState === null || initialState === void 0 ? void 0 : initialState.showColumnFilters) !== null && _s !== void 0 ? _s : false);
    const [showGlobalFilter, setShowGlobalFilter] = (0, $exYeM.useState)((_t = initialState === null || initialState === void 0 ? void 0 : initialState.showGlobalFilter) !== null && _t !== void 0 ? _t : false);
    const [showToolbarDropZone, setShowToolbarDropZone] = (0, $exYeM.useState)((_u = initialState === null || initialState === void 0 ? void 0 : initialState.showToolbarDropZone) !== null && _u !== void 0 ? _u : false);
    definedTableOptions.state = Object.assign({
        actionCell: actionCell,
        columnFilterFns: columnFilterFns,
        columnOrder: columnOrder,
        columnSizingInfo: columnSizingInfo,
        creatingRow: creatingRow,
        density: density,
        draggingColumn: draggingColumn,
        draggingRow: draggingRow,
        editingCell: editingCell,
        editingRow: editingRow,
        globalFilterFn: globalFilterFn,
        grouping: grouping,
        hoveredColumn: hoveredColumn,
        hoveredRow: hoveredRow,
        isFullScreen: isFullScreen,
        pagination: pagination,
        showAlertBanner: showAlertBanner,
        showColumnFilters: showColumnFilters,
        showGlobalFilter: showGlobalFilter,
        showToolbarDropZone: showToolbarDropZone
    }, definedTableOptions.state);
    //The table options now include all state needed to help determine column visibility and order logic
    const statefulTableOptions = definedTableOptions;
    //don't recompute columnDefs while resizing column or dragging column/row
    const columnDefsRef = (0, $exYeM.useRef)([]);
    statefulTableOptions.columns = statefulTableOptions.state.columnSizingInfo.isResizingColumn || statefulTableOptions.state.draggingColumn || statefulTableOptions.state.draggingRow ? columnDefsRef.current : $35fd956d2f1c2be7$export$1147582dfae658c6({
        columnDefs: [
            ...[
                $35fd956d2f1c2be7$export$1a520a1b96a270ad(statefulTableOptions) && $35fd956d2f1c2be7$var$getMRT_RowPinningColumnDef(statefulTableOptions),
                $35fd956d2f1c2be7$export$e3aff359325a595c(statefulTableOptions) && $35fd956d2f1c2be7$var$getMRT_RowDragColumnDef(statefulTableOptions),
                $35fd956d2f1c2be7$export$a2ed1098e0cc0675(statefulTableOptions) && $35fd956d2f1c2be7$var$getMRT_RowActionsColumnDef(statefulTableOptions),
                $35fd956d2f1c2be7$export$e60b8abd112d1687(statefulTableOptions) && $35fd956d2f1c2be7$var$getMRT_RowExpandColumnDef(statefulTableOptions),
                $35fd956d2f1c2be7$export$390e68ee95994286(statefulTableOptions) && $35fd956d2f1c2be7$var$getMRT_RowSelectColumnDef(statefulTableOptions),
                $35fd956d2f1c2be7$export$98baa70312ecf1b7(statefulTableOptions) && $35fd956d2f1c2be7$var$getMRT_RowNumbersColumnDef(statefulTableOptions)
            ].filter(Boolean),
            ...statefulTableOptions.columns,
            ...[
                $35fd956d2f1c2be7$export$702b9b60c63a9db8(statefulTableOptions) && $35fd956d2f1c2be7$var$getMRT_RowSpacerColumnDef(statefulTableOptions)
            ].filter(Boolean)
        ],
        tableOptions: statefulTableOptions
    });
    columnDefsRef.current = statefulTableOptions.columns;
    //if loading, generate blank rows to show skeleton loaders
    statefulTableOptions.data = (0, $exYeM.useMemo)(()=>(statefulTableOptions.state.isLoading || statefulTableOptions.state.showSkeletons) && !statefulTableOptions.data.length ? [
            ...Array(Math.min(statefulTableOptions.state.pagination.pageSize, 20)).fill(null)
        ].map(()=>Object.assign({}, ...$35fd956d2f1c2be7$export$851defe8865cb834(statefulTableOptions.columns).map((col)=>({
                    [$35fd956d2f1c2be7$export$da3e7a4aacd802c(col)]: null
                })))) : statefulTableOptions.data, [
        statefulTableOptions.data,
        statefulTableOptions.state.isLoading,
        statefulTableOptions.state.showSkeletons
    ]);
    //@ts-ignore
    const table = (0, $6f12815be8ba8421$export$25eaeb3743e6b31f)(Object.assign(Object.assign({
        onColumnOrderChange: onColumnOrderChange,
        onColumnSizingInfoChange: onColumnSizingInfoChange,
        onGroupingChange: onGroupingChange,
        onPaginationChange: onPaginationChange
    }, statefulTableOptions), {
        globalFilterFn: (_v = statefulTableOptions.filterFns) === null || _v === void 0 ? void 0 : _v[globalFilterFn !== null && globalFilterFn !== void 0 ? globalFilterFn : "fuzzy"]
    }));
    table.refs = {
        actionCellRef: actionCellRef,
        bottomToolbarRef: bottomToolbarRef,
        editInputRefs: editInputRefs,
        filterInputRefs: filterInputRefs,
        lastSelectedRowId: lastSelectedRowId,
        searchInputRef: searchInputRef,
        tableContainerRef: tableContainerRef,
        tableFooterRef: tableFooterRef,
        tableHeadCellRefs: tableHeadCellRefs,
        tableHeadRef: tableHeadRef,
        tablePaperRef: tablePaperRef,
        topToolbarRef: topToolbarRef
    };
    table.setActionCell = (_w = statefulTableOptions.onActionCellChange) !== null && _w !== void 0 ? _w : setActionCell;
    table.setCreatingRow = (row)=>{
        var _a, _b;
        let _row = row;
        if (row === true) _row = $35fd956d2f1c2be7$export$3442c5d213434705(table);
        (_b = (_a = statefulTableOptions === null || statefulTableOptions === void 0 ? void 0 : statefulTableOptions.onCreatingRowChange) === null || _a === void 0 ? void 0 : _a.call(statefulTableOptions, _row)) !== null && _b !== void 0 ? _b : _setCreatingRow(_row);
    };
    table.setColumnFilterFns = (_x = statefulTableOptions.onColumnFilterFnsChange) !== null && _x !== void 0 ? _x : setColumnFilterFns;
    table.setDensity = (_y = statefulTableOptions.onDensityChange) !== null && _y !== void 0 ? _y : setDensity;
    table.setDraggingColumn = (_z = statefulTableOptions.onDraggingColumnChange) !== null && _z !== void 0 ? _z : setDraggingColumn;
    table.setDraggingRow = (_0 = statefulTableOptions.onDraggingRowChange) !== null && _0 !== void 0 ? _0 : setDraggingRow;
    table.setEditingCell = (_1 = statefulTableOptions.onEditingCellChange) !== null && _1 !== void 0 ? _1 : setEditingCell;
    table.setEditingRow = (_2 = statefulTableOptions.onEditingRowChange) !== null && _2 !== void 0 ? _2 : setEditingRow;
    table.setGlobalFilterFn = (_3 = statefulTableOptions.onGlobalFilterFnChange) !== null && _3 !== void 0 ? _3 : setGlobalFilterFn;
    table.setHoveredColumn = (_4 = statefulTableOptions.onHoveredColumnChange) !== null && _4 !== void 0 ? _4 : setHoveredColumn;
    table.setHoveredRow = (_5 = statefulTableOptions.onHoveredRowChange) !== null && _5 !== void 0 ? _5 : setHoveredRow;
    table.setIsFullScreen = (_6 = statefulTableOptions.onIsFullScreenChange) !== null && _6 !== void 0 ? _6 : setIsFullScreen;
    table.setShowAlertBanner = (_7 = statefulTableOptions.onShowAlertBannerChange) !== null && _7 !== void 0 ? _7 : setShowAlertBanner;
    table.setShowColumnFilters = (_8 = statefulTableOptions.onShowColumnFiltersChange) !== null && _8 !== void 0 ? _8 : setShowColumnFilters;
    table.setShowGlobalFilter = (_9 = statefulTableOptions.onShowGlobalFilterChange) !== null && _9 !== void 0 ? _9 : setShowGlobalFilter;
    table.setShowToolbarDropZone = (_10 = statefulTableOptions.onShowToolbarDropZoneChange) !== null && _10 !== void 0 ? _10 : setShowToolbarDropZone;
    $35fd956d2f1c2be7$export$5c933a64445776e4(table);
    return table;
};
const $35fd956d2f1c2be7$export$f43e1b352a4cbffc = (tableOptions)=>$35fd956d2f1c2be7$export$f3abed63ab3c4547($35fd956d2f1c2be7$export$d132b01ac0b4e971(tableOptions));
const $35fd956d2f1c2be7$var$extraIndexRangeExtractor = (range, draggingIndex)=>{
    const newIndexes = (0, $fc28b436a2e934e3$export$7eb7cb13fd21e5e1)(range);
    if (draggingIndex === undefined) return newIndexes;
    if (draggingIndex >= 0 && draggingIndex < Math.max(range.startIndex - range.overscan, 0)) newIndexes.unshift(draggingIndex);
    if (draggingIndex >= 0 && draggingIndex > range.endIndex + range.overscan) newIndexes.push(draggingIndex);
    return newIndexes;
};
const $35fd956d2f1c2be7$export$98280022443b09bb = (table)=>{
    var _a, _b, _c, _d;
    const { getState: getState, options: { columnVirtualizerInstanceRef: columnVirtualizerInstanceRef, columnVirtualizerOptions: columnVirtualizerOptions, enableColumnPinning: enableColumnPinning, enableColumnVirtualization: enableColumnVirtualization }, refs: { tableContainerRef: tableContainerRef } } = table;
    const { columnPinning: columnPinning, columnVisibility: columnVisibility, draggingColumn: draggingColumn } = getState();
    if (!enableColumnVirtualization) return undefined;
    const columnVirtualizerProps = $35fd956d2f1c2be7$var$parseFromValuesOrFunc(columnVirtualizerOptions, {
        table: table
    });
    const visibleColumns = table.getVisibleLeafColumns();
    const [leftPinnedIndexes, rightPinnedIndexes] = (0, $exYeM.useMemo)(()=>enableColumnPinning ? [
            table.getLeftVisibleLeafColumns().map((c)=>c.getPinnedIndex()),
            table.getRightVisibleLeafColumns().map((column)=>visibleColumns.length - column.getPinnedIndex() - 1).sort((a, b)=>a - b)
        ] : [
            [],
            []
        ], [
        columnPinning,
        columnVisibility,
        enableColumnPinning
    ]);
    const numPinnedLeft = leftPinnedIndexes.length;
    const numPinnedRight = rightPinnedIndexes.length;
    const draggingColumnIndex = (0, $exYeM.useMemo)(()=>(draggingColumn === null || draggingColumn === void 0 ? void 0 : draggingColumn.id) ? visibleColumns.findIndex((c)=>c.id === (draggingColumn === null || draggingColumn === void 0 ? void 0 : draggingColumn.id)) : undefined, [
        draggingColumn === null || draggingColumn === void 0 ? void 0 : draggingColumn.id
    ]);
    const columnVirtualizer = (0, $baed1bf71a18e800$export$dd6d526d88b5a137)(Object.assign({
        count: visibleColumns.length,
        estimateSize: (index)=>visibleColumns[index].getSize(),
        getScrollElement: ()=>tableContainerRef.current,
        horizontal: true,
        overscan: 3,
        rangeExtractor: (0, $exYeM.useCallback)((range)=>{
            const newIndexes = $35fd956d2f1c2be7$var$extraIndexRangeExtractor(range, draggingColumnIndex);
            if (!numPinnedLeft && !numPinnedRight) return newIndexes;
            return [
                ...new Set([
                    ...leftPinnedIndexes,
                    ...newIndexes,
                    ...rightPinnedIndexes
                ])
            ];
        }, [
            leftPinnedIndexes,
            rightPinnedIndexes,
            draggingColumnIndex
        ])
    }, columnVirtualizerProps));
    const virtualColumns = columnVirtualizer.getVirtualItems();
    columnVirtualizer.virtualColumns = virtualColumns;
    const numColumns = virtualColumns.length;
    if (numColumns) {
        const totalSize = columnVirtualizer.getTotalSize();
        const leftNonPinnedStart = ((_a = virtualColumns[numPinnedLeft]) === null || _a === void 0 ? void 0 : _a.start) || 0;
        const leftNonPinnedEnd = ((_b = virtualColumns[leftPinnedIndexes.length - 1]) === null || _b === void 0 ? void 0 : _b.end) || 0;
        const rightNonPinnedStart = ((_c = virtualColumns[numColumns - numPinnedRight]) === null || _c === void 0 ? void 0 : _c.start) || 0;
        const rightNonPinnedEnd = ((_d = virtualColumns[numColumns - numPinnedRight - 1]) === null || _d === void 0 ? void 0 : _d.end) || 0;
        columnVirtualizer.virtualPaddingLeft = leftNonPinnedStart - leftNonPinnedEnd;
        columnVirtualizer.virtualPaddingRight = totalSize - rightNonPinnedEnd - (numPinnedRight ? totalSize - rightNonPinnedStart : 0);
    }
    if (columnVirtualizerInstanceRef) //@ts-ignore
    columnVirtualizerInstanceRef.current = columnVirtualizer;
    return columnVirtualizer;
};
const $35fd956d2f1c2be7$export$1054ce63e1c67929 = (table, rows)=>{
    var _a;
    const { getRowModel: getRowModel, getState: getState, options: { enableRowVirtualization: enableRowVirtualization, renderDetailPanel: renderDetailPanel, rowVirtualizerInstanceRef: rowVirtualizerInstanceRef, rowVirtualizerOptions: rowVirtualizerOptions }, refs: { tableContainerRef: tableContainerRef } } = table;
    const { density: density, draggingRow: draggingRow, expanded: expanded } = getState();
    if (!enableRowVirtualization) return undefined;
    const rowVirtualizerProps = $35fd956d2f1c2be7$var$parseFromValuesOrFunc(rowVirtualizerOptions, {
        table: table
    });
    const rowCount = (_a = rows === null || rows === void 0 ? void 0 : rows.length) !== null && _a !== void 0 ? _a : getRowModel().rows.length;
    const normalRowHeight = density === "compact" ? 37 : density === "comfortable" ? 58 : 73;
    const rowVirtualizer = (0, $baed1bf71a18e800$export$dd6d526d88b5a137)(Object.assign({
        count: renderDetailPanel ? rowCount * 2 : rowCount,
        estimateSize: (index)=>renderDetailPanel && index % 2 === 1 ? expanded === true ? 100 : 0 : normalRowHeight,
        getScrollElement: ()=>tableContainerRef.current,
        measureElement: typeof window !== "undefined" && navigator.userAgent.indexOf("Firefox") === -1 ? (element)=>element === null || element === void 0 ? void 0 : element.getBoundingClientRect().height : undefined,
        overscan: 4,
        rangeExtractor: (0, $exYeM.useCallback)((range)=>{
            var _a;
            return $35fd956d2f1c2be7$var$extraIndexRangeExtractor(range, (_a = draggingRow === null || draggingRow === void 0 ? void 0 : draggingRow.index) !== null && _a !== void 0 ? _a : 0);
        }, [
            draggingRow
        ])
    }, rowVirtualizerProps));
    rowVirtualizer.virtualRows = rowVirtualizer.getVirtualItems();
    if (rowVirtualizerInstanceRef) //@ts-ignore
    rowVirtualizerInstanceRef.current = rowVirtualizer;
    return rowVirtualizer;
};
const $35fd956d2f1c2be7$export$a4ae485138dfddf0 = (table)=>{
    const { getRowModel: getRowModel, getState: getState, options: { data: data, enableGlobalFilterRankedResults: enableGlobalFilterRankedResults, positionCreatingRow: positionCreatingRow } } = table;
    const { creatingRow: creatingRow, expanded: expanded, globalFilter: globalFilter, pagination: pagination, rowPinning: rowPinning, sorting: sorting } = getState();
    const rows = (0, $exYeM.useMemo)(()=>$35fd956d2f1c2be7$export$10f6207b5d9c35e5(table), [
        creatingRow,
        data,
        enableGlobalFilterRankedResults,
        expanded,
        getRowModel().rows,
        globalFilter,
        pagination.pageIndex,
        pagination.pageSize,
        positionCreatingRow,
        rowPinning,
        sorting
    ]);
    return rows;
};
const $35fd956d2f1c2be7$var$allowedTypes = [
    "string",
    "number"
];
const $35fd956d2f1c2be7$export$c557842a8e9971d3 = ({ cell: cell, rowRef: rowRef, staticColumnIndex: staticColumnIndex, staticRowIndex: staticRowIndex, table: table })=>{
    var _a, _b, _c;
    const { getState: getState, options: { enableFilterMatchHighlighting: enableFilterMatchHighlighting, mrtTheme: { matchHighlightColor: matchHighlightColor } } } = table;
    const { column: column, row: row } = cell;
    const { columnDef: columnDef } = column;
    const { globalFilter: globalFilter, globalFilterFn: globalFilterFn } = getState();
    const filterValue = column.getFilterValue();
    let renderedCellValue = cell.getIsAggregated() && columnDef.AggregatedCell ? columnDef.AggregatedCell({
        cell: cell,
        column: column,
        row: row,
        table: table
    }) : row.getIsGrouped() && !cell.getIsGrouped() ? null : cell.getIsGrouped() && columnDef.GroupedCell ? columnDef.GroupedCell({
        cell: cell,
        column: column,
        row: row,
        table: table
    }) : undefined;
    const isGroupedValue = renderedCellValue !== undefined;
    if (!isGroupedValue) renderedCellValue = cell.renderValue();
    if (enableFilterMatchHighlighting && columnDef.enableFilterMatchHighlighting !== false && String(renderedCellValue) && $35fd956d2f1c2be7$var$allowedTypes.includes(typeof renderedCellValue) && (filterValue && $35fd956d2f1c2be7$var$allowedTypes.includes(typeof filterValue) && [
        "autocomplete",
        "text"
    ].includes(columnDef.filterVariant) || globalFilter && $35fd956d2f1c2be7$var$allowedTypes.includes(typeof globalFilter) && column.getCanGlobalFilter())) {
        const chunks = (0, $1320fb82b5482877$export$2e2bcd8739ae039) === null || (0, $1320fb82b5482877$export$2e2bcd8739ae039) === void 0 ? void 0 : (0, $1320fb82b5482877$export$2e2bcd8739ae039)({
            matchExactly: (filterValue ? columnDef._filterFn : globalFilterFn) !== "fuzzy",
            query: ((_a = filterValue !== null && filterValue !== void 0 ? filterValue : globalFilter) !== null && _a !== void 0 ? _a : "").toString(),
            text: renderedCellValue === null || renderedCellValue === void 0 ? void 0 : renderedCellValue.toString()
        });
        if ((chunks === null || chunks === void 0 ? void 0 : chunks.length) > 1 || ((_b = chunks === null || chunks === void 0 ? void 0 : chunks[0]) === null || _b === void 0 ? void 0 : _b.match)) renderedCellValue = (0, $aSiaI.jsx)("span", {
            "aria-label": renderedCellValue,
            role: "note",
            children: (_c = chunks === null || chunks === void 0 ? void 0 : chunks.map(({ key: key, match: match, text: text })=>(0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                    "aria-hidden": "true",
                    component: "span",
                    sx: match ? {
                        backgroundColor: matchHighlightColor,
                        borderRadius: "2px",
                        color: (theme)=>theme.palette.mode === "dark" ? theme.palette.common.white : theme.palette.common.black,
                        padding: "2px 1px"
                    } : undefined,
                    children: text
                }, key))) !== null && _c !== void 0 ? _c : renderedCellValue
        });
    }
    if (columnDef.Cell && !isGroupedValue) renderedCellValue = columnDef.Cell({
        cell: cell,
        column: column,
        renderedCellValue: renderedCellValue,
        row: row,
        rowRef: rowRef,
        staticColumnIndex: staticColumnIndex,
        staticRowIndex: staticRowIndex,
        table: table
    });
    return renderedCellValue;
};
const $35fd956d2f1c2be7$export$28f116906b3d657e = (_a)=>{
    var _b;
    var { cell: cell, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "cell",
        "table"
    ]);
    const { options: { localization: localization, muiCopyButtonProps: muiCopyButtonProps } } = table;
    const { column: column, row: row } = cell;
    const { columnDef: columnDef } = column;
    const [copied, setCopied] = (0, $exYeM.useState)(false);
    const handleCopy = (event, text)=>{
        event.stopPropagation();
        navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(()=>setCopied(false), 4000);
    };
    const buttonProps = Object.assign(Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiCopyButtonProps, {
        cell: cell,
        column: column,
        row: row,
        table: table
    })), $35fd956d2f1c2be7$var$parseFromValuesOrFunc(columnDef.muiCopyButtonProps, {
        cell: cell,
        column: column,
        row: row,
        table: table
    })), rest);
    return (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), Object.assign({}, $35fd956d2f1c2be7$var$getCommonTooltipProps("top"), {
        title: (_b = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.title) !== null && _b !== void 0 ? _b : copied ? localization.copiedToClipboard : localization.clickToCopy,
        children: (0, $aSiaI.jsx)((0, $980dfff3cab72cf4$export$2e2bcd8739ae039), Object.assign({
            onClick: (e)=>handleCopy(e, cell.getValue()),
            size: "small",
            type: "button",
            variant: "text"
        }, buttonProps, {
            sx: (theme)=>Object.assign({
                    backgroundColor: "transparent",
                    border: "none",
                    color: "inherit",
                    cursor: "copy",
                    fontFamily: "inherit",
                    fontSize: "inherit",
                    letterSpacing: "inherit",
                    m: "-0.25rem",
                    minWidth: "unset",
                    py: 0,
                    textAlign: "inherit",
                    textTransform: "inherit"
                }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.sx, theme)),
            title: undefined
        }))
    }));
};
const $35fd956d2f1c2be7$export$bac02719eed5c352 = (_a)=>{
    var _b, _c;
    var { cell: cell, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "cell",
        "table"
    ]);
    const { getState: getState, options: { createDisplayMode: createDisplayMode, editDisplayMode: editDisplayMode, muiEditTextFieldProps: muiEditTextFieldProps }, refs: { editInputRefs: editInputRefs }, setCreatingRow: setCreatingRow, setEditingCell: setEditingCell, setEditingRow: setEditingRow } = table;
    const { column: column, row: row } = cell;
    const { columnDef: columnDef } = column;
    const { creatingRow: creatingRow, editingRow: editingRow } = getState();
    const { editSelectOptions: editSelectOptions, editVariant: editVariant } = columnDef;
    const isCreating = (creatingRow === null || creatingRow === void 0 ? void 0 : creatingRow.id) === row.id;
    const isEditing = (editingRow === null || editingRow === void 0 ? void 0 : editingRow.id) === row.id;
    const [value, setValue] = (0, $exYeM.useState)(()=>cell.getValue());
    const textFieldProps = Object.assign(Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiEditTextFieldProps, {
        cell: cell,
        column: column,
        row: row,
        table: table
    })), $35fd956d2f1c2be7$var$parseFromValuesOrFunc(columnDef.muiEditTextFieldProps, {
        cell: cell,
        column: column,
        row: row,
        table: table
    })), rest);
    const selectOptions = $35fd956d2f1c2be7$var$parseFromValuesOrFunc(editSelectOptions, {
        cell: cell,
        column: column,
        row: row,
        table: table
    });
    const isSelectEdit = editVariant === "select" || (textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.select);
    const saveInputValueToRowCache = (newValue)=>{
        //@ts-ignore
        row._valuesCache[column.id] = newValue;
        if (isCreating) setCreatingRow(row);
        else if (isEditing) setEditingRow(row);
    };
    const handleChange = (event)=>{
        var _a;
        (_a = textFieldProps.onChange) === null || _a === void 0 || _a.call(textFieldProps, event);
        setValue(event.target.value);
        if (isSelectEdit) saveInputValueToRowCache(event.target.value);
    };
    const handleBlur = (event)=>{
        var _a;
        (_a = textFieldProps.onBlur) === null || _a === void 0 || _a.call(textFieldProps, event);
        saveInputValueToRowCache(value);
        setEditingCell(null);
    };
    const handleEnterKeyDown = (event)=>{
        var _a, _b;
        (_a = textFieldProps.onKeyDown) === null || _a === void 0 || _a.call(textFieldProps, event);
        if (event.key === "Enter" && !event.shiftKey) (_b = editInputRefs.current[column.id]) === null || _b === void 0 || _b.blur();
    };
    if (columnDef.Edit) return (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: (_b = columnDef.Edit) === null || _b === void 0 ? void 0 : _b.call(columnDef, {
            cell: cell,
            column: column,
            row: row,
            table: table
        })
    });
    return (0, $aSiaI.jsx)((0, $18a733eef46a7fb6$export$2e2bcd8739ae039), Object.assign({
        disabled: $35fd956d2f1c2be7$var$parseFromValuesOrFunc(columnDef.enableEditing, row) === false,
        fullWidth: true,
        inputRef: (inputRef)=>{
            if (inputRef) {
                editInputRefs.current[column.id] = inputRef;
                if (textFieldProps.inputRef) textFieldProps.inputRef = inputRef;
            }
        },
        label: [
            "custom",
            "modal"
        ].includes(isCreating ? createDisplayMode : editDisplayMode) ? columnDef.header : undefined,
        margin: "none",
        name: column.id,
        placeholder: ![
            "custom",
            "modal"
        ].includes(isCreating ? createDisplayMode : editDisplayMode) ? columnDef.header : undefined,
        select: isSelectEdit,
        size: "small",
        value: value !== null && value !== void 0 ? value : "",
        variant: "standard"
    }, textFieldProps, {
        InputProps: Object.assign(Object.assign(Object.assign({}, textFieldProps.variant !== "outlined" ? {
            disableUnderline: editDisplayMode === "table"
        } : {}), textFieldProps.InputProps), {
            sx: (theme)=>{
                var _a;
                return Object.assign({
                    mb: 0
                }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc((_a = textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.InputProps) === null || _a === void 0 ? void 0 : _a.sx, theme));
            }
        }),
        SelectProps: {
            MenuProps: {
                disableScrollLock: true
            }
        },
        inputProps: Object.assign({
            autoComplete: "new-password"
        }, textFieldProps.inputProps),
        onBlur: handleBlur,
        onChange: handleChange,
        onClick: (e)=>{
            var _a;
            e.stopPropagation();
            (_a = textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.onClick) === null || _a === void 0 || _a.call(textFieldProps, e);
        },
        onKeyDown: handleEnterKeyDown,
        children: (_c = textFieldProps.children) !== null && _c !== void 0 ? _c : selectOptions === null || selectOptions === void 0 ? void 0 : selectOptions.map((option)=>{
            const { label: label, value: value } = $35fd956d2f1c2be7$var$getValueAndLabel(option);
            return (0, $aSiaI.jsx)((0, $32731aa3cf1ce086$export$2e2bcd8739ae039), {
                sx: {
                    alignItems: "center",
                    display: "flex",
                    gap: "0.5rem",
                    m: 0
                },
                value: value,
                children: label
            }, value);
        })
    }));
};
const $35fd956d2f1c2be7$export$563b27a93712d4f0 = (_a)=>{
    var _b, _c, _d, _e, _f;
    var { cell: cell, numRows: numRows, rowRef: rowRef, staticColumnIndex: staticColumnIndex, staticRowIndex: staticRowIndex, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "cell",
        "numRows",
        "rowRef",
        "staticColumnIndex",
        "staticRowIndex",
        "table"
    ]);
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const { getState: getState, options: { columnResizeDirection: columnResizeDirection, columnResizeMode: columnResizeMode, createDisplayMode: createDisplayMode, editDisplayMode: editDisplayMode, enableCellActions: enableCellActions, enableClickToCopy: enableClickToCopy, enableColumnOrdering: enableColumnOrdering, enableColumnPinning: enableColumnPinning, enableGrouping: enableGrouping, layoutMode: layoutMode, mrtTheme: { draggingBorderColor: draggingBorderColor }, muiSkeletonProps: muiSkeletonProps, muiTableBodyCellProps: muiTableBodyCellProps }, setHoveredColumn: setHoveredColumn } = table;
    const { actionCell: actionCell, columnSizingInfo: columnSizingInfo, creatingRow: creatingRow, density: density, draggingColumn: draggingColumn, draggingRow: draggingRow, editingCell: editingCell, editingRow: editingRow, hoveredColumn: hoveredColumn, hoveredRow: hoveredRow, isLoading: isLoading, showSkeletons: showSkeletons } = getState();
    const { column: column, row: row } = cell;
    const { columnDef: columnDef } = column;
    const { columnDefType: columnDefType } = columnDef;
    const args = {
        cell: cell,
        column: column,
        row: row,
        table: table
    };
    const tableCellProps = Object.assign(Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiTableBodyCellProps, args)), $35fd956d2f1c2be7$var$parseFromValuesOrFunc(columnDef.muiTableBodyCellProps, args)), rest);
    const skeletonProps = $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiSkeletonProps, {
        cell: cell,
        column: column,
        row: row,
        table: table
    });
    const [skeletonWidth, setSkeletonWidth] = (0, $exYeM.useState)(100);
    (0, $exYeM.useEffect)(()=>{
        if (!isLoading && !showSkeletons || skeletonWidth !== 100) return;
        const size = column.getSize();
        setSkeletonWidth(columnDefType === "display" ? size / 2 : Math.round(Math.random() * (size - size / 3) + size / 3));
    }, [
        isLoading,
        showSkeletons
    ]);
    const draggingBorders = (0, $exYeM.useMemo)(()=>{
        const isDraggingColumn = (draggingColumn === null || draggingColumn === void 0 ? void 0 : draggingColumn.id) === column.id;
        const isHoveredColumn = (hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) === column.id;
        const isDraggingRow = (draggingRow === null || draggingRow === void 0 ? void 0 : draggingRow.id) === row.id;
        const isHoveredRow = (hoveredRow === null || hoveredRow === void 0 ? void 0 : hoveredRow.id) === row.id;
        const isFirstColumn = column.getIsFirstColumn();
        const isLastColumn = column.getIsLastColumn();
        const isLastRow = numRows && staticRowIndex === numRows - 1;
        const isResizingColumn = columnSizingInfo.isResizingColumn === column.id;
        const showResizeBorder = isResizingColumn && columnResizeMode === "onChange";
        const borderStyle = showResizeBorder ? `2px solid ${draggingBorderColor} !important` : isDraggingColumn || isDraggingRow ? `1px dashed ${theme.palette.grey[500]} !important` : isHoveredColumn || isHoveredRow || isResizingColumn ? `2px dashed ${draggingBorderColor} !important` : undefined;
        if (showResizeBorder) return columnResizeDirection === "ltr" ? {
            borderRight: borderStyle
        } : {
            borderLeft: borderStyle
        };
        return borderStyle ? {
            borderBottom: isDraggingRow || isHoveredRow || isLastRow && !isResizingColumn ? borderStyle : undefined,
            borderLeft: isDraggingColumn || isHoveredColumn || (isDraggingRow || isHoveredRow) && isFirstColumn ? borderStyle : undefined,
            borderRight: isDraggingColumn || isHoveredColumn || (isDraggingRow || isHoveredRow) && isLastColumn ? borderStyle : undefined,
            borderTop: isDraggingRow || isHoveredRow ? borderStyle : undefined
        } : undefined;
    }, [
        columnSizingInfo.isResizingColumn,
        draggingColumn,
        draggingRow,
        hoveredColumn,
        hoveredRow,
        staticRowIndex
    ]);
    const isColumnPinned = enableColumnPinning && columnDef.columnDefType !== "group" && column.getIsPinned();
    const isEditable = $35fd956d2f1c2be7$export$ac9f81ed8d41453f({
        cell: cell,
        table: table
    });
    const isEditing = isEditable && ![
        "custom",
        "modal"
    ].includes(editDisplayMode) && (editDisplayMode === "table" || (editingRow === null || editingRow === void 0 ? void 0 : editingRow.id) === row.id || (editingCell === null || editingCell === void 0 ? void 0 : editingCell.id) === cell.id) && !row.getIsGrouped();
    const isCreating = isEditable && createDisplayMode === "row" && (creatingRow === null || creatingRow === void 0 ? void 0 : creatingRow.id) === row.id;
    const showClickToCopyButton = ($35fd956d2f1c2be7$var$parseFromValuesOrFunc(enableClickToCopy, cell) === true || $35fd956d2f1c2be7$var$parseFromValuesOrFunc(columnDef.enableClickToCopy, cell) === true) && ![
        "context-menu",
        false
    ].includes(// @ts-ignore
    $35fd956d2f1c2be7$var$parseFromValuesOrFunc(columnDef.enableClickToCopy, cell));
    const isRightClickable = $35fd956d2f1c2be7$var$parseFromValuesOrFunc(enableCellActions, cell);
    const cellValueProps = {
        cell: cell,
        table: table
    };
    const handleDoubleClick = (event)=>{
        var _a;
        (_a = tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.onDoubleClick) === null || _a === void 0 || _a.call(tableCellProps, event);
        $35fd956d2f1c2be7$export$250fde3c71e02f70({
            cell: cell,
            table: table
        });
    };
    const handleDragEnter = (e)=>{
        var _a;
        (_a = tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.onDragEnter) === null || _a === void 0 || _a.call(tableCellProps, e);
        if (enableGrouping && (hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) === "drop-zone") setHoveredColumn(null);
        if (enableColumnOrdering && draggingColumn) setHoveredColumn(columnDef.enableColumnOrdering !== false ? column : null);
    };
    const handleDragOver = (e)=>{
        if (columnDef.enableColumnOrdering !== false) e.preventDefault();
    };
    const handleContextMenu = (e)=>{
        var _a;
        (_a = tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.onContextMenu) === null || _a === void 0 || _a.call(tableCellProps, e);
        if (isRightClickable) {
            e.preventDefault();
            table.setActionCell(cell);
            table.refs.actionCellRef.current = e.currentTarget;
        }
    };
    return (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), Object.assign({
        align: theme.direction === "rtl" ? "right" : "left",
        "data-index": staticColumnIndex,
        "data-pinned": !!isColumnPinned || undefined
    }, tableCellProps, {
        onContextMenu: handleContextMenu,
        onDoubleClick: handleDoubleClick,
        onDragEnter: handleDragEnter,
        onDragOver: handleDragOver,
        sx: (theme)=>Object.assign(Object.assign({
                "&:hover": {
                    outline: (actionCell === null || actionCell === void 0 ? void 0 : actionCell.id) === cell.id || editDisplayMode === "cell" && isEditable || editDisplayMode === "table" && (isCreating || isEditing) ? `1px solid ${theme.palette.grey[500]}` : undefined,
                    textOverflow: "clip"
                },
                alignItems: (layoutMode === null || layoutMode === void 0 ? void 0 : layoutMode.startsWith("grid")) ? "center" : undefined,
                cursor: isRightClickable ? "context-menu" : isEditable && editDisplayMode === "cell" ? "pointer" : "inherit",
                outline: (actionCell === null || actionCell === void 0 ? void 0 : actionCell.id) === cell.id ? `1px solid ${theme.palette.grey[500]}` : undefined,
                outlineOffset: "-1px",
                overflow: "hidden",
                p: density === "compact" ? columnDefType === "display" ? "0 0.5rem" : "0.5rem" : density === "comfortable" ? columnDefType === "display" ? "0.5rem 0.75rem" : "1rem" : columnDefType === "display" ? "1rem 1.25rem" : "1.5rem",
                textOverflow: columnDefType !== "display" ? "ellipsis" : undefined,
                whiteSpace: row.getIsPinned() || density === "compact" ? "nowrap" : "normal"
            }, $35fd956d2f1c2be7$var$getCommonMRTCellStyles({
                column: column,
                table: table,
                tableCellProps: tableCellProps,
                theme: theme
            })), draggingBorders),
        children: (_b = tableCellProps.children) !== null && _b !== void 0 ? _b : (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
            children: [
                cell.getIsPlaceholder() ? (_d = (_c = columnDef.PlaceholderCell) === null || _c === void 0 ? void 0 : _c.call(columnDef, {
                    cell: cell,
                    column: column,
                    row: row,
                    table: table
                })) !== null && _d !== void 0 ? _d : null : showSkeletons !== false && (isLoading || showSkeletons) ? (0, $aSiaI.jsx)((0, $107e9a83a039e2a0$export$2e2bcd8739ae039), Object.assign({
                    animation: "wave",
                    height: 20,
                    width: skeletonWidth
                }, skeletonProps)) : columnDefType === "display" && ([
                    "mrt-row-expand",
                    "mrt-row-numbers",
                    "mrt-row-select"
                ].includes(column.id) || !row.getIsGrouped()) ? (_e = columnDef.Cell) === null || _e === void 0 ? void 0 : _e.call(columnDef, {
                    cell: cell,
                    column: column,
                    renderedCellValue: cell.renderValue(),
                    row: row,
                    rowRef: rowRef,
                    staticColumnIndex: staticColumnIndex,
                    staticRowIndex: staticRowIndex,
                    table: table
                }) : isCreating || isEditing ? (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$bac02719eed5c352, {
                    cell: cell,
                    table: table
                }) : showClickToCopyButton && columnDef.enableClickToCopy !== false ? (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$28f116906b3d657e, {
                    cell: cell,
                    table: table,
                    children: (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$c557842a8e9971d3, Object.assign({}, cellValueProps))
                }) : (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$c557842a8e9971d3, Object.assign({}, cellValueProps)),
                cell.getIsGrouped() && !columnDef.GroupedCell && (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                    children: [
                        " (",
                        (_f = row.subRows) === null || _f === void 0 ? void 0 : _f.length,
                        ")"
                    ]
                })
            ]
        })
    }));
};
const $35fd956d2f1c2be7$export$1c0dd4187ccf886 = (0, $exYeM.memo)($35fd956d2f1c2be7$export$563b27a93712d4f0, (prev, next)=>next.cell === prev.cell);
const $35fd956d2f1c2be7$export$97cb1fdb5b81c5aa = (_a)=>{
    var { parentRowRef: parentRowRef, row: row, rowVirtualizer: rowVirtualizer, staticRowIndex: staticRowIndex, table: table, virtualRow: virtualRow } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "parentRowRef",
        "row",
        "rowVirtualizer",
        "staticRowIndex",
        "table",
        "virtualRow"
    ]);
    const { getState: getState, getVisibleLeafColumns: getVisibleLeafColumns, options: { layoutMode: layoutMode, mrtTheme: { baseBackgroundColor: baseBackgroundColor }, muiDetailPanelProps: muiDetailPanelProps, muiTableBodyRowProps: muiTableBodyRowProps, renderDetailPanel: renderDetailPanel } } = table;
    const { isLoading: isLoading } = getState();
    const tableRowProps = $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiTableBodyRowProps, {
        isDetailPanel: true,
        row: row,
        staticRowIndex: staticRowIndex,
        table: table
    });
    const tableCellProps = Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiDetailPanelProps, {
        row: row,
        table: table
    })), rest);
    const DetailPanel = !isLoading && (renderDetailPanel === null || renderDetailPanel === void 0 ? void 0 : renderDetailPanel({
        row: row,
        table: table
    }));
    return (0, $aSiaI.jsx)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), Object.assign({
        className: "Mui-TableBodyCell-DetailPanel",
        "data-index": renderDetailPanel ? staticRowIndex * 2 + 1 : staticRowIndex,
        ref: (node)=>{
            var _a;
            if (node) (_a = rowVirtualizer === null || rowVirtualizer === void 0 ? void 0 : rowVirtualizer.measureElement) === null || _a === void 0 || _a.call(rowVirtualizer, node);
        }
    }, tableRowProps, {
        sx: (theme)=>{
            var _a, _b;
            return Object.assign({
                display: (layoutMode === null || layoutMode === void 0 ? void 0 : layoutMode.startsWith("grid")) ? "flex" : undefined,
                position: virtualRow ? "absolute" : undefined,
                top: virtualRow ? `${(_b = (_a = parentRowRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.height}px` : undefined,
                transform: virtualRow ? `translateY(${virtualRow === null || virtualRow === void 0 ? void 0 : virtualRow.start}px)` : undefined,
                width: "100%"
            }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx, theme));
        },
        children: (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), Object.assign({
            className: "Mui-TableBodyCell-DetailPanel",
            colSpan: getVisibleLeafColumns().length
        }, tableCellProps, {
            sx: (theme)=>Object.assign({
                    backgroundColor: virtualRow ? baseBackgroundColor : undefined,
                    borderBottom: !row.getIsExpanded() ? "none" : undefined,
                    display: (layoutMode === null || layoutMode === void 0 ? void 0 : layoutMode.startsWith("grid")) ? "flex" : undefined,
                    py: !!DetailPanel && row.getIsExpanded() ? "1rem" : 0,
                    transition: !virtualRow ? "all 150ms ease-in-out" : undefined,
                    width: `100%`
                }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.sx, theme)),
            children: virtualRow ? row.getIsExpanded() && DetailPanel : (0, $aSiaI.jsx)((0, $8c4543c1f79a917c$export$2e2bcd8739ae039), {
                in: row.getIsExpanded(),
                mountOnEnter: true,
                unmountOnExit: true,
                children: DetailPanel
            })
        }))
    }));
};
const $35fd956d2f1c2be7$export$c4e9a85606601fb5 = (_a)=>{
    var _b, _c, _d, _f;
    var { columnVirtualizer: columnVirtualizer, numRows: numRows, pinnedRowIds: pinnedRowIds, row: row, rowVirtualizer: rowVirtualizer, staticRowIndex: staticRowIndex, table: table, virtualRow: virtualRow } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "columnVirtualizer",
        "numRows",
        "pinnedRowIds",
        "row",
        "rowVirtualizer",
        "staticRowIndex",
        "table",
        "virtualRow"
    ]);
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const { getState: getState, options: { enableRowOrdering: enableRowOrdering, enableRowPinning: enableRowPinning, enableStickyFooter: enableStickyFooter, enableStickyHeader: enableStickyHeader, layoutMode: layoutMode, memoMode: memoMode, mrtTheme: { baseBackgroundColor: baseBackgroundColor, pinnedRowBackgroundColor: pinnedRowBackgroundColor, selectedRowBackgroundColor: selectedRowBackgroundColor }, muiTableBodyRowProps: muiTableBodyRowProps, renderDetailPanel: renderDetailPanel, rowPinningDisplayMode: rowPinningDisplayMode }, refs: { tableFooterRef: tableFooterRef, tableHeadRef: tableHeadRef }, setHoveredRow: setHoveredRow } = table;
    const { density: density, draggingColumn: draggingColumn, draggingRow: draggingRow, editingCell: editingCell, editingRow: editingRow, hoveredRow: hoveredRow, isFullScreen: isFullScreen, rowPinning: rowPinning } = getState();
    const visibleCells = row.getVisibleCells();
    const { virtualColumns: virtualColumns, virtualPaddingLeft: virtualPaddingLeft, virtualPaddingRight: virtualPaddingRight } = columnVirtualizer !== null && columnVirtualizer !== void 0 ? columnVirtualizer : {};
    const isRowSelected = $35fd956d2f1c2be7$export$95688405cf6a5004({
        row: row,
        table: table
    });
    const isRowPinned = enableRowPinning && row.getIsPinned();
    const isDraggingRow = (draggingRow === null || draggingRow === void 0 ? void 0 : draggingRow.id) === row.id;
    const isHoveredRow = (hoveredRow === null || hoveredRow === void 0 ? void 0 : hoveredRow.id) === row.id;
    const tableRowProps = Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiTableBodyRowProps, {
        row: row,
        staticRowIndex: staticRowIndex,
        table: table
    })), rest);
    const [bottomPinnedIndex, topPinnedIndex] = (0, $exYeM.useMemo)(()=>{
        if (!enableRowPinning || !(rowPinningDisplayMode === null || rowPinningDisplayMode === void 0 ? void 0 : rowPinningDisplayMode.includes("sticky")) || !pinnedRowIds || !row.getIsPinned()) return [];
        return [
            [
                ...pinnedRowIds
            ].reverse().indexOf(row.id),
            pinnedRowIds.indexOf(row.id)
        ];
    }, [
        pinnedRowIds,
        rowPinning
    ]);
    const tableHeadHeight = (enableStickyHeader || isFullScreen) && ((_b = tableHeadRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight) || 0;
    const tableFooterHeight = enableStickyFooter && ((_c = tableFooterRef.current) === null || _c === void 0 ? void 0 : _c.clientHeight) || 0;
    const sx = $35fd956d2f1c2be7$var$parseFromValuesOrFunc(tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx, theme);
    const defaultRowHeight = density === "compact" ? 37 : density === "comfortable" ? 53 : 69;
    const customRowHeight = // @ts-ignore
    parseInt((_f = (_d = tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.style) === null || _d === void 0 ? void 0 : _d.height) !== null && _f !== void 0 ? _f : sx === null || sx === void 0 ? void 0 : sx.height, 10) || undefined;
    const rowHeight = customRowHeight || defaultRowHeight;
    const handleDragEnter = (_e)=>{
        if (enableRowOrdering && draggingRow) setHoveredRow(row);
    };
    const handleDragOver = (e)=>{
        e.preventDefault();
    };
    const rowRef = (0, $exYeM.useRef)(null);
    const cellHighlightColor = isRowSelected ? selectedRowBackgroundColor : isRowPinned ? pinnedRowBackgroundColor : undefined;
    const cellHighlightColorHover = (tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.hover) !== false ? isRowSelected ? cellHighlightColor : theme.palette.mode === "dark" ? `${(0, $69eec9e6c105674b$export$c0816ed86df316af)(baseBackgroundColor, 0.3)}` : `${(0, $69eec9e6c105674b$export$4b073707ff63303)(baseBackgroundColor, 0.3)}` : undefined;
    return (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), Object.assign({
                "data-index": renderDetailPanel ? staticRowIndex * 2 : staticRowIndex,
                "data-pinned": !!isRowPinned || undefined,
                "data-selected": isRowSelected || undefined,
                onDragEnter: handleDragEnter,
                onDragOver: handleDragOver,
                ref: (node)=>{
                    if (node) {
                        rowRef.current = node;
                        rowVirtualizer === null || rowVirtualizer === void 0 || rowVirtualizer.measureElement(node);
                    }
                },
                selected: isRowSelected
            }, tableRowProps, {
                style: Object.assign({
                    transform: virtualRow ? `translateY(${virtualRow.start}px)` : undefined
                }, tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.style),
                sx: (theme)=>Object.assign({
                        "&:hover td:after": cellHighlightColorHover ? Object.assign({
                            backgroundColor: (0, $69eec9e6c105674b$export$58f0f39f63f3cf42)(cellHighlightColorHover, 0.3)
                        }, $35fd956d2f1c2be7$var$commonCellBeforeAfterStyles) : undefined,
                        backgroundColor: `${baseBackgroundColor} !important`,
                        bottom: !virtualRow && bottomPinnedIndex !== undefined && isRowPinned ? `${bottomPinnedIndex * rowHeight + (enableStickyFooter ? tableFooterHeight - 1 : 0)}px` : undefined,
                        boxSizing: "border-box",
                        display: (layoutMode === null || layoutMode === void 0 ? void 0 : layoutMode.startsWith("grid")) ? "flex" : undefined,
                        opacity: isRowPinned ? 0.97 : isDraggingRow || isHoveredRow ? 0.5 : 1,
                        position: virtualRow ? "absolute" : (rowPinningDisplayMode === null || rowPinningDisplayMode === void 0 ? void 0 : rowPinningDisplayMode.includes("sticky")) && isRowPinned ? "sticky" : "relative",
                        td: Object.assign({}, $35fd956d2f1c2be7$var$getCommonPinnedCellStyles({
                            table: table,
                            theme: theme
                        })),
                        "td:after": cellHighlightColor ? Object.assign({
                            backgroundColor: cellHighlightColor
                        }, $35fd956d2f1c2be7$var$commonCellBeforeAfterStyles) : undefined,
                        top: virtualRow ? 0 : topPinnedIndex !== undefined && isRowPinned ? `${topPinnedIndex * rowHeight + (enableStickyHeader || isFullScreen ? tableHeadHeight - 1 : 0)}px` : undefined,
                        transition: virtualRow ? "none" : "all 150ms ease-in-out",
                        width: "100%",
                        zIndex: (rowPinningDisplayMode === null || rowPinningDisplayMode === void 0 ? void 0 : rowPinningDisplayMode.includes("sticky")) && isRowPinned ? 2 : 0
                    }, sx),
                children: [
                    virtualPaddingLeft ? (0, $aSiaI.jsx)("td", {
                        style: {
                            display: "flex",
                            width: virtualPaddingLeft
                        }
                    }) : null,
                    (virtualColumns !== null && virtualColumns !== void 0 ? virtualColumns : visibleCells).map((cellOrVirtualCell, staticColumnIndex)=>{
                        let cell = cellOrVirtualCell;
                        if (columnVirtualizer) {
                            staticColumnIndex = cellOrVirtualCell.index;
                            cell = visibleCells[staticColumnIndex];
                        }
                        const props = {
                            cell: cell,
                            numRows: numRows,
                            rowRef: rowRef,
                            staticColumnIndex: staticColumnIndex,
                            staticRowIndex: staticRowIndex,
                            table: table
                        };
                        return cell ? memoMode === "cells" && cell.column.columnDef.columnDefType === "data" && !draggingColumn && !draggingRow && (editingCell === null || editingCell === void 0 ? void 0 : editingCell.id) !== cell.id && (editingRow === null || editingRow === void 0 ? void 0 : editingRow.id) !== row.id ? (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$1c0dd4187ccf886, Object.assign({}, props), cell.id) : (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$563b27a93712d4f0, Object.assign({}, props), cell.id) : null;
                    }),
                    virtualPaddingRight ? (0, $aSiaI.jsx)("td", {
                        style: {
                            display: "flex",
                            width: virtualPaddingRight
                        }
                    }) : null
                ]
            })),
            renderDetailPanel && !row.getIsGrouped() && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$97cb1fdb5b81c5aa, {
                parentRowRef: rowRef,
                row: row,
                rowVirtualizer: rowVirtualizer,
                staticRowIndex: staticRowIndex,
                table: table,
                virtualRow: virtualRow
            })
        ]
    });
};
const $35fd956d2f1c2be7$export$40a7c70e1740105e = (0, $exYeM.memo)($35fd956d2f1c2be7$export$c4e9a85606601fb5, (prev, next)=>prev.row === next.row && prev.staticRowIndex === next.staticRowIndex);
const $35fd956d2f1c2be7$export$5e55a092910f42e9 = (_a)=>{
    var _b, _c, _d, _e, _f, _g;
    var { columnVirtualizer: columnVirtualizer, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "columnVirtualizer",
        "table"
    ]);
    const { getBottomRows: getBottomRows, getIsSomeRowsPinned: getIsSomeRowsPinned, getRowModel: getRowModel, getState: getState, getTopRows: getTopRows, options: { enableStickyFooter: enableStickyFooter, enableStickyHeader: enableStickyHeader, layoutMode: layoutMode, localization: localization, memoMode: memoMode, muiTableBodyProps: muiTableBodyProps, renderDetailPanel: renderDetailPanel, renderEmptyRowsFallback: renderEmptyRowsFallback, rowPinningDisplayMode: rowPinningDisplayMode }, refs: { tableFooterRef: tableFooterRef, tableHeadRef: tableHeadRef, tablePaperRef: tablePaperRef } } = table;
    const { columnFilters: columnFilters, globalFilter: globalFilter, isFullScreen: isFullScreen, rowPinning: rowPinning } = getState();
    const tableBodyProps = Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiTableBodyProps, {
        table: table
    })), rest);
    const tableHeadHeight = (enableStickyHeader || isFullScreen) && ((_b = tableHeadRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight) || 0;
    const tableFooterHeight = enableStickyFooter && ((_c = tableFooterRef.current) === null || _c === void 0 ? void 0 : _c.clientHeight) || 0;
    const pinnedRowIds = (0, $exYeM.useMemo)(()=>{
        var _a, _b;
        if (!((_a = rowPinning.bottom) === null || _a === void 0 ? void 0 : _a.length) && !((_b = rowPinning.top) === null || _b === void 0 ? void 0 : _b.length)) return [];
        return getRowModel().rows.filter((row)=>row.getIsPinned()).map((r)=>r.id);
    }, [
        rowPinning,
        getRowModel().rows
    ]);
    const rows = $35fd956d2f1c2be7$export$a4ae485138dfddf0(table);
    const rowVirtualizer = $35fd956d2f1c2be7$export$1054ce63e1c67929(table, rows);
    const { virtualRows: virtualRows } = rowVirtualizer !== null && rowVirtualizer !== void 0 ? rowVirtualizer : {};
    const commonRowProps = {
        columnVirtualizer: columnVirtualizer,
        numRows: rows.length,
        table: table
    };
    return (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            !(rowPinningDisplayMode === null || rowPinningDisplayMode === void 0 ? void 0 : rowPinningDisplayMode.includes("sticky")) && getIsSomeRowsPinned("top") && (0, $aSiaI.jsx)((0, $e5ef275ef7d6f0a3$export$2e2bcd8739ae039), Object.assign({}, tableBodyProps, {
                sx: (theme)=>Object.assign({
                        display: (layoutMode === null || layoutMode === void 0 ? void 0 : layoutMode.startsWith("grid")) ? "grid" : undefined,
                        position: "sticky",
                        top: tableHeadHeight - 1,
                        zIndex: 1
                    }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(tableBodyProps === null || tableBodyProps === void 0 ? void 0 : tableBodyProps.sx, theme)),
                children: getTopRows().map((row, staticRowIndex)=>{
                    const props = Object.assign(Object.assign({}, commonRowProps), {
                        row: row,
                        staticRowIndex: staticRowIndex
                    });
                    return memoMode === "rows" ? (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$40a7c70e1740105e, Object.assign({}, props), row.id) : (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$c4e9a85606601fb5, Object.assign({}, props), row.id);
                })
            })),
            (0, $aSiaI.jsx)((0, $e5ef275ef7d6f0a3$export$2e2bcd8739ae039), Object.assign({}, tableBodyProps, {
                sx: (theme)=>Object.assign({
                        display: (layoutMode === null || layoutMode === void 0 ? void 0 : layoutMode.startsWith("grid")) ? "grid" : undefined,
                        height: rowVirtualizer ? `${rowVirtualizer.getTotalSize()}px` : undefined,
                        minHeight: !rows.length ? "100px" : undefined,
                        position: "relative"
                    }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(tableBodyProps === null || tableBodyProps === void 0 ? void 0 : tableBodyProps.sx, theme)),
                children: (_d = tableBodyProps === null || tableBodyProps === void 0 ? void 0 : tableBodyProps.children) !== null && _d !== void 0 ? _d : !rows.length ? (0, $aSiaI.jsx)("tr", {
                    style: {
                        display: (layoutMode === null || layoutMode === void 0 ? void 0 : layoutMode.startsWith("grid")) ? "grid" : undefined
                    },
                    children: (0, $aSiaI.jsx)("td", {
                        colSpan: table.getVisibleLeafColumns().length,
                        style: {
                            display: (layoutMode === null || layoutMode === void 0 ? void 0 : layoutMode.startsWith("grid")) ? "grid" : undefined
                        },
                        children: (_e = renderEmptyRowsFallback === null || renderEmptyRowsFallback === void 0 ? void 0 : renderEmptyRowsFallback({
                            table: table
                        })) !== null && _e !== void 0 ? _e : (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                            sx: {
                                color: "text.secondary",
                                fontStyle: "italic",
                                maxWidth: `min(100vw, ${(_g = (_f = tablePaperRef.current) === null || _f === void 0 ? void 0 : _f.clientWidth) !== null && _g !== void 0 ? _g : 360}px)`,
                                py: "2rem",
                                textAlign: "center",
                                width: "100%"
                            },
                            children: globalFilter || columnFilters.length ? localization.noResultsFound : localization.noRecordsToDisplay
                        })
                    })
                }) : (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
                    children: (virtualRows !== null && virtualRows !== void 0 ? virtualRows : rows).map((rowOrVirtualRow, staticRowIndex)=>{
                        let row = rowOrVirtualRow;
                        if (rowVirtualizer) {
                            if (renderDetailPanel) {
                                if (rowOrVirtualRow.index % 2 === 1) return null;
                                else staticRowIndex = rowOrVirtualRow.index / 2;
                            } else staticRowIndex = rowOrVirtualRow.index;
                            row = rows[staticRowIndex];
                        }
                        const props = Object.assign(Object.assign({}, commonRowProps), {
                            pinnedRowIds: pinnedRowIds,
                            row: row,
                            rowVirtualizer: rowVirtualizer,
                            staticRowIndex: staticRowIndex,
                            virtualRow: rowVirtualizer ? rowOrVirtualRow : undefined
                        });
                        const key = `${row.id}-${row.index}`;
                        return memoMode === "rows" ? (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$40a7c70e1740105e, Object.assign({}, props), key) : (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$c4e9a85606601fb5, Object.assign({}, props), key);
                    })
                })
            })),
            !(rowPinningDisplayMode === null || rowPinningDisplayMode === void 0 ? void 0 : rowPinningDisplayMode.includes("sticky")) && getIsSomeRowsPinned("bottom") && (0, $aSiaI.jsx)((0, $e5ef275ef7d6f0a3$export$2e2bcd8739ae039), Object.assign({}, tableBodyProps, {
                sx: (theme)=>Object.assign({
                        bottom: tableFooterHeight - 1,
                        display: (layoutMode === null || layoutMode === void 0 ? void 0 : layoutMode.startsWith("grid")) ? "grid" : undefined,
                        position: "sticky",
                        zIndex: 1
                    }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(tableBodyProps === null || tableBodyProps === void 0 ? void 0 : tableBodyProps.sx, theme)),
                children: getBottomRows().map((row, staticRowIndex)=>{
                    const props = Object.assign(Object.assign({}, commonRowProps), {
                        row: row,
                        staticRowIndex: staticRowIndex
                    });
                    return memoMode === "rows" ? (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$40a7c70e1740105e, Object.assign({}, props), row.id) : (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$c4e9a85606601fb5, Object.assign({}, props), row.id);
                })
            }))
        ]
    });
};
const $35fd956d2f1c2be7$export$8cd7047d2b3fdfcd = (0, $exYeM.memo)($35fd956d2f1c2be7$export$5e55a092910f42e9, (prev, next)=>prev.table.options.data === next.table.options.data);
const $35fd956d2f1c2be7$export$9e81ac771f69de1a = (_a)=>{
    var _b, _c, _d;
    var { footer: footer, staticColumnIndex: staticColumnIndex, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "footer",
        "staticColumnIndex",
        "table"
    ]);
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const { getState: getState, options: { enableColumnPinning: enableColumnPinning, muiTableFooterCellProps: muiTableFooterCellProps } } = table;
    const { density: density } = getState();
    const { column: column } = footer;
    const { columnDef: columnDef } = column;
    const { columnDefType: columnDefType } = columnDef;
    const isColumnPinned = enableColumnPinning && columnDef.columnDefType !== "group" && column.getIsPinned();
    const args = {
        column: column,
        table: table
    };
    const tableCellProps = Object.assign(Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiTableFooterCellProps, args)), $35fd956d2f1c2be7$var$parseFromValuesOrFunc(columnDef.muiTableFooterCellProps, args)), rest);
    return (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), Object.assign({
        align: columnDefType === "group" ? "center" : theme.direction === "rtl" ? "right" : "left",
        colSpan: footer.colSpan,
        "data-index": staticColumnIndex,
        "data-pinned": !!isColumnPinned || undefined,
        variant: "footer"
    }, tableCellProps, {
        sx: (theme)=>Object.assign(Object.assign({
                fontWeight: "bold",
                p: density === "compact" ? "0.5rem" : density === "comfortable" ? "1rem" : "1.5rem",
                verticalAlign: "top"
            }, $35fd956d2f1c2be7$var$getCommonMRTCellStyles({
                column: column,
                header: footer,
                table: table,
                tableCellProps: tableCellProps,
                theme: theme
            })), $35fd956d2f1c2be7$var$parseFromValuesOrFunc(tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.sx, theme)),
        children: (_b = tableCellProps.children) !== null && _b !== void 0 ? _b : footer.isPlaceholder ? null : (_d = (_c = $35fd956d2f1c2be7$var$parseFromValuesOrFunc(columnDef.Footer, {
            column: column,
            footer: footer,
            table: table
        })) !== null && _c !== void 0 ? _c : columnDef.footer) !== null && _d !== void 0 ? _d : null
    }));
};
const $35fd956d2f1c2be7$export$856a6255bc59d7dc = (_a)=>{
    var _b;
    var { columnVirtualizer: columnVirtualizer, footerGroup: footerGroup, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "columnVirtualizer",
        "footerGroup",
        "table"
    ]);
    const { options: { layoutMode: layoutMode, mrtTheme: { baseBackgroundColor: baseBackgroundColor }, muiTableFooterRowProps: muiTableFooterRowProps } } = table;
    const { virtualColumns: virtualColumns, virtualPaddingLeft: virtualPaddingLeft, virtualPaddingRight: virtualPaddingRight } = columnVirtualizer !== null && columnVirtualizer !== void 0 ? columnVirtualizer : {};
    // if no content in row, skip row
    if (!((_b = footerGroup.headers) === null || _b === void 0 ? void 0 : _b.some((header)=>typeof header.column.columnDef.footer === "string" && !!header.column.columnDef.footer || header.column.columnDef.Footer))) return null;
    const tableRowProps = Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiTableFooterRowProps, {
        footerGroup: footerGroup,
        table: table
    })), rest);
    return (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), Object.assign({}, tableRowProps, {
        sx: (theme)=>Object.assign({
                backgroundColor: baseBackgroundColor,
                display: (layoutMode === null || layoutMode === void 0 ? void 0 : layoutMode.startsWith("grid")) ? "flex" : undefined,
                position: "relative",
                width: "100%"
            }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx, theme)),
        children: [
            virtualPaddingLeft ? (0, $aSiaI.jsx)("th", {
                style: {
                    display: "flex",
                    width: virtualPaddingLeft
                }
            }) : null,
            (virtualColumns !== null && virtualColumns !== void 0 ? virtualColumns : footerGroup.headers).map((footerOrVirtualFooter, staticColumnIndex)=>{
                let footer = footerOrVirtualFooter;
                if (columnVirtualizer) {
                    staticColumnIndex = footerOrVirtualFooter.index;
                    footer = footerGroup.headers[staticColumnIndex];
                }
                return footer ? (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$9e81ac771f69de1a, {
                    footer: footer,
                    staticColumnIndex: staticColumnIndex,
                    table: table
                }, footer.id) : null;
            }),
            virtualPaddingRight ? (0, $aSiaI.jsx)("th", {
                style: {
                    display: "flex",
                    width: virtualPaddingRight
                }
            }) : null
        ]
    }));
};
const $35fd956d2f1c2be7$export$84b7086891079f4e = (_a)=>{
    var { columnVirtualizer: columnVirtualizer, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "columnVirtualizer",
        "table"
    ]);
    const { getFooterGroups: getFooterGroups, getState: getState, options: { enableStickyFooter: enableStickyFooter, layoutMode: layoutMode, muiTableFooterProps: muiTableFooterProps }, refs: { tableFooterRef: tableFooterRef } } = table;
    const { isFullScreen: isFullScreen } = getState();
    const tableFooterProps = Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiTableFooterProps, {
        table: table
    })), rest);
    const stickFooter = (isFullScreen || enableStickyFooter) && enableStickyFooter !== false;
    return (0, $aSiaI.jsx)((0, $9a3e078eebef299d$export$2e2bcd8739ae039), Object.assign({}, tableFooterProps, {
        ref: (ref)=>{
            tableFooterRef.current = ref;
            if (tableFooterProps === null || tableFooterProps === void 0 ? void 0 : tableFooterProps.ref) // @ts-ignore
            tableFooterProps.ref.current = ref;
        },
        sx: (theme)=>Object.assign({
                bottom: stickFooter ? 0 : undefined,
                display: (layoutMode === null || layoutMode === void 0 ? void 0 : layoutMode.startsWith("grid")) ? "grid" : undefined,
                opacity: stickFooter ? 0.97 : undefined,
                outline: stickFooter ? theme.palette.mode === "light" ? `1px solid ${theme.palette.grey[300]}` : `1px solid ${theme.palette.grey[700]}` : undefined,
                position: stickFooter ? "sticky" : "relative",
                zIndex: stickFooter ? 1 : undefined
            }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(tableFooterProps === null || tableFooterProps === void 0 ? void 0 : tableFooterProps.sx, theme)),
        children: getFooterGroups().map((footerGroup)=>(0, $aSiaI.jsx)($35fd956d2f1c2be7$export$856a6255bc59d7dc, {
                columnVirtualizer: columnVirtualizer,
                footerGroup: footerGroup,
                table: table
            }, footerGroup.id))
    }));
};
const $35fd956d2f1c2be7$export$8298b2ebbdb6a20 = (localization)=>[
        {
            divider: false,
            label: localization.filterFuzzy,
            option: "fuzzy",
            symbol: "\u2248"
        },
        {
            divider: false,
            label: localization.filterContains,
            option: "contains",
            symbol: "*"
        },
        {
            divider: false,
            label: localization.filterStartsWith,
            option: "startsWith",
            symbol: "a"
        },
        {
            divider: true,
            label: localization.filterEndsWith,
            option: "endsWith",
            symbol: "z"
        },
        {
            divider: false,
            label: localization.filterEquals,
            option: "equals",
            symbol: "="
        },
        {
            divider: true,
            label: localization.filterNotEquals,
            option: "notEquals",
            symbol: "\u2260"
        },
        {
            divider: false,
            label: localization.filterBetween,
            option: "between",
            symbol: "\u21FF"
        },
        {
            divider: true,
            label: localization.filterBetweenInclusive,
            option: "betweenInclusive",
            symbol: "\u2B0C"
        },
        {
            divider: false,
            label: localization.filterGreaterThan,
            option: "greaterThan",
            symbol: ">"
        },
        {
            divider: false,
            label: localization.filterGreaterThanOrEqualTo,
            option: "greaterThanOrEqualTo",
            symbol: "\u2265"
        },
        {
            divider: false,
            label: localization.filterLessThan,
            option: "lessThan",
            symbol: "<"
        },
        {
            divider: true,
            label: localization.filterLessThanOrEqualTo,
            option: "lessThanOrEqualTo",
            symbol: "\u2264"
        },
        {
            divider: false,
            label: localization.filterEmpty,
            option: "empty",
            symbol: "\u2205"
        },
        {
            divider: false,
            label: localization.filterNotEmpty,
            option: "notEmpty",
            symbol: "!\u2205"
        }
    ];
const $35fd956d2f1c2be7$var$rangeModes = [
    "between",
    "betweenInclusive",
    "inNumberRange"
];
const $35fd956d2f1c2be7$var$emptyModes = [
    "empty",
    "notEmpty"
];
const $35fd956d2f1c2be7$var$arrModes = [
    "arrIncludesSome",
    "arrIncludesAll",
    "arrIncludes"
];
const $35fd956d2f1c2be7$var$rangeVariants = [
    "range-slider",
    "date-range",
    "datetime-range",
    "range"
];
const $35fd956d2f1c2be7$export$18f00246d050b1b5 = (_a)=>{
    var _b, _c, _d, _e;
    var { anchorEl: anchorEl, header: header, onSelect: onSelect, setAnchorEl: setAnchorEl, setFilterValue: setFilterValue, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "anchorEl",
        "header",
        "onSelect",
        "setAnchorEl",
        "setFilterValue",
        "table"
    ]);
    const { getState: getState, options: { columnFilterModeOptions: columnFilterModeOptions, globalFilterModeOptions: globalFilterModeOptions, localization: localization, mrtTheme: { menuBackgroundColor: menuBackgroundColor }, renderColumnFilterModeMenuItems: renderColumnFilterModeMenuItems, renderGlobalFilterModeMenuItems: renderGlobalFilterModeMenuItems }, setColumnFilterFns: setColumnFilterFns, setGlobalFilterFn: setGlobalFilterFn } = table;
    const { density: density, globalFilterFn: globalFilterFn } = getState();
    const { column: column } = header !== null && header !== void 0 ? header : {};
    const { columnDef: columnDef } = column !== null && column !== void 0 ? column : {};
    const currentFilterValue = column === null || column === void 0 ? void 0 : column.getFilterValue();
    let allowedColumnFilterOptions = (_b = columnDef === null || columnDef === void 0 ? void 0 : columnDef.columnFilterModeOptions) !== null && _b !== void 0 ? _b : columnFilterModeOptions;
    if ($35fd956d2f1c2be7$var$rangeVariants.includes(columnDef === null || columnDef === void 0 ? void 0 : columnDef.filterVariant)) allowedColumnFilterOptions = [
        ...$35fd956d2f1c2be7$var$rangeModes,
        ...allowedColumnFilterOptions !== null && allowedColumnFilterOptions !== void 0 ? allowedColumnFilterOptions : []
    ].filter((option)=>$35fd956d2f1c2be7$var$rangeModes.includes(option));
    const internalFilterOptions = (0, $exYeM.useMemo)(()=>$35fd956d2f1c2be7$export$8298b2ebbdb6a20(localization).filter((filterOption)=>columnDef ? allowedColumnFilterOptions === undefined || (allowedColumnFilterOptions === null || allowedColumnFilterOptions === void 0 ? void 0 : allowedColumnFilterOptions.includes(filterOption.option)) : (!globalFilterModeOptions || globalFilterModeOptions.includes(filterOption.option)) && [
                "contains",
                "fuzzy",
                "startsWith"
            ].includes(filterOption.option)), []);
    const handleSelectFilterMode = (option)=>{
        var _a, _b;
        const prevFilterMode = (_a = columnDef === null || columnDef === void 0 ? void 0 : columnDef._filterFn) !== null && _a !== void 0 ? _a : "";
        if (!header || !column) // global filter mode
        setGlobalFilterFn(option);
        else if (option !== prevFilterMode) {
            // column filter mode
            setColumnFilterFns((prev)=>Object.assign(Object.assign({}, prev), {
                    [header.id]: option
                }));
            // reset filter value and/or perform new filter render
            if ($35fd956d2f1c2be7$var$emptyModes.includes(option)) {
                // will now be empty/notEmpty filter mode
                if (currentFilterValue !== " " && !$35fd956d2f1c2be7$var$emptyModes.includes(prevFilterMode)) column.setFilterValue(" ");
                else if (currentFilterValue) column.setFilterValue(currentFilterValue); // perform new filter render
            } else if ((columnDef === null || columnDef === void 0 ? void 0 : columnDef.filterVariant) === "multi-select" || $35fd956d2f1c2be7$var$arrModes.includes(option)) {
                // will now be array filter mode
                if (currentFilterValue instanceof String || (currentFilterValue === null || currentFilterValue === void 0 ? void 0 : currentFilterValue.length)) {
                    column.setFilterValue([]);
                    setFilterValue === null || setFilterValue === void 0 || setFilterValue([]);
                } else if (currentFilterValue) column.setFilterValue(currentFilterValue); // perform new filter render
            } else if (((_b = columnDef === null || columnDef === void 0 ? void 0 : columnDef.filterVariant) === null || _b === void 0 ? void 0 : _b.includes("range")) || $35fd956d2f1c2be7$var$rangeModes.includes(option)) {
                // will now be range filter mode
                if (!Array.isArray(currentFilterValue) || !(currentFilterValue === null || currentFilterValue === void 0 ? void 0 : currentFilterValue.every((v)=>v === "")) && !$35fd956d2f1c2be7$var$rangeModes.includes(prevFilterMode)) {
                    column.setFilterValue([
                        "",
                        ""
                    ]);
                    setFilterValue === null || setFilterValue === void 0 || setFilterValue("");
                } else column.setFilterValue(currentFilterValue); // perform new filter render
            } else {
                // will now be single value filter mode
                if (Array.isArray(currentFilterValue)) {
                    column.setFilterValue("");
                    setFilterValue === null || setFilterValue === void 0 || setFilterValue("");
                } else if (currentFilterValue === " " && $35fd956d2f1c2be7$var$emptyModes.includes(prevFilterMode)) column.setFilterValue(undefined);
                else column.setFilterValue(currentFilterValue); // perform new filter render
            }
        }
        setAnchorEl(null);
        onSelect === null || onSelect === void 0 || onSelect();
    };
    const filterOption = !!header && columnDef ? columnDef._filterFn : globalFilterFn;
    return (0, $aSiaI.jsx)((0, $cf82f57fc51895ad$export$2e2bcd8739ae039), Object.assign({
        MenuListProps: {
            dense: density === "compact",
            sx: {
                backgroundColor: menuBackgroundColor
            }
        },
        anchorEl: anchorEl,
        anchorOrigin: {
            horizontal: "right",
            vertical: "center"
        },
        disableScrollLock: true,
        onClose: ()=>setAnchorEl(null),
        open: !!anchorEl
    }, rest, {
        children: (_e = header && column && columnDef ? (_d = (_c = columnDef.renderColumnFilterModeMenuItems) === null || _c === void 0 ? void 0 : _c.call(columnDef, {
            column: column,
            internalFilterOptions: internalFilterOptions,
            onSelectFilterMode: handleSelectFilterMode,
            table: table
        })) !== null && _d !== void 0 ? _d : renderColumnFilterModeMenuItems === null || renderColumnFilterModeMenuItems === void 0 ? void 0 : renderColumnFilterModeMenuItems({
            column: column,
            internalFilterOptions: internalFilterOptions,
            onSelectFilterMode: handleSelectFilterMode,
            table: table
        }) : renderGlobalFilterModeMenuItems === null || renderGlobalFilterModeMenuItems === void 0 ? void 0 : renderGlobalFilterModeMenuItems({
            internalFilterOptions: internalFilterOptions,
            onSelectFilterMode: handleSelectFilterMode,
            table: table
        })) !== null && _e !== void 0 ? _e : internalFilterOptions.map(({ divider: divider, label: label, option: option, symbol: symbol }, index)=>(0, $aSiaI.jsx)($35fd956d2f1c2be7$export$7a47075d9547bd75, {
                divider: divider,
                icon: symbol,
                label: label,
                onClick: ()=>handleSelectFilterMode(option),
                selected: option === filterOption,
                table: table,
                value: option
            }, index))
    }));
};
const $35fd956d2f1c2be7$export$e51665a34a3a1434 = (_a)=>{
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var { anchorEl: anchorEl, header: header, setAnchorEl: setAnchorEl, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "anchorEl",
        "header",
        "setAnchorEl",
        "table"
    ]);
    const { getAllLeafColumns: getAllLeafColumns, getState: getState, options: { columnFilterDisplayMode: columnFilterDisplayMode, columnFilterModeOptions: columnFilterModeOptions, enableColumnFilterModes: enableColumnFilterModes, enableColumnFilters: enableColumnFilters, enableColumnPinning: enableColumnPinning, enableColumnResizing: enableColumnResizing, enableGrouping: enableGrouping, enableHiding: enableHiding, enableSorting: enableSorting, enableSortingRemoval: enableSortingRemoval, icons: { ClearAllIcon: ClearAllIcon, DynamicFeedIcon: DynamicFeedIcon, FilterListIcon: FilterListIcon, FilterListOffIcon: FilterListOffIcon, PushPinIcon: PushPinIcon, RestartAltIcon: RestartAltIcon, SortIcon: SortIcon, ViewColumnIcon: ViewColumnIcon, VisibilityOffIcon: VisibilityOffIcon }, localization: localization, mrtTheme: { menuBackgroundColor: menuBackgroundColor }, renderColumnActionsMenuItems: renderColumnActionsMenuItems }, refs: { filterInputRefs: filterInputRefs }, setColumnFilterFns: setColumnFilterFns, setColumnOrder: setColumnOrder, setColumnSizingInfo: setColumnSizingInfo, setShowColumnFilters: setShowColumnFilters } = table;
    const { column: column } = header;
    const { columnDef: columnDef } = column;
    const { columnSizing: columnSizing, columnVisibility: columnVisibility, density: density, showColumnFilters: showColumnFilters } = getState();
    const columnFilterValue = column.getFilterValue();
    const [filterMenuAnchorEl, setFilterMenuAnchorEl] = (0, $exYeM.useState)(null);
    const handleClearSort = ()=>{
        column.clearSorting();
        setAnchorEl(null);
    };
    const handleSortAsc = ()=>{
        column.toggleSorting(false);
        setAnchorEl(null);
    };
    const handleSortDesc = ()=>{
        column.toggleSorting(true);
        setAnchorEl(null);
    };
    const handleResetColumnSize = ()=>{
        setColumnSizingInfo((old)=>Object.assign(Object.assign({}, old), {
                isResizingColumn: false
            }));
        column.resetSize();
        setAnchorEl(null);
    };
    const handleHideColumn = ()=>{
        column.toggleVisibility(false);
        setAnchorEl(null);
    };
    const handlePinColumn = (pinDirection)=>{
        column.pin(pinDirection);
        setAnchorEl(null);
    };
    const handleGroupByColumn = ()=>{
        column.toggleGrouping();
        setColumnOrder((old)=>[
                "mrt-row-expand",
                ...old
            ]);
        setAnchorEl(null);
    };
    const handleClearFilter = ()=>{
        column.setFilterValue(undefined);
        setAnchorEl(null);
        if ([
            "empty",
            "notEmpty"
        ].includes(columnDef._filterFn)) setColumnFilterFns((prev)=>{
            var _a;
            return Object.assign(Object.assign({}, prev), {
                [header.id]: (_a = allowedColumnFilterOptions === null || allowedColumnFilterOptions === void 0 ? void 0 : allowedColumnFilterOptions[0]) !== null && _a !== void 0 ? _a : "fuzzy"
            });
        });
    };
    const handleFilterByColumn = ()=>{
        setShowColumnFilters(true);
        queueMicrotask(()=>{
            var _a;
            return (_a = filterInputRefs.current[`${column.id}-0`]) === null || _a === void 0 ? void 0 : _a.focus();
        });
        setAnchorEl(null);
    };
    const handleShowAllColumns = ()=>{
        getAllLeafColumns().filter((col)=>col.columnDef.enableHiding !== false).forEach((col)=>col.toggleVisibility(true));
        setAnchorEl(null);
    };
    const handleOpenFilterModeMenu = (event)=>{
        event.stopPropagation();
        setFilterMenuAnchorEl(event.currentTarget);
    };
    const isSelectFilter = !!columnDef.filterSelectOptions;
    const allowedColumnFilterOptions = (_b = columnDef === null || columnDef === void 0 ? void 0 : columnDef.columnFilterModeOptions) !== null && _b !== void 0 ? _b : columnFilterModeOptions;
    const showFilterModeSubMenu = enableColumnFilterModes && columnDef.enableColumnFilterModes !== false && !isSelectFilter && (allowedColumnFilterOptions === undefined || !!(allowedColumnFilterOptions === null || allowedColumnFilterOptions === void 0 ? void 0 : allowedColumnFilterOptions.length));
    const internalColumnMenuItems = [
        ...enableSorting && column.getCanSort() ? [
            enableSortingRemoval !== false && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$7a47075d9547bd75, {
                icon: (0, $aSiaI.jsx)(ClearAllIcon, {}),
                label: localization.clearSort,
                onClick: handleClearSort,
                table: table
            }, 0),
            (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$7a47075d9547bd75, {
                disabled: column.getIsSorted() === "asc",
                icon: (0, $aSiaI.jsx)(SortIcon, {
                    style: {
                        transform: "rotate(180deg) scaleX(-1)"
                    }
                }),
                label: (_c = localization.sortByColumnAsc) === null || _c === void 0 ? void 0 : _c.replace("{column}", String(columnDef.header)),
                onClick: handleSortAsc,
                table: table
            }, 1),
            (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$7a47075d9547bd75, {
                disabled: column.getIsSorted() === "desc",
                divider: enableColumnFilters || enableGrouping || enableHiding,
                icon: (0, $aSiaI.jsx)(SortIcon, {}),
                label: (_d = localization.sortByColumnDesc) === null || _d === void 0 ? void 0 : _d.replace("{column}", String(columnDef.header)),
                onClick: handleSortDesc,
                table: table
            }, 2)
        ] : [],
        ...enableColumnFilters && column.getCanFilter() ? [
            (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$7a47075d9547bd75, {
                disabled: !columnFilterValue || Array.isArray(columnFilterValue) && !columnFilterValue.filter((value)=>value).length,
                icon: (0, $aSiaI.jsx)(FilterListOffIcon, {}),
                label: localization.clearFilter,
                onClick: handleClearFilter,
                table: table
            }, 3),
            columnFilterDisplayMode === "subheader" && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$7a47075d9547bd75, {
                disabled: showColumnFilters && !enableColumnFilterModes,
                divider: enableGrouping || enableHiding,
                icon: (0, $aSiaI.jsx)(FilterListIcon, {}),
                label: (_e = localization.filterByColumn) === null || _e === void 0 ? void 0 : _e.replace("{column}", String(columnDef.header)),
                onClick: showColumnFilters ? handleOpenFilterModeMenu : handleFilterByColumn,
                onOpenSubMenu: showFilterModeSubMenu ? handleOpenFilterModeMenu : undefined,
                table: table
            }, 4),
            showFilterModeSubMenu && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$18f00246d050b1b5, {
                anchorEl: filterMenuAnchorEl,
                header: header,
                onSelect: handleFilterByColumn,
                setAnchorEl: setFilterMenuAnchorEl,
                table: table
            }, 5)
        ].filter(Boolean) : [],
        ...enableGrouping && column.getCanGroup() ? [
            (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$7a47075d9547bd75, {
                divider: enableColumnPinning,
                icon: (0, $aSiaI.jsx)(DynamicFeedIcon, {}),
                label: (_f = localization[column.getIsGrouped() ? "ungroupByColumn" : "groupByColumn"]) === null || _f === void 0 ? void 0 : _f.replace("{column}", String(columnDef.header)),
                onClick: handleGroupByColumn,
                table: table
            }, 6)
        ] : [],
        ...enableColumnPinning && column.getCanPin() ? [
            (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$7a47075d9547bd75, {
                disabled: column.getIsPinned() === "left" || !column.getCanPin(),
                icon: (0, $aSiaI.jsx)(PushPinIcon, {
                    style: {
                        transform: "rotate(90deg)"
                    }
                }),
                label: localization.pinToLeft,
                onClick: ()=>handlePinColumn("left"),
                table: table
            }, 7),
            (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$7a47075d9547bd75, {
                disabled: column.getIsPinned() === "right" || !column.getCanPin(),
                icon: (0, $aSiaI.jsx)(PushPinIcon, {
                    style: {
                        transform: "rotate(-90deg)"
                    }
                }),
                label: localization.pinToRight,
                onClick: ()=>handlePinColumn("right"),
                table: table
            }, 8),
            (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$7a47075d9547bd75, {
                disabled: !column.getIsPinned(),
                divider: enableHiding,
                icon: (0, $aSiaI.jsx)(PushPinIcon, {}),
                label: localization.unpin,
                onClick: ()=>handlePinColumn(false),
                table: table
            }, 9)
        ] : [],
        ...enableColumnResizing && column.getCanResize() ? [
            (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$7a47075d9547bd75, {
                disabled: !columnSizing[column.id],
                icon: (0, $aSiaI.jsx)(RestartAltIcon, {}),
                label: localization.resetColumnSize,
                onClick: handleResetColumnSize,
                table: table
            }, 10)
        ] : [],
        ...enableHiding ? [
            (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$7a47075d9547bd75, {
                disabled: !column.getCanHide(),
                icon: (0, $aSiaI.jsx)(VisibilityOffIcon, {}),
                label: (_g = localization.hideColumn) === null || _g === void 0 ? void 0 : _g.replace("{column}", String(columnDef.header)),
                onClick: handleHideColumn,
                table: table
            }, 11),
            (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$7a47075d9547bd75, {
                disabled: !Object.values(columnVisibility).filter((visible)=>!visible).length,
                icon: (0, $aSiaI.jsx)(ViewColumnIcon, {}),
                label: (_h = localization.showAllColumns) === null || _h === void 0 ? void 0 : _h.replace("{column}", String(columnDef.header)),
                onClick: handleShowAllColumns,
                table: table
            }, 12)
        ] : []
    ].filter(Boolean);
    return (0, $aSiaI.jsx)((0, $cf82f57fc51895ad$export$2e2bcd8739ae039), Object.assign({
        MenuListProps: {
            dense: density === "compact",
            sx: {
                backgroundColor: menuBackgroundColor
            }
        },
        anchorEl: anchorEl,
        disableScrollLock: true,
        onClose: ()=>setAnchorEl(null),
        open: !!anchorEl
    }, rest, {
        children: (_l = (_k = (_j = columnDef.renderColumnActionsMenuItems) === null || _j === void 0 ? void 0 : _j.call(columnDef, {
            closeMenu: ()=>setAnchorEl(null),
            column: column,
            internalColumnMenuItems: internalColumnMenuItems,
            table: table
        })) !== null && _k !== void 0 ? _k : renderColumnActionsMenuItems === null || renderColumnActionsMenuItems === void 0 ? void 0 : renderColumnActionsMenuItems({
            closeMenu: ()=>setAnchorEl(null),
            column: column,
            internalColumnMenuItems: internalColumnMenuItems,
            table: table
        })) !== null && _l !== void 0 ? _l : internalColumnMenuItems
    }));
};
const $35fd956d2f1c2be7$export$b039aa2e7eefde50 = (_a)=>{
    var _b, _c;
    var { header: header, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "header",
        "table"
    ]);
    const { options: { icons: { MoreVertIcon: MoreVertIcon }, localization: localization, muiColumnActionsButtonProps: muiColumnActionsButtonProps } } = table;
    const { column: column } = header;
    const { columnDef: columnDef } = column;
    const [anchorEl, setAnchorEl] = (0, $exYeM.useState)(null);
    const handleClick = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };
    const iconButtonProps = Object.assign(Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiColumnActionsButtonProps, {
        column: column,
        table: table
    })), $35fd956d2f1c2be7$var$parseFromValuesOrFunc(columnDef.muiColumnActionsButtonProps, {
        column: column,
        table: table
    })), rest);
    return (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), Object.assign({}, $35fd956d2f1c2be7$var$getCommonTooltipProps("top"), {
                title: (_b = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.title) !== null && _b !== void 0 ? _b : localization.columnActions,
                children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), Object.assign({
                    "aria-label": localization.columnActions,
                    onClick: handleClick,
                    size: "small"
                }, iconButtonProps, {
                    sx: (theme)=>Object.assign({
                            "&:hover": {
                                opacity: 1
                            },
                            height: "2rem",
                            m: "-8px -4px",
                            opacity: 0.3,
                            transition: "all 150ms",
                            width: "2rem"
                        }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.sx, theme)),
                    title: undefined,
                    children: (_c = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.children) !== null && _c !== void 0 ? _c : (0, $aSiaI.jsx)(MoreVertIcon, {
                        style: {
                            transform: "scale(0.9)"
                        }
                    })
                }))
            })),
            anchorEl && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$e51665a34a3a1434, {
                anchorEl: anchorEl,
                header: header,
                setAnchorEl: setAnchorEl,
                table: table
            })
        ]
    });
};
const $35fd956d2f1c2be7$export$e7a491feaac9d2a4 = (_a)=>{
    var _b, _c, _d;
    var { column: column, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "column",
        "table"
    ]);
    const { getState: getState, options: { localization: localization, muiFilterCheckboxProps: muiFilterCheckboxProps } } = table;
    const { density: density } = getState();
    const { columnDef: columnDef } = column;
    const checkboxProps = Object.assign(Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiFilterCheckboxProps, {
        column: column,
        table: table
    })), $35fd956d2f1c2be7$var$parseFromValuesOrFunc(columnDef.muiFilterCheckboxProps, {
        column: column,
        table: table
    })), rest);
    const filterLabel = (_b = localization.filterByColumn) === null || _b === void 0 ? void 0 : _b.replace("{column}", columnDef.header);
    return (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), Object.assign({}, $35fd956d2f1c2be7$var$getCommonTooltipProps(), {
        title: (_c = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.title) !== null && _c !== void 0 ? _c : filterLabel,
        children: (0, $aSiaI.jsx)((0, $412387e41715fadc$export$2e2bcd8739ae039), {
            control: (0, $aSiaI.jsx)((0, $71e996631894f6ef$export$2e2bcd8739ae039), Object.assign({
                checked: column.getFilterValue() === "true",
                color: column.getFilterValue() === undefined ? "default" : "primary",
                indeterminate: column.getFilterValue() === undefined,
                size: density === "compact" ? "small" : "medium"
            }, checkboxProps, {
                onChange: (e, checked)=>{
                    var _a;
                    column.setFilterValue(column.getFilterValue() === undefined ? "true" : column.getFilterValue() === "true" ? "false" : undefined);
                    (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.onChange) === null || _a === void 0 || _a.call(checkboxProps, e, checked);
                },
                onClick: (e)=>{
                    var _a;
                    e.stopPropagation();
                    (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.onClick) === null || _a === void 0 || _a.call(checkboxProps, e);
                },
                sx: (theme)=>Object.assign({
                        height: "2.5rem",
                        width: "2.5rem"
                    }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.sx, theme))
            })),
            disableTypography: true,
            label: (_d = checkboxProps.title) !== null && _d !== void 0 ? _d : filterLabel,
            sx: {
                color: "text.secondary",
                fontWeight: "normal",
                mt: "-4px"
            },
            title: undefined
        })
    }));
};
const $35fd956d2f1c2be7$export$e1c058f1849202d3 = (_a)=>{
    var _b, _c, _d, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    var { header: header, rangeFilterIndex: rangeFilterIndex, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "header",
        "rangeFilterIndex",
        "table"
    ]);
    const { options: { enableColumnFilterModes: enableColumnFilterModes, icons: { CloseIcon: CloseIcon, FilterListIcon: FilterListIcon }, localization: localization, manualFiltering: manualFiltering, muiFilterAutocompleteProps: muiFilterAutocompleteProps, muiFilterDatePickerProps: muiFilterDatePickerProps, muiFilterDateTimePickerProps: muiFilterDateTimePickerProps, muiFilterTextFieldProps: muiFilterTextFieldProps, muiFilterTimePickerProps: muiFilterTimePickerProps }, refs: { filterInputRefs: filterInputRefs }, setColumnFilterFns: setColumnFilterFns } = table;
    const { column: column } = header;
    const { columnDef: columnDef } = column;
    const { filterVariant: filterVariant } = columnDef;
    const args = {
        column: column,
        rangeFilterIndex: rangeFilterIndex,
        table: table
    };
    const textFieldProps = Object.assign(Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiFilterTextFieldProps, args)), $35fd956d2f1c2be7$var$parseFromValuesOrFunc(columnDef.muiFilterTextFieldProps, args)), rest);
    const autocompleteProps = Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiFilterAutocompleteProps, args)), $35fd956d2f1c2be7$var$parseFromValuesOrFunc(columnDef.muiFilterAutocompleteProps, args));
    const datePickerProps = Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiFilterDatePickerProps, args)), $35fd956d2f1c2be7$var$parseFromValuesOrFunc(columnDef.muiFilterDatePickerProps, args));
    const dateTimePickerProps = Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiFilterDateTimePickerProps, args)), $35fd956d2f1c2be7$var$parseFromValuesOrFunc(columnDef.muiFilterDateTimePickerProps, args));
    const timePickerProps = Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiFilterTimePickerProps, args)), $35fd956d2f1c2be7$var$parseFromValuesOrFunc(columnDef.muiFilterTimePickerProps, args));
    const { allowedColumnFilterOptions: allowedColumnFilterOptions, currentFilterOption: currentFilterOption, facetedUniqueValues: facetedUniqueValues, isAutocompleteFilter: isAutocompleteFilter, isDateFilter: isDateFilter, isMultiSelectFilter: isMultiSelectFilter, isRangeFilter: isRangeFilter, isSelectFilter: isSelectFilter, isTextboxFilter: isTextboxFilter } = $35fd956d2f1c2be7$export$863d009b6baa6754({
        header: header,
        table: table
    });
    const dropdownOptions = $35fd956d2f1c2be7$export$9530f32da83c3525({
        header: header,
        table: table
    });
    const filterChipLabel = [
        "empty",
        "notEmpty"
    ].includes(currentFilterOption) ? localization[`filter${((_c = (_b = currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.charAt) === null || _b === void 0 ? void 0 : _b.call(currentFilterOption, 0)) === null || _c === void 0 ? void 0 : _c.toUpperCase()) + (currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.slice(1))}`] : "";
    const filterPlaceholder = !isRangeFilter ? (_d = textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.placeholder) !== null && _d !== void 0 ? _d : (_f = localization.filterByColumn) === null || _f === void 0 ? void 0 : _f.replace("{column}", String(columnDef.header)) : rangeFilterIndex === 0 ? localization.min : rangeFilterIndex === 1 ? localization.max : "";
    const showChangeModeButton = !!(enableColumnFilterModes && columnDef.enableColumnFilterModes !== false && !rangeFilterIndex && (allowedColumnFilterOptions === undefined || !!(allowedColumnFilterOptions === null || allowedColumnFilterOptions === void 0 ? void 0 : allowedColumnFilterOptions.length)));
    const [anchorEl, setAnchorEl] = (0, $exYeM.useState)(null);
    const [filterValue, setFilterValue] = (0, $exYeM.useState)(()=>{
        var _a, _b;
        return isMultiSelectFilter ? column.getFilterValue() || [] : isRangeFilter ? ((_a = column.getFilterValue()) === null || _a === void 0 ? void 0 : _a[rangeFilterIndex]) || "" : (_b = column.getFilterValue()) !== null && _b !== void 0 ? _b : "";
    });
    const [autocompleteValue, setAutocompleteValue] = (0, $exYeM.useState)(isAutocompleteFilter ? filterValue : null);
    const handleChangeDebounced = (0, $exYeM.useCallback)((0, $398f0b8aef852a12$export$2e2bcd8739ae039)((newValue)=>{
        if (isRangeFilter) column.setFilterValue((old)=>{
            const newFilterValues = old !== null && old !== void 0 ? old : [
                "",
                ""
            ];
            newFilterValues[rangeFilterIndex] = newValue !== null && newValue !== void 0 ? newValue : undefined;
            return newFilterValues;
        });
        else column.setFilterValue(newValue !== null && newValue !== void 0 ? newValue : undefined);
    }, isTextboxFilter ? manualFiltering ? 400 : 200 : 1), []);
    const handleChange = (newValue)=>{
        setFilterValue(newValue !== null && newValue !== void 0 ? newValue : "");
        handleChangeDebounced(newValue);
    };
    const handleTextFieldChange = (event)=>{
        var _a;
        const newValue = textFieldProps.type === "date" ? event.target.valueAsDate : textFieldProps.type === "number" ? event.target.valueAsNumber : event.target.value;
        handleChange(newValue);
        (_a = textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.onChange) === null || _a === void 0 || _a.call(textFieldProps, event);
    };
    const handleAutocompleteChange = (newValue)=>{
        setAutocompleteValue(newValue);
        handleChange($35fd956d2f1c2be7$var$getValueAndLabel(newValue).value);
    };
    const handleClear = ()=>{
        if (isMultiSelectFilter) {
            setFilterValue([]);
            column.setFilterValue([]);
        } else if (isRangeFilter) {
            setFilterValue("");
            column.setFilterValue((old)=>{
                const newFilterValues = Array.isArray(old) && old || [
                    "",
                    ""
                ];
                newFilterValues[rangeFilterIndex] = undefined;
                return newFilterValues;
            });
        } else {
            setFilterValue("");
            column.setFilterValue(undefined);
        }
    };
    const handleClearEmptyFilterChip = ()=>{
        setFilterValue("");
        column.setFilterValue(undefined);
        setColumnFilterFns((prev)=>{
            var _a;
            return Object.assign(Object.assign({}, prev), {
                [header.id]: (_a = allowedColumnFilterOptions === null || allowedColumnFilterOptions === void 0 ? void 0 : allowedColumnFilterOptions[0]) !== null && _a !== void 0 ? _a : "fuzzy"
            });
        });
    };
    const handleFilterMenuOpen = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const isMounted = (0, $exYeM.useRef)(false);
    (0, $exYeM.useEffect)(()=>{
        if (isMounted.current) {
            const filterValue = column.getFilterValue();
            if (filterValue === undefined) handleClear();
            else if (isRangeFilter && rangeFilterIndex !== undefined) setFilterValue(filterValue[rangeFilterIndex]);
            else setFilterValue(filterValue);
        }
        isMounted.current = true;
    }, [
        column.getFilterValue()
    ]);
    if (columnDef.Filter) return (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: (_g = columnDef.Filter) === null || _g === void 0 ? void 0 : _g.call(columnDef, {
            column: column,
            header: header,
            rangeFilterIndex: rangeFilterIndex,
            table: table
        })
    });
    const endAdornment = !isAutocompleteFilter && !isDateFilter && !filterChipLabel ? (0, $aSiaI.jsx)((0, $60f459c5525ea035$export$2e2bcd8739ae039), {
        position: "end",
        sx: {
            mr: isSelectFilter || isMultiSelectFilter ? "20px" : undefined
        },
        children: (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), {
            placement: "right",
            title: (_h = localization.clearFilter) !== null && _h !== void 0 ? _h : "",
            children: (0, $aSiaI.jsx)("span", {
                children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), {
                    "aria-label": localization.clearFilter,
                    disabled: !((_j = filterValue === null || filterValue === void 0 ? void 0 : filterValue.toString()) === null || _j === void 0 ? void 0 : _j.length),
                    onClick: handleClear,
                    size: "small",
                    sx: {
                        height: "2rem",
                        transform: "scale(0.9)",
                        width: "2rem"
                    },
                    children: (0, $aSiaI.jsx)(CloseIcon, {})
                })
            })
        })
    }) : null;
    const startAdornment = showChangeModeButton ? (0, $aSiaI.jsxs)((0, $60f459c5525ea035$export$2e2bcd8739ae039), {
        position: "start",
        children: [
            (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), {
                title: localization.changeFilterMode,
                children: (0, $aSiaI.jsx)("span", {
                    children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), {
                        "aria-label": localization.changeFilterMode,
                        onClick: handleFilterMenuOpen,
                        size: "small",
                        sx: {
                            height: "1.75rem",
                            width: "1.75rem"
                        },
                        children: (0, $aSiaI.jsx)(FilterListIcon, {})
                    })
                })
            }),
            filterChipLabel && (0, $aSiaI.jsx)((0, $8b19ed05d27c6095$export$2e2bcd8739ae039), {
                label: filterChipLabel,
                onDelete: handleClearEmptyFilterChip
            })
        ]
    }) : null;
    const commonTextFieldProps = Object.assign(Object.assign({
        FormHelperTextProps: {
            sx: {
                fontSize: "0.75rem",
                lineHeight: "0.8rem",
                whiteSpace: "nowrap"
            }
        },
        InputProps: endAdornment //hack because mui looks for presence of endAdornment key instead of undefined
         ? {
            endAdornment: endAdornment,
            startAdornment: startAdornment
        } : {
            startAdornment: startAdornment
        },
        fullWidth: true,
        helperText: showChangeModeButton ? (0, $aSiaI.jsx)("label", {
            children: localization.filterMode.replace("{filterType}", // @ts-ignore
            localization[`filter${((_k = currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.charAt(0)) === null || _k === void 0 ? void 0 : _k.toUpperCase()) + (currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.slice(1))}`])
        }) : null,
        inputProps: {
            "aria-label": filterPlaceholder,
            autoComplete: "new-password",
            disabled: !!filterChipLabel,
            sx: {
                textOverflow: "ellipsis",
                width: filterChipLabel ? 0 : undefined
            },
            title: filterPlaceholder
        },
        inputRef: (inputRef)=>{
            filterInputRefs.current[`${column.id}-${rangeFilterIndex !== null && rangeFilterIndex !== void 0 ? rangeFilterIndex : 0}`] = inputRef;
            if (textFieldProps.inputRef) textFieldProps.inputRef = inputRef;
        },
        margin: "none",
        placeholder: filterChipLabel || isSelectFilter || isMultiSelectFilter ? undefined : filterPlaceholder,
        variant: "standard"
    }, textFieldProps), {
        sx: (theme)=>Object.assign({
                minWidth: isDateFilter ? "160px" : enableColumnFilterModes && rangeFilterIndex === 0 ? "110px" : isRangeFilter ? "100px" : !filterChipLabel ? "120px" : "auto",
                mx: "-2px",
                p: 0,
                width: "calc(100% + 4px)"
            }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.sx, theme))
    });
    const commonDatePickerProps = {
        onChange: (newDate)=>{
            handleChange(newDate);
        },
        value: filterValue || null
    };
    return (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            (filterVariant === null || filterVariant === void 0 ? void 0 : filterVariant.startsWith("time")) ? (0, $aSiaI.jsx)((0, $d8b0b6b29e8c007d$export$5f876910ea565cd3), Object.assign({}, commonDatePickerProps, timePickerProps, {
                slotProps: {
                    field: Object.assign({
                        clearable: true,
                        onClear: ()=>handleClear()
                    }, (_l = timePickerProps === null || timePickerProps === void 0 ? void 0 : timePickerProps.slotProps) === null || _l === void 0 ? void 0 : _l.field),
                    textField: Object.assign(Object.assign({}, commonTextFieldProps), (_m = timePickerProps === null || timePickerProps === void 0 ? void 0 : timePickerProps.slotProps) === null || _m === void 0 ? void 0 : _m.textField)
                }
            })) : (filterVariant === null || filterVariant === void 0 ? void 0 : filterVariant.startsWith("datetime")) ? (0, $aSiaI.jsx)((0, $a498d00daced0ec6$export$ccdfd7928785632e), Object.assign({}, commonDatePickerProps, dateTimePickerProps, {
                slotProps: {
                    field: Object.assign({
                        clearable: true,
                        onClear: ()=>handleClear()
                    }, (_o = dateTimePickerProps === null || dateTimePickerProps === void 0 ? void 0 : dateTimePickerProps.slotProps) === null || _o === void 0 ? void 0 : _o.field),
                    textField: Object.assign(Object.assign({}, commonTextFieldProps), (_p = dateTimePickerProps === null || dateTimePickerProps === void 0 ? void 0 : dateTimePickerProps.slotProps) === null || _p === void 0 ? void 0 : _p.textField)
                }
            })) : (filterVariant === null || filterVariant === void 0 ? void 0 : filterVariant.startsWith("date")) ? (0, $aSiaI.jsx)((0, $989344a514e036e4$export$5109c6dd95d8fb00), Object.assign({}, commonDatePickerProps, datePickerProps, {
                slotProps: {
                    field: Object.assign({
                        clearable: true,
                        onClear: ()=>handleClear()
                    }, (_q = datePickerProps === null || datePickerProps === void 0 ? void 0 : datePickerProps.slotProps) === null || _q === void 0 ? void 0 : _q.field),
                    textField: Object.assign(Object.assign({}, commonTextFieldProps), (_r = datePickerProps === null || datePickerProps === void 0 ? void 0 : datePickerProps.slotProps) === null || _r === void 0 ? void 0 : _r.textField)
                }
            })) : isAutocompleteFilter ? (0, $aSiaI.jsx)((0, $a1a2ecef81af22aa$export$2e2bcd8739ae039), Object.assign({
                freeSolo: true,
                getOptionLabel: (option)=>$35fd956d2f1c2be7$var$getValueAndLabel(option).label,
                onChange: (_e, newValue)=>handleAutocompleteChange(newValue),
                options: (_s = dropdownOptions === null || dropdownOptions === void 0 ? void 0 : dropdownOptions.map((option)=>$35fd956d2f1c2be7$var$getValueAndLabel(option))) !== null && _s !== void 0 ? _s : []
            }, autocompleteProps, {
                renderInput: (builtinTextFieldProps)=>{
                    var _a;
                    return (0, $aSiaI.jsx)((0, $18a733eef46a7fb6$export$2e2bcd8739ae039), Object.assign({}, builtinTextFieldProps, commonTextFieldProps, {
                        InputProps: Object.assign(Object.assign({}, builtinTextFieldProps.InputProps), {
                            startAdornment: (_a = commonTextFieldProps === null || commonTextFieldProps === void 0 ? void 0 : commonTextFieldProps.InputProps) === null || _a === void 0 ? void 0 : _a.startAdornment
                        }),
                        inputProps: Object.assign(Object.assign({}, builtinTextFieldProps.inputProps), commonTextFieldProps === null || commonTextFieldProps === void 0 ? void 0 : commonTextFieldProps.inputProps),
                        onChange: handleTextFieldChange,
                        onClick: (e)=>e.stopPropagation()
                    }));
                },
                value: autocompleteValue
            })) : (0, $aSiaI.jsx)((0, $18a733eef46a7fb6$export$2e2bcd8739ae039), Object.assign({
                select: isSelectFilter || isMultiSelectFilter
            }, commonTextFieldProps, {
                SelectProps: Object.assign({
                    MenuProps: {
                        disableScrollLock: true
                    },
                    displayEmpty: true,
                    multiple: isMultiSelectFilter,
                    renderValue: isMultiSelectFilter ? (selected)=>!(selected === null || selected === void 0 ? void 0 : selected.length) ? (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                            sx: {
                                opacity: 0.5
                            },
                            children: filterPlaceholder
                        }) : (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                            sx: {
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "2px"
                            },
                            children: selected === null || selected === void 0 ? void 0 : selected.map((value)=>{
                                const selectedValue = dropdownOptions === null || dropdownOptions === void 0 ? void 0 : dropdownOptions.find((option)=>$35fd956d2f1c2be7$var$getValueAndLabel(option).value === value);
                                return (0, $aSiaI.jsx)((0, $8b19ed05d27c6095$export$2e2bcd8739ae039), {
                                    label: $35fd956d2f1c2be7$var$getValueAndLabel(selectedValue).label
                                }, value);
                            })
                        }) : undefined
                }, commonTextFieldProps.SelectProps),
                onChange: handleTextFieldChange,
                onClick: (e)=>e.stopPropagation(),
                value: filterValue !== null && filterValue !== void 0 ? filterValue : "",
                children: (isSelectFilter || isMultiSelectFilter) && [
                    (0, $aSiaI.jsx)((0, $32731aa3cf1ce086$export$2e2bcd8739ae039), {
                        disabled: true,
                        divider: true,
                        hidden: true,
                        value: "",
                        children: (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                            sx: {
                                opacity: 0.5
                            },
                            children: filterPlaceholder
                        })
                    }, "p"),
                    (_t = textFieldProps.children) !== null && _t !== void 0 ? _t : dropdownOptions === null || dropdownOptions === void 0 ? void 0 : dropdownOptions.map((option, index)=>{
                        var _a;
                        const { label: label, value: value } = $35fd956d2f1c2be7$var$getValueAndLabel(option);
                        return (0, $aSiaI.jsxs)((0, $32731aa3cf1ce086$export$2e2bcd8739ae039), {
                            sx: {
                                alignItems: "center",
                                display: "flex",
                                gap: "0.5rem",
                                m: 0
                            },
                            value: value,
                            children: [
                                isMultiSelectFilter && (0, $aSiaI.jsx)((0, $71e996631894f6ef$export$2e2bcd8739ae039), {
                                    checked: ((_a = column.getFilterValue()) !== null && _a !== void 0 ? _a : []).includes(value),
                                    sx: {
                                        mr: "0.5rem"
                                    }
                                }),
                                label,
                                " ",
                                !columnDef.filterSelectOptions && `(${facetedUniqueValues.get(value)})`
                            ]
                        }, `${index}-${value}`);
                    })
                ]
            })),
            (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$18f00246d050b1b5, {
                anchorEl: anchorEl,
                header: header,
                setAnchorEl: setAnchorEl,
                setFilterValue: setFilterValue,
                table: table
            })
        ]
    });
};
const $35fd956d2f1c2be7$export$1e9b1782b5a6d69d = (_a)=>{
    var { header: header, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "header",
        "table"
    ]);
    return (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), Object.assign({}, rest, {
        sx: (theme)=>Object.assign({
                display: "grid",
                gap: "1rem",
                gridTemplateColumns: "1fr 1fr"
            }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(rest === null || rest === void 0 ? void 0 : rest.sx, theme)),
        children: [
            0,
            1
        ].map((rangeFilterIndex)=>(0, $aSiaI.jsx)($35fd956d2f1c2be7$export$e1c058f1849202d3, {
                header: header,
                rangeFilterIndex: rangeFilterIndex,
                table: table
            }, rangeFilterIndex))
    }));
};
const $35fd956d2f1c2be7$export$d5ed6349259cb6f4 = (_a)=>{
    var _b, _c;
    var { header: header, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "header",
        "table"
    ]);
    const { options: { enableColumnFilterModes: enableColumnFilterModes, localization: localization, muiFilterSliderProps: muiFilterSliderProps }, refs: { filterInputRefs: filterInputRefs } } = table;
    const { column: column } = header;
    const { columnDef: columnDef } = column;
    const currentFilterOption = columnDef._filterFn;
    const showChangeModeButton = enableColumnFilterModes && columnDef.enableColumnFilterModes !== false;
    const sliderProps = Object.assign(Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiFilterSliderProps, {
        column: column,
        table: table
    })), $35fd956d2f1c2be7$var$parseFromValuesOrFunc(columnDef.muiFilterSliderProps, {
        column: column,
        table: table
    })), rest);
    let [min, max] = sliderProps.min !== undefined && sliderProps.max !== undefined ? [
        sliderProps.min,
        sliderProps.max
    ] : (_b = column.getFacetedMinMaxValues()) !== null && _b !== void 0 ? _b : [
        0,
        1
    ];
    //fix potential TanStack Table bugs where min or max is an array
    if (Array.isArray(min)) min = min[0];
    if (Array.isArray(max)) max = max[0];
    if (min === null) min = 0;
    if (max === null) max = 1;
    const [filterValues, setFilterValues] = (0, $exYeM.useState)([
        min,
        max
    ]);
    const columnFilterValue = column.getFilterValue();
    const isMounted = (0, $exYeM.useRef)(false);
    (0, $exYeM.useEffect)(()=>{
        if (isMounted.current) {
            if (columnFilterValue === undefined) setFilterValues([
                min,
                max
            ]);
            else if (Array.isArray(columnFilterValue)) setFilterValues(columnFilterValue);
        }
        isMounted.current = true;
    }, [
        columnFilterValue,
        min,
        max
    ]);
    return (0, $aSiaI.jsxs)((0, $e10e66deff206ed9$export$2e2bcd8739ae039), {
        children: [
            (0, $aSiaI.jsx)((0, $b4abdcb1f4222ad1$export$2e2bcd8739ae039), Object.assign({
                disableSwap: true,
                max: max,
                min: min,
                onChange: (_event, values)=>{
                    setFilterValues(values);
                },
                onChangeCommitted: (_event, value)=>{
                    if (Array.isArray(value)) {
                        if (value[0] <= min && value[1] >= max) //if the user has selected the entire range, remove the filter
                        column.setFilterValue(undefined);
                        else column.setFilterValue(value);
                    }
                },
                value: filterValues,
                valueLabelDisplay: "auto"
            }, sliderProps, {
                slotProps: {
                    input: {
                        ref: (node)=>{
                            var _a, _b;
                            if (node) {
                                filterInputRefs.current[`${column.id}-0`] = node;
                                // @ts-ignore
                                if ((_b = (_a = sliderProps === null || sliderProps === void 0 ? void 0 : sliderProps.slotProps) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.ref) //@ts-ignore
                                sliderProps.slotProps.input.ref = node;
                            }
                        }
                    }
                },
                sx: (theme)=>Object.assign({
                        m: "auto",
                        minWidth: `${column.getSize() - 50}px`,
                        mt: !showChangeModeButton ? "10px" : "6px",
                        px: "4px",
                        width: "calc(100% - 8px)"
                    }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(sliderProps === null || sliderProps === void 0 ? void 0 : sliderProps.sx, theme))
            })),
            showChangeModeButton ? (0, $aSiaI.jsx)((0, $68258577de0527c4$export$2e2bcd8739ae039), {
                sx: {
                    fontSize: "0.75rem",
                    lineHeight: "0.8rem",
                    m: "-3px -6px",
                    whiteSpace: "nowrap"
                },
                children: localization.filterMode.replace("{filterType}", // @ts-ignore
                localization[`filter${((_c = currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.charAt(0)) === null || _c === void 0 ? void 0 : _c.toUpperCase()) + (currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.slice(1))}`])
            }) : null
        ]
    });
};
const $35fd956d2f1c2be7$export$3ae86ee4cf52373f = (_a)=>{
    var { header: header, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "header",
        "table"
    ]);
    const { getState: getState, options: { columnFilterDisplayMode: columnFilterDisplayMode } } = table;
    const { showColumnFilters: showColumnFilters } = getState();
    const { column: column } = header;
    const { columnDef: columnDef } = column;
    const { isRangeFilter: isRangeFilter } = $35fd956d2f1c2be7$export$863d009b6baa6754({
        header: header,
        table: table
    });
    return (0, $aSiaI.jsx)((0, $8c4543c1f79a917c$export$2e2bcd8739ae039), Object.assign({
        in: showColumnFilters || columnFilterDisplayMode === "popover",
        mountOnEnter: true,
        unmountOnExit: true
    }, rest, {
        children: columnDef.filterVariant === "checkbox" ? (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$e7a491feaac9d2a4, {
            column: column,
            table: table
        }) : columnDef.filterVariant === "range-slider" ? (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$d5ed6349259cb6f4, {
            header: header,
            table: table
        }) : isRangeFilter ? (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$1e9b1782b5a6d69d, {
            header: header,
            table: table
        }) : (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$e1c058f1849202d3, {
            header: header,
            table: table
        })
    }));
};
const $35fd956d2f1c2be7$export$1ffffd9ac5d89606 = (_a)=>{
    var _b, _c;
    var { header: header, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "header",
        "table"
    ]);
    const { options: { columnFilterDisplayMode: columnFilterDisplayMode, icons: { FilterAltIcon: FilterAltIcon }, localization: localization }, refs: { filterInputRefs: filterInputRefs }, setShowColumnFilters: setShowColumnFilters } = table;
    const { column: column } = header;
    const { columnDef: columnDef } = column;
    const filterValue = column.getFilterValue();
    const [anchorEl, setAnchorEl] = (0, $exYeM.useState)(null);
    const { currentFilterOption: currentFilterOption, isMultiSelectFilter: isMultiSelectFilter, isRangeFilter: isRangeFilter, isSelectFilter: isSelectFilter } = $35fd956d2f1c2be7$export$863d009b6baa6754({
        header: header,
        table: table
    });
    const dropdownOptions = $35fd956d2f1c2be7$export$9530f32da83c3525({
        header: header,
        table: table
    });
    const getSelectLabel = (index)=>$35fd956d2f1c2be7$var$getValueAndLabel(dropdownOptions === null || dropdownOptions === void 0 ? void 0 : dropdownOptions.find((option)=>$35fd956d2f1c2be7$var$getValueAndLabel(option).value === (index !== undefined ? filterValue[index] : filterValue))).label;
    const isFilterActive = Array.isArray(filterValue) && filterValue.some(Boolean) || !!filterValue && !Array.isArray(filterValue);
    const filterTooltip = columnFilterDisplayMode === "popover" && !isFilterActive ? (_b = localization.filterByColumn) === null || _b === void 0 ? void 0 : _b.replace("{column}", String(columnDef.header)) : localization.filteringByColumn.replace("{column}", String(columnDef.header)).replace("{filterType}", currentFilterOption ? localization[`filter${((_c = currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.charAt(0)) === null || _c === void 0 ? void 0 : _c.toUpperCase()) + (currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.slice(1))}`] : "").replace("{filterValue}", `"${Array.isArray(filterValue) ? filterValue.map((value, index)=>isMultiSelectFilter ? getSelectLabel(index) : value).join(`" ${isRangeFilter ? localization.and : localization.or} "`) : isSelectFilter ? getSelectLabel() : filterValue}"`).replace('" "', "");
    return (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            (0, $aSiaI.jsx)((0, $0b476d905dd3781d$export$2e2bcd8739ae039), {
                in: columnFilterDisplayMode === "popover" || !!filterValue && !isRangeFilter || isRangeFilter && // @ts-ignore
                (!!(filterValue === null || filterValue === void 0 ? void 0 : filterValue[0]) || !!(filterValue === null || filterValue === void 0 ? void 0 : filterValue[1])),
                unmountOnExit: true,
                children: (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                    component: "span",
                    sx: {
                        flex: "0 0"
                    },
                    children: (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), {
                        placement: "top",
                        title: filterTooltip,
                        children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), Object.assign({
                            disableRipple: true,
                            onClick: (event)=>{
                                if (columnFilterDisplayMode === "popover") setAnchorEl(event.currentTarget);
                                else setShowColumnFilters(true);
                                queueMicrotask(()=>{
                                    var _a, _b, _c, _d;
                                    (_b = (_a = filterInputRefs.current[`${column.id}-0`]) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 || _b.call(_a);
                                    (_d = (_c = filterInputRefs.current[`${column.id}-0`]) === null || _c === void 0 ? void 0 : _c.select) === null || _d === void 0 || _d.call(_c);
                                });
                                event.stopPropagation();
                            },
                            size: "small"
                        }, rest, {
                            sx: (theme)=>Object.assign({
                                    height: "16px",
                                    ml: "4px",
                                    opacity: isFilterActive ? 1 : 0.3,
                                    p: "8px",
                                    transform: "scale(0.75)",
                                    transition: "all 150ms ease-in-out",
                                    width: "16px"
                                }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(rest === null || rest === void 0 ? void 0 : rest.sx, theme)),
                            children: (0, $aSiaI.jsx)(FilterAltIcon, {})
                        }))
                    })
                })
            }),
            columnFilterDisplayMode === "popover" && (0, $aSiaI.jsx)((0, $5864cf953251acd1$export$2e2bcd8739ae039), {
                anchorEl: anchorEl,
                anchorOrigin: {
                    horizontal: "center",
                    vertical: "top"
                },
                disableScrollLock: true,
                onClick: (event)=>event.stopPropagation(),
                onClose: (event)=>{
                    //@ts-ignore
                    event.stopPropagation();
                    setAnchorEl(null);
                },
                onKeyDown: (event)=>event.key === "Enter" && setAnchorEl(null),
                open: !!anchorEl,
                slotProps: {
                    paper: {
                        sx: {
                            overflow: "visible"
                        }
                    }
                },
                transformOrigin: {
                    horizontal: "center",
                    vertical: "bottom"
                },
                children: (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                    sx: {
                        p: "1rem"
                    },
                    children: (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$3ae86ee4cf52373f, {
                        header: header,
                        table: table
                    })
                })
            })
        ]
    });
};
const $35fd956d2f1c2be7$export$4ff1e496863b625 = (_a)=>{
    var { column: column, table: table, tableHeadCellRef: tableHeadCellRef } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "column",
        "table",
        "tableHeadCellRef"
    ]);
    const { getState: getState, options: { enableColumnOrdering: enableColumnOrdering, muiColumnDragHandleProps: muiColumnDragHandleProps }, setColumnOrder: setColumnOrder, setDraggingColumn: setDraggingColumn, setHoveredColumn: setHoveredColumn } = table;
    const { columnDef: columnDef } = column;
    const { columnOrder: columnOrder, draggingColumn: draggingColumn, hoveredColumn: hoveredColumn } = getState();
    const iconButtonProps = Object.assign(Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiColumnDragHandleProps, {
        column: column,
        table: table
    })), $35fd956d2f1c2be7$var$parseFromValuesOrFunc(columnDef.muiColumnDragHandleProps, {
        column: column,
        table: table
    })), rest);
    const handleDragStart = (event)=>{
        var _a;
        (_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onDragStart) === null || _a === void 0 || _a.call(iconButtonProps, event);
        setDraggingColumn(column);
        try {
            event.dataTransfer.setDragImage(tableHeadCellRef.current, 0, 0);
        } catch (e) {
            console.error(e);
        }
    };
    const handleDragEnd = (event)=>{
        var _a;
        (_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onDragEnd) === null || _a === void 0 || _a.call(iconButtonProps, event);
        if ((hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) === "drop-zone") column.toggleGrouping();
        else if (enableColumnOrdering && hoveredColumn && (hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) !== (draggingColumn === null || draggingColumn === void 0 ? void 0 : draggingColumn.id)) setColumnOrder($35fd956d2f1c2be7$export$4780246288fde46d(column, hoveredColumn, columnOrder));
        setDraggingColumn(null);
        setHoveredColumn(null);
    };
    return (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$84d0ca45a1213a16, Object.assign({}, iconButtonProps, {
        onDragEnd: handleDragEnd,
        onDragStart: handleDragStart,
        table: table
    }));
};
const $35fd956d2f1c2be7$export$662a9faa35dc5774 = (_a)=>{
    var _b;
    var { header: header, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "header",
        "table"
    ]);
    const { getState: getState, options: { columnResizeDirection: columnResizeDirection, columnResizeMode: columnResizeMode }, setColumnSizingInfo: setColumnSizingInfo } = table;
    const { density: density } = getState();
    const { column: column } = header;
    const handler = header.getResizeHandler();
    const mx = density === "compact" ? "-8px" : density === "comfortable" ? "-16px" : "-24px";
    const lr = column.columnDef.columnDefType === "display" ? "4px" : "0";
    return (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        className: "Mui-TableHeadCell-ResizeHandle-Wrapper",
        onDoubleClick: ()=>{
            setColumnSizingInfo((old)=>Object.assign(Object.assign({}, old), {
                    isResizingColumn: false
                }));
            column.resetSize();
        },
        onMouseDown: handler,
        onTouchStart: handler,
        style: {
            transform: column.getIsResizing() && columnResizeMode === "onEnd" ? `translateX(${(columnResizeDirection === "rtl" ? -1 : 1) * ((_b = getState().columnSizingInfo.deltaOffset) !== null && _b !== void 0 ? _b : 0)}px)` : undefined
        },
        sx: (theme)=>({
                "&:active > hr": {
                    backgroundColor: theme.palette.info.main,
                    opacity: header.subHeaders.length || columnResizeMode === "onEnd" ? 1 : 0
                },
                cursor: "col-resize",
                left: columnResizeDirection === "rtl" ? lr : undefined,
                ml: columnResizeDirection === "rtl" ? mx : undefined,
                mr: columnResizeDirection === "ltr" ? mx : undefined,
                position: "absolute",
                px: "4px",
                right: columnResizeDirection === "ltr" ? lr : undefined
            }),
        children: (0, $aSiaI.jsx)((0, $a59c125ed1ac1385$export$2e2bcd8739ae039), {
            className: "Mui-TableHeadCell-ResizeHandle-Divider",
            flexItem: true,
            orientation: "vertical",
            sx: (theme)=>Object.assign({
                    borderRadius: "2px",
                    borderWidth: "2px",
                    height: "24px",
                    touchAction: "none",
                    transform: "translateX(4px)",
                    transition: column.getIsResizing() ? undefined : "all 150ms ease-in-out",
                    userSelect: "none",
                    zIndex: 4
                }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(rest === null || rest === void 0 ? void 0 : rest.sx, theme))
        })
    });
};
const $35fd956d2f1c2be7$export$ecdc50c8501e977d = (_a)=>{
    var { header: header, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "header",
        "table"
    ]);
    const { getState: getState, options: { icons: { ArrowDownwardIcon: ArrowDownwardIcon, SyncAltIcon: SyncAltIcon }, localization: localization } } = table;
    const { column: column } = header;
    const { columnDef: columnDef } = column;
    const { isLoading: isLoading, showSkeletons: showSkeletons, sorting: sorting } = getState();
    const isSorted = !!column.getIsSorted();
    const sortTooltip = isLoading || showSkeletons ? "" : column.getIsSorted() ? column.getIsSorted() === "desc" ? localization.sortedByColumnDesc.replace("{column}", columnDef.header) : localization.sortedByColumnAsc.replace("{column}", columnDef.header) : column.getNextSortingOrder() === "desc" ? localization.sortByColumnDesc.replace("{column}", columnDef.header) : localization.sortByColumnAsc.replace("{column}", columnDef.header);
    const direction = isSorted ? column.getIsSorted() : undefined;
    return (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), {
        placement: "top",
        title: sortTooltip,
        children: (0, $aSiaI.jsx)((0, $d40123128680762a$export$2e2bcd8739ae039), {
            badgeContent: sorting.length > 1 ? column.getSortIndex() + 1 : 0,
            overlap: "circular",
            children: (0, $aSiaI.jsx)((0, $a9f2baef033a0713$export$2e2bcd8739ae039), Object.assign({
                IconComponent: !isSorted ? (props)=>(0, $aSiaI.jsx)(SyncAltIcon, Object.assign({}, props, {
                        direction: direction,
                        style: {
                            transform: "rotate(-90deg) scaleX(0.9) translateX(-1px)"
                        }
                    })) : ArrowDownwardIcon,
                active: true,
                "aria-label": sortTooltip,
                direction: direction,
                onClick: (e)=>{
                    var _a;
                    e.stopPropagation();
                    (_a = header.column.getToggleSortingHandler()) === null || _a === void 0 || _a(e);
                }
            }, rest, {
                sx: (theme)=>Object.assign({
                        ".MuiTableSortLabel-icon": {
                            color: `${theme.palette.mode === "dark" ? theme.palette.text.primary : theme.palette.text.secondary} !important`
                        },
                        flex: "0 0",
                        opacity: isSorted ? 1 : 0.3,
                        transition: "all 150ms ease-in-out",
                        width: "3ch"
                    }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(rest === null || rest === void 0 ? void 0 : rest.sx, theme))
            }))
        })
    });
};
const $35fd956d2f1c2be7$export$58dfb5ecb4044b03 = (_a)=>{
    var _b, _c, _d, _f, _g, _h;
    var { columnVirtualizer: columnVirtualizer, header: header, staticColumnIndex: staticColumnIndex, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "columnVirtualizer",
        "header",
        "staticColumnIndex",
        "table"
    ]);
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const { getState: getState, options: { columnFilterDisplayMode: columnFilterDisplayMode, columnResizeDirection: columnResizeDirection, columnResizeMode: columnResizeMode, enableColumnActions: enableColumnActions, enableColumnDragging: enableColumnDragging, enableColumnOrdering: enableColumnOrdering, enableColumnPinning: enableColumnPinning, enableGrouping: enableGrouping, enableMultiSort: enableMultiSort, layoutMode: layoutMode, mrtTheme: { draggingBorderColor: draggingBorderColor }, muiTableHeadCellProps: muiTableHeadCellProps }, refs: { tableHeadCellRefs: tableHeadCellRefs }, setHoveredColumn: setHoveredColumn } = table;
    const { columnSizingInfo: columnSizingInfo, density: density, draggingColumn: draggingColumn, grouping: grouping, hoveredColumn: hoveredColumn, showColumnFilters: showColumnFilters } = getState();
    const { column: column } = header;
    const { columnDef: columnDef } = column;
    const { columnDefType: columnDefType } = columnDef;
    const tableCellProps = Object.assign(Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiTableHeadCellProps, {
        column: column,
        table: table
    })), $35fd956d2f1c2be7$var$parseFromValuesOrFunc(columnDef.muiTableHeadCellProps, {
        column: column,
        table: table
    })), rest);
    const isColumnPinned = enableColumnPinning && columnDef.columnDefType !== "group" && column.getIsPinned();
    const showColumnActions = (enableColumnActions || columnDef.enableColumnActions) && columnDef.enableColumnActions !== false;
    const showDragHandle = enableColumnDragging !== false && columnDef.enableColumnDragging !== false && (enableColumnDragging || enableColumnOrdering && columnDef.enableColumnOrdering !== false || enableGrouping && columnDef.enableGrouping !== false && !grouping.includes(column.id));
    const headerPL = (0, $exYeM.useMemo)(()=>{
        let pl = 0;
        if (column.getCanSort()) pl += 1;
        if (showColumnActions) pl += 1.75;
        if (showDragHandle) pl += 1.5;
        return pl;
    }, [
        showColumnActions,
        showDragHandle
    ]);
    const draggingBorders = (0, $exYeM.useMemo)(()=>{
        const showResizeBorder = columnSizingInfo.isResizingColumn === column.id && columnResizeMode === "onChange" && !header.subHeaders.length;
        const borderStyle = showResizeBorder ? `2px solid ${draggingBorderColor} !important` : (draggingColumn === null || draggingColumn === void 0 ? void 0 : draggingColumn.id) === column.id ? `1px dashed ${theme.palette.grey[500]}` : (hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) === column.id ? `2px dashed ${draggingBorderColor}` : undefined;
        if (showResizeBorder) return columnResizeDirection === "ltr" ? {
            borderRight: borderStyle
        } : {
            borderLeft: borderStyle
        };
        const draggingBorders = borderStyle ? {
            borderLeft: borderStyle,
            borderRight: borderStyle,
            borderTop: borderStyle
        } : undefined;
        return draggingBorders;
    }, [
        draggingColumn,
        hoveredColumn,
        columnSizingInfo.isResizingColumn
    ]);
    const handleDragEnter = (_e)=>{
        if (enableGrouping && (hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) === "drop-zone") setHoveredColumn(null);
        if (enableColumnOrdering && draggingColumn && columnDefType !== "group") setHoveredColumn(columnDef.enableColumnOrdering !== false ? column : null);
    };
    const handleDragOver = (e)=>{
        if (columnDef.enableColumnOrdering !== false) e.preventDefault();
    };
    const HeaderElement = (_b = $35fd956d2f1c2be7$var$parseFromValuesOrFunc(columnDef.Header, {
        column: column,
        header: header,
        table: table
    })) !== null && _b !== void 0 ? _b : columnDef.header;
    return (0, $aSiaI.jsxs)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), Object.assign({
        align: columnDefType === "group" ? "center" : theme.direction === "rtl" ? "right" : "left",
        colSpan: header.colSpan,
        "data-index": staticColumnIndex,
        "data-pinned": !!isColumnPinned || undefined,
        onDragEnter: handleDragEnter,
        onDragOver: handleDragOver,
        ref: (node)=>{
            var _a;
            if (node) {
                tableHeadCellRefs.current[column.id] = node;
                if (columnDefType !== "group") (_a = columnVirtualizer === null || columnVirtualizer === void 0 ? void 0 : columnVirtualizer.measureElement) === null || _a === void 0 || _a.call(columnVirtualizer, node);
            }
        }
    }, tableCellProps, {
        sx: (theme)=>Object.assign(Object.assign({
                "& :hover": {
                    ".MuiButtonBase-root": {
                        opacity: 1
                    }
                },
                flexDirection: (layoutMode === null || layoutMode === void 0 ? void 0 : layoutMode.startsWith("grid")) ? "column" : undefined,
                fontWeight: "bold",
                overflow: "visible",
                p: density === "compact" ? "0.5rem" : density === "comfortable" ? columnDefType === "display" ? "0.75rem" : "1rem" : columnDefType === "display" ? "1rem 1.25rem" : "1.5rem",
                pb: columnDefType === "display" ? 0 : showColumnFilters || density === "compact" ? "0.4rem" : "0.6rem",
                pt: columnDefType === "group" || density === "compact" ? "0.25rem" : density === "comfortable" ? ".75rem" : "1.25rem",
                userSelect: enableMultiSort && column.getCanSort() ? "none" : undefined,
                verticalAlign: "top"
            }, $35fd956d2f1c2be7$var$getCommonMRTCellStyles({
                column: column,
                header: header,
                table: table,
                tableCellProps: tableCellProps,
                theme: theme
            })), draggingBorders),
        children: [
            header.isPlaceholder ? null : (_c = tableCellProps.children) !== null && _c !== void 0 ? _c : (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                className: "Mui-TableHeadCell-Content",
                sx: {
                    alignItems: "center",
                    display: "flex",
                    flexDirection: (tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.align) === "right" ? "row-reverse" : "row",
                    justifyContent: columnDefType === "group" || (tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.align) === "center" ? "center" : column.getCanResize() ? "space-between" : "flex-start",
                    position: "relative",
                    width: "100%"
                },
                children: [
                    (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                        className: "Mui-TableHeadCell-Content-Labels",
                        onClick: column.getToggleSortingHandler(),
                        sx: {
                            alignItems: "center",
                            cursor: column.getCanSort() && columnDefType !== "group" ? "pointer" : undefined,
                            display: "flex",
                            flexDirection: (tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.align) === "right" ? "row-reverse" : "row",
                            overflow: columnDefType === "data" ? "hidden" : undefined,
                            pl: (tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.align) === "center" ? `${headerPL}rem` : undefined
                        },
                        children: [
                            (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                                className: "Mui-TableHeadCell-Content-Wrapper",
                                sx: {
                                    "&:hover": {
                                        textOverflow: "clip"
                                    },
                                    minWidth: `${Math.min((_f = (_d = columnDef.header) === null || _d === void 0 ? void 0 : _d.length) !== null && _f !== void 0 ? _f : 0, 4)}ch`,
                                    overflow: columnDefType === "data" ? "hidden" : undefined,
                                    textOverflow: "ellipsis",
                                    whiteSpace: ((_h = (_g = columnDef.header) === null || _g === void 0 ? void 0 : _g.length) !== null && _h !== void 0 ? _h : 0) < 20 ? "nowrap" : "normal"
                                },
                                children: HeaderElement
                            }),
                            column.getCanFilter() && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$1ffffd9ac5d89606, {
                                header: header,
                                table: table
                            }),
                            column.getCanSort() && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$ecdc50c8501e977d, {
                                header: header,
                                table: table
                            })
                        ]
                    }),
                    columnDefType !== "group" && (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                        className: "Mui-TableHeadCell-Content-Actions",
                        sx: {
                            whiteSpace: "nowrap"
                        },
                        children: [
                            showDragHandle && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$4ff1e496863b625, {
                                column: column,
                                table: table,
                                tableHeadCellRef: {
                                    current: tableHeadCellRefs.current[column.id]
                                }
                            }),
                            showColumnActions && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$b039aa2e7eefde50, {
                                header: header,
                                table: table
                            })
                        ]
                    }),
                    column.getCanResize() && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$662a9faa35dc5774, {
                        header: header,
                        table: table
                    })
                ]
            }),
            columnFilterDisplayMode === "subheader" && column.getCanFilter() && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$3ae86ee4cf52373f, {
                header: header,
                table: table
            })
        ]
    }));
};
const $35fd956d2f1c2be7$export$679998a3ded370a1 = (_a)=>{
    var { columnVirtualizer: columnVirtualizer, headerGroup: headerGroup, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "columnVirtualizer",
        "headerGroup",
        "table"
    ]);
    const { options: { enableStickyHeader: enableStickyHeader, layoutMode: layoutMode, mrtTheme: { baseBackgroundColor: baseBackgroundColor }, muiTableHeadRowProps: muiTableHeadRowProps } } = table;
    const { virtualColumns: virtualColumns, virtualPaddingLeft: virtualPaddingLeft, virtualPaddingRight: virtualPaddingRight } = columnVirtualizer !== null && columnVirtualizer !== void 0 ? columnVirtualizer : {};
    const tableRowProps = Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiTableHeadRowProps, {
        headerGroup: headerGroup,
        table: table
    })), rest);
    return (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), Object.assign({}, tableRowProps, {
        sx: (theme)=>Object.assign({
                backgroundColor: baseBackgroundColor,
                boxShadow: `4px 0 8px ${(0, $69eec9e6c105674b$export$58f0f39f63f3cf42)(theme.palette.common.black, 0.1)}`,
                display: (layoutMode === null || layoutMode === void 0 ? void 0 : layoutMode.startsWith("grid")) ? "flex" : undefined,
                position: enableStickyHeader && layoutMode === "semantic" ? "sticky" : "relative",
                top: 0
            }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx, theme)),
        children: [
            virtualPaddingLeft ? (0, $aSiaI.jsx)("th", {
                style: {
                    display: "flex",
                    width: virtualPaddingLeft
                }
            }) : null,
            (virtualColumns !== null && virtualColumns !== void 0 ? virtualColumns : headerGroup.headers).map((headerOrVirtualHeader, staticColumnIndex)=>{
                let header = headerOrVirtualHeader;
                if (columnVirtualizer) {
                    staticColumnIndex = headerOrVirtualHeader.index;
                    header = headerGroup.headers[staticColumnIndex];
                }
                return header ? (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$58dfb5ecb4044b03, {
                    columnVirtualizer: columnVirtualizer,
                    header: header,
                    staticColumnIndex: staticColumnIndex,
                    table: table
                }, header.id) : null;
            }),
            virtualPaddingRight ? (0, $aSiaI.jsx)("th", {
                style: {
                    display: "flex",
                    width: virtualPaddingRight
                }
            }) : null
        ]
    }));
};
const $35fd956d2f1c2be7$export$182b9e76a987279b = (_a)=>{
    var _b, _c, _d;
    var { stackAlertBanner: stackAlertBanner, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "stackAlertBanner",
        "table"
    ]);
    const { getFilteredSelectedRowModel: getFilteredSelectedRowModel, getPrePaginationRowModel: getPrePaginationRowModel, getState: getState, options: { enableRowSelection: enableRowSelection, enableSelectAll: enableSelectAll, localization: localization, manualPagination: manualPagination, muiToolbarAlertBannerChipProps: muiToolbarAlertBannerChipProps, muiToolbarAlertBannerProps: muiToolbarAlertBannerProps, positionToolbarAlertBanner: positionToolbarAlertBanner, renderToolbarAlertBannerContent: renderToolbarAlertBannerContent, rowCount: rowCount }, refs: { tablePaperRef: tablePaperRef } } = table;
    const { density: density, grouping: grouping, rowSelection: rowSelection, showAlertBanner: showAlertBanner } = getState();
    const alertProps = Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiToolbarAlertBannerProps, {
        table: table
    })), rest);
    const chipProps = $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiToolbarAlertBannerChipProps, {
        table: table
    });
    const totalRowCount = rowCount !== null && rowCount !== void 0 ? rowCount : getPrePaginationRowModel().flatRows.length;
    const selectedRowCount = (0, $exYeM.useMemo)(()=>manualPagination ? Object.values(rowSelection).filter(Boolean).length : getFilteredSelectedRowModel().rows.length, [
        rowSelection,
        totalRowCount,
        manualPagination
    ]);
    const selectedAlert = selectedRowCount > 0 ? (0, $aSiaI.jsxs)((0, $e10e66deff206ed9$export$2e2bcd8739ae039), {
        alignItems: "center",
        direction: "row",
        gap: "16px",
        children: [
            (_c = (_b = localization.selectedCountOfRowCountRowsSelected) === null || _b === void 0 ? void 0 : _b.replace("{selectedCount}", selectedRowCount.toLocaleString())) === null || _c === void 0 ? void 0 : _c.replace("{rowCount}", totalRowCount.toString()),
            (0, $aSiaI.jsx)((0, $980dfff3cab72cf4$export$2e2bcd8739ae039), {
                onClick: (event)=>$35fd956d2f1c2be7$export$971e27a1f984fd93({
                        table: table
                    })(event, false, true),
                size: "small",
                sx: {
                    p: "2px"
                },
                children: localization.clearSelection
            })
        ]
    }) : null;
    const groupedAlert = grouping.length > 0 ? (0, $aSiaI.jsxs)("span", {
        children: [
            localization.groupedBy,
            " ",
            grouping.map((columnId, index)=>(0, $aSiaI.jsxs)((0, $exYeM.Fragment), {
                    children: [
                        index > 0 ? localization.thenBy : "",
                        (0, $aSiaI.jsx)((0, $8b19ed05d27c6095$export$2e2bcd8739ae039), Object.assign({
                            label: table.getColumn(columnId).columnDef.header,
                            onDelete: ()=>table.getColumn(columnId).toggleGrouping()
                        }, chipProps))
                    ]
                }, `${index}-${columnId}`))
        ]
    }) : null;
    return (0, $aSiaI.jsx)((0, $8c4543c1f79a917c$export$2e2bcd8739ae039), {
        in: showAlertBanner || !!selectedAlert || !!groupedAlert,
        timeout: stackAlertBanner ? 200 : 0,
        children: (0, $aSiaI.jsx)((0, $e85329076f56f45f$export$2e2bcd8739ae039), Object.assign({
            color: "info",
            icon: false
        }, alertProps, {
            sx: (theme)=>{
                var _a, _b;
                return Object.assign({
                    "& .MuiAlert-message": {
                        maxWidth: `calc(${(_b = (_a = tablePaperRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 360}px - 1rem)`,
                        width: "100%"
                    },
                    borderRadius: 0,
                    fontSize: "1rem",
                    left: 0,
                    mb: stackAlertBanner ? 0 : positionToolbarAlertBanner === "bottom" ? "-1rem" : undefined,
                    p: 0,
                    position: "relative",
                    right: 0,
                    top: 0,
                    width: "100%",
                    zIndex: 2
                }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(alertProps === null || alertProps === void 0 ? void 0 : alertProps.sx, theme));
            },
            children: (_d = renderToolbarAlertBannerContent === null || renderToolbarAlertBannerContent === void 0 ? void 0 : renderToolbarAlertBannerContent({
                groupedAlert: groupedAlert,
                selectedAlert: selectedAlert,
                table: table
            })) !== null && _d !== void 0 ? _d : (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                children: [
                    (alertProps === null || alertProps === void 0 ? void 0 : alertProps.title) && (0, $aSiaI.jsx)((0, $6adb5c54f2023788$export$2e2bcd8739ae039), {
                        children: alertProps.title
                    }),
                    (0, $aSiaI.jsxs)((0, $e10e66deff206ed9$export$2e2bcd8739ae039), {
                        sx: {
                            p: positionToolbarAlertBanner !== "head-overlay" ? "0.5rem 1rem" : density === "spacious" ? "0.75rem 1.25rem" : density === "comfortable" ? "0.5rem 0.75rem" : "0.25rem 0.5rem"
                        },
                        children: [
                            alertProps === null || alertProps === void 0 ? void 0 : alertProps.children,
                            (alertProps === null || alertProps === void 0 ? void 0 : alertProps.children) && (selectedAlert || groupedAlert) && (0, $aSiaI.jsx)("br", {}),
                            (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                                sx: {
                                    display: "flex"
                                },
                                children: [
                                    enableRowSelection && enableSelectAll && positionToolbarAlertBanner === "head-overlay" && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$85257578ef187ebd, {
                                        table: table
                                    }),
                                    " ",
                                    selectedAlert
                                ]
                            }),
                            selectedAlert && groupedAlert && (0, $aSiaI.jsx)("br", {}),
                            groupedAlert
                        ]
                    })
                ]
            })
        }))
    });
};
const $35fd956d2f1c2be7$export$5fbb3e9ceda46108 = (_a)=>{
    var { columnVirtualizer: columnVirtualizer, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "columnVirtualizer",
        "table"
    ]);
    const { getState: getState, options: { enableStickyHeader: enableStickyHeader, layoutMode: layoutMode, muiTableHeadProps: muiTableHeadProps, positionToolbarAlertBanner: positionToolbarAlertBanner }, refs: { tableHeadRef: tableHeadRef } } = table;
    const { isFullScreen: isFullScreen, showAlertBanner: showAlertBanner } = getState();
    const tableHeadProps = Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiTableHeadProps, {
        table: table
    })), rest);
    const stickyHeader = enableStickyHeader || isFullScreen;
    return (0, $aSiaI.jsx)((0, $44d2089cb08aa78c$export$2e2bcd8739ae039), Object.assign({}, tableHeadProps, {
        ref: (ref)=>{
            tableHeadRef.current = ref;
            if (tableHeadProps === null || tableHeadProps === void 0 ? void 0 : tableHeadProps.ref) // @ts-ignore
            tableHeadProps.ref.current = ref;
        },
        sx: (theme)=>Object.assign({
                display: (layoutMode === null || layoutMode === void 0 ? void 0 : layoutMode.startsWith("grid")) ? "grid" : undefined,
                opacity: 0.97,
                position: stickyHeader ? "sticky" : "relative",
                top: stickyHeader && (layoutMode === null || layoutMode === void 0 ? void 0 : layoutMode.startsWith("grid")) ? 0 : undefined,
                zIndex: stickyHeader ? 2 : undefined
            }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(tableHeadProps === null || tableHeadProps === void 0 ? void 0 : tableHeadProps.sx, theme)),
        children: positionToolbarAlertBanner === "head-overlay" && (showAlertBanner || table.getSelectedRowModel().rows.length > 0) ? (0, $aSiaI.jsx)("tr", {
            style: {
                display: (layoutMode === null || layoutMode === void 0 ? void 0 : layoutMode.startsWith("grid")) ? "grid" : undefined
            },
            children: (0, $aSiaI.jsx)("th", {
                colSpan: table.getVisibleLeafColumns().length,
                style: {
                    display: (layoutMode === null || layoutMode === void 0 ? void 0 : layoutMode.startsWith("grid")) ? "grid" : undefined,
                    padding: 0
                },
                children: (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$182b9e76a987279b, {
                    table: table
                })
            })
        }) : table.getHeaderGroups().map((headerGroup)=>(0, $aSiaI.jsx)($35fd956d2f1c2be7$export$679998a3ded370a1, {
                columnVirtualizer: columnVirtualizer,
                headerGroup: headerGroup,
                table: table
            }, headerGroup.id))
    }));
};
const $35fd956d2f1c2be7$export$b1ae1cbdfc1ba774 = (_a)=>{
    var { table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "table"
    ]);
    const { getFlatHeaders: getFlatHeaders, getState: getState, options: { columns: columns, enableStickyHeader: enableStickyHeader, enableTableFooter: enableTableFooter, enableTableHead: enableTableHead, layoutMode: layoutMode, memoMode: memoMode, muiTableProps: muiTableProps, renderCaption: renderCaption } } = table;
    const { columnSizing: columnSizing, columnSizingInfo: columnSizingInfo, columnVisibility: columnVisibility, isFullScreen: isFullScreen } = getState();
    const tableProps = Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiTableProps, {
        table: table
    })), rest);
    const Caption = $35fd956d2f1c2be7$var$parseFromValuesOrFunc(renderCaption, {
        table: table
    });
    const columnSizeVars = (0, $exYeM.useMemo)(()=>{
        const headers = getFlatHeaders();
        const colSizes = {};
        for(let i = 0; i < headers.length; i++){
            const header = headers[i];
            const colSize = header.getSize();
            colSizes[`--header-${$35fd956d2f1c2be7$var$parseCSSVarId(header.id)}-size`] = colSize;
            colSizes[`--col-${$35fd956d2f1c2be7$var$parseCSSVarId(header.column.id)}-size`] = colSize;
        }
        return colSizes;
    }, [
        columns,
        columnSizing,
        columnSizingInfo,
        columnVisibility
    ]);
    const columnVirtualizer = $35fd956d2f1c2be7$export$98280022443b09bb(table);
    const commonTableGroupProps = {
        columnVirtualizer: columnVirtualizer,
        table: table
    };
    return (0, $aSiaI.jsxs)((0, $f486dbc13fd8431d$export$2e2bcd8739ae039), Object.assign({
        stickyHeader: enableStickyHeader || isFullScreen
    }, tableProps, {
        style: Object.assign(Object.assign({}, columnSizeVars), tableProps === null || tableProps === void 0 ? void 0 : tableProps.style),
        sx: (theme)=>Object.assign({
                borderCollapse: "separate",
                display: (layoutMode === null || layoutMode === void 0 ? void 0 : layoutMode.startsWith("grid")) ? "grid" : undefined,
                position: "relative"
            }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(tableProps === null || tableProps === void 0 ? void 0 : tableProps.sx, theme)),
        children: [
            !!Caption && (0, $aSiaI.jsx)("caption", {
                children: Caption
            }),
            enableTableHead && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$5fbb3e9ceda46108, Object.assign({}, commonTableGroupProps)),
            memoMode === "table-body" || columnSizingInfo.isResizingColumn ? (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$8cd7047d2b3fdfcd, Object.assign({}, commonTableGroupProps)) : (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$5e55a092910f42e9, Object.assign({}, commonTableGroupProps)),
            enableTableFooter && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$84b7086891079f4e, Object.assign({}, commonTableGroupProps))
        ]
    }));
};
const $35fd956d2f1c2be7$export$66d8efa8cc5f6f7 = (_a)=>{
    var _b;
    var { table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "table"
    ]);
    const { options: { localization: localization, mrtTheme: { baseBackgroundColor: baseBackgroundColor }, muiCircularProgressProps: muiCircularProgressProps } } = table;
    const circularProgressProps = Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiCircularProgressProps, {
        table: table
    })), rest);
    return (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        sx: {
            alignItems: "center",
            backgroundColor: (0, $69eec9e6c105674b$export$58f0f39f63f3cf42)(baseBackgroundColor, 0.5),
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            left: 0,
            maxHeight: "100vh",
            position: "absolute",
            right: 0,
            top: 0,
            width: "100%",
            zIndex: 3
        },
        children: (_b = circularProgressProps === null || circularProgressProps === void 0 ? void 0 : circularProgressProps.Component) !== null && _b !== void 0 ? _b : (0, $aSiaI.jsx)((0, $8a947ac56b8361c3$export$2e2bcd8739ae039), Object.assign({
            "aria-label": localization.noRecordsToDisplay,
            id: "mrt-progress"
        }, circularProgressProps))
    });
};
const $35fd956d2f1c2be7$var$MRT_CellActionMenu = (_a)=>{
    var _b, _c;
    var { table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "table"
    ]);
    const { getState: getState, options: { editDisplayMode: editDisplayMode, enableClickToCopy: enableClickToCopy, enableEditing: enableEditing, icons: { ContentCopy: ContentCopy, EditIcon: EditIcon }, localization: localization, mrtTheme: { menuBackgroundColor: menuBackgroundColor }, renderCellActionMenuItems: renderCellActionMenuItems }, refs: { actionCellRef: actionCellRef } } = table;
    const { actionCell: actionCell, density: density } = getState();
    const cell = actionCell;
    const { row: row } = cell;
    const { column: column } = cell;
    const { columnDef: columnDef } = column;
    const handleClose = (event)=>{
        event === null || event === void 0 || event.stopPropagation();
        table.setActionCell(null);
        actionCellRef.current = null;
    };
    const internalMenuItems = [
        ($35fd956d2f1c2be7$var$parseFromValuesOrFunc(enableClickToCopy, cell) === "context-menu" || $35fd956d2f1c2be7$var$parseFromValuesOrFunc(columnDef.enableClickToCopy, cell) === "context-menu") && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$7a47075d9547bd75, {
            icon: (0, $aSiaI.jsx)(ContentCopy, {}),
            label: localization.copy,
            onClick: (event)=>{
                event.stopPropagation();
                navigator.clipboard.writeText(cell.getValue());
                handleClose();
            },
            table: table
        }, "mrt-copy"),
        $35fd956d2f1c2be7$var$parseFromValuesOrFunc(enableEditing, row) && editDisplayMode === "cell" && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$7a47075d9547bd75, {
            icon: (0, $aSiaI.jsx)(EditIcon, {}),
            label: localization.edit,
            onClick: ()=>{
                $35fd956d2f1c2be7$export$250fde3c71e02f70({
                    cell: cell,
                    table: table
                });
                handleClose();
            },
            table: table
        }, "mrt-edit")
    ].filter(Boolean);
    const renderActionProps = {
        cell: cell,
        closeMenu: handleClose,
        column: column,
        internalMenuItems: internalMenuItems,
        row: row,
        table: table
    };
    const menuItems = (_c = (_b = columnDef.renderCellActionMenuItems) === null || _b === void 0 ? void 0 : _b.call(columnDef, renderActionProps)) !== null && _c !== void 0 ? _c : renderCellActionMenuItems === null || renderCellActionMenuItems === void 0 ? void 0 : renderCellActionMenuItems(renderActionProps);
    return (!!(menuItems === null || menuItems === void 0 ? void 0 : menuItems.length) || !!(internalMenuItems === null || internalMenuItems === void 0 ? void 0 : internalMenuItems.length)) && (0, $aSiaI.jsx)((0, $cf82f57fc51895ad$export$2e2bcd8739ae039), Object.assign({
        MenuListProps: {
            dense: density === "compact",
            sx: {
                backgroundColor: menuBackgroundColor
            }
        },
        anchorEl: actionCellRef.current,
        disableScrollLock: true,
        onClick: (event)=>event.stopPropagation(),
        onClose: handleClose,
        open: !!cell,
        transformOrigin: {
            horizontal: -100,
            vertical: 8
        }
    }, rest, {
        children: menuItems !== null && menuItems !== void 0 ? menuItems : internalMenuItems
    }));
};
const $35fd956d2f1c2be7$export$12f91577806f36a6 = (_a)=>{
    var _b;
    var { open: open, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "open",
        "table"
    ]);
    const { getState: getState, options: { localization: localization, muiCreateRowModalProps: muiCreateRowModalProps, muiEditRowDialogProps: muiEditRowDialogProps, onCreatingRowCancel: onCreatingRowCancel, onEditingRowCancel: onEditingRowCancel, renderCreateRowDialogContent: renderCreateRowDialogContent, renderEditRowDialogContent: renderEditRowDialogContent }, setCreatingRow: setCreatingRow, setEditingRow: setEditingRow } = table;
    const { creatingRow: creatingRow, editingRow: editingRow } = getState();
    const row = creatingRow !== null && creatingRow !== void 0 ? creatingRow : editingRow;
    const dialogProps = Object.assign(Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiEditRowDialogProps, {
        row: row,
        table: table
    })), creatingRow && $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiCreateRowModalProps, {
        row: row,
        table: table
    })), rest);
    const internalEditComponents = row.getAllCells().filter((cell)=>cell.column.columnDef.columnDefType === "data").map((cell)=>(0, $aSiaI.jsx)($35fd956d2f1c2be7$export$bac02719eed5c352, {
            cell: cell,
            table: table
        }, cell.id));
    return (0, $aSiaI.jsx)((0, $1a438903cf5e3275$export$2e2bcd8739ae039), Object.assign({
        fullWidth: true,
        maxWidth: "xs",
        onClose: (event, reason)=>{
            var _a;
            if (creatingRow) {
                onCreatingRowCancel === null || onCreatingRowCancel === void 0 || onCreatingRowCancel({
                    row: row,
                    table: table
                });
                setCreatingRow(null);
            } else {
                onEditingRowCancel === null || onEditingRowCancel === void 0 || onEditingRowCancel({
                    row: row,
                    table: table
                });
                setEditingRow(null);
            }
            row._valuesCache = {}; //reset values cache
            (_a = dialogProps.onClose) === null || _a === void 0 || _a.call(dialogProps, event, reason);
        },
        open: open
    }, dialogProps, {
        children: (_b = creatingRow && (renderCreateRowDialogContent === null || renderCreateRowDialogContent === void 0 ? void 0 : renderCreateRowDialogContent({
            internalEditComponents: internalEditComponents,
            row: row,
            table: table
        })) || (renderEditRowDialogContent === null || renderEditRowDialogContent === void 0 ? void 0 : renderEditRowDialogContent({
            internalEditComponents: internalEditComponents,
            row: row,
            table: table
        }))) !== null && _b !== void 0 ? _b : (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
            children: [
                (0, $aSiaI.jsx)((0, $9d719da819853e75$export$2e2bcd8739ae039), {
                    sx: {
                        textAlign: "center"
                    },
                    children: localization.edit
                }),
                (0, $aSiaI.jsx)((0, $db43a68763104a7e$export$2e2bcd8739ae039), {
                    children: (0, $aSiaI.jsx)("form", {
                        onSubmit: (e)=>e.preventDefault(),
                        children: (0, $aSiaI.jsx)((0, $e10e66deff206ed9$export$2e2bcd8739ae039), {
                            sx: {
                                gap: "32px",
                                paddingTop: "16px",
                                width: "100%"
                            },
                            children: internalEditComponents
                        })
                    })
                }),
                (0, $aSiaI.jsx)((0, $8136e94a8ae83d0c$export$2e2bcd8739ae039), {
                    sx: {
                        p: "1.25rem"
                    },
                    children: (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$e9ac3fa68bee6831, {
                        row: row,
                        table: table,
                        variant: "text"
                    })
                })
            ]
        })
    }));
};
const $35fd956d2f1c2be7$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? (0, $exYeM.useLayoutEffect) : (0, $exYeM.useEffect);
const $35fd956d2f1c2be7$export$6409dc1204eeb66a = (_a)=>{
    var { table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "table"
    ]);
    const { getState: getState, options: { createDisplayMode: createDisplayMode, editDisplayMode: editDisplayMode, enableCellActions: enableCellActions, enableStickyHeader: enableStickyHeader, muiTableContainerProps: muiTableContainerProps }, refs: { bottomToolbarRef: bottomToolbarRef, tableContainerRef: tableContainerRef, topToolbarRef: topToolbarRef } } = table;
    const { actionCell: actionCell, creatingRow: creatingRow, editingRow: editingRow, isFullScreen: isFullScreen, isLoading: isLoading, showLoadingOverlay: showLoadingOverlay } = getState();
    const loading = showLoadingOverlay !== false && (isLoading || showLoadingOverlay);
    const [totalToolbarHeight, setTotalToolbarHeight] = (0, $exYeM.useState)(0);
    const tableContainerProps = Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiTableContainerProps, {
        table: table
    })), rest);
    $35fd956d2f1c2be7$var$useIsomorphicLayoutEffect(()=>{
        var _a, _b, _c, _d;
        const topToolbarHeight = typeof document !== "undefined" ? (_b = (_a = topToolbarRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) !== null && _b !== void 0 ? _b : 0 : 0;
        const bottomToolbarHeight = typeof document !== "undefined" ? (_d = (_c = bottomToolbarRef === null || bottomToolbarRef === void 0 ? void 0 : bottomToolbarRef.current) === null || _c === void 0 ? void 0 : _c.offsetHeight) !== null && _d !== void 0 ? _d : 0 : 0;
        setTotalToolbarHeight(topToolbarHeight + bottomToolbarHeight);
    });
    const createModalOpen = createDisplayMode === "modal" && creatingRow;
    const editModalOpen = editDisplayMode === "modal" && editingRow;
    return (0, $aSiaI.jsxs)((0, $7c647d032b5c1ce4$export$2e2bcd8739ae039), Object.assign({
        "aria-busy": loading,
        "aria-describedby": loading ? "mrt-progress" : undefined
    }, tableContainerProps, {
        ref: (node)=>{
            if (node) {
                tableContainerRef.current = node;
                if (tableContainerProps === null || tableContainerProps === void 0 ? void 0 : tableContainerProps.ref) //@ts-ignore
                tableContainerProps.ref.current = node;
            }
        },
        style: Object.assign({
            maxHeight: isFullScreen ? `calc(100vh - ${totalToolbarHeight}px)` : undefined
        }, tableContainerProps === null || tableContainerProps === void 0 ? void 0 : tableContainerProps.style),
        sx: (theme)=>Object.assign({
                maxHeight: enableStickyHeader ? `clamp(350px, calc(100vh - ${totalToolbarHeight}px), 9999px)` : undefined,
                maxWidth: "100%",
                overflow: "auto",
                position: "relative"
            }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(tableContainerProps === null || tableContainerProps === void 0 ? void 0 : tableContainerProps.sx, theme)),
        children: [
            loading ? (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$66d8efa8cc5f6f7, {
                table: table
            }) : null,
            (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$b1ae1cbdfc1ba774, {
                table: table
            }),
            (createModalOpen || editModalOpen) && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$12f91577806f36a6, {
                open: true,
                table: table
            }),
            enableCellActions && actionCell && (0, $aSiaI.jsx)($35fd956d2f1c2be7$var$MRT_CellActionMenu, {
                table: table
            })
        ]
    }));
};
const $35fd956d2f1c2be7$export$a0e4041e316730e3 = (_a)=>{
    var { isTopToolbar: isTopToolbar, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "isTopToolbar",
        "table"
    ]);
    const { getState: getState, options: { muiLinearProgressProps: muiLinearProgressProps } } = table;
    const { isSaving: isSaving, showProgressBars: showProgressBars } = getState();
    const linearProgressProps = Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiLinearProgressProps, {
        isTopToolbar: isTopToolbar,
        table: table
    })), rest);
    return (0, $aSiaI.jsx)((0, $8c4543c1f79a917c$export$2e2bcd8739ae039), {
        in: showProgressBars !== false && (showProgressBars || isSaving),
        mountOnEnter: true,
        sx: {
            bottom: isTopToolbar ? 0 : undefined,
            position: "absolute",
            top: !isTopToolbar ? 0 : undefined,
            width: "100%"
        },
        unmountOnExit: true,
        children: (0, $aSiaI.jsx)((0, $2de6e1f747941867$export$2e2bcd8739ae039), Object.assign({
            "aria-busy": "true",
            "aria-label": "Loading",
            sx: {
                position: "relative"
            }
        }, linearProgressProps))
    });
};
const $35fd956d2f1c2be7$var$defaultRowsPerPage = [
    5,
    10,
    15,
    20,
    25,
    30,
    50,
    100
];
const $35fd956d2f1c2be7$export$bd75343f17999fc0 = (_a)=>{
    var { position: position = "bottom", table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "position",
        "table"
    ]);
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const isMobile = (0, $584e1e930413ffa8$export$2e2bcd8739ae039)("(max-width: 720px)");
    const { getState: getState, options: { enableToolbarInternalActions: enableToolbarInternalActions, icons: { ChevronLeftIcon: ChevronLeftIcon, ChevronRightIcon: ChevronRightIcon, FirstPageIcon: FirstPageIcon, LastPageIcon: LastPageIcon }, localization: localization, muiPaginationProps: muiPaginationProps, paginationDisplayMode: paginationDisplayMode } } = table;
    const { pagination: { pageIndex: pageIndex = 0, pageSize: pageSize = 10 }, showGlobalFilter: showGlobalFilter } = getState();
    const paginationProps = Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiPaginationProps, {
        table: table
    })), rest);
    const totalRowCount = table.getRowCount();
    const numberOfPages = table.getPageCount();
    const showFirstLastPageButtons = numberOfPages > 2;
    const firstRowIndex = pageIndex * pageSize;
    const lastRowIndex = Math.min(pageIndex * pageSize + pageSize, totalRowCount);
    const _b = paginationProps !== null && paginationProps !== void 0 ? paginationProps : {}, { SelectProps: SelectProps = {}, disabled: disabled = false, rowsPerPageOptions: rowsPerPageOptions = $35fd956d2f1c2be7$var$defaultRowsPerPage, showFirstButton: showFirstButton = showFirstLastPageButtons, showLastButton: showLastButton = showFirstLastPageButtons, showRowsPerPage: showRowsPerPage = true } = _b, restPaginationProps = $35fd956d2f1c2be7$var$__rest(_b, [
        "SelectProps",
        "disabled",
        "rowsPerPageOptions",
        "showFirstButton",
        "showLastButton",
        "showRowsPerPage"
    ]);
    const disableBack = pageIndex <= 0 || disabled;
    const disableNext = lastRowIndex >= totalRowCount || disabled;
    if (isMobile && (SelectProps === null || SelectProps === void 0 ? void 0 : SelectProps.native) !== false) SelectProps.native = true;
    const tooltipProps = $35fd956d2f1c2be7$var$getCommonTooltipProps();
    return (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        className: "MuiTablePagination-root",
        sx: {
            alignItems: "center",
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",
            justifyContent: {
                md: "space-between",
                sm: "center"
            },
            justifySelf: "flex-end",
            mt: position === "top" && enableToolbarInternalActions && !showGlobalFilter ? "3rem" : undefined,
            position: "relative",
            px: "8px",
            py: "12px",
            zIndex: 2
        },
        children: [
            showRowsPerPage && (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                sx: {
                    alignItems: "center",
                    display: "flex",
                    gap: "8px"
                },
                children: [
                    (0, $aSiaI.jsx)((0, $0f13a85ecf68fcb2$export$2e2bcd8739ae039), {
                        htmlFor: "mrt-rows-per-page",
                        sx: {
                            mb: 0
                        },
                        children: localization.rowsPerPage
                    }),
                    (0, $aSiaI.jsx)((0, $feaa83d06931451d$export$2e2bcd8739ae039), Object.assign({
                        MenuProps: {
                            disableScrollLock: true
                        },
                        disableUnderline: true,
                        disabled: disabled,
                        inputProps: {
                            "aria-label": localization.rowsPerPage,
                            id: "mrt-rows-per-page"
                        },
                        label: localization.rowsPerPage,
                        onChange: (event)=>table.setPageSize(+event.target.value),
                        sx: {
                            mb: 0
                        },
                        value: pageSize,
                        variant: "standard"
                    }, SelectProps, {
                        children: rowsPerPageOptions.map((option)=>{
                            var _a;
                            const value = typeof option !== "number" ? option.value : option;
                            const label = typeof option !== "number" ? option.label : `${option}`;
                            return (_a = SelectProps === null || SelectProps === void 0 ? void 0 : SelectProps.children) !== null && _a !== void 0 ? _a : (SelectProps === null || SelectProps === void 0 ? void 0 : SelectProps.native) ? (0, $aSiaI.jsx)("option", {
                                value: value,
                                children: label
                            }, value) : (0, $aSiaI.jsx)((0, $32731aa3cf1ce086$export$2e2bcd8739ae039), {
                                sx: {
                                    m: 0
                                },
                                value: value,
                                children: label
                            }, value);
                        })
                    }))
                ]
            }),
            paginationDisplayMode === "pages" ? (0, $aSiaI.jsx)((0, $832dbfb3b6ab77fc$export$2e2bcd8739ae039), Object.assign({
                count: numberOfPages,
                disabled: disabled,
                onChange: (_e, newPageIndex)=>table.setPageIndex(newPageIndex - 1),
                page: pageIndex + 1,
                renderItem: (item)=>(0, $aSiaI.jsx)((0, $f201c8eef94b5505$export$2e2bcd8739ae039), Object.assign({
                        slots: {
                            first: FirstPageIcon,
                            last: LastPageIcon,
                            next: ChevronRightIcon,
                            previous: ChevronLeftIcon
                        }
                    }, item)),
                showFirstButton: showFirstButton,
                showLastButton: showLastButton
            }, restPaginationProps)) : paginationDisplayMode === "default" ? (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                children: [
                    (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                        align: "center",
                        component: "span",
                        sx: {
                            m: "0 4px",
                            minWidth: "8ch"
                        },
                        variant: "body2",
                        children: `${lastRowIndex === 0 ? 0 : (firstRowIndex + 1).toLocaleString()}-${lastRowIndex.toLocaleString()} ${localization.of} ${totalRowCount.toLocaleString()}`
                    }),
                    (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                        gap: "xs",
                        children: [
                            showFirstButton && (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), Object.assign({}, tooltipProps, {
                                title: localization.goToFirstPage,
                                children: (0, $aSiaI.jsx)("span", {
                                    children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), {
                                        "aria-label": localization.goToFirstPage,
                                        disabled: disableBack,
                                        onClick: ()=>table.firstPage(),
                                        size: "small",
                                        children: (0, $aSiaI.jsx)(FirstPageIcon, Object.assign({}, $35fd956d2f1c2be7$var$flipIconStyles(theme)))
                                    })
                                })
                            })),
                            (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), Object.assign({}, tooltipProps, {
                                title: localization.goToPreviousPage,
                                children: (0, $aSiaI.jsx)("span", {
                                    children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), {
                                        "aria-label": localization.goToPreviousPage,
                                        disabled: disableBack,
                                        onClick: ()=>table.previousPage(),
                                        size: "small",
                                        children: (0, $aSiaI.jsx)(ChevronLeftIcon, Object.assign({}, $35fd956d2f1c2be7$var$flipIconStyles(theme)))
                                    })
                                })
                            })),
                            (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), Object.assign({}, tooltipProps, {
                                title: localization.goToNextPage,
                                children: (0, $aSiaI.jsx)("span", {
                                    children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), {
                                        "aria-label": localization.goToNextPage,
                                        disabled: disableNext,
                                        onClick: ()=>table.nextPage(),
                                        size: "small",
                                        children: (0, $aSiaI.jsx)(ChevronRightIcon, Object.assign({}, $35fd956d2f1c2be7$var$flipIconStyles(theme)))
                                    })
                                })
                            })),
                            showLastButton && (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), Object.assign({}, tooltipProps, {
                                title: localization.goToLastPage,
                                children: (0, $aSiaI.jsx)("span", {
                                    children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), {
                                        "aria-label": localization.goToLastPage,
                                        disabled: disableNext,
                                        onClick: ()=>table.lastPage(),
                                        size: "small",
                                        children: (0, $aSiaI.jsx)(LastPageIcon, Object.assign({}, $35fd956d2f1c2be7$var$flipIconStyles(theme)))
                                    })
                                })
                            }))
                        ]
                    })
                ]
            }) : null
        ]
    });
};
const $35fd956d2f1c2be7$export$23b863b2e258a060 = (_a)=>{
    var _b, _c;
    var { table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "table"
    ]);
    const { getState: getState, options: { enableGrouping: enableGrouping, localization: localization }, setHoveredColumn: setHoveredColumn, setShowToolbarDropZone: setShowToolbarDropZone } = table;
    const { draggingColumn: draggingColumn, grouping: grouping, hoveredColumn: hoveredColumn, showToolbarDropZone: showToolbarDropZone } = getState();
    const handleDragEnter = (_event)=>{
        setHoveredColumn({
            id: "drop-zone"
        });
    };
    const handleDragOver = (e)=>{
        e.preventDefault();
    };
    (0, $exYeM.useEffect)(()=>{
        var _a;
        if (((_a = table.options.state) === null || _a === void 0 ? void 0 : _a.showToolbarDropZone) !== undefined) setShowToolbarDropZone(!!enableGrouping && !!draggingColumn && draggingColumn.columnDef.enableGrouping !== false && !grouping.includes(draggingColumn.id));
    }, [
        enableGrouping,
        draggingColumn,
        grouping
    ]);
    return (0, $aSiaI.jsx)((0, $b8c58e7700914c7f$export$2e2bcd8739ae039), {
        in: showToolbarDropZone,
        children: (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), Object.assign({
            className: "Mui-ToolbarDropZone",
            onDragEnter: handleDragEnter,
            onDragOver: handleDragOver
        }, rest, {
            sx: (theme)=>Object.assign({
                    alignItems: "center",
                    backdropFilter: "blur(4px)",
                    backgroundColor: (0, $69eec9e6c105674b$export$58f0f39f63f3cf42)(theme.palette.info.main, (hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) === "drop-zone" ? 0.2 : 0.1),
                    border: `dashed ${theme.palette.info.main} 2px`,
                    boxSizing: "border-box",
                    display: "flex",
                    height: "100%",
                    justifyContent: "center",
                    position: "absolute",
                    width: "100%",
                    zIndex: 4
                }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(rest === null || rest === void 0 ? void 0 : rest.sx, theme)),
            children: (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                fontStyle: "italic",
                children: localization.dropToGroupBy.replace("{column}", (_c = (_b = draggingColumn === null || draggingColumn === void 0 ? void 0 : draggingColumn.columnDef) === null || _b === void 0 ? void 0 : _b.header) !== null && _c !== void 0 ? _c : "")
            })
        }))
    });
};
const $35fd956d2f1c2be7$export$802d7d5e9270e154 = (_a)=>{
    var { table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "table"
    ]);
    const { getState: getState, options: { enablePagination: enablePagination, muiBottomToolbarProps: muiBottomToolbarProps, positionPagination: positionPagination, positionToolbarAlertBanner: positionToolbarAlertBanner, positionToolbarDropZone: positionToolbarDropZone, renderBottomToolbarCustomActions: renderBottomToolbarCustomActions }, refs: { bottomToolbarRef: bottomToolbarRef } } = table;
    const { isFullScreen: isFullScreen } = getState();
    const isMobile = (0, $584e1e930413ffa8$export$2e2bcd8739ae039)("(max-width:720px)");
    const toolbarProps = Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiBottomToolbarProps, {
        table: table
    })), rest);
    const stackAlertBanner = isMobile || !!renderBottomToolbarCustomActions;
    return (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), Object.assign({}, toolbarProps, {
        ref: (node)=>{
            if (node) {
                bottomToolbarRef.current = node;
                if (toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.ref) // @ts-ignore
                toolbarProps.ref.current = node;
            }
        },
        sx: (theme)=>Object.assign(Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$getCommonToolbarStyles({
                table: table,
                theme: theme
            })), {
                bottom: isFullScreen ? "0" : undefined,
                boxShadow: `0 1px 2px -1px ${(0, $69eec9e6c105674b$export$58f0f39f63f3cf42)(theme.palette.grey[700], 0.5)} inset`,
                left: 0,
                position: isFullScreen ? "fixed" : "relative",
                right: 0
            }), $35fd956d2f1c2be7$var$parseFromValuesOrFunc(toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.sx, theme)),
        children: [
            (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$a0e4041e316730e3, {
                isTopToolbar: false,
                table: table
            }),
            positionToolbarAlertBanner === "bottom" && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$182b9e76a987279b, {
                stackAlertBanner: stackAlertBanner,
                table: table
            }),
            [
                "both",
                "bottom"
            ].includes(positionToolbarDropZone !== null && positionToolbarDropZone !== void 0 ? positionToolbarDropZone : "") && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$23b863b2e258a060, {
                table: table
            }),
            (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                sx: {
                    alignItems: "center",
                    boxSizing: "border-box",
                    display: "flex",
                    justifyContent: "space-between",
                    p: "0.5rem",
                    width: "100%"
                },
                children: [
                    renderBottomToolbarCustomActions ? renderBottomToolbarCustomActions({
                        table: table
                    }) : (0, $aSiaI.jsx)("span", {}),
                    (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex",
                            justifyContent: "flex-end",
                            position: stackAlertBanner ? "relative" : "absolute",
                            right: 0,
                            top: 0
                        },
                        children: enablePagination && [
                            "both",
                            "bottom"
                        ].includes(positionPagination !== null && positionPagination !== void 0 ? positionPagination : "") && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$bd75343f17999fc0, {
                            position: "bottom",
                            table: table
                        })
                    })
                ]
            })
        ]
    }));
};
const $35fd956d2f1c2be7$export$6f86f0bc223dfa20 = (_a)=>{
    var { column: column, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "column",
        "table"
    ]);
    const { options: { icons: { PushPinIcon: PushPinIcon }, localization: localization } } = table;
    const handlePinColumn = (pinDirection)=>{
        column.pin(pinDirection);
    };
    return (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), Object.assign({}, rest, {
        sx: (theme)=>Object.assign({
                minWidth: "70px",
                textAlign: "center"
            }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(rest === null || rest === void 0 ? void 0 : rest.sx, theme)),
        children: column.getIsPinned() ? (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), {
            title: localization.unpin,
            children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), {
                onClick: ()=>handlePinColumn(false),
                size: "small",
                children: (0, $aSiaI.jsx)(PushPinIcon, {})
            })
        }) : (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
            children: [
                (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), {
                    title: localization.pinToLeft,
                    children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), {
                        onClick: ()=>handlePinColumn("left"),
                        size: "small",
                        children: (0, $aSiaI.jsx)(PushPinIcon, {
                            style: {
                                transform: "rotate(90deg)"
                            }
                        })
                    })
                }),
                (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), {
                    title: localization.pinToRight,
                    children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), {
                        onClick: ()=>handlePinColumn("right"),
                        size: "small",
                        children: (0, $aSiaI.jsx)(PushPinIcon, {
                            style: {
                                transform: "rotate(-90deg)"
                            }
                        })
                    })
                })
            ]
        })
    }));
};
const $35fd956d2f1c2be7$export$4848b0b983b286bc = (_a)=>{
    var _b;
    var { allColumns: allColumns, column: column, hoveredColumn: hoveredColumn, isNestedColumns: isNestedColumns, setHoveredColumn: setHoveredColumn, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "allColumns",
        "column",
        "hoveredColumn",
        "isNestedColumns",
        "setHoveredColumn",
        "table"
    ]);
    const { getState: getState, options: { enableColumnOrdering: enableColumnOrdering, enableColumnPinning: enableColumnPinning, enableHiding: enableHiding, localization: localization, mrtTheme: { draggingBorderColor: draggingBorderColor } }, setColumnOrder: setColumnOrder } = table;
    const { columnOrder: columnOrder } = getState();
    const { columnDef: columnDef } = column;
    const { columnDefType: columnDefType } = columnDef;
    const switchChecked = column.getIsVisible();
    const handleToggleColumnHidden = (column)=>{
        var _a, _b;
        if (columnDefType === "group") (_b = (_a = column === null || column === void 0 ? void 0 : column.columns) === null || _a === void 0 ? void 0 : _a.forEach) === null || _b === void 0 || _b.call(_a, (childColumn)=>{
            childColumn.toggleVisibility(!switchChecked);
        });
        else column.toggleVisibility();
    };
    const menuItemRef = (0, $exYeM.useRef)(null);
    const [isDragging, setIsDragging] = (0, $exYeM.useState)(false);
    const handleDragStart = (e)=>{
        setIsDragging(true);
        try {
            e.dataTransfer.setDragImage(menuItemRef.current, 0, 0);
        } catch (e) {
            console.error(e);
        }
    };
    const handleDragEnd = (_e)=>{
        setIsDragging(false);
        setHoveredColumn(null);
        if (hoveredColumn) setColumnOrder($35fd956d2f1c2be7$export$4780246288fde46d(column, hoveredColumn, columnOrder));
    };
    const handleDragEnter = (_e)=>{
        if (!isDragging && columnDef.enableColumnOrdering !== false) setHoveredColumn(column);
    };
    if (!columnDef.header || columnDef.visibleInShowHideMenu === false) return null;
    return (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            (0, $aSiaI.jsx)((0, $32731aa3cf1ce086$export$2e2bcd8739ae039), Object.assign({
                disableRipple: true,
                onDragEnter: handleDragEnter,
                ref: menuItemRef
            }, rest, {
                sx: (theme)=>Object.assign({
                        alignItems: "center",
                        justifyContent: "flex-start",
                        my: 0,
                        opacity: isDragging ? 0.5 : 1,
                        outline: isDragging ? `2px dashed ${theme.palette.grey[500]}` : (hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) === column.id ? `2px dashed ${draggingBorderColor}` : "none",
                        outlineOffset: "-2px",
                        pl: `${(column.depth + 0.5) * 2}rem`,
                        py: "6px"
                    }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(rest === null || rest === void 0 ? void 0 : rest.sx, theme)),
                children: (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        flexWrap: "nowrap",
                        gap: "8px"
                    },
                    children: [
                        columnDefType !== "group" && enableColumnOrdering && !isNestedColumns && (columnDef.enableColumnOrdering !== false ? (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$84d0ca45a1213a16, {
                            onDragEnd: handleDragEnd,
                            onDragStart: handleDragStart,
                            table: table
                        }) : (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                            sx: {
                                width: "28px"
                            }
                        })),
                        enableColumnPinning && (column.getCanPin() ? (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$6f86f0bc223dfa20, {
                            column: column,
                            table: table
                        }) : (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                            sx: {
                                width: "70px"
                            }
                        })),
                        enableHiding ? (0, $aSiaI.jsx)((0, $412387e41715fadc$export$2e2bcd8739ae039), {
                            checked: switchChecked,
                            componentsProps: {
                                typography: {
                                    sx: {
                                        mb: 0,
                                        opacity: columnDefType !== "display" ? 1 : 0.5
                                    }
                                }
                            },
                            control: (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), Object.assign({}, $35fd956d2f1c2be7$var$getCommonTooltipProps(), {
                                title: localization.toggleVisibility,
                                children: (0, $aSiaI.jsx)((0, $8482ce3784eb7280$export$2e2bcd8739ae039), {})
                            })),
                            disabled: !column.getCanHide(),
                            label: columnDef.header,
                            onChange: ()=>handleToggleColumnHidden(column)
                        }) : (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                            sx: {
                                alignSelf: "center"
                            },
                            children: columnDef.header
                        })
                    ]
                })
            })),
            (_b = column.columns) === null || _b === void 0 ? void 0 : _b.map((c, i)=>(0, $aSiaI.jsx)($35fd956d2f1c2be7$export$4848b0b983b286bc, {
                    allColumns: allColumns,
                    column: c,
                    hoveredColumn: hoveredColumn,
                    isNestedColumns: isNestedColumns,
                    setHoveredColumn: setHoveredColumn,
                    table: table
                }, `${i}-${c.id}`))
        ]
    });
};
const $35fd956d2f1c2be7$export$809b8ec3ea194807 = (_a)=>{
    var { anchorEl: anchorEl, setAnchorEl: setAnchorEl, table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "anchorEl",
        "setAnchorEl",
        "table"
    ]);
    const { getAllColumns: getAllColumns, getAllLeafColumns: getAllLeafColumns, getCenterLeafColumns: getCenterLeafColumns, getIsAllColumnsVisible: getIsAllColumnsVisible, getIsSomeColumnsPinned: getIsSomeColumnsPinned, getIsSomeColumnsVisible: getIsSomeColumnsVisible, getLeftLeafColumns: getLeftLeafColumns, getRightLeafColumns: getRightLeafColumns, getState: getState, options: { enableColumnOrdering: enableColumnOrdering, enableColumnPinning: enableColumnPinning, enableHiding: enableHiding, localization: localization, mrtTheme: { menuBackgroundColor: menuBackgroundColor } } } = table;
    const { columnOrder: columnOrder, columnPinning: columnPinning, density: density } = getState();
    const handleToggleAllColumns = (value)=>{
        getAllLeafColumns().filter((col)=>col.columnDef.enableHiding !== false).forEach((col)=>col.toggleVisibility(value));
    };
    const allColumns = (0, $exYeM.useMemo)(()=>{
        const columns = getAllColumns();
        if (columnOrder.length > 0 && !columns.some((col)=>col.columnDef.columnDefType === "group")) return [
            ...getLeftLeafColumns(),
            ...Array.from(new Set(columnOrder)).map((colId)=>getCenterLeafColumns().find((col)=>(col === null || col === void 0 ? void 0 : col.id) === colId)),
            ...getRightLeafColumns()
        ].filter(Boolean);
        return columns;
    }, [
        columnOrder,
        columnPinning,
        getAllColumns(),
        getCenterLeafColumns(),
        getLeftLeafColumns(),
        getRightLeafColumns()
    ]);
    const isNestedColumns = allColumns.some((col)=>col.columnDef.columnDefType === "group");
    const [hoveredColumn, setHoveredColumn] = (0, $exYeM.useState)(null);
    return (0, $aSiaI.jsxs)((0, $cf82f57fc51895ad$export$2e2bcd8739ae039), Object.assign({
        MenuListProps: {
            dense: density === "compact",
            sx: {
                backgroundColor: menuBackgroundColor
            }
        },
        anchorEl: anchorEl,
        disableScrollLock: true,
        onClose: ()=>setAnchorEl(null),
        open: !!anchorEl
    }, rest, {
        children: [
            (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    justifyContent: "space-between",
                    p: "0.5rem",
                    pt: 0
                },
                children: [
                    enableHiding && (0, $aSiaI.jsx)((0, $980dfff3cab72cf4$export$2e2bcd8739ae039), {
                        disabled: !getIsSomeColumnsVisible(),
                        onClick: ()=>handleToggleAllColumns(false),
                        children: localization.hideAll
                    }),
                    enableColumnOrdering && (0, $aSiaI.jsx)((0, $980dfff3cab72cf4$export$2e2bcd8739ae039), {
                        onClick: ()=>table.setColumnOrder($35fd956d2f1c2be7$export$be53169041fbd6c5(table.options, true)),
                        children: localization.resetOrder
                    }),
                    enableColumnPinning && (0, $aSiaI.jsx)((0, $980dfff3cab72cf4$export$2e2bcd8739ae039), {
                        disabled: !getIsSomeColumnsPinned(),
                        onClick: ()=>table.resetColumnPinning(true),
                        children: localization.unpinAll
                    }),
                    enableHiding && (0, $aSiaI.jsx)((0, $980dfff3cab72cf4$export$2e2bcd8739ae039), {
                        disabled: getIsAllColumnsVisible(),
                        onClick: ()=>handleToggleAllColumns(true),
                        children: localization.showAll
                    })
                ]
            }),
            (0, $aSiaI.jsx)((0, $a59c125ed1ac1385$export$2e2bcd8739ae039), {}),
            allColumns.map((column, index)=>(0, $aSiaI.jsx)($35fd956d2f1c2be7$export$4848b0b983b286bc, {
                    allColumns: allColumns,
                    column: column,
                    hoveredColumn: hoveredColumn,
                    isNestedColumns: isNestedColumns,
                    setHoveredColumn: setHoveredColumn,
                    table: table
                }, `${index}-${column.id}`))
        ]
    }));
};
const $35fd956d2f1c2be7$export$d9eac406b7d9b19a = (_a)=>{
    var _b;
    var { table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "table"
    ]);
    const { options: { icons: { ViewColumnIcon: ViewColumnIcon }, localization: localization } } = table;
    const [anchorEl, setAnchorEl] = (0, $exYeM.useState)(null);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    return (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), {
                title: (_b = rest === null || rest === void 0 ? void 0 : rest.title) !== null && _b !== void 0 ? _b : localization.showHideColumns,
                children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), Object.assign({
                    "aria-label": localization.showHideColumns,
                    onClick: handleClick
                }, rest, {
                    title: undefined,
                    children: (0, $aSiaI.jsx)(ViewColumnIcon, {})
                }))
            }),
            anchorEl && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$809b8ec3ea194807, {
                anchorEl: anchorEl,
                setAnchorEl: setAnchorEl,
                table: table
            })
        ]
    });
};
const $35fd956d2f1c2be7$export$64e24d27f9334b87 = (_a)=>{
    var _b;
    var { table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "table"
    ]);
    const { getState: getState, options: { icons: { DensityLargeIcon: DensityLargeIcon, DensityMediumIcon: DensityMediumIcon, DensitySmallIcon: DensitySmallIcon }, localization: localization }, setDensity: setDensity } = table;
    const { density: density } = getState();
    const handleToggleDensePadding = ()=>{
        const nextDensity = density === "comfortable" ? "compact" : density === "compact" ? "spacious" : "comfortable";
        setDensity(nextDensity);
    };
    return (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), {
        title: (_b = rest === null || rest === void 0 ? void 0 : rest.title) !== null && _b !== void 0 ? _b : localization.toggleDensity,
        children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), Object.assign({
            "aria-label": localization.toggleDensity,
            onClick: handleToggleDensePadding
        }, rest, {
            title: undefined,
            children: density === "compact" ? (0, $aSiaI.jsx)(DensitySmallIcon, {}) : density === "comfortable" ? (0, $aSiaI.jsx)(DensityMediumIcon, {}) : (0, $aSiaI.jsx)(DensityLargeIcon, {})
        }))
    });
};
const $35fd956d2f1c2be7$export$df5f5becfc7dc5e7 = (_a)=>{
    var _b;
    var { table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "table"
    ]);
    const { getState: getState, options: { icons: { FilterListIcon: FilterListIcon, FilterListOffIcon: FilterListOffIcon }, localization: localization }, setShowColumnFilters: setShowColumnFilters } = table;
    const { showColumnFilters: showColumnFilters } = getState();
    const handleToggleShowFilters = ()=>{
        setShowColumnFilters(!showColumnFilters);
    };
    return (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), {
        title: (_b = rest === null || rest === void 0 ? void 0 : rest.title) !== null && _b !== void 0 ? _b : localization.showHideFilters,
        children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), Object.assign({
            "aria-label": localization.showHideFilters,
            onClick: handleToggleShowFilters
        }, rest, {
            title: undefined,
            children: showColumnFilters ? (0, $aSiaI.jsx)(FilterListOffIcon, {}) : (0, $aSiaI.jsx)(FilterListIcon, {})
        }))
    });
};
const $35fd956d2f1c2be7$export$b0757e62959fee9d = (_a)=>{
    var _b;
    var { table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "table"
    ]);
    const { getState: getState, options: { icons: { FullscreenExitIcon: FullscreenExitIcon, FullscreenIcon: FullscreenIcon }, localization: localization }, setIsFullScreen: setIsFullScreen } = table;
    const { isFullScreen: isFullScreen } = getState();
    const [tooltipOpened, setTooltipOpened] = (0, $exYeM.useState)(false);
    const handleToggleFullScreen = ()=>{
        setTooltipOpened(false);
        setIsFullScreen(!isFullScreen);
    };
    return (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), {
        open: tooltipOpened,
        title: (_b = rest === null || rest === void 0 ? void 0 : rest.title) !== null && _b !== void 0 ? _b : localization.toggleFullScreen,
        children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), Object.assign({
            "aria-label": localization.toggleFullScreen,
            onClick: handleToggleFullScreen,
            onMouseEnter: ()=>setTooltipOpened(true),
            onMouseLeave: ()=>setTooltipOpened(false)
        }, rest, {
            title: undefined,
            children: isFullScreen ? (0, $aSiaI.jsx)(FullscreenExitIcon, {}) : (0, $aSiaI.jsx)(FullscreenIcon, {})
        }))
    });
};
const $35fd956d2f1c2be7$export$aa2cd24532d76e1e = (_a)=>{
    var _b, _c;
    var { table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "table"
    ]);
    const { getState: getState, options: { icons: { SearchIcon: SearchIcon, SearchOffIcon: SearchOffIcon }, localization: localization }, refs: { searchInputRef: searchInputRef }, setShowGlobalFilter: setShowGlobalFilter } = table;
    const { globalFilter: globalFilter, showGlobalFilter: showGlobalFilter } = getState();
    const handleToggleSearch = ()=>{
        setShowGlobalFilter(!showGlobalFilter);
        queueMicrotask(()=>{
            var _a;
            return (_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        });
    };
    return (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), {
        title: (_b = rest === null || rest === void 0 ? void 0 : rest.title) !== null && _b !== void 0 ? _b : localization.showHideSearch,
        children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), Object.assign({
            "aria-label": (_c = rest === null || rest === void 0 ? void 0 : rest.title) !== null && _c !== void 0 ? _c : localization.showHideSearch,
            disabled: !!globalFilter,
            onClick: handleToggleSearch
        }, rest, {
            title: undefined,
            children: showGlobalFilter ? (0, $aSiaI.jsx)(SearchOffIcon, {}) : (0, $aSiaI.jsx)(SearchIcon, {})
        }))
    });
};
const $35fd956d2f1c2be7$export$34667439d21f6b05 = (_a)=>{
    var _b;
    var { table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "table"
    ]);
    const { options: { columnFilterDisplayMode: columnFilterDisplayMode, enableColumnFilters: enableColumnFilters, enableColumnOrdering: enableColumnOrdering, enableColumnPinning: enableColumnPinning, enableDensityToggle: enableDensityToggle, enableFilters: enableFilters, enableFullScreenToggle: enableFullScreenToggle, enableGlobalFilter: enableGlobalFilter, enableHiding: enableHiding, initialState: initialState, renderToolbarInternalActions: renderToolbarInternalActions } } = table;
    return (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), Object.assign({}, rest, {
        sx: (theme)=>Object.assign({
                alignItems: "center",
                display: "flex",
                zIndex: 3
            }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(rest === null || rest === void 0 ? void 0 : rest.sx, theme)),
        children: (_b = renderToolbarInternalActions === null || renderToolbarInternalActions === void 0 ? void 0 : renderToolbarInternalActions({
            table: table
        })) !== null && _b !== void 0 ? _b : (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
            children: [
                enableFilters && enableGlobalFilter && !(initialState === null || initialState === void 0 ? void 0 : initialState.showGlobalFilter) && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$aa2cd24532d76e1e, {
                    table: table
                }),
                enableFilters && enableColumnFilters && columnFilterDisplayMode !== "popover" && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$df5f5becfc7dc5e7, {
                    table: table
                }),
                (enableHiding || enableColumnOrdering || enableColumnPinning) && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$d9eac406b7d9b19a, {
                    table: table
                }),
                enableDensityToggle && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$64e24d27f9334b87, {
                    table: table
                }),
                enableFullScreenToggle && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$b0757e62959fee9d, {
                    table: table
                })
            ]
        })
    }));
};
const $35fd956d2f1c2be7$export$d802562b525f204b = (_a)=>{
    var _b;
    var { table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "table"
    ]);
    const { getState: getState, options: { enableGlobalFilterModes: enableGlobalFilterModes, icons: { CloseIcon: CloseIcon, SearchIcon: SearchIcon }, localization: localization, manualFiltering: manualFiltering, muiSearchTextFieldProps: muiSearchTextFieldProps }, refs: { searchInputRef: searchInputRef }, setGlobalFilter: setGlobalFilter } = table;
    const { globalFilter: globalFilter, showGlobalFilter: showGlobalFilter } = getState();
    const textFieldProps = Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiSearchTextFieldProps, {
        table: table
    })), rest);
    const isMounted = (0, $exYeM.useRef)(false);
    const [anchorEl, setAnchorEl] = (0, $exYeM.useState)(null);
    const [searchValue, setSearchValue] = (0, $exYeM.useState)(globalFilter !== null && globalFilter !== void 0 ? globalFilter : "");
    const handleChangeDebounced = (0, $exYeM.useCallback)((0, $398f0b8aef852a12$export$2e2bcd8739ae039)((event)=>{
        var _a;
        setGlobalFilter((_a = event.target.value) !== null && _a !== void 0 ? _a : undefined);
    }, manualFiltering ? 500 : 250), []);
    const handleChange = (event)=>{
        setSearchValue(event.target.value);
        handleChangeDebounced(event);
    };
    const handleGlobalFilterMenuOpen = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClear = ()=>{
        setSearchValue("");
        setGlobalFilter(undefined);
    };
    (0, $exYeM.useEffect)(()=>{
        if (isMounted.current) {
            if (globalFilter === undefined) handleClear();
            else setSearchValue(globalFilter);
        }
        isMounted.current = true;
    }, [
        globalFilter
    ]);
    return (0, $aSiaI.jsxs)((0, $8c4543c1f79a917c$export$2e2bcd8739ae039), {
        in: showGlobalFilter,
        mountOnEnter: true,
        orientation: "horizontal",
        unmountOnExit: true,
        children: [
            (0, $aSiaI.jsx)((0, $18a733eef46a7fb6$export$2e2bcd8739ae039), Object.assign({
                inputProps: Object.assign({
                    autoComplete: "new-password"
                }, textFieldProps.inputProps),
                onChange: handleChange,
                placeholder: localization.search,
                size: "small",
                value: searchValue !== null && searchValue !== void 0 ? searchValue : "",
                variant: "outlined"
            }, textFieldProps, {
                InputProps: Object.assign(Object.assign({
                    endAdornment: (0, $aSiaI.jsx)((0, $60f459c5525ea035$export$2e2bcd8739ae039), {
                        position: "end",
                        children: (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), {
                            title: (_b = localization.clearSearch) !== null && _b !== void 0 ? _b : "",
                            children: (0, $aSiaI.jsx)("span", {
                                children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), {
                                    "aria-label": localization.clearSearch,
                                    disabled: !(searchValue === null || searchValue === void 0 ? void 0 : searchValue.length),
                                    onClick: handleClear,
                                    size: "small",
                                    children: (0, $aSiaI.jsx)(CloseIcon, {})
                                })
                            })
                        })
                    }),
                    startAdornment: enableGlobalFilterModes ? (0, $aSiaI.jsx)((0, $60f459c5525ea035$export$2e2bcd8739ae039), {
                        position: "start",
                        children: (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), {
                            title: localization.changeSearchMode,
                            children: (0, $aSiaI.jsx)((0, $96b952e1d26b1f04$export$2e2bcd8739ae039), {
                                "aria-label": localization.changeSearchMode,
                                onClick: handleGlobalFilterMenuOpen,
                                size: "small",
                                sx: {
                                    height: "1.75rem",
                                    width: "1.75rem"
                                },
                                children: (0, $aSiaI.jsx)(SearchIcon, {})
                            })
                        })
                    }) : (0, $aSiaI.jsx)(SearchIcon, {
                        style: {
                            marginRight: "4px"
                        }
                    })
                }, textFieldProps.InputProps), {
                    sx: (theme)=>{
                        var _a;
                        return Object.assign({
                            mb: 0
                        }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc((_a = textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.InputProps) === null || _a === void 0 ? void 0 : _a.sx, theme));
                    }
                }),
                inputRef: (inputRef)=>{
                    searchInputRef.current = inputRef;
                    if (textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.inputRef) textFieldProps.inputRef = inputRef;
                }
            })),
            (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$18f00246d050b1b5, {
                anchorEl: anchorEl,
                onSelect: handleClear,
                setAnchorEl: setAnchorEl,
                table: table
            })
        ]
    });
};
const $35fd956d2f1c2be7$export$833ce02671e611ef = ({ table: table })=>{
    var _a;
    const { getState: getState, options: { enableGlobalFilter: enableGlobalFilter, enablePagination: enablePagination, enableToolbarInternalActions: enableToolbarInternalActions, muiTopToolbarProps: muiTopToolbarProps, positionGlobalFilter: positionGlobalFilter, positionPagination: positionPagination, positionToolbarAlertBanner: positionToolbarAlertBanner, positionToolbarDropZone: positionToolbarDropZone, renderTopToolbarCustomActions: renderTopToolbarCustomActions }, refs: { topToolbarRef: topToolbarRef } } = table;
    const { isFullScreen: isFullScreen, showGlobalFilter: showGlobalFilter } = getState();
    const isMobile = (0, $584e1e930413ffa8$export$2e2bcd8739ae039)("(max-width:720px)");
    const isTablet = (0, $584e1e930413ffa8$export$2e2bcd8739ae039)("(max-width:1024px)");
    const toolbarProps = $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiTopToolbarProps, {
        table: table
    });
    const stackAlertBanner = isMobile || !!renderTopToolbarCustomActions || showGlobalFilter && isTablet;
    const globalFilterProps = {
        sx: !isTablet ? {
            zIndex: 2
        } : undefined,
        table: table
    };
    return (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), Object.assign({}, toolbarProps, {
        ref: (ref)=>{
            topToolbarRef.current = ref;
            if (toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.ref) // @ts-ignore
            toolbarProps.ref.current = ref;
        },
        sx: (theme)=>Object.assign(Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$getCommonToolbarStyles({
                table: table,
                theme: theme
            })), {
                position: isFullScreen ? "sticky" : "relative",
                top: isFullScreen ? "0" : undefined
            }), $35fd956d2f1c2be7$var$parseFromValuesOrFunc(toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.sx, theme)),
        children: [
            positionToolbarAlertBanner === "top" && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$182b9e76a987279b, {
                stackAlertBanner: stackAlertBanner,
                table: table
            }),
            [
                "both",
                "top"
            ].includes(positionToolbarDropZone !== null && positionToolbarDropZone !== void 0 ? positionToolbarDropZone : "") && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$23b863b2e258a060, {
                table: table
            }),
            (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                sx: {
                    alignItems: "flex-start",
                    boxSizing: "border-box",
                    display: "flex",
                    gap: "0.5rem",
                    justifyContent: "space-between",
                    p: "0.5rem",
                    position: stackAlertBanner ? "relative" : "absolute",
                    right: 0,
                    top: 0,
                    width: "100%"
                },
                children: [
                    enableGlobalFilter && positionGlobalFilter === "left" && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$d802562b525f204b, Object.assign({}, globalFilterProps)),
                    (_a = renderTopToolbarCustomActions === null || renderTopToolbarCustomActions === void 0 ? void 0 : renderTopToolbarCustomActions({
                        table: table
                    })) !== null && _a !== void 0 ? _a : (0, $aSiaI.jsx)("span", {}),
                    enableToolbarInternalActions ? (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                        sx: {
                            alignItems: "center",
                            display: "flex",
                            flexWrap: "wrap-reverse",
                            gap: "0.5rem",
                            justifyContent: "flex-end"
                        },
                        children: [
                            enableGlobalFilter && positionGlobalFilter === "right" && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$d802562b525f204b, Object.assign({}, globalFilterProps)),
                            (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$34667439d21f6b05, {
                                table: table
                            })
                        ]
                    }) : enableGlobalFilter && positionGlobalFilter === "right" && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$d802562b525f204b, Object.assign({}, globalFilterProps))
                ]
            }),
            enablePagination && [
                "both",
                "top"
            ].includes(positionPagination !== null && positionPagination !== void 0 ? positionPagination : "") && (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$bd75343f17999fc0, {
                position: "top",
                table: table
            }),
            (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$a0e4041e316730e3, {
                isTopToolbar: true,
                table: table
            })
        ]
    }));
};
const $35fd956d2f1c2be7$export$b0beff8773ab4556 = (_a)=>{
    var _b, _c;
    var { table: table } = _a, rest = $35fd956d2f1c2be7$var$__rest(_a, [
        "table"
    ]);
    const { getState: getState, options: { enableBottomToolbar: enableBottomToolbar, enableTopToolbar: enableTopToolbar, mrtTheme: { baseBackgroundColor: baseBackgroundColor }, muiTablePaperProps: muiTablePaperProps, renderBottomToolbar: renderBottomToolbar, renderTopToolbar: renderTopToolbar }, refs: { tablePaperRef: tablePaperRef } } = table;
    const { isFullScreen: isFullScreen } = getState();
    const paperProps = Object.assign(Object.assign({}, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(muiTablePaperProps, {
        table: table
    })), rest);
    return (0, $aSiaI.jsxs)((0, $e479e3bd14e95ba2$export$2e2bcd8739ae039), Object.assign({
        elevation: 2
    }, paperProps, {
        ref: (ref)=>{
            tablePaperRef.current = ref;
            if (paperProps === null || paperProps === void 0 ? void 0 : paperProps.ref) //@ts-ignore
            paperProps.ref.current = ref;
        },
        style: Object.assign(Object.assign({}, isFullScreen ? {
            bottom: 0,
            height: "100dvh",
            left: 0,
            margin: 0,
            maxHeight: "100dvh",
            maxWidth: "100dvw",
            padding: 0,
            position: "fixed",
            right: 0,
            top: 0,
            width: "100dvw",
            zIndex: 999
        } : {}), paperProps === null || paperProps === void 0 ? void 0 : paperProps.style),
        sx: (theme)=>Object.assign({
                backgroundColor: baseBackgroundColor,
                backgroundImage: "unset",
                overflow: "hidden",
                transition: "all 100ms ease-in-out"
            }, $35fd956d2f1c2be7$var$parseFromValuesOrFunc(paperProps === null || paperProps === void 0 ? void 0 : paperProps.sx, theme)),
        children: [
            enableTopToolbar && ((_b = $35fd956d2f1c2be7$var$parseFromValuesOrFunc(renderTopToolbar, {
                table: table
            })) !== null && _b !== void 0 ? _b : (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$833ce02671e611ef, {
                table: table
            })),
            (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$6409dc1204eeb66a, {
                table: table
            }),
            enableBottomToolbar && ((_c = $35fd956d2f1c2be7$var$parseFromValuesOrFunc(renderBottomToolbar, {
                table: table
            })) !== null && _c !== void 0 ? _c : (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$802d7d5e9270e154, {
                table: table
            }))
        ]
    }));
};
const $35fd956d2f1c2be7$var$isTableInstanceProp = (props)=>props.table !== undefined;
const $35fd956d2f1c2be7$export$2506d3bf41f97512 = (props)=>{
    let table;
    if ($35fd956d2f1c2be7$var$isTableInstanceProp(props)) table = props.table;
    else table = $35fd956d2f1c2be7$export$f43e1b352a4cbffc(props);
    return (0, $aSiaI.jsx)($35fd956d2f1c2be7$export$b0beff8773ab4556, {
        table: table
    });
};







/* eslint-disable no-param-reassign */ // const API_BASE = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : 'https://harbourmaster.nymtech.net';
var $8c08dc4e69356b93$exports = {};
// just pre-load all the stuff that index.js lazily exports

var $72eOO = parcelRequire("72eOO");

var $7dGQP = parcelRequire("7dGQP");
var $4f559a4ae9da40db$exports = {};

var $kaZvw = parcelRequire("kaZvw");

var $7dGQP = parcelRequire("7dGQP");
var $4f559a4ae9da40db$require$MAX_LENGTH = $7dGQP.MAX_LENGTH;
var $4f559a4ae9da40db$require$MAX_SAFE_INTEGER = $7dGQP.MAX_SAFE_INTEGER;

var $72eOO = parcelRequire("72eOO");
var $4f559a4ae9da40db$require$re = $72eOO.safeRe;
var $4f559a4ae9da40db$require$t = $72eOO.t;
var $b62c1a3fea919bad$exports = {};
// parse out just the options we care about
const $b62c1a3fea919bad$var$looseOption = Object.freeze({
    loose: true
});
const $b62c1a3fea919bad$var$emptyOpts = Object.freeze({});
const $b62c1a3fea919bad$var$parseOptions = (options)=>{
    if (!options) return $b62c1a3fea919bad$var$emptyOpts;
    if (typeof options !== "object") return $b62c1a3fea919bad$var$looseOption;
    return options;
};
$b62c1a3fea919bad$exports = $b62c1a3fea919bad$var$parseOptions;


var $efd8d78764c90bc2$exports = {};
const $efd8d78764c90bc2$var$numeric = /^[0-9]+$/;
const $efd8d78764c90bc2$var$compareIdentifiers = (a, b)=>{
    const anum = $efd8d78764c90bc2$var$numeric.test(a);
    const bnum = $efd8d78764c90bc2$var$numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
const $efd8d78764c90bc2$var$rcompareIdentifiers = (a, b)=>$efd8d78764c90bc2$var$compareIdentifiers(b, a);
$efd8d78764c90bc2$exports = {
    compareIdentifiers: $efd8d78764c90bc2$var$compareIdentifiers,
    rcompareIdentifiers: $efd8d78764c90bc2$var$rcompareIdentifiers
};


var $4f559a4ae9da40db$require$compareIdentifiers = $efd8d78764c90bc2$exports.compareIdentifiers;
class $4f559a4ae9da40db$var$SemVer {
    constructor(version, options){
        options = $b62c1a3fea919bad$exports(options);
        if (version instanceof $4f559a4ae9da40db$var$SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
            else version = version.version;
        } else if (typeof version !== "string") throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version}".`);
        if (version.length > $4f559a4ae9da40db$require$MAX_LENGTH) throw new TypeError(`version is longer than ${$4f559a4ae9da40db$require$MAX_LENGTH} characters`);
        $kaZvw("SemVer", version, options);
        this.options = options;
        this.loose = !!options.loose;
        // this isn't actually relevant for versions, but keep it so that we
        // don't run into trouble passing this.options around.
        this.includePrerelease = !!options.includePrerelease;
        const m = version.trim().match(options.loose ? $4f559a4ae9da40db$require$re[$4f559a4ae9da40db$require$t.LOOSE] : $4f559a4ae9da40db$require$re[$4f559a4ae9da40db$require$t.FULL]);
        if (!m) throw new TypeError(`Invalid Version: ${version}`);
        this.raw = version;
        // these are actually numbers
        this.major = +m[1];
        this.minor = +m[2];
        this.patch = +m[3];
        if (this.major > $4f559a4ae9da40db$require$MAX_SAFE_INTEGER || this.major < 0) throw new TypeError("Invalid major version");
        if (this.minor > $4f559a4ae9da40db$require$MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError("Invalid minor version");
        if (this.patch > $4f559a4ae9da40db$require$MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError("Invalid patch version");
        // numberify any prerelease numeric ids
        if (!m[4]) this.prerelease = [];
        else this.prerelease = m[4].split(".").map((id)=>{
            if (/^[0-9]+$/.test(id)) {
                const num = +id;
                if (num >= 0 && num < $4f559a4ae9da40db$require$MAX_SAFE_INTEGER) return num;
            }
            return id;
        });
        this.build = m[5] ? m[5].split(".") : [];
        this.format();
    }
    format() {
        this.version = `${this.major}.${this.minor}.${this.patch}`;
        if (this.prerelease.length) this.version += `-${this.prerelease.join(".")}`;
        return this.version;
    }
    toString() {
        return this.version;
    }
    compare(other) {
        $kaZvw("SemVer.compare", this.version, this.options, other);
        if (!(other instanceof $4f559a4ae9da40db$var$SemVer)) {
            if (typeof other === "string" && other === this.version) return 0;
            other = new $4f559a4ae9da40db$var$SemVer(other, this.options);
        }
        if (other.version === this.version) return 0;
        return this.compareMain(other) || this.comparePre(other);
    }
    compareMain(other) {
        if (!(other instanceof $4f559a4ae9da40db$var$SemVer)) other = new $4f559a4ae9da40db$var$SemVer(other, this.options);
        return $4f559a4ae9da40db$require$compareIdentifiers(this.major, other.major) || $4f559a4ae9da40db$require$compareIdentifiers(this.minor, other.minor) || $4f559a4ae9da40db$require$compareIdentifiers(this.patch, other.patch);
    }
    comparePre(other) {
        if (!(other instanceof $4f559a4ae9da40db$var$SemVer)) other = new $4f559a4ae9da40db$var$SemVer(other, this.options);
        // NOT having a prerelease is > having one
        if (this.prerelease.length && !other.prerelease.length) return -1;
        else if (!this.prerelease.length && other.prerelease.length) return 1;
        else if (!this.prerelease.length && !other.prerelease.length) return 0;
        let i = 0;
        do {
            const a = this.prerelease[i];
            const b = other.prerelease[i];
            $kaZvw("prerelease compare", i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $4f559a4ae9da40db$require$compareIdentifiers(a, b);
        }while (++i);
    }
    compareBuild(other) {
        if (!(other instanceof $4f559a4ae9da40db$var$SemVer)) other = new $4f559a4ae9da40db$var$SemVer(other, this.options);
        let i = 0;
        do {
            const a = this.build[i];
            const b = other.build[i];
            $kaZvw("build compare", i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $4f559a4ae9da40db$require$compareIdentifiers(a, b);
        }while (++i);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(release, identifier, identifierBase) {
        switch(release){
            case "premajor":
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor = 0;
                this.major++;
                this.inc("pre", identifier, identifierBase);
                break;
            case "preminor":
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor++;
                this.inc("pre", identifier, identifierBase);
                break;
            case "prepatch":
                // If this is already a prerelease, it will bump to the next version
                // drop any prereleases that might already exist, since they are not
                // relevant at this point.
                this.prerelease.length = 0;
                this.inc("patch", identifier, identifierBase);
                this.inc("pre", identifier, identifierBase);
                break;
            // If the input is a non-prerelease version, this acts the same as
            // prepatch.
            case "prerelease":
                if (this.prerelease.length === 0) this.inc("patch", identifier, identifierBase);
                this.inc("pre", identifier, identifierBase);
                break;
            case "major":
                // If this is a pre-major version, bump up to the same major version.
                // Otherwise increment major.
                // 1.0.0-5 bumps to 1.0.0
                // 1.1.0 bumps to 2.0.0
                if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                this.minor = 0;
                this.patch = 0;
                this.prerelease = [];
                break;
            case "minor":
                // If this is a pre-minor version, bump up to the same minor version.
                // Otherwise increment minor.
                // 1.2.0-5 bumps to 1.2.0
                // 1.2.1 bumps to 1.3.0
                if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                this.patch = 0;
                this.prerelease = [];
                break;
            case "patch":
                // If this is not a pre-release version, it will increment the patch.
                // If it is a pre-release it will bump up to the same patch version.
                // 1.2.0-5 patches to 1.2.0
                // 1.2.0 patches to 1.2.1
                if (this.prerelease.length === 0) this.patch++;
                this.prerelease = [];
                break;
            // This probably shouldn't be used publicly.
            // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
            case "pre":
                {
                    const base = Number(identifierBase) ? 1 : 0;
                    if (!identifier && identifierBase === false) throw new Error("invalid increment argument: identifier is empty");
                    if (this.prerelease.length === 0) this.prerelease = [
                        base
                    ];
                    else {
                        let i = this.prerelease.length;
                        while(--i >= 0)if (typeof this.prerelease[i] === "number") {
                            this.prerelease[i]++;
                            i = -2;
                        }
                        if (i === -1) {
                            // didn't increment anything
                            if (identifier === this.prerelease.join(".") && identifierBase === false) throw new Error("invalid increment argument: identifier already exists");
                            this.prerelease.push(base);
                        }
                    }
                    if (identifier) {
                        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                        let prerelease = [
                            identifier,
                            base
                        ];
                        if (identifierBase === false) prerelease = [
                            identifier
                        ];
                        if ($4f559a4ae9da40db$require$compareIdentifiers(this.prerelease[0], identifier) === 0) {
                            if (isNaN(this.prerelease[1])) this.prerelease = prerelease;
                        } else this.prerelease = prerelease;
                    }
                    break;
                }
            default:
                throw new Error(`invalid increment argument: ${release}`);
        }
        this.raw = this.format();
        if (this.build.length) this.raw += `+${this.build.join(".")}`;
        return this;
    }
}
$4f559a4ae9da40db$exports = $4f559a4ae9da40db$var$SemVer;



var $2ad3659b67c6eda0$exports = {};

const $2ad3659b67c6eda0$var$parse = (version, options, throwErrors = false)=>{
    if (version instanceof $4f559a4ae9da40db$exports) return version;
    try {
        return new $4f559a4ae9da40db$exports(version, options);
    } catch (er) {
        if (!throwErrors) return null;
        throw er;
    }
};
$2ad3659b67c6eda0$exports = $2ad3659b67c6eda0$var$parse;


var $a3474a39467b0277$exports = {};

const $a3474a39467b0277$var$valid = (version, options)=>{
    const v = $2ad3659b67c6eda0$exports(version, options);
    return v ? v.version : null;
};
$a3474a39467b0277$exports = $a3474a39467b0277$var$valid;


var $1d6c524eaa00b988$exports = {};

const $1d6c524eaa00b988$var$clean = (version, options)=>{
    const s = $2ad3659b67c6eda0$exports(version.trim().replace(/^[=v]+/, ""), options);
    return s ? s.version : null;
};
$1d6c524eaa00b988$exports = $1d6c524eaa00b988$var$clean;


var $47bc513c5b2c88eb$exports = {};

const $47bc513c5b2c88eb$var$inc = (version, release, options, identifier, identifierBase)=>{
    if (typeof options === "string") {
        identifierBase = identifier;
        identifier = options;
        options = undefined;
    }
    try {
        return new $4f559a4ae9da40db$exports(version instanceof $4f559a4ae9da40db$exports ? version.version : version, options).inc(release, identifier, identifierBase).version;
    } catch (er) {
        return null;
    }
};
$47bc513c5b2c88eb$exports = $47bc513c5b2c88eb$var$inc;


var $8561606f835701a9$exports = {};

const $8561606f835701a9$var$diff = (version1, version2)=>{
    const v1 = $2ad3659b67c6eda0$exports(version1, null, true);
    const v2 = $2ad3659b67c6eda0$exports(version2, null, true);
    const comparison = v1.compare(v2);
    if (comparison === 0) return null;
    const v1Higher = comparison > 0;
    const highVersion = v1Higher ? v1 : v2;
    const lowVersion = v1Higher ? v2 : v1;
    const highHasPre = !!highVersion.prerelease.length;
    const lowHasPre = !!lowVersion.prerelease.length;
    if (lowHasPre && !highHasPre) {
        // Going from prerelease -> no prerelease requires some special casing
        // If the low version has only a major, then it will always be a major
        // Some examples:
        // 1.0.0-1 -> 1.0.0
        // 1.0.0-1 -> 1.1.1
        // 1.0.0-1 -> 2.0.0
        if (!lowVersion.patch && !lowVersion.minor) return "major";
        // Otherwise it can be determined by checking the high version
        if (highVersion.patch) // anything higher than a patch bump would result in the wrong version
        return "patch";
        if (highVersion.minor) // anything higher than a minor bump would result in the wrong version
        return "minor";
        // bumping major/minor/patch all have same result
        return "major";
    }
    // add the `pre` prefix if we are going to a prerelease version
    const prefix = highHasPre ? "pre" : "";
    if (v1.major !== v2.major) return prefix + "major";
    if (v1.minor !== v2.minor) return prefix + "minor";
    if (v1.patch !== v2.patch) return prefix + "patch";
    // high and low are preleases
    return "prerelease";
};
$8561606f835701a9$exports = $8561606f835701a9$var$diff;


var $510de1ae2d97a3b8$exports = {};

const $510de1ae2d97a3b8$var$major = (a, loose)=>new $4f559a4ae9da40db$exports(a, loose).major;
$510de1ae2d97a3b8$exports = $510de1ae2d97a3b8$var$major;


var $d65e014ca05d4593$exports = {};

const $d65e014ca05d4593$var$minor = (a, loose)=>new $4f559a4ae9da40db$exports(a, loose).minor;
$d65e014ca05d4593$exports = $d65e014ca05d4593$var$minor;


var $43678f8a6f3a6488$exports = {};

const $43678f8a6f3a6488$var$patch = (a, loose)=>new $4f559a4ae9da40db$exports(a, loose).patch;
$43678f8a6f3a6488$exports = $43678f8a6f3a6488$var$patch;


var $43f8efed0d8c0b8a$exports = {};

const $43f8efed0d8c0b8a$var$prerelease = (version, options)=>{
    const parsed = $2ad3659b67c6eda0$exports(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
};
$43f8efed0d8c0b8a$exports = $43f8efed0d8c0b8a$var$prerelease;


var $61acdad3a4733a76$exports = {};

const $61acdad3a4733a76$var$compare = (a, b, loose)=>new $4f559a4ae9da40db$exports(a, loose).compare(new $4f559a4ae9da40db$exports(b, loose));
$61acdad3a4733a76$exports = $61acdad3a4733a76$var$compare;


var $1f757c485454cf94$exports = {};

const $1f757c485454cf94$var$rcompare = (a, b, loose)=>$61acdad3a4733a76$exports(b, a, loose);
$1f757c485454cf94$exports = $1f757c485454cf94$var$rcompare;


var $6abb42b6d3bcba21$exports = {};

const $6abb42b6d3bcba21$var$compareLoose = (a, b)=>$61acdad3a4733a76$exports(a, b, true);
$6abb42b6d3bcba21$exports = $6abb42b6d3bcba21$var$compareLoose;


var $57e192dd5e0ec9e7$exports = {};

const $57e192dd5e0ec9e7$var$compareBuild = (a, b, loose)=>{
    const versionA = new $4f559a4ae9da40db$exports(a, loose);
    const versionB = new $4f559a4ae9da40db$exports(b, loose);
    return versionA.compare(versionB) || versionA.compareBuild(versionB);
};
$57e192dd5e0ec9e7$exports = $57e192dd5e0ec9e7$var$compareBuild;


var $0bacafb73385ad98$exports = {};

const $0bacafb73385ad98$var$sort = (list, loose)=>list.sort((a, b)=>$57e192dd5e0ec9e7$exports(a, b, loose));
$0bacafb73385ad98$exports = $0bacafb73385ad98$var$sort;


var $9b79ebd8981cdea3$exports = {};

const $9b79ebd8981cdea3$var$rsort = (list, loose)=>list.sort((a, b)=>$57e192dd5e0ec9e7$exports(b, a, loose));
$9b79ebd8981cdea3$exports = $9b79ebd8981cdea3$var$rsort;


var $c5127b01fe515e59$exports = {};

const $c5127b01fe515e59$var$gt = (a, b, loose)=>$61acdad3a4733a76$exports(a, b, loose) > 0;
$c5127b01fe515e59$exports = $c5127b01fe515e59$var$gt;


var $34e29b92339954aa$exports = {};

const $34e29b92339954aa$var$lt = (a, b, loose)=>$61acdad3a4733a76$exports(a, b, loose) < 0;
$34e29b92339954aa$exports = $34e29b92339954aa$var$lt;


var $f5234b75b7a59d2c$exports = {};

const $f5234b75b7a59d2c$var$eq = (a, b, loose)=>$61acdad3a4733a76$exports(a, b, loose) === 0;
$f5234b75b7a59d2c$exports = $f5234b75b7a59d2c$var$eq;


var $4c1cef00def94a7c$exports = {};

const $4c1cef00def94a7c$var$neq = (a, b, loose)=>$61acdad3a4733a76$exports(a, b, loose) !== 0;
$4c1cef00def94a7c$exports = $4c1cef00def94a7c$var$neq;


var $da99ec9e584f9108$exports = {};

const $da99ec9e584f9108$var$gte = (a, b, loose)=>$61acdad3a4733a76$exports(a, b, loose) >= 0;
$da99ec9e584f9108$exports = $da99ec9e584f9108$var$gte;


var $e88fe77cd4de3a58$exports = {};

const $e88fe77cd4de3a58$var$lte = (a, b, loose)=>$61acdad3a4733a76$exports(a, b, loose) <= 0;
$e88fe77cd4de3a58$exports = $e88fe77cd4de3a58$var$lte;


var $a708fbf9747e6531$exports = {};






const $a708fbf9747e6531$var$cmp = (a, op, b, loose)=>{
    switch(op){
        case "===":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a === b;
        case "!==":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a !== b;
        case "":
        case "=":
        case "==":
            return $f5234b75b7a59d2c$exports(a, b, loose);
        case "!=":
            return $4c1cef00def94a7c$exports(a, b, loose);
        case ">":
            return $c5127b01fe515e59$exports(a, b, loose);
        case ">=":
            return $da99ec9e584f9108$exports(a, b, loose);
        case "<":
            return $34e29b92339954aa$exports(a, b, loose);
        case "<=":
            return $e88fe77cd4de3a58$exports(a, b, loose);
        default:
            throw new TypeError(`Invalid operator: ${op}`);
    }
};
$a708fbf9747e6531$exports = $a708fbf9747e6531$var$cmp;


var $df5bb16e5ca6ee3e$exports = {};



var $72eOO = parcelRequire("72eOO");
var $df5bb16e5ca6ee3e$require$re = $72eOO.safeRe;
var $df5bb16e5ca6ee3e$require$t = $72eOO.t;
const $df5bb16e5ca6ee3e$var$coerce = (version, options)=>{
    if (version instanceof $4f559a4ae9da40db$exports) return version;
    if (typeof version === "number") version = String(version);
    if (typeof version !== "string") return null;
    options = options || {};
    let match = null;
    if (!options.rtl) match = version.match(options.includePrerelease ? $df5bb16e5ca6ee3e$require$re[$df5bb16e5ca6ee3e$require$t.COERCEFULL] : $df5bb16e5ca6ee3e$require$re[$df5bb16e5ca6ee3e$require$t.COERCE]);
    else {
        // Find the right-most coercible string that does not share
        // a terminus with a more left-ward coercible string.
        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
        // With includePrerelease option set, '1.2.3.4-rc' wants to coerce '2.3.4-rc', not '2.3.4'
        //
        // Walk through the string checking with a /g regexp
        // Manually set the index so as to pick up overlapping matches.
        // Stop when we get a match that ends at the string end, since no
        // coercible string can be more right-ward without the same terminus.
        const coerceRtlRegex = options.includePrerelease ? $df5bb16e5ca6ee3e$require$re[$df5bb16e5ca6ee3e$require$t.COERCERTLFULL] : $df5bb16e5ca6ee3e$require$re[$df5bb16e5ca6ee3e$require$t.COERCERTL];
        let next;
        while((next = coerceRtlRegex.exec(version)) && (!match || match.index + match[0].length !== version.length)){
            if (!match || next.index + next[0].length !== match.index + match[0].length) match = next;
            coerceRtlRegex.lastIndex = next.index + next[1].length + next[2].length;
        }
        // leave it in a clean state
        coerceRtlRegex.lastIndex = -1;
    }
    if (match === null) return null;
    const major = match[2];
    const minor = match[3] || "0";
    const patch = match[4] || "0";
    const prerelease = options.includePrerelease && match[5] ? `-${match[5]}` : "";
    const build = options.includePrerelease && match[6] ? `+${match[6]}` : "";
    return $2ad3659b67c6eda0$exports(`${major}.${minor}.${patch}${prerelease}${build}`, options);
};
$df5bb16e5ca6ee3e$exports = $df5bb16e5ca6ee3e$var$coerce;


var $65319b5af9527ef4$exports = {};
const $65319b5af9527ef4$var$ANY = Symbol("SemVer ANY");
// hoisted class for cyclic dependency
class $65319b5af9527ef4$var$Comparator {
    static get ANY() {
        return $65319b5af9527ef4$var$ANY;
    }
    constructor(comp, options){
        options = $b62c1a3fea919bad$exports(options);
        if (comp instanceof $65319b5af9527ef4$var$Comparator) {
            if (comp.loose === !!options.loose) return comp;
            else comp = comp.value;
        }
        comp = comp.trim().split(/\s+/).join(" ");
        $kaZvw("comparator", comp, options);
        this.options = options;
        this.loose = !!options.loose;
        this.parse(comp);
        if (this.semver === $65319b5af9527ef4$var$ANY) this.value = "";
        else this.value = this.operator + this.semver.version;
        $kaZvw("comp", this);
    }
    parse(comp) {
        const r = this.options.loose ? $65319b5af9527ef4$require$re[$65319b5af9527ef4$require$t.COMPARATORLOOSE] : $65319b5af9527ef4$require$re[$65319b5af9527ef4$require$t.COMPARATOR];
        const m = comp.match(r);
        if (!m) throw new TypeError(`Invalid comparator: ${comp}`);
        this.operator = m[1] !== undefined ? m[1] : "";
        if (this.operator === "=") this.operator = "";
        // if it literally is just '>' or '' then allow anything.
        if (!m[2]) this.semver = $65319b5af9527ef4$var$ANY;
        else this.semver = new $4f559a4ae9da40db$exports(m[2], this.options.loose);
    }
    toString() {
        return this.value;
    }
    test(version) {
        $kaZvw("Comparator.test", version, this.options.loose);
        if (this.semver === $65319b5af9527ef4$var$ANY || version === $65319b5af9527ef4$var$ANY) return true;
        if (typeof version === "string") try {
            version = new $4f559a4ae9da40db$exports(version, this.options);
        } catch (er) {
            return false;
        }
        return $a708fbf9747e6531$exports(version, this.operator, this.semver, this.options);
    }
    intersects(comp, options) {
        if (!(comp instanceof $65319b5af9527ef4$var$Comparator)) throw new TypeError("a Comparator is required");
        if (this.operator === "") {
            if (this.value === "") return true;
            return new $38357dbc2258a1c2$exports(comp.value, options).test(this.value);
        } else if (comp.operator === "") {
            if (comp.value === "") return true;
            return new $38357dbc2258a1c2$exports(this.value, options).test(comp.semver);
        }
        options = $b62c1a3fea919bad$exports(options);
        // Special cases where nothing can possibly be lower
        if (options.includePrerelease && (this.value === "<0.0.0-0" || comp.value === "<0.0.0-0")) return false;
        if (!options.includePrerelease && (this.value.startsWith("<0.0.0") || comp.value.startsWith("<0.0.0"))) return false;
        // Same direction increasing (> or >=)
        if (this.operator.startsWith(">") && comp.operator.startsWith(">")) return true;
        // Same direction decreasing (< or <=)
        if (this.operator.startsWith("<") && comp.operator.startsWith("<")) return true;
        // same SemVer and both sides are inclusive (<= or >=)
        if (this.semver.version === comp.semver.version && this.operator.includes("=") && comp.operator.includes("=")) return true;
        // opposite directions less than
        if ($a708fbf9747e6531$exports(this.semver, "<", comp.semver, options) && this.operator.startsWith(">") && comp.operator.startsWith("<")) return true;
        // opposite directions greater than
        if ($a708fbf9747e6531$exports(this.semver, ">", comp.semver, options) && this.operator.startsWith("<") && comp.operator.startsWith(">")) return true;
        return false;
    }
}
$65319b5af9527ef4$exports = $65319b5af9527ef4$var$Comparator;


var $72eOO = parcelRequire("72eOO");
var $65319b5af9527ef4$require$re = $72eOO.safeRe;
var $65319b5af9527ef4$require$t = $72eOO.t;


var $kaZvw = parcelRequire("kaZvw");

var $38357dbc2258a1c2$exports = {};
// hoisted class for cyclic dependency
class $38357dbc2258a1c2$var$Range {
    constructor(range, options){
        options = $b62c1a3fea919bad$exports(options);
        if (range instanceof $38357dbc2258a1c2$var$Range) {
            if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
            else return new $38357dbc2258a1c2$var$Range(range.raw, options);
        }
        if (range instanceof $65319b5af9527ef4$exports) {
            // just put it in the set and return
            this.raw = range.value;
            this.set = [
                [
                    range
                ]
            ];
            this.format();
            return this;
        }
        this.options = options;
        this.loose = !!options.loose;
        this.includePrerelease = !!options.includePrerelease;
        // First reduce all whitespace as much as possible so we do not have to rely
        // on potentially slow regexes like \s*. This is then stored and used for
        // future error messages as well.
        this.raw = range.trim().split(/\s+/).join(" ");
        // First, split on ||
        this.set = this.raw.split("||")// map the range to a 2d array of comparators
        .map((r)=>this.parseRange(r.trim()))// throw out any comparator lists that are empty
        // this generally means that it was not a valid range, which is allowed
        // in loose mode, but will still throw if the WHOLE range is invalid.
        .filter((c)=>c.length);
        if (!this.set.length) throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
        // if we have any that are not the null set, throw out null sets.
        if (this.set.length > 1) {
            // keep the first one, in case they're all null sets
            const first = this.set[0];
            this.set = this.set.filter((c)=>!$38357dbc2258a1c2$var$isNullSet(c[0]));
            if (this.set.length === 0) this.set = [
                first
            ];
            else if (this.set.length > 1) {
                // if we have any that are *, then the range is just *
                for (const c of this.set)if (c.length === 1 && $38357dbc2258a1c2$var$isAny(c[0])) {
                    this.set = [
                        c
                    ];
                    break;
                }
            }
        }
        this.format();
    }
    format() {
        this.range = this.set.map((comps)=>comps.join(" ").trim()).join("||").trim();
        return this.range;
    }
    toString() {
        return this.range;
    }
    parseRange(range) {
        // memoize range parsing for performance.
        // this is a very hot path, and fully deterministic.
        const memoOpts = (this.options.includePrerelease && $38357dbc2258a1c2$require$FLAG_INCLUDE_PRERELEASE) | (this.options.loose && $38357dbc2258a1c2$require$FLAG_LOOSE);
        const memoKey = memoOpts + ":" + range;
        const cached = $38357dbc2258a1c2$var$cache.get(memoKey);
        if (cached) return cached;
        const loose = this.options.loose;
        // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
        const hr = loose ? $38357dbc2258a1c2$require$re[$38357dbc2258a1c2$require$t.HYPHENRANGELOOSE] : $38357dbc2258a1c2$require$re[$38357dbc2258a1c2$require$t.HYPHENRANGE];
        range = range.replace(hr, $38357dbc2258a1c2$var$hyphenReplace(this.options.includePrerelease));
        $kaZvw("hyphen replace", range);
        // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
        range = range.replace($38357dbc2258a1c2$require$re[$38357dbc2258a1c2$require$t.COMPARATORTRIM], $38357dbc2258a1c2$require$comparatorTrimReplace);
        $kaZvw("comparator trim", range);
        // `~ 1.2.3` => `~1.2.3`
        range = range.replace($38357dbc2258a1c2$require$re[$38357dbc2258a1c2$require$t.TILDETRIM], $38357dbc2258a1c2$require$tildeTrimReplace);
        $kaZvw("tilde trim", range);
        // `^ 1.2.3` => `^1.2.3`
        range = range.replace($38357dbc2258a1c2$require$re[$38357dbc2258a1c2$require$t.CARETTRIM], $38357dbc2258a1c2$require$caretTrimReplace);
        $kaZvw("caret trim", range);
        // At this point, the range is completely trimmed and
        // ready to be split into comparators.
        let rangeList = range.split(" ").map((comp)=>$38357dbc2258a1c2$var$parseComparator(comp, this.options)).join(" ").split(/\s+/)// >=0.0.0 is equivalent to *
        .map((comp)=>$38357dbc2258a1c2$var$replaceGTE0(comp, this.options));
        if (loose) // in loose mode, throw out any that are not valid comparators
        rangeList = rangeList.filter((comp)=>{
            $kaZvw("loose invalid filter", comp, this.options);
            return !!comp.match($38357dbc2258a1c2$require$re[$38357dbc2258a1c2$require$t.COMPARATORLOOSE]);
        });
        $kaZvw("range list", rangeList);
        // if any comparators are the null set, then replace with JUST null set
        // if more than one comparator, remove any * comparators
        // also, don't include the same comparator more than once
        const rangeMap = new Map();
        const comparators = rangeList.map((comp)=>new $65319b5af9527ef4$exports(comp, this.options));
        for (const comp of comparators){
            if ($38357dbc2258a1c2$var$isNullSet(comp)) return [
                comp
            ];
            rangeMap.set(comp.value, comp);
        }
        if (rangeMap.size > 1 && rangeMap.has("")) rangeMap.delete("");
        const result = [
            ...rangeMap.values()
        ];
        $38357dbc2258a1c2$var$cache.set(memoKey, result);
        return result;
    }
    intersects(range, options) {
        if (!(range instanceof $38357dbc2258a1c2$var$Range)) throw new TypeError("a Range is required");
        return this.set.some((thisComparators)=>{
            return $38357dbc2258a1c2$var$isSatisfiable(thisComparators, options) && range.set.some((rangeComparators)=>{
                return $38357dbc2258a1c2$var$isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator)=>{
                    return rangeComparators.every((rangeComparator)=>{
                        return thisComparator.intersects(rangeComparator, options);
                    });
                });
            });
        });
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(version) {
        if (!version) return false;
        if (typeof version === "string") try {
            version = new $4f559a4ae9da40db$exports(version, this.options);
        } catch (er) {
            return false;
        }
        for(let i = 0; i < this.set.length; i++){
            if ($38357dbc2258a1c2$var$testSet(this.set[i], version, this.options)) return true;
        }
        return false;
    }
}
$38357dbc2258a1c2$exports = $38357dbc2258a1c2$var$Range;
var $cdde6b91397741bc$exports = {};
class $cdde6b91397741bc$var$LRUCache {
    constructor(){
        this.max = 1000;
        this.map = new Map();
    }
    get(key) {
        const value = this.map.get(key);
        if (value === undefined) return undefined;
        else {
            // Remove the key from the map and add it to the end
            this.map.delete(key);
            this.map.set(key, value);
            return value;
        }
    }
    delete(key) {
        return this.map.delete(key);
    }
    set(key, value) {
        const deleted = this.delete(key);
        if (!deleted && value !== undefined) {
            // If cache is full, delete the least recently used item
            if (this.map.size >= this.max) {
                const firstKey = this.map.keys().next().value;
                this.delete(firstKey);
            }
            this.map.set(key, value);
        }
        return this;
    }
}
$cdde6b91397741bc$exports = $cdde6b91397741bc$var$LRUCache;


const $38357dbc2258a1c2$var$cache = new $cdde6b91397741bc$exports();



var $kaZvw = parcelRequire("kaZvw");


var $72eOO = parcelRequire("72eOO");
var $38357dbc2258a1c2$require$re = $72eOO.safeRe;
var $38357dbc2258a1c2$require$t = $72eOO.t;
var $38357dbc2258a1c2$require$comparatorTrimReplace = $72eOO.comparatorTrimReplace;
var $38357dbc2258a1c2$require$tildeTrimReplace = $72eOO.tildeTrimReplace;
var $38357dbc2258a1c2$require$caretTrimReplace = $72eOO.caretTrimReplace;

var $7dGQP = parcelRequire("7dGQP");
var $38357dbc2258a1c2$require$FLAG_INCLUDE_PRERELEASE = $7dGQP.FLAG_INCLUDE_PRERELEASE;
var $38357dbc2258a1c2$require$FLAG_LOOSE = $7dGQP.FLAG_LOOSE;
const $38357dbc2258a1c2$var$isNullSet = (c)=>c.value === "<0.0.0-0";
const $38357dbc2258a1c2$var$isAny = (c)=>c.value === "";
// take a set of comparators and determine whether there
// exists a version which can satisfy it
const $38357dbc2258a1c2$var$isSatisfiable = (comparators, options)=>{
    let result = true;
    const remainingComparators = comparators.slice();
    let testComparator = remainingComparators.pop();
    while(result && remainingComparators.length){
        result = remainingComparators.every((otherComparator)=>{
            return testComparator.intersects(otherComparator, options);
        });
        testComparator = remainingComparators.pop();
    }
    return result;
};
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
const $38357dbc2258a1c2$var$parseComparator = (comp, options)=>{
    $kaZvw("comp", comp, options);
    comp = $38357dbc2258a1c2$var$replaceCarets(comp, options);
    $kaZvw("caret", comp);
    comp = $38357dbc2258a1c2$var$replaceTildes(comp, options);
    $kaZvw("tildes", comp);
    comp = $38357dbc2258a1c2$var$replaceXRanges(comp, options);
    $kaZvw("xrange", comp);
    comp = $38357dbc2258a1c2$var$replaceStars(comp, options);
    $kaZvw("stars", comp);
    return comp;
};
const $38357dbc2258a1c2$var$isX = (id)=>!id || id.toLowerCase() === "x" || id === "*";
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0-0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0-0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0-0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0-0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0-0
// ~0.0.1 --> >=0.0.1 <0.1.0-0
const $38357dbc2258a1c2$var$replaceTildes = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>$38357dbc2258a1c2$var$replaceTilde(c, options)).join(" ");
};
const $38357dbc2258a1c2$var$replaceTilde = (comp, options)=>{
    const r = options.loose ? $38357dbc2258a1c2$require$re[$38357dbc2258a1c2$require$t.TILDELOOSE] : $38357dbc2258a1c2$require$re[$38357dbc2258a1c2$require$t.TILDE];
    return comp.replace(r, (_, M, m, p, pr)=>{
        $kaZvw("tilde", comp, _, M, m, p, pr);
        let ret;
        if ($38357dbc2258a1c2$var$isX(M)) ret = "";
        else if ($38357dbc2258a1c2$var$isX(m)) ret = `>=${M}.0.0 <${+M + 1}.0.0-0`;
        else if ($38357dbc2258a1c2$var$isX(p)) // ~1.2 == >=1.2.0 <1.3.0-0
        ret = `>=${M}.${m}.0 <${M}.${+m + 1}.0-0`;
        else if (pr) {
            $kaZvw("replaceTilde pr", pr);
            ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
        } else // ~1.2.3 == >=1.2.3 <1.3.0-0
        ret = `>=${M}.${m}.${p} <${M}.${+m + 1}.0-0`;
        $kaZvw("tilde return", ret);
        return ret;
    });
};
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0-0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0-0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0-0
// ^1.2.3 --> >=1.2.3 <2.0.0-0
// ^1.2.0 --> >=1.2.0 <2.0.0-0
// ^0.0.1 --> >=0.0.1 <0.0.2-0
// ^0.1.0 --> >=0.1.0 <0.2.0-0
const $38357dbc2258a1c2$var$replaceCarets = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>$38357dbc2258a1c2$var$replaceCaret(c, options)).join(" ");
};
const $38357dbc2258a1c2$var$replaceCaret = (comp, options)=>{
    $kaZvw("caret", comp, options);
    const r = options.loose ? $38357dbc2258a1c2$require$re[$38357dbc2258a1c2$require$t.CARETLOOSE] : $38357dbc2258a1c2$require$re[$38357dbc2258a1c2$require$t.CARET];
    const z = options.includePrerelease ? "-0" : "";
    return comp.replace(r, (_, M, m, p, pr)=>{
        $kaZvw("caret", comp, _, M, m, p, pr);
        let ret;
        if ($38357dbc2258a1c2$var$isX(M)) ret = "";
        else if ($38357dbc2258a1c2$var$isX(m)) ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0`;
        else if ($38357dbc2258a1c2$var$isX(p)) {
            if (M === "0") ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0`;
            else ret = `>=${M}.${m}.0${z} <${+M + 1}.0.0-0`;
        } else if (pr) {
            $kaZvw("replaceCaret pr", pr);
            if (M === "0") {
                if (m === "0") ret = `>=${M}.${m}.${p}-${pr} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p}-${pr} <${+M + 1}.0.0-0`;
        } else {
            $kaZvw("no pr");
            if (M === "0") {
                if (m === "0") ret = `>=${M}.${m}.${p}${z} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}${z} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p} <${+M + 1}.0.0-0`;
        }
        $kaZvw("caret return", ret);
        return ret;
    });
};
const $38357dbc2258a1c2$var$replaceXRanges = (comp, options)=>{
    $kaZvw("replaceXRanges", comp, options);
    return comp.split(/\s+/).map((c)=>$38357dbc2258a1c2$var$replaceXRange(c, options)).join(" ");
};
const $38357dbc2258a1c2$var$replaceXRange = (comp, options)=>{
    comp = comp.trim();
    const r = options.loose ? $38357dbc2258a1c2$require$re[$38357dbc2258a1c2$require$t.XRANGELOOSE] : $38357dbc2258a1c2$require$re[$38357dbc2258a1c2$require$t.XRANGE];
    return comp.replace(r, (ret, gtlt, M, m, p, pr)=>{
        $kaZvw("xRange", comp, ret, gtlt, M, m, p, pr);
        const xM = $38357dbc2258a1c2$var$isX(M);
        const xm = xM || $38357dbc2258a1c2$var$isX(m);
        const xp = xm || $38357dbc2258a1c2$var$isX(p);
        const anyX = xp;
        if (gtlt === "=" && anyX) gtlt = "";
        // if we're including prereleases in the match, then we need
        // to fix this to -0, the lowest possible prerelease value
        pr = options.includePrerelease ? "-0" : "";
        if (xM) {
            if (gtlt === ">" || gtlt === "<") // nothing is allowed
            ret = "<0.0.0-0";
            else // nothing is forbidden
            ret = "*";
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === ">") {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                gtlt = ">=";
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === "<=") {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = "<";
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            if (gtlt === "<") pr = "-0";
            ret = `${gtlt + M}.${m}.${p}${pr}`;
        } else if (xm) ret = `>=${M}.0.0${pr} <${+M + 1}.0.0-0`;
        else if (xp) ret = `>=${M}.${m}.0${pr} <${M}.${+m + 1}.0-0`;
        $kaZvw("xRange return", ret);
        return ret;
    });
};
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
const $38357dbc2258a1c2$var$replaceStars = (comp, options)=>{
    $kaZvw("replaceStars", comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace($38357dbc2258a1c2$require$re[$38357dbc2258a1c2$require$t.STAR], "");
};
const $38357dbc2258a1c2$var$replaceGTE0 = (comp, options)=>{
    $kaZvw("replaceGTE0", comp, options);
    return comp.trim().replace($38357dbc2258a1c2$require$re[options.includePrerelease ? $38357dbc2258a1c2$require$t.GTE0PRE : $38357dbc2258a1c2$require$t.GTE0], "");
};
// This function is passed to string.replace(re[t.HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0-0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0-0
// TODO build?
const $38357dbc2258a1c2$var$hyphenReplace = (incPr)=>($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr)=>{
        if ($38357dbc2258a1c2$var$isX(fM)) from = "";
        else if ($38357dbc2258a1c2$var$isX(fm)) from = `>=${fM}.0.0${incPr ? "-0" : ""}`;
        else if ($38357dbc2258a1c2$var$isX(fp)) from = `>=${fM}.${fm}.0${incPr ? "-0" : ""}`;
        else if (fpr) from = `>=${from}`;
        else from = `>=${from}${incPr ? "-0" : ""}`;
        if ($38357dbc2258a1c2$var$isX(tM)) to = "";
        else if ($38357dbc2258a1c2$var$isX(tm)) to = `<${+tM + 1}.0.0-0`;
        else if ($38357dbc2258a1c2$var$isX(tp)) to = `<${tM}.${+tm + 1}.0-0`;
        else if (tpr) to = `<=${tM}.${tm}.${tp}-${tpr}`;
        else if (incPr) to = `<${tM}.${tm}.${+tp + 1}-0`;
        else to = `<=${to}`;
        return `${from} ${to}`.trim();
    };
const $38357dbc2258a1c2$var$testSet = (set, version, options)=>{
    for(let i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(let i = 0; i < set.length; i++){
            $kaZvw(set[i].semver);
            if (set[i].semver === $65319b5af9527ef4$exports.ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                const allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
};





var $75aa4fcf3a606441$exports = {};

const $75aa4fcf3a606441$var$satisfies = (version, range, options)=>{
    try {
        range = new $38357dbc2258a1c2$exports(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
};
$75aa4fcf3a606441$exports = $75aa4fcf3a606441$var$satisfies;


var $17e316282a93475b$exports = {};

// Mostly just for testing and legacy API reasons
const $17e316282a93475b$var$toComparators = (range, options)=>new $38357dbc2258a1c2$exports(range, options).set.map((comp)=>comp.map((c)=>c.value).join(" ").trim().split(" "));
$17e316282a93475b$exports = $17e316282a93475b$var$toComparators;


var $a30d163ff1406a38$exports = {};


const $a30d163ff1406a38$var$maxSatisfying = (versions, range, options)=>{
    let max = null;
    let maxSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $38357dbc2258a1c2$exports(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new $4f559a4ae9da40db$exports(max, options);
            }
        }
    });
    return max;
};
$a30d163ff1406a38$exports = $a30d163ff1406a38$var$maxSatisfying;


var $3ec4fe1392683e1f$exports = {};


const $3ec4fe1392683e1f$var$minSatisfying = (versions, range, options)=>{
    let min = null;
    let minSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $38357dbc2258a1c2$exports(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new $4f559a4ae9da40db$exports(min, options);
            }
        }
    });
    return min;
};
$3ec4fe1392683e1f$exports = $3ec4fe1392683e1f$var$minSatisfying;


var $4bc2269924d41d27$exports = {};



const $4bc2269924d41d27$var$minVersion = (range, loose)=>{
    range = new $38357dbc2258a1c2$exports(range, loose);
    let minver = new $4f559a4ae9da40db$exports("0.0.0");
    if (range.test(minver)) return minver;
    minver = new $4f559a4ae9da40db$exports("0.0.0-0");
    if (range.test(minver)) return minver;
    minver = null;
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let setMin = null;
        comparators.forEach((comparator)=>{
            // Clone to avoid manipulating the comparator's semver object.
            const compver = new $4f559a4ae9da40db$exports(comparator.semver.version);
            switch(comparator.operator){
                case ">":
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case "":
                case ">=":
                    if (!setMin || $c5127b01fe515e59$exports(compver, setMin)) setMin = compver;
                    break;
                case "<":
                case "<=":
                    break;
                /* istanbul ignore next */ default:
                    throw new Error(`Unexpected operation: ${comparator.operator}`);
            }
        });
        if (setMin && (!minver || $c5127b01fe515e59$exports(minver, setMin))) minver = setMin;
    }
    if (minver && range.test(minver)) return minver;
    return null;
};
$4bc2269924d41d27$exports = $4bc2269924d41d27$var$minVersion;


var $6bdc31e8092f439d$exports = {};

const $6bdc31e8092f439d$var$validRange = (range, options)=>{
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new $38357dbc2258a1c2$exports(range, options).range || "*";
    } catch (er) {
        return null;
    }
};
$6bdc31e8092f439d$exports = $6bdc31e8092f439d$var$validRange;


var $1d9860f58a03bd20$exports = {};


const { ANY: $1d9860f58a03bd20$var$ANY } = $65319b5af9527ef4$exports;






const $1d9860f58a03bd20$var$outside = (version, range, hilo, options)=>{
    version = new $4f559a4ae9da40db$exports(version, options);
    range = new $38357dbc2258a1c2$exports(range, options);
    let gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case ">":
            gtfn = $c5127b01fe515e59$exports;
            ltefn = $e88fe77cd4de3a58$exports;
            ltfn = $34e29b92339954aa$exports;
            comp = ">";
            ecomp = ">=";
            break;
        case "<":
            gtfn = $34e29b92339954aa$exports;
            ltefn = $da99ec9e584f9108$exports;
            ltfn = $c5127b01fe515e59$exports;
            comp = "<";
            ecomp = "<=";
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisfies the range it is not outside
    if ($75aa4fcf3a606441$exports(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let high = null;
        let low = null;
        comparators.forEach((comparator)=>{
            if (comparator.semver === $1d9860f58a03bd20$var$ANY) comparator = new $65319b5af9527ef4$exports(">=0.0.0");
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
};
$1d9860f58a03bd20$exports = $1d9860f58a03bd20$var$outside;


var $f482bc0c874938ef$exports = {};
// Determine if version is greater than all the versions possible in the range.

const $f482bc0c874938ef$var$gtr = (version, range, options)=>$1d9860f58a03bd20$exports(version, range, ">", options);
$f482bc0c874938ef$exports = $f482bc0c874938ef$var$gtr;


var $d872086aa745a773$exports = {};

// Determine if version is less than all the versions possible in the range
const $d872086aa745a773$var$ltr = (version, range, options)=>$1d9860f58a03bd20$exports(version, range, "<", options);
$d872086aa745a773$exports = $d872086aa745a773$var$ltr;


var $d6a39541936e2dda$exports = {};

const $d6a39541936e2dda$var$intersects = (r1, r2, options)=>{
    r1 = new $38357dbc2258a1c2$exports(r1, options);
    r2 = new $38357dbc2258a1c2$exports(r2, options);
    return r1.intersects(r2, options);
};
$d6a39541936e2dda$exports = $d6a39541936e2dda$var$intersects;


var $8cc228ff6cd44518$exports = {};
// given a set of versions and a range, create a "simplified" range
// that includes the same versions that the original range does
// If the original range is shorter than the simplified one, return that.


$8cc228ff6cd44518$exports = (versions, range, options)=>{
    const set = [];
    let first = null;
    let prev = null;
    const v = versions.sort((a, b)=>$61acdad3a4733a76$exports(a, b, options));
    for (const version of v){
        const included = $75aa4fcf3a606441$exports(version, range, options);
        if (included) {
            prev = version;
            if (!first) first = version;
        } else {
            if (prev) set.push([
                first,
                prev
            ]);
            prev = null;
            first = null;
        }
    }
    if (first) set.push([
        first,
        null
    ]);
    const ranges = [];
    for (const [min, max] of set){
        if (min === max) ranges.push(min);
        else if (!max && min === v[0]) ranges.push("*");
        else if (!max) ranges.push(`>=${min}`);
        else if (min === v[0]) ranges.push(`<=${max}`);
        else ranges.push(`${min} - ${max}`);
    }
    const simplified = ranges.join(" || ");
    const original = typeof range.raw === "string" ? range.raw : String(range);
    return simplified.length < original.length ? simplified : range;
};


var $4295071030187a7c$exports = {};


const { ANY: $4295071030187a7c$var$ANY } = $65319b5af9527ef4$exports;


// Complex range `r1 || r2 || ...` is a subset of `R1 || R2 || ...` iff:
// - Every simple range `r1, r2, ...` is a null set, OR
// - Every simple range `r1, r2, ...` which is not a null set is a subset of
//   some `R1, R2, ...`
//
// Simple range `c1 c2 ...` is a subset of simple range `C1 C2 ...` iff:
// - If c is only the ANY comparator
//   - If C is only the ANY comparator, return true
//   - Else if in prerelease mode, return false
//   - else replace c with `[>=0.0.0]`
// - If C is only the ANY comparator
//   - if in prerelease mode, return true
//   - else replace C with `[>=0.0.0]`
// - Let EQ be the set of = comparators in c
// - If EQ is more than one, return true (null set)
// - Let GT be the highest > or >= comparator in c
// - Let LT be the lowest < or <= comparator in c
// - If GT and LT, and GT.semver > LT.semver, return true (null set)
// - If any C is a = range, and GT or LT are set, return false
// - If EQ
//   - If GT, and EQ does not satisfy GT, return true (null set)
//   - If LT, and EQ does not satisfy LT, return true (null set)
//   - If EQ satisfies every C, return true
//   - Else return false
// - If GT
//   - If GT.semver is lower than any > or >= comp in C, return false
//   - If GT is >=, and GT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the GT.semver tuple, return false
// - If LT
//   - If LT.semver is greater than any < or <= comp in C, return false
//   - If LT is <=, and LT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the LT.semver tuple, return false
// - Else return true
const $4295071030187a7c$var$subset = (sub, dom, options = {})=>{
    if (sub === dom) return true;
    sub = new $38357dbc2258a1c2$exports(sub, options);
    dom = new $38357dbc2258a1c2$exports(dom, options);
    let sawNonNull = false;
    OUTER: for (const simpleSub of sub.set){
        for (const simpleDom of dom.set){
            const isSub = $4295071030187a7c$var$simpleSubset(simpleSub, simpleDom, options);
            sawNonNull = sawNonNull || isSub !== null;
            if (isSub) continue OUTER;
        }
        // the null set is a subset of everything, but null simple ranges in
        // a complex range should be ignored.  so if we saw a non-null range,
        // then we know this isn't a subset, but if EVERY simple range was null,
        // then it is a subset.
        if (sawNonNull) return false;
    }
    return true;
};
const $4295071030187a7c$var$minimumVersionWithPreRelease = [
    new $65319b5af9527ef4$exports(">=0.0.0-0")
];
const $4295071030187a7c$var$minimumVersion = [
    new $65319b5af9527ef4$exports(">=0.0.0")
];
const $4295071030187a7c$var$simpleSubset = (sub, dom, options)=>{
    if (sub === dom) return true;
    if (sub.length === 1 && sub[0].semver === $4295071030187a7c$var$ANY) {
        if (dom.length === 1 && dom[0].semver === $4295071030187a7c$var$ANY) return true;
        else if (options.includePrerelease) sub = $4295071030187a7c$var$minimumVersionWithPreRelease;
        else sub = $4295071030187a7c$var$minimumVersion;
    }
    if (dom.length === 1 && dom[0].semver === $4295071030187a7c$var$ANY) {
        if (options.includePrerelease) return true;
        else dom = $4295071030187a7c$var$minimumVersion;
    }
    const eqSet = new Set();
    let gt, lt;
    for (const c of sub){
        if (c.operator === ">" || c.operator === ">=") gt = $4295071030187a7c$var$higherGT(gt, c, options);
        else if (c.operator === "<" || c.operator === "<=") lt = $4295071030187a7c$var$lowerLT(lt, c, options);
        else eqSet.add(c.semver);
    }
    if (eqSet.size > 1) return null;
    let gtltComp;
    if (gt && lt) {
        gtltComp = $61acdad3a4733a76$exports(gt.semver, lt.semver, options);
        if (gtltComp > 0) return null;
        else if (gtltComp === 0 && (gt.operator !== ">=" || lt.operator !== "<=")) return null;
    }
    // will iterate one or zero times
    for (const eq of eqSet){
        if (gt && !$75aa4fcf3a606441$exports(eq, String(gt), options)) return null;
        if (lt && !$75aa4fcf3a606441$exports(eq, String(lt), options)) return null;
        for (const c of dom){
            if (!$75aa4fcf3a606441$exports(eq, String(c), options)) return false;
        }
        return true;
    }
    let higher, lower;
    let hasDomLT, hasDomGT;
    // if the subset has a prerelease, we need a comparator in the superset
    // with the same tuple and a prerelease, or it's not a subset
    let needDomLTPre = lt && !options.includePrerelease && lt.semver.prerelease.length ? lt.semver : false;
    let needDomGTPre = gt && !options.includePrerelease && gt.semver.prerelease.length ? gt.semver : false;
    // exception: <1.2.3-0 is the same as <1.2.3
    if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt.operator === "<" && needDomLTPre.prerelease[0] === 0) needDomLTPre = false;
    for (const c of dom){
        hasDomGT = hasDomGT || c.operator === ">" || c.operator === ">=";
        hasDomLT = hasDomLT || c.operator === "<" || c.operator === "<=";
        if (gt) {
            if (needDomGTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomGTPre.major && c.semver.minor === needDomGTPre.minor && c.semver.patch === needDomGTPre.patch) needDomGTPre = false;
            }
            if (c.operator === ">" || c.operator === ">=") {
                higher = $4295071030187a7c$var$higherGT(gt, c, options);
                if (higher === c && higher !== gt) return false;
            } else if (gt.operator === ">=" && !$75aa4fcf3a606441$exports(gt.semver, String(c), options)) return false;
        }
        if (lt) {
            if (needDomLTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomLTPre.major && c.semver.minor === needDomLTPre.minor && c.semver.patch === needDomLTPre.patch) needDomLTPre = false;
            }
            if (c.operator === "<" || c.operator === "<=") {
                lower = $4295071030187a7c$var$lowerLT(lt, c, options);
                if (lower === c && lower !== lt) return false;
            } else if (lt.operator === "<=" && !$75aa4fcf3a606441$exports(lt.semver, String(c), options)) return false;
        }
        if (!c.operator && (lt || gt) && gtltComp !== 0) return false;
    }
    // if there was a < or >, and nothing in the dom, then must be false
    // UNLESS it was limited by another range in the other direction.
    // Eg, >1.0.0 <1.0.1 is still a subset of <2.0.0
    if (gt && hasDomLT && !lt && gtltComp !== 0) return false;
    if (lt && hasDomGT && !gt && gtltComp !== 0) return false;
    // we needed a prerelease range in a specific tuple, but didn't get one
    // then this isn't a subset.  eg >=1.2.3-pre is not a subset of >=1.0.0,
    // because it includes prereleases in the 1.2.3 tuple
    if (needDomGTPre || needDomLTPre) return false;
    return true;
};
// >=1.2.3 is lower than >1.2.3
const $4295071030187a7c$var$higherGT = (a, b, options)=>{
    if (!a) return b;
    const comp = $61acdad3a4733a76$exports(a.semver, b.semver, options);
    return comp > 0 ? a : comp < 0 ? b : b.operator === ">" && a.operator === ">=" ? b : a;
};
// <=1.2.3 is higher than <1.2.3
const $4295071030187a7c$var$lowerLT = (a, b, options)=>{
    if (!a) return b;
    const comp = $61acdad3a4733a76$exports(a.semver, b.semver, options);
    return comp < 0 ? a : comp > 0 ? b : b.operator === "<" && a.operator === "<=" ? b : a;
};
$4295071030187a7c$exports = $4295071030187a7c$var$subset;


$8c08dc4e69356b93$exports = {
    parse: $2ad3659b67c6eda0$exports,
    valid: $a3474a39467b0277$exports,
    clean: $1d6c524eaa00b988$exports,
    inc: $47bc513c5b2c88eb$exports,
    diff: $8561606f835701a9$exports,
    major: $510de1ae2d97a3b8$exports,
    minor: $d65e014ca05d4593$exports,
    patch: $43678f8a6f3a6488$exports,
    prerelease: $43f8efed0d8c0b8a$exports,
    compare: $61acdad3a4733a76$exports,
    rcompare: $1f757c485454cf94$exports,
    compareLoose: $6abb42b6d3bcba21$exports,
    compareBuild: $57e192dd5e0ec9e7$exports,
    sort: $0bacafb73385ad98$exports,
    rsort: $9b79ebd8981cdea3$exports,
    gt: $c5127b01fe515e59$exports,
    lt: $34e29b92339954aa$exports,
    eq: $f5234b75b7a59d2c$exports,
    neq: $4c1cef00def94a7c$exports,
    gte: $da99ec9e584f9108$exports,
    lte: $e88fe77cd4de3a58$exports,
    cmp: $a708fbf9747e6531$exports,
    coerce: $df5bb16e5ca6ee3e$exports,
    Comparator: $65319b5af9527ef4$exports,
    Range: $38357dbc2258a1c2$exports,
    satisfies: $75aa4fcf3a606441$exports,
    toComparators: $17e316282a93475b$exports,
    maxSatisfying: $a30d163ff1406a38$exports,
    minSatisfying: $3ec4fe1392683e1f$exports,
    minVersion: $4bc2269924d41d27$exports,
    validRange: $6bdc31e8092f439d$exports,
    outside: $1d9860f58a03bd20$exports,
    gtr: $f482bc0c874938ef$exports,
    ltr: $d872086aa745a773$exports,
    intersects: $d6a39541936e2dda$exports,
    simplifyRange: $8cc228ff6cd44518$exports,
    subset: $4295071030187a7c$exports,
    SemVer: $4f559a4ae9da40db$exports,
    re: $72eOO.re,
    src: $72eOO.src,
    tokens: $72eOO.t,
    SEMVER_SPEC_VERSION: $7dGQP.SEMVER_SPEC_VERSION,
    RELEASE_TYPES: $7dGQP.RELEASE_TYPES,
    compareIdentifiers: $efd8d78764c90bc2$exports.compareIdentifiers,
    rcompareIdentifiers: $efd8d78764c90bc2$exports.rcompareIdentifiers
};


const $8d995646af892e7d$export$149ea0a63fc31f44 = "1.1.7";
const $8d995646af892e7d$export$8387896f8e84cb45 = {
    panda: {
        emoji: "\uD83D\uDC3C",
        minScore: 600
    },
    dolphin: {
        emoji: "\uD83D\uDC2C",
        minScore: 500
    },
    fox: {
        emoji: "\uD83E\uDD8A",
        minScore: 400
    },
    mouse: {
        emoji: "\uD83D\uDC2D",
        minScore: 0
    }
};
const $8d995646af892e7d$export$5e9c3d4235c9a19 = {
    peanut: {
        emoji: "\uD83E\uDD5C",
        minScore: 1200
    },
    icecream: {
        emoji: "\uD83C\uDF66",
        minScore: 1000
    },
    popcorn: {
        emoji: "\uD83C\uDF7F",
        minScore: 900
    },
    lollipop: {
        emoji: "\uD83C\uDF6D",
        minScore: 300
    }
};


const $f6fedae2cedfe3de$export$28dd95a052841a60 = (version)=>{
    if (!version) return false;
    return (0, $8c08dc4e69356b93$exports.gte)(version, (0, $8d995646af892e7d$export$149ea0a63fc31f44));
};
const $f6fedae2cedfe3de$export$3d15f89d8832d4ad = (item)=>{
    const version = item.self_described?.build_information?.build_version || "0.0.0";
    const binaryName = item.self_described?.build_information?.binary_name;
    const configScoreItems = {
        runsEntryGateway: Boolean(item.explorer_pretty_bond?.gateway?.identity_key),
        runsNymnode: binaryName === "nym-node",
        minBuildVersion: $f6fedae2cedfe3de$export$28dd95a052841a60(version) && binaryName === "nym-node",
        runsIPR: Boolean(item.self_described?.ip_packet_router?.address),
        runsNetworkRequester: Boolean(item.self_described?.network_requester?.address),
        usesExitPolicy: Boolean(item.self_described?.network_requester?.uses_exit_policy) !== false,
        setLocation: Boolean(item.self_described?.auxiliary_details?.location),
        runsAuthenticatorServiceProvider: Boolean(item.self_described?.authenticator?.address?.length)
    };
    let configScore = 0;
    if (configScoreItems.minBuildVersion) configScore += 100;
    if (configScoreItems.runsNymnode) configScore += 100;
    if (configScoreItems.runsIPR) configScore += 100;
    if (configScoreItems.runsNetworkRequester) configScore += 100;
    if (configScoreItems.usesExitPolicy) configScore += 100;
    if (configScoreItems.runsAuthenticatorServiceProvider) configScore += 100;
    return {
        configScoreItems: configScoreItems,
        configScore: configScore
    };
};


const $94014da42722289c$export$4c578c6b7b4ab859 = (item)=>{
    let probeScore = 0;
    const probeScoreItems = item.last_probe_result?.outcome;
    if (probeScoreItems?.as_entry?.can_connect) probeScore += 100;
    if (probeScoreItems?.as_entry?.can_route) probeScore += 100;
    if (probeScoreItems?.as_exit?.can_connect) probeScore += 100;
    if (probeScoreItems?.as_exit?.can_route_ip_v4) probeScore += 100;
    if (probeScoreItems?.as_exit?.can_route_ip_v6) probeScore += 100;
    if (probeScoreItems?.as_exit?.can_route_ip_external_v4) probeScore += 100;
    if (probeScoreItems?.as_exit?.can_route_ip_external_v6) probeScore += 100;
    if (probeScoreItems?.wg?.can_handshake) probeScore += 100;
    if (probeScoreItems?.wg?.can_register) probeScore += 100;
    if (probeScoreItems?.wg?.can_resolve_dns) probeScore += 100;
    if (probeScoreItems?.wg?.ping_hosts_performance > 0.75) probeScore += 100;
    if (probeScoreItems?.wg?.ping_ips_performance > 0.75) probeScore += 100;
    return {
        probeScore: probeScore,
        probeScoreItems: probeScoreItems
    };
};


const $f66fa928cd4a99c0$var$API_BASE = "https://harbourmaster.nymtech.net";
const $f66fa928cd4a99c0$var$NYM_API_BASE = "https://validator.nymtech.net";
const $f66fa928cd4a99c0$var$mapGatewayItem = (item)=>{
    item.config_score_calculated = 0;
    const configScore = (0, $f6fedae2cedfe3de$export$3d15f89d8832d4ad)(item);
    const probeScore = (0, $94014da42722289c$export$4c578c6b7b4ab859)(item);
    const probeScoreItems = item.last_probe_result?.outcome;
    const gatewayScore = {
        ...configScore,
        ...probeScore
    };
    item.gatewayScore = gatewayScore;
    item.config_score_calculated = gatewayScore.configScore;
    item.probe_score_calculated = gatewayScore.probeScore;
    item.last_testrun_utc = new Date(item.last_testrun_utc);
    item.last_updated_utc = new Date(item.last_updated_utc);
    item.wg_performance = Math.round(((probeScoreItems?.wg?.ping_hosts_performance || 0) * 100 + (probeScoreItems?.wg?.ping_ips_performance || 0) * 100) / 2);
};
const $f66fa928cd4a99c0$var$mapMixnodeItem = (item)=>{
    item.last_updated_utc = new Date(item.last_updated_utc);
    const version = item.self_described?.self_described?.build_information?.build_version || "0.0.0";
    const binaryName = item.self_described?.self_described?.build_information?.binary_name;
    const acceptsTermsAndConditions = Boolean(item.self_described?.self_described?.auxiliary_details?.accepted_operator_terms_and_conditions);
    item.config = {
        version: version,
        binaryName: binaryName
    };
    item.configScore = {
        acceptsTermsAndConditions: acceptsTermsAndConditions,
        runsNymnode: binaryName === "nym-node",
        minBuildVersion: (0, $f6fedae2cedfe3de$export$28dd95a052841a60)(version) && binaryName === "nym-node"
    };
};
const $f66fa928cd4a99c0$export$644d8ea042df96a6 = {
    mixFetchGateways: async ()=>{
        const res = await fetch(`${$f66fa928cd4a99c0$var$API_BASE}/v2/services?size=200&entry=true&wss=true`);
        const page = await res.json();
        page.items.forEach((item)=>{
            item.last_successful_ping_utc = new Date(item.last_successful_ping_utc);
            item.last_updated_utc = new Date(item.last_updated_utc);
        });
        return page;
    },
    services: async ()=>{
        const res = await fetch(`${$f66fa928cd4a99c0$var$API_BASE}/v2/services?size=200`);
        const page = await res.json();
        page.items.forEach((item)=>{
            item.last_successful_ping_utc = new Date(item.last_successful_ping_utc);
            item.last_updated_utc = new Date(item.last_updated_utc);
        });
        return page;
    },
    gateways: async ()=>{
        let total = 0;
        const items = [];
        for(let pageNo = 0; pageNo < 20; pageNo += 1){
            // eslint-disable-next-line no-await-in-loop
            const res = await fetch(`${$f66fa928cd4a99c0$var$API_BASE}/v2/gateways?page=${pageNo}&size=200`);
            // eslint-disable-next-line no-await-in-loop
            const page = await res.json();
            page.items.forEach($f66fa928cd4a99c0$var$mapGatewayItem);
            total = page.total;
            items.push(...page.items);
            if (items.length >= total) break;
        }
        return items;
    },
    gateway: async (identityKey)=>{
        const res = await fetch(`${$f66fa928cd4a99c0$var$API_BASE}/v2/gateways/${identityKey}`);
        if (res.status !== 200) throw new Error("Unable to get gateway details");
        const data = await res.json();
        $f66fa928cd4a99c0$var$mapGatewayItem(data);
        return data;
    },
    gatewayTestResults: async (identityKey, page = 0)=>{
        const res = await fetch(`${$f66fa928cd4a99c0$var$NYM_API_BASE}/api/v1/status/gateways/unstable/${identityKey}/test-results?page=${page}&per_page=100`);
        const data = await res.json();
        data.data.forEach((item)=>{
            item.epoch = item.timestamp;
            item.timestamp = new Date(item.timestamp * 1000);
        });
        return data;
    },
    gatewayCoreCount: async (identityKey)=>{
        const res = await fetch(`${$f66fa928cd4a99c0$var$NYM_API_BASE}/api/v1/status/gateway/${identityKey}/core-status-count`);
        const data = await res.json();
        return data;
    },
    gatewayAverageUptime: async (identityKey)=>{
        const res = await fetch(`${$f66fa928cd4a99c0$var$NYM_API_BASE}/api/v1/status/gateway/${identityKey}/avg_uptime`);
        const data = await res.json();
        return data;
    },
    mixnodes: async ()=>{
        let total = 0;
        const items = [];
        for(let pageNo = 0; pageNo < 20; pageNo += 1){
            // eslint-disable-next-line no-await-in-loop
            const res = await fetch(`${$f66fa928cd4a99c0$var$API_BASE}/v2/mixnodes?page=${pageNo}&size=200`);
            // eslint-disable-next-line no-await-in-loop
            const page = await res.json();
            page.items.forEach($f66fa928cd4a99c0$var$mapMixnodeItem);
            total = page.total;
            items.push(...page.items);
            if (items.length >= total) break;
        }
        return items;
    },
    mixnode: async (identityKey)=>{
        const res = await fetch(`${$f66fa928cd4a99c0$var$API_BASE}/v2/mixnodes/${identityKey}`);
        const data = await res.json();
        $f66fa928cd4a99c0$var$mapMixnodeItem(data);
        return data;
    },
    mixnodeStats: async ()=>{
        const res = await fetch(`${$f66fa928cd4a99c0$var$API_BASE}/v2/mixnodes/stats`);
        const data = await res.json();
        return data.slice(1, -2); // trim off first item, and last item (current day)
    },
    summary: async ()=>{
        const res = await fetch(`${$f66fa928cd4a99c0$var$API_BASE}/v2/summary`);
        const data = await res.json();
        return data;
    },
    summaryHistory: async ()=>{
        const res = await fetch(`${$f66fa928cd4a99c0$var$API_BASE}/v2/summary/history`);
        const data = await res.json();
        return data;
    }
};


const $b95301175869a770$export$c447b0cdbd1cd184 = ()=>{
    const [services, setServices] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState([]);
    const [lastUpdated, setLastUpdated] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState();
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [busyMessage, setBusyMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState();
    const refreshServices = async ()=>{
        try {
            const newServices = await (0, $f66fa928cd4a99c0$export$644d8ea042df96a6).services();
            setServices(newServices.items);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("Error getting services", e);
        }
    };
    const refresh = async ()=>{
        try {
            setBusy(true);
            setBusyMessage("Getting latest data...");
            await refreshServices();
            setLastUpdated(new Date());
            setBusyMessage("Finishing refresh...");
        } finally{
            setBusy(false);
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        refresh();
        const timer = setInterval(refresh, 300000);
        return ()=>clearInterval(timer);
    }, []);
    const columns = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useMemo(()=>[
            {
                header: "Identity Key",
                accessorKey: "gateway_identity_key",
                Cell: ({ cell: cell })=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $c14ca1eac99fe440$export$2e2bcd8739ae039), {
                        component: (0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a),
                        to: `/gateway/${cell.getValue()}`,
                        children: cell.getValue()
                    })
            },
            {
                header: "Hostname",
                accessorKey: "hostname"
            },
            {
                header: "IP Address",
                accessorKey: "ip_address"
            },
            {
                header: "Mixnet Client Websocket Port",
                accessorKey: "mixnet_websockets.ws_port"
            },
            {
                header: "Mixnet Client Secure Websocket Port",
                accessorKey: "mixnet_websockets.wss_port"
            },
            {
                header: "Last successful ping",
                accessorKey: "last_successful_ping_utc",
                Cell: ({ cell: cell })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("strong", {
                                children: (0, $08c0c798d1b2bf8a$export$2e2bcd8739ae039)(cell.row.original.last_successful_ping_utc, {
                                    addSuffix: true
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                            cell.row.original.last_successful_ping_utc.toISOString()
                        ]
                    })
            },
            {
                header: "SOCKS5 Service Provider Client Ic",
                accessorKey: "service_provider_client_id",
                width: 150
            }
        ], []);
    const table = (0, $35fd956d2f1c2be7$export$f43e1b352a4cbffc)({
        columns: columns,
        initialState: {
            pagination: {
                pageSize: 25,
                pageIndex: 0
            },
            density: "compact",
            showColumnFilters: true,
            sorting: [
                {
                    id: "probeScoreCalculated",
                    desc: true
                }
            ]
        },
        data: services,
        enableRowSelection: true,
        enableColumnOrdering: false,
        enableGlobalFilter: false
    });
    if (!lastUpdated) return null;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        mt: 5,
        py: 2,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                        children: busy ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                            children: busyMessage || "Refreshing..."
                        }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $980dfff3cab72cf4$export$2e2bcd8739ae039), {
                            variant: "outlined",
                            onClick: refresh,
                            children: "Refresh"
                        })
                    }),
                    lastUpdated && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e10e66deff206ed9$export$2e2bcd8739ae039), {
                        direction: "row",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                                children: "Last updated"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("strong", {
                                        children: (0, $08c0c798d1b2bf8a$export$2e2bcd8739ae039)(lastUpdated, {
                                            addSuffix: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                    lastUpdated.toISOString()
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $35fd956d2f1c2be7$export$2506d3bf41f97512), {
                table: table
            })
        ]
    });
};


/* eslint-disable react/no-unstable-nested-components */ 
var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");









const $025a3f487640efd2$export$68d8ed05fb20d71 = ()=>{
    const [services, setServices] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState([]);
    const [lastUpdated, setLastUpdated] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState();
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [busyMessage, setBusyMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState();
    const refreshServices = async ()=>{
        try {
            const newServices = await (0, $f66fa928cd4a99c0$export$644d8ea042df96a6).mixFetchGateways();
            setServices(newServices.items);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("Error getting services", e);
        }
    };
    const refresh = async ()=>{
        try {
            setBusy(true);
            setBusyMessage("Getting latest data...");
            await refreshServices();
            setLastUpdated(new Date());
            setBusyMessage("Finishing refresh...");
        } finally{
            setBusy(false);
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        refresh();
        const timer = setInterval(refresh, 300000);
        return ()=>clearInterval(timer);
    }, []);
    const columns = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useMemo(()=>[
            {
                header: "Identity Key",
                accessorKey: "gateway_identity_key",
                Cell: ({ cell: cell })=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $c14ca1eac99fe440$export$2e2bcd8739ae039), {
                        component: (0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a),
                        to: `/gateway/${cell.getValue()}`,
                        children: cell.getValue()
                    })
            },
            {
                header: "Hostname",
                accessorKey: "hostname"
            },
            {
                header: "IP Address",
                accessorKey: "ip_address"
            },
            {
                header: "Mixnet Client Websocket Port",
                accessorKey: "mixnet_websockets.ws_port"
            },
            {
                header: "Mixnet Client Secure Websocket Port",
                accessorKey: "mixnet_websockets.wss_port"
            },
            {
                header: "Last successful ping",
                accessorKey: "last_successful_ping_utc",
                Cell: ({ cell: cell })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("strong", {
                                children: (0, $08c0c798d1b2bf8a$export$2e2bcd8739ae039)(cell.row.original.last_successful_ping_utc, {
                                    addSuffix: true
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                            cell.row.original.last_successful_ping_utc.toISOString()
                        ]
                    })
            },
            {
                header: "SOCKS5 Service Provider Client Ic",
                accessorKey: "service_provider_client_id",
                width: 150
            }
        ], []);
    const table = (0, $35fd956d2f1c2be7$export$f43e1b352a4cbffc)({
        columns: columns,
        initialState: {
            pagination: {
                pageSize: 25,
                pageIndex: 0
            },
            density: "compact",
            showColumnFilters: true,
            sorting: [
                {
                    id: "probeScoreCalculated",
                    desc: true
                }
            ]
        },
        data: services,
        enableRowSelection: true,
        enableColumnOrdering: false,
        enableGlobalFilter: false
    });
    if (!lastUpdated) return null;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        mt: 5,
        py: 2,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                        children: busy ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                            children: busyMessage || "Refreshing..."
                        }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $980dfff3cab72cf4$export$2e2bcd8739ae039), {
                            variant: "outlined",
                            onClick: refresh,
                            children: "Refresh"
                        })
                    }),
                    lastUpdated && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e10e66deff206ed9$export$2e2bcd8739ae039), {
                        direction: "row",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                                children: "Last updated"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("strong", {
                                        children: (0, $08c0c798d1b2bf8a$export$2e2bcd8739ae039)(lastUpdated, {
                                            addSuffix: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                    lastUpdated.toISOString()
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $35fd956d2f1c2be7$export$2506d3bf41f97512), {
                table: table
            })
        ]
    });
};


/* eslint-disable react/no-unstable-nested-components */ 
var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");










var $8c326551a00e77e9$exports = {};

!function(c, a) {
    $8c326551a00e77e9$exports = a((parcelRequire("exYeM")));
}($8c326551a00e77e9$exports, (c)=>(()=>{
        var a = {
            3630: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1000 700'%3e%3cpath fill='%23d0103a' d='M0 0h1000v700H0z'/%3e%3cpath fill='%23fedf00' d='M0 0h680v700H0z'/%3e%3cpath fill='%230018a8' d='M0 0h320v700H0z'/%3e%3cpath fill='%23c7b37f' d='M469.37 188.48c12.05 0 16.98 10.34 29.03 10.34 7.44 0 11.78-2.43 18.26-6.09 4.52-2.56 7.41-3.93 12.6-3.93 5.32 0 8.58 1.61 11.3 6.17 1.54 2.58 2.82 7.63 2.14 10.53a62.43 62.43 0 0 1-4.26 12.95c-1.04 2.44-2.03 3.9-2.03 6.56 0 6.4 8.7 8.6 14.63 8.69 1.29.02 12.13.2 18.81-6.56-3.62-.16-7.67-2.97-7.67-6.59 0-4.1 2.88-6.87 6.78-8.05.74-.22 2 .44 2.68.09.95-.5.5-1.57 1.35-2.24 1.95-1.56 3.21-2.53 5.7-2.53 1.63 0 2.58.23 3.89 1.17.69.49.94 1.1 1.79 1.1 1.78 0 2.67-1.13 4.45-1.13 1.45 0 2.33.2 3.6.85 1.07.55 1.04 2.35 2.24 2.35.6 0 3.78-1.3 5.44-1.3 3.45 0 5.29 1.25 7.52 3.87.6.7.98 2.13 1.6 2.13a9.72 9.72 0 0 1 7.5 4.6c.41.65 1.03 2.25 1.75 2.53.84.32 1.55.26 2.66.97 2.52 1.62 4.47 4.66 4.37 7.6-.03 1-.48 2.38-.75 3.32-2.94 10.28-9.94 13.55-17 22.38-3 3.76-5.38 6.77-5.38 11.6 0 1.16 1.44 3.3 2.07 4.26-.39-2.26.65-5.05 3.05-5.18 3.28-.17 5.81 2.32 6.25 5.57.1.76-.19 2.08-.51 2.85a14.92 14.92 0 0 1 6.21-2.2c1.15-.12 1.82-.16 2.98-.13 5.25.13 11.04 3.08 14.55 6.07 10.75 9.13 12.05 22.49 11.46 26.2-1.3 8.24-.48 23.17-21.56 29.12 3.9 1.64 6.55 4.57 6.55 8.17 0 3.93-3 7.28-6.93 7.28-2.24 0-3.8-.55-5.37-2.12-4.38 4.38-5.23 8.85-5.23 15.06 0 3.7.7 5.9 2.26 9.26 1.65 3.55 2.83 5.63 5.8 8.2 1.57-2.37 3.23-4.1 6.08-4.1 2.75 0 5.09.88 6.22 3.39.33.76.03 1.38.42 2.12.5.95 1.33 1.16 1.84 2.12.8 1.46.02 2.72.7 4.24.45.99 1.42 1.13 1.84 2.12.67 1.52.85 2.56.85 4.24 0 4.7-4.27 8.06-8.97 8.06-1.42 0-2.2-.57-3.6-.43 2.68 2.69 4.73 3.86 6.78 7.07 2.96 4.65 3.7 7.95 4.38 13.43.12 1.02.14 1.64.14 2.69 0 7.03-1.1 11.23-4.24 17.52-3 6.03-5.57 9.37-11.03 13.3-8.51 6.12-14.72 7.89-25.02 9.89a116.22 116.22 0 0 1-17.1 2.26c-8.59.55-13.48.56-22.05 1.13-11.24.76-19.03 2.35-27 10.32 3.76 2.75 6.36 5.46 6.36 10.1 0 4.78-2.95 8.19-7.5 9.69-1.05.35-1.83.03-2.82.56-1.19.62-1.13 1.98-2.26 2.69-2 1.27-3.55 1.55-5.94 1.55-4.2 0-7.07-.99-10.04-3.95-3.44 2.86-4.6 5.44-8.48 7.63-1.27.7-1.92 1.7-3.4 1.7-2.3 0-3.37-1.47-5.22-2.83a35.86 35.86 0 0 1-6.93-6.36c-3.51 2.1-5.67 3.81-9.75 3.81-2.51 0-4.1-.35-6.22-1.7-1.11-.68-1.3-1.7-2.4-2.4-1.17-.72-2.14-.46-3.4-.99-4.72-2.03-7.77-5.53-7.77-10.67 0-4.5 2.84-7.37 6.92-9.26-7.82-7.82-15.53-9.18-26.57-9.9-8.54-.54-13.4-.56-21.91-1.12-6.77-.46-10.53-1.15-17.25-2.26-5.07-.83-8.07-1.1-12.72-3.26-16-7.45-26.19-17.68-28.27-35.2-.18-1.5-.14-2.36-.14-3.88 0-9.12 3.58-14.68 10.03-21.13-1.66-.4-2.77.16-4.38-.43-4.03-1.46-6.93-4.26-6.93-8.55 0-1.59.07-2.65.85-4.03.55-.97 1.6-1.16 1.84-2.26.32-1.45-.1-2.47.57-3.82.44-.9 1.27-1.07 1.7-1.98 1.39-2.9 3.14-5.23 6.35-5.23 2.76 0 4.53 1.45 5.94 3.82 2.69-1.24 3.43-3.25 4.95-5.8 2.52-4.22 3.67-7.17 3.67-12.08 0-3.43-.33-5.44-1.41-8.7-.78-2.33-1.1-3.92-2.83-5.65a6.83 6.83 0 0 1-5.37 2.12c-4.49 0-7.92-3.85-7.92-8.34a7.51 7.51 0 0 1 4.67-7.2c-2.42-2.1-4.52-2.27-7.21-3.97-4.08-2.58-5.51-5.3-8.2-9.33-1.75-2.63-2.2-4.47-3.1-7.49-1.09-3.64-1.7-5.81-1.7-9.6 0-1 .01-1.58.14-2.55 1-7.67 2.38-12.48 7.2-18.52 2.87-3.59 4.81-5.8 9.05-7.63 3.6-1.56 5.76-2.7 9.68-2.7 1.19 0 1.88 0 3.04.15 1.8.23 2.96.39 4.53 1.27.6.34 1.7 1.35 1.7.64 0-.81-.43-1.24-.43-2.05 0-3.25 2.33-6.22 5.58-6.22 2.35 0 3.3 2.07 4.46 4.1a6.1 6.1 0 0 0 1.13-3.53c0-5.38-2.88-8.12-6.22-12.3-7.28-9.1-16.4-13.36-16.4-25.02 0-3.48 1.68-5.85 4.66-7.64.87-.5 2.03 0 2.88-.54.73-.46.64-1.4 1.1-2.14.73-1.14 1.37-1.64 2.38-2.52 1.66-1.45 3.12-1.02 4.95-2.29.92-.63 1.14-1.46 1.85-2.3 2.05-2.48 3.89-3.68 7.12-3.68 1.62 0 2.54.01 4.04.61.51.2 1.47.97 1.6.82a7.4 7.4 0 0 1 2.24-1.82c1.36-.65 1.9-.9 3.43-.9 1.73 0 2.86.97 4.6.97.63 0 .78-.64 1.3-.97 1.53-1.04 2.41-1.63 4.29-1.63 1.8 0 2.8.6 4.31 1.56 1.43.9 1.64 2.11 3.1 2.96.82.48 1.5.26 2.41.57 4.03 1.34 7.07 4.02 7.07 8.26 0 2.3-.55 3.94-2.26 5.45-1.36 1.2-2.65.99-4.39 1.55 5.62 4.49 10.51 5.6 17.69 5.6 6.57 0 14.6-2.68 14.6-9.26 0-3.05-1.68-4.7-2.88-7.5-2.16-5-3.33-7.95-3.33-13.39 0-4.31.47-6.93 2.98-10.43 2.58-3.6 5.73-4.44 10.17-4.44z'/%3e%3cg fill='none' stroke='%23703d29'%3e%3cpath stroke-linejoin='round' stroke-width='1.04' d='M425.59 223.46a5.56 5.56 0 0 0 3.82 3.8 5.9 5.9 0 0 0 5.99-2.17c1.5-1.95 1.4-4.37.83-6.3-.37-1.24-1.37-2.44-2.7-3.47l-7.94 8.06v.08z'/%3e%3cpath stroke-linecap='round' stroke-width='1.04' d='M626.61 343.94c-1.87-4.5-6.69-2.49-6.98 0-.69 5.73 4.34 7.46 7.91 6.53a6.22 6.22 0 0 0 3.9-3.03 7.54 7.54 0 0 0 .6-5.82 7.66 7.66 0 0 0-1.32-2.59 7.77 7.77 0 0 0-2-1.89c-1.37-.87-2.87-.96-5.22-.96-8.7 0-16.33 10.29-18.89 20.98-.84 3.52-2 11.37-.4 18.81 1.72 7.93 5.15 13.42 9.17 17.59 2.18 2.25 5.14 4.26 8.99 6.43 1.18.67 4.32 2.06 6.5 2.68 2.23.64 4.3.55 6.15.15 5.16-1.12 7.56-5.92 4.96-10.83-2.13-4.02-8.4-6.22-11.35-1.1a5.08 5.08 0 0 0-.63 2.42c.02 1.37.59 3.02 1.56 3.64 2.25 1.43 5.84 1.02 5.68-2.94'/%3e%3cpath stroke-width='1.28' d='M599.69 403.07c1.75-2.06 5.76-5.14 10.34-5.7 4.66-.58 8.7.78 12.83 3 8.06 4.34 12.55 9 15.55 17.64.76 2.2 1.4 5.5 1.3 9.02-.14 5.6-1.56 11.73-3.09 14.7-1.33 2.58-4.82 13.99-23.94 21.86-11.16 4.6-28.3 5.66-40.12 6.12-16.26.65-31.26 1.25-39.96 11.98'/%3e%3cg stroke-width='1.12'%3e%3cpath d='M603.75 421.45c-.47-1.71-.03-3.35 1.32-5.2 1.82-2.5 5.68-3.35 9.18-1.4 1.17.64 2.63 1.5 3.96 3.26.5.66 1.35 1.74 1.79 2.48 1.06 1.82 1.5 3.3 1.7 3.9 3.85 10.92-2.26 22.76-10.25 27.51-6.2 3.7-13.61 5.34-22.47 6.38-3.98.47-6.26.44-10.26.62-3.23.15-6.01.1-8.63.07-2.16-.03-4.21-.02-6.3-.07a110.9 110.9 0 0 0-11.28.16c-4.55.33-7.97.44-11.81 1.09-2.52.41-5.46.82-8.55 1.51-.92.2-1.86.38-2.8.66l-1.89.58c-5.57 1.7-10.98 3.77-15.25 6.52-1.32.85-2.81 1.7-3.88 2.7-.66.63-1.47 1.26-2.12 1.9-3 2.95-6.05 6.13-6.77 10.44-.13.8-.13 1.63-.13 2.5 0 2.8 2.28 6.62 8.42 7.86m8.64-265.81c1.29 2.32 2 3.74 1.24 6.14-.84 2.73-2.77 4.36-5.52 4.36-6.22 0-9.87-7.37-7.07-12.06 4.97-8.31 14.54-3.64 23.4.48-.43-2.13-1.17-2.83-1.1-5.47.2-6.57 5.07-9.54 7.01-15.6 1.16-3.62 1.62-6.76-1.03-9.32-2.3-2.24-4.98-2.2-7.99-1.03-6.02 2.36-13.25 9.14-25.97 9.33-12.72-.19-20.01-6.97-26.03-9.33-3.01-1.18-5.69-1.21-8 1.03-2.64 2.56-2.18 5.7-1.02 9.31 1.95 6.07 6.81 9.04 7 15.6.08 2.65-.66 3.34-1.09 5.48 8.86-4.12 18.8-9.21 23.4-.48 2.57 4.87-.85 12.06-7.07 12.06-2.74 0-4.67-1.75-5.52-4.36-.76-2.32 0-4.35 1.24-6.14'/%3e%3cpath stroke-linecap='round' d='M491.5 224.79c2.4 1.84 4.1 4.1 3.82 7.77-.31 4-1.28 4.95-4.39 7.07m3.75-5.93c-.14 2.4-1.13 3.96-3.53 4.95'/%3e%3c/g%3e%3cpath fill='%23c7b37f' stroke='none' d='m432.4 214.49 1.09.78 1.16 1.24.78 1.56.4 1.32.07 1.7-.08 1.17-.39 1.33-.78.93-.93 1.01-1.32.7-1.71.39-1.48.23-1.55-.7-1.4-1-.86-1.25-.62-1.56v-.62l7.62-7.23z'/%3e%3cpath stroke-linecap='round' stroke-width='1.04' d='M430.01 220.57c-.48-2.58-3.5-3.11-4.66-1.59-1.8 2.35-.49 6.26 3.17 7.4a5.9 5.9 0 0 0 5.99-2.17c1.51-1.96 1.4-4.38.83-6.3-.37-1.24-1.36-2.33-2.7-3.34-4.25-3.24-11.12-2.49-13.37 2.95-2.91 7.02 3.42 12.29 9.25 16.25 7.34 5 15.7 5.9 22 5.83 14.31-.15 25.2-7 32.27-10.88 1.65-.9 3.34-.72 4.2.3a3.11 3.11 0 0 1-.4 4.29'/%3e%3cpath stroke-width='1.06' d='m387.6 414.35-3.19 1.17-3.26 2.48-1.4 1.95-1.8 3.1-.77 2.34-.62 2.88-.31 2.17m29.7-15.78-.23 2.8-.47 1.94-1.4 3.35-2.18 2.87-2.33 1.87-1.7.85-2.42.55'/%3e%3cpath stroke-width='1.2' d='M499.6 489.23c-.58 2.59-3 5.55-8.28 6.62l-1.02.2'/%3e%3cpath stroke-width='1.36' d='M631.59 406.57c3.34 3.11 5.69 6.9 7.49 12.1.76 2.2 1.39 5.51 1.3 9.03-.14 5.6-1.56 11.73-3.09 14.7-1.33 2.58-4.82 13.99-23.95 21.86-11.16 4.6-28.3 5.65-40.11 6.12-16.03.63-30.83 1.23-39.59 11.52'/%3e%3cpath stroke-width='.93' d='M605.45 416.95c1.19-1.62 5.52-3.67 9.02-1.73a9.67 9.67 0 0 1 3.71 3.24'/%3e%3cpath stroke-width='1.36' d='M627.51 402.79c.78.3 1.56.57 2.24.77 2.24.64 4.34.69 6.16.14 4.42-1.33 7.26-5.46 4.96-10.83a8.84 8.84 0 0 0-2.71-3.33'/%3e%3cpath stroke-linecap='round' stroke-width='1.04' d='M375.44 287.13c-2.97 1.84-5.18 2.27-7.5 4.95-2.3 4.55-3.2 7-4.1 10.65m72.04-80.77c0 2.69-1.98 4.38-4.66 4.95'/%3e%3cpath d='M620.49 275.03c7.39-.15 28.86 5.64 29.01 30.88.15 24.92-15.38 29-21.6 30.65'/%3e%3cpath stroke-width='1.04' d='M622.43 275.03c12.74-.55 25.9 8.83 26.47 32.24.45 18.28-12.52 26.58-18.74 28.24'/%3e%3cpath stroke-width='.88' d='m615.33 363.16.2-2.5.83-3.98 1.18-3.09 1.32-2.55 1.72-2.06m12.16-5.31-.2 2.45-.7 1.67-1.08 1.6-1.25.93-1.9.7-1.67.11-1.25-.2m-22.36-82.51.54-2.64 1.17-2.45 1.52-2.45 2.6-3.34 2.06-2.3 3.34-3.38 2.88-2.92 1.83-2.1 2.4-2.91 2.15-3.23 1.28-2.64.7-3.42.21-4.24-.39-1.23m-19.18 200.27 2.53-.5 1.9-1.02 1.05-1.05.74-1.2.5-1.94.04-1.37m-247.26-18.98 1.87.16 2.4-.2 2.42-.85m7.81-57.11-.31 2.18-.5.97-.75.93-1 .78-1.13.5-1.48.24-1.01.08m15.47-24.41-.54 3.38-.66 1.48-1.37 1.87-1.82 1.4-1.87.93-3.61.9m23.9-62.13-.7 2.02-.85 1.48-1.17 1.63-1.63 1.48-1.95.93-1.63.39-1.01-.08m.59-9.68.04 1.55'/%3e%3cg stroke-width='.99'%3e%3cpath stroke-linecap='round' d='M397.32 325.09a10.71 10.71 0 0 1-3.27 2.03m235.19 70.04c.13.14.58.22.74.31 2.21 1.32 6.58-.33 5.3-3.75'/%3e%3cpath d='M621.54 349.38c1.57 2.05 4.54 2.59 6.88 1.98a6.22 6.22 0 0 0 3.9-3.03 7.55 7.55 0 0 0 .6-5.83 7.67 7.67 0 0 0-1.32-2.58 10.6 10.6 0 0 0-2.13-2.23c-.17-.11-.34-.26-.52-.38m10.04 53.15a6.13 6.13 0 0 0-1.9-5.71c-.43-.38-.85-.97-1.37-1.23m.75.73c-.07-2.91-2.46-5-5.41-5.51m-6.52 4.43c-.68-.55-1.4-1.02-2.04-1.69-3.83-4-6.7-9.92-6.74-16.68-.04-6.47 2.56-13.06 5.6-15.62m-88.29 132.26 2.8-2.57 1.94-1.47 3.66-2.26 3.42-1.63 2.4-.62 4.83-1.1 5.6-.85m-46.11 30.26c-2.02 3.11-6.84 7.77-11.9 9.64-5.05-1.87-9.87-6.53-11.9-9.64'/%3e%3cpath stroke-linecap='round' d='M491.28 494.73a15.48 15.48 0 0 1-3.47 6.45'/%3e%3cpath d='m491.78 491.47-.7 3.42m-3.65 6.53-1.48 1.48-2.64 1.47-3.03.94m-8.82-277.86c.38-1.18.77-2.07.71-4.01-.2-6.57-5.06-9.55-7-15.61-1.16-3.61-1.62-6.75 1.02-9.32 2.3-2.24 4.98-2.2 8-1.02 6.01 2.36 13.3 9.14 26.03 9.33-12.73-.2-20.02-6.97-26.04-9.33-3-1.18-5.93-1.53-8.24.71-2.64 2.57-1.93 6.02-.77 9.63 1.94 6.06 6.56 9.04 6.75 15.6.06 1.95-.45 2.84-.83 4.02m29.09-21.08c12.52-.66 23.25-9.07 26.7-9.76 3.1-.6 4.81-.33 7.08 1.72-2.27-2.05-4.84-1.99-7.77-.84-6.02 2.36-13.25 9.14-25.97 9.32M624.59 383.2a24.29 24.29 0 0 1-9.72-19.27c-.03-6.48 2.57-13.07 5.6-15.63m-109.3 152.46c-2.02 3.11-6.84 7.77-11.9 9.64-5.05-1.87-9.87-6.53-11.89-9.64'/%3e%3cpath stroke-linecap='round' d='m479.17 230.74 3.62-2.02c1.65-.9 3.63-.71 4.49.32.96 1.16 1.1 3.18-.23 4.41'/%3e%3cpath d='M460.48 239.49c8.59-1.8 15.59-5.64 20.88-8.6m50.42 256.54c.71.48 1.17 1.5 1.17 1.5.2.46.45.9.52 1.32.4 2.38-1.16 3.86-3.09 4.08a5.26 5.26 0 0 1-5.48-3.17m-64.86-252.11c8.59-1.8 15.59-5.64 20.88-8.6m152.46 167.04c-1.63.63-2.53.54-4.56-.36-.83-.37-1.79-.94-2.9-1.58-3.98-2.26-8.71-5.82-13.14-14.14a29.4 29.4 0 0 1-3.45-12.2c-.11-3 .21-6.14.96-9.72 1.24-5.93 2.72-9.15 6.37-14.15 1.8-2.47 3.35-3.97 6.7-4.05m-224.53-61.41a11.12 11.12 0 0 1 4.12 8.94c0 4.84-4.05 12.75-14 15.55-3.82 1.07-7.59.2-9.87-1.18'/%3e%3cpath d='M400.46 296.28c1.79 1.24 2.49 2.64 2.49 5.07 0 1.66-1.08 3.82-2.9 5.87-3 3.34-8.1 6.19-13.73 6.26a16 16 0 0 1-9.42-2.74 14.16 14.16 0 0 1-5.98-8.4'/%3e%3cpath d='M400.3 306.71c2.03 1.86 2.65 4.2 2.65 7.13 0 4.29-1.74 7.6-5.75 11.1-.9.79-1.9 1.52-3.03 2.18m202.23-34.49v5.52m-.44-6.88v7.77m.44-24.6v10.19m-.44-12.44v13.92m-2.97 128.06a29.23 29.23 0 0 1-6.53 8.86c-3.09 3.04-5.22 4.44-9.1 6.38-3.77 1.89-6.14 2.49-10.26 3.42a52.45 52.45 0 0 1-10.73 1.32c-3.86.18-6.05.01-9.9-.25-4.14-.29-6.43-.86-10.55-1.23-3.4-.3-5.32-.57-8.74-.56-3.51 0-5.52.03-8.98.64a34.42 34.42 0 0 0-8.09 2.26c-4.2 1.7-8.94 4.66-9.95 5.98-1.01-1.32-5.75-4.28-9.95-5.98a34.42 34.42 0 0 0-8.09-2.26 44.73 44.73 0 0 0-8.98-.64c-3.42-.01-5.34.26-8.74.56-4.13.37-6.42.94-10.54 1.23-3.86.26-6.05.43-9.91.25a52.26 52.26 0 0 1-10.73-1.32c-4.12-.93-6.49-1.54-10.26-3.42-3.88-1.94-6.02-3.34-9.1-6.38l-.95-.95m65.89 83.39 2.8-.35m47.3-3.68 2.83-.27 2.69-1.08 1.88-1.14 2.56-3.03.53-1.14.4-2.62.14-1.21m73.3-213.59c1.21-4.13-.27-8.48-4.27-8.37m-206.17 72.76a12.78 12.78 0 0 1-5.62 7.3m5.69-73c-1 2.89-2.83 4.95-5.72 6.26-2.89 1.3-6.23.09-8.02-1.3'/%3e%3cpath stroke-linecap='round' d='M380.95 291.2c2.4 1.25 4.82-.58 4.32-3.7a4.45 4.45 0 0 0-3.93-3.43'/%3e%3cpath d='M390.87 422.86c.52.49.63 1.11 1.32 1.24 1.05.2 1.87.59 2.92-.81 1.3-1.73.6-4.41-.75-6.1-1.44-1.8-5.61-3.4-9.11-1.46a11.6 11.6 0 0 0-3.97 3.26c-.5.67-1.35 1.74-1.79 2.5-1.05 1.8-1.49 3.28-1.7 3.88-3.2 9.1.6 18.66 6.49 24.5'/%3e%3cpath stroke-linecap='round' d='M531.59 487.23a9.2 9.2 0 0 1 1.01 1.24c.2.47.36.92.43 1.33.4 2.38-1.16 3.86-3.08 4.09-2.65.3-4.42-1.26-5.27-3.16'/%3e%3cpath d='M608.5 216.81c5.23.64 9.78 5.63 9.78 11 0 6.91-2.33 9.49-5.97 14.44-3.9 5.3-16.64 15-16.64 26.04 0 6.69 1.87 10.96 6.69 13.14 3.1 1.4 6.74-.11 8.4-1.6 4.04-3.66 2.42-10.07-1.8-10.84-5.13-.93-6.09 7.15-1.08 6.61m27.85 107.91a5.77 5.77 0 0 0-5.65-4.88 5.8 5.8 0 0 0-5.73 5.87c0 1.59.62 3.03 1.62 4.09'/%3e%3cpath d='M599.79 279.88a11.12 11.12 0 0 0-4.12 8.94c0 4.84 4.05 12.75 14 15.55 3.81 1.07 7.46.97 9.74-.42m-243.8-16.15c-2.38.8-5.35 2.28-7.55 5.4-1.86 2.63-2.94 6.28-3.6 9.48-.3 1.4-.65 5.83.24 10.41a24.61 24.61 0 0 0 3.6 8.8 12.4 12.4 0 0 0 1.63 1.94c.51.52 1.25.97 1.77 1.37m100.02 143.82c7.58 3.36 13.13 5.87 17.84 13.31 1.48 2.33 1.87 5.68 1.87 7.62 0 4.2-1.72 8.94-5.21 11.9-3.25 2.74-6.46 3.57-10.42 3.18-3-.3-5.83-2.49-6.3-4.04M396.88 325.2c4.28 3.34 6.06 6.59 6.06 11.74 0 5.9-2.87 9.56-6.22 11.66'/%3e%3cpath stroke-linecap='round' d='M392.99 344.41c6.38 7.93 9.76 12.64 9.95 22.08.18 8.86-2.64 14.93-7.93 21.3'/%3e%3cpath d='M515.23 239.57a6.43 6.43 0 0 0 2.5-3.48c.75-2.33.77-4.31-.48-6.1 1.54 2 1.68 3.7 1.25 6.14-.28 1.55-1.27 2.37-2.5 3.49m80.4 134.62v25.24h.07c0 .02-.01 2.39-.22 3.89-.13.98-.27 1.87-.42 2.7'/%3e%3cpath d='M595.96 371.81v27.22h.07c0 .02-.01 2.4-.21 3.9a42.94 42.94 0 0 1-.73 4.11m.87-67.1v22.7m.44-20.91v18.46m0-41.94v13.84m-.44-15.47v17.06m.44-29.58v5.37m-.44-6.46v7.78m-2.88 101.86-.53 1.08a29.22 29.22 0 0 1-6.53 8.87c-3.09 3.04-5.22 4.43-9.1 6.37-3.77 1.9-6.14 2.5-10.26 3.42a52.44 52.44 0 0 1-10.73 1.33c-3.86.17-6.05 0-9.9-.26-4.14-.29-6.43-.86-10.55-1.22-3.4-.3-5.32-.58-8.74-.57-3.51.01-5.52.03-8.98.65a34.41 34.41 0 0 0-8.09 2.25c-4.2 1.7-8.94 4.66-9.95 5.99-1.01-1.33-5.75-4.29-9.95-5.99a34.4 34.4 0 0 0-8.09-2.25 44.75 44.75 0 0 0-8.98-.65c-3.42 0-5.34.27-8.74.57-4.13.36-6.41.93-10.54 1.22-3.86.27-6.05.43-9.91.25a52.24 52.24 0 0 1-10.73-1.32c-4.12-.93-6.49-1.53-10.26-3.42-3.88-1.94-6.01-3.33-9.1-6.37-1.62-1.6-2.8-2.9-3.86-4.36m-3.14-4.98c.67 4.94-1.41 9.8-3.52 12.03-1.32 1.4-4.2 4.08-7.78 4.12-5.9.08-7.67-3.98-8.03-4.97'/%3e%3cpath d='M399.4 410.7c1.1 1.08 2.07 2.4 2.9 3.96 1.47 2.8 1.02 7.49-.15 9.65-.13.23-.3.49-.48.74m-31.63 28.15c3.51 3.69 8.83 7.7 16.99 11.05 11.16 4.6 28.3 5.66 40.12 6.12 15.71.62 30.2 1.27 39 11m27.14-6.36c2.6 2.56 5.25 5.3 6.37 8.8m-11.48 17.89c-.34.36-.7.7-1.08 1.03-3.25 2.74-6.46 3.58-10.42 3.19-3-.3-5.9-2.55-6.69-4.03m-8.36-4.54c.14.2.3.4.46.58a11.88 11.88 0 0 0 7.97 3.83m41.99-.12c-2.02 3.11-6.84 7.77-11.9 9.64-5.05-1.87-9.87-6.53-11.9-9.64l-.46-.73m24.34.71c.36.4.75.76 1.16 1.1 3.24 2.75 6.45 3.59 10.41 3.2 3.01-.3 5.4-2.3 6.36-4.05 0 0 .54-.58.7-1.13'/%3e%3cpath d='m529.75 500.99-1.16 1.87-1.77 1.46-2.67 1.11-2.42.1'/%3e%3cpath d='M536.03 483.22a12 12 0 0 1 3.6 4.53c.49 1.15.72 2.4.79 3.7a9.15 9.15 0 0 1-2.23 6.48 11.74 11.74 0 0 1-9.16 3.86m.29-.44c-3.17.13-6-1.23-8.1-3.38m99.5-106.04a37.1 37.1 0 0 1-7.5-10.08 29.38 29.38 0 0 1-3.46-12.2c-.1-3 .22-6.13.97-9.72 1.23-5.93 3.44-10.51 6.37-14.15 1-1.24 2.16-2.8 3.25-3.49m-2.15-118.46c3.97.31 7.64 4.58 7.59 8.76-.07 6.08-2.1 8.6-6.89 14.55-4.12 5.13-16.48 14.15-16.17 22.78.05 1.53.88 3.11 1.8 4.39m-4.94 5.41c.88.87 1.94 1.58 3.2 2.16 2.27 1.02 4.8.5 6.66-.45m-33.08-67.53c1.33.9 2.68 2.3 3.42 4.06 2.9 7.02-3.43 12.29-9.26 16.25a33.33 33.33 0 0 1-12.97 5.13'/%3e%3cpath d='M569.69 227.43c-1.41-.01-3.1-.42-4.92-2.34a5.23 5.23 0 0 1-1.1-1.55m-23.22 7.66a7.22 7.22 0 0 1-2.06-1.5c-1.39-1.55-2.31-3.65-1.24-6.86.98-2.96 5.74-11.27 5.97-17.02.36-8.8-3.02-13.98-8.3-16'/%3e%3cpath stroke-linecap='round' d='m542.68 203.85-.2 3.3-.9 3.38-1.72 4.61-1.31 2.96-1.38 2.96-.69 2.07-.27 1.51.2 1.45m59.4 197.31c.27.66.93 1.3.93 1.3 1.01 1.7 4.94 4.66 8.52 4.7 5.9.09 7.3-4.05 7.46-4.97.75-4.5-.8-5.74-3.1-7.01 0 0-1.37-.7-3-.43'/%3e%3cpath d='M370.23 403.67c-2.09.53-4.05.55-5.76.03-4.42-1.32-8-5.56-6.18-10.83m20.92-49.72c.44.44.59 1.1.65 1.67.69 5.73-4.34 7.4-7.91 6.47a8.8 8.8 0 0 1-4.71-3.56 7.35 7.35 0 0 1-.97-3.6m34.47-36.98c.9.82 1.52 1.74 1.93 2.76m-1.77-13.31a5.98 5.98 0 0 1 1.82 2.04'/%3e%3cpath stroke-linecap='round' d='M402.91 303.94a13.22 13.22 0 0 1-2.43 3.72c-3 3.34-8.08 6.19-13.72 6.26a16 16 0 0 1-9.42-2.74c-3.41-2.28-5.64-5.53-6.37-8.71'/%3e%3cpath d='M399.11 280.13a12.11 12.11 0 0 1 3.7 5.3'/%3e%3cpath stroke-linecap='round' d='M402.86 292.56c-1.38 4.57-5.51 10.23-13.47 12.25-3.8.96-8.7-.24-10.38-1.67'/%3e%3cpath d='M375.06 291.49c.42 4.12 3.17 7.2 8.4 7.3 7.35.15 11.82-10.57 5.29-18.09'/%3e%3cpath stroke-linecap='round' d='M358.52 327.39a25.45 25.45 0 0 0 3.63 3.64 26.24 26.24 0 0 0 9.27 5.15m8.25.77c6.57-.79 10.27-5.68 9.54-11.41-.56-4.36-4.56-7.72-7.29-7.91'/%3e%3cpath d='M390.39 268.92c2.85-.1 4.47 2.48 4.44 4.66'/%3e%3cpath stroke-linecap='round' d='M389.72 229.81a17.95 17.95 0 0 0 7.86 9.1m225.28 48.38c2.69 3.68.93 10.93-6.38 11.07a8.1 8.1 0 0 1-6.94-3.92'/%3e%3cpath d='M596.4 239.25v24.69'/%3e%3cpath stroke-linecap='round' d='M380.87 291.14c2.25 1.63 5.15-1.12 4.03-4.05-.76-1.97-3.56-4.1-7.45-1.46-4.3 2.92-3.11 12.13 5.13 12.28 7.35.14 11.82-10.57 5.29-18.1-6.29-7.23-17.73-5.53-25.2.4-3.17 2.53-9.17 9.15-11.03 18.17-.58 2.8-.96 5.11-.91 7.93.02 1.85.2 3.93.75 6.53a32.6 32.6 0 0 0 4.8 11.74c.71 1.03 1.35 1.87 2.04 2.56 1.28 1.28 1.67 1.96 2.96 3.04 4.22 3.51 9.66 6.27 16.32 5.98 7.31-.3 11.51-5.44 10.73-11.5-.75-5.88-6.69-8.8-10.57-6.07-2.64 1.87-3.58 7.65 1.09 9.02 2.64.78 4.97-2.57 3.1-4.5M584.4 210.68c4.22-2.3 7.47-1.87 9.87 1.47 2.62 3.63 2.99 8.45 2.41 11.28-.85 4.2-2.06 5.94-5.4 8.99'/%3e%3cpath stroke-linecap='round' d='M594.58 212.55c4.82-3.19 10.04-1.83 12.9 2.41 2.1 3.11 2.64 5.71 2.5 9.56-.26 6.6-4.39 11.83-8.95 14.39'/%3e%3cpath d='M617.28 223.67c3.96.31 7.15 3.9 7.15 8.09 0 5.98-1.67 8.58-6.45 14.53-4.12 5.14-16.48 14.15-16.17 22.78.12 3.27 2.87 6.34 5.24 6.51'/%3e%3cpath stroke-linecap='round' d='M617.75 291.14c-2.25 1.63-5.13-1-3.89-3.8.86-1.94 3.42-4.36 7.31-1.71 4.3 2.92 3.11 12.13-5.13 12.28-7.35.14-12.32-10.3-5.29-18.1 6.42-7.1 18.32-5.72 25.78.22 3.18 2.53 9.57 9.47 10.94 18.58 1.65 11.02 1.44 24.57-9.94 32.92-4.58 3.35-10.92 4.88-16.52 4.63-7.3-.32-11.5-5.44-10.72-11.5.75-5.88 6.41-8.37 10.57-6.07 4.32 2.4 3.56 8.47-1.09 9.02-2.74.33-4.98-2.56-3.1-4.5'/%3e%3cpath d='M613.86 287.34c1.21-5.45 5.88-5.96 9.66-5.9 10.3.14 17.41 12.36 17.53 24.17.15 14.92-6.33 23.71-17.24 24.18-2.82.12-7.68-1.22-7.77-4.67'/%3e%3cpath stroke-linecap='square' d='M620.2 284.9c10.86 2.41 14.67 12.2 14.67 21.53 0 7.62-.75 18.02-15.57 21.68'/%3e%3cpath d='M638.11 389.58a6.1 6.1 0 1 0-9.79 3.66'/%3e%3cpath stroke-linecap='round' d='M616.33 380.33c2.04 3.03 4.52 6.4 9.74 9.24m-1.96 16.48c-5.12-3.36-14.84-7.76-23.62-3.43-3.26 1.61-5.45 3.6-6.68 6.84-2.22 5.84.26 12.28 2.79 14.95 1.32 1.4 4.2 4.07 7.77 4.12 5.91.08 7.32-4.06 7.47-4.97.7-4.28-1.8-6-3.11-6.46-1.02-.35-4.31-.26-5.01 2.07-.24.78-.28 2.13.34 3.14'/%3e%3cpath stroke-linecap='round' d='M531.99 488.16c1.63 3.34-.22 5.02-2.49 5.29-3.34.39-5.13-2.26-5.36-4.67a6.87 6.87 0 0 1 6.84-7.38c3.53.05 6.41 2.33 7.76 5.47.5 1.14.72 2.4.8 3.7a9.14 9.14 0 0 1-2.23 6.47c-2 2.33-5.11 3.74-8.43 3.87-6.6.27-11.74-5.9-11.74-12.2 0-12.06 17.87-18.63 24.96-20.32 8.7-2.08 14-2.86 27.99-3.63 5.6-.31 9.7-.16 15.86-.8 5.51-.57 8.4-.83 14.07-2.16 7.08-1.65 13.68-4.58 19.6-9.95 4.54-4.13 7.14-7.07 9.25-12.75 1.82-4.9 2.65-14.6-1.95-21.77-4.07-6.34-9.72-9.63-16.17-10.56-5.83-.85-10.94 1.67-14 7.45-1.47 2.8-1.02 7.48.15 9.64 1.01 1.87 3.9 4.62 7.47 4.67 5.91.08 7.32-4.06 7.47-4.98.7-4.27-1.8-5.98-3.11-6.45-1.02-.36-4.32-.27-5.02 2.07-.23.77-.27 2.13.35 3.14'/%3e%3cpath stroke-linecap='round' d='M526.9 469.02c-7.58 3.36-13.13 5.87-17.84 13.31-1.48 2.33-1.87 5.68-1.87 7.62 0 4.2 1.72 8.94 5.21 11.9 3.25 2.74 6.46 3.57 10.42 3.18 3-.3 5.83-2.49 6.3-4.04'/%3e%3cpath d='M601.73 325.2c-3.54 1.18-6.06 6.59-6.06 11.74 0 5.9 2.87 9.56 6.22 11.66'/%3e%3cpath stroke-linecap='round' d='M605.62 344.41c-6.38 7.93-9.76 12.64-9.95 22.08-.18 8.86 2.64 14.93 7.93 21.3'/%3e%3cpath d='m571.64 212.58.55-.81c2.64-3.89 7.3-4.91 10.73-2.33 4.12 3.1 5.16 8.4 4.04 14-.7 3.5-3.07 6.4-6.33 8.51'/%3e%3cpath stroke-linecap='round' d='M414.22 210.68c-4.04-1.87-7.37-1.5-9.87 1.47-2.88 3.42-3 8.45-2.41 11.28.85 4.2 2.06 5.94 5.4 8.99'/%3e%3cpath d='M404.03 212.55c-4.82-3.19-10.04-1.83-12.9 2.41-2.1 3.11-2.64 5.71-2.5 9.56.26 6.6 4.39 11.83 8.95 14.39'/%3e%3cpath d='M390.12 216.81c-5.23.64-9.4 5.07-9.4 10.43 0 6.92 1.7 9.72 5.59 15 3.9 5.3 16.64 15.01 16.64 26.05 0 6.69-1.87 10.96-6.69 13.14-3.1 1.4-6.74-.11-8.4-1.6-4.04-3.66-2.42-10.07 1.8-10.84 5.12-.93 6.09 7.15 1.08 6.61'/%3e%3cpath d='M381.33 223.67c-3.97.31-7.87 3.72-7.87 7.9 0 6 2.39 8.77 7.17 14.72 4.12 5.14 15.76 13.98 15.45 22.6-.12 3.27-2.31 7.26-4.49 6.8'/%3e%3cpath stroke-linecap='round' d='M372 343.94c1.87-4.5 6.69-2.49 6.98 0 .69 5.73-4.34 7.46-7.91 6.53a6.22 6.22 0 0 1-3.9-3.03 7.55 7.55 0 0 1-.6-5.82c.27-.93.65-1.71 1.32-2.59a7.77 7.77 0 0 1 2-1.89c1.37-.87 2.87-.96 5.22-.96 8.7 0 16.33 10.29 18.89 20.98.84 3.52 2 11.37.4 18.81-1.72 7.93-5.15 13.42-9.17 17.59-2.17 2.25-5.14 4.26-8.99 6.43a38.65 38.65 0 0 1-6.5 2.68c-2.23.64-4.33.7-6.15.15-4.42-1.33-7.26-5.46-4.96-10.83 1.79-4.18 8.4-6.22 11.35-1.1.25.44.64 1.4.63 2.42-.02 1.37-.59 3.02-1.56 3.64-2.25 1.43-5.84 1.02-5.68-2.94'/%3e%3cpath d='M365.24 397.49c1.63.63 2.53.54 4.56-.36.83-.37 1.79-.94 2.9-1.58 3.98-2.26 8.71-5.82 13.14-14.14a29.38 29.38 0 0 0 3.45-12.2c.11-3-.21-6.14-.96-9.72-1.24-5.93-2.72-9.15-6.37-14.15-1.8-2.47-3.35-3.97-6.7-4.05m-14.75 48.29a6.1 6.1 0 1 1 9.79 3.66'/%3e%3cpath d='M362.88 383.51a5.77 5.77 0 0 1 5.65-4.88 5.8 5.8 0 0 1 5.73 5.87c0 1.59-.62 3.03-1.62 4.09'/%3e%3cpath d='M374.02 383.2a24.29 24.29 0 0 0 9.72-19.27c.03-6.48-2.57-13.07-5.6-15.63'/%3e%3cpath stroke-linecap='round' d='M382.29 380.33c-2.04 3.03-4.52 6.4-9.74 9.24'/%3e%3cpath d='M397.81 402.63c-1.45-3.4-4.33-4.99-9.02-5.49-4.66-.5-8.7.79-12.83 3-8.06 4.34-12.55 9-15.55 17.65-.76 2.2-1.39 5.5-1.3 9.02.14 5.6 1.56 11.73 3.1 14.7 1.33 2.58 4.81 13.99 23.94 21.86 11.16 4.6 28.3 5.66 40.12 6.12 16.25.64 31.25 1.25 39.96 11.97'/%3e%3cpath stroke-linecap='round' d='M374.5 406.05c5.12-3.36 14.84-7.76 23.62-3.43 3.26 1.61 5.45 3.6 6.68 6.84 2.22 5.84-.26 12.28-2.79 14.95-1.32 1.4-4.2 4.07-7.77 4.12-5.91.08-7.32-4.06-7.47-4.97-.7-4.28 1.8-6 3.11-6.46 1.02-.35 4.31-.26 5.01 2.07.24.78.28 2.13-.34 3.14'/%3e%3cpath d='M394.86 421.45c.47-1.71.23-3.5-1.32-5.2-1.56-1.72-5.68-3.35-9.18-1.4a11.6 11.6 0 0 0-3.96 3.26c-.5.66-1.35 1.74-1.79 2.48-1.06 1.82-1.5 3.3-1.7 3.9-3.85 10.92 2.41 22.52 10.25 27.51 6.85 4.36 13.84 5.6 22.47 6.38 4 .36 6.26.44 10.27.62 3.22.15 6 .1 8.63.07 2.15-.03 4.2-.02 6.3-.07 3.4-.08 6.94-.16 11.27.16 4.55.33 7.97.44 11.81 1.09 2.52.41 5.46.82 8.55 1.51.92.2 1.86.38 2.8.66l1.89.58c5.57 1.7 10.98 3.77 15.25 6.52 1.32.85 2.84 1.67 3.88 2.7.8.8 1.47 1.26 2.12 1.9 3 2.95 6.05 6.13 6.77 10.44.13.8.13 1.63.13 2.5 0 2.8-2.28 6.62-8.42 7.86'/%3e%3cpath d='M466.62 488.16c-1.63 3.34.22 5.02 2.49 5.29 3.34.39 5.13-2.26 5.36-4.67a6.87 6.87 0 0 0-6.84-7.38c-3.53.05-6.41 2.33-7.76 5.47-.5 1.14-.72 2.4-.8 3.7a9.15 9.15 0 0 0 2.23 6.47c2 2.33 5.11 3.74 8.43 3.87 6.6.27 11.74-5.9 11.74-12.2 0-12.06-17.87-18.63-24.96-20.32-8.7-2.08-14-2.86-27.99-3.63-5.6-.31-9.7-.16-15.86-.8-5.51-.57-8.4-.83-14.07-2.16-7.08-1.65-13.68-4.58-19.6-9.95-4.54-4.13-7.14-7.07-9.25-12.75-1.82-4.9-2.65-14.6 1.95-21.77 4.07-6.34 9.72-9.63 16.17-10.56 5.83-.85 10.94 1.67 14 7.45 1.47 2.8 1.02 7.48-.15 9.64-1.01 1.87-3.9 4.62-7.47 4.67-5.91.08-7.32-4.06-7.47-4.98-.7-4.27 1.8-5.98 3.11-6.45 1.02-.36 4.32-.27 5.01 2.07.24.77.28 2.13-.34 3.14'/%3e%3cpath stroke-linecap='round' d='m426.97 212.58-.55-.81c-2.64-3.89-7.3-4.91-10.73-2.33-4.12 3.1-5.16 8.4-4.04 14 .7 3.5 3.07 6.4 6.33 8.51'/%3e%3cpath d='M573.04 224.37c-6.3 6.84-12.6 9.03-22 9.33-2.94.1-8.56-.93-11.82-3.26-2.1-1.5-4.43-4.05-2.96-8.48 1-2.96 5.75-11.27 5.98-17.03.36-8.79-3.02-13.6-8.3-15.47-9.78-3.45-20.27 6.21-26.6 8.32a21.34 21.34 0 0 1-8 1.24 21.63 21.63 0 0 1-8.07-1.24c-6.33-2.1-16.82-11.77-26.6-8.32-5.28 1.87-8.66 6.68-8.3 15.47.23 5.76 4.99 14.07 5.97 17.03 1.48 4.43-.85 6.99-2.95 8.48-3.27 2.33-8.88 3.35-11.82 3.26-9.4-.3-15.7-2.49-22-9.33'/%3e%3cpath stroke-linecap='round' d='M464.58 466.27c1.25.49.3-.3 8.2 3.2 7.57 3.36 12.95 6.3 17.66 13.74 1.48 2.33 1.86 5.67 1.86 7.62 0 1.25-.15 2.55-.45 3.84'/%3e%3cpath d='M465.09 500.06c1.54.77 3.28 1.22 5.08 1.29 6.6.26 11.74-5.91 11.74-12.2 0-4.37-2.38-8.05-5.7-11'/%3e%3cpath stroke-linecap='round' d='M466.52 488.15c-1.6 3.55.68 5.47 2.94 5.74 3.34.39 5.22-2.26 5.46-4.67a6.98 6.98 0 0 0-3.28-6.48'/%3e%3cpath d='M609.53 216.87c5.02 0 9.4 5.59 9.4 11.32 0 6.6-3.52 10.65-6.1 13.7-2.07 2.46-4.3 4.66-6.98 7.35'/%3e%3cpath stroke-linecap='round' d='M603.58 211.58c1.7.79 3.2 2.13 4.35 3.82 2.1 3.1 2.63 5.71 2.48 9.56-.25 6.6-5 11.17-9.24 13.96m-7.46-27.34c.35.3.68.63 1 1.01 2.88 3.43 3.1 8.48 2.41 11.29-1.03 4.2-2.43 6.02-5.85 8.54m-7.91-22.57c4.12 3.11 5.35 8.49 3.98 14.03-.97 3.95-3.46 6.32-6.56 8.21m17.38 64.19c.5 1.45 1.3 1.95 2.33 3.02a21.15 21.15 0 0 0 9.62 5.5c3.82 1.08 7.25.27 9.88-1.36m-254.7 84.43c1.94-.04 3.87 1.27 5.13 3.47.25.43.64 1.38.63 2.4-.01 1.38-.61 2.84-1.6 3.46-2.24 1.43-6.22.82-6.06-3.15'/%3e%3cpath d='M377.33 336.4c7.7 1.44 15.12 10.73 17.55 20.86.84 3.53 2 11.38.4 18.82-1.72 7.93-5.15 13.42-9.17 17.59-.95.98-2.06 1.92-3.32 2.85l-1.64 1.11m-12.39-18.96c3.16 0 5.93 3.03 5.93 6.27 0 1.6-.61 3.03-1.61 4.09'/%3e%3cpath d='M366.62 382.35c3.3 0 6.43 3.18 6.43 6.55a6.1 6.1 0 0 1-2.31 4.78'/%3e%3cpath stroke-linecap='round' d='M396.84 349.2c3.03 4.06 5.03 7.56 5.95 12.07m-.1 13.26a26.98 26.98 0 0 1-2.26 6.32 27.85 27.85 0 0 1-5.56 7.25'/%3e%3cpath d='M397.32 325.52c2.92 2.28 4.68 4.64 5.5 7.47'/%3e%3cpath stroke-linecap='round' d='M402.9 317.92c-.77 2.66-2.5 4.67-5.27 7.2m-14.3-26.85 3.37-.89 2-1.5 1.28-1.82 1.1-2.84.45-2.3'/%3e%3cpath d='M376.51 286.41c-1.06.27-2.41.66-3.82 1.33-1.9.9-3.9 2.3-5.51 4.58-1.86 2.63-2.94 6.28-3.6 9.48-.3 1.4-.65 5.84.24 10.41a24.61 24.61 0 0 0 3.6 8.81c.56.82 1.06 1.52 1.63 2.09 2.02 2.02 3.88 3.26 7 2.64'/%3e%3cpath stroke-linecap='round' d='M395.38 271.58c-.55 2-1.62 4.5-4.77 4.22'/%3e%3cpath d='M383.87 285.2c-3.02-2.96-9.43-3.73-15.8.3-.82.52-1.64 1.19-2.45 1.86-.87.73-1.57 1.57-2.25 2.48-.73 1-1.63 2.68-2.18 3.8a19.54 19.54 0 0 0-1.47 4.14 31.74 31.74 0 0 0-1.02 9.78c.17 1.51.32 2.9.56 4.18a29.13 29.13 0 0 0 3.48 9.66c1.4 2.33 4.9 7.69 12.06 8.4 2.8.27 7.61-1.01 7.77-4.67'/%3e%3cpath stroke-linecap='round' d='M568.38 220.42c.48-2.58 3.59-3.08 4.76-1.55 1.8 2.34.6 6.38-3.05 7.52a5.9 5.9 0 0 1-5.99-2.18c-1.51-1.95-1.4-4.37-.83-6.3.36-1.24 1.36-2.32 2.7-3.34 4.25-3.23 11.11-2.48 13.37 2.96 2.9 7.02-3.42 12.28-9.25 16.25-7.34 4.99-15.7 5.9-22 5.83-14.31-.16-25.2-7-32.27-10.89-1.65-.9-3.35-.72-4.2.31a3.11 3.11 0 0 0 .39 4.28'/%3e%3cpath stroke-linecap='round' d='M571.26 218c1.52.07 1.92.66 2.39 1.27 1.8 2.35.48 6.38-3.18 7.52m27.87 80.54c-5.45 5.93-.44 16.12 3.64 18.42 1.4 1.1 2 .51 3.14 1.17'/%3e%3cpath d='M598.63 295.99c-1.79 1.24-2.42 2.64-2.49 5.07-.06 2.03.3 4.29 2.2 6.27 2.98 3.1 8.8 5.79 14.43 5.86a16 16 0 0 0 9.42-2.74 14.16 14.16 0 0 0 5.98-8.4m-32.59 96.55c0 .02 0 2.39-.21 3.89a29.5 29.5 0 0 1-3.27 10.8 29.23 29.23 0 0 1-6.53 8.87c-3.08 3.04-5.22 4.43-9.1 6.37-3.77 1.9-6.14 2.5-10.26 3.42a52.45 52.45 0 0 1-10.73 1.33c-3.86.17-6.05 0-9.9-.26-4.13-.28-6.42-.86-10.54-1.22-3.4-.3-5.33-.58-8.75-.57-3.5.01-5.52.03-8.98.65a34.41 34.41 0 0 0-8.09 2.25c-4.2 1.7-8.94 4.67-9.95 5.99-1-1.32-5.75-4.29-9.95-5.99a34.41 34.41 0 0 0-8.09-2.25 44.76 44.76 0 0 0-8.98-.65c-3.42 0-5.34.27-8.74.57-4.12.36-6.41.94-10.54 1.22-3.86.27-6.05.43-9.9.26-4.22-.2-6.63-.4-10.74-1.33s-6.49-1.53-10.26-3.42c-3.87-1.94-6.01-3.33-9.1-6.37a29.22 29.22 0 0 1-6.53-8.87 29.51 29.51 0 0 1-3.26-10.8c-.2-1.5-.22-3.87-.22-3.89V239.58h192.55V398.6h.07z'/%3e%3c/g%3e%3cg fill='%23c7b37f' stroke='%23c7b37f'%3e%3cpath stroke-width='.51' d='M387.41 421.32a3.9 3.9 0 1 1 7.81 0 3.9 3.9 0 0 1-7.81 0zm-23.99-27.61c0-1.93 1.24-3.5 2.76-3.5s2.76 1.57 2.76 3.5-1.24 3.5-2.76 3.5-2.76-1.57-2.76-3.5z'/%3e%3cpath stroke='none' d='M377.05 324.36c0-1.59 1.2-2.87 2.66-2.87 1.48 0 2.67 1.28 2.67 2.87s-1.2 2.87-2.67 2.87-2.66-1.28-2.66-2.87zm47.86-102.55c-.17-1.6.79-3 2.13-3.14 1.35-.14 2.58 1.04 2.75 2.63.17 1.6-.79 3-2.14 3.14-1.34.14-2.57-1.04-2.74-2.63z'/%3e%3c/g%3e%3cg stroke='%23c7b37f' stroke-linecap='round' stroke-width='.99'%3e%3cpath d='M373.92 340.54c-.57.25-.9.46-1.32.91-.41.43-.5.59-.82 1.3-.23.52-.3 1.12-.38 1.86m7.37 41.79c.54-.66.87-1.01 1.4-1.69.43-.56.68-.87 1.06-1.47.35-.54.5-.86.8-1.43.43-.8.65-1.25 1.05-2.06m-1.97 21.78c-.92.42-1.47.61-2.37 1.09-.68.36-1.06.6-1.71 1-.78.49-1.2.77-1.95 1.3-.76.57-1.16.94-1.9 1.53m23.38-59.2c-.5-.52-.77-.82-1.28-1.32-.54-.53-.83-.84-1.4-1.32-.56-.47-.91-.69-1.5-1.12'/%3e%3cpath stroke-linecap='butt' d='M397.17 326.47c-.74.33-1.13.6-1.9.85-.89.29-1.49.44-2.34.48'/%3e%3cpath d='M371 300.68c.25.9.31 1.45.65 2.32.43 1.1.8 1.69 1.45 2.67.68 1.03 1.1 1.6 1.99 2.46.77.76 1.26 1.14 2.17 1.73.86.57 1.42.76 2.32 1.25m-1.54-9.16c.76.4 1.15.71 1.94 1.04.72.3 1.15.43 1.9.6 1.04.24 1.64.3 2.7.32 1.13.03 1.47 0 2.9-.23m11.21-63.53c-1.25-.73-2-1.05-3.2-1.87a19.05 19.05 0 0 1-2.92-2.37 14.57 14.57 0 0 1-1.81-2.02c-.56-.76-.78-1.26-1.28-2.06m11.72-7.11c.4 1.05.5 1.68 1 2.68.68 1.36 1.2 2.07 2.23 3.19 1.41 1.55 2.61 2 4.28 3.27m2.27-9.25c.39.94.5 1.52 1 2.41.43.79.72 1.2 1.3 1.9.72.9 1.2 1.36 2.1 2.07 1.04.82 1.79 1.06 2.93 1.74'/%3e%3c/g%3e%3cpath fill='%23703d29' stroke-width='.28' d='M520.78 211.91c-.08-2.65-2.69-2.92-3.69-2.92-2.88 0-3.67 1.8-7.27 3.73-4.5 2.42-6.45 2.96-10.46 3-4.01-.04-6-.58-10.52-3-3.6-1.93-4.2-3.68-7.09-3.68a3.64 3.64 0 0 0-3.51 3.84s-.03.8.1 1.34c.04.2.29.14.36.32-.03-1.2.21-1.82.8-2.63a3.42 3.42 0 0 1 2.54-1.31c2.89 0 3.96 1.85 7.56 3.78 4.51 2.42 6.45 2.96 10.46 3 4.01-.04 6-.58 10.52-3 3.6-1.93 4.63-3.94 7.52-3.94 1 0 1.7.65 2.03 1.67.2.63.1 1.04.14 1.3.03.11.18.1.21.23.1-.46.33-.63.3-1.73z'/%3e%3c/g%3e%3cg fill='%23703d29'%3e%3cpath d='M413.12 434.42c.81-.87 1.42-.54 1.57-.95.11-.3-.13-.32-.46-.45-.44-.16-.9-.26-1.34-.42-.46-.17-.87-.4-1.33-.58-.19-.07-.63-.29-.75.04-.23.61 1.6.56.99 2.2-.1.28-.37.88-1.28 1.88l-4.14 4.5c-.09.11-.24.33-.34.3-.1-.04-.08-.31-.08-.45l.06-6.4c0-1.2.1-2.1.3-2.63.28-.73 1.12-.12 1.3-.6.1-.29.02-.3-.48-.49-.25-.1-.73-.2-1.74-.57-.53-.2-1.04-.47-1.56-.66-.24-.1-.67-.41-.83 0-.05.13.12.31.16.35.58.41.73.69.74 1.47l.11 11.63c.01.84.1 1.08.26 1.13.17.07.3 0 .64-.4l8.2-8.9z'/%3e%3cpath d='M417.95 436.22c.53-1.69 1.53-.67 1.72-1.28.07-.21 0-.27-.48-.42-.91-.29-1.51-.4-2.09-.58-.56-.18-1.16-.45-1.78-.64-.15-.05-.53-.23-.63.07-.2.63 1.77.7 1.26 2.32l-2.7 8.54c-.52 1.69-1.53.86-1.73 1.49-.03.08-.03.22.11.26.42.14 1.13.28 1.82.5 1.25.4 1.82.65 2.41.84.37.11.53.09.6-.1.18-.58-1.88-.32-1.19-2.51l2.68-8.49zm5.78 1.71c.32-1.07.82-.93 1.41-.75 1.63.48 2.14 2.07 1.62 3.83-.31 1.05-.7 2.03-3.15 1.3-.49-.14-1.08-.32-.95-.77l1.07-3.61zm-4.43 7.7c-.67 2.25-1.8 1.27-1.97 1.85-.1.35.25.4.42.45.81.24 1.64.4 2.5.67.68.2 1.1.4 1.37.48.37.1.53.04.58-.12.19-.65-1.62-.39-1.06-2.3l.92-3.1c.19-.62.13-.78.98-.52.8.24 1.05.48 1.18 1.38l.52 3.23c.2 1.18.37 2.46 1.64 2.84.65.19 1.83.11 2-.44.03-.15-.03-.28-.18-.33-.16-.04-.35.02-.51-.03-.13-.04-.43-.13-.5-.46-.49-2.6-1.09-5.6-1.05-5.7.05-.18.56-.2 1.15-.48.6-.29 1.26-.81 1.6-1.96.24-.82.67-3.44-2.86-4.48-1.08-.32-2.2-.58-3.27-.9-1.02-.3-1.12-.4-1.87-.62-.19-.06-.38-.02-.43.16-.19.64 1.76.5 1.17 2.5l-2.33 7.88zm13.16 3.85c-.52 2.16-2.15.85-2.32 1.55-.1.4.18.45.48.52.65.16 1.2.21 2.3.48 1.1.26 1.61.46 2.27.62.47.11.78.25.89-.19.12-.5-2.1-.48-1.56-2.72l1.97-8.2c.2-.87.4-.92 1.06-.76l1.4.34c1.89.37.88 2.26 1.53 2.42.43.1.42-.65.44-.88l.22-1.7c.03-.2.09-.45-.16-.5-1.52-.37-2.63-.56-5.01-1.13-2.39-.57-3.46-.91-4.98-1.27-.25-.06-.3.2-.37.37l-.83 2.33c-.1.23-.29.6.06.69.73.17.81-2.32 2.66-1.88l1.37.33c.67.16.81.3.6 1.16l-2.02 8.42zm19.84-5.06c.65-1 1.3-.78 1.38-1.2.06-.32-.18-.3-.53-.37-.46-.08-.93-.1-1.4-.18-.47-.1-.92-.25-1.4-.34-.2-.04-.67-.18-.73.17-.12.64 1.67.27 1.35 2-.05.29-.2.93-.93 2.06l-3.3 5.16c-.07.12-.18.36-.28.35-.1-.02-.13-.3-.16-.43l-1.05-6.3c-.2-1.2-.26-2.1-.16-2.65.14-.78 1.08-.32 1.17-.81.06-.31-.02-.31-.55-.4-.27-.06-.76-.07-1.81-.27-.57-.1-1.11-.28-1.66-.38-.25-.05-.73-.29-.81.15-.03.13.17.28.21.3.65.32.84.56.99 1.33l2.13 11.44c.15.82.29 1.04.45 1.07.18.03.29-.06.56-.5l6.53-10.2zm.93 10.51c0 .46-.03.6.36.78.92.4 1.7.98 2.7 1.15 2.17.36 3.97-1.02 4.38-3.43.39-2.34-.57-3.31-2.2-4.47-2.04-1.46-2.91-1.85-2.7-3.08.2-1.24 1.06-1.81 2.16-1.63 2.85.48 2.52 3.94 2.9 4 .37.07.45-.14.49-.55l.23-2.5c.04-.43.13-.7-.12-.74-.21-.03-.67.19-.89.15-.5-.08-1.07-.91-2.43-1.14-1.94-.32-3.52 1-3.88 3.12-.32 1.93.54 2.8 1.85 3.75 2.44 1.75 3.45 2.16 3.18 3.73-.24 1.47-1.38 2.19-2.67 1.97-1.84-.3-2.59-2.15-2.82-4-.03-.26-.04-.43-.3-.48-.41-.06-.34.5-.33.76l.09 2.61zm24.72-6.97c.54-1.06 1.22-.91 1.25-1.34.03-.32-.21-.28-.56-.3-.47-.05-.95 0-1.42-.05-.48-.03-.94-.14-1.43-.18-.2-.02-.68-.11-.71.24-.05.65 1.7.1 1.56 1.84-.03.3-.11.95-.71 2.16l-2.74 5.47c-.06.13-.15.38-.25.37-.1 0-.16-.27-.2-.4l-1.7-6.16a8.49 8.49 0 0 1-.44-2.62c.06-.78 1.04-.42 1.08-.93.03-.31-.06-.3-.6-.34-.26-.02-.75.01-1.82-.07-.57-.05-1.14-.17-1.69-.21-.25-.02-.76-.2-.8.24 0 .13.2.26.25.28.68.24.9.46 1.12 1.21l3.32 11.15c.24.8.4 1 .56 1.02.18.01.27-.1.5-.56l5.43-10.82z'/%3e%3cpath d='M480.6 457c-.02 1.9-1.63 1.55-1.63 2.3 0 .32.33.23.52.23.45 0 .9-.07 1.44-.06.59 0 1.16.08 1.98.09.22 0 .64.02.64-.24 0-.88-2.15.37-2.12-3.2l.06-6.35c0-.17.03-.3.13-.3.09 0 .19.1.3.25l8 9.77c.11.15.2.26.43.26.2 0 .2-.14.2-.55l.1-10.47c.01-1.96 1.44-1.5 1.44-2.06 0-.05 0-.24-.31-.24-.16 0-.74.06-1.8.05-1.16 0-1.65-.08-1.92-.09-.21 0-.27.19-.27.32 0 .61 2.05.3 2.03 2l-.05 6.2c0 .47-.04.7-.14.7s-.3-.23-.52-.5l-6.68-8.28c-.3-.36-.1-.49-.63-.5-.89 0-1.33.07-1.76.07-.32 0-.62-.08-.94-.08-.2 0-.29.14-.3.31 0 .9 1.9-.3 1.86 3.28l-.06 7.1zm16.26-8.4c.02-1.77 1.27-1.09 1.27-1.72 0-.23-.08-.27-.58-.27-.96-.01-1.56.06-2.17.06-.59 0-1.24-.1-1.9-.1-.15 0-.56-.06-.57.26 0 .65 1.8.15 1.8 1.85v8.95c0 1.77-1.21 1.28-1.22 1.93 0 .1.03.22.18.23.44 0 1.16-.07 1.88-.06 1.31 0 1.93.09 2.56.1.38 0 .53-.07.54-.28 0-.6-1.89.24-1.87-2.05l.08-8.9zm7.04 8.67c.02 2.22-1.89 1.34-1.88 2.07 0 .4.29.39.6.39.66-.01 1.22-.09 2.34-.1 1.13-.01 1.68.06 2.35.05.49 0 .83.05.82-.4 0-.52-2.15.04-2.17-2.25l-.07-8.43c0-.9.16-1 .85-1l1.42-.01c1.94-.1 1.42 1.98 2.09 1.98.43 0 .24-.73.2-.96l-.2-1.71c-.01-.19-.01-.45-.26-.45-1.57.02-2.7.1-5.14.12-2.45.02-3.58-.04-5.14-.03-.25 0-.25.27-.27.45l-.24 2.47c-.03.24-.13.65.22.65.76-.01.23-2.45 2.13-2.46l1.41-.02c.69 0 .86.09.86.98l.08 8.66zm9.78-3.53c-.3.02-.53.06-.55-.13-.02-.26.06-.47.13-.7l1.03-3.4c.07-.2.13-.23.17-.23.08 0 .03 0 .14.14l1.64 3.26c.1.21.22.41.24.67.01.19-.22.19-.52.21l-2.28.18zm2.87.78c.44-.03.54.15 1.2 1.56.23.48.37.81.4 1.22.1 1.13-1.11 1.02-1.07 1.56.02.26.24.2.54.18.48-.03 1.1-.16 1.83-.21 1.1-.1 1.57-.05 2.17-.1.45-.04.6-.01.58-.33-.05-.61-.9.19-1.54-1.1l-5.41-11.02c-.26-.54-.3-.58-.45-.56-.22.01-.27.37-.37.68l-3.65 11.61c-.33 1.07-1.2 1.03-1.16 1.46.02.24.28.18.52.16.48-.04.96-.15 1.46-.19.54-.04 1.05 0 1.58-.05.35-.02.88.07.85-.33-.04-.5-1.82-.06-1.93-1.4-.03-.44.15-1.11.24-1.5.29-1.25.63-1.35.92-1.38l3.3-.26zm12.98-7.73c-.17-1.28-.1-1.3 1.91-1.57 3.21-.42 2.2 1.91 2.98 1.81.39-.05.22-.65.17-.89l-.3-1.82c-.03-.17-.17-.34-.38-.3-1.47.18-2.6.41-3.79.57-2.55.33-3.76.41-4.44.5-.23.04-.34.2-.32.37.1.74 1.9-.1 2.12 1.56l1.14 8.66c.3 2.26-1.1 1.42-1 2.27.03.12.14.2.35.17.92-.12 1.6-.29 2.12-.36.74-.1 1.36-.1 2-.18.41-.06.77-.03.72-.4-.06-.5-1.88.2-2.15-1.84l-.37-2.74c-.14-1.07-.23-1.29.53-1.39l1.24-.16c1.73-.23 1.52 1.8 2.05 1.72.4-.05.21-.7.17-.94l-.55-3.28c-.09-.5-.27-.43-.38-.42-.34.05-.16 1.75-1.6 1.94l-1.04.14c-.72.1-.73-.03-.84-.83l-.34-2.59zm6.14 4.24c.69 3.72 3.38 5.79 6.7 5.17 5.26-.97 5.44-5.65 4.96-8.22-.72-3.9-3.62-5.8-6.83-5.17-3.94.77-5.57 4.2-4.83 8.22zm1.84-1.42c-.5-2.66-.14-5.35 2.64-5.92 2.12-.43 4.53 1.32 5.28 5.38.57 3.04.1 5.67-2.73 6.25-2.95.6-4.7-3.03-5.2-5.71zm13.02-6.5c-.26-1.09.25-1.21.85-1.36 1.65-.4 2.88.73 3.31 2.51.26 1.07.4 2.11-2.08 2.7-.49.12-1.1.27-1.2-.19l-.88-3.66zm0 8.88c.56 2.29-.9 2-.77 2.59.09.36.42.22.6.18.81-.2 1.61-.46 2.5-.68.68-.16 1.14-.2 1.42-.26.37-.1.48-.23.44-.4-.16-.65-1.6.48-2.06-1.46l-.76-3.14c-.15-.63-.28-.73.59-.94.81-.2 1.15-.1 1.71.6l2.06 2.54c.76.93 1.56 1.95 2.85 1.64.65-.16 1.63-.82 1.5-1.38-.04-.14-.16-.23-.3-.2-.17.05-.3.2-.47.23-.13.03-.44.1-.66-.15-1.72-2-3.74-4.3-3.77-4.4-.04-.19.4-.46.77-1s.68-1.33.4-2.49c-.2-.83-1.14-3.31-4.72-2.46-1.1.27-2.18.6-3.28.87-1.03.25-1.18.2-1.93.38-.2.05-.33.18-.3.36.17.66 1.78-.44 2.27 1.59l1.92 7.98zm13.48-3.01c.56 2.15-1.5 1.76-1.32 2.46.1.4.37.31.66.23.65-.16 1.17-.37 2.26-.66 1.09-.28 1.65-.34 2.3-.51.47-.12.8-.15.7-.59-.14-.5-2.08.56-2.66-1.66l-2.1-8.17c-.23-.87-.1-1 .57-1.17l1.39-.36c1.85-.55 1.84 1.59 2.5 1.42.42-.11.06-.77-.03-.98l-.61-1.61c-.06-.18-.13-.43-.37-.37-1.52.4-2.59.75-4.96 1.36-2.37.61-3.48.82-5 1.21-.24.07-.17.32-.14.5l.36 2.46c.02.24.03.66.37.57.73-.19-.37-2.43 1.47-2.9l1.37-.35c.66-.18.85-.13 1.07.74l2.17 8.38zm8.59-11.46c-.47-1.7.92-1.4.75-2-.06-.22-.15-.24-.64-.1-.92.25-1.48.49-2.06.65-.57.15-1.22.26-1.85.43-.15.04-.57.1-.48.4.17.64 1.86-.37 2.31 1.26l2.4 8.63c.47 1.7-.82 1.56-.65 2.2.03.08.1.2.24.16.42-.12 1.1-.38 1.8-.57 1.25-.35 1.87-.45 2.47-.61.37-.1.5-.22.44-.42-.16-.57-1.74.76-2.35-1.45l-2.38-8.58zm3.58 4.17c1.2 3.6 4.15 5.26 7.35 4.19 5.08-1.7 4.6-6.36 3.77-8.84-1.25-3.75-4.39-5.24-7.48-4.16-3.8 1.3-4.94 4.94-3.64 8.81zm1.62-1.66c-.86-2.57-.88-5.28 1.8-6.23 2.04-.72 4.67.68 5.98 4.59.98 2.94.88 5.6-1.84 6.57-2.83 1.01-5.07-2.35-5.94-4.93zm11.92-8.47c-.41-1.04.07-1.23.65-1.46 1.58-.62 2.96.32 3.63 2.02.4 1.02.7 2.03-1.68 2.97-.47.18-1.05.41-1.22-.02l-1.38-3.51zm1.24 8.8c.87 2.18-.63 2.1-.4 2.66.13.35.44.17.61.1.78-.3 1.54-.68 2.38-1.02.65-.25 1.1-.35 1.37-.46.36-.14.44-.3.38-.45-.24-.62-1.51.7-2.24-1.16l-1.19-3c-.24-.61-.38-.7.45-1.02.78-.3 1.13-.26 1.79.36l2.39 2.23c.88.81 1.81 1.7 3.04 1.22.63-.24 1.51-1.03 1.3-1.57-.06-.14-.2-.2-.33-.15-.16.06-.27.23-.43.29-.12.05-.42.16-.67-.06-1.99-1.74-4.3-3.74-4.35-3.84-.07-.17.32-.5.62-1.09.29-.6.49-1.41.05-2.52-.31-.8-1.59-3.13-5.01-1.78-1.05.41-2.08.9-3.13 1.31-.98.4-1.14.37-1.86.65-.18.08-.3.23-.24.4.25.63 1.7-.69 2.47 1.26l3 7.63z'/%3e%3c/g%3e%3cg fill='%23fedf00'%3e%3cpath fill='%23d52b1e' d='M412.66 249.25h82.18v82.02h-82.18z'/%3e%3cpath id='a' fill='%23fff' d='M451.2 313.83s-.05 2.93-.86 5.29c-.93 2.72-.94 2.72-1.8 4.04a13.13 13.13 0 0 1-3.8 3.89c-1.96 1.26-3.95 1.88-5.95 1.7-5.49-.48-8.04-6.43-9.28-11.27-1.32-5.13-5.07-7.92-7.47-6.06-1.4 1.09-1.47 2.91-.3 4.67 1.24 1.86 4.1 2.8 4.1 2.8l-2.94 3.73s-6.3-.82-7.53-7.4c-.47-2.49.74-7.13 4.89-8.52 5.3-1.77 8.68 2 10.31 5.2 2.25 4.38 3.21 12.43 9.43 11.18 3.39-.67 4.98-5.6 4.98-7.85l2.47-2.64 3.65 1.16.1.08z'/%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 907.52 0)'/%3e%3cpath d='m461.12 278.95 10.76-11.64s1.62-1.31 1.61-3.4l-2.22.34-.5-1.14-.1-1.15 2.98-.63c.04-.48 0-.85.09-1.38.08-.5.19-.76.3-1.25l-3.26.22c.17-.57.13-.87.31-1.4.16-.45.2-.62.5-1.1.61-.1 1.16-.24 1.91-.31.73-.07 1.15-.04 1.88-.09 1.78-3.32 9.19-6.37 14.45-.9 3.81 3.96 2.99 11.22-1.95 13.14a6.32 6.32 0 0 1-6.86-1.11l1.97-3.87c2.72 1.63 4.98-.4 4.82-2.5-.2-2.65-1.92-4.29-4.35-4.5-2.26-.2-3.88 1.1-4.9 3.1-.63 1.24-.34 2.14-.55 3.5-.22 1.49-.1 2.32-.53 3.82a8.75 8.75 0 0 1-2.37 3.59l-11.03 11.93-42.94 46.45-3.23-2.98 43.21-46.74z'/%3e%3cpath fill='%23fff' d='M429.51 283.04s2.7 13.37 11.87 33.43c4.67-1.7 7.42-2.8 12.37-2.8 4.94 0 7.7.93 12.36 2.8 9.17-20.06 11.87-33.43 11.87-33.43l-24.23-31.18-24.24 31.18z'/%3e%3cpath d='m456.12 262.41 16.82 21.64s-2.24 10.52-9.08 26.35c-2.64-.6-4.91-1.13-7.73-1.32v-46.67zm-4.74 0-16.82 21.64s2.24 10.52 9.08 26.35c2.64-.6 4.91-1.13 7.73-1.32v-46.67z'/%3e%3c/g%3e%3cg fill='%23d52b1e'%3e%3cpath fill='%23fedf00' d='M503.6 249.25h82.18v82.02H503.6z'/%3e%3cpath d='M515.11 249.25h12.25v82.02h-12.25zm23.48 0h12.25v82.02H538.6zm23.48 0h12.25v82.02h-12.25z'/%3e%3c/g%3e%3cg fill='%23d52b1e' stroke='%23d52b1e' stroke-width='.51'%3e%3cpath fill='%23fedf00' stroke='none' d='M412.97 402.41c.23 1.48.76 4.01 2.16 6.6 1.48 2.34.94 2.28 4.28 6.01 1.64 1.84 4.21 3.41 6.23 4.5 2.02 1.08 3.51 1.62 6.84 2.49 6.52 1.71 11.09 1.82 16.57 1.6 4.28-.17 7.55-.7 10.25-1.06 3.86-.52 6.73-.83 11.12-1.01 2.13-.1 4.15-.11 6.14 0 2.4.13 4.78.5 7.3 1a79.61 79.61 0 0 1 10.97 3.2l.01-85.66-82.19-.02v58.54s.17 2.86.32 3.8z'/%3e%3cpath d='m422.51 417.43 3.85 2.24 5.28 1.9v-81.53h-9.13zm45.66 3.71.01-81.1h-9.14v82.4s6.25-.8 9.13-1zm18.24-81.09h-9.11v81.38c2.97.32 6.02.85 9.13 1.68l-.02-83.06zm-36.49 0v83.33c-.09.01-6.1.32-9.17 0v-83.32z'/%3e%3c/g%3e%3cpath fill='%23fedf00' d='M585.48 402.39a20.75 20.75 0 0 1-2.16 6.6c-1.48 2.34-.94 2.28-4.28 6-1.64 1.85-4.21 3.42-6.23 4.5-2.02 1.1-3.51 1.63-6.84 2.5-6.52 1.71-11.09 1.82-16.57 1.6-4.28-.17-7.55-.7-10.25-1.06-3.86-.52-6.73-.83-11.12-1.01a63.34 63.34 0 0 0-6.14 0c-2.4.13-4.78.5-7.3 1-5.45 1.1-11.04 3.2-11.04 3.2l.05-85.66 82.2-.02v58.54s-.17 2.86-.32 3.8z'/%3e%3cg id='b'%3e%3cpath fill='%23d52b1e' d='m524.62 346.91-.6.28c-.3.33-.44.52-.77.81-.45.4-.77.5-1.25.85-.24.16-.42.21-.6.44-.25.32-.08.62-.25 1-.19.4-.37.6-.65.93-.37.44-.65.61-1.07 1-.42.4-.59.73-1.1 1-.13.07-.19.14-.34.19-.21.07-.34-.01-.56.06-.39.14-.5.56-.78.72.11.22.1.37.22.6.16.32.7 1.21.81 1.43.21.3.27.7.53.78.54.17.86.16 1.32.13.79.18 1.28.16 2.03.47.61.25.86.57 1.47.84.47.21.77.34 1.28.44.38.07.6.13 1 .1.25-.03.37-.13.62-.16h.13l-.03.37v.09h.06l2.06.91c-.07.12-.15.26-.19.38-.1.32-.11.68-.06.84.63 1.89 1.16 3.07 1.47 3.19.62.23.8.86 1.16 1.5-.13.13-.23.2-.35.3-.61.6-1.15 1.02-1.65 1.82-.75 1.19-1.25 1.2-.32 2.78.55.93.82 1.1 1.53 2.4.37.67.57 1.18.79 1.98.2.75.27 1.19.3 1.97l.98.37.65-.65.63-1.2.03-.9c-.24-.2-.3-.47-.25-.78.07-.37.51-.3.72-.62.28-.47-.33-.74-.66-1.1-.6-.67-1.43-.83-1.62-1.84-.05-.28.08-.43.37-.72.86-.84 1.13-.97 1.97-1.81.24.14.61.19.97.12.28-.05.53.13 1.4.38.62.17.88.08 1.22.03l.38-.1c.05.22.11.42.12.7.06 1.05-.15 2.99.16 3.5.13.2.19.32.28.55.1.24.22.4.22.66.01.7.05 1.14 0 1.87-.04.7-.1 1.05-.22 1.75-.07.46-.16.72-.44 1.07-.28.36-.59.41-.96.68l-.1 1 1.13.47 1.28.32.69-.29c0-.25.04-.4.15-.62.13-.25.23-.44.47-.53.36-.14.76.13.9-.1.17-.24.07-.33.04-.75-.05-.66-.18-.98-.28-1.65a11.81 11.81 0 0 1-.16-2.75c.03-.62.04-.96.16-1.56.17-.89.48-1.32.68-2.2.23-.97.27-1.6.38-2.46 3.17.45 5.8.4 9.34-.38.17-.03.75-.25.75-.25.8.7 1.71 1.27 2.72 1.63v.97c.04.29-.04.48.13.72.1.15.2.24.37.28.27.06.46.02.66-.16.23-.2.18-.45.25-.75.03-.14 0-.56 0-.69.37.06.49.07.87.07.36 0 .53.01.88-.03l.03.46c.03.25-.08.44.03.66.11.23.25.36.5.4.2.05.35.02.53-.09.3-.18.27-.5.31-.84.02-.11.02-.7 0-.78l1.04-.38c0 .25-.04.52-.1.82a5 5 0 0 1-.25.93c-.2.57-.44.86-.75 1.38-.37.63-.57.98-1.03 1.56-.21.27-.36.39-.56.66-.26.33-.34.56-.6.9-.32.44-.5.73-.93 1.07-.7.55-1.15.1-2.1.84l-.22 1.03 1.44.53 1.28.25.44-.25c-.01-.3.03-.51.22-.75.21-.27.44-.35.78-.4.36-.06.75.03 1.03-.22.35-.31.35-.92.63-1.47a12.66 12.66 0 0 1 3-3.9c.61-.6 1.13-.77 1.65-1.45.25-.32.52-.46.53-.87.01-.28-.14-.42-.21-.69-.1-.38-.2-1-.2-1 1.53.75.98.65 1.26 1.4.22.62-.03 1.05.06 1.7.11.75.47 1.1.53 1.87.08.9-.14 1.42-.31 2.31-.15.79-.13 1.28-.47 2a3.85 3.85 0 0 1-1.16 1.57c-.2.17-.36.25-.59.4l-.12 1.03 1.12.38 1.63.44.37-.35c.16-.65-.05-1.61.4-1.69.41-.06.7 0 .79-.3.04-.14.06-.33.1-.63.21-1.89.41-3.65.62-4.5.23-.97.21-1.18.4-1.91.18-.66-.08-.28.41-1.69.73-2.1-.2-2.37-1.06-3.65-.46-.7-.62-.95-.69-1.5-.1-.82.16-1.5.12-2.75a42.32 42.32 0 0 1 0-2.88c.12-.05.23-.12.35-.19 1.17-.64 1.63-.83 2.37-2.46.23-.5.32-1 .32-1.47 0-.34-.07-.66-.1-1.03-.03-.4-.19-.64-.31-.94a3.17 3.17 0 0 0-.56-.85c-.78-.92-1.78-1.13-2.72-1.46-1.48-.54-2.5-.44-4.13-.57-1.67-.13-2.6-.15-4.28-.06-2 .12-3.13.52-5.12.75-1.92.22-2.98.37-4.9.4-2.27.05-4.43-.45-5.79-.34-2.45.21-2.5.76-6.19 1.07-1.92.15-3.84.18-3.84.18l-2.16-.68c.86-.31 1.07-.5 1.47-1.04.27-.36.23-.67.56-1.06.27-.31.45-.62.78-.97a2.2 2.2 0 0 0-.93-.43c-.37-.08-.58-.05-.94 0-.5.05-.77.12-1.22.34-.36.18-.62.36-.84.6 0 0-1.29-.84-2.19-1.23-1.12-.48-1.6-.7-3-.9zm1.97 11.9h.06l-.03.04-.03-.03z'/%3e%3cg fill='none' stroke='%23fedf00' stroke-linecap='round' stroke-width='.99'%3e%3cpath d='m568.77 359.52-.76.24c-.87.4-1.58.42-2.6.5-2.65.2-4.27-1.06-7-.85-1.4.11-2.03 1.2-3.46 1.55-.65.16-1.03.23-1.7.28l.51-1.03s-1.28.26-2.11.26c-.6 0-.94-.03-1.53-.13l1.02-.95s-.81-.13-1.3-.33a3.92 3.92 0 0 1-1.05-.63c.66-.12 1.03-.2 1.69-.36 1.55-.38 2.04-1.14 3.89-1.32 1.15-.11 3.03-.05 7.64.72 3.03.5 4.38.26 5.53-.26.77-.35 1.02-1.01 1.1-1.79.1-.78-.4-1.4-.87-1.81-.12-.1-.44-.33-1.1-.36'/%3e%3cpath fill='%23fcd900' stroke-linecap='butt' stroke-width='.51' d='M524.8 350.61c-.53-.07-.88.01-1.34.3-.48.29-.54.69-.89 1.13.45.1.7.36 1.14.26.35-.09.53-.24.77-.51.31-.36.43-.68.42-1.16l-.1-.02z'/%3e%3cpath d='M536.04 363.79s.26.48.4.8c.25.55.38.88.53 1.47.2.8.11 1.28.24 2.1.02.14.05.26.08.37l-.05 1.13m6.8-6.95-.35 1.33c-.36 1.36-.68 2.09-.95 3.46-.04.23-.08.45-.1.65m-10.86-3.98c.79.18.54 3.36 1.79 4.09'/%3e%3cpath stroke-linecap='butt' d='m560.12 369.78.38-.25a8.15 8.15 0 0 0 2.69-1.79'/%3e%3cpath d='M552.38 368.02c3.54-.88 5.9-2.65 7.59-2.87m-4-1.54c.3-.01.58-.03.83-.07 1.47-.2 1.7.69 2.73 1.26 1.85 1.04 2.1 2.3 4.3 3.36l.32.15.84.43'/%3e%3cpath fill='%23fcd900' stroke-linecap='butt' stroke-width='.51' d='M517.7 354.53c.27.07.43.08.7.05.34-.03.5-.23.82-.24.27-.01.47-.04.69.12.14.1.2.19.28.34.08.17.16.28.12.47-.06.28-.32.42-.61.42-.24 0-.44-.06-.55-.27a.47.47 0 0 1-.03-.4c-.29.11-.5.12-.78.02-.3-.1-.48-.24-.64-.51z'/%3e%3c/g%3e%3cpath fill='%230065bd' d='M525.13 364.17c-.8-.24-1.97-.83-1.97-.83.33-.25.6-.26.87-.55.39-.4.37-.79.59-1.32.22-.52.18-.95.67-1.34.3-.23.76-.27 1.12-.17.35.11.76.4.85.77.13.56-.16.88-.25 1.45-.08.57-.3.9-.2 1.46.07.38.23.52.36.9 0 0-1.26-.14-2.04-.37zm-.99.95a.63.63 0 1 1 1.26-.02.63.63 0 0 1-1.26.02zm-1.76-16.51-.14-.1c-.39-.31-.42-.66-.6-1.11-.18-.44-.26-.7-.32-1.16-.05-.4 0-.64 0-1.05 0-.36.04-.57 0-.94-.04-.38-.03-.61-.21-.94-.1-.18-.4-.34-.31-.42.09-.1.25-.02.42 0 .4.04.63.16.94.42.38.3.53.57.67 1.04.17.55.25.9.4 1.47.1.3.14.47.3.74.15.27.31.38.52.63l-.02.02c-.3.33-.44.54-.77.83-.3.27-.56.4-.85.58l-.03-.01zm3.6 10.64 2.23 1.03a9.24 9.24 0 0 0 3.5-3.92c.88-1.72 1.02-2.65 1.36-4.31l-1.79-.58-.35.07c-.56 1.72-.7 2.7-1.62 4.2-.8 1.28-1.72 2.3-2.65 3.03l-.68.48zm4.94 18.12c.36-.5.51-.81.92-1.26.46-.5.8-.7 1.31-1.15.16.01.34-.02.48.07a9 9 0 0 1-.52 2.75c-.14.39-.16.64-.4.98-.15.22-.28.31-.47.51-.5-.74-1.33-1.3-1.32-1.9zm33.01 1.85c.57.21.92.27 1.47.54.61.3.9.57 1.47.94.02.16.1.32.06.48a8.97 8.97 0 0 1-2.79.26c-.41-.03-.66.02-1.05-.1-.26-.1-.38-.2-.63-.32.58-.7.88-1.64 1.47-1.8zm-9.76-2.04c.57.21.92.27 1.47.54.6.3.9.57 1.47.94.02.16.1.32.06.48a8.98 8.98 0 0 1-2.79.26c-.41-.03-.66.02-1.05-.1-.26-.1-.38-.2-.63-.32.58-.7.88-1.64 1.47-1.8zm-17.34 2.13c.57.21.92.27 1.47.54.61.3.9.57 1.47.94.02.16.1.32.06.48a9 9 0 0 1-2.79.26c-.41-.03-.66.02-1.05-.1-.26-.1-.38-.2-.63-.32.58-.7.88-1.64 1.47-1.8zm-8.98-29.8c-.61-.28-1.05-1.04-.66-1.6.15-.21.41-.17.57-.39.18-.27.14-.5.13-.84 0-.37-.14-.57-.2-.94-.08-.4-.15-.64-.14-1.05 0-.63-.04-1.08.34-1.57.25-.32.66-.6.83-.62.14.14-.06.5-.04.83.04.46.13.71.3 1.15.2.56.47.8.7 1.36.2.52.4.81.41 1.37.02.45-.02.73-.2 1.15a2 2 0 0 1-.62.84c-.27.22-.45.32-.8.42-.24.02-.4-.01-.62-.11z'/%3e%3c/g%3e%3cuse xlink:href='%23b' y='36.59'/%3e%3cpath fill='none' stroke='%23703d29' stroke-width='.8' d='M412.66 249.25h82.18v82.02h-82.18zm90.94 0h82.18v82.02H503.6zm-90.63 153.16c.23 1.48.76 4.01 2.16 6.6 1.48 2.34.94 2.28 4.28 6.01 1.64 1.84 4.21 3.41 6.23 4.5 2.02 1.08 3.51 1.62 6.84 2.49 6.52 1.71 11.09 1.82 16.57 1.6 4.28-.17 7.55-.7 10.25-1.06 3.86-.52 6.73-.83 11.12-1.01 2.13-.1 4.15-.11 6.14 0 2.4.13 4.78.5 7.3 1a79.61 79.61 0 0 1 10.97 3.2l.01-85.66-82.19-.02v58.54s.17 2.86.32 3.8zm172.51-.02a20.75 20.75 0 0 1-2.16 6.6c-1.48 2.34-.94 2.28-4.28 6-1.64 1.85-4.21 3.42-6.23 4.5-2.02 1.1-3.51 1.63-6.84 2.5-6.52 1.71-11.09 1.82-16.57 1.6-4.28-.17-7.55-.7-10.25-1.06-3.86-.52-6.73-.83-11.12-1.01a63.34 63.34 0 0 0-6.14 0c-2.4.13-4.78.5-7.3 1-5.45 1.1-11.04 3.2-11.04 3.2l.05-85.66 82.2-.02v58.54s-.17 2.86-.32 3.8z'/%3e%3c/svg%3e";
            },
            8679: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 6'%3e%3cpath fill='%2300732f' d='M0 0h12v2H0z'/%3e%3cpath fill='%23fff' d='M0 2h12v2H0z'/%3e%3cpath d='M0 4h12v2H0z'/%3e%3cpath fill='red' d='M0 0h3v6H0z'/%3e%3c/svg%3e";
            },
            133: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3cpath fill='%23d32011' d='M0 0h900v600H0z'/%3e%3cpath d='M0 0h300v600H0z'/%3e%3cpath fill='%23007a36' d='M600 0h300v600H600z'/%3e%3cpath fill='%23fff' d='M486.204 529.52c-5.912-1.257-8.51-4.161-8.774-9.8-.2-4.331 1.145-7.437 4.55-10.479.839-.75 1.262-1.277.939-1.17-17.525 5.769-37.106 6.827-54.65 2.955-2.99-.66-9.202-2.352-10.946-2.978-.32-.116.31.654 1.397 1.706 1.221 1.182 2.375 2.667 2.994 3.866.982 1.883 1.018 2.056 1.018 5.39 0 2.954-.1 3.658-.695 4.97-1.237 2.734-3.523 4.435-7.241 5.385-4.745 1.217-13.838-.34-33.982-5.819-17.864-4.85-18.453-4.962-25.449-4.75-3.337.104-7.77.519-12.874 1.218-13.622 1.842-19.22 2.027-27.093.906-12.525-1.79-21.251-6.97-25.181-14.954-.523-1.066-.899-1.996-.825-2.068.074-.074 1.142.128 2.376.44 7.285 1.87 19.92 2.035 25.578.342.998-.299 1.054-.27-2.064-1.237-4.55-1.413-9.016-4.395-12.052-8.05-2.161-2.603-4.91-8.23-6.081-12.44-.5-1.797-.859-3.314-.805-3.374.054-.054 1.72.706 3.7 1.693 10 4.977 17.897 6.886 26.863 6.498 4.347-.185 6.596-.495 14.544-1.996 7.517-1.417 9.248-1.586 14.471-1.417 3.587.114 5.46.32 7.226.789l2.387.638 1.483-.924c1.749-1.09 6.188-4.557 6.028-4.716-.34-.34-7.99.658-11.05 1.445-1.956.499-3.619.85-3.692.778-.12-.12.906-.766 3.053-1.94.81-.443.45-.433-4.1.1-3.369.393-4.816.63-7.374 1.218-1.142.259-.48-.334 1.329-1.19.93-.44 1.64-.844 1.577-.898-.224-.204-6.77.758-9.068 1.33-1.303.322-2.431.53-2.503.458-.072-.072.487-.569 1.243-1.102.757-.533 1.346-1.002 1.306-1.038-.16-.16-7.697.803-9.62 1.224-1.139.25-2.129.395-2.2.325-.072-.071.926-.71 2.215-1.425l2.35-1.293-3.54-.086c-1.946-.044-4.237.044-5.09.2-.851.16-1.588.245-1.636.2-.048-.049.918-.713 2.142-1.478 2.068-1.287 4.303-3.353 3.982-3.678-.08-.076-.97.026-1.982.225-2.52.495-5.962.19-8.697-.768a84.394 84.394 0 0 0-4.79-1.477l-2.545-.689 1.796-.373c.99-.206 3.28-1.048 5.09-1.876 1.81-.829 3.968-1.749 4.79-2.052 1.797-.663 4.625-.729 6.54-.154 1.566.473 1.652.335.806-1.257-1.857-3.473-4.342-4.547-9.162-3.948-1.457.18-2.808.459-3.002.622-.193.164-.51.926-.708 1.703-.5 1.972-1.497 3.639-2.5 4.156-.945.49-2.349.315-2.913-.366-.547-.658-1.002-.519-1.597.491-.595 1.006-2.12 2.07-2.97 2.076-1.006 0-2.222-.872-2.739-1.96-.383-.806-.638-1.03-1.014-.878-1.191.479-2.68.489-3.588.02-.903-.467-1.098-.447-4.465.439-4.202 1.112-10.156 1.51-13.314.894-5.054-.986-10.479-4.291-14.1-8.587l-.538-.638 1.736.409c2.024.479 6.647.539 9.222.124 2.738-.44 15.718-3.401 15.718-3.587 0-.09-2.78-.12-6.177-.07-4.465.066-7.062-.04-9.358-.375-7.614-1.118-13.732-4.056-19.011-9.128-2.202-2.116-6.016-6.567-5.805-6.776.05-.052 1.032.365 2.182.926 3.341 1.63 6.88 2.196 15.864 2.529 4.281.16 8.627.363 9.655.453 1.03.09 1.866.06 1.856-.068-.01-.128-1.318-1.177-2.914-2.327-4.226-3.046-10.27-9.178-12.687-12.874-1.968-3.004-2.946-5.044-2.946-6.138 0-.325-.22-1.138-.487-1.804-.667-1.67-5.898-5.862-9.45-7.573-1.426-.69-2.606-1.337-2.616-1.437-.036-.333 3.388-1.703 5.142-2.056 1.303-.263 2.275-.263 3.992-.004 1.252.19 2.335.286 2.403.214.074-.07-.419-.51-1.088-.974-.67-.467-1.477-1.21-1.796-1.651l-.57-.804 1.71.399c2.884.678 3.022.45.459-.763-2.563-1.217-4.73-3.07-5.639-4.82-.483-.938-.479-.966.05-.739.719.3 3.699.58 3.699.344 0-.1-.563-.467-1.25-.819-.686-.35-1.956-1.34-2.814-2.201-1.343-1.345-1.844-1.633-3.587-2.064-1.118-.273-2.579-.822-3.253-1.218-1.473-.864-4.098-3.433-5.33-5.213-.487-.715-.944-1.238-1.012-1.174-.14.144 3.723 9.07 6.048 13.964.89 1.876 1.557 3.481 1.477 3.561-.323.32-3.672-2.036-6.08-4.283-9.816-9.15-16.866-22.914-15.672-30.589.539-3.463 2.69-5.902 6.355-7.201.807-.292 1.465-.611 1.465-.713 0-.104-.519-.533-1.153-.954-.635-.419-2.42-2.152-3.968-3.848-3.64-3.992-5.236-5.609-6.687-6.776-.65-.52-1.108-1.024-1.014-1.118.092-.094 1.497-.246 3.126-.344 2.8-.163 5.529.228 8.646 1.246.33.108-.16-.523-1.085-1.401-.925-.878-3.098-3.214-4.83-5.19-1.73-1.976-4.078-4.49-5.218-5.589L226 336.407l2.303-.333c2.306-.34 4.651-.147 7.162.579 1.746.507 1.948.347.705-.555-2.671-1.936-4.703-5.126-5.779-9.082-.788-2.898-2.05-10.14-2.411-13.832-.515-5.28.467-10.355 2.431-12.594 1.034-1.174 1.046-1.33.26-2.875-1.368-2.674-1.324-2.85.339-1.357 1.33 1.198 2.365 1.733 2.365 1.222 0-.088-.655-.998-1.45-2.022-1.486-1.906-3.406-5.19-3.793-6.475l-.216-.719.958.679c1.038.742 3.601 1.623 3.601 1.237 0-.13-.29-.495-.645-.806-1.191-1.058-4.275-6.2-4.87-8.124-.206-.652-.16-.646 1.74.246 1.94.908 6.601 2.03 6.959 1.676.103-.105-.236-.67-.753-1.257-1.93-2.196-2.76-4.625-3.178-9.271-.1-1.15-.449-2.685-.772-3.413-.32-.733-.543-1.374-.489-1.426.054-.051.719.24 1.485.645.764.407 1.465.739 1.557.739.09 0-.24-.715-.735-1.593-1.15-2.036-2.06-5.609-2.265-8.87l-.16-2.561 1.064 2.147c.767 1.543 1.583 2.615 2.908 3.813 1.014.918 1.904 1.61 1.976 1.537.074-.072-.355-1.27-.952-2.659-2.948-6.86-3.662-14.607-1.942-20.978l.33-1.227.534 1.716a15.37 15.37 0 0 0 1.45 3.144c.99 1.54 3.542 4.146 3.253 3.317-.743-2.111-1.447-5.932-1.098-5.932.124 0 .29.172.371.383.22.57 2.326 1.943 3.36 2.19l.898.216-1.357-1.47c-1.72-1.864-2.543-3.209-3.294-5.389-.325-.95-.804-1.962-1.064-2.249-.26-.287-2.22-1.844-4.35-3.463l-3.885-2.944 4.58-.186c2.522-.1 4.691-.2 4.831-.223.136-.02-.02-.48-.35-1.014-.329-.535-.822-1.849-1.097-2.918-.274-1.072-.779-2.591-1.114-3.378-.335-.786-.535-1.51-.439-1.608.096-.098 1.391 1.085 2.874 2.63l2.695 2.805-.723-1.797c-.399-.988-.954-2.854-1.237-4.143a12.136 12.136 0 0 0-1.787-4.338c-.704-1.093-1.223-2.041-1.157-2.11.067-.067.608.248 1.197.7.593.45 1.126.772 1.184.712.185-.184-.45-7.17-.89-9.82-.234-1.398-.374-2.587-.312-2.65.276-.27 3.513.64 4.411 1.238.543.368 1.428 1.318 1.962 2.116l.975 1.447.008-2.804.006-2.802 1.137 2.027c1.69 3.006 1.817 3.048 1.807.61 0-1.152.22-2.955.495-4.013.35-1.353.463-2.734.379-4.676-.1-2.383-.06-2.707.32-2.395.239.2.77 1.101 1.18 2.007l.75 1.647.446-2.994c.248-1.646.46-4.567.48-6.487.033-4.018.259-4.135 1.56-.812.451 1.15.93 2.156 1.068 2.241.134.08.246-.852.246-2.08 0-1.482.247-3.083.738-4.78.407-1.401.85-3.405.986-4.45l.246-1.897.573 2.243.574 2.246.224-1.68c.12-.927.565-2.667.984-3.873.587-1.677.764-2.774.764-4.714 0-2.176.06-2.48.434-2.168.24.2.59.852.784 1.457.579 1.816.804 1.729 1.533-.583.529-1.688.687-2.87.673-5.006-.024-2.754-.016-2.786.518-2.096.56.72 1.144 2.408 1.148 3.302 0 1.086.5.728 1.018-.739.3-.842 1.188-2.688 1.976-4.101 2.635-4.75 3.613-6.907 4.301-9.497l.683-2.575 1.403 2.11c1.45 2.18 2.044 3.552 2.435 5.614l.228 1.198.724-2.216c.4-1.217 1.803-4.475 3.12-7.239 1.318-2.764 2.555-5.709 2.755-6.543.2-.834.433-1.517.519-1.517.273 0 2.083 2.914 2.69 4.331.727 1.693 1.501 5.402 1.501 7.182 0 .749.134 1.361.3 1.361.163 0 .299-.143.299-.32 0-.175.79-2.025 1.756-4.115 2.172-4.694 3.246-7.644 3.51-9.626.111-.839.313-1.591.452-1.677.75-.463 3.194 4.49 3.9 7.9.208 1.018.46 1.852.553 1.852.094 0 .939-1.582 1.873-3.519 4.016-8.323 9.64-15.11 19.688-23.742 2.383-2.048 5.4-4.738 6.699-5.972l2.365-2.245-.18 3.742c-.34 7.074-1.856 12.814-4.495 16.992-.439.695-.794 1.323-.794 1.397 0 .074 1.018-.333 2.261-.908 4.401-2.032 6.076-2.321 13.457-2.323 3.773 0 6.892.131 7.302.305.648.276.275.539-4.192 2.934-8.333 4.475-13.313 8.064-17.864 12.874-2.244 2.375-4.607 5.461-5.036 6.577-.12.32.395.61 1.956 1.112 1.986.639 2.723 1.163 1.637 1.163-.266 0-1.377.424-2.475.939-1.657.784-2.685 1.656-6.178 5.21-3.074 3.123-4.67 4.51-5.988 5.2-1.433.751-1.596.905-.824.76.609-.113.974-.06.974.143 0 .18-.12.323-.26.323s-1.57 1.214-3.167 2.695c-1.597 1.483-3.048 2.694-3.23 2.694-.181 0-.251.08-.16.172.095.094.8-.04 1.558-.3 1.405-.479 3.21-.622 3.545-.287.103.1-.226.529-.729.952-.505.425-1.62 1.856-2.479 3.186-.862 1.33-2.026 2.874-2.587 3.429-.962.958-.978 1.006-.273.818 1.477-.391 3.593-.563 3.593-.29 0 .153-.38.5-.849.78-1.078.634-2.654 2.446-4.7 5.388-.886 1.278-1.583 2.322-1.55 2.322.035 0 .955-.256 2.045-.565 2.688-.77 3.062-.42 1.107 1.038-1.928 1.44-6.277 7.61-5.363 7.61.966 0 4.73-2.075 6.262-3.453.818-.734 1.588-1.337 1.712-1.337.39 0-.096 4.072-.772 6.503-.894 3.226-2.52 6.208-4.491 8.243-1.968 2.036-1.591 2.222 1.383.673 1.104-.579 2.056-1.048 2.11-1.048.056 0-.599 1.112-1.457 2.471-1.473 2.336-4.565 5.777-6.214 6.918l-.748.52 1.048-.168c.578-.094 1.704-.58 2.509-1.074.802-.5 1.507-.858 1.564-.799.288.28-2.367 4.152-4.177 6.098-2.108 2.266-2.096 2.529.116 1.749.702-.246 1.345-.386 1.423-.308.25.25-3.24 4.858-5.078 6.707-.978.984-2.441 2.24-3.25 2.786-.812.551-1.476 1.11-1.482 1.244-.014.473 1.357-.156 3.373-1.541 5.2-3.58 5.876-3.593 2.505-.046-2.026 2.127-2.867 3.297-3.98 5.537-.775 1.562-1.338 2.914-1.248 3.002.088.09.799-.859 1.577-2.112 2.695-4.321 7.186-8.311 10.443-9.282.818-.239 1.537-.395 1.597-.339.06.06-.22.699-.619 1.423-1.162 2.122-2.196 5.53-3.184 10.471-1.251 6.278-1.97 8.822-2.998 10.619l-.868 1.517.803 2.23c.71 1.975.802 2.654.798 5.967-.012 5.635-1.377 10.425-5.637 19.727-.918 2.016-1.676 3.804-1.676 3.978 0 .554 1.587-.046 2.99-1.138.738-.571 1.389-.902 1.445-.735.147.445-1.034 4.581-1.892 6.623-.41.974-.743 1.84-.743 1.928 0 .465.79 0 2.146-1.267l1.523-1.421-.212 1.347c-.419 2.678-1.46 6.18-2.449 8.215-.559 1.144-1.008 2.116-1.008 2.156 0 .32 1.956-.719 2.934-1.557.864-.738 1.17-.882 1.098-.505-.056.29-.253 1.401-.435 2.471-.48 2.795-1.677 6.275-2.727 7.924-.499.787-.832 1.497-.746 1.583.487.489 3.545-2.72 5.066-5.313l.792-1.348v1.39c.004 1.52-1.118 6.173-2.076 8.602-.333.839-.539 1.533-.459 1.533.08 0 .93-.53 1.882-1.181.952-.65 2.376-1.457 3.168-1.797 1.511-.649 3.776-1.124 3.776-.794 0 .106-.525 1.237-1.161 2.507-1.37 2.734-2.603 6.072-3.214 8.686-.603 2.609-.32 3.421 2.908 8.312 4.543 6.886 7.99 13.538 9.86 19.041 1.21 3.541 1.537 7.775.779 10.008-.507 1.477-.44 1.996.174 1.381.612-.614.762-.403 1.077 1.517.605 3.657.695 5.523.36 7.385-.19 1.038-.256 1.97-.146 2.076.331.328 1.912-1.804 2.495-3.363.3-.806.619-1.347.708-1.198.088.146.471 1.477.853 2.96.495 1.923.698 3.567.708 5.739.012 2.487.086 2.982.41 2.714.618-.51 1.433-2.309 1.85-4.077.255-1.104.453-1.477.618-1.178.545.97 1.478 6.655 1.497 9.126l.02 2.646.54-1.217c.299-.669.642-1.928.762-2.799.327-2.383.806-1.447.984 1.92.08 1.587.263 2.77.403 2.635.136-.14.471-1.327.745-2.639.552-2.68.449-8.223-.19-9.963-.2-.543-.28-1.072-.18-1.172.32-.313 3.545 2.718 5.625 5.285 4.918 6.064 6.499 12.21 5.19 20.18-.288 1.77-.473 3.265-.412 3.325.06.06.815-.004 1.671-.14 1.972-.315 4.535.044 7.625 1.072 2.505.838 18.233 8.513 21.896 10.69 5.836 3.467 7.872 7.396 6.794 13.104-.34 1.79-.32 2.166.16 3.413.379.994.61 1.29.798 1.018.19-.29.687.08 1.888 1.403 1.916 2.108 3.597 5.13 4.06 7.296.375 1.74.719 1.752 1.178.04.311-1.154.285-1.218-1.533-3.653-3.902-5.233-5.753-10.806-5.585-16.8l.084-3.048 1.792 2.547c3.078 4.363 6.812 7.716 10.782 9.668 2.296 1.132 5.437 2.208 5.695 1.95.09-.087-.32-.886-.91-1.776-1.53-2.301-3.014-5.489-3.597-7.744-.709-2.74-.38-11.68.427-11.68.11 0 .44.454.739 1.005.882 1.637 3.964 4.44 8.277 7.525 5.257 3.758 7.341 5.62 9.736 8.682 2.236 2.869 4.825 7.669 5.849 10.859.385 1.191.778 2.17.878 2.17.1 0 .419-.66.71-1.472.994-2.766 4.517-5.443 8.853-6.73 1.904-.565 5.904-.633 8.055-.136l1.497.345 1.378-1.217c2.694-2.368 6.447-3.527 10.618-3.278 2.108.126 2.847.32 4.54 1.188l2.019 1.038 2.136-1.062c1.796-.89 2.535-1.082 4.606-1.192 4.14-.22 8.024 1.018 10.659 3.398l1.238 1.121 1.702-.379c4.218-.944 9.17-.028 12.834 2.375 1.89 1.242 3.793 3.605 4.172 5.176.108.45.291.822.407.822.116 0 .451-.808.749-1.796.846-2.823 3.582-8.104 5.562-10.73 2.352-3.126 4.904-5.444 9.88-8.975 4.663-3.313 6.687-5.133 8.28-7.445l1.133-1.642.26.846c.14.465.33 2.615.42 4.778.239 5.833-.807 9.491-4.123 14.403-.499.739-.832 1.424-.738 1.517.283.284 3.493-.848 5.848-2.065 4.092-2.116 8.307-6.02 10.986-10.176.627-.97 1.238-1.768 1.363-1.77.34-.004.272 5.618-.09 7.652-.734 4.152-2.546 8.315-5.053 11.63-2.036 2.687-2.146 2.93-1.83 4.023.488 1.704.692 1.65 1.185-.308.585-2.319 1.96-4.674 4.108-7.034 1.157-1.273 1.656-1.636 1.844-1.357.479.719 1.351-1.796 1.132-3.277-.565-3.825-.535-5.763.115-7.497.779-2.082 2.695-4.276 5.186-5.936 2.695-1.797 20.938-10.834 23.463-11.62 3.277-1.023 5.575-1.314 7.517-.955.924.17 1.702.31 1.736.31.032 0-.132-.845-.363-1.873-.685-3.062-.838-8.706-.305-11.207.894-4.202 2.646-7.625 5.774-11.277 1.856-2.172 4.824-4.867 5.076-4.615.075.08-.08 1.07-.346 2.203-.353 1.497-.447 2.927-.339 5.21.14 3.08.713 6.287 1.122 6.287.112 0 .273-1.13.36-2.509.199-3.141.658-4.2.91-2.09.1.799.444 2.056.774 2.803l.598 1.345.02-2.647c.02-2.427.95-8.15 1.478-9.09.135-.239.469.44.868 1.777.359 1.198.958 2.555 1.337 3.014l.683.842.01-2.934c.01-2.71.638-6.507 1.397-8.477.28-.718.315-.688.858.753.583 1.537 2.176 3.724 2.495 3.413.096-.094.05-1.166-.1-2.381-.323-2.565.264-8.972.819-8.972.1 0 .569.37 1.052.822l.874.825-.709-1.348c-.638-1.21-.706-1.72-.688-4.942.02-3.09.133-3.92.828-5.936 1.99-5.782 5.499-12.608 10.1-19.66 1.45-2.224 2.78-4.421 2.954-4.882.628-1.671-1.318-8.304-3.717-12.68-.559-1.013-.946-1.907-.866-1.987.227-.227 3.4.673 4.738 1.347.667.336 1.853 1.064 2.635 1.621.779.559 1.417.952 1.417.878 0-.073-.393-1.317-.878-2.768-.79-2.375-1.158-4.098-1.637-7.699-.18-1.36-.124-1.31 1.697 1.47 1.417 2.167 2.175 2.985 3.6 3.892.827.527.825.513-.385-1.725-1.161-2.152-2.375-6.116-2.854-9.315l-.22-1.461 1.246 1.211c1.144 1.11 3.026 2.12 3.024 1.621 0-.116-.246-.615-.543-1.108-1.205-2.008-3.034-7.828-3.046-9.696-.004-.663.106-.613 1.477.673 1.23 1.147 2.112 1.696 2.112 1.31 0-.04-.463-1.249-1.026-2.684-1.126-2.87-1.876-5.808-1.565-6.123.112-.11.569.153 1.022.584.864.83 3.014 1.865 3.294 1.587.09-.09-.66-1.95-1.661-4.131-5.613-12.228-6.976-19.655-4.735-25.828l.743-2.05-.729-1.246c-1.113-1.9-1.8-4.171-2.826-9.341-1.118-5.645-2.14-9.182-3.343-11.565-.487-.968-.819-1.824-.739-1.908.31-.307 3.254.902 4.95 2.036 2.08 1.387 5.11 4.525 6.723 6.956.632.954 1.227 1.66 1.317 1.57.094-.093-.331-1.18-.944-2.42-.792-1.605-1.848-3.024-3.673-4.942-3.053-3.208-2.668-3.633.945-1.038 2.614 1.876 3.946 2.622 4.4 2.469.174-.056-.235-.467-.908-.912-.672-.445-2.015-1.587-2.98-2.535-1.94-1.902-5.852-7.06-5.459-7.202.134-.05 1.064.188 2.066.523.998.34 1.892.615 1.984.615.09 0-.882-1.046-2.161-2.325-2.06-2.062-3.833-4.511-4.451-6.168-.16-.44.073-.355 1.077.371 1.124.819 3.248 1.683 3.5 1.43.051-.05-.6-.653-1.446-1.338a21.862 21.862 0 0 1-2.846-2.934c-1.257-1.62-3.4-4.958-3.4-5.295 0-.09.887.3 1.969.864 2.982 1.553 3.293 1.325 1.158-.862-2.855-2.926-4.72-7.513-5.13-12.607l-.188-2.37 1.992 1.691c2.555 2.17 6.487 4.184 6.487 3.326 0-.094-.954-1.573-2.12-3.284-1.437-2.115-2.614-3.477-3.664-4.245-1.505-1.098-1.523-1.132-.719-1.226.46-.052 1.53.112 2.382.36.858.251 1.606.405 1.67.339.066-.06-.243-.493-.678-.958-.44-.46-1.418-1.757-2.176-2.874-1.303-1.923-2.301-2.974-3.982-4.192-.739-.539-.739-.539.904-.387.906.084 1.984.25 2.395.367.703.2.685.15-.28-.812-.562-.567-1.726-2.116-2.582-3.443-.856-1.328-1.982-2.769-2.49-3.2-.514-.431-.935-.878-.935-.994 0-.235 3.034.024 4.172.355.499.146-.01-.485-1.611-2.008-1.286-1.217-2.72-2.489-3.194-2.814-1.13-.798-1.088-1.166.11-.948.772.14.603-.012-.824-.744-1.342-.69-2.855-2.004-5.988-5.19-4.122-4.202-5.33-5.102-7.858-5.858-.699-.208-1.274-.465-1.274-.573 0-.108.944-.5 2.096-.868 1.154-.372 2.096-.823 2.096-1.004 0-.525-3.218-4.683-5.37-6.934-4.8-5.03-11.42-9.615-20.378-14.112-2.136-1.072-2.206-1.142-1.497-1.437.427-.174 3.463-.32 7.037-.333 7.032-.026 8.829.25 13.26 2.043 1.365.553 2.443.919 2.395.819l-1.341-2.735c-2.3-4.674-3.288-8.882-3.583-15.269l-.174-3.744 2.355 2.267c1.298 1.246 4.24 3.872 6.543 5.836 10.16 8.663 16.97 16.994 20.479 25.056.559 1.277 1.098 2.32 1.204 2.32.103 0 .339-.78.523-1.725.63-3.238 2.986-8.13 3.828-7.944.16.032.459.908.667 1.944.493 2.443.958 3.696 3.273 8.802 1.052 2.325 1.912 4.38 1.912 4.567 0 .187.116.34.256.34s.335-1.11.433-2.47c.1-1.357.449-3.345.782-4.417.599-1.93 2.669-5.716 3.226-5.902.16-.054.45.613.652 1.483.2.868 1.497 3.936 2.88 6.818 1.386 2.88 2.747 6.162 3.028 7.292l.511 2.055.56-2.195c.522-2.076 1.682-4.367 3.107-6.156l.639-.802.559 2.371c.339 1.445 1.217 3.659 2.251 5.665l3.228 6.253c.842 1.629 1.584 2.774 1.652 2.545.505-1.703 1.192-3.274 1.565-3.58.387-.324.42-.069.24 2.055-.18 2.176-.116 2.683.654 4.996l.859 2.575.646-1.47c1.038-2.349 1.318-2.215 1.318.62 0 2.011.173 3 .888 5.033.49 1.394.898 2.908.898 3.374.01 1.297.465.714.874-1.124.206-.91.463-1.71.575-1.78.114-.069.22.718.244 1.748.024 1.046.399 3.094.854 4.64.659 2.242.794 3.22.706 5.136-.105 2.33.104 3.018.515 1.693.386-1.238 2.006-4.71 2.196-4.71.106 0 .14 1.021.08 2.275-.066 1.251.1 3.776.36 5.612.267 1.837.518 3.743.562 4.236.076.824.164.73 1.068-1.122.539-1.112 1.086-2.022 1.207-2.022.122 0 .17 1.246.106 2.769-.08 1.916.028 3.333.36 4.61a18.283 18.283 0 0 1 .478 3.813c0 1.09.12 1.98.26 1.98s.788-.978 1.425-2.172l1.158-2.172.152 2.655.15 2.659.99-1.382c1.189-1.656 3.047-2.814 4.95-3.073 1.572-.216 1.576-.2 1.065 1.986-.367 1.57-1.143 9.92-.952 10.259.072.13.535-.108 1.028-.523 1.505-1.265 1.884-.992.739.539-1.192 1.589-2.002 3.453-2.465 5.663-.24 1.157-.635 2.574-.879 3.153-.24.583-.367 1.132-.28 1.222.089.09 1.165-.902 2.388-2.206 1.222-1.303 2.295-2.295 2.385-2.205.212.213-2.103 7.36-2.662 8.213-.42.643-.406.649 2.295.838 1.497.108 3.573.196 4.619.196 1.046 0 1.892.1 1.88.224-.012.123-1.884 1.668-4.164 3.433-4.141 3.207-4.145 3.213-4.784 5.137a15.175 15.175 0 0 1-3.305 5.537c-.51.553-.873 1.062-.805 1.13.286.285 1.793-.559 3.034-1.707l1.337-1.227-.17 1.148a49.62 49.62 0 0 1-.544 2.868c-.208.948-.29 1.722-.18 1.722.388 0 2.661-2.565 3.17-3.579.287-.566.754-1.712 1.044-2.544l.525-1.511.559 1.796c.463 1.477.559 2.695.539 6.886-.02 4.497-.12 5.43-.813 8.028-.43 1.617-1.257 4.032-1.836 5.37-.579 1.34-.994 2.494-.918 2.57.245.246 2.275-1.497 3.201-2.75.505-.683 1.31-2.05 1.789-3.038l.872-1.797-.146 2.994c-.16 3.262-1.032 6.573-2.36 8.954-.424.759-.71 1.377-.636 1.377.07 0 .869-.419 1.77-.928.905-.509 1.644-.854 1.644-.766 0 .092-.26.61-.585 1.158-.32.542-.73 1.996-.91 3.233l-.591 4.132c-.32 2.24-1.108 3.98-2.59 5.708-.594.699-1.033 1.308-.971 1.363.33.292 4.415-.512 6.024-1.185 3.17-1.33 3.062-1.387 1.932 1.094-1.226 2.69-2.286 4.397-3.7 5.962-.919 1.018-.989 1.187-.48 1.187.326 0 1.352-.383 2.282-.852.926-.469 1.686-.735 1.686-.589 0 .954-3.085 5.996-4.83 7.884-.679.739-1.142 1.338-1.03 1.338.49 0 2.202-1.042 3.126-1.903.982-.918 1.002-.922.786-.191a14.477 14.477 0 0 1-.784 1.856c-.739 1.471-.719 1.597.419 2.934 2.874 3.353 3.186 9.202 1.118 20.718-1.511 8.404-3.134 11.79-7.006 14.647-1.29.952-1.022 1.066 1.044.44 2.155-.66 5.05-.863 6.992-.506.97.18 1.816.38 1.876.44.066.063-.719.907-1.733 1.875-1.018.965-3.193 3.306-4.836 5.198-1.64 1.892-3.88 4.297-4.974 5.35-1.094 1.051-1.722 1.81-1.393 1.692 2.092-.733 5.32-1.357 7.01-1.353 2.389.004 5.117.309 5.117.574 0 .104-.369.416-.822.685-1.108.665-3.193 2.703-6.932 6.778-1.712 1.867-3.639 3.739-4.28 4.164-1.297.862-1.253.982.66 1.697 4.94 1.846 6.913 5.862 5.884 11.965-1.332 7.885-7.32 17.94-15.102 25.361-2.679 2.555-6.148 5.064-6.507 4.703-.08-.08.61-1.75 1.537-3.713 1.471-3.117 4.79-10.692 5.533-12.62.427-1.118-.114-.739-1.226.858-1.141 1.645-3.676 3.886-5.369 4.74-.585.3-1.856.72-2.824.935-1.477.327-2.008.638-3.314 1.95-.858.854-2.155 1.87-2.886 2.255l-1.327.703.894.106c.491.06 1.413-.05 2.05-.24.637-.19 1.226-.28 1.311-.193.284.283-1.137 2.255-2.405 3.343-1.098.944-3.672 2.355-5.44 2.988-1.218.439.143.455 1.985.03 1.048-.24 1.956-.385 2.02-.324.064.06-.679.887-1.647 1.825-.966.938-1.49 1.61-1.163 1.489 1.193-.44 4.265-.547 5.84-.21 1.677.36 5.102 1.77 5.08 2.09-.008.1-1.192.758-2.635 1.453-2.595 1.258-7.76 5.074-8.836 6.527-.304.413-.805 1.762-1.118 2.998-.305 1.237-.922 2.884-1.37 3.66-2.742 4.779-8.722 11.148-14.254 15.186-1.577 1.152-2.88 2.201-2.895 2.331-.01.13.623.16 1.404.064.782-.09 4.99-.291 9.357-.445 10.01-.35 14.359-1.094 17.608-3.01.567-.335 1.088-.55 1.158-.483.223.226-3.373 4.49-5.629 6.67-4.052 3.913-7.928 6.256-13.113 7.92-4.336 1.398-7.964 1.837-15.144 1.837-3.457.004-6.151.054-5.988.114.795.29 12.31 2.848 14.643 3.253 3.293.575 7.245.589 9.61.032.986-.231 1.849-.365 1.917-.3.065.067-.799 1.01-1.917 2.097-3.886 3.748-7.45 5.836-11.74 6.872-3.37.812-9.6.505-14.267-.705-3.338-.868-3.613-.898-4.457-.459-.865.451-1.95.44-3.433-.04-.533-.172-.729-.07-.946.491-.396 1.012-1.428 2.016-2.296 2.236-1.377.343-2.627-.493-4.231-2.845-.048-.066-.673.192-1.398.58-1.177.618-1.407.652-2.259.299-1.072-.44-2.17-2.126-2.746-4.204-.208-.743-.523-1.509-.7-1.707-.179-.193-1.496-.51-2.927-.698-3.577-.471-5.41-.076-7.266 1.557-1.233 1.083-2.56 3.046-2.56 3.784 0 .148.704.088 1.564-.136 3.266-.848 5.863-.413 9.847 1.649 2.067 1.07 4.978 2.112 7.301 2.615.792.167.595.273-1.645.888a84.93 84.93 0 0 0-4.79 1.48c-2.735.959-6.176 1.264-8.697.77-1.01-.2-1.904-.3-1.984-.22-.35.351 2.256 2.698 4.132 3.718 1.996 1.09 2.747 1.857 1.383 1.425-.774-.247-7.784-.572-8.906-.41-.628.091-.375.31 1.601 1.402 1.291.713 2.275 1.368 2.186 1.458-.09.09-1.078-.06-2.2-.336-1.848-.45-9.375-1.385-9.62-1.191-.06.04.435.419 1.097.838 1.371.864 1.936 1.537 1.062 1.27-2.275-.7-11.19-2.128-11.19-1.79 0 .053.893.532 1.98 1.059 1.985.97 2.176 1.46.344.878-1.094-.35-6.168-1.09-9.357-1.371-1.66-.14-1.972-.108-1.497.165.33.19 1.181.68 1.896 1.084.71.405 1.237.795 1.166.866-.072.072-1.707-.279-3.633-.774-3.194-.822-10.489-1.772-10.85-1.41-.192.192 2.988 2.84 5.277 4.392l1.767 1.202 2.634-.673c2.324-.59 3.38-.669 8.779-.659 5.7.006 6.503.08 11.229.998 8.852 1.72 11.868 2.162 16.018 2.342 9.217.399 16.992-1.501 27.289-6.667 1.822-.912 3.367-1.609 3.433-1.543.186.186-.938 4.345-1.76 6.507-2.79 7.357-6.979 12.499-12.571 15.439-2.15 1.128-5.942 2.523-6.86 2.523-.3 0-.547.114-.547.255 0 .14 1.111.5 2.47.795 1.853.403 4.124.559 9.058.628 6.86.1 9.547-.147 14.619-1.349 1.345-.32 2.495-.529 2.555-.469.064.06-.29.958-.779 1.996-3.493 7.381-11.377 12.475-22.614 14.595-7.984 1.507-15.696 1.469-27.313-.14-12.714-1.765-18.353-2.05-23.389-1.188-1.463.252-7.241 1.68-12.838 3.178-19.251 5.14-23.148 6.048-30.63 7.156-4.587.678-4.012.678-7.096.02zm-70.777-5.022c.928-.524 2-1.449 2.514-2.18.81-1.14.899-1.496.899-3.56 0-1.956-.12-2.495-.819-3.685-1.58-2.69-4.231-4.223-8.303-4.8-3.449-.487-7.579-.008-17.036 1.984-4.221.89-9.157 1.832-10.968 2.1-12.56 1.844-20.41.788-25.037-3.373-3.737-3.364-4.862-10.08-2.475-14.79.892-1.761 3.784-5.122 5.617-6.527.75-.575 1.37-1.138 1.377-1.252.024-.443-3.605-.93-6.727-.902-2.215.02-5 .33-8.53.944-14.292 2.501-14.412 2.515-21.258 2.535-5.583.02-6.862-.068-9.64-.655a46.26 46.26 0 0 1-11.393-3.976c-1.605-.802-2.919-1.393-2.919-1.313 0 .08.485 1.118 1.078 2.307 4.012 8.05 11.098 12.775 23.26 15.509 1.612.363 2.886.794 2.83.958-.186.567-3.845 2.57-6.335 3.473-6.533 2.361-16.118 3.066-23.365 1.709-1.31-.244-2.456-.37-2.543-.28-.09.09.624.898 1.586 1.797 2.982 2.778 9.134 5.409 15.659 6.696 7.595 1.501 14.379 1.47 26.008-.13 9.608-1.317 11.297-1.467 16.616-1.477 7.072-.012 9.453.4 24.902 4.284 18.147 4.57 24.51 5.748 30.22 5.6 2.897-.075 3.309-.16 4.79-.992zm80.09.64c5.573-.731 11.66-2.05 24.834-5.376 15.07-3.808 17.034-4.136 24.687-4.136 5.928 0 5.716-.02 21.407 2.092 4.882.659 13.918.647 18.163-.02 5.952-.938 10.507-2.365 14.537-4.555 2.305-1.253 5.808-4.071 5.473-4.4-.08-.08-1.158.04-2.395.273-6.108 1.15-15.286.738-21.142-.946-2.92-.839-6.946-2.691-8.343-3.829l-.886-.73 1.786-.354c10.587-2.101 17.804-5.84 22.066-11.433 1.776-2.335 3.952-6.335 3.529-6.487-.14-.05-1.444.507-2.899 1.238a46.72 46.72 0 0 1-10.972 3.852c-2.628.571-3.958.659-9.636.659-7.036 0-6.906.02-21.257-2.505-5.57-.978-12.036-1.206-14.357-.507l-1.184.36 1.73 1.492c2.04 1.757 4.651 4.88 5.521 6.61 2.228 4.42.998 11.354-2.574 14.502-3.909 3.449-9.525 4.742-18.088 4.167-4.936-.331-8.922-.972-18.503-2.966-8.457-1.76-12.19-2.255-15.23-2.016-6.103.487-10.139 3.577-10.462 8.014-.25 3.45 1.547 5.908 5.13 7.026 1.7.539 4.87.527 9.067-.024zm-116.046-15.544c1.565-.235 6.012-1.101 9.88-1.922 9.54-2.022 11.188-2.255 15.868-2.235 2.427.006 3.802-.09 3.443-.24-11.596-4.84-24.85-9.32-31.468-10.632-3.505-.699-9.441-.707-12.016-.02-5.218 1.39-7.501 3.928-7.206 8.004.216 3.004 2.75 6.107 5.62 6.878 3.49.938 10.312 1.01 15.877.165zm153.441.426c4.7-.53 6.81-1.621 8.413-4.352.938-1.604 1.266-4.315.719-5.968-.87-2.642-3.924-4.622-8.34-5.409-5.217-.934-10.12-.265-19.953 2.719-5.116 1.55-21.986 7.884-22.695 8.517-.125.12.615.091 1.649-.06 3.579-.515 8.283.08 19.547 2.47 10.574 2.246 15.13 2.705 20.662 2.083zm-76.48-.899c10.888-.834 20.762-2.854 31.692-6.487 2.24-.738 8.383-3.005 13.653-5.03 11.053-4.247 14.96-5.548 19.32-6.45 3.364-.699 8.783-.919 12.264-.505l1.946.231-.878-.678c-7.51-5.825-14.559-12.555-17.165-16.4-3.952-5.824-7.531-8.163-12.495-8.169-1.968 0-3.653.325-9.431 1.824-14.559 3.779-26.886 5.825-40.195 6.667-12.69.798-31.078-1.65-50.672-6.747-6.755-1.762-8.491-2.021-10.91-1.636-3.863.619-7.072 3.026-10.354 7.764-3.043 4.395-13.393 14.231-17.57 16.699-.898.53-1.158 1.151-.352.842 1.601-.619 6.208-.874 9.445-.533 5.799.615 10.35 1.956 21.637 6.387 14.321 5.629 20.782 7.744 29.465 9.673 10.638 2.36 21.393 3.259 30.598 2.554zm-3.074-8.662c-.778-.104-1.81-.48-2.287-.832l-.872-.645-.707.758c-.814.869-1.85.807-3.25-.191-.997-.705-1.447-.735-2.231-.14-.792.599-2.864.553-3.768-.08-.633-.443-1.346-.505-4.93-.427-6.248.14-13.16-1.048-16.912-2.894-1.418-.703-2.068-1.373-2.49-2.579-.055-.152-.423-.052-.818.226-1.732 1.211-6.076.247-7.006-1.551-.634-1.224-.606-1.669.4-6.655.479-2.375.966-5.1 1.085-6.058.2-1.62.944-2.894 1.697-2.894.367 0 .325.331-.858 6.547-.807 4.22-1.018 5.928-.799 6.287.884 1.397 4.358 2.367 6.012 1.677.54-.228 1.062-.619 1.158-.878.34-.873.864-.47.864.662 0 1.062.088 1.166 1.617 1.912 3.27 1.593 12.175 3.254 17.44 3.254 2.464 0 4.336-.559 4.655-1.393a.693.693 0 0 1 .605-.403c.246 0 .383.17.308.373-.643 1.716-.64 1.722.728 1.716 1.377-.006 2.327-.567 2.914-1.716.5-.972.978-.829.868.265-.08.819.048 1.012 1.034 1.531 1.286.67 1.71.491 2.32-.982.493-1.191 1.082-1.124 1.323.156.108.575.451 1.181.759 1.349.85.45 5.474.38 6.127-.096.513-.379.493-.459-.363-1.43-.5-.568-.946-1.23-.998-1.474-.136-.693.33-2.689.633-2.689.41 0 1.67 1.817 2.056 2.967.778 2.325.14 5.05-1.358 5.804-1.086.547-3.153.766-4.956.525zm13.687-.812c-2.096-.452-2.783-1.571-3.725-6.088a116.214 116.214 0 0 0-1.411-5.884c-.683-2.483-.715-2.815-.32-3.57.424-.806.446-.812.763-.219.18.34.85 2.914 1.491 5.725.639 2.814 1.391 5.459 1.665 5.878.459.702.674.764 2.664.764 4.58 0 12.809-2.245 12.407-3.383-.075-.22-.664-.34-1.505-.313-1.688.06-2.016-.545-1.197-2.222.986-2.016 4.403-3.13 6.056-1.972.642.453.688.639.519 2.246l-.18 1.756h.998c2.415 0 12.315-3.978 14.485-5.818 1.062-.898 1.201-1.405.539-1.956-.35-.29-.513-.192-.882.525-.533 1.034-1.152 1.253-2.523.892-.799-.21-1.118-.539-1.605-1.64-1.172-2.645-.599-5.478 1.098-5.478.946 0 3.247 1.625 4.145 2.922 1.709 2.48 2.252 5.322 1.29 6.787-1.078 1.648-6.507 4.523-11.324 5.988-3.558 1.088-5.219 1.251-6.642.658l-1.148-.479-1.197 1.022c-1.362 1.168-4.87 2.655-7.725 3.274-2.142.467-5.798.784-6.736.585zm30.686-16.713c.295-.36.275-.479-.116-.633-.667-.255-1.381.068-1.381.62 0 .588 1.01.598 1.497.013zm-101.346 6.753c-1.477-.36-2.675-1.108-3.838-2.396-.929-1.026-1.102-1.433-1.102-2.578 0-1.697.798-3.302 2.347-4.697 2.28-2.06 3.693-2.295 1.785-.3-.587.615-1.218 1.412-1.402 1.773-1.329 2.595 1.76 5.481 5.863 5.481 2.774 0 3.083-.405 3.083-4.028v-2.828l1.002-.763c.551-.419 1.158-.764 1.348-.764.495 0 .433 2.12-.126 4.275-1.421 5.49-4.575 7.888-8.962 6.823zm59.76-2.08c-.839-.649-.719-1.757.253-2.356.525-.323.73-.263 1.533.454l.924.828-.643.818c-.752.958-1.093.998-2.063.256zm-37.738-1.068c-.66-.699-.719-.709-1.438-.24-.724.475-.778.465-1.477-.349-.838-.972-.798-1.27.276-2.072l.782-.585.743.865c.732.852.748.858 1.37.293.598-.545.65-.545 1.217-.03.958.862 1.038 1.597.255 2.25-.888.738-.91.738-1.728-.134zm87.463-2.934a146.561 146.561 0 0 0-3.58-6.148c-1.591-2.57-2.136-3.74-2.292-4.91-.111-.842-.091-1.643.044-1.776.26-.26 4.331 6.403 6.579 10.766.874 1.69 1.29 2.874 1.29 3.667 0 .644-.125 1.17-.274 1.17-.15 0-.946-1.248-1.767-2.771zm-27.524 1.205c-.808-.389-.83-.624-.16-1.76.593-1.004.705-1.026 1.896-.411.982.505 1.034.678.535 1.772-.375.819-1.123.952-2.275.4zm-76.432-9.093c-.403-1.224-.22-1.527 1.082-1.787.772-.153.958-.064 1.263.607.539 1.178.44 1.64-.41 1.962-1.249.475-1.56.351-1.935-.782zm90.354.87c-1.074-.28-.385-2.487.774-2.487 1.198 0 1.797.667 1.557 1.742-.173.795-.34.949-1.006.919a7.844 7.844 0 0 1-1.323-.174zm-119.825 1.976c2.236-.413 3.627-1.122 5.022-2.559 2.13-2.191 2.102-4.012-.076-4.595-2.615-.704-5.455.739-7.924 4.02-.928 1.228-1.816 2.316-1.976 2.415-.573.356-.283.709.679.829 1.862.233 2.52.22 4.275-.108zm160.597-.16c.07-.065-.208-.487-.619-.938a40.465 40.465 0 0 1-1.996-2.53c-2.016-2.735-5.114-4.184-7.559-3.526-2.028.547-2.235 1.86-.646 4.056 1.636 2.256 5.19 3.543 8.89 3.214.99-.084 1.856-.208 1.926-.276zm-177.373-1.473c1.772-.826 2.17-1.141 3.19-2.53 1.001-1.364 1.187-2.212.652-2.975-.353-.503-.754-.618-2.156-.618-1.387 0-1.986.17-3.105.878-1.198.758-4.976 4.902-5.118 5.613-.064.319 2.315.598 3.842.447.659-.064 1.87-.433 2.695-.815zm9.002.56c2.898-.989 5.774-4.845 4.63-6.218-.918-1.112-3.752-.89-5.778.45-1.088.72-5.31 5.32-5.31 5.783 0 .605 4.665.593 6.458-.02zm177.223.153c.34-.34-4.078-5.335-5.41-6.114-2.688-1.577-5.817-1.177-5.817.739 0 1.722 2.706 4.507 5.155 5.297 1.274.413 5.68.47 6.072.08zm9.032-.18c.513-.327-3.353-4.806-5.062-5.862-2.649-1.637-5.828-1.008-5.413 1.072.247 1.244 2.427 3.52 4.128 4.311 1.161.543 2.021.703 3.752.699 1.238 0 2.403-.1 2.595-.22zm8.662-.549c-.085-.223-.914-1.417-1.84-2.644-1.267-1.687-2.062-2.427-3.213-3-2.136-1.064-3.793-1.006-4.416.151-.602 1.124 1.218 3.701 3.424 4.85 2.319 1.208 6.433 1.645 6.047.643zm-213.18-.498c3.193-1.63 4.906-4.875 2.954-5.617-2.126-.807-4.432.353-6.797 3.423-2.549 3.313-2.549 3.287.108 3.114 1.577-.104 2.655-.368 3.733-.919zm-8.48-.893c.779-.327 1.9-1.127 2.488-1.776 1.93-2.14.992-3.932-1.785-3.413-1.357.251-2.894 1.6-4.59 4.016l-1.272 1.806.822.108c1.27.17 2.78-.09 4.336-.739zm229.02.725c.419-.172.271-.51-.965-2.196-1.862-2.55-3.205-3.577-4.926-3.772-1.592-.18-2.247.24-2.247 1.437 0 1.617 2.241 3.609 4.83 4.307 1.777.48 2.555.531 3.306.224zm-185.842-4.717c.479-.732.479-.794-.04-1.177-.463-.336-.627-.332-1.038.04-.4.359-.425.579-.15 1.173.43.926.599.918 1.226-.034zm139.3-.026c.313-.678.29-.848-.153-1.177-.425-.314-.594-.308-.944.04-.339.333-.355.57-.08 1.177.44.962.72.952 1.178-.04zm-187.93-.28c.93-.259 2.081-.788 2.56-1.173.855-.692.859-.708.27-1.157-1.317-1.018-3.43-1.465-6.108-1.304-2.678.16-4.463.745-6.499 2.13l-1.084.734.978.505c2.132 1.104 6.48 1.218 9.88.266zm244.895-.159c1.297-.575 1.323-.614.748-1.052-3.273-2.475-8.946-3.24-12.215-1.64-.789.389-1.39.858-1.338 1.046.18.604 3.322 1.984 5.17 2.269 2.495.387 6.012.104 7.635-.619zm-125.089-6.153c.06-3.972-.028-6.727-.213-7.106-.168-.331-.655-.798-1.082-1.038-1.086-.613-2.495-.016-2.934 1.238-.34.964-.455 12.095-.14 12.924.144.37.639.475 2.236.475h2.055l.08-6.493zm-89.713 5.708c.579-.383.669-.579.4-.898-.44-.539-.999-.523-1.458.032-.345.411-.24 1.351.144 1.351.094 0 .505-.22.914-.487zm10.265-.61c.054-.029-.253-.284-.686-.567-.749-.491-.805-.49-1.202.05-.355.49-.347.642.06 1.093.453.503.507.503 1.098.004.347-.287.672-.547.73-.579zm72.858-5.04c-.08-5.17-.168-6.092-.631-6.737-.75-1.052-2.715-1.197-3.645-.271-.634.634-.65.798-.459 4.73a162.233 162.233 0 0 0 .387 5.968c.22 2.204.54 2.461 2.944 2.361l1.497-.063zm12.602 5.764c.405-.307.56-1.37.847-5.808.191-2.994.259-5.785.153-6.208-.107-.433-.586-.978-1.083-1.233-.779-.404-1.018-.408-1.917-.032-.566.233-1.157.674-1.317.978-.343.648-.818 11.876-.525 12.349.28.449 3.234.411 3.842-.048zm71.107-1.094c-.2-.263-.4-.53-.439-.595-.04-.06-.423.114-.846.39l-.77.507.686.558c.629.51.734.52 1.211.09.424-.379.454-.559.16-.948zm9.515 1.138c.11-.18.03-.645-.18-1.038-.367-.687-.403-.693-1.217-.212l-.838.493.808.52c.978.63 1.164.658 1.425.239zm-185.57-.543c.538-.212.968-.473.958-.579-.004-.108-.467-.487-1.026-.844l-1.018-.647-.475.725c-.37.559-.4.862-.148 1.337.18.34.419.565.53.503a24.4 24.4 0 0 1 1.178-.499zm195.28-.024c.24-.451.204-.766-.16-1.317l-.472-.729-1.018.649c-.559.359-1.024.724-1.032.818-.012.16 1.673 1.052 2.148 1.138.12.024.359-.228.533-.559zm-203.91-.26 1.242-.552-.766-.503c-.743-.487-.786-.475-1.481.333-.393.455-.653.93-.575 1.058.186.3.16.305 1.58-.332zm94.375-2.135c-.214-5.723-.569-8.707-1.11-9.301-.649-.719-2.583-.779-3.253-.108-.55.547-.56 1.297-.074 7.311l.35 4.337.897.2c.493.108 1.438.173 2.09.15l1.192-.047-.096-2.544zM465.1 469.9c.299-.487.954-10.551.724-11.15-.213-.559-1.401-.986-2.38-.858-.328.04-.881.391-1.227.774-.555.615-.654 1.214-.834 4.998-.112 2.365-.283 4.896-.383 5.62l-.18 1.318 2.036-.187c1.126-.104 2.136-.34 2.244-.515zm92.044.333c.092-.154-.16-.635-.563-1.068-.708-.766-.758-.774-1.505-.283l-.772.507.978.525c1.148.618 1.623.698 1.86.319zm-123.9-2.341c-.094-1.112-.256-3.34-.36-4.95-.17-2.661-.253-2.974-.904-3.404a1.89 1.89 0 0 0-2.648.575c-.35.54-.4 1.441-.26 4.615.1 2.17.28 4.112.403 4.311.22.352 1.83.77 3.234.839.688.036.698-.008.535-1.986zm37.01 1.527c.658-.18.748-.635.973-5.114.184-3.629.18-3.673-.569-4.417-.413-.413-1.073-.753-1.467-.753-1.367 0-1.636.733-1.98 5.45a198.221 198.221 0 0 0-.325 4.88c0 .407.23.453 1.421.29.783-.103 1.657-.259 1.946-.334zm-100.738-.27c2.09-1.465-1.214-6.074-5.25-7.32-1.94-.598-3.676-.734-4.624-.352-.431.173-.22.638 1.397 3.085 1.052 1.585 2.315 3.168 2.814 3.521 2.116 1.511 4.412 1.942 5.663 1.064zm165.579-.311c1.676-.839 2.82-2.096 4.776-5.282l1.238-2.016-.755-.193c-.948-.24-3.134.05-4.958.655-2.55.842-5.337 3.946-5.337 5.938 0 1.728 2.479 2.171 5.036.898zm-175.264.185c.643-.243.769-.479.769-1.453 0-.928-.24-1.437-1.192-2.515-1.688-1.916-3.493-2.698-6.34-2.74-1.258-.02-2.38.05-2.486.155-.265.264 1.804 3.12 3.467 4.785 1.757 1.762 3.998 2.447 5.784 1.768zm19.052-.02c1.302-.692.068-4.131-2.006-5.588-2.161-1.521-5.489-2.382-7.52-1.943l-.979.21 1.39 2.096c1.828 2.76 3.289 4.287 4.756 4.97 1.317.613 3.459.738 4.36.26zm4.14-.604c.373-.505.609-1.102.523-1.324-.18-.465-2.839-2.096-3.058-1.88-.08.08-.004.51.164.958.17.443.307 1.25.307 1.786 0 1.685.992 1.907 2.064.46zm136.301-.729c.106-.824.29-1.736.406-2.022.12-.287.09-.523-.06-.523-.48 0-3.084 1.773-3.084 2.102 0 .708 1.341 2.112 1.936 2.026.487-.07.647-.385.802-1.583zm6.388 1.052c1.564-.759 2.762-2.002 4.636-4.804l1.491-2.236-2.407-.09c-2.072-.074-2.649.024-4.112.693-.934.427-2.081 1.138-2.549 1.585-1.782 1.688-2.582 4.477-1.473 5.123.863.505 3.094.366 4.412-.27zm17.67.26c1.75-.484 2.639-1.228 4.685-3.913 1.447-1.904 1.744-2.467 1.417-2.688-.58-.4-4.423-.1-5.729.449-2.375.992-4.756 4.048-4.231 5.423.365.948 1.97 1.25 3.858.728zm-201.624-.573c1.411-.759-.086-3.473-2.695-4.895-1.105-.598-2.175-.908-3.529-1.014l-1.944-.16 1.138 1.767c2.132 3.306 3.677 4.571 5.609 4.599.463.006 1.102-.126 1.42-.3zm8.642-.25c.69-1.29-.888-3.984-3.081-5.27-1.453-.852-3.825-1.387-5.07-1.145-.739.144-.787.22-.42.649.228.271.83 1.23 1.338 2.135 1.577 2.81 3.441 4.186 5.669 4.192.93 0 1.343-.148 1.562-.559zm203.285-.028c.631-.32 1.49-.99 1.906-1.485 1.284-1.525 2.96-4.49 2.74-4.844-.135-.224-.724-.268-1.74-.134-3.74.495-6.766 2.974-6.84 5.605-.014.499.164 1.022.395 1.17.709.448 2.332.307 3.54-.312zm7.715.267c1.197-.455 2.056-1.32 3.718-3.776 1.64-2.421 1.567-2.569-1.062-2.104-3.289.58-6.151 2.875-6.151 4.926 0 1.214 1.636 1.657 3.497.954zm-138.226-.385c0-.22-.824-1.333-1.832-2.47-2.649-2.987-4.845-5.937-8.332-11.198-3.732-5.633-5.277-7.59-8.143-10.351-2.968-2.855-5.37-4.42-9.92-6.463-4.743-2.13-9.844-5.094-9.451-5.49.243-.239 11.56 3.67 13.567 4.687 3.548 1.8 5.92 3.797 9.532 8.018 1.487 1.74 2.805 3.206 2.928 3.254.414.171-.61-2.76-1.864-5.33-.99-2.028-1.736-3.03-3.672-4.938-3.194-3.153-6.016-4.61-14.132-7.311-3.453-1.15-6.938-2.37-7.744-2.715-2.228-.958-4.918-3.008-7.346-5.602l-2.185-2.336.22 1.178c.45 2.431 1.916 6.178 3.263 8.337 3.01 4.83 9.78 9.793 16.217 11.89 5.719 1.863 9.385 4.944 16.387 13.773 1.896 2.387 4.98 6.067 6.854 8.18a607.412 607.412 0 0 1 4.002 4.55c.659.774 1.647.978 1.647.34zm3.892-.008c0-.225-.223-.595-.495-.822-.91-.753-4.59-5.699-5.648-7.589-1.591-2.842-2.282-5.1-2.296-7.495-.02-3.519 1.363-5.754 4.363-7.061 2.076-.909 5.663-1.094 8.268-.432l2.583.653c.479.12.978-.176 1.956-1.154 1.732-1.736 4.698-2.942 7.736-3.15 1.87-.127 2.615-.03 4.463.592l2.216.746 1.31-.579c1.71-.758 4.891-1.008 7.047-.559 2.29.473 5.08 1.902 6.195 3.174.5.569 1.058 1.034 1.244 1.034.185 0 1.277-.286 2.42-.635 2.949-.894 6.927-.714 9.123.415 2.838 1.457 4.121 3.645 4.091 6.956-.046 3.956-2.31 8.46-7.026 13.964-.79.928-1.443 1.836-1.443 2.02 0 2.156 7.904-7.674 11.078-13.772 3.13-6.012 3.599-13.896 1.064-17.9-1.573-2.485-4.57-4.555-8.078-5.575-1.892-.547-6.064-.635-8.044-.168-1.068.254-1.225.196-2.545-.948-4.111-3.56-10.02-4.43-14.9-2.195l-1.706.782-1.58-.774c-4.572-2.236-10.943-1.377-14.602 1.968-1.536 1.407-1.632 1.449-2.77 1.185-1.748-.405-6.353-.339-8.064.12-2.161.58-4.49 1.843-6.056 3.28-2.926 2.694-3.824 5.243-3.598 10.22.27 5.94 2.042 10.159 7.27 17.278 4.05 5.521 6.426 7.896 6.426 6.427zm53.592-2.499c3.837-4.317 5.829-6.686 9.633-11.457 3.912-4.904 7.94-8.962 10.539-10.618.964-.619 3.053-1.557 4.638-2.096 1.587-.535 3.829-1.451 4.98-2.036 4.87-2.459 10.08-6.978 12.068-10.447.926-1.617 3.054-7.505 3.054-8.447 0-.283-1.226.739-2.92 2.435-1.603 1.607-3.683 3.37-4.621 3.916-.938.55-4.896 2.064-8.798 3.374-9.062 3.033-11.757 4.403-14.984 7.592-2.036 2.01-2.655 2.87-3.8 5.25-.751 1.563-1.454 3.383-1.557 4.042l-.196 1.197.848-1.048c4.779-5.908 8.403-9.042 12.675-10.982 1.856-.842 12.58-4.383 12.754-4.211.126.13-2.088 1.625-4.71 3.177-.6.356-2.85 1.438-5 2.402-7.876 3.536-11.317 6.746-18.018 16.798-3.647 5.473-5.824 8.389-8.335 11.157-1.012 1.118-1.837 2.226-1.837 2.471-.004 1.042 1.21.208 3.59-2.469zm-169.11 1.397c1.717-2.335 2.216-10.512.89-14.56-.857-2.62-2.927-5.892-3.807-6.018a1.25 1.25 0 0 0-1.018.387c-.34.403-.184.918 1.014 3.413 2.515 5.254 2.858 8.168 1.493 12.799a895.754 895.754 0 0 0-.927 3.15c-.16.562.972 1.843 1.485 1.676.186-.066.58-.443.873-.845zm279.009.3c.699-.699.625-1.467-.391-4.02-.755-1.896-1.038-6.164-.547-8.144.2-.79 1.042-2.884 1.876-4.65 1.29-2.719 1.463-3.284 1.132-3.68-.71-.86-1.587-.374-2.914 1.602-2.002 2.99-2.619 5.397-2.619 10.227 0 3.364.114 4.403.679 6.194.638 2.05 1.277 3.088 1.886 3.088.155 0 .559-.28.898-.62zm-172.379-.391c.09-.24-.822-1.545-2.148-3.07a3747.423 3747.423 0 0 1-6.926-8.044c-7.748-9.042-10.207-11.042-16.596-13.523-4.024-1.557-5.769-2.435-7.431-3.74-.62-.483-1.122-.819-1.122-.75 0 .067.32.985.709 2.035.389 1.05.878 2.615 1.077 3.477.413 1.77.715 1.77 1.421.004l.487-1.217.713.868c.39.475 1.317 1.77 2.056 2.874 1.198 1.777 1.665 2.184 4.106 3.573 6.632 3.758 13.48 8.916 19.373 14.583 1.896 1.82 3.592 3.317 3.784 3.327.19.008.413-.172.499-.4zm67.69-2.507c6.217-5.984 13.24-11.298 19.83-15.004 2.575-1.445 2.838-1.687 4.517-4.156.978-1.44 1.984-2.66 2.23-2.708.293-.054.57.327.808 1.125.2.667.479 1.21.618 1.21.144 0 .428-.707.63-1.573.203-.864.688-2.429 1.077-3.477.39-1.048.709-1.956.709-2.02 0-.064-.575.326-1.278.859-1.64 1.245-3.114 1.976-7.605 3.772-4.187 1.677-7.117 3.519-9.77 6.136-1.026 1.014-4.984 5.463-8.796 9.888-6.317 7.333-7.411 8.87-6.312 8.87.17 0 1.673-1.314 3.342-2.918zm-71.377 2.335c0-.453-5.07-4.806-9.36-8.034-3.562-2.678-7.875-5.609-11.122-7.557l-1.17-.698.2 1.437c.105.798.195 1.744.195 2.112 0 .513.308.784 1.328 1.173 3.01 1.15 6.37 3.759 9.572 7.433 1.896 2.172 2.206 2.322 8.264 3.926 2.064.547 2.095.551 2.095.208zm75.528-.874 4.126-1.154L497 461.59c2.934-3.114 6.194-5.565 8.631-6.495 1.066-.409 1.377-.678 1.377-1.193 0-.368.088-1.308.196-2.096l.195-1.43-1.469.847c-2.2 1.27-8.389 5.425-10.598 7.118-5.274 4.038-10.32 8.59-9.507 8.582.044 0 1.932-.519 4.2-1.157zm-193.95-.194c1.592-.413 3.34-.938 3.885-1.165.938-.394.998-.513 1.118-2.176.094-1.331.347-2.09 1.034-3.102 1.58-2.331 1.636-2.187-.73-1.964-1.168.108-5.13.938-8.8 1.836-7.995 1.962-11.069 2.525-13.861 2.54l-2.096.011.748.623c1.266 1.054 5.358 2.97 7.601 3.557 3.214.842 7.473.778 11.098-.16zm318.72.288c2.011-.471 6.766-2.655 8.083-3.713l.748-.599-2.13-.008c-2.746-.008-6.147-.613-12.674-2.243-5.788-1.451-9.78-2.256-11.161-2.256h-.898l.542.823c1.448 2.195 1.99 3.473 2.028 4.79l.04 1.397 1.948.665c4.647 1.587 9.73 2.016 13.473 1.142zm-229-.336c.224-.275.978-.864 1.677-1.307 1.237-.787 1.253-.818.686-1.331-.558-.505-.618-.485-1.6.558-.563.595-1.443 1.166-1.96 1.268-1.078.22-1.138.343-.416.894.707.539 1.122.515 1.611-.08zm130.272.08c.727-.547.665-.679-.413-.892-.515-.1-1.397-.67-1.956-1.264-.845-.898-1.09-1.018-1.465-.704-.62.515-.513.678 1.365 2.05 1.882 1.373 1.776 1.337 2.469.812zm-198.28-1.178c.666-1.886.931-5.489.604-8.123-.75-6.048-3.182-10.331-4.776-8.411-.286.345-.208.694.385 1.722 1.732 3 2.603 7.904 2.004 11.317-.753 4.282-.753 4.156.028 4.447.978.366 1.363.154 1.756-.954zm109.978.024c-.08-.698-.2-1.449-.268-1.666-.14-.455-1.672-.367-1.828.108-.116.359 1.63 2.834 1.996 2.834.14 0 .18-.573.1-1.274zm45.947.02c1.21-1.568 1.226-2.035.072-2.035-.687 0-.924.153-1.028.67-.61 3.03-.47 3.228.958 1.365zm110.933.58c.467-.348.467-.48.02-1.871-.619-1.906-.69-6.567-.14-9.062.228-1.03.864-2.77 1.417-3.866.759-1.509.918-2.088.667-2.391-1.525-1.836-3.972 2.395-4.79 8.283a19.676 19.676 0 0 0 .515 7.71c.365 1.308.554 1.573 1.121 1.573.38 0 .91-.167 1.188-.373zm-279.012-.34c.544-.228 1.277-.818 1.63-1.311 1.172-1.645 1.968-6.128 1.282-7.212-.391-.619-1.354-.174-2.835 1.305-2.435 2.436-3.425 6.114-1.924 7.166.799.559.635.559 1.847.052zm290.898-.186c1.35-1.347.351-4.79-2.056-7.095-2.463-2.36-3.158-2.046-2.906 1.305.234 3.122 1.283 5.217 2.986 5.958 1.222.535 1.277.529 1.976-.172zm-91.065-1.972c3.461-.04 4.381-.14 4.765-.519.429-.43.385-.55-.48-1.36-.524-.49-1.297-1.638-1.716-2.548-.738-1.617-.774-1.648-1.563-1.311-1.808.774-4.936 3.002-6.634 4.73-.994 1.01-1.807 1.946-1.807 2.076 0 .14.709-.036 1.573-.387 1.321-.533 2.256-.639 5.864-.679zm-121.435.759c2.05-.57 2.347-2.421.619-3.846-1.406-1.158-3.362-1.827-5.354-1.827-1.537 0-4.702.835-6.061 1.597-.68.383-.665.4.598.77.71.208 2.507 1.024 3.988 1.817 3.541 1.89 4.2 2.048 6.208 1.489zm17.524-.619c-.974-1.327-4.794-4.331-6.786-5.34l-1.702-.857-1.01 1.956c-.58 1.117-1.378 2.175-1.863 2.47l-.848.514.63.572c.56.503 1.033.56 4.117.483 2.754-.065 3.896.034 5.433.491 2.71.799 2.818.785 2.03-.289zm120.099-.473a47.29 47.29 0 0 1 3.892-1.916l1.916-.807-.87-.445c-2.815-1.449-6.335-1.776-8.846-.822-2.935 1.118-4.064 3.048-2.575 4.42 1.417 1.302 3.652 1.157 6.483-.43zm-164.689-.878c.839-.272 1.996-.928 2.581-1.465 1.763-1.617 1.33-3.154-1.098-3.873-2.01-.598-2.91-.578-4.686.096-1.188.45-4.627 2.611-5.86 3.68-.34.3 2.063 1.394 3.802 1.737 2.04.404 3.639.35 5.261-.173zm191.347.191c.858-.16 2.192-.578 2.96-.924 1.246-.559 1.337-.668.854-.978a88.322 88.322 0 0 1-2.47-1.736c-3.114-2.256-5.376-2.79-7.953-1.893-2.307.803-2.688 2.18-1.057 3.813 1.712 1.712 4.457 2.327 7.668 1.716zm-210.16-.165c0-.52-2.348-1.032-4.7-1.032-2.47 0-2.582.026-1.945.47.518.366 1.101.432 2.538.29 1.024-.1 2.268-.053 2.76.1 1.11.353 1.348.385 1.348.174zm88.397-.26c.743 0 1.122-.132 1.122-.399 0-.828.938-2.176 1.84-2.643.886-.459 1.65-.45 3.174.032.499.154.674.09.674-.251 0-.254.356-.739.789-1.084 1.092-.858 2.742-.806 4.124.13 1.273.862 1.377.888 1.377.351 0-.674 1.357-1.712 2.485-1.896 1.463-.24 2.355.034 3.35 1.018.664.655.873.734.997.38.08-.248.533-.807.998-1.238 1.589-1.49 4.297-1.282 5.792.443l.899 1.034.742-.719c1.473-1.427 3.723-1.305 5.23.29l.914.966 1.048-.719c.826-.559 1.32-.683 2.33-.57 1.344.145 2.46.89 2.46 1.636 0 .32.186.38.675.223 1.682-.538 2.475-.49 3.517.21.714.483 1.137 1.058 1.317 1.804.25.986.355 1.078 1.09.933.447-.088 1.11 0 1.473.193.822.44 1.05.176 2.722-3.142 2.643-5.243 1.597-9.34-2.75-10.788-1.996-.662-5.713-.463-8.044.43-.904.347-1.65.632-1.657.632-.004 0-.734-.69-1.616-1.537-2.448-2.331-4.352-3.104-7.655-3.104-2.35 0-2.898.106-4.283.819l-1.59.818-1.556-.818c-1.357-.719-1.896-.819-4.252-.819-2.325 0-2.938.114-4.49.839a11.583 11.583 0 0 0-3.194 2.331l-1.401 1.491-1.896-.675c-1.477-.527-2.555-.678-4.91-.682-2.835-.008-3.104.04-4.491.892-3.617 2.215-3.739 6.427-.344 12.056.703 1.161 1.072 1.517 1.41 1.357.25-.12.961-.22 1.58-.22zm139.46.054c1.68.06 2.405-.04 2.842-.387.535-.425.32-.455-2.631-.37-2.609.08-3.313.194-3.742.632-.507.518-.493.528.369.295.495-.14 1.916-.212 3.157-.168zm-220.245-1.147c-.551-.613-.55-.635.18-1.194.662-.509.678-.569.159-.579-.32 0-1.457-.223-2.535-.493l-1.952-.49-1.134 1.31c-.622.723-1.133 1.418-1.133 1.55 0 .125.842.153 1.872.06 1.03-.095 2.475-.05 3.217.105 1.944.405 1.944.405 1.326-.273zm212.372.175c1.358 0 2.467-.12 2.467-.271 0-.152-.439-.859-.972-1.571-.65-.858-1.123-1.232-1.423-1.11-.245.1-1.371.407-2.499.685-2.012.49-2.036.509-1.347.97.702.465.702.469.112 1.124l-.593.658.89-.245c.487-.136 2-.246 3.36-.244zm-190.943-.305c.698-.248 1.626-.451 2.06-.451.43 0 1.32-.33 1.98-.727l1.197-.722-.898-.2c-1.986-.443-2.854-.824-4.447-1.94l-1.669-1.17-.646 1.152c-.356.633-.978 1.301-1.388 1.487-.409.186-.678.503-.598.707.073.2.04.634-.08.964-.186.527-.028.638 1.317.932.838.183 1.61.353 1.717.373.1.02.758-.164 1.457-.41zm169.538-.046c.853-.14 1.098-.306.998-.667a90.095 90.095 0 0 0-.319-1.144c-.106-.359-.433-.738-.729-.83-.439-.14-.958-.894-1.722-2.5-.024-.053-.639.358-1.367.913-1.423 1.086-2.332 1.507-4.391 2.036l-1.308.334 1.07.724c.589.4 1.447.739 1.908.753.463.012 1.377.203 2.036.425.659.223 1.537.347 1.948.273.413-.074 1.258-.22 1.876-.32zm-147.914-.12c1.862-.85 2.974-4.355 2.415-7.619-.345-2.016-1.666-5.175-2.662-6.367l-.57-.679-1.464 3.2c-1.845 4.032-2.122 6.291-1.074 8.73.371.863 1.072 1.9 1.557 2.308 1.018.858.906.832 1.8.425zm124.3-.311c1.469-1.158 2.116-2.845 2.112-5.51-.006-2.235-.106-2.614-1.493-5.624l-1.487-3.227-.567.684c-.998 1.204-2.316 4.357-2.663 6.371-.545 3.186.54 6.727 2.33 7.601.846.41.878.405 1.768-.293zm-182.678-.116c2.594-.004 4.716-.092 4.716-.194 0-.593-6.06-2.235-9.321-2.529-2.036-.18-2.441-.126-3.693.5-1.656.826-1.77.973-1.527 1.943.18.735.2.739 2.647.511 1.357-.123 4.587-.23 7.18-.23zm249.184.128c.739-1.198-1.736-2.982-4.132-2.974-2.545.008-10.399 2.012-10.399 2.654 0 .1 1.583.146 3.52.1 1.935-.046 4.796.034 6.36.18 4.066.387 4.431.39 4.651.04zm-240.65-1.467c.533-.645.973-1.37.973-1.61 0-.652-2.016-2.295-2.819-2.295-.385 0-1.185.2-1.776.45-1.557.648-2.709.562-6.351-.48l-3.248-.934-.539.667c-.998 1.228-.726 1.497 1.493 1.497 2.803 0 5.13.673 8.295 2.391 1.485.805 2.763 1.47 2.847 1.477.08.006.587-.513 1.123-1.157zm230.59-2.236c.892-.26 2.615-.473 3.817-.473 1.201 0 2.191-.13 2.191-.285 0-.613-.714-1.81-1.078-1.81-.213 0-1.477.343-2.804.764-3.3 1.038-4.95 1.197-6.597.614-1.97-.688-2.559-.598-3.888.6l-1.197 1.081.572.792c.312.432.85 1.086 1.198 1.458l.63.664 2.763-1.465c1.521-.806 3.497-1.68 4.391-1.942zm-218.58.24c2.755-1.372 3.178-3.174 1.008-4.264-1.59-.798-3.157-1.014-4.63-.639-1.43.36-6.817 3.018-6.817 3.36 0 .32 1.703 1.157 3.593 1.766 2.495.807 4.942.727 6.846-.22zm168.258-.978c-.432-1.132-.85-1.531-1.611-1.531-.613 0-.693.16-.787 1.596l-.1 1.597 1.394-.449c1.323-.423 1.381-.487 1.106-1.211zm38.446.638c1.11-.515 2.016-1.05 2.012-1.177-.006-.394-4.49-2.685-6.283-3.214-1.944-.575-3.583-.41-5.27.535-2.02 1.132-1.616 2.834 1.008 4.232 1.258.67 1.71.746 3.968.664 2.116-.08 2.895-.255 4.565-1.038zm-179.922.086c.633-.3 1.348-.854 1.593-1.23.395-.606.393-.778-.024-1.586-.26-.5-.906-1.238-1.437-1.643-2.627-1.976-5.321-2.186-9.836-.754l-2.954.934.59.824c.919 1.297 2.665 2.707 4.32 3.499 1.317.627 1.848.709 4.06.613 1.66-.072 2.942-.3 3.688-.659zm5.593-.758c0-1.002-.124-1.497-.373-1.493-1.058.012-1.61.409-1.91 1.363-.316 1.002-.296 1.042.605 1.303 1.616.47 1.676.43 1.676-1.173zm145.858 1.187c1.503-.419 3.733-1.98 4.943-3.467l1.004-1.23-2.965-.937c-4.622-1.467-7.598-1.17-10.145 1.012-2.056 1.756-1.87 3.043.593 4.191 1.736.806 4.555.988 6.57.43zm-207.306-.886c2.944-1.796 2.814-6.068-.168-5.58-.59.093-1.337.438-1.656.758-.547.547-.563.718-.214 2.48.673 3.394.549 3.254 2.036 2.344zm41.051-.17c1.421-1.804.858-5.98-1.177-8.742-.825-1.124-3.485-3.3-3.693-3.02-.32.445-.669 6.413-.445 7.617.33 1.768 1.457 3.537 2.746 4.325 1.282.778 1.847.739 2.571-.18zm177.014.086c.559-.375 1.397-1.353 1.856-2.171.838-1.473.838-1.523.687-5.493-.088-2.202-.228-4.072-.314-4.16-.26-.26-2.427 1.39-3.377 2.57-2.048 2.55-2.884 5.522-2.171 7.733.732 2.282 1.596 2.675 3.319 1.521zm39.888.16c.073-.29.307-1.377.513-2.415.349-1.763.335-1.936-.21-2.481-.918-.919-2.595-1.072-3.363-.306-1.352 1.354-.59 3.833 1.587 5.158 1.137.698 1.297.702 1.47.044zm-277.27-1.387c2.754-.21 5.093-.46 5.193-.56.354-.353-.642-2.462-1.672-3.532-.759-.793-1.767-1.347-3.669-2.03-5.96-2.136-12.868-2.92-23.127-2.62-7.046.203-11.01-.04-14.212-.873-.898-.236-1.702-.353-1.792-.26-.208.21 2.275 2.424 4.674 4.172 7.026 5.11 18.164 6.946 34.603 5.703zm310.555.107c7.44-.608 12.534-1.936 16.878-4.4 2.295-1.298 6.836-5.06 6.506-5.39-.073-.076-1.191.1-2.479.391-1.98.445-4.111.535-13.72.591-12.822.076-15.429.36-21.65 2.375-3.789 1.222-4.595 1.763-5.609 3.765-.948 1.87-.932 2.016.235 2.211 3.577.6 14.926.863 19.835.46zm-256.289-.519a12.535 12.535 0 0 1-.37-1.063c-.093-.324-.332-.475-.59-.374-.24.09-.624.166-.858.166-.273 0-.425.32-.425.898 0 .852.064.898 1.23.898 1.053 0 1.197-.076 1.013-.523zm188.772-.373c0-.579-.151-.898-.425-.898a2.88 2.88 0 0 1-.858-.168c-.3-.115-.549.14-.778.793a10.878 10.878 0 0 0-.334 1.066c0 .06.54.103 1.198.103 1.132 0 1.197-.05 1.197-.898zm26.048-.439c.906-.247 1.936-.453 2.287-.455 1.258-.006 1.402-1.962.18-2.435-1.902-.735-5.633.323-7.994 2.275-.998.819-.918 1.034.5 1.332 1.037.215 2.298.036 5.029-.719zm-237.123.427c.38-.253.306-.419-.449-1.05-1.846-1.537-4.042-2.38-6.197-2.38-2.316 0-2.78.298-2.491 1.616.173.792.34.93 1.151.948.52.01 1.691.27 2.595.579 1.8.61 4.68.764 5.39.287zm8.02-1.948c1.334-.559 3.058-2.156 3.058-2.834 0-1.29-3.008-2.625-5.05-2.242-1.628.308-6.626 3.134-6.626 3.749 0 .227 2.385 1.317 3.443 1.577 1.331.323 4.123.185 5.175-.25zm40.27-.305c1.706-1.703 2.175-5.461 1.117-8.856-.609-1.933-2.236-5.05-2.63-5.042-.12.004-.436.642-.7 1.42a73.766 73.766 0 0 1-1.568 3.965c-1.308 3.06-1.391 4.599-.38 6.77 1.172 2.52 2.735 3.17 4.158 1.743zm137.403.18c.413-.324 1.053-1.29 1.42-2.152.947-2.196.735-3.849-.987-7.78-.769-1.753-1.397-3.406-1.397-3.673 0-.859-.53-.51-1.418.942-1.586 2.583-2.026 4.157-2.026 7.261 0 2.096.132 3.08.5 3.743 1.237 2.235 2.498 2.768 3.912 1.656zm43.262.14c.839-.252 1.813-.691 2.172-.983.647-.523.647-.525-1.243-1.756-2.523-1.651-3.453-2.09-4.93-2.336-1.537-.26-3.454.28-4.328 1.218-.565.599-.605.798-.303 1.525.38.918 1.888 2.076 3.221 2.475 1.366.407 3.765.343 5.41-.146zm-207.921-1.386c.707-.946.818-3.683.23-5.501-.6-1.836-2.24-4.122-3.743-5.2-1.59-1.143-1.52-1.237-1.924 2.655-.44 4.232.104 6.188 2.235 8.056 1.302 1.146 2.346 1.142 3.202-.012zm192.097.176a7.102 7.102 0 0 0 2.405-4.18c.28-1.503-.2-7.633-.598-7.633-.483 0-3.627 3.146-4.306 4.306-1.463 2.503-1.644 5.94-.399 7.524.75.953 1.753.949 2.898-.02zm-197.861-.57c0-.07-.286-.618-.635-1.207-.59-1.002-.679-1.05-1.274-.659-.349.234-.678.699-.73 1.042-.08.52.094.639 1.05.739.627.066 1.241.14 1.363.17.126.027.226-.01.226-.084zm202.751-.165c.773 0 .62-1.126-.231-1.689-.57-.379-.683-.313-1.43.829l-.81 1.237.945-.19a9.72 9.72 0 0 1 1.524-.189zm-225.436-.868 1.577-.206-1.497-.69c-.824-.38-2.758-.919-4.3-1.194-2.444-.44-2.738-.559-2.307-.918.272-.224 1.198-.639 2.056-.924 1.541-.515 1.55-.523.659-.739-.491-.126-1.65-.623-2.575-1.106-.924-.483-2.271-1.051-2.994-1.265l-1.311-.385 1.784-.52c2.056-.598 3.78-1.422 4.312-2.061.307-.373.183-.503-.769-.812a8.694 8.694 0 0 1-1.932-.927c-.44-.307-.978-.554-1.198-.548-.22.004-1.682.822-3.247 1.816-4.99 3.174-10.152 5.429-15.569 6.792l-1.048.266 1.77.379c.973.21 2.372.639 3.115.958.734.315 1.363.539 1.397.491.026-.046.223-.509.433-1.034.41-1.038 1.836-1.892 3.154-1.892.568 0 1.197.419 2.171 1.441l1.365 1.441.695-.693c1.347-1.349 3.649-.678 4.954 1.442.778 1.265.968 1.329 2.056.708 1.142-.655 2.714-.547 3.898.268.729.499 1.15.624 1.407.415.2-.166 1.078-.391 1.946-.505zm199.265-.184c.048-.04-.066-.405-.253-.814-.427-.942-2.376-1.657-2.376-.878-.006.275-.09 1.002-.191 1.616l-.186 1.118 1.465-.487c.803-.267 1.497-.519 1.545-.553zm-155.922-.387c1.501-.739 1.657-.904 1.737-1.896.073-.886-.06-1.208-.719-1.727-1.902-1.497-5.796-1.892-9.014-.922l-1.257.38.986 1.151c.539.633 1.241 1.657 1.557 2.275.315.62.698 1.308.854 1.531.455.635 3.886.172 5.856-.794zm6.128-.136c-.112-.698-.26-1.325-.32-1.391-.06-.066-.539.006-1.067.156-.68.193-1.022.515-1.178 1.093-.192.719-.124.839.579.998.439.092.934.22 1.098.272.958.32 1.097.14.89-1.126zm159.782-.499c.46-.892 1.25-2.05 1.753-2.569l.918-.948-1.284-.385c-3.241-.978-7.125-.587-9.034.914-.658.52-.792.839-.718 1.723.08.926.273 1.185 1.343 1.772 1.45.799 3.328 1.238 5.01 1.164 1.106-.048 1.228-.15 2.016-1.673zm40.225 1.174c1.048-.695 2.675-.759 3.743-.148 1.083.619 1.271.555 2.051-.713 1.326-2.151 3.607-2.79 4.996-1.403l.733.733.798-1.05c.883-1.152 2.116-1.912 3.114-1.912 1.014 0 2.323.928 2.719 1.93.2.503.389.95.419.998.03.044.658-.18 1.397-.493.738-.32 2.14-.747 3.114-.958l1.768-.38-1.048-.275c-5.916-1.557-9.748-3.213-15.369-6.63-1.786-1.088-3.393-1.977-3.573-1.977-.18 0-.533.19-.794.42-.26.231-1.018.602-1.689.824-.666.22-1.265.539-1.329.705-.19.499 1.756 1.606 4.012 2.29l2.126.64-1.346.375c-.738.203-2.085.778-2.994 1.271-.908.493-2.115.998-2.694 1.126l-1.046.228 1.429.373c.788.205 1.796.613 2.245.908l.819.533-2.846.513c-1.563.28-3.442.784-4.172 1.118l-1.325.602 1.177.214c.647.116 1.377.325 1.625.463.669.373.958.325 1.946-.33zm-242.392-1.218c3.46-.744 5.07-3.181 2.95-4.475-1.407-.858-4.195-.814-5.938.096-1.982 1.038-4.148 2.425-4.158 2.67-.016.35 1.817 1.206 3.434 1.607 1.932.475 1.95.48 3.712.1zm235.492-.14c1.261-.203 3.463-1.203 3.447-1.566-.01-.248-2.17-1.637-4.158-2.675-.958-.5-1.822-.689-3.143-.689-3.884.004-5.09 2.356-2.142 4.178 1.088.67 3.206 1.194 4.212 1.038.33-.05 1.133-.18 1.784-.284zm-221.89-1.409c.945-1.27.849-4.145-.207-6.307-.712-1.457-3.425-4.4-4.052-4.4-.116 0-.379 1.314-.587 2.919-.515 3.972-.16 5.619 1.605 7.465 1.481 1.54 2.276 1.62 3.242.323zm207.373.186c.986-.83 1.876-2.367 2.236-3.846.235-.984-.392-7.046-.729-7.046-.489 0-3.054 2.545-3.728 3.696-1.507 2.575-1.637 5.936-.28 7.294.884.884 1.358.864 2.501-.1zm-212.554-.898c0-.096-.247-.535-.55-.972-.304-.437-.64-1.044-.753-1.354-.144-.399-.308-.47-.573-.26a2.395 2.395 0 0 1-.842.412c-.376.088-.42.303-.22 1.064.216.824.403.972 1.371 1.074.615.066 1.218.14 1.342.17.123.027.225-.03.225-.13zm217.91-1.124c.195-.749.151-.962-.226-1.048-.26-.06-.629-.24-.826-.4-.26-.207-.563.12-1.092 1.159l-.733 1.443 1.314-.106c1.19-.094 1.337-.194 1.564-1.048zm-184.653.032c1.074-1.122 1.573-2.635 1.557-4.719a10.06 10.06 0 0 0-2.595-6.738l-1.323-1.497-.212.902c-.115.493-.598 2.144-1.078 3.669-.475 1.527-.866 3.227-.866 3.78 0 2.355 1.765 5.276 3.188 5.276.375 0 .972-.304 1.327-.673zm151.35-.385c1.023-1.086 1.61-2.603 1.616-4.182.004-.495-.499-2.543-1.11-4.55-1.085-3.562-1.131-3.643-1.696-3.146-1.657 1.465-3.481 5.509-3.481 7.71 0 2.226 1.772 5.224 3.09 5.224.319 0 1.032-.475 1.576-1.058zm-225.626-1.012c6.594-2.19 14.465-6.615 31.309-17.597 11.03-7.19 16.686-10.28 20.678-11.301 6.535-1.669 12.64 1.281 15.62 7.55l1.098 2.308.094-1.557c.124-2.116-.34-3.632-1.629-5.365-1.896-2.547-3.562-3.619-12.383-7.96-16.003-7.876-15.948-7.852-20.325-7.66-3.732.165-4.559.512-14.684 6.199-23.752 13.337-34.674 17.696-43.433 17.33-3.363-.14-5.095-.68-7.113-2.222-.555-.424-1.088-.691-1.184-.6-.32.324.87 2.919 2.323 5.083 4.551 6.77 14.363 15.139 19.43 16.574 2.362.67 6.877.324 10.199-.778zm309.321-.132c5.617-2.774 14.42-10.924 17.874-16.537.924-1.505 1.956-4.004 1.736-4.22-.06-.06-.812.36-1.67.939-2.18 1.469-4.08 1.96-7.565 1.96-8.05 0-18.892-4.252-37.814-14.826-11.916-6.66-13.624-7.555-15.692-8.218-2.495-.804-5.864-.87-8.307-.16-1.996.58-21.829 10.088-23.978 11.498-4.044 2.65-5.928 5.674-5.709 9.165l.096 1.491 1.25-2.555c1.522-3.11 3.666-5.27 6.606-6.666 1.89-.89 2.24-.954 5.17-.938 2.483.008 3.553.153 5.09.694 4.163 1.467 10.13 4.85 20.215 11.469 12.375 8.124 16.79 10.806 22.265 13.547 6.906 3.453 11.138 4.714 15.335 4.563 2.599-.094 3.09-.21 5.102-1.204zm-282.032-.32c1.257-.524 2.65-1.79 2.65-2.405 0-.732-1.067-1.61-2.227-1.826-1.69-.32-2.946.076-5.44 1.703-2.089 1.363-2.269 1.557-1.748 1.846 2.006 1.13 4.97 1.431 6.76.685zm248.53-.339c.618-.3 1.117-.618 1.111-.714-.026-.34-4.211-2.775-5.283-3.07-1.982-.545-4.585.315-4.585 1.517 0 .686 1.347 2.076 2.545 2.629 1.21.558 4.744.349 6.211-.364zm-212.557-.325c1.663-.852 1.825-1.66.62-3.094-1.562-1.856-3.973-2.59-6.847-2.082-.988.18-2.367.396-3.07.49-.705.093-1.27.329-1.27.53 0 .699 2.561 2.934 4.342 3.787 2.116 1.018 4.674 1.17 6.227.373zm5.19-.18a7.944 7.944 0 0 1-.186-1.65c-.004-.91-.07-.972-1.052-.972-1.097 0-1.067-.046-1.171 1.982-.016.293.387.632 1.022.858 1.497.545 1.586.529 1.387-.22zm162.04.028c.47-.18.644-.419.523-.734-.1-.26-.18-.779-.18-1.158 0-.569-.188-.714-1.048-.818-1.024-.116-1.048-.096-1.052.942 0 .585-.088 1.381-.193 1.772-.2.755-.074.755 1.952-.004zm9.832-.385c1.87-1.018 4.585-3.676 3.962-3.878-1.507-.489-6.128-1.078-7.086-.904-3.024.545-5.577 3.034-4.63 4.517.982 1.55 5.13 1.69 7.752.263zm-201.227-.934c.998-2.39.18-5.46-2.084-7.794-.862-.892-1.71-1.621-1.882-1.621-.172 0-.483 1.387-.693 3.098-.339 2.754-.327 3.267.112 4.59.475 1.438 1.63 2.855 2.575 3.162.719.236 1.517-.34 1.972-1.437zm221.893.689c.779-.859 1.45-2.196 1.72-3.45.244-1.137-.39-6.29-.808-6.55-.399-.246-2.522 1.888-3.473 3.489-.678 1.144-.798 1.692-.798 3.636 0 1.83.114 2.416.569 2.919.746.826 2.012.806 2.788-.044zm-226.56.211c0-.092-.291-.67-.646-1.291l-.647-1.118-.998.45c-.952.43-1.345 1.38-.802 1.925.24.24 3.093.272 3.093.036zm231.375-.772c.063-.543-.07-.827-.45-.934a11.39 11.39 0 0 1-1.021-.36c-.348-.14-.66.1-1.104.85l-.619 1.05 1.104.116c1.756.192 1.996.11 2.092-.718zm-71.576-8.194c1.397-2.668 2.175-3.752 4.12-5.698 1.317-1.322 2.86-2.73 3.426-3.128l1.028-.724-.906 1.33c-1.906 2.805-4.846 8.069-4.503 8.069.2 0 1.226-.41 2.282-.91 3.784-1.789 8.297-7.226 10.13-12.202.782-2.12 1.323-7.245.768-7.245-.16 0-.619.35-1.018.778-.395.431-2.795 2.271-5.33 4.092-6.95 4.99-9.874 8.211-12.83 14.143-1.006 2.01-3.672 9.032-3.672 9.66 0 .109 1.078-.943 2.389-2.334 1.836-1.947 2.794-3.306 4.116-5.829zm-86.39 3.867c-2.166-6.064-4.677-10.334-8.124-13.793-2.142-2.16-2.878-2.754-8.4-6.79a166.7 166.7 0 0 1-4.117-3.084l-.972-.786.004 1.61c0 2.03.914 5.857 1.952 8.2 1.822 4.108 5.29 7.714 9.252 9.62 1.143.55 2.135.943 2.2.879.155-.16-2-3.88-3.87-6.683-.798-1.193-1.34-2.171-1.21-2.171.526 0 4.337 3.417 5.6 5.024.739.938 1.976 2.926 2.74 4.407.955 1.848 2.106 3.463 3.663 5.14 1.25 1.345 2.312 2.275 2.355 2.07.052-.206-.433-1.847-1.077-3.643zm-59.844.475c.196 0 .81.279 1.363.618.553.34 1.072.545 1.15.467.375-.375-.37-1.453-1.357-1.96a7.944 7.944 0 0 1-1.827-1.341c-.788-.848-1.217-.99-1.217-.405 0 .205-.2.748-.435 1.203-.411.789-.38.905.672 2.324l1.108 1.497.092-1.202c.054-.678.25-1.201.449-1.197v-.004zm202.724.762c.938-1.317.978-1.473.595-2.215-.228-.436-.42-.963-.42-1.168 0-.551-.433-.46-1.057.235-.304.334-1.03.895-1.617 1.244-1.21.718-1.816 1.371-1.816 1.956 0 .293.299.24 1.185-.21 1.643-.838 1.809-.778 1.809.64 0 1.416-.036 1.428 1.32-.48zm-219.075.798c.527-.335.99-1.748.99-3.03 0-1.476-1.577-4.62-2.735-5.445-.49-.349-.928-.588-.972-.528-.044.06-.325 1.125-.624 2.367-.69 2.846-.48 4.123.938 5.694 1.042 1.15 1.68 1.398 2.403.944zm236.115-.944c1.409-1.563 1.636-2.886.958-5.558-.294-1.154-.6-2.21-.679-2.348-.263-.45-2.231 1.709-2.954 3.244-.822 1.728-.922 3.672-.26 4.954.651 1.261 1.613 1.163 2.935-.296zm-199.958-.545c1.278-1.377 1.753-3.053 1.597-5.692-.14-2.415-1.082-4.77-2.371-5.942-.515-.463-.563-.451-.819.22-.151.39-.724 1.656-1.271 2.808-.864 1.816-.998 2.41-1.006 4.49-.01 2.069.09 2.536.722 3.444 1.258 1.796 1.97 1.946 3.154.672zm164.18-.211c1.64-1.868 1.6-5.01-.112-8.739a70.398 70.398 0 0 1-1.098-2.499l-.29-.748-.878 1.038c-2.704 3.22-2.834 8.934-.251 11.337.966.902 1.57.814 2.625-.387zm-206.311.06c.788-.62.056-2.885-1.138-3.521-.51-.274-.954-.116-2.694.958-1.144.704-2.08 1.383-2.08 1.507 0 .33 1.61 1.106 2.908 1.401 1.208.28 2.391.14 3.004-.34zm250.296-.234c.699-.303 1.274-.663 1.274-.798 0-.44-4.186-2.847-4.645-2.67-.599.229-1.64 1.987-1.64 2.774 0 1.616 2.189 1.916 5.015.694zm-38.926-1.177c1.138-.012.268-1.29-1.251-1.837l-1.297-.467-.168 1.072a16.387 16.387 0 0 1-.37 1.748l-.199.675 1.306-.59c.718-.328 1.606-.6 1.976-.6zm-174.177.125a5.12 5.12 0 0 1-.291-1.497c0-.838-.006-.842-1.51-.39-.638.189-1.25.612-1.412.971-.26.579-.144.679 1.393 1.124.924.267 1.776.507 1.896.525.12.02.086-.312-.076-.733zm-6.267-.505c1.094-.553 1.351-.838 1.425-1.596.074-.759-.128-1.124-1.088-1.992-1.782-1.611-3-1.701-6.806-.51-1.717.54-3.124 1.078-3.124 1.204 0 .12.599.753 1.337 1.397 2.407 2.12 5.799 2.735 8.254 1.497zm190.26-.307c1.378-.703 3.414-2.475 3.114-2.71-.299-.24-4.71-1.673-5.72-1.857-2.61-.479-6.224 2.084-5.32 3.773.983 1.836 5.076 2.247 7.925.792zm-204.999-.745c2.148 1.537 2.086 1.523 2.587.55.938-1.817.471-3.374-1.177-3.913-1.018-.34-6.14-.323-6.144.014 0 .09.383.535.852.984.471.45 1.178 1.513 1.571 2.361l.719 1.543.095-1.277.09-1.27 1.407 1.004zm214.429-.672c.163 0 .305.439.311.972l.012.974.473-.898c.26-.493.986-1.523 1.617-2.284l1.152-1.383-1.11-.184c-3.373-.558-6.174.064-6.523 1.45-.228.914.036 2.475.515 3.05.273.33.605.211 1.796-.643.803-.58 1.593-1.05 1.757-1.05zm14.794-1.573c-.942-.739-1.114-.575-.854.812l.203 1.094.703-.659.698-.658-.75-.591zm-244.322.898c.1-.37.183-.912.185-1.205.004-.48-.08-.47-.89.13-.842.618-.866.694-.403 1.205.647.715.89.687 1.108-.128zm35.03-1.132c1.941-2.305 1.756-6.055-.46-9.405-.938-1.417-.972-1.437-1.251-.734-.16.395-.759 1.7-1.33 2.898-.898 1.88-1.018 2.385-.868 3.653.27 2.275 1.563 4.495 2.62 4.495.29 0 .87-.41 1.29-.909zm175.356.6c.823-.44 1.777-2.472 1.986-4.212.154-1.302.04-1.763-.892-3.649-.587-1.188-1.158-2.43-1.261-2.758-.18-.56-.25-.535-1.038.339-1.33 1.485-2.196 4.124-2.016 6.152.16 1.822 1.185 4.027 1.976 4.239.26.074.519.146.573.164.05.02.353-.1.672-.274zm-203.62-.963c-.01-.664-.34-1.353-1.038-2.171-.918-1.068-1.074-1.148-1.477-.745-.407.405-.305.639.938 2.172.765.942 1.437 1.716 1.49 1.716.051 0 .095-.439.09-.972zm230.676.427c.1-.295.65-1.062 1.231-1.696.966-1.054 1.018-1.198.585-1.629-.429-.425-.563-.363-1.497.729-.698.818-1.028 1.505-1.038 2.17-.01 1.049.44 1.317.719.428zm-215.798-1.902c.958-.353 1.856-.738 1.984-.848.132-.116-.519-.789-1.437-1.497-2.116-1.637-4.012-3.737-4.93-5.47l-.719-1.342-1.437.884c-.792.487-1.517 1.01-1.606 1.157-.096.15.423.915 1.147 1.697.725.786 2.084 2.471 3.022 3.748.934 1.278 1.817 2.322 1.96 2.322.144 0 1.05-.292 2.01-.65zm203.47-.748a80.179 80.179 0 0 1 3.005-3.889l2.035-2.495-1.42-.898c-.783-.499-1.526-.902-1.653-.902-.128 0-.46.44-.727.974-.782 1.541-2.45 3.453-4.475 5.118-1.026.85-1.864 1.676-1.862 1.84.004.335 2.774 1.581 3.603 1.623.313.016.932-.555 1.497-1.373zm-208.76-.284c0-.355-2.061-2.97-3.245-4.12l-1.197-1.161-2.224 1.46a237.027 237.027 0 0 1-2.794 1.817c-.547.35-.539.385.18.978.41.334 1.151.733 1.646.884 1.006.306 7.635.428 7.635.14zm218.313-.126c.603-.167 1.414-.574 1.797-.906.674-.579.678-.613.126-.964a310.79 310.79 0 0 1-2.795-1.822l-2.223-1.461-1.198 1.161c-1.186 1.148-3.245 3.765-3.245 4.12 0 .306 6.359.2 7.536-.126zm-206.09-1.724c.123-1.304-.849-3.262-2.59-5.196-2.74-3.048-4.419-3.792-6.333-2.802-1.796.932-1.565 2.4.79 4.944 2.316 2.501 5.464 4.275 7.286 4.112.61-.06.766-.254.844-1.058zm190.276.2c2.815-1.422 6.182-4.977 6.182-6.527 0-1.81-2.699-2.715-4.597-1.543-1.471.908-4.112 3.844-4.91 5.465-.667 1.353-.878 2.934-.45 3.369.346.345 2.382-.07 3.773-.767zm-180.632-2.731c.18-.699.539-1.431.798-1.63.411-.32.38-.508-.3-1.665-.927-1.581-3.189-3.717-4.49-4.244-1.272-.513-2.906-.806-2.906-.527 0 .126 1.137 1.473 2.523 2.994 2.291 2.515 2.96 3.613 3.636 5.974.19.659.396.405.739-.898zm167.954.431c.008-.806 1.349-3.441 2.088-4.098.37-.331 1.497-1.525 2.5-2.658l1.827-2.056-1.038.22c-2.775.578-5.36 2.434-6.78 4.858-.683 1.165-.719 1.353-.304 1.672.256.2.615.938.799 1.64.319 1.224.902 1.494.908.42zm-174.992-2.164c.41-.806.739-1.908.739-2.447 0-1.19-.875-2.706-1.976-3.427-1.068-.698-3.773-.704-5.35 0l-1.191.525 1.044.79c1.51 1.146 3.485 3.284 4.55 4.923.505.782 1.038 1.353 1.184 1.265.14-.088.593-.818 1.002-1.629zm183.39.236c.532-.862 1.897-2.46 3.035-3.545 1.616-1.545 1.98-2.044 1.676-2.295-.662-.551-3.163-1.05-4.241-.847-1.93.36-3.48 2.176-3.48 4.072 0 .946 1.408 4.188 1.821 4.188.124 0 .659-.709 1.19-1.573zm-256.974-.28c3.062-.678 3.457-1.125 1.73-1.948-.977-.463-1.23-.459-4.011.052-2.316.423-3.242.475-4.2.234-.768-.2-1.23-.21-1.23-.028 0 1.261 2.456 2.764 4.043 2.47a154.42 154.42 0 0 0 3.666-.778zm-9.231.531c-.068-.065-.882-.638-1.813-1.269-1.65-1.126-6.213-5.194-5.824-5.194.5 0 3.242 1.591 5.36 3.114 1.285.918 2.39 1.677 2.454 1.677.443 0-.672-1.876-1.385-2.33-.489-.307-1.862-1.696-3.054-3.081-3.022-3.517-4.45-4.266-8.439-4.415-1.816-.066-3.345.026-3.888.24l-.898.338 1.722.927c.947.507 3.102 2.05 4.787 3.423 4.625 3.772 6.599 5.15 8.515 5.948 1.545.638 2.806.958 2.46.618zm343.74-.329c.826-.425 1.49-1.263 1.49-1.88 0-.164-.558-.148-1.376.04-1.094.251-1.923.206-3.988-.212-1.432-.29-2.955-.439-3.388-.329-.758.188-1.95 1.218-1.696 1.461.271.268 5.599 1.325 6.796 1.347.709.014 1.683-.18 2.162-.427zm6.207-.754c2.124-.974 2.928-1.543 7.112-5.034 1.645-1.373 3.932-3.02 5.078-3.653 2.575-1.423 2.285-1.63-2.236-1.63-4.112 0-5.732.69-8.103 3.46-1.77 2.066-3.038 3.364-4.272 4.372-.439.359-.798.942-.798 1.293 0 .57.183.499 1.742-.703 1.922-1.477 4.577-3.105 5.74-3.522 1.086-.388-3.646 3.986-5.762 5.323-.948.599-1.722 1.146-1.722 1.217 0 .212 1.257-.223 3.217-1.121zm-332.662-2.386 1.98-.898-.146-2.022c-.147-2.046-1.411-5.175-2.435-6.024-.567-.473-.699-.24-1.956 3.438-.968 2.838-1.138 4.327-.639 5.634.372.982.779.966 3.194-.13zm315.379-.18c.503-1.52-.044-4.159-1.673-8.043l-.499-1.194-.598.739c-1.603 1.986-2.934 6.327-2.306 7.52.24.454 3.573 2.009 4.371 2.043.192.008.51-.471.705-1.064zm-325.62-.245c.558-.231 1.17-.708 1.357-1.062.738-1.373-1.613-3.616-4.252-4.063-1.163-.2-7.12.726-7.12 1.103 0 .41 1.486 1.96 2.661 2.775 2.348 1.629 5.264 2.122 7.354 1.245zm5.554.012a9.56 9.56 0 0 0-.187-1.345c-.164-.828-.306-.938-1.198-.938-.672 0-1.01.14-1.01.425 0 .232-.076.619-.167.858-.112.296.2.587.974.909 1.429.592 1.588.598 1.588.09zm322.882-.045c.928-.392 1.09-.59 1.01-1.258-.075-.639-.273-.814-1.03-.898-.984-.11-1.297.353-1.305 1.94-.004.802-.06.792 1.325.216zm10.14-.384c1.351-.598 4.1-3.04 4.1-3.64 0-.17-.3-.308-.673-.308-.373 0-1.685-.211-2.92-.47-2.814-.59-4.361-.374-6.18.861-1.596 1.09-2.01 1.897-1.497 2.935.759 1.517 4.423 1.84 7.17.622zm-320.762-2.425c1.225-.623 2.283-1.29 2.347-1.481.204-.605-2.41-1.505-5.018-1.72-2.22-.188-2.483-.156-2.321.267.185.479.593 2.028.946 3.589.16.718.293.802 1.002.652.449-.095 1.82-.684 3.046-1.305zm301.066.649c.091-.453.349-1.541.568-2.415l.406-1.59-2.435.2c-2.463.206-4.98 1.026-4.98 1.627 0 .34 5.213 3 5.888 3 .211 0 .463-.371.555-.822zm-314.176-1.597c1.727-.926 2.395-5.47 1.198-8.17-.787-1.782-1.817-3.243-2.196-3.113-.499.16-2.375 4.762-2.555 6.235-.2 1.697.32 3.44 1.352 4.545.838.898 1.277.998 2.203.499zm325.513-.587c1.76-2.092 1.696-4.639-.214-8.852l-1.018-2.256-.618.785c-2.28 2.894-2.887 6.906-1.458 9.644.933 1.79 2.162 2.04 3.31.68zm-307.797-.81c.074-.126-.014-.934-.193-1.8l-.326-1.573-1.061.2c-.946.175-1.777.798-1.803 1.346-.006.106.46.473 1.038.813.579.34 1.05.758 1.05.928 0 .353 1.092.425 1.297.086zm289.134-.246c.216-.26.779-.67 1.258-.918.744-.385.81-.513.47-.922-.374-.453-2.334-1.423-2.474-1.224-.2.288-.69 3.114-.573 3.306.234.379.906.26 1.317-.24zm-316.489-1.389c.34-.214.695-.639.793-.948.439-1.377-2.525-3.483-4.904-3.483-1.697 0-5.53.61-5.892.938-.374.34 1.407 2.186 3.022 3.14 2.127 1.257 5.275 1.417 6.981.351zm4.797.136c-.008-1.166-.292-1.423-1.567-1.423-1.008 0-1.124.08-1.124.772 0 .635.2.826 1.124 1.084.615.174 1.224.331 1.347.351.124.02.22-.331.22-.782zm27.808-1.503c.974-.729.998-.799.804-2.282-.379-2.878-1.56-3.646-2.994-1.944-1.573 1.869-2.449 4.523-1.936 5.869l.28.738 1.417-.818c.782-.45 1.876-1.152 2.429-1.563zm281.413.734c.146-2.211-1.872-5.894-3.225-5.894-.838 0-1.577 1.417-1.617 3.114l-.04 1.52 2.096 1.408c1.154.775 2.231 1.371 2.395 1.327.168-.044.34-.706.393-1.477zm25.733.958c.379-.14.674-.503.674-.824 0-.439-.263-.605-1.122-.708-1.253-.152-1.562.115-1.568 1.363-.004.898.067.898 2.016.17zm9.201-.425c1.523-.718 3.984-2.998 3.627-3.353-.304-.303-4.178-.958-5.729-.968-2.68-.02-5.577 2.016-5.082 3.573.51 1.609 4.485 2.024 7.18.748zm-326.473-.898c1.098-.565 1.126-1.303.1-2.523-1.243-1.477-2.375-1.922-4.754-1.872-1.154.028-2.46.152-2.905.28-.798.23-.802.247-.339 1.193 1.228 2.539 5.553 4.14 7.898 2.924zm302.284-.16c1.018-.379 2.684-1.928 3.253-3.013.403-.769.391-.787-.698-.968-1.797-.296-4.843-.216-5.55.145-1.177.605-2.6 2.162-2.6 2.855 0 .369.235.808.523.978.695.403 4.008.407 5.07.006zm-320.12-2.608c1.481-2.236 1.288-5.441-.49-8.224-.5-.782-1.007-1.423-1.129-1.423-.12 0-.712 1.138-1.317 2.527-1.237 2.846-1.431 4.93-.61 6.547.748 1.469 1.013 1.704 1.94 1.704.658 0 1.03-.26 1.606-1.131zm22.004.642c.944-.559 2.407-2.658 2.407-3.459 0-.351-.607-.838-1.788-1.437-.982-.495-1.933-.902-2.112-.902-.922 0-1.551 3.844-.844 5.184.634 1.207 1.117 1.333 2.335.614zm290.906.26c.607-.405 1.018-1.517 1.018-2.755 0-1.373-.694-3.301-1.19-3.301-.738 0-3.9 1.836-3.9 2.265 0 .79.825 2.096 1.942 3.08 1.09.958 1.541 1.108 2.13.715zm22.868-.068c.858-.455 1.605-2.75 1.437-4.411-.146-1.447-1.962-6.068-2.385-6.068-.443 0-2.032 3.154-2.387 4.745-.28 1.249-.28 1.9.006 2.964.685 2.574 1.864 3.556 3.327 2.774zm-303.275-1.178 1.826-1.181-1.15-.346c-1.722-.515-2.91-.291-3.034.565-.1.725.16 2.14.396 2.14.075 0 .958-.53 1.96-1.178zm270.515.132c.11-.575.12-1.25.024-1.497-.205-.539-1.772-.599-3.142-.124l-.944.33 1.72 1.143c.949.631 1.817 1.158 1.937 1.17.114.01.3-.451.403-1.026zm-308.487-2.762c-.108-1.122-.14-1.152-1.134-1.038-.886.105-1.022.231-1.022.942 0 .668.18.878.975 1.118.532.16 1.043.259 1.131.213.088-.04.11-.595.05-1.233zm-5.02.69c1.793-.748 1.689-2.255-.235-3.443-1.51-.93-3.31-1.064-6.355-.47-3.663.714-3.713.758-2.228 1.935 2.67 2.116 6.457 2.964 8.818 1.976zm350.698-.04c.366-.26.665-.732.665-1.052 0-.459-.21-.579-1.046-.579-.998 0-1.05.052-1.05 1.05 0 1.162.38 1.318 1.431.58zm9.974-.495c1.864-.854 3.717-2.315 3.36-2.644-.486-.45-6.098-1.262-7.35-1.062-1.443.23-3.094 1.165-3.543 2.008-1.265 2.363 3.665 3.477 7.533 1.696zm-342.594-1.118c.068-.914-.126-1.726-.667-2.822-.79-1.597-3.01-4.383-3.493-4.383-.395 0-.34 2.216.08 3.206.619 1.453 3.373 5.476 3.687 5.375.163-.054.339-.675.393-1.378zm4.77 1.038c.044-.032-.463-.628-1.123-1.323a17.058 17.058 0 0 1-2.056-2.762c-.653-1.138-.907-1.378-1.052-1.002-.104.273.014 1.097.26 1.826.249.73.452 1.872.452 2.535v1.21l1.723-.206c.946-.116 1.756-.236 1.796-.272zm312.048-.71c0-.63.2-1.809.44-2.615.584-1.936.133-2.295-.827-.655-.42.719-1.383 1.877-2.136 2.575-1.407 1.298-1.387 1.417.28 1.637 2.25.295 2.243.3 2.243-.942zm3.126-.753c.746-1.046 1.625-2.495 1.952-3.217.623-1.37.822-3.563.327-3.563-.439 0-2.469 2.54-3.383 4.24-.79 1.468-1.03 2.957-.639 3.971.096.256.226.471.28.471.054 0 .718-.858 1.463-1.902zm-289.497.914c.658-.373 1.197-.874 1.197-1.117 0-.659-2.894-2.475-6.439-4.052-2.076-.918-4.974-1.842-8.533-2.72-2.964-.731-6.095-1.617-6.956-1.967-.864-.351-1.646-.563-1.742-.465-.371.37 1.223 2.85 2.828 4.4 2.188 2.115 4.705 3.732 7.014 4.496 1.812.605 6.048 1.517 7.038 1.517.65 0-2.16-2.004-5.262-3.752-2.534-1.43-3.433-2.176-2.135-1.783 3.618 1.102 9.34 4.018 10.884 5.55.726.718.648.718 2.106-.105zm260.805-.99c1.133-.758 2.934-1.82 4.007-2.355 2.116-1.058 5.943-2.405 6.172-2.175.08.08-1.178.89-2.786 1.804-3.547 2.016-6.104 3.804-5.435 3.804.273 0 1.606-.213 2.97-.47 4.84-.919 8.367-2.72 11.3-5.773 1.572-1.637 2.963-3.828 2.636-4.152-.086-.09-.87.12-1.74.467-.871.348-3.805 1.17-6.524 1.83-2.718.661-6.016 1.617-7.333 2.122-3.918 1.507-8.233 4.024-8.233 4.8 0 .332 1.876 1.466 2.43 1.472.266.004 1.41-.615 2.542-1.374zm-282.418.436c.878-.463 1.094-.839 1.098-1.917.012-2.08-2.76-5.033-6.287-6.702-2.699-1.277-3.11-1.238-2.907.28.394 2.923 3.364 7.225 5.689 8.239 1.198.519 1.577.535 2.41.1zm302.32.044c2.32-.645 5.774-5.31 6.181-8.348.146-1.087.096-1.237-.433-1.237-.942 0-4.65 1.984-6.102 3.257-1.377 1.214-2.658 3.386-2.658 4.503 0 .625 1.207 2.124 1.708 2.122.13 0 .719-.14 1.307-.3zm-275.765-1.747c1.177-.583 1.181-.595.584-4.022-.419-2.425-.419-2.485.759-9.95l.375-2.395.565 1.198c.485 1.03.569 2.008.609 7.035.06 7.132.014 6.587.547 6.587.754 0 1.291-1.227 1.964-4.49 1.183-5.75.479-11.224-1.996-15.535-.994-1.737-3.944-5.723-4.236-5.725-.12 0-.175 1.321-.124 2.938.096 3.046-.05 3.908-1.608 9.487-1.238 4.435-1.158 9.447.24 14.297.363 1.264.738 1.358 2.323.573zm250.022-2.221c.493-2.032.675-3.685.683-6.212.006-3.134-.1-3.808-1.168-7.485-1.094-3.76-1.177-4.311-1.181-7.884l-.006-3.848-1.004 1.151c-2.75 3.146-4.886 7.166-5.605 10.56-1.058 4.985.214 13.999 2.02 14.33.455.086.513-.499.603-6.135.085-5.326.18-6.407.658-7.425l.56-1.198.378 2.395c1.172 7.453 1.178 7.545.765 9.806-.216 1.19-.453 2.501-.525 2.915-.11.63.048.826 1.01 1.243 2.016.878 2.072.834 2.814-2.215zm-328.754-5.39c-5.868-12.011-8.094-18.063-8.094-22.015 0-1.346.15-1.972.62-2.567.338-.433.538-.912.442-1.068-.094-.152-.918-.433-1.82-.623-5.992-1.243-6.387 4.699-1.048 15.783 1.946 4.043 3.569 6.676 6.61 10.732 1.893 2.52 6.544 7.62 6.95 7.62.097 0-1.55-3.532-3.662-7.858zm30.804 6.38c1.032-1.877.994-4.491-.094-6.717-1.297-2.65-1.525-2.675-2.594-.295-1.721 3.842-1.845 5.449-.571 7.539.51.838.752.978 1.567.898.786-.076 1.093-.334 1.692-1.425zm346.123.818c1.537-1.653 1.447-4.004-.305-7.856l-.946-2.076-.563.732c-2.291 2.978-2.483 7.312-.411 9.382.664.666 1.497.598 2.225-.18zm27.539-2.705c7.92-8.942 13.782-20.289 13.782-26.682 0-2.635-.525-3.66-2.086-4.08-1.185-.32-2.131-.225-3.676.36-.984.373-.986.389-.226 1.207.33.351.619.988.65 1.41.292 4.424-1.636 9.995-7.863 22.738-2.126 4.345-3.865 7.948-3.865 8.01 0 .526.975-.352 3.284-2.959zm-378.678.52c-.104-1.258-.163-1.342-.984-1.342-.664 0-.948.184-1.167.768-.42 1.108-.396 1.17.678 1.523 1.557.51 1.583.491 1.471-.946zm355.455.426c.469-.425-.679-1.816-1.41-1.716-.538.08-.672.32-.746 1.357l-.092 1.264.99-.332c.543-.18 1.11-.439 1.258-.573zm-306.424-.05a3.816 3.816 0 0 0-.239-.926c-.2-.499-.256-.509-.615-.075-.32.383-.323.568-.024.928.453.545.906.584.878.073zm256.305-.495c0-.14-.2-.419-.45-.628-.245-.204-.45-.256-.453-.11-.004.14-.09.579-.191.966-.174.645-.14.679.45.363.354-.19.644-.459.644-.595zm-310.216-.06c2.495-.87 1.405-3.193-1.872-3.983-.852-.206-5.473.59-5.968 1.028-.312.275 2.05 2.227 3.413 2.818 1.227.533 3.124.593 4.427.14zm16.477-.61c.784-2.246.074-5.15-1.765-7.206l-1.145-1.283-.37.898c-.564 1.377-.47 3.719.216 5.24.629 1.39 2.068 3.293 2.495 3.293.136 0 .393-.423.573-.942zm331.564-.032c1.952-2.603 2.581-5.35 1.72-7.525l-.338-.87-.699.658c-1.916 1.797-3.094 5.839-2.283 7.805.475 1.145.698 1.137 1.602-.068zm19.747.24c1.445-.69 3.085-2.21 2.73-2.532-.455-.415-2.998-.926-4.603-.926-2.778 0-4.97 1.545-4.211 2.968.67 1.258 3.918 1.517 6.088.487zm-345.59-1.763c0-1.772-.811-3.098-4.781-7.818l-3.433-4.082-.525.685c-.291.379-.533.778-.539.892 0 .112 1.45 2.135 3.222 4.49 4.884 6.494 5.588 7.362 5.828 7.226.128-.072.227-.698.227-1.393zm323.338-4.182c2.312-3.093 4.202-5.868 4.202-6.155 0-.288-.172-.759-.38-1.046-.339-.465-.786-.036-4.117 3.96-2.056 2.463-3.896 4.93-4.092 5.479-.435 1.207-.507 3.633-.106 3.493.16-.054 2.18-2.635 4.491-5.729zm-294.024 4.266c1.278-1.763 1.677-4.02 1.268-7.134-.184-1.381-.391-2.57-.463-2.64-.244-.24-5.122 5.03-5.8 6.267-.37.672-.673 1.617-.673 2.092 0 .768.207.958 1.872 1.728 1.028.475 2.104.872 2.395.884.284.01.918-.529 1.403-1.197zm263.61.331c2.187-.978 2.395-1.431 1.557-3.427-.348-.838-5.266-6.417-5.909-6.706-.11-.05-.363.882-.564 2.07-.58 3.412.036 6.638 1.57 8.27.813.869.978.859 3.348-.207zm-310.639-.932c.83-.892 1.357-3.038 1.114-4.545-.204-1.291-1.49-3.82-1.936-3.82-.274 0-1.729 3.098-2.152 4.575-.17.586-.148 1.38.056 2.145.585 2.192 1.776 2.865 2.918 1.641zm356.349-.353c.475-.755.588-1.348.503-2.621-.12-1.802-1.597-5.473-2.136-5.31-.507.148-1.717 2.751-1.892 4.066-.272 2.036 1.078 4.835 2.335 4.835.33 0 .844-.42 1.192-.972zm-316.354-.825.34-1.197c.15-.527.026-.599-1.012-.599-.944 0-1.288.16-1.693.774-.585.89-.624.825.739 1.238 1.46.449 1.437.451 1.626-.216zm275.989.092c.966-.195.99-.315.24-1.217-.723-.869-2.839-.99-2.603-.148.513 1.842.559 1.912 1.044 1.722.273-.103.868-.265 1.317-.359zm-291.274-.918c-.429-1.816-.958-2.67-1.882-3.054-1.221-.507-1.401-.283-.958 1.188.251.844.689 1.423 1.467 1.932 1.437.938 1.61.932 1.373-.06zm305.749.166c1.102-.759 1.916-1.99 1.916-2.907 0-.738-.032-.746-1.297-.22-.759.32-1.064.696-1.358 1.682-.21.698-.455 1.457-.543 1.684-.227.599.17.52 1.278-.24zm-344.5-.465c-.009-.12-.76-.693-1.665-1.268-2-1.267-6.627-6.191-5.493-5.848 1.56.475 3.776 1.886 6.071 3.872 1.318 1.138 2.308 1.836 2.196 1.549-.11-.287-1.032-1.737-2.048-3.226-2.934-4.279-5.874-6.083-10.499-6.44l-2.383-.184.599 1.17c1.469 2.874 4.81 6.726 7.395 8.506 2.116 1.457 5.876 2.667 5.824 1.867zm384.298-.24c2.261-.589 3.998-1.71 6.327-4.088 1.98-2.016 4.89-6.048 4.89-6.772 0-.36-.36-.405-2.03-.252-5.03.47-7.676 2.204-11.038 7.236-1.78 2.666-1.816 2.754-.688 1.85 3.964-3.2 6.762-4.994 7.784-4.994.639 0-4.465 5.244-5.972 6.138-1.387.822-1.892 1.347-1.291 1.347.128 0 1.038-.21 2.016-.465zm-334.756-.18c1.133-.519 1.221-1.287.319-2.834-.924-1.567-2.886-2.934-5.09-3.547-1.633-.453-7.634-.802-7.634-.447 0 .583 2.846 3.984 4.111 4.916 2.69 1.982 6.308 2.815 8.294 1.91zm288.06-.24c2.283-.797 4.16-2.223 5.868-4.45.798-1.038 1.447-1.982 1.447-2.104 0-.447-6.148-.01-8.184.585-2.269.665-4.207 2.271-4.978 4.132-.403.972-.385 1.042.4 1.716 1.042.898 3.117.944 5.449.124zm-329.208-.312c1.088-1.088.615-2.62-1.397-4.531-1.587-1.511-3.483-2.392-5.54-2.58-1.637-.147-1.745-.119-1.745.492 0 .83 1.223 3.253 2.27 4.499 1.077 1.277 3.632 2.714 4.84 2.714.578.006 1.217-.24 1.572-.594zm369.772-.675c1.98-1.351 3.693-3.687 4.058-5.539.193-.97.191-.972-1.028-.972-2.655 0-6.547 2.295-7.713 4.547-.535 1.038-.323 2.49.428 2.928 1.067.619 2.367.327 4.259-.964zm-356.131-3.669c.08-.327.016-.794-.144-1.038-.245-.37-.453-.379-1.333-.06-.573.206-1.729.456-2.569.56-.838.095-1.6.293-1.687.435-.087.14-.014.259.164.259.499 0 2.922 2.335 3.66 3.533l.66 1.066.554-2.076c.3-1.142.615-2.347.695-2.679zm331.19-.171c1.855-2.046 3.362-3.853 3.352-4.018-.028-.495-1.8-1.747-2.067-1.463-2.186 2.339-6.421 7.614-6.757 8.417-.73 1.744-.615 1.926.835 1.317.924-.391 2.191-1.553 4.638-4.255zm8.462 4.44c.004-.538 1.928-2.883 3.03-3.698l.934-.686-.858-.184c-1.15-.24-2.808-.659-3.607-.904-1.144-.35-1.411.73-.704 2.834.333.99.606 2.072.606 2.407 0 .334.136.607.3.607.165 0 .3-.168.3-.373zm-326.946-.31c0-.865-1.237-2.687-4.171-6.148-1.697-2.004-3.174-3.643-3.278-3.639-.1.004-.614.375-1.143.824l-.958.815 3.313 3.742c1.996 2.256 3.744 3.948 4.401 4.26 1.31.618 1.836.662 1.836.145zm21.258-2.27c.574-.46 1.52-1.757 2.095-2.88 1.008-1.96 1.048-2.164 1.048-5.27 0-1.796-.136-3.373-.305-3.54-.475-.48-5.545 4.582-6.387 6.379-1.052 2.243-.865 5.375.375 6.251.559.393 2.07-.056 3.174-.942zm273.655.335c.553-.698.632-1.117.533-2.774-.066-1.066-.376-2.481-.691-3.14-.759-1.587-5.844-6.55-6.271-6.12-.18.18-.312 1.677-.31 3.513.006 2.875.094 3.394.853 5.046.888 1.93 1.832 3.01 3.333 3.799 1.287.678 1.816.61 2.555-.324zm-318.799-1.349c.28-.699.591-1.485.687-1.746.124-.34-.373-.827-1.77-1.731-1.968-1.271-4.97-4.32-4.97-5.044 0-.273.233-.34.748-.21.413.104 1.108.1 1.547-.011.758-.19.725-.236-.778-.929-1.763-.818-2.416-.866-4.867-.343l-1.702.36 2.403 2.622c1.323 1.437 3.174 3.158 4.112 3.812a10.778 10.778 0 0 1 2.742 2.835c.567.894 1.098 1.636 1.182 1.64.084.006.379-.558.664-1.257zm362.131-.499c.571-.912 1.703-2.046 2.968-2.966 1.89-1.377 6.316-5.914 6.036-6.192-.066-.065-1.097-.279-2.291-.479-2.044-.339-2.256-.319-3.645.332-1.692.792-1.702 1.251-.02 1.018.635-.092 1.228-.048 1.318.1.269.433-2.923 3.782-4.79 5.033a67.043 67.043 0 0 0-1.997 1.362c-.267.22.934 3.265 1.29 3.265.12 0 .63-.665 1.133-1.477zm-336.702-.549c-1.537-3.054-1.533-3.064.308-3.084l1.592-.02-.898-.648c-1.7-1.234-4.191-4.012-5.313-5.922-1.186-2.02-1.41-2.849-.695-2.575.236.09 1.278.25 2.32.353l1.89.19-1.345-.879c-2.166-1.41-4.138-3.762-5.396-6.435-.632-1.349-1.097-2.503-1.038-2.567.064-.06.545.036 1.074.22 1.767.619 1.847.373.423-1.291-.764-.893-1.852-2.545-2.415-3.667l-1.032-2.042 1.358-.092 1.357-.091-1.727-1.631c-.946-.898-1.762-1.63-1.816-1.63-.054 0 .004 1.436.12 3.197l.203 3.2-1.057-.655c-1.368-.847-1.434-.83-1.434.33 0 .54-.203 1.272-.453 1.626-.379.539-.395.892-.111 2.09.622 2.634.724 2.77 1.137 1.51.206-.614.487-1.117.629-1.117.423 0 2.267 2.44 3.106 4.111 1.557 3.102 2.046 6.451 1.345 9.228-.411 1.632-.42 1.617 3.493 5.952 2.499 2.766 4.024 4 5.004 4.052.126.006-.16-.767-.635-1.713zm311.18.483c.589-.519 2.291-2.355 3.782-4.082 2.331-2.698 2.685-3.25 2.525-3.924a14.625 14.625 0 0 1 .882-9.47c.655-1.478 3.062-4.94 3.433-4.94.1 0 .372.502.6 1.123l.41 1.124.551-1.797c.5-1.626.505-1.872.096-2.594-.25-.436-.455-1.298-.455-1.917 0-1.043-.036-1.09-.523-.666a7.445 7.445 0 0 1-1.241.828l-.719.375.16-3.18c.09-1.748.14-3.179.113-3.179-.026 0-.824.735-1.776 1.63l-1.72 1.63 1.383.091 1.38.09-1.097 2.13c-.603 1.17-1.703 2.82-2.443 3.667-1.377 1.576-1.283 1.816.471 1.203.525-.185 1.022-.271 1.098-.193.076.077-.46 1.345-1.198 2.814-1.385 2.774-2.86 4.487-5.261 6.128l-1.347.922 1.784-.188c.978-.1 2.11-.27 2.509-.371l.726-.18-.964 1.817c-1.377 2.582-3.497 5.093-5.349 6.333l-1.593 1.07 1.683.09c1.916.103 1.92.125.565 2.82-.39.778-.709 1.485-.709 1.57 0 .492 1.324.03 2.248-.778zm-13.413-3.18a2.16 2.16 0 0 0-1.461-.674c-.827 0-.847.04-.847 1.649v1.648l1.462-.974 1.457-.978-.611-.672zm-283.777 0c.052-.966-1.421-.924-2.351.066-.665.709-.67.753-.128.952.313.114.906.467 1.317.785l.749.579.19-.855c.103-.47.205-1.157.225-1.527zm-30.303.843c2.26-1.028 2.451-2.288.613-4.046a6.814 6.814 0 0 0-4.864-1.964c-.909 0-6.875 1.371-7.274 1.67-.599.452 3.068 3.474 5.244 4.324 1.902.744 4.66.748 6.281.012zm349.413-.599c1.706-.908 4.275-3.108 4.275-3.66 0-.14-.235-.256-.523-.26-.29 0-1.663-.34-3.054-.747-3.17-.932-4.82-.938-6.766-.034-1.617.753-3.128 2.288-3.128 3.174 0 1.617 2.407 2.774 5.415 2.603 1.505-.088 2.401-.34 3.783-1.078zm-322.79-1.653c.233-.319.423-.81.423-1.097 0-1.006-1.936-3.082-3.733-4.002-1.63-.835-2.056-.913-5.748-1.052-3.014-.112-3.992-.06-3.992.215 0 .607 2.49 3.46 4.06 4.65 2.107 1.598 3.459 2.017 6.221 1.937 1.924-.06 2.425-.18 2.77-.65zm295.99-.26c1.996-.971 3.868-2.554 5.033-4.25.492-.715.899-1.378.899-1.47 0-.095-1.617-.171-3.593-.171-2.775 0-3.922.126-5.054.559-3.842 1.457-6.048 4.866-3.864 5.978 1.177.598 4.758.25 6.58-.643zm-340.479.097c0-.232-4.856-4.651-8.311-7.565-5.024-4.24-7.705-5.908-9.491-5.908-.874 0-1.126.14-1.363.768-.665 1.749-.13 5.763 1.125 8.433l.533 1.128 3.142.188c3.453.2 5.814.884 7.994 2.301 1.201.782 1.547.858 3.848.83 1.39-.02 2.527-.1 2.525-.18zm384.73-.994c2.554-1.407 4.97-2.02 8.037-2.036l2.495-.016.62-1.393c.917-2.076 1.416-4.192 1.42-6.048.006-4.451-2.626-3.94-9.88 1.904-2.96 2.385-9.335 8.128-9.51 8.563-.045.111 1.033.18 2.394.15 2.226-.049 2.675-.16 4.422-1.124zm-361.642-.535c1.217-1.218 1.904-3.25 1.908-5.657.008-1.924-.126-2.52-.946-4.191-.984-2.01-1.789-3.194-2.008-2.974-.07.071-.813 1.532-1.651 3.247-1.383 2.828-1.523 3.307-1.523 5.178 0 2.046.413 3.347 1.43 4.505.624.714 2.027.658 2.794-.106zm334.656-.136c1.792-2.275 1.665-5.355-.4-9.657-1.397-2.918-1.482-3.028-2.015-2.546-.304.275-.988 1.383-1.517 2.463-.858 1.736-.966 2.235-.944 4.363.02 1.846.173 2.694.672 3.662 1.304 2.521 3.02 3.224 4.204 1.717zm-308.998.044c3.401-1.782 5.01-6.778 3.605-11.213l-.32-1.006-2.509 2.495c-2.9 2.882-3.786 4.477-3.826 6.874-.048 2.788 1.106 3.866 3.048 2.85zm282.401.12c.739-.4 1.27-2.401 1.004-3.819-.39-2.091-1.048-3.133-3.704-5.868l-2.655-2.734-.365.898c-.2.495-.371 2.042-.38 3.441-.02 3.659 1.228 6.192 3.845 7.82 1.024.639 1.449.689 2.255.26zm-313.778-4.032c0-1.331-.012-1.347-1.018-1.347-.798 0-1.048.14-1.181.672-.28 1.118-.2 1.258.948 1.617.606.188 1.137.355 1.177.375.04.016.074-.579.074-1.317zm344.886.748c.644 0 .732-.291.43-1.423-.139-.53-.398-.672-1.197-.672-.998 0-1.008.014-1.008 1.357 0 1.251.046 1.337.58 1.05.319-.172.857-.312 1.197-.312zm-349.75-.648c1.85-1.138 1.527-2.77-.858-4.352-1.737-1.145-4.032-1.265-7.23-.369-1.357.38-2.595.799-2.748.932-.384.33 1.437 2.192 3.107 3.174 2.749 1.625 5.7 1.86 7.73.615zm360.115-.394c1.465-.858 4.136-3.141 3.922-3.353-.064-.064-1.377-.463-2.924-.888-4.411-1.21-7.273-.659-8.972 1.723-.854 1.203-.573 2.185.852 2.964 1.697.924 5.158.706 7.126-.444zm-328.18-1.081.196-1.374-1.281-.02c-1.002-.012-1.397.136-1.8.675-.51.679-.5.699.894 1.605.778.505 1.497.818 1.604.702.106-.115.28-.832.39-1.588zm291.63.447c.718-.46.724-.5.225-1.166-.403-.543-.794-.687-1.812-.673l-1.298.016.192 1.078c.106.587.263 1.318.351 1.613.174.59-.034.667 2.345-.87zm-335.964.674 1.443-.345-1.866-1.497c-1.028-.824-2.352-2.092-2.944-2.818l-1.074-1.322.822.206c1.238.307 1.008-.116-.858-1.605-1.817-1.45-4.605-4.365-4.605-4.814 0-.152.431-.275.958-.275h.958l-1.333-.859c-.733-.473-1.796-1.35-2.363-1.946-.567-.597-1.31-1.086-1.647-1.082-1.198.008-11.537 3.707-11.211 4.012.063.06 1.15.387 2.41.733 4.9 1.333 9.362 4.052 14.771 8.998 3.593 3.283 3.653 3.303 6.537 2.614zm381.656-.379c1.317-1.421 6.754-6.008 8.622-7.277a30.367 30.367 0 0 1 8.39-3.926c1.337-.386 2.424-.79 2.424-.904 0-.42-9.84-3.873-11.033-3.873-.286 0-1.054.547-1.705 1.218-.65.67-1.788 1.543-2.53 1.936l-1.346.707 1.122.014c.654.008 1.123.16 1.123.369 0 .383-3.986 4.415-5.688 5.748l-1.046.825 1.018-.2 1.014-.208-.623.879c-.699.982-2.7 2.878-4.207 3.992l-.998.738 1.596.34c2.521.538 3.07.482 3.869-.376zm-341.34-2.509c.8-.798.76-1.19-.255-2.575-1.896-2.594-3.605-3.365-8.223-3.708-1.84-.136-3.41-.188-3.483-.116-.316.311 1.098 2.32 2.714 3.858 2.29 2.188 4.336 3.134 6.779 3.134 1.473.006 1.996-.12 2.469-.593zm303.244-.467c1.174-.587 2.705-1.64 3.41-2.343 1.237-1.238 2.59-3.33 2.315-3.573-.08-.068-1.637-.02-3.47.106-3.74.255-5.594.89-7.249 2.475-.992.952-1.846 2.287-1.846 2.89 0 .174.271.583.599.914 1.026 1.026 3.648.833 6.241-.467zm-326.574.156c.319-.17.942-1.012 1.385-1.87 1.197-2.328 1.132-5.05-.2-7.933-.539-1.177-1.223-2.355-1.517-2.62-.499-.451-.612-.306-1.936 2.459-2.08 4.351-2.175 7.469-.3 9.497.765.824 1.614.978 2.57.467zm346.017-.366c1.49-1.584 1.97-4.403 1.144-6.694-.23-.639-.918-2.208-1.531-3.487-1.298-2.7-1.437-2.69-2.914.214-1.717 3.373-1.425 8.063.612 9.954.945.874 1.877.878 2.69.014zm-317.277-1.976c1.632-1.696 2.395-3.652 2.435-6.227.02-1.98-.31-4.291-.619-4.291-.114 0-1.367 1.121-2.786 2.495-2.182 2.107-2.659 2.746-3.1 4.145-.583 1.857-.423 4.112.35 4.882.911.913 2.209.565 3.72-1.004zm289.703 1.222c.499-.32.992-1.727.992-2.854.004-2.156-.939-3.839-3.593-6.417-1.397-1.358-2.63-2.47-2.735-2.47-.487 0-.838 3.793-.539 5.69.64 3.987 3.879 7.32 5.875 6.051zm-323.854-2.86c0-.878-.06-1.657-.134-1.73-.074-.075-.675-.08-1.338-.02-1.187.113-1.433.412-1.916 2.35-.044.172 1.902.763 3.162.963.126.02.225-.683.225-1.561zm356.434 1.098c1.647-.28 1.693-.32 1.305-1.066a38.628 38.628 0 0 1-.563-1.132c-.205-.44-2.231-.958-2.538-.653-.084.086-.152.887-.152 1.783 0 1.429.064 1.602.525 1.425.287-.11.928-.272 1.423-.36zm-362.165-.827c1.988-1.028 1.856-2.746-.325-4.26-2.028-1.404-5.45-1.283-10.387.374-.31.1-.148.427.598 1.204 2.835 2.95 7.302 4.131 10.112 2.68zm372.642-.3c1.688-.786 4.12-2.774 3.964-3.247-.174-.519-4.75-1.704-6.511-1.686-2.475.024-4.164.808-5.213 2.425-.62.958-.434 1.796.544 2.439 1.893 1.237 4.64 1.261 7.218.066zm-338.367-2.195c.1-.45.26-1.106.36-1.453.149-.515.027-.662-.663-.802a9.91 9.91 0 0 1-1.344-.363c-.379-.144-.553.046-.738.804-.347 1.417-.355 1.391.639 2.022 1.23.788 1.536.752 1.746-.206zm298.902.174 1.206-.689c.036-.02-.09-.539-.28-1.157-.259-.843-.459-1.066-.812-.915-.26.112-.85.27-1.317.352-.699.116-.815.26-.665.778.1.351.26 1.006.36 1.457.1.455.223.827.275.827.052 0 .609-.296 1.237-.653zm-328.399-1.297c2.505-2.106 2.384-7.525-.245-11.222l-.699-.978-.838 1.613c-2.629 5.07-2.806 8.658-.515 10.585 1.112.938 1.198.938 2.301.004zm359.237-.64c.699-.921.849-1.44.926-3.22.088-1.997.01-2.304-1.265-4.97-.747-1.563-1.461-2.875-1.587-2.915-.373-.12-1.645 1.944-2.22 3.609-.961 2.788-.648 5.595.85 7.615 1.025 1.377 2.18 1.337 3.294-.12zm-333.804.326c2.056-1.437-1.187-5.103-5.12-5.788-2.229-.391-5.289-.44-5.289-.08 0 .503 1.868 3.042 2.918 3.964 2.37 2.08 5.948 2.99 7.493 1.904zm309.667.008c1.924-.662 3.992-2.291 5.21-4.098.578-.864 1.057-1.696 1.057-1.846 0-.355-5.094 0-6.656.471-1.593.48-4.018 2.687-4.286 3.902-.403 1.837 1.785 2.575 4.677 1.571zm-340.435-3.808v-1.577l-1.347.11c-1.178.094-1.347.193-1.347.798 0 .384-.074.886-.16 1.118-.12.303.236.507 1.27.733.79.171 1.468.327 1.508.35.044.02.076-.668.076-1.532zm36.111.908c1.637-1.265 2.396-2.54 2.81-4.724.26-1.378-.023-4.316-.458-4.75-.086-.087-1.164.843-2.395 2.067-2.52 2.503-3.314 4.052-3.054 5.988.293 2.156 1.45 2.69 3.097 1.417zm297.236.206c.669-.671.878-2.256.483-3.719-.26-.962-.958-1.916-2.826-3.848l-2.483-2.569-.33 1.876c-.578 3.294.563 6.707 2.709 8.078 1.17.75 1.826.798 2.445.18zm35.984-.14c.644 0 .712-.1.555-.822-.332-1.517-.392-1.571-1.617-1.571h-1.208v1.49c0 1.474.01 1.486.769 1.198.419-.16 1.097-.293 1.503-.293zm-374.906-.559c1.322-.745 1.617-1.387 1.082-2.335-.682-1.206-2.55-2.048-4.49-2.028-1.61.02-6.288 1.221-6.288 1.617 0 .746 3.313 2.87 5.19 3.32 1.27.308 3.445.033 4.51-.572zm384.46-.146c1.513-.706 3.444-2.15 3.444-2.57 0-.13-1.358-.6-3.01-1.042-2.695-.725-3.182-.775-4.631-.473-1.777.369-3.437 1.636-3.437 2.618 0 2.01 4.587 2.89 7.634 1.467zm-23.832-2.588c1.004-1.234 2.03-2.671 2.276-3.19.487-1.018.609-2.798.193-2.798-.14 0-.954.738-1.806 1.64-1.49 1.577-3.018 4.252-3.026 5.296 0 .539.324 1.53.453 1.387.044-.05.904-1.098 1.91-2.335zm-340.742 1.125c.14-1.147-1.287-3.752-3.03-5.54-.838-.865-1.636-1.573-1.764-1.573-.34 0-.29 1.616.08 2.588.419 1.106 3.944 5.493 4.325 5.386.166-.048.34-.436.391-.859zm17.52-.752.179-1.571h-1.597c-2.441 0-2.585.523-.547 2.024.932.685 1.717 1.217 1.74 1.182.026-.032.126-.769.224-1.637zm305.245.459a88.139 88.139 0 0 1 1.51-1.044c.064-.04-.051-.28-.259-.529-.24-.291-.89-.459-1.766-.459h-1.388l.106 1.497c.056.822.17 1.497.25 1.497.08 0 .774-.44 1.543-.966zm-327.8-.072c.22-.569.111-1.108-.464-2.365-.423-.918-.826-2.495-.932-3.627-.183-1.984-.207-2.022-2.387-4.397-1.21-1.317-2.2-2.519-2.2-2.669 0-.153-.153-.273-.339-.273-.465 0-.14 2.68.47 3.852.253.491 1.023 1.541 1.71 2.336a13.587 13.587 0 0 1 3.008 6.163c.391 1.868.698 2.136 1.133.984zm349.516-.682c.26-1.953 1.617-4.691 3.293-6.653.845-.99 1.577-2.228 1.84-3.124.512-1.724.567-2.874.14-2.874a.292.292 0 0 0-.299.283c0 .154-.938 1.294-2.088 2.531-2.122 2.292-2.235 2.521-2.53 5.07a11.617 11.617 0 0 1-.77 2.81c-.798 1.803-.79 3.378.013 3.378.116 0 .295-.64.399-1.421zm-384.394-3.43c-1.743-1.816-3.108-3.365-3.034-3.439.409-.409 3.66 1.803 5.96 4.046 3.313 3.238 4.012 3.038 1.47-.415-3.652-4.962-6.422-6.51-13.272-7.425-1.438-.19-1.537-.032-.591.958a541.27 541.27 0 0 1 3.908 4.206c1.716 1.864 3.643 3.732 4.281 4.155 1.17.775 3.773 1.617 4.212 1.357.128-.073-1.192-1.624-2.934-3.443zm418.304 2.779c1.636-.743 3.141-2.14 6.896-6.383l3.113-3.521h-1.07c-1.756 0-5.484.882-7.245 1.716-.904.427-2.351 1.425-3.213 2.216-1.9 1.732-4.81 5.822-4.348 6.108.176.107 1.557-.998 3.074-2.462 2.35-2.269 5.162-4.197 5.563-3.812.204.194-1.457 2.196-3.724 4.491l-2.19 2.222.952-.006c.525 0 1.511-.26 2.196-.57zm-393.109-.16c1.078-.754 1.996-3.353 1.816-5.125-.18-1.743-1.201-4.34-1.988-5.05-.487-.44-.598-.31-1.666 1.966-1.75 3.732-1.729 6.63.06 8.044.918.718.978.722 1.776.163zm370.374-1.211c1.024-1.813.899-3.338-.548-6.639-1.164-2.655-1.264-2.788-1.767-2.335-.758.688-1.79 3.225-1.99 4.91-.18 1.547.152 2.884 1.11 4.455.51.838.752.978 1.563.898.762-.076 1.097-.34 1.636-1.291zm-353.94-2.695c-.566-2.443-2.199-5.649-3.807-7.477-.65-.739-2.595-2.635-4.32-4.212-2.914-2.664-3.217-2.862-4.247-2.774l-1.108.09.084 1.301c.18 2.775 2.07 5.36 7.589 10.367 2.243 2.04 4.536 4.344 5.09 5.118l1.007 1.41.092-.899c.05-.495-.12-1.808-.38-2.924zm343.62-5.49c3.1-2.98 4.51-5.209 4.901-7.757l.196-1.274h-1.248c-1.171 0-1.457.2-4.8 3.294-5.702 5.279-7.098 7.634-7.97 13.44l-.2 1.314 3.106-3.11a462.636 462.636 0 0 1 6.018-5.908zm-375.665 8.358c.527-.207.452-.31-.648-.872-.689-.35-2.072-1.397-3.078-2.331-1.006-.935-1.884-1.641-1.946-1.577-.244.243 4.16 5.056 4.607 5.036.259-.012.738-.128 1.067-.256zm43.82-.487c.75-.958.451-2.016-.948-3.373-1.403-1.357-3.114-1.852-6.407-1.852h-2.822l.664 1.181c.87 1.547 2.823 3.441 4.316 4.186.758.379 1.822.599 2.898.607 1.473.012 1.776-.09 2.3-.75zm316.663.054c1.507-.699 3.688-2.854 4.519-4.455l.427-.824h-2.571c-3.637 0-5.08.433-6.635 1.988-1.01 1.01-1.29 1.509-1.29 2.299 0 .752.174 1.094.676 1.337 1.157.555 3.263.407 4.876-.345zm40.877-.208c1.537-1.646 3.334-3.872 3.124-3.872-.112 0-1.014.733-2.002 1.627-.988.894-2.285 1.856-2.884 2.142-.97.459-1.024.538-.499.748 1.028.4 1.377.3 2.26-.643zm-389.947-.315a9.677 9.677 0 0 1-.187-1.47c0-.45-.194-.51-1.274-.378-1.251.155-2.02.722-2.02 1.493 0 .215.304.399.673.405.37.006 1.078.2 1.573.425 1.317.603 1.441.555 1.237-.475zm377.952.34c1.277-.44 1.622-.693 1.542-1.11-.055-.3-.151-.591-.211-.653-.116-.12-2.65-.619-2.715-.54-.095.129-.439 2.895-.355 2.885.048-.006.832-.267 1.737-.583zm-341.818-.34c1.303-.669 2.598-2.196 3.074-3.629.499-1.5.526-5.914.04-6.399-.352-.353-4.398 3.765-5.03 5.126-.879 1.876-.665 4.267.445 5.01.45.3.712.283 1.47-.106zm305.69-.208c.739-.818.922-2.289.48-3.872-.31-1.098-.915-1.948-2.73-3.812-2.75-2.834-2.927-2.77-2.933.978-.006 2.695.692 4.639 2.135 5.936 1.537 1.381 2.316 1.577 3.048.77zm-348.422-.093c.788-.196 1.58-.645 1.936-1.092.519-.665.543-.838.18-1.385-.767-1.178-2.292-1.976-3.757-1.97-1.297.006-5.579.95-5.94 1.311-.489.489 2.427 2.535 4.351 3.054 1.79.479 1.657.479 3.23.08zm393.382-.336c1.048-.379 3.742-2.26 3.742-2.61 0-.34-4.46-1.505-5.764-1.505-3.094 0-5.313 2.495-3.357 3.772 1.477.972 3.323 1.088 5.379.343zm-340.64-4.564c-.166-3.39-1.114-5.879-5.581-14.67-7.719-15.19-10.633-18.073-19.493-19.286-1.237-.17-6.557-.45-11.824-.623-16.79-.553-25.27-1.46-30.746-3.297-5.29-1.77-8.084-4.74-9.405-10.01-.274-1.098-.611-1.888-.749-1.757-.134.14-.469 1.124-.744 2.192-.855 3.321-.116 11.371 1.782 19.497 1.331 5.696 4.8 9.672 10.39 11.904 4.5 1.796 9.28 2.295 26.176 2.728 21.697.551 25.17.847 28.99 2.451 5.922 2.487 10.245 7.735 10.615 12.88.231 3.246.758 1.454.587-2.005zm285.505-1.777c2.555-5.583 7.804-9.335 14.716-10.519 1.477-.255 7.036-.53 14.52-.718 20.839-.523 29.342-1.108 33.533-2.304 2.759-.784 6.178-2.734 8.084-4.61 2.575-2.535 3.952-5.561 4.91-10.759 1.148-6.271 1.677-10.22 1.673-12.463-.006-2.121-.693-6.017-1.138-6.463-.14-.14-.423.493-.627 1.408-1.037 4.638-4.16 8.383-8.323 9.98-5.708 2.187-15.335 3.233-34.97 3.804-11.564.331-15.109 1.217-18.961 4.75-2.176 1.996-5.992 8.19-10.154 16.497-4.02 8.024-4.864 10.471-4.864 14.112 0 3.073.4 3.762.639 1.105.12-1.309.493-2.802.958-3.822zm-323.762 3.593c-.006-.18-.204-.655-.44-1.068-.409-.719-.427-.679-.429.898 0 1.511.036 1.601.44 1.066.239-.32.435-.724.429-.898zm361.326-.689c-.096-.818-.1-.818-.469-.173-.29.507-.295.838-.02 1.497.335.798.36.808.47.173.063-.369.071-1.042.02-1.497zm-370.07.443c1.576-1.684 1.736-4.778.382-7.632-.487-1.03-1.014-1.872-1.17-1.872-.458 0-2.7 4.323-2.905 5.6-.196 1.238.375 3.046 1.277 4.044.659.73 1.657.67 2.415-.14zm380.473-.115c1.048-1.138 1.437-2.8 1.012-4.372-.35-1.301-2.363-5.002-2.726-5.014-.112 0-.571.747-1.018 1.665-1.385 2.826-1.358 5.918.06 7.605.938 1.118 1.716 1.147 2.674.116zm-336.802-2.909c-.106-.419-.539-1.137-.962-1.6l-.768-.839.173 1.012c.094.555.174 1.629.174 2.387v1.378l.788-.787c.603-.602.743-.97.6-1.55zm292.012-.12-.006-2.319-.738 1.198c-.403.659-.739 1.393-.739 1.627 0 .37 1.118 1.816 1.402 1.816.052 0 .091-1.044.085-2.32zm-302.676.819c1.389-1.39.29-5.481-2.022-7.51-1.192-1.047-3.793-2.362-4.683-2.366-.519-.004-.549.165-.365 2.136.32 3.447 1.605 5.84 3.98 7.413 1.637 1.081 2.275 1.15 3.094.327zm314.153.196c1.431-.6 3.441-2.835 4.08-4.54.31-.822.659-2.406.779-3.512.253-2.375.163-2.423-2.316-1.324-2.22.988-3.419 2.102-4.44 4.124-1.458 2.882-1.125 5.082.847 5.633.048.014.52-.16 1.05-.38zm36.66-.587c-.2-.603-.818-.56-.818.06 0 .429.14.558.463.435.254-.1.413-.32.355-.495zm-388.837-.08c0-.531-.644-.44-.83.116-.064.195.096.355.36.355a.479.479 0 0 0 .47-.473zm29.042.144c0-.52-2.343-5.026-3.72-7.158-1.957-3.022-1.91-2.994-5.005-2.994h-2.694l3.27 3.22c1.843 1.812 3.826 4.101 4.538 5.24 1.214 1.935 1.317 2.02 2.435 2.02.65 0 1.174-.147 1.174-.328zm3.593.16c0-.096-.348-.625-.77-1.182-1.099-1.437-1.843-3.583-2.272-6.553l-.372-2.575h-4.359l1.306 2.022c.718 1.11 1.94 3.3 2.722 4.864.779 1.567 1.553 3.014 1.717 3.22.3.365 2.028.539 2.028.203zm324.39-.02c.272-.104 1.078-1.418 1.797-2.919.718-1.5 1.922-3.672 2.67-4.826.751-1.158 1.368-2.204 1.372-2.335.004-.132-.902-.2-2.016-.15l-2.02.09-.373 2.455c-.44 2.908-1.338 5.457-2.346 6.65-.399.473-.724.942-.724 1.042 0 .236 1.018.23 1.64-.008zm5.785-2.172c.964-1.477 2.675-3.433 4.59-5.24l3.054-2.88-1.922.004c-3.632.006-3.912.128-5.369 2.347-1.557 2.376-4.171 7.226-4.18 7.755 0 .235.42.373 1.142.373 1.106 0 1.206-.09 2.685-2.36zm-370.714.818c-.585-.685-1.816-1.663-2.728-2.172-1.729-.964-7.086-5.017-6.886-5.215.06-.06 1.4.499 2.978 1.245 1.576.749 2.864 1.254 2.864 1.126 0-.535-2.371-3.842-3.401-4.742-1.298-1.138-3.44-2.276-5.15-2.735-1.529-.411-5.82-.878-5.82-.638 0 .393 3.509 4.482 6.251 7.289 4.677 4.778 8.391 7.066 11.51 7.078l1.444.006-1.064-1.244zm406.837.675c.892-.316 2.403-1.082 3.361-1.707 1.988-1.293 8.218-7.439 10.372-10.227l1.44-1.866-1.44.006c-3.907.014-8.172 1.736-10.37 4.191-1.051 1.178-2.714 3.872-2.51 4.076.033.032 1.265-.531 2.738-1.254 1.473-.722 2.75-1.241 2.834-1.157.084.084.02.251-.152.367-.167.116-1.445 1.098-2.834 2.19-1.39 1.087-2.994 2.215-3.573 2.503-1.074.538-3.592 2.79-3.592 3.217 0 .43 2.085.246 3.728-.331zm-400.677-.827c.852-.772.704-2.459-.36-4.065-1.624-2.45-4.095-3.847-7.584-4.28-1.745-.22-1.753-.213-1.541.5.766 2.554 4.068 6.937 5.904 7.843 1.277.63 2.888.631 3.58.004zm395.474-.353c.738-.465 1.706-1.283 2.155-1.816 1.05-1.246 2.855-4.332 3.094-5.28.18-.708.13-.738-1.305-.738-2.884 0-6.06 1.732-7.585 4.132-2.228 3.512.144 5.922 3.643 3.702zm-349.716-3.557c0-.553-2.899-2.387-4.87-3.082-2.645-.93-2.935-.798-1.494.673 1.438 1.47 2.056 2.779 2.346 4.99l.21 1.57 1.903-1.885c1.046-1.038 1.905-2.06 1.905-2.27zm303.98 2.326c.203-1.72.784-2.97 2.185-4.699l1.004-1.237-1.217.273a16.92 16.92 0 0 0-2.296.725c-1.281.534-3.636 2.255-3.648 2.67-.01.32 3.293 3.753 3.606 3.753.106 0 .272-.667.368-1.481zm-336.08-5.877c-.379-1.157-.41-1.177-2.002-1.267l-1.616-.094.187 2.004c.224 2.423 1.064 4.264 2.541 5.559l1.102.97.084-2.998c.053-1.856-.06-3.447-.3-4.176zm366.423 4.392c.934-1.533 1.608-4.679 1.161-5.402-.339-.548-2.794-.385-3.103.208-.515 1.002-.683 2.834-.48 5.2.206 2.339.22 2.375.845 1.97.35-.228 1.058-1.118 1.577-1.976zm-370.37 1.347c.089-.234-.05-1.046-.308-1.809-.26-.762-.473-2.155-.475-3.097 0-.938-.12-1.886-.254-2.102-.291-.465-3.632-.882-3.632-.453 0 .156.734 1.341 1.63 2.627.913 1.311 1.797 2.98 2.002 3.796.374 1.457.739 1.82 1.038 1.032zm372.98-.81c.188-.943 1.37-3.098 2.755-5.03 1.066-1.487.97-1.909-.395-1.71-.62.089-1.344.169-1.617.173-.391.01-.539.459-.709 2.183-.115 1.192-.399 2.729-.628 3.413-.4 1.194-.3 2.35.18 2.056.123-.08.31-.567.414-1.086zm-377.959-3.973c.004-.479-.255-1.289-.575-1.808-.578-.938-.598-.942-4.34-1.301-2.069-.2-5.52-.713-7.67-1.146-2.15-.433-3.991-.703-4.095-.599-.48.48.984 1.168 3.553 1.669 4.251.828 6.133 1.643 7.92 3.429.922.924 1.682 2.012 1.902 2.725.2.652.425 1.377.499 1.602.207.647 2.8-3.573 2.808-4.57zm385.035 4.144c0-.89 1.465-3.333 2.635-4.387 1.421-1.287 3.728-2.202 7.539-2.99 2.886-.599 3.598-.914 3.598-1.603 0-.31-.295-.305-1.542.024-2.442.643-8.533 1.637-11.477 1.868l-2.699.216-.639 1.333c-.726 1.517-.714 1.581.883 4.132 1.157 1.848 1.704 2.3 1.704 1.41zm-349.872-29.427c.4-2.105.819-3.319 2.475-7.165.61-1.417-3.648 1.353-6.299 4.098-1.094 1.131-1.988 2.195-1.988 2.365 0 .167.709.639 1.573 1.046.864.405 2.042 1.074 2.619 1.487.579.409 1.07.726 1.098.698.026-.02.259-1.161.522-2.53zm316.611-.044c.51-.21.926-.519.926-.682 0-.585-4.67-4.942-6.287-5.868-2.136-1.218-2.535-1.214-1.802.03.942 1.592 2.005 4.72 2.389 7.011l.359 2.152 1.744-1.128c.959-.618 2.164-1.301 2.671-1.513zm-323.648-2.854c1.576-1.668 2.584-3.547 3.437-6.41.343-1.159.369-1.538.1-1.418a744 744 0 0 1-3.66 1.537c-1.811.762-3.867 1.716-4.57 2.132-1.53.898-2.804 2.704-2.868 4.071l-.046.988 2.245.34c3.727.563 3.643.583 5.362-1.238zm331.412 1.168c1.178-.126 1.957-.36 2.052-.613.088-.225-.21-1.166-.658-2.086-.944-1.93-2.282-2.92-5.655-4.191a46.696 46.696 0 0 1-3.547-1.513c-1.647-.823-1.702-.709-.864 1.732.944 2.745 2.02 4.571 3.483 5.916 1.197 1.108 1.53 1.268 2.345 1.124a56.65 56.65 0 0 1 2.844-.37zm-340.817-.715c.295-.479-.887-2.818-2.102-4.163-.615-.685-2.403-1.996-3.972-2.92-3.014-1.773-5.144-3.54-5.976-4.947-.69-1.17-.97-1.063-.97.372 0 3.433 3.672 10.798 5.822 11.668.878.356 6.98.35 7.2-.008zm352.49-.507c.932-.585 2.8-3.533 3.764-5.936 1.288-3.22 1.857-8.048.699-5.988-.808 1.45-3.106 3.461-5.669 4.962-1.53.894-3.393 2.236-4.14 2.974-1.39 1.382-2.848 3.988-2.518 4.517.28.453 7.016 0 7.864-.529zm-368.658-1.251a29.281 29.281 0 0 1-1.072-3.16c-.399-1.58-.553-1.523-1.287.475-.284.769-1.052 2.006-1.707 2.755l-1.191 1.35 1.281.117c.707.064 2.05.14 2.986.167l1.697.052-.709-1.756zm6.076 1.53c-2.276-4.478-3.385-7.129-3.946-9.42-.527-2.146-.793-2.775-1.178-2.755-2.427.12-2.271.032-2.088 1.248.34 2.225 1.631 6.806 2.527 8.958l.914 2.195h1.943c1.071 0 1.896-.1 1.832-.225zm368.764-.47c1.003-1.527 3.147-8.843 3.153-10.755 0-.706-.128-.828-.898-.868a47.632 47.632 0 0 1-1.246-.074c-.2-.02-.638 1.144-1.013 2.69-.66 2.68-2.04 6.192-3.154 8.02-.902 1.478-.769 1.685 1.066 1.685 1.385 0 1.71-.11 2.096-.698zm6.367.399h1.03l-1.188-1.35c-.65-.738-1.491-2.167-1.866-3.169l-.683-1.824-.708 2.455c-.39 1.353-.839 2.704-1.002 3.004-.603 1.127-.384 1.277 1.548 1.077a35.22 35.22 0 0 1 2.87-.193zm-393.328-1.272c-.008-1.423-1.623-3.08-4.004-4.101-2.905-1.246-10.02-2.102-10.308-1.244-.067.204.48.948 1.218 1.657 1.557 1.49 4.84 2.81 9.285 3.732 3.693.763 3.809.763 3.807-.044zm5.914-.207c.838-.609 1.527-1.513 2.215-2.914.954-1.936 1.002-2.19 1.002-5.383 0-1.843-.094-3.444-.211-3.561-.27-.27-3.63 2.39-5.262 4.161-2.066 2.244-2.708 5.888-1.393 7.9.639.978 2.132.893 3.647-.207zm393.082.096c.639-.978.659-4.016.032-5.503a9.635 9.635 0 0 0-1.265-2.03c-1.134-1.341-5.242-4.667-5.48-4.431-.099.104-.247 1.377-.315 2.83-.205 4.251 1.078 7.473 3.633 9.13 1.585 1.028 2.725 1.03 3.393.008zm7.525-.28c3.793-.898 7.126-2.399 8.224-3.7.45-.535.818-1.118.818-1.29 0-.22-1.038-.267-3.218-.16-6.273.32-11.143 2.751-11.151 5.57 0 .826.12.818 5.33-.42zm-376.332-2.215c.519-.647.948-1.238.948-1.31 0-.071-.43-.307-.954-.525-.978-.409-1.663-.439-2.888-.131-.691.173-.689.185.375 1.363.59.653 1.072 1.317 1.072 1.485 0 .593.519.28 1.447-.882zm343.215-2.136c-1.026-.445-1.158-.44-2.146.128-.579.331-1.098.638-1.158.678-.06.04.336.627.879 1.298l.982 1.223 1.265-1.427 1.266-1.429-1.09-.471zm-373.123-.05c.196-.698.42-1.423.499-1.605.086-.205-.393-.409-1.234-.523-1.125-.155-1.532-.073-2.241.454l-.87.638 1.297.825c.715.455 1.39.972 1.501 1.151.38.619.695.332 1.048-.942zm401.99.643c.314-.347 1.01-.858 1.554-1.138l.982-.503-.89-.658c-.735-.543-1.134-.625-2.268-.47-.842.116-1.317.316-1.228.52.08.183.316.906.523 1.606.208.7.46 1.27.567 1.27.1 0 .443-.284.759-.63zm-368.286-1.872c1.617-.753 3.1-2.242 4.006-4.018.687-1.352 1.531-4.122 1.531-5.03v-.659l-1.87.729c-3.733 1.449-4.805 2.056-5.954 3.359-1.382 1.569-2.276 4.152-1.77 5.1.734 1.369 1.907 1.517 4.057.519zm336.602.24c.895-.626.879-2.22-.045-4.196-.952-2.044-2.415-3.174-5.956-4.581l-2.974-1.184.207 1.383c.633 4.226 3.238 7.8 6.367 8.743 1.238.373 1.673.343 2.402-.166zm-342.502-1.093c.2-.2.36-.838.353-1.42-.016-2.735-2.606-5.61-6.778-7.526-1.417-.652-2.655-1.111-2.749-1.022-.09.092.004.803.21 1.577.992 3.747 3.094 6.63 5.814 7.988 1.683.834 2.603.954 3.154.403zm347.886-.231c1.75-.795 4-3.13 4.95-5.142.898-1.896 1.616-4.341 1.357-4.603-.1-.095-1.467.454-3.046 1.218-4.166 2.03-6.48 4.69-6.48 7.445 0 1.69 1.077 2.056 3.219 1.082zm-379.63-.174c1.243-.87.722-2.702-1.33-4.684-1.882-1.817-4.043-2.535-9.327-3.094l-1.896-.204.659 1.284c.694 1.369 3.161 4.131 4.59 5.15 2.436 1.732 5.969 2.482 7.306 1.55zm414.046-.599c2.112-1.037 5.13-3.866 6.188-5.8.972-1.784 1.198-1.712-3.353-1.066-3.593.511-5.44 1.242-7.038 2.783-2.06 1.99-2.569 3.802-1.322 4.706.939.679 3.438.4 5.525-.619zm-422.07.466c0-.164-.14-.3-.32-.3-.542 0-3.592-3.074-4.378-4.411-.412-.705-.819-1.277-.909-1.277-.353 0 .3 3.772.835 4.822.459.892.778 1.152 1.553 1.247 1.956.244 3.221.214 3.221-.08zm428.338-.168c.439-.09.794-.539 1.106-1.403.552-1.543.918-4.124.584-4.102-.133.01-.762.824-1.397 1.812-.635.988-1.742 2.226-2.455 2.755-.718.525-1.313 1.058-1.317 1.177-.014.2 1.956.064 3.479-.24zm-33.557-3.054c1.49-1.828 1.57-2.15.729-2.91-.569-.52-.599-.515-.787.026-.469 1.371-1.65 3.82-2.255 4.663l-.655.922.819-.54c.455-.295 1.42-1.267 2.147-2.159zm-382.22 1.88c1.373-.708 2.986-2.834 3.517-4.638.509-1.729.608-5.53.18-6.954l-.24-.81-2.605 2.454c-3.078 2.904-3.884 4.322-3.872 6.827.016 3.087 1.038 4.147 3.02 3.121zm18.778-1.429c-.543-1.028-1.15-2.335-1.35-2.906l-.359-1.032-.624.619c-.424.431-.56.826-.424 1.253.206.645 3.166 3.936 3.541 3.936.116 0-.235-.842-.778-1.872zm382.893 1.138c1.094-1.094 1.052-3.98-.088-6.16-.866-1.65-5.281-5.962-5.692-5.553-.465.464-.44 5.78.04 7.416.533 1.83 2.24 4.011 3.613 4.606 1.237.54 1.285.531 2.127-.311zm-372.915-2.25c0-.16.431-.778.958-1.377.878-1.006.912-1.112.413-1.391a6.114 6.114 0 0 1-1.094-.858c-.539-.54-.579-.525-1.5.393-.765.764-.879 1.034-.603 1.413.19.254.578.834.858 1.285.519.825.966 1.072.966.535zm343.141-1.014.779-1.287-.859-.958-.858-.962-1.038 1.01-1.042 1.008.739.698c.409.38.818.939.914 1.246.26.808.499.679 1.365-.753zm22.866-.51c-.253-.72-.543-2.288-.645-3.488-.101-1.2-.291-2.181-.419-2.181s-.633.335-1.118.744c-.802.675-.872.879-.748 2.17.12 1.247.327 1.609 1.647 2.862.828.79 1.562 1.383 1.626 1.322.064-.066-.091-.707-.345-1.428zm-388.202-.43c.778-.886.938-1.317.938-2.535 0-1.225-.13-1.564-.789-2.083-1.118-.879-1.305-.785-1.311.652-.004.699-.208 2.216-.451 3.37a79.246 79.246 0 0 0-.443 2.18c0 .293 1.263-.68 2.056-1.582zm6.482.487c1.933-.878 3.939-3.349 4.617-5.688.585-2.002 1.066-4.83.827-4.83-.523 0-6.316 2.754-7.18 3.413-2.116 1.616-3.273 5.389-2.142 7 .587.838 2.176.878 3.88.103zm377.085-.04c.769-.766.785-2.706.04-4.34-.718-1.57-2.44-3.214-4.181-3.983-3.966-1.756-4.938-2.156-5.022-2.076-.286.286.61 4.491 1.251 5.9 1.777 3.883 6.078 6.332 7.91 4.5zm-394.174-1.53c.275-.839.459-1.561.41-1.601a10.447 10.447 0 0 0-1.087-.408c-.912-.307-1.052-.267-1.71.48-.875.99-.899 1.173-.188 1.397.305.1.866.513 1.25.922.383.409.726.742.762.742.036 0 .29-.688.563-1.53zm410.294-.266c.539 0 .42-.343-.423-1.222-.773-.806-1.01-.814-2.747-.107-.04.016.14.658.4 1.423l.479 1.393.972-.743c.535-.41 1.13-.744 1.32-.744zm-379.656-1.066c1.423-.994.266-4.902-1.976-6.678-1.211-.959-6.008-3.34-6.161-3.06-.056.095.08 1.044.299 2.103.952 4.551 3.393 7.366 7.014 8.074.088.016.459-.18.824-.439zm6.77-.12c1.338-.509 3.074-2.359 3.869-4.131.774-1.721 1.361-4.264.984-4.264-.789 0-5.226 2.036-6.092 2.799-1.764 1.55-2.758 4.576-1.812 5.524.43.432 2.008.47 3.05.074zm335.852-.439c.46-1.01.1-2.58-.918-3.986-1.004-1.385-2.315-2.26-4.559-3.048a76.147 76.147 0 0 1-2.175-.792c-.52-.214-.551-.13-.355 1.086.652 4.081 3.584 7.42 6.546 7.453.913.01 1.194-.13 1.461-.713zm7.2-.144c1.585-1.006 2.946-2.844 3.659-4.938.55-1.624.958-4.072.672-4.072-.419 0-5.163 2.456-6.054 3.134-1.846 1.41-3.187 5.37-2.17 6.387.648.645 2.436.411 3.893-.51zm-384.765.26c1.76-.942-.531-4.495-3.773-5.848-1.058-.444-6.732-1.418-6.954-1.198-.45.451 2.65 4.487 4.351 5.665 2.204 1.525 4.984 2.127 6.376 1.383zm421.232-.739c1.964-.992 4.16-3.165 4.994-4.938.349-.738.61-1.377.578-1.409-.123-.136-5.854.818-6.578 1.094-3.27 1.243-5.845 4.956-4.158 6 .822.509 3.433.134 5.162-.745zm-415.185-1.297c2.176-1.437 3.338-4.417 3.168-8.138-.06-1.287-.2-2.435-.313-2.549-.31-.309-4.036 3.094-5.03 4.6-1.288 1.94-1.563 5.029-.56 6.235.47.566 1.757.499 2.735-.148zm407.08-.838c.586-1.69.05-4.106-1.267-5.745-1.357-1.684-4.38-4.363-4.634-4.105-.12.115-.216 1.582-.216 3.253 0 2.715.09 3.226.819 4.717.986 1.996 2.634 3.327 3.972 3.201.758-.07.966-.28 1.329-1.325zm-395.966-.128c.3-.507.495-.948.44-.984-1.406-.862-1.777-.898-2.436-.232l-.665.679.899.727c.493.399.97.728 1.057.728.088 0 .404-.413.705-.918zm384.31-.589c0-.108-.265-.439-.59-.73-.511-.465-.713-.487-1.497-.16-1.072.44-1.098.575-.29 1.6l.619.785.878-.649c.483-.359.878-.738.878-.848zm-20.924-1.836c.348-.485.58-.922.523-.972-.792-.65-1.329-.669-2.185-.07a48.223 48.223 0 0 1-1.038.71c-.064.037.265.62.732 1.298.805 1.162.867 1.194 1.098.573.13-.36.523-1.054.868-1.537zm-342.881.798.712-1.042-.71-.593c-.739-.618-2.196-.812-2.491-.335-.16.264 1.317 2.994 1.632 3.006.084.004.47-.459.859-1.038zm379.61-1.633.978-.664-.699-.551c-.535-.42-1.008-.511-1.97-.383-1.397.187-1.321-.088-.759 2.822l.186.938.639-.748a9.82 9.82 0 0 1 1.625-1.414zm-415.684-.347.2-1.084-1.238-.165c-.882-.12-1.485-.016-2.1.36l-.864.526 1.487.966c.819.531 1.581 1.114 1.697 1.297.24.388.519-.267.818-1.896zm12.769 1.67c.99-1.19-.276-4.504-2.57-6.726l-1.39-1.347.195 2.096c.106 1.154.05 2.828-.124 3.724-.375 1.93-.047 2.487.815 1.388.333-.424.674-.769.758-.769.084 0 .431.471.77 1.048.685 1.158.979 1.271 1.546.589zm389.432-1.227c.359-.539.389-.533.858.114.838 1.158 1.357.87 1.092-.599-.126-.698-.206-2.415-.18-3.816l.052-2.545-1.437 1.557c-2.44 2.635-3.363 5.38-2.202 6.543.547.543.683.449 1.817-1.254zm-383.848.773c2.503-.938 4.487-3.294 5.49-6.513.578-1.864.894-4.958.514-5.09-.125-.044-1.577.61-3.217 1.453-3.48 1.789-5.14 3.43-5.836 5.769-.64 2.15-.567 3.105.289 3.96.798.802 1.467.904 2.758.419zm379.137-.465c.294-.294.433-.972.41-2.012-.047-1.936-1.138-4.218-2.655-5.55-.934-.817-6.064-3.636-6.627-3.636-.106 0-.124.978-.04 2.172.22 3.187 1.186 5.421 3.194 7.42 2.271 2.26 4.43 2.865 5.716 1.604zm-358.179-1.637c1.138-.425 3.006-2.265 3.733-3.669.77-1.497 1.133-4.263.527-4.04-.232.086-1.324.456-2.427.819-1.102.363-2.45.958-2.994 1.317-1.082.719-2.336 2.898-2.336 4.06 0 1.577 1.551 2.247 3.497 1.517zm337.25-.311c.472-.471.584-.853.452-1.521-.319-1.607-1.157-2.98-2.26-3.709-.863-.57-5.06-2.223-5.648-2.223-.327 0 .3 2.924.879 4.123 1.53 3.162 4.993 4.914 6.578 3.33zm-342.857-.26c1.342-.718.935-3.513-.79-5.419-.635-.707-1.956-1.607-3.25-2.221-2.987-1.418-2.967-1.418-2.88-.004.2 3.257 2 6.29 4.372 7.369 1.397.634 1.792.678 2.546.273zm348.513-.467c1.972-1.018 3.553-3.812 3.816-6.766l.16-1.757-2.186 1.012c-3.972 1.836-5.38 3.433-5.383 6.084 0 1.166.132 1.637.525 1.866.579.343 1.926.152 3.068-.439zm-386.203-.15c1.058-.568.56-2.686-.964-4.071-1.409-1.284-2.698-1.697-5.718-1.845-3.41-.163-3.457-.105-1.876 2.246 1.742 2.587 3.988 3.952 6.536 3.972.795.004 1.705-.13 2.022-.3zm425.06-.153c2.396-.998 4.685-3.228 5.284-5.15.204-.653.146-.675-1.742-.675-2.527 0-4.707.48-5.929 1.302-1.995 1.347-3.013 3.964-1.816 4.662.785.46 2.942.386 4.204-.14zm-420.29-.585c1.937-1.002 3.3-4.152 3.29-7.625-.008-2.874-.273-2.878-3.108-.008-2.694 2.735-3.403 4.166-3.067 6.228.299 1.856 1.187 2.285 2.888 1.407zm413.28.273c.252-.1.614-.642.8-1.21.498-1.5-.085-3.592-1.454-5.235-1.577-1.896-3.922-3.984-4.18-3.724-.12.12-.205 1.407-.191 2.858.02 2.29.14 2.87.898 4.391 1.138 2.284 2.775 3.437 4.126 2.914zm-399.555-1.944c.385-.838.655-1.549.599-1.58-.838-.508-2.415-.775-2.934-.496-.335.18-.61.412-.61.52 0 .265 1.91 3.061 2.095 3.07.086.003.467-.68.852-1.514zm385.917-.008c.944-1.443.966-1.537.45-1.94-.3-.231-.813-.343-1.142-.25-.33.096-.909.248-1.288.34-.373.088-.642.25-.599.36.052.107.36.83.69 1.606.328.778.666 1.41.748 1.407.083 0 .598-.688 1.143-1.523zm-394.72-2.044c.29-.319.44-.724.328-.898-.22-.363-1.058-.439-1.062-.094 0 .12-.085.527-.185.899-.22.826.22.87.918.093zm402.44.106a3.054 3.054 0 0 1-.179-.898c0-.495-.77-.573-1.058-.108-.211.34.663 1.477 1.138 1.477.156 0 .2-.213.1-.473zm-397.16-1.333c.765-.41.749-1.836-.04-3.573-1.391-3.064-3.068-4.423-7.93-6.433l-3.163-1.307.203.946c.114.523.54 1.848.944 2.95.809 2.187 1.07 2.281 2.176.786.619-.838.712-.874.982-.393.459.822 1.112 3.485 1.118 4.559 0 1.098.698 1.69 2.76 2.335 1.593.5 2.212.525 2.948.13zm26.507-.805c1.098-1.636 1.217-3.832.34-6.221-.384-1.038-3.83-6.138-4.148-6.138-.12 0-.46.707-.765 1.571-.393 1.128-.539 2.375-.523 4.417.03 3.302.565 5.038 2.004 6.523 1.206 1.244 2.186 1.194 3.09-.151zm340.774.374c.483-.411 1.197-1.457 1.587-2.324.998-2.23 1.008-6.862.024-9.041-.384-.853-.773-1.358-.918-1.198-.14.152-1.012 1.393-1.937 2.758-2.155 3.178-2.794 5.25-2.309 7.433.4 1.793 1.297 3.11 2.116 3.11.303 0 .95-.333 1.437-.738zm26.852.14c2.255-.775 2.549-1.05 2.549-2.376 0-1.165.782-4.181 1.197-4.614.13-.14.547.163.924.672.38.511.85.928 1.052.928.32 0 1.457-2.608 2.062-4.716.246-.85.08-.842-2.255.106-2.964 1.203-5.25 2.425-6.348 3.389-1.924 1.688-3.349 5.25-2.638 6.579.425.79 1.237.798 3.459.034zm-386.961-.72c2.463-1.628 4.191-5.015 4.656-9.135.112-1.002.12-1.822.012-1.822-.469 0-6.157 3.022-6.96 3.697-1.51 1.269-2.628 3.678-2.642 5.682-.008 1.403.108 1.83.589 2.196.85.634 2.894.345 4.347-.62zm380.933.574c1.437-1.437.555-5.164-1.77-7.49-.963-.957-6.919-4.239-7.198-3.961-.064.066.02 1.177.18 2.475.327 2.563 1.453 5.33 2.834 6.966 1.645 1.942 4.916 3.048 5.952 2.01zm-402.27-1.052c.858-1.637-.312-5.848-2.33-8.391-.852-1.078-4.221-3.585-4.816-3.585-.4 0-.31 2.587.168 4.842.59 2.785 1.812 5.116 3.519 6.713 1.672 1.56 2.794 1.696 3.46.419zm422.541-.2c2.24-2.026 3.637-5.253 4.038-9.335.24-2.425.18-2.48-1.703-1.523-2.698 1.377-4.974 4.605-5.688 8.07-.286 1.37-.26 1.826.134 2.764.634 1.497 1.576 1.503 3.217.024zm-419.056-2.415c.215-.507-1.996-6.84-3.274-9.377-1.247-2.481-2.349-3.776-4.75-5.589a48.638 48.638 0 0 1-2.838-2.301l-1.014-.928.18 1.197c.327 2.176 2.205 5.324 5.021 8.433 3.054 3.374 4.098 5.234 4.557 8.158l.323 2.066.819-.647c.447-.355.884-.812.972-1.018zm31.177 1.192c-1.258-3.234-1.258-6.092.01-9.886.4-1.198.727-2.41.727-2.695-.006-.593-2.416-3.685-2.723-3.493-.112.068-.507 1.238-.878 2.599-.719 2.63-.946 6.866-.491 9.062.34 1.64-.18 1.028-.886-1.05-.743-2.176-.747-7.91-.008-10.906l.51-2.072-2.928-3.054c-1.606-1.677-3.073-3.066-3.25-3.088-.179-.02-.498.533-.708 1.234a17.11 17.11 0 0 1-.966 2.423c-.319.635-.539 1.201-.479 1.261.06.06.71-.29 1.443-.778l1.338-.882.09 2.167a21.49 21.49 0 0 1-1.134 7.625c-.308.868-.455 1.58-.33 1.58.126 0 .978-.538 1.9-1.197.923-.658 1.769-1.197 1.889-1.197.465 0-.16 5.638-.91 8.2-.43 1.462-.729 2.708-.671 2.766.06.06.425-.226.81-.64.899-.953 1.497-.953 1.497 0 0 .416.136.751.3.751.165 0 .3-.27.3-.598 0-.803.139-.767 1.596.41 2.267 1.833 4.405 2.623 3.952 1.458zm351.239.203c.463-.18 1.543-.85 2.401-1.497.858-.646 1.625-1.177 1.703-1.177.077 0 .191.303.26.672.119.703.213.583.678-.872.134-.415.333-.33 1.197.507.571.555 1.038.878 1.038.725-.006-.156-.351-1.362-.772-2.679-.52-1.617-.823-3.403-.942-5.497l-.174-3.102 1.876 1.382c1.032.758 1.982 1.38 2.112 1.38.132 0-.088-1.023-.487-2.275-.818-2.574-1.583-9.101-1.068-9.101.08 0 .799.405 1.605.898.798.495 1.51.898 1.577.898.066 0-.264-.707-.727-1.57-.459-.865-.928-2.013-1.042-2.548-.111-.535-.299-.972-.419-.972-.225 0-6.327 6.104-6.32 6.32 0 .063.207.858.454 1.764 1.062 3.908.858 9.455-.46 12.335l-.588 1.288.22-1.797c.339-2.79.143-6.062-.525-8.672-.336-1.312-.715-2.49-.845-2.615-.13-.132-.858.57-1.608 1.557l-1.378 1.796.847 2.44c1.114 3.213 1.353 5.594.798 7.89-.24.987-.535 2.031-.659 2.319-.255.609.05.658 1.248.203zm31.94-1.543c.289-2.754 1.53-5.03 4.53-8.303 1.977-2.156 2.905-3.473 3.913-5.549.732-1.497 1.327-3.024 1.327-3.385 0-.579-.26-.45-2.156 1.064-3.493 2.794-5.225 4.67-6.327 6.866-1.377 2.735-3.573 9.002-3.313 9.457.28.5 1.423 1.677 1.648 1.697.1.012.27-.819.38-1.843zm-373.03.44c.104-.452 1.27-3.541 2.587-6.867 4.81-12.12 5.35-18.051 2.096-23.081-2.016-3.11-9.956-10.898-20.379-19.98-15.399-13.419-19.968-18.028-22.499-22.698l-1.004-1.847-.1 1.198c-.131 1.613.316 4.55 2.088 13.728.825 4.258 1.438 7.805 1.358 7.879-.076.075-3.461.25-7.525.387-4.058.136-7.445.313-7.525.393-.08.08 1.645 1.397 3.832 2.924 19.028 13.273 33.798 26.766 40.95 37.405 2.068 3.074 4.295 7.465 4.982 9.816.51 1.753.854 1.976 1.142.749zm330.827-.899c3.846-12.506 21.293-30.207 47.568-48.258 1.277-.883 2.255-1.671 2.175-1.753-.083-.084-3.443-.233-7.469-.333-4.023-.1-7.405-.274-7.516-.384-.112-.11.41-3.413 1.161-7.335 2.192-11.457 2.68-15.065 2.044-15.065-.13 0-.519.572-.858 1.271-1.99 4.072-8.11 10.367-20.293 20.87-10.166 8.762-19.401 17.559-21.743 20.708-2.534 3.401-2.824 4.316-2.778 8.647.056 4.854.759 7.565 4.132 15.968 1.407 3.509 2.56 6.606 2.56 6.882 0 1.048.512.439 1.019-1.218zm-359.682-1.9c.345-.672.582-1.263.53-1.31-.051-.047-.646-.362-1.317-.702l-1.225-.619-.651.647-.645.645 1.262 1.283c.692.705 1.293 1.282 1.337 1.282.044 0 .365-.553.709-1.228zm390.018-1.97-.582-.653-1.238.633a35.668 35.668 0 0 0-1.341.699c-.054.04.207.609.585 1.263l.682 1.188 1.238-1.238c1.23-1.237 1.23-1.237.653-1.89zm-386.581-2.036c1.616-.942 2.882-2.595 3.726-4.85.625-1.665 1.342-5.748 1.058-6.028-.084-.084-1.467.503-3.074 1.306-3.489 1.742-5.435 3.532-6.16 5.662-1.49 4.377.57 6.188 4.452 3.912zm384.693.573c1.483-1.483.36-5.8-2.032-7.81-.688-.579-4.906-2.918-6.594-3.659-.15-.066-.2.85-.114 2.092.291 4.176 2.235 7.65 5.07 9.062 1.784.892 2.994.994 3.672.313zm-391.687-.325c1.637-1.483-.709-6.108-3.918-7.72-1.593-.803-6.553-2.422-6.767-2.212-.223.227.743 3.233 1.553 4.84 2.06 4.064 7.14 6.896 9.134 5.094zm398.318-.006c1.942-.665 4.221-2.96 5.489-5.53.886-1.807 1.557-4.45 1.13-4.45-.64 0-5.889 1.912-6.938 2.529-3.014 1.764-4.964 5.836-3.55 7.405.62.678 1.947.698 3.867.044zM254.66 266.56c-1.29-.659-1.223-.659-2.082.056l-.698.578 1.126 1.348 1.127 1.347.799-1.393.798-1.393-1.066-.543zm393.648.654c0-.08-.336-.395-.747-.694-.722-.527-.784-.527-1.892 0l-1.146.545.779 1.409.778 1.409 1.114-1.257c.609-.693 1.11-1.328 1.112-1.41zm-408.198-3.008c-.416-1.722-.759-3.243-.759-3.38 0-.14.415.095.922.522.87.733 1.657 1.038 1.41.55-1.558-3.04-2.092-4.897-2.466-8.564l-.175-1.748 1.068.665c.588.363 1.145.584 1.237.493.094-.094-.918-1.358-2.247-2.809-1.332-1.449-3.064-3.505-3.853-4.57l-1.437-1.929-.086 2.83c-.153 5.09 1.406 10.835 4.807 17.711 1.163 2.355 2.167 4.076 2.23 3.822.06-.253-.23-1.87-.647-3.593zm421.52.01c3.374-6.926 5.06-13.183 4.9-18.131l-.09-2.63-1.677 2.225a68.702 68.702 0 0 1-3.853 4.557c-1.203 1.281-2.105 2.407-2.01 2.503.096.095.651-.12 1.238-.483.583-.36 1.064-.54 1.064-.4s-.136 1.35-.306 2.687c-.347 2.774-1.171 5.397-2.107 6.714-.855 1.202-.635 1.318.734.388.619-.423 1.186-.715 1.252-.647.065.066-.216 1.5-.625 3.188-1.258 5.203-1.034 5.209 1.483.036zm-410.173 1.03c1.517-1.517-.531-5.996-3.563-7.772-1.517-.888-6.5-2.88-6.7-2.68-.252.253.544 3.247 1.29 4.858 1.89 4.075 7.186 7.379 8.97 5.596zm6.433-.115c2.335-1.19 5.11-5.35 5.596-8.384.236-1.473-.267-2.107-1.666-2.107-1.99 0-5.47 2.924-6.912 5.808-1.102 2.202-1.144 3.539-.15 4.53.884.893 1.613.927 3.13.153zm387.607-.148c.949-.948.95-2.236.004-4.264-.924-1.984-2.882-4.111-4.802-5.21-1.776-1.021-2.85-1.097-3.613-.259-.493.55-.51.759-.183 1.984.932 3.493 3.333 6.903 5.577 7.92 1.608.733 2.145.703 3.017-.171zm6.595.233c1.892-.644 4.531-3.241 5.575-5.489.814-1.756 1.647-4.682 1.397-4.93-.203-.205-5.162 1.77-6.706 2.675-3.054 1.788-5.016 6.062-3.537 7.696.618.68 1.377.69 3.27.046zm-397.172-8.083c0-.04-.505-.226-1.124-.408-.908-.269-1.337-.24-2.261.148l-1.138.48.87 1.113c.48.613 1.038 1.437 1.246 1.828.369.699.399.67 1.393-1.183.559-1.044 1.014-1.937 1.014-1.976zm392.809 3.213c0-.15.471-.89 1.046-1.643l1.042-1.367-1.082-.45c-.882-.37-1.298-.39-2.25-.1-.642.189-1.13.426-1.085.524.048.096.487.878.982 1.745.838 1.457 1.347 1.95 1.347 1.291zm-396.668-5.143c.773-.77.64-2.096-.419-4.144-1.064-2.076-3.066-3.403-7.036-4.677-1.868-.598-3.457-1.026-3.532-.952-.272.274 1.077 4.012 1.946 5.373 2.487 3.92 7.217 6.222 9.041 4.398zm402.937-.406c2.515-1.273 4.805-4.33 5.888-7.864.414-1.351.19-1.782-.698-1.337-.29.148-1.405.505-2.475.798-2.663.725-4.59 1.75-5.98 3.182-1.268 1.307-2.27 3.76-1.99 4.878.38 1.513 2.655 1.663 5.257.343zm-397.214.426c1.078-.3 3.227-2.016 3.227-2.583 0-.154-1.09-1.258-2.423-2.45-1.84-1.642-2.519-2.087-2.814-1.844-.619.511-1.667 3.206-1.848 4.75-.27 2.268.938 2.935 3.858 2.123zm390.089-.18c.604-.735.45-3.03-.326-4.81-1.088-2.507-1.163-2.507-3.812-.06-1.285 1.185-2.385 2.28-2.443 2.427-.17.433 1.9 2.204 2.988 2.55 1.565.5 3.124.452 3.593-.111zm-393.754-6.02.938-1.72-.978-.825c-1.17-.982-1.287-.994-2.267-.223-.42.329-1.01.598-1.317.598-.733 0-.715.5.036.967.327.203 1.028.946 1.556 1.648.53.703.986 1.278 1.024 1.278.038 0 .495-.775 1.012-1.723zm397.22-.926c1.144-1.168 1.172-1.244.428-1.244-.306 0-.898-.269-1.318-.598-.982-.77-1.097-.759-2.267.225l-.978.823.958 1.766.962 1.764.619-.866c.34-.479 1.058-1.317 1.6-1.87zm-357.685-4.77c1.676-7.254 2.341-9.807 2.98-11.43.345-.874.559-1.656.473-1.74-.22-.22-2.18 1.321-3.892 3.064-1.757 1.79-4.655 6.167-5.565 8.413l-.649 1.6.649.913c.738 1.034 1.144 1.146 1.409.385 1.05-3.014 3.565-8.084 3.866-7.784.07.07-.479 2.463-1.223 5.32l-1.348 5.193.669.714.673.715.507-.625c.28-.345.932-2.475 1.453-4.736zm318.067 3.123c-.586-1.844-2.487-9.6-2.375-9.71.26-.26 1.972 2.874 3.04 5.573l1.108 2.794.918-.922.924-.918-1.297-2.625c-1.757-3.553-3.457-5.864-6.188-8.411-2.161-2.024-3.078-2.615-2.722-1.769.692 1.645 2.143 6.793 2.894 10.254.978 4.519 1.676 6.946 2.191 7.593.491.612 1.789-.984 1.51-1.86zm-360.737-1.397c.299-.327.487-.643.419-.699-2.326-1.852-11.521-8.211-11.589-8.01-.215.65 1.657 3.61 3.477 5.496 2.046 2.12 4.87 3.816 6.347 3.816.44 0 1.048-.27 1.346-.599zm403.996-.152c2.086-.97 5.645-4.53 6.727-6.726.447-.906.686-1.689.535-1.736-.24-.08-2.495 1.496-9.89 6.922l-1.623 1.191.683.551c.906.739 1.646.695 3.572-.2zm-368.711-7.876c.265-.712.367-1.251.227-1.197-.38.146-3.327 3.437-3.327 3.718 0 .132.439.69.968 1.238l.97 1.002.34-1.733c.185-.954.558-2.315.824-3.03zm332.578 2.156c-.168-.307-.998-1.234-1.848-2.056l-1.537-1.497.605 1.547c.333.854.698 2.247.81 3.1l.206 1.547 1.038-1.038c.846-.849.978-1.138.726-1.597zm-332.09-5.689c0-.97-5.696-.694-8.45.408l-1.238.495 2.375 2.175 2.376 2.176 2.467-2.447c1.357-1.346 2.47-2.611 2.47-2.807zm336.07 3.038c2.355-2.163 2.347-2.335-.126-2.986-2.27-.598-7.205-.702-7.205-.151 0 .43 4.505 5.09 4.906 5.07.183-.006 1.277-.879 2.425-1.933zm-345.259-4.287c-1.317-1.012-3.984-1.669-3.984-.978 0 .144.46.668 1.018 1.161.964.845 1.09.879 2.266.563 1.137-.305 1.197-.367.698-.746zm350.48-.174c.4-.429.633-.79.524-.806-1.126-.152-2.15.014-3.034.49-.585.314-1.062.66-1.062.76 0 .339 1.936.784 2.395.554.247-.124.778-.573 1.178-.998zm-343.408-1.587c2.435-1.177 6.595-5.588 5.912-6.273-.307-.307-7.365.43-9.128.954-1.782.53-3.686 2.07-4.251 3.433-.311.753-.294 1.014.12 1.64.265.41.854.827 1.307.927.45.1.952.232 1.118.295.728.28 3.433-.259 4.918-.978zm340.185-.075c.71-.879.693-1.21-.13-2.43-1.585-2.355-4.183-3.305-10.173-3.724-3.47-.24-3.523-.168-1.581 2.305 1.323 1.681 3.956 3.7 5.698 4.364 2.088.798 5.346.523 6.188-.52zm-349.017-1.577c.299-.427.469-1.324.469-2.487 0-2.55-.922-4.228-4.012-7.296l-2.53-2.514-.384 1.317c-.62 2.124-.465 5.54.335 7.389 1.421 3.28 4.91 5.325 6.124 3.593zm353.444.223c1.292-.668 2.926-2.754 3.503-4.47.283-.839.515-2.404.515-3.474 0-1.924-.539-4.191-.992-4.191-.479 0-4.994 4.98-5.565 6.137-.718 1.457-.832 5.158-.18 5.942.508.613 1.593.635 2.715.054zm-388.154-2.708c-1.152-1.058-2.19-1.93-2.304-1.936-.11 0 0 .598.256 1.341.572 1.677 1.628 2.549 3.063 2.535l1.082-.014-2.095-1.926zm420.373 1.51a2.635 2.635 0 0 0 1.505-1.524c.823-1.976.352-1.968-1.826.024-1.747 1.597-1.982 1.916-1.411 1.928.373.006 1.153-.186 1.73-.427zm-413.487-.832c-.088-.37-.4-1.886-.693-3.369l-.53-2.694-1.753-.22c-.966-.12-2.066-.423-2.447-.673-.925-.604-1.014-.578-1.014.28 0 1.237 1.151 3.904 2.175 5.044 1.024 1.137 2.994 2.305 3.888 2.305.404 0 .495-.168.376-.673zm408.477-.105c1.747-.87 2.982-2.416 3.753-4.697.487-1.425.638-2.609.33-2.609-.089 0-.48.21-.875.467-.393.26-1.471.547-2.39.643-1.385.14-1.7.28-1.822.802-.08.35-.349 1.643-.598 2.879-.252 1.233-.531 2.48-.62 2.768-.227.735.376.667 2.22-.253zm-388.278-1.563c-1.038-2.745-.778-5.4 1.018-10.375.42-1.15.709-2.136.653-2.192-.06-.06-.695.34-1.418.888a47.159 47.159 0 0 1-2.011 1.457l-.705.46.36 3.101c.199 1.707.273 3.757.159 4.561-.192 1.417-.16 1.497 1.038 2.695.678.678 1.291 1.171 1.367 1.097.076-.073-.132-.838-.46-1.692zm367.28.183c.172-.215.4-2.14.508-4.281.105-2.14.271-4.32.367-4.84.153-.839.064-1.008-.753-1.43-.507-.263-1.4-.898-1.986-1.41-.584-.514-1.117-.879-1.185-.809-.068.068.22 1.062.632 2.21 1.803 4.986 2.06 7.624 1.01 10.39-.327.867-.598 1.617-.598 1.671 0 .166 1.686-1.097 2.008-1.505zm-354.811-1.437c.24 0 .144-.409-.28-1.197-.447-.819-.794-1.142-1.101-1.022a9.68 9.68 0 0 1-1.445.339c-.839.144-.97.271-.825.798.096.35.26 1.126.36 1.729l.18 1.094 1.372-.87c.759-.48 1.541-.87 1.74-.87zm344.582-1.23c.144-.452.03-.566-.569-.566a5.07 5.07 0 0 1-1.489-.28c-.654-.25-.782-.18-1.103.6-.2.478-.485.877-.63.877-.604 0-.199.55.54.735.439.11 1.211.525 1.716.924l.924.723.216-1.218c.116-.675.295-1.477.393-1.792zM264.2 221.276c0-1.391-.12-2.6-.263-2.69-.392-.24-1.777.943-2.308 1.975-.459.89-.453.91.767 2.07.678.645 1.357 1.172 1.517 1.172.16 0 .287-1.118.287-2.527zm373.408 1.417c1.368-1.331 1.417-1.948.264-3.106-1.517-1.517-1.82-1.237-1.82 1.67 0 1.398.093 2.546.211 2.546s.725-.5 1.347-1.108zm-350.578-.467c.864-.4 2.028-1.11 2.589-1.583 1.05-.888 2.722-3.022 2.722-3.473 0-.45-6.36-.287-8.023.206-2.476.734-4.555 3.297-3.743 4.602.884 1.418 3.673 1.523 6.453.248zm332.131.24c.66-.432.759-.67.61-1.462-.248-1.32-2.484-3.317-4.196-3.752-1.362-.34-7.665-.479-7.665-.166 0 .575 2.024 2.94 3.34 3.905 2.89 2.125 6.031 2.71 7.915 1.477zm-356.534-4.501c.551-.348.958-.859.962-1.212.012-.575-.16-.613-2.68-.599l-2.691.014v1.186c-.004.958.204 1.397 1.098 2.315l1.108 1.13.624-1.118c.346-.619 1.058-1.39 1.577-1.716h.004zm15.355 2.538c.729-.389 1.294-2.479 1.038-3.844-.323-1.716-1.181-3.102-3.389-5.457l-2.08-2.215-.485 1.624c-.263.895-.483 2.184-.483 2.865 0 2.654 1.387 5.58 3.214 6.786.948.625 1.383.673 2.185.243zm346.283-.269c2.148-1.307 3.619-4.559 3.307-7.301a19.826 19.826 0 0 0-.522-2.747l-.346-1.191-2.048 2.147c-2.183 2.296-3.067 3.739-3.4 5.57-.332 1.831.638 4.103 1.756 4.097.173 0 .738-.26 1.257-.575zm16.786-.679c.779-.754.99-1.203.99-2.095v-1.142h-1.756c-.968 0-2.182-.084-2.695-.188-.838-.167-.938-.114-.924.525.006.465.34.918.968 1.312.527.33 1.228 1.032 1.557 1.56.33.53.667.959.739.967.075.006.578-.42 1.125-.945zm-397.51-.858c0-.172-.189-.683-.423-1.138-.532-1.024-1.44-4.479-1.297-4.916.06-.18.411.48.782 1.467.751 2.006 2.436 4.735 2.436 3.946 0-1.077-1.527-8.848-1.996-10.123-.719-1.97-2.036-3.753-3.088-4.192-.507-.207-.99-.311-1.074-.23-.08.084-.01 1.348.16 2.811.17 1.461.439 4.046.59 5.742.324 3.56 1.05 5.39 2.507 6.324 1.078.69 1.406.762 1.406.31zm415.19-.984c1.264-1.343 1.564-2.451 2.037-7.535.231-2.469.509-4.996.614-5.614.17-.959.12-1.122-.345-1.122-.914 0-3.237 2.686-3.78 4.371-.619 1.916-2.126 9.906-1.956 10.39.067.199.742-.855 1.497-2.336 1.566-3.058 1.896-2.605.658.898a72.669 72.669 0 0 0-.738 2.142c0 .026.25-.02.559-.1.313-.08.968-.575 1.457-1.098zm-38.546-.764v-1.765l-1.121-.145c-.753-.1-1.404.026-1.972.373l-.85.519 1.686.95c.926.525 1.76 1.15 1.852 1.391.304.792.405.465.405-1.323zM280.848 218c.084-.225.839-.784 1.677-1.237l1.521-.83-.715-.55c-.654-.502-1.696-.546-3.113-.129-.374.11-.192 3.158.19 3.158.151 0 .349-.186.438-.412zm-23.532-1.125c0-.352-.276-1.084-.613-1.629-.539-.87-.758-.988-1.784-.946-1.144.044-1.162.064-.679.659.689.854 2.58 2.545 2.85 2.55.12 0 .224-.283.224-.634zm387.572-.859c.838-.848 1.283-1.496 1.038-1.5-.244 0-.727-.08-1.074-.176-.493-.132-.779.064-1.274.864-.632 1.024-.858 2.31-.403 2.31.132 0 .898-.675 1.713-1.497zm-373.399-.073c-.21-1.134-1.624-3.819-2.008-3.819-.479 0 .126 2.525.879 3.669.912 1.383 1.373 1.445 1.131.15zm359.145-2.004c.16-.743.208-1.477.114-1.629-.267-.44-1.846 2.848-1.85 3.852l-.004.898.73-.888c.4-.493.859-1.497 1.014-2.235zm-368.065.718c3.244-.832 6.074-3.413 7.475-6.812l.467-1.134-1.583.18c-5.061.585-6.203.812-7.664 1.525-3.513 1.71-4.782 5.583-2.088 6.361 1.371.395 1.397.393 3.393-.12zm28.377-.824c.878-.4 1.944-1.082 2.375-1.511 1.204-1.206 2.425-2.894 2.232-3.084-.36-.36-6.952-.26-8.02.12-1.212.431-2.906 1.964-3.293 2.978-.879 2.311 3.028 3.182 6.706 1.497zm324.36.227c2.05-1.34-.791-4.55-4.456-5.03-1.643-.215-6.227.088-6.227.412 0 .433 2.734 3.257 3.778 3.902 2.375 1.469 5.3 1.772 6.906.718zm26.77.128c.798-.794.608-2.02-.57-3.706-1.217-1.745-3.46-2.789-6.796-3.154a390.57 390.57 0 0 1-3.667-.427c-1.249-.164-1.273.351-.11 2.38 1.063 1.847 3.518 4.183 5.206 4.95 1.843.838 5.086.814 5.938-.04zM282 213.344c.705-.778.924-2.735.483-4.311-.411-1.47-4.16-6.653-4.535-6.276-.135.132-.465 1.102-.732 2.152-.779 3.044.012 6.295 1.986 8.14 1.084 1.012 2.056 1.117 2.794.299zm338.978-.393c.61-.535 1.377-1.581 1.704-2.322.799-1.804.81-5.053.02-6.814l-.569-1.273-1.473 1.85c-2.095 2.635-2.886 4.192-3.053 6.004-.174 1.826.632 3.527 1.668 3.527.326 0 1.09-.44 1.7-.972zm-364.652-.715c.758-1.157.619-3.579-.306-5.389-.758-1.471-2.235-3.026-5.333-5.609l-1.696-1.41-.354 2.1c-.698 4.167.93 8.196 4.14 10.232 1.74 1.104 2.86 1.128 3.549.08zm390.72.16c2.378-1.152 4.121-3.904 4.596-7.27.224-1.564-.05-4.51-.455-4.916-.074-.073-.848.443-1.72 1.152-4.64 3.776-5.925 5.655-5.925 8.659 0 1.407.132 1.936.6 2.405.758.758 1.289.752 2.903-.028zm-374.966-2.162c.431-1.764.47-2.36.188-3.068l-.352-.878-.538 1.497c-.759 2.096-.765 4.64-.012 4.64.095 0 .415-.985.71-2.19zm357.367.451c-.024-1.613-.958-4.54-1.278-4.022-.383.62-.293 2.29.22 4.052.587 2.008 1.094 1.996 1.058-.03zm-368.898-3.177.978-.495-.85-.719c-.704-.59-1.066-.685-2.128-.539-1.121.148-1.257.246-1.103.799.095.349.26 1.145.365 1.772l.19 1.138.784-.729a9.213 9.213 0 0 1 1.764-1.225zm382.245-1.07c.14-.445-.044-.555-1.112-.659-1.012-.096-1.433.016-1.984.527l-.702.649 1.021.628c.56.346 1.282.919 1.597 1.27l.58.639.215-1.258c.12-.692.291-1.5.385-1.796zm-367.297.525c.016-1.03.352-3.254.745-4.936.67-2.87.748-3.034 1.221-2.565.274.28.56.445.629.371.07-.07.224-.904.34-1.85.199-1.613.175-1.723-.408-1.723-.343 0-1.092-.41-1.664-.914l-1.044-.914-1.214.804c-.67.44-1.217.867-1.217.938 0 .08.558.044 1.241-.071l1.242-.208-.206 1.307c-.216 1.39-1.577 4.547-2.545 5.908-.57.799-.57.843-.032 2 .3.651.559 1.018.575.809.04-.625.545-.42.732.3.172.654 1.278 2.62 1.477 2.62.054 0 .11-.842.124-1.87zm11.417 1.143c2.3-1.187 4.72-5.1 5.45-8.802.508-2.595.203-2.83-1.98-1.52-3.753 2.255-7.017 6.057-7.017 8.183 0 2.052 1.717 3.088 3.55 2.14zm328.764-.01c1.513-.778 1.625-2.285.34-4.524-.48-.839-1.623-2.208-2.543-3.048-1.976-1.805-5.122-3.787-5.573-3.51-.738.46.583 5.25 2.092 7.605 1.493 2.328 2.678 3.298 4.746 3.893.048.012.471-.174.938-.414zm10.254-1.041c.407-.865.874-1.458 1.126-1.422.255.034.55-.343.718-.912.244-.83.166-1.15-.53-2.203-.993-1.497-2.264-4.787-2.264-5.857 0-.724.075-.768 1.048-.61.578.093 1.047.127 1.047.073 0-.053-.459-.443-1.017-.87l-1.018-.778-1.118.892c-.619.489-1.39.89-1.717.89-.545 0-.579.132-.389 1.557.26 1.946.455 2.27.958 1.577.224-.3.455-.49.52-.42.346.384 1.716 7.975 1.576 8.703-.27 1.338.293 1.01 1.062-.623zm-332.176-.507c1.565-.733 3.998-3.324 5.15-5.483 1.13-2.124 2.126-4.9 2.126-5.936 0-.71-.026-.719-.675-.252-1.143.824-3.589 2.042-4.81 2.395-1.148.332-1.182.38-1.9 2.882-.403 1.398-1.264 3.513-1.912 4.703-.651 1.186-1.182 2.247-1.182 2.36 0 .323 1.962-.085 3.203-.667zm315.905.564c-.054-.12-.683-1.377-1.394-2.788-.71-1.411-1.53-3.477-1.822-4.595l-.529-2.032-1.736-.586a18.417 18.417 0 0 1-3.346-1.613c-1.92-1.23-1.996-1.044-.878 2.255 1.59 4.695 4.679 8.31 7.954 9.306 1.002.303 1.87.333 1.747.053zm-341.563-2.261c1.585-.784 2.228-1.337 3.473-2.994.838-1.118 1.673-2.515 1.856-3.11l.33-1.078-2.787.196c-4.654.327-7.369 1.517-8.822 3.864-1.002 1.625-1.124 2.76-.365 3.413 1.441 1.238 3.393 1.148 6.313-.291zm370.444.036.6-.804-.827-1.689c-.864-1.776-2.401-3.148-4.172-3.733-1.024-.335-7.43-1.197-7.632-1.017-.332.283 1.962 4.141 3.193 5.369 2.04 2.03 3.932 2.854 6.327 2.754 1.683-.068 1.984-.175 2.515-.882zm-356.282-1.072c.093-.463.65-1.54 1.237-2.395.587-.854 1.068-1.6 1.068-1.663 0-.062-.539-.271-1.202-.469-.662-.197-1.66-.764-2.223-1.257-.593-.52-1.098-.767-1.206-.59-.489.791-1.066 3.408-.882 3.997.27.866 2.51 3.547 2.808 3.361.128-.08.308-.519.4-.984zm338.857-2.088c.3-.55.27-.994-.18-2.47-.299-.99-.664-1.801-.814-1.801-.15 0-.766.4-1.377.892-.61.493-1.545.978-2.076 1.084-.538.108-.97.231-.97.275 0 .046.473.787 1.052 1.645.58.858 1.134 1.916 1.238 2.351.106.433.255.905.335 1.046.16.276 2.184-1.916 2.794-3.024zm-361.272 1.95c.652-.926.595-3.672-.104-5.21-.605-1.33-2.08-2.921-5.074-5.468-2.12-1.808-2.263-1.777-2.595.627-.231 1.696.054 4.163.66 5.628 1.56 3.813 5.732 6.403 7.117 4.425zm383.673.228c1.366-.703 3.421-3.228 4.056-4.976.629-1.727.775-5.505.26-6.792-.26-.66-.364-.6-2.882 1.517-3.903 3.287-5.002 5.004-5.002 7.816 0 2.635 1.373 3.573 3.568 2.435zm-4.177-6.427c.253-.475.136-.571-.93-.739-.932-.151-1.437-.06-2.13.38-.818.519-.85.588-.323.758.323.1 1.047.659 1.612 1.246l1.03 1.061.224-1.081c.126-.595.36-1.326.519-1.627zm-376.756 1.746c.316-.347.974-.838 1.463-1.091l.894-.46-.724-.483c-.699-.463-3.603-.698-3.603-.293 0 .104.2.579.447 1.05.248.469.447 1.092.45 1.377 0 .703.383.665 1.073-.1zm26.862-2.439c1.926-.894 4.657-3.473 5.286-4.984.213-.523.329-1.012.251-1.09-.08-.08-1.856-.15-3.946-.16-4.281-.02-5.972.372-7.69 1.79-2.212 1.822-2.635 4.02-.95 4.963 1.317.739 4.904.48 7.05-.519zm328.22.495c.55-.26 1.085-.734 1.185-1.048.475-1.497-1.11-3.628-3.565-4.79-1.744-.826-2.032-.868-5.948-.868-2.267 0-4.118.074-4.118.16 0 .085.264.664.583 1.277 1.098 2.096 3.543 4.231 5.914 5.158 1.79.698 4.597.752 5.948.113zm-347.311-1.347c2.145-.804 4.515-3.126 5.788-5.675.519-1.034.882-1.936.81-2.008-.213-.213-6.355.523-7.419.887-3.225 1.107-5.938 4.724-4.8 6.4.784 1.158 3.134 1.326 5.62.396zm364.81-.124c.838-.754.742-1.892-.288-3.513-1.543-2.439-3.717-3.333-9.67-3.976-1.917-.203-1.977-.13-1.27 1.567 1.118 2.665 4.012 5.441 6.539 6.263 1.608.525 3.92.36 4.69-.339zm-371.932-1.976c.639-1.237.443-3.028-.539-4.996-.73-1.457-1.497-2.327-3.736-4.245l-2.82-2.411-.232.828c-.124.455-.23 1.908-.23 3.23 0 2.121.12 2.642 1.008 4.446 1.808 3.673 5.39 5.398 6.547 3.15zm17.185-.355c.839-1.64.665-4.036-.45-6.228-1.546-3.03-1.494-3.008-3.114-1.357l-1.418 1.441 1.314-.21 1.317-.21-.21 1.306c-.12.719-.566 2.012-1.003 2.875l-.795 1.57.61.827c1.378 1.852 2.8 1.846 3.747-.01zm342.67.615c1.038-1.158 1.058-1.386.24-3.054-.44-.894-.87-2.196-.964-2.886l-.172-1.262 1.318.21 1.31.21-1.342-1.312c-.942-.918-1.457-1.228-1.713-1.03-.203.156-.844 1.23-1.42 2.385-.78 1.55-1.055 2.49-1.055 3.573 0 1.425.633 3.158 1.314 3.613.658.43 1.888.213 2.483-.447zm17.102.25c1.038-.548 2.86-2.464 3.437-3.62.719-1.445 1.19-4.291.982-5.956-.327-2.622-.409-2.622-3.423-.044-3.958 3.384-5.255 6.234-4.098 9.006.364.869.587 1.038 1.364 1.038.51 0 1.291-.191 1.736-.423zm-354.836-4.668c.703 0 .44-.445-.57-.958-1.134-.572-2.919-.662-2.915-.145 0 .195.084.848.184 1.45l.18 1.099 1.357-.725c.748-.393 1.54-.719 1.764-.719zm332.735.787c0-.228.08-.798.171-1.274.16-.818.114-.864-.952-.918-.73-.04-1.429.16-1.996.563l-.87.619 1.597.679c1.964.83 2.048.842 2.048.33zm-352.267-.938c.539-.41 1.137-.747 1.327-.747.511 0 .42-.399-.22-.948-.307-.263-.618-.664-.698-.888-.1-.307-.24-.325-.559-.076-.234.184-.794.42-1.251.531-.809.194-.819.216-.374 1.074.25.479.453 1.086.453 1.341 0 .625.176.59 1.322-.285zm370.023-.074c.092-.451.245-1.028.343-1.281.126-.32-.153-.61-.938-.962-.61-.28-1.126-.476-1.144-.44-.02.034-.28.46-.584.946-.4.64-.456.919-.19 1.006.2.068.726.44 1.168.83 1.03.907 1.145.899 1.345-.099zm-342.778-1.886c2.547-.954 5.565-3.944 5.565-5.513 0-.407-.527-.46-3.966-.385-3.44.074-4.158.18-5.39.778-1.71.838-3.219 2.567-3.219 3.685 0 2.002 3.553 2.728 7.01 1.437zm320.505-.11c1.387-1.257.25-3.43-2.52-4.814-1.716-.859-1.97-.898-5.612-.898-4.423 0-4.465.04-2.687 2.395 1.204 1.592 3.42 3.257 4.964 3.732 1.601.487 5.134.24 5.855-.415zm-339.844-.792c1.012-.507 2.33-1.483 2.928-2.172 1.138-1.305 2.391-3.719 2.092-4.02-.36-.36-6.475.519-7.585 1.086-3.084 1.577-4.577 4.75-2.67 5.668 1.28.62 3.303.404 5.235-.562zm358.283.195c.606-.605.678-.868.459-1.63-.531-1.857-2.22-3.368-4.551-4.066-1.45-.431-6.537-.922-6.537-.631 0 .371 1.297 2.73 2.042 3.704 2.195 2.885 6.894 4.322 8.587 2.625zm-347.637-1.776c.769-1.577.719-3.952-.12-5.597-.684-1.343-2.953-4.778-3.157-4.778-.307 0-1.297 2.435-1.617 3.98-.559 2.724.028 5.057 1.737 6.886 1.157 1.237 2.409 1.038 3.157-.493zm334.69.479c1.903-1.988 2.368-5.589 1.132-8.828-.359-.942-.758-1.78-.888-1.863-.295-.18-2.834 3.485-3.453 4.99-.533 1.284-.605 3.705-.15 4.93.651 1.75 2.1 2.082 3.358.77zm-354.107-.086c.36-.4.6-1.224.68-2.37.175-2.424-.74-4.31-3.546-7.308l-2.201-2.352-.431 1.154c-.64 1.704-.62 5.639.04 7.34.65 1.684 3.141 4.145 4.191 4.145.395 0 .966-.274 1.27-.609zm372.53.186c2.326-1.214 3.773-4.038 3.773-7.362 0-2.163-.519-4.49-.998-4.49-.487 0-4.391 4.61-5.03 5.938-.858 1.796-.898 4.031-.08 5.365.651 1.072 1.124 1.181 2.336.549zm-350.005-3.573c.619-.391 1.423-.805 1.797-.922l.678-.216-.605-.766c-.331-.423-.602-.966-.602-1.208 0-.31-.16-.375-.525-.215-.288.123-.974.289-1.527.367-.934.13-.99.2-.823 1.038.1.495.18 1.287.18 1.76 0 1.042.024 1.044 1.427.16zm326.816-1.585c.19-1.218.176-1.243-.778-1.377-.535-.076-1.178-.228-1.427-.34-.326-.14-.58.08-.875.779a25.768 25.768 0 0 1-.539 1.192c-.065.12.328.407.873.642.547.24 1.263.639 1.593.888.698.535.822.34 1.151-1.782zm-345.345.85c1.138-.824 1.15-.848.62-1.5-.48-.591-.63-.623-1.384-.3-.467.2-.89.391-.942.423-.132.08.283 2.216.429 2.216.064 0 .639-.38 1.277-.839zm363.942-.24c.108-.594.16-1.105.106-1.137a21.688 21.688 0 0 0-.943-.423c-.752-.323-.902-.291-1.387.307-.533.659-.529.679.29 1.178.459.28.924.653 1.034.83.37.6.694.33.898-.754zm-337.411-1.047c1.746-.48 4.146-2.41 5.537-4.457 1.884-2.779 1.996-2.675-2.142-1.916-5.104.932-6.153 1.271-7.297 2.349-1.836 1.737-1.597 3.393.585 4.032 1.277.37 1.93.367 3.317-.01zm313.619-.553c.964-.679 1.054-1.427.319-2.625-.874-1.41-2.623-2.15-7.022-2.96-2.16-.395-4.092-.784-4.3-.858-.652-.244-.414.29 1.087 2.425 1.856 2.639 3.724 4.112 5.874 4.617 1.267.3 3.16.02 4.042-.599zm-334.547-.788c1.7-.895 3.401-2.443 4.639-4.222 1.305-1.876 1.217-1.996-1.391-1.826-3.753.24-7.619 2.666-7.619 4.782 0 .799 1.331 2.036 2.188 2.036.395 0 1.377-.347 2.183-.772zm354.772.04c.862-.869.888-1.098.26-2.428-.919-1.926-4.843-3.726-8.132-3.726h-1.609l.539.938c1.537 2.675 5.645 5.918 7.517 5.94.38.004 1.018-.323 1.423-.726zm-360.95-1.344c.17-.32.31-1.303.31-2.187 0-1.25-.188-1.905-.844-2.938-.873-1.374-4.437-4.681-4.73-4.388-.095.09-.24 1.222-.328 2.515-.14 2-.06 2.581.51 3.912 1.238 2.885 4.218 4.695 5.08 3.086zm18.59.272c1.396-.749 1.971-4.232 1.057-6.415-.34-.81-2.834-4.71-3.341-5.226-.068-.066-.48.679-.918 1.649-.635 1.407-.803 2.255-.827 4.161-.026 2.108.07 2.565.799 3.805.774 1.317 1.82 2.335 2.4 2.335.14 0 .514-.14.83-.307zm328.007-.264c2.399-1.463 3.088-6.048 1.437-9.585l-.872-1.87-1.581 2.425c-1.928 2.958-2.162 3.543-2.162 5.437 0 1.717.599 3.362 1.397 3.825.725.419.705.425 1.78-.232zm20.163-.499c2.01-1.816 2.88-5.15 2.09-8.004l-.315-1.137-2.056 1.826c-1.164 1.028-2.327 2.375-2.679 3.1-.666 1.38-.822 3.742-.307 4.704.509.95 1.904.739 3.27-.493zm-344.25-2.124c.223-.273.971-.746 1.662-1.051l1.253-.56-.768-.768c-.735-.732-.834-.752-2.092-.399-.942.264-1.273.493-1.158.798.092.24.166.893.166 1.458 0 1.117.303 1.29.938.524zm319.416-1.137c0-1.298-.03-1.342-1.177-1.653-1.078-.29-1.242-.251-1.94.45l-.765.762.763.29c.419.159.858.292.968.298.11.006.542.268.954.59 1.07.838 1.197.758 1.197-.74zm-337.54-1.543c1.97-.934 3.692-3.812 4.295-7.196.31-1.716.1-4.012-.407-4.519-.325-.325-1.808.66-3.493 2.32-3.148 3.104-4.71 7.932-3.014 9.307.864.699 1.303.715 2.62.088zm357.504-.16c1.689-1.401-.862-7.704-4.116-10.16-1.736-1.317-2.41-1.596-2.708-1.127-.485.766-.292 4.686.32 6.415 1.44 4.112 4.586 6.467 6.506 4.874zm-331.105-.722c1.796-.799 5.11-3.893 4.65-4.352-.345-.345-4.65-.433-6.088-.12-2.455.528-4.183 1.893-4.183 3.3 0 2.208 2.235 2.675 5.62 1.172zm307.002.271c.786-.708.706-2.241-.16-3.054-1.293-1.217-3.523-1.836-6.613-1.836-1.708 0-2.902.128-3.026.325-.307.5 2.845 3.37 4.675 4.252 1.936.938 4.271 1.084 5.122.315zm-326.822-.4c1.936 0 2.223-.069 2.223-.534 0-.958.886-3.968 1.85-6.287l.944-2.266.42 1.431c.227.789.463 1.386.519 1.326.056-.06.269-1.521.465-3.25.359-3.193.678-4.137 1.022-3.054.105.334.379.675.604.759.352.14.354-.028.006-1.092a16.89 16.89 0 0 1-.499-1.83c-.055-.372-.539.327-1.349 1.962-1.417 2.862-3.048 4.862-5.35 6.563-1.29.954-1.66 1.437-2.083 2.742-.283.87-.834 2.012-1.224 2.535-.83 1.114-.898 1.427-.239 1.178.26-.1 1.473-.184 2.695-.184zm344.033-.957c-.42-.55-1.004-1.785-1.297-2.745-.46-1.473-.711-1.836-1.63-2.301-2.185-1.118-5.129-4.922-6.58-8.517l-.363-.898-.363 1.537c-.2.842-.472 1.716-.6 1.944-.133.223.117.084.556-.315.439-.4.886-.635.998-.525.107.107.26 1.612.339 3.343.076 1.728.253 3.144.39 3.144.139 0 .438-.635.664-1.414.363-1.247.449-1.345.724-.824.63 1.178 2.13 5.768 2.332 7.116l.21 1.385 2.586.084c1.417.046 2.635.06 2.69.03.06-.03-.239-.503-.658-1.052zm-331.427-.292c1.03-.97.946-2.94-.213-4.964-1.038-1.808-4.162-4.479-4.541-3.882-.4.629-.26 4.527.22 6.136.903 3.054 2.9 4.247 4.536 2.71zm319.485-.025c1.124-1.198 1.643-2.92 1.796-5.982.172-3.424.08-3.493-2.18-1.785-2.957 2.236-4.275 5.808-2.822 7.655a2.096 2.096 0 0 0 3.208.112zm-343.23-1.643c.31-2.347 1.702-4.797 4.087-7.19l2.167-2.175-.155-2.016c-.15-1.966-1.238-5.46-1.697-5.46-.126 0-.383.506-.569 1.124-.185.62-1.377 2.94-2.644 5.164-2.487 4.365-3.681 7.29-3.693 9.042 0 .868.206 1.305.968 2.02.539.499 1.058.912 1.158.914.104 0 .273-.639.379-1.423zm365.413.475c.974-.912 1.002-1.004.819-2.595-.214-1.806-1.607-4.976-4.032-9.181-.858-1.481-1.789-3.334-2.068-4.118-.28-.779-.599-1.421-.715-1.421-.479 0-1.517 3.598-1.642 5.688l-.136 2.246 1.529 1.185c2.505 1.936 4.79 5.972 4.79 8.447 0 .919.256.879 1.457-.253zm-335.858-3.926c2.3-1.553 4.218-5.146 4.823-9.042.509-3.28.379-3.385-2.216-1.796-4.559 2.794-6.437 5.163-6.74 8.502-.134 1.497-.068 1.829.479 2.376.842.844 2.369.824 3.656-.04zm308.346.024c1.185-1.274.419-4.876-1.541-7.254-.998-1.213-6.747-5.15-7.062-4.836-.333.333.499 5.26 1.132 6.68 2.175 4.919 5.608 7.406 7.47 5.41zm-301.184-.859c2.635-.764 5.317-2.598 7.565-5.16 2.379-2.714 3.453-3.795 4.563-4.602l.888-.645-1.134-.213c-1.677-.316-5.82.012-7.539.593-.824.28-2.235.868-3.141 1.309-1.461.715-1.683.946-2.012 2.116-.2.722-.45 1.567-.547 1.876-.132.411.34.2 1.764-.794 2.076-1.453 4.5-2.63 6.162-2.994l1.024-.22-.972 1.228c-1.547 1.95-3.904 3.868-6.136 4.99-1.134.57-2.216 1.037-2.41 1.037-.193 0-.877.545-1.53 1.212l-1.184 1.214 1.348-.188a28.862 28.862 0 0 0 3.293-.753zm294.607.739c0-.713-1.407-1.942-2.719-2.375-.834-.28-2.49-1.158-3.684-1.956-2.136-1.431-4.974-4.148-4.974-4.77 0-.74 3.952.868 6.627 2.694.958.655 1.796 1.193 1.86 1.193.35 0-.799-3.227-1.298-3.638-.327-.272-1.776-.926-3.22-1.457-2.821-1.034-5.684-1.407-8.055-1.052l-1.445.22 1.222 1.091c.67.603 2.265 2.272 3.548 3.713 3.793 4.267 6.216 5.585 11.912 6.477.124.02.224-.044.224-.14zm-318.26-3.034c1.613-1.828 3.178-4.93 3.765-7.465.471-2.028.61-6.56.252-8.084-.294-1.247-1.362-3.696-1.611-3.696-.12 0-.385.573-.595 1.271-.21.699-1.022 2.551-1.808 4.116-2.196 4.381-3.094 7.154-2.875 8.888.096.793.26 2.685.364 4.204.215 3.193.333 3.23 2.515.758zm340.116-.14c0-1.018.164-2.646.365-3.612.487-2.366-.044-4.336-2.565-9.553-1.063-2.196-2.022-4.431-2.135-4.966-.11-.535-.31-.974-.44-.974-.133 0-.55.706-.926 1.57-.538 1.23-.714 2.29-.814 4.867-.16 4.002.35 6.483 1.95 9.547 1.058 2.024 3.579 4.974 4.252 4.974.185 0 .313-.759.313-1.853zm-329.038-.319c0-.186.739-2.166 1.637-4.397 1.852-4.6 2.421-7.45 2.144-10.748-.16-1.917-.77-4.947-1.274-6.338-.092-.253-.593.723-1.157 2.246-.545 1.48-1.829 4.503-2.855 6.712-2.195 4.74-2.748 7.162-2.075 9.046.534 1.487.962 1.537 1.251.14.18-.855 1.557-4.397 2.93-7.515.4-.902.048 1.81-.778 6.088-.745 3.826-.853 4.906-.525 5.23.253.259.704-.04.704-.466zm315.74-4.55c-.874-4.568-1.23-7.506-.798-6.602.425.893 2.92 7.35 3.242 8.384l.275.898.415-.75c.24-.432.414-1.578.41-2.695-.01-2.09-.412-3.254-3.358-9.73-.822-1.811-1.73-4-2.01-4.863-.279-.864-.622-1.503-.758-1.417-.595.365-1.325 4.87-1.288 7.924.046 3.573.426 5.064 2.685 10.555 1.208 2.934 1.487 3.409 1.693 2.854.16-.42-.026-2.08-.503-4.565zM299.09 152.94c11.662-7.909 20.93-18.457 24.67-28.084 1.305-3.36 2.212-7.086 2.066-8.495l-.096-.938-4.042 3.553c-12.846 11.285-21.17 22.634-23.912 32.598-.682 2.475-.539 2.621 1.314 1.364zm6.66.08c1.845-1.202 4.76-2.02 7.679-2.156 2.894-.13 3.134-.24 4.122-1.865 2.7-4.45 8.443-10.329 13.013-13.323 1.625-1.058 4.615-2.758 6.647-3.772 2.032-1.014 3.639-1.906 3.567-1.976-.28-.28-6.822.567-9.381 1.217-6.222 1.577-10.032 3.64-12.327 6.673-2.152 2.848-7.326 7.958-11.378 11.233-3.06 2.475-3.369 2.815-3.369 3.713 0 .539.072.986.16.986.088 0 .654-.327 1.267-.729zm290.184-.43c0-.668-.463-1.185-2.549-2.844-4.61-3.667-10.523-9.507-12.728-12.583-1.162-1.616-3.31-3.022-6.683-4.37-4-1.604-9.37-2.707-13.061-2.69-1.348.009-1.326.025 3.077 2.322 2.44 1.271 5.67 3.19 7.174 4.26 3.397 2.414 7.295 6.303 9.629 9.61 3.473 4.924 2.942 4.46 5.141 4.46 2.645 0 5.593.725 7.755 1.905.988.539 1.896.928 2.022.868.12-.064.223-.483.223-.938zm6.882.485c-.004-1.225-2.016-6.47-3.706-9.664-4.212-7.964-11.018-16.06-20.539-24.451l-4.042-3.563-.09 1.038c-.23 2.575 2.048 9.361 4.631 13.812 2.974 5.126 8.11 11.313 12.764 15.38 2.855 2.494 10.306 8.113 10.765 8.119.124 0 .22-.3.22-.669zm-183.41 267.023c-1.268-.575-1.913-1.583-1.913-2.988 0-1.517.6-3.503 1.118-3.703.653-.25.719.054.333 1.497-.31 1.17-.29 1.461.14 2.122.902 1.377 4.525 1.425 6.092.08.699-.603.739-.749.403-1.404a8.47 8.47 0 0 0-1.114-1.516c-.708-.763-.718-.827-.253-1.725.579-1.124.667-1.138 1.417-.18.878 1.114 2.186 1.024 2.607-.18.36-1.037 1.028-1.037 1.181-.005.14.944 1.418 1.49 2.036.87.426-.427.426-.539-.006-1.194-.427-.652-.429-.788-.012-1.38.66-.939.954-.823 1.362.538.399 1.337.028 3.186-.813 4.028-.585.587-2.036.599-2.614.02-.386-.385-.483-.385-.805 0-.2.244-.668.443-1.038.443-.559 0-.698.204-.838 1.208-.32 2.395-1.665 3.483-4.62 3.742-1.152.1-2.045.012-2.665-.273zm30.632-1.384c-.09-.247-.248-1.183-.353-2.08a15.754 15.754 0 0 0-2.236-6.283c-1.058-1.636-1.118-2.28-.335-3.3.744-.967 1.147-.618 2.367 2.025 1.054 2.285 1.553 4.487 1.533 6.762-.016 1.66-.695 3.663-.978 2.878zm19.485-.225c-.679-.779-1.014-1.549-1.421-3.293-.36-1.541-.39-1.573-1.462-1.573-1.453 0-3.097-.855-3.572-1.857-.447-.938.004-2.33 1.303-4.035.946-1.238 1.78-1.693 2.695-1.465 1.044.263 1.68 1.77 1.966 4.658.187 1.892.483 3 1.145 4.297.845 1.657.873 1.81.47 2.775-.496 1.178-.52 1.187-1.124.493zm-2.172-7.872c.28-.46-.687-1.783-1.303-1.783-.605 0-1.252.55-1.252 1.062 0 .719 2.176 1.334 2.555.719zm5.433 7.978c-.373-.97-.21-1.709.653-2.97 1.217-1.777 2.01-3.417 3.066-6.34.918-2.534 1.321-3.021 1.664-2.024 1.254 3.637 2.38 5.82 4.483 8.703.471.645.471.754-.008 1.76l-.51 1.072-.903-.858c-.878-.838-2.942-4.6-3.357-6.108-.18-.65-.367-.387-1.437 2.022-1.393 3.138-3.314 5.629-3.653 4.745zm-15.734-1.865c-.453-2.449-1.471-5.013-2.703-6.802-1.042-1.513-1.072-1.653-.579-2.724.447-.99.843-.964 1.897.133 1.217 1.274 2.784 1.258 3.876-.04.93-1.103 1.197-.95 1.197.689 0 .986-.18 1.37-.972 2.076-.53.479-1.183.868-1.449.868-.399 0-.449.22-.29 1.218.594 3.72.476 6.217-.307 6.479-.167.056-.469-.799-.672-1.897zm-21.896-1.61v-1.198h3.788l-.13-.882c-.093-.649.068-1.074.615-1.62.46-.46.639-.851.467-1.023-.17-.17-.14-.579.08-1.064l.36-.786 1.377.758c3.287 1.807 4.241 3.453 3.185 5.495-.575 1.114-1.17 1.304-2.423.779-.934-.39-1.152-.375-2.303.147-.813.372-1.946.58-3.142.585l-1.872.006v-1.197zm9.125-1.186c.096-.16-.12-.585-.483-.948l-.658-.659-.252.679c-.136.37-.173.798-.08.944.22.36 1.246.35 1.474-.014zm-2.542-1.058c.499-.599.165-1.35-.595-1.35-.34 0-.695.205-.79.454-.174.45.355 1.343.79 1.343.124 0 .393-.2.595-.447zm-14.441-4.475c-.647-.473-.665-.878-.06-1.377.39-.323.565-.29 1.058.204.569.568.57.614.06 1.077-.446.4-.623.416-1.058.096zm2.335-.152c-.45-.495-.48-.686-.17-1.057.483-.583 1.024-.58 1.517.012.32.387.286.562-.21 1.057-.59.591-.594.591-1.137-.012zm-1.222-1.816c-.499-.559-.505-.659-.083-1.078.399-.395.564-.407 1.103-.068.779.483.79.623.088 1.258-.515.465-.585.459-1.104-.114zm-67.218-8.916c-3.094-2.868-4.777-5.096-4.777-6.323 0-1.21 1.398-2.719 2.523-2.719.659 0 .77-.132.77-.912 0-1.976 1.588-3.579 3.534-3.579.475 0 1.067-.235 1.317-.523.247-.29 1.92-2.954 3.712-5.914l3.266-5.389.09-6.587.092-6.586-.93-1.406c-1.334-2.012-1.454-3.193-.486-4.844.942-1.609.954-1.824.186-3.33-.765-1.504-.753-1.841.144-3.293.405-.658.738-1.572.746-2.031.008-.705-12.974-44.435-13.283-44.744-.06-.06-.463.499-.898 1.243-1.066 1.817-4.056 5.01-4.591 4.902-.266-.056-3.05-6.83-7.293-17.754a15903.924 15903.924 0 0 0-8.507-21.862c-.905-2.305-1.643-4.327-1.641-4.49.004-.16 1.104-1.438 2.445-2.84 2.786-2.903 4.77-5.48 5.842-7.6l.743-1.461-.938-3.33c-1.421-5.053-1.314-4.87-3.044-5.101-2.212-.293-3.579-1.637-3.779-3.707-.183-1.916.26-3.06 1.673-4.297 1.87-1.645 4.032-2.443 6.547-2.415 2.958.03 4.607.806 5.46 2.575 1.153 2.369.568 4.4-1.596 5.559-.427.23-.778.568-.778.758 0 .186 2.435 8.954 5.409 19.48a26624.742 26624.742 0 0 1 16.52 58.669c.5 1.81 1.024 3.419 1.166 3.579.148.16.26-2.262.26-5.521 0-5.47-.034-5.845-.623-6.467-1.343-1.431-1.311-5.05.056-6.292.311-.28.567-.706.567-.946s-1.066-2.207-2.371-4.377c-1.304-2.168-2.416-4.132-2.47-4.365-.075-.32.2-.41 1.098-.363.659.034 1.37-.05 1.577-.188.296-.196.36-4.132.3-18.638l-.08-18.39-1.346-.704c-1.836-.958-2.574-1.705-3.449-3.493-.503-1.026-1.085-1.703-1.796-2.086-1.277-.686-2.236-2.151-2.236-3.409 0-.639-.2-1.032-.644-1.27-1.787-.953-3.745-3.249-4.292-5.03l-.22-.706 12.13.11c6.673.06 12.212.03 12.308-.068.095-.094.175-8.347.175-18.337v-18.163l-.998-1.124c-2.243-2.515-2.243-6.34 0-7.745.467-.293.898-.568.958-.61.066-.04-.433-.699-1.101-1.457-2.056-2.34-2.332-5.413-.775-8.693.639-1.347 2.068-2.794 3.242-3.285.73-.308 1.051-.699 1.325-1.609.283-.942.854-1.605 2.627-3.054 2.666-2.18 3.944-3.826 4.197-5.409.1-.633.274-1.148.38-1.148.113 0 .369.62.574 1.384.284 1.065.759 1.736 2.052 2.918 3.924 3.576 4.587 4.305 4.778 5.255.14.705.613 1.274 1.767 2.128 1.886 1.391 2.76 2.555 3.317 4.4.845 2.805.248 5.85-1.517 7.717l-.97 1.028.73.683c2.356 2.2 2.02 6.395-.612 7.66l-.814.392.075 18.616c.068 16.926.12 18.623.563 18.709.27.052 2.695-.972 5.39-2.28 10.125-4.902 16.88-8.203 16.975-8.29.054-.047-.12-.424-.387-.831a1.936 1.936 0 0 1-.295-1.497c.104-.414.036-1.034-.15-1.382-.211-.395-.235-.808-.066-1.113.294-.525-.17-2.501-.587-2.501-.133 0-1.131-1.046-2.221-2.324-3.569-4.18-5.317-8.902-5.35-14.445-.02-3.852.394-5.648 2.097-9.145 2.634-5.415 6.906-8.802 15.656-12.44 5.948-2.466 9.39-4.602 12.459-7.734 1.762-1.796 1.776-1.826 1.144-2.269-.809-.567-1.404-2.327-1.142-3.383.11-.443.473-1.098.806-1.457l.607-.651-.864-1.297c-2.565-3.833-2.126-5.649 2.63-10.859 1.493-1.64 3.058-3.656 3.477-4.48l.759-1.497.683 1.337c.379.752 2.09 2.72 3.886 4.48 4.78 4.677 5.263 6.26 3.16 10.324l-1.178 2.275.61 1.038c.749 1.266.567 2.699-.498 3.964l-.719.859.739 1.09c1.077 1.584 3.62 3.193 11.277 7.135 3.744 1.932 7.924 4.236 9.281 5.124 4.964 3.243 7.964 6.716 9.553 11.058 2.643 7.225.623 14.924-5.6 21.35-1.713 1.769-1.743 1.827-1.847 3.743a71.282 71.282 0 0 0-.096 3.094c.004.633-.132 1.413-.3 1.73-.287.53.5.974 9.51 5.39 11.387 5.584 12.323 6.011 12.69 5.784.16-.096.273-7.9.273-18.713 0-18.143-.012-18.556-.598-19.141-.328-.331-.719-.599-.875-.599-.15 0-.505-.609-.788-1.351-.958-2.511-.144-5.441 1.776-6.383l.809-.395-.95-1.082c-3.433-3.912-2.336-9.437 2.359-11.864.593-.308.924-.809 1.192-1.805.299-1.123.818-1.806 2.802-3.692 2.375-2.262 3.533-4.022 3.547-5.39.012-1.141.459-.746.854.749.32 1.21.822 1.856 3.333 4.287 2.368 2.296 2.998 3.082 3.164 3.968.16.849.559 1.386 1.717 2.31 1.962 1.56 2.834 2.77 3.399 4.714.718 2.463.06 4.89-1.896 7l-.739.793.85.399c.487.233 1.146.978 1.543 1.756 1.172 2.27.485 5.234-1.467 6.355l-.874.5v37.753H542.7l-.21.97c-.498 2.312-1.664 3.733-3.812 4.651-.459.2-.91.599-1.003.886-.575 1.785-.965 2.356-2.222 3.258-1.028.738-1.547 1.387-1.94 2.43-.759 2.01-1.288 2.731-2.595 3.554-.902.573-1.142.908-1.142 1.607 0 .558-.333 1.265-.898 1.906l-.898 1.024v33.604h3.144c1.92 0 3.143.12 3.143.303 0 .166-.85 1.683-1.888 3.37a205.154 205.154 0 0 0-2.858 4.77l-.97 1.709.573 1.137c1.084 2.15 1.078 3.102-.044 5.216l-1.006 1.908-.208 6.128c-.114 3.365-.13 6.047-.04 5.954.188-.188 1.872-6.108 14.818-52.062l8.735-30.997-1.026-1.09c-1.218-1.285-1.537-2.555-1.082-4.241.42-1.565 1.277-2.769 2.375-3.334 1.673-.868 7.142-.327 9.657.954 1.792.91 2.535 3.645 1.6 5.884-.532 1.274-2.04 2.521-3.34 2.767-.987.184-1.065.295-1.657 2.331-.34 1.178-.942 3.21-1.338 4.521l-.712 2.38 1.054 1.73c1.357 2.235 3.313 4.684 5.702 7.141l1.906 1.957-.573 1.636c-.315.898-3.265 8.639-6.554 17.202-3.29 8.562-6.84 17.824-7.888 20.578-1.052 2.759-2.036 5.016-2.196 5.018-.531.006-3.693-3.497-4.61-5.11-.586-1.022-.969-1.44-1.067-1.161-.083.24-.505 1.716-.938 3.28-.425 1.564-3.479 11.87-6.776 22.901a16490.1 16490.1 0 0 0-6.281 21.048c-.26.886-.2 1.067.59 1.804 1.142 1.072 1.404 2.311.83 3.968-.402 1.172-.402 1.357.013 1.816.569.631.852 2.555.583 3.988-.11.593-.6 1.53-1.086 2.082l-.882 1.004v6.431c0 7.453-.444 6.2 4.29 12.156 1.526 1.916 3.57 4.499 4.542 5.734 2.092 2.663 2.115 2.683 3.379 2.69.539.005 1.537.286 2.205.627.953.486 1.364.953 1.849 2.102.527 1.252.788 1.521 1.72 1.773 1.358.367 2.545 1.277 3.126 2.4.595 1.15.585 3.166-.016 3.394-.251.1-42.051.26-92.887.365l-92.43.186-2.26-2.096zm186.524-.345c.38-.24.38-.38 0-1.092-.24-.447-.838-1.064-1.333-1.363-.866-.531-4.166-.551-91.22-.553-81.716 0-90.367.046-90.794.47-.724.725-.606 2.188.204 2.516.912.365 182.566.389 183.143.02zm-5.076-5.375c0-.316-.415-.923-.918-1.35l-.924-.778h-86.653c-86.253 0-86.654.006-87.25.603-.594.592-.785 1.509-.4 1.896.11.11 39.788.2 88.173.2 86.41 0 87.972-.01 87.972-.571zm-100.896-3.893c0-.155-1.382-2.006-3.07-4.12l-3.068-3.844-13.1-.08c-7.205-.04-13.097.007-13.097.104 0 .48 5.489 7.893 5.928 8.008 1.026.27 26.407.2 26.407-.07zm30.386-.02c.13-.22-4.67-5.882-6.16-7.269l-.883-.822h-13.619c-9.305 0-13.617.1-13.617.313 0 .41 5.849 7.665 6.352 7.876.555.24 27.778.14 27.927-.1zm-61.288-3.301a1187.337 1187.337 0 0 1-4.312-6.207l-2.435-3.523-10.888-.086c-5.988-.044-11.181-.01-11.532.076-.352.085-1.09.862-1.637 1.73a622.62 622.62 0 0 1-3.928 6.024c-1.613 2.447-2.926 4.491-2.926 4.545 0 .255 2.449.28 20.269.205l19.267-.08-1.876-2.684zm82.4 2.814c0-.103-1.565-1.856-3.48-3.896l-3.48-3.708h-9.122c-5.321 0-9.077.113-9.018.271.174.473 5.972 7.176 6.336 7.325.519.21 18.762.22 18.762.006zm37.804-.195 4.417-.074-4.208-5.39c-2.315-2.963-4.443-5.624-4.724-5.907-.471-.48-1.503-.525-11.816-.56-9.128-.027-11.397.04-11.797.372-.475.4-7.479 10.722-7.75 11.431-.104.272 3.567.34 15.659.28 8.69-.04 17.788-.108 20.219-.15zm-47.21-8.836c.32-.214 2.803-3.59 3.86-5.236l.526-.822h-7.235c-6.082 0-7.198.066-6.996.413.131.23 1.287 1.645 2.567 3.146l2.329 2.728 2.315-.006c1.27 0 2.455-.1 2.635-.223zm-64.845-.24c0-.088-.748-1.437-1.662-2.994l-1.665-2.824h-10.145v1.221c0 .99.259 1.557 1.363 2.994l1.367 1.773h5.37c2.953 0 5.372-.074 5.372-.168zm27.792-3.12-2.495-2.69-13.245-.004c-7.29-.004-13.25.1-13.25.227 0 .354 2.73 4.677 3.11 4.93.184.12 6.643.22 14.352.22l14.02.006-2.492-2.69zm28.595 1.976a137.443 137.443 0 0 0-2.196-2.69l-1.646-1.976-12.352-.004c-6.792-.004-12.349.094-12.349.213 0 .12 1.108 1.332 2.463 2.695l2.465 2.475h24.162l-.55-.713zm-71.726-10.439.08-6.51h-21.866v6.387c0 3.513.092 6.479.204 6.59.111.112 4.996.168 10.852.124l10.648-.08.08-6.51zm122.374.376v-6.138l-11.301-.08-11.304-.076v12.589l11.304-.08 11.3-.076zm-98.867 3.708c.186-.185-2.451-3.553-3.313-4.231-.36-.28-2.715-.376-9.401-.376h-8.926v2.196c0 1.208.09 2.285.2 2.395.249.25 21.19.266 21.44.016zm27.301-1.836c-2.54-3.064-.922-2.77-15.293-2.77-8.377 0-12.69.103-12.69.303 0 .327 2.57 3.597 3.113 3.96.18.12 6.174.22 13.313.223l12.986.004-1.429-1.722zm14.83 1.47c0-.139-.93-1.147-2.066-2.245l-2.066-1.996h-5.121c-2.815 0-5.118.092-5.118.2 0 .228 2.954 3.719 3.433 4.064.43.305 10.938.285 10.938-.02zm17.122-2.817c.051-1.69.051-3.374-.004-3.743l-.096-.675h-12.83v7.485h12.834l.094-3.067zm4.658 1.842 1.274-1.218v-5.01l-4.717-4.37-4.714-4.372-.096 1.587-.1 1.587 2.868 2.722 2.867 2.719v3.792c0 3.732.01 3.788.672 3.784.38 0 1.238-.539 1.946-1.221zm-19.574-.345c.1-.372.183-1.833.185-3.248l.004-2.575-2.844-2.614-2.842-2.615v-8.036l-1.853-1.423c-1.017-.779-2.299-1.805-2.844-2.276l-.992-.854v-3.393c0-3.848.37-3.218-3.519-5.988l-1.87-1.337v-5.028l-1.529-1.377c-.842-.755-1.65-1.378-1.796-1.378-.152 0-.268 4.595-.268 10.609v10.603l1.274 1.48c2.8 3.254 18.317 20.128 18.51 20.128.114 0 .288-.303.386-.672zm-62.938-6.737c-.974-1.784-1.217-2.032-2.071-2.116l-.968-.093v4.231h4.141l-1.102-2.02zm27.15 1.75c-.232-.628-3.064-3.385-3.74-3.642-.76-.288-22.555-.407-22.555-.12 0 .451 1.832 3.699 2.161 3.832.695.276 24.242.21 24.136-.07zm27.031-.259c-.155-.295-1.028-1.237-1.936-2.096l-1.656-1.567H447.3c-9.42 0-11.844.08-11.844.384 0 .21.753 1.153 1.67 2.095l1.674 1.711h12.111c11.503 0 12.096-.026 11.826-.53zm-57.82-5.758c.33-.33.6-.938.6-1.348 0-.413-.27-1.018-.6-1.349-.578-.579-.997-.599-12.255-.599-10.195 0-11.712.06-12.123.471-.884.883-.453 2.795.726 3.214.246.088 5.535.171 11.75.183 10.923.024 11.324.004 11.903-.574zm11.977.28c0-.414-1.74-3.01-2.346-3.498-.315-.253-1.652-.375-4.171-.375h-3.713l.246.972c.133.539.225 1.481.203 2.096l-.04 1.123h4.91c3.288 0 4.91-.105 4.91-.319zm12.409-1.404c-.79-.944-1.637-1.888-1.889-2.096-.505-.415-10.518-.559-10.518-.145 0 .319 2.123 3.467 2.52 3.732.176.124 2.799.224 5.825.228l5.5.004-1.436-1.723zm15.135 1.53c0-.424-2.595-3.372-3.233-3.676-.807-.379-11.024-.45-11.258-.08-.08.14.625 1.082 1.567 2.1l1.717 1.849h5.604c3.082 0 5.603-.086 5.603-.192zm13.174-.04c0-.13-.813-1.037-1.805-2.021l-1.804-1.788-4.82-.092c-2.655-.056-4.93.012-5.064.148-.134.135.547 1.087 1.517 2.115l1.752 1.873h5.11c2.814 0 5.114-.106 5.114-.234zm34.67-1.187c.08-1.03-.048-1.413-.659-2.022-.678-.678-.988-.752-3.161-.752-1.324 0-2.408.124-2.408.273 0 .15.909 1.098 2.02 2.1 1.757 1.583 2.16 1.812 3.07 1.747 1.004-.08 1.052-.134 1.138-1.35zm35.438.922c.671-.606.703-1.546.08-2.435l-.463-.662h-12.52c-13.747 0-13.294-.06-13.294 1.796s-.443 1.796 13.214 1.796c11.151 0 12.494-.051 12.983-.495zm-46.905-4.445V350l-6.116-.08c-4.69-.064-6.171.006-6.357.3-.291.458-.333 6.632-.044 6.921.114.112 2.974.17 6.363.124l6.16-.08v-3.593zm-75.953-1.058c.778-.726.838-1.682.16-2.435-.466-.515-1.242-.549-12.216-.549-8.718 0-11.816.092-12.08.36-.2.2-.359.798-.359 1.33 0 1.895.036 1.903 12.585 1.903 10.912 0 11.273-.02 11.91-.61zm122.517-.006c.52-.968.24-2.167-.607-2.594-.558-.28-3.6-.376-12.201-.38-11.058-.004-11.473.014-12.05.595-.728.729-.77 1.71-.104 2.445.465.515 1.252.55 12.563.55 11.862 0 12.076-.01 12.4-.616zm-36.426-.303c.91-.718.998-1.35.295-2.128-.433-.479-1.002-.547-4.511-.547h-4.012l.094 1.422c.08 1.307.16 1.437.988 1.61.493.104 2.124.206 3.627.226 2.34.028 2.842-.056 3.516-.585zm-66.78-1.182c-.463-.658-1.112-1.271-1.441-1.357-.33-.086-3.968-.116-8.084-.07l-7.485.084-.092 1.274-.093 1.27h18.04l-.845-1.202zm26.253-.145-1.321-1.347h-23.868l1.104 1.347 1.103 1.345h24.307l-1.325-1.347zm41.107-3.667.773-1.123.02-18.358.016-18.357-.739-.972c-.918-1.197-1.507-3.632-1.237-5.081.152-.79.447-1.218 1.078-1.541l.872-.451-2.531-4.036c-1.397-2.22-2.535-4.106-2.535-4.192 0-.086 1.281-.155 2.844-.155 1.982 0 2.845-.108 2.845-.354 0-.652-5.03-7.864-7.28-10.427-6.906-7.884-16.914-14.06-26.001-16.047-2.845-.62-8.986-.615-13.074.01-13.677 2.101-22.11 6.241-30.61 15.03-3.414 3.532-8.962 10.31-8.962 10.953 0 .128 2.21.234 4.914.234h4.91l1.345 1.303c1.902 1.85 3.772 2.695 5.573 2.523 1.71-.166 3.844-1.146 5.155-2.37 1.342-1.25 1.827-1.456 3.422-1.456 1.311 0 1.513.11 2.966 1.62 2.365 2.464 4.435 2.81 7.225 1.208a8.22 8.22 0 0 0 2.036-1.766c.798-1.05.838-1.064 3.04-1.064 1.752 0 2.23.092 2.23.435 0 .24-.607 2.529-1.348 5.086l-1.345 4.65v44.958l.824-.096.822-.096.08-16.018c.06-11.668-.012-16.195-.263-16.672-.19-.36-.274-.934-.184-1.277.09-.344.016-1.018-.167-1.501-.314-.835-.246-.968 1.297-2.543.898-.91 1.748-1.657 1.892-1.657.144 0 .932.659 1.749 1.471l1.487 1.471-.214 1.747c-.12.958-.391 1.996-.599 2.303-.804 1.158-.28 1.39 3.2 1.39 2.647 0 3.307-.089 3.447-.456a.922.922 0 0 0-.126-.822c-.163-.204-.391-1.178-.499-2.168l-.2-1.796 1.625-1.597 1.631-1.605 1.707 1.707c1.497 1.497 1.676 1.806 1.48 2.499a6.002 6.002 0 0 0-.185 1.607c.016.449-.094.892-.252.99-.163.1-.287 2.275-.287 5.07v4.895l3.144 2.324 3.143 2.323v2.347c0 2.703-.09 2.567 3.384 5.03l2.305 1.637v3.365c0 1.85.14 3.673.313 4.052.288.625 1.457 1.59 3.1 2.555.425.25 2.14.371 5.303.375l4.677.004.768-1.122zm-87.284-18.115.074-18.487h-22.758v37.13l11.303-.077 11.301-.08zm10.848-3.916v-22.555l-1.066-4.758c-1.024-4.571-1.197-5.17-1.437-4.899-.359.416-6.18 9.272-6.18 9.402 0 .085.206.155.456.155.79 0 1.636 1.809 1.64 3.5 0 1.951-.399 3.02-1.516 4.043l-.879.804v17.956c0 9.876.08 18.168.18 18.43.16.398.838.47 4.49.47h4.312v-22.554zm29.68 22.031c.06-.29.074-9.856.03-21.257l-.08-20.734h-27.234v42.514h13.588c12.699 0 13.593-.034 13.697-.523zm81.247-18.04V310.78l-11.301-.08-11.304-.08v37.141l11.304-.08 11.3-.075zm-50.812 12.196.086-3.225-6.373.08-6.371.08-.088 2.546c-.046 1.397-.01 2.85.084 3.224l.17.678 6.207-.08 6.203-.08.086-3.223zm56.81-18.782c2.24-7.657 4.53-15.469 5.09-17.365.566-1.896 2.05-6.946 3.301-11.228 1.251-4.281 5.23-17.858 8.838-30.169 3.609-12.311 6.563-22.5 6.563-22.642 0-.27-2.435-.99-2.645-.779-.066.06-2.311 7.77-4.99 17.126a39364.868 39364.868 0 0 1-17.684 61.508l-2.824 9.78.024 4.144c.014 2.281.075 4.012.14 3.846.06-.163 1.947-6.567 4.187-14.221zm-62.195 8.908.088-2.022h-12.902v1.896c0 1.044.094 1.988.205 2.102.112.114 2.978.17 6.364.126l6.157-.08.09-2.022zm-102.45-18.683a189615.92 189615.92 0 0 1-9.62-33.937c-9.755-34.419-11.138-39.241-11.345-39.44-.174-.18-2.843.39-3.114.664-.064.06.31 1.503.826 3.201 1.317 4.326 1.786 5.889 7.06 23.599 2.575 8.643 7.165 24.071 10.211 34.28 3.044 10.21 6.435 21.593 7.537 25.298l2.002 6.732.084-3.632.084-3.633-3.729-13.134zm84.67 9.89c.39-.147.475-.708.47-3.067 0-1.585-.119-3.064-.259-3.282-.14-.227-.624-.359-1.117-.299l-.867.1-.085 3.117c-.092 3.523.203 4.072 1.862 3.434zm8.197-.07c.28-.179.36-.981.3-2.913l-.09-2.675-2.844-.084c-4.326-.132-4.192-.22-4.192 2.735 0 1.525.14 2.614.36 2.834.413.411 5.84.499 6.466.106zm3.593 0c.28-.179.36-1.071.296-3.362l-.086-3.12h-2.096l-.086 2.974c-.048 1.637-.02 3.15.064 3.367.168.44 1.305.523 1.906.14zm-10.27-9.027c0-.347-.468-.47-2.065-.539-1.218-.052-2.202.046-2.391.24-.575.572.443.906 2.51.824 1.498-.06 1.947-.18 1.947-.525zm11.697.265c.344-.552-.519-.854-2.455-.858-1.722-.004-2.826.471-2.301.994.34.343 4.537.224 4.756-.134zm-12.02-1.646c.56-.212.627-1.338.114-1.85-.2-.2-1.114-.36-2.036-.36-.922 0-1.836.16-2.036.36-.387.387-.485 1.508-.16 1.836.25.25 3.478.26 4.119.016zm11.677 0c.663-.254.59-1.527-.106-1.902-.946-.507-3.167-.374-3.918.233-.573.465-.619.643-.32 1.198.296.559.603.654 2.108.654.97 0 1.976-.08 2.236-.183zm-13-3.094c0-.403-.547-.683-.902-.46-.168.1-.228.31-.134.464.23.365 1.038.36 1.038 0zm11.377-.164c-.371-.449-.898-.353-.898.166 0 .154.285.28.635.28.53 0 .573-.074.265-.448zm-57.781-.449c1.526-.814 1.357-4.105-.244-4.77-.579-.24-4.42-.315-13.034-.256-11.696.08-12.235.112-12.64.667-.655.894-.55 3.333.173 4.06.58.579.998.599 12.894.599 7.56 0 12.51-.114 12.85-.3zm122.243-.57c.703-1.19.663-2.875-.085-3.623-.58-.58-.998-.6-13.044-.6-7.655 0-12.659.115-13 .3-.669.36-1.022 1.765-.752 2.994.409 1.867-.12 1.797 13.728 1.797h12.638l.515-.87zm-84.515-4.232c-2.55-.353-25.381-.34-25.599.012-.124.2 4.451.285 13.529.26 7.704-.025 12.994-.146 12.07-.272zm83.805-2.615c.425-.519 1.547-2.155 2.495-3.648l1.716-2.707h-16.315c-8.972 0-16.313.092-16.313.204 0 .568 4.28 6.954 4.717 7.035.279.052 5.552.086 11.716.076l11.21-.016.772-.942zm-120.068-2.489c1.193-1.826 2.243-3.513 2.335-3.742.14-.36-2.24-.423-16.188-.423-8.993 0-16.35.085-16.35.19 0 .223.744 1.464 2.898 4.823l1.58 2.472h23.553zm37.963 2.346c.24-.366 1.864-5.545 1.882-5.988.024-.54-1.447-.154-2.107.552-1.194 1.274-3.134 2.244-4.843 2.422-2.01.207-4.359-.719-5.58-2.204-.727-.882-1.026-1.022-2.25-1.046-1.118-.024-1.677.16-2.667.868-3.013 2.152-5.654 2.883-7.874 2.18-.644-.204-1.942-.958-2.89-1.683-1.649-1.261-2.918-1.69-2.918-.986 0 .3.373 1.857 1.228 5.13l.293 1.126h13.742c10.667 0 13.797-.084 13.984-.375zm-57.384-23.054c.004-8.108.113-14.916.247-15.126.186-.291 1.545-.359 5.76-.299l5.515.08.08 15.05.076 15.041h4.188v-33.832h-20.954l-.08 16.792c-.044 9.236-.024 16.847.044 16.916.068.068 1.248.124 2.62.124h2.496l.006-14.744zm8.23 3.07v-11.527h-5.09l-.08 11.617-.076 11.61 2.62-.086 2.625-.09zm114.22-3.443v-15.12h11.376v30.24h4.497l-.08-16.84-.073-16.843-10.106-.08-10.106-.08v33.842h4.491zm7.714 3.519-.08-11.603h-5.09l-.08 11.603-.076 11.6h5.404l-.08-11.6zm-13.84-21.856c-.112-.3-10.21-.376-49.102-.376-38.97 0-48.961.076-48.961.376l-.076 14.518c-.04 7.785-.006 14.146.076 14.146s.471-.579.868-1.278c4.685-8.293 11.725-14.77 21.178-19.48 13.732-6.847 30.664-8.104 45.169-3.35 11.842 3.879 22.408 12.455 28.594 23.21a117.58 117.58 0 0 0 1.768 2.994c.44.69.484-.451.555-14.82.044-8.563.014-15.737-.065-15.942zm23.782-2.75c.17-.32.309-.791.309-1.049 0-.425-6.86-.463-72.823-.395-69.984.074-72.83.1-72.93.619-.289 1.497-5.15 1.403 72.68 1.403 71.325 0 72.458-.01 72.764-.579zm2.195-3.618c1.026-.81 2.104-2.598 1.896-3.147-.15-.387-9.606-.431-78.072-.366-59.896.06-77.93.16-78.023.434-.188.564 2.225 2.704 3.604 3.193 1.098.387 10.609.447 75.54.467 74.051.024 74.29.02 75.053-.579zm4.238-5.808c1.09-.459 1.808-1.457 1.543-2.146-.14-.367-11.45-.415-82.127-.35-79.065.073-81.97.095-82.069.618-.12.619.695 1.65 1.593 2.016.33.14 36.474.255 80.324.267 68.1.016 79.871-.04 80.738-.403zm4.65-5.05c.411-.21.793-.613.849-.898.091-.487-4.591-.515-85.085-.515-46.852 0-85.252.114-85.338.25-.084.14.05.543.3.898l.452.648 84.039-.004c67.001-.004 84.19-.08 84.79-.379zm20.547-3.133c.499-.5.413-.533-1.85-.703-3.683-.28-5.166-1.337-4.823-3.457.2-1.238-.439-1.377-1.173-.26-1.05 1.605.191 3.697 2.72 4.581 1.53.533 4.52.44 5.124-.165zm-214.05-1.074c.853-.433 1.642-.934 1.753-1.112.396-.643-.151-.643-1.477 0-.742.36-2.086.728-2.986.822-1.473.152-1.708.092-2.407-.606-.513-.51-.778-1.106-.782-1.757l-.012-.988-.613.739c-.747.894-.583 2.175.413 3.245.605.653.852.709 2.615.585a9.076 9.076 0 0 0 3.497-.924zm152.49.826c0-.096-4.483-2.37-9.96-5.054l-9.966-4.884-9.122-.693c-6.197-.473-11.67-.698-17.06-.706-7.514-.008-10.055.126-22.893 1.213l-5.383.46-9.74 4.644c-5.354 2.555-9.865 4.77-10.02 4.918-.172.164 18.718.272 46.929.272 25.968 0 47.215-.08 47.215-.172zM387.56 220.088c0-9.784-.08-18.003-.18-18.263-.128-.333-.575-.473-1.497-.473h-1.323v36.527h2.994v-17.79zm4.49-.489V201.32l-1.42.09-1.424.09-.08 17.814c-.04 9.8-.01 17.984.068 18.187.084.224.689.375 1.497.375h1.358v-18.279zm5.027.914c.048-9.468.006-17.652-.09-18.189-.166-.924-.24-.972-1.505-.972h-1.338v36.558l1.422-.09 1.423-.09.086-17.215zm112.264-.822-.076-18.19-1.421-.091-1.424-.092v36.56h2.998l-.08-18.187zm4.564-.092V201.32l-1.42.09-1.424.09-.086 17.215c-.048 9.467-.006 17.655.09 18.19.166.924.24.971 1.507.971h1.333v-18.279zm5.016.092-.076-18.19-1.423-.091-1.42-.092v18.08c0 9.944.089 18.171.199 18.279.11.11.786.2 1.497.2h1.301l-.08-18.188zm-41.043 6.936c.425-1.106-.41-1.257-10.38-1.896-12.069-.778-22.242-.792-34.546-.04-9.36.567-9.95.675-9.544 1.736.13.336.586.39 2.143.25a623.605 623.605 0 0 1 10.212-.659c9.836-.583 23.616-.399 34.13.455l7.27.587a.743.743 0 0 0 .715-.433zm-33.776-3.712c9.64-.324 19.988-.104 27.588.586 4.372.4 6.491.39 6.082-.02-.465-.467-13.273-1.417-22.235-1.648-4.71-.12-10.391-.06-14.79.163-8.717.44-16.926 1.082-17.194 1.348-.529.529.926.594 5.679.26 2.85-.2 9.54-.51 14.87-.69zm-10.735-1.643c13.645-.97 24.765-.894 39.072.267 2.8.226 5.145.36 5.215.294.32-.308-.495-.46-4.646-.868-13.142-1.292-25.589-1.338-41.736-.148-6.627.489-7.785.63-7.785.958 0 .2.659.244 1.87.124 1.03-.1 4.635-.383 8.01-.623zm-3.592-1.916c12.363-1.637 30.632-1.523 43.802.275 5.081.695 4.73.789 7.453-2.016 2.94-3.028 4.916-7.65 5.24-12.275.227-3.18-.259-5.623-1.706-8.629-1.487-3.087-3.437-5.463-6.487-7.916-2.578-2.076-2.778-2.185-10.578-5.964-2.715-1.317-5.815-2.974-6.886-3.682-1.813-1.198-4.551-3.705-5.76-5.27-.49-.632-.74-.672-4.128-.672h-3.605l-3.058 2.894c-4.252 4.028-6.08 5.17-13.09 8.183-10.127 4.352-14.936 9.85-15.708 17.964-.51 5.363 1.782 11.73 5.858 16.275 1.517 1.693 1.617 1.749 2.794 1.597a1995.902 1995.902 0 0 0 5.859-.768zm-30.3-21.006c1.412-1.313.947-3.517-.874-4.152-.604-.211-3.882-.33-9.005-.33-8.899 0-9.485.103-10.076 1.795-.363 1.046-.21 1.663.653 2.621.598.67.648.673 9.626.673 8.65 0 9.05-.026 9.675-.607zm122.021-.128c1.361-1.257.938-3.173-.868-3.932-.789-.327-2.785-.423-8.942-.423-8.008 0-9.188.136-9.946 1.138-.619.81-.495 2.475.24 3.26l.652.692h18.07l.792-.735zm-124.362-6.002c0-.387-1.032-.449-7.485-.449-6.832 0-7.884.1-7.285.699.11.11 3.477.2 7.485.2 6.277 0 7.285-.06 7.285-.45zm121.855 0c0-.387-1.012-.449-7.317-.449-6.64 0-8.02.132-7.445.707.106.106 3.469.192 7.477.192 6.277 0 7.285-.06 7.285-.45zm-121.07-2.131c1.692-.805 2.36-2.036 2.36-4.358 0-1.736-.12-2.161-.9-3.263a13.12 13.12 0 0 0-2.047-2.196l-1.152-.928-5.588-.093c-3.07-.052-6.038-.01-6.593.093-1.198.226-3.665 2.423-4.355 3.878-.615 1.294-.61 3.757.012 5.056.267.563.974 1.306 1.572 1.653 1.018.59 1.517.629 8.374.635 6.117.006 7.455-.07 8.315-.48zm122.3-.196c1.98-1.325 2.628-4.191 1.505-6.657-.595-1.305-2.623-3.3-3.819-3.756-.413-.156-3.201-.28-6.195-.28-4.665.007-5.615.086-6.643.563-3.88 1.8-5.315 6.797-2.748 9.57.359.386.922.814 1.251.951.33.138 3.982.256 8.114.268 7.331.02 7.545.004 8.535-.659zm-124.582-12.136c0-.81-.904-.958-5.838-.958s-5.838.148-5.838.958c0 .132 2.627.24 5.838.24 3.214 0 5.838-.108 5.838-.24zm121.855 0c0-.806-.902-.958-5.728-.958-4.152 0-5.09.08-5.477.471-.26.26-.471.527-.471.6 0 .07 2.626.127 5.836.127 3.213 0 5.84-.108 5.84-.24zm-124.645-2.56c.088-.086-.599-.899-1.517-1.797-.924-.898-1.68-1.517-1.68-1.369 0 .148-.68.914-1.512 1.697-1.445 1.365-1.48 1.437-.822 1.64.743.232 5.27.092 5.533-.17zm121.95.066c0-.184-.728-1.038-1.622-1.897-1.609-1.547-1.625-1.552-1.988-.878-.2.38-.882 1.104-1.517 1.617-.635.513-1.158 1.058-1.158 1.211 0 .164 1.351.286 3.142.286 2.136 0 3.146-.108 3.146-.34zm-59.15-3.845c.642-.245.768-.483.768-1.46 0-.66-.192-1.326-.44-1.532-.304-.255-1.921-.351-5.46-.327-4.317.03-5.08.106-5.401.535-.553.734-.46 1.796.223 2.479.545.545.998.599 5.07.599 2.46 0 4.818-.132 5.24-.292zm.14-5.736c1.097-1.178 1.6-2.615 1.393-4-.23-1.525-1.302-3.088-4.408-6.42-2.023-2.169-2.335-2.398-2.594-1.915-.16.3-1.25 1.626-2.415 2.944-2.481 2.794-3.324 4.341-3.324 6.101 0 1.378.328 2.2 1.288 3.254.582.639.83.675 5.041.675 4.136 0 4.467-.04 5.022-.64zm113.022 189.512c-4.685-3.499-10.036-9.884-12.1-14.439-1.161-2.558-1.916-6.407-1.676-8.538.223-1.966 1.153-4.481 2.279-6.168.44-.659 2.347-3.489 4.241-6.287 6.098-9.022 12.435-20.375 14.012-25.124.36-1.082.805-2.056.986-2.17.184-.113.982.506 1.823 1.422 3.018 3.273 5.385 7.688 6.48 12.091.58 2.336.653 3.238.532 6.887-.12 3.56-.264 4.566-.959 6.596-1.187 3.483-2.335 5.455-5.335 9.174-4.78 5.928-6.894 9.764-8.187 14.86-1.082 4.275-.946 9.4.339 12.72.333.855-.252.611-2.435-1.018zM329.1 353.068c.615-2.396.693-3.274.58-6.511-.196-5.573-1.224-8.012-6.995-16.587-6.02-8.942-7.425-12.698-7.41-19.79.007-3.733.1-4.457.812-6.607.439-1.327 1.467-3.519 2.275-4.87 1.749-2.906 4.511-6.391 4.946-6.247.172.06.828 1.307 1.457 2.774 3.603 8.383 7.505 15.375 13.094 23.445 4.958 7.165 6.283 10.59 6.283 16.223 0 7.134-3.373 12.465-11.822 18.703-2.176 1.6-3.22 2.239-3.669 2.239-.145 0 .056-1.247.45-2.77zm10.55-33.4c-9.522-14.726-14.725-25.342-16.348-33.342-1.144-5.659.36-11.752 4.244-17.165 1.746-2.436 5.772-6.388 6.051-5.94.116.187 4.112 10.051 8.883 21.915l8.67 21.577-2.116 2.18c-4.211 4.345-6.527 9.155-6.339 13.153.056 1.132.03 2.046-.052 2.036-.082-.01-1.429-1.996-2.994-4.417zm217.358 2.26c-.008-4.45-2.206-8.846-6.757-13.505l-1.71-1.752 2.243-5.583c1.234-3.068 5.18-12.888 8.766-21.822 3.585-8.932 6.613-16.241 6.727-16.241.405 0 4.331 4.068 5.64 5.838 3.781 5.122 5.57 11.736 4.585 16.97-.443 2.36-2.17 7.68-3.529 10.858-1.46 3.433-5.025 10.208-7.57 14.395-2.481 4.084-8.098 12.715-8.276 12.715-.06 0-.12-.845-.12-1.873zM429.157 145.73c-3.22-3.094-3.605-3.569-3.188-3.916.412-.34.829-.06 3.114 2.1 4.252 4.028 4.196 3.984 4.719 3.552.253-.211.459-.495.459-.634 0-.14-.739-1.082-1.647-2.096-1.441-1.617-2.024-2.669-1.477-2.669.174 0 2.255 2.224 3.333 3.557.43.527.745.659 1.232.503.359-.114.654-.3.654-.413 0-.112-1.141-1.806-2.534-3.76-1.398-1.956-2.47-3.673-2.382-3.817.423-.682 1.166.006 3.413 3.178 1.344 1.89 2.55 3.505 2.675 3.585.126.08.475-.028.763-.24.487-.36.439-.55-.707-2.828-1.377-2.735-1.381-2.755-.838-2.755.213 0 .914 1.078 1.557 2.396 1.133 2.327 1.576 2.714 2.47 2.147.284-.18-.035-1.157-1.273-3.912-1.69-3.772-1.96-4.822-1.23-4.822.248 0 1.134 1.6 2.17 3.928.966 2.16 1.93 3.996 2.148 4.082.858.335.912-.443.193-2.775-.818-2.648-.898-3.241-.407-3.08.18.06.69 1.25 1.134 2.643.527 1.657.974 2.567 1.291 2.627.266.052.55-.014.631-.148.08-.132-.24-2.044-.712-4.251-.48-2.202-.79-4.122-.703-4.264.15-.243 1.022-.379 1.022-.16 0 .44 1.78 8.368 1.908 8.496.09.09.38.08.647-.024.489-.188.479-1.046-.05-4.75-.126-.875-.06-1.127.29-1.127.339 0 .498.503.642 2.022.308 3.22.44 3.667 1.078 3.667.543 0 .575-.264.575-4.663 0-4.28.044-4.654.523-4.563.469.09.535.595.609 4.663.075 4.196.125 4.563.63 4.563.44 0 .587-.315.739-1.573.104-.864.19-2.144.191-2.842 0-.948.12-1.274.465-1.274.4 0 .434.408.254 3.024-.2 2.868-.18 3.02.36 2.914.472-.09.724-.824 1.472-4.291.71-3.287 1.014-4.207 1.421-4.285.707-.136.673.549-.231 4.81-.898 4.227-.892 4.116-.16 4.116.48 0 .743-.483 1.385-2.55.743-2.382 1.148-3.113 1.513-2.748.084.084-.2 1.266-.63 2.63-.43 1.36-.715 2.654-.631 2.873.403 1.042 1.098.144 2.754-3.553.978-2.167 1.937-3.998 2.14-4.063.882-.296.593 1.01-1.006 4.562-1.397 3.1-1.637 3.853-1.293 4.072.758.493 1.157.152 2.443-2.102 1.161-2.035 2.02-2.948 2.02-2.147 0 .173-.613 1.351-1.362 2.615-1.037 1.756-1.269 2.363-.974 2.554.587.37 1.354.3 1.523-.14.32-.838 4.475-6.347 4.85-6.434 1.025-.24.605.798-1.516 3.748-2.649 3.673-2.849 4.132-1.916 4.427.522.168.842-.02 1.596-.944 1.968-2.411 2.795-3.198 3-2.862.112.18-.51 1.177-1.39 2.215-2.117 2.501-2.14 2.55-1.418 2.934.545.292.988-.02 3.912-2.754 1.812-1.697 3.425-3.128 3.583-3.184.157-.055.375.124.479.396.14.359-.773 1.417-3.37 3.902-1.955 1.876-3.712 3.413-3.901 3.423-.192.008-.89-.44-1.553-.992-1.757-1.471-6.272-3.709-8.948-4.441-3.194-.87-10.304-.938-13.405-.124-2.769.727-6.637 2.543-8.988 4.22-1.038.744-2.026 1.353-2.188 1.353-.16 0-1.94-1.585-3.952-3.523zm4.744-17.36c-.81-.945-.838-1.193-.213-1.985.758-.968 1.467-.998 2.315-.092.822.874.819 1.144-.04 1.95-.838.787-1.457.827-2.06.128zm-7.349-1.023c-.698-.16-1.273-.395-1.273-.531 0-.14.844-.303 1.876-.37 2.371-.149 3.998-.977 5.16-2.62.852-1.21.87-1.291.349-1.67-.719-.526-.555-1.761.25-1.88 1.746-.26 1.927-.386 2.28-1.568.2-.658.46-1.193.59-1.193.13 0 .39.774.586 1.722.44 2.136.994 3.246 1.857 3.705.798.425 7.153.413 11.303-.028a75.897 75.897 0 0 1 3.367-.305c.818-.008.619-.87-.255-1.088-.43-.108-2.555-.04-4.717.16-2.926.259-4.331.265-5.489.02-1.93-.42-2.315-.823-1.876-1.98.693-1.843 3.281-3.783 6.068-4.551 1.074-.294 1.137-.276 1.048.323-.07.479-.62.848-2.192 1.483-1.154.469-2.5 1.184-2.994 1.59-.884.733-.888.75-.3 1.218.526.42 1.306.453 6.039.276 5.253-.196 5.457-.18 6.061.423a2.046 2.046 0 0 1-.063 2.964c-.563.529-1.394.728-4.563 1.098a78.223 78.223 0 0 1-7.473.455c-4.421 0-5.216-.355-6.042-2.679-.3-.832-.63-1.513-.743-1.513-.469 0-1.736 1.888-2.195 3.274-.565 1.704-1.73 2.842-3.385 3.301-1.278.353-1.547.351-3.282-.04zm37.8-1.67a26.65 26.65 0 0 1-.842-1.086c-.34-.474-.511-.505-1.066-.21-.95.507-3.154.3-3.27-.315-.12-.64 1.244-2.232 2.695-3.146.639-.403 1.31-1.064 1.493-1.471.184-.407.435-.739.559-.739.124 0 .267 1.15.325 2.555.112 2.755.324 3.122 1.805 3.13.519 0 1.028-.284 1.44-.81.57-.725.616-1.044.44-2.955-.2-2.09-.03-3.417.425-3.417.124 0 .38 1.164.569 2.585.395 2.93.83 3.793 2.156 4.256 1.327.459 1.397-.026.455-3.12-.723-2.375-.813-4.02-.22-4.02.124 0 .675 1.467 1.23 3.26.882 2.874.958 3.385.654 4.315-.539 1.636-2.14 1.916-3.786.658l-.978-.746-.898.898c-1.038 1.038-2.487 1.206-3.188.375zm-1.986-2.66c.898-.179 1.317-1.037.693-1.424-.32-.2-2.15.914-2.15 1.309 0 .353.194.37 1.457.116zm13.39-.892c-.11-1.467-.344-3.964-.516-5.548-.26-2.388-.24-3.028.12-3.713.42-.798.447-.726.804 2.122.44 3.473.48 8.573.076 9.293-.2.36-.34-.25-.483-2.156zm-124.458 1.152c-.451-1.163-.108-3.17.808-4.734.747-1.278.759-1.37.283-2.096-.275-.42-.459-1.124-.407-1.563.084-.728.274-.567 2.148 1.836 2.275 2.914 3.154 3.473 4.287 2.735.859-.563 1.889-2.166 1.89-2.93 0-.3-.644-1.242-1.437-2.096-2.744-2.978-3.353-3.816-3.353-4.615 0-.718.286-.513 2.954 2.106 2.864 2.814 2.988 2.9 4.322 2.9 1.037 0 1.576-.18 2.215-.744l.838-.747-1.217-1.126a93.756 93.756 0 0 0-2.914-2.562c-1.098-.93-1.787-1.773-1.952-2.396-.14-.528-.144-1.004-.008-1.057.26-.106 3.253 2.409 5.854 4.918 1.421 1.369 1.585 1.656 1.585 2.794 0 .99-.186 1.447-.855 2.116-.986.988-2.642 1.393-3.892.958l-.872-.304-.14 1.637c-.253 3.094-2.894 4.525-5.253 2.846l-.964-.686v.712c0 .988-2.172 2.92-3.284 2.92-.18 0-.467-.37-.638-.824zm2.103-2.645c1.006-.846 1.146-1.36.511-1.888-.323-.267-.519-.18-.906.415-.698 1.066-1.118 2.248-.794 2.248.148 0 .684-.35 1.19-.775zm102.87-.798c-.32-2.345-.57-4.838-.554-5.539.02-1.052-.071-1.271-.534-1.271-.783 0-.795-2.096-.014-2.799.686-.618 1.429-.638 1.66-.033.2.522-.499.906-1.038.572-.215-.133-.3-.064-.22.186.077.22.6.519 1.164.669l1.024.263-.718.583-.719.579.5 3.06c.514 3.21.63 4.62.544 6.726-.1 2.411-.519 1.258-1.098-2.994zm89 2.321c-1.397-.934-1.956-1.485-1.836-1.796.2-.523.12-.499 2.056-.585.822-.04 1.982-.227 2.579-.425.988-.327 1.097-.479 1.271-1.736.104-.759.19-2.75.19-4.426 0-2.774-.066-3.133-.749-4.057-.912-1.238-.954-2.356-.128-3.403.887-1.124 1.401-.987 1.803.485.385 1.407.479 8.628.14 10.626-.16.93-.12 1.274.153 1.274.579 0 4.89-4.523 5.816-6.108.719-1.222 2.068-2.256 2.45-1.876.249.251-.64 2.894-.979 2.894-.191 0-1.34 1.028-2.554 2.285-1.214 1.258-2.887 2.727-3.721 3.268-1.212.782-1.597 1.237-1.896 2.241-.391 1.311-1.513 2.687-2.192 2.687-.215 0-1.297-.607-2.4-1.348zm3.48-.922c.346-.91.195-1.078-.795-.864-1.282.28-1.381.407-.69.912.758.555 1.257.54 1.482-.048zm-18.76-.032c-1.807-.479-2.175-.878-1.045-1.137.818-.188 4.683.774 4.79 1.193.12.475-1.864.445-3.744-.056zm4.226-2.032c-.08-.08-.868-.327-1.756-.554-1.625-.416-2.385-1.102-1.224-1.102.42 0 .625-.192.625-.579 0-.87.825-1.517 1.93-1.517 1.088 0 1.827.639 1.557 1.343-.227.587-1.092.591-1.092.004 0-.26-.27-.449-.63-.449-.451 0-.58.134-.45.473.1.26.18.52.18.575 0 .056.473.393 1.05.749.579.359.974.772.878.922-.175.29-.834.371-1.072.133zm-104.03-2.714c1.138-1.004 1.158-1.052.643-1.623-.66-.726-.424-1.95.463-2.425 1.018-.543 1.469-.14 1.469 1.297 0 1.458-.296 1.969-1.777 3.054-1.573 1.148-2.175.918-.798-.305zm1.976-2.515c0-.41-.527-.679-.719-.365-.18.29.08.644.47.644.14 0 .249-.127.249-.279zm28.794 2.764a37.927 37.927 0 0 1 1.098-.872c.05-.036-.128-.405-.4-.824-.588-.892-.383-1.842.503-2.315.885-.474 1.368.165 1.491 1.97.088 1.293.02 1.507-.499 1.608-.327.064-.918.37-1.31.679-.394.31-.979.563-1.298.563-.473 0-.395-.15.415-.809zm2.044-2.467c0-.409-.53-.674-.719-.367-.18.29.08.647.47.647.14 0 .249-.128.249-.28zm3.145.58c-.259-.823.084-1.326.61-.887.482.395 1.037.14 1.037-.479 0-.24.134-.431.3-.431.163 0 .299.2.299.449 0 .247.134.449.3.449.163 0 .299-.26.299-.579 0-.918.559-1.028.778-.16.232.93-.183 1.41-1.647 1.897-1.417.473-1.756.427-1.976-.26zm69.309-.408c0-.06.523-1.237 1.162-2.62a284.768 284.768 0 0 0 2.455-5.506c1.257-2.914 2.93-5.213 3.197-4.405.072.21-.006.547-.167.749-.16.2-.859 1.71-1.557 3.357-2.366 5.609-4.024 8.533-4.845 8.533-.133 0-.245-.05-.245-.108zm-101.426-.866c.15-.475 4.7-2.739 4.97-2.47.264.26-.613.899-2.71 1.97-1.865.95-2.446 1.079-2.26.5zm10.41-.467c0-.156.199-.451.448-.655.77-.639.513-.986-.599-.806-1.145.185-1.317-.08-.552-.845.369-.367.77-.443 1.568-.293 1.366.255 1.53.365 1.53 1.008 0 .303-.512.814-1.198 1.202-.659.369-1.198.546-1.198.39zm82.078-2.312c-3.964-1.984-4.784-2.964-4.57-5.455.051-.608-.073-.672-1.314-.672-1.629 0-3.142-.699-3.142-1.45 0-.57 1.228-1.856 2.301-2.407.36-.183 1.058-.335 1.547-.335 1.288 0 1.85-.285 2.156-1.088.148-.389.46-.708.695-.708.347 0 .291.513-.288 2.77-.938 3.667-.928 4.551.08 5.49.97.897 5.914 3.416 6.706 3.416.35 0 .779-.427 1.132-1.121.966-1.907 3.633-8.64 3.633-9.176 0-.553 1.281-1.976 1.782-1.976.174 0 .314.573.314 1.277 0 .903-.16 1.372-.54 1.61-.299.185-1.34 2.267-2.32 4.624-1.94 4.67-3.294 6.56-4.7 6.56-.418 0-1.983-.61-3.472-1.357zm-4.118-8.097c.328-.859.192-1.024-.842-1.024-1.301 0-1.972.26-1.972.758 0 .809 2.515 1.048 2.814.266zm-57.15 8.862c-.23-.371.826-1.034 3.119-1.968 2.122-.858 2.587-.809 1.25.144-1.352.958-4.176 2.135-4.372 1.82zm8.528-.06c0-.42.93-1.114 1.297-.972.212.08.755-.27 1.208-.779.453-.509 1.052-.882 1.331-.83.787.15.799 1.397.016 2.23-.588.626-.918.718-2.269.644-.872-.048-1.583-.18-1.583-.291zm3.593-1.33c0-.399-.08-.419-.45-.113-.247.205-.448.423-.448.485s.2.114.449.114c.25 0 .449-.22.449-.485zm-107.212.41c-.427-.535-2.332-2.675-4.232-4.757-2.135-2.339-3.597-4.211-3.82-4.89-.2-.603-.311-1.15-.248-1.213.16-.16 7.665 8.004 8.527 9.275 1.577 2.321 1.391 3.613-.227 1.58zm7.604.251c-1.41-.638-2.562-2.569-2.73-4.578-.1-1.198-.04-1.611.203-1.462.188.116.34.48.34.807 0 .83.838 2.411 1.605 3.03 1.48 1.193 4.69.231 6-1.797 1.365-2.115 1.42-1.96-2.695-7.445-2.082-2.774-3.952-5.183-4.152-5.349-.609-.499-1.064-1.577-.878-2.066.156-.399.335-.373 1.343.2.693.4 1.168.894 1.17 1.217 0 .531 2.13 3.673 5.106 7.537 1.908 2.483 2.08 2.874 2.08 4.725 0 1.313-.164 1.848-.87 2.82-1.633 2.256-4.476 3.285-6.522 2.36zm8.89-.13c0-.14.573-.508 1.272-.818 1.689-.75 4.018-2.94 4.383-4.121.435-1.41.719-3.49.47-3.49-.12 0-.731.154-1.362.344-.958.287-1.264.26-1.904-.16-.645-.419-.763-.722-.763-1.956 0-2.69 1.607-3.499 3.334-1.677.39.41.95.747 1.243.749 1.507.016 4.405-2.361 4.405-3.609 0-.32.136-.579.3-.579.165 0 .299.404.299.899 0 .69.136.898.579.898.904 0 2.195-1.292 2.579-2.579l.347-1.164.335.825c.35.854 1.266 1.087 2.13.539.355-.22.37-.42.08-1.058-.48-1.048-.453-1.952.054-1.952.984 0 1.604 3.652.788 4.638-.236.28-.89.451-1.733.451-1.153 0-1.505.154-2.37 1.046-.7.719-1.394 1.108-2.228 1.238-.667.11-1.571.499-2.01.868-.44.367-1.292.878-1.896 1.128l-1.098.459.032 2.345c.034 2.914-.5 4.266-2.12 5.337-1.61 1.066-5.146 2.024-5.146 1.398zm4.527-10.375c.1-.413-.93-.572-1.297-.203-.168.166-.22.439-.11.613.22.359 1.298.04 1.407-.41zm61.61 9.186c.42-.782 4.222-2.216 4.222-1.593 0 .29-2.455 1.557-3.842 1.976-.631.196-.667.156-.38-.385zm51.078-.699c-.66-.16-1.521-.355-1.917-.439-.65-.133-.678-.195-.26-.609.414-.415.694-.413 2.795.02 2.575.535 2.865.675 2.216 1.086-.53.336-1.238.32-2.834-.06zm-154.222-1.012c-.579-.878-.36-1.311.353-.718.42.347.547.331.867-.106.207-.283.31-.85.231-1.265-.12-.645-.04-.739.565-.673.639.07.703-.03.639-.97l-.072-1.048.593.707c.824.972.762 2.016-.15 2.614-.411.268-.748.665-.748.883 0 .519-.833 1.333-1.362 1.333-.231 0-.644-.34-.918-.759zm211.754-1.437c-2.096-.664-2.585-1.177-1.274-1.341.882-.11 4.966 1.058 4.966 1.421 0 .286-.758.633-1.297.593-.192-.014-1.27-.32-2.395-.675zm-55.964-.425c-1.824-.469-2.167-.848-1.024-1.138.465-.115.685-.379.671-.818-.044-1.277 2.858-1.846 3.32-.649.09.244-.009.655-.22.913-.351.419-.443.395-.892-.2-.28-.37-.655-.57-.845-.455-.559.347.18 1.371 1.344 1.856 1.101.46 1.117 1.038.02.972-.36-.02-1.43-.24-2.376-.485zm-157.706-1.76c0-.431.503-1.717 1.118-2.855.972-1.796 1.165-2.006 1.48-1.572.304.413.16.906-.818 2.854-1.23 2.445-1.78 2.93-1.78 1.573zm58.382-.853c0-.08.649-.475 1.441-.878 1.9-.962 3.43-2.7 4.212-4.79.97-2.591.882-2.968-1.012-4.367-1.224-.905-1.647-1.408-1.647-1.956 0-.873.45-.933 1.551-.206 1.765 1.164 2.64 2.982 2.64 5.479 0 2.978-1.297 5.164-3.742 6.295-1.077.5-3.443.789-3.443.423zm124.597-1.576c.384-.62.765-1.797.849-2.621.128-1.27.251-1.511.822-1.593.575-.08.675.04.675.832 0 1.777-1.589 4.503-2.621 4.503-.315 0-.243-.287.274-1.121zm-22.454-.31a902.961 902.961 0 0 0 3.822-9.074c.982-2.389 2.715-4.55 2.715-3.383 0 .328-.112.725-.248.879-.14.16-.898 1.902-1.69 3.878-1.771 4.407-2.731 6.379-3.537 7.261-.593.645-1.272.926-1.064.44zm-8.882-1.756c-.823-.252-1.597-.551-1.717-.667-.383-.367.673-1.537 1.385-1.537.375 0 1.318-.419 2.096-.938 1.64-1.086 1.637-.904.12-5.798-.835-2.695-1.074-3.13-2.38-4.342-1.636-1.52-1.892-2.684-.868-3.932.58-.702.585-.704 1.038-.11 1.226 1.61 2.93 6.028 4.08 10.58.28 1.107.391 1.237.782.913.998-.828 3.402-6.606 3.402-8.18 0-.432.331-.985.824-1.376l.822-.647.092 1.577c.052.862-.032 1.65-.187 1.748-.154.1-.887 1.457-1.625 3.022-.739 1.565-1.837 3.517-2.431 4.342-.907 1.247-1.086 1.744-1.086 3.001 0 2.763-1.058 3.334-4.341 2.34zm3.445-2.052c0-.894-.18-.918-1.304-.18-.89.585-.702.859.631.904.525.02.673-.14.673-.724zm-15.974-6.952a300.122 300.122 0 0 0-.385-6.82c-.16-2.104-.108-2.483.409-3.122l.589-.723.39 5.739c.4 5.768.23 9.018-.478 9.247-.22.072-.391-1.331-.525-4.32zm34.536 3.868c0-.705.89-.958 3.354-.958 2.604 0 2.974.14 2.275.838-.403.404-5.629.515-5.629.12zm16.092-.28c-1.254-.13-1.437-.488-.5-.991.584-.31 2.262-.234 4.556.207.678.13.772.24.487.583-.34.411-1.877.48-4.543.2zm-59.98-.49c-.508-.23-1.277-.87-1.716-1.425l-.788-1.008-.475.678c-.966 1.371-3.521 2.022-4.95 1.258-.679-.366-1.477-1.805-1.477-2.675 0-.595-.04-.599-.885-.168-1.652.859-4.207.44-4.207-.686 0-.964 1.597-2.447 3.439-3.188 1.469-.595 1.832-.882 2.02-1.6.22-.845 1.004-1.777 1.271-1.51.07.07.02 1.404-.104 2.962-.13 1.557-.147 3.17-.044 3.581.276 1.074 1.517 1.603 2.883 1.228 2.036-.563 2.211-.928 2.211-4.551 0-3.214.346-4.76 1.064-4.76.272 0 .383.974.413 3.632.05 4.044.36 5.046 1.807 5.793.483.251 1.289.455 1.79.455 1.098 0 1.102-.026.423-4.392-.459-2.924-.459-3.223 0-4.185.589-1.23 1.09-1.07 1.09.35 0 .558.22 2.39.483 4.067.527 3.33.34 4.79-.743 5.768-.778.705-2.395.879-3.508.376zm-9.46-5.8c.12-.815-.396-.869-1.97-.212-.883.369-1.018.523-.663.752.243.156.918.252 1.491.208.83-.06 1.068-.22 1.144-.75zm-47.976 5.44a1.93 1.93 0 0 1-.47-1.191c0-.679.079-.71 1.29-.543 1.038.14 1.605.02 2.86-.619.86-.435 1.638-.984 1.73-1.217.09-.234-.188-1.188-.613-2.12-.749-1.627-1.032-3.42-.547-3.42.127 0 .838 1.244 1.573 2.761 1.712 3.533 2.526 4.112 5.05 3.58.923-.19 1.844-.574 2.045-.847.759-1.03 1.89-2.196 2.13-2.196.136 0 .888.5 1.673 1.108 1.223.952 1.686 1.126 3.287 1.23 2.206.14 5.772-.366 7.311-1.035l1.098-.479-.898-.26c-.493-.139-1.876-.344-3.07-.452-1.194-.108-2.17-.308-2.17-.44 0-1.051.923-1.927 3.278-3.117 2.754-1.387 3.652-2.196 4.918-4.411 1.343-2.363 2.714-2.252 3.848.305.48 1.078.515 1.45.228 2.316-.3.918-.46 1.038-1.378 1.038-.568 0-1.489-.19-2.05-.424-.934-.39-1.051-.379-1.556.188-.304.34-1.202 1.052-1.996 1.59l-1.451.979 1.573.34c.864.183 3.233.49 5.265.682 2.036.191 3.696.465 3.696.61 0 .146-.14.523-.309.843-.251.467-.639.579-2.022.583-1.152 0-2.543.305-4.255.926-5.114 1.85-6.308 2.124-9.501 2.17-2.296.033-3.106.147-3.226.458-.191.5-2.147.256-3.5-.445-.811-.419-.943-.419-1.426.02-1.4 1.268-4.06 1.138-5.373-.26l-.679-.724-1.105 1.104c-1.621 1.62-4.306 2.32-5.258 1.365zm15.705-3.704c-.455-.848-.789-.968-1.228-.44-.32.388-.315.52.04.74.24.15.669.275.964.279.44 0 .48-.1.22-.58zm17.385-8.649c-.573-1.07-1.118-1.317-1.671-.758-.479.479-.467.53.194.898.385.214.938.393 1.237.4.425.007.473-.1.24-.54zm-80.239 8.48.934-1.654-.93-.323c-.818-.285-.93-.459-.93-1.447 0-1.198.794-2.247 1.411-1.866.194.12.705.738 1.138 1.377l.79 1.164-.814 1.527c-.858 1.608-1.862 2.874-2.28 2.874-.14 0 .17-.745.683-1.65zm.87-3.422c0-.407-.545-.687-.904-.465-.165.1-.225.311-.13.465.224.365 1.034.36 1.034-.004zm23.054.535c1.078-1.489 1.11-1.816.224-2.206-.879-.385-1.018-1.636-.286-2.538.767-.947 1.393-.64 2.2 1.077.61 1.298.622 1.427.16 1.765-.28.2-.504.51-.504.686 0 .44-1.936 2.46-2.355 2.46-.19 0 .06-.56.559-1.242zm1.148-3.549a.46.46 0 0 0-.4-.3.456.456 0 0 0-.399.3c-.054.164.126.3.4.3.273 0 .455-.134.399-.3zm8.632 4.59c-.3-.295-.24-1.895.066-1.895.144 0 .335.27.42.598.219.839 1.077.456 1.556-.692.371-.878.387-.884.719-.266.439.813 1.231.54 1.231-.419 0-.828.5-.972.67-.195.272 1.245-.81 2.79-1.608 2.295-.16-.096-.613.04-1.01.3-.752.492-1.696.618-2.044.275zm-1.097-2.414c0-.29.91-1.381 2.02-2.431 1.876-1.769 2.03-1.857 2.13-1.202.079.555-.31 1.084-1.793 2.43-2.036 1.847-2.36 2.011-2.36 1.2zm59.28-3.633c0-.152.573-.503 1.274-.782 1.906-.763 2.125-1.022 1.377-1.63-.819-.658-.533-1.662.645-2.269 1.397-.722 1.796-.345 1.796 1.697 0 .988-.12 1.707-.272 1.617-.147-.096-.924.155-1.722.553-1.67.834-3.094 1.207-3.094.812zm4.192-3.483a.45.45 0 0 0-.45-.449c-.466 0-.594.353-.249.699.345.343.699.22.699-.25zm40.718 2.774a6.51 6.51 0 0 0-1.797-.339c-.852-.032-1.067-.17-1.145-.73-.094-.679.389-1.557.854-1.557.132 0 .17.253.088.565-.232.886.475 1.063 1.429.359.838-.619.872-.619.872-.066 0 .59.964 1.19 1.128.699.05-.152.285-.53.519-.839.409-.539.431-.53.439.208.01.698-.491 1.387-1.337 1.836-.166.09-.64.026-1.048-.14zm-89.648-1.393c-.092-.145.036-.43.28-.634.664-.553.567-1.497-.152-1.497-.812 0-.755-.416.12-.883.99-.53 1.457-.15 1.317 1.068-.132 1.13-.13 1.134.679.699.473-.252.549-.515.403-1.421-.146-.918-.046-1.254.583-1.936.878-.945 2.16-1.098 2.415-.284.213.659-.888 3.832-1.294 3.737-.163-.04-1.012.265-1.886.67-1.71.799-2.207.898-2.463.48zm4.565-3.573c.06-.419-.06-.652-.343-.652-.493 0-.779.559-.575 1.137.203.58.81.26.918-.487zm6.401 3.48c-.435-.434-.479-2.036-.06-2.036.166 0 .3.193.3.43 0 .24.14.52.32.63.454.283 1.476-.74 1.484-1.478.006-.606.024-.602.559.088.639.833 1.23.623 1.23-.433 0-.838.499-.992.67-.208.274 1.25-.778 2.695-1.762 2.42-.14-.04-.687.16-1.214.439-1.142.607-1.078.599-1.527.15zm42.343-1.591c-.579-.58-.603-.87-.13-1.737l.351-.655.18.727c.244 1.014.794 1.098 1.563.232l.655-.739.513.639.514.634.376-.822c.459-1.004.878-1.066.878-.132 0 1.214-.71 1.837-2.14 1.87-.718.02-1.52.13-1.788.25-.296.134-.679.028-.974-.27zm-34.02-.25c0-.585.799-1.201 2.95-2.275 3.282-1.645 2.895-.236-.425 1.545-2.315 1.245-2.525 1.305-2.525.73zm68.43-1.07c.506-.527 1.098-.678 3.228-.828 2.296-.16 2.589-.128 2.43.287-.25.655-.62.759-3.633.984l-2.64.2.62-.639zm-58.665-1.157c.347-.28 1.018-.803 1.497-1.158l.864-.639-.675-.642c-.83-.79-.838-1.046-.053-2.144.387-.545.886-.87 1.337-.87.59 0 .742.19.892 1.123.1.62.23 1.392.293 1.72.088.464-.339.891-1.864 1.873-1.99 1.278-3.597 1.797-2.291.739zm3.11-3.807a.451.451 0 0 0-.45-.449c-.467 0-.592.356-.25.699.344.345.7.22.7-.25zm-21.557 3.673c0-.228.167-.63.375-.894.411-.53 4.42-3.024 4.587-2.855.39.388-.455 1.53-1.627 2.202-.758.44-1.826 1.058-2.36 1.381-.75.451-.973.49-.973.168zm42.514-1.018c0-.739.918-1.363 3.01-2.062 1.33-.439 2.48-.742 2.555-.667.31.31-.271 1.086-1.022 1.37-1.796.678-4.543 1.5-4.543 1.357z'/%3e%3c/svg%3e";
            },
            6772: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 138 92'%3e%3cpath fill='%23fff' d='M0 0h138v92H0z'/%3e%3cpath d='M0 0h138v46H0z'/%3e%3cg transform='translate(69 36)'%3e%3cg id='b'%3e%3cpath id='a' fill='%23fcd116' d='M-30 0 0-5.742V5.742z'/%3e%3cuse xlink:href='%23a' transform='rotate(22.5)'/%3e%3cuse xlink:href='%23a' transform='rotate(45)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(67.5)'/%3e%3cuse xlink:href='%23b' transform='rotate(135)'/%3e%3c/g%3e%3cpath fill='%230072c6' d='M0 36h138v20H0z'/%3e%3cpath fill='%23ce1126' d='M0 0v92h138V0L69 92z'/%3e%3c/svg%3e";
            },
            5897: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 600'%3e%3cclipPath id='a'%3e%3cpath d='M0 0v150h700v150H600zm600 0H300v350H0v-50z'/%3e%3c/clipPath%3e%3cpath fill='%23012169' d='M0 0h1200v600H0z'/%3e%3cpath stroke='%23fff' stroke-width='60' d='m0 0 600 300m0-300L0 300'/%3e%3cpath stroke='%23c8102e' stroke-width='40' d='m0 0 600 300m0-300L0 300' clip-path='url(%23a)'/%3e%3cpath stroke='%23fff' stroke-width='100' d='M300 0v350M0 150h700'/%3e%3cpath stroke='%23c8102e' stroke-width='60' d='M300 0v350M0 150h700'/%3e%3cpath fill='%23012169' d='M0 300h600V0h200v400H0z'/%3e%3cpath fill='%23cc3' d='M780.583 154.039c0 148.827 11.873 201.675 52.606 242.479 40.734 40.804 56.166 47.231 67.524 53.483 13.101-7.212 28.197-15.134 65.115-52.052 36.513-36.515 54.173-89.15 54.173-246.452-26.56 11.37-39.786 15.117-63.012 15.05-17.202 1.686-43.74-9.337-59.609-16.547-10.37 6.602-25.415 14.476-52.451 15.36-31.225 1.31-41.12-3.735-64.345-11.322z'/%3e%3cpath fill='%23fff' d='M787.775 163.438c0 46.043-2.722 108.794 7.006 145.1 9.77 36.462 12.013 41.803 19.36 54.528l171.206-1.27c10.576-18.319 11.11-29.666 18.953-58.936 7.814-29.165 9.788-94.177 10.016-142.6-17.216 8.725-39.761 14.908-61.643 12.195-17.543-1.275-33.752-5.092-52.627-15.264-16.374 9.353-22.082 13.622-49.119 14.714-21.05.99-38.101 2.615-63.152-8.468z'/%3e%3cpath fill='%239cf' d='M814.51 362.056c12.185 24.448 69.632 71.303 86.433 81.003 19.168-11.067 69.848-57.368 83.973-81.003H814.51z'/%3e%3cpath fill='%23f90' d='M904.221 231.606c5.414 12.14 22.77 25.545 27.541 32.114-6.073 6.57-7.287 5.854-6.49 18.06 10.56-10.535 10.75-11.633 17.542-10.035 14.88 14.155 2.663 44.557-9.634 51.166-12.294 7.051-10.062-.244-28.489 8.593 8.449 6.887 18.237-1.01 26.236 1.1 4.347 4.918-2.066 13.879 1.313 22.318 7.07-.65 6.22-14.256 7.866-19.19 5.164-18.076 36.214-30.683 37.793-47.263 6.546-2.93 13.09-.917 21.05 3.345-3.964-15.534-17.079-15.367-20.594-20.218-8.368-12.19-15.785-26.098-33.657-29.706-13.567-2.739-12.553.824-21.247-4.83-5.414-4.018-21.861-11.618-19.23-5.454z'/%3e%3cpath fill='%23f90' d='M860.839 283.106c8.73-10.234 13.053-31.127 16.917-38.218 8.93 2.05 8.833 3.408 19.78-2.965-14.703-3.981-15.81-3.628-17.501-10.1 6.177-19.155 40.078-23.06 51.953-15.781 12.282 7.068 4.474 8.596 21.278 20 2.44-10.34-9.457-14.901-11.236-22.63 2.53-5.961 13.836-4.741 20.084-11.532-3.905-5.656-16.127 1.416-21.471 2.334-19.177 4.091-45.373-16.193-61.488-9.778-5.776-4.15-6.965-10.606-6.732-19.307-12.554 10.598-6.272 21.575-9.129 26.805-7.397 12.748-16.83 25.497-11.827 42.248 3.798 12.716 6.629 10.197 5.447 20.166-1.198 6.441-.562 23.856 3.925 18.758z'/%3e%3cpath fill='%23f90' d='M931.763 290.302c-13.703-1.828-34.694 5.451-43.059 5.967-2.778-8.347-1.51-8.97-12.893-14.605 4.032 14.055 4.922 14.776-.013 19.504-20.39 4.868-41.432-20.773-41.04-34.226-.009-13.678 5.401-8.097 6.946-27.707-10.543 3.357-8.485 15.424-14.502 20.874-6.66 1.02-11.413-8.837-20.74-10.422-3.058 6.111 9.613 12.426 13.201 16.311 13.592 13.53 8.935 45.397 23.029 55.227-.738 6.86-5.918 11.17-13.85 15.48 16.009 4.76 22.613-6.043 28.785-6.417 15.27-.56 31.594.542 44.043-12.205 9.45-9.676 5.724-10.682 15.285-14.875 6.401-2.355 21.705-11.882 14.808-12.906z'/%3e%3ccircle cx='266.239' cy='122.104' r='.806' fill='%23fff' transform='matrix(3.50845 0 0 3.34488 6.33 -163.011)'/%3e%3ccircle cx='266.239' cy='122.104' r='.806' fill='%23fff' transform='matrix(-1.639 -2.95744 3.10207 -1.56258 914.323 1224.328)'/%3e%3ccircle cx='266.239' cy='122.104' r='.806' fill='%23fff' transform='matrix(-1.80698 2.86712 -3.00733 -1.72273 1749.003 -240.213)'/%3e%3c/svg%3e";
            },
            1648: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 980 700'%3e%3cpath fill='red' d='M980 0H0v700h980z'/%3e%3cpath fill-rule='evenodd' d='M516.51 528.944c-6.15-5.332-13.605-16.13-13.5-26.538.55-7.761 5.873-12.27 9.312-2.796 4.862 10.457 15.29 27.749 29.66 17.605 6.278-4.608 6.18-11.392-2.428-10.614-10.63-.728-17.16-6.577-21.917-21.636-.865-8.282 2.58-8.075 7.387-2.747 6.18 7.09 18.478 17.806 32.046 12.063 7.54-3.16 9.668-9.68-1.723-11.285-10.784.157-19.587-6.834-28.35-17.498-4.805-5.9 2.282-11.856 6.537-6.834 3.795 3.26 9.11 9.266 13.665 10.094 5.267 1.034 11.796.52 19.03-3.31 7.798-6.527 5.266-11.236-4.2-12.32-7.338.364-11.335 3.153-20.8-3.16-17.014-11.5-30.54-26.865-32.653-45.347-1.388-12.156 5.148-15.837 10.582-14.438 14.78 3.802 24.449 31.422 34.675 46.595 3.348 4.373 6.424 4.444 8.6 3.096 4.102-3.517 7.378-6.408 11.48-10.34 0 0 30.085 5.406 46.468 10.746l-18.242 6.483c-6.907-3.814-15.243.298-15.243 6.915-6.536 4.52-6.01 9.819-3.19 14.933.86-3.561 1.594-8.186 6.757-8.801 7.369 3.048 15.955-1.302 15.955-7.057l21.519-8.458 21.74 12.308c0 8.32 7.883 10.956 16.085 8.71 3.865 2.4 6.35 6.564 7.659 11.017 2.42-6.422 1.915-10.956-1.875-14.107 2.175-8.303-9.46-16.287-18.467-10.97l-15.64-8.98 26.77-.75c3.107 5.5 14.337 5.803 17.613 0 2.8-.767 5.166-1.255 10.625 2.803-1.72-6.566-5.068-9.373-10.09-9.373-3.816-6.761-17.626-6.73-19.62.882l-27.881.775 16.543-11.778c6.175 3.646 14.84-.407 16.575-7.03 2.462-2.927 5.498-4.302 11.474-2.316-3.08-5.455-7.42-7.083-15.258-3.38-7.15-5.418-16.574 1.153-15.144 6.608l-22.01 14.975c-15.976-4.767-44.91-12.19-44.91-12.19 3.445-3.624 6.94-6.991 10.379-10.665 1.242-2.152-.656-4.658-3.293-5.18-25.816-5.328-40.597-15.735-49.553-42.186-3.746-11.078 4.353-14.388 7.136-7.612 3.85 9.424 8.098 19.724 19.69 27.7 3.998 2.796 15.899.513 8.86-6.164-7.29-6.006-10.428-8.588-14.02-23.19 0-7.398 7.54-10.715 11.746-3.624 4.5 14.545 4.96 20.808 13.107 30.18 6.173 7.092 14.223 11.857 18.22 11.75 7.192-.1 14.432-7.87 4.813-13.511-14.125-5.642-19.287-13.353-21.366-20.708-2.274-12.833.21-19.046 7.952-12.733 10.98 12.476 31.94 35.717 42.92 46.538 12.305 9.424 26.423 9.73 37.66.157 6.432-7.404 4.15-15.372-5.921-13.667-22.726 1.918-39.935-9.367-58.817-39.862-3.697-6.884-4.71-16.771 3.445-9.416 9.41 12.733 23.13 23.554 35.89 28.212 12.806 4.602 23.38 2.06 27.481-1.968 4.943-4.942 3.643-17.392-4.91-14.39-7.038 2.484-16.957 3.104-27.28-.883-10.331-4.038-21.06-12.733-32.45-27.485-3.9-8.332-2.63-15.373 5.265-11.08 18.68 15.845 42.775 28.678 55.072 20.967 9.062-5.643 9.215-20.138-2.274-19.204-23.137 3.153-31.891-1.968-54.115-21.585-5.058-3.781-4.708-13.361 3.34-7.248 18.68 12.063 44.19 16.77 54.214 10.458 9.013-5.643 7.694-22.885-7.491-16.778-12.151 7.404-25.565 7.197-52.442-12.006-6.78-5.642-1.723-12.997 3.844-9.837 21.617 12.32 53.104 17.598 61.3-7.454 3.188-9.574-2.58-15.166-11.035-8.54-18.576 17.185-39.635 8.746-51.423.1-3.376-1.99-9.57-12.062 1.31-10.193 28.147 6.42 55.986.828 61.05-19.103 2.937-6.47-2.84-17.912-13.113-8.332-13.512 13.354-27.84 13.817-45.857 13.717-9.166-1.918-9.263-12.012-1.57-13.51 14.223.306 28.244-5.907 39.482-12.22 10.986-6.313 20.096-15.166 22.984-27.435 1.77-10.972-8.81-22.62-15.186-10.972-9.417 17.028-30.273 33.078-53.46 35.975-1.207-2.02-4.248-7.198-7.994-5.743-6.808 2.64-14.92 6.172-23.272 10.139-18.004 8.549-25.507 12.669-23.345 27.44 2.257 15.413-9.626 25.153-19.44 22.463-8.56-2.304-13.282-10.036-11.748-23.447 1.229-10.686 11.957-23.612 24.046-30.39 7.826-4.38 19.642-6.776 33.865-9.936 8.656-1.705 13.065-5.072 13.568-8.596 0 0-5.917 4.33-15.388 3.68-4.478-.32-7.478-2.29-8.608-4.3 3.293-.67 9.264.107 14.628.107 7.135-.057 23.702-1.655 28.097-11.7 1.367-6.626-2.987-7.817-7.038-3.573-4.353 4.587-6.146 8.71-14.88 10.25-5.314.935-10.63 2.02-17.466.365 3.85-4.573 9.968-9.252 15.186-8.39 1.716.286 3.997 1.87 5.824 4.716 1.116-7.248-.865-15.43-20.25-12.013.308-5.485-11.238-7.868-18.17-7.761-3.948.1-11.998 2.433-17.816 5.222-9.214 2.853-18.324 4.922-29.06 5.7 6.23 5.328 7.395 5.642 13.616 10.143-9.41 3.517-16.7 10.765-19.991 15.53 0 0 10.986-.307 13.77.934-11.496 3.36-16.659 5.379-22.733 11.592 2.127.364 5.314.984 6.682 1.505 1.423.514 1.053 1.448-.098 2.326-2.476 1.89-12.708 13.774-15.694 16.62-2.986-2.846-13.218-14.73-15.694-16.62-1.151-.878-1.521-1.812-.098-2.326 1.367-.52 4.555-1.141 6.682-1.505-6.075-6.213-11.237-8.232-22.733-11.592 2.784-1.241 13.77-.934 13.77-.934-3.293-4.765-10.582-12.013-19.992-15.53 6.222-4.501 7.387-4.815 13.616-10.144-10.735-.777-19.845-2.846-29.06-5.7-5.817-2.788-13.867-5.121-17.815-5.221-6.933-.107-18.478 2.276-18.17 7.76-19.385-3.416-21.366 4.766-20.25 12.014 1.827-2.846 4.108-4.43 5.824-4.715 5.218-.863 11.335 3.816 15.186 8.389-6.836 1.655-12.152.57-17.467-.364-8.733-1.54-10.526-5.664-14.88-10.25-4.051-4.245-8.404-3.054-7.037 3.573 4.395 10.044 20.96 11.642 28.097 11.699 5.364 0 11.335-.778 14.628-.107-1.13 2.012-4.13 3.98-8.608 4.3-9.472.65-15.388-3.68-15.388-3.68.503 3.524 4.91 6.89 13.568 8.596 14.223 3.16 26.039 5.557 33.865 9.937 12.089 6.777 22.817 19.703 24.045 30.389 1.534 13.41-3.188 21.143-11.747 23.447-9.814 2.69-21.697-7.05-19.44-22.463 2.162-14.771-5.341-18.891-23.345-27.44-8.352-3.967-16.464-7.5-23.272-10.14-3.746-1.454-6.787 3.725-7.994 5.744-23.187-2.897-44.043-18.947-53.46-35.975-6.376-11.648-16.957 0-15.186 10.972 2.888 12.27 11.998 21.122 22.984 27.435 11.238 6.313 25.259 12.526 39.482 12.22 7.693 1.498 7.596 11.592-1.57 13.51-18.018.1-32.345-.363-45.857-13.717-10.274-9.58-16.05 1.862-13.113 8.332 5.064 19.93 32.903 25.523 61.049 19.103 10.88-1.87 4.687 8.204 1.31 10.194-11.787 8.645-32.846 17.084-51.422-.1-8.454-6.627-14.224-1.035-11.035 8.539 8.196 25.052 39.683 19.774 61.3 7.454 5.567-3.16 10.624 4.195 3.844 9.837-26.877 19.203-40.29 19.41-52.442 12.006-15.185-6.107-16.504 11.135-7.491 16.778 10.023 6.313 35.533 1.605 54.213-10.458 8.05-6.113 8.398 3.467 3.34 7.248-22.223 19.617-30.977 24.738-54.114 21.585-11.49-.934-11.336 13.56-2.274 19.204 12.297 7.71 36.39-5.122 55.07-20.966 7.897-4.294 9.166 2.747 5.267 11.079-11.39 14.752-22.12 23.447-32.45 27.485-10.323 3.987-20.242 3.367-27.28.884-8.553-3.003-9.853 9.447-4.911 14.389 4.103 4.028 14.676 6.57 27.483 1.968 12.758-4.658 26.479-15.48 35.889-28.212 8.154-7.355 7.142 2.532 3.445 9.416-18.882 30.495-36.09 41.78-58.817 39.862-10.072-1.705-12.353 6.263-5.922 13.667 11.238 9.573 25.356 9.267 37.66-.157 10.98-10.821 31.94-34.062 42.92-46.538 7.743-6.313 10.227-.1 7.953 12.733-2.08 7.355-7.24 15.066-21.366 20.708-9.62 5.643-2.38 13.41 4.813 13.51 3.997.108 12.047-4.657 18.22-11.748 8.147-9.373 8.608-15.636 13.107-30.181 4.206-7.091 11.746-3.774 11.746 3.623-3.592 14.603-6.731 17.185-14.02 23.19-7.04 6.678 4.862 8.96 8.859 6.165 11.593-7.976 15.84-18.276 19.69-27.7 2.784-6.776 10.883-3.466 7.137 7.612-8.956 26.45-23.737 36.858-49.553 42.187-2.637.52-4.535 3.027-3.294 5.179 3.44 3.674 6.935 7.04 10.38 10.665 0 0-28.935 7.423-44.911 12.19l-22.01-14.975c1.43-5.455-7.993-12.026-15.144-6.61-7.839-3.701-12.178-2.073-15.258 3.382 5.976-1.986 9.012-.611 11.474 2.315 1.735 6.624 10.4 10.677 16.575 7.03l16.543 11.78-27.88-.776c-1.995-7.611-15.805-7.643-19.622-.882-5.02 0-8.37 2.807-10.09 9.373 5.46-4.058 7.827-3.57 10.626-2.803 3.276 5.803 14.506 5.5 17.612 0l26.771.75-15.64 8.98c-9.007-5.317-20.642 2.667-18.467 10.97-3.79 3.15-4.296 7.685-1.875 14.107 1.308-4.453 3.794-8.617 7.66-11.018 8.2 2.247 16.084-.388 16.084-8.71l21.74-12.307 21.52 8.458c0 5.755 8.585 10.105 15.954 7.057 5.163.615 5.897 5.24 6.757 8.8 2.82-5.113 3.346-10.412-3.19-14.932 0-6.617-8.336-10.73-15.243-6.915l-18.242-6.483c16.383-5.34 46.469-10.745 46.469-10.745 4.101 3.93 7.377 6.822 11.48 10.34 2.176 1.347 5.252 1.276 8.6-3.097 10.226-15.173 19.894-42.793 34.675-46.595 5.434-1.4 11.97 2.282 10.582 14.438-2.114 18.482-15.64 33.848-32.652 45.347-9.466 6.313-13.463 3.524-20.801 3.16-9.466 1.084-11.998 5.793-4.2 12.32 7.234 3.83 13.763 4.344 19.03 3.31 4.555-.828 9.87-6.834 13.665-10.094 4.255-5.022 11.342.934 6.536 6.834-8.762 10.664-17.565 17.655-28.35 17.498-11.39 1.605-9.262 8.125-1.722 11.285 13.568 5.743 25.865-4.972 32.046-12.063 4.806-5.328 8.252-5.535 7.387 2.747-4.758 15.059-11.287 20.908-21.917 21.636-8.608-.778-8.706 6.006-2.428 10.614 14.37 10.144 24.798-7.148 29.66-17.605 3.439-9.473 8.76-4.965 9.312 2.796.105 10.408-7.35 21.206-13.5 26.538C457.344 534.278 490 568.18 490 568.18s32.657-33.904 26.509-39.237zm43.763-383.94c-5.083 0-8.223 1.78-8.223 3.94 0 2.194 3.14 3.982 8.223 3.982 5.053 0 8.262-1.95 8.262-4.147 0-2.16-3.21-3.776-8.262-3.776zm-140.544 0c5.083 0 8.223 1.78 8.223 3.94 0 2.194-3.14 3.982-8.223 3.982-5.053 0-8.262-1.95-8.262-4.147 0-2.16 3.21-3.776 8.262-3.776z'/%3e%3c/svg%3e";
            },
            9263: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 600'%3e%3cpath fill='%23F2A800' d='M0 0h1200v600H0z'/%3e%3cpath fill='%230033A0' d='M0 0h1200v400H0z'/%3e%3cpath fill='%23D90012' d='M0 0h1200v200H0z'/%3e%3c/svg%3e";
            },
            1426: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-27 -14 54 36'%3e%3cpath fill='%23fff' d='M-27-14h54v36h-54z'/%3e%3cpath fill='%23dc171d' d='M-6-14H6v36H-6z'/%3e%3cpath fill='%2300007b' d='M-27-2h54v12h-54z' style='fill:%23012a87;fill-opacity:1'/%3e%3cg id='c' fill='%23fff' transform='scale(1.5)'%3e%3cg id='b'%3e%3cpath id='a' d='M0 0v1h.5z' transform='rotate(18 3.157 -.5)'/%3e%3cuse xlink:href='%23a' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(72)'/%3e%3cuse xlink:href='%23b' transform='rotate(-72)'/%3e%3cuse xlink:href='%23b' transform='rotate(144)'/%3e%3cuse xlink:href='%23b' transform='rotate(-144)'/%3e%3c/g%3e%3cg id='d'%3e%3cuse xlink:href='%23c' transform='translate(8 3.314)'/%3e%3cuse xlink:href='%23c' transform='translate(3.314 8)'/%3e%3c/g%3e%3cuse xlink:href='%23d' transform='scale(-1 1)'/%3e%3c/svg%3e";
            },
            1195: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3cpath d='M0 0h900v600H0z'/%3e%3cpath fill='%23cc092f' d='M0 0h900v300H0z'/%3e%3cpath fill='%23ffcb00' fill-rule='evenodd' d='M390.858 205.797h36.644l11.112-34.537 11.41 34.537h36.64l-29.433 21.926 11.409 35.135-30.026-21.324-29.731 21.324 11.41-35.135z'/%3e%3cpath fill='%23ffcb00' fill-rule='evenodd' d='m524.801 394.706-28.827-22.53c29.127-23.724 48.052-60.064 48.052-100.605 0-61.866-44.144-113.824-102.411-126.137l4.504-21.025c8.11 1.803 17.624 5.217 25.432 7.916l7.51-12.608c8.1 3.9 17.118 7.803 24.621 12.608l-5.703 13.518c7.51 4.808 16.575 12.251 21.616 18.112l11.277-8.809c6.008 6.604 13.218 13.507 18.323 20.721l-10.211 10.512c6.594 9.68 9.143 14.135 14.004 25.287l14.327-3.36c2.706 8.408 6.814 18.702 8.32 27.408l-13.566 5.332c1.62 6.766 3.718 18.584 3.583 28.525-.011.598-.056 1.276-.056 1.878l14.167 2.021c-.6 8.712-.897 18.625-2.704 27.333h-14.714c-2.1 9.005-4.81 20.02-8.11 28.425l12.308 7.213c-3.901 7.805-7.8 17.117-12.908 24.626l-13.514-5.703c-5.11 7.505-10.81 14.71-17.118 21.321l8.706 11.41c-2.398 2.1-4.502 4.205-6.908 6.61m-63.362-2.704 21.772 13.12c-2.03 1.857-8.112 5.006-9.724 5.644l3.56 13.666c-8.407 2.708-17.42 6.608-26.724 8.412l-5.405-13.513c-8.71 1.8-17.416 3-26.427 3l-1.807 14.114c-8.406-.598-18.617 0-27.928-2.102v-14.11c-8.411-1.506-16.519-3.606-24.324-6.312l-6.91 12.322c-7.207-3.01-16.816-6.615-24.628-11.416l5.108-13.514c-6.31-3.307-12.015-7.509-17.42-11.72l13.515-17.118c22.226 17.722 50.153 28.228 80.787 28.228 16.221 0 32.132-2.697 46.555-8.7'/%3e%3cpath fill='%23ffcb00' fill-rule='evenodd' d='M552.192 426.811 408.462 317.43l-1.31 1.866 143.36 109.573-8.509 10.647-139.753-89.64c-37.839-23.726-36.337-42.344-28.528-62.466l6.608-16.217c3.605 21.023 25.223 36.944 47.748 54.658l126.914 97.497zm36.084 32.6a2.23 2.23 0 0 1-2.23-2.238 2.23 2.23 0 0 1 2.23-2.232c1.237 0 2.24 1 2.24 2.232a2.238 2.238 0 0 1-2.24 2.239m-8.59-6.308a2.24 2.24 0 0 1-2.237-2.235 2.236 2.236 0 1 1 2.237 2.235m-8.79-7.006c-1.232 0-2.236-1-2.236-2.231a2.236 2.236 0 0 1 4.47 0c0 1.231-1 2.231-2.234 2.231m29.554 12.4-43.065-33.365-12.514 16.127 37.41 26.235c3.005 2.1 3.3 11.718 14.407 13.222 4.513.596 7.508-2.71 7.508-2.71 4.84-5.892 3.521-14.003-3.746-19.51'/%3e%3c/svg%3e";
            },
            6448: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' version='1.0' viewBox='-66.5 0 900 600'%3e%3cdefs%3e%3cclipPath id='e'%3e%3cuse xlink:href='%23a' width='400' height='267'/%3e%3c/clipPath%3e%3cclipPath id='c' clipPathUnits='userSpaceOnUse'%3e%3cpath fill='red' d='M-66.5 0h400v267h-400z'/%3e%3c/clipPath%3e%3cpath id='a' fill='%23fff' d='m146.396 44.921-.624-.267zm17.833 176.42-2.407-1.425-7.133 1.782-6.242-3.92v1.514l-1.516-2.049 1.784-1.782-.268-5.346h2.05l1.25-3.564 1.426-.624-1.16-1.782 1.784-.624-.268-2.673-1.783-.89 2.318-.268-1.426-6.504-3.567-3.564-2.14.89.892 2.941h-7.4l-6.242-2.673-2.407-1.158-11.859-2.673-.892 1.425-4.19.357h-1.16l-1.783 2.94-5.082-3.564-2.675.89.357 2.407-6.598-3.564-.268 2.316-6.508-2.94-.357.267-3.21 1.248-.624-2.406-7.757-3.831-8.292-2.674-1.516-6.86v-1.515l-3.21-5.88 1.427-7.129-2.675-.89-.892-3.03 4.458-.535h-2.05l.267-4.455-6.509 2.05-.267-1.783-.892 3.297-3.567 1.426-2.407-2.317-.892-2.406-.891-4.722 2.05-1.515.892 1.159.624-1.426-1.515-10.692 2.407.534 1.159-11.226.357-.357 2.318-1.425-2.942.267-1.16-2.673 5.35-5.97-4.815-.891-3.566 3.564-1.427-4.099-2.14 2.94-.535-2.049-2.674.891-1.784.892 1.427-5.347-1.16-.623.625-1.515-1.516.356-.267-3.029h5.617l-.268-1.426h-1.783l-3.299-5.702-1.783.624-1.16-2.05-.623 1.782-1.784-1.247 1.784-1.158-2.675-.891.624-1.515-2.14-1.159-.535-4.722-2.14-.624 1.248-.89-2.407-6.238.267-2.049.892-6.237h1.783l-.535 3.831 4.458 6.237 3.21 4.188 6.598 1.782v.267l.892-1.514 3.567 4.187 1.783 2.05.891.89 10.076 4.812 1.783.891.624.535 4.726 5.702 2.675-1.247 19.615-4.455.625-3.564L97 94.55l-.267-1.159.891-.623 4.191-1.515v-4.099l1.427-1.515 1.783-6.86-.892-2.673 4.19-10.069V59.8h2.052l2.407-3.564 2.942-.891.357-3.297 4.102-4.99 1.783.892 8.381-3.03.892-.89 1.783-1.783-.624-2.94h1.783l.892 4.722 9.183 2.139 1.516-1.515.624.267 8.025 1.782.267-.267 4.191-2.406.268 2.673 3.566.357 2.943 2.316.624.624 4.458 3.831 5.35.357 3.299.534 4.101-1.425.357 2.673 1.783 1.158 1.427-2.673h1.783l1.248 6.86 1.427.268-.268 2.406-.267.267h.535l3.566-1.782 3.3-1.158 9.183 3.207 1.783-.534.624 3.207 2.408.357-.624-1.515h2.05l.624 3.297 2.408-2.673 5.617 3.564 1.516 6.504-2.407.624.624 4.99.891 1.514 6.242 15.771-3.3 2.94-.267 3.565-2.675 3.296 2.943 2.05-1.16.89 2.675 2.674 4.102.624 1.248 1.782 1.16 2.316 2.942 1.248 3.566-2.406 2.408.267-2.943 4.188 2.943 7.752-3.567 2.94 1.516 4.722-.892 4.188 1.783 2.406 4.726.891-4.726 6.504.892 1.159 1.16 1.247-2.052 3.208 2.051 1.247-10.432 8.554 2.408 5.97-.625 3.564-3.566 1.158-.892 3.03-4.101 1.782-1.248 3.83-.892 2.05 4.19 2.139-6.24.534 1.515 3.297-3.032 2.94-4.725.891-1.516 2.673 3.566 1.782-6.776 6.238 2.05 3.296-5.349-1.158-5.974 3.564-8.024 3.831-1.784 2.673-1.159-.89 1.16-2.674-5.35 2.05-1.16-2.05-8.024 4.723-3.567-1.159-6.509 1.159-1.783-.891M166.28 50l-.625-.624h-.267v.357h.624l.268.267zm-2.051 171.342 1.783.89zm0 0 1.783.89M39.044 98.74l.357-2.139-3.299-2.05 2.942 4.189zm-7.133-16.395h-1.783l.892 2.673.891-2.317v-.356zm-.891-2.673-.892.89 1.783 1.248zm8.024 19.068.357-2.139-3.299-2.05 2.942 4.189zm-7.133-16.395h-1.783l.892 2.673.891-2.317v-.356zm-.891-2.673-.892.89 1.783 1.248zm8.024 19.068.357-2.139-3.299-2.05 2.942 4.189zm-7.133-16.395h-1.783l.892 2.673.891-2.317v-.356zm-.891-2.673-.892.89 1.783 1.248zm5.35-6.237v-2.317l-2.051.535.267 1.514zm-2.319-6.505.535 1.159 1.249-2.673-1.784 1.247zm2.319 6.505v-2.317l-2.051.535.267 1.514zm-2.319-6.505.535 1.159 1.249-2.673-1.784 1.247zm2.319 6.505v-2.317l-2.051.535.267 1.514zm-2.319-6.505.535 1.159 1.249-2.673-1.784 1.247zm31.742 90.884-2.05.267-1.784 2.406 2.943-.624.891-2.05zm0 0-2.05.267-1.784 2.406 2.943-.624.891-2.05zm0 0-2.05.267-1.784 2.406 2.943-.624.891-2.05zm2.14-60.322-.624-.534-1.783-.891 1.783.89z' transform='translate(0 -1.5)'/%3e%3cg id='d' fill='none'%3e%3ccircle cx='133.5' cy='133.5' r='49.5'/%3e%3ccircle cx='133.5' cy='133.5' r='92.5'/%3e%3ccircle cx='133.5' cy='133.5' r='133'/%3e%3cpath id='b' d='M-100 133.5h467M133.5-100v467'/%3e%3cuse xlink:href='%23b' width='400' height='267' transform='rotate(30 133.5 133.5)'/%3e%3cuse xlink:href='%23b' width='400' height='267' transform='rotate(60 133.5 133.5)'/%3e%3c/g%3e%3c/defs%3e%3cg clip-path='url(%23c)' transform='matrix(2.25 0 0 2.25 83.125 -.75)'%3e%3cpath fill='%23072b5f' d='M-66.5.333h400V267h-400z'/%3e%3cg fill='none' stroke='%23fff' stroke-width='2'%3e%3ccircle cx='133.5' cy='133.5' r='49.5'/%3e%3ccircle cx='133.5' cy='133.667' r='92.06' stroke-width='1.99'/%3e%3ccircle cx='133.5' cy='133.667' r='132.118' stroke-width='1.987'/%3e%3cpath d='M-100 133.5h467M133.5-100v467'/%3e%3cuse xlink:href='%23b' width='400' height='267' transform='rotate(30 133.5 133.5)'/%3e%3cuse xlink:href='%23b' width='400' height='267' transform='rotate(60 133.5 133.5)'/%3e%3c/g%3e%3cuse xlink:href='%23a' width='400' height='267' transform='matrix(1 0 0 .99875 0 .333)'/%3e%3cuse xlink:href='%23d' width='400' height='267' stroke='%23072b5f' stroke-width='2' clip-path='url(%23e)' transform='matrix(.99795 0 0 .9967 .195 .655)'/%3e%3c/g%3e%3c/svg%3e";
            },
            8512: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 800 500'%3e%3cpath fill='%2374acdf' d='M0 0h800v500H0z'/%3e%3cpath fill='%23fff' d='M0 166.67h800v166.67H0z'/%3e%3cg id='c'%3e%3cpath id='a' fill='%23f6b40e' stroke='%2385340a' stroke-width='1.112' d='m396.84 251.31 28.454 61.992s.49 1.185 1.28.859c.79-.327.299-1.512.299-1.512l-23.715-63.956m-.68 24.12c-.347 9.428 5.452 14.613 4.694 23.032-.757 8.42 3.867 13.18 4.94 16.454 1.073 3.274-1.16 5.232-.198 5.698.963.466 3.07-2.12 2.383-6.775-.687-4.655-4.22-6.037-3.39-16.32.83-10.283-4.206-12.678-2.98-22.058'/%3e%3cuse xlink:href='%23a' transform='rotate(22.5 400 250)'/%3e%3cuse xlink:href='%23a' transform='rotate(45 400 250)'/%3e%3cuse xlink:href='%23a' transform='rotate(67.5 400 250)'/%3e%3cpath id='b' fill='%2385340a' d='M404.31 274.41c.453 9.054 5.587 13.063 4.579 21.314 2.213-6.525-3.124-11.583-2.82-21.22m-7.649-23.757 19.487 42.577-16.329-43.887'/%3e%3cuse xlink:href='%23b' transform='rotate(22.5 400 250)'/%3e%3cuse xlink:href='%23b' transform='rotate(45 400 250)'/%3e%3cuse xlink:href='%23b' transform='rotate(67.5 400 250)'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='rotate(90 400 250)'/%3e%3cuse xlink:href='%23c' transform='rotate(180 400 250)'/%3e%3cuse xlink:href='%23c' transform='rotate(270 400 250)'/%3e%3ccircle cx='400' cy='250' r='27.778' fill='%23f6b40e' stroke='%2385340a' stroke-width='1.5'/%3e%3cpath id='h' fill='%23843511' d='M409.47 244.06c-1.897 0-3.713.822-4.781 2.531 2.136 1.923 6.856 2.132 10.062-.219a7.333 7.333 0 0 0-5.281-2.312zm-.031.438c1.846-.034 3.571.814 3.812 1.656-2.136 2.35-5.55 2.146-7.687.437.935-1.495 2.439-2.067 3.875-2.094z'/%3e%3cuse xlink:href='%23d' transform='matrix(-1 0 0 1 800.25 0)'/%3e%3cuse xlink:href='%23e' transform='matrix(-1 0 0 1 800.25 0)'/%3e%3cuse xlink:href='%23f' transform='translate(18.862)'/%3e%3cuse xlink:href='%23g' transform='matrix(-1 0 0 1 800.25 0)'/%3e%3cpath fill='%2385340a' d='M395.75 253.84c-.913.167-1.563.977-1.563 1.906 0 1.062.878 1.906 1.938 1.906a1.89 1.89 0 0 0 1.563-.812c.739.556 1.764.615 2.312.625.084.002.193 0 .25 0 .548-.01 1.573-.069 2.313-.625.36.516.935.812 1.562.812 1.06 0 1.938-.844 1.938-1.906 0-.929-.65-1.74-1.563-1.906.513.18.844.676.844 1.219a1.28 1.28 0 0 1-1.281 1.281c-.68 0-1.242-.54-1.282-1.219-.208.417-1.034 1.655-2.656 1.719-1.622-.064-2.447-1.302-2.656-1.719-.04.679-.6 1.219-1.281 1.219a1.28 1.28 0 0 1-1.281-1.281c0-.542.33-1.038.843-1.219zm2.09 5.69c-2.138 0-2.983 1.937-4.906 3.219 1.068-.427 1.91-1.27 3.406-2.125 1.496-.855 2.772.187 3.625.187h.031c.853 0 2.13-1.041 3.625-.187 1.497.856 2.369 1.698 3.438 2.125-1.924-1.282-2.8-3.219-4.938-3.219-.426 0-1.271.23-2.125.656h-.031c-.853-.426-1.698-.656-2.125-.656z'/%3e%3cpath fill='%2385340a' d='M397.12 262.06c-.844.037-1.96.207-3.563.688 3.848-.855 4.697.437 6.407.437h.03c1.71 0 2.56-1.292 6.407-.438-4.274-1.282-5.124-.437-6.406-.437h-.031c-.802 0-1.437-.312-2.844-.25z'/%3e%3cpath fill='%2385340a' d='M393.75 262.72c-.248.003-.519.005-.813.031 4.488.428 2.331 3 7.032 3h.03c4.702 0 2.575-2.572 7.063-3-4.7-.426-3.214 2.344-7.062 2.344h-.031c-3.608 0-2.496-2.421-6.22-2.375zm10.1 6.94a3.848 3.848 0 0 0-3.846-3.846 3.848 3.848 0 0 0-3.847 3.846 3.955 3.955 0 0 1 3.847-3.04 3.952 3.952 0 0 1 3.846 3.04z'/%3e%3cpath id='e' fill='%2385340a' d='M382.73 244.02c4.915-4.273 11.11-4.915 14.53-1.709.837 1.121 1.373 2.32 1.593 3.57.43 2.433-.33 5.062-2.236 7.756.215-.001.643.212.856.427 1.697-3.244 2.297-6.577 1.74-9.746a13.815 13.815 0 0 0-.67-2.436c-4.7-3.845-11.11-4.272-15.81 2.138z'/%3e%3cpath id='d' fill='%2385340a' d='M390.42 242.74c2.777 0 3.419.642 4.7 1.71 1.284 1.068 1.924.854 2.137 1.068.213.215 0 .854-.426.64s-1.284-.64-2.564-1.708c-1.283-1.07-2.563-1.069-3.846-1.069-3.846 0-5.983 3.205-6.41 2.991-.426-.214 2.137-3.632 6.41-3.632z'/%3e%3cuse xlink:href='%23h' transform='translate(-19.181)'/%3e%3ccircle id='f' cx='390.54' cy='246.15' r='1.923' fill='%2385340a'/%3e%3cpath id='g' fill='%2385340a' d='M385.29 247.44c3.633 2.778 7.265 2.564 9.402 1.282 2.136-1.282 2.136-1.709 1.71-1.709-.427 0-.853.427-2.564 1.281-1.71.856-4.273.856-8.546-.854z'/%3e%3c/svg%3e";
            },
            3928: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 500'%3e%3cpath fill='%23006' d='M0 0h1000v500H0z'/%3e%3cpath fill='%23BD1021' d='M0 250 1000 0v500L0 250z'/%3e%3cpath fill='%23FFF' d='M107.14 250 1000 26.79v446.42'/%3e%3cpath d='M766.471 277.926c6.665.512 6.437 7.12 6.437 7.12l23.602.526c3.019-8.229 6.152-7.276 11.886-3.212 5.448 3.861 11.393 5.585 11.393 5.585 2.279-11.81 19.026-9.422 19.026-9.422 7.14-17.054 7.747-16.827 3.494-18.987-4.253-2.16-5.988-5.814-5.988-5.814-4.037-4.873-6.164-11.922-6.62-16.246-.456-4.324-5.469 2.164-6.38.799-.911-1.364-8.355-.568-8.355-.568 1.823 1.933-4.405.796-4.405.796.608.455 0 2.274 0 2.274-.608-.796-5.317-1.592-5.317-1.592-.456 1.023-1.519 2.16-1.519 2.16-2.582-1.137-7.747-.91-7.747-.91-7.595-.114-12.152 2.274-14.279 3.525s-9.722 5.116-15.95 11.142-9.722 5.344-9.722 5.344c-1.823 6.708-16.709 14.894-16.709 14.894-2.43 2.16-9.874 3.183-13.671 0s0-8.868 0-8.868c1.405-2.658 2.798-2.548 2.953-11.77.105-6.236 6.542-11.182 13.149-18.43 8.078-8.861 19.368-23.449 19.368-23.449.057 4.477 2.506 5.202 2.506 5.202 2.222-4.562 5.412-8.229 5.412-8.229.171.384.627.64.627.64 2.506-3.411 4.044-4.775 4.044-4.775-.854-.341-7.861 0-14.412 5.713-6.551 5.713-11.051 3.795-11.051 3.795-4.557-1.45-4.956-4.946-4.956-4.946-3.327-14.317 9.741-24.558 9.741-24.558-17.545-4.178-4.899-26.434 16.861-35.899s21.532-13.729 21.532-13.729c1.253 1.45 2.279 4.008 2.279 4.008.228-.171 1.823-2.558 14.355-8.101 12.532-5.543 18.57-10.318 18.57-10.318 1.595 3.07 1.253 5.287 1.253 5.287 34.292-12.023 68.072-39.608 68.072-39.608.968 2.302.456 5.798.456 5.798 5.582-5.159 25.748-17.182 25.748-17.182.342 7.674-5.981 10.616-5.981 10.616.684 1.109 1.082 3.112 1.082 3.112 3.304-1.791 18.684-12.535 18.684-12.535 5.639 4.86.513 12.833.513 12.833 1.994-.298 3.475-2.046 3.475-2.046 1.424 8.271-7.747 15.562-7.747 15.562 1.595.043 4.272-1.535 4.272-1.535-1.709 9.039-18.855 19.058-18.855 19.058 2.506 2.217.114 5.159-1.937 6.481s-5.696 4.221-4.557 5.415 8.716-4.136 8.716-4.136c1.31 3.795-8.431 11.256-8.431 11.256 6.779.895 25.634-7.674 25.634-7.674-1.538 7.291-8.659 12.961-17.431 16.244-8.773 3.283-8.317 3.795-8.317 3.795 1.538 1.236 13.671-2.302 13.671-2.302-3.646 8.143-16.292 13.729-16.292 13.729 3.475 2.942 8.203-.469 12.931-3.709s11.165-6.012 18.285-8.399c7.121-2.388 12.133-.597 12.133-.597 5.924-1.876 10.937.767 10.937.767 11.393.938 12.532 5.074 12.532 5.074 1.253.298 2.222.81 5.127 2.942s2.734 8.74 2.62 11.981c-.114 3.24-1.025 3.24-1.595 4.136s-.627 1.919-.627 3.155-2.848 8.911-20.45 8.996c-17.602.085-26.678 0-26.678 0-1.453 0-3.19.853-3.19.853-7.405 3.667-3.494-2.501-12.304 4.747-8.81 7.248-13.292 5.997-13.292 5.997-1.443 1.734-10.671 10.318-15.95 13.729-5.279 3.411-4.329 3.098.266 5.088s11.545 0 11.545 0c-4.443 2.956-1.367 4.32-1.367 4.32 5.848-3.553 9.38-2.245 9.38-2.245 1.861 5.088-4.823 13.132-4.823 13.132 2.582.341 7.443 0 7.443 0-1.177 3.439-6.038 7.22-9.608 8.385-3.57 1.165-2.924 1.62-1.861 3.78s.152 4.349.152 4.349c-6.228-4.32-6.456-.455-6.456-.455-.719 5.12-.608 12.45-.608 12.45-4.405-2.217-4.633.739-4.633.739-1.139 4.661-6.532 10.062-6.532 10.062-.228-2.899-2.886-3.638-2.886-3.638-2.81 5.4-7.975 8.641-7.975 8.641-.684 4.661.608 11.199.608 11.199-3.342-.682-4.557-.625-5.089.171s.76 1.194.76 1.194l43.521 1.08c.608.057 3.19.341 3.266 5.059.076 4.718-3.798 4.946-3.798 4.946l-47.622-1.137s.228 1.307-2.279 2.615-1.671-1.478-2.355 4.377c-.684 5.855-10.178-.455-10.178-.455-1.519 2.274-5.241 5.23-5.241 5.23-2.127-6.424-4.329-8.413-7.747-2.842s6.152 4.605 6.152 4.605 55.901-8.243 58.939-8.527 6.38-.114 7.747 4.15-6.76 4.946-6.76 4.946l-57.344 6.253c-1.215 3.411-6 3.127-6 3.127.38 3.24-3.038 5.287-4.785 6.481-1.747 1.194-7.215.625-7.215.625-6.684 4.548-9.95.966-9.95.966-4.329 1.876-7.064 1.08-10.633-.455-3.57-1.535-3.266-5.855-3.266-5.855l-36.191 3.752a8.752 8.752 0 0 0-2.886 1.734c1.291 1.649-2.592 5.479-2.592 5.479 1.082.746 3.161 2.835 3.446 7.355.301 4.781-5.839 5.585-2.763 8.911s8.687.576 14.953-2.43 12.418-2.622 15.095-2.601c2.677.021 10.14 1.897 14.782 3.539 4.643 1.641 6.238.661 6.551-1.727s2.393-3.07 2.393-3.07c-.57 2.345.684 3.39.684 3.39 1.794.128 4.927-1.62 4.927-1.62-.285 1.727-2.563 2.814-2.563 2.814-4.557 3.048 1.709 1.919 1.709 1.919 12.475-2.558 16.918-2.302 20.165-1.961s18.57 6.864 18.57 6.864c.57-1.535.171-5.329.171-5.329 3.931 1.066 5.526 3.326 5.526 3.326 1.481-1.62.513-4.349.513-4.349 12.646 7.077-2.62 10.275-6.665 11.639-4.044 1.364-3.987 3.027-3.987 3.027 3.361-1.066 5.696-1.45 8.488-1.663 2.791-.213 1.823-.043 8.488-1.364 6.665-1.322 10.083 1.492 10.083 1.492-5.582.298-7.234 1.961-7.234 1.961 3.532 2.43.171 4.477.171 4.477-5.07-6.395-9.399.256-9.399.256 1.737-.256 6.836.81 8.288 1.727 1.124.709 3.76 2.004 7.035 3.517 4.625 2.137 3.76.767 7.348 2.132s2.222 4.818 2.222 4.818c-1.538-2.814-4.842-3.795-4.842-3.795-.285 3.795-4.101 4.434-4.101 4.434 4.671-5.202-5.412-7.461-10.14-7.376s-8.26 3.112-8.26 3.112c9.513 8.911 16.121 6.012 16.121 6.012-1.196 3.24-9.057 1.961-9.057 1.961 3.646 2.771 3.247 4.733 3.247 4.733-1.937-1.876-5.127-.938-11.962-5.372s-12.931-2.984-12.931-2.984c6.665 7.12-2.449 11.341-2.449 11.341-3.361 1.919 1.424 4.519 1.424 4.519-4.215.767-4.785-3.453-4.785-3.453-2.222-.426-5.412 2.26-5.412 2.26.228-4.349 5.924-2.174 6.095-6.694s-5.298-8.015-21.419-5.798-20.849-2.942-20.849-2.942c-1.367.043-1.652 1.407-1.652 1.407 2.677 2.558 3.874 3.624 3.418 5.415-.456 1.791.854 2.388.854 2.388-2.962-.171-3.19-3.709-3.19-3.709-.057 1.45-.684 1.578-1.652 3.112-.968 1.535-.057 3.496-.057 3.496-1.253-1.109-3.532-2.43-1.367-5.585 1.667-2.43-3.475-5.543-3.475-5.543-1.994-2.046-7.291-.128-7.291-.128-10.994 2.174-17.431-4.775-17.431-4.775-1.253 0-3.646-.682-3.646-.682-11.621 5.202-21.817-6.054-21.817-6.054-8.772 1.663-12.76-2.558-15.437-6.694-2.677-4.136-3.19-4.477-6.722-6.608-3.532-2.132-6.833-8.163-3.589-11.341 2.829-2.771 1.994-3.411 1.994-3.411-4.557-7.66 8.127-10.13 8.355-11.963.332-2.675 2.981-4.366 5.829-4.537 2.848-.171 2.848.085 4.728-1.833 1.88-1.919 5.469.469 5.469.469.741-.554 7.007-5.415 12.589-2.899 5.583 2.516 10.197.725 10.197.725 3.931-.853 36.571-5.287 36.571-5.287 2.108-3.155 3.589-6.95 12.589-8.996 9-2.046 15.836-7.632 15.836-7.632-1.595-1.705-4.272-1.62-5.639-1.791-1.367-.171-4.215-2.601-4.215-2.601-1.652.725-2.499.37-14.298 7.546-10.538 6.41-10.842-6.309-10.842-6.309l-22.994.042c-.399 4.86-4.101 6.779-4.101 6.779l-8.374.426c-4.671-2.473-4.728-10.701-4.728-10.701-25.292.384-39.362 9.422-39.362 9.422-28.653-14.667-51.097-17.992-51.097-17.992 34.805-3.795 53.204-13.473 53.204-13.473 19.197 11.512 37.255 11.81 37.255 11.81.684-6.95 5.355-8.655 5.355-8.655l5.296.288z'/%3e%3cpath fill='%23FFC221' d='M725.09 335.68c-7.273 4.265-5.958 6.594-5.325 7.904.646 1.336.721 2.615-1.253 4.605-1.975 1.99-1.785 2.681-1.785 2.681.304 7.069 5.311 8.57 7.399 10.304 1.749 1.452 4.715 6.002 4.715 6.002 3.722 5.344 7.671 5.4 10.595 5.4s2.664-.248 1.177-1.563c-1.398-1.237-4.329-3.638-4.329-3.638 3.911 1.364 7.633 5.457 7.633 5.457 7.39 8.086 14.203 7.021 17.203 6.623s2.468-2.132 2.468-2.132c-.158-.288-3.076-.512-3.076-.512-11.089-1.052-14.431-8.328-14.431-8.328 6.684 6.566 17.165 7.902 20.393 7.781s3.038.803 2.354.974-1.671 0-3.152-.114-1.481.256-1.139.881 1.737.689 3.503.625.342.128 4.927 3.688c4.586 3.56 16.007.682 16.007.682-7.377-1.833-8.402-5.159-8.402-5.159-10.026 1.172-14.099-4.839-14.099-4.839-1.794-1.791-7.151-4.56-7.151-4.56-5.666-2.432-6.549-7.56-6.549-7.56 1.595 2.27 4.7 4.872 8.63 5.959s5.041 1.663 5.041 1.663c-1.88.277-2.991-.341-2.991-.341-3.931-1.151-1.709.448-1.709.448 4.329 3.453 5.526 3.198 5.526 3.198 11.364 1.172 5.725-3.368 5.725-3.368 8.089 1.919 9.428-1.109 9.428-1.109 1.68 3.56 7.804 2.281 7.804 2.281-8.146 3.922-1.965 2.802-1.965 2.802 8.231-1.544 9.845.552 9.845.552 2.228 2.072 4.481 1.784 4.481 1.784s1.481.043 4.614.67 7.918 3.295 12.475 2.731 5.298.866 5.298.866c-.854-.295-2.848-.6-6.38.978s-9.627 2.089-18.513 0-9.57-1.833-9.57-1.833c2.108 1.577 3.987 3.795 4.386 5.329s1.937 1.62 1.937 1.62c.627-1.961 3.304-2.814 3.304-2.814 1.753 1.62 6.437 3.752 6.437 3.752.513-1.066 0-1.812 0-1.812 3.418 3.262 7.405 2.281 7.405 2.281 1.081-.765.741-2.601.741-2.601 1.367-.043 1.595.81 2.563 1.45s4.044.213 4.044.213c-1.139-.469-1.937-2.217-1.937-2.217 4.5-3.112 14.241-1.748 14.241-1.748 7.035 1.236 6.152 5.841 6.152 5.841 1.424.682 3.304 2.814 3.304 2.814.598-1.62.057-3.262.057-3.262 3.219 1.535 3.902 5.287 3.902 5.287 3.731-4.264-3.56-9.06-3.56-9.06 3.532-.448 7.434-.128 9.798.213s5.753 1.578 8.516 3.88 7.719 3.368 7.719 3.368c-.152-.951-2.791-2.558-3.389-2.899s-.854-1.172-.854-1.172c2.421.426 4.101.213 4.101.213-8.516-5.202-10.652-7.674-10.652-7.674 3.19.405 4.956-1.578 4.956-1.578-6.722.149-6.95-1.599-6.95-1.599.826.234 3.874.981 7.89.192s9.598.021 9.598.021c-2.905-4.669-14.156-3.88-17.744-3.688s-4.984-.277-4.984-.277c.57-.277 1.168-.874 3.987-.895 2.82-.021 5.582.213 8.772-1.983s7.567-1.471 7.567-1.471c-1.063-2.103-6.114-2.842-10.557 0s-8.469 1.933-8.469 1.933c7.026-.995 9.076-3.468 9.076-3.468-2.127-.512-3.304.171-7.519.995s-5.355-.625-5.355-.625c4.633-2.757 7.861-3.866 7.861-3.866-3.949-.824-7.595-2.51-7.595-2.51-4.101 3.857-7.291 6.034-15.152 1.913s-11.962-3.638-11.962-3.638c6.912-4.093 14.013-2.331 19.178.767s6.646.568 6.646.568c-1.633-1.023-1.405-1.904-1.405-1.904 12.532 6.395 17.963 2.416 20.735.54s-1.253-4.377-1.253-4.377c-.266 4.065-5.393 5.912-9.418 4.548s-7.747-3.098-13.538-5.514-13.045-1.165-19.805.256-7.633.739-8.241.199-.949-2.189-4.405-.767c-3.456 1.421-11.507-2.359-16.52-3.553s-13.219-.541-20.317 3.354-10.595 2.928-12.722 1.961-3.456-3.638-1.177-6.026 2.468-3.041 2.279-6.481c-.19-3.439-3.57-5.486-3.57-5.486 3.114-3.212 3.874-3.922 2.81-5.315-1.063-1.393.608-1.364 2.393-2.16s.987-.91.57-1.961c-.418-1.052-1.443-.881-1.443-.881-4.139.171-6.418-.966-6.418-.966-6.855-3.155-13.216 2.984-13.216 2.984-3.894-2.983-4.785-1.052-5.469-.313s-2.051 1.251-3.874 1.421c-1.658.155-4.164.804-5.033 2.353 0 0-.768 1.245.19 2.608 0 0 1.064 1.605-.872 3.544-1.937 1.94-2.62 2.409-2.022 4.242s.427 3.24-.313 4.434c0 0-.883-1.023-.655-2.281s.228-1.983-.057-2.665c0 0-1.908 1.876-2.25 3.219 0 0-.797-2.068 1.965-4.839s4.021-4.151 3.247-5.223c-.57-.789-2.591.488-3.077.773z'/%3e%3cpath d='M732.94 366.24s-3.456-2.643-3.038-6.31.348-4.121-.035-4.889c0 0-.63.365-.611 1.791.018 1.338-.172 2.729-.304 2.984 0 0-1.785-3.041-2.506-3.61 0 0 .608-3.183-.38-4.548-.987-1.364-1.943-1.45-3.076-1.023-1.568.59-2.752 2.047 2.517 6.367 0 0 1.964 1.563 3.332 5.031 1.367 3.468 3.646 4.008 4.101 4.207zm17.128-10.147s-.266-2.075 1.595-5.742.745-6.391.327-7.301-.669-.572 1.208-2.148c2.31-1.939-.89-4.387 2.908-7.787 0 0 2.506-2.149 3.076-3.03 0 0-4.025 2.16-6.646 3.24-2.62 1.08-12.646 5.997-10.443 9.294s1.975 3.468 1.633 4.832c0 0-5.962-3.155-3.874-8.271 0 0 .947-2.061 3.456-4.377 2.279-2.103.911.455 5.544-2.189 0 0 3.684-2.189 5.62-5.145 0 0-2.43 1.535-3.304 1.791 0 0-5.355.966-7.519 3.24-2.165 2.274-6.76 6.225-5.203 10.63 0 0-5.355-.654-6.57-6.225 0 0-9.912 12.222 10.899 17.907.001.002 3.799 1.011 7.293 1.281z'/%3e%3cpath fill='%23FFC221' d='M841.606 315.23c7.772-1.175 52.815-7.982 56.908-8.397 4.481-.455 6.197-1.053 7.671 2.558 1.671 4.093-6.152 4.15-6.152 4.15l-53.699 6.088c-2.634.304-3.223-.701-3.223-.701-.465-.858-1.363-2-1.982-2.748 0-.001-.707-.771.477-.95z'/%3e%3cpath fill='%235A3719' d='M731.61 339.66s-5.81 12.236 17.032 15.263c0 0 .057-1.364.968-3.283s2.905-5.798 1.025-8.314 1.538-1.194 2.051-4.477-.342-2.814 1.253-4.946c0 0-7.177 2.601-9.912 5.756-2.734 3.155 3.703 5.543-.114 8.996 0 0-3.19-1.151-5.07-4.605.002.001-4.441.087-7.233-4.39z'/%3e%3cpath d='M753.94 354.69s5.639 4.882 12.361 4.669 9.57-2.004 11.279-4.669c0 0 1.307 2.065 1.31 3.432 0 0 5.81-4.818 15.836-.64s6.95 3.03 9.171 3.327c0 0-4.262-.758-14.013 3.708-10.025 4.592-36.172 3.027-35.944-9.827z'/%3e%3cpath fill='%235A3719' d='M744.597 333.096s2.535.384 5.07-2.473c0 0-3.418.64-5.07 2.473zm-19.155 22.725s-4.713-3.709-1.694-4.434c0 0 2.15-.341 1.694 4.434z'/%3e%3cpath d='M828.049 379.017s2.506-4.48 9.741-4.48 8.089 3.326 17.203 3.965c0 0-10.944 3.084-18.57.256-3.987-1.478-7.576-.249-8.374.259z'/%3e%3cpath fill='%235A3719' d='M756.446 357.952s10.823 6.566 20.45-.554c0 0 .798.767 1.481 2.515 0 0 7.291-7.036 20.336.554 0 0-1.603-.178-7.747 2.473-8.004 3.454-28.026 5.714-34.52-4.988z'/%3e%3cpath d='M798.2 364.604s10.367 1.202 19.14.682c5.39-.319 11.222-1.306 8.317.52-2.905 1.825-1.481 1.996 10.937.845s-.114 2.345 8.431 3.453c0-.001-20.71 10.573-46.825-5.5z'/%3e%3cpath fill='%235A3719' d='M825.429 357.995s6.095-2.217 11.735.426c5.639 2.643 4.785 2.857 8.545 3.24 0 0-2.62 3.752-8.829.725-6.21-3.027-7.855-3.611-11.451-4.391zm6.779 18.717s5.98-2.983 12.591.118c.827.388 2.631 1.137 4.327 1.502 0 0-5.065 1.57-10.254-.043-2.157-.67-3.873-1.193-6.664-1.577zm-29.565-10.702s13.33 1.236 20.564-.205c0 0-8.374 4.042 12.646 2.166 0 0 4.671-.512 4.101.213s-.911 1.279 1.367 1.961c.001.001-15.607 6.993-38.678-4.135z'/%3e%3cpath d='M736.05 354.69s.114 1.023 3.076 2.345 4.557 3.688 5.184 4.967 2.136 3.193 4.586 3.803c0 0-10.45 2.181-15.133-3.255 0 0-3.551-3.916 2.174-7.86'/%3e%3cpath fill='%235A3719' d='M818.31 378.8s-4.158-.256-9.798-2.217c-5.639-1.961-7.121-.298-10.31-2.686-3.19-2.388-9.627-.895-10.823-.725-1.196.171-4.614 0-.342-2.771 0 0-3.418-.085-4.728-1.791 0 0-1.538 1.492-7.291.938 0 0 2.563 4.026-7.747 2.866 0 0 3.076 3.572 6.779 4.297s5.247.485 7.633-.213c0 0-.684 3.112 4.101 4.306s5.753 2.132 8.203 3.112c0 0 .342-2.004-6.038-6.651 0 0 3.418-.171 8.317 1.023 4.897 1.194 16.005 4.051 22.044.512zm2.582 4.775s1.025 2.388 4.177 1.848 8.336-1.464 13.349 1.094c0 0 .854-4.264-9.209-4.562 0 0-6.304.341-8.317 1.62zm-85.218-27.372s-3.874 3.183-.361 6.495c3.209 3.025 8.165 2.757 10.538 2.672 0 0-1.424-.81-2.677-2.686s-1.296-3.144-3.931-4.349c-2.734-1.25-3.057-1.577-3.569-2.132zm-4.064-16.542s-5.81 12.236 17.032 15.263c0 0 .057-1.364.968-3.283s2.905-5.798 1.025-8.314 1.538-1.194 2.051-4.477-.342-2.814 1.253-4.946c0 0-7.177 2.601-9.912 5.756-2.734 3.155 3.703 5.543-.114 8.996 0 0-3.19-1.151-5.07-4.605.002.001-4.441.087-7.233-4.39z'/%3e%3cpath d='M791.65 367.89s4.785-.767 16.975 3.795 17.26 3.411 19.083 3.283c0 0-6.876 3.592-17.526-1.097-9.417-4.147-10.044-2.57-18.532-5.981z'/%3e%3cpath fill='%23FFC221' d='M867.962 365.158s2.783-.095 4.405.668c0 0 1.063-.91 3.608-1.18 0 0-1.671-1.677-8.013.512zm-8.335-6.75s2.791-.128 3.627-1.464c0 0-1.405-1.791-3.551-2.643 0-.001.436 1.904-.076 4.107zm-93.668-31.153s-.513-1.364 2.392-1.791c2.905-.426 40.881-5.841 40.881-5.841s2.013-.003 2.298 1.322c.308 1.432-.228 2.503-9.399 3.575s-33.381 4.099-33.381 4.099-2.564.427-2.791-1.364z'/%3e%3cpath fill='%23FFC221' d='M803.004 325.621s0 5.372 5.469 6.168c5.306.772 7.13-.331 8.545-3.125.371-.734 1.999-6.343-.357-6.771-.926-.168-2.569-.072-3.744.43-1.83.782-3.528 1.698-2.924 2.615 1.291 1.961 1.543 2.416 1.063 2.558-1.312.389-2.277-.764-2.544-1.563-.333-.996.723-1.637-2.848-1.109-1.46.216-2.66.171-2.66.797z'/%3e%3cpath fill='%23FFC221' d='M825.752 321.491c2.794.322 2.582 6.233-.76 8.905-3.599 2.877-7.033 1.848-7.033 1.848-1.816-.767-1.588-.512-.183-2.643 1.33-2.018 1.957-4.734 1.215-6.623-.237-.604.418-1.094 1.345-1.293.002-.001 2.53-.527 5.416-.194z'/%3e%3cpath fill='%23FFC221' d='M828.182 322.011s1.994 2.509-.495 7.134c0 0-1.1 1.364 1.368 1.165s7.975-2.842 7.405-6.225c0 0-.19-.824-1.633-.739-1.443.085-.266-.796.342-.966s2.487-.867-2.392-4.008c0 0-.805-.725-1.747-.426-.744.236-3.343 1.302-3.343 2.814.001.62.495 1.251.495 1.251z'/%3e%3cpath fill='%23FFC221' d='M833.518 317.761s3.893 2.79 3.874 3.619c-.019.829-.361 1.952.665 1.853 1.025-.099 5.241-.995 4.082-3.78-1.158-2.786-2.317-3.766-4.272-4.448-1.956-.682-2.449.242-4.12 1.506-.001 0-1.216.739-.229 1.25zm-21.058 3.937s.646-2.075-2.848-2.842c0 0 1.481-1.222 4.443-.568 2.942.649 2.628 2.587 2.605 2.842 0 0-2.301-.086-4.2.568zm7.596-.483s4.048-.709 5.848-.483c0 0-1.994-4.462-7.386-2.942 0 0 1.936 2.189 1.538 3.425zm6.93-1.109s0-1.364 3.437-2.729c0 0-1.668-1.57-3.987-1.421-2.658.171-3.19 1.137-3.19 1.137s2.886 1.002 3.74 3.013zm1.348-4.661s2.127.54 3.456 1.677c0 0 2.016-2.2 3.722-2.672 0 0-3.342-1.791-7.178.995z'/%3e%3cpath fill='%235A3719' d='M716.514 304.701s9.383-7.95 14.64-6.992c5.256.957 2.62.298 8.374-.597 5.753-.895 11.678-1.492 14.07-1.194 0 0-6.95-4.988-19.368-4.903 0 0-8.772 3.027-14.811 7.035 0 0-11.621-6.481-23.64-2.601 0 0 13.045 4.732 20.735 9.252z'/%3e%3cpath fill='%23FFC221' d='m816.286 318.472 1.566-.263s2.644 3.274.723 3.311c-1.501.03-.894-.462-1.178-1.414-.285-.952-.797-1.378-1.111-1.634zm-11.791.256s-.94 1.169.826.895c2.151-.333 1.737.072 4.101-1.528 0 0 1.453-1.542 4.158-.582 0 0 2.279.746 4.13-.149s2.279-.831 3.275-.746c.997.085.93.3 2.26-.671 1.329-.971 3.636-.225 5.089-1.44 1.453-1.215 3.275-.192 0-2.537 0 0-.684-.682-.627-1.258 0 0 1.253.362 2.25 1.258.997.895 2.649.618 2.934.469 0 0 .171-2.921 3.076-5.607 2.905-2.686 2.934-2.899 1.225-2.921-1.709-.021-4.586-.682-5.554 0s-9.485 6.267-14.44 7.205c-4.956.939-9.513 2.346-12.703 7.612zm-132.242-30.555s15.209 3.922 18.627 5.571c0 0 .816-2.544-6.095-4.534 0 0 16.785-.512 34.558 7.561 0 0 8.567-7.346 36.137-5.072 0 0 .054-2.435.244-4.308 0 0-19.368-.568-37.141-11.369 0-.001-15.911 7.83-46.33 12.151zm84.534 7.347c-1.063-15.548 4.899-16.94 4.899-16.94s2.808.016 5.848.483c0 0-4.709 5.599-3.456 16.713 0 0 .494 1.791-3.494 1.791-3.924 0-3.797-2.047-3.797-2.047z'/%3e%3cpath fill='%235A3719' d='M760.85 305.81s-2.886-2.956-3.19-6.367c0 0-.076-.881 2.848-.796s3.306-.281 4.025 1.421c.7 1.655 2.544 5.145 3 5.543l-6.683.199z'/%3e%3cpath fill='%23FFC221' d='M767.096 298.048a36.973 36.973 0 0 1-.321-5.91c.19-8.669 1.629-7.899 2.199-6.818l2.966.054s-2.165-9.778-4.709-4.065c-2.5 5.612-2.317 9.266-2.013 13.7.175 2.554.512 4.144.797 5.1l1.081-2.061z'/%3e%3cpath fill='%235A3719' d='M800.593 298.071s5.725.874-3.048 2.963c0 0 .427 10.6 10.795 3.176 0 0 6.124-3.915 10.367-5.507 0 0 2.136-.739 1.88-2.338 0 0 .171-1.883-2.051-1.514 0 0-1.75.041-2.877-.37 0 0-1.225-1.442-2.051-.888s-2.763.234-1.253 2.068c1.51 1.833 1.965 1.364 2.706.831.741-.533 4.016-1.833.997.874s-5.383-1.492-6.352-2.26l-9.113 2.965zm-28.653 1.201-2.544-.057s-1.367 2.047-2.3-1.167l-1.08 2.06s3.152 11.382 5.924-.836z'/%3e%3cpath fill='%23FFC221' d='M768.332 286.14s-1.291 7.447.342 12.052l27.533.512s-.342-5.344.076-12.563h-3.911s-.532 5.997-.038 9.692l-.645.013s-.494-5.186.037-9.705h-3.228s-.532 5.543-.114 9.749h-.608s-.456-4.86.076-9.749h-3.19s-.586 5.02.041 9.68l-.762-.016s-.646-5.088.038-9.664h-3.532s-.873 4.69-.038 9.721h-.722s-.797-4.804.076-9.721h-3.532s-.835 5.315-.114 9.721h-.684s-.57-5.145.19-9.721h-3.304s-.873 4.491-.152 9.721h-.722s-.532-3.894.152-9.721h-3.265zm29.09 13.587s-.762-13.474 1.823-16.94c2.585-3.466 3.114-2.786 7.519 0 4.405 2.785 10.102 5.798 11.013 6.139.911.341 2.203.682 2.203 3.127s.456 3.183-3.342.114c-.569-.46-2.345-2.085-3.627-2.494-3.403-1.086.818.762 2.032 2.494 1.029 1.468 1.823 1.307-.835 1.99s-11.849 3.751-16.786 5.57z'/%3e%3cpath d='M807.06 290.08s-1.994-2.519.541-3.095 2.734 3.986 3.161 6.736c.428 2.75-3.189-2.779-3.702-3.641zm-3.702 11.742s-2.962 1.087-1.025 2.046 7.405-3.581 5.526-3.283c-1.881.299-4.501 1.237-4.501 1.237zm4.016-4.157s2.62-.256 2.108.874c-.513 1.13-1.453.412-1.851.163-.4-.248-2.251-.888-.257-1.037z'/%3e%3cpath fill='%23FFC221' d='M821.328 294.141s.703 5.13 5.108 6.431c0 0 2.544.632 2.013-1.613 0 0-.437-1.876-.797-2.658-.361-.782-2.127-1.279-2.317-1.364s-.418-.625.798-.227c1.215.398 1.405.441 1.31-.412-.095-.853-.81-.51-1.926-1.055-.429-.21.046-.494.502-.394.456.099 1.538.426 1.557-1.336 0 0 .241-.98-1.101-1.052-1.462-.078-1.348-.732-.892-.831.456-.099 1.986.961 2.411-.782.437-1.791-2.108-.76-1.766-1.684s2.145.528 2.295-.568c.145-1.066 1.602-1.53-.879-1.874-1.177-.163-.089-.685 1.233-.499 1.415.199 2.269-1.549 3.086-2.118.817-.568 5.431-3.325-.721-2.416-6.153.909-7.956 3.894-8.355 4.491-.401.596-2.11 4.12-1.559 9.961z'/%3e%3cpath fill='%23FFC221' d='M835.661 298.117c.791-.152 1.538.063 1.807.614 1.013 2.078-1.31 1.336-2.601 2.871s-1.329 1.222-3.152.685c-1.823-.537-2.506-3.3-2.506-3.3-.204-.848.584-.92 1.528-.812-.001.001 3.022.309 4.924-.058zm-6.662-1.105s.128.622 1.172.707c1.044.085 4.078.348 5.882-.234 0 0 .665-.131.366-1.306 0 0-.024-.762-1.648-.453s-3.973 0-4.756-.171c-.783-.17-1.42.015-1.016 1.457zm-.247-3.723s-.057 1.62 1.576 1.833c1.633.213 3.666.205 4.513.038.646-.128 1.81-.364 1.905-1.317.095-.952.361-1.663-1.652-1.165-2.013.497-4.443.171-4.69.114-.247-.057-1.614-.47-1.652.497zm.741-3.269s-.399.739-.342 1.45c.057.711 1.234.952 3.361.981s4.025-.284 4.158-.995c.133-.711.646-1.535-1.025-1.279-1.671.256-3.779.327-4.614-.014-.836-.342-1.398-.46-1.538-.143z'/%3e%3cpath fill='%235A3719' d='M907.571 298.263s-.028 1.482 1.139 2.942l-59.029-1.695s.862-.533 1.082-2.832l56.808 1.585z'/%3e%3cpath fill='%23FFC221' d='M829.967 287.576s-.513 1.492.551 1.791c1.063.298 2.886.625 5.298.242 0 0 1.215.085 1.633-1.208s.375-.568-3.059-1.251c0 0-1.081-.315 2.053-.327 0 0 1.747.057 2.013-.242.266-.298 2.582-2.132-.418-2.018-3 .114-1.519-.526 0-.526s1.994.313 2.487-.171c.494-.483.038-.156-.779-.981-.816-.824-.247-.583.342-.128s.949.597 1.614.014c.665-.583-.513-1.435 0-1.336.513.099.76 1.073 2.696.135s4.557-.448 5.269.085c.712.533 2.734 1.215 3.959-.043s-1.453-2.281-.313-2.452 1.937.234 2.393-.682c.456-.917-1.766-1.791.37-2.366 2.136-.576.342-6.566-.399-7.12 0 0-2.392 1.407-5.013 5.649s-4.158 6.715-7.719 5.415c-5.136-1.876-7.761.821-8.556 1.307-1.232.753 2.575 1.123.354 1.165-2.222.043-2.222.234-2.449.576-.228.341-.029.64.37.661.399.021 1.253.874-.114.831-1.367-.043-2.336-.256-1.934 1.197 0 0 .025.317.823.402.797.085 1.082.917-.399.917-.95.002-1.045.37-1.073.464zm5.459 14.801s-1.054.746.399.831 2.222.362 2.677-.416c.456-.778 2.421-.458 1.111-1.546-1.31-1.086-2.193-.468-4.187 1.131z'/%3e%3cpath fill='%23FFC221' d='M841.52 284.62s4.915-4.626 9.023-1.492 4.506 3.603 4.563 3.667.484.405-.627 1.386-.029.959 1.196.362 1.31-.043 1.908.618 1.398 1.045-.497 1.066-5.968 0-5.968 0-2.763.234-1.367-.895c1.396-1.13 1.196-2.473.484-2.558s-.057.682-.484 1.215-1.396 1.023-2.364 1.002-1.823.701-.285 1.257c1.538.555-.171.919-.968.897s-4.643.298-.74.767c3.902.469-.352.356 2.506 1.989 3.161 1.806.883 5.643-.313 5.984 0 0-1.31.713.342.516 1.652-.196 2.563-.431 1.396.464-1.168.895-3.503 3.88-6.75 1.599 0 0-1.481-.703 1.168-.831s-2.165-.694-2.962-1.232-3.845-3.65-1.937-3.266 1.225-.725.085-1.13-1.367-2.153-.085-1.769 2.791 1.098 3.817 1.05c1.025-.048.741-.475-1.453-1.157-2.193-.682-3.105-.789-2.592-2.643s2.905.725 2.336-.661-2.649-.703-1.538-2.537c1.111-1.833 1.367-1.045 1.88-.81s1.333.06-.114-1.023c-.913-.684.082-1.609.34-1.835z'/%3e%3cpath d='M845.053 285.899s-.029-.618.854-.512c.883.107.655-.32.911-.448s2.466.658.399 1.407c-.764.277-1.964.079-2.164-.447z'/%3e%3cpath fill='%23FFC221' d='M849.753 291.143s-1.661.846-.157 2.589c1.282 1.486 1.275 1.957 1.168 2.945-.108.988 56.807 1.585 56.807 1.585s-.1-3.656 2.336-5.713c0 .001-31.102-.724-60.154-1.406z'/%3e%3cpath fill='%235A3719' d='M908.54 297.261s.231-3.084 1.937-4.106c.94-.563 2.18-.235 2.721 2.251.77 3.536-2.227 6.544-3.618 5.201-1.325-1.278-1.04-3.346-1.04-3.346z'/%3e%3cpath fill='%237B3C20' d='M843.32 310.56s3.788-3.219 4.358-4.669c0 0 10.254 7.264 9.627.594 0 0 .029-1.788.313-3.493 0 0 3.707.364 4.272-2.596l-9.57-.282s-.997-.213-2.478 1.386-4.529 3.349-7.377 1.823c0 0-1.192-1.035-2.405-.161s-1.27 1.13-.273 2.068c.998.939 3.134 3.817 3.533 5.33zm22.017-20.06-5.611-.213s-2.051-2.878-6.038-6.076c0 0-1.168-.512 1.082-2.302 2.25-1.791 2.905-3.709 2.991-4.583s-.142-2.238.712-1.194c.854 1.045 6.665 6.289 7.491 4.733s.968-2.281 1.111-2.75.342-1.919 1.168-.405 1.393 1.127 1.424 5.052c0 0 .142 3.88.741 5.287-.002 0-7.35-2.354-5.071 2.451zm-24.353-11.938s4.272 2.388 6.38-.853c2.108-3.24 3.532-3.752 1.937-6.864s.044-4.562 1.247-5.841 2.228-1.066 2.399-6.012 3.589-6.608 5.127-8.143 5.412-3.88-.456-4.86c-5.867-.981-17.488-4.008-20.507-8.527s-4.386-1.833-4.443-1.663c-.057.171-1.025 3.496 1.994 9.508s5.582 9.877 8.488 11.824c2.905 1.947 5.526 3.013 4.044 7.021-1.482 4.007-4.045 11.17-6.21 14.41z'/%3e%3cpath fill='%235A3719' d='M856.76 265.78s.741 10.275 8.26 13.942c0 0 1.709-4.008 1.025-7.973 0 0 2.449.213 3.133 1.322 0 0 .114-2.984-3.418-4.072-3.532-1.087-1.823-7.781-.57-8.548s.854-2.103 0-3.311-1.082-3.041 1.88-2.274 2.506-.81.741-2.26-1.709-3.24.797-3.24 6.665-2.43 4.158-3.198c-2.506-.767-3.304-1.577.114-2.558s5.07-2.217 2.506-2.515c-2.563-.298-4.272-1.194-1.766-1.62s-.456-2.984-3.361-3.112-9.171 1.066-4.215-2.899-7.121-1.066-2.165-3.667-1.652-1.45-2.563-1.492-.901 0-.565-1.322c.337-1.322-.689-1.919-2.113-1.109s-1.424.81-1.367-1.023-1.709-.469-2.791 0-3.817 2.515-4.899 1.407-1.709-2.26-5.07-.213c-3.361 2.046-2.563.213-2.506-.682s1.31-4.434-3.304-.64c-4.614 3.795-.854-4.093-4.5-1.407s-4.044 3.155-4.614 1.961-1.26-2.174-5.273.384-1.05-1.535-.481-2.43 2.279-6.694-1.253-2.174c0 0-1.709 3.155-5.526-2.473 0 0-4.044 5.591-5.07 3.115-1.025-2.475-2.051-2.731-3.361-1.111s-.342-.085-.911-1.45-.911-3.88-7.633 1.023 2.336 1.322-2.791 3.539-17.488 9.209-6.152 7.589-5.526 4.434-1.595 5.543 2.677 4.519 17.431.469 12.361-.64 19.88-3.88-1.709 1.109 8.374.895c10.083-.213 1.709.043 3.646 2.132s10.481 7.035 18.456 7.845 9.912-2.174 7.633 1.279-3.076 4.775-4.443 5.969-5.127 3.922-5.184 8.698c-.057 4.775-6.266 5.543-3.987 10.829a600.8 600.8 0 0 0 5.413-5.288z'/%3e%3cpath fill='%235A3719' d='M869.88 277.27s-1.823-1.279-1.785-3.553c0 0 1.291.227 1.785 1.052 0 0 4.595-5.202-.893-7.077-5.487-1.876-2.754-6.85-.893-6.879s2.185-.54.618-2.615-1.453-2.16 1.661-2.7 2.691-1.194 1.307-1.961c-1.383-.767-2.444-2.018-2.444-2.018s8.808-3.837 5.959-5.599 0-1.307 2.544-3.127c2.544-1.819 2.886-2.16 3.266-2.871 0 0-2.515.256-4.371-.114 0 0 2.198-1.08 0-2.871-2.199-1.791-3.11-3.411-6.604-2.587s-2.355-.341-.987-1.791c1.367-1.45.721-2.274-1.747-2.643 0 0 .304-1.478 2.165-3.326 0 0-4.747.341-6.342-.483 0 0 1.899-1.307 2.051-2.871 0 0-2.62.853-5.924.54 0 0 1.937-1.677 1.937-3.155 0 0-5.734 1.279-8.393 3.297 0 0-.57-.114-1.025-.739-.456-.625-.798-1.251-7.14.767 0 0 .722-2.814 2.241-3.951s1.291-3.411-8.583 2.757c0 0-1.329-.796-2.43-3.752 0 0-2.127 3.013-3.76 4.036 0 0-1.367.574-1.196-1.347s-.968-.552-1.994 0c-1.025.552-1.709 1.916-1.196-1.964s-1.367-4.69-1.367-4.69-3.076 4.349-4.842 4.818c0 0-3.247-3.155-4.386-5.244s-1.139-2.857-2.279.767c-1.139 3.624-2.563 3.922-2.563 3.922s-1.937-1.663-2.165-2.558c0 0-.342.981-.968 1.407 0 0-1.709-2.004-1.652-4.903 0 0-10.595 5.841-11.905 9.38 0 0-10.026-.597-14.184.171 0 0 1.025-3.24 3.646-4.86 0 0-2.62-.298-2.734-2.984 0 0 2.108.298 3.418-.043s-1.823-4.136 1.481-4.221 5.412 1.577 3.93-2.814c-1.481-4.391-.797-4.391-.797-4.391s5.753 3.411 6.665 2.558-.741-2.686 4.386-1.833 3.703-2.089 5.696-2.217c1.994-.128 3.076 1.279 1.823-8.015s6.209 4.605 1.139-9.422c0 0-1.282-4.242-4.329-6.054 0 0-.684 3.07-4.13.362s-10.225-3.667-7.377-5.798c2.848-2.132 4.187-4.988 3.361-6.779 0 0-3.359 3.511-9.2 1.002-4.614-1.983-5.582 1.663-10.31.597 0 0 .085-1.215 4.073-4.349s-2.307 1.045-4.785 1.599-3.19.107 2.051-3.944c5.241-4.05 15.608-11.213 14.184-17.097 0 0 2.449 3.112 8.886.853s11.222-3.07 13.159-6.395c1.937-3.326 7.007-6.694 8.317-7.419s3.076-1.236 1.082 1.919-5.241 8.57-14.127 12.236c-8.886 3.667-12.304 6.353-13.899 8.271-1.595 1.919-9.684 6.225-4.443 5.5s14.355.128 10.083-1.109c-4.272-1.236-9.114.767-5.184-2.814s4.614-4.775 10.31-7.163 12.019-7.845 11.393-2.047c-.627 5.798-11.222 11.981-13.842 13.856-2.62 1.876-1.652 1.578-1.595 2.345s-.399 2.345-1.481 3.07-.741 1.535-.456 3.155-.285 2.26.513 2.515 1.595.384 1.823 1.535.826 1.3 2.364 1.172 2.506.021 2.62.917c.114.895 1.566 2.11 1.737-.618.171-2.729 1.168-3.262-1.623-2.004s-3.389.81-3.332-.49-.256-1.002-1.424-1.109-1.567-1.748.513-2.835c2.079-1.087 2.051.021 4.643-2.132s2.592-2.75 2.991-3.752-3.703 2.921-5.668 3.816-1.453-.618-1.111-2.857 5.241-5.159 7.491-5.202 7.32 1.279 5.127 4.349-8.402 6.715-5.725 6.992 3.105-.767 4.643.597.114 4.136-.598 5.607-2.193 3.326-2.848 3.667c0 0-2.82-5.031-2.734-1.045s-.598 5.415 0 5.564 3.731 2.238 4.728 2.281-5.412 3.006-2.734 3.198c2.677.192 6.921-1.172 8.402-3.944 0 0-5.44-1.322-7.633-3.368 0 0 6.352-1.492 4.586-7.61 0 0 6.323 1.727 3.589 4.583-2.734 2.857-4.386 2.43-2.022 3.24s3.532 1.492 3.532 1.492 1.617.81.68 2.132-.965 3.326-.168 3.283 3.475-1.279 1.225-2.643 2.563-1.13.513-2.281c-2.051-1.151-2.592-1.428-3.133-1.983-.541-.554 25.748-15.967 12.475-10.19 0 0 2.763-5.99 6.636-6.012s4.158 3.048 1.965 5.372-3.617 5.948-8.772 6.8c0 0 7.367 3.61-1.339 9.508 0 0-1.889.895-1.206 1.549.684.654 5.848-2.274 6.57-3.922.722-1.649 1.823-2.928 3.798-3.894s11.697-7.589 14.621-12.592 3.722-5.173 9.418-9.749 4.709-3.667 5.431-4.775 1.025-2.928 3.646-4.406 12.798-7.134 15.988-9.437c3.19-2.302 9.722-6.537 12.532-10.119 2.81-3.581 10.378-8.156 12.266-7.305 1.889.851-.19 3.525-4.633 6.907s-15.456 12.279-17.241 13.643-11.127 8.186-14.621 8.641-3.114 1.677-5.203 3.951-6.912 7.049-8.545 8.357c-1.633 1.307-5.507 3.979-5.734 5.855-.228 1.876.684 2.103-2.43 5.031s-12.228 9.55-15.532 10.602c0 0 5.848 1.933 2.354 5.884s-3.266 3.382-3.532 3.638c0 0 8.88-1.307 2.582 5.599 0 0-1.215 1.99 1.595-.085 3.004-2.218 1.709-5.258 1.367-5.685 0 0 4.709-2.928 10.14-3.013s5.241-.455.38-1.848c0 0 3.456-4.207 6.38-2.132s1.975 3.269-1.101 4.917c-3.076 1.649-7.633 2.331-11.013 4.207 0 0 6.418 1.251 9.874-1.364s3.608-1.307 4.063-.853c.456.455.836 1.307-.684 3.496s-1.671 2.302-1.595 2.786c.076.483-.114 1.99-3.228 2.501-3.114.512-4.519 1.819-3.456 3.297s1.101 5.145-1.557 4.804-1.937-2.444-2.962-3.269c-1.025-.824-2.468-2.103-7.102.313-4.633 2.416-5.013-.455-4.785-1.961 0 0-3 2.615-5.507.199-2.506-2.416-.228-3.354 1.215-4.576s7.329-3.78 3.798-3.326-8.81.682-10.026-2.046c-1.215-2.729 2.62-2.416 3.228-2.16s3.114 2.274 3.19-.37c.076-2.643 3.987-2.928 2.658-3.468s-3.19 1.137-3.722 1.791c0 0-2.734-3.809-7.139-2.558s1.405.739 2.582.938.494 2.388-3.456 5.941-2.165 2.473.76 2.473c2.924 0 10.102.028 5.924 3.439s-5.848 5.116-8.013 4.519.266-2.018 1.215-2.615 1.519-1.649-.532-.881-2.772.91-4.405-1.99c-1.633-2.899-.949-2.046-.266-3.951.684-1.904 2.279-3.922.38-3.212s-1.709.767-1.557-1.421c.152-2.189-2.165-2.672-2.165-2.672s.911 2.189.076 3.581-.873 1.876.494 2.245c1.367.37 2.658 1.535.797 2.814s-1.633 1.109-.456 1.876 2.886 1.649 1.063 3.439-.304 1.251.608 1.251 2.974.767 3.006 2.53c.032 1.762-.12 2.189 2.842.54s8.886-1.45 8.81.853c-.076 2.302-.76 2.871 2.393.91s4.557 1.848 6.722 0 3.532-3.638 6.038-.483 1.725 4.109-1.329 6.338 1.481.512 3.798-.682 8.81-1.99 12.532-.341 4.785 1.279 7.519.142 4.139-1.393 8.279 1.364c4.139 2.757 7.367 3.269 9.532 3.212 0 0-4.595 1.791-9.76 2.132s-7.747 1.307-8.772 2.103c0 0 3.106 1.876 3.718 4.178 0 0 3.384-.455 5.055.227 0 0-.873 2.444 1.215 3.752 2.089 1.307 3.532 1.791 1.975 3.581-1.557 1.791 2.393 1.023.152 3.553s-2.848 3.809-2.924 5.855c-.076 2.047.494 2.359-1.519 2.558s.342 2.444-.57 5.116c-.911 2.672-6.532 2.388-6.304 9.55 0 0 1.557-3.496 4.899-6.566s3.456-3.354 3.38-5.202-.228-1.421 1.557-2.814-.797-2.7.987-4.69c1.785-1.99.228-1.592 2.317-3.61s-1.823-2.274.304-4.349-5.127-4.434-3.038-5.77 5.696-3.183-6.456-2.984c0 0 2.924-4.832 13.178-3.78 0 0-2.696 1.904-2.924 3.78 0 0 1.177.597 1.899.767 0 0-.397 1.375-2.354 3.041 0 0 5.431 3.041 6.304 4.832 0 0-3.304 1.023-4.139 2.473 0 0 1.443 1.649 1.937 3.78 0 0-3.684-.455-4.177 2.302-.494 2.757-1.595.881-1.595 2.501s.114 2.274-1.177 2.53-.228 1.62 0 2.53.646 2.984.456 3.638c0 0-1.861.028-2.734.284 0 0 .57 3.951-1.633 4.519s1.177 1.364-1.177 1.791c-2.355.426-2.051.568-4.937 5.742 0 0 2.468-1.393 5.013-3.07 2.544-1.677-.19-1.165 4.025-5.315s3.456-4.463 3.114-6.566-.418-3.809 1.101-5.798c1.519-1.99 2.013-4.264 7.405-3.979 0 0-1.595-3.588-3.57-4.522 0 0 2.582-1.788 5.317-2.043 0 0-2.393-2.871-7.291-5.656 0 0 4.025-3.468 4.975-5.116 0 0-1.861.284-3.342-.057 0 0 .698-1.659 4.329-4.036 0 0 1.937 1.876 1.861 3.837 0 0 6.228-3.581 9.76-3.183 0 0 1.785 4.491-6.874 12.904 0 0 5.355.512 7.633.199 0 0-1.291 4.15-7.785 6.594s1.404 5.301-5.241 4.804-4.595 1.791-4.405 5.173.418 6.85.266 7.788c0 0-5.317-1.734-5.203 3.411s-2.734 6.225-3.304 6.708c0 0-1.543-1.379-3.874-2.189-.005.005-3.303 6.267-8.626 9.925z'/%3e%3cpath fill='%237B3C20' d='M862.28 212.78s1.823-.298 4.899 1.62 6.095-2.046 2.677-3.07.057-2.217 3.133.256 4.272 1.236 5.412.384 2.506-1.322.399-2.771c-2.108-1.45 1.424-.767 3.019.256s.968 2.089.741 2.388-.399 3.624 2.734.512 4.671-6.225 4.614-7.76c0 0 1.709 1.066 1.937 3.027s2.62-1.066 3.418-2.132c.797-1.066 2.165-3.756 1.994-5.779 0 0 2.108 3.26 5.241 0s1.766-1.213 5.526-2.194 8.488-3.752 11.051-6.864 2.734-1.023 6.038-1.791c3.304-.767 9.969-5.372 10.595-7.888.627-2.515.513-4.05-.456-3.198s-.57.171-1.994-.725c-1.424-.895-3.532 1.151-3.532 1.151s2.108 1.62.513 2.302-3.133 2.942-6.152 2.089-6.152 2.771-6.152 2.771 2.62 2.174-.911 3.539c-3.532 1.364-2.962 1.833-5.127.341 0 0-3.76 4.775-5.924 5.756 0 0-1.025-.085-1.709-.981 0 0-2.449 2.771-3.703 3.326 0 0-1.538-1.492-2.962-1.961 0 0-2.962 3.667-5.469 4.818 0 0-.741-1.364-2.336-2.302 0 0-.788 4.796-6.038 7.632 0 0 .342-1.279-2.279-3.027 0 0-6.494 5.628-9.057 6.182s-.171-1.194.171-1.919 1.937-3.112-1.196-4.093-2.62.682-3.304.981c-.684.298-.741-.554-2.848-.256-2.108.298-1.766 1.236-2.677 1.578-.911.341-4.557-.597-4.386 1.833s1.88 4.093-1.31 5.5c-3.192 1.407 1.195 1.109 5.41.469z'/%3e%3cpath fill='%235A3719' d='M875.44 205.92s.741-3.07-1.937-4.562c0 0 17.203-2.643 4.215-9.209 0 0 15.437-3.198 11.792-8.143-3.646-4.946-7.19-3.837-7.725-3.752s3.282-2.857 4.307-2.473 13.444 5.159 10.254 1.066-2.905-3.837-3.418-5.031c0 0 4.101 0 10.311 6.054 0 0 1.31-1.364 1.139-3.837 0 0 4.443 1.236 5.81 2.558 0 0 .741-1.535.456-2.388 0 0 3.817 2.046 5.127 4.221 0 0 1.766-1.535 2.051-3.283 0 0 3.817 1.578 4.785 2.771 0 0 1.253-1.663.797-4.05 0 0 6.323 1.876 7.177-2.046 0 0 6.361 1.379 2.227 3.855-5.313 3.183-.537-.785-5.987 3.009-4.226 2.942-6.589 6.395-8.621 5.685-1.493-.522-3.285 3.823-5.336 1.691s-2.051-1.151-3.475 1.066-3.646 4.477-3.646 4.477-1.109-.64-1.95-1.492c0 0-1.24 2.046-2.835 3.581 0 0-1.253-1.663-3.247-2.686 0 0-3.133 3.624-5.07 4.86 0 0-1.823-1.791-3.76-2.388 0 0-.285 4.903-4.101 7.419 0 0-.797-1.62-3.247-2.601.002 0-1.935 3.1-6.093 5.628z'/%3e%3cpath fill='%235A3719' d='M866.39 198.41s-2.09 1.606-.741 3.326c1.349 1.719 1.424-.298 3.133-.469s22.786-3.795 3.703-9.508c0 0 .797-.725 4.101-1.023s15.266-3.539 9.684-7.802c-5.582-4.264-10.225 1.449-5.526-3.667 3.76-4.093.741-6.097.741-6.097s-11.108 7.419-13.557 8.783-5.981 3.965-1.823 5.329 7.007-4.519 7.405-3.198c.399 1.322-8.374 6.182-7.12 8.442 1.253 2.26.968 4.136 3.133 3.709 2.165-.426 8.032 1.109 3.247.938s-6.38 1.237-6.38 1.237z'/%3e%3cpath d='M874.02 187.798s-1.937 1.361.627.679c2.563-.682 7.69-1.791 6.722-3.112-.97-1.322-4.387.262-7.349 2.433z'/%3e%3cpath fill='%237B3C20' d='M907.86 165.8s9.798-.256 13.842 2.473 5.981 4.519 7.177 4.903c0 0-.171 3.709-6.437 1.066 0 0 .342 1.791-.342 3.539 0 0-2.336-1.535-5.013-2.217 0 0-.456 1.407-1.31 2.217 0 0-2.791-2.814-5.924-3.667 0 0-.627 1.407-1.196 1.919 0 0-3.361-1.919-5.924-1.876 0 0 .513 2.047 0 2.857 0 0-7.121-5.585-13.444-4.86 0 0 3.076 4.477 5.07 6.694 0 0-12.817-1.023-10.709-7.93s-.171-5.172 8.203-5.123 16.007.005 16.007.005z'/%3e%3cpath fill='%235A3719' d='M847.76 184.88s-1.481 1.207 0 2.231c1.481 1.023 6.551-2.643 7.234-3.155.684-.512 2.506-.426 0 1.45s-5.07 3.922-6.665 5.969c0 0 8.488-2.302 14.013-7.077s-.257-1.682 9.171-6.225 14.355-11.853 9.285-11.085c-5.07.767-9.627 6.566-13.557 8.783s-6.152 2.515-5.526 1.236c.627-1.279 3.532-.767 8.943-5.116 5.412-4.349 4.215-4.05 4.272-5.585s-2.051-5.329 6.095-9.593 33.495-19.101 35.659-24.174c0 0-7.405.81-17.146 8.015s-14.956 10.574-17.646 11.469-2.348.298-4.114 2.388c-1.766 2.089-11.393 11.384-13.159 12.748s-2.279 2.26-2.43 5.041c-.066 1.267-11.068 9.554-14.429 12.68z'/%3e%3cpath fill='%235A3719' d='M881.25 165.56s-1.88.873-3.703 0-1.253-4.796 3.133-7.141 12.361-5.841 16.406-6.353c0 0-.57 5.074-13.159 9.337 0 0 .798 2.642-2.677 4.157z'/%3e%3cpath fill='%23AA5323' d='M885.7 162.26s.366 1.248 0 2.388c0 0 23.412 2.26 35.489-11.981 0 0-16.577 1.535-23.184 5.5 0 0 4.158-5.202 16.577-9.508 12.418-4.306 17.488-9.636 18.57-12.577 0 0-15.705 5.5-23.184 5.5 0 0-1.481-.043-2.905.767s-11.45 8.101-14.127 9.337c0 0 5.639-.469 7.633-2.302-.001 0-3.92 10.539-14.869 12.876z'/%3e%3cpath fill='%235A3719' d='M840.87 175.64s-3.019 2.132-1.766 3.198 3.411 1.279 8-2.558 15.697-13.388 8.678-13.771c0 0-8.988-.554-8.678 4.946.314 5.554-5.783 7.836-6.234 8.185zm-20.735-3.241s5.924 3.453 3.703 6.31c0 0 18.172-15.434 13.045-18.76s-9.171 2.942-7.918 3.581c1.253.64 3.93-.554 2.962.64s-10.652 7.718-11.792 8.229zm-4.728-4.988s3.987 1.194 4.158 2.899 12.019-8.357 8.886-12.577c-1.437-1.935-8.032-2.729-8.317 1.066s5.924-.384 3.76 2.345c-2.838 3.578-7.632 5.67-8.487 6.267zm42.642-8.408s-2.539 1.842-.26 2.951 3.76-.64 4.899-1.663 6.779-5.159 8.089-7.802 3.247-3.453 5.298-4.818c2.051-1.364 16.52-8.57 25.406-16.543s5.184-5.926 14.412-11.043c9.228-5.116 15.266-9.806 17.203-15.349 0 0-4.272 1.407-8.032 3.837s-12.247 7.76-13.956 8.484-4.101.853-5.355 2.174c-1.253 1.322-1.139 2.899-5.583 6.566-4.443 3.667-27.4 19.868-30.191 22.17-2.791 2.305-11.93 11.036-11.93 11.036z'/%3e%3cpath fill='%23AA5323' d='M839.58 164.37s2.506-1.382 7.215-1.06c4.709.321 23.317-17.699 28.71-21.337s22.254-15.804 24.533-18.021 2.658-4.605 4.633-5.912 3.798-1.137 8.355-3.752 26.431-15.69 25.14-23.307c0 0-32.583 19.555-40.103 25.922-7.519 6.367-28.406 20.806-32.128 23.137s-6.684 6.367-12.912 11.426-12.379 9.322-13.443 12.904z'/%3e%3cpath fill='%23AA5323' d='M832.74 157.44s6.03-.617 6.836 2.331c0 0 12.912-8.868 15.874-12.506s-.987-1.535 6.38-6.367 31.824-21.943 35.318-25.013 10.102-7.106 15.418-10.687c5.317-3.581 26.128-13.757 23.773-22.114 0 0-15.266 10.232-18.684 12.45-3.418 2.217-4.861.966-8.355 3.695s-11.165 8.186-12.532 9.891-13.064 10.687-18.76 14.496-18.456 11.199-24.609 16.543c-6.153 5.343-18.077 15.235-20.659 17.281z'/%3e%3cpath fill='%23AA5323' d='M813.95 155.69s3.051.044 3.962 1.238c0 0 5.64-4.947 11.64-.058 0 0 22.026-14.894 24.229-18.646s5.772-3.809 14.355-10.062 13.975-8.868 19.672-13.302c5.696-4.434 10.481-9.437 14.583-12.108 4.101-2.672 14.431-9.437 12.684-15.292 0 0-8.355 4.775-13.823 10.744s-5.013.853-10.557 5.855c-5.545 5.003-14.127 11.824-21.267 15.349s-2.81 3.127-7.975 6.424-4.785 2.786-6.684 3.24c-1.899.455-4.785 1.819-6.684 4.036s-6.988 5.23-12.532 8.357c-5.545 3.126-19.178 11.241-21.603 14.225z'/%3e%3cpath fill='%23AA5323' d='M820.59 144.26s-1.196-2.473.911-4.221c2.108-1.748 5.924-6.353 6.551-9.252s.171-2.43 6.266-4.946c6.095-2.515 19.937-8.996 27.742-13.814 7.804-4.818 19.653-12.577 22.102-14.453s8.393-6.054 10.804-8.015c0 0 1.158 3.283-1.462 5.543s-12.703 9.337-14.355 10.446-10.937 7.333-13.785 8.911-9.912 5.159-12.418 7.248-2.184 2.729-13.368 8.186-11.697 6.012-11.355 6.438 5.355-1.748 7.747-3.155c2.393-1.407 11.564-5.585 14.298-7.76 2.734-2.174 7.348-5.585 9.342-6.694s18.513-11 23.241-14.496 6.038-4.647 7.064-4.05c1.025.597 2.677.64.57 2.643-2.108 2.004-8.829 7.888-11.393 9.593-2.563 1.705-10.595 6.481-12.817 7.632s-3.076 3.283-4.329 4.178-4.899 3.496-9.342 4.519-5.241 4.349-8.146 6.225-23.579 13.004-24.206 13.558c0 0 1.25-1.28.338-4.264z'/%3e%3cpath fill='%23AA5323' d='M892.13 97.834s-1.139 1.009-.513 1.578c.827.75 3.703 2.771 7.291-.789 3.589-3.56 13.23-11.32 16.356-13.153s4.607-3.581 4.493-6.097c.001 0-14.81 7.888-27.627 18.461zm20.393-1.364s2.279-3.795 7.861-7.376 13.963-8.795 15.095-10.062c0 0 1.994 2.26-2.392 5.031s-12.931 8.442-13.956 9.252-2.734 2.046-6.608 3.155z'/%3e%3cpath fill='%237B3C20' d='M799 137.78s-6.209 3.326-3.987 5.415 5.526 1.45 6.893.853 3.987-1.236 4.386-1.364 5.81-1.663 7.177-4.178 5.013-5.415 7.918-7.504 3.93-4.178 3.532-5.67c-.001-.001-24.453 11.55-25.919 12.448zm-36.913 28.694s4.29-2.551 10.311-.938c0 0-.285-1.467-1.196-2.226 0 0 7.291-1.91 8.886-5.15s1.937-2.558 3.361-3.496 11.279-8.868 10.14-10.574-1.367-3.922-2.222-4.818c0 0-2.051 2.814-11.621 7.461s-20.222 8.143-27.969 18.589-6.95 16.5 2.506 19.143c0 0 6.665-4.178 22.9-2.729 16.235 1.45 21.76 7.546 22.786 8.655 1.025 1.109 4.329 5.116 1.139 11.895 0 0 3.247 1.407 3.532-1.705s.456-2.388 1.196-1.919c.741.469 1.652.554 1.31-1.833-.342-2.388-1.481-7.717-2.962-9.55s.171-1.023 1.139-.64c.968.384 4.386 3.155 2.336-1.961-2.051-5.116-2.563-2.601-2.62-2.345s-.456 1.535-4.899-1.791-8.488-4.946-11.507-5.798-.911-.853.854-1.492c1.766-.64 4.158-1.023 4.956-2.984 0 0-1.766.426-5.013-.725s-9.741-1.279-14.982 2.643c0 0 1.652-6.054-3.133-5.713s-8.146.213-13.216 4.221c0 0-.285-6.097 4.5-9.252s4.158-1.236 6.836-2.046 2.905-3.496 1.766-4.349c0 0 6.266 1.066 16.804-7.674 0 0-5.662 7.419-12.544 8.911 0 0-1.09 3.949-7.337 4.818-6.246.869-6.094 4.477-6.037 5.372z'/%3e%3cpath fill='%235A3719' d='M744.1 202.61s3.074-18.372 20.279-19.702c15.076-1.165 19.861.711 22.862 1.677s10.329 3.127 7.481 5.486-4.481 1.933-4.481 1.933 3.304-3.667.304-4.292-3.266 1.194-3.684 2.729-.608 3.382-2.089 4.576c0 0-1.519-1.762-3.684-.227s-.304 1.592.57 1.336c.873-.256 2.013-.711 1.785.625s-1.443 3.638-5.013 5.514-3.38 1.762-7.633 2.444-8.203 2.359-13.633 7.021c-5.431 4.661-11.374 3.106-12.57-2.103-1.025-4.467-.494-7.017-.494-7.017z'/%3e%3cpath d='M763.794 202.035s1.652-3.624-1.31-5.287c0 0-9.058 1.553-11.735-1.194 0 0 9.855-.512 15.95-2.899 6.095-2.388 4.272-4.05 2.165-4.434-2.108-.384-5.981.554-6.38 2.473 0 0-1.196-2.046.342-3.411s3.931-1.62 6.095-.981c2.165.64 4.101 1.578 11.222-2.132 0 0 4.101.938 4.215 3.709.114 2.771-.285 3.922-.627 4.349-.342.426-.854 1.236-1.709 1.151-.854-.085-1.937-.298-3.019 1.62-1.082 1.919-1.732 3.581-3.543 4.86 0 0 2.119-5.969-3.122-7.376 0 0-4.329 2.558-7.633 2.686 0 .002 4.216 3.924-.911 6.866z'/%3e%3cpath fill='%235A3719' d='M773.25 191.078s-1.994-2.196.627-2.43c2.62-.234 6.095 1.684 5.412 3.304-.684 1.62-3.76 1.556-6.039-.874z'/%3e%3cpath fill='%23FFF' d='M921.3 161.96s-4.785 1.364-.342 4.306 6.608 5.5 9.855 6.353 6.608 2.046 6.551 5.287c-.057 3.24-.684 4.519-2.449 6.736-1.766 2.217.968 3.198 3.304 1.919s4.329-1.961 5.867-2.857 4.101-.767 1.766.426c-2.336 1.194-4.785 1.919-1.766 2.004s21.191.426 25.007-.81 8.772-1.62 9.228-6.566c0 0 .171-2.196 1.595-3.112 1.424-.917 2.393-3.027.313-1.599-2.079 1.428-3.674 2.153-4.073 1.727s-.513-.725.997-1.428 2.364-.043 3.76-2.11c1.396-2.068 1.259-1.727.516-2.515-.744-.789-2.31-1.364-1.541-2.366s1.538-3.986-1.794-2.238-9.893 6.253-12.931 6.964-5.355 1.635-9.456 2.466-6.646 1.712-11.013 4.128-4.063-1.334-3.304-1.847c0 0 1.671 2.927 6.114-.882s2.997-.238 13.861-3.809 8.203-4.15 12.456-6.367 8.279-2.302 5.317-5.258-3.304-3.212-7.139 0c-3.836 3.212-14.431 8.385-20.773 8.527 0 0 24.495-10.574 21.988-12.108-2.506-1.535-5.203-2.899-6.912-3.269s-2.165-.796-6.114.966-4.595 2.189-5.734 2.302-4.443.767-9.114 3.183-7.177 3.382-10.292 5.287c0 0 2.165-4.377 11.811-7.276s14.583-5.571 13.519-6.054c-1.063-.483-3.456-.881-5.279-.597s-1.291-.142-7.177 2.189-3.38 1.819-8.127 2.842-6.684 2.075-9.038 3.07c0 0 .96-1.28 4.158-2.452 1.643-.601-1.798-1.221 2.763-1.406.372-.015.828.093 1.281-.036 5.896-1.691 12.342-4.008 11.355-4.178-.987-.171-6.722-.767-12.532 1.904-5.81 2.672-3.152 1.762-5.203 2.189-2.051.426-6.38 3.155-7.823 4.32-1.444 1.164-3.456 2.045-3.456 2.045z'/%3e%3cpath fill='%235A3719' d='M777.84 188.43s2.279.682 2.848 2.281 1.994-.703 1.937-1.428-1.453-3.922-3.931-2.43-1.235 1.439-.854 1.577z'/%3e%3cpath fill='%237B3C20' d='M771.484 220.027s4.863-2.287 8.943-2.004c0 0-1.595-5.756 1.253-4.775 2.848.981 2.051.597 2.62.554 0 0 .171-3.795-.57-5.287 0 0 2.905.682 5.867.725 0 0-2.791-5.457.285-9.209 0 0 1.689 3.581 5.487 4.477 0 0 .018-1.535 0-3.155 0 0 2.26-.256 4.026.682s3.247-9.891-1.994-12.279c0 0-1.253 2.046-6.152 3.07-4.899 1.023-4.859 2.007-6.873 5.694s-3.779 3.729-7.881 6.372c-4.101 2.643-6.594 8.015-6.829 8.484.002 0 2.16 2.643 1.818 6.651z'/%3e%3cpath fill='%23999' d='M934.91 157.12c1.781-.312-1.798-1.221 2.763-1.406.372-.015.828.093 1.281-.036 5.896-1.691 12.342-4.008 11.355-4.178-.987-.171-6.722-.767-12.532 1.904-5.81 2.672-3.152 1.762-5.203 2.189-2.051.426-6.38 3.155-7.823 4.32s-3.456 2.046-3.456 2.046-4.785 1.364-.342 4.306 6.608 5.5 9.855 6.353 6.608 2.046 6.551 5.287c-.057 3.24-.684 4.519-2.449 6.736-1.766 2.217.968 3.198 3.304 1.919s4.329-1.961 5.867-2.857 4.101-.767 1.766.426c-2.336 1.194-4.785 1.919-1.766 2.004s21.191.426 25.007-.81 8.772-1.62 9.228-6.566c0 0 .171-2.196 1.595-3.112 1.424-.917 2.393-3.027.313-1.599-2.079 1.428-3.674 2.153-4.073 1.727s-.513-.725.997-1.428 2.364-.043 3.76-2.11c1.396-2.068 1.259-1.727.516-2.515-.382-.405-.98-.753-1.368-1.132 0 0-1.094-.957-2.366-.147s-6.855 3.169-9.095 3.439c-2.241.27-4.557 1.222-8.583 3.183s-10.709 5.955-11.773 2.245c0 0-2.915 1.04-3.551 1.364-4.489 2.288-4.097-.959-3.304-1.847 0 0-2.354 2.643-2.26.241.095-2.402 1.614-1.99 4.234-2.757s6.76-2.473 5.051-3.894-3.513 1.411-5.412 2.276-5.696 1.632-6.285-1.125-.57-4.676-5.715-4.974-4.956-3.51-3.551-4.889 2.641-3.738 7.464-4.583z'/%3e%3cpath d='M951.263 182.053s8.013-3.695 15.38-5.429c7.367-1.734 1.595.227.342.625s-12.722 4.178-15.418 5.429c-2.697 1.251-2.141.181-.304-.625zm1.861 1.62s9-2.984 10.671-1.734c1.671 1.251.304.625-1.671.91-1.975.284-7.405 1.194-8.848 1.165-1.444-.028-.152-.341-.152-.341zm14.431-3.126s1.709-.313 1.899.313c.19.625-.76.711-1.709.597-.95-.114-1.785-.655-.19-.91z'/%3e%3cpath fill='%23FFF' d='M729.838 258.967s-.336-7.902 3.651-11.91 23.355-24.163 26.317-29.797c0 0 2.506 1.742 2.62 4.94 0 0 3.247-5.592 5.81-7.699 0 0 2.279 2.327 1.88 6.974 0 0 4.671-2.473 11.906-2.515 0 0-2.677 3.155-2.791 4.988 0 0 10.026-1.109 15.266-.256 0 0-13.785 7.717-9.912 8.399s7.918-.043 7.918-.043-4.386 4.477-11.393 5.372c0 0 8.886-.128 10.652 1.876 0 0-8.659 1.322-15.608 6.608 0 0-.649-.298-.695-2.26 0 0-.216 1.748-2.21 3.411s-6.779 5.202-8.545 6.992c-1.766 1.791-5.07 5.329-8.602 5.159 0 0 .797-2.729-1.823-3.581-2.62-.853-5.639-.256-7.747 2.004 0 0-9.342.128-12.304.554 0 0 2.108-3.368 4.044-3.283 1.937.085 9.741 1.151 10.424-4.178.684-5.329-5.013-3.922-2.848-7.077s1.652-3.027 1.709-3.326c0 0-1.766.981-2.791 3.795s-1.766 4.988-5.469 7.802c-3.703 2.814-5.236 4.518-6.261 6.479.002.002-1.687.237-3.198.572z'/%3e%3cpath fill='%23FFF' d='M738.82 254.19s.304-1.08 3.038-1.535 2.848-1.762 2.506-2.331-1.975-.568.684-3.581c0 0 .949.256 1.595.995s3.645 7.163-7.823 6.452z'/%3e%3cpath fill='%23999' d='M732.257 248.61c.142 5.265 7.042 3.309 7.042 3.309-2.458 1.868-3.961 3.247-4.993 4.537.456-2.558-3.891-3.198-3.891-3.198.358-1.564.93-3.219 1.842-4.648zm25.371-28.138c.999-1.307 1.756-2.406 2.179-3.211 0 0 2.506 1.742 2.62 4.94 0 0 3.247-5.592 5.81-7.699 0 0 2.279 2.327 1.88 6.974 0 0 4.671-2.473 11.905-2.515 0 0-2.677 3.155-2.791 4.988 0 0 10.026-1.109 15.266-.256 0 0-13.785 7.717-9.912 8.399 3.874.682 7.918-.043 7.918-.043s-4.386 4.477-11.393 5.372c0 0 8.886-.128 10.652 1.876 0 0-2.53.386-5.952 1.576 0 0-2.555-2.4-9.96-2.059 0 0 5.76-3.223 10.329-4.264 0 0-2.013-2.643-5.165-.227 0 0-6.266-4.32-1.101-7.987 0 0-3.646-.767-6.038.938 0 0 .114-2.956 2.772-4.292 0 0-7.026-1.137-8.772 4.036 0 0-1.329-2.132-.722-4.548 0 0-4.253 2.446-6.19 5.217.002.001-.639-5.254-3.335-7.215m-13.616 33.416c-1.261.31-2.949.443-5.187.304 0 0 .192-.681 1.639-1.189 0 0 .415.864 3.548.885'/%3e%3cpath d='M756.787 233.969s3.19 2.515 4.329 4.05c0 0 2.905-2.047 3.987-3.709 0 0 2.279 1.492 3.076 3.709 0 0 1.595-1.109 1.937-2.643 0 0 4.022.853 5.343 2.174 0 0 .615-3.88 0-6.31 0 0 2.803.213 4.512.938 0 0-1.589-2.558 6.525-5.841 0 0-6.136 1.317-8.462 4.008 0 0-2.62.128-3.76-.682 0 0 .171 3.922.057 5.798 0 0-1.581-.64-4.664-1.364 0 0-.747 1.279-1.26 1.577 0 0-1.937-1.535-2.791-3.496 0 0-2.963 2.691-4.101 3.837 0 0-2.791-1.961-4.728-2.046z'/%3e%3cpath fill='%23FFC221' d='M738.44 273.88s1.253.597 4.215-1.791 11.336-7.717 12.133-11.981-2.677-4.519-5.412-3.283c-2.734 1.236-1.595 3.624-1.481 4.391s.171 3.752-4.272 7.888c-4.443 4.137-5.183 4.776-5.183 4.776z'/%3e%3cpath fill='%23FFC221' d='M737.477 275.24s-6.722-2.814-.684-5.841 8.716-3.837 9.399-6.353c.684-2.516.285-2.089-1.937-1.023s-10.766 4.903-12.076 1.322c0 0 3.532 1.364 7.918-.767s7.975-2.771 5.184-3.667c-2.791-.895-12.874.213-14.526.682-1.652.469-1.253.384-1.538 2.046-.285 1.663-2.165 5.159-2.848 6.182-.684 1.023-2.336 5.287.741 7.163 3.075 1.876 7.951 1.747 10.367.256z'/%3e%3cpath d='M734.858 260.573s-1.54.213-1.255.81c.285.597.687.512 1.255.554s1.423-.298 1.536-.682c.114-.383-.965-.809-1.536-.682z'/%3e%3cpath fill='%23FFF' d='M737.078 273.748s-3.19-1.535.399-3.496 7.462-3.837 7.975-4.647c0-.001-1.709 2.429-8.374 8.143z'/%3e%3c/svg%3e";
            },
            5611: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3cpath fill='%23ed2939' d='M0 0h900v600H0z'/%3e%3cpath fill='%23fff' d='M0 200h900v200H0z'/%3e%3c/svg%3e";
            },
            1791: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 10080 5040'%3e%3cdefs%3e%3cclipPath id='b'%3e%3cpath d='M0 0h6v3H0z'/%3e%3c/clipPath%3e%3cclipPath id='c'%3e%3cpath d='M0 0v1.5h6V3zm6 0H3v3H0z'/%3e%3c/clipPath%3e%3cpath id='a' d='m0-360 69.421 215.845 212.038-80.301L155.99-35.603l194.985 115.71-225.881 19.651 31.105 224.59L0 160l-156.198 164.349 31.105-224.59-225.881-19.651 194.986-115.711-125.471-188.853 212.038 80.301z'/%3e%3cpath id='e' d='M0-210 54.86-75.508l144.862 10.614L88.765 28.842l34.67 141.052L0 93.334l-123.435 76.56 34.67-141.052-110.957-93.736L-54.86-75.508z'/%3e%3cuse xlink:href='%23a' id='d' transform='scale(2.1)'/%3e%3c/defs%3e%3cpath fill='%23012169' d='M0 0h10080v5040H0z'/%3e%3cpath stroke='%23fff' stroke-width='.6' d='m0 0 6 3m0-3L0 3' clip-path='url(%23b)' transform='scale(840)'/%3e%3cpath stroke='%23e4002b' stroke-width='.4' d='m0 0 6 3m0-3L0 3' clip-path='url(%23c)' transform='scale(840)'/%3e%3cpath stroke='%23fff' stroke-width='840' d='M2520 0v2520M0 1260h5040'/%3e%3cpath stroke='%23e4002b' stroke-width='504' d='M2520 0v2520M0 1260h5040'/%3e%3cg fill='%23fff'%3e%3cuse xlink:href='%23d' x='2520' y='3780'/%3e%3cuse xlink:href='%23a' x='7560' y='4200'/%3e%3cuse xlink:href='%23a' x='6300' y='2205'/%3e%3cuse xlink:href='%23a' x='7560' y='840'/%3e%3cuse xlink:href='%23a' x='8680' y='1869'/%3e%3cuse xlink:href='%23e' x='8064' y='2730'/%3e%3c/g%3e%3c/svg%3e";
            },
            3875: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 18'%3e%3cpath fill='%23418fde' d='M0 0h27v18H0V0z'/%3e%3cpath fill='%23ffd100' d='M0 12h27v1H0v1h27v1H0v-3z'/%3e%3cpath fill='%23EF3340' stroke='%23FFF' stroke-miterlimit='10' stroke-width='.2' d='M4.625 3.375 4 1.35l-.625 2.025L1.35 4l2.025.625L4 6.65l.625-2.025L6.65 4z'/%3e%3c/svg%3e";
            },
            3170: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 260 170'%3e%3cpath fill='%230053A5' d='M0 0h260v170H0z'/%3e%3cg fill='%23FFCE00'%3e%3cpath d='M80 0h50v170H80z'/%3e%3cpath d='M0 60h260v50H0z'/%3e%3c/g%3e%3cg fill='%23D21034'%3e%3cpath d='M95 0h20v170H95z'/%3e%3cpath d='M0 75h260v20H0z'/%3e%3c/g%3e%3c/svg%3e";
            },
            1477: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 600'%3e%3cpath fill='%233f9c35' d='M0 0h1200v600H0z'/%3e%3cpath fill='%23ed2939' d='M0 0h1200v400H0z'/%3e%3cpath fill='%2300b9e4' d='M0 0h1200v200H0z'/%3e%3ccircle cx='580' cy='300' r='90' fill='%23fff'/%3e%3ccircle cx='600' cy='300' r='75' fill='%23ed2939'/%3e%3cpath fill='%23fff' d='m680 250 9.567 26.903 25.788-12.258-12.258 25.788L730 300l-26.903 9.567 12.258 25.788-25.788-12.258L680 350l-9.567-26.903-25.788 12.258 12.258-25.788L630 300l26.903-9.567-12.258-25.788 25.788 12.258L680 250z'/%3e%3c/svg%3e";
            },
            4324: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 16 8'%3e%3cpath fill='%23002395' d='M0 0h16v8H0z'/%3e%3cpath fill='%23fecb00' d='M4.24 0h8v8z'/%3e%3cg id='b'%3e%3cpath id='a' fill='%23fff' d='M2.353.525 2.8-.85 3.247.525l-1.17-.85h1.446z'/%3e%3cuse xlink:href='%23a' x='1' y='1'/%3e%3cuse xlink:href='%23a' x='2' y='2'/%3e%3c/g%3e%3cuse xlink:href='%23b' x='3' y='3'/%3e%3cuse xlink:href='%23b' x='6' y='6'/%3e%3c/svg%3e";
            },
            2594: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 24000 16000'%3e%3cpath fill='%2300267f' d='M0 0h24000v16000H0z'/%3e%3cpath fill='%23ffc726' d='M8000 0h8000v16000H8000z'/%3e%3cpath id='a' fill='%23000' d='M12000 4124c-260 709-525 1447-1092 2012 176-58 484-110 682-105v2982l-842 125c-30-3-40-50-40-114-81-926-300-1704-552-2509-18-110-337-530-91-456 30 4 359 138 307 74-448-464-1103-798-1739-897-56-14-89 14-39 79 844 1299 1550 2832 1544 4651 328 0 1123-194 1452-194v2104h415l95-5876z'/%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 24000 0)'/%3e%3c/svg%3e";
            },
            768: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 12'%3e%3cpath fill='%23006a4e' d='M0 0h20v12H0z'/%3e%3ccircle cx='9' cy='6' r='4' fill='%23f42a41'/%3e%3c/svg%3e";
            },
            8194: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 390'%3e%3cpath fill='%23ED2939' d='M0 0h450v390H0z'/%3e%3cpath fill='%23FAE042' d='M0 0h300v390H0z'/%3e%3cpath d='M0 0h150v390H0z'/%3e%3c/svg%3e";
            },
            3121: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3e%3cpath fill='%23009e49' d='M0 0h900v600H0z'/%3e%3cpath fill='%23ef2b2d' d='M0 0h900v300H0z'/%3e%3cg fill='%23fcd116' transform='translate(450 300)'%3e%3cg id='b'%3e%3cpath id='a' d='M0-100V0h50' transform='rotate(18 0 -100)'/%3e%3cuse xlink:href='%23a' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(72)'/%3e%3cuse xlink:href='%23b' transform='rotate(144)'/%3e%3cuse xlink:href='%23b' transform='rotate(216)'/%3e%3cuse xlink:href='%23b' transform='rotate(288)'/%3e%3c/g%3e%3c/svg%3e";
            },
            1096: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'%3e%3cpath fill='%23fff' d='M0 0h5v3H0z'/%3e%3cpath fill='%2300966E' d='M0 1h5v2H0z'/%3e%3cpath fill='%23D62612' d='M0 2h5v1H0z'/%3e%3c/svg%3e";
            },
            9197: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1500 900'%3e%3cpath fill='%23fff' d='M0 0h1500v900H0'/%3e%3cpath fill='%23ce1126' d='M1500 0H375l225 90-225 90 225 90-225 90 225 90-225 90 225 90-225 90 225 90-225 90h1125'/%3e%3c/svg%3e";
            },
            744: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 500 300'%3e%3cdefs%3e%3cuse xlink:href='%23a' id='f' x='250' y='106'/%3e%3cg id='a' fill='%231eb53a'%3e%3cg id='e'%3e%3cg id='d'%3e%3cg id='c'%3e%3cpath id='b' d='M0-20V0h20' transform='rotate(30 0 -20)'/%3e%3cuse xlink:href='%23b' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='rotate(120)'/%3e%3cuse xlink:href='%23c' transform='rotate(240)'/%3e%3c/g%3e%3cuse xlink:href='%23d' transform='rotate(180)'/%3e%3c/g%3e%3cuse xlink:href='%23e' fill='%23ce1126' transform='scale(.82)'/%3e%3c/g%3e%3c/defs%3e%3cpath fill='%23ce1126' d='M0 0h500L0 300h500z'/%3e%3cpath fill='%231eb53a' d='M0 0v300L500 0v300z'/%3e%3cpath stroke='%23fff' stroke-width='40' d='m0 0 500 300m0-300L0 300'/%3e%3ccircle cx='250' cy='150' r='85' fill='%23fff'/%3e%3cuse xlink:href='%23f'/%3e%3cuse xlink:href='%23f' transform='rotate(120 250 150)'/%3e%3cuse xlink:href='%23f' transform='rotate(240 250 150)'/%3e%3c/svg%3e";
            },
            7709: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 15 10'%3e%3cpath fill='%23E8112D' d='M0 0h15v10H0z'/%3e%3cpath fill='%23FCD116' d='M0 0h15v5H0z'/%3e%3cpath fill='%23008751' d='M0 0h6v10H0z'/%3e%3c/svg%3e";
            },
            2603: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3e%3cpath fill='%23FFF' d='M0 625h937.5V0H0v625z'/%3e%3cg fill='none'%3e%3cpath fill='%23CE0F25' d='M659.049 394.35c10.735 25.244 6.121 45.149 0 64.53 15.479-5.609 48.359-21.014 44.419-40.226-6.894-16.818-28.349-20.938-44.419-24.304'/%3e%3cpath stroke='%23221B0F' d='M659.049 394.35c10.735 25.244 6.121 45.149 0 64.53 15.479-5.609 48.359-21.014 44.419-40.226-6.894-16.818-28.349-20.938-44.419-24.304z'/%3e%3cpath fill='%23FAF8F0' d='M604.198 503.635c9.756-3.152 16.456-6.744 32.61-8.985 6.658-.923 24.596.161 34.996-3.075 10.015-3.12 15.813-6.081 16.099-11.106.509-9.006 3.43-19.321 6.961-28.685 5.036-13.362 11.151-24.134 12.095-27.744.891-3.404-.64-6.816-2.896-9.945-8.792-12.194-28.496-21.087-46.054-21.066l.746 2.989c13.518.245 40.244 10.371 41.851 23.915 2.423 20.399-66.544 23.491-104.855 31.064 0 0-9.878 2.456-13.244 5.93-2.384 2.456-3.599 8.816-1.119 11.172 17.52 16.648 22.81 35.536 22.81 35.536'/%3e%3cpath stroke='%23221B0F' d='M604.198 503.635c9.756-3.152 16.456-6.744 32.61-8.985 6.658-.923 24.596.161 34.996-3.075 10.015-3.12 15.813-6.081 16.099-11.106.509-9.006 3.43-19.321 6.961-28.685 5.036-13.362 11.151-24.134 12.095-27.744.891-3.404-.64-6.816-2.896-9.945-8.792-12.194-28.496-21.087-46.054-21.066l.746 2.989c13.518.245 40.244 10.371 41.851 23.915 2.423 20.399-66.544 23.491-104.855 31.064 0 0-9.878 2.456-13.244 5.93-2.384 2.456-3.599 8.816-1.119 11.172 17.52 16.648 22.81 35.536 22.81 35.536z'/%3e%3cpath fill='%23F6E4BE' d='M700.591 432.568c-25.791 16.68-60.626 17.901-91.055 20.664l-19.374 19.696 17.76 26.156s19.784-6.49 30.028-8.074c7.24-1.117 15.374-.115 22.601-1.29 6.188-1.007 11.685-.457 15.823-5.167 4.81-5.48 4.564-15.445 7.103-22.28 1.62-4.356 4.209-7.956 7.579-13.121 5.401-8.283 9.535-16.584 9.535-16.584'/%3e%3cpath fill='%23CE0F25' d='M594.856 514.846c4.751-22.985-10-32.042-17.935-45.961 0 0 8.549 3.504 13.076 4.109 8.494 1.134 13.394.96 25.681-1.019 10.059-1.621 18.512-6.689 25.515-3.465.973.448 1.72 1.554 1.867 2.617.454 3.278-1.45 6.64-3.362 9.341-10.493 14.808-44.842 34.378-44.842 34.378'/%3e%3cpath stroke='%23221B0F' d='M594.856 514.846c4.751-22.985-10-32.042-17.935-45.961 0 0 8.549 3.504 13.076 4.109 8.494 1.134 13.394.96 25.681-1.019 10.059-1.621 18.512-6.689 25.515-3.465.973.448 1.72 1.554 1.867 2.617.454 3.278-1.45 6.64-3.362 9.341-10.493 14.808-44.842 34.378-44.842 34.378z'/%3e%3cpath fill='%23CE0F25' d='M278.37 394.35c-10.736 25.244-6.121 45.149 0 64.53-15.479-5.609-48.36-21.014-44.417-40.226 6.894-16.818 28.347-20.938 44.417-24.304'/%3e%3cpath stroke='%23221B0F' d='M278.37 394.35c-10.736 25.244-6.121 45.149 0 64.53-15.479-5.609-48.36-21.014-44.417-40.226 6.894-16.818 28.347-20.938 44.417-24.304z'/%3e%3cpath fill='%23FAF8F0' d='M333.22 503.635c-9.757-3.152-16.455-6.744-32.608-8.985-6.66-.923-24.596.161-34.996-3.075-10.016-3.12-15.816-6.081-16.1-11.106-.51-9.006-3.431-19.321-6.961-28.685-5.039-13.362-11.154-24.134-12.096-27.744-.89-3.404.64-6.816 2.898-9.945 8.792-12.194 28.499-21.087 46.054-21.066l-.747 2.989c-13.516.245-40.242 10.371-41.851 23.915-2.423 20.399 66.544 23.491 104.856 31.064 0 0 9.876 2.456 13.244 5.93 2.384 2.456 3.599 8.816 1.117 11.172-17.517 16.648-22.81 35.536-22.81 35.536'/%3e%3cpath stroke='%23221B0F' d='M333.22 503.635c-9.757-3.152-16.455-6.744-32.608-8.985-6.66-.923-24.596.161-34.996-3.075-10.016-3.12-15.816-6.081-16.1-11.106-.51-9.006-3.431-19.321-6.961-28.685-5.039-13.362-11.154-24.134-12.096-27.744-.89-3.404.64-6.816 2.898-9.945 8.792-12.194 28.499-21.087 46.054-21.066l-.747 2.989c-13.516.245-40.242 10.371-41.851 23.915-2.423 20.399 66.544 23.491 104.856 31.064 0 0 9.876 2.456 13.244 5.93 2.384 2.456 3.599 8.816 1.117 11.172-17.517 16.648-22.81 35.536-22.81 35.536z'/%3e%3cpath fill='%23F6E4BE' d='M236.83 432.568c25.79 16.68 60.625 17.901 91.054 20.664l19.372 19.696-17.759 26.156s-19.785-6.49-30.029-8.074c-7.239-1.117-15.37-.115-22.601-1.29-6.188-1.007-11.686-.457-15.821-5.167-4.81-5.48-4.564-15.445-7.104-22.28-1.617-4.356-4.207-7.956-7.579-13.121-5.399-8.283-9.533-16.584-9.533-16.584'/%3e%3cpath fill='%23CE0F25' d='M342.561 514.846c-4.749-22.985 10-32.042 17.938-45.961 0 0-8.55 3.504-13.08 4.109-8.49 1.134-13.391.96-25.679-1.019-10.057-1.621-18.513-6.689-25.514-3.465-.974.448-1.722 1.554-1.869 2.617-.454 3.278 1.45 6.64 3.362 9.341 10.496 14.808 44.842 34.378 44.842 34.378'/%3e%3cpath stroke='%23221B0F' d='M342.561 514.846c-4.749-22.985 10-32.042 17.938-45.961 0 0-8.55 3.504-13.08 4.109-8.49 1.134-13.391.96-25.679-1.019-10.057-1.621-18.513-6.689-25.514-3.465-.974.448-1.722 1.554-1.869 2.617-.454 3.278 1.45 6.64 3.362 9.341 10.496 14.808 44.842 34.378 44.842 34.378z'/%3e%3cpath fill='%23FAF8F0' d='M305.291 543.188c-4.464-2.861-9.549-5.693-12.377-9.996-1.949-2.965-2.796-7.039-1.904-10.474 5.216-20.094 4.106-30.854.49-46.069-1.167-4.917-2.358-12.341 3.794-12.01 15.78.851 33.471 5.886 46.178 5.431 5.191-.189 12.95-1.221 13.616-6.881.791-6.723-16.472-12.695-16.472-12.695 10.261 1.178 18.752 5.424 21.666 11.428 1.184 2.441.635 5.897-.894 8.141-3.009 4.423-8.734 5.621-14.034 6.331-10.558 1.425-28.455-1.47-38.575-3.412-4.577-.878-6.177-1.598-6.976-.971-2.002 1.577.731 4.762 7.103 10.72 12.891 12.055 27.917 21.872 43.424 30.307 42.229 22.967 74.524 30.305 118.381 30.305 43.855 0 76.149-7.337 118.38-30.305 15.506-8.435 30.531-18.253 43.423-30.307 6.372-5.957 9.108-9.143 7.1-10.72-.794-.626-2.395.094-6.974.971-10.12 1.943-28.017 4.837-38.576 3.413-5.296-.71-11.024-1.909-14.033-6.331-1.529-2.244-2.077-5.7-.891-8.141 2.914-6.004 11.402-10.25 21.664-11.427 0 0-17.262 5.973-16.471 12.695.665 5.66 8.424 6.693 13.615 6.881 12.709.455 30.396-4.58 46.179-5.431 6.152-.331 4.962 7.092 3.792 12.01-3.616 15.215-4.728 25.975.491 46.069.89 3.435.042 7.509-1.905 10.474-2.827 4.304-7.911 7.135-12.378 9.996-51.901 33.279-110.235 50.366-163.416 50.366-53.183-.001-111.518-17.089-163.42-50.368'/%3e%3cpath stroke='%23221B0F' d='M305.291 543.188c-4.464-2.861-9.549-5.693-12.377-9.996-1.949-2.965-2.796-7.039-1.904-10.474 5.216-20.094 4.106-30.854.49-46.069-1.167-4.917-2.358-12.341 3.794-12.01 15.78.851 33.471 5.886 46.178 5.431 5.191-.189 12.95-1.221 13.616-6.881.791-6.723-16.472-12.695-16.472-12.695 10.261 1.178 18.752 5.424 21.666 11.428 1.184 2.441.635 5.897-.894 8.141-3.009 4.423-8.734 5.621-14.034 6.331-10.558 1.425-28.455-1.47-38.575-3.412-4.577-.878-6.177-1.598-6.976-.971-2.002 1.577.731 4.762 7.103 10.72 12.891 12.055 27.917 21.872 43.424 30.307 42.229 22.967 74.524 30.305 118.381 30.305 43.855 0 76.149-7.337 118.38-30.305 15.506-8.435 30.531-18.253 43.423-30.307 6.372-5.957 9.108-9.143 7.1-10.72-.794-.626-2.395.094-6.974.971-10.12 1.943-28.017 4.837-38.576 3.413-5.296-.71-11.024-1.909-14.033-6.331-1.529-2.244-2.077-5.7-.891-8.141 2.914-6.004 11.402-10.25 21.664-11.427 0 0-17.262 5.973-16.471 12.695.665 5.66 8.424 6.693 13.615 6.881 12.709.455 30.396-4.58 46.179-5.431 6.152-.331 4.962 7.092 3.792 12.01-3.616 15.215-4.728 25.975.491 46.069.89 3.435.042 7.509-1.905 10.474-2.827 4.304-7.911 7.135-12.378 9.996-51.901 33.279-110.235 50.366-163.416 50.366-53.183-.001-111.518-17.089-163.42-50.368z'/%3e%3cpath fill='%23F6E4BE' d='M637.419 535.408s3.499-3.49 4.145-6.447c1.611-7.385-2.131-15.006-2.303-22.563-.185-8.148 1.383-24.404 1.383-24.404-20.186 19.274-75.825 68.013-171.934 68.013-93.4 0-151.749-48.739-171.935-68.013 0 0 1.565 16.256 1.381 24.404-.17 7.556-3.915 15.178-2.301 22.563.645 2.958 4.143 6.448 4.143 6.448 52.923 33.996 109.461 54.795 168.712 54.795 59.249-.001 115.788-20.8 168.709-54.796'/%3e%3c/g%3e%3cpath d='M365.845 550.515c1.832-5.256 7.756-10.813 17.201-7.524 7.839 2.731 11.168 8.888 8.714 15.929-2.452 7.039-9.43 10.85-17.426 8.066-9.036-3.147-10.385-11.03-8.489-16.471m21.111 8.006c2.399-6.886-.174-12.572-5.338-14.371-3.62-1.261-8.43-.731-11.098 6.925-2.227 6.395-.374 12.729 5.671 14.831 2.205.77 7.669 1.502 10.765-7.385m11.179-.254c1.155-4.813 1.368-5.697 1.545-6.727.195-1.091.056-1.659-.961-2.138-.245-.126-.787-.29-1.241-.399-.356-.085-.536-.193-.484-.418.054-.22.296-.23.783-.11 1.719.41 3.737.996 4.71 1.229.779.188 2.844.583 4.011.859.487.117.699.236.646.456-.054.224-.264.24-.589.16-.355-.082-.557-.1-.961-.128-.915-.052-1.304.423-1.634 1.515-.307.997-.521 1.884-1.675 6.696l-1.064 4.431c-1.101 4.59-.624 6.745.661 8.395 1.178 1.519 2.639 2.004 3.741 2.269 1.428.341 3.284.319 4.885-.639 2.201-1.311 2.982-4.137 3.764-7.397l.95-3.958c1.154-4.811 1.366-5.697 1.545-6.726.194-1.092.056-1.661-.961-2.138-.245-.125-.789-.29-1.144-.375-.357-.086-.537-.198-.484-.418.053-.223.295-.23.75-.12 1.653.396 3.673.981 3.705.989.389.095 2.455.489 3.72.79.454.109.665.226.612.448-.054.223-.264.24-.652.145-.356-.085-.559-.1-.964-.13-.912-.051-1.301.424-1.632 1.516-.307.999-.52 1.884-1.675 6.695l-.813 3.388c-.842 3.516-2.096 7.164-5.366 8.79-2.765 1.38-5.184 1.167-7.291.664-1.719-.413-4.809-1.255-6.673-3.913-1.305-1.852-1.975-4.491-.874-9.081l1.11-4.62zm28.994 13.257c-.165-.025-.24.031-.334.215l-2.416 4.159c-.445.759-.72 1.509-.776 1.897-.084.579.153 1.04 1.176 1.188l.495.07c.396.056.485.135.459.329-.037.258-.245.294-.607.241-1.056-.153-2.463-.45-3.485-.598-.363-.052-2.191-.216-3.908-.462-.429-.061-.618-.153-.581-.412.029-.194.169-.239.434-.201a9.5 9.5 0 0 0 1.031.083c1.548.025 2.331-.981 3.222-2.497l11.15-18.791c.53-.879.779-1.204 1.107-1.156.298.042.454.361.679 1.15.537 1.886 3.967 15.532 5.378 20.734.838 3.081 1.73 3.668 2.399 3.929.481.167.972.27 1.369.326.264.038.424.095.391.321-.036.258-.343.28-1.564.102-1.189-.17-3.598-.515-6.229-.959-.589-.115-.985-.172-.952-.399.027-.193.169-.239.504-.224.24-.031.513-.288.403-.698l-1.688-7.019c-.043-.169-.132-.25-.298-.271l-7.359-1.057zm6.962-.647c.166.025.214-.066.192-.169l-1.832-8.354c-.014-.134-.022-.3-.123-.315-.097-.014-.187.138-.239.265l-4.17 7.46c-.051.122-.033.225.1.244l6.072.869zm17.258 7.42c-.025 2.54.378 3.401 1.036 3.654.559.214 1.191.27 1.724.288.366.016.565.089.557.282-.01.259-.311.315-.777.299-2.166-.079-3.495-.225-4.129-.246-.3-.011-1.869.028-3.601-.034-.434-.015-.732-.057-.721-.351.006-.195.21-.254.542-.241.433.016 1.034.005 1.505-.109.876-.23 1.043-1.167 1.179-3.996l.991-19.151c.024-.65.14-1.101.472-1.089.366.014.653.446 1.196 1.05.385.441 5.261 5.826 9.955 10.719 2.186 2.295 6.515 7.141 7.063 7.683l.167.005.193-14.619c.039-1.985-.239-2.614-1.026-2.969-.493-.211-1.292-.242-1.757-.259-.401-.013-.531-.115-.524-.311.01-.26.378-.28.878-.26 1.731.063 3.329.219 4.025.244.368.014 1.639-.039 3.27.017.435.015.768.06.757.321-.007.194-.211.286-.61.27-.334-.012-.601-.022-1.005.063-.943.226-1.232.901-1.333 2.721l-1.107 20.513c-.026.716-.167 1.005-.469.994-.366-.013-.754-.386-1.107-.758-2.029-2.028-6.139-6.443-9.482-9.917-3.506-3.644-7.06-7.746-7.638-8.386l-.1-.003-.124 13.576zm31.832-3.734c-.169.014-.229.081-.281.283l-1.472 4.578c-.273.836-.383 1.627-.353 2.019.041.584.371.984 1.404.907l.499-.035c.396-.028.503.027.516.224.019.259-.175.339-.541.365-1.064.078-2.502.084-3.533.161-.365.024-2.189.255-3.916.381-.431.033-.636-.018-.656-.279-.013-.194.114-.269.381-.29.3-.02.762-.085 1.025-.138 1.516-.307 2.066-1.456 2.614-3.128l6.88-20.739c.331-.971.505-1.342.837-1.367.3-.022.52.256.908.98.926 1.727 7.195 14.326 9.681 19.106 1.479 2.83 2.475 3.215 3.185 3.328a7.58 7.58 0 0 0 1.406.028c.268-.02.435 0 .452.227.018.261-.276.346-1.509.438-1.195.086-3.623.264-6.288.39-.6.014-1.002.041-1.016-.185-.015-.195.114-.269.444-.328.228-.081.44-.39.244-.768l-3.147-6.495c-.079-.159-.184-.214-.349-.204l-7.415.541zm6.665-2.116c.166-.014.191-.113.152-.208l-3.575-7.769c-.043-.128-.09-.289-.189-.281s-.155.174-.176.306l-2.481 8.178c-.024.134.018.229.15.219l6.119-.445zm19.683-1.839c.65 4.115.999 6.334 1.781 6.804.635.396 1.527.486 4.095.081 1.746-.274 3.027-.509 3.714-1.506.329-.481.583-1.445.551-2.066-.011-.291.024-.497.289-.537.229-.039.286.119.347.503.056.355.206 2.804.088 3.78-.085.737-.225.925-1.939 1.194-2.37.371-4.094.576-5.58.781a81.923 81.923 0 0 0-4.034.534c-.363.056-1.088.173-1.872.328-.757.119-1.604.319-2.263.422-.429.068-.675.006-.711-.217-.024-.162.091-.279.488-.341a5.664 5.664 0 0 0 1.166-.315c.639-.232.691-.968.676-1.919-.049-1.378-.448-3.917-.912-6.876l-.891-5.661c-.768-4.889-.909-5.79-1.137-6.807-.236-1.083-.581-1.556-1.704-1.609-.275-.025-.674.005-1.103.074-.363.054-.569.023-.605-.201-.035-.225.185-.325.679-.405 1.549-.244 3.638-.474 4.528-.612.791-.126 3.179-.601 4.466-.802.46-.073.701-.045.735.181.037.225-.151.321-.545.384a8.714 8.714 0 0 0-1.271.299c-.864.299-1.041.888-.93 2.024.096 1.04.237 1.941 1.006 6.83l.888 5.655zm18.356-2.288c-.16.04-.209.119-.23.324l-.699 4.759c-.132.87-.11 1.667-.018 2.046.137.57.529.91 1.534.667l.486-.117c.389-.096.502-.054.547.134.061.254-.119.364-.474.451-1.037.251-2.452.493-3.459.738-.356.086-2.116.611-3.802 1.02-.42.103-.631.086-.691-.167-.045-.189.069-.284.327-.347a9.52 9.52 0 0 0 .99-.306c1.445-.55 1.8-1.775 2.064-3.515l3.381-21.584c.166-1.01.276-1.409.6-1.486.291-.069.555.166 1.055.816 1.2 1.552 9.452 12.95 12.69 17.258 1.923 2.55 2.969 2.766 3.69 2.759.506-.024 1-.109 1.39-.204.26-.061.43-.071.484.151.059.254-.215.388-1.415.677-1.166.282-3.531.855-6.14 1.421-.591.109-.98.203-1.034-.019-.048-.189.069-.285.384-.395.212-.119.37-.459.116-.799l-4.173-5.889c-.103-.141-.216-.182-.376-.143l-7.227 1.75zm6.229-3.183c.162-.039.171-.141.116-.228l-4.804-7.075c-.06-.119-.134-.27-.23-.246-.096.025-.125.198-.128.33l-1.1 8.472c-.004.134.054.222.183.19l5.963-1.443zm10.89-5.111c-1.8-5.266-.558-13.291 8.909-16.526 7.857-2.681 14.272.115 16.683 7.17 2.409 7.055-.735 14.355-8.75 17.09-9.056 3.096-14.98-2.279-16.842-7.734m21.562-6.706c-2.358-6.901-7.889-9.794-13.064-8.025-3.629 1.237-7.089 4.621-4.47 12.291 2.188 6.409 7.553 10.253 13.611 8.184 2.209-.754 6.966-3.546 3.923-12.45'/%3e%3cpath fill='%23666' d='M600.99 134.593H336.514v18.726H600.99v-18.726z'/%3e%3cpath fill='none' stroke='%23520' d='M600.99 134.593H336.514v18.726H600.99v-18.726z'/%3e%3cg fill='%235E520E' stroke='%23520'%3e%3cpath fill='%23EACE24' stroke='%23806600' stroke-width='2' d='m336.514 153.318-29.936-70.443-5.031 1.529-10.99-25.175 20.187-5.964 4.571 11.818 9.746-2.889-4.171-11.585 20.56-4.742 3.655 12.07 10.121-1.949-3.503-12.188 20.62-3.595 2.823 12.279 13.641-1.932 1.185 6.206 5.063-.641-1.04-6.175 10.45-1.36 1.066 6.281 5.11-.515-.769-6.331 10.382-.948.872 6.326 10.099-.775-1.841-18.731 20.92-1.069.684 12.324 9.976-.152-.18-12.441 21.006.001-.323 12.592 10.155.208.739-12.533 20.871.917-1.906 18.997 10.095.699.876-6.261 10.35.95-.821 6.271 5.219.511.944-6.116 10.415 1.115-1 6.25 5.158.716 1.247-6.245 13.487 1.995 2.859-12.379 20.592 3.594-3.194 12.415 9.72 1.908 3.766-12.221 20.524 4.649-4.271 12.059 9.779 2.671 4.725-12.066 20.263 5.779-10.989 25.176-8.674-2.857-30.483 71.973c-84.189-24.222-184.104-24.323-265.399-.001'/%3e%3cpath d='M462.536 95.047V72.721c0-8.93 16.066-8.93 16.066 0v22.326m-133.352 15.17-6.93-21.565c-2.771-8.625 12.746-12.092 15.519-3.466l6.929 21.565m218.296-.822 6.929-21.564c2.775-8.626 18.29-5.16 15.519 3.465l-6.931 21.565'/%3e%3cpath fill='none' stroke='%23806600' d='m514.974 119.629-.915 7.759m-180.992 17.585c88.135-25.836 184.129-26.221 272.559-1.09m-275.756-5.987c90.111-26.456 188.276-26.865 278.703-1.165m-281.552-6.015c92.091-27.003 192.401-27.375 284.776-1.056m-287.687-5.514c93.783-27.525 195.94-27.951 290.05-1.212m-64.204.807-1.609 7.573m47.759 2.274-2.605 7.077m-16.872-11.816-2.204 7.189m-25.601-20.042-1.526 7.467m17.573-4.766-1.971 7.166m20.266-3.454-2.198 7.155m22.742-2.061-2.72 7.089m-22.142-20.316-1.96 6.535m25.408-1.22-2.536 6.84m-6.342-8.928-2.266 6.595m-33.02-13.54-1.626 6.79m-10.438-9.068-1.464 7.136m-40.835 3.524-.689 7.505m27.589-5.137-1.236 7.325m-31.647-17.767-.525 7.583m14.328-6.814-.804 7.483m24.235-4.805-1.284 7.229m-3.831-15.16-1.091 6.825m-12.795-8.075-.854 7.013m-20.546-8.799-.442 7m-129.146 18.778 2.147 6.95m121.167-18.048-.356 7.741m-136.884 6.596 2.505 7.096m79.461-20.279.79 7.59m18.186-8.426.397 7.355m-41.808-4.455 1.295 7.516m52.895-10.734.135 7.47m-81.654-.092 1.8 7.411m-27.173-10.098 2.351 7.265m15.617-10.97 1.938 7.189m9.263-9.159 1.699 7.427m14.613-9.89 1.386 7.331m21.084-9.548.944 7.518m16.71-8.856.589 7.699m15.14-8.234.246 7.474m21.902-7.933-.21 7.471m-140.382 9.467 2.734 7.245m133.758-31.169-.118 7.185m-15.818-6.994.184 6.9m-14.752-6.331.457 6.908m-27.547-4.82.981 7m-22.152-4.612 1.342 6.74m-16.139-4.562 1.655 6.865m-19.03-3.658 1.927 6.596m-27.806-1.049 2.599 7.026m213.407-24.418 8.036-37.306m-243.474 51.917c95.924-28.114 200.404-28.491 296.615-1.075M506.806 67.845c18.643 1.164 37.333 3.221 55.693 6.163m-48.753-21.106-.69 5.793a602.147 602.147 0 0 0-82.977-.013l-.737-5.916m-50.095 21.258c18.179-2.916 37.099-4.966 55.557-6.138m-57.913-3.206 8.567 37.223m52.087-5.791-3.638-37.683m73.407-.076-2.018 37.784M377.7 52.127l2.61 12.115c-26.975 4.16-52.976 12.363-78.764 20.163m260.99-32.49s-2.528 11.995-2.527 11.996c27.659 4.176 54.641 12.294 81.062 20.292'/%3e%3c/g%3e%3cpath fill='%231353B4' stroke='%23540' stroke-width='2' d='M336.514 153.317c-.704 45.093-.662 90.191 0 135.284.636 43.444 2.766 77.346 21.895 103.856 23.042 31.931 61.427 54.975 110.806 77.616 49.376-22.641 87.764-45.685 110.806-77.616 19.126-26.51 21.258-60.413 21.894-103.856.664-45.092.704-90.191 0-135.284H336.514z'/%3e%3cpath fill='%23CE0F25' d='M598.216 344.999c.088-11.274 2.433-16.629 2.434-27.901 1.169-22.626 1.618-45.096 1.265-67.644H336.514c-.354 22.548.094 44.817 1.262 67.644.004 11.272 2.416 16.628 2.501 27.901h257.939z'/%3e%3cpath fill='none' stroke='%23540' stroke-width='2' d='M336.135 248.863h266.159m-262.188 96.136h258.111'/%3e%3cpath fill='%23FFF' stroke='%23000' stroke-width='.805' d='m436.14 311.056 32.228-13.13-13.13 32.229 14.324-9.548 14.325 9.548-13.131-32.229 32.229 13.13-9.55-14.323 9.55-14.324-32.229 13.13 13.131-32.228-14.325 9.549-14.324-9.549 13.13 32.228-32.228-13.13 9.549 14.324-9.549 14.323z'/%3e%3cg id='a' fill='%23FFF' stroke='%23000'%3e%3cpath fill='%23EACE24' stroke='none' d='M256.42 398.03c-.345 39.061-.69 40.443-.69 40.443 17.109 16.765 19.139 22.906 24.195 28.346 6.567-9.507 16.764-5.705 16.764-5.705 2.075-8.986 12.964-16.764 12.964-16.764-15.209-1.209-41.48-8.989-43.554-12.099-6.888-10.332 2.592-41.651 2.592-41.651l-12.271 7.43z'/%3e%3cpath fill='none' stroke='%23806600' d='M256.42 398.03c-.345 39.061-.69 40.443-.69 40.443 17.109 16.765 19.139 22.906 24.195 28.346 6.567-9.507 16.764-5.705 16.764-5.705 2.075-8.986 12.964-16.764 12.964-16.764-15.209-1.209-41.48-8.989-43.554-12.099-6.888-10.332 2.592-41.651 2.592-41.651l-12.271 7.43z'/%3e%3cpath fill='%23EACE24' stroke='none' d='m293.936 459.211-16.865-12.953 20.042 11.975'/%3e%3cpath fill='none' stroke='%23806600' d='m293.936 459.211-16.865-12.953 20.042 11.975'/%3e%3cpath fill='%23EACE24' d='M268.904 379.505s21.131-8.626 42.788 6.57c2.069.604 3.581.427 5.227.141 4.186-4.489 13.681-17.685 21.014-15.974.54-11.15-.734-55.728-.734-55.728-3.176-.124-4.277 6.11-4.277 6.11 1.834 12.709-5.5 89.948-35.563 38.862l-21.265 2.2-7.19 17.819z'/%3e%3cpath fill='none' stroke='%23806600' d='M268.904 379.505s21.131-8.626 42.788 6.57c2.069.604 3.581.427 5.227.141 4.186-4.489 13.681-17.685 21.014-15.974.54-11.15-.734-55.728-.734-55.728-3.176-.124-4.277 6.11-4.277 6.11 1.834 12.709-5.5 89.948-35.563 38.862l-21.265 2.2-7.19 17.819z'/%3e%3cpath fill='%23EACE24' stroke='none' d='M257.333 200.842c18.148 6.567 18.375 10.037 36.347 25.937 14.345 5.705 35.71 19.692 36.92 22.804l-1.164 4.543c2.766 1.727 5.378-4.644 5.378-4.644-2.765-15.729-53.276-63.103-53.276-63.103l-22.249 4.685-1.956 9.778z'/%3e%3cpath fill='none' stroke='%23806600' d='M257.333 200.842c18.148 6.567 18.375 10.037 36.347 25.937 14.345 5.705 35.71 19.692 36.92 22.804l-1.164 4.543c2.766 1.727 5.378-4.644 5.378-4.644-2.765-15.729-53.276-63.103-53.276-63.103l-22.249 4.685-1.956 9.778z'/%3e%3cpath fill='none' d='m274.395 193.804 56.861 52.195 1.211 3.802m-45.629-36.64c5.704 10.025 16.248 13.654 16.248 13.654'/%3e%3cpath d='M263.87 180.412c-.244-18.82 21.999-31.285 21.999-32.996-2.201-13.415-33.976 18.575-35.688 22.731-1.964 6.064 2.445 13.443 2.445 13.443'/%3e%3cpath d='M269.981 155.725c-6.6 5.377-11.976 22.976-11.976 22.976m-4.401 1.467c-2.688-18.088 11-33.73 10.022-34.219-8.411-4.205-19.311 18.086-22.487 25.42l4.155 24.93'/%3e%3cpath d='M249.205 165.258c-3.423 8.799.244 20.775.244 20.775m-2.933 3.667c-4.4-4.399-.245-35.929-1.467-35.929-9.288 0-14.175 30.307-12.22 36.663 6.342 20.614 11.487 24.197 11.487 24.197'/%3e%3cpath d='M238.206 178.946c-.734 9.289 6.599 20.776 6.599 20.776m-.489 13.198c-11.731-10.999-13.766-40.511-15.397-43.506-12.553 2.445-6.11 33.73-6.11 33.73.244 2.444 16.62 21.998 16.62 21.998'/%3e%3cpath d='M227.451 188.967c-4.155 8.31 14.665 32.998 14.665 32.998'/%3e%3cpath d='M258.982 282.823s-3.178-42.528 2.199-48.882l-15.886-23.465-20.531 40.817 18.575 33.975 15.643-2.445z'/%3e%3cpath fill='none' d='M258.982 282.823s-3.178-42.528 2.199-48.882l-15.886-23.465-20.531 40.817 18.575 33.975 15.643-2.445z'/%3e%3cpath d='M244.026 375.503c6.966 8.92 10.37 29.036 10.37 29.036l2.074-6.569c.978.611 1.571 5.705 2.938 5.705.611 0 .504-5.251 1.901-5.533.611-.12.206 7.26 1.556 7.26 1.1 0 1.188-5.256 1.555-5.013.864.575 1.035 6.978 1.729 3.63-.977-34.341 66.34-62.443 64.985-100.936 1.711-39.839-41.135-54.959-67.405-88.488 0 0-7.381-21.987 6.221-12.271 11-1.711 10.025-12.616 10.025-12.616h6.049c2.69-23.464-20.912-17.974-20.912-17.974-21.875 0-23.85 22.64-23.85 22.64-5.622 29.454 32.542 64.53 32.542 64.53 5.621 12.221-.05 33.295-.05 33.295l-53.114 50.04'/%3e%3cpath d='M221.253 341.843c-2.934 3.545-18.003 21.403-21.669 27.635-5.191 5.723 4.9 4.113 4.9 4.113s-14.922 15.775-22.17 20.389c2.225 6.675 16.536-2.994 16.536-2.994s-13.933 8.555-13.198 10.266c4.251 3.244 16.619-5.865 16.619-5.865s-2.954 4.154-.489 5.621c4.156 0 13.687-7.576 13.687-7.576s-1.955 4.399.245 5.131c3.974-2.505 28.843-23.221 28.843-23.221'/%3e%3cpath fill='none' d='M230.855 331.268s-7.432 9.851-2.42 8.296'/%3e%3cpath d='M229.809 305.698c-6.049 11.753-13.77 31.131-5.359 39.75 2.766.865 10.145-27.608 15.901-30.245.864-2.936 4.666-15.899 4.666-15.899'/%3e%3cpath d='M239.184 304.332c3.173 0-6.347 6.356-9.778 15.154m12.328-12.922c-4.666 21.949-.345 26.615 1.556 26.789 2.765-1.385 7.605-21.434 13.135-22.643m-38.369-105.772c-19.356-18.148-21.95-38.886-24.024-39.061-9.135-.76 3.111 36.815 3.111 36.815l23.159 18.492'/%3e%3cpath d='M214.986 209.499s-9.286-7.089-14.176-16.621m17.246 25.196c-28.69-15.901-32.147-41.825-34.566-40.962-8.834 3.489 2.419 27.309 2.419 27.309 1.556 6.567 24.37 27.134 24.37 27.134'/%3e%3cpath d='M212.542 225.63s-12.22-9.044-21.997-23.954m18.697 27.977c-34.393-19.01-35.085-40.789-38.887-39.405-8.168 22.139 21.776 43.034 42.862 58.762'/%3e%3cpath d='M211.076 239.073s-15.644-5.621-25.421-20.531m26.871 29.949c-29.9-9.505-44.336-37.371-48.048-35.949-8.641 3.284 9.506 26.616 9.506 26.616 14.69 13.654 38.887 23.678 38.887 23.678'/%3e%3cpath d='M213.276 252.761s-20.776-3.911-32.02-15.4m31.443 23.747c-47.874-15.383-49.775-30.418-54.269-29.209-8.525 6.483 18.839 27.999 18.839 27.999 3.455 5.184 38.369 14.691 38.369 14.691'/%3e%3cpath d='M216.453 263.516s-24.198.489-34.463-7.822m32.955 18.723c-45.8-9.68-52.54-23.16-56.171-22.295-5.724 7.781 21.951 24.713 21.951 24.713 17.11 9.852 40.269 11.234 40.269 11.234'/%3e%3cpath d='M220.119 279.89s-16.131.489-26.398-5.132m19.841 29.729c-12.788 11.753-20.047 33.695-13.48 35.086 3.629.171 13.48-25.581 27.826-29.208l9.159-7.952'/%3e%3cpath d='M231.851 301.155c3.171 0-16.614 6.112-20.043 14.911m-4.986-22.293c-18.665 13.999-24.637 30.557-21.948 31.455 4.147 1.383 20.745-15.871 26.789-16.939 2.938-.518 20.394-9.85 20.394-9.85'/%3e%3cpath d='M218.164 295.533c3.171 0-12.948 5.621-16.376 14.423'/%3e%3cpath d='M220.131 287.724c-20.394 2.419-56.17-19.357-56.861-17.456-8.879 10.401 29.554 27.826 38.022 26.961l30.072 1.901'/%3e%3cpath d='M228.184 293.577s-24.686.246-35.93-4.886'/%3e%3cpath d='M284.156 290.157s0-11.488-5.621-11.977c0 0-12.71-.976-26.886 1.467-32.424-19.357-7.024-44.221-11.489-52.795-1.466-13.198-23.219-32.997-23.219-32.997-2.2 1.957.443 14.277-1.223 13.444-4.399-2.199-1.686 7.485-2.933 10.021-4.155-1.466-3.942 4.823-2.933 9.532-3.422.49-2.201 6.355-1.467 10.511-6.71-3.691 2.031 10.464-.245 10.02-10.265-1.467 1.467 9.778 1.467 9.778-5.866 2.2-3.126 6.563.979 8.31-5.134 3.666.121 9.519 1.954 9.778-4.644 2.443.524 5.976 3.177 8.554-4.155 3.911 3.422 5.581 7.09 7.087-2.934 4.644.515 5.648 3.665 7.088-1.955 3.666 2.856 3.394 5.865 2.935-3.665 3.91 2.445 5.621 4.889 5.13 0 0 1.304 5.074 5.623 3.179-1.221 3.913 7.578 3.423 7.578 3.423 0 3.914 12.954 2.445 12.954 2.445'/%3e%3cpath fill='none' d='M221.087 223.77s2.689 7.088 5.866 7.088m-10.744-23.804s3.421 11.978 6.599 11.978m-9.532-2.69s.978 7.821 4.154 7.821m-7.576 2.2s2.689 7.088 5.865 7.088m-7.577 3.177s2.934 6.355 6.111 6.355m-5.866 3.911s4.889 7.821 8.065 7.821m-7.087 2.69s5.132 4.4 8.31 4.4m-7.089 3.909s5.132 4.4 8.31 4.4m-7.087 4.644s7.576 3.666 10.754 3.666m-7.333 4.889s8.555.734 11.732.734m-4.757 6.283s7.173-.304 10.349-.304m-6.2 7.218s6.136-1.688 10.004-.304m-4.301 4.278s6.134-1.689 10.004-.304m-5.511 4.97s5.963-.82 10.176-2.551m-4.126 5.663s2.504.732 6.719-.994m.54 4.103s2.16-.13 6.375-1.856m24.026-120.433c-5.011-9.505-10.198-8.468-10.198-8.468-2.591 0-3.456 1.728-6.394 1.728-3.63 0-2.765-3.803-2.765-3.803'/%3e%3cpath fill='%23000' stroke='none' d='M272.137 181.521c-1.037 4.494-4.338 5.366-4.338 5.366s.716 4.289 3.474 4.485c5.065.907 6.719-3.649 4.32-7.605-.862-1.037-3.456-2.246-3.456-2.246'/%3e%3cpath stroke='none' d='M275.279 186.708c.164.554-.675 1.33-1.875 1.731-1.2.404-2.306.279-2.47-.276l-.001-.003c-.164-.555.676-1.33 1.875-1.732 1.201-.401 2.306-.277 2.471.277v.003'/%3e%3cpath fill='none' d='M206.061 373.022c-1.589 2.566 5.745 3.248 7.7.244 0 4.156 5.665 4.314 7.699 2.322.855 2.689 4.813 2.003 7.333-.489.428 1.16 4.014 3.647 5.339 3.17 2.59-.934 12.71-15.254 14.909-16.475m-53.271 31.175s11.623-11.319 19.226-17.367m-15.251 21.515s15.289-14.13 22.894-20.179m-8.203 17.414s10.156-10.464 17.76-16.512m-27.871-4.548s11.356-13.535 18.961-19.584m-10.099 19.944s9.546-10.953 20.45-18.711m-11.747 20.345s4.499-8.628 18.214-19.196m-11.248 19.075s5.22-9.049 14.658-15.831m-15.253 17.043c-7.778 7.95-14 13.309-14 13.309m2.768-12.617c-7.779 7.95-15.727 14.345-15.727 14.345m8.121-16.592c-7.778 7.95-9.851 8.643-9.851 8.643m17.488-35.853c-1.59 2.566 2.004 8.781 9.663 5.086-2.42 6.402 1.171 4.66 6.145 2.324-1.392 5.452 4.813 2 7.331-.49.427 1.161.557 3.995 2.919 4.21 2.743.249 5.623-7.651 7.824-8.871m-24.471 2.943 13.889-12.731m-21.279 13.4 6.761-10.289m6.872 11.744 8.338-9.151m-1.109 8.957 4.392-4.809m-17.801 6.22c-1.729 1.902-5.704 4.84-5.704 4.84m13.135-2.937c-3.803 2.938-7.085 6.05-7.085 6.05m19.184-3.113c-7.778 7.95-6.049 5.876-6.049 5.876m1.9-9.16c-3.803 2.939-6.049 5.185-6.049 5.185m13.826-24.542c-11.061 13.827 4.84 2.765 4.84 2.765m-19.092 3.824s-6.486 1.188.945-7.799m11.58-6.567-2.074 3.284m-.352-94.299c-1.955 5.621 3.423 11.244 3.423 11.244m-7.578-8.066c-1.956 5.621 7.086 14.909 7.086 14.909m-8.799-5.378c-1.954 5.623 8.066 10.266 8.066 10.266m-3.665 3.911c.489 4.155 7.821 3.177 7.821 3.177m-18.282-48.787s.624 4.735 2.939 11.235c-3.63 3.629-4.32 9.159-4.32 9.159m-11.143-17.462s2.689 7.088 5.866 7.088m-7.421 1.728s2.689 7.088 5.866 7.088m-8.804.343s3.38 4.669 6.557 4.669m-5.348 4.664s3.381 4.669 6.559 4.669m-4.139 5.182s3.726.866 6.903.866m-4.656 6.047s.787.175 3.965.175m-.163-48.912s-.423 3.978 2.756 3.978m.948 59.408s3.972-.463 3.272-3.561m-9.148-1.968s6.91-2.019 6.213-5.117m8.305 18.596s1.208-8.066.509-11.166m8.997 17.562s-1.213-10.66-3.639-12.031m14.181 14.622c-2.591-8.986-6.051-13.079-8.478-13.932m18.676 13.415c-2.592-8.987-9.509-12.387-11.936-13.241m24.033 13.584c-2.592-8.986-9.506-12.387-11.934-13.238m3.471 25.212c-9.333 3.456-13.653 11.925-13.653 11.925m1.102-125.862c-2.445 0-3.178 1.466-3.178 1.466m-4.888 12.954c-1.037 2.938 2.23 6.975 1.711 6.111m-1.55-29.802c-2.421 0-2.594 4.666-2.594 4.666m15.73 35.776 3.456 4.494m-1.729 8.641 3.629 4.147m11.58 9.852 4.321 4.667'/%3e%3cpath fill='%23000' stroke='none' d='M304.346 270.347s2.054 5.674 3.519 6.162c0 0 1.666.56 2.766-.172 1.001-.668 0-2.075 0-2.075-1.342-1.955-6.285-3.915-6.285-3.915m-8.745 2.846s-.339 6.024.819 7.049c0 0 1.313 1.17 2.611.926 1.184-.221.815-1.908.815-1.908-.47-2.326-4.245-6.067-4.245-6.067m5.988 21.264s-.338 6.024.82 7.05c0 0 1.313 1.167 2.611.926 1.181-.222.814-1.909.814-1.909-.47-2.326-4.245-6.067-4.245-6.067m14.788 6.038-.13.301h-.329a.697.697 0 0 1-.527-.246c-.636-.721-.359-3.964-.116-5.977-.627-.818-2.075-2.852-1.885-3.942a.943.943 0 0 1 .43-.658l.317-.198.28.248c.368.326 3.603 3.232 3.83 4.825.133.922-1.398 4.555-1.87 5.647zm-32.675 17.667c-1.099 0-2.07 3.32-1.346 4.689 0 0 .816 1.555 2.118 1.785 1.185.209 1.434-1.5 1.434-1.5.377-2.343-.002-4.974-2.206-4.974m-6.604 48.563c-.472.821-2.362 1.968-2.735 2.189l-.294.174-.27-.211c-.673-.529-.293-1.921 1.128-4.138.006-.99.106-3.571.945-4.327a.947.947 0 0 1 .745-.253l.372.039.067.367c.089.485.845 4.767.042 6.16zm-15.52 4.521c-.273.477-.762.633-1.26.633-.436 0-.878-.119-1.191-.249l-.116-.068c-.819-.641-.438-2.657-.216-3.561.001-.916.081-3.635.945-4.413a.948.948 0 0 1 .744-.253l.349.037.083.341c.25 1.016 1.454 6.154.662 7.533zm12.832-23.586c-.285.494-.774.637-1.241.637-.569 0-1.107-.211-1.208-.253l-.118-.068c-.839-.658-.42-2.752-.201-3.622.176-.507 1.055-2.805 2.531-2.649l.384.041.058.382c.062.419.592 4.144-.205 5.532zm20.046-17.399s-2.435 5.519-1.714 6.886c0 0 .817 1.558 2.119 1.786 1.185.209 1.433-1.5 1.433-1.5.38-2.342-1.838-7.172-1.838-7.172m-7.096 14.258c-3.62 1.194-4.38 5.486-4.112 7.005 0 0 .3 1.732 1.467 2.351 1.064.565 1.825-.986 1.825-.986 1.08-2.114 3.386-6.414.82-8.37m-19.551-21.318c-2.441 1.646-2.449 3.084-2.465 4.629 0 0-.022 1.756 1.013 2.58.943.747 4.174-.638 4.174-.638 1.448-1.879-2.6-1.928-2.722-6.571m26.152-23.586c-2.441 1.646-2.448 1.371-2.464 4.626 0 0 .832 2.614 1.869 3.436.94.748 1.974-1.614 1.974-1.614 1.449-1.877.699-5.838-1.379-6.448m17.972 13.049c-1.1 0-2.07 3.32-1.347 4.686 0 0 .818 1.556 2.119 1.786 1.185.21 1.434-1.499 1.434-1.499.376-2.343-.003-4.973-2.206-4.973m-7.578 9.409c-1.571 5.08-3.413 6.621-2.691 7.988 0 0 1.794.455 3.096.684 1.185.211 1.432-1.497 1.432-1.497.381-2.344-1.471-1.676-1.837-7.175m-42.775 59.174c-1.1 0-2.07 3.319-1.347 4.686 0 0 .816 1.555 2.119 1.785 1.185.209 1.432-1.499 1.432-1.499.38-2.341-.001-4.972-2.204-4.972'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 938.5 0)'/%3e%3cg id='b' fill='%23EACE24' stroke='%23806600'%3e%3cpath d='M462.575 214.875c.309-2.981.144-8.604-1.376-11.159-.514-.862-1.772-1.869-2.755-1.826-.966.043-2.298.336-2.753 1.216-.417.808-.689 2.541-.59 3.45.137 1.264 1.572 3.854 1.572 3.854s-5.142-1.064-6.884-2.434c-1.721-1.356-3.581-3.925-4.13-6.088-.189-.74-.924-3.139.005-6.017.539-1.67 2.159-3.905 3.415-5.018 3.276-2.909 9.636-2.064 10.939-1.341 1.719.957 3.816 2.991 4.522 4.87.549 1.459 1.689 5.766 1.967 7.305.568 3.137.734 4.323.983 7.506.171 2.185.645 4.146.196 6.29-.241 1.155-.541 3.804-1.196 5.549-.658 1.754-1.67 2.604-2.541 3.379-1.78 1.585-7.473 2.435-7.473 2.435s3.128-4.073 3.933-5.884c.959-2.153 1.924-3.732 2.166-6.087m13.947 0c-.308-2.981-.144-8.604 1.376-11.159.514-.862 1.774-1.869 2.755-1.826.966.043 2.296.336 2.753 1.216.419.808.69 2.541.59 3.45-.139 1.264-1.574 3.854-1.574 3.854s5.144-1.064 6.886-2.434c1.721-1.356 3.579-3.925 4.129-6.088.189-.74.924-3.139-.005-6.017-.539-1.67-2.161-3.905-3.414-5.018-3.277-2.909-9.639-2.064-10.94-1.341-1.721.957-3.818 2.991-4.524 4.87-.549 1.459-1.688 5.766-1.967 7.305-.568 3.137-.733 4.323-.983 7.506-.173 2.185-.646 4.146-.197 6.29.243 1.155.544 3.804 1.197 5.549.656 1.754 1.67 2.604 2.541 3.379 1.779 1.585 7.474 2.435 7.474 2.435s-3.129-4.073-3.934-5.884c-.955-2.153-1.919-3.732-2.163-6.087'/%3e%3cpath d='M469.513 237.02s4.594-3.887 5.356-8.286c.683-3.958-2.362-8.591-2.594-10.455-.921-7.454 1.034-17.384 1.21-18.195.701-3.224 1.581-4.604 2.051-5.66.339-.76 1.304-2.271 2.269-3.735.554-.841 1.787-2.406 2.416-3.999.666-1.687.71-3.405.721-4.321.016-1.561-.271-2.89-.673-4.161-.381-1.209-1.626-3.186-3.429-4.323-1.944-1.226-3.515-2.211-4.114-2.601-1.975-1.289-3.191-5.528-3.215-5.528s-1.24 4.238-3.215 5.528c-.598.39-2.098 1.375-4.043 2.601-1.802 1.136-3.048 3.114-3.427 4.323-.403 1.271-.689 2.6-.671 4.161.009.916.054 2.634.721 4.321.628 1.592 1.861 3.156 2.416 3.999.966 1.464 1.93 2.975 2.268 3.735.47 1.056 1.351 2.436 2.051 5.66.176.811 2.132 10.741 1.209 18.195-.231 1.864-3.348 6.497-2.664 10.455.762 4.398 5.357 8.286 5.357 8.286'/%3e%3cpath d='m479.837 213.11-2.213-3.16h-16.145l-2.218 3.16 2.218 3.144h16.146l2.212-3.144z'/%3e%3c/g%3e%3cuse xlink:href='%23b' x='-86.94'/%3e%3cuse xlink:href='%23b' x='86.94'/%3e%3cg id='c'%3e%3cpath fill='%23EACE24' stroke='%23806600' stroke-miterlimit='10' d='M445.151 439.394h48.684v11.395h-48.684v-11.395zm-.002-2.479c-.081-10.701-1.586-21.734-6.15-31.13a6.23 6.23 0 0 1 8.016 5.969c0 .854-.169 1.663-.479 2.401a6.233 6.233 0 1 1 2.634 11.882c-.446 0-.882-.05-1.302-.138.467 4.205 2.625 7.391 5.216 7.391 2 0 3.74-1.897 4.647-4.696.905 2.799 2.648 4.696 4.647 4.696 2.785 0 5.069-3.681 5.291-8.356a6.186 6.186 0 0 1-3.533 1.103 6.231 6.231 0 0 1-.048-12.464 6.23 6.23 0 0 1 5.405-9.331 6.231 6.231 0 0 1 5.405 9.331 6.232 6.232 0 0 1-.047 12.464 6.19 6.19 0 0 1-3.534-1.103c.221 4.675 2.506 8.356 5.293 8.356 2 0 3.741-1.897 4.647-4.696.906 2.799 2.646 4.696 4.646 4.696 2.593 0 4.749-3.186 5.218-7.391a6.232 6.232 0 0 1-7.534-6.092 6.232 6.232 0 0 1 8.864-5.652 6.23 6.23 0 0 1 7.538-8.37c-4.565 9.396-6.069 20.429-6.151 31.13h-48.689z'/%3e%3cpath fill='%23806600' d='m470.924 419.776 6.634-1.04-6.97-1.095-1.095-6.969-1.091 6.969-6.971 1.095 6.635 1.04h2.858zm-25.994 21.493a.98.98 0 0 1 .927.639l1.149 2.526a.991.991 0 0 1-.001.814h.001l-1.173 2.579a.989.989 0 0 1-.904.582l.001-7.14zm.573-19.736 6.361-2.151-7.054.103-2.26-6.681 1.696 8.401 1.257.328z'/%3e%3cpath fill='%23806600' d='M443.709 418.248h.067c.063.004.115.01.158.014a.701.701 0 0 1 .351.141l.003.004.005.004c.119.087.231.18.334.276l.034.038c.109.102.206.202.286.301l.034.042c.489.613.783 1.391.783 2.235h.004v.009h-.004c0 .325-.042.632-.121.92l-.009.03-.03.1-.019.056-.004.008-.004.009a3.512 3.512 0 0 1-.278.628.696.696 0 0 1-.252.256h.001l-.006.004-.004.001-.005.005c-.046.026-.1.057-.165.092l-.13.063a68.768 68.768 0 0 0-1.16-5.232l.042-.003v-.001h.005c.029 0 .055.001.084.004v-.004z'/%3e%3cpath fill='%23FF8080' d='m464.851 444.943 4.365-2.579 4.365 2.579-4.365 2.579-4.365-2.579z'/%3e%3cpath fill='none' stroke='%239E7800' stroke-linejoin='round' d='m464.851 444.943 4.365-2.579 4.365 2.579-4.365 2.579-4.365-2.579z'/%3e%3cpath fill='%23FF8080' d='m464.851 444.943 4.365-2.579 4.365 2.579-4.365 2.579-4.365-2.579z'/%3e%3cpath fill='%23BA0028' d='m473.581 444.943-4.289 2.534-.076.045v-2.579h4.365z'/%3e%3cpath fill='%23CF1E45' d='M469.216 444.943v2.579l-4.366-2.579h4.366z'/%3e%3cpath fill='%23FF083C' d='M469.216 442.361v2.581h4.365l-.103-.061-3.95-2.334-.312-.186z'/%3e%3cpath fill='%23F9C' d='m442.574 444.852 2.577-2.578 1.174 2.578-1.174 2.579-2.577-2.579z'/%3e%3cpath fill='red' d='M442.574 444.852h3.751l-1.174 2.579-2.577-2.579z'/%3e%3cpath fill='%23CCC' d='M443.626 418.944c.077 0 .153.004.229.014a2.876 2.876 0 0 1 .837 3.76 2.03 2.03 0 0 1-1.066.304 2.04 2.04 0 1 1 0-4.078'/%3e%3cpath fill='none' stroke='%239E7800' d='M443.626 418.944c.077 0 .153.004.229.014a2.876 2.876 0 0 1 .837 3.76 2.03 2.03 0 0 1-1.066.304 2.04 2.04 0 1 1 0-4.078z'/%3e%3cpath fill='%23FFF' d='M442.649 419.753a.975.975 0 0 1 0 1.948.974.974 0 1 1 0-1.948'/%3e%3cpath fill='%23806600' d='m493.485 421.533-6.36-2.151 7.051.103 2.26-6.681-1.695 8.401-1.256.328z'/%3e%3cpath fill='%23806600' d='M495.281 418.248h-.07c-.06.004-.114.01-.156.014a.694.694 0 0 0-.35.141l-.004.004-.004.004c-.119.087-.231.18-.334.276l-.037.038a2.998 2.998 0 0 0-.284.301l-.034.042a3.571 3.571 0 0 0-.785 2.235h-.001v.009h.001c.001.325.045.632.124.92l.011.03.028.1c.005.02.012.038.019.056l.004.008.004.009c.074.219.166.434.279.628.06.11.149.194.251.256l.004.004.006.001.004.005c.046.026.1.057.165.092l.129.063a68.772 68.772 0 0 1 1.161-5.232l-.042-.003v-.001h-.006a.813.813 0 0 0-.084.004l.001-.004z'/%3e%3cpath fill='%23CCC' d='M495.365 418.944c-.079 0-.158.004-.232.014a2.876 2.876 0 0 0-.837 3.76 2.038 2.038 0 0 0 3.105-1.735 2.039 2.039 0 0 0-2.036-2.039'/%3e%3cpath fill='none' stroke='%239E7800' d='M495.365 418.944c-.079 0-.158.004-.232.014a2.876 2.876 0 0 0-.837 3.76 2.038 2.038 0 0 0 3.105-1.735 2.039 2.039 0 0 0-2.036-2.039z'/%3e%3cpath fill='%23FFF' d='M495.723 419.368a.974.974 0 1 0 0 1.947.974.974 0 0 0 0-1.947'/%3e%3cpath fill='%23806600' d='M494.059 441.269a.988.988 0 0 0-.929.639l-1.149 2.526a.987.987 0 0 0 .003.814h-.003l1.173 2.579a.99.99 0 0 0 .905.582v-7.14z'/%3e%3cpath fill='%23FF083C' d='m496.415 444.852-2.579-2.578-1.174 2.578 1.174 2.579 2.579-2.579z'/%3e%3cpath fill='%23BA0028' d='M496.415 444.852h-3.753l1.174 2.579 2.579-2.579z'/%3e%3ccircle cx='469.496' cy='418.747' r='2.287' fill='%23CCC' stroke='%239E7800' stroke-width='.5'/%3e%3ccircle cx='469.085' cy='418.041' r='.975' fill='%23FFF'/%3e%3ccircle cx='458.079' cy='442.665' r='1.668' fill='%23CCC' stroke='%239E7800' stroke-width='.5'/%3e%3ccircle cx='457.793' cy='442.174' r='.677' fill='%23FFF'/%3e%3ccircle cx='458.079' cy='447.518' r='1.668' fill='%23CCC' stroke='%239E7800' stroke-width='.5'/%3e%3ccircle cx='457.793' cy='447.026' r='.677' fill='%23FFF'/%3e%3ccircle cx='481.16' cy='442.665' r='1.668' fill='%23CCC' stroke='%239E7800' stroke-width='.5'/%3e%3ccircle cx='480.874' cy='442.174' r='.677' fill='%23FFF'/%3e%3ccircle cx='481.16' cy='447.518' r='1.668' fill='%23CCC' stroke='%239E7800' stroke-width='.5'/%3e%3ccircle cx='480.874' cy='447.026' r='.677' fill='%23FFF'/%3e%3c/g%3e%3cuse xlink:href='%23c' x='-49.151' y='-55.104'/%3e%3cuse xlink:href='%23c' x='49.151' y='-55.104'/%3e%3c/svg%3e";
            },
            9704: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 500'%3e%3cpath fill='%23c8102e' d='M0 0h1000v500H0z'/%3e%3cpath fill='%23012169' d='M0 0h500v250H0z'/%3e%3cpath fill='%23fff' d='M0 0v27.95L444.1 250H500v-27.95L55.9 0zm500 0v27.95L55.9 250H0v-27.95L444.1 0z'/%3e%3cpath fill='%23fff' d='M208.333 0v250h83.334V0zM0 83.333v83.334h500V83.333z'/%3e%3cpath fill='%23c8102e' d='M0 100v50h500v-50zM225 0v250h50V0zM0 250l166.667-83.333h37.266L37.267 250zM0 0l166.667 83.333H129.4L0 18.633zm296.067 83.333L462.733 0H500L333.333 83.333zM500 250l-166.667-83.333H370.6l129.4 64.7z'/%3e%3cpath fill='%23fff' d='M865.361 106.664v211.737c0 56.557-113.062 74.933-113.062 74.933s-113.062-18.376-113.062-74.933V106.664z'/%3e%3cpath fill='%232f8f22' d='M865.361 318.401c0 56.557-113.062 74.933-113.062 74.933s-113.062-18.376-113.062-74.933c0 0 0-4.555 2.301-7.145 0 0-1.246 9.407 5.981 16.522 0 0-5.669-10.037-.125-19.901 0 0-2.056 12.691 5.856 19.979 0 0-4.361-10.367.561-21.927 0 0-2.43 18.911 6.168 22.681 0 0 2.367-10.869-1.059-17.843 0 0 5.919 2.387 5.607 18.157 0 0 1.869-2.325 2.367-13.697 0 0 .249 13.005 4.735 16.021 0 0 1.371-1.319-.498-7.225s.81-7.979 1.246-7.854c0 0-.983 6.534 4.493 11.435 0 0-2.374-10.241.928-11.623 0 0-.685 8.67 6.168 10.618 0 0 .498-2.513-.997-5.34 0 0-1.308-3.353-.312-5.918 0 0 2.181 7.865 5.171 9.185 0 0-1.807-4.61-.125-9.185 0 0 .374 6.546 6.23 9.247 0 0-3.858-5.067-2.334-10.639l37.659 1.843 19.501.93 58.502-4.134 10.093-8.67s3.987 5.529-2.305 14.262c0 0 6.23-1.131 8.224-10.869 0 0 2.554 5.403-.935 11.372 0 0 6.916-6.911 7.912-14.765 0 0 2.679 7.602-3.863 15.77 0 0 5.856-1.948 8.349-10.618 0 0 1.994 5.222-3.676 12.601 0 0 10.591-5.627 10.28-17.25 0 0 4.423 6.408-.623 15.204 0 0 5.42-4.838 5.919-12.063 0 0 2.991 3.267-.249 12.251 0 0 6.604-6.22 7.601-12.943 0 0 1.433 6.22-4.237 14.073 0 0 3.863-.942 7.539-8.607 0 0 .997 3.016-2.367 8.545 0 0 3.614-.628 6.043-7.539 0 0 .436 4.147-.623 7.854 0 0 2.804-1.822 3.427-9.676 0 0 1.566 2.576 1.593 5.78.025 3.205-.002 1.101-.002 1.101z'/%3e%3cg stroke='%23000'%3e%3cpath fill='%23c8102e' stroke-linejoin='round' stroke-width='.831' d='M807.139 195.999s-3.929.668-8.975-.87c-5.046-1.537-7.086-.913-8.652 0 0 0 2.048-4.055-2.936-7.257 0 0 1.62 4.094-.623 6.006 0 0-.997.938-2.181-.475 0 0-1.744-1.791-3.582-3.173 0 0 4.237-1.476 3.458-5.78s-3.084-4.869-4.33-5.403c0 0 .436 1.948 0 3.267 0 0-4.61-2.576 1.651-6.22s5.109-5.78 3.987-7.634c-1.121-1.853-3.52-3.895-4.704-4.618 0 0 1.246 1.948 1.028 3.613s-3.053 2.733-2.492-.188c.561-2.922-.031-2.419-.094-5.529 0 0 5.576 1.885 7.757-3.55 0 0 2.149-5.623-4.891-8.419 0 0 1.713 2.293.872 4.021 0 0-1.495 2.827-3.271.534s-2.897-2.733-2.71-5.435c0 0 6.386.88 4.642-6.063 0 0-1.028 4.618-9.314-1.602 0 0 5.389-5.529 3.302-9.99 0 0-.654-2.042-6.511-.848 0 0 5.078-3.204 2.928-5.937 0 0-1.09-1.822-5.825.565 0 0 1.838-3.173-2.804-6.597 0 0-3.115 1.634-4.766 3.141 0 0-3.177-4.021-5.202-5.623 0 0-3.676 1.414-4.61 5.623 0 0-1.713-2.042-5.607-2.984 0 0-1.869 3.456.561 6.471 0 0-1.807-.063-5.109-1.508 0 0-3.769-1.791-3.209 1.445s.841 3.958 1.589 5.466c0 0-8.458-1.964-8.099 2.607.249 3.173 1.433 5.906 4.05 8.199 0 0-4.735 6.189-8.785 1.539 0 0-1.402 1.508 1.62 5.466 0 0 3.022 3.33.53 5.435 0 0-3.333 2.67-4.953-2.513 0 0-5.389 5.372.966 9.487 0 0 4.081 2.325 8.255-1.257 0 0-1.277 10.304-5.265 8.325 0 0-2.399-1.759 1.9-3.864 0 0-6.199-.785-7.196 5.215 0 0-.765 4.774 4.641 6.503 0 0 4.174 1.508-.156 4.744 0 0-3.053 2.325-1.059 5.78 0 0 2.399 3.801-3.676 4.178 0 0-3.302-.031-4.486-.471 0 0-1.332 2.477-.401 5.307 0 0-3.025-2.254-9.91.24-6.884 2.495-6.355.736-6.916 1.49s-1.9 3.298-1.9 3.298 3.614 4.398 3.676 4.304-.685 5.026-.685 5.026l1.776.848 14.174-6.314 14.392-7.5 11.571.709 7.338 1.747 9.639.702 6.903-3.682h9.999l10.998 5.48 12.552 7.489 6.542 1.147 5.04-.269v-10.166z'/%3e%3cpath fill='%23c8102e' stroke-linejoin='round' stroke-width='.831' d='M692.974 207.886s5.483 2.796 7.772-.597c0 0 2.991-5.702-3.575-7.681 0 0 3.575-4.288-.257-8.246 0 0-2.009-2.12-5.514-.565 0 0-1.449-3.016-4.86-2.922 0 0-2.99-.047-4.018 3.251 0 0-4.112-1.696-6.402.754 0 0-3.785 4.241 1.495 7.587l3.8.346 3.738-1.728 4.174 1.194c.003-.001-1.072 4.225 3.647 8.607z'/%3e%3cpath fill='%2364b4d1' stroke-width='.623' d='M815.359 197.859c6.605-.622 8.937 4.952 8.937 4.952 3.462 8.122-3.89 12.458-3.89 12.458.561 1.822.623 4.209.623 4.209 10.342 1.257 8.534 12.88 8.534 12.88l-3.425-2.827c-5.981-2.325-12.149 2.764-16.572 11.309s-2.305 12.566-1.558 22.681c.748 10.115 17.195 16.147 17.195 16.147s-7.788 20.042-12.834 32.922-15.576 7.539-18.628 4.826c-3.053-2.713-3.816-1.206-5.358 0s6.916 7.802-8.473 14.022-18.068 10.995-20.622 12.566-13.208.503-14.267-.817c-1.059-1.319-.436-1.319-4.423-3.77-3.987-2.45-10.716-4.586-18.068-8.168-7.352-3.581-7.165-8.168-7.102-9.11.062-.942 2.554-8.607-6.056-2.513s-15.937-2.902-15.937-2.902c-1.682-2.211-8.847-21.412-8.847-21.412-1.931-7.162-5.732-15.519-5.732-15.519.187-.063-.374.88 5.981-2.764s9.201-9.707 11.401-15.707.062-16.272-.748-18.346c-.81-2.073-5.545-11.579-11.408-13.571s-9.795 2.953-9.795 2.953-1.809-11.623 8.534-12.88c0 0 .062-2.387.623-4.209 0 0-7.352-4.335-3.89-12.458 0 0 2.332-5.574 8.937-4.952l-1.598 3.022s-1.663 16.587 22.616 5.466 23.55-13.194 37.381-6.22l10.093-.188s14.579-6.744 19.251-3.843c4.673 2.901 21.494 12.325 21.494 12.325s16.261 6.098 19.438-5.15z'/%3e%3c/g%3e%3cpath fill='%23fff' stroke='%23012169' stroke-miterlimit='10' stroke-width='.831' d='M742.31 269.772s-.844-5.091-1.731-8.388c0 0-1.802-5.174 1.272-8.806l3.812-4.387s2.369-3.187 5.302-3.62c0 0 2.933-.087 3.213-.684s3.489-5.877 11.121 0c0 0 2.43-3.895 6.168-4.555 0 0 4.038-1.225 5.991 1.791 0 0 4.538-3.441 8.432 2.097 0 0 5.389-3.031 9.314 2.996 0 0 5.327-2.598 8.598 2.94s2.617 7.8 2.617 7.8l2.428 8.796 8.6 10.618-19.999 7.539h-8.971l-17.943 4.806-31.867 2.45-8.878-10.461z'/%3e%3cg stroke='%23000' stroke-width='.831'%3e%3cpath fill='%23c8102e' stroke-linejoin='round' d='M715.374 322.736s-4.766.283-7.196 1.508-4.299 2.545-7.102 4.335c0 0-1.308 1.743-6.822.683 0 0-9.532-2.285-9.532 5.16 0 0-11.401.942-6.729 10.932 0 0 3.177 7.822 9.719 2.262 0 0-4.205 6.031 3.925 8.388 0 0 5.794 1.414 7.476-4.524 0 0 .935-2.356-1.308-5.278 0 0 2.804-.565 4.766-3.581 0 0-5.981 7.559.561 10.282 0 0 8.221 2.063 8.69-6.513 0 0-.671-3.958 2.515-5.372 0 0 6.551-1.508 9.541-8.812.001.001-9.419-5.016-8.504-9.47zm-19.247-75.168s-7.352-3.386-10.841 0c0 0-4.86-3.009-9.968 0 0 0-4.86 3.176-8.224 6.674 0 0-2.367 2.027-1.495 8.417 0 0 1.246 4.505.498 6.767 0 0-1.62-.321-4.86 3.518 0 0-4.112 4.762-7.725.559 0 0 1.121 5.85 7.912 4.907 0 0-3.302 2.576-.436 9.236 0 0 2.118 4.712-1.246 10.618 0 0 5.919-2.387 5.669-9.361 0 0-.498-4.712 1.246-8.042 0 0-1.744 3.028 2.305 9.487 0 0 3.115 4.649.561 9.487 0 0 5.856-2.136 5.296-9.236s-4.112-4.147-1.807-10.681c0 0 .561 3.347 2.305 5.035s3.987 4.515 3.053 9.227c0 0 3.489-4.335 2.679-8.796s-1.682-5.81-1.682-5.81l11.027-6.253 5.483-9.927z'/%3e%3cpath fill='none' stroke-miterlimit='10' d='M679.368 275.583s-4.548-.314-5.296-3.833m-7.975-2.324s1.585-.063 3.018 1.382c0 0 1.094 1.634 2.652 1.445'/%3e%3c/g%3e%3cpath d='M686.096 262.201s-2.367 0-3.676-1.131c0 0-1.371-.942-2.181.565 0 0-1.246 2.136 1.059 3.079 0 0 2.866 1.445-1.682 4.335 0 0 5.42-1.948 3.24-4.586 0 0-2.367-1.696-1.495-2.325 0 0 .249-.503 1.184.126.935.628 2.804.377 3.551-.063z'/%3e%3cpath fill='%23784421' stroke='%23000' stroke-width='.623' d='m760.408 274.204-18.218-62.913-.667.179 16.098 63.676z'/%3e%3cpath d='M696.964 344.785s-4.299-2.415-7.85.412c0 0 .363-1.571 3.079-2.262 0 0 1.47-4.147 5.581-3.77 0 0-1.682 2.01-3.925 3.707 0 0 2.368.245 3.115 1.913z'/%3e%3cpath fill='%2364b4d1' stroke='%23012169' stroke-miterlimit='2.613' stroke-width='.623' d='M681.825 354.778s-6.822-4.288-3.131-11.498c0 0 1.075-2.073 3.131-1.649 0 0 4.252 1.319.935 7.21-.001 0-1.683 3.817-.935 5.937zm13.831 6.786s-9.719-4.429-6.729-11.969c0 0 .924-2.545 3.079-2.356 0 0 3.748.188 2.998 5.183 0 0-1.124 4.901.652 9.142z'/%3e%3cpath d='M693.6 333.427s-2.92 2.157-4.108 3.602c0 0-1.188-1.476-2.745-2.372 0 0 1.793-.236 2.745.571 0 0 1.491-1.445 4.108-1.801z'/%3e%3cpath fill='%2364b4d1' stroke='%23012169' stroke-miterlimit='2.613' stroke-width='.623' d='M702.244 359.679s7.616-1.932 6.215-9.801c0 0-.748-3.44-3.972-2.969 0 0-3.885.992-1.355 5.994 0 0 1.495 3.572-.888 6.776z'/%3e%3cpath fill='%23f5ce00' stroke='%23000' stroke-miterlimit='2.613' stroke-width='.831' d='M736.656 193.201s4.906 1.504 7.57 2.59c0 0 7.102 3.204 16.121 0 0 0 6.099-2.415 6.912-2.59l-4.67 7.114-.234 3.675 2.922 4.288s-1.753.707-6.987-2.498c0 0-5.794-4.476-12.71 0 0 0-3.785 2.564-6.962 2.498l4.486-5.009-1.729-4.51z'/%3e%3cpath fill='%23fff' d='M705.188 350.278s.28-.377-.047-.542c0 0-.327-.141-.561.318 0 0-.794 1.26-.122 2.986 0 0 .636 1.196.327 2.445 0 0-.042.353.239.401 0 0 .269-.094.321-.353 0 0 .38-1.219-.274-2.412.001-.001-.794-1.853.117-2.843z'/%3e%3cg stroke='%23000'%3e%3cpath fill='%23c8102e' stroke-linejoin='round' stroke-width='.831' d='M810.687 207.886s-5.483 2.796-7.772-.597c0 0-2.99-5.702 3.575-7.681 0 0-3.575-4.288.257-8.246 0 0 2.009-2.12 5.514-.565 0 0 1.449-3.016 4.86-2.922 0 0 2.99-.047 4.018 3.251 0 0 4.112-1.696 6.401.754 0 0 3.785 4.241-1.495 7.587l-3.8.346-3.738-1.728-4.174 1.194c-.002-.001 1.073 4.225-3.646 8.607z'/%3e%3cpath fill='%23f5ce00' stroke-miterlimit='2.613' stroke-width='.831' d='M767.262 203.457s-.138 1.131-1.26 1.257c0 0-1.17.377-1.852-1.08 0 0-.079-.33-.097-.491-.078-.681-.311-2.639 1.807-4.241 0 0 3.458-2.827 10.062.597 0 0 5.233 2.513 8.847 4.649 0 0 9.345 5.026 10.467 5.403 0 0 4.112 2.073 10.404 2.325 0 0 8.598.628 12.242-5.403 0 0 2.772-4.586 0-7.508 0 0-1.121-1.319-2.965-1.076-.774.102-1.629.458-2.455 1.422 0 0-1.339 1.948.218 3.393 0 0 2.025 1.241 2.741-1.382 0 0 .031-.188.093.047.04.152.498 2.152-.576 3.848 0 0-5.187 7.849-19.454-.285l-18.815-10.553s-9.439-4.838-15.077 2.733c0 0-4.548 6.283 1.308 10.398 0 0 4.361 2.607 7.102-1.539 0 0 2.274-4.084-1.308-5.874 0 0-3.146-1.476-4.392 1.665s2.43 3.958 2.772 1.728c.001-.002.095-.536.188-.033z'/%3e%3cg stroke-width='.623'%3e%3cpath fill='%23e4cb5e' stroke-miterlimit='2.613' d='M692.68 235.844v-11.78c0-.925.007-1.696 1.408-2.827s2.897-2.922 5.046 2.168c0 0 4.205-4.429 5.607-5.089 0 0 2.43-2.073 4.112.942 0 0 2.243-3.393 4.018-4.241 0 0 4.205-2.733 4.392 5.466l3.271-3.016s2.523-2.073 5.327.754c0 0 4.766 4.618 5.42 5.937 0 0 1.052 1.429 1.133 3.683 0 0-.012 2.537 1.296 3.95 0 0 1.494 1.319 2.943 1.602 0 0 3.411.094 4.626 3.298 0 0 .561-.555 2.243 14.801v27.985l-18.878 22.524-30.279-8.67-12.055-4.995-2.71-8.859 11.682-7.539 6.355-17.152-2.056-12.063z'/%3e%3cpath fill='%23784421' d='m776.109 250.703 1.433-2.136 3.427-2.639s5.233 13.734 5.483 16.731v4.262s7.85 2.003 9.221 14.066l-6.479 11.937-10.155-5.655-2.928-2.136v-34.43z'/%3e%3c/g%3e%3c/g%3e%3cpath fill='%23fff' d='M679.932 345.001s.374-.495.117-.707c0 0-.164-.236-.607.33 0 0-2.064 2.307-.421 5.855 0 0 .187.506.514.341 0 0 .28-.141.023-.565.001 0-1.471-2.922.374-5.254z'/%3e%3cg stroke='%23000'%3e%3cpath fill='none' stroke-miterlimit='10' stroke-width='.831' d='M710.546 342.684s.311-1.068-.436-2.199c0 0-.498-.817-.312-1.885'/%3e%3cpath fill='none' stroke-miterlimit='10' stroke-width='.623' d='M717.265 220.483s.028 2.946.869 5.114 3.681 5.917 3.868 7.943'/%3e%3cpath fill='%23c8102e' stroke-linejoin='round' stroke-width='.831' d='M788.476 322.736s4.766.283 7.196 1.508 4.299 2.545 7.102 4.335c0 0 1.308 1.743 6.822.683 0 0 9.532-2.285 9.532 5.16 0 0 11.401.942 6.729 10.932 0 0-3.177 7.822-9.719 2.262 0 0 4.205 6.031-3.925 8.388 0 0-5.794 1.414-7.476-4.524 0 0-.935-2.356 1.308-5.278 0 0-2.804-.565-4.766-3.581 0 0 5.981 7.559-.561 10.282 0 0-8.221 2.063-8.69-6.513 0 0 .671-3.958-2.515-5.372 0 0-6.551-1.508-9.541-8.812 0 .001 9.419-5.016 8.504-9.47z'/%3e%3cg stroke-width='.623'%3e%3cpath fill='none' stroke-miterlimit='10' d='m713.505 233.536 7.778 62.78m-5.981-62.916 8.723 58.519m-7.088-58.791 10.047 58.037'/%3e%3cpath fill='%23784421' d='m735.613 285.227-18.219-62.913-.667.179 16.099 63.677z'/%3e%3cpath fill='none' stroke-miterlimit='10' d='m722.511 230.823 18.398 46.488m-19.626-45.736 17.756 48.563'/%3e%3c/g%3e%3c/g%3e%3cpath fill='%23fff' d='M692.136 357.103s-2.135-2.047-1.838-5.717c0 0 .125-.785-.267-.894 0 0-.418-.174-.48.737 0 0-.592 3.833 1.994 6.031 0 0 .176.22.462.157-.001 0 .305-.068.129-.314z'/%3e%3cg stroke='%23000'%3e%3cpath fill='none' stroke-miterlimit='10' stroke-width='.623' d='m723.341 230.192 18.969 42.407m-24.157-39.772 11.635 57.112'/%3e%3cpath fill='%23f5ce00' stroke-miterlimit='2.613' stroke-width='.831' d='M813.327 275.146c-8.31-4.715-10.132-15.176-10.132-15.176-2.009-10.414 2.056-18.66 2.056-18.66 5.374-11.356 14.582-13.469 14.582-13.469s-9.021 6.259-11.544 14.694c0 0-1.963 7.115-.841 14.136 1.121 7.021.701 5.23 2.43 10.649z'/%3e%3cpath fill='%23784421' stroke-width='.38' d='m777.542 248.567-34.917 11.025-1.904 15.554c-8.286 12.003-25.124 14.133-25.124 14.133l13.1 13.948 25.17 5.278 13.208-10.178 11.962-11.058c-1.246-5.906-.561-14.67-.561-14.67 0-1.476.561-4.932.561-4.932s-2.056-14.199-1.495-19.1z'/%3e%3cg fill='none' stroke-miterlimit='10' stroke-width='.623'%3e%3cpath d='M741.2 271.238s22.997-7.181 36.71-12.947m-47.749 26.056s28.69-5.183 48.876-16.68l7.414-5.008'/%3e%3cpath d='m786.451 266.921-7.975 5.678s-32.086 14.796-56.516 15.191m56.51-4.677s-24.665 12.701-38.808 12.89'/%3e%3c/g%3e%3cpath fill='%23c8102e' stroke-linejoin='round' stroke-width='.831' d='M807.883 247.568s7.352-3.386 10.841 0c0 0 4.86-3.009 9.968 0 0 0 4.86 3.176 8.224 6.674 0 0 2.367 2.027 1.495 8.417 0 0-1.246 4.505-.498 6.767 0 0 1.62-.321 4.86 3.518 0 0 4.112 4.762 7.725.559 0 0-1.121 5.85-7.912 4.907 0 0 3.302 2.576.436 9.236 0 0-2.118 4.712 1.246 10.618 0 0-5.919-2.387-5.669-9.361 0 0 .498-4.712-1.246-8.042 0 0 1.744 3.028-2.305 9.487 0 0-3.115 4.649-.561 9.487 0 0-5.856-2.136-5.296-9.236.561-7.1 4.112-4.147 1.807-10.681 0 0-.561 3.346-2.305 5.035-1.744 1.688-3.987 4.515-3.053 9.227 0 0-3.489-4.335-2.679-8.796s1.682-5.81 1.682-5.81l-11.027-6.253-5.483-9.927z'/%3e%3c/g%3e%3cpath fill='%23fff' stroke='%23012169' stroke-miterlimit='10' stroke-width='.831' d='M682.968 287.301s1.028-4.87 5.701-2.954c0 0 1.589-7.979 10.093-8.261 8.504-.283 8.971 8.293 8.971 8.859 0 0 2.498-3.682 6.669-3.255 0 0 7.191-.424 4.513 11.122l1.36 1.448s5.494-12.897 16.802-9.504c0 0 11.027 3.361 3.832 14.042 0 0 5.442 7.068 10.057 6.408s8.727-2.073 13.306-10.178 15.233-9.33 17.943-8.859 4.851 2.231 5.293 4.147c0 0 5.641-18.827 25.92-15.869l8.13 4.089 3.084 1.414-4.597 12.974-11.199 25.314-8.502 2.614-8.878-5.089-3.084 1.653-.252 7.582-11.71 8.429-8.13 3.351-8.971 6.126-2.087 5.476s-4.955-2.087-10.547 0l-1.851-4.533-5.233-4.995-20.33-9.59-3.673-11.846-3.711-1.653-4.154 4.758-6.074.708-9.065-6.126z'/%3e%3cg stroke='%23000'%3e%3cg stroke-miterlimit='2.613'%3e%3cg stroke-width='.831'%3e%3cpath fill='none' d='M771.499 195.132s-7.759-.345-7.478 7.697'/%3e%3cpath fill='%23f5ce00' d='M822.54 280.562c-13.504-4.147-17.195-18.66-17.195-18.66-2.757-10.885 1.682-20.403 1.682-20.403 6.168-14.485 16.604-14.482 16.604-14.482 5.233-.141 5.861 4.335 5.861 4.335.494 3.173-1.733 4.319-1.733 4.319-3.582 1.948-5.841-.691-5.841-.691-1.495-1.948-.343-3.675-.343-3.675.919-1.288 2.679-.723 2.679-.723 1.394.432 1.246 2.175 1.246 2.175.008.047.039.047.039.047.062-.016.039-.039.039-.039s.311-2.136-1.776-2.356c0 0-4.065-.88-8.831 5.058 0 0-6.276 8.011-6.261 18.377 0 0-.794 19.461 19.485 24.503 0 0-2.196 3.157-6.074 14.56 0 0-4.392 14.655-8.585 22.578 0 0-5.574 11.302-18.003 6.684 0 0-7.401-3.251-7.383-8.623 0 0-.514-4.901 3.925-5.278 0 0 4.346-.33 4.299 3.393 0 0 .117 4.029-4.626 3.11 0 0-1.659-.353-1.355-1.979 0 0 .265-1.461 2.266-.825 0 0 .062.008.07-.024 0 0 .023-.035-.047-.055 0 0-.774-.346-1.592-.06 0 0-.733.244-.791 1.387 0 0-.047.919.935 1.437 0 0 1.192.424 2.126.33 0 0 1.257 2.537 4.101 3.397 3.959 1.197 7.22.044 9.216-1.548 2.171-1.732 3.575-4.759 3.995-5.501s4.065-8.906 6.806-17.686c0 0 2.399-7.571 4.314-11.529z'/%3e%3cpath fill='%23f5ce00' d='M784.434 317.458s2.523-.342 2.523 1.908c0 0-.154 3.287-4.159 2.568 0 0-3.948-.864-2.547-5.278 0 0 .935-3.11 4.673-2.662 0 0 3.621.165 5.21 5.113 0 0 1.215 4.171-.864 7.751-2.321 3.996-8.193 6.621-11.027 7.783 0 0-11.355 4.461-14.742 7.013 0 0-5.194 3.856-2.897 7.445 0 0 .888 1.367 2.22 1.367 0 0 1.519.071 1.776-1.484 0 0 .008-.031-.016-.071 0 0-.023 0-.031.039 0 0-.109.95-.935 1.304 0 0-1.106.558-2.266-.424 0 0-1.23-1.178-.202-3.008 0 0 1.347-2.254 4.486-.919 0 0 2.765 1.367 1.628 4.304 0 0-1.012 2.703-4.346 2.696 0 0-2.51-.083-4.115-1.766-2.505-2.626-2.641-7.741-.433-10.386 0 0 2.087-2.812 6.277-4.524 2.427-.992 7.009-2.984 11.775-4.853 3.35-1.314 6.418-2.887 8.411-5.246 0 0 1.776-1.979 2.29-5.372 0 0 .491-2.545-1.059-3.102 0 0-.787-.353-1.651-.236 0 0-.023.001-.029.016-.002.001-.037.039.05.024z'/%3e%3cpath fill='none' d='M784.645 317.442s2.788-.503 4.532 2.812c0 0 1.028 2.136 1.194 3.372m.908-11.85s-2.792.484-1.354 4.434c1.355 3.723 3.872 4.944 4.619 5.462'/%3e%3cpath fill='%23f5ce00' d='M736.653 203.456s.138 1.131 1.26 1.257c0 0 1.17.377 1.852-1.08 0 0 .079-.33.097-.491.078-.681.311-2.639-1.807-4.241 0 0-3.458-2.827-10.062.597 0 0-5.233 2.513-8.847 4.649 0 0-9.345 5.026-10.467 5.403 0 0-4.112 2.073-10.404 2.325 0 0-8.598.628-12.242-5.403 0 0-2.772-4.586 0-7.508 0 0 1.121-1.319 2.965-1.076.774.102 1.629.458 2.455 1.422 0 0 1.339 1.948-.218 3.393 0 0-2.025 1.241-2.741-1.382 0 0-.031-.188-.094.047-.04.152-.498 2.152.576 3.848 0 0 5.187 7.849 19.454-.285l18.815-10.553s9.439-4.838 15.077 2.733c0 0 4.548 6.283-1.308 10.398 0 0-4.361 2.607-7.102-1.539 0 0-2.274-4.084 1.308-5.874 0 0 3.146-1.476 4.392 1.665s-2.43 3.958-2.772 1.728c0-.001-.094-.535-.187-.033zm-46.065 71.69c8.31-4.715 10.132-15.176 10.132-15.176 2.009-10.414-2.056-18.66-2.056-18.66-5.374-11.356-14.582-13.469-14.582-13.469s9.021 6.259 11.544 14.694c0 0 1.963 7.115.841 14.136-1.121 7.021-.701 5.23-2.43 10.649z'/%3e%3cpath fill='none' d='M732.416 195.132s7.759-.345 7.478 7.697'/%3e%3cpath fill='%23f5ce00' d='M681.375 280.562c13.504-4.147 17.195-18.66 17.195-18.66 2.757-10.885-1.682-20.403-1.682-20.403-6.168-14.485-16.604-14.482-16.604-14.482-5.233-.141-5.861 4.335-5.861 4.335-.494 3.173 1.733 4.319 1.733 4.319 3.582 1.948 5.841-.691 5.841-.691 1.495-1.948.343-3.675.343-3.675-.919-1.288-2.679-.723-2.679-.723-1.394.432-1.246 2.175-1.246 2.175-.008.047-.039.047-.039.047-.062-.016-.039-.039-.039-.039s-.312-2.136 1.776-2.356c0 0 4.065-.88 8.831 5.058 0 0 6.276 8.011 6.261 18.377 0 0 .794 19.461-19.485 24.503 0 0 2.196 3.157 6.074 14.56 0 0 4.392 14.655 8.585 22.578 0 0 5.574 11.302 18.003 6.684 0 0 7.401-3.251 7.383-8.623 0 0 .514-4.901-3.925-5.278 0 0-4.346-.33-4.299 3.393 0 0-.117 4.029 4.626 3.11 0 0 1.659-.353 1.355-1.979 0 0-.265-1.461-2.266-.825 0 0-.062.008-.07-.024 0 0-.023-.035.047-.055 0 0 .774-.346 1.592-.06 0 0 .733.244.791 1.387 0 0 .047.919-.935 1.437 0 0-1.192.424-2.126.33 0 0-1.257 2.537-4.101 3.397-3.959 1.197-7.22.044-9.216-1.548-2.171-1.732-3.575-4.759-3.995-5.501s-4.065-8.906-6.806-17.686c0 0-2.399-7.571-4.314-11.529z'/%3e%3cpath fill='%23f5ce00' d='M719.481 317.458s-2.523-.342-2.523 1.908c0 0 .154 3.287 4.159 2.568 0 0 3.948-.864 2.547-5.278 0 0-.935-3.11-4.673-2.662 0 0-3.621.165-5.21 5.113 0 0-1.215 4.172.864 7.751 2.321 3.996 8.193 6.621 11.027 7.783 0 0 11.355 4.461 14.742 7.013 0 0 5.194 3.856 2.897 7.445 0 0-.888 1.367-2.22 1.367 0 0-1.519.071-1.776-1.484 0 0-.008-.031.016-.071 0 0 .023 0 .031.039 0 0 .109.95.935 1.304 0 0 1.106.558 2.266-.424 0 0 1.23-1.178.202-3.008 0 0-1.347-2.254-4.486-.919 0 0-2.765 1.367-1.628 4.304 0 0 1.012 2.703 4.346 2.696 0 0 2.51-.083 4.115-1.766 2.505-2.626 2.641-7.741.433-10.386 0 0-2.087-2.812-6.277-4.524-2.427-.992-7.009-2.984-11.775-4.853-3.35-1.314-6.418-2.887-8.411-5.246 0 0-1.776-1.979-2.29-5.372 0 0-.491-2.545 1.059-3.102 0 0 .787-.353 1.651-.236 0 0 .023.001.029.016.002 0 .037.039-.05.024z'/%3e%3cpath fill='none' d='M719.27 317.442s-2.788-.503-4.532 2.812c0 0-1.028 2.136-1.194 3.372m-.908-11.851s2.792.484 1.354 4.434c-1.355 3.723-3.872 4.944-4.619 5.462m35.836-119.296s6.75-4.227 13.644.454'/%3e%3c/g%3e%3cpath fill='none' stroke-width='.623' d='M706.798 243.667s.935-3.77-3.364-10.367c0 0-2.804-6.031-4.299-9.895m9.719-4.147s2.434 5.929 3.271 8.584c0 0 3.019 7.437 3.659 8.945'/%3e%3c/g%3e%3cg stroke-width='.623'%3e%3cpath fill='none' stroke-miterlimit='10' d='M710.069 247.813s2.538 2.733 2.25 7.351m-10.661-10.272s2.804 1.351 2.619 8.796c0 0-.282 5.435 3.923 8.168m-6.922 1.916s8.775-.958 9.258 4.445c0 0 .187 5.183 3.177 5.749 0 0 4.479.424 5.367 4.571m-15.039-8.765s1.542 2.309 3.037 3.298m8.224-9s2.229 3.377 2.649 5.356m7.008-46.022s2.056 2.796 4.05 4.115m4.174 12.441s4.361 2.136 3.614 13.131c0 0-.561 6.448 1.246 9.967'/%3e%3cpath fill='%23784421' d='m712.639 232.499.28 1.037s7.819.33 12.04-4.995l-.452-1.021s-6.822-.346-11.868 4.979z'/%3e%3cpath fill='none' stroke-miterlimit='10' d='M740.807 274.447s27.042-8.062 37.464-12.762'/%3e%3c/g%3e%3cpath fill='%23784421' stroke-width='.38' d='m737.591 223.687 13.375-5.089.316.895-13.378 5.081z'/%3e%3c/g%3e%3cg fill='none' stroke-miterlimit='10'%3e%3cpath stroke='%23000' stroke-width='.623' d='m739.039 224.143 8.878 43.524m-7.337-44.109 10.168 43.324m-8.438-43.981 11.121 43.007m-6.761-44.663 15.161 32.283m-13.155-33.045 16.167 32.094m-14.682-32.658 17.488 31.772m-20.332 16.321 6.862-2.261m-12.057-2.045s20.114-5.875 35.337-12.015m-35.607 14.217s25.492-6.745 35.606-11.666m-27.827 32.399 1.335 4.084 3.649-1.168-1.246-4.047m6.558-1.803 1.335 4.083 3.65-1.167-1.247-4.047m-21.04-22.984-.315-5.525 33.425-10.149 1.807 4.649m-21.057 1.196 1.821 4.878m9.864-8.426 2.129 4.639m.642-5.48 1.991 4.389m.655-5.193 2.093 4.585m.055-5.237 3.676-2.073 1.558 4.083m-3.427-3.029 1.872 4.227'/%3e%3cg stroke='%23012169' stroke-width='.831'%3e%3cpath d='M694.649 306.526s-6.542-6.625 0-13.114c0 0-7.102-3.473-5.981-9.065m17.663 27.428s-6.775.923-4.766-12.27c0 0-2.804 5.23-3.77 7.918-.723 2.012-.245 5.26 2.623 7.016 1.146.702 7.221 2.284 9.183-1.74m-10.84-21.11s-2.757 2.545-.794 7.21m3.644-6.598s.327 4.524 2.57 7.068m-.632-8.858s-.021 5.325 3.81 8.623m-1.905-10.461s.036 5.984 4.475 9.66m17.569-.896s2.243-4.901 6.962-4.665c0 0-2.29 1.037-2.243 3.33 0 0-.28 3.785 3.785 4.162 0 0 3.271.424 4.906-1.367'/%3e%3cpath d='M738.666 319.72s-11.635-5.466-10.42-13.335c0 0 .467-4.806 5.166-7.068m-2.456 4.994s-1.028 3.393 1.262 5.749m1.354-8.058s-1.402 3.723.935 6.503m1.867-8.31s-1.68 3.079.329 5.859m-10.934 14.466s6.355 5.514 11.308 5.561m-13.317-3.817s5.939 4.806 9.651 5.513m-11.894-4.152s7.341 6.461 11.894 6.932m17.964 5.938s-7.216 3.888-1.622 7.999m-2.957-12.287s8.177-4.288 11.728-5.89m-8.784 8.105s11.822-7.21 15.326-8.764m-9.252 9.235s10.093-6.738 15.513-9.66m-8.831 9.424s6.962-5.466 13.691-9.424m2.383-6.832s-3.411-4.995-14.625 0c0 0 4.112-3.732 12.242-6.625m11.321-21.46s.919 4.052-.062 6.503'/%3e%3cpath d='M769.318 309.966s2.336-3.44 8.271-5.136c0 0 1.6 4.005 6.215 3.11 0 0 6.962-1.367 4.86-9 0 0-1.448-5.702-9.4-6.267m23.651-9.56s8.084 1.455 7.944 8.052c0 0 .654 9.895-9.766 11.827m8.618-15.816s2.221-4.823 7.174-6.803m-6.019-2.826s2.208 3.54 3.717 4.055m-4.872-1.228s2.081 2.543 2.782 2.968m-3.457-.518s1.096 1.619 2.067 2.129m-43.654-40.383s1.573-2.553 5.483-1.469m15.965 20.605s2.477-10.332 11.121-6.516m-3.505-.846s.888-4.763-1.262-7.189m-4.626 6.857s1.101 1.97.159 3.58'/%3e%3c/g%3e%3c/g%3e%3cpath fill='%2364b4d1' stroke='%23012169' stroke-miterlimit='2.613' stroke-width='.623' d='M808.195 361.563s9.719-4.429 6.729-11.969c0 0-.924-2.545-3.079-2.356 0 0-3.748.188-2.998 5.183 0 .001 1.123 4.902-.652 9.142z'/%3e%3cpath fill='%23fff' d='M811.715 357.103s2.136-2.047 1.838-5.717c0 0-.125-.785.267-.894 0 0 .418-.175.48.736 0 0 .592 3.833-1.994 6.031 0 0-.176.22-.462.157.001.001-.306-.067-.129-.313z'/%3e%3cpath fill='%2364b4d1' stroke='%23012169' stroke-miterlimit='2.613' stroke-width='.623' d='M822.026 354.778s6.822-4.288 3.131-11.498c0 0-1.075-2.073-3.131-1.649 0 0-4.252 1.319-.935 7.21 0 0 1.682 3.817.935 5.937z'/%3e%3cpath fill='%23fff' d='M823.731 345s-.374-.495-.117-.707c0 0 .164-.236.607.33 0 0 2.064 2.307.421 5.855 0 0-.187.506-.514.341 0 0-.28-.141-.023-.565 0 0 1.472-2.921-.374-5.254z'/%3e%3cpath fill='%2364b4d1' stroke='%23012169' stroke-miterlimit='2.613' stroke-width='.623' d='M801.606 359.679s-7.616-1.932-6.215-9.801c0 0 .748-3.44 3.972-2.969 0 0 3.885.992 1.355 5.994 0 0-1.495 3.571.888 6.776z'/%3e%3cpath fill='%23fff' d='M798.662 350.278s-.28-.377.047-.542c0 0 .327-.141.561.318 0 0 .794 1.26.122 2.986 0 0-.636 1.196-.327 2.445 0 0 .042.353-.239.401 0 0-.269-.094-.321-.353 0 0-.38-1.219.274-2.412 0-.001.795-1.853-.117-2.843z'/%3e%3cpath d='M807.073 344.785s4.299-2.415 7.85.412c0 0-.363-1.571-3.079-2.262 0 0-1.469-4.147-5.581-3.77 0 0 1.682 2.01 3.925 3.707 0 0-2.367.245-3.115 1.913zm3.178-11.358s2.92 2.157 4.108 3.602c0 0 1.188-1.476 2.745-2.372 0 0-1.793-.236-2.745.571 0 0-1.492-1.445-4.108-1.801z'/%3e%3cpath fill='none' stroke='%23000' stroke-miterlimit='10' stroke-width='.831' d='M793.305 342.684s-.312-1.068.436-2.199c0 0 .498-.817.312-1.885m30.589-63.017s4.548-.314 5.296-3.833m7.975-2.324s-1.585-.063-3.018 1.382c0 0-1.094 1.634-2.652 1.445'/%3e%3cpath d='M817.914 262.201s2.367 0 3.676-1.131c0 0 1.371-.942 2.181.565 0 0 1.246 2.136-1.059 3.079 0 0-2.866 1.445 1.682 4.335 0 0-5.42-1.948-3.24-4.586 0 0 2.367-1.696 1.495-2.325 0 0-.249-.503-1.184.126-.935.628-2.804.377-3.551-.063z'/%3e%3cpath fill='%2364b4d1' stroke='%23012169' stroke-miterlimit='2.613' stroke-width='.623' d='M821.134 204.987s1.069-1.455.632-5.821 3.354-4.868 4.812-3.613c0 0 1.507 1.305.121 4.074-.8 1.598-2.077 3.667-5.565 5.36z'/%3e%3cpath fill='%23fff' d='M822.559 201.727s1.421-1.528.743-4.845c0 0-.005-.327.183-.349 0 0 .345-.087.403.24 0 0 .763 3.536-.841 5.457 0 0-.293.284-.489 0 .001-.001-.215-.204.001-.503z'/%3e%3cpath fill='%2364b4d1' stroke='%23012169' stroke-miterlimit='2.613' stroke-width='.623' d='M819.923 203.399s-.112-1.76-3.154-4.751-.541-5.747 1.322-5.724c0 0 1.93.03 2.625 2.971.401 1.699.741 4.048-.793 7.504z'/%3e%3cpath fill='%23fff' d='M819.45 199.572s.054-2.156-2.7-4.406c0 0-.224-.262-.096-.401 0 0 .204-.293.47-.066 0 0 2.966 2.373 3.038 4.965 0 0-.033.419-.373.316-.001-.002-.303-.026-.339-.408z'/%3e%3cpath fill='%2364b4d1' stroke='%23012169' stroke-miterlimit='2.613' stroke-width='.623' d='M815.792 202.076s-.795-1.434-4.552-2.767-2.742-4.615-1.161-5.317c0 0 1.641-.722 3.397 1.477 1.015 1.272 2.236 3.112 2.316 6.607z'/%3e%3cpath fill='%23fff' d='M814.146 199.44s-.854-1.977-4.294-2.843c0 0-.313-.142-.255-.323 0 0 .062-.353.398-.26 0 0 3.683.886 4.834 3.205 0 0 .146.394-.206.445 0 .001-.284.108-.477-.224z'/%3e%3cpath fill='%2364b4d1' stroke='%23012169' stroke-miterlimit='2.613' stroke-width='.623' d='M818.146 203.512s-1.752.492-5.775-1.449-5.785 1.437-5.08 3.244c0 0 .737 1.87 3.851 1.542 1.798-.19 4.206-.661 7.004-3.337z'/%3e%3cpath fill='%23fff' d='M808.791 204.794s1.824 1.125 5.134-.155c0 0 .337-.065.392.117 0 0 .15.325-.178.443 0 0-3.521 1.404-5.783.171 0 0-.344-.238-.085-.484.001 0 .174-.252.52-.092z'/%3e%3cpath fill='none' stroke='%23000' stroke-miterlimit='2.613' stroke-width='.831' d='M812.26 190.797s2.009.974 1.542 3.33'/%3e%3cpath fill='none' stroke='%23000' stroke-miterlimit='10' stroke-width='.831' d='M821.138 191.127s.786 2.488-.082 3.828'/%3e%3cpath fill='%2364b4d1' stroke='%23012169' stroke-miterlimit='2.613' stroke-width='.623' d='M682.528 204.987s-1.069-1.455-.632-5.821-3.354-4.868-4.812-3.613c0 0-1.507 1.305-.121 4.074.8 1.598 2.076 3.667 5.565 5.36z'/%3e%3cpath fill='%23fff' d='M681.102 201.727s-1.421-1.528-.743-4.845c0 0 .005-.327-.183-.349 0 0-.345-.087-.403.24 0 0-.763 3.536.841 5.457 0 0 .293.284.489 0-.001-.001.216-.204-.001-.503z'/%3e%3cpath fill='%2364b4d1' stroke='%23012169' stroke-miterlimit='2.613' stroke-width='.623' d='M683.738 203.399s.112-1.76 3.154-4.751.541-5.747-1.322-5.724c0 0-1.93.03-2.625 2.971-.401 1.699-.741 4.048.793 7.504z'/%3e%3cpath fill='%23fff' d='M684.212 199.572s-.054-2.156 2.7-4.406c0 0 .224-.262.096-.401 0 0-.204-.293-.47-.066 0 0-2.966 2.373-3.038 4.965 0 0 .033.419.373.316 0-.002.302-.026.339-.408z'/%3e%3cpath fill='%2364b4d1' stroke='%23012169' stroke-miterlimit='2.613' stroke-width='.623' d='M687.869 202.076s.795-1.434 4.552-2.767 2.742-4.615 1.161-5.317c0 0-1.641-.722-3.397 1.477-1.015 1.272-2.236 3.112-2.316 6.607z'/%3e%3cpath fill='%23fff' d='M689.515 199.44s.854-1.977 4.294-2.843c0 0 .313-.142.255-.323 0 0-.062-.353-.398-.26 0 0-3.683.886-4.834 3.205 0 0-.146.394.206.445 0 .001.284.108.477-.224z'/%3e%3cpath fill='%2364b4d1' stroke='%23012169' stroke-miterlimit='2.613' stroke-width='.623' d='M685.515 203.512s1.752.492 5.775-1.449 5.785 1.437 5.08 3.244c0 0-.737 1.87-3.851 1.542-1.798-.19-4.206-.661-7.004-3.337z'/%3e%3cpath fill='%23fff' d='M694.87 204.794s-1.824 1.125-5.134-.155c0 0-.337-.065-.392.117 0 0-.15.325.178.443 0 0 3.521 1.404 5.783.171 0 0 .344-.238.085-.484-.001 0-.173-.252-.52-.092z'/%3e%3cpath fill='none' stroke='%23000' stroke-miterlimit='2.613' stroke-width='.831' d='M691.401 190.797s-2.009.974-1.542 3.33'/%3e%3cpath fill='none' stroke='%23000' stroke-miterlimit='10' stroke-width='.831' d='M682.523 191.127s-.786 2.488.082 3.828'/%3e%3cpath d='M769.739 168.273s1.273 3.634.724 6.927c-.491 2.945.179 3.706 1.243 4.289.921.504 3.055-.378 3.312-2.687 0 0 2.523 4.924-2.383 8.246 0 0-3.528 2.168-6.518-.73-1.054-1.021-1.519-3.84-1.005-6.456 0 0 .772-3.546-.514-7.186 0 0 2.009 2.144 1.495 6.419 0 0-1.028 7.67 4.649 7.293 0 0 3.925-.047 4.042-4.806 0 0-1.472 1.696-3.294 1.131-1.291-.4-2.477-1.649-2.266-3.618.221-2.065.795-5.665.515-8.822zm-6.433 12.597s-.312 6.063-5.856 7.539c0 0 .779-1.099-.467-4.115 0 0-1.215-1.759-1.121-4.492 0 0-1.765 1.381.249 5.026 1.215 2.199.156 4.838-.218 4.932-.375.094 9.158-1.257 7.413-8.89zm-7.196-6.032s-1.339-1.508-1.433-4.995c-.093-3.487-.748-4.335-1.215-4.744 0 0 .685 3.016.498 4.869s.125 2.922.374 3.801c0 0-3.022.471-4.922-3.927-1.816-4.204-3.645-3.864-4.548-3.833 0 0 1.053.117 3.177 3.958 2.122 3.838 2.711 4.62 8.069 4.871zm-14.142-9.11s1.745 4.178 1.807 6.377c0 0-4.05-1.351-5.14-4.869 0 0-4.33 1.476-2.741 6.471 0 0-3.738-1.319-5.42-4.367 0 0 2.087 1.571 4.018 2.262 0 0-.218-4.021 4.828-5.529 0 0 .751 3.602 3.271 4.461 0 .001-.187-2.261-.623-4.806zm6.666-7.162s1.402 2.042 4.268 2.136c1.37.045 2.844-.264 4.268-2.136 0 0-.187 3.55-4.268 3.581 0 0-4.268.157-4.268-3.581zm-17.655 24.267s2.126 1.932 2.57 2.568c0 0 1.495 1.461 2.779-.428 0 0 1.637-3.021 3.646-2.941 0 0-1.425.99-3.027 3.846 0 0-.431 1.054-1.623 1.172-.558.055-1.262.236-2.327-.877 0 0-.92-1.125-2.018-3.34zm21.923-38.498c-4.268-.002-.67 3.298-.67 3.298.093 5.23-4.104 6.84-6.962 5.325-2.858-1.516-.623-5.325-.623-5.325s-3.224 2.12-1.168 5.183 7.445 1.696 9.423-1.131c1.978 2.827 7.367 4.194 9.423 1.131s-1.168-5.183-1.168-5.183 2.235 3.809-.623 5.325c-2.858 1.515-7.056-.094-6.962-5.325-.001.001 3.597-3.3-.67-3.298zm2.585-5.654s1.495 2.545 1.168 6.408c0 0 1.355-3.864-1.168-6.408zm-13.083 5.984s-.327-2.78-3.037-3.016c0 0 2.289 1.65 3.037 3.016zm21.027 0s.327-2.78 3.037-3.016c0 0-2.29 1.65-3.037 3.016zm-25.326 4.241s2.149.66 3.458-.942c0 0-2.477.659-3.458.942zm-6.962-17.058s2.5-.283 5 3.44c0 0-2.477 1.319-3.084 2.12 0 0 0-1.225 1.215-2.309-.001.001-.468-1.884-3.131-3.251zm41.867 0s-2.5-.283-5 3.44c0 0 2.477 1.319 3.084 2.12 0 0 0-1.225-1.215-2.309 0 .001.467-1.884 3.131-3.251zm-19.298 2.778s2.243.615 5.046-.94c0 0 3.458-1.838 5.654 0 0 0-1.916-.853-5.607.94 0 0-3.692 2.024-5.093 0z'/%3e%3cpath fill='%23fff' d='M756.048 136.89s1.916-3.36 7.757-2.693c0 0-1.589 4.672-7.757 2.693z'/%3e%3cellipse cx='760.077' cy='135.848' fill='%23784421' rx='1.155' ry='1.464'/%3e%3cellipse cx='760.077' cy='135.848' rx='.686' ry='.898'/%3e%3cpath d='M743.525 129.728s3.691.236 5.934 1.649c0 0 2.383 1.414 5.093-.613 0 0 2.947-1.696 4.838-4.052 0 0-4.511 3.11-6.193 3.581 0 0-1.542-1.178-2.149-2.874 0 0 .234-1.272 2.663-3.628 0 0-3.271.99-3.925 3.77 0 0 .607 1.696 1.869 3.016 0 0-.607.283-2.196-.707 0-.001-3.457-1.179-5.934-.142zm9.377 22.17c-3.193 2.757 0 2.474 0 2.474s3.193.283 0-2.474zm-1.848-17.272s-2.243.615-5.047-.94c0 0-3.458-1.838-5.654 0 0 0 1.916-.853 5.607.94.001 0 3.692 2.024 5.094 0z'/%3e%3cpath fill='%23fff' d='M748.718 136.89s-1.916-3.36-7.757-2.693c0 0 1.589 4.672 7.757 2.693z'/%3e%3cellipse cx='744.689' cy='135.848' fill='%23784421' rx='1.155' ry='1.464'/%3e%3cellipse cx='744.689' cy='135.848' rx='.686' ry='.898'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2' d='M865.723 106.664v211.737c0 56.557-113.062 74.933-113.062 74.933s-113.062-18.376-113.062-74.933V106.664z'/%3e%3c/svg%3e";
            },
            6576: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1440 720'%3e%3cpath fill='%23f7e017' d='M0 0h1440v720H0z'/%3e%3cpath fill='%23fff' d='M0 50v320l1440 150V350z'/%3e%3cpath d='M0 220v150l1440 300V520z'/%3e%3cg fill='%23cf1126'%3e%3cpath d='M695.74 569.72c-19.36-2.57-37.11-8.73-49.44-17.17-2.39-1.64-4.64-2.98-4.99-2.98-.36 0-.65 1.82-.65 4.07 0 6.37-2.56 9.58-9 11.25-6.16 1.6-15.56-1.63-23.18-7.95-7.89-6.55-17-11.55-24.71-13.55-6.35-1.66-14.78-1.39-20.87.65-2.83.95-6.05 2.29-7.17 2.98-1.11.69-2.36 1.25-2.76 1.25-1.08 0-.93-6.85.2-9.04 1.49-2.87 5.16-5.7 9.44-7.26 2.16-.79 3.93-1.8 3.93-2.25s-.73-2.1-1.62-3.65c-2.9-5.08-1.71-10 3.35-13.87 5.18-3.96 13.95-4.64 21.7-1.69 1.95.74 3.77 1.35 4.04 1.35 1.02 0 .4-1.43-2.41-5.52-3.24-4.74-3.88-7.08-3.48-12.72.52-7.14 6.34-12.98 13.47-13.5 5.82-.42 9.44 1.54 18.03 9.72 25.65 24.46 53.54 37.94 86.07 41.59 8.21.92 24.73.43 34.42-1.03 29.27-4.41 58.76-19.13 81.79-40.82 6.38-6.01 9.45-7.6 14.68-7.62 4.55-.02 7.74 1.45 11 5.05 2.97 3.3 3.98 6.43 3.66 11.44-.21 3.21-.73 4.79-2.64 7.9-2.82 4.59-2.34 5.01 3.24 2.85 7.54-2.94 16.83-1.58 21.84 3.18 4.41 4.19 4.83 8.38 1.4 14.06-1.25 2.08-2.27 4.03-2.27 4.34 0 .57.95.84 5.53 1.58 5.99.96 9.42 5.41 9.42 12.21 0 2.04-.25 3.7-.56 3.7-.3 0-2.57-.83-5.04-1.85-6.98-2.88-10.95-3.62-19.11-3.57-6.21.04-8.35.33-12.68 1.74-6.63 2.17-13.72 6.35-19.5 11.5-6.37 5.68-10.38 7.47-16.58 7.42-5.76-.06-9.7-1.73-11.78-5.02-1.11-1.76-1.27-2.83-1-6.81.18-2.59.14-4.71-.07-4.71-.22 0-2.46 1.42-4.99 3.17-6.64 4.56-10.87 6.82-18.47 9.83-23.18 9.17-56.63 13.14-82.24 9.75z'/%3e%3cpath d='M706.34 525.17c-38.58-3.703-75.494-23.798-97.939-55.657-24.37-33.235-32.05-77.117-24.611-117.24 3.954-18.267 11.929-36.546 25.544-49.554-10.85 23.003-14.516 49.369-8.73 74.29 8.99 49.753 51.036 91.87 101.34 99.156 19.9 5.761 40.487-.324 59.496-6.493 41.935-14.78 73.88-54.583 77.777-99.08 3.336-24.077-.36-49.113-11.207-70.915 6.183 3.269 13.987 16.087 18.59 24.707 16.002 31.003 16.733 68.155 7.312 101.24-12.78 42.097-44.965 78.978-87.511 92.382-19.308 6.308-39.842 8.231-60.058 7.167z'/%3e%3cg id='a'%3e%3cpath d='M512.02 469.9c-2.528-.396-5.316 2.092-4.363 4.697 1.823 2.633 4.964 3.92 7.798 5.18 6.792 2.722 14.18 3.782 21.471 3.605-2.513-.006.863.026 1.802 0 5.774.017 11.516-1.024 16.944-2.98 3.018-1.062 6.864-2.025 8.1-5.363 1.207-2.175-.98-4.347-3.185-3.911-3.072.67-5.944 2.064-8.99 2.857-6.572 1.854-13.494 2.57-20.303 2.012-4.98-.608-9.804-2.2-14.41-4.143-1.597-.705-3.096-1.733-4.865-1.954z'/%3e%3cpath d='M514.83 459.52c-2.556-.38-4.758 2.56-3.692 4.908 1.965 2.848 5.267 4.365 8.356 5.699 5.37 2.148 11.204 3.047 16.975 2.875-2.191-.006.753.026 1.565 0a37.592 37.592 0 0 0 14.325-2.832c2.774-1.078 6.17-2.124 7.325-5.177.896-1.677.212-4.116-1.9-4.247-1.929-.096-3.593 1.132-5.378 1.683-6.485 2.681-13.622 3.818-20.614 3.214-4.357-.56-8.52-2.168-12.47-4.03-1.485-.718-2.82-1.836-4.491-2.093z'/%3e%3cpath d='M518.28 449.57c-2.19-.263-3.698 2.209-3.329 4.182.327 1.733 1.883 2.898 3.17 3.96 5.328 3.898 12.082 5.558 18.625 5.34-2.541-.009 3.41.042 1.595-.007 4.144-.017 8.238-1.03 11.966-2.825 2.489-1.082 5.411-2.336 6.25-5.177.401-1.324.652-3.227-.841-3.97-1.564-.874-3.117.47-4.539 1.016-4.789 2.437-10.125 3.793-15.507 3.768-4.65.157-9.033-1.8-13.068-3.907-1.464-.746-2.67-2.043-4.321-2.38z'/%3e%3cpath d='M481.53 302.7c-3.257 3.26-.77 9.271-.946 13.543 1.688 13.158 3.785 26.484 8.697 38.87 6.015 12.102 18.79 18.573 26.533 29.268 2.767 5.155 1.785 11.355 2.368 16.994.458 15.366.316 30.743.047 46.111 6.939 3.482 14.474 6.986 22.456 5.647 4.73-1.13 13.512-1.832 14.496-6.543-.383-26.5-.63-53.01-.983-79.506-2.69-8.119-10.951-12.32-17.129-17.515a155.468 155.468 0 0 1-14.188-16.099c-2.622-4.417-12.868-6.009-9.161 1.677 2.173 6.654 7.72 11.61 9.109 18.602.303 3.831 4.877 10.879.973 13.114-2.484-4.222-6.082-7.815-10.682-9.958-4.432-3.304-11.759-4.68-13.359-10.517-1.175-8.28-5.415-15.782-10.887-21.986 1.41-7.436.005-16.737-6.423-21.49l-.921-.212z'/%3e%3cpath d='M491.44 304.19c-2.963.478-2.862 4.254-1.491 6.239 1.458 4.288 1.855 8.945 1.066 13.409 5.267 6.166 9.347 13.543 10.576 21.64.03 3.044 3.233 4.051 5.309 5.555 4.871 3.102 10.348 5.351 14.686 9.233.913.976 1.602 2.027.957.035-.677-2.547-1.026-5.358-3.021-7.285-2.735-2.94-6.15-5.563-10.133-6.46-.332-4.114-2.292-7.893-4.102-11.532-2.006-3.479-4.102-7.206-7.54-9.462.138-6.098.038-12.495-2.586-18.122-.77-1.446-1.903-3.163-3.72-3.25z'/%3e%3cpath d='M499.73 306.62c-2.064.613-1.67 3.159-1.016 4.716.989 4.316 1.144 8.774 1.063 13.184 3.791 3 6.163 7.35 8.322 11.587 1.353 2.83 2.636 5.751 3.155 8.865 3.076 1.018 5.768 2.946 8.171 5.077-.952-2.882-3.076-5.113-4.504-7.744-1.551-2.737-3.033-5.592-3.69-8.693-2.958-3.157-4.587-7.63-3.941-11.952.133-4.776-1.41-9.71-4.606-13.31-.805-.793-1.766-1.67-2.954-1.73z'/%3e%3cpath d='M509.16 307.97c-1.122.198-1.805 1.266-2.406 2.137-.233.873.837 1.812 1.008 2.76a21.771 21.771 0 0 1 1.416 10.426c-.086 2.502.809 4.946 2.084 7.065.368-1.563 1.816-2.687 3.386-2.84.571-.101 1.411.188 1.078-.683-.399-4.786-1.128-9.598-2.8-14.12-.649-1.614-1.385-3.314-2.784-4.42-.284-.201-.623-.374-.982-.325z'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 1440 0)'/%3e%3cpath d='M715.67 475.98c-13.493-1.285-25.667-11.12-29.829-24 .224-2.219 2.987 1.241 4.292 1.474 2.45 1.36 5.1 2.48 7.92 2.654 3.558 1.529 5.757 5.035 9.152 6.863 1.577 1.228 7.155 3.64 6.119-.264-1.307-2.04-2.206-4.625-1.081-6.962 1.892-4.15 4.802-7.763 7.73-11.226 2.153-.72 3.595 3.527 5.134 4.957 2.131 3.279 4.7 7.28 3.447 11.352-1.22 1.509-2.021 6.047 1.241 4.522 4.022-1.77 7.316-4.742 10.651-7.517 2.919-2.039 6.654-2.183 9.713-3.97 1.417-.36 4.37-3.195 4.986-1.623-1.676 4.488-4.482 8.507-7.482 12.211-4.86 5.55-11.432 9.725-18.786 10.902-4.346.796-8.806.964-13.207.628z'/%3e%3cpath d='M731.53 460.22c.297-2.708-.32-5.473-1.703-7.935-2.123-4.326-5.121-8.166-8.046-11.96-2.757-1.616-4.287 3.657-6.12 5.17-2.857 4.277-6.443 8.657-6.617 14.036-1.607 2.502-4.604-2.04-5.896-3.535-2.468-3.491-4.336-7.62-4.03-11.987-.292-7.036 1.057-14.041 3.62-20.581 1.935-5.583 5.076-11.006 4.757-17.105.224-4.59-.708-9.658-4.426-12.745-3.538-2.776 2.291-3.368 4.143-1.928 3.168.212 4.882 5.448 7.777 4.152 1.153-2.735 1.382-5.997 3.76-8.13 2.333-3.196 4.772 1.356 5.57 3.488 1.648 1.873-.092 6.507 2.583 6.628 3.206-2.247 5.492-6.022 9.591-6.844 1.663-.949 4.504-.127 2.312 1.785-3.034 2.844-5.626 6.4-6.179 10.63-.928 5.308.4 10.69 2.713 15.47 4.446 9.39 7.885 19.997 5.636 30.445-1.043 4.644-4.198 8.645-8.032 11.34-.484.293-1.25.273-1.413-.394z'/%3e%3cpath d='M726.73 389.63c-1.456-2.624-3.224-5.21-5.673-6.995-2.381-.005-3.85 2.999-5.468 4.573-1.134 2.11-2.512 5.638-5.305 2.88-4.444-2.594-5.23-8.276-5.202-12.959-.28-7.59 2.777-14.674 5.492-21.587 1.728-4.328 1.302-9.199.248-13.634-1.327-5.092-5.414-8.623-8.56-12.595.214-1.536 4.235-.697 5.748-.405 3.36.852 5.367 3.825 7.87 5.926 1.782-.54 1.055-4.14 1.884-5.833.062-2.382 3.233-5.522 4.541-2.112 1.959 2.168-.062 6.465 2.469 7.815 2.411-.893 3.6-3.529 5.866-4.72 2.23-1.52 5.378-1.69 7.778-.497.845 2.213-2.64 4.055-3.65 5.977-4.051 5.006-5.475 11.91-3.74 18.112 1.377 4.865 3.814 9.406 4.655 14.434 1.013 5.653.98 11.59-.484 17.16-.874 3.38-3.802 5.64-6.825 7.044-.746-.694-1.14-1.714-1.644-2.583z'/%3e%3cpath d='M711.61 326.89c-3.36-2.46-4.47-4.81-4.47-9.46 0-2.38.44-3.67 2.01-5.83 2.31-3.2 1.89-4.21-1.38-3.27-5.26 1.51-7.77.13-7.95-4.35-.08-2.19.38-3.12 3.33-6.66 2.36-2.84 3.22-4.33 2.75-4.8-.46-.46-3.25 1.96-8.98 7.79-4.57 4.65-9.71 9.4-11.42 10.56-9.84 6.64-19.24 7.67-23.53 2.56-2.2-2.61-2.08-4.08.46-5.66 1.17-.72 3.14-2.38 4.39-3.69 2.95-3.07 11.74-9.41 16.1-11.61 3.54-1.79 4.38-3 2.08-3-2.98 0-12.54 6.22-19.79 12.88-2.13 1.97-5.2 4.16-6.81 4.87-3.62 1.6-10.73 2.19-13.89 1.15-2.23-.74-6.3-4.58-6.3-5.95 0-.36.93-1.16 2.06-1.77 1.13-.6 3.16-2.07 4.5-3.24 5.8-5.09 16.79-10.33 25.51-12.16 2.77-.58 1.75-1.98-1.34-1.84-5.99.26-17.88 5.83-24.98 11.69-8.32 6.86-20.87 6.21-24.91-1.29-.7-1.29-1.11-2.5-.91-2.69.19-.19 2.66-.93 5.49-1.65 3.06-.77 9.12-3.28 14.91-6.17 9.11-4.54 11.81-5.51 18.08-6.52 2.82-.45 2.97-1.83.23-2.15-3.53-.42-8.94 1.35-18.5 6.05-12.28 6.04-15.72 7.08-22.19 6.7-5.9-.36-9.23-1.87-14.02-6.4-3.13-2.97-7.57-10.51-6.7-11.38.21-.21 1.65 0 3.2.45 1.72.51 6.65.85 12.59.86 8.31.02 10.52-.2 14.95-1.48 7.41-2.14 17.26-7.15 24-12.18 12.89-9.64 23.4-13.51 36.8-13.57 12.37-.05 20.24 2.81 27.21 9.88 2.36 2.39 4.37 3.94 4.7 3.61.31-.31.65-4.49.75-9.29 0 0 3.64-.35 4.41.67 0 7.79.09 8.4 1.22 8.4.74 0 1.53-.76 2.02-1.94 1.06-2.55 4.98-6.04 9.17-8.16 9.05-4.59 24.71-4.73 37.29-.34 5.3 1.86 11.18 5.18 16.78 9.5 5.62 4.32 17.11 10.1 23.9 12.03 6.87 1.95 18.98 2.44 25.19 1.03 2.56-.58 4.96-1.06 5.34-1.06 2.29 0-1.61 7.63-6.19 12.1-8.37 8.18-19.26 8.14-34.58-.12-9.55-5.14-20.97-7.95-20.97-5.15 0 .58.6.97 1.49.97 3.32 0 9.73 2.23 18.67 6.47 9.67 4.6 15.1 6.54 18.32 6.54 2.34 0 2.41 1.45.23 4.65-2.31 3.41-6.23 5.1-11.77 5.09-5.29-.02-8.23-1.18-12.96-5.11-7.91-6.58-27.62-13.92-26.86-10 .15.78 1.1 1.26 3.13 1.57 6.86 1.05 14.91 4.89 23.15 11.06 2.54 1.91 5.18 3.79 5.85 4.19 1.13.66 1.15.86.26 2.53-1.48 2.76-5.21 4.9-9.25 5.32-5.23.54-9.78-1.02-14.49-4.96-9.94-8.32-19.31-14.34-22.31-14.34-2.45 0-1.35 1.35 2.97 3.64 5.68 3.01 11.52 7.08 15.82 11.03 2.03 1.88 4.32 3.74 5.08 4.15 1.8.96 1.73 2.37-.25 4.96-2.02 2.64-5.36 3.8-9.69 3.34-8.64-.91-15.38-5.08-25.97-16.07-4.14-4.29-7.83-7.8-8.21-7.8-1.41 0-.58 1.91 2.15 4.97 3.38 3.78 4.03 5.91 2.75 8.98-1.13 2.72-3.01 3.35-6.87 2.31-3.95-1.07-4.57-.1-1.98 3.12 3.86 4.81 3.29 10.7-1.44 14.75-1.47 1.25-3.01 2.28-3.43 2.28-.41 0-1.45-1.07-2.32-2.38-3.04-4.62-5.71-4.59-8.67.08-1.03 1.63-1.9 2.95-1.93 2.94-.04-.01-1.43-1.01-3.08-2.23z'/%3e%3cpath d='m726.67 233.03-5.13 4.06-4.6-3.47v27.74l9.73.12z'/%3e%3cpath d='M694.89 204.25c-1.02 13.11-4.35 22.26-8.98 32.35l11.1-10.29 7.72 9.17 8.36-9.33 8.53 7.88 8.2-8.2 8.52 9.97 7.4-8.2 12.54 9c-4.55-10.09-10.71-18.64-9.94-32.84-12.15 9.03-41.02 10.66-53.45.49z'/%3e%3cpath d='M716.95 197.56c-4.46.08-9.16.14-13.39.97-2.93.58-5.59 1.53-7.81 3.1.36 8.53 41 12.09 51.9.16-2.29-1.67-5.09-2.66-8.17-3.26-4.07-.79-8.57-.87-12.84-.94 0 2.34.02 4.69.02 7.04l-9.71-.03v-7.04z'/%3e%3cpath d='m724.9 153.97-6.31.05v49.38l6.44.03z'/%3e%3cpath d='m724.89 155.24-2.41 23.64 24.32 11.88-12.31-16.46 16.81-5.45zm-2.71-6.16c-3.69 0-6.42 1.38-6.42 3.02s2.73 3.03 6.42 3.03 6.4-1.39 6.4-3.03-2.71-3.02-6.4-3.02z'/%3e%3c/g%3e%3cg fill='%23f7e017'%3e%3cpath d='M711.05 563.82c3.99-1.32 6.26-3.74 7.89-8.4.81-2.32 1.36-4.73 1.22-5.36-.34-1.49-2.06-1.41-3.96.17-1.3 1.09-1.46 1.64-1.09 3.86.95 5.6-1.04 6.99-11.64 8.13-1.05.11-4.09-.07-6.77-.4-5.04-.63-6.84-.13-5.01 1.39.55.46 1.95 1.08 3.11 1.37 2.83.73 13.22.24 16.25-.76zm21.97-.93c.6-.55 2.66-1.5 4.58-2.12 2.56-.82 3.88-1.7 4.96-3.31 3.11-4.63 2.53-8.62-2.04-14-2.48-2.92-3.58-2.84-5.56.4-1.71 2.8-1.67 2.98.79 3.62 1.29.33 2.53 1.28 3.21 2.45 2.68 4.64 1.89 7.51-2.08 7.54-3.6.03-4.59.54-5.56 2.87-.51 1.21-.92 2.5-.92 2.87 0 .98 1.36.81 2.62-.32zm-7.21-5.24c.68-1.84.92-5.15.84-11.9-.05-5.14-.25-9.5-.45-9.7-.6-.6-3.56 1.31-3.95 2.54-.2.64.13 2.12.73 3.28.92 1.79 1.04 3.46.76 10.47-.36 8.86.22 10.35 2.07 5.31z'/%3e%3cpath d='M708.89 553.43c.36-1.65.82-5.03 1.03-7.5s.72-5.59 1.12-6.94c1.02-3.46-.01-4.37-2.74-2.43l-2.03 1.45.42 4.97c.39 4.48-.32 12.83-1.35 16.07-.28.86.12.64 1.25-.68.91-1.06 1.95-3.29 2.3-4.94zm-15.01 2.41c3.651-3.055 3.232-8.27 4.04-12.52-.084-2.825 1.804-6.212.586-8.683-3.412.624-5.515 3.856-3.769 7.075.146 3.738.013 7.807-1.908 11.113-1.57 2.162-6.542 1.623-6.314-1.44 1.248-4.607-4.271-2.366-6.426-1.158-1.666 1.16-5.182 1.245-3.96-1.657-.807-3.866-5.78-1.448-8.482-1.465-2.552-.046-.21-5.17-3.873-4.27-6.806-.538-14.32.06-20.21-4.052-3.449-1.658-2.937-5.806-1.142-8.49 2.144-3.664 2.756-8.248 6.16-11.092 3.368-3.231-3.178-1.867-4.653-.778-3.282 1.796-.233 6.423-2.919 8.989-1.57 2.66-3.636 6.336-7.27 5.83-5.24-.992-8.26-5.866-12.017-9.133-3.218-.642-1.408 5.222.253 6.455 3.288 2.462 7.13 4.256 11.092 5.318 3.944-.63 4.072 4.534 7.445 5.344 6.187 2.883 13.083 3.747 19.833 4.099 2.65.22 1.16 4.942 4.645 4.01 1.948.504 6.348-.726 6.569 1.537-2.953 3.506 2.834 3.428 4.975 2.8 2.742-.419 6.246-1.466 6.971 2.293 2.29 2.413 6.492 2.057 9.28.676a6.31 6.31 0 0 0 1.093-.8z'/%3e%3cpath d='M634.12 525.57c1.11-1.41 2.77-4.26 3.69-6.34.91-2.09 2.28-4.46 3.03-5.27 1.76-1.9.78-3.07-2.06-2.44-1.5.33-2.11.88-2.36 2.18-.85 4.24-2.39 8.58-3.76 10.6-2.48 3.66-2.54 3.81-1.52 3.81.53 0 1.87-1.14 2.98-2.54zm-37.46-23.48c-2.8 0-2.92 1.77-.19 2.72 1.32.46 2.44 1.57 3.34 3.38 2.66 5.29 4.22 6.23 11.28 6.84l4.53.41.22 2.75c.11 1.52.47 2.78.82 2.78s2.1-.76 3.87-1.66c3.32-1.68 6.47-5.6 6.47-8.03 0-1.59-2.65-3.31-5.06-3.31-1.07 0-3.11.86-4.72 2.03-5.04 3.65-10.43 2.91-13.38-1.84-2.42-3.92-4.95-6.07-7.18-6.07zm24.46 9.75c1.34 0 1.67.99.94 2.88-.5 1.3-2.13 1.34-2.62.06-.58-1.51.23-2.94 1.68-2.94zm189.72-6.15c-1.83.07-2.37.47-3.53 2.19-1.9 2.82-2.09 8.93-.34 11.09 1.09 1.34 1.25 1.37 3.56.41 3.22-1.35 3.76-1.3 3.75.43-.02 4.42-6.36 12.94-13 17.47-1.79 1.22-3.39 2.58-3.56 3.03-.48 1.26 1.98.98 5-.56 4.12-2.1 9.53-7.62 11.75-11.97 1.76-3.47 2.01-4.65 2.22-10.72.19-5.59.04-7.23-.91-9.09-1.06-2.09-1.4-2.28-4.06-2.28-.32 0-.61-.01-.88 0zm.22 3.9c1.38 0 1.62.31 1.78 2.29.14 1.64-.15 2.64-1.06 3.46-1.24 1.12-1.34 1.11-2.44-.56-1.54-2.36-.59-5.19 1.72-5.19zm-30.36 42.68c5.85-2.88 9.3-6.12 11.52-10.81 1.05-2.23 1.91-4.33 1.91-4.69 0-.81-2.88-2.15-4.61-2.15-1.72 0-2.07-1.19-1.33-4.48.72-3.21-.15-7.23-1.56-7.23-.51 0-1.41.75-2.01 1.66-.92 1.41-.97 2.01-.29 4.06 1 3.04.21 5.31-2.51 7.25-1.29.92-2 1.98-2 3.01 0 .87.11 1.58.24 1.58.14 0 1.56-.74 3.16-1.63l2.92-1.63 1.72 1.35c.94.74 1.72 1.95 1.72 2.69 0 3.56-10.15 9.54-17.12 10.1-3.71.3-4.34.17-5.63-1.11-1.05-1.05-1.35-1.93-1.09-3.17.2-.95.56-2.68.8-3.84.64-3.1-.69-2.68-2.99.94-1.89 2.99-2.45 6.18-1.39 7.86.87 1.37 6.65 2.68 10.74 2.43 2.57-.15 5.11-.87 7.8-2.19zm39.04-21.78c3.68-3.67 5.24-8.14 5.26-15.05l.01-5.19 3.04-1.44c3.95-1.88 7.69-5.62 7.69-7.7 0-2.14-.95-2.03-2.67.3-1.25 1.69-2.92 2.71-9.03 5.52-1.54.71-1.64 1.09-1.99 7.55-.41 7.45-1.42 10.24-5.58 15.33-2.55 3.1-2.64 3.51-.87 3.51.73 0 2.59-1.27 4.14-2.83zm-40.08-4.16c.35-1.07-1.68-1.83-2.56-.96-.37.37-.47 1.01-.22 1.42.58.93 2.42.62 2.78-.46zm55.27-14.31c.36-1.07-1.68-1.83-2.55-.96-.38.38-.48 1.02-.23 1.43.58.93 2.42.62 2.78-.47zm-66.52-38.74c-1.43.68-2.171 2.224-3.165 3.403-.715.486-.142.94.27 1.399 2.522 2.717 3.59 6.386 4.788 9.808 1.177 4.04 2.66 8.379 1.428 12.588-.484 1.613-1.752 3.282-3.646 2.746-3.03-.189-6.012-.993-9.051-.961-2.705.14-4.796 2.602-7.562 2.334-1.767.116-1.692-3.618-3.334-2.62-.813 1.948-.412 4.12-.51 6.18.307.294 1.166.037 1.68.123h5.446c.385 1.88.337 4.036 1.687 5.532 1.89.672 4.016.091 5.812-.643 1.925-.896 2.183-3.212 2.727-5.016.579-1.938 3.117-1.43 4.615-2.191 3.665-1.07 6.067-4.879 5.852-8.627-.237-5.722-2.42-11.105-4.076-16.52-.833-2.387-1.41-4.876-2.377-7.205-.113-.2-.345-.37-.584-.33zM759.34 506c2.036-.133 2.921 2.37 2.49 4.03-.762 2.255-3.535.809-4.096-.817-1.03-1.451-.393-3.404 1.606-3.213z'/%3e%3cpath d='M683.94 487.22c-.91-.02-1.93.32-2.94 1.03-5.31 3.72-6.67 8.12-3.06 9.84 2.65 1.27 1.98 2.76-2.19 4.85-5.97 2.98-11.24 2.61-21.25-1.53-2.46-1.02-3.1-.63-2.53 1.62.55 2.21 2.57 3.42 7.59 4.56 5.4 1.24 11.93.84 16.13-.97 2.05-.88 4.48-2.73 6.53-4.96l3.25-3.57 3.78.47c4.66.57 4.75.62 4.75 2.85 0 1.77.1 1.81 4.38 2.21 2.41.23 5.58.44 7.06.44 1.89.01 2.96.34 3.59 1.22.84 1.17 1.34 1.23 8.38.6 6.58-.6 7.87-.55 10.84.46 2.11.72 4.43 1.01 6.19.82 5.04-.57 11.99-4.69 13-7.72.12-.37 1.95-1.02 4.06-1.44 5.09-1.02 5.31-2.13.56-2.72-2.06-.26-5.15-1.01-6.87-1.69-1.73-.68-4.09-1.25-5.25-1.25-2.56 0-4.97 1.6-4.97 3.25 0 1.08.38 1.19 3.41.88 2.85-.29 3.68-.13 5.18 1.06.99.78 1.65 1.7 1.44 2.03-.67 1.09-6.62 3.8-9.25 4.22-1.76.28-3.18.09-4.56-.62-2.31-1.2-5.71-1.38-6.35-.35-.27.45-1 .16-2-.78l-1.56-1.47-3.53 1.47c-3.59 1.49-4.91 1.43-4.91-.28 0-.78-1.05-.87-6.34-.53-5.83.38-6.44.28-7.53-.94-1.01-1.12-1.03-1.51-.31-2.66.66-1.06.66-1.52.03-2.15s-1.45-.62-3.75 0c-5.8 1.55-7.44.68-7.44-3.85 0-2.72-1.56-4.37-3.56-4.4zm-1.44 4.16c.31 0 .57.19.97.59.51.51.78 1.4.56 1.97-.52 1.35-2.98 1.3-3.5-.06-.25-.66.07-1.4.81-1.94.52-.38.85-.57 1.16-.56z'/%3e%3cpath d='M672.1 495.6c3.53-2.24 3.45-2.07 3.96-8.29.35-4.39.29-4.72-.9-4.72-1.73 0-2.63 1.9-2.63 5.52 0 2.32-.36 3.36-1.6 4.59-2.94 2.94-10.24 1.6-11.16-2.05-.31-1.25.09-2.38 1.62-4.55 3.19-4.53 2.47-5.64-1.44-2.2-2.69 2.35-3.17 2.42-2.66.39.47-1.87-.51-2.61-2.7-2.06-1.12.28-1.73.98-2 2.34-.26 1.33-.87 2.07-1.93 2.33-1.77.45-4.79-1.23-4.79-2.66 0-1.06 4.52-6.58 10.32-12.6 2.19-2.28 3.98-4.4 3.98-4.72s-1.17-.58-2.6-.58c-2.09 0-2.6.23-2.6 1.2 0 .66-2.92 4.49-6.5 8.52-7.46 8.4-8.08 10.15-4.39 12.39 2.97 1.82 6.78 1.68 9.77-.35l2.42-1.65v2.99c0 3.82.76 5.19 3.76 6.78 3.77 1.99 8.33 1.75 12.07-.62zm156.56-51.91c-2.767 1.652-.602 5.124-.183 7.429-1.13 3.146-5.171 3.993-8.118 4.577-4.173.692-7.13 4.183-8.718 7.892-.86 2.41-2.937 6.145-5.2 2.477-1.966-1.993-5.582-3.573-7.908-1.246-1.766 1.682-2.214 4.157-2.873 6.402-1.043-1.726-1.51-4.296-3.72-4.842-3.528.496-2.253 4.944-.594 6.778 1.507 2.138 2.956 4.958 1.478 7.497-1.303 3.051-5.81 5.11-8.457 2.5-2.472-1.306-.819-5.966-3.254-6.222-1.204.87-1.303 5.746-3.23 3.103-1.39-2.259-.653-5.353-2.355-7.385-2.01.25-3.627 3.712-2.958 5.571 2.682 3.618 3.785 8.156 4.831 12.467.652 1.727-.095 5.227 1.52 5.91 1.12-2.778.08-5.93.96-8.735 2.619-.329 5.531.866 8.277.23 3.928-.509 6.964-3.824 8.342-7.355.417-2.654-.079-5.347-.153-8.017 3.104.481 6.329.471 9.314 1.48 1.48 2.27-.47 5.448-.88 7.929-1.558 5.052-5.515 8.72-9.365 12.097-1.61.953-1.827 3.478.551 2.118 5.174-2.212 9.03-6.898 11.248-11.97 1.62-3.901.318-8.247 1.375-12.237 1.562-2.996 5.321-2.365 8.103-2.356 2.88-.11 5.337-3.464 4.375-6.261-.916-3.247 2.519-4.811 4.866-5.972 3.112-1.57 5.498-4.759 5.257-8.358-.128-1.84-.037-5.332-2.531-5.5zm-11.031 18.75c3.334.886-.603 7.252-2.375 3.219-.545-1.54.75-3.274 2.375-3.219zm-15.47 4.56c4.338-.253 2.78 6.081-.885 3.205-1.9-.955-1.272-3.323.885-3.205zM645.1 491.48c.12-.63-.2-1.08-.77-1.08-1.21 0-1.94 1.06-1.37 1.98.59.95 1.89.41 2.14-.9zm50.84-5.68c0-.93-.35-1.28-1.13-1.13-1.7.32-1.89 2.48-.22 2.48.93 0 1.35-.42 1.35-1.35zm-62.91-30.52c-2.029-.417-3.305 1.3-4 2.938-1.517 2.55-3.37 5.158-6.093 6.509-1.958.544-4.094-.2-5.782-1.21-2.015-1.004-1.557-3.427-2.42-5.101-1.457-1.144-4.04.492-3.984 2.271-.16 2.386 2.072 3.764 3.925 4.687 1.574.965 3.857 1.501 4.487 3.453-.044 1.659.623 3.557 2.643 2.917 2.26-.038 2.845 2.715 1.933 4.367-.93 1.861-1.557 4.041-1.112 6.115 1.08.91 2.183-1.53 2.965-2.227l1.594-2.125c3.999.217 7.993.727 12.001.584 2.85-.051 5.278-1.81 7.09-3.875 2.564-2.68 4.67-5.829 7.598-8.142 2.084-.508.964-4.433-1.213-3.3-1.96.736-2.578 2.952-3.936 4.364-2.315 2.802-4.677 5.647-7.594 7.843-2.125.881-4.571.497-6.754 0-.91-.796 1.809-1.445 2.188-2.33 1.252-1.25 2.739-2.438 3.464-4.082-.694-1.514-2.816-1.637-4.312-1.667-3.686.442-6.501 3.536-10.223 3.827-2.826.1-1.355-2.96-.082-4.004 2.492-2.96 5.185-5.746 7.786-8.608.738-.888 3.409-1.732 1.7-2.98-.597-.215-1.242-.215-1.869-.224zm1.813 14.969c1.858 1.045-1.186 2.757-2.469 2.523-1.682.504-1.712-1.212-.218-1.553.84-.438 1.727-.894 2.686-.97zm-5.72 3.906c1.059-.02 3.275.996 1.194 1.647-1.45 1.123-3.087-1.143-1.193-1.647z'/%3e%3cpath d='M674.15 476.74c0-1.41-2.53-1.21-2.81.22-.18.92.11 1.14 1.29.97.84-.12 1.52-.65 1.52-1.19zm112.05-9.92c.26-1.35-1.62-2.25-2.61-1.26s-.08 2.87 1.26 2.61c.62-.12 1.23-.73 1.35-1.35zm-174.38-13.73c1.76-1.51 1.78-1.61 1.02-4.93-1.08-4.65-1.01-5.15.76-5.59 2.24-.57 7.93 2.48 9.19 4.92.98 1.89.95 2.02-.71 3.56-1.79 1.65-1.78 3.58.01 3.58 1.48 0 5.57-3.87 5.57-5.26 0-1.93-4.54-6.49-8.13-8.16-2.22-1.04-4.44-1.52-7.01-1.53-4.6 0-5.22.99-3.98 6.34 1.46 6.27-.52 7.12-5.57 2.39-3.75-3.51-5.23-7.16-5.21-12.91.01-6.17 2.37-9.22 7.69-9.94 3.53-.47 3.44-1.3-.19-1.84-5.3-.8-9.78 2.74-11.48 9.06-1.89 7.01 2.44 15.55 10.1 19.95 4.01 2.3 5.61 2.37 7.94.36zm208.84-7.69c.43-.43.78-1.4.78-2.15s.73-2.36 1.62-3.57c.9-1.21 1.63-2.45 1.63-2.75 0-1.23-2.03-1.19-3.63.08-1.64 1.28-2.87 1.31-2.87.06 0-.31.78-.95 1.74-1.42 2.38-1.16 2.58-2.31.57-3.23-2.58-1.17-5.17.97-5.44 4.5-.17 2.36.02 2.77 1.84 3.84 1.66.98 1.97 1.5 1.69 2.9-.48 2.43.53 3.28 2.07 1.74zm19.63-2.22c1.44-1.29 2.61-2.76 2.61-3.25s1.24-1.79 2.76-2.88c4.31-3.1 5.26-6.23 3.33-11.04-.75-1.89-3.11-4.5-8.24-9.12-3.94-3.56-7.57-6.47-8.04-6.47-1.4 0-1.15 5.15.27 5.6 2.56.82 4.11 1.87 8.14 5.5 4.68 4.23 6.84 8.18 5.66 10.38-1.13 2.13-2.63 1.47-6.76-2.96-2.17-2.33-4.32-4.23-4.76-4.23-.48.01-.82.85-.82 2.03 0 1.48.79 2.89 2.93 5.27 3.49 3.88 3.83 6.21 1.21 8.27-.94.74-1.91 1.35-2.15 1.35-.23 0-1-1.16-1.7-2.57-1.46-2.96-10.39-12.39-11.73-12.39-.61 0-.91.76-.91 2.26 0 1.81.36 2.45 1.8 3.19 1.77.92 6.15 5.33 10.55 10.65 1.26 1.52 2.5 2.75 2.77 2.76.26 0 1.65-1.06 3.08-2.35zm8.76-25.07c-.58-1.87-12.56-14.2-13.79-14.2-.64 0-.84.76-.69 2.72.17 2.38.43 2.79 2.07 3.22 1.02.27 4.18 2.75 7.01 5.5 2.82 2.75 5.3 4.84 5.5 4.63.2-.2.16-1.04-.1-1.87zM777.5 556.89a1.78 1.632 0 1 1-3.561 0 1.78 1.632 0 1 1 3.561 0zm6.29-2.1a1.78 1.632 0 1 1-3.561 0 1.78 1.632 0 1 1 3.561 0z'/%3e%3c/g%3e%3c/svg%3e";
            },
            7184: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 291.042 198.438'%3e%3cdefs%3e%3cclipPath id='a' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M0 2834.646h4251.968V0H0z'/%3e%3c/clipPath%3e%3cclipPath id='b' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2066.45 1293.03h70.05v-186.09h-70.05z'/%3e%3c/clipPath%3e%3cclipPath id='c' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2211.74 1676.68h255.01v-253.19h-255.01z'/%3e%3c/clipPath%3e%3cclipPath id='d' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2205.52 1454.59h408.18v-390.65h-408.18z'/%3e%3c/clipPath%3e%3cclipPath id='e' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2521.52 1510.89h73.13v-91.69h-73.13z'/%3e%3c/clipPath%3e%3cclipPath id='f' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2490.57 1549.14h93.58v-82.16h-93.58z'/%3e%3c/clipPath%3e%3cclipPath id='g' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2230.33 1609.63h288.03v-217.74h-288.03z'/%3e%3c/clipPath%3e%3cclipPath id='h' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2288.18 1547.51h230.75v-167.05h-230.75z'/%3e%3c/clipPath%3e%3cclipPath id='i' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2284.54 1494.68h238.37V1330.6h-238.37z'/%3e%3c/clipPath%3e%3cclipPath id='j' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2282.77 1432.13h249.19v-133.84h-249.19z'/%3e%3c/clipPath%3e%3cclipPath id='k' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2325.63 1365.89h208.44v-104.44h-208.44z'/%3e%3c/clipPath%3e%3cclipPath id='l' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2305.72 1271.04h208.09v-49.59h-208.09z'/%3e%3c/clipPath%3e%3cclipPath id='m' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2238.25 1276.4h265.8v-111.53h-265.8z'/%3e%3c/clipPath%3e%3cclipPath id='n' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2201.75 1274.57h263.53v-153.56h-263.53z'/%3e%3c/clipPath%3e%3cclipPath id='o' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2095.46 1292.36h305.73v-193.18h-305.73z'/%3e%3c/clipPath%3e%3cclipPath id='p' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2174.94 1386.32h124.17v-119.81h-124.17z'/%3e%3c/clipPath%3e%3cclipPath id='q' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2137.84 1020.08h23.55v-28.677h-23.55z'/%3e%3c/clipPath%3e%3cclipPath id='r' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2199.61 1064.1h34.86v-35h-34.86z'/%3e%3c/clipPath%3e%3cclipPath id='s' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2115.47 1293.03h70.06v-186.09h-70.06z'/%3e%3c/clipPath%3e%3cclipPath id='t' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1785.22 1676.68h255.01v-253.19h-255.01z'/%3e%3c/clipPath%3e%3cclipPath id='u' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1638.27 1454.59h408.18v-390.65h-408.18z'/%3e%3c/clipPath%3e%3cclipPath id='v' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1657.32 1510.89h73.13v-91.69h-73.13z'/%3e%3c/clipPath%3e%3cclipPath id='w' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1667.82 1549.14h93.58v-82.16h-93.58z'/%3e%3c/clipPath%3e%3cclipPath id='x' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1733.61 1609.63h288.03v-217.74h-288.03z'/%3e%3c/clipPath%3e%3cclipPath id='y' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1733.04 1547.51h230.75v-167.05h-230.75z'/%3e%3c/clipPath%3e%3cclipPath id='z' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1729.06 1494.68h238.37V1330.6h-238.37z'/%3e%3c/clipPath%3e%3cclipPath id='A' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1720.01 1432.13h249.19v-133.84h-249.19z'/%3e%3c/clipPath%3e%3cclipPath id='B' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1717.9 1365.89h208.44v-104.44H1717.9z'/%3e%3c/clipPath%3e%3cclipPath id='C' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1738.16 1271.04h208.09v-49.59h-208.09z'/%3e%3c/clipPath%3e%3cclipPath id='D' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1747.92 1276.4h265.8v-111.53h-265.8z'/%3e%3c/clipPath%3e%3cclipPath id='E' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1786.69 1274.57h263.53v-153.56h-263.53z'/%3e%3c/clipPath%3e%3cclipPath id='F' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1850.78 1292.36h305.73v-193.18h-305.73z'/%3e%3c/clipPath%3e%3cclipPath id='G' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1952.86 1386.32h124.17v-119.81h-124.17z'/%3e%3c/clipPath%3e%3cclipPath id='H' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2090.58 1020.08h23.55v-28.677h-23.55z'/%3e%3c/clipPath%3e%3cclipPath id='I' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2017.5 1064.1h34.86v-35h-34.86z'/%3e%3c/clipPath%3e%3cclipPath id='J' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2152.04 1057.5h36.11v-63.615h-36.11z'/%3e%3c/clipPath%3e%3cclipPath id='K' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2181.67 1062.56h15.19v-66.239h-15.19z'/%3e%3c/clipPath%3e%3cclipPath id='L' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2063.75 1057.49h36.11v-63.618h-36.11z'/%3e%3c/clipPath%3e%3cclipPath id='M' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2055.04 1062.55h15.19v-66.242h-15.19z'/%3e%3c/clipPath%3e%3cclipPath id='N' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2303.35 1598.25h74.92v-73.48h-74.92z'/%3e%3c/clipPath%3e%3cclipPath id='O' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1873.7 1598.25h74.92v-73.48h-74.92z'/%3e%3c/clipPath%3e%3cclipPath id='P' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1816.62 1557.48h91.87v-67.61h-91.87z'/%3e%3c/clipPath%3e%3cclipPath id='Q' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2343.48 1557.48h91.86v-66.78h-91.86z'/%3e%3c/clipPath%3e%3cclipPath id='R' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2160.52 1020.85h58.98v-36.402h-58.98z'/%3e%3c/clipPath%3e%3cclipPath id='S' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2032.47 1020.85h58.98v-36.402h-58.98z'/%3e%3c/clipPath%3e%3cclipPath id='T' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1932.9 1644.69h46.83v-21.91h-46.83z'/%3e%3c/clipPath%3e%3cclipPath id='U' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1912.44 1606.12h43.57v-34.67h-43.57z'/%3e%3c/clipPath%3e%3cclipPath id='V' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1973.3 1568.01h416.04v-434.46H1973.3z'/%3e%3c/clipPath%3e%3cclipPath id='W' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2031.12 1552.73h344.05v-368.24h-344.05z'/%3e%3c/clipPath%3e%3cclipPath id='X' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1978.01 1600.9h19.79v-20.81h-19.79z'/%3e%3c/clipPath%3e%3cclipPath id='Y' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1964.25 1584.49h16.4v-19.48h-16.4z'/%3e%3c/clipPath%3e%3cclipPath id='Z' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1862.63 1568.01h416.04v-434.46h-416.04z'/%3e%3c/clipPath%3e%3cclipPath id='aa' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M1876.8 1552.73h344.05v-368.24H1876.8z'/%3e%3c/clipPath%3e%3cclipPath id='ab' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2254.17 1600.9h19.79v-20.81h-19.79z'/%3e%3c/clipPath%3e%3cclipPath id='ac' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2271.32 1584.49h16.4v-19.48h-16.4z'/%3e%3c/clipPath%3e%3cclipPath id='ad' clipPathUnits='userSpaceOnUse'%3e%3cpath d='M2028.34 1202.53h204.21v-55.25h-204.21z'/%3e%3c/clipPath%3e%3c/defs%3e%3cpath fill='%2300702d' d='M0 198.437h291.042v-66.139H0z'/%3e%3cpath fill='%23f0e53c' d='M0 132.298h291.042V66.14H0z'/%3e%3cpath fill='%23d32011' d='M0 66.14h291.042V0H0z'/%3e%3cg clip-path='url(%23a)' transform='matrix(.07 0 0 -.07 -3.307 198.466)'%3e%3cpath fill='%23473125' d='M2493.016 985.422c1.904 2.46 1.844 6-.346 8.127l-715.049 697.004c-2.204 2.13-5.607 1.965-7.587-.375-2.01-2.354-1.844-5.982.344-8.127l715.051-696.988a5.375 5.375 0 0 1 2.594-1.41s3.09-.66 4.993 1.77'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M2493.016 985.422c1.904 2.46 1.844 6-.346 8.127l-715.049 697.004c-2.204 2.13-5.607 1.965-7.587-.375-2.01-2.354-1.844-5.982.344-8.127l715.051-696.988a5.375 5.375 0 0 1 2.594-1.41s3.09-.66 4.993 1.77z'/%3e%3cpath fill='%23473125' d='M2555.333 1077.518c1.8.18 3.493 1.29 4.364 3.15 1.35 2.847.269 6.296-2.37 7.736l-876.554 473.003c-2.653 1.425-5.877.286-7.212-2.549-1.334-2.834-.27-6.282 2.37-7.72l876.552-473.02a5.397 5.397 0 0 1 2.85-.6'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M2555.333 1077.518c1.8.18 3.493 1.29 4.364 3.15 1.35 2.847.269 6.296-2.37 7.736l-876.554 473.003c-2.653 1.425-5.877.286-7.212-2.549-1.334-2.834-.27-6.282 2.37-7.72l876.552-473.02a5.397 5.397 0 0 1 2.85-.6z'/%3e%3cpath fill='%23473125' d='M2535.014 1022.999c1.8-.091 3.614.78 4.694 2.52 1.68 2.637 1.02 6.208-1.424 7.976l-813.158 588.58c-2.46 1.785-5.804 1.08-7.453-1.544-1.664-2.624-1.019-6.193 1.425-7.977l813.16-588.595c.853-.601 1.797-.931 2.756-.96'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M2535.014 1022.999c1.8-.091 3.614.78 4.694 2.52 1.68 2.637 1.02 6.208-1.424 7.976l-813.158 588.58c-2.46 1.785-5.804 1.08-7.453-1.544-1.664-2.624-1.019-6.193 1.425-7.977l813.16-588.595c.853-.601 1.797-.931 2.756-.96z'/%3e%3cpath fill='%23f0e53c' d='M2067.028 1284.38c2.999-34.816 5.127-114.107 5.623-128.473.494-14.363 27.604-49.84 29.958-27.288 2.369 22.58-15.563 150.003-15.563 150.003z'/%3e%3cpath fill='%2300702d' d='M2079.667 1287.468c7.542-49.69 12.64-178.492 25.7-182.092 13.076-3.568 21.068-2.608 24.891 8.518 3.838 11.125-12.55 66.126-12.55 66.126l-19.763 68.613-5.938 39.436z'/%3e%3cg clip-path='url(%23b)' opacity='.25'%3e%3cpath d='M2136.497 1106.937c-14.53.21-18.818 0-27.965 49.032-9.131 49.031-14.155 90.206-20.977 86.427-6.823-3.81-11.757-1.71-13.75 6.807-1.98 8.516-9.162 31.19-6.928 38.775 2.219 7.587 28.579 4.38 28.579 4.38l23.393-101.782z'/%3e%3c/g%3e%3cpath fill='%23473125' d='M1758.954 985.422c-1.904 2.46-1.844 6 .346 8.127l715.049 697.004c2.203 2.13 5.606 1.965 7.586-.375 2.01-2.354 1.845-5.982-.343-8.127l-715.053-696.988a5.367 5.367 0 0 0-2.592-1.41s-3.09-.66-4.993 1.77'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M1758.954 985.422c-1.904 2.46-1.844 6 .346 8.127l715.049 697.004c2.203 2.13 5.606 1.965 7.586-.375 2.01-2.354 1.845-5.982-.343-8.127l-715.053-696.988a5.367 5.367 0 0 0-2.592-1.41s-3.09-.66-4.993 1.77z'/%3e%3cpath fill='%23d32011' d='M2493.826 1576.912c-3.313 38.97-22.491 67.534-21.337 113.867l-94.87-92.53c11.097-15.88 30.32-48.162 34.938-87.567 45.448 36.526 81.269 66.23 81.269 66.23'/%3e%3cpath fill='%2300702d' d='m2303.353 1525.796-106.836-104.226c12.282-10.377 20.514-28.812 29.24-44.255 3.48-6.088 46.392 24.058 96.908 62.668-.014 15.79 1.034 35.147-19.312 85.813'/%3e%3cpath fill='%23f0e53c' d='m2377.62 1598.249-74.267-72.452c20.346-50.666 19.298-70.025 19.313-85.813 29.494 22.536 61.553 47.937 89.892 70.698-4.62 39.405-23.842 71.688-34.938 87.567'/%3e%3cg clip-path='url(%23c)' opacity='.25'%3e%3cpath d='M2466.747 1676.684c-27.246-67.354-128.742-171.325-255.01-253.194 58.794 24.53 198.87 135.684 223.852 167.232 31.832 40.185 31.158 85.962 31.158 85.962'/%3e%3c/g%3e%3cpath fill='%23473125' d='M1696.637 1077.518c-1.8.18-3.493 1.29-4.364 3.15-1.349 2.847-.27 6.296 2.37 7.736l876.554 473.003c2.653 1.425 5.893.286 7.212-2.549 1.334-2.834.27-6.282-2.369-7.72l-876.553-473.02a5.397 5.397 0 0 0-2.85-.6'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M1696.637 1077.518c-1.8.18-3.493 1.29-4.364 3.15-1.349 2.847-.27 6.296 2.37 7.736l876.554 473.003c2.653 1.425 5.893.286 7.212-2.549 1.334-2.834.27-6.282-2.369-7.72l-876.553-473.02a5.397 5.397 0 0 0-2.85-.6z'/%3e%3cpath fill='%23f0e53c' d='m2501.098 1234.299 54.534 2.729-4.018 91.945-54.536-2.73z'/%3e%3cpath fill='%23d32011' d='M2163.89 1181.188c45.148-48.37 131.456-130.149 245.877-115.846 61.328 7.677 96.653 30.47 125.397 59.558 28.761 29.06 16.151 32.237 34.922 45.464 18.79 13.224 23.557 49.99 23.796 50.77.226.78-1.529 13.734 7.378 28.758 8.892 15.025 10.301 37.756 7.347 45.074-2.954 7.316 5.323 29.99 5.084 36.136-.24 6.117-6.868 25.7-7.978 34.847-1.095 9.176-3.194 30.078-3.194 30.078-1.994 32.411-18.127 155.5-15.339 175.697l-78.96-41.819c3.284-58.014 8.712-177.84 15.82-195.384 7.121-17.543 20.976-37.756 12.294-51.82-21.516-34.818 9.852-39.405-20.976-47.082-21.023-5.248-351.469-54.43-351.469-54.43'/%3e%3cg clip-path='url(%23d)' opacity='.25'%3e%3cpath d='M2613.691 1331.102c-.24 6.117-6.868 25.7-7.978 34.847-1.095 9.176-3.194 30.078-3.194 30.078-.689 11.268-3.088 33.505-5.817 58.561-9.072-15.819-18.338-36.45-17.979-44.564.541-12.377-25.985-34.448-52.525-48.034-3.597-1.86-5.652-2.968-6.507-3.569.031-.21.045-.358.075-.569 4.814.54 41.684 13.404 61.641 7.048 26.225-8.338 32.584-18.054 16.09-29.06-12.836-8.546-40.035-19.702-62.572-25.46-6.402-1.649-12.446-2.879-17.663-3.449-23.556-2.579-44.653-28.19-2.774-18.412 8.082 1.888 16.344 4.557 24.411 7.526 33.752 12.356 64.205 29.87 64.491 16.884.315-14.635-14.29-46.422-73.892-64.775-6.029-1.86-12.506-3.57-19.479-5.128-27.228-6.028-39.046-11.397-41.818-15.474-4.964-7.348 19.267-10.587 37.036-6.239 27.663 6.748 93.113 18.473 79.74-3.688-13.375-22.162-69.724-28.82-100.613-27.29-30.903 1.53-9.836-21.202 15.265-21.503 25.115-.268 37.71 5.818 37.231-9.625-.735-23.81-111.229-153.482-273.798-40.575-24.62 17.094-45.642 20.574-57.547 25.101 48.116-36.347 118.755-89.097 204.252-78.39 61.328 7.676 96.653 30.468 125.398 59.557 28.76 29.06 12.22 29.27 31.007 42.464 18.775 13.225 27.471 52.99 27.71 53.77.226.78-1.529 13.734 7.378 28.758 8.892 15.025 10.301 37.756 7.347 45.074-2.954 7.316 5.323 29.99 5.084 36.136'/%3e%3c/g%3e%3cg clip-path='url(%23e)' opacity='.25'%3e%3cpath d='M2524.73 1436.834c-13.12-33.362 16.552-13.599 42.27 11.546 10.854 10.617 19.941 18.923 27.647 25.116-1.35 12.594-2.697 25.355-3.883 37.396-25.416-20.888-56.588-50.02-66.035-74.058'/%3e%3c/g%3e%3cg clip-path='url(%23f)' opacity='.25'%3e%3cpath d='M2582.681 1545.138c-14.304-22.4-34.17-46.332-74.295-68.075-40.126-21.755.074-1.543.074-1.543l8.052 31.233c21.651 10.841 77.341 55.9 66.17 38.385'/%3e%3c/g%3e%3cpath fill='%23473125' d='M1716.954 1022.999c-1.798-.091-3.613.78-4.692 2.52-1.68 2.637-1.02 6.208 1.424 7.976l813.158 588.58c2.459 1.785 5.801 1.08 7.452-1.544 1.665-2.624 1.019-6.193-1.425-7.977l-813.158-588.595c-.854-.601-1.8-.931-2.759-.96'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M1716.954 1022.999c-1.798-.091-3.613.78-4.692 2.52-1.68 2.637-1.02 6.208 1.424 7.976l813.158 588.58c2.459 1.785 5.801 1.08 7.452-1.544 1.665-2.624 1.019-6.193-1.425-7.977l-813.158-588.595c-.854-.601-1.8-.931-2.759-.96z'/%3e%3cpath fill='%23d32011' d='M2081.062 1312.329c-.135.21-.284.42-.42.6.12-.21.269-.39.42-.6'/%3e%3cpath fill='%2300702d' d='M2267.322 1218.82c35.161-.54 53.919 13.437 64.504 17.034 10.602 3.63 21.863 24.89 25.611 37.365 3.764 12.447 7.888 16.496 9.087 21.923 1.199 5.457.27 10.016 0 16.135-.255 6.117 4.078 21.682 4.333 32.446.24 10.738-14.184 29.21-11.41 47.743 2.773 18.57-1.17 42.92-9.117 60.943-5.113 11.562-6.523 26.467-6.853 39.512l-131.98-95.506c42.419-34.788-8.127-157.772-96.487-88.53-4.395 1.622-14.126 11.548-27.71 10.888-7.768-.39-7.947-2.908-6.688-4.978 38.565-6.567 65.45-43.483 98.093-68.704 32.657-25.221 53.47-25.73 88.617-26.27'/%3e%3cpath fill='%23d32011' d='M2536.26 1397.226c.3 9.23-1.485 33.686-3.989 42.008-2.518 8.306-8.276 8.785-7.24 34.157 1.048 25.385 1.228 37.665.208 44.518-1.02 6.853 7.377 54.04-1.8 103.476l-88.3-63.905c3.179-18.204 4.858-51.672 6.356-59.109 1.83-9.116 8.518-31.038 6.328-46.498-2.188-15.458 7.438-38.759 10.527-43.963 3.09-5.217-1.334-51.467-4.798-70.84-3.448-19.343 8.052-36.437.479-59.827-13.945-58.239-68.54-121.604-140.766-125.984-72.228-4.377-159.614 75.661-176.903 93.956-16.63 17.633-37.426 40.724-53.77 64.895-2.804 0-12.656-.57-11.051-9.056 1.875-9.867-10.257 4.858-2.354-11.606 7.886-16.493 47.337-65.946 79.575-98.094 32.223-32.147 107.06-104.899 205.003-97.132 78.599 6.236 126.087 51.58 137.843 94.374 3.568 12.985 26.014 28.158 27.423 45.104 1.41 16.943-5.907 20.421 2.684 36.975 8.593 16.523 9.807 28.07 10.047 32.717.735 15.175 7.197 31.818 7.092 67.115-.045 16.553-2.908 17.484-2.594 26.72'/%3e%3cpath fill='%23f0e53c' d='m2080.612 1312.989.03-.06-.03.06m.45-.66c.494-.75 1.02-1.47 1.529-2.22.45 0 .75-.028.75-.028s-1.32.989-2.28 2.248'/%3e%3cpath fill='%23f0e53c' d='M2313.264 1151.26c72.228 4.38 126.821 67.744 140.766 125.982 7.573 23.391-3.927 40.485-.479 59.828 3.464 19.373 7.888 65.623 4.798 70.84-3.089 5.203-12.715 28.505-10.526 43.963 2.19 15.46-4.497 37.382-6.329 46.497-1.498 7.438-3.177 40.906-6.356 59.11l-91.66-66.366c.33-13.045 1.738-27.949 6.851-39.51 7.948-18.024 11.891-42.374 9.118-60.945-2.775-18.532 11.65-37.005 11.41-47.742-.255-10.765-4.588-26.33-4.333-32.447.27-6.118 1.2-10.677 0-16.134-1.199-5.428-5.323-9.476-9.087-21.923-3.748-12.475-15.009-33.736-25.61-37.366-10.586-3.598-29.344-17.572-64.505-17.032-35.148.54-55.96 1.05-88.618 26.27-32.642 25.22-59.527 62.136-98.093 68.703l.031-.059c.135-.18.284-.39.42-.6.96-1.259 2.28-2.249 2.28-2.249s-.302.03-.75.03c16.343-24.17 37.14-47.262 53.77-64.895 17.288-18.295 104.674-98.333 176.902-93.956'/%3e%3cg clip-path='url(%23g)' opacity='.25'%3e%3cpath d='M2230.33 1391.89c117.092 60.33 282.044 190.585 288.027 217.74.299-23.002-102.215-154.727-288.026-217.74'/%3e%3c/g%3e%3cg clip-path='url(%23h)' opacity='.25'%3e%3cpath d='M2518.927 1547.507c-17.154-35.252-96.25-140.362-230.748-167.045 52.21 3.12 226.265 56.343 230.748 167.045'/%3e%3c/g%3e%3cg clip-path='url(%23i)' opacity='.25'%3e%3cpath d='M2521.236 1494.683c13.87-36.136-57.924-183.972-236.7-161.841 74.521 1.019 198.403 54.039 236.7 161.84'/%3e%3c/g%3e%3cg clip-path='url(%23j)' opacity='.25'%3e%3cpath d='M2528.283 1432.127c-2.969-30.844-86.231-143.218-245.518-124.326 31.668-19.133 177.039-15.084 238.021 65.945 9.401 14.725 15.443 40.359 7.497 58.38'/%3e%3c/g%3e%3cg clip-path='url(%23k)' opacity='.25'%3e%3cpath d='M2534.07 1365.888c-10.945-29.179-50.515-107.869-208.436-87.387 43.11-18.563 146.315-34.126 195.496 22.072 8.862 10.407 12.94 65.315 12.94 65.315'/%3e%3c/g%3e%3cg clip-path='url(%23l)' opacity='.25'%3e%3cpath d='M2305.722 1265.217c117.436-36.316 159.824-21.92 208.091 5.817-.795-14.604-56.678-100.283-208.09-5.817'/%3e%3c/g%3e%3cg clip-path='url(%23m)' opacity='.25'%3e%3cpath d='M2504.052 1215.286c-16.703-11.576-119.16-45.853-265.806 61.117 27.322-34.697 120.72-104.421 223.132-101.601 15.774.03 18.247-.87 16.208-9.927 8.878 9.656 7.889 16.493 11.803 25.13 3.927 8.636 14.662 25.28 14.662 25.28'/%3e%3c/g%3e%3cg clip-path='url(%23n)' opacity='.25'%3e%3cpath d='M2465.277 1151.2c-17.454-6.088-165.343-22.852-263.525 123.374 11.56-34.697 60.142-128.952 162.733-146.824 33.272-4.14 77.655-21.443 100.792 23.45'/%3e%3c/g%3e%3cg clip-path='url(%23o)' opacity='.25'%3e%3cpath d='M2095.456 1292.357c51.596-111.049 214.014-209.44 305.734-184.25-28.234-11.516-115.336-21.203-186.453 33.616-71.105 54.85-119.28 150.634-119.28 150.634'/%3e%3c/g%3e%3cg clip-path='url(%23p)' opacity='.33'%3e%3cpath d='M2176.666 1287.56c-9.491-2.97 23.376-22.884 20.213-16.135-3.165 6.746-4.934 14.334-.676 15.323 4.275.991 17.918-15.984 10.737.54-7.168 16.525 22.715-11.156 22.715-11.156s-6.777 7.347-2.428 12.176c4.334 4.8 40.125-21.8 40.125-21.8s-15.01 15.382-23.107 26.93c-8.097 11.543 35.733-4.05 35.733-4.05s-7.184.42-24.306 14.904c-17.124 14.485 24.739 8.158 24.739 8.158s-3.193 7.496-16.448 15.143c-13.24 7.647 35.147 16.494 35.147 16.494s-26.165 7.887-32.222 15.264c-6.06 7.348 36.076 11.006 23.21 10.347-32.538-1.62-71.57 18.802-70.354 16.433 13.195-25.4 8.442-82.439-43.078-98.572'/%3e%3c/g%3e%3cpath fill='%23cacaca' d='M2545.271 1624.894c7.092 3.6 11.396-.735 15.055-4.813 8.172 23.78 36.931 45.657 44.307 51.835-8.127-4.978-37.904-25.265-61.565-24.396 2.158-5.158 4.288-11.05-1.485-16.733z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M2545.271 1624.894c7.092 3.6 11.396-.735 15.055-4.813 8.172 23.78 36.931 45.657 44.307 51.835-8.127-4.978-37.904-25.265-61.565-24.396 2.158-5.158 4.288-11.05-1.485-16.733z'/%3e%3cpath fill='%23cacaca' d='M2537.16 1633.515c3.014 2.174 7.437.795 9.866-3.074 2.445-3.867 1.964-8.787-1.05-10.946-3.014-2.174-7.437-.793-9.867 3.074-2.442 3.883-1.978 8.787 1.05 10.946'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M2537.16 1633.515c3.014 2.174 7.437.795 9.866-3.074 2.445-3.867 1.964-8.787-1.05-10.946-3.014-2.174-7.437-.793-9.867 3.074-2.442 3.883-1.978 8.787 1.05 10.946zm6.538 13.645 16.537-26.314'/%3e%3cpath fill='%23cacaca' d='M2536.364 1622.764c-6.896 10.977-7.661 24.441-3.134 35.777-9.911-10.676-11.755-27.679-3.596-40.635 8.14-12.954 23.554-17.544 36.525-11.74-11.516-.21-22.896 5.608-29.795 16.598'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M2536.364 1622.764c-6.896 10.977-7.661 24.441-3.134 35.777-9.911-10.676-11.755-27.679-3.596-40.635 8.14-12.954 23.554-17.544 36.525-11.74-11.516-.21-22.896 5.608-29.795 16.598z'/%3e%3cpath fill='%23f0e53c' d='m2531.027 1510.591 3.51.54c-2.566 18.923-1.996 86.263-1.336 96.46l-3.539.253c-.674-10.54-1.289-77.655 1.365-97.253'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='m2531.027 1510.591 3.51.54c-2.566 18.923-1.996 86.263-1.336 96.46l-3.539.253c-.674-10.54-1.289-77.655 1.365-97.253z'/%3e%3cpath fill='%23f0e53c' d='M2527.038 1500.545c-.66 95.274 1.005 101.347 2.505 106.701.194.749.419 1.529.629 2.518l-3.464.824a29.466 29.466 0 0 0-.57-2.263c-1.618-5.893-3.313-11.965-2.64-107.809z'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M2527.038 1500.545c-.66 95.274 1.005 101.347 2.505 106.701.194.749.419 1.529.629 2.518l-3.464.824a29.466 29.466 0 0 0-.57-2.263c-1.618-5.893-3.313-11.965-2.64-107.809z'/%3e%3cpath fill='%23f0e53c' d='M2524.564 1625.763c1.14-4.692 3.554-10.572 8.742-14.694 5.188-4.138.404-8.036-2.984-5.293-3.373 2.758-9.042 9.011-9.146 13.735-.106 4.738 1.394 6.447 3.388 6.252'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M2524.564 1625.763c1.14-4.692 3.554-10.572 8.742-14.694 5.188-4.138.404-8.036-2.984-5.293-3.373 2.758-9.042 9.011-9.146 13.735-.106 4.738 1.394 6.447 3.388 6.252z'/%3e%3cpath fill='%23f0e53c' d='M2536.32 1510.861c2.25-5.638 11.666-38.82 15.325-41.475-4.799-1.662-8.097-2.067-11.096-4.347-3-2.294-3.855-3.043-7.183-2.968 0 0-6.807 39.24-3.839 47.202z'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M2536.32 1510.861c2.25-5.638 11.666-38.82 15.325-41.475-4.799-1.662-8.097-2.067-11.096-4.347-3-2.294-3.855-3.043-7.183-2.968 0 0-6.807 39.24-3.839 47.202z'/%3e%3cpath fill='none' stroke='%23473125' stroke-linecap='round' stroke-width='1.556' d='m2531.7 1509.782 8.864-32.657m1.243 9.67 4.89-18.952m-7.017-3.463-8.819 38.325'/%3e%3cpath fill='%23f0e53c' d='M2527.953 1509.917c.225-1.68 2.58-2.699 5.248-2.278 2.669.403 4.648 2.114 4.424 3.792-.226 1.68-2.58 2.7-5.248 2.294-2.67-.419-4.65-2.114-4.424-3.808'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M2527.953 1509.917c.225-1.68 2.58-2.699 5.248-2.278 2.669.403 4.648 2.114 4.424 3.792-.226 1.68-2.58 2.7-5.248 2.294-2.67-.419-4.65-2.114-4.424-3.808z'/%3e%3cpath fill='%23f0e53c' d='M2529.213 1500.651c1.44-6.957 3.014-7.588 5.952-44.414-5.232-1.693-6.686 1.095-9.146 1.68-2.458.585-10.511-2.759-10.33 3.223.179 5.984 4.812 35.507 7.36 39.212z'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M2529.213 1500.651c1.44-6.957 3.014-7.588 5.952-44.414-5.232-1.693-6.686 1.095-9.146 1.68-2.458.585-10.511-2.759-10.33 3.223.179 5.984 4.812 35.507 7.36 39.212z'/%3e%3cpath fill='none' stroke='%23473125' stroke-linecap='round' stroke-width='1.556' d='m2528.057 1487.156-.284-23.946m3.509 5.862.599-13.375m-6.057 42.239-2.594-26.885m-4.53-7.721-.044-5.759'/%3e%3cpath fill='%23f0e53c' d='M2520.126 1501.041c-.016-1.71 2.159-3.105 4.858-3.134 2.7-.015 4.889 1.334 4.905 3.043.013 1.695-2.161 3.09-4.86 3.12-2.698.03-4.887-1.336-4.903-3.029'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M2520.126 1501.041c-.016-1.71 2.159-3.105 4.858-3.134 2.7-.015 4.889 1.334 4.905 3.043.013 1.695-2.161 3.09-4.86 3.12-2.698.03-4.887-1.336-4.903-3.029z'/%3e%3cpath fill='%23cacaca' d='M2492.207 1696.178c6.552 4.647 11.395 1.019 15.55-2.445 4.887 24.77 30.423 50.846 36.9 58.089-7.378-6.164-34.128-30.815-57.653-33.603 2.835-4.768 5.727-10.271.765-16.78z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M2492.207 1696.178c6.552 4.647 11.395 1.019 15.55-2.445 4.887 24.77 30.423 50.846 36.9 58.089-7.378-6.164-34.128-30.815-57.653-33.603 2.835-4.768 5.727-10.271.765-16.78z'/%3e%3cpath fill='%23cacaca' d='M2483.03 1703.465c2.699 2.609 7.242 1.933 10.182-1.53 2.922-3.463 3.118-8.381.434-11.005-2.699-2.612-7.257-1.92-10.197 1.528-2.923 3.464-3.118 8.396-.419 11.006'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M2483.03 1703.465c2.699 2.609 7.242 1.933 10.182-1.53 2.922-3.463 3.118-8.381.434-11.005-2.699-2.612-7.257-1.92-10.197 1.528-2.923 3.464-3.118 8.396-.419 11.006zm4.634 14.499 19.897-23.497'/%3e%3cpath fill='%23cacaca' d='M2483.69 1692.698c-8.307 9.791-10.87 23.016-7.918 34.921-8.366-12.085-7.9-29.194 1.89-40.77 9.806-11.56 25.671-13.734 37.725-5.997-11.349-1.979-23.39 2.04-31.697 11.846'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M2483.69 1692.698c-8.307 9.791-10.87 23.016-7.918 34.921-8.366-12.085-7.9-29.194 1.89-40.77 9.806-11.56 25.671-13.734 37.725-5.997-11.349-1.979-23.39 2.04-31.697 11.846z'/%3e%3cpath fill='%23f0e53c' d='M2471.74 1578.35c-1.2 95.275.435 101.348 1.904 106.716.195.764.404 1.545.599 2.535l-3.448.794c-.18-.87-.36-1.545-.555-2.264-1.604-5.908-3.254-11.996-2.055-107.824z'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M2471.74 1578.35c-1.2 95.275.435 101.348 1.904 106.716.195.764.404 1.545.599 2.535l-3.448.794c-.18-.87-.36-1.545-.555-2.264-1.604-5.908-3.254-11.996-2.055-107.824z'/%3e%3cpath fill='%23f0e53c' d='M2471.605 1693.853c1.753-4.468 4.933-9.911 10.63-13.195 5.683-3.298 1.47-7.902-2.248-5.698-3.705 2.22-10.166 7.528-10.902 12.19-.75 4.664.525 6.583 2.52 6.703'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M2471.605 1693.853c1.753-4.468 4.933-9.911 10.63-13.195 5.683-3.298 1.47-7.902-2.248-5.698-3.705 2.22-10.166 7.528-10.902 12.19-.75 4.664.525 6.583 2.52 6.703z'/%3e%3cpath fill='%23f0e53c' d='M2473.914 1578.486c1.483-6.957 3.059-7.586 6.207-44.383-5.233-1.724-6.702 1.05-9.161 1.62-2.46.57-10.496-2.819-10.347 3.148.135 5.983 4.618 35.553 7.138 39.256z'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M2473.914 1578.486c1.483-6.957 3.059-7.586 6.207-44.383-5.233-1.724-6.702 1.05-9.161 1.62-2.46.57-10.496-2.819-10.347 3.148.135 5.983 4.618 35.553 7.138 39.256z'/%3e%3cpath fill='none' stroke='%23473125' stroke-linecap='round' stroke-width='1.556' d='m2472.834 1564.976-.15-23.945m3.478 5.877.66-13.359m-6.298 42.193-2.43-26.915m-4.497-7.737v-5.757'/%3e%3cpath fill='%23f0e53c' d='M2464.812 1578.8c0-1.693 2.174-3.087 4.873-3.087 2.698-.015 4.888 1.348 4.903 3.059 0 1.709-2.189 3.088-4.874 3.088-2.699.015-4.886-1.364-4.902-3.06'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M2464.812 1578.8c0-1.693 2.174-3.087 4.873-3.087 2.698-.015 4.888 1.348 4.903 3.059 0 1.709-2.189 3.088-4.874 3.088-2.699.015-4.886-1.364-4.902-3.06z'/%3e%3cpath fill='%23cacaca' d='M2607.783 1571.62c7.467 2.593 11.216-2.28 14.35-6.824 10.93 22.462 42.058 40.245 50.11 45.358-8.65-3.823-40.589-19.882-63.95-15.804 1.529-5.397 2.924-11.544-3.48-16.39z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M2607.783 1571.62c7.467 2.593 11.216-2.28 14.35-6.824 10.93 22.462 42.058 40.245 50.11 45.358-8.65-3.823-40.589-19.882-63.95-15.804 1.529-5.397 2.924-11.544-3.48-16.39z'/%3e%3cpath fill='%23cacaca' d='M2600.75 1581.276c3.255 1.738 7.483-.226 9.433-4.41 1.949-4.167.898-8.965-2.34-10.705-3.27-1.739-7.482.224-9.431 4.393-1.965 4.184-.915 8.982 2.339 10.722'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M2600.75 1581.276c3.255 1.738 7.483-.226 9.433-4.41 1.949-4.167.898-8.965-2.34-10.705-3.27-1.739-7.482.224-9.431 4.393-1.965 4.184-.915 8.982 2.339 10.722zm8.112 12.624 13.271-28.354'/%3e%3cpath fill='%23cacaca' d='M2598.681 1570.704c-5.532 11.831-4.679 25.295 1.154 35.926-11.094-9.236-14.949-25.864-8.41-39.824 6.537-13.96 21.276-20.602 34.83-16.615-11.44 1.35-22.025 8.683-27.574 20.513'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M2598.681 1570.704c-5.532 11.831-4.679 25.295 1.154 35.926-11.094-9.236-14.949-25.864-8.41-39.824 6.537-13.96 21.276-20.602 34.83-16.615-11.44 1.35-22.025 8.683-27.574 20.513z'/%3e%3cpath fill='%23f0e53c' d='m2598.277 1451.379 3.448.81c-3.838 19.912-7.827 91.48-7.856 102.351l-3.539.03c.03-11.245 3.958-82.544 7.947-103.191'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.605' d='m2598.277 1451.379 3.448.81c-3.838 19.912-7.827 91.48-7.856 102.351l-3.539.03c.03-11.245 3.958-82.544 7.947-103.191z'/%3e%3cpath fill='%23f0e53c' d='M2594.962 1440.449c-7.105 101.12-5.831 107.689-4.723 113.477.166.809.33 1.648.466 2.714l-3.51.645a37.66 37.66 0 0 0-.404-2.444c-1.23-6.358-2.505-12.926 4.634-114.663z'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.605' d='M2594.962 1440.449c-7.105 101.12-5.831 107.689-4.723 113.477.166.809.33 1.648.466 2.714l-3.51.645a37.66 37.66 0 0 0-.404-2.444c-1.23-6.358-2.505-12.926 4.634-114.663z'/%3e%3cpath fill='%23f0e53c' d='M2587.345 1575.292c.557-4.813 2.266-10.96 6.929-15.759 4.648-4.812-.571-8.037-3.6-4.843-3.013 3.194-7.901 10.166-7.435 14.875.449 4.707 2.158 6.192 4.106 5.727'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M2587.345 1575.292c.557-4.813 2.266-10.96 6.929-15.759 4.648-4.812-.571-8.037-3.6-4.843-3.013 3.194-7.901 10.166-7.435 14.875.449 4.707 2.158 6.192 4.106 5.727z'/%3e%3cpath fill='%23f0e53c' d='M2603.614 1451.379c2.564-5.458 13.991-37.906 17.814-40.32-4.694-1.979-7.962-2.624-10.826-5.097-2.85-2.49-3.659-3.3-6.988-3.464 0 0-9.19 38.671-6.702 46.842z'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M2603.614 1451.379c2.564-5.458 13.991-37.906 17.814-40.32-4.694-1.979-7.962-2.624-10.826-5.097-2.85-2.49-3.659-3.3-6.988-3.464 0 0-9.19 38.671-6.702 46.842z'/%3e%3cpath fill='none' stroke='%23473125' stroke-linecap='round' stroke-width='1.556' d='m2599.055 1449.985 10.826-31.969m.661 9.732 6.042-18.562m-6.791-3.944-11.141 37.62'/%3e%3cpath fill='%23f0e53c' d='M2595.307 1449.865c.33-1.665 2.744-2.52 5.368-1.919 2.654.6 4.528 2.442 4.184 4.093-.33 1.665-2.73 2.518-5.367 1.92-2.64-.6-4.515-2.429-4.185-4.094'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M2595.307 1449.865c.33-1.665 2.744-2.52 5.368-1.919 2.654.6 4.528 2.442 4.184 4.093-.33 1.665-2.73 2.518-5.367 1.92-2.64-.6-4.515-2.429-4.185-4.094z'/%3e%3cpath fill='%23f0e53c' d='M2597.123 1440.719c1.873-6.853 3.478-7.378 8.65-43.912-5.127-2.07-6.731.63-9.22 1.02-2.504.419-10.331-3.48-10.511 2.519-.18 5.96 2.639 35.754 4.962 39.622z'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M2597.123 1440.719c1.873-6.853 3.478-7.378 8.65-43.912-5.127-2.07-6.731.63-9.22 1.02-2.504.419-10.331-3.48-10.511 2.519-.18 5.96 2.639 35.754 4.962 39.622z'/%3e%3cpath fill='none' stroke='%23473125' stroke-linecap='round' stroke-width='1.556' d='m2596.807 1427.163 1.17-23.916m-4.063 34.518-.944-27.02m-4.065-8.008.314-5.75'/%3e%3cpath fill='%23f0e53c' d='M2588.036 1440.449c.089-1.695 2.339-2.924 5.038-2.774 2.699.165 4.798 1.664 4.707 3.373-.09 1.694-2.338 2.94-5.037 2.774-2.7-.15-4.8-1.664-4.708-3.373'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M2588.036 1440.449c.089-1.695 2.339-2.924 5.038-2.774 2.699.165 4.798 1.664 4.707 3.373-.09 1.694-2.338 2.94-5.037 2.774-2.7-.15-4.8-1.664-4.708-3.373z'/%3e%3cpath d='M2519.766 1357.852c-.03.211-.044.36-.075.57-.645-.48-.585-.63.075-.57'/%3e%3cpath fill='%23d32011' d='M2085.066 1270.466c13.12-49.992 49.945-142.507 50.216-271.398.464-10.345 15.383-15.354 15.188-25.13-.209-9.807-3.238-9.957.751-17.245 2.294 7.019 9.7 9.687 9.402 16.584-.3 6.897-6.374 22.701.36 28.79 6.716 6.086 16.073 13.464 12.953 35.745-3.134 22.313-54.594 215.38-81.104 231.334-26.509 15.924-7.766 1.32-7.766 1.32'/%3e%3cpath fill='%2300702d' d='M2219.37 1017.577c1.305 6.957-6.388 25.094 1.064 26.594 7.467 1.529 19.553 7.888 15.22 20.9-4.335 13.046-32.134 74.073-60.772 110.929-28.64 36.856-58.358 67.835-58.358 67.835 16.478-44.622 68.059-197.175 73.666-221.317 2.655-11.365 29.18-4.941 29.18-4.941'/%3e%3cg clip-path='url(%23q)' opacity='.25'%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-width='3.334' d='M2159.722 1018.41c-6.327-9.327-27.395-12.895-17.709-25.34'/%3e%3c/g%3e%3cg clip-path='url(%23r)' opacity='.25'%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-width='3.334' d='M2203.281 1030.766c-11.081 5.667 27.38 37.814 29.208 30.618 2.055-8.486-6.673-9.476-6.088-12.025'/%3e%3c/g%3e%3cpath fill='%23f0e53c' d='M2102.368 1247.733c12.835-35.025 47.727-144.335 48.881-195.495.51-11.487 21.383-9.297 16.93-18.143-4.454-8.878-17.153-13.525-7.197-32.029 8.426 3.869 23.466 8.098 22.43-6.928-1.035-15.024 6.837-10.585 10.481-8.096 3.66 2.489 12.146 5.188 4.29 12.866-7.874 7.677-1.095 12.594 5.878 12.954 6.972.36 12.925-.51 14.904 3.63 1.964 4.106-1.859 5.667-6.179 6.026-4.317.36-27.514 14.155-22.49 22.462 5.007 8.308 12.415 10.977 8.651 23.451-3.778 12.476-43.079 111.769-65.525 145.745-22.462 34.007-31.054 33.557-31.054 33.557'/%3e%3cpath fill='%23f0e53c' d='M2184.942 1284.38c-2.999-34.816-5.113-114.107-5.623-128.473-.494-14.363-27.604-49.84-29.957-27.288-2.369 22.58 15.562 150.003 15.562 150.003z'/%3e%3cpath fill='%2300702d' d='M2172.302 1287.468c-7.542-49.69-12.64-178.492-25.7-182.092-13.06-3.568-21.067-2.608-24.89 8.518-3.824 11.125 12.55 66.126 12.55 66.126l19.763 68.613 5.937 39.436z'/%3e%3cg clip-path='url(%23s)' opacity='.25'%3e%3cpath d='M2115.473 1106.937c14.53.21 18.818 0 27.965 49.032 9.131 49.031 14.155 90.206 20.992 86.427 6.808-3.81 11.741-1.71 13.734 6.807 1.98 8.516 9.163 31.19 6.944 38.775-2.235 7.587-28.595 4.38-28.595 4.38l-23.392-101.782z'/%3e%3c/g%3e%3cpath fill='%23d32011' d='M1758.144 1576.912c3.313 38.97 22.491 67.534 21.336 113.867l94.87-92.53c-11.096-15.88-30.319-48.162-34.938-87.567-45.447 36.526-81.268 66.23-81.268 66.23'/%3e%3cpath fill='%2300702d' d='m1948.632 1525.796 106.819-104.226c-12.28-10.377-20.511-28.812-29.24-44.255-3.476-6.088-46.39 24.058-96.907 62.668.016 15.79-1.035 35.147 19.328 85.813'/%3e%3cpath fill='%23f0e53c' d='m1874.35 1598.249 74.282-72.452c-20.364-50.666-19.313-70.025-19.329-85.813-29.494 22.536-61.552 47.937-89.89 70.698 4.618 39.405 23.841 71.688 34.936 87.567'/%3e%3cg clip-path='url(%23t)' opacity='.25'%3e%3cpath d='M1785.223 1676.684c27.246-67.354 128.742-171.325 255.009-253.194-58.793 24.53-198.869 135.684-223.851 167.232-31.832 40.185-31.158 85.962-31.158 85.962'/%3e%3c/g%3e%3cpath fill='%23f0e53c' d='m1750.871 1234.299-54.533 2.729 4.018 91.945 54.535-2.73z'/%3e%3cpath fill='%23d32011' d='M2088.078 1181.188c-45.147-48.37-131.455-130.149-245.876-115.846-61.327 7.677-96.653 30.47-125.398 59.558-28.76 29.06-16.149 32.237-34.92 45.464-18.79 13.224-23.558 49.99-23.797 50.77-.226.78 1.53 13.734-7.378 28.758-8.892 15.025-10.3 37.756-7.347 45.074 2.954 7.316-5.323 29.99-5.084 36.136.24 6.117 6.868 25.7 7.978 34.847 1.094 9.176 3.194 30.078 3.194 30.078 1.993 32.411 18.127 155.5 15.34 175.697l78.96-41.819c-3.285-58.014-8.712-177.84-15.82-195.384-7.123-17.543-20.977-37.756-12.296-51.82 21.518-34.818-9.85-39.405 20.977-47.082 21.023-5.248 351.467-54.43 351.467-54.43'/%3e%3cg clip-path='url(%23u)' opacity='.25'%3e%3cpath d='M1638.279 1331.102c.24 6.117 6.868 25.7 7.978 34.847 1.093 9.176 3.194 30.078 3.194 30.078.689 11.268 3.087 33.505 5.817 58.561 9.072-15.819 18.338-36.45 17.992-44.564-.554-12.377 25.972-34.448 52.512-48.034 3.613-1.86 5.652-2.968 6.507-3.569-.031-.21-.044-.358-.075-.569-4.814.54-41.684 13.404-61.627 7.048-26.24-8.338-32.597-18.054-16.104-29.06 12.835-8.546 40.035-19.702 62.572-25.46 6.402-1.649 12.446-2.879 17.663-3.449 23.556-2.579 44.653-28.19 2.775-18.412-8.083 1.888-16.345 4.557-24.412 7.526-33.751 12.356-64.205 29.87-64.491 16.884-.315-14.635 14.29-46.422 73.892-64.775 6.029-1.86 12.506-3.57 19.479-5.128 27.229-6.028 39.059-11.397 41.818-15.474 4.964-7.348-19.268-10.587-37.035-6.239-27.666 6.748-93.116 18.473-79.741-3.688 13.375-22.162 69.725-28.82 100.613-27.29 30.903 1.53 9.836-21.202-15.265-21.503-25.115-.268-37.71 5.818-37.231-9.625.735-23.81 111.229-153.482 273.798-40.575 24.62 17.094 45.642 20.574 57.547 25.101-48.117-36.347-118.756-89.097-204.252-78.39-61.328 7.676-96.653 30.468-125.398 59.557-28.76 29.06-12.22 29.27-31.008 42.464-18.773 13.225-27.47 52.99-27.71 53.77-.225.78 1.53 13.734-7.377 28.758-8.892 15.025-10.301 37.756-7.347 45.074 2.954 7.316-5.323 29.99-5.084 36.136'/%3e%3c/g%3e%3cg clip-path='url(%23v)' opacity='.25'%3e%3cpath d='M1727.241 1436.834c13.12-33.362-16.555-13.599-42.27 11.546-10.855 10.617-19.942 18.923-27.648 25.116 1.348 12.594 2.697 25.355 3.882 37.396 25.416-20.888 56.588-50.02 66.036-74.058'/%3e%3c/g%3e%3cg clip-path='url(%23w)' opacity='.25'%3e%3cpath d='M1669.288 1545.138c14.304-22.4 34.171-46.332 74.296-68.075 40.125-21.755-.075-1.543-.075-1.543l-8.052 31.233c-21.637 10.841-77.34 55.9-66.169 38.385'/%3e%3c/g%3e%3cpath fill='%23d32011' d='M2170.908 1312.329c.136.21.284.42.42.6-.12-.21-.271-.39-.42-.6'/%3e%3cpath fill='%2300702d' d='M1984.648 1218.015c-35.161-.54-53.92 13.435-64.506 17.032-10.6 3.63-21.861 24.891-25.61 37.366-3.762 12.447-7.886 16.496-9.086 21.923-1.2 5.457-.27 10.016 0 16.134.27 6.117-4.078 21.682-4.333 32.447-.241 10.737 14.184 29.21 11.41 47.743-2.773 18.57 1.17 42.92 9.117 60.943 5.113 11.562 6.523 26.466 6.853 39.511l131.98-95.506c-42.42-34.788 8.127-157.77 96.487-88.528 4.394 1.621 14.126 11.546 27.71 10.886 7.767-.389 7.947-2.908 6.688-4.977-38.565-6.568-65.435-43.484-98.093-68.704-32.66-25.22-53.47-25.73-88.617-26.27'/%3e%3cpath fill='%23d32011' d='M1715.71 1397.226c-.3 9.23 1.485 33.686 3.989 42.008 2.518 8.306 8.276 8.785 7.24 34.157-1.047 25.385-1.227 37.665-.208 44.518 1.02 6.853-7.377 54.04 1.8 103.476l88.3-63.905c-3.178-18.204-4.858-51.672-6.343-59.109-1.843-9.116-8.53-31.038-6.34-46.498 2.187-15.458-7.438-38.759-10.527-43.963-3.09-5.217 1.334-51.467 4.797-70.84 3.449-19.343-8.051-36.437-.48-59.827 13.946-58.239 68.54-121.604 140.768-125.984 72.227-4.377 159.614 75.661 176.903 93.956 16.628 17.633 37.425 40.724 53.77 64.895 2.804 0 12.655-.57 11.05-9.056-1.874-9.867 10.257 4.858 2.354-11.606-7.888-16.493-47.337-65.946-79.575-98.094-32.222-32.147-107.044-104.899-205.002-97.132-78.6 6.236-126.088 51.58-137.843 94.374-3.568 12.985-26.014 28.158-27.424 45.104-1.41 16.943 5.907 20.421-2.684 36.975-8.592 16.523-9.807 28.07-10.046 32.717-.735 15.175-7.198 31.818-7.094 67.115.047 16.553 2.91 17.484 2.595 26.72'/%3e%3cpath fill='%23f0e53c' d='m2171.358 1312.989-.03-.06.03.06m-.45-.66c-.494-.75-1.02-1.47-1.529-2.22-.45 0-.75-.028-.75-.028s1.32.989 2.279 2.248'/%3e%3cpath fill='%23f0e53c' d='M1938.705 1151.26c-72.228 4.38-126.82 67.744-140.766 125.982-7.573 23.391 3.928 40.485.48 59.828-3.465 19.373-7.888 65.623-4.799 70.84 3.09 5.203 12.715 28.505 10.527 43.963-2.19 15.46 4.497 37.382 6.341 46.497 1.485 7.438 3.164 40.906 6.343 59.11l91.661-66.366c-.33-13.045-1.739-27.949-6.852-39.51-7.948-18.024-11.89-42.374-9.118-60.945 2.775-18.532-11.65-37.005-11.409-47.742.255-10.765 4.603-26.33 4.333-32.447-.27-6.118-1.199-10.677 0-16.134 1.2-5.428 5.323-9.476 9.086-21.923 3.748-12.475 15.01-33.736 25.61-37.366 10.586-3.598 29.344-17.572 64.505-17.032 35.148.54 55.96 1.05 88.617 26.27 32.66 25.22 59.528 62.136 98.094 68.703-.016-.029-.016-.029-.03-.059a9.918 9.918 0 0 1-.42-.6c-.959-1.259-2.28-2.249-2.28-2.249s.301.03.75.03c-16.345-24.17-37.14-47.262-53.77-64.895-17.289-18.295-104.675-98.333-176.903-93.956'/%3e%3cg clip-path='url(%23x)' opacity='.25'%3e%3cpath d='M2021.64 1391.89c-117.092 60.33-282.044 190.585-288.027 217.74-.3-23.002 102.215-154.727 288.026-217.74'/%3e%3c/g%3e%3cg clip-path='url(%23y)' opacity='.25'%3e%3cpath d='M1733.043 1547.507c17.154-35.252 96.25-140.362 230.748-167.045-52.21 3.12-226.265 56.343-230.748 167.045'/%3e%3c/g%3e%3cg clip-path='url(%23z)' opacity='.25'%3e%3cpath d='M1730.734 1494.683c-13.87-36.136 57.924-183.972 236.7-161.841-74.52 1.019-198.39 54.039-236.7 161.84'/%3e%3c/g%3e%3cg clip-path='url(%23A)' opacity='.25'%3e%3cpath d='M1723.686 1432.127c2.97-30.844 86.232-143.218 245.52-124.326-31.669-19.133-177.04-15.084-238.022 65.945-9.402 14.725-15.445 40.359-7.498 58.38'/%3e%3c/g%3e%3cg clip-path='url(%23B)' opacity='.25'%3e%3cpath d='M1717.9 1365.888c10.945-29.179 50.515-107.869 208.436-87.387-43.11-18.563-146.315-34.126-195.482 22.072-8.877 10.407-12.955 65.315-12.955 65.315'/%3e%3c/g%3e%3cg clip-path='url(%23C)' opacity='.25'%3e%3cpath d='M1946.247 1265.217c-117.435-36.316-159.823-21.92-208.091 5.817.796-14.604 56.694-100.283 208.09-5.817'/%3e%3c/g%3e%3cg clip-path='url(%23D)' opacity='.25'%3e%3cpath d='M1747.917 1215.286c16.704-11.576 119.16-45.853 265.806 61.117-27.32-34.697-120.72-104.421-223.132-101.601-15.773.03-18.247-.87-16.208-9.927-8.876 9.656-7.887 16.493-11.801 25.13-3.928 8.636-14.665 25.28-14.665 25.28'/%3e%3c/g%3e%3cg clip-path='url(%23E)' opacity='.25'%3e%3cpath d='M1786.693 1151.2c17.455-6.088 165.343-22.852 263.525 123.374-11.56-34.697-60.142-128.952-162.733-146.824-33.272-4.14-77.655-21.443-100.792 23.45'/%3e%3c/g%3e%3cg clip-path='url(%23F)' opacity='.25'%3e%3cpath d='M2156.513 1292.357c-51.596-111.049-214.014-209.44-305.734-184.25 28.233-11.516 115.336-21.203 186.454 33.616 71.103 54.85 119.28 150.634 119.28 150.634'/%3e%3c/g%3e%3cg clip-path='url(%23G)' opacity='.33'%3e%3cpath d='M2075.304 1287.56c9.492-2.97-23.375-22.884-20.212-16.135 3.164 6.746 4.933 14.334.675 15.323-4.275.991-17.918-15.984-10.737.54 7.168 16.525-22.717-11.156-22.717-11.156s6.778 7.347 2.43 12.176c-4.333 4.8-40.124-21.8-40.124-21.8s15.009 15.382 23.105 26.93c8.098 11.543-35.731-4.05-35.731-4.05s7.183.42 24.306 14.904c17.123 14.485-24.74 8.158-24.74 8.158s3.193 7.496 16.449 15.143c13.239 7.647-35.148 16.494-35.148 16.494s26.165 7.887 32.222 15.264c6.06 7.348-36.076 11.006-23.195 10.347 32.523-1.62 71.568 18.802 70.339 16.433-13.195-25.4-8.443-82.439 43.078-98.572'/%3e%3c/g%3e%3cpath fill='%23cacaca' d='M1706.699 1624.894c-7.092 3.6-11.396-.735-15.055-4.813-8.171 23.78-36.931 45.657-44.307 51.835 8.127-4.978 37.904-25.265 61.565-24.396-2.16-5.158-4.288-11.05 1.5-16.733z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M1706.699 1624.894c-7.092 3.6-11.396-.735-15.055-4.813-8.171 23.78-36.931 45.657-44.307 51.835 8.127-4.978 37.904-25.265 61.565-24.396-2.16-5.158-4.288-11.05 1.5-16.733z'/%3e%3cpath fill='%23cacaca' d='M1714.81 1633.515c-3.014 2.174-7.437.795-9.867-3.074-2.444-3.867-1.964-8.787 1.051-10.946 3.013-2.174 7.437-.793 9.88 3.074 2.43 3.883 1.965 8.787-1.064 10.946'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M1714.81 1633.515c-3.014 2.174-7.437.795-9.867-3.074-2.444-3.867-1.964-8.787 1.051-10.946 3.013-2.174 7.437-.793 9.88 3.074 2.43 3.883 1.965 8.787-1.064 10.946zm-6.538 13.645-16.538-26.314'/%3e%3cpath fill='%23cacaca' d='M1715.605 1622.764c6.897 10.977 7.662 24.441 3.134 35.777 9.911-10.676 11.755-27.679 3.597-40.635-8.14-12.954-23.554-17.544-36.525-11.74 11.515-.21 22.896 5.608 29.794 16.598'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M1715.605 1622.764c6.897 10.977 7.662 24.441 3.134 35.777 9.911-10.676 11.755-27.679 3.597-40.635-8.14-12.954-23.554-17.544-36.525-11.74 11.515-.21 22.896 5.608 29.794 16.598z'/%3e%3cpath fill='%23f0e53c' d='m1720.943 1510.591-3.508.54c2.564 18.923 1.994 86.263 1.334 96.46l3.539.253c.674-10.54 1.29-77.655-1.365-97.253'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='m1720.943 1510.591-3.508.54c2.564 18.923 1.994 86.263 1.334 96.46l3.539.253c.674-10.54 1.29-77.655-1.365-97.253z'/%3e%3cpath fill='%23f0e53c' d='M1724.931 1500.545c.66 95.274-1.005 101.347-2.504 106.701-.194.749-.42 1.529-.613 2.518l3.447.824c.18-.853.36-1.543.57-2.263 1.619-5.893 3.314-11.965 2.639-107.809z'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M1724.931 1500.545c.66 95.274-1.005 101.347-2.504 106.701-.194.749-.42 1.529-.613 2.518l3.447.824c.18-.853.36-1.543.57-2.263 1.619-5.893 3.314-11.965 2.639-107.809z'/%3e%3cpath fill='%23f0e53c' d='M1727.405 1625.763c-1.124-4.692-3.553-10.572-8.74-14.694-5.189-4.138-.406-8.036 2.982-5.293 3.374 2.758 9.042 9.011 9.147 13.735.106 4.738-1.394 6.447-3.389 6.252'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M1727.405 1625.763c-1.124-4.692-3.553-10.572-8.74-14.694-5.189-4.138-.406-8.036 2.982-5.293 3.374 2.758 9.042 9.011 9.147 13.735.106 4.738-1.394 6.447-3.389 6.252z'/%3e%3cpath fill='%23f0e53c' d='M1715.65 1510.861c-2.25-5.638-11.667-38.82-15.325-41.475 4.798-1.662 8.097-2.067 11.096-4.347 3-2.294 3.854-3.043 7.183-2.968 0 0 6.822 39.24 3.838 47.202z'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M1715.65 1510.861c-2.25-5.638-11.667-38.82-15.325-41.475 4.798-1.662 8.097-2.067 11.096-4.347 3-2.294 3.854-3.043 7.183-2.968 0 0 6.822 39.24 3.838 47.202z'/%3e%3cpath fill='none' stroke='%23473125' stroke-linecap='round' stroke-width='1.556' d='m1720.268 1509.782-8.862-32.657m-1.244 9.67-4.889-18.952m7.017-3.463 8.818 38.325'/%3e%3cpath fill='%23f0e53c' d='M1724.016 1509.917c-.224-1.68-2.579-2.699-5.248-2.278-2.669.403-4.648 2.114-4.423 3.792.225 1.68 2.58 2.7 5.248 2.294 2.67-.419 4.65-2.114 4.423-3.808'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M1724.016 1509.917c-.224-1.68-2.579-2.699-5.248-2.278-2.669.403-4.648 2.114-4.423 3.792.225 1.68 2.58 2.7 5.248 2.294 2.67-.419 4.65-2.114 4.423-3.808z'/%3e%3cpath fill='%23f0e53c' d='M1722.758 1500.651c-1.44-6.957-3.014-7.588-5.953-44.414 5.233-1.693 6.687 1.095 9.147 1.68 2.458.585 10.51-2.759 10.33 3.223-.18 5.984-4.812 35.507-7.362 39.212z'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M1722.758 1500.651c-1.44-6.957-3.014-7.588-5.953-44.414 5.233-1.693 6.687 1.095 9.147 1.68 2.458.585 10.51-2.759 10.33 3.223-.18 5.984-4.812 35.507-7.362 39.212z'/%3e%3cpath fill='none' stroke='%23473125' stroke-linecap='round' stroke-width='1.556' d='m1723.912 1487.156.284-23.946m-3.508 5.862-.585-13.375m6.058 42.239 2.578-26.885m4.528-7.721.046-5.759'/%3e%3cpath fill='%23f0e53c' d='M1731.844 1501.041c.016-1.71-2.16-3.105-4.844-3.134-2.713-.015-4.903 1.334-4.918 3.043-.014 1.695 2.16 3.09 4.858 3.12 2.7.03 4.89-1.336 4.904-3.029'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M1731.844 1501.041c.016-1.71-2.16-3.105-4.844-3.134-2.713-.015-4.903 1.334-4.918 3.043-.014 1.695 2.16 3.09 4.858 3.12 2.7.03 4.89-1.336 4.904-3.029z'/%3e%3cpath fill='%23cacaca' d='M1759.763 1696.178c-6.551 4.647-11.396 1.019-15.55-2.445-4.887 24.77-30.422 50.846-36.885 58.089 7.363-6.164 34.113-30.815 57.639-33.603-2.835-4.768-5.727-10.271-.765-16.78z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M1759.763 1696.178c-6.551 4.647-11.396 1.019-15.55-2.445-4.887 24.77-30.422 50.846-36.885 58.089 7.363-6.164 34.113-30.815 57.639-33.603-2.835-4.768-5.727-10.271-.765-16.78z'/%3e%3cpath fill='%23cacaca' d='M1768.94 1703.465c-2.684 2.609-7.243 1.933-10.181-1.53-2.923-3.463-3.12-8.381-.42-11.005 2.684-2.612 7.242-1.92 10.18 1.528 2.925 3.464 3.12 8.396.42 11.006'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M1768.94 1703.465c-2.684 2.609-7.243 1.933-10.181-1.53-2.923-3.463-3.12-8.381-.42-11.005 2.684-2.612 7.242-1.92 10.18 1.528 2.925 3.464 3.12 8.396.42 11.006zm-4.634 14.499-19.897-23.497'/%3e%3cpath fill='%23cacaca' d='M1768.28 1692.698c8.307 9.791 10.87 23.016 7.917 34.921 8.368-12.085 7.902-29.194-1.89-40.77-9.806-11.56-25.67-13.734-37.724-5.997 11.35-1.979 23.39 2.04 31.697 11.846'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M1768.28 1692.698c8.307 9.791 10.87 23.016 7.917 34.921 8.368-12.085 7.902-29.194-1.89-40.77-9.806-11.56-25.67-13.734-37.724-5.997 11.35-1.979 23.39 2.04 31.697 11.846z'/%3e%3cpath fill='%23f0e53c' d='M1780.23 1578.35c1.2 95.275-.435 101.348-1.904 106.716-.195.764-.404 1.545-.6 2.535l3.45.794c.179-.87.359-1.545.554-2.264 1.604-5.908 3.254-11.996 2.055-107.824z'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M1780.23 1578.35c1.2 95.275-.435 101.348-1.904 106.716-.195.764-.404 1.545-.6 2.535l3.45.794c.179-.87.359-1.545.554-2.264 1.604-5.908 3.254-11.996 2.055-107.824z'/%3e%3cpath fill='%23f0e53c' d='M1780.365 1693.853c-1.753-4.468-4.934-9.911-10.63-13.195-5.684-3.298-1.47-7.902 2.248-5.698 3.703 2.22 10.166 7.528 10.902 12.19.75 4.664-.525 6.583-2.52 6.703'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M1780.365 1693.853c-1.753-4.468-4.934-9.911-10.63-13.195-5.684-3.298-1.47-7.902 2.248-5.698 3.703 2.22 10.166 7.528 10.902 12.19.75 4.664-.525 6.583-2.52 6.703z'/%3e%3cpath fill='%23f0e53c' d='M1778.055 1578.486c-1.483-6.957-3.059-7.586-6.208-44.383 5.235-1.724 6.704 1.05 9.162 1.62 2.46.57 10.497-2.819 10.348 3.148-.135 5.983-4.619 35.553-7.138 39.256z'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M1778.055 1578.486c-1.483-6.957-3.059-7.586-6.208-44.383 5.235-1.724 6.704 1.05 9.162 1.62 2.46.57 10.497-2.819 10.348 3.148-.135 5.983-4.619 35.553-7.138 39.256z'/%3e%3cpath fill='none' stroke='%23473125' stroke-linecap='round' stroke-width='1.556' d='m1779.137 1564.976.149-23.945m-3.478 5.877-.66-13.359m6.296 42.193 2.43-26.915m4.498-7.737v-5.757'/%3e%3cpath fill='%23f0e53c' d='M1787.158 1578.8c0-1.693-2.174-3.087-4.874-3.087-2.7-.015-4.887 1.348-4.902 3.059 0 1.709 2.19 3.088 4.874 3.088 2.699.015 4.887-1.364 4.902-3.06'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M1787.158 1578.8c0-1.693-2.174-3.087-4.874-3.087-2.7-.015-4.887 1.348-4.902 3.059 0 1.709 2.19 3.088 4.874 3.088 2.699.015 4.887-1.364 4.902-3.06z'/%3e%3cpath fill='%23cacaca' d='M1644.187 1571.62c-7.467 2.593-11.216-2.28-14.35-6.824-10.931 22.462-42.058 40.245-50.111 45.358 8.652-3.823 40.59-19.882 63.95-15.804-1.528-5.397-2.922-11.544 3.479-16.39z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M1644.187 1571.62c-7.467 2.593-11.216-2.28-14.35-6.824-10.931 22.462-42.058 40.245-50.111 45.358 8.652-3.823 40.59-19.882 63.95-15.804-1.528-5.397-2.922-11.544 3.479-16.39z'/%3e%3cpath fill='%23cacaca' d='M1651.22 1581.276c-3.254 1.738-7.483-.226-9.433-4.41-1.948-4.167-.9-8.965 2.355-10.705 3.254-1.739 7.467.224 9.415 4.393 1.966 4.184.916 8.982-2.338 10.722'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M1651.22 1581.276c-3.254 1.738-7.483-.226-9.433-4.41-1.948-4.167-.9-8.965 2.355-10.705 3.254-1.739 7.467.224 9.415 4.393 1.966 4.184.916 8.982-2.338 10.722zm-8.112 12.624-13.271-28.354'/%3e%3cpath fill='%23cacaca' d='M1653.289 1570.704c5.532 11.831 4.679 25.295-1.155 35.926 11.11-9.236 14.949-25.864 8.41-39.824-6.536-13.96-21.275-20.602-34.83-16.615 11.44 1.35 22.026 8.683 27.575 20.513'/%3e%3cpath fill='none' stroke='%23000' stroke-width='2.223' d='M1653.289 1570.704c5.532 11.831 4.679 25.295-1.155 35.926 11.11-9.236 14.949-25.864 8.41-39.824-6.536-13.96-21.275-20.602-34.83-16.615 11.44 1.35 22.026 8.683 27.575 20.513z'/%3e%3cpath fill='%23f0e53c' d='m1653.693 1451.379-3.45.81c3.84 19.912 7.829 91.48 7.858 102.351l3.539.03c-.03-11.245-3.958-82.544-7.947-103.191'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.605' d='m1653.693 1451.379-3.45.81c3.84 19.912 7.829 91.48 7.858 102.351l3.539.03c-.03-11.245-3.958-82.544-7.947-103.191z'/%3e%3cpath fill='%23f0e53c' d='M1657.008 1440.449c7.106 101.12 5.832 107.689 4.723 113.477-.166.809-.33 1.648-.465 2.714l3.508.645c.12-.93.255-1.665.406-2.444 1.229-6.358 2.504-12.926-4.634-114.663z'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.605' d='M1657.008 1440.449c7.106 101.12 5.832 107.689 4.723 113.477-.166.809-.33 1.648-.465 2.714l3.508.645c.12-.93.255-1.665.406-2.444 1.229-6.358 2.504-12.926-4.634-114.663z'/%3e%3cpath fill='%23f0e53c' d='M1664.623 1575.292c-.554-4.813-2.263-10.96-6.913-15.759-4.663-4.812.557-8.037 3.584-4.843 3.014 3.194 7.903 10.166 7.438 14.875-.45 4.707-2.144 6.192-4.109 5.727'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M1664.623 1575.292c-.554-4.813-2.263-10.96-6.913-15.759-4.663-4.812.557-8.037 3.584-4.843 3.014 3.194 7.903 10.166 7.438 14.875-.45 4.707-2.144 6.192-4.109 5.727z'/%3e%3cpath fill='%23f0e53c' d='M1648.356 1451.379c-2.564-5.458-13.991-37.906-17.814-40.32 4.694-1.979 7.962-2.624 10.826-5.097 2.848-2.49 3.659-3.3 6.988-3.464 0 0 9.19 38.671 6.702 46.842z'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M1648.356 1451.379c-2.564-5.458-13.991-37.906-17.814-40.32 4.694-1.979 7.962-2.624 10.826-5.097 2.848-2.49 3.659-3.3 6.988-3.464 0 0 9.19 38.671 6.702 46.842z'/%3e%3cpath fill='none' stroke='%23473125' stroke-linecap='round' stroke-width='1.556' d='m1652.913 1449.985-10.825-31.969m-.66 9.732-6.043-18.562m6.792-3.944 11.141 37.62'/%3e%3cpath fill='%23f0e53c' d='M1656.662 1449.865c-.33-1.665-2.744-2.52-5.368-1.919-2.655.6-4.528 2.442-4.184 4.093.33 1.665 2.73 2.518 5.369 1.92 2.638-.6 4.513-2.429 4.183-4.094'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M1656.662 1449.865c-.33-1.665-2.744-2.52-5.368-1.919-2.655.6-4.528 2.442-4.184 4.093.33 1.665 2.73 2.518 5.369 1.92 2.638-.6 4.513-2.429 4.183-4.094z'/%3e%3cpath fill='%23f0e53c' d='M1654.848 1440.719c-1.874-6.853-3.478-7.378-8.652-43.912 5.128-2.07 6.733.63 9.22 1.02 2.506.419 10.333-3.48 10.513 2.519.18 5.96-2.64 35.754-4.963 39.622z'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M1654.848 1440.719c-1.874-6.853-3.478-7.378-8.652-43.912 5.128-2.07 6.733.63 9.22 1.02 2.506.419 10.333-3.48 10.513 2.519.18 5.96-2.64 35.754-4.963 39.622z'/%3e%3cpath fill='none' stroke='%23473125' stroke-linecap='round' stroke-width='1.556' d='m1655.162 1427.163-1.168-23.916m4.062 34.518.944-27.02m4.065-8.008-.314-5.75'/%3e%3cpath fill='%23f0e53c' d='M1663.934 1440.449c-.089-1.695-2.338-2.924-5.038-2.774-2.683.165-4.798 1.664-4.707 3.373.089 1.694 2.338 2.94 5.037 2.774 2.7-.15 4.799-1.664 4.708-3.373'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.556' d='M1663.934 1440.449c-.089-1.695-2.338-2.924-5.038-2.774-2.683.165-4.798 1.664-4.707 3.373.089 1.694 2.338 2.94 5.037 2.774 2.7-.15 4.799-1.664 4.708-3.373z'/%3e%3cpath d='M1732.204 1357.852c.03.211.044.36.075.57.645-.48.585-.63-.075-.57'/%3e%3cpath fill='%23d32011' d='M2166.904 1270.466c-13.12-49.992-49.946-142.507-50.216-271.398-.464-10.345-15.384-15.354-15.188-25.13.208-9.807 3.237-9.957-.75-17.245-2.295 7.019-9.702 9.687-9.403 16.584.301 6.897 6.374 22.701-.359 28.79-6.717 6.086-16.074 13.464-12.956 35.745 3.136 22.313 54.595 215.38 81.105 231.334 26.51 15.924 7.767 1.32 7.767 1.32'/%3e%3cpath fill='%2300702d' d='M2032.542 1017.833c-1.304 6.957 6.446 24.838-1.007 26.338-7.466 1.529-19.552 7.888-15.22 20.9 4.334 13.046 32.135 74.074 60.773 110.929 28.64 36.856 58.358 67.835 58.358 67.835-16.478-44.622-68.06-197.175-73.666-221.316-2.655-11.366-29.238-4.686-29.238-4.686'/%3e%3cg clip-path='url(%23H)' opacity='.25'%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-width='3.334' d='M2092.247 1018.41c6.327-9.327 27.395-12.895 17.71-25.34'/%3e%3c/g%3e%3cg clip-path='url(%23I)' opacity='.25'%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-width='3.334' d='M2048.689 1030.766c11.08 5.667-27.38 37.814-29.208 30.618-2.055-8.486 6.672-9.476 6.088-12.025'/%3e%3c/g%3e%3cpath fill='%23f0e53c' d='M2149.601 1247.733c-12.82-35.025-47.727-144.335-48.882-195.495-.51-11.487-21.382-9.297-16.93-18.143 4.455-8.878 17.154-13.525 7.2-32.029-8.428 3.869-23.467 8.098-22.432-6.928 1.048-15.024-6.839-10.585-10.482-8.096-3.658 2.489-12.146 5.188-4.289 12.866 7.872 7.677 1.095 12.594-5.877 12.954-6.973.36-12.926-.51-14.905 3.63-1.963 4.106 1.86 5.667 6.18 6.026 4.317.36 27.513 14.155 22.49 22.462-5.009 8.308-12.416 10.977-8.653 23.451 3.78 12.476 43.08 111.769 65.526 145.745 22.461 34.007 31.054 33.557 31.054 33.557'/%3e%3cg clip-path='url(%23J)' opacity='.25'%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-width='3.334' d='M2164.313 1044.14c-30.989 22.858 15.107 14.98 22.171-48.588'/%3e%3c/g%3e%3cg clip-path='url(%23K)' opacity='.25'%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-width='3.334' d='M2190.998 1049.879c17.604 27.619-28.004.726 4.167-51.891'/%3e%3c/g%3e%3cg clip-path='url(%23L)' opacity='.25'%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-width='3.334' d='M2087.585 1044.127c30.989 22.859-15.107 14.98-22.171-48.588'/%3e%3c/g%3e%3cg clip-path='url(%23M)' opacity='.25'%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-width='3.334' d='M2060.9 1049.866c-17.603 27.619 28.003.726-4.167-51.891'/%3e%3c/g%3e%3cg clip-path='url(%23N)' opacity='.25'%3e%3cpath d='m2303.763 1524.774-.41 1.023 74.266 72.452.65-.933z'/%3e%3c/g%3e%3cg clip-path='url(%23O)' opacity='.25'%3e%3cpath d='m1948.207 1524.774.41 1.023-74.267 72.452-.648-.933z'/%3e%3c/g%3e%3cg clip-path='url(%23P)' opacity='.25'%3e%3cpath d='M1908.493 1489.87v1.244l-91.661 66.366-.21-1.233z'/%3e%3c/g%3e%3cg clip-path='url(%23Q)' opacity='.25'%3e%3cpath d='m2343.512 1490.704-.035 1.216 91.662 65.56.201-1.234z'/%3e%3c/g%3e%3cg clip-path='url(%23R)' opacity='.25'%3e%3cpath fill='%23292723' d='M2218.063 1016.922c-1.33-2.784-5.212-2.855-10.125-2.944-1.263-.024-2.568-.047-3.929-.119-4.905-.25-8.828-2.414-9.995-5.506-.726-1.927-.715-5.08 3.47-9.16 2.112-2.066 3.091-3.85 2.906-5.305-.26-2.054-2.818-3.522-5.074-4.818-.72-.413-1.399-.803-1.986-1.203-.877-.598-3.543-2.42-5.64-2.42-.773 0-1.383.251-1.865.77-.86.92-1.804 3.204-1.415 8.852.273 3.97-.523 6.986-2.368 8.962-1.668 1.787-4.144 2.693-7.359 2.694-5.179 0-11.113-2.378-14.164-3.779l.463-.88c3.9 1.791 9.217 3.66 13.7 3.66 5.204-.002 9.286-2.518 8.731-10.588-.576-8.355 1.602-10.69 4.277-10.69 2.135 0 4.586 1.49 6.203 2.593 3.66 2.49 12.147 5.19 4.29 12.866-7.873 7.677-1.095 12.595 5.878 12.954 6.972.361 12.925-.509 14.904 3.63 0 0 1.124 2.05.11 3.521 0 0-.106.26-.76.833 0 0 .822-1.813-.252-3.923'/%3e%3c/g%3e%3cg clip-path='url(%23S)' opacity='.25'%3e%3cpath fill='%23292723' d='M2033.907 1016.922c1.332-2.784 5.212-2.855 10.125-2.944 1.263-.024 2.569-.047 3.929-.119 4.905-.25 8.828-2.414 9.994-5.506.727-1.927.716-5.08-3.468-9.16-2.114-2.066-3.092-3.85-2.907-5.305.26-2.054 2.818-3.522 5.074-4.818.72-.413 1.4-.803 1.987-1.203.876-.598 3.542-2.42 5.639-2.42.772 0 1.382.251 1.865.77.86.92 1.804 3.204 1.415 8.852-.274 3.97.523 6.986 2.368 8.962 1.668 1.787 4.144 2.693 7.359 2.694 5.178 0 11.113-2.378 14.163-3.779l-.462-.88c-3.9 1.791-9.216 3.66-13.701 3.66-5.203-.002-9.285-2.518-8.73-10.588.576-8.355-1.602-10.69-4.277-10.69-2.135 0-4.586 1.49-6.203 2.593-3.66 2.49-12.147 5.19-4.29 12.866 7.873 7.677 1.094 12.595-5.878 12.954-6.972.361-12.925-.509-14.904 3.63 0 0-1.125 2.05-.11 3.521 0 0 .106.26.76.833 0 0-.822-1.813.252-3.923'/%3e%3c/g%3e%3cpath fill='%23ced0d1' d='M2038.478 1170.424c-3.209-.21-6.418.089-9.477.989l1.29 4.468c10.765-3.15 23.825 2.31 29.104 12.146 5.308 9.866 1.334 21.44-10.87 31.757l2.998 3.569c19.942-16.853 15.01-31.848 11.981-37.515-4.769-8.878-14.86-14.756-25.026-15.414'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M2038.478 1170.424c-3.209-.21-6.418.089-9.477.989l1.29 4.468c10.765-3.15 23.825 2.31 29.104 12.146 5.308 9.866 1.334 21.44-10.87 31.757l2.998 3.569c19.942-16.853 15.01-31.848 11.981-37.515-4.769-8.878-14.86-14.756-25.026-15.414z'/%3e%3cpath fill='%23ced0d1' d='M2037.069 1202.33c2.414-5.277 5.937-11.515 13.719-11.754-5.576-1.92-12.58-5.49-17.032 2.999-4.44 8.517 3.313 8.756 3.313 8.756'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M2037.069 1202.33c2.414-5.277 5.937-11.515 13.719-11.754-5.576-1.92-12.58-5.49-17.032 2.999-4.44 8.517 3.313 8.756 3.313 8.756z'/%3e%3cpath fill='%23473125' d='M1909.632 1054.966c17.648 26.75 34.562 52.72 40.86 63.247 6.297 10.496 25.054 32.087 40.004 40.754 14.965 8.666 15.67 21.502 18.158 30.798 2.49 9.297 8.442 48.522 23.856 61.957 15.414 13.464 9.326-.15 22.266 15.443 12.941 15.624 240.96 289.548 240.96 289.548l11.394-7.992-212.093-267.999.255-3.87s-41.985-46.273-42.39-51.73c-.42-5.458-4.229-6.477-6.297-10.496-2.07-4.019-13.57-17.993-13.676-39.735-.12-21.74-11.709-22.522-14.348-29.659-2.624-7.168-42-104.69-49.932-125.682-11.56 10.585-59.017 35.416-59.017 35.416'/%3e%3cpath fill='none' stroke='%23272425' stroke-width='1.549' d='M1909.632 1054.966c17.648 26.75 34.562 52.72 40.86 63.247 6.297 10.496 25.054 32.087 40.004 40.754 14.965 8.666 15.67 21.502 18.158 30.798 2.49 9.297 8.442 48.522 23.856 61.957 15.414 13.464 9.326-.15 22.266 15.443 12.941 15.624 240.96 289.548 240.96 289.548l11.394-7.992-212.093-267.999.255-3.87s-41.985-46.273-42.39-51.73c-.42-5.458-4.229-6.477-6.297-10.496-2.07-4.019-13.57-17.993-13.676-39.735-.12-21.74-11.709-22.522-14.348-29.659-2.624-7.168-42-104.69-49.932-125.682-11.56 10.585-59.017 35.416-59.017 35.416z'/%3e%3cpath fill='%23f0e53c' d='M1972.937 1030.616a1560.243 1560.243 0 0 1-4.289-11.065c-11.56 10.585-59.016 35.416-59.016 35.416a6148.69 6148.69 0 0 1 10.015 15.205c33.56-20.364 53.29-39.556 53.29-39.556'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M1972.937 1030.616a1560.243 1560.243 0 0 1-4.289-11.065c-11.56 10.585-59.016 35.416-59.016 35.416a6148.69 6148.69 0 0 1 10.015 15.205c33.56-20.364 53.29-39.556 53.29-39.556z'/%3e%3cpath fill='%23ced0d1' d='M1919.647 1070.171a6052.67 6052.67 0 0 0-10.015-15.205s18.187-9.536 34.802-19.281c-.796 5.966-12.806 15.534-15.28 17.692-2.475 2.159-3.988 5.519-4.199 8.697-.209 3.177-5.308 8.097-5.308 8.097'/%3e%3cpath fill='none' stroke='%23272425' stroke-width='1.549' d='M1919.647 1070.171a6052.67 6052.67 0 0 0-10.015-15.205s18.187-9.536 34.802-19.281c-.796 5.966-12.806 15.534-15.28 17.692-2.475 2.159-3.988 5.519-4.199 8.697-.209 3.177-5.308 8.097-5.308 8.097z'/%3e%3cpath fill='%23ced0d1' d='m2042.286 1232.98 4.978-4.858 45.898 57.427-4.018 5.91z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='m2042.286 1232.98 4.978-4.858 45.898 57.427-4.018 5.91z'/%3e%3cpath fill='%23ced0d1' d='m2049.874 1261.738-4.064 4.078 252.595 305.518 2.938-5.503z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='m2049.874 1261.738-4.064 4.078 252.595 305.518 2.938-5.503z'/%3e%3cpath fill='%23ced0d1' d='M2136.242 1330.472c1.095-.959 1.274-2.549.403-3.539l-6.476-7.467c-.886-1.019-2.475-1.05-3.583-.119l-21.383 18.562c-1.095.96-1.274 2.55-.405 3.54l6.478 7.466c.869 1.02 2.473 1.05 3.568.12z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.262' d='M2136.242 1330.472c1.095-.959 1.274-2.549.403-3.539l-6.476-7.467c-.886-1.019-2.475-1.05-3.583-.119l-21.383 18.562c-1.095.96-1.274 2.55-.405 3.54l6.478 7.466c.869 1.02 2.473 1.05 3.568.12z'/%3e%3cpath fill='%23ced0d1' d='M2224.557 1441.498a2.417 2.417 0 0 0 .24-3.403l-6.477-7.468a2.406 2.406 0 0 0-3.404-.255l-19.507 16.914a2.404 2.404 0 0 0-.226 3.404l6.463 7.467c.884 1.004 2.4 1.124 3.403.255z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.205' d='M2224.557 1441.498a2.417 2.417 0 0 0 .24-3.403l-6.477-7.468a2.406 2.406 0 0 0-3.404-.255l-19.507 16.914a2.404 2.404 0 0 0-.226 3.404l6.463 7.467c.884 1.004 2.4 1.124 3.403.255z'/%3e%3cpath fill='%23ced0d1' d='M2087.165 1278.381a4.118 4.118 0 0 0 3.854 4.38 4.118 4.118 0 1 0 .539-8.218 4.117 4.117 0 0 0-4.393 3.839'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M2087.165 1278.381a4.118 4.118 0 0 0 3.854 4.38 4.118 4.118 0 1 0 .539-8.218 4.117 4.117 0 0 0-4.393 3.839z'/%3e%3cpath fill='%23ced0d1' d='M2034.55 1236.608a4.901 4.901 0 0 0 4.573 5.217c2.7.181 5.038-1.889 5.218-4.588a4.912 4.912 0 0 0-4.573-5.217 4.895 4.895 0 0 0-5.219 4.588'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M2034.55 1236.608a4.901 4.901 0 0 0 4.573 5.217c2.7.181 5.038-1.889 5.218-4.588a4.912 4.912 0 0 0-4.573-5.217 4.895 4.895 0 0 0-5.219 4.588z'/%3e%3cpath fill='%23ced0d1' stroke='%23000' stroke-width='1.549' d='M2000.153 1243.895c6.117 1.08 23.9-21.832 25.52-3.029-2.43-.18-9.895-2.039-12.116.091-5.818 5.606 5.848 4.167 5.999 6.056.329 4.17-1.154 8.187-6.448 8.548-9.012.6-2.055-6.298-4.558-9.297-.135-.15.404-.42.45-.51-4.215 1.56-6.148-.06-8.818-2.099'/%3e%3cpath fill='%23ced0d1' d='m2321.302 1572.054-3.645 2.893 24.952 31.264 3.643-2.894z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='m2321.302 1572.054-3.645 2.893 24.952 31.264 3.643-2.894z'/%3e%3cpath fill='%23ced0d1' stroke='%23000' stroke-width='1.549' d='M2017.697 1260.598c2.443-2.488 4.557-4.438 5.517-8.155 3.569 4.946 10.542 2.907 11.8-3.57.72 1.38 2.204 2.85 2.789 4.2-7.631-13.376 13.466-4.11 13.51 4.288.045 12.654-18.787 6.416-12.04-3.63-5.503 1.86-16.268 13.166-21.576 6.867'/%3e%3cpath fill='%23ced0d1' d='m2307.866 1565.23 10.062 12.057 5.217-4.32-11.425-15.203z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='m2307.866 1565.23 10.062 12.057 5.217-4.32-11.425-15.203z'/%3e%3cpath fill='%23ced0d1' d='M2295.677 1577.362c.943-4.56 3.731-9.581-.752-16.09-4.497-6.522 3.75-17.663 6.48-19.791 2.726-2.13 12.04 13.763 12.04 13.763s3.913 3.375-5.759 12.566l36.826 45.912-2.159 44.369 60.727 103.386-79.485-101.526 2.473-41.235-29.687-36.392s-1.396-1.68-.705-4.962'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M2295.677 1577.362c.943-4.56 3.731-9.581-.752-16.09-4.497-6.522 3.75-17.663 6.48-19.791 2.726-2.13 12.04 13.763 12.04 13.763s3.913 3.375-5.759 12.566l36.826 45.912-2.159 44.369 60.727 103.386-79.485-101.526 2.473-41.235-29.687-36.392s-1.396-1.68-.705-4.962z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='m2316.28 1578.501-5.595 6.583 27.56 33.813m-14.65 41.053c5.534 2.445 12.91 4.484 18.759-1.858m-16.286-39.376c3.001 1.485 8.443 5.474 18.444-4.993'/%3e%3cpath fill='%23ced0d1' d='M1980.66 1149.46c-3.209-.238-6.434.03-9.507.9l1.274 4.468c10.782-3.027 23.796 2.52 29 12.416 5.203 9.927 1.14 21.473-11.157 31.668l2.97 3.569c20.077-16.673 15.294-31.698 12.295-37.396-4.693-8.907-14.724-14.873-24.875-15.624'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M1980.66 1149.46c-3.209-.238-6.434.03-9.507.9l1.274 4.468c10.782-3.027 23.796 2.52 29 12.416 5.203 9.927 1.14 21.473-11.157 31.668l2.97 3.569c20.077-16.673 15.294-31.698 12.295-37.396-4.693-8.907-14.724-14.873-24.875-15.624z'/%3e%3cpath fill='%23ced0d1' d='M1978.966 1181.368c2.459-5.246 6.028-11.454 13.81-11.664-5.548-1.95-12.52-5.61-17.035 2.879-4.527 8.457 3.225 8.785 3.225 8.785'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M1978.966 1181.368c2.459-5.246 6.028-11.454 13.81-11.664-5.548-1.95-12.52-5.61-17.035 2.879-4.527 8.457 3.225 8.785 3.225 8.785z'/%3e%3cpath fill='%23473125' d='M1852.818 1032.894c17.41 26.93 34.097 53.021 40.305 63.577 6.193 10.585 24.771 32.327 39.645 41.114 14.888 8.817 15.473 21.651 17.89 30.98 2.412 9.325 8.02 48.58 23.314 62.165 15.31 13.555 9.326-.09 22.147 15.624 12.805 15.714 238.456 291.603 238.456 291.603l11.468-7.888-209.785-269.829.286-3.87s-41.58-46.602-41.939-52.09c-.376-5.457-4.184-6.508-6.208-10.557-2.025-4.017-13.406-18.082-13.346-39.824.076-21.773-11.515-22.64-14.079-29.809-2.565-7.198-41.099-105.02-48.836-126.102-11.666 10.496-59.318 34.906-59.318 34.906'/%3e%3cpath fill='none' stroke='%23272425' stroke-width='1.549' d='M1852.818 1032.894c17.41 26.93 34.097 53.021 40.305 63.577 6.193 10.585 24.771 32.327 39.645 41.114 14.888 8.817 15.473 21.651 17.89 30.98 2.412 9.325 8.02 48.58 23.314 62.165 15.31 13.555 9.326-.09 22.147 15.624 12.805 15.714 238.456 291.603 238.456 291.603l11.468-7.888-209.785-269.829.286-3.87s-41.58-46.602-41.939-52.09c-.376-5.457-4.184-6.508-6.208-10.557-2.025-4.017-13.406-18.082-13.346-39.824.076-21.773-11.515-22.64-14.079-29.809-2.565-7.198-41.099-105.02-48.836-126.102-11.666 10.496-59.318 34.906-59.318 34.906z'/%3e%3cpath fill='%23f0e53c' d='M1916.319 1009.083a1078.493 1078.493 0 0 1-4.182-11.095c-11.667 10.496-59.318 34.907-59.318 34.907a3435.84 3435.84 0 0 1 9.866 15.295c33.737-20.093 53.634-39.107 53.634-39.107'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M1916.319 1009.083a1078.493 1078.493 0 0 1-4.182-11.095c-11.667 10.496-59.318 34.907-59.318 34.907a3435.84 3435.84 0 0 1 9.866 15.295c33.737-20.093 53.634-39.107 53.634-39.107z'/%3e%3cpath fill='%23ced0d1' d='M1862.685 1048.19a3349.423 3349.423 0 0 0-9.867-15.296s18.263-9.355 34.95-18.982c-.837 5.968-12.938 15.414-15.427 17.573-2.49 2.13-4.033 5.49-4.274 8.667-.24 3.18-5.382 8.037-5.382 8.037'/%3e%3cpath fill='none' stroke='%23272425' stroke-width='1.549' d='M1862.685 1048.19a3349.423 3349.423 0 0 0-9.867-15.296s18.263-9.355 34.95-18.982c-.837 5.968-12.938 15.414-15.427 17.573-2.49 2.13-4.033 5.49-4.274 8.667-.24 3.18-5.382 8.037-5.382 8.037z'/%3e%3cpath fill='%23ced0d1' d='m1983.914 1212.047 5.022-4.829 45.403 57.85-4.063 5.847z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='m1983.914 1212.047 5.022-4.829 45.403 57.85-4.063 5.847z'/%3e%3cpath fill='%23ced0d1' d='m1991.261 1240.866-4.093 4.049 249.94 307.676 2.998-5.474z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='m1991.261 1240.866-4.093 4.049 249.94 307.676 2.998-5.474z'/%3e%3cpath fill='%23ced0d1' d='M2077.028 1310.35c1.11-.93 1.305-2.519.435-3.538l-6.417-7.528c-.87-1.02-2.46-1.08-3.57-.12l-21.547 18.352c-1.108.931-1.303 2.521-.434 3.54l6.418 7.526c.854 1.02 2.458 1.081 3.57.121z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.262' d='M2077.028 1310.35c1.11-.93 1.305-2.519.435-3.538l-6.417-7.528c-.87-1.02-2.46-1.08-3.57-.12l-21.547 18.352c-1.108.931-1.303 2.521-.434 3.54l6.418 7.526c.854 1.02 2.458 1.081 3.57.121z'/%3e%3cpath fill='%23ced0d1' d='M2164.385 1422.125c1.02-.869 1.124-2.383.271-3.404l-6.417-7.512c-.873-1.019-2.386-1.154-3.39-.299l-19.658 16.748a2.423 2.423 0 0 0-.27 3.405l6.417 7.526a2.403 2.403 0 0 0 3.39.284z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.205' d='M2164.385 1422.125c1.02-.869 1.124-2.383.271-3.404l-6.417-7.512c-.873-1.019-2.386-1.154-3.39-.299l-19.658 16.748a2.423 2.423 0 0 0-.27 3.405l6.417 7.526a2.403 2.403 0 0 0 3.39.284z'/%3e%3cpath fill='%23ced0d1' d='M2028.401 1257.84c-.164 2.28 1.545 4.26 3.81 4.408a4.122 4.122 0 0 0 4.437-3.808c.166-2.28-1.543-4.26-3.808-4.409-2.278-.179-4.259 1.53-4.439 3.808'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M2028.401 1257.84c-.164 2.28 1.545 4.26 3.81 4.408a4.122 4.122 0 0 0 4.437-3.808c.166-2.28-1.543-4.26-3.808-4.409-2.278-.179-4.259 1.53-4.439 3.808z'/%3e%3cpath fill='%23ced0d1' d='M1976.146 1215.586a4.91 4.91 0 0 0 4.528 5.277c2.7.18 5.053-1.829 5.264-4.528.194-2.699-1.829-5.068-4.528-5.248-2.7-.21-5.069 1.8-5.264 4.5'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M1976.146 1215.586a4.91 4.91 0 0 0 4.528 5.277c2.7.18 5.053-1.829 5.264-4.528.194-2.699-1.829-5.068-4.528-5.248-2.7-.21-5.069 1.8-5.264 4.5z'/%3e%3cpath fill='%23ced0d1' stroke='%23000' stroke-width='1.549' d='M1941.704 1222.603c6.088 1.11 24.082-21.622 25.536-2.788-2.43-.21-9.881-2.16-12.115-.03-5.864 5.547 5.802 4.227 5.937 6.087.3 4.168-1.214 8.187-6.506 8.517-9.027.51-2.011-6.328-4.499-9.357-.12-.15.419-.419.465-.48-4.229 1.5-6.134-.12-8.803-2.22'/%3e%3cpath fill='%23ced0d1' d='m2259.989 1553.506-3.657 2.878 24.679 31.474 3.66-2.865z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='m2259.989 1553.506-3.657 2.878 24.679 31.474 3.66-2.865z'/%3e%3cpath fill='%23ced0d1' stroke='%23000' stroke-width='1.549' d='M1959.083 1239.458c2.474-2.49 4.603-4.41 5.592-8.127 3.524 4.978 10.527 2.998 11.845-3.45.706 1.38 2.175 2.879 2.745 4.228-7.527-13.463 13.494-4.018 13.465 4.409-.06 12.656-18.834 6.238-12.01-3.748-5.503 1.829-16.374 13.015-21.637 6.688'/%3e%3cpath fill='%23ced0d1' d='m2246.614 1546.578 9.973 12.13 5.248-4.273-11.292-15.279z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='m2246.614 1546.578 9.973 12.13 5.248-4.273-11.292-15.279z'/%3e%3cpath fill='%23ced0d1' d='M2234.334 1558.604c.99-4.543 3.809-9.552-.614-16.104-4.44-6.553 3.913-17.619 6.657-19.717 2.744-2.115 11.905 13.853 11.905 13.853s3.884 3.405-5.863 12.507l36.437 46.242-2.534 44.338 59.813 103.926-78.586-102.217 2.819-41.218-29.374-36.648s-1.38-1.693-.66-4.962'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M2234.334 1558.604c.99-4.543 3.809-9.552-.614-16.104-4.44-6.553 3.913-17.619 6.657-19.717 2.744-2.115 11.905 13.853 11.905 13.853s3.884 3.405-5.863 12.507l36.437 46.242-2.534 44.338 59.813 103.926-78.586-102.217 2.819-41.218-29.374-36.648s-1.38-1.693-.66-4.962z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='m2254.922 1559.923-5.638 6.538 27.244 34.037m-14.979 40.934c5.503 2.49 12.85 4.59 18.773-1.709m-15.954-39.509c2.983 1.514 8.382 5.547 18.488-4.829'/%3e%3cpath fill='%23ced0d1' d='M2213.492 1170.424c3.209-.21 6.418.089 9.49.989l-1.303 4.468c-10.767-3.15-23.826 2.31-29.104 12.146-5.31 9.866-1.335 21.44 10.87 31.757l-2.998 3.569c-19.942-16.853-15.01-31.848-11.981-37.515 4.769-8.878 14.86-14.756 25.026-15.414'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M2213.492 1170.424c3.209-.21 6.418.089 9.49.989l-1.303 4.468c-10.767-3.15-23.826 2.31-29.104 12.146-5.31 9.866-1.335 21.44 10.87 31.757l-2.998 3.569c-19.942-16.853-15.01-31.848-11.981-37.515 4.769-8.878 14.86-14.756 25.026-15.414z'/%3e%3cpath fill='%23ced0d1' d='M2214.901 1202.33c-2.414-5.277-5.937-11.515-13.719-11.754 5.576-1.92 12.58-5.49 17.032 2.999 4.44 8.517-3.313 8.756-3.313 8.756'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M2214.901 1202.33c-2.414-5.277-5.937-11.515-13.719-11.754 5.576-1.92 12.58-5.49 17.032 2.999 4.44 8.517-3.313 8.756-3.313 8.756z'/%3e%3cpath fill='%23473125' d='M2342.338 1054.966c-17.647 26.75-34.563 52.72-40.858 63.247-6.3 10.496-25.057 32.087-40.006 40.754-14.95 8.666-15.654 21.502-18.158 30.798-2.49 9.297-8.426 48.522-23.856 61.957-15.414 13.464-9.326-.15-22.267 15.443-12.94 15.624-240.96 289.548-240.96 289.548l-11.395-7.992 212.095-267.999-.255-3.87s41.985-46.273 42.39-51.73c.419-5.458 4.229-6.477 6.297-10.496 2.07-4.019 13.57-17.993 13.674-39.735.12-21.74 11.727-22.522 14.35-29.659 2.639-7.168 42-104.69 49.932-125.682 11.56 10.585 59.017 35.416 59.017 35.416'/%3e%3cpath fill='none' stroke='%23272425' stroke-width='1.549' d='M2342.338 1054.966c-17.647 26.75-34.563 52.72-40.858 63.247-6.3 10.496-25.057 32.087-40.006 40.754-14.95 8.666-15.654 21.502-18.158 30.798-2.49 9.297-8.426 48.522-23.856 61.957-15.414 13.464-9.326-.15-22.267 15.443-12.94 15.624-240.96 289.548-240.96 289.548l-11.395-7.992 212.095-267.999-.255-3.87s41.985-46.273 42.39-51.73c.419-5.458 4.229-6.477 6.297-10.496 2.07-4.019 13.57-17.993 13.674-39.735.12-21.74 11.727-22.522 14.35-29.659 2.639-7.168 42-104.69 49.932-125.682 11.56 10.585 59.017 35.416 59.017 35.416z'/%3e%3cpath fill='%23f0e53c' d='M2279.033 1030.616c1.812-4.647 3.298-8.457 4.288-11.065 11.561 10.585 59.017 35.416 59.017 35.416a6152.03 6152.03 0 0 0-10.016 15.205c-33.558-20.364-53.289-39.556-53.289-39.556'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M2279.033 1030.616c1.812-4.647 3.298-8.457 4.288-11.065 11.561 10.585 59.017 35.416 59.017 35.416a6152.03 6152.03 0 0 0-10.016 15.205c-33.558-20.364-53.289-39.556-53.289-39.556z'/%3e%3cpath fill='%23ced0d1' d='M2332.322 1070.171a6346.4 6346.4 0 0 1 10.016-15.205s-18.189-9.536-34.802-19.281c.796 5.966 12.806 15.534 15.279 17.692 2.475 2.159 3.989 5.519 4.199 8.697.209 3.177 5.308 8.097 5.308 8.097'/%3e%3cpath fill='none' stroke='%23272425' stroke-width='1.549' d='M2332.322 1070.171a6346.4 6346.4 0 0 1 10.016-15.205s-18.189-9.536-34.802-19.281c.796 5.966 12.806 15.534 15.279 17.692 2.475 2.159 3.989 5.519 4.199 8.697.209 3.177 5.308 8.097 5.308 8.097z'/%3e%3cpath fill='%23ced0d1' d='m2209.683 1232.98-4.979-4.858-45.897 57.427 4.02 5.91z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='m2209.683 1232.98-4.979-4.858-45.897 57.427 4.02 5.91z'/%3e%3cpath fill='%23ced0d1' d='m2202.095 1261.738 4.065 4.078-252.58 305.518-2.954-5.503z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='m2202.095 1261.738 4.065 4.078-252.58 305.518-2.954-5.503z'/%3e%3cpath fill='%23ced0d1' d='M2115.728 1330.472c-1.095-.959-1.274-2.549-.39-3.539l6.463-7.467c.885-1.019 2.475-1.05 3.583-.119l21.382 18.562c1.095.96 1.275 2.55.406 3.54l-6.478 7.466c-.869 1.02-2.474 1.05-3.569.12z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.262' d='M2115.728 1330.472c-1.095-.959-1.274-2.549-.39-3.539l6.463-7.467c.885-1.019 2.475-1.05 3.583-.119l21.382 18.562c1.095.96 1.275 2.55.406 3.54l-6.478 7.466c-.869 1.02-2.474 1.05-3.569.12z'/%3e%3cpath fill='%23ced0d1' d='M2027.412 1441.498a2.418 2.418 0 0 1-.24-3.403l6.477-7.468a2.407 2.407 0 0 1 3.405-.255l19.506 16.914a2.416 2.416 0 0 1 .24 3.404l-6.477 7.467c-.884 1.004-2.398 1.124-3.402.255z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.205' d='M2027.412 1441.498a2.418 2.418 0 0 1-.24-3.403l6.477-7.468a2.407 2.407 0 0 1 3.405-.255l19.506 16.914a2.416 2.416 0 0 1 .24 3.404l-6.477 7.467c-.884 1.004-2.398 1.124-3.402.255z'/%3e%3cpath fill='%23ced0d1' d='M2164.805 1278.381a4.118 4.118 0 0 1-3.854 4.38 4.12 4.12 0 0 1-4.393-3.838 4.115 4.115 0 0 1 3.853-4.38 4.118 4.118 0 0 1 4.394 3.839'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M2164.805 1278.381a4.118 4.118 0 0 1-3.854 4.38 4.12 4.12 0 0 1-4.393-3.838 4.115 4.115 0 0 1 3.853-4.38 4.118 4.118 0 0 1 4.394 3.839z'/%3e%3cpath fill='%23ced0d1' d='M2217.42 1236.608a4.901 4.901 0 0 1-4.573 5.217c-2.7.181-5.037-1.889-5.217-4.588a4.91 4.91 0 0 1 4.572-5.217 4.887 4.887 0 0 1 5.219 4.588'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M2217.42 1236.608a4.901 4.901 0 0 1-4.573 5.217c-2.7.181-5.037-1.889-5.217-4.588a4.91 4.91 0 0 1 4.572-5.217 4.887 4.887 0 0 1 5.219 4.588z'/%3e%3cpath fill='%23ced0d1' stroke='%23000' stroke-width='1.549' d='M2251.817 1243.895c-6.117 1.08-23.9-21.832-25.52-3.029 2.43-.18 9.896-2.039 12.116.091 5.817 5.606-5.849 4.167-5.999 6.056-.328 4.17 1.155 8.187 6.45 8.548 9.01.6 2.052-6.298 4.556-9.297.15-.15-.404-.42-.45-.51 4.215 1.56 6.148-.06 8.818-2.099'/%3e%3cpath fill='%23ced0d1' d='m1930.684 1572.054 3.628 2.893-24.95 31.264-3.629-2.894z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='m1930.684 1572.054 3.628 2.893-24.95 31.264-3.629-2.894z'/%3e%3cpath fill='%23ced0d1' stroke='%23000' stroke-width='1.549' d='M2234.273 1260.598c-2.442-2.488-4.557-4.438-5.517-8.155-3.569 4.946-10.542 2.907-11.8-3.57-.72 1.38-2.205 2.85-2.789 4.2 7.631-13.376-13.465-4.11-13.51 4.288-.046 12.654 18.787 6.416 12.041-3.63 5.503 1.86 16.267 13.166 21.575 6.867'/%3e%3cpath fill='%23ced0d1' d='m1944.104 1565.23-10.062 12.057-5.202-4.32 11.41-15.203z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='m1944.104 1565.23-10.062 12.057-5.202-4.32 11.41-15.203z'/%3e%3cpath fill='%23ced0d1' d='M1956.293 1577.362c-.944-4.56-3.732-9.581.751-16.09 4.497-6.522-3.75-17.663-6.478-19.791-2.729-2.13-12.04 13.763-12.04 13.763s-3.915 3.375 5.757 12.566l-36.825 45.912 2.158 44.369-60.712 103.386 79.471-101.526-2.476-41.235 29.69-36.392s1.395-1.68.704-4.962'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M1956.293 1577.362c-.944-4.56-3.732-9.581.751-16.09 4.497-6.522-3.75-17.663-6.478-19.791-2.729-2.13-12.04 13.763-12.04 13.763s-3.915 3.375 5.757 12.566l-36.825 45.912 2.158 44.369-60.712 103.386 79.471-101.526-2.476-41.235 29.69-36.392s1.395-1.68.704-4.962z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='m1935.691 1578.501 5.593 6.583-27.559 33.813m14.65 41.053c-5.534 2.445-12.91 4.484-18.758-1.858m16.283-39.376c-3 1.485-8.426 5.474-18.442-4.993'/%3e%3cpath fill='%23ced0d1' d='M2271.31 1149.46c3.208-.238 6.433.03 9.507.9l-1.26 4.468c-10.797-3.027-23.81 2.52-29.015 12.416-5.203 9.927-1.139 21.473 11.157 31.668l-2.97 3.569c-20.077-16.673-15.294-31.698-12.295-37.396 4.693-8.907 14.725-14.873 24.875-15.624'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M2271.31 1149.46c3.208-.238 6.433.03 9.507.9l-1.26 4.468c-10.797-3.027-23.81 2.52-29.015 12.416-5.203 9.927-1.139 21.473 11.157 31.668l-2.97 3.569c-20.077-16.673-15.294-31.698-12.295-37.396 4.693-8.907 14.725-14.873 24.875-15.624z'/%3e%3cpath fill='%23ced0d1' d='M2273.005 1181.368c-2.46-5.246-6.028-11.454-13.81-11.664 5.547-1.95 12.52-5.61 17.035 2.879 4.527 8.457-3.225 8.785-3.225 8.785'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M2273.005 1181.368c-2.46-5.246-6.028-11.454-13.81-11.664 5.547-1.95 12.52-5.61 17.035 2.879 4.527 8.457-3.225 8.785-3.225 8.785z'/%3e%3cpath fill='%23473125' d='M2399.151 1032.894c-17.408 26.93-34.097 53.021-40.289 63.577-6.208 10.585-24.786 32.327-39.66 41.114-14.889 8.817-15.474 21.651-17.889 30.98-2.414 9.325-8.02 48.58-23.315 62.165-15.31 13.555-9.326-.09-22.148 15.624-12.804 15.714-238.455 291.603-238.455 291.603l-11.469-7.888 209.785-269.829-.285-3.87s41.58-46.602 41.94-52.09c.375-5.457 4.182-6.508 6.206-10.557 2.025-4.017 13.406-18.082 13.347-39.824-.077-21.773 11.515-22.64 14.08-29.809 2.563-7.198 41.097-105.02 48.835-126.102 11.666 10.496 59.317 34.906 59.317 34.906'/%3e%3cpath fill='none' stroke='%23272425' stroke-width='1.549' d='M2399.151 1032.894c-17.408 26.93-34.097 53.021-40.289 63.577-6.208 10.585-24.786 32.327-39.66 41.114-14.889 8.817-15.474 21.651-17.889 30.98-2.414 9.325-8.02 48.58-23.315 62.165-15.31 13.555-9.326-.09-22.148 15.624-12.804 15.714-238.455 291.603-238.455 291.603l-11.469-7.888 209.785-269.829-.285-3.87s41.58-46.602 41.94-52.09c.375-5.457 4.182-6.508 6.206-10.557 2.025-4.017 13.406-18.082 13.347-39.824-.077-21.773 11.515-22.64 14.08-29.809 2.563-7.198 41.097-105.02 48.835-126.102 11.666 10.496 59.317 34.906 59.317 34.906z'/%3e%3cpath fill='%23f0e53c' d='M2335.651 1009.083c1.784-4.677 3.223-8.486 4.183-11.095 11.666 10.496 59.317 34.907 59.317 34.907-3.328 5.159-6.657 10.286-9.866 15.295-33.737-20.093-53.634-39.107-53.634-39.107'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M2335.651 1009.083c1.784-4.677 3.223-8.486 4.183-11.095 11.666 10.496 59.317 34.907 59.317 34.907-3.328 5.159-6.657 10.286-9.866 15.295-33.737-20.093-53.634-39.107-53.634-39.107z'/%3e%3cpath fill='%23ced0d1' d='M2389.285 1048.19c3.209-5.01 6.538-10.137 9.866-15.296 0 0-18.262-9.355-34.952-18.982.84 5.968 12.94 15.414 15.43 17.573 2.489 2.13 4.033 5.49 4.273 8.667.24 3.18 5.383 8.037 5.383 8.037'/%3e%3cpath fill='none' stroke='%23272425' stroke-width='1.549' d='M2389.285 1048.19c3.209-5.01 6.538-10.137 9.866-15.296 0 0-18.262-9.355-34.952-18.982.84 5.968 12.94 15.414 15.43 17.573 2.489 2.13 4.033 5.49 4.273 8.667.24 3.18 5.383 8.037 5.383 8.037z'/%3e%3cpath fill='%23ced0d1' d='m2268.055 1212.047-5.022-4.829-45.404 57.85 4.065 5.847z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='m2268.055 1212.047-5.022-4.829-45.404 57.85 4.065 5.847z'/%3e%3cpath fill='%23ced0d1' d='m2260.709 1240.866 4.094 4.049-249.941 307.676-3-5.474z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='m2260.709 1240.866 4.094 4.049-249.941 307.676-3-5.474z'/%3e%3cpath fill='%23ced0d1' d='M2174.942 1310.35c-1.11-.93-1.29-2.519-.435-3.538l6.416-7.528c.872-1.02 2.46-1.08 3.57-.12l21.547 18.352c1.11.931 1.303 2.521.434 3.54l-6.418 7.526c-.853 1.02-2.458 1.081-3.568.121z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.262' d='M2174.942 1310.35c-1.11-.93-1.29-2.519-.435-3.538l6.416-7.528c.872-1.02 2.46-1.08 3.57-.12l21.547 18.352c1.11.931 1.303 2.521.434 3.54l-6.418 7.526c-.853 1.02-2.458 1.081-3.568.121z'/%3e%3cpath fill='%23ced0d1' d='M2087.584 1422.125c-1.02-.869-1.124-2.383-.27-3.404l6.417-7.512c.871-1.019 2.385-1.154 3.39-.299l19.657 16.748a2.422 2.422 0 0 1 .27 3.405l-6.418 7.526a2.401 2.401 0 0 1-3.388.284z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.205' d='M2087.584 1422.125c-1.02-.869-1.124-2.383-.27-3.404l6.417-7.512c.871-1.019 2.385-1.154 3.39-.299l19.657 16.748a2.422 2.422 0 0 1 .27 3.405l-6.418 7.526a2.401 2.401 0 0 1-3.388.284z'/%3e%3cpath fill='%23ced0d1' d='M2223.568 1257.84c.165 2.28-1.544 4.26-3.809 4.408-2.279.18-4.257-1.53-4.437-3.808-.166-2.28 1.543-4.26 3.808-4.409 2.278-.179 4.257 1.53 4.438 3.808'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M2223.568 1257.84c.165 2.28-1.544 4.26-3.809 4.408-2.279.18-4.257-1.53-4.437-3.808-.166-2.28 1.543-4.26 3.808-4.409 2.278-.179 4.257 1.53 4.438 3.808z'/%3e%3cpath fill='%23ced0d1' d='M2275.824 1215.586a4.912 4.912 0 0 1-4.528 5.277c-2.7.18-5.053-1.829-5.264-4.528-.195-2.699 1.829-5.068 4.528-5.248 2.715-.21 5.069 1.8 5.264 4.5'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M2275.824 1215.586a4.912 4.912 0 0 1-4.528 5.277c-2.7.18-5.053-1.829-5.264-4.528-.195-2.699 1.829-5.068 4.528-5.248 2.715-.21 5.069 1.8 5.264 4.5z'/%3e%3cpath fill='%23ced0d1' stroke='%23000' stroke-width='1.549' d='M2310.264 1222.603c-6.086 1.11-24.08-21.622-25.534-2.788 2.43-.21 9.881-2.16 12.114-.03 5.864 5.547-5.802 4.227-5.937 6.087-.299 4.168 1.214 8.187 6.522 8.517 9.012.51 1.995-6.328 4.484-9.357.135-.15-.42-.419-.465-.48 4.228 1.5 6.132-.12 8.802-2.22'/%3e%3cpath fill='%23ced0d1' d='m1991.981 1553.506 3.657 2.878-24.68 31.474-3.659-2.865z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='m1991.981 1553.506 3.657 2.878-24.68 31.474-3.659-2.865z'/%3e%3cpath fill='%23ced0d1' stroke='%23000' stroke-width='1.549' d='M2292.887 1239.458c-2.475-2.49-4.604-4.41-5.593-8.127-3.522 4.978-10.525 2.998-11.844-3.45-.706 1.38-2.174 2.879-2.745 4.228 7.527-13.463-13.494-4.018-13.465 4.409.06 12.656 18.847 6.238 12.01-3.748 5.519 1.829 16.374 13.015 21.637 6.688'/%3e%3cpath fill='%23ced0d1' d='m2005.356 1546.578-9.973 12.13-5.248-4.273 11.292-15.279z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='m2005.356 1546.578-9.973 12.13-5.248-4.273 11.292-15.279z'/%3e%3cpath fill='%23ced0d1' d='M2017.637 1558.604c-.99-4.543-3.81-9.552.614-16.104 4.439-6.553-3.914-17.619-6.657-19.717-2.744-2.115-11.906 13.853-11.906 13.853s-3.883 3.405 5.862 12.507l-36.435 46.242 2.533 44.338-59.812 103.926 78.6-102.217-2.833-41.218 29.374-36.648s1.379-1.693.66-4.962'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='M2017.637 1558.604c-.99-4.543-3.81-9.552.614-16.104 4.439-6.553-3.914-17.619-6.657-19.717-2.744-2.115-11.906 13.853-11.906 13.853s-3.883 3.405 5.862 12.507l-36.435 46.242 2.533 44.338-59.812 103.926 78.6-102.217-2.833-41.218 29.374-36.648s1.379-1.693.66-4.962z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.549' d='m1997.048 1559.923 5.638 6.538-27.244 34.037m14.994 40.934c-5.518 2.49-12.865 4.59-18.789-1.709m15.955-39.509c-2.983 1.514-8.382 5.547-18.488-4.829'/%3e%3cpath fill='%23473125' d='M2297.76 1614.533c-6.658-7.362-72.393-82.364-93.385-125.803-4.964-10.241 8.966-15.698 12.91-6.463 6.703 15.745 48.521 79.112 89.531 125.083z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.025' d='M2297.76 1614.533c-6.658-7.362-72.393-82.364-93.385-125.803-4.964-10.241 8.966-15.698 12.91-6.463 6.703 15.745 48.521 79.112 89.531 125.083z'/%3e%3cpath fill='%23ced0d1' d='M2285.555 1619.87c-1.936 3.448-4.244 15.115 2.684 25.371 6.912 10.255 14.44 13.15 22.207 11.771.478-7.797-.302-11.38 10.735-19.328 11.021-7.947 18.967-9.357 21.786-9.237 2.82.135 11.036 1.89 17.424 6.673 3.464-3.464 8.202-22.94-2.684-39.6-10.9-16.66-31.668-22.686-45.882-17.5 3.583 3.524 10.885 15.055-.78 28.776-5.353 6.192-10.378 11.02-10.378 11.02s-8.71 7.302-15.112 2.054'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.025' d='M2285.555 1619.87c-1.936 3.448-4.244 15.115 2.684 25.371 6.912 10.255 14.44 13.15 22.207 11.771.478-7.797-.302-11.38 10.735-19.328 11.021-7.947 18.967-9.357 21.786-9.237 2.82.135 11.036 1.89 17.424 6.673 3.464-3.464 8.202-22.94-2.684-39.6-10.9-16.66-31.668-22.686-45.882-17.5 3.583 3.524 10.885 15.055-.78 28.776-5.353 6.192-10.378 11.02-10.378 11.02s-8.71 7.302-15.112 2.054z'/%3e%3cpath fill='%23ced0d1' d='M2310.415 1657.416c-.135-5.381-4.363-11.53 11.276-22.296 15.624-10.766 27.424-10.256 38.7 0-6.912-4.363-17.423-9.492-31.533-.135-14.094 9.357-11.395 8.338-11.395 8.338-2.954 2.309-6.028 3.328-7.048 14.093'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.025' d='M2310.415 1657.416c-.135-5.381-4.363-11.53 11.276-22.296 15.624-10.766 27.424-10.256 38.7 0-6.912-4.363-17.423-9.492-31.533-.135-14.094 9.357-11.395 8.338-11.395 8.338-2.954 2.309-6.028 3.328-7.048 14.093z'/%3e%3cpath fill='%23ced0d1' d='m2316.743 1644.792-21.262-27.995c-1.604-2.115.225-6.208 4.094-9.147 3.853-2.923 8.29-3.584 9.896-1.47l21.262 27.98z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.025' d='m2316.743 1644.792-21.262-27.995c-1.604-2.115.225-6.208 4.094-9.147 3.853-2.923 8.29-3.584 9.896-1.47l21.262 27.98z'/%3e%3cpath fill='%23ced0d1' d='M2330.733 1634.16c-1.604-2.114-6.043-1.44-9.897 1.485-3.868 2.94-5.698 7.032-4.093 9.146 1.604 2.115 6.043 1.44 9.896-1.485 3.868-2.938 5.697-7.032 4.094-9.146'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.025' d='M2330.733 1634.16c-1.604-2.114-6.043-1.44-9.897 1.485-3.868 2.94-5.698 7.032-4.093 9.146 1.604 2.115 6.043 1.44 9.896-1.485 3.868-2.938 5.697-7.032 4.094-9.146z'/%3e%3cpath fill='%23473125' d='M2329.457 1638.314c-1.048-1.77-3.776-2.083-6.072-.72-2.324 1.365-3.343 3.898-2.294 5.669 1.05 1.768 4.018 2.533 6.328 1.168 2.309-1.363 3.073-4.348 2.038-6.117'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.025' d='M2329.457 1638.314c-1.048-1.77-3.776-2.083-6.072-.72-2.324 1.365-3.343 3.898-2.294 5.669 1.05 1.768 4.018 2.533 6.328 1.168 2.309-1.363 3.073-4.348 2.038-6.117z'/%3e%3cpath d='M1958.693 1599.268c6.252 2.25 19.388 11.2 26.72 21.232 7.333 10.032 2.954 14.185-5.218 12.475-8.17-1.708-17.094-10.944-18.503-14.018-1.41-3.06-2.999-19.69-2.999-19.69'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.595' d='M1958.693 1599.268c6.252 2.25 19.388 11.2 26.72 21.232 7.333 10.032 2.954 14.185-5.218 12.475-8.17-1.708-17.094-10.944-18.503-14.018-1.41-3.06-2.999-19.69-2.999-19.69z'/%3e%3cpath fill='%23fff' stroke='%23473125' stroke-width='19.521' d='m1953.82 1605.16 41.865-48.821'/%3e%3cpath fill='%23d32011' d='M1929.53 1559.264c-1.53 2.323-7.333 7.376-9.252 9.911-1.92 2.533-10.106 13-9.446 25.94.644 12.94.868 17.574.764 22.971-.104 5.398-4.393 23.796 7.003 33.423 11.395 9.641 17.768 13.705 36.33 11.86 18.579-1.86 32.869-11.202 21.743-23.105 1.589-2.775 3.838-6.06 9.07-7.063-4.347-.81-16.628-5.639-18.892-12.82-2.263-7.198-3.103-22.508-3.84-26.796-.733-4.303-2.967-18.428-14.482-25.91-11.5-7.467-15.64-5.623-18.998-8.41'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.595' d='M1929.53 1559.264c-1.53 2.323-7.333 7.376-9.252 9.911-1.92 2.533-10.106 13-9.446 25.94.644 12.94.868 17.574.764 22.971-.104 5.398-4.393 23.796 7.003 33.423 11.395 9.641 17.768 13.705 36.33 11.86 18.579-1.86 32.869-11.202 21.743-23.105 1.589-2.775 3.838-6.06 9.07-7.063-4.347-.81-16.628-5.639-18.892-12.82-2.263-7.198-3.103-22.508-3.84-26.796-.733-4.303-2.967-18.428-14.482-25.91-11.5-7.467-15.64-5.623-18.998-8.41z'/%3e%3cg clip-path='url(%23T)' opacity='.5'%3e%3cpath d='M1976.672 1640.264c1.425 1.514 2.414 2.999 3.058 4.422-6.163-4.29-18.982-11.365-25.37-9.131-7.437 2.579-15.714 9.252-21.457 4.647 3.225-.3 17.438-1.98 4.258-17.422 4.634 4.933 21.562 18.967 31.144.42 1.244 1.739 3.028 3.283 5.007 4.618-3.987.959-8.471 2.803-7.841 5.203.764 2.894 8.187 4.768 13.9 3.509-1.155 1.184-1.994 2.504-2.7 3.734'/%3e%3c/g%3e%3cg clip-path='url(%23U)' opacity='.33'%3e%3cpath d='M1913.2 1606.12c.42-5.157 7.153-30.167 21.412-31.562 14.246-1.396 18.488 7.782 21.398 12.476-1.664-7.978-7.573-17.919-23.887-15.1-16.314 2.82-19.417 22.611-19.642 23.931-.24 1.32.72 10.255.72 10.255'/%3e%3c/g%3e%3cpath fill='%23f0e53c' d='M2386.856 1113.564c-4.843 5.338-4.453 13.585.884 18.443 5.34 4.83 13.586 4.44 18.428-.9 4.844-5.308 4.455-13.585-.884-18.412-5.337-4.859-13.584-4.44-18.428.87'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='2.097' d='M2386.856 1113.564c-4.843 5.338-4.453 13.585.884 18.443 5.34 4.83 13.586 4.44 18.428-.9 4.844-5.308 4.455-13.585-.884-18.412-5.337-4.859-13.584-4.44-18.428.87z'/%3e%3cpath fill='%23f0e53c' d='M2006.555 1606.646s371.05-381.853 391.862-403.266c20.798-21.381 8.818-63.725-5.668-76.891-14.483-13.165-57.788-21.021-77.086 1.74-19.297 22.76-363.837 428.695-363.837 428.695z'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='2.097' d='M2006.555 1606.646s371.05-381.853 391.862-403.266c20.798-21.381 8.818-63.725-5.668-76.891-14.483-13.165-57.788-21.021-77.086 1.74-19.297 22.76-363.837 428.695-363.837 428.695z'/%3e%3cpath fill='%23f0e53c' d='M2334.196 1272.655a4.18 4.18 0 0 1-2.323-5.458c2.444-6.09-16.57-32.118-28.175-42.675-11.62-10.526-39.361-26.96-45.163-23.93-2.07 1.049-4.604.27-5.668-1.8a4.213 4.213 0 0 1 1.8-5.667c13.734-7.108 49.99 20.962 54.669 25.19 4.678 4.258 36.091 37.665 30.302 52.03a4.182 4.182 0 0 1-5.442 2.31'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.398' d='M2334.196 1272.655a4.18 4.18 0 0 1-2.323-5.458c2.444-6.09-16.57-32.118-28.175-42.675-11.62-10.526-39.361-26.96-45.163-23.93-2.07 1.049-4.604.27-5.668-1.8a4.213 4.213 0 0 1 1.8-5.667c13.734-7.108 49.99 20.962 54.669 25.19 4.678 4.258 36.091 37.665 30.302 52.03a4.182 4.182 0 0 1-5.442 2.31z'/%3e%3cpath fill='%23f0e53c' d='M2344.811 1263.688a5.617 5.617 0 0 1-1.889-7.198c-.075-5.638-15.653-27.529-30.767-41.265-15.115-13.734-38.402-27.14-44.039-26.659a5.573 5.573 0 0 1-7.332-1.23c-1.95-2.398-1.574-5.907.824-7.857 13.39-10.855 57.64 27.08 58.06 27.471.434.39 42.416 40.783 32.896 55.15a5.591 5.591 0 0 1-7.753 1.588'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.398' d='M2344.811 1263.688a5.617 5.617 0 0 1-1.889-7.198c-.075-5.638-15.653-27.529-30.767-41.265-15.115-13.734-38.402-27.14-44.039-26.659a5.573 5.573 0 0 1-7.332-1.23c-1.95-2.398-1.574-5.907.824-7.857 13.39-10.855 57.64 27.08 58.06 27.471.434.39 42.416 40.783 32.896 55.15a5.591 5.591 0 0 1-7.753 1.588z'/%3e%3cpath fill='%23f0e53c' d='M2393.243 1213.306c-2.383-1.919-2.833-5.428-.93-7.826 6.583-8.368-1.647-31.789-24.005-52.09-22.341-20.304-46.453-26.24-54.13-18.895a5.603 5.603 0 0 1-7.901-.179c-2.145-2.218-2.07-5.758.164-7.916 13.54-12.956 43.379-4.918 69.395 18.712 26.014 23.631 36.886 52.57 25.265 67.295-1.905 2.4-5.428 2.818-7.858.9'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.398' d='M2393.243 1213.306c-2.383-1.919-2.833-5.428-.93-7.826 6.583-8.368-1.647-31.789-24.005-52.09-22.341-20.304-46.453-26.24-54.13-18.895a5.603 5.603 0 0 1-7.901-.179c-2.145-2.218-2.07-5.758.164-7.916 13.54-12.956 43.379-4.918 69.395 18.712 26.014 23.631 36.886 52.57 25.265 67.295-1.905 2.4-5.428 2.818-7.858.9z'/%3e%3cpath fill='%23f0e53c' d='M2383.392 1221.553c-1.725-1.559-1.92-4.139-.359-5.848 1.978-3.689-1.32-27.949-25.76-50.17-24.306-22.073-48.658-23.123-52.346-20.842-1.574 1.59-4.138 1.65-5.803.148-1.71-1.558-1.845-4.226-.285-5.937 6.598-7.256 37.471-3.719 64.072 20.422 26.6 24.171 33.078 54.55 26.464 61.836-1.545 1.711-4.273 1.92-5.983.391'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.398' d='M2383.392 1221.553c-1.725-1.559-1.92-4.139-.359-5.848 1.978-3.689-1.32-27.949-25.76-50.17-24.306-22.073-48.658-23.123-52.346-20.842-1.574 1.59-4.138 1.65-5.803.148-1.71-1.558-1.845-4.226-.285-5.937 6.598-7.256 37.471-3.719 64.072 20.422 26.6 24.171 33.078 54.55 26.464 61.836-1.545 1.711-4.273 1.92-5.983.391z'/%3e%3cpath fill='none' stroke='%23473125' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.796' d='m2321.915 1281.62 7.214-13.703-13.136 1.29 6.447-14.906-14.558.63 4.424-14.874-14.215 2.758 3.253-15.683-15.325 4.738 1.41-14.424-14.395 5.847-.778-14.574-14.216 7.856.029-13.195-12.97 8.488'/%3e%3cpath fill='none' stroke='%23473125' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.844' d='m2366.48 1235.23 7.106-13.797-13.359 1.08 6.327-15.024-14.845.39 4.274-15.055-14.485 2.55 3.09-15.864-15.505 4.588 1.154-14.635-14.559 5.668-1.05-14.785-14.348 7.708-.21-13.375-13.046 8.366'/%3e%3cpath fill='%23f0e53c' d='M2017.98 1598.414a4.191 4.191 0 0 1-2.325-5.458c2.835-7.033-6.866-24.41-16.493-33.153-9.64-8.757-27.859-16.748-34.59-13.256-2.056 1.081-4.605.271-5.655-1.784a4.194 4.194 0 0 1 1.784-5.652c12.506-6.493 35.252 6.448 44.1 14.47 8.846 8.037 23.901 29.448 18.637 42.508a4.187 4.187 0 0 1-5.458 2.325'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.398' d='M2017.98 1598.414a4.191 4.191 0 0 1-2.325-5.458c2.835-7.033-6.866-24.41-16.493-33.153-9.64-8.757-27.859-16.748-34.59-13.256-2.056 1.081-4.605.271-5.655-1.784a4.194 4.194 0 0 1 1.784-5.652c12.506-6.493 35.252 6.448 44.1 14.47 8.846 8.037 23.901 29.448 18.637 42.508a4.187 4.187 0 0 1-5.458 2.325z'/%3e%3cpath fill='%23f0e53c' d='M2034.354 1581.966c-2.159-.855-3.194-3.313-2.323-5.458 2.653-6.615-7.753-24.112-17.829-33.274-10.076-9.146-28.489-17.827-34.818-14.543-2.052 1.064-4.603.268-5.652-1.8-1.079-2.054-.27-4.574 1.785-5.654 12.116-6.283 34.846 7.183 44.322 15.79 9.477 8.606 25.056 29.943 19.958 42.613-.854 2.145-3.298 3.18-5.443 2.325'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.398' d='M2034.354 1581.966c-2.159-.855-3.194-3.313-2.323-5.458 2.653-6.615-7.753-24.112-17.829-33.274-10.076-9.146-28.489-17.827-34.818-14.543-2.052 1.064-4.603.268-5.652-1.8-1.079-2.054-.27-4.574 1.785-5.654 12.116-6.283 34.846 7.183 44.322 15.79 9.477 8.606 25.056 29.943 19.958 42.613-.854 2.145-3.298 3.18-5.443 2.325z'/%3e%3cpath fill='none' stroke='%23473125' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.844' d='m2026.303 1585.549 3.628-11.816-7.241.675 3.852-9.417-8.71.585 3.134-10.376-9.913.286 1.665-10.603-10.406 2.67-.66-9.897-10.031 4.109-.255-8.726-8.996 4.739-.031-7.274-11.41 4.754'/%3e%3cg clip-path='url(%23V)' opacity='.33'%3e%3cpath fill='%23473125' d='M1987.932 1568.005s329.53-381.478 350.432-404.509c20.917-23.032 33.197-19.793 50.98-18.714-9.52-9.267-37.41-23.271-66.079 8.308-28.654 31.547-349.967 407.103-349.967 407.103z'/%3e%3c/g%3e%3cg clip-path='url(%23W)' opacity='.67'%3e%3cpath fill='%23fff' d='m2362.685 1185.567-328.916 350.695c-3.704 3.944-3.493 10.137.45 13.825.031.044.075.075.106.104 3.958 3.584 10.06 3.36 13.718-.554l324.343-346.258c3.704-3.927 3.778-10.075-.165-13.793-.044-.03-5.877-7.917-9.536-4.019'/%3e%3c/g%3e%3cpath fill='%23fff' d='M2006.42 1607.425c6.822-7.513-.044-24.86-15.325-38.746-15.294-13.885-33.21-19.058-40.05-11.545-6.822 7.527.046 24.875 15.325 38.76 15.295 13.885 33.213 19.058 40.05 11.531'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='2.097' d='M2006.42 1607.425c6.822-7.513-.044-24.86-15.325-38.746-15.294-13.885-33.21-19.058-40.05-11.545-6.822 7.527.046 24.875 15.325 38.76 15.295 13.885 33.213 19.058 40.05 11.531z'/%3e%3cpath fill='%23f0e53c' d='M1998.894 1600.602c4.723-5.187-.481-17.602-11.622-27.724-11.141-10.106-23.975-14.095-28.698-8.906-4.723 5.203.494 17.603 11.62 27.71 11.14 10.121 23.99 14.108 28.7 8.92'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='2.097' d='M1998.894 1600.602c4.723-5.187-.481-17.602-11.622-27.724-11.141-10.106-23.975-14.095-28.698-8.906-4.723 5.203.494 17.603 11.62 27.71 11.14 10.121 23.99 14.108 28.7 8.92z'/%3e%3cg clip-path='url(%23X)' opacity='.33'%3e%3cpath fill='%23473125' d='m1978.006 1597.634 6.268 3.27 13.525-14.89-3.854-5.924z'/%3e%3c/g%3e%3cg clip-path='url(%23Y)' opacity='.67'%3e%3cpath fill='%23fff' d='M1973.567 1565.006s-6.462 8.606-8.621 11.666c-2.16 3.073.9 11.844 6.207 5.652 5.309-6.193 9.493-13.255 9.493-13.255z'/%3e%3c/g%3e%3cpath fill='%23f0e53c' d='M1865.114 1113.564c4.843 5.338 4.453 13.585-.886 18.443-5.337 4.83-13.584 4.44-18.428-.9-4.843-5.308-4.453-13.585.886-18.412 5.337-4.859 13.584-4.44 18.428.87'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='2.097' d='M1865.114 1113.564c4.843 5.338 4.453 13.585-.886 18.443-5.337 4.83-13.584 4.44-18.428-.9-4.843-5.308-4.453-13.585.886-18.412 5.337-4.859 13.584-4.44 18.428.87z'/%3e%3cpath fill='%23f0e53c' d='M2245.415 1606.646s-371.05-381.853-391.863-403.266c-20.797-21.381-8.816-63.725 5.669-76.891 14.484-13.165 57.787-21.021 77.086 1.74 19.298 22.76 363.837 428.695 363.837 428.695z'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='2.097' d='M2245.415 1606.646s-371.05-381.853-391.863-403.266c-20.797-21.381-8.816-63.725 5.669-76.891 14.484-13.165 57.787-21.021 77.086 1.74 19.298 22.76 363.837 428.695 363.837 428.695z'/%3e%3cpath fill='%23f0e53c' d='M1917.773 1272.655a4.181 4.181 0 0 0 2.325-5.458c-2.445-6.09 16.569-32.118 28.175-42.675 11.62-10.526 39.36-26.96 45.163-23.93 2.067 1.049 4.603.27 5.667-1.8a4.215 4.215 0 0 0-1.8-5.667c-13.734-7.108-49.99 20.962-54.67 25.19-4.677 4.258-36.09 37.665-30.301 52.03a4.181 4.181 0 0 0 5.44 2.31'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.398' d='M1917.773 1272.655a4.181 4.181 0 0 0 2.325-5.458c-2.445-6.09 16.569-32.118 28.175-42.675 11.62-10.526 39.36-26.96 45.163-23.93 2.067 1.049 4.603.27 5.667-1.8a4.215 4.215 0 0 0-1.8-5.667c-13.734-7.108-49.99 20.962-54.67 25.19-4.677 4.258-36.09 37.665-30.301 52.03a4.181 4.181 0 0 0 5.44 2.31z'/%3e%3cpath fill='%23f0e53c' d='M1907.157 1263.688a5.635 5.635 0 0 0 1.905-7.198c.06-5.638 15.638-27.529 30.753-41.265 15.115-13.734 38.401-27.14 44.04-26.659a5.573 5.573 0 0 0 7.331-1.23c1.95-2.398 1.574-5.907-.809-7.857-13.39-10.855-57.638 27.08-58.074 27.471-.435.39-42.419 40.783-32.897 55.15a5.589 5.589 0 0 0 7.751 1.588'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.398' d='M1907.157 1263.688a5.635 5.635 0 0 0 1.905-7.198c.06-5.638 15.638-27.529 30.753-41.265 15.115-13.734 38.401-27.14 44.04-26.659a5.573 5.573 0 0 0 7.331-1.23c1.95-2.398 1.574-5.907-.809-7.857-13.39-10.855-57.638 27.08-58.074 27.471-.435.39-42.419 40.783-32.897 55.15a5.589 5.589 0 0 0 7.751 1.588z'/%3e%3cpath fill='%23f0e53c' d='M1858.725 1213.306c2.385-1.919 2.834-5.428.931-7.826-6.583-8.368 1.649-31.789 24.006-52.09 22.34-20.304 46.453-26.24 54.13-18.895 2.234 2.13 5.787 2.04 7.901-.179 2.145-2.218 2.07-5.758-.164-7.916-13.541-12.956-43.379-4.918-69.395 18.712-26.015 23.631-36.87 52.57-25.265 67.295 1.905 2.4 5.427 2.818 7.856.9'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.398' d='M1858.725 1213.306c2.385-1.919 2.834-5.428.931-7.826-6.583-8.368 1.649-31.789 24.006-52.09 22.34-20.304 46.453-26.24 54.13-18.895 2.234 2.13 5.787 2.04 7.901-.179 2.145-2.218 2.07-5.758-.164-7.916-13.541-12.956-43.379-4.918-69.395 18.712-26.015 23.631-36.87 52.57-25.265 67.295 1.905 2.4 5.427 2.818 7.856.9z'/%3e%3cpath fill='%23f0e53c' d='M1868.576 1221.553c1.726-1.559 1.92-4.139.361-5.848-1.98-3.689 1.32-27.949 25.76-50.17 24.32-22.073 48.658-23.123 52.346-20.842 1.574 1.59 4.124 1.65 5.803.148 1.71-1.558 1.843-4.226.285-5.937-6.598-7.256-37.471-3.719-64.072 20.422-26.6 24.171-33.077 54.55-26.464 61.836 1.545 1.711 4.273 1.92 5.982.391'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.398' d='M1868.576 1221.553c1.726-1.559 1.92-4.139.361-5.848-1.98-3.689 1.32-27.949 25.76-50.17 24.32-22.073 48.658-23.123 52.346-20.842 1.574 1.59 4.124 1.65 5.803.148 1.71-1.558 1.843-4.226.285-5.937-6.598-7.256-37.471-3.719-64.072 20.422-26.6 24.171-33.077 54.55-26.464 61.836 1.545 1.711 4.273 1.92 5.982.391z'/%3e%3cpath fill='none' stroke='%23473125' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.796' d='m1930.055 1281.62-7.198-13.703 13.12 1.29-6.447-14.906 14.559.63-4.424-14.874 14.215 2.758-3.253-15.683 15.323 4.738-1.41-14.424 14.395 5.847.78-14.574 14.215 7.856-.03-13.195 12.97 8.488'/%3e%3cpath fill='none' stroke='%23473125' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.844' d='m1885.49 1235.23-7.106-13.797 13.359 1.08-6.327-15.024 14.844.39-4.273-15.055 14.485 2.55-3.09-15.864 15.505 4.588-1.154-14.635 14.559 5.668 1.05-14.785 14.349 7.708.21-13.375 13.06 8.366'/%3e%3cpath fill='%23f0e53c' d='M2233.989 1598.414a4.187 4.187 0 0 0 2.323-5.458c-2.833-7.033 6.868-24.41 16.495-33.153 9.641-8.757 27.859-16.748 34.592-13.256 2.055 1.081 4.604.271 5.653-1.784 1.08-2.054.269-4.587-1.786-5.652-12.504-6.493-35.251 6.448-44.096 14.47-8.848 8.037-23.903 29.448-18.639 42.508a4.186 4.186 0 0 0 5.458 2.325'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.398' d='M2233.989 1598.414a4.187 4.187 0 0 0 2.323-5.458c-2.833-7.033 6.868-24.41 16.495-33.153 9.641-8.757 27.859-16.748 34.592-13.256 2.055 1.081 4.604.271 5.653-1.784 1.08-2.054.269-4.587-1.786-5.652-12.504-6.493-35.251 6.448-44.096 14.47-8.848 8.037-23.903 29.448-18.639 42.508a4.186 4.186 0 0 0 5.458 2.325z'/%3e%3cpath fill='%23f0e53c' d='M2217.63 1581.966c2.145-.855 3.18-3.313 2.324-5.458-2.668-6.615 7.738-24.112 17.815-33.274 10.075-9.146 28.488-17.827 34.815-14.543 2.069 1.064 4.605.268 5.653-1.8 1.08-2.054.27-4.574-1.784-5.654-12.116-6.283-34.845 7.183-44.323 15.79-9.477 8.606-25.056 29.943-19.957 42.613.853 2.145 3.298 3.18 5.457 2.325'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.398' d='M2217.63 1581.966c2.145-.855 3.18-3.313 2.324-5.458-2.668-6.615 7.738-24.112 17.815-33.274 10.075-9.146 28.488-17.827 34.815-14.543 2.069 1.064 4.605.268 5.653-1.8 1.08-2.054.27-4.574-1.784-5.654-12.116-6.283-34.845 7.183-44.323 15.79-9.477 8.606-25.056 29.943-19.957 42.613.853 2.145 3.298 3.18 5.457 2.325z'/%3e%3cpath fill='none' stroke='%23473125' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.844' d='m2225.668 1585.549-3.63-11.816 7.242.675-3.852-9.417 8.71.585-3.133-10.376 9.91.286-1.663-10.603 10.406 2.67.66-9.897 10.032 4.109.255-8.726 8.996 4.739.03-7.274 11.41 4.754'/%3e%3cg clip-path='url(%23Z)' opacity='.33'%3e%3cpath fill='%23473125' d='M2264.038 1568.005s-329.53-381.478-350.432-404.509c-20.917-23.032-33.197-19.793-50.98-18.714 9.52-9.267 37.41-23.271 66.079 8.308 28.654 31.547 349.967 407.103 349.967 407.103z'/%3e%3c/g%3e%3cg clip-path='url(%23aa)' opacity='.67'%3e%3cpath fill='%23fff' d='m1889.284 1185.567 328.916 350.695c3.705 3.944 3.495 10.137-.45 13.825-.03.044-.074.075-.104.104-3.96 3.584-10.063 3.36-13.72-.554l-324.343-346.258c-3.704-3.927-3.777-10.075.165-13.793.045-.03 5.878-7.917 9.537-4.019'/%3e%3c/g%3e%3cpath fill='%23fff' d='M2245.55 1607.425c-6.822-7.513.045-24.86 15.325-38.746 15.293-13.885 33.21-19.058 40.05-11.545 6.822 7.527-.046 24.875-15.325 38.76-15.294 13.885-33.213 19.058-40.05 11.531'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='2.097' d='M2245.55 1607.425c-6.822-7.513.045-24.86 15.325-38.746 15.293-13.885 33.21-19.058 40.05-11.545 6.822 7.527-.046 24.875-15.325 38.76-15.294 13.885-33.213 19.058-40.05 11.531z'/%3e%3cpath fill='%23f0e53c' d='M2253.076 1600.602c-4.707-5.187.48-17.602 11.622-27.724 11.14-10.106 23.99-14.095 28.698-8.906 4.723 5.203-.478 17.603-11.62 27.71-11.14 10.121-23.975 14.108-28.7 8.92'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='2.097' d='M2253.076 1600.602c-4.707-5.187.48-17.602 11.622-27.724 11.14-10.106 23.99-14.095 28.698-8.906 4.723 5.203-.478 17.603-11.62 27.71-11.14 10.121-23.975 14.108-28.7 8.92z'/%3e%3cg clip-path='url(%23ab)' opacity='.33'%3e%3cpath fill='%23473125' d='m2273.964 1597.634-6.268 3.27-13.525-14.89 3.855-5.924z'/%3e%3c/g%3e%3cg clip-path='url(%23ac)' opacity='.67'%3e%3cpath fill='%23fff' d='M2278.403 1565.006s6.463 8.606 8.621 11.666c2.16 3.073-.899 11.844-6.207 5.652-5.309-6.193-9.492-13.255-9.492-13.255z'/%3e%3c/g%3e%3cpath fill='none' stroke='%23473125' stroke-width='2.068' d='M2267.231 1772.767s-4.483-1.095-5.232-6.267'/%3e%3cpath fill='%23d32011' d='M2272.165 1772.648c0-1.184-1.215-2.144-2.73-2.144-1.514 0-2.73.96-2.73 2.144 0 1.185 1.216 2.145 2.73 2.145 1.515 0 2.73-.96 2.73-2.145'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='.689' d='M2272.165 1772.648c0-1.184-1.215-2.144-2.73-2.144-1.514 0-2.73.96-2.73 2.144 0 1.185 1.216 2.145 2.73 2.145 1.515 0 2.73-.96 2.73-2.145z'/%3e%3cpath fill='%23d32011' d='M2259.195 1770.744c-.45-1.095-1.95-1.514-3.345-.96-1.393.57-2.174 1.935-1.723 3.03.45 1.095 1.934 1.513 3.343.959 1.395-.57 2.174-1.92 1.725-3.03'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='.689' d='M2259.195 1770.744c-.45-1.095-1.95-1.514-3.345-.96-1.393.57-2.174 1.935-1.723 3.03.45 1.095 1.934 1.513 3.343.959 1.395-.57 2.174-1.92 1.725-3.03z'/%3e%3cpath fill='%23d32011' d='M2256.376 1822.384c-.45-1.095-1.935-1.529-3.344-.959-1.394.57-2.175 1.918-1.724 3.013.45 1.11 1.95 1.53 3.343.96 1.395-.57 2.175-1.919 1.725-3.014'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='.689' d='M2256.376 1822.384c-.45-1.095-1.935-1.529-3.344-.959-1.394.57-2.175 1.918-1.724 3.013.45 1.11 1.95 1.53 3.343.96 1.395-.57 2.175-1.919 1.725-3.014z'/%3e%3cpath fill='%23d32011' d='M2258.685 1822.054c.36-1.124 1.813-1.665 3.253-1.214 1.44.45 2.325 1.74 1.964 2.88-.36 1.122-1.813 1.663-3.253 1.213-1.439-.465-2.325-1.74-1.964-2.879'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='.689' d='M2258.685 1822.054c.36-1.124 1.813-1.665 3.253-1.214 1.44.45 2.325 1.74 1.964 2.88-.36 1.122-1.813 1.663-3.253 1.213-1.439-.465-2.325-1.74-1.964-2.879z'/%3e%3cpath fill='%23d32011' d='M2262.209 1725.146c-.45-1.095-1.95-1.529-3.344-.959s-2.175 1.92-1.724 3.027c.45 1.095 1.934 1.516 3.344.946 1.394-.57 2.174-1.919 1.724-3.014'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='.689' d='M2262.209 1725.146c-.45-1.095-1.95-1.529-3.344-.959s-2.175 1.92-1.724 3.027c.45 1.095 1.934 1.516 3.344.946 1.394-.57 2.174-1.919 1.724-3.014z'/%3e%3cpath fill='%23d32011' d='M2272.554 1725.206c.346-1.125-.525-2.414-1.964-2.864-1.44-.449-2.909.09-3.253 1.215-.36 1.14.524 2.414 1.964 2.88 1.44.45 2.894-.092 3.253-1.23'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='.689' d='M2272.554 1725.206c.346-1.125-.525-2.414-1.964-2.864-1.44-.449-2.909.09-3.253 1.215-.36 1.14.524 2.414 1.964 2.88 1.44.45 2.894-.092 3.253-1.23z'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='2.068' d='M2267.681 1723.766c-1.948-.224-3.493-1.784-3.673-3.732'/%3e%3cpath fill='%23d32011' d='M2238.892 1655.363c.06-1.186-1.11-2.205-2.624-2.28-1.515-.075-2.774.84-2.835 2.01-.06 1.184 1.126 2.203 2.624 2.278 1.516.075 2.79-.824 2.835-2.008'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='.689' d='M2238.892 1655.363c.06-1.186-1.11-2.205-2.624-2.28-1.515-.075-2.774.84-2.835 2.01-.06 1.184 1.126 2.203 2.624 2.278 1.516.075 2.79-.824 2.835-2.008z'/%3e%3cpath fill='%23d32011' d='M2232.175 1670.34c-1.17-.103-2.25 1.036-2.385 2.536-.12 1.514.72 2.819 1.906 2.923 1.184.105 2.248-1.035 2.383-2.533.119-1.515-.718-2.82-1.904-2.925'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='.689' d='M2232.175 1670.34c-1.17-.103-2.25 1.036-2.385 2.536-.12 1.514.72 2.819 1.906 2.923 1.184.105 2.248-1.035 2.383-2.533.119-1.515-.718-2.82-1.904-2.925z'/%3e%3cpath fill='%2300702d' d='M2224.482 1661.376c23.197 5.862 38.58 38.069 38.042 62.15-.825 36.152-2.52 66.186-5.188 91.81-.15 1.426-.27 2.835-.39 4.23-.406 4.559-.78 8.876-1.98 13.24l1.995.554c1.26-4.557 1.633-8.967 2.04-13.63.12-1.378.253-2.773.388-4.183 2.67-25.67 4.364-55.764 5.202-91.976.571-25.341-14.768-59.661-39.285-65.854z'/%3e%3cpath fill='none' stroke='%231b402f' stroke-width='.689' d='M2224.482 1661.376c23.197 5.862 38.58 38.069 38.042 62.15-.825 36.152-2.52 66.186-5.188 91.81-.15 1.426-.27 2.835-.39 4.23-.406 4.559-.78 8.876-1.98 13.24l1.995.554c1.26-4.557 1.633-8.967 2.04-13.63.12-1.378.253-2.773.388-4.183 2.67-25.67 4.364-55.764 5.202-91.976.571-25.341-14.768-59.661-39.285-65.854z'/%3e%3cpath fill='%2300702d' d='m2018.49 1651.314 10.106-1.604-9.596 24.65-3.269-22.58z'/%3e%3cpath fill='none' stroke='%231b402f' stroke-width='.689' d='m2018.49 1651.314 10.106-1.604-9.596 24.65-3.269-22.58z'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2002.402 1813.672c5.053 12.4 31.322 53.214 42.973 59.273-12.595 1.89-44.863-41.009-49-51.4'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2004.35 1835.67c5.384 19.972 25.087 37.154 37.458 42.283-10.361-13.12-23.617-27.874-30.214-43.319'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M1997.108 1824.348c3.089 14.561 17.125 45.583 25.117 52.421-3.99-11.412-6.18-19.029-6.733-31.278'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M1995.745 1814.122c3.178 17.768 13.719 32.493 31.442 37.262-14.14-10.572-27.02-32.539-28.698-50.008'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M1988.786 1793.97c5.503 12.04 27.291 45.657 40.726 52.9-8.622-11.035-25.162-35.852-29.299-52.045'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M1992.52 1787.583c-1.155 6.897-6.897 10.795 5.518 51.475.915-23.435.224-41.82-2.294-49.631m1.364.45c3 10.346 5.294 20.917 28.955 42.749-5.053-10.795-23.436-50.786-29.87-52.855'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M1986.088 1759.782c-2.294 5.744-8.967 43.888 2.518 76.981.465-18.158 8.113-51.13 9.027-66.064'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M1984.469 1738.176c-2.294 5.068-9.417 34.937-9.641 52.166 3.898-6.208 15.849-22.521 17.918-38.835 2.758 11.035-1.141 15.624 21.607 47.336-3.45-13.09-11.726-52.39-19.313-65.031'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M1992.985 1728.295c-3.688 3.223-6.897 13.33-5.292 22.985 1.604 9.656 8.501 59.978 8.501 59.978 3.223-25.97 4.603-72.617 0-81.345'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M1988.562 1696.597c-1.56 9.19-15.58 68.704-20.167 77.895 6.207-6.897 37.216-47.801 25.28-71.014'/%3e%3cpath fill='%2300702d' d='M2001.022 1685.786c-3.223 7.362-17.228 22.746-1.38 61.13-.464-20.451 1.38-61.13 1.38-61.13'/%3e%3cpath fill='none' stroke='%231b402f' stroke-width='.689' d='M2001.022 1685.786c-3.223 7.362-17.228 22.746-1.38 61.13-.464-20.451 1.38-61.13 1.38-61.13z'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M1995.745 1679.818c-6.673 4.589-23.902 25.506-30.8 50.096 5.054-6.897 30.65-29.193 33.484-43.2'/%3e%3cpath fill='%2300702d' d='M2007.23 1664.884c-2.76 8.952-8.742 26.884-7.587 38.835 1.154 11.95 10.72 54.144 10.03 63.65 1.005-13.568 1.064-38.145 0-54.46-1.064-16.312.765-39.763 7.2-56.992l1.617-4.603-9.49 5.982z'/%3e%3cpath fill='none' stroke='%231b402f' stroke-width='.689' d='M2007.23 1664.884c-2.76 8.952-8.742 26.884-7.587 38.835 1.154 11.95 10.72 54.144 10.03 63.65 1.005-13.568 1.064-38.145 0-54.46-1.064-16.312.765-39.763 7.2-56.992l1.617-4.603-9.49 5.982z'/%3e%3cpath fill='%2300702d' d='M1995.04 1682.577c-4.813 5.518-20.212 31.249-23.437 57.669 5.053-11.95 14.485-23.887 19.312-30.094 4.83-6.208 17.229-31.49 14.696-42.06z'/%3e%3cpath fill='none' stroke='%231b402f' stroke-width='.689' d='M1995.04 1682.577c-4.813 5.518-20.212 31.249-23.437 57.669 5.053-11.95 14.485-23.887 19.312-30.094 4.83-6.208 17.229-31.49 14.696-42.06z'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2019.855 1652.243c.24 8.967-3.209 42.044-3.674 51.927-.45 9.88.06 27.574-2.864 36.076-.12-5.968-4.379-29.614-3.899-39.511.466-9.911 2.864-40.214 6.54-45.972m-11.278 25.055c.016 6.658 4.56 25.266 4.95 32.388m-4.95-53.756c-4.813 7.813-29.389 39.286-36.286 47.788 5.518-3.21 28.954-13.09 44.923-48.476'/%3e%3cpath fill='%2300702d' d='M2037.098 1635.466c-8.037 2.533-48.25 22.52-66.634 52.165 14.933-12.64 46.647-33.784 61.581-37.683z'/%3e%3cpath fill='none' stroke='%231b402f' stroke-width='.689' d='M2037.098 1635.466c-8.037 2.533-48.25 22.52-66.634 52.165 14.933-12.64 46.647-33.784 61.581-37.683z'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2040.247 1625.584c-7.572.689-30.41 5.683-48.011 31.249 8.726-7.123 18.832-15.625 35.835-20.454'/%3e%3cpath fill='%2300702d' d='M2041.238 1631.102c-8.052 8.726-24.815 17.228-25.506 68.478 6.433-25.055 17.004-51.01 34.457-64.114z'/%3e%3cpath fill='none' stroke='%231b402f' stroke-width='.689' d='M2041.238 1631.102c-8.052 8.726-24.815 17.228-25.506 68.478 6.433-25.055 17.004-51.01 34.457-64.114z'/%3e%3cpath fill='%2300702d' d='M2043.996 1624.668c-11.037 4.59-35.987 21.533-46.483 34.083 11.547-7.437 33.619-18.458 45.554-23.286z'/%3e%3cpath fill='none' stroke='%231b402f' stroke-width='.689' d='M2043.996 1624.668c-11.037 4.59-35.987 21.533-46.483 34.083 11.547-7.437 33.619-18.458 45.554-23.286z'/%3e%3cpath fill='%2300702d' d='M2047.67 1629.258c-3.45 7.586-19.987 53.079-22.057 65.495 5.742-8.967 34.456-58.598 36.526-74.447 2.07-15.865 0-.93 0-.93z'/%3e%3cpath fill='none' stroke='%231b402f' stroke-width='.689' d='M2047.67 1629.258c-3.45 7.586-19.987 53.079-22.057 65.495 5.742-8.967 34.456-58.598 36.526-74.447 2.07-15.865 0-.93 0-.93z'/%3e%3cpath fill='%2300702d' d='M2023.543 1628.566c-5.982.931-28.144 8.054-34.98 23.213-1.336-4.364 4.646-25.972 43.018-31.473z'/%3e%3cpath fill='none' stroke='%231b402f' stroke-width='.689' d='M2023.543 1628.566c-5.982.931-28.144 8.054-34.98 23.213-1.336-4.364 4.646-25.972 43.018-31.473z'/%3e%3cpath fill='%2300702d' d='M2048.808 1615.477c-6.192-1.604-27.799-7.812-47.786 8.728 8.501-2.76 24.125-4.364 34.697-1.83z'/%3e%3cpath fill='none' stroke='%231b402f' stroke-width='.689' d='M2048.808 1615.477c-6.192-1.604-27.799-7.812-47.786 8.728 8.501-2.76 24.125-4.364 34.697-1.83z'/%3e%3cpath fill='%2300702d' d='M2060.758 1603.062c-5.741-1.14-22.97-3.449-32.161 8.501 6.896-3.209 16.088-3.898 25.97-.45z'/%3e%3cpath fill='none' stroke='%231b402f' stroke-width='.689' d='M2060.758 1603.062c-5.741-1.14-22.97-3.449-32.161 8.501 6.896-3.209 16.088-3.898 25.97-.45z'/%3e%3cpath fill='%2300702d' d='M2075.244 1595.715c-4.603-2.983-17.918-8.967-34.247-1.155 6.207-.225 15.639-.225 21.382 6.208z'/%3e%3cpath fill='none' stroke='%231b402f' stroke-width='.689' d='M2075.244 1595.715c-4.603-2.983-17.918-8.967-34.247-1.155 6.207-.225 15.639-.225 21.382 6.208z'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2097.076 1602.103c-2.07-5.01-17.244-18.338-45.958 3.269 10.106-.466 30.333-5.07 37.906-3.914m-37.217 12.64c-5.293-1.154-20.002-5.308-34.007 20.212 12.177-8.037 19.298-8.037 25.266-8.037'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2079.832 1604.682c-5.322-2.37-20.212-6.897-36.99 14.934 10.106-2.76 30.332-14.484 33.092-14.245'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2075.244 1607.89c-4.468-.674-33.857 8.982-40.44 23.212 10.796-5.294 27.335-12.641 36.076-16.553'/%3e%3cpath fill='%2300702d' d='M2097.076 1602.103c-5.292-2.715-25.746-1.634-35.732 9.432 11.83-2.954 17.349-3.644 25.61-2.49z'/%3e%3cpath fill='none' stroke='%231b402f' stroke-width='.689' d='M2097.076 1602.103c-5.292-2.715-25.746-1.634-35.732 9.432 11.83-2.954 17.349-3.644 25.61-2.49z'/%3e%3cpath fill='%2300702d' d='M2032.495 1642.362c2.684-5.354 10.347-22.056 31.338-25.64.571 4.692-9.805 12.684-15.938 15.984-6.134 3.298-10.602 5.218-15.4 9.656'/%3e%3cpath fill='none' stroke='%231b402f' stroke-width='.689' d='M2032.495 1642.362c2.684-5.354 10.347-22.056 31.338-25.64.571 4.692-9.805 12.684-15.938 15.984-6.134 3.298-10.602 5.218-15.4 9.656z'/%3e%3cpath fill='%2300702d' d='M2058.12 1624.205c5.398-8.503 18.263-23.047 32.283-16.344-2.07 2.564-7.347 4.498-12.865 5.143-5.518.63-19.417 11.2-19.417 11.2'/%3e%3cpath fill='none' stroke='%231b402f' stroke-width='.689' d='M2058.12 1624.205c5.398-8.503 18.263-23.047 32.283-16.344-2.07 2.564-7.347 4.498-12.865 5.143-5.518.63-19.417 11.2-19.417 11.2z'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2060.758 1633.17c.466 4.14-1.602 12.401-6.655 28.37-5.054 15.984-5.985 16.899-7.349 24.246-.928-6.432-1.617-34.922 3.435-45.493'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2071.33 1620.306c-.225 3.673-22.147 32.402-23.66 44.113.45-13.33-2.339-36.932 22.101-48.747'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2067.657 1622.375c-.69 10.106-2.07 19.522-5.519 28.024-3.447 8.502-6.88 13.105-7.121 25.28 4.603-11.26 26.03-54.07 33.602-63.486'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2075.933 1632.015c-.689 6.208-4.362 26.196-7.812 34.008 5.744-6.883 22.911-36.242 25.67-43.363'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2082.367 1626.962c-.227 5.744-1.036 17.005-3.165 24.817 4.32-8.277 7.302-11.486 11.201-16.314 3.914-4.829 12.642-17.814 9.882-22.461'/%3e%3cpath fill='%2300702d' d='M2056.636 1629.032c4.229-3.33 13.646-5.968 18.608-7.812 4.574-1.694 14.244-5.743 12.641-8.726-1.62-3-10.691-.96-15.174 1.14-4.484 2.098-16.075 15.398-16.075 15.398'/%3e%3cpath fill='none' stroke='%231b402f' stroke-width='.689' d='M2056.636 1629.032c4.229-3.33 13.646-5.968 18.608-7.812 4.574-1.694 14.244-5.743 12.641-8.726-1.62-3-10.691-.96-15.174 1.14-4.484 2.098-16.075 15.398-16.075 15.398z'/%3e%3cpath fill='%2300702d' d='M2097.526 1615.178c.48-2.805-10.707-5.008-15.16 0-4.454 5.007-8.097 13.165-10.017 21.667-1.933 8.5-4.228 16.089-5.833 18.847 4.125-4.378 7.693-12.19 12.686-20.226 5.01-8.038 17.635-16.225 18.324-20.288'/%3e%3cpath fill='none' stroke='%231b402f' stroke-width='.689' d='M2097.526 1615.178c.48-2.805-10.707-5.008-15.16 0-4.454 5.007-8.097 13.165-10.017 21.667-1.933 8.5-4.228 16.089-5.833 18.847 4.125-4.378 7.693-12.19 12.686-20.226 5.01-8.038 17.635-16.225 18.324-20.288z'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2261.835 1777.417c3.898 3.448 9.43 3.524 13.419 6.687-.57.12-1.305-.135-1.844.06 2.008 1.545 4.529 4.018 5.472 6.672-.224.24-1.11 0-1.35.225 1.515 1.635 2.699 3.973 3.75 5.968-.496.21-1.185-.164-1.68.06.765 2.744.975 5.968.12 8.743-2.803.059-5.292-1.036-7.047-3.194-.075.674.119 1.394.164 1.979-3.283-.571-6.072-2.834-6.866-6.103a9.962 9.962 0 0 0-.555 2.114c-1.89-2.37-2.7-5.503-2.595-8.546-.39.614-.57 1.303-.808 1.993-2.026-5.592 2.308-11.935-.526-16.658'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.689' d='M2269.405 1802.066c0-3.389-.135-6.972.106-10.255 2.294 1.678 5.233 2.19 7.602 3.704m.12 6.431c-2.985-2.039-5.639-5.067-7.139-8.382'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.689' d='M2264.937 1794.36c1.8-2.923 1.71-6.583 1.306-9.822 2.502 2.73 6.267 2.849 9.026 4.888m-5.757 2.385c-.646-1.17-1.8-3.929-2.28-5.144m-.989-2.129c-.676-1.378-2.551-4.198-3.615-5.217'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2257.861 1821.98c-5.489 3.553-17.71 6.852-19.733 14.02.18.225 1.05.21 1.334.48-2.82 2.052-5.233 4.917-5.218 8.53.495.27 1.005-.255 1.514.015-1.274 2.984-1.514 6.36-1.454 9.672 2.788-.884 5.503-2.519 7.407-4.694.015.705-.09 1.441-.15 2.16 1.56-1.575 3.51-2.55 5.038-4.123.061.645-.194 1.334-.15 1.98 2.175-1.455 4.14-3.66 5.368-6.074.21.39-.045 1.004.031 1.514 6.701-4.962 4.587-13.84 5.053-21.156'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.689' d='M2237.347 1849.629c3.33-2.789 4.56-7.722 8.007-10.046m-1.034 8.096c1.125-3.043 1.784-6.341 1.47-9.641-2.7 1.605-5.429 3.959-8.532 4.543m4.138-7.947c2.46-2.1 5.532-1.693 8.022-3.402-.195 3.238.974 6.22.451 9.534m-4.289-2.428c1.244-1.95 1.949-4.198 3.389-6.057m.57-1.215c1.29-2.144 3.763-3.253 5.802-4.588'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.736' d='M2256.45 1822.744c-.18 6.972-4.558 15.834.524 21.982.3-.03.81-.795 1.23-.87.106 3.719 1.185 7.573 4.364 9.776.54-.27.39-1.034.93-1.32 1.874 2.94 4.693 5.219 7.647 7.199.9-2.985 1.11-6.358.346-9.341.629.419 1.214.959 1.798 1.454-.435-2.34-.12-4.634-.584-6.928.599.345 1.064.99 1.649 1.349.03-2.803-.72-5.862-2.114-8.412.479.06.856.645 1.365.9-.345-8.892-9.448-12.476-15.61-17.363'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.736' d='M2268.58 1853.647c-.45-4.603-4.061-8.697-4.018-13.136m6.508 5.864c-1.995-2.834-4.499-5.443-7.603-7.183-.225 3.33.211 7.168-1.154 10.226m-4.499-8.47c-.374-3.435 1.846-5.864 1.846-9.087 2.728 2.159 6.073 2.954 8.681 5.443m-4.753 2.264c-.96-2.28-2.504-4.273-3.284-6.671m-.734-1.247c-1.096-2.444-.586-5.279-.525-7.872'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2258.55 1820.33c-2.684 7.513-9.882 10.766-13.03 17.393.615.075 1.14-.435 1.799-.299-.825 4.093-3.78 7.331-3.39 11.845.526-.15 1.11-.735 1.666-.826-.404 2.535-.3 5.43.6 7.53.45-.152.795-.812 1.29-.976-.69 3.3.915 6.327 1.934 9.221.735-2.309 2.235-4.364 3.764-5.952.164.63.015 1.378.209 1.903 1.275-2.309 2.34-4.993 3.614-7.287.435.481.164 1.035.554 1.56 1.755-2.324 2.369-5.443 2.416-8.412.419.465.749 1.185 1.123 1.68 1.035-3.015 1.035-6.224.585-9.433.539.645 1.064 1.245 1.529 1.995 1.335-7.12-4.798-12.34-4.138-19.762'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.689' d='M2247.874 1852.043c3.119-1.02 5.113-3.823 6.208-6.837.614 2.278 1.904 3.614 3.088 5.458m-8.787-4.65c3.525-1.558 6.193-4.752 7.378-8.276.193 2.43 1.094 4.214 1.934 6.372m-6.208-7.931c3.27-1.2 5.698-4.003 6.043-7.452-.239 3.358.586 6.793 2.234 9.52m-6.897 13.106c-.42 2.25-1.334 4.258-2.76 6.028m6.089-20.617c.479-1.05.674-2.25.585-3.45m-2.759 12.296c-.166-1.574.224-3.073 1.14-4.138'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2259.764 1778.106c-5.173 4.003-14.244 6.117-15.653 13.42.195.21 1.063.12 1.38.36-2.64 2.294-4.815 5.353-4.485 8.952.51.224.975-.346 1.5-.12-1.006 3.088-.96 6.476-.63 9.776 2.713-1.125 5.278-2.985 6.987-5.308.075.705.03 1.44.03 2.16 1.426-1.71 3.283-2.85 4.663-4.529.136.63-.075 1.35.03 1.98 2.04-1.65 3.824-3.99 4.828-6.509.24.376.06 1.005.164 1.515 6.254-5.518 3.405-14.184 3.256-21.517'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.689' d='M2244.59 1805.171c3.074-3.059 3.884-8.083 7.137-10.691m-.344 8.157c.855-3.12 1.244-6.478.63-9.73-2.534 1.812-5.068 4.391-8.112 5.247m3.449-8.262c2.277-2.31 5.382-2.174 7.705-4.08.091 3.256 1.5 6.119 1.261 9.477m-4.483-2.069c1.079-2.038 1.589-4.348 2.879-6.327m.448-1.261c1.11-2.249 3.48-3.553 5.398-5.053'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2262.584 1775.752c.479 7.961 4.873 13.48 6.057 20.707-.614-.09-.975-.72-1.65-.78-.345 4.168 1.59 8.097-.044 12.311-.45-.286-.855-1.005-1.365-1.245-.314 2.55-1.214 5.294-2.668 7.078-.39-.286-.541-1.006-.976-1.32-.24 3.36-2.624 5.832-4.408 8.321-.075-2.413-.93-4.798-1.965-6.76-.328.568-.404 1.317-.718 1.767-.601-2.564-.87-5.443-1.455-7.992-.555.33-.45.931-.974 1.334-1.035-2.728-.765-5.892.029-8.756-.54.33-1.05.944-1.558 1.305-.151-3.193.733-6.267 2.068-9.22-.705.464-1.38.898-2.024 1.483.705-7.198 8.112-10.917 9.552-18.233'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.689' d='M2262.404 1809.564c-2.715-1.844-3.854-5.098-4.064-8.291-1.23 2.008-2.834 2.938-4.499 4.377m9.731-2.023c-2.938-2.474-4.616-6.268-4.768-9.987-.87 2.265-2.233 3.735-3.628 5.578m8.157-5.893c-2.804-2.054-4.35-5.443-3.72-8.832-.704 3.285-2.457 6.343-4.797 8.518m2.969 14.499c-.226 2.28.104 4.467.976 6.567m-.107-21.501a6.988 6.988 0 0 1 .405-3.48m-.779 12.582c.601-1.471.629-3.03.044-4.29'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2264.562 1725.355c4.14 4.093 10.002 4.168 14.244 7.932-.613.135-1.378-.164-1.978.075 2.13 1.815 4.813 4.754 5.817 7.903-.239.284-1.17 0-1.425.27 1.605 1.933 2.85 4.708 3.974 7.077-.524.24-1.275-.195-1.784.075.81 3.254 1.035 7.062.12 10.346-2.968.075-5.608-1.23-7.467-3.779-.089.795.135 1.65.18 2.34-3.493-.66-6.448-3.344-7.303-7.227a13.793 13.793 0 0 0-.569 2.503c-2.009-2.804-2.879-6.523-2.745-10.136-.418.734-.614 1.56-.869 2.37-2.144-6.629 2.445-14.14-.555-19.749'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.689' d='M2272.6 1754.58c0-4.02-.15-8.262.104-12.145 2.444 1.98 5.548 2.593 8.068 4.377m.12 7.633c-3.165-2.43-5.969-6.013-7.558-9.957'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.689' d='M2267.847 1745.447c1.92-3.462 1.828-7.81 1.394-11.635 2.653 3.224 6.658 3.375 9.581 5.773m-6.117 2.85c-.676-1.396-1.905-4.665-2.415-6.104m-1.049-2.519c-.72-1.634-2.699-4.978-3.823-6.208'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2262.373 1726.181c-5.487 4.738-15.1 7.241-16.598 15.908.209.24 1.14.135 1.454.435-2.79 2.715-5.084 6.327-4.738 10.587.539.268 1.035-.39 1.589-.136-1.063 3.673-1.02 7.678-.674 11.591 2.879-1.336 5.592-3.539 7.423-6.298.06.84.028 1.71.028 2.564 1.515-2.009 3.48-3.373 4.95-5.368.119.75-.091 1.59.015 2.354 2.174-1.948 4.047-4.738 5.126-7.72.255.45.047 1.182.182 1.798 6.627-6.553 3.597-16.823 3.432-25.507'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.689' d='M2246.299 1758.253c3.254-3.613 4.109-9.58 7.542-12.67m-.36 9.672c.9-3.705 1.32-7.678.676-11.532-2.699 2.146-5.369 5.22-8.592 6.224m3.644-9.807c2.413-2.73 5.697-2.564 8.17-4.828.092 3.854 1.59 7.257 1.336 11.23m-4.752-2.458c1.139-2.415 1.693-5.144 3.043-7.482m.494-1.5c1.17-2.668 3.689-4.213 5.729-5.997'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.745' d='M2264.008 1722.866c-1.83 8.998-8.636 13.465-11.036 21.473.613.044 1.08-.6 1.768-.525-.358 4.858-2.938 8.906-2.053 14.11.51-.225 1.02-.96 1.558-1.11-.118 2.983.3 6.343 1.442 8.712.433-.226.704-1.035 1.182-1.29-.33 3.914 1.605 7.287 2.94 10.556.494-2.743 1.74-5.279 3.104-7.287.224.718.164 1.605.404 2.204 1.02-2.82 1.77-6.043 2.79-8.817.494.51.284 1.17.734 1.74 1.47-2.864 1.74-6.554 1.455-10.002.464.494.885 1.305 1.304 1.844.69-3.613.345-7.347-.479-11.035.63.705 1.214 1.35 1.753 2.174.527-8.413-6.16-13.885-6.342-22.597'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.745' d='M2256.915 1760.773c2.984-1.485 4.665-4.933 5.414-8.548.869 2.595 2.31 4.034 3.703 6.059m-9.282-4.574c3.329-2.144 5.623-6.102 6.419-10.315.464 2.789 1.559 4.798 2.638 7.212m-7.062-8.622c3.118-1.71 5.218-5.219 5.173-9.252.135 3.929 1.349 7.827 3.284 10.871m-5.382 15.894c-.167 2.653-.856 5.083-2.07 7.272m3.749-24.56c.359-1.26.419-2.684.18-4.078m-1.366 14.574c-.346-1.815-.104-3.6.69-4.918'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2240.226 1667.163c-.749 10.256-7.932 15.58-9.49 24.815.733-.06 1.168-.84 1.978-.84.33 5.428-2.053 10.302-.21 15.955.555-.33 1.035-1.215 1.65-1.47.314 3.33 1.334 7.002 3.013 9.447.481-.315.676-1.23 1.186-1.59.224 4.393 3.013 7.843 5.066 11.277.136-3.12 1.215-6.12 2.49-8.533.376.765.435 1.755.81 2.369.75-3.268 1.14-6.957 1.89-10.195.66.51.51 1.275 1.124 1.845 1.29-3.405 1.034-7.543.15-11.322.63.48 1.23 1.32 1.814 1.86.255-4.124-.736-8.202-2.265-12.191.84.689 1.62 1.334 2.385 2.158-.69-9.401-9.342-14.5-10.886-24.14'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.689' d='M2237.873 1709.626c3.269-2.083 4.678-6.162 4.993-10.27 1.425 2.728 3.314 4.122 5.248 6.163m-11.516-3.705c3.553-2.864 5.622-7.616 5.893-12.4.974 3.045 2.564 5.1 4.182 7.632m-9.565-8.532c3.373-2.369 5.278-6.552 4.603-11.02.764 4.318 2.79 8.486 5.518 11.561m-3.839 18.428c.225 2.968-.21 5.773-1.289 8.397m.585-27.83c.224-1.44.075-3.029-.405-4.529m.644 16.36c-.674-1.965-.689-3.989.03-5.563'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.757' d='M2246.299 1667.178c11.606.869 6.463 7.347 7.273 13.84.464-.496.66-1.424 1.2-1.845.345 3.224 1.334 7.692 3.464 10.675.39-.028.689-1.123 1.064-1.183.749 2.788 2.413 5.788 3.823 8.382.525-.346.556-1.35 1.095-1.665 2.34 2.879 5.518 5.563 8.892 6.793 1.784-2.804 2.205-6.18 1.049-9.627.749.434 1.366 1.2 1.949 1.695 1.44-3.794.839-8.367-2.04-11.682.826.242 1.725.616 2.505 1.05-1.258-3.747-3.973-6.956-7.168-9.177.872.076 1.696.42 2.549.69-4.497-6.326-18.967-8.981-27.468-8.981'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.757' d='M2274.864 1689.715c-3.464-2.595-7.062-5.489-10.571-7.737.299 3.613-.976 7.002-.885 10.57m6.538 5.039c-.271-4.589-1.755-9.612-4.229-13.676'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.757' d='M2269.72 1679.248c-4.108-.39-7.811-3.283-10.886-6.177 1.26 4.633-.929 8.577-.54 12.939m5.999-4.032c-.81-1.56-2.924-4.844-3.884-6.27m-1.575-2.638c-.988-1.74-2.398-4.048-5.428-5.052'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2239.191 1668.093c8.907 2.953 2.385 15.084 4.274 21.59.345-.433.96-.9 1.335-1.364.076 4.92-.825 10.497 1.664 14.92.285-.944.915-1.904 1.124-2.834-.239 4.064 1.23 8.472 3.464 11.8.57-.868 1.844-1.453 2.414-2.338 1.664 6.567 11.006 6.973 11.562 12.684 1.56-6.312 6.671-11.17 3.282-17.677.63.12 1.365-.015 1.995.089 2.054-7.077-.27-12.7-4.633-18.127.644-.031 1.304-.301 1.873-.376-1.138-6.327-6.64-10.106-12.04-12.595.691-.12 1.29-.524 1.965-.69-2.384-3.66-6.896-3.553-10.346-5.143-2.669-1.215-5.398-3.658-7.933.06'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.689' d='M2240.226 1667.643c9.567 4.018 10.571 14.528 21.832 16.073m-7.466-.69c4.978 7.737.63 14.71.689 22.761m11.83-10c-2.369-3.404-5.518-5.549-9.07-7.347m.689 7.467c5.292 5.802 1.994 14.665 6.207 21.021m-14.59-35.956c.3 4.964-2.413 9.027-1.964 13.9'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2196.954 1636.904c4.153 9.4-5.204 6.837 3.523 26.975.615-.39.63-1.29 1.349-1.68 2.85 4.649 3.029 10.06 7.302 14.185.33-.54.346-1.544.764-2.07 1.86 2.79 4.47 5.549 7.108 6.928.286-.494.016-1.41.302-1.95 2.247 3.765 6.34 5.504 9.759 7.573-1.334-2.834-1.798-5.968-1.814-8.696.69.494 1.215 1.334 1.846 1.694-.871-3.224-2.281-6.657-3.12-9.881.81.135 1.049.884 1.843 1.094-.464-3.6-2.622-7.138-5.173-10.061.78.119 1.71.585 2.476.78-1.711-3.748-4.5-6.882-7.708-9.687 1.05.226 2.039.42 3.105.795-5.024-7.992-15.055-8.426-20.948-16.223'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.689' d='M2215.067 1676.114c1.903-3.39 1.243-7.632-.405-11.425 2.517 1.754 4.857 2.084 7.526 2.984m-11.918 2.129c1.797-4.184 1.393-9.341-.617-13.705 2.28 2.219 4.647 3.298 7.271 4.769m-12.444-3.046c1.86-3.658 1.574-8.261-1.11-11.89 2.714 3.465 6.433 6.178 10.301 7.618m5.263 18.082c1.59 2.52 2.52 5.188 2.79 8.007m-12.536-24.845c-.495-1.38-1.364-2.698-2.503-3.808m8.261 14.14c-1.515-1.41-2.474-3.194-2.578-4.918'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2205.56 1634.236c6.896 4.602 13.3 14.92 22.416 13.374.15-.344-.33-1.393-.18-1.89 3.81 2.25 8.307 3.54 12.355 1.515.03-.75-.824-1.064-.794-1.83 4.033-.134 7.947-1.723 11.65-3.642-2.488-2.848-5.772-5.204-9.22-6.283.78-.404 1.664-.69 2.503-1.02-2.608-1.004-4.738-2.788-7.302-3.748.69-.434 1.604-.51 2.294-.93-2.804-1.798-6.313-2.923-9.672-3.044.33-.465 1.14-.525 1.695-.9-9.146-5.263-17.978 2.235-26.45 5.743'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.689' d='M2243.63 1640.802c-4.888-2.444-11.096-1.154-15.533-4.002m9.64-3.285c-4.003.36-8.066 1.395-11.604 3.628 3.222 2.34 7.332 4.304 9.64 7.693m-11.125-.525c-3.659-1.769-4.845-5.698-8.083-7.737 3.734-1.574 6.463-4.633 10.467-5.863m-.449 6.523c-2.85-.42-5.758-.015-8.607-.705m-1.666.001c-3.089-.36-5.653-2.715-8.23-4.424'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2195.619 1630.171c3.704 8.532 5.143 26.375 15.204 31.023.375-.195.599-1.423 1.095-1.738 2.249 4.437 5.817 8.531 11.185 9.415.539-.614-.09-1.454.45-2.099 4.079 2.535 9.01 3.72 13.96 4.5-.525-4.125-2.19-8.323-4.873-11.517 1.064.165 2.114.495 3.163.765-1.888-2.579-2.788-5.534-4.677-8.052.96.06 1.919.6 2.892.705-1.558-3.404-4.257-6.702-7.51-9.01.644-.197 1.484.298 2.278.327-5.487-10.585-19.268-9.88-30.004-12.4'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.689' d='M2231.17 1665.724c-3.193-5.323-10.181-8.277-12.641-13.676m11.727 3.495c-4.198-2.34-8.907-4.11-13.9-4.5 1.604 4.155 4.334 8.562 4.319 13.03m-10.632-7.781c-2.413-3.943-.944-8.126-2.774-12.025 4.753 1.094 9.522.224 14.305 1.799m-4.843 5.353c-2.535-2.22-5.669-3.794-8.022-6.268m-1.649-1.095c-2.819-2.339-3.75-6.058-5.159-9.236'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2156.633 1617.472c5.354 7.84-4.26 6.897 7.049 23.706.568-.451.463-1.26 1.123-1.71 3.432 3.764 4.332 8.607 9.101 11.667.255-.525.135-1.441.48-1.966 2.204 2.234 5.158 4.335 7.962 5.188.195-.494-.18-1.274.03-1.8 2.73 3.046 7.002 4.02 10.661 5.369-1.695-2.34-2.564-5.098-2.938-7.542.75.345 1.363 1.019 2.04 1.26-1.29-2.774-3.135-5.653-4.395-8.412.81 0 1.156.629 1.964.704-.93-3.178-3.539-6.027-6.447-8.276.778 0 1.77.27 2.55.345-2.19-3.12-5.368-5.533-8.923-7.573 1.08.03 2.085.06 3.193.24-6.026-6.432-16.013-5.353-22.88-11.486'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.689' d='M2179.754 1650.024c1.425-3.313.195-7.032-1.933-10.196 2.744 1.214 5.082 1.17 7.84 1.59m-11.499 3.644c1.215-4.02.135-8.592-2.43-12.207 2.565 1.65 5.038 2.265 7.842 3.209m-12.731-.915c1.366-3.553.467-7.646-2.683-10.51 3.15 2.713 7.198 4.603 11.216 5.337m7.602 15.461c1.904 2.023 3.178 4.302 3.823 6.777m-15.698-20.467c-.66-1.17-1.71-2.234-2.97-3.06m10.032 11.502c-1.693-1.05-2.863-2.52-3.194-4.05'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2152.42 1620.816c7.902-12.491 12.64-3.659 20.902-1.425-.314-.764-1.32-1.425-1.5-2.22 4.065 1.17 10.017 2.22 14.875 1.276.18-.45-.944-1.305-.81-1.755 3.794.525 9.507 2.218 13.45 1.904-.104-.75-2.414-3.389-2.474-4.138 4.843-1.215 9.927-3.464 13.407-6.613-2.31-3.358-6.12-5.428-10.917-5.818.959-.614 2.218-.944 3.164-1.335-3.69-3.433-9.536-4.961-15.205-3.373a18.86 18.86 0 0 1 2.743-2.279c-5.246-.389-10.704 1.08-15.248 3.569.598-.946 1.499-1.68 2.339-2.52-10.255 1.964-21.997 16.78-27.035 26.256'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.689' d='M2195.723 1598.849c-5.157 2.609-10.735 5.204-15.533 8.036 4.543 1.395 7.841 4.455 12.16 6.073m9.912-4.843c-5.67-1.92-12.566-2.684-18.909-1.89'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.689' d='M2180.144 1599.523c-2.908 4.394-8.563 7.107-13.854 9.132 6.311.84 9.747 5.173 15.204 6.853m-1.304-8.623c-2.325.15-7.542.916-9.807 1.305m-4.093.465c-2.67.284-6.283.734-9.281 3.613'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2159.633 1619.3c6.387 6.583 10.84 19.193 21.097 19.673.24-.33-.03-1.56.269-2.054 3.584 3.314 8.158 5.758 13.016 4.528.224-.795-.615-1.335-.405-2.144 4.408.794 9.027.015 13.495-1.17-2.01-3.674-4.993-6.972-8.473-8.936.946-.254 1.966-.36 2.954-.51-2.578-1.695-4.468-4.123-7.016-5.759.855-.315 1.859-.164 2.714-.448-2.594-2.61-6.133-4.649-9.762-5.578.48-.42 1.38-.286 2.054-.556-8.652-7.826-20.032-1.859-30.063-.074'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.689' d='M2199.337 1635.344c-4.708-3.764-11.74-3.853-15.878-7.96m11.245-1.26c-4.423-.57-9.086-.406-13.45 1.154 2.939 3.283 6.913 6.372 8.593 10.556m-11.922-3.179c-3.554-2.773-3.898-7.287-6.913-10.241 4.424-.81 8.127-3.465 12.761-3.84m-2.053 6.913c-2.985-1.124-6.24-1.379-9.162-2.789m-1.816-.388c-3.27-1.125-5.472-4.26-7.856-6.703'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2118.713 1598.594c11.441 8.92-2.684 12.385 7.046 26.99.54-.495 1.56-.435 2.204-.945 3.63 4.063 4.86 7.316 9.808 10.6.224-.6.06-1.588.374-2.173 2.325 2.413 5.4 4.663 8.247 5.547.164-.54-.255-1.38-.059-1.98 2.893 3.3 7.211 4.29 10.961 5.699-1.83-2.533-2.85-5.548-3.344-8.231.764.359 1.425 1.094 2.114 1.349-1.44-3.03-3.434-6.148-4.843-9.162.825-.015 1.184.674 2.024.736-1.11-3.451-3.883-6.538-6.912-8.967.793-.015 1.783.268 2.58.33-2.357-3.375-5.67-5.968-9.329-8.142 1.081.015 2.1.029 3.21.208-6.373-6.957-16.33-5.591-23.51-12.19'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.689' d='M2143.557 1634.236c1.261-3.675-.148-7.738-2.458-11.173 2.804 1.275 5.158 1.186 7.946 1.591m-11.335 4.243c1.005-4.453-.313-9.46-3.072-13.389 2.653 1.784 5.173 2.413 8.02 3.39m-12.806-.752c1.186-3.943.075-8.426-3.207-11.516 3.282 2.926 7.436 4.934 11.5 5.654m8.411 16.852c2.01 2.19 3.42 4.65 4.185 7.362m-16.793-22.175c-.721-1.274-1.815-2.43-3.136-3.313m10.662 12.444c-1.755-1.124-3.015-2.7-3.42-4.393'/%3e%3cpath fill='%2300702d' stroke='%231b402f' stroke-width='.689' d='M2123.405 1601.458c7.182 1.544 15.625 8.322 22.867 3.583.03-.374-.69-1.11-.703-1.604 3.881.57 8.065.06 10.87-3.223-.18-.675-.992-.645-1.2-1.336 3.374-1.603 6.208-4.468 8.756-7.526-2.937-1.62-6.401-2.49-9.626-2.16.54-.66 1.2-1.23 1.814-1.83-2.503.06-4.827-.734-7.271-.63.45-.644 1.2-1.047 1.664-1.677-2.893-.556-6.193-.27-9.072.869.15-.541.824-.87 1.17-1.41-9.282-1.29-14.53 8.607-20.647 14.86'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.689' d='M2157.489 1593.226c-4.845-.36-9.703 3.06-14.29 2.174m7.167-6.462c-3.284 1.799-6.403 4.213-8.728 7.498 3.42.884 7.454 1.108 10.408 3.268m-9.552 3.643c-3.614-.226-5.773-3.269-9.103-3.869 2.7-2.788 4.094-6.507 7.109-9.07m1.528 5.936c-2.518.69-4.843 2.114-7.467 2.564m-1.409.615c-2.715.824-5.562-.315-8.247-.885'/%3e%3cpath fill='%2300702d' d='M2117.184 1595.985c8.726 3.358 17.454-2.234 25.58 1.874-1.066.39-1.995.885-2.985 1.409 4.049.436 7.932 1.485 11.2 3.869-.733.344-1.723.539-2.443.96 3.569 1.019 7.122 2.864 9.297 5.968-.78.359-1.35-.195-2.084.239 2.294 2.474 5.158 4.768 7.482 7.228-.69.075-1.545-.361-2.37-.346 1.365 2.565 3.315 5.248 5.834 6.988-3.87.419-8.113 1.574-11.861-.45.045.736.72 1.41.735 2.07-2.88.509-6.402-.301-9.327-1.664-.09.779.39 1.739.39 2.488-5.578-.959-8.427-5.967-13.074-8.426-.406.869.013 1.724-.301 2.533-6.853-6.387-5.953-15.324-14.544-20.646-4.38-2.699-9.747-5.55-11.816-9.672-2.068-4.109-6.552-8.202-8.442-9.957v-8.456c2.759 4.303 10.166 17.228 13.27 19.807 3.104 2.595 1.095 2.504 5.459 4.184'/%3e%3cpath fill='none' stroke='%231b402f' stroke-width='.689' d='M2117.184 1595.985c8.726 3.358 17.454-2.234 25.58 1.874-1.066.39-1.995.885-2.985 1.409 4.049.436 7.932 1.485 11.2 3.869-.733.344-1.723.539-2.443.96 3.569 1.019 7.122 2.864 9.297 5.968-.78.359-1.35-.195-2.084.239 2.294 2.474 5.158 4.768 7.482 7.228-.69.075-1.545-.361-2.37-.346 1.365 2.565 3.315 5.248 5.834 6.988-3.87.419-8.113 1.574-11.861-.45.045.736.72 1.41.735 2.07-2.88.509-6.402-.301-9.327-1.664-.09.779.39 1.739.39 2.488-5.578-.959-8.427-5.967-13.074-8.426-.406.869.013 1.724-.301 2.533-6.853-6.387-5.953-15.324-14.544-20.646-4.38-2.699-9.747-5.55-11.816-9.672-2.068-4.109-6.552-8.202-8.442-9.957v-8.456c2.759 4.303 10.166 17.228 13.27 19.807 3.104 2.595 1.095 2.504 5.459 4.184z'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.689' d='M2151.415 1622.255c-.104-4.514-2.758-8.084-6.013-10.542 2.969-.074 5.069-1.363 7.723-2.368m-8.802 10.241c-.6-5.219-3.494-9.822-7.332-12.566 3.014.525 5.503-.089 8.411-.51m-11.831 5.714c-.269-4.77-2.788-8.936-6.821-10.527 3.973 1.425 8.412 1.425 12.31.135m13.33 13.51c2.563 1.29 4.662 3.178 6.298 5.667m-22.717-14.904c-1.079-.974-2.46-1.634-3.958-1.904m13.854 7.723c-1.964-.3-3.628-1.32-4.572-2.895'/%3e%3cpath fill='%2300702d' d='M2105.892 1623.724c2.895-8.937 4.962-16.299 10.707-22.956 5.757-6.658 13.448-16.779 13.913-22.522.421-5.398.33-7.692.33-9.986-2.294 1.604-7.226 6.088-5.968 11.365.751 3.134-.809 5.053-2.128 7.123-1.32 2.07-9.596 14.155-19.238 19.432z'/%3e%3cpath fill='none' stroke='%231b402f' stroke-width='.689' d='M2105.892 1623.724c2.895-8.937 4.962-16.299 10.707-22.956 5.757-6.658 13.448-16.779 13.913-22.522.421-5.398.33-7.692.33-9.986-2.294 1.604-7.226 6.088-5.968 11.365.751 3.134-.809 5.053-2.128 7.123-1.32 2.07-9.596 14.155-19.238 19.432z'/%3e%3cpath fill='%23f0e53c' d='M2130.154 1569.864c-.227 2.76-.106 6.897-.689 8.728-.572 1.844-4.125 3.328-3.675-.69.465-4.019 1.62-4.934 4.364-8.038'/%3e%3cpath fill='%2300702d' d='M2111.096 1600.843c-4.034 1.77-10.376-1.186-14.02-2.145-3.66-.944-2.76-4.349-8.277.705-1.38 1.26-5.743 1.71-5.218 1.83 3.494.87 9.116 1.738 2.458 6.627-1.604 1.185-5.846 3.48-5.846 3.48s3.328-2.295 7.692 1.153c4.362 3.434 8.187-1.739 9.64 2.684 1.47 4.424 7.483-1.694 8.802-5.068 1.32-3.373 4.769-9.266 4.769-9.266'/%3e%3cpath fill='none' stroke='%231b402f' stroke-width='.689' d='M2111.096 1600.843c-4.034 1.77-10.376-1.186-14.02-2.145-3.66-.944-2.76-4.349-8.277.705-1.38 1.26-5.743 1.71-5.218 1.83 3.494.87 9.116 1.738 2.458 6.627-1.604 1.185-5.846 3.48-5.846 3.48s3.328-2.295 7.692 1.153c4.362 3.434 8.187-1.739 9.64 2.684 1.47 4.424 7.483-1.694 8.802-5.068 1.32-3.373 4.769-9.266 4.769-9.266z'/%3e%3cpath fill='%2300702d' d='M2095.636 1613.139c-3.613.974 10.857-8.922 12.011-.135.495 3.883-3 17.633-7.588 24.756-4.603 7.12-8.276 14.02-9.656 19.072.24-5.967 5.518-19.522 6.673-23.662 1.139-4.138 1.919-13.284 1.995-14.574.073-1.29-2.356-5.758-3.435-5.457'/%3e%3cpath fill='none' stroke='%231b402f' stroke-width='.689' d='M2095.636 1613.139c-3.613.974 10.857-8.922 12.011-.135.495 3.883-3 17.633-7.588 24.756-4.603 7.12-8.276 14.02-9.656 19.072.24-5.967 5.518-19.522 6.673-23.662 1.139-4.138 1.919-13.284 1.995-14.574.073-1.29-2.356-5.758-3.435-5.457z'/%3e%3cpath fill='%23f0e53c' d='m2218.68 1490.545-195.197-18.233c-9.28-19.252-16.569-41.025-21.336-64.475l248.125-2.146c-6.268 32.074-17.274 61.087-31.593 84.854'/%3e%3cpath fill='%2300a0e1' d='M2125.985 1555.02c-26.66 0-51.76-13.81-72.678-37.14l134.26 11.155c-18.458 16.508-39.48 25.985-61.582 25.985'/%3e%3cpath fill='%23fff' d='m2187.566 1529.035-134.259-11.155c-11.32-12.61-21.382-28.04-29.824-45.568l195.196 18.233c-9.146 15.159-19.627 28.204-31.113 38.49m68.614-184.858c0 21.292-2.085 41.954-5.908 61.514l-248.125 2.145c-4.094-20.176-6.343-41.587-6.343-63.659z'/%3e%3cpath fill='%23f0e53c' d='M2038.208 1433.476c0 12.236 9.927 22.176 22.162 22.176 12.25 0 22.176-9.94 22.176-22.176 0-12.25-9.926-22.178-22.176-22.178-12.235 0-22.162 9.927-22.162 22.178'/%3e%3cpath fill='none' stroke='%23fff' stroke-width='5.761' d='M2038.208 1433.476c0 12.236 9.927 22.176 22.162 22.176 12.25 0 22.176-9.94 22.176-22.176 0-12.25-9.926-22.178-22.176-22.178-12.235 0-22.162 9.927-22.162 22.178z'/%3e%3cpath fill='%23d9c753' d='M1974.976 1371.239c12.505 5.607 28.338 19.222 38.34 20.332 10.002 1.109 14.995 9.506 20.002 12.288 4.993 2.804 24.157 18.638 32.492 19.583 8.339.928 6.674 2.788 15.836 7.45 9.175 4.664 14.168 4.664 24.994 10.242 10.843 5.609 17.514 13.06 20.843 12.116 3.328-.93 10.841-5.578 17.5-8.382 6.672-2.79 20.841-8.381 30.841-13.975 10.002-5.592 12.506-2.804 24.997-8.396 12.505-5.593 32.507-19.808 43.335-24.36 10.839-4.527 35.4-13.853 47.696-16.643v-95.065h-316.876z'/%3e%3cpath fill='%23b2aa00' d='M1958.587 1342.13c8.382 2.938-1.365 4.23 12.054 9.865 13.406 5.67 21.802 5.67 21.802 5.67s6.704 7.137 13.406 7.737c6.702.629 15.924 3.989 19.28 6.507 0 0 2.52-3.987 11.743 4.709h10.06l8.383 4.739h22.625l20.348 1.438s3.328 5.878 9.102 5.878c5.757 0 30.917-11.217 30.917-11.217h9.22s14.247-6.387 19.284-6.387c5.023 0 14.245-1.678 14.245-1.678l21.8-9.208 10.887-.838s8.382-8.668 19.284-11.036c10.9-2.4 20.96-7.678 25.16-10.497v-37.995h-300.576z'/%3e%3cpath fill='%2300702d' d='M1996.606 1319.125c8.112-102.711 63.966-185.74 129.177-185.74 65.36 0 121.32 82.799 129.236 185.81z'/%3e%3cpath fill='%23c8d700' d='m1987.932 1319.136 169.315.06c-11.093-15.057-98.376-59.527-163.241-42.253-64.867 17.302-6.074 42.193-6.074 42.193'/%3e%3cg clip-path='url(%23ad)' opacity='.28'%3e%3cpath fill='%23292723' d='M2029.961 1183.799s128.636 31.097 202.588 13.165l-36.196-44.564s-85.918 8.786-132.58-3.149c-46.662-11.965-33.812 34.548-33.812 34.548'/%3e%3c/g%3e%3cpath fill='%230079c7' d='M2125.985 1133.326c-71.898 0-130.18 94.405-130.18 210.852 0 116.439 58.282 210.842 130.18 210.842 71.897 0 130.181-94.403 130.181-210.842 0-116.447-58.284-210.852-130.18-210.852m129.714 390.596c-33.856 51.536-79.918 79.92-129.715 79.92-49.782 0-95.859-28.384-129.716-79.92-31.789-48.357-49.286-112.202-49.286-179.744 0-67.565 17.497-131.411 49.286-179.783 33.857-51.52 79.934-79.89 129.716-79.89 49.797 0 95.86 28.37 129.715 79.89 31.79 48.372 49.287 112.218 49.287 179.783 0 67.542-17.497 131.387-49.287 179.744'/%3e%3cpath d='m1982.909 1281.56 4.049-12.475h13.104l-10.6-7.707 4.049-12.475-10.602 7.707-10.601-7.707 4.049 12.475-10.602 7.707h13.107zm15.369-51.01 5.383-11.937 13.03 1.441-9.686-8.816 5.383-11.966-11.38 6.507-9.703-8.816 2.67 12.834-11.382 6.508 13.016 1.41zm22.522-43.843 7.573-10.707 12.504 3.898-7.841-10.494 7.57-10.706-12.413 4.197-7.843-10.496.166 13.105-12.402 4.228 12.52 3.87zm28.773-41.145 10.317-8.067 10.87 7.318-4.483-12.296 10.317-8.097-13.09.48-4.499-12.325-3.599 12.595-13.104.48 10.87 7.316zm39.392-27.559 12.819-2.76 6.569 11.337 1.348-13.045 12.82-2.73-11.994-5.337 1.349-13.016-8.758 9.747-11.98-5.308 6.583 11.336zm185.374 163.557-4.05-12.475h-13.103l10.6-7.707-4.048-12.475 10.6 7.707 10.617-7.707-4.062 12.475 10.6 7.707h-13.105zm-15.369-51.01-5.384-11.937-13.03 1.441 9.702-8.816-5.397-11.966 11.38 6.507 9.7-8.816-2.653 12.834 11.38 6.508-13.028 1.41zm-22.522-43.843L2228.89 1176l-12.519 3.898 7.843-10.494-7.558-10.706 12.4 4.197 7.857-10.496-.18 13.105 12.415 4.228-12.519 3.87zm-28.758-41.145-10.333-8.067-10.855 7.318 4.468-12.296-10.317-8.097 13.106.48 4.484-12.325 3.613 12.595 13.09.48-10.87 7.316zm-39.406-27.559-12.805-2.76-6.583 11.337-1.35-13.045-12.804-2.73 11.98-5.337-1.35-13.016 8.758 9.747 11.98-5.308-6.568 11.336z'/%3e%3cpath fill='%23f0e53c' d='m1981.47 1283 4.049-12.475h13.105l-10.602-7.708 4.049-12.474-10.601 7.707-10.601-7.707 4.048 12.474-10.601 7.708h13.105zm15.37-51.011 5.381-11.935 13.031 1.439-9.687-8.816 5.383-11.965-11.38 6.506-9.7-8.816 2.667 12.836-11.38 6.507 13.03 1.41zm22.52-43.842 7.572-10.707 12.506 3.898-7.843-10.496 7.558-10.706-12.4 4.2-7.842-10.497.164 13.105-12.4 4.228 12.52 3.87zm28.775-41.144 10.315-8.067 10.872 7.316-4.484-12.294 10.315-8.1-13.09.483-4.498-12.327-3.598 12.595-13.105.48 10.871 7.318zm39.389-27.562 12.821-2.757 6.567 11.334 1.35-13.045 12.82-2.728-11.996-5.308 1.35-13.045-8.757 9.745-11.98-5.307 6.581 11.336zM2272.9 1283l-4.049-12.475h-13.105l10.6-7.708-4.049-12.474 10.603 7.707 10.616-7.707-4.064 12.474 10.6 7.708h-13.105zm-15.37-51.011-5.383-11.935-13.029 1.439 9.7-8.816-5.398-11.965 11.381 6.506 9.702-8.816-2.668 12.836 11.393 6.507-13.029 1.41zm-22.522-43.842-7.556-10.707-12.52 3.898 7.842-10.496-7.558-10.706 12.4 4.2 7.843-10.497-.166 13.105 12.402 4.228-12.507 3.87zm-28.759-41.144-10.33-8.067-10.871 7.316 4.483-12.294-10.316-8.1 13.105.483 4.484-12.327 3.598 12.595 13.105.48-10.87 7.318zm-39.406-27.562-12.804-2.757-6.584 11.334-1.348-13.045-12.805-2.728 11.98-5.308-1.35-13.045 8.758 9.745 11.98-5.307-6.567 11.336z'/%3e%3cpath fill='%231b402f' d='M2255.221 1319.136c.63 8.247.96 16.584.96 25.041'/%3e%3cpath fill='%23f0e53c' d='M2125.985 1553.22c-69.588 0-128.38-95.737-128.38-209.042 0-113.328 58.792-209.052 128.38-209.052s128.396 95.724 128.396 209.052c0 113.305-58.808 209.043-128.396 209.043m0-421.693c-71.539 0-131.98 97.373-131.98 212.65 0 115.253 60.441 212.642 131.98 212.642 71.554 0 131.995-97.39 131.995-212.642 0-115.277-60.44-212.65-131.995-212.65'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.44' d='M2125.985 1553.22c-69.588 0-128.38-95.737-128.38-209.042 0-113.328 58.792-209.052 128.38-209.052s128.396 95.724 128.396 209.052c0 113.305-58.808 209.043-128.396 209.043zm0-421.692c-71.539 0-131.98 97.373-131.98 212.65 0 115.253 60.441 212.642 131.98 212.642 71.554 0 131.995-97.39 131.995-212.642 0-115.277-60.44-212.65-131.995-212.65z'/%3e%3cpath d='M1992.58 1408.835c.028 1.572-.696 2.822-2.173 3.75a12.868 12.868 0 0 1-4.808 1.83c-1.566.26-3.173-.016-4.835-.808-1.65-.79-2.662-1.927-3.024-3.391a60.763 60.763 0 0 1-.765-3.422c-.151-.805-.265-1.411-.327-1.823l-.38-2.294 15.313-2.525.139.824c.276 1.656.485 3.06.627 4.18.14 1.12.216 2.338.232 3.679m-16.353.056c.09 1.984-.407 3.409-1.48 4.238-1.074.848-2.527 1.44-4.35 1.733-1.486.247-2.967.05-4.498-.577-1.505-.642-2.479-1.567-2.884-2.802a29.87 29.87 0 0 1-.946-3.507 275.384 275.384 0 0 0-.559-2.868l14.015-2.328c.143.886.286 1.796.428 2.682.128.906.23 2.065.274 3.429m17.605-.333-5.7-34.022-.688.129.358 2.165.232 2.87c.09.946-.006 1.698-.288 2.302-.268.604-.857 1.043-1.756 1.319l-1.977.488-20.539 3.38-2.019.184c-.938.015-1.645-.195-2.122-.72-.46-.477-.825-1.201-1.082-2.207a51.104 51.104 0 0 1-.602-2.66 46.845 46.845 0 0 0-.429-2.217l-.688.132 5.29 32.15c.72 4.35 1.385 7.739 2.003 10.168.617 2.428 1.402 4.409 2.367 5.947.965 1.514 2.047 2.66 3.217 3.437 1.183.755 2.491 1.016 3.91.78 2.104-.365 3.457-1.585 4.053-3.72.612-2.113.897-4.202.874-6.22-.025-2.018-.275-4.467-.752-7.346l.337-.044c.572 3.377 1.072 5.898 1.513 7.562a33.558 33.558 0 0 0 1.73 4.938 10.538 10.538 0 0 0 3.183 4.09c1.42 1.103 3.06 1.489 4.937 1.179 1.823-.292 3.217-1.23 4.213-2.768.981-1.538 1.606-3.417 1.846-5.594.254-2.178.158-4.8-.246-7.817a321.177 321.177 0 0 0-1.175-7.885m1.675 92.026c-2.815-.067-5.02-1.634-6.606-4.662-.815-1.559-1.194-3.04-1.162-4.512.02-1.457.467-2.8 1.323-4.055.86-1.237 2.142-2.48 3.84-3.765 1.7-1.267 3.525-2.412 5.449-3.478 2.67-1.423 4.924-2.437 6.769-3.02a18.262 18.262 0 0 1 5.887-.77c2.08.043 3.916 1.59 5.506 4.638.81 1.537 1.194 3.04 1.174 4.495-.034 1.451-.478 2.815-1.338 4.052-.86 1.237-2.138 2.497-3.84 3.764-1.701 1.267-3.526 2.411-5.45 3.476-2.305 1.233-4.35 2.196-6.181 2.86-1.816.665-3.601.991-5.371.977m20.499 13.271c4.126-2.224 6.268-6.622 6.414-13.177.15-6.533-1.571-13.259-5.174-20.137-3.737-7.159-8.247-12.389-13.521-15.729-5.255-3.317-9.986-3.833-14.192-1.569-4.34 2.352-6.56 6.714-6.664 13.086-.105 6.371 1.65 13.025 5.295 19.991 3.643 6.946 8.127 12.188 13.46 15.715 5.336 3.526 10.14 4.134 14.382 1.82m48.032 27.925c2.137 1.84 3.747 4.292 4.83 7.338 1.061 3.039 1.713 6.069 1.967 9.06.237 3 .252 5.945.053 8.865l.844.736 10.251-11.906-38.87-33.101-.445.543c.275.233.668.583 1.181 1.05.511.454 1.264 1.175 2.24 2.159.996.975 1.581 1.813 1.794 2.497.213.684.094 1.429-.399 2.209l-1.207 1.627-13.62 15.847-1.426 1.429c-.723.625-1.39.905-2.002.86-.613-.031-1.343-.367-2.193-.98a41.28 41.28 0 0 1-2.132-1.618 37.73 37.73 0 0 0-1.579-1.277l-.467.519 25.883 22.259.463-.538-3.45-3.14c-1.014-.981-1.594-1.771-1.765-2.377-.15-.6.027-1.311.55-2.144l1.208-1.626 16.75-19.476zm78.853 23.455-33.227-.261v.706c.348.005.786.005 1.348.029.56.026 1.486.084 2.792.204 1.287.106 2.214.356 2.743.744.548.39.89 1.033 1.042 1.945l.132 2.023.054 20.892-.153 2.025c-.137.938-.452 1.589-.943 1.951-.495.362-1.462.598-2.924.694l-3.807.15v.707l33.01.255-.002-.693-3.806-.162c-1.46-.107-2.442-.32-2.935-.665-.493-.345-.807-1.013-.942-2.003l-.153-2.026-.035-21.081.128-2.013c.144-.965.478-1.613 1.011-1.959.552-.329 1.538-.551 3-.647l3.67-.108zm85.187-17.369c-.365.251-.762.537-1.211.878-.445.325-1.194.83-2.203 1.474-1.013.662-1.983 1.11-2.874 1.337-.91.23-1.916.16-3.054-.17l-3.788-1.325-26.874-10.757-5.712 4.518 4.528 28.551.437 4.028c.038 1.181-.078 2.12-.353 2.831-.262.727-.848 1.49-1.75 2.317l-2.164 1.942.445.535 25.595-20.259-.444-.535-2.538 1.786a27 27 0 0 1-2.205 1.246c-.6.276-1.128.123-1.62-.472-.311-.422-.62-1.329-.895-2.76-.273-1.432-.61-3.457-.978-6.095-.371-2.639-.9-6.558-1.571-11.745a622.156 622.156 0 0 1 9.275 3.568c3.18 1.244 5.427 2.168 6.728 2.804 1.296.655 2.143 1.213 2.544 1.721.467.566.57 1.14.309 1.72-.263.58-.654 1.142-1.18 1.687a19.64 19.64 0 0 1-1.634 1.525c-.56.451-1.082.897-1.531 1.287l.436.554 14.719-11.639zm12.885-79.281-16.011 29.11.616.335c.16-.288.389-.68.668-1.153.287-.495.775-1.279 1.499-2.359.709-1.077 1.368-1.78 1.966-2.069.58-.287 1.324-.277 2.179.034l1.842.845 18.345 10.012 1.708 1.091c.76.572 1.182 1.156 1.275 1.772.082.597-.18 1.575-.775 2.896l-1.68 3.425.616.335 15.902-28.906-.627-.352-1.948 3.276c-.778 1.241-1.431 1.981-1.97 2.266-.533.262-1.27.232-2.212-.129l-1.844-.845-18.503-10.076-1.71-1.09c-.783-.59-1.18-1.217-1.23-1.835-.026-.642.25-1.62.85-2.962l1.655-3.268zm29.043-56.371 9.46 8.069-11.783 3.9zm-3.32 12.295-4.91 1.298c-1.141.274-2.007.354-2.613.24-.658-.13-1.067-.47-1.224-1.05-.16-.575-.21-1.29-.141-2.142.056-.852.15-1.683.269-2.456.118-.793.25-1.567.365-2.318l-.7-.126-3.788 19.59.699.127.958-4.064c.41-1.517.87-2.64 1.392-3.363.508-.703 1.082-1.221 1.707-1.51a67.6 67.6 0 0 1 2.194-.965 27.262 27.262 0 0 1 2.279-.845l27.293-8.63 1.465-7.62-21.907-19.174-2.952-2.815c-.784-.772-1.293-1.572-1.547-2.308-.267-.737-.334-1.747-.225-2.941l.384-2.868-.7-.147-6.357 32.905.699.126c.1-.558.209-1.056.313-1.488.09-.441.304-1.223.655-2.355.324-1.127.647-1.92.933-2.412.282-.448.722-.658 1.327-.545.647.11 1.478.624 2.54 1.5l4.11 3.33z'/%3e%3cpath fill='%23f0e53c' d='M1991.996 1409.852c.027 1.574-.697 2.825-2.174 3.754a12.801 12.801 0 0 1-4.807 1.826c-1.566.26-3.175-.016-4.837-.806-1.648-.79-2.661-1.927-3.024-3.393a63.938 63.938 0 0 1-.763-3.4c-.152-.825-.265-1.433-.328-1.842l-.378-2.294 15.311-2.535.138.822c.279 1.667.488 3.072.628 4.19.141 1.12.218 2.34.234 3.678m-16.354.056c.089 1.984-.408 3.411-1.48 4.26-1.072.848-2.527 1.418-4.35 1.711-1.486.25-2.981.051-4.497-.574-1.504-.624-2.479-1.567-2.884-2.804-.42-1.26-.727-2.42-.946-3.506a332.66 332.66 0 0 0-.559-2.868l14.015-2.328c.142.887.284 1.794.427 2.683.128.905.231 2.063.274 3.426m17.592-.333-5.674-34.02-.702.13.359 2.163c.078.986.155 1.928.232 2.871.076.944-.021 1.696-.288 2.3-.269.605-.859 1.044-1.757 1.32l-1.977.487-20.537 3.38-2.019.184c-.94.017-1.646-.195-2.122-.717-.461-.48-.825-1.2-1.083-2.21a49.75 49.75 0 0 1-.602-2.659c-.152-.824-.285-1.56-.428-2.215l-.688.132 5.29 32.148c.717 4.35 1.385 7.74 2.002 10.17.618 2.428 1.402 4.41 2.368 5.944.966 1.538 2.045 2.661 3.229 3.438 1.171.756 2.479 1.015 3.896.782 2.106-.344 3.458-1.585 4.055-3.722.61-2.114.898-4.179.873-6.22-.024-2.019-.274-4.468-.751-7.347l.337-.044c.572 3.38 1.072 5.9 1.513 7.565a32.794 32.794 0 0 0 1.728 4.935 10.385 10.385 0 0 0 3.183 4.091c1.42 1.102 3.061 1.488 4.937 1.181 1.825-.292 3.219-1.23 4.214-2.769.982-1.54 1.606-3.417 1.845-5.596.241-2.177.158-4.799-.244-7.817a264.935 264.935 0 0 0-1.189-7.885m1.448 90.991c-2.815-.067-5.018-1.635-6.605-4.664-.812-1.537-1.194-3.04-1.177-4.515.034-1.451.481-2.795 1.337-4.052.86-1.237 2.142-2.477 3.841-3.765 1.701-1.266 3.525-2.41 5.45-3.475 2.667-1.425 4.922-2.437 6.766-3.023a18.316 18.316 0 0 1 5.903-.767c2.067.04 3.903 1.586 5.493 4.635.81 1.537 1.193 3.041 1.173 4.495a7.286 7.286 0 0 1-1.339 4.052c-.86 1.237-2.137 2.497-3.838 3.765a45.553 45.553 0 0 1-5.45 3.477c-2.307 1.233-4.352 2.194-6.182 2.859-1.816.666-3.602.992-5.372.978m20.5 13.27c4.141-2.221 6.268-6.623 6.415-13.176.15-6.534-1.574-13.259-5.172-20.118-3.755-7.18-8.249-12.408-13.523-15.748-5.258-3.319-9.987-3.834-14.194-1.568-4.339 2.352-6.56 6.713-6.664 13.083-.104 6.371 1.651 13.028 5.297 19.991 3.643 6.946 8.126 12.191 13.46 15.717 5.336 3.526 10.139 4.134 14.382 1.819m47.983 28.049c2.138 1.84 3.749 4.293 4.81 7.333a36.197 36.197 0 0 1 1.987 9.065c.237 3.002.254 5.946.052 8.864l.863.742 10.235-11.91-38.852-33.096-.465.538c.274.232.669.582 1.18 1.05.512.454 1.265 1.175 2.243 2.159.993.973 1.58 1.814 1.794 2.496.213.684.092 1.43-.4 2.21l-1.21 1.625-13.617 15.849-1.426 1.428c-.723.624-1.391.906-2.001.876-.613-.046-1.345-.384-2.195-.995a41.012 41.012 0 0 1-2.132-1.62c-.568-.486-1.111-.901-1.58-1.277l-.464.522L2047.87 1570l.463-.538-3.451-3.141c-1.012-.98-1.595-1.77-1.763-2.375-.152-.601.026-1.311.549-2.144l1.209-1.626 16.749-19.477zm78.463 23.507-33.23-.263.003.707c.326.004.784.005 1.346.03.562.025 1.488.084 2.794.204 1.287.106 2.215.354 2.74.742.552.39.89 1.035 1.024 1.943l.153 2.027.055 20.89-.134 2.027c-.157.938-.471 1.588-.965 1.949-.492.363-1.461.598-2.924.708l-3.805.138v.707l33.01.255-.004-.693-3.804-.162c-1.461-.108-2.441-.322-2.934-.667-.494-.343-.807-1.011-.965-2.005l-.131-2.023-.058-21.082.149-2.011c.144-.966.48-1.614 1.013-1.96.53-.331 1.538-.55 2.998-.646l3.669-.108zm85.36-16.679c-.365.25-.761.537-1.212.879a61.69 61.69 0 0 1-2.208 1.49c-1.008.645-1.978 1.091-2.869 1.318-.907.23-1.915.161-3.052-.17l-3.789-1.324-26.875-10.758-5.711 4.52 4.527 28.551.438 4.027c.019 1.183-.097 2.12-.353 2.83-.263.727-.847 1.49-1.768 2.321l-2.145 1.938.437.552 25.595-20.258-.436-.554-2.539 1.788a27.27 27.27 0 0 1-2.205 1.246c-.601.277-1.13.124-1.619-.473-.314-.42-.621-1.327-.895-2.759-.275-1.43-.609-3.458-.98-6.096s-.898-6.559-1.588-11.743a528.606 528.606 0 0 1 9.292 3.565c3.182 1.245 5.423 2.186 6.724 2.824 1.3.636 2.149 1.194 2.55 1.702.467.566.568 1.14.307 1.72-.261.581-.654 1.142-1.177 1.686a19.814 19.814 0 0 1-1.636 1.527c-.558.45-1.082.898-1.533 1.287l.437.553 14.72-11.637zm13.138-79.343-16.013 29.112.617.333c.16-.288.388-.678.669-1.153.285-.493.775-1.277 1.498-2.357.709-1.079 1.363-1.76 1.965-2.069.583-.289 1.325-.277 2.179.034l1.843.845 18.346 10.01 1.708 1.09c.758.573 1.18 1.16 1.273 1.773.083.597-.178 1.576-.772 2.896l-1.697 3.43.632.33 15.9-28.904-.625-.354-1.948 3.276c-.78 1.241-1.437 2.003-1.971 2.266-.533.264-1.268.233-2.213-.129l-1.843-.845-18.504-10.074-1.71-1.09c-.783-.59-1.193-1.215-1.226-1.837-.03-.64.247-1.62.847-2.96l1.656-3.27zm29.329-56.196 9.46 8.071-11.771 3.9zm-3.305 12.293-4.911 1.3c-1.14.274-2.01.354-2.613.241-.658-.13-1.067-.473-1.226-1.049-.157-.579-.208-1.293-.138-2.144.054-.852.15-1.685.267-2.456.119-.795.249-1.567.353-2.317l-.687-.127-3.79 19.591.7.126.957-4.063c.413-1.52.87-2.64 1.392-3.344.51-.723 1.084-1.24 1.708-1.533.625-.289 1.36-.61 2.194-.962a27.899 27.899 0 0 1 2.267-.844l27.305-8.63 1.464-7.6-21.905-19.195-2.967-2.813c-.768-.776-1.277-1.574-1.532-2.312-.266-.738-.34-1.703-.224-2.939l.382-2.869-.697-.146-6.36 32.903.7.126c.1-.559.21-1.054.299-1.487a50.09 50.09 0 0 1 .656-2.353c.336-1.13.66-1.923.946-2.413.283-.45.722-.66 1.328-.546.645.11 1.477.625 2.54 1.5l4.11 3.331z'/%3e%3cpath fill='%2374b500' stroke='%231b402f' stroke-linecap='round' stroke-miterlimit='8' stroke-width='.666' d='M2196.904 1317.706c7.107 31.757 29.836 42.062 34.886 41.623-1.215.746-1.848 1.053-3.265 1.206 0 0 2.213 1.08 4.425 2.375l-5.574-1.073 2.524 3.216c-2.754-1.09-4.915-2.806-4.915-2.806l.912 3.085-4.709-3.916.996 3.198c-5.305-3.85-8.193-8.231-8.193-8.231l.217 3.287c-3.908-4.992-16.56-30.9-17.99-40.465'/%3e%3cpath fill='%2374b500' d='M2136.746 1304.693c5.436 8.296 15.252 16.386 24.27 19.873-1.017.703-2.256 1.228-4.355 1.849 8.235.726 36.584 8.02 40.862-5.299.135-.42.15-.869.196-1.259-6.404 11.575-22.613 10.465-34.113-8.277-.286.449.044 1.439-.12 1.919-2.67-2.369-5.398-5.098-7.752-7.677.27 1.233.51 3.148.51 5.383-.911-2.06-3.001-5.466-4.55-7.221.487 1.829.514 2.794.528 4.443-.93-2.838-2.87-5.549-4.038-7.282.196 1.98.349 3.306.262 5.207-1.05-2.488-2.655-4.342-4.38-6.078.48 1.515.999 3.389 1.075 4.438-1.121-1.831-2.886-3.359-4.012-4.618.225 1.079 1.163 3.255 1.343 4.184-1.71-1.482-3.527-3.194-5.301-4.184.363 1.363 1.857 4.019 3.958 5.878-1.79-.24-2.796-.482-4.383-1.279'/%3e%3cpath fill='none' stroke='%231b402f' stroke-miterlimit='8' stroke-width='.666' d='M2136.746 1304.693c5.436 8.296 15.252 16.386 24.27 19.873-1.017.703-2.256 1.228-4.355 1.849 8.235.726 36.584 8.02 40.862-5.299.135-.42.15-.869.196-1.259-6.404 11.575-22.613 10.465-34.113-8.277-.286.449.044 1.439-.12 1.919-2.67-2.369-5.398-5.098-7.752-7.677.27 1.233.51 3.148.51 5.383-.911-2.06-3.001-5.466-4.55-7.221.487 1.829.514 2.794.528 4.443-.93-2.838-2.87-5.549-4.038-7.282.196 1.98.349 3.306.262 5.207-1.05-2.488-2.655-4.342-4.38-6.078.48 1.515.999 3.389 1.075 4.438-1.121-1.831-2.886-3.359-4.012-4.618.225 1.079 1.163 3.255 1.343 4.184-1.71-1.482-3.527-3.194-5.301-4.184.363 1.363 1.857 4.019 3.958 5.878-1.79-.24-2.796-.482-4.383-1.279z'/%3e%3cpath fill='%2374b500' stroke='%231b402f' stroke-linecap='round' stroke-miterlimit='8' stroke-width='.666' d='M2196.191 1320.267c8.548 34.638 9.97 47.651 17.521 54.69l-2.203-5.426 5.52 4.557-3.628-5.479 5.365 2.716c-2.516-2.804-5.86-5.298-7.914-8.464l4.873 2.968c-6.448-7.12-16.587-37.925-18.82-45.483'/%3e%3cpath fill='%2374b500' stroke='%231b402f' stroke-linecap='round' stroke-miterlimit='8' stroke-width='.666' d='M2196.13 1312.978c-.12.21-1.9 11.396-3.564 16.08-2.072 5.824-6.437 10.56-6.81 15.186 0 0 2.395-3.264 4.885-4.72 0 0-3.237 4.233-4.076 9.241 0 0 3.31-4.673 5.238-5.86 0 0-3.901 6.015-4.71 10.403l5.29-5.787c-1.587 3.255-4.17 8.712-4.17 8.712 1.45-1.676 5.125-5.072 5.125-5.072-2.105 3.64-3.724 8.214-3.724 8.214 1.229-1.64 3.547-3.827 3.547-3.827-1.69 3.33-2.395 7.147-2.395 7.147 1.078-1.95 3.443-3.735 3.443-3.735-1.211 2.015-1.95 6.307-1.95 6.307 1.328-2.863 3.303-4.729 3.303-4.729-1.631 3.415-1.394 8.41-1.394 8.41.887-2.403 1.165-3 2.808-4.872-.691 4.164 1.656 9.447 1.656 9.447-.064-2.463.615-5.105.615-5.105.194 3.224 2.762 6.851 2.762 6.851-.273-2.299-.181-4.033-.181-4.033.855 2.64 3.033 5.295 3.033 5.295.045-2.328-.933-6.607-.933-6.607 1.029.627 1.81 3.33 1.81 3.33.06-4.746-2.997-9-2.997-9 .687-.045 1.964.661 1.964.661-.44-4.836-3.61-8.62-3.61-8.62 1.12 0 2.708.964 2.708.964-.671-1.79-3.392-5.445-3.392-5.445.807.08 2.128.62 2.128.62-.36-3.74-1.604-7.523-1.604-7.523 1.074.18 1.582.736 1.582.736-.33-4.108-5.217-21.185-5.778-32.88'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.553' d='M2203.146 1371.325c-2.518-7.281-5.545-15.547-6.524-24.936-.586-5.61.26-15.106.13-20.993'/%3e%3cpath fill='%2374b500' stroke='%231b402f' stroke-miterlimit='8' stroke-width='.666' d='M2196.333 1319.886s2.7 14.281 17.784 17.614c0 0-1.514-1.055-2.945-2.536 0 0 4.728 2.127 9.083 2.316 0 0-1.95-1.088-3.165-2.612 0 0 5.476 2.18 9.148 1.775 0 0-2.07-1.059-3.236-2.428 0 0 5.104 1.382 9.21.653 0 0-2.426-.467-3.858-2.053 0 0 5.073.83 9.242-.25 0 0-2.178-.186-3.578-1.586 0 0 7.685.236 11.637-4.667 0 0-1.96.653-4.294-.187 0 0 4.232-1.059 6.69-4.076 0 0-1.617.346-3.33-.125 0 0 3.258-1.224 5.249-3.216 0 0-1.327.384-3.257-.052 0 0 2.365-.75 3.61-2.738 0 0-1.494.63-3.112.094 0 0 3.382-1.908 3.589-5.643 0 0-1.401 2.2-3.06 2.905 0 0 2.272-2.849 2.479-5.843 0 0-2.681 2.41-4.175 4.567 0 0 .493-2.603 1.323-4.139 0 0-2.82 1.597-4.216 5.664 0 0-.67-2.458-.358-3.61 0 0-2.116 2.24-2.832 5.29 0 0-.6-1.76-.622-3.018 0 0-2.315 1.836-2.956 5.57 0 0-.654-2.863-.34-4.575 0 0-3.488 3.368-4.234 8.464 0 0-1.401-2.83-.997-6.535 0 0-3.142 4.488-4.201 9.325 0 0-1.43-3.444-1.168-6.237 0 0-2.662 3.737-4.148 8.081 0 0-.246-3.358.065-6.75 0 0-3.086 4.333-5.078 7.466 0 0 .196-2.734 1.483-5.799 0 0-5.654 3.654-8.392 6.403-.953.957-8.298 1.285-11.981-7.13'/%3e%3cpath fill='%23473125' d='M2200.657 1277.609c-.385 14.535-1.077 25.035-1.672 34.823-.321-1.556-.891-2.669-2.081-2.696-2.601-.061-2.58 3.019-2.581 3.031.08-12.231.561-31.263 1.077-51.275 0 .016.344 11.13 5.257 16.117'/%3e%3cpath fill='%23292723' d='M2196.988 1309.496c1.189.027 1.676.784 1.997 2.34-.178 2.929-.154 2.222-.353 4.239-.149 5.218-4.16 5.896-4.32-.591-.04-1.608-.011-.027.009-3.051.001-.014.065-2.998 2.667-2.937'/%3e%3cpath fill='%23cbcbc9' d='M2206.355 1211.836c-.677 1.174-1.647 1.976-3.05 3.345-1.366 1.332-1.174 3.91-1.346 5.415-.194 1.7-.583 29.968-1.303 57.23-5.284-4.235-5.257-16.098-5.257-16.116.55-21.248 1.1-39.928 1.134-41.266.06-2.34.218-3.823-.899-5.232-.674-.85-1.883-2.07-2.758-3.178-.767-.971-.163-1.85 2.322-2.566 2.154-.62 1.891-1.017 4.336-1.017 2.444 0 2.747.459 3.926.88.85.302 3.766.995 2.895 2.505'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.553' d='M2199.742 1326.874c5.698 5.607 22.242 4.909 29.048 2.008 8.028-3.423 12.57-7.818 17.083-14.625'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.888' d='M2196.533 1220.381c.06-2.34.219-3.823-.898-5.232-.674-.85-1.883-2.07-2.758-3.177-.768-.973-.164-1.852 2.322-2.568 2.154-.62 1.891-1.016 4.335-1.016s2.747.46 3.927.88c.848.301 3.764.995 2.894 2.505-.676 1.174-1.647 1.976-3.05 3.345-1.366 1.332-1.173 3.91-1.346 5.416-.328 2.878-1.213 74.067-3.327 95.478-.149 5.219-4.16 5.896-4.32-.59-.37-15.017 2.146-92.132 2.221-95.04z'/%3e%3cpath fill='%2374b500' stroke='%231b402f' stroke-miterlimit='8' stroke-width='.666' d='M2195.934 1313.237c-3.539 17.21-1.74-7.116-5.489-13.443.05 1.362-.32 3.659-1.404 6.407.31-5.07.128-10.005-1.326-12.615.091 1.26-.45 4.35-1.69 7.338.176-2.403.663-8.263-.498-10.545-.255 1.438-1.03 4.747-1.864 6.557.407-3.751.318-7.916-.79-10.637-.28 2.663-.929 5.899-1.552 7.58.214-3.911-.667-9.7-2.287-12.668.372 2.022.855 7.444.043 10.533-.31-4.288-2.424-8.3-3.55-10.304-.107-.24 1.422 7.176 1.11 10.226-1.244-1.867-2.67-5.757-3.315-7.495-.418 3.23-.294 5.596 1.324 9.415-1.307-1.23-2.508-2.788-3.498-4.198.49 2.319 2.982 6.882 3.958 8.472-1.353-.741-3.748-3.255-4.859-4.454 1.395 3.18 4.167 6.827 6.266 9.316-1.564-.74-3.537-2.298-4.932-3.108 2.25 2.79 5.344 6.193 8 8.742-1.813-.644-2.878-.96-4.4-1.905 5.177 6.178 10.086 10 17.214 14.348 0 0 4.23 2.485 4.057-7.821'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.553' d='M2175.957 1295.755c4.64 9.596 8.985 15.736 17.247 24.131m-50.733-13.119c5.251 4.813 34.271 29.043 50.732 18.907'/%3e%3cpath fill='%2374b500' stroke='%231b402f' stroke-miterlimit='8' stroke-width='.666' d='M2196.904 1317.706c-1.156 6.528-16.34 16.369-40-3.068 0 0 2.06.552 4.145.459 0 0-2.687-5.3-6.96-9.823l3.754.768c-1.929-3.112-5.602-6.248-5.602-6.248l2.88.165c-1.058-2.335-4.216-4.933-4.216-4.933 2.961.857 5.927 3.112 5.927 3.112-.434-2.7-2.326-6.491-2.326-6.491 4.066 2.278 5.271 6.923 5.271 6.923.137-3.044-.43-9.301-.43-9.301s2.82 6.242 3.72 12.874c0 0 1.095-2.892 1.498-6.666 0 0 1.682 4.61 1.788 10.92 0 0 1.564-2.928 1.891-5.058 0 0 .931 4.34 1.012 8.546 0 0 1.251-2.423 1.652-4.447 0 0 1.084 4.425.633 7.7 0 0 1.263-2.235 1.921-4.451 0 0 .905 4.302.507 7.655l2.262-3.822c-.613 2.698.067 4.972 1.171 6.72.971 1.538 1.033 4.862 1.033 4.862 2.22 1.23 17.78.958 16.651-10.284'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.553' d='M2156.244 1300.573c2.998 2.79 6.928 8.817 9.76 13.436 2.85 4.618 7.542 9.304 11.65 10.474'/%3e%3cpath fill='%2374b500' stroke='%231b402f' stroke-miterlimit='8' stroke-width='.666' d='M2197.718 1312.432c-.822 15.142-8.28 26.836-17.608 35.405l.393-3.232c-4.03 5.85-11.953 9.68-11.953 9.68 3.392-2.986 5.42-7.94 5.42-7.94-3.932 4.19-10.08 7.122-10.08 7.122 1.7-1.632 4.367-5.875 4.367-5.875-4.023 3.184-8.692 4.523-8.692 4.523 2.545-1.635 5.456-5.228 5.456-5.228-4.082 2.67-9.543 3.112-9.543 3.112 2.925-1.056 6.866-4.253 6.866-4.253-4.546 1.901-10.219 1.743-10.219 1.743 2.5-.793 7.073-3.316 7.073-3.316-5.185 1.262-9.75.287-9.75.287 4.655-.786 7.51-2.382 7.51-2.382-3.899.57-7.969-.337-7.969-.337 2.867-.205 5.708-1.534 5.708-1.534-2.572.021-5.954-1.182-5.954-1.182 2.532.125 4.565-.685 4.565-.685-3.112-.207-5.332-1.762-5.332-1.762 2.262.227 3.983-.624 3.983-.624-2.24-.269-4.25-1.99-4.25-1.99 1.935.323 4.706.518 4.706.518-1.195-.668-3.65-2.988-3.65-2.988 2.15.167 4.898 1.68 4.898 1.68-1.395-3.252-3.326-4.982-3.326-4.982 2.873 1.254 6.402 4.258 6.402 4.258-.332-2.365-2.83-5.436-2.83-5.436 4.721 1.54 6.993 5.357 6.993 5.357-.316-4.106-2.904-5.804-2.904-5.804 5.878 1.194 7.685 6.397 7.685 6.397.367-3.922-1.278-6.158-1.278-6.158 4.886 2.021 6.387 6.996 6.387 6.996.499-4.318-1.531-6.124-1.531-6.124 3.601 1.376 6.142 6.561 6.142 6.561.35-4.464-1.838-6.11-1.838-6.11 6.816 1.258 8.787 5.23 8.787 5.23.046-2.344-1.433-3.972-1.433-3.972 4.97 1.628 5.07 6.422 7.356 4.804 2.52-1.783 4.427-5.396 5.67-10.218.616-2.395 2.4-11.54 2.4-11.54'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.553' d='M2154.275 1335.25c9.947 6.607 24.501 8.42 34.54.37'/%3e%3cpath fill='%2374b500' stroke='%231b402f' stroke-miterlimit='8' stroke-width='.666' d='M2199.598 1323.027s4.636 19.217 25.173 17.616c0 0-3.637 2.614-6.717 3.081 0 0 6.542 1.559 10.94-2.56 0 0-.117 2.324-2.188 4.096 0 0 5.063-.89 8.238-4.227 0 0-.156 2.286-1.245 4.184 0 0 5.01-2.146 7.52-5.465 0 0-.414 1.867-1.41 3.858 0 0 4.17-2.098 7.737-6.109 0 0-.634 2.933-2.646 4.634 0 0 1.922-.455 3.393-1.367 0 0-4.076 6.534-12.903 8.983 0 0 2.157 1.991 4.813 1.991 0 0-6.556 2.945-13.733.456 0 0 1.162 2.086 4.99 4.128 0 0-5.913.498-9.507-4.294 0 0 .14 1.681 1.446 3.983 0 0-3.485-2.396-5.227-5.239 0 0 .186 1.816 1.535 3.911 0 0-2.967-2.312-4.57-5.207 0 0 .141 2.272 1.494 4.004 0 0-14.615-7.44-18.424-31.289'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.553' d='M2200.252 1326.627c2.427 12.49 20.597 30.889 42.899 16.444'/%3e%3cpath fill='%2374b500' stroke='%231b402f' stroke-linecap='round' stroke-miterlimit='8' stroke-width='.666' d='M2210.628 1314.637c4.109-3.417 14.568-14.762 17.79-24.329 0 0 .355 4.75-1.308 9.433 0 0 3.507-3.516 4.616-12.096 0 0 .922 3.024.573 5.715 0 0 1.137-2.264 4.3-5.202l-1.782 5.52c1.66-1.609 2.645-2.739 4.829-4.402 0 0-.164 2.917-4.617 7.917l4.617-2.074s-1.438 2.961-5.164 5.711c0 0 2.308.313 4.42-.743 0 0-1.408 2.23-5.515 4.49l5.136-.208c-3.223 3.988-17.58 14.198-25.795 16.626'/%3e%3cpath fill='%2374b500' stroke='%231b402f' stroke-linecap='round' stroke-width='.666' d='M2197.586 1313.711c3.35 8.894 5.886-14.219 7.27-26.123l1.86 2.764s-.415-6.8 2.128-12.49l.769 8.2s1.359-1.432 1.795-2.199c0 0 .008 4.513-2.186 9.157l2.186-1.238c-.45 3.33-3.224 8.312-3.224 8.312l2.998-1.614c-1.111 3.21-12.693 33.263-14.43 15.041'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.553' d='M2214.566 1316.555c10.57-6.764 14.433-12.809 19.193-21.196m-35.452 21.245c4.033 4.892 9.001-19.623 10.676-28.833'/%3e%3cpath fill='%2374b500' stroke='%231b402f' stroke-miterlimit='8' stroke-width='.666' d='M2196.217 1312.767c-.056 3.354 2.107 18.163 10.407 16.896 10.212-1.56 13.329-20.26 13.54-22.432 0 0-1.236 2.042-2.834 3.452 0 0 1.76-5.688 1.3-9.294 0 0-1.183 5.421-2.691 8.044 0 0 .89-3.609.093-5.88 0 0-.673 4.72-2.468 6.886 0 0 .622-3.132-.041-4.689 0 0-.498 3.755-2.366 6.183 0 0 .477-2.345-.145-4.398 0 0-.384 2.91-2.212 6.297 0 0 .14-2.21-.391-3.663 0 0-.42 3.361-1.94 5.601 0 0-.083-2.115-.436-3.67 0 0-.355 2.823-1.9 5.348 0 0-.008-2.445-.506-3.814 0 0-.622 2.966-1.93 5.062 0 0 .099-2.075-.442-3.803 0 0-1.098 3.293-2.288 4.992-.75-1.355-2.396-5.027-2.072-7.118'/%3e%3cpath fill='none' stroke='%231b402f' stroke-linecap='round' stroke-width='.553' d='M2201.552 1327.138c6.64 4.52 12.114-5.477 15.035-14.706'/%3e%3cpath fill='%23fff' stroke='%23000' stroke-linecap='round' stroke-width='.751' d='M2126.27 1302.313c3.478 2.52 6.237 6.566 9.911 6.657-1.229-1.739-.899-2.039-2.114-3.328-1.23-1.26-4.14-3.568-4.844-3.629-.705-.03-2.953.15-2.953.15'/%3e%3cpath fill='%23fff' d='M2115.279 1215.616c-1.035-3.48-6.208-15.024-7.228-16.645-1.034-1.588-.104-3.357-1.034-4.587-.945-1.23-2.818-2.07-3.3-3.57-.463-1.5 1.41-24.23.482-24.71-.945-.45-6.478.749-6.958 2.729-.464 1.979.855 1.89 0 3.388-.84 1.5-.66 2.34-.555 3.75.09 1.41 3.194 14.844 3.374 19.732.195 4.889 1.649 25.34 1.649 25.34z'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-width='.751' d='M2115.279 1215.616c-1.035-3.48-6.208-15.024-7.228-16.645-1.034-1.588-.104-3.357-1.034-4.587-.945-1.23-2.818-2.07-3.3-3.57-.463-1.5 1.41-24.23.482-24.71-.945-.45-6.478.749-6.958 2.729-.464 1.979.855 1.89 0 3.388-.84 1.5-.66 2.34-.555 3.75.09 1.41 3.194 14.844 3.374 19.732.195 4.889 1.649 25.34 1.649 25.34z'/%3e%3cpath fill='%23fff' d='M2091.797 1215.316c.286-2.249 4.32-11.815 5.73-14.365 1.408-2.519.748-4.798.943-6.177.18-1.41 1.5-1.529 1.5-2.939 0-1.41 1.59-15.235 1.32-18.023-.286-2.819.374-4.798 1.68-5.728-.376-.929-.932-2.339.748-4.229 1.695-1.889 4.201-4.057 5.805-4.057 1.59 0 1.152 1.238 1.152 1.238s1.604.57.661 2.549c-.945 1.95-3.569 3.75-3.764 4.499-.18.749.75 2.998-.18 5.068-.946 2.069-3.029 17.183-2.909 20.303.09 2.428.09 4.317-.765 6.657-.84 2.339 1.784 11.455 1.784 15.864l-6.387 3.777z'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-width='.751' d='M2091.797 1215.316c.286-2.249 4.32-11.815 5.73-14.365 1.408-2.519.748-4.798.943-6.177.18-1.41 1.5-1.529 1.5-2.939 0-1.41 1.59-15.235 1.32-18.023-.286-2.819.374-4.798 1.68-5.728-.376-.929-.932-2.339.748-4.229 1.695-1.889 4.201-4.057 5.805-4.057 1.59 0 1.152 1.238 1.152 1.238s1.604.57.661 2.549c-.945 1.95-3.569 3.75-3.764 4.499-.18.749.75 2.998-.18 5.068-.946 2.069-3.029 17.183-2.909 20.303.09 2.428.09 4.317-.765 6.657-.84 2.339 1.784 11.455 1.784 15.864l-6.387 3.777z'/%3e%3cpath fill='%23fff' d='M2071.6 1220.294c0-1.68 3.943-10.405 3.39-11.726-.57-1.32-2.446-3.21-2.355-4.408.09-1.23 5.443-14.274 5.352-21.231.091-1.68 1.784-2.071 2.624-3.3.856-1.2-1.303-1.108 0-2.61 1.321-1.53 5.173-3.388 9.492-3.206.285.479.195.837 0 1.228 0 0 .945 1.11-.465 2.16-1.41 1.02-2.819 2.519-4.513 2.999 0 0-1.125.929-.75 1.68.374.749-.135 2.638-1.514 4.317-1.394 1.709-3.613 9.417-4.003 14.486-.405 5.066 4.107 12.865 6.267 14.093l-6.267 6.268z'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-width='.751' d='M2071.6 1220.294c0-1.68 3.943-10.405 3.39-11.726-.57-1.32-2.446-3.21-2.355-4.408.09-1.23 5.443-14.274 5.352-21.231.091-1.68 1.784-2.071 2.624-3.3.856-1.2-1.303-1.108 0-2.61 1.321-1.53 5.173-3.388 9.492-3.206.285.479.195.837 0 1.228 0 0 .945 1.11-.465 2.16-1.41 1.02-2.819 2.519-4.513 2.999 0 0-1.125.929-.75 1.68.374.749-.135 2.638-1.514 4.317-1.394 1.709-3.613 9.417-4.003 14.486-.405 5.066 4.107 12.865 6.267 14.093l-6.267 6.268z'/%3e%3cpath fill='%23fff' d='M2054.507 1225.511c.286-2.669 4.14-11.695 4.319-16.673-.09-1.768-.66-3.09-.556-4.408.09-1.319 1.786-3.299 1.786-5.818 0-2.549 1.033-16.614.268-17.484.57-1.589 1.633-2.927 2.579-3.226-1.035-.93-1.17-2.022-.883-3.04.284-1.05 2.53-4.984 4.258-5.19 1.332-.158 1.503.837 1.503.837s1.466-1.017 1.286 1.323c-.195 2.37-.788 4.518-2.79 6.028-1.217.917-.148 1.86 0 2.16.166.268 1.17 2.247 0 4.226-1.154 1.951-1.53 4.02-1.724 6.088-.18 2.071-.375 8.457-.09 9.957.285 1.5 1.59 2.73 1.125 5.82-.465 3.117.749 12.263 5.068 14.632l-9.296 6.388z'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-width='.751' d='M2054.507 1225.511c.286-2.669 4.14-11.695 4.319-16.673-.09-1.768-.66-3.09-.556-4.408.09-1.319 1.786-3.299 1.786-5.818 0-2.549 1.033-16.614.268-17.484.57-1.589 1.633-2.927 2.579-3.226-1.035-.93-1.17-2.022-.883-3.04.284-1.05 2.53-4.984 4.258-5.19 1.332-.158 1.503.837 1.503.837s1.466-1.017 1.286 1.323c-.195 2.37-.788 4.518-2.79 6.028-1.217.917-.148 1.86 0 2.16.166.268 1.17 2.247 0 4.226-1.154 1.951-1.53 4.02-1.724 6.088-.18 2.071-.375 8.457-.09 9.957.285 1.5 1.59 2.73 1.125 5.82-.465 3.117.749 12.263 5.068 14.632l-9.296 6.388z'/%3e%3cpath fill='%23fff' d='M2060.954 1261.948c-6.192 10.676-18.848-1.08-14.62-9.656 1.185-2.368 3.644-1.793 6.103-1.313-1.124.03-2.22 1.213-2.49 1.882.676-.046 1.405.15 2.179.364-.762.592-1.188 1.059-1.453 2.066a5.1 5.1 0 0 1 2.029-.073c-.656 1.003-1.04 1.835-1.1 2.638.725-.222 1.3-.218 2.137 0-.248.252-.837.923-.897 2.202 1.8-.21 3.014-1.677 3.989-3.238z'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-width='.751' d='M2060.954 1261.948c-6.192 10.676-18.848-1.08-14.62-9.656 1.185-2.368 3.644-1.793 6.103-1.313-1.124.03-2.22 1.213-2.49 1.882.676-.046 1.405.15 2.179.364-.762.592-1.188 1.059-1.453 2.066a5.1 5.1 0 0 1 2.029-.073c-.656 1.003-1.04 1.835-1.1 2.638.725-.222 1.3-.218 2.137 0-.248.252-.837.923-.897 2.202 1.8-.21 3.014-1.677 3.989-3.238z'/%3e%3cpath fill='%23fff' d='M2124.32 1237.539c1.635 1.618 2.385 6.866 3.015 9.266.629 2.369.869 6.627.749 10.496 1.5 1.768 1.004 4.767 1.5 8.786 1.259 2.01 1.124 9.146.885 12.025-.255 2.879.374 4.259 1.875 5.367 1.498 1.142 6.642 3.15 8.515 2.13 1.875-.988 4.004-.24 4.004.75 2.263-.12 3.134 2.759 2.64 4.379 0 0 .929 2.309-2.894 3.899-3.69 1.529-8.008 4.498-9.508 5.637-1.514 1.11-3.134 1.68-6.642 2.008-7.002.632-9.761-3.628-11.771-5.906-2.82-3.18-4.767-10.496-5.516-13.765-.751-3.27-3.255-13.525-4.754-16.524-1.5-3-2.01-4.528-2.76-7.527-3.253 1.019-6.506.75-10.766.509-4.258-.24-11.515 4.259-18.277 5.998-6.777 1.77-17.544-2.49-19.043-7.257-1.5-4.768-5.502-6.748-5.757-9.777-.255-3-1.006-3.987-1.5-5.997-.51-2.01.99-9.776 1.245-12.266.255-2.52 2.395-3.95 3.904-5.037l.354-.241 1.248-.87s.584-2.266 2.32-3.604l.647 3.396c1.209-2.701 2.548-3.374 2.548-3.374l.529 2.814c.962-2.35 2.15-2.95 2.15-2.95l1.31 2.674s.442-1.534 1.47-3.228l1.348 1.792s-.088-1.927.604-3.22l1.854 2.073c.135-2.88 1.635-.51 2.384-2.88.75-2.368.714-2.03 1.487-3.421 0 0 1.26 1.103 2.142 2.67l.71-2.818s1.138 1.095 1.648 1.95l.655-2.52s1.156.48 1.74 1.737l.63-2.366s1.064.347 2.016 2.117l1.143-2.817 1.43 2.559s.845-2.13 2.187-4.018l1.837 3.565c.787-1.846 1.21-2.684 3.133-4.418l.664 3.162s.767-2.31 2.198-3.54l1.266 3.24c.363-1.332.807-2.47 1.66-3.568l1.33 2.958c.353-2.386 1.618-3.378 1.618-3.378l.954 3.089s.576-1.801 1.74-3.336l.638 3.28s.673-1.907 1.872-2.794l1.21 3.17s.449-1.74 1.414-2.554l1.245 3.003 1.71-2.567c.995 1.245 1.198 1.534 1.737 3.327l1.143-1.438s1.44 1.344 1.758 3.53l1.048-1.041s.887 1.85 1.332 3.957l.94-.645c.75 1.685 1.132 4.303 1.132 4.303l.838-.558c.585 2.164.84 4.155.84 4.155l1.115-.447c.366 1.49.612 3.118.527 4.583l.972-.044s.228 4.34-1.568 8.357'/%3e%3cpath fill='none' stroke='%23000' stroke-miterlimit='8' stroke-width='.751' d='M2124.32 1237.539c1.635 1.618 2.385 6.866 3.015 9.266.629 2.369.869 6.627.749 10.496 1.5 1.768 1.004 4.767 1.5 8.786 1.259 2.01 1.124 9.146.885 12.025-.255 2.879.374 4.259 1.875 5.367 1.498 1.142 6.642 3.15 8.515 2.13 1.875-.988 4.004-.24 4.004.75 2.263-.12 3.134 2.759 2.64 4.379 0 0 .929 2.309-2.894 3.899-3.69 1.529-8.008 4.498-9.508 5.637-1.514 1.11-3.134 1.68-6.642 2.008-7.002.632-9.761-3.628-11.771-5.906-2.82-3.18-4.767-10.496-5.516-13.765-.751-3.27-3.255-13.525-4.754-16.524-1.5-3-2.01-4.528-2.76-7.527-3.253 1.019-6.506.75-10.766.509-4.258-.24-11.515 4.259-18.277 5.998-6.777 1.77-17.544-2.49-19.043-7.257-1.5-4.768-5.502-6.748-5.757-9.777-.255-3-1.006-3.987-1.5-5.997-.51-2.01.99-9.776 1.245-12.266.255-2.52 2.395-3.95 3.904-5.037l.354-.241 1.248-.87s.584-2.266 2.32-3.604l.647 3.396c1.209-2.701 2.548-3.374 2.548-3.374l.529 2.814c.962-2.35 2.15-2.95 2.15-2.95l1.31 2.674s.442-1.534 1.47-3.228l1.348 1.792s-.088-1.927.604-3.22l1.854 2.073c.135-2.88 1.635-.51 2.384-2.88.75-2.368.714-2.03 1.487-3.421 0 0 1.26 1.103 2.142 2.67l.71-2.818s1.138 1.095 1.648 1.95l.655-2.52s1.156.48 1.74 1.737l.63-2.366s1.064.347 2.016 2.117l1.143-2.817 1.43 2.559s.845-2.13 2.187-4.018l1.837 3.565c.787-1.846 1.21-2.684 3.133-4.418l.664 3.162s.767-2.31 2.198-3.54l1.266 3.24c.363-1.332.807-2.47 1.66-3.568l1.33 2.958c.353-2.386 1.618-3.378 1.618-3.378l.954 3.089s.576-1.801 1.74-3.336l.638 3.28s.673-1.907 1.872-2.794l1.21 3.17s.449-1.74 1.414-2.554l1.245 3.003 1.71-2.567c.995 1.245 1.198 1.534 1.737 3.327l1.143-1.438s1.44 1.344 1.758 3.53l1.048-1.041s.887 1.85 1.332 3.957l.94-.645c.75 1.685 1.132 4.303 1.132 4.303l.838-.558c.585 2.164.84 4.155.84 4.155l1.115-.447c.366 1.49.612 3.118.527 4.583l.972-.044s.228 4.34-1.568 8.357z'/%3e%3cpath fill='%23fff' stroke='%23000' stroke-linecap='round' stroke-width='.751' d='M2120.586 1297.095c-.419 1.738-1.693 9.956 4.32 11.875.24-1.769-.63-3.328-1.32-5.338-.69-2.04-1.035-3.569-.706-4.708'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-width='.751' d='M2124.006 1307.62c-.75-.66-2.054-1.078-1.59-4.467'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-width='1.127' d='M2128.143 1294.127c1.188.119 1.831-.991 2.685-.93.84.03 1.75 1.248 2.321 1.327.58.08.872.082 1.382-.428'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-width='.751' d='M2147.396 1290.467c-.51-.18-1.454 1.5-2.533.75m-5.308-3.717c.704.148 3.808.06 5.547-1.141m-41.444-27.799c.135-.99-2.624-3.629-3.748-5.639m24.41-15.382c-1.73-1.8-6.012-6.51-6.251-9.778m-28.686 30.182c-4.081-1.384-7.286-4.182-7.632-8.26m12.511 7.387c-1.805-.75-1.805-1.917-3.874-2.423m-2.503-7.213c-.496-1.32-1.347-3.229-1.826-4.577m-1.189-2.83a27.174 27.174 0 0 1-.99-2.879m-30.245 15.232c.614-3.72-2.247-5.997-3.446-9.084m1.498-4.139c-.419-3.18-1.813-6.07-1.064-9.711m6.208 13.58c-.9-1.11-1.365-2.4-1.38-3.869m10.511 9.386c-.794-1.798-1.217-3.676-.75-5.686m2.505 4.696c.089-3.988-3.599-6.867-4.153-10.915-.616-4.379 1.373-7.888 1.149-12.267m1.624 13.646c-.09-2.788-.24-5.788 1.14-8.127m-.134-3.15c-.195-1.617.284-3.087 1.379-4.228m2.504 2.611c.884-2.49 2.954-3.75 4.512-5.88m-2.128 9.507c-.314 2.22.48 4.319.614 6.659m1.379-7.649c.21-2.908-.344-6.057 1.515-8.517m6.013-3.267c-.616 3.598-4.543 5.758-4.259 9.535m4.124 1.62c0-2.908-.143-5.214 1.33-7.888m1.789-3.267c.735 3.018.835 5.067 0 8.127 2.608-2.399 2.205-6.969 1.89-9.356m-1.125 13.375c-.45.39-.675.929-.63 1.529m27.184 8.996c-.397-1.765-.646-3.88.12-5.758m-3.134-6.387c1.17-1.98 1.155-4.23 3.015-5.878m-1.802-1.649c1.514-1.685 2.193-2.85 2.315-4.499m2.05 1.86c-.044.929-.845 2.369-1.754 3.277m3.851-2.181c.209 1.35.158 3.252-.141 4.541m2.109-2.098c-.645 2.849-3.435 4.167-3.75 7.257m-1.378-2.49c.539-1.079-.498-2.669.042-3.929m8.223 26.641c.689-1.519 1.555-3.022 2.32-4.372m-4.018.155c.255-2.12 1.514-2.12 2.444-4.792m.22 18.598c.782-1.685 1.668-3.15 2.853-5.436m-3.073.185c.729-1.532 1.62-3.329 2.504-4.768m1.191 11.756c-1.047 1.186-1.829 2.308-2.747 3.511m3.442.374c-1.316 1.95-2.195 3.267-3.09 5m3.734-.125c-1.526 2.49-2.189 3.604-3.486 6.907m4.066-1.762c-.954 1.41-1.97 4.128-2.53 5.704m-30.298-24.858c.479.784 1.538 1.878 2.27 2.06m-9.364-8.567c.39.63.915 1.2 1.5 1.618m-35.478-17.452c-.584-1.35.586-2.55.017-3.72-.541-1.078-3.044-2.127-1.454-3.146m-1.59 7.016c-.3-1.2.39-1.83.24-2.91m67.445 65.916c-.09-.72.209-1.26.869-1.498m.255-.751c-.135-.81.164-1.41.884-1.74m.494-1.649c.422-.84.557-2.039.377-3.118m2.878-2.37c1.334-.688 2.923-1.318 4.257-1.77m-.493 2.01c.045-.51.255-.84.63-1.14m-78.407-23.51a75.85 75.85 0 0 0-1.215 1.889m.091-4.319c-.809.54-1.319 1.47-1.5 2.55m-.787-3.69c.208-.81.146-.937.464-1.507m.323-1.941c-.875.858-1.312 1.667-1.574 3.067m1.327 1.863c-.543.654-.726 1.207-.846 1.787m2.398.211c-.33.569-.75 1.318-1.02 1.889m2.055.27c.015.899.554 1.71 1.32 2.069m-.196-1.679c.842-.062 1.482-.232 2.55-1.104m10.51-85.325c.106-.928 2.205-2.937 1.755-4.376m17.498 7.586c1.784-.39 4.23-2.07 4.89-2.91m17.377-9.955c.84-.84 2.624-2.55 3.193-4.05m-48.655 40.007a3.07 3.07 0 0 1 2.353 1.619m37.561-10.076c.84.72 1.47 1.77 1.694 2.818m6.017 21.533c-.078-1.695.25-2.97.281-4.439m1.319 2.07a2.844 2.844 0 0 1 .375-1.859m-4.798 4.228c.1-2.303-.96-2.613-.924-4.604m1.251-.092c-.417-.856-.394-.877-.511-1.495m-2.439 7.029c.255-1.589-.21-3.207-.106-4.707'/%3e%3cpath fill='none' stroke='%23a4a5a8' stroke-linecap='round' stroke-width='.564' d='M2065.903 1225.482c-.195-1.859-.131-2.504.582-4.16m2.431 2.901c.48-1.26 1.844-1.39 1.833-4.61m.965 2.427c-.077-2.25 1.12-3.407 1.702-5.601m-.442 4.461c.97-1.038 1.948-3.48 1.902-4.593m-.712 7.165c.63-1.108.272-1.144 1.16-2.288m2.09-.777c1.09-1.48 1.265-2.474 2.001-5.75m.762 5.067c.895-1.355 1.265-3.688 1.79-5.519m2.515 8.393c.853-2.539.883-3.773.704-6.143m-3.509 7.527c.09-1.859.44-3.238 1.176-5.007m6.09 1.925c.414-2.094.497-4.057.198-6.38m1.272 4.724c.521-3.538-.464-5.418 1.62-7.337m.312 2.489c.913 1.94-.487 4.548-1.146 6.587m5.006-3.268c.122-1.83.026-3.526-.479-5.394m-1.019 6.384c0-1.62.089-3.15.255-4.738m6.762-.001c-.075 1.47-.15 2.788-.255 4.258m-2.249-2.278c-.104 1.648-.18 3.148-.255 4.768m4.004-5.248v3m2.759-2.76v3.748m2.009-6.507c.99 1.769 1.038 3.865 1.004 6.028m4.664 7.639c-.224-1.23-.012-3.23.542-4.25m2.051-.391c.195-1.32.375-2.699.495-4.018m3.972 11.545c.335-1.528 1.037-4.348 1.037-6.152m0 7.887c.61-1.385 1.062-3.229 1.222-4.945m-.161 6.796c.855-1.35 1.326-3.262 1.442-5.115m-.116 6.796c.496-1.183.929-2.365.874-3.89m-5.511-3.385c.315-1.202.63-4.108.63-5.128m-2.638-2.64c.104-1.259.039-2.219-.216-3.389m-55.638 12.146c0-1.589.055-3.309.657-5.082m1.096 2.593c-.029-1.14.083-2.205.563-3.014m-3.816 1.874c-.167 1.254-.794 2.52-1.004 3.63m-1.63-4.171c.249 1.38-.094 2.971-.365 4.17m-2.808-1.185c-.151.83 0 1.244-.265 2.488m-1.957-1.303c-.284.45-.575 1.61-.548 2.21m3.349-1.245c-.17 1.354-.276 2.196.107 3.294m1.373-8.758c.104.631.003 1.5-.173 2.01m-6.349 9.266c-.092 1.35 0 2.73.254 3.988m-.761.022c-.187 1.795-.08 2.617.319 3.59m.442-2.352a3.722 3.722 0 0 0 1.5 2.76m-.751 3.747c.03.78.42 1.53 1.004 2.01m1.267-14.5c.372 1.158.492 1.675.64 2.92m-2.221-5.85c.06 2.115.548 3.646.89 5.445m-1.763.199c.183 2.405.747 3.422 1.805 4.479m46.465 16.574c-1.124-.18-2.22-.72-3-1.5m4.515 1.26c-.96-.48-2.303-.63-3.074-1.26m4.318.75c-.96-.33-2.008-.688-2.999-.99m-3.516-.51c-1.334-1.081-2.6-2.1-4.252-2.518m1.755 4.126c-1.454-.299-2.954-.948-4.257-1.608m7.691 2.01c-1.016.087-1.805-.072-2.55-.24m4.125-1.77c-.676-.45-1.469-1.558-2.01-2.008m27.559-11.237c.653-1.266.931-1.93 1.748-3.144m-1.192 4.357a37.34 37.34 0 0 1 1.627-2.785m-.744 6.697c.438-.851.85-1.703 1.531-2.745m-.611 6.517c.435-.9.726-1.607 1.451-2.793m-1.451 8.48c.51-.99 1.268-2.11 1.833-2.945m-1.581 4.563c.398-.623 1.02-1.618 1.677-2.386m-.469 5.435c.359-.51.979-1.43 1.43-1.909m-1.172 7.137c.457-.706.96-1.635 1.427-2.324m-.641 7.712c.386-.783 1.025-1.986 1.683-2.856m-.727 6.776c.146-.513.448-1.145.83-1.923m-6.904-36.161v-1.38m-1.13.427v-1.776m-1.374.367v-2.24m-1.498.746c.135-.99-.12-2.894-.804-4.104m9.676 53.542c.272-.33 1.009-.99 1.398-.99m-.334.99c1.343.63 2.071-.102 2.071-.75m0 1.965c-.029-.48.257-1.184.768-1.215m0 1.054c.351-.447.786-.643 1.346-.33m-.449.612a.715.715 0 0 0 1.154-.121m-48.967-28.331c.95.685 2.482 1.4 3.65 1.795m-3.827.092c.406.302 1.354.848 1.608.938m-3.786-.377c.457.378 1.13.777 1.971 1.224m-34.145-6.262c-.3.55-.364.844-.47 1.49m-1.754-.334c-.66 1.17-.66 2.7 0 4.019m1.259 2.009c.39.81 1.442 1.713 2.131 2.132m1.966.28c1.1 0 1.785-.592 2.329-1.463m-1.672-.468c.583-.138 1.105-.513 1.843-1.024m8.684-40.542v-2.759m.749 1.501c.255-.45.4-1.605.295-2.326m.896 1.49c.173-.892.172-1.323.053-2.163m-.59-.546c0-.964-.22-1.94-.49-2.81m9.338.597c.222-.674.363-1.166.621-2.01m.427 2.24c.338-1.22.584-2.24.216-3.739m1.583 3.348c.18-1.479.223-1.85.085-3.108m1.673 2.01c-.846-.621-.846-1.053-.846-1.562m1.763 2.163c0-.091.281-.722-.326-1.151m-1.493-1.79c-.202-.718-.688-.961-.943-1.291m-.746.631c-.365-1.11-.878-1.254-1.244-2.02m-.459-.588c-.788-1.174-1.503-1.96-1.24-3.025m3.154 8.512a9.004 9.004 0 0 0-.079-2.017m28.612-2.178c-.199-1.562-.516-2.864-.765-4.81m1.714 4.436c-.213-1.31-.284-1.866-.464-2.945m2.402 4.283c.106-.869-.288-2.065-.5-3.184m1.702 2.299c-.229-.78-.37-.957-.64-1.407m2.273 3.374c-.294-.765-.572-1.33-.915-2.14m-3.168-1.234c-.162-1.702-.368-2.678-.83-4.377m-1.555-1.867c.083.98.747 1.637 1.012 3.274m22.699 99.449c.519.313.6.479 1.037.979m0-.989c.314.421.788 1.093 1.328 1.28m-9.003-1.66c-.765-.45-.872-1.266-.238-1.769'/%3e%3cpath fill='%23fff' d='M2135.285 1381.218h-3.812v5.171h3.812z'/%3e%3cpath d='M2131.585 1381.33h3.59v4.948h-3.59zm3.812-.223h-4.035v5.394h4.035z'/%3e%3cpath fill='%23fff' d='m2135.285 1386.39.529-.732v-5.288l-.53.62z'/%3e%3cpath d='m2135.406 1381.035.287-.336v4.92l-.287.396zm.529-.991-.77.9v5.82l.77-1.066z'/%3e%3cpath fill='%23fff' d='M2120.837 1378.456s.83 1.973 2.884 2.179c2.053.206 3.028-1.04 3.485-1.6l-.311-1.036-4.543-.772z'/%3e%3cpath d='m2120.976 1378.487 1.406-1.142 4.425.752.274.913c-.461.566-1.414 1.708-3.35 1.513-1.736-.175-2.58-1.68-2.755-2.036m1.343-1.38-.04.032-1.578 1.283.033.078c.009.019.879 2.036 2.974 2.246 2.08.21 3.079-1.02 3.56-1.61l.063-.076-.35-1.161-.067-.011z'/%3e%3cpath fill='%23fff' d='m2119.459 1378.724 5.36.062 1.678.25-.308-9.315-7.1.001z'/%3e%3cpath d='m2119.207 1369.835 6.874-.001.3 9.07-1.545-.227-5.27-.063zm7.09-.226h-7.324l.379 9.226.106.002 5.36.062 1.795.267-.004-.134z'/%3e%3cpath fill='%23fff' d='M2118.35 1373.351v-3.772s1.833-.044 5.723-.044l-.01 4.107s-3.076.016-5.713-.29'/%3e%3cpath d='M2118.462 1369.688c.444-.009 2.246-.04 5.5-.04l-.01 3.881c-.568 0-3.194-.019-5.49-.278zm5.723-.266h-.112c-3.848 0-5.708.044-5.726.044l-.11.003v3.982l.1.011c2.615.304 5.69.293 5.727.291h.11l.001-.112z'/%3e%3cpath fill='%23fff' fill-rule='evenodd' d='M2124.33 1374.995c-.038-.804-.686-1.426-1.445-1.39-.76.037-1.345.719-1.306 1.523.039.804.687 1.427 1.446 1.389.76-.037 1.345-.718 1.306-1.522'/%3e%3cpath fill='%23fff' fill-rule='evenodd' d='M2123.5 1375.035c-.016-.318-.272-.565-.573-.551-.302.015-.533.285-.518.604.016.319.272.565.573.55.302-.014.534-.284.518-.603'/%3e%3cpath d='M2122.957 1375.528a.42.42 0 0 1-.282-.11.48.48 0 0 1-.155-.336.483.483 0 0 1 .113-.338.42.42 0 0 1 .3-.15h.018c.232 0 .426.197.438.447a.47.47 0 0 1-.12.346.424.424 0 0 1-.292.141zm-.006-1.155-.03.001a.634.634 0 0 0-.455.225.706.706 0 0 0-.167.494c.01.19.09.364.227.488a.633.633 0 0 0 .906-.045.69.69 0 0 0 .178-.506.675.675 0 0 0-.659-.657'/%3e%3cpath fill='%23fff' fill-rule='evenodd' d='M2123.5 1375.035c-.016-.318-.272-.565-.573-.551-.302.015-.533.285-.518.604.016.319.272.565.573.55.302-.014.534-.284.518-.603'/%3e%3cpath d='M2122.957 1375.528a.42.42 0 0 1-.282-.11.48.48 0 0 1-.155-.336.483.483 0 0 1 .113-.338.42.42 0 0 1 .3-.15h.018c.232 0 .426.197.438.447a.47.47 0 0 1-.12.346.424.424 0 0 1-.292.141zm-.006-1.155-.03.001a.634.634 0 0 0-.455.225.706.706 0 0 0-.167.494c.01.19.09.364.227.488a.633.633 0 0 0 .906-.045.69.69 0 0 0 .178-.506.675.675 0 0 0-.659-.657'/%3e%3cpath fill='%23fff' d='M2124.073 1376.152h.747v-6.617h-.747z'/%3e%3cpath d='M2124.185 1369.647h.522v6.393h-.522zm.747-.225h-.971v6.842h.971z'/%3e%3cpath fill='%23fff' d='M2124.073 1373.58c-3.734-.042-5.85-.29-5.85-.29v.29s2.116.249 5.85.29'/%3e%3cpath d='M2118.11 1373.164v.516l.1.01c.022.003 2.164.25 5.862.292l.002-.224c-3.24-.035-5.28-.231-5.738-.28v-.064c.507.053 2.542.243 5.736.278l.002-.224c-3.683-.04-5.816-.287-5.837-.29z'/%3e%3cpath fill='%23fff' d='m2124.82 1376.152.197-.015v-6.602h-.197z'/%3e%3cpath d='M2125.128 1369.422h-.42v6.851l.421-.032z'/%3e%3cpath fill='%23fff' d='M2126.189 1369.721h12.426l-.228 10.206h-.954s-.498.581-1.35.705l.012.602h-.561s-1.098 1.058-2.945 1.068c-1.847.011-3.2-1.065-3.2-1.065l-.63.005-.02-.625s-.86-.098-1.388-.825l-.83-.026z'/%3e%3cpath d='M2126.305 1369.834h12.196l-.224 9.98h-.895l-.035.04a2.26 2.26 0 0 1-1.28.669l-.095.014.008.586h-.491l-.033.03c-.011.012-1.091 1.029-2.868 1.038h-.027c-1.772 0-3.09-1.031-3.102-1.042l-.031-.024-.56.005-.02-.612-.095-.012c-.01-.001-.82-.103-1.312-.78l-.032-.043-.78-.025zm12.424-.225h-12.656l.339 10.267.882.027c.45.584 1.094.762 1.337.81l.02.643.699-.006c.222.165 1.495 1.066 3.21 1.066h.029c1.713-.011 2.785-.887 2.989-1.068h.63l-.01-.62a2.49 2.49 0 0 0 1.284-.688h1.014l.003-.11z'/%3e%3cpath fill='%23211915' d='m2130.503 1369.699.15 6.243 3.513.005-.027-6.285zm2.568 9.333-.02-1.83-1.257-.004.032 1.825s.56.733 1.245.009'/%3e%3cpath fill='%23fff' fill-rule='evenodd' d='m2131.537 1379.604-.282-.003-.052-2.406.287.001z'/%3e%3cpath d='m2131.372 1379.482-.045-2.165h.045l.042 2.166zm-.291-2.407.056 2.647.523.002-.052-2.647z'/%3e%3cpath fill='%23fff' fill-rule='evenodd' d='m2133.664 1379.62-.285-.001-.022-2.416h.288z'/%3e%3cpath d='m2133.498 1379.5-.021-2.176h.05l.016 2.176zm-.263-2.417.025 2.655.525.004-.02-2.657z'/%3e%3cpath fill='%23fff' fill-rule='evenodd' d='m2133.666 1379.885-2.406-.02-.005-.264 2.409.02z'/%3e%3cpath d='m2131.378 1379.746-.001-.022 2.168.016v.025zm-.246-.265.01.503 2.645.023-.004-.505z'/%3e%3cpath fill='%23fff' fill-rule='evenodd' d='M2131.546 1380.025s.01.831.929.84c.915.01.908-.772.908-.824l.284.003s.069 1.074-1.188 1.129c0 0-1.191-.012-1.215-1.151z'/%3e%3cpath d='M2132.473 1381.054c-.036 0-.982-.026-1.08-.91h.046c.043.255.231.834 1.034.841.343 0 .586-.087.768-.27a.943.943 0 0 0 .254-.553h.046a.977.977 0 0 1-.233.56c-.185.203-.465.314-.835.332m-1.333-1.152.003.124c.026 1.24 1.321 1.267 1.334 1.267.445-.018.783-.158 1.012-.412.325-.363.298-.826.297-.846l-.007-.11-.52-.007.003.124c0 .032 0 .311-.192.504-.13.132-.326.2-.58.2h-.016c-.786-.009-.808-.694-.809-.723l-.002-.117z'/%3e%3cpath fill='%23fff' fill-rule='evenodd' d='m2132.618 1381.33-.273-.003-.007-.447.273.003z'/%3e%3cpath d='m2132.463 1381.208-.003-.206h.033l.003.206zm-.247-.45.01.687.514.006-.01-.687z'/%3e%3cpath fill='%23fff' d='m2134.876 1376.854-4.744-.015.015.512 4.729.02z'/%3e%3cpath d='m2130.243 1377.253-.01-.312 4.542.012v.318zm-.214-.513.02.71.097.002 4.829.019v-.716l-.1-.001z'/%3e%3cpath fill='%23fff' d='m2135.312 1376.743-5.612-.016.007.223 5.604.018z'/%3e%3cpath d='M2129.804 1376.85v-.022l5.408.013v.026zm-.207-.223.013.421.096.001 5.705.018v-.424h-.099z'/%3e%3cpath fill='%23fff' d='m2135.311 1377.26-5.596-.02.007.22 5.588.023z'/%3e%3cpath d='m2129.82 1377.362-.002-.022 5.394.019v.024zm-.207-.223.012.42h.097l5.687.025.002-.423-.1-.001z'/%3e%3cpath fill='%23fff' d='m2136.39 1369.728-1.88.02.006 2.256 1.854-.01z'/%3e%3cpath d='m2134.619 1369.854 1.662-.017-.017 2.05-1.64.01zm1.879-.235-2.096.021.007 2.473 2.069-.01z'/%3e%3cpath fill='%23fff' d='m2136.26 1376.811-1.65-.004.001.608 1.646.006z'/%3e%3cpath d='M2134.758 1377.27v-.316l1.355.003-.001.318zm-.294-.609.002.9 1.937.007.005-.902z'/%3e%3cpath fill='%23fff' d='m2135.352 1372-.478.003.002 4.728.466.002z'/%3e%3cpath d='m2134.983 1372.11.262-.002-.01 4.517-.25-.001zm.48-.219-.698.004.004 4.944.681.002.001-.108z'/%3e%3cpath fill='%23fff' d='m2136.042 1371.996-.48.003-.015 4.734h.467z'/%3e%3cpath d='m2135.67 1372.107.264-.002-.03 4.521h-.25zm.48-.22-.696.004-.001.108-.014 4.841.682.002z'/%3e%3cpath fill='%23fff' d='m2136.413 1376.68-1.953-.006v.264l1.95.007z'/%3e%3cpath d='M2134.566 1376.834v-.055l1.741.006v.055zm-.21-.265v.475l2.158.006.004-.475z'/%3e%3cpath fill='%23fff' d='m2136.408 1377.29-1.946-.007.001.263 1.943.008z'/%3e%3cpath d='M2134.567 1377.44v-.053l1.735.008v.053zm-.21-.263v.473l2.152.01.004-.475z'/%3e%3cpath fill='%23fff' d='m2136.122 1377.989-1.351-.007-.001-.435 1.355.005z'/%3e%3cpath d='M2134.891 1377.862v-.195l1.112.005-.002.196zm-.242-.437.002.677 1.591.008.003-.678z'/%3e%3cpath fill='%23fff' d='m2135.814 1378.565-.74-.005.001-.576.742.004z'/%3e%3cpath d='M2135.205 1378.43v-.314l.48.002-.001.315zm-.261-.577v.837l1 .006.004-.839z'/%3e%3cpath fill='%23fff' d='m2130.058 1369.79-1.835.019.081 2.23 1.814-.01z'/%3e%3cpath d='m2128.336 1369.915 1.617-.016.054 2.023-1.6.01zm1.828-.234-2.053.02.005.11.085 2.337 2.029-.01z'/%3e%3cpath fill='%23fff' d='m2130.174 1376.793-1.615-.005.022.602 1.609.007z'/%3e%3cpath d='m2128.721 1377.244-.012-.31 1.322.005.007.31zm-.314-.603.032.894 1.901.008-.024-.896z'/%3e%3cpath fill='%23fff' d='m2129.123 1372.035-.468.003.162 4.676h.455z'/%3e%3cpath d='M2128.767 1372.145h.25l.144 4.461h-.24zm.46-.219-.685.004.005.111.164 4.78.673.003z'/%3e%3cpath fill='%23fff' d='m2129.796 1372.03-.47.004.146 4.682h.457z'/%3e%3cpath d='m2129.438 1372.142.253-.002.125 4.468h-.239zm.462-.22-.685.004.004.112.148 4.785.672.003-.003-.112z'/%3e%3cpath fill='%23fff' d='m2130.317 1376.662-1.91-.005.01.262 1.907.006z'/%3e%3cpath d='m2128.517 1376.814-.002-.053 1.7.005.001.054zm-.219-.262.018.471 2.115.006-.013-.472z'/%3e%3cpath fill='%23fff' d='m2130.333 1377.266-1.903-.007.009.26 1.9.008z'/%3e%3cpath d='m2128.54 1377.414-.002-.051 1.693.008v.05zm-.22-.261.018.47 2.11.008-.012-.47z'/%3e%3cpath fill='%23fff' d='m2130.077 1377.958-1.321-.007-.015-.43 1.324.004z'/%3e%3cpath d='m2128.872 1377.83-.007-.19 1.083.005.006.192zm-.256-.431.024.672 1.56.008-.017-.674z'/%3e%3cpath fill='%23fff' d='m2129.796 1378.527-.724-.005-.02-.569.727.003z'/%3e%3cpath d='m2129.198 1378.392-.01-.308.464.001.009.31zm-.28-.57.027.83.984.006-.022-.833z'/%3e%3cpath fill='%23fff' d='M2131.904 1376.152h.747v-6.617h-.747z'/%3e%3cpath d='M2132.016 1369.647h.522v6.393h-.522zm.747-.225h-.973v6.842h.973z'/%3e%3cpath fill='%23fff' d='m2132.651 1376.152.196-.015v-6.602h-.196z'/%3e%3cpath d='M2132.96 1369.422h-.421v6.851l.422-.032z'/%3e%3cpath fill='%23fff' d='M2145.572 1379.017s-.906 1.973-3.15 2.18c-2.244.205-3.309-1.04-3.807-1.6l.34-1.037 4.963-.772z'/%3e%3cpath d='m2139.044 1378.665 4.844-.754 1.534 1.14c-.202.372-1.125 1.855-3.011 2.029-2.121.184-3.158-.94-3.663-1.51zm4.904-1-5.081.79-.384 1.17.07.078c.523.59 1.615 1.819 3.88 1.609 2.284-.21 3.236-2.225 3.246-2.246l.039-.086z'/%3e%3cpath fill='%23fff' d='m2146.2 1379.343-5.856.062-1.402.264-.555-.249v-6.453l8.211-2.627z'/%3e%3cpath d='m2138.504 1373.053 7.97-2.55-.386 8.725-5.745.06-1.387.26-.452-.205zm8.219-2.876-8.453 2.704v6.614l.658.296 1.437-.27 5.948-.062z'/%3e%3cpath fill='%23fff' d='m2138.387 1378.676.575.297 7.39.047-.11-.402-7.264-.063-.591-.339z'/%3e%3cpath d='M2138.504 1378.605v-.187l.442.254h.03l7.177.062.045.168-7.207-.046zm-.234-.59v.733l.692.342 7.543.048-.172-.636h-.09l-7.234-.064z'/%3e%3cpath fill='%23fff' d='m2146.328 1379.654-.111-.311-7.273-.044-.557-.265v.387l.555.249z'/%3e%3cpath d='M2138.504 1379.343v-.125l.44.197 7.19.044.028.076-7.195.017zm-.234-.495v.647l.672.291 7.553-.016-.195-.542h-.081l-7.247-.047z'/%3e%3cpath fill='%23fff' d='m2144.48 1378.61.275-8.27'/%3e%3cpath d='m2144.638 1370.336-.275 8.27.234.007.275-8.269z'/%3e%3cpath fill='%23fff' d='m2144.217 1378.609.289-8.264'/%3e%3cpath d='m2144.388 1370.341-.289 8.264.234.007.288-8.263z'/%3e%3cpath fill='%23fff' d='m2140.687 1378.627.2-8.286'/%3e%3cpath d='m2140.77 1370.338-.2 8.286.234.006.198-8.286z'/%3e%3cpath fill='%23040006' d='m2139.296 1370.351-.198 8.267-.711-.492v-7.679z'/%3e%3cpath d='m2138.86 1378.551-.015.418.235.008.014-.418zm-.032.746-.003.371.234.003.002-.372z'/%3e%3cpath d='M2139.133 1378.974h-.234v.325h.234z'/%3e%3cpath fill='%23fff' fill-rule='evenodd' d='M2144.055 1375.33c.036-.87-.602-1.603-1.425-1.637-.822-.033-1.518.645-1.554 1.516-.036.87.602 1.603 1.425 1.638.823.033 1.52-.645 1.554-1.516'/%3e%3cpath fill='%23fff' fill-rule='evenodd' d='M2143.157 1375.294c.014-.345-.239-.636-.565-.648-.327-.014-.602.254-.617.6-.013.345.24.636.566.649.326.013.601-.255.616-.601'/%3e%3cpath d='m2142.563 1375.778-.018-.001c-.26-.011-.464-.246-.453-.526.012-.274.223-.49.476-.49l.018.001a.454.454 0 0 1 .328.161.526.526 0 0 1 .126.366c-.012.273-.223.489-.477.489m.005-1.25c-.378 0-.693.314-.71.713-.016.408.288.754.678.77h.027c.38 0 .694-.314.711-.712a.76.76 0 0 0-.184-.531.69.69 0 0 0-.494-.24z'/%3e%3cpath fill='%23fff' d='m2135.247 1390.17.264-.654v-2.653l-.264.757z'/%3e%3cpath d='m2135.358 1387.64.042-.117v1.971l-.042.102zm.047-.813-.27.793v2.55l.215.041.273-.695v-2.652z'/%3e%3cpath fill='%23fff' d='M2147.187 1373.445v-3.91h-14.34v4.175s11.703.04 14.34-.265'/%3e%3cpath d='M2132.96 1369.647h14.115v3.697c-2.633.275-12.925.25-14.115.253zm14.34-.225h-14.565v4.4h.113c.118 0 11.74.037 14.353-.267l.099-.01z'/%3e%3cpath fill='%23fff' fill-rule='evenodd' d='M2132.848 1373.567s5.953.094 14.48-.228v.29c-8.527.322-14.48.228-14.48.228'/%3e%3cpath d='m2147.44 1373.223-.116.004c-8.426.317-14.415.23-14.473.227l-.004.225c.062 0 5.997.088 14.368-.224v.066c-8.373.314-14.307.227-14.364.223l-.004.226c.061 0 6.054.087 14.485-.228l.108-.005z'/%3e%3cpath fill='%23fff' d='m2126.463 1377.999-.404.355-7.058.049.475-.404 6.55-.035.418-.352z'/%3e%3cpath d='m2119.518 1378.11 6.549-.034.276-.232.006.106-.333.293-6.708.046zm7.027-.729-.56.472-6.55.034-.74.63 7.406-.051.476-.418z'/%3e%3cpath fill='%23fff' d='M2128.74 1380.617c-.4-.108-1.042-.348-1.39-.824l-.829-.027.009.343.635.02c.647.682 1.57.846 1.57.846z'/%3e%3cpath d='m2126.64 1380-.004-.118.657.02c.338.43.893.67 1.333.8v.133c-.27-.072-.908-.284-1.38-.782l-.032-.033zm-.234-.35.015.569.695.02c.662.673 1.561.84 1.6.848l.13.022.007-.578-.084-.022c-.354-.096-.995-.325-1.328-.782l-.032-.044z'/%3e%3cpath fill='%23fff' d='M2136.084 1380.632a2.355 2.355 0 0 0 1.349-.705h.954v.344l-.78.006s-.67.642-1.523.712z'/%3e%3cpath d='M2137.482 1380.04h.792v.12l-.71.006-.033.03c-.007.006-.592.555-1.334.669v-.137a2.483 2.483 0 0 0 1.285-.688m1.017-.225h-1.118l-.034.039a2.257 2.257 0 0 1-1.279.669l-.096.013v.576l.121-.01c.783-.065 1.408-.58 1.56-.713l.846-.006z'/%3e%3cpath fill='%23fff' d='M2136.444 1381.234h-.91s-1.099 1.068-2.945 1.068c-1.9 0-3.2-1.065-3.2-1.065l-.825.008v.334l.653-.01s1.388 1.075 3.382 1.076c1.94.001 3.076-1.069 3.076-1.069l.77-.01z'/%3e%3cpath d='M2135.578 1381.347h.754v.108l-.7.01-.033.028c-.01.011-1.13 1.04-2.998 1.04h-.002c-1.93 0-3.3-1.042-3.313-1.053l-.031-.024-.578.01v-.11l.673-.007a5.55 5.55 0 0 0 3.238 1.066c1.713 0 2.786-.884 2.99-1.068m.979-.225h-1.07l-.031.033c-.011.01-1.091 1.036-2.868 1.036-1.84 0-3.115-1.03-3.127-1.04l-.032-.027-.977.008v.56l.73-.01c.224.164 1.55 1.074 3.417 1.075h.002c1.8 0 2.913-.89 3.119-1.07l.837-.01z'/%3e%3cpath fill='%23fff' d='m2119 1379.036.364-.312 6.719-.024.38-.246.027.357-.36.195z'/%3e%3cpath d='m2119.405 1378.836 6.71-.023.25-.162.007.096-.27.146-6.798.03zm7.156-.58-.513.332-6.725.025-.626.536 7.462-.032.448-.242z'/%3e%3cpath fill='%23fff' d='m2121.125 1377.999-.175-4.22'/%3e%3cpath d='m2121.061 1373.774-.225.009.177 4.22.224-.009z'/%3e%3cpath fill='%23fff' d='m2121.414 1377.999-.175-4.206'/%3e%3cpath d='m2121.35 1373.788-.224.01.176 4.206.224-.01z'/%3e%3cpath fill='%23fff' d='m2124.62 1377.999-.076-1.847'/%3e%3cpath d='m2124.657 1376.147-.225.01.076 1.846.225-.009z'/%3e%3cpath fill='%23040006' d='m2125.691 1369.721.27 8.277.465-.458-.237-7.819z'/%3e%3cpath d='m2126.135 1377.989-.223.02.036.404.221-.02zm.058.694-.221.034.054.335.22-.034z'/%3e%3cpath d='m2126.17 1378.394-.223.018.024.296.223-.016z'/%3e%3cpath fill='%23fff' fill-rule='evenodd' d='M2132.98 1382.645h-.952v.416h.952z'/%3e%3cpath d='M2132.129 1382.745h.751v.217h-.751zm.951-.2h-1.151v.617h1.151z'/%3e%3cpath fill='%23fff' fill-rule='evenodd' d='M2132.866 1383.429h-.724v-.368h.724z'/%3e%3cpath d='M2132.243 1383.162h.523v.167h-.523zm.724-.2h-.924v.567h.924z'/%3e%3cpath fill='%23fff' fill-rule='evenodd' d='M2132.028 1383.797h.952v-.367h-.952z'/%3e%3cpath d='M2132.129 1383.529h.751v.167h-.751zm.951-.2h-1.151v.567h1.151z'/%3e%3cpath fill='%23fff' d='M2131.668 1386.693v.926h.436v2.552h2.769v-2.562l.412.001v-.917z'/%3e%3cpath d='M2131.78 1386.804h3.395v.693l-.414-.002v2.563h-2.546v-2.55h-.435zm3.617-.224h-3.84v1.15h.435v2.551h2.993v-2.56l.412.001z'/%3e%3cpath fill='%23fff' d='m2135.285 1387.61.265-.381v-.808l-.265.272z'/%3e%3cpath d='m2135.397 1386.738.042-.043v.499l-.042.06zm.265-.593-.488.502v1.32l.488-.703z'/%3e%3cpath fill='%23fff' d='M2132.103 1390.171h-.436v-2.552h.436z'/%3e%3cpath d='M2131.78 1387.73h.212v2.328h-.212zm.435-.223h-.657v2.773h.657zm1.855 3.412s-.102.202-.074.534c.028.33.064.176.13.539.067.382.095.669.105.833.01.165.041.484.081.639 0 0 .25.178.362.285.114.108.141.188.193.274 0 0-.002.187.001.264 0 0 .068.068.087.096.018.029.02.064.026.122.007.058.06.149.032.172-.014.013-.004.024-.027.04-.022.016-.012.029-.03.027-.029-.002-.05-.11-.07-.152-.02-.044-.053-.077-.01-.178l-.046-.038s-.045.013-.099-.028c-.053-.042-.389-.29-.549-.346-.113-.04-.163-.027-.269-.02-.106.01-.189.004-.207.122-.019.117-.01.336-.08.434-.07.1-.185.169-.31.127-.128-.041-.187-.131-.153-.283.034-.152.18-.378.11-.4-.069-.024-.13-.08-.209-.111-.078-.032-.099-.073-.228-.071-.189.002-.43.117-.594.165 0 0-.056-.015-.08.003s-.034.013-.027.055c.008.042 0 .055-.053.12-.054.065-.078.11-.112.116-.022.003-.04.006-.055-.026-.017-.032-.016-.015-.022-.042-.007-.026-.01-.04-.003-.061.01-.022.04-.064.056-.125.016-.062.04-.072.097-.111.048-.034.064-.001.127-.05 0 0 .015-.158.02-.188 0 0 .15-.1.235-.14.087-.041.201-.096.402-.175 0 0 .027-.361.032-.714.005-.35.065-.524.115-.76.051-.234.111-.3.116-.524.003-.226-.102-.548-.102-.548z'/%3e%3cpath fill='%23fff' d='M2135.285 1387.61h-.412v2.561h.412z'/%3e%3cpath d='M2134.985 1387.721h.189v2.337h-.189zm.412-.222h-.636v2.782h.636zm-4.554-.635.63-.755v.28h3.812l.53-.731v-.412l.63.464-.708 1.154z'/%3e%3cpath fill='%23fff' d='M2134.6 1390.459s.001.775-.852.793h-.4c-.853-.018-.852-.793-.852-.793z'/%3e%3cpath d='M2132.619 1390.57h1.858c-.034.195-.173.559-.73.57h-.4c-.555-.011-.694-.375-.728-.57m2.093-.223h-2.327v.113c0 .007.009.883.962.903h.402c.954-.02.963-.896.963-.903z'/%3e%3cpath fill='%23fff' d='m2131.395 1390.413.264-.466v.25h3.626l.225-.68v-.104l.27.073-.32.927z'/%3e%3cpath d='M2135.4 1389.266v.232l-.195.588h-3.435v-.564l-.486.78.054.222h4.202l.35-1.038z'/%3e%3cpath fill='%23fff' d='M2135.418 1390.413v.886h-.242v-.444h-3.538v.444h-.242v-.886z'/%3e%3cpath d='M2131.507 1390.524h3.8v.662h-.02v-.442h-3.761v.442h-.02zm4.022-.223h-4.245v1.109h.465v-.444h3.316v.444h.464z'/%3e%3cpath fill='%23fff' d='m2135.418 1390.413.36-.927v.396l-.36.992z'/%3e%3cpath d='m2135.675 1389.445-.368.968v.46l.222.089.362-1.08v-.396z'/%3e%3cpath fill='%23fff' d='M2133.89 1390.413v.442s-.14.322-.525.322c-.384 0-.524-.322-.524-.322v-.442z'/%3e%3cpath d='M2132.953 1390.524h.824v.305a.466.466 0 0 1-.412.236.468.468 0 0 1-.412-.236zm1.047-.223h-1.27l.009.599a.686.686 0 0 0 .626.388c.453 0 .62-.372.627-.388l.008-.045zm-.522 4.691c-.267 0-.5-.26-.5-.555 0-.285.23-.526.5-.526.284 0 .515.236.515.526 0 .295-.24.555-.515.555m0-1.177c-.322 0-.595.285-.595.622 0 .346.278.65.595.65.33 0 .61-.297.61-.65a.617.617 0 0 0-.61-.622'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-miterlimit='3.864' stroke-width='.198' d='M2119.09 1372.881s1.747.176 3.663.176m-3.75-.647s1.441.106 3.34.158m-3.428-.632s1.228.071 3.095.15m-3.151-.587s.957.024 2.823.104m-2.868-.533s1.114.038 2.563.08m-2.591-.466s1.514.043 2.36.065m-2.4-.433s1.414.002 2.083.022m-2.143-.388h1.838m13.319 3.13s5.13.024 12.64-.143m-12.698-.342s3.523.043 11.015-.046m-11.155-.479s7.256.136 9.732.06m-9.8-.497s6.258.1 8.28.035m-8.335-.461s5.32.074 6.923.056m-6.96-.441s4.284.043 5.13.045m-5.179-.411s2.682-.02 3.351-.016m-3.42-.395s1.402.01 1.838 0'/%3e%3cpath fill='%23f0e53c' d='M2143.108 1204.16c.66-6.117 1.664-16.554-10.437-28.31 4.47-4.648 10.437-7.795 19.884-7.616 9.447.149 16.884-.18 25.505 7.766-3.807 3.149-14.244 12.086-9.942 28.16z'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='.276' d='M2143.108 1204.16c.66-6.117 1.664-16.554-10.437-28.31 4.47-4.648 10.437-7.795 19.884-7.616 9.447.149 16.884-.18 25.505 7.766-3.807 3.149-14.244 12.086-9.942 28.16z'/%3e%3cpath fill='%23f0e53c' d='m2179.162 1204.629 1.188-3.188c.332 1.33.437 2.344.557 4.03l1.324-3.2c.667 1.463.914 4.315.914 4.315l.84-3.173c1.613 2.388 3.579 6.35 4.047 8.675l.229-3.937 1.258 4.998.4-3.053c1.43 4.316 2.185 4.511 1.282 11.14-.898 6.583-6.155 10.644-8.391 11.437-1.268.45-2 1.937-6.055 3.513-3.038 1.178-4.89.749-6.372 1.229-1.5.51-3.535 1.554-7.086 1.344-4.065-.242-3.268-.531-6.17-.773-2.488-.206-5.053.663-9.027-.391-3.697-.981-8.783-5.414-11.833-8.277-3.265-3.064-5.891-6.93-7.63-11.987l1.65.562c-1.618-3.223-1.826-6.794-1.826-6.794l1.583.864s-.343-1.712-.277-3.263l2.18 1.653s-.49-2.253-.332-3.921c0 0 1.16 1.014 2.162 2.087 0 0-.155-2.494.099-4.181l2.11 2.509s-.048-2.142.25-4.037l1.826 2.59s.068-1.944.54-4.015l1.754 2.741s.117-1.816.73-3.794l1.713 2.808c.476-2.062.498-2.509 1.728-4.686l1.952 3.581s.797-2.803 2.385-4.686l1.74 3.898s.313-2.08 1.964-4.408l1.827 4.154s.392-2.235 1.915-4.393c0 0 1.26 2.21 1.892 4.393l2.254-4.393s1.42 2.066 2.046 4.783l2.236-4.176s1.22 2.36 1.835 4.637l1.575-4.434c.546 1.354 1.285 3.237 1.542 4.706l1.057-4.146s.875 2.012 1.158 4.443l1.37-3.676s.707 2.121.77 4.072l1.225-3.345s.479 1.904.542 3.821l1.137-3.184s.496 1.82.604 3.786l1.006-3.133s.494 1.654.603 3.874'/%3e%3cpath fill='none' stroke='%23473125' stroke-miterlimit='10' stroke-width='.276' d='m2179.162 1204.629 1.188-3.188c.332 1.33.437 2.344.557 4.03l1.324-3.2c.667 1.463.914 4.315.914 4.315l.84-3.173c1.613 2.388 3.579 6.35 4.047 8.675l.229-3.937 1.258 4.998.4-3.053c1.43 4.316 2.185 4.511 1.282 11.14-.898 6.583-6.155 10.644-8.391 11.437-1.268.45-2 1.937-6.055 3.513-3.038 1.178-4.89.749-6.372 1.229-1.5.51-3.535 1.554-7.086 1.344-4.065-.242-3.268-.531-6.17-.773-2.488-.206-5.053.663-9.027-.391-3.697-.981-8.783-5.414-11.833-8.277-3.265-3.064-5.891-6.93-7.63-11.987l1.65.562c-1.618-3.223-1.826-6.794-1.826-6.794l1.583.864s-.343-1.712-.277-3.263l2.18 1.653s-.49-2.253-.332-3.921c0 0 1.16 1.014 2.162 2.087 0 0-.155-2.494.099-4.181l2.11 2.509s-.048-2.142.25-4.037l1.826 2.59s.068-1.944.54-4.015l1.754 2.741s.117-1.816.73-3.794l1.713 2.808c.476-2.062.498-2.509 1.728-4.686l1.952 3.581s.797-2.803 2.385-4.686l1.74 3.898s.313-2.08 1.964-4.408l1.827 4.154s.392-2.235 1.915-4.393c0 0 1.26 2.21 1.892 4.393l2.254-4.393s1.42 2.066 2.046 4.783l2.236-4.176s1.22 2.36 1.835 4.637l1.575-4.434c.546 1.354 1.285 3.237 1.542 4.706l1.057-4.146s.875 2.012 1.158 4.443l1.37-3.676s.707 2.121.77 4.072l1.225-3.345s.479 1.904.542 3.821l1.137-3.184s.496 1.82.604 3.786l1.006-3.133s.494 1.654.603 3.874z'/%3e%3cpath fill='none' stroke='%23473125' stroke-linecap='round' stroke-width='.248' d='M2133.92 1209.08c3.674 8.17 12.449 16.49 20.603 18.29m-21.946-15.877c2.083 3.343 6.977 9.28 12.608 12.4m-14.821-11.367c1.802 2.7 9.039 10.678 16.77 13.392m-17.001-10.573c6.364 6.793 14.246 13.275 24.03 12.615m-23.459-9.468c5.283 5.222 14.48 11.49 24.292 10.02m-23.899-7.227c5.405 4.38 15.827 11.452 24.352 7.576m-22.189-3.919c4.076 2.909 15.026 9.372 23.253 4.573m-19.846-.84c5.589 3.362 14.645 5.635 19.532 1.485m-15.879 1.829c3.778 2.189 11.611 2.98 15.926-1.26m-7.963 6.445c3.836-1.977 8.121-2.055 9.963-7.463m-3.25 7.917c1.653-1.652 2.903-3.903 3.158-6.393m-14.056 3.903c4.851 1.08 11.192-1.92 12.438-3.75m-5.053 6.24c2.04-1.05 5.278-3.321 6.057-5.54m4.86 6.285c-1.995-2.49-3.342-6.263-3.837-9.112m8.828 8.542c-2.938-1.498-5.233-2.519-6.947-6.319m12.144 4.911c-4.552-.652-9.328-3.685-12.342-7.523m19.836 4.945c-5.421.05-6.747-1.106-11.493-2.215m20.652-7.517c-2.412 5.956-7.624 8.626-15.586 7.774m-9.765-2.977c3.153 1.334 6.822 1.628 10.195 1.697m1.411.001c8.022-.3 13.868-8.936 14.08-16.554m-12.925 14.904c6.304-2.043 11.365-8.426 11.425-15.323m-5.54 16.123c5.54-2.813 7.34-8.006 7.834-13.98m-18.608 11.358c7.902-1.11 14.564-8.06 14.83-16.08m-15.07 17.657c7.243-.916 13.897-5.922 15.307-12.818m-23.09 12.163c2.641.48 3.537.549 6.486.729m-7.233-1.717c3.763-.42 6.214-1.265 8.95-2.474m-9.462 2.113c1.8-.51 4.248-2.054 5.673-3.224m-6.716 1.814c1.616-1.097 2.868-1.813 4.942-3.349m-2.856-2.018c-1.52 1.855-2.654 4.049-3.77 5.927m.659-5.342c-.496 1.199-1.154 2.549-1.648 3.794m-1.3-3.794c-.444 1.664-.531 3.225-.155 5.106m-5.117-10.069c.854 3.718 1.87 6.359 4.277 9.506m-9.492-10.533c1.975 4.078 5.866 9.129 9.522 11.769m-13.803-10.923c1.978 3.146 7.229 9.047 13.952 11.381m-16.221-11.2c2.682 3.718 8.968 10.069 16.356 12.086m16.555-3.659c6.64-2.82 9.775-6.657 10.855-13.734m-11.605 12.305c5.046-3.718 8.967-10.829 9.434-18.364m-12.769 18.473c6.243-4.048 10.062-10.793 10.726-18.779m-12.935 17.431c5.259-4.373 8.123-9.971 8.527-17.185m-2.983 13.824c3.096-3.988 4.403-8.152 4.724-12.95m-.661 15.579c3.005-2.853 5.152-6.866 6.304-12.645m-19.143 14.245c5.402-3.928 9.36-11.494 9.843-18.232m-9.35 14.885c3.257-4.308 4.96-8.839 5.286-15.798m-6.766 12.997c2.234-4.333 2.879-6.926 3.556-13.164m-7.123 11.276c.665-4.47 1.454-10.017 1.243-15.325m-3.988 19.794c-.139-5.013.966-11.107 1.215-16.735m-3.351 15.061c-1.162-6.56-.38-9.434-.247-14.641m-2.212 11.665c-.657-3.93-1.324-6.17-1.274-11.665m2.402 19.258c-1.79-2.795-4.61-9.277-5.555-12.105-.648-1.946-1.112-4.513-1.057-6.582m-.432 10.314c-1.812-3.78-2.414-5.098-3.173-9.235m-2.402.989c.478 2.568 2.035 6.616 3.16 8.415m-5.465-7.083c.255 1.83 1.965 5.88 3.337 7.529m-5.472-6.293c.956 2.836 1.732 4.48 3.308 6.64m18.387 5.643c.335-1.16.905-1.884 1.405-4.519m1.325 11.484c2.423-.589 3.899-1.424 5.249-2.443m-3.261 5.31c1.123.68 4.151 2.09 4.991 2.658m-8.024-3.141c.43.75.47 1 .879 1.913m-2.426-2.662c-.614 1.141-.407.93-1.172 1.949m.619-1.703c-1.722.658-3.193 1.782-6.525 1.973m6.797-2.491c-.755-.058-1.882-.388-2.585-.596m3.058-.871c-.33-1.26-.31-3.755.66-6.718m-.195 6.122c.284-.96 2.592-5.13 3.057-6.029m-1.856 6.864c.577-.835 1.552-.918 2.233-1.266m-2.399 2.527c.954.167 1.365.719 2.234 1.139m-2.486-1.831c1.076-.339 4.263.271 5.44.091m-6.546.899c-.215.901-.657 1.991-1.168 2.76m3.351 1.773c.377.82 1.3 2.819 2.699 3.937m-18.149-21.826c1.83 3.161 4.397 5.635 7.305 8.56m8.52-3.863c.45-.955 1.035-1.837 1.645-2.85m-15.514-20.038c-.338-11.813-4.495-17.506-8.52-24.681m10.527 23.605c-.409-5.552-.838-7.98-1.678-11.16m-.42-1.678c-1.656-4.287-3.463-8.187-6-12.085m-6.342 3.898c2.896 3.448 6.134 7.616 8.113 12.174m-6.15-13.509c2.657 3.8 4.637 7.203 6.826 11.86m21.181 7.902c.953-4.63 1.568-7.135 3.247-10.854m-5.971 10.39c1.274-7.648 3.164-15.084 7.872-21.203m-1.546 9.917c1.557-3.288 3.523-5.638 5.681-8.148m-16.97 20.843c.164-7.888-.715-17.533-.715-25.39m-.948 22.076c-.224-7.871-1.168-15.153-1.915-22.076m7.157 21.671c.467-4.918 1.55-15.029 5.118-20.707m-6.95 23.017c.226-6.868.37-16.156 1.49-23.655m-14.422.142c1.07 2.83 2.504 7.501 3.44 11.052m-6.08-10.301c1.808 3.63 4.458 8.956 5.609 13.5m2.241-14.719c.46 2.956 1.19 6.718 1.619 10.613m-.655 16.936c0-3.449-.593-9.595-1.182-13.345m14.89 9.366c.658-2.906 1.095-4.364 1.981-6.816m-4.8 12.025c.525-3.51 1.166-6.526 1.902-9.776m3.9-.807c.81-2.055 1.452-3.478 3.389-5.911m-7.04 5.621c1.251-4.314 1.866-5.69 3.526-9.044m.592-1.059a31.765 31.765 0 0 1 2.922-4.314m0 6.421c.884-1.195 2.564-2.666 3.7-3.862m-32.337 13.586c.974 2.677 1.214 4.761 1.55 8.484m1.355 2.928c-.016-1.2-.235-4.033-.47-5.477m9.447 2.204c.104-1.32.029-3.103 0-4.452m-1.737-1.858c-.156-3.538-.61-7.89-.806-9.419m-2.649-2.638c-.373-2.592-1.099-5.655-1.488-6.886m-1.484 4.816c-.89-2.364-1.604-4.291-2.598-6.371m17.436 27.333c.427-2.908.722-4.572 1.443-7.706m.353 9.402c.23-1.528.442-3.148.685-4.447m3.82-10.099c.743-1.874 1.6-3.076 2.63-4.41m-11.805 47.638c.375-.645.375-.645.705-1.139m-.611 1.89c.718.426 1.164 1.141 1.436 1.664m1.197-.252c1.287 1.136 2.205 1.43 3.782 2.42m-3.336-3.255c1.28.502 3.336 1.821 5.613 2.477m-8.518-3.455c.951-.147 2.362.027 3.746.25m-4.436-.76c.287-.922 2.483-4.8 3.282-6.076m-3.761 6.11c-.514-1.202-2.646-2.362-3.987-4.437m3.763 4.673c-1.213-.56-3.713-1.173-5.643-2.454m4.791 3.291c-.776.062-1.418-.288-2.181-.37m2.283 3.595c-1.446 2.108-3.604 2.776-4.239 3.058m5.881-6.315c.501 1.08.848 2.422 1.432 3.742m-1.621-1.507c.114.872.378 1.409.378 2.373m1.867-2.68c.302.456.599 1.155 1.196 1.814m-1.196-3.965c1.117.148 1.543.29 2.63.52m-.86-3.292c2.432-1.067 5.753-3.682 7.63-5.762m-9.586 6.007c.553-.75 1.834-2.189 2.448-2.729m-4.582 1.978c.362-2.458.7-4.462 1.9-6.619m-3.936 4.813c-.825-1.63-1.32-3.484-1.575-4.7m-2.367 8.966a18.75 18.75 0 0 1-4.137-1.037m4.764 2.903c-1.855.411-6.07-.075-7.936-.75m13.74 5.159c.13 1.229-.253 3.43-.253 4.12m3.697-5.214c.826 1.147 2.268 2.653 5.387 3.751m-1.692-3.834c3.576 2.52 8.525 2.938 10.55 3.237m-7.577-11.686c1.434-.93 2.782-1.893 4.097-3.072m-6.217 2.577c1.979-1.43 3.432-2.77 4.902-4.303m.811-2.481c1.188-1.618 2.824-5.001 3.258-7.026m.206-1.127c.36-1.618.703-4.655.72-6.244m-8.862 17.312c5.548-5.652 6.998-12.917 7.167-17.915m-7.913 15.412c2.276-3.466 4.314-8.277 4.613-13.532m-6.004 10.133c1.825-3.669 2.631-10.232 2.346-13.957m9.964 23.622c4.275-2.879 6.294-6.267 7.145-10.315m.242-1.217c.136-1.462.275-2.18.136-4.356m-1.224 1.742c.113-1.101.063-3.026-.069-3.807m-.157 19.911c2.172-1.8 4.174-6.363 4.344-8.009m-3.84 9.987c1.437-1.191 3.536-3.757 4.578-7.7m.367 3.795c.314-.75.616-2.019.782-2.83m-41.662-21.805c-.465 3.786.063 8.288 1.558 13.539m15.429-14.754c.136-2.058.479-6.04 1.848-9.761m-.955 7.995c.03-1.764.708-5.604 1.305-7.178m-2.964 7.842c.068-1.024.176-1.66.353-3.008m-1.702-5.667c.503-2.186 1.103-3.938 1.805-5.723m.931-2.666c.585-1.261 1.712-3.45 2.43-4.65'/%3e%3cpath fill='%23292723' d='M2194.754 1315.191s.154-.721.515-1.103c.403-.426 1.064-.437 1.91-.305.72.112.805.28 1.129.663l.18-3.248-3.734.258z'/%3e%3cpath fill='%23f0e53c' d='M2115.954 1627.398c-7.588-8.623-2.91-14.875-19.718-17.559-2.954-.479-6.673 1.02-9.461-2.458-.585-.735-.705-2.865-1.321-3.284-2.938-2.039-2.307-4.889-1.348-6.944 2.879 5.61 3.343 1.756 7.81 4.5 3.39 2.083 4.11 3.508 9.883 3.87-.3-4.155-2.894-6.329-3.6-9.434-.718-3.149.932-7.45 4.545-7.242-2.624 5.024 2.803 3.33 2.158 7.602-.81 5.294 3.794 10.782 7.123 8.907 3.479-1.964 10.42-4.768 9.52-9.37 2.88 2.907 2.536 6.506-.148 8.665-3.06 2.475-7.827 3.134-5.563 11.336 1.169 4.258 6.973 9.821 8.92 14.47z'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.048' d='M2115.954 1627.398c-7.588-8.623-2.91-14.875-19.718-17.559-2.954-.479-6.673 1.02-9.461-2.458-.585-.735-.705-2.865-1.321-3.284-2.938-2.039-2.307-4.889-1.348-6.944 2.879 5.61 3.343 1.756 7.81 4.5 3.39 2.083 4.11 3.508 9.883 3.87-.3-4.155-2.894-6.329-3.6-9.434-.718-3.149.932-7.45 4.545-7.242-2.624 5.024 2.803 3.33 2.158 7.602-.81 5.294 3.794 10.782 7.123 8.907 3.479-1.964 10.42-4.768 9.52-9.37 2.88 2.907 2.536 6.506-.148 8.665-3.06 2.475-7.827 3.134-5.563 11.336 1.169 4.258 6.973 9.821 8.92 14.47z'/%3e%3cpath fill='%23f0e53c' d='M2133.108 1600.992c0 4.064 1.453 6.478 5.367 6.028 4.558-.525 14.32-3.779 17.65.78 2.113 2.91 1.423 8.668 1.364 12.16 2.083-.03 4.153-.09 6.252-.119-.765-3.899-2.489-11.217-.749-15.055 1.753-3.854 8.005-2.983 7.196-7.828 1.95-1.394 1.875-4.062.494-6.132-.464 2.88-2.187 2.4-3.659 3.614-.658.554-2.294.15-3.282.93-.796.63-1.02 1.724-1.56 2.084-5.504 3.764-4.843-2.879-6.028-4.844-1.41-2.354.36-5.248-3.748-4.843-.569-.915-1.41-2.099.075-3.643-8.366-1.86-.375 9.806-.78 13.854-3.524.405-5.383-7.977-10.736-5.907-.915-.765-2.025-2.429-1.485-4.273-2.488 1.873-2.608 4.708-.345 7.167-3.267 4.723 6.553 4.198 10.347 8.006.105-.029.284.046.15-.014-3.853.63-6.163-1.799-9.447-2.1-3.058-.269-3.763 2.655-7.076.135'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.048' d='M2133.108 1600.992c0 4.064 1.453 6.478 5.367 6.028 4.558-.525 14.32-3.779 17.65.78 2.113 2.91 1.423 8.668 1.364 12.16 2.083-.03 4.153-.09 6.252-.119-.765-3.899-2.489-11.217-.749-15.055 1.753-3.854 8.005-2.983 7.196-7.828 1.95-1.394 1.875-4.062.494-6.132-.464 2.88-2.187 2.4-3.659 3.614-.658.554-2.294.15-3.282.93-.796.63-1.02 1.724-1.56 2.084-5.504 3.764-4.843-2.879-6.028-4.844-1.41-2.354.36-5.248-3.748-4.843-.569-.915-1.41-2.099.075-3.643-8.366-1.86-.375 9.806-.78 13.854-3.524.405-5.383-7.977-10.736-5.907-.915-.765-2.025-2.429-1.485-4.273-2.488 1.873-2.608 4.708-.345 7.167-3.267 4.723 6.553 4.198 10.347 8.006.105-.029.284.046.15-.014-3.853.63-6.163-1.799-9.447-2.1-3.058-.269-3.763 2.655-7.076.135z'/%3e%3cpath d='M2119.237 1730.093c-5.248 4.98-10.825 8.952-18.112 18.354-7.288 9.416-33.483 29.838-61.507 39.78-28.01 9.956-75.707 33.767-56.44 5.623 1.455-1.425-.163-2.729-4.467-.375-4.288 2.354-12.745 10.481-20.002 12.564-7.258 2.1-46.333 1.831-57.16-4.153-10.84-5.966-3.598-9.295 10.812-15.144 14.395-5.848 41.894-17.887 58.132-30.453 16.225-12.58 34.563-23.572 41.896-27.499 7.332-3.93 4.557-3.675 10.795-3.93 6.224-.255 57.189-4.707 64.177-36.136-4.53-3.404-34.113-57.352-13.436-60.502 20.692-3.133 35.492-2.67 38.16-1.619l-.99-3.929s6.163 1.815 8.264-2.368c3.147 1.83 5.562 8.141 10.795 8.395 5.249.271 8.726 1.095 12.91-.733 4.184-1.83 12.566-8.907 14.41-12.566 2.353-.525 3.643.54 5.232-1.049 1.41-1.409 5.758 7.332 5.758 12.835 0 5.487 4.979 4.184 8.112.255 3.149-3.93 12.836-29.854 18.339-29.585 5.503.255 6.027 2.88 7.857 3.93 2.624-1.845 6.55.51 8.382 4.183 5.757-1.05 12.834 2.1 12.834 9.431 6.283-.525 10.21 1.83 10.21 7.333 3.93 0 10.738 2.608 10.467 8.382 3.405.523 11.53 5.487 6.029 10.465-5.503 4.978-45.824 26.72-62.062 31.683-16.238 4.978-24.097 9.702-24.352 13.885-.268 4.198 17.274 7.332 23.827 24.351 6.553 17.033-8.382 23.317.78 29.074 9.176 5.758 35.626 22.777 65.209 32.477 29.6 9.687 72.799 26.706 63.907 29.585-8.906 2.88-30.903 8.38-48.972 9.16-18.083.796-76.216 1.576-93.49-4.182-17.287-5.758-33.003-8.907-43.213-34.563-10.212-25.67-8.382-42.434-12.311-48.972z'/%3e%3cpath fill='none' stroke='%2359595b' stroke-width='1.571' d='M2119.237 1730.093c-5.248 4.98-10.825 8.952-18.112 18.354-7.288 9.416-33.483 29.838-61.507 39.78-28.01 9.956-75.707 33.767-56.44 5.623 1.455-1.425-.163-2.729-4.467-.375-4.288 2.354-12.745 10.481-20.002 12.564-7.258 2.1-46.333 1.831-57.16-4.153-10.84-5.966-3.598-9.295 10.812-15.144 14.395-5.848 41.894-17.887 58.132-30.453 16.225-12.58 34.563-23.572 41.896-27.499 7.332-3.93 4.557-3.675 10.795-3.93 6.224-.255 57.189-4.707 64.177-36.136-4.53-3.404-34.113-57.352-13.436-60.502 20.692-3.133 35.492-2.67 38.16-1.619l-.99-3.929s6.163 1.815 8.264-2.368c3.147 1.83 5.562 8.141 10.795 8.395 5.249.271 8.726 1.095 12.91-.733 4.184-1.83 12.566-8.907 14.41-12.566 2.353-.525 3.643.54 5.232-1.049 1.41-1.409 5.758 7.332 5.758 12.835 0 5.487 4.979 4.184 8.112.255 3.149-3.93 12.836-29.854 18.339-29.585 5.503.255 6.027 2.88 7.857 3.93 2.624-1.845 6.55.51 8.382 4.183 5.757-1.05 12.834 2.1 12.834 9.431 6.283-.525 10.21 1.83 10.21 7.333 3.93 0 10.738 2.608 10.467 8.382 3.405.523 11.53 5.487 6.029 10.465-5.503 4.978-45.824 26.72-62.062 31.683-16.238 4.978-24.097 9.702-24.352 13.885-.268 4.198 17.274 7.332 23.827 24.351 6.553 17.033-8.382 23.317.78 29.074 9.176 5.758 35.626 22.777 65.209 32.477 29.6 9.687 72.799 26.706 63.907 29.585-8.906 2.88-30.903 8.38-48.972 9.16-18.083.796-76.216 1.576-93.49-4.182-17.287-5.758-33.003-8.907-43.213-34.563-10.212-25.67-8.382-42.434-12.311-48.972z'/%3e%3cpath fill='%23fff' d='M2087.284 1685.05a4.216 4.216 0 0 0-4.004 2.94c-8.816 28.144-42.943 30.917-59.797 32.597-2.848.286-7.407.69-9.206 1.724-21.097 12.056-54.82 37.306-78.48 50.577-21.037 11.785-67.159 24.335-66.636 26.6.525 2.25 49.123-8.816 71.208-21.203 21.863-12.265 63.081-36.796 77.416-48.057 1.485-.195 3.39-.39 5.547-.599 18.654-1.844 57.46-5.698 67.955-39.136a4.19 4.19 0 0 0-4.003-5.443'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M2087.284 1685.05a4.216 4.216 0 0 0-4.004 2.94c-8.816 28.144-42.943 30.917-59.797 32.597-2.848.286-7.407.69-9.206 1.724-21.097 12.056-54.82 37.306-78.48 50.577-21.037 11.785-67.159 24.335-66.636 26.6.525 2.25 49.123-8.816 71.208-21.203 21.863-12.265 63.081-36.796 77.416-48.057 1.485-.195 3.39-.39 5.547-.599 18.654-1.844 57.46-5.698 67.955-39.136a4.19 4.19 0 0 0-4.003-5.443z'/%3e%3cpath fill='%23fff' d='M1883.017 1805.26c-8.501 3.944-.48 6.913 14.155 1.05 6.448-2.593 20.527-8.592 32.462-16.763 14.935-10.211-39.301 12.31-46.617 15.713'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M1883.017 1805.26c-8.501 3.944-.48 6.913 14.155 1.05 6.448-2.593 20.527-8.592 32.462-16.763 14.935-10.211-39.301 12.31-46.617 15.713z'/%3e%3cpath fill='%23fff' d='M2084.15 1682.262c-1.35 0-2.667.645-3.478 1.844-1.29 1.919-.794 4.528 1.125 5.818 13.644 9.222 30.093 25.566 33.992 36.99 1.544 4.515 2.758 10.437 4.049 16.705 2.413 11.8 4.257 26.945 10.392 37.8 11.138 19.703 26.854 27.62 52.059 31.728 30.753 5.009 93.879 5.714 116.312-.45 20.96-5.742 63.934-21.426 63.14-23.616-.78-2.174-43.033 9.417-65.36 15.535-21.127 5.788-83.414 5.039-112.758.255-26.15-4.26-35.402-15.19-43.618-29.734-5.487-9.701-9.672-22.012-11.966-33.198-1.334-6.537-2.594-12.715-4.32-17.737-5.247-15.34-25.144-33.048-37.23-41.22a4.202 4.202 0 0 0-2.338-.72'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='2.095' d='M2084.15 1682.262c-1.35 0-2.667.645-3.478 1.844-1.29 1.919-.794 4.528 1.125 5.818 13.644 9.222 30.093 25.566 33.992 36.99 1.544 4.515 2.758 10.437 4.049 16.705 2.413 11.8 4.257 26.945 10.392 37.8 11.138 19.703 26.854 27.62 52.059 31.728 30.753 5.009 93.879 5.714 116.312-.45 20.96-5.742 63.934-21.426 63.14-23.616-.78-2.174-43.033 9.417-65.36 15.535-21.127 5.788-83.414 5.039-112.758.255-26.15-4.26-35.402-15.19-43.618-29.734-5.487-9.701-9.672-22.012-11.966-33.198-1.334-6.537-2.594-12.715-4.32-17.737-5.247-15.34-25.144-33.048-37.23-41.22a4.202 4.202 0 0 0-2.338-.72z'/%3e%3cpath fill='%23fff' d='M1874.02 1798.859c-8.893 2.879-1.289 6.792 13.93 2.744 6.717-1.77 21.427-6.029 34.277-12.686 16.06-8.322-40.516 7.452-48.208 9.942'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M1874.02 1798.859c-8.893 2.879-1.289 6.792 13.93 2.744 6.717-1.77 21.427-6.029 34.277-12.686 16.06-8.322-40.516 7.452-48.208 9.942z'/%3e%3cpath fill='%23fff' d='M1893.378 1810.299c-8.083 4.692.164 6.913 14.2-.254 6.176-3.181 19.657-10.453 30.797-19.674 13.931-11.545-38.01 15.864-44.997 19.928'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M1893.378 1810.299c-8.083 4.692.164 6.913 14.2-.254 6.176-3.181 19.657-10.453 30.797-19.674 13.931-11.545-38.01 15.864-44.997 19.928z'/%3e%3cpath fill='%23fff' d='M1904.623 1811.873c-7.932 4.978.405 6.913 14.17-.734 6.073-3.39 19.282-11.125 30.108-20.722 13.511-12.027-37.44 17.168-44.278 21.456'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M1904.623 1811.873c-7.932 4.978.405 6.913 14.17-.734 6.073-3.39 19.282-11.125 30.108-20.722 13.511-12.027-37.44 17.168-44.278 21.456z'/%3e%3cpath fill='%23fff' d='M1916.365 1811.977c-7.903 5.024.435 6.913 14.169-.809 6.057-3.404 19.237-11.2 30.004-20.873 13.465-12.069-37.351 17.35-44.173 21.682'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M1916.365 1811.977c-7.903 5.024.435 6.913 14.169-.809 6.057-3.404 19.237-11.2 30.004-20.873 13.465-12.069-37.351 17.35-44.173 21.682z'/%3e%3cpath fill='%23fff' d='M1930.669 1812.143c-7.812 5.157.554 6.897 14.155-1.08 5.997-3.508 19.027-11.546 29.614-21.397 13.255-12.31-37.022 18.01-43.77 22.477'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M1930.669 1812.143c-7.812 5.157.554 6.897 14.155-1.08 5.997-3.508 19.027-11.546 29.614-21.397 13.255-12.31-37.022 18.01-43.77 22.477z'/%3e%3cpath fill='%23fff' d='M1945.303 1812.533c-7.467 5.638.99 6.853 14.064-1.95 5.758-3.883 18.264-12.73 28.22-23.21 12.446-13.137-35.837 20.286-42.284 25.16'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M1945.303 1812.533c-7.467 5.638.99 6.853 14.064-1.95 5.758-3.883 18.264-12.73 28.22-23.21 12.446-13.137-35.837 20.286-42.284 25.16z'/%3e%3cpath fill='%23fff' d='M1961.254 1812.908c-5.783 5.633 1.575 5.775 11.81-3.204 4.526-3.955 14.276-12.88 21.677-22.962 9.25-12.618-28.482 21.285-33.487 26.166'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M1961.254 1812.908c-5.783 5.633 1.575 5.775 11.81-3.204 4.526-3.955 14.276-12.88 21.677-22.962 9.25-12.618-28.482 21.285-33.487 26.166z'/%3e%3cpath fill='%23fff' d='M1974.992 1810.674c-4.902 6.432 2.4 5.487 11.2-4.903 3.884-4.574 8.682-8.667 14.5-19.733 7.287-13.854-21.487 19.073-25.7 24.636'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M1974.992 1810.674c-4.902 6.432 2.4 5.487 11.2-4.903 3.884-4.574 8.682-8.667 14.5-19.733 7.287-13.854-21.487 19.073-25.7 24.636z'/%3e%3cpath fill='%23fff' d='M1982.115 1810.718c-5.34 6.072 2.023 5.653 11.545-4.078 4.199-4.288 13.24-13.929 19.853-24.56 8.262-13.287-26.78 23.39-31.398 28.638'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M1982.115 1810.718c-5.34 6.072 2.023 5.653 11.545-4.078 4.199-4.288 13.24-13.929 19.853-24.56 8.262-13.287-26.78 23.39-31.398 28.638z'/%3e%3cpath fill='%23fff' d='M1990.502 1810.897c-5.8 5.822 2.483 6.202 12.76-3.07 4.517-4.087 17.783-18.354 25.136-28.685 9.203-12.921-32.893 26.73-37.896 31.755'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M1990.502 1810.897c-5.8 5.822 2.483 6.202 12.76-3.07 4.517-4.087 17.783-18.354 25.136-28.685 9.203-12.921-32.893 26.73-37.896 31.755z'/%3e%3cpath fill='%23fff' d='M2015.386 1796.918c-5.406 6.004 1.948 5.657 11.582-3.953 4.243-4.252 9.353-7.931 16.092-18.47 8.4-13.201-22.996 17.219-27.674 22.423'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M2015.386 1796.918c-5.406 6.004 1.948 5.657 11.582-3.953 4.243-4.252 9.353-7.931 16.092-18.47 8.4-13.201-22.996 17.219-27.674 22.423z'/%3e%3cpath fill='%23fff' d='M2025.342 1796.16c-5.181 6.209 2.152 5.599 11.42-4.372 4.089-4.395 12.894-14.266 19.217-25.062 7.919-13.478-26.155 24.07-30.637 29.435'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M2025.342 1796.16c-5.181 6.209 2.152 5.599 11.42-4.372 4.089-4.395 12.894-14.266 19.217-25.062 7.919-13.478-26.155 24.07-30.637 29.435z'/%3e%3cpath fill='%23fff' d='M2036.252 1794.2c-4.602 6.645 2.657 5.372 10.978-5.39 3.672-4.758 11.537-15.381 16.871-26.708 6.665-14.144-23.872 26.34-27.849 32.099'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M2036.252 1794.2c-4.602 6.645 2.657 5.372 10.978-5.39 3.672-4.758 11.537-15.381 16.871-26.708 6.665-14.144-23.872 26.34-27.849 32.099z'/%3e%3cpath fill='%23fff' d='M2050.009 1786.652c-4.199 6.913 4.183 4.949 11.875-6.281 3.389-4.949 9.401-15.775 14.049-27.38 5.833-14.529-22.296 27.695-25.924 33.661'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M2050.009 1786.652c-4.199 6.913 4.183 4.949 11.875-6.281 3.389-4.949 9.401-15.775 14.049-27.38 5.833-14.529-22.296 27.695-25.924 33.661z'/%3e%3cpath fill='%23fff' d='M2064.748 1776.816c-3.194 5.878 3.75 4.559 9.67-4.962 2.61-4.2 7.138-13.435 10.497-23.422 4.199-12.49-17.408 23.302-20.167 28.384'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M2064.748 1776.816c-3.194 5.878 3.75 4.559 9.67-4.962 2.61-4.2 7.138-13.435 10.497-23.422 4.199-12.49-17.408 23.302-20.167 28.384z'/%3e%3cpath fill='%23fff' d='M2075.769 1771.929c-2.79 6.162 4.258 7.137 9.52-2.79 2.31-4.377 6.165-14.095 8.758-24.755 3.24-13.331-15.88 22.222-18.278 27.545'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M2075.769 1771.929c-2.79 6.162 4.258 7.137 9.52-2.79 2.31-4.377 6.165-14.095 8.758-24.755 3.24-13.331-15.88 22.222-18.278 27.545z'/%3e%3cpath fill='%23fff' d='M2087.823 1763.097c-2.277 6.281 4.396 3.943 8.833-6.343 1.95-4.543 3.613-9.612 4.183-12.655 2.4-12.956-11.034 13.57-13.015 18.998'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M2087.823 1763.097c-2.277 6.281 4.396 3.943 8.833-6.343 1.95-4.543 3.613-9.612 4.183-12.655 2.4-12.956-11.034 13.57-13.015 18.998z'/%3e%3cpath fill='%23fff' d='M2098.17 1751.941c.465 9.505 9.972-12.311 10.06-15.414.092-3.329-10.21 12.16-10.06 15.414'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M2098.17 1751.941c.465 9.505 9.972-12.311 10.06-15.414.092-3.329-10.21 12.16-10.06 15.414z'/%3e%3cpath fill='%23fff' d='M2104.573 1746.602c-1.71 6.883 7.497-7.436 7.587-10.54.09-3.33-6.837 7.497-7.587 10.54'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M2104.573 1746.602c-1.71 6.883 7.497-7.436 7.587-10.54.09-3.33-6.837 7.497-7.587 10.54z'/%3e%3cpath fill='%23fff' d='M2281.596 1781.42c8.637.135 28.548 1.11 28.548 2.91 0 1.813-16.763 6.267-35.1 5.742-18.325-.525-27.485-9.177 6.552-8.652'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M2281.596 1781.42c8.637.135 28.548 1.11 28.548 2.91 0 1.813-16.763 6.267-35.1 5.742-18.325-.525-27.485-9.177 6.552-8.652z'/%3e%3cpath fill='%23fff' d='M2259.975 1772.559c8.59.869 28.34 3.508 28.188 5.308-.15 1.799-17.229 4.827-35.447 2.759-18.218-2.085-26.63-11.456 7.26-8.067'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M2259.975 1772.559c8.59.869 28.34 3.508 28.188 5.308-.15 1.799-17.229 4.827-35.447 2.759-18.218-2.085-26.63-11.456 7.26-8.067z'/%3e%3cpath fill='%23fff' d='M2278.448 1791.645c4.257 1.321 34.456 1.906 42.164 3.134 7.706 1.23.27-9.685-21.728-7.587-21.997 2.084-29.598 1.56-20.436 4.453'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M2278.448 1791.645c4.257 1.321 34.456 1.906 42.164 3.134 7.706 1.23.27-9.685-21.728-7.587-21.997 2.084-29.598 1.56-20.436 4.453z'/%3e%3cpath fill='%23fff' d='M2305.317 1795.59c6.463.089 21.367.869 21.383 2.489 0 1.618-12.522 5.667-26.24 5.261-13.72-.388-20.634-8.08 4.857-7.75'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M2305.317 1795.59c6.463.089 21.367.869 21.383 2.489 0 1.618-12.522 5.667-26.24 5.261-13.72-.388-20.634-8.08 4.857-7.75z'/%3e%3cpath fill='%23fff' d='M2226.867 1769.23c3.628 1.229 29.465 1.769 36.06 2.893 6.598 1.125.226-8.906-18.592-6.986-18.818 1.933-25.31 1.454-17.468 4.093'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M2226.867 1769.23c3.628 1.229 29.465 1.769 36.06 2.893 6.598 1.125.226-8.906-18.592-6.986-18.818 1.933-25.31 1.454-17.468 4.093z'/%3e%3cpath fill='%23fff' d='M2212.802 1763.097c3.748 1.14 30.408 1.634 37.2 2.684 6.808 1.048.24-8.293-19.178-6.509-19.403 1.8-26.105 1.35-18.022 3.825'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.366' d='M2212.802 1763.097c3.748 1.14 30.408 1.634 37.2 2.684 6.808 1.048.24-8.293-19.178-6.509-19.403 1.8-26.105 1.35-18.022 3.825z'/%3e%3cpath fill='%23fff' d='M2198.738 1753.545c3.073 1.65 25.835 4.512 31.532 6.327 5.698 1.815 1.17-9.73-15.653-9.28-16.823.464-22.508-.646-15.879 2.953'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.377' d='M2198.738 1753.545c3.073 1.65 25.835 4.512 31.532 6.327 5.698 1.815 1.17-9.73-15.653-9.28-16.823.464-22.508-.646-15.879 2.953z'/%3e%3cpath fill='%23fff' d='M2181.629 1742.69c2.174 1.89 19.687 6.462 23.93 8.681 4.229 2.234 2.31-9.507-11.005-10.36-13.315-.856-17.633-2.37-12.925 1.68'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M2181.629 1742.69c2.174 1.89 19.687 6.462 23.93 8.681 4.229 2.234 2.31-9.507-11.005-10.36-13.315-.856-17.633-2.37-12.925 1.68z'/%3e%3cpath fill='%23fff' d='M2177.91 1734.818c2.189 1.888 19.702 6.462 23.93 8.697 4.229 2.218 2.326-9.523-10.99-10.377-13.331-.84-17.648-2.369-12.94 1.68'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M2177.91 1734.818c2.189 1.888 19.702 6.462 23.93 8.697 4.229 2.218 2.326-9.523-10.99-10.377-13.331-.84-17.648-2.369-12.94 1.68z'/%3e%3cpath fill='%23fff' d='M2179.724 1727.56c2.175 1.889 19.703 6.463 23.932 8.697 4.228 2.219 2.308-9.521-11.006-10.377-13.316-.84-17.633-2.37-12.926 1.68'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M2179.724 1727.56c2.175 1.889 19.703 6.463 23.932 8.697 4.228 2.219 2.308-9.521-11.006-10.377-13.316-.84-17.633-2.37-12.926 1.68z'/%3e%3cpath fill='%23fff' d='M2178.645 1720.858c2.294 1.739 20.047 5.217 24.41 7.183 4.363 1.963 1.725-9.643-11.62-9.658-13.345-.014-17.754-1.275-12.79 2.475'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M2178.645 1720.858c2.294 1.739 20.047 5.217 24.41 7.183 4.363 1.963 1.725-9.643-11.62-9.658-13.345-.014-17.754-1.275-12.79 2.475z'/%3e%3cpath fill='%23fff' d='M2177.774 1712.866c2.296 1.74 20.05 5.217 24.412 7.167 4.363 1.964 1.725-9.642-11.62-9.656-13.346-.015-17.754-1.274-12.792 2.489'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M2177.774 1712.866c2.296 1.74 20.05 5.217 24.412 7.167 4.363 1.964 1.725-9.642-11.62-9.656-13.346-.015-17.754-1.274-12.792 2.489z'/%3e%3cpath fill='%23fff' d='M2173.083 1707.452c2.504 1.41 20.587 2.444 25.16 3.778 4.588 1.35.404-9.776-12.82-7.976-13.225 1.8-17.768 1.155-12.34 4.198'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M2173.083 1707.452c2.504 1.41 20.587 2.444 25.16 3.778 4.588 1.35.404-9.776-12.82-7.976-13.225 1.8-17.768 1.155-12.34 4.198z'/%3e%3cpath fill='%23fff' d='M2167.43 1700.51c-4.709 2.534 15.64.57 19.326 1.574 3.69.99 9.956-6.793-1.784-7.077-8.906-.226-17.543 5.503-17.543 5.503'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.571' d='M2167.43 1700.51c-4.709 2.534 15.64.57 19.326 1.574 3.69.99 9.956-6.793-1.784-7.077-8.906-.226-17.543 5.503-17.543 5.503z'/%3e%3cpath fill='%23fff' d='M2164.626 1697.975c-3.42 3.315 13.18-2.174 16.464-1.844 3.283.33 6.927-8.382-2.94-6.612-7.481 1.351-13.524 8.456-13.524 8.456'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.452' d='M2164.626 1697.975c-3.42 3.315 13.18-2.174 16.464-1.844 3.283.33 6.927-8.382-2.94-6.612-7.481 1.351-13.524 8.456-13.524 8.456z'/%3e%3cpath fill='%23fff' d='M2161.026 1694.633c-.899 4.333 11.937-4.798 15.115-5.144 3.164-.345 4.618-9.565-4.273-5.833-6.748 2.834-10.842 10.977-10.842 10.977'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.424' d='M2161.026 1694.633c-.899 4.333 11.937-4.798 15.115-5.144 3.164-.345 4.618-9.565-4.273-5.833-6.748 2.834-10.842 10.977-10.842 10.977z'/%3e%3cpath fill='%23fff' d='M2058.21 1651.538c-5.321-8.816-2.744-18.309 5.729-21.997 10.616-4.632 14.514.555 21.516 7.527 3.794 3.765 12.326 10.542 5.518 16.51 5.953 1.02 7.752 7.647 3.389 10.555 8.352 7.227-.06 18.414-9.386 18.084-2.864 5.712-9.823 7.243-12.91.794-11.321 3.194-17.588-12.624-13.061-21.006z'/%3e%3cpath fill='none' stroke='%23909294' stroke-width='1.424' d='M2058.21 1651.538c-5.321-8.816-2.744-18.309 5.729-21.997 10.616-4.632 14.514.555 21.516 7.527 3.794 3.765 12.326 10.542 5.518 16.51 5.953 1.02 7.752 7.647 3.389 10.555 8.352 7.227-.06 18.414-9.386 18.084-2.864 5.712-9.823 7.243-12.91.794-11.321 3.194-17.588-12.624-13.061-21.006z'/%3e%3cpath fill='%23f4ac64' d='M2048.553 1666.728c2.596-1.05 4.95-.27 9.657 1.05 4.724 1.304 12.836-.795 12.055-9.177-.794-8.367-7.121-13.614-14.814-10.99-7.707 2.623-18.023 5.502-23.347 5.502-5.308 0-16.043-.525-19.716 7.332-3.658 7.857-2.878 5.758-4.978 6.538-2.085.794-3.404 7.602-1.305 10.481 2.1 2.88 11.516 12.91 19.898 11.815 8.382-1.08 10.48-4.229 15.458-14.169 4.964-9.957 7.092-8.382 7.092-8.382'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.424' d='M2048.553 1666.728c2.596-1.05 4.95-.27 9.657 1.05 4.724 1.304 12.836-.795 12.055-9.177-.794-8.367-7.121-13.614-14.814-10.99-7.707 2.623-18.023 5.502-23.347 5.502-5.308 0-16.043-.525-19.716 7.332-3.658 7.857-2.878 5.758-4.978 6.538-2.085.794-3.404 7.602-1.305 10.481 2.1 2.88 11.516 12.91 19.898 11.815 8.382-1.08 10.48-4.229 15.458-14.169 4.964-9.957 7.092-8.382 7.092-8.382z'/%3e%3cpath fill='%23f0e53c' d='M1991.17 1662.53c-.78 4.453 3.404 13.404 11.786 13.36 11.292-.06 12.58-8.637 12.58-10.992 0-2.368-8.936-2.099-10.496-.524-1.559 1.558-7.572 3.657-13.87-1.844'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.424' d='M1991.17 1662.53c-.78 4.453 3.404 13.404 11.786 13.36 11.292-.06 12.58-8.637 12.58-10.992 0-2.368-8.936-2.099-10.496-.524-1.559 1.558-7.572 3.657-13.87-1.844z'/%3e%3cpath fill='%23f0e53c' d='M1994.575 1657.49c6.627-2.787 20.737-3.853 20.183 1.905-.54 5.758-7.35 4.184-8.397 2.085-1.035-2.085-5.233-3.66-11.786-3.99'/%3e%3cpath fill='none' stroke='%23473125' stroke-width='1.424' d='M1994.575 1657.49c6.627-2.787 20.737-3.853 20.183 1.905-.54 5.758-7.35 4.184-8.397 2.085-1.035-2.085-5.233-3.66-11.786-3.99z'/%3e%3cpath fill='%23473125' d='M2008.205 1675.89c2.354 4.453 9.942 12.174 16.749 11.32 6.808-.84 10.406-1.334 12.28-4.438 2.655 2.549 2.174 6.478.45 7.527-1.725 1.05-3.404 1.98-5.58 3.869-2.173 1.889-6.776.585-8.92-1.514-2.158-2.1-1.364.524-6.597-1.305-5.248-1.844-.796-2.37-6.553-3.42-5.758-1.033-10.825-4.182-6.718-9.94 4.094-5.758 4.889-2.1 4.889-2.1'/%3e%3cpath fill='none' stroke='%23272425' stroke-width='1.424' d='M2008.205 1675.89c2.354 4.453 9.942 12.174 16.749 11.32 6.808-.84 10.406-1.334 12.28-4.438 2.655 2.549 2.174 6.478.45 7.527-1.725 1.05-3.404 1.98-5.58 3.869-2.173 1.889-6.776.585-8.92-1.514-2.158-2.1-1.364.524-6.597-1.305-5.248-1.844-.796-2.37-6.553-3.42-5.758-1.033-10.825-4.182-6.718-9.94 4.094-5.758 4.889-2.1 4.889-2.1z'/%3e%3cpath fill='none' stroke='%23272425' stroke-linecap='round' stroke-width='1.424' d='M2013.528 1674.06c3.059-1.05 7.766 7.333 13.524 1.305'/%3e%3cpath fill='%23272425' d='M2016.316 1673.266a2.618 2.618 0 0 0 2.624 2.624c1.44 0 2.608-1.17 2.608-2.624a2.61 2.61 0 0 0-2.608-2.61 2.615 2.615 0 0 0-2.624 2.61'/%3e%3c/g%3e%3c/svg%3e";
            },
            5779: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9 6'%3e%3cpath fill='%2321468B' d='M0 0h9v6H0z'/%3e%3cpath fill='%23FFF' d='M0 0h9v4H0z'/%3e%3cpath fill='%23AE1C28' d='M0 0h9v2H0z'/%3e%3c/svg%3e";
            },
            6902: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-2100 -1470 4200 2940'%3e%3cdefs%3e%3cpath id='i' fill-rule='evenodd' d='M-31.5 0h33a30 30 0 0 0 30-30v-10a30 30 0 0 0-30-30h-33zm13-13h19a19 19 0 0 0 19-19v-6a19 19 0 0 0-19-19h-19z'/%3e%3cpath id='j' d='M0 0h63v-13H12v-18h40v-12H12v-14h48v-13H0z' transform='translate(-31.5)'/%3e%3cpath id='l' d='M-26.25 0h52.5v-12h-40.5v-16h33v-12h-33v-11H25v-12h-51.25z'/%3e%3cpath id='k' d='M-31.5 0h12v-48l14 48h11l14-48V0h12v-70H14L0-22l-14-48h-17.5z'/%3e%3cpath id='b' fill-rule='evenodd' d='M0 0a31.5 35 0 0 0 0-70A31.5 35 0 0 0 0 0m0-13a18.5 22 0 0 0 0-44 18.5 22 0 0 0 0 44'/%3e%3cpath id='d' fill-rule='evenodd' d='M-31.5 0h13v-26h28a22 22 0 0 0 0-44h-40zm13-39h27a9 9 0 0 0 0-18h-27z'/%3e%3cpath id='n' d='M-15.75-22C-15.75-15-9-11.5 1-11.5s14.74-3.25 14.75-7.75c0-14.25-46.75-5.25-46.5-30.25C-30.5-71-6-70 3-70s26 4 25.75 21.25H13.5c0-7.5-7-10.25-15-10.25-7.75 0-13.25 1.25-13.25 8.5-.25 11.75 46.25 4 46.25 28.75C31.5-3.5 13.5 0 0 0c-11.5 0-31.55-4.5-31.5-22z'/%3e%3cuse xlink:href='%23a' id='o' transform='scale(31.5)'/%3e%3cuse xlink:href='%23a' id='p' transform='scale(26.25)'/%3e%3cuse xlink:href='%23a' id='r' transform='scale(21)'/%3e%3cuse xlink:href='%23a' id='q' transform='scale(15)'/%3e%3cuse xlink:href='%23a' id='s' transform='scale(10.5)'/%3e%3cg id='m'%3e%3cclipPath id='c'%3e%3cpath d='M-31.5 0v-70h63V0zM0-47v12h31.5v-12z'/%3e%3c/clipPath%3e%3cuse xlink:href='%23b' clip-path='url(%23c)'/%3e%3cpath d='M5-35h26.5v10H5z'/%3e%3cpath d='M21.5-35h10V0h-10z'/%3e%3c/g%3e%3cg id='h'%3e%3cuse xlink:href='%23d'/%3e%3cpath d='M28 0c0-10 0-32-15-32H-6c22 0 22 22 22 32'/%3e%3c/g%3e%3cg id='a' fill='%23fff'%3e%3cg id='f'%3e%3cpath id='e' d='M0-1v1h.5' transform='rotate(18 0 -1)'/%3e%3cuse xlink:href='%23e' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23f' transform='rotate(72)'/%3e%3cuse xlink:href='%23f' transform='rotate(-72)'/%3e%3cuse xlink:href='%23f' transform='rotate(144)'/%3e%3cuse xlink:href='%23f' transform='rotate(216)'/%3e%3c/g%3e%3c/defs%3e%3crect width='100%25' height='100%25' x='-50%25' y='-50%25' fill='%23009b3a'/%3e%3cpath fill='%23fedf00' d='M-1743 0 0 1113 1743 0 0-1113z'/%3e%3ccircle r='735' fill='%23002776'/%3e%3cclipPath id='g'%3e%3ccircle r='735'/%3e%3c/clipPath%3e%3cpath fill='%23fff' d='M-2205 1470a1785 1785 0 0 1 3570 0h-105a1680 1680 0 1 0-3360 0z' clip-path='url(%23g)'/%3e%3cg fill='%23009b3a' transform='translate(-420 1470)'%3e%3cuse xlink:href='%23b' y='-1697.5' transform='rotate(-7)'/%3e%3cuse xlink:href='%23h' y='-1697.5' transform='rotate(-4)'/%3e%3cuse xlink:href='%23i' y='-1697.5' transform='rotate(-1)'/%3e%3cuse xlink:href='%23j' y='-1697.5' transform='rotate(2)'/%3e%3cuse xlink:href='%23k' y='-1697.5' transform='rotate(5)'/%3e%3cuse xlink:href='%23l' y='-1697.5' transform='rotate(9.75)'/%3e%3cuse xlink:href='%23d' y='-1697.5' transform='rotate(14.5)'/%3e%3cuse xlink:href='%23h' y='-1697.5' transform='rotate(17.5)'/%3e%3cuse xlink:href='%23b' y='-1697.5' transform='rotate(20.5)'/%3e%3cuse xlink:href='%23m' y='-1697.5' transform='rotate(23.5)'/%3e%3cuse xlink:href='%23h' y='-1697.5' transform='rotate(26.5)'/%3e%3cuse xlink:href='%23j' y='-1697.5' transform='rotate(29.5)'/%3e%3cuse xlink:href='%23n' y='-1697.5' transform='rotate(32.5)'/%3e%3cuse xlink:href='%23n' y='-1697.5' transform='rotate(35.5)'/%3e%3cuse xlink:href='%23b' y='-1697.5' transform='rotate(38.5)'/%3e%3c/g%3e%3cuse xlink:href='%23o' x='-600' y='-132'/%3e%3cuse xlink:href='%23o' x='-535' y='177'/%3e%3cuse xlink:href='%23p' x='-625' y='243'/%3e%3cuse xlink:href='%23q' x='-463' y='132'/%3e%3cuse xlink:href='%23p' x='-382' y='250'/%3e%3cuse xlink:href='%23r' x='-404' y='323'/%3e%3cuse xlink:href='%23o' x='228' y='-228'/%3e%3cuse xlink:href='%23o' x='515' y='258'/%3e%3cuse xlink:href='%23r' x='617' y='265'/%3e%3cuse xlink:href='%23p' x='545' y='323'/%3e%3cuse xlink:href='%23p' x='368' y='477'/%3e%3cuse xlink:href='%23r' x='367' y='551'/%3e%3cuse xlink:href='%23r' x='441' y='419'/%3e%3cuse xlink:href='%23p' x='500' y='382'/%3e%3cuse xlink:href='%23r' x='365' y='405'/%3e%3cuse xlink:href='%23p' x='-280' y='30'/%3e%3cuse xlink:href='%23r' x='200' y='-37'/%3e%3cuse xlink:href='%23o' y='330'/%3e%3cuse xlink:href='%23p' x='85' y='184'/%3e%3cuse xlink:href='%23p' y='118'/%3e%3cuse xlink:href='%23r' x='-74' y='184'/%3e%3cuse xlink:href='%23q' x='-37' y='235'/%3e%3cuse xlink:href='%23p' x='220' y='495'/%3e%3cuse xlink:href='%23r' x='283' y='430'/%3e%3cuse xlink:href='%23r' x='162' y='412'/%3e%3cuse xlink:href='%23o' x='-295' y='390'/%3e%3cuse xlink:href='%23s' y='575'/%3e%3c/svg%3e";
            },
            2823: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 300'%3e%3cpath fill='%2300abc9' d='M0 0h600v300H0z'/%3e%3cpath fill='%23fae042' d='M0 100h600v100H0z'/%3e%3cpath d='M0 0v300l259.808-150z'/%3e%3c/svg%3e";
            },
            9301: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3cpath fill='%23ffd520' d='M0 0h900v600H0z'/%3e%3cpath fill='%23ff4e12' d='M0 600h900V0z'/%3e%3cg stroke='%23000' stroke-width='.521'%3e%3cg fill='%23fff'%3e%3cpath d='M481.74 187.59c-4.987-1.77-8.208.805-8.046 7.244.159 6.44 3.542 10.142 8.53 7.727l-.484-14.97z'/%3e%3cpath d='M486.12 175.53c-4.154-3.28-8.03-1.874-9.946 4.276-1.916 6.149.096 10.742 5.596 10.058l4.35-14.333z'/%3e%3cpath d='M493.04 163.86c-3.58-3.905-7.63-3.138-10.508 2.625-2.875 5.763-1.625 10.618 3.917 10.825l6.591-13.45zm-4.54 56.73c-6.117 2.254-6.763 10.625-2.896 15.776 3.863 5.151 10.946 6.117 14.808 0l-11.91-15.78z'/%3e%3cpath d='M481.42 202.88c-5.796-1.932-11.017 5.853-11.913 12.878-1.125 8.854-13.683 11.751-6.758 25.113 1.445-8.532 7.083-13.2 11.588-13.522 4.508-.322 11.27-1.288 14.167-6.761l-7.084-17.708zm18.35 34.45c-6.763 1.61-7.73 10.625-2.9 17.064 4.133 5.513 17.063 4.185 16.742-1.288L499.77 237.33zm19.16 54.25c.32-5.795-9.012-8.049-13.521-6.922-4.508 1.127-13.121-.16-15.133-4.99-1.608 3.863.725 8.049 7.246 10.141 4.933 1.585 4.829 5.152 3.379 6.762 3.704.644 14.65.644 18.029-4.99z'/%3e%3cpath d='M513.62 254.56c-6.6-2.897-10.513 1.516-13.038 5.795-3.704 6.278-15.133-1.77-18.996 6.6 5.233-2.253 10.558 2.553 13.038 4.186 7.083 4.668 20.767 3.22 22.7-7.727l-3.704-8.854z'/%3e%3cpath d='M517.48 262.28c-6.6 4.99-9.175 10.946-9.012 14.971.162 4.025 5.795 12.878 11.913 13.361 3.541-7.244 5.312-22.537-2.9-28.332zm-27.36 31.07c0-2.415 3.542-3.38 5.954-2.576 2.417.805 6.117 3.22 4.83 5.796l-10.784-3.22zm-36.39-13.2c-.642-2.897 4.025-7.888 10.304-5.151 6.275 2.736 7.083 8.049 4.504 10.142l-14.808-4.99z'/%3e%3cpath d='M469.02 285.46c-.483-1.61 4.037-4.825 11.754-2.898 7.725 1.932 9.62 6.907 9.338 10.786l-21.093-7.888zm-16.09-5.31c4.025-3.058 2.5-8.855-1.13-10.625-6.6-3.22-4.183-11.59-8.37-13.2-4.183-1.61-8.208-4.508-8.37-7.405-2.092 4.024-.805 7.727 2.095 10.303 2.896 2.576-2.254 13.039 1.446 15.776l14.329 5.151zm-86.29-2.25c-3.38-5.312-11.43-4.346-14.81-.644-3.38 3.703-2.897 9.176.322 11.59L366.64 277.9zm19.32-7.89c-1.288-7.083-9.82-7.888-14.488-6.117-4.668 1.77-7.888 8.854-4.83 14.005l19.319-7.888z'/%3e%3cpath d='M398.84 269.04c3.058-5.956-2.897-14.81-9.659-16.098-5.644-1.074-12.315-1.046-14.488-6.6-1.368 4.83 2.254 7.888 6.44 10.625 4.185 2.737-.806 9.82 5.956 13.844l11.752-1.77z'/%3e%3cpath d='M398.2 269.25c-1.409-4.267 1.449-9.943 7.232-9.545 5.785.398 9.08 4.6 6.53 9.855l-13.763-.31z'/%3e%3cpath d='M411.07 269.57c-.796-4.422 2.83-9.64 8.5-8.435s8.343 5.83 5.084 10.675l-13.584-2.24z'/%3e%3cpath d='M423.86 271.6c-.575-4.457 3.308-9.488 8.912-8.001 5.605 1.487 8.042 6.24 4.542 10.915L423.86 271.6zm-97.14 73.75c-10.786 0-13.42 2.568-14.971 13.683-1.932 13.844 16.903 15.454 14.971-13.683z'/%3e%3cpath d='M331.55 330.86c-16.581-6.278-25.595 19.961-42.015 15.293 5.875 9.337 20.118.017 25.434.966 9.015 1.61 28.493-1.771 16.581-16.26zm-10.79 35.9c-8.21-3.702-17.064 8.854-15.454 14.327 2.044 6.952 20.766 1.288 15.454-14.327zm-38.31 54.09c4.508 1.283 9.98 3.862 9.015 12.554-.966 8.692-17.385 26.4-32.195 27.367-14.81.967-20.123 18.833-32.84 13.842 11.912-2.25 11.912-15.775 21.249-19.958-6.762-2.417-10.303 12.879-18.995 12.879-8.693 0-12.878 13.842-23.503 12.875-10.625-.963-11.743 16.854-33 17.067-16.26.158-36.381 19.154-43.625 10.946 15.776-2.254 22.142-10.996 31.552-20.608 15.132-15.45 32.196-8.53 37.99-22.213-6.922 4.667-14.97 6.92-22.858 6.763-9.902-.205-20.766 15.775-31.874 8.691 6.439-.804 10.625-3.541 17.386-10.625 6.923-7.254 17.083-2.566 25.113-9.979 12.556-11.592 23.342-1.933 35.415-16.421-3.381-1.608-10.625-.483-17.386 3.058-6.762 3.542-15.454-2.416-23.181 1.771.965-9.496 18.995-4.062 30.264-10.625 12.718-7.404 23.262-5.233 33.323-4.346-14.005-.079-19.478-13.363-38.795-9.5-8.425 1.688-15.132-11.588-23.503-4.829.24-4.987 9.015-9.013 18.03-4.183 9.014 4.829 12.648-4.226 30.586 7.083 7.405 4.667 20.122-2.9 28.17 2.092-1.046-3.058-5.634-4.992-11.026-4.588 3.38-6.92 25.193-6.037 34.69.888z'/%3e%3cpath d='M296.78 410.38c-7.083-5.473-16.903 1.128-23.664-1.449 0 4.506 2.254 11.27 9.659 13.844 2.254-1.608 12.395-10.463 14.005-12.395z'/%3e%3cpath d='M307.89 394.77c-11.108-5.634-13.039 8.37-21.732 5.473.322 4.025 3.542 9.015 10.625 10.142l11.108-15.615z'/%3e%3cpath d='M314.49 382.05c-16.42-6.44-18.513 9.337-28.171 6.278 2.254 5.473 16.098 8.37 23.181 6.44l4.99-12.718zm22.53-69.06c-4.347-6.117-13.522-1.127-14.971 6.117-1.449 7.244 2.092 17.386 8.21 15.132l6.76-21.249z'/%3e%3cpath d='M348.13 293.67c-7.566-1.77-16.259-.966-15.293 6.44-2.898 1.287-3.703 10.785 4.185 12.877l11.108-19.318z'/%3e%3cpath d='M353.12 288.68c-7.405-8.693-15.663-8.49-20.283-4.83-8.532 6.762-16.823 2.898-17.064 9.66 5.152-3.945 9.659.804 13.844-.645 4.185-1.448 7.244 6.6 18.835 3.22l4.668-7.405zM335.25 418.6c1.127 2.092 8.049 3.058 11.43-.483 4.48-4.696-.483-17.71-7.566-18.675-7.083-.966-7.727 14.65-3.864 19.158z'/%3e%3cpath d='M327.2 418.92c10.141 3.7 14.488-4.67 9.015-9.981-1.45 1.77-6.762 8.21-9.015 9.981z'/%3e%3cpath d='M289.21 432.76c-1.932 5.796-11.913 6.763-23.181 24.792-11.269 18.029-22.054 10.463-24.791 22.858 13.522-10.946 24.142-3.675 32.195-14.488 12.235-16.421 22.309-14.063 27.045-25.113 6.76-15.775 36.381-15.454 37.991-40.244-9.98-1.932-41.533 24.79-49.259 32.194zm254.03-243.4c12.879 4.185 13.2 20.927 28.008 26.4 14.813 5.473 16.263 18.673 28.333 15.454-11.267-3.059-10.463-16.098-22.213-19.318-13.783-3.776-18.996-24.791-29.946-28.01m54.898 92.884c2.254 5.151 1.933 14.327-6.117 16.742 4.346 2.737 10.783.16 14.325-5.795-5.312 11.751-1.77 22.376 6.6 24.469-4.025-8.21 4.992-12.074 2.096-17.386 5.313 2.254 9.98 9.498 9.817 14.005 6.925-7.727-5.15-18.03-2.896-25.273l-23.825-6.761zm-83.39 82.74c-7.888-6.922-11.254 1.81-15.133-1.208-3.62-2.817-8.45-3.22-10.3-.402 6.762.242 3.458 5.473 16.579 6.761-13.121.886-10.704 15.535-19.479 14.81 9.338 8.854 14.167-7.888 21.733-5.15-2.254.643 3.542 5.955-.483 13.038 6.52-.16 9.175-9.176 9.983-13.844l-2.9-14.005zm-173.7 75.18c-2.898-2.413-11.269-3.542-14.488-1.608-3.22 1.929-2.092 2.412 1.77 2.737 3.865.321 8.853 6.571.484 6.921-3.864.158-2.576 9.496-10.625 10.142 3.3 4.025 12.718 1.367 16.098-3.058-.644 3.62 4.185 6.92 2.254 11.267 5.956.646 2.495-12.071 11.913-11.43-3.864.484-2.254 9.176 4.507 6.922-4.025 1.933-1.932 6.6 2.575 5.475-2.897.966-3.863 4.666.161 6.762 3.864-5.312-.483-24.308-14.649-34.129zm350.62-177.62c12.321 0 22.308-9.99 22.308-22.312 0-12.32-9.988-22.31-22.308-22.31-12.325 0-22.313 9.99-22.313 22.31 0 12.322 9.988 22.312 22.313 22.312z'/%3e%3cpath d='M579.3 284.02c6.763-6.44 17.067-9.659 24.146-4.83 7.083 4.83 30.588 10.625 42.179 2.576 11.588-8.049 17.063-12.235 22.213-11.269 3.867 5.796 8.533 8.532 14.329 9.015 1.77 1.932 8.05 3.542 11.592 3.058 5.15 1.288 11.429-.321 16.417-5.795 7.73 1.127 14.971-4.668 17.708-13.36 8.208-.966 8.692-10.143 3.542-16.26-4.83-.965-1.125-17.225-18.675-14.005 7.408 4.508 1.77 13.522 7.891 17.708-4.187 0-9.579 1.771-10.867 8.05 1.609-4.347-.241-7.245-1.37-8.21.162-3.703-8.046-12.798-15.775-9.498 5.554 1.207 2.416 10.142 6.441 13.522-2.9.161-5.958 1.61-7.729 4.185-2.092-3.702-9.496-7.566-14.004-7.888 0-1.288-.242-3.863-.804-5.15-2.013-3.864-3.704-8.452-2.9-14.328-3.863 4.185-7.083 9.98-9.013 14.166-6.116-4.185-21.25 1.932-28.333 3.541-7.083 1.61-30.908-2.253-36.383-8.049-5.47-5.795-16.096-9.336-26.075-12.234-13.725-3.983-13.846-18.995-28.979-29.298-.32 18.674 28.013 77.914 34.45 84.353zm-157.76 142.3c11.913 0 21.571-9.658 21.571-21.571s-9.658-21.57-21.571-21.57-21.571 9.658-21.571 21.57c0 11.913 9.658 21.571 21.571 21.571z'/%3e%3cpath d='M370.02 409.74c4.346 5.635 11.751 5.314 14.81 4.83 2.576 6.759 10.785 6.6 14.327 10.3 3.542 3.705 15.613 3.384 19.155 1.288-3.217-.32-7.403-2.25-11.428-5.633-4.858-4.08-2.576-12.234-6.44-15.131 2.898-3.22 3.381-8.532 2.737-10.625 3.06-1.771 5.313-4.669 5.635-6.118 5.313-.322 9.98-3.058 11.913-5.15 2.737 2.575 9.658-.806 13.363 3.54.804-10.625-9.338-16.259-16.1-12.717-2.738-1.448-9.98-.482-11.268 1.45-2.254-.967-8.532 2.253-11.43 4.346 3.22-1.77 3.702-7.083 2.414-9.015 2.737-1.127 5.796-4.83 6.117-7.566 3.864.644 9.658-1.932 12.233-1.288-4.183-5.473-11.105-7.405-18.189-6.922-7.325.403-10.463 5.554-11.429 11.108-4.346 2.576-5.795 11.268-4.185 14.327-2.496-.08-4.83 2.335-5.795 3.703-3.38-1.45-8.21-2.495-11.671-2.495m1.531-8.772c-1.449-4.185.47-7.953 1.449-11.268 2.495-8.45.966-10.625-6.6-9.498-.644 4.025 3.22 17.225 5.151 20.766z'/%3e%3cpath d='M360.77 352.91c1.932 1.932 8.774 2.817 9.498-3.3.832-7.022-2.012-9.74-8.13-7.003-.482 1.61-1.046 8.21-1.368 10.303z'/%3e%3cpath d='M362.22 342.37c2.576 1.046 8.13 3.139 11.188-2.817 2.566-4.996-.805-8.854-6.117-8.533-1.288 1.45-3.863 6.6-5.071 11.35z'/%3e%3cpath d='M366.97 330.54c.644 1.932 7.244 8.37 12.073 3.703 4.83-4.669 4.83-11.59-2.415-14.166-1.932.321-7.727 7.082-9.658 10.463z'/%3e%3cpath d='M376.62 320.08c1.449 4.024 5.956 10.946 14.327 7.727 8.371-3.22 4.83-13.683.966-15.776-2.254.16-11.43 4.346-15.293 8.049z'/%3e%3cpath d='M391.92 312.03c-.644 3.542 0 13.2 11.429 13.039 11.428-.16 8.211-13.522 5.313-15.454-4.669 0-12.556.16-16.742 2.415z'/%3e%3cpath d='M409.14 310.09c-1.288 2.737-4.19 20.75 18.191 15.776 2.896-.644 10.463-17.225-18.191-15.776z'/%3e%3cpath d='M421.37 311.7c-2.25 2.253 3.542 20.444 18.675 17.385 15.133-3.059 2.417-20.283-18.675-17.385z'/%3e%3cpath d='M434.25 314.44c-2.413 4.99 1.212 19.8 19.883 19.8 16.921 0-.887-19.478-19.883-19.8z'/%3e%3cpath d='M448.9 318.79c-1.212 2.766-2.696 18.468 19.317 19.8 15.938.966 12.075-21.571-19.317-19.8z'/%3e%3cpath d='M472.57 325.39c-2.733 4.83-5.633 16.903 18.513 17.869 15.471.62 5.958-17.547-18.513-17.869z'/%3e%3cpath d='M492.69 329.09c-3.542 4.83-.933 14.303 8.046 16.098 11.27 2.254 12.879-8.37 5.154-13.522-7.73-5.151-13.2-2.576-13.2-2.576z'/%3e%3cpath d='M503.64 331.34c-2.575 4.508-.98 15.454 16.096 15.454 3.542 0 17.067-13.844-16.096-15.454zM371.48 541.27c13.83 0 25.042-11.213 25.042-25.042 0-13.833-11.212-25.046-25.042-25.046-13.831 0-25.043 11.213-25.043 25.046 0 13.829 11.212 25.042 25.043 25.042z'/%3e%3cpath d='M555.15 177.13c-1.933 1.932-5.954 7.727-6.763 9.98-8.37 25.113 13.975 43.871 27.046 70.83 10.304 21.25 9.017 54.733-7.083 75.982-5.508 7.269-3.862 9.337-10.946 16.742-2.717 2.841-5.796 6.44-4.829 16.742 4.508-1.61 10.946 2.576 12.233 6.118 3.22-1.61 7.73-.966 9.337.965 5.471-2.575 9.98-1.288 14.808 3.864 4.188-.644 8.696 0 12.88 4.507 2.254-4.507 6.762-6.117 9.979-5.151-.321-5.795 5.475-9.98 10.625-7.727-1.609-7.727 5.475-13.523 12.238-11.269 5.791-4.507 17.383-4.829 23.179 1.932-10.304-2.897-9.98 8.05-18.675 7.083 2.254 6.44-3.542 10.142-9.334 12.234 3.7-1.77 7.725-3.863 9.013-1.61 3.22-2.816 9.658-1.77 11.27-.321 4.263-1.368 8.372-.322 10.3 4.829 5.797 3.542 9.66 12.556 5.476 19.318-1.288-7.083-6.117-6.761-8.05-9.659-4.509 1.61-9.017 1.61-10.304-1.288-2.575 2.576-11.267 4.83-15.13.966-1.45 5.795-6.44 10.625-12.237 10.625 1.612 4.507-2.896 12.236-6.438 16.098 5.475 2.896 3.863 9.337 2.575 13.2 8.371 1.287 1.288 8.692 15.775 13.521-7.079 2.254-20.925 0-22.858-8.692-7.083-.32-11.913-7.404-11.588-14.813-5.475-5.15-6.279-12.554 1.288-17.705-6.442 1.932-9.984-8.37-19.321-4.185-4.642 2.082-16.9-1.449-16.738-5.796-1.934 3.22-13.683 1.933-15.296-3.54-3.863 2.092-12.88-1.45-12.717-6.762-4.992 2.254-11.75-1.77-11.43-6.922-4.666-.644-5.15-4.83-4.828-8.37-4.188-1.933-3.059-5.957-1.45-10.786-2.896-3.22-1.609-7.727.645-11.913-3.22-3.22-2.575-7.083-1.612-11.59-15.454-1.288-34.813-5.015-79.2-18.673-66.967-20.605-84.997 27.688-70.187 57.952 17.087 34.92-1.932 42.5 3.864 68.58 6.117 1.287 9.336 6.437 9.015 11.912 3.62.158 6.196 3.538 4.909 9.98 3.058-.563 7.003.32 9.578 2.895 2.254-4.183 9.66-5.15 13.523-.32 8.37-.647 12.556 6.116 12.235 14.487 4.505 8.05 2.896 17.871-1.933 24.146.483-3.379 0-8.208-.158-11.104-.3-5.329-7.73-6.441-6.924-10.788-3.864.321-7.567-1.77-8.854-4.666-2.254 1.929-5.474 2.575-8.21 1.608 4.346 1.933 7.727 9.658 6.439 14.808 2.254 3.867 1.77 10.95-.966 14.008-1.288 6.275-6.117 8.53-12.395 5.792 3.542-2.25 4.83-6.275 4.668-9.659-2.253-1.929-3.38-5.633-3.541-7.887-6.278.966-14.971-4.346-16.574-6.446-13.831 0-25.043 11.213-25.043 25.046-.644-5.154-7.16-10.229-6.355-14.575-3.863-11.913 1.61-23.021 17.386-25.271-1.931-4.508 4.83-9.18 2.254-14.329-3.29-6.58-9.336-15.133-18.35-25.113 5.473-9.338 3.863-21.892.643-29.62-4.623-11.096-9.015-8.37-25.435 9.658-26.76 29.383-62.46 21.25-94.012 40.567-8.384 5.133-16.741 7.083-7.727-1.93 9.015-9.016 32.84-18.028 48.293-25.757 28.94-14.471 53.445-38.635 63.104-85.64 22.697-110.46 106.24-74.05 159.04-53.445 49.571 19.346 40.567-24.47 15.454-50.87-30.183-31.731-24.146-56.663-9.979-76.625 25.433-3.542 74.213 5.312 64.392 13.845z'/%3e%3cpath d='M644.82 448.48c15.217 0 27.554-12.333 27.554-27.55 0-15.218-12.338-27.554-27.554-27.554-15.217 0-27.554 12.336-27.554 27.554 0 15.217 12.338 27.55 27.554 27.55z'/%3e%3c/g%3e%3cg fill='none'%3e%3cpath d='M539.7 178.41c-6.117 27.045-.967 39.279 8.05 51.191 18.629 24.621 33.483 80.811 12.233 117.51'/%3e%3cg stroke-linecap='round'%3e%3cpath d='M571.89 315.41c2.575-.966 7.404-4.024 8.533-9.337m-6.603-2.413c.804-4.668 8.046-6.68 8.208-11.67m-8.048-6.53c-.483-4.83 7.246-9.176 6.117-14.005M569.8 268.08c-.646-2.737 6.438-7.888 4.508-12.234m-9.818-4.666c-1.45-3.059 3.38-6.6 1.288-9.82m-9.018-3.71c-.483-2.092 2.496-6.68.887-9.416m-8.617-6.514c.642-.805 3.22-2.737 2.17-5.151m-7.48-6.519c1.046-.564 4.183-1.53 3.783-3.863'/%3e%3cpath stroke-linejoin='round' d='M382.58 513.57c-6.44-2.254-14.488.967-16.098 6.442M371.31 525c.805-5.47 9.176-7.888 11.751-5.313-5.312-2.895-7.888 7.405-3.22 7.73M423.15 397.67c-3.862 1.932-4.987 9.015 0 14.329m5.79-12.719c-2.733 2.254-2.575 9.015 1.45 10.625-3.38-2.415 0-6.6 2.417-6.761 2.412-.161 4.02 2.736 1.125 5.634m221.188 6.432c-9.012-2.413-16.258 8.05-8.05 17.388-.158-9.017 6.28-14.971 14.167-13.363m-3.627 6.235c-2.217 0-3.462 1.733-3.462 3.42 0 1.772 1.529 3.463 4.025 3.463 1.612 0 2.9-1.85 2.9-3.3M689.4 227.83c1.45 5.473 9.017 7.727 14.971 6.44m-.001-3.54c-4.667.161-8.53-4.185-8.208-7.888 0 2.737 6.279 4.025 8.208 2.254'/%3e%3cpath d='M384.83 414.57c-1.288-3.22 3.864-6.44 4.025-9.5.16-3.057 5.795-5.472 11.59.323m-2.735-34.283c-1.127.483-2.093 1.127-3.059 1.449m14.169 16.091c-1.369.081-4.185-.08-5.715-1.127m.085 7.247c-1.127.564-3.623 1.53-5.072 1.852M347.97 492c-.161 2.9 2.737 7.083 4.346 8.37m8.214-15.29c-1.61 2.413-2.575 6.6-1.61 9.496m25.59.164c-2.898-1.933-.966-6.925-1.288-10.142-.322-3.22 3.38-8.37 10.625-4.025m-36.377-4.183c2.898-.483 5.956-.325 7.888.48m28.812-9.66c-1.288 1.77-1.61 3.704-1.77 4.992m15.29-5.312c-2.254 0-4.185 1.608-5.151 3.22m-26.079-85.64c2.576.886 9.256 4.99 9.498 9.257m17.872-30.187c-7.888-.161-10.946-8.21-4.99-8.21M418 374.32c-3.058 1.288-1.608 6.6 2.737 9.176M399.16 424.87c-1.53-1.93.483-7.563 5.473-5.875m6.277 64.635c.32-4.908 6.52-7.808 9.016-2.254M388.05 497.63c-.403-5.392 2.334-7.162 4.748-7.483 2.415-.321 5.877 1.687 7.487 5.229m-60.205 6.284c.322-3.22 3.059-6.6 5.956-6.117M634.67 358.71c-2.096 1.53-3.462 8.37 4.504 9.015m-16.734 2.255c0 .805 1.046 1.932 1.692 2.415m36.298 10.465c-2.092-1.61-7.487 4.91-2.575 9.659M609.24 436.95c-1.208-4.588 3.058-5.796 7.083-4.83m-17.383-27.69c2.413-1.61 4.83-3.38 7.888-4.185m-9.178 21.885c0-3.862 1.93-7.08 3.7-8.046m10.46-36.374c-.32 4.668 1.613 9.176 3.063 11.59m35.257-11.27c-2.337.725-4.43 1.61-5.313 3.542m2.733 9.658c1.13-.966 2.417-2.092 2.98-2.897M708.4 250.69c0 4.507-5.633 6.922-9.333 4.024m21.573-3.864c2.492 1.932 11.104.081 9.092-4.91m-19.562 30.83c-1.77-.322-4.83-2.254-6.117-3.863m23.827-9.497c-2.896.644-4.83 0-6.28-.644m-39.44 16.744c1.608 0 5.47-.644 8.13-2.012m-12.96-26.478c-2.092-.24-3.625.161-4.83.966m37.27 6.914c-.563 2.013-2.013 5.151-3.783 6.52'/%3e%3cpath stroke-linejoin='round' d='M671.86 265.99c4.025-1.77 9.017 11.912 18.675 7.083m.805-14.173c-1.288 1.77-2.092 4.508-2.254 6.922'/%3e%3c/g%3e%3cpath d='M498.81 237.98c1.288-.16 3.542-.644 4.025-2.254M333.16 387.85c4.83 2.737 8.21 7.405 6.117 14.327M554.5 223.17c1.45.966 6.925.966 9.983-.16m3.867 3.38c-.163 2.254.483 10.785-3.862 12.556'/%3e%3cpath d='M566.1 237.82c4.025 1.288 12.075.805 14.65-6.6'/%3e%3cpath d='M575.11 237.49c2.092 3.22 2.733 9.498-3.542 12.878'/%3e%3cpath d='M576.72 242.81c4.667 1.61 15.454 1.77 14.325-7.405'/%3e%3cpath d='M587.35 242.81c3.22 4.507 17.388 9.82 15.133.483M574.31 255.84c5.47 1.288 13.2-2.415 9.98-12.073'/%3e%3cpath d='M599.74 248.6c.804 3.703 18.833 7.566 16.421-.805'/%3e%3cpath d='M612.78 252.63c3.383 7.727 21.25 7.083 15.617-3.22'/%3e%3cpath d='M625.5 257.45c3.542 4.347 19.321 1.77 13.042-8.693'/%3e%3cpath d='M638.37 257.29c9.82 7.405 21.25-3.22 8.854-10.947'/%3e%3cpath d='M652.86 254.88c8.696 6.922 19.321-5.635 11.754-9.176m-80.494 6.276c2.737.805 8.533.483 9.82-4.507'/%3e%3cpath d='M591.77 250.85c-.32 7.325 11.996 10.142 15.133 1.69'/%3e%3cpath d='M602.8 257.13c2.254 4.83 13.038 6.76 14.808-.161'/%3e%3cpath d='M615.84 260.19c1.77 4.83 11.108 4.347 13.683-.644'/%3e%3cpath d='M626.14 262.77c2.896 6.278 14.808 6.278 17.546-2.898'/%3e%3cpath d='M641.6 263.89c4.667 2.898 14.65 1.77 13.842-7.244'/%3e%3cpath d='M653.51 263.09c6.92 5.635 16.742.161 11.913-9.337'/%3e%3cpath d='M664.94 270.49c3.704-.644 5.633-8.049 1.77-9.98m-87.57 11.27c7.725-4.185 9.175-11.268 3.862-18.19'/%3e%3cpath d='M585.74 264.7c4.83 2.897 14.004-.16 15.613-7.244'/%3e%3cpath d='M592.34 265.5c2.733 3.541 3.217 7.888-.325 11.912'/%3e%3cpath d='M594.59 270.01c8.53-5.312 19.154 4.508 11.267 10.464'/%3e%3cpath d='M604.41 269.53c1.933-.483 5.313-4.024 5.633-8.049m-1.773 11.749c3.542-3.703 27.692 3.864 12.396 11.59'/%3e%3cpath d='M619.54 263.09c4.667 1.77 7.083 8.371 0 10.625m6.12 5.475c5.15-5.312 21.25-1.932 15.454 4.83'/%3e%3cpath d='M637.25 277.09c2.896-9.82 20.121-3.703 14.488.322M633.71 267.27c.483 1.932.642 6.761-2.575 9.337'/%3e%3cpath d='M648.2 265.34c.642 1.61.483 4.668-.967 6.6m11.907-6.44c.967 1.77 2.575 5.151-.967 7.888M521.35 191.45c.158 9.175 3.38 15.293 15.775 9.498'/%3e%3cpath d='M525.21 202.4c-6.117 8.21.804 17.064 12.879 8.21'/%3e%3cpath d='M506.37 206.42c8.37 9.015 23.342 2.415 13.683-11.269M530.2 214.15c-1.613 8.854 5.633 10.625 11.588 6.6m-42.818-12.88c1.525 8.901 10.625 15.937 19.479 10.464'/%3e%3cpath d='M509.92 220.11c0 12.718 17.546 14.166 21.571.966'/%3e%3cpath d='M525.21 229.12c5.633 11.59 17.867 6.922 21.892-.16m-34.292-18.35c2.254 5.634 6.763 11.913 17.225 7.244m-49.415-9.984c1.45 4.668 9.82 10.303 19.479 3.863'/%3e%3cpath d='M486.57 213.83c-5.154 7.566 5.15 14.649 17.546 3.38'/%3e%3cpath d='M492.69 223.17c2.092 10.625 6.275 19.157 21.408 5.473'/%3e%3cpath d='M506.53 234.11c5.475 6.76 13.846 10.946 21.733-.483m5.797 2.413c-.483 8.049 1.125 12.073 7.404 11.751 4.95-.253 9.659-4.185 12.396-8.37'/%3e%3cpath d='M540.34 247.8c-.163 9.176 7.08 16.42 20.604 7.083'/%3e%3cpath d='M545.97 258.58c-2.575 6.922 5.15 18.19 20.283 12.395M513.94 240.23c-.963 8.854 7.246 14.81 20.446 3.38'/%3e%3cpath d='M520.38 250.05c.483 7.244 8.692 15.937 20.767 3.38'/%3e%3cpath d='M526.17 259.23c-.967 12.395 10.463 15.937 20.121 6.44m-37.341-15.62c2.575.161 4.667-2.092 5.954-3.703m-.484 12.713c2.254.483 6.12-1.61 7.408-4.185'/%3e%3cpath d='M520.06 273.71c2.575 2.737 11.267.805 12.392-2.897'/%3e%3cpath d='M529.72 273.55c4.83 11.268 17.704 10.785 23.017-1.932'/%3e%3cpath d='M550.32 276.13c2.413 6.6 8.533 10.785 18.513 8.532'/%3e%3cpath d='M555.15 282.89c-5.633 9.176 1.77 19.961 14.325 9.337'/%3e%3cpath d='M558.21 296.57c-.642 5.795 4.67 12.395 11.913 13.2m-35.743-30.1c-1.933 13.039 7.404 19.318 19.158 12.395'/%3e%3cpath d='M520.7 285.95c3.058 2.415 8.533 2.737 13.683.805m6.277 7.565c-2.9 10.947 8.37 18.835 18.029 6.6'/%3e%3cpath d='M525.05 287.72c.163 5.634 5.638 11.751 15.133 9.98m26.557 11.27c-6.442 4.346-7.73 12.073 1.288 17.063'/%3e%3cpath d='M550.96 306.71c.325 6.6 3.383 10.303 10.625 10.946'/%3e%3cpath d='M541.47 303.33c-9.658 8.854-.163 19.157 11.267 10.464'/%3e%3cpath d='M548.23 316.53c-3.22 10.142 8.854 16.259 15.292 5.956M528.27 294.96c-3.542 9.98.967 16.581 9.175 15.937'/%3e%3cpath d='M515.55 293.03c.483 5.956 5.633 8.049 11.429 6.761'/%3e%3cpath d='M519.25 299.31c-4.346 8.37 2.254 12.878 10.95 9.659m26.4 18.671c-1.45 5.312-.646 9.176 7.242 10.947'/%3e%3cpath d='M557.08 335.21c-9.5 4.347-10.304 13.523-2.9 19.478'/%3e%3cpath d='M549.43 324.99c-4.987 4.508-4.025 12.314 1.45 15.373m-43.7-44.753c-5.475 5.393-.242 20.283 11.829 12.155'/%3e%3cpath d='M538.57 314.44c-7.408 6.117-4.025 17.225 8.208 14.166'/%3e%3cpath d='M526.33 309.77c-3.862 10.947-.158 14.81 8.533 14.971M499.13 295.12c-6.6 4.99-4.83 12.073-1.93 15.293 2.897 3.22 8.368 1.77 10.139-2.415'/%3e%3cpath d='M485.28 290.78c-7.404 9.498 0 20.766 10.467 17.386m29.143 10.784c-7.567 2.737-13.338 9.607-8.696 15.615 2.738 3.542 14.65 4.025 18.03-9.659'/%3e%3cpath d='M511.2 310.09c-4.346 6.278-2.9 12.235 5.15 15.293'/%3e%3cpath d='M510.72 321.85c-4.67 2.576-7.73 5.635-6.6 11.269'/%3e%3cpath d='M500.26 312.03c-1.77 7.566.32 12.235 4.987 14.488'/%3e%3cpath d='M500.1 321.04c-7.246-.483-10.946 2.575-8.533 9.659'/%3e%3cpath d='M492.21 322.81c-7.083-2.576-8.213-8.693-5.154-15.132'/%3e%3cpath d='M486.09 317.18c-7.73.322-11.108 4.185-11.108 9.498m.638-39.608c-5.633 2.415-7.404 9.98-5.313 14.166 2.096 4.185 8.696 4.508 12.721 1.77'/%3e%3cpath d='M459.85 281.12c-5.15 5.795.804 17.064 9.983 14.327'/%3e%3cpath d='M446.65 276.61c-4.83 6.76.483 18.03 12.879 14.81m.641 31.39c-1.288-8.05 7.083-13.361 17.388-2.898'/%3e%3cpath d='M472.57 303.66c-3.058 2.737-4.504 7.083-4.025 10.625M433.45 272.75c-5.313 9.015 1.13 17.225 12.558 14.005m17.222 8.365c-7.567 7.566-4.992 15.132.642 19.478'/%3e%3cpath d='M458.4 303.98c-11.429.16-12.071 13.361-2.733 17.547'/%3e%3cpath d='M449.71 290.78c-4.667 3.22-6.117 12.073 1.933 15.615m-2.253 4.185c-4.83-2.254-10.625.483-10.142 6.117'/%3e%3cpath d='M442.14 310.74c-4.346-10.303-17.063-8.532-15.933 2.093'/%3e%3cpath d='M445.68 298.02c-2.733.483-8.208 2.092-10.3 6.278'/%3e%3cpath d='M436.19 286.43c-5.15 5.795-1.13 12.717 3.058 14.166M420.9 270.17c-.967 6.922 1.77 10.303 10.463 9.659'/%3e%3cpath d='M423.95 279.03c-3.383 8.37 1.125 12.073 9.817 11.59'/%3e%3cpath d='M425.88 289.33c-5.15 6.117-1.608 12.718 3.38 15.454'/%3e%3cpath d='M423.47 297.06c-9.175-1.127-10.625 9.498-7.567 14.488m.157-42.178c-5.632 2.415-8.852 9.498-5.793 13.844 3.06 4.346 9.176 2.897 12.556.644'/%3e%3cpath d='M412.2 285.14c-4.668 7.083-.483 12.395 4.508 14.488M394.17 268.56c-3.702 3.863-1.449 11.752 7.566 11.913 7.258.13 10.946-6.761 8.693-11.59'/%3e%3cpath d='M400.45 280.47c-2.897 6.44-1.127 13.361 9.82 12.234m4.67 10.146c-6.76-3.058-15.776 0-11.912 8.05'/%3e%3cpath d='M402.06 291.42c-2.737 3.863-1.77 9.337 1.288 12.717'/%3e%3cpath d='M401.58 301.72c-4.508.805-8.854 3.22-6.117 10.303'/%3e%3cpath d='M394.81 306.23c-5.795-1.77-13.2 2.415-8.693 8.37'/%3e%3cpath d='M385.16 308.97c-4.99-.805-10.946 4.507-6.117 9.82'/%3e%3cpath d='M377.11 314.44c-4.508 1.127-9.82 6.278-5.152 10.303m27.852-35.573c-6.44 2.897-7.083 10.142-4.025 15.454'/%3e%3cpath d='M393.04 275.81c-9.659 3.703-9.498 16.581 1.127 20.605'/%3e%3cpath d='M389.66 293.51c-5.795 3.38-6.922 9.82-3.058 14.005m-7.082-36.535c-3.864 1.288-3.542 13.2 6.761 12.878'/%3e%3cpath d='M368.9 275c-7.727 5.151 1.61 18.19 14.166 8.854'/%3e%3cpath d='M376.14 287.07c-1.127 5.313.322 11.108 8.854 11.752'/%3e%3cpath d='M376.62 294.16c-6.117 2.253-7.244 14.81 3.863 15.776M357.15 282.73c-7.888 7.244 6.44 13.522 11.752 3.059'/%3e%3cpath d='M346.2 294.8c-3.864 4.668 9.658 16.903 15.615-3.542m1.445-.318c.322 4.83 3.22 7.727 9.175 8.049m-.155 4.671c-9.498 1.449-12.556 13.361-1.932 15.937'/%3e%3cpath d='M354.73 302.05c-.322 4.507 4.346 8.21 9.659 7.405m4.831 9.815c-8.693 1.932-9.82 13.2-2.092 12.556'/%3e%3cpath d='M363.1 342.29c-7.245-2.173-7.405-10.786-.966-14.005'/%3e%3cpath d='M357.15 334.72c-6.117 3.703-3.702 12.556-.483 13.844 3.22 1.288 5.795-.322 6.118-3.058'/%3e%3cpath d='M362.3 357.9c.644 4.185-14.891 2.576-6.922-10.463'/%3e%3cpath d='M355.29 358.63c-5.231 8.21 3.3 14.89 8.693 7.888'/%3e%3cpath d='M356.02 368.53c-2.093 6.6 5.875 11.35 11.026 6.198M338.63 306.71c-2.898 5.956 11.59 8.21 12.556-4.025'/%3e%3cpath d='M334.61 315.57c-2.897 11.59 18.995 9.176 13.361-5.795'/%3e%3cpath d='M348.45 317.5c3.058 1.77 12.235 1.932 14.488-7.888'/%3e%3cpath d='M356.34 317.82c.644 3.058 3.38 6.76 5.956 7.888m-16.416-4.828c-.966 6.278 5.312 11.43 12.556 10.947'/%3e%3cpath d='M347 327c-3.541 4.83-4.668 14.166 6.44 14.81'/%3e%3cpath d='M330.1 328.61c-1.77 4.99 8.693 10.142 14.81 1.932'/%3e%3cpath d='M326.88 341.32c-.886 3.784 8.532 8.854 13.844-7.244'/%3e%3cpath d='M336.54 342.29c2.254 4.024 9.82 7.244 14.488-.644'/%3e%3cpath d='M343.46 346.48c-1.932 5.634 3.38 10.946 9.82 9.337'/%3e%3cpath d='M331.39 345.19c-1.288 8.049 8.049 12.717 13.844 8.532'/%3e%3cpath d='M325.27 348.73c-2.736 10.303 10.464 14.166 15.454 6.439'/%3e%3cpath d='M337.35 358.23c.483 5.795 9.498 10.785 16.581 5.956m-32.681-1.126c-.644 2.575 10.142 5.151 11.751-3.864'/%3e%3cpath d='M327.53 365.31c2.575 6.6 11.268 8.21 16.259.161'/%3e%3cpath d='M340.89 368.69c1.127 6.117 9.015 9.498 15.937 5.312m2.893 2.418c-1.77 8.21 6.761 14.81 12.073 10.303'/%3e%3cpath d='M346.04 374.97c-2.575 9.015 8.693 14.166 14.971 9.176'/%3e%3cpath d='M332.52 370.46c-.644 8.37 5.956 13.361 13.522 9.658'/%3e%3cpath d='M318.19 371.27c-2.254 5.473 9.659 9.98 15.293 5.313'/%3e%3cpath d='M310.78 386.24c3.059 3.541 13.683 0 14.649-7.888'/%3e%3cpath d='M322.54 384.14c3.863 4.508 13.039 6.922 16.742-2.737'/%3e%3cpath d='M336.06 386.4c-.161 6.922 12.235 11.913 16.259-.805m14.561 2.495c-1.127 3.38 1.53 8.773 7.083 9.417'/%3e%3cpath d='M356.66 386c-.805 3.863 4.83 9.255 10.786 7.083m1.134 1.607c-1.61 4.185-.242 10.221 5.392 10.141'/%3e%3cpath d='M369.14 402.5c-4.185 3.541-2.415 9.82 3.623 10.062'/%3e%3cpath d='M366.97 408.45c-5.956 4.022-3.863 12.877 4.024 12.398M348.94 391.39c0 8.693 10.785 9.98 12.878 1.932'/%3e%3cpath d='M357.63 398.47c-1.61 5.151 2.575 10.142 9.175 8.693m-7.885 53.447c1.45 2.096 7.405-1.446 5.795-4.987s-7.919-1.617-7.244 2.091'/%3e%3cpath d='M363.26 454.17c.805-7.083-7.566-8.208-9.659-2.092'/%3e%3cpath d='M356.66 448.54c2.093-3.542-4.99-8.37-7.888-3.22'/%3e%3cpath d='M351.35 443.22c1.932-5.154-6.117-7.404-6.761-2.737'/%3e%3cpath d='M342.82 433.72c.966-2.575 9.98-.967 6.117 4.346m6.923 6.444c3.542-3.22-2.414-9.82-6.117-7.404m29.937 17.224c-2.818.32-5.716 2.17-3.623 8.13 1.451 4.133 7.647 4.345 8.532 1.85'/%3e%3cpath d='M375.58 457.31c-2.737-1.77-8.693 1.208-5.956 7.004 2.06 4.363 7.244 2.575 8.049.321m-17.473.965c1.367 2.413 8.209 1.37 9.417-1.288'/%3e%3cpath d='M364.87 457.63c1.449-.967 4.104.237 4.668 1.446m-5.148-41.126c-4.668 3.058-1.77 12.396 5.473 9.98'/%3e%3cpath d='M362.94 425.52c-3.703 2.896-.322 11.913 6.6 8.533'/%3e%3cpath d='M364.07 434.05c-2.575 2.575-.08 9.738 6.6 8.37'/%3e%3cpath d='M363.1 437.59c-1.45-.646-5.232-.163-6.843 2.25m2.663-34.85c-3.541 3.38-1.852 10.304 4.748 10.866'/%3e%3cpath d='M357.63 412.07c-5.072 2.496-5.072 12.554 5.07 12.958'/%3e%3cpath d='M357.23 423.42c-2.817 2.254-1.449 10.946 5.795 9.817'/%3e%3cpath d='M359.56 432.92c-1.047 1.046-1.208 3.704-.322 4.83m-2.898-8.13c-2.575.08-5.956 1.933-6.843 4.588'/%3e%3cpath d='M344.83 424.87c.966-2.575 8.935-2.413 9.498 5.154'/%3e%3cpath d='M355.13 421.01c-1.127.242-3.3 1.288-3.863 3.462m.403-27.042c-3.462 3.139-5.151 13.04 5.392 14.97m-12.392 5.47c0-2.658 7.164-4.912 9.659-.967'/%3e%3cpath d='M340.08 403.46c1.046 2.013 6.036 4.75 9.095 2.496M314.16 387.69c-.16 4.668 3.703 8.854 9.015 8.21 5.312-.644 6.44-5.313 4.83-8.371m-4.025 8.531c-3.542 4.346.805 10.464 4.83 8.693'/%3e%3cpath d='M328.01 393c2.093-.805 9.015-1.77 11.108 1.449m-33.488-.159c-1.61 2.415 8.371 4.83 11.751.16'/%3e%3cpath d='M314 396.86c-.323 3.22 1.288 8.693 9.498 6.44'/%3e%3cpath d='M324.79 408.29c1.288-2.737-4.83-7.244-9.498-2.254-4.668 4.99.644 10.625 3.542 8.692M303.38 397.51c-2.415 4.185 6.922 11.833 12.235 4.75'/%3e%3cpath d='M297.18 404.75c-3.38 3.462.805 9.82 5.876 7.888 5.07-1.932 4.588-7.244 3.381-8.612'/%3e%3cpath d='M290.66 411.19c-2.737 2.494-.081 8.37 3.703 8.37 3.782 0 6.117-2.976 5.392-6.76m6.275-2.09c-.483 3.702 4.99 6.277 8.532 2.819m.168-6.769c.483-.805.081-2.174-.723-2.818'/%3e%3cpath d='M284.79 416.18c-3.138 2.496 3.623 9.417 7.888 3.058m16.332-4.428c-2.013 1.93 1.207 7 4.426 5.47'/%3e%3cpath d='M297.99 418.35c.483 3.458 7.244 6.033 11.51.725'/%3e%3cpath d='M301.69 421.81c-1.046 2.175 1.047 5.638 3.623 5.154M365.76 441.7c-2.494 4.908 5.473 10.625 11.269 4.667'/%3e%3cpath d='M371.55 449.02c-1.207 2.654.242 6.358 2.415 7.725'/%3e%3cpath d='M363.99 454.57c.564-2.417 4.024-4.67 7.164-3.542M359.8 448.21c.483-2.17 3.38-4.346 5.554-3.78m183.996-96.67c-11.429.161-6.6 18.513 3.22 14.81'/%3e%3cpath d='M545.65 361.29c-2.254 3.703 2.092 9.579 6.92 6.117'/%3e%3cpath d='M551.29 368.13c-3.383 5.634 8.692 14.246 13.521 5.392'/%3e%3cpath d='M560.95 376.9c.158 5.313 15.613 8.693 13.363-1.932'/%3e%3cpath d='M572.86 380.76c3.7 6.278 17.546 6.922 16.096-2.415'/%3e%3cpath d='M585.9 384.79c2.9 4.185 16.421 6.76 15.938-1.932M531 331.83c1.93 4.99 8.53 6.761 15.775 3.863m-19.955-.323c4.508 2.897-2.092 16.098-9.012 10.785'/%3e%3cpath d='M526.82 343.58c4.992 2.415 11.108.644 12.879-6.44'/%3e%3cpath d='M536.64 342.61c.483 3.703 5.796 6.6 12.717 5.151m-25.117-1.281c6.442 5.473-2.896 16.742-7.083 11.59'/%3e%3cpath d='M526.66 350.66c3.058 2.254 10.946.966 11.75-4.99'/%3e%3cpath d='M534.87 350.66c.646 3.863 3.704 5.312 8.05 5.473'/%3e%3cpath d='M524.89 355.97c3.217 4.508 11.267 5.795 14.808-.16'/%3e%3cpath d='M536.15 359.19c-.32 4.347 4.508 7.888 9.5 6.922m-27.04 2.738c4.183 2.092 8.692-5.795 5.15-11.268'/%3e%3cpath d='M523.44 377.22c4.992.322 5.633-7.244.967-11.43'/%3e%3cpath d='M534.87 384.14c4.188-.966 2.896-10.142-7.246-10.947'/%3e%3cpath d='M547.58 390.91c4.025-1.127.804-11.269-10.3-10.625'/%3e%3cpath d='M562.88 394.45c2.733-4.185-6.28-11.268-13.683-7.566'/%3e%3cpath d='M570.44 400.24c4.992 1.449 8.37-11.751-7.404-9.659'/%3e%3cpath d='M579.62 400.24c4.35-1.127 7.408-9.015-5.308-6.44'/%3e%3cpath d='M589.28 400.89c3.862 1.932 5.633-9.337-6.12-6.278M524.4 365.79c4.83 2.737 12.396-.483 11.75-6.6'/%3e%3cpath d='M534.22 364.51c1.613 2.897.967 8.532-2.092 9.98'/%3e%3cpath d='M534.7 371.27c3.22 1.288 7.567.161 10.142-4.99'/%3e%3cpath d='M540.34 371.27c.963 2.254 1.288 6.761-.808 9.015'/%3e%3cpath d='M541.15 375.13c3.542 1.932 7.725-.644 9.496-4.347'/%3e%3cpath d='M548.39 374c2.575 1.61 4.83 9.176.483 12.235'/%3e%3cpath d='M551.29 382.7c3.058.16 7.567.16 10.463-3.703'/%3e%3cpath d='M559.66 381.09c2.737.805 5.954 5.313 4.83 9.337'/%3e%3cpath d='M564.65 388.97c3.063-.322 8.37-2.415 9.82-6.117'/%3e%3cpath d='M573.02 385.27c2.58 1.449 4.35 4.507 4.025 8.049m-.005-2.579c3.058-.16 5.796-1.77 6.6-5.151m-.8 2.261c2.254.805 4.992 3.38 5.154 6.44'/%3e%3cpath d='M587.67 392.35c2.254-.322 3.862-1.77 5.313-4.025m6.117-.315c2.9 2.898-.963 12.557-6.92 10.786M537.28 192.9c-5.958 3.541-22.863 2.415-14.492-11.59'/%3e%3cpath d='M538.89 183.4c-11.75 4.668-26.242-4.346-11.108-14.166'/%3e%3cpath d='M523.76 166.02c-9.82 0-16.421 15.776-3.217 21.249M485.61 172.62c-2.575 4.99 6.6 10.463 12.879 5.473 4.863-3.866 4.504-14.327 1.608-18.352'/%3e%3cpath d='M480.62 184.53c-3.22 10.624 20.446 11.268 16.742-5.635'/%3e%3cpath d='M479.33 200.31c.804 8.049 22.7 5.473 15.613-10.786m2.577-4.514c1.77 2.415 6.6 6.6 14.808 5.795M501.38 173.58c.725 2.897 5.633 5.151 11.913 2.979M281.73 418.51c-5.553 3.946 2.979 10.142 6.117 3.3'/%3e%3cpath d='M277.38 421.57c-5.553 3.942 2.979 10.138 6.117 3.296'/%3e%3cpath d='M272.79 424.55c-5.555 3.946 2.978 10.142 6.117 3.3'/%3e%3cpath d='M267.96 427.29c-5.313 2.817.885 9.738 6.278 3.62'/%3e%3cpath d='M262.73 429.95c-5.313 2.813.886 9.738 6.278 3.62m20.692-11.92c-.081 4.104 7.727 5.796 10.543-.325'/%3e%3cpath d='M294.61 425.44c-2.415 3.058 2.013 6.842 4.428 5.47'/%3e%3cpath d='M284.22 424.87c-.242 3.462 6.519 5.475 9.82 1.692'/%3e%3cpath d='M287.93 428.5c-2.174 2.817 2.092 6.6 4.83 5.47'/%3e%3cpath d='M279.72 428.01c.24 2.737 4.104 5.875 8.29 4.104'/%3e%3cpath d='M282.21 431.71c-1.61 1.45-.805 4.833 1.449 5.88'/%3e%3cpath d='M273.84 431.47c-.644 2.496 3.623 6.925 7.969 4.025'/%3e%3cpath d='M274.72 434.37c-2.575 2.013-2.254 5.07 1.046 5.47'/%3e%3cpath d='M268.53 434.05c-.322 1.688 1.852 4.425 4.589 4.104m-18.359-4.264c-2.575 1.367 4.025 8.37 8.129 1.85'/%3e%3cpath d='M248.4 436.78c-3.22 1.533 4.75 9.258 8.291 1.37m12.559-1.69c-2.496.563-4.105 4.188-2.013 5.633'/%3e%3cpath d='M261.12 437.75c-.322 1.45 2.737 3.862 5.233 2.98m-7.323-2.33c-2.415 1.53-1.127 5.792 1.69 5.15m-10.3-2.34c-2.254 1.688-.725 5.07 2.415 4.267'/%3e%3cpath d='M254.52 440.97c.081.883 2.093 2.254 3.784 1.692m-15.694-3.142c-2.816 1.208-2.655 8.292 6.843 4.43'/%3e%3cpath d='M236.25 442.34c-3.945 1.933-2.657 7.246 5.956 2.175m.724.405c-1.046.804-2.172 4.346 1.77 2.975'/%3e%3cpath d='M235.69 446.6c-1.61 1.45-.563 4.43 2.98 3.3m-11.27-2.81c-2.897 1.692 3.46 3.946 7.727-.563'/%3e%3cpath d='M229.33 449.18c-1.288 1.288-1.288 5.07 2.092 3.704'/%3e%3cpath d='M221.12 450.71c-1.932 1.45 1.368 3.383 7.405.725'/%3e%3cpath d='M223.53 452.8c-2.254 1.85-2.013 4.183 1.288 3.458'/%3e%3cpath d='M216.85 453.85c-2.495 2.254 1.127 3.783 5.473 1.93'/%3e%3cpath d='M216.93 456.35c-4.267 1.93-2.415 5.47.24 4.104m142.23 8.206c-.99 2.13 2.254 3.862 5.313 3.38 2.937-.463 5.748-2.884 3.54-6.276'/%3e%3cpath d='M368.41 469.95c2.897 2.254 8.049-.32 8.049-3.704'/%3e%3c/g%3e%3cg fill='%23fff'%3e%3cpath d='M545.97 128.83c-12.879-6.44-39.6-18.352-47.167-8.693 6.92-2.897 27.204.161 43.946 15.615l3.22-6.922z'/%3e%3cpath d='M553.78 128.15c-14.892-17.347-23.663-13.464-34.371-19.439-10.058-5.614-26.079-6.761-29.183 2.167 14.696-7.157 28.188 3.849 36.475 5.18 11.383 1.828 17.808 10.629 21.138 14.676l5.942-2.584zm56.1-2.22c-7.73-17.708-24.254-13.083-31.554-20.605-10.621-10.946-37.504-21.088-48.613-13.522 24.467-1.288 34.888 16.865 47.971 23.181 9.338 4.508 19.317 14.166 32.196 10.947z'/%3e%3cpath d='M580.91 124c-13.2-16.42-33.488-30.908-42.821-25.435 12.233.644 16.096 9.176 24.792 14.649 8.692 5.473 4.83 13.361 18.029 10.786zm-62.79 28.98c-13.846-5.151-40.888-7.727-53.446 8.05 20.929 3.54 52.479 1.609 53.446-8.05z'/%3e%3cpath d='M515.55 159.1c-13.846-6.44-24.658 2.555-37.671 1.288-24.788-2.415-42.496-.966-44.75 10.946 14.167-12.717 37.992-2.253 47.65-4.829 9.658-2.576 45.396-.322 56.663 4.507-5.796-7.083-14.808-9.014-21.892-11.912zm43.46-36.87c-3.217-10.625-3.058-21.893 12.879-21.088-4.025-4.99-18.833-7.566-21.25 11.108-17.546-12.878-36.704-15.132-40.242-4.024 9.012-7.727 23.017-2.093 39.758 16.903 1.45-.805 5.313-2.415 8.854-2.898z'/%3e%3cpath d='M534.87 136.88c-9.98-6.439-23.504-16.903.163-21.088-10.142-5.473-24.954-3.059-23.342 15.615-27.046-10.947-46.467-7.252-50.55 3.541-4.509 11.913 12.238 18.513 15.133 10.947-3.059 1.288-13.521-2.253-8.05-9.015 5.475-6.76 33.525-1.685 60.208 12.235 7.404 3.864 32.838 3.22 6.437-12.235z'/%3e%3cpath d='M527.78 154.59c-7.7-15.722-32.679-1.449-37.713-16.678-6.88 22.312 35.521 9.966 37.713 16.678zm158.89 17.06c5.237 2.603 9.767-1.489 1.754-4.698 5.242 2.601 9.813-1.392 1.8-4.603 5.242 2.601 9.813-1.392 1.8-4.602-2.137 2.151-5.196 10.04-5.354 13.903zm2.73-30.26c11.592-12.234-.963-16.42 13.2-28.976 11.592-10.273 2.212-17.12 13.204-25.113 3.542-2.575 11.267-7.727 11.913-12.878 4.667 11.59-14.492 13.2-13.204 31.874.82 11.89-7.217 10.851-10.3 30.908-.646 4.185-3.542 13.522-14.813 4.185z'/%3e%3cpath d='M694.56 146.86c6.438-13.844 13.829-13.578 17.383-18.995 6.763-10.303 21.088 1.77 33.163-7.405-2.092 13.039-18.35 8.37-25.433 16.742-7.083 8.37-12.879 12.235-25.113 9.659z'/%3e%3cpath d='M696.17 151.37c11.271-9.015 19.575-3 27.367-7.727 19.638-11.913 27.529 2.414 45.075-3.22-4.67 11.268-30.588 1.61-41.854 9.981-11.271 8.37-50.871 16.42-30.588.966zm-32.84 64.23c-.163-5.151-4.992-11.752-11.754-12.556-6.758-.805-9.658-7.888-14.808-8.21-5.15-.322-8.533-10.625-15.617-10.464-7.083.161-9.98 9.337 6.6 17.708 16.583 8.371 34.933 18.03 35.579 13.523zm-20.93 4.35c-7.083.322-8.05 10.625-14.808 10.947 9.333 4.99 16.096-2.254 20.925-8.693l-6.117-2.254z'/%3e%3cpath d='M648.2 221.23c-6.117 5.151-7.888 15.937.967 18.995-5.313-7.325 9.337-10.625 4.829-17.386l-5.796-1.61z'/%3e%3cpath d='M654.31 221.56c-4.83 9.337 7.567 10.463 4.346 17.547 7.083-1.61 8.212-14.971 1.77-18.513l-6.116.966z'/%3e%3cpath d='M606.98 201.59c11.592-.644 22.192 5.627 29.3 15.776 4.508 6.439 19.638 9.015 24.792 3.863 5.15-5.15 2.254-16.098-10.625-12.556-3.22-5.473-12.558-3.541-17.063-8.049-4.508-4.507-21.896-17.385-26.404.966z'/%3e%3cpath stroke-linecap='round' d='M650.45 208.68c-3.058.644-4.025 5.956-2.096 8.693m8.696-5.473c.967 1.61.32 3.863-.163 4.99m-31.547-14.81c5.954.322 7.083 4.669 13.521 6.278'/%3e%3cpath d='M621.4 187.43c20.571 5.151 36.892 9.659 47.013 15.454 10.121 5.795 25.792 7.405 39.504 3.542 13.713-3.864 40.154-7.405 38.85 9.659 7.188-8.533-1.958-17.709-20.242-19.319.33-8.37-8.63-15.937-15.071-10.947 5.958-.804 11.1 10.303-.65 14.81 2.283-8.37-6.042-15.937-14.692-12.234 5.55 1.61 11.163 10.917-1.254 14.488-7.838 2.254-19.263-.643-27.75-5.795-8.488-5.151-56.154-23.825-45.708-9.658z'/%3e%3cpath d='M673.31 179.06c-6.438 2.897-2.254 9.659-12.233 13.522-9.983 3.863-16.904 12.717-14.65 20.283 6.763-14.81 18.675-14.166 22.858-19.961 4.188-5.795 10.304-14.327 4.025-13.844z'/%3e%3cpath d='M675.08 180.02c-.32 11.751-9.57 7.47-5.958 23.986 1.129 5.151 3.22 13.522-.321 21.893 10.383-7.566 3.704-23.46 8.37-29.459 2.255-2.897 5.15-7.405 6.28-11.268-2.417 6.76-2.254 19.318 4.346 22.537-5.313-12.557 14.329-22.859.804-37.347-1.93 3.542-8.05 9.82-13.521 9.659zm-32.84-11.75c1.613 2.415 3.22 8.532 1.77 11.913 3.222-1.932 7.893-6.922 9.338-10.303 6.6.966 9.175 9.176 2.9 12.717 3.863 0 10.463 0 14.163-4.346-4.504-4.99-18.508-12.718-28.17-9.981z'/%3e%3cpath d='M542.11 145.18c-1.042-.95-2.8-1.852-5.954-2.5-9.746-1.998-4.713-10.784 3.583-10.706 17.704-19.317 27.646-4.426 49.217-10.543 7.55-2.14 12.733-1.507 16.846.272 9.658-6.44 20.988-4.64 29.2 2.926.913-1.451 2.138-2.559 3.858-3.037 7.563-2.1 13.68 4.348 15.771 12.72 5.896-1.093 12.63 1.825 17.058 5.85 6.134-3.15 10.358-3.29 11.913-.052 5.475-2.575 12.567-4.19 16.108 4.502 3.542 8.693-8.37 6.118-10.304 24.47-1.191 11.32-13.842 15.775-23.825 9.014-15.967-10.817-31.55-12.557-39.279 3.864-7.725 16.42-13.779 25.96-32.517 20.605-6.758-1.932-15.454.644-20.925 8.049-5.475 7.405-13.846.482-23.825 1.287 12.554-1.931 7.746-5.09 18.675-5.795 9.98-.644 7.405-9.98 13.842-11.268-25.113 6.44-24.146-2.898-44.75 3.541 9.013-11.59 23.18-5.151 30.263-11.912-18.675-.322-27.025-12.522-35.417-7.405-13.2 8.05-7.408 30.965-41.854 28.976-16.742-.966-27.367 1.288-37.346 11.27 17.388-36.06 41.038-16.25 52.48-27.689 6.762-6.761 11.912-11.913 15.453-18.352 1.246-2.266 2.934-3.562 5.042-4.063-28.654-9.015-11.325-23.058 16.688-24.023z'/%3e%3cpath stroke-linecap='round' d='M683.59 140.11c.438.905.662 2.08.662 3.533 0 7.082-10.624 7.405-11.266 17.869-.338 5.473-.967 8.531-4.671 7.887-3.7-.644-6.921-6.439-3.38-13.2'/%3e%3cpath d='M547.42 134.63c-2.667-1.874-5.333-2.635-7.725-2.657m66.045-10.323c8.525 3.69 12.683 12.546 25.067 12.98 11.921.418 19.321 17.708 39.279 6.439.542-.305 1.07-.59 1.583-.854'/%3e%3cpath d='M635 124.63c-1.78 2.83-2.183 6.778-1.696 10.244M596.04 161.03c-15.129 0-18.996 7.727-18.996 15.132 0 7.405 7.083 17.064 19.642 17.064 12.554 0 19.317-7.727 19.317-16.098s-7.73-16.098-19.963-16.098z'/%3e%3cpath d='M598.77 192.9c-.32-4.185-7.888-3.542-7.567-6.761.321-3.22 4.188-4.508 4.188-9.015 0-4.507 6.758-4.83 9.012-1.288 2.255 3.541 9.017 10.463 10.467 6.922'/%3e%3cpath d='M604.41 175.84c-3.542 3.541-5.15 10.785-.483 16.42m5.313-10.95c-1.125 2.415-1.446 6.117-.158 8.37'/%3e%3cpath fill='none' d='M669.36 169.48c11.833.966 13.846-12.074 4.992-12.878M654.8 134.31c-4.104-5.231-13.521-7.002-13.683 4.105'/%3e%3cpath d='M639.99 151.05c-4.025-9.98-14.329-11.43-19.804-6.44-4.554 4.154-4.667 14.972 5.154 17.226 3.38-4.024 9.98-9.337 14.65-10.785z'/%3e%3cpath d='M635.56 144.77c-5.796-5.152-14.329 4.588-6.6 13.522M525.31 169.16c3.88-.92 9.55.978 18.246 5.067 5.475 2.576 21.896 8.05 32.196 2.576-10.625 3.864-18.671-12.235-26.721-10.303-8.05 1.932-22.779 4.91-28.975-.966 15.129.966 23.267-11.021 40.563-.644 4.833 2.898 10.95 4.83 16.421 4.508-14.163-17.064-32.838-6.118-34.771-19.961 8.533 9.176 29.379-2.093 40.004 15.132'/%3e%3cpath d='M545.33 152.01c-1.992-2.48-1.092-4.95-3.23-6.905'/%3e%3c/g%3e%3cpath stroke='none' d='M654.8 134.31c-3.542-3.783-11.267-.805-9.096 6.842 1.692-3.541 5.313-6.52 9.096-6.842zm-21.89 20.62c2.438-1.77 4.954-3.223 7.075-3.882-1.158-2.864-2.83-5.026-4.758-6.534-1.842-1.272-7.134 5.844-2.317 10.416z'/%3e%3cg fill='none' stroke-linecap='round'%3e%3cpath d='M623.4 141.87c-5.796-3.863-11.108-3.541-12.879-.322-4.183-.16-7.646 2.898-7.808 9.015'/%3e%3cpath d='M611.65 153.14c-6.92-4.748-16.421-2.978-15.775 7.647m-4.185 6.033c3.38-2.737 8.208-4.668 11.913.161m39.767-10.621c-1.288 1.77-2.254 4.507-.163 8.693-2.575-3.38-9.012-3.38-15.938 5.634m31.391-14.807c-8.37.966-8.208 6.439-1.45 8.854M599.1 135.43c-7.083-1.449-12.233 2.737-2.413 6.278M612.62 130.6c-9.983-2.415-14.008.16-9.5 2.415M583.8 170.69c-.32 3.542 1.608 8.21 7.404 2.898m-5.464 7.722c0 .966-.163 2.092-.808 2.897M562.55 134.14c-6.117-1.77-7.242-7.405-.158-6.922m-1.932 19.962c-6.763-2.254-6.763-8.854-1.13-8.21m13.69 4.83c-7.888-1.932-8.208-7.405-2.25-6.6m3.21-10.14c-4.183-.322-10.625 4.347.163 7.083m11.597 2.257c-9.82-1.449-9.658 2.576-3.867 5.152m11.267-14.492c-7.567-1.449-10.142 3.059-4.992 4.99m-18.828 22.86c-1.854-1.529-3.38-8.854 5.47-6.68m12.88 4.43c-5.954-1.61-11.588 4.185-6.117 7.566m13.997-14.486c-6.275-1.127-11.588.644-8.208 2.897'/%3e%3c/g%3e%3cpath fill='%23fff' d='M654.46 134.31c-3.538.655-6.708 2.734-8.762 6.84'/%3e%3c/g%3e%3c/svg%3e";
            },
            988: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1100 800'%3e%3cpath fill='%23ef2b2d' d='M0 0h1100v800H0z'/%3e%3cpath fill='%23fff' d='M300 0h200v800H300z'/%3e%3cpath fill='%23fff' d='M0 300h1100v200H0z'/%3e%3cpath fill='%23002868' d='M350 0h100v800H350z'/%3e%3cpath fill='%23002868' d='M0 350h1100v100H0z'/%3e%3c/svg%3e";
            },
            4827: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 36 24'%3e%3cpath fill='%2375aadb' d='M0 0h36v24H0z'/%3e%3cpath fill='%23fff' d='M0 9h36v6H0z'/%3e%3cpath d='M0 10h36v4H0z'/%3e%3c/svg%3e";
            },
            6783: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1098 549'%3e%3cpath fill='%23C8313E' d='M0 0h1098v549H0z'/%3e%3cpath fill='%234AA657' d='M0 366h1098v183H0z'/%3e%3cpath fill='%23FFF' d='M0 0h122v549H0z'/%3e%3cg id='b'%3e%3cpath id='a' fill='%23C8313E' fill-rule='evenodd' d='M21.217 0H37.13v9h5.305v9h5.304v9h5.304v9h5.305v9h-5.305v9H47.74v9h-5.304v9H37.13v9h-5.304v9h-5.304v-9h-5.305v-9h-5.304v-9h-5.304v-9H5.304v-9H0v-9h5.304v-9h5.305v-9h5.304V9h5.304zm5.305 18h5.304v9h5.304v9h5.305v9H37.13v9h-5.304v9h-5.304v-9h-5.305v-9h-5.304v-9h5.304v-9h5.305zm0 18h5.304v9h-5.304zM0 9h5.304v9H0zm0 54h5.304v9H0zM58.348 0h3.182v18h-3.182zm0 63h3.182v18h-3.182zm-47.74 18h5.305v9h5.304v9h5.305v9h-5.305v9h-5.304v9h-5.304v-9H5.304v-9H0v-9h5.304v-9h5.305zm0 18h5.305v9h-5.304zm31.827-18h5.304v9h5.304v9h5.305v9h-5.305v9H47.74v9h-5.304v-9H37.13v-9h-5.304v-9h5.304v-9h5.305zm0 18h5.304v9h-5.304zM0 135h5.304v9H0zm58.348-9h3.182v18h-3.182zM0 162h5.304v-9h5.305v-9h5.304v-9h5.304v-9h5.305v-9h5.304v9h5.304v9h5.305v9h5.304v9h5.304v9h5.305v9h3.182v36h-3.182v9h-5.305v9H47.74v9h-5.304v9H37.13v9h-5.304v23.4H21.217V270h-5.304v-9h-5.304v-9H5.304v-9H0v-27h5.304v9h5.305v9h5.304v9h5.304v-9h5.305v-9h5.304v-9h5.304v-9h5.305v-9h5.304v-9h-5.304v-9H37.13v-9H21.217v9h10.61v9h-5.305v9h-5.305v9h-5.304v-9h-5.304v-9H5.304v-9H0zm0 36h5.304v9H0zm58.348 27h3.182v9h-3.182zm-10.609 18h5.304v9h5.305v9h3.182v14.4h-3.182V270h-5.305v-9H47.74zM37.13 270h5.305v5.4H37.13z'/%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 122 0)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='matrix(1 0 0 -1 0 549)'/%3e%3c/svg%3e";
            },
            4790: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1000 600'%3e%3cpath fill='%23d90f19' fill-rule='evenodd' d='M0 0h1000v600H0z'/%3e%3cpath fill='%23171696' fill-rule='evenodd' d='M0 60h1000v480H0z'/%3e%3cg transform='matrix(.8 0 0 .8 154.642 48.648)'%3e%3ccircle cx='414.43' cy='301.623' r='210' fill='%23fff'/%3e%3cpath fill='%236f6' d='M452.343 161.539s-1.367-.114-2.621-1.027l2.62 1.023'/%3e%3cg fill='none'%3e%3cpath stroke='%23060' stroke-width='.57' d='M452.345 161.539s-1.367-.114-2.621-1.027'/%3e%3cpath d='m422.83 184.101 1.483.913 1.594.228s1.71 1.594 3.647 3.077c1.479 1.254 1.479-.227 1.479-.227l.913 3.647h1.252s-.344 2.39-.344 3.643l2.165-1.826 2.503 2.167s1.823-1.593 2.735-1.593c.91 0 1.252-.915 1.252-.915h.112c-6.036-2.844-8.657-5.812-6.835-8.889 2.962-5.125 7.862-1.822 9.457-1.138l22.106 11.85s1.48-.908.453-1.822c-1.142-.91-1.596-3.189-1.251-4.099.338-.912 2.844 2.848 4.1 3.188 1.255.343 4.103.8 4.103.8l-.115-1.142s3.646 2.509 3.646 3.763c0 0 2.62-1.37 1.708-2.168-.909-.795 3.988 1.94 4.33 3.422l1.026-1.147c-.112 0 .345-3.646 1.599-5.355 1.14-1.708 2.392-2.165 2.392-2.165s1.14-1.938 2.278-1.938c0 0-1.138-.795-1.593-1.707-.57-.91-1.938-1.367-1.938-1.367s1.708-1.251 2.166-1.825c.455-.683.91-.795.91-.795s-2.62-2.166-4.442-2.51c0 0-.112-2.959-2.391-3.187h1.026s-1.708-3.188-3.305-3.304c0 0 1.027-1.14 1.938-1.25 0 0-1.938-2.51-4.558-1.596l1.713-.684s-1.254-1.369-5.13-.686c0 0 .341-1.59-1.366-2.847 0 0-1.481.112-1.481 1.256 0 0-1.366-1.256-3.076-1.256-1.708 0 .569 1.822.569 1.822s-2.277-1.479-3.646-1.027c0 0 .568-2.617-.91-3.986 0 0-1.71.909-2.168 2.051l-.455-1.142s-2.278 2.738-2.733 1.937c-.344-.45-.683-2.389-.683-2.389l-1.367 2.052.227-2.852s-1.593.913-2.847 3.877c0 0-1.597 1.479-1.597 2.847 0 0-1.25-1.478-2.39 0-1.027 1.596 0 1.254 0 1.254s-.457.569-1.596.798l.23.91s-1.482-.795-2.62-.453l.567 1.364s-2.962.23-3.076-2.161c0 0-2.505-1.255-2.849.112 0 0-2.051 0-1.822 1.138 0 0-.572-1.14-1.597-1.366-1.139-.343-.228 1.478-.228 1.478s-.34-1.366-1.707-2.051c-1.367-.566-.23 1.254-.23 1.254s-1.82-1.48-.907-2.62c0 0-1.71 1.596-.912 3.08l-1.142.795s-.568-.566-.456-1.027c.112-.458-1.937 1.367-1.937 1.367s-1.255-2.962 0-2.962c.112 0-2.166-.115-2.505 2.509-.344 2.503 0 0 0 0s-1.484.112-2.85.564c-1.484.46 1.024 1.484 1.024 1.484s-2.164-.457-3.419.224l.8 1.027s-.799-.795-2.734-.112c-2.053.57.455.912.455.912s-2.05-.455-3.075 0c-1.026.457.338 1.254.338 1.254s-3.757-1.14-4.329-.798c-.567.344 1.255 2.168 1.255 2.168s-2.278.568-2.733 2.278l2.05.799s-.91.454-1.367 1.364c-.453.914 1.367.459 1.367.459s-2.505 1.822-2.505 3.19c0 0 1.825.566 3.19-.8 1.368-1.363.457-.908.457-.908l.112.909s2.62-1.138 2.62-1.822c0-.567-.45.911-.45.911l2.62-1.366 1.708 1.138'/%3e%3cpath d='m420.665 148.543-.57-2.502s3.077 0 5.813.684l1.025-2.393s2.733 1.252 3.648 2.161c0 0 5.354-1.366 6.95-.795l-.684 2.507s4.9.34 6.495.91c1.48.57-.684 1.826-.684 1.826s5.584.682 7.975 2.162c2.509 1.48 2.509 2.737 1.254 3.08l3.076 4.898s-4.9.57-5.813 1.826c-.91 1.252-1.823-1.256-1.823-1.256l-.91 3.42s-3.075-1.598-4.33-2.737c0 0-1.486 1.825-.572 2.736 0 0-3.987 0-5.586-3.649 0 0-2.392-.34-2.392 1.826 0 0-2.736-3.077-3.419-3.991l-3.078.914s-.913-1.254-2.05-1.598c-1.254-.226-.343 1.598-.343 1.598l-1.826-2.166-1.82-2.168S419.402 158 418.15 158c-1.143 0-1.143-1.484-.914-2.51.34-.909-3.646-1.138-3.987 0 0 0-1.143-4.554 3.074-5.812l4.335-1.14'/%3e%3c/g%3e%3cg stroke-width='.57'%3e%3cg fill='%23d67c59' stroke='%23000'%3e%3cpath d='M449.036 163.019s.683-1.596 1.938-.683c1.14.91 1.478 4.9 1.478 4.9l-1.823.91s1.027-1.479-1.593-5.127zm-10.36 35.784s.91-1.251-.342-3.99l1.822-.57s.683 2.165-.229 4.562h-1.254m31.565-6.274-4.33 2.623 2.166 1.026 5.241-3.079-3.08-.57m-58.003 16.98c-1.142.912-1.254 2.508-1.937 3.418-.567.91-2.279 2.162-2.391 3.531-.23 1.367-.342 2.279.226 4.104.68 1.821 3.531 9.912 2.392 16.07-1.255 6.151-.796 8.773-.34 9.688.453.91 1.823 3.416 2.622 3.416 1.821-.228 1.024-.796 1.707-1.938 1.708-2.962 0-25.87-.8-32.25-.567-4.903-2.85-9.349-3.074-9.8-.227-.575-.683-2.054-1.026-2.967-1.708-4.104-3.76-7.633-3.76-16.184 0 0-5.585 1.254-10.37-9.574-2.505-5.47-6.153-4.9-10.482-6.72l1.938-1.258s3.646 1.826 5.47 1.826c1.823 0 1.255-3.647 1.255-3.647l1.822-1.825v7.98c0 3.647 5.013 8.661 7.975 10.143 1.826.909 4.219-2.85 3.65-6.497-.572-3.645 0-8.545 0-8.545l2.505 1.478s-.91 1.596-.683 2.509c.34.913 1.593-.912 2.505-1.826 0 0 .227.23 1.14.23 0 0-1.823 3.074-2.733 4.672-.91 1.483-.91 7.296-.91 9.462s.798 7.177.798 8.771c0 1.143 2.162 5.813 3.875 8.664.569 1.14 1.936 4.1 1.936 4.1 1.366 2.166 1.478 3.648 2.28 5.474.454.909 1.254 3.53 1.822 8.092.229 1.138.456 5.47.8 8.316.34 2.735 2.62.571 5.352-1.367 2.734-2.05 2.734-6.951 2.734-6.951s2.167-1.826 1.824-.798c-.229 1.14 1.143 2.28 1.143 2.28-1.71 3.872-.684 3.417 1.024 3.303 1.708-.23 7.632-4.673 7.632-4.673.798-.23 4.331-.23 3.762 0-.684.343-1.596 2.052-1.596 2.052l3.874-.457c-1.366 1.027-6.496 3.987-7.633 4.673-1.254.8-7.403 3.763-10.026 4.786-2.62 1.14-7.75 3.648-7.977 6.269-.114 2.622.341 9.688 0 11.965-.227 2.278-1.14 12.423-1.14 12.423h-12.192s2.393-8.89-.116-11.282c-2.392-2.51-7.976-9.804-11.622-12.313-3.648-2.391 2.391-.566 2.391-.566v-2.508l5.584 6.727s9.684-8.548 0-20.171c-3.077-3.649-6.154-9.231-8.546-9.804-2.506-.683-3.76-1.254-7.977 0-4.33 1.253-14.7 1.253-19.03-5.587l3.65-.57 3.072-1.253s-1.252 4.33 7.407 4.33c8.545 0 9.8 0 9.117-7.976l2.505-1.255 1.825 1.826s-1.254 4.33-.57 6.152c.57 1.823 3.648 3.079 6.04 4.9 1.026.8 1.824.913 2.507.913 1.025-.114 1.251-.114 2.62-1.482 2.05-2.28 1.594-2.165 3.646-3.987 0 0 1.026-1.596 1.255-1.826l1.254 3.307z'/%3e%3cpath d='M414.057 203.474c.455-.452 1.367-2.166 2.165-3.647 1.367-2.277 2.965-3.645 4.786-6.496 1.707-2.62 2.392-6.493 1.707-9.229l1.594.913.117 4.33s2.166-1.826 3.078-2.278l.909.454s-6.837 7.067-13.218 18.464l-1.14-2.506zm-59.93-23.7c.911 1.59 1.825 4.674 4.558 7.065l1.822-.57s-4.215-4.9-4.215-7.063l-2.166.567m10.707-2.743s.57 5.813-.91 7.978l1.823-.907s1.252-3.989.91-6.156l-1.823-.91zm60.055-18.346s-.344 8.205 1.255 13.22l2.162-.681s-.34-1.486 1.48-2.17c1.826-.568 6.154-2.39 8.319-4.216l-.682-1.82s-3.304 2.62-4.9 3.303c-1.48.571-2.392 1.252-3.646.913-1.255-.344-2.733-2.397-1.824-7.07zm24.148 38.294s-.568 5.813-.227 8.321l1.938.457s-.454-6.953.795-7.523l-2.506-1.253m8.669 4.332s-2.166 3.761-4.67 4.104l3.987-.798s1.142-.57 2.85-2.391l-2.168-.913'/%3e%3c/g%3e%3cg fill='%23338a00' stroke='%23030'%3e%3cpath d='m422.839 184.098 1.478.907 1.596.232s1.707 1.595 3.646 3.075c1.478 1.254 1.478-.228 1.478-.228l.91 3.646h1.255s-.343 2.394-.343 3.648l2.167-1.826 2.507 2.166s1.822-1.594 2.732-1.594 1.255-.91 1.255-.91h.115c-6.04-2.852-8.658-5.813-6.837-8.89 2.964-5.128 7.862-1.826 9.456-1.14l22.106 11.85s1.481-.91.455-1.825c-1.142-.907-1.598-3.188-1.254-4.1.341-.91 2.847 2.847 4.099 3.19 1.254.343 4.101.8 4.101.8l-.114-1.14s3.647 2.506 3.647 3.761c0 0 2.62-1.366 1.708-2.166-.91-.795 3.99 1.94 4.33 3.423l1.025-1.143c-.114 0 .343-3.647 1.595-5.357 1.143-1.706 2.394-2.164 2.394-2.164s1.142-1.938 2.278-1.938c0 0-1.143-.795-1.596-1.708-.57-.915-1.938-1.368-1.938-1.368s1.71-1.253 2.167-1.824c.455-.682.912-.8.912-.8s-2.62-2.162-4.446-2.501c0 0-.112-2.967-2.391-3.192h1.026s-1.708-3.192-3.304-3.304c0 0 1.025-1.14 1.937-1.256 0 0-1.938-2.505-4.556-1.593l1.708-.681s-1.254-1.367-5.126-.684c0 0 .341-1.595-1.366-2.85 0 0-1.48.112-1.48 1.253 0 0-1.367-1.253-3.076-1.253s.57 1.826.57 1.826-2.279-1.484-3.648-1.027c0 0 .57-2.62-.912-3.991 0 0-1.705.913-2.165 2.052l-.454-1.138s-2.279 2.734-2.732 1.936c-.342-.454-.684-2.39-.684-2.39l-1.364 2.052.226-2.853s-1.595.913-2.848 3.874c0 0-1.595 1.483-1.595 2.846 0 0-1.254-1.478-2.393 0-1.027 1.596 0 1.258 0 1.258s-.457.565-1.596.795l.228.909s-1.48-.795-2.621-.453l.568 1.367s-2.962.228-3.074-2.162c0 0-2.507-1.256-2.85.112l-1.824 1.14s-.57-1.14-1.596-1.366c-1.142-.342-.227 1.479-.227 1.479s-.34-1.367-1.708-2.052c-1.366-.566-.227 1.256-.227 1.256s-1.823-1.483-.91-2.62c0 0-1.707 1.595-.91 3.078l-1.14.795s-.571-.569-.459-1.025c.118-.457-1.936 1.366-1.936 1.366s-1.254-2.961 0-2.961c.114 0-2.165-.115-2.505 2.509 0 0-1.481.112-2.85.565-1.478.458 1.027 1.483 1.027 1.483s-2.165-.457-3.418.228l.798 1.027s-.798-.799-2.735-.117c-2.053.57.454.912.454.912s-2.05-.455-3.075 0c-1.027.457.342 1.255.342 1.255s-3.762-1.141-4.331-.796c-.568.34 1.253 2.166 1.253 2.166s-2.279.568-2.732 2.278l2.05.795s-.908.455-1.367 1.37c-.452.91 1.366.453 1.366.453s-2.504 1.826-2.504 3.192c0 0 1.823.567 3.19-.798 1.367-1.366.455-.912.455-.912l.115.913s2.621-1.138 2.621-1.82c0-.572-.453.906-.453.906l2.62-1.366 1.709 1.142v-.003z'/%3e%3cpath d='m420.665 148.548-.57-2.506 5.813.68 1.024-2.391s2.732 1.252 3.646 2.161c0 0 5.354-1.366 6.952-.795l-.684 2.509s4.9.339 6.497.907c1.48.571-.684 1.826-.684 1.826s5.584.683 7.979 2.165c2.506 1.478 2.506 2.735 1.254 3.074l3.073 4.9s-4.898.57-5.81 1.821c-.911 1.255-1.822-1.25-1.822-1.25l-.912 3.418s-3.076-1.597-4.33-2.735c0 0-1.478 1.826-.568 2.735l-5.585-3.647s-2.395-.342-2.395 1.826c0 0-2.732-3.08-3.416-3.992l-3.08.913s-.907-1.251-2.05-1.596c-1.254-.224-.34 1.597-.34 1.597l-1.824-2.166-1.823-2.16s-1.596 2.161-2.85 2.161c-1.142 0-1.142-1.478-.91-2.506.34-.912-3.648-1.138-3.988 0 0 0-1.143-4.558 3.074-5.81l4.33-1.14zm-22.097 15.613-1.937 1.826-1.14-.571-2.278 2.507-.457-1.37-1.254 2.052-1.936-.683-.91 1.481-1.709-.343s-1.481 1.37-2.394 1.711c-.909.23 0-2.05 0-2.05s-1.366 2.28-2.392 2.28c-.91 0-.567-1.027-.567-1.027s-.57 1.479-1.709 1.708c-1.026.116-.57-1.138-.57-1.138l-1.826 1.367v-1.14l-.796-.34s.454-2.053 1.255-2.507c.795-.458-.8-1.821-.8-1.821l.796-.913s-2.28-.57-2.28-.112c0 0 1.143-3.076 2.734-3.651l.116-3.416s1.595-1.367 3.076-1.483c1.594-.23-.455-2.621-.455-2.621l3.646-2.162.454-2.62 5.584.451 1.14-2.391 4.447 1.137 3.757-1.937 2.733 3.192 4.102.342s-.112 2.847-.112 3.647c0 0 4.897 1.478 5.469 1.938 0 0-.912 2.962-.912 3.531 0 0 3.42-.912 4.446-.683 0 0 .343 3.192.454 3.987 0 0 5.81 1.826 6.153 2.852 0 0-1.254.795-1.937 1.82 0 0 .683 3.536.683 4.674l-.456.683s-1.71-1.595-3.077-1.823l-1.142 2.506-2.05-1.366-1.252.114s-1.026-1.255-1.826-1.255l-.114-1.138-1.595 1.025s-2.507-1.255-2.507-2.053c0-.683.115-1.825.115-1.825l-2.62 1.825s-.57-1.366-.455-1.937c.114-.57-1.026 1.369-1.026 1.369s-1.368-2.395-1.254-2.852l-.343 1.938s-2.733-.907-3.075-2.733v-.004z'/%3e%3cpath d='M362.1 175.328s4.788 2.397 4.788 3.535c0 0 1.254-2.508.57-3.42l1.824 1.254s.565-2.277-.117-2.963c-.571-.57 4.1-2.504 5.126.57 0 0 2.85-2.962-2.62-5.47 0 0-.453-1.823 2.85-1.367 0 0-.228-1.14-1.027-1.596h3.192s-1.938-1.596-4.786-2.051c-2.733-.458-1.027-.795-1.14-1.37-.23-.57 0-2.621 0-2.621s-1.596-.57-2.85.114l.456-.572s-2.964-.795-4.1-.112c0 0-1.71-.683-1.481-2.508 0 0-1.71-.112-2.504 1.708 0 0-1.596 1.825-3.76 1.825-.454 0-2.05-.914-2.05-.914l-1.37 3.192-2.164-.112.683 1.251s-3.304-.907-4.33 0c0 0 1.254 1.94.91 3.304 0 0-2.62.46-3.19.915-.683.45.911.794.911.794s-2.962.912-3.648 1.826l1.142.907-1.368 1.828 1.142.224s-1.937.572-2.962.914c-1.025.34 1.823.571 1.823.571l-1.367 1.251 2.166.34s-1.708 4.56-1.822 6.726c0 0 2.62-3.192 3.304-3.418l-2.05 3.418s3.875-1.251 4.217-1.825c.339-.683.681-1.252.681-1.252l.115 1.938s1.481-2.053 1.709-2.85c.116-.796 2.392.797 2.392.797v-1.142s2.053.683 2.733.8c.799.112.912-.343.912-.343l1.938-.227-.344 1.593s1.366-.91 1.706-1.823c.229-.913.911 0 .911 0l.91-3.647h1.935zm-15.612 16.184 1.822 3.761c-1.48.112-3.646 1.821-3.646 1.821.34 6.27-1.252 5.927-1.252 5.927.451 1.14-.29 3.255-.29 3.255l9.063-5.418.116-.57 10.712-5.016.338.569 3.078-1.708 2.166 5.695-2.165 1.255c.116 1.937 2.394 5.358 2.394 5.358l2.849-.682 3.075-1.141s.116 1.708.116 1.142c0-.459 3.302-1.596 3.302-1.596l1.48 1.482c1.143-.112 3.19-2.852 3.19-2.852l2.394.915s.797-1.367.797-2.393c0-.912 2.962-.912 2.962-.912l2.053 1.478 2.62-2.161s.798 1.595 1.823 1.82c1.143.116 3.988 2.279 3.988 1.826 0-.454 1.254-2.963 1.254-2.963l4.785 1.938c-.681-2.166-2.276-4.786-2.276-4.786s2.276-1.82 1.823-2.277c-.455-.457-1.824 0-1.824 0l1.366-2.735h-1.822l.567-.681-2.961-1.253 1.594-3.192c-.684-.8-8.546-2.396-8.546-2.396l1.823-1.708s-.911-1.367-1.823-1.367-5.698.116-5.925-.338c-.117-.457-2.053-2.169-2.053-2.169l-2.964 2.17-1.478-.458-2.62 1.027s0 1.48-.346.454c-.339-.915-2.733-3.304-2.733-3.304-.455.795-3.53 4.442-3.53 4.442s-.457 1.94-1.483.57c-1.142-1.367-3.533-2.848-3.875-1.709-.342 1.256-2.504 2.392-2.964 2.054-.452-.346-2.961-.115-3.19.568-.114.795-2.848 2.847-2.848 2.847-1.71-.796-4.447-.338-4.447-.338s-.795 1.251-.907 2.277l-5.583 1.48h.003v-.004zm51.509 46.156v-2.394l2.733 1.822 1.596-1.825 2.05 2.05 1.254-2.05v3.308l3.076-2.733 1.821.795v-2.62s2.167-3.648 1.255-4.33l1.823-.569s-3.076-3.077-3.987-3.65c-.91-.682-2.165-.682-2.165-.682s-2.393-2.396-3.988-3.077c-1.48-.57-2.396.681-2.396.681s-.91-1.82-2.505-2.163c-1.478-.34-1.478 1.254-1.478 1.254s-1.142-1.142-2.62-1.71c-1.481-.68-.456 1.366-.456 1.366l-5.242-1.59.681 1.59-4.897-1.248.567 1.823-3.416-.574-.229 1.487-4.9.909.912 1.594-3.077-1.254v2.167l-3.42 1.251 1.255 1.143s-4.558 2.165-5.471 2.848c-.91.568 1.826 1.82 1.826 1.82l-4.901-.683 1.823 1.597-4.33 3.991 3.076 2.165-1.824 2.734 4.559.91 1.822 3.076 3.76-.684v3.416l5.47-4.327s3.99 3.532 4.33 2.506c.227-.91.227-3.987.227-3.987h1.937v-3.075l1.479 1.252 2.509-3.649 3.302 4.56 2.505-5.81 3.647.57zm22.333-13.788-.57-5.241-1.593 1.596.68-4.9-2.503-.458.909-4.784-1.822-.914.453-2.277 1.825-1.367 3.304-3.192 7.63.119.911-2.509 5.472.913c.909 1.026 3.757-2.052 3.757-2.052h1.143l1.254 2.39s3.987-.571 5.81.683l-2.166 2.962 3.987.341 2.733.571 2.85-.912 3.648-.231.91 1.481h3.42l-1.14 1.367 4.444 2.05-.91.914s2.506.91 4.33.91h.91s.91 2.162-.344 3.074c0 0 1.254 3.079 3.987 3.65 2.735.57 2.735.57 3.076 1.25.345.572 0 3.65-3.075 3.65v3.08s-2.392 2.163-2.733 3.072l-1.825-1.254s-1.59 1.826-1.59 3.08c0 0-3.99-5.245-5.473-5.474-1.595-.34-1.254 2.964-1.254 2.964l-4.328-3.646-.572 2.505-3.645-3.075-2.166 1.477-3.876-3.987-3.758.459 1.478-1.94h-4.555l-.91-3.987-.684 3.304-2.733-1.822-3.532 3.874s-.455-.46-1.026-2.28c-.567-1.824-2.165 2.163-2.165 2.163l-1.254-2.847-1.478 2.847s-1.255-2.164-2.51-2.847c-1.138-.569-2.39 3.416-2.73 5.242zm.683 11.962.227-1.82 6.494-2.51 5.472-2.05 2.732-1.254 1.255 2.166 1.594-3.075 2.506 3.188 1.37-1.708 2.163 1.594h1.823l.342 2.397s4.558.338 4.898-.57c.344-.913.911 3.075.911 3.075l4.329.569.912 4.9s2.161 4.56 1.48 6.384c-.571 1.938-2.394-2.394-2.394-2.394s-.34 3.419-.683 4.33c-.227.91-5.81-.911-5.81-.911l-2.393 4.558s-2.506-3.647-3.646-3.647c-1.254 0-1.254 3.647-1.254 3.647s-3.647-4.33-5.242-6.156c-1.482-1.82-1.826 1.826-1.826 1.826s-2.39-3.99-2.39-5.13c0-1.252-2.167-2.509-2.167-2.509s-3.763 4.333-6.498 5.474c0 0 .343-2.736-.568-3.648-.91-.913-3.647 1.822-3.647 1.822s-1.938-4.217 0-8.549z'/%3e%3c/g%3e%3cg fill='none' stroke='%23004b00'%3e%3cpath d='m451.097 167.913.571 2.28s2.05-.458 3.418-.342c0 0-.342 1.823-.797 2.62 0 0 2.733-.454 3.987.341l-.57 1.367 3.193 1.37-2.964 2.391s4.783 1.707 5.698 3.077c0 0-3.076 2.165-3.532 2.053-.456-.23-.115.907.683 1.934l-2.62-.112s1.024 2.394.908 3.304c-.114.91-4.33.681-4.33.681m16.403-6.146s.797-4.558-.453-5.698c0 0 2.962 2.509 4.899 2.62 2.051.118-.116-3.76-.116-3.76s2.85 1.48 4.217 1.822c1.366.228-1.027-2.85-1.027-2.85s.796-1.482 3.075-.114m-52.976-18.116s.112-1.026-.346-1.594c-2.732-3.762 2.85 2.85 3.988 3.077m5.24-.005s1.822 1.367 2.734 1.367c.911 0-.57-3.648-1.026-4.101-.454-.458 3.304 1.478 4.673 1.709 1.366.34 1.594-2.278 1.594-2.278s4.217.682 5.13 1.254m-29.29-.796s-.341-2.392-.453-3.417m-28.253 14.82c-.228-.458 1.143-2.51.572-3.42 0 0 .795.684 1.593.798.683.112.452-2.622.452-2.622l.913.34s2.394-1.142 1.938-2.053c-.46-.91 1.594 1.366 1.594 1.366s1.368-1.366 1.368-1.934c0-.576 1.594 1.363 1.594 1.363s1.708-.342 1.708-1.366c0-1.025 2.165.34 2.165.34s.91-1.252.799-2.051m-23.017 11.4s1.024-2.391-.116-3.987m-27.571 11.502c.115-1.138.683-4.215.115-4.672-.57-.452 1.142.457 2.507.799m10.817-.45c-1.365-1.37-2.165-2.052-4.327-2.052m-18.8 9.68c.342-.796.91-2.734.57-3.874m29.166 60.4 1.48-3.077 1.824 4.329 1.252-2.735.455.912 2.733-2.963 2.964 4.445m47.522-19.257 1.937-3.873 2.621 1.367 1.254-3.76 2.733 1.71 1.595-3.533 3.077.795.226-2.506s2.165 1.25 2.734 2.162c.682.914 0-3.073 0-3.073l2.505 1.138s1.824-1.826-.683-2.85'/%3e%3cpath d='m442.663 212.938 2.733 3.99 2.277-2.621 2.053 4.442 2.62-1.595 3.76 2.165 1.707-1.366 4.103 2.963 1.709-3.53 3.646 1.139 2.39-4.1m-98.443-10.716s1.596-2.738 1.025-3.991c-.683-1.254 3.304 2.165 3.304 2.165s.91-2.735.341-3.987c-.683-1.254 4.558 3.648 4.558 3.648s.913-4.216 0-5.13c-.911-.913 5.014 1.254 5.014 1.254s2.395-.681 1.482-1.937c-.911-1.253 3.988 1.822 3.988 1.822s1.138-3.074 0-4.217c-1.255-1.25 3.645 1.483 3.645 1.483l-1.822-3.307 3.987.228-.34-3.647m35.32 52.644 2.621-1.255 2.28 2.281 2.505-3.987 3.075 2.96.456-2.96 3.305 1.37.683-1.828 3.645 1.941.341-2.737 1.822.572.342-1.826'/%3e%3c/g%3e%3c/g%3e%3cpath fill='%239dc9e2' d='M372.125 370.434a81.476 81.476 0 0 1-6.953-15.154l49.34-43.423 49.34 43.306c-1.71 5.012-3.99 10.37-7.178 15.5l-.393.631a481.232 481.232 0 0 1-3.71-1.429s-1.596 1.482-2.845 1.594c-1.71.23-3.192-1.479-3.192-1.479s-2.166 1.823-4.33 1.479c-2.165-.224-3.077-1.594-3.077-1.594s-2.278 1.822-3.876 1.48c-1.478-.346-2.505-1.371-2.505-1.371s-1.366 1.713-3.304 1.372c-1.822-.347-3.531-1.372-3.531-1.372s-2.845 1.25-4.67 1.481c-1.823.345-3.42-1.596-3.42-1.596s-2.392 1.596-3.304 1.596c-.91 0-4.329-1.596-4.329-1.596s-3.533 1.14-4.786 1.14c-1.142 0-4.67-1.478-4.67-1.478s-3.304.907-4.785.907c-1.597 0-3.875-.907-3.875-.907s-2.73 1.253-4.215.907a15.434 15.434 0 0 1-2.85-.907s-2.962 1.253-4.9.907c-1.822-.338-3.987-1.59-3.987-1.59s-.342.91-3.875 1.59h-.115'/%3e%3cg stroke='%23000'%3e%3cpath fill='%23fff' stroke-width='.797' d='M414.517 261.938v49.916l-49.34 43.65c-4.783-13.903-5.125-26.324-5.125-31.68V261.94h54.466'/%3e%3cpath fill='%23ffe682' stroke-width='.797' d='M414.517 261.938v49.916l49.225 43.65c4.784-13.903 5.127-26.324 5.127-31.68V261.94h-54.352'/%3e%3cg stroke-width='.57'%3e%3cpath fill='%23d67c59' d='M382.686 360.063c3.71 2.01 2.453 1.377 10.142 4.099 6.268 2.17 13.558 3.192 24.154 3.192 9.272 0 14.491-.736 17.428-1.546 3.046-.873 3.767-2.103 3.767-2.103l-7.633 7.75s-30.682 1.656-36.237-1.937c-2.162-1.142-6.836-4.9-11.62-9.457z'/%3e%3cpath fill='none' stroke-linecap='round' d='M427.7 345.592s9.8 5.582 0 16.296m-44.095-1.254 14.129-13.452-1.596 18.008m7.403 1.593v-30.084m24.159 30.084v-31.91m-12.197 32.48v-34.3'/%3e%3cpath fill='%23d90f19' stroke-linejoin='round' d='m403.541 338.3-6.382 2.053 6.382.683V338.3m11.962-4.68-6.72 2.508 6.72.228zm12.197 1.825-6.723 2.509 6.723.34v-2.852zm3.987 14.481c-.342-1.368 3.99-1.251 3.99-1.251s1.253 4.555 0 7.403l-3.647-.683s.343-3.074-.342-5.47z'/%3e%3cg fill='%23fff'%3e%3cpath stroke-linejoin='round' d='m385.766 358.808 11.966-11.626-.572 6.954s-6.15 3.987-6.15 6.837l-5.243-2.166m6.372 2.399s1.255-3.648 4.67-5.47l-.34 7.294-4.328-1.826zm17.215-20.172s4.897-.684 8.546 0c0 0-.572 4.9 0 5.81 0 0-6.724-1.595-9.457.91 0 0-.912-4.559.912-6.72zm-10.371 1.254s4.9-.683 8.545 0c0 0-.91 5.473-.342 6.384 0 0-5.471-3.08-8.204-.574 0 0-1.825-3.758 0-5.81z'/%3e%3cpath stroke-linecap='round' stroke-linejoin='round' d='M398.635 348.66s4.9-.568 8.546 0c0 0-.57 4.9 0 5.814 0 0-6.381-1.481-9.117.91 0 0-1.254-4.558.571-6.723zm9.8-.906s7.066-.908 10.71-.34c0 0-1.48 3.988.344 6.723 0 0-7.635-2.052-10.483.34-.003 0-2.393-4.559-.571-6.724zm-10.36 7.638 9.455.683s-.909 6.952-.341 7.863c0 0-7.632-1.826-9.117.681 0 0-2.506-6.38 0-9.229h.003zm10.708 0s8.2-.571 11.963 0c0 0-2.168 5.246.229 9.8 0 0-10.713-3.072-12.197-.571 0 0-2.501-6.38 0-9.229zm12.533-14.358s4.897-.684 8.545 0c0 0-.568 4.9 0 5.81 0 0-6.723-1.595-9.454.91-.003 0-.915-4.559.909-6.72zm0 6.72s4.897-.57 8.545 0c0 0-.568 4.9 0 5.813 0 0-6.723-1.482-9.454.911 0 0-.915-4.558.909-6.722zm.57 7.067s4.898-.68 8.659 0c0 0-1.255 7.635-.684 8.546 0 0-5.577-2.621-8.202-.338 0 0-1.592-6.039.229-8.208z'/%3e%3cpath d='M432.023 355.392s1.592 5.81 3.645 6.496l-2.733 3.304s-3.304-2.393-3.648-5.124c0 0 2.165-2.51 2.735-4.674z'/%3e%3c/g%3e%3c/g%3e%3cg stroke-width='.61'%3e%3cpath fill='%23006ac8' stroke='none' d='M456.45 371.117c-7.862 13.108-20.738 25.413-41.93 33.048-21.539-7.747-34.64-20.624-42.39-33.62l.114-.113c3.532-.687 3.875-1.595 3.875-1.595s2.165 1.254 3.988 1.596c1.937.34 4.899-.912 4.899-.912s1.254.571 2.848.913c1.479.34 4.215-.911 4.215-.911s2.279.913 3.874.913c1.48 0 4.786-.912 4.786-.912s3.53 1.478 4.67 1.478c1.255 0 4.785-1.138 4.785-1.138s3.42 1.596 4.33 1.596c.91 0 3.304-1.598 3.304-1.598s1.594 1.937 3.416 1.597c1.825-.228 4.673-1.48 4.673-1.48s1.708 1.026 3.532 1.366c1.935.343 3.304-1.367 3.304-1.367s1.024 1.027 2.506 1.367c1.595.343 3.873-1.48 3.873-1.48s.91 1.368 3.077 1.594c2.166.343 4.33-1.479 4.33-1.479s1.478 1.708 3.19 1.479c1.254-.114 2.846-1.594 2.846-1.594s2.848.909 3.873 1.254'/%3e%3cpath fill='none' stroke-width='.57' d='M454.513 374.085c-1.708.117-1.938-1.026-1.938-1.026s-2.273 1.94-4.443 1.597c-2.277-.338-3.304-1.822-3.304-1.822s-2.393 1.938-3.989 1.595c-1.593-.228-2.732-1.37-2.732-1.37s-1.479 1.714-3.418 1.37c-1.938-.227-3.649-1.369-3.649-1.369s-3.075 1.258-5.014 1.598c-1.937.344-3.532-1.823-3.532-1.823s-4.443 1.483-5.353 1.483c-1.027 0-4.219-1.484-4.219-1.484s-2.163 1.369-3.416 1.369c-1.366 0-5.014-1.596-5.014-1.596s-3.42.913-5.016.913-3.987-.914-3.987-.914-2.963 1.254-4.558.914c-1.595-.344-2.85-.914-2.85-.914s-3.19 1.254-5.126.914c-1.937-.344-4.217-1.596-4.217-1.596s-.34.797-4.099 1.596h-.116'/%3e%3cg fill='%23006ac8' stroke-width='.683'%3e%3cpath d='M383.75 378.733s-.318.745-3.29 1.4c-.063-.004-.806.176-.806.176.274-.05.497-.09.736-.14a13.81 13.81 0 0 1-.84.28c3.36 4.853 8.394 9.26 13.638 12.793 5.247 3.535 11.275 7.753 21.538 10.763 10.792-4.213 13.67-5.815 20.724-10.539 7.053-5.152 10.727-8.36 14.661-13.645-3.08 1.749-2.637 1.768-4.233 1.54-1.596-.34-2.767-1.505-2.767-1.505s-1.456 1.736-3.394 1.505c-1.937-.338-3.64-1.504-3.64-1.504s-2.53 1.721-5.04 1.609c-1.937-.116-3.536-1.82-3.536-1.82s-4.447 1.47-5.356 1.47c-1.026 0-4.2-1.47-4.2-1.47s-2.177 1.364-3.429 1.364c-1.366 0-5.006-1.61-5.006-1.61s-3.41.91-5.005.91c-1.596 0-3.989-.909-3.989-.909s-2.843 1.252-4.55.91c-1.598-.338-2.872-.909-2.872-.909s-3.175 1.252-5.11.91c-1.938-.338-4.234-1.574-4.234-1.574z'/%3e%3cpath d='M414.73 404.012c11.147-4.64 13.16-5.903 19.903-10.024-1.176.031-4.596-1.074-3.359-1.425 0 0-1.37 1.234-2.737 1.234-1.254 0-4.9-1.59-4.9-1.59s-3.416.907-5.012.907-3.988-.907-3.988-.907-2.964 1.25-4.559.907c-1.596-.338-2.85-.907-2.85-.907s-3.303 1.25-5.125.907c-1.938-.338-4.219-1.593-4.219-1.593s-2.804 1.487-4.564 1.658c5.387 3.945 11.056 7.797 21.41 10.833z'/%3e%3c/g%3e%3c/g%3e%3cg stroke-width='.509'%3e%3cpath fill='%23d67c59' stroke-width='.57' d='M368.52 266.185c-.791-.02-1.738.444-3.196 1.766-2.3 2.077-3.128 4.217-.11 6.805l14.958 13.601c2.184 2.124 5.239 2.512 6.52 3.614l15.203 15.546c1.916 1.655 2.833 2.829 1.75 4.243-1.202 2.325.085 2.64.359 2.71 2.08.468.95-.834 1.219-1.507-.027-.237.068-.472.086-.735.035-.525 1.646-2.1 3.082-2.66.717-.28.96.018 1.14.403.656.262 1.349-.718.383-1.754-.832-1.158-2.131.722-3.598.28 0 0-2.211-1.37-2.816-2.35-1.29-1.437-2.953-2.725-3.91-3.958-1.014-1.142-4.826-6.184-10.63-11.988-1.668-1.09-1.289-5.21-2.483-6.488-.101-.893-11.604-12.277-15.707-16.395-.83-.61-1.46-1.113-2.25-1.133z'/%3e%3cpath fill='none' stroke-width='.56' d='m369.246 272.31 15.634 15.446'/%3e%3cpath fill='%23e8e8e6' stroke-width='.639' d='M390.415 279.366c.241-.465.77-1.65 1.329-2.942.22-.51 4.426-7.218 6.523-7.415 0 0 13.078 9.515 13.088 9.64.045.513-5.673 9.065-6.171 8.415 0 0-15.322-6.433-14.769-7.698z'/%3e%3cpath fill='%23ccb8c8' stroke='none' d='M398.747 281.606c-1.792-1.39-4.75-2.747-7.14-4.34l-1.075 2.24c.864.967 11.746 6.025 13.534 7 0 0-2.072-2.376-5.32-4.9z'/%3e%3cpath fill='none' stroke-width='.448' d='M391.6 276.98c1.4.98 4.06 2.66 5.74 3.64 3.22 2.24 5.26 4.708 7.561 6.02'/%3e%3cg stroke-width='.57'%3e%3cpath fill='%23d67c59' d='m365.102 317.737 29.778-36.852c.56-.511 3.32-.537 3.694 2.316l-28.202 38.435c.002 0-3.21-.318-5.269-3.899zm99.816.403c-1.027.801-2.77 1.009-2.77 1.009-1.935-2.28-3.534-4.673-6.268-7.634l-29.742-36.58 3.076-2.963 26.776 31.338c.797.797 5.472 5.7 9.916 11.508.003.002.39 2.275-.99 3.326z'/%3e%3cpath fill='%23e8e8e6' d='m436.279 279.6-4.787-5.697s-3.646.453-4.328 2.393c0 0-2.62 4.33-9.572 4.787 0 0 1.934 8.091 10.026 12.421 0 0 2.963-8.322 5.81-9.802 0 0 2.962-2.166 2.85-4.1z'/%3e%3cpath fill='%23d67c59' d='M424.317 304.902c-.683-.23-1.366 0-2.394.571-.909.571-2.05.34-1.937-.8.115-1.026 0-.91 1.254-1.707 1.826-1.026 4.217-1.142 5.698-.571l-2.62 2.509m32.468-32.37c-.228-.796-.453-1.59.342-2.617.797-.912.797-2.51-1.142-1.712-1.938.8-2.621 2.964-1.024 6.27l1.82-1.942z'/%3e%3cpath fill='%23e8e8e6' d='m423.633 305.585 33.73-33.505 8.315 8.89s-1.708-.687-2.393-.232c-.569.457.684 2.166.684 2.166s-1.595-.57-2.278-.114c-.798.454 0 2.392 0 2.392s-1.366-1.024-2.052-.57c-.568.458 0 2.62 0 2.62s-1.822-.568-2.276-.114c-.457.457 0 2.394 0 2.394s-1.825-.912-2.734 0c-.91.91.454 2.166.454 2.166s-2.278-.912-3.19.454c-.911 1.368.114 2.62.114 2.62s-1.822-.908-2.278-.457c-.455.458 0 2.621 0 2.621s-1.594-.91-2.62.232c-1.026 1.254.114 2.279.114 2.279s-1.478-.915-2.28-.46c-.799.46.228 2.622.228 2.622s-1.478-1.027-2.506 0c-1.026 1.142 0 2.277 0 2.277s-1.254-1.14-2.506 0c-1.142 1.254 0 2.509 0 2.509s-1.822-.911-2.505 0c-.797.907.227 2.166.227 2.166s-1.367-.798-2.278-.347c-.907.46 0 2.509 0 2.509s-1.366-1.481-1.935-.682c-.683.797.114 2.734.114 2.734s-1.254-1.482-1.937-.681c-.797.683.454 2.393.454 2.393s-2.277-1.026-1.708-1.026z'/%3e%3c/g%3e%3cpath fill='%234d4d4d' stroke='none' d='m455.42 274.818-2.62 2.621.569 9.005s.57-2.62 1.365-.8c0 0 .23-2.164.799-1.82-.46-.232-.114-9.006-.112-9.006m-4.895 4.895-1.938 1.822.683 9.005s.571-3.42 1.367-.683c0 0-.115-2.279-.115-3.079.003.572.003-7.065.003-7.065m-20.396 20.183-1.824 1.934.458 5.473s.57-3.532 1.366-.8c0 0-.229-2.274-.229-3.076 0 .572.23-3.533.23-3.533'/%3e%3cg fill='none' stroke='%234d4d4d' stroke-width='1.026'%3e%3cpath d='M427.845 277.327c1.255 1.255 4.787 5.81 4.787 5.81m-3.185-3.3c-.227.685-.68 2.62-1.706 3.647m2.266-3.2c-.115.456-.115 1.938-1.706 3.42m2.277-2.725c-.229.795-.341 1.366-.91 1.937m1.257-1.254c0 .57-.34.683-.453 1.026m-3.758-3.2c-.454.455-3.761 2.62-5.583 3.305m4.665-2.05c-.455.458-2.507 2.053-3.647 2.51m3.31-1.143c-.683.459-1.823 1.596-2.732 1.937m2.05-.57c-.455.569-1.141 1.026-1.709 1.368'/%3e%3cpath stroke-linecap='square' d='M404.997 284.73c.372-.685 1.02-2.033 1.867-3.266 1.075-1.564 1.538-1.83 2.1-2.38'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg stroke-width='.57'%3e%3cpath fill='%23358b03' stroke='%23060' d='M294.99 376.594c1.708.795 0-5.585.567-7.977.683-2.507 5.583 6.153 7.98 7.296 2.506 1.251 17.774-6.043 17.774-6.043l3.646-6.837 1.938 5.582s4.215-4.9 5.47-6.722 0 3.648-1.255 5.47c-1.255 1.826 3.646 2.509 3.075 6.155-.57 3.649 4.9-2.507 4.9-2.507l14.128 1.254s2.39-8.55 6.151-13.45l1.14 5.475 5.81-5.925c6.497 17.096 20.172 35.672 48.2 45.813 26.32-9.572 39.882-26.555 46.944-42.74l7.862 8.098s6.155-1.827 7.293-2.509c1.253-.571 14.471 4.674 14.471 4.674s2.393.911 3.648 1.826c1.251.91.34-3.991.34-3.991s6.723 1.253 6.152 4.9c0 0 1.482-3.418 2.736-3.987 1.255-.571 4.214 3.076 4.9 4.329.57 1.142 15.042 2.963 17.092 4.217 0 0 1.596 1.825 1.596 3.078 0 0 3.077-.344 5.471-.344 0 0-1.824.907-1.824 2.849 0 1.825-.912 3.308-2.734 4.216-1.824.913 0 1.593 2.393 1.825 2.507.34 0 3.416-4.9 5.244 0 0-1.14 2.733.912 3.643 0 0-4.22.345-4.9-.91 0 0-1.479 2.848-1.479 4.33 0 0-4.558-1.484-5.813-2.165 0 0-1.824 1.82-.571 2.733 0 0-8.315-.91-9.912-3.987 0 0-2.963.91-2.394 1.937 0 0-5.81-3.987-7.633-3.987l-1.254 2.046s-3.988-2.391-5.242-2.391c-1.142 0-.228 1.822-.228 1.822l-5.581-3.42-2.164 3.42s-4.558-2.167-5.81-3.076c-1.143-.91-1.48 1.822-2.393 2.162 0 0-1.824-2.503-4.33-2.162 0 0-.91 3.075-.569 3.987 0 0-7.065-1.48-8.317-1.825-1.254-.34-.57 1.482 0 2.737 0 0-5.242-1.48-6.382-2.397l-.342 2.397s-4.326-.343-5.239-1.254l-2.734 3.758h-3.988l-.91 3.304s-7.633-2.162-8.32-.91c-.569 1.251.343 3.074.343 3.074l-6.722-.91-.567 2.733s-7.75-2.393-9.574-1.255c0 0-2.393 2.51-3.989 3.079-1.478.683 0-.912 0-.912l-2.39-3.304s-2.734 1.482-4.332.912c-1.477-.687-6.38 2.39-7.977 1.479 0 0 0-2.168-1.25-2.737-1.143-.57-3.305-.57-4.22.913 0 0-.906-1.254-2.503-3.647-1.48-2.51-3.648.227-3.648.227l-.342-2.964-4.216-.343c-2.507-.342-3.076-2.51-3.076-2.51s-6.494.684-7.406.346l1.594-1.484s-8.886 1.827-10.707 1.143c-1.938-.569 2.05-3.078 2.05-3.078s-8.205-2.047-9.8-2.391c-1.479-.342-10.37 1.477-11.624 1.477s-1.823-2.053-1.823-2.053-2.167 1.826-3.99 2.397c0 0-1.48-3.646-.568-3.99 0 0-5.81 1.597-6.153 3.08 0 0-1.479-2.392-1.255-3.419 0 0-2.732 4.33-3.987 5.242-1.254.912-.229-2.166-.229-2.166s-3.416 4.33-4.67 4.673v-3.078s-9.8 5.241-12.533 4.56c0 0 0-2.17.91-2.736l-6.153-.342c-1.479-.226-3.304-.907-4.899-1.253-1.478-.23 2.167-1.822 4.674-1.14 0 0-6.837-2.506-8.89-1.254 0 0-.912-2.506 2.732-3.42 0 0-4.672-4.555-7.408-4.216 0 0 3.08-1.821 5.586-.912 0 0-2.849-7.746-4.673-8.658 0 0 6.496-1.14 8.32-.224z'/%3e%3cg stroke='%23000'%3e%3cpath fill='%23d67c59' d='m285.525 242.91 82.953-42.964c.398-2.222-.862-3.965-2.164-5.701-23.722 11.635-45.311 25.753-71.672 34.306-1.48.571-14.585 6.039-21.308 14.132-2.133 2.138-2.29 5.292-2.29 5.292s.164 3.617.925 4.594c0 0 .197.994 1.437 1.789-.014 0 .765.38 1.306.187.6.112 1.58.106 2.95-2.29 1.368-2.281 5.813-7.522 7.862-9.348z'/%3e%3cpath fill='%23e8e8e6' d='m352.3 200.405 10.71-5.13s3.648 2.735 3.304 5.813c0 0 .799 7.065 9.574 11.965 0 0-7.409 9.229-20.395 10.028 0 0 1.49-12.182-1.244-15.716 0 0-.456.437-.257-.168.387-1.186-.264-5.25-1.927-6.145-.204-.112.131-.444.236-.648z'/%3e%3c/g%3e%3c/g%3e%3cpath fill='none' stroke='%234d4b4d' stroke-width='.912' d='M364.833 201.883c-2.278.912-9.685 4.786-9.685 4.786m6.157-2.511c-.115 1.139-.799 3.874 0 5.812m-1.03-5.466c0 .57-.91 2.621.115 5.358m-1.246-4.787c-.229 1.143-.455 1.826 0 3.08m-.919-2.396c-.227.683 0 1.026 0 1.478m6.72-1.826c.341.91 3.418 5.697 5.242 7.635m-4.782-5.473c.343.912 2.051 4.217 3.304 5.473m-3.528-3.535c.454 1.14 1.366 3.192 2.277 4.33m-2.277-2.046c.228.913.683 2.053 1.366 2.853'/%3e%3cg stroke='%23000' stroke-width='.509'%3e%3cpath fill='%23d67c59' stroke-width='.57' d='M439.484 180.33c-1.516.182-2.883 1.219-4.421 3.84-2.689 5.14-2.035 7.945 6.085 11.465h.004l30.47 14.921c6.106 2.968 8.304.221 11.75 1.72l60.136 30.632c5.159 2.255 8.047 2.976 7.305 5.645-.102 3.44 1.114 3.913 1.95 4.075 1.297.543 2.3.849 2.573-.65.198-.297-.163-.778-.547-1.41-.384-.631-.79-1.413-.691-2.304.099-.892.171-1.311.469-1.782.297-.47.818-.988 1.808-2.078.495-.544.962-.785 1.406-.828.444-.043.868.109 1.27.344.555.324 1.039.7 1.535 1.05 2.005-.16.219-3.007-1.172-4.09-3.026-1.417-3.371 1.801-6.558 1.462 0 0-5.698-2.164-7.75-3.645-3.779-2.057-9.055-4.497-10.254-5.836-3.84-.72-32.74-16.977-49.114-25.136-1.756-1.47-2.713-6.907-6.164-8.727-1.013-1.467-23.178-11.588-34.77-17.383-2.135-.797-3.803-1.467-5.32-1.285z'/%3e%3cg fill='%23ffa54b' transform='translate(-4.865 22.64) scale(1.12001)'%3e%3cpath fill='%23ad7c59' fill-opacity='.99' d='M309.734 165.117c-.203.61-.712.203-.712.408-.405 2.135-.305 3.253-.813 4.475-.712 1.424-3.256 2.748-3.154 2.645-2.033.61-4.474 3.054-8.44.814-.205-.1-.407-.306-.61-.508 0 0 1.116 4.17-2.95 6.204-1.425.713-15.77 8.244-15.77 8.244s-1.527 2.748-.51 6.512c.103.61.305 1.118-.305 1.526-.916.71-2.646 2.748-3.662 6.004 0 0-3.053-1.324-3.053-3.256 0-1.934 1.22-2.95 1.526-4.378.304-1.32 1.117-4.68.712-5.698-.406-1.12-2.238-1.526-2.95-1.933-.61-.41-1.425.405-1.322 1.32.103 1.02.813.813 1.628 1.02 0 0-.916 1.93-.813 3.355l-9.257 4.783s1.22 1.626 1.627 2.34c.405.712 1.32 10.175 4.07 14.653 2.746 4.478 3.662 3.257 4.272 3.867.508.508 1.32 1.32 2.034 1.934.712.51 3.865.812 4.477-.915.712-1.63 1.22-2.647 3.154-4.174 1.933-1.523 5.9-5.39 5.9-7.122 0 0 2.34 6.716 2.033 12.313 0 0 8.546 1.732 16.177 1.933 7.632.105 11.497-1.524 11.497-1.524s1.018-6.41.608-7.632c0 0 1.22 4.172 2.137 5.596 1.018 1.727 2.135 5.288 4.373 5.493 2.137.1 3.97-2.135 4.17-3.05v-6.717h8.648c0-.1 3.867 1.424 5.087 1.22 1.22-.102 1.933-1.22.813-1.628l-.405-.303c1.117 0 2.543.71 2.543.71h4.27c.104-.102 0-.41-.102-.51-.305-1.22-2.544-2.24-4.17-2.95-1.63-.608-3.46-1.323-4.68-1.423-1.933-.206-3.257-.1-6.207.408-.814.1-3.866.405-5.8 1.32-.51.307-1.02.407-.813-.915.306-1.426.204-7.835-1.32-10.583-1.12-1.932-1.018-3.562-.814-5.188.104-1.63.204-7.226 0-8.855-.306-1.627-2.544-3.867-6.61-4.375-3.867-.51-7.124-3.664-7.326-6.207-.305-2.542.408-7.223.814-9.257'/%3e%3cg fill='none'%3e%3cpath fill='%23b68a6a' d='M292.444 153.627c-.712 3.253-.712 6.104-.61 9.257.103 2.135 1.12 4.577 2.035 6.715.61 1.426 1.425 3.052 2.746 3.867 3.563 2.34 6.92-.204 8.853-1.018.916-.308 2.34-1.626 2.747-2.442.508-1.22.303-2.135.812-4.475-.103.1.813-.408.712-.408.916-1.526.712-2.034 1.22-3.054.51-1.018-.608-2.136-1.83-1.93.608-1.934 1.018-4.073.404-5.905-.202-.608.51-2.235-.608-1.832-4.58 1.832-9.97 1.426-14.854 1.426-.406 0-.712-.815-1.32-.71-.104 0-.205.303-.308.505'/%3e%3cpath fill='%23000' d='M292.034 155.347c-.508-.406-.61-1.32 0-3.256.712-1.928 0-2.033 1.12-3.152 1.12-1.12.813-1.63 1.525-1.932.71-.206 2.848-.206 3.56-.508.61-.308 1.526-.714 2.948-.916 1.526-.308 4.58-.206 6.003.608 1.527.812 2.545 2.85 3.46 3.56 1.02.71 1.63 3.662 1.427 7.94-.307 4.27-1.12 3.457-1.12 3.457s-1.222-2.034-2.238-.308c0 0 0-1.627.203-2.85.102-1.218-.61-3.457.102-4.984 0 0-5.8 1.832-8.75 1.73-3.052-.203-7.323-.917-7.527-1.627l-.714 2.237'/%3e%3cpath fill='%23fff' stroke='%23fff' d='M294.984 151.797c-.305-.61-1.832-2.85-.61-3.56 1.12-.613.407 2.744 1.936 3.457 0 0-.51 1.526-1.32.102z'/%3e%3cpath d='M298.344 160.137c-.508 1.732-.712 2.138-.916 3.156m10.586 1.624c.204.61.404.303.914.405m.406-3.965c.51-.61 1.22-.303.813 1.223'/%3e%3cpath d='M292.444 157.697c.916.303 1.832.608 2.748 1.02 1.526.61.61 2.845.204 4.27-.204.715-1.02 1.934-.61 2.547.51.81 1.12.303 2.036.403 0-.303.61-.508.813-.508.712-.1 1.12.507 1.627.307.61-.308.51-1.224.306-1.73m-.104-4.479c.102-.403 1.018-.81 1.526-.915 2.136-.405 3.66-.712 5.393.51m-5.699 11.085c-1.73.408-3.56.71-5.188-.206m-.002-.804c.813-.408 1.12-.816 2.137-.308 0-.102 1.12-.406 1.12-.406.813 0 1.323.304 2.137.812m-5.494.302c.916-.306 3.358-.306 5.394.102'/%3e%3cg stroke-width='.305'%3e%3cpath fill='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='.304' d='M292.344 160.137c.713-.1 1.526-.916 3.154.306 1.12.712-1.832 1.426-1.322 1.324-1.32.202-1.73-.508-1.828-1.122 0-.202-.204-.508 0-.508zm8.34.81c.712-1.426 1.832-1.12 2.85-.816 1.018.307.712.106 1.628.614-1.12.203-.814.303-1.63.71-.915.408-1.728.61-2.34.206-.204-.206-.712-.508-.712-.916 0 .1.102.203.204.203z'/%3e%3cpath fill='%23000' d='M293.764 161.357c.406 0 .712-.406.712-.814 0-.508-.306-.916-.712-.916-.507 0-.812.408-.812.916 0 .408.303.814.812.814zm8.65.2c.405 0 .712-.403.712-.916 0-.507-.407-.81-.813-.81-.405 0-.712.303-.712.81 0 .515.408.917.814.917z'/%3e%3c/g%3e%3c/g%3e%3cg id='a'%3e%3cg fill='none'%3e%3cpath d='M345.854 213.657c-.608-.714-1.018-1.02-1.83-1.324-.61-.303-1.424-.71-2.036-1.016-.712-.408-1.73-.508-2.34-.916m.406 2.646c-.306-.203-.508-.304-.812-.51-.306-.1-.712-.1-1.02-.203-.102 0-.102-.204-.203-.204-.916-.102-1.832-.51-2.44-1.32m-62.775-9.363c.914.71 3.152 2.24 3.356 5.19.204 1.525 1.02 3.05 1.02 3.05m-13.126-7.83c.51 1.727.61 7.425 6.003 13.43m-4.983-21.37c-.408 1.12-.916 2.137.202 2.95m14.448 10.69c1.12-2.545 4.578-2.342 4.578-4.782'/%3e%3cpath d='M284.814 207.247c-.306-2.85-.916-4.475-.405-8.647.202-1.223.404-5.9 0-8.14 0 0 1.628 7.832-3.663 9.362m34.388 12.515c0-3.97.916-6.21.916-6.21 1.22-5.592-1.12-7.73-.203-9.154.812-1.22 2.035-3.766.407-8.854 0 0 2.847 10.483-4.478 10.483-7.425 0-7.12-2.748-7.12-2.748'/%3e%3cpath d='M284.404 190.457c0 2.135 0 8.447 9.055 8.447 2.745 0 5.697-1.933 7.323-3.256m2.242-2.751c-.306-1.934-.306-4.375-.306-6.92m-13.634-3.45c2.44-.308 4.376-.61 8.955-.61m.305-6.32c.51 2.24-.304 5.8 3.866 6.31m4.374-7.12c-.61 1.63-.61 3.256-.814 4.375m.204 2.755c1.73 0 4.985-1.12 9.054-.306m1.426 22.786c.813 1.63 1.018 3.765 3.56 6.207m-31.74-11.397c.204 1.324-1.73 5.698-.306 9.262 1.322 3.558 1.12 7.63-1.12 11.088m6.616-19.02c-.813 1.626-2.238 3.256-2.544 4.68m6.604-1.63c0 1.018-2.744 8.75-4.68 10.886 0 0 3.56 1.424 3.05 6.614m7.33-21.06c0 1.324-.204 1.63.916 2.44m2.444 0c1.32 1.628 5.492 6.514 4.576 9.26m-7.326-6.51c.306 1.018.306 6.31-.61 8.955m-2.13-.205c-1.12 0-2.746.814-3.052 2.747m8.742-3.057c1.118-.306 3.355 1.626 3.355 7.123m15.675-10.273c-2.136.61-3.052 1.732-2.44 1.12-1.12.915-2.138 1.525-2.138 1.525'/%3e%3c/g%3e%3cpath fill='%23000' stroke-width='.305' d='M289.794 197.987c.608 0 1.118-.408 1.118-.916 0-.41-.507-.815-1.118-.815-.51 0-1.02.405-1.02.816 0 .506.508.917 1.02.917zm23.1.31c.51 0 1.02-.405 1.02-.916 0-.504-.508-.81-1.02-.81-.607 0-1.118.306-1.118.81 0 .512.51.917 1.118.917z'/%3e%3cpath fill='%23e8e8e6' d='M280.544 239.807c1.22-7.937 4.985-14.55 5.086-15.162 0 0 3.865.816 10.58 1.424 6.612.71 8.444.407 11.496.2 2.95-.302 6.815-.81 6.815-.81s1.222 2.44 1.323 4.883c.305 5.188 2.236 27.677 2.44 33.68 0 0 .813 3.56.813 12.31 0 9.568 2.645 29 2.645 39.382l-2.644.51s-14.446 1.12-14.446-.814c0-2.134-.813-27.065 1.322-42.125 0 0-.508-2.95-1.322-5.496-.813-2.443-4.375-10.074-4.375-11.7 0 0-5.695 16.073-6 18.825-.305 2.543-1.12 38.357-1.63 41.312 0 0-8.24 6.308-9.36 6.92-1.117.51-9.053-3.36-9.257-4.375-.306-1.118.814-13.23 4.578-33.176 1.425-7.123.61-8.44.61-10.375 0-1.933.103-27.473 1.322-35.41z'/%3e%3cpath fill='none' d='M294.274 274.917c-.61 2.24-1.628 4.375-3.56 5.803m-2.75-53.633c-.304 1.322-2.238 7.325-7.122 10.887m14.242-9.767c-1.12 3.562-5.493 22.693-6.31 45.383m-.3 7.127c-.204 2.135-1.322 18.012-1.628 20.756m-.812 3.054c-.51 1.117-2.746 10.375-2.746 18.62m32.246-35.92c-.204 1.933-1.02 15.668 3.56 27.98m-18.51-85.98c-.305 2.237-.813 16.688-.813 17.806 0 1.117 1.63 2.747 2.442 3.054 0 0-1.628.51-1.933 6.003m-4.076-12.923c-.308 1.727-1.934 8.547-3.054 11.295m13.124-25.435s4.884 1.018 5.188 0c0 0 1.628 29.512 3.866 45.89m-11.184-42.13c0 1.934-.61 16.485-.61 16.485m2.44 2.135s1.93 2.745 1.425 4.066m-17.805-28.076c1.63.508 3.053.812 3.053.812m5.187 1.628c-.307.814-.61 4.58-.61 4.58m8.75 38.87c.61.814 1.425 1.936.814 4.377'/%3e%3cpath fill='%23d67c59' d='M284.914 224.447s0-3.256 1.22-4.886c0 0 3.457.715 8.342 1.223 4.984.508 8.95.916 12.615.508 3.664-.405 7.43-1.32 7.43-1.32s1.016 4.783.505 5.495c0 0-3.968.814-8.34 1.016-4.478.304-11.903-.407-14.446-.81-3.36-.41-6.31-1.02-7.326-1.223z'/%3e%3cpath fill='%23fff' d='m288.064 224.847.608-4.883 1.02.1-.204 5.088zm22.08-4.07.103 5.496 1.22-.206-.1-5.597zm-15.67 0-.406 5.29h.713l.713-5.29z'/%3e%3cpath fill='%23653024' d='M276.774 320.807c-.305 1.322-.812 3.154-1.018 5.496 0 .508-.507 3.256 1.018 3.356 1.12.102 1.425-2.85 1.425-2.85s-1.02 3.256.304 3.664c1.832.403 2.034-3.562 2.034-3.562-.204 1.12-1.425 3.97.306 4.27 1.83.308 2.34-3.866 2.34-3.866s-1.526 4.174.304 4.275c1.73.1 1.73-4.07 1.73-4.07s-.917 4.987 1.525 4.58c1.32-.204 1.628-1.935 1.933-2.952.406-1.524 1.322-3.457.204-6.612-.812-2.34-.507-2.95-.507-2.95s-2.85 2.137-5.087 3.56c-1.02.61-6.514-2.34-6.514-2.34zm29.71-4.38c-.508-.307-.406 1.832-.61 2.846-.102 1.02.205 3.257 3.664 3.055 3.355-.307 6.715-1.018 8.85-.51 2.138.61 5.29.712 7.022.712 1.73 0 2.85-.202 3.66-.51.714-.302 2.24.41 2.95.41.714 0 1.832-1.12 1.73-1.833-.102-1.324-1.32-1.324-3.053-1.424-1.628-.203-3.865-.51-4.983-.916-1.12-.408-3.154-1.527-5.698-2.035 0 0-4.883.205-5.898.205-1.02 0-7.022.303-7.634 0z'/%3e%3c/g%3e%3cg fill='%23ad7c59' stroke-linecap='round'%3e%3cpath stroke-linejoin='round' d='M255.714 189.847c-.507.306-1.12-2.035.406-2.95 0 0 .406-1.932 2.035-2.137 0 0 1.32-1.832 3.257-1.626 0 0 2.235-1.525 3.05-1.324.813.102 2.85 2.136 2.95 2.85.205.71 0 1.933-.51 2.442-.61.608-1.018-.102-1.12-.916 0 0 .408 1.524-.812 2.135-1.22.715-1.12.207-1.22-.61 0 0-.307 1.63-1.12 1.833-.813.305-1.32-.408-1.934-.408 0 0 1.02.816.307 1.426-.713.51-1.526.304-2.036-.1-.51-.51-1.12-1.833-3.257-.61z'/%3e%3cpath d='M265.684 186.087c-.51-1.63-2.137-3.054-4.07-2.848m2.24 4.368c-.306-.408-.408-.816-.712-1.22-.916-1.528-2.85-1.424-4.477-1.832m2.439 4.582c-.61-.406-.813-1.222-1.425-1.524-1.02-.408-2.035-.916-3.256-.714'/%3e%3c/g%3e%3c/g%3e%3cg transform='translate(-4.86 22.637) scale(1.12001)'%3e%3cpath fill='%23653024' d='M439.14 165.12c.712-.306.51.61.61.916.306 1.32.306 2.748.813 3.967.608 1.12.812 1.526 1.83 2.035 1.627.916 6.407 3.562 9.767 1.424.204-.1.508-.306.712-.508 0 0-1.22 4.172 2.95 6.207 1.32.71 15.668 8.242 15.668 8.242s1.525 2.748.61 6.512c-.205.61-.406 1.118.203 1.526 1.02.71 2.644 2.748 3.766 6.004 0 0 2.946-1.324 2.946-3.256 0-1.934-1.22-2.95-1.525-4.375-.2-1.324-1.016-4.682-.607-5.698.405-1.118 2.135-1.526 2.847-1.936.714-.41 1.526.405 1.322 1.32-.102 1.02-.812.817-1.628 1.02 0 0 1.02 1.93.814 3.355l9.358 4.783s-1.22 1.63-1.628 2.34c-.51.715-1.425 10.175-4.17 14.653-2.75 4.478-3.664 3.257-4.172 3.867-.61.508-1.424 1.324-2.137 1.934-.61.51-3.765.815-4.477-.915-.712-1.628-1.22-2.647-3.153-4.174-1.934-1.523-5.9-5.39-5.9-7.122 0 0-2.34 6.72-2.035 12.313 0 0-8.443 1.732-16.176 1.937-7.632.102-11.498-1.528-11.498-1.528s-1.018-6.41-.61-7.632c0 0-1.22 4.172-2.033 5.596-1.12 1.727-2.237 5.29-4.376 5.493-2.236.104-3.968-2.135-4.27-3.05v-6.717h-8.647c0-.1-3.766 1.424-5.087 1.223-1.22-.105-1.832-1.223-.813-1.63l.407-.304c-1.12 0-2.544.71-2.544.71h-4.272c0-.102.103-.41.103-.51.308-1.218 2.546-2.24 4.273-2.95 1.628-.608 3.356-1.323 4.578-1.423 1.934-.203 3.257-.1 6.207.408.812.1 3.967.408 5.798 1.322.508.304 1.118.405.813-.915-.305-1.426-1.22-5.598.307-8.346 1.018-1.933.916-3.56.813-5.19-.204-1.728-1.118-5.597-1.118-7.324 0-5.7 4.375-8.04 8.24-9.262 4.272-1.32 7.12-2.748 6.92-5.288-.104-2.646.608-7.02.202-9.058'/%3e%3cg fill='none'%3e%3cpath fill='%23653024' d='M456.34 153.63c.916 3.356 1.12 4.17 1.12 5.29 0 1.22-.51 1.425-.104 2.75.713 2.44-.712 5.087-2.44 7.936-.814 1.32-1.425 3.052-2.747 3.866-3.357 2.135-7.428-.408-9.564-1.327-1.117-.505-1.73-1.32-2.033-2.135-.407-1.22-.51-2.34-.813-3.967 0-.306.103-1.22-.61-.916-1.22-1.424-1.017-2.034-1.523-3.05-.51-1.022.916-2.14 2.034-1.935-.61-1.933-.915-4.072-.305-5.904.204-.608-.508-2.235.51-1.832 4.577 1.832 9.97 1.426 14.854 1.426.403 0 .71-.812 1.32-.71.097 0 .2.305.3.508'/%3e%3cpath fill='%23000' d='M456.75 155.35c.508-.406.204-2.34-.306-4.375-.203-1.017-1.018-1.424-2.136-2.542-1.12-1.122-1.525-1.122-2.236-1.424-.61-.207-2.034-.207-2.746-.51-.61-.307-2.238-.104-3.766.102-2.036.304-3.153.202-4.68 1.018-1.525.814-2.745 1.73-3.255 3.256-.406 1.118-1.12 2.542-.814 6.817.205 4.272 1.02 3.458 1.02 3.458s1.12-1.627 1.832-.61c0 0-.103-2.24-.305-3.56-.103-1.222 0-2.748.51-4.58 0 0 4.678 1.732 9.053 1.732 3.053 0 7.02-.306 7.123-1.017l.71 2.235z'/%3e%3cpath d='M450.44 160.14c.61 1.732.104 1.222.408 2.34m-10.278 2.03c0 .812-.61.61-1.02.61'/%3e%3cpath d='M456.85 158.82c-.916-.713-2.645-.204-3.46.102-1.525.71-.712 2.24-.204 3.664.204.71 1.02 1.727.51 2.44-.406.813-.712.41-1.628.51.104-.307-.812 0-1.117 0-.61-.1-.915.404-1.425.203-.608-.305-.508-1.22-.306-1.73m.1-4.479c0-.403-1.32-.81-2.745-.915-2.238-.102-2.442.104-4.172 1.322m11.497 8.953c-.405-.608-1.018-.916-2.137-.405 0-.204-1.524-.406-1.524-.406-.813 0-1.322.302-2.137.71m5.588.611c-.916-.61-3.256-.2-5.596-.2m.206.81c1.73.512 3.46.816 5.188 0'/%3e%3cg stroke-width='.305'%3e%3cpath fill='%23fff' stroke-linecap='round' stroke-linejoin='round' d='M456.44 160.14c-.712-.1-1.018-.916-3.153.306-1.12.61 1.832 1.426 1.425 1.324 1.22.202 1.628-.508 1.73-1.122-.002-.203.202-.508-.002-.508zm-8.34.81c0-.816-1.83-1.12-2.847-.816-1.02.306-.61.105-1.526.613 1.02.203.712.303 1.526.71.914.408 1.12.814 2.34.206.305-.105.71-.508.812-.916-.1.1-.202.203-.305.203z'/%3e%3cpath fill='%23000' d='M455.12 161.36a.802.802 0 0 1-.813-.814c0-.508.307-.916.813-.916.405 0 .712.408.712.916 0 .408-.307.814-.712.814zm-8.75.2c-.406 0-.712-.403-.712-.916 0-.508.403-.81.812-.81.41 0 .712.302.712.81 0 .514-.303.916-.812.916z'/%3e%3c/g%3e%3c/g%3e%3cuse xlink:href='%23a' width='100%25' height='100%25' fill='%23d67c59' transform='matrix(-1 0 0 1 748.816 0)'/%3e%3cg fill='%23653024'%3e%3cpath stroke-linecap='round' d='M491.64 193.51c.508.206 1.934-2.033.508-3.05 0 0-.508-1.933-2.136-2.035 0 0-1.322-1.933-3.257-1.63 0 0-2.136-1.524-2.948-1.42-.916.2-2.95 2.236-3.053 2.95-.102.608 0 1.83.508 2.44.61.51 1.02-.104 1.12-1.02 0 0-.406 1.53.812 2.24 1.22.71 1.12.1 1.22-.71 0 0 .307 1.626 1.12 1.932.813.303 1.322-.408 1.935-.408 0 0-1.02.814-.306 1.323.713.61 1.525.303 2.035-.104.61-.405.305-1.728 2.44-.51z'/%3e%3cpath stroke-linecap='round' stroke-linejoin='round' d='M482.49 189.75c.506-1.73 2.235-3.153 4.067-2.85m-2.137 4.38c.203-.41.305-.816.61-1.224.915-1.524 2.948-1.524 4.576-1.832m-2.546 4.476c.61-.408.814-1.118 1.426-1.42 1.018-.513 2.136-.917 3.256-.715'/%3e%3cpath stroke='none' d='M482.31 186.77c-.896.716-1.837 1.798-1.906 2.28-.103.61-.008 1.828.5 2.44.55.46.95-.018 1.095-.782-.06.463-.072 1.465.843 2 1.22.71 1.118.095 1.22-.72 0 0 .31 1.636 1.124 1.94.813.305 1.325-.407 1.938-.407 0 0-1.026.805-.312 1.313.712.61 1.522.31 2.03-.094.61-.41.3-1.723 2.44-.5.266.105.803-.453 1.03-1.157l-7.688-5.53z'/%3e%3cpath d='M480.68 188.19c-1.502 2.582.5 4.132 1.164 2.62-.193 2.385 1.606 2.29 2.285 1.537.657 2.512 1.83 1.395 2.908 1.164-1.223 2.29 1.48 1.61 2.12 1.082.924-1.362 1.356-.277 2.036-.416l1.164-1.247m-7.977-5.7c-1.686.896-2.512 2.137-2.535 3.7m4.865-2.2c-1.687.896-2.512 2.137-2.535 3.7m5.405-1.75c-1.687.897-1.765 1.722-2.493 2.826'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg fill='%23ffe682'%3e%3cpath d='M414.517 444.859c25.64.23 40.796-9.117 49.113-14.702 19.484-13.104 23.587-13.56 26.78-13.335 3.646.347 8.997 1.598 9.228 4.79.342 4.9-7.635 7.065-12.194 7.065-4.67 0-16.866-3.078-16.866-3.078l-3.192 2.168c2.166 1.027 27.122 9.343 31.907 1.482 4.897-7.978 9.8-20.858 9.8-20.858s-5.47-9.8-17.665-9.8c-12.306 0-24.27 7.75-32.245 13.558-7.979 5.813-18.004 13.79-44.67 13.79-26.663 0-36.804-7.977-44.779-13.79-7.974-5.81-19.941-13.559-32.133-13.559-12.304 0-17.774 9.8-17.774 9.8s4.898 12.88 9.798 20.859c4.784 7.86 29.742-.458 31.903-1.484l-3.076-2.168s-12.305 3.078-16.865 3.078c-4.673 0-12.649-2.164-12.306-7.064.228-3.192 5.582-4.446 9.228-4.789 3.192-.224 7.295.231 26.778 13.335 8.322 5.584 23.477 14.588 49.23 14.702'/%3e%3cpath d='M373.267 414.652s0-2.17-.345-5.357c-.455-4.103-2.847-5.13-4.783-4.558-1.254.45-3.76 3.533-3.76 3.533v.115a36.247 36.247 0 0 0-3.533-2.166c.912-1.026 6.154-4.216 7.406-4.216 1.143 0 16.866 6.38 21.877 10.71 1.254 1.142 2.167 8.207 1.48 10.483-8.43-2.164-13.9-5.354-18.346-8.432v-.114m-7.522 15.962s-3.42 3.416-3.532 9.686c-.115 7.407 5.242 7.75 8.774 7.635 4.217-.116 7.633-2.506 7.521-10.37 0 0-6.953-2.965-12.764-6.952m89.915-15.959s.115-2.17.458-5.357c.45-4.103 2.731-5.13 4.67-4.558 1.253.45 3.759 3.533 3.759 3.533v.115a36.077 36.077 0 0 1 3.53-2.166c-.91-1.026-6.15-4.216-7.292-4.216-1.252 0-16.975 6.38-21.99 10.71-1.143 1.142-2.053 8.207-1.48 10.483 8.545-2.164 13.899-5.354 18.345-8.432v-.114m7.516 15.962s3.418 3.416 3.532 9.686c.228 7.407-5.244 7.75-8.773 7.635-4.219-.116-7.521-2.506-7.521-10.37 0 0 6.951-2.965 12.763-6.952'/%3e%3c/g%3e%3cpath fill='%23171696' d='M358.336 425.594s-12.193 3.079-16.75 3.079c-4.67 0-12.648-2.162-12.305-7.066.23-3.192 5.584-4.442 9.23-4.784 2.734-.232 6.268.112 19.827 8.771m112.247 0s12.191 3.079 16.865 3.079c4.558 0 12.532-2.162 12.19-7.066-.225-3.192-5.58-4.442-9.228-4.784-2.736-.232-6.268.112-19.827 8.771m-97.318-10.83c-1.254-.911-2.507-1.826-3.65-2.733-1.707-1.256-3.417-2.397-5.24-3.647 0 0 2.505-3.192 3.758-3.535 1.937-.683 4.329.339 4.782 4.443.345 3.192.345 5.475.345 5.475m-8.317 32.141c2.169 1.255 4.559 1.143 6.042 1.027 4.217-.115 7.634-2.507 7.52-10.37 0 0 5.24 2.621 13.788 4.673 0 0 1.367 1.708 1.593 5.126.346 2.852-1.595 5.925-3.871 5.7 0 0-11.966-2.166-19.257-3.415-4.218-.798-5.813-2.738-5.813-2.738m90.708-32.147c1.252-.911 2.506-1.826 3.758-2.733 1.596-1.256 3.304-2.397 5.127-3.647 0 0-2.505-3.192-3.759-3.535-1.937-.683-4.217.339-4.67 4.443-.344 3.19-.458 5.474-.458 5.474m8.313 32.142c-2.166 1.255-4.559 1.143-6.04 1.027-4.217-.115-7.52-2.507-7.52-10.37 0 0-5.242 2.621-13.676 4.673 0 0-1.479 1.708-1.708 5.126-.227 2.852 1.71 5.925 3.875 5.7 0 0 12.078-2.166 19.257-3.415 4.217-.798 5.81-2.738 5.81-2.738'/%3e%3cg fill='none' stroke='%23000' stroke-width='.797'%3e%3cpath d='M414.517 444.859c25.64.227 40.796-9.12 49.113-14.702 19.484-13.104 23.587-13.559 26.777-13.333 3.648.341 9.004 1.596 9.228 4.786.345 4.9-7.633 7.063-12.193 7.063-4.67 0-16.864-3.073-16.864-3.073l-3.19 2.166c2.166 1.027 27.118 9.345 31.904 1.479 4.9-7.977 9.798-20.855 9.798-20.855s-5.47-9.803-17.663-9.803c-12.305 0-24.27 7.753-32.247 13.564-7.975 5.812-18 13.789-44.667 13.789-26.663 0-36.803-7.978-44.778-13.79-7.976-5.81-19.943-13.563-32.133-13.563-12.305 0-17.774 9.804-17.774 9.804s4.897 12.877 9.798 20.855c4.785 7.862 29.742-.454 31.904-1.479l-3.074-2.167s-12.309 3.073-16.864 3.073c-4.674 0-12.65-2.16-12.309-7.064.23-3.192 5.584-4.444 9.231-4.788 3.188-.226 7.291.23 26.776 13.334 8.322 5.586 23.475 14.59 49.227 14.702z'/%3e%3cpath d='M358.336 425.594s-12.194 3.079-16.747 3.079c-4.673 0-12.65-2.166-12.31-7.066.23-3.192 5.585-4.446 9.231-4.784 2.733-.232 6.267.112 19.827 8.771zm112.238 0s12.193 3.079 16.865 3.079c4.558 0 12.532-2.166 12.193-7.066-.23-3.192-5.582-4.446-9.227-4.784-2.735-.232-6.27.114-19.827 8.771zm-97.307-10.83c-1.254-.911-2.507-1.826-3.65-2.733-1.704-1.256-3.415-2.397-5.24-3.647 0 0 2.508-3.192 3.76-3.535 1.937-.683 4.328.339 4.782 4.447.347 3.185.347 5.469.347 5.469z'/%3e%3cpath d='M373.267 414.652s0-2.168-.345-5.357c-.453-4.103-2.847-5.13-4.783-4.558-1.254.455-3.763 3.533-3.763 3.533v.115a37.196 37.196 0 0 0-3.53-2.166c.91-1.026 6.152-4.216 7.406-4.216 1.143 0 16.865 6.38 21.878 10.713 1.254 1.143 2.165 8.204 1.48 10.485-8.434-2.17-13.902-5.36-18.35-8.433m-7.52 15.844s-3.415 3.416-3.53 9.686c-.115 7.404 5.241 7.749 8.773 7.635 4.217-.116 7.632-2.506 7.523-10.374 0 0-6.952-2.963-12.763-6.952z'/%3e%3cpath d='M368.597 432.315s-2.733 2.848-3.19 7.52c-.227 3.649 2.165 5.698 5.242 5.47 4.329-.224 6.04-6.15 3.987-9.457z'/%3e%3cpath d='M364.945 446.908c2.167 1.255 4.556 1.14 6.04 1.027 4.216-.117 7.631-2.509 7.522-10.371 0 0 5.243 2.62 13.788 4.672 0 0 1.369 1.708 1.593 5.13.345 2.848-1.593 5.925-3.87 5.696 0 0-11.967-2.166-19.258-3.416-4.22-.801-5.815-2.736-5.815-2.736zm90.71-32.144c1.255-.911 2.506-1.826 3.76-2.733 1.597-1.256 3.304-2.397 5.13-3.647 0 0-2.507-3.192-3.762-3.535-1.937-.683-4.216.339-4.67 4.447a104.806 104.806 0 0 0-.455 5.469h-.002z'/%3e%3cpath d='M455.655 414.652s.115-2.168.458-5.357c.452-4.103 2.731-5.13 4.67-4.558 1.253.455 3.759 3.533 3.759 3.533v.115a37.196 37.196 0 0 1 3.531-2.166c-.91-1.026-6.151-4.216-7.293-4.216-1.254 0-16.975 6.38-21.99 10.713-1.143 1.143-2.053 8.204-1.48 10.485 8.545-2.17 13.899-5.36 18.345-8.433m7.516 15.844s3.418 3.416 3.532 9.686c.228 7.404-5.244 7.749-8.775 7.635-4.216-.116-7.52-2.506-7.52-10.374 0 0 6.95-2.963 12.763-6.952z'/%3e%3cpath d='M460.326 432.315s2.734 2.848 3.192 7.52c.342 3.649-2.168 5.698-5.245 5.47-4.329-.224-5.925-6.15-3.987-9.457z'/%3e%3cpath d='M463.966 446.908c-2.166 1.255-4.559 1.14-6.04 1.027-4.215-.117-7.518-2.509-7.518-10.371 0 0-5.244 2.62-13.674 4.672 0 0-1.48 1.708-1.708 5.13-.228 2.848 1.708 5.925 3.875 5.696 0 0 12.077-2.166 19.253-3.416 4.218-.801 5.813-2.736 5.813-2.736z'/%3e%3c/g%3e%3cpath fill='none' stroke='%23fff' stroke-width='.797' d='M391.389 444.287s3.76 2.739-.798 6.157m-10.482-7.982 11.51 5.016m-9.582-2.395 8.429 3.644m-5.461-5.805 6.38 2.852m46.26-1.487s-3.875 2.739.684 6.157m10.483-7.982-11.51 5.016m9.684-2.395-8.43 3.644m5.362-5.805-6.268 2.852'/%3e%3cg stroke='%23000'%3e%3cpath stroke-width='.784' d='M346.33 409.231c.164.265.27.541.32.825.042.29.03.612-.034.969-.163.847-.616 1.48-1.352 1.917-.74.435-1.587.554-2.524.375a4.293 4.293 0 0 1-1.269-.45 5.074 5.074 0 0 1-1.035-.694c-.125.15-.258.291-.39.44l-.546-.104c.175-1.103.349-2.206.532-3.309.179.034.366.068.554.107.034.427.105.815.195 1.173.086.358.235.698.431 1.036.187.308.423.577.717.794.285.217.639.37 1.059.446.315.063.597.073.854.034.246-.037.464-.112.632-.235a1.54 1.54 0 0 0 .43-.467 2.06 2.06 0 0 0 .236-.674 1.994 1.994 0 0 0-.123-1.136c-.152-.376-.442-.686-.84-.94a59.324 59.324 0 0 0-.947-.586 13.235 13.235 0 0 1-.918-.589c-.5-.347-.87-.739-1.094-1.202-.229-.45-.288-.993-.166-1.63a2.386 2.386 0 0 1 .423-.975 2.64 2.64 0 0 1 .803-.725 2.946 2.946 0 0 1 1.048-.378 3.369 3.369 0 0 1 1.168.019c.445.083.84.23 1.168.432.324.205.623.417.878.658l.37-.403c.183.033.363.067.548.105l-.551 3.196c-.184-.037-.37-.07-.557-.107a13.109 13.109 0 0 0-.135-1.114 4.15 4.15 0 0 0-.32-1 2.267 2.267 0 0 0-.601-.766c-.25-.21-.586-.35-1.002-.431a1.607 1.607 0 0 0-1.19.205c-.355.224-.576.521-.651.919-.078.411-.043.774.103 1.086.141.316.385.59.728.84.302.224.61.416.91.596.3.179.583.358.863.548.25.167.497.348.72.55.217.196.407.414.553.645m13.98 1.96a4.208 4.208 0 0 0-.542-.203 1.64 1.64 0 0 0-.65-.1c-.19.017-.388.158-.6.415a6.62 6.62 0 0 0-.667 1.02c-.683 1.239-1.372 2.48-2.054 3.722-.262.472-.589.828-.984 1.07a2.94 2.94 0 0 1-1.265.425 3.784 3.784 0 0 1-1.277-.086 4.857 4.857 0 0 1-1.102-.43c-.518-.286-.952-.604-1.284-.966-.332-.367-.582-.735-.724-1.118a2.597 2.597 0 0 1-.182-1.134 2.417 2.417 0 0 1 .302-1.034l2.795-5.062a1.055 1.055 0 0 0 .127-.398c.002-.115-.05-.257-.146-.414a1.747 1.747 0 0 0-.314-.357c-.143-.116-.255-.21-.358-.275l.235-.43c1.21.667 2.41 1.331 3.618 1.994l-.237.426a3.621 3.621 0 0 0-.46-.18 2.255 2.255 0 0 0-.433-.123c-.165-.024-.303 0-.41.094-.111.09-.2.192-.274.324-.87 1.58-1.742 3.155-2.611 4.733a3.888 3.888 0 0 0-.314.762c-.094.28-.121.571-.092.87.034.314.157.605.35.896.198.291.537.568 1.01.829.445.246.863.388 1.244.417.379.022.72-.022 1.023-.157a2.318 2.318 0 0 0 .728-.487 2.957 2.957 0 0 0 .498-.659l1.938-3.513c.246-.448.419-.83.508-1.154.093-.319.096-.548.022-.712-.082-.183-.24-.37-.45-.557a4.14 4.14 0 0 0-.518-.41l.235-.426c1.184.65 2.365 1.302 3.55 1.956l-.234.43m5.028 8.705c.152.311.24.653.247 1.015.005.364-.1.741-.323 1.131-.224.392-.506.684-.851.878a2.548 2.548 0 0 1-1.092.324 3.427 3.427 0 0 1-1.151-.107 4.704 4.704 0 0 1-1.143-.465l-4.068-2.342.246-.426c.101.051.247.112.452.19a2 2 0 0 0 .45.141.63.63 0 0 0 .399-.074.83.83 0 0 0 .284-.314c1.17-2.027 2.34-4.062 3.509-6.09a1.098 1.098 0 0 0 .14-.398.65.65 0 0 0-.133-.41 1.958 1.958 0 0 0-.326-.37c-.135-.117-.243-.212-.342-.277.078-.14.163-.282.244-.422 1.32.758 2.64 1.519 3.964 2.283.307.177.583.373.833.594.242.224.448.481.616.776.157.278.251.583.26.907a1.88 1.88 0 0 1-.27 1.008 2.106 2.106 0 0 1-.623.695 1.966 1.966 0 0 1-.806.34 2.97 2.97 0 0 1-.866.033 3.879 3.879 0 0 1-.927-.194l-.034.056a5.8 5.8 0 0 1 .725.655c.251.275.452.56.59.863zm-.73-2.12c.254-.089.462-.212.636-.382a3.257 3.257 0 0 0 .504-.672c.265-.466.347-.907.243-1.321-.1-.422-.437-.784-.992-1.105-.126-.071-.291-.166-.488-.273-.202-.112-.37-.2-.495-.265l-1.882 3.262c.255.146.506.291.764.437.334.193.638.313.923.367.286.05.549.039.789-.05zm-.713 3.187a1.893 1.893 0 0 0 .201-1.527c-.153-.522-.55-.96-1.189-1.328a40.245 40.245 0 0 0-.654-.37c-.18-.095-.317-.164-.408-.212-.576 1.001-1.146 1.993-1.72 2.988a.724.724 0 0 0-.023.744c.132.247.381.473.753.684.597.347 1.159.444 1.678.28.52-.168.97-.58 1.36-1.258zm22.063 5.037a4.032 4.032 0 0 0-.56-.148 1.669 1.669 0 0 0-.654-.033c-.187.033-.37.195-.559.472a6.843 6.843 0 0 0-.561 1.08l-1.674 3.91c-.213.496-.504.884-.87 1.164a3.002 3.002 0 0 1-1.218.55 3.763 3.763 0 0 1-1.278.036 4.784 4.784 0 0 1-1.143-.314c-.541-.233-1.003-.51-1.372-.837-.368-.333-.65-.672-.833-1.04a2.597 2.597 0 0 1-.292-1.108 2.429 2.429 0 0 1 .196-1.064l2.278-5.313a1.053 1.053 0 0 0 .09-.404.829.829 0 0 0-.185-.4 1.864 1.864 0 0 0-.351-.324c-.153-.1-.274-.185-.381-.239l.19-.448 3.797 1.626c-.067.148-.129.299-.195.446a4.026 4.026 0 0 0-.473-.134 2.693 2.693 0 0 0-.444-.079c-.168-.01-.302.03-.399.131a1.113 1.113 0 0 0-.239.352c-.71 1.656-1.419 3.31-2.126 4.968a3.957 3.957 0 0 0-.243.784 2.078 2.078 0 0 0 0 .88c.066.307.214.585.438.855.226.269.588.514 1.088.725.469.204.9.3 1.284.292.375-.015.713-.093.996-.258.27-.155.504-.336.68-.554a2.98 2.98 0 0 0 .432-.706c.526-1.232 1.053-2.457 1.58-3.687.2-.471.332-.868.391-1.196.056-.33.04-.558-.051-.711-.1-.176-.274-.345-.504-.51a4.342 4.342 0 0 0-.554-.358l.19-.447 3.726 1.595a14.41 14.41 0 0 0-.195.445m10.716 12.59c-1.4-.404-2.804-.811-4.205-1.217l.134-.47c.157.038.354.078.602.123.243.039.422.05.527.032a.945.945 0 0 0 .39-.205.83.83 0 0 0 .213-.376l1.975-6.836a1.608 1.608 0 0 0-.102-.028c-1.84 2.367-3.722 4.698-5.565 7.067-.11-.03-.218-.065-.334-.096-.224-3.024-.507-6.044-.73-9.064a.83.83 0 0 0-.089-.025c-.539 1.87-1.082 3.738-1.62 5.611-.157.538-.24.956-.252 1.266-.017.305.036.536.138.7.071.124.252.267.538.443.283.177.47.275.564.308l-.137.47-3.844-1.11c.045-.159.092-.316.137-.471.207.037.431.069.667.083.235.018.422-.002.574-.07.19-.082.35-.232.49-.477.13-.24.281-.656.454-1.255l1.389-4.81c.08-.276.112-.51.097-.709a1.107 1.107 0 0 0-.163-.514 1.432 1.432 0 0 0-.435-.41 2.38 2.38 0 0 0-.571-.275l.134-.47 3.241.938c.213 2.616.485 5.23.695 7.847 1.33-1.75 2.699-3.475 4.032-5.226.15-.195.291-.397.419-.622a3.304 3.304 0 0 0 .233-.445c1.033.298 2.072.598 3.103.899l-.135.467a4.5 4.5 0 0 0-.493-.075 2.783 2.783 0 0 0-.457-.027.513.513 0 0 0-.385.18 1.093 1.093 0 0 0-.196.379l-1.96 6.776a.923.923 0 0 0-.034.41c.025.122.1.241.229.367.069.07.201.15.396.244.197.1.35.165.47.208a33.1 33.1 0 0 0-.138.466m10.185-3.093c.258.23.474.51.62.843s.2.722.143 1.165a2.352 2.352 0 0 1-.444 1.14 2.677 2.677 0 0 1-.881.722 3.554 3.554 0 0 1-1.107.35 4.712 4.712 0 0 1-1.234.011c-1.552-.195-3.103-.392-4.655-.585l.06-.487c.113.007.273.007.494 0 .214-.002.375-.019.47-.045a.61.61 0 0 0 .338-.224.842.842 0 0 0 .143-.396c.29-2.324.582-4.648.875-6.975a1.131 1.131 0 0 0-.022-.42.665.665 0 0 0-.283-.327 1.938 1.938 0 0 0-.445-.215c-.171-.056-.305-.103-.421-.124l.06-.485 4.542.572c.35.045.679.12 1 .23.308.111.597.265.865.475.25.195.46.44.594.736.134.299.182.64.134 1.032a2.025 2.025 0 0 1-.913 1.51c-.238.16-.504.274-.787.365a3.976 3.976 0 0 1-.93.182l-.01.062c.28.07.585.175.923.325.33.15.627.336.87.562zm-1.494-1.672c.198-.178.347-.374.443-.598a3.23 3.23 0 0 0 .202-.817c.067-.531-.028-.963-.287-1.31-.257-.35-.701-.553-1.342-.633a31.808 31.808 0 0 0-.551-.066l-.57-.053c-.156 1.245-.31 2.491-.47 3.735.295.036.585.072.874.11a2.987 2.987 0 0 0 .998-.02 1.51 1.51 0 0 0 .702-.35zm.576 3.217c.07-.574-.067-1.064-.403-1.487-.346-.423-.88-.672-1.61-.764a28.652 28.652 0 0 0-.748-.087 14.039 14.039 0 0 0-.463-.042c-.145 1.145-.286 2.283-.43 3.424a.73.73 0 0 0 .269.695c.216.174.537.287.96.34.684.09 1.237-.038 1.651-.392.416-.359.674-.911.773-1.684zm13.34 3.081h-2.675c-.582-.924-1.125-1.7-1.593-2.374-.479-.669-1.003-1.342-1.559-2.057h-1.014v3.102c0 .157.03.302.076.418.05.123.163.218.33.284.083.033.23.06.44.09.21.026.388.041.531.048v.49h-4.188v-.49c.11-.007.27-.026.49-.049a1.76 1.76 0 0 0 .44-.09.597.597 0 0 0 .304-.26.866.866 0 0 0 .09-.442v-7.072c0-.157-.02-.302-.067-.43-.05-.12-.157-.216-.33-.28a2.598 2.598 0 0 0-.454-.115 3.536 3.536 0 0 0-.474-.064v-.49h4.575c.418 0 .81.038 1.181.124.37.091.699.224.997.414.286.187.523.416.691.717.17.296.258.653.258 1.075 0 .381-.058.708-.172.999a2.068 2.068 0 0 1-.52.75c-.204.206-.461.363-.752.513a6.034 6.034 0 0 1-.97.371c.482.643.899 1.172 1.222 1.611.315.437.724.961 1.187 1.59a2.946 2.946 0 0 0 1.049.934c.117.066.273.104.453.136.184.034.336.05.454.056-.002.16-.002.325-.002.49zm-3.674-7.287c0-.59-.18-1.052-.516-1.41-.34-.348-.83-.518-1.46-.518h-1.187v4.19h.915c.642 0 1.185-.192 1.606-.606.422-.412.644-.957.644-1.655zm15.086 6.559-4.11.314a26.57 26.57 0 0 0-.037-.493 4.03 4.03 0 0 0 .9-.206c.229-.088.343-.178.335-.28-.004-.042-.017-.088-.026-.15a.541.541 0 0 0-.052-.158c-.323-.708-.663-1.41-.989-2.121l-3.468.261a12.07 12.07 0 0 0-.25.864c-.064.249-.123.472-.17.677a4.179 4.179 0 0 0-.09.49 1.616 1.616 0 0 0-.012.305c.011.183.168.308.47.392.3.083.633.112 1.004.105l.037.491-3.722.282c-.011-.164-.022-.328-.037-.49a2.33 2.33 0 0 0 .446-.115 1.447 1.447 0 0 0 .433-.209c.18-.141.31-.28.403-.428a2.184 2.184 0 0 0 .256-.578c.392-1.262.859-2.673 1.331-4.248.472-1.572.924-2.968 1.292-4.195l.558-.041c1.29 2.73 2.637 5.43 3.931 8.156.083.175.176.31.269.417.1.107.228.205.396.294.112.058.252.101.429.128.176.034.318.045.437.041.015.168.028.334.038.498zm-4.276-3.687c-.586-1.22-1.199-2.436-1.788-3.662-.385 1.3-.8 2.59-1.189 3.888zm18.332-7.715-.499.135c-.193-.327-.493-.64-.896-.964-.406-.32-.756-.459-1.042-.429a6.87 6.87 0 0 0-.504.095c-.196.048-.41.101-.658.166l-1.601.436c.342 1.264.683 2.53 1.026 3.79.364-.101.733-.202 1.099-.3.328-.09.586-.191.75-.314a1.254 1.254 0 0 0 .381-.442 1.43 1.43 0 0 0 .125-.53 2.744 2.744 0 0 0-.032-.697l.504-.137c.34 1.24.675 2.477 1.009 3.712-.165.045-.336.09-.504.138a3.341 3.341 0 0 0-.318-.63c-.153-.223-.287-.38-.407-.466a1.02 1.02 0 0 0-.593-.206 2.666 2.666 0 0 0-.769.115l-1.097.299.88 3.25a.858.858 0 0 0 .2.37c.087.098.213.156.381.192.079.018.236.011.47-.011a3.21 3.21 0 0 0 .53-.068l.128.474-4.144 1.124-.129-.474c.135-.043.312-.11.53-.192.212-.084.355-.142.416-.194a.594.594 0 0 0 .224-.336.943.943 0 0 0-.02-.435l-1.847-6.81a1.281 1.281 0 0 0-.18-.373c-.078-.095-.21-.155-.386-.187a2.834 2.834 0 0 0-.524-.023 2.755 2.755 0 0 0-.517.056l-.128-.475 7.5-2.033.64 2.37m11.046-.836c.363.904.716 1.81 1.08 2.71l-6.978 3.37-.213-.442c.098-.056.235-.14.42-.258.175-.11.297-.202.353-.269a.592.592 0 0 0 .165-.373.907.907 0 0 0-.112-.432c-1.014-2.101-2.027-4.203-3.044-6.306a1.091 1.091 0 0 0-.25-.339.594.594 0 0 0-.416-.116 1.86 1.86 0 0 0-.476.044 2.251 2.251 0 0 0-.47.124c-.068-.146-.143-.297-.211-.443l3.765-1.819.213.444a3.334 3.334 0 0 0-.422.278 2.552 2.552 0 0 0-.359.3.48.48 0 0 0-.168.394c0 .146.038.287.106.422l2.856 5.917c.13.27.242.475.347.61a.616.616 0 0 0 .363.262c.126.035.294.012.497-.066.204-.067.476-.183.817-.351.157-.073.311-.159.48-.247.166-.084.314-.184.453-.276.134-.1.25-.201.355-.305a.687.687 0 0 0 .193-.293c.075-.275.148-.655.186-1.16.034-.492.051-.881.023-1.164.149-.07.298-.143.446-.213m5.22-9.69a4.883 4.883 0 0 1 1.71.878 6 6 0 0 1 1.398 1.636c.397.672.638 1.34.75 2.012a4.85 4.85 0 0 1-.078 1.93 4.608 4.608 0 0 1-.781 1.646 4.555 4.555 0 0 1-1.393 1.24c-.593.349-1.202.571-1.839.64-.639.067-1.246.032-1.837-.155a4.72 4.72 0 0 1-1.677-.896 5.864 5.864 0 0 1-1.347-1.57 5.796 5.796 0 0 1-.76-2.03 5.077 5.077 0 0 1 .07-1.92 4.626 4.626 0 0 1 .795-1.663 4.58 4.58 0 0 1 1.38-1.235 4.685 4.685 0 0 1 1.784-.629 4.486 4.486 0 0 1 1.826.112zm2.628 6.504a4.587 4.587 0 0 0-.23-1.517 8.045 8.045 0 0 0-.745-1.611 8.416 8.416 0 0 0-1.109-1.493 4.585 4.585 0 0 0-1.237-.933 2.789 2.789 0 0 0-1.297-.297c-.436.002-.881.14-1.31.392-.475.283-.825.63-1.026 1.053a3.04 3.04 0 0 0-.31 1.358c.01.468.093.96.274 1.484.18.528.419 1.048.723 1.564a8.624 8.624 0 0 0 1.064 1.45c.37.398.784.706 1.211.932a2.83 2.83 0 0 0 1.303.328c.444 0 .896-.127 1.355-.397a2.693 2.693 0 0 0 .984-.985c.221-.403.347-.85.35-1.328zm12.29-6.673c-.725.515-1.456 1.033-2.182 1.546-1.003-.416-1.9-.734-2.67-1.011-.778-.275-1.6-.515-2.457-.778-.28.196-.553.392-.832.587l1.794 2.53c.09.126.201.222.302.296.118.072.26.078.434.039.09-.019.221-.082.412-.181.19-.097.336-.187.459-.269l.285.401c-1.139.81-2.278 1.615-3.416 2.423-.096-.13-.19-.266-.286-.398.09-.07.21-.176.373-.321a1.826 1.826 0 0 0 .307-.33.57.57 0 0 0 .094-.388.868.868 0 0 0-.176-.41c-1.366-1.924-2.729-3.85-4.09-5.771a1.232 1.232 0 0 0-.302-.307c-.112-.073-.255-.091-.428-.04a3.582 3.582 0 0 0-.863.391l-.285-.401c1.243-.881 2.486-1.76 3.73-2.643a5.32 5.32 0 0 1 1.034-.58 3.16 3.16 0 0 1 1.053-.242 2.05 2.05 0 0 1 .975.182c.317.141.593.387.834.728.222.31.37.612.437.918.074.302.078.601.017.909-.05.285-.168.558-.322.851a5.603 5.603 0 0 1-.578.863c.769.249 1.414.436 1.932.606.508.176 1.148.366 1.887.614a2.923 2.923 0 0 0 1.396.153 1.52 1.52 0 0 0 .448-.152c.17-.074.305-.156.404-.216.091.134.19.269.281.403zm-7.207-3.819c-.344-.484-.761-.759-1.238-.853-.482-.085-.98.056-1.494.42l-.97.688a6420.468 6420.468 0 0 0 2.426 3.422l.75-.532c.525-.37.852-.845.955-1.422.105-.583-.027-1.157-.43-1.723zm15.372-2.34c.272.92.545 1.845.824 2.766l-7.72 2.861c-.055-.151-.115-.306-.17-.459.13-.056.302-.136.504-.25.205-.11.34-.184.396-.243a.683.683 0 0 0 .198-.36.86.86 0 0 0-.064-.425c-.817-2.198-1.629-4.392-2.446-6.593a1.139 1.139 0 0 0-.213-.353c-.09-.09-.224-.134-.401-.152a2.38 2.38 0 0 0-.523.028 2.498 2.498 0 0 0-.509.098c-.056-.151-.116-.307-.17-.459l7.193-2.67.817 2.213c-.163.063-.33.124-.489.183-.207-.302-.534-.57-.952-.832-.434-.269-.782-.361-1.058-.299-.14.031-.305.073-.493.138-.198.068-.409.139-.652.228l-1.458.541c.448 1.212.902 2.43 1.35 3.64.35-.128.695-.258 1.051-.389.332-.123.572-.242.706-.37a1.023 1.023 0 0 0 .29-.457 1.758 1.758 0 0 0 .06-.597 3.355 3.355 0 0 0-.085-.637l.493-.182c.443 1.198.886 2.396 1.333 3.595-.166.064-.333.123-.493.183a3.7 3.7 0 0 0-.383-.61c-.161-.197-.302-.337-.43-.41a1.014 1.014 0 0 0-.58-.156 2.437 2.437 0 0 0-.714.175l-1.053.39c.343.92.68 1.837 1.022 2.756.103.274.205.481.303.63a.633.633 0 0 0 .361.276c.141.045.32.033.522-.016.207-.056.493-.146.853-.278.145-.056.332-.123.571-.21.235-.088.435-.165.585-.252.157-.081.325-.176.484-.286.158-.116.264-.218.302-.325.127-.28.227-.675.287-1.176.06-.5.097-.86.078-1.075.157-.061.312-.12.473-.179m8.288-6.79a4.771 4.771 0 0 1 1.232 1.48 5.99 5.99 0 0 1 .642 2.053 5.678 5.678 0 0 1-.097 2.144 4.862 4.862 0 0 1-.826 1.747 4.563 4.563 0 0 1-1.362 1.204 4.627 4.627 0 0 1-1.764.593c-.689.092-1.334.056-1.942-.13-.613-.184-1.164-.456-1.635-.859a4.78 4.78 0 0 1-1.187-1.478 5.678 5.678 0 0 1-.63-1.976c-.104-.79-.067-1.509.095-2.164a5.05 5.05 0 0 1 .822-1.738 4.64 4.64 0 0 1 3.137-1.814 4.741 4.741 0 0 1 1.887.118 4.517 4.517 0 0 1 1.628.822zm-.127 7.015a4.603 4.603 0 0 0 .388-1.488 8.493 8.493 0 0 0-.063-1.773 8.147 8.147 0 0 0-.437-1.807 4.502 4.502 0 0 0-.763-1.342 2.822 2.822 0 0 0-1.079-.78c-.408-.169-.865-.218-1.357-.155-.554.073-1.012.256-1.365.568a2.99 2.99 0 0 0-.817 1.127 4.832 4.832 0 0 0-.325 1.471 8.118 8.118 0 0 0 .05 1.721 8.16 8.16 0 0 0 .414 1.75c.18.512.446.954.752 1.33.299.378.654.63 1.064.813.409.175.881.236 1.406.164a2.671 2.671 0 0 0 1.286-.518 2.778 2.778 0 0 0 .846-1.085z'/%3e%3cpath fill='none' stroke-width='1.139' d='M468.871 261.938v61.881c0 12.307-1.708 61.314-54.354 80.348-52.757-19.034-54.466-68.036-54.466-80.348v-61.88z'/%3e%3c/g%3e%3cpath fill='%23338a00' stroke='%23075400' stroke-width='.596' d='M407.316 101.06c-4.083.034-8.6 1.993-13.238 6.97v.003c11.159-3.276 16.084 4.126 20.738 8.848a185.144 185.144 0 0 0-40.187 4.469c-4.316-9.542-19.574-21.154-31.426-3.579 10.797-5.1 16.869 1.972 22.32 5.86a183.334 183.334 0 0 0-32.113 12.3c-.036-.074-.06-.17-.097-.242-4.452-8.508-27.624-18.889-33.079 4.598 11.419-11.846 22.776 1.254 29.551-2.516a184.921 184.921 0 0 0-29.312 19.047c-.048-.06-.089-.142-.137-.199-6.19-7.357-31.075-12.548-31.305 11.555 8.411-13.732 21.951-4.066 27.946-8.508a185.828 185.828 0 0 0-26.551 27.207c-.142-.157-.278-.352-.422-.492-6.901-6.704-32.184-9.393-29.98 14.61 7.176-14.894 22.254-5.715 27.406-11.645-.787.905-1.198 2.046-1.418 3.324a184.53 184.53 0 0 0-18.774 31.965c-8.516-4.559-33.479-.333-24.824 22.14l.004.004c2.841-16.267 19.866-11.484 23.203-18.574-.035.074-.043.156-.074.23a183.218 183.218 0 0 0-11.586 37.387c-10.494.256-27.607 10.189-15.195 27.782-.887-11.867 8.005-14.91 13.629-18.559a186.012 186.012 0 0 0-1.895 26.48c0 2.668.068 5.318.18 7.957-9.473 4.117-21.91 21.338-2.274 32.059-5.556-9.389-.484-15.728 3.047-21.137a183.67 183.67 0 0 0 6.738 33.97c-8.868 5.709-17.914 21.677.735 31.05-5.947-9.306-.914-15.855 2.43-21.422a183.823 183.823 0 0 0 15.167 32.05c-7.113 7.689-11.815 26.56 9.395 30.118-8.65-7.293-5.486-15.216-3.992-21.59a185.65 185.65 0 0 0 23.93 28.734c-6.703 8-10.4 27.5 11.218 29.649-10.412-7.64-5.505-17.171-5.117-23.922a185.209 185.209 0 0 0 34.426 24.414c-1.884 10.32 3.712 27.907 23.39 20.719-10.644-1.969-12.236-9.75-14.003-15.906a183.26 183.26 0 0 0 38.503 13.355c-.184 10.45 6.906 25.133 24.891 17.156-10.944-1.273-12.949-9.17-15.176-15.238a185.716 185.716 0 0 0 31.16 2.633c2.02 0 4.028-.045 6.032-.11 2.28 10.232 14.421 24.377 29.738 10.016-11.618 2.59-15.955-5.553-20.375-10.55a183.776 183.776 0 0 0 40.277-7.91c6.32 8.407 21.669 15.974 30.614-1.946-8.7 5.582-15.085 1.618-20.48-1.594a183.942 183.942 0 0 0 30.62-15.074c7.887 6.427 30.056 9.206 29.73-13.504-5.755 9.918-14.358 8.049-20.988 7.785a185.68 185.68 0 0 0 29.282-25.238c9.283 4.964 28.409 4.982 27.132-16.07-5.284 10.155-13.95 8.697-20.582 8.73a185.093 185.093 0 0 0 21.727-31.89c10.331 1.757 29.212-4.83 20.25-24.485h-.004c-1.252 11.075-9.477 12.97-15.621 15.262a183.238 183.238 0 0 0 13.004-38.387c10.32-2.236 24.597-14.208 10.25-29.457 2.113 9.632-3.303 14.181-8.098 17.965a185.943 185.943 0 0 0 2.14-28.192c0-1.317-.022-2.63-.05-3.941 10.051-3.21 23.152-16.577 7.293-30.355 3.456 10.532-3.14 15.64-7.773 20.23a184.16 184.16 0 0 0-4.993-30.871c8.87-5.284 18.98-23.913-1.851-32.078 7.135 9.167 1.91 16.419-.832 22.445a183.49 183.49 0 0 0-12.895-31.176c7.492-7.267 13.186-26.371-8.156-30.648 8.499 7.638 4.928 15.539 3.25 21.894a185.317 185.317 0 0 0-19.324-26.66c3.968-9.72 2.134-28.003-18.578-25.027 8.755 3.601 9.757 10.137 10.175 16a185.672 185.672 0 0 0-23.77-20.195c2.861-9.903-2.327-30.12-23.144-22.32v.003c11.035 1.947 12.43 10.183 14.336 16.41a183.977 183.977 0 0 0-33.027-16.457c1.754-10.177-5.476-29.538-25.305-19.757 12.344.926 13.755 10.719 16.73 16.753a183.936 183.936 0 0 0-47.175-8.656c-1.593-6.959-8.437-16.132-17.39-16.058zm7.832 20.41c.917 0 1.83.022 2.743.036-6.205 3.72-11.544 15.967-24.887 12.55 14.374 16.239 30.152-2.277 31.894-12.32a179.5 179.5 0 0 1 46.25 8.621c-6.938 2.125-15.809 9.99-26.316 2.614 7.518 19.959 28.42 8.827 34.02.101a179.423 179.423 0 0 1 35.765 18.344c-7.237.404-17.647 9.28-28.156.207 5.43 20.474 27.121 11.724 33.727 3.64 9.762 7.023 18.787 15 26.949 23.793.405 1.13.986 2.11 1.922 2.829-6.244-4.792-20.923 5.851-30.512-6.989.913 22.413 26.746 16.679 33.422 9.57a180.429 180.429 0 0 1 19.719 28.028c-6.29-3.578-20.032-1.414-24.106-14.734-6.515 20.705 17.816 24.397 27.293 20.582a178.881 178.881 0 0 1 13.188 32.843c-5.906-4.18-18.883-4.915-20.473-18.25-9.793 18.687 11.911 26.675 22.34 25.2a180.013 180.013 0 0 1 5.062 34.8c-2.314-6.924-17.557-11.5-14.195-26.066-16.548 15.241 4.566 30.974 14.363 31.422.018 1.077.04 2.153.04 3.234 0 11.536-1.097 22.811-3.169 33.742-.402.738-.679 1.512-.722 2.364.4-7.818-16.779-13.71-11.63-28.852-17.977 13.5 1.355 31.224 11.07 32.688a178.734 178.734 0 0 1-14.308 40.16c-.424-7.185-10.716-17.134-2.054-28.399-20.76 6.862-9.518 28.651-.856 34.024a180.391 180.391 0 0 1-23.34 33.367c2.348-6.816-3.887-19.909 8.36-27.426-22.392-.966-19.05 24.598-12.578 32.047a180.875 180.875 0 0 1-31.145 26.25c1.549-7.034-2.553-19.092 9.176-25.578-20.696-1.836-20.337 20.113-15.297 29.488a179.218 179.218 0 0 1-33.563 15.93c-1.086-.257-2.15-.302-3.203.031 7.516-2.378 7.023-20.409 23.118-20.953-19.284-12.09-29.224 12.843-26.88 22.14.081.319.231.658.352.989a179.473 179.473 0 0 1-40.535 7.578c6.481-3.235 12.647-15.244 25.79-10.934-13.728-17.804-31.557 1.668-32.895 11.293-1.908.06-3.82.102-5.743.102a181.12 181.12 0 0 1-33.785-3.172c-.604-.692-1.3-1.25-2.164-1.594 7.32 2.92 18.515-11.29 31.27-1.535-7.101-21.51-30.772-8.574-34.93.074a10.905 10.905 0 0 0-.633 1.711 178.799 178.799 0 0 1-43.492-16.097c-.025-.012-.041-.035-.066-.047 7.107 3.404 19.238-10.023 31.3.566-5.588-21.806-29.801-10.758-34.746-2.422a180.432 180.432 0 0 1-31.636-22.3c7.086 1.378 17.742.288 22.39 11.375 4.421-21.29-20.271-22.526-29.273-17.758a180.802 180.802 0 0 1-25.93-31.793c6.183 3.77 20.394.731 25.004 14.238 5.92-21.151-19.18-23.887-28.266-19.555a179.077 179.077 0 0 1-16.593-36.93c2.533 7.321 20.434 7.117 20.84 22.981 12.335-19.007-12.622-29.087-22.036-26.87a179.486 179.486 0 0 1-6.8-37.31c4.962 5.243 18.638 7.29 18.511 21.165 12.069-17.268-8.318-27.902-18.87-27.797a182.924 182.924 0 0 1-.15-6.98c0-9.446.733-18.722 2.134-27.774 2.613 6.715 13.012 14.425 6.937 26.414 19.234-10.61 3.843-30.12-5.66-33.652a178.73 178.73 0 0 1 8.258-28.88c2.283 6.343 5.37 13.937-1.32 21.637 18.97-5.04 12.918-23.631 5.46-31.64a179.673 179.673 0 0 1 15.153-27.106c.429 6.337.527 13.558-7.274 18.684 19.158.239 18.901-18.325 14.242-28.254a181.022 181.022 0 0 1 22.102-23.648c-.304 6.935.356 15.828-9.273 20.859 19.389 2.184 20.716-17.04 16.824-27.258a180.343 180.343 0 0 1 23.207-15.797c-1.788 6.696-3.108 15.453-13.551 18.293 18.44 6.267 23.91-12.178 22.34-22.992a178.793 178.793 0 0 1 34-12.875c-5.444 4.753-8.862 17.401-22.442 16.11 17.175 14.154 30.057-7.978 29.551-17.852a180.769 180.769 0 0 1 39.367-4.324z'/%3e%3cpath fill='%23ad7d5a' stroke='%23000' stroke-width='.57' d='M305.125 381.948c-.341 1.48-.909 3.533-1.14 6.156 0 .569-.568 3.646 1.14 3.758 1.255.115 1.596-3.192 1.596-3.192s-1.142 3.647.34 4.104c2.053.451 2.279-3.99 2.279-3.99-.228 1.255-1.596 4.447.343 4.783 2.05.345 2.62-4.33 2.62-4.33s-1.709 4.675.341 4.788c1.938.112 1.938-4.558 1.938-4.558s-1.027 5.585 1.708 5.13c1.478-.23 1.823-2.168 2.165-3.307.454-1.707 1.48-3.872.228-7.406-.91-2.62-.568-3.304-.568-3.304s-3.192 2.394-5.697 3.988c-1.143.683-7.296-2.621-7.296-2.621zm33.276-4.906c-.569-.344-.455 2.052-.683 3.188-.114 1.142.23 3.648 4.104 3.422 3.757-.344 7.52-1.14 9.912-.572 2.394.684 5.924.798 7.864.798 1.938 0 3.192-.226 4.1-.571.8-.339 2.508.459 3.304.459.8 0 2.051-1.255 1.937-2.053-.114-1.483-1.478-1.483-3.42-1.595-1.823-.227-4.328-.571-5.58-1.026-1.255-.457-3.533-1.71-6.382-2.28 0 0-5.469.23-6.606.23-1.142 0-7.865.34-8.55 0z'/%3e%3cpath fill='none' stroke='%23060' stroke-width='.57' d='m320.055 385.14-.228-5.242 2.165 1.826.57-3.99c.91-.228 2.393 1.597 2.393 1.597l-.23-3.988 3.305 3.646s-.228-3.078.909-4.9c0 0 2.506 2.165 2.506 4.672 0 2.17 2.165-3.077 2.165-3.077l1.824 5.813 1.478-2.167 1.255 4.555 2.733-3.987 2.165 4.673 4.9-.344.572 2.736 2.164-2.393 2.85 1.823s2.391-.683 3.646-.683c1.254 0 2.735 1.594 2.735 1.594s.91-1.59 1.823-2.162c.91-.57 2.166.91 2.504 1.821l1.825-3.304s2.394 2.395 2.733 3.304c0 0 .343-2.732.913-3.646.571-.91 1.478.343 2.165 1.483l1.48-4.9s1.595.338 2.733 2.163c1.255 1.821 1.255-2.737 1.255-2.737s2.732 3.65 3.42 6.154m68.6-.912s.91-2.503 2.166-3.758c0 0 2.392 2.851 2.392 3.76 0 0 .683-.341 1.937-1.25l1.823 1.82 2.166-1.479 2.052 1.823 3.761-1.595 1.479 1.594 5.809-.681 2.169.909 2.05-2.617 1.937 2.048 3.076-3.074s1.48 1.249 1.822 2.164c0 0 2.507-1.255 3.078-2.164 0 0 2.39-.912 2.732.566 0 0 1.479-1.14 1.367-2.393-.116-1.252 1.708-.34 2.277 1.257 0 0 .684-2.51 2.51-2.739 0 0 1.25 1.483.907 4.219 0 0 2.735-2.163 3.99-2.393 0 0 .57 3.074-.341 5.813 0 0 2.85-4.674 3.418-3.078.228.91.911 3.99.228 6.152l2.507-1.595.911 3.08 2.733-.571m-128.033 9.28s2.051-3.416 3.304-4.33c0 0 2.733 2.168 3.645 4.901 0 0 .344-1.821 1.255-3.416 0 0 3.418 1.59 3.987 3.76 0 0 1.254-2.166 2.165-2.733.911-.688 1.824 2.39 1.824 4.214 0 0 2.165-2.281 3.42-2.394 0 0 2.392 1.139 3.075 5.13 0 0 2.281-2.166 3.077-1.826 0 0 2.734 1.826 2.05 4.33-.34 1.367 2.736-1.591 6.495-2.504l3.304 2.505s3.077-4.101 3.987-5.471c0 0 2.51.91 2.51 2.395 0 0 1.14-4.335 2.049-4.787.91-.569 2.164 1.367 2.164 2.621 0 0 .343-3.304 2.168-3.989 0 0 1.822 1.252 1.822 2.509 0 0 1.938-3.76 3.42-4.676'/%3e%3cpath fill='%235ac800' d='m320.055 385.14-.228-5.242 2.165 1.826.57-3.99c.91-.231 2.393 1.597 2.393 1.597l-.23-3.992 3.305 3.648s-.228-3.078.909-4.903c0 0 2.506 2.167 2.506 4.673 0 2.17 2.165-3.078 2.165-3.078l1.824 5.813 1.479-2.165 1.254 4.557 2.736-3.989 2.162 4.675 4.9-.344.571 2.733 2.164-2.391 2.85 1.822s2.393-.683 3.647-.683 2.735 1.598 2.735 1.598.91-1.598 1.822-2.173c.91-.565 2.168.915 2.505 1.826l1.825-3.304s2.392 2.395 2.733 3.304c0 0 .34-2.733.91-3.647.572-.91 1.48.344 2.166 1.483l1.478-4.9s1.598.34 2.734 2.166c1.252 1.822 1.252-2.733 1.252-2.733s2.733 3.645 3.416 6.15c0 0-18.866 6.478-32.172 4.707-15.662-2.085-28.56-5.047-28.56-5.047m129.342-.569s.91-2.508 2.167-3.763c0 0 2.392 2.853 2.392 3.763 0 0 .681-.341 1.937-1.254l1.822 1.822 2.167-1.478 2.053 1.82 3.757-1.596 1.48 1.596 5.812-.68 2.165.91 2.052-2.622 1.937 2.05 3.076-3.077s1.48 1.252 1.822 2.167c0 0 2.507-1.25 3.078-2.167 0 0 2.393-.91 2.732.57 0 0 1.482-1.142 1.37-2.391-.114-1.253 1.708-.344 2.278 1.25 0 0 .683-2.504 2.504-2.732 0 0 1.253 1.476.911 4.218 0 0 2.733-2.17 3.987-2.397 0 0 .571 3.077-.34 5.815 0 0 2.848-4.675 3.42-3.078.228.91.911 3.987.228 6.15l2.505-1.593.91 3.078 2.732-.571s-16.176 2.478-31.416 1.024c-15.242-1.453-29.543-6.835-29.54-6.835m-11.266 11.314c.74-.458-5.09 11.993-19.23 12.656-19.67.92-36.487-8.893-36.487-8.893s2.052-3.418 3.304-4.332c0 0 2.733 2.167 3.646 4.9 0 0 .343-1.824 1.254-3.417 0 0 3.419 1.59 3.987 3.76 0 0 1.255-2.166 2.168-2.733.91-.687 1.823 2.39 1.823 4.217 0 0 2.164-2.283 3.418-2.397 0 0 2.394 1.14 3.078 5.13 0 0 2.279-2.164 3.075-1.826 0 0 2.735 1.826 2.05 4.33-.341 1.37 2.734-1.59 6.496-2.503l3.304 2.504s3.075-4.1 3.987-5.472c0 0 2.509.915 2.509 2.397 0 0 1.14-4.331 2.05-4.786.91-.57 2.163 1.366 2.163 2.623 0 0 .344-3.306 2.167-3.99 0 0 1.824 1.252 1.824 2.51-.004-.003 1.933-3.764 3.416-4.678z'/%3e%3c/g%3e%3c/svg%3e";
            },
            1022: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9600 4800'%3e%3cpath fill='%23d52b1e' d='M0 0h2400l99 99h4602l99-99h2400v4800H7200l-99-99H2499l-99 99H0z'/%3e%3cpath fill='%23fff' d='M2400 0h4800v4800H2400zm2490 4430-45-863a95 95 0 0 1 111-98l859 151-116-320a65 65 0 0 1 20-73l941-762-212-99a65 65 0 0 1-34-79l186-572-542 115a65 65 0 0 1-73-38l-105-247-423 454a65 65 0 0 1-111-57l204-1052-327 189a65 65 0 0 1-91-27l-332-652-332 652a65 65 0 0 1-91 27l-327-189 204 1052a65 65 0 0 1-111 57l-423-454-105 247a65 65 0 0 1-73 38l-542-115 186 572a65 65 0 0 1-34 79l-212 99 941 762a65 65 0 0 1 20 73l-116 320 859-151a95 95 0 0 1 111 98l-45 863z'/%3e%3c/svg%3e";
            },
            957: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 10080 5040'%3e%3cdefs%3e%3cpath id='a' d='m0-360 69.421 215.845 212.038-80.301L155.99-35.603l194.985 115.71-225.881 19.651 31.105 224.59L0 160l-156.198 164.349 31.105-224.59-225.881-19.651 194.986-115.711-125.471-188.853 212.038 80.301z'/%3e%3cpath id='b' d='M0-210 54.86-75.508l144.862 10.614L88.765 28.842l34.67 141.052L0 93.334l-123.435 76.56 34.67-141.052-110.957-93.736L-54.86-75.508z'/%3e%3c/defs%3e%3cpath fill='green' d='M0 0h10080v5040H0z'/%3e%3ccircle cx='5040' cy='2520' r='1050' fill='%23ffe000'/%3e%3ccircle cx='5367.4' cy='2520' r='864' fill='green'/%3e%3ccircle cx='1730' cy='1470' r='1100' fill='%23ffe000'/%3e%3cpath fill='%23802000' stroke='%237b3100' stroke-width='23.333' d='M1654.1 2299.4h274.67s12.398-25.178-2.766-37.767-74.229-15.36-58.27-59.892c32.806-91.555 37.384-63.326 57.984-280.77s30.518-558.49 30.518-558.49h-39.674s7.63 106.05-15.259 244.15-29.755 150.3-54.933 256.35-28.992 115.21-51.88 177.01-25.179 64.852-61.038 122.07c-35.859 57.222-22.889 35.859-42.726 70.192-9.918 17.166-22.126 12.589-28.802 25.082-6.676 12.494-7.82 42.058-7.82 42.058z'/%3e%3cpath fill='green' d='M1863.7 668.6c2.282 42.661-2.007 99.138-19.688 145.1-17.928 51.216-37.423 102.27-36.458 155.31-28.502 9.694-57.877-61.678-85.312-19.688 20.624 58.016 68.239 103.95 100.86 156.22 5.502 16.205 52.438 58.518 25.281 68.358-68.547-23.46-85.162-110.31-127.68-163.05-49.38-88.757-141.44-151.49-244-155.82-38.524 1.01-163.78-9.548-131.19 56.419 47.997 32.632 107.14 53.91 154.53 90.537 35.31 3.303 99.31 62.248 95.579 84.52-62.102-25.153-91.169-55.299-158.08-81.758-90.658-35.014-216.06-13.954-266.25 76.021-9.357 23.433-23.172 91.731 6.255 98.238 34.384-53.685 83.569-113.7 156.45-97.6 57.244 4.47-63.877 106.64-17.544 86.084 14.68-6.515 48.583-28.769 72.102-31.093 23.518-2.324 36.653 15.282 54.497 17.718 35.688 4.872 45.515 19.833 42.207 28.537-3.903 10.269-15.241 1.501-51.52 13.004-18.14 5.751-27.615 21.692-48.774 28.989-21.158 7.298-65.173 7.815-81.621 1.344-57.547-24.996-151.89-20.645-169.83 51.468-.016 31.71-28.236-3.504-41.278 10.196-9.78 34.603-12.31 70.132-63.633 66.99-31.155 32.684-63.06 66.527-102.62 89.78 23.215 53.285 115.2-53.515 110.9-8.483-40.21 54.832 20.689 66.37 47.348 24.166 45.088-47.64 100.93-105.63 168.21-57.618 32.044 30.169 50.664-15.951 73.857-13.481 14.612 37.475 32.998 1.844 49.583-8.75 27.15-3.383 19.51 33.91 51.77 10.938 64.294-42.551 143.39-6.796 206.2-48.197 66.853-30.458 9.386 24.532-9.065 46.028-29.373 56.97-3.9 131.76-67.613 167.14-25.593 67.895 30.237 157.4-26.707 207.63-8.284 31.496 73.234 27.889 96.113 40.832 40.09 1.587-1.723-91.758 38.054-104.27 53.344 33.019 50.846-59.05 39.83-87.447 5.172-64.552 8.815-135.13 40.893-193.6 34.102-71.662 65.666 29.186 27.49 57.558-21.684 65.896-53.25 148.36-3.942 209.64 14.211 3.18 25.88 37.625 44.28 48.212s43.53-2.684 48.117-34.022c23.601-94.37 11.712-195.85 45.415-287.63 23.788-28.43 56.603-4.584 71.355 21.559 47.23 54.833 80.43 123.38 137.61 168.56 52.063 24.362 98.106 61.21 122.1 114.81-.32 41.353 117.45 47.692 82.258 1.727-33.768-44.747-11.488-89.504 22.715-119.26 18.318 4.518 12.904-28.289-1.458-15.312-22.995-5.424-24.466-47.512 7.497-27.507 53.836 17.379-4.197-38.962-23.655-40.69-45.52-28.215-97.82-60.676-120.2-109.72 59.256.604 120.77 32.564 181.32 12.74 48.538-24.937 97.769 2.08 114.72 44.864 37.52-5.987 21.524-43.614 0-56.146 27.443-11.325 46.422-34.805 13.147-55.515-17.574-22.934 23.566-62.052-27.001-60.422 1.651-38.627-13.556-73.973-55.66-87.318-42.178-35.717-165.95 52.62-162.36-27.89-12.471-43.818 50.278-5.854 67.812-27.708 18.118-46.194-86.337-41.686-51.87-77.5 22.51-14.494 128.15-35.314 45.306-50.82-41.347 11.364-76.832 2.949-109.37-17.513-29.657 49.603-114.34-26.938-99.252 61.251-11.585 33.23-87.278 119.57-107.76 53.423 17.422-51.845 107.1-68.797 79.29-138.7-4.267-43.636-40.445 7.589-57.49 4.335-8.63-27.162 26.104-59.178 50.313-65.625 48.038 36.948 49.493-46.614 95.178-39.816 33.355-7.41-10.771-21.718-20.074-27.996 9.14-24.416 60.346-36.892 10.136-58.094-44.302-32.872-77.138 32.72-113.68 36.218-35.072-39.595 31.842-58.628 50.312-79.479.993-15.543-39.017-4.69-26.98-18.229 10.457-18.69 81.302-20.081 48.126-48.125-49.965-17.153-114.44-12.876-162.38 9.346-30.203 9.777-39.09 78.07-65.122 75.237-12.24-30.398 3.985-90.372-37.917-99.167zm236.25 667.19c38.072-6.447.808 57.818-17.5 56.875 1.618-23.092-55.065-20.869-19.897-40.988 11.405-7.364 24.112-12.982 37.397-15.887z'/%3e%3cg fill='%23ffe000'%3e%3cuse xlink:href='%23a' x='7560' y='4200'/%3e%3cuse xlink:href='%23a' x='6300' y='2205'/%3e%3cuse xlink:href='%23a' x='7560' y='840'/%3e%3cuse xlink:href='%23a' x='8680' y='1869'/%3e%3cuse xlink:href='%23b' x='8064' y='2730'/%3e%3c/g%3e%3c/svg%3e";
            },
            2867: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 600'%3e%3cpath d='M0 0h800v600H0z' style='fill:%23007fff'/%3e%3cpath d='M36 120h84l26-84 26 84h84l-68 52 26 84-68-52-68 52 26-84-68-52zM750 0 0 450v150h50l750-450V0h-50' style='fill:%23f7d618'/%3e%3cpath d='M800 0 0 480v120l800-480V0' style='fill:%23ce1021'/%3e%3c/svg%3e";
            },
            2882: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 300'%3e%3cpath fill='%23FFCE00' d='M0 0h450v300H0z'/%3e%3cpath fill='%23289728' d='M0 0h450v225H0z'/%3e%3cpath fill='%23FFF' d='M0 0h450v150H0z'/%3e%3cpath fill='%23003082' d='M0 0h450v75H0z'/%3e%3cpath fill='%23D21034' d='M187.5 0h75v300h-75z'/%3e%3cpath fill='%23FFCE00' d='M75.028 7.004 94.9 67.996 42.902 30.333h64.197L55.1 67.996 75.028 7.004z'/%3e%3c/svg%3e";
            },
            956: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 2'%3e%3cpath fill='%23009543' d='M0 0h3v2H0z'/%3e%3cpath fill='%23FBDE4A' d='m0 2 2-2h1v2z'/%3e%3cpath fill='%23DC241F' d='M3 0v2H1z'/%3e%3c/svg%3e";
            },
            2857: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 320'%3e%3cpath fill='%23D52B1E' d='M0 0h320v320H0z'/%3e%3cpath fill='%23fff' d='M60 130h200v60H60z'/%3e%3cpath fill='%23fff' d='M130 60h60v200h-60z'/%3e%3c/svg%3e";
            },
            7464: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 300'%3e%3cpath fill='%23009E60' d='M0 0h450v300H0z'/%3e%3cpath fill='%23FFF' d='M0 0h300v300H0z'/%3e%3cpath fill='%23F77F00' d='M0 0h150v300H0z'/%3e%3c/svg%3e";
            },
            4039: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 9600 4800'%3e%3cdefs%3e%3cclipPath id='a'%3e%3cpath d='M0 0h12v6H0z'/%3e%3c/clipPath%3e%3cclipPath id='b'%3e%3cpath d='M0 0v1.5h8V4zm6 0H3v4h-5z'/%3e%3c/clipPath%3e%3c/defs%3e%3cg fill='%23012169' stroke-width='.6' clip-path='url(%23a)' transform='scale(800)'%3e%3cpath d='M0 0h12v6H0z'/%3e%3cpath stroke='%23fff' d='m0 0 6 3M0 3l6-3'/%3e%3cpath stroke='%23c8102e' stroke-width='.4' d='m0 0 6 3M0 3l6-3' clip-path='url(%23b)'/%3e%3cpath stroke='%23fff' stroke-width='1' d='M3 0v4M0 1.5h7'/%3e%3cpath stroke='%23c8102e' d='M3 0v4M0 1.5h7'/%3e%3cpath d='M0 3h6V0h6v6H0z'/%3e%3c/g%3e%3cg transform='translate(7200 2400)'%3e%3cg id='d'%3e%3cpath id='c' fill='%23fff' d='m0-1992 81 249h261l-211 153 81 249L0-1494l-212 153 81-249-211-153h261z'/%3e%3cuse xlink:href='%23c' transform='rotate(24)'/%3e%3cuse xlink:href='%23c' transform='rotate(48)'/%3e%3c/g%3e%3cuse xlink:href='%23d' transform='rotate(72)'/%3e%3cuse xlink:href='%23d' transform='rotate(144)'/%3e%3cuse xlink:href='%23d' transform='rotate(216)'/%3e%3cuse xlink:href='%23d' transform='rotate(288)'/%3e%3c/g%3e%3c/svg%3e";
            },
            5294: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-4 -4 24 16'%3e%3cpath fill='%23d52b1e' d='M20 12H-4V-4h24z'/%3e%3cpath fill='%23fff' d='M4 4h16v-8H-4z'/%3e%3cpath fill='%230039a6' d='M4 4h-8v-8h8z'/%3e%3cg id='c'%3e%3cg id='b'%3e%3cpath id='a' fill='%23fff' d='M0-2v2h1z' transform='rotate(18 0 -2)'/%3e%3cuse xlink:href='%23a' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(72)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(-72)'/%3e%3cuse xlink:href='%23c' transform='rotate(144)'/%3e%3c/svg%3e";
            },
            4564: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 90 60'%3e%3cpath fill='%23007a5e' d='M0 0h30v60H0z'/%3e%3cpath fill='%23ce1126' d='M30 0h30v60H30z'/%3e%3cpath fill='%23fcd116' d='M60 0h30v60H60z'/%3e%3cg fill='%23fcd116' transform='translate(45 30)'%3e%3cg id='b'%3e%3cpath id='a' d='M0-8v8h4z' transform='rotate(18 0 -8)'/%3e%3cuse xlink:href='%23a' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(72)'/%3e%3cuse xlink:href='%23b' transform='rotate(144)'/%3e%3cuse xlink:href='%23b' transform='rotate(216)'/%3e%3cuse xlink:href='%23b' transform='rotate(288)'/%3e%3c/g%3e%3c/svg%3e";
            },
            2170: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 30 20'%3e%3cdefs%3e%3cpath id='a' fill='%23ffde00' d='M0-1 .588.809-.952-.309H.952L-.588.809z'/%3e%3c/defs%3e%3cpath fill='%23de2910' d='M0 0h30v20H0z'/%3e%3cuse xlink:href='%23a' transform='matrix(3 0 0 3 5 5)'/%3e%3cuse xlink:href='%23a' transform='rotate(23.036 .093 25.536)'/%3e%3cuse xlink:href='%23a' transform='rotate(45.87 1.273 16.18)'/%3e%3cuse xlink:href='%23a' transform='rotate(69.945 .996 12.078)'/%3e%3cuse xlink:href='%23a' transform='rotate(20.66 -19.689 31.932)'/%3e%3c/svg%3e";
            },
            7160: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 4'%3e%3cpath fill='%23CE1126' d='M0 0h6v4H0z'/%3e%3cpath fill='%23003893' d='M0 0h6v3H0z'/%3e%3cpath fill='%23FCD116' d='M0 0h6v2H0z'/%3e%3c/svg%3e";
            },
            1516: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1000 600'%3e%3clinearGradient id='a'%3e%3cstop offset='0' stop-color='%23fbd55f'/%3e%3cstop offset='1' stop-color='%23cb8e32'/%3e%3c/linearGradient%3e%3cradialGradient xlink:href='%23a' id='f' cx='416.38' cy='814.57' r='7.422' gradientTransform='matrix(1 0 0 1.0057 0 -4.636)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='e' cx='393.34' cy='837.95' r='7.506' gradientTransform='matrix(1 0 0 .99109 0 7.468)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='d' cx='416.58' cy='860.97' r='7.422' gradientTransform='matrix(1 0 0 1.0082 0 -7.063)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='c' cx='439.62' cy='837.58' r='7.506' gradientTransform='matrix(1 0 0 .98778 0 10.237)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='b' cx='416.51' cy='837.65' r='11.146' gradientTransform='matrix(1 0 0 .98848 0 9.646)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='g' cx='760.54' cy='474.25' r='12.039' gradientTransform='matrix(1 0 0 .99305 0 3.294)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='h' cx='731.81' cy='474.25' r='12.039' gradientTransform='matrix(1 0 0 .99305 0 1.88)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='i' cx='703.46' cy='474.25' r='12.039' gradientTransform='matrix(1 0 0 .99305 0 3.294)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='j' cx='771.02' cy='499.67' r='12.039' gradientTransform='matrix(1 0 0 .991 0 4.502)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='k' cx='742.68' cy='499.67' r='12.039' gradientTransform='matrix(1 0 0 .991 0 4.502)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='l' cx='714.14' cy='499.67' r='12.039' gradientTransform='matrix(1 0 0 .991 0 4.502)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='m' cx='772.18' cy='526.29' r='12.039' gradientTransform='matrix(1 0 0 .99305 0 3.655)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='n' cx='745.39' cy='525.29' r='12.039' gradientTransform='matrix(1 0 0 .99305 0 3.648)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='o' cx='716.86' cy='525.29' r='12.039' gradientTransform='matrix(1 0 0 .99305 0 3.648)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='p' cx='768.04' cy='552.78' r='11.383' gradientTransform='matrix(1 0 0 .98916 0 5.991)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='q' cx='741.28' cy='552.78' r='11.347' gradientTransform='matrix(1 0 0 .99234 0 4.237)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='r' cx='714.26' cy='552.78' r='11.385' gradientTransform='matrix(1 0 0 .989 0 6.08)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='s' cx='761.91' cy='580.39' r='10.886' gradientTransform='matrix(1 0 0 .99259 0 4.303)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='t' cx='737.53' cy='577.5' r='10.886' gradientTransform='matrix(1 0 0 .99205 0 4.59)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='u' cx='711.71' cy='576.36' r='10.886' gradientTransform='matrix(1 0 0 .99259 0 4.272)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='v' cx='751.9' cy='604.02' r='10.462' gradientTransform='matrix(1 0 0 .98919 0 6.531)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='w' cx='729.67' cy='600.54' r='9.95' gradientTransform='matrix(1 0 0 .99915 0 .513)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='x' cx='706.08' cy='597.51' r='8.123' gradientTransform='matrix(1 0 0 .99726 0 1.636)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='y' cx='741.9' cy='625.39' r='9.95' gradientTransform='matrix(1 0 0 .99915 0 .535)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='z' cx='720.45' cy='618.78' r='8.345' gradientTransform='matrix(1 0 0 1.0069 0 -4.273)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='A' cx='700.55' cy='614.7' r='7.03' gradientTransform='matrix(1 0 0 .99645 0 2.18)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='B' cx='731.65' cy='644.12' r='9.333' gradientTransform='matrix(1 0 0 .99834 0 1.067)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='C' cx='712.98' cy='635.08' r='7.792' gradientTransform='matrix(1 0 0 1.00597 0 -3.791)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='D' cx='695.15' cy='628.49' r='6.64' gradientTransform='matrix(1 0 0 .99767 0 1.462)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='E' cx='718.42' cy='660.82' r='8.623' gradientTransform='matrix(1 0 0 1.00252 0 -1.666)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='F' cx='702.21' cy='650.42' r='7.301' gradientTransform='matrix(1 0 0 .999 0 .647)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='G' cx='686.7' cy='642.53' r='6.091' gradientTransform='matrix(1 0 0 1.0069 0 -4.435)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='H' cx='707.38' cy='674.82' r='7.953' gradientTransform='matrix(1 0 0 .9913 0 5.871)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='I' cx='693.57' cy='664.01' r='6.615' gradientTransform='matrix(1 0 0 1.01302 0 -8.648)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='J' cx='680.18' cy='655.53' r='5.651' gradientTransform='matrix(1 0 0 1.00534 0 -3.497)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='K' cx='694.25' cy='686.15' r='6.753' gradientTransform='matrix(1 0 0 1.00986 0 -6.764)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='L' cx='682.92' cy='676.43' r='5.721' gradientTransform='matrix(1 0 0 1.00582 0 -3.938)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='M' cx='671.83' cy='668.65' r='4.779' gradientTransform='matrix(1 0 0 1.02442 0 -16.33)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='N' cx='682.71' cy='696.23' r='6.282' gradientTransform='matrix(1 0 0 1.00802 0 -5.585)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='O' cx='673.31' cy='686.5' r='5.292' gradientTransform='matrix(1 0 0 1.01694 0 -11.63)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='P' cx='663.89' cy='678.28' r='4.489' gradientTransform='matrix(1 0 0 1.00862 0 -5.844)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='Q' cx='671.6' cy='705.18' r='6.282' gradientTransform='matrix(1 0 0 1.0059 0 -4.166)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='R' cx='662.2' cy='695.65' r='5.292' gradientTransform='matrix(1 0 0 1.01055 0 -7.342)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='S' cx='654.58' cy='687.37' r='4.49' gradientTransform='matrix(1 0 0 1.01672 0 -11.49)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='T' cx='646.03' cy='696.48' r='4.136' gradientTransform='matrix(1 0 0 1.02355 0 -16.403)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='U' cx='653.02' cy='704.68' r='4.489' gradientTransform='matrix(1 0 0 1.00552 0 -3.892)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='V' cx='660.59' cy='713.14' r='4.846' gradientTransform='matrix(1 0 0 1.0171 0 -12.2)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='W' cx='637.01' cy='705.72' r='3.872' gradientTransform='matrix(1 0 0 1.01093 0 -7.714)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='X' cx='642.62' cy='712.94' r='4.135' gradientTransform='matrix(1 0 0 1.01384 0 -9.865)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='Y' cx='649.42' cy='720.03' r='4.405' gradientTransform='matrix(1 0 0 1.0073 0 -5.25)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='Z' cx='628.35' cy='711.82' r='3.517' gradientTransform='matrix(1 0 0 1.02676 0 -19.049)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='aa' cx='633.37' cy='718.62' r='3.871' gradientTransform='matrix(1 0 0 1.02113 0 -15.183)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='ab' cx='639.59' cy='726.09' r='4.048' gradientTransform='matrix(1 0 0 1.03175 0 -23.056)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='ac' cx='621.03' cy='717.31' r='3.417' gradientTransform='matrix(1 0 0 1.01622 0 -11.635)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='ad' cx='625.6' cy='723.58' r='3.634' gradientTransform='matrix(1 0 0 1.01891 0 -13.684)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='ae' cx='629.94' cy='730.32' r='3.904' gradientTransform='matrix(1 0 0 1.0334 0 -24.397)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='af' cx='614.05' cy='721.3' r='3.053' gradientTransform='matrix(1 0 0 1.00982 0 -7.086)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='ag' cx='617.69' cy='727.85' r='3.256' gradientTransform='matrix(1 0 0 1.0159 0 -11.57)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='ah' cx='621.24' cy='734.22' r='3.473' gradientTransform='matrix(1 0 0 1.00532 0 -3.906)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='ai' cx='606.69' cy='724.91' r='2.946' gradientTransform='matrix(1 0 0 1.0049 0 -3.546)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='aj' cx='609.28' cy='730.85' r='3.122' gradientTransform='matrix(1 0 0 1.01859 0 -13.586)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='ak' cx='612.94' cy='737.49' r='3.378' gradientTransform='matrix(1 0 0 1.01562 0 -11.523)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='al' cx='600.03' cy='728.91' r='2.506' gradientTransform='matrix(1 0 0 1.0265 0 -19.31)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='am' cx='602' cy='734.39' r='2.724' gradientTransform='matrix(1 0 0 .98882 0 8.212)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='an' cx='604.74' cy='740' r='2.914' gradientTransform='matrix(1 0 0 1.00265 0 -1.96)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='ao' cx='685.79' cy='453.08' r='8.107' gradientTransform='matrix(1 0 0 .99658 1.768 2.964)' gradientUnits='userSpaceOnUse'/%3e%3cg stroke-width='1.2'%3e%3cpath fill='%23002b7f' d='M0 0h1000v600H0z'/%3e%3cpath fill='%23fff' d='M0 100h1000v399.996H0z'/%3e%3cpath fill='%23ce1126' d='M0 200.004h1000v200.004H0z'/%3e%3cellipse cx='300.001' cy='300' fill='%23fff' rx='75' ry='87.5'/%3e%3c/g%3e%3cg transform='translate(235.939 234.475) scale(.15382)'%3e%3cg stroke='%23000' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath fill='%23cea849' stroke-width='3' d='m105.36 349.34 11-20.25-26-7.25-8 18zm622.24 0-11-20.25 26-7.25 8 18z'/%3e%3cpath fill='%23dca842' stroke-width='3.001' d='m409.48 91.438-40.094 1.157c-25.601 2.418-35.334 12.29-19.437 30.965-41.272 6.469-81.637 15.908-118.94 35.626-10.486-1.74-22.662 4.134-26.156 14.232-2.912 8.158 4.188 16.828 16.812 13.387-8.35 21.987-106.99 19.428-109.5 56.05 7.472-6.368 15.699-11.766 23.906-6.318l-5.656 17.11c-14.363 4.277-24.455 6.644-30.47 22.363-6.212 15.77-15.13 39.832-21.343 51.671-4.08 5.472-5.063 11.284-5.063 14.17 0 6.814 4.869 16.326 16.125 16.326 11.456 0 17.094-7.175 17.094-14.388-.666-5.02-2.644-10.912-14.75-10.228 20.321-4.871 37.886 1.953 49.687 9.477 16.306 12.038 20.387 35.38 10.875 54.58-9.323 18.654-33.013 29.543-68.344 15.764-28.736-11.292-57.644 3.484-67.156 29.151-43.293 117.15 32.408 212.17 118.22 267.58 89.304 57.703 105.21 73.418 129.09 101.62 24.07 28.155 47.37 60.398 82.312 60.398 5.437 0 10.682-1.56 15.344-4.097 21.995 0 23.424 8.208 52.937 8.727v.03c.512 0 1.004-.026 1.5-.03.492.004.962.03 1.47.03v-.03c29.544-.514 30.965-8.727 52.968-8.727 4.662 2.537 9.876 4.097 15.312 4.097 34.943 0 58.243-32.243 82.312-60.398 23.88-28.205 39.821-43.92 129.12-101.62 85.81-55.415 161.51-150.44 118.22-267.58-9.512-25.668-38.45-40.443-67.187-29.15-35.33 13.778-58.989 2.89-68.312-15.765-9.512-19.2-5.431-42.542 10.875-54.58 11.802-7.524 29.335-14.349 49.656-9.477-12.106-.684-14.053 5.209-14.719 10.228 0 7.213 5.638 14.388 17.094 14.388 11.257 0 16.094-9.512 16.094-16.327 0-2.885-.95-8.697-5.031-14.169-6.212-11.839-15.163-35.903-21.375-51.67-6.014-15.72-16.106-18.087-30.47-22.365l-5.624-17.109c8.207-5.448 16.434-.05 23.906 6.318-2.507-36.622-101.18-34.064-109.53-56.05 12.625 3.442 19.756-5.229 16.844-13.387-3.494-10.098-15.67-15.973-26.156-14.232-37.27-19.72-77.67-29.16-118.94-35.63 15.89-18.68 6.16-28.547-19.44-30.964l-40.094-1.157-7-.219-6.969.219z'/%3e%3cg fill='none' stroke-width='3'%3e%3cpath d='M365.36 93.093c38.572.12 30.016 46.144-5 48.25-43.149 5.035-96.201 3.62-125 15.5m-99 61.247c33.314-9.378 69.202-1.792 91-11.75s26.49-42.896 3-47.25'/%3e%3cpath d='M349.11 123.59c7.68-1.77 15.889-2.044 19.979-5.77 4.09-3.727 5.313-10.405-4.48-11.23m-142.989 80.5c7.161-12.05 4.837-20.454-4.518-14.67M467.6 93.093c-38.572.12-30.016 46.144 5 48.25 43.149 5.035 96.201 3.62 125 15.5m99 61.247c-33.314-9.378-69.202-1.792-91-11.75s-26.49-42.896-3-47.25'/%3e%3cpath d='M483.85 123.59c-7.68-1.77-15.889-2.044-19.979-5.77-4.09-3.727-5.312-10.405 4.48-11.23m142.979 80.5c-7.161-12.05-4.837-20.454 4.518-14.67M219.23 742.45c61.736 43.665 70.667 100.43 134.54 103.15'/%3e%3cpath d='M354.55 854.5c-37.662 8.11-62.318-12.363-92.023-56.818-15.15-22.4-54.94-53.9-122.89-96.38-106.78-66.66-138.42-182.91-103.67-246.66 8.543-15.676 30.48-21.857 43.099-18.346 32.811 8.852 87.947 0 88.141-53.159.194-29.917-24.268-64.879-55.912-64.879-19.224 0-29.511 6.38-34.556 13.154'/%3e%3cpath d='M349.89 831.9c0-2.918 2.52-5.984 6.212-5.984 3.688 0 6.988 3.264 6.988 7.32 0 8.9-5.05 13.697-15.725 11.57-8.737-1.73-12.619-11.176-8.93-20.67 3.687-9.643 16.111-15.626 29.505-9.643 13.4 6.182 11.843 26.654 7.187 38.275-2.719 6.725-8.156 12.363-14.756 16.022M613.72 742.45c-61.73 43.66-70.66 100.43-134.73 103.15'/%3e%3cpath d='M478.41 854.5c37.662 8.11 62.318-12.363 92.018-56.818 14.949-22.401 54.942-53.901 122.89-96.379 106.77-66.659 138.42-182.92 103.67-246.66-8.538-15.676-30.475-21.857-43.094-18.346-32.811 8.852-87.947 0-88.141-53.159-.194-29.917 24.268-64.879 55.911-64.879 19.219 0 29.511 6.38 34.556 13.154'/%3e%3cpath d='M495.88 830.52c0-26.456-44.843-34.764-79.205-34.764-34.168 0-79.205 8.308-79.205 34.764'/%3e%3cpath d='M483.07 831.9c0-2.918-2.52-5.984-6.212-5.984-3.688 0-6.988 3.264-6.988 7.32 0 8.9 5.05 13.697 15.725 11.57 8.737-1.73 12.619-11.176 8.93-20.67-3.687-9.643-16.111-15.626-29.505-9.643-13.4 6.182-11.843 26.654-7.187 38.275 2.719 6.725 8.156 12.363 14.756 16.022'/%3e%3cpath d='M460.16 857.17c-18.056 0-17.474 19.44-43.681 19.44-26.012 0-25.431-19.44-43.487-19.44'/%3e%3c/g%3e%3c/g%3e%3cg stroke='%23000' stroke-width='3'%3e%3cpath fill='url(%23b)' d='M416.48 828.14c-12.812 0-12.812 19.035 0 19.035s13.006-19.035 0-19.035'/%3e%3cpath fill='url(%23c)' d='M439.58 831.66c-7.957 0-7.957 11.828 0 11.828 7.962 0 8.156-11.828 0-11.828'/%3e%3cpath fill='url(%23d)' d='M422.5 860.99c0-8.002-11.843-8.002-11.843 0 0 7.952 11.843 7.952 11.843 0'/%3e%3cpath fill='url(%23e)' d='M393.38 843.89c7.957 0 7.957-11.878 0-11.878-7.962 0-8.156 11.878 0 11.878'/%3e%3cpath fill='url(%23f)' d='M410.46 814.57c0 7.952 11.843 7.952 11.843 0s-11.843-7.952-11.843 0'/%3e%3c/g%3e%3cg id='ap' stroke='%23000'%3e%3cpath fill='%23825123' stroke-width='3' d='M154.052 272.66c2.176.121 4.391.67 6.438 1.531 3.615 1.523 6.784 4.129 7.906 7.75.007.023.024.04.031.063 31.912 88.55 14.845 126.29-13.5 183.59-40.958 82.506-11.105 205.42 80.375 259.16 44.974 26.295 79.656 35.262 106.22 41.906 13.281 3.322 24.558 6.07 34.094 10.156 9.2 3.94 18.697 11 24.695 19.174-9.19.76-24.19 3.281-31.554 5.445-10.704-13.603-37.624-26.11-65.484-35.588-27.86-9.478-56.925-16.224-72.688-19.344h-.031c-51.284-14.874-99.1-48.249-135.12-90.656-38.135-44.889-57.625-106.35-50.094-167.97 1.687-14.102 7.292-22.719 15.28-27.406 7.99-4.687 18.097-5.486 28.813-4.78 19.477 1.123 38.56-4.195 56-14.939 22.488-13.845 31.704-38.325 31.344-64.906-.36-26.58-10.401-55.133-26.312-76.406-5.686-7.658-7.962-13.4-7.844-17.844.119-4.444 3.002-7.378 6.531-8.406a13.699 13.699 0 0 1 2.75-.5 16.09 16.09 0 0 1 2.156-.031z'/%3e%3cpath fill='url(%23g)' d='M760.57 462.8c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23h)' d='M731.84 461.38c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23i)' d='M703.5 462.8c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23j)' d='M771.06 488.24c15.337 0 15.337 22.862 0 22.862s-15.531-22.862 0-22.862' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23k)' d='M742.71 488.24c15.337 0 15.337 22.862 0 22.862s-15.531-22.862 0-22.862' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23l)' d='M714.17 488.24c15.337 0 15.337 22.862 0 22.862s-15.531-22.862 0-22.862' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23m)' d='M772.22 514.84c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23n)' d='M745.43 513.84c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23o)' d='M716.89 513.84c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23p)' d='M768.14 542.02c14.368 0 14.368 21.52 0 21.52-14.557 0-14.751-21.52 0-21.52' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23q)' d='M741.35 542.02c14.363 0 14.363 21.52 0 21.52-14.562 0-14.562-21.52 0-21.52' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23r)' d='M714.37 542.02c14.368 0 14.368 21.52 0 21.52-14.562 0-14.756-21.52 0-21.52' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23s)' d='M762.43 570.11c13.782.547 12.812 21.172-.97 20.575-13.786-.596-13.01-21.371.97-20.575' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23t)' d='M738.05 567.22c13.782.596 12.812 21.172-.974 20.575-13.782-.547-13.006-21.122.974-20.575' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23u)' d='M712.23 566.07c13.787.596 12.817 21.172-.97 20.575-13.781-.596-13.005-21.371.97-20.575' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23v)' d='M752.61 594.2c13.205.994 11.843 20.575-1.357 19.631-13.2-.795-12.037-20.575 1.357-19.631' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23w)' d='M730.29 591.12c12.619.745 11.262 19.581-1.163 18.836-12.619-.795-11.456-19.631 1.163-18.836' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23x)' d='M706.61 589.93c10.094.596 9.12 15.953-.974 15.158-10.094-.596-9.319-15.705.974-15.158' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23y)' d='M742.52 615.97c12.619.745 11.262 19.581-1.163 18.836-12.619-.795-11.456-19.631 1.163-18.836' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23z)' d='M720.97 610.9c10.487.795 9.319 16.5-.97 15.755-10.485-.795-9.512-16.5.97-15.755' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23A)' d='M700.97 608.22c8.737.348 7.763 13.568-.775 12.971-8.737-.398-7.962-13.568.775-12.971' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23B)' d='M733.59 635.55c11.456 2.535 7.574 19.83-3.881 17.096-11.456-2.535-7.57-19.581 3.881-17.096' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23C)' d='M714.56 628c9.512 2.137 6.212 16.5-3.106 14.164-9.513-2.137-6.406-16.5 3.106-14.164' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23D)' d='M696.51 622.58c7.962 1.74 5.243 13.767-2.719 11.828-7.956-1.74-5.238-13.767 2.719-11.828' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23E)' d='M721.16 653.24c10.099 3.479 4.662 18.836-5.437 15.158-10.094-3.529-4.85-18.836 5.437-15.158' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23F)' d='M704.47 644.1c8.543 2.932 3.881 15.755-4.468 12.624-8.538-2.883-4.075-15.705 4.468-12.624' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23G)' d='M688.55 637.34c6.988 2.286 3.3 12.971-3.688 10.437-6.992-2.485-3.3-13.17 3.688-10.437' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23H)' d='M710.49 668.2c8.93 4.075 2.719 17.444-6.212 13.17-8.931-3.877-2.719-17.246 6.212-13.17' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23I)' d='M696.12 658.46c7.38 3.33 2.137 14.562-5.045 11.083-7.38-3.28-2.33-14.562 5.045-11.083' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23J)' d='M682.34 650.91c6.212 2.932 1.744 12.027-4.274 9.294-6.212-2.883-1.938-12.226 4.274-9.294' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23K)' d='M697.09 680.63c7.38 3.678 1.556 14.91-5.626 11.033-7.38-3.678-1.75-14.91 5.626-11.033' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23L)' d='M685.25 671.88c6.212 3.081 1.357 12.425-4.662 9.095-6.212-3.081-1.357-12.425 4.662-9.095' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23M)' d='M673.79 664.87c5.05 2.733.97 10.288-3.881 7.604-5.05-2.535-1.168-10.486 3.881-7.604' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23N)' d='M685.83 691.46c6.406 4.075 0 13.816-6.212 9.542-6.407-4.075-.194-13.816 6.212-9.542' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23O)' d='M675.93 682.57c5.238 3.479 0 11.431-5.243 7.952-5.243-3.479 0-11.68 5.243-7.952' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23P)' d='M666.03 674.96c4.468 2.932 0 9.542-4.27 6.61-4.462-2.882 0-9.492 4.27-6.61' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23Q)' d='M674.73 700.43c6.406 4.274 0 13.767-6.212 9.492-6.407-4.075-.194-13.767 6.212-9.492' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23R)' d='M664.83 691.66c5.238 3.529 0 11.48-5.243 7.952-5.243-3.479 0-11.431 5.243-7.952' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23S)' d='M656.71 684.11c4.463 2.932 0 9.492-4.274 6.61-4.463-2.932 0-9.741 4.274-6.61' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23T)' d='M647.98 693.4c4.075 2.535 0 8.747-3.886 6.212-4.076-2.683 0-8.896 3.886-6.212' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23U)' d='M655.16 701.4c4.463 2.883 0 9.492-4.27 6.56-4.467-2.882 0-9.492 4.27-6.56' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23V)' d='M662.92 709.55c4.85 3.28 0 10.486-4.662 7.157-4.855-3.082 0-10.487 4.662-7.157' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23W)' d='M638.85 702.94c3.688 2.535 0 7.952-3.688 5.616-3.692-2.535 0-8.15 3.688-5.616' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23X)' d='M644.57 709.92c4.075 2.733 0 8.747-3.881 6.014-4.08-2.684 0-8.698 3.881-6.014' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23Y)' d='M651.55 716.84c4.274 2.684 0 9.294-4.27 6.411-4.273-2.932 0-9.343 4.27-6.411' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23Z)' d='M630 709.28c3.3 2.137 0 7.405-3.3 5.07-3.3-2.138 0-7.356 3.3-5.07' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23aa)' d='M635.21 715.78c3.688 2.535 0 8.15-3.688 5.666-3.687-2.535 0-8.15 3.688-5.666' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23ab)' d='M641.53 723.19c3.881 2.535 0 8.747-3.881 5.815-3.882-2.535 0-8.747 3.881-5.815' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23ac)' d='M622.74 714.97c3.106 2.336-.393 7.008-3.499 4.672-2.912-2.336.393-7.008 3.499-4.672' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23ad)' d='M627.45 721.07c3.3 2.535-.388 7.554-3.688 5.02-3.3-2.485.388-7.555 3.688-5.02' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23ae)' d='M631.97 727.58c3.494 2.733-.388 8.35-4.075 5.467-3.494-2.733.387-8.35 4.075-5.467' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23af)' d='M615.7 719.44c2.525 2.137-.775 6.063-3.3 3.727-2.52-2.335.78-6.013 3.3-3.727' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23ag)' d='M619.58 725.92c2.525 2.286-.97 6.56-3.688 3.877-2.718-2.336.97-6.61 3.688-3.877' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23ah)' d='M623.18 732.05c2.912 2.733-.97 7.008-3.881 4.274-2.913-2.485.969-6.958 3.881-4.274' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23ai)' d='M608.34 723.22c2.33 2.137-.97 5.616-3.3 3.479-2.33-2.336.97-5.815 3.3-3.479' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23aj)' d='M611.02 729c2.525 2.535-.97 6.212-3.494 3.678-2.524-2.336.97-6.213 3.494-3.678' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23ak)' d='M614.9 735.44c2.719 2.733-1.163 6.809-3.881 4.075-2.719-2.534.974-6.808 3.881-4.075' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23al)' d='M601.5 727.58c1.744 1.938-1.168 4.672-2.912 2.733-1.75-1.938.969-4.87 2.912-2.733' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23am)' d='M603.61 732.94c1.943 2.137-1.163 5.02-3.3 2.883-1.744-2.137 1.168-5.02 3.3-2.883' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23an)' d='M606.49 738.49c2.132 2.336-1.362 5.417-3.499 3.131-2.132-2.336 1.362-5.666 3.499-3.131' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3cpath fill='url(%23ao)' d='M687.6 446.92c10.094 0 10.094 15.158 0 15.158s-10.288-15.158 0-15.158' transform='matrix(-1 0 0 1 833.412 0)'/%3e%3c/g%3e%3cuse xlink:href='%23ap' width='833.333' height='500' transform='matrix(-1 0 0 1 832.957 0)'/%3e%3cpath fill='%2389c5e3' stroke='%23000' d='M182.15 433.08c11.262-37.473 16.893-85.632.974-148.3 70.081-45.226 119.39-86.576 233.55-86.576 113.96 0 167.73 31.41 233.55 86.576-15.725 62.671-10.094 110.63.97 148.3h-469.42'/%3e%3cpath fill='%23fcdd09' d='m235.5 341.84-5.22 56.66c-.051.007-.105-.008-.156 0l-20.12-56.16 9.687 59.312c-.072.033-.147.06-.219.094l-22.47-29.65 13.5 35.25-16.5-11.5 10.031 18.812c-.09.129-.192.245-.28.375l-11.75-1.438 7.28 10.22a38.86 38.86 0 0 0-2.28 13.17c0 .213.06.411.063.624h77.625c.003-.213.062-.41.062-.625 0-4.637-.791-9.095-2.28-13.219l15.29-14.67-19.25 6.72c-.156-.24-.309-.483-.47-.719 2.958-3.633 31.908-39.25 30.72-39.25-1.229 0-36.6 30.34-37.844 31.406l-.188-.156 27.781-61.5-38.438 55.188c-.126-.05-.248-.108-.375-.156l11.32-58.28-20.25 56-5.25-56.5z'/%3e%3cpath fill='%230f47af' stroke='%23000' d='M181.82 433.08c-6.212 20.774-13.975 38.467-20.769 53.576-17.668 39.809-21.356 132.4 43.874 197.85 96.873 96.863 170.65 57.85 207.73 110.63h7.57c37.08-52.78 110.85-13.767 207.73-110.63 65.23-65.454 61.735-158.04 43.873-197.85-6.6-14.959-14.562-32.801-20.774-53.576h-469.42'/%3e%3cpath fill='%23fff' d='M323.62 343.97c-1.122-5.432-13.795-4.388-12.875-13.125-8.429-1.344-6.858-16.406 8.875-15.375 1.657-2.99 20.674-9.835 18.375-.375 9.544-8.316 16.457-.702 11.125 3 3.682 3.687 5.54 12.114-5.75 11.375 4.32 7.685-5.712 7.399-12.375 5.25.164 2.911-.332 5.217-4.125 4.5-2.394 1.618-.582 3.704-.25 5.625zm174.6 5.93c.107-6.855-12.811-4.763-12.33-12.57-7.012-1.075-5.993-15.596 8.5-14.724-.808-4.194 19.513-9.577 17.596-.36 7.079-7.505 14.066-.489 9.78 2.874 3.526 3.53 7.806 9.601-4.632 10.894 5.013 4.86-5.47 7.085-11.851 5.028.157 2.788-1.693 3.746-5.326 3.06-2.292 1.55.818 4.796 1.136 6.636l-2.873-.838zm100.68 23.69c1.202-5.19-10.656-4.731-10.349-10.643-5.387-.814-4.605-11.809 6.53-11.149-.62-3.176 13.868-8.502 12.896-.772 5.439-5.683 11.432.13 8.139 2.675 2.71 2.674 5.998 7.27-3.559 8.249 3.852 3.68-4.203 5.365-9.105 3.807.12 2.11-.55 2.461-3.342 1.942-1.762 1.173 2.128 4.007 2.372 5.4l-3.582.49z'/%3e%3cpath fill='%23509164' stroke='%23000' stroke-width='.999' d='M-308.88 472.49c2.912-15.158 15.337-29.124 16.699-40.952 1.163-10.685 3.3-15.158 9.512-26.39 6.213-11.282 8.733-16.5 10.094-24.303 1.939-10.089 9.513-12.226 13.006-1.938 3.3 10.288 9.9 36.13 13.394 42.145 3.3 6.013 6.8 14.363 6.213 18.438-.582 4.075 4.468 5.616 7.38 8.548 2.913 2.733 3.3 12.226 11.843 20.377 8.538 8.15 18.051 13.965 26.012 18.04 7.182 16.153 12.037 40.605 10.87 68.536h-533.29c-.195-7.356 0-14.562.387-21.52 47.368-12.226 65.036-43.487 85.03-41.35 10.874-15.158 24.074-31.46 33.199-39.81 10.869-9.89 32.225-49.3 37.662-73.405 5.437-23.856 13.394-36.678 19.412-35.336 6.018 1.392 8.543 2.535 15.725 24.104 9.905 29.67 16.699 33.199 24.268 54.52 6.6 18.488 20.387 51.637 41.548 68.933 13.2-9.89 28.343-20.973 33.194-28.726 4.08-6.809 10.293-17.295 17.668-22.315 3.3-9.89 7.569-27.583 11.068-31.857 3.3-3.877 4.657-7.753 5.044-14.562.194-6.809 5.437-21.172 12.62-33.2 7.186-11.827 16.698-15.704 20.967 0 4.076 15.756 13.588 48.756 22.52 69.33 3.687 8.55 10.486 25.397 25.43 43.09l1.614 1.906c.303-.53.607-.926.911-2.304z' transform='matrix(1.00186 0 0 1 867.911 0)'/%3e%3cg fill='%23034418'%3e%3cpath d='M497.202 528.38c-9.919-9.542-25.673-7.405-33.645-14.959-7.782-7.356-20.23-2.336-47.073-15.904-3.307-1.74-6.613-3.876-9.919-6.411-21.201-17.295-35.008-50.494-41.62-68.933-7.394-21.172-14.395-24.651-24.314-54.57-5.252-15.904-8.17-20.774-11.67-22.514 9.142 9.94 4.282 25.446 11.67 42.145 2.918 6.61-1.946 6.61-3.5 4.473-1.36-2.137-5.835-3.131-7.976-2.932 3.893 3.33 4.476 11.679 8.364 20.377 3.695 8.747-2.917 7.802 5.06 20.228 2.135 3.478 2.917 8.697-.195 10.834-3.306 1.938-5.641-6.014-10.506-3.28 1.364 3.13 7 8.746 10.7 12.026 3.694 3.33.194 5.07-2.724 3.529-3.112-1.59-7.2-3.131-9.336-4.87 0 2.534 3.112 5.417 7.389 9.293 4.476 3.728 1.558 6.411-8.753 6.411 1.558 2.336.976 8.151-3.695 8.946 6.418.398 11.283 12.226 19.255 13.021 7.782.547 8.56 6.014.976 7.356-7.588 1.342-22.954-10.884-30.537-18.836-1.947 2.733-6.03 3.876-8.948 2.336-.194 3.677.971 12.624 4.472 18.438-3.695-1.541-8.554-6.412-13.42-12.425-4.665-5.616-7.777 2.733-3.694 7.753 4.083 5.069 6.807 9.144.194 13.02-6.418 3.678-10.501 2.336-15.365-4.472-6.807 5.665-9.53 6.013-14.784 5.069 0 3.28-5.641 11.083-8.165 16.898-5.642 11.232 250.125 34.541 242.931 7.356'/%3e%3cpath d='M681.164 530.1c-67.298-5.864-104.444-31.857-125.454-56.707-14.976-17.494-21.783-34.541-25.478-43.089-8.947-20.575-18.477-53.576-22.56-69.33-1.365-5.218-3.307-8.35-5.642-9.492-3.5-1.74-1.753 4.274.777 7.355 2.723 2.932 2.529 5.666-.971 3.529-3.5-1.939-5.253 1.938-1.947 6.759 3.112 4.671 7.976 10.139 8.947 15.357.976 5.069 1.365 9.492 3.889 12.027 2.335 2.534-6.418 3.13-10.113-2.883-.194 3.877.976 9.493 3.5 8.896 2.336-.397 3.113 1.74-.194 7.604-3.306 5.616-2.917 7.555-1.747 10.09 1.747 3.876 6.224-11.48 8.947-2.734 1.36 4.075 3.695 9.144 5.83 12.425 2.142 3.13 1.948 5.07-1.164 5.07s-5.836-7.804-6.224-1.194c-.194 6.412 4.864 8.549 10.113 8.151 5.058-.199 5.835 1.74 5.058 4.473-.582 2.733 1.554 5.417 4.472 4.87 2.723-.795 7.005 1.74 9.336 8.35 2.335 6.61-1.554 9.492-7.195 4.82-5.642-4.82-13.808-9.094-14.59-12.623-.582-3.082-2.917 1.391-.388 5.665 2.335 4.274 3.695 6.213 6.807 7.952 3.112 1.54-.194 7.952-5.442 3.877-5.06-3.877-7.394-2.933-8.948 1.54-2.53 7.207-10.113 5.467-7.782 9.344 2.335 3.876 1.364 10.089-2.137 11.63-3.699 1.54-7.976-.746-7.588-7.555-.97 1.342-4.665 1.939-7.583 1.144-.388 9.542-3.112 12.822-8.948 10.288-.194 2.137-.388 5.814-3.306 8.548 6.418-.945 7.778 3.479 8.36 6.212.394 2.734 1.365 2.336 5.06 2.734 3.5.198 7.976 4.82 1.363 3.677-6.617-.944-16.924 1.342-22.953-3.081 6.224 5.616 23.924 5.815 31.314 12.97 53.88 22.167 148.797 29.92 186.326 19.632.195-4.473-.388-14.761-.776-18.041'/%3e%3cpath d='M603.028 372.77c1.554.745 3.112 2.883 4.472 6.212 3.306 10.288 9.918 36.082 13.424 42.095 3.306 6.014 6.806 14.363 6.224 18.438-.588 4.076 4.471 5.666 7.389 8.549 2.918 2.733 3.306 12.226 11.865 20.377 8.559 8.15 18.09 14.015 26.06 18.09 4.865 10.834 8.56 25.396 10.113 42.493-22.949-1.74-51.733-8.549-66.128-14.96.583-2.136.583-4.82-.194-8.895-.971-4.076-.194-7.207 4.083-11.083 4.282-3.877 2.918-10.487.587-14.164-2.335-3.48-2.14-5.616-.199-7.753 1.753-1.939 1.753-5.467-2.33-9.344-4.282-3.876-1.364-7.952.97-11.43 2.336-3.53 5.836-9.543 3.307-17.296-2.53-7.554-6.418 1.74-9.53-1.143-1.947-1.988-3.112-5.666-.971-8.747 2.136-2.932.777-8.548-1.753-12.822 5.642-1.54-3.888-18.041-5.447-25.048-1.553-7.008 1.753-10.486-1.942-13.22'/%3e%3c/g%3e%3cpath fill='%23509164' d='M358.313 435.81c0 3.678-.97 8.946-1.946 10.685 2.335 3.678 5.447 11.232 5.058 13.568 3.112-2.882 9.142-.596 10.502 7.405 1.364 8.15 2.724 15.705 1.947 20.178 2.723 2.336 8.559 6.411 9.53 10.884.97 4.274 3.889 3.678 6.806 3.28 9.142-1.342 8.365 9.692 17.896 8.15 13.419-1.937 5.059 8.748 18.477 8.35 7.778-.397 18.477 1.143 23.925 8.747 6.024-8.15 11.278-5.069 16.725-2.932 5.447 1.938 12.253 1.392 6.224-2.882-6.224-4.473-18.478-5.07-23.925-3.728-5.447 1.392-13.613.398-19.255-4.622-5.447-5.07-14.976-9.343-20.812-9.542-5.836-.199-7.195-.547-11.666-7.157-4.282-6.41-11.283-5.665-14.784-6.013-3.306-.2-5.835-4.473-1.946-8.548 5.641-6.014-2.336-6.81.582-10.487 2.918-3.678 1.365-8.549-6.418-9.145-7.777-.596-4.86-3.082-3.694-8.548 2.723-12.971-14.784-10.834-13.42-17.047m305.562 69.284c.777-7.952-5.253-11.232-6.612-17.295-1.165-6.014-10.7-6.212-13.225-4.423.971 1.74 0 4.82-1.17 6.56-1.165 1.59-1.165 2.535 1.17 3.33 2.525.596 4.666 1.143 4.86 3.28.194 1.938 1.364.199 2.335-2.336.777-2.485 7.584 3.131 8.365 8.15.583 5.07 3.306 8.549 4.083 2.535m-31.314-8.351c1.165 2.932 5.447 7.008 7.777 7.008 2.335 0 5.836 1.74 6.418 4.472.394 2.336 2.335 5.616 4.865 6.014 2.53.398 1.165 2.336-1.947 2.137-3.306-.199-8.36-2.137-8.748-4.473 1.165 4.87-.394 7.008-3.506 3.48-2.917-3.28-4.47-7.953-8.36-8.549 2.918-.547 3.306-1.342 1.942-4.274-1.165-2.883-.194-10.636 1.559-5.815'/%3e%3cpath fill='%23078930' stroke='%23000' stroke-width='.999' d='M-716.69 545.89c6.382-3.131 16.23-1.938 19.904 1.342 1.93-3.678 5.025-6.411 10.828-5.417 4.644-5.07 8.511-7.604 11.22-5.07 2.708-5.02 11.799-6.212 14.894-3.08 3.288-5.07 9.863-7.406 14.309-4.673 5.803-7.604 16.052-10.288 22.241-6.41 5.417-4.076 11.606-3.28 14.314-.597 2.708 2.535 8.511-2.684 10.833 2.137 4.06-.944 11.794-1.143 13.344 3.13.965-2.335 4.446-3.726 6.382-1.937 0-8.946 6.382-15.755 15.28-13.618 4.253-6.412 11.606-9.095 15.087-6.81 3.674-3.677 11.215-1.142 14.502 3.33 7.16-.198 10.64 3.082 14.314 9.493 3.674 6.411 14.314 10.288 21.083 7.405 6.769-2.534 12.958-3.33 15.28-.198 4.06-3.678 8.511-2.734 11.215-.2 4.644 4.076 9.09-3.13 11.8-.397 4.257 4.473 8.124-4.075 15.665.398 7.353 4.473 21.855 11.232 33.075 11.232s20.117-13.767 27.272-4.076c7.155-4.82 17.988-7.156 25.53-3.08 4.45-4.076 14.7-5.418 18.76-1.542 4.06-6.212 11.798-9.94 18.373-7.802 3.674-6.362 18.374-7.356 22.821 1.59 3.679 0 9.477 3.28 9.477 7.356 3.679 0 9.482 2.335 9.482 6.61 4.06-.994 9.085 1.54 9.863 6.41 8.12-.596 14.7 2.734 18.374 9.493 2.708-2.336 1.158-8.35 7.347-9.492 6.19-.994 8.126.944 9.863 3.081 6.769-5.02 16.25-4.423 24.177 2.733 5.803-2.335 11.22-1.341 12.958 1.541 2.516-2.336 6.576-2.882 10.64-2.882.194 13.17-.97 27.533-3.871 42.294h-523.75c-2.709-14.363-3.867-28.726-3.674-41.946' transform='matrix(1.00186 0 0 1 867.911 0)'/%3e%3cpath fill='%23fff' d='m416.28 245.04-5.243 16.898H393.18l14.557 10.486-5.437 16.898 14.174-10.487 14.368 10.487-5.438-16.898 14.363-10.089h-17.663l-5.437-16.898m-67.947 5.223-2.525 17.494-17.469 2.733 15.92 7.952-2.72 17.444 12.426-12.624 15.725 8.002-8.156-15.755 12.62-12.425-17.47 2.733-8.155-15.755M282.72 267.16l.194 17.693-16.893 5.616 17.087 5.268v17.643l10.094-14.562 16.893 5.268-10.68-14.214 10.293-14.363-16.893 5.666-10.675-14.214M220.4 294.14l3.106 17.494-15.725 8.35 17.663 2.335 2.913 17.444 7.574-15.904 17.469 2.336-12.812-12.425 7.768-15.755-15.725 8.35-12.812-12.226M484.23 250.66l2.525 17.494 17.469 2.733-15.92 7.952 2.72 17.444-12.426-12.624-15.725 8.002 8.15-15.755L458.6 263.48l17.474 2.733 8.155-15.755m66.011 16.702-.194 17.693 16.888 5.616-17.082 5.268v17.643l-10.094-14.562-16.893 5.268 10.68-14.214-10.293-14.363 16.7 5.666 10.674-14.214m61.934 27.179-3.106 17.494 15.725 8.35-17.668 2.335-2.908 17.444-7.574-15.904-17.474 2.336 12.817-12.425-7.768-15.755 15.725 8.35 12.812-12.226'/%3e%3cpath fill='%23865800' d='m387.186 672.52 1.938-129.86c0-6.212 1.168-7.206 1.362-.398l.388 131.65'/%3e%3cpath fill='%23704d25' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' d='m387.186 672.52 1.938-129.86c0-6.212 1.168-7.206 1.362-.398l.388 131.65'/%3e%3cpath fill='%23fff' d='M390.676 542.46c4.463-3.877 14.75 4.87 21.157 1.193-3.882 12.574-19.412 2.684-21.157 7.355v-8.548'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' d='M390.676 542.46c4.463-3.877 14.75 4.87 21.157 1.193-3.882 12.574-19.412 2.684-21.157 7.355v-8.548'/%3e%3cpath fill='%23865800' d='m431.056 672.72 1.938-129.66c0-6.212 1.168-7.405 1.362-.199l.388 131.4'/%3e%3cpath fill='%23704d25' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' d='m431.056 672.72 1.938-129.66c0-6.212 1.168-7.405 1.362-.199l.388 131.4'/%3e%3cpath fill='%23fff' d='M434.746 542.86c4.463-3.877 14.756 4.87 21.162 1.143-4.08 12.624-19.417 2.733-21.162 7.405v-8.548'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' d='M434.746 542.86c4.463-3.877 14.756 4.87 21.162 1.143-4.08 12.624-19.417 2.733-21.162 7.405v-8.548'/%3e%3cpath fill='%23865800' d='m472.596 679.93 1.943-129.91c0-6.212 1.163-7.157 1.357-.15l.388 131.4'/%3e%3cpath fill='%23704d25' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' d='m472.596 679.93 1.943-129.91c0-6.212 1.163-7.157 1.357-.15l.388 131.4'/%3e%3cpath fill='%23fff' d='M476.096 550.02c4.468-3.877 14.756 4.87 21.162.994-4.075 12.624-19.412 2.733-21.162 7.355v-8.498'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' d='M476.096 550.02c4.468-3.877 14.756 4.87 21.162.994-4.075 12.624-19.412 2.733-21.162 7.355v-8.498.149z'/%3e%3cpath fill='%23704d25' d='M487.546 694.84c-4.468 0-10.094-2.087-11.65-5.616-3.3 3.131-17.081 4.87-22.518.199-3.688 3.13-15.143 5.268-20.968 1.54-4.657 4.076-18.443 3.728-25.625-.546-2.912 3.081-11.262 5.417-15.725 5.815-6.406-9.145-23.687-23.706-34.556-29.124-12.231-6.014-36.693-17.693-49.7-23.31-7.573-3.28-14.561-8.945-.193-2.733 15.337 6.61 39.993 16.5 56.687 23.905 23.88 10.487 119.2 8.946 134.92 7.555 8.156-.547 19.025-6.76 26.6-11.431 5.824-3.53 6.018-1.392.387 1.54-6.213 3.28-13.006 5.815-17.862 12.624-6.6 9.145-15.725 13.22-19.22 19.234'/%3e%3cpath fill='%23704d25' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' d='M487.546 694.84c-4.468 0-10.094-2.087-11.65-5.616-3.3 3.131-17.081 4.87-22.518.199-3.688 3.13-15.143 5.268-20.968 1.54-4.657 4.076-18.443 3.728-25.625-.546-2.912 3.081-11.262 5.417-15.725 5.815-6.406-9.145-23.687-23.706-34.556-29.124-12.231-6.014-36.693-17.693-49.7-23.31-7.573-3.28-14.561-8.945-.193-2.733 15.337 6.61 39.993 16.5 56.687 23.905 23.88 10.487 119.2 8.946 134.92 7.555 8.156-.547 19.025-6.76 26.6-11.431 5.824-3.53 6.018-1.392.387 1.54-6.213 3.28-13.006 5.815-17.862 12.624-6.6 9.145-15.725 13.22-19.22 19.234l-.58.348z'/%3e%3cpath fill='%23fff' d='m496.476 572.18-30.868-3.33c-5.437 9.145-6.212 20.575-3.3 28.577 9.9-9.343 27.762-4.473 36.693.348-2.912-8.15-7.38-19.184-2.331-25.396'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' d='m496.476 572.18-30.868-3.33c-5.437 9.145-6.212 20.575-3.3 28.577 9.9-9.343 27.762-4.473 36.693.348-2.912-8.15-7.38-19.184-2.331-25.396l-.194-.199z'/%3e%3cpath fill='%23fff' d='M498.806 597.58c-9.12.199-30.863-.348-37.662-.348-7.375 9.493-3.3 23.856-1.55 29.322 8.15-13.02 33.973-6.063 43.873 3.28-5.05-9.542-8.93-17.693-4.463-32.404'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' d='M498.806 597.58c-9.12.199-30.863-.348-37.662-.348-7.375 9.493-3.3 23.856-1.55 29.322 8.15-13.02 33.973-6.063 43.873 3.28-5.05-9.542-8.93-17.693-4.463-32.404l-.198.15z'/%3e%3cpath fill='%23fff' d='M503.276 630.23c-8.931-1.59-37.662-3.529-43.487-5.07-4.662 9.692-8.543 22.316-10.482 34.393 13.975-15.357 46.399-4.076 53.193 10.834-6.794-12.822-13.593-32.205.97-40.157'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' d='M503.276 630.23c-8.931-1.59-37.662-3.529-43.487-5.07-4.662 9.692-8.543 22.316-10.482 34.393 13.975-15.357 46.399-4.076 53.193 10.834-6.794-12.822-13.593-32.205.97-40.157h-.195z'/%3e%3cpath fill='%23fff' d='m464.836 562.84-40.773-5.417c-5.82 6.809-10.094 18.836-9.512 32.8 8.543-8.15 39.799-4.87 47.76 6.81-2.718-12.624-6.212-28.527 2.719-34.392'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' d='m464.836 562.84-40.773-5.417c-5.82 6.809-10.094 18.836-9.512 32.8 8.543-8.15 39.799-4.87 47.76 6.81-2.718-12.624-6.212-28.527 2.719-34.392l-.194.198z'/%3e%3cpath fill='%23fff' d='m461.726 598.18-45.236-6.014c-7.182 9.145-6.794 22.116-5.05 35.932 10.294-8.548 43.875-3.876 51.837 7.555-4.851-16.7-8.931-26.59-1.357-37.473'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' d='m461.726 598.18-45.236-6.014c-7.182 9.145-6.794 22.116-5.05 35.932 10.294-8.548 43.875-3.876 51.837 7.555-4.851-16.7-8.931-26.59-1.357-37.473h-.194z'/%3e%3cpath fill='%23fff' d='m463.086 635.65-46.011-4.672c-7.182 8.946-12.037 18.09-10.482 31.46 7.181-11.828 37.662-3.28 50.668 9.89-7.763-10.288-8.543-25.048 5.825-36.678'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' d='m463.086 635.65-46.011-4.672c-7.182 8.946-12.037 18.09-10.482 31.46 7.181-11.828 37.662-3.28 50.668 9.89-7.763-10.288-8.543-25.048 5.825-36.678z'/%3e%3cpath fill='%23fff' d='M388.146 562.84c-5.05 3.877-12.812 17.295-13.98 20.973 8.543-3.479 26.599-4.473 37.86 3.877-3.3-6.412-4.467-17.644-1.555-22.316-4.463-1.938-16.306-2.932-22.13-2.335'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' d='M388.146 562.84c-5.05 3.877-12.812 17.295-13.98 20.973 8.543-3.479 26.599-4.473 37.86 3.877-3.3-6.412-4.467-17.644-1.555-22.316-4.463-1.938-16.306-2.932-22.13-2.335l-.194-.2z'/%3e%3cpath fill='%23fff' d='M369.316 590.02c11.843-.199 36.106 2.733 46.593 5.616-6.212 9.343-5.437 25.247-2.912 35.137-16.112-15.904-42.711-15.506-58.436-10.834 2.912-7.206 10.094-22.166 14.562-30.118'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' d='M369.316 590.02c11.843-.199 36.106 2.733 46.593 5.616-6.212 9.343-5.437 25.247-2.912 35.137-16.112-15.904-42.711-15.506-58.436-10.834 2.912-7.206 10.094-22.166 14.562-30.118l.193.199z'/%3e%3cpath fill='%23fff' d='M416.296 634.31c-11.456.398-40.768-4.672-54.167-11.282-4.657 12.624-6.794 33.597-7.182 41.151 13.006-17.444 44.848-7.753 54.942 10.089-.969-9.493-4.467-32.801 6.407-40.157'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' d='M416.296 634.31c-11.456.398-40.768-4.672-54.167-11.282-4.657 12.624-6.794 33.597-7.182 41.151 13.006-17.444 44.848-7.753 54.942 10.089-.969-9.493-4.467-32.801 6.407-40.157v.199z'/%3e%3cpath fill='%23fff' d='M388.146 562.84c-32.23 19.432-56.687 58.645-65.812 85.83 9.125-.199 20.575 2.733 24.656 10.884 9.512-39.063 22.906-75.145 41.156-96.913'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' d='M388.146 562.84c-32.23 19.432-56.687 58.645-65.812 85.83 9.125-.199 20.575 2.733 24.656 10.884 9.512-39.063 22.906-75.145 41.156-96.913v.199zm.97-18.84c-26.4 26.589-63.868 74.002-77.461 99.796m184.821-71.616c7.181 34.938 8.93 81.904 6.019 99.199'/%3e%3cpath fill='%2300009e' d='M534.686 635.28c-8.185 4.083-23.7-7.338-31.024-2.152v-4.524c7.11-4.966 22.624 6.455 31.024 2.152v4.745'/%3e%3cpath fill='%23002b7f' d='M534.686 635.28c-8.185 4.083-23.7-7.338-31.024-2.152v-4.524c7.11-4.966 22.624 6.455 31.024 2.152v4.745-.22z'/%3e%3cpath fill='%23fff' d='M534.686 640.02c-8.185 4.083-23.7-7.338-31.024-2.373v-4.745c7.11-4.966 22.624 6.456 31.024 2.152v4.745'/%3e%3cpath fill='none' d='M534.686 640.02c-8.185 4.083-23.7-7.338-31.024-2.373v-4.745c7.11-4.966 22.624 6.456 31.024 2.152v4.745z'/%3e%3cpath fill='%23ff0016' d='M534.686 644.77c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.966 22.624 6.456 31.024 2.373v4.524'/%3e%3cpath fill='%23ce1126' d='M534.686 644.77c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.966 22.624 6.456 31.024 2.373v4.524'/%3e%3cpath fill='%23fff' d='M534.686 649.51c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.745 22.624 6.456 31.024 2.152z'/%3e%3cpath fill='none' d='M534.686 649.51c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.745 22.624 6.456 31.024 2.152z'/%3e%3cpath fill='%2300009e' d='M534.686 654.04c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.966 22.624 6.456 31.024 2.152v4.524'/%3e%3cpath fill='%23002b7f' d='M534.686 654.04c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.966 22.624 6.456 31.024 2.152v4.744z'/%3e%3cg stroke-width='1.832'%3e%3cpath fill='%23865800' d='m404.084 440.136.688-46.081c0-2.205.414-2.558.483-.142l.137 46.717'/%3e%3cpath fill='%23704d25' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65' d='m404.084 440.136.688-46.081c0-2.205.414-2.558.483-.142l.137 46.717'/%3e%3cpath fill='%23fff' d='M405.322 393.984c1.584-1.376 5.235 1.728 7.508.423-1.377 4.462-6.888.952-7.508 2.61v-3.033'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65' d='M405.322 393.984c1.584-1.376 5.235 1.728 7.508.423-1.377 4.462-6.888.952-7.508 2.61v-3.033'/%3e%3cpath fill='%23865800' d='m419.651 440.207.688-46.01c0-2.205.415-2.628.483-.071l.138 46.628'/%3e%3cpath fill='%23704d25' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65' d='m419.651 440.207.688-46.01c0-2.205.415-2.628.483-.071l.138 46.628'/%3e%3cpath fill='%23fff' d='M420.96 394.126c1.584-1.376 5.237 1.728 7.51.405-1.448 4.48-6.89.97-7.51 2.628v-3.033'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65' d='M420.96 394.126c1.584-1.376 5.237 1.728 7.51.405-1.448 4.48-6.89.97-7.51 2.628v-3.033'/%3e%3cpath fill='%23865800' d='m434.392 442.765.69-46.099c0-2.204.412-2.54.481-.053l.138 46.628'/%3e%3cpath fill='%23704d25' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65' d='m434.392 442.765.69-46.099c0-2.204.412-2.54.481-.053l.138 46.628'/%3e%3cpath fill='%23fff' d='M435.634 396.666c1.585-1.375 5.236 1.729 7.51.353-1.447 4.48-6.889.97-7.51 2.61v-3.016'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65' d='M435.634 396.666c1.585-1.375 5.236 1.729 7.51.353-1.447 4.48-6.889.97-7.51 2.61v-3.016.053z'/%3e%3cpath fill='%23704d25' d='M439.697 448.056c-1.585 0-3.582-.74-4.134-1.993-1.17 1.112-6.061 1.729-7.99.071-1.31 1.111-5.374 1.87-7.441.547-1.653 1.446-6.545 1.322-9.093-.194-1.034 1.093-3.997 1.922-5.58 2.063-2.274-3.245-8.406-8.412-12.263-10.335-4.34-2.134-13.02-6.278-17.636-8.27-2.687-1.165-5.167-3.175-.069-.97 5.443 2.345 14.192 5.854 20.116 8.482 8.474 3.721 42.299 3.174 47.877 2.68 2.894-.193 6.751-2.398 9.439-4.056 2.067-1.252 2.136-.494.137.547-2.204 1.164-4.615 2.063-6.338 4.48-2.342 3.245-5.58 4.69-6.82 6.825'/%3e%3cpath fill='%23704d25' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65' d='M439.697 448.056c-1.585 0-3.582-.74-4.134-1.993-1.17 1.112-6.061 1.729-7.99.071-1.31 1.111-5.374 1.87-7.441.547-1.653 1.446-6.545 1.322-9.093-.194-1.034 1.093-3.997 1.922-5.58 2.063-2.274-3.245-8.406-8.412-12.263-10.335-4.34-2.134-13.02-6.278-17.636-8.27-2.687-1.165-5.167-3.175-.069-.97 5.443 2.345 14.192 5.854 20.116 8.482 8.474 3.721 42.299 3.174 47.877 2.68 2.894-.193 6.751-2.398 9.439-4.056 2.067-1.252 2.136-.494.137.547-2.204 1.164-4.615 2.063-6.338 4.48-2.342 3.245-5.58 4.69-6.82 6.825l-.206.123z'/%3e%3cpath fill='%23fff' d='m442.866 404.53-10.954-1.182c-1.93 3.245-2.204 7.301-1.17 10.141 3.512-3.316 9.85-1.587 13.02.123-1.034-2.892-2.619-6.807-.827-9.011'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65' d='m442.866 404.53-10.954-1.182c-1.93 3.245-2.204 7.301-1.17 10.141 3.512-3.316 9.85-1.587 13.02.123-1.034-2.892-2.619-6.807-.827-9.011l-.069-.071z'/%3e%3cpath fill='%23fff' d='M443.693 413.543c-3.236.07-10.952-.123-13.365-.123-2.617 3.368-1.17 8.465-.55 10.405 2.892-4.62 12.056-2.152 15.569 1.164-1.792-3.386-3.17-6.279-1.584-11.499'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65' d='M443.693 413.543c-3.236.07-10.952-.123-13.365-.123-2.617 3.368-1.17 8.465-.55 10.405 2.892-4.62 12.056-2.152 15.569 1.164-1.792-3.386-3.17-6.279-1.584-11.499l-.07.053z'/%3e%3cpath fill='%23fff' d='M445.279 425.13c-3.17-.565-13.365-1.253-15.432-1.8-1.654 3.44-3.031 7.919-3.72 12.204 4.96-5.449 16.466-1.446 18.877 3.845-2.411-4.55-4.824-11.428.343-14.25'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65' d='M445.279 425.13c-3.17-.565-13.365-1.253-15.432-1.8-1.654 3.44-3.031 7.919-3.72 12.204 4.96-5.449 16.466-1.446 18.877 3.845-2.411-4.55-4.824-11.428.343-14.25h-.068z'/%3e%3cpath fill='%23fff' d='m431.638 401.216-14.468-1.923c-2.065 2.416-3.582 6.684-3.376 11.64 3.032-2.892 14.123-1.729 16.949 2.416-.965-4.48-2.205-10.123.964-12.204'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65' d='m431.638 401.216-14.468-1.923c-2.065 2.416-3.582 6.684-3.376 11.64 3.032-2.892 14.123-1.729 16.949 2.416-.965-4.48-2.205-10.123.964-12.204l-.069.07z'/%3e%3cpath fill='%23fff' d='m430.535 413.756-16.052-2.134c-2.549 3.245-2.411 7.848-1.792 12.75 3.652-3.033 15.569-1.375 18.394 2.681-1.721-5.925-3.17-9.435-.482-13.297'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65' d='m430.535 413.756-16.052-2.134c-2.549 3.245-2.411 7.848-1.792 12.75 3.652-3.033 15.569-1.375 18.394 2.681-1.721-5.925-3.17-9.435-.482-13.297h-.068z'/%3e%3cpath fill='%23fff' d='m431.017 427.053-16.327-1.658c-2.548 3.174-4.271 6.42-3.72 11.163 2.549-4.197 13.365-1.163 17.98 3.51-2.754-3.65-3.031-8.888 2.067-13.015'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65' d='m431.017 427.053-16.327-1.658c-2.548 3.174-4.271 6.42-3.72 11.163 2.549-4.197 13.365-1.163 17.98 3.51-2.754-3.65-3.031-8.888 2.067-13.015z'/%3e%3cpath fill='%23fff' d='M404.425 401.216c-1.792 1.375-4.547 6.137-4.961 7.442 3.031-1.235 9.438-1.587 13.435 1.375-1.171-2.275-1.586-6.26-.552-7.918-1.584-.688-5.786-1.04-7.854-.829'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65' d='M404.425 401.216c-1.792 1.375-4.547 6.137-4.961 7.442 3.031-1.235 9.438-1.587 13.435 1.375-1.171-2.275-1.586-6.26-.552-7.918-1.584-.688-5.786-1.04-7.854-.829l-.068-.07z'/%3e%3cpath fill='%23fff' d='M397.743 410.86c4.202-.07 12.812.97 16.533 1.993-2.204 3.316-1.929 8.96-1.033 12.469-5.718-5.644-15.156-5.502-20.736-3.845 1.033-2.557 3.581-7.865 5.167-10.687'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65' d='M397.743 410.86c4.202-.07 12.812.97 16.533 1.993-2.204 3.316-1.929 8.96-1.033 12.469-5.718-5.644-15.156-5.502-20.736-3.845 1.033-2.557 3.581-7.865 5.167-10.687l.069.07z'/%3e%3cpath fill='%23fff' d='M414.414 426.577c-4.066.141-14.467-1.658-19.222-4.003-1.652 4.48-2.41 11.922-2.548 14.602 4.615-6.19 15.914-2.751 19.496 3.58-.344-3.368-1.585-11.64 2.274-14.25'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65' d='M414.414 426.577c-4.066.141-14.467-1.658-19.222-4.003-1.652 4.48-2.41 11.922-2.548 14.602 4.615-6.19 15.914-2.751 19.496 3.58-.344-3.368-1.585-11.64 2.274-14.25v.07z'/%3e%3cpath fill='%23fff' d='M404.425 401.216c-11.437 6.895-20.116 20.81-23.354 30.457 3.238-.07 7.3.97 8.75 3.862 3.375-13.862 8.127-26.666 14.604-34.39'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.65' d='M404.425 401.216c-11.437 6.895-20.116 20.81-23.354 30.457 3.238-.07 7.3.97 8.75 3.862 3.375-13.862 8.127-26.666 14.604-34.39v.07zm.344-6.686c-9.368 9.435-22.664 26.26-27.488 35.413m65.585-25.413c2.548 12.398 3.17 29.064 2.136 35.201'/%3e%3cpath fill='%2300009e' d='M456.425 426.921c-2.905 1.45-8.41-2.604-11.01-.763v-1.606c2.524-1.762 8.03 2.29 11.01.764V427'/%3e%3cpath fill='%23002b7f' d='M456.425 426.921c-2.905 1.45-8.41-2.604-11.01-.763v-1.606c2.524-1.762 8.03 2.29 11.01.764V427v-.079z'/%3e%3cpath fill='%23fff' d='M456.425 428.603c-2.905 1.45-8.41-2.604-11.01-.842v-1.684c2.524-1.762 8.03 2.291 11.01.764v1.684'/%3e%3cpath fill='none' d='M456.425 428.603c-2.905 1.45-8.41-2.604-11.01-.842v-1.684c2.524-1.762 8.03 2.291 11.01.764v1.684z'/%3e%3cpath fill='%23ff0016' d='M456.425 430.289c-2.905 1.527-8.41-2.526-11.01-.764v-1.684c2.524-1.762 8.03 2.291 11.01.842v1.606'/%3e%3cpath fill='%23ce1126' d='M456.425 430.289c-2.905 1.527-8.41-2.526-11.01-.764v-1.684c2.524-1.762 8.03 2.291 11.01.842v1.606'/%3e%3cpath fill='%23fff' d='M456.425 431.97c-2.905 1.528-8.41-2.525-11.01-.763v-1.684c2.524-1.684 8.03 2.291 11.01.764z'/%3e%3cpath fill='none' d='M456.425 431.97c-2.905 1.528-8.41-2.525-11.01-.763v-1.684c2.524-1.684 8.03 2.291 11.01.764z'/%3e%3cpath fill='%2300009e' d='M456.425 433.578c-2.905 1.528-8.41-2.525-11.01-.763v-1.684c2.524-1.762 8.03 2.29 11.01.763v1.606'/%3e%3cpath fill='%23002b7f' d='M456.425 433.578c-2.905 1.528-8.41-2.525-11.01-.763v-1.684c2.524-1.762 8.03 2.29 11.01.763v1.684z'/%3e%3c/g%3e%3cpath fill='none' stroke='%23000' stroke-width='3' d='M650.12 284.78c-24.656 97.46 2.912 159.19 21.937 201.88 17.862 39.809 21.356 132.4-43.874 197.85-96.873 96.863-170.65 57.85-207.73 110.63m-7.953.19c-37.08-52.78-110.85-13.76-207.73-110.63-65.23-65.45-61.73-158.04-43.87-197.85 19.02-42.49 46.59-104.22 21.94-201.88'/%3e%3cg stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='3'%3e%3cpath fill='%2389c5e3' d='M427.55 39.787c1.357 6.308 3.106 23.321-6.212 25.758 17.082 21.075 41.737 24.086 85.03 24.086 27.18 0 49.118-.191 65.23 0 0 5.4-1.75 11.183-1.75 17.921 0 6.5 6.799 9.51 16.7 7.264 9.9-2.246 31.061-8.602 42.512 1.481 19.224 17.204 54.555 20.167 64.067 31.015-2.912-13.094-15.337-26.332-29.119-37.37 13.006-1.864 29.894-.526 35.72 3.918-14.76-15.999-41.55-16.382-55.14-24.219-13.59-7.838-26.6-14.767-36.69-17.395 0-4.444-.587-8.028-4.469-10.609-8.543-5.974-25.237-8.028-38.825-8.793 1.939-2.055 2.326-4.492 2.326-8.22V23.55c0-7.312.78-9.175-7.57-14.385-32.224-19.785-71.441-33.978-142.88-33.978-71.248 0-110.47 14.002-142.88 33.978-8.542 5.21-7.568 7.073-7.568 14.385v21.075c0 3.728.194 6.165 2.326 8.22-13.588.573-30.088 2.628-38.825 8.793-3.688 2.58-4.468 5.974-4.468 10.61-9.9 2.437-22.906 9.366-36.688 17.394-13.593 7.838-40.38 8.22-55.136 24.23 5.63-4.445 22.519-5.974 35.525-3.92-13.588 10.849-26.012 24.087-29.12 37.372 9.513-10.849 44.844-13.812 64.262-31.016 11.257-10.084 32.419-3.918 42.513-1.481 9.9 2.246 16.699-.573 16.699-7.264 0-6.738-1.75-12.521-1.75-17.921 15.92-.382 37.856 0 65.23 0 43.1 0 67.755-3.01 85.03-24.086-9.512-2.437-7.763-19.259-6.212-25.758-20.188-4.492-30.282-12.138-46.593-12.138-16.112 0-19.025 8.554-19.025 11.756v2.628c-12.812 0-30.868-3.202-35.331-11.613 24.85-10.084 61.736-19.21 112.4-19.21 50.668 0 87.555 9.127 112.4 19.21-4.463 8.411-22.52 11.613-35.331 11.613v-2.628c0-3.01-2.719-11.756-19.025-11.756s-26.405 7.455-46.593 12.138h-.775z'/%3e%3cg fill='none'%3e%3cpath d='M260.98 89.965c-12.619.191-21.55.956-26.405 2.437-7.763 2.438-8.538 6.547-3.494 8.793M339.21 42.176v9.749c0 6.308 6.794 14.528 17.28 14.528 25.819 0 30.868-4.444 50.087-3.919'/%3e%3cpath d='M406.38 62.009c-17.86-3.011-32.03-12.521-47.76-12.521-15.531 0-18.831 7.073-16.112 10.466M224.48 72.809V92.02c0 5.257 3.688 12.521 17.668 9.749 12.231-2.246 20.188.526 20.188 5.782'/%3e%3cpath d='M267.96 53.215c2.912 2.963 9.319 5.591 23.493 10.657 26.012 9.51 85.805 16.009 124.64-.956M528.88 30.42c5.05 2.055 9.706 4.11 13.787 6.165 24.263 12.138 26.012 14.958 17.469 19.594m11.654 33.786c12.619.191 21.55.956 26.405 2.437 7.763 2.438 8.538 6.547 3.494 8.793M493.36 42.176v9.749c0 6.308-6.794 14.528-17.28 14.528-25.819 0-30.868-4.444-50.087-3.919'/%3e%3cpath d='M426.18 62.009c17.87-3.011 32.04-12.521 47.77-12.521 15.526 0 18.831 7.073 15.919 10.466M608.09 72.809V92.02c0 5.257-3.688 12.521-17.668 9.749-12.231-2.246-20.193.526-20.193 5.782'/%3e%3cpath d='M564.61 53.215c-2.912 2.963-9.319 5.591-23.493 10.657-26.012 9.51-85.805 16.009-124.64-.956'/%3e%3c/g%3e%3cpath fill='%2389c5e3' d='M416.28 66.453c11.843 0 12.231-8.937 12.231-17.156 0-8.029-.388-17.013-12.231-17.013s-12.231 8.984-12.231 17.013.388 17.156 12.231 17.156z'/%3e%3cpath fill='none' d='M304.55 30.437c-5.169 2.052-9.936 4.105-14.113 6.157-24.843 12.123-26.628 14.939-17.883 19.568'/%3e%3c/g%3e%3cg id='aq' fill='%23078930' stroke='%23000' stroke-width='3'%3e%3cpath d='M387.94 192.56c16.306-10.486 36.499-28.13 43.874-39.809 10.094-16.301 11.456-8.35 19.219-9.691-18.25 19.979-40.962 41.35-57.074 52.63l-6.019-3.13m-136.48 39.21c-40.768-23.11-56.299.994-65.812 2.137 11.257 2.734 20.769 20.774 65.812-2.137z'/%3e%3cpath d='M269.71 218.4c-38.83-26.241-56.105-3.33-65.816-2.733 11.068 3.479 19.224 22.315 65.816 2.733z'/%3e%3cpath d='M297.47 202.84c-38.248-26.987-56.105-4.473-65.816-4.075 11.068 3.876 18.637 22.514 65.816 4.075z'/%3e%3cpath d='M320.38 189.08c-35.137-31.062-55.33-10.486-64.842-11.282 10.482 5.07 16.112 24.452 64.842 11.282z'/%3e%3cpath d='M349.69 178.99c-33.582-32.851-54.744-13.22-64.256-14.562 10.288 5.417 14.95 25.396 64.256 14.562z'/%3e%3cpath d='M380.37 175.66c-27.762-37.672-51.831-21.917-61.15-24.651 9.125 7.206 10.482 27.384 61.15 24.651z'/%3e%3cpath d='M385.42 177.2c-1.362-8.498-17.28-19.383-18.637-23.458 4.075-.398 4.657-5.268 2.912-7.008-1.361-1.342-4.661-.596-6.406 1.193-1.75 2.137-3.494 7.157 2.132 11.431 5.825 4.274 13.205 12.027 15.536 17.842'/%3e%3cpath stroke-linecap='round' stroke-linejoin='round' d='M214.38 234.5c11.063-3.33 25.043-1.74 34.75-2.733M232.44 218.2c11.451-2.535 25.043 0 34.943 0m-7.183-16.35c11.451-2.087 25.043.596 34.943.596M283.49 184.01c11.65-.944 24.85 3.33 34.556 4.473M313 171.98c11.644-.398 24.656 4.473 34.362 6.212m-1.942-15.162c11.649 1.193 23.686 8.548 32.811 11.48'/%3e%3c/g%3e%3cuse xlink:href='%23aq' width='100%25' height='100%25' transform='matrix(-1 0 0 1 832.76 0)'/%3e%3cg stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='3'%3e%3cg fill='%23fff'%3e%3cpath d='M416.49 190.46c9.125 0 16.888 0 22.519-.745v-13.021c0-4.275 15.143-9.344 38.05-4.871 89.692 17.494 101.92 58.049 170.07 81.357.775.199 3.3.994 6.212 1.54 1.75-4.075 3.688-8.15 5.825-13.17 1.163-3.727 11.068-3.528 19.8.547 10.1 4.87 14.562 10.487 12.817 13.42-1.75 4.274-3.499 7.753-5.05 11.231 15.92 5.666 44.844 14.214 35.332 52.433-7.376-7.156-25.237-14.959-36.3-14.959-12.62 0-26.211-4.82-21.937-18.637-2.331-1.143-6.411-3.28-8.544-3.677-.387 1.193-.969 2.336-1.555 3.479-2.913 7.206-15.531 9.74-28.15 5.467-71.055-24.253-92.992-77.878-176.86-78.624v2.335c0 6.76-8.737 12.971-32.225 12.971-23.3 0-32.225-6.212-32.225-12.97v-2.336c-83.673.546-105.81 54.172-176.86 78.624-12.425 4.274-25.043 1.54-28.15-5.467-.393-1.143-.974-2.287-1.556-3.48-2.137.398-6.212 2.535-8.543 3.678 4.08 13.618-9.125 18.637-21.937 18.637-11.063 0-28.731 7.803-36.3 14.96-9.513-38.02 19.025-46.569 35.33-52.434-1.555-3.478-3.105-6.957-5.049-11.232-1.55-2.932 2.719-8.548 12.812-13.419 8.738-4.274 18.443-4.472 19.805-.546 2.138 4.82 3.882 8.896 5.825 13.17 2.913-.547 5.238-1.342 6.213-1.541 67.949-23.309 80.373-63.863 170.06-81.357 22.717-4.473 38.055.596 38.055 4.87v13.022c5.63.546 13.394.745 22.519.745z'/%3e%3cpath d='M393.78 189.71c-6.019-.596-9.512-1.938-9.512-4.274 0-5.815 9.512-3.877 9.512-8.747M165.27 253.58c3.494 8.35 7.962 19.035 12.037 28.13m-20.577-23.86c3.494 8.15 10.099 22.116 12.037 27.931'/%3e%3c/g%3e%3cpath fill='none' d='M140.62 255.71c2.33 4.075 14.562-1.938 16.112 1.938 1.362 4.076-2.326 6.213-10.869 9.294m27.567-25.392c1.744 5.218-10.487 7.356-7.962 12.027 1.556 3.081 8.35 2.137 13.786.944'/%3e%3cpath fill='%23fff' d='M384.06 185.24v26.987m55.14-22.517c5.825-.596 9.512-1.938 9.512-4.274 0-5.815-9.512-3.877-9.512-8.747m228.5 76.891c-3.494 8.35-7.962 19.035-12.037 28.13m20.577-23.86c-3.499 8.15-10.099 22.116-12.037 27.931'/%3e%3cpath fill='none' d='M692.36 255.71c-2.33 4.075-14.562-1.938-16.112 1.938-1.362 4.076 2.326 6.213 10.869 9.294M659.55 241.55c-1.744 5.218 10.487 7.356 7.962 12.027-1.556 3.081-8.35 2.137-13.787.944'/%3e%3cpath fill='%23fff' d='M448.91 185.24v26.987'/%3e%3c/g%3e%3cpath d='m203.96 281.77-7.523-26.884 9.371-2.622c2.396-.67 4.176-.908 5.338-.713 1.162.196 2.24.797 3.233 1.805.994 1.007 1.724 2.342 2.189 4.005.588 2.102.558 3.937-.092 5.503-.649 1.566-1.857 2.774-3.623 3.624 1.146.417 2.144.946 2.995 1.584.85.639 2.108 1.859 3.773 3.66l4.145 4.496-5.3 1.483-4.865-4.947c-1.753-1.79-2.912-2.892-3.476-3.308-.565-.415-1.107-.659-1.629-.73-.52-.072-1.295.035-2.322.323l-.917.256 3.141 11.223zm.097-16.756 3.3-.924c2.018-.564 3.277-1.012 3.777-1.343.5-.331.847-.814 1.039-1.448.192-.633.163-1.396-.087-2.289-.24-.856-.603-1.495-1.09-1.92a2.718 2.718 0 0 0-1.695-.682c-.453-.018-1.676.251-3.669.81l-3.484.974zm24.613 9.536-12.392-25.016 15.221-7.54 2.096 4.232-11.092 5.494 2.748 5.546 10.306-5.105 2.088 4.215-10.307 5.105 3.373 6.809 11.467-5.68 2.088 4.214zm20.14-10.63-15.128-23.463 6.242-4.024c2.326-1.5 3.919-2.368 4.778-2.605 1.376-.373 2.816-.207 4.321.5 1.505.705 2.86 1.992 4.064 3.86 1.094 1.696 1.69 3.324 1.79 4.884.099 1.56-.182 2.881-.843 3.964-.661 1.084-2.165 2.382-4.513 3.896l-2.545 1.64 5.707 8.85zm-8.695-21.991 4.292 6.658 2.145-1.383c1.44-.928 2.354-1.66 2.74-2.197.388-.537.576-1.175.566-1.917-.01-.741-.262-1.496-.757-2.264-.502-.78-1.096-1.325-1.782-1.639-.685-.313-1.337-.399-1.955-.257-.619.142-1.74.736-3.36 1.781zm10.435-12.159 3.778-2.64 8.66 12.396c1.345 1.925 2.268 3.146 2.769 3.664.871.893 1.815 1.395 2.83 1.507 1.015.111 2.037-.193 3.068-.913.874-.61 1.45-1.304 1.73-2.08.278-.775.277-1.58-.004-2.413-.28-.834-1.217-2.39-2.81-4.67l-8.844-12.66 3.793-2.65 8.398 12.02c2.145 3.07 3.532 5.404 4.16 7.001.628 1.598.664 3.222.106 4.874-.557 1.652-1.777 3.135-3.661 4.451-1.957 1.367-3.73 2.083-5.318 2.148-1.589.065-3.075-.368-4.46-1.297s-3.274-3.106-5.666-6.53zm19.27-13.94 7.703-4.957c2.103-1.353 3.705-2.112 4.806-2.278 1.102-.165 2.259.049 3.471.643 1.212.593 2.214 1.504 3.004 2.732.728 1.131 1.135 2.315 1.22 3.55s-.13 2.33-.65 3.284c1.404-.33 2.744-.211 4.022.355 1.278.567 2.37 1.555 3.278 2.964 1.099 1.708 1.617 3.416 1.554 5.125s-.565 3.063-1.508 4.061c-.655.694-2.403 1.955-5.243 3.782l-6.55 4.215zm6.39 1.413 3.493 5.43 2.562-1.65c1.538-.989 2.47-1.627 2.8-1.914.593-.533.93-1.146 1.012-1.84.081-.695-.129-1.431-.63-2.21-.447-.695-.961-1.16-1.544-1.396-.582-.237-1.124-.27-1.625-.098-.501.172-1.777.917-3.826 2.236zm6.008 9.337 4.04 6.277 3.602-2.319c1.58-1.017 2.541-1.752 2.883-2.206.342-.454.51-1.022.5-1.703-.007-.682-.252-1.396-.733-2.144-.495-.768-1.065-1.296-1.71-1.583a2.97 2.97 0 0 0-1.956-.19c-.66.16-1.822.776-3.488 1.848zm20.582.56-12.79-24.557 4.087-2.129 10.617 20.386 10.201-5.313 2.173 4.172zm17.29-9.33-10.795-25.746 4.25-1.782 10.795 25.746zm18.42-16.67 4.784.377c.226 3.192-.232 5.712-1.376 7.558s-2.853 3.11-5.127 3.79c-2.859.855-5.505.448-7.94-1.222-2.803-1.93-4.851-5.055-6.143-9.372-1.365-4.561-1.405-8.439-.121-11.632 1.118-2.773 3.185-4.611 6.202-5.514 2.456-.735 4.763-.51 6.92.673 1.536.839 2.929 2.35 4.178 4.534l-3.996 2.587c-.713-1.364-1.601-2.307-2.666-2.83a4.377 4.377 0 0 0-3.293-.277c-1.617.484-2.726 1.584-3.325 3.3-.6 1.717-.414 4.2.558 7.447 1.008 3.369 2.224 5.616 3.647 6.74s2.931 1.449 4.525.972c1.167-.35 2.041-1.105 2.621-2.265.58-1.161.764-2.783.552-4.866zm30.13 3.41-4.942.924-3.13-5.866-8.986 1.68-.687 6.58-4.83.903 3.63-29.079 4.81-.9zm-10.397-9.292-4.993-9.606-1.147 10.753zm39.057-1.318 8.208.624c2.076.157 3.624.508 4.645 1.051 1.02.544 1.934 1.399 2.74 2.566.806 1.167 1.396 2.646 1.769 4.439.373 1.793.46 3.992.263 6.598-.179 2.348-.6 4.369-1.262 6.064-.663 1.695-1.44 3.018-2.333 3.97a7.852 7.852 0 0 1-3.13 2.063c-1.193.425-2.698.569-4.514.43l-8.45-.641zm4.135 4.936-1.367 17.992 3.373.256c1.445.11 2.502.053 3.171-.17a3.8 3.8 0 0 0 1.687-1.11c.456-.519.865-1.36 1.227-2.526.361-1.165.616-2.717.763-4.656.153-2.014.135-3.612-.055-4.794-.19-1.182-.553-2.13-1.089-2.84a4.14 4.14 0 0 0-2.04-1.479c-.618-.208-1.828-.381-3.632-.518zm19.335 23.604-1.723-27.188 16.542-1.049.291 4.6-12.054.764.382 6.027 11.201-.71.29 4.58-11.2.71.469 7.4 12.462-.79.29 4.58zm50.4-26.02 4.378 1.965c-.86 3.082-2.14 5.3-3.838 6.654s-3.732 1.969-6.103 1.845c-2.98-.156-5.335-1.43-7.065-3.822-1.992-2.761-2.87-6.392-2.634-10.893.25-4.754 1.516-8.42 3.799-10.995 1.986-2.235 4.55-3.27 7.695-3.106 2.56.134 4.658 1.121 6.29 2.961 1.165 1.307 1.968 3.199 2.41 5.676l-4.633 1.092c-.213-1.524-.732-2.711-1.558-3.562-.827-.85-1.83-1.307-3.008-1.368-1.687-.089-3.1.575-4.243 1.99-1.142 1.414-1.801 3.814-1.978 7.2-.184 3.511.205 6.036 1.166 7.574.962 1.537 2.274 2.35 3.935 2.437 1.217.063 2.294-.354 3.23-1.252.937-.898 1.656-2.363 2.157-4.397zm10.29-2.53c.794-3.23 1.926-5.772 3.396-7.627 1.47-1.854 3.1-3.104 4.893-3.748 1.793-.644 3.786-.696 5.98-.156 3.181.782 5.474 2.634 6.88 5.555 1.406 2.922 1.557 6.626.453 11.113-1.116 4.537-3.048 7.82-5.796 9.85-2.416 1.799-5.22 2.305-8.414 1.52-3.217-.792-5.482-2.532-6.795-5.221-1.493-3.074-1.692-6.836-.597-11.286zm4.668.952c-.767 3.12-.75 5.604.05 7.455.8 1.85 2.074 2.99 3.825 3.421 1.763.434 3.414.02 4.953-1.242s2.704-3.496 3.492-6.701c.773-3.144.781-5.606.023-7.388-.758-1.781-2.05-2.897-3.874-3.345-1.824-.45-3.496-.056-5.016 1.178s-2.67 3.442-3.453 6.622zm19.442 10.388 4.363 1.272c-.926 3.483-.092 5.774 2.502 6.875 1.286.546 2.44.639 3.46.28 1.022-.36 1.744-1.037 2.165-2.03.248-.584.33-1.136.247-1.654-.084-.518-.333-1.02-.747-1.506s-1.5-1.468-3.26-2.945c-1.578-1.318-2.652-2.477-3.22-3.477-.569-1-.88-2.128-.932-3.385s.176-2.487.687-3.69c.595-1.403 1.449-2.53 2.562-3.382 1.113-.851 2.352-1.325 3.717-1.422s2.871.205 4.519.904c2.477 1.052 4.126 2.545 4.947 4.479.82 1.934.74 4.169-.24 6.704l-4.355-1.58c.398-1.458.404-2.593.017-3.405-.386-.812-1.152-1.461-2.297-1.947-1.145-.486-2.13-.621-2.952-.405-.823.216-1.385.68-1.688 1.394-.297.701-.267 1.41.09 2.127.358.718 1.426 1.791 3.205 3.222 1.876 1.527 3.145 2.835 3.807 3.922.662 1.088 1.015 2.28 1.06 3.574s-.263 2.712-.917 4.255c-.947 2.232-2.43 3.816-4.448 4.753s-4.488.785-7.41-.455c-5.165-2.192-6.792-6.352-4.882-12.478zm21.51 20.02 11.3-20.255-5.937-3.312 2.301-4.124 15.882 8.86-2.3 4.124-5.921-3.303-11.3 20.255zm29.75 18.53-4.205-2.756 1.805-6.4-7.645-5.01-5.053 4.27-4.109-2.694 22.758-18.462 4.093 2.683zm-1.064-13.904 3.051-10.386-8.275 6.962zm10.274 20.564 15.933-22.924 7.99 5.554c2.044 1.42 3.36 2.64 3.95 3.66.589 1.02.812 2.235.669 3.643-.144 1.407-.708 2.82-1.694 4.238-1.246 1.793-2.68 2.938-4.3 3.434-1.621.497-3.322.336-5.102-.484.407 1.149.636 2.255.686 3.317.05 1.063-.09 2.81-.419 5.24l-.825 6.06-4.519-3.141.715-6.901c.263-2.492.375-4.088.336-4.788-.04-.7-.198-1.273-.474-1.72-.277-.448-.853-.976-1.728-1.584l-.782-.544-6.652 9.57zm12.979-10.599 2.815 1.956c1.72 1.196 2.867 1.881 3.441 2.056.574.175 1.167.134 1.777-.121.611-.256 1.18-.765 1.71-1.526.507-.73.769-1.417.785-2.063a2.718 2.718 0 0 0-.553-1.741c-.275-.361-1.262-1.132-2.96-2.313l-2.972-2.065zm5.891 23.619 15.362-23.31 3.848 2.536-15.362 23.31zm25.3 3.49 3.024 3.726c-2.156 2.364-4.298 3.768-6.424 4.213-2.126.444-4.219.076-6.28-1.102-2.59-1.482-4.118-3.68-4.586-6.595-.535-3.362.317-6.999 2.555-10.91 2.363-4.133 5.144-6.835 8.343-8.106 2.78-1.101 5.536-.87 8.27.693 2.225 1.273 3.653 3.099 4.282 5.477.45 1.691.316 3.742-.404 6.153l-4.63-1.112c.497-1.457.568-2.75.213-3.882a4.374 4.374 0 0 0-2.069-2.577c-1.466-.838-3.027-.883-4.684-.134-1.656.749-3.326 2.595-5.01 5.537-1.745 3.053-2.535 5.482-2.369 7.288s.971 3.122 2.415 3.948c1.058.605 2.207.718 3.448.338 1.241-.38 2.543-1.365 3.906-2.955zm21.63 20.25-4.709-1.762.35-6.64-8.561-3.203-3.988 5.279-4.602-1.722 18.13-23.024 4.584 1.715zm-4.102-13.327.687-10.804-6.537 8.615zm-320.37-250.43-3.876 1.752-3.752-4.192-7.048 3.185.757 5.547-3.789 1.712-2.856-24.632 3.773-1.706zm-10.412-5.55-6.033-6.892 1.217 9.07zm12.357 4.955L301.914.455l5.555-1.833 8.383 14.203-1.742-16.393 5.57-1.837 7.4 22.433-3.444 1.136L317.812.505l2.167 18.866-3.58 1.18-9.452-16.462 5.825 17.658zm21.567-6.83-5.652-22.936 13.955-3.439.956 3.88-10.17 2.506 1.253 5.085 9.45-2.329.952 3.865-9.45 2.328 1.539 6.243 10.513-2.591.952 3.864zm17.554-4.207-4.196-23.247 8.103-1.462c2.072-.374 3.59-.432 4.553-.175.963.257 1.823.85 2.58 1.777.757.928 1.265 2.11 1.525 3.548.328 1.819.156 3.361-.516 4.629-.671 1.267-1.785 2.189-3.34 2.764.931.443 1.73.968 2.396 1.573.666.606 1.628 1.734 2.887 3.385l3.133 4.117-4.582.827-3.704-4.555c-1.335-1.647-2.223-2.669-2.665-3.064-.443-.395-.88-.643-1.314-.745-.433-.102-1.094-.073-1.981.088l-.793.143 1.751 9.704zm1.416-14.108 2.854-.515c1.744-.315 2.84-.592 3.288-.831.448-.24.778-.618.99-1.137.213-.518.249-1.163.11-1.935-.134-.74-.39-1.308-.766-1.704a2.3 2.3 0 0 0-1.373-.71c-.38-.051-1.432.079-3.155.39l-3.013.543zm17.71 10.869-3.202-23.403 3.864-.53 3.202 23.405zm19.11-10.906 3.909 1.099c-.336 2.686-1.13 4.702-2.383 6.047s-2.878 2.114-4.878 2.305c-2.512.241-4.642-.531-6.389-2.317-2.01-2.063-3.198-4.992-3.562-8.788-.385-4.01.218-7.235 1.808-9.675 1.383-2.118 3.4-3.305 6.052-3.559 2.16-.207 4.038.358 5.634 1.694 1.138.948 2.046 2.431 2.725 4.449l-3.742 1.492c-.368-1.25-.95-2.178-1.748-2.787a3.702 3.702 0 0 0-2.688-.77c-1.422.136-2.523.868-3.302 2.194-.78 1.327-1.032 3.418-.758 6.273.284 2.962.924 5.026 1.92 6.193s2.196 1.684 3.597 1.55c1.027-.099 1.876-.582 2.548-1.45.672-.87 1.091-2.185 1.256-3.95zm25.38 7.385-4.25.17-1.905-5.294-7.728.309-1.38 5.425-4.154.166 6.593-23.905 4.137-.165zm-7.57-9.05-3.006-8.653-2.274 8.863zm29.878.829 3.735 1.594c-.68 2.621-1.727 4.518-3.142 5.69-1.416 1.172-3.127 1.724-5.135 1.656-2.523-.085-4.535-1.125-6.037-3.121-1.728-2.305-2.528-5.363-2.4-9.174.136-4.026 1.15-7.147 3.041-9.362 1.645-1.922 3.799-2.838 6.461-2.748 2.169.073 3.958.875 5.368 2.406 1.006 1.087 1.716 2.675 2.13 4.763l-3.904.997c-.204-1.286-.662-2.282-1.374-2.989a3.702 3.702 0 0 0-2.567-1.11c-1.427-.048-2.613.535-3.557 1.75-.944 1.215-1.464 3.256-1.56 6.122-.101 2.974.268 5.104 1.106 6.39.838 1.286 1.96 1.952 3.366 2 1.03.035 1.936-.335 2.714-1.11.779-.774 1.364-2.025 1.755-3.753zm6.837 9.04 2.042-23.533 14.32 1.242-.346 3.981-10.434-.905-.453 5.217 9.696.841-.344 3.965-9.696-.84-.556 6.404 10.788.936-.344 3.965zm18.007 1.647 3.343-23.384 3.764.538 5.616 16.738 2.232-15.617 3.605.515-3.342 23.385-3.893-.556-5.54-16.353-2.18 15.248zm23.541 3.759 3.863-19.242-5.64-1.132.787-3.918 15.087 3.029-.787 3.918-5.624-1.13-3.863 19.243zm11.97 2.468 6.036-22.838 7.96 2.104c2.036.538 3.436 1.128 4.2 1.769.764.64 1.292 1.541 1.586 2.702.293 1.16.253 2.447-.12 3.86-.473 1.786-1.281 3.111-2.426 3.975-1.145.864-2.544 1.228-4.197 1.091.657.796 1.158 1.609 1.505 2.44.348.83.742 2.26 1.184 4.287l1.097 5.057-4.502-1.19-1.429-5.694c-.513-2.058-.893-3.36-1.128-3.904-.226-.545-.522-.956-.87-1.231-.348-.276-.966-.53-1.834-.76l-.78-.206-2.519 9.534zm7.253-12.182 2.804.74c1.714.454 2.824.666 3.331.64.508-.028.967-.231 1.379-.611.411-.38.717-.95.917-1.708.193-.727.202-1.35.027-1.868a2.3 2.3 0 0 0-.943-1.224c-.323-.207-1.33-.535-3.023-.982l-2.96-.783zm28.111 22.96-4.023-1.382.143-5.625-7.315-2.512-3.252 4.557-3.932-1.35 14.806-19.892 3.916 1.345zm-3.776-11.18.333-9.153-5.332 7.437zm5.769 12.051 9.405-21.458 3.572 1.565-7.808 17.813 8.914 3.907-1.598 3.645z'/%3e%3c/g%3e%3c/svg%3e";
            },
            2440: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 400'%3e%3cpath fill='%23002a8f' d='M0 0h800v400H0z'/%3e%3cpath fill='%23fff' d='M0 80h800v80H0v80h800v80H0z'/%3e%3cpath fill='%23cf142b' d='M346.4 200 0 0v400z'/%3e%3cpath fill='%23fff' d='m115.5 140 35.35 108.5-92.5-67h114.2l-92.5 67z'/%3e%3c/svg%3e";
            },
            2177: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 510 300'%3e%3cpath fill='%23003893' d='M0 0h510v300H0z'/%3e%3cpath fill='%23fff' d='M0 150h510v75H0z'/%3e%3cpath fill='%23cf2027' d='M0 175h510v25H0z'/%3e%3cg fill='%23f7d116' transform='translate(191.25 187.5)'%3e%3cg id='d'%3e%3cg id='c' transform='translate(0 -75)'%3e%3cg id='b'%3e%3cpath id='a' d='M0-15V0h7.5' transform='rotate(18 0 -15)'/%3e%3cuse xlink:href='%23a' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(72)'/%3e%3cuse xlink:href='%23b' transform='rotate(144)'/%3e%3cuse xlink:href='%23b' transform='rotate(216)'/%3e%3cuse xlink:href='%23b' transform='rotate(288)'/%3e%3c/g%3e%3cuse xlink:href='%23c' y='150'/%3e%3c/g%3e%3cuse xlink:href='%23d' transform='rotate(72)'/%3e%3cuse xlink:href='%23d' transform='rotate(144)'/%3e%3cuse xlink:href='%23d' transform='rotate(216)'/%3e%3cuse xlink:href='%23d' transform='rotate(288)'/%3e%3c/g%3e%3c/svg%3e";
            },
            8168: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 54 36'%3e%3cpath fill='%23002b7f' d='M0 0h54v36H0z'/%3e%3cpath fill='%23f9e814' d='M0 22.5h54V27H0z'/%3e%3cg id='d' fill='%23fff'%3e%3cg id='c'%3e%3cg id='b'%3e%3cpath id='a' d='M12 8v4h2z' transform='rotate(18 12 8)'/%3e%3cuse xlink:href='%23a' x='-24' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(72 12 12)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(-72 12 12)'/%3e%3cuse xlink:href='%23c' transform='rotate(144 12 12)'/%3e%3c/g%3e%3cuse xlink:href='%23d' x='-4' y='-4' transform='scale(.75)'/%3e%3c/svg%3e";
            },
            7628: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1000 500'%3e%3cpath fill='%230021ad' d='M0 0h1000v500H0z'/%3e%3cpath fill='%231c8a42' d='M0 0h1000v500z'/%3e%3ccircle cx='500' cy='250' r='90.32' fill='%23ffc639'/%3e%3cpath fill='%231c8a42' d='M444.84 209.43c6.179 8.477 15.542 22.689 23.072 18.979 5.876.02 8.91.433 9.706 4.344 13.86 2.359 37.153-3.487 51.647-22.366 0 0 1.22.161.797-7.015.08-3.125 4.273-2.5 4.374-1.482.585 1.553.484 2.712 1.27 2.752 1.784-.595 4.223-4.596 6.27-7.136.554-1.119.251-2.298.382-3.71 1.079-2.65 3.77-2.076 4.335-.685.514.897.524 1.583 1.028 2.48 2.731 1.824 7.66.12 8.043.12.484-2.227 1.915-2.015 1.915-2.015 1.824-.403 1.109-.242 2.308.383-1.058 12.005 2.359 12.539 2.077 18.697.12 6.874-2.077 8.83-2.077 11.45.696 3.205 10.835 3.316 7.267 6.027-3.134 1.673.01 4.808-4.707 6.028-13.728 6.965-16.359 12.942-16.359 12.942s-3.447 6.511-3.83 6.511c-2.298 4.344-5.21 1.976-6.834 4.092-.806 2.661-1.713 8.558-.1 11.622.806 4.213-.101 6.512-1.11 10.724-.906 8.79-4.394 10.12-4.797 13.204-1.613 3.296.343 18.778-1.19 18.778-10.22.202-18.051-1.955-22.093-2.761 3.94-16.984 2.409-31.901 2.409-33.433-1.008-12.146-18.193-9.193-20.824-10.805-2.178-.464-3.548-2.238-4.314-3.004-2.43-.262-3.337-.816-5.766-1.068-1.21.604-.484 1.23-3.185 2.066-6.854.826-9.878-5.977-9.878-5.977.333-2.288-15.41.463-23.969-1.522-3.507 1.955-5.04 7.74-7.912 8.426-.08 1.794-4.727-1.472-5.665-3.235-.191-5.13 4.476-7.399 4.476-7.399 3.709-2.61 5.906-3.034 7.69-4.838.897-4.465.444-7.77 2.349-11.128 1.612-2.56 3.991-1.36 5.604-2.51 1.733-1.149 2.47-8.668.867-10.724 0 0-6.935-6.259-7.318-6.642-2.258-6.47 2.64-10.644 4.042-10.17z'/%3e%3cpath fill='%23ffc639' d='M877.93 97.555c-4.092-16.194-40.721-51.071-68.247-73.265-6.572-4.477-10.855-1.81-9.999 4.573 3.427 5.716 5.998 12 9.425 17.716.957 3.81 2.761 6.477 3.719 10.286 0 0 .282 6.573.857 7.144 8.567 9.434 9.716 17.432 9.716 17.432 4.949 9.526 9.334 16.478 18.002 24.29 9.717 6.098 2.57 25.047 2.853 35.147 0 6.38-4.566 5.625-8.568 4.858-31.528-28.958-62.774-29.049-90.3-37.435-10.766-1.139-10.957 4.002-7.43 6.854 19.243 20.582 37.335 34.582 61.152 46.294l12.005 7.439c4.566 3.81 9.142 7.62 13.708 11.43 10.573 6.854 11.44 13.143 11.44 13.708.282 12.861-6.582 22.86-8.578 26.861-3.608 13.637-10.855 16.006-10.855 16.006-58.874 39.723-89.737 50.004-185.18 37.717-1.431-.756-10.573.766 0 4.576 24.291 8.094 83.961 21.076 141.69-6.26 13.86-9.716 23.132-6.53 33.171-12.346 16.49-10.17 40.035-22.83 44.32-24.251 12.86-6.864 48.864-14.575 57.16-21.44 9.514-.765 19.392-2.015 20.057-10.2 3.125-2.025 7.7-.544 11.097-7.216 7.55-1.31 6.28-4.012 6.28-4.012-1.905-5.332-8.961-7.529-14-11.43-7.44-2.48-12.58-3.245-18.012-.574-1.714.766-3.427 1.522-5.141 2.288 0 0-8.003-1.15-8.003-1.714-17.78-.977-16.046-59.902-22.336-84.478z'/%3e%3cpath fill='%231c8a42' d='M919.63 194.01a4.402 2.751 15.947 0 1-8.396-2.637 4.402 2.751 15.947 0 1 8.396 2.637z'/%3e%3cg fill='%23fff'%3e%3cpath id='a' d='m188.16 190.94-12.751-11.936-12.904 11.77 1.383-17.405-17.249-2.753 14.475-9.774-8.606-15.197 16.668 5.22 6.518-16.205 6.31 16.287 16.734-5.007-8.8 15.086 14.348 9.96-17.283 2.53 1.158 17.424z'/%3e%3cpath d='m233.39 335.53-13.752-9.167-13.391 9.664 4.712-15.568-13.582-9.415 16.667-.446 4.988-15.496 5.595 15.3 16.667-.156-13.21 9.902 5.307 15.382z'/%3e%3cuse xlink:href='%23a' x='2.522' y='269.061'/%3e%3cuse xlink:href='%23a' x='-112.066' y='123.223'/%3e%3cuse xlink:href='%23a' x='108.427' y='85.027'/%3e%3c/g%3e%3c/svg%3e";
            },
            3250: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3e%3cpath fill='%23fff' d='M0 0h900v600H0z'/%3e%3cpath id='a' fill='%234e5b31' d='M463.1 506.741a1.01 1.01 0 0 1-.347-.245l-.125-.117a21.523 21.523 0 0 1-1.582-1.643c-1.332-1.513-3.119-3.728-4.69-5.685-3.115-3.883-5.689-7.228-6.174-7.858l-.793-1.032-7.767-2.395-5.671-2.644 3.03-3.406 10.408 4.456 7.767 1.594 14.363 10.564-.011.009c-.029.024-2.089 1.738-4.136 3.6-.913.83-2.064 1.9-2.877 2.783-.335.359-.646.74-.93 1.14a9.004 9.004 0 0 0-.465.88m-53.34-16.02a39.63 39.63 0 0 1-19.895-5.567h-.007v-.008a10.24 10.24 0 0 1 2.878-3.1c1.941-1.425 5.442-3.128 11.1-3.15h.117c6.7 0 14.9 2.278 24.373 6.771a36.022 36.022 0 0 1-18.566 5.054l.01.01-.01-.01zm-29.37-6.51a4.241 4.241 0 0 1-3.17-1.333A6.439 6.439 0 0 1 375.8 480a14.656 14.656 0 0 1-.351-4.217 4.336 4.336 0 0 1 1.562-.354h.112c2.511 0 4.49 2.178 5.338 4.337a4.35 4.35 0 0 1 .274 3.067 2.417 2.417 0 0 1-2.34 1.37l-.005.009zm51.68-5.99c-17.359-2.479-24.717-8.755-27.833-13.583a15.705 15.705 0 0 1-2.634-9.96v-.014h.013c.872-.2 1.764-.299 2.658-.293 4.618 0 16.43 2.323 27.8 23.842l.007.014-.02-.01.009.004zm-35.58-3.44c-7.416 0-13.062-1.28-16.782-3.8a10.304 10.304 0 0 1-3.686-4.125 6.75 6.75 0 0 1-.594-2.023 22.704 22.704 0 0 1 7.765-1.65c.383-.018.769-.029 1.174-.03 5.732 0 14.448 1.87 23.646 10.78l.009.009h-.011a90.034 90.034 0 0 1-11.53.84l.009-.001zm-35.91-1.38c-7.82 0-18.563-2.388-25.263-9.087l-.007-.008h.02a78.487 78.487 0 0 1 15.523-2.062c.488-.012.98-.018 1.475-.019 7.332 0 12.944 1.422 16.682 4.225a4.942 4.942 0 0 1 2.178 2.783 2.28 2.28 0 0 1-1.056 2.15c-1.683 1.271-4.692 1.949-8.945 2.017l-.6.02-.007-.019zm-25.34-13a3.206 3.206 0 0 1-2.479-1.167 5.87 5.87 0 0 1-1.108-2.522 14.298 14.298 0 0 1-.291-3.674v-.018c.382-.176.797-.27 1.217-.275a3.784 3.784 0 0 1 2.589 1.158 6.956 6.956 0 0 1 1.688 2.645 4.03 4.03 0 0 1 .18 2.635 1.915 1.915 0 0 1-1.8 1.21l.004.008zm58.53-1.32a4.241 4.241 0 0 1-3.17-1.333 6.45 6.45 0 0 1-1.422-2.878 14.656 14.656 0 0 1-.351-4.217 4.336 4.336 0 0 1 1.562-.354h.112c2.511 0 4.49 2.178 5.338 4.337a4.35 4.35 0 0 1 .274 3.067 2.413 2.413 0 0 1-2.34 1.37l-.003.008zm-28.51-1.18c-15.737-.554-23.9-5.027-27.984-8.683a18.3 18.3 0 0 1-4.24-5.447 11.649 11.649 0 0 1-.908-2.438l.021-.009a13.461 13.461 0 0 1 3.885-.579h.368c5.307 0 16.111 2.229 28.852 17.153v.01l.006-.007zm17.09-1.59c-12.661-1.928-19.834-7.363-23.622-11.585a24.177 24.177 0 0 1-5.213-8.738 18.622 18.622 0 0 1 3.9-.469c.169 0 .345-.007.524-.007s.365 0 .553.007c6.368.139 17.934 3.023 23.855 20.785h.01l-.007.007zm-65-6.08a49.336 49.336 0 0 1-11.96-1.432c-6.629-1.658-9.473-4.189-10.691-6.021a6.318 6.318 0 0 1-1.031-2.534 4.282 4.282 0 0 1-.031-1.073l.031-.011a45.238 45.238 0 0 1 10.464-1.328c.239 0 .48-.006.725-.006a43.806 43.806 0 0 1 8.564.83 27.146 27.146 0 0 1 16.053 10.14v.009h-.013a49.635 49.635 0 0 1-12.12 1.42l.009.006zm29.39-10.68a4.244 4.244 0 0 1-3.172-1.3 6.49 6.49 0 0 1-1.42-2.908 14.4 14.4 0 0 1-.351-4.185 4.336 4.336 0 0 1 1.562-.354h.112c2.506 0 4.488 2.179 5.339 4.338a4.25 4.25 0 0 1 .243 3.034 2.356 2.356 0 0 1-2.31 1.38l-.003-.005zm-22.1-3.03a48.225 48.225 0 0 1-11.967-5.225c-5.544-3.413-12.326-9.45-13.153-18.83h.014a7.14 7.14 0 0 1 1.278-.154c.1 0 .217-.006.334-.006 1.656 0 5.046.466 9.147 3.584 5.22 3.98 10.04 10.92 14.35 20.65l-.003-.019zm14.43-.53a39.027 39.027 0 0 1-9.469-6.084 60.759 60.759 0 0 1-16.716-23.33 7.698 7.698 0 0 1 3.655-.718c2.411.068 6.083 1.07 10.154 5.463 4.676 5.047 8.85 13.34 12.4 24.651l.01.032-.03-.01-.004-.004zm-37.39-1.09c-4.821 0-6.471-2.615-6.957-3.74a7.783 7.783 0 0 1-.554-3.707v-.02a10.615 10.615 0 0 1 2.4-.314h.165a9.918 9.918 0 0 1 8.084 3.841c.255.379 1.037 1.694.39 2.721-.52.81-1.7 1.22-3.53 1.22l.002-.001zM291 421.431a63.914 63.914 0 0 1-11.141-.952c-4.294-.781-6.728-4.432-8.013-7.356a25.55 25.55 0 0 1-1.8-6.254h.012c13.282.39 19.555 4.271 22.478 7.457a11.713 11.713 0 0 1 3.206 6.922h-.009c-.02 0-1.89.18-4.74.18l.007.003zm13.83-13.82a53.867 53.867 0 0 1-3.033-4.228c-1.573-2.445-3.028-5-3.028-7.084 0-2.016-.474-6.266-.757-8.619-.358-2.985-.72-5.54-.75-5.757h.013c.337.123 8.308 3.114 8.308 10.591s-.738 15.014-.745 15.089v.011h-.01l.002-.003zm-10.33-.71c-.084 0-.167-.008-.25-.021-2.356-.393-6.5-2.194-11.073-4.818-5.082-2.914-9.209-6.036-11.62-8.791-2.2-2.512-3.5-6.457-3.88-11.726a43.595 43.595 0 0 1 .087-7.163 4.135 4.135 0 0 1 1.315-.2c1.764.029 3.647.823 6.189 2.574a49.763 49.763 0 0 1 6.49 5.514 99.384 99.384 0 0 1 7.2 7.971l.032.04c.265.475 2.537 4.571 4.307 8.558a27.554 27.554 0 0 1 2.024 5.746c.174.581.174 1.2 0 1.781a.902.902 0 0 1-.385.448c-.139.06-.289.091-.44.09l.004-.003z'/%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 900 0)'/%3e%3cpath fill='%23d57800' d='m727.132 103.967-2.355.938-.923.368-2.854-.157-2.673 1.283-4.74 3.239-.209.15-1.767.461-1.641-.708-.932.424-.321 1.92-.887 1.379-1.092.767-3.783.387-3.19 1.645-4.15-1.111-1.928.755-4.1 3.692-2.095.992-.732-.042-2.778-.143-1.173.384-1.752 1.693-3.315.258-1.033.715-1.618 3.26-1.753 1.808-1 .212-1.087-.4-.817.144-.37 2.086-.793.874-2.219.764-1.773 1.477-1.556.8-2.084-.052h-.479l-2.076 1.146-3.9.342-1.624 1.549-.358.331-.758.458-1.24.74-.3.184-1.5-.267-1.75.693-.708-1.089-1.211.727-1.6.069-2-.889-1.522-.678-1.113.161-.387 1.94-.039.206-1.17 1.557-2.184 1.323-.3.387-2.485 3.208-4.722 4.966-3.993 2.028-4.139 1.259-2.9 2.38-7.6 3.767-11.995 5.973-2.453.786-3.52.562-6.278 2.312-5.539 1.671-.308.094-1.1.332-7.81 2.363-3.635-.384-2.153.782-5.605-.622-3.9.077-2.467.513-4.637 2.224-7.827 3.762-2.586 2.366-4.027 2.1-4.715 1.493.011-1.981-.028-.084-1.636.517-1.181.373-3.825.59h-2.128l-1.321-.384-.2.069-7.818 2.569-8.719.842-4.363 1.4-3.26-.052-2.038.606-4 .489-1.428-.381-.322-.088-11.75.51-5.372-.607-2.564.583-4.3-1.446-6.269-.727-1.465-.439-3.3-.978-1.491.859-1.116.119-2.667-.967-.96-.024-2.2.8-1.267-.325-1.177-.938-2.761-.411-1.682-1.414-9.4 1.246-2.551-.75-8.554-2.492-1.361.069-1.7 1.271-2.548.929-2.212.575-3.012.1-3.5-.918-3.606-1.748-1.333-.317-2.974.3-.91.082-5.466-2.932-7.042-4.4-4.778-2.3-1.794-.291-.241.853.89 2.8.3 2.774-.091 2.563-.049 1.587.446 1.425 1.725 1.912.719 1.92.526 5.284-.006 5.362-.839 8.551-.283 1.3-1 4.43-.914 4.069-3.546 10.833-.974 1.343-2.391 1.631-5.419 3.688-3.99 2.3-1.263.523-3.239.245-2.018-.1-2.513-1.361-2.467-.635-3.232-2.324-3.6-.744-3.941-2.278-1.026-1.233-2.146-.2-2.976-.893v-.005l-1.093-.327-.755-.22-3.8-.1-3.54-1.634-1.864-.45-2.547-.129-2.666 1.239-1.351.629-1.707-.678-1.235.077-1.4 2.115-.172.323-.964.51-1.2-.017-.939-.025-1.016.444-1.368.593-1.208.527-.59.255-.01-.01-.363.073-.645.112-.8.153-1.41-.824-.75-.442-1.257-.256-.677.489-.133 2.3-.618 1.378-1.961 1.734-1.993 1.755-1.389 2.047-3.676 8.39-2.3 3.385-.715.789-2.418 2.66-2.136 1.657-4.922 3.815-4.659 1.741-4.013.82-1.951.008-3.7-.492-3.323-1.02-3.65-2.282-4-3.217-5.794-5.724-.82-.493-.171-.114-1.825-1.167-1.354.035-.53.874-.29 1.263-.245 1.12-.664 6.367.049.369.349 2.622 4.4 6.15 1.358 3.267.223.373.908 1.525.691 1.163.069.118 1.5 4.488-1.057 2.534.534 1.7-1.336 1.037-.245 1.465 3.951 4.953.862 2.185-.963 3.029-1.536 1.671-.429.457.216 1.28 1.818 1.635 3.089 2.75 1.647 4.086 1.253 1.1 1.456-.31.81.618 1.228-.021 1.208 1.208.782.379 1.236.616.977 1.272.216 3.911 1.822 4.86.028 2.635.01.374 1.134 1.948.356 1.538-.6 4.069 1.445 1.306 1.567-.32 1.012.16 1.626 1.354 1.969 3 1.926-.282 1.222.589 5.9 5.334 1.339.676.074.042.963.483 1.2 1.208 1.856-1.232.206-.021 2.018-.178.886.6 1.7 1.149 2.234-.029 4.844 1.485 2.119.543 4.261 2.648 1.811 1.12 1.072.871 1.424 1.161 2.845 1.224 2.44.584 1.322.314 1 .384.025-.062h.014l-.024.063 5.284 2.023 2.862.668 2.648.975 1.927.7 1.414.023 2-1.682 1.937-.112 1.609.4 1.57-.263 2.485-1.531.485-.719 1.762-.839 5.944-.738 1.737.564 4.46-1.94 2.988.831 2.645-.938 5.779 1.284 1.536 1.081 1.717 1.965.21.009 1.912.037-.8 1.331 2.523 2.647 2.279 3.445.154.455 1.657 4.864 1.232 1.723.862 2.405.042 1.568-1.34 1.022-.22.583-.076.216.272.655.506-.276.963-.533 1.172-.182 2.066.22 1.364.143 2.154-1.069 1.427-.71 2.293.987 2.52-.028 1.058.471 3 1.358 1.529.144.565-.371.36-.856-.185-1L397 377.23l-2.531-2.938-1.036-1.51-.789-2.186-.244-2.796-.174-1.885.314-2.477.68-.884.5-1.968h.009l.129-.515 1.406-1.866 3.724-2.393 4-3.582 3.162-2.085 3.26-1.412.087-.4.363.146 8.292-2.819.137-.016 3.692-.643 24.92 1.755.924-.279v-.006l.83-2.33.447-.432.3-.282 2.74-1.206 1.281-.183 3.556.878 1.456.359 2.332-1.307 1.654.028 3.417-1.866 2.111.053.8-.321 4.112-2.955 3.961-1.135 1.03-.548.363-.2 4.06-2.144 2.579-1.981 2.226-1.183 2.438-.629 6.38-.449 1.283-2.138 2.744-.366 1.657-1.87 1.9-.771 1.359-1.958 1.139-1.641 1.591-.921 5.1-.32 6.045.749.8-.485 1.366-4.875 1.43-.915 3.851-5.612.013-2.045v-1.708l.633-2.432-.43-4.391.51-4.446 2.394-5.65 2.109-2.279 3.4-2.3 1.729-.753 2.449-.412v.001l.36-.061.624-.107 8.433-.116c.117-.087 3.067-.042 3.067-.042l2.812-.038 7.116 1.264.506.088 2.4.779 2.774 2.157 2.938 2.869.551.535 1.9.8.575.251 1.571-.251 2.237-1.165 1.688-1.427 2.3-1.257.056-.08 1.295-1.948.039-.04.028.007v-.011h-.022l.511-.775 4.447-1.733 5.23-.3.588-.318.327-.175 1.382-1.623 1.295-.01 3.135 1.134 2.2-.438 1.75.7 1.36-.161 2.565-.3 2.754 1.937 1.605.2 5.658 3.31.294.048.152.028.324.054.671-.2 1-.289.132-.039.126.175.643.907.882.126 1.044-1.393-.415-.632-.157-.23-2.021-.411-1.815-3.1 1.728-1.861-2.711-3.326-.45-.551-.153-.234-.937-1.423-4.746-7.235-6.182-4.935-2.165-1.732-.014-.01-.758-.6-3.3-3.358-2.358-3.13-.309-.674-.487-1.062-1.413-3.078-2.462-1.9-2.006-2.191-.1-.129-4.14-5.626-.68-.943-.978-.565-2.066-.014-.2-.2-.116-.121.07-.074.991-.985 1.105-.278.476-1.089-2.108-6.1-.014-.213-.157-1.95 1.718-8.855.22-1.079 2.928-5.958 1.814-1.486 1.98-3.892 1.7-2.488 1.625-1.582.284-.168 2.934-1.776 2.465-.347 2.348-.331 4.1 1.264 3.9-.076.761-.081 1.77-.2 2.911-.917 1.374-.848.713-1.093 1.487-4.987.478-1.587.917-1.724 5.306-6.108 4.011-3.71 9.019-6.613 4.415-2.639 2.254-1.347 20.126-8.946 5.23-5.3 2.725-2.758 4.821-3.235 5.641-2.311 4.854-3.842 1.06-1.334 1.336-4.3 1.113-.269 1-2.174.286-.618 3.961-2.792.448-.223 15.388-7.71 2.236.307 1.2-1.793 4.477-.751.824-.14 1.1-.551.939-1.6v-.316l.129-4.273.956-1.155.521-2.816.491-.65.513-.676 1.268-.891-.22-.531.032.031z'/%3e%3c/svg%3e";
            },
            49: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3cpath fill='%23d7141a' d='M0 0h900v600H0z'/%3e%3cpath fill='%23fff' d='M0 0h900v300H0z'/%3e%3cpath fill='%2311457e' d='M450 300 0 0v600z'/%3e%3c/svg%3e";
            },
            7558: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'%3e%3cpath d='M0 0h5v3H0z'/%3e%3cpath fill='%23D00' d='M0 1h5v2H0z'/%3e%3cpath fill='%23FFCE00' d='M0 2h5v1H0z'/%3e%3c/svg%3e";
            },
            540: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 15 10'%3e%3cpath d='M0 0h15v10H0z' style='fill:%236ab2e7'/%3e%3cpath d='M0 5h15v5H0z' style='fill:%2312ad2b'/%3e%3cpath d='M0 0v10l4.33-2.5L8.66 5 4.33 2.5 0 0z' style='fill:%23fff'/%3e%3cpath d='m3.314 3.75.31.955H4.63l-.813.59.31.955-.812-.59-.812.59.31-.955L2 4.705h1.004l.31-.955z' style='fill:%23d7141a'/%3e%3c/svg%3e";
            },
            8280: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 370 280'%3e%3cpath fill='%23c60c30' d='M0 0h370v280H0z'/%3e%3cpath fill='%23fff' d='M120 0h40v280h-40z'/%3e%3cpath fill='%23fff' d='M0 120h370v40H0z'/%3e%3c/svg%3e";
            },
            4944: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1200 600'%3e%3cpath fill='%23006b3f' d='M0 0h1200v600H0z'/%3e%3cpath fill='%23fcd116' d='M0 225h1200v100H0z'/%3e%3cpath fill='%23fff' d='M0 275h1200v100H0z'/%3e%3cpath d='M0 275h1200v50H0z'/%3e%3cpath fill='%23fcd116' d='M525 0h100v600H525z'/%3e%3cpath fill='%23fff' d='M575 0h100v600H575z'/%3e%3cpath d='M575 0h50v600h-50z'/%3e%3cg fill='%23006b3f' transform='translate(600 300)'%3e%3ccircle r='150' fill='%23d41c30'/%3e%3cg id='b'%3e%3cpath id='a' stroke='%23000' d='M-4.81-118.41 0-132.13l4.37 13.5 14.65.22-11.59 8.85 5.25 15.05L0-103.8l-12.46 8.85 4.81-14.61-11.37-8.63z'/%3e%3cuse xlink:href='%23a' width='100%25' height='100%25' transform='scale(-1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' width='100%25' height='100%25' transform='rotate(36)'/%3e%3cuse xlink:href='%23b' width='100%25' height='100%25' transform='rotate(72)'/%3e%3cuse xlink:href='%23b' width='100%25' height='100%25' transform='rotate(108)'/%3e%3cuse xlink:href='%23b' width='100%25' height='100%25' transform='rotate(144)'/%3e%3cg stroke='%23000' stroke-width='2.5'%3e%3cellipse cx='680.21' cy='586.13' rx='30.805' ry='189.82' transform='matrix(.28955 -.03018 .01659 .23226 -186.117 -75.926)'/%3e%3cellipse cx='680.21' cy='586.13' rx='30.805' ry='189.82' transform='matrix(.30626 -.03184 .01669 .23225 -188.733 -74.887)'/%3e%3cellipse cx='680.21' cy='586.13' rx='30.805' ry='189.82' transform='matrix(.245 -.0259 .0179 .25675 -151.947 -90.936)'/%3e%3cpath fill='%239c4a00' stroke-width='.657' d='M-44.213 62.565c7.657-.319 4.332-4.416 8.2-6.596 3.864-2.177 9.365-.737 11.015 1.986 1.65 2.722.327 5.397 2.45 5.433 2.126.037 59.928-2.387 62.01-.105 2.085 2.28 2.429 6.776.27 8.524-2.16 1.77-75.235 2.588-77.751.738-2.517-1.824-6.202-9.53-6.194-9.98z'/%3e%3cg fill='%23fcd116' stroke-width='.633'%3e%3cpath d='M-3.377 68.195c-.139 5.775 8.404 4.14 8.521 8.963-.257 5.114-14.324.313-14.46-9.041.585-9.345 14.354-13.963 14.525-8.625.126 4.435-8.447 2.927-8.586 8.703z'/%3e%3cpath d='M1.664 68.261c-.14 5.776 8.403 4.14 8.52 8.964-.257 5.113-14.324.312-14.459-9.042.585-9.345 14.354-13.962 14.524-8.625.127 4.435-8.446 2.928-8.585 8.703z'/%3e%3cpath d='M7.07 68.058c-.138 5.775 8.404 4.14 8.522 8.963-.257 5.114-14.324.313-14.46-9.042.585-9.344 14.354-13.962 14.524-8.624.127 4.435-8.446 2.927-8.585 8.703z'/%3e%3cpath d='M12.111 68.124c-.138 5.776 8.404 4.14 8.521 8.964-.257 5.113-14.324.312-14.46-9.042.586-9.345 14.355-13.962 14.525-8.625.126 4.435-8.447 2.928-8.586 8.703z'/%3e%3c/g%3e%3cellipse cx='478.38' cy='-41.086' fill='%239c4a00' stroke-width='.399' rx='3.534' ry='3.403' transform='matrix(1.37992 .02078 -.03062 1.45444 -625.227 117.205)'/%3e%3cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(.20742 -.0313 .04226 .39514 -119.978 -293.416)'/%3e%3cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(.20742 -.0313 .04226 .39514 -127.335 -293.996)'/%3e%3cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(.20742 -.0313 .04226 .39514 -132.603 -303.411)'/%3e%3cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(.19943 -.03154 .04632 .43593 -125.407 -340.635)'/%3e%3cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(.1995 -.03084 .04356 .40874 -112.65 -316.232)'/%3e%3cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(.1995 -.03084 .04356 .40874 -118.304 -319.639)'/%3e%3cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(.1995 -.03084 .04356 .40874 -125.437 -324.554)'/%3e%3cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(.1995 -.03084 .04356 .40874 -132.042 -327.532)'/%3e%3cpath fill='%239461c9' stroke-width='.575' d='M-14.734-52.686s-14.655 12.72-13.01 47.144C-25.9 29.078 4.648 45.352 4.648 45.352s7.786-9.827 6.882-37.644C9.347-32.96-5.078-50.929-5.078-50.929z'/%3e%3cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(.20968 .00618 -.02884 .39634 -45.183 -309.401)'/%3e%3cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(.20968 .00618 -.02884 .39634 -52.319 -311.283)'/%3e%3cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(.20968 .00618 -.02884 .39634 -55.825 -321.487)'/%3e%3cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(.20186 .00451 -.03211 .4372 -42.11 -356.832)'/%3e%3cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(.2018 .00521 -.02998 .40996 -33.907 -330.547)'/%3e%3cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(.2018 .00521 -.02998 .40996 -38.863 -334.906)'/%3e%3cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(.2018 .00521 -.02998 .40996 -45.006 -341.014)'/%3e%3cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(.2018 .00521 -.02998 .40996 -50.974 -345.121)'/%3e%3cellipse cx='624.42' cy='606.11' fill='%23d41c30' stroke-width='1pt' rx='58.28' ry='186.49' transform='matrix(.19787 -.07643 .08023 .1871 -155.838 -59.213)'/%3e%3cellipse cx='218.13' cy='356.75' stroke-width='1.464' rx='10.823' ry='12.905' transform='matrix(.49828 .00887 -.00657 .36896 -99.51 -162.77)'/%3e%3cellipse cx='218.13' cy='356.75' stroke-width='1.546' rx='10.823' ry='12.905' transform='matrix(.44637 .00795 -.00657 .36896 -84.135 -169.3)'/%3e%3cellipse cx='218.13' cy='356.75' stroke-width='1.546' rx='10.823' ry='12.905' transform='matrix(.44637 .00795 -.00657 .36896 -90.652 -169.416)'/%3e%3cellipse cx='218.13' cy='356.75' stroke-width='1.56' rx='10.823' ry='12.905' transform='matrix(.46714 .00832 -.00617 .34637 -93.888 -166.37)'/%3e%3cellipse cx='218.13' cy='356.75' stroke-width='1.56' rx='10.823' ry='12.905' transform='matrix(.46714 .00832 -.00617 .34637 -94.462 -172.017)'/%3e%3cellipse cx='218.13' cy='356.75' stroke-width='1.546' rx='10.823' ry='12.905' transform='matrix(.44637 .00795 -.00657 .36896 -96.878 -173.22)'/%3e%3cellipse cx='218.13' cy='356.75' stroke-width='1.562' rx='10.823' ry='12.905' transform='matrix(.44637 .00795 -.00644 .36143 -95.469 -176.631)'/%3e%3cellipse cx='218.13' cy='356.75' stroke-width='1.464' rx='10.823' ry='12.905' transform='matrix(.49828 .00887 -.00657 .36896 -114.725 -179.37)'/%3e%3cellipse cx='218.13' cy='356.75' stroke-width='1.56' rx='10.823' ry='12.905' transform='matrix(.46714 .00832 -.00617 .34637 -98.157 -179.081)'/%3e%3cellipse cx='218.13' cy='356.75' stroke-width='1.562' rx='10.823' ry='12.905' transform='matrix(.44637 .00795 -.00644 .36143 -100.291 -183.521)'/%3e%3cellipse cx='218.13' cy='356.75' stroke-width='1.546' rx='10.823' ry='12.905' transform='matrix(.44637 .00795 -.00657 .36896 -110.489 -178.906)'/%3e%3cellipse cx='218.13' cy='356.75' stroke-width='1.562' rx='10.823' ry='12.905' transform='matrix(.44637 .00795 -.00644 .36143 -108.857 -179.772)'/%3e%3cellipse cx='218.13' cy='356.75' stroke-width='1.562' rx='10.823' ry='12.905' transform='matrix(.44637 .00795 -.00644 .36143 -106.807 -183.696)'/%3e%3cellipse cx='528.68' cy='564.48' stroke-width='2.545' rx='67.438' ry='205.64' transform='matrix(.21932 -.07743 .08683 .20202 -145.015 -72.556)'/%3e%3cellipse cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(.20574 -.09785 .09471 .21196 -137.122 -77.403)'/%3e%3cg stroke-width='.575'%3e%3cpath d='M31.463 7.799c12.81 15.598 11.193 25.503 9.857 33.883-4.025-9.663-6.223-15.746-19.035-31.347-12.813-15.6-6.418-26.548-5.538-32.316 1.926 4.993 1.903 14.179 14.716 29.78z'/%3e%3cpath d='M32.616 20.398C45.426 35.996 43.81 45.9 42.473 54.28c-4.024-9.663-6.222-15.746-19.035-31.347C10.625 7.334 17.021-3.613 17.9-9.382c1.927 4.993 1.903 14.179 14.716 29.78z'/%3e%3cpath d='M33.002 30.545c13.12 15.323 11.7 25.26 10.532 33.667-4.217-9.576-6.536-15.61-19.658-30.936-13.122-15.325-6.947-26.405-6.183-32.19 2.026 4.95 2.186 14.134 15.309 29.46z'/%3e%3c/g%3e%3cellipse cx='528.68' cy='646.07' stroke-width='1.389' rx='13.321' ry='40.796' transform='matrix(.40784 -.1038 .16694 .37767 -299.57 -196.03)'/%3e%3cellipse cx='528.68' cy='646.07' stroke-width='1.64' rx='13.321' ry='40.796' transform='matrix(.3669 -.0631 .12978 .31265 -259.003 -166.871)'/%3e%3cellipse cx='528.68' cy='646.07' stroke-width='1.64' rx='13.321' ry='40.796' transform='matrix(.36815 -.05532 .12326 .31531 -261.524 -166.82)'/%3e%3cellipse cx='528.68' cy='646.07' stroke-width='2.097' rx='13.321' ry='40.796' transform='matrix(.29658 -.05431 .11151 .23308 -211.07 -135.538)'/%3e%3cellipse cx='528.68' cy='646.07' stroke-width='2.097' rx='13.321' ry='40.796' transform='matrix(.29952 -.038 .0968 .23873 -208.27 -143.865)'/%3e%3cpath stroke-width='.575' d='M8.62-15.768C12.407-6.513 13.94 1.81 12.04 2.81c-1.899.999-6.513-5.7-10.301-14.956'/%3e%3cellipse cx='528.68' cy='646.07' stroke-width='2.097' rx='13.321' ry='40.796' transform='matrix(.29952 -.038 .0968 .23873 -208.894 -154.737)'/%3e%3cellipse cx='528.68' cy='646.07' stroke-width='2.097' rx='13.321' ry='40.796' transform='matrix(.30032 -.0321 .09144 .24056 -212.194 -155.987)'/%3e%3cg stroke-width='.575'%3e%3cpath d='M2.026-28.338c3.678 6.254 5.658 12.094 4.418 13.037-1.238.942-5.227-3.368-8.905-9.622'/%3e%3cpath d='M4.573-32.485C8.25-26.231 10.23-20.391 8.99-19.448c-1.238.942-5.227-3.368-8.905-9.622m15.928-2.537c5.125 8.543 7.883 16.52 6.154 17.81-1.727 1.29-7.288-4.598-12.413-13.14'/%3e%3cpath d='M8.452-36.082c3.693 6.904 5.687 13.348 4.45 14.385-1.237 1.036-5.236-3.727-8.929-10.632'/%3e%3c/g%3e%3cg fill='%239461c9'%3e%3cg stroke-width='.591'%3e%3cpath d='M8.125-46.086c-2.466 2.482-.051 7.123 2.205 8.8 2.53 2.295 16.742 17.287 26.769 4.673-8.034-.146-23.027-19.004-28.974-13.473z'/%3e%3cpath d='M6.369-53.486c-2.465 2.483-.05 7.124 2.206 8.802 2.53 2.294 16.742 17.286 26.768 4.672-8.033-.146-23.026-19.005-28.974-13.474z'/%3e%3cpath d='M4.123-60.576c-2.466 2.482-.051 7.124 2.205 8.801 2.53 2.294 16.742 17.286 26.769 4.672-8.034-.146-23.027-19.004-28.974-13.473z'/%3e%3cpath d='M-.759-68.687c-2.465 2.483-.05 7.124 2.206 8.801 2.53 2.295 16.742 17.287 26.769 4.673C20.182-55.36 5.189-74.218-.76-68.687z'/%3e%3c/g%3e%3cpath stroke-width='.628' d='M-18.272-76.448c5.08-3.78 14.412-4.884 21.681-1.183 6.056 2.966 16.148 15.073 23.735 17.935-5.34.952-8.59.147-12.002-1.492-6.739 4.88-9.14 5.611-16.008 6.57-9.551 1.378-17.48-1.108-20.266-6.09-2.839-4.699-1.615-12.238 2.86-15.74z'/%3e%3c/g%3e%3cellipse cx='287.23' cy='323.04' fill='%23d41c30' rx='14.154' ry='14.986' transform='matrix(.3091 .0055 -.00301 .16933 -95.304 -125.19)'/%3e%3cellipse cx='204.58' cy='348.26' fill='%23fcd116' rx='23.254' ry='15.895' transform='matrix(.2458 -.09144 .08132 .21925 -99.445 -116.289)'/%3e%3ccircle cx='283.9' cy='333.86' r='5.828' fill='%23000' stroke='none' transform='matrix(.2699 .0048 -.00416 .23342 -82.956 -148.374)'/%3e%3cpath fill='%23fcd116' stroke-width='.732' d='M-17.128-65.515c.402 1.95-1.043 4.583-4.18 5.515-3.195 1.323-5.618 4.322-7.016 9.227-4.856-11.184-1.77-15.916 3.388-17.066 4.436-1.415 7.11-1.236 7.808 2.324z'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";
            },
            7316: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3e%3cpath fill='%23fff' d='M0 0h900v600H0z'/%3e%3cpath fill='%23002d62' d='M0 0h390v240H0z'/%3e%3cpath fill='%23ce1126' d='M0 360h390v240H0z'/%3e%3cpath fill='%23002d62' d='M510 360h390v240H510z'/%3e%3cpath fill='%23ce1126' d='M510 0h390v240H510z'/%3e%3cpath fill='%23201b18' d='M434.183 245.772c-8.326-.144-16.733 1.755-23.725 6.092-3.214 1.995-3.97 2.666-2.203 5.871-.417.287-3.343 1.181-4.066 1.437-2.677 1.013-5.393 2.032-7.667 3.397-1.383.83-1.961 1.451-3.022 2.553l6.671-.512c-.21.431-.692 1.053-.966 1.467-1.14 1.645-1.848 2.953-2.845 4.675 1.89-1.279 3.59-2.475 5.771-3.542 4.774-2.407 13.357-2.472 16.878-6.7.9-1.068.353-1.706-.404-3.444 2.606-.863 3.586-1.467 6.752-2.186 7.652-1.706 12.925.32 16.622-.59 1.156-.288 2.282-.925 2.362-2.138l-.546-3.86 12.424-.016c.016 2.187-2.089 4.993 1.77 5.998 3.487.909 10.543-1.084 16.635.606l6.752 2.184c-.033.321-.516 1.182-.66 1.63-.289.78-.257 1.195.242 1.753.658.75 1.59 1.5 2.587 2.074 1.977 1.13 4.565 1.85 7.01 2.44 7.023 1.707 7.682 2.153 13.083 5.759-.354-1.053-2.926-4.802-3.778-6.126l6.64.527c-1.143-1.739-4.646-3.573-6.672-4.37l-8.086-2.952c.737-1.41 1.35-2.584.612-3.748-1.125-1.707-7.873-5.023-9.58-5.488a85.494 85.495 0 0 0-8.852-1.903c-2.879-.46-8.411-.857-8.411-.857-.397-.418.762-2.613-1.013-4.148-1.044-.828-2.555-1.116-4.1-1.276-6.17-.59-14.578-.414-20.815 0-1.8.111-3.068.305-4.1 1.277-1.253 1.18-1.413 1.897-1.302 4.116z'/%3e%3cg fill='%23002d62'%3e%3cpath d='M435.915 250.17c.915-.815 1.044-1.053 2.506-1.548 3.183-1.068 8.198-.973 11.558-.973 2.733.015 5.402-.032 8.101.224 2.733.27 4.34.605 6.157 2.184.322-1.898.74-3.524.803-5.614.081-2.248-1.189-2.92-3.183-3.318-3.295-.686-8.824-.622-12.375-.59-2.316.015-10.545.08-12.218.686-1.527.542-2.733 1.738-2.603 3.812.047 1.036.82 4.483 1.254 5.136z'/%3e%3cpath d='M411.7 260.922c.563-.511.177-1.022 2.781-2.473 3.28-1.835 7.877-3.525 11.637-4.275 3.263-.638 6.623-.622 10.03-.367 1.511.112 3.505.352 5 .112 0 0 1.612-.377 2.065-.777.592-.523.555-1.728.555-1.728-1.093-.878-4.212 2.154-7.04 1.197-.917-.302-1.174-1.787-1.529-2.807l-.915-3.478c-5.175-.67-14.049 1.405-18.839 3.542-2.17.957-5.738 2.76-7.072 4.147-1.19 1.212.032 2.984.707 3.876.852 1.105 2 2.412 2.62 3.03zm44.535-9.591c-.29 1.818 1.045 2.344 2.653 2.583 3.326.465 8.31-1.051 14.917.24 2.829.559 5.593 1.5 8.052 2.504.997.414 4.468 2.027 5.176 2.729l1.254 1.5c.354-.192 2.266-2.49 2.652-2.984.74-.942 1.833-2.632.706-3.924-.979-1.133-5.255-3.35-7.151-4.164-2.532-1.086-6.558-2.056-9.68-2.584-3.182-.537-9.526-1-9.526-1s-.405 5.898-2.028 6.391c-3.167.941-4.71-1.706-7.025-1.291z'/%3e%3cpath d='M481.266 258.653c-.209.91-.61.989 1.062 2.377 3.906 3.222 10.479 3.382 14.594 5.152 2.089.908 3.247 1.658 5.095 2.775-.177-.543-2.571-4.003-3.166-4.913 1.832-.032 4.228.144 6.108.256-.095-.064-.145-.16-.257-.256-2.765-2.424-9.806-4.642-13.342-5.806-1.02 1.193-1.996 2.352-3.118 3.525-.434.414-.706.703-1.574.463-1.093-.303-1.946-1.244-2.604-1.835-.643-.574-1.946-1.657-2.798-1.738zm-24.934-7.914c1.994.144 2.267.51 3.778 1.181.61.27 1.383.398 2.17.335 1.077-.08 1.205-.224 1.495-1.07.417-1.21-1.625-2.008-2.572-2.217l-4.388-.653zm-12.698.022-.418-2.394c-1.318-.143-7.426.895-6.976 2.776.224.878.418 1.021 1.383 1.117 2.652.24 3.07-1.419 6.01-1.499zm-31.439 10.527c.885 1.578 3.248-1.244 4.629-2.266.788-.59.885-.575 1.768-.94l-.481-.767c-.756.16-2.654 1.196-3.36 1.58-1.045.573-2.202 1.323-2.556 2.392z'/%3e%3cpath d='M481.439 258.083c.288.143.578.175.915.383 1.977 1.148 4.388 4.227 5.337 3.078.578-.717-1.575-2.186-2.235-2.536l-3.486-1.675a1.988 1.988 0 0 0-.531.75zm-62.781.635c.208.909.61.99-1.062 2.376-3.906 3.223-10.48 3.383-14.594 5.152-2.089.91-3.248 1.66-5.097 2.776.178-.542 2.573-4.004 3.167-4.913-1.832-.032-4.228.144-6.109.255.097-.064.147-.16.259-.255 2.765-2.424 9.805-4.643 13.341-5.806.37.383.674.797 1.012 1.197.418.51 1.64 1.88 2.106 2.328.434.414.706.702 1.574.462 1.094-.303 1.946-1.243 2.604-1.834.644-.575 1.946-1.659 2.799-1.739z'/%3e%3c/g%3e%3cpath fill='%23eac102' d='M419.582 249.718c-.564-.012-1.07.266-1.574.475-.162.048-.586.206-.263.355.25.112.25.432.367.65.135.377.253.757.41 1.127.186.61.414 1.208.641 1.805.04.15-.146.538.173.38.323-.128.654-.235.979-.366a1.851 1.851 0 0 0 1.091-.878c.12-.186.132-.414.192-.624a1.01 1.01 0 0 0-.002-.538c-.04-.26-.059-.532-.187-.767-.133-.333-.273-.679-.544-.923-.231-.254-.5-.486-.829-.595a.94.94 0 0 0-.454-.101zm-.268.393c.383-.022.657.312.834.61.157.306.281.627.424.94.158.495.336 1.01.262 1.54-.059.28-.333.459-.56.607-.248.139-.486-.099-.49-.347-.09-.25-.202-.492-.278-.747-.186-.434-.298-.896-.493-1.326a5.81 5.81 0 0 1-.279-.902c-.07-.293.304-.363.517-.38a.384.384 0 0 1 .063.005zm2.203-1.093c.09.14.313.165.306.37.09.26.183.518.242.787.068.209.105.425.192.628.075.275.158.549.233.825.092.263.194.525.246.8.035.209.194.448.06.646-.085.094-.052.235.094.159.219-.015.404-.151.621-.161.123-.043.421-.043.407-.19-.133-.113-.313-.192-.307-.399-.093-.314-.197-.625-.282-.938-.067-.225-.128-.453-.206-.672-.05-.172-.075-.355-.14-.526a62.622 62.622 0 0 1-.33-1.096c-.06-.152-.105-.302.032-.434.048-.223-.291-.025-.411-.026-.257.053-.502.16-.757.227zm3.666-1.021c-.333-.014-.634.182-.871.398-.25.296-.43.667-.418 1.062-.02.35-.05.707.05 1.048.11.537.375 1.032.706 1.466.229.228.511.4.81.516.255.059.531.08.785.012.423-.137.754-.494.878-.918.103-.29.186-.596.171-.907.007-.295-.103-.575-.153-.862a3.207 3.207 0 0 0-.396-.88c-.182-.245-.418-.446-.634-.656a1.41 1.411 0 0 0-.886-.276l-.04-.002zm-.019.285c.363.054.611.376.733.7.242.471.342.996.495 1.5.067.21.05.435.106.648.042.296.039.616-.088.892-.155.248-.534.326-.758.126-.232-.153-.327-.426-.46-.656-.086-.315-.235-.609-.299-.93-.059-.258-.17-.5-.19-.765-.063-.408-.168-.843-.017-1.245.07-.199.284-.272.477-.27zm2.956-.64c-.152.203-.276.419-.307.67-.052.258.036.516.087.767a1 1 0 0 0 .476.568c.333.242.716.4 1.083.582.246.096.512.248.59.52.059.183.083.393.016.577-.09.203-.288.385-.525.322a.829.829 0 0 1-.596-.266 1.486 1.486 0 0 1-.463-.732c-.096-.186-.283 0-.224.147-.043.21-.083.44-.036.648.139.15.346.217.512.333.218.1.454.185.698.186.229-.034.476-.02.679-.147.224-.111.425-.26.526-.5.136-.28.201-.612.105-.916a1.427 1.427 0 0 0-.863-1.074 5.026 5.026 0 0 0-.756-.344c-.287-.137-.626-.307-.695-.648-.064-.232-.003-.54.247-.633.235-.103.502-.01.68.156.157.135.257.32.341.504-.045.247.343.152.216-.05-.067-.201.213-.5-.054-.626-.215-.127-.44-.25-.694-.275a1.158 1.158 0 0 0-.798.11c-.082.041-.163.085-.246.122zm14.008-5.483c-.373 0-.739.091-1.105.152-.15.113-.515-.026-.541.195a.829.829 0 0 1 .254.534c.049.345-.038.7.06 1.04.016.244-.043.5.055.735.032.366-.05.747.07 1.102.032.229.104.512-.09.692-.205.17.134.258.264.169.262-.03.526-.054.786-.091.197-.053.072-.212-.035-.275-.153-.256-.109-.568-.13-.851-.005-.22 0-.44-.007-.658.257-.128.555-.095.819-.202.498-.115.989-.475 1.082-1.003.104-.47-.111-.975-.476-1.274a1.762 1.762 0 0 0-1.006-.265zm-.084.386c.316-.043.533.257.63.52.075.228.068.474.06.713-.017.368-.343.65-.69.702-.17.022-.473.076-.406-.185-.03-.283-.078-.564-.053-.85-.014-.268-.155-.562-.005-.817.113-.144.315-.042.464-.083zm3.333-.59c-.242-.063-.457.17-.425.403-.068.289-.09.588-.18.87a12.343 12.343 0 0 1-.232 1.254c-.109.513-.186 1.037-.363 1.534-.007.147-.33.329-.15.426.258-.029.518-.014.779-.026.232-.09-.111-.259-.153-.385-.035-.197.017-.403.05-.599.019-.109.027-.235.166-.197l.97-.007c.022.267.179.515.153.787-.066.12-.161.396.081.335.305-.006.603-.101.909-.079.254-.074-.09-.246-.119-.383-.126-.283-.201-.585-.285-.881-.084-.368-.202-.726-.293-1.09-.085-.202-.118-.414-.181-.622a11.659 11.659 0 0 1-.322-1.256c-.015-.137-.295-.064-.405-.084zm-.198 1.008c.189.537.284 1.103.48 1.637.11.195-.09.303-.258.251-.19-.03-.612.179-.616-.128.083-.209.11-.43.147-.65a8.63 8.63 0 0 0 .147-.828c.023-.097.06-.19.101-.282zm3.659-1.149-1.56.018a1.05 1.05 0 0 1-.081.485l-.066.51c.173.029.233-.177.337-.272.16-.166.33-.372.583-.362.13.007.337-.075.283.13.007.217.079.424.059.64.01.96.033 1.92.014 2.88-.005.133-.152.18-.202.296.05.062.31.011.44.03.248 0 .496.007.746-.006.116.025.104-.171-.033-.177-.093-.22-.073-.469-.09-.703-.01-1.03-.045-2.059-.004-3.088.127-.075.29-.154.424-.058.117.07.243.13.356.205l.232.341c-.036.027.25.148.177-.028.012-.197-.084-.375-.09-.57-.036-.153.023-.382-.21-.317-.44-.03-.875.042-1.314.047zm3.558-.117c-.336-.019-.663.085-.999.06-.108-.005-.32.038-.145.142.197.141.135.386.139.591-.022 1.04.03 2.08-.024 3.121-.035.174-.066.365-.235.46.034.137.314.028.443.067.272.008.545.012.817.02-.006-.161-.235-.234-.172-.41l.007-1.446c.235-.072.401.08.415.318.034.218.147.408.234.606.112.216.249.42.402.605.184.151.337.343.542.467.152.054.313.08.47.121.006-.196-.19-.304-.275-.463-.175-.29-.265-.621-.41-.927a2.402 2.402 0 0 1-.194-.634c-.13-.206.128-.179.249-.27a1.262 1.262 0 0 0 .527-.544c.137-.229.123-.505.108-.762-.015-.233-.165-.422-.293-.605-.144-.165-.36-.257-.551-.356a4.126 4.126 0 0 0-.749-.158c-.1-.005-.205 0-.305-.003zm.307.341c.23-.016.434.107.577.275.111.143.15.336.168.517 0 .191.017.391-.033.578-.09.247-.283.485-.56.515-.2.024-.414.068-.61.026-.048-.141-.005-.308-.02-.46 0-.389-.004-.779.012-1.168.024-.273.25-.273.466-.283zm2.78.402c-.007.194-.062.383-.045.578-.01.341-.014.683-.055 1.02-.046.575-.013 1.151-.03 1.725-.036.168-.08.344-.197.475-.07.07-.112.141.022.114.171-.02.33.04.495.066.207 0 .412.013.616.015.202-.061-.111-.155-.084-.281-.103-.237-.046-.497.004-.738.03-.542-.022-1.09.07-1.63.03-.33-.034-.665.026-.994.1-.192-.034-.458.169-.605.044-.081.123-.179-.026-.149-.25-.002-.504.011-.75-.051-.118.007-.403-.093-.41.061.065.13.228.236.195.392zm3.15-.151c-.081.358-.24.694-.328 1.051-.063.217-.145.43-.204.65-.13.343-.22.7-.347 1.047-.136.437-.248.901-.549 1.261-.171.059-.14.346.068.239.204.012.4.08.609.064.166.057.211-.115.055-.182-.197-.155-.215-.43-.09-.631-.006-.249.2-.373.423-.303.252.022.505.075.76.068.008.239.111.467.116.709.04.172-.3.495.008.481.265.029.525.09.792.081.122.008.295-.006.162-.15-.175-.347-.193-.746-.275-1.12-.012-.403-.132-.79-.165-1.19-.072-.405-.184-.806-.199-1.22a2.36 2.36 0 0 0-.11-.59c.022-.166-.102-.25-.253-.2-.159-.015-.312-.085-.474-.066zm.05.951c.12.253.078.538.14.804.048.316.06.638.155.944.09.354-.354.184-.54.165-.168.013-.49.002-.328-.25.07-.181.112-.375.177-.56.055-.18.105-.358.152-.539.148-.15.107-.4.224-.563l.02-.002zm8.003 4.424c.003.198.28.275.227.5-.02.476.002.952.039 1.428.01.728.051 1.456.004 2.183a.38.38 0 0 1-.13.296c-.15.103.09.148.18.128l2.192-.08c.06-.326.143-.651.153-.983-.002-.163-.144-.087-.172.032-.196.279-.464.566-.827.58-.18-.004-.42.065-.554-.08-.066-.175-.047-.372-.067-.555a39.65 39.65 0 0 1-.02-2.943c-.017-.207.095-.386.17-.57zm2.979 4.418 1.18-.004c-.01-.235-.158-.098-.182-.437-.02-.298.019-3.434.048-3.645.057-.388.177-.225.177-.408l-1.16-.03c.003.306.148.03.157.477.004.196-.005.404-.005.598 0 .506.01 2.67-.02 3.008-.023.295-.185.211-.195.441zm1.839-4.525c.045.174.228.293.171.505.01.49-.093.971-.096 1.461a32.664 32.664 0 0 1-.093 1.719c-.03.205-.016.428-.112.615-.087.038-.28.167-.08.204.481.096.98.06 1.459.18.353.087.72-.027 1.03-.197.423-.288.531-.874.41-1.344-.044-.23-.223-.38-.387-.527a16.22 16.22 0 0 0-.42-.37.952.952 0 0 0 .825-.734c.076-.313.026-.68-.216-.912-.072-.083-.136-.18-.246-.22-.179-.104-.358-.212-.568-.237-.554-.1-1.118-.108-1.677-.143zm1.041.409c.23.016.502-.02.661.185.28.3.265.768.09 1.118-.025.153-.205.252-.346.298-.185.046-.378.023-.565.011-.047-.37.047-.743.038-1.116.005-.171.018-.354.123-.496zm-.235 1.946c.332.016.704.07.923.349.206.264.14.618.155.928-.036.394-.42.756-.825.686-.216-.012-.346-.154-.305-.368a11.336 11.336 0 0 1 .052-1.595zm2.14 2.492c.092.16.312.113.464.176.365.08.73.16 1.09.257.312.06.623.129.934.191.057-.242.248-.438.276-.691.133-.179-.146-.295-.23-.11a1.153 1.153 0 0 1-1.09.193c-.257-.01-.436-.229-.345-.477.027-.515.082-1.034.223-1.53.156-.056.359.03.514.093.22.093.333.31.432.51.15.116.14-.24.165-.338.02-.303.062-.606.098-.907-.244.036-.343.428-.64.28-.19-.076-.625.038-.517-.283.03-.357.137-.702.216-1.052.384-.122.808.063 1.042.376.137.123.232.425.365.456.074-.3.022-.612.026-.917-.116-.187-.393-.134-.577-.222-.56-.133-1.115-.296-1.685-.379-.32-.06.109.232.034.39l-.303 2.043c-.08.525-.121 1.056-.23 1.578a.606.606 0 0 1-.262.363zm3.774-3.568c.13.246.145.535.069.8-.137.666-.32 1.323-.415 1.998-.079.404-.154.808-.23 1.21-.036.18-.472.313-.145.427.28.116.577.182.861.281.284.011-.066-.296.024-.451.042-.305.145-.599.171-.905.05-.158 0-.47.235-.472.254.018.121.351.187.515.09.483.227.963.43 1.41.151.292.426.49.692.663.065-.184-.16-.474-.187-.696-.091-.31-.096-.63-.108-.95l-.037-.744c.257-.082.528-.141.732-.33.293-.319.4-.795.286-1.214a1.655 1.655 0 0 0-.82-1.034c-.464-.27-1.016-.285-1.513-.46a1.456 1.456 0 0 0-.232-.048zm1.01.602a.806.806 0 0 1 .744.464c.159.443.104.962-.16 1.353-.159.215-.446.234-.686.173-.207-.01-.476-.077-.347-.34.069-.44.185-.87.253-1.312a.898.898 0 0 1 .196-.338zm1.914 1.452c.207.02.336-.216.535-.257.185-.076.426-.171.59-.005.121.145.039.355-.008.515-.08.274-.135.558-.207.836l-.485 2.038c-.07.186-.07.426-.307.479-.103.212.286.201.414.302.231.101.464.194.71.262-.012-.185-.171-.341-.09-.545.092-.528.249-1.042.363-1.568a39.122 39.122 0 0 1 .485-1.896c.266-.083.485.156.59.372.1.202.152.424.256.624.167-.109.101-.342.128-.51l.049-.5c-.336-.177-.71-.267-1.053-.432-.25-.115-.515-.202-.773-.306l-.82-.318c-.16.228-.213.508-.366.74a.347.347 0 0 0-.01.168zm4.204.84c-.175.113-.237.332-.344.503-.12.21-.286.391-.401.605-.362.586-.717 1.178-1.084 1.762-.153.206-.327.421-.57.524-.16.214.225.243.344.33.118.08.35.279.44.191-.038-.214-.192-.424-.072-.64.096-.168.143-.555.404-.38.251.157.538.263.752.473.07.19-.076.4-.04.605.075.218-.285.36-.191.52.19.145.42.223.62.349.14.058.411.272.333-.014-.01-.292-.07-.592-.007-.88.11-.212.057-.47.083-.702-.002-.32.077-.632.098-.949.053-.521.097-1.043.157-1.564.016-.173.152-.478-.09-.519-.15-.05-.262-.255-.432-.215zm-.3.934c.028.071.084.14.053.22-.061.55-.15 1.096-.19 1.647.006.272-.316-.026-.44-.077-.165-.1-.469-.168-.268-.4.164-.284.397-.523.538-.821.109-.185.245-.36.307-.57zm2.751.57c-.046.272-.008.565-.207.788a5.615 5.615 0 0 1-.446.747c-.16.289-.303.585-.482.863a61.4 61.4 0 0 1-.682 1.128c-.134.034-.388.061-.181.233.163.211.392.359.564.565.256.234.515.468.759.71.386.277.96.408 1.37.105.195-.192.41-.365.58-.58a4.239 4.239 0 0 0 .4-.815c.112-.371.178-.762.132-1.15-.04-.617-.354-1.191-.773-1.633-.244-.244-.512-.466-.76-.706-.103-.07-.181-.17-.274-.255zm.743 1.107c.33.232.545.627.515 1.037-.034.649-.337 1.25-.702 1.772-.199.323-.43.692-.827.778-.302.079-.608-.124-.747-.381-.128-.287.088-.576.202-.83.322-.563.686-1.107.979-1.688.112-.233.246-.47.45-.636.04-.02.081-.06.13-.052z'/%3e%3cpath fill='%23006300' d='M435.984 348.957c.799.274 2.433 1.036 3.094 1.343 0 0 2.288 4.27 2.257 4.208.869.616.73.48 1.702.72l-5.384 2.223c-1.563.582-.938 1.95-.208 2.224.8.24 2.466-.445 3.057-.719 2.674-1.232 5.104-2.497 7.5-4.037.384-.24 2.155-1.47 2.503-1.403l9.517 5.406c.694.308 2.084 1.198 2.848.65.312-.205.8-.685.625-1.232-.14-.58-.521-.684-.972-.854-.73-.309-5.037-2.259-5.176-2.259l1.147-.308c.347-.24-.252-.95.2-.813l2.37-3.875 2.952-1.06c-.02-2.72-22.224-4.412-28.032-.214z'/%3e%3cpath fill='%23ff0' d='M437.527 358.098c-.8.24-.59 1.78 1.008 1.266 1.077-.377.244-1.675-1.006-1.265zm23.62.065c-.244.581-.21.854.347 1.094.59.274.938.274 1.32-.137.52-.512.104-.718-.348-.957-.486-.275-.104-.24-.486-.138-.277.103-.486.07-.833.138z'/%3e%3cpath fill='%23006300' stroke='olive' stroke-width='.283' d='M482.247 269.909c-.07.109-.136.072.075.432 2 4.022 1.29 2.12 2.94 7.364-.316-.323-.738-.896-1.054-1.326-.877-1.185-1.676-2.48-2.412-3.773-.176-.36-.287-.464-.602-.715-.14.395.56 2.508.735 3.084.737 2.586 2.704 5.537 4.142 7.872-.421-.215-.668-.547-1.018-.87-1.263-1.04-.91-.782-1.646-2.075-.701-1.222-1.263-2.522-1.754-3.85a62.435 62.435 0 0 0-1.085-2.723c-.14.18-.038-.145-.142.25-.105.36.031.787.067 1.145.175 1.51.421 3.023.668 4.531-1.018-.43-.761-.504-1.65-1.23-.21-.109-.487-.713-.734-.785l-.847-.998c-.21.54 1.138 3.014 1.489 3.3.427.735 2.233 2.01 2.443 2.513.771 1.797 1.472 3.198 2.663 4.634l1.055 1.362-2.315-2.335c-1.684-1.545-2.348-2.186-4.243-3.695.036.539.702 1.003 1.052 1.327l2.895 3.177c.91 1.185 2.011 2.285 2.818 3.541l1.83 3.085c-.21-.36-.739-1.037-1.02-1.396l-2.8-3.484c-.983-1.186-2.07-2.009-3.333-3.014-1.053-.863-2.474-1.779-2.474-1.779 0 .462 2.355 3.434 4.052 4.328.53.499 1.035 1.024 1.511 1.575.492.54.948 1.011 1.404 1.587.841 1.149 1.676 2.472 2.414 3.729l1.127 1.98c-.876-.32-4.948-4.954-5.93-5.96-.807-.826-1.154-1.298-2.172-1.8.07.503 2.836 3.668 3.467 4.35.28.287.39.463.601.715l1.228 1.404c.807.97 2.278 2.687 2.84 3.764l.843 1.732c-.036-.18-1.65-2.298-1.897-2.55a11.75 11.75 0 0 0-1.052-1.258c-.912-1.005-2.42-2.7-3.506-3.453l-2.808-1.612c-.14.289.46.713.81.999l1.053 1.009c1.263 1.005 2.977 2.945 3.959 4.238.666.79 1.158 1.55 1.72 2.411-.35-.215-.632-.539-.877-.826-.386-.396-.56-.504-.91-.827-.526-.54-1.228-1.039-1.93-1.543l-4.526-2.23c.07.36 1.576 1.29 1.996 1.542.877.574 2.352 1.508 3.124 2.334.35.36.527.617.843.904.666.61 1.161 1.253 1.687 2.008.526.755.979 1.328 1.47 2.12.527.825.84 1.548 1.261 2.445l1.545 5.711c-.49-1.868-1.438-3.922-2.104-5.754-.526-1.4-1.687-4.805-3.475-4.195-.665.251-.98.967-1.261 1.543-.421.789-.986-.29-2.389 2.583-.77 1.616-1.293 3.485-1.645 5.28a1.79 1.79 0 0 0 0 .862c.35-.144.595-1.11.736-1.543.7-1.759 1.406-2.8 2.388-4.452l-1.336 6.072c.455-.07.601-.869.776-1.3.596-1.51 1.118-3.013 1.68-4.523 1.998 1.4 2.633 8.945 2.914 11.638-.211-.933-.983-2.944-1.403-3.842l-2.039-3.377c-1.192.145-1.331 1.65-1.611 2.585-.35-.467-.705-1.252-1.512-1.18-.736.036-1.014.896-1.12 1.723a9.6 9.6 0 0 0 .034 2.652c.036.18.246 1.942.352 2.085l.25.25.418-5.168c.771.358 2.248 3.7 2.037 5.065-.77 4.993-1.234 6.568-3.9 10.697-.455.72-.944 1.473-1.47 2.12-.246.36-.488.685-.769 1.008l-.876.973c1.368-2.37 1.957-3.308 2.94-6.038.7-2.048 1.299-4.2 1.544-6.392.042-.347.03-.698-.033-1.042-.281.107-.354.503-.46.826-2.315 7.185-2.625 7.432-6.414 13.825l.703-4.091c-.351.035-.287.216-.427.611-.105.288-.204.505-.31.793-.525 1.58-1.053 3.121-1.895 4.522.07-.43.311-1.008.45-1.438.387-1.33.633-2.761.844-4.126l.034-.94c-.421-.036-.45.789-.626 1.293-.455 1.472-1.121 2.77-1.787 4.134v-.396c.14-.899.384-2.264.209-3.161 0 0 .136.22-.11-.319-.35.108-.42.788-.492 1.11-.107.425-.235.845-.384 1.258-.876 2.443-1.96 4.019-3.224 6.246-.74-.022-.158.052.167.077-.104-.026-.18-.044-.175-.052.515.072.39.07.175.052 1.048.265 7.025 1.395 7.025 1.395 3.472-.143 5.781-.427 9.22-.068.525.036 2.666.432 2.981.18-1.018-.574-1.993-.828-3.115-1.187l-3.3-.828 9.362-.25-.843-.466c-1.542-.61-5.717-.865-7.365-.972 3.086-.288 5.373-.532 8.46-.569.805-.23 3.552.657 2.346-.577-1.087-.755-4.63-.862-5.787-.827l5.545-.25c.882-.227 6.581 1.101 4.56-.215-1.578-.79-5.056-1.515-6.74-1.765.983-.575 1.863-1.147 2.915-1.576 2.104-.899 4.42-1.544 6.665-2.154 2.471-.385 4.332-1.563 1.085-1.043-1.998.216-4.417.785-6.172.965l1.58-.862c1.542-.79 3.326-1.113 5.01-1.688.316-.108.213.003.317-.284l-.275-.103c-.315-.037-.603.102-.919.137 1.018-.61 3.825-1.187 4.877-1.438a73.75 73.75 0 0 0 3.792-.999c.386-.108.91-.108 1.119-.431l-.242-.147c-.386-.144-7.189.865-7.926 1.008-.666.107-1.935.396-2.497.396 2.07-.861 4.106-1.764 6.281-2.411.385-.108 1.969-.391 2.18-.75-.422-.18-.774-.073-1.37.034-2.035.324-4.001.863-5.93 1.474-.666.215-1.582.571-2.214.714 6.98-2.693 4.32-1.904 10.775-3.16.736-.145 1.332-.075 1.402-.577l-3.716-.217c-1.228.037-2.49.326-3.507.362l2.763-2.334c.773-.647.422-.825 1.754-.86.527-.038 2.141.075 2.457-.104-.948-.97-1.227-.47-2.139-.974l1.128-1.37c.28-.358.558-.678.768-1.145.105-.215.104-.175.033-.319l-.45.07-2.882 2.367c-.491.36-.382.327-1.12.362-1.262.109-2.492.5-3.65.716 1.37-1.078 2.242-1.72 3.752-2.62.666-.43 1.37-.793 2.07-1.188.562-.288 1.966-.752 2.071-1.11l-4.45 1.145c-.878.323-3.3 1.472-3.826 1.903 1.964-2.19 4.976-4.7 7.29-6.46.281-.216.99-.572 1.095-.896-.175-.071-.25-.114-.426-.078-1.228.252-3.997 2.12-4.944 2.731-1.578 1.042-3.3 2.19-4.702 3.411.841-.899 1.617-1.723 2.563-2.55.211-.215.49-.466.735-.646.246-.215.423-.396.668-.611.492-.395.88-.785 1.37-1.18.947-.791 1.89-1.62 2.73-2.481l1.404-1.223c.317-.289 1.263-.86 1.228-1.362-1.929 1.078-3.713 2.257-5.538 3.515-.91.61-1.753 1.258-2.63 1.87-.666.43-2.037 1.686-2.563 1.937 1.087-1.76 2.213-3.59 3.615-5.099 1.72-1.903 3.89-3.88 5.855-5.495.526-.432 1.021-.968 1.512-1.328v-.18c-.456-.036-1.971 1.082-2.322 1.369-2.105 1.545-4.168 3.26-5.921 5.057-.317.323-.562.651-.877.939-.912.862-1.795 2.008-2.53 3.05-.984 1.4-2.038 2.909-2.949 4.418.596-2.73 2.527-4.845 4-6.46l3.367-3.705c.244-.252.357-.43.567-.68 2.248-2.47 3.329-4.386 3.784-7.28-.383.56-.926 1.215-1.78 2.275-.269.314-.5.55-.768.904l-6.832 7.865c.308-1.1 1.65-3.459 2.264-4.402a75.658 75.658 0 0 1 2.689-3.893c.653-.905 3.647-4.802 4.376-5.471l.317-.319c.079-.478.462-.72.961-1.136.56-.467.67-.718 1.336-1.076-.632-.647-2.985.82-3.44 1.145-2.982 2.047-5.117 4.847-7.29 7.65.279-1.51 2.063-5.928 2.904-7.185.702-.933 1.337-2.153 2.038-3.015l1.964-3.093c-.457.036-.98.721-1.262 1.009l-.56.577c-2.63 2.8-4.18 5.923-6.004 9.371.105-1.724 1.654-4.628 2.497-6.03 1.088-1.868 2.31-3.449 3.433-5.246-.633-.18-2.492 2.049-2.808 2.516-.806 1.006-1.611 2.012-2.313 3.162-1.263 2.12-2.49 4.483-3.332 6.891l-.209.508c.141-2.263 2.384-7.656 3.366-9.416.596-1.04 1.227-1.866 1.93-2.764.28-.323.455-.607.701-.93.49-.61.912-1.156 1.403-1.767l1.37-1.825c-.877-.324-4.04 3.268-4.636 4.023-.771.97-1.472 2.042-2.137 3.084.35-1.725 1.65-4.129 2.596-5.566.843-1.293 1.718-2.33 2.665-3.48.31-.355.581-.742.81-1.154-.982-.144-5.015 4.567-5.82 5.608-.351.467-.638.894-.953 1.361l-1.328 2.12c-.07.143-.111.215-.218.395l-.275.362c.211-1.653 1.194-5.107 1.72-6.616.737-1.94 1.748-3.695 2.59-5.6-.702-.107-2.028 1.692-2.414 2.267l-1.578 3.015c.175-1.4 2.344-6.284 3.081-8.079-.421.107-.699.751-1.085 1.325-.982 1.545-1.861 3.054-2.773 4.634.14-1.58 1.16-3.234 1.862-4.6-1.299.575-3.474 5.213-4 6.686-.245.61-.493 1.323-.669 2.006l-.275.724c-.07-3.556.66-7.188 1.186-10.673-.316.072-.386.435-.527.758l-.384.897c-.21.646-.455 1.254-.701 1.972l-1.019 4.239c-1.51-2.12-1.888-6.031-4.87-10.45-.946-1.4-1.267-1.548-2.53-2.446zm1.587 42.39c1.226 3.412 1.718 4.598 2.63 8.226a.84.84 0 0 0-.35.353c-.141.36-.281 1.013-.527 1.516l-.91-3.162c-.351-1.149.144-3.489-.244-3.884-.35.61-.246.721-.316 1.834-.21-.252-.42-.967-.56-1.326-.7-1.94-.806-1.368-.35-2.481.14-.323.345-.932.626-1.077z'/%3e%3cg fill='%23008f4c'%3e%3cpath d='M493.057 306.366c.453-4.74 6.302-15.95 8.018-16.19.258-.036-1.923 3.126-3.438 6.253-1.515 3.128-3.13 7.218-3.667 9.117-.503 1.88-.963 3.307-1.006 3.222-.043-.083-.008-1.17.093-2.403zm12.72-2.92c-.017.091-1.075 1.143-2.4 2.33-4.428 4.134-9.586 11.362-11.955 17.195-2.516 6.244-1.88 4.663-1.14 1.628 1.923-6.55 7.18-14.855 12.075-18.899 1.72-1.455 3.483-2.588 3.42-2.253zm-14.723-10.653c.006-4.323.413-5.83 2.897-11.02 1.589-3.33 2.188-4.423 2.363-4.172.11.183-.033.784-.333 1.362-1.47 2.84-3.873 10.947-4.286 14.49-.142 1.187-.353 2.185-.458 2.19-.116.028-.197-1.252-.182-2.85zm-7 24.14c.279 3.364-.28 7.19-1.761 11.04-.893 2.305-4.413 7.632-5.252 7.973-.412.16-.311-.062.617-1.14 3.684-4.362 6.134-10.84 6.183-16.802-.21-3.236.017-3.664.214-1.07z'/%3e%3cpath d='M494.773 312.864c.504 1.513.575 5.08.029 6.92-1.325 4.45-4.492 7.706-9.005 9.281-.886.297-1.65.52-1.71.462-.04-.038.64-.43 1.547-.839 5.63-2.64 9.14-7.963 9.18-13.905.007-1.108-.217-1.648-.28-1.925-.102-.46-.203-.817-.056-.935.077-.06-.075-.167.295.94z'/%3e%3cpath d='M507.088 322.335c-.061.055-2.512.514-5.435 1.026-2.923.494-6.71 1.21-8.378 1.576-2.574.552-3.09.625-3.252.4-.1-.152-.183-.303-.182-.36 0-.112 7.946-1.54 12.454-2.214 3.272-.49 5.04-.652 4.794-.428zm-23.118-49.624c1.876 2.264 2.318 3.24 3.273 7.105.617 2.476.778 3.325.577 3.275-.135-.044-.321-.426-.417-.865-.466-2.166-2.73-7.52-4.055-9.564-.441-.688-.764-1.307-.712-1.358.049-.069.648.564 1.334 1.407z'/%3e%3cpath d='M481.934 275.481c.89 2.833 1.466 3.733 4.159 6.594 1.724 1.838 2.34 2.424 2.404 2.222.034-.145-.183-.507-.497-.822-1.546-1.54-4.783-6.333-5.781-8.567-.337-.748-.68-1.355-.748-1.335-.083.006.126.864.465 1.91zm16.813 8.79c-2.978 2.726-7.804 11.444-7.1 12.802.109.203 1.35-1.8 2.698-4.473 1.348-2.675 3.298-5.91 4.309-7.258 1.016-1.314 1.75-2.368 1.67-2.357-.077.011-.796.59-1.577 1.285zm1.343 2.226c-3.326 3.045-8.718 12.784-7.93 14.301.12.227 1.505-2.01 3.012-4.997 1.506-2.987 3.684-6.6 4.813-8.107 1.137-1.468 1.955-2.645 1.868-2.633-.088.014-.89.658-1.764 1.436zm-19.081-8.928c.525 2.93.983 3.897 3.294 7.094 1.479 2.053 2.017 2.716 2.105 2.525.052-.138-.118-.528-.39-.88-1.34-1.736-3.948-6.92-4.656-9.267-.24-.788-.503-1.436-.574-1.426-.083-.004.017.874.22 1.953z'/%3e%3cpath d='M485.557 283.401c2.363.776 3.176.99 3.14.781-.038-.143-.395-.357-.817-.48-2.098-.565-8.002-3.227-8.094-4.261-.265-.379-1.26-1.875-1.26-1.875s5.089 5.152 7.03 5.835zm20.22 10.33c-4.524 3.14-12.621 14.071-11.903 16.046.11.298 2.15-2.188 4.453-5.565 2.304-3.377 5.524-7.402 7.136-9.044 1.614-1.593 2.794-2.886 2.686-2.886-.108.001-1.186.65-2.37 1.448zm-.691 6.69c-1.976 3.972-9.566 11.578-11.143 11.18-.237-.063 1.47-1.954 3.834-4.142 2.364-2.19 5.137-5.182 6.24-6.647 1.065-1.46 1.942-2.542 1.95-2.455.01.09-.384 1.025-.882 2.064zm-26.677 27.411c-.81 3.916-5.655 12.334-7.111 12.37-.22.003.83-2.046 2.38-4.513 1.55-2.465 3.273-5.727 3.895-7.262.59-1.52 1.104-2.669 1.132-2.595.029.074-.1.98-.296 2zm12.4-23.522c-.792-2.508-3.022-5.528-6.105-8.264-3.096-2.783-4.042-3.227-1.32-.619 2.51 2.386 5.65 6.64 6.774 9.18.478 1.03.944 1.853 1.046 1.781.13-.06-.047-.989-.394-2.078zm2.334 31.832c-3.481-1.016-12.418-.913-13.128.143-.106.16 2.008.231 4.688.105 2.68-.126 6.07-.05 7.575.122 1.483.19 2.633.285 2.587.234-.044-.05-.823-.33-1.723-.604zm-3.824 1.545c-3.518-.875-12.444-.41-13.113.675-.1.163 2.016.148 4.689-.086 2.672-.234 6.062-.296 7.575-.185 1.487.13 2.64.178 2.593.13-.048-.05-.836-.297-1.744-.534zm-3.932 1.906c-3.538-.78-12.45-.078-13.09 1.022-.096.167 2.02.096 4.684-.21 2.666-.304 6.053-.456 7.568-.384 1.49.09 2.643.108 2.596.06-.05-.048-.844-.273-1.758-.488z'/%3e%3cpath d='M483.064 341.831c-3-1.13-10.774-1.323-11.42-.29-.095.154 1.74.296 4.074.26 2.334-.039 5.28.15 6.586.371 1.283.24 2.28.372 2.243.32-.038-.053-.708-.356-1.483-.66zm13.893-11.027c-7.338 2.087-16.204 3.357-16.712 5.114-.073.264 3.239-.273 6.498-1.565 3.258-1.293 7.463-2.603 9.38-2.993 1.894-.354 3.379-.773 3.339-.965-.075-.052-1.302.415-2.506.41zm9.567-4.708c-.074.066-2.988.611-6.464 1.22-3.477.587-7.981 1.438-9.966 1.876-3.06.655-3.673.741-3.866.473-.122-.18-.217-.359-.217-.426 0-.134 9.45-1.833 14.81-2.634 3.893-.586 5.997-.777 5.7-.51z'/%3e%3cpath d='M504.254 324.2c-.056.061-2.45.765-5.31 1.571-2.863.788-6.564 1.882-8.188 2.417-2.508.81-3.014.933-3.197.724-.117-.14-.211-.282-.217-.337-.01-.113 7.762-2.338 12.183-3.465 3.21-.82 4.955-1.16 4.728-.91z'/%3e%3cpath d='M502.442 315.56c-5.07 2.074-15.24 10.972-14.946 13.06.047.314 2.553-1.665 5.502-4.459 2.949-2.793 6.926-6.019 8.84-7.268 1.906-1.2 3.328-2.204 3.22-2.227-.104-.023-1.292.374-2.615.893z'/%3e%3cpath d='M506.204 317.988c-5.055.333-16.53 5.497-16.86 7.574-.048.313 2.719-.757 6.107-2.457 3.388-1.699 7.804-3.477 9.843-4.045 2.019-.525 3.555-1.019 3.468-1.074-.086-.056-1.245-.063-2.558.003z'/%3e%3cpath d='M506.044 318.553c-12.933 10.868-20.2 16.18-22.78 15.057-.386-.173 4.753-3.124 9.146-5.934 4.395-2.81 9.628-6.794 11.762-8.82 2.069-2.03 3.749-3.508 3.749-3.363 0 .145-.841 1.536-1.877 3.06zm-13.84 3.398c2.608-4.243 3.915-5.46 9.477-8.968 3.566-2.255 4.812-2.944 4.833-2.585-.005.248-.506.747-1.146 1.124-3.154 1.847-10.393 8.272-12.932 11.486-.855 1.078-1.663 1.921-1.767 1.86-.133-.046.558-1.357 1.536-2.916zm1.418-12.22c.453-4.738 8.567-20.568 10.282-20.81.258-.035-1.922 3.127-3.437 6.254-1.515 3.128-3.13 7.22-3.67 9.117-.502 1.88-3.467 8.772-3.51 8.69-.043-.084.234-2.019.334-3.25zm-3.42-18.259c-1.363-3.216-1.407-4.448-.413-8.989.633-2.913.922-3.89 1.188-3.752.173.107.212.593.077 1.105-.661 2.515-.647 9.203.036 11.951.226.923.317 1.722.208 1.754-.114.053-.606-.877-1.096-2.069zm2.482 17.365c-.714-2.257-2.72-4.977-5.496-7.44-2.79-2.505-3.64-2.906-1.187-.558 2.259 2.15 5.084 5.977 6.096 8.267.43.926.852 1.668.944 1.602.116-.053-.043-.89-.355-1.87zm-12.432 3.643c2.553-9.193 4.577-7.6 4.577-7.6 5.588 5.264 2.843 23.352 2.843 23.352-.048-37.02-7.42-15.752-7.42-15.752z'/%3e%3cpath d='M482.318 311.841c2.554-9.193 3.23-8.794 3.23-8.794 4.624.943 4.334 21.217 4.334 21.217-2.023-34.785-7.564-12.424-7.564-12.424zm-2.44 7.138c-.101-6.603 1.203-5.615 1.203-5.615 3.738 3.345 5.127 16.195 5.127 16.195-5.802-25.949-6.33-10.58-6.33-10.58zm11.336-19.4c-1.122-3.547-4.586-7.214-8.147-11.864-4.381-3.938-5.72-4.566-1.867-.877 2.545 1.543 7.543 8.806 9.092 13.163.677 1.458 1.337 2.622 1.48 2.52.186-.086-.065-1.4-.558-2.942z'/%3e%3cpath d='M490.84 296.47c-.862-2.73-3.102-6.235-6.46-9.215l-2.04-1.92c2.012 2.396 6.566 8.69 7.79 11.458.523 1.121 1.03 2.02 1.14 1.94.144-.066-.05-1.077-.43-2.265zm-18.6 36.593c-.265 2.005-2.4 6.436-3.133 6.512-.11.01.344-1.064 1.035-2.368.692-1.302 1.44-3.014 1.698-3.81.243-.79.46-1.39.478-1.354.016.036-.015.5-.078 1.02zm-1.842 1.162c-.265 2.005-2.402 6.436-3.134 6.511-.111.012.344-1.064 1.035-2.367.692-1.304 1.44-3.015 1.698-3.812.244-.79.46-1.389.477-1.353.017.036-.014.5-.076 1.02zm2.78.148c-.266 2.006-2.4 6.437-3.133 6.512-.111.011.344-1.063 1.035-2.367.692-1.303 1.44-3.015 1.698-3.812.243-.79.46-1.388.477-1.353.017.037-.015.5-.077 1.02z'/%3e%3c/g%3e%3cpath fill='%2300873f' d='M404.997 283.802c.013.992.286 1.25.727 1.877l.112-1.942c-.364-.222-.504-.035-.84.065z'/%3e%3cg fill='none' stroke='%23006300' stroke-width='.627' transform='translate(-82.672 -25.552) scale(1.06534)'%3e%3cpath d='m455.17 303.94-.866-.693m1.776-4.627c-.693-.996-.736-.996-.736-.996m-1.774 13.456c-.26-2.12-1.472-2.727-1.472-2.727m11.342 29.987c-5.4-5.97-7.165-16.77-7.165-16.77 1.765-4.518 4.102-5.557 4.102-5.557m-4.097 5.507c-1.765-6.957-1.325-14.228-1.325-14.228.623-8.93 3.454-16.822 3.454-16.822m-3.509 19.31c1.432-6.536 6.87-5.746 6.87-5.746'/%3e%3cpath d='M454.83 310.99c4.883-1.983 4.3-6.288 5.177-8.04 1.321-2.644 2.276-3.415 2.276-3.415M459.7 332.37c-1.661-4.206.312-4.984.312-4.984m-.982 3.634c-2.13-2.752-4.83-2.543-4.83-2.543m3.89-10.277c1.298-2.388-.052-4.78-.052-4.78m.692 16.3-3.798-4.925m2.278-30.435c.514-1.946-1.028-2.827-1.028-2.827'/%3e%3cg transform='translate(442.052 224.217) scale(.1567)'%3e%3cpath id='a' fill='red' stroke-width='2' d='M91.376 425.97a5.975 5.975 0 1 1-11.95 0 5.975 5.975 0 0 1 11.95 0z'/%3e%3c/g%3e%3cuse xlink:href='%23a' width='100%25' height='100%25' transform='matrix(.1567 0 0 .18128 444.567 235.353)'/%3e%3cuse xlink:href='%23a' width='100%25' height='100%25' transform='translate(443.685 248.32) scale(.1567)'/%3e%3cuse xlink:href='%23a' width='100%25' height='100%25' transform='translate(439.992 252.043) scale(.16899)'/%3e%3cuse xlink:href='%23a' width='100%25' height='100%25' transform='translate(438.744 256.228) scale(.16899)'/%3e%3cuse xlink:href='%23a' width='100%25' height='100%25' transform='translate(440.286 257.844) scale(.16899)'/%3e%3cuse xlink:href='%23a' width='100%25' height='100%25' transform='translate(463.222 286.05) scale(.12289)'/%3e%3cuse xlink:href='%23a' width='100%25' height='100%25' transform='translate(464.293 287.305) scale(.12289)'/%3e%3cpath d='M458.76 316.61c-.22-.955-1.101-1.248-1.101-1.248M472.4 339.53c1.591 1.163 2.081.428 2.081.428'/%3e%3c/g%3e%3cg fill='%23006300'%3e%3cpath d='M422.703 339.796c-1.044-3.718-.783-4.565-.783-4.565m-8.113-2.136s-.621-1.45.393-2.28c.6-.492 3.2.922 4.535-4.878 0 0-.81-.094-2.67.748v-.46s-.414-1.292-.23-2.906c0 0 .886-1.36.914-1.909 0 0-1.676-.62-4.95 3.592 0 0-.298-.9-2.696-2.513 0 0-1.3 3.68-.645 5.764.508 1.618.545 2.192 2.26 3.367 0 0 1.382.6 1.566 2.444.646 0 1.488-.11 1.488-.11s.08.018.035-.859zm-2.44 4.293c-.53.3-.766.572-1.706.692-4.224.541-6.594-5.026-6.594-5.026-.14-1.107.37-.522 1.245-.208 1.153.415 1.496.09 2.79-.069 1.706-.207 3.62 1.476 3.62 1.476 1.083.945 1.176 2.836 1.176 2.836-.116.3-.531.3-.531.3zm-5.017-10.046c-4.418-1.875-7.043.23-7.043.23-.163.276.261.406.261.406 2.771.342 1.88.213 3.032 1.793 1.973 2.706 5.46 2.135 5.46 2.135.719.163 1.436 1.028 1.436 1.028-.293-2.413-3.146-5.592-3.146-5.592zm-7.65-17.493c-.848-.588-.656.587-.656.587-1.826-3.196-6.647-3.44-6.647-3.44-.394-.019-.624-.318-.624-.318-.806 0 .185 1.613.185 1.613 1.452 3.873 2.835 4.312 2.835 4.312-1.646.94-4.281-1.105-3.689.391 2.56 2.697 4.288 3.066 4.288 3.066 3.229.785 4.658 0 4.658 0 .738 1.338 1.222 1.522 1.222 1.522 2.928.877 3.573 2.56 3.573 2.56 0-3.205-1.205-7.158-1.205-7.158-.916-1.375-3.94-3.138-3.94-3.138z'/%3e%3cpath d='M421.499 340.903c-1.565.49-1.696 1.598-1.696 1.598-1.532 2.086-7.042.1-7.042.1-1.696-.459-1.37-.915-1.37-.915 1.532-.782 2.054-1.4 2.054-1.4-2.934-2.642-3.358-6.066-3.358-6.066 4.565-.913 5.967-.065 5.967-.065-.294-1.762-1.793-1.794-1.793-1.794-.36-.555.424-.587.424-.587 4.01.392 6.162 2.902 6.162 2.902 1.5 2.12 1.043 4.206 1.043 4.206.359 2.12-.391 2.022-.391 2.022zm-18.633-18.387c-2.22-.653-3.504.07-3.504.07-1.153.46-3.252-.877-3.252-.877-2.766-2.304-3.296-3.734-3.296-3.734 0-.415 2.442-.322 2.442-.322 3.22-.078 3.954.583 3.954.583 1.663.945 1.491 1.812 2.086 2.16 1.436.84 1.665 1.23 1.665 1.23.407.556.584 1.09-.095.89zm4.304 1.13c1.52-1.754 3.596-.554 3.596-.554 3.182.37 4.196-3.227 4.196-3.227.738-1.476 1.292-2.168 1.292-2.168.184-.83-1.384-.138-1.384-.138-2.72.691-2.813.968-2.813.968.462-4.289.462-4.334.462-4.334.045-.692-.738-.184-.738-.184-3.92 2.26-4.38 3.918-4.38 3.918l-1.615-3.043c-.507-1.245-.876.14-.876.14-.738 3.688-.461 4.011-.461 4.011.508 1.982 1.015 2.535 1.015 2.535.92 1.2.92 1.66.92 1.66z'/%3e%3cpath d='M430.234 333.734c-.62.163-2.25 2.74-2.25 2.74-1.956-3.685-4.564-4.273-4.564-4.273-.522.23.065 1.077.065 1.077.782 1.956-.131 3.488-.131 3.488-.293 1.435.033 1.76.033 1.76-3.097-1.597-3.293-1.434-3.293-1.434-.034 1.99 2.348 5.706 2.348 5.706 5.15-1.37 5.542-1.27 5.542-1.27 1.924-.294 1.875-.328 1.875-.328 1.548-4.433.375-7.466.375-7.466zm-25.248-20.284c1.988.978 2.12 2.282 2.12 2.282.52 1.696 5.15 2.086 5.15 2.086 3.783-.39 3.39-1.075 3.39-1.075-2.183-1.923-1.555-1.77-2.476-2.675-1.65-1.613-3.815-1.662-3.815-1.662-2.902.457-3.521-.13-3.521-.13-1.044.555-.848 1.173-.848 1.173zm-4.486-6.648c-.934-3.408 2.153-7.63 2.153-7.63 2.575 4.795 2.086 6.13 2.086 6.13-.913 3.196-2.176 5.543-2.176 5.543-.472-2.413-1.72-2.793-2.063-4.043z'/%3e%3cpath d='M398.849 308.134c-3.265.093-6.379-3.605-6.379-3.605 4.869-1.262 5.962-.53 5.962-.53 2.669 1.52 4.5 3.17 4.5 3.17-2.27-.105-2.885.931-4.082.965z'/%3e%3cpath d='M396.335 303.543c-2.075.322-3.873-1.707-3.873-1.707-2.767-3.689-1.845-4.887-1.845-4.887.23-.139.554.322.554.322.876.784 2.443.968 2.443.968-4.426-2.766-1.521-8.9-1.521-8.9.554-.599.738.877.738.877.6 1.615 2.351 2.582 2.351 2.582.922 1.245.922 1.753.922 1.753.461-2.076.97-1.522.97-1.522.552 1.66 2.388 2.821 2.627 3.965.646 3.09.139 3.505.139 3.505-.37 1.797-.393 3.158-.393 3.158-1.682-.62-3.112-.115-3.112-.115zm10.42 7.425c1.06-1.43 0-4.104 0-4.104-.415-2.859 3.873-5.58 3.873-5.58 1.245 2.306 1.106 3.69 1.106 3.69 3.274-.784 4.012-1.015 4.012-1.015.138 1.844-1.614 4.52-1.614 4.52 2.675.782 3.596-.508 3.596-.508-1.29 5.948-6.962 4.75-6.962 4.75-2.352-1.522-4.011-1.754-4.011-1.754z'/%3e%3cpath d='M397.86 293.624c.324-3.587.977-3.718.977-3.718.386.143.576 1.737 1.092 1.976 2.248 1.036 2.234 3.438 2.234 3.438-.066 2.868-.482 2.61-.482 2.61-3.136-.04-3.822-4.305-3.822-4.305zm10.375.715c1.095-4.066.433-4.474.433-4.474-.48 0-1.334 1.672-1.998 1.724-2.885.225-3.842 2.864-3.842 2.864-1.091 3.174-.53 3.06-.53 3.06 3.456 1.226 5.548-1.73 5.937-3.174z'/%3e%3cpath d='M397.997 286.901c.38-4.192 1.142-4.346 1.142-4.346.451.167.673 2.031 1.278 2.31 2.628 1.21 2.613 4.016 2.613 4.016-.075 3.355-.561 3.054-.561 3.054-3.667-.046-4.607-3.542-4.472-5.034zm11.708 1.001c1.187-4.04.533-4.46.533-4.46-.48-.012-1.371 1.64-2.035 1.677-2.89.162-3.906 2.78-3.906 2.78-1.162 3.147-.6 3.045-.6 3.045 3.43 1.303 5.586-1.604 6.008-3.04zm4.816 11.294c3.334-2.57 3.055-3.296 3.055-3.296-.383-.292-2.076.522-2.634.16-2.432-1.568-4.793-.049-4.793-.049-2.79 1.863-2.275 2.112-2.275 2.112 2.006 3.07 5.46 1.986 6.647 1.073z'/%3e%3cpath d='M414.414 301.401c3.176-1.457 3.066-2.06 3.066-2.06-.266-.284-1.795.078-2.195-.287-1.741-1.587-3.94-.786-3.94-.786-2.608 1-2.225 1.27-2.225 1.27 1.138 2.675 4.164 2.381 5.293 1.863zm-10.952-19.25c-1.265-3.763 2.544-8.739 2.544-8.739a50.635 50.635 0 0 1 1.238 4.173c3.027-3.074 5.712-3.548 5.712-3.548l-.103 2.375c2.022-.196 2.87-.652 2.87-.652-.436 3.015-4.24 6.064-4.24 6.064-1.435.913-3.196.587-3.196.587-2.754.783-3.398 2.657-3.398 2.657-.27-1.63-.46-.042-1.427-2.919zm5.55 12.58c1.707-2.259 4.428-1.29 4.428-1.29 2.443.184 4.519-2.353 4.519-2.353 1.106-1.798 1.797-2.213 1.797-2.213-.092-.599-.691-.507-.691-.507-1.476.323-1.476.37-1.476.37 1.108-4.104.508-4.288.508-4.288-.37 0-.6.276-.6.276-.645 1.89-3.273 1.798-3.273 1.798-.138-2.72-.74-2.352-.74-2.352-.414.692-1.29 1.107-1.29 1.107-2.582 2.582-2.582 3.69-2.582 3.69.139 3.042-.6 5.764-.6 5.764z'/%3e%3c/g%3e%3cg fill='%2300863d'%3e%3cpath d='M408.523 309.657c.344-.393 1.12-.985 1.714-1.32.595-.343.406-.2.693-.85.266-.614.188-.477.615-.9l-.377 1.15c.602-.344.826-.536 1.672-.993.07.337-.552.636-1.064.971a28.29 28.29 0 0 1-1.323.85l-2.308 1.956c2.183-.506 1.79-.142 2.883-.322 2.337-.384 3.443-3.69 4.233-5.618-1.602.3-3.26.657-4.436 1.45-1.505 1.013-1.393 1.934-2.302 3.626zm-5.966 8.331c-.14-.356-.546-.949-.77-1.343-.623-1.113-.693-1.44-1.504-2.712-.518-.82-.329-.393-.666-1.306.308.022.736.95 1.085 1.328l-.006-1.35c.37.03.266.357.286.764.07 1.32-.056 1.092.756 2.542l1.644 2.705c-.097-.428-.308-.807-.427-1.248-.483-1.765.623-3.862-3.736-6.454l-1.078-.657c.078 2.141.315 5.675 2.282 6.781.342.193.74.28 1.112.428.399.172.679.366 1.02.522zm-1.011-26.814c-.162-.549-.418-1.035-.585-1.65-.156-.555-.067-.426-.456-.7l-.51-.622.643.328a4.152 4.152 0 0 0-.516-1.006c-.403-.575-.222-.192-.638-.938.745-.082 1.531 2.13 1.698 2.704.51 1.706.49 1.5 1.498 2.87-.007-.233-.37-.65-.464-1-.269-.938.745-2.21-.255-4.218-.597-1.206-1.832-1.404-2.436-2.418l-.53-1.04c-.196.362-.498 1.794-.524 2.266-.088 1.472.268 3.404 1.288 4.384.37.348 1.283.848 1.787 1.04zm5.56-10.622c.21-.15.615-.72.98-1.035l1.064-.892-.161-.986c.21.071.125-.093.335.672.273-.243.91-1.314 1.19-1.743.21.293-.413 1.2-.602 1.485-.31.493-.602.844-1.057 1.192l-2.036 2.5c.426-.136.74-.286 1.203-.378 1.323-.265 1.833-.38 2.758-1.858.874-1.39 1.112-3.105 1.462-4.71-1.89.756-3.884 1.52-4.864 3.29-.364.65-.203 1.207-.273 2.463zm-11.921 17.866c-.54-1.392-2.022-3.027-2.183-3.734l-.218-1.656c.309.043.169-.078.26.214 0 0 .083.936.195 1.2l.672 1.206c.029-.807-.105-.407.21-1.099.322.413-.175 1.128.308 1.935.252.421.595 1.084.91 1.45-.015-1.15.777-2.92-.525-4.599-.455-.578-.988-.779-1.554-1.257l-1.092-1.72c-.88 1.871-.713 5.675 1.05 6.94.336.242.644.328 1.008.527.189.107.308.171.49.286.167.107.293.214.469.307zm8.522-7.425c.762-.626.522-.875 2.293-2.206.437-.328.757-.697 1.135-1.115.543-.593.36-.473 1.085-1.173.18.317-.99 1.53-1.357 1.976l.71.085c-.113.423-.51.11-1.085.267-.518.13-1.887 1.69-2.265 2.086.34-.098.65-.24 1.06-.319 1.098-.215 1.784.078 2.968-1.435.996-1.263 1.35-2.854 1.837-4.4-1.518.357-3.351 1.128-4.2 1.957-1.215 1.174-1.113 2.18-1.574 3.23-.182.404-.44.676-.607 1.047zm-5.923 11.441c-.175-.256-.77-.713-1.063-.928-.61-.436-.686-.442-1.532-.507l-2.541-1.406c.315-.164.476.207 1.07.522l1.19.514-.147-.657c.224.014.245.05.344.293l.069.421c1.14.092.958.113 2.093.835-.127-.514-.197-.486-.519-.744-.28-.22-.343-.39-.566-.699-.357-.493.041.23-.567-.692-.987-1.485-2.072-.835-2.77-1.014l-1.813-.743a7.01 7.01 0 0 0 2.134 3.898c.476.443 1.029.95 1.903 1.1.273.043 2.365-.129 2.715-.193zm-1.022 9.483c-.358-.35-.756-.644-1.183-.958-.308-.222-.462-.193-.882-.235l-.818-.279.923-.035c-.105-.072-.294-.243-.426-.35-.652-.52-.777-.515-1.198-1.143.182-.17.302.043.554.236.748.585 2.204 1.756 2.932 2.255l1.357.75c-.063-.727-1.302-3.069-2.324-3.52l-4.534-1.24c.232.762 1.358 2.876 1.827 3.511 1.322 1.8 1.462 1.2 2.421 1.057.49-.07.868-.036 1.35-.05zm2.172-10.218-1.716-5.68c.312.102.27.481.454 1.12l.455 1.175c.227-.494-.094-.068.397-.844.218.25-.036.788-.129 1.106-.174.6-.16.377.078.99l.81 2.1c.04-.474-.005-.729.083-1.218.259-1.374.476-2.139-.177-3.573-.57-1.258-1.52-2.18-2.404-3.162-.132.24-.402 1.877-.457 2.272-.214 1.46-.094 3.454 1.068 4.398.916.753.383.158 1.538 1.316zm3.388 7.351c.035-.586-.063-3.29-.042-4.519 0-.264.015-.52.015-.785.006-.414-.036-.278.188-.586.1.144.117.308.111.515l-.026 1.863.538-.914c.344.128.049.471-.104.792-.127.25-.407.721-.449.957l.09 2.67c.016-.022.037-.07.043-.057.028.042.295-.693.455-.957.553-.943 1.197-2.29.93-3.498l-1.49-4.29c-.314.527-.7 1.413-.959 1.991a9.153 9.153 0 0 0-.678 2.364c-.28 1.997.259 2.405.875 3.44.188.322.328.664.503 1.014zm2.397-25.472c.022-.508.23-3.127.168-3.349-.021-.07-.174-.37-.216-.499l-.245-1.05c.37.044.217.271.427.657l.14.2.063-.77c.04-.523-.036-.265.188-.773.21.123.09-.085.147.237a3.706 3.706 0 0 1-.028.393c-.182 1.75-.252 3.668-.336 5.425.169-.286.23-.743.413-1.085.455-.892 1.24-2.427 1.162-3.47l-.987-5.133c-.357.543-.707 1.4-1.008 2.02-.671 1.372-1.287 3.456-.874 5.013l.874 2.027c.064.114.05.086.11.157zm-13.71 29.553c.307.377.937.928 1.378 1.263.86.643 2.869 1.492 3.876 1.428l2.303-.422-.357-1.07c-.428.014-.756.192-1.245.2a8.35 8.35 0 0 1-1.414-.1 18.466 18.466 0 0 1-1.31-.228c-.777-.165-.502-.045-1.098-.458l2.422.357c-.63-.485-.406-.236-.868-.87.35-.037 1.07.655 1.379.87l2.07-.1-.16-1.22c-1.036-.43-2.492-.407-3.555-.036-2.148.735-1.385.563-3.421.386zm2.726 5.37c.127.4 2.303 2.89 2.821 3.062l4.772.2c-.595-.33-1.435-.672-2.106-.944-.917-.37-.972-.178-2.456-.02.078-.328.356-.265 1.154-.45-.335-.178-1.784-.585-1.805-.6l-.21-.228c.099-.1.029-.115.245-.094.07.008.273.086.37.115 2.205.721 2.835 1.006 4.928 1.87-.673-.513-.833-.692-1.345-1.349-1.917-2.434-3.932-1.642-6.367-1.563zm16.589-26.624.73-1.335c.358-.756-.211-.779.044-1.792.259.081.18.058.314.93l.884-2.026c.253.682-1.143 3.274-1.442 3.905l-.473 1.31c1.143-1.273 2.537-1.868 2.76-2.93l.17-5.116c-.821.677-1.934 1.773-2.494 2.673-.83 1.327-.754 2.546-.493 4.38zm-2.207 30.213c.42-.186.735-.435 1.219-.628 1.882-.522 1.133.378 2.33-1.286l-.315.886c.854-.285 1.077-.815 1.707-1.443.16.314-.33.844-.58 1.086-1.057 1.043-2.128.707-2.75.95l-1.24.613c1.42-.222 1.26.036 2.436.214 2.393.364 3.072-2.027 3.884-3.44l.566-1c-1.357.142-3.002.97-4.05 1.556-.792.435-1.051.672-1.61 1.192-.218.2-.477.472-.735.657-.358.264-.63.335-.862.644z'/%3e%3cpath d='M407.948 309.412c.839-.799.658-2.67 1.28-3.797.119-.215.21-.329.35-.5.23-.293.146-.236.448-.228.098.22-.357.456-.532.856l-.378 1.207c.078-.058.049-.036.126-.115.063-.07.084-.1.126-.164.588-.836 1.12-1.043 1.967-1.578l-.813-3.02-1.483 1.285a7.036 7.036 0 0 0-1.26 1.55c-1.056 1.863.09 2.74.169 4.505zm-.438 12.401 1.96-3.213v-1.51c.299.047.194-.113.388.896.66-.97.2-.857.95-1.343.053.29-.765 1.767-.868 1.92-.833 1.166-1.233 1.901-1.953 3.136.467-.189 1.106-.87 1.44-1.182.283-.257.438-.394.743-.59.282-.183.58-.32.847-.494l.832-4.6c-.75.317-2.77 1.736-3.358 2.478-1.226 1.562-1.292 2.04-.98 4.502zm4.4-11.272 2.555-.234c-.078.335-.442.341-1.162.45-1.147.177-3.275.155-4.505.177.355.2.712.321 1.076.536.37.221.637.4 1.016.592.804.414 1.776.38 2.637.05l3.345-3.113c-1.757.408-.791.472-3.163-.006-.364.314-.525.7-1.287 1.213-.155.107-.372.207-.51.336zm-18.152-6.178c.72 1.48 2.83 3.254 4.728 3.02.847-.108 1.001-.377 1.51-.873-.112-.13.023-.027-.143-.11a.816.816 0 0 0-.217-.065c-1.452-.287-1.63-.172-3.11-.008l.672-.346c-.389-.1-.774-.186-1.154-.29-.607-.17-.525-.147-.991-.48.17-.166.128-.127.428-.039 1.939.621 2.395.586 4.504.912-.2-.638-1.864-1.432-2.757-1.554-1.41-.178-1.897.544-3.47-.167zm12.517 16.992-.643-4.127c.335.093.237.222.398 1.085l.735 3.741c.063-1.42.546-2.435.118-3.897l-1.47-2.82c-.272.67-.467 2.57-.412 3.37.09 1.255.35 1.634 1.008 2.39.126.144.119.15.266.258zm5.593-42.134c.21-.129.378-.35.566-.586l.61-.47c.013.35-.49.756-.826 1.177-.483.613-.784.713-1.021 1.006-.946 1.193-.848.992-2.345 1.65 3.078.186 4.744-3.064 6.067-5.276-2.91.414-2.38.614-2.66 1.45-.125.363-.3.706-.391 1.05zm1 13.007.84-1.39c.505-.736.833-.224 1.63-1.004-.214-.194-.15-.133-1.025.211l1.395-1.903c-.766.133-2.408 2.813-2.83 3.426l-.954 1.138c.56-1.735.362-3.342 1.22-4.12l4.63-2.899c-.183 1.121-.6 2.736-1.128 3.734-.78 1.477-1.945 2.062-3.777 2.808zm-11.547 5.465c-.251-.763-1.176-1.556-1.329-1.977l-.666-2.685c.372.044.372.757.442 1.071l.356 1.15c.224-.82-.146-.243.364-1.035.252.5-.3 1.335.042 1.798.343.472.37.408.91 1.214.308-1.235.356-2.805-.392-3.655l-2.148-2.356c-.546.792-.497 3.034-.112 4.17.44 1.27.931 1.413 1.736 1.841.314.165.496.33.797.464zm1.865-.298c.547-.72 1.82-1.223 2.137-1.615l1.69-2.609c-.41-.09-.671.668-.86.977l-.801 1.09c.063-.954.244-.204-.008-1.233-.45.44-.168 1.53-.703 1.897-.537.375-.544.297-1.412.957.125-1.426.648-3.113 1.756-3.742l3.147-1.717c.29 1.042-.584 3.407-1.41 4.472-.934 1.19-1.506 1.162-2.52 1.322-.394.06-.647.166-1.016.2zm5.656.32c.84-.043 3.128-.078 3.829-.45l.965-.45c0 .257 0 .123-.364.493.923-.043.517-.107 1.406.05-.105.186.182.157-.734.214-1.03.071-1.575.178-2.498.278l-3.415.344c2.183.792 2.54 1.997 5.01 1.076 1.966-.734 2.359-1.533 3.604-3.033-3.072.714-3.402-1.885-6.41.1-.364.243-1.176 1.063-1.393 1.377z'/%3e%3cpath d='M412.934 299.601c.804.1.468-.014 1.14.3-.315.27-1.652-.065-2.183.042l-2.204-.042c.707.977 1.888 1.45 3.562 1.277 1.643-.178 2.07-.6 3.392-1.406l-2.497-.82zm-.917 14.34c-.21-.208-.756-.478-1.1-.608-1.391-.528-2.482-.028-3.19-.042l-1.59-.186c.422.464 2.129 1.1 2.96 1.234 2.143.35.7.915 2.92-.4zm.224 1.576.636.571c-.166.086-.398-.072-.665-.2l-.118 1.45 2.904-.365c-.917-1.157-1.505-1.714-2.597-2.727-.083.45-.21.778-.16 1.27zm-3.728.82 1.734-1.313c-.44-.344-1.245-.329-1.853-.515l-1.674-.67c.4.556.413.428.89 1.248.266.457.46.943.903 1.25zm8.405-25.707c-.755.442-1.285 1.127-2.128 1.48-1.138.462-2.355.006-3.071.737 1.92-.11 3.186.622 4.675-.75.914-.845 1.713-2.145 2.46-3.223-.301-.019-1.294.284-1.494.49-.105.104-.248.441-.358.611-.343.547-.112.142-.084.655zm-6.34 43.701 1.4 2.841 1.93 2.364c.4-.187.848-.507 1.303-.736l1.553-.55c-.867-.37-.91-.8-1.4-.835-1.195-.079-.496.114-2.085-.158.147-.256.077-.135.903-.15l1.008-.028c-.588-.543-1.315-.92-1.973-1.399l2.072 1.057-.064-1.378c.504.057.196.835.426 1.6.112.35.777.791 1.135.97.685.343.937.264 1.644.443l1.624.513c-.666-.943-.364.122-1.492-2.206-.455-.942-.88-1.513-1.651-1.992-1.875-1.163-4.184-.385-6.332-.356zm2.356-2.792c.02-1.142-.064-2.184.027-3.348.043-.543-.21-1.942-.3-2.74.266.077.223.2.286.534l.21.743c.266-1.2.33-1.165.98-2.028.105.278-.644 1.214-.777 2.578l-.133 3.39c.133-.157.147-.213.3-.385.12-.136.21-.229.337-.364.238-.243.406-.479.637-.836 1.623-2.527.637-3.968.665-4.718l.469-2.448c-.504.206-1.89 1.212-2.205 1.534-1.252 1.27-2.49 3.506-1.707 5.418.182.45.433.83.63 1.265.196.442.35 1.021.58 1.405z'/%3e%3cpath d='M412.07 341.245c.273.17 1.84.678 2.246.8 1.49.464 3.829.635 4.863-.75.567-.764.91-.964 1.624-1.535-1.106.022-1.868.443-2.833.663-.722.165-.77.672-1.36 1.23l-.544.376c.007-.356.693-1.027 1.015-1.406l-2.17-.02c.07-.35.652-.178 1.61-.265 1.875-.158 2.19-.657 4.226-.899a.839.839 0 0 0 .4-.115c-3.038-.014-3.702-2.055-7.341.53zm13.892-1.876v-1.52c-.665-.507-.665-.67-1.07-1.45.356.03.504.6 1.05.986-.056-.728-.357-1.949-.525-2.728.35.058.517 1.03.602 1.38.427 1.776.055 3.147.37 3.72l.868 1.17c.294-1.236 1.567-2.036.049-5.077-.923-1.856-1.673-2.17-3.226-3.34.188.85.4 1.15.266 2.191-.098.728-.385 1.278-.468 1.992-.197 1.642.307 1.55.63 1.734.545.307 1.049.636 1.455.943zm-15.031-2.886-.462-1.02c-1.28.021-1.66.542-3.444-.658-.468-.314-.391-.278-.65-.77l1.973 1.105c-.105-.22-.343-.45-.734-1.256.063-.042-.043-.136.182-.008.09.05.125.122.167.18l.959 1.27 1.315-.143c-.028-.222-.252-.592-.35-.82-.188-.444-.097-.515-.432-.758-.442-.322-.988-.636-1.66-.699-.825-.079-1.316.207-2.063.264l-2.016-.42c.09.391.847 1.648 1.057 1.947.854 1.2 3.114 2.95 5.03 2.2.28-.108.889-.287 1.128-.414zm-10.495-9.343.105.057c.1.05.064.035.156.07.572.237 1.076.5 1.482.965.517.585.553.871 1.343 1.528 1.274 1.063 2.652 1.028 4.354 1.25-.156-.237-.575-.723-.777-.929-1.36-1.45-1.113-1.37-1.981-1.25l-1.42.115c.063-.293.916-.35 1.539-.485a3.94 3.94 0 0 0-.917-.293c-.714-.13-.21.056-1.03-.25.373-.5 2.206.156 3.053.95.63.578 1.413 1.506 2.015 2.213l-.987-2.128c-1.008-1.835-3.674-2.492-5.632-2.14-.315.05-1.029.163-1.302.327zm11.858 4.857c-.706-2.24-1.862-3.19-2.176-4.554-.21-.928-.133-1.014.035-1.857.455.622-.385 1.05.944 3.277-.076-.72-.258-1.043-.133-1.913.055-.35.484-1.684.477-1.72-.063-.364-1.673-1.842-2.114-2.306-.23 1.978-.741 3.74-.098 5.71.665 2.043 1.756 1.566 3.065 3.363zM423 342.087l1.413-.378c-.21-.172-.707-.815-.917-1.13-.616-.898-.546-.977-.3-1.427.077.136.02.014.056.186.034.242-.022.314.153.622.133.227.23.362.406.584.35.464.58.735 1.015 1.071-.028-.707-.161-1.05.035-1.47.267.1.09-.079.189.192l.084 1.214 1.567-.414c-1.056-1.864-3.085-2.535-4.94-3.27.168.721.336 1.471.51 2.191.196.836.428 1.314.729 2.03zm-2.482-4.027c-.17-.422-.47-.87-.7-1.357-.504-1.092-.427-1.592-1.442-2.642-.174-.177-.314-.357-.525-.52-.104-.079-.377-.243-.42-.35-.007-.007-.013-.028-.013-.043l.014-.15c.35-.072 1.05.735 1.266.95.609.585 2.008 3.547 2.478 4.46-.063-.406-.273-.89-.133-1.284.405-1.17-.722-2.977-1.274-3.348l-4.387-1.942c.525.5.832.786 1.196 1.593.286.642.42.085 1.56 1.306 1.21 1.277 1.113 2.87 2.38 3.327z'/%3e%3cpath d='M428.572 338.05c.078-.209.155-.423.23-.65.142-.4.03-.237.365-.565.168.264 0 .407-.182.964-.356 1.063-.588 1.955-.888 3.04.972-.127.93-.15 1.343-.876.252-.444.448-1.065.546-1.636l-.12-4.127-1.265 1.65c-.658.95-.245.435-.03 2.2zm-13.188-9.365c.314-.179 1.049-1.064 1.365-1.414.18.335-.666 1.214-.848 1.398-.713.68-.266 0-1.196 1.114 1.882.28 2.659-2.206 3.268-3.476-.372.022-1.568.415-1.862.592-.252.143-.174.072-.244.393-.05.2-.064.293-.133.5-.098.307-.231.6-.35.893z'/%3e%3c/g%3e%3cg fill='%23ce1126' stroke='%23000'%3e%3cpath stroke-width='.295' d='m434.474 352.26 2.366 1.228-1.347 2.655c.983-.167 4.55-1.394 5.716-1.76-.291-.828-.4-.928-.291-1.957l-.4-1.892-2.877.962a23.979 23.979 0 0 1-3.167.764zm31.055-.415-2.368 1.227 1.348 2.656c-.984-.167-4.551-1.394-5.717-1.76.291-.83.4-.928.291-1.958l.4-1.89 2.877.961a24.18 24.18 0 0 0 3.169.764z'/%3e%3cpath stroke-width='.301' d='M443.061 356.021c2.661-.376 5.043-1.786 5.043-1.786.407.439 2.536.126 2.536.126.971-.19 1.41-.344 1.41-.344 2.663 1.69 4.698 1.942 4.698 1.942 2.35-.126 2.412-1.942 2.412-1.942-.093-1.598-.251-1.66-.251-1.66 1.254-1.974-.093-3.54-.093-3.54-.627-.72-4.26.438-4.26.438-2.444 1.16-2.6.658-2.6.658-.694-1.088-3.244-.895-4.354-.062-2.693-.596-3.07-.784-3.07-.784-2.725-1.033-3.163-.407-3.163-.407-.971 1.16-.658 2.38-.658 2.38 0 .69.22 1.285.22 1.285-.596 3.507 2.13 3.696 2.13 3.696z'/%3e%3cpath stroke-width='.239' d='M452.041 353.059c5.857 1.318 5.442 2.153 5.442 2.153-.355.613-2.075-.174-2.075-.174-4.57-1.6-3.367-1.98-3.367-1.98zm-3.633.022c-5.858 1.317-5.443 2.153-5.443 2.153.356.613 2.076-.175 2.076-.175 4.57-1.6 3.367-1.978 3.367-1.978z'/%3e%3cpath fill='%23aa241e' stroke-width='.223' d='M448.654 349.107c-2.518.447-.53 2.325-.443 3.488 0 .626-.618 1.698.045 1.968.618.267 1.942-.045 2.648-.045.973-.045 1.634.045 1.502-1.208-.089-.94-.397-1.252-.397-2.46-.045-.848.133-1.788-.795-1.877-.574-.045-1.986.044-2.561.133z'/%3e%3cpath fill='none' stroke-width='.241' d='M452.126 350.502c6.68-.033 6.188-1.1 6.188-1.1m-6.071 3.135c6.614.888 5.722 1.851 5.722 1.851'/%3e%3cpath fill='none' stroke-width='.234' d='M448.099 352.346c-6.16 1.369-5.606 2.345-5.606 2.345m4.925-4.327c-6.295.455-5.662-.613-5.662-.613'/%3e%3c/g%3e%3cpath d='M422.666 342.607c-3.374 1.108-5.613 1.88-8.838 3.771-1.23-1.849-2.91-4.585-4.101-6.173-.672-.852-1.604-1.776-2.76-2.368-1.827-.851-2.499-.592-3.655.407l-.82-1.552c-1.64-2.885-3.356-4.215-5.183-6.546l-1.642-1.922c-.223-.258-.297-.443-.595-.592.706 2.322 1.218 4.54 1.677 7.063-1.007-.555-1.939-1.11-2.983-1.552-.783-.297-2.796-.74-3.766-.63l1.192 1.073c2.052 1.81 3.394 4.215 4.214 6.914.896 2.92 2.984 6.026 5.184 8.17.448.444 1.715 1.59 2.535 1.886 2.461.888 2.35-.037 3.244-.48 1.894 3.206 3.113 4.813 5.296 7.246 2.349 2.478 6.042 3.143 9.397 2.367 1.492-.37 2.424-.777 3.58-1.443 4.364-2.514 2.276-4.473 1.753-6.47 1.417-.443 6.966-2.122 8.961-2.491 7.026-1.3 20.048-1.471 28.378-.259.746.108 9.144 2.344 9.964 2.825-.592 1.392-.827 2.082-.743 3.612.142 1.415 1.358 2.155 2.44 2.783 1.155.666 2.087 1.073 3.579 1.443a12.34 12.34 0 0 0 4.51.185c3.134-.518 4.775-2.33 6.118-3.956 2.23-2.546 2.925-4.09 4.065-5.88 0 0 .636.592 1.088.74.426.139 1.82-.111 2.194-.26 1.08-.405 1.752-1.219 2.496-1.922 2.314-2.218 4.253-5.102 5.185-8.244 1.118-3.698 2.647-5.435 5.37-7.839-3.518.12-4.733 1.076-6.713 2.182l.747-3.623c.223-.999.782-2.478.894-3.44-1.6 1.704-3.02 3.487-4.437 5.066-.672.888-1.418 1.627-2.089 2.588-1.41 2.176-1.141 2.243-1.678 2.958-4.95-2.75-7.174 3.949-10.516 8.06-6.204-3.487-11.608-4.582-18.907-5.916-1.635-.172-3.094-.405-4.437-.554-9.173-1.072-19.278-1.034-28.415.333-4.717.596-7.635 1.462-11.783 2.441z'/%3e%3cg fill='%23ce1126'%3e%3cpath d='M416.284 356.874c.568-1.626 1.278-1.98 2.685-2.662 4.511-2.07 6.75-2.92 11.894-4.288a66.397 66.397 0 0 1 9.062-1.703c1.574-.255 1.957-.271 4.736-.443 4.102-.222 6.488-.222 10.591 0 1.777.019 3.296.208 4.736.443 3.057.37 6.3.926 9.173 1.701 4.623 1.185 7.682 2.294 11.857 4.253 1.902.887 1.642.924 2.722 2.662 1.381-.925 2.388-2.921 3.171-4.252.41-.703 1.007-1.664 1.268-2.478.448-1.369-.411-1.81-1.045-2.329-2.31-1.997-6.637-3.734-10.33-4.77-15.848-4.399-37.66-4.584-53.474-.037-3.842 1.11-7.757 2.663-10.294 4.696-.334.258-.67.554-.967.889-.896 1.034.577 3.086 1.042 3.956.467.867.87 1.717 1.344 2.366.573.783 1.275 1.456 1.828 1.997z'/%3e%3cpath d='M400.624 342.757c1.79.334 2.423.852 3.579 2.405 2.573 3.55 2.686 6.063 7.048 10.87 1.007 1.108 1.753 1.996 3.282 2.661 1.602.703 3.281.925 5.184.667 1.788-.222 3.132-.703 4.474-1.48 0 0 1.608-.923 2.03-1.49.422-.568.506-1.91.506-1.91-1.306-.408-3.654 2.143-5.183 3.142-2.798 1.849-3.879 1.183-5.855-.556-1.716-1.478-2.35-3.068-3.469-4.991-.447-.777-1.267-1.959-.969-3.18l2.089-2.144c-.826-1.356-1.859-2.866-2.61-4.03-1.045-1.59-1.641-2.662-2.984-3.697-.783-.629-2.35-1.552-3.467-.887-.938.733-1.612 1.594-2.425 2.587-.447.517-.97 1.257-1.23 2.033z'/%3e%3cpath d='M397.644 335.944c-.412-.15-1.902-1.294-2.687-1.627l-3.281-1.11c.448.555.896.888 1.79 1.997 2.088 2.662 2.088 4.806 3.73 7.987.558 1.07 1.528 2.476 2.348 3.438.559.701 2.45 2.504 2.946 2.92 1.146.952 2.346 1.088 2.993.298.149-.56-1.352-1.555-2.171-1.961-1.008-.556-1.902-1.147-2.61-1.812-1.94-1.96-.449-4.363 1.043-6.064l1.007-1.183c.223-.802-1.406-3.075-2.275-4.214-.895-1.073-3.17-3.623-4.177-4.77.15.925.448 2.18.634 3.143.15.665.671 2.44.71 2.958zm28.975 17.937-.784-1.848c-1.08.112-6.376 2.441-7.607 3.218-.372.222-1.863 1.404-1.156 2.144 2.052 2.218 5.147-1.034 6.974-2.441.634-.517 1.454-1.11 2.573-1.073z'/%3e%3cpath d='M406.143 349.605c-.337-.111-.262-.775-1.455-1.664-.448-.37-3.146-1.773-3.609-2.291 0 0-.884-.631-.778-1.54.08-.697.658-.827.658-.827 2.424.074 5.294 6.026 5.184 6.322zm93.32-6.74c-1.789.333-2.422.851-3.579 2.404-2.573 3.55-2.684 6.065-7.049 10.87-1.006 1.11-1.751 1.998-3.281 2.662-1.603.704-3.28.925-5.182.666-1.79-.221-3.133-.702-4.476-1.48 0 0-1.606-.923-2.03-1.49-.421-.567-.506-1.91-.506-1.91 1.305-.408 3.655 2.144 5.185 3.142 2.796 1.85 3.877 1.183 5.854-.554 1.716-1.48 2.35-3.07 3.467-4.992.447-.776 1.27-1.958.97-3.179l-2.089-2.145c.825-1.356 1.86-2.866 2.61-4.03 1.046-1.59 1.643-2.662 2.984-3.697.784-.628 2.349-1.553 3.47-.888.935.734 1.61 1.596 2.422 2.588.448.517.97 1.257 1.23 2.034z'/%3e%3cpath d='M502.455 336.061c.41-.147 1.902-1.293 2.686-1.626l3.281-1.11c-.448.556-.894.89-1.79 1.997-2.087 2.663-2.087 4.808-3.73 7.987-.558 1.072-1.528 2.477-2.349 3.44-.558.7-2.449 2.502-2.946 2.919-1.145.953-2.632.946-2.992.3-.147-.563 1.352-1.557 2.172-1.964 1.007-.554 1.901-1.145 2.61-1.81 1.94-1.96.448-4.364-1.044-6.064l-1.007-1.183c.303-1.52 1.407-3.075 2.275-4.217.896-1.071 3.17-3.622 4.176-4.77-.149.925-.446 2.183-.633 3.143-.242.987-.49 1.981-.71 2.96zm-28.977 17.94.785-1.848c1.08.11 6.376 2.44 7.607 3.215.372.223 1.864 1.406 1.156 2.145-2.051 2.219-5.146-1.035-6.974-2.44-.633-.517-1.454-1.11-2.572-1.072z'/%3e%3cpath d='M493.956 349.714c.336-.112.26-.777 1.455-1.666.447-.369 3.146-1.772 3.609-2.29 0 0 .882-.632.778-1.539-.08-.697-.659-.828-.659-.828-2.424.074-5.295 6.027-5.183 6.323z'/%3e%3c/g%3e%3cpath fill='%23eac102' d='M421.811 346.17c-.262.002-.519.097-.77.166-.382.158-.755.333-1.142.476-.158.04-.193.221 0 .24.213.17.159.479.274.705.073.26.135.524.221.78.078.333.196.656.257.991.088.327.198.648.25.982.022.144-.274.446.017.355.292-.067.545-.26.848-.284.116-.005.32-.2.089-.202-.27-.142-.178-.507-.318-.738-.062-.246-.142-.489-.192-.736.068-.286.447-.092.473.135.155.207.351.388.551.554.245.173.482.383.788.436a1.05 1.05 0 0 0 .664-.056c-.296-.26-.646-.468-.874-.799-.194-.26-.359-.543-.544-.81.285-.265.55-.596.609-.993.027-.42-.187-.862-.558-1.07a1.581 1.581 0 0 0-.642-.131zm-.352.373c.234.004.421.162.535.354.13.242.213.523.19.797a.695.695 0 0 1-.392.571c-.168.132-.602.416-.623.034-.115-.423-.26-.842-.338-1.276-.063-.266.214-.373.416-.432a1.176 1.176 0 0 1 .213-.048zm1.835-.966c.034.202.3.292.266.527.055.312.133.62.214.925.024.284.12.553.158.834.045.2.112.393.14.597.048.275.13.546.168.825.055.12-.273.375-.041.36.76-.213 1.53-.396 2.29-.616.2.032.261-.117.223-.289l.004-.693c-.233 0-.223.321-.4.422-.272.29-.655.435-1.028.54-.215.03-.324-.182-.352-.36-.074-.177-.048-.37-.113-.548-.067-.266-.108-.538-.166-.806.273-.113.58-.174.872-.117.147.01.27.295.397.155 0-.24-.096-.472-.138-.707-.05-.099-.075-.467-.23-.36-.078.159-.101.38-.3.438a1.834 1.834 0 0 1-.624.209c-.141-.144-.142-.457-.173-.676.019-.236-.142-.593.189-.644a.985.985 0 0 1 1.028.042c.112.082.369.332.382.051-.142-.225-.152-.54-.33-.73-.212-.03-.402.105-.609.134-.614.14-1.222.321-1.828.487zm5.085-1.392c-.309.018-.61.095-.913.16-.33.098-.659.205-.988.306-.254.142.252.243.227.446.036.216.07.435.123.646.041.219.1.435.122.658.08.317.13.64.195.962.023.3.157.58.159.885.056.191-.048.393-.101.54.325-.079.655-.146.975-.245.168.013.247-.221.048-.235-.141-.212-.141-.483-.21-.722-.042-.258-.103-.51-.153-.765.456-.11.92-.255 1.295-.543.25-.216.456-.51.46-.853a1.389 1.389 0 0 0-.251-.868 1.31 1.31 0 0 0-.46-.319c-.17-.048-.35-.048-.528-.053zm.567.057zm-.926.297a.681.681 0 0 1 .631.463c.107.26.157.552.11.831-.05.183-.154.365-.346.429-.188.079-.36.258-.578.217-.13-.125-.04-.371-.14-.538-.077-.329-.116-.669-.215-.992-.041-.199.131-.352.313-.382a1.054 1.054 0 0 1 .225-.028zm4.117-1.133c.124.116.252.225.331.38.117.155.081.36.14.537.077.26.07.537.138.798.045.22.092.44.092.664.094.274.087.574.075.858-.062.41-.497.724-.907.638a.556.556 0 0 1-.427-.333c-.132-.158-.176-.36-.217-.557-.048-.285-.108-.57-.146-.858-.032-.291-.084-.578-.12-.868-.035-.233-.096-.46-.13-.693-.046-.128.292-.406.026-.36-.338.033-.663.134-.998.182-.248.166.183.228.169.427.045.204.03.416.08.619.076.443.182.877.216 1.326.03.206.093.402.105.609.05.21.176.39.29.57.194.18.42.353.696.37.476.08 1.008-.03 1.349-.392.14-.177.261-.386.298-.608.012-.324.014-.653-.071-.966-.034-.325-.036-.656-.14-.967-.034-.269-.083-.538-.108-.808a.618.618 0 0 1-.02-.4c-.01-.14.243-.268.127-.37-.208-.01-.406.082-.613.08-.09.009-.187.04-.233.122zm3.262-.615c-.45-.013-.891.094-1.331.164-.18.07-.477.05-.582.2.128.138.28.266.254.48.091.455.128.922.212 1.38.003.29.104.567.113.856.027.337.08.676.072 1.012.013.118-.24.388 0 .335.182-.076.375-.033.564-.1a5.241 5.241 0 0 1 .748-.111 4.792 4.792 0 0 0 .892-.223 2.53 2.53 0 0 0 .431-.382.7.7 0 0 0 .194-.494c.023-.312-.027-.681-.287-.887-.164-.137-.375-.188-.574-.26-.142-.038-.32-.165-.094-.228.235-.138.442-.342.511-.612a.782.782 0 0 0-.161-.737c-.096-.233-.345-.31-.572-.355a2.406 2.406 0 0 0-.39-.038zm-.604.334c.286-.066.618.036.776.295.155.206.1.482.075.72-.01.267-.29.354-.497.44-.15.09-.529.205-.483-.095.046-.207-.037-.405-.056-.609a4.97 4.97 0 0 1-.02-.577zm.334 1.825c.227-.01.503-.022.657.18.213.183.276.473.274.743-.007.219.004.483-.197.625-.206.135-.463.248-.714.212-.234-.108-.216-.423-.25-.643-.03-.223-.09-.443-.103-.669-.056-.163-.099-.468.167-.416a.653.653 0 0 1 .166-.032zm2.073-2.537c-.024.164.236.179.227.37.036.227.001.46.074.684.035.22 0 .449.057.668.07.268-.007.558.091.821.053.274-.022.562.073.828.063.244.034.529-.146.716-.085.139.22.08.307.048.328-.026.657-.038.982-.09.19-.02.38-.03.565-.077l.663-.067a3.94 3.94 0 0 0 .113-.839c.02-.101.03-.27-.11-.177-.065.18-.193.33-.303.483a.918.918 0 0 1-.356.185c-.16.045-.318.107-.487.092-.184.046-.383-.03-.39-.243-.056-.26-.026-.531-.09-.791-.061-.504-.08-1.01-.115-1.515-.037-.304-.102-.608-.064-.915.018-.124.34-.369.065-.321a1.87 1.87 0 0 1-.477.057c-.172.018-.34.07-.515.065a1.046 1.046 0 0 0-.164.018zm3.143-.346c-.038.148.174.075.199.235.086.162.008.358.083.525.029.197.033.398.051.596l.145 1.911c.055.16.051.329.049.495.023.142-.203.255-.168.358.402-.01.81-.027 1.203-.116.13-.023-.002-.176-.087-.178-.119-.131-.11-.327-.132-.493-.023-.304-.026-.61-.087-.907-.029-.236.011-.479-.049-.712-.055-.33-.01-.668-.093-.993-.02-.211-.067-.434.002-.639.032-.075.272-.25.074-.233a6.928 6.928 0 0 0-1.125.128.255.255 0 0 0-.064.023zm4.99 2.58c-.218-.02-.298.204-.42.339-.13.208-.37.299-.598.35-.26.066-.492-.128-.673-.289a2.025 2.025 0 0 1-.338-.675c-.084-.218-.101-.452-.157-.677a4.194 4.194 0 0 1 0-1.022c.079-.235.16-.5.362-.658.262-.161.618-.082.819.142.188.15.25.382.352.588.15.235.229-.11.236-.241.024-.167.132-.343.089-.507-.14-.172-.369-.241-.574-.308-.483-.141-1.051-.061-1.427.293-.152.107-.258.26-.349.417-.115.146-.17.318-.218.494-.085.223-.093.465-.139.699-.037.51.089 1.023.28 1.492.137.236.349.415.515.632.154.207.429.263.67.293.304.027.622-.038.867-.225.221-.142.375-.359.497-.587a1.186 1.186 0 0 0 .202-.483.135.135 0 0 0 .003-.066zm1.729-3.152c-.18.04-.43-.02-.568.065-.04.314-.121.622-.18.933-.049.218-.116.428-.123.65-.142.544-.245 1.095-.357 1.645-.11.258-.196.526-.309.782-.128.078-.096.254.068.185l.78-.018c-.016-.175-.252-.233-.273-.423-.06-.192.02-.369.03-.555.016-.226.339-.076.49-.125l.667-.014c-.03.25.195.45.165.704.045.137-.26.419.013.391.309.023.609-.08.916-.077.282-.016-.068-.27-.091-.403-.087-.314-.215-.619-.292-.937-.127-.446-.26-.889-.383-1.336-.123-.39-.215-.79-.326-1.183-.039-.132-.014-.32-.207-.284h-.021zm-.42.968c.163.536.319 1.075.482 1.612.082.22-.154.162-.288.183-.17.017-.34.04-.511.035-.117-.166.036-.407.048-.599.023-.25.134-.484.138-.737.057-.162.01-.357.13-.495zm5.365-1.12-1.216.077c-.072.141.215.161.159.33.028.328.007.658.007.986-.017.89-.046 1.78-.06 2.67-.013.12-.332.371-.06.349.596.02 1.209.078 1.794-.075.19-.047.345-.164.487-.292.198-.173.349-.4.472-.63a2.92 2.92 0 0 0 .2-.832 3.362 3.362 0 0 0-.026-.896c-.039-.253-.142-.495-.236-.73-.125-.16-.201-.348-.342-.49a2.078 2.078 0 0 0-.544-.365c-.216-.003-.416-.131-.635-.1zm.101.328c.248-.009.512.126.594.372.09.167.158.338.183.528.056.197.011.405.06.605.07.375.003.756-.049 1.127a1.728 1.728 0 0 1-.229.782c-.064.2-.29.261-.452.345-.21.055-.498.04-.546-.222-.037-.234-.016-.475-.022-.712.004-.852.007-1.704.061-2.555-.014-.24.2-.309.4-.268zm3.712-.198a1 1 0 0 0-.718.208c-.243.164-.377.436-.548.665-.184.326-.252.701-.296 1.067.013.308-.046.62.009.928.098.226.152.472.233.706.075.304.3.545.543.73.194.114.395.215.624.23.427.044.832-.225 1.081-.556.188-.27.393-.545.447-.878.081-.259.104-.528.132-.796.012-.204-.034-.405-.04-.608-.03-.27-.142-.52-.256-.764-.174-.268-.312-.587-.601-.753a1.095 1.095 0 0 0-.61-.18zm-.012.263c.322.009.52.337.562.625.066.23.09.466.119.703-.016.389.012.779-.03 1.166-.069.247-.027.51-.125.748-.045.243-.14.487-.322.66-.166.108-.388.17-.547.01-.193-.11-.21-.342-.3-.524-.11-.317-.064-.658-.073-.987.008-.466.026-.934.042-1.399.062-.236.094-.484.203-.704a.5.5 0 0 1 .47-.297zm1.622 4.327c.264-.026.522.095.783.086.193-.172-.21-.314-.158-.535-.022-.267.04-.532.102-.789.041-.243.068-.49.107-.733.064-.237.063-.488.126-.726.028-.205.036-.548.115-.661.13.21.056.468.133.693.043.264.054.527.101.79.051.277.09.554.11.833.05.247.08.504.114.756.056.18-.052.532.25.458.273.096.181-.27.303-.427.094-.385.167-.775.27-1.156.09-.215.12-.451.19-.672.096-.364.18-.732.33-1.08 0 1.047.08 2.098.006 3.143-.048.118-.322.314-.03.332.266.016.53.042.793.089.253.064.215-.159.056-.259-.16-.267-.058-.588-.076-.88.01-.517-.042-1.03-.035-1.547a12.06 12.06 0 0 1 .043-1.423c.059-.08.295-.281.073-.29l-.94-.044c-.04.255-.151.495-.188.75a11.172 11.172 0 0 1-.24.889c-.031.273-.128.53-.183.798-.008.114-.102.237-.106.046.019-.24-.118-.461-.085-.704-.006-.2-.104-.382-.077-.588-.022-.414-.157-.817-.157-1.233-.055-.2-.335-.096-.495-.175-.172-.005-.345-.01-.517-.02.075.267.145.537.087.815-.04.232-.097.461-.114.696-.086.542-.214 1.076-.277 1.62-.077.193-.057.408-.143.595-.06.175-.108.34-.274.442a.172.172 0 0 0 .002.111zm4.166.453c.227.092.479.073.709.148.117 0 .395.12.406-.042-.096-.146-.23-.281-.172-.474.026-.241.08-.481.068-.726-.004-.22.079-.43.078-.65a27.473 27.473 0 0 1 .104-1.46 1.647 1.647 0 0 1 .076-.54c-.015-.142.099-.21.189-.272.067-.233-.233-.129-.363-.166-.255-.018-.506-.089-.764-.085-.058.109.162.196.141.335.037.18-.01.364-.016.545-.079.265-.05.547-.079.82-.015.259-.045.517-.069.776-.079.19-.068.403-.07.608a3.163 3.163 0 0 1-.06.705c.012.154-.044.326-.17.395-.002.029-.003.056-.006.083zm1.449.315c.204-.016.4.093.6.076.111.044.34.112.228-.092a.94.94 0 0 1-.16-.598c-.011-.365.044-.728.095-1.088a2.47 2.47 0 0 1 .081-.762c.022-.236.028-.476.093-.705.124.114.155.378.247.549.336.857.659 1.718.991 2.576.08.167.12.419.32.474.247.102.186-.191.196-.338.017-.216.132-.413.081-.639.035-.236.082-.472.081-.713.057-.233.089-.47.08-.71.042-.23.095-.458.079-.696.004-.253.08-.495.134-.74.005-.165.436-.335.17-.435-.233.007-.548-.158-.731-.074.048.189.213.342.18.556.029.487-.101.964-.097 1.45-.053.24-.07.503-.101.732-.134-.18-.18-.462-.284-.678-.105-.262-.193-.53-.318-.783-.053-.225-.173-.427-.236-.648l-.362-.892a4.32 4.32 0 0 1-.81-.168c-.208.121.12.314.086.491.065.353.003.709-.046 1.06a5.271 5.272 0 0 1-.076.695c-.001.25-.004.502-.09.741a7.1 7.1 0 0 1-.109.778c-.009.222-.219.332-.321.483-.004.033 0 .066 0 .098zm3.801-3.64c.023.153.216.254.13.434.004.209-.032.414-.067.618a3.866 3.866 0 0 1-.079.582c-.03.317-.097.63-.095.95-.005.19-.081.37-.073.564-.015.148-.073.288-.083.438-.02.132-.039.262-.068.391-.057.071-.094.15-.192.158-.09.188.267.168.384.199.208.046.416.065.61.138.159.056.222-.12.082-.192-.15-.195-.04-.446-.027-.667.016-.168.029-.34.071-.507.034-.224.019-.455.084-.674.023-.174.01-.355.075-.52.038-.226.002-.463.083-.681-.01-.193.044-.378.087-.563-.004-.175.046-.36.205-.45a1.552 1.552 0 0 0-.485-.142c-.17-.015-.33-.087-.499-.114a.202.202 0 0 0-.143.037zm1.328 2.98c-.016.234.01.466.047.695.048.314.196.604.382.86.11.206.335.296.52.425.233.14.537.124.78.019.146-.067.325-.102.406-.259.165-.195.364-.379.44-.632-.107-.228-.262.112-.372.178-.245.19-.618.259-.889.085-.19-.132-.289-.344-.36-.555-.044-.208-.134-.406-.111-.62a8.818 8.818 0 0 1 .023-.845c.112-.22.047-.48.142-.707.086-.188.124-.41.266-.569a.575.575 0 0 1 .464-.233c.188.03.31.21.43.345a.967.967 0 0 1 .188.63c-.044.158.146.365.244.165.06-.23.219-.438.235-.675-.04-.196-.234-.298-.366-.43-.142-.104-.303-.178-.46-.256-.293-.083-.646-.123-.908.071a1.453 1.453 0 0 0-.467.349c-.208.2-.301.484-.41.745a3.53 3.53 0 0 0-.213.855c-.01.12-.01.24-.01.36zm4.364-1.632c-.266.552-.482 1.125-.743 1.677-.097.199-.146.419-.258.61-.128.294-.233.6-.406.872-.13.186-.172.466-.388.571-.178.038-.137.227.04.22.22.025.421.162.627.174.176-.103-.094-.243-.068-.39-.03-.208.057-.41.143-.59.155-.16.385-.017.565.02.137.089.365.037.461.142 0 .298-.003.595-.004.892-.162.08-.129.288.06.284.2.049.396.102.59.162.112.051.34.096.209-.09-.133-.289-.093-.611-.108-.918-.009-.256.01-.517-.036-.768-.064-.21-.017-.431-.035-.646.004-.466.032-.932-.02-1.395-.01-.22.007-.44-.02-.66-.183-.077-.386-.097-.576-.156l-.034-.01zm-.088.92.032 1.96c-.252-.004-.484-.12-.728-.168-.137-.197.174-.372.159-.582.122-.304.276-.594.395-.9.064-.096.057-.23.142-.31zm1.956 4.114c-.011-.249-.203-.467-.124-.727-.017-.32.092-.622.16-.93.01-.223.107-.434.118-.659.05-.27.15-.529.162-.804.097-.243.177.07.19.185.143.443.243.9.366 1.348.056.197.093.398.17.587.128.367.183.755.32 1.121-.014.226.108.511.374.455.113-.25.14-.54.207-.81.064-.237.043-.492.155-.714.087-.407.108-.831.25-1.227.083-.322.165-.647.23-.973.072-.125.453-.31.17-.416-.216-.034-.46-.235-.659-.17.037.174.144.335.135.523.011.259-.083.507-.09.763a5.707 5.707 0 0 0-.164.655c-.053.254-.1.51-.145.764-.18-.165-.11-.448-.216-.656-.08-.293-.183-.578-.237-.878a7.466 7.466 0 0 1-.226-.863 2.66 2.66 0 0 1-.183-.666c-.152-.217-.446-.223-.672-.322-.203-.113-.362.013-.199.203.109.44.001.896-.094 1.328-.086.38-.205.758-.236 1.147-.099.24-.105.5-.17.748-.077.203-.15.44-.347.558-.254.213.234.225.365.289a.886.886 0 0 0 .39.142zm4.266-2.873c-.142.324-.333.624-.49.942-.128.307-.312.587-.47.88-.302.528-.618 1.049-.925 1.574-.154.054-.355.282-.073.313.214.075.405.218.626.27.16-.083-.1-.293-.066-.433.02-.222.095-.431.194-.629.135-.087.341.102.501.136.16.116.53.083.489.34.013.271.013.551-.084.81-.127-.002-.2.105-.07.187.16.074.333.121.492.201.155.03.314.18.47.107-.048-.193-.125-.409-.104-.624.02-.336.02-.671.023-1.009-.004-.229.072-.45.058-.68l.044-2.217c-.223.02-.391-.178-.615-.168zm-.136.889-.028 1.98c-.168-.038-.324-.12-.486-.178-.12-.093-.446-.123-.263-.31.135-.265.284-.521.416-.784.101-.245.237-.475.36-.71z'/%3e%3cg transform='matrix(1.11591 0 0 1.11592 -106.897 -41.652)'%3e%3cpath fill='%23fff' d='M474.5 281.05c.065.433.033 36.778.033 40.539 0 3.595.042 5.876 1.751 8.152 1.407 1.97 3.767 3.592 6.075 4.13 1.63.333 7.631.2 9.718.2 4.635-.217 5.188.814 6.943 3.107 1.994-3.22 4.187-3.267 8.287-3.107 2.087 0 6.554.166 8.413-.233 2.217-.53 3.948-1.589 5.38-3.362 2.349-2.696 2.218-6.058 2.218-9.586v-38.312c0-1.73-.195-1.298.685-2.197l5.772-6.058-61.668.034 6.392 6.69z'/%3e%3cpath fill='%23002d62' d='M493.76 299.09v-24.768h-25.509l6.333 6.69.06 18.078z'/%3e%3cpath fill='%23ce1126' d='M503.98 299.09v-24.768h25.986l-6.631 7.108v17.66zm-10.22 10.23h-19.299l-.057 15.602c.874 6.814 5.913 9.135 10.433 9.112 3.059.033 4.1-.02 8.923-.055z'/%3e%3cpath fill='%23002d62' d='M503.98 309.32h19.418l-.063 15.602c-.456 6.754-5.913 9.135-10.433 9.112l-8.922-.055z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.454' d='M474.61 281.05c.065.433.033 36.778.033 40.539 0 3.595 0 5.791 1.793 8.321 1.408 1.97 3.43 3.55 6.033 3.961 1.63.333 7.631.2 9.718.2 2.674 0 3.913-.133 5.707 1.664.554.533.685.799 1.109 1.465.228-.167.228-.2.359-.433a5.27 5.27 0 0 1 2.674-2.33c1.402-.566 3.75-.366 5.38-.366 2.088 0 6.555.166 8.414-.233 2.217-.53 4.18-1.948 5.38-3.362 2.349-2.696 2.218-6.058 2.218-9.586v-38.312c0-1.73-.195-1.298.685-2.197l5.772-6.058-61.668.033 6.392 6.69z'/%3e%3cpath fill='%23eac102' stroke='%23000' stroke-width='.273' d='M497.92 280.41v2.773h-2.798v2.346h2.798v9.926h2.303v-9.926h2.833v-2.346h-2.833v-2.773z'/%3e%3cg id='b'%3e%3cpath fill='%23fff' d='m481.88 284.06.03 4.53-1.91-1.93.28 31.93c0 4.76 3.43 8.6 7.66 8.6 4.19 0 7.6-3.79 7.65-8.5l-.31-16.44-2.06-2.13-.03-1.68z'/%3e%3cpath fill='%23002d62' d='m481.88 284.22.03 4.56-1.91-1.94.16 18.19 8.25 7.85.06-17.41-.31-.35v-2.93z'/%3e%3cpath fill='%23ce1126' d='m490.77 295.51 2.424 3.079.016 1.045-2.446-2.51zm4.53 6.91.218 11.442c-1.177 2.21-3.569 1.012-3.569 1.012l.076-15.79z'/%3e%3cpath fill='%23002d62' d='M495.55 319.64c-3.128 2.339-3.997-1.128-3.997-1.128 2.341-.227 3.454-1.596 3.977-2.978z'/%3e%3cpath fill='%23ce1126' d='M480.21 309.72c4.293 4.872 7.965 7.502 7.965 7.502.965 7.668 5.5 5.12 7.134 3.925-.923 3.596-3.868 6.223-7.359 6.223-4.23 0-7.66-3.86-7.66-8.621z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.262' d='m493.2 299.63-.018-1.159-11.32-14.382.029 3.963z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.317' d='m480 286.66.294 31.922c0 4.76 3.428 8.62 7.656 8.62 4.196 0 7.603-3.801 7.654-8.512l-.31-16.445z'/%3e%3cg fill='%23eac102' stroke='%23000' stroke-width='.064'%3e%3cpath d='M486.17 281.23c-.778-1.457-.622-2.085-.081-2.641l-2.933-3.006.816 4.2c.84-.212 1.425 0 2.198 1.447zm-3.02-5.65 3.002 5.623'/%3e%3cpath d='m498.07 300.74-.762.292-11.924-20.42.702-.396z'/%3e%3cpath d='M484.98 280.59c-.102-.19.107-.507.469-.71.36-.201.736-.212.838-.022.103.19-.107.507-.468.709-.361.202-.737.212-.839.023zm-3.96 1.63c-.955-1.342-.88-1.986-.414-2.609l-3.287-2.594 1.34 4.057c.805-.32 1.412-.188 2.361 1.146zm-3.7-5.2 3.686 5.182'/%3e%3cpath d='m495.28 300.01-.719.39-14.401-18.682.647-.484z'/%3e%3cpath d='M479.76 281.75c-.125-.175.043-.517.375-.765.333-.248.703-.308.829-.133.125.174-.043.517-.375.765-.333.248-.704.307-.829.133zm.42 4.61c-1.098-1.224-1.094-1.872-.7-2.545l-3.555-2.199 1.781 3.877c.765-.411 1.383-.349 2.474.867zm-4.25-4.75 4.237 4.724'/%3e%3cpath d='m495.66 302.86-16.38-16.905.589-.556 16.462 16.99z'/%3e%3cpath d='M478.88 286.03c-.144-.159-.015-.518.288-.803.303-.285.665-.387.809-.228.144.159.015.518-.288.803-.303.285-.665.387-.809.228z'/%3e%3c/g%3e%3c/g%3e%3cuse xlink:href='%23b' width='100%25' height='100%25' transform='matrix(-1 0 0 1 998.257 0)'/%3e%3cg stroke='%23000' stroke-width='.236'%3e%3cpath fill='%23ce1126' d='m496.73 314.54-.634 10.104c-.64-.057-1.877-.16-1.97-.981-.052-.464 1.263-8.732 1.313-9.536.437.12.893.323 1.291.413z'/%3e%3cpath fill='%23002d62' d='M495.77 314.12c-.063.396-.283 2.806-.22 3.094.189.971 1.383.827 2.043.863l.126-5.18c-.22.215-1.698 1.115-1.949 1.223z'/%3e%3cpath fill='%23002d62' d='M495.88 327.04c1.664-2.085 4.784-.536 4.784-.536 3.415.766 2.565-3.136 2.565-3.136-.693-7.804-1.52-13.144-1.52-13.144l-4.989 3.331z'/%3e%3cpath fill='%23002d62' stroke-width='.188' d='M495.86 327.17c-.36 2.317 1.958 1.977 1.958 1.977 2.757-.04 1.968-2.956 1.968-2.956-2.957-.849-3.926.979-3.926.979z'/%3e%3cpath fill='%23ce1126' d='M497.83 312.74c-.173 8.072-.246 8.895-.246 8.895.115 2.212 2.532 1.016 2.532 1.016.575-.24 1.208-.06 1.208-.06l-.115-2.75c4.022-.298 3.087-2.64 3.087-2.64-1.64-7.623-1.747-7.29-1.747-7.29z'/%3e%3cpath fill='none' stroke-width='.225' d='M501.31 319.81c-2.537-.04-3.568.96-3.568.96l-.103.22'/%3e%3cpath fill='%23fff' stroke-width='.209' d='m500.99 326.45-.875-15.193 1.75-1.172 1.517 14.216v.146c0 2.638-2.392 2.003-2.392 2.003z'/%3e%3c/g%3e%3cg fill='%23fff' stroke='%23000'%3e%3cpath fill='%23000' stroke-width='.042' d='m488.23 302.2 6.788 12.45 14.63-9.712-7.62-11.249z'/%3e%3cpath stroke-width='.272' d='m488.49 302.1 13.753-8.014 7.52 10.823-14.53 9.347z'/%3e%3cpath fill='%23000' stroke-width='.039' d='m495.43 313.53 13.697-8.82-1.053-1.686-6.862-9.323-4.962 4.008-6.335 3.51-1.116-.696.223 1.488z'/%3e%3cpath stroke-width='.148' d='M496.18 297.77c-2.026-.96-4.38 2.067-5.057 2.668-.678.601-2.041.24-2.041.24l6.179 11.086c1.823.72 2.999-1.615 3.846-2.338 1.553-1.325 3.376-1.223 3.376-1.223z'/%3e%3cpath stroke-width='.148' d='M496.36 297.88c.006-2.378 2.952-3.135 3.738-3.557.787-.422 1.033-1.906 1.033-1.906l6.927 10.563c-.126 2.081-2.591 2.288-3.55 2.826-1.758.987-1.997 2.509-1.997 2.509z'/%3e%3cpath stroke-width='.105' d='M495.02 311.82c-3.953-7.236-6.127-11.017-6.127-11.017-.093 1.326-.02 1.242-.02 1.242 4.611 7.43 6.489 11.413 6.489 11.413-.103-.548-.224-1.093-.342-1.638z'/%3e%3cg fill='%23000' stroke='none'%3e%3cpath d='m490.87 302.2.113.185c.032-.017.06-.049.055-.088.006-.029-.032-.066-.017-.085.01-.005.014.017.02.023l.13.212c-.024.021-.036-.037-.06-.04-.031-.029-.09-.023-.11.007.034.054.066.11.102.163.021.024.051.003.071-.01.056-.031.105-.085.105-.152.011-.026-.026-.067.002-.082l.068.158-.388.246c-.015-.013 0-.018.012-.025.042-.021.023-.07 0-.097l-.196-.32c-.016-.034-.059-.023-.082-.004-.01.007-.018-.016-.002-.016l.364-.231.082.134c-.024.02-.04-.034-.067-.038-.047-.028-.103-.005-.145.023zm.4-.28.243.398a.045.045 0 0 0 .066.023c.008.009.005.014-.005.018l-.155.099c-.02-.02.03-.03.014-.056-.017-.037-.041-.071-.062-.107l-.158-.259a.044.044 0 0 0-.066-.022c-.008-.008-.008-.014.003-.018zm.52-.36.096.15c-.023.023-.037-.029-.061-.032-.057-.035-.14-.035-.186.02-.032.034-.019.101.031.11.059.015.119-.002.178-.003.056-.003.12.003.16.048.05.05.054.132.02.192a.231.231 0 0 1-.18.107c-.035.001-.036.04-.044.06-.01.011-.012-.008-.019-.014l-.093-.153c.022-.02.036.028.058.032.058.045.15.056.208.004.044-.032.046-.112-.01-.135-.055-.023-.117-.004-.175-.003-.062.005-.135-.003-.175-.057-.053-.062-.04-.161.02-.213a.214.214 0 0 1 .134-.053c.035.003.038-.033.03-.055l.009-.006zm.51.27c-.015.047-.036.1-.084.122-.04.018-.087-.011-.096-.053-.014-.052.017-.101.04-.146.012-.027.04-.053.045-.08-.016-.023-.028-.049-.048-.069-.034-.022-.09.014-.082.053.022.015.061.021.056.058-.002.044-.064.068-.095.037-.033-.04-.012-.098.017-.134a.217.217 0 0 1 .125-.08c.048-.009.091.02.11.063.033.052.064.105.098.157.009.023.04.012.036-.012.027-.003.01.032.008.048-.012.038-.053.069-.093.061a.077.077 0 0 1-.036-.025zm-.015-.025-.064-.105c-.019.038-.037.082-.024.124.011.044.073.037.082-.004l.003-.007zm.145-.435.025.04c.007-.05.034-.102.085-.12.044-.016.092.013.114.052.04.06.075.125.115.185.01.025.039.018.055.015.01.009 0 .013-.008.018l-.144.09c-.018-.017.023-.031.006-.054-.022-.044-.05-.086-.076-.129-.02-.03-.036-.063-.06-.09-.041-.033-.073.033-.066.07l.113.183c.01.024.037.03.056.025.01.009.001.013-.008.018l-.143.09c-.02-.02.03-.034.008-.06-.026-.048-.057-.094-.085-.14-.02-.034-.039-.068-.063-.099-.013-.024-.049.012-.051-.015l.126-.08zm.31-.35.07.115.074-.047.02.033-.073.047c.043.07.085.141.13.211.01.033.06.028.061-.008.003-.014-.004-.035.017-.028.01.05-.013.108-.063.127a.09.09 0 0 1-.117-.046l-.121-.197-.04.026c-.017-.018.01-.04.01-.06a.452.452 0 0 0 .021-.165l.011-.007zm.31-.05a.162.162 0 0 1 .183.004.24.24 0 0 1 .1.178.162.162 0 0 1-.074.148.152.152 0 0 1-.151.018.224.224 0 0 1-.123-.274.16.16 0 0 1 .065-.074zm.016.023c-.044.03-.01.085.009.12.03.054.059.11.101.155.03.037.097.01.085-.039-.008-.04-.033-.074-.052-.11-.024-.04-.046-.081-.078-.114-.017-.016-.044-.028-.065-.012zm-1.666 2.067.113.185c.032-.017.06-.049.055-.088.006-.029-.032-.066-.017-.085.01-.005.014.017.02.023l.13.212c-.024.021-.036-.037-.06-.04-.031-.029-.09-.023-.11.006.034.055.066.111.102.164.021.024.05.003.071-.01.056-.031.105-.085.105-.152.011-.026-.026-.067.002-.082l.068.158-.388.246c-.015-.013 0-.018.012-.025.042-.021.023-.07 0-.097l-.196-.32c-.016-.034-.059-.023-.082-.004-.011.007-.018-.016-.002-.016l.364-.231.082.134c-.025.02-.04-.034-.067-.038-.047-.028-.103-.005-.145.023zm.7.18-.274-.191c-.021-.016-.05-.03-.074-.022-.005-.006-.009-.012.001-.015l.157-.1c.008.009.01.016-.004.022-.022.033.024.056.046.073l.118.082c-.01-.056-.018-.113-.03-.168-.002-.028-.027-.06-.056-.038-.005.006-.017-.012-.008-.013l.097-.061c.019.016-.015.028-.01.048.001.046.011.091.017.137l.036.236zm.33-.3c-.015.047-.036.1-.084.122-.04.018-.087-.011-.096-.053-.014-.052.017-.101.04-.146.012-.027.04-.053.045-.079-.016-.024-.028-.05-.048-.07-.034-.022-.09.014-.082.053.021.016.061.021.056.058-.002.043-.064.068-.095.037-.033-.04-.013-.098.017-.134a.217.217 0 0 1 .125-.08c.048-.009.091.02.11.063l.097.157c.01.023.04.012.036-.012.028-.003.01.032.008.048-.011.038-.052.069-.092.061a.072.072 0 0 1-.036-.025zm-.015-.025-.064-.105c-.019.038-.037.082-.024.124.011.044.073.037.082-.004l.003-.007zm.155-.425.025.04c.007-.05.033-.102.084-.12.045-.016.093.013.115.052.04.06.075.125.115.185.01.025.039.018.055.015.01.01 0 .013-.008.018l-.144.091c-.018-.018.023-.032.006-.055-.022-.044-.05-.085-.075-.127-.02-.031-.036-.064-.06-.092-.042-.033-.074.033-.067.07l.113.184c.01.024.037.03.057.024.01.009 0 .013-.008.018l-.144.09c-.02-.019.03-.034.008-.059-.026-.049-.057-.096-.086-.144-.02-.032-.038-.066-.062-.095-.013-.024-.049.012-.05-.015l.125-.08zm.45-.28.104-.066.023.037-.06.037c.062.01.103.078.087.137a.184.184 0 0 1-.103.12c-.05.011-.029.1.021.07.054-.031.102-.073.163-.087.044-.01.086.022.098.063.016.05-.011.102-.048.136a.368.368 0 0 1-.178.096c-.05.015-.09-.047-.052-.085.006-.01.027-.025.003-.019a.071.071 0 0 1-.077-.066c-.004-.035.014-.068.033-.097-.048.013-.104.004-.137-.036-.046-.052-.033-.136.014-.183a.193.193 0 0 1 .11-.057zm-.053.044c-.037.026-.015.077.003.108.022.035.044.085.091.088.044-.003.05-.06.03-.09a.281.281 0 0 0-.077-.105.042.042 0 0 0-.047 0zm.194.361c-.035.012-.073.07-.023.09.043.012.082-.02.117-.04.031-.023.08-.067.047-.107-.045-.018-.084.027-.123.045zm.339-.535-.17.108c.028.041.07.08.122.083.049.003.083-.044.082-.09-.001-.012-.002-.022.012-.019.012 0 .002.025.006.033a.156.156 0 0 1-.047.125c-.04.037-.1.056-.152.034a.246.246 0 0 1-.13-.151c-.024-.071-.004-.162.063-.202.053-.035.126-.019.169.024a.304.304 0 0 1 .045.055zm-.095.03c-.024-.035-.043-.081-.088-.09-.048 0-.045.06-.031.091.007.02.018.038.029.056l.09-.058zm.085-.41.243.398a.045.045 0 0 0 .066.023c.008.009.005.014-.005.018l-.155.099c-.02-.02.03-.03.014-.056-.017-.037-.041-.071-.062-.107l-.158-.259a.044.044 0 0 0-.065-.022c-.008-.008-.008-.014.003-.018l.12-.076zm.13-.11c.032-.023.082-.002.09.036.011.04-.025.083-.066.077-.044-.004-.069-.062-.042-.096a.051.051 0 0 1 .018-.017zm.14.123.156.256a.045.045 0 0 0 .066.023c.007.008.007.014-.004.017l-.157.1c-.02-.019.026-.026.015-.05-.012-.034-.033-.062-.05-.093l-.09-.144c-.01-.027-.042-.025-.06-.017-.009-.007-.008-.013.002-.016l.12-.076zm.21-.133a.162.162 0 0 1 .183.004c.059.043.1.113.1.187a.161.161 0 0 1-.079.141.15.15 0 0 1-.154.012.224.224 0 0 1-.114-.27.16.16 0 0 1 .064-.074zm.016.023c-.044.03-.01.085.009.12.03.054.059.11.101.155.03.038.097.01.085-.039-.008-.04-.033-.074-.052-.11-.026-.04-.048-.085-.083-.118-.016-.014-.041-.022-.06-.008zm-1.946 2.207.096.15c-.023.023-.037-.029-.061-.033-.057-.034-.14-.034-.186.02-.032.035-.019.102.031.112.059.014.119-.003.178-.004.056-.003.12.003.16.048.05.05.054.132.02.192a.231.231 0 0 1-.18.107c-.035.001-.036.04-.044.06-.01.011-.012-.008-.018-.014l-.093-.153c.021-.02.035.028.057.032.058.045.15.056.208.004.044-.032.046-.112-.009-.135-.056-.023-.117-.004-.175-.003-.063.005-.135-.004-.176-.056-.054-.065-.038-.169.027-.22a.215.215 0 0 1 .127-.047c.036.003.038-.033.03-.055a.03.03 0 0 1 .008-.005zm.53.08-.17.108c.028.041.07.08.122.083.049.003.083-.044.082-.09-.001-.012-.002-.022.012-.019.012 0 .002.025.006.033a.156.156 0 0 1-.047.125c-.04.037-.1.056-.152.034a.245.245 0 0 1-.13-.151c-.024-.071-.004-.162.063-.202.053-.035.126-.019.169.024a.301.301 0 0 1 .045.055zm-.095.03c-.024-.035-.044-.081-.088-.09-.048 0-.045.06-.031.091.007.02.018.038.029.056l.09-.058zm.235-.33.104-.066.023.037-.06.037c.062.01.103.078.087.137a.184.184 0 0 1-.103.12c-.05.011-.028.1.021.07.054-.031.102-.073.163-.087.044-.01.086.022.098.063.016.05-.011.102-.048.136a.37.37 0 0 1-.178.096c-.05.014-.09-.047-.052-.085.006-.01.027-.025.003-.02a.071.071 0 0 1-.077-.065c-.004-.035.014-.069.033-.097-.048.013-.104.004-.137-.036-.046-.052-.033-.136.014-.183a.19.19 0 0 1 .11-.057zm-.053.044c-.037.026-.015.077.003.108.022.035.044.085.091.088.044-.003.05-.06.03-.09a.284.284 0 0 0-.077-.105.042.042 0 0 0-.047 0zm.194.361c-.035.012-.073.07-.023.09.043.012.082-.02.117-.04.031-.023.08-.067.047-.107-.045-.018-.084.027-.123.045zm.299-.685.16.262a.04.04 0 0 0 .059.02c.008.008.005.014-.005.018l-.115.072-.025-.042c-.005.051-.033.104-.083.121-.044.015-.092-.01-.114-.048-.042-.061-.077-.126-.118-.188-.01-.024-.038-.017-.054-.014-.009-.008-.004-.013.005-.017l.115-.073.145.236c.015.042.074.03.076-.013.005-.02.01-.04-.005-.056l-.103-.167a.04.04 0 0 0-.057-.02c-.008-.008-.008-.014.003-.018zm.21-.13.025.04c.007-.05.034-.102.085-.12.044-.016.092.013.114.052.04.06.075.125.116.185.01.025.038.018.054.015.01.009 0 .013-.008.018l-.144.09c-.018-.017.023-.031.006-.054-.022-.044-.05-.086-.076-.129-.02-.03-.036-.063-.06-.09-.041-.033-.073.033-.066.07l.113.184c.01.023.037.03.056.024.01.009.001.013-.008.018l-.143.09c-.02-.019.03-.034.008-.059-.027-.05-.058-.096-.086-.144-.02-.032-.038-.066-.062-.096-.013-.024-.049.013-.051-.015l.126-.08zm.62-.6.096.15c-.023.023-.037-.029-.061-.033-.057-.034-.14-.034-.186.02-.032.035-.019.102.031.112.059.014.119-.003.178-.004.056-.003.12.003.16.048.05.05.054.132.02.192a.231.231 0 0 1-.18.107c-.035.001-.036.04-.044.06-.01.012-.012-.008-.018-.014l-.094-.153c.022-.02.036.028.058.032.058.045.15.056.208.004.044-.032.046-.112-.009-.135-.056-.023-.117-.004-.175-.003-.063.005-.135-.003-.176-.056a.158.158 0 0 1 .02-.214.213.213 0 0 1 .134-.053c.036.003.038-.033.03-.055l.008-.006zm.5.24c-.015.047-.036.1-.084.122-.04.019-.087-.012-.096-.053-.014-.05.015-.098.038-.14.012-.03.041-.057.047-.085-.016-.024-.028-.05-.048-.07-.033-.022-.09.014-.082.053.021.016.061.021.056.058-.002.044-.064.068-.095.037-.033-.04-.013-.098.017-.133a.216.216 0 0 1 .125-.081.104.104 0 0 1 .11.063l.097.157c.01.023.04.012.036-.012.028-.003.01.032.007.048-.011.038-.052.069-.092.061a.075.075 0 0 1-.037-.025zm-.015-.025-.064-.105c-.019.038-.037.082-.024.124.011.044.073.037.082-.004l.003-.007zm.155-.415.025.04c.007-.05.034-.102.085-.12.044-.016.092.013.114.052.04.06.075.125.116.185.01.025.038.018.054.015.01.009 0 .013-.008.018l-.144.09c-.018-.017.023-.031.006-.054-.022-.044-.05-.086-.076-.129-.019-.03-.036-.063-.06-.09-.041-.033-.073.033-.066.07l.113.184c.01.023.037.03.057.024.01.009 0 .013-.008.018l-.144.09c-.02-.02.03-.034.008-.059-.026-.05-.057-.096-.086-.144-.02-.032-.038-.066-.062-.096-.013-.024-.049.013-.05-.015l.125-.079zm.42-.44c-.008-.009-.009-.015.003-.02l.227-.144c.008.01.01.016-.003.02-.038.015-.043.06-.016.09l.155.254c.024.041.044.091.025.138a.194.194 0 0 1-.146.119c-.048.008-.108-.012-.124-.062-.014-.042.03-.088.072-.074.044.01.031.062.043.092.04.024.097-.03.065-.071-.04-.075-.087-.147-.131-.22-.028-.044-.053-.09-.083-.133-.02-.026-.056-.012-.077.004l-.01.006zm.64-.23.16.262a.04.04 0 0 0 .059.02c.008.008.005.014-.005.018l-.115.072-.025-.042c-.005.049-.03.099-.076.119a.097.097 0 0 1-.118-.042c-.043-.062-.079-.129-.12-.192-.01-.024-.039-.017-.055-.014-.009-.008-.004-.013.005-.017l.115-.073c.048.079.095.158.145.236.015.042.074.03.076-.013.005-.02.009-.04-.005-.056l-.103-.167a.04.04 0 0 0-.058-.02c-.008-.008-.008-.014.003-.018zm.41.1c-.015.047-.036.1-.084.122-.04.019-.087-.012-.096-.053-.014-.052.017-.101.04-.146.012-.027.04-.053.045-.08-.016-.023-.028-.049-.048-.069-.034-.022-.09.014-.082.053.021.015.061.02.056.057-.002.044-.064.069-.095.037-.033-.04-.013-.097.017-.133a.216.216 0 0 1 .125-.08c.048-.009.091.02.11.063l.097.157c.01.023.04.012.036-.012.028-.003.01.032.008.048-.011.038-.052.069-.092.061a.074.074 0 0 1-.037-.025zm-.015-.025-.064-.105c-.019.038-.037.082-.024.124.011.044.073.037.082-.004l.003-.007zm.145-.425.025.04c.007-.05.034-.102.085-.12.044-.016.092.013.114.052.04.06.075.125.115.185.01.025.039.018.055.015.01.009 0 .013-.008.018l-.144.09c-.018-.017.023-.031.006-.054-.022-.044-.05-.086-.076-.129-.019-.03-.036-.063-.06-.09-.041-.033-.073.033-.066.07l.113.184c.01.023.037.03.057.024.01.009 0 .013-.008.018l-.144.09c-.02-.02.03-.034.008-.059-.026-.05-.057-.096-.086-.144-.02-.032-.038-.066-.062-.096-.013-.024-.049.012-.051-.015l.125-.079zm-2.7 4.74.105.148c-.022.018-.04-.03-.064-.033a.165.165 0 0 0-.187.012.17.17 0 0 0-.07.161c.009.078.048.15.098.209.042.049.107.082.173.07.076-.013.147-.071.16-.15.012-.02-.001-.062.017-.07.02.001.002.042.006.057a.23.23 0 0 1-.112.177.238.238 0 0 1-.225.026.304.304 0 0 1-.16-.387.262.262 0 0 1 .223-.159c.035.002.025-.04.028-.056zm.54.08-.174.11c.007.042.01.085.021.126.008.042.057.017.077.01.012.01 0 .015-.01.02l-.126.08c-.022-.022.034-.035.024-.064.002-.05-.011-.1-.018-.151l-.059-.397c.009-.01.017-.005.025.003l.391.281c.03.027.076.032.108.017.012.01 0 .014-.01.02l-.161.102c-.023-.022.035-.029.025-.057-.008-.03-.04-.044-.062-.062l-.051-.037zm-.025-.019-.188-.136.034.234.155-.098zm.305-.251c.031.05.061.102.094.152.015.035.058.038.084.014.007-.011.016 0 .016.007l-.191.121c-.009-.009-.009-.015.004-.02.041-.016.04-.066.014-.096l-.192-.314a.053.053 0 0 0-.086-.018c-.008.01-.018.002-.018-.007.067-.042.132-.086.2-.125.048-.028.109-.042.161-.018.075.035.106.14.058.207a.283.283 0 0 1-.144.097zm-.012-.02c.042-.014.092-.036.1-.086.016-.063-.03-.131-.09-.151-.047-.014-.094.014-.125.05l.115.188zm.592-.05c.008.009.009.015-.003.02l-.181.115c-.008-.01-.01-.016.003-.02.038-.016.043-.062.017-.092l-.195-.32c-.015-.037-.06-.042-.088-.017-.007.012-.018-.004-.014-.009l.19-.12c.008.009.009.015-.003.02-.039.015-.043.062-.017.092l.19.312c.014.038.06.054.091.025l.01-.007zm.13-.71.07.104c-.024.021-.035-.036-.064-.034-.043-.015-.08.018-.115.039l-.026.017.221.362c.015.037.059.043.087.017.007-.013.02.006.012.01l-.186.118c-.011-.01-.006-.016.006-.021.043-.02.033-.07.008-.1l-.212-.346c-.034.023-.072.04-.1.072-.023.03-.001.074 0 .1-.01.012-.012-.007-.018-.014l-.05-.091.367-.232zm.36-.2c-.012-.01-.004-.017.007-.022l.144-.091c.012.01.004.017-.007.022-.042.022-.03.075-.004.105.044.074.091.147.133.222.026.046.042.102.023.153-.024.075-.097.12-.166.149a.159.159 0 0 1-.19-.063c-.05-.072-.093-.148-.139-.222-.018-.027-.031-.062-.064-.072-.022-.005-.041.016-.058.02-.013-.01 0-.015.01-.021l.177-.113c.012.011.004.017-.007.023-.042.019-.033.07-.008.1.045.072.089.146.135.218.029.04.064.089.119.089a.178.178 0 0 0 .147-.094.129.129 0 0 0 .002-.127c-.033-.068-.077-.131-.115-.197-.021-.032-.037-.068-.065-.094-.025-.017-.051.003-.073.015zm.74-.05c.013-.01.015.002.017.013.01.044.022.087.033.13l-.348.22c-.011-.01-.005-.016.006-.021.044-.02.032-.072.007-.102l-.188-.307a.054.054 0 0 0-.087-.018c-.007.013-.023-.004-.014-.009l.2-.126c.021.023-.033.028-.039.05-.023.033.007.066.023.094.059.097.117.194.177.29.022.046.07.014.098-.007.038-.026.083-.047.106-.089.019-.036.013-.079.008-.118zm.08-.5c.1-.067.243-.04.321.048a.3.3 0 0 1 .076.277.256.256 0 0 1-.276.193.274.274 0 0 1-.2-.14.278.278 0 0 1-.026-.253.26.26 0 0 1 .105-.125zm.009.029a.152.152 0 0 0-.07.15.423.423 0 0 0 .105.217c.043.049.106.093.174.081a.161.161 0 0 0 .128-.157.387.387 0 0 0-.088-.211c-.04-.054-.097-.107-.169-.107a.155.155 0 0 0-.08.026zm.881-.589c.021.02-.025.033-.02.058-.006.046.008.092.013.139l.068.41c-.009.01-.017.008-.026 0l-.415-.29c-.025-.029-.067-.008-.09-.006-.012-.01.004-.013.011-.018l.167-.106c.024.023-.038.032-.028.062.01.03.041.046.066.064l.264.185-.06-.353c.002-.043-.041-.07-.077-.044-.007.004-.017-.015-.003-.016l.13-.084zm.49.31c.008.009.009.015-.003.02l-.181.115c-.008-.01-.01-.016.003-.02.038-.016.043-.062.017-.092l-.195-.32c-.015-.037-.06-.042-.088-.017-.007.012-.018-.004-.014-.009l.19-.12c.008.009.009.015-.003.02-.039.015-.043.062-.017.092l.19.312c.014.038.06.054.091.025l.01-.007zm.23-.15c.008.009.009.015-.003.02l-.181.115c-.008-.01-.01-.016.003-.02.038-.016.043-.062.017-.092l-.195-.32c-.015-.037-.06-.041-.088-.017-.007.012-.018-.004-.014-.009l.19-.12c.008.009.009.015-.003.02-.039.015-.043.062-.017.092l.19.312c.014.038.06.054.091.025l.01-.007zm.22-.14c.008.009.009.015-.003.02l-.181.115c-.008-.01-.01-.016.003-.02.038-.016.043-.062.017-.092l-.195-.32c-.015-.037-.06-.042-.088-.017-.007.012-.018-.004-.014-.009l.19-.12c.008.009.009.015-.003.02-.039.015-.043.062-.017.092l.19.312c.014.038.06.054.091.025l.01-.007zm-3.92 4.12c-.009-.055-.003-.12.043-.158.035-.032.088-.05.134-.029.053.02.07.082.06.133.002.014-.018.046-.005.047a.14.14 0 0 1 .143.057.185.185 0 0 1-.008.225.271.271 0 0 1-.121.083c-.034.015-.07-.033-.033-.054.038-.021.089-.003.123-.036.047-.037.048-.113.007-.155a.12.12 0 0 0-.12-.042c-.025 0-.05.019-.068.027-.015-.017.025-.027.026-.046a.12.12 0 0 0 0-.142c-.03-.048-.104-.046-.138-.003-.026.023-.024.067-.033.092a.28.28 0 0 1-.01 0zm.36-.29.076-.123c.008-.008.014-.007.017.004l.24.39c.011.032.046.046.073.024.01-.012.017-.008.022.004l-.169.107c-.022-.022.03-.026.033-.05.008-.028-.018-.051-.03-.075-.056-.091-.11-.183-.168-.274-.011-.03-.052-.052-.071-.016-.01.013-.01.02-.023.01zm.73-.51.157-.1c.02.018-.015.02-.019.037-.032.048-.022.107-.025.161l-.002.195c.03.046.056.095.088.14.018.034.058.022.082.003.01-.004.017.016.001.017l-.18.114c-.012-.01-.005-.017.007-.022.043-.02.03-.071.006-.1l-.064-.105c-.094-.043-.187-.089-.281-.13-.026-.019-.065.003-.084-.003-.01-.01.012-.013.018-.02l.17-.108c.02.018-.016.02-.021.037-.03.038.023.06.052.073l.174.082.002-.216a.046.046 0 0 0-.075-.045.047.047 0 0 1-.005-.01zm.82.04c-.008.052-.043.101-.095.115-.068.02-.142-.02-.178-.078a.225.225 0 0 1-.016-.226c.026-.044.08-.08.132-.067-.025-.04-.048-.082-.076-.12-.018-.027-.044 0-.056.01-.013-.005-.007-.012 0-.02.02-.027.039-.056.06-.083.007-.006.015-.011.019.002.079.129.156.257.236.385.01.026.047.054.066.02.005-.015.024.005.01.012l-.061.086c-.008.005-.016.014-.02 0l-.02-.036zm-.014-.024-.097-.158c-.025-.037-.078-.06-.12-.035-.044.03-.043.095-.023.14.025.059.07.122.138.132a.082.082 0 0 0 .094-.051.147.147 0 0 0 .008-.028zm.094-.236c.028.048.075.09.133.093.054.005.11-.036.115-.092.005-.017-.006-.043-.001-.055.023-.005.017.032.023.046.007.053-.006.113-.05.146a.148.148 0 0 1-.163.012.248.248 0 0 1-.106-.136.166.166 0 0 1 .051-.188.134.134 0 0 1 .138-.023c.027.012.063.04.066.066zm-.012-.02.14-.089c-.018-.033-.057-.06-.096-.048-.049.013-.07.073-.052.117a.14.14 0 0 0 .008.02zm.572-.22a.184.184 0 0 1-.014.172.134.134 0 0 1-.145.05c-.066-.016-.112-.073-.138-.133-.033-.075-.009-.175.064-.218a.124.124 0 0 1 .132-.008c.03.015.027.061-.007.07-.046.02-.055-.06-.102-.042-.048.013-.068.067-.056.112a.208.208 0 0 0 .123.145c.05.02.109-.01.126-.06.015-.026.003-.064.007-.087zm-.1-.44c.047-.032.088.054.035.072-.045.017-.076-.047-.035-.072zm.126.143c.053.087.105.174.16.26.012.03.048.04.072.016.005.007.01.015-.002.018l-.139.088c-.02-.022.032-.025.024-.051-.003-.03-.024-.053-.038-.078-.03-.05-.06-.1-.093-.148-.015-.026-.045-.008-.057.01-.008-.006-.014-.01-.005-.017.022-.03.042-.06.064-.088zm.414.107c-.016.038-.024.084-.06.109-.043.035-.109.012-.13-.036-.023-.04-.004-.087.016-.124a1.04 1.04 0 0 1 .076-.108c-.015-.026-.03-.055-.06-.067-.041-.013-.098.032-.075.076.01.016.026.034.017.054-.018.039-.07.013-.07-.023-.007-.053.03-.099.073-.124.034-.022.08-.042.118-.018.028.02.042.052.06.08.029.045.055.092.086.136.019.026.042-.005.04-.027.002-.012.004-.018.01-.006.015.02-.002.05-.007.071-.01.038-.063.058-.085.02-.005 0-.004-.015-.01-.013zm-.013-.022-.072-.117c-.027.04-.064.08-.066.13 0 .04.041.081.082.068.032-.014.045-.052.056-.08zm.113-.608c-.006-.008-.01-.015.001-.018l.183-.116c.006.008.01.014-.001.018-.033.014-.048.055-.024.084l.158.26c.026.045.042.1.025.152a.115.115 0 0 1-.103.081c-.049.006-.079-.072-.023-.086.035-.011.064.055.094.021.01-.03-.014-.056-.028-.081l-.186-.303c-.014-.037-.059-.042-.087-.018zm.42.09c.028.048.075.09.133.093.054.005.11-.036.115-.092.005-.017-.006-.043-.001-.055.023-.005.017.032.023.046.007.053-.006.113-.05.146a.147.147 0 0 1-.156.016.242.242 0 0 1-.113-.14.166.166 0 0 1 .05-.188.134.134 0 0 1 .14-.023c.026.012.062.04.065.066zm-.012-.02.14-.089c-.018-.033-.057-.06-.096-.048-.049.013-.07.073-.052.117a.14.14 0 0 0 .008.02zm.382-.39.064.105c-.017.018-.03-.018-.046-.023a.087.087 0 0 0-.122.018c-.03.04.014.09.058.082.047 0 .093-.014.14-.008a.099.099 0 0 1 .087.087c.005.055-.033.107-.083.128-.025.016-.067.012-.077.044-.007.008-.01.001-.014-.006l-.06-.1c.017-.017.027.019.044.023.04.03.104.03.137-.011.026-.03.008-.08-.03-.09-.058-.013-.118.01-.176-.003-.057-.016-.085-.09-.058-.14.018-.04.06-.062.1-.071.017-.001.029-.014.026-.03l.01-.006zm.35-.19c.049.079.096.158.146.236.013.034.052.027.066.004.01.004.01.01.003.017-.02.03-.04.059-.062.087-.007.003-.015.013-.018 0l-.035-.058c-.01.045-.017.099-.058.127-.036.03-.092.02-.12-.016-.033-.038-.056-.084-.083-.127-.018-.028-.033-.059-.055-.084-.02-.022-.05.006-.065.005-.009-.008-.003-.013.005-.016l.095-.06.133.215c.017.043.077.051.103.012.014-.023.038-.057.027-.083l-.106-.173c-.014-.032-.052-.023-.073-.009-.006-.007-.01-.013.002-.017zm.26-.19.064.105c-.017.018-.03-.018-.046-.023a.087.087 0 0 0-.122.018c-.03.04.015.09.058.082.047 0 .093-.014.14-.008a.099.099 0 0 1 .087.087c.005.055-.033.107-.082.128-.026.016-.068.012-.078.044-.007.008-.01.001-.014-.006l-.06-.1c.017-.017.027.019.044.023.04.03.104.03.137-.011.026-.03.008-.08-.03-.09-.06-.014-.123.014-.184-.005-.053-.021-.076-.093-.048-.143.02-.037.06-.056.099-.066.016-.002.028-.013.025-.03zm.57.02c-.016.038-.024.084-.06.109-.043.035-.109.012-.13-.036-.023-.04-.004-.087.016-.124.023-.038.05-.073.076-.108-.015-.026-.031-.055-.06-.067-.041-.013-.098.032-.075.076.01.016.026.034.017.054-.018.039-.07.013-.07-.023-.007-.053.03-.1.073-.125.034-.02.08-.04.118-.018.028.02.042.052.06.08.029.046.055.093.086.137.019.026.042-.005.04-.027.002-.012.004-.018.01-.006.015.02-.002.05-.007.071-.01.038-.063.058-.085.02l-.004-.007-.004-.006zm-.013-.022-.072-.117c-.027.04-.064.08-.066.13 0 .04.041.081.082.068.032-.014.045-.052.056-.08zm-4.497 3.472.258.42c.013.039.055.03.077.016.009.008.003.013-.006.017l-.137.087c-.021-.02.03-.024.022-.05-.004-.03-.025-.053-.039-.08-.06-.096-.117-.193-.178-.288-.01-.027-.044-.047-.062-.016-.003.012-.025-.003-.012-.01.021-.029.041-.06.063-.088l.014-.009zm.33 0a.16.16 0 0 1 .158-.01.21.21 0 0 1 .117.184.167.167 0 0 1-.08.154.153.153 0 0 1-.157.007.211.211 0 0 1-.115-.193.165.165 0 0 1 .077-.142zm.003.028c-.038.024-.044.076-.028.115a.284.284 0 0 0 .135.155c.04.022.096.008.115-.035.02-.046-.005-.094-.029-.133-.03-.05-.074-.1-.135-.113a.087.087 0 0 0-.058.011zm.377-.268.064.105c-.017.018-.03-.018-.046-.023-.036-.03-.095-.02-.122.018-.03.04.015.09.058.082.047 0 .093-.014.14-.008a.099.099 0 0 1 .087.087c.005.055-.033.107-.083.128-.025.016-.067.012-.077.044-.007.008-.01.001-.014-.006l-.06-.1c.017-.017.027.019.044.023.04.03.104.029.137-.011.026-.03.008-.08-.03-.09-.058-.013-.118.01-.176-.003-.057-.016-.084-.09-.058-.14.018-.04.06-.061.1-.07.017-.002.029-.015.026-.03l.01-.007zm.22-.35c.048-.032.089.054.035.073-.045.017-.074-.048-.035-.073zm.127.143.198.324c.03.05.046.117.013.17-.024.036-.07.075-.115.06-.042-.028.008-.08.045-.06a.039.039 0 0 0 .049-.057c-.034-.064-.075-.125-.112-.188-.032-.05-.06-.102-.096-.15-.018-.028-.043.009-.056.01-.014-.004-.002-.013.003-.02.02-.028.038-.056.059-.082zm.363-.213c.049.079.096.158.146.236.013.034.052.027.066.004.01.004.01.01.003.017-.02.03-.04.059-.062.087-.007.003-.015.013-.018 0l-.035-.058c-.01.045-.017.099-.058.127-.036.03-.092.02-.12-.016-.032-.038-.055-.083-.082-.126-.019-.028-.034-.06-.056-.086-.02-.022-.05.006-.065.005-.009-.008-.003-.012.005-.016l.095-.06.133.216c.017.042.077.051.103.012.014-.023.038-.057.027-.084l-.106-.172c-.014-.032-.052-.024-.073-.009-.006-.007-.01-.014.002-.017zm.45.1c-.008.052-.043.101-.095.115-.068.02-.142-.02-.178-.078a.225.225 0 0 1-.016-.226c.027-.044.08-.08.132-.067-.025-.04-.048-.082-.077-.12-.017-.027-.043 0-.055.01-.013-.005-.007-.012 0-.02.02-.027.039-.056.06-.083.007-.006.015-.011.019.002.078.128.156.257.236.385.01.026.046.054.066.02.005-.015.024.005.01.011-.02.03-.04.059-.061.087-.008.005-.016.014-.02 0l-.02-.036zm-.014-.024-.097-.158c-.025-.037-.078-.06-.12-.035-.044.03-.043.095-.023.14.025.06.07.122.138.132a.082.082 0 0 0 .094-.051.137.137 0 0 0 .008-.028zm-.056-.556c.047-.032.088.054.035.072-.045.017-.076-.047-.035-.072zm.126.143c.053.087.105.174.16.26.012.03.048.04.072.016.005.007.01.015-.002.018l-.139.088c-.02-.022.032-.025.024-.052-.003-.029-.024-.052-.038-.077-.03-.05-.06-.1-.093-.148-.015-.026-.045-.008-.057.01-.008-.006-.014-.01-.005-.017.022-.03.042-.06.064-.088zm.224-.153a.16.16 0 0 1 .158-.01.21.21 0 0 1 .117.184.167.167 0 0 1-.08.154.153.153 0 0 1-.157.007.211.211 0 0 1-.115-.193.165.165 0 0 1 .077-.142zm.003.028c-.038.024-.044.076-.028.115a.284.284 0 0 0 .135.155c.04.022.096.008.115-.035.02-.046-.005-.094-.029-.133-.03-.05-.074-.1-.135-.113a.082.082 0 0 0-.058.011zm.387-.278.064.105c-.021.018-.037-.028-.06-.03-.045-.028-.119.004-.118.06.007.046.063.053.1.045.052-.004.107-.02.153.01.044.03.054.094.027.137-.024.049-.078.069-.126.083-.013.003-.022.044-.033.017l-.06-.099c.02-.018.035.03.06.031.042.024.108.013.13-.035.016-.038-.02-.08-.06-.078-.056-.005-.115.017-.17-.004a.105.105 0 0 1-.032-.154c.024-.035.068-.045.106-.058.015-.008 0-.025.019-.03zm.5-.32.25.409c.013.036.054.028.076.012.01.009.005.015-.005.02l-.14.088c-.02-.016.01-.02.018-.034.02-.026-.007-.053-.02-.077l-.073-.12c-.006.05-.022.109-.072.132-.06.027-.133-.004-.172-.053-.049-.059-.074-.142-.046-.216.02-.058.075-.11.14-.11.025.002.02-.045.044-.051zm.093.277c-.032-.052-.063-.105-.096-.156-.02-.037-.071-.044-.104-.02-.049.03-.056.098-.032.146.024.054.064.114.128.122a.093.093 0 0 0 .103-.079c-.004.001.007-.014.002-.013zm.257-.467c.049.079.096.158.146.236.013.034.052.027.066.004.01.004.01.01.003.017-.02.03-.04.059-.062.087-.007.003-.015.013-.018 0l-.035-.058c-.01.045-.017.099-.058.127-.036.03-.092.02-.12-.016-.032-.038-.055-.083-.082-.126-.019-.028-.034-.06-.056-.086-.02-.022-.05.006-.065.005-.009-.008-.003-.012.005-.016l.095-.06.133.216c.017.042.077.051.103.012.014-.023.038-.057.027-.084l-.106-.172c-.014-.032-.051-.024-.073-.009-.006-.007-.01-.014.002-.017zm.19.02c.028.048.075.09.133.093.054.005.11-.036.115-.092.005-.017-.006-.043-.001-.055.023-.005.017.032.024.046.007.053-.006.113-.05.146a.147.147 0 0 1-.156.016.242.242 0 0 1-.114-.14.166.166 0 0 1 .051-.188.134.134 0 0 1 .138-.023c.027.012.063.04.066.066l-.206.13zm-.012-.02.14-.089c-.018-.033-.057-.06-.096-.048-.049.013-.07.073-.052.117a.14.14 0 0 0 .008.02zm.372-.59.258.42c.013.039.055.03.077.016.009.008.003.014-.006.018l-.137.087c-.021-.021.03-.025.022-.05-.004-.03-.025-.054-.039-.08-.06-.096-.117-.193-.178-.29-.01-.026-.044-.046-.062-.015-.003.013-.025-.003-.012-.01.021-.029.041-.059.063-.087l.014-.01zm.3.2c.028.048.075.09.133.093.054.005.11-.036.115-.092.005-.017-.006-.043-.001-.055.023-.005.017.032.024.046.007.053-.006.113-.05.146a.147.147 0 0 1-.156.016.242.242 0 0 1-.114-.14.166.166 0 0 1 .051-.188.134.134 0 0 1 .138-.023c.027.012.063.04.066.066zm-.012-.02.14-.089c-.018-.034-.056-.06-.096-.048-.048.013-.07.073-.052.117a.14.14 0 0 0 .008.02zm-3.718 3.19.137.225c.01-.049.02-.107.07-.132.043-.027.096.002.12.04.043.06.077.125.118.185.014.03.049.014.066.008.011.01-.003.014-.011.02l-.133.084c-.02-.02.024-.022.025-.042.01-.027-.014-.049-.025-.07-.032-.051-.06-.104-.097-.151-.03-.044-.091-.014-.105.028-.007.022-.024.048-.005.067.035.057.069.115.106.171.014.035.053.004.07.006.01.01-.007.014-.013.02l-.133.083c-.02-.022.037-.029.024-.058-.013-.037-.038-.069-.057-.103-.055-.088-.108-.178-.164-.265-.013-.035-.052-.025-.067-.004-.014-.005-.005-.014.001-.022.02-.027.039-.055.06-.082l.013-.009zm.68.16c-.016.038-.024.084-.06.109-.043.035-.109.012-.13-.036-.023-.04-.004-.087.016-.124a1.04 1.04 0 0 1 .076-.108c-.015-.026-.031-.055-.06-.067-.041-.013-.098.032-.075.076.01.016.026.034.017.054-.018.039-.07.013-.07-.023-.007-.053.03-.1.073-.125.034-.02.08-.04.118-.018.028.02.042.053.06.08.029.046.055.093.086.137.019.026.042-.005.04-.027.002-.012.004-.018.01-.006.015.02-.002.05-.007.071-.01.038-.063.058-.085.02l-.004-.007-.004-.006zm-.013-.022-.072-.117c-.027.04-.064.08-.066.13 0 .04.041.081.082.067.032-.013.045-.05.056-.08zm.093-.328c.002-.052.022-.112.075-.132.063-.026.137.01.174.062a.215.215 0 0 1 .044.19.178.178 0 0 1-.136.133c-.024 0-.062.019-.078 0l-.214-.35c-.011-.027-.047-.053-.067-.019-.004.014-.025-.004-.011-.01a1.4 1.4 0 0 1 .063-.088c.007-.005.016-.013.019 0zm.013.021.113.184c.044.012.103 0 .12-.047.023-.059-.006-.121-.04-.168-.028-.04-.08-.072-.129-.056-.038.012-.057.051-.064.087zm.197-.451c.047-.032.087.054.035.072-.045.017-.076-.048-.035-.072zm.126.143c.053.087.105.174.16.26.012.03.048.04.072.016.005.007.01.015-.002.018l-.139.088c-.02-.022.032-.025.024-.052-.003-.029-.024-.052-.038-.077-.03-.05-.06-.1-.093-.148-.015-.026-.045-.008-.057.01-.008-.006-.014-.01-.005-.017.022-.03.042-.06.064-.088l.013-.01zm.414.107c-.016.038-.024.084-.06.109-.043.035-.109.012-.13-.036-.023-.04-.004-.087.016-.123a1.04 1.04 0 0 1 .076-.11c-.015-.025-.031-.054-.06-.066-.041-.013-.098.032-.075.076.01.016.026.034.017.054-.018.039-.07.013-.07-.023-.007-.053.03-.1.073-.124.034-.022.08-.042.118-.018.028.02.042.052.06.08.029.045.055.092.086.136.019.026.042-.005.04-.027.002-.012.004-.018.01-.006.015.02-.002.05-.007.071-.01.038-.063.058-.085.02-.005 0-.004-.014-.01-.013zm-.013-.022-.072-.117c-.027.04-.064.08-.066.13 0 .04.041.081.082.067.032-.013.044-.05.056-.08zm.113-.308c.007-.052.023-.113.074-.136.044-.023.094.008.119.045.039.058.072.12.11.177.014.032.052.024.07.012.01.008.004.014-.005.017l-.139.088c-.01-.01-.004-.017.01-.022.034-.022.01-.061-.007-.085-.03-.047-.057-.096-.088-.142a.058.058 0 0 0-.102-.007c-.014.023-.038.056-.024.082l.106.173c.014.035.054.018.073.009.009.008.003.013-.006.017l-.139.088c-.011-.012-.002-.017.01-.024.03-.024.004-.06-.01-.084-.036-.056-.068-.113-.106-.167-.015-.027-.045-.01-.057.007-.008-.005-.014-.01-.005-.017.021-.03.041-.06.063-.088.007-.005.015-.013.018 0zm.76-.3a.184.184 0 0 1-.014.172.134.134 0 0 1-.145.05c-.066-.016-.112-.073-.138-.133-.033-.075-.009-.175.064-.218a.124.124 0 0 1 .132-.008c.03.015.027.061-.007.07-.046.02-.055-.06-.102-.042-.048.013-.068.067-.056.112a.208.208 0 0 0 .123.145c.05.02.109-.01.126-.06.015-.026.003-.064.007-.087zm.01-.28.042.07c0-.042 0-.093.036-.12.036-.031.096.02.06.056-.021.025-.073-.012-.077.032 0 .023-.01.05.005.07.03.049.06.1.092.148.015.034.059.032.082.017.004.006.008.012-.002.015l-.147.094c-.019-.019.02-.023.023-.041.01-.026-.012-.047-.023-.068-.034-.055-.067-.111-.103-.165-.014-.029-.049-.014-.06.006-.005-.005-.015-.009-.007-.015l.066-.09c.004-.004.01-.006.013-.009zm.25-.01c.028.048.075.09.133.093.054.005.11-.036.115-.092.005-.017-.006-.043-.001-.055.023-.005.017.032.023.046.007.053-.006.113-.05.146a.147.147 0 0 1-.156.016.242.242 0 0 1-.113-.14.166.166 0 0 1 .051-.188.134.134 0 0 1 .138-.023c.027.012.063.04.066.066zm-.012-.02.14-.089c-.018-.033-.057-.06-.096-.048-.049.013-.07.073-.052.118a.12.12 0 0 0 .008.02zm.172-.47c.047-.032.087.054.035.072-.045.017-.076-.047-.035-.072zm.126.143c.053.087.105.174.16.26.012.03.048.04.072.016.005.007.01.015-.002.018l-.139.088c-.02-.022.032-.025.024-.052-.003-.029-.024-.052-.038-.077-.03-.05-.06-.1-.093-.148-.015-.026-.045-.008-.057.008-.008-.005-.014-.009-.005-.016.022-.03.042-.06.064-.088l.013-.01zm.474.107c-.008.054-.046.105-.101.117-.07.016-.143-.027-.177-.088a.224.224 0 0 1-.011-.218c.026-.044.08-.08.132-.068-.025-.04-.048-.082-.077-.12-.017-.026-.043.002-.055.011-.013-.005-.007-.013 0-.02.02-.028.039-.056.06-.083.007-.006.015-.011.019.002.079.128.156.257.236.384.01.027.046.055.066.02.005-.014.024.006.01.012-.02.029-.04.059-.061.087-.008.005-.016.014-.02 0l-.02-.036zm-.014-.024-.097-.158c-.025-.037-.078-.06-.12-.035-.044.03-.043.095-.023.14.025.06.07.122.138.132a.083.083 0 0 0 .094-.051.137.137 0 0 0 .008-.028zm.114-.426a.16.16 0 0 1 .158-.01.209.209 0 0 1 .117.19.168.168 0 0 1-.088.153.156.156 0 0 1-.164-.006.215.215 0 0 1-.093-.234.169.169 0 0 1 .07-.093zm.003.028c-.039.024-.044.076-.028.115a.283.283 0 0 0 .135.155c.04.021.096.008.114-.036.021-.045-.005-.094-.028-.132-.03-.05-.075-.1-.135-.113a.085.085 0 0 0-.058.011zm-1.023-9.288.082.135c-.018.02-.027-.026-.045-.03-.05-.044-.14-.032-.172.027-.02.036-.002.09.041.095.075.013.151-.009.226.002a.119.119 0 0 1 .092.138c-.011.068-.074.116-.139.128-.025.005-.071.015-.053.05-.008.008-.013.003-.017-.006l-.074-.121c.02-.02.03.026.049.03.053.044.139.023.177-.03.032-.042.006-.107-.046-.114-.052-.008-.104.003-.157 0-.047.002-.1-.008-.128-.05-.04-.053-.018-.134.035-.171.032-.032.082-.026.118-.047.011-.015-.01-.03.011-.036zm.12-.11c.04-.027.075.046.03.062-.039.014-.065-.041-.03-.062zm.108.123.136.222c.01.027.044.03.063.015.006.007.006.011-.003.014l-.118.075c-.018-.018.028-.021.02-.044-.002-.026-.02-.046-.033-.068-.025-.04-.048-.082-.075-.12-.012-.026-.04-.016-.05.004-.006-.004-.015-.008-.007-.015l.055-.076.012-.008zm.212-.113.122-.077c.002.005.011.01.003.013-.03.012-.016.048.008.058l.147.106-.033-.199c0-.021-.022-.034-.038-.019-.004.012-.018-.007-.01-.009l.08-.051c.003.005.014.012.001.015-.019.017-.012.044-.009.066l.044.272c-.005.001-.01.01-.015.005l-.232-.166c-.018-.018-.046-.009-.063-.007a.03.03 0 0 1-.005-.007zm.43-.28a.137.137 0 0 1 .142-.006c.066.033.1.111.093.183-.008.077-.089.14-.166.123a.175.175 0 0 1-.132-.144.15.15 0 0 1 .028-.124.138.138 0 0 1 .035-.032zm.003.024c-.043.027-.035.085-.013.122.026.05.066.098.122.115.04.012.085-.018.087-.06 0-.046-.027-.087-.053-.122-.03-.04-.083-.082-.135-.06zm.327-.234.055.09c-.013.014-.023-.012-.035-.017-.034-.032-.099-.019-.115.026-.014.046.045.066.081.055.038-.003.078-.014.115 0 .046.015.067.074.046.117-.02.05-.074.066-.12.083-.003.004-.009.024-.016.018l-.056-.092c.014-.015.023.016.038.02.038.029.109.023.126-.028.012-.045-.041-.07-.08-.062-.039 0-.08.012-.117-.003a.09.09 0 0 1-.029-.131c.022-.036.069-.035.097-.058 0-.012 0-.013.01-.018zm.19-.11a.137.137 0 0 1 .142-.006c.066.033.1.111.092.183-.008.077-.088.14-.165.123a.175.175 0 0 1-.132-.144.149.149 0 0 1 .034-.131.155.155 0 0 1 .029-.025zm.003.024c-.043.026-.035.085-.013.122.026.05.066.098.122.115.04.012.085-.018.087-.06 0-.046-.027-.087-.053-.122-.03-.04-.083-.082-.135-.06zm.177-.264.053.086.06-.038a.449.449 0 0 0 .013.02l-.06.039.107.176c.01.025.046.037.06.01.012-.013 0-.033.017-.039.011.038-.003.091-.044.105-.038.012-.067-.02-.082-.05l-.105-.172-.041.026c-.015-.014.011-.028.01-.044.015-.037.007-.078.006-.114zm.22-.02.036.06c-.002-.041.003-.105.055-.11.039-.006.05.058.01.063-.018 0-.048-.008-.05.02-.002.02-.009.043.004.06l.078.126c.014.03.05.028.071.015.004.005.007.01 0 .012l-.127.08c-.016-.015.017-.019.02-.035.007-.021-.01-.04-.02-.058-.03-.047-.057-.095-.088-.14-.012-.026-.04-.014-.052.005-.003-.004-.012-.007-.006-.012l.056-.078zm.24-.15a.137.137 0 0 1 .142-.006c.066.033.1.111.093.183-.008.077-.089.14-.166.123a.175.175 0 0 1-.132-.144.15.15 0 0 1 .028-.124.138.138 0 0 1 .035-.032zm.003.024c-.043.026-.035.085-.013.122.026.05.066.098.122.115.04.012.085-.018.087-.06 0-.046-.027-.087-.053-.122-.03-.04-.083-.082-.135-.06zm.327-.234.055.09c-.013.014-.023-.012-.035-.017-.034-.033-.099-.019-.115.026-.014.046.045.066.081.055.038-.003.078-.014.115 0 .046.015.067.074.046.117-.02.05-.074.066-.12.083-.003.004-.009.024-.016.018a44.91 44.91 0 0 1-.056-.092c.014-.015.023.016.038.02.038.029.109.023.126-.028.012-.045-.041-.07-.08-.062-.039 0-.08.012-.117-.003a.09.09 0 0 1-.029-.131c.022-.036.069-.035.097-.058 0-.012 0-.013.01-.018zm-2.08 2.39c.02-.028.04-.057.061-.084.007-.007.012-.006.016.003l.031.051c-.002-.042.006-.09.045-.115.04-.027.094-.015.129.014.062.05.098.14.07.218a.124.124 0 0 1-.106.079c-.014-.002-.025-.005-.013.008.02.032.039.067.062.097.016.023.043-.006.057-.003.009.008 0 .011-.007.015l-.124.08c-.01-.01-.004-.015.007-.02.033-.021.009-.057-.007-.08l-.158-.257c-.01-.03-.044-.017-.057-.002l-.007-.005zm.119-.012c.027.044.053.09.083.133.026.034.082.028.107-.005.028-.038.011-.09-.01-.126-.024-.043-.063-.089-.116-.087-.044.004-.06.048-.064.085zm.271-.148c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.028.02.04.006.045-.005.096-.044.125a.128.128 0 0 1-.146.007.22.22 0 0 1-.089-.13.139.139 0 0 1 .055-.149.112.112 0 0 1 .118-.012c.02.01.046.033.051.053zm-.01-.017.12-.076c-.02-.046-.09-.061-.119-.016-.019.028-.016.064-.002.092zm.23-.273.036.06c-.002-.041.003-.105.055-.11.039-.006.05.058.01.063-.018 0-.048-.008-.05.02-.001.02-.008.043.005.06.026.042.05.085.077.126.014.03.05.028.071.015.004.005.007.01 0 .012l-.127.08c-.016-.015.017-.019.02-.035.007-.021-.01-.04-.02-.058-.03-.047-.057-.095-.088-.14-.012-.026-.04-.014-.052.005-.003-.004-.012-.007-.006-.013l.056-.077z'/%3e%3cpath d='M498.8 298.84c.009-.045.02-.1.068-.12a.077.077 0 0 1 .088.021c.006-.046.02-.098.067-.119.04-.02.087.008.107.044.032.05.06.101.093.15.012.028.045.006.058.008.01.01-.009.012-.014.018l-.11.07c-.019-.02.035-.025.023-.052-.011-.027-.03-.052-.045-.077-.021-.034-.04-.07-.065-.1-.037-.04-.09.008-.097.049-.01.015-.007.03.005.043.03.047.057.096.088.143.013.03.047.002.06.005.01.009-.008.012-.014.018l-.113.071c-.018-.02.033-.025.023-.05-.007-.025-.024-.046-.037-.069-.022-.035-.042-.073-.068-.106-.03-.039-.085-.01-.097.03-.009.019-.017.04 0 .056.03.048.058.098.09.145.012.028.044.008.059.004.01.01-.006.013-.013.018a54.84 54.84 0 0 1-.111.07c-.018-.018.032-.023.02-.048-.013-.035-.036-.065-.055-.097-.022-.034-.04-.072-.068-.1-.016-.014-.044.034-.044.006.019-.026.037-.054.057-.08.009-.01.014-.004.019.007l.027.042zm.62-.16c-.015.043-.032.098-.084.107-.05.01-.095-.044-.086-.092.01-.055.049-.098.08-.143.015-.01-.008-.025-.011-.036-.02-.04-.078-.039-.098 0-.01.016-.003.034.007.048.02.02.005.06-.025.05-.044-.022-.028-.087.002-.115.031-.03.074-.058.119-.049.03.01.044.04.06.066l.076.12c.008.022.036.013.036-.008.003-.005.003-.022.007-.021.003.007.012.013.008.022-.001.035-.025.096-.069.075-.01-.005-.016-.019-.023-.024zm-.011-.019-.062-.1c-.022.033-.051.065-.056.106-.007.046.056.09.09.05a.164.164 0 0 0 .028-.056zm.091-.271c.007-.044.02-.096.064-.117.037-.02.08.006.101.039.033.05.062.102.095.152.011.026.043.022.06.009.006.007.006.012-.003.015l-.12.076c-.009-.01-.003-.014.007-.02.03-.018.009-.052-.006-.073l-.072-.117c-.016-.034-.063-.047-.087-.014-.014.02-.035.05-.025.074.031.05.06.1.092.149.012.03.046.015.062.007.007.007.003.01-.005.014l-.118.076c-.007-.008-.006-.014.005-.018.03-.019.008-.053-.006-.075-.029-.047-.056-.094-.087-.14-.012-.028-.04-.01-.053.002-.008-.004-.01-.009-.003-.015.018-.024.035-.05.054-.074.006-.004.012-.01.015 0zm.29-.12c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.027.02.04.006.044-.005.096-.043.125a.128.128 0 0 1-.146.007.22.22 0 0 1-.09-.13.139.139 0 0 1 .055-.149.112.112 0 0 1 .118-.012c.02.01.047.033.051.053zm-.01-.017.12-.076c-.02-.046-.09-.061-.119-.016a.087.087 0 0 0 0 .092zm.48-.193c.018.047.02.105-.011.147a.114.114 0 0 1-.125.043c-.059-.014-.1-.067-.12-.121a.151.151 0 0 1 .057-.18c.036-.025.097-.031.126.008.023.04-.048.07-.064.028-.032-.047-.098.006-.093.051a.17.17 0 0 0 .06.123c.029.025.069.044.106.029.046-.017.064-.07.055-.115-.004-.014 0-.01.009-.013zm.04-.12c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.027.02.04.006.044-.005.096-.043.125a.128.128 0 0 1-.146.007.22.22 0 0 1-.09-.13.139.139 0 0 1 .055-.149.112.112 0 0 1 .118-.012c.02.01.047.033.051.053zm-.01-.017.12-.076c-.02-.046-.09-.061-.119-.016a.09.09 0 0 0 0 .092zm.24-.273.036.06c-.002-.041.003-.105.055-.11.039-.006.05.058.01.063-.018 0-.048-.008-.05.02-.002.02-.009.043.004.06l.078.126c.014.03.05.028.071.015.004.005.007.01 0 .012l-.127.08c-.016-.015.017-.019.02-.035.007-.021-.01-.04-.02-.058-.03-.047-.057-.095-.088-.14-.012-.026-.041-.013-.052.006-.003-.004-.012-.007-.006-.013.02-.025.038-.052.057-.077l.012-.008zm.22.01c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.028.02.04.006.045-.005.096-.043.125a.128.128 0 0 1-.147.007.22.22 0 0 1-.089-.13.139.139 0 0 1 .055-.15.112.112 0 0 1 .117-.011c.022.01.047.033.052.053zm-.01-.017.12-.076c-.02-.046-.09-.061-.119-.016-.019.028-.016.064-.002.092zm.15-.403c.04-.027.075.047.03.062-.04.014-.065-.041-.03-.062zm.108.123.136.222c.01.027.043.03.063.015.006.007.006.011-.003.014l-.118.075c-.018-.018.028-.021.02-.044-.002-.026-.02-.046-.033-.068-.025-.04-.048-.082-.075-.12-.012-.026-.04-.016-.05.004-.006-.004-.015-.008-.007-.015l.055-.076.011-.008zm.232-.163.055.09c-.013.014-.023-.012-.035-.017-.034-.033-.098-.019-.115.026-.014.046.045.066.081.055.038-.003.078-.014.115 0 .046.015.067.074.046.117-.02.05-.074.066-.12.083-.003.004-.009.024-.016.018l-.056-.092c.014-.015.024.016.038.02.038.029.109.023.126-.028.012-.045-.041-.07-.08-.062-.038 0-.08.013-.117-.003a.09.09 0 0 1-.029-.131c.022-.036.069-.035.098-.058-.001-.012 0-.013.009-.018zm-2.72 2.92c.024.041.064.077.114.08.046.004.095-.031.098-.08.004-.013-.006-.037 0-.046.02-.004.015.027.02.04.006.044-.005.096-.044.124a.126.126 0 0 1-.133.014.21.21 0 0 1-.1-.128.14.14 0 0 1 .047-.153.114.114 0 0 1 .123-.017c.022.011.047.033.052.053zm-.01-.017.12-.076c-.02-.046-.09-.061-.119-.016a.094.094 0 0 0-.002.092zm.26-.233c.007-.044.02-.096.064-.117.037-.02.08.006.1.039.034.05.063.102.096.152.01.026.042.022.06.009.005.007.004.012-.004.015l-.12.076c-.008-.01-.002-.014.008-.02.03-.018.009-.051-.006-.073l-.072-.117c-.016-.034-.063-.047-.087-.014-.014.02-.035.05-.025.074.03.05.06.1.092.149.011.03.046.015.062.007.007.007.003.01-.005.014l-.118.076c-.007-.008-.006-.014.005-.018.03-.019.008-.053-.006-.075-.029-.047-.056-.094-.087-.14-.012-.028-.04-.01-.053.002-.008-.004-.01-.009-.003-.015.018-.024.035-.05.054-.074.006-.004.012-.01.015 0zm.43-.27c.009-.045.02-.1.068-.12a.077.077 0 0 1 .088.021c.006-.046.02-.098.067-.119.04-.02.087.008.107.044.032.05.06.101.093.15.012.029.045.006.058.008.01.01-.009.012-.014.018l-.11.07c-.019-.02.035-.025.023-.051-.01-.028-.029-.051-.043-.077-.022-.034-.04-.07-.067-.102-.037-.038-.09.01-.097.05-.01.016-.007.03.004.043l.088.143c.013.03.048.002.061.005.009.009-.01.012-.015.018a51.14 51.14 0 0 1-.113.071c-.017-.02.034-.024.024-.05-.006-.026-.025-.046-.037-.069-.023-.035-.042-.073-.069-.106-.03-.039-.085-.01-.096.03-.01.019-.017.04-.001.056.03.048.058.097.09.145.012.028.045.008.06.004.01.01-.007.012-.013.018l-.112.07c-.018-.018.032-.023.02-.048-.013-.035-.036-.065-.054-.097-.022-.034-.04-.072-.068-.1-.017-.014-.044.034-.045.006.02-.026.037-.053.057-.079.01-.01.015-.005.02.006zm.33-.48c.04-.027.075.046.03.062-.039.014-.065-.041-.03-.062zm.108.123.136.222c.01.027.043.03.063.015.006.007.006.011-.003.014l-.118.075c-.018-.018.027-.022.02-.044-.002-.026-.02-.046-.033-.068-.025-.04-.048-.082-.075-.12-.012-.026-.04-.016-.05.004-.006-.004-.015-.008-.007-.015l.055-.076.011-.008zm.212-.093c.02-.028.04-.057.061-.084.007-.007.012-.006.016.003l.031.052c-.002-.042.006-.092.045-.116.04-.027.093-.015.129.014.062.05.098.14.07.218a.124.124 0 0 1-.106.08c-.014-.003-.025-.006-.013.007.02.033.039.067.062.098.016.023.043-.006.057-.003.009.008 0 .01-.007.015l-.124.078c-.011-.009-.004-.015.007-.02.033-.021.009-.056-.007-.08l-.158-.256c-.01-.032-.044-.018-.057-.002l-.007-.004zm.119-.012c.027.044.053.09.083.133.026.034.082.028.107-.005.028-.038.012-.09-.01-.126-.024-.043-.063-.088-.116-.087-.044.004-.06.048-.064.085zm.471-.058c-.015.043-.032.098-.084.107-.052.01-.099-.05-.085-.1.015-.054.053-.098.086-.143-.014-.023-.029-.05-.057-.058-.035-.007-.08.034-.057.069.01.014.022.032.01.049-.025.032-.065-.01-.057-.04.003-.051.046-.086.088-.105a.074.074 0 0 1 .105.031c.031.049.06.099.091.147.008.021.036.013.036-.008.003-.005.003-.023.007-.022.003.007.012.013.008.022 0 .035-.024.096-.068.075-.01-.005-.016-.018-.023-.024zm-.011-.019-.062-.1c-.022.033-.052.065-.056.106-.007.046.056.09.09.05a.164.164 0 0 0 .028-.056zm-.029-.491.22.36c.012.027.045.03.065.011.005.006.008.013-.002.015l-.12.076c-.017-.018.027-.021.02-.043-.004-.026-.022-.048-.035-.07l-.15-.245c-.008-.022-.038-.04-.053-.014 0 .01-.022 0-.01-.007.017-.025.035-.051.054-.076a.078.078 0 0 0 .01-.007zm.46.24c-.015.043-.032.098-.084.107-.052.01-.099-.05-.085-.1.015-.054.053-.098.086-.143-.014-.023-.029-.05-.057-.058-.035-.007-.08.034-.057.069.01.014.022.032.01.049-.025.032-.065-.01-.057-.04.003-.051.046-.086.088-.105a.074.074 0 0 1 .105.031l.09.147c.009.021.037.013.037-.008.003-.005.003-.023.007-.022.003.007.012.013.008.022 0 .035-.024.096-.068.075-.01-.005-.016-.018-.023-.024zm-.011-.019-.062-.1c-.022.033-.051.065-.056.106-.007.046.056.09.09.05a.164.164 0 0 0 .028-.056zm.071-.281c.001-.044.02-.096.064-.113.052-.021.112.004.144.047.04.048.062.116.04.177a.152.152 0 0 1-.129.108c-.019 0-.049.013-.056-.011l-.181-.295c-.01-.024-.04-.04-.055-.012-.003.011-.021-.004-.01-.01.018-.025.036-.051.055-.075.006-.004.013-.012.016 0l.112.183zm.011.018.096.158c.045.013.104-.006.108-.059.01-.052-.019-.102-.051-.14-.028-.034-.083-.052-.12-.021-.02.015-.027.04-.033.062zm.259-.248.036.06c-.002-.041.003-.105.055-.11.039-.006.051.059.01.063-.018 0-.048-.007-.05.02-.002.02-.008.043.004.06l.078.126c.014.03.05.028.071.015.004.005.007.01 0 .012l-.127.08c-.016-.015.017-.019.02-.035.007-.021-.01-.04-.02-.058-.03-.047-.057-.095-.088-.14-.012-.026-.04-.014-.052.005-.003-.004-.012-.007-.006-.013l.056-.077zm.41.06c-.015.043-.032.098-.084.107-.052.01-.099-.05-.085-.1.015-.054.053-.098.086-.143-.014-.023-.029-.05-.057-.058-.035-.007-.08.034-.057.07.01.013.022.031.01.048-.025.032-.065-.01-.057-.04.003-.05.046-.086.088-.105a.074.074 0 0 1 .105.031c.031.049.06.099.091.146.008.022.036.014.036-.008.003-.005.003-.022.007-.02.003.006.012.012.008.021 0 .035-.024.096-.068.075-.01-.005-.017-.019-.023-.024zm-.011-.019-.062-.1c-.022.033-.052.065-.056.106-.007.046.055.09.09.05a.163.163 0 0 0 .028-.056zm-2.569 2.339.055.09c-.013.014-.023-.012-.035-.017-.034-.032-.099-.019-.115.026-.014.046.045.066.081.055.038-.003.078-.014.115 0 .046.015.067.074.046.117-.02.05-.074.066-.12.083-.003.004-.009.024-.016.018a44.91 44.91 0 0 1-.056-.092c.014-.015.023.016.038.02.038.029.109.023.126-.028.012-.045-.041-.07-.08-.062-.039 0-.08.013-.118-.003a.09.09 0 0 1-.028-.131c.022-.036.069-.035.097-.058 0-.012 0-.013.01-.018zm.17.04c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.027.02.04.006.044-.005.096-.043.125a.128.128 0 0 1-.146.007.22.22 0 0 1-.09-.13.139.139 0 0 1 .055-.149.113.113 0 0 1 .123-.01c.019.011.043.032.046.05zm-.01-.017.12-.076c-.02-.046-.09-.061-.119-.016a.094.094 0 0 0-.002.092zm.23-.273.036.06c-.002-.041.003-.105.055-.11.039-.006.05.058.01.063-.018 0-.048-.008-.05.02-.002.02-.009.043.004.06l.078.126c.014.03.05.028.071.015.004.005.007.01 0 .012a67.32 67.32 0 0 0-.127.08c-.016-.015.017-.019.02-.035.007-.021-.01-.04-.02-.057-.03-.048-.057-.096-.088-.142-.012-.025-.04-.013-.051.006-.003-.004-.013-.007-.006-.012l.055-.078zm.23.01c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.027.02.04.006.045-.005.096-.043.125a.128.128 0 0 1-.146.007.22.22 0 0 1-.09-.13.139.139 0 0 1 .055-.149.113.113 0 0 1 .123-.01c.019.011.043.032.046.05zm-.01-.017.12-.076c-.02-.046-.09-.061-.119-.016a.094.094 0 0 0-.002.092zm.14-.393c.04-.027.075.047.03.062-.04.014-.065-.041-.03-.062zm.108.123.136.222c.01.027.043.03.063.015.006.007.006.011-.003.014l-.118.075c-.018-.018.028-.021.02-.044-.002-.026-.02-.046-.033-.068-.025-.04-.048-.081-.075-.12-.012-.026-.04-.016-.05.004-.006-.004-.015-.008-.007-.015l.055-.076.011-.008zm.232-.163.055.09c-.013.014-.023-.012-.035-.017-.034-.032-.099-.019-.115.026-.014.046.045.066.081.055.038-.003.078-.014.115 0 .046.015.067.074.046.117-.02.05-.074.066-.12.083-.003.004-.009.024-.016.018l-.056-.092c.014-.015.023.016.038.02.038.029.109.023.126-.028.012-.046-.041-.07-.08-.062-.039 0-.08.013-.118-.003a.09.09 0 0 1-.028-.131c.022-.036.069-.035.097-.058 0-.012 0-.013.01-.018zm.19-.12.122-.077c.002.005.011.01.003.013-.03.012-.016.048.008.058l.147.106-.033-.199c0-.02-.021-.034-.038-.018-.004.01-.018-.007-.01-.01l.08-.051c.003.006.014.013.001.015-.019.017-.012.044-.009.066l.044.273c-.005 0-.01.01-.014.005l-.233-.167c-.018-.017-.046-.009-.063-.007l-.005-.008zm.41-.12c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.027.02.04.006.044-.005.096-.043.125a.128.128 0 0 1-.146.007.22.22 0 0 1-.09-.13.138.138 0 0 1 .055-.149.113.113 0 0 1 .123-.01c.019.011.043.032.046.05zm-.01-.017.12-.076c-.02-.046-.09-.061-.119-.016a.094.094 0 0 0-.002.092zm.24-.273.036.06c-.002-.041.003-.105.055-.11.039-.006.05.058.01.063-.018 0-.048-.008-.05.02-.001.02-.008.043.005.06.026.042.05.085.077.126.014.03.05.028.071.015.004.005.007.01 0 .012l-.127.08c-.016-.015.017-.019.02-.035.007-.021-.01-.04-.02-.057-.03-.048-.057-.096-.088-.142-.012-.025-.04-.013-.051.006-.003-.004-.013-.007-.006-.012l.055-.078zm.44.05c-.007.05-.046.097-.099.102-.06.007-.116-.032-.143-.085a.19.19 0 0 1-.005-.179c.02-.041.078-.064.111-.06-.02-.034-.04-.069-.063-.1-.015-.023-.038 0-.048.009-.01-.004-.007-.01 0-.017l.05-.071c.007-.004.014-.012.017 0l.2.326c.009.023.04.052.06.02.004-.012.02.005.007.01l-.052.075c-.006.004-.014.011-.017 0zm-.012-.02-.083-.136c-.023-.036-.08-.055-.113-.02-.033.036-.022.091 0 .13.024.046.064.092.118.094.042.005.073-.03.078-.068zm.272-.14c-.015.043-.032.098-.084.107-.052.01-.099-.05-.085-.1.015-.054.053-.098.086-.143-.014-.023-.029-.05-.057-.058-.035-.007-.08.034-.057.07.01.013.022.031.01.048-.025.032-.065-.01-.057-.04.003-.05.046-.086.088-.105a.074.074 0 0 1 .105.031l.09.146c.009.022.037.013.037-.008.003-.005.003-.022.007-.02.003.006.012.012.008.021 0 .035-.024.096-.069.075-.009-.005-.016-.019-.022-.024zm-.011-.019-.062-.1c-.022.033-.051.065-.056.106-.007.046.056.09.09.05a.164.164 0 0 0 .028-.056zm.301-.171c-.007.05-.046.097-.099.102-.06.007-.116-.032-.143-.085a.19.19 0 0 1-.005-.179c.02-.041.078-.064.111-.06-.02-.034-.04-.069-.063-.1-.015-.023-.038 0-.048.009-.01-.004-.007-.01 0-.017l.05-.071c.007-.004.014-.012.017 0l.2.326c.009.023.04.052.06.02.004-.012.02.005.007.01l-.052.075c-.006.004-.014.01-.017 0zm-.012-.02-.083-.136c-.023-.036-.08-.055-.113-.02-.033.036-.022.091 0 .13.024.046.064.092.118.094.042.005.073-.03.078-.068zm.082-.2c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.027.02.04.006.045-.005.096-.043.125a.128.128 0 0 1-.146.007.22.22 0 0 1-.09-.13.139.139 0 0 1 .055-.149.113.113 0 0 1 .123-.01c.018.011.042.032.046.05zm-.01-.017.12-.076c-.02-.046-.09-.061-.119-.016a.094.094 0 0 0-.002.092zm.24-.283.036.06c-.002-.041.003-.105.055-.11.039-.006.05.058.01.063-.018 0-.048-.008-.05.02-.001.02-.008.043.005.06.026.042.05.085.077.126.014.03.05.028.071.015.004.005.007.01 0 .012l-.127.08c-.016-.015.017-.019.02-.035.007-.021-.01-.04-.02-.057-.03-.048-.057-.096-.088-.142-.012-.025-.04-.013-.051.006-.003-.004-.013-.007-.006-.012l.055-.078zm.41.07c-.015.043-.032.098-.084.107-.052.01-.099-.05-.085-.1.015-.054.053-.098.086-.143-.014-.023-.029-.05-.057-.058-.035-.007-.08.034-.057.07.01.013.022.031.01.048-.025.032-.065-.01-.057-.04.003-.051.046-.086.088-.105a.074.074 0 0 1 .105.031c.031.049.06.099.091.146.008.022.036.013.036-.008.003-.005.003-.022.007-.02.003.006.012.012.008.021 0 .035-.024.096-.069.075-.009-.005-.016-.019-.022-.024zm-.011-.019-.062-.1c-.022.033-.051.065-.056.106-.007.046.056.09.09.05a.164.164 0 0 0 .028-.056zm.091-.271c.009-.045.02-.1.068-.12.03-.014.066-.003.088.021.006-.046.02-.098.067-.119.04-.02.086.008.107.044.032.05.06.101.093.15.012.029.045.006.058.008.01.01-.009.012-.014.018l-.11.07c-.019-.02.035-.025.023-.052-.011-.027-.03-.051-.044-.077-.022-.034-.04-.07-.066-.1-.037-.04-.09.008-.097.049-.01.015-.007.03.004.043.03.047.057.096.088.143.013.03.047.002.06.005.01.009-.008.012-.014.018l-.113.071c-.018-.02.033-.025.024-.05-.006-.026-.025-.046-.037-.069-.023-.035-.043-.073-.069-.106-.03-.04-.085-.01-.096.03-.01.019-.017.04-.001.056.03.048.058.097.09.144.012.029.044.008.059.004.01.01-.006.013-.013.019l-.111.07c-.018-.019.032-.024.02-.049-.013-.035-.036-.065-.055-.097-.021-.033-.039-.07-.067-.1-.017-.013-.045.035-.045.007.019-.027.037-.054.057-.08.009-.01.015-.004.02.007zm.44-.22c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.027.02.04.006.045-.005.096-.043.125a.128.128 0 0 1-.146.007.22.22 0 0 1-.09-.13.139.139 0 0 1 .055-.149.113.113 0 0 1 .123-.01c.018.011.043.032.046.05zm-.01-.017.12-.076c-.02-.046-.09-.061-.119-.016a.094.094 0 0 0-.002.092zm.28-.213c.007-.044.02-.096.064-.117.037-.02.08.006.101.039.033.05.062.102.095.152.011.026.043.022.06.009.006.007.005.012-.003.015l-.12.076c-.009-.01-.003-.014.007-.02.03-.018.009-.052-.006-.073l-.072-.117c-.016-.034-.063-.047-.087-.014-.014.02-.035.05-.025.074.03.05.06.1.092.149.011.03.046.015.062.007.007.007.003.01-.005.014l-.118.075c-.007-.008-.006-.013.005-.017.03-.02.008-.054-.006-.076-.03-.046-.057-.093-.087-.139-.013-.028-.041-.011-.053.002-.008-.004-.01-.009-.003-.015l.053-.074c.006-.004.013-.011.016 0zm.2-.33.053.086.06-.038a.449.449 0 0 0 .013.02l-.06.039.107.176c.01.025.046.037.06.01.012-.013-.002-.033.017-.039.011.038-.003.091-.044.105-.038.012-.067-.02-.082-.05l-.105-.172-.041.026c-.015-.014.011-.028.01-.044.015-.037.007-.078.006-.114zm.24.11c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.027.02.04.006.044-.005.096-.043.125a.128.128 0 0 1-.146.007.22.22 0 0 1-.09-.13.138.138 0 0 1 .055-.149.113.113 0 0 1 .123-.01c.018.011.043.032.046.05zm-.01-.017.12-.076c-.02-.046-.09-.061-.119-.016a.09.09 0 0 0 0 .092zm-4.45 3.797c.009-.045.02-.1.068-.12a.077.077 0 0 1 .088.021c.006-.046.02-.098.067-.119.04-.02.086.008.107.044.032.05.06.101.093.15.012.028.045.006.058.008.01.01-.009.012-.014.018l-.11.07c-.019-.02.035-.025.023-.052-.01-.027-.03-.05-.044-.076-.022-.034-.04-.07-.066-.102-.037-.038-.09.01-.097.05-.01.015-.007.03.004.043l.088.143c.013.03.048.002.06.005.01.009-.008.012-.014.018a51.14 51.14 0 0 1-.113.071c-.017-.02.034-.024.024-.05-.007-.025-.025-.046-.037-.069-.023-.035-.042-.073-.069-.106-.03-.039-.085-.01-.096.03-.01.019-.017.04-.001.056.03.048.058.097.09.145.012.028.044.007.06.004.01.01-.007.012-.013.018l-.112.07c-.018-.018.032-.023.02-.048-.01-.031-.03-.056-.046-.084-.024-.037-.044-.077-.073-.11-.018-.024-.043.032-.05.004l.059-.08c.009-.01.015-.005.02.006zm.32-.47c.04-.027.075.046.03.062-.039.014-.065-.041-.03-.062zm.108.123.136.222c.01.027.044.03.063.015.006.007.006.011-.003.014l-.118.075c-.018-.018.028-.021.02-.044-.002-.026-.02-.046-.033-.068-.025-.04-.048-.081-.075-.12-.012-.026-.04-.016-.05.004-.006-.004-.015-.008-.007-.015l.055-.076.011-.008zm.242-.163.055.09c-.013.014-.023-.012-.035-.017-.034-.032-.099-.019-.115.026-.014.046.045.066.081.055.038-.003.078-.014.115 0 .046.015.067.074.046.117-.02.05-.074.066-.12.083-.003.004-.009.024-.016.018a44.91 44.91 0 0 1-.056-.092c.014-.015.023.016.038.02.038.029.109.023.126-.028.012-.046-.041-.07-.08-.062-.038 0-.08.013-.117-.003a.09.09 0 0 1-.029-.131c.022-.036.069-.035.098-.058-.001-.012 0-.013.009-.018zm.54.01c-.007.05-.046.097-.099.102-.06.007-.116-.032-.143-.085a.19.19 0 0 1-.005-.179c.02-.042.078-.064.111-.06-.02-.034-.04-.069-.063-.1-.015-.023-.037.002-.048.009-.01-.004-.007-.01 0-.017l.05-.071c.007-.004.014-.012.017 0l.2.326c.009.023.04.052.06.02.004-.012.02.005.007.01l-.052.075c-.006.004-.014.01-.017 0zm-.012-.02-.083-.136c-.023-.036-.08-.055-.113-.02-.033.036-.022.091 0 .13.024.046.064.092.118.094.042.005.073-.03.078-.068zm-.048-.47c.04-.027.075.046.03.062-.039.014-.065-.041-.03-.062zm.108.123.136.222c.01.027.044.03.063.015.006.007.006.011-.003.014l-.118.075c-.018-.018.027-.021.02-.044-.002-.026-.02-.046-.033-.068-.025-.04-.048-.082-.075-.12-.012-.026-.04-.016-.05.004-.006-.004-.015-.008-.007-.015l.055-.076.011-.008zm.232-.163.055.09c-.013.014-.023-.012-.035-.017-.034-.032-.099-.019-.115.026-.014.046.045.066.081.055.038-.003.078-.014.115 0 .046.015.067.074.046.117-.02.05-.074.066-.12.083-.003.004-.009.024-.016.018l-.056-.092c.014-.015.023.016.038.02.038.029.109.023.126-.027.012-.046-.041-.071-.08-.063-.038 0-.08.013-.117-.003a.09.09 0 0 1-.029-.131c.022-.036.069-.035.097-.058 0-.012 0-.013.01-.018zm.38-.01c.018.047.02.105-.011.147a.114.114 0 0 1-.125.043c-.059-.014-.1-.067-.12-.121a.151.151 0 0 1 .057-.18c.036-.025.097-.031.126.008.023.04-.048.07-.064.028-.033-.047-.098.006-.093.05a.17.17 0 0 0 .06.124c.029.024.069.044.106.028.045-.016.064-.07.055-.115-.004-.014 0-.01.009-.012zm-.08-.36c.04-.027.075.046.03.062-.039.014-.065-.041-.03-.062zm.108.123.136.222c.01.027.043.03.063.015.006.007.006.011-.003.014l-.118.075c-.018-.018.027-.021.02-.044-.002-.026-.021-.047-.033-.07-.025-.04-.048-.08-.075-.118-.012-.026-.04-.016-.05.004-.006-.004-.015-.008-.007-.015l.055-.076.011-.008zm.072-.003c.02-.028.04-.057.061-.084.007-.007.013-.006.016.003l.031.051c-.002-.042.006-.09.045-.115.04-.027.094-.015.129.014.062.05.098.14.07.218a.124.124 0 0 1-.105.079c-.015-.002-.026-.005-.014.008.02.033.039.067.062.097.016.023.044-.006.057-.003.009.008 0 .011-.007.015l-.124.08c-.01-.01-.004-.016.007-.021.033-.021.009-.057-.007-.08l-.158-.257c-.01-.03-.044-.017-.057-.002l-.007-.004zm.119-.012c.027.044.053.09.083.133.026.034.082.028.107-.005.028-.038.012-.09-.01-.126-.024-.043-.063-.089-.116-.087-.044.004-.06.048-.064.085zm.151-.398c.04-.027.075.046.03.062-.039.014-.065-.041-.03-.062zm.108.123.136.222c.01.027.043.03.063.015.006.007.006.011-.003.014l-.118.075c-.018-.018.027-.021.02-.044-.002-.026-.02-.046-.033-.068-.025-.04-.048-.081-.075-.12-.012-.026-.04-.016-.05.004-.006-.004-.015-.008-.007-.015l.055-.076.011-.008zm.072-.233.22.36c.012.028.045.03.065.011.005.006.008.013-.002.015l-.12.076c-.017-.018.027-.021.02-.043-.004-.026-.022-.048-.035-.07l-.15-.245c-.008-.022-.038-.04-.053-.014-.002.01-.022-.002-.011-.007l.054-.076.012-.006zm.28 0a.137.137 0 0 1 .142-.006c.066.033.1.111.092.183-.008.077-.088.14-.165.123a.175.175 0 0 1-.132-.144.15.15 0 0 1 .028-.124.138.138 0 0 1 .035-.032zm.003.024c-.043.027-.035.085-.013.122.026.05.066.098.122.115.04.012.085-.018.087-.06 0-.046-.027-.087-.053-.122-.03-.04-.083-.082-.135-.06zm.327-.234.055.09c-.013.014-.023-.012-.035-.017-.034-.032-.099-.019-.115.026-.014.046.045.066.081.055.038-.003.078-.014.115 0 .046.015.067.074.046.117-.02.05-.074.066-.12.083-.003.004-.009.024-.016.018a44.91 44.91 0 0 1-.056-.092c.014-.015.023.016.038.02.038.029.109.023.126-.028.012-.045-.041-.07-.08-.062-.038 0-.08.013-.117-.003a.09.09 0 0 1-.029-.131c.022-.036.069-.035.098-.058-.001-.012 0-.013.009-.018zm-1.76 4.26c-.008-.047-.003-.103.036-.135.032-.03.082-.044.122-.021.046.021.054.079.042.123 0 .01-.017.035.003.026a.12.12 0 0 1 .126.065.16.16 0 0 1-.033.195c-.028.024-.06.05-.098.054-.039.005-.036-.053 0-.054.042-.002.096-.008.113-.056.022-.048-.007-.104-.051-.128-.037-.02-.083-.01-.118.01-.007.007-.012.006-.014-.003.035-.03.06-.082.041-.128-.013-.047-.072-.073-.113-.043-.035.017-.04.065-.047.094l-.01.001zm.67-.1.019.092-.227.144c-.017-.022.011-.051.01-.076.02-.084.043-.172.026-.259-.009-.048-.044-.097-.097-.099-.059-.004-.105.058-.096.114.004.011.005.021-.007.026-.023-.048-.026-.11.01-.152a.133.133 0 0 1 .158-.037c.052.024.071.087.07.141.002.082-.02.161-.035.241-.004.013-.008.025.006.013.041-.027.084-.052.124-.08.024-.014.024-.045.033-.064l.007-.004zm.11-.04c.019-.013.048-.003.054.019.01.02-.006.047-.028.05a.037.037 0 0 1-.043-.03.037.037 0 0 1 .017-.039zm.28-.65.134-.085c.018.015-.015.02-.017.036-.026.042-.017.092-.02.139l-.001.161c.025.04.048.082.075.12.016.03.05.018.072.001.009 0 .01.015-.001.016l-.153.097c-.01-.009-.004-.014.006-.02.038-.016.026-.061.004-.086l-.054-.089c-.08-.037-.16-.076-.24-.111-.022-.017-.056.005-.072-.002-.01-.01.01-.012.014-.018l.146-.092c.018.015-.012.017-.017.031-.025.033.021.053.046.064l.147.07c0-.065.003-.129.001-.193.004-.037-.04-.05-.064-.03l-.007-.01zm.71-.04c.018.047.02.105-.011.147a.114.114 0 0 1-.125.043c-.059-.014-.1-.067-.12-.121a.15.15 0 0 1 .057-.18c.037-.025.097-.031.126.008.024.04-.048.07-.063.028-.033-.047-.099.006-.094.051a.17.17 0 0 0 .06.123c.029.024.07.044.106.028.046-.016.064-.07.055-.115-.004-.014 0-.01.01-.012zm.06-.27a.137.137 0 0 1 .142-.006c.066.033.1.111.093.183-.008.077-.089.14-.166.123a.175.175 0 0 1-.132-.144.149.149 0 0 1 .034-.131.134.134 0 0 1 .029-.025zm.003.024c-.043.027-.035.085-.013.122.026.05.066.098.122.115.04.012.085-.018.087-.06 0-.046-.027-.087-.053-.122-.03-.04-.083-.082-.135-.06zm.267-.134c.007-.044.02-.096.064-.117.037-.02.08.006.101.039.033.05.062.102.095.152.011.026.043.022.06.009.006.007.005.012-.003.015l-.12.076c-.009-.01-.003-.014.007-.02.03-.018.009-.051-.006-.073l-.072-.117c-.016-.034-.063-.047-.087-.014-.014.02-.035.05-.025.074.031.05.06.1.092.149.011.03.046.015.062.007.007.007.003.01-.005.014l-.118.075c-.007-.008-.006-.013.005-.017.03-.019.008-.054-.006-.075-.029-.047-.056-.094-.087-.14-.012-.028-.04-.01-.053.002-.008-.004-.01-.009-.003-.015.018-.024.035-.05.054-.074.006-.004.012-.01.015 0zm.31-.26a.137.137 0 0 1 .142-.006c.064.032.097.107.093.177-.005.077-.081.143-.158.13a.174.174 0 0 1-.14-.145.149.149 0 0 1 .034-.131.133.133 0 0 1 .029-.025zm.003.024c-.043.027-.035.085-.013.122.026.05.066.098.122.115.04.012.085-.018.087-.06 0-.046-.027-.087-.053-.122-.03-.04-.083-.082-.135-.06zm.487-.094c.018.047.02.105-.011.147a.114.114 0 0 1-.125.043c-.059-.014-.1-.067-.12-.121a.15.15 0 0 1 .057-.18c.036-.025.097-.031.126.008.023.039-.048.07-.064.028-.032-.047-.098.006-.093.051a.17.17 0 0 0 .06.123c.029.024.069.044.106.029.045-.017.064-.07.055-.115-.004-.015 0-.01.009-.013zm.04-.12c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.028.02.04.006.045-.005.096-.043.125a.128.128 0 0 1-.146.007.22.22 0 0 1-.09-.13.139.139 0 0 1 .055-.149.112.112 0 0 1 .118-.012c.02.01.047.033.051.053zm-.01-.017.12-.076c-.02-.046-.09-.061-.119-.016a.087.087 0 0 0 0 .092zm.23-.273.036.06c-.002-.041.003-.105.055-.11.039-.006.05.058.01.063-.018 0-.048-.008-.05.02-.001.02-.007.043.005.06.026.042.05.085.077.126.014.03.05.028.071.015.004.005.007.01 0 .012l-.127.08c-.016-.015.017-.019.02-.035.007-.021-.01-.04-.02-.058-.03-.047-.057-.095-.088-.14-.012-.026-.04-.014-.052.005-.003-.004-.012-.007-.006-.013l.056-.077zm.23.01c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.028.02.04.006.045-.005.096-.044.125a.128.128 0 0 1-.146.007.22.22 0 0 1-.089-.13.139.139 0 0 1 .055-.149.112.112 0 0 1 .117-.012c.022.01.047.033.052.053zm-.01-.017.12-.076c-.02-.046-.09-.061-.119-.016-.019.027-.016.064-.002.092zm.14-.423c.04-.027.075.046.03.062-.039.014-.065-.041-.03-.062zm.108.123.136.222c.01.027.043.03.063.015.006.007.006.011-.003.014l-.118.075c-.018-.018.028-.021.02-.044-.002-.026-.02-.046-.033-.068-.025-.04-.048-.081-.075-.12-.012-.026-.04-.016-.05.004-.006-.004-.015-.008-.007-.015l.055-.076.011-.008zm.242-.133.055.09c-.013.014-.023-.012-.035-.017-.034-.032-.098-.019-.115.026-.014.046.045.066.081.055.038-.003.078-.014.115 0 .046.015.067.074.046.117-.02.05-.074.066-.12.083-.003.004-.009.024-.016.018l-.056-.092c.014-.015.023.016.038.02.038.03.109.023.126-.027.012-.046-.041-.071-.08-.063-.038 0-.08.013-.117-.003a.09.09 0 0 1-.029-.131c.022-.036.069-.035.098-.058-.001-.012 0-.013.009-.018zm.2-.34.22.36c.012.028.045.03.065.011.005.006.008.013-.002.015l-.12.076c-.017-.018.027-.021.02-.043-.004-.026-.022-.048-.035-.07-.05-.082-.099-.164-.15-.245-.008-.022-.038-.04-.053-.014 0 .01-.022 0-.01-.007.018-.025.035-.051.054-.076a.072.072 0 0 0 .01-.007zm.45.25c-.015.043-.032.098-.084.107-.05.01-.095-.044-.086-.092.01-.055.049-.099.08-.143.015-.01-.008-.025-.011-.036a.055.055 0 0 0-.097 0c-.01.016-.003.034.007.048.02.02.005.06-.026.05-.044-.022-.028-.087.002-.115.03-.029.07-.055.114-.05.033.006.048.039.065.064.025.041.05.083.076.123.008.022.036.013.036-.008.003-.005.003-.022.007-.021.003.007.012.013.008.022 0 .035-.024.096-.068.074-.01-.005-.016-.019-.023-.023zm-.011-.019-.062-.1c-.022.033-.051.065-.056.106-.007.046.056.09.09.05a.164.164 0 0 0 .028-.056zm-4.049 3.309.122-.077c.002.005.011.01.003.013-.03.012-.016.048.008.058l.147.106-.033-.199c0-.02-.022-.034-.038-.019-.004.012-.018-.006-.01-.008l.08-.051c.003.005.014.012.001.015-.019.017-.012.044-.009.066l.044.272c-.005.001-.01.01-.014.005l-.233-.166c-.018-.018-.046-.009-.063-.007zm.4-.14c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.027.02.04.006.045-.005.096-.043.125a.128.128 0 0 1-.146.007.22.22 0 0 1-.09-.13.139.139 0 0 1 .055-.149.113.113 0 0 1 .123-.01c.018.011.042.032.046.05zm-.01-.017.12-.076c-.02-.046-.09-.061-.119-.016a.094.094 0 0 0-.002.092zm.23-.273.036.06c-.002-.041.003-.105.055-.11.039-.006.05.058.01.063-.018 0-.048-.008-.05.02-.001.02-.008.043.005.06.026.042.05.085.078.126.013.03.05.028.07.015.004.005.007.01 0 .012l-.127.08c-.016-.015.017-.019.02-.035.007-.022-.01-.04-.02-.058-.03-.047-.057-.095-.088-.141-.012-.025-.04-.013-.052.006-.003-.004-.012-.007-.006-.013l.056-.077zm.46.07c-.007.05-.046.097-.099.102-.06.007-.116-.032-.143-.085a.19.19 0 0 1-.005-.179c.02-.041.078-.064.111-.06-.02-.034-.04-.069-.063-.1-.015-.023-.037.002-.048.009-.01-.004-.007-.01 0-.017l.05-.071c.007-.004.014-.012.017 0l.2.326c.009.023.04.053.06.02.004-.012.02.005.007.01l-.052.075c-.007.004-.014.011-.017 0zm-.012-.02-.083-.136c-.024-.036-.08-.055-.113-.02-.033.036-.022.091 0 .13.024.046.064.092.118.094.042.005.073-.03.078-.068zm.252-.16c-.015.043-.032.098-.084.107-.052.01-.099-.05-.085-.1.015-.054.053-.098.086-.143-.014-.023-.029-.05-.057-.058-.035-.007-.08.034-.057.069.01.014.022.032.01.049-.025.032-.065-.01-.057-.04.003-.051.046-.086.088-.105a.074.074 0 0 1 .105.031l.091.146c.008.022.036.013.036-.008.003-.005.003-.022.007-.02.003.006.012.012.008.021 0 .035-.024.095-.068.075-.01-.005-.017-.019-.023-.024zm-.011-.019-.062-.1c-.022.033-.051.065-.056.106-.007.046.055.09.09.05a.162.162 0 0 0 .028-.056zm.311-.151c-.007.05-.046.097-.099.102-.06.007-.116-.032-.143-.085a.19.19 0 0 1-.005-.179c.02-.041.078-.064.111-.06-.02-.034-.04-.069-.063-.1-.015-.023-.037.002-.048.01-.01-.005-.007-.011 0-.018l.05-.071c.007-.004.014-.012.017 0l.2.326c.009.023.04.053.06.02.004-.012.02.005.007.01l-.052.075c-.007.004-.014.011-.017 0zm-.012-.02-.083-.136c-.023-.036-.08-.055-.113-.02-.033.036-.022.091 0 .13.024.046.064.092.118.094.042.005.073-.03.078-.068zm.212.07-.008-.013c.028-.031.041-.088.008-.12-.014-.002-.013.02-.025.023-.027.022-.065-.013-.054-.043.01-.04.067-.043.091-.014.034.033.036.09.012.13-.006.013-.017.025-.024.037zm.04-.53.121-.077c.015.013-.006.017-.013.028-.01.027.02.042.04.055l.133.085c-.011-.063-.02-.126-.033-.19 0-.027-.03-.028-.044-.018-.009-.008-.002-.012.006-.016l.073-.046c.017.015-.017.025-.012.046.01.069.023.137.034.205.009.057.02.113.027.17.005.045-.009.099-.051.12-.037.024-.079-.036-.037-.057.025-.01.066-.011.062-.05 0-.03-.008-.06-.013-.09l-.22-.143a.089.089 0 0 0-.069-.013l-.005-.01zm.45-.49.22.36c.012.027.045.03.065.011.005.006.008.012-.002.015l-.12.076c-.017-.018.027-.021.02-.043-.004-.026-.022-.048-.035-.07l-.15-.245c-.008-.022-.038-.04-.053-.014-.002.01-.022-.002-.011-.007l.054-.076.012-.006zm.44.23c-.015.043-.032.098-.084.107-.052.01-.099-.05-.085-.1.015-.054.053-.098.086-.143-.014-.023-.029-.05-.057-.058-.035-.007-.08.034-.057.069.01.014.022.032.01.049-.025.032-.065-.01-.057-.04.002-.051.046-.086.088-.105a.074.074 0 0 1 .105.031c.031.049.06.099.091.146.008.022.036.013.036-.008.003-.005.003-.022.007-.02.003.006.012.012.008.021 0 .035-.024.096-.068.075-.01-.005-.017-.019-.023-.024zm-.011-.019-.062-.1c-.022.033-.052.065-.056.106-.007.046.056.09.09.05a.164.164 0 0 0 .028-.056zm.121-.351.122-.077c.002.005.011.01.003.013-.03.012-.016.048.008.058l.147.106-.033-.199c0-.02-.022-.034-.038-.019-.004.012-.018-.006-.01-.008l.081-.052c.002.006.014.013 0 .016-.019.016-.011.044-.009.066l.044.272c-.005.001-.01.01-.014.005l-.233-.166c-.018-.018-.045-.009-.063-.007zm.4-.14c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.027.02.04.006.045-.005.096-.044.125a.128.128 0 0 1-.145.007.22.22 0 0 1-.09-.13.139.139 0 0 1 .055-.149.113.113 0 0 1 .123-.01c.018.011.043.032.046.05zm-.01-.017.12-.076c-.02-.046-.09-.061-.119-.016a.094.094 0 0 0-.002.092zm.24-.273.036.06c-.002-.041.003-.105.055-.11.039-.006.05.058.01.063-.018 0-.048-.008-.05.02-.001.02-.008.043.005.06.026.042.05.085.078.126.013.03.05.028.07.015.005.005.008.01 0 .012l-.127.08c-.016-.015.017-.019.02-.035.008-.021-.01-.04-.02-.058-.03-.047-.057-.095-.088-.14-.012-.026-.04-.014-.051.005-.003-.004-.013-.007-.006-.013l.055-.077zm.45.07c-.007.05-.046.097-.099.102-.06.007-.116-.032-.143-.085a.193.193 0 0 1-.006-.179c.02-.041.078-.064.111-.06-.02-.034-.04-.069-.063-.1-.015-.023-.037.002-.048.01-.01-.005-.007-.011 0-.018l.05-.071c.007-.004.014-.012.017 0l.2.326c.009.023.04.053.06.02.004-.012.02.005.007.01l-.052.075c-.007.004-.014.011-.017 0l-.018-.03zm-.012-.02-.083-.136c-.024-.036-.08-.055-.113-.02-.033.036-.022.091 0 .13.024.046.064.092.118.094.042.005.073-.03.078-.068zm.262-.16c-.015.043-.032.098-.084.107-.052.01-.099-.05-.085-.1.015-.054.053-.098.086-.143-.014-.023-.029-.05-.057-.058-.035-.007-.08.034-.057.069.01.014.022.032.01.049-.025.032-.065-.01-.057-.04.002-.048.04-.082.08-.101.038-.026.094-.017.113.027.031.049.06.099.091.146.008.022.036.013.036-.008.003-.005.003-.022.007-.02.003.006.012.012.008.021 0 .035-.024.096-.068.075-.01-.005-.017-.019-.023-.024zm-.011-.019-.062-.1c-.022.033-.051.065-.056.106-.007.046.056.09.09.05a.163.163 0 0 0 .028-.056zm.311-.151c-.007.05-.046.097-.099.102-.06.007-.116-.033-.143-.085a.19.19 0 0 1-.005-.179c.02-.042.078-.064.111-.06-.02-.034-.04-.069-.063-.1-.015-.023-.038.002-.048.009-.01-.004-.007-.01 0-.017l.05-.071c.007-.004.014-.012.017 0l.2.326c.009.023.04.052.06.02.004-.012.02.005.007.01l-.052.075c-.007.004-.014.011-.017 0zm-.012-.02-.083-.136c-.023-.036-.08-.055-.113-.02-.033.036-.022.091 0 .13.024.046.064.092.118.094.042.005.073-.03.078-.068zm.242-.48a.137.137 0 0 1 .142-.006c.066.033.1.111.092.183-.008.077-.088.14-.165.123a.175.175 0 0 1-.132-.144.149.149 0 0 1 .034-.131.155.155 0 0 1 .029-.025zm.003.024c-.043.027-.035.085-.013.122.026.05.066.098.122.115.04.012.085-.018.087-.06 0-.046-.027-.087-.053-.122-.03-.04-.083-.082-.135-.06zm.327-.234.055.09c-.013.014-.023-.012-.035-.017-.034-.033-.099-.019-.115.026-.014.046.045.066.081.055.038-.003.078-.014.115 0 .046.015.067.074.046.117-.02.05-.074.066-.12.083-.003.004-.009.024-.016.018a44.91 44.91 0 0 1-.056-.092c.014-.015.023.016.038.02.038.029.109.023.126-.027.012-.046-.041-.071-.08-.063-.039 0-.08.013-.118-.003a.09.09 0 0 1-.028-.131c.022-.036.069-.035.097-.058 0-.012 0-.013.01-.018zm-4.61 3.76.118.192c.008-.041.017-.091.058-.113.04-.023.086.004.107.04.035.049.064.103.098.153.011.025.042.013.056.007.01.009-.003.012-.01.017l-.113.072c-.015-.015.014-.018.02-.031.013-.024-.009-.046-.02-.066-.027-.043-.052-.088-.082-.129-.034-.044-.092 0-.097.044-.01.016-.005.03.006.043.029.047.057.095.087.142.013.03.046.003.06.005.01.009-.006.01-.011.016l-.114.072c-.018-.02.032-.024.02-.05-.012-.032-.033-.06-.05-.09-.047-.075-.091-.15-.139-.225-.012-.032-.043-.019-.057-.003-.012-.004-.005-.012.001-.019l.05-.07a.078.078 0 0 0 .013-.007zm.6.15c-.015.043-.032.098-.084.107-.052.01-.099-.05-.085-.1.015-.054.053-.098.086-.143-.014-.023-.03-.05-.057-.058-.035-.007-.08.034-.057.069.01.014.023.032.01.049-.025.032-.065-.01-.057-.041.003-.05.046-.085.088-.104a.074.074 0 0 1 .105.031l.091.146c.008.022.036.013.037-.008.003-.005.003-.022.007-.02.003.006.012.012.008.021-.001.035-.025.096-.069.075-.01-.005-.016-.019-.023-.024zm-.011-.019-.062-.1c-.022.033-.051.065-.056.106-.007.046.056.09.09.05a.164.164 0 0 0 .028-.056z'/%3e%3cpath d='m502.21 304.89.036.06c-.002-.041.003-.105.055-.11.039-.006.05.058.01.063-.018 0-.048-.008-.05.02-.002.02-.009.043.004.06l.078.126c.014.03.05.028.071.015.004.005.007.01 0 .012l-.127.08c-.016-.015.016-.019.02-.035.007-.021-.01-.04-.02-.058-.03-.047-.057-.095-.088-.14-.012-.026-.04-.014-.052.005-.003-.004-.012-.007-.006-.013l.056-.077zm.4.07c-.015.043-.032.098-.084.107-.052.01-.099-.05-.085-.1.015-.054.053-.098.086-.143-.014-.023-.03-.05-.057-.058-.035-.007-.08.034-.057.069.01.014.023.032.01.049-.025.032-.065-.01-.057-.04.003-.051.046-.086.088-.105a.074.074 0 0 1 .105.031c.031.049.06.099.091.146.008.022.036.014.037-.008.003-.005.003-.022.007-.02.003.006.012.012.008.021-.001.035-.025.096-.069.075-.01-.005-.016-.019-.023-.024zm-.011-.019-.062-.1c-.022.033-.051.065-.056.106-.007.046.056.09.09.05a.164.164 0 0 0 .028-.056zm.131-.581.22.36c.012.027.045.03.065.011.005.006.008.013-.002.016l-.119.075c-.018-.018.026-.021.02-.043-.004-.026-.022-.046-.035-.069-.05-.082-.1-.165-.151-.246-.008-.022-.038-.04-.053-.014 0 .01-.022 0-.01-.007.017-.025.035-.051.054-.076a.078.078 0 0 0 .01-.007zm.13-.09c.04-.027.075.047.03.062-.04.014-.065-.041-.03-.062zm.108.123.136.222c.01.027.043.03.063.015.006.007.006.011-.003.014l-.118.075c-.018-.018.028-.022.02-.044-.002-.026-.021-.047-.033-.07-.025-.04-.048-.08-.075-.119-.012-.025-.04-.015-.05.004-.006-.004-.015-.008-.007-.014l.055-.076.011-.007zm.182-.043c.001-.044.02-.096.064-.113.052-.021.112.004.144.047.04.048.062.116.04.177a.152.152 0 0 1-.129.108c-.019 0-.049.013-.056-.011l-.181-.295c-.01-.024-.04-.04-.055-.012-.003.011-.021-.004-.01-.01l.055-.075c.006-.004.013-.012.016 0zm.011.018.096.158c.044.013.104-.007.109-.059.01-.052-.02-.102-.052-.14-.028-.034-.083-.052-.12-.021-.02.015-.027.04-.033.062zm.259-.248.036.06c-.002-.041.003-.105.055-.11.039-.006.05.058.01.063-.018 0-.048-.008-.05.02-.001.02-.008.043.005.06.026.042.05.085.077.126.014.03.05.028.071.015.004.005.007.01 0 .012a67.32 67.32 0 0 0-.127.08c-.016-.015.017-.019.02-.035.007-.021-.01-.04-.02-.058-.03-.047-.057-.095-.088-.14-.012-.026-.04-.014-.051.005-.003-.004-.013-.007-.006-.013l.055-.077zm.22.01c.024.041.064.077.114.08.049.004.1-.036.098-.087.003-.012-.007-.032 0-.039.02-.004.015.028.02.04.006.045-.005.096-.043.125a.128.128 0 0 1-.146.007.22.22 0 0 1-.09-.13.139.139 0 0 1 .055-.149.112.112 0 0 1 .118-.012c.02.01.047.033.051.053zm-.01-.017.12-.076c-.02-.046-.09-.061-.119-.016a.094.094 0 0 0-.002.092zm.33-.333.055.09c-.013.014-.023-.012-.035-.017-.034-.033-.099-.019-.115.026-.014.046.045.066.081.055.038-.003.078-.014.115 0 .046.015.067.074.046.117-.02.05-.074.066-.12.083-.003.004-.009.024-.016.018l-.056-.092c.014-.015.023.016.038.02.038.029.109.023.126-.027.012-.046-.041-.071-.08-.063-.038 0-.08.013-.117-.003a.09.09 0 0 1-.029-.131c.022-.036.069-.035.098-.058-.001-.012 0-.013.009-.018zm.24.14c.019-.013.048-.003.054.019a.038.038 0 0 1-.028.05.037.037 0 0 1-.043-.03.037.037 0 0 1 .017-.039z'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e";
            },
            5606: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3cpath fill='%23fff' d='M0 0h900v600H0z'/%3e%3cpath fill='%23006233' d='M0 0h450v600H0z'/%3e%3cpath fill='%23d21034' d='M580 225a150 150 0 1 0 0 150 120 120 0 1 1 0-150m5 75-135-44 84 115V229l-84 115z'/%3e%3c/svg%3e";
            },
            734: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1440 960'%3e%3cdefs%3e%3clinearGradient id='d' x1='597.92' x2='601.38' y1='342.3' y2='277.58' gradientTransform='matrix(1.14637 0 0 1.17117 33.18 82.14)' gradientUnits='userSpaceOnUse'%3e%3cstop offset='0' stop-color='%23fff'/%3e%3cstop offset='1' stop-color='%231ea8d1'/%3e%3c/linearGradient%3e%3clinearGradient id='e' x1='599.96' x2='600.31' y1='326.43' y2='399.5' gradientTransform='matrix(1.14637 0 0 1.17117 33.18 82.14)' gradientUnits='userSpaceOnUse'%3e%3cstop offset='0' stop-color='%23FFF'/%3e%3cstop offset='.13' stop-color='%23c1d3e8'/%3e%3cstop offset='.3' stop-color='%2388b0d5'/%3e%3cstop offset='.46' stop-color='%235998c6'/%3e%3cstop offset='.62' stop-color='%232c87bc'/%3e%3cstop offset='.76' stop-color='%23007db5'/%3e%3cstop offset='.9' stop-color='%230077b0'/%3e%3cstop offset='1' stop-color='%230075af'/%3e%3c/linearGradient%3e%3c/defs%3e%3cpath fill='%23ed1c24' d='M0 0h1440v960H0z'/%3e%3cpath fill='%23034ea2' d='M0 0h1440v720H0z'/%3e%3cpath fill='%23fd0' d='M0 0h1440v480H0z'/%3e%3cg id='a' stroke='%23000' stroke-width='.46' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'%3e%3cpath fill='%23b1babf' d='M452.3 476.58a.57.57 0 0 1-.11.18s-2.73 1.42-5.71 1.62c0 0-2.7 8.42-5.89 11 3.72-2.49 9.8-4.76 11.33-4.92.08-2.35.51-5.13 2.02-6l.22-.05a9.58 9.58 0 0 0-1.86-1.83z'/%3e%3cpath fill='none' stroke-width='.23' d='m442.15 487.98 10.95-10.45m-1.16 6.79-5.44-6.08'/%3e%3cpath fill='%23b1babf' d='m472.76 455.57 3.2 3.78-20.28 19.03h-1.26l-2.3-2.06.12-1.6z'/%3e%3cpath fill='none' stroke-width='.23' d='m454.08 476.66 19.83-18.34'/%3e%3cpath fill='%23b1babf' d='m478.97 217.63 8.48 8.02-2.18.92-8.36-7.9 2.06-1.04'/%3e%3cpath fill='%23034ea2' d='m509.97 317.7 11.08 10.95 5.2-12.53.99-7.69c-.78-22.02-.38-43.66-.38-43.66l3.26 2.84-12.44-12.45-7.33-7.2s-.14 46.32-.38 69.74z'/%3e%3cpath fill='%23ed1c24' d='m527.24 308.43 11-32.7-11.38-10.96s-.4 21.64.38 43.66z'/%3e%3cpath fill='%23fd0' d='m510.36 247.96 7.32 7.2c-13.33-13.35-28.93-29-36.85-37.02-1.46-1.48-1.8 31.9-1.64 69.12l30.79 30.44c.24-23.42.38-69.74.38-69.74z'/%3e%3cpath fill='none' stroke-width='.23' d='m534.98 272.44-59.13-59.49'/%3e%3cpath fill='%23b1babf' stroke-width='.34' d='M476.98 214.13c-.12-.06-.2-.11-.21-.14 0 0-1.68-3.45-1.86-7.2 0 0-10.18-3.55-13.26-7.6 2.96 4.7 5.6 12.38 5.76 14.3 2.86.15 6.22.75 7.26 2.66l.05.27c.84-.64 1.6-1.4 2.26-2.29z'/%3e%3cpath fill='%23ed1c24' stroke-width='.34' d='m484.95 223.48-2.6-2.65c-.2.6-.5 1.62-1 3.41-1.04 3.82-.23 16.62-.8 21.01s-1.63 10.41-1.74 12.99l-.02.16c-.03 3.05 1.12 6.8 1.12 6.8s1.83.94 2.14.12.46-7.2.46-8.52.38-2.08 1.52-8.4.61-9.9.16-13.75c-.46-3.85.76-11.17.76-11.17z'/%3e%3cpath fill='%23034ea2' stroke-width='.34' d='M480.06 218.04s-2.87 7.83-2.75 13.85c.11 6.01-.81 14.32-.93 15.56-.09.92-1.18 5.8-1.28 9.47-.04 1.3.29 1.16.59 1.93 0 0 1.98 1.24 3.1-.45l.02-.16c.11-2.58 1.15-8.6 1.73-12.99.58-4.39-.23-17.19.81-21 .5-1.8.8-2.83 1-3.42.2-.67.27-.79.27-.79l-2.56-2z'/%3e%3cpath fill='%23ed1c24' stroke-width='.34' d='M487.82 216.7a86.75 86.75 0 0 1-7.84 1.64c6.5.13 9.11 4.02 9.11 4.02l2.2-2.65c1.96-3.24-1.74-3.59-3.47-3.01z'/%3e%3cpath fill='%23ed1c24' stroke-width='.23' d='m479.99 218.34.17.33c.77 1.4 3.94 6.65 7.59 4.73l1.35-1.03s-2.6-3.9-9.11-4.03z'/%3e%3cpath fill='%23034ea2' stroke-width='.34' d='M480.53 218.34s6.41-3.56 7.3-3.53c.9.04 1.01 1.51 1.23 2.37s-.02 1.91-3.2 1.82c-3.16-.08-2.23-.43-5.33-.66z'/%3e%3cpath fill='%23034ea2' stroke-width='.34' d='M490.62 214.23c-.95-4.4-5.46-3.48-5.46-3.48-4.43.74-4.99 6.12-5.06 7.54l-.01.34c10.45-8.9 9 .21 9 .21 1.05-1.85 1.53-4.61 1.53-4.61z'/%3e%3cpath fill='none' stroke-width='.23' d='m462.2 200.03 13.75 15.31m-8.54-1.82 7.57-6.7'/%3e%3cpath fill='%23b1babf' stroke-width='.34' d='M480.04 203.82a2 2 0 0 0-.43-.46c.48 2.86.2 5.81-1 8.46a12.7 12.7 0 0 1-3.73 4.76c-3.45 2.64-8.22 3.26-12.77 1.43l.25.17c.38.25.77.5 1.17.72 7.19 4.06 15.19 2.52 17.87-3.43 1.6-3.55.95-7.88-1.36-11.65z'/%3e%3ccircle cx='477.02' cy='257.56' r='2.09' fill='%23e8b909'/%3e%3cpath fill='%23e8b909' d='M479.63 269.7c-2.96-.11-4.6-.28-6.53-.4.25-4.08.6-9.75 3.86-9.55 3.23.2 2.92 5.86 2.67 9.95z'/%3e%3cpath fill='none' d='M475.83 263.2s-.56 5.84-.61 6.18m2.23-6.12s.07 4.43-.28 6.26'/%3e%3ccircle cx='480.7' cy='263.46' r='2.09' fill='%23e8b909'/%3e%3cpath fill='%23e8b909' d='M484.04 275.42c-2.97.07-4.62 0-6.54 0 0-4.1 0-9.77 3.27-9.77 3.24 0 3.27 5.68 3.27 9.77z'/%3e%3cpath fill='none' d='M479.86 269.15s-.2 5.86-.24 6.2m1.86-6.23s.34 4.42.1 6.27'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 1439.03 0)'/%3e%3cg stroke='%23000' stroke-width='.34'%3e%3cpath fill='none' d='M529.89 257.24c-3.95 1.18-6.94 3.1-11.21 3.63' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M511.32 264.35s-.4-8.1-.07-9c.32-.88 7.38-6.38 5.24-20.15 0 0-1.39-4.62-.67-5.76 0 0-6.12 11.66-6.62 15.14-.51 3.48.36 9.15.7 10.53.34 1.38.89 5.1.89 5.1' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M515.3 233.09c0 1.67-.57 3.39-.85 5.02-.28 1.62-.5 3.13-1.06 4.68-.71 1.98-1.68 4.03-2.05 6.08-.3 1.72-.3 3.47-.35 5.22m-.33 1.35c-.1-1.5 1.77-3.5 2.96-4.53m-2.36-1.63c.44-1.09-.95-3.34-1.1-4.54m1 6.32c-.05-2.64 3.2-3.36 3.32-5.76m-2.12.01c-.28-1.27-2.34-2.27-1.71-3.73' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M513.32 242.88c.26-.8.92-1.6 1.41-2.35.45-.67 1.32-1.16 1.64-1.86m-2.37 1.38c.06-1.67-.48-3-.42-4.62' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M518.47 255.06c.02-2.97.41-4.65 2.81-6.48 2.1-1.6 4.84-2.35 5.73-4.98-.48.9-.28 2.07-.5 3.06a16.46 16.46 0 0 1-1.24 3.52 28.45 28.45 0 0 1-2.97 4.75' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M508 264.51c1.63-3.75 4.27-6.78 8.07-8.46 2.91-1.28 6.03-1.72 9.16-1.88 1.9-.1 3.67-.12 5.52-.73 1.34-.44 3.67-1.05 4.53-2.2-5.33 2.99-8.41 8.88-14.2 11.26-4.56 1.87-10.6.94-14.61 4.05' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M508.38 264.89c2.88-2.97 6.5-5 10.48-6.1 3.12-.86 6.65-1.9 9.44-3.6m-9.32 3.96c.91.46 3 1.46 4.08 1.28m-.24-2.7c.95 0 2.54.75 3.32.38m-6.4.4c-1.1-1.93 1.65-2.06 2.3-3.2' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M536.73 243.83c1-1.15.65-4.4 1.18-5.97.68-2.04 2.24-3.48 3.14-5.36-.82 1.85-.09 4.39-.74 6.35-.74 2.18-2.48 4.05-3.7 6' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M538.26 241.27c-.2-1.84 1.28-3.33 1.66-4.98' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M505.23 305.87c2.2 3.34 4.85 8.7 1.85 12.42-.65-.96-.71-2.81-1.75-3.48-.75-.48-2.12-.27-3.01-.65-2.39-1.01-1.93-3.59-3.53-4.88l-.38-.94 6.28-3.1.54.63z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M502.38 308.56c2.8 2.08 4.74 5.5 4.47 9.06m-4.85-9.19c.8 1.92.11 3.38.28 5.2.08-.11.14-.24.23-.35m.63-4.34c1.83 1.35 3.09 2.36 4.34 4.21' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M495.23 296.18c1.02-1.23 1.29-3.41 2.17-4.86 1.11-1.8 2.98-3.6 4.97-4.3a24.56 24.56 0 0 1 7.39-1.44c2.43-.1 5.25.96 7.32.76-4.26 1.56-9.49 1.75-13.41 4.19-2.56 1.58-5.13 4.24-7.16 6.45-1.7 1.84-2.13 3.9-3.07 6.1' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M495.36 297.71c1.04-2.53 3.19-5.73 5.4-7.4 2.2-1.7 5.08-2.71 7.88-2.56m-11.5 6.64c1.44-1 3.37-1.94 4.6-3.2' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M505.44 288.1c1.35-1.52 3.25-1.39 4.98-1.63m-16.85 18.64c.56-.75.85-1.72 1.3-2.58.63-1.18 1.47-2.19 2.28-3.27a43.6 43.6 0 0 1 5.23-6.02 14.55 14.55 0 0 1 6.4-3.43c2.2-.5 6.09.04 7.73-1.64-1.22 1.47-1.77 3.28-3.2 4.7-2.07 2.07-4.23 4.37-6.86 5.82-2 1.1-4.61 2.32-6.79 2.82-1.91.44-5.23.44-6.33 2.43.1.05.18.14.24.22.35-.23.71-.52 1.02-.84' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M494.85 302.56c1.13-.38 2.16-1.98 3.03-2.8 1.26-1.2 2.6-2.14 4.08-3.07a38.18 38.18 0 0 1 5.75-3.1c1.64-.69 3.23-1.3 4.63-2.4' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M500.97 297.33c1.35-.44 2.68-1.04 4.08-1.28.79-.13 1.73.03 2.43-.38m-4.46.25c1.01-1.48 2.69-2.72 3.32-4.34' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M524.72 254.04c1.75-2.38 3.82-4.09 6.17-5.93 1.56-1.24 2.77-2.91 4.66-3.68 5.01-2.05 10.55 1.9 15.69 1.81-2.23.97-4.19 2.37-6.6 2.98-2.4.61-4.77.97-7.27.99-4.41.04-10.25.1-12.78 4.47' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M527.66 251.49c2.9-.72 5.77-2.56 8.58-3.67 2.85-1.11 5.98-.52 8.78-1.44m-8.87 1.53c1.85-.68 4.49.76 6.51.77' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M533.41 249.06c.92-.76 1.86-1.6 2.84-2.3.74-.51 1.78-1 2.01-1.91' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M504.58 280.18c2.1-.42 2.83-4.03 3.4-5.62.76-2.18 1.42-5.22 2.78-7.09.9-1.21 2.62-2.16 3.88-3.06 1.6-1.15 2.37-1.57 4.25-1.85 2.52-.38 5.2-.63 7.76-.65 2.3-.03 4.93.36 7.07-.73-2.34.78-4.69 2.75-6.11 4.61-2.23 2.92-3.66 5.6-7 7.7-2.97 1.89-6.64 2.77-10.01 3.8-1.92.58-5.12 1.27-5.6 3.46' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M507.61 277.54c3.65-3.69 5.16-9 10.73-10.47 3.4-.9 8.7-1.37 10.98-4.34' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M510.51 274.11a6.2 6.2 0 0 1 4.31-1.79c1.64 0 3.37.41 4.88-.38m-.98-4.62c1-.37 2.02.25 3.03.26 1.05.01 1.88-.6 2.84-.77m-9.19 1.53c.47-2 1.51-2.83 2.56-4.47' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M501.48 285.78c1.62-.1 2.35-2.1 2.85-2.98.7-1.18 1.34-2.87 2.46-3.85.74-.63 2.1-1.06 3.1-1.49a7.4 7.4 0 0 1 3.34-.78c1.93-.05 3.99-.03 5.94.12 1.76.13 3.75.52 5.43.04a11 11 0 0 0-4.88 2.23c-1.84 1.52-3.06 2.95-5.7 3.93-2.35.88-5.2 1.15-7.81 1.52-1.5.2-3.96.4-4.43 1.61' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M503.92 284.47c2.96-1.86 4.36-4.79 8.68-5.26 2.64-.3 6.69-.23 8.57-1.77' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M506.92 282.53a5.68 5.68 0 0 1 3.37-.74c1.25.1 2.55.45 3.74.1m-1.16-2.52c.78-.14 1.53.27 2.3.34.8.07 1.46-.21 2.2-.26m-7.08.29c.45-1.1 1.28-1.5 2.16-2.38' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M491.42 308.23s-13.45-14.3-6.2-32.03c0 0 .22 4.9.65 5.55.43.64 7.9 11.85 6.83 21.57-1.06 9.72-.53 5.77-.53 5.77l-.75-.86z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M491.42 307.05s-1.7-11.32-3.84-14.42c-2.14-3.1-2.46-9.6-2.25-10.78m2.24 9.51c.58-.73 1.21-1.5 1.28-2.46m.65 7.26c.6-.8.7-1.84.96-2.67m-1.18 4.91c-.7-.88-3.29-1.04-3.42-2.03m1.29-3.3c-.52-1.08-3.15-1.36-3.2-2.67m1.27-3.63c-1.01-.76-1.22-1.4-1.6-2.56m6.73 18.36c-1.02-1.16-2.16-1.54-3.31-2.24m3.42-.22c.2-1.01 1.22-2 1.18-2.99' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M514.17 250.18s3.23-7.34 3.92-7.98c.68-.64 9.48-2.23 13.66-15.39 0 0 .8-4.72 1.95-5.39 0 0-10.68 7.48-12.68 10.32s-3.74 8.25-4.04 9.63c-.3 1.37-1.46 4.91-1.46 4.91' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M531.62 224.41c-.73 1.48-2.02 2.73-3 4.04-.96 1.3-1.83 2.54-3.02 3.64-1.52 1.43-3.3 2.8-4.54 4.43-1.08 1.43-1.87 3.07-2.73 4.64m-.81.85c.58-1.38 3.15-2.27 4.68-2.64m-1.41-2.52c.88-.76.62-3.39 1.02-4.51m-1.49 5.16c.81-2.35 5.55-.33 6.52-2.32m-3.29-1.33c.31-1.25-1.1-3.08.11-4.08' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M525.49 232.15c.6-.6 1.54-1 2.31-1.42.7-.39 1.7-.42 2.3-.89m-2.74.12c.79-1.45.9-2.88 1.67-4.27' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M496.94 255.01s.5-4.56.29-5.06c-.22-.5-5.3-3.6-3.36-11.35 0 0 1.14-2.6.64-3.24 0 0 4.22 6.56 4.5 8.53s-.5 5.15-.78 5.92c-.29.78-.79 2.87-.79 2.87' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M494.84 237.54c-.05.94.34 1.9.5 2.83.17.9.3 1.76.66 2.63.47 1.12 1.14 2.27 1.36 3.42.19 1.01.12 2.04.12 3.07m.22.64c.11-.85-1.22-1.97-2.07-2.55m1.78-.92c-.3-.61.79-1.88.93-2.55m-.85 3.01c.3-1.4-3.43-1.61-3.36-2.87m2.57.18c.24-.71 1.79-1.27 1.36-2.1' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M496.06 243.06c-.17-.45-.64-.9-.98-1.32-.31-.38-.95-.66-1.16-1.05m1.71.77c0-.94.43-1.7.43-2.6' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M496.44 275.23s.5-9.38.9-10.37c.41-.99 7.74-6.47 7.2-22.6 0 0-.82-5.48-.01-6.7 0 0-7.1 12.69-7.96 16.64-.86 3.95-.65 10.59-.48 12.22s.29 5.98.29 5.98' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M503.64 239.7c-.17 1.92-.92 3.83-1.36 5.68-.44 1.83-.82 3.55-1.51 5.26-.9 2.2-2.04 4.44-2.62 6.76-.5 2.02-.67 4.14-.93 6.22m-.43 1.26c.07-1.75 2.07-3.81 3.32-4.86m-2.08-2.16c.54-1.2-.54-3.96-.56-5.36m.57 6.42c-.04-2.9 4.84-2.71 5.06-5.3m-3.59-.19c-.13-1.5-1.98-2.9-1.23-4.5' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M500.69 250.75c.33-.9 1.05-1.74 1.6-2.53.5-.72 1.4-1.18 1.77-1.95m-2.42 1.29c.24-1.91-.13-3.52.1-5.37' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M495.94 265.35s-2.67-4.48-3.52-6.94c-.86-2.46-2.35-4.8-2.89-5.23s5.88 3.3 6.3 4.38' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M495.83 261.29c-.9-2.1-2.11-4.9-4.27-5.98m3.52 5.66c-.21-.94-1.26-1.61-1.92-2.14m1.71.43c-.26-.85-.42-1.84-.64-2.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M496.36 280.08s.75-9.72 5.13-12.28c0 0 4.27-2.14 6.08-3.84 0 0 2.57-3.53.96-1.28-1.6 2.24-2.67 14.73-2.77 15.48-.1.74-1.71 5.55-4.7 9.18s-4.38 5.87-5.02 7.16c-.64 1.28-1.18 4.7-1.18 4.7' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M495.94 291.19c1.61-1.34 1.94-3.46 2.67-5.37.8-2.1 1.74-4.07 2.05-6.28.33-2.27.9-4.27 1.82-6.37.94-2.16 2.7-3.76 3.82-5.69m-5.58 12.99c1.4-1.93 2.96-1.98 4.72-3.2m-6.87 8.99c.99-1.51 3.1-1.22 3.83-3.06m-3.08-1.2c.57-2.07-1.24-3.22-1.66-5.1m3.75-.87a7.24 7.24 0 0 1 0-6.26m-4.52 4.45a23.85 23.85 0 0 1 2.04-7.8c.62-1.35 1.54-2.63 2.27-3.91.5-.9 1.15-2.18 2.08-2.72' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23ffdf4f' stroke-width='.23' d='M503.27 259.4c-.1.48.6.77 1.13.49.04-.12.02-.23.04-.35.65.2 2.15.2 1.3-.78.6-.1 1.57-.67.74-1.18.48-.47.52-1.32-.02-1.77-.08.07-.17.17-.26.23-.04-.58-.55-.83-1.12-.7-.02.1.01.22-.01.31-.4-.27-.87-.3-1.27-.05.04.08.15.15.19.23-.36-.06-.53.13-.83.15.06.1.07.4.12.5.1-.01.1-.02 0-.02-.4.14-.67.43-.77.87.15.04.31.14.47.18-.76.22-.74.87-.08 1.13.1 0 .1 0 0-.01-.74.67.56.84 1 .26' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' stroke='none' d='M611.07 383.12c.5.3.23 1.16 1.2 1.24.18-.5.33-.66.44-1.18-.29 0-1.43.17-.79.37'/%3e%3cpath fill='%23ffdf4f' stroke-width='.23' d='M504.45 265.29c-.1.48.6.77 1.13.49.04-.12.02-.23.04-.35.65.2 2.15.2 1.3-.78.6-.1 1.57-.67.74-1.18.48-.47.52-1.32-.02-1.77-.08.07-.17.17-.26.23-.04-.58-.55-.83-1.12-.7-.02.1.01.22-.01.31-.4-.27-.87-.3-1.27-.05.04.08.15.15.19.23-.36-.06-.53.13-.83.14.06.1.07.4.12.5.1 0 .1-.01 0-.01-.4.14-.67.43-.77.87.15.04.31.14.47.18-.76.22-.74.87-.08 1.13.1 0 .1 0 0-.01-.74.67.56.84 1 .26' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' stroke='none' d='M612.47 389.93c.44.31.2 1.2 1.07 1.28.17-.52.3-.68.4-1.21-.25 0-1.28.17-.7.38'/%3e%3cpath fill='none' d='M503.78 264.38c-4.63 2.68-8.54 7.49-7.4 13.15' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M513.74 252.13c3.73-1.83 4.71-6.08 8.2-8.14 2.27-1.33 4.95-1.71 7.5-2.2 1.8-.34 4.23-.66 5.3-2.37-1.6 1.95-3.47 3.46-5.27 5.18-1.9 1.8-3.5 3.32-6.12 4.09-2 .58-4.07.37-6.03 1.05-1.63.56-2.59 1.89-3.96 2.9l.38-.51z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M517.45 249.44c1.9-1.18 3.12-3.06 5.2-3.92 2.31-.96 4.92-1.18 7.19-2.2m-9.58 3.79c1.68-.96 4.07 0 5.62-1.15m-2.94-.6c.85-.72 1.9-1.34 2.68-2.04m-10.98 18c-2.1 1.01-6.44 1.68-7.28 4.34' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23ffdf4f' stroke-width='.23' d='M514.64 261.19c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.72-.61.44-1.13-.15 0-.33-.04-.47-.04 1.1-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.85 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' stroke='none' d='M624.46 386.4c.05 2.38 1.94-1.32.03-.12.03.19.21.16.26.27'/%3e%3cpath fill='%23ffdf4f' stroke-width='.23' d='M522.3 267.32c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.11-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' stroke='none' d='M633.24 393.57c.05 2.4 1.94-1.31.03-.1.03.18.21.15.27.25'/%3e%3cpath fill='%23ffdf4f' stroke-width='.23' d='M517.57 270.77c.28.77 1.01 1.02 1.77.88l.14-.36c.94.44 1.84-.23 1.2-1.17.64-.1.73-.6.45-1.12-.15 0-.33-.04-.48-.04 1.11-1.4-2.42-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.45.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' stroke='none' d='M627.82 397.6c.05 2.4 1.94-1.31.02-.1.03.18.22.14.27.25'/%3e%3cpath fill='%23ffdf4f' stroke='none' d='M619.34 399.85c.31.9 1.16 1.2 2.02 1.03l.17-.41c1.07.5 2.1-.28 1.37-1.37.74-.12.84-.72.52-1.32-.18 0-.38-.05-.55-.05 1.27-1.63-2.78-2.87-2.82-1.04-.76-.04-1.76.51-.91 1.06-.79.43-.97 1.7.05 1.95'/%3e%3cpath fill='%23de2126' stroke='none' d='M620.66 398.2c.04 2.39 1.93-1.32.02-.11.03.18.22.15.27.26'/%3e%3cpath fill='%23ffdf4f' stroke-width='.23' d='M506.59 276.51c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.11-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' stroke='none' d='M615.23 404.34c.05 2.39 1.94-1.32.03-.11.03.18.21.15.27.26'/%3e%3cpath fill='%23ffdf4f' stroke-width='.23' d='M530.08 258.51c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.11-1.4-2.42-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.45.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' stroke='none' d='M642.16 383.24c.05 2.4 1.94-1.31.03-.1.03.18.21.15.27.25'/%3e%3cpath fill='%23ffdf4f' stroke-width='.23' d='M538.64 246c.28.77 1.01 1.02 1.77.88l.14-.36c.94.44 1.84-.23 1.2-1.17.64-.1.73-.6.45-1.12-.15 0-.33-.04-.48-.04 1.11-1.4-2.42-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.45.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' stroke='none' d='M651.98 368.6c.04 2.38 1.93-1.32.02-.12.03.19.21.15.27.26'/%3e%3cpath fill='%23ffdf4f' stroke-width='.23' d='M531.75 245.49c.28.77 1.01 1.02 1.77.88l.14-.36c.94.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.1-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' stroke='none' d='M644.08 368c.04 2.38 1.93-1.32.02-.12.03.19.22.16.27.27'/%3e%3cpath fill='%23ffdf4f' stroke-width='.23' d='M514.12 281.11c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.11-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' stroke='none' d='M623.88 409.71c.04 2.4 1.94-1.31.02-.1.03.18.22.14.27.25'/%3e%3cpath fill='%23ffdf4f' stroke-width='.23' d='M506.98 283.54c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.1-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' stroke='none' d='M615.67 412.56c.04 2.39 1.94-1.32.02-.11.03.18.22.15.27.26'/%3e%3cpath fill='%23ffdf4f' stroke-width='.23' d='M506.59 294.26c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.11-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' stroke='none' d='M615.23 425.13c.05 2.38 1.94-1.32.03-.12.03.19.21.16.27.27'/%3e%3cpath fill='%23ffdf4f' stroke-width='.23' d='M500.08 298.73c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.1-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67l.14.08' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' stroke='none' d='M607.77 430.36c.05 2.39 1.94-1.32.03-.11.02.18.21.15.26.26'/%3e%3cpath fill='%23ffdf4f' stroke-width='.23' d='M520.13 253.4c.28.77 1.01 1.02 1.77.88l.14-.36c.93.44 1.84-.23 1.2-1.16.64-.1.73-.61.45-1.13-.15 0-.33-.04-.48-.04 1.1-1.4-2.43-2.45-2.46-.89-.66-.04-1.54.44-.8.9-.68.37-.84 1.46.05 1.67' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23de2126' stroke='none' d='M630.76 377.27c.04 2.39 1.93-1.32.02-.11.03.19.22.15.27.26'/%3e%3cpath fill='%2339b54a' d='M537.75 242.93c2.74-2.5 2.59-6.66 6.38-8.43 1.92-.89 4.22-1.43 5.83-2.76-2.95 5-7.02 8.71-12.21 11.19' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M537.11 243.19c1.87-.68 3.25-2.28 5.04-3.12 2-.93 3.69-.26 5.8-.45 2.1-.18 4.03-.72 6.01-1.4-3.8 5.2-11.86 1.37-16.6 4.72' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M539.28 241.15c1.69-.3 2.5-2.2 3.42-3.44 1.08-1.47 2.62-1.8 4.24-2.56m-47.72 56.53c.95-1.32 1.79-2.83 2.94-3.96' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M492.65 309.16c.66-1.44.85-3.01 1.94-4.18 1.21-1.3 3.3-2.67 4.9-3.42 4.46-2.1 10.47-1.28 14.22-4.75-1.6 4.51-7.27 8.45-11.47 10.43-1.75.83-3.61 1.61-5.53 1.92-1.5.25-3.4-.08-4.83.38' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M492.9 309.28c1.45-.66 2.33-2.02 3.6-2.83a19.97 19.97 0 0 1 4.7-2.18c2.01-.64 4.1-1.27 6.05-2.12.74-.32 3.02-1.34 3.14-2.06m-13.26 6.26c1.39.38 2.68 1.35 4.21.51m-.78-2.43c2.56.01 4.57.36 7.02-.77' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M497.37 306.15c.56-.58.65-1.43 1.11-2.08.45-.63 1.16-1.18 1.57-1.8m1.53 1.65c.53-.62 1.05-1.23 1.76-1.7.7-.45 1.81-.62 2.33-1.36m-14.05 7.71c.27-1.81 1.58-3.13 2.34-4.71.48-1.03.93-3.06.98-4.17' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M493.27 305.39s.75-10.68.43-11.85c-.32-1.18-7.9-8.44-5.02-26.6 0 0 1.7-6.08.96-7.57 0 0 6.3 15.37 6.73 19.96.42 4.6-.75 12.07-1.18 13.89-.42 1.81-1.17 6.72-1.17 6.72' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M490.06 264.17c-.07 2.2.5 4.47.75 6.62.24 2.13.43 4.13.98 6.17.71 2.61 1.7 5.31 2.03 8.02.29 2.36.19 4.78.19 7.17' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M494.34 293.64c.17-1.99-1.82-4.61-3.1-5.98' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M493.91 285.53c-.45-1.43 1.18-4.4 1.39-5.98' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%2339b54a' d='M494.02 286.6c.45-3.27-5.13-3.77-5.02-6.73' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='none' d='M492.84 280.29c.36-1.67 2.67-2.98 2.03-4.91m-2.99 1.71c-.26-1.06-.95-2.12-1.47-3.1-.46-.88-1.41-1.53-1.73-2.45m2.56 1.81c0-2.2.64-3.96.64-6.09' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3c/g%3e%3cg stroke='%23000'%3e%3cg fill='%23009c4f' stroke-width='.43'%3e%3cpath d='M706.69 299.29c-.76-11.43-6.04-56.73-16.34-71.32 0 0 10 14.14 11.1 76.8l5.24-5.48z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M705.16 292.54c-5.62-35.75-25.08-67.02-25.08-67.02 7.35 15.13 20.25 53.84 23.64 77.45l2.33-2.23-.89-8.2z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M674.47 227.34c16.47 29.84 23.28 73.26 24.32 80.45l5.79-5.56c-5.35-33.64-30.11-74.89-30.11-74.89' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M664.8 224.38c2.81 4.74 15.4 29.58 20.51 43.94 4.15 11.63 8.35 32.79 10.21 42.73l7.13-6.85c-6.56-30.92-33.85-73.69-37.84-79.82' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M654.57 221.39s21.01 32.36 27.47 54.44c2.04 6.99 8.15 28.02 10.46 37.93l8.22-6.55c-6.51-19.03-26.9-67.2-46.15-85.82' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M654.81 240.03c10.93 14.65 29.6 49.29 34.66 76.94l9.45-9.09c-8.15-22.15-34.4-55.83-44.11-67.85' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M661.97 260.62c13.04 17.11 23.02 45.73 23.75 59.02l8.08-6.54c-8.23-22.02-31.83-52.48-31.83-52.48' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3c/g%3e%3cpath fill='none' stroke-linecap='round' stroke-width='.27' d='M823.61 452.48c-3-14.1-10.05-29.28-16.96-42.47m22.96 36.18c-6.6-19.32-18.14-41.61-31.06-61.33m29.11 42.47c-7.95-20.24-24.31-59.8-36.91-75.74m43.66 83.87c-5.7-21.77-18.3-50.74-25.06-64.4m27.01 57.81c-6-24.07-13.65-45.23-18.46-56.27m22.36 59.49c-1.8-19.16-11.7-51.05-19.2-67.76m17.1 43.84c-.75-9.35-3.75-28.67-5.85-37.1'/%3e%3c/g%3e%3cg id='b' fill='none' stroke='%23000' stroke-width='.46' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'%3e%3cpath fill='%23b1babf' d='M486.92 512.12a.57.57 0 0 1-.11.18s-2.73 1.42-5.71 1.62c0 0-2.7 8.42-5.89 11 3.72-2.49 9.8-4.76 11.33-4.92.08-2.36.51-5.13 2.02-6l.22-.05a9.5 9.5 0 0 0-1.86-1.83z'/%3e%3cpath stroke-width='.23' d='m476.77 523.52 10.95-10.45m-1.17 6.78-5.44-6.08'/%3e%3cpath fill='%23b1babf' d='m527.78 478.26-37.48 35.65h-1.26l-2.3-2.07.12-1.6 37.71-35.76 3.21 3.78'/%3e%3cpath stroke-width='.23' d='m488.69 512.19 35.19-33.01'/%3e%3cpath fill='%23fd0' d='M517.38 449.99c-24.76-15.59-28.8-63.2-28.43-69.69s.61-82.52.61-82.52l7.33 7.2c-13.33-13.35-28.93-29-36.85-37.02-2.54-2.57-.72 99.61-.72 144.98 0 21.28 13.27 96.33 91.1 58.56 0 0 38.9-13.96 50.25-30.8-2.65 0-5.27-.16-7.85-.49a41.85 41.85 0 0 1-3.78 1.78c-44.89 30.25-71.66 8-71.66 8z'/%3e%3cpath fill='%23034ea2' d='M488.96 380.3c-.38 6.5 3.67 54.1 28.43 69.69 0 0 26.77 22.25 71.66-8-13.57 5.6-24.65 6.78-31.91 4.63-21.7-6.41-44.65-31.48-48.31-56.84-3.67-25.37-2.75-75.2-2.75-75.2l3.25 2.85-12.43-12.45-7.33-7.2s-.23 76.02-.61 82.52z'/%3e%3cpath fill='%23ed1c24' d='M520.74 347.46c-.22-2.3-.38-10.48-.4-19.4-5.11-5.12.98 1.16-10.95-10.77l-3.32-3.41-.01 1.63c-.1 6.9-.61 50.93 2.76 74.27 3.67 25.37 25.99 50.44 47.69 56.85 7.26 2.15 18.96.97 32.54-4.63.91-.62 1.84-1.25 2.77-1.91-39.25-5.6-66.33-42.19-71.08-92.63z'/%3e%3cpath stroke-width='.23' d='m519.52 327.41-59.13-59.49'/%3e%3cpath fill='%23b1babf' stroke-width='.34' d='M458.98 264.71c-.91-.9-2-1.46-3.06-1.65.17-.7.07-1.32-.32-1.7-.83-.83-2.69-.3-4.15 1.17-1.46 1.48-1.97 3.35-1.14 4.17.4.39 1 .47 1.7.3a5.9 5.9 0 0 0 1.68 3.06c1.95 1.93 4.7 2.3 6.17.82 1.46-1.48 1.07-4.24-.88-6.17z'/%3e%3cpath d='m458.96 267.62-.17-.33.17.33zm8.93 3.69-1.35 1.03c.44-.23.9-.56 1.35-1.03z'/%3e%3cpath fill='%23ed1c24' stroke-width='.34' d='M460.84 324.05c.3-1 .46-8.71.46-10.31 0-1.61.38-2.53 1.53-10.17 1.14-7.64.6-12 .15-16.66-.46-4.66 1-14.65 1-14.65l-2.85-2.08c-.19.72-.5 1.96-.99 4.14-1.04 4.62-.23 20.11-.8 25.43-.58 5.32-1.62 12.6-1.74 15.73l-.01.19c-.04 3.7 1.1 8.23 1.1 8.23'/%3e%3cpath fill='%23034ea2' stroke-width='.34' d='M458.64 267.84s-2.66 8.44-2.54 15.72c.11 7.29-.81 17.35-.93 18.85-.11 1.5-2.08 11.8-.92 15.38l1.38 1.96s1.77-1.1 1.96-4.09v-.18c.13-3.13 1.17-10.4 1.74-15.73.58-5.32-.23-20.81.81-25.44.5-2.17.8-3.41 1-4.13.2-.82.28-.95.28-.95l-2.78-1.39z'/%3e%3cpath fill='%23ed1c24' stroke-width='.34' d='M466.62 265.65a86.75 86.75 0 0 1-7.84 1.64c6.5.13 9.11 4.02 9.11 4.02l2.2-2.65c1.96-3.24-1.74-3.59-3.47-3.01z'/%3e%3cpath fill='%23ed1c24' stroke-width='.34' d='m458.78 267.28.17.33c.77 1.4 3.94 6.65 7.59 4.73l1.35-1.03s-2.6-3.9-9.11-4.03z'/%3e%3cpath fill='%23034ea2' stroke-width='.34' d='M459.21 267.21s5.1-5.28 5.96-5.5c.87-.24 1.4 1.14 1.86 1.9.46.77.53 1.84-2.52 2.68-3.06.84-2.27.24-5.3.92z'/%3e%3cpath fill='%23034ea2' stroke-width='.34' d='M467.66 260.33c-2.2-3.93-6.24-1.73-6.24-1.73-4.01 2-2.98 7.31-2.64 8.69l.1.32c7.4-11.56 8.66-2.42 8.66-2.42.47-2.09.12-4.86.12-4.86z'/%3e%3cpath fill='%23e8b909' stroke-width='.53' d='M558.44 469.55c.28-4.79.64-11.43-3.06-11.66-3.74-.23-4.14 6.4-4.42 11.23 2.2.16 4.08.36 7.48.49' transform='matrix(.87232 0 0 .85385 -28.94 -70.13)'/%3e%3ccircle cx='455.52' cy='318.82' r='2.09' fill='%23e8b909'/%3e%3cpath d='M454.26 324.19s-.56 5.84-.61 6.18m2.23-6.11s.07 4.43-.28 6.26'/%3e%3cpath fill='%23e8b909' stroke-width='.53' d='M560.55 463.61s.39 5.17.12 7.34m-1.98-7.3s-.23 6.87-.27 7.26m5.07.08c-3.4.08-5.3 0-7.5 0 0-4.8 0-11.45 3.75-11.45 3.7 0 3.75 6.65 3.75 11.45z' transform='matrix(.87232 0 0 .85385 -28.94 -70.13)'/%3e%3ccircle cx='459.27' cy='321.64' r='2.09' fill='%23e8b909'/%3e%3cellipse cx='452.96' cy='264.03' fill='%23c0cad0' stroke-width='.23' rx='1.97' ry='3.5' transform='rotate(44.76 452.94 264)'/%3e%3cpath fill='%23b1babf' stroke-width='.34' d='M448.94 274.96s-2.8-1.6-3.08-4.92c-.19-2.32 1.43-4.41 2.44-5.48.47.33.87.53 1.07.54l.61-.36 2.16-2.23 1.36-1.34c.5-.63.86-1.15.87-1.36l-.2-.5c1.75-1.9 5.71-6.56 3.94-7.73-1.52-.98-6.03 2.68-7.56 3.99l-.74-.32c-.2.02-.57.27-1.02.64a31.9 31.9 0 0 1-3.12-10.4s-15.83-4.7-20.83-10.68c4.84 6.99 9.44 18.55 9.84 21.46 4.08.01 8.86.63 10.88 3.01-.29.38-.49.71-.5.87-.04.38.08.8.28 1.22a9.95 9.95 0 0 1-4.98 2.8c-3 .54-5.74-2.72-5.74-2.72h-.05a11.31 11.31 0 0 0-.52 3.4c0 6.14 4.84 11.1 10.8 11.1 1.5 0 2.92-.3 4.21-.87l-.12-.12z'/%3e%3cpath stroke-width='.23' d='m426.06 236.42 21.32 21.32m-12.73-1.34 10.88-10.71'/%3e%3cpath stroke-width='.34' d='M446.18 260.15a3.37 3.37 0 0 1 3.44-3.3c1.83.07 3.27 1.64 3.21 3.51s-1.6 3.36-3.43 3.3a3.37 3.37 0 0 1-3.22-3.51z'/%3e%3cpath stroke-width='.27' d='M533 389.88c-.27 2.3.93 7.18 3.35 9.65s6.2 4.31 10.26 3.8' transform='matrix(.87232 0 0 .85385 -28.94 -70.13)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='matrix(-1 0 0 1 1440 0)'/%3e%3cg id='c' stroke='%23000' stroke-width='.46'%3e%3cpath fill='%23fd0' d='M581.88 467.92c-6.19.17-17.65 1.6-17.65 1.6s-19.97 26.48-20.46 32.01c-.48 5.53-.48 10.1 12.76 8.18 0 0 6.4-1.21 11.69-1.6 5.82-1.9 6.46-.52 7.07-.12.47-2.02 1.6-6.86 2.96-12.5 2.7-11.14 6.28-25.38 7.35-26.87l.05-.38c-.33-.3-1.77-.38-3.77-.32z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23ed1c24' d='M587.08 458.22s-.29 1.86-.73 4.96l5.3 2.5s-.48 7.7-.72 12.27c-.16 3.02-2.2 23.76-3.58 37.5l-1.06 10.56c.28 4.22-3.06 8-3.06 8-2.23 2.18-3.33 3.97-3.68 5.42l-.11 1.24c.01.17.04.34.07.5.57 2.54 4.04 3.48 6.37 3.2 3.85-.49 11.07-5.1 11.07-5.1l.72-73.11-10.59-7.94z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23034ea2' stroke-linecap='round' d='M586.35 463.18c-.2 1.44-.45 3.15-.7 5.05.1.1.1.2-.01.33l-.05.06c-1.07 1.5-4.65 15.72-7.34 26.88-1.36 5.63-3.02 12.35-3.49 14.37-.57 1.25-10.67 12.84-10.86 16.6-.08 1.53 1.16 2.46 4.65 2.25 5.33-.32 9.05-1.3 11.69-1.95 3.32-.82 4.94-1.14 5.88.99l.18-1.75c.2-2.1.6-5.93 1.05-10.56 1.38-13.74 3.42-34.48 3.58-37.5.24-4.57.72-12.27.72-12.27l-5.3-2.5z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23ebc900' d='M574.87 507.48c-.42-.3-.12-1.38-7.42.68-1.63 7.31-3.55 18.31-3.55 18.31.03-3.72 7.8-11.38 10.06-14.85 1.13-1.75 1.44-3.26.91-4.14z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23023f88' d='m585.7 529.77.51-2.01c-.95-2.13-2.59-1.8-5.96-.99-.18 4.42-.4 9.33-.68 12.68.35-1.45 1.45-3.27 3.71-5.44 0 0 1.7-1.43 2.42-4.24z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='matrix(-1 0 0 1 1435.18 0)'/%3e%3cg fill='%23452c25' stroke='%23000' stroke-width='.47'%3e%3cpath stroke-width='.58' d='M593.68 214.48s-8.43 19.15-5.51 21.05c0 0 8.54-14.87 16.05-20.5 3.9-3.6 6.27.04 6.77-3.13s-10.26-7.7-10.26-7.7l-6.9 9.49' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M562.94 229.06s-12.25 20.87-9.04 21.11c3.22.25 16.31-26.6 16.31-26.6l-4.46.74-2.81 4.75z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M566.64 223.25s-12.8 20.53-9.6 20.86c3.2.33 17.01-26.16 17.01-26.16l-4.48.63-2.93 4.67z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M569.23 219.67s-14.57 19.31-11.41 19.93c3.16.61 19.27-24.55 19.27-24.55l-4.53.23-3.33 4.39z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M573.13 216.28s-17.07 17.15-14.02 18.19c3.05 1.04 22.43-21.7 22.43-21.7l-4.5-.39-3.91 3.9z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M573.74 210.04s-14.9 19.07-11.74 19.74 19.67-24.23 19.67-24.23l-4.52.15-3.41 4.34zm-3.8 16.39s-14.57 19.31-11.41 19.93c3.16.61 19.27-24.55 19.27-24.55l-4.52.23-3.34 4.39zm8.2-3.82s-8.53 15.72-7.56 16.37c.98.65 11.34-8.96 16.46-18.32s-9.27 1.56-9.27 1.56' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath stroke-width='.58' d='M586.61 219.12s-8.43 19.15-5.51 21.05c0 0 10.56-11.55 13.32-20.73s0-.64 0-.64l-.76-9.97-6.9 9.5' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath stroke-width='.58' d='M579.05 221.05s-8.43 19.15-5.51 21.05c0 0 10.56-11.55 13.32-20.73s0-.64 0-.64l-.76-9.97-6.9 9.5' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M574.68 219.38s-17.07 17.15-14.02 18.19 22.43-21.7 22.43-21.7l-4.51-.39-3.9 3.9z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M576.03 221.7s-17.07 17.15-14.02 18.19c3.05 1.04 22.43-21.7 22.43-21.7l-4.5-.39-3.91 3.9z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M577.39 224.42s-17.07 17.15-14.02 18.19 22.43-21.7 22.43-21.7l-4.5-.39-3.91 3.9zm1.27-23.55s-12.68 15.85-10.85 18.58c1.83 2.73 13.4-7.28 17.07-14.3 3.65-7-6.1-4.8-6.1-4.8' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M578.26 217.71s-10.87 20.36-8.06 19.19c2.8-1.17 13.82-16.48 15.04-19.86 1.22-3.38.8-6.9.8-6.9l-8.4 5.06.71 3.94' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath stroke-width='.4' d='M578.33 211.01s9.02-16.23-.06 3.06c-9.08 19.28-12.48 16.1-12.48 16.1-.7-1.1 7.9-14.17 7.9-14.17s6.38-10.05 7.9-11' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath stroke-width='.43' d='M588 208.86s10.03-16.12-.02 3.06C577.92 231.1 574 227.86 574 227.86c-.81-1.12 8.78-14.07 8.78-14.07s7.13-9.97 8.85-10.9' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M588.39 209.96s-10.13 21.1-7.8 22.65c0 0 8.4-9.48 10.6-17.02 2.19-7.53 0-.52 0-.52l2.8-13.56m4.83 3.75s-10.13 21.1-7.81 22.65c0 0 8.41-9.48 10.6-17.02 2.2-7.53 0-.52 0-.52l2.82-13.56' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M584.32 202.05s-12.68 15.85-10.85 18.58c1.83 2.73 13.4-7.28 17.07-14.3 3.65-7-6.1-4.8-6.1-4.8' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3c/g%3e%3cg fill='%23c69024' stroke='%23000' stroke-width='.53'%3e%3cpath fill='%23b1babf' stroke-width='.46' d='M682.1 459.3c0 2.91-.97 3.47-.97 3.47H532.06v-6.64h149.08s.97.26.97 3.17z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23b87510' d='M655.42 620.46c0 1.17.02 2.32.07 3.48h126.56a90.35 90.35 0 0 0-.02-7.55H655.5c-.06 1.35-.1 2.7-.1 4.07z'/%3e%3cpath fill='%23b76e11' d='M655.51 616.38h126.52c-.08-1.91-.22-3.8-.42-5.68H655.93c-.2 1.87-.34 3.77-.42 5.68z'/%3e%3cpath fill='%23ac620e' d='M655.94 610.69h125.68c-.2-1.88-.45-3.74-.76-5.58H656.7c-.31 1.84-.57 3.7-.77 5.58z'/%3e%3cpath fill='%23a2550b' d='M776.82 599.51h-116.1c-2.33 0-3.7 3.7-4.02 5.58h124.15c-.32-1.88-1.81-5.58-4.02-5.58z'/%3e%3cpath fill='%23b76e11' d='M655.91 630.01h125.72c.2-2 .35-4.02.42-6.07H655.5c.08 2.05.22 4.07.42 6.07z'/%3e%3cpath fill='%23ac620e' d='M656.56 634.94h124.43c.26-1.62.47-3.27.65-4.93H655.92c.17 1.66.38 3.3.64 4.93z'/%3e%3cpath fill='%23a2550b' d='M660.71 640.2H776.8c2.28 0 3.9-3.48 4.18-5.25H656.55c.28 1.78 1.72 5.25 4.15 5.25z'/%3e%3cpath d='M671.4 640.34c-1.14-3.61-1.95-12.01-2.09-20.9-.13-8.9 2.56-20.28 2.56-20.28h-6.27s-2.7 11.39-2.56 20.28c.14 8.89.95 17.29 2.1 20.9h6.26zm95.03.06c1.15-3.61 1.95-12.01 2.09-20.9.13-8.9-2.56-20.28-2.56-20.28h6.27s2.7 11.39 2.56 20.28c-.14 8.89-.95 17.29-2.1 20.9h-6.26zm-57.57-.06c-.94-5.4-1.05-12.53-1.05-20.9s.89-17.9 1.52-20.28h-6.27c-1.1 3.55-1.51 13.04-1.51 20.28 0 7.24.2 15.68 1.04 20.9h6.27zm19.58 0c.94-5.4 1.05-12.53 1.05-20.9s-.89-17.9-1.52-20.28h6.27c1.1 3.55 1.51 13.04 1.51 20.28 0 7.24-.2 15.68-1.04 20.9h-6.27z'/%3e%3cpath stroke-width='.55' d='M686.12 620.17c3.7 6.65 11.28 20.39 11.28 20.39l5.3-.16s-3.09-6.54-11.43-20.63c-8.35-14.1-13.94-20.82-13.94-20.82l-5.3.15s10.39 14.42 14.09 21.07zm65.59 0c-3.7 6.65-11.28 20.39-11.28 20.39l-5.3-.16s3.09-6.54 11.43-20.63c8.34-14.1 13.94-20.82 13.94-20.82l5.3.15s-10.39 14.42-14.09 21.07z'/%3e%3cpath stroke-width='.55' d='M749.23 620.17a8113.7 8113.7 0 0 1 11.28 20.39l5.3-.16s-3.09-6.54-11.43-20.63c-8.35-14.1-13.95-20.82-13.95-20.82l-5.3.15s10.4 14.42 14.1 21.07z'/%3e%3cpath fill='%23b1babf' d='M634.54 627.22s2.77-13.45-1.63-21c-4.4-7.56-10.11-9.77-11.42-9.22-1.3.55 14.02-22.67 30.33-.37 0 0-14.35 1.66-11.41 29.67'/%3e%3cpath fill='%23d3dce0' stroke='none' d='M623.71 597.01c4.45-4.96 14.81-12.42 25.97.29a8.1 8.1 0 0 1 2.13-.67c-16.3-22.3-31.62.92-30.32.37.37-.16 1.08-.1 2.01.24l.21-.23'/%3e%3cpath fill='%23b1babf' d='M631.92 622.28a27.8 27.8 0 0 0-8.4 4.62s-10.85-5.92-17.86-6.51c-.6-.05-1.19-.14-1.72-.1.55-.1 1.13-.15 1.7-.28 7.12-1.64 15.85-5.45 17.75-6.93 2.55 2.59 5.9 5.23 8.63 5'/%3e%3cpath fill='none' stroke-width='.4' d='M605.71 620.21h26.48m-8.74-7.23.1 13.7'/%3e%3cpath fill='%23b1babf' d='M640.52 627.22c-.2 4.17-1.38 7.37-2.8 7.37-1.44 0-2.63-3.3-2.81-7.56'/%3e%3cpath fill='%23b1babf' d='M631.2 613.4h13.05v13.64H631.2z'/%3e%3cpath fill='none' d='M633.81 616.12h7.83v8.18h-7.83z'/%3e%3cpath fill='none' d='M636.16 618.58h3.13v3.27h-3.13zm13.42-21.22.3-.1c1.21-.53 2.03-.63 2.03-.63-16.31-22.3-31.63.92-30.32.37.34-.15 1-.1 1.86.2.05 0 .16.08.21.1'/%3e%3cpath fill='none' stroke-width='.27' d='M649.56 597.28c-11.26-12.77-21.7-5.04-26.06-.09'/%3e%3cpath stroke-width='.55' d='M688.61 620.17c-3.7 6.65-11.28 20.39-11.28 20.39l-5.3-.16s3.09-6.54 11.43-20.63c8.35-14.1 13.94-20.82 13.94-20.82l5.3.15s-10.39 14.42-14.09 21.07z'/%3e%3c/g%3e%3cpath fill='url(%23d)' d='M631.37 476.35c0 62.57 39.41 113.29 88.03 113.29s88.04-50.72 88.04-113.29c0-62.57-39.42-113.3-88.04-113.3s-88.03 50.72-88.03 113.3'/%3e%3cpath fill='%23395054' stroke='%23000' stroke-width='.46' d='M641.6 329.09c3.35-2.15 6.54-2.11 10.55-3.38 2.79-.88 6.16-1.05 8.87-1.69 2.47-.58 9.95 4.32 12.45 5.07l.17 6.8s-12.4 1.3-16.82-.38c-4.42-1.67-15.22-6.84-15.22-6.84' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23006c3c' d='M683.24 486.82c1.6 1.33.26 1.9-.67 2.99-.53.62 3.06 3.39 6.9 4.6a5.2 5.2 0 0 1 2.93 2.31c.53.81 1.72 1.63 3.58 2.98 1.85 1.36.4 1.77 4.78 1.9 4.37.14 6.1 1.22 7.83 1.63 1.72.4 2.78.68 7.03 1.22 4.25.54 19.3-.04 18.9.1-.4.13-10.55 2.27-11.48 2.81-.93.55-5.7-.6-6.63-.06-.92.54-1.85 1.35-2.91 2.17-1.07.8-.27 1.08.8 1.35s2.25.54 4.1 1.5c1.86.94 1.86 1.08 5.98 1.62 4.11.54 2.52 0 6.37.81 3.85.82 2.92.55 7.3.68 4.38.14.93.54 6.63.14 5.71-.41 4.38-.27 6.64-.27 2.25 0 2.26-.41 4.78-.55s4.3 3.84 1.77 3.84 1.98-.8.26-.67c-1.73.14-6.28-.32-7.2.22-.94.55-1.87 1.63-4.39 3.53-2.52 1.9-.53 2.85.27 3.39s1.99.81 3.05 1.22c1.06.4 2.12.27 5.44 1.49 3.32 1.22 4.12 1.36 6.24 1.49 2.12.14 5.18.95 5.18.95s4.1 1.76 6.23 1.9c2.13.13 1.33.54 3.98 1.76 2.66 1.22 2.52.27 4.65.27 2.12 0 2.92.27 4.11 1.09 1.2.8 2.92 1.49 2.92 1.49s-.93 2.57-9.69 17.08c-8.75 14.51-22.3 23.19-32.24 28.88-9.96 5.7-22.96 6.37-41.28 4.47-18.31-1.9-36.1-20.74-43.8-30.5a68.07 68.07 0 0 1-10.74-19.53l1.59-.13c.93-.14 1.86-.27 3.32-.54 1.46-.28 1.33-.14 3.05-.55s2.26-.4 3.85-1.08c1.6-.68 1.06-.95 3.58-1.63s1.73-.54 2.39-.68c.66-.13 1.73-.27 3.18-.81 1.46-.54 3.19-1.35 1.6-2.17s0-.95 0-.95 1.72.14 4.11.27c2.39.14 1.46.4 3.05.54 1.6.14 1.46 0 2.66-.27 1.2-.27-.27-1.62-.53-2.98-.27-1.36-.93-.54-1.46-1.09-.53-.54-1.06-.27-2.79-1.35-1.73-1.09-1.2-.14-4.91-1.36-3.72-1.21-.39 1.1-5.03-.26s-2.07.95-5.92-.27-5.1-3.94-1.52-3.4 1.06-.13 1.45-.68 1.07-.13 3.19-.27c2.12-.13 1.86 0 3.85-.13 1.99-.14 2.79-.68 2.79-.68s1.72.68 2.91.68.8-.27.8-1.09 1.2 0 2.12.27c.93.27 3.19-.13 3.19-.13s1.06-.14 3.05-.14c2 0 .8-.4 2.66-1.08 1.85-.68 0-1.36-.67-1.5-.66-.13-.8-.4-1.72-1.21a7.9 7.9 0 0 0-2.9-1.71c-1.2-.41-8.19.52-9.91-.02s-1.66-2.75 1.8-2.88c3.44-.14 1.32 0 3.04 0s1.33.27 2 .27c.66 0 1.32 0 4.1-.41 2.8-.4 1.6-.54 3.46-1.36s3.85-.54 5.44-1.22c1.6-.67-.66-1.35-2.65-2.3-2-.95 0 .54-1.46-.95-1.46-1.5-8.88-5.85-11.14-7.88-2.08-1.87 1.8-1.17 3.75-2.07 0 0 .84-1.97-1.33-2.71s-1.93-.74-4.22-1.6-3.38-2.47-5.07-2.84c-1.69-.37-2.53-.86-2.53-.86'/%3e%3cpath fill='%236dbe45' d='M683.24 486.82c-1.02.76-1.02 1.8-.67 2.99.24.79 1.77 4.1 5.62 5.32 1.6.5 3.67.78 4.2 1.59.53.81 1.73 1.63 3.59 2.98 1.85 1.36.4 1.77 4.78 1.9 4.37.14 6.1 1.22 7.83 1.63 1.72.4 2.78.68 7.03 1.22 4.25.54 18.52.17 18.13.3-.4.14-12.76 2.72-13.7 3.26-.92.54-2.7-1.26-3.64-.71-.92.54-1.85 1.35-2.91 2.17-1.07.8-.27 1.08.8 1.35s2.25.54 4.1 1.5c1.86.94 1.86 1.08 5.98 1.62 4.11.54 2.52 0 6.37.81 3.85.82 2.92.55 7.3.68 4.38.14.88 1.06 6.59.66s3.78.09 6.04.09 2.9.67 5.43.53c2.52-.13 8.46 1.65 5.94 1.65-1.57 0-4.02-.72-6.79-.5-1.73.13-3.41-.26-4.34.28-.93.54-1.86 1.63-4.38 3.53-2.52 1.9-.53 2.84.27 3.39.8.54 1.99.81 3.05 1.22 1.06.4 2.12.27 5.44 1.49 3.32 1.22 4.11 1.35 6.24 1.49 2.12.13 5.17.95 5.17.95s4.12 1.76 6.24 1.9c2.12.13 1.33.54 3.98 1.76 2.66 1.22 2.52.27 4.65.27 2.12 0 2.92.27 4.11 1.09.75.5 1.7.96 2.32 1.23 0 0 5.47-15.31 7.6-21.97 2.12-6.66 4.39-25.9 4.39-27.06 0-1.16-3.12-2.9-4.11-2.6-.99.28-5.24.28-6.52.28h-17.85c-1.13 0-1.98.87-4.1-.14-2.13-1.01-5.95-1.6-7.23-1.45-1.27.15-6.52.3-7.65.3-1.13 0-13.74-.59-15.86-.44s-6.1.14-8.65 0c-2.55-.15-5.8-.15-7.08-.3-1.27-.14-5.95-.43-7.08.44-1.14.87-4.25 1.16-5.67 1.45s-5.24 1.01-7.22 1.16c-1.99.14-7.8 1.3-9.63 1-1.85-.28-8.11-.3-8.11-.3'/%3e%3cpath d='M683.24 486.68c-1.18 1.03-1.03 2.53-.43 3.86a9.08 9.08 0 0 0 5.38 4.72c1.31.45 2.94.5 4.05 1.41.36.29.63.76.98 1.08.62.56 1.32 1.04 2 1.53a10.5 10.5 0 0 1 1.92 1.7c.5.58 1.33.6 2.02.67 1.66.15 3.31.13 4.96.43 1.18.2 2.32.6 3.45.98 1.89.63 3.9.93 5.85 1.22 4.7.69 9.44.62 14.17.6l4.38-.02c.3 0 1.53-.2 1.78.02v-.27c-.24.15-.65.16-.92.22l-2.53.55c-2.15.47-4.3.95-6.45 1.45-1.34.32-2.7.6-3.99 1.12-.86.34-2.15-.82-3.03-.9-.61-.06-1.38.75-1.83 1.09-.66.5-1.5 1-1.98 1.7-.68 1.02 3.24 1.67 3.73 1.85 1.06.4 2.03 1 3.06 1.45.91.4 1.91.54 2.88.7 2.28.34 4.6.37 6.85.8 2.33.43 4.46.85 6.83.88 1.23.02 2.51-.03 3.72.25.4.1.74.36 1.15.46 1.06.27 2.33.06 3.4-.02 1.3-.08 2.6-.2 3.91-.14 1.29.06 2.72.2 3.98.4 2.56.43 5.11.32 7.65.93.78.2 1.66.38 2.36.81.13.08.08-.06-.03-.03-.14.05-.32.03-.46.04-.78.01-1.58-.14-2.34-.25a33.94 33.94 0 0 0-5.38-.23c-1.48.02-2.8-.25-4.04.7-1.02.8-1.96 1.69-2.96 2.48-.7.55-2 1.25-2.03 2.3-.04 1.75 2.5 2.49 3.75 2.9 1.3.43 2.6.67 3.9 1.02 2.13.56 4.13 1.54 6.29 1.99 1.82.38 3.7.37 5.52.75 1.04.21 1.97.47 2.95.86 1.67.66 3.44 1.33 5.24 1.5 1.71.15 2.87 1.27 4.43 1.95 1.7.75 3.3.03 5.1.1 2.13.08 3.65 1.45 5.53 2.3 1.16-3.24 2.3-6.48 3.44-9.73 1.6-4.58 3.41-9.19 4.63-13.9 1.25-4.82 1.94-9.81 2.64-14.74.5-3.5 1.03-7.01 1.28-10.53.1-1.33-1.33-2.1-2.34-2.6-.9-.44-1.54-.4-2.47-.29-1.28.16-2.6.15-3.88.16-3.4.05-6.8.01-10.21.01h-6.54c-1.21 0-2.54-.15-3.74.1a5.3 5.3 0 0 1-3.69-.37c-1.41-.64-3-.94-4.52-1.17-2.18-.33-4.42-.01-6.62.06-3.63.12-7.23-.05-10.86-.18-4.43-.17-8.81-.05-13.23-.07-3.3-.01-6.61-.17-9.9-.32-2.25-.1-4.47-.4-6.72-.1-1 .14-1.72.72-2.65 1.04-1.35.45-2.8.58-4.19.82-2.55.45-5.07 1-7.65 1.22-3.13.26-6.46 1.43-9.6.98-2.61-.38-5.33-.28-7.95-.3-.02 0-.02.27 0 .27 3.94.02 7.94.6 11.85.11 5.1-.64 10.13-1.47 15.19-2.31 1.2-.2 2.55-.4 3.59-1.1.88-.6 2.17-.56 3.17-.6 2.4-.07 4.8.25 7.18.31 3.37.1 6.73.3 10.1.24 1.84-.04 3.66-.13 5.51-.1 4.11.1 8.22.31 12.33.43 4.25.12 8.41-.7 12.6.28 1.44.33 2.76 1.13 4.2 1.36.93.14 1.8-.33 2.73-.33h16.62c1.64 0 3.27 0 4.91-.05.96-.03 1.89-.1 2.83-.27 1.02-.18 2.36.79 3.1 1.38 1.25 1 .72 2.49.56 3.89-.26 2.29-.56 4.57-.87 6.86a149.06 149.06 0 0 1-2.7 15.41c-1.17 4.7-3 9.28-4.6 13.83-1.16 3.35-2.34 6.7-3.53 10.03-.02.05-3.24-1.8-3.62-1.95a7.49 7.49 0 0 0-4.23-.2 4.7 4.7 0 0 1-3.22-.44c-1-.44-1.86-1.3-2.89-1.62-1.1-.34-2.32-.31-3.44-.63a34.74 34.74 0 0 1-3.48-1.24 19.53 19.53 0 0 0-5.88-1.14c-2.82-.19-5.29-1.35-7.96-2.14-2.22-.66-4.63-.83-6.62-2.14-.36-.23-.7-.46-1-.76-.99-.98.6-2.06 1.28-2.58 1.15-.87 2.21-1.86 3.34-2.77 1.07-.87 2.27-.75 3.59-.7 1.97.05 3.85-.06 5.83.22.36.05 3.21.79 2.94-.18-.1-.39-1.39-.62-1.68-.7-1.19-.36-2.41-.6-3.64-.73-1.3-.15-2.58 0-3.88-.24-1.2-.22-2.35-.28-3.55-.38-1.32-.1-2.53-.22-3.89-.15-1.87.1-3.82.54-5.58-.24-.85-.38-1.96-.31-2.86-.34-1.19-.03-2.37 0-3.55-.08-2-.15-3.91-.82-5.9-1.05-2.12-.24-4.24-.36-6.36-.73-1.83-.32-3.3-1.3-5.01-1.99-1.12-.45-2.35-.59-3.46-1.07-.55-.25 1.57-1.83 1.72-1.94.52-.41 1.14-1.01 1.82-1.1.83-.09 1.78.72 2.58.9.42.1.93-.2 1.33-.32 1.52-.46 3.09-.79 4.63-1.14 1.87-.43 3.75-.84 5.62-1.25.8-.17 2.05-.2 2.76-.62.03-.02.03-.24 0-.27-.12-.11-.67-.02-.82-.03l-2.44.01c-2.37.02-4.73.03-7.09.02-4.6-.03-9.13-.25-13.64-1.25-2.02-.45-3.95-1.25-6-1.61-1.62-.3-3.26-.25-4.9-.4-.69-.06-1.32-.17-1.8-.72-.64-.76-1.39-1.29-2.19-1.87-.56-.41-1.12-.83-1.65-1.28-.44-.38-.73-.88-1.17-1.24-1.08-.88-2.97-.95-4.25-1.39a8.81 8.81 0 0 1-3.68-2.57c-1.19-1.35-2.6-3.82-.88-5.33.05-.04-.03-.24 0-.27'/%3e%3cpath fill='%236dbe45' d='M680.46 490.44c1.41 1.74.15.55-3.24 2.38-2.66 1.43 11.47 8.81 12.93 10.3 1.46 1.5-.53 0 1.46.95 2 .95 4.25 1.63 2.65 2.3-1.59.69-3.58.42-5.44 1.23-1.85.81-.66.95-3.45 1.35s-3.45.41-4.11.41c-.66 0-.5-.25-2.23-.25s-.28.35-3.73.48c-.34.01-4.87.53-4.83.53 2.18.24 7.33.46 9.64.55 1.28.06 2.46.67 4.2 1.27 1.2.4 2 .95 2.92 1.76.93.81 1.06 1.08 1.73 1.22s2.52.81.66 1.5c-1.86.67-.66 1.08-2.65 1.08-2 0-3.06.13-3.06.13s-2.25.4-3.18.14c-.93-.27-2.13-1.09-2.13-.27s.4 1.08-.8 1.08-2.91-.68-2.91-.68-.8.55-2.79.68c-1.99.14-1.72 0-3.85.14-2.12.13-3.25-.4-3.18.27.13 1.31-1.83.71-1.5 1.67.29.1-2.46.1-2.24.17 3.85 1.22 4.93-.49 9.58.87 4.64 1.36 1.46.68 5.17 1.9 3.72 1.22 3.19.27 4.91 1.35s2.26.82 2.8 1.36c.52.54 1.19-.27 1.45 1.08.27 1.36 1.73 2.71.53 2.99s-1.06.4-2.65.27c-1.6-.14-.67-.41-3.05-.55-2.4-.13-4.12-.26-4.12-.26s-1.6.13 0 .94c1.6.82-.13 1.63-1.6 2.17-1.45.55-2.51.68-3.18.82-.66.13.14 0-2.39.67-2.52.68-1.98.96-3.58 1.63-1.6.68-2.12.68-3.85 1.09-1.72.4-1.59.27-3.05.54-1.46.27-2.39.4-3.32.54-.93.14-2.64.43-2.64.43s-6.11-10.1-9.15-22.64c-3.05-12.55-4.42-32.93-4.42-33.93s4.5-1.04 6.01-.49c1.52.56 8.8 1.11 12.17 1.56 3.37.44 11.73 1.66 12.38 1.88.65.23 2.65-1.12 4.28 0 1.63 1.1 6.37 4.44 6.37 4.44'/%3e%3cpath d='M680.46 490.57c.2.24.76.67.32.85-.4.16-.86.2-1.27.32-.7.18-2.33.52-2.6 1.3-.21.6.32 1.2.68 1.59 1.25 1.35 2.92 2.37 4.44 3.37 1.8 1.18 3.63 2.3 5.45 3.42.64.4 1.27.8 1.9 1.23.2.14.4.28.59.44l.18.16.42.45c.14.28.2.28.15-.01-.2.1.82.48.9.51.79.37 1.6.7 2.37 1.1 1.1.54.3.97-.49 1.2-.94.27-1.97.3-2.94.46a6.88 6.88 0 0 0-3.06 1.3c-.95.7-2.66.64-3.77.78-.78.1-1.56.18-2.35.18-.93 0-1.83-.28-2.78-.24-.4.01-.74.19-1.13.28-.83.2-1.71.14-2.56.22-1.47.15-2.98.24-4.43.5-.03 0-.03.27 0 .27 5.63.58 12.1-.4 16.75 3.58.48.4.89.9 1.47 1.15.45.2.91.24 1.36.48.86.46-.87.99-1.14 1.13-.37.19-.56.56-.96.7-1.12.37-2.65.07-3.85.18-.78.07-1.55.22-2.34.25-.61.02-1.12-.1-1.68-.33-.4-.16-1.06-.6-1.44-.25-.27.26.18.93-.1 1.2-.64.62-2.81-.27-3.5-.52-.21-.07-.23 0-.44.09-.63.3-1.35.4-2.03.49-1.16.15-2.33.09-3.5.13-.84.03-1.66.08-2.5.03-.41-.02-1.09-.22-1.46.06-.07.05-.06.23-.06.3-.02.46-.23.67-.63.84-.4.17-.91.16-.91.72 0 .1 0 .26.07.33v-.27c-.69.25-1.55 0-2.26.14-.03 0-.03.24 0 .26.15.25 1.17.32 1.45.37a9 9 0 0 0 1.8.11c1.3-.02 2.55-.2 3.85-.1 1.92.17 4 .78 5.72 1.69 1.8.94 3.79 1.1 5.71 1.53.98.21 1.81 1 2.75 1.35.36.13.72.21 1.04.43.43.3.75.25 1.21.44.4.17.7 1.66.9 2.07.35.7.64 1.25-.31 1.48a6.36 6.36 0 0 1-3.22.05c-1.06-.28-2.04-.39-3.15-.45-1-.06-2.16-.32-3.17-.21-.27.02-.68.09-.68.43 0 .87 2.11 1.02.65 2-1.73 1.15-3.99 1.29-5.95 1.86-1.2.34-2.45.57-3.5 1.27a10.7 10.7 0 0 1-3.56 1.42c-2.71.62-5.45 1.05-8.19 1.47-.32.04-2.24.56-2.39.3l-.71-1.24a88.76 88.76 0 0 1-3.04-6.09 87.4 87.4 0 0 1-6.38-20.05 215.26 215.26 0 0 1-2.56-18.83c-.24-2.38-.45-4.76-.63-7.14-.06-.77-.6-2.9.21-3.34 1.7-.9 4.27-.34 6 .1 2.41.61 5 .7 7.45.96 4.95.5 9.88 1.21 14.79 2 .62.1 1.25.2 1.86.35.4.1.8-.06 1.19-.17a4.95 4.95 0 0 1 2.42-.17c.98.21 2.03 1.25 2.84 1.8l3.16 2.23 1.09.76c-.03-.02.05-.23 0-.27l-4.75-3.33c-.97-.67-1.86-1.47-3.07-1.56-1.04-.09-2.01.63-3.03.4-4.32-.98-8.85-1.45-13.25-1.97-2.77-.32-5.55-.55-8.32-.9-2-.26-3.89-.89-5.92-.88-.79 0-2.93-.09-2.89 1.13.04 1.08.13 2.15.21 3.23 1.4 18.36 3.72 37.32 13.37 53.32 4.9-.83 10.15-1.06 14.56-3.55 1.56-.88 3.64-1.2 5.4-1.56 1.02-.21 4.8-.88 4.22-2.6-.07-.2-1.36-.8-1.1-.98.13-.1.4-.15.56-.14 1.36.1 2.73.2 4.09.27 2.1.12 3.84.96 5.95.18.27-.1.24-.5.22-.73-.04-.39-.3-.77-.47-1.1-.26-.5-.38-1.6-.75-1.95-.31-.3-.67-.2-1.05-.33-.32-.1-.58-.42-.93-.54-1.08-.37-1.99-1.09-3.05-1.46-.47-.16-1.02-.14-1.5-.21a19.3 19.3 0 0 1-3.61-1.05c-1.06-.39-2-.89-3.09-1.22a16.22 16.22 0 0 0-4.36-.82c-1.04-.02-2.08.14-3.12.16-.5.01-1.02-.04-1.52-.12-.36-.05-.71-.14-1.06-.23-.22-.06-.52.13-.1.11.6-.04 1.4.1 1.97-.11.02-.01.02-.25 0-.27-.22-.18.95-.57 1.01-.6.26-.1.42-.32.47-.59.04-.23 0-.5.27-.57.57-.16 1.4.07 2 .08 1.22.04 2.46-.06 3.68-.1 1.26-.03 2.65-.09 3.8-.69.48-.26 3.88 1.62 3.85.17 0-.35-.17-.9.27-.97.52-.07 1.3.46 1.78.62.95.32 2.2.03 3.16-.12.85-.15 1.74-.13 2.6-.14.56-.01 1.25.1 1.76-.2.5-.3.8-.66 1.38-.9 1.82-.73.1-1.55-.93-1.82-.56-.15-1.05-.78-1.46-1.15a9.93 9.93 0 0 0-1.84-1.3 16.1 16.1 0 0 0-4.94-1.7c-2.72-.42-5.62-.25-8.37-.44a49.5 49.5 0 0 1-1.61-.14v.27c1.2-.22 2.44-.28 3.65-.41 1.23-.14 2.6 0 3.77-.44 1.1-.43 2.25.04 3.36.09 1.64.06 3.35-.27 4.95-.54.55-.1 1.04-.23 1.48-.57a6.66 6.66 0 0 1 2.88-1.16c.74-.14 4.28-.13 4.25-1.32-.01-.38-.23-.51-.53-.71a15 15 0 0 0-3.45-1.58c-.37-.12-.13.35-.1.34.04-.02.02-.23 0-.26-.17-.54-.92-1-1.36-1.31-.87-.6-1.78-1.16-2.68-1.71-2.29-1.42-4.58-2.8-6.77-4.37-.82-.6-1.63-1.21-2.33-1.94-.27-.27-.5-.57-.65-.92-.23-.57 1.28-.98 1.54-1.09.41-.17 2.44-.4 2.55-.9.1-.45-.34-.85-.57-1.15.03.04-.05.21 0 .27'/%3e%3cpath fill='%23557176' d='M635.57 484.14s.26-2.15 5.52-2.15 3.68.54 9.72 1.35c6.04.8 10.51.8 12.62 1.07s6.56.8 8.14 1.34c1.58.54 4.2 1.88 4.2 1.88s-1.04.8 3.42.8c4.47 0 3.15-.26 9.46-.26s2.1 1.6 10.25 0c8.14-1.61 14.45-2.42 16.55-2.96 2.1-.53-2.36-2.14 5.52-1.07s11.57.27 12.88.27c1.31 0 6.83.27 9.46.27 2.63 0 6.3 0 7.88.26 1.58.27 3.94-.26 7.36.27 3.42.54 4.2-1.07 6.83.54s7.36.54 9.2.27c1.84-.27 5.52 0 6.57 0s6.04.53 8.4.53c2.37 0 7.1-.53 7.1-.53l4.47.53s.79-11.54.79-12.88c0-1.35 2.85-3.36-2.18-3.85-18.5-1.79-11.34-2.94-22.26-3.67-2.63-.54-15.24-3.76-17.87-4.3-2.63-.53-16.82-4.83-21.02-4.83-4.2 0-14.72.54-17.35.54s-25.49-.54-28.64-.54c0 0-8.4-2.95-10.51-3.76s-2.37-.53-9.2-.27-8.4 1.08-14.71.27-11.57 0-14.46.54c-2.89.54-7.1 2.15-7.1 2.15l-1.04 28.2z'/%3e%3cpath d='M635.6 484.36c.09-.64.82-1.1 1.32-1.37 1.8-.95 4.11-.77 6.05-.7 1.29.04 2.5.29 3.74.58 2.32.55 4.7.83 7.08 1.07 3.91.41 7.85.49 11.76 1 1.94.25 3.94.47 5.84 1 1.52.44 2.99 1.23 4.4 1.95v-.54c-.24.2-.2.76.03.94.68.54 2.12.38 2.9.4 1.15.03 2.3 0 3.46-.06 3.7-.2 7.39-.48 11.01.43.58.14 1.2.08 1.79.02 1.66-.16 3.3-.53 4.94-.85 3.51-.68 7.04-1.27 10.57-1.85 1.12-.19 2.25-.37 3.37-.57.64-.12 1.44-.17 2.02-.5.2-.12.25-.33.25-.55.01-.25.07-.89-.06-.44.11-.39 1.07-.28 1.33-.28 1.7.02 3.4.35 5.08.55 2.86.34 5.76.46 8.64.29 4.08-.25 8.12.04 12.2.06 2.9 0 5.76.18 8.65.34 1.4.07 2.82-.08 4.23-.04 1.78.06 3.47.48 5.27.23 1.16-.17 2.13-.3 3.25.18.65.27 1.2.66 1.87.88.78.26 1.62.32 2.43.35 2.61.09 5.15-.7 7.75-.72 4.76-.04 9.5.84 14.26.61 1.3-.06 2.59-.18 3.88-.3.55-.06 1.23-.26 1.78-.19l4.45.54c.02 0 .02-.13.02-.14.24-3.53.48-7.06.68-10.6.09-1.42.1-2.44.7-3.74.42-.95.3-1.9-.68-2.35-1.46-.69-3.42-.56-4.99-.74a132 132 0 0 1-4.8-.6 44.42 44.42 0 0 1-5.17-1c-2.07-.56-4-1.23-6.15-1.5-1.77-.2-3.47-.3-5.2-.72-2.29-.54-4.57-1.1-6.84-1.67-3.6-.88-7.24-1.67-10.83-2.6-4.7-1.24-9.36-2.6-14.1-3.63-1.85-.4-3.72-.8-5.62-.78-2.54.01-5.08.12-7.62.22-3.7.14-7.39.35-11.08.3l-12.48-.26c-4.2-.08-8.38-.18-12.57-.24-.98-.02-1.74 0-2.66-.32l-6.27-2.23c-2.26-.8-4.35-1.82-6.78-1.76-4.77.11-9.51.62-14.27.85-2.61.12-5.17-.23-7.76-.48a44.24 44.24 0 0 0-20.04 2.84c-.03.02-.02.18-.02.2l-1.05 28.19c0 .17.03.52.05.14l.73-19.58.31-8.4.01-.2c-.01.3.16.12.4.03 1.25-.46 2.52-.88 3.8-1.26 2.67-.81 5.45-1.22 8.23-1.45 3.8-.33 7.48.09 11.26.42 2.76.24 5.5 0 8.26-.23 3.2-.27 6.43-.39 9.65-.52a9.3 9.3 0 0 1 3.84.52c3.48 1.31 7 2.52 10.5 3.75.32.11.86.01 1.2.02l2.28.03 6.25.12c7.64.16 15.3.54 22.94.26 2.78-.1 5.55-.22 8.32-.31 2.06-.07 4.18-.26 6.24-.03 4.8.52 9.55 2.02 14.2 3.28a506.04 506.04 0 0 0 23.1 5.69c1.68.36 3.48.3 5.18.58.96.16 1.89.41 2.81.72 3.28 1.07 6.67 1.55 10.08 1.96 1.8.22 3.63.34 5.42.6 1.02.15 2.4.5 1.83 1.77-.52 1.14-.55 1.95-.62 3.2-.2 3.73-.46 7.45-.71 11.17.01-.15-3.7-.5-4.28-.58-.46-.05-.95.07-1.4.11-1.36.14-2.72.26-4.09.35-4.84.3-9.72-.59-14.58-.6-2.6 0-5.13.74-7.74.72a7.85 7.85 0 0 1-3.98-1.07c-1.16-.67-2.32-.54-3.58-.34-1.64.25-3.2-.08-4.83-.2-1.55-.11-3.11.05-4.67.01-1.17-.03-2.35-.24-3.54-.29-1.7-.06-3.4-.05-5.1-.05-4.1 0-8.13-.33-12.2-.06-2.89.2-5.78.03-8.65-.29-1.62-.18-3.22-.45-4.84-.54-.4-.02-1.26-.14-1.56.24-.1.13-.07.38-.06.53 0 .08 0 .17.02.26.05.35.04 0 .02.05-.15.37-.89.42-1.2.49-.93.2-1.87.35-2.8.5-2.93.5-5.86.96-8.77 1.49-2.95.52-5.92 1.35-8.92 1.53-.98.06-1.8-.33-2.75-.51-2.3-.45-4.8-.23-7.14-.13-1.54.06-3.06.18-4.6.2-1.2 0-2.43.04-3.6-.22-.2-.05-.46-.12-.57-.31.23.4-.13.43.08.26.05-.04.06-.5 0-.54a29.82 29.82 0 0 0-4.4-1.94c-1.97-.63-4.14-.79-6.18-1.05-4.11-.54-8.26-.6-12.37-1.05-3.66-.4-7.23-1.52-10.9-1.59-1.49-.02-6.02-.18-6.37 2.18-.02.1.02.5.02.46'/%3e%3cg fill='%2399afca'%3e%3cpath d='M784.27 477.04c-.5 1.01-1 2.01-1.58 2.97-.07.13.05.46.01.52.58-.96 1.09-1.97 1.58-2.97.06-.14-.05-.45-.01-.52m-134.82-1.73c-.61.88-1.21 1.76-1.7 2.72-.06.13.05.45.02.52a21.8 21.8 0 0 1 1.7-2.73c.08-.1-.05-.46-.02-.51m3.51-1.45c-.02.13-.1.24-.12.37-.02.12-.02.24 0 .36 0 .02.01.2.03.1.02-.13.1-.24.12-.37.02-.12.01-.25 0-.37 0-.01-.01-.2-.03-.1m4.24-1.76c-.26 1.01-.6 2-.97 2.97-.05.14.05.43.02.51.36-.98.71-1.96.97-2.97.03-.15-.04-.42-.02-.51m1.44-.86c-.01.6-.12 1.18-.23 1.75-.03.12-.02.25-.01.37 0 .02.01.2.03.1.15-.74.25-1.47.26-2.22 0-.3-.05-.3-.05 0m2.68-1.97a96.66 96.66 0 0 0-3.64 6.68c-.06.13.05.45.02.51a97.16 97.16 0 0 1 3.63-6.68c.08-.12-.04-.46-.01-.51m1.57-.93c-.17 1.64-.83 3.13-1.44 4.63-.06.14.04.44.01.52.64-1.55 1.3-3.09 1.47-4.77 0-.07-.02-.59-.04-.38m1.44-.01a16.41 16.41 0 0 1-.47 3.18c-.02.1.02.5.03.46.25-1.16.47-2.31.5-3.5 0-.17-.05-.52-.06-.14m1.83-.24c.07.88-.3 1.73-.6 2.53-.05.14.04.43.02.51.42-1.14.71-2.19.61-3.41-.02-.21-.04.3-.03.37m-12.58 12.72c.6-.34 1.1-.8 1.7-1.12.1-.06-.04-.51 0-.54-.6.33-1.1.79-1.7 1.12-.1.05.04.5 0 .53m3.5-1.89c-.21.33-.4.67-.6 1-.05.07-.03.24-.03.32 0 .02.02.22.04.19l.6-1c.05-.06.02-.24.02-.32 0-.02-.02-.21-.03-.18m19.26-14.74c-.13.37-.34.7-.6.98-.05.05-.03.21-.03.27l.03.27c.27-.29.48-.63.61-1 .03-.1.02-.23.02-.33a.78.78 0 0 0-.03-.19m.98 4.11a7.9 7.9 0 0 0 1.96-5.47c-.02-.33-.05.18-.04.27.1 1.66-.9 3.44-1.92 4.67-.1.12.07.45 0 .53m3.97-5.78a16.57 16.57 0 0 1-.47 3.32c-.03.1.01.5.02.46.26-1.2.48-2.4.5-3.63 0-.17-.05-.51-.05-.14m-3.26.43c-.41 1.43-1.19 2.7-1.94 3.96-.07.13.05.46.02.52.75-1.27 1.52-2.53 1.94-3.96.04-.15-.04-.43-.02-.52m-15.02 13.61c-.26.67-.53 1.34-.84 1.98-.07.14.04.45.01.52.31-.65.59-1.32.85-1.98.05-.15-.04-.44-.02-.52m1.59 0a14.1 14.1 0 0 1-1.57 2.1c-.1.1.06.46 0 .53.61-.64 1.1-1.37 1.58-2.11.08-.12-.05-.47-.01-.52m3.26.62-.72 1.49c-.04.08-.02.24-.02.33 0 .02.02.2.03.18l.73-1.48c.04-.09.02-.24.02-.33 0-.02-.02-.21-.04-.19m1.46-1.48c-.63 1.4-1.3 2.77-2.3 3.95-.1.11.07.45 0 .53 1-1.18 1.68-2.57 2.31-3.97.06-.14-.04-.44-.01-.51m30.16-10.29a2.4 2.4 0 0 0-.73.88c-.05.08-.02.24-.02.32 0 .02.02.22.03.2.17-.35.41-.64.72-.86.04-.04.02-.23.02-.27a4 4 0 0 0-.02-.27m-.35 5c1.87-1.19 2.78-3.68 2.8-5.84.01-.3-.04-.3-.05 0-.02 1.94-1.11 4.26-2.75 5.3-.1.06.04.5 0 .53m-14.43 2.94a7.63 7.63 0 0 1-2.3 2.1c-.1.06.05.5 0 .53a7.68 7.68 0 0 0 2.32-2.11c.08-.12-.05-.47-.02-.52m-3.87 6.84c3.06-.86 5.55-3.49 7.15-6.2.07-.12-.05-.45-.01-.5-1.6 2.69-4.1 5.3-7.14 6.17-.08.02 0 .53 0 .53m4.85 3.47a9.57 9.57 0 0 0 3.15-3.1c.08-.12-.04-.47-.01-.52a9.53 9.53 0 0 1-3.14 3.09c-.1.05.04.5 0 .53m6.77-4.5a37.17 37.17 0 0 1-6.17 6.56c-.1.09.05.48 0 .53a37.21 37.21 0 0 0 6.17-6.56c.1-.12-.06-.44 0-.53m1.84-.84c.37-.78.76-1.57 1.32-2.22.1-.12-.06-.46 0-.54-.57.67-.96 1.46-1.34 2.24-.06.14.05.45.02.52m5.08 4.82c1.05-1.93 2.02-4.03 3.62-5.56.1-.1-.06-.47 0-.53-1.6 1.54-2.58 3.64-3.64 5.58-.07.13.05.45.02.51m4.35-4.1c-1.07 1.21-2.26 2.32-3.27 3.59-.1.12.07.45 0 .53 1.01-1.27 2.2-2.38 3.27-3.58.1-.12-.06-.47 0-.54m12.36-2.2c.54-1.49.78-3.07.74-4.66 0-.37-.05-.03-.05.14.04 1.36-.25 2.74-.7 4-.06.15.04.44.01.52m-.74-4.58c-.35 1.58-.48 3.22-1.21 4.68-.07.13.05.45.01.51.74-1.47.88-3.14 1.22-4.73.02-.1-.01-.5-.02-.46m2.91-.12c-.23 1.53-.18 3.1-.72 4.56-.06.14.04.43.01.51.56-1.49.5-3.05.73-4.6.02-.11-.02-.51-.02-.47m1.55 1.4c-.03 1.52-.47 3-1.07 4.4-.06.13.05.43.02.5.65-1.5 1.07-3.1 1.1-4.76.01-.17-.04-.52-.04-.14m1.58.95c.16 3.05-1.22 6.1-3.13 8.38-.1.12.07.46 0 .53a13.19 13.19 0 0 0 3.17-9.18c-.01-.33-.05.18-.04.27m1.58.73c-.5 1.37-1.08 2.7-1.58 4.08-.05.14.05.43.02.51.5-1.37 1.08-2.7 1.57-4.08.06-.15-.04-.44-.01-.52m1.21-.75c-.34.92-.85 1.75-1.33 2.6-.07.13.05.46.02.52.48-.86.98-1.69 1.33-2.6.05-.15-.04-.44-.02-.52m.97 1.74c-.95 1.83-1.72 3.78-3.27 5.19-.1.09.06.47 0 .53 1.56-1.42 2.33-3.37 3.28-5.2.07-.14-.05-.46-.01-.52m1.09-.83a6.42 6.42 0 0 1-.6 1.95c-.07.12.05.45.01.51.35-.62.48-1.31.61-2 .03-.12.02-.25.01-.37 0-.02-.01-.2-.03-.1m1.71-.39c-1.05 2.08-2.46 3.9-3.76 5.81-.08.12.05.47.02.52 1.3-1.92 2.7-3.74 3.75-5.82.07-.13-.05-.45-.01-.51m7-5.38c.08.76-.31 1.6-.6 2.28-.05.14.05.44.02.51a6.4 6.4 0 0 0 .62-3.17c-.02-.2-.05.31-.04.38m-.45 7.74a19.6 19.6 0 0 0 3.39-7.7c.02-.1-.02-.5-.03-.46a19.48 19.48 0 0 1-3.38 7.65c-.08.11.04.47.01.51m5.42-8a4.61 4.61 0 0 1-.7 2.42c-.08.12.04.46.01.51.53-.85.73-1.78.74-2.78 0-.17-.04-.52-.05-.15m-10.38 7.6c-1.2 1.36-2.27 2.8-3.4 4.21-.09.12.07.45 0 .53 1.13-1.4 2.2-2.85 3.4-4.2.1-.12-.07-.46 0-.54m1.68.89a156.62 156.62 0 0 1-3.87 5.18c-.1.13.07.45 0 .53 1.32-1.71 2.64-3.43 3.88-5.2.09-.12-.04-.47 0-.52m.84 2.33-1.7 1.36c-.1.09.06.5 0 .54l1.7-1.36c.1-.09-.06-.5 0-.54m16.11-8.03c-.47.7-1.1 1.25-1.7 1.85-.1.1.07.46 0 .53.6-.6 1.23-1.16 1.71-1.87.08-.11-.05-.46-.01-.51m.62 2.88c.9-.64 1.21-1.84 1.23-2.92 0-.17-.04-.51-.05-.14-.02.94-.41 1.98-1.18 2.53-.1.07.05.5 0 .53m-7.07 3.87c0 .44-.1.91-.34 1.3-.05.07-.02.24-.02.32 0 .02.02.21.03.19.3-.5.37-1.1.38-1.67 0-.1.02-.23-.02-.33l-.03.19m2.1 4.28c.69-1.64 1.5-3.22 1.7-5.02.02-.07 0-.58-.03-.37-.2 1.75-1.02 3.29-1.68 4.88-.06.14.04.44.01.51m-.25-5.32c-.35.91-.85 1.74-1.33 2.6-.07.12.04.45.01.5.48-.85.98-1.68 1.33-2.6.06-.14-.04-.43-.01-.5m3-.3c.05 1.33-1.1 2.52-1.67 3.63-.07.13.04.45.01.52.74-1.44 1.77-2.58 1.71-4.29-.01-.38-.05-.03-.05.14m.89 4.5c.43-.9 1.05-1.72 1.21-2.74.02-.12.02-.24.01-.37 0-.01-.02-.2-.03-.1-.16 1-.79 1.82-1.2 2.7-.07.14.04.45 0 .52m3.5-9.66a20.65 20.65 0 0 0-1.7 3.59c-.05.14.05.43.02.5.49-1.23.98-2.46 1.7-3.58.07-.12-.05-.46-.02-.51m2.79 1.13a9.45 9.45 0 0 1-1.33 3.2c-.07.11.05.46.02.5a9.59 9.59 0 0 0 1.34-3.24c.02-.1-.02-.5-.03-.46m2.18.96a15.3 15.3 0 0 1-1.46 3.47c-.07.12.05.46.02.51a15.4 15.4 0 0 0 1.45-3.46c.04-.15-.04-.43-.01-.52m1.83 6.09c.6-.9.5-1.94.5-2.98 0-.3-.05-.3-.05 0 0 .88.03 1.72-.46 2.47-.08.12.04.46.01.51m2.4-2.23c-.1 2.12-1.73 3.82-3.01 5.34-.09.1.06.41 0 .48 1.36-1.62 2.95-3.34 3.05-5.58 0-.08-.03-.54-.04-.24m-7.01 2.08c-.49.5-.98.99-1.57 1.36-.1.07.04.5 0 .54.59-.38 1.08-.87 1.57-1.37.05-.04.03-.2.03-.26l-.03-.27m3.26-.38a21.93 21.93 0 0 0-2.78 2.85c-.1.12.07.46 0 .54.87-1.02 1.75-2.01 2.79-2.85.1-.09-.06-.49 0-.53m10.51-5.81c0 .3-.02.58-.1.87-.03.1-.02.22-.02.32l.03.19c.14-.45.14-.9.14-1.37 0-.02 0-.27-.02-.27-.03 0-.03.25-.03.27m1.46-1.35a5.05 5.05 0 0 1-1.08 3.2c-.08.11.05.47.02.51a5.98 5.98 0 0 0 1.1-3.98c-.02-.32-.05.18-.04.27m2.44 1.09a68.63 68.63 0 0 0-2.06 4.2c-.06.15.04.45.01.52a70.68 70.68 0 0 1 2.06-4.2c.07-.13-.04-.46-.01-.52m1.8 1.31a9.95 9.95 0 0 1-1.2 3.65c-.07.12.05.45.01.51.64-1.2 1.08-2.43 1.23-3.78 0-.07-.02-.59-.04-.38m2.56.92-2.55 4.82c-.07.13.05.45.02.52l2.54-4.83c.07-.13-.05-.45-.01-.51m1.45 2.47a24.76 24.76 0 0 1-2.41 4.2c-.1.12.06.44 0 .53a24.8 24.8 0 0 0 2.42-4.22c.07-.13-.04-.44 0-.51m2.18 1.98c-1.22 1.4-2.1 3.1-3.51 4.33-.1.09.06.48 0 .53 1.4-1.23 2.3-2.93 3.51-4.33.1-.11-.06-.46 0-.53M767.31 484c.47-.16.87-.37 1.13-.8.27-.47.43-.91.8-1.3.11-.11-.06-.47 0-.53-.33.35-.53.74-.74 1.18-.25.5-.67.75-1.19.92-.08.03.01.53 0 .53m3.49-2.44c-.04 1-.78 1.78-1.32 2.54-.08.11.05.47.02.52.65-.93 1.3-1.73 1.35-2.91 0-.17-.04-.52-.05-.15m1.58.75c-.06 1.4-1.29 2.41-2.16 3.34-.09.1.06.4 0 .46 1.01-1.08 2.14-2.08 2.2-3.67 0-.15-.03-.45-.04-.13'/%3e%3cpath d='M785.83 475.13c-.22 1.98-1.91 3.38-3.02 4.88-.09.12.07.44 0 .53 1.15-1.57 2.82-2.97 3.05-5.03 0-.07-.01-.59-.03-.38m.63 4.91a10.1 10.1 0 0 0 2.06-3.35c.06-.14-.04-.44-.01-.51a10.03 10.03 0 0 1-2.05 3.33c-.1.1.06.47 0 .53m3.86-3.86a22.53 22.53 0 0 1-2.54 4.2c-.08.12.04.47 0 .52.96-1.34 1.9-2.68 2.55-4.2.06-.15-.04-.45-.01-.52m2.67.12c-1.09 1.36-2.13 2.75-3.4 3.95-.1.1.07.48 0 .54 1.27-1.2 2.31-2.6 3.4-3.96.1-.12-.07-.45 0-.54m1.7.51a11.34 11.34 0 0 1-1.34 2.97c-.07.12.05.46.02.51.56-.93 1.05-1.9 1.33-2.97.04-.15-.04-.42-.01-.51m-2.55 5.31c-1.18 1.53-2.9 2.42-4.6 3.22-.1.05.03.52 0 .53 1.7-.8 3.42-1.69 4.6-3.21.1-.13-.06-.45 0-.54m-7.51 1.64c.77-.57 1.67-.9 2.55-1.23.08-.04-.02-.53 0-.54-.88.34-1.78.67-2.55 1.24-.1.08.06.5 0 .53m10.06-1.64c-.69 1.19-1.88 1.94-3.03 2.6-.1.05.04.5 0 .53 1.16-.66 2.35-1.42 3.04-2.61.07-.13-.05-.46-.01-.52m-36.23-15.45c-.66 1.13-1.82 1.71-3.02 2.09-.08.03.01.53 0 .53 1.2-.38 2.37-.97 3.04-2.11.07-.12-.05-.46-.02-.51m-48.81 4.68c.27 1.78-.79 3.26-1.93 4.45-.1.11.07.47 0 .54 1.47-1.54 2.28-3.3 1.95-5.45 0-.05-.04.35-.02.46m-52.8-8.9a41.5 41.5 0 0 1-4.85 2.85c-.1.05.04.51 0 .53 1.67-.86 3.3-1.77 4.85-2.85.1-.07-.05-.5 0-.53m-7.27-.75a13.64 13.64 0 0 1-3.76 3.1c-.1.05.04.5 0 .53a13.56 13.56 0 0 0 3.76-3.1c.1-.11-.06-.46 0-.53'/%3e%3c/g%3e%3cpath fill='url(%23e)' d='M722.72 507.13h.01c.04 0 .06-.02.05-.02l-.06.02m.9-.18 4.14-.9c-1.48.3-2.96.6-4.13.9m4.86-1.07-.73.17c3.02-.6 6.04-1.14 6.46-1.42-.06 0-2.9.63-5.73 1.25m5.73-1.25zm-60.41-33.45c-1.12.74-5.52 2.69-7.82 3.83-2.3 1.14-2.36 3.42-1.58 3.83.8.4 6.05 3.62 6.44 4.22.4.6-2.23 1.74-2.54 1.92-.3.18-.15.9-.15.9 2.78 3.81 13.55 4.03 11.82 5.26-1.72 1.21-4.87 1.01-2.71 3.15a39.23 39.23 0 0 0 7.35 5.5c3.23 1.65 3.06 3.03 3.77 3.77 1.46 1.49.62 1 2.6 1.94 2 .95 4.25 1.63 2.66 2.3-1.6.69-3.58.42-5.44 1.23-1.86.81-.66.95-3.45 1.35-2.79.41-3.45.41-4.11.41-.67 0-.27-.27-2-.27-1.72 0 .4-.13-3.05 0-3.05.12-8.9-1.35-10.21-1.69 1.43.38 8.19 2.16 10.08 2.64 2.12.54 1.99.27 3.72.82 1.72.54 3.31.67 4.5 1.08 1.2.4 2 .95 2.93 1.76.93.81 1.06 1.09 1.72 1.22.67.14 2.53.82.67 1.5-1.86.67-.67 1.08-2.66 1.08-1.99 0-3.05.13-3.05.13s-2.26.41-3.18.14c-.93-.27-2.13-1.08-2.13-.27s.4 1.08-.8 1.08c-1.19 0-2.91-.67-2.91-.67s-.8.54-2.8.67c-.99.07-1.42.07-1.86.07-.45 0-.92 0-1.98.07-.77.05-1.35.03-1.8 0-.77-.04-1.13-.07-1.38.27-.4.54 2.12 1.22-1.47.68-3.58-.54-2.25-.54 1.6.68 3.85 1.22 1.06 0 5.7 1.35 4.65 1.36 1.47.68 5.18 1.9s3.19.27 4.91 1.36c1.73 1.08 2.26.81 2.79 1.35.53.54 1.2-.27 1.46 1.09.27 1.35 1.72 2.7.53 2.98-1.2.27-1.06.4-2.65.27-1.6-.13-.67-.4-3.06-.54-2.38-.14-4.11-.27-4.11-.27s-1.6.13 0 .95c1.6.81-.13 1.63-1.6 2.17-1.45.54-2.52.68-3.18.81-.66.14.13 0-2.39.68s-1.99.95-3.58 1.63c-1.6.67-2.12.67-3.85 1.08-1.72.4-1.6.27-3.05.54-1.46.27-2.39.41-3.32.55-.93.13-1.6.13-1.6.13s3.06 9.76 10.76 19.52c7.7 9.77 25.48 28.61 43.8 30.5 18.3 1.9 31.31 1.23 41.27-4.46 9.95-5.7 23.49-14.37 32.25-28.88 8.76-14.5 9.4-16.57 9.4-16.57s-1.82-.82-3.22-.51c-1.4.31-1.4-2.58-3.53-2.58s-2 .95-4.65-.27c-2.65-1.22-1.85-1.63-3.98-1.77-2.12-.13-6.23-1.9-6.23-1.9s-3.05-.8-5.18-.94c-2.12-.14-2.92-.27-6.24-1.5-3.32-1.21-4.38-1.08-5.44-1.48-1.06-.41-2.26-.68-3.05-1.22-.8-.55-2.79-1.5-.26-3.4 2.51-1.9 3.45-2.98 4.37-3.52.93-.54 2.92-1.76 4.65-1.9 1.72-.13 1.86-.54 4.38-.54 2.52 0-1.33-1.09-3.85-.95-2.52.13-2.52.54-4.78.54-2.26 0-.93-.13-6.63.27-5.71.4-2.26 0-6.64-.13-4.38-.14-3.45.13-7.3-.68s-2.25-.27-6.37-.81-4.11-.68-5.97-1.63c-1.86-.95-3.05-1.22-4.12-1.5-1.06-.26-1.85-.53-.8-1.35 1.07-.81 5.15-3.92 6.07-4.47a9.9 9.9 0 0 1 2.15-.73 33.7 33.7 0 0 1-1.34.28c-.7.12-2.2.23-4.75-.1-4.25-.54-5.3-.8-7.03-1.21-1.73-.41-3.45-1.5-7.83-1.63-4.38-.14-2.92-.55-4.78-1.9-1.86-1.36-3.05-2.17-3.58-2.98a5.18 5.18 0 0 0-2.92-2.3c-3.85-1.23-7.44-4-6.9-4.62.93-1.08 2.26-1.65.66-2.98-1.63-1.35-10.82-2.95-13.4-3.76 0 0 .06-.44.2-.49.58-.2 1.91-.56 2.9-1.25 1.25-.87 0-1.41-1.51-2.22-2.06-1.1-5.59-2.68-7.16-3.82-1.64-1.19 1.7-3.22 5.06-4.7 3.35-1.48 11.75-8.73 13-9.87l-.06-.4s-9.26 7.45-10.38 8.18'/%3e%3cpath d='M684.26 463.26a120.91 120.91 0 0 1-6.62 5.52 65.81 65.81 0 0 1-4.24 3.1c-1.6 1.08-3.4 1.76-5.07 2.71-.91.52-2.55 1.39-2.58 2.64-.03 1.07 1.7 1.66 2.43 2.06 1.98 1.08 4.04 2.02 6.03 3.08 2.97 1.6-2.23 2.09-2.46 3.26 0 .03-.03.24 0 .25 4.22 1.28 8.95 1.47 12.93 3.45.52.26 1.4.9 1.1 1.62-.26.6-.98.86-1.29 1.4a.72.72 0 0 0-.02.54c.35.84 1.29 1.42 1.98 1.91a19.05 19.05 0 0 0 4.95 2.43c1.43.47 2.12 1.35 3.04 2.48.94 1.14 2.28 1.95 3.46 2.8.52.38.87.87 1.32 1.3.6.6 1.82.52 2.58.57 1.66.1 3.28.16 4.9.52 1.1.24 2.14.64 3.2.97 2.02.64 4.17.92 6.24 1.2 1.63.23 3.26.43 4.91.4.52-.02 1.24 0 1.74-.23.02-.01.01-.26 0-.27l-.08.02c-.03.02-.02.27 0 .27.5.08 1.26-.26 1.74-.36l3.9-.85 3.95-.88c.57-.12 1.33-.44 1.92-.4v-.28c-1.31.73-3.27.8-4.71 1.07-2.24.44-4.5.84-6.7 1.47-1.74.5-3.12 1.75-4.56 2.83l-2.58 1.96c-.4.3-.79.55-.76 1.1.04.66 1.67.8 2.14.93 1.42.37 2.74 1 4.05 1.67 2.08 1.06 4.57 1.19 6.84 1.42 2.2.23 4.3.56 6.5.98 2.24.44 4.54.24 6.81.38 1.26.08 2.37.27 3.65.2 2.26-.14 4.53-.43 6.8-.42 1.85.01 3.59-.24 5.43-.45a13.5 13.5 0 0 1 4.3.26c.4.08.83.18 1.19.39-.11-.07.1-.12-.23-.06-.46.08-.95.03-1.41.04-2.66.1-5.37.83-7.68 2.15-.84.49-1.54 1.1-2.28 1.73-1.17 1.01-2.8 1.88-3.63 3.2-1.84 2.9 6.63 4.22 8.17 4.68 2.68.8 5.09 1.86 7.9 2.05 1.91.13 3.97.46 5.76 1.2 1.08.43 2.19.82 3.3 1.16 1.2.36 2.46.33 3.63.7.94.28 1.82 1.13 2.7 1.55 1.25.6 2.17.67 3.46.39 1.14-.25 2.12-.13 2.9.8.5.63.85 1.79 1.82 1.66.74-.09 1.4-.04 2.13.14.43.1.94.53 1.08.11l-.07.16c-.82 1.97-1.96 3.82-3 5.67-3.42 6.03-6.83 12.21-11.15 17.63a77.85 77.85 0 0 1-14.85 13.95 99.14 99.14 0 0 1-14.51 9.06c-5.08 2.52-10.72 3.64-16.3 4.12-7.17.62-14.4.16-21.55-.52-6.6-.64-12.62-2.84-18.36-6.2-10.28-5.99-19.16-14.73-26.6-24.06a69.56 69.56 0 0 1-11.04-19.83c0-.03-.02-.06-.03-.08.13.4.34.24.76.21 2.8-.2 5.65-.85 8.39-1.44 1.24-.27 2.48-.63 3.58-1.3a13.33 13.33 0 0 1 3.5-1.38c1.99-.55 4.04-.88 5.92-1.76.49-.23 1.07-.56 1.06-1.18-.02-.62-1.8-1.16-.91-1.4.64-.17 1.47.05 2.12.1 1.34.09 2.9-.06 4.19.45.67.27 1.45.27 2.17.28.39 0 1.85-.17 2-.55.34-.9-.54-1.9-.84-2.68-.33-.88-.24-1.12-1.18-1.23-.3-.04-.53-.36-.79-.49-.3-.16-.67-.23-1-.36-.84-.31-1.53-.92-2.37-1.22-.48-.16-1.02-.14-1.51-.21a12.97 12.97 0 0 1-4.53-1.47c-1.26-.76-2.9-1.04-4.3-1.42-.92-.25-1.84-.29-2.75-.5-1.81-.43-3.57-1.08-5.39-1.52v.26c.58.06 4.06.92 4.06.35 0-.24-.18-.33-.34-.48-.66-.6 1.94-.44 2.14-.44 1.21.01 2.44-.07 3.66-.1 1.25-.04 2.65-.1 3.79-.7.49-.26 3.88 1.62 3.86.17 0-.35-.17-.9.27-.97.51-.07 1.3.46 1.78.62.94.32 2.2.03 3.15-.13.85-.14 1.75-.12 2.6-.13.57-.01 1.26.09 1.76-.21.5-.29.81-.65 1.38-.88 1.83-.74.1-1.56-.92-1.83-.56-.15-1.06-.78-1.47-1.15a9.88 9.88 0 0 0-1.84-1.3c-1.55-.86-3.44-.97-5.12-1.41-4.83-1.27-9.7-2.39-14.54-3.66 0 0-.04.25 0 .26 1.73.47 3.48.86 5.24 1.2 2.48.47 4.8.46 7.31.5 1.12.03 2.24.35 3.34.33.95 0 1.9-.15 2.85-.27 1.05-.14 2.34-.15 3.22-.84 1.07-.83 2.44-1.1 3.74-1.28.6-.08 3.29-.16 3.38-1.06.03-.32-.07-.48-.3-.69-1.07-.97-2.86-1.34-4.14-2-1.45-.76-1.95-2.69-3.1-3.78-1.07-1-2.5-1.55-3.71-2.33a42.5 42.5 0 0 1-3.91-2.93c-.58-.47-3.04-2.23-2.21-3.02.79-.76 2.23-.85 3.15-1.45.48-.31.07-.76-.27-.91-1.63-.72-3.56-.9-5.26-1.35-2.05-.55-4.29-1.24-5.86-2.76-1.55-1.5 2.32-1.73 2.32-3.07 0-.32-.28-.48-.5-.65-.86-.7-1.82-1.27-2.75-1.87-.88-.56-1.77-1.1-2.66-1.63-.23-.14-.48-.26-.7-.4-.9-.6.05-2.1.52-2.64.85-.97 2.4-1.44 3.53-1.97 1.37-.65 2.74-1.28 4.09-1.95 2.24-1.12 4.15-2.88 6.1-4.43 1.9-1.5 3.77-3 5.65-4.51.05-.04-.03-.25 0-.27-2.7 2.17-5.39 4.32-8.1 6.46a22 22 0 0 1-3.65 2.48c-1.24.63-2.5 1.2-3.76 1.8-1.3.6-2.8 1.11-3.86 2.12-.56.54-1.37 2.28-.62 3.06.44.47 1.22.76 1.77 1.1 1.06.64 2.1 1.3 3.14 2 .31.2 1.98 1.07 1.59 1.54-.57.7-1.62 1.01-2.38 1.43-.25.13-.22.64-.2.86.07.7.84 1.17 1.37 1.54 1.82 1.29 4.15 1.84 6.27 2.36.91.22 1.83.42 2.74.65.5.12 1.19.23 1.6.6.12.11-2.19 1.07-2.49 1.18-.53.2-1.06.44-1.08 1.08-.02.54.4.95.74 1.3.96 1.03 2.12 1.9 3.21 2.75 1.16.9 2.36 1.74 3.62 2.48 1.34.78 2.66 1.41 3.52 2.77.42.66.7 1.19 1.25 1.77a6.03 6.03 0 0 0 2.13 1.45c.79.37 1.6.7 2.38 1.1 1.1.54.3.96-.49 1.19-1.76.5-3.54.37-5.22 1.23-.64.32-1.04.72-1.77.9-1.39.32-2.86.46-4.28.57-1.15.08-2.22-.23-3.37-.25-1.05-.01-2.1.01-3.16.01-3.33 0-6.77-.9-9.97-1.77v.27c3.6.95 7.2 1.94 10.8 2.83 2.8.69 5.85.94 8.52 2.08 1.36.57 2.22 1.77 3.44 2.53.38.23.93.27 1.35.45 1.18.51-.46 1-.92 1.24-.32.16-.5.47-.8.64-.52.32-1.5.13-2.07.14-.8.02-1.62.05-2.41.17-1.06.17-2.2.34-3.23-.01-.44-.15-1.8-1.03-1.82-.07 0 .2.02.4.04.6.08.62-1.21.36-1.51.33-.77-.1-1.8-.8-2.51-.48-1.17.56-2.58.57-3.84.6-1.36.04-2.74.13-4.1.09-.45-.02-2.14-.12-1.58.83.08.14.24.25.36.36.12.1.08-.08-.06-.06-.19.02-.4-.02-.6-.04-1.1-.1-2.18-.4-3.28-.5 0 0-.03.26 0 .26 1.99.48 3.98 1.41 6 1.64 1.98.22 3.93.82 5.8 1.5 1.57.57 3 1.29 4.66 1.67.67.16 1.36.14 2.02.32 1.07.3 1.97 1.1 3.04 1.45.38.12.62.32.93.55.5.36.8-.15 1.18.57.31.6.45 1.35.77 1.99.51 1-.12 1.09-.94 1.3-.88.24-2 .18-2.86-.11-1.26-.43-2.6-.39-3.9-.47-.34-.03-3.03-.59-2.97.35 0 .18.01.17.13.33.2.26.67.43.94.6.7.44-.61 1.1-.77 1.18-1.39.75-2.96 1.02-4.48 1.34-1.05.21-2.11.59-3.13.9-1.46.45-2.67 1.44-4.15 1.9-1.56.48-3.21.75-4.82 1-1.85.26-3.7.76-5.57.78-.02 0-.01.24 0 .27 3.08 9.78 9.33 18.36 16.1 25.82 8.5 9.38 18.75 18.3 30.76 22.47a40.95 40.95 0 0 0 9.66 1.94c3.8.36 7.63.62 11.45.72 6.24.16 12.57-.17 18.66-1.72 5.28-1.34 9.9-3.98 14.52-6.84a98.27 98.27 0 0 0 15.2-11.42 69.1 69.1 0 0 0 9.52-10.91c2.82-4.02 5.23-8.38 7.68-12.64 1.14-1.98 2.27-3.96 3.3-6 .22-.42.47-.86.62-1.32 0-.03.03-.24 0-.26-1.02-.45-2.13-.68-3.22-.51-.94.15-1.36-1.03-1.83-1.66-.73-1-1.78-1-2.89-.8a5.1 5.1 0 0 1-3.45-.4c-.96-.41-1.75-1.16-2.7-1.55-.48-.2-1.04-.18-1.54-.23-.7-.06-1.4-.27-2.1-.46-1.67-.48-3.23-1.27-4.93-1.67-2.46-.58-5.02-.54-7.46-1.2-2.6-.71-5.08-1.7-7.72-2.29-1.23-.27-2.6-.75-3.68-1.4-.34-.21-.68-.44-.98-.7-1.2-1.02.34-2.14 1.12-2.74 2.14-1.62 3.9-3.36 6.36-4.48 1.24-.56 2.52-.6 3.82-.88.52-.11 1.03-.2 1.56-.25.65-.06 1.42.1 2.04-.13.1-.03.05-.27.04-.34-.11-.49-2.21-.64-2.56-.69-2.56-.35-5.02.47-7.57.44-1.4-.02-2.77.05-4.17.15-1.9.13-4.04.59-5.93.2-2.06-.44-4.25-.18-6.34-.3-2.2-.12-4.32-.96-6.53-1.1-2.4-.15-4.9-.3-7.2-.99-1.03-.3-1.97-.91-2.94-1.36-.77-.36-1.58-.63-2.4-.86-.55-.15-2.78-.41-1.51-1.39 1.94-1.49 3.86-3.1 5.94-4.38.72-.44 1.65-.6 2.44-.8 1.37-.34 2.76-.62 4.15-.9 1.34-.26 2.68-.5 4.01-.78.68-.14 1.52-.22 2.14-.56.03-.02.02-.27 0-.27-.54-.03-1.21.26-1.73.37l-3.9.85c-1.31.3-2.63.59-3.95.87-.53.12-1.38.49-1.93.4v.28c.02-.01.05-.03.07-.02v-.27c-.42.2-1.02.18-1.47.2-1.73.12-3.46-.14-5.17-.37-2.09-.28-4.2-.6-6.24-1.2-.97-.29-1.9-.65-2.89-.9-1.71-.44-3.46-.52-5.21-.6-.8-.03-1.81 0-2.5-.49-.53-.36-.88-.98-1.4-1.37-1.12-.85-2.35-1.59-3.32-2.63-1.05-1.14-1.63-2.1-3.18-2.66a22.85 22.85 0 0 1-4.64-2.22c-.55-.35-1.08-.75-1.57-1.19a4.92 4.92 0 0 1-.48-.5c-.4-.48.18-.85.5-1.17 3.1-3-5.58-4.4-7.03-4.74-1.78-.42-3.57-.8-5.35-1.23a23.4 23.4 0 0 1-.93-.25c-.24-.07 1.13-.63 1.19-.65.75-.27 2.11-.69 2.28-1.6.22-1.12-2.23-1.87-2.94-2.23-2.1-1.08-4.61-1.96-6.43-3.51-1.46-1.26 5.14-4.2 5.76-4.52 1.63-.84 3.12-2 4.58-3.1 2.72-2.05 5.39-4.22 7.91-6.52.06-.04-.02-.23 0-.26m-41.7 4.63c-.6.96-1.38 1.78-2.17 2.58-.1.1.06.47 0 .54.8-.82 1.58-1.64 2.19-2.61.07-.12-.05-.46-.02-.51m1.09 1.11c-.5.79-.96 1.6-1.33 2.47-.06.14.04.44.01.52.37-.87.83-1.69 1.34-2.48.07-.12-.05-.46-.02-.51'/%3e%3cg fill='%234f91c5'%3e%3cpath d='M702.98 507.39c.93-.66 1.78-.36 2.8-.1.93.22 1.67.07 2.54-.29.05-.02-.01-.26 0-.27-.89.37-1.6.48-2.54.28-1.03-.21-1.85-.56-2.8.11-.05.04.02.25 0 .27m1.51 1.21c.24-.6 1.13-.44 1.63-.44.02 0 .02-.26 0-.26-.51 0-1.4-.17-1.64.45-.02.07.03.22.01.26m-2.9-2.12c1.02-.67 2-.5 3.14-.65.03 0 .01-.26 0-.26-1.13.15-2.12-.03-3.14.64-.05.03.02.25 0 .27m-6.19 3.17c-2.21-.96-4.5.66-6.73-.26.01 0-.05.25 0 .27 2.24.92 4.52-.7 6.73.26-.01 0 .05-.25 0-.27'/%3e%3cpath d='M690.77 510.08c-1.32-.59-2.6.47-3.96.01.01 0-.04.26 0 .27 1.37.46 2.64-.6 3.96-.01-.01 0 .05-.25 0-.27m-2.64 1.03c-.99-.79-2.58-.08-3.7-.12-.03 0-.03.26 0 .26 1.12.04 2.71-.66 3.7.13-.03-.02.05-.23 0-.27m4.03 56.03c-1.08.42-3.27.58-4.16-.34-1.17-1.21-2.4-.54-3.9-.37-.03 0-.01.26 0 .26 1.23-.13 2.76-.89 3.74.19.97 1.06 3.07 1.02 4.32.53.04-.02-.02-.26 0-.27m-18.08-31.06c2.16-1.25 4.32.4 6.57-.27.04 0 0-.26 0-.26-2.25.66-4.4-.99-6.57.27-.05.03.02.25 0 .26m-18.53 4.84c.9-.34 1.67-.48 2.6-.2.85.27 1.61.66 2.5.8 2.22.33 4.52-.55 6.73-.6.02 0 .02-.27 0-.27-2.26.06-4.46.79-6.72.6-.88-.08-1.7-.49-2.51-.79-.9-.33-1.74-.13-2.6.2-.04 0 .01.26 0 .26m2.23 2.41c2.46-.98 5.09.04 7.62-.53.03-.01 0-.27 0-.27-2.53.57-5.16-.45-7.62.53-.05.02 0 .27 0 .27m20.89-8.99c2.18-.86 4.2-.31 6.44-.27.02 0 .02-.27 0-.27-2.25-.04-4.26-.6-6.44.27-.04.02.01.26 0 .27m6.96-2.24c1.32-.2 2.49-.25 3.81-.04.01 0 .03-.27 0-.27-1.32-.2-2.49-.15-3.8.04-.04 0-.02.27 0 .27m-22.6 18.35c2.69-1.51 5.67.95 8.28-.67.05-.03-.03-.25 0-.26-2.61 1.61-5.6-.85-8.28.67-.05.02.02.25 0 .26m2.23 2c1.79-.38 3.59-.67 5.39-.94.03 0 0-.26 0-.26-1.8.26-3.6.55-5.39.94-.03 0 0 .26 0 .26m5.78-6.71c1.72-.95 4 .17 5.39-1.47.05-.06-.03-.23 0-.27-1.4 1.64-3.67.53-5.39 1.48-.05.03.02.25 0 .26m8.68 9.54c1.94-1.49 4.43.05 6.44-1.21.05-.03-.03-.25 0-.27-2 1.26-4.5-.27-6.44 1.21-.05.04.03.25 0 .27m-.67-4.97c1.3-.18 2.64-.62 3.94-.31 1.25.3 2.2 1.15 3.55 1.12.03 0 .02-.27 0-.27-1.17.02-2.12-.56-3.18-1-1.37-.55-2.91 0-4.3.2-.03 0-.01.26 0 .26m1.31 15.04c1.99-.96 3.81-.9 5.92-.4 1.82.42 3.02 1.17 4.46-.54.05-.06-.03-.23 0-.27-1.36 1.62-2.7 1.12-4.46.54a7.83 7.83 0 0 0-5.92.4c-.05.03.02.26 0 .27m18.4-5.77c2.2.43 4.02.16 6.1-.6 1.08-.4 2.12-.85 3.28-.96 1.07-.1 2.17.13 3.23.21.02 0 .03-.26 0-.26-1.07-.08-2.15-.24-3.23-.21-1.15.03-2.23.55-3.29.95a10.55 10.55 0 0 1-6.09.6s-.03.26 0 .27m14.58-1.08c1.73-.27 3.4-.76 5.17-.62 1.78.15 3.2 1.1 4.95.22.05-.03-.02-.26 0-.27-1.54.78-2.89.18-4.47-.13-1.9-.38-3.78.25-5.65.53-.03 0 0 .27 0 .27m13.94-.27c3.4-1.27 5.91 1.78 9.19 2.01.01 0 .02-.26 0-.26-3.28-.24-5.8-3.29-9.2-2.02-.04.02.01.27 0 .27m13.01.54c1.52-.5 2.94-.23 4.47.1 1.64.35 3.09.3 4.59-.5.05-.03-.02-.26 0-.27-1.51.82-2.94.84-4.59.5-1.54-.32-2.94-.6-4.48-.1-.04.01 0 .27 0 .27m10.91 1.34c2.45-1.38 5.02-.92 7.63-1.6.03-.02 0-.27 0-.27-2.61.69-5.18.22-7.63 1.6-.05.04.02.26 0 .27m-18.13 8.46c1.16-1 2.49-.95 3.92-.73 1.33.2 2.75.56 3.83-.48.05-.05-.03-.23 0-.26-1 .95-2.28.73-3.52.52-1.52-.25-2.98-.4-4.23.68-.05.05.03.24 0 .27m1.71 2.83c1.96-1.6 4.43-.92 6.57-2.02.05-.03-.02-.26 0-.27-2.14 1.1-4.6.42-6.57 2.02-.06.04.03.24 0 .26m24.3-6.31c2.24-.1 4.48.1 6.7-.27.03 0 0-.27 0-.27-2.22.38-4.46.17-6.7.27-.02 0-.02.27 0 .27m.79 2.55a5.68 5.68 0 0 1 2.53-.73c.78-.02 1.55.1 2.33.06.03 0 .02-.26 0-.26-.78.03-1.55-.06-2.33-.07-.9-.02-1.73.32-2.53.74-.05.02.02.25 0 .26m4.73-5.5c.72-.78 1.84-.47 2.76-.67.04-.01 0-.27 0-.27-.92.2-2.04-.1-2.75.67-.05.06.03.23 0 .27m-63.08 4.03c1.32-1.05 2.7-1.08 4.3-1 1.75.07 3.17-.22 4.5-1.42.06-.04-.02-.24 0-.26-1.34 1.2-2.75 1.47-4.5 1.4-1.6-.06-2.97-.04-4.3 1.01-.05.04.03.25 0 .27m1.32 1.47c2.06-1.6 4.65-.27 6.97-.94.03 0 0-.26 0-.26-2.32.66-4.91-.67-6.97.94-.05.04.03.24 0 .26m-3.03-5.23c3.03-1.7 6.83 1.76 9.46-.94.06-.05-.03-.24 0-.27-2.63 2.7-6.43-.75-9.46.94-.05.03.02.26 0 .27m10.13 12.88c1.23-.93 1.94-.47 3.28-.13 1.91.47 3.82.53 5.78.53a.65.65 0 0 0 0-.26c-1.78 0-3.54-.05-5.29-.42-1.5-.31-2.4-1.03-3.77.02-.06.03.02.24 0 .26m0 2.02c2.37-1.73 5.3.95 7.88.53.03 0 0-.27 0-.27-2.58.42-5.51-2.26-7.88-.53-.05.04.02.25 0 .27m-14.99-43.77c2.45-1.77 5.02.5 7.62-.4.05-.02 0-.27 0-.27-2.6.9-5.18-1.36-7.62.4-.05.04.03.25 0 .27m1.44 1.35c1.67-.44 3.34.3 5-.14.04 0 0-.27 0-.27-1.66.44-3.33-.3-5 .14-.03 0 .01.27 0 .27m-13.52 13.02c2.03-.9 4.02-.7 6.18-.67.02 0 .02-.27 0-.27-2.16-.02-4.14-.23-6.18.67-.05.02.01.26 0 .27m73.7 3.76c1.47-1.74 3.92-1.25 5.91-1.48.03 0 .01-.27 0-.27-2 .23-4.44-.26-5.9 1.48-.06.06.02.23 0 .27m-6.05 4.43c2.42-2.37 5.47-.34 8.28-1.48.04-.02-.01-.26 0-.27-2.8 1.14-5.86-.9-8.28 1.48-.05.05.03.24 0 .27m-59.38 3.88c1.55-2.05 3.85-1.43 6.04-2 .04-.02 0-.28 0-.28-2.19.59-4.49-.04-6.04 2.02-.05.06.03.22 0 .26m84.38-20.77c1.4-.3 2.71-.67 4.15-.55 1.47.12 2.7.27 4.09-.36.05-.02-.01-.26 0-.27-1.36.62-2.64.54-4.09.36-1.41-.17-2.78.25-4.15.55-.03 0 0 .27 0 .27m-1.1 2.52c.97-.2 1.87-.24 2.85-.28a4.76 4.76 0 0 0 2.18-.82c.05-.03-.02-.25 0-.26a5.3 5.3 0 0 1-1.95.8c-1.04.14-2.04.08-3.08.3-.03 0 0 .26 0 .26m-3.93-5.02c1.77-.83 4.52 1.04 5.79-.91.04-.06-.02-.23 0-.26-1.27 1.94-4.03.08-5.79.9-.05.02.01.25 0 .26m7.19 6.4c.98-.35 1.8-.6 2.84-.57.9.03 1.7.2 2.52-.27.05-.03-.03-.25 0-.27-.8.46-1.63.34-2.52.27-1.02-.07-1.88.23-2.83.57-.04.01 0 .26 0 .27m-13.33-7.03c1.7-1.97 4.7 1.07 6.73-.26.05-.03-.03-.25 0-.27-2.03 1.33-5.03-1.7-6.73.26-.05.06.03.23 0 .27m-3.45-.97c.6-1 1.91-.67 2.89-.75 1.1-.1 1.93-.74 2.7-1.5.05-.05-.03-.23 0-.26a4.63 4.63 0 0 1-2.7 1.49c-1 .14-2.27-.26-2.9.76-.04.06.02.23 0 .26m-50.95-21.99c1.62-.8 3.24.14 4.9-.27.04 0 0-.26 0-.26-1.66.4-3.28-.54-4.9.26-.05.02.02.25 0 .26m2.01 1.49c.82-.69 1.8-.03 2.7-.45.05-.02-.02-.26 0-.27-.9.42-1.88-.23-2.7.45-.06.05.02.24 0 .27m36.37 47.01c.88-.1 1.88.4 2.7-.07.06-.02-.02-.25 0-.26-.82.45-1.82-.04-2.7.06-.03 0-.01.27 0 .27m-64.05-41.55a7.18 7.18 0 0 0-4.09-.38c-.92.23-.86 1.15-1.98.8 0 .01-.04.26 0 .28 1.01.3 1.16-.43 1.98-.81 1.16-.54 2.96-.02 4.08.37 0 0 .05-.25 0-.26m-.81 1.41c-2.3-1.06-4.76-.13-7.17-.38-.02 0-.03.26 0 .26 2.4.25 4.87-.67 7.17.39-.02 0 .04-.24 0-.27'/%3e%3cpath d='M680.52 522.8c-1.19-.42-2.3-1-3.5-1.37-1.38-.42-2.9-.42-4.3-.75 0 0-.04.26 0 .27 1.27.3 2.55.45 3.84.64 1.38.2 2.65 1.02 3.96 1.48 0 0 .04-.25 0-.27m-5.03 24.82c1.62-2.07 4.02-.62 6.16-1.1.04 0 0-.26 0-.26-2.14.47-4.54-.98-6.16 1.1-.05.05.03.22 0 .26m.07 1.22c.78-.36 1.5-.83 2.39-.84.8-.01 1.6.53 2.39.64 0 0 .03-.26 0-.26-.83-.12-1.57-.53-2.4-.65-.81-.11-1.68.52-2.38.84-.05.02.01.26 0 .27m1.44 3.53c.49-.48.95-.63 1.59-.4.52.2.95.42 1.5.15.04-.03-.02-.26 0-.27-.54.27-.98.07-1.5-.14-.63-.25-1.11-.08-1.59.4-.05.05.03.23 0 .26m1.07-8.03c.6-.36 1.13-.34 1.77-.08.65.27 1.16.43 1.81.08.05-.03-.02-.26 0-.27-.59.32-1.08.23-1.68-.02-.68-.29-1.23-.37-1.9.02-.05.03.02.26 0 .27m-6.3-.77c1.05-.26 1.84.33 2.86.48.79.11 1.66-.4 2.43-.55.03 0 0-.27 0-.27-.82.16-1.6.58-2.43.55-1.05-.04-1.77-.75-2.86-.48-.03 0 0 .27 0 .27m15.17 14.33c1.28-1.34 3.1-.22 4.6-.96.04-.03-.03-.26 0-.27-1.5.75-3.32-.37-4.6.96-.05.06.03.24 0 .27m28.06 2c1.7-1.04 3.5-.32 5.34-.33.02 0 .02-.27 0-.27-1.85.01-3.64-.7-5.35.32-.05.04.02.26 0 .27m11.83-.31c2.17-.79 3.88 1.27 6.04.83.04 0 0-.27 0-.27-2.16.44-3.87-1.62-6.04-.83-.04.01.01.26 0 .27m14.9.37c1.75-.32 4.37 1.38 5.8-.13.04-.05-.04-.23 0-.26-1.43 1.5-4.05-.2-5.8.12-.03 0 0 .27 0 .27m10.39 1.35c.64-1.3 1.98-.74 3.12-.62 1.36.15 2.63.03 3.73-.86.06-.04-.02-.24 0-.26-1.23 1-2.63.98-4.13.82-1.08-.12-2.14-.52-2.73.66-.03.07.03.22.01.26m-48.44-.83c1.15-.06 2.13-.53 3.21-.9 1.2-.42 2.48-.03 3.64-.52.05-.02-.01-.26 0-.27-1.03.44-2.19.17-3.27.41-1.25.27-2.28.95-3.58 1.01-.03 0-.02.27 0 .27m7.86 10.53c1.82-2.12 4.64-.04 6.8-1.34.04-.03-.03-.26 0-.27-2.16 1.3-4.98-.77-6.8 1.35-.05.06.03.23 0 .27m2.52.71c1.73-.62 4.52.44 5.79-1.22.05-.06-.04-.22 0-.27-1.27 1.66-4.06.6-5.79 1.22-.04.02.01.27 0 .27m16.35 7.06c1.28-1.35 2.73-1.5 4.46-1.18 2.03.39 3.93.81 5.98.35.04-.01 0-.27 0-.27-1.88.43-3.66.13-5.52-.25-1.9-.39-3.49-.42-4.92 1.09-.05.05.03.23 0 .26'/%3e%3cpath d='M731.22 579.37c1.06-.73 2.2-1 3.46-.84.01 0 .03-.26 0-.26-1.26-.17-2.4.1-3.46.83-.05.04.03.25 0 .27m-34.86-22.39c.85-1.08 2.46-.44 3.57-.94.05-.02-.02-.26 0-.27-1.11.5-2.72-.14-3.57.94-.05.06.04.22 0 .27m6.12.09c.27-1.5 2.4-.72 3.36-1.34.05-.03-.02-.25 0-.26-1 .63-3.09-.19-3.37 1.37l.01.23m10.89-.98c-.87-.06-1.66-.38-2.54-.32-.98.07-1.93.55-2.86.84-.04 0 .01.26 0 .26.96-.3 1.87-.67 2.86-.83.86-.14 1.7.26 2.54.31.02 0 .03-.26 0-.26m3.88.48a10.1 10.1 0 0 1 3.45-.12c.97.12 2.01.68 2.97.53.03 0 0-.27 0-.27-.84.13-1.72-.31-2.56-.46a9.85 9.85 0 0 0-3.86.05c-.04 0 0 .27 0 .27m12.33.41c1.49-.16 3.03.32 4.28-.73.05-.05-.02-.25 0-.27-1.25 1.05-2.8.57-4.28.73-.02 0 0 .27 0 .27m8.05-.31c2.4-2.52 5.8.12 8.66-.73.04-.01 0-.26 0-.26-2.86.85-6.25-1.8-8.66.73-.05.05.03.23 0 .26m-52.17 0c1.12-.9 2.47-.9 3.77-1.35.04-.02 0-.27 0-.27-1.3.45-2.65.46-3.77 1.36-.05.04.03.24 0 .26m40.56.09c.96-1.39 2.6-1.46 4.07-1.86.04-.02 0-.27 0-.27-1.48.4-3.12.48-4.08 1.88-.04.05.03.23 0 .25m21.5-.82c.97-.99 2.34-.76 3.57-1.04.03 0 0-.26 0-.26-1.23.28-2.6.05-3.57 1.04-.05.05.04.23 0 .26m5.91-2.08c.89-.66 1.9-.63 2.95-.73.03 0 .02-.27 0-.27-1.05.1-2.06.08-2.95.73-.06.04.02.25 0 .27m0-2.81c.98-.29 2-.43 2.85-1.04.05-.04-.02-.25 0-.27-.85.61-1.88.75-2.85 1.04-.04.02 0 .27 0 .27m-72.13.83c1.12-.12 2.22-.48 3.36-.31 0 0 .03-.26 0-.27-1.14-.17-2.24.19-3.36.32-.03 0-.01.26 0 .26'/%3e%3c/g%3e%3cpath fill='%23fff' stroke='%23000' stroke-width='.46' d='M523.83 317.68s8.07-.73 7.67.65c-.39 1.38.4 1.38 2.57 1.38s8.09-.79 8.68.2c.6.98 6.31-.4 8.48-.8 2.17-.39 3.75-.39 4.93-.59 1.19-.2 3.36-.78 3.36 0s.59 2.57.59 2.57 2.56 2.17 4.34 2.17c1.77 0 2.37.6 2.76 1.18.4.6 0 1.78 1.58 1.38 1.58-.39.2.4 3.94-.98 3.75-1.38 2.17-.2 3.16-.99a4.34 4.34 0 0 1 3.95-.98c1.77.4 3.15 1.18 3.74.98.6-.2 1.98-.59 4.54.6 2.56 1.18 5.33 1.57 7.5 1.77s3.35.6 4.53 0 3.95-.6 4.74-.6-.8-.39 3.75.2c4.53.6 4.93.6 5.52 0s2.17-.98 2.96-1.18c.79-.2 1.18-1.18 1.97-.79.79.4 2.76 1.19 4.34 1.97 1.58.8 5.33 1.19 7.5.8 2.17-.4.79-.2 4.34.59 3.55.78 4.73.98 6.11.98s6.35-.59 6.35-.59l-1.81-.41c-2.17-1.78-1.18-.18-5.33-2.35s-2.36-1.38-8.48-2.76c-6.11-1.39-4.73-2.57-6.7-3.75-1.98-1.19-2.18 0-4.35 0-2.17 0-1.38-1.38-6.5-5.13-5.13-3.75-4.74-2.76-6.71-4.34-1.98-1.58-6.12-4.14-8.29-6.12-2.17-1.97-6.7-1.5-8.68-1.57-4.37-.15-6.04-4.31-9.86-3.48-1.72.38-4.74-2.25-9.08-3.23-4.34-.99-8.48 2.56-11.63 4.54-3.16 1.97-10.66 6.11-14.01 9.07-3.35 2.96-10.53 6.5-14.87 7.88s-7.47 1.35-7.47 1.35' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M690.58 437.7c-.63.42-1.32.69-2.03.93-.08.03.02.53 0 .53.71-.24 1.4-.5 2.03-.92.1-.07-.04-.5 0-.54m30.99 5.09c-2.4 1.3-4.26 3.39-6.56 4.85-.1.06.05.5 0 .53 2.3-1.46 4.16-3.55 6.56-4.85.1-.05-.04-.51 0-.53m.2-3.49a14.76 14.76 0 0 1-4.64 4.47c-.1.06.04.51 0 .54a14.85 14.85 0 0 0 4.65-4.49c.08-.11-.05-.47-.01-.51m-1.84-1.71a7.18 7.18 0 0 1-2.98 1.79c-.07.02 0 .53 0 .53 1.16-.3 2.1-1 2.98-1.79.1-.1-.06-.48 0-.53m.17 1.44c-1.31 1.35-2.55 2.87-4.29 3.67-.1.04.03.52 0 .53 1.74-.8 2.98-2.31 4.3-3.67.1-.1-.07-.47 0-.53m.87 6.89c-1.22 1.61-2 3.62-3.95 4.47-.09.04.03.52 0 .53 1.96-.85 2.73-2.85 3.95-4.47.09-.13-.07-.45 0-.53m-1.05 3.85c-.71.84-1.29 1.92-2.36 2.33-.1.03.02.52 0 .53 1.07-.4 1.65-1.49 2.36-2.33.1-.11-.06-.46 0-.53m.53 3.03c1.03.75 1.5 2.03 2.54 2.78-.05-.04.1-.46 0-.54-1.03-.74-1.5-2.02-2.54-2.77.05.04-.1.46 0 .53m2.27 5.46c.5.36.8.9 1.22 1.34l.03-.27c0-.05.02-.21-.03-.26-.42-.44-.72-.99-1.22-1.34l-.03.26c0 .05-.02.24.03.27m-34.6-15.93c-1.39 1.48-3 2.71-4.82 3.58-.1.05.04.52 0 .53 1.82-.86 3.43-2.1 4.82-3.58.1-.1-.06-.46 0-.53m-2.28 4.03c-2.22 1.93-4.88 3.02-7.62 3.94-.08.03.01.53 0 .53 2.74-.91 5.4-2 7.62-3.94.1-.09-.06-.48 0-.53m-3.68 4.04c-1.16 1.68-2.86 3.7-4.9 4.2-.07.02 0 .53 0 .53 2.05-.5 3.75-2.52 4.91-4.21.08-.12-.04-.47 0-.52m-12.53 1.79c-1.26.81-2.54 1.59-3.94 2.14-.09.03.02.52 0 .53 1.4-.55 2.68-1.32 3.94-2.15.1-.06-.04-.5 0-.53m-2.62-.89c-.33.1-.64.24-.97.36-.08.03.02.53 0 .53.33-.11.64-.26.97-.36.07-.02 0-.53 0-.53m19 3.4c-.66.39-1.3.8-1.92 1.25-.1.07.05.5 0 .53.62-.45 1.26-.86 1.92-1.25.1-.06-.04-.5 0-.53m24.09 1.08c-.93.43-1.84.9-2.72 1.43-.1.06.05.5 0 .53.88-.53 1.8-1 2.72-1.43.1-.05-.03-.52 0-.53m6.22-1.08c-.62.37-1.13.9-1.5 1.53-.04.08-.01.24-.01.33 0 .02.02.2.03.18.36-.63.87-1.14 1.48-1.5.1-.07-.04-.52 0-.54'/%3e%3cg fill='%23007638' opacity='.59'%3e%3cpath d='M658.31 514.56c-.1 1.21-.1 2.57.6 3.62-.03-.05.09-.4.01-.52a4.19 4.19 0 0 1-.57-2.73c0-.07-.02-.58-.04-.37m-.69 3.4c-.42-.64-1.15-1.54-1.1-2.36 0-.09-.03-.6-.05-.27-.06 1.23.48 2.15 1.13 3.15-.03-.05.1-.4.02-.52m-1.87-.49a10.7 10.7 0 0 1-2.21-6.13c-.02-.33-.05.18-.05.26.14 2.3.8 4.61 2.26 6.4-.07-.07.1-.4 0-.53m4.75.2c-.18-.2-.27-.42-.37-.65-.01-.03-.03.16-.03.18 0 .1-.03.24.01.33.12.24.2.48.38.67l.03-.26c0-.06.02-.22-.03-.27m1.21.19c-.22-.08-.43-.16-.55-.37-.02-.03-.03.17-.03.18 0 .09-.03.25.01.33.13.22.34.31.57.4-.02-.01.08-.51 0-.54m-9.4-1.14c-.77-1.53-.82-3.22-.9-4.9-.03-.34-.06.17-.05.26.1 1.77.13 3.55.94 5.16-.03-.07.08-.39.02-.52m1.36-14.18c.01.94.4 2.93-.8 3.25-.09.02 0 .53 0 .53 1.28-.34.87-2.8.85-3.78 0-.3-.05-.3-.05 0m-2.02 3.88c.26-.28.45-.6.57-.96.03-.1.02-.23.02-.33l-.03-.19c-.12.36-.3.68-.55.94-.05.05-.03.21-.03.27 0 .02.03.26.02.27m2.33 0c.77-.54.68-1.52.68-2.36 0-.3-.05-.3-.05 0 0 .71 0 1.38-.63 1.82-.1.08.05.5 0 .54m8.55-2.47c.29.7.08 1.56.08 2.3 0 .3.04.3.05 0 0-.9.24-1.96-.11-2.82.03.08-.08.37-.02.52m-7.53 2.56c1-.63 1.04-2.09.85-3.16 0-.04-.04.36-.03.46.15.82-.1 1.72-.82 2.17-.1.06.05.5 0 .53m6.8-.2c.21-.35.29-.73.3-1.14 0-.1.01-.23-.02-.32-.01-.02-.03.16-.03.18-.01.27-.13.54-.27.77-.04.07-.02.24-.01.32 0 .02.01.22.03.2m-3.83-4.18c.45 1.14-.16 2.65-.29 3.83 0 .07.01.59.04.38.17-1.49.85-3.25.26-4.72.04.07-.07.37 0 .51m5.32 4.01v-1.05c0-.02 0-.26-.02-.26-.03 0-.03.24-.03.26v1.05c0 .02 0 .26.03.26.02 0 .02-.24.02-.26m9.84 1.41c.61-.68.58-1.66.58-2.54 0-.3-.05-.3-.05 0 0 .73-.03 1.45-.53 2.01-.1.11.06.46 0 .53m-14.7-1.33c.93-1.12 1.04-2.53 1.14-3.93 0-.09-.02-.6-.05-.27-.09 1.32-.22 2.62-1.09 3.67-.1.12.07.45 0 .53m-2.42.19c1.66-.55.97-3.62.76-4.87 0-.05-.04.36-.03.46.2 1.18.75 3.39-.73 3.87-.08.03.01.53 0 .54m4.08-2.39c-.05.68-.13 1.44-.73 1.86-.1.07.05.5 0 .53.67-.47.72-1.37.77-2.12 0-.1-.03-.6-.05-.27m3.37 2.48c.3-.22.38-.5.4-.86 0-.1.02-.23-.02-.33a.8.8 0 0 0-.03.19c0 .18-.22.37-.35.47-.04.03-.02.22-.02.26l.02.27m-2.88 0a6.46 6.46 0 0 0 1.15-3.9c0-.17-.05-.52-.06-.14a5.84 5.84 0 0 1-1.09 3.5c-.09.13.07.45 0 .54m-9.85-.37c.1-.1.16-.18.2-.32.02-.12.01-.25 0-.37 0-.02 0-.2-.03-.1-.04.1-.1.18-.17.25-.05.05-.03.21-.03.27l.03.27m3.53 10.96c-.95-1.23-1.29-2.78-1.67-4.27.02.1-.05.37-.01.52.38 1.49.72 3.04 1.68 4.28-.07-.09.1-.4 0-.53m-3.25-.38a8.19 8.19 0 0 1-.74-1.52l-.03.19c0 .1-.02.23.02.33.18.54.45 1.03.74 1.52.01.02.03-.17.03-.19 0-.08.03-.25-.02-.33m12.06-.22c.03.35.1.69.2 1.02l.03-.19c0-.1.01-.22-.02-.33a4.52 4.52 0 0 1-.17-.88c-.01-.09-.03-.09-.04 0a1.8 1.8 0 0 0 0 .38m9.12 10.17c.06.62.46 1.06.75 1.58.02.03.03-.16.03-.18 0-.09.03-.25-.02-.33-.25-.46-.68-.9-.73-1.45 0-.09-.03-.09-.04 0v.38m-.06 1.83c-.48-.42-.67-1.02-.83-1.61.02.09-.06.36-.02.51.17.6.36 1.2.85 1.63-.06-.06.1-.45 0-.54m52.89-21.31c.94-.63 1.29-1.75 1.68-2.77.05-.14-.04-.43-.01-.5-.4 1-.74 2.12-1.67 2.74-.1.06.05.5 0 .53m2.34-.58c1.13-1.92.79-4.25.67-6.37-.02-.33-.05.18-.05.27.1 1.9.37 3.9-.63 5.59-.08.12.04.46 0 .51m49.39 6.2v-1.24c0-.02 0-.26-.02-.26-.03 0-.03.24-.03.26v1.24c0 .02 0 .27.03.27s.02-.25.02-.27m5.39.23c.09-.39.1-.78.1-1.18 0-.01.01-.26-.02-.26s-.02.25-.02.26c0 .25-.03.48-.08.72-.03.12-.02.25-.01.37 0 .02 0 .2.03.1m-4.47.68c.64-1.48.84-3.07.94-4.68.01-.09-.02-.6-.04-.27-.1 1.53-.3 3.03-.91 4.44-.06.14.04.44.01.51m3.09-.35c0-1.08.17-2.15.18-3.23 0-.3-.05-.3-.05 0-.01 1.08-.17 2.15-.19 3.23 0 .3.05.3.06 0m-1.32-.13c.56-2 1.1-3.97 1.13-6.07 0-.17-.04-.52-.05-.14-.04 1.97-.57 3.82-1.1 5.7-.04.15.04.43.02.51m-3.8-.05c0-.51.09-1.01.1-1.52 0-.02 0-.27-.03-.27s-.03.25-.03.27c0 .5-.08 1-.09 1.52 0 .01 0 .26.03.26s.02-.25.02-.26m2.68.53c.54-1.73.4-3.56.66-5.34.02-.1-.02-.5-.02-.46-.26 1.76-.12 3.58-.65 5.29-.04.15.04.43.01.51m-1.2.08c.2-.88.37-1.74.39-2.63 0-.17-.05-.52-.06-.15 0 .8-.19 1.55-.35 2.31-.03.12-.02.25-.01.37 0 .02 0 .2.03.1m2.05-.52c.02-1 .17-1.98.19-2.97 0-.17-.05-.51-.05-.14-.02 1.04-.18 2.07-.19 3.1 0 .31.05.31.05 0m-52.92-6.37a6.58 6.58 0 0 0 1.32-3.8c0-.18-.04-.52-.05-.15a6.1 6.1 0 0 1-1.27 3.41c-.1.13.06.45 0 .54m-2.32.47c.26-.52.54-1.03.84-1.53.04-.07.02-.24.02-.32 0-.02-.02-.22-.04-.19-.29.5-.58 1-.83 1.52-.05.09-.03.24-.02.33 0 .02.02.21.03.19m4.93-1.46c.1-.7.1-1.42.1-2.13 0-.02 0-.26-.02-.26s-.03.24-.03.26c0 .56 0 1.12-.08 1.67v.37c0 .01.02.2.03.1m2.13-.65c.36-1.42.57-2.87.85-4.3.02-.1-.02-.51-.03-.46-.27 1.41-.48 2.84-.83 4.24-.04.16.03.43.01.52m1.61-.93c0-.82.08-1.64.09-2.47 0-.3-.05-.3-.05 0 0 .83-.09 1.65-.1 2.47 0 .3.05.3.06 0m1.46-.59c.47-1.47.74-2.96.86-4.5 0-.08-.03-.6-.05-.26-.1 1.44-.38 2.86-.82 4.24-.05.15.04.43.01.52m2.04-.28c.54-.97.66-2.03.76-3.11 0-.07-.02-.59-.04-.38a7.31 7.31 0 0 1-.73 2.97c-.07.13.05.46.01.52m1.68.48c.62-.97.83-2.07.94-3.2 0-.08-.02-.6-.04-.38a6.64 6.64 0 0 1-.92 3.06c-.07.12.05.46.02.52m2.78-1.05c1-.86 1.66-1.97 2.06-3.24.04-.14-.04-.43-.02-.51a6.89 6.89 0 0 1-2.04 3.22c-.1.1.06.48 0 .53m3.82.08c.85-1.17.67-2.73.76-4.1 0-.1-.02-.6-.04-.28-.09 1.32.08 2.75-.73 3.87-.08.11.04.47.01.51m2.22-.84c1.15-.64 1.5-1.88 1.52-3.14 0-.17-.05-.51-.05-.14-.02 1.13-.46 2.2-1.47 2.75-.1.05.04.51 0 .53m-4.05.88c0-.43 0-.86.08-1.29.02-.12.01-.25 0-.36 0-.02-.01-.2-.03-.1-.1.58-.1 1.16-.1 1.75 0 .02 0 .27.02.27s.03-.25.03-.27m-5.68 1.23c0-.53 0-1.05.08-1.58.02-.11.02-.24.01-.36 0-.02-.02-.2-.03-.1-.1.68-.1 1.36-.11 2.04 0 .02 0 .26.02.26.04 0 .03-.24.03-.26m-2.73 1.31c.67-.63.68-1.59.77-2.45 0-.07-.02-.59-.04-.38-.09.82-.1 1.7-.73 2.3-.1.1.06.47 0 .53m-1.29.19c.38-.83.4-1.73.4-2.63 0-.3-.06-.3-.06 0 0 .74-.04 1.44-.36 2.12-.06.13.05.44.02.5'/%3e%3cpath d='M731.09 506.53v-1.33c0-.01 0-.26-.03-.26s-.03.25-.03.26v1.33c0 .02 0 .27.03.27s.03-.25.03-.27m-1.7.54c.48-1.43 1.1-2.8 1.4-4.3.02-.1-.02-.5-.02-.46-.3 1.47-.92 2.83-1.4 4.25-.04.14.05.43.02.51m9.58-2.94c.46-.98.65-2.03.76-3.1 0-.08-.02-.6-.04-.38a8.94 8.94 0 0 1-.73 2.97c-.06.13.05.44.01.51m1.95-.57c.1-.22.2-.44.28-.67.03-.1.02-.22.02-.32a.8.8 0 0 0-.03-.19 5.4 5.4 0 0 1-.28.67c-.04.08-.02.23-.02.32 0 .02.02.21.03.19m2.6-.48c.76-1.4.42-3.02.3-4.53-.02-.21-.05.3-.04.38.1 1.22.34 2.5-.27 3.63-.07.13.05.46.01.52m2.24-.28c.73-1.5.84-3.14.94-4.78.01-.09-.02-.6-.04-.27-.1 1.56-.22 3.11-.91 4.53-.07.14.04.45.01.52m-23.09 1.17c-.1.88-.55 1.7-.37 2.6.02.1.04-.08.04-.1 0-.11.01-.24-.01-.36-.06-.29.15-.71.22-1 .07-.25.13-.5.16-.77 0-.06-.01-.58-.04-.37m.03 3.49c.16-.7.27-1.4.46-2.1.04-.14-.04-.41-.02-.5-.18.69-.3 1.39-.46 2.09-.04.15.04.42.01.5m9.23-2.05v-1.05c0-.02 0-.26-.02-.26-.03 0-.03.24-.03.26v1.05c0 .02 0 .26.03.26s.02-.24.02-.26m3.53-.83c-.01-.9-.26-1.71-.48-2.57.02.1-.05.37-.01.52.18.72.43 1.43.44 2.19.01.37.06.03.05-.14m4.17-.73a9.7 9.7 0 0 0 1.12-3.54c.01-.1-.02-.5-.03-.46a9.61 9.61 0 0 1-1.1 3.49c-.08.12.04.45 0 .51m14.7 13.68c.54-1.01 1-2.06 1.4-3.14.05-.14-.05-.43-.02-.5-.39 1.07-.86 2.11-1.4 3.13-.06.12.05.45.02.5m3.25-.26a6.32 6.32 0 0 0 1.5-3.27c.01-.1-.02-.5-.03-.46a6.16 6.16 0 0 1-1.47 3.2c-.1.11.06.45 0 .53m2.69-.48a5.76 5.76 0 0 0 1.22-4.58c0-.05-.04.35-.02.46.2 1.35-.4 2.57-1.2 3.59-.1.12.07.45 0 .53m2.52-.67c.88-1.64.68-3.6.48-5.38-.03-.21-.05.3-.04.37.17 1.54.29 3.11-.45 4.5-.07.13.04.45.01.51m-6.34-1.05c.12.37.47.94 0 1.18-.09.06.05.52 0 .54.35-.18.34-.62.32-.97-.03-.44-.17-.85-.3-1.27.02.09-.06.37-.02.52m2.25 1.92c.52-.58.5-1.43.5-2.17 0-.02 0-.27-.03-.27s-.03.25-.03.27c0 .6-.03 1.18-.44 1.64-.1.1.06.46 0 .53m2.98-.59c.3-.73.47-1.47.48-2.27 0-.17-.04-.52-.05-.14 0 .66-.2 1.29-.44 1.9-.06.14.04.44.01.51m-6.03.42c0-.35 0-.68.08-1.01.02-.12.02-.25 0-.37 0-.02 0-.2-.03-.1-.1.49-.1.98-.1 1.47 0 .02 0 .27.02.27.03 0 .03-.25.03-.27m-2.61.89c.08-.44.17-.89.36-1.3.04-.09.02-.24.02-.33 0-.02-.02-.2-.03-.18-.2.42-.29.9-.38 1.35-.02.12-.02.25 0 .37 0 .01 0 .2.03.1m7.86-5.91c-.04 1.05-.66 2.01-.35 3.08-.03-.08.05-.36.01-.51-.13-.46.16-1.04.26-1.49.08-.31.12-.61.13-.94 0-.17-.03-.51-.05-.14m-3.31 2.4a9 9 0 0 1-.08-1.38c0-.02 0-.27-.03-.27s-.02.25-.02.27c0 .61 0 1.23.1 1.84.02.1.04-.08.04-.1l-.01-.36m2.05.38.28-2v-.36c0-.02-.01-.2-.03-.1l-.28 2v.36c0 .02.02.2.03.1m-1.39-.24c0-.43.02-.85.17-1.26.03-.1.02-.23.02-.33l-.03-.18c-.2.56-.2 1.18-.21 1.77 0 .02 0 .27.03.27s.02-.25.02-.27m4.38-.19c0-.46 0-.91-.1-1.37-.03-.1-.04.08-.04.1 0 .12-.02.25 0 .36.08.3.09.6.09.91 0 .02 0 .27.02.27.03 0 .03-.25.03-.27m-3.19 2.63c.21-.45.3-.93.3-1.42 0-.1.02-.23-.02-.33a.9.9 0 0 0-.03.19c0 .36-.1.72-.26 1.04-.04.1-.02.24-.02.33 0 .02.02.21.03.19m-2.86-2.51c0-.41-.09-.82-.1-1.23a.85.85 0 0 0-.03-.19c-.03.1-.02.23-.01.33 0 .41.08.82.09 1.23 0 .03.02.21.03.19.03-.1.02-.23.02-.33m30.49 11.51c.29-2.03 1.96-3.48 2.33-5.5.01-.11-.02-.51-.03-.47-.37 2.03-2.04 3.47-2.32 5.51-.02.1.01.5.02.46m1.31-.73c0-.56.2-1.06.63-1.42.1-.1-.06-.48 0-.54-.54.47-.67 1.13-.68 1.81 0 .17.04.52.05.15m-2.43.47c.26-.53.56-1.03 1.02-1.41.04-.04.02-.22.02-.27l-.02-.26c-.47.39-.77.9-1.03 1.43-.05.09-.02.24-.02.33 0 .02.02.21.03.19m3.44-.86c.36-1.17.47-2.37.57-3.58 0-.07-.02-.59-.04-.38-.1 1.17-.2 2.33-.55 3.45-.04.15.04.43.02.51m-4.11.15c-.05-.14-.07-.18-.07-.12 0-.1-.03-.09-.04 0v.38c.01.1.05.18.11.26l.03-.26c0-.07.02-.21-.03-.27m4.57.62a9.91 9.91 0 0 0 1.22-6.43c-.03-.2-.05.31-.04.38a8.52 8.52 0 0 1-1.2 5.54c-.07.12.05.46.02.51m-8.45-12.13c.1-.87.1-1.75-.1-2.6-.02-.1-.03.07-.04.1 0 .1-.01.24.01.36.14.58.16 1.16.1 1.76-.02.07 0 .59.03.38'/%3e%3cpath d='M790.66 524.75c.91-1.5.75-3.43.94-5.1.01-.08 0-.6-.03-.38-.2 1.65-.03 3.5-.92 4.96-.07.12.05.46.01.52m-18.89.5c-.04.37-.04.76.1 1.1.02.03.04-.16.04-.18 0-.1.02-.23-.02-.33-.02-.04-.09-.16-.08-.22v-.37c-.01-.1-.03-.09-.04 0m-52.51-20.64c1.1-.7 1.55-2 1.86-3.24.04-.15-.03-.42-.01-.51-.31 1.23-.75 2.51-1.85 3.22-.1.07.04.5 0 .53m51.52 21.77c0-.33.02-.7-.1-1.01-.02-.03-.04.16-.04.18 0 .1-.02.24.02.33.07.16.07.33.07.5 0 .02 0 .27.03.27s.02-.25.02-.27m1.87-.18v-2.38c0-.3-.05-.3-.05 0v2.38c0 .3.05.3.05 0m-53.23-25.56c-.1 1.13-.14 2.5-1.2 3.15-.1.07.05.51 0 .54 1.1-.68 1.13-2.15 1.23-3.31 0-.07-.02-.58-.03-.38m3.65 7.01a15.2 15.2 0 0 0 1.04-5.22c0-.17-.04-.52-.05-.15a14.1 14.1 0 0 1-1 4.85c-.05.14.04.44.01.52m-5.67-3.33c.17-.27.27-.56.37-.85.03-.1.02-.23.02-.33l-.03-.19c-.1.3-.2.59-.37.86-.05.07-.02.24-.02.32 0 .02.01.22.03.19m4.11 2.58v-.66c0-.01 0-.26-.02-.26-.03 0-.03.25-.03.26v.67c0 .02 0 .26.03.26s.02-.24.02-.26m-4.87-2.67a.37.37 0 0 0 .19-.1c.04-.04.02-.21.02-.27l-.02-.26a.37.37 0 0 1-.19.1c-.07 0 0 .53 0 .53m53.58-9c0-.35.04-.66.23-.97.04-.08.01-.25.01-.33 0-.02-.01-.21-.03-.18-.27.44-.26.98-.26 1.48 0 .02 0 .27.03.27s.02-.25.02-.27m15.44.38c.01-.46.12-.9.22-1.35a1.21 1.21 0 0 0 0-.5 8.27 8.27 0 0 0-.27 1.85c0 .02 0 .27.03.27s.02-.25.02-.27m-7.73.26c.6-2 .73-4.09.74-6.17 0-.3-.05-.3-.05 0-.01 1.91-.15 3.81-.7 5.65-.05.15.03.43 0 .52m-1.91-.02v-1.35c0-.02 0-.27-.02-.27-.03 0-.03.25-.03.27v1.35c0 .02 0 .27.03.27s.02-.25.02-.27m6.14.14c.14-.55.05-1.1-.12-1.63-.01-.02-.04.16-.04.19 0 .1-.01.22.02.32.06.18.17.41.12.6-.02.1-.02.22-.02.33 0 .02.03.2.04.18m-7.82-.62c.01-1.26.23-2.5.35-3.75 0-.07-.02-.59-.03-.38-.14 1.38-.36 2.74-.37 4.13 0 .3.04.3.05 0m5.64.38c.6-.94.62-2.07.73-3.15.01-.07-.01-.59-.03-.38-.11 1.04-.13 2.11-.71 3.01-.08.12.04.47 0 .52m-8.3-.15c.12-.65.12-1.31.24-1.96.02-.12.01-.25 0-.37 0-.02-.01-.2-.03-.1-.12.66-.12 1.32-.24 1.98-.02.11-.02.24 0 .36 0 .02 0 .2.03.1m5.3.23c.14-.6.14-1.22.14-1.83 0-.02 0-.27-.03-.27s-.02.25-.02.27c0 .46-.01.92-.11 1.37-.03.12-.02.25-.01.37 0 .01.01.19.03.1m-2.17.15c.5-1.37 1.18-2.66 1.45-4.1.02-.1-.02-.5-.03-.46-.26 1.43-.94 2.7-1.44 4.04-.05.14.05.43.02.51m-2.06-1c-.19-.31-.33-.68-.34-1.05 0-.02-.02-.21-.03-.19-.04.1-.02.23-.02.33.01.5.12.99.38 1.42.02.02.03-.17.03-.19 0-.08.03-.25-.02-.32m6.51.76c.11-.24.14-.5.25-.74.03-.1.02-.23.02-.33 0-.02-.03-.2-.04-.18-.1.23-.13.5-.24.73-.04.1-.02.24-.02.33 0 .02.02.21.03.19m5.18-2.09c.26.57.2 1.13.1 1.73v.37c0 .02.02.2.04.1.13-.9.26-1.87-.13-2.71.03.07-.08.38-.01.51m-3.73 2.47c.4-.29.6-.76.73-1.24.03-.1.02-.22.02-.33l-.03-.18a2.1 2.1 0 0 1-.72 1.22c-.04.03-.02.22-.02.27l.02.26m2.79.33c.26-1.6.75-3.49-.25-4.92.03.05-.1.4-.02.51.84 1.2.47 2.6.24 3.95-.02.1.02.5.03.46m-5.18-.9c.12-1.06.33-2.1.59-3.14.03-.15-.04-.41-.02-.5a27.26 27.26 0 0 0-.61 3.26c-.01.07 0 .59.03.38m-5.05-.07v-2.46c0-.3-.05-.3-.05 0v2.46c0 .3.05.3.05 0m-2.56.02c.18-.2.15-.5.15-.75 0-.02 0-.27-.03-.27s-.02.25-.02.27c0 .1-.03.15-.1.22-.04.05-.02.2-.02.27l.02.26m12.45-.14c0-.86 0-1.72-.13-2.57-.02-.1-.04.08-.04.1l.01.36c.1.7.1 1.4.1 2.11 0 .3.06.3.06 0m2.75.13c.12-.28.14-.57.14-.87 0-.02 0-.27-.02-.27s-.03.25-.03.27c0 .12-.05.24-.1.36-.04.09-.02.23-.02.32 0 .02.02.21.03.2m-12.28.04c-.1-1-.12-2.01-.12-3.02 0-.3-.05-.3-.05 0 0 1.14.01 2.27.13 3.4.02.2.04-.31.03-.38'/%3e%3cpath d='M775.16 496.12c.12-1.72.13-3.45.24-5.17.01-.09-.02-.6-.04-.27-.11 1.72-.13 3.45-.24 5.17 0 .09.02.6.04.27m2.29-.62c.27-.91.27-1.94 0-2.85.02.08-.06.36-.02.51.19.62.19 1.2 0 1.83-.04.14.04.42.02.51m2.16.5c.26-.82.37-1.63.38-2.48 0-.3-.05-.3-.05 0 0 .67-.14 1.32-.34 1.96-.05.15.04.43.01.51m2.39-2.09c.2.65.65 1.45.6 2.14 0 .07.02.58.04.38.08-1.1-.3-2.01-.62-3.04.03.09-.06.37-.01.52m-10.94 1.34v-.49c0-.02 0-.27-.02-.27-.03 0-.03.25-.03.27v.5c0 .01 0 .26.03.26.02 0 .02-.25.02-.27m15.53-.14a.84.84 0 0 1-.23-.48c0-.02-.01-.2-.03-.1-.02.12-.02.25-.01.37.02.28.08.53.26.75l.03-.27c0-.06.02-.22-.03-.27m-5.65.74c.26-1.38.37-2.77.38-4.17 0-.3-.05-.3-.06 0 0 1.25-.12 2.48-.35 3.71-.02.1.02.5.03.46m-5.07 17.78c.14-.55.25-1.1.26-1.67 0-.1.02-.23-.01-.32-.01-.02-.04.16-.04.18 0 .44-.12.87-.22 1.3a1.3 1.3 0 0 0 .01.5m3.86-.35c.63-.71.63-1.71.63-2.61 0-.3-.05-.3-.06 0 0 .75-.05 1.5-.57 2.07-.1.11.06.46 0 .54m9.39 10.15.12 1.35c0 .1.02.1.03 0v-.37l-.12-1.36c0-.09-.03-.08-.03 0-.02.13-.01.25 0 .38m-15.94 2.03v.61c0 .02 0 .27.03.27s.02-.25.02-.27v-.61c0-.02 0-.27-.02-.27s-.03.25-.03.27m-.96-1.48v2.59c0 .3.05.3.05 0v-2.59c0-.3-.05-.3-.05 0m-9.86-8.49c.5-.91.72-1.86.74-2.9 0-.17-.05-.51-.05-.14a5.4 5.4 0 0 1-.7 2.53c-.07.12.04.45 0 .51m.36 2.96a2.22 2.22 0 0 0 1.23-2.12c0-.02-.02-.2-.03-.1-.12.78-.5 1.33-1.2 1.69-.1.05.04.51 0 .53m8.59 8.17a7.6 7.6 0 0 0-.26-1.67l-.03.19c0 .1 0 .22.02.33.1.42.21.85.22 1.29 0 .02.02.2.03.18.04-.1.02-.22.02-.32'/%3e%3cpath d='M762.35 515.96c.14.48.1.97.1 1.47 0 .02 0 .27.02.27.03 0 .03-.25.03-.27 0-.67.06-1.34-.14-1.98.03.08-.06.36-.01.51m-1.31 1.57c.12-.63.24-1.24.25-1.88 0-.1.02-.23-.02-.33l-.03.19c0 .53-.12 1.04-.22 1.56-.03.12-.02.25-.01.37 0 .01.01.2.03.1m-5.71-7.39c0 1.34.17 2.71-.46 3.93-.07.13.05.45.01.52.72-1.38.51-2.95.5-4.45 0-.3-.05-.3-.05 0m1.15 7.28c0-.3.02-.57.1-.86.03-.1.02-.22.02-.32l-.03-.19c-.14.44-.14.9-.14 1.37 0 .01 0 .26.02.26.03 0 .03-.25.03-.26m7.79-4.13c.1 1.13-.67 2.37-1.43 3.12-.1.1.07.47 0 .53a5.03 5.03 0 0 0 1.47-4.02c-.02-.21-.04.3-.04.37m-6.87-1.53c-.12.9-.39 1.77-.38 2.7 0 .3.06.3.05 0 0-.76.26-1.5.35-2.24.02-.12.02-.24.01-.37 0-.01-.02-.2-.03-.1m2.18 5.69a5.14 5.14 0 0 0 1.23-3.24c0-.01-.02-.2-.03-.1a5.01 5.01 0 0 1-1.2 2.8c-.1.12.07.47 0 .54m-23.42-14c.01.33-.22.69-.45.9-.05.04-.03.21-.03.27l.03.26c.45-.4.52-.99.5-1.57a.8.8 0 0 0-.03-.18c-.03.1-.02.22-.02.32m-4.41 2.02v-1.48c0-.02 0-.27-.03-.27-.02 0-.02.25-.02.27v1.48c0 .02 0 .26.02.26.03 0 .03-.24.03-.26m-2.55.26c.3-.5.4-1.18.24-1.75a.9.9 0 0 0-.04.19c0 .1 0 .22.02.32.06.22-.12.54-.24.72-.05.08-.02.25-.02.33 0 .02.02.21.03.19m-4.45.84c.11-.52.13-1.06.13-1.59 0-.02 0-.26-.03-.26s-.02.24-.02.26c0 .38-.03.76-.11 1.13-.03.11-.02.25-.01.36 0 .02.01.2.04.1m-4.84.65c.34-.35.5-.68.5-1.18 0-.1.02-.23-.01-.33-.01-.02-.04.17-.04.2 0 .3-.25.57-.45.78-.05.05-.03.21-.03.27l.03.26m.96-3.58c-.04.2-.17.24-.35.21-.01 0-.06.52 0 .53.23.04.34-.06.38-.28.02-.12.01-.24 0-.36 0-.02-.01-.2-.03-.1m2.79 3.44c.36-.5.68-1.04.96-1.6.04-.08.02-.23.02-.32 0-.02-.02-.22-.03-.19-.28.56-.6 1.1-.97 1.6-.08.11.05.47.02.51m16.01-5.2c-.03.68-.15 1.31-.58 1.84-.1.12.07.45 0 .54.49-.6.6-1.35.63-2.1 0-.1-.03-.6-.05-.28m3.14-.83c.01.46.07.95-.23 1.33-.04.05-.02.2-.02.26 0 .03.03.26.02.27.45-.56.3-1.47.27-2.12-.02-.33-.05.18-.05.26m2.21 1.6a2.2 2.2 0 0 0 .24-1.23c-.02-.1-.04.08-.04.1-.01.21-.13.42-.22.61-.04.09-.02.24-.02.33 0 .02.02.21.03.19m3.35-1.07c0-.07-.04-.1-.1-.07-.04 0-.03.53 0 .53.17 0 .14-.18.15-.32 0-.1.02-.23-.02-.33l-.03.19m-28.18-10.9c.14-.6.13-1.22.13-1.84 0-.01 0-.26-.02-.26s-.03.25-.03.26c0 .47 0 .92-.1 1.38-.03.11-.02.24-.01.36 0 .02 0 .2.03.1m7.61-.98c.01-.86.12-1.72.12-2.58 0-.3-.05-.3-.05 0 0 .86-.11 1.72-.12 2.58 0 .3.05.3.05 0m-3.78-3.22c.1.58.4 1.5-.23 1.85-.1.05.04.51 0 .53.83-.44.38-2.13.26-2.84-.02-.1-.04.08-.04.1 0 .12-.01.24.01.36m1.83 1.61c-.08-.28-.1-.56-.1-.86 0-.01 0-.26-.02-.26-.03 0-.03.25-.03.26 0 .47.01.93.14 1.37l.03-.19c0-.1.01-.22-.02-.32m-3.16-1.97c-.04.82.02 1.71-.35 2.47-.06.13.05.44.02.5.4-.8.34-1.81.37-2.7.01-.09-.03-.6-.04-.27m3.88 2.49c.25-.29.26-.63.26-1 0-.02 0-.27-.02-.27-.03 0-.03.25-.03.27 0 .2-.1.34-.21.47-.05.05-.03.2-.03.27l.03.26m-5.64 1.77c0-.31.12-.62.22-.92.03-.1.02-.23.02-.33 0-.02-.03-.2-.04-.18a4.6 4.6 0 0 0-.26 1.3c0 .1-.01.22.02.32.01.02.03-.16.03-.19m2.03-1.53c.14-.28.24-.55.26-.86v-.37c-.03-.1-.04.08-.04.1-.02.22-.14.43-.23.61-.04.09-.02.24-.02.33 0 .02.02.21.03.19m-1.67.55c0-.33.1-.65.12-.99 0-.1.02-.23-.02-.32a.9.9 0 0 0-.03.18c-.01.33-.11.65-.12.99 0 .1-.02.23.02.33a.8.8 0 0 0 .03-.2m3.6-1.07a.42.42 0 0 1-.1-.22c0-.02 0-.27-.02-.27-.03 0-.03.25-.03.27 0 .25 0 .55.15.75l.03-.26c0-.07.01-.21-.03-.27m1.81 1.28c.26-.28.37-.64.5-1 .02-.1.01-.22 0-.32a.9.9 0 0 0-.02-.2c-.12.36-.23.71-.48.99-.04.05-.02.2-.02.26 0 .03.03.26.02.27m-78.36.35v-4.68c0-.3-.06-.3-.06 0v4.68c0 .3.06.3.06 0m-5.1.61c-1.43-2.13-2.34-4.6-1.68-7.25.03-.15-.04-.42-.02-.51-.72 2.92.03 5.82 1.7 8.27-.04-.05.08-.4 0-.51m3.63-.38c-.26-.46-.43-.93-.24-1.45.05-.15-.05-.44-.02-.52-.28.8-.16 1.76.24 2.49-.03-.06.09-.39.02-.52m2.04.52a7.1 7.1 0 0 0 .14-1.61c0-.02 0-.27-.03-.27s-.02.25-.02.27c0 .37-.02.73-.1 1.1a1.06 1.06 0 0 0 .01.51m-3.85-.39c-.59-1-.94-2.1-1.08-3.26-.02-.2-.04.31-.03.38a8.7 8.7 0 0 0 1.1 3.4c-.04-.06.08-.4 0-.52m2.67.03c-.12-.59-.23-1.17-.37-1.75.02.09-.05.36-.02.5.14.57.25 1.14.36 1.7.02.1.03-.07.04-.09l-.01-.36m-2.18-.28c-.45-1.22-.72-2.82.11-3.92.1-.12-.06-.44 0-.53-.98 1.3-.64 3.55-.12 4.96-.04-.08.06-.37 0-.51'/%3e%3cpath d='M642.96 489.07c-.55-1.33-.26-2.7 1.08-3.3.1-.03-.02-.51 0-.53-1.66.73-1.71 2.85-1.09 4.35-.03-.08.07-.38.01-.52m6.64.75a.96.96 0 0 1-.1-.36c0-.02 0-.27-.02-.27-.04 0-.03.25-.03.27 0 .3.02.6.14.87.01.03.03-.16.03-.18 0-.1.02-.24-.02-.33m-3.5-2.97c-.41.5-.46 1.25-.61 1.85-.04.15.03.43.01.52.15-.6.2-1.35.6-1.84.1-.12-.07-.45 0-.53m-2.17 3.33c-.2-.31-.34-.66-.35-1.04 0-.03-.02-.21-.03-.19-.03.1-.02.23-.02.33.01.52.1.98.38 1.42.02.02.04-.17.04-.19 0-.08.02-.25-.02-.33m2.42-.12a2 2 0 0 1-.23-.74c0-.02-.02-.2-.03-.1a2.59 2.59 0 0 0 .25 1.35l.03-.19c0-.09.02-.24-.02-.32m2.98-.24v.99c0 .02 0 .26.02.26.03 0 .03-.24.03-.26v-.99c0-.02 0-.26-.03-.26s-.02.24-.02.26m-7.43.75c0-1.27-.11-2.55-.12-3.82 0-.3-.06-.3-.05 0 0 1.28.11 2.55.12 3.82 0 .3.05.3.05 0'/%3e%3c/g%3e%3cpath fill='%23999b9e' d='M692.79 473.45c-.43.16-.8.41-1.18.67-.05.03-.03.22-.03.27l.03.26c.38-.25.75-.51 1.18-.67.09-.03-.02-.53 0-.53m-6.23-3.34a9.5 9.5 0 0 0-2.78 2.48c-.1.13.07.45 0 .54.76-1 1.7-1.86 2.78-2.49.1-.06-.04-.5 0-.53'/%3e%3cg fill='none' stroke='%23000' stroke-width='.92'%3e%3cpath fill='%23949699' stroke-width='.23' d='M660.05 288.89c.78 1.4 4.05 12.05 4.05 12.05-10.84-11.93-36.22-20.3-65.8-20.3-29.17 0-54.44 8.16-65.53 19.83-.18.19 1.69-5.34 3.9-10.62 2.16-5.16 4.67-10.08 4.83-10.18 13.05-7.96 33.64-13.09 56.8-13.09 23.33 0 44.05 5.2 57.08 13.26 0 0 4.02 6.37 4.67 9.05z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cg fill='%23fd0' stroke-width='.46' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'%3e%3cpath d='M597.16 284.19s1.03 5.9 1.97 7.87c0 0 2.23-6.29 2.23-7.78m-8-1.74s-1.48 5.8-1.42 7.99c0 0 4.6-4.83 5.21-6.2m-6.72-5.08s-3.85 4.6-4.74 6.58c0 0 6.24-2.36 7.38-3.32'/%3e%3cpath d='M589.27 275.66s-5.29 2.83-6.86 4.34c0 0 6.67.14 8.1-.33'/%3e%3cpath d='M589.52 271.93s-5.96.68-7.97 1.5c0 0 6.14 2.6 7.64 2.68'/%3e%3cpath d='M591.04 268.71s-5.81-1.47-8-1.42c0 0 4.84 4.6 6.2 5.21'/%3e%3cpath d='M593.73 266.13s-4.86-3.51-6.9-4.27c0 0 2.79 6.06 3.83 7.13m6.98-4.34s-2.98-5.2-4.54-6.73c0 0 .05 6.67.57 8.08'/%3e%3cpath d='M601.08 264.74s-1.02-5.9-1.96-7.88c0 0-2.23 6.3-2.23 7.79m8.08 1.8s1.54-5.8 1.5-7.97c0 0-4.65 4.77-5.27 6.13'/%3e%3cpath d='M607.56 269.24s3.6-4.79 4.4-6.82c0 0-6.12 2.67-7.2 3.7'/%3e%3cpath d='M608.9 272.79s5.14-3.09 6.64-4.67c0 0-6.67.18-8.07.72'/%3e%3cpath d='M608.9 276.11s5.87-1.22 7.81-2.22c0 0-6.36-2.03-7.85-1.98'/%3e%3cpath d='M607.74 279.37s5.93.87 8.1.6c0 0-5.28-4.1-6.7-4.56'/%3e%3cpath d='M605.43 282.12s5.23 2.93 7.35 3.44c0 0-3.47-5.7-4.63-6.64m-6.71 5.19s3.42 4.92 5.1 6.31c0 0-.62-6.64-1.26-8'/%3e%3cellipse cx='599.04' cy='274.46' rx='10.52' ry='10.1'/%3e%3c/g%3e%3cg transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'%3e%3cpath fill='%23000' stroke='none' d='M595.62 271.52c0 .49-.42.89-.94.89s-.94-.4-.94-.89.42-.88.94-.88.94.4.94.88'/%3e%3cpath stroke-width='.68' d='M592.77 271.5c1.02-1.52 2.71-1.45 3.88 0'/%3e%3cpath fill='%23000' stroke='none' d='M604.29 271.64c0 .49-.42.88-.94.88s-.94-.4-.94-.88c0-.49.42-.88.94-.88s.94.4.94.88'/%3e%3cpath stroke-width='.68' d='M601.44 271.61c1.02-1.52 2.71-1.45 3.88 0m-7.94 3.71c.61.05 1.04.33 1.67.36.65.03 1.03-.26 1.58-.42'/%3e%3cellipse cx='599' cy='278.37' stroke-width='.68' rx='2.34' ry='.33'/%3e%3cpath stroke-width='.81' d='M598.04 280.83c.6 0 1.19.12 1.74-.06'/%3e%3c/g%3e%3cpath d='m557.53 278.96-.95-2s-2.95.2-4.32 2.74c0 0-1.9-2.22-5.16-.95l-.1 2.95s2.21-3.06 4.53-.95c0 0-1.06 4.42 1.58 4.21 2.63-.2.84-3.9.31-4.1l-.52-.22s1.47-2.52 4.63-1.68zm-4.33 3.57c.15.62.07 1.18-.18 1.24-.25.06-.58-.39-.74-1-.16-.63-.08-1.18.17-1.25s.59.39.75 1zm21.8-11.01c-.21-.13-.73-.47-1.48-.34 0 0 .69.64.58.9 0 0-.1.55-.7.49 0 0-2.34-.26-4.24 1 0 0-1.33.2-1.43-.08 0 0-.23-.45-.03-.63a.19.19 0 0 1 .05-.03c.28-.15-1.42.23-1.03 1.04.39.82 1.28 1.12 2.05 1.05h.12v-.02s.56-.03 0 .01c.05.13 2.17 4.78 3.54 4.31 1.4-.47 1.57-4.85 1.42-5.33l-.07-.19s-.05-.16 0 0c.03 0 3.02-1.1 1.22-2.18zm-2.87 6.05c-1 .2-2.22-2.94-2.1-3.03 1.32-1.03 2.3-.89 2.57-.82-.16-.2.09.02.09.02l-.09-.02c.18.22.54 3.66-.47 3.85z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath stroke-width='1.61' d='M626.1 274.92c0-.38-.02-.75-.11-1.1a2.35 2.35 0 0 0-.44-.8 4.04 4.04 0 0 0-.9-.85c-.55-.34-1.11-.08-1.08.58.03.66.6 1.2 1.13 1.52.44.26.91.47 1.4.65 1.67.6 3.31.94 4.26 1.55.4.25.76.51 1.2.69a2.4 2.4 0 0 0 2.1-.09c.46-.27 1.15-.97.63-1.5-.6-.59-1.64-.38-2.36-.11-.56.21-1.17.55-1.64.9.27.58-.1 1.18-.23 1.83-.16.5-.32 1.01-.31 1.55.01.72 1.08 2.26 1.53.98.26-.74.13-1.85-.63-2.25-.2-.1-.39-.2-.59-.28-1.46-.6-2.97-.86-4.26-1.44a3.76 3.76 0 0 0-1.55-.3c-.45.03-.9.2-1.1.62-.17.32-.36.73-.15 1.07.43.7 1.6.06 2.06-.28.35-.26.58-.67.74-1.1a6 6 0 0 0 .3-1.84z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M645.98 282.55s-1.35-.7-2.25.73c0 0-3.35-.37-1.22-5.5.06-.14-2.16.92-1.69 4.2 0 0 .43 2.75 3.6 4.01 0 0 2.65.58 2.55-1.99 0 0-.13-1.24-.99-1.45zm-.77 2.25c-.32 0-.58-.27-.58-.6s.26-.6.58-.6c.32 0 .58.27.58.6 0 .33-.26.6-.58.6z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M644.19 281.61s1.46.43 2.06-1.15c0 0 3.37-.3 2.27 5.16-.03.15 1.94-1.33.84-4.45 0 0-.96-2.62-4.3-3.24 0 0-2.72-.05-2.12 2.44 0 0 .37 1.2 1.25 1.24zm.32-2.35c.3-.07.62.15.68.47a.59.59 0 0 1-.45.7.59.59 0 0 1-.68-.47.59.59 0 0 1 .45-.7z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23fd0' stroke='none' d='m672.31 408.85-1.09-2.35s-3.38.25-4.95 3.21c0 0-2.17-2.6-5.91-1.11l-.12 3.45s2.54-3.57 5.19-1.1c0 0-1.2 5.17 1.81 4.93 3.02-.25.97-4.57.36-4.81l-.6-.25s1.69-2.96 5.31-1.97m-4.97 4.18c.18.72.1 1.37-.2 1.45-.29.07-.67-.45-.85-1.18-.18-.73-.09-1.38.2-1.45s.67.45.85 1.18m25-12.9c-.25-.15-.83-.55-1.7-.4 0 0 .8.75.67 1.06 0 0-.12.65-.81.57 0 0-2.67-.3-4.86 1.18 0 0-1.52.22-1.64-.1 0 0-.26-.52-.03-.74a.22.22 0 0 1 .05-.04c.32-.17-1.61.28-1.17 1.23.44.95 1.47 1.3 2.35 1.23l.13-.01v-.02s.65-.04 0 .02c.07.15 2.5 5.59 4.07 5.04 1.6-.55 1.79-5.68 1.62-6.24l-.08-.22s-.05-.19 0 0c.03-.01 3.46-1.3 1.4-2.56m-3.29 7.1c-1.15.22-2.54-3.45-2.4-3.56 1.5-1.2 2.62-1.04 2.94-.96-.19-.24.1.03.1.03l-.1-.03c.2.26.61 4.29-.54 4.51'/%3e%3cpath stroke='%23fd0' d='M626.1 274.92c0-.38-.02-.75-.11-1.1a2.35 2.35 0 0 0-.44-.8 4.04 4.04 0 0 0-.9-.85c-.55-.34-1.11-.08-1.08.58.03.66.6 1.2 1.13 1.52.44.26.91.47 1.4.65 1.67.6 3.31.94 4.26 1.55.4.25.76.51 1.2.69a2.4 2.4 0 0 0 2.1-.09c.46-.27 1.15-.97.63-1.5-.6-.59-1.64-.38-2.36-.11-.56.21-1.17.55-1.64.9.27.58-.1 1.18-.23 1.83-.16.5-.32 1.01-.31 1.55.01.72 1.08 2.26 1.53.98.26-.74.13-1.85-.63-2.25-.2-.1-.39-.2-.59-.28-1.46-.6-2.97-.86-4.26-1.44a3.76 3.76 0 0 0-1.55-.3c-.45.03-.9.2-1.1.62-.17.32-.36.73-.15 1.07.43.7 1.6.06 2.06-.28.35-.26.58-.67.74-1.1a6 6 0 0 0 .3-1.84z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23fd0' stroke='none' d='M773.7 413.05s-1.54-.83-2.57.85c0 0-3.85-.42-1.4-6.44.07-.17-2.47 1.08-1.93 4.91 0 0 .49 3.24 4.12 4.71 0 0 3.04.68 2.92-2.33 0 0-.15-1.45-1.13-1.7m-.88 2.63c-.37 0-.67-.31-.67-.7s.3-.7.67-.7c.36 0 .66.31.66.7 0 .39-.3.7-.66.7'/%3e%3cpath fill='%23fd0' stroke='none' d='M771.66 411.95s1.67.5 2.36-1.35c0 0 3.86-.35 2.6 6.04-.04.18 2.22-1.55.96-5.2 0 0-1.1-3.08-4.94-3.8 0 0-3.1-.06-2.41 2.86 0 0 .41 1.4 1.43 1.45m.36-2.76c.36-.07.7.18.78.56.08.38-.15.75-.51.82-.36.07-.71-.18-.79-.56-.07-.38.16-.74.52-.82'/%3e%3c/g%3e%3cpath fill='%23fd0' d='m716.54 549.26.09-3.64s16.09.7 23.83.62v2.84s-21.14.36-23.92.18'/%3e%3cpath fill='%235c5342' d='M744.34 543.92h6.45v1.66h-6.45z'/%3e%3cpath d='M753.97 544.68v3.4h-.35v-3.4L750 525.76l.2-.05 3.64 18.78 3.09-6.28.18.03m-16.43 7.67h.35v2.3h-.35zm.61 0h.35v2.3h-.35zm1.47 0h.35v2.3h-.35zm.83 0h.35v2.3h-.35zm1.25 0h.35v2.3h-.35zm1.28 0h.35v2.3h-.35zm.83 0h.35v2.3h-.35zm1.04 0h.35v2.3h-.35zm1.04 0h.35v2.3h-.35zm.99 0h.35v2.3h-.35zm1.4 0h.35v2.3h-.35zm3.64-.23h.35v2.3h-.35zm.95-3.4h.35v5.34h-.35zm-4.03.96h.35v4.97h-.35zm-9.99 4.35h.48v.62h-.48z'/%3e%3cpath d='m752.88 547.84.03-.02c.25-.17 2.09-1.45 2.6-1.44.53.01 1.13-.03 1.13-.03v.38l-1.17.04-2.03 1.06m1.29.17.03-.02c.24-.18 2.07-1.48 2.57-1.48.54 0 1.14-.05 1.14-.05v.38l-1.16.06-2.01 1.09m-4.55-4.94h1.6v.29h-1.6z'/%3e%3cpath d='M752.37 541.74c-.2.03-.36.62-.34 1.32.02.7.2 1.25.41 1.22.2-.02.36-.62.34-1.32-.02-.7-.2-1.25-.41-1.22m.06 2.17c-.15.02-.28-.37-.3-.86 0-.5.1-.92.25-.94.15-.02.28.37.29.87.01.5-.1.91-.24.93m-6.39-15.69-9.02.39v-.23l9.4-.34'/%3e%3cpath d='m737.14 522.23 4.04 23.16-3.74-12.84.04-.65 2.8 9.78-3.18-17.96.04-1.49z'/%3e%3cpath d='m739.27 545.55-1.8-14.64-.15.57 1.57 13.87.3.11m-1.04-.03s-.04-5.31-.67-6.76l-.08.42.6 6.26c.04.46.15.08.15.08m-.71-11.55-1.5 11.43.26.15 1.35-11.23m-.49-5.96-1.94 16.01.19.27 1.71-15.94'/%3e%3cpath d='m737.36 532.4-12.46 8.29-.15-.23 12.53-8.3v.16'/%3e%3cpath fill='%23858d8d' d='M744.7 542.83h6.45l-.35 1.09h-6.45z'/%3e%3cpath fill='%23755338' d='m755.24 545.24.02-.12 1.9-8.03.25.05-1.9 7.9'/%3e%3cpath fill='%23fd0' d='M761.19 540.61c-.82.3-1.87-1.45-2.36-2.3-.48-.83-1.72-.53-1.72-.53l-.31 1.06c.24-.05 1.23-.19 1.66.55.49.84 1.53 2.6 2.36 2.29l-.46 1.33h.01l.82-2.4z'/%3e%3cpath fill='%23034ea2' d='M758.46 539.39c-.42-.73-1.42-.6-1.66-.55l-.17.57c.31-.06 1.2-.14 1.6.55.5.84 1.54 2.6 2.36 2.3l-.25.74.02.02.46-1.34c-.83.3-1.87-1.45-2.36-2.29'/%3e%3cpath fill='%23ed1c24' d='M756.52 539.77h.07c1.34.04 1.72 1.03 1.98 1.68.24.6 1.56 1.42 1.76 1.55l.26-.74c-.82.3-1.87-1.46-2.36-2.3-.4-.69-1.3-.6-1.6-.56l-.1.31s-.03.06-.01.06'/%3e%3cg fill='%23a37853'%3e%3cpath d='m737.46 533.62 13.1-8v-.17h-.28l-12.85 7.66v.37'/%3e%3cpath d='m737.6 528.53.26 16.77-.5.2-.43-16.23.06-12.98.14.09.11 12z'/%3e%3cpath d='M736.25 545.64c0 .22.16.4.35.4l19.45-.29c.2 0 .35-.18.34-.4 0-.23-.16-.4-.35-.4l-19.45.28c-.2 0-.34.19-.34.41'/%3e%3c/g%3e%3cg stroke='%23000' stroke-width='.13'%3e%3cpath fill='%23616264' stroke='none' d='M727.71 541.95s.8.04 2.43.3c0 0-1.8.24-2.77.55-.98.32-2.87 2.18-3.27 2.54-.4.35-.58.53-.58.53l-3.06-.02s1.42-1.83 2.03-2.27c.6-.45 1.81-1.26 2.4-1.36.6-.1 1.7-.36 2.82-.3'/%3e%3cpath fill='%23a3a5a8' d='M736.66 546.21a6.06 6.06 0 0 0-5.93-3.95h-.1c-4.53.19-4.76 2.05-6.47 3.61h-.32l-.04.06s9.32.28 12.86.28z'/%3e%3cpath fill='%23797a7d' stroke='none' d='M735.41 545.57a.1.1 0 0 1-.14-.05.11.11 0 0 1 .05-.15.1.1 0 0 1 .14.06.1.1 0 0 1-.05.14m-.24-.49a.11.11 0 0 1-.15-.03.1.1 0 0 1 .03-.15.11.11 0 0 1 .15.03.1.1 0 0 1-.03.15m-.3-.45c-.05.03-.11.03-.14-.02-.04-.05-.04-.11.01-.15.05-.04.12-.04.15.01.04.05.03.12-.02.16m-.35-.41a.1.1 0 0 1-.15 0 .12.12 0 0 1 0-.16.1.1 0 0 1 .15 0c.05.05.04.12 0 .16m-.38-.38a.11.11 0 0 1-.15.02c-.05-.04-.05-.1-.02-.15s.1-.06.15-.02c.05.04.06.1.02.15m-.41-.33c-.03.05-.1.06-.15.03a.1.1 0 0 1-.03-.14c.03-.05.1-.07.15-.04.06.03.06.1.03.15m-.46-.28c-.03.05-.1.07-.14.04a.12.12 0 0 1-.05-.15.1.1 0 0 1 .15-.04c.05.03.07.1.04.15m-.48-.23a.11.11 0 0 1-.14.06.11.11 0 0 1-.06-.14.1.1 0 0 1 .14-.06.1.1 0 0 1 .06.14m-.5-.2a.11.11 0 0 1-.13.08.1.1 0 0 1-.08-.13c.02-.05.08-.1.13-.08.06.02.1.07.08.13m-.52-.11c-.01.06-.06.1-.12.09a.12.12 0 0 1-.09-.13c.01-.06.06-.1.12-.09.06.01.1.07.09.13m-.53-.07c0 .06-.05.1-.11.1a.1.1 0 0 1-.1-.1c0-.07.05-.12.11-.11.06 0 .1.05.1.11m-.53-.02c0 .06-.04.1-.1.1a.1.1 0 0 1-.11-.1c0-.05.04-.1.1-.11.06 0 .1.05.11.11m-.53.04c0 .06-.04.11-.1.12a.1.1 0 0 1-.11-.1.1.1 0 0 1 .1-.12.1.1 0 0 1 .11.1m-.53.05c0 .06-.03.11-.1.12a.11.11 0 0 1-.11-.1.1.1 0 0 1 .09-.12c.06 0 .11.04.12.1m-.52.08c.01.06-.02.12-.08.13a.1.1 0 0 1-.13-.08.11.11 0 0 1 .09-.13.1.1 0 0 1 .12.08m-.52.12a.1.1 0 0 1-.07.13.134.134 0 0 1-.14-.08.1.1 0 0 1 .08-.13c.06-.01.11.02.13.08m-.5.17c.02.06 0 .12-.06.14a.1.1 0 0 1-.14-.06.1.1 0 0 1 .06-.14.1.1 0 0 1 .14.06m-.49.21c.03.06.01.12-.04.15a.1.1 0 0 1-.14-.03.11.11 0 0 1 .04-.15.1.1 0 0 1 .14.03m-.45.29c.03.05.02.12-.02.15-.05.03-.11.03-.15-.02a.113.113 0 0 1 .02-.16c.05-.03.12-.02.15.03m-.41.35a.1.1 0 0 1 0 .15.11.11 0 0 1-.16 0 .1.1 0 0 1 0-.16.1.1 0 0 1 .16.01m-.37.38c.04.04.05.1 0 .15a.1.1 0 0 1-.14.01.11.11 0 0 1-.01-.15.1.1 0 0 1 .15 0m-.36.4c.05.04.05.1.01.15a.1.1 0 0 1-.15.02.11.11 0 0 1 0-.16.1.1 0 0 1 .14-.01m-.35.4a.1.1 0 0 1 0 .15.1.1 0 0 1-.15 0 .11.11 0 0 1 0-.15.1.1 0 0 1 .15 0'/%3e%3cpath fill='%23939598' d='M729.55 542.2c-4.65.17-4.85 2.06-6.59 3.63l.88.03.32.01c1.71-1.56 1.93-3.42 6.48-3.6a6.23 6.23 0 0 0-1.09-.07z'/%3e%3cg fill='%23442c13' stroke-width='.12'%3e%3cpath d='m596.42 395.94.13-2.25.52-.03v.62l3.72-.1-.81 2.09-3.53-.13-.06-.3' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='m598.22 389.02.1 5.58-.46.03.23-5.61zm2.06-.33.1 5.68-.33.06.03-5.74zm2.31 4.51-.23-5.42-.13.04.1 5.41zm3.32-.57.99-4.98-.1.07-1.2 4.9z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='m602.23 387.81-2.25 6.5-.36-.07 2.35-6.46zm.52.1.56 4.9.29-.04-.62-4.86z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3c/g%3e%3cpath fill='%23a48b58' stroke-width='.12' d='M606.8 387.71h-5.1l-3.61 1.3 4.27.14z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23a37853' stroke-width='.12' d='m597.96 389.15 3.85-1.27 5.1-.1.02-.36-5.22.1-3.72 1.2z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M722.38 542.35c0-.8.53-1.45 1.2-1.45.57 0 1.05.5 1.16 1.16l.25-.04c-.13-.8-.71-1.41-1.42-1.41-.8 0-1.44.78-1.44 1.74 0 .28.06.54.16.78l.22-.15c-.08-.19-.13-.4-.13-.63z'/%3e%3cpath fill='%23939598' d='M721.11 545.75c1.9-1.6 1.96-3.58 6.67-3.78a6.25 6.25 0 0 0-1.09-.06c-4.8.17-4.85 2.18-6.76 3.78a.6.6 0 0 0-.1.13l1.19.03.09-.1z'/%3e%3c/g%3e%3cpath fill='%23fd0' d='M743.67 548.94v-.25s12.6.02 12.66-.71c.08-.75-6.1-.45-15.75.05'/%3e%3cpath fill='%23696161' d='M708.02 530.86c-.75.09-1.3-.77-2 .34l-.06.07c-.48.56-.73 1.34-.43 1.93.17.35 1 .66 1.37.71.92.13 1.66-.63 1.75-1.52.43.54 1.68.56 2.31.6 1.1.06 1.4-.14 1.58-1.32.65.93 1.17 1 2.27.8 1.27-.22 2.74-.37 3.67-1.33.35.55.86.85 1.48.85.54.01 1.25-.09 1.75-.28.42-.16.89-.75 1.31-.83.33.5.98.3 1.41.39.81.5 1.69.82 2.99.11.34-.19 1.56.27 1.98.07.3-.15.36-.44.6-.6.54.42 1.4-.01 1.97-.16.45.02 1.08-.05 1.25-.6.79-.49.56-.9.31-1.12-1.26-.52-2.13-.52-3.3.34-.4-.1-.59-.1-.87.42-.5-.78-1.39-1-2.3-.44-.78-.45-1.18-.12-1.81-.1-1.26-.96-3.5-.83-5.06.1-1.77-.84-2.31-.36-3.48.53-.66-.3-1.47-.11-2.2-.06-.64.05-.98.89-1.55.6-1.27-.61-1.88.34-2.83.3-1.04-.91-2.1.2-2.1.2' opacity='.75'/%3e%3cpath fill='%2384848a' d='M707.99 548.97c0 .61-.48 1.1-1.08 1.1-.6 0-1.08-.5-1.08-1.1v-13.59c0-.6.48-1.1 1.08-1.1.6 0 1.08.5 1.08 1.1v13.59z'/%3e%3cpath fill='%23453717' d='M717.07 546.5s-.7.69-.87.75c-.17.05-1.01.42-1.18.42-.17 0-.53.03-.92.03h-.76l-.68-.05.28 1.34 3.76.09.37-2.58z'/%3e%3cpath fill='%236a5e46' d='M713 546.61h-1.4l-.02.14h-1.22l-.27 2.26 2.85-.02'/%3e%3cpath fill='%23453717' d='M710.59 548.62c0 .03-.02.06-.06.06a.06.06 0 0 1-.05-.06v-1.17a.06.06 0 1 1 .11 0v1.17zm.31 0c0 .03-.02.06-.06.06a.06.06 0 0 1-.05-.06v-1.17a.06.06 0 1 1 .11 0v1.17zm.33 0c0 .03-.02.06-.06.06a.06.06 0 0 1-.05-.06v-1.17c0-.04.02-.06.05-.06s.06.02.06.06v1.17zm.51 0a.06.06 0 1 1-.11 0v-1.17c0-.04.02-.06.05-.06.03 0 .06.02.06.06v1.17zm.47 0c0 .03-.02.06-.06.06a.06.06 0 0 1-.05-.06v-1.17c0-.04.02-.06.05-.06s.06.02.06.06v1.17zm.4 0c0 .03-.02.06-.06.06s-.05-.03-.05-.06v-1.17c0-.04.02-.06.05-.06.04 0 .06.02.06.06v1.17z'/%3e%3cpath fill='%232f2311' d='M709.66 548.93v-.12l.06-2.6-.28.08-.03 1.33-.28.1-.11-.3h-.68l-.23.1v1.23zm-8.72-1.6-.37.03v.2h-.42l-.03-.41h-.36v-.32l-.45-.02-.08-1.09H699v-1.49l-.31-.03.1 3.18-.18.03v.35h.2l-.09 1.05 4.27.24-.12-1.72h-.4v.23l-1.1-.12-.07.4h-.28z'/%3e%3cpath fill='%23866d46' d='m703.75 547.72-.91-.04.15 1.25.78-.08z'/%3e%3cpath fill='%23acacad' d='M708.09 539.94a1.7 1.7 0 0 0-1.19-.44c-.48 0-.91.17-1.18.44a.57.57 0 0 0-.02.14c0 .05 0 .1.02.14.27-.27.7-.44 1.18-.44.5 0 .92.17 1.19.44l.02-.14-.02-.14'/%3e%3cpath fill='%23866d46' d='m707.28 547.33-.04-.38.27-.34-.68-.12-.04.36-.35.02-.06.2h-.25l-.17.06-.12.37-.2-.26.09 1.6 2.22-.05v-1.44'/%3e%3cpath fill='%232f2311' d='m703.5 548.93 2.4-.08-.08-1.23-2.25.02'/%3e%3cpath fill='%23453717' d='m698.38 548.94.04-1.76-.49.08h-.34l-.26-.15-.04.11-1.23.04-.15-.38-.75.07-.04.27-.93.04-.15-.35h-.26v-1.9l-.41.03-.19 2.3-.37.03v-.3l-.49-.04-.07.57-.57-.08.04-.53h-.52l-.08.61-3.17.08.15-2.76-.53-.07.04 2.75s-2.06-.69-2.4-1.03l1.24 1.49s4.11.8 11.93.88'/%3e%3cpath fill='%23895f33' d='M685.52 547.95s-.67-.2-5.9-1.8c-5.25-1.6-7.75-2.75-8.24-2.9-.49-.15-1.2 0 1.01 1 2.2.99 10.51 3.85 11.9 3.82 1.38-.04 1.5.07 2.43-.12.93-.2-1.2 0-1.2 0'/%3e%3cpath fill='%23fff' d='M708.02 530.86c-.76.09-1.3-.77-2 .35l-.06.06c-.48.56-.73 1.34-.44 1.93.18.35 1 .66 1.38.72.91.12 1.66-.64 1.74-1.53.44.54 1.69.56 2.32.6 1.1.06 1.4-.14 1.58-1.32.65.93 1.16 1 2.27.8 1.27-.21 2.74-.37 3.67-1.33.35.55.86.85 1.48.86a5.2 5.2 0 0 0 1.75-.29c.42-.16.88-.75 1.31-.83.33.5.98.3 1.41.4.8.5 1.69.8 2.99.1.34-.18 1.55.27 1.98.07.3-.15.36-.44.6-.6.54.42 1.4 0 1.97-.16.45.03 1.08-.05 1.25-.6.79-.49.56-.9.3-1.12-1.25-.51-2.12-.51-3.3.34-.39-.1-.58-.09-.86.42-.5-.78-1.39-1-2.3-.44-.78-.45-1.19-.12-1.81-.1-1.26-.96-3.5-.83-5.07.1-1.76-.84-2.3-.36-3.47.53-.66-.3-1.47-.11-2.2-.05-.65.05-.98.88-1.56.6-1.26-.62-1.87.33-2.82.29-1.04-.91-2.11.2-2.11.2'/%3e%3cpath fill='%23ffe600' d='m740.68 548.21.61.77H716.6l-18.03-.23s-7.85-.2-11.7-.58c-3.86-.38-8.24-1.49-8.24-1.49.04 1.19.87 1.8 1.54 2.41.09.08.25.17.46.25 1.45.59 5.41 1.32 6.68 1.55 1.46.27 6.66.57 10.18.53 3.51-.03 39.24-.19 39.24-.19v-.34c1.38.23 18.93-1.07 18.93-1.07.05-.08.1-.21.17-.37.18-.44.38-1.1.47-1.36l.03-.12-15.65.24z'/%3e%3cpath d='m683.35 552.03-8.83-7.03.68.23 8.15 6.5z'/%3e%3ccircle cx='567.74' cy='398.67' r='.48' fill='%23565759' stroke='%23000' stroke-width='.23' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23565759' stroke='%23000' stroke-width='.13' d='m684.74 550.52.06.2c-.36.4-.67.21-.67.21v-1.58a.22.22 0 0 0 .14-.2c0-.13-.1-.23-.22-.23-.11 0-.21.1-.21.22 0 .09.05.16.12.2v1.6s-.32.19-.68-.23l.06-.2-.48.07.19.44.08-.13s.5.43.89.43h.04c.38 0 .9-.43.9-.43l.08.13.19-.44-.49-.06z'/%3e%3cpath d='M686 549.04c0-.18.15-.33.33-.33.17 0 .32.15.32.33 0 .18-.15.33-.32.33a.33.33 0 0 1-.33-.33m3.02.61c0-.18.15-.33.32-.33.18 0 .33.15.33.33 0 .18-.15.33-.33.33a.33.33 0 0 1-.32-.33m2.98.11c0-.18.15-.33.32-.33.18 0 .33.15.33.33 0 .18-.15.33-.33.33a.33.33 0 0 1-.32-.33m3.42-.05c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33m3.31.05c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33m3.09-.05c0-.18.15-.33.32-.33.18 0 .33.15.33.33 0 .18-.15.33-.33.33a.33.33 0 0 1-.32-.33m8.75.34c0-.18.15-.33.32-.33.18 0 .33.15.33.33 0 .18-.15.33-.33.33a.33.33 0 0 1-.32-.33m8.98.23c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33m3.08.11c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33m2.7 0c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33m2.75 0c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33m2.63-.05c0-.18.15-.33.33-.33.17 0 .32.15.32.33s-.15.33-.32.33a.33.33 0 0 1-.33-.33m2.53-.12c0-.18.15-.33.33-.33s.32.15.32.33a.324.324 0 1 1-.65 0m2.64 0c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33m-31.09-.46c0-.18.15-.33.33-.33.18 0 .32.15.32.33 0 .18-.14.33-.32.33a.33.33 0 0 1-.33-.33m2.81.17c0-.18.15-.33.33-.33.17 0 .32.15.32.33 0 .18-.15.33-.32.33a.33.33 0 0 1-.33-.33'/%3e%3cg fill='none' stroke='%23000' stroke-width='.23' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'%3e%3ccircle cx='622.02' cy='399.23' r='.35'/%3e%3ccircle cx='624.18' cy='399.04' r='.35'/%3e%3ccircle cx='626.28' cy='398.89' r='.35'/%3e%3c/g%3e%3cpath fill='%23ed1c24' d='m682.56 551.38.5.4-.09.31a1 1 0 0 0 .22.29l.09.09h.03c1.05 1.03 3.88 2.59 3.88 2.59l12.15.35h.22s55.16-.37 55.16-.66-.47-2.56-.47-2.56-.29-.23-.59-.16c-.73.17-4.72.52-7.57.81-.94.1-1.79.18-2.31.25-2.09.31-.28 0-.28 0s-21.54.24-24.53.16c-2.99-.07-20.38.09-20.38.09s-10.91-.78-11.81-.78-2.69-.76-3.44-.84a2.55 2.55 0 0 1-.78-.34z'/%3e%3cpath fill='%23034ea2' d='M755.83 549.45c-.06.16-.12.3-.17.37 0 0-17.55 1.3-18.93 1.07v.34s-35.73.16-39.24.2a82.1 82.1 0 0 1-10.18-.54c-1.27-.23-5.23-.96-6.67-1.54l-.73.09s1.57 1.3 2.64 1.94c.34.2.62.33.8.35.74.08 2.54.84 3.44.84s11.82.77 11.82.77 17.36-.16 20.35-.08c3 .08 24.54-.15 24.54-.15s-1.8.3.3 0 8.9-.84 9.87-1.07c.3-.08.65-.36.97-.72.68-.77 1.28-1.88 1.28-1.88l-.09.01'/%3e%3cpath fill='%23fd0' d='m716.54 549.26.09-3.64s16.09.7 23.83.62v2.84s-21.14.36-23.92.18'/%3e%3cpath fill='%239b7e39' d='m730.02 554.92.39.29.42-.29-.17-2.78-.53-.02-.11 2.8zm-.68-2.78-.83 2.47.28.38.49-.15.62-2.72h-.1l-.46.02m-2.18 1.73.17.46h.5l1.2-2.18-.7.04-1.17 1.68zm-1.04-1.05.04.48.49.14 1.23-1.23-1.05.03-.71.58zm5.74 1.88.46.13.3-.41-.96-2.24-.6-.02.8 2.54zm1.1-.49.47.02.2-.47-1.13-1.55-.72-.03 1.18 2.03zm1.14-.9.47-.1.07-.52-.55-.43-1.1-.03 1.11 1.08z'/%3e%3cg fill='none' stroke='%23d0c9ce' stroke-width='.13'%3e%3cpath fill='%23fff' stroke='%23999b9e' d='m716.79 523.61.12.1s.12-.2.24-.2.43.15.43.15l.06-.2.54.15-.03-.26s.36.05.35.02l-.04-.22.45.03-.03-.2s.61.08.6.04l-.13-.24s.5.05.7.05c.2 0 .18.06.18.06v-.16l.8-.02-.13-.19.6-.01-.26-.28s1.2.4 1.57.04c0 0-.55.04-1.16-.16-.62-.2-1.2-.26-1.42-.32a8.02 8.02 0 0 1-1.7-.66h.21s-1.34-.51-2.03-.62c0 0-.87-.18-1.28.12 0 0-.19.24-.34.3-.15.07-.48.29-.5.32-.03.03-.1-.07-.5.17 0 0-.1.04-.12.03 0 0-.77-.39-1.68-.03l-.07.04s-.37-.17-.66-.17c-.03 0-.34-.18-.4-.21l-.02-.01s-.37-.77-1.06-.7c-.68.06-1 .22-1.1.25-.1.02-.8.27-.94.3-.14.03-.45.17-.45.17s-.62.27-.76.3c-.15.02-.99.21-1.02.21-.04 0 .08.04.1.04 0 0-.64.2-1.02.24-.36.05-1.5.23-1.6.2-.08-.02-.03 0-.03 0s.33.17 1.27.08l.37-.01h.04l-.41.2c.02-.01.99-.01.8.03-.07.02-.3.18-.3.18l.93.01-.13.13s.86.04.95.02l-.15.18s.44-.02.74-.1l-.15.22.63-.03-.23.23s.4.06.5.04l.05-.01-.17.14h.6l-.06.12.53-.1.14.16s.42-.19.47-.18l.27.2s.27-.23.3-.24h.04s.1.22.21.28c0 0 .2-.14.26-.13.05 0 .15.15.15.15l.14-.13.35.13s.07-.2.17-.17c.1.02.52.79 1.46.85 1.18.07 1.65-.59 1.65-.59l.35-.22.05.21.37-.17v.1s.47-.2.48-.28l.17.24s.3-.2.33-.19c.05.01.1.14.34.18'/%3e%3cpath d='m713.3 523.5.06.08m-.24-.01c0 .04.02.08.04.11'/%3e%3cpath stroke='%23fff' d='M706.23 522.25a.15.15 0 0 1-.1.05m-.2.01c-.05.02-.09.06-.15.07'/%3e%3cpath d='M720.25 522.73s-1.37-.35-1.83-.83c0 0 .04-.09-.02-.16s-.03-.02-.03-.02.24.14.45.12c0 0-.02-.17-.14-.25m1.29.15s-.72.03-1.17-.02'/%3e%3cpath d='M720.57 522.06s-.24 0-.41.04c-.17.03-.7.05-.89-.06-.19-.12-.3-.13-.44-.17m.51.9c-.04 0-1.01-.34-1.33-.72m.88.94s-.67-.13-1.45-.92m1.04 1.1c-.04-.03-1.45-.46-1.5-1.13m1.18 1.32s-.8-.16-1.5-1.19m.98 1.29s-.82-.63-1.04-1.12m.56 1.19c-.02-.04-.59-.76-.67-1.23m-.06 1.12s-.3-.9-.19-1.29m-.3 1.25c0-.03-.04-.08.02-.34a.78.78 0 0 0-.05-.51m-.46 1.03c0-.02 0-.31.1-.52.1-.21.14-.41-.01-.65m-.51 1.14s-.06-.2.13-.45l.02-.23s.07.01.05-.04l-.06-.14m-.8-.62c.08-.07.2-.24.19-.27l-.05-.1.08.1s.04.01.13-.05c.1-.07.2-.07.26-.14.06-.06.1-.12.15-.14.04-.03.12.02.2-.01.07-.03.3-.15.34-.2l.1-.14c.04-.03.1-.12.1-.12s.25.07.42.07l.4-.01c.15 0 .5-.03.64 0l.53.08c.05 0 .2.05.33.07.11.02.31-.04.38-.06'/%3e%3cpath d='M715.05 522.61c.06.02.2.08.22.13-.05-.12.13-.2.2-.28.07-.09.07-.19.07-.3m-.15-.18c.21.18.39.38.56.6.02-.13.02-.25.07-.38.03-.06.14-.13.12-.21'/%3e%3cpath d='m715.78 521.36.15.34c.05.1.09.22.16.3.06.08.15.14.24.2.07.04.16.11.24.13.06-.05.08-.16.08-.23 0-.08-.1-.2-.05-.27m-.21-.51c.03.32.22.48.5.65.11.06.33.17.45.15.18-.02.1-.22.1-.32'/%3e%3cpath d='M716.72 521.41c.08.08.2.12.3.18l.2.2c.04-.03.04-.1.02-.12m-.23-.41c.02.1.12.25.19.33.1.12.22.23.36.3.08.06.23.13.33.13.14.01.13-.13.08-.21.08.13.33.08.45.12'/%3e%3cpath d='M715.74 521.37c.24 0 .46-.07.7-.1.16-.02.34-.04.5-.02.15.02.29.08.43.08.04-.08-.04-.2-.09-.26m.16.05c.12.1.24.19.4.24.06.03.13.03.19.06.05.02.08.06.12.1m-.59-.11c.13.04.26.08.3.22m-2.99 1.1c-.06.09-.1.18-.18.26m.71-.25c0 .06.02.12 0 .17m-.02.26c-.02.08-.06.17-.05.26.02 0 .02-.01.03-.02m.51-.23-.03.12m-.24-1c.05.07.07.14.12.2.04.06.08.09.09.15m.33-.11a.2.2 0 0 1-.05-.1m.01-.12.06.12m-.05-.26.04.08m.16 1.05.04.05m.19-.31c.04.06.04.13.06.2m.26.16c-.04-.05-.02-.11-.04-.17m.81.01c.04.04.08.07.14.08m.16.08c.04.04.16.06.17 0m-.19-.41c.04.06.1.11.17.14m.75-.46c.1-.01.18.07.28.08m-.25-.49c.03.05.16.2.23.2m.34.09c.02.06.19.06.24.09m-2.52-1.89.2.1c.05.02.13.06.19.03m-.62-.13c.11 0 .19.09.3.09a.46.46 0 0 0-.12-.05m-.43-.02c.12.03.12.04.2.12v-.03m-.44-.15c.05.05.13.07.16.14m-.29-.13c0 .04.03.07.07.09m-.37-.02a.17.17 0 0 1-.08-.1m.19.75c.19.1.23.3.28.47m2.31-.54c.15.03.21.13.33.2 0-.03-.01-.02-.03-.03m-.76-.26c.12.05.25.05.34.13l.11.12.02-.04m-1.37.7c.07.05.15.13.2.2.03.04.05.11.09.14m-2.68-.88c.08.07.26.08.24.21 0 .05-.06.08-.07.13 0 .05.03.1.04.14m-.28-.28c.03.06.1.1.04.17l.01-.02m.42-.51c.12.09.25.14.35.25.05.05.1.2.16.21m-.67-.8c.18.06.2-.1.32-.17m.07.1c.07-.07.04-.23.15-.26m-.33.02c.12-.1.16-.23.34-.25m-1.53.98c.07.03.14.07.13.15m-.18 0c.02.03.05.06.05.1a.25.25 0 0 1-.04-.03m-.22-.15.06.08c.03.03.02.05.03.04m.32.41c-.03.08 0 .17 0 .23m-.35 1.04c.02.04.05.24-.03.22m-2.49-1.37c.06 0 .06-.05.1-.07.05-.03.1-.03.16-.03m.03.27c.02.03.02.06 0 .06m-.16-.04v.05m-.12-.06-.01.06m.59-.98a.92.92 0 0 0-.12.25h.03m.26-.16a.22.22 0 0 0-.05.15m.33-.4-.16.11m-.88.31c-.15-.05-.18-.1-.19-.22-.12 0-.3-.19-.2-.3-.04.21-.3.13-.43.06a1 1 0 0 1-.45-.46c-.05.09-.13.08-.24.08-.21 0-.42.03-.64.04-.23.02-.45-.07-.68-.06-.2 0-.36.1-.55.13l-.5.01m4.1.38c-.1.02-.22.01-.3.08.02.01 0 .02 0 .03m-5.56.05c.27.01.54.07.81.06.14 0 .27-.03.4-.05.12-.02.26-.03.36-.08m-1.47 1c.24-.01.5-.1.74-.17.26-.06.52-.13.75-.26a.45.45 0 0 0 .23-.24c.04-.1.11-.2.12-.31m-1.04 1.15c.12-.03.23-.17.34-.23.11-.07.24-.1.37-.14.27-.09.52-.23.71-.42m-.84.89c.1-.1.26-.11.39-.17a2.74 2.74 0 0 0 .94-.8m-.81 1.12.8-.4c.13-.08.24-.17.36-.28.09-.08.13-.22.22-.3m-1.06 1.25c.28-.17.57-.35.84-.55.23-.18.5-.3.62-.58m-1.05 1.29c.14-.25.38-.45.62-.62.19-.13.37-.28.39-.51m-.51 1.15c0-.09.09-.18.14-.25l.23-.31c.08-.13.13-.26.19-.4m.06.92c.09-.25.1-.54.13-.8v-.2c0-.1.04-.18.07-.28m.37 1.21c.02-.06-.02-.11-.02-.17 0-.06.03-.1.04-.15.02-.1 0-.24 0-.34 0-.1-.04-.23-.01-.33.02-.08.12-.13.2-.17m.27 1.33c-.08-.26-.28-.5-.26-.77 0-.12.01-.29.13-.35m.4 1.15c.07-.17.07-.47.01-.64m.53.6c-.08-.16-.24-.26-.2-.45.02-.1.08-.17.1-.27'/%3e%3cpath d='M711.3 522.71a.4.4 0 0 1-.23.16c-.09.02-.2-.02-.27.06-.06-.08-.03-.29-.03-.39 0-.13-.02-.27.03-.4.09-.22.31-.35.56-.39'/%3e%3cpath d='M711.18 521.61c-.12.18-.37.09-.51.24-.13.14-.15.41-.11.58.04-.04.1-.05.16-.09m-.27-1.06c-.04.12-.17.18-.24.28a.61.61 0 0 0-.11.28c-.03.1-.04.2 0 .3.04.1.08.18.1.27m-.14-1.35c-.03.21-.32.4-.48.54-.07.07-.13.15-.11.25.02.07.08.12.12.18l.05.14a.56.56 0 0 1 .18-.1c.08-.02.19-.02.24-.08m-2.12-.85c-.2.18-.57.27-.68.52m1.41.06c-.07.06-.14.15-.22.2-.1.04-.2.03-.31.03m-.48-.01c.12-.06.54-.06.56-.22m.55.39c.16-.01.3-.01.38-.15m-.94-.25c-.02.08-.07.16-.08.23m.53-.2c.11.1 0 .3.13.38m.77-.92-.25.27c-.06.05-.15.1-.18.18-.04.1.01.2.03.3m-.22-.87c.08.08.2 0 .3.02.06 0 .14.03.25.02.09-.01.17-.04.26 0 .05.04.08.1.16.1m-.49.64a.93.93 0 0 1-.26.12m-.91-.45-.04.11m.28-.14c.1-.15.2-.19.34-.26m2.17-.16c0 .04-.02.09 0 .12v-.03m-.2-.25c0 .1.02.12.06.21l-.04-.05m-.14-.19c-.01.05-.01.12.01.15m-.32-.31a.5.5 0 0 1 .1-.12m-.14-.01a.46.46 0 0 1-.14.14m-.04-.16a.2.2 0 0 1-.13.15m-.08-.09a.35.35 0 0 1-.16.11m-.15-.09a.52.52 0 0 1-.14.1m-.13-.09c-.01.03-.05.05-.09.05m2.12 1.33c.02-.09.18-.1.26-.08m-.45.21c.04-.01.07-.05.07-.08m-1.15.51c0 .1.01.17-.06.26m-.14.55v-.1m.12-.03c0 .02 0 .05-.02.07m-.15-.15c0 .02 0 .04-.02.06m-.53.15s0-.03.02-.04m.2-.09v.06m.22-.88c0 .1 0 .26-.1.35m.59-1.54c-.1.13-.42.24-.4.41m-.5-.44a.15.15 0 0 1-.07.06m.32.01-.1.15m1.16.12c-.15.05-.29.1-.32.25m-1.59.36c.02.14-.15.26-.29.3m.96-.31c-.05.06-.13.14-.21.16m-.82.54c-.02.05-.07.08-.1.11m-.2.04c-.04.02-.12.1-.16.07m-.33-.67c-.02.06-.1.09-.14.12m-.35.11-.24.06'/%3e%3cpath stroke='%23fff' d='M706.76 522.55c-.03.05-.1.08-.15.09'/%3e%3cpath d='M707.13 521.42a.8.8 0 0 0-.4.14'/%3e%3cpath stroke='%23fff' d='M706.03 522.48c-.04.02-.11.06-.16.04m-.97-.36c.2-.12.48-.17.7-.22.12-.03.21-.05.3-.1.1-.05.18-.11.26-.14'/%3e%3cpath d='M706.66 522.49h-.14'/%3e%3c/g%3e%3cpath fill='%232f3b30' stroke='%23fff' stroke-width='.13' d='M711.87 544.25s.26-1.37 1.24-1.63c.98-.27 2.01-1.06 2.01-2.06s-.57-1.58-1.19-1.9c0 0 1.86-1.26 1.86-3.1 0-1.85-1.96-2.85-1.96-2.85s3-1.16 3.2-2.69c.2-1.53-1.34-3.32-1.8-3.84-.47-.53-1.2-.58-1.2-.58l.32.63-.62-.27s.3.87 1.13 1.59c.62.53 1.7 1.63 1.4 2.47-.31.85-3.05 2.22-3.05 2.22v1.15s1.96 1.22 1.91 2.27c-.05 1.06-1.75 2.27-1.75 2.27l-.1 1.05s1.18.8 1.13 1.63c-.05.85-1.3 1.27-1.3 1.27s-1.49.68-1.28 2.21'/%3e%3cpath fill='%232f3b30' stroke='%23fff' stroke-width='.13' d='M714.47 544.25s-.26-1.37-1.24-1.63c-.98-.27-2.01-1.06-2.01-2.06s.57-1.58 1.19-1.9c0 0-1.86-1.26-1.86-3.1 0-1.85 1.96-2.85 1.96-2.85s-3-1.16-3.2-2.69c-.2-1.53 1.34-3.32 1.8-3.84.47-.53 1.2-.58 1.2-.58l-.32.63.62-.27s-.3.87-1.13 1.59c-.62.53-1.7 1.63-1.4 2.47.31.85 3.05 2.22 3.05 2.22v1.15s-1.96 1.22-1.91 2.27c.05 1.06 1.75 2.27 1.75 2.27l.1 1.05s-1.18.8-1.13 1.63c.05.85 1.3 1.27 1.3 1.27s1.49.68 1.28 2.21'/%3e%3cpath fill='%2364472d' d='M712.67 520.55h.75v27.9h-.75z'/%3e%3cpath fill='%2364472d' d='M712.94 520.2h.2v.53h-.2z'/%3e%3cpath fill='%2364472d' d='M712.32 519.45c0-.42.34-.76.75-.76a.766.766 0 0 1 0 1.53.76.76 0 0 1-.75-.77'/%3e%3cg fill='none' stroke='%23000'%3e%3cpath stroke-width='1.28' d='M630.79 241.91c27.11 16.28 45.97 52.4 45.97 94.32 0 49.9-26.7 91.57-62.26 101.37' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath stroke-width='.64' d='M629.83 243.6c26.74 15.87 45.37 51.37 45.37 92.63 0 48.97-26.25 89.84-61.16 99.37' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath stroke-width='1.3' d='M581.76 438.03a59.66 59.66 0 0 0 34-.13' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath stroke-width='1.29' d='M658.8 386.73c-10.25 22.96-27.38 39.6-47.5 44.6l.2-1a51.65 51.65 0 0 1-27.03-.48l.12 1.14c-18.5-5.08-34.39-20.06-44.54-40.7l.53 1.06c10.16 20.1 25.82 34.64 44.01 39.64l-.12-1.14a51.73 51.73 0 0 0 27.02.47l-.19 1c19.75-4.9 36.63-21.02 46.93-43.33' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath fill='%23b1babf' stroke='none' d='M756.95 364.67s-16.9-10.47-38.95-10.22c-16.15.2-34.57 9.45-34.57 9.45-18.49 11.06-33.66 30.64-43.12 54.73a155.82 155.82 0 0 0-10.57 57.08c0 59.12 32.85 106.44 73.9 117.7 0 0 6.1 2.68 14.45 2.68 8.36 0 16.03-1.07 16.03-1.07 41.87-10.38 74.9-58.76 74.9-118.67 0-77.67-60.07-116.67-52.07-111.68m-22.8 222.67s-8.44 1.54-15.96 1.54a64.65 64.65 0 0 1-14.71-1.93c-36.96-10.3-66.32-55.13-66.32-109.25 0-19 4.2-37.76 10.24-53.43 8.52-22.05 22.99-39.13 39.63-49.25 0 0 16.79-10.44 31.32-10.61 19.85-.24 34.87 11.32 34.87 11.32 27.85 17.65 47.2 56.53 47.2 101.65 0 54.85-28.57 100.46-66.26 109.96'/%3e%3cg fill='%23c69024' stroke='%23080101' stroke-width='.46'%3e%3cpath d='M566.69 242.43c-26.9 15.88-45.66 51.71-45.66 93.37 0 49.34 26.31 90.51 61.3 100.03l-.94 1.87c-35.39-10.02-61.93-51.84-61.93-101.89 0-41.96 18.57-78.14 45.46-94.64l1.77 1.27zm63.59.14c26.94 15.88 45.73 51.73 45.73 93.4 0 49.36-26.35 90.54-61.39 100.06l.93 1.88c35.45-10.04 62.03-51.86 62.03-101.94 0-41.98-18.68-78.17-45.61-94.68l-.21-.15-1.9 1.22.42.2z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M570.08 251.03c-24.52 14.61-41.62 47.6-41.62 85.96 0 45.42 23.98 83.32 55.87 92.08l.59 2.34-1.44-.61c-32.26-9.24-56.45-47.73-56.45-93.81 0-38.64 17-71.94 41.51-87.13l.2-.14 1.72 1.12-.38.19z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath stroke-width='.49' d='m631.14 240.63.24.17-4.73 9.93-.16-.09c-3.84-2.37-15.17-8.52-29.13-8.33-11.1.15-23.56 6.6-26.46 8.2.92-2.26-5.08-9.89-5.08-9.89l1.31-.75s16.04-9.16 30.1-9.34c19.19-.25 33.91 10.1 33.91 10.1' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath d='M626.76 251.03c24.56 14.62 41.69 47.62 41.69 85.99 0 45.44-24.03 83.35-55.96 92.11l.05 2 1.27-.41c32.07-9.48 56.07-47.83 56.07-93.7 0-38.65-17.03-71.96-41.58-87.16l-.02-.02-1.42-.82-.48 1.82.38.19z' transform='matrix(1.14637 0 0 1.17117 33.18 82.14)'/%3e%3cpath stroke-width='.57' d='m758.74 365.2-.08.04c-2.57 1.26-4.68 4.3-5.52 8.1-.26 1.2-.4 2.7-.36 3.77 0 0-2.87-1.56-2.87-1.8-.02-.98.08-2.03.32-3.1.93-4.24 3.49-7.66 6.4-8.58.04 0 2.11 1.57 2.11 1.57zm-79.57.3.08.04c2.57 1.26 4.68 4.3 5.52 8.1.26 1.2.4 2.7.36 3.77 0 0 2.87-1.56 2.87-1.8.02-.98-.08-2.03-.31-3.1-.94-4.24-3.45-7.64-6.37-8.55a70.56 70.56 0 0 0-2.15 1.54z'/%3e%3cpath stroke-width='.53' d='M738.76 595.14s-.6-.47-1.37-1.32c-.56-3.65-2.58-5.31-2.58-5.31l-.43.04c-.37-1.32-.52-2.8-.26-4.41l-.21.03a65.33 65.33 0 0 1-15.93 1.84 56.54 56.54 0 0 1-13.75-2.12c-.04-.02-.8-.01-.78.06.54 1.58.45 3.14.06 4.56h-.03s-1.81 1.49-2.48 4.74c-.78.98-1.41 1.57-1.41 1.57l1.17.34-.01.22c-.08 3.18 2.9 3.72 4.87 3.74.6 4.02 3.13 3.39 4.46 2.74l-.29.39c.2 2.7 1.6 2.92 3.16 4.25.14.12 1.14.76 1.47 1.22l.06-.02c1.46 2.04 2.55 7.17 4.45 7.17h.5c1.9 0 2.98-5.09 4.44-7.15.32-.46 1.32-1.1 1.46-1.22 1.57-1.33 2.96-1.55 3.16-4.25l-.29-.39c1.33.65 3.85 1.28 4.46-2.74 1.96-.02 4.9-.55 4.87-3.65l1.23-.33z'/%3e%3cpath stroke-width='.53' d='M740.44 594.56c-2.12-1.25-3.9-4.13-4.4-7.48a11.56 11.56 0 0 1-.08-2.98l-2.37-.23c-.27 1.2-.32 2.57-.1 4.03.57 3.79 2.77 6.97 5.24 7.88l1.71-1.22zm-42.41-.12c2.12-1.25 3.9-4.13 4.4-7.48.17-1.05.18-2.05.08-2.98l2.37-.23c.27 1.2.32 2.57.1 4.03-.57 3.79-2.77 6.97-5.24 7.88l-1.71-1.22z'/%3e%3c/g%3e%3cpath fill='%23000' stroke='none' d='M705.48 599.31c1.82-1.34 2.43-3.6 2.9-5.74.03-.1-.01-.51-.02-.46-.47 2.1-1.08 4.34-2.88 5.67-.1.08.05.5 0 .53m4.25 2.98c2.12-.87 3.22-4.2 3.75-6.25.04-.15-.04-.42-.01-.52-.53 2.07-1.64 5.37-3.74 6.24-.09.03.03.52 0 .53m4.88 5.61a13.02 13.02 0 0 0 2.38-6.86c0-.07-.02-.58-.03-.37a12.7 12.7 0 0 1-2.35 6.7c-.1.13.07.44 0 .53m17.97-9.13c-1.8-1.33-2.4-3.56-2.88-5.67 0-.05-.05.36-.02.46.48 2.13 1.08 4.4 2.9 5.74-.05-.04.1-.45 0-.53m-4.11 2.99c-2.1-.87-3.2-4.17-3.74-6.23.03.09-.05.36-.01.51.53 2.06 1.63 5.38 3.75 6.25-.02 0 .1-.5 0-.53m-4.88 5.76a12.7 12.7 0 0 1-2.35-6.7c-.01-.21-.04.3-.03.37.21 2.54.88 4.8 2.38 6.86-.06-.09.1-.4 0-.53'/%3e%3c/g%3e%3cg fill='%23452c25' stroke='%23000' stroke-width='.55'%3e%3cpath d='M662.23 304.61s-4.2 9.73-1.93 10.68c2.28.96 8.06-.57 12.97-9.35 4.9-8.77-2.91-5.49-2.91-5.49l-8.13 4.16zm25.92 6.49s-.7 12.78 0 13.73c.7.96 7.18.96 7.53-8.58.35-9.54-1.4-9.92-1.4-9.92l-6.3 4.39'/%3e%3cpath d='M692.03 295.69s-4.55 14.3-.17 17.17c4.37 2.86 7.88-14.12 8.05-17.93.18-3.82-7.88.76-7.88.76zm3.13 18.27s.88 13.35 3.33 13.93c2.45.57 6.48-3.82 6.48-7.25 0-3.44-4.2-11.45-4.2-11.45l-5.79 4.2'/%3e%3cpath d='M695.28 297.97s-4.55 14.3-.18 17.17c4.38 2.86 7.89-14.12 8.06-17.93.18-3.82-7.88.76-7.88.76zm.35-22.96s-6.66 6.87-6.48 10.68c.17 3.82 9.8-5.15 10.68-6.87.88-1.71-4.2-3.81-4.2-3.81z'/%3e%3cpath d='M691.06 271.16s-5.26 9.73-3.85 12.78 6.48-2.29 8.93-5.72c2.45-3.44-5.08-7.06-5.08-7.06zm-11.82 1.68s-3.5 13.16-.88 14.5c5.15 2.61 8.47-9.11 8.94-13.55.52-4.96-8.06-.95-8.06-.95z'/%3e%3cpath d='M686.82 272.73s-6.66 6.87-6.48 10.68c.17 3.82 9.8-5.15 10.68-6.87.88-1.71-4.2-3.81-4.2-3.81zm-113.54.97s-13.76 6.9-14.96 9.86c-1.2 2.95 41.49-4.48 64.95-21.06l-9.52-5.63-40.47 16.83z'/%3e%3cpath d='M589.51 276.18s-25.05 9.35-6.95 9.72c0 0 35.88-7.47 54.99-22.08l-4.83-7.14-43.21 19.5z'/%3e%3cpath d='M626.31 251.19s-26.45 13.54-23.48 15.07c2.98 1.53 21.73-2.67 31.54-8.77 9.81-6.1 14.02-9.54 14.02-9.54l-11.74-3.25-10.34 6.49zm-9.99 29.71s-9.45 7.91-8.36 8.81c1.1.9 20.42-2.14 35.48-13.96l-1.9-6.97-25.41 11.75'/%3e%3cpath d='M599.85 279.39s-9.06 7.22-7.07 7.8c1.98.6 9.66 6.04 43.64-16.12l4.01-2.47-6-8.46-34.58 19.25zm-6.99-26.08c-28.58 10-57.24 29.91-57.24 29.91 2.8-.95 73.54-29.43 73.54-29.43m46.41 44.14s-6.13 9.35-4.9 10.5c1.22 1.14 8.76 4.76 17.51-7.26 8.76-12.01-8.23-10.1-8.23-10.1l-4.38 6.86z'/%3e%3cpath d='M648.65 289.83s-9.2 11.54-7.27 13.07c1.93 1.52 12.44 1.33 20.32-9.73 7.89-11.07.18-.57.18-.57l-2.28-10.11-10.95 7.34z'/%3e%3cpath d='M639.8 284.39s-8.93 10.68-8.06 12.4c.88 1.72 12.97 1.14 22.95-9.35s1.93-14.3 1.93-14.3l-16.64 10.68'/%3e%3cpath d='m623.95 284.87-5.7 7.92s1.58 7.44 21.2-6.1c19.63-13.55 18.58-12.4 18.58-12.4l-10.52-1.91-23.56 12.5zm-62.5-11.4-12.44 5.59s-2.8 2.46 4.5 2.65c7.3.18 22.4-1.84 48.65-16.72a136.13 136.13 0 0 0 19.38-13.15l-9.56-3.56-50.53 25.19z'/%3e%3cpath d='M540.15 281.31s17.9-1.95 25-6.6c0 0-1.45 2.17 7.7-1.4l51.97-25.36-1.73-3.38s-56.61 24.25-60.9 25.6c-4.28 1.35-22.04 11.14-22.04 11.14z'/%3e%3cpath stroke-width='.64' d='M670.11 304.2s-1.75 14.18.35 14.7c2.1.53 8.06-3.93 10.51-12.6 2.45-8.67-9.63-7.62-9.63-7.62l-1.75 5'/%3e%3cpath d='M679.4 310.24s-1.05 10.4.35 11.35c1.4.95 4.9 1.34 9.11-6.87 4.2-8.2 2.28-5.15 2.28-5.15l-9.46-5.15-2.28 5.82z'/%3e%3cpath d='M682.02 292.21s-7.7 16.79-3.33 16.6c4.38-.2 10.34-12.79 11.21-15.65.88-2.86-7.88-.95-7.88-.95z'/%3e%3cpath d='M681.35 292.06s-2.9 18.5 1.24 16.93c4.14-1.56 6.48-15.5 6.56-18.51.07-3.02-7.8 1.58-7.8 1.58z'/%3e%3cpath d='M687.63 293.93s-4.55 14.3-.18 17.17c4.38 2.86 7.89-14.12 8.06-17.93.18-3.82-7.88.76-7.88.76zm-17.96-4.71s-3.5 13.16-.88 14.5c5.15 2.61 8.47-9.11 8.94-13.55.52-4.96-8.06-.95-8.06-.95zM637 262.07s-11.74 9.73-10.34 11.26c1.4 1.52 15.07-1.15 21.2-5.35 6.13-4.2 8.58-6.48 8.58-6.48l-10.5-6.49-8.94 7.06z'/%3e%3cpath d='M647.34 252.15s-7.53 6.1-6.13 7.63c1.4 1.53 14.89-4 17.34-6.68 2.45-2.67 2.28-5.53 2.28-5.53l-13.49 4.58z'/%3e%3cpath d='M654.52 251s-9.64 8.58-7.18 11.64c2.45 3.05 16.64-10.5 18.57-12.21 1.92-1.72-11.39.57-11.39.57z'/%3e%3cpath d='m650.49 247.38-20.5 9.73s-17.34 11.25-15.59 12.4c1.75 1.14 15.24-2.48 24.88-7.25 9.63-4.77 20.32-12.78 20.32-12.78m-3.4 8.97s-22.18 19.07-18.85 20.98c3.33 1.9 15.37-3.33 25.35-12.49'/%3e%3cpath d='M659.84 263.77s-13.38 22.14-11.98 24.24c1.4 2.1 10.5-4.96 15.07-10.3 4.55-5.34 8.13-13.23 8.13-13.23'/%3e%3cpath d='M666.23 266.6s-13.6 25.27-12.02 27.37c1.57 2.1 9.46.38 14.19-9.54 4.73-9.92 4.32-16.32 4.32-16.32l-6.49-1.51z'/%3e%3cpath d='M674.13 267.81s-15.11 31.2-12.13 34.24c2.98 3.06 19.7-23.65 20.48-27.43 1.34-6.63-8.53-7.38-8.53-7.38m-31.69-20.05s-13.66 6.49-10.86 7.82c2.8 1.34 15.59-4.39 17.34-4.96 1.75-.57-6.48-2.86-6.48-2.86z'/%3e%3cpath d='M644.36 249.29s-8.4 6.68-6.66 8.4c1.75 1.71 14.54-5.16 17-7.26 2.45-2.1-10.34-1.14-10.34-1.14z'/%3e%3cpath stroke-width='.58' d='M662 249.82s-11.5 15.45-7.97 16.06c3.52.61 16.87-9.96 17.05-11.79.19-1.83-9.08-4.27-9.08-4.27z'/%3e%3cpath d='M667.13 253.29s-12.26 15.45-8.76 16.4c3.5.96 3.85-1.52 3.85-1.52s9.64-8.01 10.34-10.11c.7-2.1-5.08-4.96-5.08-4.96'/%3e%3cpath d='M670.99 256.92s-8.94 15.45-6.66 16.4c2.28.96 5.96-2.86 9.64-7.43 3.68-4.58-2.98-8.97-2.98-8.97z'/%3e%3cpath d='M673.26 263.98s-5.26 9.73-3.85 12.78c1.4 3.05 6.48-2.29 8.93-5.72 2.45-3.44-5.08-7.06-5.08-7.06zm2.21 27s-3.5 13.16-.88 14.5c5.15 2.61 8.47-9.11 8.94-13.55.52-4.96-8.06-.95-8.06-.95z'/%3e%3cpath d='M699.54 273.18s-3.5-1.14-6.13-1.14c0 0-7.71-6.1-11.91-6.68-4.2-.57-.62-.67-.62-.67s-.44-10.01-1.66-10.78c0 0-.7-10.3-7.18-11.06-6.49-.76-21.03.57-23.66-.38-2.62-.96-10.68-4.32-25.92-.2-15.6 4.23-46.3 18.01-47.88 18.4-1.58.37 35.26-8.1 45.6-12.67 0 0 10.33-.76 13.49-1.72 0 0-11.74 5.73-.88 3.25 10.86-2.48 8.41 0 8.41 0s-1.05 2.48 5.08 1.14 6.13 0 6.13 0 7.01 2.48 12.44-.76c0 0 2.8 9.73 6.3 11.06 0 0 4.17 8.92 12.93 10.63 0 0 4.16 2.95 5.04 3.52l4.95 1.63 5.3-4.14'/%3e%3cpath d='M627.71 246.81s-35.04 12.59-33.81 16.02c1.22 3.44 36.61-9.72 42.22-13.35 5.6-3.62-7.88-2.86-7.88-2.86'/%3e%3c/g%3e%3cg fill='%23452c25' stroke='%23000' stroke-width='.55'%3e%3cpath stroke-width='.49' d='m869.44 278.12 13.78 7.82s3.36 2.79-4.02 1.15c-7.38-1.65-23.11-7.08-52.84-26.2-13.44-8.66-17.68-8.41-17.68-8.41l18.73.5 42.03 25.14z'/%3e%3cpath stroke-width='.49' d='m873.99 274.72 13.78 7.82s3.36 2.79-4.02 1.15c-7.38-1.65-23.11-7.08-52.84-26.2-13.44-8.66-2.63 7.13-2.63 7.13l2.28-10.38 43.43 20.48z'/%3e%3cpath stroke-width='.48' d='M896.91 282.25s-16.45-3.06-22.45-7.44c0 0 1.06 1.89-7-1.77 0 0 3.11 7.05-19.54-8.38-22.66-15.44-14.74-7.68-14.74-7.68l6.34-1.64s34.78 13.9 38.6 15.35c3.81 1.46 18.8 11.56 18.8 11.56z'/%3e%3cpath d='m810.88 288.41 5.51 7.86s-1.83 7.37-20.97-6.97c-19.13-14.34-18.13-13.15-18.13-13.15l10.57-1.48 23.21 13.18m-25.05 4.5s8.89 11.63 6.9 13.07c-1.97 1.45-12.47.83-19.96-10.55-7.5-11.38-.16-.58-.16-.58l.7-18.4 12.71 15.9'/%3e%3cpath d='M795.15 287s8.56 11.04 7.62 12.72c-.93 1.68-13 .61-22.6-10.28-9.62-10.9-1.44-14.38-1.44-14.38L795 286.42m48.91-5.94s24.39 10.49 6.3 9.8c0 0-35.43-9.54-53.76-25.24l5.18-6.85 42 21.68'/%3e%3cpath d='M856.71 277.45s13.2 8 14.18 11.05c.99 3.05-41.02-7.84-63.18-26.3l9.9-4.84 39.1 20.09zm-38.34 7.26s9.55 7.84 8.46 8.75c-1.08.9-20.44-1.99-35.64-13.69l1.82-6.98 25.55 11.55'/%3e%3cpath d='M834.7 284.04s9.42 6.5 7.47 7.18c-1.96.68-9.35 6.49-44.4-14.04l-4.13-2.27 5.57-8.75 35.5 17.3'/%3e%3cpath d='M798.72 264.81s11.4 10.2 9.94 11.67c-1.45 1.47-15.02-1.76-21-6.2-5.98-4.45-10.33-10.15-10.33-10.15l12.7-2.74 8.69 7.42z'/%3e%3cpath d='m785.14 247.77 20.76 12.37s16.94 11.96 15.15 13.03c-1.8 1.07-15.14-3.1-24.6-8.26-9.47-5.17-20.45-16.28-20.45-16.28m-3.96 57.66s3.87 9.9 1.56 10.75c-2.31.86-8.04-.9-12.64-9.87-4.6-8.97 2.43-4.29 2.43-4.29l8.65 3.41z'/%3e%3cpath d='M778.92 299.89s5.8 9.6 4.54 10.69c-1.27 1.09-8.92 4.4-17.26-7.97-8.33-12.37 8.58-9.76 8.58-9.76l4.14 7.04z'/%3e%3cpath d='M761.58 256.61s19.8 38.23 18.15 40.26c-1.65 2.03-9.47 0-13.85-10.11-4.38-10.11-7.96-23.23-7.96-23.23l3.66-6.92zm23.06 9.72s16.52 14.04 13.13 15.81c-3.4 1.77-9.97-.79-19.63-10.35-9.66-9.56 6.34-6.04 6.34-6.04'/%3e%3cpath d='M776.64 266.57s11.8 21.68 10.33 23.72c-1.47 2.04-10.33-5.39-14.7-10.91-4.36-5.53-7.67-13.56-7.67-13.56'/%3e%3cpath d='M764.94 258.27s8.4 15.8 6.08 16.67c-2.3.86-5.85-3.1-9.37-7.83-3.51-4.73 3.29-8.84 3.29-8.84zm.19 32.33s3.04 13.3.37 14.52c-5.23 2.4-8.14-9.45-8.46-13.9-.35-4.98 8.09-.62 8.09-.62zm-10.46 21.08s.7 9.96-.73 10.85c-1.43.9-4.94 1.13-8.86-7.24-3.92-8.36-2.1-5.24-2.1-5.24l9.63-4.75 2.1 5.43'/%3e%3cpath d='M764.03 309.58s1.4 10.37-.72 10.66c-2.11.3-7.95-3.19-10.19-9.58-2.23-6.4 9.82-5.13 9.82-5.13l1.63 3.69'/%3e%3cpath d='M754.39 277.06s10.82 24.22 9.08 27.67c-3.4 6.75-13.24-14.75-16.21-23.15-3.32-9.39 7.13-4.52 7.13-4.52z'/%3e%3cpath d='M749.37 281.11s14.76 26.66 8.53 27.28c-6.22.62-17.53-19.34-19.43-23.97-1.9-4.64 10.9-3.3 10.9-3.3z'/%3e%3cpath d='M748.49 286.64s7.26 25.55 2.58 23.29c-4.67-2.26-10.3-21.5-11.07-25.66-.77-4.15 8.49 2.37 8.49 2.37zm25.5-36.32s11.2 17.1 7.56 17.6c-3.63.51-16.9-11.42-17.02-13.4-.12-1.97 9.46-4.2 9.46-4.2z'/%3e%3cpath d='M767 251.04s14.27 19.48 9.97 20.47c-4.3.99-4.63-2.06-4.63-2.06s-11.39-10.26-12.15-12.86c-.77-2.6 6.39-5.8 6.39-5.8m27.41-1.06s13.43 7.04 10.58 8.26c-2.84 1.22-15.43-5.02-17.16-5.67-1.73-.64 6.58-2.59 6.58-2.59zm-12.85 1.61s9.81 10.12 7.24 13.55c-2.58 3.43-16.2-12.82-18.06-14.88-1.86-2.07 11.89.93 11.89.93m-24.87 14.46s15.8 30.78 12.9 33.91c-2.92 3.13-20.48-23.08-21.1-26.88-.6-3.8 8.36-7.6 8.36-7.6'/%3e%3cpath stroke-width='.64' d='M748.26 268.19s6.32 9.63 5.96 14.82c-.36 5.19-9.55-7.43-10.34-9.8-.8-2.38 4.38-5.02 4.38-5.02z'/%3e%3cpath d='M761.25 263.2s4.92 9.94 3.4 12.93c-1.5 3-8.2-6.04-10.53-9.57-2.33-3.53 7.13-3.36 7.13-3.36z'/%3e%3cpath stroke-width='.66' d='M738.45 272.97s7.71 8.56 7.34 13.12c-.37 4.56-11.57-6.66-12.55-8.76-.98-2.1 5.21-4.36 5.21-4.36z'/%3e%3cpath d='M788.31 248.28s11.68 10.47 9.86 12.12c-1.8 1.64-17.6-9.67-19.98-11.87-2.38-2.2 10.12-.25 10.12-.25z'/%3e%3cpath d='m778.44 247.52 9.13 7.7s8.49 5.66 7.03 7.13c-1.45 1.47-14.74-4.62-17.1-7.39-2.36-2.77-2.08-5.62-2.08-5.62l3.02-1.82zm30.09 2.42s34.58 14.02 33.23 17.4c-1.34 3.38-36.25-11.22-41.73-15.08-5.47-3.85 7.98-2.53 7.98-2.53'/%3e%3cpath d='M809.78 254.39s25.96 14.62 22.94 16.02c-3.03 1.4-21.62-3.56-31.21-10.06-9.6-6.5-13.68-10.1-13.68-10.1l11.84-2.77 10.11 6.91zm-63.92 17.77s4.92 9.94 3.4 12.93c-1.5 3-6.39-2.55-8.72-6.08-2.33-3.54 5.32-6.85 5.32-6.85zm1.17 22.41s4.06 14.48-.42 17.16c-4.47 2.68-7.39-14.43-7.43-18.25-.04-3.82 7.85 1.09 7.85 1.09z'/%3e%3cpath d='M726.92 270.71s14.44-6.34 17-5.83c0 0 3.03-.76 4.65-2.03 1.63-1.27 5.36-4.31 5.36-4.31s-2.56-17.5 15.83-15.72c18.4 1.78 42.61 4.06 47.5 4.82 4.9.76 22.82 5.83 27.02 7.86 4.19 2.03 31.5 14.39 37.09 16.42 3.3 1.2 10.6 5.76 16.01 9.29 3.72 2.42-.11.69-.11.69s-44.23-23.48-59.87-26.62c-3.91-.79.27 4.48.27 4.48s-10.16-4-14.35-5.78c-4.2-1.78-7.68-2.54-11.64-2.29-3.96.26-6.99-.5-9.32-1.26-2.32-.76-15.6-1.27-17.92-1.52-2.33-.26-4.2-.76-4.2-.76l.94 1.52-6.52-1.02-1.87 2.8s-6.28 1.26-6.75-.77c-.46-2.03-3.73 9.13-5.36 12.42-1.63 3.3-7.68 3.3-9.54 5.33-1.86 2.03-3.03 3.3-3.96 3.8-.93.51-5.59 3.3-7.22 3.3s-11.64.76-11.64.76l-2.56-4.06 1.16-1.52zm18.99 40.99s.26 12.8-.48 13.72c-.73.93-7.2.66-7.23-8.88-.02-9.55 1.75-9.86 1.75-9.86l6.15 4.65'/%3e%3cpath d='M742.56 296.15s4.06 14.48-.42 17.16c-4.47 2.68-7.39-14.43-7.43-18.25-.05-3.82 7.85 1.09 7.85 1.09z'/%3e%3cpath d='M739.24 298.29s4.06 14.48-.42 17.16c-4.47 2.68-7.39-14.43-7.43-18.25-.04-3.82 7.85 1.09 7.85 1.09z'/%3e%3c/g%3e%3cpath fill='%23d9c0b9' stroke='%23000' stroke-width='.55' d='M741.9 357.31s2.49 3.1 2.18 4.1c0 0 2.56-2.58-.74-6.24l-1.44 2.14zm-20.58-5.88h1.5l.56 1.4-.21 1.28-1.3.6s-2.11-.55-1.6 1.98c0 0-.99-4.64 1.05-5.26zm10.54 10.39 1.54-1.7 1.66.87s-.69 4.5-.95 4.83c-.26.33-.3.38-.3.51s-.27-.85-.77-1.42c-.5-.56-1.01-3.04-1.18-3.09zm-16.11-5.59-.76-2.27.88-1.2 1.79-.01.75.36s1.44 3.27.18 4.98c0 0-.53-1.84-1.14-2.1 0 0-1.33-.2-1.7.24zm-16.68 3.91s-2.51 4.2.75 6.3c0 0-.2-3.92 2.35-4.76l-3.1-1.54zm-8.64-1.7 2.27-.59.22.1s-1.49 2.87-1.09 3.57c.41.7-2.03-1.27-1.4-3.08z'/%3e%3cpath fill='%23bd8759' stroke='%23000' stroke-width='.55' d='M730.39 333.74s.08 7.8.08 9.18c0 1.39-.16 3.47-.96 4.68-.79 1.21-1.59 1.9-2.86 1.9-1.27 0-4.61-.17-5.25 1.05-.64 1.2-1.11 1.9-1.11 1.9s2.06-1.21 2.38 0c.32 1.21-.8 2.25-.8 2.25s1.92.35 3.67-.69 2.7-1.21 3.5-1.21c.8 0 1.43.86 1.43.86s.48 2.6.32 4.16c-.16 1.56-.48 4.68 1.27 4.68 0 0 .64-1.56 1.27-1.73.64-.17 2.39 1.56 2.07 2.08 0 0 .32-3.3-.32-5.2-.63-1.9-.95-3.99-.95-3.99s5.41 1.91 5.89 2.6c.47.7 1.75 1.91 2.22 1.74.48-.18 0-1.74.96-2.08.95-.35 1.43.52 1.43.52s-1.59-3.64-3.98-4.85c-2.38-1.22-3.98-1.22-4.93-2.26-.95-1.04-1.12-2.25-1.27-3.46-.16-1.22.04-11.69.04-11.69l-4.1-.44zm-27.02 19.83s-3.96 3.07-4.4 4.51c-.45 1.45-.58 2.84-.58 2.84s3.55-.43 3.11 1.53c0 0 1.15.66 2.98-3.59s3.56-6.08 4.86-5.96c1.3.13 2.95 1.39 3.78 2.27.83.9 1.98 1.55 3.43 1.14 0 0-1.52-2.31-.56-2.82.95-.5 2.41-.4 2.41-.4s-1.2-2.88-3.8-3.3c-2.6-.42-4.4-1.14-3.79-2.27.62-1.13 3.94-9.91 3.94-9.91l-4.4-6.47-1.77 5.63s.58 3.32.6 4.18c.02.85-3.5 8.12-3.98 8.54-.47.43-9.92 4.08-11.04 4.44-1.12.36-3.47 3.15-3.47 3.15l-.27 2.1s1.58-1.3 2.09-.52c0 0 1.1-1.39 2.08-.87.98.52.82.72.82.72s1.75-1.15 2.06-1.72c.3-.56.4-.5.4-.5l2.78-.48'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.55' d='M708.49 345.51c-.41.07-.7.01-.98-.18m2.5-3.67a3.3 3.3 0 0 1-1.3-.46m-.27 2.44c.3.17.63.23.98.18m-4.22 5.85c.19.13.41.21.65.23m26.53-3.86c.65.11 1.24.46 1.91.52m-.79-2.43c-.51.13-.95.03-1.27-.35m1.58-1.9c-.6.07-1.23.04-1.75-.17m-.47 7.79c.6.08 1.17.38 1.75.52m-1.59 1.91c.3-.07.57-.01.8.17m-.33 6.41c.4-.07.78-.01 1.11.17m-21-8.68c-.5.08-.9.38-1.1.87m4.34-.56c-.7.4-1.32.97-1.4 1.78m-18.72 1.79c.54.5 1.34.78 1.81 1.23m40.85-3.87c-.41.19-.69.56-.8 1.04m3.03-.35a.76.76 0 0 0-.48.7'/%3e%3cpath fill='%23452c25' stroke='%23000' stroke-width='.55' d='M747.46 301.88s-1.23-5.54-2.1-6.3c-.88-.77.35-1.54.35-1.54s-2.28-5.54-3.68-6.5c-1.4-.95.17-1.71.17-1.71s-2.45-3.83-4.2-4.97c-1.75-1.15 0-1.34 0-1.34s-1.83-5.13-6.1-7.48c0 0-2.83-2.98-5.72-3.8-2.89-.82-10.05-1.58-18.7-1.42-9.12.16-12.98 6.48-12.98 6.48l-.59 7.33 1.32-.9-1.93 9.14c-.3 2.09 1.63 5.71 1.74 10.08.03 1.38.12 2.82.28 4.3a37.88 37.88 0 0 0 3.1 11.9c.15.3.28 1.2.45.9.44-.76 1.44 2.6 2.34 3.8 0 0 .54 4.55.97 2.86.17-.65 1.63 2.58 2.54 4.61.32.74 2.05 5.76 1.98 3.47-.07-2.5 1.52 5.32 1.52 6.45l2.1-3.06 1.05 3.44 1.75-.2-.52 3.26s4.9-4.02 5.08-5.55c.17-1.52.35-2.67.35-2.67l1.58-1.53 2.45-3.82s6.13 4.77 6.83 6.5c.7 1.71 1.4 3.24 1.4 3.24l1.58-1.53 1.4 3.44.88-1.72.85 2.4.07-.15.56 1.57c.43.4 1.4.6 3.25-2.48 2.62-4.4 2.45-7.83 2.62-8.6.18-.76 1.23 1.34 1.23 1.34s2.28-4.2 1.93-6.88c-.35-2.68 1.4-1.72 1.4-1.72s.35-7.07 0-8.8c-.35-1.71 1.23-1.33 1.23-1.33s-.53-8.4-1.06-9.36c-.52-.96 1.23-1.15 1.23-1.15z'/%3e%3cpath d='M735.18 282.43c1.24.37 1.84 1.76 2.37 2.85-.03-.07.08-.38.01-.52-.53-1.08-1.14-2.5-2.38-2.86 0 0-.08.5 0 .53m1.12 5.28c2.28 1.93 2.48 4.57 2.35 7.45 0 .1.03.6.05.27.13-3.05.1-6.14-2.4-8.25.06.05-.1.44 0 .53m4.75 2.7c1.26 2.07 1.38 4.35 1.38 6.74 0 .3.05.3.05 0 0-2.54-.06-5.03-1.42-7.25.04.05-.09.39-.01.51m1.66 9.99c-.14 1.48-.4 2.93-.7 4.39-.01.1.02.5.03.46.3-1.49.56-2.97.7-4.47.01-.07-.01-.59-.03-.38m-1.53 7.66c.12.97.24 1.93.14 2.9 0 .08.01.6.04.39.13-1.24 0-2.44-.14-3.67-.03-.2-.05.31-.04.38m-2.95-9.62c0 1.64.01 3.27.15 4.9.02.21.04-.3.03-.38-.12-1.5-.13-3-.13-4.52 0-.3-.05-.3-.05 0m-1.25 10.62c.13 1.55.13 3.1.13 4.67 0 .3.05.3.05 0 0-1.69 0-3.37-.14-5.05-.02-.2-.05.31-.04.38m7.01-1.35c.68.71 1.1 1.55 1.24 2.53.02.1.04-.08.04-.1v-.36a4.8 4.8 0 0 0-1.28-2.6c.06.07-.1.42 0 .53m-.42-10.72c.7.58 1.26 1.29 1.82 2-.07-.08.1-.41 0-.53a12.8 12.8 0 0 0-1.82-2c.06.05-.1.44 0 .53m-5.76 8.02c0 1.46-.14 2.9-.4 4.34-.03.1.01.5.02.46.3-1.59.42-3.19.43-4.8 0-.3-.05-.3-.05 0m-3.06 3.19c.12 1.3.12 2.6 0 3.9 0 .08.02.6.04.38.14-1.55.14-3.1 0-4.66-.02-.2-.05.31-.04.38m-10.04-34.24c.8.13 1.48.5 2.2.87.02 0 .33.2.38.12.06-.08-.21-.32-.23-.34a6.35 6.35 0 0 0-1.5-1.1c-.9-.48-1.8-.97-2.83-1.14-.2-.03.56.7.6.73.37.3.9.78 1.38.86m-27.28 26.45c.52 1 .6 2.15 1.12 3.14-.03-.06.08-.38.01-.51-.52-1-.6-2.15-1.12-3.14.04.06-.08.38-.01.51m4.76-26.98c1.17-.42 2.41-.43 3.64-.57.05 0 .02-.54 0-.53-1.22.14-2.47.15-3.64.57-.09.03.02.52 0 .53m6.99-.57a7.93 7.93 0 0 1 3.5-.57c.03 0 .03-.53 0-.53-1.2 0-2.39.04-3.5.57-.1.04.03.52 0 .53m-12.16 6.18c-.15.03-.15.14-.16.28v.36c.02.1.04-.08.04-.1 0 .1.06 0 .12 0 .07-.02.01-.54 0-.54m-.73 18.83c0 .98 0 1.97.15 2.94.02.1.04-.08.04-.1l-.01-.36c-.13-.82-.13-1.65-.13-2.48 0-.3-.05-.3-.05 0m34.7-18.58c.5.14.8.5.97.99a.8.8 0 0 0 .03-.19c0-.1.02-.23-.02-.32-.16-.5-.48-.87-.98-1.01 0 0-.08.5 0 .53m.56 8.56a6.94 6.94 0 0 1 1.67 2.85c-.02-.09.06-.37.02-.52a7 7 0 0 0-1.69-2.86c.06.06-.1.42 0 .53m-1.82-6.28c.76.66 1.4 1.42 2.1 2.14-.07-.06.1-.43 0-.53-.7-.72-1.34-1.49-2.1-2.14.06.05-.1.44 0 .53m2.09 14.25a6.06 6.06 0 0 1-.55 3.51c-.06.14.04.44.01.52.61-1.46.83-2.93.57-4.49-.01-.05-.05.36-.03.46m1.95 4.42c.1.66.12 1.3 0 1.97a1.6 1.6 0 0 0 0 .36c0 .02 0 .2.03.1a8.9 8.9 0 0 0 0-2.89c-.02-.1-.04.08-.04.1l.01.36m7.56 15.6c.5 1.79.54 3.61.54 5.46 0 .3.05.3.05 0 0-2.02-.03-4.02-.58-5.97.03.08-.05.36-.01.51m-1.26 3.63a30.58 30.58 0 0 1-1.4 3.71c-.06.14.05.45.02.52.57-1.2.98-2.46 1.4-3.72.04-.14-.05-.43-.02-.51m-42.21-12.05c1.17 1.52 1.8 3.35 2.79 4.99-.03-.06.09-.4.01-.51-.99-1.65-1.62-3.48-2.8-5.01.07.08-.1.4 0 .53m7.41.18c-1.07.14-1.33-1.4-2.24-1.71.02 0-.08.5 0 .53.9.32 1.17 1.85 2.24 1.71.06 0 .02-.53 0-.53m-4.2 7.09c.77 1.35 1.27 2.83 2.1 4.14-.04-.05.09-.4.01-.51-.82-1.31-1.33-2.8-2.1-4.14.04.05-.08.38-.01.51m4.9 1.73a11.07 11.07 0 0 1 2.09 3.42c-.03-.08.06-.37.01-.52a11.2 11.2 0 0 0-2.1-3.43c.07.08-.1.41 0 .53m-.43 5.13c.43.9.82 1.82 1.26 2.71-.03-.06.08-.38.01-.51-.43-.9-.82-1.82-1.26-2.71.04.06-.07.38-.01.51m4.61 1c.25.94.4 1.9.4 2.88 0 .3.05.3.05 0a13.55 13.55 0 0 0-.44-3.4c.03.1-.05.37-.01.52m-1.96 4.26c.3 1.36.7 2.68 1.4 3.88-.03-.05.09-.39.02-.51-.7-1.18-1.1-2.5-1.4-3.83 0-.05-.04.36-.02.46m1.13-18.1c1.1.42 2.21.84 3.36 1.14 0 0 .07-.51 0-.53-1.15-.3-2.25-.72-3.36-1.14.02 0-.09.5 0 .53m.84 4.71c1.32.73 2.7 1.32 4.05 2-.03-.02.1-.48 0-.53-1.34-.68-2.73-1.27-4.05-2 .04.02-.1.47 0 .53m1.26 5.28c.68.83 1.42 1.59 2.24 2.29-.06-.06.1-.45 0-.54-.82-.7-1.56-1.45-2.24-2.28.07.08-.1.41 0 .53m1.39 6.56c.57.9.83 1.91.97 2.97.02.1.04-.08.04-.1l-.01-.36a7.39 7.39 0 0 0-.99-3.02c.04.05-.08.39-.01.51m3.91-16.31c.12.63.27 1.26.43 1.88-.03-.09.05-.36.01-.51-.15-.6-.3-1.22-.41-1.83-.02-.1-.04.08-.04.1 0 .12-.01.24.01.36m9.79-3.91c-.28.7-.6 1.36-.98 2-.07.12.05.46.01.51.38-.64.7-1.3.98-2 .06-.14-.04-.43-.01-.51m4.03-.17c0 1.12-.02 2.24-.27 3.34-.02.1.02.51.03.46.28-1.25.3-2.52.3-3.8 0-.3-.06-.3-.06 0m.85 6.19c.1.96 0 1.91-.13 2.87-.02.1.02.5.02.46.17-1.24.28-2.46.15-3.7-.03-.21-.05.3-.04.37m3.08 5.86a5.44 5.44 0 0 1-1.94 3.25c-.1.1.06.48 0 .53a5.54 5.54 0 0 0 1.97-3.32c.01-.1-.02-.5-.03-.46m-9.92-5.74c-.28.56-.64 1.06-.98 1.57-.05.07-.02.25-.02.33 0 .02.02.21.03.18.34-.51.7-1.01.98-1.57.04-.08.02-.23.02-.32 0-.02-.02-.21-.03-.19m1.13 7.85a7.8 7.8 0 0 1-1.4 1.57c-.1.08.06.49 0 .53.56-.43.98-1 1.4-1.57.04-.06.03-.2.03-.26 0-.03-.04-.26-.03-.27m-3.5 4.14c-1.37-1.35-2-3.08-1.4-5.05.06-.14-.03-.43 0-.51a5.9 5.9 0 0 0 1.4 6.1c-.06-.07.1-.44 0-.54m-4.62-4.36c.1.8.1 1.6-.13 2.37-.05.15.04.43.01.51.33-1.08.3-2.23.15-3.34-.02-.1-.04.08-.04.1l.01.36m10.63 5.23c-.29.97-.81 1.82-1.26 2.71-.06.14.05.45.02.52.44-.9.97-1.75 1.25-2.72.05-.14-.04-.42-.01-.51m6.85 2.85a38.1 38.1 0 0 1-1.96 3c-.08.11.05.47.02.51.68-.98 1.36-1.95 1.95-3 .07-.12-.04-.45-.01-.51m3.34 3.6a70.2 70.2 0 0 0-.57 5.52c0 .09.02.6.05.27.13-1.78.27-3.56.55-5.33.01-.1-.02-.5-.03-.46m4.33-6.41c.01.62.13 1.24.14 1.86 0 .37.05.02.05-.15-.01-.62-.13-1.23-.14-1.85 0-.38-.05-.03-.05.14m-45.98-20.15a11.3 11.3 0 0 0 .57 5.34c-.03-.08.06-.37 0-.51a9.03 9.03 0 0 1-.54-4.37c.01-.1-.03-.5-.03-.46'/%3e%3cpath fill='%23dcddde' d='M697.1 285.19s-.53-5.3.96-5.88c0 0 .53-4.87 7.01-4.2 0 0 2.2-3.62 5.7-1.71 0 0 3.32-1.63 5.25-.67 1.93.95 4.3 2.57 4.47 2.95 0 0 2.8-.57 4.11.48s.7 4.48.7 4.48 3.16 2.42 3.42 4.55c.26 2.13.26 2.99-.44 3.56 0 0 1.4 1.15 1.14 2.77s-1.58 3.97-1.84 3.97.18 4.23-1.22 5.66c-1.4 1.43-2.72 1.72-3.33 1.91-.61.2-2.2 2.48-3.68 2.77-1.49.28-3.5-2.3-3.68-3.06-.18-.76-2.19-1.62-2.19-1.62s-4.56 4.87-7.62 4.1a7.93 7.93 0 0 1-4.82-3.81c-.26-.48-1.14-4-1.14-4s-3.41-2.01-3.15-3.92c.26-1.9 1.66-4.2 1.66-4.2l-1.31-4.13z'/%3e%3cg fill='%23fff'%3e%3cpath d='M712.57 281.17c2.95-2.7 6.85-5.56 11.04-4.56 0 0 .07-.52 0-.54-4.19-1-8.09 1.86-11.04 4.57-.1.1.06.47 0 .53m14.19 3.23c-2.96-2.01-8.14-2.75-11.04-.27-.1.1.06.48 0 .53 2.9-2.48 8.08-1.74 11.04.27-.05-.03.1-.46 0-.53m-11.3 4.55c1.21 3.93 2.78 7.93 2.1 12.13-.02.1.02.5.02.46.74-4.55-.78-8.82-2.1-13.1.02.08-.07.36-.02.51m-4.74 2.39c.73 3.97.26 7.99 0 11.98-.02.1.01.6.04.27.28-4.23.76-8.5-.01-12.7-.01-.06-.05.35-.03.45m6.32-2.92c3.86.92 7.64 3.49 9.72 6.97-.04-.06.08-.39.01-.51a15.86 15.86 0 0 0-9.73-7s-.07.52 0 .54m-3.44 5.37c.01 2.44.2 4.89-.5 7.26-.05.15.03.43 0 .51.77-2.53.57-5.15.55-7.77 0-.3-.05-.3-.05 0m6.07-.54c2.43 2 4.35 5.04 4.71 8.24.03.21.05-.3.04-.37a13.17 13.17 0 0 0-4.75-8.4c.06.05-.1.44 0 .53m-17.87 6.7c.8-1.15 1.8-2.45 3.15-2.94.08-.04-.02-.53 0-.54-1.36.5-2.35 1.81-3.16 2.97-.08.11.04.46.01.51m5.78-20.88c-.51-2.18-2.15-3.47-3.9-4.65.04.03-.1.42 0 .48 1.74 1.16 3.38 2.45 3.89 4.63-.02-.09.04-.32.01-.46m-3.42-.04c-2.02-.96-4.11-1.07-6.3-1.07-.05 0-.05.53 0 .53 2.19 0 4.28.11 6.3 1.07-.03-.01.1-.48 0-.53m6.32-.34c.27-2.1-.04-4.08-1.85-5.37.04.03-.1.4 0 .46 1.52 1.09 2.07 2.6 1.83 4.5a2 2 0 0 0 .02.41m7.61 2.48c1.9-1.01 3.97-.82 6.04-.8.04 0 .04-.54 0-.54-2.07-.01-4.14-.2-6.04.8-.1.06.04.52 0 .54m3.42 5.1c2.93.31 5.17 1.82 7.1 4.03-.13-.15.2-.84 0-1.07-1.93-2.2-4.17-3.72-7.1-4.03-.04 0-.11 1.06 0 1.07m-12.89 8.08c-.7 2.8-.16 6.35-3.4 7.5-.18.06.03 1.05 0 1.06 3.28-1.16 2.73-4.7 3.43-7.53.07-.3-.08-.85-.03-1.03'/%3e%3cpath d='M715.45 292.16c1.12 2.95 2.7 5.96 2.09 9.23-.04.2.03 1.01.05.92.74-4.03-.7-7.48-2.11-11.18.06.16-.14.75-.03 1.03m4.22-.52a6.95 6.95 0 0 1 5.75 5.83c.03.21.08-.16.08-.19.01-.24 0-.49-.02-.73-.39-2.97-2.88-5.6-5.81-5.98-.04 0-.12 1.06 0 1.07m-.03 4.22c.45 2.45 1.14 4.9.27 7.35-.1.29.09.86.03 1.03 1.08-3.06.31-6.22-.25-9.3-.02-.1-.09.71-.05.92m-1.55-10.66c3.15-.53 6.47-1 9.2 1.07-.11-.08.2-.9 0-1.06-2.73-2.08-6.05-1.6-9.2-1.08-.13.03-.02 1.07 0 1.07m-5.76-6.25c.38-2.6 2.67-4.46 4.97-5.3.17-.06-.04-1.05 0-1.06-2.38.86-4.64 2.77-5.02 5.44a3.7 3.7 0 0 0-.02.73c0 .03.04.4.07.19m-2.87 1.56c-.08-2.88-1.34-5.2-2.58-7.73.05.12-.14.68-.03.91 1.12 2.26 2.45 4.47 2.52 7.07.02.66.1.05.09-.25m-2.64 1.55c-.56-2.57-2.25-4.27-4.5-5.44.08.04-.19.96 0 1.06 2.17 1.14 3.9 2.8 4.45 5.3.02.1.1-.71.05-.92m-4.24-1.03c-1.47-1.02-3.01-1.99-4.8-2.26-.02 0-.1.82 0 .83 1.79.28 3.33 1.24 4.8 2.26-.08-.05.16-.72 0-.83m9.17 12.06c.25 2.73.6 5.48-.77 7.97-.13.25.1.9.03 1.03 1.63-2.98 1.11-6.5.81-9.75-.03-.42-.08.61-.07.75'/%3e%3cpath d='M714.92 291.62c.91 2.56 1.99 5.3 1.8 8.08 0 .17.06 1.2.1.54.22-3.4-.75-6.5-1.87-9.65.05.16-.13.74-.03 1.03m2.12-3.74c2.6.8 5.2 1.65 7.1 3.76-.13-.14.2-.84 0-1.07-1.9-2.1-4.5-2.95-7.1-3.76.02.01-.16 1.02 0 1.07m-7.06-5.79c.28-2.27.52-4.53.54-6.82 0-.6-.1-.6-.1 0a54.3 54.3 0 0 1-.51 6.07c-.02.14.02 1.17.07.75m-4.77-1.45a23.15 23.15 0 0 1-5.26-3.49c.12.1-.2.89 0 1.07a23.12 23.12 0 0 0 5.26 3.49c-.06-.03.19-.98 0-1.07m-.79 13.69a6.64 6.64 0 0 0-2.64 3.24c-.08.19-.04.46-.04.66 0 .04.05.41.07.37a6.57 6.57 0 0 1 2.61-3.2c.2-.13-.1-1.01 0-1.07m3.37 2c-.05 1.87-1.08 3.42-2.32 4.7-.2.22.13.94 0 1.08a7.93 7.93 0 0 0 2.42-5.5c0-.34-.08-1.03-.1-.28m8.82-14.7c1.55-2.45 5.3-2.65 7.8-3.34.16-.04 0-1.06 0-1.06-2.53.69-6.26.9-7.83 3.37-.15.24.1.93.03 1.03m-17.23-.04a8.55 8.55 0 0 1-1.7-.8c.05.03-.12.6 0 .66.55.31 1.1.62 1.7.8-.01 0 .1-.63 0-.66m.34 12.54c-.54.22-1.1.45-1.47.93-.1.1-.05.4-.05.53l.01.38c0-.02.03.17.04.15.37-.48.93-.7 1.47-.92.08-.04.05-.47.05-.54 0-.02-.02-.54-.05-.53m2.26.58a6.8 6.8 0 0 0-2.62 2.45c-.12.17.08.73.03.8a6.73 6.73 0 0 1 2.6-2.41c.14-.07-.05-.82-.01-.84m4.29 1.06c-.97 2.37-3.62 4.98-1.7 7.63-.06-.1.19-.81.03-1.03-1.33-1.83 1.01-3.9 1.7-5.57.11-.28-.1-.88-.03-1.03m3.03-.04c.07 2.41-.35 4.8-.77 7.15-.04.21.04 1.02.05.92.5-2.77.9-5.53.82-8.35-.02-.75-.11-.06-.1.28m7.75-2.85c1.76 2.3 3.31 4.78 4.06 7.62-.04-.18.11-.73.03-1.03-.75-2.86-2.32-5.34-4.09-7.66.13.18-.19.82 0 1.07m.91-1.85c2.89 2.2 6.1 4.27 8.14 7.39-.06-.1.18-.8.03-1.03-2.05-3.13-5.27-5.21-8.17-7.43.1.09-.2.91 0 1.07'/%3e%3cpath d='M719.66 287.22a6.78 6.78 0 0 1 3.1.31c.92.34 1.68 1.1 2.51 1.6.84.5 1.69.97 2.37 1.69.9.94.91 2.55 1.17 3.77.02.08.09-.61.05-.79-.22-1-.33-2-.67-2.97-.33-.94-1.14-1.52-1.94-2.02-.95-.61-1.88-1.23-2.82-1.85-1.12-.73-2.5-.77-3.77-.65-.1.01-.04.91 0 .91'/%3e%3cpath d='M726.73 293.14c.32.93.7 1.85 1.01 2.78-.03-.1.08-.48.02-.67-.32-.93-.7-1.85-1.01-2.78.03.11-.08.48-.02.67m-8.09-14.73c2.04-.56 4.12-.93 6.12-1.62.17-.06-.03-1.06 0-1.07-2 .7-4.08 1.06-6.12 1.62-.16.05.01 1.07 0 1.07m-8.49 1.02a9.3 9.3 0 0 1 1.36-2.88c.76-1.13.87-2.55 1.8-3.58.2-.23-.13-.93 0-1.07-.77.85-1.04 1.95-1.48 2.98-.52 1.25-1.35 2.17-1.7 3.52-.09.3.07.85.02 1.03m-6.95 19.06a9.33 9.33 0 0 0 .35 5.26c-.06-.16.14-.75.03-1.03a5.63 5.63 0 0 1-.33-3.31c.05-.23.03-.5.02-.73 0-.04-.03-.4-.07-.19m4.22 3.31c-.73 1-.74 2.5-.35 3.65.01.04.06-.31.06-.35 0-.2.02-.44-.04-.62-.21-.64-.05-1.16.33-1.68.08-.1.05-.37.05-.5 0-.05-.07-.47-.05-.5m3.14-1.68c-.03 1.01-.57 1.97-1 2.86-.08.2.07.64.03.74.52-1.1 1-2.16 1.04-3.4.01-.24-.05-.74-.07-.2m.09-5.92v1.27c0 .04 0 .54.05.54.06 0 .05-.5.05-.54v-1.27c0-.04.01-.53-.05-.53-.06 0-.05.5-.05.53m-1.43.74c.08.15.15.3.2.46.04.23.06.24.06.04l-.05.26c-.04.24-.03.5-.01.73 0 .04.03.4.07.2.16-.88.2-1.92-.24-2.72-.03-.05-.07.34-.07.38 0 .17-.05.5.04.65m-2.04-.67a14.3 14.3 0 0 0-.47 2.02c-.03.24-.03.5-.01.73 0 .03.03.4.07.2.1-.66.24-1.3.44-1.92.06-.2.04-.45.03-.66 0-.05-.05-.41-.06-.37m-1.57.09a11.7 11.7 0 0 1-3.51 2.66c-.2.11.08 1.02 0 1.07a11.7 11.7 0 0 0 3.51-2.66c.09-.11.05-.4.05-.54 0-.05-.07-.51-.05-.53m-2.72.46c-.58.46-1.23.8-1.93 1.04-.17.06.03 1.06 0 1.07.7-.25 1.35-.58 1.93-1.04.1-.08.05-.44.05-.54l-.05-.53m-3.85-.94c-.56.25-1.14.47-1.7.72-.15.06.04.83 0 .85.56-.25 1.14-.46 1.7-.72.15-.06-.04-.83 0-.85m11.73-.47c.01.7.12 1.37.25 2.06.04.2.07-.16.07-.2.02-.23.03-.5-.02-.73-.09-.46-.2-.94-.2-1.41 0-.05-.05-.42-.06-.37-.07.19-.04.45-.04.65m1.81-.83c0 .82.09 1.6.38 2.37.01.04.06-.33.06-.38 0-.2.04-.46-.03-.65-.16-.43-.3-.88-.3-1.34 0-.04 0-.53-.06-.53s-.05.5-.05.53m1.4-.18c.24.34.52.81.53 1.25 0 .04.05.41.06.37.07-.2.05-.45.04-.65a3.44 3.44 0 0 0-.6-2c-.04-.05-.07.34-.07.38 0 .15-.05.52.04.65m1.71-.68c.6.13 1.14.37 1.59.81l.05-.53c0-.11.04-.45-.05-.54a3.15 3.15 0 0 0-1.59-.8s-.14 1.03 0 1.06m.91-1.39c.7.58 1.47 1.02 2.38 1.16.03 0 .12-1.05 0-1.07a4.83 4.83 0 0 1-2.38-1.16l-.05.54c0 .1-.04.45.05.53m1.92-4.63c.61 0 1.21.1 1.81.23.01 0 .14-1.04 0-1.06-.6-.13-1.2-.23-1.81-.24-.08 0-.08 1.07 0 1.07m-.89-2.21c.37-.6.92-1.05 1.46-1.49.09-.07.05-.43.05-.53l-.05-.53c-.55.45-1.11.9-1.49 1.52-.09.15-.04.5-.04.66 0 .03.04.42.07.37m-1.69-2.14c.1-.7.34-1.33.77-1.9.08-.11.05-.4.05-.53 0-.06-.07-.5-.05-.53a4.3 4.3 0 0 0-.84 2.77c0 .03.04.4.07.19m-1.37-.99c.7-.98 1.17-2.1 1.81-3.12.1-.15.04-.5.04-.66 0-.04-.03-.42-.07-.37-.64 1.01-1.11 2.14-1.8 3.12-.1.14-.05.5-.04.66 0 .03.02.42.06.37'/%3e%3cpath d='M711.45 276.86c.03 1.2.11 2.39.36 3.56.05.2.07-.15.08-.2.01-.22.03-.5-.02-.72-.21-.96-.3-1.94-.32-2.92-.02-.75-.1-.06-.1.28m-5.06.84c.18.43.42.84.64 1.26a8.28 8.28 0 0 1 .46 1.12c-.06-.22.05-.16-.08.07-.15.24.1.9.03 1.02.3-.53.26-1.39.12-1.96-.22-.92-.78-1.68-1.14-2.54.06.15-.15.75-.03 1.03m-1.01 2.08a18.6 18.6 0 0 0-2.27-1.85l-.05.53c0 .1-.04.47.05.53a18.8 18.8 0 0 1 2.27 1.86l.05-.54c0-.11.04-.44-.05-.53m3.31 1.11c.47-2.34.38-4.68-.58-6.88.06.15-.15.75-.03 1.03.7 1.6.91 3.17.56 4.93-.05.23-.03.5-.02.73 0 .03.03.4.07.19m4.96-3.06c.08 0 .08-1.07 0-1.07s-.08 1.07 0 1.07'/%3e%3cpath d='M708.04 280.99c.12-1.32.43-2.62.57-3.94a5.8 5.8 0 0 0 0-1.13c-.03-.27-.09-.26-.11 0-.14 1.32-.45 2.62-.57 3.94a6.1 6.1 0 0 0 0 1.13c.03.27.08.27.11 0m14.34 8.22a4.68 4.68 0 0 1 2.81 2.29c.04.07.1-.5.1-.56 0-.28.06-.73-.06-.99a4.76 4.76 0 0 0-2.85-2.34c.04.01-.25 1.52 0 1.6m-3.88 7.96c.2.68.22 1.3.1 2.01-.07.35-.05.74-.03 1.1 0 .05.05.59.1.28.3-1.6.34-3.37-.13-4.93-.01-.06-.1.49-.1.56 0 .3-.03.68.06.98m-3.23-2.16c0 1.32.08 2.64-.19 3.94-.07.35-.05.74-.02 1.1 0 .05.04.58.1.28.36-1.75.28-3.54.27-5.32 0-.05.01-.8-.08-.8s-.08.74-.08.8m-1.64 1.43c-.46 1.75-.9 3.51-1.27 5.29-.06.35-.04.74-.02 1.1 0 .05.04.58.1.28.35-1.73.79-3.43 1.23-5.13.12-.45-.11-1.27-.04-1.54m2.21 1.12c.01 1.5.19 3.03.02 4.53-.04.37-.03.76 0 1.13.03.27.08.26.11 0 .22-1.9.05-3.77.03-5.66 0-.06.01-.8-.08-.8s-.08.74-.08.8m-10.61.8c.03-.48.03-.57-.01-.29a2.5 2.5 0 0 1-.31.8c-.13.23-.06.72-.06.98 0 .05.06.64.1.56.56-1 .51-2.32.36-3.43-.04-.3-.1.24-.1.29-.03.36-.03.73.02 1.09m4.66-3.16c.31.6.29 1.12.28 1.78 0 .05 0 .8.08.8.09 0 .08-.75.08-.8 0-1.1.12-2.31-.4-3.32-.04-.08-.1.5-.1.56 0 .26-.07.73.06.98m1.27-.55c.17.14.32.29.44.48l.12.27c.04.1.05.39.04.05 0 .16.01.32.04.48 0 0 .02.18.06.08.1-.29.06-.68.06-.98-.02-.78-.13-1.48-.76-1.98-.03-.02-.06.26-.06.24a5.49 5.49 0 0 0 0 1.13c.01.04.01.19.06.23m1.57-1.42c.25.5.54 1 .8 1.5.03.09.05-.06.05-.08.03-.15.03-.31.04-.47l-.01-.62c0-.1 0-.27-.05-.37-.25-.5-.54-1-.79-1.5-.04-.08-.06.07-.06.08l-.03.48v.61c0 .1 0 .27.05.37m3.51-1.27a39.9 39.9 0 0 0 1.95 2.58c-.03-.03.07-.72.07-.8 0-.2.06-.64-.07-.8-.68-.81-1.3-1.66-1.9-2.52-.06-.08-.1.5-.1.56-.01.22-.1.78.05.98m1.81-3.01c.47.83 1.01 1.6 1.6 2.34-.02-.03.08-.72.08-.8 0-.19.06-.63-.07-.8a17 17 0 0 1-1.57-2.28c-.04-.08-.1.5-.1.56 0 .25-.07.75.06.98m-17.65-8.05a7.08 7.08 0 0 0-1.7-1.04 4.6 4.6 0 0 0-.08.8c0 .1-.04.74.08.8.62.26 1.18.62 1.7 1.04l.08-.8c0-.15.06-.69-.08-.8m5.53-1.9a4.55 4.55 0 0 1 .17.48c0 .16.01.33.04.48 0 0 .02.18.06.08.1-.29.06-.68.05-.98 0-.55-.06-1.1-.28-1.6-.04-.09-.06.07-.06.08l-.03.48c-.01.28-.07.71.05.98m4.36-4.15a5.74 5.74 0 0 1-.62 3.07c-.14.23-.07.73-.06.98 0 .06.05.64.1.56.84-1.44.77-3.41.73-5.04 0-.06-.07-.62-.1-.55-.1.29-.06.68-.05.98m.98 5.91a6.46 6.46 0 0 0 2.06-2.58c.12-.25.06-.71.06-.98 0-.05-.06-.63-.1-.56a6.3 6.3 0 0 1-2.02 2.52c-.13.1-.08.67-.08.8 0 .05.06.81.08.8m2.72-.11c.32-.33.59-.7.9-1.04.05-.05.05-.17.06-.24a5.83 5.83 0 0 0 0-1.13c0 .03-.03-.25-.05-.23-.32.33-.6.7-.91 1.04-.05.05-.05.17-.06.24a5.49 5.49 0 0 0 0 1.13c0-.03.04.25.06.23m4.08.71c-1.02 0-2.04-.01-3.06-.12-.07 0-.16 1.59 0 1.6 1.02.1 2.04.12 3.06.12.11 0 .12-1.6 0-1.6m-.91 3.68c1.36.82 2.68 1.7 4.08 2.43-.1-.06.3-1.44 0-1.6-1.4-.73-2.72-1.61-4.08-2.43.13.08-.3 1.42 0 1.6'/%3e%3cpath d='M717.28 287.82c1.21.77 2.53 1.36 3.63 2.32l.07-.8c0-.16.06-.68-.07-.8-1.1-.96-2.42-1.55-3.63-2.32-.02-.01-.08.76-.08.8 0 .13-.05.71.08.8m-7.8-5.81c.17-.58.17-1.2.17-1.81 0-.06.01-.8-.08-.8s-.08.74-.08.8c0 .22 0 .03 0 0 0 .1-.02.18-.05.27-.1.3-.06.67-.06.98 0 .16.01.32.04.48 0-.02.03.18.06.08m-9.54-4.26c1.06 1.3 2.41 2.25 3.72 3.27.97.75 1.7 2.04 2.74 2.63-.12-.07.3-1.42 0-1.6-.94-.53-1.58-1.67-2.41-2.37-1.39-1.16-2.89-2.1-4.05-3.53.2.24-.3 1.24 0 1.6m2.27 4.31a31.68 31.68 0 0 1-1.81-2.08c-.02-.02-.06.26-.06.23-.02.19-.02.38-.02.57 0 .19-.06.63.08.8.58.71 1.17 1.42 1.8 2.08l.09-.8c0-.17.06-.66-.08-.8m-1.27 10.56c-.43.78-.79 1.59-1.34 2.29-.13.16-.08.6-.08.8 0 .08.1.76.08.8.57-.72.94-1.55 1.38-2.35.13-.24.06-.72.06-.98 0-.06-.06-.64-.1-.56m1.19 1.6c-.02.89-.32 1.78-.43 2.66-.05.37-.04.76 0 1.13.02.27.07.26.1 0 .15-1.14.46-2.21.48-3.36 0-.3.05-.7-.05-.99-.03-.06-.1.5-.1.56m4.18 7.35c.76-2.53.67-5.2.62-7.81-.02-1.12-.16-.09-.15.42.04 1.98.06 3.94-.51 5.85-.13.44.12 1.28.04 1.54m2.45-6.14c.29.88.35 1.68.2 2.6a5.2 5.2 0 0 0-.02 1.08c0 .05.06.6.1.29.28-1.8.34-3.76-.24-5.51-.02-.06-.1.49-.1.56 0 .3-.04.68.06.98m2.4-.89a5.55 5.55 0 0 1 1.06 3.9c-.01.25.08 1.78.14.8.13-2.08.18-4.6-1.2-6.3.02.03-.08.72-.08.8 0 .2-.05.64.08.8'/%3e%3cpath d='M711.82 293.47c.55 2.3.98 4.62 1.21 6.97.06.63.13-.92.11-1.13a55.1 55.1 0 0 0-1.28-7.38c.07.28-.15 1.08-.04 1.54m2.27-.58a15 15 0 0 1 2.38 4.51c.02.06.1-.48.1-.55 0-.32.03-.68-.06-.99a14.98 14.98 0 0 0-2.38-4.51c.1.13-.28 1.21-.04 1.54m4.68-3.86c-.47-.8-1.45-.9-2.29-.84-.15.01-.07 1.6 0 1.6.8-.07 1.8 0 2.25.78.04.08.1-.5.1-.56 0-.25.07-.75-.06-.98'/%3e%3cpath d='M716.37 288.4c1.47-.21 2.94-.23 4.42-.23.12 0 .12-1.6 0-1.6-1.48 0-2.95.02-4.42.23-.18.03-.05 1.6 0 1.6m2.72-12.13c-1.17 1.4-1.8 3.31-2.2 5.09-.07.34-.04.74-.02 1.09 0 .06.04.59.1.29.38-1.69 1-3.54 2.12-4.87.14-.16.08-.61.08-.8 0-.08-.1-.77-.08-.8m-6.38 1.37c.22 1.35.77 2.6 1.15 3.9.02.06.1-.49.1-.56 0-.31.03-.68-.06-.98-.36-1.25-.9-2.45-1.11-3.74-.05-.3-.1.24-.1.29-.03.36-.04.73.02 1.09m-1.21 2.33a6.39 6.39 0 0 1-1.22-2.17c-.04-.1-.07.1-.06.08-.03.16-.04.32-.04.48 0 .3-.04.68.05.98.26.84.73 1.55 1.27 2.23.02.02.06-.26.06-.24l.02-.56c0-.2.05-.63-.08-.8m-2.15 1.05a16.4 16.4 0 0 1-4.99-2.43c.17.12-.3 1.36 0 1.6a16.4 16.4 0 0 0 4.99 2.43c-.04-.01.25-1.52 0-1.6'/%3e%3c/g%3e%3cg stroke-width='0'%3e%3cpath fill='%23d9c0b9' stroke='%23000' stroke-width='.55' d='M670.35 297.23s-2.95-5.08 5.24-7.57c0 0 2.48 1.35 3.05 2.28 0 0-1.43 2.39-6.1 3 0 0-2.1.63-2.19 2.29z'/%3e%3cpath fill='%235e3f17' d='M675.77 290.98c-1.34.82-3.45.83-3.87 2.68v.12c.43-1.85 2.54-1.85 3.87-2.67.03-.01-.01-.12 0-.13'/%3e%3cpath fill='%23d9c0b9' stroke='%23000' stroke-width='.55' d='M671.21 296.4s3.3.7 5.52-.93c1.83-1.34 2.48-.73 2.96-.63 0 0 .1-1.65-1.05-2.9 0 0-2.32 1.91-4.03 2.43-1.71.52-2.87.35-3.4 2.03z'/%3e%3cpath fill='%23dba05f' stroke='%23000' stroke-width='.55' d='M711.3 280.57s-7.05 1.2-8.9 1.63a50.5 50.5 0 0 1-7.54.86c-1.47 0-3.72-1.18-5.3-1.5-1.56-.32-6.65-.85-8.5 1.07s-3.04 2.56-3.63 3.2c-.58.64-2.94 2.73-3.04 3.65-.09.93.6 2.31 1.77 2.31 1.18 0 3.64 2.5 3.64 3.03 0 .87 3.22 1.8 6.27 1.79 5.49-.03 8.19-2.8 16.42-1.83 4.48.53 12.72-2.99 14.2-5.12 1.46-2.13 2.34-4.37.87-6.82-1.46-2.45-5.87-2.2-6.26-2.27z'/%3e%3cpath d='M681.79 288.47s-.02.16-.05-.09l-.04-.18-.05-.13-.01-.15c-.03-.05.15.04.72-.52l.48-.73c-.04.02.7-.91 1.77-1.16 1.08-.25 2.07-.07 2.21-.06.05-.06-2.44-.1-2.6.2 0-.2 2.4-.28 2.52-.11.03-.06-2.25-.08-2.42.24 0-.14 2.07-.24 2.3-.05 0 0-.39-.05-.5-.04l.19.04h-.3l-.16-.02c0-.01.45.05.48.1 0 0 .2-.07-.6-.02 0 0-.5-.1-1.3.16-1.07.16-1.03 1.6-2.64 2.52'/%3e%3cpath fill='none' d='M681.62 287.87c.1 0 .79-.27 1.45-1.5-.19-.33 2.49-1.38 2.77-1.04 0-.01.73 0 1.14.07'/%3e%3cpath fill='none' d='M684.27 285.55c-.27-.04-1.63 1.1-1.5 1.17-.3.7-1.07 1.17-1.15 1.15m2.76-2.15c0-.09 1.84-.26 2.2-.13m-2.54.62c-.05-.2 1.91-.46 2.1-.33'/%3e%3cpath d='M686.09 287.46s.08.05-.03-.06l-.08-.1-.05-.08-.07-.06s-.06.03-.56.46c0 0-.21.16-.47.4 0-.02-.48.4-1 .69-.57.08-1.38.45-1.38.6-.05-.23 1.61-.66 1.59-.69.12.08-1.48.37-1.5.7-.06-.2 1.46-.58 1.52-.59.08.1-1.34.33-1.38.63 0 .01.2-.19.27-.2l-.1.08c.05-.05.12-.06.18-.08l.1-.05s-.28.13-.27.19c.01.03-.16-.02.37-.16 0 .05 1.34-.27 2.86-1.68'/%3e%3cpath fill='none' d='M685.84 287.12c0-.02-.59.58-1.2 1 0 .1-1.24.84-1.57.75-.02-.04-.53.22-.74.48'/%3e%3cpath fill='none' d='M683.99 288.6c.1-.1.88-.63.88-.64.28-.3.97-.85.98-.85m-1.83 1.63c.07.06-1.17.23-1.37.53m1.72-.56c.08.16-1.32.53-1.38.58'/%3e%3cpath fill='%23c6262c' stroke='%23000' stroke-width='.55' d='M688.04 281.76s-.1-2.24-2.25-3.1c-2.15-.84-4.6-.95-5.48-.84-.88.1-1.03.5-2.13.67-1.1.18-2.28.71-2.28.71s0-.1-.58.96c-.6 1.07-1.57 1.6-1.08 2.56s.17 1.13.77 1.3c.6.2-.3-.32-.3-.32s-3.77 1.22-2.86 3.53c.92 2.31 1.84 1.45 2.12 1.4.27-.05 2.13-1 2.13-1l3.06-2.86s3.6-1.41 3.99-1.52c.39-.1 2.1.04 2.1.04l2.79-1.53z'/%3e%3cpath d='M685.31 287.01c0 .56-.57 1.28-1.27 1.6-.7.34-1.26.15-1.26-.4 0-.56.56-1.28 1.26-1.61.7-.33 1.27-.15 1.27.41'/%3e%3cpath fill='%235e3f17' d='M708.62 292.91a5.35 5.35 0 0 0 2.05-.93'/%3e%3cpath fill='%23842116' d='M674.86 285.06c.58.01 1.25.31 1.16 1.02v.38c.01.09.03.09.04 0 .06-.43.08-.93-.09-1.34-.18-.45-.67-.58-1.11-.6-.04 0-.04.54 0 .54m2.77 1.07a2.7 2.7 0 0 0-.26-2.4c.03.05-.1.4-.02.52.3.42.45.85.27 1.37-.06.14.04.43.01.51m2.24-2.37c-.14-.93-.47-1.97-1.33-2.45.04.02-.1.47 0 .53.84.47 1.17 1.47 1.3 2.38.02.1.04-.08.04-.1l-.01-.36m1.97-.48c.12-.87.05-1.8-.67-2.38.06.05-.1.45 0 .54.4.32.72.84.64 1.38v.36c0 .02.02.2.03.1m-3.3-2.91c1.93-.98 5.85-1.41 7.36.54-.07-.09.1-.41 0-.54-1.51-1.94-5.43-1.51-7.36-.53-.1.05.04.51 0 .53'/%3e%3cpath fill='%237a2e26' d='M680.38 294.73c.61 0 1.24 0 1.84-.13.07-.02 0-.54 0-.54-.6.14-1.23.14-1.84.14-.04 0-.04.53 0 .53m-1.16-8.54c-.5 0-.35.61-.66.87-.04.03-.02.21-.02.26l.02.27c.3-.26.17-.86.66-.87.04 0 .04-.53 0-.53m1.7 1.15c.26-.48.76-.67 1.22-.9.1-.05-.04-.52 0-.54-.47.24-.97.44-1.23.93-.04.08-.02.24-.02.32 0 .02.02.22.03.19m2.21 2.94c.42.03.74-.15.99-.48.04-.06.02-.2.02-.27 0-.03-.03-.25-.02-.26-.25.33-.57.51-.99.48-.03 0-.05.53 0 .53m1.74-.62a3.1 3.1 0 0 0 1.56-1.35c.04-.08.02-.25.02-.33 0-.02-.02-.21-.03-.19a3.07 3.07 0 0 1-1.55 1.34c-.1.04.02.52 0 .53m-2.74-2.88c-.39.65-1.11.98-1.55 1.59-.08.1.04.47.01.51.44-.6 1.17-.94 1.55-1.59.05-.07.03-.24.02-.32 0-.02-.02-.22-.03-.19m1.19 8.5c1.4.07 2.74-.11 4.1-.48.07-.02-.01-.53 0-.53-1.36.36-2.7.55-4.1.48-.03 0-.05.53 0 .53m6.44-.24c1.82-1.32 3.36-2.46 3.96-4.77.04-.15-.04-.42-.02-.51-.59 2.3-2.14 3.44-3.94 4.75-.1.07.05.5 0 .53m1.09-3.17a6.43 6.43 0 0 0 2.74-3.42c.05-.15-.05-.44-.02-.52a6.39 6.39 0 0 1-2.72 3.4c-.1.07.04.51 0 .54m-.62-8.07c1-.12 2.08.7 2.78 1.35-.07-.06.1-.44 0-.54-.7-.64-1.79-1.46-2.78-1.34-.06 0-.02.53 0 .53m25.84 4.02c1.13-1.83.51-4.12-.66-5.75.03.04-.1.4-.01.51.99 1.39 1.65 3.13.66 4.73-.08.12.04.46.01.51m-19.72-2.58c1.14.83 4.29 2.94 3.43 4.67-.07.13.04.45.01.51 1.18-2.37-1.86-4.57-3.44-5.71.05.03-.1.45 0 .53m8.86 8.51a5.98 5.98 0 0 0 .3-1.89c-.02-.09-.03-.09-.04 0-.05.47-.1.93-.27 1.38-.04.1-.02.23-.02.32 0 .02.02.21.03.19m-31.26-5.34c.44-.65.3-1.52-.13-2.12.03.04-.1.4-.02.51.12.16.21.32.29.5.1.22-.03.42-.15.6-.05.06-.02.25-.02.32 0 .02.01.22.03.19m19.67 5.65c.62-.4 1.05-.98 1.2-1.73.02-.11.01-.24 0-.36 0-.02-.01-.2-.03-.1-.13.71-.58 1.28-1.17 1.66-.1.06.05.5 0 .53m2.95-.24c.27-.3.36-.65.38-1.04 0-.1.02-.23-.02-.33l-.03.19c0 .23-.19.49-.33.65-.04.05-.03.2-.03.26 0 .03.04.26.03.27m17.82-9.78c.48.86.56 1.8.35 2.77-.03.1.01.5.02.46a5.37 5.37 0 0 0-.36-3.74c.04.06-.08.38-.01.51m-1.78 1.81c.35.87.32 1.77.22 2.69 0 .07.02.59.04.38a7.24 7.24 0 0 0-.25-3.58c.03.07-.07.37-.01.51m-1.67 1.55c0 .65 0 1.3-.22 1.91-.05.15.05.44.02.52.28-.77.25-1.62.25-2.43 0-.3-.05-.3-.05 0'/%3e%3c/g%3e%3cpath fill='%23dcddde' stroke='%23000' stroke-width='.27' d='M694.56 275.41c-7.07.4-14.05-4.3-14.05-4.3-8.76-1.7-9.27-9.63-9.27-9.63-3.5-1.34-6.52-10.34-6.52-10.34-5.43 3.24-12.23.04-12.23.04s0-1.34-6.13 0c-6.13 1.33-5.08-1.15-5.08-1.15s2.45-2.48-8.4 0c-10.87 2.48.87-3.24.87-3.24-3.16.95-13.5 1.72-13.5 1.72-3.78.17-7.63 2.04-11.83 3.23-2.6.75-7.07 1.61-9.33 2.58-6.02 2.57-18.09 8.1-28.05 12.02-13.1 5.14-23.5 9.05-22.81 8.89.82-.2 14.23-8.7 31.03-16.31 15.6-7.08 33.5-13.62 42.53-16.19 11.7-3.88 21.3-2.02 26.74-.05 2.63.96 17.13-.44 23.6.32 6.5.76 7.17 11.42 7.17 11.42 1.22.76 1.66 10.78 1.66 10.78s-3.6.1.61.67c4.2.57 11.92 6.67 11.92 6.67 2.62 0 2.92-.1 2.92-.1s1.53-1.92 3.63-2.72c2.1-.8 4.03-1.61 6.4-1.79 2.36-.18 5.7-.2 8.06.07 2.37.27 5.16.29 8.5.91 3.32.63 3.67.81 4.72 1.17 1.05.36 2 .12 2 .12 4.32-1.8 12.35-5 14.2-4.64 0 0 3.03-.76 4.66-2.03 1.62-1.26 5.35-4.3 5.35-4.3s-2.57-18.11 15.82-16.34c18.4 1.78 42.79 4.14 47.68 4.9 4.89.76 22.4 5.76 26.59 7.8 4.2 2.02 16.24 7.42 21.6 9.79 2.17.96 10.46 4.63 16.59 7.05a61.3 61.3 0 0 1 16.08 9.69c-5.77-2.44-10.43-5.23-15-7.21-3.7-1.6-7.56-2.35-10.56-3.69-6.38-2.83-11.3-5.41-15.16-7.21-14.24-6.64-14.11-6.9-19.88-7.36-3.98-.3 2.86 4.86 2.86 4.86s-13.04-5.07-17.23-6.85c-4.2-1.77-7.69-2.53-11.65-2.28-3.95.25-6.98-.5-9.3-1.27-2.34-.76-15.61-1.27-17.94-1.52-2.33-.25-4.19-.76-4.19-.76l.93 1.52-6.52-1.01-1.86 2.79s-6.29 1.26-6.75-.77c-.47-2.02-3.73 9.13-5.36 12.43-1.63 3.3-9.07 2.2-10.93 4.23-1.86 2.03-5.84 3.39-6.77 3.9-.93.5-3.75.26-5.38.26-2.43 0-.36.04-4.34.8 0 0-3.44-.04-4.75-.58a73.89 73.89 0 0 0-5.66-1.78c-1.99-.57-13.05-.82-14.63-.73-1.57.09-4.24.9-6 1.62-1.74.72-4.8 2.6-4.8 3.04'/%3e%3cpath fill='%23452c25' d='M695.29 273.29s-.74.57-.93 2c-.18 1.42-.1.85-.1.85'/%3e%3cpath fill='%23574f4c' d='M731.03 271.21c.94.7 1.9 1.41 2.74 2.24.02.03.3.28.2.08-.1-.22-.28-.42-.44-.58a26.97 26.97 0 0 0-3.02-2.5c-.18-.13.01.18.04.22.13.2.29.4.48.54'/%3e%3c/svg%3e";
            },
            9927: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 33 21'%3e%3cpath fill='%23FFF' d='M0 0h33v21H0z'/%3e%3cpath d='M0 0h33v14H0z'/%3e%3cpath fill='%234891D9' d='M0 0h33v7H0z'/%3e%3c/svg%3e";
            },
            5174: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3e%3cpath d='M0 0h900v600H0z'/%3e%3cpath fill='%23fff' d='M0 0h900v400H0z'/%3e%3cpath fill='%23ce1126' d='M0 0h900v200H0z'/%3e%3cg fill='%23fff' stroke='%23c09300'%3e%3cpath stroke-linejoin='round' stroke-width='1.27' d='m450.81 302.4 68.488 63.579-4.876-115.47c-.716-17.5-15.924-13.485-26.97-7.172-11.192 7.172-23.959 7.172-37.447 2.437-13.485 4.735-26.253 4.735-37.444-2.437-11.046-6.313-26.252-10.328-26.97 7.172l-4.879 115.47L450.81 302.4z'/%3e%3cpath id='a' fill='%23c09300' stroke='none' d='m393.47 246.49-4.734 112.32-8.035 7.168 4.879-115.47c2.294-1.578 6.313-4.017 7.89-4.017zm9.62 8.04-4.017 93.955-8.032 8.22 4.877-108.49c1.579 1.577 6.314 5.45 7.172 6.31zm8.75 7.17-3.155 78.362-6.455 6.31 4.018-89.406c1.574 1.578 4.73 3.874 5.592 4.734zm9.47 4.02-3.156 66.787-6.313 5.12 3.156-74.345c1.579.717 4.735 2.438 6.313 2.438zm8.75 0-2.297 55.657-6.455 6.313 2.44-61.252c1.575 0 5.593 0 6.312-.718z'/%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 900 0)'/%3e%3cpath fill='%23c09300' stroke-width='1.074' d='m453.16 315.06 9.613 43.755-3.158 3.155-3.3-2.439-5.451-39.018 2.296 39.018-3.157 4.016-3.157-4.016 2.296-39.018-5.45 39.018-3.303 2.44-3.154-3.156 9.611-43.755h6.314z'/%3e%3cg id='b' fill='none' stroke-linejoin='round' stroke-width='1.27'%3e%3cpath fill='%23fff' stroke-width='1.189' d='m428.48 295.84-19.08 67.705 26.255 4.018 11.188-50.924-18.363-20.8z'/%3e%3cpath d='m422.17 318.94 2.296 5.593 12.405-11.848'/%3e%3cpath d='m430.76 304.92 2.596 24.346 7.89-10.328m-3.156 4.012 4.31 14.875m1.69-5.465-8.718 13.241m2.72 13.216-2.791-13.198-2.436-13.423-5.84 7.91-2.562-9.12-8.174 8.385 4.157 15.25 5.738-9.434 3.155 9.612 5.89-9.162'/%3e%3cpath d='m414.99 361.97 5.3-7.444 3.452 11.457 4.735-8.032 3.157 9.614'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='matrix(-1 0 0 1 900 0)'/%3e%3cg stroke-linecap='round' stroke-linejoin='round' stroke-width='1.27'%3e%3cpath stroke-width='2.378' d='M450 393.81c19.943 0 39.024-1.578 50.213-4.734 4.735-.859 4.735-3.298 4.735-6.455 4.736-1.578 2.295-7.17 5.595-7.17-3.3.862-4.016-5.595-8.033-4.732 0-5.597-5.596-6.313-10.33-4.738-9.47 3.158-26.255 3.875-42.18 3.875-15.924-.717-32.567-.717-42.18-3.875-4.733-1.575-10.326-.859-10.326 4.738-4.018-.863-4.736 5.594-8.034 4.731 3.299 0 .86 5.593 5.594 7.17 0 3.158 0 5.597 4.878 6.456 11.045 3.156 30.128 4.734 50.068 4.734z'/%3e%3cpath d='M422.89 363.54c6.454.861 13.628 1.578 19.225.861 3.153 0 5.45 5.45-.863 6.313-5.593.715-14.345 0-19.08-.862-4.017-.718-12.768-2.295-18.364-3.876-5.594-2.436-1.576-7.168 1.578-6.452 4.879 1.577 11.192 3.157 17.505 4.016zm54.23 0c-6.457.861-13.628 1.578-19.081.861-3.3 0-5.596 5.45.717 6.313 5.596.715 14.347 0 19.078-.862 4.019-.718 12.77-2.295 18.364-3.876 5.597-2.436 1.58-7.168-1.577-6.452-4.878 1.577-11.19 3.157-17.501 4.016z'/%3e%3cpath d='M403.09 360.39c-4.877-.861-7.172 4.732-5.593 7.887.717-1.578 4.017-1.578 4.735-3.155.858-2.437-.718-2.437.858-4.732zm19.08 14.67c0-3.153 3.155-2.765 3.155-5.921 0-1.577-.86-4.018-2.437-4.018-1.579 0-3.158 1.578-3.158 3.156-.718 3.157 2.44 3.63 2.44 6.783zm22.71-9.08c4.73 0 4.262 6.314 1.966 9.47 0-2.295-4.017-3.156-4.017-4.732 0-2.442 3.626-2.442 2.051-4.738zm52.03-5.59c4.878-.861 7.174 4.732 5.595 7.887-.718-1.578-4.017-1.578-4.734-3.155-.86-2.437.718-2.437-.86-4.732zm-19.08 14.67c0-3.153-3.153-2.765-3.153-5.921 0-1.577.86-4.018 2.438-4.018 1.577 0 3.156 1.578 3.156 3.156.718 3.157-2.44 3.63-2.44 6.783zm-22.71-9.08c-4.732 0-4.263 6.314-1.967 9.47 0-2.295 4.015-3.156 4.015-4.732.001-2.442-3.626-2.442-2.048-4.738z'/%3e%3cpath stroke-width='.891' d='M404.67 361.97c1.58 0 4.018.718 4.735 1.577l-4.74-1.58zm7.88 2.44c.862 0 4.018.716 5.596 1.575l-5.6-1.58zm28.7 3.15c-1.578 0-4.734 0-5.593.715l5.59-.72zm-8.75 0c-.859-.862-4.016-.862-5.593 0h5.59zm62.84-5.59c-1.578 0-3.875.718-4.735 1.577l4.735-1.577zm-7.89 2.44c-.86 0-4.017.716-5.595 1.575l5.6-1.58zm-28.7 3.15c1.58 0 4.735 0 5.595.715l-5.6-.72zm8.75 0c.86-.862 4.018-.862 5.595 0h-5.6z'/%3e%3cg fill='%23c09300' stroke='none'%3e%3cpath d='M403.34 374.58c-.534-.102-.815-.525-.68-1.025.164-.609.651-.957 1.112-.794.294.104.83.645.832.839.003.222-.28.752-.402.754-.053 0-.135.046-.182.102-.1.118-.413.175-.68.124zm54.93 3.92c-.199-.074-.515-.518-.515-.724.002-.387.574-1.018.929-1.021.175-.001.655.248.834.434.325.338.254.893-.154 1.208-.201.155-.8.212-1.094.103zm.36 2.48c-.42-.142-.574-.348-.608-.814-.036-.485.012-.56.525-.84l.365-.2.347.155c.48.214.693.445.71.767.018.348-.24.704-.64.883-.352.158-.373.16-.699.05z'/%3e%3cpath d='M407.75 370.09c-.346-.01-.821.307-1.094.469-.649.152-1.404.55-2.031.125-.617-.191-1.438-.04-1.531.718.158.652 1.071 1.025 1.625.594.41-.537 1.531-.853 1.656.063-.457.692-.405 1.609-.781 2.344-.061.457-.252.892-.5 1.28-.462.047-.954-.007-1.344.282-.626.034-1.265.345-1.625.875-.403.578-.789 1.165-.906 1.875.107.725.937.933 1.562.969.667.183 1.335.424 2 .625 1.086.243 2.102.635 3.188.875 1.584.477 3.248.697 4.844 1.125.167.055.324.104.5.125.662.137 1.007-.583 1.062-1.125.329-1.16.58-2.34.906-3.5.225-.466.497-1.517-.406-1.281-.515.308-.952.773-1.594.812-.874.05-.375.945-.031 1.313.076.587-.11 1.288-.5 1.75-.52.33-1.172-.057-1.719-.188-.574.01-1.723-.283-1.187-1.062.19-.577.207-1.209.437-1.782.294-.614.336-1.285.469-1.937-.361-.777-.979.256-1.469.344-.338.234-1.605.334-.937.937.575.437.134 1.197.03 1.75-.036.77-.837.954-1.468.781-.628-.03-1.501-.497-.969-1.187.121-.575.322-1.14.438-1.719.237-.698.437-1.363.687-2.062a5.78 5.78 0 0 1 .625-1.75c.018-.686.478-1.276.47-1.97-.048-.338-.2-.461-.407-.468zm-3.594 7.25a.353.353 0 0 1 .219.031c.25.106.257.31 0 .531-.112.097-.24.191-.281.188-.468-.04-.606-.11-.625-.281-.017-.151.03-.195.343-.344a1.45 1.45 0 0 1 .344-.125zm-1.036 5.02c-.496-.466-.416-.806.317-1.353.314-.234.505-.208.863.12.553.504.575.823.087 1.255-.24.213-.346.257-.627.26-.293.003-.376-.034-.64-.282zm3.05.92a.86.86 0 0 1-.623-1.088c.129-.434.203-.477.84-.483.716-.007.854.112.861.741.004.355-.023.437-.2.6-.207.193-.605.297-.878.23zm89.11.08c-.227-.189-.273-.274-.275-.515-.003-.41.233-.712.746-.944.682-.308.96-.266 1.216.186.342.601.325.847-.084 1.252-.225.224-.268.237-.785.242-.507.003-.565-.01-.818-.221zm-85.06 1.15c-.364-.097-.552-.37-.557-.807-.004-.334.02-.387.253-.57.152-.118.39-.22.579-.245.267-.037.364-.013.58.138.55.387.667.77.348 1.14-.34.397-.662.488-1.203.344zm21.92.98c-.08-.1-.26-.16-.278-.287.032-.555.059-1.117.236-1.648.096-.523.012-1.07.194-1.579.187-.927.187-1.882.402-2.803.01-.475.055-.95.193-1.406.157-.722.013-1.476.226-2.19-.023-.267.285-.983.556-.559.394.577.912 1.045 1.421 1.516.438.252.036.624-.266.75-.416.163-.517.62-.487 1.022-.058.414-.225.806-.242 1.23-.087.622-.07 1.254-.151 1.876-.182.609-.113 1.26-.173 1.888.008.398-.182.76-.156 1.16-.048.406-.066.894-.407 1.172-.329.166-.804.138-1.068-.142zm29.7-9.8c-.482.365-.914.795-1.344 1.219-.592.449.487.71.625 1.094.157.586.148 1.21.188 1.812.179.552.258 1.138.218 1.719-.051.622-.863.491-1.218.844-.492.207-.688.69-1.063 1.03-.246.484-.312 1.077-.344 1.626.036.448-.302.95 0 1.344.04.055.086.132.125.187.102.145.343.03.5.063.504-.029 1.029.047 1.5-.157 1.21-.209 2.432-.226 3.657-.28.749.023 1.47-.238 2.218-.22.587.13.851-.506.844-.968-.332-.654-.045-1.429-.312-2.094-.235-.673-.143-1.428-.25-2.125-.015-.549-.711-.752-1.063-.344-.341.345-.893.414-1.156.844-.297.602.627.603.781 1.062.176.465.118.98.156 1.47.115.592-.529.625-.937.687-.537.2-1.29.336-1.594-.313-.19-.48-.165-.993-.219-1.5-.013-.892-.227-1.768-.28-2.656-.052-1.097-.242-2.187-.313-3.281-.01-.456-.071-1.198-.72-1.063zm-.625 8.25.313.031.03.375.032.375-.406.125a3.28 3.28 0 0 1-.407.094 2.55 2.55 0 0 1-.187-.125c-.22-.159-.164-.385.125-.688.163-.17.239-.203.5-.187zm-29.965-9.28c-.38.135-.862.693-1.25.688-.88.062-.757.919-.125 1.218.083.26.005.588.031.875.123.79-.375 1.425-.281 2.22-.044.87-.307 1.717-.344 2.593-.247.903-.25 1.832-.406 2.75-.104.823-.7.533-1.219.312-.004-.356-.027-.705-.031-1.062.216-.817-.441-1.056-1.094-1.156-.686.065-1.023-.523-.875-1.125.295-.351 1.036-.254 1.5-.313.981.204.942-1.112.438-1.562-.345-.636-1.199-.91-1.438-1.563.096-.866-.48-1.732-1.187-2.156-1.089-.076-1.91.863-2.313 1.781-.452.131-.904.267-1.344.438-.709.177-1.72 1.407-.75 1.875.545.15 2.2.528 1.47 1.28-.413.708-1.202.72-1.907.532-.724 0-1.53-.352-1.5-1.187-.148-.75-.123-1.558-.469-2.25-.148-.84-1.1-.643-1.156.125-.733.534-.636 1.397-.125 2.03.319.73.003 1.578-.313 2.25-.19.876-1.155.906-1.843 1.188-.338.131-1.629-.078-1.156.657.753.265 1.652.505 2.437.312.823-.102 1.538-.665 1.938-1.375.552-.56 1.502-.267 2.218-.281.773-.002 1.563.542 2.313.187.217-.564 1.222-1.495 1.531-.53-.053.862.71 1.325 1.5 1.218.864-.05.544.61.531 1.125.057.934.66 1.425 1.438 1.812.265.072.545.048.812 0 .748-.235 1.554-.568 1.781-1.406.304-.68.311-1.45.532-2.156.177-1.13.406-2.26.437-3.406.276-1.039.197-2.136.406-3.188.133-.782.231-1.563.313-2.344-.092-.417-.272-.487-.5-.406zm-6.781 4.156c.151.019.235.204.25.531.016.365.206.661.437.72.183.045.167.238-.03.374-.116.08-.322.127-.688.125-.578-.003-.937-.153-1.25-.469l-.188-.187.281-.188c.142-.108.399-.332.563-.5.285-.29.473-.424.625-.406zm66.031-7.876a8.365 8.365 0 0 0-1.656.25c-1.04-.065-1.563 1.027-.563 1.563.602 1.534 1.54-.317 2.5-.188 1.438.28 1.56 1.832 1.781 3 .081 1.157.415 2.282.75 3.375.963 1.07-.72 1.74-1.437.906-.611-.664-1.92-1.48-2.656-.562-.904.382-.94 1.59-1.688 1.937-1.209.368-1.361-1.119-2-1.75-.587-.824-1.71-.896-2.625-1.187-.429-.869-.205-2.346-1.094-2.938-.745.304-2.113 1.702-.968 2.344 1.117.96-.488 1.401-1 2.063-.732.814-.849 1.936-.969 2.968-1.26.696-1.504-.787-1.656-1.718-.098-1.112-1.036-.786-1.688-.375-.952.385-1.428 1.29-2.094 2-.08.647.038 1.356.032 2.03.216.812 1.202.431 1.812.376.979-.41 1.38.627.594 1.219-.532.676-2.22.322-2.063 1.406.544.063 1.111.043 1.657 0 1.09-.298 2.261-1.068 2.375-2.281.143-1.059 1.667-.866 2.5-1.094 1.04-.3 2.294-.377 2.53.937.71.745 2.25 1.584 3.032.563.795-.485 1.176-1.338 1.125-2.25-.162-.785 1.269-.813 1.625-.375.521.858 2.151.605 2.938.125.836-.617 1.017-1.705 2.218-1.719 1.783-.534 3.635-.841 5.375-1.5 1.41-.307-.21-1.198-.562-1.719-1.074-.53-2.008 1.642-3.219.563-.936-.716-.872-2.077-1.219-3.125-.237-1.358-.177-2.923-1.156-4-.672-.715-1.586-.887-2.531-.844zm-6.813 9.469c.126-.003.268.06.5.187.439.242.751.643.75.969 0 .213-.054.227-.375.375-.197.091-.42.189-.5.188-.18-.002-.624-.357-.625-.5 0-.06-.058-.287-.125-.47-.117-.32-.099-.316.063-.53.103-.138.187-.216.313-.22zm6.532.344c.372-.025.593.091.75.375.181.329.058.58-.407.78-.203.089-.407.16-.437.157-.03-.003-.198-.102-.375-.219-.27-.177-.31-.264-.313-.468-.003-.316.35-.597.782-.625zm-8.938.093c.11-.017.209.04.344.156.18.155.237.28.281.594a2.23 2.23 0 0 1 0 .625c-.048.226-.053.216-.562.219-.64.006-.7-.064-.688-.656.008-.377.012-.478.219-.688.16-.162.297-.233.406-.25zm-5.5 1.438a.57.57 0 0 1 .438.437c.065.318.008.462-.25.594-.222.113-.734.15-.875.063a.613.613 0 0 1-.188-.188c-.068-.121-.055-.18.031-.25.06-.05.126-.12.125-.156 0-.037.068-.163.157-.281a.543.543 0 0 1 .562-.22zm9.25 1.187a.651.651 0 0 1 .438.156c.185.163.179.4-.031.563-.136.104-.872.095-1.125 0-.113-.042-.156-.099-.157-.219-.002-.14.038-.227.281-.344.205-.097.416-.155.594-.156zm-17.171 4.819c-.096-.063-.238-.117-.095-.222.173-.302.518-.407.825-.52a3.436 3.436 0 0 0 1.373-1.118c.05-.333.424-.513.422-.861.003-.475.032-.962-.084-1.426-.129-.426-.452-.752-.827-.974-.256-.202-.674-.258-.768-.614-.053-.343.253-.604.36-.91.223-.421.411-.863.651-1.275.26-.288.659-.015.793.263.19.277.357.576.45.897.303.332.571.721.68 1.162.148.31.383.602.369.966 0 .416.235.787.22 1.206.014.56.013 1.145-.191 1.674-.14.294-.421.47-.607.733-.319.295-.67.579-1.08.736-.289.092-.457.426-.819.345-.514.009-1.037.079-1.547-.004.032.054-.156-.092-.125-.058zm-6.85.45c-.243-.25-.295-.355-.298-.6-.003-.248.045-.346.282-.586.439-.443.653-.453 1.41-.07.722.365.967.399 1.032.14.062-.25.478-.48.874-.481a.82.82 0 0 1 .592.203c.251.196.263.227.27.68.004.463-.002.48-.29.736-.278.244-.323.259-.666.224-.437-.043-.7-.244-.77-.588-.052-.25-.14-.31-.206-.14-.021.055-.129.122-.239.15-.204.051-.549.268-.794.5-.093.087-.255.128-.519.131-.355.003-.405-.018-.678-.299zm-19.82-8.9c-.665.007-1.38.566-1.469 1.219.152.752.777 1.49.375 2.281.278 1.013-.761 1.397-1.469.813-.427-.972-.643-2.036-1.28-2.907-.805-.227-1.155 1.057-1.72 1.5.28.755 1.096 1.433 1.188 2.375.195.915-.361 1.93-1.156 2.406-.686.655-1.626.421-2.47.563-1.023.599.753.818 1.22.844 1.047.106 2.135-.032 2.906-.813.769-.367.71-1.697 1.625-1.844 1.588-.07 3.163.244 4.75.282.85.203 2.163-.101 2.75.53.002 1.108.94 1.791 1.844 2.22.498.138 1.024-.48 1.53-.594.966-.308.673-1.502 1.25-1.969 1.651-.09 3.317-.07 4.97-.093.314.007.407-.44.625-.626-.037-.638-.06-1.272-.157-1.906-.318-.806.052-1.844-.53-2.53-.83-.227-1.537.533-2.376.593-.926.412-1.706 1.268-1.75 2.312-.548.897-1.427-.16-1.125-.906-.034-.325.07-.704-.031-1-.507-.608-1.395-.41-2.094-.5-1.018.04-2.012-.18-3.031-.156-.893-.068-1.822.078-2.688-.156-1.031-.03-.89-1.039-1.062-1.75a1.018 1.018 0 0 0-.625-.188zm2 3.688c.343.006.667.051 1 .093.43.071.89-.148 1.313 0 .976.166 1.953.127 2.937.219.26-.004.446.185.625.344.002.683 0 1.379 0 2.062-.03.258.076.598-.156.781a.7.7 0 0 1-.25.125c-.27-.07-.558-.247-.688-.5-.041-.357.018-.704.031-1.062-.007-.093.04-.237 0-.313a1.248 1.248 0 0 0-.718-.25c-.85-.029-1.682-.091-2.531-.125-.707-.044-1.434.06-2.125-.125-.269-.097-.618-.064-.782-.343-.234-.273.104-.597.344-.72a2.28 2.28 0 0 1 1-.187zm11.281.25c.159-.003.21.05.281.343.046.188.1.417.125.5.037.118-.022.156-.187.219-.494.186-.986.168-1.156-.063-.078-.104.012-.434.156-.562.29-.259.61-.437.781-.438z'/%3e%3c/g%3e%3c/g%3e%3cpath stroke-width='1.15' d='M449.98 327.23c32.642-25.106 29.843-61.883 29.843-61.883a12.72 12.72 0 0 1-2.54.258c-6.848 0-23.179-3.917-26.989-8.892-4.081 4.503-20.77 8.892-27.574 8.892-.861 0-1.722-.086-2.54-.258 0 0-2.843 36.776 29.8 61.883z'/%3e%3cpath stroke-width='.916' d='M477.22 268.04a13.55 13.55 0 0 1-.848.026c-6.205 0-20.619-3.183-26.175-7.957-5.82 4.41-20.47 7.957-26.576 7.957a4.7 4.7 0 0 1-.85-.086c-.014 1.39.059 2.832.145 4.144.323 4.9 1.183 9.819 2.488 14.552 4.108 14.895 12.516 27.553 24.572 37.155 12.066-9.61 20.484-22.28 24.6-37.186 1.308-4.732 2.17-9.65 2.496-14.55.086-1.285.157-2.692.148-4.055z'/%3e%3cpath fill='%23c09300' stroke='none' d='M439.38 265.03c-5.872 1.845-12.229 3.031-15.75 3.031a4.7 4.7 0 0 1-.844-.093c-.014 1.39.07 2.845.156 4.156a72.77 72.77 0 0 0 2.47 14.53c2.764 10.026 7.506 19.033 13.968 26.782V265.03zm20.62-.09v49.25c6.794-7.921 11.733-17.206 14.594-27.562a72.952 72.952 0 0 0 2.469-14.531c.085-1.284.166-2.7.156-4.063-.28.018-.56.032-.844.032-3.73 0-10.42-1.17-16.375-3.125z'/%3e%3cg stroke-width='1.27'%3e%3cpath stroke-width='1.218' d='M462.31 253.09c.667.04-.902-3.568-.902-3.568 1.765 1.804 8.43 2.235 8.43 2.235-4-1.766-7.998-15.096-7.528-25.721.432-10.664-1.528-14.86-3.097-16.428-2-2-8.43-3.764-12.664-4-2.392-.117-2 1.804-2 1.804-4.43-1.137-8.86-1.568-10.86-.235-1.883 1.255-2.275 7.528-.902 6.43 3.332-2.666 6.234-.235 8.233 2.666 1.764 2.549 1.647 9.763-.902 18.192-2.666 8.861-9.959 17.722-9.959 17.722 3.96 0 9.528-3.528 9.528-3.528l-1.333 5.528c4.195-2 7.528-5.097 7.528-5.097l3.999 4.195c1.333-1.764 4-4.195 4-4.195s3.332 3.529 8.429 4z'/%3e%3cpath fill='none' d='M446.12 227.57s-2.235 16.428-6.43 21.094m9.96-21.524s-.863 16.623-3.764 21.956m6.894-21.286s0 18.192 1.098 21.289m2.862-20.389s.902 15.291 4.666 20.819'/%3e%3cpath fill='%23c09300' stroke-width='.354' d='M442.08 219.61c-.196-1.45-.549-2.588-1.059-3.333-2-2.901-4.9-5.332-8.233-2.666 0 0 1.137-3.529 3.568-3.646 1.882-.118 6.155 1.411 9.92 7.841 0 0-2.784-.627-3.45-.039-1.256 1.098-.746 1.843-.746 1.843z'/%3e%3cpath fill='%23c09300' stroke-width='.354' d='M432.44 209.26c.274-.902.706-1.725 1.255-2.078 2-1.333 6.43-.902 10.86.235 0 0-.392-1.921 2-1.803 4.234.235 10.664 2 12.663 3.999.47.51 1.02 1.255 1.49 2.391h-.078c-.98-1.372-3.764-1.293-4.431-1.215-1.059.118-1.725.078-3.137.431-.666.157-1.686.353-2.235.784-.43.353-.784 1.647-1.45 1.647-1.059 0-.98-.274-1.255-.588-.353-.431-.549-1.059-.902-1.02-1.097.197-2.862-.666-5.096-2.43-2.235-1.765-3.098-2.196-5.999-2-2.862.235-3.764 1.843-3.764 1.843l.079-.196z'/%3e%3ccircle cx='448.824' cy='210.672' r='1.176' stroke='none'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";
            },
            346: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 300'%3e%3cpath d='M0 0h600v150H0z'/%3e%3cpath fill='%23007a3d' d='M0 150h600v150H0z'/%3e%3cpath fill='%23fff' d='M0 100h600v100H0z'/%3e%3cpath fill='%23c4111b' d='m0 0 200 150L0 300z'/%3e%3ccircle cx='300' cy='150' r='40' fill='%23c4111b'/%3e%3ccircle cx='315' cy='150' r='40' fill='%23fff'/%3e%3cpath fill='%23c4111b' d='m289.263 174.22 17.056-12.192 16.923 12.377-6.325-19.99 17-12.27-20.965-.16-6.416-19.961-6.632 19.89-20.966-.067 16.867 12.454-6.542 19.92z'/%3e%3c/svg%3e";
            },
            3553: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 500'%3e%3cpath fill='%23ea0437' d='M0 0h1000v500H0z'/%3e%3cpath fill='%234189dd' d='M0 500h1000V250'/%3e%3cpath fill='%2312ad2b' d='M0 0h1000v250'/%3e%3cpath fill='%23ffc726' d='M230.25 369.162c-10.81 2.985-17.008 11.371-16.85 19.284l53.211-.213c.478-8.503-6.517-16.367-17.166-19.464 52.097-1.076 97.357-20.59 105.58-33.112-8.138-3.532-17.548 2.152-24.257.844 15.928-7.361 63.647-38.248 55.889-71.36-6.031 18.392-24.3 33.609-32.081 37.694 17.826-27.067 42.166-55.247 21.049-77.069 1.066 12.648-8.037 26.567-12.058 27.613 10.34-28.6 20.206-64.507-2.197-88.179 2.942 8.556 1.754 32.691-2.297 33.776-1.248-19.448-4.566-60.353-25.047-59.77 6.505 5.79 9.351 21.595 9.496 37.56-4.668-10.937-9.972-19.171-21.318-27.247-9.178-17.602-25.508-32.186-41.84-42.634 1.833 12.812 3.35 22.92 21.24 36.209-9.328-.58-18.652-18.262-28.62-18.752-7.93-.382-14.151 7.185-27.108 2.83 1.434 4.277 7.48 6.171 8.755 9.335-2.775 1.917-9.364-.299-14.84-3.151 7.534 10.263 19.208 16.297 29.12 14.26 11.786-2.266 24.424-1.068 36.477 5.791-3.079 1.581-15.06 1.571-22.75.609 6.99 7.076 11.677 11.766 23.83 11.689 10.855-.071 16.546-5.79 19.334-2.248 6.808 8.067 11.39 16.13 17.085 25.628-12.58 1.39-8.788-14.228-22.799-22.216-7.872 16.293 9.055 35.608 20.577 43.637.155 12.247 1.945 22.494 7.14 31.818 3.501 6.574 8.028 13.303 6.321 28.14-6.897-5.024-13.638-21.966-11.158-35.416-8.633 2.355-12.008 17.535-7.94 25.177 3.04 5.818 5.07 16.951 1.564 21.928-3.417 4.637-3.775 4.118-3.73 14.07.122 5.955-3.205 12.997-8.623 17.907 1.131-4.196 2.421-11.415 1.168-15.927-4.283 7.265-15.028 14.783-18.412 22.595-3.322 7.829-4.165 21.39-20.245 24.517-20.686 4.106-27.826 7.691-41.137 13.138-1.477-10.11 2.945-31.193 11.399-29.99 8.254 1.468 33.28-8.624 24.328-29.707-1.768 6.645-7.666 13.13-14.043 13.417 6.89-8.939 19.185-18.194 13.197-33.172-3.329 6.367-8.564 14.007-16.503 18.306 8.51-16.31.988-21.189-9.118-7.756-3.817 5.182-6.122 15.567-8.547 28.756-3.97-10.727-3.708-24.847-8.412-36.313-4.914-12.399 6.521-15.673 11.903-14.678 13.177 3.518 35.198 3.516 33.562-18.253-5.691 7.364-15.671 9.638-26.449 6.987 12.104-8.838 21.661-25.464 8.173-34.143-.45 9.204-7.573 19.524-17.083 24.277-2.226-7.766-2.226-16.009-.317-25.045-5.31 5.59-9.189 17.22-12.273 30.441-.232-13.069 2.24-22.485 4.073-29.515 2.78-10.269 9.687-3.587 20.262-2.83 10.183.578 24.204-5.05 21.524-18.86-3.477 5.464-10.615 7.59-17.907 7.012 8.78-5.318 24.076-14.77 15.687-29.307-3.524 5.506-4.665 10.216-14.865 11.905 2.672-6.145 3.115-14.833 11.032-18.276-14.123-2.812-22.208 6.456-26.318 20.972-1.667-10.064-3.65-13.77-4.045-21.13 7.634-8.479 8.433-25.066-8.094-28.775-.98 8.556-.69 10.595 1.19 17.561-7.758-4.608-18.692-7.151-25.972-.634 4.932 5.322 12.566 10.008 24.332 4.203-2.78 9.093-10.008 7.537-19.942 4.07 6.072 11.404 13.734 13.43 22.19 12.116 4.428 11.673 4.623 20.542-8.315 37.542.598-10.564-.153-18.434-8.546-26.976-7.192-7.044-13.038.301-1.798 15.962-6.819-5.021-14.536-15.213-16.86-25.403-2.248 12.589-.224 27.426 6.745 35.743-3.296 3.522-7.044-.374-12.588-8.991 2.097 27.576 13.862 32.897 29.673 26.75.45 15.136.45 29.15 1.35 47.434-9.22-13.262-20.907-23.154-27.428-25.627-2.022 7.419 5.622 17.084 9.893 22.48-6.52-1.35-20.683-12.14-20.683-12.14-1.424 12.29 14.465 23.68 24.73 28.775-12.064-.525-17.387-5.095-25.18-12.589.151 34.095 36.942 28.174 43.837 22.93.9 16.785 2.182 36.19 3.08 52.976-10.4-1.815-9.582-4.942-18.482-5.766-24.7-.963-44.295-29.652-50.783-50.755-1.862 3.473-.385 7.107-2.088 11.374-4.01-10.359-9.134-23.737-16.005-29.963 1.75 6.039 1.935 12.175 1.327 23.462-2.358-7.313-4.552-9.555-4.71-18.14.15-6.59 6.358-11.452 6.014-20.722-.254-6.768-6.427-21.436-7.335-32.791-2.989 11.687-4.865 24.007-9.443 31.242 2.275-12.48 1.546-21.093 5.394-29.492 4.446-8.843 8.226-16.738 5.266-25.662-2.838 3.447-1.862 6.578-8.993 14.953-1.55-9.107 9.22-23.683 19.673-29.543 7.372-3.884 16.664-17.777 10.61-27.3-6.931 4.98-10.044 11.706-19.837 23.2 6.985-27.305 25.134-34.45 46.862-34.543 4.808-.022 14.501-1.758 17.222-8.12-6.125 2.364-13.366 2.665-19.81 1.375 4.69-6.885 14.566-5.99 23.77-6.03 7.218-.035 18.488-1.014 23.044-11.295-8.806 3.815-22.54 4.609-31.188 1.907 13.753-7.126 35.294-7.893 46.342-17.244-12.593-9.398-44.104 2.19-64.007 15.84 5.563-5.087 14.355-14.11 19.206-21.395-10.886-5.219-38.415 25.279-47.899 43.4-9.007 5.086-12.61 13.06-16.108 18.625 4.8-16.218 5.308-27.987 9.313-41.342-30.877 10.629-18.043 67.679-24.76 81.327.791-15.068.151-34.426-6.053-44.408-9.51 7.255-10.278 49.959-1.349 85.51-3.224-9.513-9.31-18.395-11.262-29.974-14.076 25.671 8.251 55.957 26.92 79.881-14.055-7.32-27.951-23.067-37.08-36.268 2.52 45.947 50.501 55.494 57.95 66.786-10.11-4.706-29.439-14.019-37.64-4.26 13.351 3.082 24.002 6.645 32.584 12.27 12.452 15.548 36.032 22.347 77.098 24.065z'/%3e%3c/svg%3e";
            },
            1934: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 750 500'%3e%3cpath fill='%23c60b1e' d='M0 0h750v500H0z'/%3e%3cpath fill='%23ffc400' d='M0 125h750v250H0z'/%3e%3cg stroke='%23000' stroke-width='.39'%3e%3cg stroke-width='.26'%3e%3cpath fill='%23ad1519' stroke-linejoin='round' d='M167.99 222.24s-.51 0-.79-.16-1.13-.96-1.13-.96l-.68-.49-.62-.85s-.73-1.18-.4-2.09c.34-.91.91-1.23 1.42-1.5.51-.26 1.58-.59 1.58-.59s.85-.37 1.13-.42c.28-.06 1.3-.32 1.3-.32s.28-.16.56-.27c.29-.11.68-.11.91-.16.22-.06.79-.24 1.13-.26.52-.02 1.36.1 1.64.1s1.24.05 1.64.05c.39 0 1.8-.11 2.2-.11.39 0 .68-.05 1.13 0 .45.06 1.24.32 1.47.43s1.58.59 2.09.75 1.75.37 2.32.64c.56.27.91.72 1.19 1.1.28.37.34.78.45 1.05.11.26.11.84 0 1.11-.11.26-.51.81-.51.81l-.62 1.02-.79.64s-.57.54-1.02.48c-.45-.04-5.03-.86-7.97-.86s-7.64.86-7.64.86h.01z'/%3e%3cg fill='%23c8b100'%3e%3cellipse cx='175.66' cy='215.68' rx='1.38' ry='2.5'/%3e%3cellipse cx='175.68' cy='215.68' rx='.64' ry='2.3'/%3e%3cellipse cx='175.68' cy='213.04' stroke='none' rx='.93' ry='.87'/%3e%3cpath stroke-width='.3' d='M176.96 212.74v.58h-2.53v-.58h.94v-1.32h-.62v-.57h.62v-.57h.6v.57h.62v.57h-.62v1.32h.99'/%3e%3cpath fill='none' d='M175.94 212.2a.93.87 0 1 1-.5 0'/%3e%3cpath d='M175.68 222.08h-4.81l-.11-1.18-.23-1.23-.23-1.53c-1.33-1.75-2.55-2.9-2.96-2.65.1-.32.22-.56.47-.71 1.18-.7 3.61.98 5.44 3.74.16.25.32.5.46.75h3.97c.14-.25.3-.5.46-.75 1.82-2.76 4.26-4.44 5.43-3.74.26.15.37.39.47.71-.41-.24-1.62.9-2.96 2.65l-.23 1.53-.23 1.23-.1 1.18h-4.84z'/%3e%3cpath fill='none' d='M167.55 215.44c.91-.53 3.02 1.14 4.73 3.74m11.55-3.74c-.91-.53-3.01 1.14-4.73 3.74'/%3e%3c/g%3e%3cg id='a' fill='%23c8b100'%3e%3cpath d='M168.58 224.25c-.2-.57-.58-1.08-.58-1.08 1.95-.57 4.66-.93 7.67-.94 3.01.01 5.75.37 7.69.94 0 0-.22.38-.52.91-.17.3-.39.81-.38.81-1.75-.54-4.02-.81-6.8-.82-2.79.01-5.46.35-6.86.86.02 0-.1-.32-.23-.68h.01'/%3e%3cpath d='M175.67 226.73c2.43-.01 5.11-.38 6.1-.63.66-.2 1.05-.49.98-.84-.04-.16-.18-.3-.37-.38-1.46-.47-4.07-.8-6.71-.8-2.63 0-5.27.33-6.72.8-.19.08-.33.22-.37.38-.07.35.32.64.98.84.99.25 3.68.62 6.11.63zm7.81-4.65-.59-.53s-.57.34-1.28.24c-.7-.11-.93-.97-.93-.97s-.79.67-1.44.62c-.65-.06-1.07-.62-1.07-.62s-.71.51-1.33.46c-.62-.06-1.21-.83-1.21-.83s-.63.8-1.25.86c-.62.05-1.13-.54-1.13-.54s-.28.59-1.07.72-1.47-.62-1.47-.62-.45.73-.99.92c-.54.18-1.24-.27-1.24-.27s-.12.27-.2.43-.31.19-.31.19l.18.47c1.93-.56 4.56-.91 7.53-.91s5.67.35 7.61.92l.2-.54h-.01z'/%3e%3cpath d='m175.69 219.49.28.05c-.05.12-.06.24-.06.38 0 .58.5 1.05 1.12 1.05.49 0 .91-.31 1.06-.73.01.01.11-.38.15-.38.03 0 .03.41.05.41.07.53.55.89 1.1.89.62 0 1.11-.47 1.11-1.06 0-.04 0-.08-.01-.12l.35-.35.19.44c-.07.14-.1.29-.1.46 0 .56.47 1.01 1.06 1.01.37 0 .69-.18.88-.45l.23-.29v.36c0 .34.14.66.49.71 0 0 .38.03.91-.38.52-.41.8-.75.8-.75l.03.42s-.51.84-.97 1.1c-.25.15-.64.31-.95.25-.32-.05-.55-.31-.67-.61-.23.14-.51.22-.8.22-.63 0-1.2-.35-1.42-.86-.29.31-.69.5-1.16.5-.51 0-.97-.23-1.26-.58-.28.27-.67.43-1.09.43-.55 0-1.05-.28-1.33-.69-.29.41-.78.69-1.34.69-.42 0-.81-.16-1.09-.43-.29.35-.75.58-1.25.58-.48 0-.88-.19-1.17-.5-.22.51-.79.86-1.42.86-.29 0-.56-.08-.79-.22-.12.3-.35.56-.68.61-.3.06-.69-.1-.94-.25-.47-.26-1.02-1.1-1.02-1.1l.07-.42s.29.34.81.75.91.38.91.38c.34-.05.49-.37.49-.71v-.36l.22.29c.19.27.51.45.88.45.59 0 1.06-.45 1.06-1.01a.89.89 0 0 0-.1-.46l.19-.44.35.35c-.01.04-.01.08-.01.12 0 .59.49 1.06 1.11 1.06.55 0 1.03-.36 1.11-.89.01 0 .01-.41.04-.41.05 0 .14.39.16.38.14.42.56.73 1.06.73.61 0 1.11-.47 1.11-1.05 0-.14 0-.26-.05-.38l.29-.05h.01z'/%3e%3cpath stroke-linejoin='round' d='M175.67 222.23c-3.01.01-5.72.37-7.67.94-.13.04-.29-.06-.33-.17-.04-.13.05-.28.18-.32 1.95-.6 4.73-.98 7.82-.98s5.88.38 7.83.98c.13.04.22.19.18.32-.04.11-.2.21-.33.17-1.95-.57-4.67-.93-7.68-.94z'/%3e%3cpath d='M165.43 221c-.01.01-.38-.48-.65-.73-.2-.18-.68-.33-.68-.33 0-.08.28-.28.58-.28.18 0 .35.07.45.2l.04-.2s.24.05.35.32c.12.29.05.72.05.72s-.05.2-.14.3zm1.89-.78-.11.66-1.4.15-.21-.12.04-.23 1.06-.87.62.41'/%3e%3cpath d='M165.45 220.75c.12-.12.36-.09.53.06.18.15.24.38.12.5-.12.13-.36.1-.53-.06-.18-.15-.24-.38-.12-.5zm2.57.13c-.06-.18 0-.37.13-.42.14-.03.3.09.37.27.06.19 0 .38-.14.42-.13.04-.29-.08-.36-.27zm.65-.84.51.48 1.22-.66.09-.21-.17-.17-1.4-.12-.25.68'/%3e%3cpath d='m170.08 217.76-.67.64.86 1.14.23.09.17-.18.3-1.37-.89-.32'/%3e%3cpath d='m172.36 219.3-.26.63-1.4-.13-.18-.16.1-.22 1.22-.64.52.52'/%3e%3cellipse cx='170.51' cy='219.65' rx='.49' ry='.47'/%3e%3cpath d='M172.87 219.95c-.03-.2.07-.37.21-.39s.28.13.3.33c.03.19-.07.37-.21.38-.14.02-.28-.13-.3-.32zm.91-.71.4.57 1.34-.42.14-.18-.15-.2-1.33-.39-.4.62'/%3e%3cpath d='m175.66 217.15-.86.52.64 1.38.22.14.22-.14.64-1.38-.86-.52'/%3e%3cpath d='m177.55 219.24-.39.57-1.34-.42-.14-.18.14-.2 1.34-.39.39.62'/%3e%3cellipse cx='175.67' cy='219.21' rx='.49' ry='.47'/%3e%3cpath d='M178.5 219.95c.02-.2-.08-.37-.22-.39s-.28.13-.3.33c-.02.19.07.37.21.38.14.02.28-.13.31-.32zm.49-.65.26.63 1.4-.13.18-.16-.1-.22-1.22-.64-.52.52'/%3e%3cpath d='m181.27 217.76.67.64-.86 1.14-.23.09-.17-.18-.3-1.37.89-.32'/%3e%3cpath d='m182.68 220.04-.51.48-1.22-.66-.1-.21.19-.17 1.4-.12.24.68'/%3e%3cellipse cx='180.85' cy='219.65' rx='.49' ry='.47'/%3e%3cpath d='M183.34 220.88c.06-.18 0-.37-.13-.42-.14-.03-.3.09-.37.27-.06.19 0 .38.14.42.13.04.29-.08.36-.27zm2.39.12c.01.01.38-.48.66-.73.19-.18.67-.33.67-.33 0-.08-.28-.28-.58-.28-.18 0-.35.07-.45.2l-.04-.2s-.24.05-.36.32c-.11.29-.03.72-.03.72s.04.2.13.3zm-1.89-.78.11.66 1.4.15.21-.12-.05-.23-1.05-.87-.62.41'/%3e%3cpath d='M185.74 220.75c-.11-.12-.35-.09-.53.06s-.24.38-.12.5c.12.13.36.1.54-.06.18-.15.23-.38.11-.5z'/%3e%3c/g%3e%3cg id='b' fill='none'%3e%3cpath fill='%23ad1519' d='m168.05 224.3.31-.5.65.13-.38.56-.58-.19'/%3e%3cpath fill='%23058e6e' d='m170.85 223.81-.69.11c-.18.02-.35-.09-.38-.26a.32.32 0 0 1 .27-.35l.7-.1.71-.11c.18-.02.34.09.37.25.02.17-.1.33-.27.35l-.71.11'/%3e%3cellipse cx='173.19' cy='223.3' fill='%23fff' rx='.44' ry='.41'/%3e%3cpath fill='%23ad1519' d='M175.7 223.48h-.96c-.18 0-.33-.14-.33-.31s.14-.31.32-.31h1.96c.19 0 .33.14.33.31s-.15.31-.33.31h-.99'/%3e%3cellipse cx='178.16' cy='223.3' fill='%23fff' rx='.44' ry='.41'/%3e%3cpath fill='%23058e6e' d='m180.5 223.81.69.11c.18.02.35-.09.38-.26a.313.313 0 0 0-.27-.35l-.7-.1-.71-.11c-.18-.02-.35.09-.37.25a.3.3 0 0 0 .27.35l.71.11'/%3e%3cpath fill='%23ad1519' d='m183.24 224.33-.25-.53-.67.06.32.59.6-.12'/%3e%3cpath fill='%23ad1519' stroke-linejoin='round' d='M175.66 226.16c-2.43 0-4.63-.22-6.3-.65 1.67-.43 3.87-.69 6.3-.7 2.44 0 4.65.27 6.33.7-1.68.43-3.89.65-6.33.65z'/%3e%3cpath stroke-width='.01' d='M176.8 226.08v-1.16m-.58 1.2.01-1.23m-.43 1.25v-1.26'/%3e%3cpath stroke-width='.02' d='M175.44 226.15v-1.27'/%3e%3cpath stroke-width='.03' d='M175.09 226.15v-1.27'/%3e%3cpath stroke-width='.04' d='M174.77 226.15v-1.27m-.33 1.27v-1.27'/%3e%3cpath stroke-width='.05' d='M174.16 226.15v-1.27'/%3e%3cpath stroke-width='.06' d='m173.61 226.08-.01-1.15m.27 1.17v-1.21'/%3e%3cpath stroke-width='.07' d='M173.1 226.03v-1.06m.26 1.09-.01-1.13'/%3e%3cpath stroke-width='.08' d='M172.42 225.97v-.93m.23.94V225m.23 1.02V225'/%3e%3cpath stroke-width='.09' d='M172.19 225.96v-.9'/%3e%3cpath stroke-width='.1' d='M171.97 225.92v-.85'/%3e%3cpath stroke-width='.11' d='M171.73 225.89v-.78'/%3e%3cpath stroke-width='.12' d='m171.24 225.82-.01-.62m.26.66v-.7m-.5.61v-.55'/%3e%3cpath stroke-width='.13' d='M170.76 225.73v-.46'/%3e%3cpath stroke-width='.14' d='M170.51 225.67v-.36'/%3e%3cpath stroke-width='.15' d='M170.26 225.64v-.27'/%3e%3cpath stroke-width='.18' d='M169.99 225.58v-.13'/%3e%3c/g%3e%3c/g%3e%3cg id='c'%3e%3cg fill='%23005bbf'%3e%3cpath d='M191.28 330.68c-1.54 0-2.91-.33-3.93-.87-1-.51-2.36-.82-3.86-.82-1.51 0-2.9.32-3.91.83-1.01.53-2.4.86-3.92.86-1.54 0-2.92-.36-3.93-.9-1-.49-2.33-.79-3.79-.79-1.52 0-2.86.29-3.86.81-1.02.54-2.42.88-3.95.88v2.41c1.53 0 2.93-.35 3.95-.88 1-.52 2.34-.82 3.86-.82 1.45 0 2.79.31 3.79.8 1.01.53 2.39.9 3.93.9 1.52 0 2.91-.33 3.92-.86 1.01-.52 2.4-.84 3.91-.84 1.5 0 2.86.32 3.86.83 1.02.54 2.37.87 3.91.87l.02-2.41z'/%3e%3cpath fill='%23ccc' d='M191.28 333.09c-1.54 0-2.91-.33-3.93-.87-1-.51-2.36-.83-3.86-.83-1.51 0-2.9.32-3.91.84-1.01.53-2.4.86-3.92.86-1.54 0-2.92-.37-3.93-.9-1-.49-2.33-.8-3.79-.8-1.52 0-2.86.3-3.86.82-1.02.53-2.42.88-3.95.88v2.41c1.53 0 2.93-.35 3.95-.88 1-.52 2.34-.82 3.86-.82 1.45 0 2.79.31 3.79.8 1.01.54 2.39.9 3.93.9 1.52 0 2.91-.34 3.92-.86s2.4-.84 3.91-.84c1.5 0 2.86.32 3.86.84 1.02.53 2.37.86 3.91.86l.02-2.41'/%3e%3cpath d='M191.28 335.5c-1.54 0-2.91-.33-3.93-.86-1-.52-2.36-.84-3.86-.84-1.51 0-2.9.32-3.91.84s-2.4.86-3.92.86c-1.54 0-2.92-.36-3.93-.9-1-.49-2.33-.8-3.79-.8-1.52 0-2.86.3-3.86.82-1.02.53-2.42.88-3.95.88v2.4c1.53 0 2.93-.34 3.95-.88 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1.01.54 2.39.89 3.93.89 1.52 0 2.91-.32 3.92-.85 1.01-.52 2.4-.83 3.91-.83 1.5 0 2.86.31 3.86.82 1.02.55 2.37.86 3.91.86l.02-2.4'/%3e%3cpath fill='%23ccc' d='M191.26 340.32c-1.54 0-2.89-.33-3.91-.87-1-.51-2.36-.82-3.86-.82-1.51 0-2.9.31-3.91.83s-2.4.86-3.92.86c-1.54 0-2.92-.37-3.93-.9-1-.5-2.33-.79-3.79-.79-1.52 0-2.86.29-3.86.81-1.02.53-2.42.88-3.95.88v-2.4c1.53 0 2.93-.36 3.95-.9 1-.51 2.34-.8 3.86-.8 1.45 0 2.79.3 3.79.79 1.01.54 2.39.89 3.93.89 1.52 0 2.91-.32 3.92-.85 1.01-.52 2.4-.83 3.91-.83 1.5 0 2.86.31 3.86.82 1.02.55 2.39.86 3.93.86l-.02 2.42'/%3e%3cpath d='M191.26 342.73c-1.54 0-2.89-.33-3.91-.86-1-.52-2.36-.84-3.86-.84-1.51 0-2.9.32-3.91.84s-2.4.86-3.92.86c-1.54 0-2.92-.37-3.93-.9-1-.5-2.33-.8-3.79-.8-1.52 0-2.86.3-3.86.82-1.02.53-2.42.88-3.95.88v-2.39c1.53 0 2.93-.37 3.95-.9 1-.52 2.34-.81 3.86-.81 1.45 0 2.79.3 3.79.79 1.01.53 2.39.9 3.93.9 1.52 0 2.91-.34 3.92-.86s2.4-.83 3.91-.83c1.5 0 2.86.31 3.86.82 1.02.54 2.38.87 3.93.87l-.02 2.41z'/%3e%3c/g%3e%3cg fill='%23c8b100'%3e%3cpath stroke-linejoin='round' d='M166.92 320.78c.05.21.13.4.13.62 0 1.46-1.27 2.63-2.81 2.63h22.94c-1.55 0-2.81-1.17-2.81-2.63 0-.21.04-.41.09-.62-.13.05-.29.06-.44.06h-16.69c-.13 0-.29-.02-.41-.06z'/%3e%3cpath d='M167.33 319.27h16.69c.57 0 1.02.35 1.02.78s-.45.79-1.02.79h-16.69c-.56 0-1.02-.36-1.02-.79s.46-.78 1.02-.78zm-3.06 10.59h22.87v-5.83h-22.87v5.83z'/%3e%3c/g%3e%3cpath fill='%23ccc' d='M167.55 318.32h16.25v-79.63h-16.25v79.63z'/%3e%3cpath fill='none' d='M179.13 238.8v79.46m1.83-79.46v79.46'/%3e%3cg fill='%23c8b100'%3e%3cpath d='M164.58 232.37h22.29v-5.84h-22.29v5.84z'/%3e%3cpath stroke-linejoin='round' d='M166.92 236.26a.91.91 0 0 1 .41-.07h16.69c.17 0 .32.03.46.08-.58-.19-.99-.71-.99-1.32s.45-1.14 1.03-1.33c-.14.04-.33.08-.49.08h-16.7c-.17 0-.33-.01-.47-.06l.09.02c.6.18.94.71.94 1.29 0 .56-.38 1.13-.97 1.31z'/%3e%3cpath d='M167.33 236.19h16.69c.57 0 1.02.35 1.02.78 0 .44-.45.79-1.02.79h-16.69c-.56 0-1.02-.35-1.02-.79 0-.43.46-.78 1.02-.78zm0-3.82h16.7c.57 0 1.03.3 1.03.66 0 .37-.46.67-1.03.67h-16.7c-.56 0-1.02-.3-1.02-.67 0-.36.46-.66 1.02-.66z'/%3e%3c/g%3e%3c/g%3e%3cg id='d' fill='%23ad1519'%3e%3cpath d='M162.48 298.62c-2.26 1.3-3.8 2.64-3.55 3.31.12.61.84 1.07 1.87 1.75 1.62 1.13 2.6 3.14 1.83 4.07 1.34-1.08 2.19-2.69 2.19-4.49 0-1.87-.9-3.56-2.34-4.64z'/%3e%3cpath stroke-linejoin='round' d='M200.4 268.47c-3.54-1.46-9.57-2.55-16.49-2.78-2.39.02-5.04.25-7.79.7-9.72 1.63-17.13 5.51-16.54 8.67.01.06.04.2.05.26 0 0-3.64-8.21-3.7-8.52-.65-3.51 7.56-7.82 18.35-9.62 3.39-.57 6.69-.79 9.56-.76 6.9 0 12.9.89 16.52 2.23l.04 9.82'/%3e%3cpath d='M167.52 278.47c-4.51-.32-7.58-1.53-7.94-3.41-.28-1.5 1.25-3.17 3.97-4.68 1.21.14 2.58.3 4 .3l-.03 7.79m16.31-6.09c2.82.43 4.93 1.13 5.98 1.99l.1.17c.5 1.03-1.97 3.22-6.11 5.67l.03-7.83'/%3e%3cpath stroke-linejoin='round' d='M157.42 293.83c-.43-1.28 3.97-3.86 10.18-6.14 2.84-1.01 5.18-2.07 8.09-3.35 8.63-3.82 15-8.2 14.22-9.79l-.09-.17c.46.38 1.18 8.24 1.18 8.24.78 1.46-5.05 5.78-13 9.58-2.54 1.22-7.91 3.2-10.44 4.09-4.54 1.57-9.04 4.54-8.63 5.64l-1.51-8.09v-.01z'/%3e%3c/g%3e%3cg stroke-width='.26'%3e%3cpath fill='%23ad1519' stroke-width='.27' d='M324.85 220.42s-.74.78-1.28.89c-.53.1-1.21-.49-1.21-.49s-.48.51-1.08.64c-.59.14-1.41-.66-1.41-.66s-.57.8-1.07.99c-.51.18-1.13-.24-1.13-.24s-.23.39-.65.61c-.18.09-.48-.05-.48-.05l-.6-.38-.68-.72-.62-.24s-.28-.91-.31-1.07c-.02-.16-.08-.57-.08-.57-.13-.65.87-1.4 2.3-1.72.82-.19 1.54-.18 2.06-.02.57-.48 1.78-.82 3.2-.82 1.29 0 2.42.27 3.04.7.61-.43 1.74-.7 3.03-.7 1.42 0 2.62.34 3.19.82.53-.16 1.24-.17 2.07.02 1.42.32 2.43 1.07 2.3 1.72 0 0-.06.41-.08.57-.03.16-.32 1.07-.32 1.07l-.62.24-.68.72-.58.38s-.3.14-.48.05c-.43-.21-.66-.61-.66-.61s-.62.42-1.13.24c-.51-.19-1.07-.99-1.07-.99s-.82.8-1.42.66c-.59-.13-1.07-.64-1.07-.64s-.68.59-1.21.49c-.54-.11-1.27-.89-1.27-.89z'/%3e%3cg fill='%23c8b100'%3e%3cellipse cx='324.82' cy='216.2' rx='1.38' ry='1.96'/%3e%3cellipse cx='324.85' cy='216.2' rx='.63' ry='1.81'/%3e%3cellipse cx='324.84' cy='213.95' stroke='none' rx='.93' ry='.88'/%3e%3cpath stroke-width='.3' d='M326.13 213.64v.58h-2.53v-.58h.94v-1.3h-.62v-.58h.62v-.58h.61v.58h.61v.58h-.61v1.3h.98'/%3e%3cpath fill='none' d='M325.11 213.12a.93.88 0 1 1-.51-.01'/%3e%3c/g%3e%3cg fill='none' stroke-width='.21'%3e%3cpath stroke-linecap='round' stroke-width='.26' d='M314.41 219.99c-.13-.33-.22-.7-.22-1.08 0-1.59 1.26-2.88 2.83-2.88.5 0 .96.13 1.37.37'/%3e%3cpath stroke-width='.26' d='M319.48 217.93c-.15-.26-.29-.54-.29-.84 0-1.15 1.19-2.08 2.64-2.08.62 0 1.2.17 1.65.45m6.69 2.5c.15-.26.25-.57.25-.87 0-1.15-1.18-2.08-2.64-2.08-.62 0-1.19.17-1.64.45'/%3e%3cpath stroke-linecap='round' stroke-width='.26' d='M335.21 219.99c.13-.33.21-.7.21-1.08 0-1.59-1.26-2.88-2.82-2.88-.5 0-.97.13-1.38.37'/%3e%3cellipse cx='313.57' cy='218.68' rx='.45' ry='.43'/%3e%3cellipse cx='313.74' cy='217.1' rx='.45' ry='.43'/%3e%3cellipse cx='314.76' cy='215.9' rx='.45' ry='.43'/%3e%3cellipse cx='316.11' cy='215.25' rx='.45' ry='.43'/%3e%3cellipse cx='317.55' cy='215.31' rx='.45' ry='.43'/%3e%3cellipse cx='318.43' cy='217.08' fill='%23fff' rx='.45' ry='.43'/%3e%3cellipse cx='318.68' cy='215.58' rx='.45' ry='.43'/%3e%3cellipse cx='319.81' cy='214.64' rx='.45' ry='.43'/%3e%3cellipse cx='321.23' cy='214.19' rx='.45' ry='.43'/%3e%3cellipse cx='322.67' cy='214.24' rx='.45' ry='.43'/%3e%3cellipse cx='326.94' cy='214.24' rx='.45' ry='.43'/%3e%3cellipse cx='328.39' cy='214.19' rx='.45' ry='.43'/%3e%3cellipse cx='329.8' cy='214.64' rx='.45' ry='.43'/%3e%3cellipse cx='330.93' cy='215.58' rx='.45' ry='.43'/%3e%3cellipse cx='331.18' cy='217.08' fill='%23fff' rx='.45' ry='.43'/%3e%3cellipse cx='332.06' cy='215.31' rx='.45' ry='.43'/%3e%3cellipse cx='333.51' cy='215.25' rx='.45' ry='.43'/%3e%3cellipse cx='334.86' cy='215.9' rx='.45' ry='.43'/%3e%3cellipse cx='335.88' cy='217.1' rx='.45' ry='.43'/%3e%3cellipse cx='336.05' cy='218.68' rx='.45' ry='.43'/%3e%3c/g%3e%3cuse xlink:href='%23a' x='149.17'/%3e%3cuse xlink:href='%23b' x='149.17'/%3e%3c/g%3e%3cuse xlink:href='%23c' x='149.17'/%3e%3cuse xlink:href='%23d' transform='matrix(-1 0 0 1 500.57 0)'/%3e%3cpath fill='%23c8b100' stroke='none' d='M166.42 264.65c1.99-.72 3.29-1.58 2.66-3.14-.41-1-1.43-1.19-2.97-.63l-2.71.99 2.44 6.03c.27-.12.54-.24.81-.34.28-.1.57-.18.85-.26l-1.08-2.64v-.01zm-1.18-2.91.69-.25c.57-.21 1.21.1 1.5.8.21.53.16 1.13-.5 1.55-.21.13-.46.23-.7.33l-.99-2.43m7.54-2.52c-.29.08-.57.16-.86.22-.29.05-.59.09-.88.12l1.41 6.28 4.38-.88c-.05-.12-.12-.26-.14-.38-.03-.14-.03-.28-.04-.41-.77.22-1.61.46-2.61.66l-1.26-5.61m8.78 5.41c.82-2.28 1.82-4.46 2.81-6.67-.18.03-.36.06-.54.07s-.37.01-.54 0c-.53 1.61-1.18 3.21-1.87 4.8-.82-1.51-1.73-2.99-2.43-4.51-.34.04-.69.09-1.03.12-.34.02-.7.01-1.04.02 1.26 2.06 2.48 4.11 3.64 6.23.16-.03.32-.06.5-.08.16-.01.33.01.5.02m9.16-4.83c.15-.31.31-.6.48-.89-.24-.22-.96-.55-1.81-.63-1.79-.18-2.81.61-2.93 1.69-.26 2.26 3.31 2.07 3.14 3.57-.07.64-.75.9-1.48.83-.81-.08-1.41-.53-1.51-1.19l-.22-.02c-.12.39-.29.77-.48 1.15.53.34 1.21.53 1.85.59 1.83.19 3.22-.54 3.35-1.74.23-2.15-3.37-2.27-3.23-3.54.06-.53.47-.88 1.4-.79.67.07 1.08.43 1.26.95l.18.02m119.58 5.18c.62-2.33 1.41-4.58 2.19-6.87-.17.05-.35.09-.53.11-.17.03-.36.04-.54.05-.37 1.64-.88 3.29-1.42 4.94-.96-1.44-2-2.84-2.83-4.3-.34.07-.68.15-1.02.2s-.69.07-1.04.11c1.45 1.94 2.85 3.89 4.2 5.91.16-.04.32-.1.5-.12.16-.02.33-.02.49-.03m6.18-6.82c-.29.01-.59.04-.88.03-.3 0-.6-.04-.89-.06l-.12 6.41 4.49.08c-.03-.13-.06-.28-.06-.41s.04-.27.07-.4c-.81.05-1.68.1-2.71.08l.1-5.73m7.04 1.05c.72.06 1.41.19 2.1.31-.01-.13-.03-.27-.02-.41.01-.13.06-.26.1-.39l-6.07-.5c.01.14.03.27.02.4-.01.14-.06.27-.1.4.62-.02 1.37-.02 2.21.05l-.53 5.77c.29 0 .59 0 .88.03.3.02.59.07.88.11l.53-5.77m2.49 6.32c.29.05.59.09.88.15.28.06.57.15.85.23l.72-2.94.08.01c.16.41.38.9.49 1.19l.9 2.22c.36.06.71.11 1.05.18.36.08.7.18 1.04.28l-.31-.67c-.48-1-.99-2.01-1.41-3.02 1.12.04 1.98-.36 2.2-1.26.15-.62-.1-1.11-.68-1.53-.44-.31-1.28-.47-1.83-.6l-2.44-.53-1.54 6.29m3.14-5.42c.71.16 1.59.27 1.59 1.07-.01.21-.03.35-.06.48-.23.94-.94 1.26-2.13.91l.6-2.46m8.42 7.35c-.05.69-.18 1.37-.31 2.1.3.14.61.27.9.44.3.16.57.34.86.52l.6-7.23c-.14-.06-.27-.12-.41-.19-.13-.07-.25-.15-.37-.24l-6.38 4.05c.17.08.35.16.51.25.17.09.31.19.47.28.54-.45 1.1-.82 1.74-1.3l2.39 1.31v.01zm-1.81-1.66 2.13-1.37-.25 2.4-1.88-1.03'/%3e%3cpath fill='%23ad1519' stroke-width='.26' d='M249.65 182.72c6.64 0 12.56.99 16.41 2.51 2.2 1 5.16 1.73 8.4 2.17 2.47.33 4.81.39 6.85.24 2.73-.06 6.67.74 10.62 2.48 3.26 1.45 5.99 3.21 7.8 4.91l-1.57 1.4-.45 3.96-4.3 4.92-2.15 1.83-5.09 4.07-2.6.21-.79 2.25-32.91-3.86-33.02 3.86-.79-2.25-2.61-.21-5.08-4.07-2.15-1.83-4.3-4.92-.44-3.96-1.58-1.4c1.82-1.7 4.54-3.46 7.8-4.91 3.95-1.74 7.89-2.54 10.62-2.48 2.04.15 4.38.09 6.85-.24 3.24-.44 6.2-1.17 8.4-2.17 3.86-1.52 9.44-2.51 16.08-2.51z'/%3e%3cg fill='%23c8b100'%3e%3cpath d='m225.34 191.42 1.38 1.11 2.08-3.4c-2.25-1.38-3.8-3.78-3.8-6.51 0-.31.02-.61.06-.91.21-4.34 5.5-7.92 12.2-7.92 3.48 0 6.63.95 8.84 2.48.06-.67.12-1.25.21-1.86-2.43-1.42-5.6-2.28-9.05-2.28-7.71 0-13.74 4.39-14.03 9.57-.03.31-.05.61-.05.92 0 2.76 1.26 5.26 3.26 6.99l-1.1 1.81'/%3e%3cpath d='M225.43 191.46c-2.63-1.97-4.27-4.64-4.27-7.58 0-3.38 2.22-6.4 5.58-8.41-2.07 1.67-3.33 3.83-3.51 6.23-.03.31-.05.61-.05.92 0 2.76 1.26 5.26 3.26 6.99l-1.01 1.85'/%3e%3cpath d='M202.21 194.89c-1.48-1.65-2.38-3.79-2.38-6.12 0-1.41.33-2.75.91-3.95 2.13-4.38 8.82-7.57 16.76-7.57 2.16 0 4.23.23 6.14.67-.42.46-.75.97-1.08 1.48-1.59-.31-3.29-.48-5.06-.48-7.27 0-13.36 2.83-15.12 6.65a7.33 7.33 0 0 0-.73 3.2c0 2.32 1.09 4.4 2.79 5.82l-2.63 4.3-1.41-1.12 1.81-2.88z'/%3e%3cpath d='M204.9 180.48c-1.91 1.21-3.36 2.69-4.16 4.34-.58 1.2-.91 2.54-.91 3.95 0 2.33.9 4.47 2.38 6.12l-1.6 2.59c-1.53-1.96-2.42-4.26-2.42-6.7 0-4.2 2.67-7.87 6.71-10.3zm45.14-9.21c1.76 0 3.28 1.16 3.64 2.73.23 1.38.38 2.95.41 4.62.01.18-.01.35-.01.52 0 .2.04.41.05.61.06 3.52.56 6.62 1.27 8.52l-5.36 5.14-5.43-5.14c.72-1.9 1.22-5 1.29-8.52 0-.2.04-.41.04-.61 0-.17-.01-.34-.01-.52.03-1.67.18-3.24.41-4.62.36-1.57 1.94-2.73 3.7-2.73z'/%3e%3cpath d='M250.04 172.94c.91 0 1.68.58 1.87 1.39.23 1.31.37 2.8.4 4.38 0 .16-.01.32-.01.48 0 .2.03.39.04.59.05 3.32.53 6.25 1.21 8.05l-3.54 3.35-3.54-3.35c.67-1.8 1.15-4.73 1.21-8.05 0-.2.04-.39.04-.59 0-.16-.01-.32-.01-.48.03-1.58.17-3.07.4-4.38.18-.81 1.02-1.39 1.93-1.39zm24.66 18.48-1.39 1.11-2.08-3.4c2.26-1.38 3.81-3.78 3.81-6.51 0-.31-.02-.61-.06-.91-.21-4.34-5.5-7.92-12.2-7.92-3.49 0-6.63.95-8.84 2.48-.06-.67-.12-1.25-.22-1.86 2.44-1.42 5.6-2.28 9.06-2.28 7.71 0 13.74 4.39 14.03 9.57.03.31.05.61.05.92 0 2.76-1.27 5.26-3.27 6.99l1.11 1.81'/%3e%3cpath d='M274.61 191.46c2.63-1.97 4.27-4.64 4.27-7.58 0-3.38-2.22-6.4-5.58-8.41 2.07 1.67 3.33 3.83 3.51 6.23.03.31.05.61.05.92 0 2.76-1.27 5.26-3.27 6.99l1.02 1.85'/%3e%3cpath d='M297.83 194.89c1.47-1.65 2.38-3.79 2.38-6.12 0-1.41-.33-2.75-.91-3.95-2.14-4.38-8.82-7.57-16.76-7.57-2.16 0-4.23.23-6.15.67.43.46.76.97 1.09 1.48 1.58-.31 3.29-.48 5.06-.48 7.27 0 13.35 2.83 15.11 6.65.47.97.73 2.06.73 3.2 0 2.32-1.09 4.4-2.79 5.82l2.63 4.3 1.42-1.12-1.81-2.88z'/%3e%3cpath d='M295.14 180.48c1.91 1.21 3.36 2.69 4.16 4.34.58 1.2.91 2.54.91 3.95 0 2.33-.91 4.47-2.38 6.12l1.6 2.59c1.53-1.96 2.41-4.26 2.41-6.7 0-4.2-2.67-7.87-6.7-10.3z'/%3e%3cellipse cx='250.05' cy='167.3' fill='%23005bbf' stroke-width='.26' rx='4.43' ry='4.2'/%3e%3cpath stroke-width='.26' d='M248.89 155.54v2.26h-2.42v2.3h2.42v6.61h-3.05c-.03.21-.22.37-.22.59 0 .58.12 1.14.35 1.64 0 .02.02.02.03.03h8.12c0-.01.02-.01.03-.03.22-.5.35-1.06.35-1.64 0-.22-.19-.38-.22-.59h-2.96v-6.61h2.42v-2.3h-2.42v-2.26h-2.43z'/%3e%3c/g%3e%3cg fill='%23fff'%3e%3cellipse cx='250.04' cy='188.94' rx='1.91' ry='1.8'/%3e%3cellipse cx='250.04' cy='185.4' rx='1.91' ry='1.8'/%3e%3cellipse cx='250.04' cy='181.6' rx='1.52' ry='1.44'/%3e%3cellipse cx='250.04' cy='178.18' rx='1.1' ry='1.04'/%3e%3cellipse cx='250.04' cy='175.18' rx='.88' ry='.83'/%3e%3cellipse cx='198.94' cy='198.67' rx='1.1' ry='1.04'/%3e%3cellipse cx='197.44' cy='196.02' rx='1.1' ry='1.04'/%3e%3cellipse cx='196.44' cy='192.94' rx='1.1' ry='1.04'/%3e%3cellipse cx='196.31' cy='189.64' rx='1.1' ry='1.04'/%3e%3cellipse cx='197.12' cy='186.4' rx='1.1' ry='1.04'/%3e%3cellipse cx='198.81' cy='183.45' rx='1.1' ry='1.04'/%3e%3cellipse cx='201.06' cy='181.02' rx='1.1' ry='1.04'/%3e%3cellipse cx='203.68' cy='179.01' rx='1.1' ry='1.04'/%3e%3cellipse cx='206.8' cy='177.36' rx='1.1' ry='1.04'/%3e%3cellipse cx='210.04' cy='176.19' rx='1.1' ry='1.04'/%3e%3cellipse cx='213.66' cy='175.54' rx='1.1' ry='1.04'/%3e%3cellipse cx='217.1' cy='175.36' rx='1.1' ry='1.04'/%3e%3cellipse cx='220.47' cy='175.48' rx='1.1' ry='1.04'/%3e%3cellipse cx='224.21' cy='190.32' rx='1.1' ry='1.04'/%3e%3cellipse cx='222.34' cy='187.65' rx='1.1' ry='1.04'/%3e%3cellipse cx='221.35' cy='184.75' rx='1.1' ry='1.04'/%3e%3cellipse cx='221.47' cy='181.57' rx='1.1' ry='1.04'/%3e%3cellipse cx='222.16' cy='178.37' rx='1.1' ry='1.04'/%3e%3cellipse cx='223.84' cy='175.48' rx='1.1' ry='1.04'/%3e%3cellipse cx='226.4' cy='173.47' rx='1.1' ry='1.04'/%3e%3cellipse cx='229.39' cy='171.81' rx='1.1' ry='1.04'/%3e%3cellipse cx='232.7' cy='170.82' rx='1.1' ry='1.04'/%3e%3cellipse cx='236.13' cy='170.23' rx='1.1' ry='1.04'/%3e%3cellipse cx='239.5' cy='170.28' rx='1.1' ry='1.04'/%3e%3cellipse cx='242.99' cy='170.87' rx='1.1' ry='1.04'/%3e%3cellipse cx='246.23' cy='171.99' rx='1.1' ry='1.04'/%3e%3cellipse cx='253.8' cy='171.99' rx='1.1' ry='1.04'/%3e%3cellipse cx='257.04' cy='170.87' rx='1.1' ry='1.04'/%3e%3cellipse cx='260.54' cy='170.28' rx='1.1' ry='1.04'/%3e%3cellipse cx='263.9' cy='170.23' rx='1.1' ry='1.04'/%3e%3cellipse cx='267.34' cy='170.82' rx='1.1' ry='1.04'/%3e%3cellipse cx='270.64' cy='171.81' rx='1.1' ry='1.04'/%3e%3cellipse cx='273.64' cy='173.47' rx='1.1' ry='1.04'/%3e%3cellipse cx='276.19' cy='175.48' rx='1.1' ry='1.04'/%3e%3cellipse cx='277.88' cy='178.37' rx='1.1' ry='1.04'/%3e%3cellipse cx='278.57' cy='181.57' rx='1.1' ry='1.04'/%3e%3cellipse cx='278.69' cy='184.75' rx='1.1' ry='1.04'/%3e%3cellipse cx='277.69' cy='187.65' rx='1.1' ry='1.04'/%3e%3cellipse cx='275.83' cy='190.32' rx='1.1' ry='1.04'/%3e%3cellipse cx='279.57' cy='175.48' rx='1.1' ry='1.04'/%3e%3cellipse cx='282.94' cy='175.36' rx='1.1' ry='1.04'/%3e%3cellipse cx='286.38' cy='175.54' rx='1.1' ry='1.04'/%3e%3cellipse cx='290' cy='176.19' rx='1.1' ry='1.04'/%3e%3cellipse cx='293.24' cy='177.36' rx='1.1' ry='1.04'/%3e%3cellipse cx='296.36' cy='179.01' rx='1.1' ry='1.04'/%3e%3cellipse cx='298.97' cy='181.02' rx='1.1' ry='1.04'/%3e%3cellipse cx='301.22' cy='183.45' rx='1.1' ry='1.04'/%3e%3cellipse cx='302.91' cy='186.4' rx='1.1' ry='1.04'/%3e%3cellipse cx='303.72' cy='189.64' rx='1.1' ry='1.04'/%3e%3cellipse cx='303.6' cy='192.94' rx='1.1' ry='1.04'/%3e%3cellipse cx='302.6' cy='196.02' rx='1.1' ry='1.04'/%3e%3cellipse cx='301.1' cy='198.67' rx='1.1' ry='1.04'/%3e%3c/g%3e%3cg fill='%23c8b100'%3e%3cpath d='M250.15 226.18c-12.26-.02-23.25-1.47-31.09-3.83-.57-.18-.87-.7-.84-1.25-.01-.52.29-1 .84-1.17 7.84-2.36 18.83-3.81 31.09-3.83 12.27.02 23.25 1.47 31.09 3.83.55.17.84.65.83 1.17.03.55-.27 1.07-.83 1.25-7.84 2.36-18.82 3.81-31.09 3.83'/%3e%3cpath d='M250.07 216.09c-12.41.03-23.55 1.58-31.39 4 .65-.31.59-1.12-.22-3.2-.98-2.53-2.5-2.42-2.5-2.42 8.66-2.56 20.73-4.16 34.16-4.18 13.44.02 25.6 1.62 34.27 4.18 0 0-1.53-.11-2.51 2.42-.81 2.08-.87 2.89-.21 3.2-7.84-2.42-19.19-3.97-31.6-4'/%3e%3cpath d='M250.12 210.3c-13.43.02-25.5 1.62-34.16 4.18-.58.17-1.19-.05-1.38-.6s.12-1.18.7-1.35c8.71-2.67 21.08-4.35 34.84-4.38 13.77.03 26.19 1.71 34.9 4.38.58.17.89.8.7 1.35s-.8.77-1.38.6c-8.67-2.56-20.78-4.16-34.22-4.18'/%3e%3cpath d='m250.2 199.78 1.23.22c-.19.5-.24 1.05-.24 1.63 0 2.57 2.21 4.65 4.92 4.65 2.18 0 4.04-1.35 4.67-3.21.08.05.47-1.68.68-1.66.17.02.15 1.8.22 1.77.31 2.34 2.46 3.93 4.87 3.93 2.71 0 4.91-2.08 4.91-4.65 0-.19-.01-.38-.04-.57l1.54-1.52.83 1.94c-.33.61-.46 1.3-.46 2.03 0 2.46 2.1 4.44 4.69 4.44 1.63 0 3.06-.78 3.9-1.97l.99-1.25-.01 1.53c0 1.55.66 2.93 2.16 3.18 0 0 1.73.1 4.03-1.7 2.29-1.8 3.55-3.29 3.55-3.29l.2 1.8s-1.9 2.95-3.97 4.15c-1.14.66-2.86 1.35-4.23 1.13-1.44-.24-2.48-1.4-3.01-2.74-1.03.61-2.25.97-3.55.97-2.81 0-5.33-1.54-6.32-3.86-1.29 1.4-3.09 2.25-5.2 2.25-2.24 0-4.29-1.01-5.57-2.56a7.198 7.198 0 0 1-4.88 1.87c-2.48 0-4.69-1.22-5.94-3.05-1.25 1.83-3.46 3.05-5.94 3.05-1.89 0-3.61-.71-4.87-1.87-1.28 1.55-3.34 2.56-5.58 2.56-2.11 0-3.9-.85-5.19-2.25-1 2.32-3.52 3.86-6.32 3.86-1.31 0-2.52-.36-3.55-.97-.54 1.34-1.57 2.5-3.02 2.74-1.36.22-3.08-.47-4.22-1.13-2.08-1.2-3.98-4.15-3.98-4.15l.2-1.8s1.27 1.49 3.56 3.29c2.29 1.81 4.02 1.7 4.02 1.7 1.51-.25 2.16-1.63 2.16-3.18l-.01-1.53.99 1.25c.84 1.19 2.28 1.97 3.9 1.97 2.59 0 4.69-1.98 4.69-4.44 0-.73-.13-1.42-.46-2.03l.83-1.94 1.54 1.52c-.02.19-.04.38-.04.57 0 2.57 2.2 4.65 4.91 4.65 2.42 0 4.56-1.59 4.88-3.93.06.03.05-1.75.22-1.77.2-.02.6 1.71.67 1.66.64 1.86 2.49 3.21 4.68 3.21 2.71 0 4.91-2.08 4.91-4.65 0-.58-.03-1.13-.24-1.63l1.29-.22'/%3e%3cpath d='M208.37 206.32a2.24 2.24 0 0 0-.72-1.06c-.79-.68-1.84-.79-2.36-.25-.07.07-.13.17-.17.25 0 0-1.11-2.08-2.41-2.78-1.29-.7-3.49-.52-3.49-.52 0-1.6 1.3-2.89 2.99-2.89.99 0 1.92.41 2.48 1.11l.23-1.07s1.36.27 1.98 1.82-.06 3.8-.06 3.8.34-.96.85-1.61c.51-.64 1.81-1.34 2.49-1.66.67-.31 1.37-.79 1.37-.79s.03.18.05.61c.03.51-.01.83-.01.83 1.24-.17 2.69.04 3.83.48-.49.95-1.41 1.84-2.62 2.3 0 0 .44.36.83.75.34.34.44.49.44.49s-.85.13-1.27.19c-.43.05-1.84.28-2.69.22-.62-.04-1.32-.14-1.74-.22'/%3e%3cpath fill='%23ad1519' d='M205.29 205.01c.52-.54 1.57-.43 2.36.25.8.67 1.02 1.66.51 2.19-.51.54-1.57.42-2.36-.25-.79-.68-1.02-1.66-.51-2.19'/%3e%3cpath fill='%23fff' d='M216.39 205.91c-.28-.83-.03-1.65.57-1.83.6-.19 1.32.33 1.6 1.16s.03 1.65-.57 1.84c-.6.18-1.31-.34-1.6-1.17'/%3e%3cpath d='M226.12 201.86c-.33-.27-.59-.64-.67-1.08s.01-.87.23-1.23c0 0-.88-.44-1.83-.69-.72-.19-1.99-.2-2.37-.2-.38-.02-1.15-.03-1.15-.03s.07.17.28.55c.27.46.5.75.5.75-1.27.29-2.35 1.12-3.03 2.09.99.68 2.3 1.1 3.6.97 0 0-.12.34-.2.86-.06.43-.06.61-.06.61s.71-.26 1.07-.39c.35-.13 1.54-.55 2.15-.96.8-.54 1.48-1.25 1.48-1.25'/%3e%3cpath d='M225.68 191.65c1.06.67 1.98 1.79 2.3 3.03 0 0 .13-.25.71-.59.59-.33 1.09-.32 1.09-.32s-.17.97-.25 1.32c-.09.34-.09 1.38-.32 2.32-.23.93-.63 1.68-.63 1.68-.42-.34-.99-.51-1.58-.41-.58.1-1.06.44-1.32.9 0 0-.66-.58-1.21-1.38-.55-.81-.93-1.78-1.13-2.08-.21-.3-.72-1.15-.72-1.15s.47-.18 1.14-.05c.67.12.88.32.88.32-.14-1.28.28-2.62 1.04-3.59'/%3e%3cpath d='M228.97 201.38a1.727 1.727 0 0 0-.42-2.3s.67-.71 1.47-1.26c.6-.41 1.8-.82 2.15-.95.36-.13 1.07-.4 1.07-.4s0 .18-.06.61c-.08.52-.2.87-.2.87 1.3-.14 2.62.29 3.61.98-.69.97-1.77 1.79-3.04 2.08 0 0 .23.28.5.74.21.39.28.56.28.56l-1.15-.03c-.38 0-1.65-.01-2.37-.2-.95-.25-1.84-.69-1.84-.69'/%3e%3cellipse cx='227.37' cy='200.45' fill='%23ad1519' rx='2.17' ry='2.06'/%3e%3cpath fill='%23fff' d='M237.76 201.77c-.11-.87.31-1.63.93-1.7.63-.07 1.23.57 1.34 1.44.11.86-.3 1.63-.93 1.7-.62.07-1.22-.57-1.34-1.44'/%3e%3cpath d='M248.5 199.83c-.32-.36-.53-.82-.53-1.33 0-.5.19-.97.51-1.32 0 0-.89-.67-1.89-1.12-.77-.35-2.18-.59-2.6-.67l-1.28-.24s.04.2.2.67c.2.56.4.93.4.93-1.47.08-2.85.81-3.81 1.76.96.94 2.34 1.66 3.81 1.75 0 0-.2.36-.4.93-.16.46-.2.67-.2.67l1.28-.24c.42-.08 1.83-.32 2.6-.67 1-.46 1.91-1.11 1.91-1.11'/%3e%3cpath d='M250.11 188.36c1.05.95 1.85 2.36 1.95 3.82 0 0 .19-.27.91-.53.73-.26 1.28-.16 1.28-.16s-.39 1.05-.55 1.42c-.17.37-.39 1.53-.84 2.53-.44 1-1.05 1.76-1.05 1.76-.4-.45-1-.75-1.67-.75-.68 0-1.27.3-1.67.75 0 0-.61-.76-1.05-1.76-.45-1-.67-2.16-.84-2.53s-.56-1.42-.56-1.42.56-.1 1.28.16.92.53.92.53c.1-1.46.86-2.87 1.89-3.82'/%3e%3cpath d='M251.76 199.83c.33-.36.53-.82.53-1.33 0-.5-.19-.97-.51-1.32 0 0 .89-.67 1.9-1.12.76-.35 2.17-.59 2.6-.67l1.26-.24s-.02.2-.19.67c-.2.56-.4.93-.4.93 1.47.08 2.86.81 3.81 1.76-.95.94-2.33 1.66-3.81 1.75 0 0 .2.36.4.93.16.46.19.67.19.67l-1.26-.24c-.43-.08-1.84-.32-2.6-.67-1.01-.46-1.92-1.11-1.92-1.11'/%3e%3cellipse cx='250.14' cy='198.5' fill='%23ad1519' rx='2.17' ry='2.06'/%3e%3cpath fill='%23fff' d='M262.58 201.77c.11-.87-.3-1.63-.93-1.7s-1.23.57-1.34 1.44c-.11.86.31 1.63.93 1.7.63.07 1.23-.57 1.34-1.44'/%3e%3cpath d='M271.38 201.38c-.22-.35-.32-.79-.25-1.23.09-.44.33-.81.67-1.07 0 0-.67-.71-1.47-1.26-.61-.41-1.8-.82-2.16-.95-.35-.13-1.06-.4-1.06-.4s-.01.18.06.61c.08.52.19.87.19.87-1.29-.14-2.61.29-3.6.98.68.97 1.77 1.79 3.03 2.08 0 0-.23.28-.49.74-.22.39-.28.56-.28.56l1.14-.03c.38 0 1.66-.01 2.37-.2.95-.25 1.84-.69 1.84-.69'/%3e%3cpath d='M274.67 191.65c-1.06.67-1.98 1.79-2.31 3.03 0 0-.12-.25-.71-.59-.58-.33-1.09-.32-1.09-.32s.17.97.26 1.32c.09.34.09 1.38.31 2.32.23.93.64 1.68.64 1.68.42-.34.99-.51 1.57-.41.59.1 1.06.44 1.33.9 0 0 .66-.58 1.21-1.38.54-.81.92-1.78 1.12-2.08.21-.3.72-1.15.72-1.15s-.47-.18-1.14-.05c-.67.12-.88.32-.88.32.15-1.28-.28-2.62-1.03-3.59'/%3e%3cpath d='M274.22 201.86c.34-.27.6-.64.67-1.08.09-.44 0-.87-.22-1.23 0 0 .88-.44 1.83-.69.72-.19 1.99-.2 2.36-.2.39-.02 1.15-.03 1.15-.03s-.06.17-.28.55c-.26.46-.49.75-.49.75 1.26.29 2.34 1.12 3.03 2.09-.99.68-2.31 1.1-3.6.97 0 0 .11.34.19.86.06.43.06.61.06.61s-.71-.26-1.06-.39c-.36-.13-1.55-.55-2.16-.96-.79-.54-1.48-1.25-1.48-1.25'/%3e%3cellipse cx='272.98' cy='200.45' fill='%23ad1519' rx='2.17' ry='2.06'/%3e%3cpath fill='%23fff' d='M283.96 205.91c.28-.83.03-1.65-.57-1.83-.6-.19-1.32.33-1.61 1.16-.28.83-.03 1.65.57 1.84.6.18 1.32-.34 1.61-1.17'/%3e%3cpath d='M291.97 206.32c.11-.37.36-.75.72-1.06.79-.68 1.85-.79 2.36-.25.07.07.14.17.18.25 0 0 1.1-2.08 2.4-2.78s3.5-.52 3.5-.52c0-1.6-1.31-2.89-3-2.89-.99 0-1.92.41-2.47 1.11l-.23-1.07s-1.36.27-1.98 1.82.05 3.8.05 3.8-.33-.96-.84-1.61c-.51-.64-1.81-1.34-2.49-1.66-.68-.31-1.37-.79-1.37-.79s-.03.18-.06.61c-.02.51.02.83.02.83-1.25-.17-2.7.04-3.83.48.48.95 1.4 1.84 2.61 2.3 0 0-.43.36-.83.75-.33.34-.43.49-.43.49s.85.13 1.27.19c.43.05 1.84.28 2.68.22.63-.04 1.32-.14 1.74-.22'/%3e%3cpath fill='%23ad1519' d='M295.05 205.01c-.51-.54-1.57-.43-2.36.25-.79.67-1.02 1.66-.51 2.19.51.54 1.57.42 2.36-.25.79-.68 1.02-1.66.51-2.19'/%3e%3c/g%3e%3cg fill='none'%3e%3cpath fill='%23ad1519' stroke-linejoin='round' d='M250.12 224.57c-11.06-.01-21.07-1.29-28.68-3.26 7.61-1.97 17.62-3.17 28.68-3.19 11.07.02 21.13 1.22 28.74 3.19-7.61 1.97-17.67 3.25-28.74 3.26z'/%3e%3cpath stroke-width='.05' d='M258.04 224.28v-6.01m-3.02 6.21.04-6.37m-2.24 6.45v-6.49'/%3e%3cpath stroke-width='.09' d='M250.95 224.64v-6.57'/%3e%3cpath stroke-width='.14' d='M249.16 224.64v-6.57'/%3e%3cpath stroke-width='.18' d='M247.48 224.64v-6.57'/%3e%3cpath stroke-width='.23' d='M245.81 224.64v-6.57'/%3e%3cpath stroke-width='.28' d='M244.32 224.64v-6.57'/%3e%3cpath stroke-width='.33' d='m241.48 224.28-.04-5.97m1.39 6.05v-6.25'/%3e%3cpath stroke-width='.37' d='M238.86 224.01v-5.5m1.33 5.66-.04-5.86'/%3e%3cpath stroke-width='.42' d='M235.35 223.7v-4.84m1.15 4.92v-5.08m1.19 5.24v-5.28'/%3e%3cpath stroke-width='.46' d='M234.12 223.66v-4.68'/%3e%3cpath stroke-width='.51' d='M232.97 223.42v-4.36'/%3e%3cpath stroke-width='.56' d='M231.74 223.31v-4.06'/%3e%3cpath stroke-width='.6' d='m229.22 222.95-.04-3.22m1.33 3.38v-3.62'/%3e%3cpath stroke-width='.63' d='M227.93 222.68v-2.84'/%3e%3cpath stroke-width='.68' d='M226.74 222.45v-2.36'/%3e%3cpath stroke-width='.73' d='M225.45 222.13v-1.85'/%3e%3cpath stroke-width='.77' d='M224.12 221.98v-1.38'/%3e%3cpath stroke-width='.91' d='M222.72 221.66v-.67'/%3e%3cpath d='M220.12 221.66c7.75-2.18 18.29-3.52 30-3.54 11.72.02 22.31 1.36 30.06 3.54'/%3e%3cpath fill='%23ad1519' d='m216.72 217.16 1.22-1.59 3.37.43-2.69 1.96-1.9-.8'/%3e%3cpath fill='%23fff' d='M224.03 215.28c0-.58.49-1.04 1.1-1.04s1.1.46 1.1 1.04c0 .57-.49 1.04-1.1 1.04s-1.1-.47-1.1-1.04'/%3e%3cpath fill='%23058e6e' d='m233.64 215.07-2.36.27c-.61.07-1.17-.33-1.24-.9-.08-.57.35-1.09.96-1.15l2.37-.28 2.42-.28c.6-.07 1.15.33 1.22.9s-.36 1.09-.96 1.16l-2.41.28'/%3e%3cpath fill='%23fff' d='M240.54 213.35c0-.58.49-1.04 1.1-1.04.6 0 1.1.46 1.1 1.04 0 .57-.5 1.04-1.1 1.04-.61 0-1.1-.47-1.1-1.04'/%3e%3cpath fill='%23ad1519' d='M250.15 214.16h-3.29c-.6 0-1.11-.46-1.11-1.03 0-.58.49-1.04 1.1-1.04h6.64c.61 0 1.1.46 1.1 1.04 0 .57-.51 1.03-1.11 1.03h-3.33'/%3e%3cpath fill='%23fff' d='M257.56 213.35c0-.58.5-1.04 1.1-1.04.61 0 1.1.46 1.1 1.04 0 .57-.49 1.04-1.1 1.04-.6 0-1.1-.47-1.1-1.04'/%3e%3cpath fill='%23058e6e' d='m266.66 215.07 2.36.27c.6.07 1.17-.33 1.24-.9s-.36-1.09-.96-1.15l-2.37-.28-2.42-.28c-.61-.07-1.15.33-1.22.9-.08.57.36 1.09.96 1.16l2.41.28'/%3e%3cpath fill='%23fff' d='M274.07 215.28c0-.58.49-1.04 1.1-1.04s1.1.46 1.1 1.04c0 .57-.49 1.04-1.1 1.04s-1.1-.47-1.1-1.04'/%3e%3cpath fill='%23ad1519' d='m283.57 217.16-1.21-1.59-3.37.43 2.69 1.96 1.89-.8'/%3e%3c/g%3e%3cg stroke-width='.52'%3e%3cpath fill='%23ccc' d='M250.49 344.33c-13.08 0-26.05-3.2-36.95-8.54-8.03-3.98-13.36-12-13.36-21.19v-33.3H300.6v33.3c0 9.19-5.32 17.21-13.36 21.19-10.9 5.34-23.66 8.54-36.75 8.54z'/%3e%3cpath fill='%23ffd691' d='M252.91 329.55c2.09.63 3.15 2.19 3.15 4.01 0 2.38-2.3 4.18-5.3 4.18-2.99 0-5.42-1.8-5.42-4.18 0-1.79 1-3.8 3.08-3.94 0 0-.06-.19-.24-.5-.22-.23-.64-.66-.64-.66s.79-.15 1.25.02c.46.18.77.47.77.47s.21-.43.52-.76c.3-.33.7-.53.7-.53s.46.38.61.64c.15.27.25.59.25.59s.42-.35.79-.49c.37-.15.84-.26.84-.26s-.13.46-.22.69-.14.72-.14.72'/%3e%3cpath fill='%23058e6e' d='M250.32 340.32s-3.98-2.68-5.7-3.04c-2.21-.47-4.69-.09-5.76-.15.03.03 1.29.93 1.84 1.48s2.39 1.65 3.43 1.91c3.22.81 6.19-.2 6.19-.2m1.14.24s2.54-2.66 5.21-3.02c3.15-.44 5.22.26 6.44.58.03 0-1.01.49-1.56.87-.55.37-1.97 1.57-4.14 1.59-2.18.03-4.58-.23-4.97-.17-.4.06-.98.15-.98.15'/%3e%3cpath fill='%23ad1519' d='M250.69 337.28c-1-.93-1.62-2.25-1.62-3.72 0-1.46.62-2.78 1.63-3.71a5.08 5.08 0 0 1-.01 7.43'/%3e%3cpath fill='%23058e6e' d='M249.68 342.71s.61-1.52.67-2.83c.06-1.09-.15-2.17-.15-2.17h.8s.39 1.16.39 2.17c0 1.02-.18 2.37-.18 2.37s-.55.08-.73.17c-.19.09-.8.29-.8.29'/%3e%3cg fill='%23c8b100'%3e%3cpath fill='%23ad1519' d='M250.32 314.57c0 13.16-11.16 23.82-25.05 23.82s-25.15-10.66-25.15-23.82v-33.35h50.2v33.35'/%3e%3cpath d='M200.03 314.12c.15 7.02 2.95 12.25 5.73 15.67v-49.47h-5.66l-.07 33.8zm11.05 20.11c1.57.83 3.72 2.22 6.03 2.77l-.15-56.96h-5.88v54.19zm11.2 4.02c2.3.23 4.01.19 5.87 0v-58.21h-5.87v58.21zm11.04-1.25c2.3-.46 4.9-1.89 6.03-2.63v-54.33h-5.88l-.15 56.96zm11.49-7.76c2.45-2.18 4.75-7.12 5.59-12.76l.14-36.44h-5.87l.14 49.2z'/%3e%3c/g%3e%3cpath fill='%23ad1519' d='M300.65 281.22v33.35c0 13.16-11.28 23.82-25.17 23.82-13.9 0-25.16-10.66-25.16-23.82v-33.35h50.33'/%3e%3cpath id='e' fill='%23c8b100' stroke='%23c8b100' stroke-width='.26' d='M272.71 306.14c.05-.14.12-.27.19-.4l-4.26-4.74-1.67.72-3.06-3.39 1-1.46-5.34-5.99c-.07.02-.2.02-.27.04l.03 4.02 1.75.5v4.46l-1.75.48-.03 4.08c.84.26 1.48.88 1.74 1.67l3.21.01.51-1.67h4.72l.5 1.67zm-6.98-18.5v1.61h2.76v-1.61zm-7.3 20.37c.64 0 1.16-.49 1.16-1.1s-.52-1.11-1.16-1.11c-.65 0-1.17.5-1.17 1.11s.52 1.1 1.17 1.1zm15.99-9.73-1.76-.48v-4.46l1.76-.5-.01-1.92c-.85-.25-1.51-.87-1.79-1.67h-2.68l-.51 1.67h-4.71l-.51-1.67h-3.09c-.08.22-.17.42-.29.61l5.38 5.96 1.67-.71 3.06 3.4-1 1.45 4.18 4.64c.09-.04.18-.08.28-.12zm-7.25-1.39-1.29 1.04 1.77 1.98 1.29-1.05zm8.004 36.186c-1.24-.065-2.255-.902-2.514-2.016-1.67-.23-3.25-.66-4.73-1.3l.84-1.43c1.29.55 2.66.91 4.08 1.11.31-.66.86-1.16 1.58-1.4l.01-5.62-1.76-.49v-4.46l1.76-.48v-7.64a.882.882 0 0 1-.2-.09l-3.98 4.42 1 1.44-3.06 3.4-1.67-.71-3.3 3.67c.57.87.55 2-.11 2.85a15.58 15.58 0 0 0 3.24 2.75l-.84 1.44c-1.42-.89-2.7-1.99-3.79-3.22-.87.26-1.86.11-2.6-.5-1.15-.93-1.29-2.56-.3-3.64l.14-.16c-.69-1.56-1.16-3.24-1.32-5l1.71.01c.14 1.5.51 2.93 1.09 4.27.49-.06 1-.01 1.46.16l3.32-3.68-1-1.45 3.06-3.4 1.67.72 3.99-4.43a2.15 2.15 0 0 1-.21-.46l-2.76.01-.5 1.67h-4.72l-.51-1.67-3.24-.01c-.27.76-.9 1.36-1.69 1.62l-.01 4.04-1.71-.01v-4.01c-1.1-.33-1.91-1.31-1.91-2.47 0-1.15.82-2.15 1.92-2.48l.01-4.05-1.76-.48v-4.46l1.76-.5v-4.05c-1.08-.35-1.84-1.32-1.84-2.45 0-1.43 1.22-2.58 2.73-2.58 1.22 0 2.25.74 2.61 1.78h3.09l.51-1.67h4.71l.51 1.67h2.68c.357-1.031 1.363-1.767 2.559-1.78l.071 8.37h-.85v2.61h.845l-.021 21.59h-.784v2.61h.78zm-5.914-18.306-1.29-1.04-1.78 1.98 1.29 1.04zm-9.96-18.44h-1.69l-.01 2.61h1.7zm9.16 11.41v-1.6h-2.85v1.6zm-10.6 9.69-1.76-.39-.25-4.45 1.75-.58v2.56c0 .99.09 1.92.26 2.86zm1.46-5.52 1.75.41s.09 2.87.05 2.22c-.04-.74.19 2.24.19 2.24l-1.76.58c-.18-.9-.24-1.84-.24-2.79zm10.81 16.93.39-1.7c-1.52-.48-2.93-1.18-4.17-2.09l-1.26 1.11c1.48 1.15 3.19 2.08 5.04 2.68zm-.85 1.44-1.3 1.22c-1.47-.54-2.86-1.26-4.12-2.11l.38-1.77c1.5 1.13 3.21 2.03 5.04 2.66z'/%3e%3cuse xlink:href='%23e' transform='matrix(-1 0 0 1 550.43 0)'/%3e%3cpath fill='%23058e6e' stroke='none' d='M272.59 306.94c0-1.44 1.23-2.6 2.74-2.6s2.73 1.16 2.73 2.6c0 1.43-1.22 2.58-2.73 2.58s-2.74-1.15-2.74-2.58'/%3e%3cg fill='%23c8b100' stroke-width='.46'%3e%3cpath fill='%23ad1519' stroke-width='.52' d='M200.12 281.25h50.18v-55.72h-50.18v55.72z'/%3e%3cpath d='M217.34 238.41h-.92v-.92h-1.62v3.69h1.62v2.55h-3.47v7.39h1.85v14.79h-3.7v7.63h28.42v-7.63h-3.69v-14.79h1.85v-7.39h-3.47v-2.55h1.62v-3.69h-1.62v.92h-.93v-.92h-1.61v.92h-1.16v-.92h-1.62v3.69h1.62v2.55h-3.46v-8.09h1.84v-3.7h-1.84v.93h-.93v-.93h-1.62v.93h-.92v-.93h-1.85v3.7h1.85v8.09h-3.47v-2.55h1.62v-3.69h-1.62v.92h-.92v-.92h-1.85v.92zm-6.24 35.13h28.42m-28.42-1.85h28.42m-28.42-1.85h28.42m-28.42-1.85h28.42m-28.42-2.08h28.42m-24.72-1.62h21.03m-21.03-1.85h21.03m-21.03-2.08h21.03m-21.03-1.84h21.03m-21.03-1.85h21.03m-21.03-1.85h21.03m-21.03-1.85h21.03m-22.88-1.85h24.73m-24.73-1.85h24.73m-24.73-1.85h24.73m-24.73-1.84h24.73m-21.26-1.85h17.79m-10.63-1.85h3.47m-3.47-1.85h3.47m-3.47-1.85h3.47m-3.47-1.85h3.47m-5.32-2.31h7.16m-12.47 7.86h3.69m-5.31-2.31h6.93m-6.93 33.97v-1.85m0-1.85v-1.85m-1.85 1.85v1.85m3.47 0v-1.85m1.84 3.7v-1.85m0-1.85v-1.85m0-2.08v-1.62m0-1.85v-2.08m-1.84 7.63v-2.08m-3.47 2.08v-2.08m7.16 0v2.08m1.62-2.08v-1.62m-5.31-1.85v1.85m3.69-1.85v1.85m3.47-1.85v1.85m-1.85-1.85v-2.08m1.85-1.84v1.84m0-5.54v1.85m-1.85-3.7v1.85m1.85-3.7v1.85m-3.47-1.85v1.85m-3.69-1.85v1.85m-1.62-3.7v1.85m3.46-1.85v1.85m3.47-1.85v1.85m1.85-3.7v1.85m-3.47-1.85v1.85m-3.69-1.85v1.85m-1.62-3.69v1.84m6.93-1.84v1.84m-3.47-5.54v1.85m15.95-1.85h-3.7m5.32-2.31h-6.94m6.94 33.97v-1.85m0-1.85v-1.85m1.85 1.85v1.85m-3.47 0v-1.85m-1.85 3.7v-1.85m0-1.85v-1.85m0-2.08v-1.62m0-1.85v-2.08m1.85 7.63v-2.08m3.47 2.08v-2.08m-7.17 0v2.08m-1.62-2.08v-1.62m5.32-1.85v1.85m-3.7-1.85v1.85m-3.46-1.85v1.85m1.84-1.85v-2.08m-1.84-1.84v1.84m0-5.54v1.85m1.84-3.7v1.85m-1.84-3.7v1.85m3.46-1.85v1.85m3.7-1.85v1.85m1.62-3.7v1.85m-3.47-1.85v1.85m-3.47-1.85v1.85m-1.84-3.7v1.85m3.46-1.85v1.85m3.7-1.85v1.85m1.62-3.69v1.84m-6.94-1.84v1.84m3.47-5.54v1.85m-7.16 18.71v-2.08m0-5.54v-1.85m0 5.55v-1.85m0-5.55v-1.85m0-1.85v-1.84m0-3.7v-1.85m0-1.85v-1.85m-8.78 4.85h3.69m3.47-5.54h3.47m3.46 5.54h3.7'/%3e%3cpath d='M230.05 273.54v-4.86c0-.92-.46-3.7-4.85-3.7-4.16 0-4.62 2.78-4.62 3.7v4.86h9.47z'/%3e%3cpath d='m222.19 268.91-2.31-.23c0-.92.23-2.31.93-2.77l2.08 1.62c-.23.23-.7.92-.7 1.38zm3.93-2.31 1.16-2.08c-.46-.23-1.39-.46-2.08-.46-.46 0-1.39.23-1.85.46l1.15 2.08h1.62zm2.31 2.31 2.31-.23c0-.92-.23-2.31-.92-2.77l-2.08 1.62c.23.23.69.92.69 1.38zm-6.7-8.08v-5.09c0-1.38-.92-2.54-2.54-2.54s-2.54 1.16-2.54 2.54v5.09h5.08zm7.16 0v-5.09c0-1.38.93-2.54 2.55-2.54 1.61 0 2.54 1.16 2.54 2.54v5.09h-5.09zm-8.78-12.48.23-4.62h-4.39l.47 4.62h3.69zm6.94 0 .46-4.62h-4.39l.23 4.62h3.7zm3.46 0-.46-4.62h4.62l-.46 4.62h-3.7z'/%3e%3cpath fill='%230039f0' stroke='none' d='M228.43 273.54v-4.16c0-.7-.46-2.78-3.23-2.78-2.54 0-3.01 2.08-3.01 2.78v4.16h6.24zm-7.16-13.18v-4.39c0-1.15-.69-2.31-2.08-2.31s-2.08 1.16-2.08 2.31v4.39h4.16zm8.09 0v-4.39c0-1.15.69-2.31 2.08-2.31 1.38 0 2.08 1.16 2.08 2.31v4.39h-4.16z'/%3e%3c/g%3e%3cpath fill='%23ccc' d='M250.28 281.25h50.32v-55.72h-50.32v55.72z'/%3e%3cpath fill='%23db4446' stroke-width='.39' d='m275.93 239.26.05-.62.09-.34s-1.61.13-2.46-.11-1.61-.59-2.4-1.25c-.79-.68-1.1-1.1-1.67-1.18-1.36-.22-2.4.4-2.4.4s1.02.37 1.78 1.31 1.59 1.41 1.95 1.53c.59.18 2.66.05 3.22.07.57.03 1.84.19 1.84.19z'/%3e%3cg fill='none' stroke-width='.39'%3e%3cpath fill='%23ed72aa' d='M283.46 237s.01.72.08 1.4c.06.67-.22 1.24-.11 1.61s.16.66.3.93c.14.26.21.94.21.94s-.38-.28-.74-.54c-.35-.27-.6-.44-.6-.44l.1 1.03c.04.31.22.89.51 1.24.29.33.87.89 1.05 1.33.18.45.14 1.44.14 1.44s-.46-.75-.87-.89c-.39-.14-1.26-.62-1.26-.62s.79.79.79 1.55c0 .75-.32 1.6-.32 1.6s-.36-.68-.83-1.12c-.47-.45-1.13-.9-1.13-.9s.52 1.17.52 1.95c0 .79-.15 2.47-.15 2.47s-.39-.64-.79-.96c-.4-.31-.87-.58-1.02-.78-.14-.21.48.64.54 1.16.07.51.32 2.35 1.92 4.69.94 1.37 2.39 3.77 5.5 2.98 3.11-.78 1.96-4.97 1.3-6.92-.65-1.95-.98-4.11-.94-4.87.04-.75.58-2.97.51-3.39-.07-.41-.24-2 .14-3.28.4-1.33.73-1.85.95-2.4.21-.55.39-.86.46-1.34s.07-1.37.07-1.37.58 1.06.73 1.44c.14.38.14 1.5.14 1.5s.11-1.12.98-1.67 1.88-1.13 2.13-1.44.33-.51.33-.51-.08 1.92-.62 2.67c-.36.49-1.77 2.09-1.77 2.09s.73-.28 1.23-.3c.51-.04.87 0 .87 0s-.62.48-1.41 1.64c-.8 1.16-.47 1.26-1.05 2.22s-1.05 1-1.78 1.58c-1.08.87-.5 4.34-.36 4.86.15.51 2.03 4.76 2.07 5.79.03 1.03.21 3.33-1.6 4.8-1.16.95-3.07.96-3.51 1.23-.43.28-1.29 1.13-1.29 2.91 0 1.79.64 2.06 1.15 2.51.51.44 1.16.2 1.3.55.15.34.22.54.44.75.21.2.36.44.29.82-.08.38-.91 1.23-1.2 1.85-.29.61-.87 2.23-.87 2.47s-.07.99.18 1.37c0 0 .91 1.06.29 1.26-.4.14-.78-.25-.97-.2-.54.14-.83.47-.98.45-.36-.07-.36-.25-.4-.76-.03-.51-.01-.72-.17-.72-.22 0-.33.18-.37.45s-.04.89-.29.89-.61-.45-.83-.55-.83-.2-.87-.48c-.03-.27.36-.85.76-.96.4-.1.76-.3.51-.51-.26-.2-.51-.2-.76 0-.25.21-.79.04-.76-.27.04-.31.11-.69.07-.86-.03-.17-.47-.51.1-.82.59-.31.84.27 1.42.17s.86-.31 1.08-.65.18-1.06-.22-1.5c-.39-.45-.79-.52-.94-.8-.14-.27-.36-.92-.36-.92s.11 1.2.04 1.37-.04.89-.04.89-.39-.45-.72-.79c-.32-.34-.65-1.37-.65-1.37s-.03.96-.03 1.34c0 .37.43.72.29.86-.15.13-.83-.72-1.02-.86-.18-.14-.76-.58-1.01-1.06s-.44-1.16-.51-1.41c-.07-.24-.19-1.31-.07-1.58.18-.4.47-1.13.47-1.13h-1.41c-.76 0-1.3-.23-1.59.28s-.15 1.54.21 2.88c.37 1.33.58 1.98.48 2.22-.11.24-.58.79-.76.89-.19.11-.69.07-.91-.03-.21-.1-.57-.27-1.26-.27s-1.12.03-1.37-.03c-.26-.07-.88-.38-1.17-.31s-.79.32-.65.72c.22.61-.21.75-.51.72-.29-.04-.53-.14-.9-.24-.36-.11-.9 0-.83-.42.07-.41.22-.44.4-.74.18-.32.25-.52.04-.54-.25-.02-.51-.05-.7.11-.2.16-.51.51-.76.38-.26-.14-.46-.43-.46-1.08 0-.64-.68-1.2-.05-1.17.62.03 1.41.48 1.55.13s.06-.51-.28-.78-.76-.43-.31-.77c.45-.35.56-.35.74-.54.17-.18.41-.79.73-.64.62.3.02.73.65 1.42.62.69 1.01.94 2.06.83 1.04-.11 1.33-.24 1.33-.54 0-.29-.09-.82-.12-1.04-.02-.21.15-.99.15-.99s-.48.3-.63.59c-.13.29-.42.8-.42.8s-.11-.6-.08-1.09c.02-.29.12-.79.11-.89-.03-.27-.23-.94-.23-.94s-.16.73-.28.94c-.11.21-.16 1.07-.16 1.07s-.67-.58-.48-1.55c.13-.75-.12-1.74.11-2.06.22-.33.75-1.64 2.06-1.69 1.3-.05 2.31.05 2.77.03.45-.03 2.06-.33 2.06-.33s-2.97-1.52-3.64-1.98c-.68-.45-1.73-1.63-2.07-2.16-.34-.54-.65-1.58-.65-1.58s-.53.02-1.02.29c-.48.27-.96.67-1.24.99s-.73 1.05-.73 1.05.08-.94.08-1.23-.06-.86-.06-.86-.33 1.28-1.01 1.76c-.68.49-1.47 1.15-1.47 1.15s.08-.71.08-.88c0-.16.17-.99.17-.99s-.48.72-1.21.86c-.74.13-1.81.11-1.9.56-.08.45.2 1.07.03 1.39s-.54.54-.54.54-.42-.35-.79-.38c-.36-.03-.71.16-.71.16s-.31-.4-.19-.67c.11-.26.67-.66.54-.83-.15-.16-.6.06-.88.19-.28.14-.88.27-.82-.19.05-.45.2-.72.05-1.04-.14-.32-.05-.53.18-.61.22-.08 1.12.02 1.21-.19.08-.21-.22-.48-.82-.61-.59-.14-.88-.49-.57-.78.32-.3.4-.38.54-.64.14-.27.2-.76.74-.51.53.24.42.83.99 1.01.56.19 1.89-.08 2.17-.24s1.19-.83 1.5-.99c.31-.15 1.61-1.12 1.61-1.12s-.76-.53-1.05-.8c-.28-.27-.78-.91-1.04-1.05-.25-.13-1.5-.61-1.92-.64-.42-.02-1.72-.48-1.72-.48s.59-.19.79-.35c.19-.16.64-.56.87-.53.22.02.28.02.28.02s-1.21-.05-1.47-.13c-.25-.08-.99-.54-1.27-.54s-.84.11-.84.11.76-.48 1.38-.59c.62-.1 1.1-.08 1.1-.08s-.96-.27-1.19-.58c-.22-.33-.45-.8-.62-1.02-.17-.21-.28-.56-.59-.59s-.85.38-1.16.35-.54-.22-.57-.67c-.02-.46 0-.3-.1-.54-.12-.24-.57-.8-.15-.93.43-.14 1.33.08 1.42-.08.08-.16-.48-.65-.85-.83-.37-.19-.96-.51-.65-.78.31-.26.62-.37.79-.61s.37-.91.74-.7c.36.21.87 1.26 1.16 1.18.28-.08.3-.83.25-1.15-.06-.32 0-.88.28-.83s.51.43.96.46c.45.02 1.13-.11 1.07.21-.05.32-.31.71-.62 1.06-.3.36-.45 1.05-.25 1.5.2.46.71 1.19 1.16 1.48s1.3.51 1.84.85c.53.35 1.78 1.34 2.2 1.45s.85.32.85.32.48-.21 1.13-.21 2.14.1 2.71-.14 1.3-.64 1.08-1.15c-.23-.51-1.47-.96-1.36-1.36s.57-.43 1.33-.46c.76-.02 1.8.14 2-.94.2-1.06.26-1.68-.81-1.92-1.08-.24-1.87-.27-2.07-1.04-.2-.78-.39-.97-.17-1.18.23-.21.62-.32 1.41-.37.8-.06 1.7-.06 1.96-.25.25-.18.3-.69.61-.91.31-.21 1.53-.4 1.53-.4s1.46.71 2.8 1.71c1.21.9 2.3 2.23 2.3 2.23'/%3e%3cpath d='M269 243.39s-.8.23-1.1.67c-.37.53-.34 1.07-.34 1.07s.68-.56 1.56-.33c.87.24.96.33 1.33.3s1.27-.35 1.27-.35-.74.86-.65 1.45c.08.58.19.85.17 1.15-.06.72-.6 1.61-.6 1.61s.31-.19 1.05-.35c.73-.16 1.36-.51 1.75-.81.39-.29.9-1.02.9-1.02s-.16 1 0 1.42c.17.44.23 1.67.23 1.67s.47-.42.85-.62c.19-.11.7-.38.9-.7.14-.22.32-1.06.32-1.06s.11.9.39 1.34c.28.42.7 1.74.7 1.74s.29-.86.6-1.21.68-.8.7-1.07c.03-.27-.08-.85-.08-.85l.39.85m-11.41.61s.48-.83.93-1.1c.46-.26 1.08-.74 1.25-.8.16-.05.9-.46.9-.46m.99 5.17s1.09-.55 1.41-.75c.68-.4 1.16-1.12 1.16-1.12'/%3e%3cpath stroke-width='.26' d='M282.57 240.9s-.34-.48-.42-.65c-.09-.15-.23-.48-.23-.48'/%3e%3cpath d='M278.33 257.41s2.04 1.26 1.98 2.31c-.06 1.04-1.13 2.41-1.13 2.41'/%3e%3c/g%3e%3cpath stroke-width='.26' d='M273.05 236.24s-.17-.48-.2-.62c-.03-.13-.12-.29-.12-.29s.88 0 .85.27c-.02.27-.28.27-.34.37-.05.11-.19.27-.19.27z'/%3e%3cpath stroke-width='.05' d='m277.06 234.85-.06-.43s.77 0 1.13.26c.57.4.93 1.02.91 1.05-.1.09-.54-.27-.85-.37 0 0-.23.05-.45.05-.23 0-.34-.11-.37-.21-.03-.12.03-.3.03-.3l-.34-.05z'/%3e%3cpath stroke-width='.26' d='m273.08 240.14.33-.53.34.49-.67.04m.81-.02.4-.53.43.48-.83.05m-.36-3.29.82.29-.74.38-.08-.67m.99.27.73.18-.59.46-.14-.64'/%3e%3cpath fill='%23db4446' stroke-width='.39' d='M261.88 236.08s.48.34.85.4c.37.05.76.05.82.05.05 0 .17-.54.11-.91-.2-1.2-1.3-1.47-1.3-1.47s.33.73.17 1.07c-.23.48-.65.86-.65.86zm-2.29 1.04s-.43-.77-1.33-.67c-.9.11-1.5.81-1.5.81s1-.03 1.25.13c.37.24.48.86.48.86s.54-.32.71-.54c.16-.21.39-.59.39-.59zm-1.1 3.13s-.77.11-1.19.59c-.43.49-.36 1.4-.36 1.4s.5-.54.95-.54c.46 0 1.16.16 1.16.16s-.22-.56-.22-.8-.34-.81-.34-.81zm2.57 10.12s-.42-.45-1.16-.32c-.74.14-1.22.97-1.22.97s.63-.17 1-.08c.36.08.62.45.62.45s.34-.29.45-.45.31-.57.31-.57zm-.85 2.97s-.62-.1-1.16.33c-.53.43-.56 1.25-.56 1.25s.51-.43.91-.37c.39.05.87.27.87.27s.08-.51.11-.64c.09-.38-.17-.84-.17-.84zm1.45 2.74s-.05.79.33 1.28c.4.51 1.13.59 1.13.59s-.24-.53-.28-.8c-.06-.4.34-.75.34-.75s-.37-.38-.73-.38c-.37 0-.79.06-.79.06zm7.34 7.04s-.51-.64-1.21-.62c-.71.03-1.45.69-1.45.69s.88-.07 1.11.22c.23.3.45.67.45.67s.4-.21.57-.35c.17-.13.53-.61.53-.61zm-2.17 2.81s-.93-.14-1.39.35c-.45.48-.42 1.36-.42 1.36s.56-.61 1.07-.56 1.08.32 1.08.32-.09-.53-.15-.78c-.05-.24-.19-.69-.19-.69zm2.01 2.97s-.46.64-.12 1.15 1.05.75 1.05.75-.26-.37-.14-.8c.09-.34.67-.8.67-.8l-1.46-.3zm12.4 1.21s-.81-.19-1.27.08c-.45.26-.82 1.39-.82 1.39s.74-.62 1.28-.54c.53.08.93.3.93.3s.08-.46.02-.78c-.03-.19-.14-.45-.14-.45zm.4 2.99s-.62.64-.4 1.18c.23.54.62 1.1.62 1.1s-.02-.8.23-1.02c.37-.32 1.05-.37 1.05-.37s-.54-.48-.71-.54c-.17-.05-.79-.35-.79-.35zm3.11.94s-.31.78.28 1.28c.59.52 1.11.57 1.11.57s-.46-.81-.32-1.23c.15-.45.54-.72.54-.72s-.74-.25-.85-.22c-.11.02-.76.32-.76.32z'/%3e%3cg fill='%23c8b100' stroke-width='.26'%3e%3cpath d='m282.88 232.71-.29.02c-.01.03-.14.24-.26.35-.26.25-.65.28-.86.07a.486.486 0 0 1-.14-.41c-.17.09-.35.09-.51-.01-.26-.15-.32-.5-.14-.79.03-.06.06-.14.11-.18l-.02-.32-.35.08-.1.19c-.22.25-.54.31-.7.17a.526.526 0 0 1-.13-.27c0 .01-.09.09-.17.11-.54.13-.75-1.05-.77-1.35l-.17.25s.16.7.08 1.3c-.08.59-.29 1.19-.29 1.19.74.19 1.86.8 2.97 1.65s1.98 1.78 2.34 2.42c0 0 .58-.32 1.18-.51s1.36-.2 1.36-.2l.22-.21c-.32.05-1.58.1-1.56-.43 0-.08.07-.18.08-.18a.697.697 0 0 1-.3-.06c-.18-.13-.18-.43.02-.69l.18-.13.01-.34-.34.05c-.03.04-.11.09-.15.13-.27.23-.65.25-.86.03a.416.416 0 0 1-.11-.46.58.58 0 0 1-.45-.05c-.26-.15-.31-.52-.11-.8.09-.14.28-.31.31-.32l-.07-.3h-.01z'/%3e%3cpath fill='%23000' stroke-width='.05' d='M280.63 233.4c.05-.07.15-.06.23 0s.1.16.06.21c-.05.06-.15.06-.24-.01-.07-.05-.1-.15-.05-.2zm.95.79-.33-.25c-.06-.04-.07-.12-.04-.16.04-.04.12-.04.18 0l.33.26.33.25c.05.04.08.12.04.16s-.12.04-.18 0l-.33-.26m-1.74-1.19-.26-.15c-.07-.04-.1-.12-.07-.17s.11-.06.17-.02l.26.16.26.15c.06.03.09.11.07.16-.03.05-.11.06-.17.02l-.26-.15m-1.04-.71c.05-.06.16-.06.24 0 .08.07.1.16.05.22-.05.05-.15.05-.23-.01s-.1-.15-.06-.21zm3.83 2.63c.05-.05.03-.14-.05-.21-.08-.06-.19-.06-.24 0-.04.05-.02.15.06.21s.18.06.23 0zm.57.66.22.21c.05.05.13.07.18.03.04-.04.04-.11-.01-.16l-.21-.21-.22-.21c-.05-.05-.14-.07-.18-.03-.05.03-.04.11.01.16l.21.21m.95.81c.05-.06.03-.15-.05-.21-.08-.07-.18-.07-.23-.01s-.03.15.05.22c.08.05.18.06.23 0z'/%3e%3cpath d='m281.4 230.36-.59.01-.11.87.06.14.15-.01.76-.51-.27-.5'/%3e%3cpath d='m281.4 230.36-.59.01-.11.87.06.14.15-.01.76-.51-.27-.5'/%3e%3cpath d='m279.8 230.84-.02.54.92.12.15-.07-.02-.15-.53-.71-.5.27'/%3e%3cpath d='m281.7 231.92-.49.27-.54-.71-.01-.15.14-.06.93.11-.03.54'/%3e%3cpath d='M280.51 231.25c.08-.13.26-.17.39-.09.14.07.18.24.1.37s-.26.17-.39.09a.26.26 0 0 1-.1-.37zm-2.15-.9c-.02.01-.13-.46-.26-.71-.08-.19-.39-.43-.39-.43.03-.05.42-.19.87.09.38.31-.03.87-.03.87s-.09.14-.19.18z'/%3e%3cpath d='m279.39 230.66-.42.37-.68-.6.06-.08.03-.15.92-.07.09.53'/%3e%3cpath d='M278.24 230.29c.05-.15.18-.23.28-.2.11.04.15.18.1.33s-.18.23-.29.2c-.11-.04-.15-.18-.09-.33zm5.43 1.48-.59-.06-.25.85.05.14.15.01.83-.41-.19-.53'/%3e%3cpath d='m282.01 232.03-.1.54.9.23.15-.04.01-.14-.43-.79-.53.2'/%3e%3cpath d='m283.73 233.36-.53.2-.42-.78.01-.15.15-.03.89.23-.1.53'/%3e%3cpath d='M282.65 232.54c.1-.12.28-.13.4-.04.13.09.15.26.05.38s-.28.13-.41.04a.26.26 0 0 1-.04-.38zm2.99 1.07.11.55-.87.3-.16-.04-.01-.14.36-.81.57.14'/%3e%3cpath d='m285.49 235.2-.56.13-.31-.83.04-.15.15-.02.85.35-.17.52'/%3e%3cpath d='m283.97 233.66-.18.52.85.34.16-.02.03-.14-.3-.83-.56.13'/%3e%3cpath d='M284.91 234.63c.12-.11.12-.28.02-.39a.318.318 0 0 0-.41-.02c-.11.11-.12.28-.01.39.1.11.29.12.4.02zm1.38 1.8c0 .01.5.03.79.09.2.04.52.27.52.27.06-.04.12-.42-.28-.79-.39-.28-.88.22-.88.22s-.12.12-.15.21z'/%3e%3cpath d='m285.75 235.54-.29.46.76.51.09-.08.13-.04-.12-.88-.57.03'/%3e%3cpath d='M286.37 236.53c.14-.07.21-.22.15-.31s-.22-.1-.36-.02-.2.22-.14.31c.05.09.21.1.35.02z'/%3e%3c/g%3e%3cg stroke-width='.61'%3e%3cellipse cx='250.43' cy='281.01' fill='%23ad1519' rx='16.26' ry='18.3'/%3e%3cellipse cx='250.44' cy='280.97' fill='%23005bbf' rx='11.44' ry='13.42'/%3e%3cg id='f' fill='%23c8b100' stroke-width='.34'%3e%3cpath stroke-linejoin='round' d='M245.03 271.74s-1.35 1.48-1.35 2.86c0 1.39.57 2.54.57 2.54-.21-.55-.76-.94-1.41-.94-.83 0-1.5.63-1.5 1.42 0 .22.14.58.24.77l.49.99c.16-.37.54-.57.98-.57.59 0 1.08.45 1.08 1.01 0 .09-.01.17-.04.25l-1.22.01v1.03h1.09l-.81 1.61 1.07-.42.81.91.84-.91 1.07.42-.8-1.61h1.08v-1.03l-1.22-.01c-.02-.08-.02-.16-.02-.25 0-.56.47-1.01 1.06-1.01.44 0 .82.2.98.57l.49-.99c.1-.19.24-.55.24-.77 0-.79-.67-1.42-1.49-1.42-.66 0-1.21.39-1.41.94 0 0 .57-1.15.57-2.54 0-1.38-1.39-2.86-1.39-2.86z'/%3e%3cpath d='M242.87 281.11h4.36v-1.03h-4.36v1.03z'/%3e%3c/g%3e%3cuse xlink:href='%23f' x='10.63'/%3e%3cuse xlink:href='%23f' x='5.31' y='9.14'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e";
            },
            4178: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 720 360'%3e%3cpath fill='%23da121a' d='M0 0h720v360H0z'/%3e%3cpath fill='%23fcdd09' d='M0 0h720v240H0z'/%3e%3cpath fill='%23078930' d='M0 0h720v120H0z'/%3e%3cg transform='translate(360 180)'%3e%3ccircle r='120' fill='%230f47af'/%3e%3cg id='a'%3e%3cpath fill='%23fcdd09' d='m0-96-4.206 12.944 17.348 53.39h-23.13l-2.599 8h74.163l11.011-8H21.553z'/%3e%3cpath stroke='%23fcdd09' stroke-width='4' d='m25.863-35.597 30.564-42.069'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='rotate(72)'/%3e%3cuse xlink:href='%23a' transform='rotate(144)'/%3e%3cuse xlink:href='%23a' transform='rotate(216)'/%3e%3cuse xlink:href='%23a' transform='rotate(288)'/%3e%3c/g%3e%3c/svg%3e";
            },
            4617: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 810 540'%3e%3cdefs%3e%3cg id='d'%3e%3cg id='b'%3e%3cpath id='a' d='M0 0v1h.5z' transform='rotate(18 3.157 -.5)'/%3e%3cuse xlink:href='%23a' transform='scale(-1 1)'/%3e%3c/g%3e%3cg id='c'%3e%3cuse xlink:href='%23b' transform='rotate(72)'/%3e%3cuse xlink:href='%23b' transform='rotate(144)'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='scale(-1 1)'/%3e%3c/g%3e%3c/defs%3e%3cpath fill='%23039' d='M0 0h810v540H0z'/%3e%3cg fill='%23fc0' transform='matrix(30 0 0 30 405 270)'%3e%3cuse xlink:href='%23d' y='-6'/%3e%3cuse xlink:href='%23d' y='6'/%3e%3cg id='e'%3e%3cuse xlink:href='%23d' x='-6'/%3e%3cuse xlink:href='%23d' transform='rotate(-144 -2.344 -2.11)'/%3e%3cuse xlink:href='%23d' transform='rotate(144 -2.11 -2.344)'/%3e%3cuse xlink:href='%23d' transform='rotate(72 -4.663 -2.076)'/%3e%3cuse xlink:href='%23d' transform='rotate(72 -5.076 .534)'/%3e%3c/g%3e%3cuse xlink:href='%23e' transform='scale(-1 1)'/%3e%3c/g%3e%3c/svg%3e";
            },
            9314: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1800 1100'%3e%3cpath fill='%23fff' d='M0 0h1800v1100H0z'/%3e%3cpath fill='%23003580' d='M0 400h1800v300H0z'/%3e%3cpath fill='%23003580' d='M500 0h300v1100H500z'/%3e%3c/svg%3e";
            },
            5916: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 600'%3e%3cclipPath id='a'%3e%3cpath d='M0 0v150h700v150H600zm0 300v100h300V0h300z'/%3e%3c/clipPath%3e%3cpath fill='%23012169' d='M0 0h1200v600H0z'/%3e%3cpath stroke='%23fff' stroke-width='60' d='m0 0 600 300M0 300 600 0'/%3e%3cpath stroke='%23c8102e' stroke-width='40' d='m0 0 600 300M0 300 600 0' clip-path='url(%23a)'/%3e%3cpath stroke='%23fff' stroke-width='100' d='M300 0v400M0 150h700'/%3e%3cpath stroke='%23c8102e' stroke-width='60' d='M300 0v400M0 150h700'/%3e%3cpath fill='%2369b3e7' d='M0 300h600V0h600v600H0z'/%3e%3cg stroke-miterlimit='4.8'%3e%3cpath fill='%23fff' d='M778.8 143.94v205.09c0 67.08 121.2 106.91 121.2 106.91s121.2-39.833 121.2-106.91V143.94z'/%3e%3cpath fill='%23c8102e' d='M883.2 216v92.344H778.8v33.6h104.4v107.6l16.8 6.396 16.8-6.396v-107.6h104.4v-33.6H916.8V216z'/%3e%3cpath fill='%23c8102e' d='M778.8 143.94h242.4v79.2H778.8z'/%3e%3cg stroke-miterlimit='3'%3e%3cg fill='%23fff' stroke='%23000' stroke-width='.805'%3e%3cellipse cx='798.23' cy='192.212' stroke-width='.803' rx='13.623' ry='10.962'/%3e%3cellipse cx='798.23' cy='186.525' rx='12.114' ry='6.123'/%3e%3cellipse cx='798.23' cy='198.769' rx='12.114' ry='6.123'/%3e%3cellipse cx='798.23' cy='192.213' rx='12.114' ry='6.123'/%3e%3c/g%3e%3cpath fill='%23fedd00' stroke='%23000' stroke-width='1.2' d='m1015.2 207.43-1.985-5.476s-5.433-2.216-5.847-5.102c-.968-7.694-3.714-10.578-7.83-11.678-4.125-1.1-6.868.689-6.868.689-1.24 1.787-7.426 1.787-10.859 1.921-3.434.14-3.493-1.492-3.493-1.492-2.668.02-3.79-1.941-3.79-1.941-1.746-3.487-3.045-4.792-3.908-5.233 4.457.066 7.813-1.991 12.844-7.27 5.493-5.772 9.415-3.54 9.415-3.54-2.666 5.39.887 4.913.887 4.913 7.28-3.706.96-13.051-1.237-12.638-2.198.41-2.825-1.07-2.825-1.07.067 1.678-2.44 2.345-2.44 2.345 1.88-10.674-4.489-13.504-4.489-13.504-.964.962-1.516 2.884-1.516 2.884-1.783 6.458-7.69 5.497-14.29 2.335-6.592-3.158-24.179 3.3-29.672 5.497-5.5 2.199-15.528 5.634-24.596.55-9.064-5.087-11.269-4.124-14.839-3.16-3.574.96-9.888 2.475-12.222 1.235-2.338-1.236-5.002-1.313-5.002-1.313.636-.355-.358-1.846-.358-1.846-2.747-3.708.358-5.981.358-5.981s-5.115 1.44-3.08 10.169l.934 1.309s.685 2.746 2.2 3.571l-.054.601s1.293-.6 1.7 1.184c.418 1.785 2.34.138 3.164-1.372 0 0-1.376 7.97 8.52 9.892 0 0-1.107-1.238-.693-2.062.41-.824-1.234-1.517-1.095-2.75.136-1.232-2.47-1.782-.414-2.748 2.058-.962 3.026-2.886 7.42-.275s7.834 2.064 7.834 2.064-2.681-5.502-1.204-5.499c1.477.002 8.123 8.23 11.394 7.823 3.272-.403 9.593-4.113 12.754-2.74 0 0 .271-1.648 12.36-3.71 12.092-2.061 27.006-8.087 32.599-2.807 0 0 .654 4.182 2.987 5.283 0 0-.418 8.654-15.385 3.842l-5.43-1.428s-.834-2.629-29.304 4.693c0 0-1.675.585-2.775 1.412-1.102.82-2.614-.414-8.247 1.645-5.628 2.065-26.654 8.935-39.564 6.46l-.017.034c-2.844-.85-5.508-.41-5.616-.859-.14-.55 1.513.14 1.513.14-.96-1.102-1.374-1.191-1.374-1.191-10.855-1.19-8.936-6.094-8.936-6.094l.553 1.512c1.787-2.334-.692-7.83-.692-7.83l-.105.018a5.679 5.679 0 0 0-.1-.5l.897-.62c5.222-4.397 11.269-5.222 11.269-5.222-3.575-4.394-11.134-2.058-11.134-2.058.14-5.358-2.058-11.542-2.058-11.542-7.423.825-11.678 7.006-11.678 7.006-.275-5.494-7.284-8.652-7.284-8.652 2.608 3.158.964 10.714.964 10.714l.274.138c-.434-.011-.688 0-.688 0l-.156 1.62-.257-.108s-2.608.96-5.63 7.83c0 0-.305 1.623-1.474 3.087-.01-.19.01-.36-.013-.559 0 0-3.376 4.423-11.176 0 0 0-10.598-6.288-14.323-6.055-3.725.232-6.174 1.979-5.937 3.026 0 0-8.504-.7-11.413 4.19 0 0-6.403 2.329-.93 7.57 0 0 .733 2.277 2.326 3.497 0 0-.226-4.784.933-3.378 0 0 .302.472.874.802.152.67.666 2.534 1.804 3.483l.82-.26c.124-1.193.382-2.7.647-3.334.125.017.225.032.27.035-.036.035-.07.055-.104.087l1.513 2.329 1.745-.931c.817-.12 1.863.7 1.863.7l1.98-1.632c-.012-.018-.024-.021-.036-.04 1.95.326 2.483-3.454 2.483-3.454 1.752.46 3.39-.055 4.785-.9.85 3.134 7.791 6.496 7.791 6.496l.299-.026c-.588.376-.937.658-.937.658 3.158 2.202 9.067 1.651 9.067 1.651-2.47.964-2.125 5.537-2.125 5.537-1.444.593-1.585 2.018-1.585 2.018 4.81 1.92 8.095.33 8.095.33.264 1.565-.125 1.732-.125 1.732-1.922 4.12-2.747 8.105-2.747 8.105.042.018.091.027.132.042-.059.108-.132.212-.177.324 0 0-8.384 2.91-12.11 6.986 0 0-.35-1.166-1.399-1.166-1.047 0-4.308-2.675-5.822-3.143-1.51-.463-3.725.468-4.308-.23-.527-.635-.29-5.405-1.298-6.174l.019.004-1.049-2.91c-.698 1.512-3.608 1.161-3.608 1.161-.116.07-.563.396-1.197.869-.58.031-1.249-.17-1.249-.17-.299.062-.594.9-.811 1.716-.117.086-.235.176-.353.266v-.817c-.58.465-1.745-.233-2.213-.233-.228 0-.51.667-.739 1.352-1.184.22-2.754.279-2.754.279-.466.233-.119 3.842-.119 3.842-3.374 1.865-1.746 4.657-1.746 4.657 1.864 9.083 17.35 5.007 18.515 6.174 1.162 1.166 3.843 1.395 5.24 1.395 1.395 0 3.14 3.378 5.122 3.727 1.981.35 0-2.677 9.183-4.87 9.178-2.194 12.239-5.959 12.239-5.959 2.875-.554 3.675-4.049 3.89-5.46.028.65.104 1.37.209 2.19.414 3.161-1.77 4.312-1.77 4.312l7.955-2.388c3.157-.825 2.746-3.575 2.746-3.575 3.022 8.657 8.52 9.206 8.52 9.206 1.098-3.298.963-4.26.963-4.26l2.472-.135c.1-1.864-1.545-3.226-2.497-3.86l3.87 2.348 1.508-.275c0 1.374 2.062 2.608 2.062 2.608l.278-1.782c1.787 2.335 5.083 1.51 5.083 1.51a11.039 11.039 0 0 0-.291-1.284c7.04 4.346 18.286-1.189 18.286-1.189 3.021.687 3.434-1.1 3.434-1.1 3.434.41 4.231-1.937 4.231-1.937 8.083-.7 13.772-6.446 13.772-6.446 3.98-.275 4.11-3.122 4.11-3.122s3.991.788 7.84-4.022c8.928-12.775 22.28-6.124 22.28-6.124l-7.72.489c-20.194-.136-11.822 13.598-11.822 13.598l1.245-.132c1.923.411 8.515 5.633 6.085 9.522-.039.068-.091.13-.136.193-4.117 5.636-11.742.26-13.915-4.495-2.2-4.807-6.599-3.707-6.599-3.707s-11.4 1.924-6.73 10.991l.17.005c.086 2.213 1.475 4.734 5.542 7.24 2.284 3.231 9.794 3.568 15.31 2.373 2.566-.56 16.112-6.384 16.112-6.384.993-2.95 4.36-2.27 7.38-6.529s-4.26-5.772-5.907-8.105c-1.651-2.339.414-1.925.414-1.925 6.592 3.573 7.141-7.832 7.141-7.832.69 6.593 6.458 8.38 6.458 8.38 3.574-3.568.967-10.852.967-10.852 8.519 15.25 13.678 12.822 13.678 12.822-4.587-2.84-2.278-6.64-2.278-6.64 4.117 16.211 21.022 2.062 21.022 2.062-.824 2.332.004 3.705 1.513 5.217 1.51 1.512 3.297 2.2 2.476 4.948-.827 2.747-8.653 2.2-8.653 2.2s-7.698-.411-7.007 6.046c.403 1.509 5.49 2.058 7.414 1.648 0 0-.794.173 2.05.553.953.122 2.104.143 3.275.104 3.279-.1 6.77-.657 6.77-.657 4.391-.959 3.707-2.476 3.707-2.476 6.726-1.24 7.418-5.775 7.418-5.775z'/%3e%3cpath d='M791.954 179.295c.005-.007.361-.848 1.04-.95.522-.077 1.157.31 1.828 1.125l.367-.276c-.015-.027-1.813-2.646-1.097-4.495.32-.824 1.114-1.39 2.357-1.67l-.1-.452c-1.403.322-2.306.98-2.686 1.958a3.132 3.132 0 0 0-.202 1.136c0 .904.318 1.82.645 2.522-.407-.255-.803-.36-1.184-.303-.69.104-1.026.601-1.208.925zM1004 215.28c-4.59.728-11.328 1.132-11.864-.257-.094-.247-.11-1.238 3.648-3.685l-.438-.673c-3.136 2.042-4.398 3.518-3.96 4.646.962 2.5 10.799 1.072 12.763.759zm-87.8 2.65c-1.046-1.6-.576-3.793 1.398-6.523l-.65-.47c-2.194 3.019-2.672 5.524-1.422 7.435z'/%3e%3cpath d='M910 211.02c.1 2.768 2.056 5.339 5.8 7.632l.42-.686c-3.504-2.144-5.322-4.49-5.417-6.974-.138-3.812 3.89-6.752 3.929-6.783l-.47-.654c-.18.128-4.418 3.216-4.262 7.465zm78.29 1.03c-1.259 1.859-.838 4.11-.82 4.205l.788-.155c-.007-.022-.372-2.026.703-3.604.645-.949 1.686-1.564 3.097-1.832l-.145-.79c-1.635.31-2.85 1.04-3.623 2.176zm-179.37-35.16-.248-.062-.034.255c-.007.025-.358 2.464-1.464 3.127-.31.185-.643.206-1.028.065l-1.878-1.142c-.375-.33-.696-.573-1.238-.414-.108-.14-.538-.724-.538-1.662 0-.105.007-.216.022-.329.134-1.1.902-2.161 2.29-3.151l-.264-.376c-1.505 1.075-2.338 2.243-2.484 3.48a3.351 3.351 0 0 0 .697 2.448l.112.129.152-.07c.418-.185.539-.076.946.284l2.027 1.233c.514.19.99.155 1.422-.102 1.144-.685 1.545-2.681 1.639-3.235 4.877 1.048 8.802-4.88 8.972-5.135l-.39-.252c-.035.062-4.04 6.134-8.713 4.909z'/%3e%3cpath d='M797.23 175.98c-.244.988-.077 1.957.487 2.882.539.878 1.07 1.344 1.623 1.418.674.093 1.213-.407 1.688-.845.346-.324.674-.625.944-.605l.42.29.36-.288-.747-.46c-.472-.035-.868.332-1.29.726-.421.386-.853.793-1.314.73-.4-.056-.832-.463-1.29-1.207-.497-.815-.647-1.669-.436-2.53.526-2.176 3.127-3.775 3.155-3.79l-.236-.393c-.117.068-2.792 1.71-3.364 4.072zm-6.71 31.06c.233-.841.88-1.558 1.919-2.135-.205.02 1.019 1.015 2.069.904l.681-.369c.279.24 2.097 1.895 2.097 3.992 0 .441-.08.894-.279 1.353l.426.179c1.33-3.15-2.015-5.944-2.046-5.974l-.122-.096-.207.134-.596.324c-.86.09-1.979-.819-1.987-.827-1.411.615-2.133 1.43-2.4 2.399zm15.53-8.04c-1.004.085-3.802.62-4.715 2.071-.33.527-.379 1.107-.139 1.733l.367.977c.871 2.343 1.776 4.765 2.763 5.312l.223-.4c-.838-.465-1.75-2.913-2.556-5.072l-.365-.977c-.187-.494-.156-.928.095-1.328.75-1.19 3.265-1.765 4.365-1.856.641-.052.85 2.313.977 3.727l.457-.042c-.183-2.083-.376-4.236-1.472-4.145z'/%3e%3cpath d='M798.38 201.3c-.588.526-.47 1.318-.462 1.352.005.218.266 6.068 3.044 7.277l.183-.421c-2.514-1.096-2.767-6.845-2.771-6.901-.001-.035-.083-.616.317-.966.421-.375 1.259-.403 2.42-.084l.123-.442c-1.34-.37-2.3-.308-2.854.185z'/%3e%3cpath d='M796.18 201.78c-1.229.856-1.178 3.298-1.177 3.4l.46-.008c0-.026-.046-2.303.98-3.015.383-.264.887-.275 1.501-.027l.17-.425c-.765-.312-1.418-.287-1.934.075zm66.15-32.29c.022.038 1.31 2.945 1.31 5.305 0 .419-.198.717-.291 1.081-.052-.135-.5-1.366-.5-1.366l-.39.987c-.017.055-.525 1.384.382 2.883 1.2 1.977 4.187 3.243 8.884 3.758h-.002c0 .004.059.055.066.065-.195.026-.341.08-.385.122l-.189.16.025.4c.122.488.678.512 1.784.554.187.01.49.055.705.066.275.077.557.153.557.153l-.094-.108c1.07.074 2.274.338 3.581.826-.289.076-.995.252-.995.252l1.162.458c.088.035 8.648 3.474 12.191 6.303-1.006.872-5.3 4.08-12.736 2.247l-1.246-.306.845.965c.052.058 4.896 5.614 5.9 8.983-1.687.017-8.185-.042-10.455-1.971l-.588.535c.03.05 3.115 4.576 3.804 8.105-.884.116-3 .203-4.252-1.433l-.577-.751-.313 2.037c-.605-.456-1.367-1.137-1.367-1.867v-.48l-1.833.333-3.765-2.283a7.975 7.975 0 0 0-.605-.365c-.004-.004-.035-.022-.035-.022l-.027-.016-.39.706s.448.267.577.348c.806.525 2.186 1.67 2.325 3.188-.595.035-2.448.136-2.448.136l.046.426v.067c0 .252-.08 1.304-.848 3.679-1.158-.276-5.37-1.744-7.858-8.874l-.775.192c.004.02.013.114.013.265 0 .65-.23 2.279-2.465 2.86-.013.004-4.15 1.248-6.452 1.937.43-.616.824-1.46.824-2.685 0-.26-.017-.54-.051-.837-.14-1.036-.224-1.899-.224-2.619 0-1.501.369-2.395 1.406-3.031l-.362-.716c-.097.038-9.618 3.82-14.339 2.25.216-.922 1.016-4.162 2.628-7.616l-.208.198c.31-.132.625-.615.364-2.166l-.086-.528-.484.233c-.03.015-3.052 1.363-7.417-.236.089-.358.32-1.001 1.235-1.38l.268-.108-.026-.292c0-.01-.01-.213-.01-.531 0-1.179.184-3.94 1.88-4.602l-.18-.777c-.055.007-5.161.415-8.257-1.307.812-.56 2.519-1.592 4.505-1.878l.318-.045.022-.318c.004-.016.011-.11.011-.26 0-.403-.156-1.219-.511-2.04 1.178.328 2.59.625 3.091.249l.17-.128-.146-3.099-.803.039.123 2.562c-.504.027-1.788-.23-3.035-.626l-1.234-.392.795 1.024c.645.829.727 1.858.737 2.331-2.79.519-4.976 2.251-5.07 2.33l-.41.337.435.303c2.4 1.672 6.153 1.817 8.08 1.775-1.136 1.28-1.328 3.421-1.328 4.492 0 .22.007.278.011.386-1.363.736-1.568 2.118-1.577 2.182l-.03.3.282.116c4.125 1.644 6.941.85 7.897.497.007.128.035.302.035.393 0 .378-.07.494-.07.494-2.026 4.248-2.875 8.286-2.885 8.324l-.066.334.313.124c3.828 1.53 10.705-.559 13.75-1.634-.399.689-.632 1.464-.632 2.429 0 .809.098 1.718.233 2.731.035.257.05.494.05.724 0 2.28-1.541 3.142-1.615 3.18l.306.741 7.955-2.389c1.84-.478 2.531-1.565 2.824-2.489 3.139 7.444 8.066 8.115 8.285 8.14l.32.027.1-.302c.766-2.287.943-3.449.978-4.01a439.55 439.55 0 0 0 2.462-.131l.02-.361c.004-.063.004-.123.004-.182 0-.658-.205-1.24-.49-1.764.498.3 1.377.834 1.377.834l1.318-.24c.344 1.33 1.923 2.374 2.127 2.499l.512.307s.188-1.212.267-1.74c1.965 1.758 4.753 1.235 4.885 1.202l.352-.09-.052-.357c-.4-2.688-2.204-5.886-3.265-7.596 3.491 1.587 9.85 1.471 10.163 1.461l.474-.016-.093-.465c-.564-2.825-4.094-7.272-5.57-9.04 8.201 1.541 12.606-2.714 12.795-2.907l.288-.306-.317-.278c-2.757-2.402-9.112-5.19-11.665-6.257l.894-.226-.883-.494c-2.135-1.2-4.398-1.349-5.928-1.415l-.007-.012c-.97-1.111-1.464-1.289-1.589-1.316-5.546-.612-7.579-2.166-8.317-3.366-.062-.099-.031-.166-.077-.262.12-.16.244-.318.244-.318.535-.697.726-1.63.726-2.617 0-2.547-1.294-5.457-1.367-5.625l-.738.334z'/%3e%3cpath d='M836.8 167.86c-.017.08-.608 3.119-3.196 4.543-1.947 1.07-4.52.982-7.639-.266l-.351-.14.037.376c.008.078.213 1.864 1.897 3.172 1.402 1.092 3.408 1.475 5.922 1.2-.841.998-3.544 4.452-3.544 7.802 0 .177.011.354.028.528.344.247 4.58 1.395 6.544-1.116.07 1.077.379 4.522 1.724 5.87.737.733.91 1.804.91 2.66 0 .771-.146 1.367-.146 1.379l-.152.613.511-.372c.163-.119 4.057-2.971 5.302-6.707-.004.01.623-.937 1.825-1.325-.025.163-.046.33-.046.563 0 1.444.633 4.064 4.836 5.671l.345.132-.031-.367a7.135 7.135 0 0 1-.028-.726c0-1.055.146-2.993 1.15-3.997.662-.66.86-1.404.86-2.049 0-.507-.112-.918-.226-1.22.849.215 2.855.862 3.672 2.39 1.186 2.223 5.338.454 5.516.38l-.143-.437c-.017.004-1.746.391-2.837-.358-.48-.33-.768-.837-.869-1.51l-.192-2.31c-.042-1.047-.187-1.712-.713-2.271.55-.05 1.652-.031 2.118 1 .734 1.617 3.251 1.774 3.356 1.783l.861.045-.723-.468c-.024-.014-2.198-1.456-1.822-3.336l.313-1.376c.595-2.48 1.585-6.632.779-9.181l-.438.14c.2.636.282 1.39.282 2.196 0 2.26-.64 4.944-1.072 6.738l-.316 1.395a2.608 2.608 0 0 0-.052.538c0 1.217.79 2.146 1.405 2.705-.74-.16-1.766-.512-2.151-1.37-.605-1.326-2.229-1.387-3.004-1.23l-.542.109.462.307c.73.487.75 1.054.802 2.293l.195 2.358c.115.804.473 1.419 1.06 1.824.515.35 1.117.4 1.666.44-1.233.321-2.924.522-3.531-.62-1.145-2.132-4.292-2.702-4.424-2.727l-.48-.083.24.421c.026.046.358.652.358 1.422 0 .546-.167 1.171-.733 1.735-1.116 1.126-1.287 3.167-1.287 4.296 0 .221.011.252.015.387-3.595-1.511-4.231-3.749-4.231-5.016 0-.539.104-.898.118-.945l.105-.354-.365.062c-1.746.288-2.472 1.71-2.503 1.77-.999 2.991-3.71 5.359-4.691 6.148a6.88 6.88 0 0 0 .066-.895c0-.935-.202-2.126-1.05-2.976-1.43-1.429-1.624-5.973-1.624-6.019l-.03-.82-.4.712c-1.582 2.833-6.2 1.472-6.245 1.46-.195-3.58 3.866-8.16 3.908-8.206l.425-.472-.626.092c-2.652.384-4.712.03-6.123-1.06a4.63 4.63 0 0 1-1.644-2.499c3.076 1.146 5.656 1.21 7.642.113 2.774-1.534 3.383-4.675 3.407-4.807 2.913-6.606 5.458-7.649 5.486-7.656l-.16-.431c-.115.04-2.74 1.073-5.768 7.95z'/%3e%3cpath d='m843.45 158.07-.194.007-2.364 3.24.702.07c12.829 1.248 19.613 8.988 19.679 9.068l.296.344 2.326-2.527-.17-.26c-6.506-10.244-20.136-9.947-20.275-9.942zm.22.804c1.585.004 13.27.365 19.189 9.331-.29.313-.935 1.019-1.28 1.397-1.387-1.438-7.962-7.582-19.237-8.906a631.23 631.23 0 0 1 1.328-1.822z'/%3e%3cpath d='M841.6 164.84c-1.096 1.495-2.114 3.707-2.114 4.742 0 .198.038.354.122.453.007.01.046.013.059.029-1.336 1.197-2.131 3.196-2.131 5.456 0 1.243.22 2.538.681 3.773l.257.695c1.259 3.424 2.344 6.384 7.788 4.641 5.244-1.675 5.45-2.011 6.77-4.189l.345-.564c.72-1.17 1.506-1.404 2.343-1.652.999-.3 2.034-.608 2.942-2.4l.883-1.324c.953-1.313 2.142-2.94 2.285-5.023l-.46-.031c-.132 1.95-1.28 3.518-2.197 4.78l-.922 1.388c-.82 1.616-1.715 1.884-2.664 2.167-.883.263-1.79.534-2.604 1.853l-.348.566c-1.27 2.096-1.431 2.366-6.512 3.994-5.027 1.606-5.946-.9-7.218-4.364l-.257-.702c-1.433-3.818-.313-7.669 1.55-9.049l.64-.475-.887.1c-.01-.038-.02-.071-.02-.131 0-.624.681-2.611 2.037-4.464 1.158-1.578 3.89-3.142 3.92-3.157l-.23-.399c-.115.069-2.845 1.63-4.058 3.287z'/%3e%3cpath d='M839.16 178.65c.9.624 2.166.58 3.692 0 .007.544.129 1.7 1.078 2.538 1.116.988 2.965 1.178 5.5.574l-.108-.446c-2.375.567-4.089.407-5.087-.469-1.072-.945-.922-2.45-.918-2.463l.042-.394-.365.155c-1.537.662-2.74.702-3.575.125-1.495-1.04-1.383-3.755-1.38-3.786l-.46-.022c-.001.124-.127 3.002 1.581 4.188z'/%3e%3cpath d='M842.07 174.99c-.656.156-.827.706-.827 1.13 0 .102.011.197.024.279.115 1.182 1.398 1.969 2.563 2.306 1.133.328 2.528.35 3.077-.356.22-.282.38-.79-.1-1.61-1.75-2.977-4.581-1.811-4.737-1.749zm1.888 3.271c-1.02-.291-2.142-.953-2.232-1.933-.022-.094-.132-.752.448-.89l.046-.015c.104-.047 2.611-1.136 4.19 1.55.281.48.327.845.132 1.093-.338.44-1.454.526-2.584.195zm-1.934-3.254c.004-.004.046-.018.046-.018l-.046.018zm1.626 5.973c-.295 2.514-.115 2.574.066 2.63l.16.05.18-.212 1.456-1.92-1.828-.866-.034.318zm.421.376.737.348c-.198.253-.566.744-.845 1.11.007-.378.053-.912.108-1.458zm-4.211-2.396-.097 2.376 1.995-2.413-1.887-.209-.011.246zm.449.266.552.06c-.195.233-.324.392-.585.706.02-.37.027-.575.033-.766z'/%3e%3cpath d='M838.53 178.2c.017.031 1.484 2.9 1.745 3.947.167.665 1.015 1.422 2.027 1.797 1.008.38 1.953.318 2.659-.174l1.325-1.101c.441-.425.588-.544.945-.483l.077-.453c-.601-.101-.894.179-1.34.603l-1.269 1.058c-.782.546-1.739.313-2.239.12-.946-.35-1.63-1.028-1.742-1.48-.275-1.094-1.721-3.92-1.78-4.04l-.408.206zm1.91-8.6c-1.62.748-2.305 2.713-2.333 2.796l.435.151c.007-.019.654-1.87 2.092-2.53.702-.322 1.488-.311 2.344.025l.17-.425c-.973-.393-1.884-.396-2.708-.017zm10.89 5.16c.128.096 3.188 2.414 1.43 5.243l.39.243c1.984-3.188-1.514-5.83-1.545-5.858l-.275.372zm-9.2.45s-.476 1.73 1.957 2.34c0 0-2.288-.02-2.433-.61-.154-.591.013-1.9.476-1.73zm7.44 2.07c0 .15-.122.274-.271.274a.275.275 0 0 1-.271-.274c0-.148.124-.271.27-.271.15 0 .272.123.272.271zm.27 1.08c0 .15-.122.275-.271.275s-.268-.125-.268-.275c0-.146.119-.27.268-.27s.271.125.271.27z'/%3e%3ccircle cx='848.01' cy='177.825' r='.27'/%3e%3cpath d='M848.75 179.45a.27.27 0 0 1-.539 0c0-.151.123-.275.268-.275.149 0 .271.123.271.275zm-7.1-7.32a.273.273 0 0 1-.546 0c0-.146.125-.271.271-.271.154 0 .275.125.275.271z'/%3e%3ccircle cx='841.65' cy='173.22' r='.27'/%3e%3ccircle cx='840.09' cy='172.68' r='.27'/%3e%3cpath d='M840.83 174.3a.276.276 0 0 1-.275.271.273.273 0 0 1 0-.546.278.278 0 0 1 .275.275zm4.74-9.55s3.518 2.165.132 6.228c0 0 1.666-1.237 1.836-3.362.178-2.123-1.207-3.816-1.968-2.866zm13.5 5.84c-1.133.582-2.764-.496-3.58-1.514-.814-1.02-2.5-1.28-3.55.58-1.048 1.864-2.56 2.562-2.56 2.562s1.477-.872 2.998-2.503c1.512-1.627 2.385-.32 3.87.466s1.717.959 2.763.552l.059-.143z'/%3e%3cpath d='M858.78 170.86c-.463.348-1.312.64-2.212-.09-.9-.727-1.658-1.715-2.792-1.134-1.138.584-3.293 2.212-3.293 2.212s3.495-2.417 4.165-1.892c.668.526 2.243 1.805 3.202 1.43.961-.383.93-.526.93-.526z'/%3e%3cpath d='M856.1 172.34c-1.105-.844-2.212.989-3.143.76-.931-.237-1.69-1.779-1.69-1.779s.877 1.631 2.097 1.252c1.224-.377 2.069-1.135 2.824-.555.757.585-.088.322-.088.322z'/%3e%3cpath d='M854.37 172.57c-2.183.226-2.399-1.813-2.399-1.834 0 0 .689 1.78 2.619 1.457l-.22.377z'/%3e%3cpath d='M854.3 171.18c.143.552.112.803-.473.803-.588 0-.987-.196-.987-.766 0-.571 1.374-.392 1.46-.037zm-7.84-3.03c0 .38-.313.685-.7.685s-.462-.26-.462-.636.076-.73.462-.73.7.307.7.681z'/%3e%3cpath d='M844.05 165.71s3.74.04 1.888 4.72c0 0 1.425-2.33.531-4.006-.897-1.674-2.305-1.252-2.305-1.252s-.343.317-.114.538z'/%3e%3cpath d='M843.94 167.58c-.01.938.616 1.907 1.856 2.876l.286-.36c-1.123-.876-1.69-1.72-1.682-2.506.007-.786.612-1.253.619-1.26l-.275-.37c-.032.026-.79.604-.804 1.62z'/%3e%3cpath d='M844.77 168.37c.16.539.577.946 1.244 1.212l.17-.425c-.527-.21-.855-.518-.972-.913-.237-.796.403-1.724.41-1.732l-.372-.267c-.036.048-.779 1.12-.48 2.125zm5.13 2.6s.696 1.512-.32 3.143c-1.02 1.63-.992 1.544-.992 1.544s1.224-2.241.759-3.175c-.462-.931.553-1.512.553-1.512zm14.55 15.79c3.842.724 12.51 7.52 12.6 7.59l.498-.636c-.365-.282-8.915-6.985-12.948-7.744l-.15.79zm3.41 9.59c.257 3.41 3.967 5.528 4.127 5.614l.392-.7c-.038-.018-3.49-1.996-3.72-4.975l-.799.061zm-9.21.71c0 3.824 3.584 8.45 3.738 8.647l.632-.497c-.034-.043-3.567-4.602-3.567-8.15h-.803zm-12.15.43c.632 1.262.566 1.902.403 2.215-.19.353-.58.407-.594.41l.094.801c.295-.035.887-.24 1.2-.816.383-.7.253-1.7-.383-2.964l-.72.354z'/%3e%3cg fill='%23fff' stroke='%23000' stroke-width='.36'%3e%3cpath d='M791.86 178.63s.233 2.56 2.212 4.079c0 0-.233-2.8.35-3.96 0-.001-1.046-1.165-2.562-.119zm3.95 1.63s.468 2.326 1.865 3.376l.82-.233s.347-2.914.813-3.262c.466-.347-1.979 1.048-3.498.119z'/%3e%3cpath d='m799.31 180.14 1.513 2.33 1.745-.932-.348-2.792s-1.046-.237-2.91 1.394z'/%3e%3cpath d='m806.41 180.61-1.98 1.63s-1.046-.816-1.864-.699l.352-2.562s1.397-1.047 3.492 1.631zm-14.09 24.1s-.348-3.61.119-3.842c0 0 1.394.465 1.977-.12 0 0 .816 2.914.582 4.078-.231 1.163-1.628.701-2.678-.116zm8.97-3.73s-.115-3.028.466-3.38c0 0 2.91.351 3.608-1.16l1.049 2.91s-3.26-.351-5.123 1.63z'/%3e%3cpath stroke-width='.35' d='M798.15 201.56s.58-3.143 1.165-3.26c0 0 1.513.465 1.979-.12l-.115 3.847c0-.001.115-1.632-3.029-.467zm-3.38.47s.698-2.795 1.165-2.795c.468 0 1.632.699 2.213.233v2.096s-2.566-.58-2.911 2.91l-.467-2.444z'/%3e%3c/g%3e%3c/g%3e%3cg fill='%2300ad50' stroke='%23000' stroke-width='.78'%3e%3cpath d='M840.16 260s7.914 7.35 5.845 13.758c0 0 5.087-10.932-.375-14.137-5.47-3.203-5.657-.748-5.47.38z'/%3e%3cpath fill='%23862633' d='M830.17 267.15s-2.07 2.833.188 4.906c0 0-2.448 3.574-.56 6.595 0 0-1.51 3.203-1.133 6.596 0 0-1.321 5.275 1.505 7.73 0 0 3.018 1.508 4.34.188 0 0 2.636-3.957.938-8.109 0 0 1.885-3.39-.188-7.725 0 0 .567-2.45-1.13-5.274 0 0 1.13-1.888.186-3.394 0 0-3.767-3.961-4.146-1.513z'/%3e%3cpath d='M832.43 257.92s-9.422-18.09-16.02-18.848c-6.598-.755-6.972-7.16-6.972-7.16s.752 3.015 6.031 3.015c5.278 0 15.456 7.349 16.585 13.003 1.13 5.653 2.263 4.902 2.263 4.902l-1.887 5.088z'/%3e%3cpath d='M832.43 256.6s3.394-22.805 18.286-23.184c14.885-.38 9.989 1.13 13.567-1.321 0 0-9.985 5.281-16.208 6.032-6.217.754-11.308 12.812-11.119 15.08.187 2.259-3.391 6.596-5.088 5.09-1.697-1.509.563-1.697.563-1.697z'/%3e%3cpath d='M835.82 265.09s3.391-9.047 9.235-6.029c0 0-4.526-8.673-12.629-1.134 0 0 3.582 4.9 3.394 7.163zm-11.31-9.06s4.902 20.17-2.639 26.387c0 0 .187-10.361-4.335-16.582-4.52-6.223 4.522-13.003 6.974-9.805z'/%3e%3cpath d='M825.08 259.62s8.86 8.484 9.427 11.31c.567 2.827 2.637-8.48-1.508-11.682-4.147-3.209-8.67-3.773-8.67-3.773l.751 4.145z'/%3e%3cpath fill='%23862633' d='M808.74 281.85s.803 3.56 2.988 4.25c0 0 .113 2.645 2.068 3.448 0 0-1.037 2.184.69 3.56 0 0-.347 4.367 1.263 5.289 0 0 3.911-.23 5.285-1.38 0 0 .806-2.868-1.374-5.747 0 0 .34-2.758-1.843-4.25 0 0 .69-3.68-2.069-5.057 0 0-.457-2.99-2.184-4.482.001-.001-3.33 4.71-4.824 4.369z'/%3e%3cpath d='M813.1 277.48s-11.606-4.252-18.042 1.84c0 0 9.88 1.38 11.147 3.333 1.264 1.95 7.352-3.216 6.895-5.173z'/%3e%3cpath d='M809.54 284.72s-.918-.803-2.066-1.61c-1.15-.802-10.916-3.446-12.3 5.977 0 0-3.563-9.307 1.609-10.573 5.175-1.266 9.312 1.724 12.757 6.206m-7.64-19.26s3.577 7.726 4.9 8.108c1.318.372 2.26-.942 2.26-.942s-4.71-6.974-7.16-7.166zm-2.64-11.87s-3.018-9.988-6.596-7.35c-3.581 2.639-2.64 9.798-2.64 9.798s-7.162-7.346-3.017-13.192c4.152-5.842 12.253.566 12.253 10.744z'/%3e%3cpath fill='%23862633' d='M807.37 274.13s0 1.885 1.32 2.448c1.32.566 3.77 1.505 3.77.38 0-1.131-1.884-5.467-2.642-4.9-.755.567-2.069.56-2.448 2.072z'/%3e%3cpath d='M805.11 262.45s-.377-8.668 5.274-11.876c0 0 1.134.194 1.7-1.501 0 0-4.528 10.927-3.207 16.393l-.187.755'/%3e%3cpath d='M806.24 251.89s10.177-21.112 22.618-13.762c0 0-13.004 2.64-17.714 11.876l-4.715 6.967-.188-5.082z'/%3e%3cpath d='M800.77 259.62s-3.017-14.134-4.9-16.016c-1.887-1.886-5.091-3.959-8.862-.756 0 0 6.6-5.845 13.572-.942 6.971 4.9 5.464 12.628 5.464 12.628l-.751 9.802L800.58 260'/%3e%3cpath d='M811.7 276.39s-12.44-23.552-20.542-6.78c0 0-1.512 4.332.184 6.025 0 0-4.524-3.39-2.45-11.682 2.07-8.29 15.828-4.524 19.79 2.263 3.957 6.784 5.09 10.18 4.524 10.552-.567.38-1.507-.378-1.507-.378zm35.06 6.79s9.05-18.66 14.324-10.18c0 0 1.506 4.145-.757 5.845 0 0-3.577-4.335-6.78.942-3.205 5.275-1.885 4.902-1.885 4.902s-3.394.942-4.902-1.51z'/%3e%3cpath d='M860.32 278.84s4.9 2.635 3.209 7.913c0 0 6.591-12.625-2.452-13.758.001 0 1.698 3.96-.757 5.845zm.57-12.81s11.876 3.39 12.252 8.484c0 0 2.076-9.805-4.711-12.82 0 .001-8.107 1.322-7.541 4.336z'/%3e%3cpath d='M866.17 250.38c5.09-9.989 11.498 3.204 11.498 3.204s2.26-10.364-4.145-12.252c-6.411-1.884-10.556 22.05-10.556 22.05l-7.54 1.697s2.074-20.917 13.381-22.805l1.318.19'/%3e%3cpath d='M857.12 256.41s-7.16-14.7-12.061-16.206c-4.902-1.508 2.642-3.77 5.657-.944 3.01 2.824 8.665 6.408 8.101 13.948l-1.697 3.202zm-7.35 20.17s2.072-9.985 7.726-13.003c5.653-3.018 10.932-1.884 10.932-1.884s-6.788 1.505-7.914 4.902c-1.133 3.39-3.018 3.577-3.018 3.577l-7.726 6.408z'/%3e%3cpath fill='%23862633' d='M846.76 283.18s-3.203 6.032-2.452 6.972c0 0-3.39 4.9-2.072 7.35 0 0 3.394 2.639 4.902 1.506 0 0 3.953-5.462 2.824-8.48 0 0 2.638-3.578 1.7-5.838 0 0-3.956.187-4.902-1.51z'/%3e%3cpath fill='%23000' stroke='none' d='M830.18 272.41c.212.108 2.116 1.032 3.396.605l.916-.783-.72-.357c-.47.931-2.542.163-3.234-.18l-.358.715zm-.31 5.85-.156.79c.162.03 3.986.771 5.81-.849l-.535-.599c-1.524 1.353-5.08.669-5.119.658zm-.97 6.66-.472.65c.046.035 4.49 3.2 7.334-.256l-.623-.512c-2.362 2.868-6.08.233-6.239.118zm-17.26.96.167.43c.16-.065 3.925-1.577 4.164-4.331l-.457-.042c-.215 2.472-3.838 3.929-3.874 3.943zm2.13 3.44.032.458c.147-.01 3.623-.27 4.23-2.7l-.448-.116c-.524 2.107-3.78 2.354-3.814 2.358zm.72 3.56-.025.462c.167.007 4.06.209 5.382-1.948l-.393-.243c-1.18 1.927-4.926 1.733-4.964 1.729zm29.53-2.44c.07.073 1.748 1.732 3.71 1.658.96-.034 1.811-.476 2.53-1.303l-.608-.528c-.567.653-1.224 1.001-1.948 1.029-1.606.058-3.104-1.408-3.119-1.426l-.565.57z'/%3e%3c/g%3e%3cg fill='%23862633' stroke='%23000' stroke-width='.42'%3e%3cpath d='M961.06 304.22a1.66 1.66 0 0 0-.608.403l.608-.403zm13.86-3.47c-.134-.344-.222-.2-.4-.352-.253-.208-.4-.876-.622-1.125-.132-.153-.285-.004-.428-.042-.324-.713-.705-1.464-1.046-2.152a.597.597 0 0 0 .094-.32c0-.028-.16-.577-.17-.601-.098-.153-.252-.063-.345-.3-.105-.236-.025-.701-.063-.98-.027-.232-.118-.36-.104-.688.014-.285.167-.616.149-.866-.007-.156-.191-.507-.246-.64-.223-.538-.41-1.046-.438-1.71-.028-.602.093-.97.138-1.492.056-.625-.275-.929-.275-1.506.004-.442.19-.938.244-1.334a9.952 9.952 0 0 0 .033-1.884c-.04-.532-.19-.852-.108-1.45.022-.146.091-.264.108-.47-.004-.146-.004-.287-.004-.43v-.858c0-.278.028-.592.004-.863-.024-.225-.156-.458-.156-.636 0-.306.195-.451.153-.866-.027-.299-.07-.369-.138-.629-.132-.493-.042-.991-.123-1.52-.038-.252-.119-.333-.143-.622-.033-.34.071-.458.105-.7.035-.24.07-.555.038-.81-.038-.306-.183-.522-.143-.855l-.111 3.782c-.094-3.3-.226-6.355-.226-6.355l-5.018-2.357s-.425 9.214-.317 10.496c.1 1.287.532 10.076.317 11.147-.216 1.072-.744 6.429-.744 6.429s-2.454 1.714-3.414 3.64c-.964 1.93-.748 2.573-1.072 2.573l2.385-.372-1.776 1.186a1.085 1.085 0 0 1 1.106.171c.04.034.306.26.34.26.093 0 .223-.238.337-.28.37-.125.681.568 1.032.515.188-.028.445-.226.599-.427.127-.17.176-.47.31-.584.122-.104.42.017.549.017.35 0 .705.011 1.056 0 .467-.013.845-.67 1.275-1.043.401-.337.696-.456 1.125-.43.469.034.893.472 1.37.5.361.018.612.062.904-.317.201-.264.344-.656.535-.931l1.186-.184c.235.098.475.206.676.198.303-.014.616-.051.916-.004.114.015.34.282.433.216.064-.049.172-.41.237-.518-.027-.145-.071-.506-.124-.628z'/%3e%3cpath d='M964.77 304.05c.302 0 .58-.07.834.152.042.08.08.158.119.233a.26.26 0 0 0 .25.035c.171.115.206.18.393.223.174.037.365-.007.539-.004.22.007.326.083.531.167.358.146.594.007.904-.216.359-.264.49-.062.834.269.258.246.205.223.438.055.035-.08.076-.156.115-.223.115-.048.233-.08.35-.101.193-.09.383-.08.565-.149.19-.074.33-.285.531-.247.174.035.373.176.539.23.16.054.23.086.362.183.24-.493.768-.64 1.106-.879.351-.243.678.052 1.064.056.205 0 .288-.12.434-.167.164-.06.35.026.508-.039.167-.062.198-.223.382-.243.34-.042.72.513 1.06.618.191.063 1.076.261.946-.389-.125-.62-.68-.19-.8-.625-.063-.247.067-.599-.01-.876-.066-.253-.344-.546-.511-.601-.209-.066-.33.152-.508-.018-.146-.136-.201-.644-.33-.845-.171.125-.278.24-.504.194-.258-.062-.233-.15-.425-.393-.417-.522-.657.313-1.042.18-.293-.093-.564-.83-.794-1.13-.122-.16-.466-.678-.643-.562-.299.194-.027.758-.183 1.008-.112.174-.508-.004-.65.024-.226.049-.268.108-.432.379-.33.546-.522.98-1.035.918-.244-.028-.427-.275-.665-.185-.253.097-.396.368-.674.4-.202.016-.435.024-.633-.052-.194-.088-.414-.452-.591-.553a.23.23 0 0 0-.24-.046c-.02-.01-.288-.167-.292-.167-.31-.09-.284-.079-.41.33-.074.254-.101.515-.195.755-.09.202-.288.451-.403.587-.216.233-.32.17-.601.254-.226.074-.526.425-.647-.027-.18-.682.5-1.7-.258-1.523-.198.046-.317.083-.438.376-.134.337-.026.555-.086.925-.08.465-.968 1.248-.792 1.669.118.296.514-.16.622-.086.18.124.129.42.257.619.269.41 1.065-.636 1.11-.07m-3.221-4.073c-.002-.059-.013-.115-.017-.176-.212-.039-.452-.264-.647-.268-.183-.01-.542.438-.668.653-.389.643-.28 1.519-.935 1.506-.16-.004-.535-.112-.675-.015-.246.174-.09.69-.09 1.04 0 .33.15 0-.027.428-.053.118-.212.156-.254.313-.132.56.333.382.539.376a103.36 103.36 0 0 1 1.575 0c.317.007.508-.105.803-.22.194-.066.608-.062.773-.236.059-.066.25-.508.277-.612.042-.216-.04-.477.01-.657.084-.316.367-.195.418-.622.136-1.048-.982-.264-.806-1.294'/%3e%3c/g%3e%3cg stroke='%23000' stroke-width='.78'%3e%3cpath d='M974.21 271.28c0 1.356-.928 2.448-2.078 2.448-1.137 0-2.073-1.092-2.073-2.448 0-1.352.935-2.452 2.073-2.452 1.15.001 2.078 1.1 2.078 2.452zm-6.78-3.02c0 1.352-.929 2.448-2.074 2.448-1.147 0-2.078-1.096-2.078-2.448s.931-2.45 2.078-2.45c1.145 0 2.074 1.098 2.074 2.45z'/%3e%3cpath d='M971.01 269.2c0 1.356-.929 2.448-2.074 2.448s-2.072-1.092-2.072-2.448.928-2.45 2.072-2.45 2.074 1.095 2.074 2.45z'/%3e%3cpath d='M967.54 271.44c0 1.356-.932 2.454-2.076 2.454s-2.072-1.1-2.072-2.454c0-1.352.927-2.448 2.072-2.448s2.076 1.094 2.076 2.448z'/%3e%3cpath d='M970.76 273.31c0 1.352-.935 2.454-2.075 2.454-1.143 0-2.076-1.102-2.076-2.454s.933-2.448 2.076-2.448c1.139.001 2.075 1.096 2.075 2.448z'/%3e%3c/g%3e%3cpath fill='%2300ad50' stroke='%23000' stroke-width='.78' d='M971.76 246.58s20.918-29.209 43.348 1.134c0 0 .187 3.018-1.885 6.22l-.567-2.448-1.318.374-.376-1.507-2.455-.187.758-3.206-2.642 2.074.379-2.263-3.016 3.02.38-6.411-3.207 5.466.376-3.767-1.13 1.693-.68-2.196-1.013 2.196-1.512-1.128v1.507l-2.635-2.262-.942 3.015-1.319-3.202-.378 2.26-1.322-2.64-.184 2.83-4.339-1.887.942 2.639-2.069-1.505.376 1.505-2.824-.563.185 1.694-3.015-.566.567 1.506-4.148-.562 1.502 1.696-.417.69s22.66-7.473 24.168 20.796l-4.148 2.072 1.133-2.256-1.133-.757-3.39-2.635.942-3.585-1.129.38-.19-2.073-.565.376-1.322-2.073-.376.755-.942-2.454-.942 1.7-.567-4.148-1.505 2.643-.192-1.509-.566.942-1.884-2.263-.56 1.508-.76-1.13-.562 1.318-2.074-1.888v1.513l-1.317-1.134-.571.755-3.198-1.697-.196 1.505-1.692-1.505-.568 1.505s20.55 11.689 14.137 30.725l-1.134 2.448-.372-6.404-1.884 3.39 1.31-7.35-1.31 1.317-.194-2.823-1.69 2.823-.574-3.201-.748.942-1.136-4.902-.942 2.076-1.506-5.466-1.13 2.26-.754-4.708-.755 2.826-2.263-4.149-.374 1.693-1.317-3.39-.759 1.134s-3.769-.192-4.898-1.134c-1.13-.938-4.336 5.657-4.336 5.657l.378-3.96-1.317 2.635v-2.635l-2.452 7.914-.566-5.653-1.319 4.9-.568-1.505-.375 2.075-.755-.758-.658 2.225-1.23-.903v3.014l-1.129-1.508-.942 4.524-.564-1.88v2.068l-.942-1.126-.945 4.524-1.318-1.884-.185 3.2.56 2.454-1.505-.755.567 3.953s-5.844-10.927 1.133-21.484c6.968-10.55 16.393-13.38 16.393-13.38l-.946-.938-.187-.945-5.653 2.826.19-1.7-1.509 1.32-.375-1.884-.946 1.697-.184-.755-1.322 2.076-.757-3.018-.94 3.585-.889-2.507-1.937 5.33v-3.957l-1.508 4.148-.564-4.524-1.13 5.274v-4.711l-1.7 4.711-1.129-4.52-.755 4.332-1.129-3.39-1.134 5.087-1.693-4.524-.942 6.787-1.13-2.643-.19 4.902-1.315-3.014 1.315 6.404-1.697-2.448.568 3.957-2.448-4.336.187 5.094-1.321-1.7-.568 1.885s-.56-19.6 12.816-23.372c13.386-3.768 22.055 1.133 22.055 1.133l-5.087-4.145.564-1.321h-1.884l.754-1.509-3.957.191 1.13-1.508-3.018.375v-.94l-1.884 1.503.754-1.693-2.638 1.693-.161-2.507-1.349 2.135-.748-2.263-6.034 6.028 1.695-6.218-1.129 1.322-.187-1.322-1.697 2.642-.378-1.887-.755 2.26-.567-2.637-1.314 2.637-1.323-2.446-.563 3.205-.945-1.7-1.13 2.45-1.505-1.51-.191 1.51-3.016-1.32.755 2.264-2.263-1.884-.568 3.014-1.315-1.508-.942 3.772-.942-3.583-.942 2.827s11.786-30.286 41.605-10.526c0 0 3.247 3.176 4.002 5.436.755 2.264.19.38.19.38l-.567-20.92 1.13 9.047.754-3.206-.187 4.713 3.012-6.598s-3.577 10.933-2.26 14.89c0 0 1.322-12.626 5.848-14.136l-4.148 9.046 1.317-.19-.942 1.888h1.13l-1.366 2.99-.707 1.534.751 1.506 1.139-1.141z'/%3e%3cpath d='m968.66 258.87.594.535c.08-.083 1.944-2.069 5.074.574l.518-.616c-3.742-3.164-6.17-.522-6.186-.493zm-.91-10.26-.122.725 1.453-.62a360.89 360.89 0 0 1-.999 1.748l2.168-.721a9103.73 9103.73 0 0 1-2.688 3.517l.64.494 4.276-5.601-2.657.886c.277-.482 1.14-2.005 1.14-2.005l-2.298.988.475-2.874-.795-.133-.593 3.596z'/%3e%3cpath d='M963.76 248.84s.528 1.169.925 2.039c-.171-.071-1.475-.593-1.475-.593l4.35 7.694s.525-.67.556-.712c-.438 1.123-.876 2.256-.876 2.256l.751.292 1.875-4.822-.692-.393-1.51 1.933c-.406-.723-1.91-3.386-2.625-4.645.09.034 1.207.484 1.207.484s-.82-1.812-1.203-2.653l1.63 1.018v-2.868h-.803v1.419l-2.663-1.662.553 1.213zm-2.74 9.66.32.737c1.178-.504 2.148-.588 2.885-.237.863.414 1.123 1.304 1.126 1.31l.775-.208c-.01-.052-.352-1.248-1.543-1.822-.952-.458-2.152-.385-3.563.22zm3.376 8.15-.66-4.215.795-.125.661 4.214zm5.789-.694-1.074-3.22.765-.255 1.073 3.22zm2.124 2.38-.807-3.216.782-.196.807 3.216z'/%3e%3cpath fill='%2300ad50' stroke='%23000' stroke-width='.78' d='M811.41 365.04s-3.534-1.606-5.143-.43c-1.608 1.181-1.389 2.892-2.783 2.784 0 0 5.354 1.179 6.532-.216 1.177-1.387 1.394-1.819 1.394-1.819m.65 1.161s-2.326 3.11-1.522 4.93c.802 1.822 2.523 1.978 2.116 3.315 0 0 2.302-4.974 1.196-6.426-1.105-1.442-1.474-1.745-1.474-1.745m-4.236-8.684s-3.71 1.15-4.126 3.095c-.426 1.946.879 3.086-.232 3.931 0 0 4.782-2.68 4.737-4.506-.045-1.823-.163-2.284-.163-2.284m1.964 1.044s1.76-3.467.652-5.118c-1.106-1.663-2.832-1.52-2.662-2.904 0 0-1.414 5.296-.073 6.536 1.343 1.23 1.763 1.468 1.763 1.468m-3.32-1.242s.085-3.876-1.632-4.889c-1.715-1.015-3.209-.141-3.658-1.467 0 0 1.026 5.389 2.774 5.928 1.746.525 2.227.556 2.227.556m6.629 6.332s4.068-1.397 4.392 2.998c.32 4.39-.216 2.893-.216 2.893s-2.142-4.713-4.496-5.464l.32-.427z'/%3e%3cpath d='M811.99 366.59c0 .094.426 3.414.426 3.414l.572-.073-.43-3.322c.014.004 1.39-7.3 1.39-7.3l-.567-.105-1.391 7.386z'/%3e%3cpath d='m808.29 365.51-.19.542c1.946.684 4.661-1.454 4.774-1.544l-.36-.448c-.024.017-2.578 2.034-4.224 1.45zm5.098-4.286-9.102-4.605.363-.717 9.102 4.605z'/%3e%3cpath d='m806.79 360.19-.568-.567 1.821-1.82.567.568zm3.185-.885-1.927-4.18.729-.336 1.928 4.18zm2.695 5.115.052.804c2.475-.168 3.08 1.435 3.084 1.453l.79-.164c-.094-.459-1.086-2.284-3.926-2.093z'/%3e%3cpath fill='%23FFF' stroke='%23000' d='M854.43 366.27c3.035-1.7 3.643-7.657 3.643-7.657-.726 2.191-6.31 4.375-6.31 4.375 4.126-2.556 9.101-14.084 9.101-14.084-1.334 4.13-12.138 7.526-19.06 11.411-6.923 3.883-3.279 15.058-3.279 15.058-1.94-1.337-5.706-7.283-6.432-12.509-.733-5.219-2.796-7.28-7.531-7.889-4.738-.608-7.529 4.732-7.529 4.732l-7.04 3.647 7.159.24s5.106 1.704 5.106 5.71c0 4.008-4.493 20.034 2.91 29.021 5.153 6.245 24.166 9.833 24.166 9.833'/%3e%3cpath fill='%23FFF' stroke='%23000' d='M840.47 378.65s1.457-7.165 6.192-6.922c4.735.243 6.07-5.34 8.863-6.192 2.793-.848 17.242-4.731 18.821-11.656 0 0-1.335 11.416-14.568 17.122 0 0 10.681-3.523 11.898-5.83 0 0-4.739 10.2-16.272 11.778 0 0 10.806-.849 12.385-3.761 0 0-4.857 6.433-12.869 7.285 0 0 7.405 3.035 9.35.484 0 0-4.009 4.735-8.989 5.096l1.34.366s-4.736 5.587-9.958 1.822c-5.219-3.766-5.344.974-5.344.974'/%3e%3cpath fill='%23FFF' stroke='%23000' d='M851.25 389.45s6.098 10.202 6.707 15.665c0 0 11.658 12.872 16.028 13.595 0 0-2.065.848-5.831-2.305 0 0 3.157 3.278 3.766 3.4.604.125-2.552-.243-3.039-1.095 0 0 1.338 1.948 2.187 2.19.852.244-.849-.242-.849-.242s-1.581-.244-2.309-.852c-.73-.605-.243 1.575-.243 1.575s-1.822-.486-2.427-1.092c-.608-.605.244 1.34.244 1.34l-1.578-.367-1.092.726s-.122.73-.856.123c-.723-.601-2.061 0-2.061 0s-.975.852-1.457.243c-.482-.606-2.323 2.336-2.323 2.336l-7.645-18.455'/%3e%3cpath d='m858.505 422.928-9.662-18.393 1.014-.533 9.663 18.393zm8.442-1.24-16.531-18.51.858-.766 16.532 18.51zm3.771-1.632-18.864-17.58.783-.84 18.865 17.58zM823.44 360.84s-1.231-2.204-2.303-1.376c-1.069.825-1.685.976-1.87.919 0 0 1.076.059 1.687-.522.613-.586 1.656-.216 2.486.979zm-6.66-1.01s.676 1.398.685 1.422c-.068.004-.763 2.257-.763 2.257l.553.17.75-2.453c-.013-.213-.703-1.642-.703-1.642l-.522.246z'/%3e%3cpath d='M823.16 360.5s-.918 1.075-2.176.766l-1.252-.306s1.066.06 1.776.093c.7.029 1.618-.337 1.652-.553z'/%3e%3cpath d='M822.86 360.72s-1.132-1.195-1.9-.858c0 0 1.35-.43 2.116.73l-.216.128z'/%3e%3cpath d='M822.67 360.5s-1.286.887-2.699-.09l-.086-.066.183-.059c.001.001 1.778.735 2.602.215z'/%3e%3ccircle cx='821.573' cy='360.284' r='.383'/%3e%3cpath d='M822.61 394.2s-.996 1.834-.475 2.939c.528 1.103 2.89 1.675 3.205 3.146.317 1.475 1.105 1.471 2.208 1.266 1.105-.212 1.314-.264 1.314-.264s-4.625-2.473-5.834-6.46l-.418-.627z'/%3e%3cg fill='%23862633' stroke='%23000' stroke-width='.48'%3e%3cpath d='M972.09 356.85s8.418-11.099 15.882-8.184c7.465 2.917 12.316 4.321 12.316 4.321s.142 7.475-3.828 7.475c-3.96 0-7.757-7.465-11.366-5.246-3.616 2.215-6.584 5.25-6.818 6.296-.233 1.048-9.562 1.283-6.185-4.662z'/%3e%3cpath stroke-width='.78' d='M940.14 410.37s-2.328 2.444-1.278 3.031c1.054.581 3.146-.122 3.146-.935 0-.82-1.395-2.329-1.868-2.096z'/%3e%3cpath stroke-width='.78' d='M938.28 412.7s-4.312-2.455-7.694 3.376c-3.387 5.83-6.182 15.277-8.164 16.56-1.981 1.282 19.241-9.328 19.475-13.758 0 0 1.397-5.716-.817-5.602-2.215.122-2.333.356-2.8-.576z'/%3e%3cpath d='M938.86 413.4s-4.43 1.043-5.362 7.337c-.932 6.303-7.114 9.565-7.462 9.797m74.264-77.544s-6.738 2.344-5.574 7.01'/%3e%3c/g%3e%3cpath fill='%23fedd00' stroke='%23000' stroke-width='.48' d='M948.54 366.64s.232-15.976 13.284-15.277c2.473.23 1.294 3.146 1.294 3.146s2.823-1.977 4.113 1.166c0 0 4.117-1.864 4.585 2.218 0 0 4.47-.58 3.88 3.032 0 0 3.056-.699 2.942 1.867 0 0 3.526-1.4 3.17 2.215 0 0 3.882-2.566 3.297 2.096 0 0 3.999-2.794 5.404 1.869 1.411 4.662-3.995 14.574-9.287 17.138'/%3e%3cpath d='M984.81 367.61c.018.125 1.76 12.498-5.257 17.026l.247.39c7.27-4.69 5.482-17.356 5.466-17.484l-.456.068zm-8.45 13.55.324.33c4.444-4.325 5.4-15.976 5.434-16.469l-.455-.038c-.011.122-.977 11.974-5.303 16.177zm-4.15-2.77.458.037c.572-7.195 6.196-15.425 6.256-15.509l-.38-.258c-.058.082-5.75 8.413-6.334 15.73zm-3.26-2.1.458.046c.8-8.68 6.533-15.196 6.59-15.258l-.341-.308c-.06.064-5.891 6.688-6.707 15.52zm-4.55-2.9.458.017c.456-10.25 7.18-15.28 7.247-15.33l-.272-.371c-.065.051-6.967 5.2-7.433 15.684zm-4.2-2.55.462-.014c-.336-9.328 6.835-14.912 6.91-14.97l-.279-.364c-.073.06-7.434 5.78-7.093 15.348zm-7.57-3.41.455.056c1.249-10.097 10.236-12.725 10.326-12.75l-.125-.441c-.09.024-9.373 2.729-10.656 13.135z'/%3e%3cpath fill='%2300ad50' stroke='%23000' stroke-width='.48' d='M940.84 386s-2.212-14.813 6.648-19.472c0 0 1.637-.352 2.566 1.748 0 0 4.666-1.98 4.784 1.978 0 0 2.33-1.864 2.914.7 0 0 5.013-1.047 4.08 2.683 0 0 4.197-1.165 3.847 2.445 0 0 4.2-1.514 3.497 1.635 0 0 4.429-1.047 3.382 2.567 0 0 5.483-.581 3.85 3.265 0 0 4.081-1.048 3.146 2.1 0 0 5.366.935 2.914 4.315-2.448 3.378-8.63 8.51-14.686 10.724'/%3e%3cpath fill='%2300ad50' stroke='%23000' stroke-width='.48' d='M936.06 400.92s-3.616-12.355 3.269-15.509c0 0 1.275-.352 1.51.935 0 0 1.519-1.985 2.686-.233 0 0 3.495-1.633 4.315.931 0 0 2.33-1.985 3.498.928 0 0 2.216-.928 2.216 1.401 0 0 3.03-1.282 3.03 1.517 0 0 2.91-1.165 2.33 1.981 0 0 4.433.699 3.15 2.798 0 0 3.97 1.046 2.448 2.683 0 0 4.312-.466 1.981 2.448 0 0 3.265-1.047 1.402 2.57-1.869 3.612-7.695 7.576-11.776 8.041'/%3e%3cpath fill='%2300ad50' stroke='%23000' stroke-width='.48' d='M940.37 410.71s-7.694-7.462-4.075-9.676c0 0 1.626.462 2.211 2.097 0 0 1.864-2.681 2.918.115 0 0 2.8-.931 2.8.938l2.21 1.634s2.57-.236 2.104 1.398c0 0 2.799-.352 2.68 1.165 0 0 2.452.115 2.219 1.745 0 0 4.193.7 2.329 2.803 0 0-7.346 1.512-12.475-.585 0 0-2.688-.936-2.92-1.634z'/%3e%3cpath d='m966.76 398.38.164.427c4.56-1.755 12.478-12.564 12.816-13.024l-.372-.275c-.084.117-8.174 11.164-12.608 12.871zm-2.59-1.97.223.4c3.967-2.213 11.867-12.676 12.2-13.121l-.366-.278c-.079.112-8.174 10.834-12.058 12.998zm-2.25-.92.296.352c4.19-3.478 10.291-14.966 10.552-15.452l-.406-.216c-.062.117-6.32 11.896-10.441 15.317zm-2.06-2.65.456.064c.796-5.807 8.953-14.947 9.032-15.037l-.34-.308c-.338.38-8.334 9.336-9.148 15.281zm-16.33-7.06.46-.04c-.686-8.203 6.18-17.238 6.25-17.328l-.364-.277c-.074.089-7.044 9.262-6.346 17.645zm4.32.72.456-.08c-1.136-6.576 6.63-15.928 6.71-16.02l-.351-.298c-.327.389-7.984 9.605-6.815 16.398zm6.64 2.42.46-.013c-.226-7.507 6.976-15.032 7.05-15.11l-.33-.32c-.072.077-7.414 7.743-7.18 15.443zm-15.84 13.6.43-.16c-2.615-6.937 1.926-15.819 1.972-15.906l-.414-.212c-.045.091-4.677 9.149-1.988 16.278zm3.02.45.438-.142c-2.281-7.065 1.585-16.535 1.626-16.628l-.427-.176c-.037.092-3.966 9.721-1.637 16.946zm12.5 7.06.157.434c7.44-2.676 12.305-9.46 12.353-9.525l-.375-.269c-.046.067-4.826 6.738-12.134 9.36zm-1.53-1.62.187.421c5.934-2.677 11.467-10.146 11.52-10.223l-.37-.269c-.056.075-5.514 7.443-11.337 10.07zm-1.44-.56.269.373c4.641-3.362 10.604-11.982 10.667-12.07l-.378-.257c-.061.088-5.977 8.638-10.558 11.953zm-7.44-4.33.456-.066c-1.026-7.414 3.773-16.208 3.824-16.295l-.403-.223c-.051.091-4.923 9.018-3.877 16.584zm3.23 2.01.31.34c4.788-4.322 6.418-15.971 6.484-16.464l-.456-.064c-.014.119-1.672 11.981-6.338 16.188z'/%3e%3cpath d='m950.27 406.91.269.372c6.758-4.888 8.59-14.274 8.605-14.365l-.449-.086c-.018.09-1.815 9.295-8.425 14.08zm.78-20.23c0 .438.022.875.062 1.318-.007-.038-5.125 16.583-5.125 16.583l.438.135 5.139-16.674c-.794-8.06 6.296-16.859 6.366-16.945l-.354-.288c-.071.08-6.526 8.093-6.526 15.871z'/%3e%3cpath d='M956.41 390.74c-.067.233-1.627 11.618-7.768 15.818l.26.38c6.315-4.32 7.849-15.545 7.911-16.019 2.725-3.243 9.005-14.614 9.069-14.728l-.404-.222c-.063.114-6.318 11.45-9.068 14.77zm-18.13 12.44c.046.239 1.072 5.896 2.246 7.891l.396-.231c-1.136-1.926-2.175-7.68-2.186-7.74l-.456.08zm2.91.07c.05 2.816.064 7.436-.094 7.847l.428.168c.236-.592.146-6.784.128-8.019l-.462.004z'/%3e%3cpath d='m941.45 411.32.418.187c1.971-4.29 2.578-7.249 2.586-7.277l-.452-.09c-.007.024-.602 2.942-2.552 7.18z'/%3e%3cpath d='m941.89 411.45.233.396c3.657-2.125 4.506-5.821 4.536-5.976l-.448-.1c-.01.036-.841 3.66-4.321 5.68z'/%3e%3cpath d='m942.57 411.77.046.455c3.584-.358 6.025-4.711 6.13-4.895l-.405-.223c-.023.045-2.429 4.328-5.771 4.663z'/%3e%3cpath d='m942.93 412 .028.458c5.754-.354 8.343-3.793 8.448-3.938l-.372-.272c-.024.032-2.577 3.415-8.104 3.752z'/%3e%3cpath d='m943.34 412.12-.094.449c.31.07 7.642 1.625 10.152-2.197l-.385-.251c-2.334 3.558-9.601 2.013-9.673 1.999z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='4.2' d='M778.8 143.94v205.09c0 67.08 121.2 106.91 121.2 106.91s121.2-39.833 121.2-106.91V143.94z'/%3e%3c/g%3e%3c/svg%3e";
            },
            7971: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1200 600'%3e%3cpath fill='%23012169' d='M0 0h1200v600H0z'/%3e%3cpath fill='%23012169' d='M0 300h600V0h600v600H0z'/%3e%3cpath fill='%23012169' d='M0 0h600v300H0z'/%3e%3cpath fill='%23fff' d='M0 0v33.54L532.92 300H600v-33.54L67.08 0zm600 0v33.54L67.08 300H0v-33.54L532.92 0z'/%3e%3cpath fill='%23fff' d='M250 0v300h100V0zM0 100v100h600V100z'/%3e%3cpath fill='%23c8102e' d='M0 120v60h600v-60zM270 0v300h60V0zM0 300l200-100h44.72l-200 100zM0 0l200 100h-44.72L0 22.36zm355.28 100 200-100H600L400 100zM600 300 400 200h44.72L600 277.64z'/%3e%3cpath fill='%23500' stroke='%23500' stroke-linejoin='round' stroke-width='1.318' d='M998.104 481.751c-6.102-.967-11.383-3.718-17.285-9.84l-2.96-2.9-3.567 1.247c-18.613 6.271-40.543 10.618-66.673 11.055-33.923.568-63.053-4.427-80.093-11.848l-5.36-2.046-2.81 2.908c-6.164 6.65-12.367 10.021-19.428 10.558-6.724.512-15.925-2.828-20.559-7.463-1.906-1.906-2.222-2.567-3.115-6.51-.835-3.691-2.893-9.156-4.354-11.564-.663-1.093-2.202-3.207-3.42-4.698-5.955-7.29-6.146-7.745-4.387-10.5 2.305-3.612 5.875-5.927 10.05-6.518 1.338-.19 2.502-.415 2.587-.5.086-.086-.49-1.18-1.281-2.431-2.083-3.3-3.45-6.12-3.105-6.412.165-.14 1.926-1.404 3.913-2.811 7.753-5.489 9.815-8.7 12.652-19.715.86-3.335 1.942-6.699 2.406-7.474 1.907-3.19 5.737-5.049 11.007-5.344 4.059-.228 6.125.218 10.494 2.26 8.634 4.037 17.5 11.393 24.832 20.604l3.16 3.968-.22 3.433c-.706 11.018-1.653 17.1-3.531 22.68-.698 2.074-.998 3.474-.788 3.678.495.483 10.474 3.524 15.576 4.746 7.892 1.89 17.553 3.376 28.49 4.38 6.855.63 32.714.63 39.21 0 10.503-1.018 22.608-3.068 30.356-5.14 6.442-1.724 13.732-4.127 13.732-4.528 0-.237-.231-.986-.514-1.663-1.634-3.91-2.95-11.894-3.42-20.738l-.322-6.087 2.927-3.633c3.54-4.393 9.519-10.376 13.562-13.571 4.035-3.188 9.735-6.64 13.24-8.019 6.886-2.709 15.988-1.192 19.065 3.178.545.774 2.023 4.254 3.284 7.732 4.086 11.266 5.824 13.709 13.342 18.745 1.54 1.031 2.8 2.126 2.8 2.431 0 .306-1.138 2.8-2.53 5.541-1.39 2.742-2.529 5.09-2.529 5.216 0 .126.702.23 1.56.23 4.648 0 10.442 3.61 12.406 7.728.764 1.602.49 2.585-1.406 5.024-.846 1.088-2.57 3.31-3.83 4.936-3.204 4.132-5.213 8.119-6.748 13.39-2.085 7.156-2.184 7.364-4.564 9.567-2.505 2.32-8.118 5.2-11.889 6.101-2.987.714-7.564.998-9.963.617z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cg color='%23000' paint-order='markers stroke fill'%3e%3cpath fill='none' stroke='%23520' stroke-linejoin='round' stroke-width='.158' d='m987.012 436.644 10.916-9.88c-.044-4.722-2.756-8.62-6.476-10.051-3.274-1.26-6.415-1.337-10.161 2.745.396 7.444 1.691 11.221 5.721 17.186z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23951b1d' d='m999.716 451.516 3.44 5.25c.767.145 1.545.28 2.32.417-.417 3.5 1.573 8.636 1.573 8.636s-13.567 7.529-20.46 11.195c-3.586-2.612-6.915-6.225-10.049-10.832l-3.4-5.435c3.359-1.217 6.567-2.374 6.871-2.495.64-.256 15.493-6.146 15.493-6.146z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e2a950' d='M1003.565 456.84c9.135 1.698 19.21 2.53 19.847 12.037.343 7.174-13.117 12.716-21.523 13.237-7.125.442-13.652-3.215-19.489-8.88 6.658-3.337 20.271-7.965 21.165-16.394z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='none' stroke='%23520' stroke-linejoin='round' stroke-width='.158' d='M1023.412 468.877c.343 7.174-13.1 13.279-21.523 13.237-9.98-.048-18.176-5.386-25.349-15.933l-10.85-17.338c-5.23-8.317-6.03-20.829-6.35-32.091 6.28-8.405 13.428-16.438 24.443-22.814 5.573-3.15 11.301-5.944 19.554-2.897 5.418 1.909 6.723 5.873 7.424 10.14-.506 17.55-1.754 34.92-11.045 50.334l3.44 5.251c9.24 1.751 19.61 2.463 20.256 12.11z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23c98c26' d='M983.003 428.905c.757 2.264 1.783 4.429 3.187 6.455-6.216 4.75-13.67 8.262-21.814 11.085-.06-.124-.118-.25-.177-.376a32.044 32.044 0 0 1-.86-1.993c-.124-.315-.25-.626-.366-.947-.103-.286-.199-.58-.296-.87a40.04 40.04 0 0 1-.376-1.172c-.04-.133-.077-.268-.116-.402 7.152-4.099 13.747-7.638 20.818-11.78z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23ab1e2b' d='M1013.903 458.961c5.132 1.502 9.117 4.058 9.509 9.916.343 7.174-13.1 13.278-21.523 13.237-3.96-.02-7.636-.887-11.082-2.567.321-.16 9.338-2.002 13.273-4.525 2.872-1.841 6.018-5.888 7.042-7.425 1.024-1.536 1.535-5.635 2.56-8.195a2.89 2.89 0 0 1 .221-.44z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23c47645' d='M1013.903 458.961a25.13 25.13 0 0 1 2.518.868c-.122 2.253 1.345 4.152 1.13 6.262-.18 1.779-1.002 3.491-1.992 4.98-1.384 2.078-3.248 3.889-5.34 5.25-2.34 1.521-5.1 2.323-7.787 3.077-2.743.769-4.328.75-8.422 1.45a25.226 25.226 0 0 1-3.203-1.301c1.683-.938 4.656-1.235 6.285-1.96 1.63-.724 3.892-1.537 5.793-2.623 1.902-1.087 3.622-2.445 3.984-2.807.362-.362 3.348-3.803 3.62-4.256.271-.453 2.794-6.579 3.414-8.94z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23ca6b5b' d='M980.724 395.824c.074.84.134 1.84.188 2.93.064 1.407.077 2.832.085 4.259.004.8.013 1.597.008 2.4-.008 1.335-.015 2.67-.026 4.006-.01 1.162.001 2.316.008 3.471.007.914.012 1.828.039 2.734.013.455.02.91.04 1.363.039.857.092 1.708.16 2.554v.018s-.106 6.216 1.022 9.373c.975 2.731 3.943 6.428 3.943 6.428l-13.812 7.676-7.992 3.407c-.004 0-.008.003-.013.005-.042-.086-.08-.176-.121-.263 0-.001-.001-.004-.003-.005-2.89-7.87-4.654-20.451-4.91-29.428 5.678-7.597 12.074-14.887 21.384-20.928z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e2b269' d='M980.902 407.108c-.003 1.44.08 7.29.126 8.712a73.28 73.28 0 0 0 .198 3.72v.019l.003.005c.306 3.74.968 7.352 2.294 10.72l-21.281 10.597-.015-.057c-.014-.044-.026-.089-.039-.134a47.537 47.537 0 0 1-.458-1.683l-.014-.044-.074-.307c-.16-.654-.31-1.317-.448-1.987l-.005-.016v-.002a.066.066 0 0 0-.003-.011l-.005-.023c-.077-.378-.14-.764-.211-1.146a70.04 70.04 0 0 1-.7-4.648 91.522 91.522 0 0 1-.114-.965 95.91 95.91 0 0 1-.227-2.191v-.008l-.002-.01-.006-.063c-.002-.027-.002-.055-.005-.082-.13-1.487-.235-2.98-.317-4.472z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23f2d196' d='M981.036 416.327c.127 3.49.459 6.903 1.259 10.145-6.041 2.844-17.175 8.28-21.106 10.163-.089-.433-.164-.875-.245-1.313a70.314 70.314 0 0 1-.383-2.3c-.047-.308-.1-.613-.142-.924l-.005-.036c-.008-.061-.012-.124-.02-.185a93.396 93.396 0 0 1-.462-4.166l-.028-.358z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23951b1d' d='M985.256 433.846c.299.51.592 1.02.934 1.514-6.217 4.75-13.671 8.265-21.816 11.088a31.001 31.001 0 0 1-.932-2.112z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='none' stroke='%23520' stroke-linejoin='round' stroke-width='.158' d='M980.724 395.824c1.198 13.408-2.183 28.494 5.466 39.536-6.217 4.75-13.671 8.265-21.816 11.088-4.044-8.213-4.743-19.464-5.034-29.696 5.678-7.597 12.074-14.887 21.384-20.928z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23faecbd' d='M998.495 425.01c1.147-1.174 2.755-3.056 4.066-4.76 3.532-4.588 6.143-9.468 7.415-13.852.446-1.541.59-2.422.64-3.939.042-1.298.04-1.327-.156-2.304-.609-3.041-1.514-4.974-3.042-6.496-1.263-1.259-2.582-2.007-4.898-2.78-2.303-.768-4.296-1.075-6.56-1.01-3.565.103-6.626 1.112-11.365 3.745-1.153.64-3.357 1.966-3.643 2.19-.113.088-.118.144-.067.704.184 2.017.215 3.638.22 11.618.003 5.977.027 8.63.087 9.603.046.739.097 1.385.113 1.436.02.062.233-.106.652-.517.982-.963 1.751-1.532 2.734-2.023 2.031-1.015 4.118-1.03 6.694-.047 2.699 1.03 4.845 3.254 5.911 6.127.257.691.516 1.696.585 2.269.025.205.064.408.087.452.028.052.209-.091.527-.416z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23ae4c33' stroke='%23000' stroke-linejoin='round' stroke-width='.011' d='M982.198 418.372c1.316-1.236 2.897-2.132 4.233-2.4.5-.099.52-.114.519-.385-.001-.156.268-5.53.597-11.945.33-6.414.576-11.685.547-11.713-.123-.124-4.82 2.408-6.587 3.55-.7.453-.663.335-.523 1.72.05.497.128 5.487.173 11.089.045 5.602.109 10.317.142 10.479.033.162.086.292.117.29.032-.003.384-.31.782-.685z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23dba35a' stroke='%23000' stroke-linejoin='round' stroke-width='.016' d='M991.702 416.567c0-.043.81-6.037 1.8-13.32.99-7.285 1.774-13.27 1.743-13.3-.115-.115-2.357.25-3.415.555-.598.173-1.678.545-2.4.827l-1.313.514v.83c0 .863-.959 20.663-1.08 22.283l-.068.92.44-.072c.611-.099 2.32.17 3.393.536.495.168.9.27.9.227z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e9be79' stroke='%23000' stroke-linejoin='round' stroke-width='.016' d='M999.467 423.861c4.144-4.659 7.143-9.202 9.12-13.817 1.855-4.326 2.363-7.66 1.628-10.694-1.15-4.743-3.256-7.007-7.897-8.485-1.917-.61-3.66-.92-5.357-.952-.834-.015-1.543 0-1.575.036-.032.035-.674 4.673-1.426 10.306a8734.61 8734.61 0 0 1-1.785 13.315l-.418 3.073.775.416c2.655 1.424 4.558 4.043 5.257 7.234.12.545.261.992.315.992.053 0 .667-.64 1.363-1.424z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23012169' stroke='%23500' stroke-linejoin='round' stroke-width='.989' d='m988.315 432.11 5.462-4.154 2.621-2.319s1.337-.761 1.188-1.385c-.856-3.606-3.174-6.382-6.317-7.565-3.47-1.306-6.195-.743-8.953 1.85l-1.021.96.142 1.408c.53 5.263 1.582 9.27 3.82 12.942.354.581 1.362-.516 1.417-.516.054 0 1.64-1.222 1.64-1.222z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3c/g%3e%3cpath fill='none' stroke='%23520' stroke-linejoin='round' stroke-width='.158' d='m813.01 435.622-10.916-9.88c.044-4.722 2.756-8.62 6.476-10.051 3.274-1.26 6.415-1.337 10.161 2.745-.396 7.444-1.69 11.221-5.72 17.186z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23951b1d' d='m800.306 450.494-3.44 5.25c-.766.145-1.544.28-2.32.417.418 3.5-1.573 8.636-1.573 8.636s13.567 7.528 20.46 11.195c3.587-2.612 6.916-6.225 10.049-10.832l3.401-5.435c-3.36-1.217-6.568-2.374-6.872-2.495-.64-.257-15.493-6.147-15.493-6.147z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e2a950' d='M796.457 455.818c-9.134 1.697-19.21 2.53-19.846 12.037-.343 7.174 13.116 12.716 21.522 13.237 7.126.442 13.653-3.215 19.49-8.88-6.658-3.338-20.272-7.965-21.166-16.394z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='none' stroke='%23520' stroke-linejoin='round' stroke-width='.158' d='M776.61 467.855c-.343 7.174 13.1 13.278 21.523 13.237 9.98-.048 18.176-5.386 25.349-15.933l10.85-17.338c5.23-8.318 6.03-20.829 6.35-32.091-6.28-8.405-13.428-16.438-24.443-22.814-5.573-3.15-11.3-5.944-19.554-2.897-5.417 1.908-6.723 5.873-7.423 10.14.505 17.55 1.754 34.92 11.044 50.334l-3.44 5.25c-9.24 1.752-19.61 2.464-20.256 12.112z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23c98c26' d='M817.02 427.883c-.758 2.264-1.784 4.428-3.188 6.455 6.217 4.75 13.67 8.262 21.814 11.085.06-.124.118-.25.178-.376.307-.647.591-1.312.86-1.993.123-.315.25-.626.365-.947.104-.286.199-.58.296-.87.13-.388.257-.777.376-1.172.04-.133.077-.268.116-.402-7.152-4.099-13.747-7.638-20.817-11.78z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23eed3a6' stroke='%23520' stroke-linejoin='round' stroke-width='.158' d='M789.262 400.158c-2.578 16.13-10.122 19.841-17.382 24.262 0 0 23.003 56.794 128.552 56.13 89.789 0 118.38-34.52 127.467-57.578-15.17-8.326-13.815-15.38-17.382-22.814 3.334 14.887-28.885 55.328-109.722 55.405-94.496.09-112.814-46.953-111.533-55.405z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e6ba74' d='m1013.208 407.385-.512.937c-6.268 12.911-13.017 18.092-21.804 24.667-10.82 8.096-23.872 12.991-36.717 17.187-8.767 2.864-17.992 4.262-27.154 5.325-13.238 1.536-26.633 1.975-39.95 1.493a181.461 181.461 0 0 1-26.429-2.91c-7.423-1.373-14.726-3.412-21.906-5.744-5.925-1.924-11.846-3.992-17.414-6.784-6.307-3.164-17.954-11.214-17.954-11.214l-10.371-11.267-5.845-10.637c-3.484 9.346-9.464 12.446-15.271 15.982 0 0 23.003 56.794 128.553 56.129 89.788 0 118.377-34.519 127.463-57.576-10.211-5.604-12.911-10.632-14.689-15.588z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e2a950' d='M787.152 408.436c-3.484 9.347-9.464 12.447-15.271 15.984 0 0 7.654 18.792 34.219 34.631-.35-3.343-2.09-18.143-2.09-18.724 0-.64-.002-9.473-.77-9.985-.769-.512-9.985-10.5-10.37-11.267-.266-.533-3.613-6.682-5.718-10.64z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23c98c26' d='M1018.563 416.854c2.744 2.546 5.814 4.275 8.84 6.118 0 0-1.266 6.195-7.239 13.523-.593-1.227-1.972-3.17-1.972-3.376 0-.64-1.154-4.994-1.154-6.146 0-1.152.258-6.529.258-7.68 0-.294.513-1.226 1.267-2.44z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='none' stroke='%23520' stroke-linejoin='round' stroke-width='.158' d='M789.262 400.158c-2.578 16.13-10.122 19.841-17.382 24.262 0 0 23.003 56.794 128.552 56.13 89.789 0 118.38-34.52 127.467-57.578-15.17-8.326-13.815-15.38-17.382-22.814 3.334 14.887-28.885 55.328-109.722 55.405-94.496.09-112.814-46.953-111.533-55.405z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23ab1e2b' d='M786.12 457.94c-5.133 1.501-9.118 4.057-9.51 9.915-.342 7.174 13.1 13.278 21.523 13.237 3.96-.02 7.636-.887 11.082-2.567-.321-.16-9.338-2.002-13.273-4.525-2.871-1.841-6.018-5.889-7.042-7.425-1.024-1.536-1.535-5.635-2.56-8.196a2.89 2.89 0 0 0-.22-.44z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23c47645' d='M786.12 457.94c-.876.255-1.723.538-2.519.867.123 2.253-1.344 4.152-1.13 6.262.18 1.779 1.002 3.491 1.993 4.98 1.383 2.077 3.247 3.889 5.34 5.25 2.34 1.521 5.099 2.323 7.786 3.076 2.743.77 4.328.75 8.422 1.45 1.09-.357 2.158-.79 3.203-1.3-1.682-.938-4.655-1.235-6.285-1.96-1.63-.724-3.892-1.537-5.793-2.623-1.901-1.087-3.621-2.445-3.983-2.807-.362-.362-3.349-3.803-3.62-4.256-.272-.453-2.794-6.579-3.415-8.94z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23ca6b5b' d='M819.298 394.802a80.54 80.54 0 0 0-.188 2.93 108.468 108.468 0 0 0-.085 4.259c-.004.8-.013 1.597-.007 2.4.007 1.335.015 2.67.025 4.006.01 1.162 0 2.315-.008 3.47-.006.915-.012 1.829-.038 2.735-.013.455-.022.91-.041 1.362a68.941 68.941 0 0 1-.16 2.555v.018s.106 6.215-1.021 9.373c-.975 2.73-3.943 6.428-3.943 6.428l13.811 7.676 7.992 3.406.013.006c.043-.086.08-.177.121-.263l.003-.005c2.891-7.87 4.655-20.451 4.91-29.428-5.677-7.597-12.073-14.888-21.384-20.928z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e2b269' d='M819.12 406.086c.003 1.44-.08 7.29-.125 8.712a73.839 73.839 0 0 1-.199 3.72v.019l-.002.005c-.307 3.74-.969 7.352-2.295 10.719l21.281 10.598.016-.057.038-.134c.162-.554.315-1.115.459-1.684l.013-.043.074-.307c.16-.655.31-1.317.449-1.988 0-.005.003-.01.005-.015v-.003l.002-.01.006-.023c.077-.379.14-.764.21-1.146a70.04 70.04 0 0 0 .701-4.648c.04-.32.078-.643.113-.965a95.91 95.91 0 0 0 .227-2.191v-.008c0-.004.003-.007.003-.01.001-.021.002-.042.005-.063.003-.027.003-.055.005-.082.13-1.487.235-2.98.317-4.473z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23f2d196' d='M818.987 415.305c-.127 3.489-.46 6.903-1.26 10.145 6.042 2.844 17.175 8.28 21.107 10.163.088-.433.164-.875.244-1.313.14-.76.269-1.525.384-2.3.046-.308.099-.614.141-.924l.006-.036c.008-.061.012-.124.02-.185.186-1.375.336-2.766.461-4.166.01-.12.018-.24.029-.358z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23c98c26' d='M780.902 418.426c-2.744 2.546-5.814 4.276-8.84 6.118 0 0 2.161 5.299 8.134 12.627.593-1.227 1.076-2.274 1.076-2.48 0-.64 1.154-4.993 1.154-6.146 0-1.152-.258-6.528-.258-7.68 0-.294-.513-1.226-1.266-2.439z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cg color='%23000' paint-order='markers stroke fill'%3e%3cpath fill='%23f9e7d9' stroke='%23500' stroke-linejoin='round' stroke-width='.158' d='m787.874 471.692-4.952-14.595 8.872 4.98 1.178 2.715-.272 2.535-.543 1.72-1.268 1.357z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e6ba74' d='M763.295 441.225c-1.037 1.628-.214 2.326 0 3.329 0 0 6.87 7.444 9.282 11.842 1.947 3.55 4.033 11.459 4.033 11.459-.59-2.845 4.655-7.382 8.45-7.682 2.95-.233 6.859 1.96 7.425 4.865.517 2.65-1.295 5.993-4.609 6.658 8.955-2.025 4.482-10.674 2.816-14.66 0 0-2.602-4.532-3.456-6.985-1.678-4.82-3.2-14.972-3.2-14.972-10.834-4.111-16.627-.302-20.741 6.146z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23f9e7d9' d='M775.254 433.383c-4.035.163-7.056 1.92-9.496 4.588 4.153 7.18 10.65 17.955 10.65 17.955L768.8 438c2.909-3.218 6.59-3.734 10.863-2.173l-.252-2.078c-1.492-.288-2.882-.417-4.158-.366z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23c47645' d='M780.133 433.885c1.12 7.778 2.907 21.033 3.646 26.536a6.65 6.65 0 0 1 1.282-.247c2.95-.233 6.857 1.96 7.423 4.864.467 2.39-.968 5.34-3.687 6.383 7.664-2.414 3.499-10.55 1.895-14.386 0 0-2.601-4.532-3.455-6.985-1.678-4.82-3.2-14.97-3.2-14.97a29.255 29.255 0 0 0-3.904-1.195zm8.664 37.536c-.3.095-.584.199-.922.275.323-.064.628-.163.922-.275z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23ab1e2b' d='m781.062 434.132 5.678 26.168c2.582.484 5.28 2.361 5.744 4.738.467 2.39-.968 5.34-3.687 6.383 7.664-2.414 3.499-10.55 1.895-14.386 0 0-2.601-4.532-3.455-6.985-1.678-4.82-3.2-14.97-3.2-14.97a29.975 29.975 0 0 0-2.975-.948z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='none' stroke='%23520' stroke-linejoin='round' stroke-width='.102' d='M572.738 673.714c-.682 1.023-.14 1.461 0 2.091 0 0 4.514 4.678 6.098 7.44 1.28 2.232 2.65 7.2 2.65 7.2-.388-1.787 3.058-4.638 5.551-4.826 1.938-.147 4.506 1.232 4.879 3.057.34 1.664-.852 3.765-3.028 4.183 5.883-1.273 2.944-6.706 1.85-9.211 0 0-1.71-2.848-2.271-4.389-1.103-3.028-2.103-9.406-2.103-9.406-7.117-2.584-10.923-.19-13.626 3.86z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none' transform='matrix(1.5221 0 0 1.5916 -108.474 -631.053)'/%3e%3c/g%3e%3cpath fill='%23951b1d' d='M814.767 432.824c-.3.51-.593 1.02-.935 1.514 6.218 4.75 13.671 8.265 21.817 11.087.335-.681.64-1.39.932-2.11z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='none' stroke='%23520' stroke-linejoin='round' stroke-width='.158' d='M819.298 394.802c-1.198 13.407 2.183 28.494-5.466 39.536 6.218 4.75 13.671 8.265 21.817 11.087 4.044-8.212 4.742-19.463 5.033-29.695-5.677-7.597-12.073-14.888-21.384-20.928z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23faecbd' d='M996.536 430.922c-37.437 26.401-123.877 41.537-183.525 4.701l.286 27.417c19.508 9.905 47.501 17.758 87.137 17.509 46.357 0 76.372-9.209 95.842-21.284z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cg style='line-height:125%25;-inkscape-font-specification:&quot;Narkisim, Normal&quot;;font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:center'%3e%3cpath d='M812.504 448.458q-1.816 3.144-4.913 3.845-3.002.677-6.143-1.138l-3.599-2.1q1.426-1.345 2.989-4.048l2.939-5.087q1.423-2.463 2.218-4.963l1.42.845q9.226 5.487 5.09 12.646zm-2.267-1.376q1.515-2.623.78-5.092-.71-2.373-3.293-3.936l-6.375 11.034q6.024 2.95 8.888-2.006zm12.491 11.475-2.538 2.356-7.755-3.61q1.263-1.43 2.752-4.721l2.347-5.19q1.107-2.448 1.619-4.942l8.056 3.75-2.206 1.872q-1.129-1.483-2.781-2.253-.208-.096-1.054-.452l-2.18 4.821 4.792 2.23-2.445 1.762q-1.041-1.315-3.077-2.378l-2.338 5.17q2.705 1.029 3.345 1.2 1.705.486 3.463.385zm11.089 2.876q-.794 2.14-2.877 2.745-1.87.526-4.042-.304-1.402-.536-2.563-1.785l1.096-2.955q.368 1.182.79 1.79.56.797 1.523 1.165 1.06.405 2.062.044 1.067-.374 1.458-1.428.407-1.097-.607-2.774l-1.918-3.064q-.926-1.917-.305-3.59.73-1.966 2.606-2.576 1.726-.568 3.706.188 1.328.507 2.456 1.583l-1.012 2.727q-.582-1.165-.855-1.517-.514-.656-1.403-.995-.92-.352-1.721-.037-.841.324-1.18 1.236-.387 1.043.632 2.71l1.906 3.096q.906 1.971.248 3.742zm5.889 6.697-3.407-1.114q1.175-1.884 1.792-3.828l2.21-6.96q.832-2.618.938-4.767l3.407 1.114q-1.161 1.803-1.993 4.421l-2.175 6.85q-.653 2.055-.772 4.284zm16.245 4.645-2.815-.772q-2.094-3.304-4.051-8.806l-.586 2.196q-.713 2.678-.784 5.123l-3.456-.947q.987-1.57 1.778-4.538l1.77-6.644q.535-2.006.656-4.594l1.711.47q3.268.895 4.704 1.998 2.24 1.733 1.484 4.567-.725 2.723-4.103 3.216 1.253 4.19 3.692 8.73zm-2.172-12.523q.762-2.857-2.807-4.136l-1.702 6.387q1.601.258 2.742-.198 1.367-.551 1.767-2.053zm15.233 12.06-1.973 2.86-8.343-1.814q.927-1.674 1.675-5.215l1.18-5.583q.557-2.633.522-5.18l8.667 1.883-1.752 2.314q-1.42-1.199-3.197-1.586-.224-.048-1.126-.209l-1.096 5.187 5.155 1.12-2.009 2.258q-1.298-1.054-3.513-1.642l-1.175 5.56q2.861.41 3.522.434 1.77.1 3.463-.387zm24.293-12.086-.935 2.759q-1.276-.64-2.203-.848-.734-.164-2.333-.238l-.344 9.651q-.134 3.774.376 5.8l-3.792-.145q.658-1.785.803-5.854l.34-9.552q-1.859.052-2.76.14-1.498.164-2.69.562l1.02-2.756zm16.588 16.989-3.794.096q.528-2.08.492-3.446l-.114-4.33-7.297.185.058 2.214q.076 2.89.74 5.532l-3.794.095q.528-2.056.449-5.081l-.18-6.826q-.08-3.1-.723-5.41l3.793-.095q-.532 2.376-.483 4.221l.084 3.198 7.297-.185-.06-2.25q-.068-2.595-.717-5.139l3.794-.096q-.535 2.242-.463 5.009l.17 6.432q.091 3.517.748 5.876zm15.262-4.579-1.144 3.51-9.016.721q.438-1.985.134-5.811l-.479-6.034q-.225-2.846-1.026-5.423l9.367-.749-1.085 2.889q-1.8-.782-3.723-.629-.241.02-1.205.134l.445 5.605 5.571-.446-1.362 2.911q-1.634-.672-4.06-.589l.477 6.01q3.028-.464 3.707-.642 1.826-.442 3.4-1.457zm26.307-1.107-2.955.629q-3.465-2.051-7.827-6.195l.48 2.305q.587 2.81 1.658 5.1l-3.626.773q.18-1.918-.47-5.035l-1.455-6.974q-.44-2.105-1.53-4.55l1.795-.383q3.43-.73 5.266-.396 2.87.532 3.491 3.507.596 2.858-2.289 4.921 3.103 3.27 7.462 6.298zm-7.822-10.52q-.626-2.999-4.511-2.479l1.399 6.704q1.597-.525 2.436-1.49 1.004-1.159.676-2.735zm14.046 8.748-3.578.976q-.027-2.308-.572-4.35l-1.95-7.311q-.733-2.75-1.836-4.678l3.578-.976q-.006 2.23.728 4.98l1.919 7.195q.576 2.159 1.711 4.164zm15.225-13.921q.036 1.376.268 2.338.143.598.723 2.278.6 1.736 1.215 2.754-2.559 1.961-5.152 2.878-3.666 1.297-6.607.006-3.058-1.337-4.331-5.025-1.313-3.802.29-7.043 1.58-3.194 5.325-4.519 1.833-.648 4.225-.768l.952 2.758q-2.589-.74-4.992.11-2.56.905-3.417 3.36-.793 2.28.127 4.946.925 2.678 2.794 3.915 2.062 1.359 4.622.454 1.296-.459 2.939-1.804l-.713-2.065q-.666-1.93-1.767-3.336zm19.043.277-3.334 1.639q-.36-2.069-.934-3.27l-1.823-3.807-6.412 3.151.932 1.947q1.217 2.542 2.858 4.622l-3.333 1.638q-.349-2.047-1.623-4.707l-2.875-6.004q-1.306-2.725-2.796-4.518l3.334-1.639q.473 2.334 1.25 3.956l1.346 2.812 6.412-3.15-.948-1.98q-1.093-2.282-2.682-4.281l3.334-1.638q.416 2.214 1.581 4.648l2.71 5.657q1.48 3.093 3.003 4.924zm5.136-23.29.786 2.739q-1.372.217-2.227.58-.676.289-1.991 1.143l5.083 7.909q1.988 3.093 3.52 4.42l-3.105 2.05q-.466-1.802-2.609-5.136l-5.031-7.828q-1.453 1.103-2.122 1.688-1.103.987-1.832 1.985l-.716-2.784z' aria-label='DESIRE THE RIGHT' font-family='Narkisim' font-size='13.552' font-weight='400' letter-spacing='.932' style='-inkscape-font-specification:&quot;Narkisim, Normal&quot;;font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:center' text-anchor='middle' word-spacing='4.557'/%3e%3c/g%3e%3cpath fill='%23faecbd' d='M801.528 423.987c-1.148-1.173-2.756-3.055-4.067-4.759-3.531-4.588-6.143-9.468-7.414-13.853-.447-1.54-.59-2.42-.64-3.938-.042-1.298-.04-1.327.155-2.305.61-3.04 1.514-4.973 3.042-6.495 1.264-1.26 2.582-2.007 4.899-2.78 2.302-.768 4.296-1.075 6.56-1.01 3.565.103 6.625 1.111 11.364 3.745 1.153.64 3.358 1.966 3.644 2.19.112.088.118.143.067.704-.185 2.016-.215 3.638-.22 11.618-.003 5.977-.028 8.63-.088 9.602-.045.74-.096 1.386-.113 1.437-.02.062-.232-.106-.652-.517-.982-.963-1.75-1.532-2.734-2.023-2.03-1.016-4.118-1.03-6.694-.047-2.699 1.03-4.844 3.254-5.91 6.127-.257.69-.516 1.696-.585 2.268-.025.205-.064.409-.088.453-.028.052-.209-.091-.526-.417z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23ae4c33' stroke='%23000' stroke-linejoin='round' stroke-width='.011' d='M817.824 417.35c-1.316-1.237-2.897-2.133-4.232-2.4-.501-.1-.52-.114-.52-.386.002-.155-.267-5.53-.597-11.944-.329-6.414-.575-11.685-.547-11.713.124-.124 4.821 2.408 6.587 3.55.7.453.664.335.524 1.719-.05.498-.129 5.488-.174 11.09-.045 5.601-.108 10.317-.141 10.479-.033.162-.086.292-.118.29-.032-.003-.384-.311-.782-.685z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23dba35a' stroke='%23000' stroke-linejoin='round' stroke-width='.016' d='M808.32 415.545c0-.043-.81-6.037-1.8-13.321s-1.773-13.269-1.742-13.3c.114-.114 2.356.251 3.414.556.599.173 1.679.545 2.4.827l1.313.513v.831c0 .863.96 20.663 1.08 22.283l.068.92-.44-.072c-.611-.099-2.32.17-3.393.535-.495.169-.9.271-.9.228z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e9be79' stroke='%23000' stroke-linejoin='round' stroke-width='.016' d='M800.555 422.839c-4.143-4.659-7.142-9.202-9.12-13.817-1.855-4.326-2.362-7.661-1.627-10.694 1.149-4.743 3.255-7.007 7.896-8.485 1.917-.61 3.661-.92 5.357-.952.834-.016 1.543 0 1.575.036.032.035.674 4.673 1.426 10.306.752 5.633 1.556 11.625 1.786 13.315l.418 3.073-.776.416c-2.655 1.424-4.558 4.043-5.257 7.234-.12.545-.26.992-.314.992-.054 0-.667-.64-1.364-1.424z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23012169' stroke='%23500' stroke-linejoin='round' stroke-width='.989' d='M812.157 433.244c-3.19-2.288-6.046-4.667-8.653-7.209-.863-.84-1.517-1.56-1.453-1.6.063-.04.237-.582.385-1.205.856-3.606 3.175-6.382 6.317-7.565 3.47-1.306 6.196-.744 8.953 1.85l1.021.96-.141 1.408c-.53 5.263-1.898 9.675-4.135 13.347-.354.58-.688 1.056-.743 1.056-.054 0-.752-.469-1.551-1.042zm-21.61 23.391c-.464-.56-2.974-5.816-3.388-7.097-.473-1.462-1.243-4.455-1.42-5.52l-.097-.576 1.25 1.194c3.026 2.893 7.07 6.299 9.885 8.325.65.467 1.182.896 1.185.952 0 .078-.857 1.438-1.099 1.737-.02.027-1.294.27-2.828.54-1.535.271-2.914.523-3.064.56-.154.037-.34-.014-.424-.115z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cg color='%23000' paint-order='markers stroke fill'%3e%3cpath fill='%23f9e7d9' stroke='%23500' stroke-linejoin='round' stroke-width='.158' d='m1012.15 472.736 4.95-14.595-8.871 4.98-1.178 2.715.272 2.535.543 1.72 1.268 1.357z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e6ba74' d='M1036.728 442.27c1.037 1.628.214 2.325 0 3.328 0 0-6.87 7.445-9.282 11.843-1.947 3.55-4.033 11.458-4.033 11.458.59-2.844-4.655-7.381-8.45-7.681-2.95-.234-6.859 1.96-7.425 4.865-.517 2.649 1.295 5.993 4.609 6.657-8.955-2.025-4.482-10.673-2.816-14.66 0 0 2.602-4.531 3.456-6.985 1.678-4.82 3.2-14.97 3.2-14.97 10.834-4.112 16.627-.303 20.741 6.144z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23f9e7d9' d='M1024.77 434.428c4.034.162 7.055 1.92 9.495 4.588-4.153 7.179-10.65 17.954-10.65 17.954l7.607-17.926c-2.909-3.217-6.59-3.733-10.863-2.173l.252-2.078c1.492-.288 2.882-.417 4.158-.365z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23c47645' d='M1019.89 434.93c-1.12 7.778-2.907 21.033-3.646 26.536a6.613 6.613 0 0 0-1.282-.247c-2.95-.234-6.857 1.96-7.423 4.864-.467 2.39.968 5.34 3.687 6.383-7.664-2.415-3.499-10.55-1.895-14.386 0 0 2.601-4.532 3.455-6.985 1.678-4.82 3.2-14.97 3.2-14.97a29.255 29.255 0 0 1 3.904-1.195zm-8.664 37.536c.3.094.584.199.922.275a5.705 5.705 0 0 1-.922-.275z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23ab1e2b' d='m1018.96 435.177-5.677 26.168c-2.582.484-5.28 2.36-5.744 4.738-.467 2.39.968 5.34 3.687 6.383-7.664-2.415-3.499-10.55-1.895-14.386 0 0 2.601-4.532 3.455-6.985 1.678-4.82 3.2-14.97 3.2-14.97a29.975 29.975 0 0 1 2.975-.948z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='none' stroke='%23520' stroke-linejoin='round' stroke-width='.102' d='M572.738 673.714c-.682 1.023-.14 1.461 0 2.091 0 0 4.514 4.678 6.098 7.44 1.28 2.232 2.65 7.2 2.65 7.2-.388-1.787 3.058-4.638 5.551-4.826 1.938-.147 4.506 1.232 4.879 3.057.34 1.664-.852 3.765-3.028 4.183 5.883-1.273 2.944-6.706 1.85-9.211 0 0-1.71-2.848-2.271-4.389-1.103-3.028-2.103-9.406-2.103-9.406-7.117-2.584-10.923-.19-13.626 3.86z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none' transform='matrix(-1.5221 0 0 1.5916 1908.497 -630.008)'/%3e%3c/g%3e%3cpath fill='%23012169' stroke='%23500' stroke-linejoin='round' stroke-width='.923' d='M1009.326 457.738c.419-.542 2.683-5.623 3.056-6.861.427-1.414 1.44-4.18 1.6-5.21l.087-.557-1.127 1.155c-2.73 2.797-6.633 6.28-9.173 8.239-.585.451-1.066.866-1.068.92 0 .076.709 1.072.927 1.362.02.025 1.167.26 2.552.522 1.384.262 2.628.505 2.764.54.139.037.306-.013.382-.11z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%232a7fff' fill-rule='evenodd' d='M899.032 441.717s-127.428-32.369-126.685-155.514l.982-162.78h251.408l.985 161.845c.743 123.145-126.69 156.45-126.69 156.45z' font-size='12'/%3e%3cpath fill='%23333' stroke='%23333' stroke-width='3.938' d='M859.96 271.502c-1.107-.336-1.654-.836-1.654-1.513 0-.336-.17-.53-.42-.478-.232.048-.613-.176-.848-.497-.396-.543-.293-.735 1.463-2.715l1.89-2.13.845-3.601c.887-3.775 2.164-11.526 2.488-15.098.206-2.274.413 2.31-.144 2.11-1.945-.273-2.802-3.676-5.764-3.836-3.097-.166-4.4-5.722-5.244-5.976-2.237-.674-6.306-1.593-10.15-5.464-3.494-3.519-3.742-3.879-5.613-8.13-.472-1.074-1.508-2.924-2.301-4.113l-1.443-2.16-.323-4.553c-.178-2.505-.532-5.538-.787-6.74-.495-2.343-.448-2.998.508-7.066.51-2.17.562-3.069.397-6.884l-.19-4.387-1.462-1.56c-1.903-2.031-2.558-3.59-2.85-6.789-.387-4.229-2.008-8.04-5.101-8.885-.812-.222-2.933-.26-6.625-.118-7.524.29-9.25 1.219-9.655-1.453-.095-.63-.438-1.427-.76-1.774-.433-.464-.68-1.37-.939-3.443l-.352-2.813.921-1.265c2.607-3.577 11.966-13.09 19.453-19.772.93-.83 1.234-1.34 1.358-2.269.18-1.362.773-1.938 2.246-2.189 2.012-.341 2.19-.428 2.68-1.306.54-.97 1-1.071 2.46-.538.847.308 1.04.278 1.622-.25.597-.542 1.003-.595 4.155-.546 3.012.046 3.637.142 4.539.692.575.35 2.005.967 3.178 1.37 1.173.402 2.35.93 2.616 1.173s1.263.761 2.216 1.152c2.323.952 6.224 3.257 8.61 5.088 1.07.821 2.896 1.996 4.056 2.611 3.674 1.948 11.765 8.318 12.345 9.72.293.708.76 1.127 1.717 1.54.723.313 1.875 1.089 2.56 1.724l1.246 1.154 4.657.475c8.341.85 12.663 1.061 21.844 1.068 10.27.008 13.407-.209 23.423-1.615 11.674-1.639 16.47-2.01 23.288-1.804 6.47.196 7.855.389 10.487 1.462 3.7 1.508 10.079 5.823 13.42 9.079 2.737 2.666 6.279 10.14 8.277 17.468 1.174 4.302 1.499 7.405 1.036 9.895-.55 2.96-1.464 3.375-2.605 1.181-1.236-2.377-1.845-3.408-1.95-3.302-.064.064.032 1.01.211 2.103.244 1.485.241 2.358-.01 3.46-.578 2.526-.437 3.325 1.124 6.366l1.461 2.846-.29 2.938c-.158 1.615-.292 3.679-.296 4.586l-.008 1.649-1.336.515c-1.333.513-1.335.517-1.093 1.582.876 3.84-.45 7.75-3.272 9.64-.867.581-1.59 1.203-1.605 1.382-.155 1.79.918 9.129 1.766 12.074.661 2.298.737 4.426.286 8.052-.31 2.494-.707 3.528-2.528 6.583l-1.019 1.71.661 2.109c.363 1.16.673 2.567.689 3.128.027.989-.018 1.031-1.428 1.367-2.11.503-4.27.484-5.018-.045-.352-.25-.932-.379-1.302-.291-.366.087-.856.034-1.088-.119-.355-.233-.257-.685.627-2.866 1.058-2.613 2.358-7.128 2.708-9.404.105-.684-.023-2.775-.287-4.7-.585-4.258-1.566-6.485-4.428-10.05-1.551-1.932-2.415-2.715-3.973-3.598-1.094-.62-2.092-1.128-2.217-1.128s-.58.98-1.013 2.176c-.837 2.315-1.27 2.88-2.605 3.392-.836.32-.837.326-.7 2.444.076 1.167.505 3.253.953 4.634l.814 2.513-1.242 2.775c-.684 1.526-1.47 3.438-1.75 4.25-.616 1.795-1.717 4.004-2.765 5.55l-.78 1.152.652 2.08c.359 1.144.665 2.538.68 3.1.027.988-.017 1.03-1.427 1.367-2.425.577-4.318.495-5.23-.229-.603-.479-.85-.542-1.021-.262-.244.398-1.463.161-1.463-.284 0-.142.436-1.356.97-2.698 1.181-2.967 1.917-5.729 3.11-11.669l.91-4.53-.638-1.785c-1.095-3.068-4.324-9.2-5.263-9.997-.49-.415-1.246-.748-1.705-.748-.623 0-1.152-.368-2.171-1.512l-1.348-1.512-2.541 1.218c-1.653.793-2.947 1.22-3.701 1.221-.638.001-2.05.087-3.14.19-1.779.17-2.022.272-2.395.999-.98 1.914-1.793 2.152-3.456 1.012l-1.072-.733-.844.629c-.738.55-1.079.605-2.727.435-1.619-.168-2.033-.106-2.943.436-.883.525-1.288.592-2.428.4a17.056 17.056 0 0 0-2.837-.174 6.426 6.426 0 0 1-2.771-.526c-1.037-.463-1.538-.529-2.46-.32-1.944.437-8.533.161-10.302-.432-1.305-.437-1.723-.463-2.618-.165-1.623.54-2.67.305-3.232-.725-1.081-1.985-2.558-.553-2.367 2.295.13 1.921-.444 2.552-2.318 2.552-1.231 0-1.453.1-1.896.856-.275.47-.803.995-1.172 1.165-.64.294-.664.415-.506 2.595.115 1.587.02 2.96-.313 4.49-.826 3.806-1.035 5.332-1.224 8.972l-.185 3.54 1.207 2.703c.663 1.486 1.206 2.828 1.206 2.981 0 .153-.45.626-1.002 1.05-1.385 1.066-3.927 1.62-6.193 1.348-1.604-.192-1.95-.357-3.04-1.445l-1.228-1.227 1.507-2.179c2.066-2.985 2.39-4.403 2.38-10.445-.009-6.15-.426-11.78-.895-12.072-.389-.243-1.584 2.02-1.746 2.185-.057.057-2.253.098-2.596 3.392-.697 6.682-1.23 9.143-2.75 12.716l-1.04 2.44.888 2.452c1.007 2.786.954 2.989-1.023 3.896-1.251.574-4.815.714-6.35.249z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cg color='%23000' paint-order='markers stroke fill'%3e%3cpath fill='%23c27e50' d='M861.759 234.84c.386 1.289 1.803 6.827 1.803 8.501 0 1.674-1.16 7.212-1.16 8.887 0 1.674-2.317 10.947-2.317 10.947l6.182 1.03 2.575-6.053s1.03-5.538 1.03-6.31c0-.773.902-11.077.902-11.077l-.386-6.697z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23ab612e' d='m868.97 236.772-6.051.13c.386.773.128 1.803 1.287 3.22 1.16 1.416 2.318 2.833 2.833 3.348.515.516.773 1.417.773 2.963 0 1.545.128 2.704.128 4.636s-1.158 5.795-1.415 6.826c-.258 1.03-2.062 5.794-2.062 5.794s1.388-.578 2.124-.234l2.256-5.303s1.03-5.539 1.03-6.312c0-.772.902-11.075.902-11.075l-.175-3.022z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath d='m860.154 263.257-4.007 4.372c.139.438.724 1.29.981 1.677.09.135 2.077-2.448 2.18-2.321.16.195-1.94 2.658-1.748 2.833 1.364 1.232 3.556 1.914 6.51 1.545 2.362-.446 3.284-.863 4.099-2.277l-1.867-4.918z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23a1a1a1' d='M861.534 264.735c-.161.29-3.185 4.647-3.097 4.74 2.223 2.39 8.304 2.027 8.441.075-3.183.462-5.246 1.2-7.212-1.24z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3c/g%3e%3cpath fill='%23acacac' d='M850.433 236.05c1.276.639 3.617 5.32 3.617 5.32s1.277 2.34 2.34 2.553c1.064.213 0-1.064 2.34.639 2.341 1.702 5.32 2.978 5.32 2.978l4.256-.212s4.255-.851 5.106-1.277c.852-.426 1.277.213 1.915-2.128.639-2.34 1.49-2.766 1.703-5.958.212-3.191.212-8.723.212-8.723l-.85-3.617h-5.746l-7.66.425-5.532-.425-2.553 3.617z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cg fill='%23e2c773' stroke='%23000' stroke-linejoin='round' stroke-width='.25' color='%23000' paint-order='markers stroke fill' style='marker:none'%3e%3cpath fill='%23d7b5a0' stroke='%237d5035' stroke-width='.422' d='M849.357 154.702s-1.658-2.448-1.974-2.921c-.316-.474-1.5-2.527-2.685-4.502-1.185-1.974-1.176-2.756-2.212-3.79-1.184-1.184-2.745-2.025-4.343-2.528-2.444-.768-5.1-.737-7.66-.631-1.44.06-2.891.272-4.264.71-2.175.696-5.606 2.606-6.159 3.001-.553.395-3.712 3.554-3.712 3.554s-1.658 1.58-2.132 2.132c-.474.553-2.527 2.448-3.238 3-.71.553-2.843 3.397-3.317 3.791-.474.395-.71.711-1.343 1.343-.631.632-1.026 1.421-1.263 1.737-.236.316-.79 1.264-.79 1.264s0 1.342.237 2.053c.162.764-.063 2.574.553 3.632.32.552 1.5 1.185 1.5 1.185 3.847.1 7.544.573 7.266-1.895-.76 1.834-4.276 3.665-7.266 1.888l-.315 1.35c.12.605.097 1.253.868 1.658 2.119 1.041 3.82 1.145 5.528 1.263l4.896-.71c1.638-.185 6.265-.21 8.466 2.234 1.558 1.75 4.628 7.603 3.98 9.755l20.977-.559-.106-16.064-.426-8.511z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23d0a386' stroke='none' d='M820.463 144.038c-.575.562-.739.824-1.772 1.608-1.033.785-1.95 1.699-3.793 3.726-1.843 2.026-3.638 2.828-2.077 3.596 1.561.77.979 1.29 1.382 1.887.402.596.209 1.804.938 3.656.73 1.851 4.333 2.128 4.333 2.128s2.837.601 3.03-.398c.194-.999-.876-2.968 1.039-3.219 1.914-.25 2.58 1.122 3.849-.343 1.268-1.464.732-4.314 2.222-5.321 1.49-1.007 1.885-1.708 1.885-1.708s-2.989.717-3.966.683c-.978-.034-3.879-1.114-4.164-2.05-.285-.936-.874-4.912-.874-4.912z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23000' stroke-width='.158' d='m804.423 162.678 1.027-1.342c.733-.009 1.052.274 1.264.631.386.19.77.35 1.105-.078l-.079-1.264c.545.382 1.028.778 1.105 1.264-.226.617-.508 1.216-1.973 1.421-.738.19-1.572.95-2.152 1.876-.11-.995-.081-1.882-.297-2.508z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23dec7b7' stroke='none' d='M812.658 151.787c1.259.948 2.013.764 2.137 2.674.124 1.91-.386 1.692-.039 2.177.347.486 1.847 1.49 2.137 2.674.289 1.185.34 1.857.174 2.582-.165.725-.357 1.343-.252 1.773.106.431.582 1.912.582 1.912s-1.235-.383-1.632-1.541c-.397-1.158-.423-.462-2.112-1.305-8.182 11.42-3.695-3.781-4.069-4.375-.373-.593-2.304-1.491-2.304-1.491 1.808-1.78 3.777-4.47 5.378-5.08z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23d0a386' stroke='none' d='M834.069 155.376c-.387.644-.902 1.932-2.061 2.576-1.16.644-3.606 1.16-4.637 1.16-1.03 0-1.931-1.16-2.575.128-.644 1.288-1.03 1.803-1.417 2.962-.386 1.16-2.447 1.16-2.576 1.932-.129.773-.773 1.16-.901 2.705a28.049 28.049 0 0 1-.387 2.833s1.03-2.576 2.318-2.704c1.288-.13 1.417 0 3.091-.13 1.675-.128 2.963-.257 3.864-1.416.902-1.16 2.705-2.19 4.122-2.318 1.416-.129 2.704-.387 3.348-2.06.644-1.675 1.16-1.675.644-2.963-.515-1.288-2.833-2.705-2.833-2.705zm-8.157-9.598c1.64 0 1.549-.182 2.368 0 .82.182 1.366.637 1.822 1.275.455.637.182 1.184 1.275 1.275 1.092.09 1.82.546 1.82.546s.365.91.73.82c.364-.091.455-1.822.455-2.641 0-.82-.82-2.368-.82-2.368l-1.64-.91s-.594-.243-1.687-.516-1.226.242-1.773.242c-.546 0-.82-.273-1.457.455-.637.729-1.184 1.457-1.184 1.457z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3c/g%3e%3cpath fill='%23662900' d='M823.681 149.512s.73-1.056 1.184-1.503c.34-.334.679-.74 1.138-.865.752-.205 1.612-.047 2.323.273.52.234.91.364 1.275 1.138.364.774.09.729.592 1.048.5.318.637.455.637.455s-.319.182-1.002.546c-.683.365-1.154.675-1.776.911-.454.173-.927.408-1.411.364-.616-.055-1.118-.527-1.685-.774-.256-.111-.774-.318-.774-.318s-.364.09-.592.5c-.228.41-.455.547-.683 1.093a27.974 27.974 0 0 1-.637 1.366l-.274.41s-.182-.683-.182-1.047c0-.364.046-.82.137-1.366.09-.547.728-1.457.728-1.457z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cg color='%23000' paint-order='markers stroke fill'%3e%3cpath fill='%23c27e50' d='M874.38 240.636c0 2.061.644 6.182.773 9.016.129 2.833.129 4.508.129 6.31v4.219l-.612 3.284 6.15-.033s-.495-1.306-.31-2.982c.301-2.725.696-6.425.696-7.063 0-1.03-.386-8.243-.386-8.243l-1.16-4.121z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23ab612e' d='M874.896 243.985s-.13 3.864.386 5.152c.515 1.288 3.477.644 4.121 2.704.644 2.061 1.288 4.38 1.288 4.38l.36-2.448.8-2.511.772-4.186-2.125-12.235s-7.405 0-7.405.773c0 .772 1.803 8.371 1.803 8.371z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath d='m874.628 263.32-3.484 4.798c.187.42.865 1.2 1.165 1.556.104.123 1.786-2.67 1.903-2.555.18.175-1.627 2.862-1.415 3.014 1.495 1.069 3.75 1.497 6.644.793 2.295-.71 3.163-1.23 3.812-2.728l-2.414-4.673z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23a1a1a1' d='M876.166 264.63c-.127.307-2.635 4.98-2.537 5.063 2.48 2.12 8.48 1.068 8.395-.887-3.11.821-5.075 1.788-7.306-.412z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3c/g%3e%3cg color='%23000' paint-order='markers stroke fill'%3e%3cpath fill='%23c27e50' d='M943.21 225.555c.91 4.917 2.368 10.2 4.007 12.932 1.64 2.732 4.553 9.653 4.553 9.653s-1.457 5.282-1.457 6.557c0 1.275-1.639 7.559-1.639 7.559l6.01-.638s2.915-4.189 3.461-6.739c.547-2.55 2.915-6.01 2.915-7.103s-1.64-4.918-1.64-4.918-.364-7.468-.364-8.743c0-1.275.182-9.107.182-9.107z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23ab612e' d='m959.24 225.008-12.194.417c1.264 2.869 2.343 5.027 4.178 7.779 2.185 3.278.911 2.187 3.097 6.558 2.185 4.371 1.457 4.917 3.097 6.92 1.639 2.004 2.001 3.644 2.001 3.644s.766-.88 1.567-2.181c.035-.134.073-.272.073-.37 0-1.093-1.64-4.916-1.64-4.916s-.362-7.47-.362-8.744c0-1.275.182-9.107.182-9.107z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath d='m949.633 263.374-1.068 4.437c1.693 1.652 4.876.696 7.985-.128l-1.803-6.054-6.182.516-2.319 5.409c1.248.522 2.262.83 2.069.031z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%238a8a8a' d='M954.36 262.917c.129.322 1.481 4.25 1.481 4.25-2.198.818-4.324 1.273-6.182.387l5.023-1.03z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3c/g%3e%3cpath fill='%23acacac' d='M937.441 228.14c1.277.639 3.617 5.32 3.617 5.32s1.277 2.34 2.34 2.553c1.065.213 0-1.064 2.341.639 2.34 1.702 5.32 2.979 5.32 2.979l4.255-.213s4.256-.851 5.107-1.277c.85-.425 1.276.213 1.915-2.128.638-2.34 1.49-2.766 1.702-5.957.213-3.192.213-8.724.213-8.724l-.851-3.617h-5.745l-7.66.425-5.532-.425-2.554 3.617z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cg color='%23000' paint-order='markers stroke fill'%3e%3cpath fill='%23c27e50' d='M965.18 230.029c1.288 3.735 5.308 7.608 6.08 9.024.773 1.417.142.691 2.548 3.902.129 4.121 1.416 7.598.901 9.401-.515 1.804-1.674 6.955-1.674 6.955l5.667-.515s1.288-2.318 2.06-3.477c.773-1.16 1.932-3.993 1.932-3.993s-.128-5.28-.128-5.924c0-.644-1.546-7.985-1.546-7.985l-3.477-5.152-2.834-2.962z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23ab612e' d='M966.982 228.401c1.159 2.447 4.557 7.197 6.746 7.97 2.19.772 2.27 2.205 2.27 2.205s.643 1.159.514 3.477c-.128 2.318-1.288 3.349.516 5.41 1.803 2.06 3.734 2.575 3.734 2.575l1.817.979.433-6.805-1.348-4.22-.644-3.992-.745-5.987-5.695-3.415z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath d='m974.039 260.152-1.068 4.438c1.693 1.65 4.876.695 7.985-.129l-1.803-6.053-6.182.515-2.319 5.41c1.248.521 2.262.83 2.069.03z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%238a8a8a' d='M978.766 259.696c.129.322 1.481 4.25 1.481 4.25-2.198.817-4.324 1.273-6.182.386l5.023-1.03z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3c/g%3e%3cpath fill='%23c9c9c9' stroke='%23b3b3b3' stroke-linejoin='round' stroke-width='.158' d='M820.59 143.702c1.193-1.948 2.116-2.089 3.205-3.101.706-.657 2.158-1.93 2.158-1.93s-.122-2 .502-2.645c1.017-1.054 4.285-.972 4.285-.972s.023-1.586.608-1.9c1.017-.546 3.329.943 3.329.943s.59-1.448 1.246-1.688c1.139-.418 3.541.837 3.541.837s1.641-.92 2.524-.837c1.223.115 1.838 1.369 3.221 1.794 1.383.426 2.7.554 3.907 1.185.652.34 1.732 1.369 1.732 1.369s2.012.53 2.949.971c.958.45 2.69 1.688 2.69 1.688s1.225.506 1.778.865c1.333.867 3.648 3.072 3.648 3.072s2.278 1.016 3.374 1.61c1.07.58 3.115 1.9 3.115 1.9s2.193 1.767 3.268 2.674c.945.797 2.797 2.433 2.797 2.433s1.822.738 2.414 1.472c.47.583.324 1.86.738 2.124s1.962.526 2.797 1.073c.862.564 2.168 2.2 2.168 2.2 13.929 1.834 28.3 2.343 43.257 1.09 0 0 17.094-2.912 25.728-3.009 5.34-.06 10.936-.335 15.949 1.505 5.512 2.023 14.444 10.08 14.444 10.08l4.514 8.125 3.009 9.329c2.515 8.505-.597 15.54-2.106 9.328-.805.831-3.282-8.091-3.16-8.275l-.903-4.965 1.655 9.404 1.204 5.34-.752 3.16-.753-1.955.753 4.212 2.858 4.966v2.256l-.451.602-.15 6.77-2.86.904c.812 2.209 1.378 4.356.603 6.168l-1.806 3.612-3.46 2.106c-.014 1.54.594 3.159-.903 4.514-1.241.295-2.304 1.575-3.912-.15 0 0-1.434 1.62-2.407 1.654-.989.035-2.558-1.504-2.558-1.504l-2.859.451-3.761-1.956-3.01 1.354h-1.956l-4.664-3.31s-4.062-.903-4.514 0c-.451.903-2.407 1.354-2.407 1.354l-3.761-1.203-3.611 1.053-1.655 1.204-3.01 2.106-2.708-.301s-3.31-.451-3.61.451c-.302.903-.773 2.834-1.957 3.01-1.232.182-2.859-2.408-2.859-2.408s-.777 1.515-1.504 1.806c-1.219.487-3.912-.452-3.912-.452s-1.445 1.505-2.407 1.655c-1.035.162-3.01-.902-3.01-.902s-1.486.713-2.256.601c-1.048-.151-2.709-1.655-2.709-1.655s-1.965.82-3.009.903c-1.513.12-4.514-.602-4.514-.602s-1.342.627-2.051.584c-1.399-.085-2.553-1.428-3.874-1.63-.855-.13-1.471 1.252-1.885 1.252-1.053 0-1.953-.576-1.953-.576l-.615-1.472-1.122-.35-.687.387c1.015 1.321-.38.89-.752 1.204l.602 2.256c-.223.839.423 1.75-1.956 2.408 0 0-1.956-.753-2.107 0-.15.752-.902 1.655-.902 1.655s-2.619.038-2.408.602c.432 1.153.945 2.307 0 3.46 0 0-2.062.757-3.088.552-.92-.184-2.366-1.52-2.366-1.52l-1.015-2.793s-3.105-.115-4.364-.903c-1.394-.873-3.009-3.912-3.009-3.912h-2.859s-4.062-.15-4.664-.15c-.602 0-7.69.238-11.134-1.204-2.63-1.102-6.62-5.417-6.62-5.417s-3.164-2.958-4.213-4.814c-.647-1.146-1.204-3.762-1.204-3.762l-1.805-2.858s-1.866-2.247-2.257-3.611c-.18-.627 0-1.956 0-1.956l-.451-6.922s-1.043-2.663-1.054-4.062c-.014-1.91 1.355-5.567 1.355-5.567l.451-3.761-.602-3.762s.316-1.863 0-2.708c-.535-1.432-2.21-2.158-3.009-3.46-.594-.97-1.08-2.042-1.279-3.16-.185-1.041.28-2.127.105-3.17-.242-1.435-1.566-4.076-1.566-4.076l.634-1.33s4.363-4.364 5.717-4.364c1.354 0 4.136.703 5.785-.3 2.036-1.24 3.757-3.791 3.611-6.17-.146-2.392-3.462-3.495-4.363-5.717-1.025-2.527-.97-8.125-.97-8.125l-1.355-3.31-1.956-2.257-5.567-1.053z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23acacac' d='M836 204.832c3.607.515 4.895.773 7.857-.128 2.962-.902 5.795-2.19 5.795-2.19s-1.674 2.576-3.09 3.349c-1.417.772-3.736 2.19-3.607 2.704.13.515.258.13 2.319-.644 2.06-.772 6.053-2.833 2.962.773-3.091 3.606-4.508 4.121-4.766 4.894-.257.773-1.674 2.705-1.545 3.864.129 1.159 5.023-.644 5.023-.644s-2.06 1.545-4.122 3.606c-2.06 2.06-3.09 2.962-3.09 2.962s-2.319-1.288-2.448-5.924c-.128-4.637-1.545-9.66-1.803-10.69-.257-1.03 0-2.318 0-2.318z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23959595' d='M839.06 220.893c-.387.103-.087-.61-1.591-.61-1.325 0-2.192-.1-3.007-.282.035.043.2.263.2.263l1.808 2.859s.556 2.615 1.203 3.761c1.05 1.857 4.213 4.815 4.213 4.815s3.99 4.314 6.62 5.416c3.443 1.442 10.532 1.204 11.134 1.204.542 0 3.55.112 4.205.136a26.335 26.335 0 0 1-.799-1.923c-1.805-4.814-2.407-3.31-3.61-4.514-1.204-1.203-1.205-.601-3.31-3.61-2.107-3.01-6.32-1.505-6.32-1.505s-3.31-.301-5.416-2.106c-2.107-1.806-.782-.487-2.587-2.594-.677-.79-2.638 2.853-2.742-1.31z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e5e5e5' d='M836.264 134.295s-1.433 2.345-1.954 2.997c-.522.652-2.608.784-3.13.784l-2.997 1.694 4.562.13 3.78 3.519 3.26 6.126-1.435-6.256 5.475 1.435s.131 3.518-.13 4.17c-.26.652-2.086 4.042-2.607 5.346-.522 1.303 4.562 5.083 4.562 5.083v-4.04l6.388-4.043 4.824-3.649 3.519 2.738s3.519 5.475 3.519 6.127c0 .19-.32.839-.75 1.63-3.236 2.792-5.698 6.56-7.785 10.298-1.477 5.585-10.634 1.604-4.485-2.303 1.493-2.004 3.807-4.698 5.74-7.16-3.411 1.54-8.617.93-11.73 2.902-4.233 3.504-11.596 8.968-14.967 10.085 1.461.078 2.984-.198 4.402.237 6.773-1.167 2.4 4.927-2.002 3.995-6.46-.198 1.094 2.89 3.811 2.052 3.734-.43 11.923-.052 6.014 4.355 6.877 3.124 12.64-2.238 18.128-5.398 1.818 1.79-5.618 6.888-7.756 9.108-3.534 4.677-8.504 4.302-13.431 4.205-2.548 2.142 3.28 1.356 4.756 1.478.217 3.918-14.752 2.284-8.664 8.245 6.083.483 12.413.952 18.317-.97 4.663-1.639.622 2.113-.609 3.468 1.981 3.07 8.161-2.203 11.682-2.49 2.381 5.2-7.209 5.635-10.344 8.604 3.164.437 13.713.443 17.386-5.076 4.425-3.838 6.04 2.353 2.43 4.787-4.413 3.545-10.154 7.35-15.559 7.666-7.07-4.732-6.015 3.748-11.089 6.808 8.194 1.366.642 3.259 4.064 4.604 6.58 1.55 10.432-6.348 16.438-2.158 5.33 4.252 1.247-9.583 5.595-6.783-1.697-6.376 6.6-4.366 6.878.481.678 4.4 3.59 3.238 2.887-.681.325-3.332-.122-6.476-2.595-8.981-1.968-5.89 8.102-3.73 6.451 1.794 2.297 8.673.661-9.632 4.153-5.977 3.513 4.356 1.39 12.648 6.565 15.3 4.076-1.824 8.396 5.001 10.726 2.336 4.403-4.841.533-12.37 1.073-18.3 3.192-3.209 4.394 3.544 3.3 6.172.204 4.576-.43 9.278.361 13.768 1.895-.907 3.573-6.806 4.148-9.913.323-4.094-2.308-11.296 4.504-10.137-.357 4.797 1.6 7.637 5.261 10.21 4.55 5.189-1.61-8.225 4.13-4.712 1.278 1.563 5.182 13.223 4.884 7.377 1.366-5.994-1.025-11.468-1.158-17.347 2.961-1.336 5.941 5.987 6.439 9.276 2.072-.073-3.303-10.276-1.737-10.082 5.67 2.525 8.607 8.205 10.429 13.895 2.633 6.938-.393-3.767-.826-6.26 2.992 5.338 6.032 10.713 8.262 16.495.258-3.909-.41-7.731-1.405-11.5-1.59-8.34 4.15-.397 5.822 2.88 3.964 4.206 5.411 9.656 7.672 14.804.826 4.354 1.643.2 3.192-1.243 4.589-5.252-1.157-11.505-1.168-17.464 1.47-6.081 3.213 4.112 3.673 6.13 2.216.551 3.852 11.384 4.018 6.95.095-1.272.143-1.814.187-2.297.142-2.726.238-5.455.17-8.195 8.826 7.79 5.35-12.778-1.253-24.17-2.169-5.249 2.313.061 2.543 2.593 5.081 1.483-1.367-9.947 3.287-7.96 2.21 6.906.573-3.623.013-5.785-4.5-4.54-8.7-11.683-15.857-12.478.349.332.644.674.943 1.01.06.237.544.777 1.15 1.403-.022-.03-.107-.157-.136-.197.062.083.168.213.21.27 1.942 1.996 5.669 5.369 6.62 7.579 1.968 7.35-6.29-1.816-7.963-1.118 2.99 5.894-2.363 1.946-4.582.087-3.56-4.008-5.279-10.425-11.148-11.694-2.127 1.91 5.375 5.95 6.915 8.72 1.733 1.468 6.489 10.13 3.504 8.906-.775-.468-1.145-.73-1.505-.983-3.393-1.735-8.958-5.159-11.075-9.002-4.544-5.36-1.921 1.502 1.29 3.267.294 2.653 5.013 12.942-.374 10.21-5.657-4.298-7.21-11.33-11.405-16.656-1.431.981 1.873 8.601 1.25 12.288 1.124 6.809-2.884 1.64-4.494-1.522-4.006-1.886-2.09-10.698-5.26-10.604-1.551 4.72-1.689.911-3.003-1.57-1.852 3.883-.828 8.221-1.185 12.341.433 7.564-3.58-1.12-4.52-4.073.493-4.57-1.756-4.21-2.453-.122-.415 8.6-5.6-.693-5.34-4.31 2.268-5.032-6.856-8.432-6.406-2.727 2.132 4.817 3.573 12.313.372 17.349.871-6.59-6.262-10.95-5.171-17.801-1.588-5.252-3.394-.483-3.843 2.483.391 5.811-1.59 9.486-5.186 13.723-3.328 5.438-2.562-1.647-3.352-4.193-2.06-9.028-.867 4.11-2.917 6.636-2.67-3.211-2.851-10.525-2.708-15.442 1.897-5.99-2.063.775-2.428 1.54-.12.195-.182.27-.312.486-3.43 7.654-2.946-1.994-3.384-5.543-.157-4.491-.755-.766-.98 1.213-.022.166-.033.205-.055.39-.705 2.33-.426 14.092-3.601 7.965-1.516-1.556-1.215-11.893-2.012-6.927-.126 7.853-5.116-2.242-3.102-5.708.106-6.093-.141 1.31-1.138 3.112-2.77-3.663-1.913-7.666-.75-11.784-.856.302-1.669.673-2.444 1.093-.047-.5-.105-1.053-.165-1.35-.13-.651-.391-1.172-.521-2.997s.391-2.086.391-2.086-2.345-.262-2.867-.784c-.521-.521-1.305 0-4.043-.651-2.737-.652-6.517-3.911-7.95-5.475-1.434-1.565-1.305-1.955-2.087-2.868-.782-.912-1.435 2.087-1.435 2.087s-2.866-.131-4.17-3.26c-1.303-3.128-1.302-1.435-1.302-1.435s-3 2.87-4.695.784c-1.694-2.086-1.435-3.389-1.435-3.389zm126.265 45.312a31.8 31.8 0 0 0 2.016.963c-1.92-1.42-3.526-2.029-2.016-.963zm8.157-11.497c-.02-.022-.051-.051-.072-.073.197.263.217.273.072.073zm8.932 53.51c-.064 1.233-.119 2.466-.207 3.7.216-2.34.386-5.644.207-3.7zm-122.998-62.7c1.872-.845 3.212-2.328 3.351-5.26-.277 1.156-1.672 3.122-3.351 5.26z'/%3e%3cpath fill='%232c1c12' d='M843.479 157.145c-.404-1.793-.897-3.56.109-5.776.563-1.843 3.2-3.361 5.34-3.705 3.295-.529 8.407.112 9.6 2.848.798 1.828 1.23 4.251-2.401 5.414-2.7.993-5.3 4.293-8.29 4.706-1.238-1.188-1.65-2.527-4.358-3.487z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23d6b39d' d='M843.294 156.864c-.393-1.75-.875-3.475.107-5.638.55-1.8 3.124-3.283 5.213-3.618 3.218-.516 8.208.109 9.373 2.78.778 1.786 1.201 4.151-2.344 5.286-2.636.97-5.174 4.192-8.093 4.595-1.209-1.16-1.612-2.468-4.256-3.405z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23181818' stroke='%236f3f1e' stroke-linejoin='round' stroke-width='.158' d='M845.9 155.481c1.255-.465 1.65 1.262 1.597 1.756 2.83-2.342 6.04-4.809 7.128-4.374.467-2.892-8.278-4.118-8.724 2.618z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cg paint-order='markers stroke fill'%3e%3cpath fill-rule='evenodd' stroke='%23000' stroke-linejoin='round' stroke-width='.158' d='M826.927 147.576c-.92.001-1.74.483-2.045 1.201l-.067.221s-.128.302-.296.428c-.166.125-.63.377-.893.629-.413.393-.793.843-1.048 1.352-.21.415-.377 1.341-.377 1.341s.413-.92.683-1.341c.256-.4.53-.796.882-1.116.242-.22.823-.531.823-.531l.307.322-.213-.745c.159 1.339 1.34 1.83 2.244 1.83 1.2 0 2.172-.802 2.174-1.793 0-.993-.973-1.798-2.173-1.798z' style='marker:none'/%3e%3cpath fill='%23794d2f' d='M826.93 147.575a2.172 1.797 0 0 0-1.883.904l-.097.157v.001a1.579 1.579 0 0 0-.155.415c1.009.296 3.11.281 4.281.058a1.524 1.524 0 0 0-.047-.192 2.172 1.797 0 0 0-.001-.006v-.001a1.586 1.586 0 0 0-.074-.19c0-.001 0-.002-.002-.002-.033-.062-.067-.12-.1-.181a2.172 1.797 0 0 0-1.922-.963z' color='%23000' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath stroke='%23000' stroke-linejoin='round' stroke-width='.158' d='m825.803 149.454.098.348 1.927-.014s.32-.39.265-.348c-.056.041-2.29.013-2.29.013z' color='%23000' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e6c74d' stroke='%23e6e600' stroke-linejoin='round' stroke-width='.001' d='M826.742 151.077a2.424 2.424 0 0 1-1.251-.454 1.951 1.951 0 0 1-.506-.587 9.823 9.823 0 0 1-.225-.748c0-.006.017-.038.037-.073l.039-.064.085.02c.216.056.596.113.95.144a15.192 15.192 0 0 0 2.506-.023c.174-.017.556-.068.609-.082.025-.006.025-.006.025.15 0 .256-.046.453-.162.677-.349.68-1.214 1.108-2.107 1.04zm1.118-1.214a.933.933 0 0 0 .143-.157c.172-.217.171-.215.16-.279-.01-.05-.012-.053-.055-.06a46.704 46.704 0 0 1-1.415.008l-.977-.006v.048c.001.07.11.436.135.455.018.013.18.015 1 .008.605-.005.991-.012 1.009-.018z' color='%23000' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3c/g%3e%3cpath fill='%23d4d4d4' d='M811.227 171.794c-1.46-.16-2.718-.487-3.844-1.001-.702-.32-.934-.605-1.069-1.313-.056-.296-.044-.46.07-.978l.138-.623.52.15c.791.23 1.639.311 2.316.223.654-.086 1.131-.216 1.117-.304-.006-.034-.03-.057-.054-.05-.657.17-1.224.23-1.833.196-1.223-.068-2.096-.374-2.966-1.042-.503-.385-.733-.748-.874-1.381-.079-.351-.077-.36.131-.667.308-.454 1.084-1.197 1.462-1.4a3.56 3.56 0 0 1 .79-.271c.845-.177 1.426-.596 1.663-1.2.128-.327.056-.572-.278-.952-.295-.335-.811-.719-.896-.666-.03.018-.041.336-.025.706l.03.673-.176.08c-.246.112-.652-.016-.826-.26-.185-.26-.608-.459-.994-.468l-.324-.008-.354.456c-.195.251-.395.513-.443.583-.05.07-.105.11-.125.09-.02-.02-.054-.37-.076-.778l-.04-.743.26-.423c.975-1.591 1.404-2.158 2.448-3.232 1.197-1.23 1.067-1.176 1.892-.796.5.231.831.563.945.948.04.135.119.538.176.897.057.358.172.801.256.984.225.492 1.19 1.442 1.733 1.705.497.242 1.252.407 1.86.407.275 0 .52.04.672.112.318.15 2.138 1.998 2.404 2.44.245.408.615 1.787.735 2.739.12.95.053 3.544-.105 4.124l-.124.454-2.346.342c-2.529.368-2.667.377-3.846.247z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23c99472' d='M843.857 153.96s1.569-3.961 3.307-4.873c2.262-1.186 5.402-1.126 7.662.063.727.383 1.412 2.02 1.412 2.02s-1.705-.917-2.636-.925c-2.709-.023-4.34-.091-6.268.752-1.395.61-3.477 2.963-3.477 2.963z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23acacac' d='M830.849 181.392c3.606.258 6.182 0 7.212 0 1.03 0-.773-.257 1.288 1.803 2.06 2.061 0 1.546 2.834 2.319 2.833.772 8.757.257 8.757.257s-2.575 2.06-4.379 2.06c-1.803 0-6.954-.514-8.5 0-1.545.516-3.348 2.577-3.348 2.577l.772 2.575h-2.06l.772-5.409-2.318-3.606zm39.668-27.819s1.03 2.318 1.03 4.122c0 1.803.773 2.575.773 2.575l.515 1.803 2.576.258 1.803 4.121s0-6.182 2.06-5.151c2.061 1.03 1.804-1.546 2.834 1.288 1.03 2.833 2.06 5.409 2.06 5.409s-1.545-2.576 1.546-2.834c3.091-.257 4.637-1.03 4.894.516.258 1.545 0 1.803-.257 3.606-.258 1.803-1.03 4.379-.258 3.09.773-1.287.258-2.833 1.546-2.317 1.287.515.772-1.546 2.06 2.318s1.288 4.379 1.288 4.379.515-.258 1.03-4.637c.516-4.379-1.287-4.894.516-6.697s2.759-4.43 5.335-3.142c2.576 1.288 2.392-1.494 3.68 4.43 1.288 5.924 2.318 7.727 2.318 7.727s0-1.803-.257-6.182c-.258-4.378-.515-5.666-.515-5.666l-4.38-1.546s-6.954 1.03-7.984 1.03c-1.03 0-4.38 0-6.182-.772-1.804-.773-11.077-3.091-11.077-3.091l-5.924-3.349zm43.016 8.5c9.273 0 9.788-.515 15.455-.515s7.985-2.06 11.076-2.318 4.894-.258 9.273-.258c4.38 0 4.122-2.318 11.592-.257 7.47 2.06 8.242 2.576 9.53 3.09 1.288.516 6.182 3.607 6.182 3.607l5.925 5.924s-5.667-4.894-7.213-5.924c-1.545-1.03-8.5-2.576-8.5-2.576s-1.546-.257-1.546 1.546 2.834 4.636 2.834 4.636l5.152 3.091 1.803 3.606-4.637-4.121s-2.833-1.03-3.09.258c-.258 1.288.772 3.348.772 3.348s-2.834-3.09-4.121-5.667c-1.288-2.575-2.061-4.379-3.607-5.409-1.545-1.03-4.894-2.318-4.894-2.318s-6.697-2.06-5.667 0c1.03 2.06.773 1.03 2.061 3.606 1.288 2.576 2.318 1.803 5.41 6.44 3.09 4.636 3.863 5.409 1.545 3.09-2.318-2.318-2.834-2.833-4.38-5.151-1.545-2.318-2.832-3.864-4.636-4.121-1.803-.258-2.318-1.803-2.318.257s-1.545.773 0 3.349c1.546 2.576 1.288 2.318 2.06 5.151.774 2.834 3.35 7.47 3.35 7.47s-2.319-1.03-3.092-3.09c-.772-2.061-3.348-4.895-3.863-7.47-.515-2.576-2.576-5.41-2.576-5.41l-3.349-.515s-.772 1.03-.772 2.318-.516-1.03-.516 2.319c0 3.348.258 2.06.773 6.182.515 4.12 0 1.287-1.03-.516s-1.803-3.863-2.576-6.697c-.773-2.833-1.546-4.636-1.546-4.636l-2.06 2.06-1.546-2.318s-2.576-.515-2.576.515-1.287 3.606-1.287 5.925v7.47s-1.288-3.864-1.288-5.41c0-1.545-1.546-6.182-2.061-5.151-.515 1.03-3.606 1.03-3.606 2.318v3.09s1.545 0-1.03-4.893c-2.576-4.894-5.41-5.925-5.41-5.925z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23c9c9c9' d='M902.775 183.116c0 2.186-1.093 4.007-1.275 7.468-.182 3.46-.91 4.553-.182 9.29.728 4.735 2.914 12.385 2.914 14.388 0 2.004.182 7.286.547 0 .364-7.286-1.64-11.293-1.64-12.568 0-1.275-.364-4.189-.364-8.378 0-4.19.546-7.286.546-7.286l-.546-3.824zm11.657-4.917c.546 3.824.546 2.732-.182 8.196-.729 5.464-1.093 7.65-.91 9.107.181 1.457 1.092 7.285 1.456 10.017.364 2.732-.182 6.193.182 3.643.365-2.55-.364-9.289-.364-12.75 0-3.46-.364-3.825 0-7.285s.364-6.74.364-6.74zm9.653 5.281c0 2.55-.364 8.197-.364 11.111 0 2.914.729 7.286 1.64 10.564.91 3.279 1.274 6.74 1.274 6.74s2.55-2.55 0-7.468-2.003-10.929-2.003-12.75c0-1.822-.547-8.196-.547-8.196zm8.743-7.831c0 2.185-.546 4.007.364 7.467s1.275 2.55.729 5.464c-.547 2.915-.91 2.915-.91 5.465s.181 4.189.181 4.189-.182-4.554.547-5.829c.728-1.275 1.275-5.1 1.275-6.375 0-1.274-.911-2.367-1.093-3.46-.182-1.093-.91-3.825-.91-3.825zm12.932 6.557c0 2.003-1.093 4.37-.729 8.196.365 3.825-1.093 3.46 1.457 6.921 2.55 3.46 2.368 4.007 4.007 6.74 1.64 2.731 3.097 8.196 3.097 8.196s-1.275-8.561-1.822-9.29c-.546-.728-3.642-6.01-3.824-7.103-.183-1.093-1.458-2.368-1.822-4.007-.364-1.64-.364-9.653-.364-9.653zm12.021 1.457c1.457 3.096.91 2.003 1.821 6.921.911 4.918-.182 4.007 1.093 8.014s2.004 6.01 3.097 8.378c1.092 2.368.91 2.368 2.732 5.647 1.821 3.278 2.732 6.01 3.096 7.65.364 1.639 1.093-.911.364-3.097-.728-2.185-1.821-4.371-2.732-7.65-.91-3.278-2.732-5.646-3.278-7.65-.547-2.003-2.368-4.37-2.368-5.646 0-1.275-1.275-7.832-1.275-7.832l-1.093-2.732zm-73.038-6.011c0 2.186-1.821 5.829-1.639 8.56.182 2.733 1.64 8.925 1.821 9.654.183.729 1.093 3.096 1.458 6.193.364 3.096.364 5.464.91 3.096.547-2.368.182-9.289-.728-12.021-.911-2.732-2.004-3.279-2.004-5.646v-4.554c0-1.093.182-5.282.182-5.282zm-34.424-1.639c2.914-.182 4.918-.91 7.832-2.55 2.914-1.64 5.464-5.464 6.01-6.193.547-.728 1.64-6.01 1.64-4.735 0 1.275.364 4.007-1.457 6.739-1.822 2.732 1.275 1.821-3.279 3.825-4.553 2.003-1.821 1.457-4.918 2.185-3.096.729-5.828.729-5.828.729zm-.911 16.574c2.368-1.092 7.65-1.639 9.471-4.553 1.822-2.914.183-3.096 2.915-5.1 2.732-2.003 1.821-.91 4.553-3.825 2.732-2.914 3.46-5.1 3.46-5.1l-2.913 6.193s-2.004-.364-3.279 3.096c-1.275 3.461-.546 3.097-1.821 4.736-1.275 1.64 3.278.182-2.186 2.186-5.464 2.003-7.65 1.821-7.65 1.821zm13.114 4.918c2.004-.364 4.007-1.639 5.829-4.735 1.821-3.097 2.732-5.282 4.553-6.922 1.822-1.639 3.643-5.828 3.643-5.828s-.364 5.1-.91 5.828c-.547.729-3.461 1.275-3.643 2.55-.183 1.275.182 1.457-.729 3.097-.91 1.639-1.093 1.639-1.64 2.55-.546.91-2.367 2.367-2.367 2.367l-2.732.729zm104.184-13.842c.364 2.367 1.093 6.192 2.368 8.014 1.275 1.821 4.007 5.828 4.917 8.196.911 2.368 3.097 10.2 3.097 10.2s.182-4.736-.182-6.01c-.365-1.276-1.457-4.008-1.822-5.465-.364-1.457-2.185-4.736-2.732-5.828-.546-1.093-2.368-2.732-2.55-3.825-.182-1.093-3.096-5.282-3.096-5.282zm4.189-3.643s1.275.364 2.186.91c.91.547 3.096.183 4.189 1.093 1.093.911 2.914 1.822 3.278 3.279l.547 2.186s-1.275-2.368-2.55-3.279c-1.275-.91-2.914-1.457-4.554-2.003a42.092 42.092 0 0 1-2.914-1.093z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23acacac' d='M858.312 229.808c2.368-.546 2.025 2.486 7.67 1.94 5.647-.547 9.108-2.733 9.836-4.008.729-1.275.729-7.103 1.458-6.557.728.547 1.275 4.736 2.55 5.282 1.274.547 1.82 2.186 3.642.547 1.822-1.64 2.732-2.186 2.915-3.825.182-1.64-.183-5.646.728-4.918.91.729 3.279 7.286 3.279 7.286s0-6.01 1.092-4.554c1.093 1.457 2.732 5.282 2.732 5.282s1.088-4.392 2.608-4.566c.847-.097 1.953 2.803 4.3 3.585 6.557 2.186 3.96.528 6.51 1.803s-.897-3.347 3.292-3.347c1.683 0 2.015 3.11 3.224 4.125 1.801 1.512 2.618-1.283 2.618-1.283s3.13-3.595 3.677-4.506c.546-.91-.729-8.378 1.274-4.007 2.004 4.371 4.825 5.692 4.825 5.692l1.937 1.308s2.71-1.718 3.438-1.536c.729.182 2.19.663 3.101.663.91 0 1.877-1.736 2.6-2.556l2.158-2.45s-.459-3.303 4.489-3.677c2.326-.375 3.316 6.927 5.138 7.292 1.821.364-2.523-8.093.574-5.726 3.096 2.368 2.704 5.726 4.89 7.183 8.367 13.36.953 1.8 1.78 2.796l3.106 2.589s1.704 4.97.26 5.68c-2.412 1.187-3.246-1.762-3.246-1.762s-4.814-5.296-7.547-5.478c-2.732-.183-4.553-2.368-9.653 0-5.1 2.367-3.096 1.457-7.468 3.096-4.37 1.64-5.1 2.55-8.378 2.368-3.278-.182-4.896.999-8.356.999s1.14-.788-5.518.386c-5.24.925-10.422 1.769-15.037 1.277-1.32-.14-2.593.743-3.808.095-1.198-3.219 1.524-3.326 1.391-4.943-3.754 1.127-4.223 1.266-6.01 2.365-2.733 3.642-.877 3.606-3.245 5.064-2.368 1.457-4.77 4.592-4.77 4.592s-.364.547-3.278-2.732c-2.914-3.278 1.86-.543-3.786-2-5.647-1.457-.727-1.89-5.28-2.437-.458.198-2.752-2.112-2.752-2.112z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23959595' d='M948.194 211.543s.01 3.067-.743 4.534c-.752 1.467-1.805 0-5.115.367-3.31.367-1.956 4.035-1.956 4.035l-2.708 3.667-1.204.734-6.018 1.711s-3.31 0-4.965-1.345c-1.655-1.344-1.505-.978-2.859-1.956s-3.009 1.712-3.46 2.445c-.452.734-2.558 2.812-4.965 3.057-2.408.244-2.107-2.934-3.01-4.035-.902-1.1-.3 1.834-1.203 3.18-.903 1.344-1.655.244-4.815-1.101s-3.46.367-3.46.367l-5.115-4.524s-.301 2.567-1.054 5.624c-.752 3.056-3.009 3.79-4.062 7.58-.171.616-.812.704-.953 1.138.12.06 1.4.724 2.375.724.414 0 1.03-1.122 1.886-1.016 1.321.164 2.473 1.255 3.872 1.324.71.035 2.052-.474 2.052-.474s3 .587 4.514.489c1.043-.068 3.009-.734 3.009-.734s1.66 1.222 2.708 1.345c.77.09 2.257-.489 2.257-.489s1.974.865 3.009.734c.962-.123 2.407-1.345 2.407-1.345s2.693.763 3.912.367c.727-.237 1.504-1.467 1.504-1.467s1.627 2.104 2.86 1.956c1.182-.143 1.654-1.712 1.955-2.445.3-.734 3.613-.367 3.613-.367l3.017-.321 2.7-1.146 1.656-.978s2.374-.87 3.61-.856c1.296.014 2.471 1.09 3.762.978.879-.077 1.545-.913 2.407-1.1 1.47-.32 3.06-.39 4.514 0 1.131.303 3.044 1.755 3.044 1.755-.027-.047 3.055.048 3.032.005-1.01-.352-6.072-2.204-6.72-6.48-1.054-3.912-.847-2.04-2.653-5.585-1.805-3.545-2.637-10.351-2.637-10.351zm-75.617 21.366c1.803 0 4.25-.773 4.508-1.288s.129-1.803.644-1.674.386 1.932 1.417 2.06c1.03.13 4.765-2.447 3.606-.901-1.16 1.545-3.864 1.803-3.993 3.348-.128 1.546-.901 2.19-.901 2.19s-.902-1.803-1.546-2.06c-.644-.258-3.735-1.675-3.735-1.675z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath d='M808.633 168.28a6.193 6.193 0 0 1-1.228-.16 3.086 3.086 0 0 1-.544-.229 3.554 3.554 0 0 1-.271-.15c-.004-.004.03-.004.112-.001a.468.468 0 0 1 .152.017c.136.054.353.122.539.169a6.36 6.36 0 0 0 1.101.166c.165.013.692.011.847-.003.332-.03.632-.08.947-.156a1.83 1.83 0 0 1 .143-.031c.017 0 .041.027.041.047 0 .071-.303.169-.777.249a4.731 4.731 0 0 1-1.062.082z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23959595' d='M988.258 207.132c-.676.426-1.219 1.052-1.538 1.265-.677.451.15 3.31.226 4.514.075 1.203-1.88 2.708-3.837 3.084-1.956.376-.827 3.912-1.43 5.717-.601 1.806-.601 3.611-1.052 4.965-.452 1.354-3.46 2.483-3.837 3.762-.244.83.31 2.549 1.138 4.189.442-.176.872-.414 1.326-.522 1.497-1.355.89-2.973.902-4.514l3.46-2.106 1.806-3.611c.776-1.812.21-3.96-.601-6.169l2.858-.902.15-6.77.452-.603v-2.256z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e5e5e5' d='M857.122 225.357c1.177.09 5.07 1.992 6.066 3.53.995 1.54.362 2.354 2.715 4.618 2.354 2.263 5.704 3.44 6.066 3.62.362.182 1.63 1.268 4.164 1.811 2.535.544 1.177 1.63 2.626 1.087 1.448-.543 1.358-1.087 2.535-2.626 1.176-1.539 2.444-3.53 3.168-3.983.724-.453 1.449-1.81 1.54-3.53.09-1.72 1.538-1.268.09-4.255-1.449-2.988-4.527-7.514-5.16-9.416-.634-1.9-1.902-4.707-2.354-4.526-.453.181-5.432 1.267-6.337 2.535-.906 1.267-4.617 3.53-5.251 4.255-.634.724-4.346 2.897-4.98 3.62-.633.725-4.526 3.35-4.888 3.26z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23c9c9c9' stroke='%23b3b3b3' stroke-linejoin='round' stroke-width='.158' d='M859.415 222.073c3.86-.191 3.644-.733 5.998-.733 2.353 0 .358.149 4.341.149 3.984 0 5.07-.362 7.243-1.63 2.172-1.267 4.345-4.526 4.345-4.526s-1.812 3.003-3.804 4.994c-1.992 1.992-3.162 1.948-5.516 1.767-2.354-.18-6.251-.062-6.251-.062l-8.69.724zm5.632 5.21s3.63.138 5.443.075c2.179-.076 4.44.12 6.518-.544 1.4-.447 3.791-2.247 3.791-2.247s-1.735 1.369-2.705 1.885c-1.203.641-2.469 1.252-3.813 1.48-2.02.342-4.103-.033-6.145-.212-1.036-.091-3.09-.437-3.09-.437zm6.156 5.431s2.173.725 4.526 0c2.354-.724 2.173-.724 4.346-1.63 2.173-.904 3.44-2.172 2.716-1.448-.725.725-3.622 2.173-3.622 2.173l-4.526 1.087z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cg color='%23000' paint-order='markers stroke fill'%3e%3cpath fill='%233d6c1e' d='m825.778 272.774 7.985-3.091c-3.006-4.306-3.743-9.136-3.606-14.167 3.307 3.021 6 6.38 8.914 10.372-4.828-6.039-4.492-9.17-4.218-15.069l6.122 9.333c-.296-3.118-.98-6.112 1.288-10.046 2.748 2.72 3.235 6.945 3.864 11.076.447-3.12 1.334-5.311 3.396-8.316 1.638 3.319 1.888 7.431 1.844 11.712 1.128-3.074 2.203-6.194 4.155-8.561.866 2.72 1.378 7.214 1.06 10.29.912-4.023 3.747-4.912 6.941-5.213.514 1.03.348 2.56-.957 4.924 1.767-1.917 3.68-3.755 7.001-4.836-.182 1.916-.406 3.834-2.489 5.868 3.38-3.43 5.663-7.309 11.505-9.731l-3.734 10.526c2.565-5.096 5.895-9.962 13.264-13.617.007 2.405-.119 4.788-1.545 6.954 2.557-4.076 6.665-6.822 12.621-7.985-.399 2.694-2.297 5.049-4.379 7.213 3.235-2.839 6.114-6.335 12.107-7.47l-5.152 7.985c3.792-2.459 7.077-5.748 12.107-6.182.655 1.21-4.637 6.44-4.637 6.44s10.86-9.185 16.743-8.758c-1.678 3.917-3.363 6.219-7.47 9.015 3.4-2.502 6.11-5.841 11.076-6.44-.633 2.267.917 4.253-3.09 6.955 2.98-1.25 6.007-3.27 8.757-.58.404-2.14 1.228-3.653 2.318-4.765 3.076 2.404 3.858 3.456 4.894 5.86-.797-3.03-.483-5.812.258-8.5 4.11 2.411 3.008 6.244 3.67 9.595.593-3.638-1.537-8.122 3.542-10.368 1.306 2.697 1.522 5.03 1.288 7.213 3.844-1.547 6.374-3.176 7.47-4.894 1.486.609 1.686 2.055-.257 4.894 3.09-2.627 6.182-6.041 9.273-5.41-.528 1.405-.696 3.203-1.675 5.796 2.92-5.12 5.68-6.113 10.69-6.568-.395 2.18-2.358 5.033-5.152 8.242 5.242-6.862 10.643-10.051 16.228-9.015-1.417 3.099-2.182 6.316-7.212 8.758 4.289-2.27 8.45-5.83 13.394-1.546-2.638 2.924-7.115 4.24-12.493 4.766l12.235 11.204-.515 11.077-168.202-2.834z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23294814' stroke='%23007300' stroke-linejoin='round' stroke-width='.159' d='M840.917 271.572s4.67 1.58 4.124-.241c-.545-1.821-2.366-5.65-2.366-5.65s1.642-.725 2.55 0c.908.733 2.366 1.463 2.366 1.463l.546-2.188-2.183-2.366s.908-1.275 1.82 0c.909 1.275 1.46 2.004 2.367 2.728.913.73 3.463 2.367 3.463 2.367l1.641-2.183 1.638 1.642 2.366-2.734 1.275 4.009 3.824-3.284s-.183 1.825 0 2.733c.184.918-.545 3.284 1.092 2.555 1.642-.73 4.554-3.284 4.554-3.284s-1.82 3.1-.725 3.462c1.092.367.908 2.004 2.545.367 1.642-1.642 1.642-1.825 2.917-3.1 1.275-1.275 1.82-4.37 1.82-1.82s.184 3.645.184 3.645.179 1.275 1.275 1.092c1.092-.184 1.642-.546 2.55-1.459.908-.907 1.458-3.095 2.733-3.457 1.275-.367 2.367-.184 4.009-1.096 1.637-.908 4.186-2.005 4.916-2.005.724 0-1.826-1.275 1.82.367 3.641 1.642 4.187 1.275 4.916 1.821.73.546.913.362 5.284 2.733 4.37 2.367 3.578-4.138 3.578-4.138s10.523 11.691 11.72 11.793c.942.077-4.54-6.293-3.752-6.148 2.086.377 5.027 3.41 5.027 3.41l.86-2.174-4.641-3.124 6.283.145-3.004-2.878-.183-1.821s1.641-.184 2.366.179c.729.367-.908 2.187 3.641 2.004 4.554-.179 4.737-.725 4.737-.725s1.459-.729 2.367.908c.912 1.642-.039-.531 2.51.387 2.55.907 1.822 2.728 2.734.724.908-2.004 1.092-3.096 1.092-3.096l1.642 4.009s1.27.908 1.453.178c.184-.724.724-2.55.724-2.55l1.28 2.734 1.092-1.275 1.096-1.642 2.728-.908 2.55-.724 1.459.908.912-.546 2.004.179 1.637-.546 1.642.73 1.821.723 2.366 1.464s-1.458.545 1.459-.184c2.912-.729 3.279-2.187 5.462-2.187 2.187 0 5.466-1.275 6.558-.725 1.09.546.907-1.096 2.187 1.27 1.275 2.367 1.454 1.275 2.366 5.1.908 3.83.908 3.284.908 7.833 0 4.554-.362 6.925-.362 6.925l-43.351-.184-63.2-1.275-25.498-.183-9.47-2.115-2.125-4.665 4.41 1.313z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%2398b432' d='m850.038 273.338 1.897 14.224 7.304 4.413 11.924.12.226-8.453-2.795 1.352 1.897-4.534-3.259.771.966-2.999-3.993 1.417-1.159-4.121-2.06 2.575-.645-3.606-1.931 2.319.257-3.478-2.576 2.447-.901-3.606-1.675 4.379zm75.73-1.803.74 6.514-3.566-3.215 1.795 8.55 6.067 4.556 12.519 3.031-.52-2.884.712-3.726 3.211-1.637-3.056-2.817-2.705 1.287v-2.447l-2.447 1.675-.258-5.796-3.135 4.446.045-4.188-3.702 2.15.224-4.597-1.736 2.195-1.355-5.158-1.159 3.607zm20.349 8.629 7.34 3.993 12.063-3.724-1.501-10.959-2.06 3.22-.774-3.477-1.674 2.962-2.704-3.22v3.864l-3.607-4.25v6.568s-4.121-3.606-4.121-3.09c0 .514.644 3.348.644 3.348l-3.22.257 3.606 2.447z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%233d6c1e' d='M832.196 260.98c.182.911-.364.82 1.093 3.097 1.457 2.277 1.275 2.186 2.368 3.916s1.457 2.641 1.457 2.641l-3.46.91 4.917-.455 1.275-.364s-1.821-1.184-2.004-1.64c-.182-.454-2.367-2.913-2.64-4.097-.274-1.184-1.549-3.188-1.549-3.188z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%2398b432' d='M831.923 260.343c0 .365.455.456.91 1.822.456 1.366 1.002 2.64 1.185 3.005.182.364 1.001 2.003 1.457 2.55.455.546 1.457 1.457 1.457 1.457l-.911-3.552s-1.184-2.094-1.366-2.732c-.182-.637-2.732-2.55-2.732-2.55zm3.643-4.735c-.091.364-.16 2.459.205 3.005.364.546.25 1.002.979 2.368.728 1.366 1.821 3.096 1.821 3.096zm6.557-3.097s-.611 1.92-.638 2.914c-.04 1.507.729 4.463.729 4.463zm7.288 1.909.87 3.961.386 5.055s-1.835-3.187-1.674-3.574c.16-.386.418-5.441.418-5.441zm5.764 3.671.644 3.317-.097 3.67s-.836-2.172-.934-3.316c-.104-1.226.387-3.67.387-3.67zm7.502 4.057.096 1.546-.547 1.706-1.256.419.676-.998s.42-1.095.451-1.224c.033-.128.58-1.449.58-1.449zm6.117.065c.065.129-.064 1.61-.064 1.61l-.966 1.964-1.964 1.674 1.352-2.028 1.16-1.836zm8.436-3.463s-.91 2.185-.91 2.458c0 .274-1.367 4.099-1.367 4.099l-.774 2.003s-2.96 1.73-2.686 1.685c.273-.046 1.867-1.366 2.185-2.004.319-.637 1.275-3.551 1.503-3.87.228-.319 1.184-3.188 1.184-3.188zm10.245-3.051c.046.318-.273 2.595-.41 3.187-.136.592-.637 1.594-.865 2.095-.227.5-1.32 2.185-1.684 2.64-.365.456-1.64 1.094-2.004 1.458-.364.364-1.32.82-1.73 1.366-.41.546-2.004 2.504-2.004 2.504s.319-1.593.729-2.23c.41-.638-.091-1.23 1.23-2.05 1.32-.82 2.14-1.138 2.458-1.412.319-.273 1.002-1.183 1.412-1.775.41-.592 1.366-2.778 1.502-2.96.137-.182 1.366-2.823 1.366-2.823zm10.565-1.321c0 .273-.501 1.73-.684 1.958-.182.228-.956 1.366-1.32 1.867-.364.501-1.275 1.275-1.548 1.548-.273.273-.228.592-1.184 1.184s-1.457.774-2.004 1.047c-.546.274-2.003 1.048-2.003 1.048s1.548-1.548 2.23-1.867c.684-.319 1.64-.729 2.187-1.64.546-.91 2.322-2.731 2.322-2.731s.273-.775.956-1.139c.683-.364 1.047-1.275 1.047-1.275zm7.604-.318c-.365.41-.729.5-1.23 1.32-.5.82-.728 1.002-1.275 2.003-.546 1.002-.82 1.23-1.275 2.05-.455.82-.683 1.32-1.138 1.775-.455.456-2.687 1.503-2.687 1.503s.592-.82 1.366-1.412c.775-.591 1.048-1.502 1.64-2.276.592-.774 2.504-3.643 2.504-3.643zm7.331 1.457c0 .182 0 .637-.592 1.183-.592.547-1.275.957-1.548 1.321-.274.364-.456.273-1.366 1.366-.911 1.093-1.549 1.412-2.095 2.231-.546.82-2.641 2.004-2.641 2.004s1.184-.956 2.05-1.867c.864-.91.773-1.73 1.866-2.55 1.093-.82 1.457-1.093 2.186-1.685.728-.592 2.14-2.003 2.14-2.003zm12.112-2.414c-.137.319-.592 1.139-1.23 2.186-.637 1.047-1.047 1.366-1.548 2.14-.5.774-.774 1.23-1.138 2.14-.364.91-.228 1.002-.728 1.594-.501.592-1.275.91-2.14 1.184-.866.273-2.004.546-3.051.774-1.048.228-2.277 1.002-2.277 1.002s1.138-1.093 1.867-1.457c.728-.365 1.821-.911 2.64-1.23.82-.319 1.913-.865 2.323-1.32.41-.456 1.047-1.594 1.275-2.095.228-.5 1.366-2.004 1.594-2.231.227-.228.683-1.002.865-1.32.182-.32 1.548-1.367 1.548-1.367zm3.597 3.006c-.09.364-.683.728-.637 1.548.045.82.228 1.366.045 1.776-.182.41-.319.546-.91 1.047-.592.5-1.367.592-1.685 1.23-.319.637-.547.864-.547.864s.182-1.457.683-2.094c.501-.638.957-.956 1.366-1.275.41-.319.501-.638.638-1.184.136-.546.091-1.002.273-1.23.182-.227.774-.682.774-.682zm8.926 1.639s-.684.637-.775 1.366c-.091.728-.546 1.685-.319 2.413.228.729.365.865.41.364.045-.5 0-1.229.273-1.684.273-.456.638-1.867.638-1.867zm5.562-2.168c-.194.708-.644.386-.644 1.674 0 1.288-.193 1.095 0 2.125s.129 1.868.515 2.963c.386 1.094.708 1.867.708 1.867s-.257-2.06-.193-2.576c.064-.515-.064-1.674.064-2.447.13-.773 0-1.803 0-2.19 0-.386-.45-1.416-.45-1.416zm5.924-1.16s-.901.194-1.095.774c-.193.58-.837.386-.837 1.932 0 1.545-.064.901-.064 2.125 0 1.223-.129 3.477-.129 3.477s.45-.45.515-1.481c.065-1.03-.064-1.932.193-2.77.258-.836.194-1.61.451-2.06.258-.45.966-1.996.966-1.996zm9.708 2.4c-.05.403-.055.819-.177 1.207-.159.504-.065.322-.709 1.417-.644 1.094-1.352 1.61-1.352 1.61s1.618-1.33 2.19-2.19c.282-.425.558-.907.58-1.417.02-.5-.452-1.432-.452-1.432s-.047.537-.08.805zm7.663-1.385c-.032.354-.161.998-.21 1.53-.048.53-.257.917-.354 1.61-.096.692-.16 1.062-.418 1.448-.258.387-.354.355-.982.95-.628.596-.676.95-.129.612.547-.338.982-.547 1.288-.998.306-.451.58-1.481.773-2.013.193-.53.257-1.271.338-1.754.08-.483-.08-1.015-.08-1.079 0-.064-.226-.306-.226-.306zm8.758-.451c-.049.355.112.854-.065 1.337s-.386.885-.595 1.48c-.21.596-.676.967-1.095 1.643-.419.676-.644.95-1.095 1.352-.45.403-1.851.902-1.851.902s1.513-1.176 1.916-1.53c.402-.354.499-1.175 1.046-1.787.547-.612.74-1.272.95-1.594.21-.322.418-.998.467-1.094.048-.097.322-.709.322-.709zm11.38-1.016c-.137.228-.32.41-.547 1.184-.228.774-.273 1.184-.683 1.776-.41.592-.956 1.139-1.32 1.822-.365.683-.729.956-1.275 1.548-.547.592-3.142 1.411-3.142 1.411s.91-.5 1.821-1.366c.91-.865 1.412-1.776 1.913-2.504.5-.729.728-1.867 1.548-2.596.82-.728 1.685-1.275 1.685-1.275zm5.828 6.602c-.637.32-1.002.32-1.73 1.048-.729.729-2.368 1.23-3.142 1.457-.774.228-2.914.41-3.279.501-.364.091-3.233.364-3.233.364s.729.547 1.913.501c1.184-.045 1.958-.455 2.823-.5.865-.046 1.548-.501 2.14-.547.592-.045 2.459-.91 2.641-1.047.182-.137.729-.319 1.093-.729s.774-1.047.774-1.047z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3c/g%3e%3cpath fill='%23fff' fill-rule='evenodd' d='M814.068 267.333c-18.062 0-24.082 15.755-42.143 15.755v31.513c3.192-.985 30.103-15.755 42.143-15.755 12.042 0 30.103 15.755 42.143 15.755 12.042 0 29.811-15.755 42.143-15.755 12.042 0 34.193 15.755 48.166 15.755 18.062 0 26.456-15.755 42.144-15.755 12.041 0 26.522 15.447 36.122 15.755 0-10.503 1.358-30.037 1.358-30.037l-.492-1.293c-5.155.184-18.927-15.938-36.988-15.938-18.062 0-30.104 15.757-45.988 15.078-15.883-.679-26.26-15.078-44.322-15.078-18.061 0-24.081 15.755-42.143 15.755s-24.081-15.755-42.143-15.755zm.25 64.878c-12.334.117-32.754 16.584-34.468 16.829 1.623.829 15.716 25.31 15.716 25.31s5.722-3.281 18.061-5.253c12.341-1.972 25.23 11.291 39.707 13.523 14.478 2.233 32.2-13.523 44.58-13.523 12.042 0 28.438 16.543 44.322 13.523 15.883-3.019 22.078-20.002 37.043-19.388 14.964.612 20.985 5.865 20.985 5.865l18.061-21.01s-18.076-14.277-33.12-15.016c-15.044-.74-21.063 15.016-39.125 15.016-24.082 0-30.213-15.755-48.166-15.755-18.062 0-24.082 15.755-42.143 15.755-18.062 0-28.723-15.998-41.453-15.876zm85.704 73.642a29.836 29.836 0 0 0-1.689.003c-18.358.538-24.981 15.755-49.964 15.755 0 1.293 43.72 21.01 49.964 21.01 6.248 0 60.714-22.165 49.97-21.01-24.202 0-31.178-15.291-48.28-15.758z' font-size='12'/%3e%3cpath fill='%23280b0b' stroke='%23280b0b' stroke-width='1.305' d='M892.857 422.741c-15.785-2.99-28.273-11.317-37.04-24.696-4.7-7.172-7.905-14.746-8.667-20.483-.438-3.3-1.265-3.86-4.741-3.208-1.963.367-2.35.198-4.217-1.838-1.131-1.233-2.058-2.41-2.06-2.615 0-.205-.42-1.172-.93-2.148-.51-.976-.783-2.346-.608-3.045.28-1.111-.326-1.55-4.843-3.51-2.84-1.23-5.502-2.369-5.917-2.528-.55-.21-.382 1.468.617 6.181 1.409 6.646 1.412 7.368.04 7.368-.71 0-1.865-2.62-1.634-3.71.12-.569-2.086-11.253-2.366-11.459-.571-.42-12.992-5.761-13.397-5.761-.79 0-16.529-9.1-16.239-9.39.325-.325 11.533 4.348 21.61 9.01 3.94 1.822 7.26 3.216 7.38 3.096.12-.12-.207-2.482-.726-5.25-1.146-6.111-1.154-6.436-.147-6.436.52 0 1.247 2.022 2.094 5.83a992.285 992.285 0 0 0 1.492 6.643c.25 1.032 8.058 4.707 27.049 12.729 4.61 1.947 8.85 3.8 9.421 4.119.572.318 1.318.579 1.658.579.869 0 .63-17.492-.247-18.08-.45-.302-.42-.443.094-.449 1.405-.017.752-2.174-1.065-3.515l-1.813-1.339-1.56 1.227c-2.105 1.653-4.055 1.545-5.513-.307-1.084-1.376-1.42-1.473-3.295-.956-1.705.47-2.155.403-2.45-.363-.443-1.155.47-1.758 3.41-2.254 1.242-.21 2.257-.565 2.257-.79 0-.226-.77-1.346-1.71-2.49-3.151-3.828-4.457-7.13-4.724-11.946-.215-3.878-.051-4.87 1.215-7.326.982-1.903 1.216-2.84.712-2.84-.666 0-1.767-1.732-1.344-2.113.145-.13 6.74-1.932 14.084-3.847 2.327-.607 2.544-.828 2.544-2.584 0-1.486-.484-2.307-2.14-3.627l-2.142-1.706-1.34 1.257c-1.755 1.648-4.029 1.597-5.649-.126-2.478-2.635-2.158-2.903 5.883-4.92l5.089-1.277v-1.991c0-2.116-1.371-3.305-5.502-4.77-1.653-.586-2.345-.47-5.147.853-3.982 1.881-4.107 1.882-6.314.027-3.065-2.576-4.73-3.192-7.15-2.647-3.191.72-3.137.164.127-1.278 2.29-1.011 3.5-1.18 6.23-.865 2.906.334 3.883.162 6.885-1.213 3.453-1.582 3.546-1.591 7.184-.698 2.028.498 3.821.762 3.986.586.165-.176-.037-.44-.449-.587-.412-.147-.748-.648-.748-1.114 0-.614.795-.848 2.884-.848h2.884l-.257 6.578c-.142 3.618-.159 6.578-.038 6.578.12 0 2.103-.56 4.407-1.247 2.304-.686 4.857-1.342 5.674-1.457 1.71-.242 2.635.812 1.7 1.937-.35.422-.467.767-.26.767.208 0-.343.808-1.223 1.794-1.618 1.814-4.157 2.392-5.336 1.215-.991-.99-5.047 5.058-5.047 7.527 0 1.718.192 2.048 1.048 1.803 3.214-.92 14.536-3.967 14.744-3.967.926 0 .749 2.083-.27 3.172-.677.722-2.218 3.309-3.427 5.747-1.757 3.547-2.192 5.102-2.173 7.774.027 3.74 1.84 7.877 4.973 11.35 1.008 1.117 1.708 2.23 1.558 2.474-.151.244-1.167.61-2.258.815-1.58.296-2.138.798-2.74 2.46-.881 2.435-2.439 3.44-4.926 3.18-1.477-.155-2.114.24-3.772 2.333-1.098 1.385-2.182 2.332-2.41 2.103.196 9.71.021 15.646-.264 22.602-.092 2.605.174 3.432 1.788 5.555 4.781 6.286 13.17 12.95 17.387 13.811.44.09 1.203.316 1.697.503s1.975.48 3.293.652c1.317.172 3.068.49 3.891.708a52.58 52.58 0 0 0 3.177.707l1.68.311c-.186-13.206-.039-26.417-.26-39.622-.098-4.647-.242-5.207-1.718-6.656-1.572-1.544-1.634-1.555-2.637-.448-1.304 1.44-3.654 1.441-5.837.003-.936-.617-2.244-.98-2.905-.808-.68.178-1.432-.048-1.73-.519-.813-1.282-.653-1.73.615-1.73.64 0 1.313-.245 1.498-.544.185-.299-.655-3.46-1.867-7.026-1.744-5.133-2.212-7.436-2.246-11.06-.041-4.257.133-4.917 2.496-9.457 2.166-4.163 2.364-4.825 1.347-4.502-.922.292-1.193.104-1.193-.83 0-.855.57-1.365 1.946-1.742 1.07-.294 4.303-1.154 7.185-1.913l5.238-1.379v-2.002c0-1.565-.247-2.003-1.13-2.003-.623 0-1.744-.495-2.492-1.1-1.32-1.067-1.392-1.067-2.46 0-1.437 1.435-2.964 1.392-4.913-.14-3.287-2.581-2.109-3.58 6.655-5.641 4.09-.963 4.34-1.116 4.34-2.669 0-1.43-.505-1.896-3.815-3.523-4.637-2.28-6.005-2.326-9.597-.321-3.351 1.87-4.643 1.663-8.22-1.323-2.49-2.077-2.748-2.155-6.199-1.869l-3.6.299 2.993-1.443c2.655-1.28 3.51-1.401 7.556-1.07 4.156.34 4.824.235 7.48-1.177 3.351-1.782 6.324-1.959 10.689-.636 2.065.625 2.751.678 2.245.172-1.29-1.287-.791-1.684 2.115-1.685l2.844-.001-.2 6.488-.2 6.488 5.743-1.498c3.16-.824 5.901-1.342 6.093-1.15.728.727-1.33 4.825-3.282 6.537-2.009 1.761-3.494 1.966-6.102.839-1.216-.526-2.352 1.866-2.352 4.952v2.267l8.532-2.3c4.692-1.266 8.868-2.172 9.28-2.015.856.327 1.028 2.117.203 2.117s-5.917 10.734-6.7 14.123c-.588 2.544-.508 3.674.555 7.875 1.556 6.145 3.369 10.294 4.497 10.294.477 0 1.031.426 1.231.946.504 1.312.527 1.275-1.067 1.675-.863.216-1.58.95-1.805 1.847-.205.82-1.322 2.436-2.48 3.594-2.217 2.213-4.139 2.639-6.417 1.421-1.09-.582-1.415-.476-2.206.723-.51.773-1.508 2.032-2.215 2.798-1.268 1.372-1.288 1.742-1.352 24.094l-.065 22.702 3.447-.026c1.896-.015 4.66-.287 6.142-.605 1.482-.319 3.368-.726 4.191-.906.823-.18 2.279-.715 3.235-1.19.956-.474 2.088-.861 2.515-.861.427 0 .992-.385 1.255-.855.263-.47.692-.846.953-.835 4.904-2.965 7.027-4.634 10.257-6.046.754-.625.944-7.323.944-7.323s-.54-11.876-.58-21.384c-.035-1.561.354-1.76.58-3.025 0-.987-.32-1.794-.71-1.794-.39 0-1.308-.561-2.039-1.247-1.28-1.201-1.387-1.209-2.92-.206-1.52.995-1.689.99-3.798-.097-1.215-.627-3.286-1.14-4.603-1.14-1.661 0-2.395-.26-2.395-.844 0-.47 1.058-1.146 2.395-1.529 2.749-.788 2.757-.865.657-6.42-.833-2.205-1.832-5.73-2.22-7.831-.634-3.434-.574-4.256.59-8.082.712-2.342 1.469-4.71 1.681-5.264.316-.821.1-.95-1.179-.706-1.055.202-1.678.003-1.914-.611-.48-1.25-.192-1.374 8.651-3.714l7.804-2.065v-2.248c0-1.827-.218-2.248-1.164-2.248-.64 0-1.575-.587-2.078-1.304-.862-1.229-.98-1.246-2.027-.299-.612.553-1.58 1.005-2.152 1.005-2.1 0-5.342-2.515-4.948-3.839.09-.303 2.842-1.255 6.116-2.117l5.953-1.567.18-2.119c.168-1.972-.012-2.22-2.555-3.564-2.665-1.407-2.783-1.417-4.57-.398-2.491 1.422-3.715 1.319-5.876-.497-1.462-1.23-2.234-1.469-3.788-1.177l-1.95.368 1.716-.973c1.113-.63 2.588-.881 4.191-.712 1.687.177 3.227-.114 4.84-.915 2.014-1 2.768-1.082 5.088-.552 2.47.565 4.381.336 2.575-.308-.412-.147-.749-.648-.749-1.114 0-.613.794-.847 2.872-.847h2.871l-.249 5.68c-.136 3.125-.011 5.682.284 5.682.458 0 7.37-1.809 10.537-2.757.76-.228 1.048.024 1.048.915 0 1.324-1.064 2.865-3.868 5.607-1.388 1.357-2.165 1.67-3.592 1.448-1.559-.243-2.014.01-3.167 1.778-1.461 2.235-1.821 5.575-.6 5.553 1.038-.019 13.445-3.395 14.208-3.866 1.616-.998 1.118 1.925-1.046 6.125-4.984 9.677-5.255 12.695-1.861 20.77 1.61 3.832 2.074 4.461 3.056 4.15.945-.3 1.122-.116.96.999-.138.951-.763 1.51-2.06 1.845-1.193.307-2.468 1.354-3.553 2.917-1.902 2.741-4.566 4.387-6.242 3.856-.816-.259-1.41.137-2.195 1.464-.591 1-1.272 1.82-1.513 1.82-.241 0-.395 1.076-.343 2.391.187.74.126 1.524.098 2.286-.012.848.822 2.039.387 1.353-.327-.515-.557 4.02-.59 11.604-.052 12.413-.049 12.447 1.144 11.368.659-.595 1.197-1.444 1.197-1.887 0-.442.333-.737.74-.655.486.099.741-.665.748-2.237 0-1.461.3-2.417.758-2.466.411-.045 1.017-.114 1.347-.155.874-.11.21-.945.316-2.109-.232-1.447-.113-2.077-.148-2.87.114-1.746.625-2.87-.154-2.87a.607.607 0 0 0-.613.598c-.638-1.196-.11-.471-.722-1.6-.162-.62.058-2.55.488-2.951.63-.587 12.656-2.554 17.896-3.46.658-.115 1.4-.242 1.646-.284.247-.042.45-2.331.45-5.087 0-4.976-.013-5.016-1.753-5.736-1.382-.571-2.192-.566-3.825.024-1.85.668-2.241.615-3.643-.486-.915-.719-2.067-1.104-2.761-.923-.655.171-1.19.044-1.19-.282 0-.751 3.025-1.377 4.63-.957.67.174 2.04-.107 3.045-.627s2.182-.834 2.614-.7c.433.135 1.528.408 2.433.606l1.647.36v6.567c0 7.689-.846 7.197 8.68 5.043 3.623-.82 7.664-1.552 8.981-1.628 2.36-.136 2.394-.109 2.301 1.86-.059 1.245-.547 2.315-1.297 2.84-2.57 1.797-3.064 13.934-.62 15.24 1.248.668 1.533 3.496.365 3.628-.412.046-4.271.017-8.577-.065l-7.827-.148-1.904 5.316c-5.55 15.494-17.474 29.454-30.936 36.216-4.222 2.12-11.226 4.56-16.155 5.625-6.098 1.318-20.454 1.594-26.21.504zm-34.42-79.343c2.686-.648 2.844-.797 2.844-2.677 0-1.095-.178-1.99-.396-1.99-.746 0-6.014 3.599-7.15 4.885-1.129 1.276-1.127 1.28.362.875a204.87 204.87 0 0 1 4.34-1.093zm35.025-.564 4.939-1.294v-2.582c0-2.202-.154-2.527-1.048-2.209-1.407.5-8.095 5.22-9.085 6.413-1.026 1.234-.682 1.212 5.194-.328zm37.868.18c3.815-1.075 3.895-1.139 4.077-3.288.102-1.205-.046-2.191-.332-2.191-.678 0-5.356 3.067-7.637 5.007-2.187 1.86-1.39 1.957 3.892.471zm-59.059-3.346c2.912-.8 5.447-1.607 5.634-1.794.187-.186-2.534-.34-6.047-.34h-6.386v1.795c0 2.174.104 2.179 6.8.34zm42.493-2.54c3.234-.687.249-1.369-6.035-1.378l-6.137-.01v4.672l5.239-1.462c2.88-.804 6-1.624 6.933-1.822zm31.148 1.942c2.912-.8 5.447-1.607 5.634-1.794.187-.186-2.384-.34-5.712-.34s-6.19.223-6.357.495c-.378.61.231 3.094.758 3.094.21 0 2.765-.655 5.677-1.455z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23fff' fill-rule='evenodd' stroke='%23000' stroke-width='1.234' d='M900.986 444.359s-132.072-29.614-131.336-152.76V118.033l258.776-.002 1.947 172.633c.736 123.145-129.387 153.696-129.387 153.696zm-.185-5.493S773.868 409.35 774.603 286.204l.972-162.78h247.276l1.701 161.845c.736 123.145-123.75 153.597-123.75 153.597z' font-size='12'/%3e%3cg transform='matrix(1.48121 0 0 1.54883 323.943 -124.042)'%3e%3cg fill='none' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.385' paint-order='markers stroke fill'%3e%3cpath d='M413.302 472.407c.995-3.535 7.855-27.87 7.855-27.87l1.97-4.34m-6.409 30.301c0-.29 6.4-30.27 6.4-30.27m-3.384 27.461c.21-1.27 3.167-22.559 3.167-22.559l.218-4.901' style='marker:none' transform='matrix(1 0 0 1.00603 -8.772 -141.32)'/%3e%3cpath d='m405.267 325.302 4.657.522m-3.587-4.396 4.132.654m-3.056-4.452 3.513.634m-2.536-4.414 3.092.579' style='marker:none' transform='matrix(1 0 0 1.00603 1.916 -3.19)'/%3e%3cpath d='m420.228 447.356 2.48.553' style='marker:none' transform='matrix(1 0 0 1.00603 -8.772 -141.32)'/%3e%3cpath d='m405.637 323.398 4.518.589m-3.398-4.463 4.132.654m-3.08-4.452 3.512.634m-2.61-4.415 3.092.58' style='marker:none' transform='matrix(1 0 0 1.00603 1.916 -3.19)'/%3e%3cpath stroke-width='.395' d='m404.572 327.21 4.963.514' style='marker:none' transform='matrix(1 0 0 1.00603 1.916 -3.19)'/%3e%3cpath stroke-width='.404' d='m404.018 329.119 5.303.504' style='marker:none' transform='matrix(1 0 0 1.00603 1.916 -3.19)'/%3e%3c/g%3e%3cpath fill='none' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.271' d='m414.16 265.564 9.275 5.285 2.616 6.394' paint-order='markers stroke fill' style='marker:none'/%3e%3cg fill='none' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.317' paint-order='markers stroke fill' style='marker:none'%3e%3cpath d='M414.44 468.467c.995-3.536 6.717-23.929 6.717-23.929l1.97-4.342m-6.003 28.989c0-.291 5.995-28.956 5.995-28.956m-3.629 29.159c.211-1.27 3.41-24.258 3.41-24.258l.219-4.901' style='marker:none' transform='matrix(1.21616 0 0 1.2235 -125.57 -237.034)'/%3e%3cpath d='m405.267 325.302 4.657.522m-3.587-4.396 4.132.654m-3.056-4.452 3.513.634m-2.536-4.414 3.092.579' style='marker:none' transform='matrix(1.21616 0 0 1.2235 -112.572 -69.046)'/%3e%3cpath d='m420.228 447.356 2.48.553' style='marker:none' transform='matrix(1.21616 0 0 1.2235 -125.57 -237.034)'/%3e%3cpath d='m405.637 323.398 4.518.589m-3.398-4.463 4.132.654m-3.08-4.452 3.512.634m-2.61-4.415 3.092.58m-7.231 14.685 4.963.514m-5.517 1.395 5.303.504' style='marker:none' transform='matrix(1.21616 0 0 1.2235 -112.572 -69.046)'/%3e%3c/g%3e%3cpath fill='none' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.271' d='M336.133 310.078c11.183-14.064 19.469-27.856 27.418-42.95m-45.12 35.079c5.532-3.359 25.725-15.526 37.338-24.97 5.752-4.676 8.082-10.678 8.082-10.678m.867.221c-.29 0 8.575 6.002 8.575 6.002l1.6 6.787m56.39 30.521c-.29 0-33.137-41.326-33.137-41.617 0-.29-9.047-6.81-9.047-6.519l-7.618 9.992' paint-order='markers stroke fill' style='marker:none'/%3e%3cg fill='none' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.484' font-size='12' paint-order='markers stroke fill' style='marker:none'%3e%3cpath stroke-width='.474' d='m413.635 471.006 7.58-27.036 2.013-3.776m-7.036 31.609 6.163-27.544.873-4.065m-4.396 31.175 4.788-26.855-.392-4.32m-9.302 27.033 6.102.863' style='marker:none' transform='matrix(.84711 0 0 .78432 5.016 -42.669)'/%3e%3cpath d='m380.154 325.92 5.185.74m-4.065-4.836 4.772.65m-3.737-4.788 4.28.555m-2.989-4.703 3.57.568' style='marker:none' transform='matrix(.84711 0 0 .75482 34.964 74.706)'/%3e%3cpath stroke-width='.474' d='m419.95 447.418 3.568.624' style='marker:none' transform='matrix(.84711 0 0 .78432 5.016 -42.669)'/%3e%3cpath d='m383.951 311.503 3.568.568m-4.744 3.58 4.28.555m-5.519 3.583 4.773.65' style='marker:none' transform='matrix(.84711 0 0 .75482 34.964 74.706)'/%3e%3c/g%3e%3cg stroke-width='.618' color='%23000' paint-order='markers stroke fill'%3e%3cpath fill='%23fff' fill-opacity='.996' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.542' d='M412.808 266.403s-2.355-.847-3.566-.742c-1.172.103-2.093 1.14-3.256 1.306-1.018.144-2.055-.458-3.07-.297-.93.148-2.574 1.127-2.574 1.127s1.658-.573 2.48-.415c1.216.234 1.9 1.797 3.133 1.92 1.164.117 2.116-1.224 3.286-1.186 1.318.042 3.598 1.572 3.598 1.572z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23a00' d='M409.242 265.662c-.064.006-.126.024-.19.035v.886c-1.11.127-1.91 1.32-3.025 1.385-1.032.06-1.906-.914-2.939-.944-.666-.02-1.704.317-2.326.541-.015.008-.037.018-.05.026.603-.207 1.654-.526 2.31-.462 1.1.109 1.9 1.324 3.005 1.342 1.08.017 1.902-1.18 2.982-1.216h.044v.87c.062-.006.125-.01.19-.009.125.004.464.067.604.096v-.854c1.356.245 2.95 1.153 2.95 1.153v-1.166s-1.631-.626-2.95-.72v-.948a3.221 3.221 0 0 0-.605-.015z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3c/g%3e%3cg stroke-width='.541' color='%23000' paint-order='markers stroke fill' transform='translate(.233)'%3e%3cpath fill='%23dd8b59' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' d='M387.842 262.276h2.411v72.953h-2.411z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e6ab87' d='M388.247 262.26h1.601v72.984h-1.601z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23efc9b2' d='M388.667 262.26h.762v72.984h-.762z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3crect width='3.857' height='.787' x='387.119' y='261.268' fill='%23dd8b59' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' overflow='visible' rx='0' ry='0' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3c/g%3e%3cg stroke-width='.541' color='%23000' paint-order='markers stroke fill'%3e%3cpath fill='%23dd8b59' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' d='M363.077 266.818h2.411v72.953h-2.411z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3crect width='3.857' height='.787' x='362.354' y='265.697' fill='%23dd8b59' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' overflow='visible' rx='0' ry='0' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e6ab87' d='M363.574 266.923h1.417v72.743h-1.417z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23efc9b2' d='M363.958 266.923h.648v72.743h-.648z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3c/g%3e%3cg fill='%23dd8b59' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' color='%23000' paint-order='markers stroke fill'%3e%3cpath d='M413.073 265.655h2.411v72.953h-2.411z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3crect width='3.857' height='.787' x='412.351' y='264.597' overflow='visible' rx='0' ry='0' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3c/g%3e%3cpath fill='%23e6ab87' d='M413.479 265.669h1.601v72.984h-1.601z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='none' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.271' d='m323.837 304.704 10.787-2.11 16.432 14.763-13.114 2.075z' paint-order='markers stroke fill' style='marker:none'/%3e%3cpath fill='%23efc9b2' d='M413.898 265.669h.762v72.984h-.762z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cg fill='none' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.484' font-size='12' paint-order='markers stroke fill' style='marker:none'%3e%3cpath stroke-width='.474' d='m413.635 471.006 7.58-27.036 2.013-3.776m-7.036 31.609 6.163-27.544.873-4.065m-4.396 31.175 4.788-26.855-.392-4.32m-9.302 27.033 6.102.863' style='marker:none' transform='matrix(-.84711 0 0 .78432 772.984 -43.832)'/%3e%3cpath d='m380.154 325.92 5.185.74m-4.065-4.836 4.772.65m-3.737-4.788 4.28.555m-2.989-4.703 3.57.568' style='marker:none' transform='matrix(-.84711 0 0 .75482 743.036 73.543)'/%3e%3cpath stroke-width='.474' d='m419.95 447.418 3.568.624' style='marker:none' transform='matrix(-.84711 0 0 .78432 772.984 -43.832)'/%3e%3cpath d='m383.951 311.503 3.568.568m-4.744 3.58 4.28.555m-5.519 3.583 4.773.65m-5.448 3.51 4.773.651' style='marker:none' transform='matrix(-.84711 0 0 .75482 743.036 73.543)'/%3e%3c/g%3e%3cpath fill='%23e98e01' fill-rule='evenodd' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M445.08 320.351c-.29-.872-.463-2.436-.556-3.669-.088-1.16-.175-2.337 0-3.488.195-1.283 1.158-3.729 1.158-3.729s-25.289 3.623-25.289 3.914c0-.335-.156 6.885-.156 6.885z' paint-order='markers stroke fill' style='marker:none'/%3e%3cpath fill='%23e9b001' fill-rule='evenodd' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='m439.854 312.355.01 6.577h3.205l-.032-7.119zm-4.648.67-.008 5.907 3.214-.068-.017-6.331zm-4.633 5.907.04-5.059 3.023-.487.12 5.544zm-4.517-.012-.016-4.378 3.026-.542.065 4.932zm-4.656.012.162-3.74 3.01-.463.026 4.198z' paint-order='markers stroke fill' style='marker:none'/%3e%3cpath fill='%23dd8b59' fill-rule='evenodd' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M333.946 301.377c0 .872 3.721 18.639 3.721 18.639.078.334 1.296.45 1.181-.334-.042-.287-4.003-18.36-4.003-18.36-.454-.42-.445-.126-.9.055z' paint-order='markers stroke fill' style='marker:none'/%3e%3cpath fill='%23dd8b59' fill-rule='evenodd' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='m323.442 303.82 24.465 10.784-.078 1.053-24.352-10.398-8.886-4.968 8.851 3.53z' paint-order='markers stroke fill' style='marker:none'/%3e%3cpath fill='%23fec618' fill-rule='evenodd' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M354.218 286.541s-3.798 2.741-2.926 7.973c.872 5.232 4.655 8.237 4.945 8.237.291 0 3.902-3.662 7.39-4.534 3.489-.873 12.226-.36 12.226-.36s-4.45-4.626-3.577-8.986c.872-4.36 4.293-8.099 4.293-8.099s-21.479 5.77-22.35 5.77z' paint-order='markers stroke fill' style='marker:none'/%3e%3cpath fill='none' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.271' d='m444.654 307.765-18.022-28.487' paint-order='markers stroke fill' style='marker:none'/%3e%3cpath fill='%23fec618' fill-rule='evenodd' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M380.124 281.604c0 .581-3.928 4.83-3.685 9.523.23 4.434 3.198 11.15 3.489 11.15.291 0 4.897-4.646 8.676-5.518 3.778-.872 12.9.251 12.61.251-.29 0-3.235-7.32-3.235-10.517 0-3.198 4.804-11.007 4.804-11.007z' paint-order='markers stroke fill' style='marker:none'/%3e%3cg color='%23000' paint-order='markers stroke fill'%3e%3cpath fill='%23fed65b' d='M399.596 281.13c-4.772 1.128-16.548 3.885-22.076 4.987-.398 1.136-.713 2.303-.717 3.197-.006 1.388-.232 3.223.2 4.988l21.4-4.884c-.388-1.175-.647-2.344-.556-3.295.126-1.305.891-3.199 1.749-4.992z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23fedf82' d='m398.794 282.927-21.901 4.737c-.147.594-.35 1.167-.353 1.65-.004.942-.256 2.091.054 3.285l21.381-4.745c-.12-.618-.178-1.209-.128-1.73.084-.87.458-2.007.947-3.197z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3c/g%3e%3cg stroke-linecap='round' stroke-linejoin='round' stroke-width='.541' transform='matrix(.9935 -.1088 .11896 .9935 -31.642 44.095)'%3e%3cuse xlink:href='%23a' id='b' width='100%25' height='100%25' x='0' y='0' stroke-dasharray='none' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='4' stroke-width='.541' transform='matrix(.99572 .08841 -.09667 .99572 28.306 -28.34)'/%3e%3cuse xlink:href='%23b' width='100%25' height='100%25' transform='translate(5.666 -.532)'/%3e%3cuse xlink:href='%23b' width='100%25' height='100%25' transform='translate(-5.708 .577)'/%3e%3c/g%3e%3cpath fill='none' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.271' d='M405.627 303.318s2.99 9.099 6.181 12.586c1.973 2.156 7.557 4.651 7.557 4.651M379.715 303s4.047 17.915 11.024 22.275a952.102 952.102 0 0 1 12.789 8.139' paint-order='markers stroke fill' style='marker:none'/%3e%3cpath fill='none' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.271' d='M379.774 303.244s7.767 13.31 14.162 17.962c6.395 4.65 15.115 9.01 15.115 9.01m-53.484-27.614c2.034 3.488 1.744 10.174 4.069 12.499 2.325 2.326 5.814 7.558 5.814 7.558' paint-order='markers stroke fill' style='marker:none'/%3e%3cpath fill='none' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.271' d='M356.148 302.893c1.163 1.744 4.406 10.428 6.395 13.08 1.454 2.326 16.278 17.15 16.278 17.15' paint-order='markers stroke fill' style='marker:none'/%3e%3cpath fill='%23dd8b59' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M432.986 300.673h.471v11.355h-.471z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e96a01' fill-rule='evenodd' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M419.365 314.45c3.198 0 27.324-4.65 27.324-4.65s.872-2.907 0-2.907-27.324 5.523-27.324 5.523z' paint-order='markers stroke fill' style='marker:none'/%3e%3cpath id='a' fill='red' fill-opacity='.996' fill-rule='nonzero' stroke='%23512007' stroke-dasharray='none' stroke-dashoffset='0' stroke-linecap='butt' stroke-linejoin='miter' stroke-miterlimit='4' stroke-opacity='.996' stroke-width='.813' d='m119.614 166.093-.438-1.408-1.474.053 1-1.083-.783-1.25 1.439.324.69-1.303.439 1.408 1.474-.053-1 1.084.783 1.25-1.439-.325z' clip-rule='nonzero' color='%23000' color-interpolation='sRGB' color-interpolation-filters='linearRGB' color-rendering='auto' display='inline' image-rendering='auto' opacity='1' overflow='visible' paint-order='markers stroke fill' shape-rendering='auto' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none' text-rendering='auto' transform='matrix(.673 -.09611 .1005 .64363 291.729 188.469)' vector-effect='none' visibility='visible'/%3e%3cuse xlink:href='%23b' width='100%25' height='100%25' stroke-linecap='round' stroke-linejoin='round' stroke-width='.541' transform='matrix(.99274 -.11507 .12581 .99274 -32.657 51.235)'/%3e%3crect width='3.857' height='.787' x='412.351' y='264.597' fill='%23dd8b59' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' color='%23000' overflow='visible' paint-order='markers stroke fill' rx='0' ry='0' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23fec618' fill-rule='evenodd' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M405.154 275.569c-.23.602 1.54 1.923 2.92 1.814 1.379-.11 1.73-1.157 2.093-1.627.322.56.876 2.971 4.396 1.817 2.919-1.073 2.679-2.794 3.089-3.188.251.068.711.649 1.348.672 2.506.095 4.672-4.166 4.397-4.145-.276.022-17.668 4.904-18.243 4.657z' paint-order='markers stroke fill' style='marker:none'/%3e%3cpath fill='%23dd8b59' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M315.065 367.106h19.723v.981h-19.723z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none' transform='matrix(.96841 -.24935 .271 .96258 0 0)'/%3e%3cpath fill='%23fec618' fill-rule='evenodd' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M379.682 273.515s1.06 1.999 2.892 1.779c1.83-.22 1.851-2.083 1.851-2.083s1.102 2.867 3.946 2.26c2.843-.608 3.511-3.611 3.511-3.611s1.451 1.963 3.702.895c2.251-1.069 3.113-4.182 2.85-4.151-.26.031-18.752 4.911-18.752 4.911z' paint-order='markers stroke fill' style='marker:none'/%3e%3cpath fill='%23dd8b59' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M291.353 358.737h19.723v.981h-19.723z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none' transform='matrix(.96841 -.24935 .271 .96258 0 0)'/%3e%3cpath fill='%23fec618' fill-rule='evenodd' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M355.231 277.698c-.478.324.107 2.122 2.097 2.019 2.501-.286 2.724-2.612 2.724-2.612s.715 3.268 3.86 2.638c3.143-.63 4.806-4.829 4.806-4.829s.08 1.585 2.207 1.337c2.229-.592 2.568-3.217 2.568-3.217-6.057 1.602-12.169 3.088-18.262 4.664z' paint-order='markers stroke fill' style='marker:none'/%3e%3cpath fill='%23dd8b59' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M266.32 356.808h19.723v.981H266.32z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none' transform='matrix(.96841 -.24935 .271 .96258 0 0)'/%3e%3cg stroke-width='.541' color='%23000' paint-order='markers stroke fill'%3e%3cpath fill='%23fff' fill-opacity='.996' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' d='M387.683 262.817s-3.905-1.405-5.913-1.23c-1.944.171-3.47 1.89-5.4 2.165-1.687.24-3.408-.759-5.09-.492-1.544.245-4.269 1.869-4.269 1.869s2.75-.951 4.114-.689c2.016.388 3.149 2.98 5.194 3.185 1.931.194 3.51-2.03 5.45-1.967 2.185.07 5.966 2.606 5.966 2.606z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23a00' d='M381.769 261.588c-.108.01-.21.039-.315.057v1.47c-1.841.21-3.168 2.187-5.018 2.295-1.71.1-3.16-1.514-4.873-1.564-1.105-.032-2.826.526-3.858.897l-.083.043c1.002-.344 2.744-.873 3.831-.766 1.824.18 3.15 2.195 4.983 2.225 1.792.029 3.154-1.957 4.945-2.016.023-.001.05.001.073.001v1.44c.104-.01.209-.016.315-.013.208.007.77.111 1.002.158V264.4c2.249.407 4.893 1.912 4.893 1.912l-.001-1.933s-2.704-1.038-4.892-1.195v-1.57c-.233-.046-.8-.043-1.002-.025z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3c/g%3e%3cg stroke-width='.618' color='%23000' paint-order='markers stroke fill'%3e%3cpath fill='%23fff' fill-opacity='.996' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.542' d='M362.907 267.566s-3.422-1.231-5.182-1.077c-1.703.15-3.04 1.655-4.732 1.896-1.478.211-2.987-.665-4.461-.43-1.353.214-3.74 1.637-3.74 1.637s2.409-.834 3.605-.604c1.767.34 2.759 2.611 4.551 2.791 1.693.17 3.076-1.779 4.777-1.724 1.914.062 5.227 2.284 5.227 2.284z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23a00' d='M357.724 266.489c-.094.008-.184.034-.276.05v1.288c-1.613.184-2.776 1.917-4.397 2.012-1.499.087-2.77-1.327-4.27-1.371-.969-.028-2.477.46-3.381.786l-.073.037c.878-.3 2.404-.764 3.358-.67 1.597.157 2.76 1.923 4.366 1.949 1.57.025 2.764-1.715 4.333-1.767l.064.001v1.262a2.3 2.3 0 0 1 .276-.011c.182.006.675.097.878.138v-1.241c1.97.357 4.288 1.676 4.288 1.676l-.001-1.694s-2.37-.91-4.287-1.047v-1.377c-.204-.04-.702-.037-.878-.021z' overflow='visible' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3c/g%3e%3cpath fill='%23dd8b59' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M261.207 364.593h25.51v1.269h-25.51zm26.818 1.625h25.51v1.269h-25.51z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none' transform='matrix(.96841 -.24935 .271 .96258 0 0)'/%3e%3cpath fill='%23dd8b59' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M288.025 366.218h25.51v1.269h-25.51zm19.341 28.401h19.723v.981h-19.723z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none' transform='matrix(.96841 -.24935 .271 .96258 0 0)'/%3e%3cpath fill='%23dd8b59' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M307.366 394.619h19.723v.981h-19.723z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none' transform='matrix(.96841 -.24935 .271 .96258 0 0)'/%3e%3cpath fill='%23dd8b59' fill-rule='evenodd' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.7' d='M21.125 565.715a2.375 2.375 0 0 0-1.074 4.494c-.067.22-.1.447-.102.676a2.37 2.37 0 0 0 2.174 2.36 2.368 2.368 0 0 0-.014.247c0 1.312 1.32 2.375 2.632 2.375 1.027 0 1.437-.885 1.743-1.024l3.065 1.09c-1.347 2.807 9.148 43.71 51.92 41.518 42.233-2.165 50.885-41.566 50.885-41.566s-19.023-.219-19.391-.219c-.367 0-14.705 18.451-33.084 18.066-18.38-.384-24.26-4.997-28.305-8.84-4.043-3.843-7.719-9.609-7.719-9.609l-21.105-9.088c-1.419-.454-.892-.48-1.625-.48z' paint-order='markers stroke fill' style='marker:none' transform='matrix(.79077 0 0 .75625 330.038 -113.63)'/%3e%3cpath fill='%23fecf3e' d='M390.46 339.321c-9.839-.78-19.23-3.926-24.24-8.459-1.718-1.554-3.385-3.519-3.85-4.991-.179-.568-.212-1.388-.28-1.467-.069-.079-2.067-.58-4.317-1.231-6.215-1.8-5.956-1.923-6.622-2.21-.143-.327-.391-1.074-.493-1.074a1.87 1.87 0 0 1-.488-.11c-.192-.071-.302-.013-.302.16 0 .15.172.316.382.368.508.127.517.962.013 1.22-.615.315-1.289.214-1.908-.284-.69-.555-.773-1.12-.177-1.204.61-.087 1.194-.929 1.043-1.504-.081-.31-.255-.473-.503-.473-.463 0-.482.16-.054.46.304.213.304.256-.004.706-.601.877-2.049.572-2.532-.535-.36-.824-.366-.813.382-.813.36 0 .792-.051.962-.114.434-.16.911-1.113.77-1.54-.12-.36-.857-.51-.857-.173 0 .1.086.182.191.182.299 0 .225.673-.109.992-.748.715-2.381-.018-2.413-1.084a3.376 3.376 0 0 1 .12-.96c.151-.454 1.011-.957 1.637-.957.522 0 17.82 7.106 17.997 7.393.802 1.301 4.081 5.158 5.678 6.678 3.494 3.327 6.638 4.914 11.896 6.003 4.849 1.005 12.617 1.343 15.72.685 3.758-.798 7.365-2.285 10.792-4.451 2.896-1.83 4.721-3.265 7.662-6.026l2.6-2.44 1.864.052 1.864.053-1.102 1.37c-6.79 8.44-14.706 13.8-22.677 15.354-1.913.373-6.47.596-8.644.424z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cg fill='none' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.385' paint-order='markers stroke fill'%3e%3cpath d='M413.684 471.046c.995-3.536 7.473-26.508 7.473-26.508l1.97-4.342m-6.027 28.941c0-.291 6.019-28.908 6.019-28.908m-3.003 26.098c.21-1.27 2.785-21.197 2.785-21.197l.218-4.901' style='marker:none' transform='matrix(-1 0 0 1.00603 787.264 -141.848)'/%3e%3cpath d='m405.267 325.156 4.657.523m-3.587-4.454 4.132.655m-3.056-4.368 3.513.634m-2.536-4.347 3.092.579' style='marker:none' transform='matrix(-1 0 0 1.00603 776.576 -3.718)'/%3e%3cpath d='m420.228 447.356 2.48.553' style='marker:none' transform='matrix(-1 0 0 1.00603 787.264 -141.848)'/%3e%3cpath d='m405.637 323.277 4.657.523m-3.537-4.36 4.132.654m-3.08-4.391 3.512.634m-2.61-4.371 3.092.58' style='marker:none' transform='matrix(-1 0 0 1.00603 776.576 -3.718)'/%3e%3c/g%3e%3cpath fill='%23fec618' fill-rule='evenodd' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M355.552 304.616c-.478.323.108 2.122 2.098 2.018 2.5-.285 2.723-2.017 2.723-2.017s1.053 2.433 4.197 1.803c3.143-.63 4.47-3.995 4.47-3.995s.08.992 2.206.744c2.229-.592 2.569-3.217 2.569-3.217-6.058 1.602-12.17 3.088-18.263 4.664z' paint-order='markers stroke fill' style='marker:none'/%3e%3cpath fill='%23dd8b59' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M256.258 382.41h25.51v1.269h-25.51z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none' transform='matrix(.96841 -.24935 .271 .96258 0 0)'/%3e%3cg style='marker:none'%3e%3cpath fill='%23fec618' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M432.984 300.672s-1.755-.632-2.658-.553c-.874.077-1.56.85-2.428.973-.758.108-1.532-.341-2.288-.221-.694.11-1.919.84-1.919.84s1.236-.427 1.85-.31c.906.175 1.415 1.34 2.334 1.432.869.087 1.578-.912 2.45-.884.983.031 2.682 1.171 2.682 1.171z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3c/g%3e%3cpath fill='%23fec618' fill-rule='evenodd' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M404.583 284.44s-2.315 4.72-2.327 7.248c-.018 3.763 3.072 10.822 3.363 10.822.291 0 4.774-4.633 8.262-4.924 3.488-.291 11.226-.21 11.226-.21s-3.288-5.681-2.997-8.878c.29-3.198 4.184-9.978 4.184-9.978z' paint-order='markers stroke fill' style='marker:none'/%3e%3cpath fill='%23dd8b59' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M309.91 375.046h25.51v1.269h-25.51z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none' transform='matrix(.96841 -.24935 .271 .96258 0 0)'/%3e%3cpath fill='none' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.271' d='M350.237 321.831c1.019-.48.84-1.823-.258-1.782m-4.319-2.449c2.458 1.047 2.84-1.845 1.852-1.504m-.226 3.889c2.005.303 2.115-2.015 1.188-1.671' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cg fill='none' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.317' paint-order='markers stroke fill' style='marker:none'%3e%3cpath d='M414.44 467.944c.995-3.535 6.717-23.406 6.717-23.406l1.97-4.342m-6.121 28.205c0-.29 6.113-28.172 6.113-28.172m-3.511 28.375c.21-1.27 3.293-23.474 3.293-23.474l.218-4.901' style='marker:none' transform='matrix(-1.21616 0 0 1.2235 903.715 -236.92)'/%3e%3cpath d='m405.267 325.302 4.657.522m-3.587-4.396 4.132.654m-3.056-4.452 3.513.634m-2.536-4.414 3.092.579' style='marker:none' transform='matrix(-1.21616 0 0 1.2235 890.717 -68.932)'/%3e%3cpath d='m420.228 447.356 2.48.553' style='marker:none' transform='matrix(-1.21616 0 0 1.2235 903.715 -236.92)'/%3e%3cpath d='m405.637 323.398 4.518.589m-3.398-4.463 4.132.654m-3.08-4.452 3.512.634m-2.61-4.415 3.092.58m-7.231 14.685 4.963.514m-5.517 1.395 5.303.504' style='marker:none' transform='matrix(-1.21616 0 0 1.2235 890.717 -68.932)'/%3e%3c/g%3e%3cpath fill='%23fec618' fill-rule='evenodd' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M380.202 303.726s1.168 2.204 3.188 1.961c2.018-.242 2.041-2.296 2.041-2.296s1.215 3.161 4.35 2.492c3.134-.67 3.87-3.982 3.87-3.982s1.6 2.165 4.082.987c2.482-1.178 3.432-4.61 3.143-4.576-.288.035-20.674 5.414-20.674 5.414z' paint-order='markers stroke fill' style='marker:none'/%3e%3cpath fill='%23dd8b59' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M281.439 387.928h25.51v1.269h-25.51z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none' transform='matrix(.96841 -.24935 .271 .96258 0 0)'/%3e%3cpath fill='none' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.271' d='M405.364 303.16s1.787 11.317 4.99 15.941c1.668 2.407 6.977 5.523 6.977 5.523' paint-order='markers stroke fill' style='marker:none'/%3e%3cpath fill='%23fec618' fill-rule='evenodd' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M405.302 303.976c-.23.602 1.54 1.923 2.92 1.813 1.38-.109 1.73-1.156 2.094-1.626.321.56.875 2.971 4.395 1.816 2.919-1.072 2.68-2.793 3.09-3.187.25.067.71.648 1.347.672 2.507.094 4.673-4.167 4.397-4.145-.276.022-17.667 4.903-18.243 4.657z' paint-order='markers stroke fill' style='marker:none'/%3e%3cpath fill='%23dd8b59' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='M304.496 394.392h25.51v1.269h-25.51z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none' transform='matrix(.96841 -.24935 .271 .96258 0 0)'/%3e%3cpath fill='%23e96a01' fill-rule='evenodd' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.541' d='m418.203 321.717 27.871.582c.517-1 .33-1.552.034-2.035l-27.894-.29z' paint-order='markers stroke fill' style='marker:none'/%3e%3cpath fill='%23e6ab87' d='m352.252 304.395 23.967-6.164.18.642-23.983 6.163z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23efc9b2' d='m352.468 304.475 23.38-6.041.123.46-23.433 5.977z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e6ab87' d='m352.388 285.97 23.966-6.164.181.642-23.983 6.163z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23efc9b2' d='m352.603 286.05 23.38-6.041.124.46-23.433 5.977z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e6ab87' d='m355.17 277.17 18.096-4.654.137.485-18.109 4.653z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23efc9b2' d='m355.333 277.23 17.654-4.56.092.347-17.692 4.512z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e6ab87' d='m379.983 272.725 18.096-4.654.137.485-18.109 4.653z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23efc9b2' d='m380.146 272.786 17.653-4.562.093.348-17.693 4.512z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e6ab87' d='m405.076 274.964 18.095-4.654.137.485-18.109 4.654z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23efc9b2' d='m405.238 275.025 17.654-4.562.092.348-17.692 4.512z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e6ab87' d='m378.634 280.856 23.966-6.163.18.642-23.983 6.163z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23efc9b2' d='m378.849 280.937 23.38-6.042.123.46-23.433 5.977z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e6ab87' d='m402.328 283.93 23.966-6.162.181.641-23.983 6.164z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23efc9b2' d='m402.543 284.012 23.38-6.042.124.46-23.433 5.977z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e6ab87' d='m378.04 303.436 23.967-6.164.18.642-23.983 6.163z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23efc9b2' d='m378.256 303.516 23.38-6.041.123.46-23.433 5.977z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23fed65b' d='M373.268 285.873c-4.355 1.079-14.551 3.595-21.916 5.347a8.711 8.711 0 0 0-.06 3.294 13.259 13.259 0 0 0 1.33 3.945l20.436-4.759c-.673-1.468-1.114-3.166-.781-4.828.21-1.05.569-2.064.991-2.999z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23fedf82' d='M372.766 287.12c-2.645.668-15.246 3.846-21.584 5.368a9.079 9.079 0 0 0 .11 2.026c.194 1.162.534 2.208.945 3.142l20.443-4.89c-.44-1.232-.668-2.574-.403-3.894.12-.599.289-1.185.49-1.752z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23fed65b' d='M423.76 283.506c-4.502 1.126-15.612 3.884-20.827 4.986-.376 1.136-.672 2.303-.677 3.196-.006 1.388.412 3.223.955 4.988l19.423-4.883c-.366-1.175-.61-2.344-.523-3.295.118-1.305.84-3.199 1.65-4.992z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23fedf82' d='m423.003 285.302-20.504 4.737c-.138.594-.24 1.167-.243 1.65-.004.942.186 2.091.48 3.284l19.495-4.744c-.113-.619-.168-1.21-.12-1.73.078-.87.432-2.007.892-3.197z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e6ab87' d='m402.205 303.892 23.966-6.163.18.642-23.983 6.163z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23efc9b2' d='m402.42 303.973 23.38-6.041.123.46-23.432 5.976z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cuse xlink:href='%23c' id='d' width='100%25' height='100%25' x='0' y='0' fill='%23520' stroke='%232b1100' transform='translate(14.52 2.971)'/%3e%3cg fill='%23520' stroke='%232b1100' transform='translate(-.135)'%3e%3cellipse id='e' cx='367.833' cy='328.845' fill='%23520' fill-opacity='1' fill-rule='evenodd' stroke='%232b1100' stroke-dasharray='none' stroke-dashoffset='0' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='4' stroke-opacity='.996' stroke-width='.541' opacity='1' paint-order='markers stroke fill' rx='.955' ry='.913' style='marker:none' vector-effect='none'/%3e%3cuse xlink:href='%23d' width='100%25' height='100%25' transform='translate(23.503 -8.526)'/%3e%3c/g%3e%3cg fill='%23520' stroke='%232b1100' transform='translate(-.101)'%3e%3cuse xlink:href='%23e' id='c' width='100%25' height='100%25' x='0' y='0' fill='%23520' stroke='%232b1100' transform='translate(8.712 5.555)'/%3e%3cuse xlink:href='%23c' width='100%25' height='100%25' transform='translate(29.243)'/%3e%3c/g%3e%3c/g%3e%3cpath fill='none' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.232' d='m288.864 682.347 8.903 2.593c2.214 10.233 21.926 16.04 34.514 14.994 10.772-.896 19.986-8.545 26.775-17.513' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none' transform='matrix(1.48121 0 0 1.54883 419.01 -682.25)'/%3e%3cpath fill='none' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.232' d='M296.071 684.503c.63 6.791 9.553 18.81 33.508 18.81 23.2 0 32.449-21.02 32.449-21.02' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none' transform='matrix(1.48121 0 0 1.54883 419.01 -682.25)'/%3e%3cpath fill='none' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.269' d='M293.562 683.837c.728 7.865 8.265 24.187 36.005 24.187 26.866 0 36.456-25.455 36.456-25.455' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none' transform='matrix(1.48121 0 0 1.54883 419.01 -682.25)'/%3e%3cpath fill='none' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.301' d='M291.315 683.184c-.235 5.794 8.842 29.466 38.189 29.072 26.032-.35 36.788-23.303 39.244-29.58' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none' transform='matrix(1.48121 0 0 1.54883 419.01 -682.25)'/%3e%3cpath fill='none' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.042' d='M901.958 406.694c-12.297-.727-22.395-3.729-30.346-9.025-2.337-1.556-3.715-2.678-5.706-4.643-4.184-4.13-6.944-8.862-7.88-13.512-.13-.647-.205-1.208-.166-1.247.039-.038.513.065 1.054.229l.984.298.167.736c.25 1.106 1.029 2.904 1.831 4.225 1.963 3.235 5.22 6.342 9.414 8.984 1.893 1.193 6.193 3.338 8.579 4.28 11.147 4.405 24.698 6.256 34.164 4.665 9.475-1.59 18.61-6.778 27.377-15.546 3.237-3.237 5.486-5.833 8.494-9.801l1.067-1.409 1.829.023c1.005.013 1.853.05 1.883.08.032.03-.371.87-.895 1.862-2.577 4.9-6.193 9.87-10.258 14.104-8.867 9.238-19.835 14.592-32.043 15.645-1.536.132-7.617.164-9.549.05z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='none' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.042' d='M904.291 414.053c-7.36-.216-14.667-1.43-20.583-3.418-2.954-.992-4.149-1.488-6.933-2.877-8.738-4.358-15.029-10.568-19.108-18.863-1.78-3.62-3.061-7.691-3.462-11.006l-.1-.82.37.091c.202.052.923.264 1.601.472l1.232.38.195 1.197c.106.658.439 1.936.738 2.838 2.695 8.132 10.1 15.438 20.154 19.88 4.612 2.037 10.385 3.648 16.135 4.502 5.925.878 13.958 1.094 18.846.504 13.361-1.611 25.11-8.457 34.401-20.044 2.51-3.132 4.764-6.573 6.5-9.926l1.05-2.03 2.706.1c1.489.057 2.722.115 2.74.133.076.063-1.158 2.764-2.232 4.889-2.444 4.834-5.487 9.438-9.115 13.792-1.779 2.135-5.611 5.98-7.621 7.643-8.293 6.868-17.347 10.863-27.539 12.152-1.877.238-6.62.522-7.922.475a361.97 361.97 0 0 0-2.053-.064z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='none' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.042' d='M902.878 420.574c-9.436-.558-16.674-2.363-23.891-5.957-9.716-4.837-17.754-12.688-23.076-22.539-2.141-3.964-3.983-8.779-4.65-12.167-.384-1.948-.593-3.819-.425-3.819.058 0 .694.17 1.412.377l1.306.378.09.719c.325 2.638 1.154 5.884 2.15 8.428 4.307 10.99 12.856 19.306 24.73 24.052 5.456 2.18 11.458 3.542 18.816 4.27 2.958.292 12.105.249 14.571-.07 11.252-1.45 20.756-5.79 29.514-13.474 1.705-1.496 4.791-4.67 6.353-6.533 4.423-5.277 8.65-12.077 11.022-17.732l.56-1.335h1.623c.894 0 1.669.046 1.725.103.267.267-3.269 7.922-5.346 11.569-5.915 10.389-13.331 18.687-21.753 24.338-7.824 5.249-16.343 8.281-25.819 9.189-1.63.157-7.454.288-8.914.203z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='none' stroke='%23512007' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='.996' stroke-width='.042' d='M900.261 423.107c-4.98-.355-9.044-1.045-13.242-2.249-14.592-4.186-26.494-14.208-34.205-28.802-2.76-5.226-5.167-12.287-5.423-15.911l-.083-1.183.692.212c.382.117 1.021.312 1.422.43l.728.216.099 1.162c.487 5.774 3.573 13.487 8.051 20.118 8.957 13.266 22.574 21.505 38.918 23.55 22.39 2.8 41.341-5.014 55.508-22.89 4.58-5.78 8.984-13.328 11.812-20.254l.895-2.193 1.078-.04 1.077-.042-.214.749c-1.343 4.69-3.868 10.567-6.54 15.224-7.202 12.552-17.42 21.757-29.937 26.97-6.487 2.702-13.688 4.33-21.583 4.882-1.866.13-7.496.162-9.054.051z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23fec413' d='M902.556 406.645c-12.884-.658-23.64-3.947-31.928-9.764-4.454-3.125-8.382-7.53-10.515-11.79-1.114-2.223-2.117-5.249-2.12-6.392v-.379l.813.224c.447.122.864.268.927.323.063.054.21.474.325.933.315 1.243 1.75 4.079 2.753 5.437 2.38 3.225 6.098 6.312 10.53 8.743 8.911 4.886 20.36 7.901 31.55 8.31 11.702.428 21.513-3.175 31.76-11.663 2.188-1.814 8.076-7.72 9.952-9.984a153.606 153.606 0 0 0 2.961-3.713l1.446-1.884h3.61l-.703 1.4c-4.04 8.05-11.37 16.505-18.696 21.563-6.49 4.48-13.852 7.318-21.526 8.295-2.128.27-8.62.47-11.14.341z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e9b001' d='M904.678 413.995c-8.401-.268-15.838-1.59-22.636-4.027-2.103-.753-6.353-2.805-8.655-4.178-4.45-2.656-8.592-6.345-11.587-10.32-3.01-3.997-5.559-9.221-6.755-13.846-.41-1.59-.92-4.315-.825-4.41.024-.024.707.153 1.519.392l1.475.436.245 1.252c.737 3.754 2.645 7.741 5.314 11.1 3.506 4.413 9.047 8.606 14.884 11.264 8.273 3.766 17.848 5.637 28.875 5.641 4.028.002 6.296-.156 9.119-.634 11.816-2.002 22.232-8.103 30.729-18 3.245-3.78 6.257-8.252 8.292-12.311l.656-1.309 1.236.017c.68.01 1.886.058 2.68.107l1.442.088-.492 1.132c-.91 2.09-2.84 5.804-4.16 8.004-3.427 5.71-7.544 10.826-12.183 15.137-8.57 7.964-18.989 12.837-30.048 14.057-2.083.23-6.722.525-7.479.476a75.01 75.01 0 0 0-1.646-.068z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23e98e01' d='M899.537 420.244c-7.384-.802-12.941-2.238-18.656-4.821-10.16-4.592-18.562-12.312-24.313-22.338-1.788-3.118-3.677-7.52-4.6-10.718-.544-1.888-1.05-4.575-1.05-5.577 0-.578.026-.624.298-.538.163.052.713.214 1.221.359.509.145.95.29.98.32.03.03.15.653.266 1.383.643 4.052 1.76 7.49 3.673 11.304 2.075 4.137 4.514 7.426 8.08 10.896 8.843 8.605 21.702 13.416 37.471 14.02 8.573.328 14.055-.284 20.657-2.304 10.744-3.289 20.886-10.681 28.515-20.785 3.453-4.573 6.922-10.442 8.752-14.808l.608-1.45h.53c.29 0 1.017.04 1.614.091 1.278.108 1.272-.184.056 2.667-1.896 4.448-5.072 10.37-7.508 14.002-8.641 12.884-19.25 21.463-31.744 25.672-3.427 1.155-6.703 1.902-10.938 2.495-2.292.32-11.374.405-13.912.13z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3cpath fill='%23d05f01' d='M900.929 423.062c-5.757-.428-9.506-1.044-13.752-2.259-8.644-2.472-16.143-6.823-22.638-13.134-4.962-4.821-8.967-10.312-12.129-16.627-2.618-5.23-4.572-11.155-4.955-15.03l-.093-.944 1.275.381c.701.21 1.309.416 1.35.457.041.041.144.708.228 1.482.422 3.88 1.99 8.727 4.34 13.42 6.088 12.157 16.141 21.463 28.407 26.296 7.103 2.8 14.393 4.113 22.848 4.118 5.412.004 9.476-.454 14.184-1.597 12.992-3.153 24.113-10.666 33.32-22.51 1.728-2.223 4.454-6.296 6.108-9.125 1.475-2.524 4.135-7.886 5.229-10.54l.845-2.051.993-.042.993-.041-.208.678c-.114.373-.275.922-.357 1.22-.082.297-.463 1.398-.847 2.446-3.607 9.864-9.076 18.615-15.906 25.453-10.265 10.275-23.074 16.134-38.625 17.666-2.046.202-9.157.391-10.61.283z' color='%23000' overflow='visible' paint-order='markers stroke fill' style='isolation:auto;mix-blend-mode:normal;solid-color:%23000;solid-opacity:1;marker:none'/%3e%3c/svg%3e";
            },
            2883: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-19 -10 38 20'%3e%3cpath fill='%2375b2dd' d='M-19-10h38v20h-38z'/%3e%3cg id='c' fill='%23fff' transform='translate(0 -6)'%3e%3cg id='b'%3e%3cpath id='a' d='M0-2v2h1' transform='rotate(18 0 -2)'/%3e%3cuse xlink:href='%23a' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(72)'/%3e%3cuse xlink:href='%23b' transform='rotate(144)'/%3e%3cuse xlink:href='%23b' transform='rotate(216)'/%3e%3cuse xlink:href='%23b' transform='rotate(288)'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='rotate(90)'/%3e%3cuse xlink:href='%23c' transform='rotate(180)'/%3e%3cuse xlink:href='%23c' transform='rotate(270)'/%3e%3c/svg%3e";
            },
            2619: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 16'%3e%3cpath fill='%23FFF' d='M0 0h22v16H0z'/%3e%3cg fill='%230065BD'%3e%3cpath d='M6 0h4v16H6z'/%3e%3cpath d='M0 6h22v4H0z'/%3e%3c/g%3e%3cg fill='%23ED2939'%3e%3cpath d='M7 0h2v16H7z'/%3e%3cpath d='M0 7h22v2H0z'/%3e%3c/g%3e%3c/svg%3e";
            },
            9206: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 2'%3e%3cpath fill='%23ED2939' d='M0 0h3v2H0z'/%3e%3cpath fill='%23fff' d='M0 0h2v2H0z'/%3e%3cpath fill='%23002395' d='M0 0h1v2H0z'/%3e%3c/svg%3e";
            },
            9297: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 300'%3e%3cpath fill='%233a75c4' d='M0 0h400v300H0z'/%3e%3cpath fill='%23fcd116' d='M0 0h400v200H0z'/%3e%3cpath fill='%23009e60' d='M0 0h400v100H0z'/%3e%3c/svg%3e";
            },
            4170: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 25 15'%3e%3cpath fill='%23FFF' d='M0 0h25v15H0z'/%3e%3cg fill='%23CE1124'%3e%3cpath d='M11 0h3v15h-3z'/%3e%3cpath d='M0 6h25v3H0z'/%3e%3c/g%3e%3c/svg%3e";
            },
            9488: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 30'%3e%3cclipPath id='a'%3e%3cpath d='M0 0v30h60V0z'/%3e%3c/clipPath%3e%3cclipPath id='b'%3e%3cpath d='M30 15h30v15zv15H0zH0V0zV0h30z'/%3e%3c/clipPath%3e%3cg clip-path='url(%23a)'%3e%3cpath fill='%23012169' d='M0 0v30h60V0z'/%3e%3cpath stroke='%23fff' stroke-width='6' d='m0 0 60 30m0-30L0 30'/%3e%3cpath stroke='%23C8102E' stroke-width='4' d='m0 0 60 30m0-30L0 30' clip-path='url(%23b)'/%3e%3cpath stroke='%23fff' stroke-width='10' d='M30 0v30M0 15h60'/%3e%3cpath stroke='%23C8102E' stroke-width='6' d='M30 0v30M0 15h60'/%3e%3c/g%3e%3c/svg%3e";
            },
            3782: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 600'%3e%3crect width='100%25' height='100%25' fill='%230065BD'/%3e%3cpath stroke='%23fff' stroke-width='120' d='m0 0 1000 600M0 600 1000 0'/%3e%3c/svg%3e";
            },
            1365: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 830 498'%3e%3cpath fill='%2300ab39' d='M0 249h830v249H0z'/%3e%3cpath fill='%23fff' d='M0 0h830v249H0z'/%3e%3cg stroke='%23000' stroke-width='1.8'%3e%3cpath fill='%23d21034' d='M543.282 29.532c-.011.02-.019.044-.031.063.033-.018.061-.044.094-.063h-.063zm-.031.063c-52.242 28.887-99.003 58.945-144.969 97.25-22.06 19.27-15.833 34.631-16.687 51.937.711 11.618-2.511 22.426-9.656 28.938-16.35 3.306-32.715 6.632-49.063 9.938-1.566-4.524-3.121-9.042-4.687-13.563 1.495-6.94 7.232-10.352 19.312-6 .952-8.923-6.227-12.555-14.625-15.656-2.885-2.246-6.468-3.971-6-11.688-1.412-17.467 26.615 1.25 26.875 1.25.261 0-.934-17.627-13.812-21.156-7.022-2.485-9.994-9.892-7.313-15.375 5.618-11.209 16.194.878 24.282 1.312-.304-7.316-2.387-12.531-8.688-18.437-3.392-2.087-11.722-3.657-11.938-7.156-.176-4.752 7.808-6.784 18.782-5.469-2.288-6.66-9.668-10.968-19.813-14.094l-6-10.437c-2.841-5.26-4.115-5.402 2.469-15.375 5.915-3.827 13.774-9.237 19.688-13.063l-6.532-.781c.869-7.131.969-9.53 2.625-21.375-6.346 8.672-14.275 7.121-21.406 10.687 0 0-20.33 3.61-26.875 12.25-.261 0-51.125-2.593-51.125-2.593-10.84 1.51-20.099 4.582-21.906 15.125-24.792 2.502-50.755.289-69.657 24 12.87-.609 24.136-3.674 38.594-1.813 0 0 12.321.233 14.875 13.281.261.522 4.188.532 4.188.532 1.566 1.217 3.121 2.439 4.687 3.656.609-1.652 1.204-3.317 1.813-4.969l4.187 2.875c.434-1.826.879-3.642 1.313-5.469 1.392.957 2.764 1.919 4.156 2.875.087-2.174.195-4.357.281-6.53l5.469 3.905v-8.593s20.192-.047 26.344 12.781c.262.261-56.665 10.463-111.657 5.75 5.306-2.609 10.602-5.235 15.907-7.844-20.05-4.076-38.901-7.761-56.594-21.656 6.677 25.137 41.181 54.663 48.25 54.531 0 .261-6.781-12.25-6.781-12.25 19.916.87 39.835 1.725 59.75 2.594 2.175 6.61 1.213 14.02 6.531 19.844 0 0-3.299 10.925 4.031 15.375.262.521 8.75-22.157 8.75-22.157s2.6 6.101 5.219 10.157c3.795-19.508 25.031-22.688 25.031-22.688s4.438 10.176 4.438 10.438c-6.636.96-14.89 14.486-10.438 21.906-4.45.085-12.351 13.186-9.906 20.344-3.741 3.723-13.058 8.686-10.688 24.281-7.334 1.572-11.676 14.991-9.406 29.219-11.349 10.564-8.563 29.956 1.563 37.812-4.203 3.74-6.791 6.616-6.781 11.219-3.996-1.485-7.68-.244-9.407 2.375-4.898-5.021-11.931-9.418-16.937-4.719-1.296-5.94-9.032-12.474-17.5-11.718.496-6.264-2.755-14.018-11.719-16.719 0 0-1.814-29.358-10.719-38.875-.873-5.326.51-8.948 7.844-13.313 7.323-3.906 8.879-6.935 8.344-18 2.887-7.396 5.08-14.936-3.906-20.062.27 8.795-2.43 13.031-6 16.937-4.266-.621-5.756 4.358-8.626 6.532-4.016-5.414 8.472-13.799-.781-25.844-.521-.523-6.459-15.723-21.125-15.375 6.971 4.082 9.92 10.951 9.906 18-4.624 13.045-6.973 23.127-2.343 38.093-6.093-9.128-9.549-26.482-14.594-29.5-4.422-.862-6.582-11.321-23.75-8.343 7.406 1.992 9.757 7.647 11.75 12.781-4.541 2.342-2.285 8.519 1.031 12.781-.63 10.015 5.37 15.866 14.344 19.594-1.478 13.653-2.96 27.283-4.438 40.937-3.564-.454-9.05 13.425-11.218 13.844-3.489 2.171-9.581 8.01-2.594 9.656-2.076 7.492-4.001 12.009-15.156 13.563 0 0 11.787 6.991 21.562-4.969 10.474-.262 7.03-12.752 12.094-18.25 0-.26 2.874-2.066 7.062-13.062 1.832 9.819 11.908 39.888 34.688 54.812 19.856 21.256 36.175 41.33 36 69.656 7.75-7.208 12.378-18.624 15.938-29.5 10.776-3.748 26.191-5.179 39.937-4.562-2.358 4.961-4.997 9.721-1.594 12.938-9.593 3.294-11.695 10.256-7.843 17.218-10.112 6.867-10.778 11.28-10.938 22.688-18.708 23.985-30.249 23.188-48.781 16.968-6.086-3.572-15.505-8.714-19.844-6-8.004-5.334-19.512-6.126-21.406 6 6.006-4.978 9.592-4.018 14.375.782-.962 2.436-1.766 4.862 1.812 6.25-1.566 1.739-3.121 3.48-4.687 5.218-8.613-1.324-20.194-1.25-23.219 11.219 4.424-3.665 14.24-4.525 22.156-1.031 1.479.522 2.959 1.04 4.438 1.562.174 2 .358 4 .531 6 0 0-11.732-1.811-14.875 17.219 11-11.702 18.781-8.625 18.781-8.625 4.239 6.205 19.841 5.271 31.063-4.937 15.762-8.812 20.357 3.851 30.531-4.438 8.436-6.292 18.417-2.108 25.281 5.219 7.915 2.969 16.2 5.413 22.719 0 0 0 7.963-5.081 15.906 3.125.087-9.253-6.47-14.169-15.375-14.344l-2.625-2.625c-8.349-1.74-17.73-1.034-25.031-5.218 3.442-13.066 8.457-24.904 18.25-34.969 12.088-12.958 20.987-18.85 36.25-38.688-.589 11.211 8.003 23.677 12.531 35.063 0 0 9.116-14.555 10.438-26.375.26 0 11.423-5.81 16.187-10.75 10.056 6.237 26.446-4.994 37.032-14.281 6.524 2.47 11.478 2.292 19.062 0-6.088 12.39 3.521 23.883 18.781 28.687 1.411 10.938 12.459 13.229 29.219 13.313.706 6.436 10.688 7.312 10.688 7.312-6.308 2.94-9.596 5.886-9.376 12.531-6.464.044-11.36 1.671-13.062 9.125-8.876.152-17.922.833-25.562 5.219-8.176-1.269-18.122-4.657-24.532-11.219-3.306-2.783-4.131-6.796-9.906-8.344-3.66-4.326-8.039-3.36-9.406.782-3.783-2.955-17.972-4.328-20.344 9.125 6.624-4.848 12.564-6.696 16.719-.781-2.264 4.106 5.516 6.455 12.25 8.093 4.776.296 13.247 4.647 15.906 12-6.16 1.869-15.496 1.253-21.656-3.406-5.476-4.582-12.872-4.036-16.938-1.031-5.64-3.596-19.071 3.193-19.593 14.062 5.658-5.184 10.807-7.691 15.937-4.406-2.553.606-1.583.855-1.313 2.344l13.032 7.562c-6.394 1.687-12.405 4.238-9.625 16.156 0 0 5.208-10.296 16.937-6.5.261-.26 1.617 3.678 4.969 1.032 5.076-5.776 16.682-8.362 26.875-9.375 8.18-.977 16.347-3.387 23.469 1.281 6.341-3.262 13.401-5.456 20.625-.25 8.523 2.696 14.746 12.631 25.562 8.094 5.379-3.723 11.99-3.912 18.782 3.656.082-9.543-7.069-12.742-17.219-14.875-2.349-1.393-4.683-2.795-7.031-4.187-6.522-.958-13.072.198-19.594-2.876 34.134-8.824 58.062-27.859 74.906-55.031 5.392 1.913 10.764 3.805 16.156 5.719 3.825.245 4.117 1.574 12 3.938.297-11.614-4.689-23.578-25.562-24.782l-27.406-10.437c-5.818-6.135-8.447-19.152-1.032-26.875 7.258-6.463 8.525-5.689 13.313-13.563 5.822-.53 11.309 5.469 16.687 5.469 2.554 7.587 17.274 14.294 26.625 12 5.859 5.187 17.008 8.07 29.219 3.906 6.93 6.067 15.959 8.6 26.594 3.906 2.823 2.824 8.783 5.069 15.656 3.657.522 0 3.473 7.541 10.969 10.187-3.268 3.176-1.259 16.966 2.093 21.906-2.288 5.302-3.008 10.958-1.062 16.438-7.559 4.86-9.098 8.475-5.719 16.688-9.899 15.906-21.741 17.724-32.875 12.812-4.002-2.522-7.998-5.071-12-7.594-4.261-4.175-8.52-8.325-12.781-12.5-2.17-2.037-6.66-2.677-7.594 1.813 0 0-16.399-3.658-17.719 10.187 6.798-6.62 16.438-.792 16.438-.531s-2.296 1.823-.531 4.469c.397-.331 11.973 4.32 22.281 8.75 5.6 2.122 6.831 2.786 9.281 4.094a441.984 441.984 0 0 0-9.281-4.094c-6.275-2.379-12.388-4.279-14.188-3.813-5.84-.545-12.034-1.27-14.874 3.125-6.278 2.656-16.084 4.783-15.657 16.438 4.239-6.94 10.055-6.647 17.469-6-.174.522-.326 1.04-.5 1.562 8.05 3.667 6.523-.998 14.031-1.687 6.277-.576 15.174 1.672 19.875 3.25-5.913 1.739-13.954 1.009-17.75 5.219-.696 1.392-3.131.823-2.062 4.156 0 0-11.534-.298-14.625 15.656 11.728-7.509 20.615-7.281 20.875-7.281.261 0 3.656.781 3.656.781s14.084-9.406 14.344-9.406c.262 0 13.638-5.923 19.812.781 5.389 2.649 11.153 2.818 16.719-.531 10.966-4.77 21.231-5.104 31.313 1.594l9.124 5.468c1.304-.869 2.603-1.755 3.907-2.625 0 0 10.329-2.917 17.906 6.281-3.132-15.914-14.5-16.437-14.5-16.437-.87-.783-1.756-1.561-2.625-2.344-5.392-2.087-10.764-4.194-16.156-6.281-2.354-5.826-8.268-10.465-2.375-17.469 6.02-29.926 13.218-52.401 1.562-82.719 10.871 4.696 19.005 19.217 32.625 14.094 0-12.176-44.822-35.294-79.062-53.875 56.094-2.87 123.51-44.277 97.594-96.906 4.088-12.697 8.162-25.397 12.25-38.094 5.77 11.623 17.453 20.483 27.937 24.25-8.641-16.496-13.6-66.93-8.625-101.75-22.603 27.922-47.563 52.702-74.094 77.875 13.05 3.05 24.453.904 37.063-.656-3.566 7.305-7.029 14.632-10.594 21.938-34.473-20.188-74.947-5.038-75.25 21.906 1.179 31.42 40.027 35.885 62.437 24.937-4.442 28.647-70.281 18.094-70.281 18.094-23.394-8.064-45.613-6.683-70.187-6.5 5.106-15.71 33.46-29.652 55.062-23.5-30.243-33.91 4.275-76.008 45.906-88.97-45.376-14.965-6.304-49.557 27.657-74.343 0 0-97.663 41.101-106.563 40.969-27.779-2.087-20.207-34.967-9.625-52.656zM236.72 69.064c2.273.012 4.945.234 7.062.75 4.404 1.073 9.763 1.688 9.688 3-2.039 3.412-7.047 7.529-11.969 7.281-4.921-.248-7.766-3.198-9.406-10.594.503-.272 2.352-.45 4.625-.437zm411.094 115.875c6.403-.088 14.074 2.62 21.562 10.562-3.6 10.37-34.842 15.697-36.937.344-.633-4.641 6.016-10.78 15.375-10.906z'/%3e%3cpath fill='none' stroke-linejoin='round' d='m268.98 159.71 4.737 6.891m-.215.217s0 9.259 1.938 9.476m-4.307 4.952c.215.216 4.954 8.184 4.954 8.184m-13.569 2.153c.215 0 6.031 6.677 6.031 6.677m5.051-5.18c0 .215 5.501 10.565 5.932 10.565m-13.136-3.447s1.938 12.491 3.66 12.061m-11.801 10.828 5.556 8.339m4.738-17.229s3.015 11.845 5.383 10.767m2.364-17.879c.216.215 5.606 7.974 7.112 6.897m-1.291 3.014 5.168 10.338m-13.783-2.37c.215.432 4.307 12.277 4.307 12.277m-14.214-6.03s3.877 13.137 7.323 10.982m-8.83 6.462s.215 6.891 3.661 7.321m2.37-10.767c0 .215 3.445 4.954 3.445 4.954m6.398-13.149 2.862 4.534m6.246-12.921 4.308 5.383m-24.293-67.137c.215 5.815 9.437-2.048 13.098-7.002m-17.018 27.19s10.122-7.107 17.875-17.875m-21.106 34.889c7.107-1.938 20.183-17.753 22.767-26.152m-24.275 41.873c1.94.861 26.367-16.732 27.014-29.653m-27.659 43.221c0-.215 22.33-5.693 31.591-30.244m-32.79 48.826s35.657-21.381 37.595-37.102m240.77 73.006s-2.299 18.453-20.82 21.252m26.635 11.699c.215-.216 17.659-19.383 13.137-25.198m27.351 6.676s-.215 13.353-11.199 22.613m32.95-18.735s.432 16.151-6.46 22.612m26.488-12.922s-7.727 15.126-10.526 16.634m10.191 10.173s10.167 2.534 13.397-4.143m-10.761 26.084s9.399 1.697 13.706-7.347m-14.714 24.284s7.607 6.391 12.776-2.007m-121.95-122.44s-.862 32.735 45.225 39.41c51.472 14.215 75.807 6.677 78.823 64.394-1.938 21.967-4.668 46.778-20.604 37.301m-152.32-110.95s7.323 13.136 16.152 12.275c11.629-3.446 15.936 3.661 15.936 3.661m-63.53-2.8s19.383 9.476 35.964-5.815m-33.811-7.753c1.722 22.613-26.059 35.535-37.043 33.382m38.36 53.27c.216 0 15.05-8.905 12.036-15.152m-41.566 1.94c.431-.432 24.982-2.801 29.505-11.631m-40.919-24.552c0-.215 34.845.097 37.213 6.557m9.09-27.231s-34.028 58.148 28.858 58.148m-64.824-59.01s-7.323 21.753-17.66 29.074m-18.52-36.61s12.636 24.449-.071 36.509m-32.879-29.618c.215.43 4.091 34.673-4.524 44.364m-11.843-43.287s1.291 21.751-5.169 29.504c-6.462 7.753 1.513 23.856 1.513 23.856m-78.5 10.457s4.624 8.114 11.086 5.313m-3.231-23.042s10.337 4.522 13.783 2.799m-2.584-39.411s-15.291 4.307-9.476 22.397c8.829 7.108 17.444 6.03 17.444 6.03m-38.119 48.456c-.215 0 1.723 14.215 11.63 3.446 6.891-14.428 28.643-55.132 33.597-69.131m10.121-6.675s-10.553-8.184-10.121 3.23c-.217 7.106 3.229 8.829 3.229 8.829.43 5.169 4.954 12.49 8.614 5.815 1.508-6.461-1.076-9.261-1.076-9.261m6.03-11.63c-9.476-.646-14.644 20.245 3.662 7.11m6.245-14.216s-2.368 3.232-6.03-.215c-1.939-3.445-8.829 15.507 3.231 16.152 2.153-5.6 8.83-7.107 8.83-7.107m5.6-17.875s-5.385 2.584-7.323 2.153c-6.461 1.508-5.17 16.584 3.014 15.722 2.799-3.23 5.815-7.753 5.815-7.753m-52.29-29.83c-.216 0-21.372 33.268 11.794 42.098m256.71-92.175s-12.922 10.984-.862 28.643c-40.058-.645-61.592 17.875-63.315 30.365-51.041-3.66-41.78 11.416-58.364 16.368-22.182-18.521-54.702-8.183-52.548 10.337-14.861-20.89-37.688-10.767-40.487-5.599-2.8 5.169-1.723-25.628-1.723-25.628s-14.86 6.677-25.199 18.952c.217-8.183 0-21.536 0-25.843-12.418 2.512-24.407 2.654-37.257 2.369m-33.596-9.476s18.52 10.337 41.349-3.661m-42.857-33.596s14.43 12.92 41.566 8.829m-32.52-38.55s3.229 10.553 34.243 11.199m-23.74-35.604s11.679 14.283 27.4 12.13m-17.443-32.52s4.522 7.753 21.751 9.045m-11.631-31.658s9.046 9.907 19.384 8.184m34.431-88.698s4.006-4.005 10.682-2.003m-13.573 23.142s-12.463-.445-11.573-5.34c.892-5.563 13.13-9.569 13.13-9.569s16.243-10.458 18.691-14.019m-73.432 56.966 15.8 30.263 7.565-11.349 4.006 7.788 6.453-11.348 11.126 7.12-4.228-13.796 9.345-.667s-2.448-6.676-10.904-8.01c2.226-1.78 10.014-6.899 10.014-6.899s-4.449-5.118-11.348-5.34c2.225-2.448 5.34-8.456 5.118-8.456-.222 0-6.899-1.558-6.899-1.558s15.8 5.118 28.038-2.003m-30.25-24.467c.222.223-.891 6.231-4.229 9.791m-56.742 6.899s9.774-2.69 17.088-1.165c7.245 1.488 16.958 4.057 16.958 4.057s11.57-1.557 15.354-4.228m-73.656 7.789s-1.334 4.672-1.779 7.788c0 2.225-7.122 5.118-7.122 5.118m13.353-22.475s6.23 7.788 6.452 12.238c.223 4.45-4.672 7.789-4.672 7.789m-66.089 33.156-6.454-10.458 5.786-2.003m117.2 156.72c-5.168-6.676 3.876-109.19 23.044-135.89-6.676 48.24 15.506 97.558 21.105 97.343m-102.4-125.99s8.722 3.337 26.812-10.984m24.443 34.676 12.975.16m389.49-80.51s-216.19 101.02-219.34 106.37c36.505-11.015 191.33-36.82 195.11-34.616-9.126 2.203-197 45.315-205.81 55.7 46.889-1.573 145.08 15.106 160.49 31.155-33.358-7.552-133.12-22.343-163.64-15.735 22.344 5.35 107.94 60.737 107.94 69.548-12.902-12.272-115.81-54.757-119.9-50.665 23.6 14.16 56.96 66.714 56.958 79.617-6.923-11.014-66.4-74.898-69.861-70.807 6.294 8.813 18.766 84.222 12.39 87.717 0-9.126-23.09-75.13-24.978-77.017-4.721 1.258-34.152 80.528-28.321 87.899-3.776-26.433.628-81.604 7.866-79.402-12.901 1.888-54.078 56.18-49.673 64.677 1.259-13.532 3.1-22.507 26.386-67.51-25.805 1.573-79.302 35.247-88.43 47.205 7.239-21.398 52.555-57.59 72.381-60.107m93.316-78.747c22.85-12.68 93.46-38.557 140.56-57.543m-184.91 125.78s15.576-.222 31.153-42.501c15.35-57.85 137.07-122.38 139.52-134.4m-376.67 235.07s-3.615 7.703-8.066 9.929m25.525 1.744s-4.829 9.382-5.942 13.832m22.65-9.243s4.052 12.803.714 18.812m-47.239-52.053c-12.238 6.899 6.964 50.494 65.041 54.722m-9.346-23.587s-1.557 7.788 9.346 23.365c-3.115 17.356 13.195 30.996 19.649 33.22m-33.67-213.01c0-.222 1.78-4.672 1.78-4.672l1.984 5.144 3.193-.083 2.107-5.158 1.73 5.177h3.173l1.957-5.748 2.957 5.442 2.512.128 1.977-6.63 4.077 4.75 1.481-.574 1.27-6.632 4.028 4.638 1.155-.677 1.868-6.536 3.345 4.86 1.685-.55 1.563-5.492 3.11 5.048m-50.532 8.149 24.274-.361c7.723-.115 20.442-10.82 34.684-7.481m-110.12 59.774s4.005 8.679 9.569 3.783m-18.914 2.003s-7.789 20.917 1.557 25.81M129.47 158.45s0 4.895 10.236-2.67M97.633 268.37s8.233 2.448 6.898 8.679m-3.788-104.81s5.118 2.448 10.014-5.117m44.282 245.89c8.01-.445 9.735 3.172 17.023 3.172 8.396.256 16.577-3.172 27.26-6.065m68.757 19.36c-.223 0-3.783 7.565-.667 11.347m-113.49-10.68s12.685-10.46 19.36-4.005c6.454 2.226 10.013 1.78 10.013 1.78m-22.69-27.59s3.115 8.01-7.344 6.898m-3.115 11.57s6.675 4.23-.89 9.792m4.895 7.566s9.123 1.336 3.782 8.678m290.91-64.115s24.776 2.564 25.915 4.415c2.85-2.991 24.972-20.911-2.225-23.473-4.555 18.654-23.263 19.343-23.69 19.058zm-8.828 12.388c9.255 7.404 5.463 11.84 34.513-7.666m-47.756 16.923s13.67 14.667 23.637-3.134m-49.695 8.402-18.51 9.682m-33.322 13.67s11.25-9.682 16.518-4.556c5.268 5.126 27.624-4.413 27.624-4.413m-35.74-33.037s3.845 7.689-3.56 8.686m-11.107 15.379s3.901 7.23-3.646 9.223m12.332 10.428s11.677.569 7.547 9.397m101.67-10.964s-6.408 5.41-1.708 11.535m94.691-50.408s7.404 3.559-1.424 9.683m-7.404 12.815s5.553 5.839 1.851 10.679m13.67 11.676s7.688 2.136 6.835 8.544m100.81-14.24s-6.408 4.699-2.99 10.823m-111.139-197.97c15.38-1.852 37.45 32.322 48.698 39.015m67.272-87.425s7.79 6.8.936 23.205m13.505-49.366c2.167 1.686 10.54 6.154 16.07 16.496m5.311-67.659c0 .142-10.822 29.191-10.822 29.191m22.925-30.615s-2.136 25.915-5.268 31.184m-42.957 47.223c-3.6 10.371-34.84 15.678-36.935.326-1.065-7.816 18.503-19.872 36.935-.326z'/%3e%3cpath stroke-linejoin='round' d='m236.48 69.148 12.02 2.225s-8.46 11.349-12.02-2.225z'/%3e%3c/g%3e%3c/svg%3e";
            },
            5564: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 30'%3e%3cclipPath id='a'%3e%3cpath d='M0 0v30h60V0z'/%3e%3c/clipPath%3e%3cclipPath id='b'%3e%3cpath d='M30 15h30v15zv15H0zH0V0zV0h30z'/%3e%3c/clipPath%3e%3cg clip-path='url(%23a)'%3e%3cpath fill='%23012169' d='M0 0v30h60V0z'/%3e%3cpath stroke='%23fff' stroke-width='6' d='m0 0 60 30m0-30L0 30'/%3e%3cpath stroke='%23C8102E' stroke-width='4' d='m0 0 60 30m0-30L0 30' clip-path='url(%23b)'/%3e%3cpath stroke='%23fff' stroke-width='10' d='M30 0v30M0 15h60'/%3e%3cpath stroke='%23C8102E' stroke-width='6' d='M30 0v30M0 15h60'/%3e%3c/g%3e%3c/svg%3e";
            },
            1898: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 500 300'%3e%3cdefs%3e%3cg id='c'%3e%3cg id='b'%3e%3cpath id='a' fill='%23fcd116' d='M0-1v1h.5' transform='rotate(18 0 -1)'/%3e%3cuse xlink:href='%23a' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(72)'/%3e%3cuse xlink:href='%23b' transform='rotate(144)'/%3e%3cuse xlink:href='%23b' transform='rotate(216)'/%3e%3cuse xlink:href='%23b' transform='rotate(288)'/%3e%3c/g%3e%3c/defs%3e%3cpath fill='%23ce1126' d='M0 0h500v300H0z'/%3e%3cpath fill='%23007a5e' d='M42 42h416v216H42z'/%3e%3cpath fill='%23fcd116' d='M42 42h416L42 258h416z'/%3e%3ccircle cx='250' cy='150' r='36' fill='%23ce1126'/%3e%3cuse xlink:href='%23c' transform='matrix(33 0 0 33 250 150)'/%3e%3cuse xlink:href='%23d' x='-100'/%3e%3cuse xlink:href='%23c' id='d' transform='matrix(19.5 0 0 19.5 250 21)'/%3e%3cuse xlink:href='%23d' x='100'/%3e%3cuse xlink:href='%23d' x='-100' y='258'/%3e%3cuse xlink:href='%23d' y='258'/%3e%3cuse xlink:href='%23d' x='100' y='258'/%3e%3cpath fill='%23ce1126' d='M67.749 150.41c4.504 8.39 13.265 17.52 20.916 20.73.123-8.52-2.9-19.44-7.034-28.14l-13.882 7.41z'/%3e%3cpath fill='%23fcd116' d='M60.112 121.63c6.529 13.61-16.933 46.08 22.156 53.69-4.822-6.58-7.931-17.44-6.755-26.16 8.201 3.12 16.83 12.25 20.317 19.23 10.23-37.15-26.24-34.89-35.718-46.76z'/%3e%3c/svg%3e";
            },
            5676: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 300 200'%3e%3cdefs%3e%3cg id='c'%3e%3cclipPath id='a'%3e%3cpath d='M-109 104a104 104 0 0 0 0-208h218a104 104 0 0 0 0 208z'/%3e%3c/clipPath%3e%3cpath id='b' d='M-55 74a55 55 0 0 1 110 0V-74a55 55 0 0 1-110 0z' clip-path='url(%23a)'/%3e%3cuse xlink:href='%23b' transform='rotate(90)'/%3e%3c/g%3e%3c/defs%3e%3cpath d='M0 0h300v200H0z' style='fill:%23fff'/%3e%3cpath d='M130 0v80H0v40h130v80h40v-80h130V80H170V0h-40z' style='fill:red'/%3e%3cuse xlink:href='%23c' fill='red' transform='translate(64.45 39.45)'/%3e%3cuse xlink:href='%23c' fill='red' transform='translate(235.55 160.55)'/%3e%3cuse xlink:href='%23c' fill='red' transform='translate(235.55 39.45)'/%3e%3cuse xlink:href='%23c' fill='red' transform='translate(64.45 160.55)'/%3e%3c/svg%3e";
            },
            9209: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 2'%3e%3cpath fill='%23ED2939' d='M0 0h3v2H0z'/%3e%3cpath fill='%23fff' d='M0 0h2v2H0z'/%3e%3cpath fill='%23002395' d='M0 0h1v2H0z'/%3e%3c/svg%3e";
            },
            9654: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-18 -12 36 24'%3e%3cpath fill='%23fff' d='M-18-12h36v24h-36z'/%3e%3cpath fill='none' stroke='%23e8112d' stroke-width='6' d='M0-12v24M-18 0h36'/%3e%3cpath id='a' fill='%23f9dd16' d='m-9 2 1-1h9v-2h-9l-1-1z'/%3e%3cuse xlink:href='%23a' transform='rotate(90)'/%3e%3cuse xlink:href='%23a' transform='rotate(-90)'/%3e%3cuse xlink:href='%23a' transform='rotate(180)'/%3e%3c/svg%3e";
            },
            3426: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 300'%3e%3cpath fill='%23006b3f' d='M0 0h450v300H0z'/%3e%3cpath fill='%23fcd116' d='M0 0h450v200H0z'/%3e%3cpath fill='%23ce1126' d='M0 0h450v100H0z'/%3e%3cpath d='m225 100 32.492 100-85.065-61.803h105.146L192.508 200z'/%3e%3c/svg%3e";
            },
            3983: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 512 256'%3e%3cpath fill='%23da000c' d='M0 0h512v256H0z'/%3e%3cpath fill='%23fff' d='M0 0h512v171.5H0z'/%3e%3cg stroke='%23000'%3e%3cg id='a' fill='%23da000c' stroke-linecap='square'%3e%3cpath fill='%23000' stroke='none' d='M196.571 116.303h64v43.993h-64z'/%3e%3cpath d='M229.819 153.865H190.75l-8.66 5.7v6.04h47.729m-16.35-37.011c5.625 0 10.219 4.689 10.219 10.469v14.78h7.343v-56H190.75v56h12.5v-14.78c0-5.554 4.515-10.47 10.219-10.47z'/%3e%3cpath fill='%23000' stroke='none' d='M204.528 59.962h18.523v33.959h-18.523z'/%3e%3cpath d='M223 88.656h-16.209v-5.75h-11.885v5.75h-8.062v-5.75h-4.813v10.438H223m-36.156-.038h34.97v4.538h-34.97z'/%3e%3cpath d='M200.719 47.625v35.281h6.072V73.22c0-3.63 2.562-6.6 6.147-6.781.115-.006.226 0 .343 0a6.78 6.78 0 0 1 6.781 6.78v9.688h5.782V47.625zm-2.188-4.781v4.781h29.25v-4.781zm-3.75-9.156v9.156h35.094v-9.157h-5.406v4.657h-6.531v-4.657h-9.97v4.657h-6.53v-4.657zM182.09 159.564H230m31-2.751h-32.438l-9.78 4.718v7.031H261'/%3e%3cpath stroke-linecap='butt' d='M218.771 161.52H262'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 512 0)'/%3e%3cg fill='%23f8d80e'%3e%3cg stroke-linecap='round'%3e%3cpath stroke-width='.768' d='M273.297 150.031c-2.654.883-5.053 2.369-7.469 3.753-3.1 1.831-6.107 3.827-8.904 6.099-.985.649-1.93 1.36-2.69 2.273-1.025.878-2.064 2.055-1.868 3.513.051.643.873-.755 1.414-.823a4.39 4.39 0 0 1 3.142-.471c1.271-1.339 2.91-2.236 4.325-3.406 3.004-2.243 6.236-4.168 9.525-5.961 1.148-.589 2.3-1.186 3.525-1.602l-1-3.375z'/%3e%3cpath d='M260.4 157.391v3.912m2.417-5.618v3.883m2.416-5.388v3.858m2.417-5.344v3.981'/%3e%3cpath stroke-width='.768' d='m238.891 150.156-1.188 3.313c5.537 2.1 10.81 4.878 15.798 8.06 1.691 1.15 3.467 2.266 4.796 3.846.293.81-.514 1.489-1.314 1.244-.732-.249-1.453-.532-2.226-.004-1.107.503-2.106 2.141-.426 2.69 2.315 1.556 6.082.88 7.195-1.844.581-1.402.618-3.196-.508-4.345-2.063-2.364-4.797-4.008-7.421-5.672-4.69-2.82-9.573-5.374-14.706-7.288z'/%3e%3cpath d='m254.05 158.035-.313 3.34m3.095-1.635-.862 3.269m3.834-.997-1.808 2.537m2.719 3.631-2.61-1.4m3.423-1.351-2.995.28m-.868 4.056-.205-2.633m-.892-.376-2.473 1.822m-9.418-15.641v3.115m6.286.192v3.534m-3.143-5.185v3.32'/%3e%3c/g%3e%3cpath d='M235.781 227.563v8.03h5.031v-4.03h6.844v4.03h5.406v-8.03zm0 11.062v8.063h17.281v-8.063h-5.406v4.031h-6.844v-4.031z'/%3e%3cpath d='M253.052 193.651h4.99v58.115h-4.99z'/%3e%3cpath d='M253.052 198.679h4.99v50.06h-4.99z'/%3e%3cpath stroke-width='1.024' d='m255.547 179.406 10.625 6.188-10.625 6.156-10.625-6.156zm-14.219 3.969h-2.781v4.438h2.781l14.219 8.25 14.219-8.25h2.78v-4.438h-2.78l-14.22-8.25z'/%3e%3cpath stroke-width='1.024' d='M255.344 164.281c-2.419.34-4.226 2.73-4.094 5.134.01 3.738-.018 7.476.014 11.214.129 2.408 2.233 4.566 4.675 4.588 1.985.188 3.979-.972 4.811-2.78l-1.718-1.031c-.444 1.184-1.724 1.918-2.97 1.781-1.634.046-2.958-1.544-2.812-3.134.01-3.713-.019-7.428.015-11.14.09-1.516 1.535-2.755 3.048-2.6.626-.18 1.487.676 1.875-.063.583-.83-.415-1.477-.97-1.937-.613-.085-1.253-.008-1.874-.032zm5.781 3.906c-.396.746-1.216 1.19-1.875 1.58v7.514l2 1.156c-.008-3.204.016-6.408-.011-9.611-.032-.197-.008-.499-.114-.639z'/%3e%3c/g%3e%3cg fill='%23da000c'%3e%3cpath fill='%23000' stroke='none' d='M240.803 38.351h29.329v53.255h-29.329z'/%3e%3cpath d='M238.75 38.375v44.563h9.313v-13.22c0-3.048 1.952-7.28 7.937-7.28s7.938 4.232 7.938 7.28v13.22h9.312V38.374zm15.813 5h2.875v15.25h-2.875zm-8.25 3h2.906v11.156h-2.906zm16.468 0h2.906v11.156h-2.906zm-27.187-14.406v6.343h40.812V31.97zm-3.844-7.375v7.375h48.5v-7.375h-6.094v4.062h-6.875v-4.062h-7.844v4.062h-6.875v-4.062h-7.843v4.062h-6.875v-4.062zm-9 73.25v4.594h66.5v-4.594z'/%3e%3cpath d='M220.031 82.906v14.938h71.938V82.906h-6.813v5.75h-9.062v-5.75h-12.156v5.75h-15.875v-5.75h-12.157v5.75h-9.062v-5.75z'/%3e%3cpath stroke-linejoin='round' d='M228.688 102.438v54.343h12.843v-20.344c0-9.582 6.397-14.093 14.469-14.093 7.759 0 14.469 4.51 14.469 14.094v20.343h12.844v-54.344z'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";
            },
            9860: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 12'%3e%3cpath fill='%23fff' d='M0 0h18v12H0z'/%3e%3cpath fill='%23d00c33' d='M0 6h18v6H0zm3 0a4 4 0 0 0 8 0 4 4 0 0 0-8 0'/%3e%3c/svg%3e";
            },
            3671: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 18'%3e%3cpath fill='%233A7728' d='M0 0h27v18H0'/%3e%3cpath fill='%230C1C8C' d='M0 0h27v11H0'/%3e%3cpath fill='%23CE1126' d='M0 0h27v6H0'/%3e%3cpath stroke='%23FFF' d='M0 6.5h27m0 5H0'/%3e%3c/svg%3e";
            },
            5948: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 2'%3e%3cpath fill='%23ce1126' d='M0 0h1v2H0z'/%3e%3cpath fill='%23fcd116' d='M1 0h1v2H1z'/%3e%3cpath fill='%23009460' d='M2 0h1v2H2z'/%3e%3c/svg%3e";
            },
            3797: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3cpath fill='%23ED2939' d='M0 0h900v600H0z'/%3e%3cpath fill='%23fff' d='M0 0h600v600H0z'/%3e%3cpath fill='%23002395' d='M0 0h300v600H0z'/%3e%3c/svg%3e";
            },
            1836: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3600 2400'%3e%3cpath fill='%23e32118' d='M0 0h3600v2400H0z'/%3e%3cpath fill='%23fff' d='M0 0h3600v1600H0z'/%3e%3cpath fill='%233e9a00' d='M0 0h3600v800H0z'/%3e%3cpath fill='%230073ce' d='M0 0v2400l900-1200z'/%3e%3cg stroke='%23000'%3e%3cpath fill='%23fff' stroke-width='4.8' d='M1608 958.8h383V1360c0 135-176 31-191 103-26-74-191 33-191-111 0-140-1-393.2-1-393.2z'/%3e%3cpath fill='%2373452b' d='M1827 1399s-5 5-14 1-10-257-10-257c20-22 36-29 36-29l12 10c-45 23-41 56-37 113 1 21 1 48 6 74 7 33 21 61 22 82 1 13-15 6-15 6z'/%3e%3cpath fill='%2373452b' d='M1796 1108h18c-15 145-2 231-2 273 0 14 8 19 7 19-18 20-27-1-27-1z'/%3e%3cpath fill='%23a36629' d='M1768 1399c-17 8-19-8-18-10 37-75 53-240 19-258l2-16c13 4 25 21 25 21 5 185 0 261-3 264-18 19-25-3-26-5'/%3e%3cpath fill='none' d='M1767 1396c-3-16 26-57 24-100m25 35c9 25 13 47 11 68'/%3e%3cpath fill='%23009a3b' d='M1855 1040c6-7 6-7 17-7 2-15 27-15 29 4 20-4 24 8 16 20 19-5 36 0 31 22 34 9 21 33 6 38-2 15-16 20-35 14-24 17-38 11-49-6-27 4-29-2-41-17-21 9-25 9-43-2-1 14-6 10-15 9 1 18-6 26-22 20 12 25-19 36-34 15-14 1-15-3-22-8-6 20-28 17-32 6-28-4-25-19-2-20 2-16 16-13 25-11 1-10 7-8 12-6-3-7-1-11 8-13-13-17-5-23 8-29-7-16 5-15 14-16-1-17 4-20 22-22-2-6 1-11 11-11-6-17 2-20.9 20-18 3-24.7 56-13 52 21 15 2 20 5 24 17z'/%3e%3cg fill='none'%3e%3cpath d='M1748 1031c4 2 9 0 10 11 8-14 18-6 18 10m55-29c-4 6-19 6-17 22-5-7-15-9-19-2m60-3c0 4-1 16-5 22m67-5c1 1-14 0-21 5m58 55c-4-2-12-7-18 1 0-4 0-15-11-15m-6 28c0-10-2-13-4-16m-29 2c-8-6-16 3-16 8m-42-17c0-4-3-12 4-15m-118 57c2-10 9-10 8-15-1-8-10-15-21-4'/%3e%3cpath d='M1722 1135c6-2 12-1 14 2m-31-39c4-4 14-3 20 0m0-24c5 0 14-2 17 7 11-17 19-15 21-11m20-2c8-3 22 5 30 19 4-11 10-9 16-10m38 10c13-6 21 6 25 11 6-8 11-8 17-8m-163 21c3-5 10-6 15-3-1-9 5-13 9-11'/%3e%3c/g%3e%3cpath fill='gold' stroke-width='3.5' d='m1787 902.6-22 1-11 19.7-12-18.8-22 .9 10-19.8-12-18.8 23-1 10-19.7 12 18.8 22-.9-10 19.8zm-94 7.3-22 5.4-6 21.3-16-16-21 5.2 6-21.3-15-16.2 21-5.3 6-21.4 16 16 22-5.2-7 21.4zm-91 18.7-20 9.9-1 22.2-19-12.2-20 9.8 2-22.2-19-12.3 20-10 2-22.2 18 12.2 20-9.8-1 22.2zm214-26 22 1 10 19.7 12-18.8 22 .9-10-19.8 12-18.8-22-1-11-19.7-12 18.8-22-.9 10 19.8zm94 7.3 21 5.4 6 21.3 16-16 21 5.2-6-21.3 16-16.2-22-5.3-6-21.4-16 16-21-5.2 6 21.4zm90 18.7 20 9.9 1 22.2 19-12.2 20 9.8-1-22.2 18-12.3-20-10-1-22.2-19 12.2-20-9.8 2 22.2z'/%3e%3cg fill='%23fff' stroke-width='3.5'%3e%3cpath d='m2027 1352 25 36 23-34-16-29zm-159 105 2 36s10 0 19-3c8-3 15-9 15-9l-1-19zm-134 0-2 35s-9 0-18-2c-8-2-15-7-15-7l-10-24zm-161-105-26 36-28-46 21-22z'/%3e%3cpath d='M1698 1529c0 34 206 34 206 0v-48c0 25-206 20-206 0z'/%3e%3cpath d='M1514 1418c18 92 184 94 184 94v-31c-4-12 3-16 30-20 11-1 6-17 6-17s-72 13-123-7c-69-28-79-82-79-82s-5 42-18 63zm573 0c-17 92-183 94-183 94v-31c3-12-4-16-31-20-11-1-5-17-5-17s72 13 123-7c68-28 76-82 76-82s7 42 20 63z'/%3e%3cpath d='M1527 1383c-46-25-10-51-6-125 7 45 58 64 52 93-21 1-31-31-41 4l-5 28zm547 0c46-26 8-51 4-125-7 45-57 64-51 93 20 1 30-31 40 4l7 27z'/%3e%3c/g%3e%3cpath stroke='none' d='m1555 1417 5 4-11 12c-4.403 4.803-5.467 7.98-2.41 10.905 3.797 3.63 6.466 2.368 10.41-1.905l12-13 4 4-11.99 13.989c-6.508 7.594-12.55 5.856-17.617 1.123-4.416-4.124-6.947-10.102-.454-17.454l12.1-13.6zm20 17 5 3-1 24 11-17 5 3-16 26-6-3 1-24-11 17-5-3zm9 42 14-28 5 3-13 27zm22-24-11.04 28.98L1606 1485c10.29 3.75 15.12-.78 18.39-9.48 3.3-8.85 1.86-15.36-8.43-19.5L1606 1452zm3.96 7.02c10.35 3.6 10.98 7.53 8.16 14.64-2.73 6.75-5.28 9.39-15.12 4.32l6.96-18.96zM1639 1463l-18 27 6.96 2.04 4.02-7.02 12 3 1.02 7.02 6.96.96-6.96-31.98-6-1.02zm1.98 7.02 1.98 12-7.98-1.02 6-10.98zm15.12-4.42-1.084 30.99 11.772.23c10.941.208 14.051-5.62 14.318-14.91.271-9.45-3.208-15.153-14.298-15.715l-10.708-.596zm6.003 5.377c10.964.044 12.838 3.543 12.453 11.195-.366 7.273-1.955 10.588-12.884 8.969l.43-20.164zM1761 1509v31.98h7.02v-12s6 .36 10.98-.96c3.93-1.02 6.66-3.54 6.75-9.75.09-6.09-3.45-9.27-9.57-9.27h-15.2zm7.02 4.98 7.05.09c5.88 0 4.77 8.91.18 8.91h-7.23v-9zM1797 1509l-13.02 31.98h7.02l3-7.98h13.02l3 7.98h6.96l-13-32h-7zm3 7.02 4.98 12h-9l4.02-12zm17 18.98 17-21h-15v-5h24v5l-18 21h18v6h-26zm101-62 6-1 3 18c1.067 6.401-1.858 10.764-6.414 12.445-5.19 1.914-11.806.164-12.586-8.445l5-1c1.165 5.152 3.237 5.599 5.636 4.791 1.904-.64 2.889-3.64 2.364-6.79zm10-1.8 5.92-1.123 2.74 14.98c1.172 6.409 3.183 9.135 7.351 8.407 5.174-.903 5.741-3.8 4.64-9.51l-3.68-15.98 6.057-.915 4.019 16.623c2.35 9.722-2.729 13.578-9.546 14.851-5.939 1.11-12.253-.399-14.322-9.987zm31 13.8 5-2c2.453 4.405 6.28 4.178 9.255 2.863 4.133-1.827 4.606-5.44 2.562-6.663-2.914-1.743-9.869.733-13.615-.634-4.482-1.635-6.406-4.156-6.177-8.032.276-4.666 4.381-7.23 8.846-8.615 4.996-1.55 9.926-1.003 13.129 5.081l-6 2c-1.953-3.287-4.466-3.131-6.697-2.078-1.866.882-4.784 2.538-3.222 5.206 1.277 2.18 8.626.765 12.498.923 4.004.164 7.24 2.836 7.781 6.687.755 5.368-1.234 8.276-7.44 10.697-7.667 2.99-14.583-.36-15.92-5.435zm27-25-8 4-2-5 22-9 2 4-8 4 9 22-5 3zm13-11 5-3 14 26-5 3zm34 2 6-2c2.821 5.932-1.415 16.715-11.775 16.493-15.164-.325-16.805-17.027-14.421-22.536 4.005-9.252 15.224-9.075 20.196-3.957l-5 4c-3.17-4.067-10.212-1.504-10.688 2.237-.776 6.106 1.912 11.788 7.371 14.483 4.629 2.285 11.761-3.46 8.316-8.72zm-3-21 5-4 18 24-5 4zm19-15-4.98 4.02 10.98 30 4.98-4.98-3-6 9-8.04 6 3 5.04-3.96L2049 1415zm1.98 7.02L2061 1427l-6 6-4.02-10.98z'/%3e%3c/g%3e%3c/svg%3e";
            },
            8281: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 18'%3e%3cpath fill='%230D5EAF' d='M0 0h27v18H0z'/%3e%3cpath fill='none' stroke='%23FFF' stroke-width='2' d='M5 0v11M0 5h10m0-2h17M10 7h17M0 11h27M0 15h27'/%3e%3c/svg%3e";
            },
            4273: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 750 375'%3e%3cdefs%3e%3clinearGradient id='b'%3e%3cstop offset='0' stop-color='%23d5dfff'/%3e%3cstop offset='1' stop-color='%23FFF'/%3e%3c/linearGradient%3e%3clinearGradient id='a'%3e%3cstop offset='0' stop-color='%23474747'/%3e%3cstop offset='1' stop-color='%23f50'/%3e%3c/linearGradient%3e%3clinearGradient xlink:href='%23a' id='f' x1='215.83' x2='228.97' y1='102.99' y2='102.99' gradientTransform='matrix(.74087 0 0 1.3286 40.513 .006)' gradientUnits='userSpaceOnUse'/%3e%3clinearGradient xlink:href='%23a' id='c' x1='109.34' x2='110.94' y1='218.47' y2='173.45' gradientTransform='matrix(1.5101 0 0 .65184 40.513 .006)' gradientUnits='userSpaceOnUse'/%3e%3clinearGradient id='d' x1='125.91' x2='126.02' y1='316.38' y2='337.23' gradientTransform='matrix(1.2315 0 0 .79928 40.513 .006)' gradientUnits='userSpaceOnUse'%3e%3cstop offset='0' stop-color='%23b50000'/%3e%3cstop offset='1' stop-color='%23ffc500'/%3e%3c/linearGradient%3e%3clinearGradient xlink:href='%23b' id='g' x1='117.6' x2='78.221' y1='1040.4' y2='1003.7' gradientTransform='matrix(2.5627 0 0 .38409 40.513 .006)' gradientUnits='userSpaceOnUse'/%3e%3clinearGradient xlink:href='%23b' id='h' x1='264.72' x2='255.03' y1='245.98' y2='226.38' gradientTransform='matrix(.88634 0 0 1.1105 40.513 .006)' gradientUnits='userSpaceOnUse'/%3e%3clinearGradient xlink:href='%23b' id='e' x1='407.87' x2='456.4' y1='149.38' y2='147.35' gradientTransform='matrix(.55904 0 0 1.7607 40.513 .006)' gradientUnits='userSpaceOnUse'/%3e%3c/defs%3e%3cpath fill='%23012169' d='M0 0h750v375H0z'/%3e%3cpath fill='%23FFF' d='M0 0v20.963L333.073 187.5h41.925v-20.963L41.925.001H0zm374.998 0v20.962L41.925 187.5H0v-20.962L333.073 0h41.925z'/%3e%3cpath fill='%23FFF' d='M156.25 0v187.499h62.499V0h-62.5zM0 62.5V125h374.998V62.5H0z'/%3e%3cpath fill='%23c8102e' d='M0 75v37.5h374.998V75H0zM168.75 0v187.499h37.499V0h-37.5zM0 187.499l125-62.5h27.95l-125 62.5H0zM0 0l125 62.5H97.05L0 13.976V0zm222.049 62.5 125-62.5h27.95l-125 62.5h-27.95zm152.95 124.999-125-62.5h27.95l97.05 48.525V187.5z'/%3e%3cpath fill='%236a4c2d' stroke='%23000' stroke-width='.828' d='M552.668 265.56s-2.08 5.49-3.266 5.49-5.49-2.373-5.49-2.373-3.117 5.049-4.75 5.34c-1.634.299-5.937-.738-5.937-.738s-4.155 0-4.304-.596c-.149-.59.15-1.776.15-1.776s-5.936 4.744-7.272 4.446c-1.336-.292-5.788-5.93-5.788-5.93l-.742 2.968-8.458-.298-7.42-4.75s-4.156 6.824-4.304 6.675-7.272 1.633-7.272 1.633l-.445-1.335-4.749-2.82s3.71-5.191 3.71-5.34-1.78-.745-1.78-.745l-2.672 2.23-5.49 3.558-5.491-2.522 2.374-4.452.297-3.267 4.304-6.526 52.682-51.202 25.97 47.935-3.857 14.395z'/%3e%3cpath fill='%23FFF' stroke='%23000' stroke-width='.828' d='m590.096 268.665 13.712-.497-5.838-2.881 52.251-1.969-7.383-2.813-6.54-8.862-27.075-2.037s-2.037-1.546-5.347-.776c-.137-2.105-2.67-4.85-2.67-4.85l-16.668-1.267-10.408 7.104 7.03 18.003 8.936.845z'/%3e%3cpath fill='url(%23c)' stroke='%23000' stroke-width='1pt' d='m121.32 150.76 2.22-7.56s3.89-6.56 3.89-9.46c0-2.89 2.9-6.33 2.9-6.33s8.89-2.56 10.78 2.89c9.57-14.46 20.8-.67 20.8-.67l3.11-3.67 6.34-7.78s9.01 8.45 9.12 9.89c.11 1.45 1.55.45 1.55.45l9.79-.78s4.64 3.64 3.67 10.56c3.45 2.04 6.56 14.01 6.56 14.01l-80.73-1.55z' transform='matrix(.621 0 0 .621 461.4 21.482)'/%3e%3cpath fill='%23656263' stroke='%23000' stroke-width='.828' d='M590.102 170.97c1.05-.64 4.353-1.69 3.95-6.521s-4.59-5.397-6.924-5.235c-2.342.161-4.434 2.173-4.434 2.173l-7.732-4.912s3.87-24.405 7.974-25.933c3.9-2.813 4.59-4.03 4.59-4.67 0-.646-1.448-2.26-1.448-2.26l-25.212-2.981-23.84 2.82s-1.851 2.819-1.609 3.949c.242 1.124.323 2.335 4.59 5.638 4.725 3.633 7.973 24.486 7.973 24.486s-6.682 3.298-7.086 2.894c-.403-.397-2.415-.8-3.465-.64-1.043.162-4.508 1.932-4.508 6.521 0 4.596 3.465 7.253 3.465 7.253s22.79-2.657 26.175 3.62c3.304-7.57 24.964-4.911 27.541-6.203z'/%3e%3cpath stroke='%23000' stroke-linejoin='round' stroke-opacity='.979' stroke-width='.776' d='M614.657 145.601s.254-2.651 2.142-3.912c1.894-1.26 14.507-1.894 17.537 0 3.024 1.894 4.16 11.228 4.16 11.228s1.895 3.279 2.019 5.676.379 4.036.379 4.036 10.091 13.122 10.215 24.977c1.137 8.073.882 29.64-2.266 37.837-.13 10.222-4.416 16.904-4.416 16.904s1.006 1.763.882 3.658c-.13 1.894-1.136 3.657-1.136 3.657l14.755 7.316-5.422-2.019s5.552 4.67 5.422 4.546c-.125-.13-6.18-2.906-6.18-2.906l3.658 3.658c-.124-.125-8.954-4.037-8.954-4.037s4.16 3.912 3.912 3.788c-.255-.124-6.688-3.155-6.688-3.155s4.036 4.292 3.912 4.037-5.8-2.521-5.8-2.521l.248 2.142s-4.54-.254-4.54-3.658c-2.272-1.26-3.781-3.03-3.781-3.03l-10.47-1.764-11.861-35.446 2.776-59.914.757-3.025-1.26-8.073z'/%3e%3cpath fill='%23fb0' stroke='%23000' stroke-width='.822' d='M606.733 337.074s-6.074-12.774-9.098-12.954c-2.732-5.21 9.495-47.792 33.149-50.22 13.004 1.068 1.068 14.99-7.483 10.706 1.068 3.745 5.34 9.104 5.34 9.104s-16.922 7.315-21.908 43.364z'/%3e%3cpath fill='%23fb0' stroke='%23000' stroke-width='.828' d='M525.307 338.937s5.03-14.544 8.08-14.724c3.055-.18-8.08-48.469-32.313-48.829-13.105 1.08-1.077 15.078 7.54 10.768-1.077 3.776-5.385 9.16-5.385 9.16s17.054 7.359 22.078 43.625z'/%3e%3cpath fill='%2300713d' stroke='%23000' stroke-width='.828' d='M547.539 248.104c-.062-.118-6.018 1.869-2.161 8.352.292-2.509 2.974-4.03 2.974-4.03s-4.086 4.85.236 8.936c.528-3.857 2.981-5.08 2.981-5.08s-3.036 8.936.056 10.743c.354-3.564 2.627-5.135 2.627-5.135s-2.745 7.998-.292 9.805c.292-3.03 2.335-4.378 2.335-4.378s-1.223 8.297 1.987 8.88c.062-2.924 2.397-5.78 2.397-5.78s-1.055 6.768 3.968 7.066c.063-2.57.994-5.49.994-5.49s2.28 7.18 5.608 6.012c-.056-2.1.056-6.074 0-6.074-.062 0 2.099 6.831 6.073 5.552-.584-1.931.23-4.21.23-4.21s2.105 4.266 5.9 2.862c.645-1.285-.175-3.794-.175-3.794s5.546 5.726 7.241 2.28-4.44-4.615-4.44-4.615h4.148s-1.34-3.502-6.949-4.266c1.926-.876 3.913-.23 3.913-.23s-1.168-4.384-6.893-4.85c2.223-.757 4.676-.23 4.676-.23s-.764-4.148-7.067-5.315c.993-1.112 3.676-.758 3.676-.758s-2.509-3.912-5.372-3.683c-2.862.236-28.733-2.626-28.671-2.57z'/%3e%3cpath fill='none' stroke='%233ec26d' stroke-linecap='round' stroke-width='.776' d='M573.056 269.186s2.279 1.112 2.223 2.106m-.876-3.912s2.92 2.042 2.863 3.558m-.298-4.614s2.341 1.459 2.453 3.738m1.459-2.801s1.174 2.51.764 2.975m1.578-1.633c.173 1.987-.18 2.16-.18 2.16m-28.616-14.717s2.745 1.751 2.515 4.204m-2.689-2.099s1.285 1.224.994 2.043m2.397-4.086s1.807 2.51 1.223 4.26m1.869-2.627s.82 1.578.062 2.453m1.398-1.694s.993 1.576.117 2.104m-1.222 3.093s2.564.584 2.918 2.509m-1.404-4.26s2.69.173 2.981 3.036m.584-4.03c.056 0 1.807 3.099 1.515 4.086m1.931-3.794s.696 2.98.174 3.912m2.043-2.745c0 .062.056 3.447.056 3.447m-3.44-8.117s1.69.64 1.571 2.28m.001-3.801s2.16 1.23 1.93 3.565m.584-4.552s1.87 2.217 1.168 4.67m2.098-4.149s-.695 2.745-.41 3.857m2.398-1.988s-1.224.938-.584 2.106m-10.041 8.581s.403 2.106 0 2.454m-2.689-3.677s1.34 2.335.875 3.503m-3.739-3.62s1.522 1.75 1.46 3.154m-3.794-2.807s1.403 1.348 1.285 2.105m-2.509-.062s1.342 1.404 1.28 1.696'/%3e%3cpath fill='%23FFF' stroke='%23000' stroke-width='.828' d='M529.002 173.49c6.44-.118 12.88-.23 19.32-.347 0 0 12.76 0 14.14 4.142 2.415-5.521 13.45-5.173 13.45-5.173l20.003-.69c.118 16.097.23 32.193.348 48.29-3.907 18.735-17.475 31.962-32.423 37.595-17.823-5.75-29.087-20.81-32.764-37.943-.695-15.29-1.385-30.585-2.074-45.874z'/%3e%3cpath fill='%23006b00' stroke='%23000' stroke-width='.828' d='m535.883 173.31 28.137 74.98 25.418-76.613c-7.887.51-24.803-1.242-26.902 5.95-3.254-6.434-21.052-3.839-26.653-4.317z'/%3e%3cpath fill='%23ffc900' stroke='%23006b00' stroke-linecap='round' stroke-width='.428' d='M555.034 213.905c1.087.565 1.056-20.35 2.478-20.996.404-1.733.609-2.49 1.118-4.328-1.223-2.168-6.7-2.062-8.731-.218.913 2.919 1.316 3.894 1.316 3.894 2.745 4.44 2.199 22.12 3.82 21.648z'/%3e%3cpath fill='%23cdad56' stroke='%23000' stroke-linejoin='round' stroke-width='.776' d='M547.495 52.251s1.994-2.259 2.08-2.8c.094-.543 9.036-.904 14.365-10.842 2.98-5.24 0-2.168 0-2.168l-.18-2.53s3.707-3.523 2.353-5.421c-1.36-1.897-.907 2.44-3.074 2.35s-.994-4.699-.994-4.699-.18-.542-.813-.813c-.907.09-.633 1.717-1.447 1.897-.813.181-1.534-3.794-1.534-3.794s-1.354-1.807-2.534 3.885c.634 6.053 4.521 4.878 4.521 8.854 0 3.975-3.434 7.047-4.427 7.137-.994.09-.634-3.343-.634-3.343s-.54-1.626-.9-1.626 1.987-.361 1.627-4.879c-.814-5.42-1.447 1.265-2.894.994-1.447-.27-.36-4.969.18-5.51s-.633-2.802-3.794 2.98c-.274 2.801-.634-.722-1.267-.542-1.08 2.26-.9 3.885.633 5.963 2.26 2.078 3.708 4.156 3.615 5.24-.087 1.085-1.267 3.524-2.888 3.524-1.627 0 .087-2.982 0-3.976-.093-.993-2.8-4.607-2.8-4.607s-1.901-3.072-1.721-3.162c.18-.09-.18-.542-1.08 2.62-.907 3.162-1.994-2.078-1.994-2.078s-1.26 3.884 1.447 6.234c-2.074-.271-2.254.542-2.254.542 0 1.084 2.8 1.536 3.16 3.433.36 1.897-2.893 2.981-2.893 2.981s1.36 1.897 5.148-1.806c.093 2.348-1.44 3.975-1.44 3.975 1.26.572 2.253.511 2.433 1.987z'/%3e%3cpath fill='%23cdad56' stroke='%23000' stroke-linejoin='round' stroke-width='.682' d='M535.1 52.251s-1.689-2.507-1.763-3c-.081-.493-8.31.623-12.202-9.413-2.532-4.769 0-1.973 0-1.973l.154-2.302s-2.695-3.297-1.544-5.023.677 2.22 2.157 2.227c1.84-.082.844-4.275.844-4.275s.153-.493.69-.74c.766.083 1.082 2.556 1.772 2.72s2.117-2.91 2.564-3.542c.634-.09.61-2.548 1.609 2.631-.534 5.508-5.099 4.44-5.099 8.057s2.913 6.412 3.758 6.494c.844.082.54-3.041.54-3.041s.46-1.48.764-1.48c.31 0-2.683.574-2.373-3.536.69-3.848 2.217.248 3.447 0 1.23-.246-.143-4.069.211-4.653.08-.583 1.888-3.09 2.59 2.442.23 2.549 1.62-2.193 2.155-2.029.925 2.055-.404 4.8-1.708 6.691-1.92 1.89-2.789 3.962-2.708 4.949.075.986.528 2.212 1.913 2.212 1.379 0 .466-1.72.54-2.623s2.379-3.832 2.379-3.832c.453-.722.074-2.072.552-2.696.752.008 1.062-1.035 1.826 1.842.77 2.877 1.69-1.891 1.69-1.891s1.073 3.535-1.23 5.673c1.763-.247 1.918.493 1.918.493 0 .986-.838 1.397-1.148 3.123s.919 2.713.919 2.713-1.15 1.727-4.372-1.644c-.08 2.137 1.23 3.617 1.23 3.617-1.081.521-1.92.466-2.075 1.81z'/%3e%3cpath fill='%23ffc900' d='M584.743 184.494c-1.683-1.527-1.882-.192-2.708-.534-.41-.167-.726-.546-1.08-.894-.304-.317-.67-.447-1.074-.615-.156.454-.305.9-.46 1.354s.429 1.205.416 1.882c-.118 1.006-.528 1.844-1.795 2.186.36-.714.566-.745.454-1.621-.05-.435-1.273-1.211-1.124-1.62.223-.665.608-1.43.323-2.094-.516.354-1.199.168-1.714.385-.441.193-.466 1.006-1.075 1.342-.62.292-1.993.149-3.142-.503.702-.528 1.28-.174 1.981-.702.348-.267.335-1.403.683-1.67.354-.268 1.193-.547 1.54-.814-.316-.36-.298-.925-.614-1.285-.311-.36-1.708-.286-2.025-.64-.633-.72-.51-1.664-1.143-2.379 1.634.584 1.398 1.38 1.808 1.317.77-.373 1.54-.44 1.943-.273.41.174 1.18 1.18 1.584 1.347.155-.453.379-1.024.528-1.478.155-.453-.683-1.235-.534-1.689.31-.9 1.068-1.701 1.372-2.608.112.876.255 1.608.366 2.478.056.434.913.664.97 1.099.055.44-.448 1.447-.398 1.888.472-.093 1.149-.031 1.614-.124.472-.094.783-1.18 1.249-1.273.937-.187 1.614-.13 2.564.05-.701.651-1.242.608-1.683 1.204-.347.267.137 1.143-.875 1.757-.38.224-1.379-.043-1.733.224.317.36.634.714.95 1.074.31.36 1.727.528 2.043.888.628.714.963 1.571.789 2.341zm-43.265.739c1.683-1.527 1.882-.192 2.714-.534.403-.173.72-.552 1.074-.894.304-.317.67-.447 1.074-.62.156.453.31.906.46 1.36.155.453-.422 1.198-.41 1.875.112 1.012.522 1.844 1.789 2.192-.36-.714-.566-.752-.454-1.621.056-.435 1.273-1.211 1.124-1.627-.223-.658-.608-1.428-.323-2.093.522.36 1.199.174 1.72.385.435.199.466 1.012 1.069 1.348.627.292 2 .149 3.142-.503-.702-.534-1.28-.174-1.981-.708-.348-.261-.33-1.404-.683-1.665-.348-.267-1.186-.552-1.54-.82.316-.353.298-.925.614-1.285.317-.354 1.714-.28 2.025-.64.633-.713.515-1.657 1.143-2.378-1.634.584-1.391 1.379-1.801 1.323-.777-.373-1.547-.447-1.95-.273-.404.167-1.18 1.173-1.584 1.347-.155-.453-.372-1.024-.528-1.478s.69-1.235.534-1.689c-.304-.906-1.068-1.701-1.372-2.608-.112.87-.255 1.602-.366 2.478-.056.434-.913.664-.97 1.099-.049.435.454 1.447.398 1.882-.472-.094-1.149-.031-1.614-.118-.466-.1-.777-1.187-1.249-1.28-.937-.186-1.608-.13-2.564.05.701.658 1.242.609 1.683 1.211.347.267-.137 1.143.875 1.757.38.224 1.385-.043 1.733.224a73.93 73.93 0 0 0-.944 1.074c-.317.36-1.733.528-2.043.882-.634.72-.969 1.577-.795 2.347z'/%3e%3cpath fill='%23ffc900' stroke='%23006b00' stroke-linecap='round' stroke-linejoin='round' stroke-width='.428' d='M583.234 189.326c-1.528 1.186-11.37 3.676-11.476 12.227-.1 8.552 1.726 10.501-.1 10.719-3.552 0-4.06-9.526-3.961-13.75.105-4.222.204-3.57.204-3.57s2.435.646 2.236 2.708c-.205 2.055 2.434-5.093 1.522-7.036 1.62 1.62 3.757.975 3.757.863 0-.106-1.218-1.404-1.727-2.378s1.826.54 1.826.54.1-1.627-1.931-1.515c-2.64 0 .41-.87.41-.87s1.521 1.41 2.54-.105c-1.118-1.193-2.745-1.845-2.745-1.845s-1.423-2.701-3.348-3.241c-2.235-.547-1.93.968-4.47.757-.504.969-.504 1.08.508 1.404-1.726 1.192-.813 3.57-.813 3.57s2.745-1.186 2.64.758c-.1 1.95-1.622 1.627-2.64.435-.913-.54-1.217.54-1.217.54l1.422 1.515s-2.739-.105-3.453 1.733c1.522-.106 2.335.329 2.335.329s-3.148 1.403-3.453 2.161-.403-.863-.503-.863c-.105 0-3.049-1.087-3.049-1.087l-1.018 4.682s2.037 2.031 3.148 1.38c1.118-.647 3.149-2.597 4.366-2.056-3.552 2.707-7.104 6.6-9.036 7.147-.503-.434-2.23-2.167-2.943-1.304-.708.87-.199 1.95.714 1.845.913-.112-2.944.863-2.136 2.49.813 1.62.714 1.515 1.422 1.08.714-.434-.609-.54 2.03-1.298s2.54-1.515 2.54-1.515-.509 1.186-1.931 1.515c-1.422.323-2.534.323-2.23.758.305.429.913 1.186.709 1.62s2.943-2.272 3.757-.105c2.13-.112 3.552-2.707 2.54-4.223.099 1.621 1.117 2.168.502 2.925-.608.758 4.776-2.49 2.137-4.44.708 1.621.813 2.925.813 2.925s1.217-.112 1.522-.546c.304-.429-.609 1.192-.205 1.515.403.329 2.335 2.167 1.521 3.465-.503-.758-.608-1.95-1.217-1.838-.609.105-3.148 1.95-4.67 2.055s1.826 5.633 1.826 5.633-2.335-.33-2.64-.112-1.825-1.95-2.13-.646c-.509 1.621.51.969.51.969s-1.323-.646-2.03.112c-.715.757-1.423 1.515-.914 1.838.503.323 2.739.323 3.043.217s-2.54.218-2.738.54c-.205.324-.609 1.516 0 1.95s2.13-.217 2.229-.54c.105-.329.205 1.186.205 1.186s2.64.218 2.64-2.484c0-2.707.204 1.944.204 1.944s2.64.435 2.739-2.273c.105-2.701.304 1.845.304 1.845s1.726-.547 1.726-.975c0-.435-.099 5.409-1.316 7.036-1.932-1.305-3.149.863-3.149.863s.1 3.136-.105 3.893c-.199.758 1.322-.428 1.422-.757.105-.323 1.931-1.186 2.03-1.404.106-.217.61-1.298.61-1.298s-.405 1.516-1.112 1.733c-.715.211-1.423.969-1.118 1.62s1.422 1.081 1.825 1.733c.404.646 1.826-3.788 1.826-3.788l.106.975s1.825-.434 2.03-1.298c.2-.869-1.93-1.627-.205-3.03 1.727-1.41 0 1.298 0 1.298s.61 2.055 1.013 2.055c.41 0 1.422-3.9.41-4.868-1.019-.975 1.521 1.186 1.521 1.186s1.422-4.006-.1-4.546c-1.527-.54-2.235-.758-2.235-.758s.814-1.08.404-1.186c-.404-.111 2.136 2.379 2.54 1.727.41-.646 1.018-2.596-1.925-3.677-2.95-1.08-.106-4.117-.106-4.117s1.832 2.167 3.148.975c1.317-1.186-.099-1.186-.099-1.186s3.75-2.385 3.856-3.577c-.714-.105-1.93.112-1.93.112s2.135-1.41 1.626-3.683c-.813 1.193-1.931 1.193-1.931 1.193s1.832-1.838 1.521-3.571c-1.111.863-1.012 1.515-1.726 1.298-.708-.218-1.925-7.036.919-7.47 2.838-.43 1.317 3.359 1.416 3.359.105 0 4.266-1.733 0-4.546 1.018-.33 3.148 1.62 3.148 1.62s-.913-4.762-5.483-1.837c1.118-1.193 1.832-1.95 2.745-1.733s4.16-.112 4.16-1.08c-.807-.652-2.533.323-3.452 0-.913-.33 6.502-.87 5.893-4.546z'/%3e%3cpath fill='none' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' d='M481.3 118.54s12.25-6.43 18.37 1.54m4.9 12.24c-.31 0-4.29 3.98-5.21 3.98m13.48 8.88s11.32.92 18.67-10.41' transform='matrix(.3316 0 0 .35352 391.45 150.228)'/%3e%3cpath fill='none' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' d='M525.08 141.81s.92 6.13 2.76 6.13c1.83 0-3.06 1.53-4.9.3 2.14 2.76 3.37 7.66 0 9.49' transform='matrix(.3316 0 0 .35352 391.45 150.228)'/%3e%3cpath fill='%23e80000' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' d='M519.26 218.97s-3.98 4.28-8.88 4.59' transform='matrix(.3316 0 0 .35352 391.45 150.228)'/%3e%3cpath fill='none' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' d='M523.86 199.37s-2.45-12.24-.92-15.31c.92-3.98 4.9-5.51 7.96-10.71m-8.27 17.14s-3.06 7.35-16.53 4.9m20.21-23.27s.91 9.8-11.33 6.13m-3.68-50.21s-4.9 4.28-3.06 10.1' transform='matrix(.3316 0 0 .35352 391.45 150.228)'/%3e%3cpath fill='%23006b00' d='M567.087 191.703s2.132-.866 2.54-1.3c.404-.432 1.117-1.298 1.32-1.949.202-.647-1.423-1.623-.61-3.03.507-.649 1.216-.757 2.437 0 1.216.757-1.118-2.38-2.335-2.488-1.22-.109-2.033.865-2.334.649-.305-.217.1.866-.408.866s1.014.866.915 1.408c-.103.541 1.622 2.38 1.522 2.814-.103.432-2.54 2.92-3.047 3.03z'/%3e%3cpath fill='%23ffc900' stroke='%23ffc900' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.25' d='M534.27 97.112c2.79-.636 3.24.07 2.75 2.449-1.31-.66-1.79-1.217-2.75-2.449z' transform='matrix(.3316 0 0 .35352 391.45 150.228)'/%3e%3cpath fill='%23e80000' stroke='%23006b00' stroke-linejoin='round' stroke-width='1.25' d='M514.71 233.52s-1.03 6.41 1.49 6.94c-.13-2.48.54-4.17 1.16-4.83-.54-.25-2.53-2.07-2.65-2.11zm-5.68-7.89c-2.32-.33-6.23 1.59-5.11 3.91 1.89-1.62 3.63.13 4.95-1.52.4-.46.29-1.81.16-2.39zm-.02-4.58s-3.65-.58-4.16 1.95c2.52-.32 3.27-.59 4.11-.06.24-.54.01-1.76.05-1.89z' transform='matrix(.3316 0 0 .35352 391.45 150.228)'/%3e%3cpath fill='%23e80000' stroke='%23006b00' stroke-linejoin='round' stroke-width='1pt' d='M493.54 184.94s2.19.82 2.81 3.06c1.74-1.08 2.57-5.83-2.81-3.06zm-5.42 5.45c.09-.04 4.59-2.77 5.05-.16-.95.95-1.37 1.57-2.11 1.78-.58 0-1.74-1.78-2.94-1.62zm-.45 8.85c.08-.04 2.89-2.52 3.97-.87 1.07 1.66-.87 1.57-.87 1.57s-.99-.45-3.1-.7zm-3.97-49.28c-.04 0-3.6-1.37-5.09 1.11 2.36.29 3.19 1.12 4.26 1.95-.29-1.04-.78-2.61.83-3.06zm-6.9 18.56s.16-4.17 2.14-5.87c1.12.62 1.45 1.61 2.2 2.85-1.49.33-3.48.42-4.34 3.02zm9.5-2.98s-3.92 1.82-2.64 3.81c1.28-1.37 2.69-.95 2.69-.99s0-2.77-.05-2.82z' transform='matrix(.3316 0 0 .35352 391.45 150.228)'/%3e%3cpath fill='%23ffc900' stroke='%23006b00' stroke-linejoin='round' stroke-width='1pt' d='M480.64 125.6c-1.41 1.58 1.74 5.01 5.04 4.51.83-3.72-4.21-5.66-5.04-4.51z' transform='matrix(.3316 0 0 .35352 391.45 150.228)'/%3e%3cpath fill='none' d='M550.815 192.088c-.229.619.68 1.489 1.207 1.245.213-.637-.968-1.736-1.207-1.245z'/%3e%3cpath fill='%23e80000' stroke='%23006b00' stroke-linejoin='round' stroke-width='1pt' d='M484.28 122.75s.62 2.94 3.47 2.15c-.45-2.27-2.44-3.97-2.44-3.97-.12.67.41 1.7-1.03 1.82zm1.9 8.52s1.57 1.69 4.67-1.78c-1.4.41-3.88-.83-3.88-.83s0 2.4-.79 2.61z' transform='matrix(.3316 0 0 .35352 391.45 150.228)'/%3e%3cpath fill='%23ffc900' stroke='%23006b00' stroke-linejoin='round' stroke-width='1pt' d='M480.46 118.86c-1.4 1.57.59 3.76 3.89 3.27.83-3.72-3.06-4.42-3.89-3.27z' transform='matrix(.3316 0 0 .35352 391.45 150.228)'/%3e%3cpath fill='url(%23d)' d='M144.62 266.62s7.04-2.01 10.78 1.01c3.73 3.01 3.73.28 3.73.28s5.46 2.01 7.04 1.58-1.15.15 1-1.15c2.16-1.29-4.31.29-4.88-2.44-1.01-1.72.14-3.88-2.15-3.16-1.58-2.01 1-3.44.43-5.6-1.58 1.15-2.45-.43-3.74 2.44-3.01-.57-.43-4.74-3.73-5.17 0 3.02-2.44 3.16-2.59 4.89-1.43 1-7.75 4.74-5.89 7.32z' transform='matrix(.621 0 0 .621 461.4 21.482)'/%3e%3cpath fill='%23c01500' stroke='%23000' stroke-width='.828' d='M500.91 329.237c2.836-.683 18.2 3.397 24.124 9.744-1.26-11.309-4.392-19.972-4.392-19.972s-9.155-2.614-10.412-1.353c-1.843 1.937-7.38 7.756-9.32 11.581zm-4.683-52.238c-1.077.18-2.154.9-3.231 2.695-1.257 3.049-2.154 10.768-3.95 12.563s-3.41 1.974-3.41 3.595c0 1.615.18 5.384 5.026 6.819 4.847.18 12.567-7.72 12.567-7.72s3.95-4.309 5.564-8.973c-9.334 3.23-15.977-5.39-12.566-8.98z'/%3e%3cpath fill='%23c01500' stroke='%23000' stroke-width='.822' d='M631.237 327.436c-2.813-.677-18.35 3.379-24.231 9.688 1.248-11.24 4.36-19.86 4.36-19.86 1.086-.292 8.985-2.595 10.233-1.341 1.826 1.925 7.713 7.713 9.638 11.513zm4.353-51.934c1.069.18 1.447 1.584 2.323 3.372 1.242 3.03 2.528 7.452 4.31 9.234 1.782 1.789 3.384 4.428 3.384 6.036s-.372 3.776-5.185 5.204c-4.807.18-11.78-5.998-11.78-5.998s-3.919-4.28-5.521-8.924c9.265 3.217 15.264-5.055 12.47-8.924z'/%3e%3cpath fill='%23fb0' stroke='%23000' stroke-width='.828' d='M490.842 319.37s9.693 6.638 9.874 9.693c26.032-38.601 92.454-50.63 130.329-2.695 5.03-6.645 10.234-8.793 10.234-8.793-39.85-52.065-119.201-45.6-150.437 1.794z'/%3e%3cg fill='%231e5aa6' stroke='%23000' stroke-width='1pt'%3e%3cpath stroke-width='.828' d='m589.6 171.69 3.794-.094-6.776 8.583 8.13 9.488-15.991 20.146 15.09 18.158c-1.658 4.067-3.583 7.768-6.148 11.116l-8.67-9.582 15.718-19.6-12.916-14.636 7.768-23.58zm-54.208 1.713-4.067.094 7.588 8.215-8.036 10.03 16.712 18.164-13.824 18.518c1.658 4.068 4.037 8.582 6.595 11.923l8.222-10.39-16.891-18.79 12.377-15.718-8.676-22.046z'/%3e%3cpath stroke-width='.828' d='m554.184 222.19-5.962 7.948 21.319 24.666c3.763-1.9 6.72-4.067 9.942-6.682l-11.116-12.83 4.521-13.283 6.502 7.496-20.325 25.933c-3.403-1.447-7.167-3.708-10.57-6.509l10.75-13.637-5.061-13.103zm-6.595-12.377 3.887 4.88-2.534-6.594-1.353 1.714z'/%3e%3cpath stroke-width='.802' d='M575.416 214.129c.08-.094 3.136-4.161 3.136-4.161l-1.186-1.62-1.95 5.78z'/%3e%3c/g%3e%3cg font-family='Timmons' font-size='14' font-weight='bold'%3e%3ctext x='-328.344' y='362.397' transform='matrix(.403 -.473 .473 .403 461.4 21.482)'%3e%3ctspan x='-328.344' y='362.397'%3eL%3c/tspan%3e%3c/text%3e%3ctext x='-292.335' y='384.266' transform='matrix(.436 -.442 .442 .436 461.4 21.482)'%3e%3ctspan x='-292.335' y='384.266'%3eE%3c/tspan%3e%3c/text%3e%3ctext x='-239.78' y='451.681' transform='matrix(.4737 -.33822 .35254 .46837 461.4 21.482)'%3e%3ctspan x='-239.78' y='451.681'%3eO%3c/tspan%3e%3c/text%3e%3ctext x='-188.526' y='429.958' transform='matrix(.51446 -.3478 .3478 .51446 461.4 21.482)'%3e%3ctspan x='-188.526' y='429.958'%3eT%3c/tspan%3e%3c/text%3e%3ctext x='-115.426' y='451.479' transform='matrix(.56 -.268 .268 .56 461.4 21.482)'%3e%3ctspan x='-115.426' y='451.479'%3eE%3c/tspan%3e%3c/text%3e%3ctext x='-94.111' y='453.046' transform='matrix(.567 -.252 .252 .567 461.4 21.482)'%3e%3ctspan x='-94.111' y='453.046'%3eR%3c/tspan%3e%3c/text%3e%3ctext x='-68.371' y='454.982' transform='matrix(.576 -.232 .232 .576 461.4 21.482)'%3e%3ctspan x='-68.371' y='454.982'%3eR%3c/tspan%3e%3c/text%3e%3ctext x='112.016' y='445.666' transform='rotate(-4.6 467.783 -5492.19) scale(.621)'%3e%3ctspan x='112.016' y='445.666'%3eR%3c/tspan%3e%3c/text%3e%3ctext x='180.225' y='430.793' transform='matrix(.62 0 0 .62 461.4 21.482)'%3e%3ctspan x='180.225' y='430.793'%3eR%3c/tspan%3e%3c/text%3e%3ctext x='414.759' y='275.217' transform='matrix(.54 .307 -.307 .54 461.4 21.482)'%3e%3ctspan x='414.759' y='275.217'%3eR%3c/tspan%3e%3c/text%3e%3ctext x='483.878' y='193.05' transform='rotate(39.8 201.03 648.008) scale(.621)'%3e%3ctspan x='483.878' y='193.05'%3eE%3c/tspan%3e%3c/text%3e%3ctext x='309.116' y='414.028' transform='matrix(.59837 .11248 -.09645 .5911 461.4 21.482)'%3e%3ctspan x='309.116' y='414.028'%3eO%3c/tspan%3e%3c/text%3e%3ctext x='105.058' y='459.272' transform='matrix(.56007 -.08172 .08475 .60547 461.4 21.482)'%3e%3ctspan x='105.058' y='459.272'%3eO%3c/tspan%3e%3c/text%3e%3ctext x='-45.708' y='455.835' transform='matrix(.582 -.215 .215 .582 461.4 21.482)'%3e%3ctspan x='-45.708' y='455.835'%3eA%3c/tspan%3e%3c/text%3e%3ctext x='518.35' y='144.724' transform='rotate(45.196 204.897 565.016) scale(.621)'%3e%3ctspan x='518.35' y='144.724'%3eA%3c/tspan%3e%3c/text%3e%3ctext x='271.188' y='388.298' transform='rotate(11.357 122.69 2331.003) scale(.621)'%3e%3ctspan x='271.188' y='388.298'%3eA%3c/tspan%3e%3c/text%3e%3ctext x='40.322' y='455.168' transform='matrix(.61 -.115 .115 .61 461.4 21.482)'%3e%3ctspan x='40.322' y='455.168'%3eM%3c/tspan%3e%3c/text%3e%3ctext x='94.429' y='448.079' transform='matrix(.618 -.064 .064 .618 461.4 21.482)'%3e%3ctspan x='94.429' y='448.079'%3eP%3c/tspan%3e%3c/text%3e%3ctext x='155.088' y='437.607' transform='matrix(.62 0 0 .62 461.4 21.482)'%3e%3ctspan x='155.088' y='437.607'%3eP%3c/tspan%3e%3c/text%3e%3ctext x='405.134' y='276.665' transform='matrix(.54 .306 -.306 .54 461.4 21.482)'%3e%3ctspan x='405.134' y='276.665'%3eP%3c/tspan%3e%3c/text%3e%3ctext x='232.095' y='409.793' transform='rotate(6.586 44.083 4020.832) scale(.621)'%3e%3ctspan x='232.095' y='409.793'%3eI%3c/tspan%3e%3c/text%3e%3ctext x='530.392' y='132.089' transform='rotate(46.59 205.751 546.6) scale(.621)'%3e%3ctspan x='530.392' y='132.089'%3eT%3c/tspan%3e%3c/text%3e%3ctext x='464.158' y='218.519' transform='rotate(36.82 198.426 703.928) scale(.621)'%3e%3ctspan x='464.158' y='218.519'%3eT%3c/tspan%3e%3c/text%3e%3ctext x='313.725' y='361.961' transform='matrix(.596 .175 -.175 .596 461.4 21.482)'%3e%3ctspan x='313.725' y='361.961'%3eM%3c/tspan%3e%3c/text%3e%3ctext x='513.704' y='123.248' transform='rotate(47.66 206.381 533.067) scale(.621)'%3e%3ctspan x='513.704' y='123.248'%3eG%3c/tspan%3e%3c/text%3e%3c/g%3e%3cpath fill='none' stroke='%23fff700' stroke-linecap='round' stroke-width='.828' d='M620.339 146.266s3.75-3.21 6.42-3.304m-5.88 2.857c.087-.087 22.387-3.21 23.095-3.925m-23.008 4.105c.087-.093 24.97-2.143 24.97-2.143m-25.057 2.23s26.486-1.249 28.094.093m-28.187-.18s25.958.18 26.405.8m-26.312-.8 24.97 2.049m-25.237-1.869c.087 0 25.418 2.23 27.914 5.44m1.335 4.545c-.087-.086-8.65-10.258-29.342-10.078m.093.18s14.357.98 18.903 5.974m-18.636-6.154s9.272-1.783 18.996 9.905'/%3e%3cpath fill='url(%23e)' stroke='%23000' stroke-width='1pt' d='M247.4 217.74s20.72.82 20.72 2.85-15.44 5.89-15.64 14.42 11.78 9.14 12.59 19.9c.81 10.77-9.34 12.39-11.37 15.24-2.04 1.42-6.91 16.65-6.3 25.59s3.25 39.2 7.92 45.3c3.66 2.84 9.14 11.98 15.03 9.14 5.89-2.85 1.83-13.2 1.22-16.05-.61-2.84 2.44-7.51 2.44-11.78s-2.24-7.72-2.03-8.73c.2-1.02 16.45 3.86 15.43 19.9-1.01 16.05-7.51 11.17-7.51 11.17s2.03 19.71-3.05 22.35c-9.14 4.87-15.84-1.02-15.84-1.02l.86 4.01-6.95-3.6s-8.94-12.8-10.97-18.49c-2.03-5.68-4.47-31.07-3.66-36.56.81-5.48 1.42-37.58 1.02-39.2-.41-1.63-2.03-28.44-1.02-32.5 1.02-4.06 7.31-21.94 7.11-21.94z' transform='matrix(.621 0 0 .621 461.4 21.482)'/%3e%3cpath fill='%23ff7000' stroke='%23000' stroke-width='.828' d='M601.162 153.42s8.955-8.7 14.128-7.695c2.645 0 .124 1.895.124 1.895s4.54.378 5.173 2.397c.124.881-2.149 1.136-2.149 1.136s1.895.379 2.019 2.018c.13 1.64-19.17.373-19.295.249z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.828' d='M601.665 153.04s9.589-1.26 13.625-5.296m-3.912 2.651s7.06-.254 7.06.758'/%3e%3cpath fill='%23FFF' stroke='%23000' stroke-linejoin='round' stroke-width='.776' d='M636.479 253.575s6.054-1.391 7.694-3.534c1.012-.758 6.31 7.949-7.694 3.534z'/%3e%3cpath fill='none' stroke='%23FFF' stroke-linecap='round' stroke-width='.776' d='M634.84 203.497s.757 4.67-1.386 7.818c-1.136 1.261-4.545 3.41-4.545 4.925 0 1.51 1.26 3.527 1.012 5.297-.255 1.764-2.143 3.534-2.018 5.043 0 1.515 2.142 9.588 1.887 9.712m-6.048-47.929s-4.794 1.64-5.807 6.434'/%3e%3cpath fill='%23c75b00' stroke='%23000' stroke-width='.828' d='M621.717 150.395s1.646 4.54 6.943.249c-3.41-4.664-6.943-.124-6.943-.249z'/%3e%3cpath d='M625.632 150.204c0 .244-.254.442-.568.442s-.567-.198-.567-.442c0-.243.254-.441.567-.441s.568.198.568.441z'/%3e%3cpath fill='%23FFF' stroke='%23000' stroke-width='.828' d='M578.403 139.857s10.047 10.874 16.55 10.756c1.18 3.192-2.957 6.16-4.609 7.576-3.31-1.062-6.303.192-13.984-9.26.478-6.03 2.16-8.836 2.043-9.072zm13.593-25.293c1.298-4.018 3.9-7.21 6.142-7.564-.59-3.074 4.732-16.662 20.214-21.866.943 6.974-6.62 13.83-6.62 13.83s22.809-3.9 27.417-9.694c-.472 2.602-5.08 18.792-29.43 18.674 9.222 8.75-2.95 15.724-8.153 13.594 9.576-7.328-2.714-11.7-9.57-6.974z'/%3e%3cpath fill='%23cccccd' stroke='%23CCC' stroke-width='.828' d='M599.796 108.894c4.608-2.956 6.26-2.956 10.048-2.366-2.72.354-2.72.472-2.72.472s-.236.354 1.416 1.894c-1.888-.478-3.546-1.54-8.744 0z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.828' d='M598.02 107s9.104-4.844 14.184-8.154'/%3e%3cpath fill='%2300F' stroke='%23000' stroke-width='.828' d='M590.22 158.177s12.532 3.427 13.948-14.538c-2.72-7.8-6.502-24.585-.708-29.43-5.322-3.663-11.11.119-11.11.119-.354.826-5.086 7.563 1.298 19.381-15.127-4.018-8.98 10.284-8.98 10.284.59-2.248 8.626-4.372 10.638 7.092.826 2.838-5.44 7.21-5.086 7.092z'/%3e%3cpath fill='%2300F' stroke='%23000' stroke-width='.828' d='M604.286 143.757s13.24-7.092 12.88-23.753c-11.228.236-15.246 14.767-15.246 14.767l2.366 8.986z'/%3e%3cpath fill='%23FFF' stroke='%23000' stroke-width='.828' d='M544.956 142.931s-9.806 8.508-15.364 5.788c-4.136 2.484-8.98-1.888-8.98-1.888s5.67 20.915 26.002 5.788c-.354-4.608-1.422-9.334-1.658-9.688z'/%3e%3cpath fill='%2300F' stroke='%23000' stroke-width='.828' d='M529.474 148.365c.826-4.372 4.254-6.502 6.974-2.366 3.664.714 7.328-14.296-5.676-11.818 3.664-19.617-7.325-26.945-7.325-26.945s-3.9 21.747-2.127 25.765c1.773 4.018-2.6-7.446-16.664-10.638-.237 16.432 15.719 24.114 15.719 24.114s4.491 4.136 9.099 1.888z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.828' d='M530.772 134.063s-6.142 5.204-4.726 12.296m-4.608-13.004s-1.418 5.08 1.655 12.29m-2.601 1.658s2.837-4.608 8.982 1.298'/%3e%3cpath fill='%23FFF' stroke='%23000' stroke-width='.828' d='M521.674 115.39c0-.118-9.336 0-3.782 9.457-4.136 1.298-13.354-4.725-6.972-12.767-20.92-.472-29.429-10.514-29.429-19.736 6.146 6.384 20.801 3.782 26.001 7.682-6.382-5.906-5.082-14.066-5.082-14.066s17.847 5.322 21.037 21.158c-1.064 3.074-1.536 8.508-1.773 8.272z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.828' d='M507.318 99.616c3.444 3.503 12.293 4.552 16.784 8.452'/%3e%3cpath fill='%23cccccd' stroke='%23CCC' stroke-width='.589' d='M511.392 109.956s7.326-.944 9.45 1.652c-2.867 0-3.823-.708-7.963.832 1.168-.596.849-1.658 1.486-1.658s-2.654-.826-2.973-.826z'/%3e%3cpath fill='%23923f00' stroke='%23000' stroke-width='.828' d='M547.912 52.635s4.017-3.546 8.39-.355c-1.976 5.904-9.098 3.664-9.098 3.664s.236 2.955-.472 4.373c1.422 1.072 2.595 4.61 2.595 4.61s7.328-1.773 8.868 1.418c2.807-.388 4.844 0 4.844 0s5.676-1.418 7.682-1.418c2.012 0 8.39 1.654 8.98 2.836.596 1.181 2.72 9.1 4.142 8.982 1.415-.118-3.428 1.89-4.732-.118-1.298-2.01-.944 2.6-.944 2.6s4.017 4.254 4.49 5.2c.471.943-2.478 8.625-.237 13.947-1.968.18-2.123 2.242-2.123 2.242-.112 2.341-3.074 2.956-3.074 2.956l-.708-3.192-2.012 1.186.826-2.484s2.72-6.62 2.956-8.744c.236-2.13-2.484-5.911-4.608-5.911-2.13 0-3.664 6.737-3.664 6.737s-1.062 5.08-.708 5.552-1.422-1.652-1.422-1.652-.944 3.074-1.652 4.018-2.248 1.298-2.248 1.298-1.062-3.074-.708-4.254 5.794-5.788 5.322-9.097c-.478-3.31 0-2.484-.124-2.602-.118-.118-2.832-2.482-2.95-3.782-.118-1.3-3.546 1.655-8.036.709-1.378 2.402-1.54 8.388-1.54 8.388s-.472 7.21.472 8.042c.95.826-2.36 2.596-2.36 2.596l-2.366 3.192s-.826-2.006-.826-1.888-1.658 1.18-1.658 1.18l.95-2.366c-.062-1.788 2.298-6.676 2.298-10.812s.298-8.568.298-8.568-4.372-.237-4.254 4.252c.118 4.497-1.061 4.733-.825 6.03s1.415 4.962 1.061 6.03c-.354 1.062-1.77 1.416-1.77 1.416l-.353.59s-4.372 2.012-4.254 2.838-.118-2.366-.118-2.366L542 96.48s2.602-1.652 2.602-5.788-.597-4.725-.479-5.67c.118-.95.715-4.377.597-4.731-.118-.355-2.478.945-3.192.945-.708 0 1.304-2.482 1.54-4.255s-2.366 1.655-4.49-.354c.987-2.182 2.478-2.837 2.714-4.491s-1.652 1.418-3.31.236c.136-1.586 1.776-2.954 1.776-2.954s-1.348-.166-1.894 0c-1.062-.355 1.186-2.01 1.304-4.373s-1.304-3.31-1.304-3.428-2.36-2.127-2.714-2.954-.354-1.773-.354-1.773-3.906 2.836-8.514-3.191c4.223-3.604 8.75-.946 8.75-.946s1.18-3.31 6.614-3.073c5.44.237 6.501 3.31 6.266 2.955z'/%3e%3cpath fill='%2300F' stroke='%23000' stroke-width='.828' d='M577.645 113.769c.093 0 10.035.298 10.135 5.614.1 5.31-3.05 3.937-3.149 3.937s-7.284-.888-7.284-.888l.298-8.663z'/%3e%3cpath fill='%23fffeff' stroke='%23000' stroke-width='.828' d='M567.995 112.29s12.401-.092 11.712 5.317c-.69 5.415-3.838 4.334-3.838 4.334l-6.005-.497-1.87-9.153z'/%3e%3cpath fill='%2300F' stroke='%23000' stroke-width='.828' d='m561.008 111.7 7.185.59s4.329.59 4.136 4.727c-.198 4.135-4.434 4.235-4.434 4.235l-6.986-.398.1-9.153z'/%3e%3cpath fill='%23FFF' stroke='%23000' stroke-width='.828' d='M544.18 113.769c-.1 0-10.042.298-10.142 5.614-.093 5.31 3.056 3.937 3.155 3.937s7.284-.888 7.284-.888l-.298-8.663z'/%3e%3cpath fill='%2300F' stroke='%23000' stroke-width='.828' d='M553.823 112.29s-12.4-.092-11.712 5.317c.69 5.415 3.838 4.334 3.838 4.334l6.005-.497 1.87-9.153z'/%3e%3cpath fill='%23FFF' stroke='%23000' stroke-width='.828' d='m560.816 111.7-7.185.59s-4.335.59-4.136 4.727 4.428 4.235 4.428 4.235l6.986-.398-.093-9.153z'/%3e%3cpath fill='%235e0043' stroke='%23000' stroke-width='.828' d='M580.054 171.46s5.167-7.614 7.347-6.8c1.9.633.453 6.526-.453 7.073l-6.894-.273zm-35.415 1.36c-1.627-2.267-3.987-8.52-6.16-6.8-1.907.633-.454 6.526.453 7.073l5.707-.273z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.828' d='M548.06 157.76s10.067 6.204 13.37 6.366 13.774-8.055 13.774-8.055'/%3e%3cpath fill='%235e0043' stroke='%23000' stroke-width='.828' d='m549.03 133.442 1.93-2.416 9.67 4.913 9.824-4.354 1.931 2.019-10.954 7.731-12.402-7.893z'/%3e%3cpath fill='%23474747' stroke='%23474747' stroke-linejoin='round' stroke-width='.776' d='M541.354 133.312c.782.987 7.03 8.582 8.16 14.866 1.124 6.285-.646-8.62-.646-8.62s7.731 3.789 7.973 6.205 3.695-.162 3.863-.578l-22.387-14.537 3.037 2.664zm38.197-.435s-8.135 10.712-7.166 22.387c-1.677-5.589-.323-14.817-.323-14.817l-1.77 1.13s-1.85 7.893-4.191 9.098c-.392-.938-.317-1.286-.317-1.286s-2.497 3.217-2.98 3.54.16 10.874.16 10.874.839 7.65 1.801 7.57c-1.099.534-2.446 1.372-2.446 1.372l-1-20.418 2.285-2.298s3.062-3.701 3.304-7.328c-1.329 1.13-2.82 1.453-2.82 1.453s-.403 5.155-1.608 5.875c-1.21.727-1.242 2.074-1.242 2.074l-.285-6.738 18.598-12.488z'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-width='.776' d='m560.946 145.278 1.578 32.212'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.828' d='M541.136 160.66s3.702 2.18 5.074 8.781c12.078-.888 15.867 3.385 15.867 3.385s9.904-4.75 14.5-3.869c1.608-3.378 6.197-7.731 6.197-7.731'/%3e%3cpath fill='%23b4b6b9' stroke='%23000' stroke-width='.828' d='m536.081 129.089 24.865 16.27 22.394-15.06s4.67-2.576 4.266-4.427c-.398-1.857-2.012-1.13-2.82-.807-.8.323-23.436 16.35-23.436 16.35l-24.082-15.226s-1.77-.56-2.093.565c-.323 1.13.664 1.77.906 2.335z'/%3e%3cpath fill='%23474747' stroke='%23474747' stroke-linejoin='round' stroke-width='.776' d='M580.551 124.866s-6.365-2.701-6.365-.36c0 2.335.18 2.577 1.205 4.08 1.018 1.496-.783 2.459-.783 2.459s-.242-.658-.602-1.683c-.36-1.018-3.782-1.739-4.08-2.937-.298-1.205.72-3.124-1.323-3.36-2.037-.242-4.018.839-4.44 3.18s-3.061 7.8-3.061 7.8l.36-12.42c4.483.316 12.805 1.297 19.207 2.036-1.919-.298.72.125.665.783-.18.54-.845.596-.783.422zm-22.511-3.124c-1.136 0-6.843.659-8.284 1.503-1.44.839 2.341 2.155 1.863 3.298s-.54 3.421-2.341 2.943c-1.801-.484-7.862-3.483-8.042-4.502s-1.441-1.08-1.441-1.08 17.407-2.342 18.245-2.162z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.828' d='m560.785 120.314-.044 15.264M549.03 102.33s-6.975 11.32-7.111 11.669'/%3e%3cpath fill='url(%23f)' stroke='%23000' stroke-width='1pt' d='M161.8 129.74s4.89 6.67 4.33 8.56c2 1.56 4.23 7.79 4.23 7.79' transform='matrix(.621 0 0 .621 461.4 21.482)'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.828' d='M573.615 101.361s-6.558 9.253-6.353 9.942'/%3e%3cpath d='M540.013 57.364c-.149.517-.985.717-1.867.447s-1.478-.909-1.33-1.426c.15-.518.985-.718 1.868-.448s1.477.91 1.329 1.427zm2.651-.183c.148.517.984.718 1.867.447s1.477-.908 1.329-1.426c-.149-.517-.985-.718-1.867-.447s-1.478.909-1.33 1.426z'/%3e%3cpath fill='%23ff7000' stroke='%23000' stroke-linejoin='round' stroke-width='.828' d='M619.438 248.849s-2.434.46-2.353.683c.074.23-7.073.46-7.223.23-.155-.23-1.068 1.217-1.068 1.217l1.143-.683s1.745 1.82 2.28 1.67-.23.683-.075.838c.149.15.683-.304.683-.304l11.811-.199-5.198-3.452z'/%3e%3cpath fill='%23ff7000' stroke='%23000' stroke-linejoin='round' stroke-width='.776' d='m623.841 252.525-9.65.28s-2.428 2.204-2.584 2.732c-.149.534 1.596.683 1.596.683l.535 1.826 1.217-.454s8.203 1.218 15.736-.46c3.8-1.328 4.465-2.924 1.8-3.893-2.657-.969-8.575-.677-8.65-.714z'/%3e%3cpath fill='url(%23g)' stroke='%23000' stroke-width='1pt' d='m208.37 403.93 27.97-1.25-5.21-4.42 75.65-3.05-2.61-6.01-84.7 3.4 10.19 4.76-22.88.68.68 2.38-6-.23s6.68 2.6 6.91 3.74z' transform='matrix(.621 0 0 .621 461.4 21.482)'/%3e%3cpath fill='url(%23h)' stroke='%23000' stroke-width='1pt' d='M239.73 249.42c-2.23-1.11-12-2.44-22.89 4.67l.45 25.11s15.99-8.67 23.77-6.67c-.45-7.78-.45-17.77-1.33-23.11z' transform='matrix(.621 0 0 .621 461.4 21.482)'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.828' d='m514.231 223.71-40.959 40.664m59.214-40.365-33.244 43.78m31.76-55.207-44.374 53.723m-1.336-.745 4.304-5.043m49.864-20.927-17.216 23.747m-.742 3.117.446 9.048m25.374-27.603-18.252 22.859m14.991-1.783 7.421-12.171m-4.602-2.372-8.904 10.09m6.234-19.586-6.085 7.415m-1.783-18.251s-18.55 27.156-18.253 29.386m16.322-32.944c-.44.292-16.025 20.921-16.025 20.921m-.89 6.527-2.82 3.415m-3.562 5.198-4.303 5.639'/%3e%3cpath fill='%238a9396' stroke='%232b2b2b' stroke-width='.828' d='M512.205 161.207s-1.257 3.95 0 5.924c1.256 1.975 9.155 17.953 9.155 17.953s5.388-6.644 7.363-6.824c1.974-.174 1.074 17.239 1.074 17.239s-3.23 3.049-5.204 2.869c-1.976-.18 4.844 6.824 4.664 12.749s-8.974 35.366-12.205 35.9c-3.232.54 1.436-5.384 1.256-6.999s-1.077-.54-1.795-2.335 1.078-4.49.718-6.284c-.359-1.795-1.975-1.435-2.154-2.69-.18-1.26 1.077-1.614.898-3.055-.18-1.434-2.155-1.074-1.975-2.335.18-1.254.359-.714.18-3.049s-.539 1.615-2.514 1.795-3.59 4.67-3.59 4.67-3.95 5.564-7.9 3.049c2.334 5.03.54 7.185-.358 7.359-.898.18.717 3.95-1.437 4.13s1.616 8.439-.897 9.16c2.692 1.254.538 2.868.538 2.868s-6.222.522-4.847 8.62c-18.311-6.465-27.287-17.593-27.108-28.902.18-11.314 3.77-21.542 12.567-25.312 2.513-9.34 6.822-19.393 6.822-19.393s-.718-4.13-.18-6.819c.54-2.695 3.052-5.384 3.052-5.384s-.36-6.465-.179-9.694c.18-3.235 1.436-4.67 1.615-6.464s-.538-10.955 1.257-12.57 5.206-1.434 7.001-2.508c1.796-1.08 4.13-3.056 6.463-2.876s4.308 1.795 4.308 1.795 8.798 0 9.336 3.41c.538 3.415-1.795 4.67-1.795 4.67s1.257 4.85-4.13 9.333z'/%3e%3cpath fill='%23cecfcf' stroke='%232b2b2b' stroke-width='.828' d='M504.394 148.77c.282.52-.36 1.413-1.433 1.994s-2.172.63-2.454.11c-.281-.521.36-1.414 1.434-1.995s2.172-.63 2.453-.11z'/%3e%3cpath d='M502.904 149.676c0 .329-.299.595-.667.595-.368 0-.667-.266-.667-.595 0-.328.299-.594.667-.594.368 0 .667.266.667.594z'/%3e%3cpath fill='none' stroke='%232b2b2b' stroke-width='.388' d='M516.03 155.618s2.18 9.737-.427 16.456m1.097-20.716s4.255 5.626 3.706 12.625m-3.294-13.861c.138 0 3.568 3.018 3.43 5.074m-2.606-6.31s2.333 1.646 2.881 3.292'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.828' d='M516.838 147.924s-8.37 13.587-7.273 22.095'/%3e%3cpath fill='none' stroke='%232b2b2b' stroke-width='.388' d='M517.387 147.514s-11.115 6.589-13.173 28.131'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.828' d='m516.152 151.495-4.391 3.29'/%3e%3cpath fill='none' stroke='%232b2b2b' stroke-width='.388' d='M500.097 176.881s6.175-25.66 17.153-29.367'/%3e%3cpath fill='%232b2b2b' stroke='%232b2b2b' stroke-width='.828' d='M521.503 185.525s5.903-7.408 7.275-7.135.957 17.152.957 17.152-4.39 3.291-5.347 3.155c-.963-.137 4.937 7.961 4.8 10.98s-.273 3.017-.273 3.017 0-1.782-1.372-4.664-.553-6.179-9.47-13.45c-2.196-4.528 4.391 2.744 5.762 1.645 1.373-1.093-2.469-10.563-2.332-10.7z'/%3e%3cpath fill='none' stroke='%232b2b2b' stroke-width='.828' d='M511.014 143.794s-2.48.677-2.82 1.69c-.338 1.018-1.803 2.03-2.592 1.688-.79-.335-2.256-1.577-2.256-1.577'/%3e%3cpath fill='%232b2b2b' stroke='%232b2b2b' stroke-linejoin='round' stroke-width='.776' d='M496.919 152.476s-3.721 3.72-1.917 4.173c1.804.447 3.721-2.931 3.721-2.931s0 5.75 1.579 4.844c1.579-.9 6.201-4.167 6.201-4.167s1.579-.118 1.917 0c.339.111 4.285 3.49 6.878 2.254-1.465 3.831-3.157 4.285-3.157 4.285s-2.706 3.496-6.201 2.701c-3.496-.789-4.398-2.254-4.398-2.254s-2.932.23-3.834-1.124c-.902-1.354-1.24-2.143-1.24-2.143s-1.691 1.69-2.143.9c-.45-.788 0-5.414 2.594-6.538z'/%3e%3cpath fill='none' stroke='%232b2b2b' stroke-width='.828' d='M518.005 147.29s-6.878-2.03-9.246 1.354c-2.368 3.378-1.804 5.297-.564 5.633'/%3e%3cpath d='M519.066 147.098c0 .81-.58 1.468-1.297 1.468s-1.296-.657-1.296-1.468.58-1.468 1.296-1.468 1.297.657 1.297 1.468z'/%3e%3cpath fill='%232b2b2b' stroke='%232b2b2b' stroke-width='.828' d='M499.048 164.647s2.805 4.316 6.149 5.502-2.32 2.211-5.664-.05c-2.427-3.29-1.78-5.663-1.78-5.663s.647-.652 1.295.211zm24.002 25.461s-7.875-10.948-10.14-11.544c-2.266-.59 1.725-1.074 4.153 1.242 2.427 2.316-.647-3.776-.647-3.776l6.634 14.078z'/%3e%3cpath fill='%232b2b2b' stroke='%232b2b2b' stroke-linejoin='round' stroke-width='.776' d='M498.293 253.376c3.02-.807 16.18 7.551 19.147 9.656 2.967 2.1 9.171.752 9.171.752s-2.863 1.726-4.64 2.16c-1.78.43 5.286.43 5.286.43s-16.828 4.638-33.926-4.366c-1.565-7.011 3.667-8.576 4.962-8.632z'/%3e%3cpath fill='%232b2b2b' stroke='%232b2b2b' stroke-width='.828' d='M517.548 192.803s-2.211-.428-3.344-1.726c-1.132-1.292-2.75-4.477-4.423-5.825-1.672-1.347-10.032-5.93-13.052-5.608s-3.938-.322-4.316-.701-1.617.161-1.402 1.726c.216 1.565-2.32 5.018-1.402 6.632.917 1.621 5.232 8.198 6.095 8.415.863.217.324 3.832.324 3.832s3.829 3.88 4.8 4.098c.97.217 1.941.92 1.834 1.832-.108.92-4.208 5.937-4.208 5.937s-4.422 2.316-4.476 3.614c-.054 1.292 1.078 3.987 4.585 4.85 3.505.863 12.944.162 13.43-.646.485-.807 1.24-5.663.916-6.148s-2.643-1.943-3.83-1.726c-1.185.217-2.264 1.186-2.157 1.403.108.218-1.671 1.13-1.671.267s3.505-4.744 3.829-4.421c.324.323 5.286.807 6.203 3.291.917 2.478.917 4.26 3.505 3.993 2.59-.273 6.202-2.645 6.525-7.607s-2.91-8.309-3.72-8.793-3.506-2.106-3.721-2.857c-.216-.758-.755-3.235-.324-3.832z'/%3e%3cpath fill='%232b2b2b' stroke='%232b2b2b' stroke-width='.828' d='M470.893 214.706s8.36-2.16 10.517-2.105c2.158.05 10.302 3.825 12.676 6.148 2.373 2.316 7.227 7.818 10.41 7.334 3.182-.485 4.099-1.13 4.099-1.13l-1.241 2.372s-2.589.702-3.883.379c-1.295-.323-3.83-1.137-6.365-3.615-2.535-2.484-10.356-9.172-16.99-8.687-6.634.49-10.464 7.017-10.464 7.017s.054-3.186.324-3.887-1.402 1.509-1.402 1.509l2.319-5.335z'/%3e%3cpath fill='%232b2b2b' stroke='%232b2b2b' stroke-width='.828' d='M501.69 221.177c.055.05 2.104.59 5.556.59s5.286-1.51 5.286-1.51l-.216-1.347.54-1.888s2.642 2.696 2.588 3.236-1.078.758-1.078.758l-.378-1.298-.916 1.136s-5.017 3.987-7.767 3.397c-2.751-.596-5.286-2.372-4.585-2.807.701-.428 1.079-.267.97-.267zm-12.19 7.067s-3.02-.056-4.368.59-1.834 1.46-2.75 1.347c-.917-.105-1.619-1.291-1.35-1.776.378-.757 2.158-1.726 5.556-1.459 3.398.273 2.913 1.298 2.913 1.298zm10.573 8.197c0-.161-.216-4.421-1.888-6.148-1.672-1.726-3.722-1.726-4.639-1.515-.917.217 3.398 2.105 3.83 3.347s1.834 4.695 1.456 5.558c-.378.857-1.079-2.428-3.722-3.347s-6.31-.429-5.555.758 3.722.105 5.232 2.639 2.643 5.235 2.643 5.235l.485-1.838 1.349-.373.161-3.509.648-.807z'/%3e%3cpath fill='%232b2b2b' stroke='%232b2b2b' stroke-linejoin='round' stroke-width='.776' d='m497.915 250.246-2.75-5.502s-.864-3.503-3.183-4.477c-2.319-.97-5.394-.808-5.448.378s4.963 2.695 5.286 3.348c.324.645.162 1.726-.27 1.776-.43.055-2.642-.808-3.775-.54-1.133.273-1.78 1.726-3.452 1.297-1.672-.435-3.075-5.769-2.427-6.31.647-.54-1.24.97-1.618-.434s.54-5.769-.108-6.31c-.647-.54-3.775-2.427-3.83-2.806-.053-.373.162-21.462 17.8-3.987-7.552-8.955-10.518-7.986-11.92-8.036-1.025 0-7.875.59-9.601 9.328-1.726 8.737-3.776 3.291-3.776 3.291s-.377 3.776 1.457 4.856c1.833 1.075-.864 4.204-.864 4.204s-3.29-8.035-2.804-11.544c-.647 2.807-.593 9.762 3.56 17.37 4.854 5.123 9.439 9.873 21.628 15.208 6.419-9.812 6.095-10.998 6.095-11.11z'/%3e%3cpath fill='%238a9396' stroke='%232b2b2b' stroke-linejoin='round' stroke-width='.776' d='M486.373 250.302s3.56.428 4.53 2.267c.971 1.831 1.403 4.638 1.403 4.638.593-1.186.862-2.21 2.05-3.074s2.05-.975 1.995-1.62-3.776-4.583-5.663-4.8-5.178 2.049-5.178 2.049-.593.863.863.54z'/%3e%3cg fill='none' stroke-linecap='round' stroke-width='1.25'%3e%3cpath stroke='%238a9396' stroke-width='.776' d='M494.504 259.58s9.225 4.204 24.42 4.477'/%3e%3cpath stroke='%232b2b2b' stroke-width='.776' d='M525.3 216.755s-.788 7.744-6.744 23.02'/%3e%3cpath stroke='%232b2b2b' stroke-linecap='butt' stroke-width='.828' d='M524.115 221.519s-1.788 5.557-6.75 9.724'/%3e%3c/g%3e%3c/svg%3e";
            },
            4523: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 960 600'%3e%3cdefs%3e%3cradialGradient id='a'%3e%3cstop offset='.22' stop-color='%23f9f0aa'/%3e%3cstop offset='1' stop-color='%23b07e09'/%3e%3c/radialGradient%3e%3cradialGradient xlink:href='%23a' id='d' cx='447.42' cy='308.27' r='16.53' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='e' cx='451.56' cy='313' r='10.91' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='f' cx='454.11' cy='308.64' r='9.78' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='g' cx='458.39' cy='307.06' r='17.35' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='j' cx='445.98' cy='252.36' r='13.02' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient id='m' cx='477.86' cy='215.27' r='.34' gradientUnits='userSpaceOnUse'%3e%3cstop offset='.26' stop-color='%23a50a0a'/%3e%3cstop offset='1' stop-color='%234c0505'/%3e%3c/radialGradient%3e%3cradialGradient id='n'%3e%3cstop offset='0' stop-color='%23fff'/%3e%3cstop offset='1' stop-color='%23fff' stop-opacity='0'/%3e%3c/radialGradient%3e%3clinearGradient id='h' x1='473.91' x2='472.36' y1='259.17' y2='231.96' gradientUnits='userSpaceOnUse'%3e%3cstop offset='.22' stop-color='%23b07e09' stop-opacity='0'/%3e%3cstop offset='1' stop-color='%23b07e09'/%3e%3c/linearGradient%3e%3clinearGradient id='i' x1='483.13' x2='485.49' y1='296.66' y2='326.58' gradientUnits='userSpaceOnUse'%3e%3cstop offset='.22' stop-color='%23b07e09' stop-opacity='0'/%3e%3cstop offset='1' stop-color='%23b07e09'/%3e%3c/linearGradient%3e%3clinearGradient id='k' x1='451.54' x2='455.37' y1='249.52' y2='240.58' gradientUnits='userSpaceOnUse'%3e%3cstop offset='.22' stop-color='%23f9f0aa'/%3e%3cstop offset='1' stop-color='%23b07e09'/%3e%3c/linearGradient%3e%3clinearGradient id='l' x1='473.31' x2='475.93' y1='237.25' y2='270.45' gradientUnits='userSpaceOnUse'%3e%3cstop offset='.22' stop-color='%23f9f0aa'/%3e%3cstop offset='1' stop-color='%23b07e09'/%3e%3c/linearGradient%3e%3c/defs%3e%3cpath fill='%234997d0' d='M0 0h960v600H0z'/%3e%3cpath fill='%23fff' d='M320 0h320v600H320z'/%3e%3cg stroke='%2324420e'%3e%3cpath fill='none' stroke-width='.44' d='M452.12 377.48c2.67-.4 4.2-1.14 6.04-1.79m2.21-4.05a13.03 13.03 0 0 1 3 4.64m-8.12-5.08a15.4 15.4 0 0 1 3.14 4.15m-49.58-136.58c-1.04 1.6-3.1 2.73-4.78 3.43m-.34-.2c.04-1.37-.24-3.03.05-4.4m-1.98 5.03c.11.37.44 1.4.68 2.03m2.02.92c-.38.08-1.52.26-2.03.34m-3.95-.88c-.01 2.52.29 5.55.53 7.82m-1.79-.96c.47.76.95 1.5 1.54 1.88m-4.58 6.47c.49.94.94 2.12 1.3 3.96m3.72-4.63c-.41.2-1.21.93-1.93 1.54m1.59 4.4c-.98.87-2.2 1.5-3.43 2.12m-3.81 40.41a15.98 15.98 0 0 0 3.96 4.68m.58 1.69a8 8 0 0 1-2.95-.97m4.4 8.41 1.69.97m-.44 3.47c1.25.82 2.51 2.28 3.77 3.86m-1.45 2.85c1.39.3 2.5.64 3.23 1.06m-1.06 2.42 2.12.07m1.21-5.38c-.1 1.53-.25 2.97-.48 4.25m1.01 1.59.43-1.64m4.69 5.99-.15 3.24m39.21 27.9-1.16 1.6m-2.41-3.92-.68-1.83'/%3e%3cg stroke-width='.16'%3e%3cpath fill='%23406325' d='M486.11 384.93c-.8-1.26-2.1-2.03-3.28-2.66-7.72-4.05-15.4-5.84-24.11-7.24-2.02-.34-4.03-2.22-6.09-3.19-4.96-2.36-10.49-3.28-15.31-5.7a7.78 7.78 0 0 1-2.1-1.54c-1.93-2.22-5.4-2.9-7.55-4.97-8.33-7.87-17.18-15.12-21.77-25.55-5.57-12.7-12.5-25.79-11.57-40.23.61-9.12-.75-18.35 1.5-27.04 3.33-12.9 7.59-25.64 15.4-36.31l-1.3.82c-7.87 10.67-12.13 23.42-15.46 36.31-2.24 8.7-.89 17.92-1.5 27.04-.93 14.44 6 27.53 11.57 40.28 4.59 10.38 13.49 17.62 21.78 25.55 2.15 2.02 5.62 2.7 7.53 4.97.57.63 1.83 1.4 2.11 1.54 4.83 2.42 10.35 3.34 15.31 5.65 2.06 1.02 4.08 2.85 6.1 3.2 8.7 1.4 16.38 3.23 24.1 7.23a8.02 8.02 0 0 1 3.28 2.66l1.36-.82'/%3e%3cg fill='%2367923d'%3e%3cpath d='M406.34 331.62c-2.8-6.3-1.36-21.6-.2-23.53 6.63 13 4.43 23.74.2 23.53zm45.86 45.39c-7.1.36-20.61 9.3-21.86 11.4 15.08.11 24.02-7.32 21.86-11.4zm7.46-4.29c-6.85-5.45-14.19-23.66-14.03-26.5 15.1 10.83 18.93 24.28 14.03 26.5z'/%3e%3cpath d='M454.61 372.78c-6.95-4.24-15.79-20.11-15.94-22.75 15.2 8.19 20.2 20.12 15.94 22.75zM439.05 366c.98-7.82-5.67-24.24-7.59-25.98-2.95 16.47 3 27.57 7.59 25.98zm-27.31-24.28c-2.3-5.65-.61-19.32.47-21 5.52 11.7 3.26 21.22-.47 21zm-13.71-76.83c3.59-6.65 18.38-15.71 20.99-15.93-6.77 14.57-18.04 19.83-20.99 15.93z'/%3e%3cpath d='M398.74 259.33c2.15-7.28 14.87-19.27 17.36-20.03-3.73 15.67-13.68 23.17-17.36 20.03zm27.81 99.15c-5-6.18-8.01-23.86-7.29-26.36 11.27 12.51 12.03 25.23 7.29 26.36zm-28.65-36.46c-6.9 1.09-21.36-4.64-22.92-6.34 14.53-3.15 24.29 2.07 22.92 6.34zm-2.22-9.68c.82-5.58 8.67-15.8 10.36-16.66-1.1 11.96-7.45 18.6-10.36 16.66zm51.33 58.54c-8.48.43-24.63 11.1-26.13 13.62 18.03.14 28.7-8.74 26.13-13.62z'/%3e%3c/g%3e%3cg fill='%23406325'%3e%3cpath d='M406.41 331.47c4.23.21 6.4-10.4-.27-23.38 1.21 12.32 1.2 22.31.27 23.38zm11.18 19.99c-4.47-5.47-19.38-11.33-21.71-11.14 8.88 12.08 19.88 15.1 21.71 11.14zm-24.42-52.98c-1.15-8.04-12.33-22.71-14.74-23.97 1.51 17.18 10.55 26.7 14.74 23.97zm8.39 34.29c-5-3.68-18.97-5.34-20.94-4.72 10.14 8.3 20.21 8.46 20.94 4.72zm-9.36-24.83c-2.89-5.69-14.81-13.48-16.9-13.7 5.53 12.39 14.57 16.94 16.9 13.7zm2.73-47.54c.9-7.57-5.53-23.45-7.34-25.16-2.87 15.93 2.91 26.67 7.34 25.16zm4.47-14.92c2.66-6.5.76-22.43-.52-24.42-6.4 13.51-3.83 24.65.52 24.42z'/%3e%3cpath d='M404.42 237.83c3.14-4.77 4.16-17.68 3.48-19.47-7.23 9.71-6.95 18.94-3.48 19.47zm5.95-6.14c4.4-3.48 9.22-15.5 9.08-17.43-9.74 6.95-12.22 15.84-9.08 17.43zm-16.05 43.2c.1.87-.98-8.18-10.05-18.31.4 14.81 6.25 20.42 10.05 18.31zm32.56 85.78c-6.18-4.56-23.39-6.73-25.77-5.93 12.56 10.36 24.88 10.55 25.77 5.93zm12.07 5.24c-4.54 1.6-10.44-9.42-7.54-25.88 2.81 13.95 6.18 25.06 7.54 25.88zm13.3 11.15c2.12 4.08-6.7 11.44-21.79 11.31 11.96-4.89 21.24-9.86 21.79-11.31zm7.39-4.47c4.86-2.25 1.1-15.54-14-26.37 8.59 13.21 14.45 24.61 14 26.37z'/%3e%3cpath d='M454.57 372.67c4.28-2.67-.69-14.44-15.9-22.64 9.41 11.18 16.1 20.97 15.9 22.64zm-42.79-30.99c3.73.22 5.96-9.26.48-20.92.72 10.97.42 19.97-.48 20.92zm-13.76-76.74c2.95 3.9 14.05-1.3 20.84-15.92-10.17 9.34-19.23 16.06-20.84 15.92z'/%3e%3cpath d='M398.86 259.33c3.68 3.14 13.54-4.3 17.27-19.98-8.1 11.25-15.64 19.74-17.27 19.98zm27.72 99.09c4.74-1.12 3.95-13.78-7.25-26.27 5 13.41 8.01 24.75 7.25 26.27zm-28.87-36.46c1.4-4.24-8.3-9.37-22.8-6.26 12.26 2.2 22.04 5.04 22.8 6.26zm-1.94-9.61c2.9 1.89 9.18-4.66 10.29-16.62-4.68 9.18-9.17 16.27-10.29 16.62zm51.2 58.68c2.58 4.88-7.96 13.67-26.04 13.52 14.29-5.84 25.38-11.78 26.04-13.52z'/%3e%3cpath d='M399.36 326.3c-2.66-6.26-14.8-15.46-16.98-15.84 4.94 13.64 14.25 19.15 16.98 15.84z'/%3e%3c/g%3e%3cg fill='%2367923d'%3e%3cpath d='M392.42 273.92c4.07-4.67 17.47-9.13 19.6-8.86-8.04 10.4-17.94 12.51-19.6 8.86zm25.07 77.59c-1.8 3.92-12.7.92-21.65-11.15 10.89 6.83 20.25 11.5 21.65 11.15zm-24.39-53.05c-4.2 2.73-13.13-6.74-14.69-23.88 6.63 13.2 13.04 23.38 14.69 23.88zm8.42 34.34c-.77 3.73-10.69 3.59-20.86-4.72 10.72 3.4 19.73 5.34 20.86 4.72zm-9.45-24.95c-2.33 3.24-11.29-1.27-16.8-13.66 8.19 7.97 15.48 13.75 16.8 13.66zm2.76-47.55c-4.43 1.56-10.16-9.08-7.3-25 2.67 13.48 5.94 24.17 7.3 25zm4.47-14.86c-4.3.23-6.87-10.81-.47-24.32-.82 12.8-.5 23.23.47 24.32zm5.04-7.67c-3.47-.53-3.72-9.66 3.52-19.37-2.74 9.98-4.15 18.37-3.52 19.37zm5.98-6.08c-3.14-1.64-.7-10.43 9.04-17.34-5.53 8.65-9.32 16.18-9.04 17.34z'/%3e%3cpath d='M394.25 274.9c-3.8 2.1-9.58-3.5-9.99-18.32 5.1 11.68 8.6 17.8 9.99 18.32zm32.57 85.8c-.89 4.63-13.14 4.4-25.68-5.9 13.17 4.28 24.25 6.7 25.68 5.9zm-8.17-9.48c-4.02-4.34-7.16-17.35-6.75-19.24 9.01 8.74 10.22 18.16 6.75 19.24zm-16.88-24.99c-3.57-5.79-3.88-20.9-2.92-22.96 8.26 11.81 7.25 22.59 2.92 22.96zm-2.63.09c-2.74 3.3-11.93-2.16-16.87-15.83 8.13 9.1 15.47 15.8 16.87 15.83z'/%3e%3c/g%3e%3cg fill='%23406325'%3e%3cpath d='M392.37 274c1.62 3.62 11.45 1.53 19.5-8.88-11.98 6.8-16.72 9.74-19.5 8.88zm9.34 52.07c4.33-.37 5.33-11.04-2.93-22.85 2.66 11.86 3.79 21.68 2.93 22.85zm16.96 25.11c3.47-1.07 2.25-10.45-6.71-19.18 4.4 9.73 7.2 18.01 6.71 19.18z'/%3e%3cpath d='M394.23 291.77c2.06-8.39-1.7-22.6-4.3-25.56-4.72 15.43-.24 26.6 4.3 25.56z'/%3e%3c/g%3e%3cpath fill='%2367923d' d='M393.93 293.77c-5.9 1.34-8.64-12.03-4.08-27.08 1.07 13.55 2.83 26.15 4.08 27.08z'/%3e%3cpath fill='%2367923d' d='M392.73 293.72c-.56-7.53 6.93-23.09 8.91-24.7 2.02 15.8-4.46 26.3-8.91 24.7z'/%3e%3cpath fill='%23406325' d='M392.84 293.61c4.41 1.64 10.85-8.76 8.83-24.56-3.5 13.26-7.44 23.76-8.83 24.56z'/%3e%3cpath fill='%2367923d' d='M394.13 303.26c0-7.6 8.47-22.23 10.56-23.62.84 16.16-6.33 25.83-10.56 23.62z'/%3e%3cpath fill='%23406325' d='M394.21 303.41c4.23 2.21 11.3-7.36 10.47-23.52-4.4 12.85-9.05 22.9-10.47 23.52z'/%3e%3c/g%3e%3cg fill='%23ba1f3e' stroke='%23511124' stroke-width='.22'%3e%3ccircle cx='396.83' cy='251.27' r='1.08' stroke-width='.19'/%3e%3ccircle cx='405.2' cy='245.07' r='1.08' stroke-width='.19'/%3e%3ccircle cx='401.56' cy='241.71' r='1.09' stroke-width='.19'/%3e%3ccircle cx='392.5' cy='313.12' r='1.28'/%3e%3ccircle cx='395.03' cy='297.13' r='1.28'/%3e%3ccircle cx='408.21' cy='334.46' r='1.28'/%3e%3ccircle cx='402.39' cy='336.43' r='1.28'/%3e%3ccircle cx='446.7' cy='367.63' r='1.28'/%3e%3ccircle cx='449.61' cy='374.71' r='1.28'/%3e%3c/g%3e%3c/g%3e%3cg stroke='%2324420e'%3e%3cpath fill='none' stroke-width='.44' d='M561.15 258.97c.62.62 1.17.8 2.3 1.9m-6.63-18.95c-.04-1.37-.63-3.6-.92-4.97m3.45 2.98c.06 1.95-.22 3.8-1.06 5.5m-4.16-.53c1.75 1.58 3.5 3.08 5.26 3.9m3.82 1.22a18.7 18.7 0 0 1-.68 5.94m.32 1.51 1.31-2.26m-1.86 12.22c1.4.3 2.81 1.95 3.5 3.48m.48-1.29 1.64-2.19m1.71 30.73a23.98 23.98 0 0 1-2.46 3.48m-3.96-.07c.79 1.46 1.56 2.95 2.6 4.03m2.45 5.87a13.19 13.19 0 0 1-4.44 4.03m.14 4.5c-1.1.75-2.43 2.95-3.69 4.71m8.44-20.18-2.12.87m-1.4-7.49 1.26 1.11m-9.3 37.39c-.84-.1-1.46 0-2.12.07m-2-1.93.61 1.64m-7.71 5.12c-.26 1.87-.07 3.73.2 5.6m4.31-9.02 1.02 2.25m3.83-.2-2.53.41m-30.85 25.27-.92 1.74m11.9-3.93c-1.5.19-2.78-.04-4.1-.2m-5.46 5.94a27.28 27.28 0 0 0-2.94-.96m-14.74 2.66c-.9.77-1.99 2.44-3.07 4.1m-.55-4.57c-2.43 1.25-3.18 3.71-4.44 5.8m2.8 2.87a52.47 52.47 0 0 1-5.33-2.05m16.77-.68c-2.32-1.2-4.75-1.09-7.14-1.47m10.76-.34c-3.63-.7-7.01-.61-10.28-.14m7.78-2.6-1.4-.58m-5.53 5.5-2.32-1.3m57.94-49.19c-1.26.82-2.51 2.28-3.77 3.86m1.83-79.62-2.15-.72'/%3e%3cg stroke-width='.16'%3e%3cpath fill='%23406325' d='M474.39 384.85c.8-1.26 2.1-2.03 3.28-2.66 7.72-4.05 15.4-5.84 24.11-7.24 2.02-.34 4.03-2.22 6.1-3.19 4.95-2.36 10.48-3.28 15.3-5.7a7.78 7.78 0 0 0 2.11-1.54c1.92-2.22 5.38-2.9 7.54-4.97 8.33-7.87 17.18-15.12 21.77-25.55 5.57-12.7 12.5-25.79 11.57-40.22-.61-9.13.75-18.35-1.5-27.05-3.33-12.9-7.59-25.64-15.4-36.31l1.3.82c7.87 10.67 12.13 23.42 15.46 36.31 2.24 8.7.89 17.92 1.5 27.05.93 14.43-6 27.52-11.57 40.27-4.6 10.38-13.49 17.63-21.78 25.55-2.15 2.02-5.62 2.7-7.54 4.97a9.98 9.98 0 0 1-2.1 1.54c-4.83 2.42-10.35 3.34-15.31 5.66-2.06 1-4.08 2.84-6.1 3.18-8.7 1.4-16.38 3.24-24.1 7.25a8.02 8.02 0 0 0-3.28 2.65l-1.36-.82'/%3e%3cg fill='%23406325'%3e%3cpath d='M553.65 334.6c2.74-7.42 0-24.84-1.49-26.95-6.65 15.37-3.34 27.5 1.49 26.95z'/%3e%3cpath d='M546.54 341.64c2.3-5.65.61-19.32-.47-21-5.52 11.7-3.26 21.22.47 21zm16.81-74.15c-3.3-6.1-16.87-14.42-19.26-14.62 6.21 13.37 16.55 18.2 19.26 14.62z'/%3e%3cpath d='M561.76 259.47c-1.8-6.07-12.4-16.05-14.47-16.7 3.1 13.07 11.4 19.32 14.47 16.7zm4.74 14.96c-3.54-4.05-15.16-7.93-17.01-7.7 6.98 9.04 15.57 10.87 17.01 7.7zm-2.8 46.33c6.13.97 18.96-4.12 20.34-5.63-12.9-2.8-21.55 1.84-20.34 5.63zm-.15-5.64c-.04-5.64-6.4-16.86-7.96-17.93-.55 12 4.8 19.45 7.96 17.93z'/%3e%3cpath d='M563.96 301.44c0-7.6-8.47-22.23-10.56-23.62-.84 16.16 6.33 25.83 10.56 23.62zm-52.89 75.27c4.48 5.5 19.65 11.13 22.09 10.9-8.8-12.23-20.07-15.05-22.09-10.9z'/%3e%3c/g%3e%3cg fill='%2367923d'%3e%3cpath d='M553.56 334.43c-4.82.55-8.09-11.44-1.4-26.79-.49 14.2.24 25.63 1.4 26.79zm-53.37 43.66c7.1.36 20.61 9.3 21.86 11.4-15.08.11-24.02-7.32-21.86-11.4zm0-7.94c2.1-7.97 15-21.21 17.51-22.15-3.6 17.13-13.74 25.53-17.51 22.15zm21.27-4.23c-.98-7.82 5.67-24.24 7.58-25.98 2.96 16.47-3 27.58-7.58 25.98zm21.46-14.54c4.47-5.47 19.38-11.33 21.71-11.14-8.88 12.08-19.88 15.1-21.71 11.14zm25.79-53.26c.9-6.33 9.71-17.88 11.6-18.87-1.19 13.52-8.3 21.02-11.6 18.87z'/%3e%3cpath d='M557.02 336.18c5.82-4.29 22.1-6.23 24.4-5.5-11.81 9.67-23.55 9.85-24.4 5.5zm10.27-24.52c3.03-5.98 15.57-14.17 17.75-14.4-5.8 13.02-15.3 17.8-17.75 14.4zm-1.48-45.56c-.1-7.63 7.98-22.73 9.97-24.24 1.16 16.14-5.73 26.2-9.97 24.24zm-6.93-25.92c-2.32-5.28-1.1-18.41-.1-20.07 5.56 10.96 3.68 20.17.1 20.07zm-4.23-2.18c-5.27-4.68-10.64-19.76-10.41-22.1 11.75 9.26 14.39 20.36 10.41 22.1z'/%3e%3cpath d='M566.28 272.54c-.32.82 2.94-7.7 14.22-15.3-4.01 14.26-11.04 18.27-14.22 15.3zm-34.1 89.9c7-5.17 26.53-7.63 29.23-6.72-14.25 11.74-28.22 11.97-29.23 6.72zm14.33-20.84c-3.73.22-5.96-9.26-.48-20.92-.72 10.97-.42 19.97.48 20.92zm16.85-74.07c-2.7 3.58-12.9-1.2-19.12-14.61 9.33 8.57 17.64 14.74 19.12 14.61zm-1.7-8.06c-3.07 2.62-11.29-3.58-14.4-16.65 6.76 9.37 13.05 16.45 14.4 16.65zm4.89 15.03c-1.4 3.15-9.94 1.33-16.92-7.7 10.39 5.89 14.5 8.45 16.92 7.7zm-2.69 46.21c-1.25-3.76 7.36-8.32 20.24-5.56-10.88 1.95-19.57 4.48-20.24 5.56zm-.4-5.6c-3.14 1.47-8.45-5.88-7.89-17.88 3.36 9.74 6.83 17.38 7.89 17.88z'/%3e%3cpath d='M563.88 301.59c-4.23 2.2-11.3-7.36-10.47-23.52 4.4 12.85 9.05 22.9 10.47 23.52zm-52.69 75.07c2.02-4.15 13.15-1.38 21.98 10.89-11-6.75-20.49-11.3-21.98-10.89z'/%3e%3c/g%3e%3cg fill='%23406325'%3e%3cpath d='M521.55 365.83c4.54 1.6 10.44-9.42 7.54-25.88-2.81 13.95-6.18 25.06-7.54 25.88z'/%3e%3cpath d='M531.83 360.59c4.34-6.65 5.55-24.55 4.58-26.97-9.94 13.6-9.41 26.33-4.58 26.97zm-31.69 17.54c-2.12 4.08 6.7 11.44 21.79 11.31-11.95-4.88-21.24-9.86-21.79-11.31zm.16-8.05c3.79 3.34 13.8-4.95 17.4-22.08-8.12 12.42-15.71 21.8-17.4 22.08zm42.71-18.65c1.8 3.92 12.7.92 21.65-11.15-10.89 6.83-20.25 11.51-21.65 11.15zm25.75-53.33c3.3 2.15 10.34-5.3 11.56-18.8-5.21 10.4-10.26 18.4-11.56 18.8zm-11.69 38.11c.9 4.35 12.45 4.18 24.31-5.5-12.5 3.97-23 6.22-24.31 5.5zm10.36-24.64c2.45 3.4 11.87-1.33 17.66-14.35-8.6 8.37-16.28 14.44-17.66 14.35zm-1.51-45.56c4.24 2.02 11.06-7.95 9.9-24.1-4.08 13.14-8.46 23.42-9.9 24.1zm-6.96-25.87c3.54.1 5.41-9.03-.13-20 .95 10.5.9 19.08.13 20zm-4.23-2.24c3.97-1.74 1.33-12.71-10.42-21.97 6.47 11.02 10.85 20.57 10.42 21.97zm11.61 34.67c3.17 2.97 10.14-1.06 14.15-15.33-7.8 10.08-12.68 15.17-14.15 15.33zm-34.09 89.91c1 5.25 14.91 5 29.13-6.69-14.94 4.85-27.5 7.6-29.13 6.69z'/%3e%3cpath d='M539.14 354.75c3.27-4.93 4.27-18.27 3.56-20.08-7.48 10.08-7.16 19.57-3.56 20.08zm19.6-28.61c3.57-5.79 3.88-20.9 2.92-22.96-8.26 11.81-7.25 22.59-2.92 22.96z'/%3e%3c/g%3e%3cpath fill='%2367923d' d='M531.79 360.54c-4.83-.64-5.33-13.31 4.55-26.87-3.62 13.85-5.46 25.44-4.55 26.87zm35.16-68.33c-.94-7.76 3.98-20.14 6.63-22.52 2.58 14.38-2.66 23.95-6.63 22.52zm-27.84 62.49c-3.6-.5-3.9-9.95 3.54-20-2.78 10.3-4.21 18.93-3.54 20zm23.36-104.24c-2.17-5.88.03-20.04 1.24-21.77 5.28 12.25 2.63 22.11-1.24 21.77zm-58.08 120.15c2.47-8.1 16.2-21.08 18.8-21.91-4.33 17.42-15.06 25.52-18.8 21.91zm54.53-41.59c2.66-6.26 14.8-15.46 16.98-15.84-4.94 13.64-14.25 19.14-16.98 15.84zm-.12-3.03c-4.33-.37-5.33-11.04 2.93-22.85-2.66 11.86-3.79 21.68-2.93 22.85z'/%3e%3cpath fill='%23406325' d='M567 294.04c5.16 1.84 9.08-9.89 6.6-23.91-2.43 12.06-5.38 23.2-6.6 23.91z'/%3e%3cpath fill='%23406325' d='M567.77 293.64c.56-7.53-6.93-23.09-8.92-24.7-2.01 15.8 4.47 26.3 8.92 24.7zm-5.22-43.22c3.83.34 6.47-9.43 1.19-21.69.33 11.45-.29 20.75-1.19 21.69zM504.5 370.53c3.79 3.62 14.37-4.42 18.7-21.84-8.84 12.35-16.96 21.61-18.7 21.84zm54.64-41.49c2.74 3.3 11.93-2.16 16.87-15.83-8.13 9.1-15.47 15.8-16.87 15.83z'/%3e%3cpath fill='%2367923d' d='M567.66 293.53c-4.41 1.64-10.85-8.76-8.83-24.56 3.5 13.26 7.44 23.76 8.83 24.56z'/%3e%3c/g%3e%3cg fill='%23ba1f3e' stroke='%23511124' stroke-width='.22'%3e%3ccircle cx='564.63' cy='254.9' r='1.08'/%3e%3ccircle cx='568.41' cy='266.82' r='1.08'/%3e%3ccircle cx='569.76' cy='304.3' r='1.28'/%3e%3ccircle cx='564.65' cy='297.29' r='1.28'/%3e%3ccircle cx='549.91' cy='337.17' r='1.28'/%3e%3ccircle cx='556.2' cy='339.9' r='1.28'/%3e%3ccircle cx='513.8' cy='372.26' r='1.28'/%3e%3ccircle cx='506.8' cy='377.29' r='1.28'/%3e%3ccircle cx='557.05' cy='249.25' r='1.08'/%3e%3c/g%3e%3c/g%3e%3cg id='b' fill='%238c959d' stroke='%23485654' stroke-width='.11'%3e%3cpath d='M434.25 336.27c-.13 1.07.84 2.34 2.13 2.07.38-.08.62-.58.13-.49-.43.1-.88-.07-1.2-.37a1.68 1.68 0 0 1-.4-1.92l-.66.7v.01z'/%3e%3cpath stroke='none' d='M437.24 338.34c-1.02 1.17-2.57 1.68-3.43.83-.57-.56-.77-1.2-.47-1.9l-1.12 1.22c.05.1.72 1.31 1.71 1.76 1.22.55 2.97-.28 4.02-1.56.74-.91 1.56-2.43.97-3.61a3.98 3.98 0 0 0-1.97-1.7l-1.03 1.1c.51-.24 1.15-.13 1.7.31 1.27 1.04.53 2.5-.38 3.55z'/%3e%3cpath fill='%23485654' stroke='none' d='M437.24 338.34a4 4 0 0 1-1.16.96c-.45.23-.96.39-1.47.31-.26-.03-.51-.13-.72-.3-.2-.16-.37-.35-.5-.57a1.61 1.61 0 0 1-.25-.74c-.02-.26.04-.53.14-.77l.12.08-1.11 1.24.01-.1c.28.48.63.94 1.05 1.3a1.99 1.99 0 0 0 1.5.57c.53-.01 1.07-.2 1.56-.47a5.1 5.1 0 0 0 1.3-1.05c.37-.41.69-.88.93-1.38.24-.5.41-1.05.38-1.6a1.83 1.83 0 0 0-.23-.77c-.13-.24-.3-.46-.5-.66-.39-.4-.86-.72-1.37-.93l.1-.02-1.04 1.09-.09-.12c.24-.1.5-.14.76-.11.25.02.5.11.71.24.43.26.8.65.93 1.14.13.5 0 1.01-.21 1.45a5.1 5.1 0 0 1-.84 1.2v.01zm0 0c.31-.38.6-.78.8-1.23.19-.44.3-.94.16-1.4-.13-.46-.5-.83-.9-1.06-.4-.24-.92-.3-1.34-.1l-.09-.12 1.02-1.11.04-.04.05.02a4.17 4.17 0 0 1 1.98 1.66c.15.25.23.55.25.85.05.6-.13 1.17-.38 1.7-.25.52-.58 1-.96 1.44-.4.43-.85.8-1.36 1.08a3.7 3.7 0 0 1-1.67.5 2.2 2.2 0 0 1-1.62-.63 5 5 0 0 1-1.07-1.37l-.03-.05.04-.05 1.13-1.22.12.08c-.1.22-.15.46-.14.7.01.24.1.48.22.68.12.21.29.4.47.56.19.16.42.25.66.3.49.08 1-.06 1.43-.28.45-.22.85-.54 1.19-.91z'/%3e%3cpath fill='%236c301e' stroke='%23351710' stroke-linejoin='round' stroke-width='.22' d='m515.24 249.25-40.14 39.52c-3.05 3.03-37.96 36.37-41.1 39.38-1.1 1.32-4.23 4.86-4.56 5.35-2.13 2.31-4.44 5.33-7.2 8.03-.5.62-1.14.4-1.73.74a23.38 23.38 0 0 0-5.06 4.37l-12.2 13.5c-.8.86-1 1.39-.47 1.88l6.62 8.85c1.23 1.2 2.65 1.83 3.2.81 3.15-5.44 10.96-13.75 13.91-20.33 1.77-3.93 3.98-11.06 5.56-12.78 1.94-2.16 7.17-7.73 11.8-12.7l.94-1 .94-1.02c23.51-23.95 50.72-53.05 70.53-73.56-.78-.78-.29-.31-1.04-1.04z'/%3e%3cpath d='M431.89 328.11c-1.23.04-2.02-.7-2.85-1.4 1.17.35 2.35.8 3.45.34l-.6 1.06z'/%3e%3cpath fill='%23b2b6ba' stroke-width='.22' d='m557.05 220.1-31.8 26.22c-.31.37-.63.27-.93 0l-2.9-2.42.02-.1c0-.17-.04-.33-.09-.47l1.42-1.45c.18-.22.12-.3-.12-.55l-.59-.6c-.22-.17-.41-.03-.64.18L520 242.4c-.74.03-1.33.63-1.35 1.36-19.24 18.73-35.8 35.44-54.94 53.87l-22.57 21.55c-.81 1.05-4.3 2.91-6.6 4.41a5.63 5.63 0 0 0-1.82 1.55l-1.84 5.43c-.58 1.2-2.43 4-2.51 4.2 2.36 2.38 2.24 2.2 3.86 3.72 1.82-2.02 6.7-7.1 11.12-11.85.35-.38.38-.42.83-.97a13.32 13.32 0 0 0-2.6-2.74l-.62-.55c-.17-.16.24-.44.42-.64 26.47-25.58 54.96-53.7 78.28-76.6a1.41 1.41 0 0 0 1.02-.1l2.79 3.22c.65.65 1.2.63 1.73.4l31.86-28.55z'/%3e%3cpath fill='%23485654' stroke='none' d='M430.95 330.39c.2.03.4.05.6.03.2-.02.4-.07.58-.16l-.02.02a139.62 139.62 0 0 1 1.47-4.74l.01.02c-.2-.22-.43-.42-.73-.5.3.06.56.25.77.46l.01.02v.01l-.71 2.38-.75 2.37v.01h-.02c-.19.1-.4.15-.6.15-.2 0-.41-.03-.61-.07z'/%3e%3ccircle cx='438.18' cy='328.13' r='.62' fill='none' stroke-width='.16'/%3e%3ccircle cx='434.44' cy='331.88' r='.62' fill='none' stroke-width='.16'/%3e%3cpath fill='%23485654' stroke='none' d='M440.97 322.38a11.74 11.74 0 0 1-1.74-1.63 11.63 11.63 0 0 1 1.74 1.63z'/%3e%3cpath d='m502.17 259.06 3.49 3.41.64-.59-3.48-3.4-.65.58z'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='scale(-1 1) rotate(-2.84 -9.26 19640.24)'/%3e%3cg stroke='%2324420e' stroke-width='.16'%3e%3cpath fill='%2367923d' d='M433.91 365.36c-7.87-3.32-26.89-.67-29.22.93 16.29 8.01 29.54 4.58 29.22-.93zm89.02 3.32c7.87-3.32 26.89-.67 29.22.93-16.29 7.98-29.54 4.58-29.22-.93z'/%3e%3cpath fill='%23406325' d='M433.76 365.48c.32 5.5-12.79 8.89-29.07.9 15.29.94 27.79.38 29.07-.9zm89.32 3.29c-.32 5.5 12.79 8.89 29.07.9-15.29.94-27.79.41-29.07-.9z'/%3e%3c/g%3e%3cg id='c'%3e%3cpath fill='%23b2b6ba' stroke='%23485654' stroke-width='.22' d='M508.49 359.99c-20.73-30.12-52-54.61-76.1-68 3.55-.16 11.46 3.89 14.67 5.96 23.94 15.42 44.3 35.8 65.66 59.82a35.2 35.2 0 0 1-3.44 3.05l-.79-.83z'/%3e%3cpath fill='%238c959d' d='m510.55 359.75-1.45 1.4C486.09 331.51 454 303.2 432.43 292c30.08 13.86 55.4 41.77 78.03 67.65l.09.09z'/%3e%3cpath fill='%23485654' d='m510.56 359.75-1.45 1.4a302.96 302.96 0 0 0-16.87-19.73 336.02 336.02 0 0 0-18.37-18.34 284.92 284.92 0 0 0-19.8-16.76 195.86 195.86 0 0 0-10.55-7.56c-3.6-2.4-7.3-4.66-11.13-6.65l.1-.2c7.89 3.65 15.33 8.2 22.37 13.29a210.61 210.61 0 0 1 20.03 16.63 359.99 359.99 0 0 1 18.33 18.5c5.9 6.36 11.63 12.89 17.34 19.42za897.45 897.45 0 0 0-17.42-19.35c-5.92-6.35-12-12.56-18.35-18.47-6.36-5.9-13-11.51-20.04-16.59a134.67 134.67 0 0 0-22.36-13.23l.1-.2c3.84 2 7.54 4.28 11.14 6.68 3.6 2.4 7.11 4.95 10.55 7.58a284.86 284.86 0 0 1 19.8 16.8 336.06 336.06 0 0 1 18.34 18.37 302.66 302.66 0 0 1 16.8 19.8h-.01l1.45-1.39z'/%3e%3cg fill='%23fab81c' stroke='%236c301e' stroke-width='.11'%3e%3cpath stroke-width='.22' d='M517.5 355.07a18.32 18.32 0 0 0-5.26 2.23c-.23 1.4-1.95 2.95-3.58 3.3l-.6-.76a.13.13 0 0 0-.17-.04 6.9 6.9 0 0 0-.57.34c-.6-.1-1.34.2-1.66.97-.38.97.39 2.25 1.23 3.09.92.73 1.38 1.07 2.45.92 1.09-.23 1.68-1.22 1.93-1.53 3.72 4.5 6.52 6.93 11.23 10.64 2.1.02 3.22-1.3 2.52-2.8-.23-.5-.84-.84-1.33-.66.04-.15.02-.3 0-.45 2.46-2.26 3.5-5.08.91-9.87-2.22-4.03-4.71-5.4-7.09-5.38h-.01zm6.25 4.53c.43.74.69 1.38 1.02 2.05 1.48 3 .2 6.6-2.33 7.71-.13 0-.09-.02-.22.02.42-.69-.82-2.15-1.46-1.64.3-.76-.67-2.02-1.46-1.7.42-.7-.53-1.9-1.42-1.5.46-.77-.32-1.87-1.24-1.67.27-.82-.42-1.76-1.35-1.6.07-.72-.16-1.12-.51-1.45 1.11-.85 2.35-2.15 3.44-2.74 2.72-1.18 4.4 1.07 5.52 2.52z'/%3e%3cpath d='M524.89 362.77c-.52-.25-.76-.76-.59-1.1.17-.35.7-.44 1.22-.18.52.25.8.74.63 1.09-.17.34-.74.45-1.26.2v-.01z'/%3e%3cpath d='M524.59 361.75c-.52-.25-.76-.76-.59-1.1.17-.35.7-.44 1.22-.18.52.25.8.74.63 1.09-.17.34-.74.45-1.26.2v-.01z'/%3e%3cpath d='M523.97 360.62c-.52-.25-.76-.76-.59-1.1.17-.35.7-.44 1.22-.18.52.25.8.74.63 1.09-.17.34-.74.45-1.26.2v-.01z'/%3e%3cpath d='M523.19 359.6c-.52-.25-.76-.76-.59-1.1.17-.35.7-.44 1.22-.18.52.25.8.74.63 1.09-.17.34-.74.44-1.26.2v-.01z'/%3e%3cpath d='M522.16 358.61c-.52-.25-.76-.76-.59-1.1.03-.05.01-.14.06-.12.2.1.64.19.6-.14-.07-.1-.15-.22-.07-.14.14 0 .46.14.63.22.52.26.8.75.63 1.1-.17.33-.74.44-1.26.19v-.01z'/%3e%3c/g%3e%3cpath fill='%23fab81c' d='M511.27 363.6c.68-1.77 2.05-3.41 3.5-3.8m-3.27 4.05c1.26.26 3.3-1.24 3.8-2.59m-2.61 4.04c1.66.38 3.3-1.22 3.93-2.4m-2.44 3.98c1.96.06 3.16-1.33 3.74-2.39m-2.23 3.92c1.66.01 3.17-1.36 3.65-2.42m-2.19 3.82c1.8-.07 3.08-.9 3.62-2.07m-1.98 3.49c1.66.1 3-.9 3.44-1.86m-1.66 3.31c1.66.1 2.7-.93 3.14-1.9'/%3e%3cpath fill='%236c301e' d='M511.27 363.6a7.03 7.03 0 0 1 2.3-3.24c.36-.26.77-.47 1.2-.57-.42.14-.8.37-1.16.63-.35.27-.66.58-.95.92a9.24 9.24 0 0 0-1.39 2.26zm.23.25c.4.06.8-.04 1.18-.2a5.65 5.65 0 0 0 1.95-1.4c.27-.29.51-.62.68-.99-.13.4-.36.74-.62 1.06a5.26 5.26 0 0 1-1.98 1.42 2.1 2.1 0 0 1-1.21.11zm1.19 1.45c.4.07.82.04 1.2-.09.39-.12.75-.3 1.08-.54a6.24 6.24 0 0 0 1.65-1.77 5.2 5.2 0 0 1-1.6 1.86c-.33.23-.7.43-1.1.53-.4.11-.84.13-1.23.01zm1.49 1.58a3.83 3.83 0 0 0 2.18-.69c.32-.21.6-.48.86-.76.26-.3.5-.6.7-.94-.33.7-.85 1.34-1.5 1.79a3.37 3.37 0 0 1-2.24.6zm1.51 1.53a4.1 4.1 0 0 0 2.11-.77 5.16 5.16 0 0 0 1.54-1.65c-.14.36-.36.68-.61.97a4.25 4.25 0 0 1-1.9 1.29c-.37.12-.76.18-1.14.16zm1.46 1.4c.36-.04.73-.1 1.08-.19a4.63 4.63 0 0 0 1.89-1.01c.26-.26.48-.55.65-.87-.13.34-.34.65-.6.93a3.5 3.5 0 0 1-.88.66c-.66.34-1.4.5-2.14.48zm1.64 1.42a4.54 4.54 0 0 0 1.97-.48c.3-.15.58-.35.84-.58s.47-.5.63-.8c-.12.32-.33.61-.58.86a3.58 3.58 0 0 1-2.86 1zm1.78 1.45c.33 0 .65-.04.96-.12a3.3 3.3 0 0 0 1.62-.99c.22-.23.4-.5.56-.79a2.96 2.96 0 0 1-3.14 1.9z'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='scale(-1 1) rotate(-3.41 -13.8 16470.84)'/%3e%3cg stroke='%2324420e' stroke-width='.16'%3e%3cpath fill='%23406325' d='M409.24 240.02c7.21-2.37 18.73-15.45 19.48-17.92-15.6 4.16-22.76 14.35-19.48 17.92zm145.74 4.7c-1.7-7.04-13.28-19.01-15.57-19.91 2.77 15.16 11.92 22.76 15.57 19.91z'/%3e%3cpath fill='%2367923d' d='M409.24 240.02c-3.32-3.57 3.8-13.67 19.34-17.82-10.96 8.4-19.2 16.18-19.34 17.82zm145.74 4.7c-3.66 2.9-12.72-4.65-15.49-19.77 7.17 11.07 13.94 19.51 15.49 19.77z'/%3e%3c/g%3e%3cg stroke='%23999270' stroke-width='.16'%3e%3cpath fill='url(%23d)' d='M452.21 318.1s-6.16.66-7.88-7.83c-1.85-9.09 5.3-10.06 5.3-10.06s8.1-.78 13.15-.9l2.24 17.95-12.81.84z'/%3e%3cpath fill='url(%23e)' d='M453.02 315.36s-3.98.76-4.8-5.55c-.59-4.48 2.18-5.11 2.18-5.11l9.23 1.56.05 8.24-6.66.86z'/%3e%3cpath fill='url(%23f)' d='M450.4 304.7s5.9-.43 8.99-.83l1.28 5.71-7.1.45s-.49-5.16-3.17-5.33z'/%3e%3cpath fill='url(%23g)' d='M449.16 300.36s7.58-1.86 8.52 6.49c.24 2.18-.94 7.17-4.66 8.51l13.88-1.45-1.26-15.01-4.68.39s-9.92.34-11.8 1.07z'/%3e%3cpath fill='%23f9f0aa' d='M452.2 318.1c.05 0 51.9-3.5 57.22-3.27 15.74-8.64-.08-42.56-13.35-61.54 1.52-4.27-29.85-13.89-44.04-13.02-1.78.1-3.5.23-5.16.35-7.7.82-7.77 10.7-4.63 16.93 3.04 6.04 30.31 55.12 11.14 60.31l-1.18.24z'/%3e%3cpath fill='url(%23h)' d='M507.79 273.34a148.36 148.36 0 0 0-11.72-20.05c1.52-4.27-29.86-13.89-44.04-13.02-1.79.1-3.51.23-5.16.35-7.7.82-7.77 10.7-4.64 16.93.96 1.9 4.3 8.04 7.85 15.73'/%3e%3cpath fill='url(%23i)' d='M455.04 284.95c5.55 14.65 8.66 30.12-1.64 32.9l-1.18.24c.05 0 51.9-3.49 57.22-3.27 8.54-4.68 7.8-16.8 3.2-29.94'/%3e%3cpath fill='url(%23j)' d='M447.4 243.49c-3.7 0-4.66 3.56-4.6 5.82.13 5.9 4.6 6.19 4.6 6.19l5.96-.33 2.86-12.17-8.82.49z'/%3e%3cpath fill='url(%23k)' d='m447.4 243.53 8.82-.49.91 9.09-7.7.34s2.5-7.28-2.03-8.94z'/%3e%3cpath fill='url(%23l)' d='M496.12 253.29c6.69-1.07 6.6-10.07 2.03-13.67-15.5-.57-35.9-.15-50.63.96 1.67-.05 6.33.37 6.85 6.5a8.2 8.2 0 0 1-3.06 7 6.93 6.93 0 0 1-3.9 1.45c.24.1 2.16.01 3.6-.08.73-.05 2.54-.27 3.05-.33 21.01-2.76 41.99-1.83 41.99-1.83h.07z'/%3e%3cpath fill='%23b07e09' stroke='none' d='M458.47 267.42c-.14-.33-.32-.75-.73-.8-.25 0-.65-.06-.57-.4.24-.11.54-.04.8-.06.56 0 1.11-.12 1.67-.15.34.1.26.54-.1.46-.41.1-.18.57-.08.81.44 1.04.87 2.08 1.33 3.1.12.31.38.58.72.61.36.04.75.05 1.09-.11.3-.2.24-.63.2-.94-.13-.36.54-.28.5.04.12.43.27.86.44 1.27-.02.2-.28.15-.42.17-1 .08-1.99.13-2.98.22-.32-.01-.8.28-.99-.1-.12-.38.51-.16.6-.45 0-.33-.2-.62-.31-.92l-1.17-2.75zm4.83-.34c-.14-.32-.3-.72-.69-.8-.24-.02-.65-.01-.61-.37.15-.16.45-.06.67-.1.59.03 1.17-.08 1.76-.14.29-.02.4.52.02.45-.35.01-.38.4-.23.65.47 1.14.96 2.28 1.44 3.41.1.25.24.55.54.59.25.05.65-.03.7.32-.04.26-.43.11-.63.16a6.58 6.58 0 0 0-1.55.12c-.23.06-.55.02-.56-.27.05-.28.58-.07.6-.4-.03-.33-.2-.62-.32-.93l-1.14-2.69zm4.46.71c.09.23.4.06.59.08.26-.03.54-.22.51-.51-.04-.45-.26-.91-.63-1.19-.34-.24-.78-.21-1.17-.16-.02.16.1.3.15.45l.55 1.33zm.67 1.6c.16.35.28.74.56 1.01.25.17.57.1.85.07.3-.02.48-.33.38-.61-.14-.64-.55-1.3-1.24-1.44-.3-.05-.61-.06-.91 0-.02.15.09.3.13.43l.23.54zm-2.04-2.38c-.15-.34-.3-.76-.68-.92-.25-.08-.65.03-.7-.32.06-.3.56-.1.8-.16.86-.03 1.74-.27 2.6 0 .73.17 1.39.8 1.44 1.58.03.38-.26.68-.58.84-.04-.14.37.06.5.08.6.19 1.13.58 1.39 1.14.2.4.35.93.04 1.32-.36.4-.94.41-1.44.43-.75.02-1.5.03-2.25.18-.26.04-.45-.48-.08-.45.37-.02.4-.42.24-.67l-1.28-3.05zm7.42-1.9c.33-.05.36.32.46.53.1.29.27.54.35.83-.28.28-.5-.14-.63-.36-.14-.24-.38-.47-.69-.45-.4 0-.81.02-1.22.07-.14.16.07.4.12.58.19.45.36.9.56 1.34.27-.02.62.02.81-.2.08-.24-.27-.75.21-.65.3.17.26.6.42.89.12.38.38.72.49 1.11-.26.29-.53-.13-.62-.36-.19-.35-.63-.3-.96-.3-.24-.05-.08.17-.04.28.21.5.38 1.01.66 1.48.2.34.65.3 1 .28.32-.02.72-.03.92-.34.21-.25-.28-.75.13-.83.35-.03.34.38.43.6.07.29.18.56.28.83-.02.2-.28.14-.42.16-1.02.07-2.04.11-3.06.2-.3 0-.8.23-.9-.2.02-.3.64-.14.55-.55-.07-.35-.25-.66-.37-1-.38-.89-.73-1.8-1.12-2.68-.14-.3-.37-.62-.73-.63-.24.04-.6-.13-.47-.41.35-.07.72-.02 1.07-.06l2.77-.16zm2.31 1.32c-.15-.35-.3-.77-.68-.93-.26-.08-.72.01-.7-.4.25-.18.66-.03.97-.08.8-.01 1.62-.24 2.41 0 .82.23 1.52.97 1.57 1.84.03.41-.3.75-.68.86-.3.02.23.1.3.2.64.3 1.08.87 1.41 1.47.08.23.52.7.59.25-.03-.5.64-.08.49.26 0 .36-.35.59-.68.58-.47.04-.9-.23-1.14-.62-.42-.55-.71-1.22-1.27-1.66-.23-.17-.56-.27-.83-.15-.05.14.07.28.1.41.19.41.31.85.55 1.22.2.31.6.36.94.36.36.09.25.58-.13.43-.58 0-1.17-.04-1.75.08-.27.13-.87.01-.65-.37.28-.02.67-.17.48-.53-.33-.87-.7-1.73-1.05-2.6l-.25-.62zm1.4.9c.14.32.6.14.87.1.35-.07.34-.5.23-.77-.16-.47-.37-1.03-.9-1.2-.25-.03-.84-.2-.88.16.2.53.43 1.05.63 1.58l.05.12zm7.22 1.71c.1.26.21.61.54.66.25.05.66-.03.71.33-.04.26-.43.1-.63.14a7.1 7.1 0 0 0-1.6.08c-.24.07-.56-.03-.53-.32.13-.2.65-.03.62-.4-.08-.4-.27-.77-.41-1.15l-1.15-2.88c-.1-.31-.45-.3-.7-.28-.28 0-.69.06-.69.41-.08.23.22.62-.04.74-.3.06-.36-.28-.43-.5-.1-.31-.26-.6-.38-.92.03-.21.32-.17.49-.2l4.13-.16c.3-.05.5.19.52.47.1.34.27.66.41.98-.11.33-.5.04-.55-.2-.2-.35-.51-.7-.94-.7-.26 0-.64-.1-.82.14.01.24.15.45.22.67l1.23 3.09zm3.73-.91c-.2 0-.1.24-.12.37.01.28-.02.57.03.85.13.3.53.23.79.31.23.13.17.5-.14.4-.42-.03-.85-.08-1.27.02-.25.14-.71-.12-.49-.39.2-.03.45-.1.5-.33.07-.42.03-.84.04-1.26l.02-3.71c.12-.28.52-.05.6.16 1.2 1.52 2.38 3.05 3.6 4.54.2.23.46.4.77.42.26 0 .4.53.03.42-.52-.03-1.03-.06-1.54.03-.23 0-.5.1-.7-.03-.24-.17-.07-.43.2-.4.35-.1 0-.48-.12-.65-.19-.26-.38-.52-.59-.75-.17-.09-.37-.03-.55-.04l-1.06.04zm1.17-.51c.19.01-.05-.16-.08-.24l-1.28-1.66c.09-.01.02.18.04.26v1.68l1.32-.04zm3.06-1.85c-.15-.4-.35-.89-.82-.98-.24.04-.7-.18-.45-.44.55 0 1.1.03 1.65-.02.7-.06 1.42-.04 2.08.2a4.35 4.35 0 0 1 2.92 3.33c.1.6-.08 1.3-.63 1.64-.73.47-1.64.38-2.47.33-.47-.02-.94.04-1.4.09-.3-.04-.34-.51.02-.46.37 0 .37-.42.23-.66l-1.13-3.03zm1.97 2.5c.15.33.24.75.56.97.3.14.66.12.98.08.44-.06.72-.5.72-.91a4.27 4.27 0 0 0-.63-2.13 2.65 2.65 0 0 0-1.84-1.37c-.33-.05-.67-.1-1-.05-.07.13.06.27.1.4l1.11 3zm-21.11 12.41c.12.35.44.6.8.63.26.05.7-.01.72.36-.14.23-.53.07-.77.12-.52 0-1.04 0-1.55.1-.28 0-.57.12-.84.04-.24-.12-.2-.47.1-.43.26-.05.61-.13.63-.44-.02-.29-.18-.54-.28-.8l-1.15-2.75c-.09-.33-.45-.34-.71-.29-.25.05-.62.13-.68-.22.03-.29.5-.24.7-.39.31-.12.62-.25.94-.35.22-.05.32.15.38.32l1.71 4.1zm.75-4.51c.68-.03 1.37.08 2.05 0 .3-.03.1-.5.38-.47.37.02.31.48.33.74a.52.52 0 0 1-.56.58c-.54.03-1.07-.05-1.6-.02.12.42.29.81.44 1.21.03-.13.46-.15.64-.18a2.78 2.78 0 0 1 2.61 1.54c.22.48.33 1.1-.02 1.55-.4.45-1.03.54-1.6.55-.49 0-1.06-.11-1.35-.55-.17-.22-.14-.68.22-.64.3 0 .66.26.6.6.17.22.53.14.78.13.3 0 .59-.24.57-.55 0-.49-.18-.97-.45-1.36-.3-.43-.78-.71-1.3-.7-.3-.05-.55.15-.83.15-.29-.04-.34-.37-.44-.58-.23-.6-.46-1.2-.65-1.82-.02-.1.08-.2.18-.18zm6.85 1.02c-.16-.4-.37-.88-.84-.97-.24.06-.7-.17-.46-.43.55-.02 1.11 0 1.67-.07.7-.08 1.43-.07 2.1.18 1.5.5 2.71 1.82 2.94 3.39.09.58-.11 1.24-.63 1.56-.72.47-1.61.4-2.43.38-.45 0-.9.07-1.34.13-.3-.04-.36-.5 0-.46.38-.03.35-.45.2-.69l-1.21-3.02zm2.03 2.46c.16.34.26.75.59.97.3.14.65.1.97.05.44-.07.69-.52.68-.94 0-.76-.32-1.48-.7-2.13a2.64 2.64 0 0 0-1.86-1.33 3 3 0 0 0-.98-.02c-.07.13.06.27.1.4l1.2 3zm6.44-4.26c.31-.05.35.3.44.5.1.29.24.55.34.84-.19.3-.5-.06-.59-.29-.14-.24-.35-.52-.67-.5-.41-.03-.82 0-1.23.03-.23.1.01.39.05.56.18.45.35.92.54 1.36.27 0 .58.01.8-.15.18-.21-.27-.74.21-.68.33.12.28.57.42.84.12.4.35.74.49 1.14-.18.33-.54-.06-.6-.3-.14-.33-.51-.37-.82-.36-.2-.03-.37.01-.23.22.22.51.38 1.05.66 1.54.2.35.65.3 1 .3.32-.01.73 0 .93-.32.2-.24-.2-.66.08-.8.34-.1.42.27.47.51.08.31.18.6.29.9-.03.2-.28.14-.43.16-1.03.04-2.06.06-3.09.12-.28-.01-.69.21-.87-.1-.18-.4.5-.19.53-.53.03-.3-.15-.58-.25-.86-.38-.96-.75-1.94-1.14-2.9-.14-.31-.36-.66-.74-.68-.24.04-.6-.13-.46-.4.36-.07.73-.01 1.1-.04l2.77-.11zm-27.28 14.28c.15.49.67.69 1.11.82.77.26 1.6.52 2.15 1.16.3.37.52.85.5 1.34-.04.5-.47.87-.93.99-.57.18-1.2.13-1.73-.1-.27-.11-.17.47-.5.27-.24-.18-.16-.56-.3-.81-.1-.33-.24-.65-.38-.97.01-.32.48-.15.5.1.32.6.92 1.12 1.63 1.13.36 0 .8-.18.83-.59.01-.53-.41-.95-.86-1.18-.64-.33-1.38-.44-2-.81a1.94 1.94 0 0 1-.94-1.61c.01-.44.37-.78.77-.9.5-.17 1.05-.2 1.56-.06.24.13.34-.27.6-.07.11.2.08.46.2.67.07.29.26.54.33.82-.16.25-.47.02-.52-.2-.22-.36-.52-.77-.98-.8-.35-.03-.79-.03-1.01.29-.1.15-.1.35-.03.51zm6.69-1.65c.33-.06.34.31.42.53.08.27.2.53.29.8-.14.28-.5.02-.54-.21-.14-.26-.34-.58-.67-.56-.41 0-.82.03-1.23.08-.23.1 0 .39.03.57l.46 1.36c.27-.02.58-.01.8-.18.2-.2-.19-.6.14-.7.38-.05.35.44.44.68.1.45.33.85.46 1.29-.14.32-.53.01-.55-.25-.1-.33-.48-.4-.79-.37-.17 0-.42 0-.27.22.18.5.32 1.02.55 1.5.12.3.45.35.73.33.39-.03.84.01 1.15-.28.24-.24.04-.59.1-.85.24-.2.52.06.5.34.06.34.15.68.26 1.02-.04.2-.3.14-.44.17-1.02.08-2.04.13-3.06.23-.28-.02-.68.23-.85-.1-.16-.37.45-.2.53-.5.09-.29-.1-.57-.17-.85-.33-.98-.65-1.96-1-2.94-.12-.3-.33-.66-.7-.66-.24.06-.6-.13-.43-.4.35-.07.71-.03 1.07-.07l2.77-.2zm4.18 4.14c.1.3.27.64.61.7.25.09.67-.07.73.29 0 .32-.49.15-.7.2-.52-.03-1.03 0-1.53.1-.22.04-.55.11-.6-.18-.06-.34.45-.15.56-.4.08-.26-.06-.52-.13-.77-.34-1-.66-2.01-1.01-3.01-.11-.3-.27-.68-.63-.71-.23-.01-.63-.03-.56-.37.18-.16.49-.05.71-.08.74.01 1.45-.2 2.19-.15.75.03 1.48.51 1.73 1.23.17.4.22.92-.08 1.28-.39.45-1.02.55-1.58.62-.21-.03-.04.2-.03.3l.32.95zm-.57-1.72c.2.03.46-.03.67-.08.32-.07.48-.4.4-.7a2.24 2.24 0 0 0-.54-1.17c-.3-.26-.75-.26-1.12-.17-.13.12 0 .32.04.47l.55 1.65zm6.15 1.43c.09.25.17.61.5.65.24.06.65-.03.68.32-.06.27-.44.12-.64.16a7.09 7.09 0 0 0-1.6.1c-.23.09-.55-.01-.5-.3.14-.22.65-.05.64-.42-.05-.39-.21-.75-.33-1.13l-.95-2.9c-.07-.31-.43-.3-.68-.27-.25.02-.62.05-.69.35-.08.25.04.53-.01.78-.24.16-.47-.1-.46-.33-.08-.35-.2-.68-.34-1-.01-.24.3-.22.47-.24l4.15-.25c.3-.05.49.19.48.47.08.34.22.66.34.98-.06.28-.48.13-.5-.12-.17-.36-.44-.74-.87-.76-.28 0-.63-.06-.86.12-.05.2.08.4.13.6l1.04 3.19zm2.1-3.29c-.1-.3-.22-.7-.57-.79-.24-.06-.65.01-.63-.35.1-.22.42-.09.61-.12.6.02 1.2-.06 1.79-.12.26-.12.48.42.15.42-.25 0-.55.19-.44.47.13.53.32 1.05.48 1.57.24.73.47 1.47.72 2.2.07.23.25.43.5.44.24 0 .66.04.59.38-.18.16-.48.06-.71.08-.54-.04-1.07.05-1.6.11-.24.1-.54-.13-.4-.37.2-.1.65-.05.62-.39-.08-.4-.24-.8-.36-1.2l-.75-2.33zm5.76-1.6c.32-.06.33.3.4.52.08.27.2.54.28.81-.14.29-.5.02-.53-.22-.13-.26-.33-.57-.67-.56-.4-.01-.82.02-1.23.05-.23.1-.01.4.02.57.14.45.28.91.44 1.36.27-.01.58 0 .8-.16.2-.2-.18-.61.16-.7.37-.03.34.45.42.7.09.45.32.85.44 1.29-.11.29-.52.04-.52-.22-.1-.32-.43-.45-.74-.42-.15.02-.5-.07-.36.17.17.52.3 1.05.53 1.55.12.28.45.35.73.33.4-.02.85.03 1.16-.26.25-.22.05-.58.11-.84.26-.2.53.07.5.35.06.34.15.68.25 1.02-.05.2-.28.14-.43.16-1.03.05-2.07.1-3.1.17-.27-.02-.64.2-.83-.07-.22-.39.38-.25.5-.48.14-.27-.04-.55-.1-.81l-.96-3c-.12-.31-.32-.7-.7-.7-.25.05-.6-.15-.43-.41.34-.07.7-.02 1.05-.05l2.81-.15zm2 .96c-.07-.36-.34-.68-.73-.62-.38.1-.5-.57-.04-.43.51 0 1.03-.08 1.53.03.25.27.44.58.66.86l2.17 2.9c-.15.04-.03-.18-.05-.3l.36-3.54c.27-.22.73-.13 1.07-.2.29-.04.93-.13.75.35-.34.06-.77.22-.54.65.36 1.2.74 2.39 1.12 3.58.07.41.49.54.86.52.31.02.33.57-.05.43-.6 0-1.2-.04-1.78.07-.27.09-.82.06-.64-.36.3-.05.8-.14.58-.57-.31-1.06-.65-2.11-.98-3.17.07.1-.01.25 0 .38-.1.99-.23 1.97-.3 2.97-.04.26.05.57-.07.8-.24.1-.39-.12-.5-.28l-2.86-3.7c.1-.04.09.2.14.3.3.95.59 1.92.91 2.87.1.39.5.5.85.5.38.2.1.55-.23.41-.5-.07-1 .03-1.5.08-.3 0-.32-.5.03-.44.47 0 .33-.53.22-.8l-1.02-3.28.04-.01zm8.74.85c.06.22.36.07.53.1.28-.02.62-.18.63-.5.01-.44-.16-.9-.5-1.19-.33-.25-.77-.23-1.16-.2-.04.15.06.31.1.46l.4 1.33zm.49 1.6c.12.35.19.74.45 1.02.24.18.56.1.84.09.26-.02.49-.23.46-.5-.03-.6-.31-1.26-.9-1.5a2.4 2.4 0 0 0-1.07-.09c-.12.1.03.3.05.43l.17.55zm-1.78-2.4c-.11-.35-.22-.77-.58-.94-.23-.09-.64.02-.66-.34.08-.28.54-.07.77-.13.89 0 1.8-.23 2.66.06.7.18 1.28.82 1.28 1.56 0 .4-.33.71-.69.86-.02-.13.36.07.5.1.53.19 1.02.55 1.23 1.1.17.4.28.94-.04 1.32-.36.4-.95.43-1.45.44-.8 0-1.59-.01-2.37.12-.29.03-.4-.5-.04-.45.36 0 .46-.38.32-.66l-.93-3.04zm5.01-.18c-.11-.35-.22-.77-.58-.94-.24-.09-.69.02-.66-.37.19-.25.65-.04.95-.1.68 0 1.36-.13 2.04-.05.79.1 1.54.65 1.74 1.45.14.42.05.95-.36 1.19-.09.1-.52.2-.45.19.6.24 1.12.69 1.41 1.27.16.26.25.58.47.8.27.2.3-.17.34-.33.35-.18.53.32.39.58-.15.42-.68.5-1.06.4-.34-.07-.6-.34-.76-.64-.34-.54-.55-1.17-1.03-1.61-.22-.2-.56-.31-.85-.2-.07.14.04.29.06.43.13.4.21.8.39 1.17.16.33.54.41.87.41.32 0 .35.56-.03.43-.6 0-1.22-.07-1.83.03-.22 0-.53.14-.67-.1-.22-.42.41-.22.55-.46.1-.28-.06-.56-.12-.84l-.81-2.71zm1.31.92c.1.32.56.15.8.14.3-.03.47-.32.4-.6-.07-.45-.19-.94-.54-1.25-.3-.23-.72-.23-1.08-.16-.16.12-.01.34.02.5l.4 1.37zm6.89-2.54c.31-.05.33.3.38.51.08.28.2.55.26.83-.13.26-.49.03-.51-.2-.13-.26-.3-.6-.63-.6a9.5 9.5 0 0 0-1.28 0c-.24.08-.03.38-.01.56.13.45.25.91.4 1.36.25 0 .53 0 .77-.1.29-.16-.1-.6.2-.7.36-.09.36.39.42.63.06.47.3.9.4 1.35-.12.28-.52.02-.52-.23-.08-.3-.37-.46-.66-.44-.15.02-.56-.12-.44.13.16.53.27 1.07.49 1.57.1.3.44.36.72.36.4-.01.85.06 1.18-.22.26-.22.07-.58.14-.84.26-.18.53.1.49.37.05.34.12.68.21 1.02-.05.2-.3.12-.45.14-1.04.02-2.07.03-3.11.07-.27-.03-.6.15-.82-.06-.26-.38.3-.3.47-.47.2-.22.04-.5-.02-.75-.3-1.03-.58-2.06-.89-3.08-.1-.3-.27-.68-.63-.72-.24.01-.61-.1-.49-.4.3-.1.66 0 .98-.04l2.95-.05zm-32.82 13.13c-.1-.37-.22-.85-.64-.95-.24 0-.65-.06-.5-.4.3-.12.67-.02 1-.07.82-.04 1.65-.24 2.46-.02a3.54 3.54 0 0 1 2.59 2.36c.22.73.26 1.6-.23 2.24-.52.67-1.42.85-2.22.86-.61 0-1.23 0-1.84.12-.24.14-.63-.1-.42-.36.25-.07.67-.15.59-.52-.1-.51-.25-1.01-.36-1.52l-.43-1.74zm1.64 2.44c.1.32.14.7.4.94.28.17.62.1.92.08.47-.07.82-.48.9-.94a3.91 3.91 0 0 0-.39-2.22c-.26-.6-.8-1.08-1.44-1.22a2.98 2.98 0 0 0-1.16-.04c-.08.12.02.27.04.4l.73 3zm7.06-4.43c.32-.06.31.3.36.51.06.28.16.54.22.82-.13.26-.5.06-.5-.19-.12-.25-.27-.58-.6-.58-.42-.02-.85.02-1.27.06-.24.08-.05.38-.04.57.12.45.21.9.34 1.35.27-.01.58 0 .82-.17.21-.19-.13-.61.2-.69.38-.04.3.45.37.69.05.44.25.85.34 1.29-.12.28-.53.05-.5-.21-.08-.33-.41-.46-.71-.42-.15.02-.5-.07-.37.17.13.52.22 1.05.4 1.55.1.3.44.35.7.33.42-.02.9.02 1.22-.3.25-.23.02-.61.17-.84.3-.17.49.14.45.4.03.34.09.66.16.99-.06.2-.3.14-.47.16-1.02.07-2.05.12-3.07.2-.26-.01-.56.15-.78.01-.26-.27.1-.4.32-.44.3-.1.26-.44.19-.68-.27-1.08-.51-2.16-.79-3.24-.08-.3-.23-.67-.6-.7-.23.03-.6-.08-.46-.39.3-.12.65-.03.97-.07l2.93-.18zm6.49 4.1c.04.3.28.57.6.62.23.1.6-.04.73.24.1.35-.39.24-.6.25-.56 0-1.14-.02-1.7.07-.3.02-.58.1-.87.07-.27-.12-.15-.5.15-.45.27-.06.63-.13.7-.44.04-.27-.07-.53-.12-.79l-.64-2.76c-.03-.33-.39-.34-.64-.3-.22.01-.58.17-.66-.16-.03-.34.47-.27.67-.4.37-.13.74-.28 1.11-.38.21-.05.3.15.32.32l.95 4.11zm3.69-3.32c-.07-.36-.28-.79-.69-.84-.3-.05-.67.03-.78.34-.1.38.04.81.37 1.03.28.2.6.3.9.45.06-.12.24-.35.23-.56.02-.14 0-.29-.03-.42zm.84 2.9c-.1-.5-.57-.78-1-.96-.18-.03-.44-.27-.56-.17-.3.27-.46.71-.32 1.1.12.49.48.97 1 1 .35.05.77-.1.87-.47a.96.96 0 0 0 0-.5zm.89-.22a1.2 1.2 0 0 1-.47 1.3 2.4 2.4 0 0 1-2.02.24 1.67 1.67 0 0 1-1.19-1.28c-.12-.49.08-1.04.52-1.31.1-.1.49-.14.17-.22-.5-.24-.99-.64-1.09-1.22-.12-.49.1-1.03.55-1.27.86-.47 2.09-.2 2.59.67.21.37.25.86 0 1.22-.15.2-.33.4-.57.45.49.1.93.4 1.22.79.14.19.24.4.29.63zm3.26.56c.24 0 .5-.14.54-.4.09-.19-.08-.6.26-.58.3.02.27.37.3.6.03.4 0 .87-.34 1.13-.25.16-.56.1-.84.1-.56-.02-1.12-.14-1.68-.07-.24.02-.5.28-.72.1-.19-.23-.07-.52 0-.77.2-.61.62-1.12 1.1-1.54.33-.3.7-.65.76-1.13.04-.41-.08-.84-.3-1.19-.28-.45-.94-.6-1.4-.32-.22.15-.4.5-.22.75.21.16.6.01.7.35.13.23 0 .6-.3.6-.44.06-.84-.28-.95-.7a1.2 1.2 0 0 1 .5-1.4c.5-.3 1.13-.3 1.68-.17.57.14 1.04.58 1.22 1.14.15.43.16.93-.08 1.34-.38.72-1.15 1.07-1.66 1.67-.14.16-.25.38-.19.59.08-.2.4-.13.58-.17.35-.01.7.08 1.04.07zm3.94-.42c.04.31.27.58.58.63.23.1.57-.01.72.23.14.34-.33.28-.54.27-.59-.02-1.18-.05-1.77.02-.29.02-.58.09-.86.05-.28-.13-.13-.5.16-.44.27-.05.63-.11.72-.42.03-.27-.07-.53-.11-.79l-.58-2.77c-.02-.28-.32-.34-.55-.3-.24-.03-.56.16-.71-.1-.18-.35.34-.35.55-.44.4-.12.8-.28 1.22-.38.21-.05.3.15.31.32l.86 4.12z'/%3e%3c/g%3e%3cg fill='%23448127' stroke='%2334541f' stroke-width='.22'%3e%3cpath fill='url(%23m)' stroke='%234c0505' d='m475.8 219.41-3.77 4.48c-1.2 5.24 1.78 9.19 7.65 12.62 4.75 2.95 13.55 3.69 16.33 1.3l-13.72-13.06-6.49-5.34z'/%3e%3cpath d='M503.58 354.27c-.67-.81-1.35-1.62-2.04-2.42-8.55 11.3-19.24 21.42-32.61 28.57 15.07-4.27 24.94-15.26 34.65-26.15zm-15.44 35.71c5.32-10.77 11.73-21.54 18.2-32.32-.7-.88-1.42-1.76-2.14-2.63-7.35 12.18-15.98 26.68-16.06 34.95zm41.73-114.5c-.98-4.25-2.27-8.84-4.3-13.05-2.67-5.44-6.63-10.84-11.84-16.8-9.38-10.18-18.77-20-31.93-27.26l.07-.14.08.05h.16l-.16-.2h.47l-.25-.26h.43l-.35-.4h.46l-.32-.33h.49l-.28-.36.4.03-.37-.39.55-.1-.45-.28.48-.1-.4-.27.59-.19-.52-.3.65-.3-.63-.45.67-.23-.73-.3.62-.31-.73-.13.5-.57-.7.04.31-.6-.67.05-.04-.05.37-.45-.68.12.3-.61-.65.32.18-.7-.62.43.1-.72-.59.5.06-.7-.5.54.04-.72-.5.6-.06-.7-.4.55-.2-.67-.34.67-.17-.71-.32.71-.15-.71-.27.71-.2-.67-.22.67-.16-.6-.24.72-.23-.67-.24.77-.29-.69-.13.82-.35-.67-.04.8-.38-.6-.03.78-.4-.57.03.7-.44-.37.22.74-.53-.3.2.65-.43-.24.15.63-.4-.13.21.47-.03.07-.3-.06.17.36a9.03 9.03 0 0 0-.35 3.52c.02.23.6.46.69.6.28.44.23.67.23.67-1.6 2.58-3.02 4.57-3.18 7.53 1.28-1.62 2.6-3.6 4.46-3.6-.92 1.54-1.35 6.17-.32 6.88l.77-1.36c.03 1.08.18 1.8.39 2.33.32-.65.64-1.28.96-1.75.07 1.51.27 2.72.7 3.32.43-.74 1.01-1.2 1.62-1.57-.2.86-.52 1.67-.39 2.7.65-1.1 1.3-1.75 1.94-2.51-.38 1.58-.04 2.77.41 4.52.4-2.08.56-2.3 1.52-3.17.1 1.9-.26 3.63.14 4.7.88-1.68 1.46-1.44 1.98-2.53-.1 1.58-.41 3.3-.01 4.7a4.48 4.48 0 0 1 1.94-2.67c.06 2.2.57 1.84-.8 3.7.58.27 2.54-.37 3.6-.83-.5 1.18-.35 2.1-.87 2.94 1.08-.54 2-1.42 2.9-2.32-.42 1.35-1.52 2.7-.97 4.05.25-1.26 1.28-2.3 2.24-2.49-.15.7-.25 2.17-1.27 2.88 2.44.25 3.4-1.4 4.64-2.7-.16 1.36-.12 2.44 1.55 4.35-.34-2.43.24-1.93 1.34-3.39.54 2.15 1.15 4.43 3.39 6.02-.93-2.27-1.1-3.44-.58-4.87.29 1.48 1.69 3.25 2.02 4.65.2-1.55.44-3.05.96-4.06.65 1.76 1.2 3.57 1.36 5.6.48-1 .88-2.03 1.16-3.08 19.73 20.62 24.13 46.84 2.5 74.54 7.78-5.25 9.78-13.57 14.1-20.67-4.21 9.3-6.09 19.74-13.51 27.43 7.19-6.2 8.71-11.89 13.03-17.87-4.6 12.5-10.98 26.2-19.82 38.75 1.57 1.7 3.14 3.44 4.72 5.18l4.1-6.84c9.37-15.44 24.65-37.5 16.91-71.15z'/%3e%3c/g%3e%3cpath fill='%23eac102' stroke='%23a08307' stroke-width='.22' d='M473.16 215.29c-1 .23-1.4.64-2.11 1.44.92.2 1.7.25 2.52.27.26-.03.34-.35.29-.59l-.13-.95c-.02-.22-.6-.2-.87-.09l.3-.08z'/%3e%3cpath fill='%23a08307' d='M471.04 216.73a9.89 9.89 0 0 1 2.13-.49 9.82 9.82 0 0 1-2.13.49z'/%3e%3cellipse cx='477.68' cy='215.42' stroke='%23000' stroke-width='.1' rx='.78' ry='.81'/%3e%3cellipse cx='477.86' cy='215.26' fill='url(%23n)' rx='.34' ry='.35'/%3e%3cg fill='%2334541f'%3e%3cpath d='M488.18 389.69a83.38 83.38 0 0 1 3.31-8.79c1.26-2.86 2.66-5.67 4.14-8.43a199.58 199.58 0 0 1 7.11-12.16l2.51-3.97-2.42 4.03-2.4 4.03c-1.58 2.7-3.14 5.41-4.61 8.17a133.67 133.67 0 0 0-4.18 8.4 98.1 98.1 0 0 0-3.46 8.72zm-18.84-9.46a75.8 75.8 0 0 0 26.08-19.07 153.49 153.49 0 0 0 6.95-8.34 111.9 111.9 0 0 1-6.83 8.45 81.9 81.9 0 0 1-7.74 7.63 69.95 69.95 0 0 1-18.46 11.33zm37.28-29.34a136.2 136.2 0 0 0 4.3-6.66c1.37-2.26 2.69-4.55 3.96-6.86a331.1 331.1 0 0 0 3.75-6.99l3.68-7.03-1.75 3.57-1.78 3.54c-1.2 2.35-2.44 4.7-3.71 7.01-1.29 2.31-2.6 4.6-4 6.85a93.84 93.84 0 0 1-4.45 6.57zm5.89-25.11a60.2 60.2 0 0 0 8.5-13.4 72.56 72.56 0 0 0 4.98-15.06l.41-1.95a61.14 61.14 0 0 0 .7-5.91c.17-2.65.17-5.3-.04-7.95a53.36 53.36 0 0 0-3.64-15.42 50.47 50.47 0 0 1 3.79 15.41 54.3 54.3 0 0 1-.32 11.94c-.08.66-.17 1.3-.28 1.97l-.41 1.95a72.68 72.68 0 0 1-5.06 15.09 58.22 58.22 0 0 1-8.63 13.33z'/%3e%3cpath d='M510.87 320.07a35.91 35.91 0 0 0 4.9-5.85 52.06 52.06 0 0 0 3.8-6.62c1.1-2.3 2.1-4.65 3.02-7.02.46-1.18.92-2.38 1.36-3.57l.33-.9.3-.9c.18-.6.35-1.22.58-1.83v.02c.5-2.53.77-5.1.8-7.67.03-2.58-.17-5.16-.57-7.7-.4-2.55-1-5.06-1.73-7.53-.73-2.48-1.6-4.91-2.56-7.3 1 2.38 1.9 4.8 2.66 7.27a57.63 57.63 0 0 1 1.77 7.54c.42 2.55.63 5.13.61 7.72a41.44 41.44 0 0 1-.78 7.71v.02c-.22.59-.4 1.2-.58 1.81l-.3.91-.34.9c-.45 1.2-.91 2.38-1.38 3.57a96.55 96.55 0 0 1-3.07 7.01 51.58 51.58 0 0 1-3.84 6.62 35.96 35.96 0 0 1-4.98 5.79z'/%3e%3cpath d='M505.05 349.23c1.2-1.66 2.39-3.33 3.57-5l1.78-2.5c.59-.84 1.2-1.66 1.73-2.54a68.5 68.5 0 0 0 2.9-5.4c.9-1.85 1.82-3.68 2.71-5.52 1.78-3.69 3.5-7.4 4.97-11.23a75.28 75.28 0 0 0 3.45-11.76c.85-4 1.41-8.06 1.88-12.13.43-4.06.48-8.18.04-12.25a52.36 52.36 0 0 0-2.72-11.94 72.65 72.65 0 0 0-5.1-11.16 72.6 72.6 0 0 1 5.2 11.13 52.4 52.4 0 0 1 2.77 11.96c.44 4.08.41 8.2 0 12.28-.46 4.07-1.02 8.14-1.86 12.15a75.52 75.52 0 0 1-3.5 11.79 145.12 145.12 0 0 1-5 11.22c-.9 1.85-1.82 3.67-2.73 5.51a67.34 67.34 0 0 1-2.92 5.4c-.53.89-1.16 1.7-1.75 2.53l-1.8 2.5c-1.2 1.65-2.4 3.31-3.62 4.96z'/%3e%3cpath d='M507.81 352.25c2.36-3.84 4.71-7.68 6.95-11.58 2.25-3.9 4.49-7.82 6.47-11.86a81.9 81.9 0 0 0 5-12.52 74.15 74.15 0 0 0 2.71-13.2c.59-4.46.93-8.96.93-13.46s-.37-9-1.2-13.42a57.58 57.58 0 0 0-3.98-12.87 54 54 0 0 0-6.96-11.53 54.08 54.08 0 0 1 7.06 11.49 57.58 57.58 0 0 1 4.02 12.88 73.26 73.26 0 0 1 1.24 13.45 102.9 102.9 0 0 1-1.37 16.83 74.24 74.24 0 0 1-2.28 9.88 82.1 82.1 0 0 1-5.04 12.53c-2 4.05-4.24 7.96-6.5 11.85a442.64 442.64 0 0 1-7.05 11.53zM480 220.77c.47-.01.95.04 1.42.11a18.85 18.85 0 0 1 4.08 1.25c1.74.77 3.37 1.77 4.9 2.9a35.81 35.81 0 0 1 6.16 5.9c.6.74 1.2 1.48 1.76 2.24a60.86 60.86 0 0 0-3.78-4.23 37.82 37.82 0 0 0-4.27-3.73 26.78 26.78 0 0 0-4.84-2.93c-.86-.4-1.74-.74-2.65-1-.9-.27-1.83-.47-2.78-.51z'/%3e%3c/g%3e%3cg fill='%23448127'%3e%3cpath d='M496.38 231.57s3.06 1.8 4.73 4.44c0 0-4.72-.88-8.07-4.65'/%3e%3cpath fill='%2334541f' d='M496.38 231.57a14.43 14.43 0 0 1 2.66 1.9 13.11 13.11 0 0 1 2.16 2.48l.13.22-.24-.06a15.7 15.7 0 0 1-4.41-1.75c-1.37-.79-2.63-1.8-3.64-3a15.17 15.17 0 0 0 3.72 2.86c.68.38 1.4.72 2.12 1 .73.28 1.49.52 2.25.68l-.12.17c-.28-.46-.6-.9-.96-1.3a16.08 16.08 0 0 0-2.36-2.23c-.42-.34-.86-.67-1.31-.97z'/%3e%3cpath d='M489.58 230.69s7.23 4.61 8.27 4.98c0 0-1.6-3.48-5.05-4.97'/%3e%3cpath fill='%2334541f' d='m489.58 230.69 4.14 2.49a156.88 156.88 0 0 0 3.11 1.84c.35.2.7.4 1.06.55l-.13.14a12.91 12.91 0 0 0-2.07-2.9 10.73 10.73 0 0 0-2.89-2.11c.56.22 1.1.5 1.6.85a11.03 11.03 0 0 1 3.55 4.08l.12.24-.25-.1c-.77-.33-1.44-.76-2.14-1.17l-2.06-1.27c-1.36-.86-2.7-1.73-4.04-2.64z'/%3e%3cpath d='M492.46 228.36s3.76 1.6 4.61 4.38c0 0-6.75-2.84-7.96-4.35'/%3e%3cpath fill='%2334541f' d='M492.46 228.36a10.67 10.67 0 0 1 2.8 1.68c.43.35.81.75 1.14 1.2.33.44.61.93.77 1.47l.07.22-.21-.1a77.2 77.2 0 0 1-4.13-1.93c-.68-.35-1.35-.71-2-1.11-.32-.2-.64-.4-.95-.63-.3-.23-.6-.47-.84-.77.25.29.56.5.87.72.32.21.65.4.98.6a84.15 84.15 0 0 0 6.16 2.94l-.15.12c-.16-.5-.41-.98-.73-1.42a7.8 7.8 0 0 0-1.09-1.18 12.7 12.7 0 0 0-2.7-1.81z'/%3e%3cpath d='M486.76 231.25s6.65 4.76 8.61 4.76c0 0-1.95-3.26-5.39-4.75'/%3e%3cpath fill='%2334541f' d='M486.76 231.25a124.04 124.04 0 0 0 4.18 2.65c.7.42 1.42.83 2.16 1.2.37.18.74.36 1.12.5.37.15.77.3 1.15.3l-.09.16a15.68 15.68 0 0 0-2.32-2.76 12.98 12.98 0 0 0-2.98-2.04c1.13.45 2.17 1.13 3.09 1.93a12.97 12.97 0 0 1 2.4 2.76l.1.17h-.2a3.76 3.76 0 0 1-1.23-.31c-.39-.16-.77-.34-1.13-.53-.74-.38-1.46-.8-2.16-1.22a63.89 63.89 0 0 1-4.09-2.81z'/%3e%3cpath d='M486.76 232.74s3.46 2.92 5.43 2.92c0 0-1.95-3.26-5.4-4.75'/%3e%3cpath fill='%2334541f' d='M486.76 232.74a32.06 32.06 0 0 0 2.59 1.74c.44.26.9.5 1.37.7.24.1.48.2.73.26.24.07.49.11.74.12l-.1.15c-.3-.5-.67-.99-1.06-1.45a13 13 0 0 0-4.23-3.35c1.13.45 2.16 1.13 3.08 1.93a12.95 12.95 0 0 1 2.4 2.77l.1.15h-.2c-.54 0-1.06-.18-1.54-.39-.48-.2-.94-.46-1.39-.74a20.06 20.06 0 0 1-2.49-1.89z'/%3e%3cpath d='M485.03 226.18s7.2 5.12 8.06 7.9c0 0-6.52-3-7.73-4.5'/%3e%3cpath fill='%2334541f' d='M485.03 226.18a51.63 51.63 0 0 1 4.5 3.49c.73.62 1.42 1.28 2.06 1.99.32.35.63.71.91 1.1.28.4.55.8.7 1.28l.06.24-.22-.1a79.6 79.6 0 0 1-4-2.04c-.66-.37-1.31-.74-1.94-1.15-.32-.2-.62-.42-.92-.65-.3-.23-.6-.47-.82-.77.25.29.55.5.85.73.3.21.62.4.94.6.64.39 1.3.75 1.96 1.1 1.33.69 2.66 1.36 4.02 1.98l-.14.13a4.68 4.68 0 0 0-.66-1.22c-.27-.39-.57-.75-.89-1.1-.63-.7-1.32-1.35-2.02-2a71.2 71.2 0 0 0-4.4-3.62z'/%3e%3c/g%3e%3cg stroke='%2324420e' stroke-width='.16'%3e%3cpath fill='%23406325' d='M445.02 370.33c-4.89 3.64-18.55 5.43-20.45 4.8 9.94-8.27 19.73-8.47 20.45-4.8zm69.76 4.44c5.25 4.77 21.1 8.05 23.48 7.46-10.55-10.77-22.1-11.86-23.48-7.46z'/%3e%3cpath fill='%2367923d' d='M444.98 370.3c-.72-3.67-10.46-3.45-20.38 4.78 10.45-3.45 19.24-5.41 20.38-4.78zm69.91 4.41c1.37-4.4 12.8-3.34 23.36 7.46-11.88-5.02-21.94-8.1-23.36-7.46z'/%3e%3c/g%3e%3c/svg%3e";
            },
            6296: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill-rule='evenodd' clip-rule='evenodd' image-rendering='optimizeQuality' shape-rendering='geometricPrecision' text-rendering='geometricPrecision' viewBox='0 0 216958.34 116416.66'%3e%3cpath fill='%23c62139' d='M0-.005h216958.33V116416.66H0z'/%3e%3cpath fill='%2300297b' d='M5291.666 5291.667h206375v105833.331h-206375z'/%3e%3cpath fill='%2392dbfc' d='M108537.167 28617.296s-18122.53 14420.028-18122.53 29399.058c0 14981.029 18122.541 29783.057 18122.541 29783.057s18006.53-13724.025 18006.53-29783.057c0-16057.03-18006.54-29399.058-18006.54-29399.058z'/%3e%3cpath fill='%23008ce7' d='M92419.719 67159.562c4716.233 11327.588 16117.447 20639.81 16117.447 20639.81s11603.943-8844.17 16181.373-20640.687'/%3e%3cpath fill='%239c8431' d='M124781.681 63890.343c-2794.003 1999.002-18515.022 1039-18515.022 1039l-879.002 2238.004 18719.024 57.999c78-306.998 265-672 330-982.002z'/%3e%3cpath fill='%23ffde52' d='M96651.642 73153.356c796.01 26.008 1589.01 193.997 2301.011 576 1273 668 2011.001 662.999 3383 683.999 1436.002 21.987 2563.004 1079.003 4115.006 1123.003 2859.004 80 4061.005 1500.001 1838.002 1499.001-1050.002-1.059-3301.004-706.001-4389.006-558.001-1654.002 168-2610 294.002-3834.001 1267.003-1166.001-1400.001-2332.002-2940.004-3414.012-4591.005zm5656.011 7128.008c709.002-485.002 1197.002-864.002 1885.002-885.002 1337.002-41 1793.003-868 3338.005-867 1756.003 322 4136.005-211 5529.007-520.002 2473.004-570 1300.002-2300.004-197-2928.003-1210.002-518.001-3478.004-26.009-4885.006-540.001-1065.002-416-187-1079.001 386-1220.001 578-106 1198.002 85 1917.002 201.999 1284.002 113.001 2897.004-7.011 4025.006-182 2331.002-356.998 2235.001-1041 3360.005-1057.002 821-38 1446.002-281.998 2006-682.001 658.002-439 1343.003-1340.002 2139.004-1304l468.002 20.003c-4916.007 9510.012-13745.019 15753.018-13745.019 15753.018s-2853.004-2184.001-6226.008-5790.005z'/%3e%3cpath fill='%238c4200' d='M113608.667 73315.355c305.001 1180.003 628.002 1581.003 1868.003 1884.001 1224.002 303.001 3094.003-887 1935.004-2042.003-1103.004-1074-2265.005-1349-3253.005-2316.003-1533.002-1520-3636.006-4662.006-4635.006-7633.01-1093.002-3248.003-903.002-12392.016-854.002-17024.022 1.006-54 133-86 148-108 71-102 139 33 28.001-646-29-174-167-354-166-530 1.005-314.002-1084.001 343-1370.003 903-65 128 208.001 493 208.001 565 37 4444.006-441 13218.017 739 17190.024 730.001 2459.003 2062.003 4358.006 3268.005 6115.007 723.001 1126.001 1769.002 2341.003 2084.002 3642.006z'/%3e%3cg fill-rule='nonzero'%3e%3cpath fill='%23fff' d='M100086.654 60304.335c-14-2.117-69-8.996-122-16.007-377-46-780-204.999-1075.001-425-420-313-698-814.002-791-1429.003-26.01-172-25.01-615 1-784 74-474.999 248-894.002 498-1200 74-90.001 216-228.002 303-293.002 205-156 470-278.002 749-346 200-50 323-65 563-72 334.001-7.99 569.001 22.013 833.001 110 338 111.002 600.005 291 785.005 537.002 125 165.999 287 534.998 310 705.001 12 92.998-25.001 162-107 196.998-26.001 11.006-156 50.001-290 86-269.004 72.002-307.004 74.002-367.004 23.998-40-33.999-54-60-89-169-16-46-55-139.999-88-207-51-102.999-72-134-141-203-69-69.999-99-90.999-202-141-228-111.001-484.001-149-779.001-113.001-216 26.008-450 114.001-597 225.001-327 246-509.001 732-490 1306.001 25 783 357 1214.002 1040 1351.003 131 26.008 417 26.008 557 0 204-38 503-155.001 672-263.001l61-38v-249l1.01-250.002-539-3.995-539-3.996-34-23.997c-19-13.997-45-40-58-59-24-33-24-38.002-24-331.002 1-293 1-298 25-331 13-18.996 40-45 59-58.001l34-25.003 923 2.117 924 2.117 33 23.997c19 12.99 45 42 59 64l24.001 39.003 2.01 765c2.011 815 0 848-49 907-13.999 17.013-78 69-141 115.002-436 320.998-900 511.998-1377 567-123.001 13.996-481.001 18.996-557.001 7.99zm4829.003 41.003c-483-37.002-848.002-181.002-1114.002-438.002-262-253-392-570-450-1098-17-147-18-302.002-17-1496.004 2.01-1286 3-1334 23-1373 11.002-22.014 37-53.002 57-69l38-28.002 317.001-2.99c306-2.116 319-2.116 364 20.003 28 13.996 56 39.002 71 62l24.001 39.003 4 1380c3.001 1216.003 5.001 1393.001 20 1489.002 40 250 80 343.002 197 460 147 146 300 200.002 590 210 267.002 7.99 450.002-22.013 607.002-99 181-88 263-226.998 325-544.999 23-120.002 23-139.002 32-1501.004 9.001-1543 2.011-1415 85-1478l39-29h330.002c368 1.057 357-1.059 416 76.999l30 39 1.005 1238.001c1.006 1242.003-5 1502.003-38 1736.005-71 497.998-236 812.998-554 1059-107 82.999-151 111-256.001 162.999-161 81-347 136.001-558 166-110 16.007-471.001 27-583.001 18.996zm4322.006-67.001c-14-2.99-45-26.008-70-50-51-51.002-65-98-50-162 18.998-79.002 1583.001-4115.006 1608.001-4147.005 49-66 63-68 429-67 366.001 0 380.001 2.99 430.001 68 12.999 18.998 401.001 958.001 862.002 2089 732 1797.004 837 2062.003 837 2110.004 0 60.999-24 103-81 144-34 23.997-35 23.997-401 22.991h-367l-40-30.998c-51-39-50-35.002-287.002-655-108-283.001-201-523.002-207-533-9-17.992-55-18.997-735-20.003-681.002-1.058-726.002 0-733 17.013-4.002 10-96.002 261.998-205.002 559.998-108 297-206 556.001-218 575.001-11.999 18.997-37 45-55 58.002-33 23.997-39 23.997-363 25.003-181 1.058-340-1.058-354-3.995zm2343.002-2066.003c-15.999-45-404-1083-414-1108-4-11.008-9.001-6.007-17 16.006-18 54.001-415 1113.002-420 1122.001-3 3.995 191 7.99 430 8.996h436.001zm3314.005 2062.003c-46-13.997-96-67-109-116.002-7.002-27.998-9.002-713-4.001-2121.001l7.001-2079.002 28-38c56-73 51-72 552-71 417 1.057 452 2.115 487.002 20.001 20.002 11.007 46.998 35 58.999 53 11.986 17.013 244.999 702 517.001 1520.003 273 818.002 498 1488.002 501 1488.002 2.99 0 235-665.002 516-1477.003 319.002-924 521-1493 538.003-1519 56-81 50.998-80 510-79 390.999 0 408.999 1.058 446 22.013 21.009 11.985 49.999 40 65 61l26.01 40-2.99 2091.003c-3.995 1971-5.001 2093.001-22.992 2125.002-10.002 17.992-36.002 46.998-58.002 63l-39 29.998-319-1.058c-316 0-319 0-353-25.003-18.997-12.99-45-39.002-58.002-58.002l-25.003-33.999-2.99-1200.002-2.99-1199-55.999 158.999c-31 88-221.001 632-422.002 1209-353 1011.003-368 1052.003-409 1094.003-25.002 26.01-56 46-77 50.001-20.003 3.995-153.002 6.985-297 6.985-251-1.058-264-2.117-309-25.003-26.009-12.99-57.002-39-69-56.999-12.013-17.992-207-581.002-433.002-1251.001-226-669.002-415-1217.002-419-1217.002-5 0-8.998 542.002-10.998 1206-2.011 1351.003 4 1252.004-80 1308.003l-43 28.001-298 1.058c-164.002 1.06-313.002-2.99-331.002-8.996z'/%3e%3cpath fill='%23bd0728' d='M100058.654 60119.336c-542-62-1030-302.001-1324.001-652-248-294-408-682-461-1118.003-17-143.999-16-484 2.01-621.998 62-475.002 250-918.002 519-1223.003 459-521 1412-731.003 2186.001-481 488 156.999 778 454.999 943 966 23 71 40 131 38 134-6.001 3.996-422 117.002-453 123-18 2.99-27-13.997-54-93.999-77-226.002-194-414.001-324-518.001-284-226-684-309-1153-238.001-300 46-598 200.002-769 398-257.001 297.003-384.001 661-400.001 1142.003-15 476 71 839 270 1139 323 488 1075 706.002 1744.001 506 214-64 447-174.997 611-292l75.999-53.998 1.006-385v-386.002l-604.005-1.058-605-1.058 1.01-236.001v-236l864 2.116 864.001 1.059-2.011 752.001-1.006 752-95 70c-389 286.002-779.004 459.003-1196.004 533.001-154 27.001-522 37-678 18.997zm4787.003 36.999c-392-43-697.002-169-913.002-379-197-191-310-428-369-772.998-42-248.003-45-376.003-43-1696.005l2.01-1293.001 265.001 1.059h264l2.011 1379c2.011 1467.002 1.006 1443.002 57 1664.004 71 282 281 491 581.002 578 240 70 564 71 837 2.99 324-81 498-255 586-585.001 68-253 67.002-229 74-1690.002l7.002-1345.001 265 1.058h264l-3 1247c-1.005 718-7.001 1317.001-14 1413.003-45 632-209 974-592 1233-151 103-356 181-582 223-98 17.992-576.001 31.001-688.001 18.997zm4474.006-113.998c12.999-33.002 366-948.002 785-2034.004l763.002-1974.002 286-2.117 287-2.99 822.001 2020.003c452 1111.002 825.001 2029.003 829.001 2040.004 7.001 18.998-11.001 20.003-292 20.003l-300-1.058-52-135.001c-29-74-134-351-235-614l-183.002-478.003-862-3.995-862.002-5-224 616-224 616.001-281-1.059h-280zm2534.002-1625.003c-3-11.007-121-326-261-700.001-140-374-298-808-350-966.002-52-157-97-288-99-291-3-2.99-23 66-44 153.001-69 289-135 487-381 1137.003-133 354.999-246 654-250 664.998-8.002 18.997 30 20.003 691 21.008 660 1.06 699 0 694-18.997zm3112.005-354 4-2039.001 400 3.995 399 3.995 540 1625.003c297 893 557.001 1680.002 577.001 1749.003 21.008 68 40 121.999 43 119.999 2.117-2.99 69.001-196.001 148-430.001 80.003-233 350.002-1017.001 601.002-1742.003l457.002-1318.001 358-2.116 358-2.117-3.995 2038.002-3.995 2039.004-253-1.058h-253l2.99-1713.003c2.115-942.002-1.06-1707.003-7.013-1701.002-5 6.006-256 718-557.001 1582.003-300.998 864-568 1629-593 1700l-46 129.002h-477.999l-582.002-1726.003c-320-949-586-1733.003-591-1743.002-5-8.996-10.999 767.001-12.999 1725.003l-4 1741.001h-253l-253-1.058z'/%3e%3c/g%3e%3cpath fill='%23109421' d='M97273.642 44871.316c77 106.001 66 563.001 66 563.001 63 38 1085.01-870.001 1085.01-829.001 1 191.001 24 585.001 24 585.001s1058.001-1006.001 1102.001-900.001c49 119-4 702.001-4 702.001s704-776.001 833-916.001c93.001-100 78.001 126 87.001 491 2.01 65 1153.998-850 1223.998-866 149-32 195 475 187 602-6 94 1063.002-610 1016.002-517l79 541c298-41 1008.001-306 1435.001-237 137 22 130 91 8.001 141-2058.002 833.001-3641.002 2089.002-4563.002 3839.005-314 596-410 1116.001-327 1247.001 0 0 370-796 787-921 56-16 93 510 150 480 0 0 316-798.002 544-1092.002 61-79 163 419.001 228 345.001 0 0 164-534.001 484.999-906.001 46-53 129 505 180 458 333.001-307 646.001-1077 771.001-1134 87-68 102 640 185 579 0 0 475.002-954.002 759.002-1127.002 182-112 175 521 175 521 362-357 761-949 950-1206 87.002-118 39 780 132 815 119 46 899.002-688 987.002-703 58-10.002 126 209-26 385-12.002 13.999-964.001 1112.001-964.001 1112.001 185 35 257-17 390 18 395 104-740.001 755.001-721.001 877.001 0 0 547-10.002 364 96-132 77-855 1008-855 975.002 0-17 363 8 361 112-3 193-601 1188-607 1182-33-33 321-43 369 55 88 181.002-614.001 986.002-477.001 1123.002 18.999 19 401 6.001 571 44 82 18 312 1462.002 254 1404.002-12.997-13.999 246.002-1354.001 403.002-1762.002 96-247 403 373 428 318-12.999 0-62-881.001-19-1282.001 12-112 233 117 230 10.002-8-243.002-28-503.002 22-740.002 38-179 226 323 299.001 188 0 0-228-872-133-1118 63-162.002 215 392 315 414 0 0-56-678.002 49-853.002l317 340.001c69-109 56-1165.001 120-1264.001 53-83 382.001 396 431.001 321 44-68-139-852.002-98-914.002 58-89 419.001 218 426 212.001 147-148 142.001-517.001 204.001-654.001 166-371 1118.001-419 1230.001-155 55.001 128 17 293-5 492 9.001 8.001 477 42 481 6.001 0 0-56 437-23 918.002 5 64 475-16 481 48 43 453-61 495-61 495 4 33 317.001-48 322.001-12.999 34 221-37 490-177 749-21 37.002 448-36 455 7.002 57 340 68 610.001 9.001 1090.001-5 39 459.001-339 466.001-300 70 404-10.999 840 31 1258.001 10.001 97.001 307-289 334-177 27 110-66 910.001-21 955.001 0 0 497.001-25 541.001 17 394.001 370 319 1016.001 319 1016.001 108-80 67.001-858-42-1570.002-12-75 382.001-46 370.001-116 0 0-432-260-574-984.002-30.001-155 417-123 417-123-124-285-342-339-527.001-613-60-90 464-131 464-157 1.006-273-442-403-671-687-98-121 478-127.002 478-127.002-169-235-726-338-1010-649-155-169 565-335 556-364-79-249-756-327-1084.002-608.002-68-58 428.001-254 428.001-254-50-106-1131.001-817-581-752 232 28 703 358 740 308 0 0-20-415 28-465 181-188.002 805.001 798 1017.001 758 0 0 78-706 174.001-725 228-43 506 1028 731 1028 30 0 47-619 163-653 131.001-38 278.001 694 444.001 856.001 154.001 149 156.001-572.001 246.001-435.001 153 221 190 682.001 399 885.002 136 132 161-636.002 312-533.002 175 119.001 134 517.002 331.001 713.002 94 93 157-507 264-419 95 77 159 811 261.001 927 130 148 280-387 415-302 97 62 74 697 164 833 184 282.002 280.002-341 402.001-245 85 65 269 795.002 346.001 853.002 171 130 265-332 395-267 94 46 284 986 362 962 51-15.999 177-2142.002-641.002-3039.004-1333-1462.002-3720.003-2306.002-5668.005-2327.002 0 0 979.001-195 1005-357 52.001-323 538.002-285 877.002-211 60 12.999 28-571.002 36-574.002 303-7 574.001 172 864.001 348 90 55-183-585-87-530 372 215 786 278 1037.001 539 66 69.002-76-493-76-493 186-45 553.001 223 697.001 474 70 124.002-4-655 51-517 0 0 648 220 718 493 0 0 53.002-494 140-468 260.001 68 488.003 507 691.002 570 0 0-84-440-17.992-423 488 123 1018.001 425 1017.001 423-275-688-1318.002-1409.001-3153.004-1602.002-337-34.999-1704.002-91-2863.004 178.002-950 220-1700.002 345-1546.002 195 628.002-615.002 1643.002-690.002 1922.003-833.002 200-102-673-439-500-487 172-41 952-106 952-106 169-132-567-390.001-457-582.002 220-385 1521.002-35 1632.003-181 36-49-559.002-401-534.002-453 95-195 1253.002 144 1280.002-26 0 0-351-262-601-477.001-30-26 1034-312 1034-312-20-20-182-134-426-229-223-87 934.002-388 934.002-388-1466.002-670.002-5271.008 1236-6026.008 3214.003-196 472-202-41-161-441.001 39-430 93-807 47-1202.002-14-117-311 311.001-331 197.001-76-420 149-881.001 46-1347.001-34-157-428.002 463-480.002 306-144-431 108-1037.002 6.001-1631.002-40-232-413 497-538 289-146-241-82-1134.002-151-1269.002-56-108-388.001 428-416.001 327-450-1637.002 148-1841.002-716-918-30.001 32-222.001-968.002-255.001-934.002-354 758.002-934.002-540-1132.002-419-148 92 404 594 410 820 3.001 109-508 116-508 116 11 187 972.002 711.002 1003.002 916.002 25 169-680.002 127-680.002 127 22 229 823.002 447 867.002 690.002 25 134-375 164-362 300 21 209 774 622 799 835.001 17 148-481 209-493 347-15 167 1000 727.001 1001 884.001 1.006 222-404 108-588 220-259 157.001 831 793.001 877.002 974.002 36 159-436.002 19-452.002 164-20 190 534.002 477.001 661.002 803.001 127 322-3.001 404-185.001 276-365-257-1837.002-1821.002-2228.003-2238.003-568-606-1731.002-1285-2891.004-1325-121 37 624.002 564 629.002 755 1.005 49-335.001 122-320.001 137 206 206 847.001 451 847.001 451l-184 331.001c43 97 347 123 834 283 0 0-365 226-338 247 258 206 758.002 358 758.002 358l-492.001 165c-29 95 1107.001 550.002 1107.001 550.002s-355 306-339 322c87 87 922 280 922 280 14 14-590 202-586 206 219 219 823.002 290.001 964.002 652.002 0 0 83 206-156 167-940.002-341-2396.004-1047.001-5219.004-770.001-2886.011 376.001-5085.013 2885.003-5047.013 3135.004 0 0 1032-740.001 1141.001-590z'/%3e%3cg fill='%238c4200' transform='translate(201503.018 49556.295)'%3e%3cellipse cx='-76406.734' cy='-54552.762' rx='609.989' ry='646.731' transform='rotate(-32.773) skewX(.012)'/%3e%3cellipse cx='80113.359' cy='46920.699' rx='696.674' ry='738.637' transform='matrix(-.84082 -.54131 -.5415 .8407 0 0)'/%3e%3cellipse cx='80494.336' cy='47852.852' rx='743.691' ry='788.485' transform='matrix(-.84082 -.54131 -.5415 .8407 0 0)'/%3e%3c/g%3e%3cpath d='M102199.713 69706.336h919v687h-919z'/%3e%3cpath fill='%238c4200' d='M97603.708 70148.337s6037.009 459.999 9739.011-334.999c0 0 311.001 210.999-136 732.999-447 521.001-1578 632.999-2199.001 745 0 0-149 335-137 509 12.999 174.001 392 156.001 578 118.002l186-37.002s-87 652.002-2372.001 739.002c-750.001 28.998-3222.999 81-3745.999-652.002 0 0 453 37.002 571 0 118-36.999 32-509-12.01-578.001-42.99-67.998-1603 0-2422-757.999-203-216.001-300-446-300-528 0-7.012 250 44 250 44zm3146.01 1267s1651.998 211 3553 0c0 0 50 360-37.001 497.001-87 136.999-2280.001 242.001-3385.999 50.001-178-57.002-184-275.003-130-547.002z'/%3e%3cpath fill='%23fdf9ff' d='M98443.718 69854.337s2240-2382.001 1554-7352.007c0 0 2333.998 601.001 4713 4034.005 0 0 694 697 1510.001 3183.001z'/%3e%3cpath fill='%23c62139' d='M108540.72 26889.305S89359.708 41168.314 89359.708 58005.326c0 16839.012 19181.012 31522.022 19181.012 31522.022s19058.02-13472.01 19058.02-31522.022c0-18049.013-19058.02-31116.021-19058.02-31116.021zm-7 3456.003S91469.708 43048.315 91469.708 58027.326c0 14981.012 17064.012 28044.022 17064.012 28044.022s16955.02-11985.01 16955.02-28044.022c0-16057.011-16955.02-27682.018-16955.02-27682.018z'/%3e%3c/svg%3e";
            },
            2203: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-2 -3 12 6'%3e%3cpath fill='%23ce1126' d='M-2-3h4v6h-4z'/%3e%3cpath fill='%23fcd116' d='M2-3h8v3H2z'/%3e%3cpath fill='%23009e49' d='M2 0h8v3H2z'/%3e%3cg id='b'%3e%3cpath id='a' fill='%23000' d='M0-1v1h.5' transform='rotate(18 0 -1)'/%3e%3cuse xlink:href='%23a' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(72)'/%3e%3cuse xlink:href='%23b' transform='rotate(144)'/%3e%3cuse xlink:href='%23b' transform='rotate(216)'/%3e%3cuse xlink:href='%23b' transform='rotate(288)'/%3e%3c/svg%3e";
            },
            5418: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 500 300'%3e%3cpath fill='%23009e49' d='M0 0h500v300H0z'/%3e%3cpath fill='%23fff' d='m0 0 500 150L0 300z'/%3e%3cpath fill='%23fcd116' d='M0 13.05 456 150 0 286.95z'/%3e%3cpath d='m0 0 250 150L0 300z'/%3e%3cpath fill='%23ce1126' d='M0 17.5 220.85 150 0 282.5z'/%3e%3c/svg%3e";
            },
            9588: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3e%3cpath fill='%23de2910' d='M0 0h900v600H0z'/%3e%3cg id='a'%3e%3cpath fill='%23fff' d='M449.964 299.913c-105.263-44.486-58.602-181.581 42.07-174.69-20.366 10.467-23.318 29.997-11.687 48.09 13.024 20.256-1.2 52.848-18.806 60.767-28.935 13.025-34.728 47.75-11.577 65.833z'/%3e%3cpath fill='%23de2910' d='m444.272 200.92-5.92 9.294-2.144-10.815-10.679-2.759 9.625-5.39-.671-10.999 8.085 7.49 10.256-4.043-4.61 10.01 7.001 8.505zm6.288 97.839c-12.731-6.534-22.996-20.155-27.468-36.431-5.115-18.67-2.173-38.743 8.083-55.038l-2.208-1.394c-10.64 16.929-13.693 37.743-8.386 57.12 4.728 17.221 15.214 31.097 28.787 38.064z'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='rotate(72 450 300)'/%3e%3cuse xlink:href='%23a' transform='rotate(144 450 300)'/%3e%3cuse xlink:href='%23a' transform='rotate(216 450 300)'/%3e%3cuse xlink:href='%23a' transform='rotate(288 450 300)'/%3e%3c/svg%3e";
            },
            6382: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 10080 5040'%3e%3cdefs%3e%3cclipPath id='b'%3e%3cpath d='M0 0h6v3H0z'/%3e%3c/clipPath%3e%3cclipPath id='c'%3e%3cpath d='M0 0v1.5h6V3zm6 0H3v3H0z'/%3e%3c/clipPath%3e%3cpath id='a' d='m0-360 69.421 215.845 212.038-80.301L155.99-35.603l194.985 115.71-225.881 19.651 31.105 224.59L0 160l-156.198 164.349 31.105-224.59-225.881-19.651 194.986-115.711-125.471-188.853 212.038 80.301z'/%3e%3cpath id='e' d='M0-210 54.86-75.508l144.862 10.614L88.765 28.842l34.67 141.052L0 93.334l-123.435 76.56 34.67-141.052-110.957-93.736L-54.86-75.508z'/%3e%3cuse xlink:href='%23a' id='d' transform='scale(2.1)'/%3e%3c/defs%3e%3cpath fill='%23012169' d='M0 0h10080v5040H0z'/%3e%3cpath stroke='%23fff' stroke-width='.6' d='m0 0 6 3m0-3L0 3' clip-path='url(%23b)' transform='scale(840)'/%3e%3cpath stroke='%23e4002b' stroke-width='.4' d='m0 0 6 3m0-3L0 3' clip-path='url(%23c)' transform='scale(840)'/%3e%3cpath stroke='%23fff' stroke-width='840' d='M2520 0v2520M0 1260h5040'/%3e%3cpath stroke='%23e4002b' stroke-width='504' d='M2520 0v2520M0 1260h5040'/%3e%3cg fill='%23fff'%3e%3cuse xlink:href='%23d' x='2520' y='3780'/%3e%3cuse xlink:href='%23a' x='7560' y='4200'/%3e%3cuse xlink:href='%23a' x='6300' y='2205'/%3e%3cuse xlink:href='%23a' x='7560' y='840'/%3e%3cuse xlink:href='%23a' x='8680' y='1869'/%3e%3cuse xlink:href='%23e' x='8064' y='2730'/%3e%3c/g%3e%3c/svg%3e";
            },
            5220: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 72 36'%3e%3cpath d='M0 0h72v36H0z' style='fill:%230073cf'/%3e%3cpath d='M0 12h72v12H0z' style='fill:%23fff'/%3e%3cg id='c' fill='%230073cf' transform='matrix(2 0 0 2 36 18)'%3e%3cg id='b'%3e%3cpath id='a' d='M0 0v1h.5z' transform='rotate(18 3.157 -.5)'/%3e%3cuse xlink:href='%23a' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(72)'/%3e%3cuse xlink:href='%23b' transform='rotate(-72)'/%3e%3cuse xlink:href='%23b' transform='rotate(144)'/%3e%3cuse xlink:href='%23b' transform='rotate(-144)'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='translate(10 -3.2)'/%3e%3cuse xlink:href='%23c' transform='translate(10 2.8)'/%3e%3cuse xlink:href='%23c' transform='translate(-10 -3.2)'/%3e%3cuse xlink:href='%23c' transform='translate(-10 2.8)'/%3e%3c/svg%3e";
            },
            1276: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1200 600'%3e%3cpath fill='%23171796' d='M0 0h1200v600H0z'/%3e%3cpath fill='%23fff' d='M0 0h1200v400H0z'/%3e%3cpath fill='red' d='M0 0h1200v200H0z'/%3e%3cpath fill='red' d='M600.037 455.185c64.152 0 116.636-52.487 116.636-116.635V199.954H483.399V338.55c0 64.151 52.487 116.635 116.635 116.635z'/%3e%3cpath fill='%23fff' d='M600.037 453.316c62.928 0 114.411-51.485 114.411-114.41V202.198H485.623v136.706c0 62.929 51.486 114.411 114.414 114.411z'/%3e%3cg fill='red'%3e%3cpath d='M533.916 206.5h-44.03v48.376h44.03zm0 96.749h44.03v-48.373h-44.03zm-44.03 35.387c0 4.393.272 8.726.779 12.988h43.251V303.25h-44.03v35.387zm132.094-35.387h-44.034v48.375h44.034zm0 96.748h44.03v-48.373h-44.03zm44.03 26.463A111.488 111.488 0 0 0 691.15 400h-25.14v26.46zm-132.091-26.463h44.03v-48.373h-44.03zm-25.18 0a111.46 111.46 0 0 0 25.18 26.492v-26.492h-25.18z'/%3e%3cpath d='M607.632 448.373a109.46 109.46 0 0 0 14.345-1.958v-46.418h-44.03v46.424c4.668.957 9.445 1.611 14.303 1.949 5.127.317 10.254.299 15.379 0zm101.585-96.749c.51-4.277.782-8.625.782-13.033v-35.34h-43.992v48.376h43.21zm-87.237-48.375h44.03v-48.373h-44.03zm0-96.749h-44.03v48.376h44.03zM710 254.876V206.5h-43.99v48.376z'/%3e%3c/g%3e%3cpath fill='%23fff' d='m712.464 198.535 27.3-61.885-20.799-33.587-34.46 12.758-24.194-27.656-31.88 18.27-28.426-23.282-28.427 23.281-31.88-18.27-24.197 27.654-34.46-12.757-20.805 33.595 27.265 61.897c34.357-15.55 72.451-24.214 112.507-24.214 40.037 0 78.114 8.658 112.461 24.196z'/%3e%3cpath fill='%230093dd' d='m516.26 118.552-.051.06-34.173-12.655-19.123 30.876 7.325 16.656 18.558 42.126a274.588 274.588 0 0 1 43.227-14.953l-15.76-62.107z'/%3e%3cpath fill='%23fff' stroke='%23000' stroke-width='.35' d='M514.293 149.084a16.572 16.572 0 0 1 1.916 7.752c0 9.2-7.503 16.703-16.703 16.703-8.107 0-14.896-5.83-16.395-13.51 2.885 5.1 8.362 8.554 14.618 8.554 9.244 0 16.786-7.538 16.786-16.785 0-.925-.077-1.83-.222-2.717z'/%3e%3cpath d='m498.985 125.975-.056.275-1.165 5.995 4.6 4.02.21.183-.266.092-5.773 1.99-1.182 5.993-.056.275-.21-.186-4.61-4.005-5.778 1.973-.27.092.057-.279 1.164-5.992-4.597-4.02-.213-.186.266-.092 5.773-1.987 1.182-5.993.056-.275.21.184 4.61 4.007 5.778-1.972z'/%3e%3cpath fill='%23f7db17' d='m492.048 134.488 4.31 3.758 5.393-1.857zm.035-.19 9.707 1.899-4.295-3.756zm-10.42-2.041 9.704 1.899-4.31-3.756zm9.668 2.091-9.707-1.898 4.295 3.753zm.542-.364 6.499-7.455-5.4 1.842zm-6.978 8.006 6.498-7.455-5.408 1.854zm6.646-7.328-6.498 7.456 5.4-1.843zm6.979-8.006-6.499 7.455 5.409-1.854zm-7.023 7.352-3.208-9.354-1.105 5.598zm3.445 10.047-3.208-9.354-1.1 5.61zm-3.025-9.419 3.208 9.357 1.105-5.599zm-3.444-10.048 3.208 9.358 1.098-5.614z'/%3e%3cpath fill='%23171796' d='m571.874 109.257-.059.047-31.614-18.115-23.942 27.363 15.761 62.108a274.725 274.725 0 0 1 45.147-7.542l-5.296-63.86z'/%3e%3cpath fill='red' d='M528.11 165.245a290.314 290.314 0 0 1 47.745-7.974l-1.339-16.143a306.934 306.934 0 0 0-50.392 8.416l3.983 15.701zm-7.923-31.214a322.445 322.445 0 0 1 53.005-8.853l-1.315-15.847a338.401 338.401 0 0 0-55.603 9.286l3.913 15.414z'/%3e%3cg transform='scale(.00296)'%3e%3cpath fill='%230093dd' d='m212105 36890-23 13-9517-7794-9497 7778 1788 21560c2543-210 5113-322 7709-322 2608 0 5190 113 7744 325l1795-21560z'/%3e%3cg id='a'%3e%3cpath d='M202545 46585c-18-2-44 10-69 45-186 250-359 469-545 720-195 61-242 180-167 348-261-26-291 193-302 432-250-379-522-482-814-307-11-230-187-338-439-392-180-10-319-65-436-145-60-42-110-64-170-106-126-88-226-5-172 74 267 434 535 868 802 1302-14 80 6 151 88 204 47 133 93 265 140 397-11 38-21 75-32 113-221-105-443-118-664-133-170-8-287-50-361-137-54-63-91-26-92 82-3 534 162 1014 599 1492-231 4-462 11-694 21-79 6-95 39-73 104 126 304 339 579 822 766-208 112-327 285-357 520-9 224-75 382-212 455-60 32-81 65-24 106 253 185 565 193 895 112-157 270-226 553-198 850 208 56 412 15 614-52-29 61-44 175-52 309-7 115-41 229-104 343-32 33-65 84 4 102 336 91 648 52 915-47 0 243 2 487 76 727 18 58 70 102 125 26 155-214 322-396 527-517 31 90 75 168 156 215 96 55 147 170 153 343 0 30-2 60 35 90 149 7 514-380 589-597 206 121 284 246 439 461 55 76 99 29 128-25 62-243 67-481 66-724 267 99 579 138 915 47 69-19 36-70 4-102-62-114-105-250-113-365-9-133-14-226-43-287 202 68 405 108 614 52 29-297-53-579-211-850 330 80 655 73 908-112 57-41 35-74-24-106-136-73-203-231-212-455-30-235-149-409-357-520 483-187 696-463 822-766 22-66 6-99-73-104-231-10-480-24-711-27 437-478 606-961 604-1495-1-108-38-146-92-82-74 87-179 137-348 146-222 15-435 24-656 128-11-38-21-75-32-113 46-132 106-260 153-393 82-53 102-123 88-204 267-434 513-868 781-1302 54-79-46-162-171-74-60 42-110 64-170 106-117 80-257 134-437 145-251 54-417 167-428 397-293-175-564-73-814 307-11-239-41-457-302-432 75-168 17-291-178-352-186-250-458-470-644-720-31-35-51-47-69-45z'/%3e%3cg fill='%23f7db17'%3e%3cpath d='M205075 47978c-51-26-124 17-162 95s-33 170 19 196c40 20 84-6 119-56l22-36c2-3 4-6 5-9 38-78 49-163-2-188zm-5008 0c52-26 124 17 162 95s39 165-13 191-103-24-141-102-60-158-9-184zm4539 905c-32 0-59 27-59 59s26 59 59 59 59-26 59-59c0-32-26-59-59-59zm-4032 0c-32 0-59 26-59 59 0 32 26 59 59 59s59-26 59-59-26-59-59-59zm4294-304c-754-91-1506-133-2260-133s-1509 41-2269 115c-26 8-21 90 14 86 756-73 1507-113 2256-113 743 0 1485 40 2228 129 39 4 54-80 32-84z'/%3e%3cpath d='M200319 48495c768-75 1530-117 2289-116 754 0 1507 42 2261 133l111-184c-32 10-62 9-90-5-76-38-92-161-36-274 56-114 164-175 240-138 39 19 62 62 68 114l446-739c-204 130-328 214-581 252-281 41-409 139-368 307 38 156-57 133-201 54-314-171-541 71-652 353-73 186-159 181-168-13-4-70 0-131-7-200-21-223-89-286-216-224-161 78-175 25-137-58 28-60 86-128 66-221-9-67-66-92-151-98-182-244-467-483-649-727-182 244-374 483-556 727-86 5-142 30-152 98-20 93 52 157 80 217 38 82 23 135-137 57-127-61-186-3-207 220-7 69-10 139-13 209-9 194-95 199-168 13-111-282-352-524-667-353-145 79-203 102-182-54 23-172-107-266-388-307-253-37-377-122-581-252l419 682c12-25 29-45 53-57 76-38 184 24 240 138 56 113 40 237-36 274-10 5-21 8-32 10l100 163zm4389 911c-7 3-7 4-24 11-46 19-80 66-134 124-57 60-128 125-211 188-12 10-25 19-44-6s-7-35 6-44c80-62 149-124 204-182 30-32 56-63 77-92-95-11-190-21-284-30-79 24-157 55-222 95-59 35-107 77-137 125-8 14-16 27-44 11-27-16-19-30-11-44 35-58 91-107 158-147 33-20 69-38 106-54-107-9-214-18-321-25-22 13-42 29-61 47-20 19-39 42-56 67-9 13-18 26-44 8s-18-31-8-44c19-29 41-54 64-77l9-9c-80-5-161-10-241-14-2 2-5 5-8 7-21 18-40 38-55 59s-28 43-38 67c-6 15-12 29-41 18-29-12-23-26-17-41 12-29 27-55 45-81 8-11 18-22 27-33-115-5-230-9-344-12-4 5-9 8-14 11-25 15-47 32-66 51s-35 40-48 63c-8 14-16 28-43 12-28-16-20-29-12-43 16-28 35-54 59-77 7-7 14-13 21-19-122-2-244-4-365-4-120 0-240 1-360 3 8 7 15 13 22 20 23 23 42 49 59 77 8 14 16 27-12 43s-35 2-44-12c-13-23-29-44-48-63s-41-36-66-51c-6-3-12-7-15-12-115 2-230 6-345 11 11 11 20 23 29 35 19 25 33 52 45 81 6 15 12 29-17 41s-35-3-41-18c-9-24-22-46-38-67-15-21-34-41-55-59-4-3-7-6-10-10-81 4-162 8-243 13 4 4 9 8 13 12 24 23 45 48 64 77 9 13 18 26-8 44s-35 5-44-8c-18-26-36-48-56-67s-41-35-64-49c-1-1-3-2-5-3-110 7-220 14-330 23 43 18 85 38 122 61 67 40 124 89 158 147 8 14 16 27-11 44-27 16-35 3-44-11-29-48-78-90-137-125-72-44-159-77-246-102h-2c-90 7-179 15-268 24 22 33 51 68 86 106 55 58 124 120 204 182 13 9 25 19 6 44s-32 15-44 6c-83-64-155-128-211-188-37-38-99-111-135-140-196-90-354-127-575-147-153-14-318-9-458-79 36 85 75 164 126 229 53 68 120 121 209 147 8 2 21 16 22 25 28 157 84 286 169 386 52 60 114 110 188 149-75-81-132-166-172-251-67-142-90-286-77-420 1-16 3-32 34-29 32 3 30 19 29 35-11 123 9 256 72 387 56 118 159 237 291 346 24 19 0 63-29 55-154-44-290-123-383-231-89-104-149-237-180-397-94-32-165-90-222-164-47-60-85-131-118-205 28 428 182 801 456 1137 61 75 165 182 255 216 92 35 95 100-20 101-34 1-69 1-105 1 84 31 164 66 233 105 127 73 217 162 224 273 1 16 2 32-29 34-32 2-33-14-34-29-6-86-82-160-192-223-113-65-259-117-402-160-154 0-312-1-459 3 39 28 80 57 131 84 82 44 188 86 343 122 89 21 166 52 233 91 71 42 130 93 177 150 10 12 20 25-5 45s-34 8-45-5c-42-52-95-98-159-135-61-36-133-64-216-84-161-38-272-81-358-128-75-40-131-82-184-123 180 393 450 573 835 689 23 7 43 13 61 19 3 1 6 1 9 2 86 21 175 40 266 55 92 15 166 28 261 37 16 1 32 3 29 34-3 32-19 30-34 29-99-9-174-22-266-38-58-10-115-21-171-33-26 6-64 9-107 12-232 14-420 225-435 494 0 5 0 11-1 16 88-80 179-157 273-212 117-68 239-103 364-69 15 4 31 8 22 39-8 31-23 27-39 22-106-28-212 3-316 63-108 63-213 158-315 253-24 147-82 285-205 377 61 34 104 65 163 45 86-39 172-78 261-108 91-31 184-52 282-57 16-1 32-1 33 31s-14 32-31 33c-91 4-179 24-264 53-75 26-149 58-222 91 221 47 460-1 667-79 60-22 105-42 133-41 51-30 112-53 172-79 66-28 132-51 182-57 16-2 32-4 35 28 4 32-12 33-28 35-112 13-127 21-222 79 0 21-66 57-126 96-36 24-70 52-87 67-95 86-144 181-188 287-29 70-52 145-68 224 55-108 121-211 201-303 94-108 208-201 345-265 14-7 29-13 42 15 13 29-1 35-15 42-129 60-236 147-324 250-90 103-161 222-219 345-31 64-8 1-42 86 110-122 212-224 323-307 132-100 283-157 418-133 15 3 31 6 26 37s-21 28-37 26c-116-21-250 32-369 121-121 92-244 223-366 361 184 26 366-26 542-85 91-30 183-135 239-152 19-24 38-46 57-67 33-37 67-71 102-100 12-10 24-20 45 4s8 34-4 45c-33 28-65 60-96 94-32 35-62 73-92 113-6 8-13 17-24 16-60 70-151 162-172 240-57 210-25 370-122 576 71-38 128-81 175-134 53-60 94-135 128-230 37-104 95-195 167-270 75-77 165-136 261-172 15-5 30-11 41 19s-4 35-19 41c-87 32-169 86-238 157-66 68-119 151-153 247-37 102-81 183-141 250-44 50-95 91-156 127 52-3 78-10 121-7 79-6 211-66 279-119 66-51 116-120 154-206 6-15 13-29 42-16s23 27 16 42c-42 96-99 174-173 231-56 43-121 75-196 93 161-5 311-42 467-100 65-24 87-168 127-208 32-58 66-112 105-158 47-56 101-101 164-127 15-6 29-12 41 18 12 29-3 35-17 41-52 21-98 60-139 108-36 42-68 93-98 147 10 73-51 228-53 305-7 205-2 409 53 612 53-71 107-134 162-192 0-5 0-10 1-15 18-106 33-219 40-332 7-112 7-223-6-329-2-16-4-32 27-35 32-4 34 12 35 28 14 111 14 226 7 340-6 90-16 180-30 269 54-51 53-51 77-103 37-80 59-159 67-237 9-80 5-157-13-230-4-15-7-31 24-38s35 8 38 24c19 80 25 165 14 252-8 65-24 132-49 199 56-42 114-82 178-122-4-75-5-153-3-227 2-68 7-134 18-190 4-20 7-40 47-33s37 27 33 48c-9 50-14 111-16 177-2 78 0 162 4 243 5 82 49 185 125 230 103 62 158 163 186 274 16-145 17-280 3-400-17-143-55-267-114-368-8-14-16-27 12-44 27-16 35-2 43 12 63 110 104 241 122 393 17 146 13 310-13 488 102-82 381-258 352-594-7-27-16-52-28-75-7-14-14-28 14-42s35 0 42 14c17 33 30 69 39 110 5 24 8 49 11 76 13-7 45-43 51-39 24 16 58 38 80 54-21-60-35-120-42-178-10-87-5-172 14-252 4-15 7-31 38-24s27 23 24 38c-18 73-22 151-13 230 9 77 31 157 67 237 4 8 8 16 5 25 24 21 47 42 70 65-13-84-22-170-28-255-8-115-7-230 7-341 2-16 4-32 35-28s29 20 27 35c-13 106-13 217-6 329 7 113 22 225 40 332 1 2 1 5 1 7 54 59 95 120 152 196 55-203 73-407 66-612-2-76-69-227-65-302-30-55-63-107-100-151-41-49-87-87-139-108-15-6-29-12-18-41 12-29 27-24 41-18 62 26 117 71 164 127 38 45 72 98 103 154 57 7 78 179 143 212 154 57 298 94 453 100-75-19-140-50-195-93-74-57-131-135-173-231-6-15-13-29 16-42s35 2 42 16c38 86 88 156 154 206 85 66 289 124 400 127-61-37-113-78-157-128-59-67-104-148-141-250-34-95-87-179-153-247-68-71-150-124-238-157-15-6-29-11-19-41 11-29 26-24 41-19 96 36 186 94 261 172 72 74 130 166 167 270 34 95 75 169 128 230 47 54 105 98 177 135-98-207-66-367-122-577-35-129-232-277-193-320 45-51 133 88 248 127 175 59 357 111 540 85-122-138-244-269-366-361-119-90-237-140-352-120-16 3-31 6-37-26-5-31 10-34 26-37 135-24 269 32 401 132 111 84 201 175 311 298-18-47 0-14-30-77-59-123-130-241-220-345-89-102-196-189-324-250-14-7-28-13-15-42 13-28 28-22 42-15 137 65 251 157 345 265 81 93 147 198 203 307-15-81-39-157-68-227-44-106-93-201-188-287-62-56-209-140-208-179-29-15-33-11-63-24-61-26-121-46-164-52-16-2-32-4-28-35 4-32 19-30 35-28 50 6 115 28 182 56 33 14 66 43 98 60 53 4 139 47 208 74 206 78 446 126 666 79-73-33-147-65-223-91-85-29-172-49-264-53-16-1-32-1-31-33s17-31 33-31c98 4 191 26 282 57 89 30 175 69 261 108 59 27 101-7 163-45-123-92-181-230-205-376l-2-2c-102-95-207-190-315-253-104-60-210-91-316-63-15 4-31 8-39-22-8-31 7-35 22-39 125-33 247 1 364 69 94 55 186 132 274 213 0-6-1-11-1-17-15-270-203-480-435-494-78-5-189 21-186-32 4-59 97-44 234-86 385-116 655-296 836-690-54 41-110 83-186 124-86 47-198 91-358 128-82 19-154 48-216 84-64 38-117 84-159 135-10 12-20 25-45 5s-14-32-5-45c47-57 106-108 177-150 67-39 145-70 233-91 155-36 261-78 343-122 51-27 92-55 131-84-148-4-305-3-459-3-143 44-289 96-402 160-110 63-186 136-192 223-1 16-2 32-34 29-32-2-31-18-29-34 8-111 97-200 224-273 69-39 149-74 233-105-35 0-70 0-104-1-116-2-112-66-20-101 90-34 190-141 251-216 271-334 412-714 456-1130-33 72-69 140-115 198-57 73-128 131-222 164-31 160-91 293-180 397-92 108-216 185-369 230-29 8-52-35-29-55 132-109 221-226 278-344 62-131 83-264 72-387-1-16-3-32 29-35 31-3 33 13 34 29 12 134-10 278-78 420-40 85-97 170-172 251 73-39 136-89 187-149 85-100 141-229 170-386 1-8 14-22 22-25 89-27 155-79 209-147 51-65 90-143 126-228-140 69-304 64-457 78-213 19-369 68-554 152z'/%3e%3cpath d='M204649 49231c-680-88-1359-113-2041-114-684 0-1369 40-2058 112-20 6-15 33-14 46 2 28 37 35 121 27 643-60 1285-93 1932-93 674 0 1351 21 2038 102 33 9 77-85 22-81z'/%3e%3cpath fill-rule='evenodd' d='M200570 49160c683-71 1362-110 2038-110 675 0 1349 40 2025 127l31-127c-17 9-37 15-58 15-67 0-123-55-123-123s55-123 123-123c51 0 94 31 113 75l60-170c-724-84-1446-122-2171-122-729 0-1459 38-2193 107l58 164c22-32 59-54 101-54 68 0 123 55 123 123s-55 123-123 123c-12 0-25-2-36-6l33 94-2 7zm3067-416c-68 0-123 55-123 123s55 123 123 123 123-55 123-123-55-123-123-123zm0 64c-33 0-59 27-59 59s26 59 59 59c32 0 59-27 59-59s-26-59-59-59zm-1082-91c-67 0-123 55-123 123s55 123 123 123 123-55 123-123-55-123-123-123zm0 64c-32 0-59 26-59 59s26 59 59 59 59-26 59-59c0-32-26-59-59-59zm-1064-40c-68 0-123 55-123 123s55 123 123 123c67 0 123-55 123-123s-55-123-123-123zm0 64c-33 0-59 26-59 59s26 59 59 59c32 0 59-26 59-59 0-32-26-59-59-59z'/%3e%3c/g%3e%3cpath d='M202601 47974c-14-68-49-129-100-175-51-47-116-78-187-88-33-4-39-58-7-68 60-20 114-67 157-133 45-69 79-157 95-256 5-34 64-35 69-1 15 84 51 153 97 208 55 66 125 112 193 138 31 12 25 63-8 68-59 9-105 42-141 87-50 62-81 145-100 221-8 33-62 31-69-2zm33-118c20-52 47-103 81-146 28-34 60-64 99-84-51-30-100-70-143-120-28-34-53-73-73-116-19 59-45 112-75 158-31 47-67 86-108 116 50 19 95 47 134 82 34 31 63 68 85 110zm799 5115-515 206c-17 7-35 14-48-21-14-34 4-41 21-48l515-206c17-7 35-14 48 21 14 34-4 41-21 48zm59-326-604 328c-16 9-33 18-51-15s-1-42 15-51l604-328c16-9 33-18 51 15s1 42-15 51zm-1826-65 604 328c16 9 33 18 15 51s-34 24-51 15l-604-328c-16-9-33-18-15-51s34-24 51-15zm51 322 515 206c18 7 35 14 21 48-14 35-31 28-49 21l-515-206c-17-7-34-14-21-48 14-35 31-28 48-21zm224 434c137 33 261 48 358 31 88-16 155-60 191-146v-493c-107-1-212-15-303-41-109-31-170-98-201-178-41-107-27-235-4-329 5-18 9-36 45-27s32 27 27 45c-20 82-33 194 1 284 23 60 69 110 152 133 91 25 198 38 307 38 107 0 214-13 304-40 82-24 148-69 192-123s65-117 57-176c-5-36-24-62-49-80-34-24-82-35-128-37-47-2-94 7-142 16-25 5-50 9-77 13-19 2-37 5-42-32s14-40 32-42c23-3 48-8 73-12 52-10 105-20 159-18 60 2 121 18 168 51 42 29 72 72 80 131 11 80-16 163-73 233-53 65-131 119-229 147-83 24-178 38-274 42v483c3 5 3 11 2 16 37 82 102 125 188 141 97 18 221 2 358-31 18-5 36-9 45 27 8 37-9 41-28 45-146 35-279 51-388 32-92-17-165-58-215-132-49 74-124 115-215 132-109 20-242 4-388-32-18-4-37-8-28-45 8-36 27-32 45-27zm356 210 402-9c19 0 38-1 38 37 1 38-18 38-37 38l-402 9c-19 0-37 1-38-37s18-38 37-38zm593-3082c151-125 293-227 423-297 133-72 254-111 359-106 19 1 37 1 36 39-1 37-20 37-39 36-92-4-200 32-322 97-125 67-263 166-410 289-14 12-29 24-53-5s-9-41 5-53zm-605 56c-141-130-298-240-445-314-139-71-268-108-363-100-19 2-37 4-40-34-4-37 15-39 34-40 110-10 252 31 404 107 152 77 315 191 461 325 14 13 28 25 2 53-25 27-39 15-53 2zm-213 1004c37-83 83-155 136-219 53-63 112-119 174-170 14-12 29-24 52 5 24 29 9 41-5 53-59 48-114 101-164 160-49 59-91 125-125 201-8 17-15 34-49 19s-27-32-19-49zm371-1734c49 66 88 139 114 223 26 82 40 175 39 279 5 80 6 165-7 249-13 86-42 170-97 246-43 60-101 97-165 113-53 13-109 10-164-7 29 100 51 208 6 308-8 18-33 27-51 18-43-22-86-43-128-62s-84-36-127-51l-1-1c-95-37-173-73-236-112-65-39-115-80-150-124l1 2c-44-49-72-106-88-170-14-55-20-114-22-174-72-39-138-78-194-116-64-43-118-87-161-131-13-14-26-27 1-53s40-12 53 1c39 40 89 80 150 121 60 40 128 81 204 121 124 13 247 51 370 109 106 50 211 115 317 192 13 7 19 16 27 20 8 6 16 13 25 19 51 22 104 28 152 16 47-11 90-39 122-84 48-66 72-139 84-214 12-77 11-157 6-234v-2c1-97-12-183-35-258-24-76-58-142-102-201-11-15-22-30 7-52s41-7 52 7zm-375 1047c-104-77-207-141-311-190-105-49-210-83-314-98 2 48 8 93 18 135 13 52 35 99 71 138l1 1c30 37 73 72 130 107 60 36 134 71 225 106l-1-1c45 16 89 34 133 54 31 14 61 28 93 44 19-83-10-179-37-267-2-8-5-15-9-29zm776-1003c-44 59-79 125-102 201-24 76-36 161-35 258v2c-5 77-6 158 6 234 12 75 37 148 84 214 32 45 75 72 122 84 48 12 101 6 152-16 8-6 17-13 25-19 6-4 13-12 27-20 105-77 211-143 317-192 123-58 246-95 370-109 75-40 144-80 204-121s111-81 149-121c13-13 26-27 53-1s14 39 0 53c-43 44-97 88-161 131-57 38-122 77-194 116-2 61-8 119-22 174-16 63-44 121-88 170l1-2c-35 44-85 85-150 124-63 38-141 75-237 112l-1 1c-43 15-85 32-127 51-43 19-85 40-128 62-18 9-43 0-51-18-45-100-23-208 6-308-55 18-111 20-164 7-64-15-122-53-165-113-55-76-84-160-97-246-13-85-12-169-7-249-1-104 13-196 39-279 26-84 65-158 114-223 11-15 22-30 52-7 30 22 19 37 7 52zm940 715c-105 15-209 49-314 98-104 49-207 113-311 190-4 13-6 21-8 29-27 88-56 184-37 267 31-15 62-30 93-44 44-20 87-38 133-54l-1 1c91-35 165-70 225-106 58-34 100-70 131-107l1-1c35-39 57-86 71-138 11-42 16-87 19-135z'/%3e%3cpath fill-rule='evenodd' d='M203459 50602c-119 0-216 97-216 216s97 217 216 217 216-97 216-217c0-119-97-216-216-216zm0 69c-81 0-147 66-147 147s66 147 147 147 147-66 147-147-66-147-147-147zm0 60c-48 0-87 39-87 87s39 87 87 87 87-39 87-87-39-87-87-87zm-1697-124c119 0 217 97 217 216s-97 217-217 217c-119 0-216-97-216-217 0-119 97-216 216-216zm0 69c81 0 147 66 147 147s-66 147-147 147-147-66-147-147 66-147 147-147zm0 60c48 0 87 39 87 87s-39 87-87 87-87-39-87-87 39-87 87-87z'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='rotate(-2.173 -55532.79 156275.842)'/%3e%3cuse xlink:href='%23a' transform='rotate(2.18 459865.852 156275.761)'/%3e%3c/g%3e%3cpath fill='%23171796' d='m683.871 118.584-.074.027-23.992-27.422-31.546 18.08-5.32 63.861a274.6 274.6 0 0 1 45.145 7.556l15.784-62.099z'/%3e%3cpath d='M634.482 122.518c1.096-.267 2.178-.323 3.226.32.46.19.806.432 1.019.743.486-.376.98-.728 1.493-1.03.72-.534 1.454-1.005 2.245-1.268 1.132-.575 2.26-.915 3.392-1.02 1.196-.203 2.399-.215 3.596-.144a6.48 6.48 0 0 1 2.885.865c.835.414 1.667.832 2.502 1.247.883.491 1.766.936 2.648 1.309 1.12.441 2.379.59 3.72.64.658.023 1.304.023 1.938-.145.512-.137.832.19.267.536-4.147 2.544-7.397.281-10.17-.732a20.117 20.117 0 0 1 2.667 2.124c1.054 1.016 2.233 2.047 4.318 2.997 1.265.575 2.642 1.028 4.41 1.043.6.006 1.245-.018 1.944-.133.352-.057.503-.024.51.16.005.124-.027.373-.238.512-1.069.717-2.076.907-3.199.978-2.138.136-4.425-.566-6.516-1.689-1.674-.9-2.802-1.996-4.135-2.98-1.33-.98-2.48-1.525-3.714-1.786-1.218-.26-2.536-.23-3.647.113.332.065.613.222.785.42.572.338 1.307.486 2.37.608.554.065.382.447-.471.906-.512.66-1.179 1.016-2.065.93-1.22.809-1.655.32-2.064-.21-.05.335-.148.663-.293.98a.753.753 0 0 1-.018.533c.195.303.29.596.225.919a.77.77 0 0 0 .272.491c.255.231.418.498.45.824.004.216.122.394.294.554.249.204.5.385.75.69.737.266 1.078.832 1.199 1.564.557.18.788.583.897 1.063.317.134.608.293.774.575 1.137.003 2.248.003 3.287.112.975.104 1.769.711 2.48 1.5.48.073.965.097 1.463-.016.512-.225 1.054-.397 1.644-.447.974-.083 1.952-.133 2.882.089.63.151 1.122.486 1.525.942.58.66 1.475.572 2.24.246 1.036-.442 1.898-.427 2.959.038.453-.175.906-.257 1.36-.21.387-.42.799-.524 1.222-.536.69-.024 1.191.083 1.06.968-.035.24-.177.471-.358.554-.316.685-.92.886-1.688.82-.083.472-.275.821-.583 1.046.352 1.087.014 1.523-.791 1.508-.17.314-.42.51-.85.447a1.726 1.726 0 0 1-1.09.643c.047.284.168.418.37.723.548.83-.276 1.164-1.028 1.176.193.548.216 1.096.148 1.644.767.465.871.953.163 1.436.518.907.317 1.573-.655 2.059-.014.506-.065 1.016-.402 1.3-.231.196-.563.231-.344.598.394.652.308 1.476-.275 1.5-.125-.013-.237.005-.246.204 0 .068-.06.136-.175.204-.7.376-1.354.806-1.955 1.3-.089.06-.178.101-.267.021-.438.954-1.255 1.922-2.159 2.897-.14.717-.545 1.203-1.217 1.454a.512.512 0 0 1-.4.409c.376.418.518.82.154 1.217-.447.49-1.037.966-1.626 1.117-1.253.32-2.038.26-2.542-.22-.444-.423-.27-.743.012-.876-.773.062-.93-.346-.91-.891.045-.273.137-.237.41-.228.42.011.8-.217 1.196-.347.154-.26.356-.486.604-.675.14-.877.694-1.363 1.446-1.65.607-.231 1.188-.818 1.75-1.576.347-.598.697-1.194 1.043-1.792-.243-.317-.308-.634-.317-.95a1.847 1.847 0 0 1-.696-.647c-.545-.038-.77-.284-.85-.625a1.294 1.294 0 0 1-.409-.053c-.266.172-.536.323-.87.308a8.618 8.618 0 0 1-1.363 1.138c-.163.45-.486.63-.88.687-1.12.133-1.789 1.528-2.405 2.097-.249.184-.403.51-.512.9-.054.735-.181 1.31-.584 1.321-.361-.014-.418-.053-.43-.091a1.482 1.482 0 0 0-.47.02c.302.332.35.75.07 1.117-.278.361-.678.474-1.063.5-.796.054-1.442-.017-2.04-.26-.572-.234-.64-.575-.622-.906-.412-.196-.495-.391-.45-.584.056-.249.284-.376.57-.296a3.06 3.06 0 0 1 .747-.246c.723-.779 1.467-1.448 2.284-1.76.24-.29.515-.55.85-.767.095-.699.554-1.25 1.117-1.762a2.51 2.51 0 0 1 .275-.758c-.032-.151.01-.222.012-.365-.228-.423-.364-.933-.195-1.356a1.642 1.642 0 0 1-.063-.676c-1.344.8-1.759.528-1.913-.121-.492.412-.95.604-1.28.012-.476.142-.956.302-1.433.112-.311.122-.625.231-.984.255-.145.287-.34.575-.604.862-.015.604-.225 1.209-.613 1.813a11.588 11.588 0 0 1-.87 1.934c.005.207-.024.415-.134.625.104.743-.145 1.105-.554 1.288-.11.3-.272.602-.521.9-.012.099-.021.2-.033.297.163.439.19.874-.255 1.312-.358.225-.74.462-1.12.649-.447.22-.861.116-1.237-.02-.66-.238-.61-.469-.525-.694a.805.805 0 0 1-.651-.009c-.16-.1-.261-.204-.42-.308-.143-.257-.193-.491.153-.675.436-.193.732-.335 1.075-.687.119-.267.27-.468.483-.522.207-.485.462-.814.809-.903.254-.601.527-1.265.85-1.84.112-.174.195-.355.142-.553-.006-.163.006-.317.142-.41.077-.064.213-.124.042-.215a1.7 1.7 0 0 1 .204-1.443c.35-.527.74-1.8.37-2.426-.068-.35-.136-.75-.092-1.078-.127-.006-.222.012-.349-.077-.284-.175-.521-.009-.738.308-.157.397-.314.747-.47.747-.149 1.024-.652 1.821-1.176 2.026-.122.47-.199.941-.134 1.412.054.513 0 .862-.237.922-.26.065-.503.216-.654.634a1.28 1.28 0 0 0-.092.42c.361.373.252.838-.095 1.182-.782.77-1.753.658-2.781.355-.744-.293-.924-.604-.85-.92-1.055-.09-.845-.898.03-1.141.938-.264 1.7-.865 2.324-1.724.057-1.019.29-1.712.839-1.822.053-.625.249-1.187.512-1.72.276-.483.444-1.014.347-1.66-.584-.364-.608-.74-.071-1.125.177-.104.157-.21-.063-.317-.355-.035-.31-.376-.287-.696-.015-.166-.1-.252-.258-.255-.788-.115-.592-.438-.254-.788.142-.16.237-.396.089-.491-.122-.077-.205-.347-.232-.584-.482-.364-.275-.737 0-1.096-.272-.23-.4-.568-.438-.962-.897-.039-1.232-.495-.746-1.159.204-.28.468-.55.788-.808.207-.335.405-.67.308-1.004-.258-.655.565-1.15 1.27-1.659a1.1 1.1 0 0 1-.154-.512c-.397-.383-.296-.738.142-1.076a1.33 1.33 0 0 1-.162-.521c-.987.196-.98-.394-.522-1.342-.571-.329-.411-.912.625-1.8.015-.205.054-.362.113-.472a2.395 2.395 0 0 0-1.25.38c-.394.257-.785.225-1.18.062-.12-.196-.307-.362-.52-.513-.27-.237-.332-.503-.276-.788-1.161.066-1.383-.793-.687-1.3.388-.308.672-.63.779-.983.314-.797.98-1.34 1.63-1.896 0-.228.05-.456.12-.687-.287-.193-.589-.332-.92-.359a1.47 1.47 0 0 0-.717-.796c-.217-.13-.288-.252-.154-.545-.617-.551-.463-.886-.306-1.203z'/%3e%3cg fill='%23f7db17'%3e%3cpath d='M655.548 152.429c-.068.005-.139.011-.219.008-.299.305-.657.61-.99.871-.286-.332-.713.033-.295.234l-.214.148c-.136.362-.26.516-.663.578-.062.009-.125.02-.187.035a3.69 3.69 0 0 1 .018-.447c.018-.18.047-.355.086-.527.006-.033.015-.062-.047-.077s-.072.018-.077.05a5.446 5.446 0 0 0-.092.542 3.438 3.438 0 0 0-.018.495c-1.016.326-1.603 1.383-2.296 2.136-.299.257-.45.613-.56.986-.059.198-.08 1.108-.284 1.123-.098.003-.201 0-.31 0-.11-.166-.259-.17-.445-.012-.424-.01-.874-.012-1.25.047-.258.279.45.175.826.406.172.104.246.308.178.592-.347.827-2.28.56-2.923.22-.3-.157-.311-.338-.3-.596a2.7 2.7 0 0 0 .406-.03c.231-.032.46-.1.684-.228.063-.035.128-.07.057-.198s-.137-.092-.199-.056c-.19.11-.385.166-.58.192-.202.03-.41.03-.608.021-.017 0-.035-.003-.05 0-.112-.065-.198-.142-.151-.21.047-.065.234.006.27.017.299-.139.56-.228.882-.29.682-.728 1.375-1.413 2.314-1.789.281-.338.586-.604.953-.847.13-.812.525-1.244 1.114-1.783a2.78 2.78 0 0 1 .32-.868c-.036-.187-.009-.305 0-.495-.225-.426-.358-.796-.18-1.273-.11-.347-.095-.58-.054-.9a.436.436 0 0 0-.003-.181 7.777 7.777 0 0 1 1.06-.717 3.87 3.87 0 0 0 .048 1.004l-.003.003c-.1.11-.187.216-.246.329a.662.662 0 0 0-.092.346c0 .033 0 .065.065.062.066 0 .066-.032.063-.065a.54.54 0 0 1 .077-.281c.053-.098.133-.199.228-.3a.132.132 0 0 0 .023-.032c.311-.009.616-.175.922-.42a7.67 7.67 0 0 0 .823-.821c-.003.444-.006.889-.012 1.333a2.928 2.928 0 0 0-.672.88c-.015.03-.03.056.026.085.06.03.074 0 .086-.03.163-.322.37-.589.61-.81h.012c.065 0 .065-.033.065-.066v-.003a3.963 3.963 0 0 1 1.146-.658c-.056.392-.082.774-.014 1.14.074.404.264.783.649 1.115a.06.06 0 0 0 .023.012z'/%3e%3cpath d='M636.2 141.161c.05-.092.178-.21.22-.201l.023-.006c.14-.261.285-.504.436-.723.195-.284.403-.536.622-.75.023-.023.047-.044.092 0 .044.048.02.069 0 .092-.214.208-.415.45-.608.729-.148.216-.29.453-.426.71.044.06.065.152.041.217.045.406.098.634.279.868a.253.253 0 0 1 .062-.041c.074-.181.175-.341.3-.483.153-.172.34-.317.565-.439a2.24 2.24 0 0 0 .379-.394c.1-.133.18-.27.237-.408.012-.03.024-.06.086-.036.06.024.047.056.035.086a1.99 1.99 0 0 1-.251.438 2.57 2.57 0 0 1-.41.418s-.008.006-.011.006c-.21.115-.391.252-.533.412-.11.121-.196.257-.264.408.095.069.136.255.048.374-.27.388-.59.616-.086.947a.791.791 0 0 0 .237.64c.115.122.103.545-.181.85-.267.27-.062.199.213.231.021.006.042.015.062.021v-.003c.101-.195.22-.37.35-.533.127-.16.267-.311.409-.453.198-.196.355-.409.468-.625.11-.21.174-.427.186-.634.003-.033.003-.065.071-.06.066.004.063.036.06.069a1.763 1.763 0 0 1-.202.687 2.64 2.64 0 0 1-.491.655c-.14.139-.273.281-.397.441a3.249 3.249 0 0 0-.335.512c.332.202.225.563.275.895a.584.584 0 0 1 .172.047c.003-.006.006-.012.012-.017l.196-.308.308-.49c.017-.026.035-.056.088-.02.057.036.039.062.021.089l-.308.489-.195.308c-.003.006-.006.012-.01.014.205.166.22.468-.032.7-.494.373-.355.488.107.784.06.436.062.785-.033 1.156.003.009.003.02.006.032.012.122.02.246.03.368l.03.37c.002.032.005.065-.06.07s-.068-.026-.07-.058l-.03-.37a.77.77 0 0 1-.006-.095c-.024.056-.048.115-.077.177-.332.726-.676 1.318-.75 2.133-.797.19-.678.974-.723 1.668-.628.847-1.356 1.525-2.366 1.863-.19.062-.649.174-.693.414-.006.086.308.273.51.163.556-.533.834-.237.195.308-.05.104-.01.22.1.317.578.519 2.009.687 2.66.276.483-.302.735-.634.314-1.093.027-.652.282-1.289.969-1.472.08-.148.056-.424.02-.575-.065-.566.024-1.07.163-1.614.024-.068.074-.125.187-.154.26-.054.761-.809.918-1.535.039-.157.062-.32.092-.482.042-.252.14-.297.267-.149.121-.162.118-.26.192-.447.267-.388.652-.699 1.102-.48a3.795 3.795 0 0 1-.22-1.04 3.39 3.39 0 0 1 .143-1.288c.018-.062.039-.121.136-.106l.388-.922c.13-.308.26-.619.391-.927.012-.03.024-.059.083-.035s.048.056.036.086l-.391.927c-.13.308-.258.613-.388.918.056.041.038.095.02.148-.118.37-.157.78-.127 1.179.03.432.136.85.296 1.19.015.033.033.066.027.098.213.125.21.154.201.439-.006.222.024.441.077.708.424.782-.017 2.09-.43 2.745a1.357 1.357 0 0 0-.168 1.043c.255.246.089.5-.136.673-.018.059 0 .127.003.186.023.255-.068.468-.202.678-.346.625-.613 1.292-.891 1.946-.504.14-.607.433-.809.904-.293.083-.323.169-.447.438-.338.34-.66.545-1.093.74-.358.164-.012.32.24.492.228.17.527-.198.714-.476.204-.308.411-.217.278.023a2.432 2.432 0 0 0-.27.841c-.076.214.735.377.874.383.495.023 1.117-.46 1.505-.705.323-.33.273-.616.13-1.016l.003-.027a2.463 2.463 0 0 1-.595-.06 4.29 4.29 0 0 1-.699-.23c-.03-.012-.06-.024-.036-.086.024-.06.057-.048.086-.036.231.095.454.175.679.222.186.042.379.063.583.057l.033-.311c.257-.317.435-.628.574-1.007.548-.258.551-.525.477-1.111.122-.237.148-.376.14-.646.36-.643.657-1.3.903-1.996.432-.575.64-1.117.59-1.801.038-.267.136-.418.331-.409.142-.198.27-.403.385-.63a.575.575 0 0 0 .071.005.083.083 0 0 1 0-.047c.036-.157.077-.297.13-.412a.997.997 0 0 1 .178-.281c.08-.196.11-.385.09-.57a1.379 1.379 0 0 0-.193-.553.615.615 0 0 1-.146-.231c-.026-.092-.008-.184.083-.276.024-.023.048-.044.092 0 .045.048.024.072 0 .092-.053.05-.062.098-.047.145a.57.57 0 0 0 .121.187l.006.012c.116.198.193.403.213.613s-.008.427-.103.643c0 .003-.012.018-.012.02a.902.902 0 0 0-.163.252 2.11 2.11 0 0 0-.121.385c-.003.01-.003.018-.006.024.305 0 .574-.095.868-.24l.017-.018a1.8 1.8 0 0 0 .436-.536 2.36 2.36 0 0 0 .249-.72c.005-.032.011-.062.077-.053.062.012.056.045.053.074a2.527 2.527 0 0 1-.264.761c-.1.187-.219.338-.337.457.473.142.885.003 1.335-.137-.065-.634-.056-1.116.012-1.496.074-.411.214-.702.388-.92.021-.027.039-.051.092-.013.05.042.033.066.012.092-.163.205-.293.477-.361.865-.066.362-.077.824-.015 1.434.006-.003.015-.003.023-.006.19.323.29.557.679.305.142-.095.29-.19.409-.314.044-.047.03-.074.065-.113.37-.394.743-.76 1.113-1.087.374-.328.747-.61 1.12-.838.027-.018.056-.035.089.02s.006.072-.02.09a8.062 8.062 0 0 0-1.103.823c-.317.279-.634.587-.95.918.017.057.026.154.035.303.033.438.113.702.738.462a3.18 3.18 0 0 0 .708-.341c.157-.095.29-.175.382-.196.204-.16.405-.31.61-.447.198-.133.4-.255.598-.361a3.63 3.63 0 0 1 .163-.69c.193-.569.515-1.096.921-1.594l.021-.018c.338-.183.613-.4.832-.645a2.86 2.86 0 0 0 .513-.82c.012-.03.023-.06.086-.036.059.023.047.056.035.085a3.07 3.07 0 0 1-.533.857c-.228.254-.51.48-.859.669-.394.486-.708.995-.892 1.543a3.328 3.328 0 0 0-.145.593c.012.003.024.014.036.038.03.06 0 .074-.027.086a.097.097 0 0 0-.026.015c-.039.32-.03.657.03 1.007.275-.009.553-.163.834-.391.3-.243.605-.578.907-.918.003-.01.003-.015.012-.021.074-.243.169-.456.293-.628a1.18 1.18 0 0 1 .498-.409c.03-.012.059-.026.085.036.024.059-.003.07-.035.086a1.078 1.078 0 0 0-.444.364c-.119.166-.21.373-.282.61l-.012 1.386c.015-.011.033-.023.048-.038.34-.264.731-.46 1.155-.613.044-.018.095.023.086.07-.065.416-.1.827-.033 1.206.065.356.225.688.545.984a3.475 3.475 0 0 1 .584-.77c.003-.006.006-.012.015-.015a5.07 5.07 0 0 1 .376-.34c.095-.087.19-.176.281-.264.095-.086.19-.175.285-.264.023-.024.047-.044.091.003s.021.071-.003.092c-.094.089-.19.174-.284.263-.095.086-.19.175-.284.264l-.003.003a3.89 3.89 0 0 0-.35.314c.003.121.01.24.015.361.003.065.003.13.006.196.272.074.435.077.714.07.092.549.139.635.616.647a4.055 4.055 0 0 1 .018-.572 2.5 2.5 0 0 1 .142-.616c.012-.03.024-.06.083-.039.062.024.05.054.038.083-.07.184-.112.38-.136.584-.02.18-.024.367-.018.56h.039c.19.39.414.583.817.758.113-.178.196-.356.25-.533a1.71 1.71 0 0 0 .07-.596c-.003-.032-.003-.065.06-.068.065-.003.068.027.07.06.015.213-.011.426-.077.64s-.168.423-.31.633c-.012.018-.024.036-.045.036.018.228.056.397.136.568.06-.127.122-.254.193-.373.098-.172.21-.326.346-.462.024-.024.045-.044.092 0 .045.044.024.068 0 .092a2.09 2.09 0 0 0-.326.435 4.979 4.979 0 0 0-.228.453c.045.078.101.155.166.243-.758 1.3-1.57 3.102-3.066 3.694-.773.305-1.11.7-1.264 1.525-.29.226-.498.454-.687.768-.504.168-.954.42-1.5.397 0 .352.116.506.469.509.672-.338.823-.4.882-.352.083.07-.094.553-.651.944-.086.054-.083.086-.033.175.471.738 1.706.474 2.37.3.474-.125 1.33-.688 1.567-1.162.092-.219-.116-.5-.323-.731-.948.145-.767-.765.047-.385.276-.083.311-.086.388-.391.726-.282 1.028-.587 1.194-1.366.732-.788 1.466-1.6 1.993-2.544.146-.178.231-.492.19-.655.13-.154.201-.35.249-.527.047-.19.077-.376.07-.566 0-.032-.002-.065.063-.068s.065.03.068.062a2.2 2.2 0 0 1-.074.601 5.599 5.599 0 0 1-.15.463c.046.118.07.198.174.168.634-.51 1.274-.868 1.958-1.291.047-.29.234-.433.521-.444.116.003.157-.033.199-.14.16-.4-.042-.675-.234-1.007-.178-.494.139-.613.456-.85.331-.246.308-.897.32-1.273h.003c-.012-.063-.024-.128-.039-.193a3.279 3.279 0 0 0-.113-.4c-.011-.03-.02-.062.039-.083.062-.02.071.01.083.042.05.145.089.281.118.414.012.054.021.107.033.157.317-.163.649-.352.773-.705.11-.39-.104-.76-.293-1.093a11.957 11.957 0 0 1-.743.32c-.03.012-.06.024-.084-.035s.006-.074.036-.083a12.774 12.774 0 0 0 .859-.38c.142-.094.287-.195.39-.328.229-.329-.384-.625-.597-.758 0-.01.003-.018.003-.027-.308-.281-.614-.566-.922-.847-.023-.02-.047-.045-.003-.092s.069-.027.092-.003l.853.782c.048-.483.054-.945-.097-1.425-.048-.154-.104-.305-.157-.456a1.395 1.395 0 0 1-.598-.498 1.296 1.296 0 0 1-.2-.619c-.002-.032-.002-.065.063-.07.065-.004.065.029.071.062.015.201.065.39.175.556.11.17.275.317.515.439.258.133.8.065 1.114-.086.435-.246-.133-.744-.267-1.037-.094-.21-.118-.426-.16-.651.039-.006.077-.015.119-.021a1.304 1.304 0 0 0-.175-.184.752.752 0 0 0-.234-.142c-.03-.012-.062-.02-.038-.083.02-.062.053-.05.083-.038.097.035.19.091.275.165.083.072.16.157.234.258a1.89 1.89 0 0 0 .127-.024c.43-.085.667-.325.927-.633a4.495 4.495 0 0 0-.467-.483 12.61 12.61 0 0 0-.534-.45c-.023-.021-.05-.042-.009-.092s.066-.03.092-.01c.184.149.368.3.54.457.174.16.34.329.491.512.015.018.03.036.018.06.394.035.459-.045.657-.397a1.892 1.892 0 0 0-.237-.513 3.126 3.126 0 0 0-.394-.483c-.023-.023-.044-.047 0-.091.048-.045.072-.021.092 0 .154.16.297.328.41.503a1.9 1.9 0 0 1 .25.542c.184.003.383.012.54-.083.344-.204.053-.939-.036-1.223a.052.052 0 0 0 .015-.012 3.452 3.452 0 0 0-.136-.086c-.08-.05-.163-.1-.243-.154-.027-.018-.053-.035-.02-.089.035-.056.062-.038.088-.02l.243.154.178.112.08-.062c.252-.201.34-.468.417-.746.119-.427.143-.237.64-.311.536-.083.827-.143 1.144-.77.165-.083.251-.155.28-.359.054-.37.025-.56-.399-.592-.592-.048-.954.07-1.354.462.054.08.107.163.16.243.018.026.036.053-.017.091-.054.036-.071.01-.09-.017l-.15-.231c-.54-.054-.972.032-1.475.222l-.151-.062c.106.142.19.278.251.411.086.19.13.37.137.542 0 .033.003.065-.063.068s-.065-.03-.068-.062c-.006-.157-.044-.32-.124-.494s-.202-.359-.373-.554l-.003-.003c-.421-.151-.806-.228-1.2-.22.065.066.133.13.198.193.086.083.172.166.255.249.024.024.048.044 0 .092-.044.047-.068.023-.092 0a20.421 20.421 0 0 1-.254-.25 20.421 20.421 0 0 1-.255-.248c-.009-.009-.018-.018-.024-.027a3.445 3.445 0 0 0-1.063.276c-.24.1-.486.178-.726.222.178.172.329.364.447.584.125.225.22.473.282.749.006.033.015.062-.048.077s-.07-.018-.077-.047c-.059-.264-.15-.504-.27-.717s-.266-.403-.44-.569c-.018-.015-.033-.033-.027-.056a2.225 2.225 0 0 1-.658.003l.264.435c.015.03.027.06-.03.086-.059.027-.074 0-.086-.03l-.242-.509a1.807 1.807 0 0 1-.593-.234c.062.234.11.486.145.752.048.353.077.729.086 1.126 0 .032.003.065-.062.065s-.065-.033-.065-.062a9.81 9.81 0 0 0-.083-1.11 5.874 5.874 0 0 0-.187-.89 2.077 2.077 0 0 1-.266-.248 2.624 2.624 0 0 0-.711-.554 1.186 1.186 0 0 1-.26.91c-.022.026-.04.05-.093.011-.05-.041-.032-.065-.012-.092a1.058 1.058 0 0 0 .22-.9c-.406-.187-.853-.279-1.316-.317a6.64 6.64 0 0 1 .687 1.09c.184.15.282.334.338.536.054.198.066.412.074.628 0 .032.003.065-.062.068s-.065-.03-.068-.062a2.608 2.608 0 0 0-.068-.599.893.893 0 0 0-.302-.476c-.003-.003-.018-.018-.018-.021-.1-.202-.213-.4-.335-.596a5.762 5.762 0 0 0-.411-.568l-.006-.006a6.246 6.246 0 0 0-.471-.009c.026.036.053.071.077.11a.721.721 0 0 1 .106.308c.003.032.006.065-.059.07s-.068-.026-.07-.059a.623.623 0 0 0-.09-.254.843.843 0 0 0-.139-.172c-.326.009-.649.035-.96.062.326.418.587.85.788 1.295a6.01 6.01 0 0 1 .462 1.53c.006.033.012.066-.053.075-.062.012-.068-.02-.074-.053a5.99 5.99 0 0 0-.453-1.5 6.4 6.4 0 0 0-.827-1.335l-.047.003a4.295 4.295 0 0 0-.75.145c.11.068.205.136.288.204.112.092.201.184.278.276.021.027.042.05-.009.092s-.07.018-.091-.01a1.966 1.966 0 0 0-.261-.26 3.003 3.003 0 0 0-.373-.255 5.97 5.97 0 0 0-.385.14c-.071.026-.14.053-.21.074.219.157.429.329.63.521.243.234.471.498.676.803.017.026.035.053-.018.089s-.071.008-.092-.018a4.744 4.744 0 0 0-.655-.782 5.859 5.859 0 0 0-.705-.572c-.266.06-.536.074-.805.065.166.33.31.66.42.996.119.361.202.725.228 1.096.003.032.006.065-.059.07s-.068-.026-.07-.059a4.47 4.47 0 0 0-.223-1.066 7.779 7.779 0 0 0-.447-1.043 8.492 8.492 0 0 1-.495-.053c.095.302.178.613.249.93.083.373.15.756.201 1.144.003.032.006.065-.056.074-.065.008-.068-.024-.074-.057a11.558 11.558 0 0 0-.199-1.131 11.598 11.598 0 0 0-.275-1.013c-.468-.507-.986-1.001-1.62-1.265a2.13 2.13 0 0 1 .468 1.404c0 .033-.003.065-.065.062-.066 0-.066-.035-.063-.065a2.041 2.041 0 0 0-.15-.835 2.094 2.094 0 0 0-.439-.658 2.44 2.44 0 0 0-.447-.089 19.527 19.527 0 0 0-1.25-.083c.32.29.571.557.548.88-.003.033-.006.065-.071.06s-.063-.04-.06-.072c.021-.299-.275-.568-.622-.876-.248-.01-.5-.012-.75-.015.137.139.256.278.35.417.13.19.223.38.267.57v.008c.027.293.098.55.228.764.127.21.311.373.563.489.03.015.06.027.032.086s-.056.047-.085.032a1.368 1.368 0 0 1-.62-.539 1.88 1.88 0 0 1-.245-.811 1.568 1.568 0 0 0-.246-.522 3.344 3.344 0 0 0-.43-.494c-.278 0-.554-.003-.832-.003.116.329.196.666.252 1.01.065.42.095.85.103 1.285 0 .033 0 .065-.065.065s-.065-.032-.065-.062a8.927 8.927 0 0 0-.1-1.267 5.592 5.592 0 0 0-.261-1.031h-.077a1.253 1.253 0 0 0-.61-.548.754.754 0 0 1-.133.352c-.018.027-.04.054-.093.018s-.035-.062-.017-.089a.618.618 0 0 0 .112-.338c-.041-.017-.086-.035-.133-.056-.133-.557-.258-.788-.702-.977a2.966 2.966 0 0 1-.042.477c-.035.201-.1.405-.222.6-.017.028-.035.057-.089.022-.056-.036-.038-.063-.02-.09a1.52 1.52 0 0 0 .204-.553c.03-.169.039-.34.039-.507l-.077-.026c-.119-.78-.261-1.215-1.07-1.523.01.101.012.205.006.308a1.704 1.704 0 0 1-.112.536c-.012.03-.024.063-.083.039s-.048-.053-.039-.083c.065-.169.095-.335.104-.498a2.375 2.375 0 0 0-.024-.459c-.172-.195-.417-.382-.628-.59.006.288-.032.572-.112.86a3.825 3.825 0 0 1-.483 1.042c-.018.027-.036.057-.089.021-.056-.035-.038-.062-.02-.089.216-.334.373-.672.467-1.007.092-.32.125-.643.101-.965a1.282 1.282 0 0 1-.222-.326.58.58 0 0 1-.018.041l-.095.214c-.014.03-.026.059-.086.035-.059-.027-.047-.056-.035-.086.032-.07.062-.142.095-.213.023-.056.05-.116.074-.172a1.17 1.17 0 0 1-.015-.11c-.027-.248-.16-.44-.34-.604l-.004-.003a1.887 1.887 0 0 1-.089.234c-.056.122-.13.24-.225.362-.02.026-.038.05-.091.012-.05-.042-.03-.066-.012-.092.089-.113.157-.225.21-.335.044-.095.077-.19.1-.287a1.202 1.202 0 0 1-.189-.308.995.995 0 0 1-.124.213 1.454 1.454 0 0 1-.243.246c-.024.02-.05.041-.092-.01s-.015-.07.009-.091c.092-.074.163-.148.22-.222s.094-.145.12-.22c.042-.115.057-.04.018-.227.068-.368-.068-.587-.263-.892a.089.089 0 0 1 .012-.024 1.114 1.114 0 0 0-.394.104 3.58 3.58 0 0 0-.57.332c-.026.018-.052.035-.088-.018-.039-.053-.012-.071.018-.089.21-.142.409-.26.59-.34.183-.08.352-.125.497-.116a.462.462 0 0 0 .015-.284c-.593.219-1.06.322-1.437.346a2.05 2.05 0 0 1-.948-.145c-.03-.015-.059-.027-.032-.086.023-.06.056-.047.086-.035.234.1.515.16.888.136.37-.024.827-.125 1.413-.344l-.006-.018a4.24 4.24 0 0 0 .252-.699c-.21.057-.418.054-.625.048h-.042c-.032 0-.065-.003-.065-.065 0-.065.036-.065.065-.065h.042c.22.002.438.008.654-.063a6.26 6.26 0 0 0 .039-.23c.033-.258.335-.32.548-.09.178.19.34.391.515.474.356.17.756.018 1.043-.213l-.264-.086c-.032-.009-.062-.02-.041-.08.02-.062.05-.053.08-.041.112.035.225.07.338.11l.077-.08c.734.062 1.211-.092 1.682-.566a8.657 8.657 0 0 1-1.114-.039c-.355-.041-.648-.112-.865-.22-.03-.014-.059-.029-.03-.085.03-.06.06-.044.087-.03.201.101.482.17.823.208.347.038.755.05 1.22.035h.006c.042-.047.083-.097.128-.15.201-.084.403-.176.55-.341-.855-.092-1.67-.261-2.437-.661-.199-.222-.513-.347-.847-.432-.622-.077-1.173.077-1.68.34-.133-.124-.237-.237-.367-.358-.195-.024-.38-.128-.575-.151-.26-.03-.533.02-.793-.01-.033-.002-.066-.005-.057-.07.006-.065.039-.062.071-.057.261.03.534-.02.794.01.252.029.492.139.744.168.84-.317 1.537-.491 2.138-.465a7.1 7.1 0 0 1 2.16-.272.192.192 0 0 1-.027-.024c-.086-.086-.045-.13 0-.172.394-.4.486-.767.358-1.099-.13-.343-.485-.666-.98-.962-.527.059-1.034-.083-1.594-.021-.35.038-.693.115-1.03.228.28.1.527.267.728.504.249.293.427.693.521 1.196.012.06.021.122-.097.142-.119.024-.13-.038-.142-.097-.086-.46-.246-.82-.468-1.085-.234-.334-.77-.465-.94-.533-.56.057-1.11.119-1.59.243-.361.092-.678.22-.921.409.361-.077.737-.062 1.063.1.311.155.575.445.74.916.021.056.04.115-.076.154s-.137-.018-.154-.077c-.14-.406-.359-.649-.616-.776-.513-.255-1.57-.033-2.018.3-.26.195-.52.446-.779.74-.047.056-.097.11-.207.014-.11-.097-.062-.15-.012-.204.27-.305.542-.575.824-.782.272-.201.554-.347.844-.415.296-.328.734-.527 1.24-.657.496-.128 1.061-.193 1.636-.249-.169-.34-.385-.545-.634-.655-.267-.118-.572-.136-.903-.103-.69.237-1.304.607-1.893 1.025.053 0 .107 0 .157.003.175.011.332-.015.477.041.056.02.115.041.074.157-.05.14-.433.053-.566.044a1.69 1.69 0 0 0-.5.048c-.027.006-.057.015-.083.006-.72.444-1.236.894-1.834 1.4l-.1.036c-.534-.02-.901.054-1.12.22-.199.15-.214.388-.175.707-.092.3-.207.628-.237.978-.625.536-1.321 1.072-1.644 1.854-.071.228-.192.43-.343.61.127.021.23.06.31.122.03.023.057.047.08.077a2.88 2.88 0 0 1 .069-.394c.044-.184.11-.353.195-.489.018-.027.036-.053.089-.018.056.036.038.062.02.09-.08.12-.139.278-.18.45-.05.204-.077.429-.083.636-.003.065-.121.071-.13.006a.358.358 0 0 0-.14-.252.65.65 0 0 0-.337-.106 3.93 3.93 0 0 1-.436.397c-.124.1-.242.21-.27.373-.017.284.333.335.664.355.756.045.154.474.57.85.2.14.387.303.53.501.287.104.464.08.66-.009.038-.512-.006-.773.219-.773h.024a.96.96 0 0 1 .053-.195c.039-.095.095-.193.172-.288.02-.024.041-.05.092-.009s.03.065.009.092a1.009 1.009 0 0 0-.152.255.937.937 0 0 0-.053.213c.039.077.03.228.027.498.43-.21.82-.264 1.259-.285.82-.96 1.17-.716.45-.017l-.116.219c-.124.24-.204.426-.23.752-.21.184-1.242 1.03-.857 1.345.27-.039.439-.027.335.175-.127.27-.512.829-.385 1.137.047.113.213.1.376.062l.036-.032c.27-.22.554-.471.82-.764a4.75 4.75 0 0 0 .708-.993c.027-.053.053-.103.13-.086.08-.296.175-.59.282-.885.11-.305.234-.613.367-.922a.066.066 0 0 1 .113-.011c.112.163.222.281.331.358.098.071.196.104.29.104s.193-.033.291-.098a1.4 1.4 0 0 0 .323-.34c.018-.027.038-.054.092-.015s.035.062.014.091c-.118.166-.234.288-.355.37s-.24.125-.364.122a.63.63 0 0 1-.365-.13 1.417 1.417 0 0 1-.296-.3c-.115.27-.222.54-.32.81-.11.298-.204.6-.287.9.068.056.038.11.012.163a5.17 5.17 0 0 1-.753 1.051 7.307 7.307 0 0 1-.699.667c.033.219.09.426.19.64.447-.386.865-.777 1.232-1.18a7.47 7.47 0 0 0 .94-1.258c.017-.027.032-.057.088-.024s.039.062.024.089c-.13.225-.279.444-.439.66.03.045.006.062-.017.083-.048.039-.075.193-.086.391-.018.27 0 .604.03.844.002.033.008.066-.057.074s-.068-.023-.074-.056c-.033-.252-.047-.595-.033-.868.003-.07.012-.136.021-.195a15.78 15.78 0 0 1-.302.346c-.373.412-.8.809-1.256 1.2l-.012.009a.883.883 0 0 0 .042.07c-.397.288-.72.389-.276.774l.445-.32.473-.34c.027-.018.054-.039.092.014s.012.071-.015.092l-.476.34-.46.33a.778.778 0 0 0 .113.453.66.66 0 0 1 .098-.01l.995-.722c.027-.02.053-.038.092.015s.012.071-.015.092c-.32.234-.643.468-.966.702a.892.892 0 0 1-.115.148c-.326.234-1.463.936-1.342 1.422v.003c.273-.077.545-.172.806-.306.27-.139.533-.325.782-.58.023-.024.044-.044.092 0 .044.044.023.068 0 .092-.258.263-.53.453-.812.601v.012c-.003.044-.003.089-.006.133s-.003.089-.006.133c-.003.033-.003.066-.068.063s-.062-.036-.062-.068c.003-.045.003-.09.006-.134.003-.023.003-.05.003-.074a4.526 4.526 0 0 1-.702.252c.097.46-.143.853-.388 1.247-.14.113-1.277 1.034-.803 1.31.127.061.27.091.412.106z'/%3e%3cpath d='M636.716 125.14c-.237-.143-.542-.318-.838-.377a1.801 1.801 0 0 0-.631-.702c-.22-.142-.22-.13-.137-.287.25-.027.353-.095.356-.163.13.003.243.02.338.053a.51.51 0 0 1 .251.175c.021.027.039.053.092.012.053-.039.033-.065.012-.092a.678.678 0 0 0-.314-.22 1.279 1.279 0 0 0-.462-.058c-.015 0-.027 0-.039.006a.929.929 0 0 0-.414-.069c-.17-.16-.311-.346-.243-.577.009.009.024.012.038.015.134.038.258.077.365.127.103.045.19.1.248.166.021.024.045.047.092.003s.027-.068.006-.092a.93.93 0 0 0-.29-.198 2.228 2.228 0 0 0-.281-.104c.977-.198 1.85-.184 2.725.335.459.19.675.408.924.746l-.249.21c-.572-.014-.992.066-1.256.267-.237.178-.284.498-.293.817z'/%3e%3c/g%3e%3cpath d='M656.147 152.189c-.193.118-.35.201-.548.234a.09.09 0 0 0 .023-.024c.128-.24.276-.45.442-.64l.065-.074.009.237.009.27zm2.449 5.242c-.13.196-.29.374-.47.536-.178.16-.38.312-.596.454-.027.017-.056.035-.092-.018s-.009-.071.018-.089a5.08 5.08 0 0 0 .58-.441 2.55 2.55 0 0 0 .45-.513c.018-.026.036-.053.092-.017.054.035.036.062.018.088zm1.62-1.931-.245.376c-.018.027-.036.054-.092.018-.054-.035-.036-.062-.018-.089.083-.124.163-.252.246-.376.018-.027.035-.053.092-.018.053.036.035.062.017.092zm-.882-.124c-.042.186-.11.364-.228.527s-.294.308-.545.424c-.03.014-.06.026-.086-.033s.003-.074.032-.086c.231-.107.388-.237.495-.382a1.2 1.2 0 0 0 .207-.48c.006-.032.015-.062.077-.047s.057.044.048.077zm1.587-1.937a1.149 1.149 0 0 0-.171.222 1.437 1.437 0 0 0-.125.272c-.012.03-.02.062-.083.042s-.053-.054-.041-.083a1.42 1.42 0 0 1 .326-.542c.023-.024.044-.045.091 0 .045.044.024.068 0 .092zm1.298.127c-.056.184-.11.37-.178.554a3.53 3.53 0 0 1-.258.563c-.017.026-.032.056-.088.023s-.042-.062-.024-.089c.104-.18.18-.36.249-.539.065-.18.118-.364.174-.548.01-.032.018-.062.08-.044s.054.047.045.08zm-.589-7.592c.402.593.491 1.203.506 1.816a9.11 9.11 0 0 1 .157-.67l.009-.02c.169-.237.275-.474.329-.708s.053-.471.011-.705c-.006-.033-.011-.062.054-.074.062-.012.07.02.077.053.044.252.044.507-.012.758a2.098 2.098 0 0 1-.34.747c-.11.412-.19.826-.267 1.241l-.015.077c-.012.062-.13.053-.13-.012 0-.047 0-.092.002-.139.01-.773.018-1.55-.482-2.284-.018-.026-.039-.053.017-.092.054-.035.074-.008.092.018zm-.987 1.271c-.006.05-.009.1-.015.148-.003.05-.009.1-.012.151-.003.033-.006.065-.07.06s-.063-.04-.06-.072c.003-.05.009-.1.012-.148.003-.05.009-.1.015-.15.003-.033.006-.066.07-.06s.063.038.06.071zm-.275 1.724c.1.329.177.663.234 1.007.038.234.062.47.074.714.026-.045.056-.086.088-.128a1.5 1.5 0 0 1 .418-.346c.027-.018.056-.033.089.024s.006.074-.024.088a1.31 1.31 0 0 0-.379.317.88.88 0 0 0-.184.403c-.011.065-.13.054-.13-.012.003-.355-.027-.702-.08-1.04s-.13-.666-.228-.989c-.009-.032-.02-.062.042-.08s.07.012.08.042zm1.374.616a4.436 4.436 0 0 1 .08 1.487c-.003.032-.009.065-.074.056s-.06-.041-.056-.074c.026-.222.035-.453.023-.696a4.503 4.503 0 0 0-.1-.746c-.006-.033-.015-.063.05-.077.062-.015.071.017.077.05zm1.178-.219c.045.243.069.48.057.708-.012.23-.056.45-.151.663-.08.243-.086.486-.044.729.041.249.136.497.248.75.015.029.027.058-.032.085s-.074-.003-.086-.032a3.173 3.173 0 0 1-.26-.78 1.622 1.622 0 0 1 .05-.796l.003-.006a1.7 1.7 0 0 0 .139-.62 2.812 2.812 0 0 0-.056-.678c-.006-.032-.012-.062.053-.074s.07.021.077.054zm.57-1.956c-.03.122-.06.247-.092.371-.03.122-.06.246-.092.37-.006.033-.015.063-.077.048s-.056-.048-.048-.08c.03-.122.06-.246.092-.37.03-.122.06-.246.092-.37.009-.033.015-.063.08-.048.062.015.056.047.047.08zm-.584-3.246c.036.113.068.226.104.338.009.033.017.062-.045.08-.062.02-.07-.012-.08-.041l-.103-.338c-.012-.033-.021-.062.041-.08s.071.012.08.041zm.299-2.467c.003.154.003.308-.009.969a.967.967 0 0 0-.293.477 1.7 1.7 0 0 0-.009.731c.006.033.012.065-.053.077s-.071-.02-.077-.053a1.778 1.778 0 0 1 .012-.788c.059-.222.174-.4.331-.54l-.026-.41c-.003-.155-.003-.309-.006-.46 0-.033 0-.065.065-.065s.065.032.065.065zm-2.449-.859c.379.249.705.524.93.85.228.329.358.705.343 1.15a.067.067 0 0 1-.092.056l-.642-.276c.142.921.106 1.656-.095 2.219a2.003 2.003 0 0 1-1.17 1.232.064.064 0 0 1-.086-.08c.11-.35.175-.699.201-1.048s.012-.7-.047-1.046c-.006-.033-.012-.065.053-.074.065-.012.071.02.074.053.06.359.077.72.048 1.078a4.8 4.8 0 0 1-.166.942c.459-.225.785-.586.968-1.099.202-.565.232-1.318.072-2.271-.01-.05.044-.092.088-.072l.661.285a1.718 1.718 0 0 0-.32-.975c-.216-.31-.527-.574-.894-.814-.027-.018-.054-.036-.018-.092.035-.053.062-.036.089-.018zm6.412-1.262-.053.128c-.018.042-.033.086-.05.127-.012.03-.024.06-.083.036s-.048-.054-.036-.083l.054-.128c.018-.042.032-.086.05-.127.012-.03.024-.06.083-.036s.047.054.035.083zm-1.508-.032c.125.05.226.118.309.201.083.08.145.175.198.279.015.03.03.059-.026.085-.06.03-.075 0-.086-.026-.048-.092-.104-.175-.175-.246s-.157-.13-.267-.172c-.03-.012-.059-.024-.035-.083s.053-.047.083-.035zm-2.239.642a1.4 1.4 0 0 1 .326.631c.056.234.065.495.036.773-.003.033-.006.066-.071.06s-.063-.039-.057-.071a2.193 2.193 0 0 0-.032-.732 1.292 1.292 0 0 0-.296-.572c-.021-.023-.045-.047.006-.091.047-.045.07-.018.091.005zm-7.568.729-.026.255a8.156 8.156 0 0 0-.024.255c-.003.032-.006.065-.071.059s-.062-.039-.056-.071c.009-.086.017-.172.023-.255l.027-.255c.003-.032.006-.065.071-.059s.062.039.06.071zm1.404-.74c.036.121.072.243.11.364l.033.11c.008.032.017.062-.045.08s-.07-.012-.08-.045l-.032-.11c-.036-.12-.071-.242-.11-.364-.009-.03-.018-.062.044-.08s.072.012.08.045zm2.88 1.934a.757.757 0 0 1 .026.157 1.37 1.37 0 0 1 0 .157c-.003.032-.006.065-.07.059s-.063-.038-.06-.071a1.046 1.046 0 0 0 0-.136.69.69 0 0 0-.024-.137c-.009-.032-.018-.062.045-.08s.07.015.08.048zm.992-2.192a.42.42 0 0 1 .118.195.292.292 0 0 1-.03.21c-.014.03-.032.06-.088.027-.056-.03-.042-.059-.027-.088.02-.042.027-.08.018-.122s-.039-.089-.083-.136c-.024-.024-.044-.045 0-.092.044-.044.068-.024.092 0zm-6.872.346c0 .155.024.303.074.439.05.14.13.27.243.39.15.173.228.341.27.513.04.17.044.335.053.498 0 .032.003.065-.063.068s-.065-.03-.068-.062c-.006-.16-.011-.32-.047-.474a1.076 1.076 0 0 0-.24-.46 1.318 1.318 0 0 1-.27-.432 1.407 1.407 0 0 1-.082-.485c0-.033 0-.066.065-.066s.065.033.065.066zm2.781 1.872c.154.288.24.57.273.854.035.28.018.568-.033.867a1.46 1.46 0 0 0 .208 1.002c.174.296.45.577.805.838a3.573 3.573 0 0 1-.16-1.123c.018-.426.148-.838.447-1.226.128-.166.214-.338.273-.512.062-.175.095-.353.118-.525.003-.032.01-.065.072-.056.065.006.059.038.056.071-.024.184-.06.367-.122.551s-.157.37-.293.548a1.984 1.984 0 0 0-.42 1.152c-.018.406.07.827.207 1.26.018.055-.05.103-.098.073-.447-.302-.788-.634-.998-.986-.204-.347-.287-.711-.222-1.087.047-.288.062-.563.03-.833s-.113-.533-.258-.805c-.015-.027-.033-.057.026-.086.057-.033.074-.003.09.026zm-1.116 1.71c0 .308-.086.616-.24.924a4.233 4.233 0 0 1-.471.722c.097-.038.198-.077.296-.124a2.867 2.867 0 0 0 .874-.622c.121-.124.243-.27.367-.441.018-.027.038-.054.092-.015s.032.065.015.092a4.485 4.485 0 0 1-.38.456 3.101 3.101 0 0 1-.337.302 30.597 30.597 0 0 1 .086.427c.006.032.014.062-.05.077-.063.014-.072-.018-.078-.05l-.047-.229c-.009-.047-.018-.095-.03-.142-.154.11-.31.192-.462.264-.177.082-.352.145-.527.21-.056.02-.11-.056-.071-.104.249-.296.459-.59.604-.883.145-.29.228-.577.228-.864 0-.033 0-.066.065-.066s.066.033.066.066zm-1.36-.11v.293c0 .033 0 .065-.065.065s-.065-.032-.065-.065v-.293c0-.033 0-.065.065-.065s.065.032.065.065z'/%3e%3cpath d='M653.709 142.07c.178.436.225.842.157 1.22-.065.38-.246.732-.515 1.064l-.01.009c-.257.222-.45.489-.592.788a3.267 3.267 0 0 0-.228.646c.071-.098.142-.19.228-.276a1.39 1.39 0 0 1 .637-.38 5.94 5.94 0 0 0 .77-.503 5.03 5.03 0 0 0 .676-.63c.02-.024.044-.048.091-.006s.027.065.006.091c-.213.24-.444.454-.693.646s-.512.364-.794.518l-.014.006c-.243.066-.43.19-.587.347s-.281.352-.403.554c-.032.053-.13.018-.118-.045.065-.367.163-.713.31-1.027s.35-.593.623-.827c.255-.314.423-.646.486-1.001s.017-.738-.152-1.15c-.011-.029-.023-.058.036-.085.06-.024.074.006.086.035zm2.763 4.432c-.041.118.045.228.22.453l.118.154c.234.31.32.663.326 1.033.006.362-.062.738-.133 1.102-.012.063-.119.06-.128-.003a2.236 2.236 0 0 0-.482-1.075c-.255-.32-.596-.604-.987-.865-.026-.018-.053-.035-.018-.092.036-.053.063-.035.09-.017.402.27.752.562 1.015.894.202.252.353.524.442.824a4.25 4.25 0 0 0 .074-.765c-.006-.343-.086-.669-.3-.956-.044-.063-.082-.11-.115-.151-.204-.264-.302-.391-.24-.575.012-.03.02-.062.083-.041s.05.053.041.082zm1.179-.078c.048.05.098.101.146.155.047.05.097.1.145.154.023.023.044.047-.003.091s-.071.021-.092-.003c-.048-.05-.098-.1-.145-.154-.048-.05-.098-.1-.145-.154-.021-.023-.045-.047.003-.091s.07-.021.091.002zm1.446.466c-.092.29-.18.577-.27.867-.092.29-.18.578-.272.868-.01.033-.018.062-.08.042-.062-.018-.053-.05-.042-.08.092-.29.181-.578.27-.868.092-.29.18-.578.272-.868.01-.033.018-.062.08-.044.063.02.054.05.042.083zm.817 4.848a.302.302 0 0 0 0 .217c.012.03.024.062-.038.083-.06.023-.071-.006-.083-.039a.433.433 0 0 1 0-.311c.012-.033.024-.062.083-.039.062.024.05.054.038.083zm-.859-1.424c-.038.15-.08.305-.118.456a26.13 26.13 0 0 1-.119.459c-.008.032-.017.062-.08.047-.062-.017-.056-.047-.047-.08l.119-.459c.038-.15.08-.305.118-.456.009-.033.015-.062.08-.047.062.014.056.047.047.08zm-1.238-.006.113.112c.024.024.044.045 0 .092-.048.045-.071.024-.092 0l-.113-.112c-.023-.024-.044-.045 0-.092.048-.045.072-.024.092 0zm-1.454-.696c-.03.086-.06.171-.092.257-.03.086-.06.172-.092.258-.012.03-.02.062-.083.039-.059-.021-.05-.054-.038-.083.03-.086.06-.172.092-.258.03-.086.059-.172.091-.258.012-.032.021-.062.083-.041s.05.053.042.083zm-2.083 2.2a.867.867 0 0 0-.171.279c-.039.1-.06.204-.077.314-.006.032-.012.065-.074.053-.065-.012-.06-.041-.054-.074a1.97 1.97 0 0 1 .086-.338.962.962 0 0 1 .196-.32c.02-.023.044-.047.092-.002s.026.068.003.091zm-5.959 5.838a.829.829 0 0 1-.127.199 1.373 1.373 0 0 1-.199.193c-.024.02-.05.041-.092-.012-.041-.05-.014-.071.01-.092a1.02 1.02 0 0 0 .287-.34c.014-.03.026-.06.085-.036.06.026.045.056.033.086zm.933-.494a.44.44 0 0 1-.127.169.765.765 0 0 1-.202.115c-.032.012-.062.024-.083-.038-.023-.062.01-.074.039-.083.065-.024.121-.056.163-.092s.07-.077.092-.121c.011-.03.026-.06.085-.033s.045.056.033.086zm1.238-.756c-.02.036-.044.072-.077.107s-.077.071-.133.107c-.027.018-.056.035-.089-.02s-.006-.075.024-.09a.476.476 0 0 0 .169-.166c.017-.026.032-.056.088-.02.057.032.039.059.024.089zm1.863-4.845c-.059.174-.1.346-.115.518s-.006.344.03.512c.005.033.014.063-.048.078s-.071-.018-.077-.05c-.041-.184-.05-.371-.033-.555s.06-.367.122-.548c.012-.032.02-.062.083-.041s.05.053.041.083zm1.268-12.894c-.006.145-.044.287-.113.43s-.165.28-.293.42c-.02.024-.044.048-.092.003s-.026-.068-.003-.092c.119-.13.21-.26.273-.388a.96.96 0 0 0 .098-.379c0-.032.003-.065.068-.062s.062.035.062.068zm-1.294-1.143c.112.195.18.394.219.592.038.196.047.394.035.59 0 .032-.003.065-.068.062s-.062-.036-.062-.068c.012-.187.003-.37-.033-.557-.035-.184-.1-.37-.204-.554-.015-.027-.033-.056.024-.089s.074-.003.089.024zm-1.715 2.126a1.888 1.888 0 0 1-.507-.52.816.816 0 0 1-.118-.546c.006-.032.011-.062.074-.053.065.012.059.041.053.074a.69.69 0 0 0 .1.459c.095.16.252.32.472.483.026.018.053.038.014.092s-.065.032-.091.014zm1.898 3.226v.282c0 .032 0 .065-.065.065s-.065-.033-.065-.066v-.281c0-.033 0-.065.065-.065s.065.032.065.065zm-2.426-2.444c.382.362.61.797.732 1.28.077.3.11.616.116.948.002 0 .008-.003.014-.003.172-.06.305-.213.397-.46.098-.26.148-.621.157-1.08 0-.003.006-.03.01-.033.135-.222.218-.447.275-.67s.083-.45.103-.678c.006-.056.083-.08.119-.032.222.314.417.64.568.99s.252.719.29 1.122c.004.032.007.065-.059.07s-.068-.026-.07-.058a3.631 3.631 0 0 0-.279-1.082 4.834 4.834 0 0 0-.453-.82 3.62 3.62 0 0 1-.09.521c-.055.231-.141.46-.28.69-.01.468-.063.839-.163 1.108-.107.287-.267.465-.477.536-.021.006-.039.012-.057.003-.003.16-.011.323-.023.489-.003.033-.006.065-.071.06s-.063-.04-.06-.072c.045-.539.033-1.051-.085-1.513a2.471 2.471 0 0 0-.697-1.218c-.023-.02-.047-.044-.003-.092s.069-.023.092-.003zm1.422 6.081-.08.513-.08.51c-.003.032-.009.064-.074.053-.062-.01-.06-.042-.053-.074l.08-.51.08-.512c.006-.033.009-.063.074-.054.062.012.06.042.053.074zm-2.731 1.159.071.388c.006.032.012.062-.053.074-.062.012-.071-.021-.077-.054l-.071-.388c-.006-.032-.012-.062.053-.074.062-.012.071.021.074.054zm2.361-3.134a2.838 2.838 0 0 1-.199.746 2.78 2.78 0 0 1-.432.696l-.003.003c-.234.255-.347.519-.382.794s.003.563.08.856c.009.033.015.062-.047.08-.063.015-.072-.015-.08-.047a2.363 2.363 0 0 1-.083-.904c.038-.299.163-.59.414-.865a2.62 2.62 0 0 0 .412-.66c.098-.231.16-.468.19-.714.003-.033.008-.065.07-.056.066.009.06.041.057.074zm-.616-.918c.044.248.006.494-.098.743a2.79 2.79 0 0 1-.483.723l-.006.006c-.222.186-.379.39-.503.601a5.133 5.133 0 0 0-.308.66c-.012.03-.024.06-.086.036-.06-.024-.048-.053-.036-.083.092-.228.187-.456.317-.678s.296-.436.527-.631c.202-.228.359-.456.457-.684.094-.222.13-.448.088-.667-.005-.032-.011-.062.054-.077.062-.012.07.02.077.054zm-3.012 1.43a2.16 2.16 0 0 1-.193 1.298c-.184.373-.477.693-.835.98-.024.02-.05.041-.092-.012-.042-.05-.015-.07.012-.092.343-.275.625-.583.8-.936s.248-.752.18-1.223c-.003-.033-.009-.065.056-.074s.068.024.074.056zm-3.848 2.13c.038.077.074.154.11.23.04.084.08.164.118.247.015.03.026.059-.03.086-.059.026-.074 0-.086-.03-.038-.083-.08-.163-.118-.246-.036-.077-.074-.154-.11-.228-.015-.03-.026-.06.03-.086.06-.026.074 0 .086.03zm-1.526.03c-.003.293.021.583.092.861.074.279.193.548.388.806l.006.012c.098.198.154.397.193.598.026.148.044.297.053.445.187-.199.329-.4.432-.61.119-.243.181-.495.187-.756 0-.032 0-.065.065-.062.065 0 .065.032.062.065a1.96 1.96 0 0 1-.198.809c-.127.26-.314.51-.56.75-.038.038-.107.01-.11-.045-.008-.193-.023-.385-.059-.572s-.089-.373-.177-.56c-.202-.27-.33-.554-.406-.847s-.101-.592-.098-.897c0-.033 0-.066.065-.066s.065.033.065.066zm.208 5.21a3.287 3.287 0 0 1 .225-.957c.012-.03.023-.06.083-.036.062.024.047.054.038.083a3.155 3.155 0 0 0-.216.916c-.003.032-.003.065-.071.059-.065-.003-.062-.036-.06-.068zm-.178 1.451.08-.578c.003-.032.009-.065.074-.056s.06.042.056.074l-.08.578c-.003.032-.009.065-.074.056s-.059-.041-.056-.074zm-.998 2.432c.095-.095.186-.207.272-.332.09-.127.172-.266.255-.412.015-.03.033-.056.089-.026.056.032.041.059.024.089a5.182 5.182 0 0 1-.261.423c-.092.13-.187.249-.29.35-.024.023-.048.044-.092 0s-.021-.068 0-.092zm-1.443-8.16v.24c0 .032 0 .065-.065.065s-.065-.033-.065-.066v-.24c0-.032 0-.065.065-.065s.065.033.065.066zm-2.44 5.621c-.003-.059-.006-.118-.012-.177l-.012-.18c0-.034-.003-.066.062-.07s.068.028.068.063l.012.178c.003.06.006.118.012.178 0 .032.003.065-.062.068s-.068-.027-.068-.063zm6.128-9.999c-.124.43-.222.876-.213 1.259.006.37.11.678.376.85.31.201.447.503.577.796.01.018.015.036.024.054.039-.145.071-.3.086-.453.02-.19.02-.374-.006-.54-.006-.032-.012-.065.053-.077.063-.011.072.021.074.054.03.177.03.376.01.574a3.13 3.13 0 0 1-.14.643c-.018.053-.095.06-.118.009a7.43 7.43 0 0 1-.098-.213c-.122-.276-.249-.56-.53-.74-.308-.2-.43-.546-.439-.957-.006-.397.092-.856.22-1.298.008-.032.017-.062.08-.044s.053.047.044.08zm-.43-1.639c.042.335.03.643-.026.954a5.007 5.007 0 0 1-.29.951 3.01 3.01 0 0 0-.208 1.25c.02.424.13.844.326 1.244.015.03.03.06-.03.086-.059.03-.074 0-.086-.03a3.17 3.17 0 0 1-.124-2.598 4.75 4.75 0 0 0 .281-.926 2.84 2.84 0 0 0 .027-.913c-.003-.032-.009-.065.056-.074.063-.008.069.024.074.057zm-2.846 4.053a.989.989 0 0 0-.074.586c.035.199.121.4.243.601.018.027.032.057-.02.09-.057.032-.075.005-.09-.024a1.88 1.88 0 0 1-.258-.646 1.095 1.095 0 0 1 .083-.66c.015-.03.027-.06.086-.033s.045.056.033.086zm-1.241-.445c.02.116.027.252.015.388a1.072 1.072 0 0 1-.09.338v.003a.497.497 0 0 0-.047.329c.024.115.083.23.163.35.018.026.036.053-.017.091s-.072.012-.092-.018a1.065 1.065 0 0 1-.184-.396.605.605 0 0 1 .06-.415.951.951 0 0 0 .076-.293 1.382 1.382 0 0 0-.012-.353c-.005-.032-.011-.065.054-.074.065-.012.07.02.074.053zm7.257-10.748a2.897 2.897 0 0 0 .39 1.833c.019.026.033.056-.023.089s-.071.003-.089-.024c-.163-.284-.287-.587-.358-.904s-.092-.651-.048-1.007c.003-.032.006-.065.072-.056.065.006.062.039.056.071zm-.91.879c.17.3.314.622.424.974s.184.741.21 1.17c.003.033.003.066-.062.069s-.065-.03-.068-.063a4.71 4.71 0 0 0-.616-2.085c-.015-.03-.033-.056.024-.089s.074-.003.088.024zm-4.508.139c-.435.62-.625 1.123-.66 1.558-.036.433.08.794.252 1.129l.002.009c.119.343.172.684.163 1.027a3.232 3.232 0 0 1-.198 1.025c-.012.033-.02.063-.083.039-.062-.02-.05-.054-.039-.083.119-.329.184-.655.193-.984a2.81 2.81 0 0 0-.154-.977c-.18-.352-.302-.738-.264-1.194s.234-.983.685-1.623c.017-.027.038-.053.091-.018.054.039.036.066.015.092zm4.203-1.783a.918.918 0 0 1-.065.572c-.077.174-.21.34-.409.497-.201.157-.32.362-.373.608-.056.251-.044.545.018.873.006.033.012.066-.053.077-.062.012-.071-.02-.077-.053-.063-.347-.074-.655-.015-.924a1.14 1.14 0 0 1 .42-.681c.181-.143.3-.294.37-.448a.793.793 0 0 0 .057-.491c-.006-.033-.015-.063.05-.077.063-.012.071.02.077.05zm-4.452.382c.086.276.09.545.01.815-.078.266-.238.53-.48.788l-.006.006a1.512 1.512 0 0 0-.465.72c-.092.28-.125.595-.143.92-.003.033-.003.066-.068.063s-.062-.036-.062-.068c.018-.335.053-.658.148-.954s.249-.563.5-.776a1.87 1.87 0 0 0 .451-.735 1.263 1.263 0 0 0-.009-.74c-.009-.033-.02-.063.042-.08s.07.012.08.044zm2.548.133a.954.954 0 0 0 0 .29c.015.093.05.181.11.267.017.027.035.054-.018.092-.054.036-.071.012-.092-.018a.784.784 0 0 1-.13-.317 1.02 1.02 0 0 1 0-.328c.002-.033.008-.066.074-.057s.059.042.056.074zm-.122-.669a1.066 1.066 0 0 0-.539.5c-.124.235-.198.537-.222.907.015.018.024.033.024.044.124.17.21.37.263.596.06.246.08.524.072.826 0 .033-.003.065-.069.062s-.062-.035-.062-.065a3.029 3.029 0 0 0-.068-.794 1.528 1.528 0 0 0-.225-.524c-.483.45-.72.948-.735 1.49-.017.566.205 1.182.631 1.84.018.026.036.056-.017.091s-.072.006-.09-.02c-.44-.682-.669-1.322-.651-1.914.018-.583.273-1.117.797-1.596v-.003c.02-.406.1-.738.24-.999.142-.263.34-.45.604-.56.03-.011.06-.023.086.036.024.06-.006.074-.036.086zm-.722-.936c-.006.053-.012.095-.015.14-.033.307-.065.654-.3.864-.13.116-.213.252-.272.397a1.97 1.97 0 0 0-.11.486c-.002.032-.005.065-.07.056-.066-.006-.06-.038-.057-.074.02-.18.056-.355.119-.518a1.15 1.15 0 0 1 .305-.448c.195-.174.23-.497.257-.779.006-.053.012-.103.015-.142.003-.032.01-.065.074-.056s.06.041.057.074zm7.076 7.55c.077.16.14.326.18.495s.063.343.054.524c0 .033-.003.065-.068.062s-.062-.035-.062-.068a1.791 1.791 0 0 0-.048-.489 2.429 2.429 0 0 0-.175-.468c-.014-.03-.026-.059.033-.085s.071 0 .086.03zm.021 2.322c.056.267.059.54.011.812s-.148.551-.296.832c-.1.234-.198.468-.299.702-.015.03-.027.06-.086.036s-.047-.056-.035-.086c.1-.234.198-.471.299-.705l.003-.006c.145-.27.24-.533.287-.794a2.008 2.008 0 0 0-.012-.764c-.006-.032-.012-.065.05-.077.063-.015.072.018.078.05zm-1.475-2.162c.423.471.699.969.829 1.493.133.524.118 1.075-.042 1.65-.008.032-.017.062-.08.044s-.053-.047-.044-.08c.154-.554.169-1.08.042-1.584s-.394-.984-.803-1.44c-.02-.024-.042-.047.006-.092s.07-.017.092.006zm-.131 2.607a6.646 6.646 0 0 1-1.084 1.653 3.148 3.148 0 0 0-.672 1.173c-.018.059-.13.038-.125-.024.012-.196-.012-.391-.065-.587s-.142-.394-.26-.59v.004c-.237-.35-.338-.702-.32-1.052.02-.35.16-.696.408-1.042.143-.243.243-.489.314-.732s.107-.489.116-.734c0-.033.003-.066.068-.063s.062.036.062.068a3.26 3.26 0 0 1-.45 1.529l-.003.006c-.234.329-.367.654-.385.977-.018.326.08.649.3.975l.002.003c.124.207.216.414.276.625.026.097.047.195.059.293a3.312 3.312 0 0 1 .586-.91 6.15 6.15 0 0 0 .62-.811 6.68 6.68 0 0 0 .444-.812c.014-.03.026-.059.086-.032s.044.056.032.086zm-3.865-1.244c-.01.323.02.625.086.909.065.281.171.545.32.788.017.027.032.056-.021.089-.056.035-.071.006-.089-.02a2.817 2.817 0 0 1-.335-.824 3.742 3.742 0 0 1-.089-.942c0-.033.003-.065.066-.063.065.003.065.036.062.066zm-2.201 1.179v.379c0 .032 0 .065-.065.065s-.065-.033-.065-.065v-.38c0-.032 0-.065.065-.065s.065.033.065.066zm.729-2.012c.006.223-.024.439-.092.646-.071.207-.18.406-.34.592-.022.024-.042.05-.093.006-.05-.041-.026-.065-.006-.091a1.62 1.62 0 0 0 .314-.551 1.71 1.71 0 0 0 .086-.602c0-.032-.003-.065.063-.065s.065.033.065.062zm-1.982 3.905c-.355-.886-.441-1.588-.352-2.16a2.455 2.455 0 0 1 .705-1.374c.234-.24.438-.477.571-.773s.196-.652.148-1.132c-.003-.033-.006-.065.06-.071s.065.027.07.06c.048.503-.017.879-.16 1.196-.139.314-.352.563-.595.811a2.339 2.339 0 0 0-.67 1.304c-.085.55 0 1.232.347 2.094.012.03.024.06-.035.083s-.074-.006-.086-.036zm-1.143-1.455a.9.9 0 0 0-.057.43c.015.142.069.287.157.432.018.027.036.056-.02.089-.057.035-.071.006-.09-.021-.097-.16-.156-.323-.174-.486s.003-.326.065-.488c.012-.03.024-.06.083-.039.062.024.048.053.039.083zm5.621-3.993c.235.329.37.67.398 1.025s-.054.723-.255 1.105c-.015.027-.03.056-.086.027-.06-.03-.042-.06-.027-.086.19-.359.267-.702.24-1.034-.024-.332-.154-.652-.373-.96-.02-.026-.039-.053.015-.092s.07-.012.092.015zm1.757-1.374a3.002 3.002 0 0 1 .089 2.088c-.018.06-.124.047-.127-.018-.012-.326-.08-.619-.202-.877s-.302-.48-.536-.669c-.024-.02-.05-.041-.009-.092s.065-.03.092-.009a2.018 2.018 0 0 1 .746 1.262c.039-.216.057-.432.048-.649a2.81 2.81 0 0 0-.22-.989c-.011-.03-.023-.06.036-.086.06-.023.074.006.086.036zm1.043-1.425c.23.228.394.53.494.903.098.368.134.8.116 1.295v.003c-.024.21-.033.415-.009.604.02.187.074.358.172.513.018.026.035.056-.018.091-.056.036-.074.006-.092-.02a1.326 1.326 0 0 1-.192-.57 2.85 2.85 0 0 1 .009-.633v.003c.017-.483-.018-.903-.11-1.256-.095-.35-.246-.63-.46-.844-.023-.024-.047-.045 0-.092.045-.047.069-.024.093 0zm-2.767-.275c-.15.183-.243.4-.287.64a2.42 2.42 0 0 0 .006.8c.006.032.012.061-.053.073-.063.012-.069-.02-.075-.053a2.528 2.528 0 0 1-.005-.844c.047-.261.15-.495.314-.7.02-.023.041-.05.091-.008s.03.065.01.092zm-5.423 3.652c-.024.539-.18.977-.433 1.339-.251.358-.595.642-1 .88-.028.017-.057.032-.09-.024s-.006-.071.024-.09c.388-.227.72-.5.96-.843.24-.341.388-.756.411-1.268 0-.033.003-.065.069-.062s.062.035.062.068zm-.14-1.866c.03.201.018.397-.026.592a2.715 2.715 0 0 1-.22.584c-.014.03-.029.056-.085.03-.06-.03-.045-.06-.03-.087.095-.19.169-.373.21-.554s.054-.358.027-.545c-.003-.032-.009-.065.056-.074s.072.024.074.057zm3.673-.27v.184l.063.954.006.085c.003.033.003.066-.06.072h-.02c-.01.011-.024.017-.054.017-.065 0-.065-.032-.065-.065v-1.054l-.018-.258c-.003-.033-.006-.065.06-.071.065-.003.068.027.07.06v.02c.015.012.015.032.015.053zm.887-1.638c-.262.317-.365.622-.371.921s.086.599.222.895c.308.495.409.986.376 1.48-.03.493-.192.981-.409 1.47-.014.03-.026.06-.085.033s-.045-.057-.033-.086c.213-.474.367-.951.397-1.425a2.31 2.31 0 0 0-.359-1.41l-.003-.006c-.145-.314-.242-.63-.236-.957.005-.328.121-.66.4-1 .02-.024.04-.051.091-.01s.03.066.01.092zm-5.697-10.156c.43-.33.85-.516 1.292-.563.438-.045.891.05 1.383.281l.489-.006c.165-.003.334-.006.5-.006.033 0 .065 0 .065.065s-.032.065-.065.065c-.169.003-.335.006-.5.006l-.45.006-.01.01c-.527.464-.977.719-1.377.802a1.324 1.324 0 0 1-1.09-.237c-.032-.024-.065-.047-.02-.113s.08-.044.112-.02a1.2 1.2 0 0 0 .966.21c.35-.074.746-.29 1.211-.684-.427-.187-.818-.26-1.194-.222-.408.041-.805.219-1.211.53-.033.023-.065.047-.113-.015-.047-.065-.017-.089.015-.113z'/%3e%3cpath d='M639.447 126.22c.18 0 .326.146.326.326a.327.327 0 0 1-.326.326c-.178 0-.326-.145-.326-.326s.145-.325.326-.325zm2.243 1.97c.233-.121.414-.251.565-.385a2.71 2.71 0 0 0 .367-.406c.018-.026.039-.053.092-.014s.032.065.015.091a2.83 2.83 0 0 1-.385.43c-.157.14-.347.272-.593.4-.03.015-.059.03-.086-.027-.03-.056-.003-.074.027-.086zm4.623-1.913a.652.652 0 0 1 .361.003.957.957 0 0 1 .35.192c.023.021.05.042.009.092s-.066.03-.092.009c-.101-.083-.205-.14-.302-.166s-.196-.026-.294-.003c-.032.01-.062.018-.08-.047-.017-.062.015-.071.045-.08zm-2.645.106c.103-.236.26-.417.477-.533.213-.112.482-.16.811-.13.033.003.065.006.06.071s-.04.062-.072.06c-.305-.027-.55.014-.74.115a.91.91 0 0 0-.418.47c-.012.03-.026.06-.086.033s-.047-.056-.032-.086zm.302.433a.529.529 0 0 1 .145-.3.697.697 0 0 1 .335-.183c.032-.009.062-.018.08.045s-.015.07-.045.08a.556.556 0 0 0-.272.148.432.432 0 0 0-.11.23c-.006.033-.012.063-.074.054s-.06-.041-.053-.074zm-4.402 1.464a1.993 1.993 0 0 0-.183.352 1.028 1.028 0 0 0-.06.414c.003.033.006.065-.059.068s-.068-.026-.071-.059a1.18 1.18 0 0 1 .065-.468c.048-.136.119-.26.196-.379.017-.027.035-.056.089-.02.056.035.038.062.02.088zm1.262.565v.195c0 .033 0 .066-.065.066s-.065-.033-.065-.066v-.195c0-.033 0-.065.065-.065s.065.032.065.065zm-.82-1.41a1.2 1.2 0 0 0 .388.074c.13 0 .263-.018.394-.047.032-.006.062-.015.077.047s-.018.071-.048.08a1.748 1.748 0 0 1-.426.05 1.244 1.244 0 0 1-.433-.083c-.032-.011-.062-.023-.038-.083.023-.062.053-.047.083-.038zm.811-2.367a.397.397 0 0 0-.26.08.472.472 0 0 0-.163.237c-.01.033-.018.062-.08.045s-.054-.05-.045-.08c.033-.104.1-.22.21-.302a.538.538 0 0 1 .341-.107c.033 0 .065.003.065.065 0 .065-.032.065-.065.065zm-1.312.134a.995.995 0 0 0-.234.136.318.318 0 0 0-.104.142c-.012.033-.02.062-.083.042s-.05-.05-.041-.083a.46.46 0 0 1 .145-.202c.068-.056.157-.11.27-.157.03-.012.059-.024.083.036.026.059-.003.074-.036.086zm-.809.023a.852.852 0 0 0-.337.412c-.012.03-.021.062-.083.039-.06-.021-.05-.054-.039-.083.036-.098.09-.187.154-.267s.142-.148.231-.21c.027-.018.054-.036.092.017s.012.072-.018.092zm-1.04.833a2.174 2.174 0 0 0-.473.489c-.018.026-.039.053-.092.014s-.033-.065-.015-.092c.074-.103.154-.198.237-.284s.172-.163.264-.231c.026-.02.053-.039.092.012.038.053.011.07-.015.092zm.104 1.146c-.062.068-.124.136-.186.201l-.19.202c-.02.023-.044.047-.092.003s-.026-.068-.003-.092l.187-.201c.062-.066.124-.134.19-.202.02-.024.044-.047.091-.003s.027.068.003.092zm-1.051.305v.403c0 .032 0 .065-.065.065s-.065-.033-.065-.065v-.403c0-.033 0-.065.065-.065s.065.032.065.065zm1.347 1.771c-.02.22-.04.439-.062.66l-.006.063c-.003.033-.005.065-.07.06s-.063-.04-.06-.072c.003-.02.003-.041.006-.062l.062-.66c.003-.033.006-.066.071-.06s.063.039.06.071zm-.79-.586c-.003.142-.01.287-.015.43 0 .032-.003.065-.068.062s-.062-.036-.062-.066c.003-.145.008-.287.014-.432 0-.033.003-.065.069-.062s.062.035.062.068zm-.735-5.61a.91.91 0 0 1 .584.584c.012.032.02.061-.042.082s-.07-.012-.083-.041a.811.811 0 0 0-.195-.317.87.87 0 0 0-.311-.19c-.03-.012-.06-.023-.039-.083.024-.062.054-.05.083-.038zm6.451 8.412a2.034 2.034 0 0 1 .027 1.685c-.012.03-.024.06-.083.036s-.047-.056-.035-.086c.11-.264.163-.527.157-.79a1.973 1.973 0 0 0-.184-.792c-.015-.03-.027-.059.033-.086s.074.003.085.033zm-2.103 2.432c.092-.317.225-.593.38-.844s.328-.48.503-.705c.201-.261.335-.545.406-.836.077-.314.08-.64.024-.948-.006-.032-.012-.062.053-.074.062-.011.071.021.074.054.06.326.056.666-.024 1a2.29 2.29 0 0 1-.43.887 7.893 7.893 0 0 0-.494.693 3.27 3.27 0 0 0-.364.811c-.01.033-.018.062-.08.045s-.054-.048-.045-.08zm-2.703-.714c.043-.119.109-.222.198-.314s.198-.169.328-.231c.03-.015.06-.027.086.03.027.059 0 .074-.032.085a.993.993 0 0 0-.294.205.716.716 0 0 0-.168.27c-.012.029-.024.062-.083.038-.06-.02-.05-.053-.039-.083zm-.525-.19c.1-.13.201-.251.317-.358.118-.11.251-.202.406-.264.03-.012.059-.023.082.036.024.062-.005.074-.038.083a1.18 1.18 0 0 0-.364.237c-.11.1-.208.222-.303.343-.02.027-.038.054-.091.012-.054-.038-.033-.065-.012-.092zm2.802-2.778c.112.05.219.074.323.077s.204-.012.302-.039c.032-.008.062-.017.08.045s-.015.071-.045.08a.995.995 0 0 1-.71-.044c-.03-.015-.06-.027-.033-.086s.056-.045.086-.033zm-1.395-.181.097-.112.012-.015c.021-.024.045-.047.092-.006.048.044.027.068.006.092l-.012.015a3.445 3.445 0 0 1-.1.112c-.021.024-.042.048-.092.006-.048-.041-.027-.068-.006-.092zm30.165 8.703c.062.068.115.139.163.216.044.077.08.157.11.243.011.032.02.062-.042.08-.062.02-.071-.012-.083-.042a.95.95 0 0 0-.098-.216.995.995 0 0 0-.145-.192c-.02-.024-.044-.048.003-.092s.071-.021.092.003zm-33.489 15.716c.143.13.29.249.454.332.16.08.337.13.539.13.032 0 .065 0 .065.065s-.033.066-.065.066c-.223 0-.418-.057-.599-.146a2.202 2.202 0 0 1-.483-.35c-.023-.02-.047-.044-.002-.09s.068-.028.091-.004z'/%3e%3cg fill='red'%3e%3cpath d='M661.016 124.479c.744.032 1.46.003 2.07-.098-.651.471-1.483.788-2.38.936.174-.136.287-.278.337-.423a.533.533 0 0 0-.027-.415zm-1.774-.184c.483.08.983.136 1.478.17.006.01.015.02.02.032.08.11.104.216.069.32-.042.118-.154.242-.338.37-.05.035-.1.07-.03.169a7.037 7.037 0 0 1-1.516.026.22.22 0 0 0 .05-.041c.181-.19.297-.385.33-.59a.783.783 0 0 0-.063-.453zm-13.11-3.767a16.54 16.54 0 0 1 2.55-.116c.285.116.495.284.625.507.143.248.193.574.134.98-.01.06-.018.121.103.136.122.018.13-.044.137-.103.065-.463.006-.839-.163-1.135a1.307 1.307 0 0 0-.32-.367c.077.003.154.006.23.012.996.053 1.77.337 2.634.767a.121.121 0 0 1 .02.024c.184.192.247.39.217.595-.033.216-.163.45-.37.69-.039.047-.08.092.015.172.091.08.133.032.171-.015.234-.275.388-.548.427-.815a.87.87 0 0 0-.045-.435c.73.361 1.47.708 2.19 1.087.014.009.029.015.044.024a.14.14 0 0 0 .012.047.607.607 0 0 1-.065.53c-.11.157-.309.294-.596.4-.056.021-.112.042-.07.157.04.113.1.092.156.071.338-.127.575-.29.71-.491a.79.79 0 0 0 .134-.566c.477.258.954.524 1.443.758l.003.003c.086.172.1.326.032.468-.07.151-.237.293-.5.424-.054.026-.11.053-.057.163s.11.083.163.056c.317-.157.519-.338.613-.54a.68.68 0 0 0 .054-.432c.169.074.34.145.515.21.471.175 1.04.326 1.65.439a.08.08 0 0 0 .015.018c.112.157.15.308.124.453-.026.151-.118.305-.266.46-.042.044-.083.085.003.17a.323.323 0 0 0 .038.033c-1.851-.19-3.498-1.075-5.222-1.741-.204-.08-.412-.157-.616-.237-.637-.24-1.28-.566-1.92-.827a.2.2 0 0 0-.082-.041c-.045-.015-.086-.03-.13-.041-.027-.012-.057-.021-.084-.033.003.003.01.006.012.009a10.594 10.594 0 0 0-1.771-.415 7.639 7.639 0 0 0-2.032-.02l-.113-.018c.06-.365.012-.685-.168-.963a1.564 1.564 0 0 0-.587-.518z'/%3e%3cpath d='M643.102 121.342c.85-.37 1.712-.607 2.592-.752.403.16.67.355.82.586.145.228.18.495.13.803a5.246 5.246 0 0 0-2.299.281c-.195-.411-.458-.66-.766-.796a1.553 1.553 0 0 0-.477-.125zm9.321 4.716a11.62 11.62 0 0 0-.699-.418c-1.152-.634-2.473-1.025-3.797-1.075.012-.01.02-.02.033-.03.47-.48.574-.933.414-1.356-.124-.33-.411-.634-.808-.91.444-.023.856.003 1.318.068.651.092 1.496.311 2.266.622.19.415.243.78.16 1.087-.086.323-.33.593-.72.815-.053.03-.107.06-.047.166s.112.077.165.044c.454-.254.732-.574.836-.965.08-.302.056-.64-.077-1.016.521.234.992.512 1.32.817.43.296.854.596 1.268.91.003.527-.15.826-.405.983-.27.163-.655.184-1.093.14-.06-.007-.122-.013-.134.109v.006z'/%3e%3cpath d='M654.959 127.965c-.77-.601-1.523-1.23-2.331-1.771.447.035.847 0 1.15-.18.292-.181.485-.495.517-1.008.483.373.948.767 1.39 1.19.222.211.444.419.672.623 0 .003.003.006.003.012.053.19.071.352.056.488a.574.574 0 0 1-.139.33.684.684 0 0 1-.34.192c-.217.062-.498.074-.845.035-.056-.006-.115-.012-.13.092z'/%3e%3cpath d='M657.616 129.716a14.382 14.382 0 0 1-.767-.424c-.59-.35-1.144-.75-1.686-1.167.332.027.61.009.836-.053a.937.937 0 0 0 .456-.264.806.806 0 0 0 .201-.468 1.153 1.153 0 0 0-.003-.266c.53.453 1.087.873 1.689 1.24.314.193.63.374.944.543-.003.02 0 .041.003.065.039.243-.097.397-.346.495-.29.115-.723.162-1.218.192-.056.003-.11.006-.115.1z'/%3e%3cpath d='M660.453 130.83c-.9-.246-1.77-.59-2.568-.978.457-.033.86-.086 1.15-.201.328-.13.518-.332.506-.655.527.267 1.055.498 1.59.687.096.21.101.382.013.527-.107.178-.341.326-.631.454-.057.023-.113.05-.063.16v.002z'/%3e%3cpath d='M666.366 130.228c.077-.012.55-.136.305.045-1.742 1.14-3.952 1.137-6.034.6.323-.144.587-.319.72-.538.1-.163.118-.35.071-.554.663.216 1.336.37 2.029.459a.47.47 0 0 1-.11.317c-.11.136-.296.27-.6.403-.057.023-.114.047-.063.16.047.112.104.086.16.062.343-.151.566-.311.696-.474a.687.687 0 0 0 .163-.441c.856.092 1.741.08 2.666-.042zm-12.044 30.002c-.13.137-.24.288-.346.466-.507.168-.954.42-1.5.396 0 .353.116.507.469.51.672-.338.823-.4.882-.353.083.071-.094.554-.651.945-.086.054-.083.086-.033.175.471.738 1.706.474 2.37.3.474-.125 1.33-.688 1.567-1.162.092-.216-.116-.5-.323-.732-.524.08-.705-.162-.622-.331-.554-.196-1.17-.237-1.813-.214zm-18.936-5.968a4.095 4.095 0 0 1-1.315.729c-.19.062-.649.174-.693.414-.006.086.308.273.51.163.556-.533.834-.237.195.308-.05.104-.01.22.1.317.578.519 2.009.687 2.66.276.483-.302.735-.634.314-1.093.003-.104.015-.205.033-.308l-.797-.08-.489-.285-.518-.441zm12.464 4.336c-.047.006-.098.012-.145.021-.258.279.45.175.826.406.172.104.246.308.178.592-.347.827-2.28.56-2.923.22-.3-.157-.311-.338-.3-.596a2.7 2.7 0 0 0 .406-.03c.231-.032.46-.1.684-.228.063-.035.128-.074.057-.198-.071-.127-.137-.092-.199-.056-.19.106-.385.166-.58.192-.202.03-.41.03-.608.021h-.05c-.112-.065-.198-.142-.151-.21.047-.065.234.006.27.017.299-.139.56-.228.882-.29.045-.044.086-.092.13-.136.59.05 1.153.14 1.526.275zm-8.942-.506c-.119.071-.16.172-.246.358-.338.34-.66.545-1.093.74-.359.164-.012.32.24.492.228.17.527-.198.714-.476.204-.308.411-.217.278.023a2.432 2.432 0 0 0-.27.842c-.076.213.735.376.874.382.495.023 1.117-.46 1.505-.705.323-.33.273-.616.13-1.016l.003-.027a2.463 2.463 0 0 1-.595-.06 4.29 4.29 0 0 1-.7-.23c-.029-.012-.058-.024-.035-.086.015-.039.033-.048.054-.045l-.853-.195zm3.462-32.967c.137-.006.273-.012.406.003.252.03.492.139.744.168.84-.317 1.537-.491 2.138-.465a7.1 7.1 0 0 1 2.16-.272.192.192 0 0 1-.027-.024c-.086-.086-.045-.13 0-.172.394-.4.486-.767.358-1.099-.13-.343-.486-.666-.98-.962-.527.059-1.034-.083-1.594-.02-.35.038-.693.115-1.03.227.28.1.527.267.728.504.249.293.427.693.521 1.196.012.06.021.119-.097.143s-.13-.039-.143-.098c-.085-.46-.245-.82-.468-1.084-.234-.335-.77-.465-.938-.533-.56.056-1.111.118-1.591.242-.361.092-.678.22-.921.41.361-.078.737-.063 1.063.1.311.154.575.444.74.915.021.056.04.116-.076.154s-.137-.018-.154-.077c-.14-.406-.359-.649-.617-.776-.512-.255-1.57-.032-2.017.3-.26.195-.521.447-.779.74-.026.032-.056.062-.092.065.96.065 1.926.115 2.672.415zm-2.846-.542c-.02-.054.015-.092.047-.13.27-.306.542-.575.824-.783.272-.201.554-.346.844-.414.296-.33.734-.528 1.244-.658.495-.127 1.06-.193 1.632-.249-.169-.34-.385-.545-.634-.654-.267-.119-.575-.137-.903-.104-.69.237-1.304.607-1.893 1.025.053 0 .107 0 .157.003.175.012.332-.015.477.041.059.02.115.042.074.157-.05.14-.433.054-.566.045a1.69 1.69 0 0 0-.5.047c-.03.006-.057.015-.083.006-.62.382-1.087.77-1.588 1.194.38.133.675.29.868.474z'/%3e%3c/g%3e%3cpath fill='%230093dd' d='m711.17 195.594 25.923-58.758-19.123-30.876-34.102 12.627-15.784 62.1a274.19 274.19 0 0 1 43.082 14.91z'/%3e%3cpath fill='%23fff' d='M678.11 141.244a314.594 314.594 0 0 1 49.48 17.126l-10.002 22.68a289.893 289.893 0 0 0-45.586-15.775z'/%3e%3cpath fill='red' d='m719.196 177.407 6.683-15.145a310.646 310.646 0 0 0-48.812-16.895l-3.94 15.494a294.82 294.82 0 0 1 46.3 16.025l-.23.521z'/%3e%3cpath d='M681.878 157.168c.447-.282.924-.214 1.404-.137.388-.145.835-.195 1.32-.177.208-.113.448-.193.72-.243.146-.113.152-.234.021-.364-.121-.149-.19-.294-.198-.442-.77-.447-1.055-1.128-1.348-1.804-.438-.115-.643-.263-.69-.43-.213-.02-.424-.04-.634-.064-.998.11-1.256-.214-1.611-.477-.296-.098-.554-.26-.72-.572-.11-.14-.22-.275-.329-.415-.272-.346-.19-.805.222-.779.29.033.578.033.845-.082.31-.14.776-.137 1.128-.107.418-.024.681-.293 1.087-.673l-.006-.485c-.065-.175.018-.252.249-.228.542.017.865.272 1.084.634.631.11 1.129.411 1.463.941.839.003 1.404.32 1.472.631.05.228-.195.49-.574.768.003.056.006.115.006.171.225.196.373.391.45.584.471.18.921.423 1.342.779 1.2-.14 3.222.731 5.956 2.476 1.775.317 3.496.809 5.148 1.523.35.011.7.02 1.046.032 2.965-.438 5.838-.1 8.504 1.937 1.007.122 1.91.439 2.784.8.649.267 1.31.37 1.976.433a9.91 9.91 0 0 1 3.255.873c1.218.273 2.355.655 3.06 1.508.5.604.38 1.161-.258 1.392-.385.812-1.152.847-2.301.447-.791.146-1.662-.488-2.453-1.084-1.099-.352-2.109-.986-3.107-1.661-.518-.388-1.043-.634-1.552-.744-.4-.086-.758-.142-.998 0-.119.071-.104.113 0 .199a1.6 1.6 0 0 1 .536 1.004c.056.37-.003.796.018 1.25.023.477.31.823.79 1.12.33.2.72.414 1.286.494.27.053.347.21.338.415.15.722.29 1.451.554 2.106.074.186.216.275.43.432.73.527.352 1.117-.315 1.244-.583.516-1.087.862-1.685.998-.477.16-.673-.035-.833-.27a.604.604 0 0 1-.554-.307c-.583-.43-.085-1.176 1.31-.856.03-.163.148-.214.266-.21-.083-.362-.13-.765.027-1.14-.124-.08-.231-.182-.412-.24-.503-.16-.98-.392-1.356-.744-.714-.673-1.83-1.235-2.906-1.801-.889-.045-1.55-.453-2.245-.8l-.942-.012c-.276-.092-.5.003-.667.202-.278.337-.601.281-.983.237-.438-.05-.883-.018-1.321-.024-.216.053-.43.121-.664.124-.494-.026-.977-.032-1.306.243-.272.287-.545.267-.817.16-.205-.095-.353-.195-.439-.302-.343-.071-.566-.157-.64-.26-.577-.164-.74-.327-.713-.49-.768-.183-.403-.787.094-.808.587-.024 1.123.089 1.698.169.482.136 1.078.056 1.472-.3.254-.23.35-.429.66-.6-.992-.066-1.724-.24-2.263-.581-1.451-.915-2.612-1.138-3.536-.362-.246.14-.439.196-.702.095a1.329 1.329 0 0 0-.73-.035c-.523.118-1.042.053-1.566-.137-.767.193-1.531.234-2.298.077-.65.341-1.123.38-1.425.119-.285-.16-.554-.323-.809-.498-.412-.062-.59-.166-.607-.302-.527-.06-.592-.252-.59-.462-.219-.252-.136-.444.083-.607.391-.163.797-.222 1.247.009.27.127.468.252.631.379.3-.036.557 0 .782.083.166-.26.637-.273 1.153-.243.257-.172.565-.293.96-.329a3.25 3.25 0 0 1-.033-.184c-.519-.136-.785-.512-1.043-.891-.797-.015-1.368-.35-1.937-.7-.468.04-.844-.115-1.209-.334-.296.024-.625.036-.936-.044a3.19 3.19 0 0 1-1.75 0c-.388.035-.7-.003-1.02-.033-.363.418-.772.492-1.22.279-.245-.311-.595-.516-1.036-.631-.335-.11-.439-.255-.498-.412-.409-.252-.326-.5.068-.69.297-.142.667-.169 1.23.11.183.068.388.115.619.133z'/%3e%3cpath fill='%23fff' d='M701.41 163.121c-.04-.068-.122-.24-.421-.068-.927-.05-1.964-.038-2.743-.497-.812-.477-1.647-.975-2.545-.94.267-.251.599-.423.984-.527.515-.136 1.125-.145 1.8-.035.949.154 1.784.338 2.43.58.622.234 1.06.525 1.253.898a.507.507 0 0 0 .053.06c.249.16.465.322.646.494.136.127.254.26.355.403a3.123 3.123 0 0 1-.892-.054 3.593 3.593 0 0 1-.924-.32z'/%3e%3cpath d='m703.542 118.368.053.279 1.167 6.042-4.641 4.046-.213.187.27.095 5.817 2.01 1.181 6.043.057.279.213-.187 4.65-4.031 5.827 1.996.27.092-.054-.278-1.167-6.046 4.641-4.046.214-.186-.27-.092-5.817-2.014-1.182-6.043-.057-.278-.213.186-4.653 4.034-5.824-1.999z'/%3e%3cpath fill='%23f7db17' d='m700.698 128.667 4.337-3.78 5.453 1.879zm10.512-2.041 4.352-3.782 5.435 1.88zm9.826-1.709-4.337 3.78-5.453-1.878zm-10.513 2.044-4.35 3.78-5.436-1.878zm-6.365-8.036 5.441 1.866 1.102 5.66zm7.026 8.08 5.45 1.878 1.09 5.649zm6.392 7.655-5.441-1.864-1.102-5.66zm-7.026-8.081-5.45-1.875-1.09-5.649zm3.777-9.532 1.105 5.646-4.352 3.782zm-3.487 10.124 1.1 5.66-4.346 3.771zm-3.433 9.366-1.104-5.645 4.35-3.783zm3.487-10.124-1.1-5.66 4.346-3.768z'/%3e%3c/svg%3e";
            },
            2032: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 500 300'%3e%3cpath fill='%23d21034' d='M0 0h500v300H0z'/%3e%3cpath fill='%2300209f' d='M0 0h500v150H0z'/%3e%3cg fill='%23f1b517' stroke='%23000' stroke-width='.183'%3e%3cpath fill='%23fff' stroke='none' d='M202.679 112.284h94.642v75.341h-94.642z'/%3e%3cpath fill='%23016a16' stroke='%23016a16' d='m269.047 166.766-19.314.56-19.227.22s-9.878 3.653-13.916 4.473c-4.026.817-3.503 2.14-6.618 2.836-2.496.558-2.784.734-4.248.83-.886.058-1.977.74-3.045 1.49v10.45h94.642v-9.939c-1.026-.559-2.004-.944-3.004-1.284-1.39-.472-2.327-.99-4.823-1.547-3.115-.696-2.592-2.019-6.618-2.836-4.038-.82-13.829-5.253-13.829-5.253z'/%3e%3cg id='a'%3e%3cpath d='m244.529 143.512 1.397-.033 2.555 10.75-.545 3.385-3.407-14.102z'/%3e%3cpath fill='%23fff' d='m243.064 136.346.954 8.284 1.022-.066-1.976-8.218z'/%3e%3cpath d='m245.722 154.589-4.293-11.538 1.601-.098 5.009 14.101-2.317-2.465z'/%3e%3cpath fill='%23fff' d='m239.419 136.477 1.772 8.02h1.43l-3.202-8.02z'/%3e%3cpath d='m241.906 150.546-2.521-5.424 1.09-.23 4.6 9.007-3.169-3.353z'/%3e%3cpath fill='%23fff' d='m236.08 138.778 2.794 7.626h1.43l-4.224-7.626z'/%3e%3cpath fill='%230a328c' d='m242.249 151.364-11.436-12.484c-3.571 2.828-2.908 8.021-2.908 8.021l12.957 10.166 1.387-5.703z'/%3e%3cpath fill='%23d20014' d='m248.861 158.235-8.483-8.594c-3.587.125-.741 5.48-.56 6.152l9.043 7.734v-5.292z'/%3e%3cpath d='m248.139 156.757-17.54-18.78-.684.483 18.561 20.622-.337-2.325zm-18.553-19.985-.385-.446.038-.891-3.619-2.303 1.617 3.64 1.232.223.385.446.732-.669z'/%3e%3cpath d='M227.738 138.11c.616-.743 1.348-1.486 2.657-2.192l1 1.45-2.155 1.82-1.502-1.078z'/%3e%3cpath fill='%230a328c' stroke='%230a328c' d='m225.811 141.278.588 1.026c.364-.135 4.031-3.457 4.031-3.457l2.632-.08.756-.838c-1.932-2.08-3.752.297-3.752.297l-4.255 3.052z'/%3e%3cpath fill='%23d20014' stroke='%23d20014' d='M227.911 143.007c.14-.918 1.876-3.214 2.128-3.295 1.303.391 2.515 1.141 3.835-1.837-1.148 1.459-3.471-.027-3.471-.027l-1.008.838.028.405-3.052 2.836 1.54 1.08z'/%3e%3cpath fill='%230a328c' d='m237.252 154.672-14.367-11.411c-2.46 2.503-.415 10.231-.415 10.231l14.043 7.608.739-6.428z'/%3e%3cpath fill='%23d20014' d='m249.166 163.917-11.818-9.467c-4.036.566-.864 6.506-.623 7.16l12.481 6.77-.04-4.463z'/%3e%3cpath d='m248.697 162.005-25.554-19.182-.587.591 26.837 20.955-.696-2.364zm-26.769-20.198-.46-.374-.122-.885-3.979-1.662 2.248 3.314 1.254.014.459.374.6-.781z'/%3e%3cpath d='M220.349 143.433c.473-.835 1.06-1.689 2.222-2.603l1.246 1.259-1.795 2.153-1.673-.809z'/%3e%3cpath fill='%230a328c' stroke='%230a328c' d='m218.925 146.641.16 1.06c.337-.188 3.56-3.726 3.56-3.726l2.586-.477.527-.833c-1.797-2.114-3.713.698-3.713.698l-3.12 3.278z'/%3e%3cpath fill='%23d20014' stroke='%23d20014' d='M220.971 148.545c-.123-.982 1.22-3.863 1.455-3.98 1.547.46 2.894 1.152 3.462-2.07-.897 1.614-3.46.363-3.46.363l-.86.979.121.53-2.61 3.37 1.892.808z'/%3e%3cpath fill='%230a328c' d='M236.224 161.651c-.19-.046-18.517-10.442-18.517-10.442-1.334 2.252-.128 5.52.457 6.029.034 1.5-.602 2.306.707 5.439.386 2.036 1.328 3.913 2.7 5.027 1.671 6.417 8.222 6.848 10.746 1.624l3.907-7.677z'/%3e%3cpath fill='%23d20014' d='m248.352 168.512-12.548-7.355c-4.036.567.085 8.056.326 8.71l12.116 4.304.106-5.659z'/%3e%3cpath d='m246.243 165.846-28.35-15.089-.484.672 29.905 16.647-1.071-2.23zm-29.715-15.909-.514-.3-.265-.856-4.2-1.04 2.758 2.934 1.24-.177.515.301.466-.862z'/%3e%3cpath d='M215.232 151.782c.332-.896.773-1.828 1.772-2.907l1.436 1.056-1.425 2.398-1.783-.547z'/%3e%3cpath fill='%230a328c' stroke='%230a328c' d='m214.1 155.181.593 1.167c.307-.232 3.004-4.578 3.004-4.578l2.492-.82.469-1.014c-2.002-1.85-3.498 1.342-3.498 1.342l-3.06 3.903z'/%3e%3cpath fill='%23d20014' stroke='%23d20014' d='M216.772 156.836c-.2-.999.484-4.197.7-4.345 1.56.465 2.863.597 3.223-2.622-.907 1.529-3.328.953-3.328.953l-.71 1.085.15.38-2.059 3.95 2.024.599z'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 499.859 0)'/%3e%3cpath fill='%23016a16' stroke='%23016a16' d='m248.757 125.603-.465 9.07h2.9l-.425-8.992 3.023-.424-.335-3.582-7.51.29.041 3.253 2.771.385z'/%3e%3cg id='b' fill='%23016a16'%3e%3cpath d='M249.817 121.898c-7.764-7.771-13.878-3.98-15.334-2.902.963.187 1.826-.412 2.273-.48-.28.353-.865 1.229-.865 1.229s2.4-1.134 2.668-1.03c-.346.276-.727.936-.727.936.178.069 1.528-1.057 1.795-1.077-.411.466-.539 1.528-.539 1.528l1.17-.545c.304.216-.085.63.18.609 1.944-.16 4.677 1.777 5.053 2.372'/%3e%3cpath d='M247.895 123.321c-.81-1.854-15.588-5.005-18.56.244 1.164.293 2.276-.976 2.276-.976l-.101 1.171 1.972-1.512-.708 1.56 1.568-1.268-.05 1.269 1.921-2.098-.253 1.22 1.72-.732-.203 1.024'/%3e%3cpath d='M247.238 123.614c-3.793-2.537-9.66-.83-9.66-.83-3.741 2.099-5.736 1.72-6.22 5.611.355-.146 1.366-1.366 1.366-1.366l.759 1.513.252-2.147.607 1.659.91-2.732.203 1.854 1.416-1.854.657.536.607-1.415.556.927s.961-.585 1.518-.244l1.062-1.22.252.879.91-1.073.355.78.91-.83-.05.586 3.135.05'/%3e%3cpath d='M246.38 124.053c-2.643-.05-10.226 2.812-12.188 5.806a13.29 13.29 0 0 1 1.263-.635l.387 1.203.473-1.203.1.927c.29-.724.618-.806 1.164-.049l.202-1.122.304 1.073.505-1.17s.318 1.269.506 1.22c0 0 .838-2.195 1.214-2.294l.1 1.366.506-1.366.456 1.025.1-1.464.506 1.122s.266-1.103.658-1.317l.758.683 3.378-2.427'/%3e%3cpath d='M246.888 124.678c-3.521 1.35-6.67 6.179-6.43 8.226 1.565-1.941 1.229-1.674 1.928.56 0 0 .264-1.955.53-2.187l.459 1.446.17-1.892.47.022-.12-1.187.7.535c-.164-.678-.339-.907.385-1.489 0 0-.917.117-.193-1.535l.675.651s-.12-.721.12-1l2.485-.861'/%3e%3cpath d='m247.229 125.04-1.33 2.534.682.197-1.535 1.152 1.296-.132s-1.978.724-2.217 2.665l2.013-.888s-1.706 1.744-1.945 2.797l1.16-1.02s-1.125 1.217-.955 3.06l.853-.954c-.205 2.237-.137 2.435.887 4.146 0 0-.273-2.633.034-2.962l2.25 2.337-1.261-3.324s1.398 2.106 2.25 1.909l-1.773-2.698 1.74 1.414-1.978-2.961 1.841.56s-1.33-1.679-1.228-2.732l1.262 1.382s-.477-1.58-.34-2.04l.647.132-1.262-1.448.853-.165-.102-.954.614-.197-.034-1.053'/%3e%3cpath d='M248.559 125.797c-2.183 2.961-1.057 7.535-2.353 9.871'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='matrix(-1 0 0 1 499.859 0)'/%3e%3cpath d='M250.945 166.535s1.189-9.945 1.186-14.225c-.002-3.37-.814-10.835-.814-10.835H247.9s-.52 7.429-.442 10.789c.1 4.281 1.186 14.27 1.186 14.27h2.301z'/%3e%3cpath d='M247.674 141.953h3.96l-.465-2.666h-2.87l-.625 2.666z'/%3e%3cpath d='M247.927 139.816h3.539l-.667-2.666h-2.18l-.692 2.666z'/%3e%3cpath d='M248.155 137.655h2.949l-.499-2.666h-1.876l-.574 2.666z'/%3e%3cpath d='M250.709 134.673h-2.063l-.209.964h2.44l-.168-.964zm.423 29.694h-2.62m2.763-1.947h-2.94m3.329-1.976h-3.727m3.919-2.153h-3.9m3.927-2.152h-4.102m4.262-1.968h-4.45m4.46-1.791h-4.65m4.622-2.161h-4.65m4.495-2.135h-4.495m4.289-2.17h-4.065m3.868-1.959h-3.672'/%3e%3cpath fill='%230a328c' stroke='%230a328c' d='M249.909 119.044c-.688-.324-2.245-1.313-1.783-1.903l.713-1.214c1.01-2.277-.018-1.395-.126-2.106-.103-.682 3.865-.149 3.924 1.397.016.426-.295.176-.252 2.611l-.755 1.458c-.565.053-1.234-.014-1.721-.243z'/%3e%3cpath d='m250.392 124.934-.986-.83.273-7.105.965.283-.252 7.652z'/%3e%3cpath fill='%23d20014' stroke='%23d20014' d='M251.672 119.246c.62-.362 1.024-1.443.65-2.085-1.016-1.287-1.673-.756-3.378-1.336-.34.362-1.055 1.059-.902 1.579 2.242 1.056 1.372.156 2.114.288.4.07.658.545 1.516 1.554z'/%3e%3cuse xlink:href='%23c' transform='matrix(1 0 0 -1 -.002 320.37)'/%3e%3cpath fill='%23016a16' stroke='%23fff' stroke-linecap='round' stroke-width='.181' d='M238.358 161.75c0 1.299-.815 2.353-1.818 2.353s-1.819-1.054-1.819-2.353v-1.276h3.637v1.276z'/%3e%3cellipse cx='236.539' cy='160.063' fill='%23fff' stroke='none' rx='1.806' ry='.898'/%3e%3cpath fill='%23016a16' stroke='%23f1b517' d='m236.126 161.075-.31-3.297h1.382l-.226 3.297h-.846z'/%3e%3cpath id='c' fill='%23016a16' stroke='%23fff' stroke-linecap='round' stroke-width='.237' d='M238.538 160.118c-.265.493-1.06.852-1.999.852-.938 0-1.728-.359-1.993-.852a.756.756 0 0 0-.099.359c0 .669.937 1.21 2.092 1.21s2.092-.541 2.092-1.21a.748.748 0 0 0-.093-.359z'/%3e%3cg id='d'%3e%3cpath d='m246.035 172.786-7.06-2.19-3.076-5.254-10.893-.535.378 3.94 9.28 1.777.882 1.581 10.666 2.968-.177-2.287z'/%3e%3cpath fill='%23503200' d='m238.662 174.254-11.149-16.398-.547.411 11.06 16.467.636-.48z'/%3e%3cpath fill='%23fff' d='m228.551 158.5-1.19-1.992c-.223-.368-.561-.49-1.059-.228-.484.255-.437.76-.24 1.123l1.101 1.852 1.388-.755z'/%3e%3cpath d='m239.986 164.127-22.496-2.286-.547 3.27 22.387 2.252.656-3.236z'/%3e%3cpath d='m217.089 160.997-.583 4.538h.948l.656-4.151-1.021-.387zm3.755.738-.255 4.08.583.07.474-3.622-.802-.528zm15.241 1.759-.547 3.834 1.094-.035.437-3.799h-.984zm3.351.105-.779 4.434 1.238.18.354-2.332c.1.468.531.824 1.046.824.589 0 1.07-.464 1.07-1.032s-.481-1.026-1.07-1.026c-.409 0-.78.24-.94.687l.231-1.662-1.15-.073zm-8.119.72-3.094 3.482.361.423 3.97-2.711-1.237-1.194zM224.124 173l3.094-3.482-.361-.423-3.97 2.711 1.237 1.194zm8.096-.871-3.764-2.91-.387.273 2.965 3.756 1.186-1.119zm-9.282-6.716 3.816 2.81.464-.348-2.99-3.755-1.29 1.293zm4.152-2.319.365 4.573.513-.022 1.207-4.452-2.085-.099zm1.251 11.095-.365-4.573-.565-.053-.691 4.626h1.621zm5.06-6.163-4.795.51-.073.457 4.85.634.018-1.601zm-11.408 1.583 4.68-.74.1-.364-4.842-.54.062 1.644z'/%3e%3cellipse cx='227.693' cy='168.548' rx='1.27' ry='1.225'/%3e%3cpath fill-rule='evenodd' stroke-linecap='round' d='M234.438 168.548c0 3.592-3.022 6.507-6.745 6.507-3.723 0-6.745-2.915-6.745-6.507 0-3.592 3.022-6.507 6.745-6.507 3.723 0 6.745 2.915 6.745 6.507zm-1.347 0c0 2.874-2.419 5.207-5.398 5.207s-5.398-2.333-5.398-5.207c0-2.874 2.419-5.207 5.398-5.207s5.398 2.333 5.398 5.207z'/%3e%3cpath d='m223.48 165.264-1.057-.796m8.611.025.902-.92m1.031 9.128-1.109-.87m-8.378 1.865.954-1.02m21.762-10.554 1.155 5.886-.942.497-1.014-6.299.801-.084z'/%3e%3cpath fill='%23fff' d='M245.592 161.364c-.535-.224-1.232.155-2.374-1.292-1.878 1.723-.107 1.98.179 3.686.53.218.858-1.323 2.302-1.481.179-.018 2.298-.203 2.298-.203l-.532-.726s-1.474.04-1.873.016z'/%3e%3cpath fill='%23fff' d='m246.359 162.518-.214-1.756c-.232-.62-1-.087-1 .275l.197 1.619 1.017-.138z'/%3e%3cpath fill-rule='evenodd' d='m240.765 167.372.019 1.637c-.536.183-.454.585-.437 1.168l.019 4.772c-.19.316-.778.331-1.054.58-.277.247-.242.729 1.02 1.046l.975.035c1.486-.325 1.793-.818 1.048-1.095-.397-.148-.919-.324-1.117-.557l.033-1.137.964.035c.26 0 .753-.652.77-1.185l.005-2.47c-.035-1.401-1.085-1.559-1.38-1.542l.021-1.29-.886.003zm1.63 2.73c.018-.4-.555-.757-.786-.767s-.734.467-.751.867v1c.034.367.327 1.61.915 1.701.28.043.64-.4.64-.767l-.017-2.034z'/%3e%3cpath fill='%23fff' d='M234.275 172.328c-.636-.257-.63 1.172-.63 1.172l1.002.01c.44.2.792.843.512 1.159-.231.261-2.177-.441-2.308-.037.344 1.941 2.917 2.688 3.848 1.839.91-.83 1.141-3.048-1.817-3.629l-.607-.514zm.595.528-.292.639'/%3e%3cpath d='m214.943 173.055-.963-4.05m2.132 3.817-1.48-3.153m4.026 2.324-3.337-1.792m4.782 1.427-6.192-2.688'/%3e%3cpath fill='%23d20014' stroke='%23d20014' d='M210.215 166.013s-2.254-.036-2.656.122c-.162.064.567.825.416 1.115-.563 1.083-4.394.934-4.697.698-.519-.405 3.568-.753 3.595-1.029.03-.316-.605-1.146-.506-1.655.128-.661 1.788-.907 1.788-.907l2.06 1.656z'/%3e%3cpath fill='%23503200' d='m213.233 168.05-5.102-4.222s-.225-.238-.413-.033c-.184.2.069.431.069.431l5.263 4.348.183-.524z'/%3e%3cpath d='M218.146 172.217c-.09-.087-4.155-3.608-4.155-3.608l-.271-1.028s-.628.425-.858.645-.587.819-.587.819l1.138.052 3.595 3.294 1.138-.174z'/%3e%3cellipse cx='232.534' cy='177.056' rx='.74' ry='.715'/%3e%3cellipse cx='230.641' cy='175.716' rx='.74' ry='.715'/%3e%3cellipse cx='228.091' cy='176.593' rx='.74' ry='.715'/%3e%3cellipse cx='224.153' cy='177.445' rx='.74' ry='.715'/%3e%3cellipse cx='222.487' cy='177.64' rx='.74' ry='.715'/%3e%3cellipse cx='220.846' cy='177.64' rx='.74' ry='.715'/%3e%3cellipse cx='219.18' cy='177.591' rx='.74' ry='.715'/%3e%3cellipse cx='219.988' cy='176.325' rx='.74' ry='.715'/%3e%3cellipse cx='221.604' cy='176.398' rx='.74' ry='.715'/%3e%3cellipse cx='223.144' cy='176.203' rx='.74' ry='.715'/%3e%3cellipse cx='222.361' cy='174.961' rx='.74' ry='.715'/%3e%3cellipse cx='220.846' cy='174.937' rx='.74' ry='.715'/%3e%3cpath fill-rule='evenodd' d='M236.47 177.991c0-.316-.769-.18-.769-.55 0-.412 1.173-.11 1.335.252.66-.596.944-.16 1.348.02.575-.855 1.287-.823 1.981-.197.401-.443 1.41-.297 1.757.197.664-.66 1.255-.497 1.715-.02.186-.346.458-.27.654-.02.354-.628 1.242-.44 1.616-.024.332-.366.673-.08 1.114.19.297-.28.778-.227.778.05 0 .29-.628.188-.628.474 0 .256.458.127.458.45 0 .255-.68.35-.785-.056-.23.44-1.062.271-1.144-.138-.276.335-.897.436-1.246-.059-.286.234-.63.267-.787.031-.517.556-1.388.442-1.688-.17l-.294.012c-.508.69-1.302.37-1.52-.01-.853.615-1.362.42-1.838.02-.548.666-1.381.62-1.573 0-.368.267-1.137.33-1.137.017 0-.301.653-.192.653-.469zm1.655.15c0 .143-.195.26-.436.26s-.435-.117-.435-.26.195-.26.435-.26.436.117.436.26zm1.82-.218c0 .172-.235.312-.524.312-.289 0-.524-.14-.524-.312 0-.173.235-.312.524-.312.29 0 .524.14.524.312zm3.575.197c0 .175-.212.316-.474.316s-.474-.141-.474-.316c0-.174.212-.316.474-.316s.474.142.474.316zm-1.904-.083c0 .22-.207.4-.463.4s-.464-.18-.464-.4.208-.4.464-.4.463.18.463.4zm4.06.01c0 .198-.186.358-.414.358s-.415-.16-.415-.358c0-.197.186-.357.415-.357s.414.16.414.357zm-1.244.083c0 .128-.12.231-.267.231-.148 0-.268-.103-.268-.23s.12-.231.268-.231c.147 0 .267.103.267.23zm2.422.094c0 .183-.135.331-.302.331s-.301-.148-.301-.331c0-.183.135-.332.301-.332s.302.149.302.332z'/%3e%3c/g%3e%3cuse xlink:href='%23d' transform='matrix(-1 0 0 1 499.859 0)'/%3e%3cg stroke-width='.231'%3e%3cpath fill='%230a328c' stroke='%230a328c' d='M249.837 165.718c-2.512 0-4.55.944-4.55 2.102 0 .199.057.39.169.572.543.629 2.307 1.087 4.398 1.087 1.957 0 3.625-.402 4.277-.97.164-.216.256-.446.256-.689 0-1.158-2.038-2.102-4.55-2.102z'/%3e%3cpath stroke-width='.187' d='M254.427 167.981v7.058c0 .828-2.048 1.5-4.572 1.5s-4.573-.672-4.573-1.5v-7.058c0 .828 2.049 1.5 4.573 1.5 2.524 0 4.572-.672 4.572-1.5z'/%3e%3cpath fill='%23d20014' stroke='%23d20014' stroke-width='.183' d='M245.282 167.982v1.082l2.22 6.845 1.772-5.264 1.946 5.465 1.425-5.159 1.783 3.469v-1.92l-1.656-3.363a8.25 8.25 0 0 1-.593.134l-1.028 3.812-1.447-3.604a14.522 14.522 0 0 1-.715-.023l-1.453 3.627-1.661-4.367c-.376-.217-.593-.466-.593-.734z'/%3e%3cpath fill='%230a328c' stroke='%230a328c' stroke-width='.187' d='M254.427 173.721v1.318c0 .827-2.048 1.499-4.572 1.499s-4.573-.672-4.573-1.5v-1.317c0 .828 2.049 1.5 4.573 1.5 2.524 0 4.572-.672 4.572-1.5z'/%3e%3cpath stroke-width='.187' d='M251.737 175.085c-.372.055-.769.097-1.185.118l.011 1.317a12.24 12.24 0 0 0 1.186-.118l-.012-1.317zm-4.869-.23-.012 1.312c.353.1.75.185 1.186.246v-1.317a8.907 8.907 0 0 1-1.174-.241zm-1.586-1.132v1.317c0 .246.185.474.506.679l.023-1.3c-.336-.21-.529-.444-.529-.696zm9.146.14-.023.006c-.08.267-.379.516-.831.723l.006 1.312c.53-.245.848-.54.848-.863v-1.178z'/%3e%3cpath fill='none' stroke-width='.187' d='M254.427 168.027v7.012c0 .828-2.048 1.5-4.572 1.5s-4.573-.672-4.573-1.5v-7.012'/%3e%3cpath fill='%23fff' stroke='%23fff' stroke-width='.192' d='M253.392 167.52c0 .501-1.584.907-3.537.907-1.954 0-3.538-.406-3.538-.907s1.584-.907 3.538-.907c1.953 0 3.537.406 3.537.907z'/%3e%3cpath d='m248.698 168.19.157 1.25c.307.022.626.038.953.04l.232-1.29h-1.342zm4.103-.303-.912.247.058 1.177a8.91 8.91 0 0 0 .866-.19l-.012-1.234zm-5.404-1.908c-.259.076-.5.165-.72.263l.127.945.581-.185.012-1.023zm2.44-.373c-.122 0-.241.007-.36.011l.197 1.183.605-.012.238-1.154a9.727 9.727 0 0 0-.68-.028zm2.673.418-.122 1.034.691.244.076-1.015a5.259 5.259 0 0 0-.645-.263z'/%3e%3cpath stroke-width='.183' d='m245.993 168.8.184-1.288-.935-.506.028 1.465.723.329zm8.403-.278.042-1.288-.876.262.834 1.026z'/%3e%3c/g%3e%3cpath d='M263.686 160.029c.83-.115 2.062 1.024 2.136 2.433.06 1.118-1.69 1.06-1.69 1.06-.09.458-1.055.881-1.84.916-.763.033.207-1.432.207-1.432-.475-1.26.148-2.748.148-2.748l1.039-.229z'/%3e%3cpath d='m262.499 162.948.801-.029s.061.414.208.43c.157.017.326-.401.326-.401l1.217-.029'/%3e%3cpath fill='%23d20014' stroke='%23f1b517' d='M264.131 160.859c.68-.491.084-1.48-.386-1.489l-1.098.029c-.517.01-1.392.573-1.276 1.06.102.423.387.617.831.543.202-.033.626-.563.831-.572.275-.013.878.588 1.098.429z'/%3e%3cpath fill-rule='evenodd' d='M214.242 174.855c-.617.078-.731.788-.5 1.44-2.686.756-5.086 1.74-7.455 2.406-.095-.474 1.174-1.845 1.174-1.845.336.162.587.93.587.93.084-1.578 1.639-2.628 1.639-2.628-.924-.122-3.732.967-4.068 1.412 0 0 1.087-.121 1.255 0 0 0-2.14 2.312-2.237 3 .333.75 4.027 1.311 4.027 1.311-.058.195-1.087.93-1.087.93 1.47.323 3.685-.717 4.347-1.35 0 0-1.728-.143-3.074-1.234 0 0 .277.68.11 1.004 0 0-2.1-.605-2.318-.953.006-.03 4.966-1.315 7.368-2.001.088.429.565 1.24 1.138 1.048.374-.125.256-.866.117-1.39a.77.77 0 0 0 .505.185c.422 0 .767-.327.767-.735 0-.407-.345-.74-.767-.74a.757.757 0 0 0-.72.505c-.096-.453-.345-1.354-.808-1.295zm1.889 1.528c0 .19-.16.345-.358.345s-.358-.155-.358-.345.16-.345.358-.345.358.154.358.345z'/%3e%3cpath d='M293.068 177.884c.183-.367-.162-2.212-.162-2.212-.373.042-.882.681-.882.681.48-1.511-.865-4.037-.865-4.037.91.19 3.945 3.128 4.103 3.657 0 0-1.33-.474-1.53-.415.217 1.506 1.258 2.205 1.65 2.988 0 0-1.726.38-1.553 1.822l-1.127.021c-.39-.481.152-1.276.152-1.276l-7.739-3.241c-.499-.21-1.62-.718-1.452-1.318.17-.604 2.016.251 2.47.398l6.935 2.932z'/%3e%3cpath d='m285.635 176.541.91-1.673c.326-.44-.346-.92-.823-.356l-1.02 1.527c-.454.837.5 1.067.933.502z'/%3e%3cg fill='%23fff'%3e%3cpath d='m231.367 180.366-.063-1.825-2.207.122-.126 1.987 2.396-.284z'/%3e%3cpath d='m215.237 182.924-2.95-1.655c12.168 1.115 14.653-3.13 17.593-3.356 1.808-.141 2.09 2.002-1.412.982l.905 2.241s-8.638 4.86-17.129 2.853l2.993-1.065zm53.012-2.558.063-1.825 2.7.062.125 1.988-2.888-.225z'/%3e%3cpath d='m284.939 182.477 2.777-1.515c-13.94.415-10.766-2.29-17.74-3.048-1.802-.196-3.156 2.12 1.413.982l-.906 2.241 2.193.002c4.748 3.127 11.156 3.406 15.401 2.402l-3.138-1.064z'/%3e%3cpath d='M228.418 178.908v3.154s7.728 2.868 21.519 2.868c13.85 0 21.519-2.868 21.519-2.868v-3.154s-5.85 2.695-21.52 2.695c-15.61 0-21.518-2.695-21.518-2.695z'/%3e%3c/g%3e%3cpath fill='%23000' stroke='none' d='m229.573 182.08.682-2.31.317.088-.602 2.037 1.18.324-.081.272-1.496-.411zm2.236-1.015.038-.454.102-.39.338.083-.102.389-.193.416-.183-.045zm3.326-.156.322.063-.286 1.36c-.05.236-.118.418-.203.546s-.208.222-.371.281c-.164.059-.363.065-.598.019a1.217 1.217 0 0 1-.536-.224.66.66 0 0 1-.242-.391c-.032-.156-.021-.359.031-.608l.287-1.36.323.064-.287 1.358c-.043.204-.055.358-.036.463s.07.192.156.264a.73.73 0 0 0 .335.147c.237.047.418.028.54-.056.123-.084.216-.273.278-.569l.287-1.357zm.363 2.51.402-2.37.333.053.975 2.064.315-1.86.312.048-.402 2.37-.333-.052-.975-2.066-.315 1.862-.312-.05zm2.541.383.342-2.378.326.044-.342 2.378-.326-.044zm.937-1.049c.047-.396.194-.694.441-.893.247-.2.545-.28.894-.242.228.025.427.1.598.226.171.125.293.287.367.486.074.199.097.418.069.656a1.382 1.382 0 0 1-.23.633c-.123.18-.283.308-.48.386a1.279 1.279 0 0 1-.619.081 1.202 1.202 0 0 1-.604-.231 1.056 1.056 0 0 1-.364-.49 1.31 1.31 0 0 1-.071-.612zm.337.042c-.034.288.02.523.16.706.14.183.332.288.574.315a.814.814 0 0 0 .638-.184c.178-.15.286-.377.322-.684a1.19 1.19 0 0 0-.041-.52.761.761 0 0 0-.259-.37.83.83 0 0 0-.427-.168.865.865 0 0 0-.625.164c-.185.135-.3.382-.342.741zm2.309 1.417.202-2.394.337.027 1.144 1.982.16-1.88.314.026-.203 2.393-.337-.027-1.143-1.983-.16 1.88-.314-.024zm3.489.242.109-2.399 1.677.071-.013.283-1.348-.057-.034.743 1.167.05-.013.282-1.167-.049-.049 1.09-.329-.014zm1.833.079 1.004-2.383.355.007.97 2.42-.375-.008-.275-.732-1.041-.02-.288.722-.35-.007zm.738-.973.844.016-.247-.67a6.39 6.39 0 0 1-.166-.501 2.98 2.98 0 0 1-.143.456l-.288.7zm1.914 1.01.005-2.4h.33l-.006 2.401h-.33zm1.542-.006-.031-2.118-.82.011-.004-.283 1.972-.027.004.283-.823.012.031 2.117-.33.005zm2.442-.058-.116-2.398.329-.015.102 2.115 1.225-.055.014.283-1.554.07zm1.675-.073.776-2.46.354-.025 1.193 2.325-.374.026-.343-.705-1.038.071-.22.744-.348.024zm.644-1.033.841-.058-.308-.645a6.445 6.445 0 0 1-.213-.485c-.02.156-.053.312-.1.467l-.22.721zm2.921.758-.273-2.386 1.67-.178.032.282-1.342.143.084.739 1.161-.124.033.282-1.161.123.124 1.085-.328.034zm1.825-1.37c-.058-.394.006-.718.193-.972.186-.253.453-.404.8-.452a1.24 1.24 0 0 1 .64.073c.197.08.358.207.482.38.123.175.203.381.238.62.035.24.017.463-.056.667s-.194.368-.365.491c-.17.123-.362.2-.576.23a1.221 1.221 0 0 1-.646-.077 1.085 1.085 0 0 1-.48-.386 1.327 1.327 0 0 1-.23-.574zm.337-.041c.043.286.156.5.34.644a.817.817 0 0 0 .637.164.8.8 0 0 0 .57-.333c.133-.188.178-.435.132-.741a1.201 1.201 0 0 0-.176-.493.781.781 0 0 0-.347-.295.842.842 0 0 0-.458-.058.85.85 0 0 0-.561.311c-.144.176-.19.443-.137.8zm2.614.806-.444-2.363 1.085-.19a1.52 1.52 0 0 1 .51-.023.558.558 0 0 1 .315.177.673.673 0 0 1 .169.338.586.586 0 0 1-.09.453c-.09.135-.25.239-.48.31a.87.87 0 0 1 .218.084c.11.067.22.157.328.267l.547.569-.407.071-.417-.435a4.647 4.647 0 0 0-.295-.284c-.075-.065-.14-.108-.194-.13s-.108-.033-.16-.036a1.065 1.065 0 0 0-.182.02l-.376.066.197 1.049-.324.057zm.076-1.377.696-.122c.148-.026.262-.06.34-.105a.367.367 0 0 0 .189-.398.358.358 0 0 0-.178-.254c-.098-.057-.238-.07-.42-.038l-.774.136.147.781zm3.93-.262.34.01c-.007.269-.083.49-.227.66a1.034 1.034 0 0 1-.595.34c-.262.058-.487.053-.675-.015s-.347-.189-.478-.365a1.606 1.606 0 0 1-.275-.6 1.366 1.366 0 0 1-.004-.67c.054-.203.16-.37.316-.503s.341-.223.556-.27c.243-.053.46-.037.654.046a.973.973 0 0 1 .464.428l-.3.141a.757.757 0 0 0-.332-.32.693.693 0 0 0-.431-.028.813.813 0 0 0-.438.231.689.689 0 0 0-.183.405 1.39 1.39 0 0 0 .029.466c.046.2.117.367.212.502a.686.686 0 0 0 .358.273c.144.046.29.052.439.02a.71.71 0 0 0 .422-.25c.101-.126.15-.293.149-.5zm.916.653-.67-2.312 1.734-.467.079.273-1.416.381.205.708 1.326-.357.078.272-1.326.357.228.787 1.472-.396.079.273-1.79.481z'/%3e%3c/g%3e%3c/svg%3e";
            },
            7710: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 3'%3e%3cpath fill='%23436F4D' d='M0 0h6v3H0z'/%3e%3cpath fill='%23FFF' d='M0 0h6v2H0z'/%3e%3cpath fill='%23CD2A3E' d='M0 0h6v1H0z'/%3e%3c/svg%3e";
            },
            2126: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 2'%3e%3cpath fill='%23FFF' d='M0 0h3v2H0z'/%3e%3cpath fill='%23CE1126' d='M0 0h3v1H0z'/%3e%3c/svg%3e";
            },
            7884: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 300'%3e%3cpath d='M0 752.362h200v300H0z' style='fill:%23169b62;fill-opacity:1;stroke:none' transform='translate(0 -752.362)'/%3e%3cpath d='M200 752.362h200v300H200z' style='fill:%23fff;fill-opacity:1;stroke:none' transform='translate(0 -752.362)'/%3e%3cpath d='M400 752.362h200v300H400z' style='fill:%23ff883e;fill-opacity:1;stroke:none' transform='translate(0 -752.362)'/%3e%3c/svg%3e";
            },
            9571: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1100 800'%3e%3cpath fill='%23fff' d='M0 0h1100v800H0z'/%3e%3cpath fill='%230038b8' d='M0 75h1100v125H0zm0 525h1100v125H0z'/%3e%3cpath fill='none' stroke='%230038b8' stroke-width='27.5' d='M423.816 472.853h252.368L550 254.295zM550 545.705l126.184-218.558H423.816z'/%3e%3c/svg%3e";
            },
            2509: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 300'%3e%3cpath d='M0 0h600v300H0z' style='fill:%23cf142b;fill-opacity:1;fill-rule:nonzero;stroke:none'/%3e%3cpath d='M419.102 546.464c.291-.879.877-9.946.584-9.946-.293 0-13.747-15.793-13.454-15.793.294 0 17.257 3.803 17.257 3.216 0-.583 6.727-16.67 6.727-16.963 0-.291 8.19 19.597 8.19 19.597l16.67 7.313-11.7 9.65s2.634 18.72 2.634 19.013c0 .291-11.7-11.116-11.7-11.116l-12.87 1.463s-1.754-5.85-2.338-6.434z' style='font-size:12px;fill:%23f9dd16;fill-opacity:.98823499;fill-rule:evenodd;stroke:%23000;stroke-width:2.40245399pt' transform='translate(163.243 23.834) scale(.3498)'/%3e%3cpath d='M328.48 300.674c-11.114 5.723-53.768 54.478-59.618 62.082-4.9 11.04-14.486 25.005-24.36 33.995-10.54 7.973-16.397 18.866-14.946 29.18-.118 12.834 7.078 21.572 12.81 30.602 3.392 4.125 7.957 6.792 12.81 7.116 9.955 1.315 10.84 4.38 15.822 6.278 19.628 26.725 48.91 46.432 69.998 62.043 13.442 7.085 22.79 14.17 25.992 18.038 6.175 11.789 5.038 23.285 4.193 28.933-5.219 19.69-10.439 39.38-15.657 59.071-2.633 16.087 11.347 12.47 12.099 9.252 6.308-8.19 15.724-2.438 29.177-49.82 6.167-8.302 12.337-16.605 18.504-24.908 0 0 7.119-2.847 7.119-3.558 10.823-12.995 2.582-20.433-3.56-22.773-4.508-1.66-9.015-3.323-13.522-4.983 0 0-15.657-15.657-16.368-15.657-7.44-21.643-43.96-67.85-52.443-74.283-5.872-6.12-8.666-8.726-14.24-12.13-8.569-4.099-11.334-5.432-16.583-7.527-4.37-1.754-1.26-6.552 1.52-8.745 28.926-15.746 51.855-33.245 79.61-51.038l4.27-2.847-9.963-56.933c-15.42-5.456-30.84-10.915-46.26-16.37-2.426 1.66-4.269 3.322-6.405 4.982z' style='font-size:12px;fill:%23fff;fill-rule:evenodd;stroke:%23000;stroke-width:3.71638179;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' transform='translate(163.243 23.834) scale(.3498)'/%3e%3cpath d='M367.185 600.428c.147-.583 28.955-5.85 28.955-5.85s-3.364 10.677-3.51 10.677l-28.662 8.627 3.217-13.454z' style='font-size:12px;fill:%23f9dd16;fill-opacity:1;fill-rule:evenodd;stroke-width:1pt' transform='translate(163.243 23.834) scale(.3498)'/%3e%3cpath d='M292.113 491.958c5.557-14.77 20.983-26.466 31.345-29.692' style='font-size:12px;fill:none;stroke:%23000;stroke-width:2.40245399pt' transform='translate(163.243 23.834) scale(.3498)'/%3e%3cpath d='M366.15 600.688c1.86-.524 10.117-2.934 12.521-3.308 2.566-.601 5.12-1.274 7.587-2.069 2.847-.581 4.63-1.117 7.587-1.655 2.316-.884 4.606-1.49 7.083-2.069M360.934 618.5c.24-.322 2.203-2.057 3.613-2.895 1.66-.524 7.338-2.934 9.485-3.309 2.292-.6 4.572-1.273 6.775-2.068 2.544-.581 4.135-1.117 6.778-1.655 2.068-.884 4.113-1.49 6.323-2.069' style='font-size:12px;fill:none;stroke:%23000;stroke-width:2.65663357pt' transform='translate(163.243 23.834) scale(.3498)'/%3e%3cpath d='M372.632 496.138h-.414c1.295 0 .5-.108-1.242 2.068-.62 1.672-5.929 5.377-9.927 5.377-1.929.207-4.893.413-6.825.413-.55 0-1.31-.413-1.862-.413m19.856 77.765h2.067c2.145 0 4.298.382 6.205.413 2.069 0 4.137.586 6.206.586 2.087.296 4.603.2 6.763.507 2.421.082 4.365.56 6.885.56 2.032.077 3.128.416 5.38.416l-5.38-.416c2.032.077 3.128.416 5.38.416m-47.569 47.98c.22-.323 2.018-2.057 3.308-2.896 1.52-.523 6.72-2.933 8.687-3.308 2.097-.6 4.185-1.273 6.203-2.068 2.33-.582 3.786-1.118 6.206-1.656 1.895-.884 3.767-1.49 5.79-2.068m8.541-59.901c-1.17 3.397.345 4.25.972 5.716 1.091 1.42 3.875 3.584 8.274 4.963 1.696.457 3.001.904 4.964 1.656 1.3.12 1.939.444 2.895.826m-180.758-137.74h.413c-1.298 0-.52.084 1.655-1.655 1.343-1.502 2.465-2.182 3.721-3.722M260.02 464.8c.275 0 24.062-11.988 26.601-14.55 1.8-1.304 3.162-2.68 5.35-4.163 1.404-.732 2.41-1.672 3.725-2.481 1.093-1.583 2.52-2.54 3.308-3.988 1.46-1.266.833-2.638 2.018-4.164.56-1.561 1.607-4.192 1.948-5.622m30.295 17.791c.13.855-.38 3.49-.343 5.496-.082 2.326-3.073 9.51-6.689 11.655' style='font-size:12px;fill:none;stroke:%23000;stroke-width:2.40245399pt' transform='translate(163.243 23.834) scale(.3498)'/%3e%3cpath d='M290.53 447.356c.14 0 3.76 1.177 9.812 3.04 7.284 2.618 22.434 12.165 23.938 13.48 1.535 1.208 4.281 2.286 5.333 3.72 1.646 1.423 2.852 3.064 4.137 4.55 1.512 1.844 2.8 3.403 3.722 4.964 4.6 3.731 16.976 29.565 17.372 31.023a63.455 63.455 0 0 1 2.068 4.55c.918 1.058 1.54 2.552 2.482 4.138.865 2.056 1.833 2.993 2.898 4.55 1.369.951 3.214 2.758 4.963 3.721 1.864 1.595 3.613 2.244 4.963 3.31 1.951.83 23.751 14.61 24.763 15.3 1.991 1.6 8.072 7.901 3.803 12.485-1.812 1.55-3.443 3.601-4.99 4.478-1.576 1.579-3.77 2.285-5.581 3.102-9.821 2.902-14.823 1.862-16.755 1.862h-2.068M242.383 398.622c2.791 1.093 1.665.286 4.178 1.43 1.688.74 2.8.759 4.46 1.364 1.762.565 6.682 1.451 9.046 3.825 1.735 1.566 3.058 2.89 4.964 4.034 2.253 1.554 3.88 2.246 6.674 3.411 2.356.882 4.992 1.86 7.375 1.944 2.477.144 3.07.021 5.446.021h5.793-5.793 5.793' style='font-size:12px;fill:none;stroke:%23000;stroke-width:2.40245399pt' transform='translate(163.243 23.834) scale(.3498)'/%3e%3cpath d='M241.717 426.234c6.203-.414 16.543 1.448 16.75 1.448l13.65-.206c7.172-.692 8.755-3.448 9.928-5.38 2.688-4.134 4.55-5.583 6.619-8.684 3.308-2.482 7.86 3.308 8.067 3.308 11.58 10.962 2.273 24.404 1.653 24.817-5.79 5.31-7.032 5.653-10.547 2.275-3.517-4.137-4.55-5.996-7.445-7.445-5.583-2.688-17.166-.62-17.375-.62-.206 0-5.996 2.275-5.996 2.275-2.828 1.034-4.62 3.518-9.514 4.342-4.963.346-6.619-.137-9.1-4.135-3.309-5.17-1.656-11.376 3.31-11.995z' style='font-size:12px;fill:%23ffe606;fill-rule:evenodd;stroke:%23000;stroke-width:2.40245399pt' transform='translate(163.243 23.834) scale(.3498)'/%3e%3cpath d='M565.566 175.36c-.909.177-9.1 4.11-8.956 4.365.144.255-7.03 19.723-7.173 19.467-.144-.255-5.142-16.906-5.653-16.618-.51.286-17.828 2.306-18.084 2.45-.253.142 13.068-16.743 13.068-16.743l-1.795-18.116 14.146 5.469s15.027-11.47 15.283-11.613c.253-.143-3.956 15.646-3.956 15.646l7.583 10.502s-4.24 4.395-4.463 5.19z' style='font-size:12px;fill:%23f9dd16;fill-opacity:.98823499;fill-rule:evenodd;stroke:%23000;stroke-width:2.40245457pt' transform='translate(163.243 23.834) scale(.3498)'/%3e%3cpath d='M395.73 374.811c10.435 6.883 73.838 20.169 83.333 21.542 12.025-1.139 28.896.373 41.571 4.574 12.116 5.28 24.481 5.046 32.76-1.273 11.245-6.187 15.335-16.741 20.398-26.164 1.933-4.979 2.02-10.264-.075-14.654-3.734-9.322-1.495-11.595-2.283-16.868 13.676-30.207 16.505-65.389 19.777-91.422-.412-15.19 1.182-26.81 2.985-31.497 7.25-11.16 17.827-15.803 23.165-17.834 19.721-5.101 39.443-10.2 59.164-15.302 15.313-5.589 5.308-16.002 2.135-15.08-10.23-1.486-9.831-12.512-57.726-1.018-10.26-1.307-20.52-2.616-30.78-3.922 0 0-5.97-4.81-6.59-4.461-16.632-3.066-19.077 7.762-18.106 14.264.762 4.742 1.521 9.486 2.283 14.228 0 0-5.974 21.32-5.626 21.94-15.22 17.093-37.876 71.981-39.327 82.529-.686 9.91-4.43 8.121-3.426 17.754.038 7.528-.838 2.828 1.675 18.338.613 4.669-5.094 4.308-8.368 2.96-27.9-17.497-54.392-28.907-83.504-44.381l-4.574-2.326-44.744 36.586 8.401 48.346c2.636 1.302 4.989 2.093 7.482 3.141z' style='font-size:12px;fill:%23fff;fill-rule:evenodd;stroke:%23000;stroke-width:3.71638179;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' transform='translate(163.243 23.834) scale(.3498)'/%3e%3cpath d='M638.05 194.167c-.582.158-19.29-22.372-19.29-22.372s10.955-2.3 11.026-2.173l21.567 20.756-13.304 3.79z' style='font-size:12px;fill:%23f9dd16;fill-opacity:1;fill-rule:evenodd;stroke-width:1pt' transform='translate(163.243 23.834) scale(.3498)'/%3e%3cpath d='M580.29 312.765c-15.599 2.395-33.353-5.32-41.244-12.77' style='font-size:12px;fill:none;stroke:%23000;stroke-width:2.40245457pt' transform='translate(163.243 23.834) scale(.3498)'/%3e%3cpath d='M638.783 194.943c-1.368-1.365-7.515-7.381-9.02-9.294-1.782-1.942-3.62-3.839-5.522-5.6-1.902-2.196-3.242-3.487-5.161-5.802-1.906-1.585-3.555-3.284-5.274-5.16m43.059 21.673c-.398-.052-2.872-.913-4.294-1.731-1.27-1.19-6.153-4.958-7.532-6.647-1.647-1.703-3.35-3.36-5.124-4.891-1.753-1.933-3-3.057-4.764-5.097-1.784-1.37-3.314-2.855-4.902-4.498' style='font-size:12px;fill:none;stroke:%23000;stroke-width:2.65663414pt' transform='translate(163.243 23.834) scale(.3498)'/%3e%3cpath d='m544.473 240.531.202.36c-.634-1.129-.339-.382 2.412.07 1.761-.28 7.592 2.532 9.552 6.017 1.125 1.58 2.758 4.063 3.705 5.747.27.48.281 1.344.552 1.826m58.054-55.421-.202-.36-.81-1.44c-1.051-1.87-1.773-3.934-2.68-5.612-1.015-1.803-1.517-3.893-2.531-5.696-.766-1.965-2.082-4.11-2.873-6.144-1.115-2.15-1.651-4.08-2.886-6.276-.93-1.81-1.17-2.93-2.274-4.893l2.274 4.893c-.93-1.81-1.17-2.93-2.274-4.893m65.135 17.951c-.389-.035-2.782-.752-4.145-1.465-1.202-1.07-5.85-4.42-7.141-5.951-1.551-1.534-3.16-3.024-4.843-4.394-1.649-1.746-2.83-2.753-4.484-4.598-1.7-1.219-3.145-2.553-4.64-4.033m-56.4 21.911c3.534-.644 3.535-2.384 4.505-3.648.703-1.647 1.225-5.135.271-9.645-.433-1.702-.683-3.059-.99-5.138-.531-1.192-.562-1.908-.698-2.929m-31.477 225.067-.202-.36c.636 1.13.327.411-2.254-.632-1.967-.434-3.11-1.08-5.068-1.42m20.083-35.375c-.135-.24-22.242-15.1-25.72-16.058-2.018-.929-3.886-1.442-6.25-2.623-1.327-.864-2.64-1.28-3.989-2.03-1.916-.176-3.448-.952-5.097-.929-1.82-.652-2.708.566-4.619.282-1.635.277-4.442.653-5.855 1.056m.66-35.126c.682-.532 3.23-1.38 4.96-2.394 2.067-1.069 9.795-1.982 13.437.119' style='font-size:12px;fill:none;stroke:%23000;stroke-width:2.40245457pt' transform='translate(163.243 23.834) scale(.3498)'/%3e%3cpath d='M542.188 336.004c-.069-.121-.817-3.854-2.16-10.042-1.287-7.633-.39-25.518.019-27.473.3-1.93-.105-4.852.63-6.472.433-2.132 1.272-3.987 1.939-5.837.865-2.22 1.593-4.106 2.502-5.676.998-5.839 17.451-29.286 18.528-30.347a63.46 63.46 0 0 1 2.953-4.033c.472-1.318 1.47-2.593 2.39-4.19 1.368-1.762 1.71-3.065 2.546-4.756.158-1.66.829-4.154.811-6.15.477-2.407.186-4.25.454-5.95-.234-2.106 1.094-27.862 1.2-29.082.418-2.52 2.931-10.909 9.02-9.434 2.238.82 4.826 1.236 6.348 2.155 2.148.6 3.84 2.166 5.439 3.345 7.343 7.138 8.887 12.008 9.834 13.692l1.014 1.803m-82.461 193.466-.203-.36c.548.974.244.488-.45-1.645-.184-1.835-.75-4.317-1.035-6.061-.371-1.812-1.22-3.876-.99-5.138-.649-1.84-.24-3.36-.067-5.183.516-2.28.748-3.929.812-6.15.25-2.726.049-4.658.204-7.234-.718-2.12-.865-3.896-1.96-6.015-.973-2.026-1.718-3.9-2.883-5.972l-2.839-5.049 2.84 5.05-2.84-5.05' style='font-size:12px;fill:none;stroke:%23000;stroke-width:2.40245457pt' transform='translate(163.243 23.834) scale(.3498)'/%3e%3cpath d='M547.698 388.905c-3.4-5.205-6.845-15.13-6.946-15.31 0-.003-6.87-11.798-6.87-11.798-4.118-5.912-7.296-5.942-9.554-6.017-4.921-.317-7.097-1.23-10.814-1.513-3.785-1.668-.969-8.474-1.07-8.654 3.88-15.466 20.159-13.94 20.823-13.603 7.465 2.445 8.373 3.36 7.152 8.078-1.883 5.094-2.997 6.905-2.841 10.139.392 6.184 7.872 15.266 7.974 15.449.102.18 4.922 4.112 4.922 4.112 2.287 1.958 5.33 2.303 8.447 6.165 2.734 4.157 3.124 5.836.856 9.959-2.885 5.417-9.105 7.018-12.079 2.993z' style='font-size:12px;fill:%23f9dd16;fill-opacity:1;fill-rule:evenodd;stroke:%23000;stroke-width:2.40245457pt' transform='translate(163.243 23.834) scale(.3498)'/%3e%3cpath d='M238.862 224.504c.121-.366.365-4.14.243-4.14s-5.722-6.574-5.6-6.574c.122 0 7.183 1.583 7.183 1.339 0-.243 2.8-6.939 2.8-7.061 0-.121 3.409 8.157 3.409 8.157l6.939 3.044-4.87 4.017s1.096 7.792 1.096 7.914c0 .121-4.87-4.627-4.87-4.627l-5.357.609s-.73-2.435-.973-2.678z' style='fill:%23f9dd16;fill-opacity:.98823499;fill-rule:evenodd;stroke:%23000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' transform='rotate(117.437 234.631 155.127) scale(.84038)'/%3e%3cpath d='M201.141 122.196c-4.626 2.382-22.38 22.676-24.815 25.841-2.04 4.595-6.03 10.408-10.14 14.15-4.387 3.319-6.825 7.853-6.221 12.146-.049 5.342 2.946 8.979 5.332 12.738 1.412 1.717 3.312 2.827 5.332 2.962 4.144.547 4.512 1.823 6.586 2.613 8.17 11.124 20.358 19.327 29.136 25.825 5.595 2.949 9.486 5.898 10.819 7.508 2.57 4.907 2.097 9.692 1.745 12.043l-6.517 24.588c-1.096 6.696 4.723 5.19 5.036 3.851 2.626-3.409 6.545-1.015 12.145-20.737l7.702-10.368s2.963-1.185 2.963-1.481c4.505-5.409 1.075-8.505-1.482-9.479l-5.628-2.074s-6.517-6.517-6.813-6.517c-3.097-9.009-18.39-28.426-21.921-31.104-3.456-2.271-2.043-3.264-5.743-4.865-2.739-1.522-.855-.881-6.995-3.133-1.819-.73-.524-2.727.633-3.64 12.04-6.554 21.584-13.838 33.137-21.244l1.777-1.185-4.147-23.698-19.255-6.814c-1.01.691-1.777 1.383-2.666 2.074z' style='fill:%23fff;fill-opacity:1;fill-rule:evenodd;stroke:%23000;stroke-width:1.54691064;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' transform='rotate(117.437 234.631 155.127) scale(.84038)'/%3e%3cpath d='M217.252 246.966c.061-.243 12.052-2.435 12.052-2.435s-1.4 4.444-1.461 4.444l-11.93 3.591 1.339-5.6z' style='fill:%23f9dd16;fill-opacity:1;fill-rule:evenodd;stroke:none' transform='rotate(117.437 234.631 155.127) scale(.84038)'/%3e%3cpath d='M186.004 201.816c2.313-6.148 8.734-11.016 13.047-12.359' style='fill:none;stroke:%23000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' transform='rotate(117.437 234.631 155.127) scale(.84038)'/%3e%3cpath d='M216.821 247.074c.774-.218 4.211-1.221 5.212-1.377 1.068-.25 2.131-.53 3.158-.861 1.185-.242 1.927-.465 3.158-.689.964-.368 1.917-.62 2.948-.861m-16.647 11.202c.1-.134.917-.856 1.504-1.205.691-.218 3.054-1.221 3.948-1.377.954-.25 1.903-.53 2.82-.861 1.059-.242 1.721-.465 2.821-.689.861-.368 1.712-.62 2.632-.861' style='font-size:12px;fill:none;stroke:%23000;stroke-width:1.10579996pt' transform='rotate(117.437 234.631 155.127) scale(.84038)'/%3e%3cpath d='M219.519 203.556h-.172c.539 0 .208-.045-.517.861-.258.696-2.468 2.238-4.132 2.238-.803.086-2.037.172-2.841.172-.229 0-.545-.172-.775-.172m8.265 32.369h.86c.893 0 1.789.159 2.583.172.861 0 1.722.244 2.583.244.869.123 1.916.083 2.815.211 1.008.034 1.817.233 2.866.233.846.032 1.302.173 2.239.173l-2.239-.173c.846.032 1.302.173 2.239.173m-19.8 19.971c.092-.134.84-.856 1.377-1.205.633-.218 2.797-1.221 3.616-1.377.873-.25 1.742-.53 2.582-.861.97-.242 1.576-.465 2.583-.689.789-.368 1.568-.62 2.41-.861m3.555-24.933c-.487 1.414.144 1.769.405 2.379.454.591 1.613 1.492 3.444 2.066.706.19 1.249.376 2.066.689.541.05.807.185 1.205.344m-75.239-57.333h.172c-.54 0-.216.035.689-.689.559-.625 1.026-.908 1.549-1.549m8.738 14.503c.115 0 10.016-4.99 11.073-6.056.749-.543 1.316-1.116 2.227-1.733.584-.305 1.003-.696 1.55-1.033.455-.659 1.049-1.057 1.377-1.66.608-.527.347-1.098.84-1.733.233-.65.669-1.745.811-2.34m12.61 7.405c.054.356-.158 1.453-.143 2.288-.034.968-1.279 3.958-2.784 4.851' style='fill:none;stroke:%23000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' transform='rotate(117.437 234.631 155.127) scale(.84038)'/%3e%3cpath d='M185.345 183.251c.058 0 1.565.49 4.084 1.265 3.032 1.09 9.338 5.064 9.964 5.611.639.503 1.782.952 2.22 1.549.685.592 1.187 1.275 1.722 1.894.629.767 1.165 1.416 1.549 2.066 1.915 1.553 7.066 12.306 7.231 12.913.289.568.647 1.359.861 1.894.382.44.641 1.062 1.033 1.722.36.856.763 1.246 1.206 1.894.57.396 1.338 1.148 2.066 1.549.776.664 1.504.934 2.066 1.378.812.345 9.886 6.081 10.307 6.368.829.666 3.36 3.289 1.583 5.197-.754.645-1.433 1.499-2.077 1.864-.656.657-1.569.951-2.323 1.291-4.088 1.208-6.17.775-6.974.775h-.861m-53.373-69.385h.172c-.465 0-.227-.011.689.172.703.308 1.719.609 2.41.861.733.235 1.655.348 2.066.689.8.14 1.268.598 1.894 1.033.722.652 1.273 1.073 2.066 1.549.938.647 1.68.968 2.583 1.55.916.172 1.59.481 2.582.516.934.06 1.766.172 2.755.172h2.411-2.411 2.411m35.984-26.686h-.345c.637 0 .458-.023-.516.172-1.017.525-2.371.922-3.272 1.377-1.028.34-2.133.717-3.099 1.206-1.094.641-2.102 1.162-3.099 1.893-.991.531-1.965 1.185-2.927 1.722-.959.521-1.751 1.024-2.582 1.722-.694.385-1.637.93-2.411 1.549-.727.261-1.252.779-1.721 1.206-.911.807-1.469 1.226-2.411 2.066-.495.468-1.153 1.018-1.894 1.721-.778.519-1.62 1.517-2.238 2.066-.396.517-.976 1.132-1.549 1.55-.441.555-.952 1.285-1.55 1.722-.355.528-.976 1.216-1.55 1.894-.465.569-1.105 1.142-1.549 1.721-.598.662-1.056 1.329-1.722 1.894-.119.398-.369.604-.516.861' style='fill:none;stroke:%23000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' transform='rotate(117.437 234.631 155.127) scale(.84038)'/%3e%3cpath d='M165.027 174.459c2.582-.172 6.886.603 6.972.603l5.682-.086c2.985-.288 3.644-1.435 4.132-2.239 1.119-1.721 1.894-2.324 2.755-3.615 1.377-1.033 3.272 1.377 3.358 1.377 4.82 4.563.946 10.158.688 10.33-2.41 2.21-2.927 2.353-4.39.947-1.464-1.722-1.894-2.496-3.099-3.099-2.324-1.119-7.145-.258-7.232-.258-.086 0-2.496.947-2.496.947-1.177.43-1.923 1.464-3.96 1.807-2.066.144-2.755-.057-3.788-1.721-1.377-2.152-.689-4.735 1.378-4.993z' style='fill:%23f9dd16;fill-opacity:1;fill-rule:evenodd;stroke:%23000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' transform='rotate(117.437 234.631 155.127) scale(.84038)'/%3e%3cpath d='M332.302 290.148c-2.276-2.067 42.81 16.337 49.014 16.546 8.48-3.102 43.433-32.676 43.433-32.676.345 2.895 1.584 10.409 4.96 11.996-13.51 10.962-25.781 21.508-39.292 32.468.966 17.373-2.205 35.78 6.618 55.221 0 0-10.546.205-10.546 0-9.307-9.307-12.618-54.185-12.618-54.185-14.821-6.619-29.644-13.029-44.465-19.648 2.138-1.38 3.86-5.652 2.896-9.722z' style='font-size:12px;fill:%23f9dd16;fill-opacity:.98742095;fill-rule:evenodd;stroke:%23000;stroke-width:2.40244999pt' transform='translate(163.243 23.834) scale(.3498)'/%3e%3cpath d='M375.199 336.153c.72-.523-8.133 4.113-10.407 5.277-40.961 21.85-62.04 53.634-63.354 54.835-.708 1.354-2.011 3.16-3.204 4.929-.96 1.483-2.338 3.018-3.246 4.518-1.255 1.738-3.893 5.17-5.334 6.694-.18.982.683-.336.4.317m113.133-102.538c-.795-.402 7.378 5.351 9.453 6.84 38.166 26.431 76.072 30.638 77.74 31.257 1.529.01 3.73.343 5.849.595 1.759.175 3.753.698 5.503.82 2.119.32 6.378 1.096 8.393 1.681.954-.29-.611-.453.098-.502' style='font-size:12px;fill:none;stroke:%23000;stroke-width:2.40244999pt' transform='translate(163.243 23.834) scale(.3498)'/%3e%3c/svg%3e";
            },
            2908: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 225 150'%3e%3cpath fill='%23f93' d='M0 0h225v150H0z'/%3e%3cpath fill='%23fff' d='M0 50h225v50H0z'/%3e%3cpath fill='%23128807' d='M0 100h225v50H0z'/%3e%3cg transform='translate(112.5 75)'%3e%3ccircle r='20' fill='%23008'/%3e%3ccircle r='17.5' fill='%23fff'/%3e%3ccircle r='3.5' fill='%23008'/%3e%3cg id='d'%3e%3cg id='c'%3e%3cg id='b'%3e%3cg id='a' fill='%23008'%3e%3ccircle r='.875' transform='rotate(7.5 -8.75 133.5)'/%3e%3cpath d='M0 17.5.6 7 0 2l-.6 5L0 17.5z'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='rotate(15)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(30)'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='rotate(60)'/%3e%3c/g%3e%3cuse xlink:href='%23d' transform='rotate(120)'/%3e%3cuse xlink:href='%23d' transform='rotate(-120)'/%3e%3c/g%3e%3c/svg%3e";
            },
            141: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 600 300'%3e%3cdefs%3e%3cclipPath id='c'%3e%3cpath d='M0 0v75h350v75h-50zm300 0H150v200H0v-50z'/%3e%3c/clipPath%3e%3cclipPath id='b'%3e%3cpath d='M0 0h300v150H0z'/%3e%3c/clipPath%3e%3c/defs%3e%3cpath fill='%23FFF' d='M0 0h600v300H0z'/%3e%3cpath id='a' fill='%23002b7f' d='M600 260.881c-6.723 4.045-12.499 13.498-30.36 13.498-35.711 0-44.641-19.902-71.427-19.902-17.856 0-26.785 19.902-44.641 19.902-35.715 0-44.643-19.902-71.429-19.902-17.857 0-26.786 19.902-44.643 19.902-35.714 0-44.643-19.902-71.428-19.902-17.858 0-26.786 19.902-44.643 19.902-35.714 0-44.643-19.902-71.429-19.902-17.858 0-26.786 19.902-44.643 19.902-35.714 0-44.643-19.902-71.428-19.902-17.858 0-23.215 14.182-33.929 14.182v25.621c10.714 0 16.071-14.181 33.929-14.181 26.785 0 35.714 19.901 71.428 19.901 17.857 0 26.785-19.901 44.643-19.901 26.785 0 35.715 19.901 71.429 19.901 17.857 0 26.785-19.901 44.643-19.901 26.785 0 35.714 19.901 71.428 19.901 17.857 0 26.786-19.901 44.643-19.901 26.786 0 35.714 19.901 71.429 19.901 17.856 0 26.785-19.901 44.641-19.901 26.786 0 35.716 19.901 71.427 19.901 17.861 0 23.637-5.64 30.36-9.684v-29.435z'/%3e%3cuse xlink:href='%23a' transform='translate(0 -49.753)'/%3e%3cuse xlink:href='%23a' transform='translate(0 -99.507)'/%3e%3cuse xlink:href='%23a' transform='translate(0 -149.26)'/%3e%3cuse xlink:href='%23a' transform='translate(0 -199.014)'/%3e%3cuse xlink:href='%23a' transform='translate(0 -248.768)'/%3e%3cpath fill='%23FFF' d='M0 0h300v152H0z'/%3e%3cg clip-path='url(%23b)'%3e%3cpath fill='%2300247d' d='M0 0h300v150H0z'/%3e%3cpath stroke='%23fff' stroke-width='30' d='m0 0 300 150m0-150L0 150'/%3e%3cpath stroke='%23cf142b' stroke-width='20' d='m0 0 300 150m0-150L0 150' clip-path='url(%23c)'/%3e%3cpath stroke='%23fff' stroke-width='50' d='M150 0v200M0 75h350'/%3e%3cpath stroke='%23cf142b' stroke-width='30' d='M150 0v200M0 75h350'/%3e%3c/g%3e%3cpath d='M814.961-301.181 797.244 407.48c0 37.298 80.097 37.298 88.583 0L868.11-301.181h-53.149z' style='fill:%23a24300;stroke-width:6.935;stroke:%23fff' transform='matrix(.12095 0 0 .28726 347.839 166.046)'/%3e%3cg transform='matrix(.43857 0 0 .37683 122.2 25.058)'%3e%3cg transform='matrix(-.31451 .10485 -.1383 -.30323 1046.472 373.319)'%3e%3cg id='d' style='fill:none;stroke-width:1;stroke:%23000'%3e%3cpath d='m496.063 549.213 17.717 70.866 35.433-53.15-17.717 88.583 35.433-35.433-35.433 88.582 35.433-35.433-35.433 88.583 35.433-35.433-35.433 106.299 35.433-35.433-35.433 106.299 35.433-35.433-35.433 106.299-17.716 53.151-17.717 17.72-17.717-17.72-17.716-53.151-35.433-106.299 35.433 35.433-35.433-106.299 35.433 35.433-35.433-106.299 35.433 35.433-35.433-88.583 35.433 35.433-35.433-88.582 35.433 35.433-17.717-88.583 35.433 53.15 17.717-70.866z' style='fill:%23006d00;stroke-width:8.25;stroke:%23fff' transform='translate(177.166 -224.052)'/%3e%3cpath d='M673.228 325.161v496.067m-70.866-177.17 70.866 106.3 70.866-106.3'/%3e%3cpath d='m602.362 573.192 70.866 106.3 70.866-106.3'/%3e%3cpath d='m602.362 502.326 70.866 106.3 70.866-106.3'/%3e%3cpath d='m602.362 449.176 70.866 88.583 70.866-88.583'/%3e%3cpath d='m602.362 396.027 70.866 88.582 70.866-88.582'/%3e%3cpath d='m620.079 342.877 53.15 106.3 53.15-106.3'/%3e%3c/g%3e%3c/g%3e%3cuse xlink:href='%23d' transform='matrix(.23652 -.28186 .29496 .22762 354.567 204.654)'/%3e%3cuse xlink:href='%23d' transform='matrix(.15164 .33524 -.3329 .1673 907.539 -153.47)'/%3e%3cuse xlink:href='%23d' transform='matrix(-.20952 .30246 -.3147 -.19945 1141.363 167.58)'/%3e%3cuse xlink:href='%23d' transform='matrix(-.20772 -.25838 .23618 -.23515 689.986 567.277)'/%3e%3cg transform='matrix(-.36218 -.09947 -.2098 .31773 1222.415 -24.23)'%3e%3cg id='e' style='fill:none;stroke-width:1;stroke:%23000'%3e%3cpath d='m460.63 549.213 28.643 70.866 42.223-53.15-10.184 88.583 27.9-35.433-17.716 88.582 25.249-35.433-25.249 88.583 35.433-35.433-35.433 106.299 35.433-35.433-35.433 106.299 35.433-35.433-35.433 106.299-17.716 53.151-17.717 17.72-17.717-17.72-17.716-53.151-35.433-106.299 35.433 35.433-35.433-106.299 35.433 35.433-35.433-106.299 35.433 35.433-45.617-88.583 45.617 35.433-53.15-88.582 42.966 35.433-25.25-88.583 35.433 53.15.001-70.866z' style='fill:%23006d00;stroke-width:8.25;stroke:%23fff' transform='translate(283.465 -124.016)'/%3e%3cpath d='m750.673 460.63 28.855 124.016v336.618'/%3e%3cpath d='m719.695 761.81 59.833 88.583 60.682-88.582'/%3e%3cpath d='m717.998 690.945 61.53 88.582 60.682-88.582'/%3e%3cpath d='m718.846 620.079 60.682 88.582 59.833-88.582'/%3e%3cpath d='m716.3 566.929 63.228 70.866 53.149-70.866'/%3e%3cpath d='m708.662 513.78 70.866 70.865 45.406-70.865'/%3e%3cpath d='m719.589 469.222 53.15 86.886 35.327-95.478'/%3e%3c/g%3e%3c/g%3e%3cuse xlink:href='%23e' transform='matrix(.36088 .10411 .01321 .38053 452.761 -239.266)'/%3e%3cg style='fill:none;stroke-width:1;stroke:%23000'%3e%3cpath d='m354.331 531.496 88.583 88.583 17.716-53.149v88.582l35.433-35.433-17.716 88.583 35.432-35.434-17.716 88.584 35.433-35.433-17.716 106.299 35.433-35.433-35.433 106.299 35.433-35.433-17.717 106.298-17.716 53.151-17.717 17.72-17.717-17.72-17.716-53.151-53.15-82.294 35.434 11.429-35.433-106.299 35.433 35.433-53.15-106.299 35.433 35.433-53.15-88.584 53.15 35.434-70.866-88.583 53.149 35.433-70.866-70.866 70.866 35.433-53.149-88.583z' style='fill:%23006d00;stroke-width:8.25;stroke:%23fff' transform='matrix(.04613 -.36474 .32602 .0648 386.005 315.21)'/%3e%3cpath d='m378.962 560.015 63.952 95.497 17.716 53.15 8.859 45.205 8.858 78.811 9.315 70.866 8.401 141.736' transform='matrix(.04613 -.36474 .32602 .0648 386.005 315.21)'/%3e%3cpath d='m425.197 903.544 63.665 70.866 50.749-88.583' transform='matrix(.04613 -.36474 .32602 .0648 386.005 315.21)'/%3e%3cpath d='m417.082 814.961 70.579 88.583 50.75-88.583' transform='matrix(.04613 -.36474 .32602 .0648 386.005 315.21)'/%3e%3cpath d='m407.48 752.443 70.867 80.235 45.948-88.583M372.047 637.796l88.583 70.866 25.831-70.866' transform='matrix(.04613 -.36474 .32602 .0648 386.005 315.21)'/%3e%3cpath d='m360.618 602.363 82.296 53.149 10.515-53.149m-63.665 88.582 81.095 70.866 33.946-70.866' transform='matrix(.04613 -.36474 .32602 .0648 386.005 315.21)'/%3e%3c/g%3e%3c/g%3e%3cpath d='m52.504 257.674 98.536-17.68 102.642 17.68-47.626 19.801-87.861 1.415-65.691-21.216z' style='fill:%239d9d9d;stroke-width:1.008;stroke:%23000' transform='translate(412 157.18) scale(.25333)'/%3e%3cpath d='M151.789 98.445c-17.223 5.987-36.302-8.425-67.359 15.094 0 0-54.144-23.163-58.257 30.371-.165 2.167 8.57 15.223 9.786 14.29 6.804-5.224-3.23 5.072-3.23 6.56 0 1.5.998 2.333 1.335 2.994.331.667 1.163 1.665 1.329 4.494.165 2.828-6.137 10.544-3.474 13.372 2.657 2.829 2.822 10.984 2.822 13.311 0 2.326 1.666 8.816 2.829 10.151 1.163 1.328 3.159 4.653 3.159 7.481 0 2.829 1.163 10.647.661 12.637-.496 1.996 2.994 4.494 6.16 5.492 3.159.998 43.935 1.706 101.162.708 57.233-.998 76.328 8.057 99.974-.543 3.655-1.328 4.322-4.322 3.992-5.988-.337-1.659 0-6.979.998-8.314.998-1.328 7.653-11.975 6.318-13.971 1.256-1.134 10.589 5.39 4.645-.436-1.524-1.493.853-17.216 1.673-20.528.827-3.318 2.096-9.549 3.621-10.706 1.532-1.157-2.598-5.488-2.305-6.27.298-.788 1.411-3.229 2.962-4.341 0 0 2.885-13.527 1.106-20.176-1.767-6.655-8.27-36.583-48.862-30.588 0 0-54.34-20.9-71.045-15.094z' style='fill:%23c00;stroke-width:1.629;stroke:%23000' transform='translate(412 157.18) scale(.25333)'/%3e%3cg transform='translate(413.752 163.796) scale(.27506)'%3e%3cg stroke-width='1.241' transform='matrix(.49697 -.0446 .08947 .72677 44.7 100.543)'%3e%3cg id='f'%3e%3cpath d='M49.75.125c-5.093.89-15.156 29.245-12.609 38.75 1.763 6.58 4.498 11.12 6.047 13.906-3.405-4.685-11.383-13.75-22.25-13.75-13.664 0-15.431 29.948-15.094 31.875.001.007-.002.026 0 .032.001.004.029.027.031.031h.031c.613-.715 6.142-13.094 19.657-13.094 8.896 0 15.829 7.035 18.375 10.031-.001.945.022 1.858.031 2.782-2.004 2.828-3.282 9.531-9.469 17.968C27.023 98.852 4.128 99.897.281 100h49.532c.047 0 .109.003.156 0 .022.002.04-.001.062 0 .047.003.109 0 .157 0h49.531c-3.847-.103-27.18-1.148-34.656-11.344-6.188-8.437-7.028-15.14-9.032-17.968.009-.924.032-1.837.032-2.782 2.545-2.996 9.478-10.031 18.375-10.031 13.514 0 19.043 12.379 19.656 13.094h.031c.002-.004.03-.027.031-.031.002-.006-.001-.025 0-.032.337-1.927-1.43-31.875-15.093-31.875-10.868 0-18.846 9.065-22.25 13.75 1.548-2.786 4.29-8.575 5.718-13.906C65.118 29.219 55.091.132 50 .125c-.08 0-.169-.014-.25 0zm-6.437 52.844c.352.49.662.912.906 1.281.005.008.541 2.977.547 2.984-.003.064 2.627 10.186 2.624 10.25-.264-.392-3.737-13.915-4.077-14.515zm13.375 0c-.341.6-4.033 14.123-4.297 14.515-.003-.064 3.393-13.139 3.39-13.203 0-.01-.437 2.964-.437 2.953.244-.369.991-3.775 1.344-4.265z' style='fill:%23f7d917;stroke-width:1.241;stroke:%23000'/%3e%3cpath d='M42 67.578s4-1.859 8-1.859 8 1.859 8 1.859v4.953s-4-1.859-8-1.859-8 1.859-8 1.859v-4.953z' style='fill:%23f7d917;stroke-width:1.241;stroke:%23000'/%3e%3c/g%3e%3c/g%3e%3cuse xlink:href='%23f' transform='matrix(.49538 .0597 -.0636 .7295 168.919 96.59)'/%3e%3cg style='fill:%23f7d917;stroke-width:.715;stroke:%23000'%3e%3cpath d='m24.308 134.56 9.69-11.814s.903 1.168 0 0C14.132 97.065 13.127 82.331 15.363 74.87c2.236-7.461 6.709-15.544 18.635-25.493 11.926-9.948 20.156-4.419 31.336-4.419 11.181 0 14.163 2.487 23.852 3.731 9.69 1.243 35.778 2.487 35.778 2.487v-6.84s1.029.192 0 0c-11.518-2.147-26.088 0-35.778-2.487-9.689-2.487-17.889-3.108-28.324-3.108-10.435 0-17.92-3.043-24.628 1.31-6.709 4.352-14.908 11.813-20.871 18.031C9.4 64.3 6.419 76.735 7.164 84.818c.746 8.083 3.727 14.923 8.199 21.14 4.473 6.218 3.727 11.192 5.218 15.544 1.491 4.353 3.727 13.679 3.727 13.058zm214.947 0-9.69-11.814s-.904 1.168 0 0c19.865-25.681 20.87-40.415 18.634-47.876-2.236-7.461-6.708-15.544-18.634-25.493-11.926-9.948-20.156-4.419-31.337-4.419-11.181 0-14.162 2.487-23.852 3.731-9.69 1.243-35.778 2.487-35.778 2.487v-6.84s-1.029.192 0 0c11.519-2.147 26.088 0 35.778-2.487 9.69-2.487 17.889-3.108 28.324-3.108 10.436 0 17.92-3.043 24.629 1.31 6.708 4.352 14.907 11.813 20.87 18.031 5.963 6.218 8.945 18.653 8.199 26.736-.745 8.083-3.727 14.923-8.199 21.14-4.472 6.218-3.727 11.192-5.217 15.544-1.491 4.353-3.727 13.679-3.727 13.058z'/%3e%3cpath d='M115.553 38.701h34.563v70.894h-34.563z' style='stroke-width:.835'/%3e%3c/g%3e%3cg style='fill:%23f7d917;stroke-width:.5;stroke:%23000'%3e%3cpath d='M119.684-23.799s3.72 3.028 6.575 6.922c2.856 3.893 4.846 8.652 4.846 8.652s-4.759-1.99-8.652-4.846c-3.894-2.855-6.922-6.575-6.922-6.575V6.656s3.028-3.72 6.922-6.575c3.893-2.856 8.652-4.846 8.652-4.846s-1.534 3.927-2.524 8.653c-.891 4.25-8.183 14.064-8.183 14.064l21.303 1.429s-3.542-11.243-4.969-15.493c-1.536-4.578-2.167-8.653-2.167-8.653s4.759 1.99 8.653 4.846c3.893 2.855 6.921 6.575 6.921 6.575v-26.302s-3.028 3.72-6.921 6.575c-3.894 2.856-8.653 4.846-8.653 4.846s1.99-4.759 4.846-8.652c2.855-3.894 6.575-6.922 6.575-6.922h-26.302z'/%3e%3cpath d='M149.978 23.076a17.143 17.143 0 1 1-34.286 0 17.143 17.143 0 1 1 34.286 0z'/%3e%3cpath d='M116.074 25.535h34.102s.494-6.596-1.974-9.064h-10.594l-.179-9.888h-10.042l-.179 9.888s-7.127.357-10.41.357c-1.489 4.041-1.26 4.381-1.26 4.381l.536 4.326z'/%3e%3c/g%3e%3cg style='fill:%23f7d917;stroke-width:.75;stroke:%23000'%3e%3cpath d='M110.877 107.221s6.212 5.056 10.979 11.557c4.767 6.501 8.09 14.446 8.09 14.446s-7.946-3.323-14.446-8.09c-6.501-4.767-11.557-10.979-11.557-10.979v43.916s5.056-6.211 11.557-10.979c6.5-4.767 14.446-8.09 14.446-8.09s-3.323 7.946-8.09 14.447c-4.767 6.5-10.979 11.557-10.979 11.557h43.916s-6.212-5.057-10.979-11.557c-4.767-6.501-8.09-14.447-8.09-14.447s7.946 3.323 14.446 8.09c6.501 4.768 11.557 10.979 11.557 10.979v-43.916s-5.056 6.212-11.557 10.979c-6.5 4.767-14.446 8.09-14.446 8.09s3.323-7.945 8.09-14.446c4.767-6.501 10.979-11.557 10.979-11.557h-43.916zM27.24 181.78l21.625-3.813s-6.995-3.901-12.819-9.475c-5.824-5.574-10.476-12.822-10.476-12.822s8.402 1.892 15.632 5.458c7.23 3.566 13.288 8.806 13.288 8.806l-7.626-43.249s-3.901 6.995-9.475 12.819c-5.574 5.824-12.822 10.475-12.822 10.475s1.892-8.401 5.458-15.631c3.566-7.23 8.806-13.288 8.806-13.288l-21.625 3.813L27.24 181.78zm199.599-60.72s5.24 6.058 8.806 13.288c3.566 7.23 5.458 15.631 5.458 15.631s-7.248-4.651-12.822-10.475c-5.574-5.824-9.475-12.819-9.475-12.819l-7.626 43.249s6.058-5.24 13.288-8.806c7.23-3.566 15.632-5.458 15.632-5.458s-4.652 7.248-10.476 12.822c-5.823 5.574-12.819 9.475-12.819 9.475l21.625 3.813 10.034-56.907-21.625-3.813z'/%3e%3cpath d='m27.464 179.533.15 31.506s52.648-17.928 105.296-17.928 105.296 17.928 105.296 17.928v-31.506s-52.685-17.929-105.371-17.929c-52.686 0-105.371 17.929-105.371 17.929z'/%3e%3c/g%3e%3cg fill='%23FFF' stroke='%23000'%3e%3cg transform='translate(21.246 -360.32) scale(.66123)'%3e%3cpath id='g' d='M2.02 723.052a12.122 12.122 0 1 1-24.243 0 12.122 12.122 0 1 1 24.243 0z'/%3e%3c/g%3e%3cuse xlink:href='%23g' transform='translate(10.965 -378.602) scale(.66123)'/%3e%3cuse xlink:href='%23g' transform='translate(8.822 -400.03) scale(.66123)'/%3e%3cuse xlink:href='%23g' transform='translate(15.25 -420.03) scale(.66123)'/%3e%3cuse xlink:href='%23g' transform='translate(28.822 -436.459) scale(.66123)'/%3e%3cuse xlink:href='%23g' transform='translate(47.394 -447.887) scale(.66123)'/%3e%3cuse xlink:href='%23g' transform='translate(68.108 -446.459) scale(.66123)'/%3e%3cuse xlink:href='%23g' transform='translate(88.822 -443.03) scale(.66123)'/%3e%3cuse xlink:href='%23g' transform='translate(109.537 -440.887) scale(.66123)'/%3e%3cuse xlink:href='%23g' transform='matrix(-.66123 0 0 .66123 242.316 -360.32)'/%3e%3cuse xlink:href='%23g' transform='matrix(-.66123 0 0 .66123 252.597 -378.602)'/%3e%3cuse xlink:href='%23g' transform='matrix(-.66123 0 0 .66123 254.74 -400.03)'/%3e%3cuse xlink:href='%23g' transform='matrix(-.66123 0 0 .66123 248.312 -420.03)'/%3e%3cuse xlink:href='%23g' transform='matrix(-.66123 0 0 .66123 234.74 -436.459)'/%3e%3cuse xlink:href='%23g' transform='matrix(-.66123 0 0 .66123 216.169 -447.887)'/%3e%3cuse xlink:href='%23g' transform='matrix(-.66123 0 0 .66123 195.454 -446.459)'/%3e%3cuse xlink:href='%23g' transform='matrix(-.66123 0 0 .66123 174.74 -443.03)'/%3e%3cuse xlink:href='%23g' transform='matrix(-.66123 0 0 .66123 154.026 -440.887)'/%3e%3cg transform='translate(1.04)'%3e%3cuse xlink:href='%23g' transform='translate(138.474 -378.32) scale(.66123)'/%3e%3cuse xlink:href='%23g' transform='translate(138.474 -392.602) scale(.66123)'/%3e%3cuse xlink:href='%23g' transform='translate(138.474 -404.03) scale(.66123)'/%3e%3cuse xlink:href='%23g' transform='translate(138.474 -414.459) scale(.66123)'/%3e%3cuse xlink:href='%23g' transform='translate(138.474 -447.887) scale(.66123)'/%3e%3cuse xlink:href='%23g' transform='translate(138.474 -446.459) scale(.66123)'/%3e%3cuse xlink:href='%23g' transform='translate(138.474 -439.03) scale(.66123)'/%3e%3cuse xlink:href='%23g' transform='translate(138.474 -428.887) scale(.66123)'/%3e%3c/g%3e%3c/g%3e%3cg fill='%23FFF' stroke='%23000'%3e%3cg transform='translate(-.457 -2)'%3e%3cpath id='h' d='M143.571 136.291a10.357 10.357 0 1 1-20.714 0 10.357 10.357 0 1 1 20.714 0z'/%3e%3c/g%3e%3cuse xlink:href='%23h' transform='translate(-108.714 16.786)'/%3e%3cuse xlink:href='%23h' transform='translate(107.286 16.786)'/%3e%3c/g%3e%3c/g%3e%3cpath d='M134.791 210.096h34.762v15.153h-34.762z' style='fill:%23002b7f;stroke-width:.841;stroke:%23000' transform='translate(412 157.18) scale(.25333)'/%3e%3cpath d='M16.043 233.111a22.995 8.556 0 1 1-45.99 0 22.995 8.556 0 1 1 45.99 0z' style='fill:%233e8225;stroke-width:1.5;stroke:%23000' transform='matrix(-.1718 -.01744 .00604 .24262 461.52 156.97)'/%3e%3cpath d='m36.937 229.285-8.709 8.709 10.101 5.832 23.493-6.294-4.187-13.304-20.698 5.057zm230.469 0 8.71 8.709-10.102 5.832-23.493-6.294 4.187-13.304 20.698 5.057z' style='fill:%23c00;stroke-width:1.086;stroke:%23000' transform='translate(412 157.18) scale(.25333)'/%3e%3cpath d='M16.043 233.111a22.995 8.556 0 1 1-45.99 0 22.995 8.556 0 1 1 45.99 0z' style='fill:%233e8225;stroke-width:1.5;stroke:%23000' transform='matrix(.1718 -.01744 -.00604 .24262 439.58 156.97)'/%3e%3cg fill='%23FFF' stroke='%23000' transform='translate(412 157.18) scale(.25333)'%3e%3cg transform='translate(1.07 -3.476)'%3e%3cpath id='i' d='M126.203 214.704a4.278 4.278 0 1 1-8.556 0 4.278 4.278 0 1 1 8.556 0z'/%3e%3c/g%3e%3cuse xlink:href='%23i' transform='translate(2.406 10.16)'/%3e%3cuse xlink:href='%23i' transform='translate(-52.406 6.15)'/%3e%3cuse xlink:href='%23i' transform='translate(-47.059 18.984)'/%3e%3cuse xlink:href='%23i' transform='matrix(-1 0 0 1 303.075 -3.476)'/%3e%3cuse xlink:href='%23i' transform='matrix(-1 0 0 1 301.738 10.16)'/%3e%3cuse xlink:href='%23i' transform='matrix(-1 0 0 1 356.55 6.15)'/%3e%3cuse xlink:href='%23i' transform='matrix(-1 0 0 1 351.203 18.984)'/%3e%3c/g%3e%3cpath d='M238.538 280.603c3.267-.567 22.977-5.253 27.127-7.76-2.678-4.828-7.484-8.605-3.744-7.018 2.014.855 3.607-5.799-2.239-10.885-16.973 5.567-57.68 15.739-108.829 15.739-52.344 0-93.562-10.707-110.535-16.273-5.846 5.086-4.025 10.864-4.378 13.023-.003.017.003 2.725 1.069 4.879 5.754 6.251 24.394 9.332 27.662 9.9 15.352 2.666 30.705 6.697 86.148 6.697 51.289 0 72.366-5.635 87.719-8.302z' style='fill:%23fff;stroke-width:1.714;stroke:%23000' transform='translate(412 157.18) scale(.25333)'/%3e%3cg transform='translate(391.394 139.673) scale(.27506)'%3e%3cpath d='M132.906 289.655c-3.009.523-22.147 7.301-25.968 9.61.003.014-.003.045 0 .061.325 1.988-3.322 11.251 2.062 15.935 15.632-5.127 59.525-20.406 106.634-20.406 48.209 0 88.14 15.279 103.772 20.406 5.384-4.684 1.737-13.947 2.063-15.935.003-.016-.004-.047 0-.061-3.822-2.309-22.96-9.087-25.969-9.61-14.14-2.455-28.772-11.586-79.835-11.586-47.237 0-68.619 9.131-82.759 11.586z' style='fill:%23fff;stroke-width:1.578;stroke:%23000'/%3e%3cg transform='matrix(1.38439 -.14324 .15642 1.26776 -86.626 -64.755)'%3e%3cg id='k' fill='%23000' stroke='%23000'%3e%3cg transform='translate(56.864 150.9) scale(.4996)'%3e%3cpath id='j' d='M115.508 301.56a1.872 1.872 0 1 1-3.743 0 1.872 1.872 0 1 1 3.743 0z'/%3e%3c/g%3e%3cuse xlink:href='%23j' transform='translate(55.527 153.307) scale(.4996)'/%3e%3cuse xlink:href='%23j' transform='translate(57.398 154.911) scale(.4996)'/%3e%3cpath d='m113.518 303.669 8.526-3.166-4.185 2.392 2.686-.083-2.492 1.168 4.001.275-8.536-.586z'/%3e%3c/g%3e%3c/g%3e%3cuse xlink:href='%23k' transform='matrix(1.38439 -.14324 .15642 1.26776 -45.032 -76.658)'/%3e%3cuse xlink:href='%23k' transform='matrix(1.37843 .19234 -.15163 1.26835 100.17 -120.86)'/%3e%3cuse xlink:href='%23k' transform='matrix(1.38439 .14324 .15642 -1.26776 54.434 659.458)'/%3e%3cuse xlink:href='%23k' transform='matrix(1.38439 .14324 .15642 -1.26776 96.412 670.42)'/%3e%3c/g%3e%3c/svg%3e";
            },
            8247: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3cpath fill='%23ce1126' d='M0 0h900v600H0z'/%3e%3cpath fill='%23fff' d='M0 200h900v400H0z'/%3e%3cpath d='M0 400h900v200H0z'/%3e%3cg fill='%23007a3d' transform='translate(-1.009 -.584) scale(2.18978)'%3e%3cpath d='M246.026 120.178c-.558-.295-1.186-.768-1.395-1.054-.314-.438-.132-.456 1.163-.104 2.318.629 3.814.383 5.298-.873l1.308-1.103 1.54.784c.848.428 1.748.725 2.008.656.667-.176 2.05-1.95 2.005-2.564-.054-.759.587-.568.896.264.615 1.631-.281 3.502-1.865 3.918-.773.201-1.488.127-2.659-.281-1.438-.502-1.684-.494-2.405.058-1.618 1.239-3.869 1.355-5.894.299zm5.734-5.242c-.563-.717-1.239-3.424-1.021-4.088.192-.576.391-.691.914-.527.918.287 1.13.92.993 3.064-.107 1.747-.366 2.206-.886 1.551zm-67.516-1.946c-.185 1.311 2.325 4.568 3.458 5.158-.77.345-1.728.188-2.434.576-3.948 3.948-18.367 18.006-21 21.366 7.799.154 16.448-.106 23.761-.44-.007-5.299 5.018-5.572 8.381-7.502 1.73 2.725 6.075 2.516 6.618 6.617 0 4.91.009 12.307.009 17.646h-66.625c-1.172 5.176-5.844 9.125-12.354 7.5 2.014-2.104 5.405-2.827 6.619-5.734 1.024-6.365-2.046-10.296-4.031-13.906 3.284-1.195 3.782-1.494 7.121-3.737-2.344 7.12 6.091 6.338 12.353 6.175.211-2.417.089-5.271-1.766-5.624 2.396-.87 2.794-1.168 6.619-4.412v9.593c14.886 0 30.942-.111 46.139-.111 0-3.002.795-7.824-1.581-7.824-2.269 0-.107 6.173-1.87 6.173h-35.63c0-1.328-.034-4.104-.034-6.104 1.51-1.51 1.331-1.379 11.648-11.697 1.028-1.031 8.266-7.568 14.599-13.713zm89.06-.254c2.487 1.339 4.457 3.191 7.502 3.972-.354 1.261-1.476 1.759-1.77 3.087v26.91c3.402.75 4.118-1.178 5.737-2.205.442 4.307 3.186 8.529 3.088 11.91h-14.559c.002-14.555.002-29.114.002-43.674zm-19.412 14.412s5.296-4.471 5.296-4.643v23.484l3.814-.006c0-8.947-.118-18.022-.118-26.338 1.548-1.549 4.58-3.791 5.338-5.358v42.06c-10.746 0-30.793.012-33.443.012-.493-8.729-.577-17.771 9.6-15.826v-3.563c-.311-.609-.868.147-.998-.645 1.615-1.617 2.163-2.029 6.538-5.852 0 4.612.08 15.5.08 15.5 1.07 0 3.153.004 3.857.004.001.002.036-18.227.036-18.829zm-12.553 18.603c.716 1.075 3.154 1.056 3.04-.755-.411-1.493-3.616-.924-3.04.755z'/%3e%3ccircle cx='144.527' cy='161.369' r='2.042'/%3e%3cpath d='M207.549 112.779c2.488 1.339 4.457 3.191 7.502 3.971-.353 1.26-1.476 1.76-1.768 3.087v26.911c3.401.749 4.117-1.18 5.736-2.206.441 4.308 3.185 8.528 3.088 11.91h-14.56c.002-14.556.002-29.114.002-43.673z'/%3e%3c/g%3e%3c/svg%3e";
            },
            9339: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 630 360'%3e%3cpath fill='%23da0000' d='M0 0h630v360H0z'/%3e%3cpath fill='%23fff' d='M0 0h630v240H0z'/%3e%3cpath fill='%23239f40' d='M0 0h630v120H0z'/%3e%3cg transform='translate(8.4 100.4)'%3e%3cg id='e'%3e%3cg id='c' fill='none' stroke='%23fff' stroke-width='2'%3e%3cpath id='b' d='M0 1h26M1 10V5h8v4h8V5h-5M4 9h2m20 0h-5V5h8m0-5v9h8V0m-4 0v9' transform='scale(1.4)'/%3e%3cpath id='a' d='M0 7h9m1 0h9' transform='scale(2.8)'/%3e%3cuse xlink:href='%23a' y='120'/%3e%3cuse xlink:href='%23b' y='145.2'/%3e%3c/g%3e%3cg id='d'%3e%3cuse xlink:href='%23c' x='56'/%3e%3cuse xlink:href='%23c' x='112'/%3e%3cuse xlink:href='%23c' x='168'/%3e%3c/g%3e%3c/g%3e%3cuse xlink:href='%23d' x='168'/%3e%3cuse xlink:href='%23e' x='392'/%3e%3c/g%3e%3cg fill='%23da0000' transform='matrix(45 0 0 45 315 180)'%3e%3cg id='f'%3e%3cpath d='M-.548.836A.912.912 0 0 0 .329-.722 1 1 0 0 1-.548.836'/%3e%3cpath d='M.618.661A.764.764 0 0 0 .422-.74 1 1 0 0 1 .618.661M0 1l-.05-1L0-.787a.31.31 0 0 0 .118.099V-.1l-.04.993zM-.02-.85 0-.831a.144.144 0 0 0 .252-.137A.136.136 0 0 1 0-.925'/%3e%3c/g%3e%3cuse xlink:href='%23f' transform='scale(-1 1)'/%3e%3c/g%3e%3c/svg%3e";
            },
            74: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2500 1800'%3e%3cpath fill='%23003897' d='M0 0h2500v1800H0'/%3e%3cpath fill='%23fff' d='M700 0h400v1800H700M0 700h2500v400H0'/%3e%3cpath fill='%23d72828' d='M800 0h200v1800H800M0 800h2500v200H0'/%3e%3c/svg%3e";
            },
            8451: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 2'%3e%3cpath fill='%23009246' d='M0 0h1v2H0z'/%3e%3cpath fill='%23fff' d='M1 0h1v2H1z'/%3e%3cpath fill='%23ce2b37' d='M2 0h1v2H2z'/%3e%3c/svg%3e";
            },
            2306: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 30 18'%3e%3cpath fill='%23fff' d='M0 0h30v18H0z'/%3e%3cpath stroke='%23df112d' stroke-width='2' d='m0 0 30 18M0 18 30 0'/%3e%3cg stroke='%23000' stroke-width='.015'%3e%3cpath fill='%23e8112d' d='M16.57 2.693c.385 1.561.174 3.489-1.567 4.559-1.742-1.07-1.953-2.998-1.568-4.559.41-.373 2.276-.603 3.135 0z'/%3e%3cpath fill='%23f9dd16' d='M15 2.38c.638 0 1.233.169 1.584.388.068-.539.312-1.077.6-1.484-.3-.006-.435.154-.438.32-.075-.213-.37-.2-.46-.085.329.222.075.616-.222.535-.14-.038-.213-.135-.24-.277a.162.162 0 1 0-.068-.01.35.35 0 0 1-.384.165c-.156-.044-.222-.185-.222-.31 0-.325.313-.375.407-.319-.006-.219-.35-.394-.457-.213a.585.585 0 0 0-.1-.713c-.213.2-.219.5-.1.713-.106-.181-.45-.006-.457.213.094-.056.407-.006.407.32a.312.312 0 0 1-.222.31.35.35 0 0 1-.383-.167.162.162 0 1 0-.07.011c-.026.142-.1.239-.239.277-.297.081-.55-.313-.222-.535-.09-.116-.385-.128-.46.084-.003-.165-.138-.325-.438-.319.288.407.532.945.6 1.484.351-.22.946-.388 1.584-.388z'/%3e%3cg id='a'%3e%3cg fill='%23f9dd16'%3e%3cpath d='M16.324 3.91c-.038.01-.038.06-.058.06.1-.003.148-.031.179-.081-.022.02-.003.058-.01.067.073-.025.108-.088.082-.13.017.024.064.037.08.039-.052-.04-.016-.133-.098-.18.027-.002.08.03.095.066-.013-.083-.025-.136-.093-.182.007.008.046.016.062 0a.11.11 0 0 1-.053-.103c.005-.04-.022-.05-.074-.036a1.2 1.2 0 0 1-.214.018c-.129 0-.241 0-.348-.074.16.067.364-.073.364-.189 0-.128-.158-.233-.477-.163-.32.07-.709.04-.709-.066 0-.107.279-.121.422-.1.143.023.246.037.514-.058-.066.026-.279.033-.448-.015-.169-.048-.584-.048-.587.176-.004.224.442.204.826.147.224-.033.342-.01.342.063 0 .07-.206.099-.364.08a1.226 1.226 0 0 0-.507.041c-.156.046-.264 0-.437.03-.083.014-.286 0-.386-.166-.062.044-.247.136-.278.226-.045.083-.015.165.044.246.074.102-.037.086-.116.09-.108.005-.253-.012-.329-.097-.067-.076-.156-.137-.227-.081-.037.029-.002.067.027.057.029-.011.063.01.094.024a.127.127 0 0 0-.124.014c-.03.026.006.075.041.058.028-.014.084-.023.12.01-.039-.007-.08-.006-.1.016-.02.021-.005.052.038.05.069-.003.086.045.155.035a.107.107 0 0 0-.077.044c.064-.03.135.05.218.032-.032.013-.084.045-.084.07.05-.058.382.043.39-.081a.105.105 0 0 1-.019.097c.042-.026.18-.035.222-.134.004.03-.002.068-.027.077.044.014.102-.019.161-.107.024-.035.03-.058.025-.084a.197.197 0 0 0 .148-.051c.047-.04.099.033.18-.019.08-.051.15-.007.194-.033.044-.026.105.01.153-.02.047-.03.122.014.2-.048.125.045.27.13.626.064.204-.037.268.032.268.125 0 .065-.038.07-.066.072-.113.007-.162-.043-.207-.027-.03.011-.048.06-.005.077-.036.018-.031.052-.013.065.018.013.066.001.098-.014-.041.019-.084.052-.06.088.015.02.052.039.087-.006.035-.046.1-.084.14-.078zm-2.261-.969c-.103-.042-.137-.043-.114.04.01.036.035.087.06.11 0-.035.014-.132.054-.15z'/%3e%3cpath d='M14.384 2.941c.103-.042.138-.043.114.04a.275.275 0 0 1-.06.11c0-.035-.013-.132-.054-.15z'/%3e%3cpath d='M14.224 2.885c.195 0 .22.091.218.205 0 .123-.067.08-.104.239-.015.061-.064.065-.114.065s-.098-.004-.113-.065c-.038-.158-.104-.116-.105-.24 0-.113.024-.204.218-.204z'/%3e%3cpath d='M13.723 3.336c-.05-.03-.082-.01-.102-.004.064.017.067.1.214.138-.033-.01-.052.01-.083-.007.06.047.128.103.272.104.08.001.024.042-.028.019.054.056.162.01.23.112.013-.08-.127-.204-.063-.294-.198-.009-.214-.118-.328-.206-.093-.07-.102-.143-.143-.278-.018-.062-.09-.1-.13-.085-.035.012-.047.043-.017.065.03.023.068.026.076.083-.039-.047-.097-.064-.125-.034-.017.017-.01.058.026.062.06.006.017.064.085.121-.06-.067-.112-.074-.144-.037-.02.022 0 .061.041.057.06-.006.13.145.219.184zm1.597.567c-.031.006-.022.057-.064.06.1 0 .152-.023.2-.062-.022.013-.031.046-.033.065.053-.046.18-.05.246-.037.066.013.077-.018.1-.06.025-.043-.008-.067-.041-.1s-.04-.079-.033-.156c-.177-.235-.493-.121-.496-.018.114.132.128.117.224.136.095.018.154.018.09.071-.022.019-.114.01-.186.013-.16.007-.233-.11-.28-.05-.04.05 0 .073.08.07-.055 0-.128-.002-.115.049.02.086.103-.016.135.02-.027-.007-.07.01-.071.036-.002.026.06.06.13.005a.2.2 0 0 1 .114-.042z'/%3e%3cpath d='M15.457 3.545a.303.303 0 0 0-.177-.02m-.687-.007c-.047.101-.019.151-.012.198m-.491-.679c.033.017.051-.03.099.02-.013-.015-.03.037-.066.003m.232-.023c-.032.017-.05-.03-.098.02.013-.015.03.037.066.003'/%3e%3cpath d='M14.257 3.056c-.011.01-.012-.007-.004.036.016.08.034.117-.03.117-.066 0-.046-.037-.03-.117.008-.043.007-.026-.004-.036'/%3e%3c/g%3e%3cpath fill='%23ff0016' stroke-width='.008' d='M14.224 3.362c.052 0 .082-.001.074-.075-.003-.03.036-.041.022-.089.015.059-.096.053-.096.027 0 .026-.111.032-.097-.027-.013.048.026.06.022.09-.008.073.023.074.075.074zm-.047-.149-.126-.035m.126.042-.14-.002m.141.009-.12.032m.212-.046.126-.035m-.126.042.141-.002m-.141.009.12.032'/%3e%3cpath fill='%230051ba' stroke-width='.002' d='M13.573 2.837c-.036-.045-.128-.007-.13.05.031-.037.082.016.11.005.018-.008.035-.036.02-.055zm-.047.108c-.037-.046-.128-.007-.13.05.03-.037.081.015.109.004.02-.007.036-.036.02-.054zm-.024.145c-.041-.042-.128.007-.123.063.026-.04.082.007.108-.007.019-.01.032-.04.015-.056zm.044.448c-.046-.036-.126.022-.116.077.022-.042.083-.002.108-.02.016-.011.026-.043.008-.057zm-.003.098c-.054-.02-.113.06-.085.109.007-.047.077-.028.095-.052.013-.016.013-.049-.01-.057zm.071.074c-.055-.021-.114.059-.086.108.007-.047.078-.028.096-.051.012-.017.012-.05-.01-.058zm1.434.141c-.055-.02-.114.06-.086.11.007-.048.078-.029.096-.052.012-.017.012-.05-.01-.058zm.073.067c-.056-.014-.105.072-.072.118.002-.048.074-.037.089-.062.01-.018.007-.05-.016-.056zm-.051-.161c-.051-.03-.122.04-.104.093.016-.045.082-.014.104-.035.015-.014.02-.046 0-.058zm1.02.115c-.057-.014-.106.072-.073.118.002-.048.074-.037.09-.062.01-.018.006-.05-.017-.056zm.001-.09c-.051-.028-.12.044-.1.096.015-.045.082-.017.103-.038.014-.014.018-.047-.003-.058zm.04.17c-.057-.01-.102.077-.067.122 0-.048.072-.04.086-.066.01-.019.005-.051-.019-.056zm-1.903-.634c.036 0 .05.01.05.075 0 .137-.001.196-.045.196-.045 0-.042-.056-.042-.157 0-.052 0-.079-.01-.074 0-.035.015-.04.047-.04z'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='matrix(.9 0 0 .9 1.453 1.671)'/%3e%3cuse xlink:href='%23a' transform='matrix(.67 0 0 .75 4.909 3.354)'/%3e%3c/g%3e%3c/svg%3e";
            },
            6413: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 6'%3e%3cpath fill='%23009B3A' d='M0 0h12v6H0'/%3e%3cpath stroke='%23FED100' d='M-6 9 18-3V9L-6-3'/%3e%3c/svg%3e";
            },
            9191: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 840 420'%3e%3cpath fill='%23007a3d' d='M0 0h840v420H0z'/%3e%3cpath fill='%23fff' d='M0 0h840v280H0z'/%3e%3cpath d='M0 0h840v140H0z'/%3e%3cpath fill='%23ce1126' d='M0 0v420l420-210z'/%3e%3cpath fill='%23fff' d='m129.787 180 6.508 16.485 16.947-5.19-8.83 15.367 14.623 10.014-17.52 2.676 1.289 17.677L129.787 225l-13.016 12.03 1.289-17.678-17.52-2.676 14.623-10.014-8.83-15.367 16.946 5.19L129.787 180z'/%3e%3c/svg%3e";
            },
            3923: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3cpath fill='%23fff' d='M0 0h900v600H0z'/%3e%3ccircle cx='450' cy='300' r='180' fill='%23bc002d'/%3e%3c/svg%3e";
            },
            6755: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-120 -80 240 160'%3e%3cdefs%3e%3cpath id='a' stroke-miterlimit='10' d='M-1 55.426h2V-38c2-2 2-5 2-8 0-2 0-10-3-18.663C-3-56-3-48-3-46c0 3 0 6 2 8z' transform='rotate(30)'/%3e%3c/defs%3e%3cpath fill='%23fff' d='M-120-80h240V80h-240z'/%3e%3cpath d='M-120-80h240v48h-240z'/%3e%3cpath fill='%23060' d='M-120 32h240v48h-240z'/%3e%3cg id='b'%3e%3cuse xlink:href='%23a' stroke='%23000'/%3e%3cuse xlink:href='%23a' fill='%23fff'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='scale(-1 1)'/%3e%3cpath fill='%23b00' d='M-120-24v48h101c3 8 13 24 19 24s16-16 19-24h101v-48H19C16-32 6-48 0-48s-16 16-19 24z'/%3e%3cpath id='c' d='M19 24c3-8 5-16 5-24s-2-16-5-24c-3 8-5 16-5 24s2 16 5 24'/%3e%3cuse xlink:href='%23c' transform='scale(-1 1)'/%3e%3cg fill='%23fff'%3e%3cellipse rx='4' ry='6'/%3e%3cpath id='d' d='M1 5.85s4 8 4 21-4 21-4 21z'/%3e%3cuse xlink:href='%23d' transform='scale(-1)'/%3e%3cuse xlink:href='%23d' transform='scale(-1 1)'/%3e%3cuse xlink:href='%23d' transform='scale(1 -1)'/%3e%3c/g%3e%3c/svg%3e";
            },
            3867: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 600'%3e%3cpath fill='red' d='M0 0h1000v600H0z'/%3e%3cpath fill='%23ff0' d='M454.869 259.272c-11.177-6.943-23.032-12.701-35.225-17.443-10.5 15.58-16.596 34.208-16.596 54.36 0 9.992 1.524 19.645 4.403 28.79 5.08-11.685 11.516-23.031 19.306-33.87a188.215 188.215 0 0 1 28.112-31.837zm-29.806-24.556c13.21 4.573 25.91 10.5 38.104 17.443 2.71-2.37 5.588-4.403 8.298-6.435-12.87-7.113-26.588-12.87-40.644-17.274-2.032 2.033-4.064 4.065-5.758 6.266zm11.855-12.023c15.241 4.064 29.805 9.652 43.522 16.934 3.218-2.032 6.436-3.895 9.484-5.757-14.564-7.452-29.975-12.87-45.894-16.766a57.437 57.437 0 0 0-7.112 5.589zm14.394-10.161c16.766 3.387 33.023 8.806 48.265 16.257 15.41-7.451 31.668-12.87 48.264-16.257-14.056-8.298-30.652-13.04-48.264-13.04s-34.04 4.742-48.265 13.04zm103.81 4.742a209.349 209.349 0 0 0-45.893 16.596 283.47 283.47 0 0 1 9.484 5.757c13.886-7.282 28.45-12.87 43.522-16.934-2.201-2.033-4.572-3.895-7.112-5.42zm13.21 11.346c-14.056 4.234-27.604 9.991-40.644 17.104a158.93 158.93 0 0 1 8.468 6.435c12.023-6.943 24.725-12.87 37.934-17.443-1.694-2.201-3.557-4.233-5.758-6.096zm11.177 13.378a198.118 198.118 0 0 0-35.055 17.274c10.33 9.314 19.644 19.983 28.112 31.837a204.81 204.81 0 0 1 19.305 33.87c2.71-9.314 4.234-18.798 4.234-28.79 0-20.152-6.097-38.78-16.596-54.19zm-8.298 66.385c-10.161-16.427-22.354-30.991-35.902-43.353-3.048 2.201-6.266 4.403-9.145 6.604 22.862 21.338 41.321 48.095 53.006 79.255 2.71-4.064 5.25-8.298 7.282-12.532-4.234-10.16-9.314-20.152-15.241-29.974zm-53.684-44.03c3.049-2.202 6.097-4.404 9.315-6.436-2.71-2.37-5.589-4.572-8.468-6.774-3.217 2.032-6.435 4.064-9.653 6.266h.17c2.879 2.202 5.758 4.572 8.636 6.943zm-17.95-13.549c3.217-2.032 6.604-4.064 9.652-5.927-3.217-2.032-6.435-4.064-9.652-5.927-3.218 1.863-6.266 3.895-9.484 5.927 3.218 1.863 6.266 3.895 9.484 5.927zm-9.145 6.605c-3.218-2.202-6.266-4.234-9.484-6.266l-8.636 6.605c3.217 2.201 6.265 4.233 9.314 6.435a173.309 173.309 0 0 1 8.806-6.774zm9.145 6.774c-2.88 2.201-5.758 4.572-8.806 7.113 3.048 2.37 5.927 4.91 8.806 7.45 2.879-2.54 5.757-5.08 8.806-7.45-2.88-2.371-5.758-4.912-8.806-7.113zm0 31.668a213.913 213.913 0 0 0-33.362 47.587c-6.266 11.854-11.177 24.217-14.903 36.579 14.226 7.96 30.652 12.701 48.265 12.701s34.039-4.742 48.264-12.701c-3.726-12.362-8.637-24.725-14.903-36.58-9.145-17.78-20.322-33.7-33.361-47.586zm-55.885 64.183c11.007-28.112 27.265-52.667 47.248-72.99-2.88-2.709-5.758-5.249-8.806-7.958-23.2 22.523-41.83 50.465-53.176 82.81a94.433 94.433 0 0 0 10.33 9.823c1.356-3.895 2.88-7.79 4.404-11.685zm64.521-72.99c19.983 20.323 36.24 44.878 47.418 72.99 1.524 3.895 2.879 7.79 4.233 11.685 3.726-3.048 7.282-6.266 10.5-9.822-11.516-32.346-30.144-60.288-53.345-82.811-3.048 2.71-5.927 5.25-8.806 7.959zm-88.23 63.845c11.685-31.16 30.144-57.748 53.175-79.085a186.939 186.939 0 0 0-9.314-6.774c-13.548 12.531-25.74 27.095-35.902 43.522a215.114 215.114 0 0 0-15.24 29.805c2.031 4.403 4.571 8.468 7.281 12.532zm80.102-159.187c59.61 0 108.213 48.603 108.213 108.213 0 59.61-48.603 108.214-108.213 108.214-59.61 0-108.214-48.603-108.214-108.214 0-59.61 48.603-108.213 108.214-108.213zm47.756-23.709c-3.048 3.557-6.435 8.129-9.822 15.41-.847-1.862-.847-4.063-.34-6.434.848-7.79 3.05-12.532 7.114-19.137 1.354-2.37 2.71-4.403 3.386-6.943 2.54-7.62 2.033-17.781-3.556-25.74.847 8.975-1.863 16.426-4.91 20.998-.509.847-1.017 1.355-1.694 2.033-3.218 3.217-6.774 6.435-11.347 13.886-2.54 4.064-5.08 8.975-7.451 16.765-1.016-1.693-1.355-3.725-1.185-6.096-.34-7.96 1.016-12.87 3.895-20.152 1.016-2.54 2.032-4.742 2.37-7.452 1.186-7.79-.846-17.781-7.62-24.725 2.201 8.637.846 16.427-1.524 21.508-.508.846-.847 1.524-1.355 2.201-2.71 3.726-5.589 7.451-9.145 15.41-1.693 4.573-3.556 9.823-4.572 17.782-1.355-1.524-2.033-3.556-2.202-5.927-1.524-7.79-1.016-12.87.678-20.49.677-2.541 1.354-4.912 1.185-7.622 0-7.959-3.556-17.442-11.346-23.37 3.556 8.298 3.387 16.258 1.862 21.677-.338.677-.677 1.524-1.016 2.201-2.032 4.234-4.403 8.299-6.604 16.766-1.016 4.742-2.032 10.33-1.863 18.29-1.355-1.355-2.37-3.218-3.048-5.42-2.71-7.62-3.049-12.531-2.371-20.49.17-2.71.339-5.081 0-7.621-1.355-7.96-6.435-16.766-14.903-21.338 4.742 7.62 5.758 15.58 5.08 20.999l-.507 2.54c-1.355 4.403-3.049 8.806-3.895 17.612-.34 4.742-.508 10.33 1.016 18.29-1.694-1.186-2.88-2.879-3.895-4.911-3.895-7.113-4.911-12.024-5.589-19.814-.17-2.71-.339-5.08-1.355-7.62-2.37-7.621-8.806-15.58-17.95-18.629 5.927 6.605 8.298 14.225 8.298 19.814 0 .847 0 1.693-.17 2.54-.677 4.572-1.524 9.314-1.016 17.951.508 4.742 1.186 10.33 3.895 17.95-1.863-.846-3.387-2.37-4.742-4.233-4.91-6.266-6.604-11.007-8.467-18.628-.677-2.71-1.185-4.911-2.54-7.451-3.557-6.944-11.177-13.887-20.66-15.58 6.773 5.757 10.33 13.04 11.346 18.458.169.847.169 1.694.169 2.54.17 4.573 0 9.315 1.863 17.952 1.185 4.572 2.71 9.991 6.604 16.934-1.862-.508-3.556-1.693-5.25-3.387-5.927-5.419-8.467-9.822-11.346-17.104-1.016-2.54-2.032-4.741-3.556-6.943-4.742-6.266-13.21-11.854-23.031-12.024 7.79 4.573 12.362 11.008 14.225 16.258l.508 2.54c.847 4.572 1.355 9.314 4.572 17.443 1.863 4.403 4.403 9.483 9.314 15.75-2.032-.17-3.895-1.186-5.757-2.541-6.605-4.403-9.823-8.467-14.056-15.072-1.355-2.37-2.54-4.403-4.573-6.266-5.588-5.588-14.902-9.822-24.555-8.467 8.298 3.387 13.886 9.144 16.596 14.056.339.677.677 1.524 1.016 2.37 1.524 4.234 2.71 8.807 7.113 16.427 2.54 4.065 5.758 8.637 11.685 14.225-2.032 0-4.065-.677-6.097-1.693-7.282-3.387-11.007-6.774-16.088-12.701-1.863-2.032-3.387-3.895-5.588-5.589-6.436-4.572-16.258-7.282-25.572-4.403 8.806 2.032 15.241 6.774 18.459 11.177.677.678 1.016 1.355 1.355 2.202 2.201 4.064 4.234 8.467 9.822 15.072 3.048 3.725 6.943 7.79 13.548 12.362-1.863.339-3.895 0-6.266-.847-7.62-2.032-11.854-4.91-17.782-9.991-2.032-1.694-3.895-3.218-6.265-4.572-7.113-3.557-17.274-4.573-26.08-.34 8.975.509 16.088 4.404 20.152 8.13.508.677 1.016 1.185 1.524 2.032 2.88 3.556 5.42 7.62 12.024 13.378 3.557 3.048 8.129 6.435 15.41 9.992-1.862.677-4.063.677-6.265.17-7.96-.848-12.532-3.05-19.306-7.114-2.37-1.354-4.403-2.71-6.943-3.387-7.62-2.54-17.612-2.032-25.572 3.557 8.807-.847 16.427 1.863 21 4.91.677.509 1.354 1.017 1.862 1.694 3.387 3.218 6.605 6.774 13.887 11.347 4.064 2.54 9.145 5.25 16.765 7.451-1.693 1.016-3.725 1.355-6.096 1.355-7.96.17-12.87-1.186-20.152-4.065-2.54-1.016-4.742-2.032-7.452-2.37-7.79-1.186-17.781.846-24.725 7.62 8.637-2.201 16.597-.847 21.508 1.524.846.508 1.524.847 2.201 1.355 3.726 2.71 7.451 5.589 15.58 9.145 4.403 1.693 9.653 3.556 17.612 4.572-1.524 1.355-3.556 2.032-5.757 2.202-7.96 1.693-12.87 1.016-20.66-.678-2.541-.677-4.912-1.185-7.622-1.185-7.959 0-17.442 3.556-23.2 11.346 8.128-3.556 16.088-3.387 21.507-1.862.847.338 1.524.677 2.37 1.016 4.065 2.032 8.299 4.403 16.766 6.604 4.573 1.016 10.161 2.032 18.12 1.863-1.354 1.355-3.217 2.37-5.419 3.048-7.451 2.71-12.531 3.049-20.321 2.371-2.71-.17-5.08-.339-7.79 0-7.79 1.355-16.597 6.435-21.169 15.072 7.451-4.911 15.41-5.927 21-5.25.846.17 1.523.339 2.37.508 4.403 1.525 8.806 3.049 17.612 3.895 4.742.34 10.33.508 18.29-1.016-1.186 1.694-2.879 2.88-4.911 3.895-6.943 3.895-12.024 4.911-19.814 5.589-2.71.338-5.08.508-7.62 1.355-7.621 2.37-15.411 8.806-18.629 17.95 6.774-5.927 14.395-8.128 19.983-8.298.847 0 1.694 0 2.54.17 4.403.677 9.145 1.524 17.951 1.016 4.742-.339 10.33-1.186 17.782-3.895-.678 1.863-2.202 3.387-4.234 4.742-6.266 4.91-11.007 6.604-18.628 8.467-2.54.677-4.911 1.185-7.282 2.54-7.113 3.557-13.887 11.177-15.58 20.66 5.588-6.773 12.87-10.33 18.29-11.346.846-.169 1.693-.169 2.54-.169 4.572-.17 9.483 0 17.95-1.863 4.573-1.185 9.992-2.71 17.105-6.604-.508 1.862-1.863 3.725-3.557 5.25-5.419 5.927-9.822 8.467-17.104 11.346-2.37 1.185-4.572 2.032-6.774 3.556-6.435 4.742-12.023 13.21-12.193 23.031 4.573-7.79 11.177-12.362 16.427-14.225.847-.17 1.524-.339 2.37-.508 4.573-.847 9.315-1.355 17.444-4.572 4.403-1.863 9.483-4.403 15.918-9.145-.338 1.863-1.185 3.726-2.71 5.588-4.402 6.605-8.297 9.823-15.071 14.056-2.202 1.355-4.234 2.54-6.266 4.573-5.588 5.588-9.653 14.902-8.298 24.555 3.218-8.298 8.975-13.886 13.887-16.596.846-.339 1.524-.677 2.37-1.016 4.403-1.355 8.976-2.71 16.427-7.113 4.065-2.54 8.637-5.758 14.225-11.685.17 2.032-.508 4.065-1.693 6.097-3.387 7.282-6.774 11.007-12.701 16.088-2.032 1.863-3.895 3.387-5.42 5.588-4.572 6.436-7.281 16.258-4.402 25.572 1.862-8.806 6.604-15.241 11.177-18.459.677-.508 1.354-1.016 2.032-1.355 4.064-2.201 8.467-4.234 15.241-9.822 3.556-3.048 7.62-6.943 12.193-13.548.339 1.863 0 4.064-.677 6.266-2.202 7.62-4.911 11.854-10.161 17.782-1.694 2.032-3.218 3.895-4.403 6.435-3.556 7.112-4.742 17.104-.508 25.91.677-8.975 4.403-16.088 8.298-19.983.508-.677 1.185-1.185 1.863-1.694 3.725-2.878 7.62-5.419 13.378-12.023 3.048-3.557 6.435-8.129 9.992-15.41.677 1.862.677 4.063.338 6.265-1.016 7.96-3.048 12.532-7.112 19.306-1.524 2.37-2.71 4.403-3.557 6.943-2.37 7.62-1.862 17.781 3.726 25.74-.847-8.975 1.694-16.595 4.911-21.168.508-.677 1.016-1.354 1.524-1.862 3.218-3.387 6.774-6.605 11.516-13.887 2.37-4.064 5.08-9.145 7.282-16.765 1.016 1.693 1.355 3.725 1.355 6.096.338 7.96-1.016 12.87-4.065 20.152-1.016 2.54-1.862 4.742-2.37 7.452-1.186 7.79.846 17.781 7.62 24.725-2.201-8.637-.847-16.597 1.694-21.508.338-.846.677-1.524 1.185-2.201 2.71-3.726 5.758-7.451 9.145-15.58 1.863-4.403 3.726-9.653 4.742-17.612 1.185 1.524 1.862 3.556 2.201 5.757 1.524 7.96 1.016 12.87-.847 20.66-.677 2.541-1.185 4.912-1.185 7.622 0 7.959 3.726 17.442 11.516 23.2-3.557-8.128-3.557-16.088-1.863-21.507.17-.847.508-1.524.847-2.37 2.032-4.065 4.403-8.299 6.604-16.766 1.016-4.573 2.032-10.161 1.863-18.12 1.524 1.354 2.37 3.217 3.048 5.419 2.88 7.451 3.049 12.531 2.54 20.49-.338 2.541-.508 4.912 0 7.621 1.186 7.96 6.266 16.766 14.903 21.338-4.742-7.62-5.927-15.58-5.08-20.999 0-.847.169-1.693.508-2.54 1.354-4.403 3.048-8.806 3.895-17.612.169-4.742.338-10.33-1.016-18.29 1.524 1.186 2.879 2.879 3.895 4.911 3.895 6.943 4.91 12.024 5.588 19.814.17 2.71.339 5.08 1.186 7.62 2.54 7.621 8.806 15.411 18.12 18.629-5.927-6.774-8.298-14.395-8.468-19.983 0-.847 0-1.694.17-2.54.677-4.403 1.693-9.145 1.016-17.951-.339-4.742-1.186-10.33-3.726-17.782 1.694.847 3.218 2.202 4.573 4.234 4.91 6.266 6.773 11.007 8.636 18.628.508 2.54 1.186 4.911 2.371 7.282 3.726 7.113 11.177 13.887 20.83 15.58-6.943-5.588-10.5-12.87-11.516-18.29-.169-.846-.169-1.693-.169-2.54 0-4.572.17-9.314-1.694-17.95-1.185-4.573-2.878-9.992-6.773-17.105 2.032.508 3.725 1.863 5.25 3.557 5.927 5.419 8.467 9.822 11.515 17.104 1.016 2.37 1.863 4.572 3.556 6.774 4.742 6.435 13.21 12.023 22.862 12.193-7.62-4.573-12.193-11.177-14.056-16.427-.338-.847-.508-1.524-.677-2.37-.677-4.573-1.355-9.315-4.572-17.444-1.863-4.403-4.234-9.483-9.145-15.75 2.032.17 3.895 1.017 5.758 2.541 6.604 4.403 9.822 8.298 13.886 15.072 1.355 2.202 2.71 4.403 4.573 6.266 5.588 5.588 14.902 9.653 24.555 8.298-8.298-3.218-13.886-8.975-16.427-13.887-.508-.846-.846-1.524-1.016-2.37-1.524-4.403-2.879-8.976-7.282-16.427-2.54-4.065-5.758-8.637-11.515-14.225 1.862 0 3.895.508 6.096 1.693 7.113 3.387 11.008 6.774 16.088 12.701 1.694 2.032 3.218 3.895 5.42 5.42 6.435 4.741 16.257 7.281 25.57 4.572-8.636-2.032-15.071-6.774-18.458-11.347-.508-.677-1.016-1.354-1.355-2.032-2.201-4.064-4.064-8.467-9.653-15.241-3.217-3.556-7.112-7.62-13.717-12.193 2.032-.339 4.064 0 6.266.677 7.62 2.202 11.854 5.08 17.95 10.161 2.033 1.694 3.896 3.218 6.267 4.403 7.112 3.556 17.104 4.742 25.91.508-8.975-.677-15.919-4.403-19.983-8.298-.677-.508-1.185-1.185-1.694-1.863-2.71-3.725-5.419-7.62-11.854-13.378-3.726-3.048-8.298-6.435-15.41-9.992 1.862-.677 3.894-.677 6.265-.338 7.79 1.016 12.532 3.048 19.137 7.282 2.37 1.354 4.403 2.54 6.943 3.387 7.62 2.37 17.781 1.862 25.74-3.726-8.975.847-16.426-1.694-20.998-4.911l-2.033-1.524c-3.217-3.218-6.435-6.774-13.886-11.516-4.064-2.37-8.976-5.08-16.766-7.282 1.694-1.016 3.895-1.355 6.097-1.355 8.129-.338 13.04 1.016 20.152 4.065 2.54 1.016 4.742 1.862 7.452 2.37 7.79 1.186 17.781-.846 24.725-7.62-8.637 2.201-16.427.847-21.508-1.694-.677-.338-1.524-.677-2.201-1.185-3.726-2.71-7.451-5.589-15.41-9.145-4.404-1.693-9.823-3.556-17.782-4.742 1.524-1.185 3.556-1.862 5.927-2.201 7.79-1.524 12.87-1.016 20.49.847 2.541.677 4.912 1.185 7.622 1.185 7.959 0 17.442-3.726 23.37-11.346-8.298 3.387-16.258 3.387-21.508 1.693-.846-.17-1.693-.508-2.37-.847-4.234-2.032-8.299-4.403-16.766-6.604-4.742-1.016-10.16-2.032-18.29-1.863 1.355-1.524 3.218-2.37 5.42-3.048 7.62-2.88 12.7-3.049 20.49-2.54 2.71.338 5.081.508 7.79 0 7.79-1.186 16.597-6.266 21.17-14.903-7.621 4.742-15.411 5.927-21 5.25-.847-.17-1.693-.339-2.54-.678-4.403-1.354-8.806-3.048-17.443-3.895-4.742-.17-10.5-.338-18.29 1.186 1.017-1.694 2.71-3.049 4.912-4.065 6.943-3.895 11.854-4.91 19.644-5.588 2.71-.17 5.08-.339 7.62-1.186 7.621-2.54 15.58-8.806 18.629-18.12-6.605 5.927-14.225 8.298-19.814 8.468-.847 0-1.693 0-2.54-.17-4.573-.677-9.314-1.693-17.951-1.016-4.742.339-10.33 1.186-17.95 3.895.846-1.863 2.37-3.387 4.233-4.742 6.266-4.91 11.007-6.773 18.628-8.636 2.71-.508 4.911-1.186 7.451-2.371 6.944-3.726 13.887-11.177 15.58-20.83-5.757 6.943-12.87 10.5-18.459 11.516-.846.169-1.693.169-2.54.169-4.572 0-9.314-.17-17.781 1.694-4.742 1.185-10.161 2.878-17.104 6.773.508-2.032 1.693-3.725 3.387-5.25 5.419-5.927 9.822-8.467 17.104-11.515 2.54-1.016 4.741-1.863 6.943-3.556 6.266-4.742 11.854-13.21 12.024-22.862-4.573 7.62-11.008 12.193-16.258 14.056-.846.338-1.693.508-2.54.677-4.572.847-9.314 1.355-17.443 4.572-4.234 1.863-9.314 4.234-15.75 9.145.17-1.863 1.186-3.895 2.541-5.758 4.403-6.604 8.467-9.822 15.072-13.886 2.37-1.355 4.403-2.71 6.266-4.573 5.588-5.588 9.822-14.902 8.467-24.555-3.387 8.298-9.144 13.886-14.056 16.596-.677.339-1.524.677-2.201.847-4.403 1.524-8.976 2.879-16.596 7.282-4.065 2.54-8.637 5.758-14.225 11.515 0-1.862.677-3.895 1.693-5.927 3.387-7.282 6.774-11.007 12.701-16.257 2.032-1.694 3.895-3.218 5.589-5.42 4.572-6.435 7.282-16.257 4.403-25.57-2.033 8.636-6.774 15.071-11.177 18.458-.678.508-1.355 1.016-2.202 1.355-4.064 2.201-8.467 4.064-15.072 9.653-3.725 3.217-7.79 7.112-12.193 13.717-.508-1.863-.17-4.064.678-6.266 2.201-7.62 4.91-11.854 9.991-17.95 1.694-2.033 3.387-3.727 4.572-6.267 3.557-7.112 4.573-17.104.34-25.91-.509 8.975-4.235 15.919-8.13 19.983-.677.677-1.185 1.185-1.862 1.694-3.726 2.71-7.79 5.419-13.548 12.023z'/%3e%3c/svg%3e";
            },
            3108: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 625 400'%3e%3cpath fill='%23032ea1' d='M0 0h625v400H0z'/%3e%3cpath fill='%23e00025' d='M0 100h625v200H0z'/%3e%3cg fill='%23fff' stroke='%23000' stroke-width='.96' transform='translate(117.143 -434.934)'%3e%3cg stroke-linejoin='bevel'%3e%3cpath d='M139.02 623.46h113.8v43.788h-113.8z'/%3e%3cpath d='M246.95 647.64h3.586v16.495h-3.586zm-107.93-8.15h113.8v5.09h-113.8zm0-6.9h113.8v4.489h-113.8z'/%3e%3cpath stroke-width='.945' d='M139.02 625.7h113.8v4.354h-113.8z'/%3e%3cpath d='M168.98 647.64h3.586v16.495h-3.586zm48.99 0h3.586v16.495h-3.586zm-78.05 0h3.586v16.495h-3.586zm7.03 0h3.586v16.495h-3.586zm7.5 0h3.586v16.495h-3.586zm7.5 0h3.586v16.495h-3.586zm62.82 0h3.586v16.495h-3.586zm7.5 0h3.586v16.495h-3.586zm7.5 0h3.586v16.495h-3.586z'/%3e%3cpath stroke-linejoin='miter' d='M94.509 669.55c1.76-.897 3.768-2.984 4.425-5.319h193.07c.657 2.335 2.665 4.422 4.425 5.319z'/%3e%3c/g%3e%3cpath d='M193 556.8s-.144-4.112 2.25-4.157c2.396.044 2.251 4.157 2.251 4.157zm-12.49 54.54v-5.536c-.079-2.768-2.76-2.968-2.838-4.986 0 0-.346-3.027.452-4.408 1.084 4.047 3.056 3.304 3.056 1.64 0-1.453-1.117-2.804-3.408-6.33-.732-1.128-.28-4.66.747-5.923.398 3.07.853 4.54 2.171 4.54.805 0 1.462-.524 1.462-2.062 0-1.957-1.325-2.945-1.977-4.725-.76-2.078-.236-4.196 1.026-5.38.541 3.03.38 4.237 1.726 4.237 2.713-.858 0-4.786-.58-5.777-.666-1.155.897-3.46.897-3.46.863 2.69 1.14 2.91 2.07 2.66 1.174-.315 1.023-2.056-.41-3.463-.904-.889-.808-2.212.163-3.274.975 1.905 2.223 1.79 2.343.658l-.784-4.393h17.255l-.857 4.249c-.245 1.216 1.396 1.48 2.416-.514.972 1.062 1.067 2.385.163 3.274-1.432 1.407-1.584 3.148-.41 3.463.93.25 1.208.03 2.07-2.66 0 0 1.403 1.571.897 3.46-.58.99-3.293 4.919-.58 5.777 1.346 0 1.185-1.208 1.726-4.237 1.263 1.184 1.786 3.302 1.026 5.38-.651 1.78-1.976 2.768-1.976 4.725 0 1.538.657 2.062 1.461 2.062 1.319 0 1.774-1.47 2.172-4.54 1.026 1.263 1.479 4.795.747 5.922-2.291 3.527-3.408 4.878-3.408 6.33 0 1.665 1.971 2.408 3.056-1.64.797 1.382.451 4.41.451 4.41-.079 2.017-2.759 2.217-2.838 4.985v5.536zm7.22-46.02-.397-3.125h15.838l-.397 3.125zm1.06-3.19-.341-2.569h13.604l-.341 2.569zm2.16-2.66-.227-2.569h9.058l-.227 2.569zm33.02 110.08c-2.027-.781-4.977-2.919-4.977-5.07v-24.297l2.638-3.358h-52.776l2.53 3.359v24.297c0 2.15-2.027 4.288-4.053 5.07z'/%3e%3cpath stroke-linejoin='bevel' d='M178.24 647.64h3.586v16.495h-3.586zm30.32 0h3.586v16.495h-3.586z'/%3e%3cpath d='M167.91 609.17v27.656h54.023v-5.957l.078-21.7c-2.21.869-2.597 2.872-2.597 2.872v11.777h-48.75V612.04s-.544-2.003-2.754-2.871z'/%3e%3cpath d='M214.6 669.55c-1.766-.781-5.612-2.919-5.612-5.07v-27.192c.378-1.518 2.436-2.414 3.761-3.358h-35.823c1.705.902 3.606 1.652 4.285 3.359v27.192c0 2.15-3.041 4.288-4.807 5.069z'/%3e%3cpath d='M219.41 634.22v-19.587h-4.91v-1.909h-38.84v1.909h-4.91v19.587zm-12.55 35.33c-1.73-.781-4.249-2.919-4.249-5.07v-23.214l1.42-2.11h-17.69l1.42 2.11v23.215c0 2.15-2.519 4.288-4.249 5.07z'/%3e%3cpath stroke-width='.981' d='M190.71 639.16h8.966v30.377h-8.966z'/%3e%3cpath stroke-linejoin='bevel' d='M204.38 632.48c.021-2.001 5.838-2.091 8.832-3.795H177.26c2.994 1.704 8.675 1.844 8.675 3.795l1.217 3.882 14.883.598z'/%3e%3cpath d='M211.41 611.34c0-4.899.205-6.786 1.71-6.786v15.58c-3.69 1.34-6.325 6.05-6.325 6.05h-23.211s-2.634-4.71-6.325-6.05v-15.58c1.856 0 1.868 1.972 1.868 6.786zm1.71-2.01c0-5.618 4.851-6.25 4.851-6.25v5c-1.846-.08-2.737 1.578-2.737 4.044 0 2.466 1.487 2.506 1.487 2.506v14.19h-3.601z'/%3e%3cpath d='M177.28 609.33c0-5.618-4.851-6.25-4.851-6.25v5c1.846-.08 2.737 1.578 2.737 4.044 0 2.466-1.487 2.506-1.487 2.506v14.19h3.601z'/%3e%3cg fill='none' stroke-width='.8'%3e%3cpath d='M186.84 570.62h17.128m-19.158 5.35h20.921m-22.951 6.49h24.904m-27.024 7.93h29.536m-30.216 9.04h30.426'/%3e%3cpath stroke-width='.96' d='M170.75 628.92h48.661m-33.221.01h18.036v6.629H186.19z'/%3e%3c/g%3e%3cpath d='M183.93 614.24c2.99 3.59 2.713 9.68 2.679 13.27h17.343c-.035-3.59-.312-9.68 2.678-13.27zm9.75-41.13-2.376-1.224v-3.497c.971.292 2.062.411 2.168 1.96.338-2.21.948-2.103 1.907-2.964.958.861 1.568.753 1.906 2.963.107-1.548 1.197-1.667 2.169-1.96v3.498l-2.377 1.224z'/%3e%3cpath d='m193.52 578.85-3.946-2.713v-3.223c1.383.32 2.936.451 3.088 2.149.482-2.423 1.35-3.675 2.715-4.62 1.365.945 2.233 2.197 2.715 4.62.152-1.698 1.705-1.828 3.089-2.149v3.223l-3.947 2.713z'/%3e%3cpath d='m193.24 587.8-4.538-3.985v-4.736c1.591.471 3.377.663 3.552 3.157.553-3.56 1.552-5.4 3.121-6.787 1.57 1.388 2.568 3.227 3.122 6.787.175-2.494 1.96-2.686 3.551-3.157v4.736l-4.537 3.985zm8.37 5.29-4.104 5.676h-4.646l-4.104-5.676zm-15.22 9.53c2.053 1.122 2.81 3.357 3.03 7.553h11.55c.22-4.196.977-6.431 3.03-7.553z'/%3e%3cpath stroke-linejoin='bevel' d='M204.17 593.09v-5.702c-1.95.537-3.213 1.691-3.776 3.258 0-1.893-2.49-6.257-5.207-8.43-2.724 2.432-5.257 6.38-5.206 8.43-.464-1.492-1.826-2.721-3.776-3.258v5.702z'/%3e%3cpath stroke-linejoin='bevel' d='M205.04 602.62v-5.702c-2.138.537-3.522 1.691-4.139 3.258 0-1.893-2.73-6.258-5.708-8.43-2.986 2.432-5.763 6.38-5.707 8.43-.508-1.492-2.002-2.721-4.139-3.258v5.702z'/%3e%3cpath stroke-linejoin='bevel' d='M207.44 614.32v-6.577c-2.66.687-4.312 2.653-5.15 3.8 0-3.561-4.02-8.99-7.1-10.768-3.16 1.825-7.101 7.435-7.101 10.768-.86-1.14-2.49-3.113-5.15-3.8v6.577z'/%3e%3cpath stroke-linejoin='bevel' d='M206 628.92v-6.762c-2.346.92-3.048 3.18-3.786 4.717.29-6.859-3.862-14.23-7.024-16.1-3.163 1.87-7.393 9.4-7.024 16.1-.758-1.527-1.44-3.797-3.786-4.717v6.762z'/%3e%3cpath d='M204.36 639.16v-6.762c-2.458.585-2.61 1.491-3.392 3.006.29-4.097-2.611-8.77-5.773-10.64-3.163 1.87-6.064 6.544-5.774 10.64-.782-1.515-.878-2.421-3.392-3.006v6.762z'/%3e%3cg id='a'%3e%3cpath d='M98.935 664.23v-20.44c-.67-2.603-2.88-4.905-4.54-5.366V620.43l3.741 2.023 4.271 18.81v22.966z'/%3e%3cpath d='M98.935 664.31v-20.519c-.67-2.603-2.88-4.905-4.54-5.366v-19.243c2.511 0 3.741 3.273 3.741 3.273l4.271 18.81v22.887z'/%3e%3cpath d='M96.275 669.55c1.73-.781 4.249-2.919 4.249-5.07v-25.547l-1.185-2.108h43.522l-1.699 2.108v25.547c0 2.151 1.73 4.289 3.46 5.07z'/%3e%3cpath d='M135.84 669.55c-1.73-.781-4.249-2.919-4.249-5.07v-24.297l3.62-3.359h-29.589l3.62 3.36v24.296c0 2.151-2.52 4.289-4.25 5.07z'/%3e%3cpath d='M131.69 669.55c-1.73-.781-4.249-2.919-4.249-5.07v-21.965l2.37-3.359h-18.799l2.37 3.36v21.965c0 2.15-2.52 4.288-4.25 5.069z'/%3e%3cpath d='M115.92 639.16h8.982v30.393h-8.982z'/%3e%3cpath stroke-linejoin='bevel' d='M103.7 647.64h3.586v16.495H103.7zm30.75 0h3.586v16.495h-3.586zm-33.81-27.82h4.32v16.909h-4.32zm0-3.18h4.295v3.139h-4.295z'/%3e%3cpath stroke-linejoin='bevel' stroke-width='1.034' d='M136.17 623.46h6.16v13.054h-6.16z'/%3e%3cpath d='M104.89 636.6v-28.941c1.232 0 1.422 4.242 4.249 4.242 1.472 0 1.315-1.757.489-3.188-.732-1.268-1.637-3.018-.407-6.279.843 2.495 3.112 3.287 2.693 1.722-.72-2.688-2.795-3.13-1.239-7.302.54 3.48 2.773 3.327 2.231 1.304-.61-2.28-1.873-3.214-.316-6.428.873 3.65 2.052 3.435 2.052 1.171 0-3.347-.128-6.957 4.203-8.296 0 0 .25-3.068 1.812-3.068s1.813 3.068 1.813 3.068c4.33 1.34 4.202 4.95 4.202 8.296 0 2.264 1.18 2.478 2.052-1.17 1.558 3.213.295 4.147-.315 6.427-.543 2.023 1.69 2.177 2.23-1.304 1.557 4.172-.517 4.614-1.238 7.302-.42 1.565 1.85.773 2.693-1.722 1.23 3.26.325 5.011-.407 6.279-.826 1.43-.983 3.188.489 3.188 2.827 0 3.017-4.242 4.249-4.242V636.6zm-6.766-21.86v22.079h2.511v-22.135c-.905-.457-1.755-.527-2.511.056z'/%3e%3cpath d='M98.203 629.03c3.112 1.591 6.195 3.433 6.975 7.793h-6.975zm43.167-6.61v14.407h2.035v-14.443c-.635-.298-1.503-.344-2.035.036z'/%3e%3cpath d='M143.41 628.92c-3.112 1.591-6.195 3.433-6.975 7.793h6.975zm-20.58-33.65 1.814-1.525v-1.953c-.664.065-1.026.293-1.516.936-.417-1.295-1.334-2.305-2.562-2.933-1.229.628-2.146 1.593-2.563 2.887-.49-.643-.852-.825-1.516-.89v1.953l1.815 1.525z'/%3e%3cpath d='m123.8 600.16.843-1.825v-2.539c-.664.066-1.026.297-1.516.949-.417-1.313-1.334-2.338-2.562-2.974-1.229.636-2.146 1.615-2.563 2.927-.49-.651-.852-.836-1.516-.902v2.539l.844 1.825z'/%3e%3cpath d='m123.93 606.79 2.695-3.287v-3.243c-.986.111-1.524.503-2.252 1.606-.62-2.222-1.981-2.708-3.806-3.786-1.825 1.078-3.187 1.485-3.806 3.707-.729-1.103-1.267-1.416-2.252-1.527v3.243l2.694 3.287z'/%3e%3cpath d='M124.72 613.3s3.14-2.74 3.327-4.244v-3.467c-1.217.143-2.368.459-3.267 1.883-.765-2.87-1.959-3.67-4.212-5.062-2.253 1.392-3.447 2.192-4.212 5.062-.899-1.425-2.05-1.74-3.267-1.883v3.467c.397 1.504 3.327 4.244 3.327 4.244z'/%3e%3cpath d='M126.06 625.32s4.301-4.761 4.4-6.616v-5.406c-1.61.223-3.132 1.33-4.321 3.551-1.011-4.475-2.59-7.595-5.57-9.765-2.98 2.17-4.56 5.29-5.57 9.765-1.19-2.221-2.712-3.329-4.321-3.551v5.406c.308 1.855 4.4 6.616 4.4 6.616z'/%3e%3cpath d='M126.06 632.43s3.676-3.742 4.4-5.366v-5.406c-1.61.223-3.132 1.33-4.321 3.551-1.011-4.475-2.59-7.037-5.57-9.207-2.98 2.17-4.56 4.732-5.57 9.207-1.19-2.221-2.712-3.329-4.321-3.551v5.406c.933 1.624 4.4 5.366 4.4 5.366z'/%3e%3cpath d='M127.54 636.56c-1.073-4.668-1.996-8.13-7.163-11.641-5.167 3.51-6.09 6.973-7.163 11.641z'/%3e%3cpath d='M130.2 639.16v-6.762c-2.346.92-4.467 2.28-5.249 3.795-.873-3.754-2.557-5.408-4.653-7.679-2.097 2.271-3.501 3.925-4.375 7.679-.782-1.515-2.902-2.875-5.249-3.795v6.762z'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 390.74 0)'/%3e%3cpath d='M72.694 694.25h245.33v12.531H72.694z'/%3e%3cpath d='M66.228 706.76h258.26v12.512H66.228zm19.348-31.25h219.56v8.11H85.576z'/%3e%3cpath d='M79.157 683.56h232.4v10.622h-232.4zm10.255-14.28h211.89v6.174H89.412z'/%3e%3cpath stroke-width='1.045' d='M112.41 669.31h16.005v49.935H112.41z'/%3e%3cpath stroke-width='1.043' d='M115.95 669.31h8.917v49.936h-8.917z'/%3e%3cpath stroke-width='1.045' d='M187.08 669.31h16.006v49.935h-16.005z'/%3e%3cpath stroke-width='1.043' d='M190.73 669.31h8.917v49.936h-8.917z'/%3e%3cpath stroke-width='1.045' d='M262.19 669.31h16.005v49.935H262.19z'/%3e%3cpath stroke-width='1.043' d='M265.73 669.31h8.917v49.936h-8.917z'/%3e%3cpath fill='none' d='M98.935 664.23h193.07M115.79 712.97h9.244m-9.244-6.25h9.244m-9.244-6.25h9.244m-9.244-6.25h9.244m-9.244-6.25h9.244m-9.244-6.25h9.244m-9.244-6.25h9.244m65.736 37.51h8.607m-8.607-6.253h8.607m-8.607-6.254h8.607m-8.607-6.253h8.607m-8.607-6.253h8.607m-8.607-6.253h8.607m-8.607-6.254h8.607m66.193 37.51h9.244m-9.244-6.25h9.244m-9.244-6.25h9.244m-9.244-6.25h9.244m-9.244-6.25h9.244m-9.244-6.25h9.244m-9.244-6.25h9.244'/%3e%3c/g%3e%3c/svg%3e";
            },
            9584: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 600 300'%3e%3cdefs%3e%3cstyle%3e.str1%7bstroke:%23000;stroke-width:.46;stroke-miterlimit:22.9256%7d.fil3%7bfill:none%7d%3c/style%3e%3c/defs%3e%3cpath fill='%23c81010' d='M0 0h600v162H0z'/%3e%3cg id='bird'%3e%3cpath id='bird_outline' fill='%23f8d000' d='M305.75 27.34c-19.08-7.89-30.76-9.34-43.81-9.47-18.9.13-27.92 8.25-45.94 9 7.14 7.69 33.02 9.57 43.93-.53 16.22 1.69 19.9 6.07 24.25 11.52-6.77-1.07-14.57-3.02-21.04 4.14-5.46 1.1-7.99 0-17.33 0-4.36 0-5.87 2.14-5.81 6 2.82-3.9 22.31-1.6 27.09 0 3.67 1.23 7.57 6.32 12.22 7.15 12.19 2.17 29.68-4.2 45.81-8.54L360 42h-23.93L366 36h-32.54c-.69-.79-2.34-1.81-3.66-2.68 8.37-5.39 15.77-15.19 17.66-19.92 15.09-.15 24.83-1.55 36.54-4.29-77.18-8.54-59.61.67-78.25 18.23z' class='str1'/%3e%3cpath id='eye' fill='%23000' d='M270.06 39.89c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5c-.82 0-1.5-.67-1.5-1.5s.68-1.5 1.5-1.5z'/%3e%3cpath id='eye_outline' fill='none' fill-rule='nonzero' stroke='%23000' stroke-miterlimit='22.926' stroke-width='.15' d='M270.06 39.89c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5c-.82 0-1.5-.67-1.5-1.5s.68-1.5 1.5-1.5z'/%3e%3cpath d='M290.13 38.29S283.86 42 279.7 42m45.42 4.61S330.85 42 336.07 42M233.82 24.6s4.66-2.44 6.86-3.09m12.45-.39s7.39-3.19 15.62-3.03m4.36 3.81s9.69-1.63 18.64.36m-7.5 1.98s8.04-1.35 15.75.83m-7.48 1.62s8.19.11 12.26 1.69M216 26.87s11.49 3.14 20.83-1.35m-19.37 2.71s14.92 3.68 21.74-3.15m-16.74 5.73s11.24 3.62 20.08-5.72m-9.64 7.99s9.08-2.6 12.52-7.95m-5.42 8.1s6.09-4.22 8.28-7.98m70.18 3.22s2.38 2.99 11.34 4.85m-9.76-6.26s3.85 3.85 11.87 4.79m-9.93-6.6s3.91 3.36 12.42 4.61m-10.49-6.54s5.98 3.99 12.79 4.45m-10.43-6.97s4.19 3.91 12.5 4.88m-10.74-6.89s4.91 4.22 12.63 4.8m-10.9-6.9s3.01 3.48 12.94 4.39m-11.18-6.66s3.35 3.68 12.78 4.48m-11.41-6.35s5.9 4.45 12.73 4.36m-11.56-6.06s7.8 4.68 12.45 4.53m-11.03-6.69s6.2 3.86 11.98 4.71m-38.62 16.98s2.5 1.89 4.84 1.81m-3.4-3.21s2.17 1.85 5.15 1.84m-3.4-3.56s2.46 2.3 5.41 1.88m-3.75-3.54s2.94 2 5.57 1.94m-3.73-3.83s2.18 1.89 5.63 2.07m-3.99-4.15s2.56 2.27 5.82 2.35m-4.09-3.85s2.48 1.59 5.99 1.89m-4.42-3.64s3.35 1.18 6.42 1.47m-4.61-3.61s2.31 1.62 6.41 1.52m-4.78-3.66s2.74 1.82 6.26 1.86m-5.06-3.89s3.68 2.06 6.85 1.6m-5.51-4.03s2.33 2.55 6.67 2.46m-5.73-3.56s4.18 2.35 7.01 1.75m-5.24-3.08s3.17 1.93 6.07 1.85m-2.85-2.82s5.65 2.88 13.29-.24m-8.48 2.29s11.42 2.62 16.37-1.96m-7.41 2.64s7.85.82 16.63-1.96m-11.41 2.01s11.92 2.4 32.63.09M243.24 32.96s5.33-3.51 7.54-7.55m-3.55 6.9s4.29-4.16 5.54-6.74m-1.58 5.67s3.53-3.17 4.31-5.39m-21.55-.19s7.66-1.67 25.98.68m-18.9-3.74s6.42-3.11 12.14-4.06m-5.76 2.77s4.69-2.21 11.61-3.31m-.95 2.89s6.49-2.77 14.43-2.51m-6.22 2.56s8.9-1.99 17.1-.87m6.73 5.22s6.79-.31 14.6 1.63m-26.21-4.36s9.73-.52 16.4.71m43.77-14.7s3.36 2.91 12.72 4.76m-7.44-4.29s5.26 2.99 13.56 4.03m-8.04-3.99s7.38 3.21 15.18 3.41m-7.01-2.71s7.52 1.81 16.84 1.32m-112.07 9.68s5.1-2.1 14.14-1.93m19.49 9.57s3.06-.37 6.86 1.44' class='fil3 str1'/%3e%3cpath d='M284.18 37.86c2.11.33 4.12.58 5.95.43 7.16-3.91 12.05-7.58 15.62-10.95' class='fil3 str1'/%3e%3c/g%3e%3cg fill='%23f8d000' stroke='%23000' stroke-miterlimit='22.926' stroke-width='.46'%3e%3cg id='rays_6'%3e%3cg id='rays_2' transform='rotate(-84.706 300 156)'%3e%3cpath id='wavy' d='M290.63 105.87A50 50 0 0 1 300 66a50 50 0 0 0 9.37 39.87' transform='rotate(13.4 300 156)'/%3e%3cpath id='straight' d='M290.63 105.87 300 63l9.37 42.87'/%3e%3c/g%3e%3cuse xlink:href='%23rays_2' transform='rotate(21.18 300 156)'/%3e%3cuse xlink:href='%23rays_2' transform='rotate(42.35 300 156)'/%3e%3c/g%3e%3cuse xlink:href='%23rays_6' transform='rotate(63.53 300 156)'/%3e%3cuse xlink:href='%23rays_6' transform='rotate(127.06 300 156)'/%3e%3ccircle cx='300' cy='156' r='51'/%3e%3c/g%3e%3cpath fill='%23183070' d='M0 162h600v138H0z'/%3e%3cpath id='wave' fill='none' stroke='%23fff' stroke-width='24' d='M-36 168q30-12 60 0t60 0 60 0 60 0q30-12 63 0t66 0q33-12 63 0t60 0 60 0 60 0 60 0'/%3e%3cuse xlink:href='%23wave' y='48'/%3e%3cuse xlink:href='%23wave' y='96'/%3e%3c/svg%3e";
            },
            740: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 500 300'%3e%3cpath fill='%233A75C4' d='M0 0h500v300H0z'/%3e%3cpath fill='%23CE1126' d='M0 0h500v225H0z'/%3e%3cpath fill='%23FFF' d='M0 0h500v150H0z'/%3e%3cpath fill='%23FFC61E' d='M0 0h500v75H0z'/%3e%3cpath fill='%233D8E33' d='m0 300 250-150L0 0v300z'/%3e%3ccircle cx='85' cy='150' r='67.5' fill='%23FFF'/%3e%3ccircle cx='115' cy='150' r='67.5' fill='%233D8E33'/%3e%3cpath id='a' fill='%23FFF' d='m100.01 89.2 7.36 22.588-19.258-13.949h23.776L92.63 111.788l7.38-22.588z'/%3e%3cuse xlink:href='%23a' y='32.208'/%3e%3cuse xlink:href='%23a' y='64.417'/%3e%3cuse xlink:href='%23a' y='96.625'/%3e%3c/svg%3e";
            },
            1552: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 750 500'%3e%3cdefs%3e%3cclipPath id='a'%3e%3cpath fill='none' d='M0 0h750v500H0z'/%3e%3c/clipPath%3e%3c/defs%3e%3cg clip-path='url(%23a)'%3e%3cpath fill='%23009e49' d='M750 0H0v500'/%3e%3cpath fill='%23ce1126' d='M0 500h750V0'/%3e%3cpath stroke='%23fcd116' stroke-width='210' d='M0 500 750 0'/%3e%3cpath stroke='%23000' stroke-width='150' d='M0 500 750 0'/%3e%3cg id='d' fill='%23fff' transform='rotate(-33.69 514.716 -777.095)'%3e%3cg id='c'%3e%3cpath id='b' d='M0-70V0h35' transform='rotate(18 0 -70)'/%3e%3cuse xlink:href='%23b' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='rotate(72)'/%3e%3cuse xlink:href='%23c' transform='rotate(144)'/%3e%3cuse xlink:href='%23c' transform='rotate(216)'/%3e%3cuse xlink:href='%23c' transform='rotate(288)'/%3e%3c/g%3e%3cuse xlink:href='%23d' transform='translate(-285 190)'/%3e%3c/g%3e%3c/svg%3e";
            },
            4848: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 72 36'%3e%3cpath fill='%23024FA2' d='M0 0h72v36H0z'/%3e%3cpath fill='%23fff' d='M0 6h72v24H0z'/%3e%3cpath fill='%23ED1C27' d='M0 7h72v22H0z'/%3e%3ccircle cx='24' cy='18' r='8' fill='%23fff'/%3e%3cg fill='%23ED1C27' transform='matrix(7.75 0 0 7.75 24 18)'%3e%3cg id='b'%3e%3cpath id='a' d='M0 0v1h.5z' transform='rotate(18 3.157 -.5)'/%3e%3cuse xlink:href='%23a' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(72)'/%3e%3cuse xlink:href='%23b' transform='rotate(-72)'/%3e%3cuse xlink:href='%23b' transform='rotate(144)'/%3e%3cuse xlink:href='%23b' transform='rotate(-144)'/%3e%3c/g%3e%3c/svg%3e";
            },
            9831: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-36 -24 72 48'%3e%3cpath fill='%23fff' d='M-36-24h72v48h-72z'/%3e%3cg transform='rotate(-56.31)'%3e%3cg id='b'%3e%3cpath id='a' stroke='%23000' stroke-width='2' d='M-6-25H6m-12 3H6m-12 3H6'/%3e%3cuse xlink:href='%23a' y='44'/%3e%3c/g%3e%3cpath stroke='%23fff' d='M0 17v10'/%3e%3ccircle r='12' fill='%23cd2e3a'/%3e%3cpath fill='%230047a0' d='M0-12A6 6 0 0 0 0 0a6 6 0 0 1 0 12 12 12 0 0 1 0-24z'/%3e%3c/g%3e%3cg transform='rotate(-123.69)'%3e%3cuse xlink:href='%23b'/%3e%3cpath stroke='%23fff' d='M0-23.5v3M0 17v3.5m0 3v3'/%3e%3c/g%3e%3c/svg%3e";
            },
            970: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 6'%3e%3cpath fill='%23007a3d' d='M0 0h12v2H0z'/%3e%3cpath fill='%23fff' d='M0 2h12v2H0z'/%3e%3cpath fill='%23ce1126' d='M0 4h12v2H0z'/%3e%3cpath d='m0 0 3 2v2L0 6z'/%3e%3c/svg%3e";
            },
            3941: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1200 600'%3e%3cclipPath id='a'%3e%3cpath d='M0 0v150h700v150H600zm600 0H300v350H0v-50z'/%3e%3c/clipPath%3e%3cpath fill='%23012169' d='M0 0h1200v600H0z'/%3e%3cpath stroke='%23fff' stroke-width='60' d='m0 0 600 300m0-300L0 300'/%3e%3cpath stroke='%23c8102e' stroke-width='40' d='m0 0 600 300m0-300L0 300' clip-path='url(%23a)'/%3e%3cpath stroke='%23fff' stroke-width='100' d='M300 0v350M0 150h700'/%3e%3cpath stroke='%23c8102e' stroke-width='60' d='M300 0v350M0 150h700'/%3e%3cpath fill='%23012169' d='M0 300h600V0h600v600H0z'/%3e%3cpath fill='%23fff' stroke='%23fff' stroke-linejoin='round' stroke-width='9.6' d='M989.722 232.949v93.45c0 80.992-38.339 108.787-89.617 130.832-51.278-22.045-90.096-49.84-90.096-130.831v-93.451h179.713z'/%3e%3cuse xlink:href='%23b' width='100%25' height='100%25' stroke='%23fff' stroke-linejoin='round' stroke-width='9.6'/%3e%3cuse xlink:href='%23c' width='100%25' height='100%25' stroke='%23fff' stroke-linejoin='round' stroke-width='9.6'/%3e%3cg stroke='%23000' stroke-width='1.438'%3e%3cg id='b' fill='%23fcea83'%3e%3cpath d='M754.417 449.563c2.875 7.668 23.483 17.732 47.444 4.792 16.294-9.105 26.838-22.044 36.901-45.048 2.876-5.75 4.313-12.94-2.396-17.252-5.271-3.834-13.898-8.147-17.732-11.981-1.916-1.917-3.833-3.355-5.271-4.793.958.959 1.917 1.917 2.875 3.355 9.585 11.502-.479 28.275-11.022 38.339-7.668 7.188-21.566 24.92-41.694 8.147-4.313-3.834-14.377 11.98-9.105 24.44zm291.373 0c-3.355 7.668-23.962 17.732-47.444 4.792-16.294-9.105-26.838-22.044-37.38-45.048-2.397-5.75-3.835-12.94 2.875-17.252 5.271-3.834 13.898-8.147 17.731-11.981 1.917-1.917 3.355-3.355 5.272-4.793-.959.959-1.917 1.917-2.875 3.355-9.585 11.502.479 28.275 10.543 38.339 7.667 7.188 22.045 24.92 42.172 8.147 4.314-3.834 13.898 11.98 9.106 24.44z'/%3e%3cpath d='M900.105 490.778c38.339 0 97.285-17.253 128.914-77.636 5.272-10.064 0-15.336-6.23-18.69-6.71-2.876-14.856-9.585-19.17-13.898 7.668 7.668 6.23 12.94.96 21.566-24.442 40.735-57.988 61.342-104.474 61.342-46.486 0-80.032-20.607-104.473-61.342-5.271-8.627-6.71-13.898.48-21.566-3.835 4.313-12.46 11.022-19.17 13.898-6.23 3.354-11.502 8.626-6.23 18.69 31.63 60.384 91.054 77.636 129.394 77.636z'/%3e%3c/g%3e%3cpath id='c' fill='%23c8102e' d='M811.446 409.787c-.958-4.792-7.189-2.875-9.105 2.875-2.397-3.354-4.793-6.709-6.71-10.543-5.75-8.626-6.71-14.377 1.438-22.524 3.834-3.834 11.502-8.147 16.773-3.355 11.023 9.106 5.272 23.962-2.396 33.547zm176.838 0c.958-4.792 7.668-2.875 9.585 2.875 2.396-3.354 4.792-6.709 6.709-10.543 5.75-8.626 6.71-14.377-1.917-22.524-3.355-3.834-11.022-8.147-16.773-3.355-10.543 9.106-5.272 23.962 2.396 33.547zm-233.867 39.776c-4.792-7.189-8.626-25.879-9.585-30.671-1.437-4.313-1.917-8.147 3.355-10.064 5.272-1.917 10.064 4.792 12.46 10.543 2.396 5.751 6.23 14.377 10.543 24.92-10.543-6.23-19.17-1.917-16.773 5.272zm291.373 0c4.313-7.189 8.147-25.879 9.585-30.671.958-4.313 1.917-8.147-3.355-10.064-5.271-1.917-10.064 4.792-12.46 10.543-2.396 5.751-6.23 14.377-10.543 24.92 10.543-6.23 18.69-1.917 16.773 5.272z'/%3e%3cg fill='%2300493d' stroke='none'%3e%3cpath d='m782.213 406.432-3.834 1.917c-.958.48-.958 1.438-.958 1.917h-.48l-1.917-4.313h.48c0 .479.479.958 1.437.479l8.147-4.313c.959-.48.959-.959.48-1.438l.479-.48 2.396 4.793h-.48c-.478-.479-.958-.958-1.916-.479l-3.355 1.917 1.438 2.875 3.834-1.437c.958-.48.48-1.438.48-1.917h.478l1.917 4.313c-.479-.48-.958-.959-1.917-.48l-8.147 4.314c-.958.479-.958.958-.479 1.437l-.48.48-2.395-4.313.479-.48c.48.48.958.959 1.917.48l3.834-1.917zm8.147 6.23c.958-.48.958-.958.48-1.917h.478l4.793 7.189-3.355 2.396v-.48c1.917-1.437 1.917-3.354 1.438-3.833-.48-.48-.959-.959-.959-1.438-.479 0-.479-.48-1.437.48-.48.478-3.355 2.395-3.355 2.395.48.48.959 1.917 3.355.48h.479l-5.272 3.833v-.479c2.397-1.917 1.438-3.354.959-3.834l-3.355 2.397c-.958.479-.958.958-.958 1.437.479 0 .479.48.958.959.48.958 1.917 1.917 4.313.958l.48.48-3.834 1.437-4.793-7.668h.48c.479.48.958.959 1.916.48zm7.667 18.211-3.355 2.875c-.479.48-.479 1.438 0 1.917h-.479l-3.355-3.354.48-.48c.479.48.958.959 1.917 0l6.23-6.23c.958-.479.958-.958.479-1.917l3.355 3.834c-.48-.479-1.438-.479-1.917 0l-2.876 2.876 2.396 2.396 2.876-2.396c.958-.959.48-1.438 0-1.917l.48-.48 3.354 3.834h-.48c-.479 0-.958-.479-1.916.48l-6.23 5.75c-.959.959-.959 1.438-.48 1.917v.48l-3.354-3.834c.479 0 1.437.48 1.917 0l3.354-3.355zm7.189 10.064 1.438 1.438 1.917-4.313s-1.438.479-3.834 1.917l.479.958-.48.48-.958-.96c-.479.48-.958.48-1.437.96-1.438.958-.959 1.437-.48 1.916v.48l-2.396-2.397h.48l1.916-.479 9.585-5.272.48.48s-.48.479-4.793 10.064c0 .958-.48 1.437 0 2.396l-3.834-3.355.48-.48c.479.96 1.437.96 1.916 0 0-.478.48-1.437.48-1.916l-1.438-1.438.479-.479zm3.834 9.585.48-.48c.478.48.958.48 1.916 0l6.23-8.146-.479-.48c-.958-.479-2.396-.479-3.834.959v-.48l1.917-2.395 7.189 5.271-2.397 2.876h-.479c1.438-1.438.959-3.355 0-3.834v-.48l-6.23 8.147c-.958.48-.48 1.438 0 1.917h-.48z'/%3e%3cpath d='m821.51 452.439-2.396 3.355c-.48.958 0 1.437.479 1.917l-.48.479-3.833-2.876v-.479c.958.48 1.438.48 1.917-.48l5.271-7.188c.48-.958 0-1.437-.479-1.917l.48-.479 3.833 2.876v.479c-.958-.48-1.437-.48-1.917.48l-2.396 3.354 2.876 1.917 2.396-3.355c.48-.958 0-1.438-.48-1.917l.48-.48 3.834 2.876v.48c-.48-.48-1.438-.48-1.917.479l-4.793 7.668c-.958.479-.479.958 0 1.437v.48l-4.313-2.876h.48c.479 0 .958 0 1.437-.48l2.396-3.833zm9.585 13.418.48-.48c.478.48 1.437.48 1.916-.478l3.834-8.147c.48-.959 0-1.438-.48-1.917l8.148 3.833-1.917 3.834-.48-.479c1.438-1.917 0-3.834-.479-4.313-.479 0-.958-.48-1.437-.48-.48 0-.48 0-.959.96-.479.478-1.917 3.354-1.917 3.354.48.48 1.438 1.438 3.355-.959h.48l-2.876 5.751-.48-.479c1.438-2.875-.479-3.355-.958-3.355l-1.917 3.834c-.48.959 0 1.438.48 1.438v.48zm13.897 6.71c-1.438-.958-1.438-3.834 0-6.71.958-2.875 2.875-5.27 4.792-4.312 1.438.479.959 3.354 0 6.23-1.437 3.354-3.354 5.271-4.792 4.792h-.48c3.355 1.438 5.752-.48 7.19-3.834 1.437-2.875.958-6.23-1.918-7.668-2.875-1.437-5.75.48-7.188 3.834-1.438 3.355-.959 6.71 1.917 7.668zm14.857.958 1.917-5.75c.48-.96 0-1.439-.48-1.918l2.397.48v.479c-.48 0-.959 0-1.438.958l-1.917 5.751c-.958 2.396-2.396 4.313-5.271 3.355-1.917-.48-3.355-2.876-2.397-5.272l2.397-6.23c.479-.958 0-1.438-.48-1.917v-.48l4.314 1.918v.479c-.48-.48-1.438-.48-1.438.48l-2.396 6.23c-.48 1.916-.48 3.833.958 4.312 1.438.48 2.876-.479 3.834-2.875z'/%3e%3cpath d='M864.162 467.295c0-.48 0-.48-.48-.48l3.355.48 2.876 9.105 1.438-5.75c.479-.959 0-1.438-.48-1.917l2.876.479-.48.48c-.479 0-.958 0-1.437.958l-2.396 10.543h-.48l-3.834-11.502-2.396 7.668c0 1.438.48 1.438.959 1.917v.48l-2.876-.96v-.479c.48.48 1.438 0 1.438-.958l2.396-8.626-.479-1.438z'/%3e%3cpath d='M880.456 476.88c-.958 4.313-2.875 5.272-3.834 5.272h-.958s-.48-.48 0-.959l1.437-9.585c.48-.479.48-.958.959-.479h.958c.959 0 1.917 1.917 1.438 5.751l1.438.48c.958-4.793-.959-6.71-3.355-7.19-1.917-.479-4.792-.958-4.792-.958v.48c.479.479 1.437.479.958 1.916l-1.438 8.627c-.479.958-.958 1.437-1.437 1.437h-.48l4.793.959c2.396.48 4.792 0 5.75-5.272zm4.313-3.834c0-.958-.958-1.438-1.438-1.438v-.479l8.627.959-.48 3.833c0-2.396-1.437-3.354-2.396-3.354-.48-.48-.958-.48-1.438-.48-.479 0-.479 0-.479 1.438 0 .48-.48 3.834-.48 3.834.48 0 1.918.48 2.876-2.396l-.479 6.23h-.48c0-2.875-1.437-2.875-1.916-2.875l-.48 4.313c0 .958 0 .958.48.958l.958.48c1.438 0 2.876-.48 3.834-3.355h.48l-.959 3.834-9.105-.959c.958 0 1.437-.48 1.917-1.438zm15.815 5.751c0 4.313-1.438 5.75-2.875 5.75-.48-.478-.48-.478-.959-.478l-.48-.48.48-10.064c0-.479 0-.479.48-.479h.958c.958 0 2.396 1.438 2.396 5.751h1.917c0-4.792-2.396-6.23-4.792-6.23-1.917-.48-4.793-.48-4.793-.48v.48c.48 0 1.438.48 1.438 1.438l-.48 9.105c0 .959-.479 1.438-.958 1.438v.48h4.313c2.397 0 4.793-.96 5.272-6.231h-1.917zm13.898 3.834c0 .958.48.958 1.438.958v.48l-5.272.479c.48-.48 1.438-.959 1.438-1.917l-.959-9.105c-.479-.959-.958-.959-1.917-.959v-.48l5.272-.478c-.48.479-1.438.958-.958 1.917zm4.792.958v-.48c.48 0 .958-.478.958-1.437l-1.916-10.064h-.48c-.958.48-1.917 1.438-1.437 3.355h-.48l-.479-3.355 8.626-1.438.48 3.355h-.48c0-1.917-1.437-2.396-2.875-2.396h-.48l1.918 10.064c0 .958.479 1.438 1.437 1.438v.479zm20.607-9.585-1.917-5.75c0-.96-.958-.96-1.438-.96v-.479l2.397-.958v.48c-.48.478-.48.478-.48 1.437l1.917 6.23c.48 1.917.48 4.792-2.396 5.75-1.917.48-4.313-.478-4.792-3.354l-1.917-6.23c-.48-.958-.959-.958-1.438-.958l-.48-.48 4.793-1.437v.479c-.48.48-.958.958-.48 1.917l1.439 6.23c.479 1.917 1.917 2.875 3.354 2.875 1.438-.479 1.917-2.396 1.438-4.792zm5.272-3.354c2.396-.958 1.917-2.396 1.438-3.834-.48-1.438-1.438-2.396-2.396-1.917-.48 0-.959.48-.48.959l1.438 4.792.48.48.958 3.833c.479.959 1.437.959 1.917.48v.479l-4.313 1.917-.48-.48c.959-.479.959-.958.959-1.917l-3.355-8.147c-.48-1.437-.958-.958-1.917-.958v-.48l4.793-1.916c1.916-.48 3.833 0 4.792 1.917.48 2.396-.48 3.834-2.396 4.792-.48 0-.959.48-.959.48zm11.981 1.437c-1.438.48-3.355-1.438-4.792-4.792-1.438-2.876-1.438-5.751 0-6.23 1.437-.48 3.354 1.437 4.792 4.313 1.438 2.875 1.438 5.75 0 6.709 2.875-.958 3.834-4.313 2.396-7.668-1.438-2.875-4.313-4.792-7.188-3.834-2.876 1.438-3.834 4.793-2.397 7.668 1.438 3.355 4.314 5.272 7.189 3.834zm.479-13.418h-.958l2.875-1.917 8.626 4.792-2.875-5.271c-.48-.959-1.438-.959-1.917-.959v-.479l2.396-.958c-.48.479-.958.958 0 1.917l4.792 9.584-.479.48-10.543-5.751 3.834 7.188c.479.959 1.438.959 1.917.48v.479l-2.396 1.437v-.479c.479-.48.479-.958 0-1.917l-3.834-7.668-1.438-.958zm21.565 1.438v-.48c0-.478.48-.958 0-1.916l-5.75-8.147h-.48c-.959.48-1.438 2.396 0 3.834l-.48.479-1.916-3.355 7.188-4.792 1.917 2.875c-1.437-1.437-2.875-1.437-3.834-.958l-.479.48 5.75 8.146c.48.959 1.439.959 1.918.48v.479zm5.272-11.502 2.875 3.355c.48.479 1.438.479 1.917 0v.479l-3.834 3.355v-.48c.48-.479.48-.958 0-1.917l-5.75-7.188c-.48-.959-.959-.48-1.917-.48l3.834-3.354v.48c0 .478-.48.958 0 1.916l2.396 2.876 2.875-1.917-2.396-3.355c-.48-.959-1.438-.48-1.917-.48l3.834-3.354v.48c-.48.479-.48.958 0 1.916l5.75 7.189c.48.479.96.479 1.438 0l.48.479-3.834 3.355-.48-.48c.48-.479.96-.958.48-1.917l-2.876-3.354zm4.313-10.064c-.48-.48-1.438-.48-1.917 0v-.48l6.23-5.75 2.876 2.875h-.48c-1.437-1.917-3.354-.958-4.313-.479 0 .48-.48.48-.958.959 0 0 0 .479.479 1.437l2.875 2.876c.48-.48 1.917-1.438 0-3.834h.48l3.833 4.313v.48c-2.396-2.397-3.354-.96-3.833-.48l2.875 2.875c.48.959.958.959.958.959l1.438-1.438c.48-.48.959-1.917 0-4.792h.48l1.916 3.354-6.23 6.23-.479-.479c.48-.479.959-.958 0-1.917zm11.497-13.419c-.48.48-.48 1.438.48 1.917.958.958 1.916.958 3.833 0 .959-.48 2.876-.959 4.313.48 2.396 2.395 1.438 4.312.959 5.27-.48.48-1.438.96-1.917 1.438-.48 0-.48 0-.48.48v.479l-3.354-2.875h.48c1.916.958 3.833 1.437 4.791 0 .959-.959 0-1.917-.479-2.397-.958-.958-1.917-.958-3.354 0-1.438.48-3.355.48-4.793-.479-1.917-1.917-1.917-3.355-.958-4.792.479-.48 1.438-.959 1.917-1.438.479 0 .479 0 0-.958l3.354 2.396h-.479c-2.396-.959-3.834-.48-4.313.479zm4.32-3.834c-.958-.48-1.438 0-1.917.48h-.48l5.273-7.669 3.354 2.397-.48.479c-1.916-1.438-3.833-.48-4.312 0 0 .48-.48.958-.48 1.438-.479 0-.479.479.48.958.479.48 3.354 2.396 3.354 2.396.48-.479 1.438-1.437-.479-3.354v-.48l4.792 3.834c-2.875-1.437-3.354 0-3.833.48l3.354 2.396c.959.479 1.438.479 1.438.479 0-.48.48-.959.958-1.438.48-.958.959-2.396-.958-4.313l.48-.48 2.395 2.876-4.792 7.189h-.48c.48-.959.48-1.438-.478-2.396zm12.94-8.626-1.438 2.396c-1.917-1.917-2.875-3.354-2.875-3.354l4.313.958h.959c.479 0 1.437.48 1.916.48 1.438.478.959.958.48 1.916h.479l2.396-4.313c-.958.959-1.438.48-2.396.48-10.064-1.918-11.023-2.397-11.023-2.397v.48l7.668 8.626c.48.479.48 1.437.48 1.917h.479l1.437-2.397-.479-.479c-.48.959-.958 1.438-1.917 0l-.958-.958 1.437-3.355zm-2.88-10.543c-.48.48-.48 1.438.959 1.917 1.437.48 1.916 0 3.354-.959 1.438-.958 2.875-1.916 4.792-.958 2.876 1.438 2.397 3.834 1.917 4.792-.479.48-.958 1.438-1.437 1.917v.959l-3.834-1.917c2.396.48 4.313 0 4.792-1.438.48-.958-.48-1.917-.958-2.396-.959-.48-1.917 0-3.355.958-1.438 1.438-2.875 1.917-4.792.959-1.917-.959-2.876-2.396-1.917-3.834 0-.958.958-1.438 1.438-1.917 0-.48 0-.48-.48-.958v-.48l3.834 1.917h-.48c-2.395-.479-3.833.48-3.833 1.438z'/%3e%3c/g%3e%3c/g%3e%3cuse xlink:href='%23d' width='100%25' height='100%25' stroke='%23fff' stroke-linejoin='round' stroke-width='9.6'/%3e%3cuse xlink:href='%23e' width='100%25' height='100%25' stroke='%23fff' stroke-linejoin='round' stroke-width='9.6'/%3e%3cuse xlink:href='%23f' width='100%25' height='100%25' stroke='%23fff' stroke-linejoin='round' stroke-width='9.6'/%3e%3cuse xlink:href='%23g' width='100%25' height='100%25' stroke='%23fff' stroke-linejoin='round' stroke-width='9.6'/%3e%3cg stroke='%23000' stroke-width='1.438'%3e%3cg id='d' fill='%23073163'%3e%3cpath fill='%23fff' d='M863.203 232.47c-6.23 1.438-10.543 1.917-16.294-3.355-3.834-3.834-2.875-10.543.958-12.94 4.314-2.874 8.147-4.791 13.42-3.354 5.27 1.438 19.168 14.377 15.814 14.857-3.355 0-8.626 3.354-13.898 4.792zm14.857-23.004c1.917-1.438 4.313-2.396 10.543-2.875 5.751-.48 10.064-.48 11.502 3.833 1.917 5.272 3.354 11.502 7.188 14.378-2.396 1.437-14.377 2.875-18.69.479-5.75-2.876-7.188-13.898-10.543-15.815zm41.214.48c1.917-1.438 4.313-1.438 10.543-.958 6.23.479 8.626.958 10.064 5.271 1.438 4.792 0 11.023 2.876 15.336-2.876.958-12.46.958-15.815-2.397-5.272-3.833-4.793-14.856-7.668-17.252z'/%3e%3cpath d='M948.028 212.821c-4.313-.958-7.189-1.438-9.105 0 2.396 2.875.479 14.377 5.271 18.21 3.355 2.397 11.981 2.876 13.898-2.395 2.396-4.793 2.396-11.981-10.064-15.815zm-49.361-4.792c1.438-1.438 4.313-1.917 10.064-1.917 6.23 0 10.064.959 11.98 4.792 1.918 4.793 1.439 11.023 4.793 14.857-1.438 1.917-14.377 1.917-18.21-.959-5.272-3.354-5.752-14.377-8.627-16.773zm-40.735 4.313c0-2.396 3.355-2.875 11.98-3.355 8.627-.958 9.106-.479 11.982 5.751 1.438 3.355 3.354 9.106 7.188 11.023-10.543 2.396-13.897 3.833-19.648.479-4.313-2.396-9.106-8.147-10.064-10.543-.48-1.438-.48-2.876-1.438-3.355z'/%3e%3c/g%3e%3cg fill='%23f9d050' stroke-width='.647'%3e%3cg id='f'%3e%3cpath d='M880.935 163.46c-10.064-7.668-22.045-14.856-33.067-16.294 7.188 4.313 27.316 20.128 32.588 25.4'/%3e%3cpath d='M886.686 156.271c-11.98-8.147-25.879-17.253-39.297-18.21 10.064 5.27 24.92 17.73 33.067 27.795m21.565-23.003c6.71-14.856 13.898-23.003 23.483-32.109-4.793 10.064-10.065 30.671-12.46 38.818'/%3e%3cpath d='M912.565 140.457c4.792-10.543 11.98-19.649 24.441-25.4-6.23 6.23-15.815 24.92-18.211 34.985'/%3e%3cpath d='M916.878 150.041c5.75-8.147 17.253-23.483 37.86-31.63-11.981 11.981-29.713 34.026-34.026 42.652m2.875-.479c8.626-4.792 25.879-12.46 38.339-10.064-7.668 2.876-30.671 13.419-40.735 23.003'/%3e%3cpath d='M921.67 157.23c8.147-8.626 23.003-21.566 38.818-26.837-11.502 11.022-35.943 35.942-39.297 39.776m-22.524-18.211c-5.75-17.732-14.377-34.505-27.316-39.776 7.188 10.543 16.294 25.878 21.086 48.881m-4.793-9.584c-9.585-11.502-22.524-23.003-37.38-25.4 10.063 5.751 26.837 22.525 33.067 38.819'/%3e%3cpath d='M892.916 151c-11.98-21.566-21.086-25.4-26.358-29.713 4.313 8.147 14.856 29.713 21.087 38.819'/%3e%3cpath fill='none' d='M868.954 149.562c5.75 3.355 14.377 11.502 17.253 16.773'/%3e%3cpath d='M868.954 159.626c2.875 2.396 8.147 5.272 12.94 9.585m44.089-2.397c4.792-3.834 15.335-10.064 20.607-11.98m-23.961 8.626c4.792-6.23 14.377-14.856 17.732-17.732m-4.314-11.981c-4.313 4.792-14.377 16.773-18.21 22.524m5.75-26.837c-3.355 4.313-10.064 16.773-11.98 21.086m-25.88-20.127c2.875 7.668 8.147 20.607 10.064 25.879m-14.377-17.732c1.917 2.875 5.75 9.585 7.189 14.377'/%3e%3c/g%3e%3cg id='g'%3e%3cpath d='M897.708 136.143c0-4.313 2.875-9.105 5.75-9.105 3.355 0 5.752 5.75 5.752 9.105 0 3.834-2.876 7.189-5.751 7.189-2.876 0-5.751-2.876-5.751-7.189z'/%3e%3cpath d='M891.478 139.977c.48-4.792 3.834-8.626 6.71-8.147 2.875.48 4.312 6.23 3.833 9.585-.48 3.834-3.834 6.709-6.23 6.23-2.396 0-4.792-3.355-4.313-7.668zm12.94 1.438c-.958-4.313.958-9.105 3.834-9.585 2.875-.479 5.75 4.313 6.23 8.147.958 3.834-1.438 7.668-3.834 7.668-2.396.48-5.75-1.917-6.23-6.23z'/%3e%3cpath d='M897.229 145.249c0-4.792 2.875-9.105 5.75-9.105 3.355 0 5.752 5.271 5.752 9.105 0 3.834-2.876 7.189-5.751 7.189-2.876 0-5.751-2.876-5.751-7.189z'/%3e%3cpath d='M888.603 147.645c0-4.313 3.355-9.105 6.23-9.105 2.875 0 5.75 5.75 5.75 9.105 0 3.834-3.354 7.189-5.75 7.189-2.875 0-6.23-2.876-6.23-7.189zm17.732-1.917c0-4.313 2.875-9.105 5.75-9.105 3.355 0 5.752 5.75 5.752 9.105 0 3.834-2.876 7.189-5.751 7.189-2.876 0-5.751-2.876-5.751-7.189z'/%3e%3cpath d='M904.418 149.562c0-4.792 3.355-9.105 6.23-9.105 2.875 0 5.75 5.271 5.75 9.105 0 3.834-2.875 7.189-5.75 7.189s-6.23-2.876-6.23-7.189z'/%3e%3cpath d='M896.75 153.875c0-4.792 2.875-9.105 5.75-9.105 3.355 0 5.752 5.75 5.752 9.105 0 3.834-2.876 7.189-5.751 7.189-2.876 0-5.751-2.876-5.751-7.189zm-11.981 0c0-4.792 2.396-9.105 4.792-9.105 2.397 0 4.313 5.75 4.313 9.105 0 3.834-2.396 7.189-4.313 7.189-2.396 0-4.792-2.876-4.792-7.189zm26.837-.958c0-4.313 2.396-8.626 4.792-8.626 2.397 0 4.793 5.271 4.793 8.626 0 4.313-2.876 7.189-4.793 7.189-2.396 0-4.792-2.876-4.792-7.189z'/%3e%3cpath d='M914.482 161.064c.958-4.792 3.834-8.626 5.75-8.147 1.918.48 2.397 6.23 1.439 9.585-.48 4.313-3.355 6.709-5.272 6.23-1.917-.48-2.875-3.834-1.917-7.668z'/%3e%3cpath d='M905.376 159.626c.48-4.313 3.355-8.626 5.75-8.147 2.876 0 4.314 5.75 3.835 9.105-.48 4.314-2.876 7.189-5.272 6.71-2.396 0-4.792-3.355-4.313-7.668zm-13.418 1.438c-1.438-4.792-4.313-8.147-6.23-7.668-1.917.48-2.396 6.23-1.438 9.585.959 3.834 3.834 6.23 5.751 5.75 1.438-.478 2.875-3.833 1.917-7.667z'/%3e%3cpath d='M888.603 160.105c0-4.313 2.396-8.626 4.792-8.626 2.876 0 4.793 5.271 4.793 8.626 0 4.313-2.396 7.189-4.793 7.189-1.917 0-4.792-2.876-4.792-7.189z'/%3e%3cpath d='M895.791 162.022c0-4.792 2.875-9.105 5.75-9.105 3.355 0 5.752 5.271 5.752 9.105 0 3.834-2.876 7.189-5.751 7.189-2.876 0-5.751-2.876-5.751-7.189zm2.397-52.716c-.958 3.834-4.313 7.189-1.917 12.46-4.313-1.438-8.147-1.917-11.502 1.917 4.314-.48 8.147.959 10.064 3.834-3.834-.48-5.75 1.438-6.709 3.834 3.355-.959 6.71-1.917 8.147-1.438-1.438 1.438-3.834 3.834-4.313 5.75 2.875-2.395 6.23-1.916 8.147-3.354-1.438 3.355 1.438 6.71 3.834 10.064-.48-4.792 2.396-8.147.958-10.543 4.313.959 4.793 4.792 11.023 4.792-2.396-1.437-3.834-6.23-6.71-6.23 1.438-.479 7.189-.958 8.147 0-.958-1.917-4.313-3.834-6.23-3.834 1.917-1.916 5.272-5.75 7.668-6.709-3.355.48-8.626.959-10.543 3.834 4.792-3.834 3.834-11.022 9.105-11.98-2.875-.48-7.188 1.437-10.543 4.792 1.438-2.876 1.438-6.71 3.355-7.668-3.834.958-8.147 5.75-9.585 8.147 0-2.396-1.438-6.23-2.396-7.668zm2.396 7.668c0 1.438 0 4.313-.48 5.272m6.71-5.751c-.958.958-2.875 4.313-2.875 7.189'/%3e%3cpath fill='none' d='M909.689 122.246c-1.438.958-2.875 2.396-3.355 4.313'/%3e%3c/g%3e%3c/g%3e%3cg id='e' fill='%23059334'%3e%3cpath d='M858.89 169.69c-3.355 0-6.23-1.438-8.147-3.834-3.355-4.313-12.46-6.23-16.294-2.396-1.438.958-3.355.958-4.792 1.438-2.397 0-5.272 2.396-4.313 7.188 1.916-1.438 2.396 0 3.833 0 .959-.48.48.48.48 1.438 0 2.396 5.271 7.188 10.064 6.71 5.271 0 7.667 1.916 8.626 2.875 1.437 1.437.479.958 1.437 3.354 1.438 1.438 1.917 1.917-.479 3.834-3.354 2.876-5.75 9.585 0 14.856 6.23 4.793 22.045 11.981 39.777-1.917 17.252-13.418 44.09-5.75 46.006-.958 2.397 4.792 3.355 7.668 3.834 10.064.48 1.917 2.876 3.834 6.23 3.355 3.355 0 7.189 1.437 9.106 2.875 2.396 1.438 5.75.959 4.792-3.355-1.917-13.418-10.064-15.335-11.022-21.565 4.792.479 8.147.479 10.064-1.438 1.437-1.917 3.354-5.271 5.271-6.23 1.438-.958 1.438-1.917-.479-1.438-2.396.48-3.834 1.438-8.147.959-22.045-2.396-83.866-19.17-95.847-15.815z'/%3e%3cpath fill='%23000' d='M956.654 185.984c-2.396 1.438-4.792 3.834-9.105 9.585-4.793 6.23-19.17 12.46-36.902 12.46-17.252 0-27.795-2.876-35.463-9.106-4.313-3.354-7.668-5.271-10.543-6.709-5.272-2.396-6.23-7.668-4.793-11.98-1.437 2.395-2.396 4.791-5.271 4.312-1.917 0-5.75 0-4.792 1.917-.48-.958-.48-2.396-.959-2.875l-.958-.959c1.437.959 4.792-1.917 7.188-1.917 1.917.48 4.313-1.917 3.834-4.792-.48-2.396-.958-4.313-1.438-6.23 3.834-1.917 54.154 7.188 64.218 8.147 10.064.48 38.818 4.792 34.984 8.147z'/%3e%3cpath d='M865.6 167.773c4.792-4.792 10.543-7.189 16.294-5.75h1.438c2.875-2.397 9.584-2.876 13.418-.96h1.917c5.751-1.916 16.773 0 20.607 3.835l1.438.958c12.94-.958 20.607 4.792 29.713 13.898.958.958 2.396 2.875 4.792 3.355 2.875.479 3.355 1.916.958 3.354-2.875 1.438-5.271 3.834-10.063 9.106-4.314 5.75-18.211 11.501-35.464 11.501-16.773 0-26.837-2.875-34.505-8.626-4.313-3.355-7.668-5.272-10.064-6.71-2.875-.958-6.709-4.792-5.271-8.626.958-3.833-1.438-8.626-3.355-13.418 1.438-.959 5.272-2.396 7.189-1.438l.958-.48z'/%3e%3cg fill='%2300493d'%3e%3cpath d='M950.424 179.754c-9.105-9.105-16.773-14.856-29.713-13.898 0 .48 0 1.917-.479 2.876 7.668 2.875 18.69 11.501 23.483 17.731 1.917-1.917 5.271-4.313 6.709-6.709zm-31.15-14.856c-3.834-3.834-14.856-5.75-20.607-3.834 0 1.917 0 4.792-.959 6.71 3.355 1.437 6.23 4.792 9.106 8.146 1.917-.479 6.71-1.917 9.105-2.396.959-1.917 2.876-6.23 3.355-8.626zm-22.524-3.834c-3.834-1.917-10.543-1.438-13.419.958-.958 1.917-1.437 5.751-1.437 7.668 1.917 0 4.792 1.438 5.75 2.396 2.876-.958 6.71-2.875 8.148-4.313.479-1.917 1.437-4.792.958-6.709zm-31.15 6.709c4.792-4.792 10.543-7.189 16.294-5.75-.958 1.437-1.438 4.312-1.438 7.188-5.271-.48-11.98.958-14.856 2.875v-4.313z'/%3e%3cpath d='M941.798 187.422c-4.313-6.23-14.856-13.419-22.045-16.773 0 .479-.958 2.396-1.438 3.834 2.876 4.313 8.627 13.897 11.023 19.17 2.396-.96 9.105-3.835 12.46-6.231zm-36.422 10.543c.958-6.71 1.438-16.294 1.438-19.649 2.396-.479 7.188-1.917 9.105-2.396 2.396 3.834 8.147 13.898 10.543 18.69-5.75 1.438-15.335 3.834-21.086 3.355zm-16.773-23.004c2.396-.958 5.75-2.875 8.147-4.792 1.917 1.437 5.75 4.792 7.189 6.709 0 4.313-1.438 16.773-1.917 21.086-3.834 0-10.064-.958-13.419-2.875.48-7.189.958-15.336 0-20.128zm-23.962 5.751c.48-.958.958-4.313.958-5.75 3.834-2.397 13.42-4.793 20.608-.96.479 4.793 0 16.774-.48 19.65-6.23-4.793-16.294-11.502-21.086-12.94z'/%3e%3c/g%3e%3cg fill='none'%3e%3cpath fill='%23000' stroke='none' d='M840.679 172.086c-.958 0-1.438-2.875-3.355-2.875-.479 0-1.917.479-2.396 0 0 .958.48 1.917.959 2.396.479 1.437 2.875.479 4.792.479z'/%3e%3cpath d='M840.679 180.233c5.75 0 6.71-7.189 9.585-7.668m-6.23 8.147c4.313 1.917 7.668-8.147 11.022-7.668m-19.648-4.792c1.438 0 2.396-1.917 4.792.48.959.958 2.397 1.437 3.355 1.437m-.959 5.272c-1.917 2.875-5.272 4.792-7.189 3.834m-.958-15.815c-1.438.958-2.396 2.875-3.355 4.313m-1.437 2.875v2.396'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg stroke-width='1.438' transform='translate(.002 -.032)'%3e%3cpath fill='%23fff' d='M989.72 232.95v93.451c0 80.991-38.339 108.79-89.617 130.83-51.278-22.045-90.096-49.84-90.096-130.83V232.95h179.71z'/%3e%3cpath fill='%23cf142b' d='M900.1 312.02c4.313 0 11.022-3.834 16.773-9.585 6.23-6.709 16.773-9.105 27.796 0 11.022 9.106 17.732 5.272 23.482 0 5.75-5.271 10.543-7.188 21.566-7.188v-62.301h-179.71v62.3c11.022 0 15.815 1.918 21.566 7.19 5.75 5.27 12.46 9.105 23.483 0 11.502-9.106 21.566-6.71 28.275 0 5.272 5.75 11.981 9.584 16.773 9.584z'/%3e%3cpath fill='%230b50a0' d='M900.1 359.95c5.75 0 17.252-6.23 20.128-7.668 10.543-6.23 18.211-.479 24.441 2.396 6.71 2.876 19.169 6.23 26.837 0 7.668-6.23 11.981-5.75 17.252-5.75.958-7.189.958-14.377.958-22.524v-5.751c-6.709-1.438-10.064.479-17.252 6.71-7.188 6.23-15.336 4.791-25.879.958-10.064-4.314-20.128-11.981-30.192 0-2.875 3.354-9.584 8.147-16.294 8.147-7.188 0-13.419-4.793-16.294-8.147-10.543-11.981-20.128-4.314-30.192 0-10.543 3.833-19.169 5.271-26.358-.959-6.709-6.23-10.064-8.147-17.252-6.71v5.752c0 8.147.48 15.336 1.438 22.524 5.272 0 9.106-.48 16.773 5.75 7.668 6.23 20.607 2.876 26.837 0 6.71-2.875 14.377-8.626 24.92-2.396 2.876 1.438 13.898 7.668 20.128 7.668zm0 20.6c7.189 0 15.815-2.875 23.482-7.189 9.585-5.271 16.294-2.875 25.879 1.918 10.064 4.792 18.211 3.354 23.962 0 2.875-1.917 5.272-5.751 11.502-4.314-2.875 11.981-7.189 22.524-12.46 31.15-9.585 2.397-14.856 2.397-24.92-1.917-10.064-4.792-22.524-7.667-29.233-3.354-6.23 3.834-12.939 5.75-18.211 5.75-5.272 0-11.981-1.916-18.211-5.75-6.71-4.313-19.169-1.438-29.233 3.354-10.064 4.314-15.336 4.314-24.92 1.917-5.272-8.626-9.585-19.169-12.46-31.15 6.23-1.437 8.626 2.397 11.502 4.314 5.272 3.354 13.898 4.792 23.482 0 10.064-4.793 16.773-7.189 26.358-1.917 7.668 4.313 16.294 7.188 23.482 7.188zm0 76.68c19.169-8.147 36.901-17.252 51.278-29.713-3.834-1.438-6.23-.48-9.585-2.875-3.354-2.397-13.419-3.355-22.045 1.437-9.105 4.313-12.939 5.272-19.649 5.272-6.709 0-10.543-.959-19.649-5.272-8.626-4.792-18.69-3.834-22.045-1.437-3.354 2.396-5.75 1.437-9.584 2.875 14.377 12.46 31.63 21.566 51.278 29.713z'/%3e%3cg id='h'%3e%3cpath fill='%23f9d050' d='m831.1 383.43 23.962-73.802 23.962 73.802-62.78-45.527h77.636z'/%3e%3cpath fill='%23024919' d='m835.89 376.72 49.84-36.422h-61.342l49.361 36.422-18.69-58.467z'/%3e%3c/g%3e%3cuse xlink:href='%23h' width='100%25' height='100%25' x='90.097'/%3e%3cuse xlink:href='%23h' width='100%25' height='100%25' x='45.048' y='52.237'/%3e%3cpath fill='none' stroke='%23000' d='M989.72 232.95v93.451c0 80.991-38.339 108.79-89.617 130.83-51.278-22.045-90.096-49.84-90.096-130.83V232.95h179.71z'/%3e%3cpath fill='%23e4c900' stroke='%23806600' stroke-width='.697' d='M862.208 280.702s-3.037-.024-4.253-.736c-1.323-.774-2.739-3.511-2.739-3.511s-3.348.543-4.888.21c-1.608-.349-3.91-2.188-3.91-2.188 1.537-.227 2.686-.46 4.175-1.664 0 0-2.964-.157-4.652-.807-1.47-.566-3.869-2.44-3.869-2.44 1.37-.34 2.853-.299 3.932-1.638 0 0-2.903.026-4.218-.455-1.313-.48-3.398-2.326-3.398-2.326 1.595-.139 3.113-.434 4.139-1.724 0 0-2.94.1-4.186-.39-1.72-.675-4.352-2.926-4.352-2.926 1.655-.124 3.3-.267 4.553-1.206l-.93-1.889c-1.124-2.28-3.476-1.476-5.04-2.104-1.535-.618-2.395-2.3-2.479-3.244-.148-1.664.703-4.206 4.458-3.675-1.867-2.846.077-4.89 2.064-5.709 1.909-.786 3.595-.571 4.89 2.543 0 0 1.743-1.409 2.687-1.618 1.314-.29 2.795.145 3.262 1.375.192.506.262 1.564-.06 2.195-.51.999-1.632 1.683-1.998 3.144-.415 1.654 1.113 4.54 1.113 4.54s7.218 5.717 10.538 8.85c1.767 1.666 4.976 5.272 4.976 5.272l.177-.103h7.155l.639 12.072-7.786.152z'/%3e%3cpath fill='%23fee46e' d='M852.804 262.287c-2.122-1.886-7.788-6.095-7.788-6.095s-1.297-3.144-1.467-5.304a5.337 5.337 0 0 1 .564-2.822c.453-.874 1.782-1.192 2.032-2.144.078-.3-.026-.665-.226-.903-.238-.284-.646-.473-1.016-.451-1.397.082-3.611 2.144-3.611 2.144s-1.385-2.488-2.596-3.047c-.512-.237-1.172-.216-1.693 0-.492.203-.976.619-1.129 1.128-.486 1.619 1.016 4.966 1.016 4.966s-3.258-.828-4.514 0c-.479.316-.725 1.01-.678 1.58.053.624.507 1.216 1.016 1.58 1.387.995 4.966 1.242 4.966 1.242l4.176 5.643-4.402 1.241c1.677.913 2.99 1.223 7.562 1.242-.931 1.957-2.296 2.627-3.499 3.499l7.675 1.128c-.667 1.92-2.673 2.098-3.612 2.935 1.471.978 3.588 1.472 5.886 1.83.365.058.735.111 1.108.163-1.523-.21-1.263-9.76.23-9.555z'/%3e%3cpath fill='%23ffefa7' d='M851.247 264.44c-4.09-7.098-5.009-5.963-10.123-9.563 3.614 6.412 3.293 5.888 10.123 9.563z'/%3e%3cpath fill='%23377bc8' stroke='%232c5aa0' stroke-width='.697' d='M842.294 240.84c1.367 1.696 1.523 2.474 1.211 4.455.648.674 1.27.837 1.807.674 1.08-.329 1.584-1.19 1.333-2.383-.802-.503-.932-2.017-4.351-2.746zm-8.172.898c-.565-.02-1.252.039-2.105.227 1.947.977 2.41 1.62 2.948 3.553.869.345 1.5.236 1.922-.135.847-.746.95-1.739.227-2.72-.703-.095-1.299-.864-2.992-.925zm-2.421 7.677c-.906.276-2.135-.617-4.924 1.49 2.177.077 2.866.468 4.16 2 .934-.048 1.464-.41 1.692-.923.459-1.032.138-1.976-.928-2.567z'/%3e%3cpath fill='%23e4c900' stroke='%23806600' stroke-width='.697' d='M897.612 286.245c-1.26-.368-2.8-2.026-4.138-2.018-1.408.008-2.402.794-3.11 1.85-.338.505.192 2.392.72 2.754l2.426 1.668s-1.519 1.745-1.634 2.727c-.1.854.329 1.539.94 2.213.798.878.994 1.218 2.265 1.403.759.11 2.555-.221 2.555-.221s-.042 1.4.402 2.046c.804 1.171 2.169 2.203 3.728 2.039 1.218-.129 1.613-.313 2.257-1.22.51-.719.408-2.556 1.237-3.313l3.37-3.078c1.455.88 1.417 2.193 1.236 3.547 0 0 2.163-1.367 2.807-2.346.67-1.02.935-3.428.935-3.428 1.37 1.235 1.823 2.34 1.53 3.815 0 0 2.202-1.375 2.91-2.346.798-1.092 1.486-3.454 1.486-3.454 1.003.975 1.214 2.363.832 4.06 0 0 2.46-1.649 3.118-2.977.52-1.05.832-2.887.832-2.887 2.99.217 4.921-1.085 5.053-2.432.102-1.045-1.08-2.47-3.488-2.883 0 0-.89-1.327-1.226-2.308-.231-.675-.248-1.442 0-2.112.497-1.34 1.656-2.468 2.839-3.432 1.628-1.325 5.17-2.991 5.17-2.991l-1.036-5.19-12.065-1.848-13.336 3.287c2.43 1.115 7.875 4.928 7.43 6.373-.166.541-1.324 1.053-1.878 1.777-.408.533-.096 1.385.304 1.936.561.77 1.901.947 2.332 1.672.388.652.564 1.233.102 1.847-.914 1.213-3.985 1.723-5.475 2.376-2.715 1.191-7.312 3.788-7.312 3.788-1.43.186-2.8-.309-4.118-.693z'/%3e%3cpath fill='%23ffe66f' d='M902.307 288.792s3.352-1.764 5.132-2.643c2.807-1.387 7.713-1.753 8.946-4.63 0 0 .349-.64.235-1.526-.171-1.327-2.484-2.423-1.76-3.871l.586-1.174s2.46 1.06 3.168 1.877c.575.665.657 1.772 1.408 2.23.77.47 2.698.234 2.698.234l1.173 3.402s1.786-.014 2.464.821c.198.245.236.647.117.939-.188.464-1.273.582-1.746.748-.922.323-2.346-.72-2.346-.72s.494 2.307.25 3.054c-.167.517-.82 1.408-.82 1.408-.52-.881-.857-1.31-3.198-2.496 0 0-.282 1.967-.91 3.202-.292.572-1.174 1.526-1.174 1.526s-.535-1.086-.939-1.526c-.756-.823-2.96-1.207-2.96-1.207s-.434 2.413-1.054 3.699c-.228.474-.618 1.173-.618 1.173s-.423-1.108-.822-1.525c-.472-.495-1.76-1.056-1.76-1.056l-4.545 3.754s-.687 2.221-1.757 2.935c-.619.413-.95.211-1.617-.117-.324-.16-.614-.472-.704-.821-.29-1.122.442-2.528.442-2.528s-2.445.958-4.054.501c-.612-.174-1.376-.655-1.407-1.29-.074-1.466 2.058-2.848 2.058-2.848s-2.407-.566-3.406-1.937c-.326-.447-.557-1.193-.235-1.642.37-.518 1.253-.477 1.877-.352 1.191.237 1.734 1.656 2.938 1.82l4.34.586z'/%3e%3cpath fill='%23ffefa7' d='M917.938 284.359c-5.907-.303-10.523 2.555-15.242 5.739 6.053.028 10.69-1.993 15.242-5.74z'/%3e%3cpath fill='%23efd300' stroke='%23806600' stroke-width='.697' d='M922.003 269.91s-.23 4.317-2.033 5.422c-.776.475-1.863.673-2.71.338-.82-.323-1.394-1.203-1.694-2.032-.192-.531-.508-1.864-.508-1.864s-2.756-1.26-4.235-1.355c-2.178-.139-6.437 1.186-6.437 1.186.727-2.26 2.684-4.112 4.743-5.929l7.114-.508 5.76 4.743z'/%3e%3cpath fill='%23fee46e' d='M935.781 241.223c1.684-.224 5.14-1.055 6.301-2.428l2.057-2.428c-.321 4.037-2.03 6.654-5.657 8.428-2.894 1.415-6.235 1.742-9.387 1.428-1.984-.198-5.657-1.428-5.657-1.428 2.015 2.615.99 4.462-1.543 5.713 0 0 .375-2.505-.386-2.857-1.642-.758-3.492.23-5.236 1.391-1.288.858-3.237 1.258-4.55 1.24-2.188-.029-3.4-.06-5.447-.92-1.233-.52-3.374-2.501-4.28-2.304-1.959.425-4.431.664-5.545 2.502-.387.639-.34 1.638 0 2.31.761 1.506 2.473 2.292 3.985 2.694 4.496 1.197 8.166 1.189 12.605.429 4.574-.783 9.915-2.351 14.488-3.297 4.533-.939 10.378-2.711 13.813-3.568 6.071-1.514 8.795-1.722 13.338-1.642 7.957.141 10.562 4.834 10.32 9.956-.249 5.262-5.043 7.644-9.148 9.12-7.218 2.596-17.128 1.118-23.356.94 0 0 2.088 1.943 3.035 2.83 1.11 1.041 1.664 3.216 3.035 3.747 1.88.728 4.756-.715 6.744-.843 2.78-.178 7.503.187 7.503.187.724-.818 1.192-1.386 1.944-1.63.539-.176 1.387-.186 1.82-.002.855.363 1.431 1.481 1.072 3.563 0 0 .594.923 1.499 1.136.958.225 2.077.027 2.624.218.9.316 2.36 1.31 2.36 1.31s-1.547.545-2.19.98c-.44.298-1.029 1.285-1.029 1.285s2.119.04 3.004.476c.948.468 1.823 1.788 1.823 1.788s-1.275-.1-1.883.326c-.465.326-1.227 1.223-1.227 1.223s2.48-.224 3.325.596c.748.726 1.609 2.026 1.609 2.026s-1.338-.032-1.971.17c-.412.132-1.14.664-1.14.664s1.714.992 2.467 2.145c.602.92.751 2.979.751 2.979s-1.01-.84-1.63-1.15c-.387-.192-1.266-.161-1.266-.161l.402 4.226c.098 1.04 1.41 2.165 1.644 2.969.295 1.014.221 1.395-.308 2.283-.678 1.138-2.078 1.37-3.29 1.142-.667-.126-1.606-1.063-1.606-1.063s-.683 1.403-1.144 1.833c-.772.72-1.104.629-2.11.586-.773-.033-1.46-.194-1.995-.814-.615-.714-1.041-2.851-1.041-2.851l-2.374.521c-.516.114-2.079-.76-2.253-1.31-.365-1.155-.4-2.322.308-3.259.674-.889 2.535-.935 3.483-1.425 1.215-.628 2.383-2.444 2.383-2.444s-3.967-3.39-5.682-5.497c-.944-1.16-2.566-3.87-2.566-3.87s-5.058 1.693-6.965 2.037c-4.705.848-9.715 0-9.715 0-7.19 0-11.974-12.267-18.513-15.068-1.995-.854-2.934-.72-5.021-.203-7.576 1.877-15.664 12.542-23.17 14.741-3.08.903-9.53 1.222-9.53 1.222s-1.057 2.527-2.055 3.248c-1.087.785-3.814.836-3.814.836s-.697 3.022-1.496 4.17c-.835 1.2-3.128 2.362-3.128 2.362.338-1.379.54-2.434.061-4.175 0 0-1.14 2.41-2.25 3.552-.965.994-3.32 2.222-3.32 2.222.189-1.286.729-2.506 0-3.961 0 0-.97 2.435-1.813 3.335-.841.899-3.067 1.877-3.067 1.877.431-1.39.707-2.78 0-4.17 0 0-.922 2.497-1.748 3.336-1.14 1.157-3.884 2.425-3.884 2.425.463-1.434.908-2.868.565-4.302l-1.866-.003c-2.252-.005-2.396 2.292-3.445 3.338-1.03 1.027-2.703 1.05-3.505.73-1.414-.565-2.672-2.55-.955-5.467-2.97.384-4.517-1.862-4.51-3.86.007-1.92.586-3.614 3.581-3.41 0 0-.387-1.662-.236-2.536.21-1.218 1.073-2.275 2.24-2.156.48.048 1.371.427 1.78.957.644.838.821 2.059 1.894 2.969 1.214 1.03 4.1.946 4.1.946s5.61-3.665 9.311-5.143c1.97-.787 7.561-1.976 7.561-1.976l.176-16.583c3.36.25 1.915.285 4.757.183 4.082-.148 14.805 1.85 14.805 1.85l7.636-.63s12.736-2.32 18.795-3.046c3.053-.365 6.137-.628 9.202-.434 4.617.29 8.582 1.673 12.922 1.957 3.649.239 6.14.688 9.789.435 5.209-.362 14.52.063 17.478-5.622.768-1.475.374-3.496-.772-4.633-1.512-1.499-2.587-2.063-4.604-1.548-1.064.272-2.416 1.173-2.549 2.283a3.13 3.13 0 0 0 .473 2.064c.782 1.221 1.665 1.59 1.665 1.59s-2.26.366-3.288-.549c-1.083-.962-2.056-4.018-2.056-4.018-.509.78-.883 1.635-.797 2.745.073.957-.003 1.556.962 3.008 0 0-2.39-.185-3.535-1.643-.77-.98-1.398-3.928-1.398-3.928-.678.744-1.092 1.948-1.121 2.836-.042 1.282.458 1.845.71 3.192 0 0-2.356-.77-3.289-2.192-.723-1.104-1.109-4.003-1.109-4.003-2.71.75-7.885 1.811-13.519 3.155-3.969.947-10.03 2.403-14.315 3-7.358 1.028-12.714.496-17.237-1.636-2.354-1.11-3.415-2.177-4.021-4.697-.345-1.43.162-3.457 1.33-5.034 1.63-2.2 4.459-3.846 7.619-4.716 0 0 8.37-2.496 13.244-3 7.816-.806 10.994.407 14.26.864 2.122.297 4.406-.19 5.075-1.076.562-.746 1.493-1.55.239-3.349 0 0 1.588.035 2.643 2.202.43.885-.1 2.93-.1 2.93z'/%3e%3cpath fill='%23e4c900' d='M944.148 236.369s-2.274 3.868-3.92 5.024c-2.073 1.456-4.61 2.262-6.99 2.606-2.314.334-4.675-.25-6.992-.56-2.686-.358-6.684-2.14-6.684-2.14.81 1.428 1.632 2.854 1.844 4.28 0 0-2.528-.672-3.861-.232-1.05.346-3.044 1.318-4.06 1.79-1.579.735-4.112-.013-5.79-.255-1.734-.25-2.343-1.176-3.902-.674l-1.518.488 4.917 2.885 4.918.744 3.073-.651 3.38-2.047 2.69-.186.768 1.21.077 2.14 1.766-1.768.462-1.49-.539-2.604 3.611 1.116 4.61.372 4.764-.93 4.226-2.047 2.074-2.605 1.076-4.467zm12.588 12.943a6.254 6.254 0 0 0-3.213 1.021c-1.415 1.359-1.296 2.982-1.28 4.34-.726-1.26-1.3-3.44-1.938-5.225-1.763 1.809-1.857 4.414-2.34 6.555-.991-1.89-1.445-4.134-2.049-6.024-2.037 1.713-2.57 3.78-3.219 5.491-.509-1.098-1.006-2.243-1.134-4.96-.261.099-.426.172-.651.261-6.042.821-19.646 5.258-30.207 6.322-5.851.59-12.24.2-15.925-2.432-1.625-1.16-2.725-2.754-3.023-4.893l-.543 2.497 1.736 3.285 3.907 2.233 7.378 1.71 8.03-.79 4.557-.526 23.858-5.49.518 3.094 1.61 2.037 2.157.974-.841-2.746.33-1.86.84-1.196 1.208 3.455 1.645 1.373 2.23.575-.913-1.682-.073-2.215.694-1.638 1.134 2.923 1.317 1.107 2.962.265-1.829-2.08-.365-1.861 1.207-1.506 2.779-.664 2.158.84 1.682 1.596.513 2.48-.442 1.848c4.162-3.686.138-8.648-4.465-8.494zm4.465 8.494c-.037.034-.068.068-.107.1l.073.045.034-.145zm3.665-4.643c-.225 2.796-1.192 4.99-2.712 6.648-7.205 7.861-23.288 5.235-31.004 2.544l-3.473-.551a35.499 35.499 0 0 0-1.724-.74c-2.58-.569-2.024-.28-4.868-.458-3.066-.194-6.15.069-9.202.434-6.06.726-18.796 3.045-18.796 3.045l-7.635.63s-10.724-1.997-14.806-1.85c-2.842.103-1.397.067-4.757-.183l-.03 2.795s3.513.923 6.778 1.585l-.948.064-4.725 8.346c-.205-1.564-.853-3.904-.853-3.904l-.495 6.283-.906 1.601-5.549 1.388-5.642 2.561-4.432 3.172-4.432-1.22-1.713-3.05s.406 3.524 1.41 4.636c1.231 1.365 4.835 1.586 4.835 1.586s5.235-3.71 8.06-5.001c1.226-.561 2.497-.952 3.779-1.3.444.506 1.035 1.107 1.7 1.587.634.456 1.994 1.168 1.994 1.168.159-3.832 2.367-3.787 5.687-5.796l.34 2.345s6.254-2.136 7.955-4.043c1.136-1.274 2.238-2.774 2.733-4.552.368-1.322.304-3.553.216-5.029 1.392-.008 2.79-.048 4.245-.1 6.387-.226 13.236-3.118 19.586-3.976 5.085-.687 10.708-1.683 15.336-.822 3.887.724 5.378 2.277 8.73 4.767 2.82 2.093 5.68 7.725 9.456 7.725 0 0 2.136-.132 3.529-.329 1.754-.248 2.989-.983 4.75-1.15 2.397-.23 5.693.254 5.693.254 1.553-2.191 2.348-2.236 2.794-1.957.983.614 1.117 1.973.231 3.35.978.744 1.602 1.966 4.576 1.792-1.31 1.153-1.705 1.729-2.243 3.15 1.116-.408 2.286-.02 3.956.513-1.182 1.12-1.507 2.233-1.916 3.218 1.11-.16 1.94.108 3.933.483-1.138.66-1.993.973-2.184 1.887 1.299.82 1.179.497 3.069 2.27-1.201.174-1.934.176-2.402 1.11l2.29 4.034-.305-3.758s.88-.031 1.267.162c.62.308 1.63 1.149 1.63 1.149s-.15-2.059-.752-2.98c-.752-1.151-2.466-2.144-2.466-2.144s.727-.531 1.14-.663c.633-.202 1.97-.171 1.97-.171s-.86-1.3-1.609-2.027c-.845-.82-3.325-.595-3.325-.595s.762-.897 1.227-1.223c.608-.427 1.884-.326 1.884-.326s-.875-1.32-1.823-1.788c-.885-.436-3.004-.476-3.004-.476s.587-.986 1.028-1.285c.643-.435 2.19-.979 2.19-.979s-1.459-.995-2.36-1.311c-.546-.191-1.665.008-2.624-.218-.905-.212-1.498-1.136-1.498-1.136.359-2.082-.218-3.2-1.074-3.563-.432-.184-1.28-.174-1.82.002-.75.245-1.219.813-1.942 1.631 0 0-4.724-.366-7.504-.188-1.987.128-4.864 1.571-6.744.844-1.37-.531-1.925-2.707-3.035-3.747-.947-.888-3.035-2.83-3.035-2.83l-.143-.208 7.094.443 7.149.107h4.501c5.177-1.264 11.206-2.645 13.68-8.979l.089-4.703zm-53.529 12.074c-1.873-.039-4.004.583-5.696 1.31-4.836 2.08-12.416 8.379-12.416 8.379-2.144 1.339-5.225 3.556-7.512 4.484-3.495 1.418-10.975 1.653-10.975 1.653s-1.015 3.86-2.379 4.596c-1.207.652-3.908-.823-3.908-.823s.044 2.187-.113 3.36c-.143 1.071-1.19 3.088-1.19 3.088s-.27-1.593-.623-2.264c-.517-.982-2.095-2.4-2.095-2.4s-.424 2.22-.85 3.223c-.549 1.294-2.152 3.498-2.152 3.498s-.214-1.32-.454-1.92c-.436-1.09-1.756-2.95-1.756-2.95s-.532 2.296-.962 3.361c-.366.906-1.36 2.538-1.36 2.538s-.26-.849-.452-1.234c-.536-1.073-1.927-2.95-1.927-2.95s-.955 2.454-1.586 3.567c-.394.696-1.36 1.92-1.36 1.92s-.02-2.208-.623-2.88c-.564-.629-1.68-.9-2.435-.755-2.48.476-3.444 2.93-5.097 5.114-.356.47-1.12.741-.825.206.452-.82.11-1.582-.214-2.008-.365-.478-1.065-.764-1.567-.454-.767.473 1.819-3.201 1.756-3.201 0 0-2.61.09-3.852-.206-.718-.17.631.235.465-1.922-.157-2.032-1.75-1.832-1.31-1.99 1.218-.435 3.224.482 3.224.482s-.929-.963-.51-1.822c.191-.391 1.294-1.189 1.469-2.2.253-1.473-.94-2.636-.986-2.525-.524 1.27-2.031.938-2.242 2.156-.15.875.237 2.537.237 2.537-2.995-.205-3.573 1.49-3.58 3.409-.008 1.998 1.54 4.243 4.51 3.86-1.718 2.917-.46 4.902.954 5.466.802.32 2.475.297 3.505-.73 1.049-1.046 1.193-3.343 3.445-3.338l1.866.004c.343 1.434-.102 2.868-.565 4.301 0 0 2.743-1.267 3.884-2.425.826-.838 1.748-3.335 1.748-3.335.707 1.39.431 2.779 0 4.169 0 0 2.225-.977 3.067-1.876.842-.9 1.813-3.336 1.813-3.336.729 1.456.189 2.676 0 3.962 0 0 2.355-1.229 3.32-2.223 1.11-1.141 2.25-3.552 2.25-3.552.48 1.742.277 2.796-.062 4.175 0 0 2.294-1.162 3.129-2.362.799-1.148 1.496-4.169 1.496-4.169s2.727-.052 3.813-.836c.999-.722 2.056-3.248 2.056-3.248s6.45-.32 9.53-1.222c7.506-2.2 15.594-12.864 23.17-14.742 2.086-.517 3.026-.652 5.021.203 6.538 2.8 11.322 15.068 18.512 15.068 3.238 0 5.011.848 9.715 0 1.907-.344 6.965-2.036 6.965-2.036s1.623 2.71 2.566 3.869c1.716 2.108 5.682 5.498 5.682 5.498s-1.167 1.815-2.382 2.443c-.949.49-2.81.536-3.483 1.425-.71.937-.673 2.103-.308 3.258.174.55 1.737 1.424 2.252 1.31l2.374-.52s.427 2.136 1.042 2.85c.535.62 1.222 1.04 1.994 1.073 1.007.043 1.339-.124 2.11-.844.461-.43 1.145-1.832 1.145-1.832s.938.936 1.606 1.062c1.211.229 2.611-.004 3.29-1.142.529-.889-.138-3.112-.433-4.126 0 0-.027 2.151.16 2.897-.83-1.873-3.117-1.817-3.865.074-1.128-.71-1.433-1.939-1.433-1.939l-.588 2.457c-.3.466-.066 1.102-.647 1.437-.089-2.368-1.632-2.608-2.992-1.995-.427-.855-.205-2.287-.205-2.287s-1.333.64-2.296.905c-.573.158-.198-.399-.351-1.085-.18-.805-1.32-.588-1.09-.726 1.218-.737 2.522-1.01 3.683-1.874 1.062-.79 2.35-3.363 2.35-3.363s-4.128-3.49-6.015-5.803c-1.516-1.858-3.333-5.72-3.333-5.72s-7.452 2.342-11.619 2.53c-2.485.113-5.987.013-8.268-1.187-4.066-2.14-6.59-7.436-10.309-10.361-2.366-1.862-4.333-4.005-7.138-4.38a7.025 7.025 0 0 0-.786-.059z'/%3e%3cpath fill='%23fff1a1' d='m934.302 236.32.066.154.013-.058-.079-.096zm.066.154-.381 1.663-1.816 1.816-2.131.67-3.554-.383-5.368-.765h-5.998l-6.71.956-6.553 1.626-3.71 1.624s2.523.46 3.789.383c3.768-.227 7.39-1.885 11.13-2.486 2.252-.36 4.52-.754 6.79-.67 2.95.111 5.814 1.396 8.762 1.53 1.555.072 3.255.434 4.658-.381.806-.469 1.609-1.338 1.815-2.391.198-1.01-.555-2.807-.724-3.192zm18.87 10.035-7.776.554-9.262 2.215c10.604 1.891 23.35-6.057 28.246 4.62l.071-1.662-2.132-3.234-3.202-1.833-5.946-.66zm11.208 7.388-.003.09.114.138c-.035-.08-.075-.15-.11-.228zm-48.645 10.188c11.838 7.67 13.26 19.316 28.81 14.17-13.979 1.103-14.852-12.53-28.81-14.17zm-11.94 1.817c-13.742 5.445-17.27 5.238-19.01 7.203-.736.83-.763 1.936-1.436 3.087-.669 1.144-1.981 2.331-3.537 3.335 9.716-.199 17.382-10.493 23.982-13.625zm46.942 11.279c1.4 5.666 4.904 9.056 8.688 12.433-1.656-5.712-4.513-9.402-8.688-12.433zm-90.156 7.226c-7.593.667-7.975 3.687-11.01 5.088 8.056-.788 7.417-1.81 11.01-5.088z'/%3e%3cpath fill='none' stroke='%23806600' stroke-width='.697' d='M935.781 241.223c1.684-.224 5.14-1.055 6.301-2.428l2.057-2.428c-.321 4.037-2.03 6.654-5.657 8.428-2.894 1.415-6.235 1.742-9.387 1.428-1.984-.198-5.657-1.428-5.657-1.428 2.015 2.615.99 4.462-1.543 5.713 0 0 .375-2.505-.386-2.857-1.642-.758-3.492.23-5.236 1.391-1.288.858-3.237 1.258-4.55 1.24-2.188-.029-3.4-.06-5.447-.92-1.233-.52-3.374-2.501-4.28-2.304-1.959.425-4.431.664-5.545 2.502-.387.639-.34 1.638 0 2.31.761 1.506 2.473 2.292 3.985 2.694 4.496 1.197 8.166 1.189 12.605.429 4.574-.783 9.915-2.351 14.488-3.297 4.533-.939 10.378-2.711 13.813-3.568 6.071-1.514 8.795-1.722 13.338-1.642 7.957.141 10.562 4.834 10.32 9.956-.249 5.262-5.043 7.644-9.148 9.12-7.218 2.596-17.128 1.118-23.356.94 0 0 2.088 1.943 3.035 2.83 1.11 1.041 1.664 3.216 3.035 3.747 1.88.728 4.756-.715 6.744-.843 2.78-.178 7.503.187 7.503.187.724-.818 1.192-1.386 1.944-1.63.539-.176 1.387-.186 1.82-.002.855.363 1.431 1.481 1.072 3.564 0 0 .594.922 1.499 1.135.958.226 2.077.027 2.624.218.9.316 2.36 1.31 2.36 1.31s-1.547.545-2.19.98c-.44.299-1.029 1.285-1.029 1.285s2.119.04 3.004.477c.948.467 1.823 1.787 1.823 1.787s-1.275-.1-1.883.326c-.465.326-1.227 1.223-1.227 1.223s2.48-.224 3.325.596c.748.726 1.609 2.026 1.609 2.026s-1.338-.032-1.971.17c-.412.133-1.14.664-1.14.664s1.714.993 2.467 2.145c.602.92.751 2.979.751 2.979s-1.01-.84-1.63-1.15c-.387-.192-1.266-.161-1.266-.161l.402 4.226c.098 1.04 1.41 2.165 1.644 2.969.295 1.014.221 1.395-.308 2.283-.678 1.138-2.078 1.37-3.29 1.142-.667-.126-1.606-1.063-1.606-1.063s-.683 1.403-1.144 1.833c-.772.72-1.144.92-2.15.876-.773-.033-1.42-.484-1.955-1.104-.615-.714-1.041-2.851-1.041-2.851l-2.374.521c-.516.114-2.079-.76-2.253-1.31-.365-1.155-.4-2.322.308-3.259.674-.889 2.535-.935 3.483-1.425 1.215-.627 2.383-2.443 2.383-2.443s-3.967-3.39-5.682-5.498c-.944-1.16-2.566-3.87-2.566-3.87s-5.058 1.693-6.965 2.037c-4.705.848-9.715 0-9.715 0-7.19 0-11.974-12.267-18.513-15.068-1.995-.854-2.934-.72-5.021-.203-7.576 1.877-15.664 12.542-23.17 14.742-3.08.902-9.53 1.221-9.53 1.221s-1.057 2.527-2.055 3.249c-1.087.784-3.814.835-3.814.835s-.697 3.022-1.496 4.17c-.835 1.2-3.128 2.362-3.128 2.362.338-1.379.54-2.434.061-4.175 0 0-1.14 2.41-2.25 3.552-.965.994-3.32 2.222-3.32 2.222.189-1.285.729-2.506 0-3.961 0 0-.97 2.435-1.813 3.335-.841.899-3.067 1.877-3.067 1.877.431-1.39.707-2.78 0-4.17 0 0-.922 2.498-1.748 3.336-1.14 1.157-3.884 2.425-3.884 2.425.463-1.434.908-2.868.565-4.301l-1.866-.004c-2.252-.005-2.396 2.292-3.445 3.338-1.03 1.027-2.703 1.05-3.505.73-1.414-.564-2.672-2.55-.955-5.467-2.97.384-4.517-1.862-4.51-3.86.007-1.92.586-3.614 3.581-3.41 0 0-.387-1.661-.236-2.536.21-1.218 1.073-2.275 2.24-2.156.48.048 1.371.427 1.78.957.644.839.821 2.059 1.894 2.969 1.214 1.03 4.1.947 4.1.947s5.61-3.665 9.311-5.144c1.97-.787 7.561-1.976 7.561-1.976l.176-16.583c3.36.25 1.915.285 4.757.183 4.082-.147 14.805 1.85 14.805 1.85l7.636-.63s12.736-2.32 18.795-3.045c3.053-.366 6.137-.628 9.202-.435 4.617.29 8.582 1.673 12.922 1.957 3.649.239 6.14.688 9.789.435 5.209-.361 14.52.063 17.478-5.622.768-1.475.374-3.496-.772-4.632-1.512-1.5-2.587-2.064-4.604-1.549-1.064.272-2.416 1.174-2.549 2.283-.071.602.019 1.132.473 1.843.782 1.221 1.665 1.81 1.665 1.81s-2.625.145-3.654-.769c-1.083-.962-1.69-3.797-1.69-3.797-.509.78-.883 1.635-.797 2.745.073.957-.003 1.556.962 3.009 0 0-2.39-.186-3.535-1.644-.77-.98-1.398-3.927-1.398-3.927-.678.743-1.092 1.947-1.121 2.835-.042 1.283.458 1.845.71 3.192 0 0-2.356-.769-3.289-2.192-.723-1.103-1.109-4.003-1.109-4.003-2.71.75-7.885 1.811-13.519 3.156-3.969.947-10.03 2.402-14.315 3-7.358 1.027-12.714.496-17.237-1.637-2.354-1.11-3.415-2.177-4.021-4.697-.345-1.43.162-3.457 1.33-5.034 1.63-2.2 4.459-3.846 7.619-4.716 0 0 8.37-2.496 13.244-3 7.816-.806 10.994.407 14.26.864 2.122.297 4.406-.19 5.075-1.076.562-.746 1.493-1.55.239-3.349 0 0 1.588.036 2.643 2.203.43.885-.1 2.93-.1 2.93z'/%3e%3cpath fill='%23fee46e' d='M879.187 264.843c1.815 1.129 3.808-.35 4.219-.502 0 0-.87-.606-1.457-2.063-.395-.98-.532-2.71-.569-3.521-.135-3.014 1.067-3.481 1.106-3.253 0 0 1.997-.685 2.825-1.323.785-.603 1.147-1.652 1.364-2.618.324-1.448-.247-3.576-.247-3.576-2.9-.168-3.638.216-4.318 1.104 0 0-.06-1.48-.463-2.832-.201-.674-.665-1.677-1.14-2.327-.49-.667-.988-.972-.988-.972-.018.769-.709 1.471-1.062 2.007 0 0-.294-2.944-1.033-4-.57-.814-2.141-1.899-2.13-1.895.012.003-1.786.102-2.704.482-1.191.492-3.025 2.814-3.025 2.814-.009-.643-.213-1.607.186-2.264 0 0-.583-.011-1.355.288-.75.29-1.682.886-2.214 1.345-1.068.922-1.916 2.137-1.916 2.137-.048-1.164-.444-1.834-3.043-3.257 0 0-1.628 1.486-2.135 2.88-.338.931-.596 2.01-.26 2.941.353.984 1.667 2.636 1.667 2.636.155-.171.917.87-.821 3.336-.468.664-1.516 2.049-2.376 2.66-1.28.912-2.339.954-2.339.954.646 1.682.823 2.37 3.284 2.695-5.61 4.026-6.246 10.448-1.94 15.919.281-.657 1.243-2.15 1.81-2.722-.06-.047.073 3.161 1.674 4.795.52.53.773 3.481 1.523 4.409.685.846 1.647 1.767 1.647 1.767s.746-2.34 1.841-2.704c1.102-.368 3.161-.956 3.84-1.17 1.368-.432 3.802-3.345 3.802-3.345l-.428 3.562c7.38-2.616 9.065-7.627 7.175-14.387z'/%3e%3cpath fill='%23504416' d='M864.88 255.754c.322 2.11-.689 6.289-1.486 7.429l4.797 1.923 4.735.546c-.387-1.938 1.51-5.726 2.455-7.015l-3.48.075-1.553-1.552-2.842.63-2.626-2.036z'/%3e%3cpath fill='%23fff' d='M865.826 256.952c-.627 2.27-.267 2.688-.15 3.585l1.384-2.964-1.234-.621zm6.717 2.185-.39 3.248c.572-.7 1.1-.865 1.765-3.124l-1.375-.124zm-6.86 2.287c-.572.7-1.1.866-1.765 3.125l1.375.123.39-3.248zm6.035 1.723-1.383 2.964 1.234.621c.627-2.27.266-2.688.15-3.585z'/%3e%3cpath fill='%23ffefa7' d='M869.449 244.046c-.953-.002-1.877.043-2.562.153-1.733.276-1.807.998-1.807.998 3.163.08 5.42 1.273 7.32 2.904l-1.812 2.65s.558.944 1.037 1.106c.477.162 1.49-.25 1.49-.25l-.276-3.487c2.731-.019 5.321.454 7.72 1.598 0 0 .183-.76-1.057-1.876-1.474-1.327-4.51-3.071-6.013-3.455-.783-.2-2.452-.337-4.04-.34zm-1.118 9.353a1.52 1.49 15.929 0 0-1.465 1.075 1.52 1.49 15.929 0 0 1.053 1.851 1.52 1.49 15.929 0 0 1.872-1.016 1.52 1.49 15.929 0 0-1.054-1.85 1.52 1.49 15.929 0 0-.406-.06zm4.556 1.3a1.52 1.49 15.929 0 0-1.465 1.076 1.52 1.49 15.929 0 0 1.053 1.85 1.52 1.49 15.929 0 0 1.872-1.016 1.52 1.49 15.929 0 0-1.053-1.85 1.52 1.49 15.929 0 0-.407-.06zm-9.291 4.657c-3.25.001-6.835 4.148-6.797 9.012 2.31-3.182 7.174-6.866 7.109-9a3.707 3.707 0 0 0-.313-.013zm11.108 4.297c-.413 1.997 1.262 6.203.781 9.907 2.138-4.743 1.433-9.083-.781-9.907zm-12.523 3.422s-.85 1.726-.892 3.126c-.028.936 0 1.918.343 2.79.355.9 2.604 2.605 2.604 2.605l-.605 2.11s2.416-1.044 2.915-1.86c.382-.624 1.535-3.192 1.535-3.192l-2.532 1.971s-2.556-2.02-2.973-3.126c-.643-1.7-.394-4.424-.394-4.424z'/%3e%3cpath fill='%23fff' d='M866.291 247.441c-.898-.051-1.531.275-1.735.989-.272.952.395 1.977 1.806 2.38 1.41.402 2.783-.317 3.054-1.269.272-.952-.733-1.521-2.143-1.924a4.55 4.55 0 0 0-.982-.176zm9.881 2.86c-.706-.029-1.22.176-1.39.77-.272.953.514 2.288 1.924 2.69 1.41.403 2.518-.116 2.79-1.067.272-.952-.47-1.722-1.88-2.124-.528-.151-1.02-.252-1.444-.27z'/%3e%3cpath fill='%23d1b948' d='M866.301 247.203a2.764 2.764 0 0 0-.894.09c-.532.152-.92.528-1.075 1.075-.156.546-.034 1.117.312 1.594.347.476.91.874 1.656 1.087 1.52.434 3.01-.322 3.33-1.445.161-.562-.08-1.06-.52-1.408-.438-.347-1.045-.605-1.764-.81a4.673 4.673 0 0 0-1.045-.183zm-.016.468c.28.017.592.072.931.169.691.197 1.255.458 1.603.733.348.276.468.51.357.901-.223.78-1.446 1.492-2.746 1.12-.664-.189-1.132-.517-1.404-.892-.272-.374-.355-.8-.24-1.205.116-.405.364-.646.77-.762a2.2 2.2 0 0 1 .729-.064zm9.897 2.402a3.098 3.098 0 0 0-.435.018c-.556.063-1.024.359-1.184.92-.32 1.124.545 2.552 2.066 2.986.746.213 1.434.173 1.98-.05.545-.221.951-.641 1.107-1.188a1.52 1.52 0 0 0-.346-1.481c-.37-.41-.963-.736-1.695-.945-.54-.154-1.042-.25-1.493-.26zm-.024.478c.392.01.869.089 1.387.237.677.193 1.18.473 1.464.786.284.313.368.65.252 1.055-.115.406-.41.722-.839.896-.429.175-1 .207-1.663.018-1.3-.371-1.964-1.622-1.741-2.402.111-.39.337-.525.778-.576.11-.012.232-.017.362-.014z' color='%23000' style='text-indent:0;text-decoration-line:none;text-transform:none'/%3e%3cpath fill='%23e4c900' d='M866.35 245.326c-.645-.086-1.42.024-1.887.476-.28.27-.324 1.136-.324 1.136l1.01.012 1.136.324 2.451 1.099 2.686-.155s-1.468-.6-2.185-1.007c-.97-.549-1.784-1.736-2.887-1.884zm12.865 3.672c-.927-.237-1.99.255-2.964.215-.824-.034-2.444-.314-2.444-.314l2.2 1.549 2.66.36 1.109.316.864.523s.419-.758.324-1.136c-.158-.63-.758-1.133-1.351-1.4-.127-.056-.265-.079-.398-.113zm-15.586 14.264c-2.576 6.23 7.39 9.381 8.848 2.525-2.676-.188-5.477-.675-8.848-2.525z'/%3e%3cpath fill='%23806600' d='m863.391 262.626-.203.495c-.69 1.67-.536 3.21.127 4.398.664 1.187 1.816 2.002 3.097 2.389 1.28.386 2.699.343 3.923-.294 1.223-.636 2.206-1.884 2.595-3.712l.117-.52-.543-.032c-2.641-.185-5.356-.658-8.662-2.472l-.45-.252zm.31.763c2.915 1.489 6.41 2.223 8.776 2.434-.394 1.269-1.185 2.784-2.041 3.23-.975.506-2.863.64-3.934.317-1.07-.323-2.456-1.654-2.982-2.596-.465-.831-.197-2.163.182-3.385z' color='%23000' style='text-indent:0;text-decoration-line:none;text-transform:none'/%3e%3cpath fill='%23377bc8' stroke='%232c5aa0' stroke-width='.697' d='M867.727 257.805c-1.241 4.1-2.321 8.733-1.48 13 2.966-3.18 4.483-7.647 5.592-11.783.006-.167-.815-.537-.92-.669-.257-.324-.693-1.09-.693-1.09s-.829.523-1.297.634c-.4.094-1.202-.092-1.202-.092z'/%3e%3cpath fill='%23e4c900' d='M875.206 239.046c.011.004-1.786.103-2.705.482-1.19.492-3.024 2.814-3.024 2.814-.01-.642-.214-1.606.185-2.264 0 0-.583-.01-1.354.288-.75.291-1.683.886-2.215 1.345-1.068.922-1.915 2.137-1.915 2.137.94-.033 3.033-1.92 3.843-1.737.686.155.21 1.992.873 2.076.904.115 1.708-1.3 2.832-2.29.998-.878 2.383-1.546 3.046-1.329.667.218 1.495 1.52 1.847 2.793.416 1.505.723 3.126 1.414 3.464.686.335 1.282-1.53 1.98-1.295.83.278 1.215 3.118 2.008 3.535 0 0-.06-1.48-.463-2.832-.201-.674-.665-1.677-1.14-2.327-.49-.667-.988-.972-.988-.972-.018.77-.708 1.471-1.062 2.008 0 0-.294-2.945-1.032-4-.57-.815-2.142-1.9-2.13-1.896zm-11.964 10.506c-1.023 1.734.262 3.4 2.33 3.77l-.8 2.04 1.174 2.301 2.141.746 2.025-.8 1.346 1.826 1.88.423 2.418-1.454.967-1.638 1.511-.092 1.291-.62.459-1.608c-1.201.86-2.386 1.702-4.818.69-.07 1.289-.384 2.089-.83 2.545-.532.545-1.252.6-1.965.413-.889-.233-1.65-1.239-2.001-1.771-.88.527-1.631.927-2.175.749-1.137-.371-1.774-1.047-1.96-1.827-.197-.827.113-1.77.87-2.59-4.503-1.19-2.888-2.388-3.863-3.103zm-2.326.583c-.468.664-2.758 4.323-3.618 4.936-1.28.91-2.339.952-2.339.952.646 1.682.822 2.37 3.283 2.695-5.61 4.026-6.246 10.448-1.939 15.919.28-.657 1.242-2.149 1.81-2.722-.06-.047.073 3.162 1.674 4.796.52.53.773 3.48 1.523 4.408.685.847 1.647 1.768 1.647 1.768s.746-2.34 1.841-2.705c1.103-.367 3.161-.956 3.84-1.17 1.367-.43 3.802-3.344 3.802-3.344l-.428 3.562c7.38-2.616 9.064-7.627 7.175-14.388 1.815 1.13 3.808-.35 4.218-.5 0 0-.869-.608-1.457-2.065-.395-.98-.504-2.711-.568-3.52l-.175-2.22s-.835 2.492-1.033 3.185c-.198.694.07 3.16.07 3.16-1.198-.423-2.405-.816-3.462-1.734 0 0 1.268 5.003 1.405 7.386.074 1.288-.365 3.575-.861 4.766-.527 1.262-3.09 3.197-3.09 3.197s.616-3.202.604-4.3c-.017-1.56-.636-5.523-.636-5.523s-.885 4.061-1.589 5.271c-.8 1.378-2.27 3.806-2.27 3.806.412-3.884.206-4.107-.294-5.576 0 0-.92 4.832-2.627 6.908-.426.518-2.043.934-2.967 1.415-1.025.535-1.342 1.11-1.342 1.11s-.967-2.703-1.236-3.328c-.596-1.383-1.779-2.836-2.182-4.286-.592-2.133 2.266-6.718 2.266-6.718-1.058.02-2.117 1.263-3.258 2.633-.933 1.12-1.998 2.3-2.512 3.153 0 0-.914-3.331-.899-4.32.022-1.4.549-2.804 1.269-4.005 1.168-1.95 6.306-5.953 6.306-5.953-1.414.38-2.694.883-5.375.103 0 0 2.121-2.488 2.469-3.073 1.065-1.793.664-2.473.955-3.68zm9.573 2.047c-1.063-.019-2.4.122-2.4.122l.143.92.965.373 1.307 1.944 3.326-.892.442-.762s-1.877-1.394-2.87-1.62a4.81 4.81 0 0 0-.913-.085z'/%3e%3cpath fill='none' stroke='%23806600' stroke-width='.697' d='M879.187 264.843c1.815 1.129 3.808-.35 4.219-.502 0 0-.87-.606-1.457-2.063-.395-.98-.532-2.71-.569-3.521-.135-3.014 1.067-3.481 1.106-3.253 0 0 1.997-.685 2.825-1.323.785-.603 1.147-1.652 1.364-2.618.324-1.448-.247-3.576-.247-3.576-2.9-.168-3.638.216-4.318 1.104 0 0-.06-1.48-.463-2.832-.201-.674-.665-1.677-1.14-2.327-.49-.667-.988-.972-.988-.972-.018.769-.709 1.471-1.062 2.007-.328-2.717-.933-4.268-3.162-5.896-2.59.062-4.086 1.32-5.73 3.296-.009-.642-.213-1.606.186-2.263 0 0-.583-.012-1.355.287-.75.291-1.682.887-2.214 1.346-1.068.922-1.916 2.137-1.916 2.137-.048-1.164-.444-1.834-3.043-3.257 0 0-1.628 1.485-2.135 2.88-.337.931-.596 2.01-.26 2.941.353.984 1.667 2.636 1.667 2.636.156-.171.917.87-.821 3.336-.468.664-1.515 2.048-2.376 2.66-1.28.912-2.339.954-2.339.954.646 1.682.823 2.37 3.284 2.695-5.61 4.026-6.246 10.448-1.94 15.918.281-.657 1.243-2.148 1.81-2.721-.06-.048.073 3.161 1.674 4.795.52.53.773 3.48 1.523 4.409.685.846 1.647 1.767 1.647 1.767s.746-2.34 1.841-2.704c1.103-.368 3.161-.956 3.84-1.17 1.368-.432 3.802-3.345 3.802-3.345l-.427 3.562c7.38-2.616 9.064-7.627 7.175-14.387z'/%3e%3cpath fill='%23806600' d='M861.223 242.63s-1.183 1.827-1.008 3.017c.14.946 1.767 3.075 1.767 3.075s1-3.092.843-4.24c-.115-.843-1.602-1.852-1.602-1.852zm4 3.945a1.58 1.58 0 0 0-.646.169c-.441.216-.742.284-.929.938.543-.087.893-.284 1.338-.483.106-.053.27-.053.554.056.568.22 1.357.852 2.228 1.104 1.247.36 2.86-.065 3.496-.134-.069.262-.19 1.032-.467 1.435-.14.205-1.178.601-1.656 1.055a14 14 0 0 0-.67.673c-.198.216-.364.389-.464.661-.2.55-.09 1.134-.09 1.134l.023.312.299.096c1.1.358 1.29.76 1.563 1.616l.043.134.1.079c.116.102.202.184.305.25.103.065.238.12.359.133.24.029.286-.02.51-.007l.19.013.148-.13c.684-.582 1.068-.82 2.191-.544l.294.074.194-.25s.393-.441.513-1.014c.06-.284-.078-.431-.132-.719-.054-.288-.13-.607-.214-.925-.167-.638-.696-1.8-.708-2.05-.022-.487.234-1.138.314-1.397.507.396 1.648 1.732 2.89 2.082.874.247 1.878.126 2.476.24.3.056.437.143.5.244l.882 1.116c.186-.654-.036-1.071-.296-1.488-.261-.416-.492-.37-.913-.45-.84-.16-1.812-.061-2.388-.223-1.417-.4-2.778-1.917-2.778-1.917l-.4-.348-.3.443s-.544.824-.485 2.13c.023.506.524 1.492.688 2.119.081.313.156.617.201.86.046.244.037.445.038.44-.022.11-.127.263-.22.414-1.06-.155-2.235.347-2.891.867-.116.002-.273-.007-.264-.004-.014-.01-.056-.05-.09-.077-.281-.799-1.178-2.025-2.173-2.458.001-.177-.006-.363.032-.469-.002.006.106-.167.273-.35.168-.182.392-.402.626-.625.47-.445 1.452-.882 1.739-1.3.74-1.078.71-2.065.71-2.065l-.028-.537-.523.085s-1.816.58-3.23.17c-.575-.165-1.348-.761-2.147-1.07a1.54 1.54 0 0 0-.615-.108zm-1.918 2.535c-.774 1.045-.896 2.162-.447 3.027.375.72 1.13 1.177 2.012 1.469-.05.141-.064.164-.126.371-.134.45-.273.975-.22 1.484.11 1.04.691 1.878 1.44 2.516.652.558 1.532.792 2.348.752.503-.025.949-.218 1.305-.401.127-.066.14-.082.244-.144.199.406.498.902 1.057 1.289.672.465 1.534.727 2.383.599.972-.148 1.906-.552 2.55-1.379.314-.403.473-.923.596-1.376.045-.161.036-.169.065-.297.947.283 1.842.198 2.518-.268.803-.555 1.239-1.57 1.21-2.778-.692.352-.075 1.382-1.594 2.324-.494.341-1.21.416-2.136 0l-.706-.579.046 1.003s-.061.34-.172.745c-.11.405-.3.878-.43 1.047-.468.6-1.273.9-2.087 1.023-.545.083-1.216-.108-1.704-.446-.467-.323-.893-1.214-.914-1.303l-.23-.97-.49.543c-.12.133-.457.273-.748.423-.291.15-.635.274-.917.288-.593.03-1.272-.165-1.692-.524-.626-.534-1.21-1.428-1.29-2.184-.023-.212.066-.714.187-1.117.12-.403.356-.724.356-.724l.401-.517-.809.05c-.931-.198-1.59-.66-1.867-1.193-1.004-1.111-.097-1.917-.139-2.753zm21.9.365s-1.794.074-2.337.728c-.74.893-1.521 4.045-1.521 4.045s2.505-.949 3.123-1.678c.777-.918.736-3.095.736-3.095z' color='%23000' style='text-indent:0;text-decoration-line:none;text-transform:none'/%3e%3cpath fill='%232b2200' d='M867.072 248.081a.996.996 0 0 0-.965.723.996.996 0 0 0 .685 1.23.996.996 0 0 0 1.23-.683.996.996 0 0 0-.684-1.23.996.996 0 0 0-.266-.04zm9.932 2.844a.996.996 0 0 0-.935.722.996.996 0 0 0 .684 1.231.996.996 0 0 0 1.23-.685.996.996 0 0 0-.683-1.23.996.996 0 0 0-.296-.038z'/%3e%3cpath fill='%23377bc8' stroke='%232c5aa0' stroke-width='.697' d='M839.961 281.706c-.73.339-1.794-.467-3.97 1.828 1.797-.074 2.387.268 3.54 1.707.767-.113 1.183-.512 1.341-1.04.32-1.06.001-1.98-.91-2.495zm51.148 2.94c-.883.342-2.175-.459-4.803 1.845 2.177-.081 2.894.259 4.296 1.693.927-.116 1.429-.517 1.619-1.045.382-1.062-.006-1.981-1.112-2.493zm-54.916 3.412c-.56.66-1.8.43-3.05 3.58 1.626-.929 2.282-.896 3.811-.127.667-.47.918-1.036.892-1.596-.054-1.128-.647-1.82-1.653-1.857zm55.992 4.888c-.636.7-2.15.561-3.469 3.799 1.91-1.048 2.704-1.064 4.6-.409.777-.519 1.046-1.102.98-1.66-.134-1.12-.892-1.768-2.11-1.73zm-52.04 2.656c-.297-.015-.62.078-.955.285-.229.905-1.408 1.426-1.253 4.917 1.058-1.763 1.645-2.116 3.291-2.332.398-.802.394-1.444.148-1.92-.31-.598-.735-.924-1.23-.95zm111.248.373c-.21.011-.434.07-.67.177-.308.87-1.527 1.231-1.687 4.722 1.21-1.612 1.825-1.886 3.48-1.884.468-.743.523-1.382.321-1.887-.304-.763-.812-1.16-1.444-1.128zm-51.56 2.36c-.359.023-.736.156-1.119.405-.18.93-1.545 1.598-.989 5.05 1.087-1.889 1.756-2.315 3.716-2.74.394-.848.322-1.486-.025-1.928-.435-.555-.983-.825-1.582-.787zm64.578.238c-.602-.055-1.132.325-1.5 1.123.227.906-.514 2.133 1.221 4.927.068-2.177.393-2.867 1.66-4.157-.038-.933-.337-1.463-.76-1.693a1.619 1.619 0 0 0-.621-.2zm-7.12 1.013c-.384.035-.765.27-1.116.706.024.946-.955 1.897.118 5.142.533-2.08.995-2.643 2.497-3.488.165-.913-.009-1.52-.368-1.874-.361-.358-.747-.52-1.131-.485z'/%3e%3c/g%3e%3c/svg%3e";
            },
            3025: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 2000 1000'%3e%3cpath fill='%2300afca' d='M0 0h2000v1000H0z'/%3e%3cg fill='%23fec50c' transform='translate(1080.472 420)'%3e%3ccircle r='134.55'/%3e%3cg id='c'%3e%3cg id='b'%3e%3cpath id='a' d='M0-152.9c8-.1 11-5.1 11-11.1 0-8-11-46.1-11-46.1S-11-172-11-164c0 6 3 11.1 11 11.1z'/%3e%3cuse xlink:href='%23a' transform='rotate(90)'/%3e%3cuse xlink:href='%23a' transform='rotate(180)'/%3e%3cuse xlink:href='%23a' transform='rotate(270)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(22.5)'/%3e%3cuse xlink:href='%23b' transform='rotate(45)'/%3e%3cuse xlink:href='%23b' transform='rotate(67.5)'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='rotate(11.25)'/%3e%3c/g%3e%3cg fill='%23fec50c'%3e%3cpath d='M1056.467 711.467c-3.6.2-7.1.666-10.534 1.766-4.7.634-9.2 2.267-13.866 3.034l-1.867.3-3.133.3c.2.866.333 1.733.333 2.6 0 .9-.1 1.766-.333 2.5-.2.7-.834 1.566-1.334 2.1-.666.733-1.366 1.366-2.2 1.766-.8.4-1.7.567-2.6.634-.9.033-1.833 0-2.7-.334-.9-.3-1.733-.866-2.5-1.533-.933.233-1.9.4-2.8.5-.933.1-1.8.1-2.633 0-.933-.267-1.9-.567-2.8-.933s-1.767-.834-2.6-1.367c-3.4 2-7.2 3.9-9.267 7.4-1.166 1.6-1.4 3.433-1.666 5.333-.167 2.334.433 4.8 1.433 6.967.367.633.667-2.3 1.8-2.7 1.9-1.567 4.267-2.7 6.667-3.333 2.033-1.034 1.766.066.933 1.666-.2.834-1.333 4 .2 2.4 6.767-3 14.267-3.6 21.567-4.166 10.6-1.1 21.233-1.334 31.866-1.467 10 .133 20 .267 30 .633 4.767.134 9.567 1.2 14.267.4 1.133-.3 2.9-.366 3.567-1.033-2.134-1.233-4.634-1.267-7-1.567H1080.2c-5.3-.533-10.833-.6-15.833-2.6-1.334-.533-2.567-1.8-3.834-.433-1.9.667-3.933 1.133-5.933 1.267-3.5.266-7-.467-10.233-1.767 2.333-3.233 5.133-6.067 7.7-9.067-2.067-.333-4.067-.766-6.134-1.266 3.634-2.5 7-5.334 10.534-8z'/%3e%3cpath d='M1212.2 746.01c-7.245 4.35-12.775-3.362-18.831-5.675-4.325 2.349-4.729 10.208-8.77 13.93-4.835 5.502-10.76-1.537-10.319-6.965-5.782 4.874-8.706 15.922-18.057 14.446-4.43-3.615-7.721-11.201-11.106-2.564-2.76 4.222-10.11 10.23-13.916 3.854-1.178-5.63-4-12.25-7.063-3.308-2.102 6.325-8.85 10.978-15.379 8.209-3.574-2.922 2.865-13.727-1.684-12.958-6.8 4.495-10.753 15.658-20.242 14.764-3.685-4.136 2.236-11.144-1.806-15.735-4.77 6.123-10.063 15.089-18.315 15.735-3.988-3.232.157-12.501-2.39-13.873-8.467 5.078-17.401 14.128-28.05 11.294 4.15-15.873 21.49-21.442 36.073-22.68 25.089-3.084 51.484 2.586 75.624-6.47 3.9-2.373 13.35-5.739 9.985-11.243-2.98-4.347 7.753-2.647 8.785-7.724-.639-6.43 4.927-5.545 10.364-6.108 24.376-1.052 48.455 4.082 72.758 4.954 1.836 11.842-11.3 20.157-21.876 16.5-5.052.819-12.627-11.615-11.142-2.57-1.018 4.748-.305 11.018-4.643 14.189m-207.4-24.248c5.643 5.165 9.6-.973 14.875-3.216 17.692-6.085 33.128-16.719 48.346-27.344 9.22-7.63 17.214-17.525 29.597-20 24.155-7.303 49.832-6.417 74.08-13.157 18.465-25.28 49.826-34.299 76.097-48.83 5.899-1.833 8.178-6.688 10.062-12.048 10.028-15.83 23.689-29.857 39.845-39.439 7.644-4.177 16.764-6.582 25.418-4.672-.62 10.307-6.533 19.442-13.672 26.57 5.842-.128 10.863-3.819 16.767-3.611 2.023 10.578-9.4 16.114-15.478 22.7 3.385.787 16.353 1.768 9.286 5.159-9.005 6.25-19.289 10.541-27.602 17.799 7.67 1.378 8.544 3.008.745 5.782-4.222 2.862-12.341 3.862-13.126 9.437 5.794 3.561-2.669 7.097-5.933 8.255-6.242 1.454-12.798 4.165-4.507 8.907-3.136 4.738-9.865 5.749-15.356 5.28 1.666 5.37 4.078 11.379-2.892 13.748-15.624 11.81-33.96 20.402-53.6 22.367 24.535 1.886 49.806-2.668 70.772-16.011 2.768-3.273 17.282-6.79 9.164-9.542-3.822-1.59-12.016-3.357-12.57-6.271 11.355-7.006 25.664-4.514 37.88-8.676.316-3.955-9.292-2.855-12.874-3.755-8.543-.7-8.042-2.88.195-3.688 10.422-2.76 22.226-3.303 30.993-10.098-7.138-3.307-16.116-.396-23.732-3.096 12.911-5.65 28.142-6.217 39.726-14.704 5.277-5.87-6.76-4.036-10.267-3.893-7.15 1.245-10.456-2.178-2.332-5.149 13.87-10.227 31.433-16.87 41.176-31.697 2.308-3.319 5.433-13.319-1.928-9.722-9.68 3.219-18.198 14.101-29.228 10.735 21.733-16.844 42.413-36.02 57.267-59.33.768-6.723-9.785-7.45-12.532-2.172-13.963 13.454-26.6 29.335-44.477 37.77 17.121-16.525 31.276-36.092 43.626-56.372 2.648-6.032 9.764-13.286 5.902-19.983-6.225-5.153-14.013-.436-17.248 5.73-10.854 14.17-19.096 30.709-33.054 42.25 12.22-23.321 24.871-48.147 25.18-75.046-.038-5.538-1.15-13.694-8.67-12.66-5.962 1.069-4.546 9.992-7.004 14.505-5.411 18.377-7.951 38.279-19.05 54.37 2.497-14.933 6.866-30.5 3.512-45.58-1.567-6.739-12.45-3.84-11.048 2.83-13.002 65.86-57.194 123.46-114.99 156.78-26.464 14.973-56.023 24.626-86.096 29.002-8.09 1.771-16.84.732-24.572 3.49-18.736 14.367-30.08 38.407-53.802 45.935-10.632 5.284-24.496 6.356-32.098 16.233-.658 1.263-.8 2.727-.774 4.128'/%3e%3cpath d='M1075.8 654.95c-3.5 6.354-5.56 13.658-10.06 19.347-13.541-12.321-33.171-11.914-50.347-12.734-14.177-.757-29.594-2.065-40.563-12.176-11.539-9.452-20.958-21.724-33.852-29.393-11.769-3.2-23.633-7.204-33.095-15.271-20.22-16.482-31.8-40.937-51.558-57.933-3.767-3.708-8.209-6.581-12.429-9.727-4.01.977-2.195 9.631-7.102 5.22-2.67-1.9-9.348-2.085-9.95.569 6.041 7.96 12.088 17.049 12.925 27.23-4.12.422-11.445-.87-13.487.664 5.471 8.2 12.484 15.473 20.452 21.263-3.822.614-11.353.28-12.818 1.82 7.909 6.446 16.39 13.034 26.747 14.69 2.12 2.794-3.1 8.19 1.29 10.576 2.545 1.04 10.944 2.78 5.159 5.675-3.97 2.675-2.497 8.91 2.58 8.77 3.21 1.64 10.417 2.041 10.981 4.88-2.845 2.895-11.698 6.328-4.163 9.04 7.039 3.904 15.067 6.439 23.105 6.717-4.034 3.394-9.004 5.32-13.156 8.513 18.55 10.877 39.113 18.03 59.433 24.919 8.09 2.703 16.274 5.223 24.66 6.81-24.368-1.407-47.921-8.621-70.115-18.495-11.503-5.045-23.084-9.92-34.873-14.265 5.169-2.69 11.148-3.347 16.509-5.675-11.128-2.23-23.285-2.96-33.067-9.077 1.5-2.676 7.183-2.802 10.326-4.164 5.911-1.416 9.578-3.134 1.243-3.648-8.405-2.281-18.045-1.257-25.452-6.328.477-3.04 8.229-1.98 11.386-3.293 3.976-.683 8.396-1.255 11.573-3.93-12.994-5.387-29.99-1.57-40.168-13.045-2.347-4.372 7.289-.85 10.033-1.579 6.973 0 14.467 2.216 21.107-.595-18.934-8.313-39.215-16.095-53.655-31.471-1.603-2.472-6.407-9.225-2.531-10.06 11.239 1.487 19.374 13.753 31.396 11.844 1.597-2.153-6.984-5.681-9.126-8.758-17.528-15.041-34.54-31.364-46.825-51.066-.845-6.58 9.497-7.565 12.22-2.484 13.405 12.911 25.514 27.977 42.21 36.791 5.924 2.873-3.402-3.4-4.644-5.675-15.427-17.914-30.113-36.834-40.895-57.932-1.93-3.802-5.128-10.686.646-12.71 5.773-2.892 11.501 1.048 14.428 6.007 11.342 14.305 19.688 31.307 33.817 43.225-12.037-23.359-24.889-47.948-25.2-74.828.283-5.21.618-13.092 7.684-12.878 5.933-.9 4.996 6.696 6.94 10.318 5.846 19.747 8.395 41.121 20.122 58.556-2.59-14.649-6.403-29.735-3.87-44.627.584-4.89 6.089-6.37 9.682-3.414 2.905 7.11 3.51 15.89 6.157 23.491 15.06 51.52 48.875 96.832 92.941 127.24 36.292 24.891 79.362 39.75 123.32 42.341 3.97.346 7.956.466 11.932.71'/%3e%3ccircle cx='1020' cy='720.887' r='2.367'/%3e%3ccircle cx='1019.8' cy='720.507' r='.965' stroke='%2300afca' stroke-width='.381'/%3e%3c/g%3e%3cg fill='%23fec50c'%3e%3cg id='f'%3e%3cg id='e'%3e%3cpath d='M120 72.922s-9.61-8.076-12.874-4.025c-5.25 6.515 16.14 38.968 16.14 50.396 0 18.759-12.517 23.86-27.973 26.539-10.371 1.798-27.259-.752-27.259-.752 3.18-4.273 5.248-5.532 10.606-5.873-5.965-3.097-12.039-9.82-12.039-20.284 0-16.138 6.643-22.79 6.643-40.983 0-10.093-8.276-22.941-8.276-22.941 14.629 1.464 21.879 15.009 17.754 25.834 2.328.335 4.442-.19 6.258-1.91 1.07 3-.62 6.483-2.883 9.484 1.823.974 3.162.39 6.066-.21-.276 3.092-2.128 6.376-6.66 9.468 13.151-3.415 21.243 5.751 21.243 15.347 0 7.248-5.079 12.443-10.044 12.443-1.604 0-3.961-.661-5.29-1.654-.938 1.995-.455 4.665.51 6.66-3.638-.962-5.948-3.123-4.304-7.621-2.795-.257-5.018-1.201-6.53-3 1.532-1.963 3.857-3.093 6.53-3.001-2.035-4.2.233-6.55 3.538-8.456 0 0-2.102 8.456 3.265 8.456 2.413 0 4.612-.786 4.612-4.343 0-3.097-2.707-7.387-8.966-7.114-6.258.273-11.332 4.315-11.332 14.306 0 9.216 7.434 13.8 17.23 14.096 8.833.273 15.5-4.512 15.5-13.625 0-12.128-17.508-39.773-17.508-50.58 0-8.11 7.292-12.636 14.427-12.636 9.252 0 17.058 9.161 17.058 9.161l-5.435 6.815z'/%3e%3cpath id='d' d='M122.02 292.14c0 20.27-18.198 30.688-32.498 30.688-19.266 0-29.524-11.519-29.524-26.598 0-8.548 1.566-13.911 5.507-22.092 0 0 31.78-66.091 44.153-91.653 1.543-3.188 2.041-6.818 2.041-12.138 0-8.217-7.97-14.933-16.327-15.139-7.618-.19-15.918 7.102-15.918 15.412 0 10.093 5.236 14.593 10.612 14.593 6.616 0 9.252-2.72 9.252-7.365 0-3.237-1.563-4.637-3.81-4.637-5.674 0-4.081 7.638-4.081 7.638-2.818-.617-5.134-3.497-3.81-7.093a10.23 10.23 0 0 1-5.51-3.273c1.521-1.475 3.266-2.613 5.51-3-1.329-4.388.447-6.531 4.286-7.433-.775 1.687-.801 3.24-.544 4.705 6.043-1.719 15.306 1.016 15.306 11.456 0 10.365-7.194 19.093-20.681 16.912 3.208 1.534 4.84 4.673 5.17 8.183-2.45-.954-5.17-1.09-5.17-1.09 1.577 2.78 3.767 5.177 3.673 10.637-2.5-1.137-4.823-3.242-8.027-1.91 5.03 9.898-1.15 23.512-16.871 26.733 5.754-6.745 8.571-14.027 8.571-21.277 0-23.496-6.53-27.445-6.53-43.78 0-6.835 3.513-14.215 10.476-19.231v.273c-4.602-1.233-7.55-3.499-9.245-6.578 10.515-2.982 25.8-2.927 34.006.302 9.434 1.093 16.02 8.33 17.96 12.004 1.94 3.67 5.709 16.953 0 28.912-6.25 13.088-35.712 75.56-44.898 95.198-1.948 4.165-3.13 8.583-3.13 13.366 0 12.03 11.02 16.23 17.28 16.23 7.483 0 15.102-5.7 15.102-12.82 0-4.511-2.45-7.228-5.987-7.228-8.458 0-7.944 7.195-6.258 11.729-5.264-2.367-8.324-6.592-7.483-11.047-2.98-.409-5.817-1.822-8.435-4.774 2.06-2.6 4.572-4.567 8.435-4.637-1.687-6.912 2.94-9.835 7.483-11.456-1.437 5.073-2.38 10.911 6.258 10.911 6.3 0 11.258 1.091 14.15 5.183.17-5.456.68-27.005.68-27.005.364-8.098-10.838-7.867-17.958-5.456 2.687-9.327 8.198-14.37 20.952-13.093-3.096-1.295-6.395-4.208-6.395-9.82.002-7.593 6.162-16.005 10.206-18.492l2.022 79.051z'/%3e%3cuse xlink:href='%23d' transform='matrix(1 0 0 -1 0 645.08)'/%3e%3c/g%3e%3cuse xlink:href='%23e' transform='matrix(-1 0 0 1 240 0)'/%3e%3c/g%3e%3cuse xlink:href='%23f' transform='matrix(1 0 0 -1 0 1000)'/%3e%3c/g%3e%3c/svg%3e";
            },
            5984: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 400'%3e%3cpath fill='%23ce1126' d='M0 0h600v400H0z'/%3e%3cpath fill='%23002868' d='M0 100h600v200H0z'/%3e%3ccircle cx='300' cy='200' r='80' fill='%23fff'/%3e%3c/svg%3e";
            },
            2012: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 750 500'%3e%3cpath fill='%23ed1c24' d='M0 0h750v500H0z'/%3e%3cpath fill='%23fff' d='M0 125h750v250H0z'/%3e%3cpath fill='%2300a651' d='M371.59 125c-5.367 11.3-15.473 19.198-25.132 26.672-1.589 1.387-5.54 4.075-2.673 6.12 2.455-2.744 9.195.89 5.278 3.841-3.509 3.285-8.34 4.487-12.236 7.197-3.45 1.874-6.949 3.832-9.685 6.701-.186 4.482 5.562 2.001 7.894 3.869 3.038 3.247-1.288 8.721-5.274 7.47-5.097.155-8.618 4.64-10.545 8.92-3.987 6.165-11.543 7.99-17.557 11.499-3.442 2.006-6.781 4.226-9.985 6.567-4.131 2.824-.537 8.416 3.858 7.044 4.744-.473 9.013-4.201 13.925-3.127 4.455 1.565 5.705 7.387 4.187 11.452-1.124 3.254-3.85 5.547-6.032 8.089-3.545 3.59-8.18 5.921-13.067 7.033-4.723 1.585-8.968 4.479-12.066 8.385-3.596 3.62-7.178 7.299-11.31 10.317-1.306 3.332 2.378 6.17 5.45 6.08 6.472-.407 10.958-5.704 16.47-8.426 4.575-2.056 9.958 2.874 8.84 7.64-.355 4.636-4.696 6.989-8.555 8.415-11.346 5.704-21.197 13.975-29.944 23.1-1.81 3.69-6.783 2.605-9.46 5.177-1.745 3.255 2.633 4.972 5.245 4.637 11.225-1.35 21.7-6.094 31.622-11.315 3.69-1.764 7.155-4.086 10.992-5.492 3.603-.89 8.628.677 9.273 4.778-.005 4.33-4.294 6.727-7.691 8.419-10.475 5.503-21.971 8.546-33.168 12.184-4.191-1.172-7.349 6.285-2.75 7.626 4.861 1.668 10.03.33 15.004.112 15.378-2.356 28.828-10.677 43.204-16.057 5.976-1.948 13.03.77 15.98 6.37 2.963 4.992 2.692 11.556-.434 16.406-4.94 10.568-12.45 20.282-22.531 26.358-6.329 3.133-13.716 4.332-19.14 9.129-5.016 1.653 2.515 8.431 3.604 3.052 3.014-4.111 8.33-5.34 13.153-5.51 7.247-.789 14.943-2.126 20.574-7.143 5.049-3.92 10.024-9.328 16.879-9.413 3.788.45 7.535 3.494 11.383 1.636 3.366-1.54 8.648-.638 9.527 3.502 1.607 4.842 6.598 7.045 10.556 9.636 1.433 2.012 6.193 7.2 7.29 2.626-.885-3.263.38-8.255 4.66-7.165 3.739.167 7.301 1.546 11.033 1.772 4.969 1.029 9.113 4.43 11.935 8.538 1.94 2.68 6.192 7.286 9.351 3.732 1.96-3.676-1.781-6.742-4.828-8.055-4.442-2.752-8.24-6.418-12.123-9.89-5.724-5.345-10.669-12.145-11.577-20.132-1.232-7.963-.584-16.085.455-24.027 1.308-5.113 7.847-7.904 12.418-5.187 6.433 2.935 12.821 7.135 20.196 6.68 10.657.229 21.608-1.812 32.022 1.277 10.135 3.192 17.38 11.744 27.253 15.445 2.21 1.343 5.037.065 5.847-2.295.978-2.121.288-4.835-1.756-6.044-11.441-11.549-27.078-17.16-40.315-26.184-4.168-1.058-4.927-7.763-1.074-9.7 5.065-3.68 12.232-1.967 16.726 1.829 3.795 2.223 8.07 3.888 12.523 3.892 4.561-1.428 2.35-8.027-1.734-8.524-7.399-4.177-12.698-11.033-19.109-16.466-3.69-3.125-7.73-6.29-12.69-6.896-2.711-.493-5.485-.601-8.232-.417-2.576-2.8.857-7.087 4.188-6.736 3.419.23 6.818.484 10.232.008 3.815-.28 7.627-.674 11.455-.7 3.091 2.104 9.267-1.531 6.478-5.16-3.047-2.67-7.454-2.438-11.095-3.808a171.078 171.078 0 0 0-19.497-5.125c-4.612-.275-4.043-6.344.01-7.014 2.652-.989 4.958 1.049 7.504 1.365 4.348.934 8.838.922 13.184 1.87 3.685-1.82.836-7.203-2.497-7.517-7.866-2.813-14.663-7.889-21.308-12.827-7.337-5.518-13.993-11.899-21.42-17.289-2.694-1.67-7.111-2.15-7.82-5.851-.25-3.405 3.757-4.955 6.598-4.16 4.03 1.19 7.786 3.263 11.894 4.281 3.223.548 6.545 1.501 9.652 1.095 3.943-2.477-1.691-4.06-3.73-4.92-5.258-2.836-9.93-6.614-14.66-10.216-4-3.413 3.39-4.92 5.932-3.607 4.25 1.778 4.734-4.415 1.558-5.973-3.743-1.592-6.962-4.234-10.356-6.538-6.133-4.365-13.079-7.821-20.618-8.781-8.452-.85-16.34-5.71-20.825-12.938-2.78-4.119-4.82-8.674-6.794-13.218zm-27.758 47.418c4.356.129 3.687 7.98-.602 7.456-4.165-.268-3.91-8.3.602-7.456zm41.09 4.228c4.24-.759 5.137 6.977.902 7.34-4.413.79-6.048-7.83-.902-7.34zm-12.035 1.008c4.298.845 3.533 8.332-.804 8.397-3.173.707-6.593 2.872-9.803 1.25-2.61-2.762 1.163-6.845 4.077-7.742 2.235-.45 4.291-1.466 6.53-1.905zm27.699.032c4.14 1.511 2.68 8.822-1.688 8.729-4.13.553-6.054-6.338-2.202-7.972 1.247-.442 2.553-.815 3.89-.757zm-46.725 8.294c3.045 2.898 1.247 8.49-2.508 9.827-2.706 1.506-6.396 5.067-9.344 2.137-1.6-3.58 2.415-6.275 4.777-8.261 2.107-1.639 4.433-3.126 7.075-3.703zm34.778 16.163c4.36 2.059 2.147 9.916-2.638 9.428-3.93-.996-3.417-7.737.541-8.274.749-.287 1.435-.708 2.097-1.154zm-13.834.78c4.077 1.91.964 8.715-3.143 7.734-4.259-.5-4.18-7.987.516-7.31.885-.045 1.799-.067 2.627-.423zm29.822 3.903c4.469-1.386 9.85 3.218 8.4 7.887-1.992 3.62-6.918 4.078-10.446 2.725-4.051-.2-6.776-6.29-3.167-8.87 1.494-1.127 3.376-1.59 5.213-1.742zm-66.016 1.171c3.695-2.01 7.619 4.032 4.476 6.698-2.081 3.06-7.427 4.31-9.784.907-1.958-3.324 1.208-8.909 5.308-7.605zm-17.05 2.862c4.192.574 6.924 4.381 8.473 8.007.378 4.418-6.141 6.842-8.985 3.627-3.198-2.006-5.997-6.132-4.32-9.96 1.032-1.521 3.09-2.149 4.832-1.674zm102.003 15.969c4.55-1.2 7.853 6.071 3.946 8.702-3.572 3.244-10.516-1.054-8.654-5.683.926-1.716 2.778-2.857 4.708-3.02zm-57.904 8.293c3.815.486 2.58 7.097-.948 6.875-3.786-.701-2.919-7.248.948-6.875zm-19.35 3.512c3.111-2.201 7.124 3.172 4.536 5.676-3.102 2.185-7.126-3.103-4.536-5.676zm30.766.65c3.606 2.192 5.747 6.278 6.196 10.4-1.729 3.853-8.403 2.924-9.156-1.178-1.32-3.244-.103-7.417 2.96-9.221zm10.737 6.375c4.648-1.167 2.98 8.547-.9 5.177-1.29-1.53-.6-4.05.9-5.177zm-67.432 6.765c3.078-.901 7.564.046 8.413 3.578.359 3.32-3.291 5.046-5.966 5.869-4.287 1.322-8.48 3.494-13.09 3.202-3.454-1.975-4.695-6.016-5.927-9.541 3.335-3.127 8.245-2.21 12.38-2.992a95.993 95.993 0 0 1 4.19-.116zm104.6 15.22c3.925-1.924 8.146 4.307 4.86 7.217-4.11 4.732-12.025 5.61-16.94 1.636-.591-4.187 3.591-7.228 7.307-7.83 1.563-.44 3.116-1.1 4.772-1.023zm22.063 4.781c4.46-.767 7.974 5.596 4.789 8.889-3.015 4.545-10.204 5.737-14.314 2.011-1.602-3.768 1.648-7.695 5.108-8.904 1.487-.633 2.895-1.444 4.417-1.996zm-110.94 6.765c4.13-.408 7.914 3.69 7.372 7.763 2.99 2.942-2.305 8.424-5.284 5.377-2.625-3.18-2.611-7.496-3.628-11.303-.045-.846.58-1.94 1.54-1.837zm31.71 2.374c4.27-1.846 9.795 3.263 7.47 7.588-1.66 3.522-8.136 2.341-7.92-1.739-.012-1.952-.17-3.953.45-5.849zm-15.428 2.764c4.282-.981 8.21 4.57 5.831 8.273-4.269.38-6.485-4.687-5.83-8.273z'/%3e%3c/svg%3e";
            },
            9875: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 300'%3e%3cpath fill='%236Cf' d='M0 0h600v300H0z'/%3e%3cpath fill='%23FFF' d='m200 274 100-14 100 14L300 27z'/%3e%3cpath d='m213.5 274 86.5-14 86.5 14L300 60z'/%3e%3cpath fill='%23FCD116' d='M200 274h200L300 150z'/%3e%3c/svg%3e";
            },
            325: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1000 600'%3e%3cpath fill='%23002b7f' d='M0 0h1000v600H0z'/%3e%3cpath fill='%23ce1126' d='M0 300h1000v300H0z'/%3e%3cg fill='%23ffd83d' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'%3e%3cg id='a'%3e%3cpath stroke='none' d='m216.377 122.289-1.838 62.5h-63.42c-7.802-15.169-14.246-28.052-14.246-45.497 0-14.6 11.483-26.195 28.033-26.195 17.52 0 36.77 5.904 51.471 9.192z'/%3e%3cg stroke-width='1.5'%3e%3cpath d='M144.456 125.16v36.076m5.094-39.756v48.033m5.093-50.561v57.225m5.093-58.407v44.882m5.094-45.104v45.327m5.093-46.91v46.885m5.094-46.885v46.885m5.093-46.426v46.885m5.094-46.425v46.885m5.093-43.899v46.886m5.093-46.426v52.86m5.094-52.86v46.886m5.093-46.886v46.886'/%3e%3cpath fill='%23000' d='M176.395 117.923c10.764 1.775 34.407 12.837 31.71 27.803-3.821 21.21-16.208 12.698-32.629 9.65l-12.408 4.137c-4.44 4.532-10.978 8.683-15.395 3.217h-7.353v28.722h81.342V122.06z'/%3e%3c/g%3e%3ccircle cx='212.815' cy='112.983' r='4.94'/%3e%3ccircle cx='201.713' cy='110.311' r='4.94'/%3e%3ccircle cx='190.45' cy='107.482' r='4.94'/%3e%3ccircle cx='179.143' cy='105.596' r='4.94'/%3e%3ccircle cx='167.836' cy='104.481' r='4.94'/%3e%3ccircle cx='156.749' cy='105.113' r='4.94'/%3e%3ccircle cx='146.179' cy='108.732' r='4.94'/%3e%3ccircle cx='137.276' cy='115.28' r='4.94'/%3e%3ccircle cx='130.957' cy='124.414' r='4.94'/%3e%3ccircle cx='127.912' cy='135.156' r='4.94'/%3e%3ccircle cx='128.027' cy='146.301' r='4.94'/%3e%3ccircle cx='130.152' cy='157.215' r='4.94'/%3e%3cpath d='m214.998 119.531-.46 6.434c-12.29-1.883-29.714-8.732-45.955-8.732-15.006 0-26.654 6.003-26.654 21.14 0 14.919 6.317 28.485 14.705 42.28l-8.731 4.136c-7.803-15.169-14.247-28.052-14.247-45.497 0-14.6 11.484-28.952 31.25-28.952 17.52 0 35.39 5.904 50.092 9.191z'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 443.938 0)'/%3e%3cpath d='m221.969 53.125-5.156 9.656 5.156 9.625 5.156-9.625-5.156-9.656zm0 24.375-5.156 9.625 5.156 9.656 5.156-9.656-5.156-9.625zm-18.382-2.547 8.132 5.156 8.105-5.156-8.105-5.156-8.132 5.156zm20.526 0 8.106 5.156 8.131-5.156-8.131-5.156-8.106 5.156z'/%3e%3ccircle cx='221.969' cy='75.069' r='3.906'/%3e%3ccircle cx='221.969' cy='100' r='10.455'/%3e%3cpath fill='none' stroke-width='1.5' d='M219.344 89.875c0 3.114-.022 4.924-.031 6.625-2.52.112-5.006.377-7.438.781m20.188 0a62.126 62.126 0 0 0-7.438-.781v-6.625m-12.781 12.688a61.391 61.391 0 0 1 10.125-.844c3.45 0 6.83.293 10.125.844'/%3e%3cpath d='M211.75 117.688c-.992 17.082-3.009 34.479-9.656 47.124l10.812-4.375c3.777-14.328 4.57-32.842 5.719-41.593l-6.875-1.156zm20.438 0-6.875 1.156c1.148 8.75 1.942 27.265 5.718 41.594l10.813 4.375c-6.648-12.646-8.665-30.043-9.656-47.125z'/%3e%3cpath d='M221.953 154.688c-12.913 0-22.399 6.086-22.969 21.593-3.156-5.555-16.51-23.025-28.968-20.687-7.41 1.39-13.957 11.666-12.844 23.437-6.135-17.63-24.107-20.519-37.219-10.094 11.642 9.573 16.821 37.835 26.625 50.094h150.75c9.804-12.259 15.014-40.521 26.656-50.094-13.112-10.425-31.083-7.536-37.218 10.094 1.113-11.771-5.466-22.047-12.875-23.437-12.459-2.338-25.781 15.132-28.938 20.687-.57-15.507-10.086-21.594-23-21.594z'/%3e%3cg stroke-width='1.5'%3e%3cpath fill='%23000' d='M297.107 219.026c0 5.58-33.662 11.718-75.138 11.718-41.476 0-75.138-6.137-75.138-11.718s33.662-8.502 75.138-8.502c41.476 0 75.138 2.92 75.138 8.502z'/%3e%3ccircle cx='221.969' cy='114.445' r='3.504'/%3e%3ccircle cx='221.969' cy='122.027' r='3.734'/%3e%3ccircle cx='221.969' cy='130.184' r='4.079'/%3e%3ccircle cx='221.969' cy='139.261' r='4.653'/%3e%3ccircle cx='221.969' cy='149.371' r='5.113'/%3e%3cpath fill='%23000' stroke='none' d='M219.938 159.206c-.553-.007-1.076.459-.938 1.344.163 1.043.367 2.995.563 4.312.22 1.493 1.09 1.13 1.312-.031.221-1.161.132-1.906.188-4.063.027-1.078-.573-1.555-1.125-1.562zm4.062 0c-.553.007-1.153.484-1.125 1.562.055 2.157-.034 2.902.188 4.063.22 1.161 1.091 1.524 1.312.031.195-1.317.4-3.269.563-4.312.138-.885-.385-1.351-.938-1.344zm-7.687.562c-.506.07-1.03.58-1 1.125.055.996.33 2.19.437 3.688.11 1.548 1.202.947 1.313.062.11-.884.235-2.192.125-3.906-.042-.643-.323-.925-.657-.969a.842.842 0 0 0-.218 0zm11.093 0c-.334.043-.615.326-.656.97-.11 1.713.015 3.02.125 3.905.11.885 1.202 1.486 1.313-.062.107-1.499.382-2.692.437-3.688.03-.544-.494-1.054-1-1.125a.842.842 0 0 0-.219 0zm-15.437 1.75c-.463.12-.889.677-.75 1.313.276 1.272.531 2.678.531 3.969 0 1.106.945.711 1-.063a59.74 59.74 0 0 0 .156-3.906c0-1.115-.474-1.432-.937-1.313zm19.687 0c-.329.091-.625.477-.625 1.313 0 1.493.102 3.132.157 3.906.055.774 1 1.169 1 .063 0-1.291.254-2.697.53-3.97.14-.635-.286-1.192-.75-1.312a.551.551 0 0 0-.312 0zm-59.093.171c-.555-.018-.943.734-.563 1.563.608 1.327 1.254 2.165 1.875 3.594.553 1.271 1.401.478 1.125-.407-.277-.884-.577-1.87-1.406-3.75-.311-.705-.699-.989-1.031-1zm98.812 0c-.332.011-.72.295-1.031 1-.83 1.88-1.13 2.866-1.406 3.75-.277.885.571 1.678 1.125.407.62-1.43 1.266-2.267 1.875-3.594.38-.83-.009-1.581-.563-1.563zm-94.812.063c-.408.124-.656.642-.407 1.25.498 1.216 1.217 2.463 1.719 3.781.442 1.161 1.426.832 1.094-.219-.332-1.05-.43-1.665-1.094-3.656-.332-.995-.905-1.28-1.312-1.156zm90.5 0c-.35.074-.752.41-1 1.156-.664 1.99-.763 2.606-1.094 3.656-.332 1.05.651 1.38 1.094.22.502-1.319 1.22-2.566 1.718-3.782.25-.608.002-1.126-.406-1.25a.592.592 0 0 0-.312 0zm-85.5.969c-.515.097-.913.882-.563 1.843.443 1.217 1.072 2.368 1.625 3.75.553 1.383 1.471 1.104 1.25.22-.221-.886-.492-2.352-1.156-4.563-.29-.968-.757-1.327-1.156-1.25zm80.812 0c-.4-.077-.866.282-1.156 1.25-.664 2.211-.935 3.677-1.156 4.562-.222.885.696 1.164 1.25-.219.553-1.382 1.182-2.533 1.625-3.75.35-.961-.049-1.746-.563-1.843zm-93.187.687c-.557.057-1.065.965-.72 1.656.554 1.106.904 1.483 1.438 2.657.553 1.216 1.159.274.938-.5-.222-.775-.505-1.676-.781-2.782-.203-.81-.541-1.065-.875-1.03zm105.562 0c-.334-.034-.672.221-.875 1.031-.276 1.106-.56 2.007-.781 2.782-.222.774.384 1.716.937.5.534-1.174.884-1.55 1.438-2.657.345-.69-.162-1.599-.719-1.656zm-67.031 2.798c-.584 0-1.208.774-1 1.5.331 1.161.844 2.19 1.219 3.687.331 1.327 1.274.666 1.218-.218-.055-.885-.207-2.089-.593-3.97-.146-.704-.494-.999-.844-1zm28.5 0c-.35 0-.699.295-.844 1-.387 1.88-.538 3.084-.594 3.969-.055.884.887 1.545 1.219.218.374-1.496.887-2.526 1.219-3.687.207-.726-.416-1.5-1-1.5zm-14.25 1.187c-.72 0-.819.966-.844 1.75-.083 2.572-1.15 5.069-2.062 6.313-.913 1.244-2.256.913-3.5.25-1.245-.664-1.986-1.16-3.313-2.156-1.327-.996-2.334-.414-.75 1.843 4.617 6.58 9.625 12.205 9.625 22.938 0 1.388.242 1.812.844 1.812.601 0 .875-.424.875-1.812 0-10.733 4.976-16.357 9.594-22.938 1.583-2.257.577-2.839-.75-1.843-1.327.995-2.069 1.492-3.313 2.156-1.244.663-2.588.994-3.5-.25-.913-1.244-1.98-3.741-2.062-6.313-.026-.784-.125-1.75-.844-1.75zm-35.281-1.61a.6.6 0 0 0-.188.031c-.269.085-.448.41-.344.97.186 1.001.88 2.966 1.157 3.905.276.94 1.432.74 1.156-.53-.277-1.273-.262-1.657-.594-3.095-.181-.786-.747-1.269-1.187-1.28zm70.562 0c-.44.012-1.006.495-1.187 1.281-.332 1.438-.318 1.822-.594 3.094-.277 1.272.88 1.472 1.156.531.276-.94.97-2.904 1.156-3.906.104-.56-.075-.884-.343-.969a.6.6 0 0 0-.188-.03zm-91.531.406c-.579.046-.994.773-.406 1.844.633 1.157 1.72 2.608 2.218 3.438.498.829 1.359.27.75-.782-.608-1.05-.812-2.257-1.531-3.75-.27-.56-.684-.777-1.031-.75zm112.5 0c-.348-.027-.762.19-1.031.75-.72 1.493-.924 2.7-1.532 3.75-.608 1.051.253 1.61.75.782.498-.83 1.585-2.281 2.219-3.438.588-1.071.173-1.798-.406-1.844zm-144.188 3.33c-.668-.036-.877 1.17-.25 1.968.913 1.161 1.548 1.777 2.594 2.719.83.746 1.07-.222.656-.969-.414-.746-1.014-1.505-1.843-2.75-.455-.682-.853-.952-1.157-.969zm175.875 0c-.303.016-.701.286-1.156.968-.83 1.245-1.43 2.004-1.844 2.75-.414.747-.173 1.715.657.969 1.046-.942 1.68-1.558 2.593-2.719.627-.798.418-2.004-.25-1.969zm-170.843 1c-.533.006-.884.4-.47 1.312.595 1.306 1.378 2.786 1.876 3.781.497.995 2.014 1.33 1.406-.219-.608-1.548-.728-2.343-1.281-3.78-.277-.72-1-1.102-1.531-1.095zm165.812 0c-.532-.008-1.255.374-1.531 1.093-.553 1.438-.673 2.233-1.281 3.781-.609 1.549.908 1.214 1.406.22.498-.996 1.28-2.476 1.875-3.782.414-.913.063-1.306-.469-1.313zm-175.562.343c-.774.008-.84.784-.157 1.281.913.664 2 1.4 3.063 2.25 1.244.996 1.726.08 1.062-.75-.663-.829-1.31-1.67-2.968-2.5-.415-.207-.743-.284-1-.28zm185.312 0c-.258-.002-.585.074-1 .281-1.659.83-2.305 1.671-2.969 2.5-.663.83-.181 1.746 1.063.75 1.062-.85 2.15-1.586 3.062-2.25.684-.497.618-1.273-.156-1.28zm-109.656.719c-.433.06-.807.552-.625 1.187.331 1.161.708 2.392.937 3.594.222 1.162 1.565 1.176 1.344.125-.22-1.05-.332-2.365-.719-3.969-.145-.601-.448-.89-.75-.937a.637.637 0 0 0-.187 0zm33.812 0c-.301.047-.605.336-.75.937-.386 1.604-.498 2.919-.718 3.97-.222 1.05 1.122 1.036 1.343-.126.23-1.202.606-2.433.938-3.594.181-.635-.192-1.127-.625-1.187a.637.637 0 0 0-.188 0zm-63.906-1.985c-.34.094-.536.744-.281 1.656 1.41 5.06 1.842 7.724 1.594 8.969-.25 1.244-.932 1.414-1.844 1a18.844 18.844 0 0 1-2.813-1.594c-.829-.581-1.692.114-.5 1.094 6.055 4.976 10.252 10.664 11.875 17.562.332 1.41 1.218 1.576.969 0-1.372-8.69-1.636-15.833.438-20.312.779-1.684-.006-3.3-1.25-.563-.83 1.825-2.172 2.545-3.25.969-1.079-1.576-3.306-5.78-3.97-7.688-.248-.715-.555-1.046-.812-1.093a.354.354 0 0 0-.156 0zm94.031 0c-.256.047-.563.378-.812 1.093-.664 1.908-2.89 6.112-3.969 7.688-1.079 1.576-2.42.856-3.25-.969-1.244-2.737-2.03-1.12-1.25.563 2.074 4.479 1.81 11.622.438 20.312-.25 1.576.637 1.41.968 0 1.623-6.898 5.82-12.586 11.875-17.562 1.192-.98.33-1.675-.5-1.094-.829.58-1.9 1.179-2.812 1.594-.912.414-1.595.244-1.844-1-.249-1.245.184-3.91 1.594-8.97.254-.911.058-1.561-.281-1.655a.354.354 0 0 0-.157 0zm-124.468 2.422c-.547.007-1 .39-.75 1.22.398 1.328 1.223 2.764 1.5 3.593.276.83 1.165.442 1-.719-.166-1.16-.248-1.853-.47-3.125-.11-.636-.734-.976-1.28-.969zm155.062 0c-.546-.007-1.17.333-1.281.97-.222 1.271-.303 1.963-.469 3.124-.166 1.161.723 1.548 1 .719.276-.83 1.101-2.265 1.5-3.594.249-.83-.204-1.212-.75-1.219zm-136.281-1.735c-.635-.114-.727 1.524-.188 2.188.72.885 1.718 1.954 2.719 3.156.83.995 1.342.11.844-.719-.498-.83-1.236-1.711-2.563-3.812-.332-.526-.6-.775-.812-.813zm117.5 0c-.212.038-.48.287-.813.813-1.327 2.1-2.065 2.982-2.562 3.812-.498.83.014 1.714.844.719 1-1.202 2-2.271 2.718-3.156.54-.664.448-2.302-.187-2.188zm-132 3.954c-.394-.028-.729.292-.563 1.094.232 1.116.567 2.043.844 3.094.276 1.05 1 .87 1-.125 0-.996-.178-2.106-.344-3.157-.083-.525-.543-.878-.937-.906zm146.5 0c-.394.028-.855.381-.938.906-.166 1.051-.344 2.161-.343 3.157 0 .995.723 1.175 1 .125.276-1.051.612-1.978.843-3.094.166-.802-.168-1.122-.562-1.094zm-133.406 1.421c-.62.094-1.164.692-.438 1.625 1.161 1.493 2.432 2.54 2.875 3.094.442.553 1.563.349.844-.813-.735-1.186-1.846-2.615-2.344-3.5-.187-.331-.566-.462-.937-.406zm120.062 0c-.272.029-.548.158-.687.406-.498.885-1.61 2.314-2.344 3.5-.72 1.162.401 1.366.844.813.442-.553 1.713-1.601 2.875-3.094.725-.933.18-1.531-.438-1.625a.889.889 0 0 0-.25 0zm-140.719 4.173c-.488-.044-.657.35 0 1.25 1.493 2.046 3.14 5.142 3.25 6.469.111 1.327-.545 1.312-1.156 1.312-1.825 0-2.716-1.332-4.375-1.719-1.659-.387-1.9.486-.719 1.344 6.083 4.424 12.179 9.36 14.625 13.844.995 1.825 2.34 2.492 1.594.75-2.287-5.337-2.841-9.857-2.344-12.594.498-2.737 1.177-4.58 1.094-6.156-.083-1.576-.977-1.468-1.344 0-.249.995-.73 2.314-1.062 2.812-.332.498-1.666.777-2.938-.937-1.272-1.714-4.48-5.015-5.531-5.844-.394-.31-.8-.505-1.094-.531zm161.625 0c-.293.026-.7.22-1.093.531-1.051.83-4.26 4.13-5.532 5.844-1.272 1.714-2.606 1.435-2.937.937-.332-.498-.814-1.817-1.063-2.812-.367-1.468-1.26-1.576-1.343 0-.083 1.576.595 3.419 1.093 6.156.498 2.737-.056 7.257-2.343 12.594-.747 1.742.598 1.075 1.593-.75 2.447-4.485 8.543-9.42 14.625-13.844 1.181-.858.94-1.73-.718-1.344-1.66.387-2.55 1.72-4.375 1.72-.611 0-1.268.014-1.157-1.313.11-1.327 1.757-4.423 3.25-6.47.657-.9.489-1.293 0-1.25z'/%3e%3cpath d='m150.127 212.651 1.95 6.174m2.06-7.344 1.728 6.24m2.605-6.953 1.187 6.365m2.833-7.169 1.27 6.349m3.886-6.858 1.032 6.392m4.452-6.385 1.112 6.378m4.242-8.189.803 6.425m4.234-6.1.803 6.425m4.071-7.074.804 6.424m4.089-6.93.442 6.46m4.786-6.461.384 6.463m4.357-6.79.326 6.467m4.9-6.793.272 6.47m5.74-6.632.272 6.469m79.044.177-1.95 6.174m-2.06-7.344-1.729 6.24m-2.604-6.953-1.187 6.365m-2.833-7.169-1.27 6.349m-3.886-6.858-1.033 6.392m-4.452-6.385-1.112 6.378m-4.241-8.189-.804 6.425m-4.233-6.1-.804 6.425m-4.07-7.074-.804 6.424m-4.09-6.93-.441 6.46m-4.787-6.461-.383 6.463m-4.357-6.79-.327 6.467m-4.9-6.793-.271 6.47m-5.74-6.632-.272 6.469m-7.202-6.89v7.123'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";
            },
            1616: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1200 600'%3e%3cpath fill='%23ffb700' d='M0 0h1200v600H0z'/%3e%3cpath fill='%23ff5b00' d='M50 300 215 50h165v500H215z'/%3e%3cpath fill='%23005641' d='M50 50h165v500H50z'/%3e%3cpath fill='%238d2029' d='M430 50h725v500H430z'/%3e%3cpath id='a' fill='%23ffb700' stroke='%23000' stroke-width='2.126' d='M1086.1 466.06s6.798 13.841 14.309 19.48c11.128 8.356 33.945 7.752 43.629 17.5 11.604 11.495-.9 26.682-.796 28l.636 8.02s-7.824.095-11.119.609c-4.953.772-6.886 4.803-16.109 4.204-23.189-1.505-22.254-22.397-23.566-40.25-1.164-6.798-3.859-15.662-5.39-22.458-1.313-5.828-1.594-15.105-1.594-15.105z'/%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 1585 0)'/%3e%3cuse xlink:href='%23a' transform='matrix(1 0 0 -1 0 600)'/%3e%3cuse xlink:href='%23a' transform='rotate(180 792.5 300)'/%3e%3cuse xlink:href='%23b' stroke='%23000' stroke-width='5.56'/%3e%3cg id='b' fill='%23ffb700'%3e%3cpath d='m681.54 479.56 4.36-2.517 1.864 2.522c2.485 3.359 9.36 3.321 13.921-.078l3.488-2.598 2.921 2.598c3.84 3.417 11.012 3.422 15.591.012 3.206-2.388 3.653-2.436 5.773-.619 1.264 1.083 4.97 2.316 8.237 2.74 5.882.764 5.971.722 9.413-4.442 2.883-4.324 3.334-6.075 2.646-10.269-.456-2.78-.947-7.256-1.092-9.945-.26-4.87-.233-4.9 6.86-7.37 3.917-1.364 8.452-3.193 10.076-4.065 2.833-1.52 10.643-10.699 10.643-12.508 0-.48-3.05-1.214-6.78-1.632-14.833-1.664-17.345-9.629-7.702-24.423 15.725-24.128 25.215-47.625 25.278-62.593.029-6.69.41-8.937 1.27-7.482 3.513 5.946-2.782 30.877-12.317 48.78l-3.839 7.209 3.663-.844c2.015-.463 13.861-5.461 26.325-11.107 34.115-15.45 45.833-18.479 67.911-17.549 18.498.78 26.375 4.393 39.435 18.09 6.918 7.257 13.583 12.45 25.775 20.08 25.975 16.26 27.058 17.667 28.293 36.788 1.251 19.373.628 20.424-14.024 23.661-12.524 2.767-20.375 8.606-22.481 16.717-1.125 4.332 1.242 4.457 7.556.399l4.627-2.974 2.058 2.974c2.705 3.91 8.455 3.926 13.23.036l3.606-2.939 3.687 2.939c5.729 4.565 13.347 3.458 15.497-2.252.414-1.098 1.517-.746 3.75 1.195 4.186 3.637 14.914 5.197 16.072 2.337.443-1.09-.397-3.786-1.866-5.988-6.242-9.36-8.195-13.823-8.276-18.918-.113-7.087 2.001-10.505 10.06-16.268 9.792-7.001 12.817-16.033 5.372-16.033-4.598 0-9.232-4.064-12.187-10.686-6.008-13.461-4.83-28.552 4.186-53.657 9.159-25.5 10.175-30.202 10.211-47.256.03-13.79-.317-16.174-3.455-23.734-1.918-4.623-5.81-11.505-8.649-15.294l-5.161-6.89 6.627-5.49c20.234-16.764 16.095-44.199-8.263-54.77-7.452-3.233-9.314-3.519-22.372-3.431-7.834.053-19.78 1.083-26.546 2.29-6.899 1.232-18.575 2.221-26.585 2.254-12.725.05-14.885-.263-19.79-2.873-5.112-2.722-5.99-4.014-6.99-10.305-.206-1.293-1.11-2.583-2.01-2.867-1.738-.548-9.77 6.423-10.957 9.51-.586 1.524-1.063 1.418-2.781-.613-1.14-1.349-2.733-4.449-3.54-6.888-2.026-6.136.463-10.735 7.675-14.181l5.595-2.674-3.3-2.048c-6.808-4.225-18.385-1.334-22.572 5.635-1.184 1.972-2.476 3.588-2.87 3.593-.395.003-2.646-1.877-5.003-4.18-8.79-8.59-5.766-21.297 5.991-25.177 6.27-2.069 11.818-.49 12.972 3.69 1.763 6.383 7.241-2.007 6.259-9.584-.654-5.037-.556-5.212 2.93-5.212 4.847 0 15.165 6.362 18.356 11.32 3.706 5.756 3.437 14.822-.642 21.58l-3.203 5.305 4.19-.84c6.143-1.23 12.112-5.045 15.13-9.671 3.193-4.892 3.536-14.416.705-19.555-2.743-4.981-2.428-5.772 1.627-4.089 6.897 2.863 10.584 6.02 13.35 11.431 2.49 4.873 2.63 6.084 1.281 11.156-.832 3.13-2.683 7.246-4.113 9.149-2.228 2.962-2.304 3.459-.529 3.459 3.305 0 10.206-3.128 12.658-5.737 1.238-1.319 3.044-4.564 4.012-7.213l1.76-4.816 2.024 3.67c2.86 5.192 8.422 9.863 15.204 12.77 7.293 3.127 10.33 3.303 6.516.379-2.572-1.973-7.31-15.878-5.875-17.238.846-.8 10.747 6.818 22.053 16.968 10.695 9.6 17.415 12.746 27.238 12.746 12.548 0 19.854-10.923 14.214-21.251-3.288-6.022-10.613-6.858-14.896-1.701-1.97 2.371-2.51 4.257-1.933 6.745.707 3.047.431 3.453-2.345 3.453-3.647 0-10.837-4.667-23.606-15.321-19.471-16.248-43.13-30.02-60.214-35.05-10.963-3.229-34.383-4.489-45.528-2.45-12.062 2.207-26.329 9.11-34.101 16.5-13.772 13.093-13.991 30.517-.581 46.384l3.84 4.546-2.6 4.039c-3.783 5.877-3.459 13.785.804 19.61 1.877 2.566 3.77 4.664 4.208 4.662.437 0 .917-1.65 1.065-3.665.377-5.097 2.564-8.511 6.319-9.863 3.381-1.218 5.567-.643 21.05 5.537 16.29 6.502 43.078 6.949 71.562 1.194 13.964-2.821 30.43-2.655 37.674.38 13.279 5.563 16.357 20.036 6.595 31.022-4.225 4.756-8.3 6.692-21.983 10.448-10.412 2.857-12.878 3.047-36.543 2.81-20.218-.201-27.484.187-35.737 1.91-8.96 1.87-14.47 2.06-40.79 1.396l-30.43-.767 3.374 2.795c1.856 1.537 4.478 3.427 5.827 4.202 2.295 1.317 2.219 1.494-1.193 2.76-2.005.742-6.455 1.35-9.888 1.35h-6.244l-.84 5.306c-.462 2.919-.427 6.326.078 7.571.744 1.838.467 2.102-1.47 1.398-1.313-.477-4.97-1.416-8.126-2.086-3.157-.67-7.406-2.034-9.442-3.031-3.425-1.677-3.806-1.632-5.067.6-1.127 1.994-11.702 9.864-13.254 9.864-.25 0-.574-1.517-.719-3.372-.144-1.855-1.67-6.684-3.39-10.731-1.72-4.047-3.516-8.462-3.991-9.811-.717-2.035-1.041-2.14-1.906-.613-.573 1.012-1.41 3.77-1.859 6.132-.45 2.36-2.043 6.195-3.541 8.522l-2.724 4.23-1.738-3.617c-1.865-3.883-4.961-7.91-6.082-7.91-.378 0-1.023 1.243-1.432 2.76-.855 3.17-8.197 11.957-9.99 11.957-.66 0-1.201-2.483-1.201-5.518s-.583-5.519-1.295-5.519-1.295.785-1.295 1.745c0 2.334-6.27 9.292-8.373 9.292-.918 0-2.394.828-3.281 1.84-2.312 2.638-4.203 2.268-3.231-.633.456-1.36.16-4.532-.659-7.051l-1.932-5.958c-.309-.954-2.556-.7-7.312.824-7.685 2.464-10.26 2.028-6.308-1.068 1.444-1.131 3.642-5.051 4.883-8.71 1.242-3.66 3.073-6.906 4.07-7.215 1.396-.433 1.322.102-.324 2.327-1.175 1.589-2.14 3.732-2.144 4.762 0 1.03-.89 3.473-1.966 5.428-1.077 1.956-1.753 3.749-1.504 3.985.25.236 3.174-.875 6.498-2.468l6.044-2.898.025 2.592c.014 1.426.742 5.188 1.618 8.36l1.594 5.766 4.114-1.891c4.205-1.933 8.188-8.822 8.188-14.164 0-2.64 1.512-2.235 2.132.571.182.824 1.131 3.915 2.11 6.87l1.78 5.371 2.816-3.391c1.55-1.866 3.492-5.525 4.316-8.131 1.432-4.526 3.68-6.471 3.68-3.185 0 2.368 6.462 10.861 7.709 10.131.602-.353 1.802-3.54 2.666-7.083 1.796-7.369 4.695-12.38 6.537-11.302.692.405.962 1.192.599 1.748s1.125 5.347 3.307 10.646a4484.425 4484.425 0 0 1 4.87 11.856c.797 1.963 1.517 1.678 6.194-2.453 2.911-2.57 5.554-5.448 5.872-6.395.48-1.431 1.13-1.379 3.852.31 3.807 2.363 16.605 6.169 17.593 5.233.37-.351.75-3.712.844-7.47l.17-6.832 3.68.764c2.025.42 6.281.393 9.459-.058l5.778-.82-5.15-3.533c-2.832-1.943-5.695-4.458-6.363-5.588-.711-1.204-3.232-2.226-6.087-2.469-7.715-.655-21.388-8.324-21.388-11.996 0-.689 1.893.483 4.208 2.605 5.135 4.706 12.27 7.66 18.5 7.66h4.661l-2.884-3.835c-1.656-2.204-3.142-6.384-3.491-9.822-.556-5.481-1.135-6.353-6.858-10.331-3.438-2.39-7.696-5.972-9.462-7.96l-3.212-3.615-1.639 4.292c-.901 2.36-2.003 4.292-2.448 4.292-.445 0-2.177-1.38-3.85-3.066s-3.377-3.06-3.787-3.052c-.41.007-1.892 2.28-3.293 5.047l-2.547 5.034-1.968-2.901c-1.083-1.596-3.64-4.42-5.683-6.274s-3.118-3.373-2.388-3.373 3.251 1.933 5.603 4.294l4.277 4.294 1.74-3.146c1.033-1.867 1.42-4.734.952-7.053-.682-3.38-.586-3.576.71-1.455.824 1.35 3.326 3.936 5.56 5.748l4.061 3.294 2.803-5.134c2.79-5.11 2.81-5.12 4.078-2.068 1.698 4.08 13.98 14.149 24.437 20.032 1.612.907.933-2.211-2.044-9.38-.788-1.9-1.433-5.323-1.433-7.608 0-3.39-.978-4.899-5.314-8.198-6.26-4.763-8.283-8.15-9.463-15.835-.478-3.113-1.573-6.575-2.434-7.694-1.278-1.66-1.489-.73-1.147 5.047.23 3.894-.276 8.736-1.125 10.759l-1.545 3.68-1.194-3.067c-.656-1.686-3.56-4.619-6.453-6.516-2.893-1.898-4.923-3.77-4.512-4.16.411-.389 3.387 1.34 6.613 3.844 4.915 3.814 5.998 4.227 6.678 2.547.8-1.973 0-10.562-1.546-16.563-.77-2.996-.703-2.98 2.994.716 2.726 2.726 4.234 5.978 5.402 11.65 1.484 7.207 2.232 8.407 8.896 14.258 4.002 3.514 7.484 6.191 7.74 5.95.254-.24.759-9.33 1.121-20.199.696-20.84-.09-25.8-5.11-32.239l-2.578-3.308 4.054-4.373c5.288-5.705 7.717-10.277 8.77-16.515l.857-5.075-4.575 4.333c-3.747 3.548-5.536 4.333-9.875 4.333-4.296 0-5.975-.72-8.87-3.805-3.474-3.702-9.63-7.264-15.549-8.997-2.187-.64-2.914-.362-2.914 1.118 0 1.084-1.207 4.213-2.684 6.953l-2.684 4.983-5.624-5.558c-3.45-3.41-7.543-6.064-10.589-6.865-7.78-2.046-8.202-1.843-8.202 3.954 0 8.793-3.754 10.431-10.51 4.587-5.152-4.455-9.424-5.424-19.192-4.35l-7.543.829 1.357 3.405c1.134 2.845.878 4.043-1.55 7.273-3.94 5.24-9.063 7.51-16.949 7.51-3.632 0-8.177.752-10.1 1.67-1.923.919-6.701 1.977-10.619 2.352-3.917.375-8.092 1.044-9.278 1.487-1.855.693-2.059.122-1.461-4.098.915-6.458-3.597-11.222-10.627-11.222-9.122 0-13.33 8.159-9.757 18.922.688 2.071 1.587 5.338 2 7.259.427 1.993 4.535 7.283 9.568 12.318 4.85 4.854 9.435 9.904 10.188 11.223.753 1.32 3.24 3.436 5.529 4.704l4.16 2.306-.548-4.452c-.603-4.893.463-5.66 3.066-2.208.93 1.235 3.295 3.23 5.253 4.434 3.086 1.896 3.561 1.935 3.561.288 0-1.045.63-3.454 1.398-5.353l1.398-3.452 2.425 4.697c1.333 2.583 5.671 8.455 9.639 13.048 7.698 8.912 12.389 18.87 9.968 21.163-.982.93-3.636.858-9.138-.248-4.264-.857-9.54-1.31-11.722-1.007-4.457.62-4.808.044-2.067-3.388 2.893-3.623 2.433-4.22-3.25-4.22-6.576 0-22.901-3.152-29.168-5.632-6.094-2.411-7.5-1.81-9.293 3.969-.808 2.6-2.286 7.314-3.285 10.474l-1.816 5.744 6.592-.635c3.626-.349 8.29-1.143 10.364-1.764 2.075-.621 3.96-.951 4.19-.734.23.218-.695 2.463-2.055 4.988l-2.472 4.593 4.11-.838c2.261-.461 5.662-1.589 7.559-2.506 3.3-1.596 3.564-1.48 6.167 2.697 3.2 5.138 5.761 4.927 6.33-.522.587-5.632 2.44-4.8 5.925 2.665 3.351 7.177 6.838 9.711 7.508 5.456.223-1.412 2.028-3.712 4.012-5.11 4.014-2.827 7.039-1.979 8.773 2.46 1.795 4.596-2.209 9.333-13.853 16.392-23.327 14.14-36.886 33.479-40.757 58.128-3.492 22.233 7.413 45.207 29.29 61.708 10.469 7.896 27.1 16.23 26.043 13.05-4.488-13.504-4.34-39.273.25-43.62.689-.653.452 2.036-.527 5.975-3.645 14.672-2.061 26.363 7.282 53.763 8.451 24.782 7.281 35.373-4.679 42.374-3.841 2.248-6.315 2.619-16.643 2.493-11.207-.136-12.428.09-16.026 2.957-3.488 2.78-8.01 11.906-8.01 16.165 0 2.307 2.561 2.002 7.596-.905z'/%3e%3cpath d='m863.45 479.06 4.701-3.021 3.19 3.021c4.18 3.958 9.076 3.87 13.094-.237 1.754-1.792 3.329-3.033 3.5-2.759.17.274.953 1.603 1.737 2.952.994 1.707 3.036 2.566 6.723 2.826 4.441.313 5.634-.117 7.399-2.668l2.104-3.04 4.627 2.974c12.67 8.142 19.42-.4 13.758-17.411-2.879-8.65-1.296-13.512 7.983-24.521 3.913-4.643 7.118-9.598 7.122-11.011 0-2.254-.724-2.556-5.932-2.453-4.983.1-6.44-.436-9.064-3.323-4.266-4.697-4.013-10.075.756-16.044l3.81-4.769-6.76-4.587c-3.717-2.523-10.421-8.492-14.898-13.265-10.054-10.719-19.94-15.802-32.975-16.955l-8.74-.773.012 6.616c.017 8.517 4.014 16.71 14.924 30.588 12.405 15.779 13.271 18.222 13.774 38.846l.425 17.442-3.59 3.406c-3.243 3.077-4.706 3.47-15.173 4.073-9.964.575-12.058 1.089-14.982 3.68-3.883 3.44-5.045 5.311-6.244 10.062-.699 2.77-.415 3.373 1.583 3.373 1.338 0 4.55-1.36 7.135-3.022zm-266.63-45.08c1.109-1.5 2.016-3.92 2.016-5.38 0-2.205.985-2.793 5.831-3.481l5.832-.828-3.89-3.1c-4.62-3.682-5.047-6.558-.975-6.564 4.056 0 10.925-4.212 11.97-7.328.485-1.449.18-3.384-.691-4.377-2.274-2.595-6.549-2.204-7.343.672-.853 3.09-2.282 3.099-5.522.03-4.873-4.615-4.982-14.169-.226-19.732 2.242-2.621 2.222-2.793-.636-5.5-3.075-2.912-5.27-8.675-3.826-10.043.46-.435 2.889-.089 5.398.771 3.565 1.221 4.973 1.24 6.442.085 4.45-3.498-.371-7.995-7.507-7.003-2.872.4-4.058 0-4.47-1.49-.312-1.13-2.824-2.605-5.654-3.32-5.057-1.278-5.093-1.263-5.093 2.221 0 3.818-2.18 4.539-6.32 2.09-3.366-1.991-6.63-.446-6.63 3.138 0 3.343 3.363 4.992 9.39 4.604 4.621-.298 4.793 3.139.403 8.08l-3.156 3.552 2.5 3.593c3.704 5.32 3.392 14.158-.654 18.547l-3.172 3.44-2.081-2.759c-2.892-3.834-6.848-3.577-7.932.516-.71 2.68-.123 3.905 3.233 6.745 2.255 1.908 5.548 3.47 7.318 3.47 4.378 0 4.207 3.443-.345 6.922l-3.56 2.721 5.503.854c3.027.47 5.503 1.353 5.503 1.963 0 2.339 3.814 9.615 5.04 9.615.709 0 2.195-1.227 3.304-2.726z'/%3e%3cpath d='M668.48 402.92c5-1.97 15.821-11.134 15.821-13.398 0-.712-2.987-3.997-6.637-7.3-7.683-6.951-16.04-18.657-18.204-25.501-1.13-3.569-6.585-9.678-21.951-24.581l-20.448-19.832-5.894 1.493c-3.241.82-7.196 1.512-8.788 1.537-2.744.041-2.695.199.954 3.022l3.848 2.979 5.396-2.995c5.23-2.903 5.417-2.92 6.062-.585.378 1.368-.437 3.738-1.883 5.48-1.402 1.687-2.2 3.602-1.775 4.254.426.652-.921 2.016-2.993 3.03-3.84 1.881-6.505 8.071-3.474 8.071 2.726 0 8.737-7.417 8.044-9.925-.355-1.285-.183-2.606.381-2.937 2.342-1.37 2.195 4.453-.183 7.317-1.402 1.688-2.2 3.602-1.775 4.255.426.652-.921 2.016-2.993 3.03-3.815 1.869-6.506 8.071-3.503 8.071 2.944 0 8.857-7.087 8.125-9.739-.383-1.387-.235-2.792.33-3.123 1.576-.923 2.427 3.674 1.096 5.927-.713 1.206-.707 2.853.017 4.16 1.31 2.366-.019 6.91-2.432 8.323-1.035.605-.334 1.793 2.175 3.688 3.631 2.742 3.702 3.03 3.702 15.13 0 10.112.408 12.722 2.266 14.482 2.085 1.976 2.266 1.983 2.266.089 0-2.07 3.632-4.599 6.603-4.599.876 0 6.351 4.64 12.167 10.312 5.85 5.706 11.973 10.561 13.707 10.87 1.723.308 3.588.634 4.145.726.557.092 3.18-.687 5.828-1.73zM605.96 354c0-3.26-6.724-6.74-14.767-7.641-6.493-.729-6.6-.688-6.6 2.556 0 2.685 1.022 3.741 5.504 5.693 7.202 3.135 15.863 2.804 15.863-.608z'/%3e%3cpath d='M613.33 353.7c3.28-2.976 4.834-6.516 2.86-6.516-2.269 0-8.292 5.406-8.292 7.442 0 3.179 1.118 2.988 5.432-.926zm-6.99-9.64c.278-1.84-.86-3.067-4.27-4.607-7.355-3.322-16.15-4.86-18.268-3.196-3.9 3.067-1.301 7.183 5.003 7.924 2.538.298 5.98 1.072 7.648 1.72 4.846 1.882 9.454 1.024 9.887-1.841zm0-9.85c.396-2.624-1.282-3.563-14.978-8.383-10.225-3.6-14.752-1.902-11.484 4.305 1.138 2.163 3.049 3.15 7.334 3.792 3.187.478 7.543 1.41 9.68 2.074 5.707 1.772 9.005 1.148 9.448-1.788zm6.86-9.23c2.067-2.095 3.757-4.567 3.757-5.494 0-3.006-8.161 2.313-9.201 5.996-1.248 4.419.775 4.232 5.444-.502zm-6.86-.62c.45-2.989-4.52-5.688-14.294-7.762-7.171-1.522-10.334-.659-9.797 2.673.293 1.82 2.681 3.149 9.457 5.263 10.843 3.384 14.104 3.345 14.634-.174zm9.56-13.91c12.525-5.575 13.608-19.635 1.798-23.326-4.904-1.533-8.035-.707-9.912 2.615-1.437 2.543-.476 7.167 1.49 7.167.664 0 1.208.856 1.208 1.902 0 4.882-19.123 7.094-26.965 3.12-2.755-1.397-3.955-5.022-1.662-5.022 1.714 0 2.898-3.693 2.023-6.306-1.193-3.559-4.78-4.792-9.983-3.431-11.74 3.07-11.41 16.865.543 22.719 9.8 4.8 31.287 5.092 41.46.563z'/%3e%3cpath d='M608.11 299.64c.725-.687.41-1.742-.806-2.698-2.663-2.093-2.52-5.206.4-8.77 2.193-2.675 2.467-6.68 3.222-47.073 1.301-69.611 6.478-121.97 13.3-134.53 2.717-5.001 2.336-5.02-4.683-.245-9.042 6.152-15.926 14.163-22.026 25.63-11.516 21.652-15.518 50.78-15.518 112.96 0 35.306.24 39.925 2.251 43.244 1.91 3.152 2.012 4.316.67 7.683-.87 2.183-1.264 4.268-.877 4.635 2.571 2.435 21.302 1.79 24.067-.83zm105.23-66.38c.392-.601-.475-3.636-1.926-6.745-2.264-4.847-3.176-5.652-6.4-5.652-10.102 0-26.341-4.514-43.083-11.976-9.668-4.309-13.007-5.3-14.166-4.201-2.958 2.801 1.958 9.45 9.571 12.946 6.754 3.1 25.635 6.91 34.248 6.91 4.997 0 5.115.226 2.271 4.336l-2.091 3.023 5.652.145c3.11.08 7.4.566 9.538 1.081 5.549 1.337 5.6 1.338 6.387.133z'/%3e%3cpath fill='%23000' d='M772.35 264.63c0-1.8-5.284-6.675-10.638-9.817-4.205-2.467-4.9-2.542-4.909-.53-.014 3.055-2.73 10.731-3.798 10.731-.601 0-1.49-1.5-1.977-3.333-.486-1.833-2.524-5.446-4.53-8.029l-3.645-4.695-2.84 4.35c-2.646 4.056-7.231 8.028-9.266 8.028-.486 0-.58-2.136-.211-4.747.402-2.836.092-5.086-.77-5.59-.794-.465-1.444-.303-1.444.36 0 1.528-6.367 8.75-7.714 8.75-.555 0-1.332-2.069-1.727-4.598-.394-2.53-1.065-6.53-1.49-8.891-.426-2.361.48-.76 2.014 3.557l2.789 7.85 3.058-4.784c1.681-2.631 3.06-5.506 3.064-6.39 0-.882.572-1.273 1.264-.869.691.405 1.654 3.568 2.139 7.029l.881 6.292 3.365-3.689c1.85-2.029 4.019-4.745 4.818-6.036 1.427-2.304 1.508-2.302 4.347.106 1.59 1.349 4.036 4.575 5.434 7.17 1.399 2.595 2.73 4.526 2.959 4.292.228-.234.74-2.909 1.138-5.944.398-3.035.753-5.631.79-5.769.197-.752 10.134 5.708 13.811 8.978 2.363 2.102 4.607 3.528 4.987 3.168.38-.36.691-3.461.691-6.892 0-5.317-.563-6.742-3.815-9.648-3.74-3.343-3.844-3.361-5.226-.916-1.793 3.173-3.908 3.219-3.908.084 0-2.287-7.066-11.08-8.904-11.08-.477 0-1.965 1.932-3.307 4.293-1.343 2.36-2.786 4.29-3.208 4.287-1.813-.011-11.774-11.117-11.77-13.122 0-1.594.672-1.187 2.418 1.476 1.327 2.024 3.978 5.045 5.89 6.713 3.874 3.379 5.282 2.557 6.776-3.953.426-1.855 1.166-3.373 1.645-3.373 1.656 0 10.327 9.21 11.547 12.264l1.224 3.066.928-3.373c1.134-4.124 2.385-4.277 4.195-.514.757 1.572 4.492 4.84 8.302 7.263l6.926 4.405 1.39-4.43c.764-2.437 1.777-3.837 2.25-3.112.706 1.081-1.094 8.423-2.453 10.002-.203.237-2.448-1.07-4.987-2.905l-4.617-3.335-.019 5.97c-.012 3.284-.369 7.213-.798 8.73-.84 2.968-3.069 3.803-3.069 1.15zm-34.53-47.6c-8.231-6.872-9.481-8.445-9.299-11.702l.194-3.467.537 3.349c.314 1.955 2.506 4.885 5.269 7.042l4.732 3.694 2.907-3.363c1.6-1.85 2.929-4.053 2.955-4.896.067-2.199.461-2.014 6.034 2.821 4.952 4.296 5.03 4.317 5.765 1.533.411-1.552.265-4.473-.323-6.492-1.618-5.55-1.301-6.388 1.15-3.04 1.222 1.667 3.186 4.025 4.365 5.238 2.052 2.113 2.177 2.087 2.941-.613.439-1.551.806-4.39.815-6.309l.019-3.488 4.464 5.06c4.17 4.728 4.554 4.902 5.827 2.65.75-1.326 1.372-4.517 1.383-7.09.014-3.325.364-4.164 1.21-2.898 1.412 2.114.431 7.87-2.176 12.775l-1.871 3.52-2.457-3.827c-3.142-4.893-4.188-4.814-6.204.466-1.905 4.99-3.144 5.37-5 1.533-1.202-2.483-1.43-2.179-2.283 3.037l-.948 5.797-5.679-4.407-5.678-4.407-2.553 2.903c-1.404 1.596-2.572 3.592-2.596 4.435-.052 1.827-1.417 1.884-3.5.146zm73.22-25.6c-2.996-2.7-5.06-5.275-4.587-5.723.474-.448 1.007-.577 1.185-.285.178.291 2.627 2.866 5.442 5.723 6.483 6.576 5.15 6.762-2.04.285zm-97.53-10.08c-2.725-3.685-2.537-6.127.78-10.121 2.398-2.886 3.493-3.278 7.68-2.746 2.684.34 8.463 2.713 12.84 5.272 5.056 2.955 10.285 4.935 14.335 5.427 3.507.426 6.376.587 6.376.357 0-.23-1.456-2.603-3.237-5.274-4.228-6.344-4.083-7.024.686-3.224 4.895 3.901 10.75 5.042 23.836 4.644l6.393-.194-3.71-3.666c-5.186-5.127-3.59-5.587 2.138-.616 5.373 4.663 5.036 4.991-6.271 6.12-4.805.48-9.972.132-14.267-.96-6.426-1.635-6.675-1.61-5.458.544.702 1.242 1.838 2.257 2.525 2.257.687 0 1.25.63 1.25 1.398 0 2.365-13.88.285-20.512-3.073-15.15-7.67-17.058-8.335-20.664-7.199-2.006.633-4.015 2.484-4.707 4.338-2.31 6.188 6.466 10.997 10.085 5.528 1.049-1.586.804-2.67-1.04-4.599-2.525-2.642-2.288-3.019 1.12-1.78 2.42.88 2.746 6.69.495 8.821-2.576 2.44-8.453 1.749-10.674-1.254z'/%3e%3cpath fill='%23000' d='M773.19 166.07c-1.895-1.794-.41-2.234 8.085-2.392 10.508-.196 16.89-1.947 24.42-6.7 6.033-3.81 7.669-3.06 1.942.89-5.224 3.602-13.372 6.371-21.239 7.218-3.81.41-8.15.978-9.647 1.263-1.497.284-3.1.158-3.561-.279z'/%3e%3c/g%3e%3c/svg%3e";
            },
            7073: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 209 110'%3e%3cpath fill='%23bf0a30' d='M0 0h209v110H0z'/%3e%3cpath stroke='%23fff' stroke-width='10' d='M0 15h209M0 35h209M0 55h209M0 75h209M0 95h209'/%3e%3cpath fill='%23002868' d='M0 0h50v50H0z'/%3e%3cg transform='matrix(15 0 0 15 25 25)'%3e%3cg id='b'%3e%3cpath id='a' fill='%23fff' d='M0 0v1h.5z' transform='rotate(18 3.157 -.5)'/%3e%3cuse xlink:href='%23a' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(72)'/%3e%3cuse xlink:href='%23b' transform='rotate(-72)'/%3e%3cuse xlink:href='%23b' transform='rotate(144)'/%3e%3cuse xlink:href='%23b' transform='rotate(-144)'/%3e%3c/g%3e%3c/svg%3e";
            },
            7192: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 300'%3e%3cpath fill='%23009543' d='M0 0h450v300H0z'/%3e%3cpath fill='%23fff' d='M0 0h450v210H0z'/%3e%3cpath fill='%2300209f' d='M0 0h450v90H0z'/%3e%3cg fill='%23fff'%3e%3cpath fill='%23000' stroke='%23000' d='M224.76 95.569c-1.71.037-3.378 1.93-3.378 1.93l.147 20.234-6.388 6.692h5.172l-.044 11.603-30.591 41.193-4.522-1.563-7.904 16.86s19.55 12.243 47.925 11.908c31.144-.37 48.064-12.471 48.064-12.471l-8.168-16.644-4 1.74-30.983-40.98-.043-11.949h5.17l-7.037-6.609.041-20.159s-1.751-1.82-3.46-1.783z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='5' d='M235.43 144.01h-21.153s-7.678-16.176-6.433-27.485c1.267-11.515 7.848-16.963 16.598-17.059 10.345-.115 15.767 5.07 17.405 16.598 1.623 11.424-6.417 27.947-6.417 27.947z'/%3e%3cpath d='M187.79 182.57c-.346.461-2.882 5.533-2.882 5.533l4.38-.923-1.498-4.61zm2.53 6.57-4.61 1.498 5.532 2.19-.922-3.688zm2.08-6.46 2.305 6.8 5.648-1.613-1.498-3.227-6.455-1.96zm3.57 9.23.807 2.766 7.492 1.845-2.997-6.34-5.302 1.729zm8.3-5.77 2.651 6.34 5.648-2.19-1.844-2.767-6.455-1.383zm3.69 8.65.922 2.42 8.76 1.268-3.688-5.763-5.994 2.075zm8.41-6.8 3.227 5.648 8.184-2.997-.922-2.19-10.489-.461zm4.73 7.72 1.729 2.997 10.143-.346-3.804-5.648-8.068 2.997zm10.72-7.49 2.766 4.726 6.455-3.112-1.729-2.536-7.492.922zm10.6 3.57-6.455 3.227 1.73 2.767 8.644-1.384-3.919-4.61zm2.08-4.96 3.343 4.15 5.417-4.265-1.844-1.96-6.916 2.075zm9.91 2.19-5.187 3.919 1.383 2.42 7.147-1.844-3.343-4.495zm7.15-8.18 1.268 1.844-3.573 5.302-3.689-4.725 5.994-2.421zm2.42 4.61 2.19 4.38-4.38 1.498-.346-2.074 2.536-3.804z'/%3e%3c/g%3e%3c/svg%3e";
            },
            6906: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'%3e%3cpath fill='%23C1272D' d='M0 0h5v3H0z'/%3e%3cpath fill='%23006A44' d='M0 0h5v2H0z'/%3e%3cpath fill='%23FDB913' d='M0 0h5v1H0z'/%3e%3c/svg%3e";
            },
            9207: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 600'%3e%3cpath fill='%2300a1de' d='M0 300h1000v300H0z'/%3e%3cpath fill='%23ed2939' d='M0 0h1000v300H0z'/%3e%3cpath fill='%23fff' d='M0 200h1000v200H0z'/%3e%3c/svg%3e";
            },
            5590: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 600'%3e%3cpath fill='%239E3039' d='M0 0h1200v600H0'/%3e%3cpath fill='%23FFF' d='M0 240h1200v120H0'/%3e%3c/svg%3e";
            },
            1084: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 960 480'%3e%3cpath fill='%23239e46' d='M0 0h960v480H0z'/%3e%3cpath d='M0 0h960v360H0z'/%3e%3cpath fill='%23e70013' d='M0 0h960v120H0z'/%3e%3ccircle cx='480' cy='240' r='60' fill='%23fff'/%3e%3ccircle cx='492.132' cy='240' r='52.132'/%3e%3cpath fill='%23fff' d='m509.175 240 80.7-26.221L540 282.426v-84.852l49.875 68.647z'/%3e%3c/svg%3e";
            },
            3365: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3cpath d='M-900 0H0v600h-900z' style='fill:%23c1272d;fill-opacity:1;stroke:none' transform='scale(-1 1)'/%3e%3cpath d='m450 224.315-44.467 136.87 116.401-84.559h-143.87l116.403 84.559z' style='fill:none;stroke:%23006233;stroke-width:14.62993431;stroke-miterlimit:4;stroke-dasharray:none'/%3e%3c/svg%3e";
            },
            6072: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 750 600'%3e%3cpath fill='%23FFF' d='M0 0h750v600H0z'/%3e%3cpath fill='%23CE1126' d='M0 0h750v300H0z'/%3e%3c/svg%3e";
            },
            4399: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1800 900'%3e%3cpath fill='%23cc092f' d='M0 0h1800v900H0z'/%3e%3cpath fill='%23ffd200' d='M0 0h1200v900H0z'/%3e%3cpath fill='%230046ae' d='M0 0h600v900H0z'/%3e%3cpath d='M847.69 183.24c-3.223 0-6.038.822-7.68 2.1 2.609.76 4.506 3.166 4.506 6.092v7.423h-7.422c-2.907 0-5.315-1.87-6.093-4.454-1.278 1.642-2.099 4.457-2.099 7.679 0 3.223.821 6.039 2.099 7.679.761-2.61 3.166-4.506 6.093-4.506h7.422v35.681c0 2.805-1.754 5.132-4.198 5.989 3.541.482 6.588 5.234 7.423 7.833.837-2.593 3.884-7.351 7.424-7.833a6.28 6.28 0 0 1-4.251-5.989v-35.683h7.424c2.908 0 5.315 1.87 6.093 4.456 1.277-1.642 2.098-4.459 2.098-7.68 0-3.223-.82-6.038-2.098-7.679-.761 2.609-3.167 4.504-6.093 4.504h-7.424v-7.422c0-2.908 1.869-5.315 4.455-6.093-1.64-1.276-4.457-2.098-7.679-2.098z'/%3e%3cpath fill='%23f5d402' d='M847.69 184.78c-1.678 0-3.156.314-4.402.716 1.664 1.447 2.765 3.544 2.765 5.939v7.423c0 .106-.031.207-.052.308v1.177h-1.178c-.1.021-.202.051-.307.052h-7.424c-2.367 0-4.439-1.083-5.886-2.713-.416 1.259-.768 2.697-.768 4.403 0 1.678.314 3.156.716 4.402 1.447-1.664 3.543-2.763 5.938-2.763h8.959c-.01.154-.052.303-.052.459v.768c.021.1.051.201.052.307v35.681c0 2.317-1.195 4.139-2.765 5.58a11.976 11.976 0 0 1 2.918 2.561c.737.885 1.03 1.751 1.536 2.661.507-.908.799-1.776 1.536-2.661a12.036 12.036 0 0 1 2.867-2.509c-1.584-1.437-2.765-3.305-2.765-5.631v-37.168h1.229c.1-.02.201-.05.307-.05h7.423c2.366 0 4.438 1.083 5.886 2.712.415-1.258.769-2.695.769-4.402 0-1.677-.315-3.156-.717-4.402-1.447 1.664-3.543 2.763-5.938 2.763h-7.423c-.105 0-.207-.031-.307-.052h-1.178v-1.177c-.021-.099-.051-.201-.052-.308v-7.422c0-2.367 1.084-4.438 2.713-5.887-1.259-.414-2.696-.768-4.402-.768'/%3e%3cpath d='M940.609 313.987c-4.535-3.221-8.258-6.862-10.904-11.11-6.372-10.223-9.061-22.773-9.061-35.527 0-5.391 6.04-11.46 6.04-15.82 0-6.59-.614-10.544-.614-10.544 2.143.292 5.887 4.095 5.887 4.095s-.129-10.938-3.585-12.849c0 0 1.398-1.438 6.451-1.587-1.42-3.596-8.446-7.986-8.446-7.986.351-.629 1-1.173 1.842-1.638 1.765-.976 4.245-1.62 6.142-1.997-2.022-.419-4.352-1.061-6.91-1.895-5.842-1.903-12.719-4.697-19.146-7.78-11.732-5.628-20.669-5.99-25.596-5.99-3.575.001-8.84.099-11.927 2.152-2.825 1.875-2.595 4.314-3.584 5.17-2.33 2.016-6.321 1.945-8.243 1.945-12.44 0-12.901 13.311-12.901 13.311s3.181-4.813 8.805-4.813c9.351 0 16.433 5.094 16.433 7.013 0 .777-.964.921-1.023.921-6.108 0-15.326-3.516-20.223-3.686v2.406c10.931 3.803 22.013 9.187 22.013 32.917 0 14.943-1.789 30.19-9.265 42.183-2.648 4.247-6.418 7.881-10.955 11.11l44.385 8z'/%3e%3cg id='a'%3e%3cpath d='m896.222 303.988-44.383 10c-2.019-.61-11.513-3.56-18.174-7.269-11.726-6.532-17.806-13.03-31.74-13.669v-10.598c0-5.662 2.049-10.763 2.049-16.177-5.874-1.575-22.178-21.51-37.218-30.358-22.13 14.334-39.265 37.865-39.265 48.686 0 0 .665 232.51 0 313.51 0 4.668-2.815 11.263-2.815 11.263 8.079-3.418 22.888-23.68 26.006-31.382v3.687c12.201-5.564 21.135-20.184 25.136-27.747.071 1.094.257 3.839.257 3.839 10.9-9.555 24.776-66.038 24.776-66.038l23.124 22.725s-8.363 16.976-11.621 20.015c0 0 2.184.277 4.658.256-1.522 2.188-13.147 18.925-16.791 25.238-3.41 5.906-5.816 3.277-11.058 3.277-4.347 0-14.2 6.925-15.818 9.727-1.701 2.945-2.968 6.523-2.968 9.471 0 3.24 3.43 7.68 3.43 7.68.369-1.552 1.023-2.1 1.023-2.1s9.013 11.228 10.341 12.695c1.034 1.143 5.645 1.886 7.27.411 4.066-3.697 8.002-6.282 11.621-11.62 1.863-2.752 2.005-5.905 4.146-8.859 7.162-9.88 21.415-28.799 24.675-33.12.218 1.203.405 2.205.612 3.43 3.694-7.458 21.451-21.707 21.451-21.707l18.578 8.55s-34.687 79.735-65.476 91.995c0 0 13.395 5.691 29.845 14.232a447.91 447.91 0 0 1 7.372 3.943 203.524 203.524 0 0 0 6.399-8.14c9.836-13.16 19.455-28.413 19.455-28.413.67 3.961-4.524 16.194-13.31 31.281-1.728 2.964-3.53 6.064-5.529 9.213a333.743 333.743 0 0 1 6.655 3.892c16.295 9.805 31.598 21.077 37.267 31.432l4-10.009-4-10.009V317.264l2-5z'/%3e%3cg fill='%23b07f55'%3e%3cpath d='M896.202 667.221c-5.749-6.236-17.769-13.855-31.278-20.886 16.334-29.316 24.428-75.655 20.63-84.88 0 0-6.705 24.033-14.898 37.729-7.586 12.684-16.925 26.95-25.954 37.526-7.428-3.169-14.631-5.828-20.785-7.68 27.058-20.843 54.726-89.742 54.726-89.742l-28.612-13.26s-10.704 12.479-14.18 14.796c0 0-1.485-6.206-2.355-8.396 0 0-4.101 3.102-6.346 3.176 0 0-.671-4.212-1.178-6.964-2.825 1.883-7.525 1.485-7.525 1.485 4.127-1.954 9.01-13.925 9.01-13.925l-27.322-36.343s-9.597 46.116-20.528 55.596v-198.58l8.652 8.036 13.105-12.235v-9.317l-11.621 10.852v-28.105a94.373 94.373 0 0 0 3.788-6.194c1.881 3.279 7.96 13.329 15.101 19.505 1.175-4.778 8.908-9.318 8.908-9.318s2.771 7.508 7.012 9.368c1.492-2.628 10.394-8.446 10.394-8.446s-7.616 1.157-10.7 4.045c-2.649-.593-3.328-11.058-3.328-11.058s-11.207 5.459-13.156 9.368c-2.137-.578-5.464-8.988-6.759-12.44a74.752 74.752 0 0 1 8.345-.46c3.196 0 7.285 1.514 11.569 3.532 4.707 2.216 9.631 5.022 14.028 7.014 5.632 2.55 14.153 3.068 16.637 3.174-2.845 2-5.973 3.826-9.367 5.529 0 0 13.411-.124 22.832-4.813 3.361-2.162 6.849-4.316 9.829-6.86-1.293 3.593-3.306 7.839-6.452 11.467 13.836-1.171 20.726-9.072 22.679-11.723.918 2.375 2.553 6.187 5.119 9.47h5v340zM794.247 267.298l.255 6.348v18.687c-5.019-1.727-11.326-9.973-14.384-14.334v-2.56c0-2.408 1.417-4.167 2.457-5.119l-3.02-1.074c-1.152 1.313-2.406 3.263-2.406 5.784v1.485l-9.009 9.676-8.856-13.413v-3.276c0-2.208 1.698-4.67 3.123-6.348l-2.97-1.075c-1.499 1.942-3.072 4.559-3.072 7.013v2.661a10183.97 10183.97 0 0 1-10.187 10.496l-5.17-11.109c6.205-8.595 16.266-18.219 25.749-25.125 0 0 20.564 18.881 27.49 21.283zm-52.12 18.123v15.411l-7.167 6.654v-22.883c0-2.191.918-4.831 2.456-7.731z'/%3e%3cpath d='M764.447 291.359v9.522l-8.241 7.731v-29.794zm-11.161 17.202-8.243-7.679v-11.159l8.243-8.652zm37.627-11.57c-1.914 2.705-6.927 9.321-12.337 12.236v-26.16c1.241 2.064 6.934 11.274 12.337 13.924zm-15.257-12.594v24.163l-8.243-7.679v-8.549zm-33.53 25.75v24.113l-7.167-6.707v-10.7zm11.154 7.731v8.651l-8.244 7.678v-24.009zm11.158-7.678v24.01l-8.241-7.731v-8.549zm11.213 7.73v8.549l-8.243 7.73v-24.01zm11.159 16.33-8.244-7.731v-8.036c2.843-1.735 5.702-4.924 8.243-8.293zm-20.885 10.648 8.703-8.089v198.63s.607 9.856 1.024 16.279l-18.429 18.634V336.766zM752.253 562.94c0 6.385-11.659 21.273-17.303 24.675v-250.74l8.6 8.036 8.703-8.09z'/%3e%3c/g%3e%3cg fill='%23d10429'%3e%3cpath d='m824.535 541.388 6.348-4.352s.423 2.1.972 4.967c-2.718 3.716-18.331 25.024-26.057 35.425-1.921 2.584-3.534 9.163-3.534 9.163s-2.814-1.331-2.814-3.736c0-2.362.308-5.171.308-5.171s-2.101 2.406-5.735 2.406c0-2.903 5.614-6.052 5.836-10.186-4.281 3.174-7.999 1.545-12.951 3.072-5.393 1.661-6.895 3.927-8.549 3.84-.974-.053-1.856-1.733-1.484-2.765.644-1.787 7.314-6.733 11.977-7.627 1.117-.214 9.903 1.912 11.673-.819 7.292-11.252 19.13-29.518 20.272-31.278.752-.18 1.444-.371 1.995-.719 0 0-.067 5.751 1.743 7.78z'/%3e%3cpath d='M783.72 576.452c.353.408.322 1.006-.053 1.33l-2.866 2.508c-.375.324-.977.255-1.33-.154-.354-.408-.324-1.006.052-1.331l2.866-2.508a.851.851 0 0 1 .665-.204c.238.027.488.154.666.359zm4.351 3.02c.857.988.802 2.388-.103 3.175l-6.962 6.091c-.906.788-2.367.63-3.226-.357-.857-.988-.803-2.439.103-3.225l6.962-6.041a2.206 2.206 0 0 1 1.229-.513c.712-.058 1.46.254 1.997.87zm3.99 4.71c.857.988.803 2.387-.103 3.174l-7.012 6.092c-.906.787-2.316.63-3.175-.358-.858-.987-.803-2.438.104-3.224l6.961-6.041a2.07 2.07 0 0 1 1.178-.513c.711-.058 1.51.252 2.047.87zm2.403 3.737a2.37 2.37 0 0 1 1.997.819c.858.988.803 2.439-.102 3.225l-6.963 6.042c-.906.787-2.316.629-3.174-.359s-.854-2.388.051-3.175l7.014-6.091c.338-.296.749-.427 1.177-.461z'/%3e%3c/g%3e%3c/g%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 1792.404 0)'/%3e%3cpath fill='%23b07f55' d='M885.934 206.637c11.458 0 19.517 5.224 30.359 10.033 2.841 1.26 5.45 2.281 7.779 3.071-1.459 1.293-2.594 2.592-2.918 3.687 0 0 4.859.9 7.064 4.967 0 0-4.62.524-5.375 3.224 2.588.195 5.159 3.457 5.171 6.605l-6.553-2.049s1.587 7.358 1.587 15.358c0 4.086-5.886 8.894-5.886 15.819 0 21.734 5.475 30.088 9.369 36.807 1.523 2.629 2.761 5.654 5.324 7.935-11.218-5.973-19.556-13.439-19.556-20.374v-26.262h-2.918v26.262c0 5.029 1.228 7.372 1.228 7.372 1.761 5.564 5.321 14.152 7.526 17.61-10.321-5.578-15.564-12.563-15.564-15.153v-36.092h-2.918v36.603l.563 2.508c-1.251 1.88-2.877 4.106-3.993 4.863-1.113-.756-2.69-2.986-3.943-4.863l.564-2.508v-36.603h-2.918v36.092c0 2.589-5.243 9.575-15.563 15.153 2.205-3.459 5.764-12.046 7.524-17.61 0 0 1.229-2.342 1.229-7.372v-26.262h-2.918v26.262c0 6.927-8.307 14.405-19.505 20.374 2.537-2.283 3.757-5.321 5.272-7.935 4.258-7.348 9.522-16.683 9.522-43.258 0-9.974-1.475-16.755-4.044-21.501-.781-1.566-1.833-5.734 4.146-5.734 3.097 0 10.188 5.478 10.188 5.478s-.292-4.371-3.891-6.86c-.597-.413-1.586-1.712-1.586-2.919 0-.904 1.551-3.135 2.763-3.686.833-.378-12.183-2.646-12.183-8.549 0-1.229.773-2.048 3.479-2.048 3.545 0 9.312 4.249 14.438 4.249 3.789 0 5.283-.922 9.163-.922 4.742 0 14.635 8.979 18.019 8.651-3.783-2.375-9.894-11.365-19.145-11.365-3.211 0-6.117.717-9.114.717-3.841 0-7.623-3.533-11.774-3.533-2.782 0-5.889.155-6.349-.564-.805-1.255-.08-1.983.666-3.02 1.409-1.957 5.366-2.525 9.267-2.661a77.953 77.953 0 0 1 3.433-.05c1.09.011 2.099.053 2.971.053z'/%3e%3cpath fill='%23cc092f' d='M848.73 220.69s2.419-4.581 8.534-4.581c2.556 0 10.992-.177 10.992-.177 1.124 2.921 6.249 7.802 6.249 12.878 0 0-5.202-9.377-19.723-9.377-3.649 0-6.054 1.256-6.054 1.256z'/%3e%3cpath fill='%23d10429' d='M872.34 230.6s-3.093 3.258-3.765 4.997c-3.061-1.16-8.399-6.661-8.399-6.661s4.525 2.642 12.163 1.664z'/%3e%3cpath d='M867.44 221.97s-3.568-1.144-3.568-2.342c0-1.526 1.733-1.526 2.769-.337.713.819.798 2.68.798 2.68z'/%3e%3cellipse cx='882.798' cy='222.06' rx='5.112' ry='4.043'/%3e%3ccircle cx='882.8' cy='222.06' r='3.56' fill='%23f5d402'/%3e%3ccircle cx='882.799' cy='222.06' r='1.511'/%3e%3cpath d='m801.375 591.952 16.201 8.838-3.93 18.029-16.201-8.84z'/%3e%3cpath d='m725.9 418.73-5.836 2.663L786 565.813h7.014zm77.762 170.32-4.76 4.915 2.969 6.553 5.784-2.662z'/%3e%3cpath d='M746.39 532.6s5.554 11.472 9.775 13.045c-2.183-.595-9.271 2.006-9.271 2.006s12.499 11.165 23.1 11.898c8.99.619 13.355-3.868 13.355-3.868l-1.801-9.524s-5.5-6.642-14.302-9.707c-8.894-3.098-20.857-3.848-20.857-3.848zm41.87-20.55s-7.669 6.565-9.768 14.169c-2.1 7.605 1.368 16.247 1.368 16.247l6.444 12.021s8.931-4.753 12.73-11.86c3.799-7.108 2.406-16.698 2.406-16.698s-7.075 2.634-7.975 3.8c1.493-7.884-5.206-17.679-5.206-17.679zm-24.65-3.07s-8.722 2.948-17.192 2.438c-8.068-.487-14.777-7.262-14.777-7.262s6.688-4.526 9.989-3.923c-3.631-1.327-8.896-10.423-8.896-10.423s7.482-2.261 14.116.24c6.634 2.503 12.419 9.77 12.419 9.77l4.342 9.16zm3-42.6s4.362 9.032 3.328 12.171c1.353-2.09 6.474-5.345 6.474-5.345s3.096 14.624.135 23.656c-2.96 9.031-11.974 12.47-11.974 12.47l-9.943-19.337s-1.48-7.164 1.62-12.837c3.101-5.673 10.36-10.779 10.36-10.779zm-56.75-23.91s9.427-.99 18.051 2.583c7.21 2.993 9.42 8.433 9.42 8.433l3.551 9.52s-10.261 3.848-18.368.906c-8.108-2.945-14.065-12.68-14.065-12.68s5.666-2.149 7.823-1.343c-3.142-1.39-6.41-7.419-6.41-7.419v.001zm29.65-17.67s4.137 5.313 4.261 11.424c1.103-3.249 6.268-6.84 6.268-6.84s5.312 12.855 4.146 21.982c-1.166 9.128-8.809 14.527-8.809 14.527l-9.531-18.092s-3.106-7.415-2.191-13.167c.916-5.75 5.856-9.836 5.856-9.836zm-32.65-34.6s-1.709 9.854 1.199 15.53c2.598 5.065 4.252 6.176 4.252 6.176-4.954-3.269-12.444-3.551-12.444-3.551s2.666 10.721 9.037 15.612 16.195 3.748 16.195 3.748 6.46-8.6 6.01-17.865c-.449-9.265-7.808-19.197-7.808-19.197s-2.902 6.02-3.158 10.514c-1.878-4.633-13.285-10.966-13.285-10.966zm77 165.07.265 3.537c5.875.055 6.75-.53 8.256 1.322 1.003 1.234 3.389 2.311 5.787 1.215 2.4-1.095 3.475-3.977 2.38-6.376s-3.326-2.92-5.475-2.496c-1.319.26-2.187 1.313-3.306 1.891-2.128 1.102-7.909.908-7.909.908z'/%3e%3cpath d='m783.35 552.57 2.859 2.095c-3.067 5.014-4.024 5.446-3.251 7.705.515 1.504.166 4.097-2.035 5.553-2.2 1.455-5.214.841-6.669-1.358-1.454-2.2-.715-4.366.783-5.965.92-.982 2.27-1.16 3.353-1.803 2.062-1.223 4.959-6.228 4.959-6.228zm-19.9-42 .264 3.537c5.876.054 6.75-.53 8.256 1.321 1.002 1.233 3.389 2.311 5.787 1.215 2.401-1.095 3.476-3.976 2.379-6.375-1.095-2.4-3.325-2.92-5.474-2.496-1.32.261-2.187 1.313-3.305 1.891-2.129 1.101-7.909.908-7.909.908z'/%3e%3cpath d='m764.64 511.82 2.5 2.517c-3.809 4.474-4.824 4.753-4.411 7.104.276 1.567-.473 4.075-2.874 5.17-2.399 1.095-5.279.021-6.376-2.379-1.095-2.399-.028-4.425 1.701-5.771 1.061-.825 2.425-.793 3.593-1.258 2.227-.887 5.867-5.382 5.867-5.382zm-20.97-43.1.265 3.537c5.876.054 6.75-.53 8.257 1.323 1.003 1.231 3.388 2.309 5.788 1.213 2.398-1.095 3.474-3.975 2.379-6.377-1.097-2.399-3.326-2.919-5.476-2.495-1.32.261-2.187 1.313-3.306 1.891-2.128 1.102-7.908.907-7.908.907z'/%3e%3cpath d='m745.3 467.98 2.499 2.516c-3.809 4.475-4.822 4.754-4.411 7.105.276 1.566-.473 4.074-2.873 5.169-2.399 1.094-5.28.02-6.376-2.379-1.094-2.4-.027-4.426 1.701-5.771 1.061-.827 2.424-.793 3.594-1.26 2.227-.887 5.866-5.38 5.866-5.38zm-22.7-43.44.264 3.536c5.876.055 6.751-.53 8.256 1.321 1.004 1.234 3.39 2.311 5.788 1.217 2.4-1.097 3.475-3.977 2.38-6.377s-3.326-2.921-5.476-2.496c-1.318.261-2.186 1.314-3.305 1.891-2.128 1.101-7.909.908-7.909.908z'/%3e%3cpath d='m724.23 423.8 2.498 2.517c-3.808 4.475-4.823 4.753-4.41 7.105.276 1.566-.474 4.074-2.873 5.169-2.4 1.095-5.28.021-6.375-2.379-1.096-2.399-.028-4.427 1.699-5.771 1.062-.825 2.425-.793 3.594-1.26 2.226-.886 5.866-5.38 5.866-5.38z'/%3e%3cpath fill='%23f5d402' d='m803.71 597.062 10.048 5.482-2.438 11.183-10.049-5.482zm-43.99-96.972c-2.106.874-5.23-8.295-7.524-13.318-2.353-5.155-7.131-13.1-5.774-13.72 1.489-.68 3.451 3.492 5.859 8.767 2.408 5.273 9.412 17.449 7.439 18.269zm-21.63-48.29c-2.105.877-4.41-5.127-6.703-10.151-2.353-5.154-4.645-8.795-3.288-9.415 1.49-.68 3.69 3.837 5.616 8.055 1.866 4.088 6.348 10.69 4.374 11.512zm50.04 109.49c-1.653.442-8.869-14.662-14.703-27.442-5.833-12.779-10.177-23.119-8.82-23.736 1.49-.681 6.213 11.391 12.049 24.172 5.835 12.781 12.713 26.673 11.475 27.006z'/%3e%3cpath fill='%23097754' d='M709.76 396.19s-.255 7.201 2.127 11.285c2.383 4.086 7.704 5.715 7.704 5.715s.254-7.199-2.128-11.283c-2.383-4.086-7.703-5.717-7.703-5.717zm-4.98 16.29s6.255.368 9.868 3.136c3.61 2.768 5.009 8.535 5.009 8.535s-4.146.421-7.756-2.347c-3.611-2.769-7.121-9.324-7.121-9.324zm19.63-14.54s-2.08 4.77-1.84 9.912c.239 5.143 3.24 10.937 3.24 10.937s2.713-6.174 2.474-11.318c-.238-5.143-3.147-8.075-3.874-9.531zm-10.53 46.36s3.071 4.288 7.799 6.626c4.728 2.337 11.773 2.424 11.773 2.424s-3.516-4.562-8.245-6.9c-4.728-2.337-11.327-2.152-11.327-2.152zm1.52 9.96s2.257 4.421 6.384 6.316c4.129 1.896 12.574 1.74 12.574 1.74s-3.24-4.131-7.368-6.027c-4.128-1.897-11.591-2.029-11.591-2.029zm23.77-23.58s-2.495 4.123-2.251 8.666c.245 4.545 3.227 9.511 3.227 9.511s2.097-5.693 1.852-10.237c-.244-4.545-2.829-7.94-2.829-7.94zm9.19 5.83s-4.269 5.73-4.882 11.621c-.613 5.89 2.428 11.942 2.428 11.942s5.157-5.178 5.77-11.068c.613-5.892-3.316-12.493-3.316-12.493zm-11.77 54.4s.513 2.118 2.297 4.367c1.783 2.251 4.836 4.632 4.836 4.632s2.949-.948 6.615-.155c3.665.795 8.54 4.06 8.54 4.06s-5.247-7.831-10.695-10.876c-5.448-3.043-11.591-2.029-11.591-2.029zm-.54 13.46s6.793-2.902 12.387-2.153c5.595.749 10.639 5.171 10.639 5.171s-7.561 2.616-13.155 1.868c-5.596-.749-9.872-4.886-9.872-4.886zm28.71-31.58s-6.007 6.364-6.511 11.887c-.503 5.522 4.871 10.669 4.871 10.669s-.264-3.542.661-5.874c.926-2.332 2.893-4.822 2.893-4.822s.838-2.843.514-5.123c-.453-3.186-2.428-6.737-2.428-6.737zm8.62 7.37s-5.662 5.729-7.158 11.864c-1.497 6.135 1.17 12.676 1.17 12.676s5.149-4.062 6.646-10.196c1.497-6.135-.659-14.344-.659-14.344zm14.18 36.98s2.565 5.355 3.215 9.833c.652 4.477.048 6.027.048 6.027s-2.652 2.607-3.841 4.14c-1.528 1.97-1.752 5.576-1.752 5.576s-5.325-7.916-4.504-13.703c.82-5.786 6.834-11.874 6.834-11.874zm11.22 12.39s-6.818 4.503-9.523 9.123c-2.708 4.617-1.304 9.349-1.304 9.349s4.858-.428 7.566-5.046c2.706-4.618 3.26-13.427 3.26-13.427zm-44.8 19.02s9.826-.268 15.832 1.209c6.006 1.475 8.192 4.695 8.192 4.695s-6.753 3.162-12.759 1.686c-6.006-1.475-11.266-7.591-11.266-7.591zm-1.66-11.66s4.433 6.873 10.164 9.367c7.898 3.435 17.043 1.77 17.043 1.77s-4.968-6.089-11.804-8.777c-6.838-2.687-15.403-2.359-15.403-2.359z'/%3e%3cpath d='m1088.74 401.944 1.281 2.712s-2.08.714-3.022 2.559c-.94 1.847.615 4.455.615 4.455s-10.804-.943-12.491.154c-1.528.99.647 8.474-.359 14.795-1.402 8.81-4.875 8.07-5.017 9.777-.138 1.659 1.331 4.249 1.331 4.249s-2.026.638-2.458 1.485c-.695 1.362.484 3.875-.358 5.528-4.7 9.223-11.64 22.836-16.228 31.843-.641 1.257-2.363 1.737-3.226 3.43-.796 1.562-.153 3.839-.153 3.839s-3.041.182-4.096 2.253c-1.121 2.2-.461 5.17-.461 5.17s-1.923.246-2.868 2.099c-1.009 1.981.7 3.02.259 3.891-6.169 12.102-13.434 26.368-17.867 35.068-1.631 3.199-7.338 3.84-10.65 10.341-3.214 6.306 1.382 10.955 1.382 10.955s-4.772.432-6.04 2.919c-1.292 2.535-.27 6.384 3.174 8.139 3.444 1.754 7.207.334 8.5-2.201 1.267-2.487-1.281-6.604-1.281-6.604s6.463.931 9.675-5.376c3.313-6.501.52-11.441 2.15-14.641 4.434-8.7 11.7-22.965 17.867-35.068.445-.871 2.267-.117 3.276-2.098.944-1.853 0-3.532 0-3.532s2.822-1.23 3.943-3.431c1.056-2.071-.563-4.658-.563-4.658s2.223-.792 3.02-2.354c.862-1.693.228-3.35.869-4.609 4.59-9.006 11.531-22.62 16.229-31.841.843-1.655 3.555-2.221 4.249-3.585.432-.846-.255-2.866-.255-2.866s2.988-.296 4.248-1.383c1.298-1.118-1.337-3.516 4.967-9.829 4.522-4.528 11.817-7.192 11.722-9.01-.105-2.01-7.218-10.187-7.218-10.187s3.001-.253 3.942-2.098c.941-1.846.308-3.994.308-3.994l2.968-.512V393.65zm-98.136 196.074a3.498 3.498 0 0 0 0 3.121s-3.583-1.12-4.812-.512c-1.158.573 0 17.458 0 17.458s14.295-9.018 14.077-10.29c-.23-1.352-3.225-3.635-3.225-3.635 1.158-.186 2.061-.912 2.509-1.791.47-.925.533-3.568-2.714-5.223-1.216-.62-2.299-.804-3.175-.716-1.455.147-2.365 1.01-2.66 1.588z'/%3e%3cg fill='%23f5d402'%3e%3cpath d='m1091.34 402.51 6.757 3.431-.101-8.14zm-2.61 4.915c-.868 1.704-.025 3.886 1.894 4.863 1.92.977 4.148.373 5.018-1.33.868-1.704.023-3.885-1.895-4.863a4.2 4.2 0 0 0-2.201-.462c-1.208.083-2.273.727-2.816 1.792zm-11.62 6.195c-.711.46.256 6.545.051 11.722-.194 4.882-1.756 6.257-2.611 7.935-.789 1.549-3.634 3.379-3.634 3.379l2.354 2.355s1.532-2.386 3.942-7.118c2.843-5.579 2.751-15.688 3.585-16.227.725-.469 6.655-1.946 6.655-1.946-.001 0-5.442-.294-8.447-.255-1.003.013-1.73.048-1.895.155z'/%3e%3cpath d='M1077.73 441.725s.787-2.188 3.533-7.577c3.311-6.499 10.379-11.213 10.544-12.389.172-1.212-2.457-6.91-2.457-6.91s-6.235 1.195-7.117 2.048c-.852.823-.476 9.267-3.788 15.767-2.744 5.388-4.094 7.372-4.094 7.372z'/%3e%3cpath d='M1093.65 422.22c.052.989-8.163 6.861-11.007 12.439-2.41 4.731-3.43 7.373-3.43 7.373l3.277.512s-.226-3.367.563-4.915c.854-1.677 1.079-3.731 4.915-6.757 4.068-3.209 9.567-6.014 9.522-6.861-.041-.782-6.144-8.344-6.144-8.344s2.257 5.692 2.304 6.553zm-24.06 36.5c4.936-9.688 6.444-10.348 7.065-11.569.669-1.312.509-3.078-1.689-4.199-.824-.419-1.531-.526-2.15-.459-1.033.111-1.784.767-2.201 1.586-.622 1.222-.285 2.855-5.223 12.544l-11.212 21.961s-1.175 2.156 1.024 3.276c2.199 1.119 3.174-1.127 3.174-1.127zm-19.81 25.188c-.611 1.201.436 2.964 2.355 3.943 1.919.976 3.996.791 4.607-.41.611-1.2-.486-2.964-2.406-3.943-.959-.489-1.935-.687-2.764-.613-.83.072-1.486.424-1.792 1.023zm-4.15 6.245c-.792 1.553.443 3.783 2.765 4.968 2.322 1.183 4.84.886 5.631-.667.792-1.554-.444-3.782-2.765-4.967-.871-.442-1.733-.677-2.56-.716-1.374-.065-2.576.411-3.071 1.382zm-2.61 6.964c-.611 1.199.437 2.963 2.355 3.941 1.919.978 3.995.791 4.608-.409.611-1.2-.437-2.964-2.355-3.942-.96-.49-1.986-.688-2.816-.615-.828.073-1.485.424-1.792 1.025zm-1.69 6.655s-12.448 24.5-16.84 33.121c-1.404 2.754-7.312 4.47-9.625 9.011-2.33 4.568-.686 8.844 2.354 10.392 3.039 1.549 7.502.423 9.83-4.146 2.313-4.54.235-10.353 1.637-13.106 4.393-8.624 16.843-33.122 16.843-33.122s1.226-2.156-.973-3.276a2.372 2.372 0 0 0-1.433-.255c-1.212.155-1.793 1.381-1.793 1.381zm-31.49 56.874c-.933 1.83.134 4.269 2.405 5.426 2.272 1.158 4.904.601 5.837-1.228.933-1.83-.186-4.27-2.457-5.427-.852-.435-1.721-.637-2.56-.614-1.399.04-2.643.7-3.225 1.843zm-16.583 37.423c-.71.024-1.298.249-1.535.717-.477.935.508 2.413 2.201 3.276 1.693.862 3.464.782 3.942-.154.477-.937-.51-2.414-2.201-3.276-.847-.432-1.695-.588-2.407-.564zm-5.836 4.606v12.082l9.83-7.065s-1.333-2.354-4.25-3.84c-2.917-1.485-5.58-1.178-5.58-1.178z'/%3e%3c/g%3e%3cpath fill='%23f5d402' d='M993.643 333.597c0-6.626 8.703-13.157 8.703-13.157H790.1s8.703 6.53 8.703 13.157v157.986c0 4.162 1.286 6.872 3.328 9.521 2.041 2.853 6.39 6.795 10.903 9.727 13.94 9.053 37.246 18.599 54.88 26.621 14.694 6.684 20.671 9.381 28.309 18.839 7.639-9.458 13.667-12.154 28.361-18.839 17.631-8.021 40.938-17.568 54.879-26.621 4.515-2.932 8.864-6.873 10.904-9.727 2.042-2.649 3.276-5.359 3.276-9.521z'/%3e%3cpath fill='%23d10429' d='M803.82 422.981v-89.385c0-5.059-2.56-8.139-2.56-8.139h189.928s-2.56 3.081-2.56 8.139l.054 89.385-92.431 28z'/%3e%3cpath fill='%230b45bb' d='m988.681 422.981-57.234-1.075h-70.393l-57.234 1.075v68.601c0 3.448 3.578 11.525 24.215 21.807 34.111 16.998 60.33 24.934 68.189 34.607 7.858-9.673 34.077-17.61 68.189-34.607 20.636-10.282 24.214-18.359 24.214-21.807z'/%3e%3cpath d='M930.063 419.401s33.019-8.326 33.019-43.617c0-27.563-33.103-41.237-34.044-47.814-3.235 11.381 11.058 27.1 11.058 45.715 0 24.086-17.764 25.239-17.764 25.239-4.157 0-5.841 2.968-7.475 2.968-3.497-.365-5.143-4.813-8.601-4.813-3.247 0-5.74 5.017-10.033 5.017-4.292 0-6.735-5.017-9.983-5.017-3.456 0-5.103 4.448-8.6 4.813-1.634 0-3.319-2.968-7.476-2.968 0 0-17.763-1.153-17.763-25.239 0-18.615 14.295-34.336 11.058-45.715-.938 6.577-34.041 20.25-34.041 47.814 0 35.291 33.019 43.617 33.019 43.617l-9.42 17.149s13.645.683 20.887 6.861c8.733 7.448 7.883 23.229 7.883 34.709 0 9.045-1.143 18.59-5.784 22.524-6.232 5.284-10.445 5.675-10.445 11.878 0 5.174 3.977 6.211 10.445 9.625 8.287 4.373 7.901 10.238 20.22 10.238 12.321 0 11.985-5.864 20.273-10.238 6.468-3.414 10.444-4.451 10.444-9.625 0-6.203-4.214-6.594-10.444-11.878-4.641-3.936-5.784-13.48-5.784-22.524 0-11.48-.849-27.261 7.883-34.709 7.243-6.177 20.886-6.861 20.887-6.861z'/%3e%3cpath d='m896.22 330.42-5.735 16.281-15.614-7.424 7.423 15.615-16.279 5.784 16.279 5.785-7.423 15.563 15.614-7.423 5.735 16.279 5.785-16.279 15.614 7.423-7.422-15.563 16.279-5.785-16.279-5.784 7.422-15.615-15.614 7.424-5.785-16.281zm-35.17 91.49s-20.387-4.984-28.002-15.051c-13.313 11.976-29.232 16.126-29.232 16.126s16.607 7.498 29.232 17.048c5.817-8.336 28.002-18.123 28.002-18.123zm70.39 0s22.186 9.786 28.004 18.123c12.623-9.55 29.229-17.048 29.229-17.048s-15.917-4.151-29.229-16.126c-7.615 10.066-28.004 15.051-28.004 15.051zm-62.04 21.7-7.935 7.934 7.935 7.935 7.935-7.935-7.935-7.934zm53.7 0-7.934 7.934 7.934 7.935 7.935-7.935-7.935-7.934zm-55.697 46.33c0 10.025-.972 15.307-.972 15.307s11.186-3.293 13.414-14.641c1.044-5.32 2.207-24.918-3.175-28.259l-14.59-2.867c1.576 3.899 5.323 15.977 5.323 30.46zm48.426-27.592c-5.381 3.34-4.218 22.938-3.174 28.259 2.227 11.348 13.413 14.641 13.413 14.641s-.972-5.282-.972-15.307c0-14.483 3.747-26.562 5.324-30.46zm-82.824.567c-5.031 1.262-8.071 6.385-6.808 11.416.193.77.511 1.481.87 2.15a9.254 9.254 0 0 0-2.304-.461 9.55 9.55 0 0 0-.972 0c-4.761.16-8.73 3.903-9.061 8.755-.354 5.174 3.579 9.629 8.755 9.983a9.393 9.393 0 0 0 2.251-.103 9.217 9.217 0 0 0-1.125 1.996c-1.937 4.813.409 10.351 5.222 12.288 4.812 1.935 10.298-.461 12.234-5.273a9.067 9.067 0 0 0 .564-2.202 9.277 9.277 0 0 0 1.586 1.689c3.979 3.328 9.931 2.801 13.259-1.177a9.364 9.364 0 0 0-1.178-13.208c-.602-.504-1.27-.9-1.945-1.228a9.316 9.316 0 0 0 2.098-.972c4.395-2.755 5.725-8.609 2.969-13.004-1.894-3.021-5.222-4.574-8.549-4.351a9.465 9.465 0 0 0-4.403 1.434 9.33 9.33 0 0 0-1.791 1.433 9.436 9.436 0 0 0-.256-2.303c-1.104-4.403-5.151-7.305-9.522-7.117a9.522 9.522 0 0 0-1.894.255zm99.82 27.335c1.017 9.587 8.808 17.619 18.429 19.914-1.643-2.687-2.735-5.682-3.072-8.856-1.205-11.37 7.588-20.581 19.607-20.581 1.894 0 3.729.234 5.528.667-4.237-6.947-12.215-11.775-20.887-11.775-12.018.001-20.813 9.263-19.605 20.631z'/%3e%3cg fill='%23ffd200'%3e%3cpath d='M847.592 373.684c0 18.128 9.667 28.821 22.576 28.821 2.462 0 5.155 3.328 7.475 3.328 3.782 0 6.298-4.198 8.601-4.198 2.927 0 4.9 4.607 9.982 4.607 5.083 0 7.107-4.607 10.034-4.607 2.302 0 4.818 4.198 8.6 4.198 2.321 0 5.012-3.328 7.475-3.328 12.909 0 22.577-10.693 22.577-28.821 0-14.784-12.416-32.81-11.058-35.734 0 0 24.214 17.369 24.214 37.832 0 32.963-33.429 41.109-33.429 41.109l7.525 16.944s-10.362 1.554-16.689 6.656c-8.439 6.805-8.55 25.191-8.55 37.626 0 14.648.545 20.855 5.837 24.829 5.58 4.193 9.777 5.096 9.777 9.369 0 3.723-4.345 5.246-9.983 7.73-6.413 2.827-7.052 7.731-16.33 7.731-9.279 0-9.867-4.904-16.28-7.731-5.637-2.484-9.983-4.006-9.983-7.73 0-4.273 4.197-5.176 9.777-9.369 5.292-3.974 5.836-10.181 5.836-24.829 0-12.435-.11-30.821-8.549-37.626-6.328-5.104-16.689-6.656-16.689-6.656l7.524-16.944s-33.428-8.145-33.428-41.109c0-20.463 24.215-37.832 24.215-37.832 1.358 2.924-11.057 20.95-11.057 35.734zM883.58 509.81c-6.567 0-10.75 1.386-10.75 3.379 0 1.994 4.184 3.328 10.75 3.328 1.75 0 3.737-1.019 3.737-3.328s-1.988-3.379-3.737-3.379zm25.34 0c-1.75 0-3.737 1.071-3.737 3.379-.001 2.309 1.987 3.328 3.737 3.328 6.568 0 10.75-1.333 10.75-3.328 0-1.994-4.183-3.379-10.75-3.379z'/%3e%3cpath d='m896.28 341.38 3.686 10.394 9.931-4.761-4.71 9.982 10.342 3.687-10.342 3.686 4.71 9.931-9.931-4.71-3.737 10.341-3.686-10.341-9.931 4.71 4.71-9.931-10.341-3.686 10.341-3.687-4.71-9.982 9.931 4.761 3.737-10.394zm-46.133 81.148c-.002 0-17.099 12.696-17.099 12.696l-.206.255-.358-.307-18.941-11.877s12.087-4.167 19.198-11.415c6.728 7.703 17.406 10.648 17.406 10.648zm128.801.767s-12.609 6.28-18.943 11.877l-.357.307-.204-.255c-5.986-6.871-17.098-12.696-17.098-12.696s10.676-2.945 17.405-10.648c7.111 7.248 19.197 11.415 19.197 11.415zM869.4 447.4l4.147 4.145-4.147 4.199-4.198-4.199 4.198-4.145zm53.7 0 4.199 4.145-4.199 4.199-4.146-4.199 4.146-4.145zm-48.067 18.119c2.897 3.998 2.405 10.462 2.405 19.455 0 9.067-6.808 12.541-6.808 12.541 0-21.794-2.247-27.034-3.43-33.635zm50.267-1.639c-1.185 6.602-3.429 11.841-3.429 33.634 0 0-6.809-3.474-6.809-12.541 0-8.993-.492-15.455 2.406-19.454l7.832-1.639z'/%3e%3cpath id='b' d='M842.832 472.128c.204.816.226 1.618.153 2.407-.06.654-.234 1.248-.46 1.842-1.133-.414-2.359-.615-3.635-.615-3.159 0-5.987 1.39-7.935 3.585a7.308 7.308 0 0 1-1.33-1.536c-.42-.649-.775-1.359-.973-2.15-.982-3.913 1.411-7.876 5.324-8.857.488-.124 1-.185 1.484-.204a7.29 7.29 0 0 1 7.372 5.528z'/%3e%3cuse xlink:href='%23b' transform='rotate(72 838.89 486.468)'/%3e%3cuse xlink:href='%23b' transform='rotate(144 838.89 486.468)'/%3e%3cuse xlink:href='%23b' transform='rotate(216 838.89 486.468)'/%3e%3cuse xlink:href='%23b' transform='rotate(288 838.89 486.468)'/%3e%3ccircle cx='838.89' cy='486.468' r='7.065'/%3e%3cpath d='M962.925 476.942c-11.729 2.268-20.17 12.628-18.942 24.727-3.738-3.096-6.473-7.266-6.962-11.877-.951-8.979 5.571-15.922 15.41-15.922 3.761 0 7.375 1.152 10.494 3.072z'/%3e%3c/g%3e%3c/svg%3e";
            },
            6249: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 640 320'%3e%3cpath fill='%23d3ae3b' d='M0 0h640v320H0z'/%3e%3cpath fill='%23c40308' d='M16 16h608v288H16z'/%3e%3cpath fill='%23B96B29' d='M389.64 157.4c1.87-.53 8.39-2.43 12.98-6.16 4.6-3.72 5.49-6.7 5.86-8.32.37-1.61.53-2.88-.66-1.96-1.19.93-4.75 3.73-7.18 5.08a26.85 26.85 0 0 1-5.99 2.35c-1.32.37-2.37.6-1.1.1 1.26-.5 5.4-1.95 8.6-5.15 3.19-3.2 5.71-7.99 5.76-10.93.06-2.94-.15-2.73-1.1-2-.94.74-4.3 4.9-6.2 6.47a60.01 60.01 0 0 1-6.46 4.57c-1.52.9-3.67 1.89-.68-.16 3-2.05 8.67-6.88 10.98-13.13 2.31-6.25 1.89-9.93 1.84-10.56-.06-.63-.58-1.9-1.1-.73-.53 1.15-4.32 8.72-7.36 11.97-3.05 3.26-2.31 2.63-3 3.15-.68.53-1.83 1.47-.36-.37 1.47-1.83 4.52-6.09 6.1-10.29 1.57-4.2 1.99-8.4 2.04-10.82.05-2.42-1-5.78-1.47-6.78s-.95-1.73-1.1-.58c-.16 1.16-2.58 8.62-3.9 12.24a47.14 47.14 0 0 1-4.46 8.51c-.52.8-1.89 2.42-.42-.31s4.31-10.77 4.68-18.39c.37-7.61-.68-11.81-1.74-13.92-1.05-2.1-1.96-2.84-1.96-2.84s.18 5.2-1.37 12.67-3.82 11.41-3.82 11.41-.95 1.08-.3-.71a31.8 31.8 0 0 0 1.77-8.36c.44-4.72.5-10.1-.88-14.66-1.5-4.98-4.1-7.52-4.1-7.52-.73 7.14-.59 16.34-3.2 23.8-.5-.44-1.14-1.25-1.4.4a42.09 42.09 0 0 1-4.66 12.9c-3.22 5.87-4.53 6.64-4.53 6.64s-.6-1.43-1.02-2.2c-.41-.78-.65-1.2-1.19-.13-.54 1.08-2.33 5.2-6.27 9.74-3.93 4.55-6.14 6.76-6.02 10.16.12 3.41 1.9 5.14 4.3 6.7 2.38 1.55 2.8 2.39 2.44 4.24-.36 1.85-2.5 2.51-4.35 2.57-1.86.06-4.18-.12-5.02.36-.83.48-.9 1.67-1.73 2.5-.83.84-1.2 1.32-1.97 1.44l-.67.09c-.17-8.99 3.31-13 3.31-13l-9.73-11.42-1.5.7a2.72 2.72 0 0 0-.29-.44 7.46 7.46 0 0 1-1.72-5.18c.48.05 1.46.4 2.34.22.88-.17.22-1.06-.05-1.9-.26-.84-.53-3.76-.35-4.86l.26-1.55s1.42 1.55 2.3 1.55c.88 0 .8-.89.92-1.86.2-1.47.9-3.32 2.03-4.34 0 0 1.55 1.07 3.31 1.07a8.7 8.7 0 0 0 6.04-2.3c1.9-1.82 1.85-2.26 1.85-2.26s3.53 1.24 6.22 1.37c2.7.14 5.56-.3 6.93-3.14 1.36-2.83-.4-5.44-.7-5.88-.32-.44-1.2-.8-1.2 0s.05 2.92-1.59 3.98c-1.63 1.06-2.9 1.02-4.45.53a13.68 13.68 0 0 0-8.73-.23c.12-.11 2.13-2.18 4.1-2.78 2.03-.62 3.22.22 3.88 1.02s1.23 2.08 1.76.22a6.9 6.9 0 0 0-.66-5.35 5.05 5.05 0 0 0-4.76-2.04c-1.98.23-2.69.53-2.69.53s-1.01-2.87-3.57-3.4c-3.12-.65-6.56.52-9.26 2.03 0 0-2.12.5-4.28-.13a13.96 13.96 0 0 1-3.64-1.81l.73-2.35 1.27-.43c.64-.25.5-.46.59-1 .08-.54-1.22-1.48-1.22-1.48s-.18-1.61 1.94-2.72c2.13-1.11 1.9-.93 1.9-.93s1.25.24 1.76-.13c.5-.37.5-.6.5-.6s.94-.31 1.3-.88c.34-.57.4-1.39.15-2.05-.25-.66-.57-.8-.22-1.1.34-.32.66-1.08.69-1.61l.03-.67s.72-.25.7-1.35c-.04-1.1-.64-1.55-.99-1.65-.34-.09-.56-.09-.56-.09s-.06-.66-.63-1.54c-.57-.89-.94-1.27-.94-1.27s.4-.31.19-1.04a1.94 1.94 0 0 0-1.23-1.32c-.5-.16-1.04 0-1.04 0s-1.67-1.01-2.45-1.42l-.98-.5s-.03-.7-.31-1.08-.95-.54-1.3-.54-.71.2-.71.2-2.84-.73-4-.92c-1.16-.2-1.23-.29-1.23-.29s-2.51-1.2-3.49-1.38c-.97-.2-1.25-.29-1.25-.29s1.01-1.23 1.08-2.65a3.95 3.95 0 0 0-1.89-3.36c-.57-.33-.87-.39-1.06-.5l-.02-.98 1.9.19.15-3.04-1.84.23.28-1.83-3.86-.05.29 1.83-1.86-.12.16 3 1.95-.26-.19 1.14s-.71.12-1.32.56c-1 .6-1.86 1.77-1.8 3.2.07 1.41.92 2.67.92 2.67s-.25.07-1.23.25c-.97.2-3.49 1.4-3.49 1.4s-.06.09-1.23.28c-1.16.19-4 .91-4 .91s-.37-.19-.72-.19c-.34 0-1 .16-1.28.54-.29.38-.32 1.07-.32 1.07l-.97.5c-.8.42-2.46 1.43-2.46 1.43s-.53-.16-1.04 0c-.5.16-1 .6-1.22 1.32s.19 1.04.19 1.04-.38.38-.95 1.26c-.56.89-.63 1.55-.63 1.55s-.22 0-.56.1c-.35.09-.95.53-.98 1.64-.03 1.1.7 1.35.7 1.35l.03.66c.03.54.34 1.3.69 1.61.34.32.03.44-.22 1.1-.25.67-.2 1.49.15 2.06.35.56 1.3.87 1.3.87s0 .23.5.6 1.76.14 1.76.14-.23-.18 1.9.93c2.12 1.1 1.93 2.72 1.93 2.72s-1.3.94-1.21 1.48c.08.54-.06.75.59 1 .65.24 1.26.43 1.26.43l.73 2.35c-.8.54-2.22 1.4-3.63 1.81-2.16.62-4.28.13-4.28.13-2.7-1.5-6.14-2.68-9.26-2.03-2.56.53-3.58 3.4-3.58 3.4s-.7-.3-2.68-.53a5.06 5.06 0 0 0-4.77 2.04 6.9 6.9 0 0 0-.66 5.35c.53 1.86 1.1.57 1.76-.22.67-.8 1.86-1.64 3.89-1.02 1.97.6 3.98 2.66 4.1 2.78a13.68 13.68 0 0 0-8.73.23 4.67 4.67 0 0 1-4.46-.53c-1.63-1.06-1.59-3.19-1.59-3.98s-.88-.44-1.19 0-2.07 3.05-.7 5.88c1.36 2.83 4.23 3.27 6.92 3.14 2.7-.13 6.22-1.37 6.22-1.37s-.04.44 1.85 2.26c1.9 1.8 4.28 2.3 6.04 2.3s3.31-1.07 3.31-1.07c1.14 1.02 1.83 2.87 2.03 4.34.13.97.04 1.86.93 1.86.88 0 2.29-1.55 2.29-1.55s.09.44.26 1.55c.18 1.1-.08 4.02-.35 4.86-.26.84-.93 1.73-.04 1.9.88.18 1.85-.17 2.33-.22 0 2.12-.42 3.52-1.72 5.18l-.27.4c-.48-.2-.96-.43-1.44-.67l-9.73 11.44s3.5 4.02 3.3 13.06v-.07c-.17-.01-.4-.04-.7-.09-.78-.12-1.14-.6-1.97-1.43-.84-.84-.9-2.03-1.73-2.51s-3.17-.3-5.02-.36c-1.85-.06-4-.72-4.35-2.57-.36-1.85.06-2.69 2.44-4.24 2.4-1.56 4.18-3.29 4.3-6.7.12-3.4-2.09-5.61-6.03-10.16-3.94-4.54-5.73-8.66-6.26-9.74s-.78-.65-1.2.12c-.41.78-1.01 2.21-1.01 2.21s-1.31-.77-4.54-6.63a42 42 0 0 1-4.65-12.91c-.26-1.65-.9-.84-1.4-.4-2.62-7.46-2.47-16.66-3.2-23.8 0 0-2.6 2.54-4.1 7.52-1.38 4.57-1.33 9.94-.89 14.66.42 4.5 1.33 7.15 1.77 8.36.66 1.79-.3.71-.3.71s-2.26-3.94-3.81-11.41c-1.56-7.47-1.38-12.67-1.38-12.67s-.9.74-1.96 2.84c-1.05 2.1-2.1 6.3-1.73 13.92.37 7.62 3.2 15.66 4.68 18.39 1.47 2.73.1 1.1-.43.31a47.3 47.3 0 0 1-4.46-8.5c-1.31-3.63-3.73-11.09-3.89-12.25-.16-1.15-.63-.42-1.1.58-.47 1-1.52 4.36-1.47 6.78a34.3 34.3 0 0 0 2.05 10.82c1.57 4.2 4.62 8.46 6.09 10.3 1.47 1.83.31.89-.37.36s.05.1-3-3.15-6.82-10.82-7.35-11.97c-.52-1.16-1.05.1-1.1.73-.05.63-.47 4.3 1.84 10.56 2.31 6.25 7.98 11.08 10.98 13.13 3 2.05.84 1.05-.69.16-1.52-.9-4.57-3-6.46-4.57-1.89-1.58-5.25-5.73-6.2-6.46-.94-.74-1.15-.95-1.1 2s2.58 7.72 5.77 10.92c3.2 3.2 7.33 4.65 8.6 5.15 1.27.5.21.27-1.1-.1a26.8 26.8 0 0 1-6-2.35c-2.42-1.35-5.98-4.15-7.17-5.08-1.19-.92-1.03.35-.66 1.96.37 1.61 1.26 4.6 5.85 8.32 4.6 3.73 11.11 5.63 12.99 6.16 1.87.53.55.53.55.53s-.74-.1-4.54-.95-9.55-3.86-11.1-4.84c-1.56-.98-1.8-1.35-1.59.71.21 2.06 2.4 6.48 5.91 8.54s9.84 3.12 11.48 3.2c1.63.08 1.21.31.47.37-.74.05-2.56.05-5.54-.3-2.44-.28-6.07-1.46-7.3-1.88-.14-.53-.27-1.04-.33-1.35-.14-.79-.55-.67-.8-.5-.27.18-.42.32-1.28.76-.88.44-.9-.09-.93-.35-.03-.26-.2-1.4-.24-1.98-.03-.58-.35-.61-.75-.44l-3.08 1.32c-.72.32-.06.9.32 1.6.38.7.96 1.71.96 1.71l-2.41.65c-.58.14-.4.55-.26.96.14.4 1.04 2.44 1.28 3.02s.75.24.75.24l1.83-1.08.64 2.44c-.03.04-.85.2-1.77.85-.93.65-.7 1.48.41 1.8 1.11.33 2.4.89 3.84 3.48 1.43 2.6 1.8 7.28 2.68 14.65.88 7.36 5.59 11.12 6.24 11.58s.27.84.27.84-.64.93-.37 2.36a3.55 3.55 0 0 0 2.17 2.5c.65.24.47.89.47.89s-.33 1.57 0 4.45c.32 2.87 2.68 6.11 3.32 6.67.65.55.7.83.6 1.07-.09.23-.5.04-1.29.64a8.15 8.15 0 0 0-2.22 2.46c-.55 1.02-.37 1.62-.18 3.01.18 1.4 2.22 2.65 2.22 2.65s-.37.09-.47 1.1c-.09 1.03.65 2.19 1.58 2.93.92.74 2.68 1.1 2.68 1.1l.23 1.5c.09.6 1.24 1.2 1.98 1.61.74.42 2.17.19 2.78-.09.6-.28 1.01.05 1.38.65.37.6.23 2.92.23 3.85 0 .92-.55 1.9-.23 2.36.32.46 1.2.14 2.08-.37.88-.51 1.11-.14 1.9.37a6 6 0 0 0 2.35.93c.33-.05.19-.88.19-1.58s.12-2.27.45-2.5c.15-.1 1.5-.21 2.55-.65.49-.2 1.11-.42 1.16-.88.04-.46-.65-.46-2.18-1.25-1.52-.79-1.8-1.25-2.77-1.9-.97-.65-.5-.88-.5-1.16 0-.28.46-.6.64-.97s.1-1.2.1-1.2.78-.8 1.15-1.21c.37-.42.83-1.07 1.34-1.49s1.3-2.4 1.8-3.06c.5-.64 1.66-1.34 2.36-2.22.69-.88 2.54-2.32 3.6-3.01 1.06-.7 3.93-2.04 3.93-2.04s-.05 1.71.7 2.55c.73.83 1.7-.65 4.98-2.97 3.28-2.32 5.78-3.15 5.78-3.15s.69 1.06 1.57 2.18c.87 1.1 1.66-.05 5.68-5.61a72.84 72.84 0 0 1 8.97-9.9l.9.4c-.09.22-.17.46-.25.72-.37 1.16-.97 1.9-1.75 3.5-.79 1.62-1.98 1.98-3.36 4.15-1.39 2.16-1.57 3.64-1.7 5.85-.15 2.2 1.1 2.67 1.1 2.67s-2.03 1.98-2.63 3.45c-.6 1.47-.92 4.47-.92 4.47s-.32.13-1.06 1.65c-.74 1.53-2.07 1.75-4 3.69-1.94 1.93-4.1 2.76-5.12 3.36-1 .6-.73 1.2-.46 1.98.28.78 1.66 1.56 3.27 2.16 1.62.6 2.17.37 3.27.32 1.1-.04.23.83-.23 1.3-.46.45-1.06 2.06-.96 3.86.09 1.8 1.42 1.38 3.08 1.1 1.66-.27 3.6-1.1 3.6-1.1l-.19.5c-.18.51-.28.88-.28 2.31 0 1.43.23 2.12.65 2.49.41.36 1.24-.42 1.84-.6.6-.19 1.61-.78 3.09-1.1 1.47-.33 2.02-.97 2.02-.97s-.37.46-.46 1.47c-.1 1.01-.05 2.53.19 3.4.22.88.87 1.94 1.88 2.86 1.02.92 1.25.5 1.98-.64.74-1.15 2.26-2.63 2.26-2.63s.09.37 1.1 3.64c1.02 3.27 4.33 5.99 4.33 5.99s3.32-2.72 4.33-6c1.01-3.26 1.1-3.63 1.1-3.63s1.52 1.48 2.26 2.63c.74 1.15.97 1.56 1.98.64a6.29 6.29 0 0 0 1.89-2.85c.23-.88.27-2.4.18-3.41-.09-1.01-.46-1.47-.46-1.47s.55.64 2.03.96c1.47.33 2.48.92 3.08 1.1.6.2 1.43.97 1.84.6.42-.36.65-1.05.65-2.48s-.1-1.8-.28-2.3l-.18-.51s1.93.83 3.6 1.1 2.98.7 3.08-1.1c.09-1.8-.51-3.4-.97-3.87-.46-.46-1.34-1.33-.23-1.29 1.1.05 1.66.28 3.27-.32 1.6-.6 3-1.38 3.27-2.16.27-.78.55-1.38-.46-1.98-1.02-.6-3.18-1.43-5.11-3.36-1.94-1.94-3.27-2.16-4.01-3.69-.74-1.52-1.06-1.65-1.06-1.65s-.32-3-.92-4.47c-.6-1.47-2.62-3.45-2.62-3.45s1.24-.46 1.1-2.67c-.14-2.21-.32-3.69-1.7-5.85-1.38-2.17-2.58-2.53-3.37-4.15-.78-1.6-1.38-2.34-1.74-3.5a21.1 21.1 0 0 0-.24-.7l1.19-.51a72.7 72.7 0 0 1 8.99 9.9c4.02 5.57 4.8 6.73 5.68 5.62.88-1.11 1.57-2.18 1.57-2.18s2.5.83 5.78 3.15c3.28 2.32 4.25 3.8 4.99 2.97.39-.44.47-1.17.52-1.73a69.7 69.7 0 0 1 7.84 2.78c2.85 1.2 3.16 1.83 5.42 3.61s5.48 1.62 8.53.69c3.04-.93 11.16-3.6 14.42-5.02 3.25-1.4 5.58-2.64 5.92-3.3.34-.65.72-2.47.72-3.12 0-.65-.72-1.62-.96-1.79-.24-.17-.13-.69-.07-1.1a3.45 3.45 0 0 0-.65-2.2c-.5-.55-.44-.75-.37-2.33.14-3.36-2.25-7.58-5.64-8.93 0 0-.09-.39-.36-.62-.28-.22-.73-.43-.73-.43s.06-1.93.04-2.34c-.02-.41.16-.37.4-.25.22.11.58.57 1.13.7.55.15.9-.25 1.01-.86.11-.62.57-1.86.78-2.48.2-.62-.05-.71-.3-.78-.25-.07-1.07-.16-1.46-.25-.4-.1-.4-.12-.3-.32.1-.21.23-.53.73-1.31s.05-.8-.44-.96c-.48-.17-2.65-.83-3.24-.92-.6-.1-.73.4-.73.66s.02 1.36.04 1.77-.36.3-.6.18a8.45 8.45 0 0 1-1.16-.76c-.41-.32-.7-.02-.87.44-.16.46-.66 2.34-.82 2.9-.16.54-.12.98.11 1.07.23.1 1.3 0 1.95 0 .64 0 .27.37.27.37s-.69 1.12-.91 1.56c-.23.43-.62.5-1.15.5h-1.4s-3.52.13-6.1 2.05c-2.6 1.92-3.32 3.52-3.72 4.44-.4.93-.86.73-1.26 1.06-.4.34-1.52 1.53-1.52 2.26 0 .73.26 1.13-.87 1.86-1.12.73-2.05 3.9-.53 5.57 1.53 1.65 2.13 3.3 2.6 4.1.45.8 0 1.13-.4 1.13s-1.24-.67-1.93-1.2c-.7-.5-4.2-3.24-5.7-4.37-1.5-1.12-.4-1-.4-1s.38.04 1.26-.33 1.02-.83.14-1.1a11.14 11.14 0 0 1-3.05-1.72c-.46-.47-.7-.98.19-1.44.87-.46 2.81-1.71 1.29-2.13-1.53-.42-3.33-.74-4.8-1.16-1.49-.42-1.63-.83-1.63-.83l.98-1.4s.78-1.1-.14-1.25-3.14-.41-5.18-1.3c-4.06-1.75-6.6-4.74-7.55-8.38l.07-.09c.76 1.5 2.53 4.3 5.19 4.4 3.64.12 4.06-1.02 3.22-2.22s-1.79-2.27-2.03-2.62c-.24-.36-.3-.84.66.06s2.77 3.94 8.26 3.58c5.5-.36 5.46-1.43 5.46-1.73 0-1.06-1.11-1.22-1.77-1.88-.35-.35-.56-.85.55-.43s3.83.93 7.52.13c1.46-.3 5.33-2 5.7-3.96 0 0-2.45-.13-4.17-.87-1.71-.74-2.74-1.35-.92-.98 1.82.37 5.36 1.11 8.47.06 1.82-.62 4.17-2.1 4.17-4.79 0 0-3.38-.71-4.62-1.16-1.24-.45-1.64-.8-1.64-.8s4.83 1.54 9.21-.68c4.38-2.22 4.57-5.26 4.57-5.97s-.1-.93-.1-.93-4 .98-6.97.95c-2.99-.02-3.9-.29-3.9-.29s8.33-.23 12.52-2.8c4.2-2.56 4.44-7.6 4.44-7.6s-4.75 1.68-7.73 2.03c-2.98.34-4.8.34-5.54.29-.74-.06-1.16-.3.47-.37 1.64-.08 7.97-1.14 11.48-3.2 3.5-2.06 5.7-6.48 5.91-8.53.21-2.07-.03-1.7-1.58-.72-1.56.98-7.31 4-11.11 4.84-3.8.84-4.54.95-4.54.95s-1.46-.07.42-.6zm-150.1 9.58-1.68.96s-.67-1.37-.85-1.77c-.17-.41-.08-.59.15-.59.23 0 .93-.2 1.48-.26.08 0 .15-.02.21-.03.19.52.43 1.09.75 1.66l-.06.04zm51.18 29.97c-1.02 1.9-3.79 3.9-5.82 4.78s-4.25 1.15-5.18 1.3c-.92.13-.14 1.24-.14 1.24l.97 1.4s-.13.41-1.61.83-3.28.74-4.8 1.16c-1.53.41.4 1.67 1.28 2.13.88.46.65.97.19 1.44-.46.46-2.17 1.43-3.05 1.71s-.74.75.14 1.12c.88.36 3.28.83 3.28.83s-.05.1-1.52 1.2a12.1 12.1 0 0 1-5.78 1.95c-1.71.1-4.41.2-7.84.05-3.43-.16-3.82-.24-3.82-.24s-.12-1.14-.36-2.84c-.23-1.69-1.26-4.1-2.05-5.2-.78-1.1-2.44-3.3-2.44-3.3s.04-.48.16-1.03.04-1.14-.36-2.18c-.4-1.05-2.4-2.57-2.4-2.57s-.09-1.12-.09-2.16-.72-5.13-1.36-7.05c-.64-1.92-3.76-6.97-5.2-9.37-1.45-2.4-2.3-5.96-2.74-8.73-.43-2.76-.26-3.67-.11-4.4.06-.31.2-.6.32-.86a8.6 8.6 0 0 0 2.32 2.08c4.2 2.56 12.54 2.8 12.54 2.8s-.93.27-3.9.3c-2.99.02-6.97-.96-6.97-.96s-.11.21-.11.93.19 3.75 4.56 5.97c4.38 2.22 9.21.69 9.21.69s-.4.34-1.63.79c-1.24.45-4.62 1.16-4.62 1.16 0 2.7 2.35 4.17 4.17 4.78 3.11 1.06 6.65.32 8.47-.05 1.82-.37.8.24-.93.98-1.7.74-4.16.87-4.16.87.37 1.96 4.24 3.65 5.7 3.96 3.69.8 6.4.3 7.52-.13s.9.08.55.42c-.66.67-1.78.83-1.78 1.89 0 .3-.03 1.37 5.46 1.73s7.31-2.69 8.27-3.59c.95-.9.9-.42.65-.06-.23.36-1.19 1.44-2.02 2.63-.84 1.2-.42 2.33 3.22 2.21 2.68-.08 4.45-2.93 5.2-4.42l.05.07.15.2c-.34.88-.93 2.32-1.58 3.54zM335 78.19c-.5-.94-.76-1.39-.76-1.39s2.07.97 3.3 2.36c1.23 1.4 1.2 2.13 1.39 2.81.18.69 0 1.94-.19 3.13-.18 1.18-.18 1.89.06 2.3.23.43.44.64.44.64s-.92.23-1.78.57c-.86.35-1.99.66-2.62.14-.63-.53-.78-.9-.39-1.24.4-.34 1.86-.76 2.04-3.28.18-2.52-.99-5.1-1.49-6.04zm-11.28 6.86c.47-1.2.67-2.34.3-4.8-.3-2.06-.7-3.82-.8-6.04 0 0 1.53.33 3.72 2.34 2.2 2 2.7 4.07 2.7 5.07s-.53 2.23-.61 3.2c-.09.98.27 1.85.27 1.85s-.8.33-1.52.83c-.73.5-1.23.8-2.34.75-1.1-.05-1.78-.55-2.42-.89s-1.05-.39-1.05-.39 1.27-.72 1.74-1.92zm-10.7-8.5c2.2-2 3.72-2.34 3.72-2.34-.1 2.22-.5 3.98-.8 6.05-.36 2.45-.17 3.59.3 4.79.48 1.2 1.75 1.92 1.75 1.92s-.41.06-1.05.39c-.64.33-1.3.84-2.42.9-1.11.05-1.61-.26-2.33-.76-.73-.5-1.53-.83-1.53-.83s.36-.87.27-1.84c-.08-.98-.6-2.2-.6-3.2 0-1.01.5-3.07 2.7-5.08zm-7.91 12.2c-.63.52-1.75.2-2.62-.13-.86-.35-1.78-.58-1.78-.58s.21-.21.45-.63c.23-.42.23-1.13.05-2.31-.18-1.19-.37-2.44-.18-3.13.18-.68.15-1.42 1.38-2.8 1.23-1.4 3.3-2.37 3.3-2.37s-.26.45-.76 1.39c-.5.95-1.67 3.52-1.49 6.04.18 2.52 1.65 2.94 2.04 3.28.4.34.23.71-.4 1.24zm29.24 21.07c-2.16 1.2-3.4.93-3.3 1.82.08.88 2.02 1.55 2.02 1.55s-1.98 2.12-3.53 3.1c-1.54.97-3.35 1.59-3.35 1.59s-.62.08-.27 1.06c.36.97.97 1.63 1.46 1.9.48.26.75.35.75.35s-2.69 2.88-3.88 3.8c-1.2.94-1.85 1.25-2.82 1.64-.97.4-.49 2-.27 2.7.22.7 1.06 1.68 1.55 1.82.48.13.66.48.04 1.46-.46.72-2 2.65-2.74 3.72l-.04.02c-.73-1.06-2.29-3.01-2.75-3.74-.62-.98-.44-1.33.04-1.46s1.32-1.11 1.54-1.82c.22-.7.71-2.3-.26-2.7-.97-.4-1.63-.7-2.82-1.63-1.2-.93-3.88-3.8-3.88-3.8s.26-.1.75-.36a3.6 3.6 0 0 0 1.45-1.9c.35-.98-.26-1.06-.26-1.06s-1.81-.62-3.36-1.6c-1.54-.97-3.52-3.1-3.52-3.1s1.94-.66 2.03-1.54c.08-.89-1.15-.62-3.31-1.82s-2.87-2.7-2.87-2.7 2.51-.83 3.75-3.36c.44-.89.54-1.7.5-2.39l.1.04c4 1.3 8.7 1.83 12.9 1.83 4.18 0 8.87-.53 12.87-1.83l.1-.04c-.05.69.06 1.5.5 2.4 1.23 2.52 3.74 3.36 3.74 3.36s-.7 1.5-2.86 2.7z'/%3e%3cpath fill='%23D4AF3A' d='M347.47 158.5c0-6.79 3.12-11.08 3.12-11.08l-8.5-9.73c-8.08 3.13-15.5 3.32-22.09-.04-6.6 3.36-14 3.17-22.1.04l-8.5 9.73s3.13 4.3 3.13 11.08c0 6.79-1.31 11.82-2.08 15.1-.76 3.29-1.42 9.41.33 13.8 1.75 4.37 3.61 8.2 11.16 11.37s11.5 4.82 14.12 7c2.63 2.2 3.94 3.95 3.94 3.95s1.31-1.76 3.94-3.94c2.63-2.2 6.57-3.83 14.12-7 7.55-3.18 9.4-7.01 11.16-11.39 1.75-4.38 1.1-10.5.33-13.79-.76-3.28-2.07-8.3-2.07-15.1z'/%3e%3cpath fill='%23B96B29' d='M344.8 161.3c-1.06-6.48 2.67-12.19 2.67-12.19l-7.27-8.5c-5.6 3.15-13.4 2.72-20.17-.4-6.78 3.12-14.58 3.55-20.18.4l-7.27 8.5s3.74 5.7 2.67 12.19c-1.07 6.48-3.36 16.74-2.79 20.92.58 4.18 3.53 9.02 6.57 11.57s7.54 4.67 10.74 5.82a30.98 30.98 0 0 1 7.8 4.51c1.47 1.15 2.46 2.14 2.46 2.14s.98-.99 2.46-2.14 4.6-3.36 7.79-4.5c3.2-1.16 7.71-3.3 10.75-5.83 3.03-2.55 5.98-7.39 6.56-11.57.57-4.2-1.73-14.45-2.8-20.93z'/%3e%3cpath fill='%231D5E91' d='M344.1 162.07c-1.05-7 2.1-12.63 2.1-12.63l-6.56-7.31c-5.55 2.85-12.29 2.11-19.63-.44-7.35 2.55-14.09 3.29-19.64.44l-6.56 7.3s3.16 5.64 2.1 12.64-2.66 14.92-2.35 19.57c.02.32.06.64.1.97h5.98s.35-.4 1.01-.69c.67-.28.86-.47.86-.47s.12-1.21.85-1.46c.73-.26 1.05-.26 1.33-.26s.5-.06.86-.41c.35-.35 1.3-1.2 1.7-2.42s.67-1.68.67-2.47c0-.8.29-2.07.29-2.07s-.16-.38-.76-.15c-.6.22-.7-.39-.76-.99-.07-.6-.03-1.84.31-2.41s.48-.77.48-.77l-.25-.95s-3.8.76-4.47-2.19c-.66-2.95-.79-4.38-.88-4.7-.1-.32-.2-.48-.7-.44-.5.03-1.59-.32-2.35-1.85-.76-1.52-.82-2.15-.6-2.76.22-.6.64-.38.76-.19.13.2 1.14 1.65 1.55 1.24.42-.41.2-.41-.38-1.56s-.38-1.52-.31-2.1c.06-.56-.2-1.33-.2-1.64 0-.32.36-.58.7-.42.35.16.67.42.83.6.16.2.22.48.54.3s.12-1.25.12-1.6c0-.34.41-.6.92-.31.5.28.76.82.76 1.2 0 .39.03.73.22.73s.41-.57.45-.95c.03-.38.25-.95.6-.47.35.47.47 1.17.35 1.9-.13.73.12.35-.13 1.62s-.38 1.84-.35 2.8c.03.95.06 1.49.54 2.66.47 1.18.85 2.54 1.74 2.57l1.14.04s.98-1.9 1.74-2.35c.76-.45 1.84-.51 2.6-.6.76-.1 1.07-.33 1.07-.52s-.25-.25-1.17-.38c-.91-.12-1.67-.35-1.7-1.05-.04-.7.15-1.3-.45-1.33-.6-.03-2.09-.51-2.63-1.5-.53-.98-.4-1.2-.34-1.74s.76-1.62 1.2-.6.73 1.14 1.1 1.36c.39.23.9.29.64-.41-.25-.7-.41-1.14-.35-1.65.07-.5.41-.73.83-.83.4-.1 1.64-.47 2.28-.6.63-.13.66-.19.66-.19s.06-.44.89-.7a5.96 5.96 0 0 1 1.96-.28c.6 0 1.04.1 1.84-.29.79-.38 1.42-.44 1.93-.41.5.03.88.22 1.26.47.38.26.26.6.26.96 0 .35.06.54.6.54s1.01 0 1.52.19c.5.19 1.2.47.76 1.01-.44.54-.47 1.15-.76 1.12-.28-.04-.25.28-.38.47-.13.2-.22.35.1.54.31.2.34.38.79.8.44.4 1.1.85.44 1.52-.66.67-1.84 1.2-1.84 1.2s-.66.32.1.77c.76.44 1.1 1.37 1.4 1.52.28.16.56.42.75.51.2.1.16.73.16.73s-.41.29-.98.51c-.57.22-1.17.48-1.71.48s-.82 0-.6.5c.22.51.6 1.05.7 1.34.09.28.22.8.22.8s.88.18 1.67.18c.8 0 1.14.03 2.88-.16 1.75-.18 2.25-.25 3.93-.06 1.68.2 1.93.13 2.38.29.44.16.88.38.88.38s2.38-.03 3.68-.32c1.3-.28 1.61-1.11 1.42-1.55-.19-.45-.16-1.12-2.44-1.43-2.28-.32-3.2-.2-5-.55-1.8-.34-4.62-1.27-5.13-3.52-.5-2.25 1.33-3.2 2.25-3.65.92-.45 2.91-1.14 3.83-1.52.92-.39 2.6-.77 4.37-.51 1.77.25 2.79.73 3.48.31.7-.4 1.27-.1 1.14.54-.12.64-.82 1.94-2.82 2.54-1.99.6-4.4.67-5.7.32-1.3-.35-2.27-.86-3.06-.57-.8.29-1.68 1.27-.83 2.44.86 1.18 5.23 1.53 6.4 1.66 1.17.12 5.5-.2 6.74 1.96 1.24 2.17.25 4.58-1.2 5.12-1.46.54-2.7.89-3.8 1.05l-1.1.15s.5 1.15.5 1.63c0 .47-.07 1.36.47 1.7.54.36 1.3.61 2.22.52.92-.1 2.03.54 2.09 1.36.06.83.32 1.97.41 3.62.1 1.65 0 3.02 0 3.02s-.06.64-.28 1.24c-.23.6-1.37 2.94-1.37 2.94h6.38c.05-.33.08-.65.1-.97.26-4.71-1.35-12.63-2.4-19.63z'/%3e%3cpath fill='%236D8C3E' d='M294.42 185.72a18.27 18.27 0 0 0 7.75 9.55c5.45 3.28 7.8 2.85 12.94 6.2 5.14 3.34 4.83 3.9 4.9 3.9s-.25-.57 4.89-3.9c5.14-3.35 7.5-2.92 12.94-6.2a18.25 18.25 0 0 0 7.75-9.55h-51.16z'/%3e%3cpath fill='%23D4AF3A' d='M298.88 158.13c.58.61 1.02.8 1.91.71.9-.1 1.1.56 1.26 1.26.16.71.16 2.38.8 3.92.65 1.54 2.8 1.63 2.8 1.63a9.6 9.6 0 0 1 .65-2.56c.06-.14.34-.83-.43-.83s-.74-.31-1.2-1.05a14.44 14.44 0 0 1-1.57-3.97c-.21-1.27.19-3.14.4-3.82.22-.68.25-1.14 0-1.26-.25-.13-.74 0-.74 0s.19.58-.03.67c-.22.1-.4-.3-.55-.74-.16-.43-.34-.37-.65-.34-.3.04-.3.31-.1.62.22.3.1.86.1.86s-.68-.49-.95-.61c-.28-.13-.93.12-1 .49-.05.37.26 1.32.84 1.82.59.49.59 1.5.4 1.97-.18.46-1.05.4-1.23.18a.53.53 0 0 0-.8 0c-.25.28-.5.44.09 1.05zm-.34-1.63s-.34-.28-.46-.43l-.37-.5s-.06.16-.06.53.4.77.4.77l.49-.37zm1.29-4.28c.28-.12.5-.19.28-.5-.22-.3-.4-.64-.62-.7-.22-.06-.4-.03-.4-.03s.25.55.3.9c.07.33.17.45.44.33zm1.61-1.3c-.03.28.03.4.28.28.24-.13.34-.47.21-.71-.12-.25-.4-.43-.4-.43l-.18-.13c-.02 0 .1.71.08.98zm2.3.37c.03-.3-.1-.65-.1-.65s0 .37-.15.59c-.15.22-.12.15.03.34.15.19.18.03.21-.28zm3.62 15.66c.45 1.05 1.6-.6 2.65-1.93 1.04-1.32 1.01-.3.87.77a5.1 5.1 0 0 0 .7 2.98c.42.73.77.31.94-.21.17-.52.31-1.6.66-2.13s.7-.07.73.38.6 1.47 1.12 2.06c.52.6.77-.2.94-.94s.38-1.85.52-2.31c.14-.45.63-.07.63-.07l1.05 1.01c.7.67.76-.38.83-.9.07-.53-.1-1.68.1-1.86.22-.17.8.25 1.72.7.9.46.87-.42.76-.9-.1-.5-.62-1.62-1.36-2.24-.73-.63-.83-1.37-.59-1.68.25-.32 1.12-.04 1.67-.1.56-.08.84-.15 1.26-.22.42-.07.42-.49.42-.49s-.32-.52-.9-1.05c-.6-.52-.95-.94-1.68-1.12-.73-.17-1.74 0-1.74 0l-.1-.2c-.11-.21-.32-.21-.46 0-.14.2-.49.48-.77.73-.28.24-.45.38-.63.28-.17-.1.14-.35.14-.35s.39-.28.74-.98c.34-.7.45-1.37.17-1.68-.28-.32-1.05 0-1.46 0-.42 0-.67.07-.7-.14-.04-.21.42-.1.94-.18.52-.07.84-.7 1.01-1.22s.31-.46.63-.14c.31.31.6.24.66.03.07-.2.35-.73.7-1.26.35-.52.56-1.25.17-1.74-.38-.5-1.32-.42-1.7-.1-.39.3-.63.62-.74 1.4-.1.76-.31.34-.31.1s-.32-.64-.18-.95c.14-.31 0-.66 0-.66s-.07-.67-.8-.8-1.57.03-2.3.2-.6.8-.6.8-.55.04-1.14.11c-.6.07-1.3.32-1.85.46-.56.14-.77.2-.77.48 0 .29.1.74.1.74s.46 0 .7.14c.25.14.1.38-.17.49-.28.1-.39.14-.39.49s.14.42.42.42.87 0 1.57.31c.7.32.87.95.8 1.3-.07.35-1.04.8-1.53.8s-.63.1-.63.42c0 .32.6.28.6.28s.59.04 1.74.17c1.15.15 1.32.39 1.85.84.52.46.14.56-.1.7-.25.14-.64.46-1.02.6-.38.14-.63.42-.98.49s-1.22.03-2.82.66c-1.6.63-2.16 2.73-2.16 2.73s.2-.07.94-.45c.73-.39 1.64-.8 2.47-1.33.84-.53.84.24.42.98-.42.73.39.59.63.38.24-.21.56-.42 1.36-.84s.52.25.52.25-.24.49-.31 1.64c-.07 1.16 1.15.07 1.7-.66s.81 0 .4.84c-.43.84-1.23 1.5-1.68 1.5-.46 0-.8-.49-.84-.77s.14-1.12-.14-1.33c-.28-.2-1.08.04-1.67.39-.6.35-.74.07-.87-.25-.14-.31.2-.42.07-.63-.14-.2-.46 0-.7.1-.25.11-.8.43-1.88.99-1.09.55-1.02.87-1.02 1.67s.2 1 .65 2.04z'/%3e%3cpath fill='%23D4AF3A' d='M317.82 149.44c.23-.14.64-.3.64-.3s.51-.13.99-.2c.47-.06.39-.33.28-.55-.1-.23-.28-.31-.9-.31s-1.01.31-1.36.45c-.35.15-.76.25-.76.25l.3.43c.23.35.58.4.8.24zm2.52 2.5c.25 0 .52-.14.52-.14s.45-.23.86-.38c.41-.14.58-.2.82-.7.25-.49-.27-.49-.99-.67-.72-.2-1.07.06-1.15.32-.08.27-.06.58-.35 1.1-.29.5.04.47.3.47zm-.23.63c-.7 0-1.48 1.05-1.77 1.24s-.12.37-.12.37.2.43.28.84c.09.41.1 1.11.1 1.11s.11.04.52.04c.41 0 .66-.2 1.05-.5s.7-.38 1.26-.49c.55-.1.82-.2 1.44-.53s-.33-.9-.99-1.44a2.46 2.46 0 0 0-1.77-.62zm-9.31 2.42c.55-.06.8-.34.8-.65s-.28-.64-.99-.58c-1.73.15-3.41-.47-3.72-2.19 0 0-.59 1.08.5 2.28 1.08 1.2 2.86 1.2 3.42 1.14zm-5.91 27.32c.09.15.2.25.3.3h2.66c.46-.12.46-.54.48-.83.03-.34.3-1.31.66-3.08.37-1.77 1-3.03 1.26-3.74s-.26-.95-.45-1.4c-.18-.44-.47-1.23-.55-1.63-.08-.4-.7-.34-1.05-.32s-.4.58-.45 1.11c-.05.53-.29 2.08-.55 3.42-.26 1.35-1.78 3.14-2.2 3.54-.43.4-.77.55-1.06.55s-.91 0-1.23.18c-.31.19-.63.69-.66 1.08-.02.4.6.61.6.61s.5-.29.7-.53c.17-.23.6-.29 1.01-.36.42-.08.48.07.32.28-.16.2-.11.25.21.81zm-4.07-.14c-.2.07-.35.27-.44.44h1.74a.93.93 0 0 0-.17-.44c-.21-.26-.77-.13-1.13 0z'/%3e%3cpath fill='%23D4AF3A' d='M303.18 182.12c-.21.12-.47.3-.6.49h1.87c.07-.18.09-.4-.14-.6-.42-.34-.84-.05-1.13.1zm16.22-.77c-.2 0-.39.18-.68.39-.3.2-.38.52-.43.77l.01.1h.8a.14.14 0 0 0 .05-.1c0-.23.1-.44.43-.73.35-.3.03-.43-.17-.43zm1.56.86c0-.25-.1-.47-.27-.45s-.48.34-.72.52c-.14.1-.24.23-.32.33h1.17c.07-.14.14-.29.14-.4z'/%3e%3cpath fill='%23D4AF3A' d='M328.18 173.58c.56-.4.47-.52.5-.95.02-.43.02-.57-.2-.72-.23-.16-1.07-.53-1.86-.53s-2.28.19-2.84.57c-.57.39-.84 1.77-.84 2.49s.11.84.32.84.54-.52.54-.52.74.97 1.2 1.65c.45.68.24.95.04 1.47-.2.52-.95 1.9-1.53 2.2-.6.3-1.04.02-1.74-.1-.7-.1-1.09.1-1.5.5s-.01.73.23.73c.25 0 .6-.02.86.32.19.23.06.77-.03 1.08h3.46c.59-.26 1-1.07 1.15-1.52.18-.5.93-1.15 1.3-1.49.35-.34.4-.56.4-1.31s-.2-1.18-.48-1.7a3.1 3.1 0 0 1-.38-1.7c.06-.46.8-.93 1.37-1.34z'/%3e%3cpath fill='%23D4AF3A' d='M322.49 164.95c.35.56.17.67-.32.78-.5.1-1.04.19-1.81.13-.78-.07-.76.04-.78.43a3.4 3.4 0 0 1-.54 1.8c-.45.61-1.01.38-1.36.14s-.54-.18-.67.26-.36.73-.73 1.38c-.37.64-.6.67-.86.6s-.5-.45-.76-.47-.67-.54-1.05-1.17c-.4-.62-.59.07-.84.6-.26.54-.52.93-1.02.87-.5-.07-1.05-1-1.33-1.56s-.46-1.1-.89-1.07c-.43.02-1.14.92-1.62 1.16-.47.24-.6.15-.81-.15-.22-.3-.5.1-.78.82-.28.71.02 1.31.4 1.5.4.2 1.17-.36 1.7-.7.5-.35.75-.26 1.29-.26.53 0 .5.88.73 2.18.24 1.29.99 1.46.99 1.46s.26.22.84-.77c.58-1 .65-1.97 1.2-1.97.57 0 .61.13 1.17.91.56.78 1.04 1.36 1.36.78.32-.59.6-1.45.97-1.75.37-.3.71-.39.33.17-.4.56-.57 1.17.23.93s3.84-1.47 5.07-1.7c0 0 1.44-.24 3.1-.33 1.66-.08 2.07-.2 2.72-.2.65 0 .67-.06.71-.49.05-.43-.3-.34-1.5-.34-1.21 0-2.06.15-2.9.28-.84.13-1.22.1-1.08-.1.16-.23.4-.38 1.36-.53a39.7 39.7 0 0 1 4-.28c1.03-.02.7.3.62 1-.09.68.08 1.7.15 2.35.06.64.08.84.65 1.74s2.5 1.47 3.06 1.77c.56.3.47 0 .45-.54-.02-.54.43-.52.93-.24.5.29 1.31.52 1.9.67.58.15.66.26.66.56s.07.97.13 1.6c.07.63.05.82-.21 1.2s-1.36 1.52-1.36 1.52-.5 0-1.55.26c-1.06.26-1.39.75-1.5 1.18s.2.56.25.74c.02.1 0 .32 0 .51h.24c.09-.15.22-.35.38-.56.37-.47 1.3-.58 1.9-.3.4.18.4.6.36.86h2.41a86.8 86.8 0 0 0 1.3-2.59c.26-.58.41-.94.43-1.74s.11-3.88-.04-4.06c-.15-.17.04-.69 0-1.55-.04-.86 0-1.5-1.6-1.66-1.6-.15-2.09-.82-2.63-1.36-.54-.54-.4-1.79-.84-3.3-.43-1.5-1.48-1.74-3.36-2.11-1.88-.37-3.26-.4-4.66-.28s-3.14.32-4.12.24c-.95-.12-.8.16-.45.72z'/%3e%3cpath fill='%23D4AF3A' d='M331.55 182.27c-.16.1-.27.23-.35.34h1.63c.01-.14-.01-.3-.16-.47-.24-.3-.72-.13-1.12.13zm2.92-.11c-.27.13-.44.3-.54.45h1.65v-.19c-.06-.26-.56-.54-1.1-.26zm-40.72 1.03c.1.51.21 1.03.36 1.55h51.79c.14-.52.27-1.04.36-1.55h-52.51zm34.9-24.74c1.64 1.09 6.83 1.15 9.27 1.64 2.44.48 2.27 2.35 1.52 3.32-.75.98-4.18 1.1-4.8 1.18.34.23.84.95.84.95l1.4-.12c1.04-.08 2.85-.34 4.08-1.38 1.24-1.03 1.15-2.7.06-3.81-1.1-1.12-2.9-1.23-4.74-1.44-1.83-.2-3.27-.34-5.33-.68-2.07-.35-3.07-1.18-3.07-2.39 0-1.2 1.12-1.83 1.92-2.06.8-.23 2.1-.57 3.24-.15 1.15.43 2.5.5 4.77.2 2.26-.28 2.78-1.86 2.78-1.86s-.29.14-1.44.17c-1.14.03-1.98-.49-4.07-.52-2.1-.02-2.84.72-3.82 1.07-.97.34-3.58.6-4.36 2.3-.77 1.7.12 2.5 1.76 3.58z'/%3e%3cellipse cx='315.04' cy='150.64' fill='%23B96B29' rx='.98' ry='.96'/%3e%3cpath fill='%23B96B29' d='M336.02 152.28c-1.3-.11-2.99.23-2.99.23s.32.26.75.23 1.2-.06 2.47.17c1.26.23 2.18-.37 2.18-.37s-1.12-.14-2.41-.26z'/%3e%3cpath fill='%231D5E91' d='M323.74 176.38c-.32-.5-.4-.45-.77-.14-.36.32-.72-.77-.77-1.44-.04-.68.27-2.76.27-2.76s-1.76.36-2.71.68c-.95.31-1.86.4-2.63.59s-1.17.36-1.58.27c-.4-.1-1.27-.14-1.94-.14s-.64.14-1.32.81c-.67.68-.85 1.04-1.4 2.31a13.45 13.45 0 0 0-.9 3.98c-.12 1-.32 1.7-.44 2.06h8.11l.33-.83c.22-.46.66-.76.98-.9s.6-.16.74-.52c.15-.36.56-.66.98-.85s1.17-.08 1.85.1c.68.2.91-.27 1.1-.52.2-.26.28-.62.64-1.09.36-.46.1-.89.1-.89s-.34-.22-.66-.72zm13.01.22c-.1-.47-.06-.53-.34-.6-.28-.06-.74-.14-1.15-.31-.4-.17-.36.91-.36.91s-.95.1-2.04-.02c-1.08-.13-2.35-1.1-2.8-1.43-.44-.31-.93-1.04-.93-1.04s-.34.32-.68.51-.54.88-.6 1.56c-.06.68.79 1.5.85 2.18.06.68-.74 2.04-1.15 2.6-.27.37-.63 1.18-.83 1.65h3.92a2 2 0 0 1 .42-.66c.4-.4 1.08-.48 1.08-.48s0-.17.15-.53c.15-.37.55-.8 1.53-1.17.98-.39 2.14-.45 2.14-.45s.47-.38.81-.91c.34-.53.1-1.33-.02-1.8z'/%3e%3cpath fill='%23D4AF3A' d='M304.15 219.77c.73.24 2.1-.3 2.77-1.12.68-.82.93-2.1 1.41-2.82l.84-1.27s-.1 1.2-.75 2.81a10.31 10.31 0 0 0-.57 4.54c.29 1.8 1.45 2.1 2.14 1.85.51-.19 1.3-.98 2.01-2.18.23-.38.4-.9.61-1.32.46-.88.88-2.31 1.08-2.27.45.09.16 1.1 0 1.78-.35 1.36-1.03 3.36-1.08 4.57s.1 3.4 1.32 3.5c1.21.1 1.84-.97 2.52-3.45.69-2.48.83-3.26 1.12-3.26.3 0 .3 1.7.3 2.43 0 .25 0 .94.1 1.64.2 1.33.58 2.92.97 3.28.58.53 1.07.43 1.07.43s.48.1 1.07-.43c.58-.54 1.06-4.19 1.06-4.92s0-2.43.3-2.43c.29 0 .43.78 1.11 3.26.69 2.48 1.32 3.55 2.53 3.45 1.22-.1 1.37-2.28 1.32-3.5s-.73-3.21-1.07-4.57c-.34-1.36.14-1.27 1.07.49.29.54.59 1.21.88 1.68.65 1.03 1.28 1.65 1.74 1.82.68.24 1.85-.05 2.14-1.85.3-1.8-1.07-6.96-1.07-6.96l.59.88c.48.73.73 2 1.4 2.82.69.83 2.05 1.36 2.78 1.12s.83-1.6.3-4.04c-.54-2.43-2.73-3.8-4.29-5.74-1.43-1.79-2.53-4.93-2.7-5.43a17.96 17.96 0 0 0-5.23 3.7c-3.22 3.35-3.92 4.2-3.92 4.2s-.7-.85-3.91-4.2a18.03 18.03 0 0 0-5.27-3.71c-.18.41-1.52 3.42-2.96 5.23-.72.9-1.71 1.57-2.42 2.44-.82 1-1.31 2.2-1.6 3.5-.52 2.43-.42 3.79.3 4.04z'/%3e%3cpath fill='%23D4AF3A' d='M304.06 228.01c.94-.83 1.43-1.29 1.43-1.29s.68-.57.51.52c-.17 1.08-.54 3.31-.31 4.28.23.97.34 1.8 1.54 1.08 1.2-.71 1.48-1.14 2.05-1.74.57-.6 1.17-.85 1.03.09-.14.94-.57 2.37-.37 4.28.2 1.91 1.14 2.2 2.37.57a21.5 21.5 0 0 0 2.34-3.91c.37-.8 1.11-1.48 1.11 0 0 3.2.73 7.83 4.25 9.07 3.52-1.24 4.25-5.88 4.25-9.07 0-1.48.74-.8 1.11 0 .38.8 1.12 2.28 2.34 3.9 1.23 1.63 2.17 1.35 2.37-.56.2-1.91-.23-3.34-.37-4.28s.46-.69 1.03-.09c.57.6.85 1.03 2.05 1.74 1.2.72 1.32-.11 1.54-1.08.23-.97-.14-3.2-.3-4.28-.18-1.09.5-.52.5-.52s.49.46 1.43 1.29a4 4 0 0 0 2.24.88s.6-3.35-.8-5.35-1.9-2.66-1.9-2.66-.8-.04-1.4-.27c-.6-.24-1.2-.67-1.2-.67v1.85s1.72 1.63 2.12 2.11c.4.48 1.2 1.31.03.51s-2.14-1.6-2.14-1.6-.23 1.69-.72 2.12c-.48.42-1.17.48-1.45.37l-.29-.12-.08.66s1.05 1.97 1.2 2.77c.14.8-.09.71-.57-.32-.49-1.02-1.43-2.34-1.86-3.05s-1.05-1.2-1-.28c.06.9-.31 2.56-.63 3.16-.3.6-.5.8-.5.8s.65 2.31.73 2.74c.09.43.03.91-.34.37s-1.43-2.82-1.43-2.82-1.4-.06-1.8-.46c-.4-.4-1.02-1.94-1.02-1.94s-.57 1.97-1.05 2.6c-.47.63-1.57 1.26-1.57 1.26s-.08 3.41-.16 4.02c-.08.6-.1.86-.36.86-.25 0-.28-.26-.36-.86-.08-.6-.16-4.02-.16-4.02s-1.1-.63-1.57-1.26c-.48-.63-1.05-2.6-1.05-2.6s-.63 1.54-1.03 1.94c-.4.4-1.8.46-1.8.46s-1.05 2.28-1.42 2.82c-.37.54-.43.06-.34-.37s.74-2.74.74-2.74-.2-.2-.51-.8a8.2 8.2 0 0 1-.63-3.16c.06-.92-.57-.43-1 .28s-1.37 2.03-1.85 3.05c-.49 1.03-.72 1.12-.57.32s1.2-2.77 1.2-2.77l-.1-.66-.28.12c-.28.11-.97.05-1.45-.37-.49-.43-.72-2.12-.72-2.12s-.97.8-2.14 1.6c-1.17.8-.37-.03.03-.51s2.11-2.11 2.11-2.11v-1.85s-.58.43-1.19.67c-.6.23-1.4.27-1.4.27s-.5.65-1.9 2.66c-1.4 2-.8 5.35-.8 5.35s1.3-.04 2.25-.86zm17.17 22.31c-.9-1.05-1.2-1.58-1.2-1.58s-.3.52-1.2 1.58c-.9 1.05-3.01 2.7-3.01 2.7s.18 2.8 1.2 4.3c.86 1.27 1.67 2.43 3 3.3a10.97 10.97 0 0 0 3.02-3.3c1.01-1.5 1.2-4.3 1.2-4.3s-2.11-1.65-3.01-2.7z'/%3e%3cpath fill='%23B96B29' d='M319.57 253.73c.08.65.03 2.28.42 2.28s.34-1.63.42-2.28c.08-.65.11-2.2.11-2.2h-1.06s.04 1.55.12 2.2z'/%3e%3cpath fill='%23D4AF3A' d='M319.98 100.87c-3.77.06-8.18-.46-10.62-1.36l-2.59.57c4.01 1.5 7.36 2.1 13.21 2.15 5.85-.06 9.2-.64 13.2-2.15l-2.59-.57c-2.43.9-6.85 1.42-10.62 1.36zm13.7-3.14c-.3-.25-2.01-1.47-2.46-1.7-.45-.22-.1-.82-.02-1.07.07-.25 2-.8 3.08-1.07 1.06-.27.9-.5.9-.5s-.63-.72-4.5-1.14c-3.88-.43-10.69-.33-10.69-.33s-6.8-.1-10.68.33c-3.87.42-4.5 1.14-4.5 1.14s-.17.23.9.5 3 .82 3.08 1.07c.07.25.42.85-.02 1.07a27.9 27.9 0 0 0-2.46 1.7c-.3.25-.33.64.15.67.47.02.48.02 1.8-.25 4-.8 7.75-1.01 11.74-1.07 3.98.06 7.73.28 11.72 1.07 1.33.27 1.34.27 1.81.25.47-.03.45-.42.15-.67z'/%3e%3cpath fill='%23D4AF3A' d='M329.27 99.37c-2.66-.31-4.35-.66-9.27-.61-4.92.04-6.6.3-9.27.61 1.68.68 4.38 1.01 9.27 1.01s7.6-.34 9.27-1zm-10.09-36.48 2.03-.16-.19-1.78 2.18.3.09-1.75-2.29.21.4-1.89-2.52-.02.44 1.91-2.22-.2v1.74l2.2-.25zm4.43 2.87h-2.73v-2.33a4.02 4.02 0 0 0-1.51-.01v2.34h-2.82a3.05 3.05 0 0 0-.12 1.33h7.3a2.9 2.9 0 0 0-.14-1.33z'/%3e%3cpath fill='%231D5E91' d='M320.08 70.03c1.62 0 3-.95 3.48-2.27h-6.97a3.67 3.67 0 0 0 3.5 2.27zm1.5-6.38v1.6h1.8a3.5 3.5 0 0 0-1.8-1.6zm-3.01 0c-.8.32-1.43.89-1.8 1.6h1.8v-1.6z'/%3e%3cpath fill='%23B96B29' d='M322.17 93.31c-.69-.32-2.19-.96-2.19-.96l-2.2 1.09c-.77.39-.67.27-.91.84s.02.76.36.91c.34.15 2.79 1.4 2.79 1.4l3.01-1.4c.6-.27.48-.55.32-.98-.16-.42-.5-.57-1.17-.9z'/%3e%3cpath fill='%23D4AF3A' d='m317.64 94.03 2.4 1.22 2.37-1.22-2.43-1.14zm2.34-9.38s-.2.84-.47 1.2c-.27.36-.48.69-.4 1.12.08.44.58.73.87.73.3 0 .8-.29.87-.73.08-.43-.13-.76-.4-1.12-.26-.35-.47-1.2-.47-1.2z'/%3e%3ccircle cx='320' cy='88.56' r='.45' fill='%23D4AF3A'/%3e%3cpath fill='%23D4AF3A' d='M318.39 86.24s.78-.87 1.07-1.42c.29-.54.52-1.03.52-1.03s.24.49.52 1.03c.3.55 1.07 1.42 1.07 1.42s1.1-.58 1.73-2.68c.64-2.11-.14-4.33-.43-6.73s-.52-6.52-.52-6.52c-.83.48-1.62.68-2.37.7a4.89 4.89 0 0 1-2.37-.7s-.23 4.13-.52 6.52c-.29 2.4-1.07 4.62-.43 6.73.64 2.1 1.73 2.68 1.73 2.68z'/%3e%3cellipse cx='319.98' cy='81.51' fill='%23B96B29' rx='1.89' ry='1.83'/%3e%3cellipse cx='319.98' cy='77.22' fill='%23B96B29' rx='1.82' ry='1.76'/%3e%3cellipse cx='319.98' cy='73.12' fill='%23B96B29' rx='1.74' ry='1.68'/%3e%3cellipse cx='319.98' cy='81.18' fill='%23D4AF3A' rx='1' ry='.97'/%3e%3cellipse cx='319.98' cy='76.91' fill='%23D4AF3A' rx='.97' ry='.93'/%3e%3cellipse cx='319.98' cy='72.82' fill='%23D4AF3A' rx='.85' ry='.82'/%3e%3cpath fill='%23b96b29' d='M319.93 224.04c.12.02.14-.28.16-.83.03-.56.1-1.9.23-2.7.14-.78-.2-.73-.41-.69-.21.05-.33.65-.33 1s.1 2.34.1 2.76.13.44.25.46z'/%3e%3cg id='a'%3e%3cpath fill='%23d4af3a' d='M300.28 239.41c.84-.53 1.57-1.13 3.48-2.4 1.9-1.26 2.6-2.66 2.6-2.66h-.67c-.36 0-.67-.51-.7-1.02-.03-.5 0-1.55.14-2.76.14-1.2-.2-2.19-.2-2.19s-.8.76-2.04 1.4c-1.24.65-1.74.34-1.74.34l-.31-1.23s-.53 1.12-1.29 2.44c-.76 1.33-2.8 2.79-4.26 3.89s-3.06 2.25-4.27 2.67c-1.2.42-.5.99-.5.99s1.2 1.2 4.32 1.77 4.6-.7 5.44-1.24z'/%3e%3cpath fill='%23d4af3a' d='M311.17 238.2c-1.11-.12-1.78-.54-2-1.75-.13-.78.06-3.8.06-3.8s-.36.32-.78.82c-.42.5-1.38.62-1.38.62s-.14.42-.56 1.1c-.42.67-.95 1.5-2.02 2.16-1.06.68-2.3 1.47-3.11 2.14-.81.68-1.77 1.47-2.83 2.06a4.66 4.66 0 0 0-2.39 3.12c-.36 1.58-.08 2.08 1.15 2 1.24-.09 1.38.03 3.37-.48 1.99-.5 4.82-2.73 6.9-4.05 2.08-1.32 3.59-3.94 3.59-3.94z'/%3e%3cpath fill='%23d4af3a' d='M316.69 240.02s-.84-1.07-1.15-2.28l-.9-3.6s-.28.76-.95 2.2c-.67 1.43-1.82 1.77-1.82 1.77s-.06.62-1.01 1.83a14.03 14.03 0 0 1-3.8 3.18c-1.42.84-3.27 2-4.28 3.43-1.01 1.43-1.1 2.92-.62 3.57.48.65 1.15-.09 2.1-.56s3.68-.9 7.44-2.93c3.76-2.02 4.99-6.61 4.99-6.61z'/%3e%3cpath fill='%23d4af3a' d='M318.32 248.44c1.04-1.55 1.2-5.32 1.2-5.32s-.36-.25-.86-.67c-.5-.42-1.49-1.91-1.49-1.91s-.62 1.29-1.29 2.5a9.4 9.4 0 0 1-2.41 2.92c-1.4 1.3-3.31 2.57-4.13 3.94-.8 1.38-.36 4.14.17 5.07.54.93 1.3.61 2.08-.14.78-.76 1.04-.96 2.41-2.14s3.28-2.7 4.32-4.25z'/%3e%3cpath fill='%23b96b29' d='M305.98 216.89c.55-1.13 1.18-2.5 1.68-3.19.5-.7.86-1.49.86-1.49s-1.34 1.22-1.87 2.09c-.53.86-.86 1.7-1.1 2.64-.24.93-.12 1.08.43-.05zm5.33.96c.22-.74.34-1.24.34-1.24s.21-.72.1-.77c-.13-.05-.68.45-1.06 1.67-.39 1.23-.96 3-.84 3.07.12.08 1.24-1.99 1.46-2.73zm4.2 3.38.24-.55s.43-1.4.43-1.68c0-.29-.14-.62-.5.1s-.38 1.41-.46 1.72c-.07.32-.48 1.4-.36 1.5.12.09.41-.56.65-1.09zm-13.04 12.8-.56-.34s-.34.45-.82.96c-.47.5-1 .7-1.37 1.18-.36.48-.93 1.07-1.8 1.52s-1.2.6-1.03.73c.17.14.76-.2.76-.2s.25-.02 1.29-.64 1.29-.96 1.96-1.55 1.57-1.66 1.57-1.66zm4.55 5.38c.4-.42.81-.7.59-.93-.23-.22-.5-.2-.87.11s-1.4 1.3-1.88 1.72c-.48.42-.87.67-1.35 1.04-.47.37-1.51.93-2.02 1.2-.5.3-.02.32-.02.32s.39-.2.81-.34c.42-.14 1.63-.67 1.63-.67s.47-.23 1.12-.68c.64-.45 1.6-1.35 1.99-1.77zm5.24 3.63c.34-.67-.03-.48-.59-.25-.56.22-1.82 1.6-2.55 2.1s-1.35.71-1.96 1.02c-.62.31-.62.48-.6.62.03.14.29.14.54.03.25-.12 1.12-.62 1.12-.62s.37-.11.7-.14c.34-.03.82-.4 1.57-1.04.76-.65 1.43-1.04 1.77-1.72zm2.44 4.81c-.93.56-2.52 1.83-2.94 2.67-.43.85-.7 1.44-.57 1.58.14.14.6-.14.79-.48.2-.34.62-.85.62-.85s1.6-1.57 2.18-1.94 1.55-1.4 1.77-2.02c.22-.62.06-.96.06-.96s-.99 1.44-1.91 2z'/%3e%3cpath fill='%23c52126' d='M289.99 113.28c-.85-.5-3.13-1.47-5.56-1.68-2.42-.2-4.3.16-6.31.7a6.98 6.98 0 0 1-3.77.14 5.23 5.23 0 0 1-3.54-3.95s-1.6 2.06.03 4.29a4.8 4.8 0 0 0 2.86 1.95c3.4.68 6.73-1.4 9.56-1.57 2.72-.18 4.86 1.55 4.86 1.55s.64.53 1.55 0c.9-.53 1.17-.93.32-1.43z'/%3e%3cpath fill='%23d4af3a' d='m280.2 211.66-.8-.1c-.47-.07-1.47-.4-1.77-.54-.3-.13-.77-.17-1.07.17-.3.34-2.75 1.78-2.75 1.78h4.05c1.4 0 2.34-1.31 2.34-1.31z'/%3e%3cpath fill='%23d4af3a' d='M291.59 210.97v-.4l-.54-1.16s-.63.39-1.24 1.02c-.79.82-1.64 1.97-2.02 2.46-.67.86-1.61 1.68-.8.3.8-1.38 1.07-1.98 1.72-2.9.64-.91 1.13-1.32 1.05-1.37-.08-.06-.6-.14-2.3-.35-1.69-.22-2.74-.87-3.52-1.33-.78-.46-2.18-1.21-2.18-1.21s-2.88 1.21-3.96 1.48-1.73.43-.68.95c1.06.51 1.94.67 2.46 1 .5.32 2.1.83 3.07.83.97 0 2.6.03 1.96.7-.64.68-1.37 1.98-2.07 3.95-.7 1.97-.73 3.73-.73 4.6s.1 1.72.1 1.72 1.2-1.32 4.37-3.32a56.1 56.1 0 0 1 4.96-2.94c.59-.27.89-.27.78-1.03-.1-.76-.43-2.62-.43-3z'/%3e%3cpath fill='%23d4af3a' d='m303.73 201.31-.59-.27a.7.7 0 0 0-.15.05c-.37.2-2.3 1.5-3.1 2.76-.77 1.27-1.56 1.38-.7 0a11.94 11.94 0 0 1 2.84-3.32 35.56 35.56 0 0 1-4.9-2.8 7.49 7.49 0 0 1-1.07 1.65c-.67.7-2.17 1.3-2.17 1.3s1.2-1.22 1.6-2.16c.27-.6.44-1.23.53-1.62a21.1 21.1 0 0 1-3.21-3.06c-.2.8-.84 2.77-2.76 4.9-2.5 2.8-7.5 4.22-7.5 4.22s-1.74.19-.33.56 2.43 1 5.19.52c2.76-.48 2.94-.6 3.32-.7.37-.12 1.38-.04 0 .48s-4.6 1-5.82.9c-1.23-.12-2.91-.38-1.16.55s2.5 1.3 3.58 1.3 1.53.35 2.58.35c1.04 0 1.34-.2 2.08-.34.75-.15 1.23.11 1.23.4 0 .3-1 1.13-.96 3.18.03 2.05.18 3.4.37 3.99.19.6.63 1.56.93 2.13.3.55.41 1.11.7-.08.3-1.2.98-2.9 1.24-4.06.26-1.16.4-1.2.52-1.8.11-.6.75-1.04.45.04s-.64 2.46-.86 3.43c-.22.97-.74 2.76.15 1.35.9-1.42 4.25-5.19 4.8-5.86s1.02-1.3 1.43-1.86c.4-.56 1.56-1.3 2.12-2.13.5-.74 1.99-2.18 2.63-2.7-.95-.4-1.95-.83-3.01-1.3zm-46.36-86.08c.09 2.06 2.36 5.99 3.66 8.09 1.3 2.1 1.65 2.94 1.43 3.08-.23.13-.76-.94-1.48-1.88-.71-.93-2.1-3.12-3.25-4.78s-2.86-5.58-3.08-5.94c-.22-.36-.31-.58-.9-.13-.57.44-1.69 4.78-.35 7.73 1.34 2.94 3.35 5.09 4.2 6.12.84 1.02 1.96 2.63 1.78 2.77-.18.13-.5-.27-1.52-1.34s-2.72-2.9-3.84-4.25a31.7 31.7 0 0 1-2.56-4.09c-.16-.3-.37-.21-.53-.06-.37.37-.95 1.23-.7 3.57.36 3.26 2.05 5.14 3.57 6.8 1.52 1.64 3.03 3.03 2.81 3.25s-1.78-1.16-2.85-2.19a95.4 95.4 0 0 1-4.29-4.29c-.58-.7-1.42-.35-1.38 2.46s3.17 5.68 4.46 7.24c1.3 1.56 2.9 2.5 2.77 2.81-.14.32-1.43-.49-2.28-1.07-.84-.58-4.01-2.64-4.64-3.08-.62-.45-.93.4-.13 3.08s3.12 4.82 4.5 5.8c1.39.99 3.62 2.2 3.48 2.51-.13.31-1.07-.09-2.36-.72-1.3-.62-2.85-1.2-3.97-1.51-1.12-.32-1.11.49-1.11.49s-.23 2.27 1.42 4.1 3.53 2.55 5.31 2.86c1.78.32 2.05.4 2 .68-.04.26-.22.3-.62.3s-2.05.19-3.57.19-2.31.35-2.31 1.02-.05 1.57 2.23 3.09c2.27 1.52 4.81 1.74 5.88 1.96 1.07.23 1.12.32.9.63-.23.31-.72.27-2.41.45-1.7.17-2.72.84-2.95 1.29-.22.45.14 1.79 1.52 2.73 1.38.93 3.17 1.25 5.84 1.07 2.68-.18 3.35-.23 3.44.22.09.45-.8.58-2.14.8-1.34.23-2.37.23-3.13.86-.75.62-.17 1.92 1.12 2.85s4.5.94 5.84.85 3.4-.58 3.53-.22-.98.9-2.37 1.38c-1.38.5-1.78.8-2.05 1.39-.27.58-.04 1.12 1.6 1.74 1.66.63 4.07.63 5.32.05s1.91-.8 2.14-.58c.22.22 0 .44-.27.76-.27.3-1.34 1.16-2.72 1.52s-1.52.35-2 1.47c-.5 1.12.75 2.01 3.25 2.1 2.5.09 5.84-.9 6.91-1.52 1.07-.63 1.47-.76 1.65-.54.18.23.14.36-.4.76s-2.23 1.61-3.08 1.84c-.84.22-.93.84-.93 1.43 0 .58-.23 1.74 2 2.27 2.23.54 4.86.14 7.27-1.56a5.5 5.5 0 0 0 1.48-1.39c-.19-2.28-.09-3.85.19-5.3a8.81 8.81 0 0 1-2.3-.55c-1.33-.53-1.86-1.78-2.18-2.45-.31-.67-.76-.67-1.3-.5-.53.18-1.06.4-1.82.36s-2.36-.44-3.52-1.83c-1.16-1.39-.94-2.72-.99-3.4-.04-.67-1.11-.17-1.65-.17-.53 0-2.1-.23-3.52-1.21-1.43-.98-1.43-2.32-1.56-2.86-.14-.54-.72-.9-1.16-1.07-.45-.18-1.16-.36-2.14-1.16-.98-.8-1.34-2.37-1.39-2.9-.04-.54-.62-.59-2.63-1.61s-1.83-3.18-1.74-4.02c.1-.85 1.03-1.57 1.03-1.88 0-.32-.67-.4-1.34-.8s-2.36-1.08-2.4-3.58c-.05-2.5 1.6-2.77 1.6-2.77s-.31-.13-.98-.54c-.67-.4-2.5-1.65-2.5-3.12 0-1.48.67-2.15 1.16-2.5.49-.36 1.83-.72 1.83-.72s-.85-.54-1.2-1.7c-.36-1.16-.5-2.59.35-3.62.85-1.02 2.27-1.02 3.03-1.02s1.43.4 1.7.18c.27-.23.31-.4.04-.99a4.38 4.38 0 0 1-.09-2.5c.23-.49.27-1.47 2.19-2.1 1.92-.62 3.92.67 4.55 1.03s.36-.5.36-1.12c0-.62-1.3-2.19-2.77-4.42s-2.14-3.4-3.8-6.8-2.71-7.76-2.94-8.88c-.22-1.12-.67-.58-.67-.58s-.44.18-1.47 2.77a16.66 16.66 0 0 0-1.11 7.01z'/%3e%3cpath fill='%23d4af3a' d='M291.02 160.92a5.02 5.02 0 0 1-3.8-2.36c-1.14-1.67-2.87-2.07-5.85-2.01-3 .05-4.37-1.38-5.12-3.46-.74-2.07.12-4.43 3.16-5.92s4.43-3.17 4.54-5.76c.12-2.59-3.04-5.81-6.2-9.43s-5.63-8.75-5.63-8.75-.92 1.2-.92 2.41.46 2.48 0 2.82c-.46.35-.63-.51-2.47-1.32-1.84-.8-3.34-.92-4.48.4s0 3.63 1.03 4.72c1.03 1.1 1.9 1.9 1.6 2.3s-1.83-.63-2.35-.97-1.72-1.67-3.5-1.5-2.42.69-2.59 2.19c-.17 1.5 1.61 2.82 2.76 3.4 1.15.57 1.6 1.09 1.32 1.31-.29.24-.57 0-1.1-.17a5.35 5.35 0 0 0-2.86 0c-.92.35-2.42 1.61-1.04 3.17 1.38 1.55 4.25 2.13 4.83 2.24.57.12.86-.06.92.4.05.47-1.21.47-2.76.52s-2.01 1.56-1.78 2.7 2.81 2.42 4.25 2.65c1.44.23 1.95 0 2.07.4.11.4-.17.58-.98.81-.8.23-2.35.4-2.64 1.67-.29 1.27-.35 1.84.86 2.94 1.2 1.09 3.16.92 3.73.8.58-.11 1.27-.75 1.84-.17.58.57-.51 1.04-1.5 1.73-.97.69-.91 2.01.76 2.93 1.66.92 3.33.58 4.02.35s1.6-1.33 2.07-.64c.46.7-1.44.93-2.24 1.9-.8.98-.52 2.6 1.09 3.57 1.6.98 4.25.29 4.7-.11.47-.4 1.04-.58 1.39-.23.34.34-.17 1.26-.52 2.07-.34.8-.98 3.16 1.44 4.08 2.41.92 4.6-1.15 5-1.55.4-.4.8-.46 1.15-.29.34.17.17.52-.12.92-.29.4-.92 2.13.8 3.34 1.18.82 2.47.76 3.16.64.36-1.34.83-2.78 1.3-4.8H290c-.23 0-.27.34-.27.48s.07.25-.14.25c-.2 0-.23.12-.53.33-.3.2-.58.46-.74.34-.16-.11.62-.53.83-.78.2-.25.62-.65.65-.92.02-.28.16-.44.57-.78.13-.11.23-.24.31-.36.28-1.34.55-2.92.8-4.82.16-1.29.26-2.5.3-3.64l-.76-.04zm-49.11-35.87c2.57 5.2 6.2 8.12 6.2 8.12s-.48-1.3-.7-2.18c-.2-.89-.04-1.9-.04-1.9s-.91-1.16-2.6-3.75-2.56-6.42-2.56-6.42 1.56 3.83 2.78 5.86c1.21 2.03 2.61 3.69 2.61 3.69s.5-1.8.84-1.9c.35-.08.61.2.91.6.3.39.57.35.57.35s-.42-.85-1.06-1.88c-.29-.47-.71-.97-1-1.45-.97-1.5-3.03-4.38-4.09-7.25-1.06-2.88-3.37-10.09-3.77-12.2-.4-2.12-.8-.96-1.21.6-.4 1.56-.96 3.78-.6 7.1s1.15 7.42 3.72 12.61zm3.32 14.02c.96.7 2.37 1.66 2.37 1.66s-.23-.52-.37-1.14-.2-1.91-.2-1.91l-1.9-1.68a27.83 27.83 0 0 1-3.73-3.98c-1.95-2.42-.38-.97 1.2.76s4.63 4.25 4.63 4.25l.02-.56c.02-.53.18-.9.47-1.27.28-.36.13-.41-1.58-1.72-1.71-1.32-6.15-6.3-7.96-9.28-1.81-2.98-3.77-7.01-3.77-7.01s-.96 5.95 2.66 12.5c3.63 6.56 7.2 8.67 8.16 9.38zm19.02 37.53c1.99-.77 1.44-2.73 1.44-2.76s-1.22.38-2.34.8c-1.12.42-3.87 1.22-4.96 1.25-1.09.03-1.09-.12-1.12-.29-.03-.16.83 0 2.4-.28 1.57-.3 4.32-1.74 4.8-2.06.48-.32.42-.38-.28-.45a3.02 3.02 0 0 1-1.57-.6c-.26-.23-1 .1-2.79.5-1.8.42-5.51 1.07-8.36 1.07s-5.51-.48-5.96-.58c-.45-.1-.93.16.45 2.47 1.38 2.31 6.21 3.56 9.58 3.53 3.36-.04 6.72-1.83 8.71-2.6zm-8.94-4.77c3.47.03 4.76-1 4.76-1s0-.18-.47-.89c-.47-.7-.38-1.9-.38-1.9s-.82.14-2.26.35c-1.44.2-3.12.4-4.97.08s-1.06-.53.4-.35c1.48.18 4.3-.36 5.21-.68.91-.32.53-.62-.08-.82-.62-.2-2.3-1.27-2.3-1.27s-4.2.53-8.11.09c-3.91-.44-6.39-1.44-7.18-1.56s-.76.2-.76.2-.21.36 1.14 2.48c1.35 2.12 4 3.5 6.24 4.15 2.23.65 5.29 1.1 8.76 1.12zm-.89-8.13s-.15-.2-.35-.91c-.2-.71.38-1.24.38-1.24s-.8-.23-3.38-.56c-2.6-.32-2.74-.53-4.33-.88-1.58-.36-2.64-.83-2.61-1s.53.08 1.47.44c.94.35 4.9.76 6.58 1 1.68.23 2.62.41 2.91.23.3-.17 1.33-.44 1.33-.44s-.7-.2-1.59-.35a5.6 5.6 0 0 1-2.15-.86c-.47-.32-.61-.41-2.73-.64-2.12-.24-3.82-.92-7.62-2.3-3.79-1.39-6.64-3.03-7.4-3.65-.77-.62-.71-.18-.5.62.2.8.17 1.8 2.08 4.03 1.91 2.24 2.85 3.21 7.67 4.98 4.83 1.77 10.24 1.53 10.24 1.53zm-14.26-11.75c4.26 3 9.26 4.1 10.32 4.24.24-.28-.26-1.28-.03-1.89.28-.72.74-.73 1.77-.79 1.02-.06.35-.27.11-.27s-.29-.02-2-.47c-1.7-.44-3.44-.7-5.79-1.59-2.35-.88-3.06-1.53-3-1.7.06-.18 1.09.56 3.27 1.38 2.17.82 4.7 1.15 6.08 1.44 1.39.3.18-.3-.47-.68-.64-.38-1.56-1.8-1.56-1.8s-1.53-.26-4.02-1.02a32.52 32.52 0 0 1-6.68-2.8c-.72-.4-1.41-.93-2.16-1.47-1.43-1.02-2.87-2.07-3.43-2.48-.85-.62-.58-.12-.5.27s.68 2.15 2.03 4.1c1.35 1.94 1.8 2.52 6.06 5.53zm-.7-8.45c4.2 3.33 7.82 4.36 8.44 4.62.62.27.56-.09.44-.44-.12-.35-.2-1.5-.2-1.5l-3.18-1.83c-1.68-.97-3.53-2.3-4.77-3.15-1.23-.85-.5-.8-.11-.47.38.32 2.08 1.33 3.79 2.39 1.7 1.06 4.3 2.59 4.3 2.59s.05-.56.4-.91 1.24-.27 1.24-.27-.44-.44-.7-.85c-.27-.42-1.65-.86-3.21-1.6-1.56-.73-4.36-2.79-6.41-4.53a83.89 83.89 0 0 1-6.33-6.45c-.26-.35-.44-.3-.47.15-.03.44-.17.73.27 2.74.44 2 2.3 6.18 6.5 9.51zm14.88-31.47c.48.99 1 1.74 1.38 2.38.56.98.88 1.6.88 1.6s.12-.34.03-.92-.18-1.4-.02-2.36c.08-.52.19-1.04.16-1.5-.03-.52-.2-.97-.28-1.27-.13-.56-.74-3.02-1.03-4.75-.3-1.73-.6-4.2-.59-6.39.03-2.18.34-1.08.34-.02s.11 2.68.45 5.17c.34 2.5 1.4 6.3 1.4 6.3s.06-.58.38-1.41.83-1.78 1.23-2.82c.4-1.03.26-1.2.26-1.2s-1.47-7.07-1.86-10.41a427.64 427.64 0 0 1-1.01-12.12c-2.16 2.18-3.77 7.9-4.05 13.3-.22 4.08.44 7.85.63 9.38.38 3.03.9 5.4 1.7 7.04zm-4.79 11.15c.07-1.6.43-2.81 1.47-3.17 0 0-.92-1.6-1.71-3.88-.55-1.56-1-3.57-1.23-5.1-.56-3.8-1.01-7.7.11-1.3 1.13 6.38 2.49 8.64 2.49 8.64l1.63 2.66c-.24-1.17-.28-1.99-.21-3.26s.22-3 .6-4.37c0 0-1.97-3.96-3.2-8.7s-1.96-9.08-1.98-11.65l-.17-3.45s-2.03 1.53-2.71 9.27c-.68 7.75 1.35 15.15 2.37 17.98 1.02 2.82 2.54 6.33 2.54 6.33zm22.16 59.06s-.32-.22-1.28-.83-.67-2.44-.67-2.44-.26.19-.97.67c-.7.48-1.5 1.03-2.46 1.41s-1.44.65-2.05.84c-.61.19-.45-.07.06-.36.51-.28.68-.44 1.96-.96 1.28-.51 3.84-2.76 3.84-2.76s-.6-.06-1.67-.1-2.4-.57-2.4-.57-1.05.96-5.32 2.79c-4.26 1.83-7.88 2.3-7.88 2.3s.45 2.2 2.5 2.93c1.7.74 4.04 1.19 8.62.1 4.58-1.1 7.72-3.02 7.72-3.02zm5.61 4.37c.35-1.8-.67-3.05-.67-3.05s-.23.13-.87.7c-.64.58-1.57 1.68-3.36 2.57s-2.44.84-.7-.1 4.26-3.56 4.26-3.56l-.68-.25c-.67-.26-1.82.19-6.63 3.08-4.8 2.88-7.62 2.98-7.62 2.98s2.14 2.6 7.97 2.4c5.83-.18 7.95-2.97 8.3-4.77zm11.02-2.09s-.64.9-1.5 1.48-3.18.93-3.18.93-.1.25-.54.83c-.45.58-1.44 1.96-2.47 2.7-1.02.73-2.62 1.21-2.72 1.02s.93-.58 1.92-1.19c1-.6 1.9-1.73 2.56-2.5.68-.77-.28-.64-.28-.64s-1.22.03-2.34-.06c-1.12-.1-.9 0-1.22.54s-.77 1.03-1.6 2c-1.02 1.17-1.98 2.23-2.95 3.39-.64.77-.16 1-.16 1s.29.48 2.88.77c1.6.17 3.34-.03 5.17-1.08 1.13-.66 2.3-1.7 3.49-3 3.1-3.4 2.94-6.19 2.94-6.19zm1.38 7.02c-.64.83-1 1.19-1 1.19s.45-1.38.84-2.02c.2-.35.43-.67.6-.9-.44-.96-.79-2-1.05-3.12-.28.93-1.17 3.64-2.27 5.4-1.35 2.14-2.53 2.92-1.77 3.5.77.57 2.28.7 3.98-.14 1.64-.8 2.11-2.2 2.34-3.34-.28-.45-.55-.91-.8-1.4-.22.13-.52.38-.87.83z'/%3e%3cellipse cx='289.34' cy='105.75' fill='%23d4af3a' rx='1.19' ry='1.09'/%3e%3cpath fill='%23d4af3a' d='M286.83 103.69c1.09-.03 1.67-.54 2.87-.42 1.42.13 3.34.96 5.67 2.2a9.7 9.7 0 0 0 6.55.57c.65-.19 1.3-.54 1.91-.9 2.84-1.6 2.15-4.76 2.15-4.76a11.12 11.12 0 0 1-7.09 2.15s.19.14.6.55c.41.42 1.16.9.91 1.1-.24.21-1.28-.78-2.14-1.42a12.92 12.92 0 0 0-4.35-2.15c-2.2-.65-4.66-.7-6.3.22-1.66.92-1.8 2.07-1.56 2.53.12.26.43.34.78.33zm30.81 23.11c-.5-.14-1.37-.28-2.51-1.33a47.76 47.76 0 0 1-4.21-4.63c-.32-.55-.19-1.06.6-1.38.77-.32 1.32-1.33 1.32-1.33s-1.7-.64-2.83-1.47c-1.15-.82-3.8-3.2-4.17-3.8s-.18-.7.37-.87c.55-.19.69-.56.69-.56s-1.24-.77-2.38-1.7c-1.14-.9-2.7-2.42-2.7-2.42-1.71.69-4.4.4-5.85.14-2.56-.46-4.44-1.52-4.44-1.52s-.09.41-.4 1.2c-.33.77-1.52 1.23-2.7.45-1.2-.78-.92-2.47-.92-2.47s-.96-.6-2.93-1.33-3.56-.83-5.16-.1c-1.6.74-2.38 2.94-2.38 4.6 0 1.64.87.95 1.05.72.18-.23.55-1.42 2.56-1.74 2.01-.32 3.84.64 6.13 2.52 2.28 1.88 2.79 2.02 3.93 3.21 1.14 1.2.23 1.84-1.74 2.48s-4.48-.64-4.57-.6c-.38.2.85 1.94 2.54 2.6 1.7.66 3.87.24 5.55-.44 1.15-.46 1.36.02 1.7.37 1.85 1.95 2.33 3.78 2.65 6a2.7 2.7 0 0 0 1.73-2.01c.07-.37.19-1.2.83-.6.64.6 1.14 3.9 1.14 5.41s-.46 3.54-.46 3.54l.46-.05c.28-.05.82-.37 1.55-.78.74-.41.78.05.78.87s.28 2.39 1.37 5.18 2.7 3.72 2.7 3.72.32-.55.64-1.65c.32-1.1.55-3.26.55-5.14s-.5-5.92-.5-5.92 2.29 2.8 4.66 3.5c2.38.68 4.76.27 5.76-.88s.1-1.65-.41-1.79z'/%3e%3cpath fill='%23d4af3a' d='M302 134.04s-.72 1.6-1.12 2.17-.56.65-.56.65.72.62 1.77.94c1.05.33 1.99.53 1.99.53s-1.18-1.62-1.6-2.76c-.41-1.14-.48-1.53-.48-1.53zm14.28-.94c-.35-.9-.57-1.4-.57-1.4-1.46.3-4.23-.4-5.43-1.12 0 0 1.1 2.23 2.2 3 1.09.77 1.24.81 1.24.81s-1.1.18-2.56-1.27c-1.47-1.44-2.13-3.1-2.13-3.1s.33 3.85-.26 6.2-.72 2.68-.72 2.68 3.1.55 6.57-.42c3.45-.96 3.72-1.27 3.72-1.27s.41-.1-.13-.83a18.68 18.68 0 0 1-1.93-3.28z'/%3e%3cpath fill='%23b96b29' d='M310 124.64c-1.06-1.22-1.17-1.52-1.17-1.52s-.37.38-.05.9a11.1 11.1 0 0 0 2.87 2.45 7.4 7.4 0 0 0 2.07.77l-.05-.2s-2.6-1.18-3.67-2.4zm-4.22 8.03s-.27-4.84-.27-5.56-.45-.53-.45-.53l-.53.24 1.04 7.08c.11.76.49.7.68.66-.38-.2-.45-1.67-.47-1.89zm-6.53-20.95c-.4-.4-1.28-.69-.43.26.86.96 1.98 2.14 2.3 3.13.34.99.53 2.2-.03 1.94-.56-.26-.95-.26-1.54-.75a9.86 9.86 0 0 0-2.18-1.45c-.46-.13-1.28 0-.62.72.66.73 1.38 1.42 2.63 2.34 1.25.92 1.98 1.31 2.64 1.78.65.46 1.31.85 1.31.85s-.6-3.95-1.68-5.7-2-2.72-2.4-3.12zm-21.34 66.15c-.8.6-1.85.86-1.85.86s-.5-.03-.5.16.58 0 1.19-.1c.6-.12 1.44-.73 1.74-.95.3-.22.75-.5.6-.88-.13-.4-.38.3-1.18.91zm6.89 3.69c-.17.2-1.5 1.19-1.5 1.19s-.4.28-.85.44c-.44.17-.55.42-.55.42s.08.1.55-.03c.47-.14 1.85-1.1 2.3-1.5.44-.38.63-.5.47-.66-.17-.16-.25-.05-.42.14zm-27.93-49.63c.25.3.55.71.69.58.14-.14-.03-.28-.36-.66-.33-.39-.52-.58-.52-.58s-.47-.75-.75-1.02c-.27-.28-.68-.42-.16.22.52.63.85 1.16 1.1 1.46zm-2.12 4.65c.3.28.58.52.9.88s.59.74.78.55c.19-.2-.5-.6-.8-.99-.3-.39-.55-.63-.94-.94s-.85-.55-.85-.55.6.78.91 1.05zm.79 7.51c.53.55 1.3.72 1.41.5.11-.22-.06-.4-.5-.62-.43-.22-1.15-.69-1.5-.94a7.61 7.61 0 0 1-.97-.77c-.25-.25-.54-.47-.63-.38-.1.08.73.96.97 1.1.25.14.7.56 1.22 1.11zm1.52 6.01c0-.22.05-.33-.39-.36-.44-.03-1.05-.1-1.05-.1s-.86-.34-.91-.18c-.06.17.72.5 1.05.56.33.05.75.16.94.27.2.11.36.03.36-.19zm.66 6.53c-.94 0-1.74-.22-1.8-.08s.45.36.92.52c.47.17 1.35.22 1.96.25s.72-.1.7-.41c-.04-.3-.84-.28-1.78-.28zm7.36 7.15c-.14-.14-.47-.03-1 .08-.52.11-1.38.28-1.88.25s-1.57-.05-1.57-.05l-.61.14c0 .14.8.1 1.96.25 1.16.13 1.94-.11 2.5-.2.54-.08.74-.33.6-.47zm3.04 5.09c-.58.22-1 .28-1.44.28-.44 0-1.5.19-1.5.19s-.49.06-.4.25c.08.2.24 0 .68-.06.45-.05.78 0 1.55-.02.78-.03 1.22-.23 1.69-.3.47-.1 1-.34.75-.65-.25-.3-.75.09-1.33.31zm5.92 3.85c-.33.33-1.6 1.2-1.6 1.2s-.25.19-.75.43-.47.37-.39.5.39-.2.67-.3 1.18-.72 1.65-1.1c.47-.4 1.08-.7.97-.98-.1-.28-.22-.08-.55.25zm-9.85-49.85s.11.25 1.13 1.53c1.02 1.28.48.07.22-.25-.26-.33-1.75-2.45-2.26-3.03-.51-.59-.59-.3-.33.07.26.37 1.24 1.68 1.24 1.68zm-2.15 6.56c.15-.15-.18-.3-.77-1.02l-1.75-2.23s-.33-.69-.43-.62c-.11.08.4 1.17.87 1.65.48.47 1.1 1.38 1.42 1.78s.51.59.66.44zm2.83 12.3c0-.36-1.16-.3-1.68-.41l-1.46-.3s-1.1-.2-1.12-.06c-.03.13.22.27.82.38.6.11 1.51.39 2.2.5s1.24.25 1.24-.11zm-2.83-6.64c.77.62 1.28.91 1.68 1.13.4.22.73.55.95.3.22-.26-.19-.45-.84-.74-.66-.29-.99-.54-.99-.54l-.7-.37c-.32-.18-.87-.4-.1.22zm6.6-4.38c-.47-.4-.88-.62-.88-.62s-.58-.55-.69-.37c-.1.19.66.73 1.02 1.06.37.33 1.02 1.28 1.35 1.1.33-.19-.33-.77-.8-1.17zm-4.31 17.14-1.05.28c-.41.1-.44.3.3.3s1.06-.2 1.8-.33c.75-.14 1-.22.89-.47-.11-.25-.5-.17-.8-.08l-1.14.3zm1.16 6.21c-.06.14.53 0 .91-.14.39-.14 1.2-.55 1.66-.69.47-.14.47-.22.47-.5 0-.27-.5-.05-1.1.14-.61.2-1.39.8-1.39.8s-.5.25-.55.39zm7.99 3.76c.55-.33.67-.58.47-.75-.2-.16-.36-.14-.8.22-.44.36-1.3.97-1.3.97s-.44.17-.77.34-.75.44-.64.6c.1.17.8 0 1.16-.3.36-.3 1.33-.75 1.88-1.08zm3.77 4.99c.22-.2.88-.41 1.19-.64.3-.22.5-.88.25-.97s-.39.28-.91.67c-.53.39-2.33 1.58-2.33 1.58l-.47.19c-.5.2-.27.33.14.28.42-.06.7-.06 1.19-.44.5-.4.72-.48.94-.67zm5.58 4.73c.47-.2 1.16-.8 1.5-1.1.33-.31.74-.7.5-.9-.26-.19-.53.06-.92.42s-1.41 1.44-1.41 1.44-.14.03-.7.47c-.55.44.04.36.23.17.2-.2.33-.3.8-.5z'/%3e%3cpath fill='%23d4af3a' d='m305.58 96.59 2.25-1.6-2.65-.68-1.7 1.36z'/%3e%3cellipse cx='312.78' cy='94.72' fill='%23b96b29' rx='2.15' ry='2.07'/%3e%3cellipse cx='312.78' cy='94.28' fill='%23d4af3a' rx='1.29' ry='1.24'/%3e%3cpath fill='%23d4af3a' d='M308.3 87.6c.55.21 1.27.12 1.27.12s.22-.95-.3-1.41c-.53-.47-1-.8-1.32-1.1l-.38-.42s0 .82-.04 1.34c-.04.51.22 1.27.77 1.48z'/%3e%3cellipse cx='309.44' cy='88.65' fill='%23d4af3a' rx='.39' ry='.37'/%3e%3cpath fill='%23d4af3a' d='M306.51 88.25c-.17.23-.53.6-.53.6s.44.02.8.27c.36.26.82.48 1.24.43.43-.05.6-.45.52-.74-.1-.28-.3-.57-.99-.83-.7-.26-.87.04-1.04.27z'/%3e%3cpath fill='%23d4af3a' d='M308.01 90.76c-1.35.12-3.13-1.37-3.13-1.37-.17 1.2-.9 1.81-2.04 2.04l.1.05s1.06.54 2.3.73c.57.09 1.07 0 1.67-.13a7.06 7.06 0 0 0 2-.63c.81-.5.57-1.8.57-1.8s-.12.98-1.47 1.1zm-5.25-1.36c-.55-.2-1.38-.6-1.73-.62-.34-.02-.85-.1-.76.54.09.64.74.95 1.38.97.64.02.97-.23 1.35-.42.38-.19.31-.26-.24-.47zm-4.22-2.29c-.6-.43-1.14-.55-1.14-.55s-.4 1.04-.17 1.68c.22.65.69.82 1.26.8.57-.02 1.42-.31 1.17-.75a3.38 3.38 0 0 0-1.12-1.18z'/%3e%3cellipse cx='299.09' cy='90.04' fill='%23d4af3a' rx='.47' ry='.34'/%3e%3cpath fill='%23d4af3a' d='M300.38 84.86c-.37-1.77-.31-3.7 1.37-6.16 1.68-2.46 4.6-3.45 4.6-3.45s.1-.2 1.03-1.19c.94-1 2.84-2.24 2.84-2.24s-2.2.55-3.46.95v.06c0 .85-.67 1.54-1.5 1.54-.33 0-.62-.1-.87-.27-.68.13-2.94 1.49-3.52 1.97.14.23.23.51.23.81 0 .85-.68 1.54-1.51 1.54-.25 0-.49-.06-.7-.17l-.19.33c-.47.87-.82 1.7-1.08 2.48.38.26.64.76.64 1.33 0 .85-.57 1.53-1.28 1.54-.05.5-.04.85-.02 1 .06.5.25.8 1.12 1.06.87.24 2.05 1.77 2.05 1.77.09 0 .7-1.12.25-2.9z'/%3e%3cpath fill='%23d4af3a' d='M305.74 73.5c.32-.25.37-.65.12-.87-.25-.23-.71-.2-1.03.06-.31.26-.37.65-.12.88.25.22.71.2 1.03-.06zm-5.64 3.82c.36-.33.42-.82.14-1.1-.29-.3-.8-.26-1.17.07-.35.32-.41.82-.13 1.1.28.29.8.25 1.16-.07z'/%3e%3cellipse cx='296.74' cy='82.11' fill='%23d4af3a' rx='.87' ry='.86'/%3e%3cpath fill='%23d4af3a' d='M315.54 70.02c-.45.1-1.29.37-2.54 1.02h.02c.87 0 1.55.56 1.55 1.28s-.8 1.5-1.66 1.5-1.46-.75-1.46-1.47c0-.17.04-.34.11-.49l-1.19.77c-2.77 1.87-3.42 2.77-4.8 5.33-1.36 2.55-1.86 5.35-1.27 7 .6 1.65 2.77 2 2.8 2s-.25-.26-.28-.57c-.03-.31.07-.47.16-1.09.1-.62.03-1.37.03-1.37s.5-.06.78.28c.28.35.68.75.96 1.1.28.33 1.03.99 1.03.99s.44-.63.44-1.37c0-.75-.5-1.56-.6-2.87s.6-3.64 1.87-5.35a15.05 15.05 0 0 1 4.39-3.61c.72-.34.84-.87.87-1.18.03-.32.1-.53.16-1.31s-.65-.75-1.37-.6z'/%3e%3cpath fill='%23d4af3a' d='M312.79 72.97c.49 0 .94-.44.94-.84 0-.4-.39-.72-.88-.72s-.88.33-.88.73.33.83.82.83zm4.12 16.28c.67.27 1.42.12 1.78-.12.35-.24.47-.84.05-1.19a1.34 1.34 0 0 0-1.43-.12c-.39.22-1.26.84-1.26.84s.2.32.86.59z'/%3e%3cpath fill='%23d4af3a' d='M319.05 90c-.24.37-.42.6-1.16.63s-1.55-.02-2.03-.5c-.49-.49-.82-1.17-.82-1.17l-.84-.01s-.28 1.16-.65 1.48c-.37.33-1.66.38-2.22-.04s-1.08-.94-1.18-.88 0 .49.58.99.98.8 1.92.8h5.32s1.08.07 1.39-.58c.3-.64.32-1.05.17-1.2-.14-.17-.24.1-.48.48z'/%3e%3cpath fill='%23d4af3a' d='M310.96 89.1c.8.44 1.24.17 1.53-.19.3-.35.34-.51.34-.51s-.75-.28-1.12-.5c-.36-.2-.61-.41-.98-.37-.36.05-.42.1-.42.1s-.15 1.02.65 1.47z'/%3e%3cellipse cx='307.11' cy='81.24' fill='%23b96b29' rx='1.77' ry='1.76'/%3e%3cpath fill='%23b96b29' d='M310.19 75.14c-.71-.47-1.75-.28-2.33.43-.58.72-.47 1.68.24 2.16.71.48 1.76.29 2.34-.43.57-.7.46-1.68-.25-2.16z'/%3e%3cellipse cx='307.04' cy='81.01' fill='%23d4af3a' rx='1.03' ry='.98'/%3e%3cpath fill='%23d4af3a' d='M309.45 75.34c-.46-.13-1.02.1-1.26.5s.01.83.62.96c1.12.22 1.66-1.18.64-1.46z'/%3e%3c/g%3e%3cpath fill='%23D4AF3A' d='M282.34 212.67s-2.74 1.31-3.61 1.54c-.87.24-1.07.24-1.07.24s-1.87 1.7-3.25 2.51c-1.44.85-3.09 1.47-4.74 1.65-2.14.23-8.03.16-10.67.06s-4.28.54-5.42 1.82c-1.13 1.27-1.4 3.11.04 4.52s3.04.7 3.57-.16c.54-.88.27-1.98.04-2.49-.24-.5.47-.67 1.2-.7.74-.03 1.98.07 3.11.23 1.14.17 3.15.84 4.02 1.31.87.47.36.54-.24.44s-1.27-.34-2.34-.74a9.28 9.28 0 0 0-2.64-.64c-.67-.03-.44.34-.3.57.13.24.5.8.6 1.08.1.27-.2 1.27-.2 1.27l.33.64s.4-.64.54-.97c.13-.34-.04-.98.1-1.28s.7-.3 1.14.2c.43.5.93 1.11 1.17 2.38.23 1.28-.2 2.18-.2 2.18s.53.44.63.74c.1.3-.13 1.51-.13 1.51s.36.24.7-.47c.33-.7.73-1.94.83-2.38.1-.44.4-1.24.94-.64s.9 1.34 1 1.71c.1.37.1.67.1.67s1.2-1.17 1.6-1.84 1.25-1.68 2.38-2.62c1.14-.94 3.11-2.81 4.08-3.45.97-.64 3.45-1.98 4.22-2.45s.9-.5 1.03-1.81c.14-1.31.77-2.48 1.07-3.39.3-.9.36-1.24.36-1.24zm-43.85-49.15c-.02-.22-.47-1-.58-1.4-.11-.4-.51-.16-.51-.16s-.87.49-1.52.67-.73-.07-.8-.4c-.07-.34-.22-1.4-.34-2.13-.1-.74-.26-.7-.53-.58-.27.11-1.07.4-1.63.65-.55.24-.38.51-.2.82.18.32.83 1.64 1.12 2.1.29.48.02.68-.32.83-.33.16-.82.23-1.49.45s-.62.38-.56.6c.07.23.52 1.15.76 1.57.25.42.47.13.47.13s.71-.64 1.31-.94c.6-.28.65-.2.8.25.16.45.85 2.8.99 3.24.13.45.35.4.67.27.3-.13.73-.2 1.09-.31.35-.11.49-.83.49-.83s-1.32-2.37-1.67-2.97c-.36-.6 0-.74.26-.78.27-.05 1.05-.16 1.72-.32.66-.17.48-.55.46-.78zm14.86 64.38c-.1-.57 0-1.14-.43-1.58a5.4 5.4 0 0 1-1.17-2c-.2-.71.16-1.05.1-1.45-.07-.4-.6-.4-1.14.03-.54.44-1.24.84-1.24 2.11 0 1.28.47 2.79 2.24 3.32 1.77.54 1.74.14 1.64-.43zm1.8-.61s-.37-.23-.54.1-.13.5.34 1.24.77.9 1.3 1.24c.54.34.17-.33.1-.53-.06-.2 0-.47-.13-.64-.13-.17-.2-.37-.2-.9 0-.54-.87-.5-.87-.5z'/%3e%3cpath fill='%23D4AF3A' d='M257.32 233.33c.33-.5.64-.64 1.44-1s2.27-.58 2.77-.61c.5-.03 1.64-1 1.47-2.01-.16-1.01-.9-1.41-1.54-1.55s-1.2-.13-1.4.17c-.2.3-.57.7-1.27.94s-.8.47-1.24.6c-.43.14-.1.4-.47.7-.36.31-.86 0-1.43-.16-.57-.17-.6-.27-1.24-.3l-2.3-.14s-.07-.03-.44-.03-.4.07-.57.47c-.17.4.03 1.41.44 1.91.4.5 1.7.74 2.57 1 .87.28 1.3.38 2.04.51.76.13.86 0 1.2-.5zm8.13.8c.7-.47.3-1.27.13-1.78-.16-.5-1.13-.6-1.63-.6s-.77 0-1.04.23c-.27.24-.64.57-1.37.8-.74.24-1.3.51-2.31.91-1 .4-1.3 1.08-1.74 1.35-.43.26-1.27 0-1.27 0s-.6-.17-.8 0c-.2.16 0 .5.4.93.4.44 1.17.4 2.04.68.87.26 1.04.06 1.37-.17.33-.24.6-.74 1.2-1.1.6-.38 1.91-.44 2.55-.51a6.15 6.15 0 0 0 2.49-.74zm0-3.05c.3.27.64.64.9.2.27-.43.7-1.34.4-1.88-.3-.53-.66-1-.66-1s-.5 1.54-.74 1.94c-.22.41-.19.47.11.74zm-2.71-4.63c0-.87-.6-1.95-.6-1.95s-.2.8-.57 1.51c-.37.7-.74 1.08-.74 1.08s.87.23 1.2.23.72.01.72-.86zm-5.01 1.85c.94-.2 1.44-.57 1.84-.9s.64-1.25.37-1.71c-.27-.48-.94-.98-1.2-.98h-.5s-.28.87-.64 1.31c-.37.44-.8.74-.77 1.3.03.57-.04 1.17.9.97zm1.9-4.26a1.6 1.6 0 0 0-.43-1.2l-.5-.5s-.07.66-.14 1.03-.1.44-.1.44.27.27.5.37c.23.09.63.3.66-.14zm-11.56-23.79.63-3.95c-.47-3.95-2.53-7.7-4.16-10.28a49.03 49.03 0 0 1-4.06-8.8 24.93 24.93 0 0 1-1.23-6.66c0-1.55.66-2.35.66-2.35s.29-.42.02-.69c-.26-.26-.68-.02-1.1.4s-.86 1.2-1.04 1.75c-.17.56-.17.75-.17.75s-.84-.2-2.19-.08c-1.34.1-1.98.22-2.03.5-.04.3.18.51 1.15.93.97.42 1.59.6 2.07 1.18.49.57 1.73 3.46 2.1 4.86.39 1.4 1.2 5.18 1.53 8.15s1.33 6.57 2.73 9.57c.46.99 2.97 5.67 5.09 4.73zm2.45 6.96c-.92.51-.88 4.25-.47 6.19.4 1.94 2.3 4.35 2.88 5 .57.64.7.64 1.01.47.31-.17.44-.17.44-.17s.82-.27 1.43-.74c.6-.48.37-1.67.27-2.73-.1-1.05-.92-3.16-2.4-5.6-1.49-2.46-2.24-2.94-3.15-2.43zm1.01-3.03c0-1.22-1.06-2.14-2.27-2.14a2.1 2.1 0 0 0-1.4.43c-1.23 1.1-.49 3.89 1.3 3.89.64 0 1.4-.11 1.86-.56.42-.39.51-1.04.51-1.62zm17.68 35.14c-.49-.09-.77-.28-1.5-.77-.7-.49-1.86-1.5-2.06-1.98-.2-.5-.2-.52-.89-.29-.69.23-1.66.2-2.4.23-.75.03.08.86.6 1.64.51.77.34 3.38.34 3.38s0 .23-.12.6c-.11.38-.03.64.17.72.2.09.32-.08.84-.69.51-.6 1.46-2.18 1.46-2.18l.95.23c.8.2 2.1.09 2.75-.11.68-.2.36-.7-.13-.78z'/%3e%3cpath fill='%23D4AF3A' d='M266.14 241.34c-.34-.06-.49-.09-.66.14-.17.23-.32.66-.4.9-.09.22-.06.42.14.6.2.17.5.37.5.37s.28.31.57.46c.28.14.34-.29.34-.6 0-.32.17-.9.17-1.27s-.3-.55-.65-.6z'/%3e%3cpath fill='%231D5E91' d='M396.62 216.11c-.84-.2-1.2-.52-1.2-.52s-.35-.04-.64.48c-.27.52-1.35 1.2-1.35 1.2s-1.51.4-1.72 1.43c-.2 1.04.52 1.4 1.24 1.28.72-.12 2.48-.48 3.23-1.4.76-.91.88-1.43 1.04-1.8.14-.34.23-.46-.61-.66zm2.35-8.26c-.55-2.3-2.03-5.16-4.9-6.58 0 0-1.08 3.79-1.4 4.98-.32 1.2-.32 1.16.6 1.4.91.24 3.86.88 4.46 1.04s1.6.67 1.24-.85zm-13.68-2.15c.68.12.6-.16.84-1.08l1.43-5.46s-3.03-.12-5.66 1.16c-2.63 1.27-3.79 3.62-3.79 3.62s.68.28 2.48.68c1.8.4 4.03.95 4.7 1.07zm-7.02 6.26c-1.07-.2-1.48-.32-1.48-.32s.68 2.6 1.8 4.03c1.12 1.44 2.35 2.15 4.67 2.2 2.3.03 4.06-1.24 4.34-2.24.28-1 .76-1.75.76-1.75s-4.19-.56-5.9-.96c-1.74-.4-3.13-.76-4.21-.96z'/%3e%3cpath fill='%23D4AF3A' d='M377.55 210.32c1.04.24 9.57 1.87 10.29 2.03.72.16 1.32.32 1.52.12.2-.2.32-.32 1.07-.6.76-.27.72-1.03.72-1.03s.2-.72.28-1.44c.08-.72.48-.96 1.32-.08.83.88 1 2.15 1.15 3.4.16 1.23 2.12 1.55 2.87 1.67.76.12 1.12-.12 1.56-.84.44-.72.68-2.15.8-3.07.12-.92.04-.84-.92-1.08-.96-.24-5.38-1.23-6.18-1.44-.8-.2-.64-.71-.52-1.27s1.87-6.18 1.87-6.18c-1.25-.78-3-1.24-5.1-1.48 0 0-1.28 5.74-1.52 6.62-.24.88-.8.88-1.71.72-.92-.16-7.54-1.71-7.54-1.71l-.52 1.23c-.52 1.24-.76 2.71-.76 3.47s.27.74 1.3.97z'/%3e%3cpath fill='%23D4AF3A' d='M400.2 215.51c-.88-.57-1.53-.73-1.99.34-.45 1.07-.5 2.64-1.64 3.75-1.14 1.11-2.75 2.26-4.35 2.14-1.6-.11-2.52-.5-2.14-2.33.38-1.83 2.83-2.4 3.4-3.36s.42-2.07-.42-2.8c-.84-.72-2.06-.88-2.4-.65a5.29 5.29 0 0 0-1.84 2.45c-.5 1.38-.8 2.49-1.87 3.37a8.1 8.1 0 0 1-5.96 1.26c-2.13-.5-2.9-1.15-3.7-3.25-.8-2.1-1.76-5.58-2.18-5.97-.42-.38-.95-.69-1.87-.04-.91.65-.99 1.61-1.1 2.38-.12.76 0 1.64.91 2.75.92 1.1 1.87 2.22 2.22 3.36.34 1.15 1.37 2.91-.08 2.99-1.45.07-2.1.11-3.2-.96-1.11-1.07-5.43-4.02-6.61-4.97-1.19-.96-1.68-1.26-1.68-1.26-2-.04-4-.86-6-2.22 0 0 1.15 2.94 1.38 4.05.23 1.11.19 1.72.19 1.72s4.35 2.22 6.07 3.06c1.72.84 5.2 2.83 6.87 3.86 1.68 1.04 3.1 2.64 6.07 2.03 2.98-.61 9.01-2.45 10.96-3.02 1.95-.57 7.33-1.91 9.32-3.29s2.17-1.3 2.52-2.68c.34-1.35 0-2.1-.88-2.69zm-11.49-20.59c.33-.04.46-.09 1.48-.22 1.02-.14.64.84.46 1.21-.17.38-.48 1.13-.9 1.84-.42.7.13.82.42.93.28.11.7.15 1.52.38.82.22.66-.38.69-.69.02-.31.06-1.93.15-2.5.09-.57.62-.42.82-.3l1.12.6c.42.23.62-.01.7-.26s.3-.68.47-1.32c.18-.64-.22-.51-.62-.51s-.97 0-1.63-.02c-.66-.02-.24-.67-.24-.67L394 192c.37-.6.24-.68-.14-.8l-1.87-.46c-.33-.09-.49-.04-.49.18s-.04 1.37-.04 1.81c0 .44-.04.7-.62.73-.57.02-.93-.31-1.39-.82-.46-.5-.66-.3-.7-.1-.05.19-.43 1.65-.52 2.05-.1.39.11.37.44.32zm3.2 14.49s-.04 1.16-.16 1.55c-.12.4-.4 1 .08 1.16.48.16.92.36 1.2.28.28-.08.15-.64 0-1.11a4.27 4.27 0 0 0-.76-1.48l-.35-.4zm7.02 4.62c.16.36.48.44.72.52.24.08.56.08.56-.36s.08-1-.28-1.48c-.36-.48-.55-.82-.76-.12-.2.72-.4 1.1-.24 1.44zm-24.45-4.66c.2.04.96.28.96.28s0-1.12.16-1.88c.15-.75.47-1.27.2-1.27s-.44.24-.64.56c-.2.31-.76.4-.96 1.31-.2.91.08.95.28 1z'/%3e%3ccircle cx='379.27' cy='207.45' r='1.56' fill='%23B96B29'/%3e%3ccircle cx='383.65' cy='208.53' r='1.59' fill='%23B96B29'/%3e%3ccircle cx='396.42' cy='211.24' r='1.6' fill='%23B96B29'/%3e%3ccircle cx='388.04' cy='209.57' r='1.6' fill='%23B96B29'/%3e%3ccircle cx='389.2' cy='205.74' r='1.6' fill='%23B96B29'/%3e%3ccircle cx='390.32' cy='201.91' r='1.6' fill='%23B96B29'/%3e%3ccircle cx='379.38' cy='207.3' r='.78' fill='%23D4AF3A'/%3e%3ccircle cx='383.77' cy='208.37' r='.8' fill='%23D4AF3A'/%3e%3ccircle cx='396.54' cy='211.08' r='.8' fill='%23D4AF3A'/%3e%3ccircle cx='388.16' cy='209.41' r='.8' fill='%23D4AF3A'/%3e%3ccircle cx='389.32' cy='205.58' r='.8' fill='%23D4AF3A'/%3e%3ccircle cx='390.44' cy='201.75' r='.8' fill='%23D4AF3A'/%3e%3cuse xlink:href='%23a' width='640' height='320' transform='matrix(-1 0 0 1 639.97 0)'/%3e%3c/svg%3e";
            },
            82: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3cpath fill='%23ED2939' d='M0 0h900v600H0z'/%3e%3cpath fill='%23fff' d='M0 0h600v600H0z'/%3e%3cpath fill='%23002395' d='M0 0h300v600H0z'/%3e%3c/svg%3e";
            },
            3675: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3cpath fill='%23007E3A' d='M0 0h900v600H0z'/%3e%3cpath fill='%23FC3D32' d='M0 0h900v300H0z'/%3e%3cpath fill='%23FFF' d='M0 0h300v600H0z'/%3e%3c/svg%3e";
            },
            8562: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 570 300'%3e%3cpath fill='%23003893' d='M0 0h570v300H0z'/%3e%3cpath fill='%23fff' d='M0 295.2V288L570 35v87.4z'/%3e%3cpath fill='%23dd7500' d='M0 290.4v-4.8L570 4.8v58.8z'/%3e%3cg fill='%23fff' transform='translate(109.536 109.536)'%3e%3cg id='b'%3e%3cpath d='M0-93 5.59 0H-5.59z'/%3e%3cpath id='a' d='M0-66.588 6.824 0H-6.824z' transform='rotate(15)'/%3e%3cuse xlink:href='%23a' transform='rotate(15)'/%3e%3cuse xlink:href='%23a' transform='rotate(30)'/%3e%3cuse xlink:href='%23a' transform='rotate(45)'/%3e%3cuse xlink:href='%23a' transform='rotate(60)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(90)'/%3e%3cuse xlink:href='%23b' transform='rotate(180)'/%3e%3cuse xlink:href='%23b' transform='rotate(270)'/%3e%3c/g%3e%3c/svg%3e";
            },
            8006: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 56 28'%3e%3cpath fill='%23d20000' d='M0 0h56v28H0z'/%3e%3cg fill='%23ffe600'%3e%3cpath d='M0 0h8.4L28 13.5 47.6 0H56L0 28h8.4L28 14.5 47.6 28H56zm56 11.2v5.6L0 11.2v5.6zM25.2 0 28 12l2.8-12zm0 28L28 16l2.8 12z'/%3e%3ccircle cx='28' cy='14' r='4.5' stroke='%23d20000'/%3e%3c/g%3e%3c/svg%3e";
            },
            3692: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 300'%3e%3cpath fill='%23CE1126' d='M0 0h450v300H0z'/%3e%3cpath fill='%23FCD116' d='M0 0h300v300H0z'/%3e%3cpath fill='%2314B53A' d='M0 0h150v300H0z'/%3e%3c/svg%3e";
            },
            9086: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 18 12'%3e%3cpath fill='%23FECB00' d='M0 0h18v6H0z'/%3e%3cpath fill='%23EA2839' d='M0 6h18v6H0z'/%3e%3cpath fill='%2334B233' d='M0 4h18v4H0z'/%3e%3cg transform='translate(9 6.422) scale(4.422)'%3e%3cpath id='a' fill='%23FFF' d='M-.325 0 0-1l.325 1z'/%3e%3cuse xlink:href='%23a' transform='rotate(-144)'/%3e%3cuse xlink:href='%23a' transform='rotate(-72)'/%3e%3cuse xlink:href='%23a' transform='rotate(72)'/%3e%3cuse xlink:href='%23a' transform='rotate(144)'/%3e%3c/g%3e%3c/svg%3e";
            },
            4158: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4800 2400'%3e%3cg fill='%23f9cf02'%3e%3cg transform='scale(5)'%3e%3cpath fill='%23c4272f' d='M0 0h960v480H0z'/%3e%3cpath fill='%23015197' d='M320 0h320v480H320z'/%3e%3ccircle cx='160' cy='164' r='44'/%3e%3ccircle cx='160' cy='144' r='48' fill='%23c4272f'/%3e%3ccircle cx='160' cy='152' r='32'/%3e%3cpath d='M140 92a20 20 0 0 0 40 0c0-8-5-9-5-12s3-7-3-12c3 5-2 6-2 11s2 5 2 9a4 4 0 0 1-8 0c0-4 4-8 4-14s-1-8-4-13-8-9-4-13c-6 2-3 10-3 15s-4 8-4 14 3 7 3 11a4 4 0 0 1-8 0c0-4 2-4 2-9s-5-6-2-11c-6 5-3 9-3 12s-5 4-5 12ZM72 216v192h40V216Zm136 0v192h40V216Zm-88 32v16h80v-16Zm0 112v16h80v-16Zm0-144h80l-40 24Zm0 168h80l-40 24Z'/%3e%3c/g%3e%3cg stroke='%23c4272f' stroke-width='24'%3e%3ccircle cx='800' cy='1560' r='212'/%3e%3cpath fill='none' d='M800 1348a106 106 0 0 1 0 212 106 106 0 0 0 0 212'/%3e%3c/g%3e%3c/g%3e%3cg fill='%23c4272f'%3e%3ccircle cx='800' cy='1454' r='40'/%3e%3ccircle cx='800' cy='1666' r='40'/%3e%3c/g%3e%3c/svg%3e";
            },
            2914: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 660 440'%3e%3cpath fill='%2300785E' d='M0 0h660v440H0z'/%3e%3cpath fill='%23FBD116' d='m330 82.958-14.208 43.735 37.203-27.027h-45.99l37.203 27.027z'/%3e%3cg id='a'%3e%3cpath fill='%23FFF' d='M330 303.99h-93.937c-1.184-1.2-2.35-2.423-3.488-3.667H330a1.962 1.962 0 0 1 1.306 1.736A1.968 1.968 0 0 1 330 303.99zm0-28.725c.545-1.114 1.607-3.694 1.125-6.921a11.356 11.356 0 0 0-1.125-3.492c-5.271 4.988-15.175 12.981-29.785 17.401a74.286 74.286 0 0 1-21.548 3.173h-57.872a132.363 132.363 0 0 0 5.364 7.333h55.945c18.242.001 34.954-6.58 47.896-17.494zm-100.461-22.637a29.595 29.595 0 0 1-8.887 1.926c13.629 15.415 33.545 25.144 55.723 25.144 21.066 0 40.091-8.775 53.625-22.867a404.194 404.194 0 0 0 4.167-53.998A404.18 404.18 0 0 0 330 140.801c-6.045 5.419-17.371 17.128-22.71 35.079a74.291 74.291 0 0 0-3.072 21.203c0 15.291 4.623 29.506 12.547 41.329-9.731-12.57-15.526-28.338-15.526-45.454 0-11.369 2.558-22.144 7.126-31.783a29.782 29.782 0 0 1-6.904-11.902c-6.121 10.804-9.618 23.284-9.618 36.581 0 16.539 5.409 31.819 14.552 44.172-15.923-16.693-38.377-27.099-63.25-27.099-1.336 0-2.667.034-3.989.093a29.924 29.924 0 0 1 6.188 8.157c24.742.038 47.078 10.377 62.964 26.949-15.171-12.672-34.698-20.303-55.995-20.303-11.902 0-23.25 2.382-33.594 6.696 10.629 28.085 37.78 48.075 69.574 48.075 2.059 0 4.1-.093 6.116-.258a74.7 74.7 0 0 1-13.22 1.174c-20.061 0-38.269-7.956-51.65-20.882zM330 334.01h-48.684c15.067 5.988 31.492 9.281 48.684 9.281a10.003 10.003 0 0 0 1.146-4.542A10.016 10.016 0 0 0 330 334.01zm0-22.458h-85.83a132.307 132.307 0 0 0 7.169 5.729H330c.197-.201 1.167-1.236 1.167-2.865s-.97-2.663-1.167-2.864zm0 11.458h-70.304a131.655 131.655 0 0 0 13.242 7.333H330a6.927 6.927 0 0 0 1.063-3.844A6.902 6.902 0 0 0 330 323.01z'/%3e%3cpath fill='%23FBD116' d='m237.639 150.67-13.442 28.839 27.822-15.433-31.575-3.874 23.268 21.699zm23.024-38.4 9.303 30.429 10.362-30.092-26.068 18.254 31.819.552z'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 660 0)'/%3e%3c/svg%3e";
            },
            8787: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 500'%3e%3cpath fill='%230071bc' d='M0 0h1000v500H0z'/%3e%3cg fill='none' stroke='%23000' stroke-width='1.935'%3e%3cpath fill='%23fff' d='M557.817 395.544s17.632-18.65 34.586-15.09c5.086-19.665 24.244-21.191 24.244-21.191s-1.865-21.7 22.717-26.448c.679-14.75 15.598-26.956 15.598-26.956s-3.052-22.888 12.546-28.143c-9.494-18.14 3.22-31.365 3.051-31.704-.17-.339-16.106-28.652-1.865-36.79-15.088-12.715-10.172-27.125-10.172-27.125s-16.445-4.239-10.511-23.905c-13.563-2.374-16.276-24.244-16.276-24.244s-20.853 4.238-23.396-13.902c-13.732 2.204-15.258-11.359-15.428-11.359-.17 0-27.295 7.29-32.72-13.224-10.511 5.426-15.09-4.238-15.09-4.238s-15.088 7.46-24.073-6.951c-17.971 11.19-27.974-.509-27.974-.509s-23.566 15.597-31.364 3.56c-13.902 14.072-26.279 7.969-26.279 7.969s-10.51 18.649-27.465 13.902c-3.899 17.292-23.396 17.632-23.396 17.632s2.035 15.258-21.361 19.327c-3.052 17.97-15.259 21.022-15.259 21.022s1.187 17.463-9.833 23.057c3.9 9.834-6.273 21.87-6.273 21.87s10.85 13.563-3.899 28.822c14.241 3.73 3.9 28.313 3.9 28.313s19.666 8.816 7.29 25.091c14.071 4.578 9.663 15.767 9.833 22.38 8.985 4.068 16.953 2.033 13.054 20.174 27.634 3.052 14.58 18.31 14.58 18.31s12.885.509 7.799 10.68c23.565-.508 26.956 17.633 26.956 17.633s21.87-5.765 24.753 2.712c2.882 8.477-9.494 65.611-9.494 65.611s-18.48 0-32.212-14.75c-32.213-.847-25.092-22.04-25.6-22.04-.51 0-10.681 3.9-15.937-13.732-21.531 4.408-20.853-13.732-21.023-13.902-.17-.17-9.663-4.408-6.103-13.393-22.21 2.034-20.514-19.667-20.514-19.667-4.86-1.978-6.668-6.499-5.934-11.02-2.882-1.017-22.548-1.356-12.376-27.295-18.819-11.36-7.12-24.413-7.12-24.413s-25.94-13.394-5.934-28.822c-14.92-22.04 1.186-33.06 1.186-33.06s-20.683-21.022.34-35.941c-3.391-31.873 15.597-39.502 15.597-39.502s-10.003-25.94 17.123-36.79c1.696-26.278 20.684-26.956 20.684-26.956s.508-20.853 30.347-18.819c5.764-18.649 26.109-14.92 26.109-14.92s6.272-22.548 33.907-11.697c14.071-27.465 34.925-13.394 34.925-13.394s13.223-8.646 19.835-5.934c8.396-14.428 26.27-.559 37.827 2.233 4.188-1.629 19.138-12.913 30.666 1.328 15.259-10.003 28.313 7.968 28.313 7.968s21.023-10.68 30.856 13.733c44.588-4.07 38.146 25.09 38.146 25.09s35.094-7.967 27.465 26.957c31.873 2.204 28.651 23.227 28.651 23.227s20.175 15.258 11.36 28.99c17.97.848 11.358 18.141 11.358 18.141s13.733 5.256 2.374 26.617c26.278 21.023 5.086 41.876 4.916 41.707-.17-.17 14.072 16.953 1.187 36.62 3.9 31.195-11.867 39.163-11.867 39.163s4.068 20.175-13.563 25.939c-.34 23.735-22.718 26.617-22.718 26.617s5.933 10.31-16.276 21.16c-.876 15.882-24.074 17.155-24.074 17.155s-2.204 29.16-31.704 21.362c-7.16 23.397-41.706 16.445-42.384 16.106-.678-.339-6.612-50.183-6.612-50.352z'/%3e%3cpath d='M599.01 420.07s-2.616 5.032 7.85 9.46m13.08-21.34s11.673-2.818 19.522 0m15.298-29.38c0 .201-1.61 5.233 7.648 12.478M661.4 365.73s6.843 5.032 18.315 4.83m-87.345 9.86s.402 13.283-6.44 19.522m29.38-40.052s11.27 2.818 20.529-1.811m51.721-17.709s2.415 3.421 14.893 2.818M638.86 332.52c.402.201 14.692 4.83 23.749.604m4.821-55.354s.604-.805 5.032 14.692M678.5 234.1s-.604 8.252-7.245 11.874m49.715-45.684s-9.66 7.849-7.849 11.069M672.87 194.65s5.032 8.453-3.22 14.289m-21.13-50.509s8.654-.403 12.478 7.044m5.632-61.784c0 .201 1.811 1.811-1.61 5.233m-60.18-4.433s4.629 7.245 3.824 16.101m22.946-40.654c2.013-.201 8.855-3.22 8.855-3.22m-38.645-25.56c-.201 0-2.616 9.057 1.811 12.277M590.75 92.415c0 9.66 7.648 7.245 2.415 16.503M572.04 84.365c-.201 0-12.075 9.258-12.075 10.868m-18.925-15.9s5.032 5.031 3.824 11.874M499.58 73.295c-.201.403-4.227 9.057-7.044 10.667M462.96 73.497c.201 0 4.025 8.05-1.006 13.887M397.75 106.91c.201.402 10.264 2.013 10.264 2.013M372.59 130.25c.201-.201 12.277-3.824 12.277-3.824M353.07 145.35c.403 0 8.453 1.409 10.465.403m-16.105 7.037s2.616 1.409.403 14.893M308.19 117.37l4.83 7.245M291.68 154.6c0-.201 4.83 7.245 11.271 8.654m26.769 29.186c.201 0 7.85-1.61 9.057-2.415M326.3 219.81c.201 0-.201-5.032 6.038-8.453M318.05 232.29c0 .201 5.837 7.447 9.862 8.453m-13.282 5.437c.604-.201 6.843-5.636 14.088-5.233M312.61 264.89s.201 6.24 18.717 4.63m-16.897 17.31c0-.201 5.434-12.478 16.503-17.107m-1.613 32.807s1.61-5.233 10.868-8.855m-.608 29.585s6.642-5.434 9.057-6.239m-.797 22.339s4.025 4.226 14.088-3.019m-62.598 6.439c1.208-.201 15.899-3.623 20.931 4.025m-15.091 8.055s15.497-2.013 17.51-.402m37.83 3.622s-2.013 4.227 17.107-2.818m6.643 10.468c-3.421 5.836.805 10.465-3.623 13.082M326.1 373.78c.604-.402 7.044-2.616 6.038-11.874m-.198 25.754c.805-.201 11.472-4.83 13.686-2.415m7.244 15.905s1.409-9.46 4.428-10.465m11.672 24.755s8.855-.201 12.679-3.019m4.421-28.981c.201.201 8.252 4.428 25.359.201M392.51 421.88s2.415 12.277 2.214 15.094M632.21 133.87h6.642M526.35 75.308s-2.616 7.648-6.038 9.66M454.5 31.836c.201.201.805 6.239-3.019 11.472m-33.201 2.214c0 .201 1.61 6.843-9.057 9.057'/%3e%3c/g%3e%3cg fill='%23f7df73' fill-rule='evenodd' stroke='%23000' stroke-linejoin='round'%3e%3cpath stroke-width='2.419' d='M561.72 423.68s100.53-28.397 130.89-151.78c-17.626 126.65-127.63 166.79-127.63 166.79l-3.264-15.015z'/%3e%3cpath stroke-width='2.429' d='M429.95 421.01s-99.612-28.908-129.69-154.51c17.464 128.92 126.46 169.79 126.46 169.79l3.234-15.285z'/%3e%3c/g%3e%3cg fill='%238c1800'%3e%3cpath d='M572.03 431.37c3.107 0 10.794-8.505 15.21-9.486 4.416-.981 4.907-5.397-.164-5.56-5.07-.164-9.485 5.724-9.485 5.724s-4.416 3.761-8.996 4.252c-4.58.49-1.635 6.215 3.435 5.07zm21.42-15.7s-3.108-1.145 4.907-4.252c8.013-3.108 7.523-6.706 10.14-8.178 2.616-1.472 8.177-5.397 9.322-3.107 1.145 2.29-5.888 6.869-7.523 7.36-1.636.49-9.65 7.85-11.94 8.504-2.29.654-3.925.327-4.906-.327zm-173.71 13.17c-3.079 0-10.695-8.658-15.071-9.656-4.375-1-4.862-5.495.162-5.661 5.023-.167 9.399 5.827 9.399 5.827s4.375 3.83 8.913 4.329c4.537.5 1.62 6.326-3.403 5.16zm-21.23-15.98s3.08-1.165-4.862-4.329c-7.94-3.163-7.454-6.826-10.047-8.324-2.592-1.499-8.102-5.494-9.236-3.164s5.834 6.993 7.454 7.493 9.561 7.991 11.83 8.657c2.269.666 3.89.333 4.861-.333z'/%3e%3cpath stroke='%238c1800' stroke-width='2.419' d='M629.92 388.19s-10.467 6.051-8.995 7.523c1.472 1.472 10.794-5.724 10.958-5.887.163-.164 3.925-4.743-1.963-1.636z'/%3e%3cpath stroke='%238c1800' stroke-width='2.429' d='M362.37 384.89s10.371 6.16 8.913 7.658c-1.459 1.499-10.695-5.827-10.857-5.993-.162-.167-3.89-4.828 1.944-1.665z'/%3e%3c/g%3e%3cg fill='none' stroke='%238c1800' stroke-linecap='round'%3e%3cpath stroke-width='3.144' d='M645.46 372.82c-6.869 7.687-6.869 7.523-6.869 7.523'/%3e%3cpath stroke-width='2.902' d='m655.76 360.23-6.542 8.014'/%3e%3cpath stroke-width='2.66' d='m666.07 343.87-7.36 11.776'/%3e%3cpath stroke-width='2.419' d='m674.74 327.19-6.051 12.103m9.971-20.933-1.963 4.252'/%3e%3cpath stroke-width='1.451' d='m683.08 306.75-1.636 5.07'/%3e%3cpath stroke-width='3.158' d='M346.98 369.24c6.806 7.825 6.806 7.659 6.806 7.659'/%3e%3cpath stroke-width='2.915' d='m336.77 356.42 6.482 8.158'/%3e%3cpath stroke-width='2.672' d='m326.56 339.77 7.293 11.987'/%3e%3cpath stroke-width='2.429' d='m317.97 322.79 5.996 12.32m-9.886-21.31 1.945 4.329'/%3e%3cpath stroke-width='1.457' d='m309.71 301.98 1.62 5.161'/%3e%3c/g%3e%3cpath fill='%23217900' stroke='%23000' stroke-linejoin='round' stroke-width='1.935' d='M343.56 115.74c.086 0 7.477 6.41 6.096 16.07-1.38 9.66-6.959 23.09-5.837 33.095.685 4.011.426 11.198.426 11.198s-6.7-9.52-6.786-19.698 7.255-19.842 7.255-27.346c0-7.504-1.327-13.492-1.154-13.319zm-3.66 2.88s-9.698 9.258-10.947 18.255c-.922 4.638-1.28 26.247-1.39 35.839-.217 2.943-1.437 14.558-1.696 18.785-.258 4.226 7.134-7.215 7.557-16.53-.231-9.643-.232-29.953.749-33.005.872-3.924.682-8.259 2.03-12.194 1.785-5.46 3.783-11.064 3.697-11.15z'/%3e%3cg fill='none' stroke='%236b18b5' stroke-linejoin='round'%3e%3cpath stroke-width='1.935' d='M276.41 180.31s6.574 9.102 7.754 14.328c1.18 5.225 3.371 15.508 6.237 19.722 2.865 4.214 19.216 27.644 20.059 37.421.168 6.405-6.743 17.362-17.025 17.53-6.406-.168-22.924-4.382-23.6-18.542-.674-14.159 5.058-14.497 5.732-23.093.674-8.597.843-47.197.843-47.366z'/%3e%3cpath d='M389.35 56.361s-6.806.485-12.046 3.326c-4.06 2.503-10.937 6.105-15.743 12.769-12.223 9.529-30.612 13.975-36.412 21.891-3.472 5.386-3.258 18.338 5.44 23.823 5.56 3.184 21.865 8.165 29.797-3.583 7.932-11.748 3.21-15.014 7.1-22.71 6.418-17.641 21.776-35.372 21.864-35.517zm165.09-17.195s-5.083-4.552-10.769-6.34c-4.623-1.175-12.322-.664-20.288-1.446-15.348-2.153-31.171-13.253-40.892-11.912-6.284 1.252-15.441 10.416-13.331 20.481 1.58 6.21 8.525 18.768 22.483 16.294s13.837-5.519 22.072-8.078c20.085-11.262 40.56-8.961 40.724-8.999zM718.18 198.3c1.146-2.62-.965-7.542-2.464-13.311-1.455-4.542-3.627-11.592-8.941-17.858-6.315-14.154-5.233-33.564-11.524-41.094-4.395-4.663-17.02-7.567-24.433-.44-4.427 4.633-13.177 19.264-3.678 29.785 9.5 10.52 13.64 6.558 20.176 12.182C702.9 178.03 710.531 196.38 718.18 198.3zm-5.59 123.64c2.128-2.946 5.938-8.625 5.485-13.354-.359-3.746 1.717-15.101 1.944-20.055 1.408-15.434 11.069-27.962 8.442-41.372-1.554-6.216-10.658-15.083-20.61-12.489-6.126 1.879-19.765 9.384-16.62 23.206 3.146 13.822 7.612 13.593 10.566 21.694 8.48 16.748 3.054 36.642 10.793 42.37z'/%3e%3c/g%3e%3cg fill='%236b18b5'%3e%3cpath d='M491.8 26.96c0-2.178-2.449-3.943-5.471-3.943s-5.472 1.765-5.471 3.943c-.001 2.178 2.449 3.943 5.47 3.943s5.473-1.765 5.472-3.943zm2.34 9.173c0-2.088-2.522-3.782-5.632-3.782s-5.632 1.694-5.632 3.782 2.521 3.782 5.632 3.782 5.632-1.693 5.632-3.782zm7-10.862s-6.437 4.828-3.781 6.759c2.655 1.93 9.976-4.184 9.976-4.184l-6.195-2.575zM690.31 135.8c.002-1.372-.641-2.641-1.687-3.328a3.03 3.03 0 0 0-3.38 0c-1.045.687-1.689 1.956-1.687 3.328-.002 1.372.642 2.641 1.687 3.328 1.046.687 2.334.687 3.38 0s1.689-1.956 1.687-3.328zm-2.45-9.21c0-2.289-1.58-4.144-3.53-4.144-1.95 0-3.53 1.855-3.53 4.144s1.58 4.144 3.53 4.144 3.53-1.855 3.53-4.144zm1.69 18.73c0-1.187-.618-2.149-1.381-2.149s-1.382.962-1.382 2.149.619 2.149 1.382 2.149c.763 0 1.381-.962 1.381-2.149zm5.68-16.73c0-1.356-.618-2.456-1.381-2.456s-1.382 1.1-1.382 2.456.619 2.456 1.382 2.456c.763 0 1.381-1.1 1.381-2.456zm-15.51 1.69c0-1.102-.618-1.995-1.381-1.995s-1.382.893-1.382 1.995.619 1.995 1.382 1.995c.763 0 1.381-.893 1.381-1.995zm2.46 13.2c0-1.78-1.305-3.225-2.916-3.225s-2.917 1.444-2.917 3.225c0 1.78 1.306 3.225 2.917 3.225 1.61 0 2.917-1.444 2.916-3.225zm-7.68-5.84c0-1.526-1.1-2.763-2.456-2.763-1.356 0-2.456 1.237-2.456 2.763 0 1.526 1.1 2.763 2.456 2.763s2.456-1.237 2.456-2.763zm-1.22-7.82c.001-.823-.408-1.585-1.074-1.996a2.026 2.026 0 0 0-2.15 0c-.665.411-1.075 1.173-1.074 1.996 0 .823.409 1.585 1.074 1.996a2.026 2.026 0 0 0 2.15 0c.666-.411 1.075-1.173 1.074-1.996zm34.99 39.8c-3.17-4.184-8.246-5.947-11.337-3.938-3.09 2.01-3.026 7.03.144 11.215 3.17 4.184 8.247 5.947 11.337 3.938 3.091-2.01 3.026-7.03-.144-11.215zm9.01 77.19c.614-5.135-1.89-9.656-5.593-10.099-3.704-.443-7.204 3.36-7.819 8.494-.614 5.135 1.89 9.656 5.594 10.1 3.703.443 7.204-3.36 7.818-8.495zm1.9 44.94c1.055-5.062-1.049-9.783-4.7-10.544-3.652-.761-7.468 2.725-8.523 7.787-1.056 5.063 1.049 9.784 4.7 10.545 3.652.76 7.467-2.726 8.523-7.788zm8.66-42.06c0-2.034-1.374-3.684-3.07-3.684-1.695 0-3.07 1.65-3.07 3.684s1.375 3.684 3.07 3.684c1.696 0 3.07-1.65 3.07-3.684zm-7.52 8.44-6.293 7.137s-5.91.154-5.603 2.073c.307 1.918 8.136 7.674 8.059 9.977-.077 2.302 5.219-.538 5.219-.538s4.22-12.817 4.22-12.893c0-.076-.23-8.902-2.532-8.749-2.303.154-2.926 2.83-3.07 2.994zm-413.94-2.82a2.995 2.995 0 1 0-5.99 0 2.995 2.995 0 0 0 5.99 0zm2.83-9.15c0-1.746-1.341-3.162-2.995-3.162-1.654 0-2.995 1.416-2.995 3.162s1.34 3.162 2.995 3.162c1.654 0 2.995-1.416 2.995-3.162zm-24.6-43.53c-1.123-2.518-3.463-3.921-5.225-3.135-1.762.786-2.28 3.465-1.157 5.982s3.462 3.922 5.225 3.135c1.762-.786 2.28-3.464 1.157-5.982zm7.43 27.12c-1.543-3.263-4.757-5.082-7.178-4.063s-3.132 4.49-1.59 7.754 4.757 5.082 7.178 4.063 3.133-4.49 1.59-7.754zm7.95 19.88c.5-4.076-1.189-7.82-3.772-8.363-2.584-.542-5.083 2.322-5.583 6.397-.5 4.076 1.189 7.82 3.772 8.363 2.584.543 5.083-2.321 5.583-6.397zm-12.76 2.91c1.598-3.783 1-7.846-1.336-9.076s-5.524.84-7.122 4.622c-1.598 3.783-1 7.846 1.336 9.076s5.524-.84 7.122-4.622z'/%3e%3cpath d='M281.42 243.99c0-1.93-1.49-3.494-3.328-3.494-1.838 0-3.328 1.564-3.328 3.494s1.49 3.494 3.328 3.494c1.838 0 3.328-1.564 3.328-3.494zm-2.66-8.65c0-1.746-1.341-3.162-2.995-3.162s-2.995 1.416-2.995 3.162 1.34 3.162 2.995 3.162c1.654 0 2.995-1.416 2.995-3.162zm2.82-16.64c0-2.94-1.304-5.325-2.912-5.325-1.608 0-2.912 2.384-2.912 5.325s1.304 5.325 2.912 5.325 2.912-2.384 2.912-5.325zm8.96-1.28c.388-2.915-.59-5.45-2.184-5.662-1.594-.213-3.201 1.979-3.589 4.894-.388 2.915.59 5.45 2.184 5.662 1.594.212 3.201-1.979 3.589-4.894zm63.85-127.378c1.187-4.128-.037-8.277-2.734-9.267-2.697-.99-5.845 1.554-7.032 5.682-1.187 4.129.037 8.278 2.734 9.268 2.697.99 5.845-1.555 7.032-5.683zm-12.12 18.378c3.557-3.027 5.076-7.212 3.394-9.349-1.683-2.136-5.93-1.414-9.486 1.613s-5.076 7.213-3.394 9.349 5.93 1.414 9.486-1.613zm-7.08-10.203c3.517-2.599 5.02-6.192 3.356-8.025-1.664-1.834-5.863-1.214-9.38 1.384-3.518 2.599-5.02 6.192-3.356 8.026 1.663 1.833 5.863 1.214 9.38-1.385zm27.27-17.936c2.372-1.813 3.385-4.32 2.263-5.6s-3.954-.847-6.326.966c-2.372 1.814-3.385 4.32-2.263 5.6s3.954.847 6.326-.966z'/%3e%3cpath d='M348.25 97.659c1.622-2.506 1.73-5.208.243-6.035-1.487-.826-4.008.535-5.63 3.042s-1.73 5.208-.243 6.035c1.487.826 4.008-.536 5.63-3.042zm20.51-10.739c2.55-2.15 3.544-4.997 2.22-6.36s-4.467-.725-7.017 1.425c-2.55 2.15-3.545 4.997-2.22 6.36s4.466.725 7.017-1.425zm-37.07 25.05c2.384-.119 4.184-1.307 4.02-2.653-.164-1.346-2.23-2.34-4.614-2.222-2.385.12-4.185 1.307-4.02 2.653.164 1.346 2.23 2.341 4.614 2.222zm44.88-38.364c1.622-2.506 1.73-5.208.243-6.035-1.487-.826-4.008.535-5.63 3.042s-1.73 5.208-.243 6.035c1.487.826 4.008-.536 5.63-3.042z'/%3e%3c/g%3e%3cg fill='%23ffd200' stroke='%23ef8a10' stroke-width='1.935'%3e%3cpath d='M553.24 88.375s12.574-5.8 16.169-16.603c3.594-10.802-10.882-10.906-12.795-7.473-1.912 3.434 1.631 11.983.719 14.243-.913 2.26-6.029 7.716-4.093 9.833z'/%3e%3cpath stroke-width='2.419' d='M441.8 92.316s8.163-11.186 6.047-22.372c-2.117-11.186-14.814-4.233-14.814-.302s7.255 9.674 7.558 12.093c.302 2.418-1.512 9.674 1.21 10.58zm-22.07 6.651s8.163-11.186 6.046-22.372-14.814-4.233-14.814-.302 7.256 9.674 7.559 12.093c.302 2.418-1.512 9.674 1.209 10.58zm-24.49 7.563s8.163-11.186 6.047-22.372c-2.117-11.186-14.814-4.233-14.814-.302s7.255 9.674 7.558 12.093c.302 2.418-1.512 9.674 1.21 10.58zm-17.23 17.23s8.163-11.186 6.046-22.372-14.814-4.233-14.814-.302 7.256 9.674 7.559 12.093c.302 2.418-1.512 9.674 1.209 10.58zm-18.14 16.63s8.163-11.186 6.046-22.372-14.814-4.233-14.814-.302 7.256 9.674 7.559 12.093c.302 2.418-1.512 9.674 1.209 10.58z'/%3e%3cpath d='M401.57 43.519s-10.87 8.579-11.84 19.922c-.97 11.343 13.13 8.06 14.187 4.275 1.057-3.785-4.387-11.269-4.028-13.68.36-2.41 4.058-8.911 1.681-10.517zm36.28-11.186s-10.87 8.579-11.84 19.922c-.97 11.343 13.13 8.06 14.187 4.275 1.057-3.786-4.387-11.269-4.028-13.68.36-2.41 4.058-8.911 1.681-10.517zM302.66 130.27s2.296 13.656 11.776 19.96 13.38-7.638 10.569-10.385-11.991-1.571-13.932-3.045c-1.941-1.474-5.863-7.843-8.414-6.53zm-18.12 46.37s.112 13.847 8.479 21.568c8.366 7.72 14.418-5.43 12.076-8.586-2.343-3.157-11.592-3.445-13.277-5.206-1.684-1.762-4.552-8.67-7.278-7.776zm41.8 51.8s-4.942-12.936-15.479-17.248c-10.536-4.312-11.613 10.125-8.316 12.264 3.298 2.139 12.065-.823 14.26.24 2.193 1.063 7.293 6.533 9.535 4.744zm-8.68-22.39s8.38-11.025 6.481-22.25-14.729-4.52-14.805-.59c-.076 3.929 7.066 9.813 7.321 12.237.255 2.424-1.7 9.643 1.003 10.603zM578.94 99.561s12.574-5.8 16.169-16.603c3.594-10.802-10.882-10.906-12.795-7.473-1.912 3.434 1.631 11.983.719 14.243-.913 2.26-6.029 7.716-4.093 9.833zm38.03 18.969s7.396-11.707 4.537-22.726-15.064-3.233-14.801.69c.263 3.92 7.886 9.167 8.35 11.56.463 2.393-.862 9.754 1.914 10.477zm103.77 107.74s-4.96-12.929-15.502-17.226c-10.542-4.298-11.599 10.141-8.299 12.275 3.3 2.134 12.064-.839 14.26.22 2.194 1.06 7.302 6.524 9.541 4.731zM670 234.3s.288-13.845 8.751-21.459c8.464-7.614 14.348 5.612 11.966 8.739-2.382 3.125-11.635 3.296-13.342 5.037-1.706 1.74-4.661 8.611-7.375 7.683zm-8.17-146.816s-12.945-4.917-23.175.08c-10.23 4.996-.169 15.405 3.622 14.366 3.79-1.038 7.414-9.553 9.667-10.485 2.253-.93 9.73-1.097 9.886-3.962zm-29.62-24.791s-12.945-4.917-23.175.08c-10.23 4.996-.169 15.405 3.622 14.366 3.79-1.038 7.414-9.553 9.667-10.485 2.253-.93 9.73-1.097 9.886-3.962zm-44.19-23.64s-10.975 8.445-12.084 19.775c-1.109 11.331 13.03 8.221 14.133 4.449 1.103-3.773-4.248-11.322-3.86-13.73.39-2.406 4.168-8.86 1.81-10.494zm-28.75-6.922s-5.005 12.912-.077 23.175 15.404.273 14.39-3.525c-1.012-3.798-9.503-7.478-10.418-9.737-.916-2.26-1.032-9.737-3.895-9.912zm-81.61 49.756s8.952-10.565 7.65-21.875c-1.3-11.31-14.467-5.295-14.752-1.375-.285 3.92 6.536 10.174 6.662 12.61.126 2.434-2.209 9.539.44 10.64z'/%3e%3c/g%3e%3cg fill='%23de2010' stroke='%23000' stroke-width='2.383'%3e%3cpath d='M701.62 233.11c-.502-4.05-2.454-7.607-5.117-9.332-2.663-1.724-5.633-1.353-7.79.974s-3.172 6.256-2.663 10.304c.502 4.05 2.454 7.607 5.117 9.332 2.663 1.724 5.634 1.353 7.79-.974 2.157-2.327 3.172-6.256 2.663-10.304z'/%3e%3cpath d='M699.95 212.66c-.502-4.05-2.454-7.607-5.117-9.332-2.663-1.724-5.633-1.353-7.79.974s-3.172 6.256-2.663 10.304c.502 4.05 2.454 7.607 5.117 9.332 2.663 1.724 5.634 1.353 7.79-.974 2.157-2.327 3.172-6.256 2.663-10.304z'/%3e%3cpath d='M695.8 190.82c-.856-3.99-3.113-7.362-5.917-8.846s-5.73-.853-7.675 1.655c-1.944 2.507-2.61 6.51-1.746 10.498.856 3.99 3.112 7.362 5.917 8.846s5.73.853 7.674-1.655 2.61-6.51 1.747-10.498z'/%3e%3cpath d='M688.23 168c-1.845-3.64-4.887-6.325-7.977-7.045-3.09-.72-5.758.636-6.999 3.556-1.24 2.92-.864 6.96.987 10.597 1.845 3.64 4.887 6.325 7.977 7.045 3.09.72 5.759-.636 7-3.556 1.24-2.92.863-6.96-.988-10.597z'/%3e%3cpath d='M680.14 149.69c-1.845-3.64-4.887-6.325-7.977-7.045-3.09-.72-5.758.636-6.999 3.556-1.24 2.92-.864 6.96.987 10.597 1.845 3.64 4.887 6.325 7.977 7.045 3.09.72 5.759-.636 7-3.556 1.24-2.92.863-6.96-.988-10.597z'/%3e%3cpath d='M668.64 131.28c-2.147-3.47-5.405-5.889-8.545-6.344s-5.684 1.121-6.672 4.136c-.99 3.015-.272 7.009 1.88 10.475 2.147 3.47 5.405 5.889 8.545 6.344 3.14.456 5.684-1.121 6.673-4.136.989-3.015.272-7.009-1.881-10.475z'/%3e%3cpath d='M655.85 113.54c-2.472-3.246-5.949-5.339-9.118-5.489-3.17-.15-5.549 1.666-6.242 4.763-.692 3.096.408 7.002 2.885 10.244 2.472 3.246 5.949 5.338 9.118 5.488 3.17.15 5.55-1.666 6.242-4.762.692-3.096-.407-7.002-2.885-10.244z'/%3e%3cpath d='M640.59 96.996c-2.916-2.854-6.66-4.42-9.817-4.109-3.158.311-5.25 2.453-5.486 5.617-.236 3.164 1.418 6.869 4.34 9.717 2.916 2.854 6.66 4.42 9.817 4.11 3.157-.312 5.249-2.453 5.485-5.617.237-3.164-1.418-6.87-4.34-9.718z'/%3e%3cpath d='M623.41 81.776c-3.167-2.573-7.038-3.789-10.154-3.188-3.115.6-5.001 2.925-4.946 6.097s2.044 6.71 5.215 9.277c3.167 2.573 7.038 3.789 10.154 3.188 3.115-.6 5.001-2.925 4.946-6.097s-2.044-6.71-5.215-9.277z'/%3e%3cpath d='M605.21 69.628c-3.55-2.012-7.57-2.568-10.542-1.458-2.973 1.109-4.446 3.714-3.865 6.833s3.13 6.277 6.683 8.283c3.55 2.012 7.569 2.568 10.542 1.458 2.972-1.109 4.446-3.714 3.865-6.833s-3.13-6.277-6.683-8.283z'/%3e%3cpath d='M584.84 58.844c-3.718-1.68-7.772-1.868-10.631-.493-2.86 1.375-4.09 4.104-3.227 7.157s3.688 5.966 7.409 7.64c3.718 1.68 7.771 1.868 10.63.493 2.86-1.375 4.09-4.104 3.228-7.157-.863-3.053-3.688-5.966-7.409-7.64z'/%3e%3cpath d='M564.86 50.799c-3.822-1.427-7.88-1.343-10.64.22-2.76 1.564-3.805 4.37-2.74 7.358s4.08 5.706 7.905 7.126c3.822 1.428 7.879 1.343 10.64-.22 2.76-1.564 3.805-4.37 2.74-7.358s-4.08-5.705-7.905-7.126z'/%3e%3cpath d='M544.56 44.43c-3.92-1.131-7.959-.738-10.592 1.032-2.633 1.77-3.46 4.647-2.17 7.545 1.29 2.899 4.503 5.378 8.425 6.502 3.92 1.132 7.959.738 10.592-1.032 2.633-1.77 3.46-4.646 2.17-7.545-1.29-2.898-4.503-5.377-8.425-6.502z'/%3e%3cpath d='M522.21 40.62c-4.048-.514-7.978.497-10.307 2.651-2.33 2.154-2.704 5.124-.982 7.79 1.721 2.665 5.277 4.62 9.326 5.127 4.047.514 7.977-.497 10.307-2.652 2.329-2.154 2.703-5.124.982-7.789-1.722-2.665-5.277-4.62-9.326-5.127z'/%3e%3cpath d='M500.15 39.375c-4.077-.167-7.906 1.175-10.043 3.52-2.137 2.345-2.257 5.336-.315 7.844 1.942 2.51 5.652 4.154 9.729 4.314 4.077.168 7.906-1.175 10.043-3.52 2.137-2.344 2.257-5.335.315-7.844-1.943-2.509-5.652-4.154-9.729-4.314z'/%3e%3cpath d='M479.94 40.089c-4.077-.167-7.906 1.175-10.043 3.52-2.137 2.345-2.257 5.336-.315 7.844 1.942 2.51 5.652 4.154 9.729 4.314 4.077.168 7.906-1.175 10.043-3.52 2.137-2.344 2.257-5.335.315-7.844-1.943-2.509-5.652-4.154-9.729-4.314z'/%3e%3cpath d='M456.25 42.895c-3.978.906-7.323 3.204-8.772 6.026-1.449 2.823-.782 5.741 1.75 7.654s6.542 2.529 10.519 1.616c3.978-.905 7.323-3.203 8.772-6.026 1.449-2.822.781-5.74-1.75-7.653s-6.542-2.53-10.519-1.617z'/%3e%3cpath d='M434.7 48.296c-3.89 1.23-7.034 3.797-8.245 6.73s-.306 5.785 2.375 7.482 6.728 1.981 10.616.744c3.89-1.23 7.034-3.797 8.245-6.73s.306-5.785-2.375-7.482-6.728-1.981-10.616-.744z'/%3e%3cpath d='M415.04 56.715c-3.716 1.685-6.531 4.607-7.385 7.663-.853 3.056.386 5.781 3.25 7.147 2.863 1.366 6.916 1.166 10.629-.526 3.715-1.685 6.53-4.607 7.384-7.663s-.385-5.781-3.249-7.147c-2.864-1.366-6.916-1.166-10.629.526z'/%3e%3cpath d='M395.43 66.766c-3.559 1.996-6.114 5.148-6.704 8.265-.59 3.118.877 5.727 3.847 6.844s6.99.571 10.546-1.431c3.559-1.996 6.115-5.148 6.704-8.266.59-3.117-.877-5.726-3.847-6.843s-6.99-.571-10.546 1.431z'/%3e%3cpath d='M376.88 79.349c-3.32 2.371-5.519 5.782-5.766 8.945-.247 3.163 1.494 5.598 4.568 6.385 3.073.788 7.011-.192 10.328-2.569 3.32-2.37 5.519-5.781 5.766-8.945.247-3.163-1.494-5.597-4.568-6.385-3.074-.787-7.011.192-10.328 2.569z'/%3e%3cpath d='M359.71 92.358c-3.108 2.643-5.01 6.228-4.989 9.4s1.963 5.452 5.092 5.977c3.13.524 6.97-.785 10.073-3.434 3.108-2.643 5.01-6.228 4.989-9.4-.022-3.173-1.963-5.452-5.092-5.976-3.13-.525-6.97.784-10.073 3.433z'/%3e%3cpath d='M344.56 108.19c-2.91 2.86-4.55 6.571-4.302 9.734.25 3.163 2.349 5.297 5.508 5.595 3.158.3 6.895-1.282 9.8-4.146 2.911-2.86 4.551-6.572 4.302-9.735-.248-3.163-2.348-5.296-5.507-5.595-3.158-.299-6.895 1.282-9.801 4.147z'/%3e%3cpath d='M331.51 125.79c-2.661 3.093-3.984 6.93-3.472 10.06.513 3.131 2.784 5.081 5.956 5.115s6.765-1.855 9.42-4.953c2.661-3.093 3.985-6.93 3.472-10.06-.513-3.131-2.784-5.081-5.956-5.115s-6.764 1.855-9.42 4.953z'/%3e%3cpath d='M319.58 143.81c-2.316 3.36-3.223 7.314-2.38 10.373.845 3.059 3.31 4.755 6.469 4.45 3.158-.305 6.527-2.565 8.837-5.929 2.316-3.359 3.223-7.314 2.38-10.373-.844-3.058-3.31-4.755-6.468-4.45-3.158.305-6.528 2.566-8.838 5.929z'/%3e%3cpath d='M309.64 164.24c-1.704 3.707-1.918 7.76-.562 10.628 1.357 2.868 4.077 4.116 7.136 3.273 3.059-.843 5.99-3.649 7.688-7.359 1.705-3.707 1.918-7.76.562-10.628-1.357-2.868-4.077-4.116-7.136-3.273-3.059.843-5.99 3.649-7.688 7.359z'/%3e%3cpath d='M301.77 185.59c-1.361 3.846-1.207 7.901.404 10.635 1.61 2.733 4.434 3.73 7.403 2.613s5.635-4.177 6.99-8.026c1.36-3.846 1.207-7.901-.404-10.635-1.611-2.733-4.434-3.73-7.404-2.613s-5.634 4.177-6.989 8.026z'/%3e%3cpath stroke-width='2.133' d='M294.94 226.01c-.38 3.257.76 6.378 2.99 8.188s5.21 2.03 7.817.581c2.607-1.45 4.443-4.35 4.817-7.607.38-3.257-.76-6.379-2.99-8.188s-5.21-2.031-7.817-.581c-2.607 1.45-4.444 4.35-4.817 7.607z'/%3e%3cpath d='M296.76 207.14c-.91 3.977-.291 7.988 1.623 10.518 1.914 2.53 4.833 3.196 7.655 1.745 2.821-1.45 5.117-4.797 6.02-8.776.911-3.977.292-7.987-1.623-10.518-1.914-2.53-4.832-3.195-7.654-1.745-2.822 1.451-5.118 4.797-6.021 8.776z'/%3e%3c/g%3e%3cpath fill='%23ffe300' d='M685.33 197.47c2.485-2.66 4.798-3.413 7.724-2.443-1.032-7.019-3.253-9.4-5.959-8.555-2.706.845-3.93 4.453-1.765 10.998zm3.8 21.19c2.679-2.466 5.042-3.042 7.886-1.854-.5-7.077-2.535-9.619-5.297-8.98-2.762.64-4.255 4.145-2.589 10.834zm-8.99-40.52c1.728-3.205 3.774-4.52 6.85-4.324-2.78-6.527-5.533-8.267-7.936-6.762-2.402 1.505-2.67 5.306 1.086 11.086zm-9.43-19.28c1.728-3.205 3.774-4.52 6.85-4.324-2.78-6.527-5.533-8.266-7.936-6.762-2.402 1.505-2.67 5.306 1.086 11.086zm-22.61-35.32c1.19-3.44 2.998-5.067 6.066-5.369-3.793-5.995-6.79-7.27-8.92-5.398s-1.782 5.666 2.854 10.767zm-14.78-15.39c1.06-3.483 2.805-5.177 5.859-5.595-4.017-5.847-7.06-7.007-9.117-5.057-2.057 1.95-1.568 5.73 3.258 10.652zm-31.06-26.215c-.064-3.64 1.074-5.79 3.851-7.127-5.623-4.326-8.875-4.492-10.23-2.003-1.357 2.489.272 5.933 6.38 9.13zm16.16 12.122c.567-3.597 2.06-5.516 5.027-6.353-4.789-5.234-7.963-5.961-9.73-3.744-1.767 2.216-.758 5.89 4.703 10.097zm-34.61-22.301c-.44-3.614.471-5.87 3.095-7.486-6.04-3.723-9.291-3.553-10.384-.937-1.092 2.615.884 5.873 7.288 8.423zm-18.85-8.228c-.952-3.514-.374-5.876 1.992-7.852-6.51-2.82-9.704-2.187-10.411.558-.707 2.745 1.715 5.687 8.419 7.294zm-20.31-6.293c-1.246-3.421-.87-5.824 1.32-7.993-6.725-2.259-9.854-1.357-10.326 1.438-.472 2.795 2.19 5.521 9.006 6.555zm-19.95-3.862c-1.49-3.322-1.289-5.745.739-8.067-6.872-1.767-9.927-.641-10.195 2.18-.27 2.823 2.584 5.349 9.456 5.887zm-21.13-1.62c-1.827-3.15-1.878-5.58-.102-8.1-7.017-1.045-9.94.391-9.914 3.226.026 2.835 3.125 5.051 10.016 4.874zm-41.36 3.116c-2.532-2.616-3.167-4.963-2.052-7.837-7.062.678-9.552 2.777-8.843 5.521.708 2.745 4.25 4.15 10.895 2.316zm20.36-2.68c-2.155-2.935-2.467-5.346-.972-8.042-7.09-.285-9.84 1.458-9.51 4.273.33 2.815 3.65 4.686 10.482 3.769zm-40.34 6.996c-2.881-2.226-3.846-4.458-3.154-7.462-6.892 1.684-9.055 4.118-7.96 6.732 1.094 2.615 4.8 3.497 11.114.73zm-38.25 17.587c-3.252-1.637-4.624-3.645-4.516-6.725-6.446 2.963-8.106 5.764-6.535 8.123 1.572 2.36 5.38 2.52 11.051-1.398zm18.44-9.422c-3.03-2.02-4.147-4.18-3.666-7.224-6.758 2.159-8.746 4.737-7.473 7.27 1.274 2.532 5.033 3.154 11.14-.046zm-52.75 33.31c-3.522-.924-5.282-2.601-5.818-5.637-5.687 4.242-6.727 7.328-4.699 9.307 2.03 1.98 5.786 1.344 10.517-3.67zm16.37-13.397c-3.439-1.196-5.062-3.007-5.36-6.075-6 3.784-7.28 6.779-5.412 8.91 1.868 2.133 5.663 1.793 10.772-2.835zm-30.91 27.727c-3.591-.6-5.497-2.11-6.307-5.084-5.277 4.741-6.033 7.908-3.832 9.695 2.2 1.787 5.884.812 10.139-4.611zm-13.04 16.91c-3.63-.271-5.666-1.603-6.742-4.49-4.826 5.2-5.29 8.423-2.937 10.002 2.353 1.58 5.933.275 9.679-5.512zm-10.9 17.3c-3.63.288-5.844-.716-7.35-3.405-3.972 5.878-3.938 9.134-1.37 10.335 2.567 1.2 5.905-.638 8.72-6.93zm-9.58 18.47c-3.562.757-5.888.048-7.73-2.423-3.176 6.344-2.72 9.568-.018 10.425 2.702.858 5.773-1.398 7.748-8.002zm-7.66 18.95c-3.397 1.311-5.806.98-8.016-1.167-2.13 6.767-1.17 9.878 1.634 10.297 2.804.418 5.478-2.296 6.382-9.13zm-5.13 21.13c-3.301 1.536-5.727 1.367-8.076-.628-1.673 6.894-.506 9.934 2.32 10.164 2.825.23 5.312-2.657 5.756-9.536zm-2.09 17.58c-3.108 1.646-5.53 1.84-8.07.596-.924 5.619.556 7.84 3.38 7.64 2.824-.201 4.981-2.795 4.69-8.236zm355.57-83.65c1.243-3.422 3.075-5.021 6.147-5.276-3.702-6.052-6.68-7.372-8.837-5.533-2.157 1.838-1.868 5.638 2.69 10.809zm29.15 98.44c2.679-2.466 5.042-3.042 7.886-1.854-.5-7.077-2.535-9.619-5.297-8.98-2.762.64-4.254 4.145-2.589 10.834z'/%3e%3cpath fill='%23ffd200' stroke='%23ef8a10' stroke-width='1.008' d='M646.9 149.66s7.396-11.707 4.537-22.726-15.064-3.233-14.801.69c.263 3.92 7.886 9.167 8.35 11.56.463 2.393-.862 9.754 1.914 10.477z'/%3e%3cg fill='%23217900' stroke='%23000' stroke-linejoin='round' stroke-width='2.419'%3e%3cpath stroke-width='1.935' d='M663.67 124.92c-.086 0-8.022 7.935-6.641 17.596 1.38 9.66 7.504 21.564 6.382 31.569-1.121 10.006-2.932 16.647-2.932 16.647s9.315-10.609 9.401-20.787-6.383-23.548-6.383-31.052c0-7.504.346-14.146.173-13.973zm14.75 32.43s-6.21 4.572-5.606 15.095c.603 10.523 11.472 29.844 11.472 29.844s7.935 16.302 7.676 20.529c-.259 4.226 1.466-4.054.69-13.369-.776-9.316-12.766-29.844-12.766-29.844s-2.587-4.226-2.329-11.213c.26-6.987.95-10.954.863-11.041z'/%3e%3cpath d='M505.65 52.293s26.653 1.035 26.825 18.286c-.086 2.674 0 5.865-.949 13.542 5.262-2.846 8.798-10.782 8.108-15.871.086-17.51-23.806-29.499-33.984-15.957z'/%3e%3cpath d='M488.75 51.517s21.477-4.485 21.65 12.766c.173 17.251-6.814 20.011-6.814 20.011s16.475-3.537 16.56-21.046c.087-17.51-21.217-25.272-31.396-11.731zM697.38 249.19c.494 7.74 8.069 15.149 5.105 28.652-3.788 15.314-17.125 51.705-14.82 58.127-3.952-5.434-3.294-10.539-3.623-18.113-.33-7.574 11.032-35.732 12.021-45.283 0-8.562.823-20.254 1.317-23.382z'/%3e%3cpath d='M697.38 249.36s12.35 15.643 11.691 27.993c-.659 12.35-7.575 26.84-5.27 33.262-3.951-5.434-4.94-8.892-5.269-16.467-.329-7.574 6.093-15.973 4.776-24.206-1.318-8.233-6.093-20.583-5.928-20.583zm-404.56 3.45c-.494 7.74-6.257 14.655-3.294 28.158 3.788 15.314 17.29 34.744 15.15 56.974 3.951-5.434 5.104-11.527 5.433-19.102.33-7.574-14.984-33.098-15.973-42.648 0-8.562-.823-20.254-1.317-23.382z'/%3e%3cpath d='M292.82 252.98s-12.021 15.149-11.362 27.499c.165 8.233 15.314 42.648 13.009 49.07 3.952-5.434 5.105-4.776 4.94-13.009-4.446-21.077-12.35-34.58-11.032-42.813 1.317-8.233 4.61-20.748 4.446-20.748z'/%3e%3c/g%3e%3cg fill='none' stroke='%23000' stroke-width='1.935'%3e%3cpath fill='%238c8a8c' d='M526.38 104.56s21.457 1.35 22.508 13.655c1.05 12.304-5.102 19.807-5.102 19.807s2.701 26.559-18.306 34.361c-22.508 2.701-57.769.6-57.769.6s-10.354 2.551-14.555-18.906c-4.201-21.457-5.402-36.612-5.402-36.612s2.101-12.004 17.256-12.754c15.155-.75 61.22.15 61.371-.15z'/%3e%3cpath stroke-linecap='round' d='M543.63 137.87s-11.554 14.405-10.353 20.257'/%3e%3cpath fill='%238c8a8c' d='M528.18 171.63c2.851 2.4 5.552 5.102 6.152 13.955l1.2 17.706 15.005 135.05 13.204 97.683.9 15.155s-3.15 11.104-12.003 12.004c-6.452 13.504-41.414 17.406-44.865 17.256-3.151-.15-14.255-4.802-21.007-4.201-6.753.6-18.456 5.101-23.708 4.351-5.252-.75-17.106-4.802-19.206-13.354-14.705-4.652-17.106-15.905-17.106-15.905l15.905-112.99 15.455-142.85s1.8-19.056 9.453-21.907c7.952-.75 49.066.75 60.62-1.95z'/%3e%3cpath d='m447.15 367.15-3.151 99.934M544.23 380.35l8.853 82.378'/%3e%3cpath fill='%23fff' stroke-linejoin='round' stroke-width='2.016' d='m498.19 114.45 29.923 92.093 96.82.004-78.327 56.92 29.916 92.095-78.331-56.915-78.331 56.914 29.916-92.095-78.327-56.92 96.82-.004z'/%3e%3c/g%3e%3c/svg%3e";
            },
            8125: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 2'%3e%3cpath fill='%23ED2939' d='M0 0h3v2H0z'/%3e%3cpath fill='%23fff' d='M0 0h2v2H0z'/%3e%3cpath fill='%23002395' d='M0 0h1v2H0z'/%3e%3c/svg%3e";
            },
            1727: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-72 -28 144 96'%3e%3cpath fill='%23cd2a3e' d='M-72-28H72v96H-72z'/%3e%3cpath fill='%23006233' d='M-72-13.6H72v67.2H-72Z'/%3e%3cpath fill='%23ffc400' d='M30 2.92c-.08 16.496-13.488 29.84-30 29.84S-29.92 19.416-30 2.92a30.973 30.973 0 0 0-1.008 7.84c0 17.12 13.872 31.008 31.008 31.008S31.008 27.896 31.008 10.76A30.88 30.88 0 0 0 30 2.92z' class='st1'/%3e%3cpath fill='%23ffc400' d='M0-9.24-2.694-.949h-8.719l7.053 5.126-2.693 8.291L0 7.344l7.053 5.124L4.36 4.177l7.053-5.125H2.694z'/%3e%3c/svg%3e";
            },
            8643: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 600'%3e%3cclipPath id='a'%3e%3cpath d='M0 0v150h700v150H600zm600 0H300v350H0v-50z'/%3e%3c/clipPath%3e%3cpath fill='%23012169' d='M0 0h1200v600H0z'/%3e%3cpath stroke='%23fff' stroke-width='60' d='m0 0 600 300m0-300L0 300'/%3e%3cpath stroke='%23c8102e' stroke-width='40' d='m0 0 600 300m0-300L0 300' clip-path='url(%23a)'/%3e%3cpath stroke='%23fff' stroke-width='100' d='M300 0v350M0 150h700'/%3e%3cpath stroke='%23c8102e' stroke-width='60' d='M300 0v350M0 150h700'/%3e%3cpath fill='%23012169' d='M0 300h600V0h600v600H0z'/%3e%3cpath fill='%23fff' d='M769.466 147.526h256.879l-.306 182.787c2.137 73.48-43.662 119.076-127.931 139.634-59.834-14.86-128.837-45.596-128.939-137.549l.305-184.872z'/%3e%3cpath fill='%2300a2bd' stroke='%23000' stroke-width='1.813' d='M775.152 153.036h245.493l-.291 175.155c2.041 70.41-41.728 114.102-122.261 133.802-57.188-14.237-123.132-43.692-123.23-131.805l.292-177.152z'/%3e%3cpath fill='%23a53d08' d='M1018.74 348.938c-8.93 67.21-60.692 96.576-120.655 112.162-53.073-14.238-110.174-36.968-121.243-111.824l241.901-.338z'/%3e%3cpath d='m888.365 185.664-.342-22.075 17.455.17.171 21.905h47.744l.17 17.113-47.914.17-.383 201.816-17.026.107-.217-202.093-47.583.171.01-17.455z'/%3e%3cg fill='%23ff9a08' stroke='%23000' stroke-width='.968'%3e%3cpath fill-rule='evenodd' d='m849.714 357.267 43.703 45.338c15.112-16.61 4.63-78.696-15.247-90.13-2.382 7.351-6.434 16.166-10.74 19.008-9.475 6.457-32.692 14.006-24.932 18.84 1.77-2.45 6.399-4.765 8.577.681 2.587 8.577-9.666 9.122-9.666 9.122s-7.76-.954-9.122-8.85 11.559-15.105 12.662-15.656c1.089-.41 17.971-4.901 20.83-19.879 3.54-14.704 7.216-12.525 7.897-12.798 22.055 2.178 36.487 41.662 37.305 69.436.816 27.774-11.3 46.154-13.48 47.38-2.177 1.225-52.552-59.769-52.552-59.769l4.765-2.723z'/%3e%3cpath d='m881.573 315.061.271 81.825m-5.172-80.328.271 74.338m-5.581-63.582.271 59.088m-4.628-54.868.273 48.879m-4.902-46.7v41.253m-5.038-37.985v32.675m-4.356-30.088v25.05'/%3e%3cg fill='none' stroke='%23ffdf00' stroke-linecap='round' stroke-width='1.813'%3e%3cpath stroke-width='.968' d='m849.033 362.441 45.065 51.6'/%3e%3cpath d='M896.276 329.901s20.424 44.658 1.498 81.417m-54.051-58.272s1.498-3.948 3.404-2.314m-6.943-9.122s-8.169 7.215-3.676 11.845'/%3e%3c/g%3e%3c/g%3e%3cg stroke='%23000' stroke-width='.399'%3e%3cpath fill='%23008021' d='M905.779 228.044c3.025-2.595 4.595-4.181 6.468-3.892 1.874.288 4.425.143 6.298-.433 1.88-.578 11.177-1.73 15-.433 1.298.144 3.026.866 5.69 3.1 2.671 2.235 6.564 6.128 5.266 16.942-1.297 10.813-.873 15.439-1.443 21.483-1.006 10.67-3.373 19.456-7.64 18.744 5.767 10.093 6.343 18.744 10.09 25.665 3.753 6.921 6.057 21.051 4.614 36.335-1.437 15.284-5.475 49.6 6.633 72.67-2.02 1.441-6.918 0-11.247-4.615-4.323-4.614-6.222-4.462-9.804-1.73-10.956 8.363-21.216 18.442-36.33 8.363-3.462-2.307-4.557-5.074-2.02-12.112 6.343-17.59 9.425-41.725 8.425-53.06V228.044z'/%3e%3cpath fill='%23ffe1cf' d='M916.171 217.23c.791 2.451 1.222 5.623-.076 8.506-1.297 2.884-1.582 6.345.576 10.526 3.462-4.902 8.367-3.893 11.247-6.776 2.886-2.884 3.462-5.624 5.627-6.2-2.165-1.875-5.481-3.893-4.76-9.373.722-5.479 8.361-9.948 1.443-18.311-4.468-5.399-10.962-3.893-13.772-1.802-1.323.982-2.45 2.378-2.88 3.316-.437.937.108 3.07-.943 4.326a14.172 14.172 0 0 1-2.595 2.45c-.646.47-1.05 1.152-.36 1.947.278.318.784.386 1.341.579-.323.648-.69 1.295-1.05 1.764-.342.44-.197.86.215 1.218-.545 1.73.506 1.918-.216 3.216-.626 1.122-1.474 2.45.867 3.749.646.36 3.716 1.072 5.336.865zm-28.045 28.693c-4.038 1.01-10.525-.72-15.43-.144-2.165.255-3.893-.865-3.602-3.028.285-2.163.576-5.479.14-8.507-.672-4.718 1.588-11.246 4.759-18.456 3.17-7.209 4.76-11.246 4.76-14.634 0-2.235.215-4.759 2.234-6.056 1.493-.959 1.778-1.89 2.31-2.667 1.221-1.803 2.373-2.235 2.519-1.153.088.643-.146 1.225-.722 2.09 1.298-1.082 3.5-2.344 4-2.704.507-.36 3.07-2.162 3.21-.468 1.012-.505 1.696-.47 1.949.071.272.585.107.83-.4 1.262.722-.144 1.552 1.118.109 2.235.76-.252 1.512 1.01.183 2.163-1.38 1.19-2.956 2.019-3.462 2.956-.506.937-3.93 3.569-5.298 4.145-1.373.577-1.443 1.368-1.443 3.388 0 22.205-2.664 20.4-2.664 25.738 0 1.441-.291 2.739 1.152 2.306 1.443-.432 3.531-1.081 5.696-1.081v12.544zm.861 47.869c6.52-3.258 13.988-4.47 17.88-5.479 3.893-1.01 10.095-4.036 13.12-5.622 3.032-1.587 5.482-3.75 7.21-4.327 1.734-.576 3.67-1.77 4.76-3.892 5.62-10.958 8.651-19.752 8.651-27.395 0-5.047-1.297-10.67-6.202-6.633-4.608 3.795-9.627 11.11-10.956 16.437-2.02 8.074-3.747 9.805-4.184 11.39-.43 1.587-2.063 1.585-4.038 2.02-8.506 1.874-10.525 3.17-16.867 7.93-6.342 4.757-13.266 8.94-17.88 11.534-4.614 2.596-5.475 2.884-6.488 4.974-1.006 2.09-1.943 3.677-2.81 4.615-.867.937-1.114 2.032-.937 3.172.146.937-.291 5.262-.36 6.704-.077 1.442.284 1.803.866 1.874.576.073 1.368-.216 1.659-1.946-.291 1.73 2.088 1.153 2.234-.144-.076 1.874 2.45.793 2.595-.937 0 1.225 1.911.378 2.089-.217.43-1.441.79-3.027 1.367-4.18.842-1.675 1.74-3.843 3.392-5.048 1.874-1.37 1.007-2.883 4.899-4.83zm46.716 118.088c.437 1.586 1.228 3.389 1.513 4.47.29 1.081-.216 1.419-.5 2.019-1.513 3.172-3.14 8.228-3.393 10.958-.139 1.586-1.221 3.1-1.728 4.037-.557 1.034-.341 1.831.937 2.811.614.469 2.595-.144 2.81-1.153.722.72 2.02.433 2.595-.65.652.65 1.734.217 2.456-.864.646.433 1.582-.433 1.943-1.01 1.013.505 2.095-.107 2.127-2.09.006-.398.253-1.081.544-1.55.285-.469.392-1.37.36-2.163-.037-.793.47-2.379 1.153-3.496.683-1.118 1.873-3.1 1.367-4.975-.469-1.746-1.222-1.586-1.874-4.109-1.582-1.658-3.747-3.965-5.98-4.11-2.235-.143-3.533 1.37-4.33 1.875zm-41.02 12.4c2.019 2.018 6.563 2.09 9.734-1.298-1.152-.505-3.677-1.658-4.829-2.595-1.588 1.586-3.392 3.388-4.905 3.893z'/%3e%3cpath fill='%23870f00' d='M915.089 195.026c.791-5.118 4.418-4.998 6.703-4.47.936.217 3.247.433 5.405-.144 4.278-1.14 7.5.36 7.07 4.47 1.152.865 2.373 2.883 2.158 4.614-.215 1.73.145 2.451 1.734 2.667 1.582.217 4.975 2.163 2.734 4.902 2.165 1.299 3.823 4.614 2.671 6.85-1.152 2.234-4.614 2.595-6.057.576-1.582.72-4.183.865-5.766-.792-1.082 1.296-3.823 1.153-4.329 0-.5-1.154-1.354-1.771-2.373-2.092-1.159-.36-1.228-3.532.5-3.893-.216-.937-.14-2.018.29-2.523s.07-1.441-.936-2.235c-1.013-.793-1.873-3.821-.867-5.479-1.728.577-5.55-1.081-6.342-2.235-.797-1.153-1.873-1.225-2.595-.216z'/%3e%3cg fill='none'%3e%3cpath d='M916.171 217.23c2.81-.36 3.747-2.09 5.836-1.947m-11.823-5.882c.184.162.418.294.684.44.57.308 1.19.344 1.765.415m-1.614-3.838c.392.135.81.333 1.184.719m5.335-12.111c-1.658-1.586 2.81-4.83 7.5-.216.874.86 3.095.865 3.747.648m-4.759 2.019c2.165-.505 5.405-.505 6.342 1.946.943 2.452 2.816.865 4.33 3.75 1.512 2.883 3.892 6.127 6.195 3.892m-9.152 6.633c-.652-.865-.937-2.74-.506-4.038-.867-1.009-.507-3.1 0-4.109m-5.696 2.163c.076.865 1.228 2.451 3.032 2.74m8.936 4.037c-1.006-1.298-.867-2.45-.646-4.037'/%3e%3cpath d='M926.982 200.145c-.07 1.297.722 3.028 2.089 3.604.29.72 1.734 2.74 4.614 2.452m.582-11.319c-1.582-1.228-3.728-2.74-6.563-3.115m-11.033 44.495c-2.45 3.317-4.038 7.93-2.88 14.419 1.152 6.488 3.026 16.004-1.734 20.33m23.361 12.544c-3.317-.72-8.076-.72-10.671 1.154s-6.924 2.018-9.804.576'/%3e%3cpath d='M928.425 283.339c-2.886.504-4.253 2.523-4.253 7.858 0 5.335-1.152 13.12-.146 20.762m-.867-26.385c-1.873.504-3.817.576-3.456 5.623m-6.272.144c.07-3.1 1.152-5.984 3.171-5.48m17.589 6.057c.146-6.849-1.367-8.795-3.386-8.723 2.74.072 4.608.407 5.766 11.607.867 8.362 2.614 11.323 4.614 17.88 5.19 17.013 2.595 43.254 5.19 52.482m-16.147-71.228c5.475 15.861 8.36 33.451-.576 61.711 6.05 16.726 12.108 28.837 13.26 35.759m-29.988-59.982c1.006-3.604-2.595-4.037.576-16.725 1.373-5.496 1.589-8.795.721-10.526m.001 7.499c-1.298 5.624 4.184 16.149 1.443 23.79m-6.779 1.442c0 4.902 1.152 11.246.867 16.149-.291 4.902 1.709 7.174 4.038 11.823 8.361 16.726 14.051 28.659 13.26 44.41-.14 2.883.867 8.939-2.158 10.668m-15.792 4.254c.867.072 1.804-.36 2.886-2.956s4.545-18.167 3.101-28.837m1.729 12.112c.43 3.316.43 10.093-1.728 15.428m7.209-25.377c1.297 7.065 1.152 13.41.146 17.879m-3.032-.001c.146 2.884 1.443 10.093-.722 10.67m11.538-44.12c5.33 8.363 9.513 28.982 13.981 33.306m-9.367-3.316c-.146-2.307-.291-5.479-1.589-6.921m-56.013-94.008c.07-1.587-.215-3.1 1.513-5.551m-4.108 6.488c.215-5.551.14-6.056 1.728-7.57m-3.962 7.714c.07-3.965-.437-5.335 1.152-7.858m18.741-111.094c-.614.396-4.215 3.135-5.728 4.29m7.278-2.957c-.684.108-2.665 1.73-6.196 4.47m6.304-2.235c-1.114.504-3.24 2.56-5.19 3.93m-3.677-4.326c-.538.396-1.582 1.55-2.089 1.946m52.337 239.708c-.323-.36-.323-1.623.253-3.028m2.341 2.379c-.392-.396 0-2.127.399-3.244m2.057 2.379c-.468-.216-.614-1.226.07-2.596m1.873 1.586c-.323-.108-.468-.649.108-2.234'/%3e%3c/g%3e%3cpath stroke='none' d='M913.969 199.567c1.044 1.37 2.127 1.225 2.317 2.108.19.884.329.946.531 1.209.203.26-.494.208-.835.067-.336-.14-1.184-.126-1.703-.119-.513.008-1.126-.599-.74-.67.38-.07.329-.19.272-.46-.057-.268.215-.693.373-.77.165-.078.05-.064-.095-.424-.152-.36-.341-1.236-.12-.941zm.633-1.254c1.17.137 3.19.77 4.285 1.982.86.953.158.7-.279.736-.436.036-1.29-.273-1.721-.815-.424-.541-1.696-1.227-2.374-1.406-.411-.106-.797-.601.089-.497z'/%3e%3c/g%3e%3c/svg%3e";
            },
            7698: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3e%3cpath fill='%23cf142b' d='M0 0h900v600H0z'/%3e%3cpath fill='%23fff' d='M0 0h450v600H0z'/%3e%3cpath fill='%23e60d2e' d='M22.222 82.828v45.457h45.455c0 7.574 7.576 15.151 15.152 15.151v45.454h45.452v-45.454c7.576 0 15.152-7.577 15.152-15.151h45.455V82.828h-45.455c0-7.574-7.576-15.151-15.152-15.151V22.223H82.829v45.454c-7.576 0-15.152 7.577-15.152 15.151H22.222z'/%3e%3cpath fill='%2396877d' d='M25.254 85.857v39.397h45.452c0 7.574 7.576 15.15 15.152 15.15v45.454h39.392v-45.454c7.576 0 15.152-7.577 15.152-15.15h45.452V85.857h-45.452c0-7.574-7.576-15.151-15.152-15.151V25.252H85.858v45.454c-7.576 0-15.152 7.577-15.152 15.151H25.254z'/%3e%3cpath fill='%23ccc' d='M26.77 87.373v36.364h45.452c0 7.574 7.576 15.153 15.152 15.153v45.454h36.362V138.89c7.576 0 15.152-7.58 15.152-15.153h45.452V87.373h-45.452c0-7.574-7.576-15.15-15.152-15.15V26.769H87.374v45.454c-7.576 0-15.152 7.577-15.152 15.15H26.77z'/%3e%3cg id='a' fill='%23d0d0d0'%3e%3cpath fill='%2396877d' d='M84.536 71.681c2.663 2.663 1.943 7.7-1.607 11.25s-8.587 4.27-11.25 1.607c-2.662-2.662-1.942-7.7 1.608-11.25s8.587-4.27 11.249-1.607z'/%3e%3cpath d='m71.143 79.715 1.071-1.072 4.286 2.142-2.143-4.285 1.071-1.072 4.286 8.57-8.571-4.285zm6.429-6.428 1.071-1.071 6.429 6.428L84 79.715z'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='rotate(90 105.555 105.557)'/%3e%3cuse xlink:href='%23a' transform='rotate(180 105.555 105.557)'/%3e%3cuse xlink:href='%23a' transform='rotate(270 105.555 105.557)'/%3e%3cg fill='none' stroke='%2396877d' stroke-width='.514'%3e%3ccircle cx='105.555' cy='105.557' r='31.822'/%3e%3ccircle cx='105.555' cy='105.557' r='24.245'/%3e%3c/g%3e%3ccircle cx='93.434' cy='131.31' r='1.515'/%3e%3ccircle cx='117.675' cy='131.31' r='1.515'/%3e%3cpath d='M104.55 131.31v1.58h-2.02c-2.02 0-2.02 1.58 0 1.58h2.02v1.58c.007 1.636 1.763 1.835 1.892.137l.128-1.708h2.02c2.02 0 2.02-1.58 0-1.58h-2.02v-1.58c0-1.58-2.02-1.58-2.02 0zM75.954 113.4l2.084-.497-.23-.965c-.053-.222-.14-.372-.263-.452-.122-.08-.332-.102-.63-.067l-.034-.145 1.794-.427.035.144c-.206.052-.35.115-.435.189a.521.521 0 0 0-.166.262c-.027.102-.02.241.023.418l.23.966 1.665-.397c.269-.064.442-.123.52-.178a.36.36 0 0 0 .129-.204.762.762 0 0 0 .008-.382l-.046-.191.145-.035.542 2.275-.144.035-.045-.188c-.052-.219-.154-.363-.305-.431-.099-.043-.307-.026-.625.05l-3.424.816c-.269.064-.442.123-.52.177a.362.362 0 0 0-.13.2.747.747 0 0 0-.008.383l.045.187-.145.035-.94-3.944 1.153-.329.032.137c-.231.127-.394.249-.489.366a.799.799 0 0 0-.173.393c-.02.144.002.354.068.63l.279 1.17zm-1.342-9.402c.04-.706.342-1.303.908-1.79.565-.488 1.25-.709 2.052-.664.826.047 1.498.346 2.014.899.516.552.754 1.199.712 1.94-.042.749-.344 1.363-.905 1.843s-1.264.695-2.11.647c-.863-.048-1.552-.382-2.064-1.001a2.608 2.608 0 0 1-.607-1.874zm.288.093c-.027.487.132.887.476 1.202.429.392 1.077.612 1.943.66.888.05 1.582-.1 2.083-.454a1.41 1.41 0 0 0 .61-1.124 1.582 1.582 0 0 0-.526-1.3c-.38-.355-1-.557-1.858-.606-.93-.052-1.635.092-2.113.433-.38.273-.585.67-.615 1.189zm7.894-9.951-.517 1.36-3.038.817a8.805 8.805 0 0 1-.153.419 4.251 4.251 0 0 1-.05.114l1.48.563c.32.122.533.163.637.122.147-.053.256-.175.329-.365l.075-.199.14.053-.831 2.182-.14-.053.073-.191c.082-.216.071-.396-.034-.542-.058-.082-.232-.179-.522-.29l-3.29-1.252c-.32-.122-.533-.163-.637-.122-.148.056-.258.18-.331.373l-.073.191-.14-.053.707-1.855c.206-.54.397-.925.574-1.151.176-.227.404-.39.684-.488s.566-.092.86.02c.312.119.545.324.698.616.152.292.195.67.127 1.134l1.861-.495c.427-.113.729-.235.905-.365.176-.131.332-.33.467-.596l.14.053zM78.8 96.76a3.78 3.78 0 0 1 .084-.209c.184-.486.219-.892.102-1.219a1.08 1.08 0 0 0-.663-.676c-.318-.12-.614-.12-.889.004-.275.123-.475.349-.6.677-.055.145-.106.35-.153.616l2.119.807zm11.596-18.053 1.053 1.367-.118.077c-.352-.283-.682-.454-.989-.514-.442-.087-.877.008-1.304.285-.583.377-.877.894-.882 1.552-.002.554.171 1.099.52 1.637.282.436.624.78 1.026 1.03.401.25.793.37 1.175.361a1.893 1.893 0 0 0 1.004-.293 2.215 2.215 0 0 0 .78-.865l-.856-1.322c-.148-.23-.263-.369-.344-.417a.42.42 0 0 0-.266-.057c-.097.01-.238.075-.423.195l-.083-.129 1.771-1.147.083.129-.084.054c-.175.114-.258.25-.247.41.009.112.092.29.251.536l.907 1.4a4.083 4.083 0 0 1-.567.802c-.21.229-.469.443-.777.642-.883.572-1.738.724-2.564.454a2.705 2.705 0 0 1-1.469-1.136 2.93 2.93 0 0 1-.459-1.345 2.95 2.95 0 0 1 .29-1.624c.208-.412.54-.766.997-1.062.166-.108.326-.192.48-.253.153-.062.384-.127.694-.196a1.12 1.12 0 0 0 .299-.093.16.16 0 0 0 .071-.13c.005-.06-.027-.148-.094-.267l.125-.081zm8.873.614-2.039.543-.136.926c-.034.228-.037.392-.01.493.021.08.078.14.17.181s.269.036.527-.013l.038.144-1.658.44-.038-.143c.21-.097.339-.186.387-.265.099-.16.178-.45.237-.874l.7-4.827.136-.036 2.998 3.893c.242.313.436.506.585.579.148.073.331.087.55.043l.038.144-2.078.552-.038-.144c.207-.066.34-.138.397-.218a.28.28 0 0 0 .053-.247c-.03-.113-.13-.28-.299-.498l-.52-.673zm-.185-.258-1.46-1.891-.35 2.372 1.81-.481zm9.621-.028.131.033-.523 1.46-4.216-.165.006-.148.204.008c.23.009.398-.06.503-.206.06-.083.095-.28.108-.59l.136-3.515c.013-.34-.016-.554-.087-.642-.1-.122-.253-.187-.46-.195l-.204-.008.006-.149 2.466.096-.006.149c-.29-.014-.493.005-.612.056a.491.491 0 0 0-.247.204c-.046.084-.076.288-.088.612l-.133 3.421c-.01.222.007.376.046.46.03.058.078.101.144.13.066.03.274.052.625.065l.397.016c.418.016.712-.003.883-.058a1.15 1.15 0 0 0 .475-.31c.145-.151.294-.393.446-.724zm7.257 1.942.117.068-.907 1.258-4.006-1.325.047-.141.194.064c.22.072.399.053.54-.058.08-.064.17-.244.267-.539l1.104-3.338c.107-.323.138-.537.094-.642-.062-.145-.191-.25-.387-.314l-.195-.065.047-.141 2.343.775-.047.14c-.274-.092-.475-.13-.603-.114a.492.492 0 0 0-.294.127c-.068.068-.152.256-.254.564l-1.075 3.25c-.07.212-.098.364-.083.456a.287.287 0 0 0 .102.165c.055.046.25.125.583.235l.377.125c.397.13.685.194.865.188.18-.005.36-.06.542-.166.181-.105.391-.296.63-.572zm5.849 3.097-1.722-1.219-.799.488c-.196.12-.325.223-.385.308-.048.068-.058.15-.03.248.028.097.144.229.347.396l-.086.121-1.4-.991.086-.122c.209.1.36.142.451.128.186-.026.46-.152.823-.377l4.156-2.554.115.082-1.07 4.796c-.086.385-.11.658-.071.819.039.16.145.31.32.45l-.087.121-1.755-1.242.086-.121c.184.116.324.171.422.165a.28.28 0 0 0 .224-.117c.068-.096.132-.28.191-.549l.184-.83zm.08-.308.518-2.331-2.047 1.25 1.529 1.081zm6.463 1.191.88 1.188-1.3 5.11 2.525-1.87c.27-.2.415-.355.437-.465.031-.146-.017-.306-.144-.478l-.113-.152.12-.088 1.13 1.524-.12.088-.115-.155c-.137-.185-.29-.275-.46-.27-.104.005-.279.097-.524.28l-3.69 2.735-.087-.117 1.387-5.5-2.696 1.999c-.27.2-.416.353-.44.46-.03.15.019.309.145.479l.115.155-.12.088-1.129-1.524.12-.088.112.151c.139.188.293.279.462.273.104-.004.279-.096.524-.278l3.045-2.257a2.62 2.62 0 0 0 .08-.507c-.002-.1-.03-.23-.082-.387a1.28 1.28 0 0 0-.182-.305l.12-.089zm6.87 12.662-1.184.483-.05-.144c.201-.103.34-.194.414-.274a.807.807 0 0 0 .213-.427 1.152 1.152 0 0 0-.077-.55l-.257-.724-3.925 1.388c-.315.112-.5.216-.554.312-.073.133-.073.3-.002.5l.062.177-.14.05-.77-2.178.14-.05.064.182c.077.217.197.348.36.392.101.027.295-.01.583-.112l3.925-1.389-.218-.617c-.085-.24-.163-.405-.234-.493a.745.745 0 0 0-.396-.24c-.17-.045-.373-.035-.612.03l-.05-.144 1.225-.366 1.484 4.194zm-4.313 9.666-.075-1.453 2.448-1.974a8.874 8.874 0 0 1-.03-.445v-.125l-1.58.082c-.343.018-.554.066-.633.146-.113.107-.164.263-.153.466l.011.213-.148.008-.122-2.332.149-.008.01.205c.013.23.096.39.25.482.087.052.285.07.595.054l3.516-.183c.342-.018.553-.067.632-.146.113-.11.163-.268.153-.475l-.011-.204.149-.008.103 1.982c.03.578.01 1.007-.06 1.285-.07.279-.214.52-.43.723-.216.203-.48.312-.793.329a1.272 1.272 0 0 1-.888-.282c-.258-.205-.45-.534-.575-.986l-1.503 1.205c-.345.275-.571.508-.68.699s-.17.435-.187.734l-.148.008zm2.596-4.01c.003.05.004.095.005.132l.003.093c.027.519.16.904.399 1.156.238.252.531.369.879.35.34-.017.61-.138.812-.361.202-.224.293-.511.275-.862a3.539 3.539 0 0 0-.109-.626l-2.263.118zm1.495 11.21-.483 1.838-.144-.037.027-.101c.018-.068.014-.174-.012-.32s-.08-.285-.164-.42a3.617 3.617 0 0 0-.441-.536l-1.668-1.796-1.322-.347c-.324-.085-.536-.102-.635-.05-.135.07-.23.21-.286.423l-.045.171-.143-.037.587-2.24.144.038-.05.187c-.058.223-.032.399.079.527.068.08.25.157.545.235l1.247.327 2.588-.867c.304-.103.496-.176.577-.22.08-.044.192-.15.333-.318a.535.535 0 0 0 .098-.215l.143.038-.591 2.254-.144-.037.03-.117a.707.707 0 0 0 .004-.359.286.286 0 0 0-.217-.22c-.093-.025-.282.01-.567.104l-1.988.654 1.354 1.46c.203.22.364.345.483.377a.36.36 0 0 0 .386-.132.809.809 0 0 0 .13-.302l.145.038z'/%3e%3cg fill='%2396877d' stroke='%23000' stroke-width='.203'%3e%3cpath d='M122.85 110.19c.532-.135 1.41-.026 1.41-.026s.076.365-.155.487c.257.148 1.18.103 1.18.103s-.36.275-.539.384c.333.032.743.461.743.461s-.769.128-1.102-.051c.205.41.18.769.18.769s-1.243-.308-1.691-1.128m-2.106-1.699c-.301.743-2.51-.64-2.51-.64s.973 1.543 2.433 1.716M93.181 123.66h25.877l1.998-1.589-3.33-1.793-5.125-1.742-2.05-1.127-3.791.204-3.177 1.691-4.356.513-1.025 1.178-3.228.257-5.073-.103 8.455 1.333-6.969-.36 1.794 1.538z'/%3e%3cpath d='M107.12 116.23c-3.241-1.742-4.189 2.55-5.585 3.587 1.883.32 3.305-1.448 4.919-2.306 1.224 3.333 3.151 1.127 3.151 1.127s2.011 3.19 4.689 1.743c.73.55 1.537.05 1.537.05s.974.18 1.179-.256c.512.18 1.076-.46 1.076-.46s1.114.012 1.332-.564c1.653.294 3.843-3.382 3.843-3.382l.666-1.281.974-.205s.064-.64-.461-.615c-.013-.385-.346-.59-.82-.513.09-.23-.256-.41-.256-.41-.923.231-.974 2.563-.974 2.563s-1.614 1.23-2.203 1.537c-.026-1.333-2.255-3.139-1.794-3.997.461-.858 1.909 1.32 3.177.922 1.268-.397 1.891-2.047 1.947-3.33-.358-.872-1.23-2.306-1.23-2.306l-.82-.052-.717-1.742s-1.511.987-1.486 1.845c.026.858 1.589 1.588 1.589 1.588s-.901.564-1.742.308c-.077.87 1.024.704 1.434.717.205.628.82.974.82.974s.385.96-.615.87c-.999-.089-2.178-2.391-3.587-1.331-1.498 1.127.667 3.177.667 3.177s-1.32.691-2.101 2.46c-3.19-2.691-5.06-1.436-8.609-.718z'/%3e%3cpath d='M102.46 111.67c1.332 1.255.403 3.342.922 3.74.551.423 1.333-.204 1.333-.204 1.396.371 3.894-.41 3.894-.41 1.1.615.665-.293 1.332-.256.59 1.511 2.562 1.23 2.562 1.23s-1.806-1.845-2.92-2.358c-.859.513-3.357.59-3.792.513-.486-.086-.18-.68-.41-1.025.918-.894.192-3.113-.308-3.946-2.036-1.356-4.468.968-2.613 2.716zm-8.861-3.75c-1.676.453-4.583-2.165-5.942-1.16s-.725 3.479.18 4.71c.886 1.205-1.294 1.64-1.883 2.356-.554.673.18 1.45.18 1.45l.617.398-.109.906.326 1.087s.3.262.399-.073c.28.281.03 1.093.725 1.196-.25-.52.18-1.957.18-1.957s1.215.091 1.523-.434c.307-.526-.29-1.667-.29-1.667h.362c-.408-.28-.544-1.123-.544-1.123s1.685-.535 1.667-1.812c-.018-1.277-2.735-2.636-1.739-3.297 1.105-.734 3.025 1.902 4.674.688 1.632-1.201.58-.036.58-.036s.746-1.678-.906-1.232zm8.651-17.949c-2.242-.935-6.822-.993-9.377-2.255-1.121.07-1.62.955-1.666 1.307-1.172-.058-1.966 1.787-1.793 2.152-2.133-.864-3.126 2.511-2.434 3.203-1.82.077-1.595 2.402-1.768 3.049-.583 1.415.13 1.892 1.281 1.383.173.615-.07.96-.59 1.076 3.158 3.614 4.943-2.223 7.713-2.203 3.458-1.012 4.816-2.716 4.816-2.716l1.358.18 2.46-5.176z'/%3e%3ccircle cx='105.145' cy='87.384' r='3.305'/%3e%3cpath d='M99.33 113.41c-2.05-.372-5.444-2.498-5.79-5.278 1.908-7.494 11.755-3.58 12.604-9.217-.217-3.719.45-7.4 2.512-10.511.96-1.217 2.203-1.537 2.203-1.537s.223.793-.102 1.332c1.626-.18 3.856.73 5.38.82.448.91.41 1.242.307 1.793-.102.551-.717.41-.717.41-.398.377-.876.761-1.947.564-.807.615-2.511.768-2.511.768s3.561 3.754 2.972 4.92c.743.345 1.845 1.998 1.845 1.998s2.434-1.281 3.228-2.46c1.41 0 3.715 1.474 4.868 1.64 1.41 1.14 2.818 2.306 2.818 2.306s-1.678 1.102-2.408-.359c-.884.077-2.793-2.037-5.432-1.383-.077 2.344-2.664 3.997-2.664 3.997s2.415-.338 3.74.46a139.033 139.033 0 0 0 3.382 2.717l1.794 3.074s-1.64.282-2.255-1.845c-.615 1.717-.64-1.063-3.074-2.357-.743.09-1.115.141-1.743-.358-1.755.474-3.83 1.498-6.302 1.23-1.755.55-3.037 2.01-4.817 2.818-1.78.807-2.306.41-2.306.41l-1.435.05c-.207.865-.09 2.179-.87 2.41.499.537-.36 2.83-1.23 3.227.41 1.474 1.61 1.925 2.869 2.665 0 0 1.114-.512 1.844.154s1.486 2.562 1.486 2.562-1.52.103-1.998-.103c-.479-.205-.525-.704-1.076-.563-3.472-3.088-5.302-1.86-5.637-2.562-.342-.72.82-2.6.462-3.792z'/%3e%3cpath d='M90.99 99.655c.181-.226 1.45.254 1.45.254l2.318 1.449 4.71 3.044 1.667 2.427-3.007-.978-4.167-3.587-2.246-1.45s-.906-.933-.725-1.16zm27.86 7.715c-1.627-.41-5.637 4.458-5.637 4.458l3.024 3.28s.09-5.586 2.613-7.738z'/%3e%3cpath d='M99.023 93.789c-.887 1.137-.967 3.429.188 4.353.108 1.391 1.291 4.197 2.22 4.46 1.016.288 5.073 1.23 6.662.974-.304 2.575 1.716 4.641 3.587 5.995-.014.232-.017.514.199.8.21.276 1.192.326 1.235.174.436.613 2.548.882 2.7.609.15-.266-3.105-2.53-3.827-3.222-.613-1.144-1.775-3.694-2.05-5.74-1.597-1.9-4.34-1.862-4.34-1.862l.087-3.723.154-4.202-1.486-.768s.3-.137.461-.308c.361.156 1.04-.57 1.128-.774.341.12.65.12.71-.064.054-.16.115-.879.24-1.25 1.12-.987-.164-3.08-1.878-3.114-1.697-.035-2.077 2.023-2.044 2.18.159.645.125.97 0 1.126-.128.16-.718.513-.718.513s-.948-.449-2.1 0-2.448 1.05-2.512 1.793c-.525.077-1.383.756-1.537 1.333-.461-.09-1.063.294-2.05 1.896-1.767.781-1.87 4.56-1.87 4.56s-.477.695-.5 1.063c-.022.369.167.705.398.64.025.244.346.462.486.385.052.244.403.38.615.346.02.167.702.125.756-.026.06-.166-.067-.996.013-1.063.074-.06.64.372.794.256.154-.115-.03-.484-.115-.627-.077-.128-.564-.27-.679-.871s.307-1.435.307-1.435 1.922-1.512 2.14-2.806c1.447.141 2.213-1.124 2.626-1.601z'/%3e%3cpath d='M95.679 88.37c.439-1.073 2.024-.974 2.024-.974s.567-1.492 2.703-.602c.804-.621 2.92.27 2.92.27s.794-1.057 1.833-.936c1.925.224 2.245 1.989 2.126 2.293-1.053.266-2.879-.856-4.266-.538-.81.458-2.123.942-2.613 1.602-1.284.134-2.655-1.182-4.727-1.115zm4.01 1.781c.48-.295 1.659-.813 2.46-.18.839.904 2.126 1.743 2.126 1.743l1.46.615.667.41-.436 6.687c-1.352-1.383-2.619-1.626-3.587-3.254-.519-.698-.122-2.376-1.025-3.485-.903-1.108-1.864-1.857-1.665-2.536z'/%3e%3cpath d='M103.2 92.082s.765-.145.978.036c.268.09.526.168.598.399.29.086.49.235.49.453.271.072.38.561.38.561l-.254.38s-.29-.271-.326-.56c-.183-.091-.589-.187-.688-.454-.317-.031-.521-.195-.58-.47-.295.067-.598-.345-.598-.345z'/%3e%3cpath d='M109.68 87.717c-.436-.487-1.204-.128-1.204-.128l-2.05 3.536-.897.743-.077 2.767.743 2.587-.256 1.999s1.032-.969 1.153-1.512c.116-.519-.384-2.203-.384-2.203s-.615-1.05.128-2.998c.743-1.947 2.434-3.561 2.844-4.79z'/%3e%3cpath d='M114.74 90.868s-3.2 4.573-8.44 6.2c-1.447.346-.922-3.382-.922-3.382l-.359.103s-.807 3.65 1.127 3.69c5.266-1.038 9.216-6.581 9.216-6.581l-.63-.028zm2.17 26.292s-.487.359-1.127 0c-.333-.769-1.23-.82-1.23-.82s-.578-1.66-1.486-1.178c-.141-.859-1.127-.41-1.127-.41s-.026-1.243-1.179-1.076c.384-1.423-1.589-1.333-1.589-1.333s-.064-1.601-2.972-1.28c6.265-2.806 11.222 4.406 11.222 4.406m2.458 2.301s1.448 1.627 2.203 1.64c.756.013.82-1.589.82-1.589s.244.692.615.513c-.038.486.461.615.461.615s-1.306 3.036-5.021.153m-10.408-.712-.512 2.1s-.654.59-.462.718c.193.128 1.23-.205 1.23-.205s1.614-.192 2.101-.666c.333.756 1.076.82 1.076.82s.051-.32-.051-.512c.359.064.666-.052.666-.052s.205-.589-.256-.82c.051-.435.269-.82-.512-.768-.577.615-1.999 1.32-2.358 1.076-.358-.243 1.41-1.025.923-2.05'/%3e%3c/g%3e%3c/svg%3e";
            },
            6550: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 4'%3e%3cpath fill='%2300A551' d='M0 0h6v4H0z'/%3e%3cpath fill='%23FFD500' d='M0 0h6v3H0z'/%3e%3cpath fill='%231A206D' d='M0 0h6v2H0z'/%3e%3cpath fill='%23EA2839' d='M0 0h6v1H0z'/%3e%3c/svg%3e";
            },
            9709: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 720 480'%3e%3cpath fill='%23D21034' d='M0 0h720v480H0z'/%3e%3cg fill='%23007E3A'%3e%3cpath d='M120 120h480v240H120z'/%3e%3ccircle cx='390' cy='240' r='80' fill='%23FFF'/%3e%3ccircle cx='420' cy='240' r='80'/%3e%3c/g%3e%3c/svg%3e";
            },
            448: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-225 -114 450 300'%3e%3cpath d='M-225-114h450v300h-450z'/%3e%3cg fill='%23CE1126'%3e%3ccircle r='64.5'/%3e%3cpath d='M-225-14h450V86h-450z'/%3e%3cg id='e'%3e%3cg id='d'%3e%3cg id='c'%3e%3cg id='b'%3e%3cpath id='a' d='M0-102c-2.2 0-3 3.3-3 6.5 0 8 1 12 3 23.5 2.04-11.5 3-15.6 3-23.5 0-3.3-1-6.5-3-6.5'/%3e%3cuse xlink:href='%23a' transform='rotate(5)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(10)'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='rotate(20)'/%3e%3c/g%3e%3cuse xlink:href='%23d' transform='rotate(40)'/%3e%3c/g%3e%3cuse xlink:href='%23e' transform='rotate(-80)'/%3e%3c/g%3e%3cpath d='M-225-21.5h450v7.5h-450z'/%3e%3cpath fill='%23339E35' d='M-225 86h450v100h-450z'/%3e%3c/svg%3e";
            },
            7925: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 980 560'%3e%3cdefs%3e%3cradialGradient xlink:href='%23a' id='b' cx='842.31' cy='103.66' r='25.859' gradientTransform='matrix(.18574 .04718 -.04532 .18635 233.798 198.77)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='c' cx='651.52' cy='550.46' r='25.859' gradientTransform='matrix(-.17642 -.07067 .06515 -.16392 430.544 377.876)' gradientUnits='userSpaceOnUse'/%3e%3cradialGradient xlink:href='%23a' id='d' cx='380.84' cy='740.37' r='25.859' gradientTransform='matrix(.0989 .0037 -.0045 .1943 442.362 123.304)' gradientUnits='userSpaceOnUse'/%3e%3clinearGradient id='a'%3e%3cstop offset='0' stop-color='%23fff'/%3e%3cstop offset='1' stop-color='%23f15770'/%3e%3c/linearGradient%3e%3c/defs%3e%3cpath fill='%23ce1126' d='M0 0h980v560H0z'/%3e%3cpath fill='%23fff' d='M0 0h653.333v560H0z'/%3e%3cpath fill='%23006847' d='M0 0h326.667v560H0z'/%3e%3cg fill='%23fcca3e' stroke='%23aa8c30' transform='translate(-.699 1.184) scale(1.16833)'%3e%3cpath stroke-width='.35' d='m466.96 303.53.293 5.878 2.22-1.467-1.702-4.839z'/%3e%3ccircle cx='466.703' cy='301.93' r='1.892' stroke-width='.3'/%3e%3cpath stroke-width='.35' d='m474 312.69-4.3-4.119-1.932 1.553 5.843 3.405z'/%3e%3cpath stroke-width='.3' d='M473.63 315.01c-.608-.815-.403-2.003.446-2.658.853-.655 2.037-.524 2.645.288.602.815.403 2.007-.448 2.662-.854.653-2.037.52-2.643-.292z'/%3e%3cpath stroke-width='.35' d='m507.04 251.22 4.407 4.384.512-2.219-4.028-2.7z'/%3e%3ccircle cx='506.451' cy='250.09' r='1.845' stroke-width='.3'/%3e%3cpath stroke-width='.35' d='m518.65 253.82-6.733 1.921.554-2.224 5.79-.563z'/%3e%3ccircle cx='519.742' cy='252.89' r='1.803' stroke-width='.3'/%3e%3cpath stroke-width='.35' d='m496.03 287-4.108-6.398.661-.33 4.647 5.489z'/%3e%3ccircle cx='491.518' cy='279.115' r='1.909' stroke-width='.3'/%3e%3cpath stroke-width='.35' d='m496.29 287.17 5.218.953.192-.715-4.37-1.732z'/%3e%3ccircle cx='503.102' cy='288.18' r='1.889' stroke-width='.3'/%3e%3cpath stroke-width='.3' d='M373.59 301.72c0 .91-.714 1.556-1.391 1.556-.672 0-1.22-.735-1.22-1.64 0-.909.548-1.644 1.22-1.644.677 0 1.391.824 1.391 1.728z'/%3e%3cpath stroke-width='.35' d='m373.56 304.65 1.195 6.566-1.59-.628-.57-5.705z'/%3e%3cpath stroke-width='.3' d='M375.01 302.42c.767.994-.531 2.511-1.91 2.889-1.377.375-3.097-.26-3.08-1.522.018-1.432 2.01-.687 2.545-.853.825-.26 1.62-1.584 2.445-.514z'/%3e%3cellipse cx='363.566' cy='312.49' stroke-width='.3' rx='2.045' ry='1.483'/%3e%3cpath stroke-width='.35' d='m367.03 312.14 6.307-.314-1.068-1.256-5.18.563z'/%3e%3cpath stroke-width='.3' d='M367.56 311.41c.526 1.597.57 3.774-1.218 3.545-1.791-.233-1.452-1.833-1.591-2.45-.256-1.121-1.307-2.13-.228-3.223 1.08-1.097 2.508.528 3.037 2.128z'/%3e%3cellipse cx='347.006' cy='276.955' stroke-width='.3' rx='1.236' ry='1.881'/%3e%3cpath stroke-width='.35' d='m347.03 281.12.144 6.11-1.59-1.444.112-4.866z'/%3e%3cpath stroke-width='.3' d='M349.39 279.26c.322 1.41-1.745 2.204-3.152 1.942-1.406-.258-2.47-.993-2.257-2.289.213-1.299 1.96-1.007 2.556-.647.596.355 2.405-.985 2.853.994z'/%3e%3cellipse cx='336.229' cy='286.5' stroke-width='.3' rx='2.13' ry='.973'/%3e%3cpath stroke-width='.35' d='m340.06 286.5 4.797-.325 2.043 1.58-6.915-.26z'/%3e%3cpath stroke-width='.3' d='M338.3 283.93c1.294.041 2.187 1.467 2.002 2.981-.183 1.514-1.348 2.738-2.54 2.553-1.194-.192-1.108-1.199-1.08-1.5.03-.304.696-.852.768-1.341.07-.486-.341-1.57-.187-2.073.157-.505.455-.638 1.037-.62zm-3.87-37.19c-.536.852-1.555 1.499-2.07 1.167-.518-.333-.333-1.52.201-2.373.533-.85 1.385-1.274 1.902-.941.517.334.5 1.294-.033 2.147z'/%3e%3cpath stroke-width='.35' d='m329.08 256.35 2.678-6.311-.4-.346-3.036 4.432z'/%3e%3cpath stroke-width='.3' d='M331.27 250.05c-1.326-.97-1.619-1.964-1.192-2.943.425-.979 1.419-.344 1.419-.344s.653.722 1.135.978c.483.262 1.252-.083 1.819.72.569.807.227 1.613-.228 1.816-.455.2-1.845.576-2.953-.227zm-11.13-.83c.95.543 1.456 1.458 1.13 2.056-.328.59-1.367.634-2.32.09-.947-.54-1.453-1.458-1.125-2.053.327-.594 1.363-.635 2.315-.093z'/%3e%3cpath stroke-width='.35' d='m322.92 251.99 4.946 2.966-.144 2.333-5.368-4.612z'/%3e%3cpath stroke-width='.3' d='M322.88 252.55c-1.097 1.225-2.104 1.41-3.013.868-.912-.543-.177-1.473-.177-1.473s.78-.574 1.089-1.03c.31-.459.06-1.272.914-1.751.855-.478 1.605-.043 1.753.44.144.48.35 1.922-.566 2.946z'/%3e%3c/g%3e%3cg fill='%23aa8c30'%3e%3cpath d='M546.112 356.319s-.42.28-.65.733c-.22.452-.473 1.362-.473 1.362l.026-2.22.748-.432.35.557z'/%3e%3cpath d='M546.44 354.929s-.517.876-1.744.807c-1.221-.066-1.822-.636-1.97-1.262-.15-.62-.15-1.074.245-1.801.399-.723-.579.69-.579.69v1.381l.896 1.062.76.234.752.048.961-.317.645-.488zm6.461 11.286s-.619.322-1.091.15c-2.898-1.028-5.33-2.727-5.33-2.727l5.82 3.615zm3.621 1.647s-.064 1.018-1.191 1.524c-1.125.507-1.914.274-2.326-.213-.41-.488-.615-.891-.588-1.72.036-.828-.205.88-.205.88l.619 1.232 1.272.53.79-.139.686-.302.714-.728.36-.734zm37.212-72.961s-.148.228-.148.605c0 .38-.023 1.062-.023 1.062l-1.268-1.411.64-.834zm-.678-1.835c.074 1.01-1.392 2.446-2.487 1.992-1.094-.45-1.89-1.59-1.291-2.727.596-1.136-.3.43-.3.43l.152 1.667 1.041.957 1.296.077 1.021-.577.621-1.14zm15.387 2.746s-.248-.692-.121.087c.12.785-.883 2.463-2.057 2.31-1.166-.151-1.702-1.172-1.602-2.122.099-.945-.198.328-.198.328l.185 1.266.626.593.895.53 1.044-.18.947-.606.421-.89v-.634z'/%3e%3cpath d='M603.173 296.98s.04.53-.656.91a81.278 81.278 0 0 0-2.015 1.162l4.33-1.261-.359-1.05-1.3.24zm-26.217 34.337s-.233.255-.246.793a6.47 6.47 0 0 0 .11 1.192l-2.426-3.837.72-.456 1.843 2.308zm-1.332-3.61c-.432 1.012-2.198 1.654-3.045 1.162-.846-.49-1.566-2.324-.532-3.13l-.538.469-.275 1.045.389 1.097.846.957.781.24 1.247-.25.907-.708s.658-1.89.22-.882zm8.552 8.798s.024.452-.77.452c-.795 0-2.462.026-2.462.026l4.03.778.2-.804z'/%3e%3cpath d='M589.13 337.45c.361 1.346-.834 2.642-2.376 2.189-1.542-.458-1.957-1.989-1.472-2.814l-.381.961.28 1.28.946.823.967.21.989-.244 1-.959.248-1.145zm-151.8 17.105c.416.47-.23 2.221-1.973 2.928-1.742.703-2.606.032-3.07-.556-.464-.588-.432-1.21-.432-1.21l-.248.317.233.912.881.755 1.54.335 1.147-.216 1.129-.607.579-.607.498-.74.067-.907-.283-.457h-.067l-.027.036z'/%3e%3cpath d='M435.776 358.376s-.298.098-.563.54c-.263.435-.364 1.207-.364 1.207l-.135-2.05.898-.473zm-5.806 6.168s-.165.439.299.672c.465.24 1.56.506 1.56.506l-2.854.1-.298-1.108 1.293-.17zm-.97 1.776s.033.102.027.29c-.01.19-.06.467-.226.821-.333.703-.465 1.516-1.492 1.31-1.03-.2-1.46-.976-1.56-1.646-.1-.673-.332-.941-.332-.941v.905l.629 1.515 1.028.473h.897l.697-.27.33-.91.17-.74z'/%3e%3cpath d='M421.803 366.122s.333 1.313 1.793 1.346c1.46.037 1.825-.407 1.825-.407l.165.507-.53.268-1.268.144-1.116-.221-.519-.384-.395-.689zm-14.476-38.953s.05.15-.05.631c-.1.477-.994 1.616-2.663 1.639-1.666.028-2.362-.531-2.81-1.086-.449-.554-.524-1.337-.524-1.337l-.05.833.647 1.035 1.642.773 1.568.01 1.593-.466.697-.773.163-.847-.213-.41zm-2.64 3.54s-.596.052-.895.318c-.297.268-.56.592-.56.592l-.024-1.981 1.479.112zm-7.173 5.235s-.115.115.749.505c.863.388 4.795.806 4.795.806l-6.306-.17.233-1.076zm-.713.116s-.017.24-.331.877c-.314.64-1.109 2.34-2.437 2.105-1.33-.236-1.162-1.163-1.162-1.312 0-.153-.018-.473-.018-.473l-.231.961.314.672.547.34 1.08.134.728-.322.796-.759.416-.807.332-.858zm-3.4.164s-.036.3-1.08.339c-1.045.027-2.537-.424-2.537-.424l.496.621.863.22 1.078.016.846-.083zm-3.213-44.292s.232.675-.365 1.112c-.596.436-1.893.705-2.721.233-.83-.471-2.325-1.985-2.325-1.985l.7 1.248 1.093.91 1.525.434 1.46-.23.665-.578.2-.469z'/%3e%3cpath d='M385.737 293.954s.032.173 0 .843c-.033.674-.3 1.787-.3 1.787l1.328-2.967-.53-.472zm-8.225 2.324s-.198-.204.198.673c.398.878 3.65 4.006 3.65 4.006l-5.176-4.371.596-.848.731.54zm-1.73.503s-.664.41-1.261.439c-.597.035-1.592-.032-1.725-.741-.132-.703.199-1.006.199-1.006l-.43.975.165.535.765.44 1.062.101.96-.471.266-.27zm-2.09-2.22s.064.202-.898.068c-.962-.135-2.122-1.245-2.122-1.245l.762 1.21 1.627.674z'/%3e%3c/g%3e%3cg fill='%239ca168'%3e%3cpath d='M612.45 280.238c-.47 5.88-6.27 8.882-9.305 11.08-3.04 2.2-4.507 4.926-4.507 4.926l-1.02 3.428-.5 2.193-.098.763c.2.61.46 1.67.497 3.26.079 2.673-.17 6.483-.17 6.483l4.082-2.928 2.958-1.111.895-.144s-3.284 3.266-4.578 6.8c-1.292 3.535-3.683 11.042-8.162 13.462-4.476 2.426-7.268 1.418-8.76 2.731-1.49 1.31-1.543 1.662-1.543 1.662l-1.907 2.611-1.51 1.952-1.411.976-.891.722c-.031.728-.119 1.672-.362 2.54-.49 1.726-1.072 3.646-1.072 3.646s.894-.544 1.98-.679c1.078-.14 2.086-.127 2.086-.127s-.844 1.034-1.141 2.044c-.3 1.011.198 7.07-5.573 10.703-5.775 3.635-20.474 3.063-20.474 3.063l-2.784 1.108-2.62 1.957-2.393 2.623-.179.707s-1.807 2.204-3.106 3.065c-1.29.857-4.276 2.823-4.276 2.823s2.534-.096 3.385.201c.843.309 5.372 2.327 5.372 2.327s-3.318-.067-5.573.806c-2.259.875-12.541 6.698-17.518 6.53-4.974-.165-12.079-7.439-12.079-7.439l-3.218-2.254-5.34-1.041-6.605-.372.094-.865.125-1.068s2.241-.254 5.846.17c3.082.37 4.108 1.393 6.694 1.694 2.59.303 4.502-.074 5.45-.5.946-.437 8.932-7.199 8.932-7.199l8.982-3.151 3.433.5 1.52.406 1.396.404s-.47.733-1.469 1.667c-.994.931-2.241 1.566-2.241 1.566l1.098.878 5.67-.905 1.852.478s.144.039.533.284c.088-.409.315-1.257.826-1.924.697-.907 3.883-3.508 5.248-4.416 1.374-.908 1.67-1.035 2.12-1.515.446-.48 2.288-5.229 2.288-5.229l.25-2.419 6.271-6.036 4.228-4.493 1.844-5.124-.2-1.033s1.519 1.564 1.244 4.744c-.273 3.18-.971 4.292-.971 4.292s4.277-2.954 6.57-3.965c1.837-.81 3.194-.756 3.664-.705.604-.343 2.252-1.362 3.251-2.826 1.246-1.815 1.57-2.35 1.57-3.08 0-.733.2-4.267.2-4.267l-.4-10.83 3.684-8.153 5.348-4.797 1.021-.607s-.425 1.135-.5 1.92c-.074.781-.074 2.168-.074 2.168s2.711-3.708 4.106-4.39c.319-.155.601-.288.856-.407a10.71 10.71 0 0 0 1.104-2.994c.43-2.053.5-4.81.5-4.81l.082-4.485-.871-3.487-2.49-6.69-.1-8.808-1.864-2.515s1.766-.138 3.954 3.02c2.189 3.157 2.839 7.598 2.839 7.598l5.083-15.6s1.364 1.842 2.328 4.921c.976 3.08 1.272 5.175 1.272 5.175l2.001-4.33c-.017.046-.06.3.24 1.529.345 1.437 3.455 3.232 2.985 9.113zm-103.194 99.711s-.951-2.388-5.845-4.812c-4.895-2.421-8.54-2.893-8.54-2.893l-.054 1.8 7.683 3.35 3.83 3.131 2.925-.576z'/%3e%3cpath fill='%23717732' d='M544.232 365.291c.472-.63 4.608-4.314 6.72-5.4 2.117-1.088 4.925-1.287 4.925-1.287 2.913-.534 3.386-.102 10.105-3.812 6.72-3.709 8.213-7.978 9.506-9.012 1.293-1.037 3.655-1.287 3.655-1.287s-2.812 3.307-5.272 6.006c-2.464 2.705-5.104 4.418-8.888 6.97-3.78 2.549-11.64 2.676-11.64 2.676-3.312.76-4.43 1.562-6.273 3.177a22.266 22.266 0 0 0-3.092 3.376s-.217-.775.254-1.407zm18.54-19.461c-6.218 5.68-8.262 10.957-8.262 10.957s5.526-4.744 8.362-7.47c2.838-2.727 6.816-4.042 8.61-5.708 1.793-1.667 1.892-3.078 3.035-4.141 1.143-1.058 1.994-1.565 1.994-1.565s-2.74-2.118-13.74 7.927zm-13.12 13.147s2.66-1.167 3.666-3.555c.748-1.767.35-2.218 1.494-4.24 0 0 6.469-6.248 8.755-8.937 4.083-4.797 2.241-8.733 2.241-8.733s.447 2.02-1.243 4.138c-1.693 2.12-10.039 7.826-11.05 11.11-1.014 3.282-.447 3.4-.896 5.147-1.034 4.022-2.967 5.07-2.967 5.07zm-4.299 16.138s-3.254-2.184-6.9-1.952c-7.432.473-13.719 5.047-18.627 5.182-4.915.136-6.844-2.328-10.637-4.914-4.046-2.759-14.066-2.358-14.066-2.358l-.063.239-.07.292s6.89.07 9.827.885c5.612 1.548 8.636 7.39 15.008 7.018 8.268-.488 15.047-5.523 18.427-5.506 5.807.038 7.1 1.114 7.1 1.114zm-36.867-3.764s5.765 1.039 10.243-2.246c4.479-3.282 9.801-7.723 12.74-7.925 2.936-.202 6.023.555 6.023.555s-3.736-1.666-6.718-1.618c-2.99.052-6.023.457-8.813 2.123-2.786 1.667-4.13 4.693-7.164 6.613-3.038 1.922-6.312 2.498-6.312 2.498zm-1.03 7.752c-.77 0-1.668.5-1.967.453-.297-.048-2.063-1.869-4.527-3.179-2.465-1.312-6.137-2.105-6.137-2.105s-.458.114.364.389c.82.28 3.856 1.31 5.795 2.219 1.943.913 3.906 2.98 4.083 3.308.174.333.871 1.261 2.314 1.21 1.445-.049 2.017-.877 1.863-1.438-.143-.553-1.017-.857-1.788-.857zm4.056-5.602s2.283 1.302 6.069 1.21c8.065-.202 13.14-5.722 18.423-7.741 5.27-2.023 7.975-.272 7.975-.272s.14-.285-.03-.408c-.745-.557-3.194-1.886-5.894-1.846-8.86.135-17.151 5.721-20.765 7.235-3.495 1.462-5.777 1.822-5.777 1.822zm85.747-61.07c-2.717 2.806-6.772 11.767-8.561 14.213-1.789 2.45-4.034 3.18-5.001 4.167-.851.865-4.106 5.249-4.853 6.312-.745 1.058-.971.756-1.493 1.21-.52.453-.796.48.074.25.871-.223 1.145-.755 2.488-2.269 1.342-1.516 1.27-2.198 3.407-4.115 2.14-1.922 6.016-4.106 7.942-6.465 1.921-2.355 5.848-11.475 7.9-13.695 2.224-2.409 6.107-3.84 6.107-3.84s-3.06-.892-8.01 4.232zm-13.785 16.993s-.1-1.617 1.891-3.992c1.99-2.375 2.688-2.068 4.278-5.554 1.592-3.483 2.294-6.864 3.585-10.549 1.291-3.69 3.532-7.326 3.532-7.326s-2.089.202-4.23 3.084c-2.143 2.878-5.527 8.13-7.269 13.279-1.742 5.15-1.787 11.057-1.787 11.057zm-2.54 3.376s.747-.398.844-4.892c.103-4.494-.246-10.803 1.049-13.934 1.291-3.129 8.161-10.655 8.161-10.655s-2.839.707-6.819 3.888c-3.977 3.179-5.672 7.172-5.473 10.196.2 3.035 1.894 6.465 2.043 9.446.143 2.976.196 5.951.196 5.951zm16.172-30.926s1.695-6.092 2.388-7.575c.703-1.483.734-2.357 4.181-6.225 1.978-2.22 3.92-3.64 4.744-6.733.831-3.101.801-11.746.801-11.746s-.896.803-1.625 2.32c-.733 1.518-.2 7.133-1.495 9.724-1.296 2.595-4.213 8.69-5.675 10 0 0-.297-4.375.234-8.786.53-4.408 2.026-5.752 2.687-8.649.664-2.89.265-10.367.265-10.367s-2.353 2.428-3.519 5.218c-1.156 2.793-1.855 7.807-1.889 11.577-.035 3.772.865 6.835.998 8.988.127 2.154.294 3.165-.568 5.52-.861 2.356-.429.74-.961 3.03a52.855 52.855 0 0 1-1.092 4.007zm-5.37-33.053s2.054 2.59 1.72 5.553c-.332 2.96-1.458 6.867-.297 9.963 1.162 3.094 2.888 3.4 3.353 5.18.466 1.784.495 5.266.495 5.266s.962-6.613.3-8.43c-.662-1.814-.962-.977-1.923-2.894-.964-1.915.031-7.166-.698-10.228-.729-3.065-2.95-4.411-2.95-4.411z'/%3e%3cpath d='M469.61 379.429s.624-1.74 4.804-3.783c4.18-2.046 10.473-4.8 11.071-4.446.598.355-.324 2.629-.324 2.629l-4.054 1.234-3.234 1.896-3.782 2.447z'/%3e%3cpath d='M480.266 368.435c-5.342.202-8.255 1.515-9.282 1.718-.354.07-1.123.615-1.78.29-1.252-.62-2.342-2.34-2.342-2.34l-1.129-.943-.265 3.834-7.797-6.761-.831 4.472-.995 2.058-7.73-7.307.365 5.654s-2.023.266-2.123.202l-5.508-3.837-1.624.54 1.792 3.33-6.97.541s-.562.306-1.509 1.176c-.945.872-1.469 1.691-1.469 1.691s-.21.355.037.518c.25.164 2.155.127 2.752-.102.597-.228.982-1.06 1.157-.72.172.344.396 1.871 1.319 1.72.92-.153 4.159-2.607 6.469-1.528 2.573 1.199-3.335 2.941-2.724 4.772.605 1.82 4.863 1.047 5.945.463 1.082-.577 4.315-4.61 5.636-3.078 1.842 2.134-3.867 3.787-2.81 5.918 1.02 2.057 4.205 1.594 5.746.708 1.545-.882 5.13-6.4 5.925-5.212 1.379 2.067-3.024 4.04-1.919 5.64 1.109 1.602 3.547-.058 5.166-1.198 1.617-1.136 2.264-3.84 4.502-5.099 2.24-1.262 2.089-.735 2.704-.757.618-.028 2.347-1.74 2.347-1.74l5.265-2.236 2.576.188 1.33.63 2.639.369.31-2.225s-3.053-1.428-5.175-1.35zm-42.123.042 1.115-1.978-.631-.96s-1.858-1.04-3.55-2.754c-1.692-1.72-2.31-2.113-3.086-2.5-.775-.391-3.382-2.089-3.382-2.089l-1.176-4.338-.695-1.254-2.01.788-2.65-9.332-.516-1.672-1.094-.064-2.171 5.657-2.428-3.533-.617-7.733-1.513 1.697-1.95 1.98-3.463-7.01s-.282-.18-.459.404c-.175.569-.473 2.782-.257 4.095-.926-.578-2.518-1.67-4.649-3.506-3.518-3.03-4.364-4.587-4.364-4.587l-1.64-3.707 1.54-3.259.772-3.887-3.384 1.385-.597-8.786-.523-2.774-4.081 5.832s-1.59-2.248-1.59-2.5c0-.25.073-5.552.073-5.552l-1.095-.33-1.67 3.13s-1.603-3.23-2.31-3.919c.113-1.24.298-4.409-.455-6.856-.955-3.115-2.07-4.773-1.673-7.315.401-2.543 1.433-2.786 1.315-3.918-.12-1.129-1.792.73-1.234-.765.558-1.492 5.893-4.886 4.778-6.663-1.116-1.778-6.25 2.787-5.057-.28 1.193-3.07 6.13-3.113 6.41-7.392.173-2.666-4.66 1.657-5.097.322-.437-1.331 2.984-4.076 2.947-5.813-.04-1.736.637-1.936-.32-2.866-.954-.929-3.9 3.633-3.9 3.633l-3.224-1.214-1.117 4.607-.993 3.915-3.982-2.338 1.074 4.765.957 4.644-4.142-1.051 2.191 3.956 2.853 2.9 1.763 2.39 1.277.686 1.71 1.7.597 2.544s.997 2.788.997 2.91c0 .12.158 2.744.158 2.744l.04 1.815-.09 1.41-.06.531-.088.606-.035 1.662c-.779.075-2.043-1.191-2.505-.402-.496.86 2.39 3.08 1.842 3.635-.547.559-4.777-.857-5.025.505-.25 1.364.398 3.28 2.837 3.887 2.437.607 8.11 1.918 7.166 3.027-.947 1.115-7.117-3.38-6.867-.097.248 3.279 2.389 4.642 3.981 5.25 1.592.607 7.811-.098 7.464 1.363-.348 1.466-5.076-.455-5.524 1.665-.447 2.124 3.285 2.423 4.084 2.423.795 0 3.381-.099 4.376.658.997.757 4.478 4.443 6.67 6.311 1.859 1.584 5.873 4.365 7.045 5.173l-.057-.007c-1.18-.11-3.623-.369-4.011.511-.495 1.136 9.359 4.649 6.53 5.74-2.826 1.086-5.873-3.01-6.689-.507-.818 2.503 1.872 4.62 3.407 5.53 1.532.91 10.27.185 8.558 2.16-1.712 1.983-8.043-1.332-8.102 1.013-.06 2.345 4.22 6.059 6.41 5.955 2.191-.099 4.597-3.614 5.594-1.715.996 1.898-1.693 2.667.417 3.172 2.11.502 3.603-2.162 6.051-1.679 2.448.486 6.292 2.037 8.442 3.996a121.125 121.125 0 0 1 4.358 4.222z'/%3e%3cpath fill='%23717732' d='M472.17 378.342c1.494.027 1.692.833 1.892.81.2-.028 2.713-2.173 5.1-3.485 2.39-1.315 6.022-2.095 6.022-2.095l.226.328s-4.327 1.081-6.419 2.548c-2.59 1.819-4.628 2.957-4.755 3.283-.125.325-1.068.96-2.537.986-1.467.02-2.091-.855-2.091-1.29 0-.426 1.07-1.108 2.561-1.085zm13.039-6.605s-1.292.135-2.023-.507c-.73-.64-2.356-1.21-3.917-1.21-1.558 0-4.056.86-6.035 2.756-.16.155-.557.884-2.26 2.023.592.114 1.738-.671 2.987-1.682 1.793-1.458 4.048-1.853 5.64-2.083 1.592-.242 2.589.67 3.32 1.171.729.51 2.22.369 2.22.369zm-77.4-31.631c.16-.068.136-.42.03-1.032-.24-.09-1.204-.496-3.369-1.787-2.537-1.515-7.813-5.708-7.813-5.708s2.193 2.123 4.382 4.092c2.188 1.967 6.122 4.39 6.122 4.39l.02.016c.335.033.576.052.628.029zm54.642 38.707s.796-1.045 2.214-3.325c1.418-2.282 2.712-3.011 2.91-3.29.2-.276-.547-1.388-.971-2.248-.421-.858-.347-1.765-.347-1.84 0-.076.52 1.336 1.566 2.12a14.6 14.6 0 0 1 1.676 1.437s2.08-.277 2.133-.681c.05-.406-.052-.682-.4-.832-.346-.153-.746.31-1.691-.105-1.965-.854-2.763-3.835-3.933-3.935-1.168-.1-.333 3.157-.846 3.204-1.817.176-3.235-6.612-7.59-6.89-3.064-.198-3.608.38-3.757 1.06-.147.68 3.708 4.749 2.414 5.324-1.294.586-5.4-6.384-8.386-6.463-2.984-.075-3.234 1.064-3.01 1.719.222.657 3.309 1.236 2.587 3.41-.7 2.108-3.707-3.255-6.468-2.956-2.762.303-3.062.505-3.187 1.287-.122.783.971 1.919.574 2.196-.398.277-2.141.2-3.534 1.16-1.392.963-3.335 3.587-3.335 3.587s1.817-2.574 4.23-2.853c2.413-.275 8.511.027 8.511.027s-.82-.507-1.716-1.314c-.896-.809-1.669-2.448-1.669-2.448s1.345 1.263 2.64 2.321c1.292 1.064 2.91 1.87 2.91 1.87s2.588.253 2.763.557c.173.303-.077.907-1.144 2.066-1.072 1.162-2.614 2.529-2.614 2.529s2.587-1.97 3.085-2.4c.498-.428 2.29-1.792 2.29-1.792s1.892.25 2.09.202c.198-.05.108-.707-1.161-2.574-1.268-1.868-2.472-3.89-2.472-3.89s1.56 1.433 3.135 3.511c1.575 2.077 1.344 3.036 1.99 3.14.648.1 1.692.242 2.164.219.636-.033.473.905-.623 2.574-1.093 1.666-1.739 3.809-1.739 3.809s1.117-1.793 2.312-3.027c1.194-1.238 1.818-2.704 2.29-2.78.475-.074 2.074.126 2.3.03.22-.104-.384-.76-1.229-2.48-.846-1.714-1.12-4.09-1.12-4.09s.821 2.227 2.116 3.84c1.294 1.614 1.792 2.914 2.073 2.932.281.013 1.282-.116 2.008-.106.365.007.406-.08.447.15.124.713-.175 1.139-1.044 2.78-.871 1.64-1.442 3.258-1.442 3.258zm-33.045-19.165c1.866.636 2.587.636 2.587.636s-2.563-1.518-3.235-3.664c-.674-2.143-.074-6.665-1.169-6.612-1.095.052-1.718 3.332-2.812 2.677-1.096-.655.372-6.693-.822-9.264-1.193-2.577-4.006-4.37-4.654-3.437-.646.94-.495 6.489-2.238 5.278-1.742-1.21.15-5.958-.375-8.129-.521-2.173-1.839-3.737-2.834-3.207-.998.534.394 4.596-1.172 4.645-1.567.052-1.343-2.854-2.015-3.13-.67-.277-.896.585-1.27.03-.373-.559-.172-2.629-.994-2.427-.821.202-.671 1.793-.449 2.673.224.886.721 2.149 1.07 2.73.347.581 1.593 1.31 1.495 1.794-.1.48-.75.884-1.592.907-.848.026-2.764-.053-2.764-.053s2.039.635 2.81.711c.772.074 2.268-.328 2.639.353.372.684 2.165 3.104 2.165 3.104s.421-1.262.646-3.486c.224-2.217.124-4.166.124-4.166s.597 2.578.522 4.119c-.072 1.536-.646 4.541-.646 4.541s1.69 1.414 1.195 1.793c-.497.38-2.265.331-4.33.304-2.064-.027-5.001-.733-5.001-.733s2.638 1.264 4.477 1.564c1.843.306 5.849.405 5.849.405l2.737 3.102s1.31-2.25 1.493-4.487c.184-2.241-.05-4.839-.05-4.839s.572 2.337.674 4.333c.098 1.997-.65 5.528-.897 5.83-.25.305-1.647 1.173-2.879 1.483-1.807.455-5.433.914-5.433.914s3.345.447 5.749-.127c2.406-.568 2.687-1.237 3.358-.831.674.406 1.271 1.138 1.271 1.138s1.44 1.117 2.091 1.412c.1.225-1.111.725-1.727 1.113-.612.386-2.231 1.135-2.231 1.135s2.365-.859 3.41-1.135c.523-.143 1.792-.608 1.792-.608l.696.38s.05-.505-.148-1.917a41.847 41.847 0 0 0-.499-2.78s.821 1.289 1.072 2.5c.246 1.211.246 2.447.246 2.447s.2.35 2.067.981zm-47.678-54.624s.532-2.56.532-5.519c0-2.967-2.06-7.545-2.39-8.013a7.528 7.528 0 0 1-.531-.878l1.392-2.15-1.79 1.41s-.994-.203-1.857-.739a3.978 3.978 0 0 1-1.295-1.344s.915.676 1.792 1.042c.875.362 1.094.235 1.094.235l-.691-2.988s-.913-.364-2.945-1.495c-2.031-1.132-3.863-2.907-3.863-2.907s2.748 1.657 4.3 2.3c1.554.649 2.43.69 2.43.69s1.632-.488 2.468-.974c.835-.483 2.549-1.777 2.549-1.777s-1.633.931-2.708 1.173c-1.075.245-2.428.4-2.428.4l-.48-3.63-1.71-1.776c-1.352-1.779-2.391-4.321-2.391-4.321s1.394 1.773 2.512 2.621c1.115.853 2.149 2.223 2.149 2.223s1.273-.688 2.507-1.533c1.232-.847 4.298-3.071 4.298-3.071s-1.75.927-4.179 2.06c-2.43 1.13-2.51 1.011-2.51 1.011s-.197-1.574.161-2.263c.36-.684 1.117-1.816.996-2.502-.12-.69-.636-.446-.836-1.011-.2-.568.637-4.036.637-4.036s.2 1.251.24 1.894c.04.644-.319 1.535.557 1.535.876 0 4.977-4.119 5.493-4.887.517-.766 1.276-2.866-.878-2.017-2.147.847-1.634 2.682-3.421 2.542-.519-.04-1.115-2.341-1.792-1.777-.677.57-2.19 1.98-2.47 3.596-.276 1.615.36 4.08-.556 4.805-.917.728-1.712-2.786-3.505-2.303-1.79.485-2.188 2.948-1.909 3.918.28.968 4.18 5.491 2.947 6.06-1.236.564-4.262-3.84-5.894-.85-1.633 2.986 5.136 6.059 5.97 6.786.836.729.082.932 1.275 2.424 1.195 1.491 2.789 1.858 3.624 2.87.834 1.009 3.304 5.81 3.304 8.92 0 3.111-.198 4.246-.198 4.246zm17.979 26.215s-1.658-1.935-1.108-5.111c.547-3.18 2.738-8.788 1.99-9.494-.745-.704-3.083 3.434-3.682 2.477-.598-.961 1.344-6.565.35-8.89-.998-2.32-1.095-3.784-3.086-3.582-1.993.201-2.837 6.765-3.782 5.605-.948-1.16.545-4.087-.1-5.653-.648-1.566-.997-2.123-1.992-1.873-.994.254-1.443 3.282-2.14 3.235-.697-.052-1.842-3.641-3.284-3.128-1.443.502 3.432 6.863 3.432 6.863s.87-.757 1.32-1.842c.448-1.088.895-2.273.895-2.273s.4 2.07.05 2.879c-.347.805-.621 2.701-.621 2.701s-1.196.378-3.16.073c-1.966-.299-3.584-1.108-3.584-1.108s1.32.884 3.333 1.412a125.61 125.61 0 0 1 4.156 1.189s.525.655 1.418 1.84a436.86 436.86 0 0 0 1.668 2.195s.574-1.21 1.146-3.204c.572-1.994 1.94-5.275 1.94-5.275s-.423 3.963-.897 5.906c-.47 1.946-.969 4.696-.969 4.696s-1.742-.175-4.08-.605c-2.339-.433-5.526-1.236-5.526-1.236s2.788 1.111 5.501 1.842c2.711.727 4.404 1.186 4.404 1.186l2.13 2.816s.583-1.024 1.429-2.207c.845-1.193 1.494-2.807 1.494-2.807s-.374 2.2-1.022 3.511c-.647 1.313-1.095 2.095-1.095 2.095s-1.37.33-2.637.3c-1.27-.022-3.858-.05-3.858-.05s2.166.731 3.882 1.015c1.717.275 2.962.45 2.962.45s.124.781 1.045 2.098c.919 1.31 2.078 1.954 2.078 1.954z'/%3e%3c/g%3e%3cpath fill='%23fff' d='M481.47 388.624s-.972-1.045-2.265-1.727c-1.293-.679-1.728-.478-1.728-.478l-.599-.213 1.134-2.955 8.522-8.142 1.319-8.181.314-.01 4.937-.05-.052 11.168 1.566.709 9.512 5.704-.03 2.483s-.47.167-1.39.53c-.922.367-1.143.637-1.143.637l-3.59.337-6.269-4.546-2.59-2.722-4.725 6.055-2.924 1.4z'/%3e%3cpath fill='%23016848' d='M488.175 366.916s-.14.431-.2 1.69c-.065 1.257.082 7.855-.24 8.758-.32.9-4.908 2.794-7.531 5.079-2.62 2.293-2.719 3.973-2.719 3.973s-.864.067-2.49.672c-1.625.603-2.355 1.514-2.355 1.514s.963-4.07 5.208-7.838c4.25-3.775 6.304-4.093 6.776-4.726.476-.63 0-7.85.102-8.432.096-.58.607-.631.958-.682.35-.05 2.491-.007 2.491-.007zm10.83 24.114s.67-1.31 1.1-1.75c.427-.437 1.461-1.178 1.461-1.178s.161-.166-2.16-1.178c-2.324-1.008-3.518-.673-5.175-1.848-1.659-1.177-3.319-3.199-3.319-3.199l-2.223 1.985s1.33 1.885 2.59 3.097c1.256 1.209 4.11 1.615 5.372 2.322 1.261.709 2.355 1.749 2.355 1.749z'/%3e%3cpath fill='%23cd202a' d='M492.335 366.869s2.514-.15 2.864.24c.347.388.296.82.31.948.01.122.13 6.099-.31 8.065-.468 2.053-1.529 4.103-2.128 4.71-.598.606-4.377 3.908-6.17 5.655-1.792 1.749-3.615 4.244-3.615 4.244s-.664-.741-1.228-1.451c-.561-.706-1.131-.942-.997-1.412.132-.47 2.026-3.3 5.045-5.285 3.018-1.987 5.542-4.24 6.104-7.47.569-3.233.125-8.244.125-8.244z'/%3e%3cpath fill='%23cd202a' d='M509.135 387.292s-.604-.61-2.73-.644c-2.135-.037-2.31.285-2.31.285s-1.17-1.477-3.05-2.7c-1.883-1.226-3.301-1.045-5.323-2.376-2.024-1.334-3.085-3.278-3.085-3.278l1.559-3.166s1.742 2.45 3.548 3.78c1.81 1.33 5.82 2.626 7.1 3.748 1.277 1.116 4.292 4.35 4.292 4.35z'/%3e%3cg transform='translate(-.699 1.184) scale(1.16833)'%3e%3cpath fill='%2330c2dc' stroke='%230872a7' stroke-width='.7' d='M452.73 299.48s-4.686-1.817-4.347-3.462c.341-1.64 10.824-4.404 10.824-4.404l.167-2.765s-1.533-.086-4.175.778-6.817 1.987-11.328 1.987c-2.74 0-4.226-.287-4.97-.511-.484-.147-36.95-2.289-38.14-2.277-.513.01-1.166-.007-1.99-.063-4.855-.346-7.978-7.778-7.978-7.778l-2.3.402s.706 3.652-.513 3.975c-2.384.635-18.229-7.837-18.229-7.837l-.875 3.436s9.688 5.183 9.396 7.11c-.292 1.926-3.164 1.78-3.164 1.78l1.231 2.31c.435.039 15.95.787 16.214 5.446.108 1.881-3.805 2.995-3.805 2.995l1.305 1.593v.793s8.617.051 11.003 1.384c2.385 1.334 3.6 3.258 6.523 4.936 2.92 1.68 22.752 1.27 25.85.399 3.503-.987 5.655-4.956 11.35-6.684 5.696-1.726 7.536-1.813 7.536-1.813z'/%3e%3ccircle cx='373.416' cy='292.05' r='2.745' fill='%23fff' stroke='%230872a7' stroke-width='1.37'/%3e%3ccircle cx='389.095' cy='279.26' r='2.746' fill='%23fff' stroke='%230872a7' stroke-width='1.37'/%3e%3ccircle cx='454.822' cy='299.74' r='2.817' fill='%23fff' stroke='%230872a7' stroke-width='1.37'/%3e%3cpath fill='%23f8c83c' d='M361.11 275.15c-.895 2.072 2.638 6.005 5.11 6.437 2.47.432 3.833-.171 4.26-1.382.427-1.214.095-2.528-.469-3.282-1.576-2.12-8.01-3.847-8.9-1.773z'/%3e%3cpath fill='%23fff' d='M368.9 278.31c-.067-1.252-2.129-2.466-3.45-2.466-1.32 0-2.642-.04-2.428.652.212.689 3.621 1.6 3.705 1.987.086.389-1.021.862-.468 1.382.554.52 1.236.132 1.79-.258s.893-.52.851-1.297z'/%3e%3cpath fill='%23f8c83c' d='M390.71 301.99c.567 1.825-.851 2.718-2.684 3.542-1.832.82-5.58.343-6.43-1.123-.854-1.47 1.362-3.847 3.62-4.41 2.257-.56 4.982.347 5.494 1.991z'/%3e%3cpath fill='%23fff' d='M386.92 303.07c.716-.124.725 1.083 1.364.992.639-.084 1.192-1.12 1.021-1.814-.17-.692-1.364-1.642-2.385-1.554-1.022.087-4.046 2.634-3.707 3.326.342.69 1.023.606 1.578.347.554-.26 1.363-1.167 2.129-1.297z'/%3e%3cpath fill='%23f8c83c' d='M458.35 292.53c1.661 2.21 4.656.173 5.45-.688.796-.865 3.237-2.277 2.244-3.718-.997-1.44-2.697-1.324-3.834-1.27-1.136.058-3.465 1.732-3.86 2.507-.399.781-.74 2.193 0 3.169z'/%3e%3cpath fill='%23fff' d='M458.89 291.07s.145-2.407 2.39-2.507c1.276-.057 1.332.347 2.3.896.962.544 1.332-.72 1.332-.72s.058 1.7-1.501 1.755c-1.564.056-.999-.69-2.53-.921-1.35-.205-1.991 1.497-1.991 1.497z'/%3e%3c/g%3e%3cg fill='%23f9aa51' stroke='%23953220' stroke-linecap='round' stroke-linejoin='round' stroke-width='.7'%3e%3cpath stroke-width='.701' d='m492.837 335.792-1.295-.84s-2.589-.133-4.346-.1c-1.76.032-5.242.202-5.242.202l5.206 15.111 6.239 8.988 2.391.859 4.844-.321.824-2.355-1.823-14.575-6.797-6.97z'/%3e%3cpath stroke-width='.701' d='m475.64 336.738.249-1.717s1.177-.15 2.82-.2c1.642-.054 3.077.108 3.253.236.17.127 3.634 4.36 4.825 7.133 1.192 2.78 2.587 7.421 4.13 10.254 1.544 2.824 4.88 7.571 4.88 7.571s-1.67.098-3.138.098-3.1.051-3.1.051l-2.799-1.084-8.782-13.656-2.339-8.687z'/%3e%3cpath stroke-width='.701' d='M471.971 334.88s3.583-.066 3.916.135c.331.203 4.312 3.74 5.903 8.112 1.595 4.374.797 4.982 2.857 9.493 2.053 4.51 4.91 7.538 4.91 7.538s-5.973.337-9.357-.27c-3.385-.606-4.58-.538-5.378-1.477-.794-.947-2.654-2.09-2.654-2.09h-3.381l.794-4.712-.927-10.567.199-5.458 3.117-.704zm35.832 2.792-5.705-2.353-10.617-.54s.393 2.83.792 5.455c.4 2.622 2.26 8.814 3.985 11.846 1.723 3.029 3.452 6.732 4.382 7.605.931.876 7.035-1.649 7.035-1.649l3.979-.605-.531-4.344-.566-1.345.933-12.353-.867-1.917z'/%3e%3cpath stroke-width='.701' d='M470.242 337.742c0 1.35 1.428 1.416 1.792 1.35.364-.07 1.593-.54 1.593-2.36 0-1.817-1.127-3.228-3.352-3.364-2.223-.134-3.914 2.66-3.914 4.543 0 1.884 1.89 2.86 1.89 3.57 0 0-1.89 1.75-1.792 4.81.099 3.065 2.59 5.421 2.59 5.421s-2.657 2.12-2.657 4.241c0 2.121 2.027 3.531 3.917 3.531 1.89 0 4.313-1.21 4.313-2.822 0-1.618-1.427-2.59-2.62-2.59-1.195 0-1.693.702-1.693 1.241m39.317-16.717c0 1.313-.849 1.368-1.596 1.368-.746 0-1.74-.407-1.74-2.075 0-1.665 2.191-2.574 3.585-2.574 1.389 0 3.781 1.918 3.781 4.243 0 2.32-1.692 3.885-1.692 3.885s1.043.504 1.043 3.43c0 2.932-1.888 5.05-1.888 5.05s2.466.962 2.466 3.992c0 3.024-2.093 4.016-3.538 4.016-1.445 0-3.96-.861-3.96-2.931 0-2.074 1.297-2.801 2.29-2.801.996 0 1.968 1.161 1.968 2.296'/%3e%3cpath fill='%23953220' stroke='none' d='M473.899 354.601s.37.244.649.836c.284.6.488 1.557 1.143 2.14 1.294 1.162 11.146 1.519 14.135 1.519 2.984 0 11.942.404 13.635-.607 1.694-1.008 1.892-2.677 2.936-3.435 1.045-.755 1.344-.703 1.344-.703l-1.295 1.108-.094 2.119.766 1.161s-.17.61-1.219 1.266c-1.044.657-1.99.857-3.433 1.01-1.443.152-20.301.1-23.343-.403-3.034-.508-2.834-.457-3.73-1.112a6.604 6.604 0 0 1-1.394-1.363l.399-1.362-.5-2.173zm30.598-18.096 1.692.74s-1.445.45-2.534 3.432c-1.098 2.983-.202 3.94-.946 4.24-.748.306-8.91.052-8.91.052l-1.398-3.386z'/%3e%3c/g%3e%3cg fill='%23231f20'%3e%3cpath d='M530.527 335.324s-1.394-.505-2.039-1.666c-.65-1.162-1.196-2.626-.7-2.93.503-.303 1.544.704 1.448 1.619-.103.906 1.291 2.978 1.291 2.978zm15.948-4.404s.995 1.814 1.342 2.016c.35.2 1.939.914 1.939.914s-2.237 0-2.932-.609c-.7-.607-1.694-2.273-1.694-2.273z'/%3e%3cpath d='M551.289 332.392s-1.344.805-2.486.352c-1.145-.454-2.038-1.113-1.597-1.614.452-.507.746-.304 1.344.35.599.661 2.739.912 2.739.912zm8.107-6.87s-1.095.964-1.89.964c-.797 0-2.39-.307-2.39-.66 0-.353 2.087-.555 2.437-.503.352.05 1.843.2 1.843.2zm-12.15-16.1s-1.794.554-2.388 1.466c-.594.908-.449 1.917.3 1.865.743-.048.944-1.058.944-1.362 0-.298 1.144-1.969 1.144-1.969zm-8.003 4.393s-1.342.854-1.693 1.615c-.35.755-.649 2.369.148 2.423.799.05 1.049-1.214 1.095-1.869.053-.656.45-2.169.45-2.169z'/%3e%3cpath fill='%238cbebf' stroke='%2304534e' stroke-width='.701' d='m524.92 323.501-4.393 4.65s10.102 5.656 17.863 5.404c7.768-.25 16.627-6.31 17.22-7.574.6-1.258.102-6.664-.896-8.382-.996-1.715-6.37-5.905-8.408-5.704-2.038.201-5.627 2.928-8.96 6.16-3.335 3.232-2.99 5.954-7.615 5.708-4.628-.254-4.814-.262-4.814-.262z'/%3e%3cpath fill='%230c8489' d='M523.798 325.359s10.815 1.618 13.93-1.143c3.124-2.758 6.505-8.144 8.696-9.358 2.191-1.214 3.181-1.214 3.181-1.214s1.613 1.027 2.357 1.67c.748.636 2.754 2.285 2.754 2.285l.865 5.137.065 2.824-3.38 2.765-6.209 2.86-5.936 1.85-5.043-.136-10.217-2.962-2.591-1.834-.665-.59z'/%3e%3cpath fill='%2304534e' d='M540.283 319.13c0-.92.604-.875 1.428-.875s1.725.157 1.725 1.078c0 .922-.9 2.253-1.725 2.253-.825 0-1.428-1.532-1.428-2.455zm4.346 2.724c0-.83.636-1.28 1.623-1.28.991 0 1.892 1.109 1.892 1.935 0 .828-.8 1.499-1.785 1.499-.99 0-1.73-1.327-1.73-2.154zm-1.496 6.472c0-1.034.634-1.249 1.626-1.249.987 0 1.595.466 1.595 1.498 0 1.03-.807 1.869-1.795 1.869-.991 0-1.426-1.09-1.426-2.118zm-5.7-1.986c0-1.104 1.048-1.449 1.938-1.449.89 0 1.61.897 1.61 2.007 0 1.107-.72 2-1.61 2-.89 0-1.939-1.452-1.939-2.558zm-9.032 1.098a2.208 2.208 0 1 1 4.415 0 2.206 2.206 0 0 1-2.209 2.202 2.206 2.206 0 0 1-2.206-2.202z'/%3e%3cpath fill='%238cbebf' d='M544.63 321.854c0-.746 1.019-1.28 1.622-1.28.609 0 1.098.6 1.098 1.349 0 .74-.49 1.345-1.097 1.345-.604 0-1.624-.673-1.624-1.414zm-1.462 6.204c0-.858.791-1.214 1.695-1.214.905 0 1.589.355 1.589 1.214 0 .853-.735 1.545-1.64 1.545-.907 0-1.644-.692-1.644-1.545zm-5.7-1.893c0-.945 1.552-1.376 2.194-1.376.641 0 .53.632.53 1.58 0 .952-.525 1.717-1.166 1.717-.64 0-1.559-.968-1.559-1.921zm2.686-7.14c0-.863.672-.909 1.232-.909.554 0 .96.26.96 1.128 0 .864-.453 1.564-1.011 1.564-.561 0-1.181-.917-1.181-1.782zm-11.777 7.747c0-1.004.874-1.951 2.158-1.951 1.283 0 2.586.443 2.586 1.444 0 1.004-1.568 2.728-2.852 2.728-1.287 0-1.892-1.217-1.892-2.221z'/%3e%3cpath d='M532.513 325.02s-1.492.254-2.29 1.01c-.793.759-.896 1.62-.446 1.87.446.25.997-.556 1.145-.909.146-.355 1.592-1.972 1.592-1.972zm7.174-1.566s-1.442 1.012-1.59 2.023c-.152 1.013 0 1.514.4 1.566.398.048.643-1.316.496-1.82-.148-.501.694-1.769.694-1.769z'/%3e%3cpath d='M540.879 324.973s-.944.048-1.592.655c-.644.608-1.242 1.363-.793 1.415.444.048 1.146-.302 1.19-.708.051-.402 1.195-1.362 1.195-1.362zm1.542-8.33s-.748.607-1.145.958c-.401.356-.895 1.364-.401 1.62.5.254.848-.204 1.196-.907.35-.713.35-1.67.35-1.67zm5.433 3.481s-1.397.197-1.843.804c-.445.607-.749 1.316-.15 1.316.596 0 .745-.304.997-.857.25-.555.996-1.262.996-1.262zm-.853 6.414s-.297.96-1.144 1.412c-.846.46-1.092.862-1.442.254-.35-.604.098-.91.547-1.064.447-.147 2.039-.6 2.039-.6z'/%3e%3cpath fill='%2304534e' d='M555.658 322.192s.6 2.979-1.987 4.44c-2.587 1.467-9.854 6.616-16.72 6.01-6.87-.608-14.684-4.543-14.684-4.543l-1.092.504 1.74.757 5.325 2.22 6.067 1.77 3.786.25 3.285-.405 6.068-2.015 5.143-2.628 2.67-2.12.715-.877-.066-1.243v-1.717z'/%3e%3cpath d='M420.81 283.38s1.593 1.364 1.443 2.524c-.15 1.161-.548 1.62-.994 1.416-.45-.203-.45-1.416-.35-1.917.1-.51-.1-2.023-.1-2.023zm11.776 10.948s-.448 2.017-1.246 2.219c-.795.202-1.392-.655-1.243-1.01.15-.354.796-.05 1.145-.354.348-.298 1.344-.855 1.344-.855zm-25.632 1.565s.546 1.162 1.592 1.364c1.044.2 1.543-.507 1.393-.86-.148-.35-.597-.254-1.145-.254-.547 0-1.84-.25-1.84-.25zm4.58 8.985s.947 1.113 2.24 1.263c1.291.15 1.94-.859 2.038-1.161.1-.304-1.492-.255-1.99.15-.497.405-2.289-.252-2.289-.252zm8.108 6.917s2.089-.405 2.435-.958c.35-.557.897-1.515.451-2.073-.45-.553-.797.86-1.046 1.412-.249.559-1.84 1.619-1.84 1.619z'/%3e%3cpath fill='%238cbebf' stroke='%2304534e' stroke-width='.701' d='M432.691 306.303s1.396-9.359-6.17-15.956c-7.566-6.595-12.476-4.982-15.066-2.554-2.587 2.42-4.843 10.366 3.185 17.301 8.031 6.933 17.92 4.779 17.92 4.779l.131-3.57z'/%3e%3cpath fill='%230c8489' d='M409.618 296.396s-.144-5.142 2.284-6.672c2.428-1.537 10.428-2.87 14.371 4.727 3.943 7.589 4.021 11.386 3.027 15.225l-4.22-.042-6.53-2.662-5.416-4-3.517-6.576z'/%3e%3cpath fill='%2304534e' d='M431.687 307.647s-1.325 1.482-4.048 1.348c-2.72-.137-15.394-3.435-18.58-14.81l.201 2.49.13.808.837 2.293 2.666 3.871 3.347 2.869 4.22 2.183 3.026.887 3.94.688h2.27l1.992-2.627z'/%3e%3cpath fill='%2304534e' d='M425.086 304.364c0-1.015.52-1.047 1.328-1.047.806 0 1.426-.355 1.426.655 0 1.015-.554 2.476-1.36 2.476-.807 0-1.394-1.075-1.394-2.084zm.537-6.018c0-.7.638-1.264 1.43-1.264.788 0 1.423.564 1.423 1.264 0 .698-.635 1.258-1.423 1.258-.79 0-1.43-.56-1.43-1.258zm-5.748 6.637c0-.547.72-.992 1.61-.992.889 0 1.609.445 1.609.992 0 .547-1.6 1.295-2.489 1.295-.887 0-.73-.747-.73-1.295zm-.525-7.092c0-.891.432-.607 1.211-.607.781 0 1.743.254 1.743 1.147 0 .892-.963 2.086-1.743 2.086-.778 0-1.211-1.736-1.211-2.626zm-5.34 1.191c0-.75.507-1.801 1.46-1.801.951 0 1.989 1.05 1.989 1.802s-.771 1.362-1.726 1.362c-.951 0-1.722-.61-1.722-1.362zm.958-6.273c0-.778.531-.738 1.508-.738.982 0 1.777.397 1.777 1.181 0 .778-1.145 1.748-2.124 1.748-.98 0-1.16-1.406-1.16-2.191zm5.784-.607c0-.755.642-.508 1.559-.508.918 0 1.66.61 1.66 1.364 0 .751-1.173 1.597-2.09 1.597-.917 0-1.13-1.702-1.13-2.453z'/%3e%3cpath fill='%238cbebf' d='M414.968 292.645c.131-.54.507-.911 1.194-.911.686 0 1.293.13 1.293.911 0 .778-.557 1.416-1.243 1.416-.688 0-1.431-.66-1.244-1.416zm-1.063 6.157c0-.761.381-1.479 1.16-1.479.779 0 1.394.077 1.394.841 0 .765-.682 1.65-1.46 1.65-.779 0-1.094-.249-1.094-1.012zm6.8-6.495c0-.606.518-.673 1.26-.673.741 0 1.227.155 1.227.755 0 .608-.6 1.095-1.343 1.095s-1.145-.573-1.145-1.177zm-1.32 5.9c0 .828.607 1.501 1.36 1.501.75 0 1.558-.658 1.558-1.482 0-.833-.84-1.619-1.593-1.619-.75 0-1.325.773-1.325 1.6zm6.472-.865c0 .75.652 1.364 1.458 1.364.807 0 1.46-.615 1.46-1.364 0-.754-.653-1.362-1.46-1.362-.805 0-1.458.608-1.458 1.362zm-6.24 7.57c0-.657.685-1.294 1.363-1.294.677 0 1.327.419 1.327 1.077 0 .66-1.179 1.549-1.858 1.549-.678 0-.831-.671-.831-1.331zm5.504-.969c0-.807.616-.875 1.46-.875s1.26.081 1.26.89c0 .81-.681 1.47-1.525 1.47-.844 0-1.195-.675-1.195-1.485z'/%3e%3cpath d='M426.617 294.48s.844 1.057.993 1.865c.148.807.148 1.718-.15 1.82-.298.1-.795-.507-.944-1.262-.149-.76.1-2.423.1-2.423zm-4.826-5.152s.547.86.547 1.618c0 .757-.1 1.564-.497 1.564-.398 0-.398-.756-.398-1.313 0-.554.348-1.87.348-1.87zm-5.678.759s.549.86.549 1.618c0 .755-.1 1.565-.498 1.565-.4 0-.4-.757-.4-1.31 0-.56.349-1.872.349-1.872z'/%3e%3cpath d='M414.127 291.15s.746.203 1.392.705c.648.505.896 1.109.648 1.413-.25.304-.845-.148-.994-.504-.15-.354-1.046-1.614-1.046-1.614zm4.323 5.947s1.095.05 1.693.607c.596.556 1.093 1.011.746 1.416-.349.402-1.195-.305-1.544-.706-.348-.404-.895-1.317-.895-1.317zm-5.27-.199s.997.25 1.493.603c.5.357.649 1.064.4 1.214-.25.148-.597-.102-1.045-.555-.449-.456-.847-1.262-.847-1.262zm12.736 3.996s.35 1.212.35 2.065c0 .861.1 1.618-.3 1.618-.398 0-.597-1.058-.597-1.716 0-.66.547-1.967.547-1.967zm-1.437 1.963s.896.352 1.294.705c.397.355.498.911.2 1.011-.299.1-.499-.555-.748-.807-.247-.252-.746-.91-.746-.91zm-5.678.35s.957.113 1.376.399c.415.284.458 1.594.415 1.764-.04.168-.665.054-.918-.57-.246-.625-.873-1.593-.873-1.593z'/%3e%3cpath fill='%2304534e' d='M416.604 285.893s-5.013 1.086-5.929 4.319c-.917 3.231-.957 6.825-.957 6.825L409 292.92l.997-2.667 1.458-2.45 2.207-1.389 1.988-.686zm15.644 19.172s.52-1.252-.954-5.208c-1.475-3.959-4.499-9.131-4.499-9.131l2.35 2.665 1.87 3.03.915 2.786.677 2.546-.039 2.5z'/%3e%3cpath d='M437.318 298.662s1.74 1.14 1.916 1.768c.175.634.247.837-.199 1.012-.448.181-1.17-.528-1.37-1.012-.2-.48-.347-1.768-.347-1.768zm-7.348 19.745s.822-1.54 1.915-2.12c1.095-.58 1.916-.506 2.215-.15.299.353-.72 1.16-1.467 1.439-.747.278-2.663.83-2.663.83zm12.35 4.72s1.219-.58 2.015-1.44c.797-.855.896-1.46.597-1.765-.298-.302-1.294.203-1.743.883-.447.678-.87 2.322-.87 2.322zm-1.345-1.157s.424-1.588.848-2.095c.423-.505 1.019-.781 1.468-.505.45.277.174.989-.15 1.362-.323.38-2.166 1.238-2.166 1.238z'/%3e%3cpath fill='%238cbebf' stroke='%2304534e' stroke-width='.701' d='M461.62 312.566s-7.693-11.126-19.641-11.714c-9.556-.472-12.575 8.061-12.227 10.635.342 2.534 3.932 8.095 16.672 9.034 12.741.944 14.797-6.005 15.329-6.343.53-.338-.133-1.612-.133-1.612z'/%3e%3cpath fill='%230c8489' d='M452.542 304.925s3.184 2.427 4.53 4.344c1.342 1.917 1.642 3.333.846 3.586-.798.247-7.715-6.164-13.388-7.524-5.675-1.365-10.6-.1-11.696 2.626-1.092 2.728-.695 6.816 1.893 8.478 2.589 1.672 14.731 3.637 14.731 3.637s5.524-.757 5.722-.856c.2-.101 3.534-1.97 3.534-1.97l.745-1.92.898-2.524.398-1.01-2.937-3.23-5.275-3.637z'/%3e%3cpath fill='%2304534e' d='M442.786 306.49c0 .713-.75 1.066-1.492 1.066-.743 0-1.37-.376-1.37-1.087 0-.712.602-1.289 1.345-1.289.742 0 1.517.599 1.517 1.31zm-7.01 2.524c0-.714.801-.703 1.607-.703.804 0 1.456.585 1.456 1.3 0 .713-1.265 1.698-1.993 1.352-.893-.43-1.07-1.228-1.07-1.95zm7.536 4.123c0-.907.769-1.645 1.719-1.645.947 0 1.715.738 1.715 1.645 0 .904-1.291 1.888-2.239 1.888s-1.195-.984-1.195-1.888z'/%3e%3cpath fill='%238cbebf' d='M437.61 314.82c0-.793.817-.958 1.519-.958.699 0 1.592.747 1.592 1.54 0 .794-.893 1.337-1.592 1.337-.701 0-1.519-1.123-1.519-1.92z'/%3e%3cpath fill='%2304534e' d='M447.81 317.589c0-.647.385-1.224 1.046-1.224.66 0 1.467.388 1.467 1.033 0 .651-.656 1.364-1.317 1.364a1.184 1.184 0 0 1-1.196-1.173zm4.58-3.493c0-.824.466-.736 1.27-.736s1.617.465 1.617 1.289c0 .824-1.012 1.261-1.816 1.261s-1.072-.996-1.072-1.814z'/%3e%3cpath fill='%238cbebf' d='M442.342 305.836c0 .637-.264.98-.896.98-.631 0-1.394-.343-1.394-.98 0-.644.29-.838.921-.838.632 0 1.37.194 1.37.838zm-3.657 2.98c0 .7-1.057 1.137-1.717 1.137-.66 0-1.095-.437-1.095-1.138 0-.696.51-.906 1.172-.906.66 0 1.64.21 1.64.906zm1.624 5.888c0 .61-.232 1.081-.944 1.081-.714 0-1.643-.47-1.643-1.081 0-.613.257-1.037.971-1.037s1.616.424 1.616 1.037zm6.087-1.998c0 .64-1.255 1.363-1.917 1.363-.66 0-.944-1.179-.944-1.816 0-.644.532-1.16 1.194-1.16.66 0 1.667.972 1.667 1.613zm8.832 1.893c0 .667-1.061.63-1.667.63-.603 0-1.145-.747-1.145-1.41 0-.673.2-1.29 1.693-1.114.6.07 1.12 1.228 1.12 1.893zm-5.222 2.698c0 .666-.51 1.21-1.142 1.21-.63 0-1.145-.544-1.145-1.21 0-.67.514-.935 1.144-.935.632 0 1.143.264 1.143.935z'/%3e%3cpath d='M450.801 313.617s1.242-.404 2.187-.308c.947.104.999.458.999.607 0 .154-.748.458-1.097.352-.35-.096-2.089-.65-2.089-.65zm-5.176 4.381s.996-.607 1.742-.755c.745-.15 1.344.098 1.293.553-.05.457-.296.559-1.043.559-.745 0-1.992-.357-1.992-.357zm-3.33-7.665s2.138.91 2.589 1.767c.446.86.646 1.061.198 1.314-.447.252-.947-.307-1.244-.707-.3-.403-1.542-2.374-1.542-2.374z'/%3e%3cpath d='M441.746 313.056s1.643-.452 2.389-.452c.748 0 .947.05 1.046.404.1.35-.166.503-.78.47-.613-.036-2.655-.422-2.655-.422zm-5.245.105s1.792.239 2.239.707c.449.471.449.896.265 1.16-.182.271-1.029.102-1.293-.168-.266-.27-1.212-1.699-1.212-1.699z'/%3e%3cpath d='M436.243 315.743c.083-.083.695-1.011 1.343-1.227.646-.22 1.393-.184 1.525.149.136.336-.562.84-1.026.944-.465.1-1.842.134-1.842.134zm-1.354-7.839 1.774.488c.648.488.796.876.648 1.063-.15.182-.78.285-1.312-.067-.781-.527-1.111-1.484-1.111-1.484zm3.89-4.521s1.81.504 2.407 1.327c.595.827.512 1.315.214 1.483-.298.169-.997-.25-1.392-.62-.4-.374-1.229-2.19-1.229-2.19z'/%3e%3cpath fill='%2304534e' d='M459.458 316.386s-3.682 3.132-11.992 2.83c-8.312-.304-15.828-3.84-17.717-7.727l.745 1.919 1.843 2.473 5.823 2.98 6.52 1.46 5.175.306 4.877-.858s3.582-1.717 3.783-1.817c.198-.1.597-.96.597-.96zm1.098-3.938s-1.392-1.718-3.335-3.535c-1.942-1.82-9.505-6.72-9.505-6.72l6.12 2.78 4.033 3.386 2.886 3.175-.198.914z'/%3e%3cpath d='M460.907 305.076s2.09.81 2.439 1.314c.35.503.795.96.795.96s-.546 1.362-1.043.808c-.5-.558-.598-.558-1.146-1.316-.548-.76-1.045-1.766-1.045-1.766zm6.215-3.33s1.943.81 2.638 1.77c.697.96.549 1.766.25 1.867-.3.103-1.592-1.011-1.792-1.463-.2-.452-1.096-2.173-1.096-2.173z'/%3e%3cpath d='M469.073 301.35s1.84 1.366 2.138 1.968c.3.607.897 1.412.3 1.615-.598.202-1.443-.705-1.692-1.258-.25-.56-.746-2.325-.746-2.325zm10.492 2.464s1.444.5 1.594 1.717c.148 1.213-.15 2.07-.15 2.07s-.996-.857-.996-1.113c0-.248.15-.453 0-1.005a561.67 561.67 0 0 0-.448-1.669zm2.792.97s1.145 1.162 1.296 1.917c.147.756.295 1.265-.348 1.363-.649.106-.995-.657-.995-1.31 0-.66.047-1.97.047-1.97zm-18.81 22.923s.895.403 1.74.1c.847-.304 1.547-1.06 1.394-1.565-.148-.509-.595-.961-1.244-.303-.647.655-.296.961-.796 1.207l-1.094.561zm10.352 2.815s1.394-.201 2.34-1.215c.945-1.005 1.344-1.712.696-1.966-.646-.253-1.493 0-1.642.806-.15.809-1.394 2.375-1.394 2.375zm8.505.305s1.049-.608 1.846-1.362c.794-.76 1.24-1.21.693-1.767-.546-.56-.945-.156-1.192.1-.25.254 0 .254-.298 1.06-.303.807-1.049 1.969-1.049 1.969z'/%3e%3cpath d='M484.998 330.78s1.121-1.364 1.382-2.126c.25-.754.398-1.612-.111-1.564-.51.048-1.127.76-1.16 1.316-.04.553-.111 2.373-.111 2.373z'/%3e%3cpath fill='%238cbebf' stroke='%2304534e' stroke-width='.701' d='M459.108 316.993c.073-3.74 5.375-12.369 11.493-12.27 2.549.045 7.545 1.37 11.597 3.183 3.38 1.513 4.48 3.185 6.72 3.736 2.24.555 5.623.15 5.623.15l7.614-.857-5.971 8.737-2.136 1.916s-1.895 3.686-7.318 5.804c-5.426 2.12-14.583.555-18.714-.453-4.13-1.008-9.007-4.944-8.908-9.945z'/%3e%3cpath fill='%2304534e' d='m459.108 316.993.399.009c.012-.84.337-2.037.92-3.325.87-1.938 2.316-4.1 4.086-5.757 1.772-1.654 3.85-2.793 5.984-2.793h.098c1.214.023 3.085.357 5.138.912a45.125 45.125 0 0 1 6.305 2.232c1.657.74 2.743 1.517 3.724 2.196.978.672 1.862 1.27 3.061 1.564.967.24 2.095.308 3.098.308 1.458 0 2.658-.143 2.667-.146l6.743-.761-5.446 7.965-2.16 1.938-.035.066-.003.008c-.087.164-1.965 3.598-7.102 5.61-1.9.741-4.33 1.024-6.837 1.024-4.394 0-9.035-.86-11.638-1.497-1.968-.477-4.143-1.666-5.804-3.32-1.662-1.655-2.803-3.756-2.802-6.082l.003-.142-.4-.01-.399-.01-.002.161c.002 2.603 1.272 4.9 3.04 6.658 1.773 1.764 4.053 3.009 6.175 3.53 2.651.645 7.333 1.523 11.825 1.523 2.568 0 5.077-.286 7.122-1.083 5.544-2.17 7.501-5.943 7.527-5.997l-.35-.187.262.3 2.173-1.947 6.501-9.504-8.486.956-.2.019c-.394.04-1.321.117-2.376.117-.969 0-2.05-.065-2.91-.278-1.04-.26-1.822-.775-2.798-1.451-.974-.672-2.127-1.492-3.855-2.26-2.047-.922-4.326-1.708-6.42-2.277-2.094-.57-3.995-.917-5.329-.945h-.112c-1.612 0-3.15.57-4.543 1.462-2.091 1.333-3.872 3.395-5.15 5.485-1.276 2.093-2.058 4.2-2.094 5.719l.399.01z'/%3e%3cpath fill='%230c8489' d='M496.085 318.162c-.645.505-1.342.505-2.139.505-.8 0-17.766-10.35-23.042-9.898-5.274.453-10.3 2.728-10.45 8.132-.148 5.398 1.195 5.452 2.288 6.966 1.097 1.515 11.448 3.789 11.448 3.789l6.32-.107 5.08-.552 4.476-2.423 2.44-1.967 1.64-2.021 1.94-2.423z'/%3e%3cpath fill='%2304534e' d='M469.272 315.405c0 1.06-.41 1.801-1.442 1.801-1.028 0-1.798-.467-1.798-1.528 0-1.055.586-1.452 1.616-1.452 1.032 0 1.624.12 1.624 1.179zm1.776-4.721c0-.881.851-1.266 1.827-1.266s1.726.355 1.726 1.235c0 .875-.771 1.55-1.746 1.55-.977 0-1.807-.642-1.807-1.52zm10.164 2.758c0-.765.657-1.385 1.47-1.385.809 0 1.465.62 1.465 1.385 0 .766-.656 1.387-1.465 1.387-.813 0-1.47-.621-1.47-1.387zm2.045 6.227c0-.979.711-1.769 1.592-1.769.88 0 1.7.413 1.7 1.387s-.318 1.925-1.197 1.925c-.878 0-2.095-.568-2.095-1.542zm-4.93 3.983c0-.837.744-1.514 1.668-1.514.92 0 1.664.676 1.664 1.514 0 .84-.657 1.382-1.575 1.382-.922 0-1.758-.542-1.758-1.382zm-9.312-1.612c0-.811.656-1.464 1.467-1.464a1.465 1.465 0 1 1 0 2.928 1.465 1.465 0 0 1-1.467-1.464z'/%3e%3cpath fill='%238cbebf' d='M469.213 315.182c0 .832-.714 1.515-1.592 1.515-.881 0-1.594-.682-1.594-1.515 0-.838.707-1.17 1.585-1.17.88.002 1.602.332 1.602 1.17zm4.931-4.801c0 .809-.251 1.331-1.104 1.331-.851 0-1.981-.522-1.981-1.331 0-.81.693-1.462 1.542-1.462.851 0 1.542.652 1.542 1.463zm9.85 2.628c0 .696-.647 1.257-1.444 1.257-.798 0-1.443-.562-1.443-1.257 0-.698.645-1.266 1.442-1.266.798 0 1.444.568 1.444 1.266z'/%3e%3cpath fill='%2304534e' d='M478.77 317.168c0 1.066-.41 1.808-1.441 1.808-1.03 0-1.8-.471-1.8-1.53 0-1.06.585-1.45 1.617-1.45 1.031 0 1.625.12 1.625 1.172z'/%3e%3cpath fill='%238cbebf' d='M471.656 321.69c0 .84-.715 1.516-1.593 1.516-.879 0-1.593-.676-1.593-1.516 0-.83 1.012-1.258 1.893-1.258.877 0 1.292.428 1.292 1.258zm6.81-4.697c0 .836-.69 1.513-1.542 1.513-.851 0-1.542-.676-1.542-1.512 0-.834.691-1.518 1.542-1.518.852 0 1.542.684 1.542 1.517zm8.05 2.08c0 .921-.56 1.655-1.522 1.655s-1.74-.747-1.74-1.662c0-.921.279-1.236 1.238-1.236.96 0 2.025.323 2.025 1.243zm-5.151 4.229c0 .867-.583 1.36-1.464 1.36-.88 0-1.724-.493-1.724-1.36 0-.862.754-1.22 1.632-1.22.876 0 1.556.358 1.556 1.22z'/%3e%3cpath d='M481.96 318.255s2.532-.254 2.983.202c.45.455.4 1.108.199 1.312-.2.202-1.197.251-1.443-.098-.247-.357-1.739-1.416-1.739-1.416zm-2.488-8.178s1.942.5 2.736 1.31c.797.808.649 1.618.5 1.768-.15.149-.849.305-1.394-.3-.546-.607-1.842-2.778-1.842-2.778zm-5.772 3.937s2.265 1.235 2.764 1.94c.497.706.621 1.265.398 1.565-.225.303-1.347-.076-1.519-.454-.173-.377-1.642-3.051-1.642-3.051zm-.993 1.741s2.538.33 3.16.807c.622.481 1.07.506 1.02.884-.048.38-.321.66-.72.606-.4-.052-1.495-.531-1.742-.757a811.17 811.17 0 0 0-1.718-1.54zm-2.92-7.43s2.589.406 3.12.808c.53.406.663 1.552.066 1.89-.598.33-1.26-.337-1.46-.809-.2-.471-1.727-1.89-1.727-1.89zm-5.586 3.913s2.382 1.133 3.122 2.186c.398.568.747 1.058 0 1.314-.683.226-1.393-1.01-1.393-1.314 0-.302-1.729-2.186-1.729-2.186z'/%3e%3cpath d='M463.675 315.335s1.526-.338 2.258-.338c.728 0 1.778-.253 1.791.338.01.59-.895.703-1.434.533-.532-.182-2.614-.533-2.614-.533zm13.18 8.505s1.668-1.039 2.488-.862c.82.18 1.094.105 1.094.607 0 .506-.971.405-1.27.405-.299 0-2.313-.15-2.313-.15zm-9.23-1.344s.644-.96 1.342-1.056c.697-.104.994-.052 1.095.248.1.307-.597.86-.897.86-.297 0-1.54-.052-1.54-.052z'/%3e%3cpath fill='%2304534e' d='M494.005 320.813s-2.536 3.055-6.071 4.57c-3.532 1.516-6.22 2.017-11.148 1.715-4.926-.302-7.314-1.06-10.65-2.774-3.335-1.717-5.972-4.19-6.47-5.251-.496-1.064.549 1.767.549 1.767l3.036 3.985 3.632 1.618 5.325 1.31 5.027.607 3.83-.096 4.58-.713 2.935-1.054 1.993-1.215 1.544-1.266zm-4.743-9.018s-1.38.456-4.414-1.416c-3.038-1.865-6.672-4.293-13.539-4.34-6.867-.049-9.056 4.649-9.505 4.996-.449.355 3.084-4.085 3.084-4.085l3.136-1.669 2.44-.404 2.338.102 3.036.809 2.737.857 3.188 1.059 2.784 1.524 3.365 1.756 1.35.81zm9.218 2.02s-4.029-.052-5.175.048c-1.148.1-1.195.304-1.347.607-.15.303-.447.707-.447.707l-1.244-2.677 5.475-.76 2.98 1.116z'/%3e%3cpath fill='%230c8489' stroke='%2304534e' stroke-width='.701' d='M491.061 341.983c.277.735.916 1.402 1.717 1.42.803.023 2.491-.03 2.491-.03l5.449-.326 1.917-2.198 1.17-4.924s1.471-1.789 1.471-1.865c0-.075 5.074-2.803 5.074-2.803l4.382-1.264 2.81-.3 3.878-1.287 2.864-1.49 1.245-1.845 1.217-2.8-1.217-3.79-3.038-4.062-5.145-2.095h-4.261l-4.776 1.743-8.41 1.99s-4.63 2.02-6.547 5.63c-1.91 3.609-1.888 4.547-2.21 9.315-.328 4.776-.08 10.981-.08 10.981z'/%3e%3cpath fill='%238cbebf' d='M493.34 340.103c1.61 0 .366-2.663 2.193-5.829 1.824-3.157 4.046-7 4.61-7 .563 0 .66.575 1.323.375.665-.201 1.797-1.213 1.863-1.485.066-.267.066-2.052 1.457-3.197 1.397-1.145 3.353-2.76 4.279-2.962.931-.197 1.364-.37 1.528.067.166.437-.533 1.044.101 1.247.631.204 2.091.137 2.454-.81.364-.942.265-1.443.265-1.443s.963-.942 2.789-.54c1.827.404 2.055.3 2.221 1.01.165.706-.831.807-.63 1.312.197.501-.138.448.05.832.185.38.478 1.456 1.704 1.424 1.231-.033 1.762-.742 1.762-.742l.36-.647s.338-.765-.13-1.068c-.466-.304-.297-.674.169-.473.462.203 2.32 2.794 2.952 1.715.633-1.075.699-2.59.365-2.96-.332-.37-2.953-4.31-2.953-4.31l-4.68-1.582-6.2.51-6.009 3.43-5.505 2.929s-.3 4.507-1.296 3.702c-.995-.809-2.424-3.029-2.85-2.289-.435.742-1.395 4.038-1.96 5.685-.565 1.65-2.19 6.735-2.026 8.621.168 1.883 1.199 4.479 1.794 4.479z'/%3e%3cpath fill='%238cbebf' d='M498.877 332.812c-.434.033-1.063.472-1.26.722-.2.255-.481.795-.3 1.382.182.588 1.045 1.162 1.113 1.23l.69-.02 1.495-.435s.477-.54.504-1.242c.03-.711-.403-.897-.615-.964-.22-.066-1.627-.673-1.627-.673zm9.487-7.839c-.848-.302-1.222.276-1.37.528-.148.254-.084.87-.084.87s.186 1.173.633 1.391c.446.212 1.619.62 1.987.212.378-.4.756-.68.73-1.437-.02-.759-1.076-1.132-1.076-1.132zm7.64 1.834c-.035-.289-.78-.49-1.28-.403-.496.087-1.163.721-.925 1.683.228.956 1.142 1.041 1.857.858.712-.186.577-1.199.577-1.347 0-.15-.228-.791-.228-.791zm-22.069 1.542c0 .438.796 1.349 1.861 1.282 1.058-.068 1.718-.877 1.826-1.515.094-.642-.567.535-1.364.74-.794.2-1.26.404-1.626-.035-.364-.437-.697-.471-.697-.471z'/%3e%3cpath fill='%2304534e' d='M501.12 334.448s.115.975-.588 1.48c-.702.504-1.152.452-1.557.452-.404 0-.845-.082-1.14-.487-.295-.405-.516-.977-.516-.977s.775 1.276 1.993.94c1.22-.333 1.809-1.408 1.809-1.408zm20.552-12.734s-.01.981-.775 1.388c-.76.407-1.105.523-1.51.472-.4-.055-.959-.218-1.224-.642-.901-1.409-.369-2.329-.369-2.329s.65 2.443 1.903 2.273c1.254-.172 1.975-1.162 1.975-1.162zm-18.32 4.38s-.626 1.918-1.89 1.918c-1.259 0-1.156-.367-1.062-.607.104-.232.567.24 1.13.068.565-.164 1.822-1.378 1.822-1.378zm3.552-.339s-.13 1.39.336 1.858c.465.474.997.713 1.528.713s.93-.14 1.325-.674c.4-.54.166-1.115.166-1.115s.008.292-.389.694c-.4.405-.726.471-1.125.471-.397 0-1.077-.05-1.28-.52-.202-.47-.561-1.427-.561-1.427zm6.507-6.682s.4 1.04-.399 1.884c-.793.84-2.32.37-2.32.37s1.229.3 1.827-.37c.597-.674.892-1.883.892-1.883z'/%3e%3cpath fill='%2304534e' d='M492.639 343.024s8.076-.137 8.725-1.249c.644-1.107-.7-5.452 4.179-8.883 4.875-3.431 8.661-3.384 11.247-3.588 2.589-.2 8.176-1.942 9.158-6.912.595-3.033-3.485-3.235-5.027-6.11-1.542-2.88-5.522-1.716-5.722-1.716-.198 0-4.62-.128-6.719 1.917-1.247 1.214-1.096 2.728-1.693 3.433-.6.707-5.925 0-6.52.86-.597.856.149 2.671-.252 3.077-.393.403-1.687-1.164-1.687-1.164l.445-4.29 6.82-3.987 7.759-4.292s5.081.25 5.28.152c.2-.104 5.225 2.624 5.373 2.675.148.053 2.636 3.03 2.636 3.03s.49 1.216.699 3.583c.1 1.125.006 2.093-.24 2.975-1.255 4.47-5.632 7.474-10.241 7.703-4.607.23-8.76 2.311-10.863 3.835-2.108 1.528-3.156 8.256-3.186 9.063-.03.806-10.037.26-10.037.26l-.135-.372z'/%3e%3cpath d='M496.038 327.298c-.41.33-1.017.31-1.148-.155-.37-1.32.415-3.278.415-3.278s-.02 2.05.134 2.388c.15.338.56.26.746.54.066.097.18.24-.147.505zm5.083-1.04c-.391-.12-.323-1.363-.026-1.895.3-.528 2.566-2.199 2.566-2.199s-.723 1.67-1 2.277c-.272.603-1.047 1.97-1.54 1.817zm-1.998 8.202c-.318.067-.42-.634-.42-1.518 0-.883 1.543-2.497 1.543-2.497s-.472 1.416-.525 1.866c-.047.456.252.86.199 1.392-.048.527-.444.682-.797.757z'/%3e%3cpath d='M502.885 332.193s-.72.835-1.545 1.29c-.817.45-1.712 1.13-2.215.984-.494-.155.32-1.229.599-1.341 1.395-.553 3.161-.933 3.161-.933zm6.916-9.873s-.917.762-1.365 1.843c-.45 1.086-.648 1.972-.2 2.173.453.201 1.12-1.239 1.172-1.72.048-.476.393-2.296.393-2.296z'/%3e%3cpath d='M512.337 325.78s-.645-.603-1.793-.882c-1.142-.28-1.665-.025-1.789.304-.125.325-.972.845-.548 1.097.423.25.919-.44 1.267-.52.352-.075.752-.327 1.37-.225.62.101 1.493.225 1.493.225zm-1.485-6.777c.407.352 1.026-.304 1.596-.944.561-.64.994-1.818.994-1.818s-1.165.607-1.658 1.011c-.502.403-1.163 1.55-.932 1.75zm10.55-.246s-1.358.643-1.822 1.247c-.466.606-1.064 1.277-.598 1.614.465.338.89-.3 1.262-.805.36-.504 1.158-2.056 1.158-2.056zm-3.014 7.068s-.46.945-1.323 1.516c-.862.575-1.892.84-2.055.537-.17-.3.133-.944.46-1.107.337-.17.535-.137 1.295-.338.763-.2 1.623-.608 1.623-.608z'/%3e%3c/g%3e%3cg transform='translate(-.699 1.184) scale(1.16833)'%3e%3cellipse cx='385.551' cy='257.828' fill='url(%23b)' rx='3.769' ry='5.631' transform='rotate(8.667 385.551 257.828)'/%3e%3cg fill='%23fcca3e' stroke='%23aa8c30'%3e%3cpath stroke-width='.35' d='m387.66 247.73-2.24 5.602 1.83-.254 1.056-4.931z'/%3e%3cpath stroke-width='.3' d='M388.7 245.35c-.797-.1-1.53.507-1.634 1.36-.104.85.459 1.618 1.256 1.722.8.1 1.529-.51 1.634-1.358.103-.852-.456-1.62-1.256-1.724z'/%3e%3cpath stroke-width='.35' d='m485.22 259.35-5.522 5.18 2.278.579 3.788-4.99z'/%3e%3cpath stroke-width='.3' d='M487.68 257.21c-.884-.488-2.054-.155-2.616.743-.566.895-.304 2.019.578 2.505.884.488 2.055.155 2.62-.742.562-.897.303-2.02-.582-2.506z'/%3e%3cpath stroke-width='.35' d='m344.88 229.45 2.913 6.42 1.254-1.787-3.297-4.86z'/%3e%3cpath stroke-width='.3' d='M343.71 226.65c-.723.613-.798 1.731-.166 2.5.63.776 1.728.905 2.453.295.722-.609.798-1.731.167-2.5-.632-.773-1.729-.905-2.454-.295z'/%3e%3c/g%3e%3cg fill='%23aa8c30'%3e%3cpath d='M389.25 245.56s.45.244-.07.084c-.522-.159-1.758.442-1.76 1.314 0 .874.647 1.359 1.3 1.365.656.006-.242.119-.242.119l-.842-.248-.35-.507-.28-.705.216-.756.497-.645.65-.234.43.051z'/%3e%3cpath d='M387.99 249.33s-.356-.072-.68.408c-.32.48-.972 1.385-.972 1.385l1.251-3.082.682.356zm100.23 8.36s.403.485-.126.061c-.53-.422-2.287-.34-2.744.632-.458.974.056 1.816.815 2.131.766.317-.341.02-.341.02l-.861-.67-.143-.732.03-.92.646-.736.92-.482.88.041.475.267.45.388z'/%3e%3cpath d='M484.78 261.3s-.382-.254-1.01.132c-.624.384-1.856 1.083-1.856 1.083l3.06-2.841.616.719zm-140.45-34.97s.564-.198.012.129c-.55.325-1.037 1.873-.304 2.574.733.702 1.66.529 2.188-.032.531-.56-.094.305-.094.305l-.882.531-.705-.109-.819-.32-.461-.788-.143-.95.322-.75.39-.326z'/%3e%3cpath d='M346.49 230.45s-.348.252-.203.912c.15.664.387 1.95.387 1.95l-1.59-3.546.846-.309z'/%3e%3c/g%3e%3cellipse cx='351.47' cy='241.607' fill='url(%23c)' rx='6.06' ry='4.079' transform='rotate(62.907 351.47 241.607)'/%3e%3cg fill='%23e92736'%3e%3cpath d='M344.65 240.24s1.25.288 1.93-.057c.682-.347.796-.866.964-1.034.172-.173.343-.808.286-1.212-.058-.404-.965-1.786-1.25-1.9-.284-.116-1.25 0-1.418-.174-.17-.174.142-.55-.23-.635-.367-.086-2.269 2.077-1.93 2.422.342.343.54-.172.652.117.114.284.03 1.092.03 1.436 0 .346.966 1.037.966 1.037z'/%3e%3cpath d='M346.5 236.2c.149.3.852 1.237 1.136 1.352.284.118 1.136.148 1.42.034.285-.116 1.193-.982 1.222-1.357.028-.374 0-.662-.17-1.04-.17-.374-.072-1.38-.412-1.437-.341-.058-.49-.104-.66-.302-.17-.204.106-.564-.15-.936-.253-.377-3.294 1.412-3.067 1.756.228.346.54-.026.653.203.113.227-.143 1.38.028 1.727z'/%3e%3cpath d='M353.37 235.43c.17-.458.113-1.959-.198-2.277-.313-.317-.825-.343-.854-.547-.026-.2.37-.289.37-.635 0-.344-3.379.115-3.152.494.228.372.797.172.767.4-.028.23-.569.518-.625.809-.056.287.173 1.24.313 1.467.142.235-.056.518.341.664.4.145.34.145.711.26.368.115 1.703.056 1.875-.09.167-.143.282-.085.452-.545zm28.73 16.88s.554.96 1.167 1.189c.612.227.996-.003 1.204.003.205.007.693-.256.907-.528.214-.274.531-1.658.436-1.905-.096-.247-.731-.793-.725-.998.006-.212.418-.23.256-.515-.165-.286-2.603-.221-2.616.196-.012.42.422.242.31.481-.11.242-.653.66-.866.86-.214.203-.073 1.217-.073 1.217z'/%3e%3cpath d='M385.66 251.11c-.1.268-.264 1.263-.167 1.512.097.244.578.8.813.91.238.116 1.3.183 1.545-.018.249-.2.409-.387.538-.715.13-.327.807-.856.645-1.105-.165-.247-.224-.366-.2-.59.023-.233.406-.262.486-.645.08-.38-2.795-1.256-2.874-.91-.079.346.333.323.257.53-.075.206-.932.722-1.043 1.031z'/%3e%3cpath d='M390.16 255c.384-.162 1.272-1.073 1.283-1.458.012-.382-.269-.723-.163-.857.106-.137.392.063.606-.14.211-.2-2.049-2.066-2.147-1.703-.097.363.358.603.201.72-.159.116-.651-.057-.86.078-.212.13-.662.833-.72 1.057-.058.224-.353.269-.207.603.143.337.11.3.256.602.145.302.96 1.11 1.15 1.133.188.025.22.13.601-.035zm86.74 7.25s.049 1.07.461 1.551c.416.479.837.467 1.01.57.17.103.697.111.992-.015.297-.13 1.168-1.146 1.197-1.4.026-.25-.27-1.01-.172-1.183.096-.171.448.004.437-.31-.015-.318-2.089-1.416-2.28-1.07-.194.347.246.4.05.552-.196.152-.84.243-1.103.312-.268.071-.592.993-.592.993z'/%3e%3cpath d='M480.26 262.95c-.214.156-.842.823-.891 1.05-.049.227.052.86.184 1.052.13.191.936.723 1.234.688.299-.04.52-.104.787-.29.27-.187 1.07-.271 1.064-.533-.005-.259.01-.379.142-.532.133-.159.455-.01.709-.26.256-.245-1.584-2.207-1.818-1.983-.238.223.096.393-.065.511-.162.12-1.099.116-1.346.297z'/%3e%3cpath d='M480.96 267.83c.364.14 1.557.135 1.82-.092.26-.226.297-.61.457-.623.16-.017.22.283.496.293.276.006 0-2.544-.302-2.384-.304.162-.166.596-.345.567-.182-.026-.4-.439-.627-.489-.226-.051-.988.097-1.18.198-.184.104-.408-.055-.533.24-.125.294-.125.251-.226.527-.102.275-.096 1.277.016 1.41.11.129.064.216.424.353z'/%3e%3c/g%3e%3cpath fill='%23f7e204' d='M346.72 237.45c.278.417-.09 1.421-.317 1.706-.226.284-1.74-.13-1.762-.41-.024-.284-.134-.759.064-1.025.2-.265.709-.873 1.094-.796.384.07.822.383.921.525zm.41-1.88c-.178.38.077.808.272 1.017.196.208 1.283.479 1.58.299.297-.183.75-1.869.541-2.129-.208-.26-.793-.304-.99-.275-.198.035-1.28.824-1.403 1.088zm3.62-1.72c-.146.345-.098.821.025.968.123.148.831.644 1.248.623.416-.026.614-1.194.614-1.418 0-.224-.124-.32-.418-.448-.292-.122-1.469.275-1.469.275zm34.27 18.13c-.093.417-.926.775-1.232.796-.309.023-.94-1.175-.78-1.355.16-.18.386-.53.666-.556.278-.03.951-.066 1.13.223.18.282.247.743.216.892zm1.4-.84c-.34.108-.454.522-.466.77-.015.244.456 1.09.74 1.169.285.082 1.588-.619 1.623-.904.036-.283-.276-.68-.413-.784-.13-.106-1.252-.327-1.484-.251zm3.17 1.29c-.3.107-.56.417-.583.584-.018.163.093.9.351 1.149.259.247 1.09-.31 1.228-.442.136-.132.127-.265.03-.525-.094-.26-1.026-.766-1.026-.766zm89.98 10.76c-.26.311-1.115.22-1.385.089-.266-.124-.273-1.431-.061-1.507.21-.076.554-.259.803-.153.243.104.825.397.852.72.024.325-.121.742-.209.851zm1.27.12c-.323-.074-.623.185-.756.36-.135.177-.185 1.024-.002 1.208.18.193 1.57.264 1.74.066.17-.198.122-.633.07-.773-.053-.138-.83-.813-1.052-.86zm1.45 2.59c-.27-.114-.65-.09-.774-.005-.117.09-.536.612-.526.925.009.315.933.49 1.108.495.18.009.263-.083.37-.299.108-.217-.178-1.116-.178-1.116z'/%3e%3cellipse cx='476.695' cy='268.569' fill='url(%23d)' rx='2.938' ry='5.862' transform='rotate(47.855 476.695 268.568)'/%3e%3c/g%3e%3cg fill='%2378732e' transform='translate(-.699 1.184) scale(1.16833)'%3e%3cpath fill='%23a8ac71' d='M375.12 185.22s-5.026.432-8.52-.173c-3.492-.605-2.725-9.507-2.811-9.766-.084-.26-2.13-2.42-1.79-4.407.342-1.989 6.795-7.233 7.668-7.519.597-.195 1.874.347 1.874.347s1.631-1.587 2.115-1.587c.499 0 1.187.915.996 1.306-.193.388-2.408 1.684-2.579 2.678-.17.994.022 1.988-.618 2.96-.638.972-1.874 2.29-2.023 3.111-.149.821-.51 1.535.107 1.837.618.303 2.727.043 4.537-.777 1.809-.822 2.554-1.924 2.81-1.815.256.107-1.043 2.267-3.045 3.112-2.001.842-3.323 1.813-4.324 1.663 0 0-1.107 2.658 2.323 2.808 3.428.152 5.324-.755 5.324-.755zm-19.64 20.96s2.64 1.035 2.64 3.978c0 2.937-2.894 5.399-2.81 10.584.086 5.188.89 5.239 7.753 10.804.213.174 1.661 1.644 2.044 3.33.385 1.683 1.618 11.623 8.223 11.577 6.6-.041 7.496-4.23 7.496-4.23l-2.812-4.15s-2.3.688-3.536.388c-1.234-.303-2.34-1.124-3.067-2.722-.723-1.6-.92-5.408-2.044-7.086-2.769-4.15-7.71-4.841-7.752-9.206-.043-4.366 3.023-4.839 2.171-10.027-.85-5.184-7.028-7.691-7.028-7.691l-2.512-1.016-.873 5.207z'/%3e%3cpath fill='%23f1a720' d='M373.67 169.89c2.214-.517.937-6.29.937-6.29l-1.533 1.276s.948 1.233.948 2.56c0 1.326-.352 2.454-.352 2.454z'/%3e%3cpath fill='%23a8ac71' d='M377.71 227.47s-1.027-.844-1.129-.914c-.791-.526-4.257-3.327-3.702-11.656.626-9.421 14.325-14.376 15.22-18.122.992-4.148 4.093-5.96-6.815-14.49l-2.557 2.996 4.473 3.357s.99-.556 1.047.714c.058 1.266-1.193 2.355-1.5 3.348-.283.906-7.086 5.632-7.597 6.094-.51.462-3.906 3.101-3.906 3.101s-1.77 1.741-3.419 5.4c-1.645 3.66-.797 8.354-.797 8.354s.054 10.003 10.681 11.817z'/%3e%3cpath d='m371.03 232.74.767 3.543-2.172.799-.937-.042-.68.3-1.683 1.625-.427-.134s-.256.09-.34-.95c-.086-1.035-.235-1.944-.235-1.944l2.045.84.723.046.511-.173.895-1.943zm-6.35.65s-.682-.821-1.022-1.317c-.29-.424-.436-.523-1.193-1.127l1.49-.839 1.598.02-.234 1.923zm3.63-5.69s1 .496 1.32 1.252c.32.758.788 1.686.788 1.686l-2.534-.192-1.939-.61 1.257-1.749zm-.99 15.67s-.513-.322-.81-1.14c-.3-.824-.534-2.142-.534-2.142l1.684-.322 1.98.796.555.047s-.469.992-.533 1.037c-.063.043-1.917 1.66-1.917 1.66zm6.72-5.43s-1.488-.468-1.724-1.169c-.255-.754-.448-.601-.448-.601l-.467 2.006-.597 1.882s.127.323.194.323c.062 0 1.425-.346 1.512-.387.084-.041 1.125-1.125 1.148-1.189.021-.065.382-.865.382-.865zm-6.27 6.31s.745.41 1.788 1.016c1.045.603 1.662.603 1.662.603l.788-.841.809-1.6.107-.194-4.026.364zm5.82-1.55 3.431-2.054.233-1.856-.68-.52s.128.063-.809.063h-1.172l-.618 2.271zm-2.45 3.24s2.405 1.036 6.558-.476c1.882-.685 2.237-1.598 2.237-1.598l-1.662-.646-1.574 1.405-5.56 1.315zm-3.28-26.63s-.243-.775-.479-1.789c-.233-1.015-.213-1.448-.213-1.448l1.223.635 1.768 1.316-1.257.998zm2.89 4.89s-.598-.605-1.11-1.38c-.51-.78-.865-1.5-.865-1.5l1.3.268 1.513.731-.668 1.956z'/%3e%3cpath fill='%23c6c7a6' d='M363.02 169.18c-.228.836-.54 2.363.625 2.651.63.155 3.127-.051 5.963-3.284 1.364-1.557 1.39-3.086 1.39-3.086l.54-1.754s-1.107-.808-2.897.315c-1.608 1.01-5.621 5.158-5.621 5.158z'/%3e%3cellipse cx='370.771' cy='164.639' fill='%231c242f' rx='.502' ry='.531'/%3e%3cpath fill='%23a8ac71' d='M367.16 165.17c-1.211.945-2.343 2.162-2.343 2.162s1.916-.542 3.44-1.926c.864-.785 2.55-1.09 3.438-.884.462.106.301-.49.086-.66-.497-.393-1.882-.591-2.184-.362-.042.033-1.218.718-2.437 1.67z'/%3e%3cpath d='M372.92 218.3s-.084-.399-.138-1.393c-.054-.995.06-1.493.06-1.493l-1.135.986-1.087 1.512 1.682.603zm-5.88-3.36s-.156-1.546-.07-3.014c.083-1.467.68-4.135.68-4.135l.718 1.825 2.065 3.218.66.477-1.746 1.276-1.788.582zm5.92-.82s.105-.733.287-1.413c.176-.664.695-1.727.695-1.727s.028.108-.057.126c-.085.023-1.81 1.451-1.853 1.514-.043.066-.809.733-.809.733l1.085.824.7-.04m-4.818-7.657s.263-.965 1.178-2.132c.915-1.166 1.818-2.362 1.818-2.362l.78 3.134.468 2.676.085.566s-.637.282-.894.259c-.256-.022-2.173-.132-2.407-.455-.233-.324-1.028-1.686-1.028-1.686zm6.21 3.65s.582-.618 1.093-1.092c.51-.478 1.324-1.395 1.324-1.395l-4.208.77.597 1.423zm-2.54-8.7s.39-.139 1.52-1.281c1.127-1.148 1.703-1.01 1.703-1.01l.47 4.517-2.216-.65z'/%3e%3cpath d='m377.1 207.36 2.534-2.571-4.215-1.207.769 2.96zm1.77-6.8.256-4.364s-.86.402-1.946 1.308c-1.085.907-1.59 1.196-1.59 1.196l.51.78 1.492.97zm3.75-4.23.006-3.436-.148.066s-.604.93-1.305 1.512c-.704.583-1.024.993-1.024.993l1.13.736 1.34.129zm1.57 4.6s1.188-.988 2.057-1.674c1.298-1.029 1.947-2.15 1.947-2.15l-5.451-.412.213 2.183zm-12.68-18.05-.17 2.392 4.545-.027-1.11-1.526-1.387-.866-1.307-1.326zm8.78 21.31c.24-.18 1.423-1.067 1.98-1.633.617-.626 1.587-1.253 1.587-1.253l-4.324-.476.086 2.854zm8.23-7.79s.464-1.74.42-3.404c-.042-1.663-.314-2.407-.314-2.407l-3.236 2.203.467 1.642 1.237 1.341z'/%3e%3cpath d='M382.98 192.4s.958-1.16 1.022-1.828c.064-.67.057-.462.057-.462l2.557.043 1.532.128.192.154-1.15 1.36-1.576.906-2.023.24zm5.18-2.55s-1-1.716-1.566-2.67c-.563-.95-1.118-1.403-1.118-1.403l-1.248 3.714-.126.359z'/%3e%3cpath fill='%23fff' d='m356.53 215.28-.489 1.034s1.703-.884 3.025-.84c1.319.044 2.79 1.687 2.79 1.687l.319-1.194s-1.747-1.705-2.897-1.787c-1.152-.089-2.748 1.1-2.748 1.1zm.852-7.626s.363.43.447.56c.084.13.128-1.275 1.852-2.009 1.726-.735 2.664-.151 2.664-.151s-.341-.995-1.106-1.21c-.768-.218-1.513-.065-2.452.605-.936.67-1.405 2.205-1.405 2.205zm5.857 5.743s-.809-1.723-2.214-2.07c-1.407-.346-3.196.73-3.196.73l-.296.91s1.915-1.082 3.321-.518c1.406.56 1.96 2.162 1.96 2.162zm-6.58-6.696c.084.304.426.69.426.69s-.193-1.856.66-2.807c.852-.951 1.49-1.296 1.49-1.296l-.788-.413s-1.128.757-1.514 1.579c-.382.82-.36 1.944-.274 2.247zm-.76-3.039c.396-.921 1.568-1.325 1.568-1.325s-.119-.204-.383-.347c-.266-.141-.542.012-.542.012s-.757.392-1.212 1.43c-.453 1.035-.396 2.534-.396 2.534l.702.39s-.136-1.772.262-2.694zm10.336-25.064c1.08-.577 1.875-.461 1.875-.461s-1.594 1.678-.825 3.768c-.905 1.75-1.19 3.081-1.19 3.081h.85s.289-1.363.625-2.437c.923 1.786 2.472 2.79 2.472 2.79l1.305-.057s.002-1.74.673-3.255l.125.142c1.417 1.499 2.611 1.847 2.611 1.847l.014-.447s-1.49-.88-2.342-2.032l-.085-.124.025-.05c1.024-1.611 2.388-2.13 2.388-2.13l.909.75.225-.289-.68-.864-.788.022s-1.412 1.177-2.323 2.204a12.015 12.015 0 0 1-1.034-2.054l-.584-.214s-1.414.163-2.68 2.208c-.157-1.5 1.573-3.138 1.573-3.138l-.085-.627s-1.748.33-3.11.734c-1.363.404-2.194 1.686-2.194 1.686l-.056.92s1.227-1.397 2.306-1.972zm1.875 2.766c.795-1.153 2.555-1.901 2.555-1.901s.045.933 1.015 2.173c-.662 1.162-.957 2.953-.957 2.953s-1.363-.862-2.556-2.592a2.12 2.12 0 0 1-.21-.387c.05-.087.1-.17.153-.246zm-9.94 27.758.065 1.012s1.043-1.141 2.62-1.185c1.576-.045 2.918 1.185 2.918 1.185s.02-1.359-.192-1.486c-.213-.132-1.492-.867-2.685-.867-1.192 0-2.725 1.34-2.725 1.34zm28.116-14.74a13.338 13.338 0 0 1-.612-1.348c.238-.09.474-.21.696-.376a16.368 16.368 0 0 0 2.258-2.074l-.469-.736h-2.13c-.417 0-1.303-.105-1.804-.17.093-.326.356-1.243.663-2.196.384-1.189.73-1.827.73-1.827l-.724-.733s.17.676-1.108.849c-1.278.173-3.635-1.035-3.635-1.035v.518s2.073.663 3.265.835a2.316 2.316 0 0 0 1.59-.351c-.183.378-.52 1.117-.702 1.776-.155.566-.377.935-.362 1.18.01.16.242.304.242.304l-.113 1.11s1.278.171 1.873.171c.597 0 2.215.13 2.215.13s-1.15 1.342-2.257 1.859c-.146.07-.3.123-.46.17-.059-.157-1.322-2.085-1.322-2.085l-.128.713s.904 1.241.994 1.504c-.817.108-1.994-.172-1.994-.172l-.511.563s-.037 1.6.012 3.255a35.242 35.242 0 0 1-2.341-.749l-.457.346.022-.08-.588.47s-.511 1.942-.382 4.148l.007.112c-2.1-.52-3.16-1.756-3.16-1.756l-.511.434s-.345 1.904.13 4.203c-1.795-.356-3.354-1.913-3.354-1.913l-.667.56s.398 3.719.823 5.748c.035.174.085.323.13.477a6.426 6.426 0 0 1-.982.042c-1.83-.087-2.967-1.772-2.967-1.772l-.54 1.309s.697 3.575 2.698 5.174l.451.36c-1.71 1.396-3.76 1.615-3.76 1.615l.127 1.128s1.222.958 2.414 1.782c.118.076.243.153.373.221-.951.85-2.116 1.194-2.116 1.194l.313.747s1.583-1.105 2.317-1.7c1.06.427 2.456.595 2.456.595v-.606s-1.027-.092-1.978-.396l.139-.129c.596-.577 1.76-2.361 1.76-2.361l.113-1.296s-.733-.104-1.527-.737c2.416-1.652 2.508-2.404 2.508-2.404l.456-.854s-.816-.35-1.418-1.538c1.657-.322 3.804-.858 3.835-.948.042-.129.287-.27.287-.27s-.929-1.521-1.325-3.384c1.91.494 3.859.813 3.859.813l.61-.522s-.47-1.544-.621-3.226c2.265.143 4.186.313 4.186.313l.383-.433s-1.277-2.442-1.234-3.824l.003-.127a6.2 6.2 0 0 0 1.273.127c1.877-.045 3.962 0 3.962 0l.32-.714s-1.81-1.232-2.235-2.012zm-13.79 20.332s-.608 1.236-1.844 2.662c-.1.112-.198.211-.295.312a6.054 6.054 0 0 1-.642-.312c-1.448-.822-1.819-1.759-1.819-1.759s.8-.392 3.237-2.026c1.288 1.02 1.364 1.123 1.364 1.123zm1.136-4.124s-.76.905-2.534 2.488a5.418 5.418 0 0 1-.546-.599c-1.136-1.472-2.556-2.738-2.413-4.956 0 0 .88 1.586 2.841 1.382.4-.038.86-.109 1.336-.191.522 1.313 1.316 1.876 1.316 1.876zm2.642-3.326s-1.815.596-3.5.867a6.964 6.964 0 0 1-.207-.565c-.637-2.074-.637-5.229-.637-5.229s1.415.979 3.4 1.53c.577 2.354.944 3.397.944 3.397zm-.601-3.837c-.294-1.935.091-3.855.091-3.855s1.055 1.054 3.023 1.384c.135 1.789.342 2.677.342 2.677s-1.495.083-3.456-.206zm7.63-2.948s-1.269.492-3.708.15a19.81 19.81 0 0 1-.04-.712c-.085-2.203.109-3.987.109-3.987l.007-.026c.347.153 1.645.684 2.855.979l.011.14c.17 1.987.766 3.456.766 3.456zm-.172-4.104-.131-.031c.083-1.413.077-3.47.077-3.47s1.187.317 2.101.193c.242.6.085.757.68 1.664.598.909 1.492 1.644 1.492 1.644s-3.025.257-4.219 0zm-9.88 24.441-.17-.706s-1.192.886-1.53 1.796a2.163 2.163 0 0 1-.375-.094 181.81 181.81 0 0 1-2.667-1.02l.268.53s1.945.894 2.455 1.01l.165.03a72.103 72.103 0 0 1-.645 1.84l.313.434s.177-1.314.679-2.233c.667.066 1.592.1 1.592.1s-.114.517-.286 1.094c-.168.577-.511 1.931-.511 1.931l.583.361 2.714.056-.457-.539s-.084-.135-.965-.163c-.881-.03-1.42.116-1.42.116s.113-.55.454-1.646c.34-1.096.356-1.032.356-1.032l-.342-.95s-.867.24-1.443.22a3.985 3.985 0 0 1 1.232-1.135zm-14.825-1.711c1.662 0 3.067 1.12 3.067 1.12l-.063-.794s-1.299-1.752-2.79-1.752c-1.492 0-3.259 1.535-3.259 1.535v1.64s1.383-1.75 3.045-1.75zm17.507 25.497c-1.703.732-3.62.732-3.62.732s.518-.742 1.026-2.025c3.332-.935 4-3.159 4-3.159l-.213-.821s-.807 2.033-3.492 3.154c.497-1.575 1-4.234 1-4.234l-.915-.237s-1.314 1.644-2.553 2.06c.84-1.636.956-3.51.956-3.51l-.405-.713s-.895.8-2.301 1.06a2.314 2.314 0 0 1-.687.007l.005-.007c.768-1.079 2.238-4.192 2.238-4.192l-.257-.585s-1.128 2.748-2.279 4.127c-.147.18-.29.346-.436.507-1.176-.34-2.863-1.348-2.863-1.348l.19.52s.956.73 2.349 1.173c-.849.89-1.774 1.72-1.774 1.72l.083 1.253s2.16.41 3.933.59c-1.428 2.02-2.589 2.693-2.589 2.693l.575.866s1.754-.011 4.902-.785c-.896 1.692-1.578 2.427-1.578 2.427s2.874.198 4.834-.8c1.96-.994 2.555-2.03 2.555-2.03l-.553-.608s-.426 1.429-2.13 2.165zm-9.072-5.407s.846-.93 1.572-1.885l.09.025c2 .432 2.553-.173 2.553-.173s.38 1.085-.84 3.034c-1.44-.06-3.375-1.001-3.375-1.001zm1.788 4.02 1.79-2.078a5.3 5.3 0 0 0 .341-.437c1.962-.07 3.067-1.68 3.067-1.68s.23 1.625-.648 3.627c-2.493.908-4.55.568-4.55.568zm-2.428-12.88c1.875.13 4.303 1.013 4.303 1.013l-.298-.992s-2.308-.564-3.745-.75c.642-1.438 2.061-2.122 2.061-2.122l-.638-.347s-.786.129-1.853 1.946a5.376 5.376 0 0 0-.24.451 5.485 5.485 0 0 0-.4-.018c-1.703-.046-3.13.948-3.13.948l.256.52s1.484-.642 2.946-.668c-.53 1.475-.924 3.152-.924 3.152l.385.887s.742-2.37 1.261-4.02zm-3.94-8.038-.405-1.04s-2-.709-3.534.023c-1.534.735-2.684 2.507-2.684 2.507l.64 1.21s1.064-1.966 2.47-2.44c1.404-.477 3.514-.26 3.514-.26zm3.898 3.046-1.32-.693s-2.172.629-2.94 1.407c-.767.78-1.384 2.767-1.172 3.327.213.56.896.928.896.928s.36-2.095 1.426-3.088c1.066-.994 3.11-1.881 3.11-1.881zm-5.067-.625c.892-.864 2.512-1.19 2.512-1.19l-.81-.734s-1.96.238-2.982 1.146c-1.022.909-2.343 2.788-2.343 2.788l1.152 1.121s1.576-2.27 2.471-3.13zm6.744-58.716.07-.09c1.033-1.328 2.035-1.328 2.428-1.22.165.045.385.026.581-.007l-.007.006.031-.011c.05-.01.094-.018.138-.028.05 0 .096.017.122.066-.328.518-.793 1.937-1.035 3.13-.3 1.468-.936 1.642-1.405 2.548-.468.91-1.447 2.423-1.49 3.717-.043 1.297.297 1.988.638 2.162.342.173.967-.564.937-.864-.043-.432-.382 0-.638 0-.255 0-.213-.432-.341-1.21-.129-.779.935-2.939 1.32-3.631.383-.691 1.192-1.512 1.362-2.68.153-1.04.911-3.319.911-3.327 0-.064-.58-.223-1.708-.302-.84-.061-1.973.676-2.509 1.5-.532.821-2.209 1.48-2.209 1.48s1.837.013 2.805-1.239z'/%3e%3cpath d='m374.33 178.91-3.27.087.938 2.446zm-3.85-.13s-.475-.301-.703-.562c-.227-.26-.404-.368-.404-.368l-1.178.742-.682 2.42.34.346zm-.44 6.56-2.386-3.515-1.362 2.932.652.23s.653.064 1.647.208c.994.145 1.449.145 1.449.145zm9.7 58.72-.12.082c-.565.378-3.069 1.906-6.141 1.906a8.76 8.76 0 0 1-4.535-1.248c-.916-.546-1.542-1.36-2.003-2.347-.692-1.476-.995-3.335-1.311-5.139-.322-1.803-.649-3.551-1.444-4.836-1.072-1.708-3.09-2.776-4.899-4.298-1.813-1.522-3.424-3.45-3.761-6.875-.034-.347-.05-.69-.05-1.026-.001-2.262.726-4.23 1.462-5.952.733-1.727 1.49-3.196 1.495-4.523 0-.222-.022-.441-.072-.653-.243-1.025-1.127-1.884-1.94-2.52-.814-.628-1.567-1.015-1.575-1.02l-.017-.008-1.27-.351-.108.398 1.25.347.054-.2-.092.185s.043.021.121.066c.281.155.998.577 1.683 1.15.687.574 1.33 1.312 1.495 2.045.042.18.06.37.06.56.007 1.163-.715 2.622-1.46 4.359-.741 1.739-1.496 3.764-1.497 6.116 0 .352.018.706.053 1.066.343 3.552 2.054 5.607 3.907 7.157 1.855 1.548 3.84 2.626 4.813 4.203.984 1.57 1.244 4.081 1.716 6.499.237 1.205.531 2.392 1.016 3.43.483 1.038 1.164 1.93 2.166 2.525a9.171 9.171 0 0 0 4.74 1.304c3.665-.003 6.481-2.054 6.5-2.067z'/%3e%3cpath d='m376.91 237.6-.025.02c-.14.082-.796.448-1.64.448-.678-.003-1.476-.224-2.284-1.02-.987-.973-1.276-1.877-1.525-3.024-.244-1.148-.434-2.53-1.212-4.34-.804-1.867-2.784-3.357-4.625-4.821-1.85-1.456-3.547-2.888-3.852-4.444a4.306 4.306 0 0 1-.087-.877c-.004-1.314.564-2.647 1.15-4.154.585-1.506 1.181-3.191 1.181-5.215 0-.342-.016-.695-.053-1.055-.272-2.608-2.26-4.547-4.151-5.841a18.497 18.497 0 0 0-3.724-1.953l-.136.391s.107.038.304.119c.683.278 2.414 1.05 4.018 2.288 1.606 1.24 3.07 2.932 3.282 5.04.034.345.051.685.051 1.011 0 1.94-.57 3.562-1.151 5.062-.58 1.5-1.178 2.872-1.18 4.307 0 .32.03.639.094.962.376 1.785 2.158 3.218 4 4.687 1.851 1.461 3.778 2.948 4.505 4.66.756 1.762.937 3.088 1.187 4.258.248 1.171.582 2.2 1.64 3.239.878.868 1.8 1.138 2.568 1.133a3.659 3.659 0 0 0 1.89-.533z'/%3e%3cpath fill='%23a8ac71' d='M388.97 227.59s2.29.54 2.206 2.397c-.086 1.86-1.108 4.45-1.108 4.45l-3.153-2.853 1.775-1.57.652-.933z'/%3e%3cpath fill='%23f8c83c' stroke='%23977c2e' stroke-width='.35' d='M349.61 205.23s-2.257.777-2.725-.216c-.47-.994-.256-1.773-.298-1.987-.044-.216-1.365-.303-1.236-1.6.127-1.297 1.788-1.21 2.13-1.21.342 0 .425-1.99 1.577-1.9 1.15.085 1.703 1.424 1.703 1.424z'/%3e%3cpath fill='%23f8c83c' stroke='%23977c2e' stroke-width='.35' d='M352.12 205.84s-1.916.996-2.514.043c-.596-.952 0-2.162-.213-2.378-.214-.214-1.361-.604-1.15-1.726.214-1.124 1.406-.78 1.833-.996.425-.215.723-1.901 1.916-1.598 1.192.304 1.406 1.253 1.406 1.253s-.939 4.493-1.278 5.402z'/%3e%3cpath fill='%23f8c83c' stroke='%23977c2e' stroke-width='.35' d='M355.36 206.27s-.555 1.212-1.917.948c-1.364-.256-.937-2.244-1.151-2.592-.212-.343-1.192-.604-1.022-1.857.17-1.252 1.406-1.08 1.874-1.252.469-.174.979-2.119 1.874-1.817.896.304 1.746 1.427 1.576 1.946 0 0-1.916.603-2.172 1.9-.255 1.298.938 2.724.938 2.724z'/%3e%3cpath fill='%23af7029' d='M385.51 227.14s-1.703-1.872-2.896-3.512c-1.193-1.645-3.04-3.52-3.04-3.52l-2.923-1.468-1.846-3.083-.23-3.63.797-2.102 1.108-1.614s-6.057 2.169-2.983 13.771c1.308 4.927 4.658 5.644 4.658 5.644l5.566-.34z'/%3e%3cpath fill='%23816c2a' d='M382.71 188.39c.576.018.86.21 1.034.45.173.244.228.57.227.851 0 .153-.016.289-.031.386l-.02.112-.008.035.199.053-.187-.084c-2.003 4.438-6.255 6.51-10.07 9.274-1.904 1.384-3.693 2.947-5.007 5.078-1.315 2.136-2.145 4.838-2.145 8.469 0 .183.002.372.007.56.146 6.673 2.67 10.264 5.448 12.142 2.775 1.885 5.777 2.075 6.91 2.078.297 0 .466-.013.47-.013l.006-.003h.006c.002 0 .777-.1 1.894-.202 1.114-.097 2.566-.2 3.904-.2.855 0 1.666.042 2.303.149.639.1 1.1.287 1.242.48.178.224.245.447.247.676.004.505-.365 1.087-.815 1.551-.443.465-.965.825-1.15.91l.172.375c.265-.124.787-.49 1.272-.996.478-.503.924-1.141.93-1.84a1.48 1.48 0 0 0-.34-.938c-.292-.348-.817-.51-1.493-.628-.674-.11-1.5-.15-2.368-.15-2.714 0-5.845.4-5.851.4l.026.208-.017-.208-.11.005a8.314 8.314 0 0 1-.328.006c-1.09 0-4.014-.192-6.684-2.003-2.667-1.817-5.112-5.233-5.266-11.807-.002-.186-.006-.37-.006-.553.003-3.57.811-6.183 2.082-8.247 1.905-3.099 4.88-4.984 7.787-6.945 2.906-1.96 5.752-4.004 7.315-7.458l.008-.016.004-.018c.002-.01.071-.28.071-.638-.002-.33-.057-.74-.304-1.094-.243-.354-.69-.611-1.354-.623l-.01.415z'/%3e%3cpath fill='%23fff' d='M390.88 229.04s-1.436 2.631-1.8 2.658c-.366.026 1.242.415 1.606 1.035l-.343.643s-1.59-1.131-2.586-1.179l-.09-.97s.813-.275 1.487-.89c.554-.506 1.132-1.922 1.143-2.248z'/%3e%3cpath fill='%23fcca3d' d='m396.48 230.77-3.579.98-1.824-1.14s.15-1.49-.66-2.129c-.835-.66-1.33-.854-2.055-1.157-.724-.302-3.28-.356-3.28-.356l-6.465-7 2.415.256 3.819-.474 3.55-.302 1.875.276 2 .618 1.052.89 1.092.967 1.095 1.8.696 2.033.284 2.188z'/%3e%3cpath fill='%23af7029' d='M396.62 230.54s-1.28.378-2.897.345c-1.62-.023-2.65-.274-2.65-.274s.094.102-.248 1.17a15.072 15.072 0 0 1-.654 1.727l.059 4.204 3.407.668 1.79-.694.909-4.582z'/%3e%3cpath fill='%23fcca3d' d='m395.67 228.76.155 1.63.667.194-.016-1.467zm-3.21-39.29-.398-2.865-1.122-1.901-1.42-1.946-1.52-1.672-.85-.76-.356-.563-3.735.173-1.958 2.334s5.1 3.599 7.02 7.532c1.651.496 2.936 1.54 3.669 2.255l.173-.31z'/%3e%3cpath fill='%23af7029' d='M388.84 192.63c-.053 2.92-.554 4.308-.942 4.955l2.262-2.594 1.63-2.93c-.733-.715-2.018-1.76-3.67-2.255.456.938.735 1.892.72 2.824z'/%3e%3cpath fill='%23816c2a' d='M394.11 235.87c-.003-.002-1.052-1.313-1.834-2.08-.799-.776-1.722-1.201-1.733-1.208l-.17.378s.05.023.144.074c.282.149.923.52 1.475 1.059.375.366.828.879 1.184 1.294.357.42.617.744.617.745z'/%3e%3cpath fill='%236f5b24' d='M396.31 232.73s-.342 1.264-1.619 2.416c-1.279 1.154-2.897 1.932-2.897 1.932l3.663 1.354 2.442-2.274z'/%3e%3cpath fill='%23404118' d='m396.85 235.77-.224.433-.688.666-.54.573.913-3.8.651 1.121.085.606z'/%3e%3cpath fill='none' stroke='%2378732e' stroke-width='.3' d='M375.12 185.22s-5.026.432-8.52-.173c-3.492-.605-2.725-9.507-2.811-9.766-.084-.26-2.13-2.42-1.79-4.407.342-1.989 6.795-7.233 7.668-7.519.597-.195 1.874.347 1.874.347s1.631-1.587 2.115-1.587c.499 0 1.187.915.996 1.306-.193.388-2.408 1.684-2.579 2.678-.17.994.022 1.988-.618 2.96-.638.972-1.874 2.29-2.023 3.111-.149.821-.51 1.535.107 1.837.618.303 2.727.043 4.537-.777 1.809-.822 2.554-1.924 2.81-1.815.256.107-1.043 2.267-3.045 3.112-2.001.842-3.323 1.813-4.324 1.663 0 0-1.107 2.658 2.323 2.808 3.428.152 5.324-.755 5.324-.755z'/%3e%3c/g%3e%3cg fill='%23d2a567'%3e%3cpath fill='%23ab6d29' stroke='%234d2a15' stroke-width='.511' d='M487.942 173.581s-10.755-2.03-10.58 6.924c.057 2.826.684 3.806 2.958 4.443 2.274.634 6.83.866 10.695 4.328 3.862 3.462 4.15 6 4.15 8.077 0 2.076-.964 3.982-.964 3.982l2.441 11.828 2.45 8.77 7.278-4.213 4.267-12.982-5.46-23.369z'/%3e%3cpath fill='%234d2a15' d='M498.62 218.597s3.747-1.416 4.712-4.444c.264-.831-3.785-4.474-3.883-4.474-.097 0 2.058 1.041 3.054 1.95.994.91 1.757 1.281 2.053 1.146.3-.135 2.028-4.142 1.364-5.017-.664-.874-1.696-2.927-3.254-3.97-1.557-1.044-3.615-.91-3.615-.91s2.855-.908 4.28-.1c1.423.807 1.558 1.75 1.723 1.414.167-.337-.3-4.343-.945-5.69-.646-1.346-1.309-1.986-3.036-2.322-1.72-.338-3.58-.204-3.58-.204s2.488-1.379 4.376-.907c1.89.472 1.861 1.414 2.023 1.212.17-.203-.93-3.669-1.372-4.545-.451-.874-2.707-2.626-3.338-2.828-.628-.202-2.688-.265-2.688-.265l-.995.013s1.432-.992 3.256-.824c1.82.169 1.92.774 2.183.674.267-.1-.199-.336-1.306-1.112-1.114-.772-6.489-3.063-6.489-3.063l-4.91-.068s-.052-1.244 1.378-1.479c1.427-.237 1.84.184 1.74-.187-.098-.368-4.143-1.26-4.143-1.26s-2.326.068-3.322.1c-.993.037-4.612.454-4.612.454s.315-.793 1.023-1.412c.539-.475 1.375-.771 2.064-.96 1.59-.438-.896-1.683-.896-1.683l1.328-2.018 5.974.502 12.607 7.373 5.908 5.084 3.746 9.558-1.128 16.424-8.43 6.969s-3.713.573-3.713.404c0-.17.863-3.535.863-3.535z'/%3e%3cpath d='M487.626 177.8s-.4-1.162-.4-2.626.25-1.414.25-1.414-4.03-.557-6.968 1.766c-2.934 2.323-1.244 6.361-1.244 6.361s1.282-1.262 2.92-1.87c1.643-.601 4.597-.502 4.597-.502.248-.254-.646-1.415-1.742-1.667-1.098-.252-3.235-.252-3.235-.252s1.245-.86 3.385-.655c2.141.2 2.437.858 2.437.858z'/%3e%3cpath fill='%238f4620' d='m500.232 220.01-2.723.945 1.66 11.443 10.881 18.644 5.707-1.005 1.926-3.435 1.526.674c.657.674 2.788 4.307 4.58 5.047 1.79.741 2.716.472 4.312 1.756 1.594 1.275 7.415 9.944 7.716 10.276.294.338-.335-3.717-.335-3.717l-1.774-5.184-2.201-3.618-.334-.975 3.019.033 1.872 1.147 2.871 2.401 1.491 1.769.781 1.82.329 1.594.768 2.476 1.588 3.435 1.913 3.264.61-1.331-.93-3.836-2.919-9.307-1.79-3.13s2.355 1.697 2.983 1.916c.631.223 2.772 3.42 2.772 3.42l1.362 3.296.98 3.062.671 2.678.984 2.857 1.69-.973-.296-2.067-1.46-6.382-.63-6.916s.816-.02 1.805 1.074c1 1.092 1.895 3.571 1.895 3.571l.733 6.26.991 5.737 1.857 5.859 1.94 3.683 1.263 2.067s.067-2.926.048-3.06c-.015-.132-2.373-24.498-2.373-24.498l.318-1.027s.281-.154 1.094 1.008c.812 1.16 1.627 2.976 1.627 2.976l.713 3.82.347 2.644.498 4.98.663 5.4 2.491 5.794 1.344 3.128.748-3.717-1.182-26.204.552-.757s1.39 1.145 1.853 1.955c.468.804 1.332 1.594 1.332 1.594l.811 5.774.731 16.527.58 4.257 4.86-43.286 3.002-.655.348-.826-2.192-1.683-4.922-7.64-3.32-7.388-5.822-10.728-10.105-12.318s-6.269-5.354-7.862-6.566c-1.593-1.21-2.911-1.967-2.911-1.967l.498-1.54 1.666-2.702-.272-.126-1.3.078-3.38.48-3.41-1.012-6.691-4.67-7.167-3.408-4.208-1.489-10.151-2.575-10.1-1.364-4.533-.062-4.129.77s-2.099.865-2.756 2.162c-.653 1.296-.705 2.203-.504 4.096.197 1.895 1.342 2.879 4.18 4.042 2.842 1.16 9.505 5.604 9.505 5.604l3.214 3.229 1.191 1.541.174 1.188 2.163 17.039-4.278 9.263-3.068 1.592z'/%3e%3cpath fill='%23ab6d29' d='M511.157 246.567s1.822 3.097 4.41.709c2.593-2.39-1.13-9.191-1.091-9.596.032-.404 1.191-.537 1.191-.537l1.894 3.5s1.127 1.884.693 4.88c-.428 2.996-3.315 5.587-3.315 5.587l-3.285-.74z'/%3e%3cpath fill='%234d2a15' d='m574.713 286.5-2.34-6.92s-.691-4.442-.691-5.35c0-.912-.45-12.17-.651-14.288-.198-2.12-.095-4.547-.32-4.845a962.59 962.59 0 0 0-2.54-3.36l-.992-1.037.702-.503s.862.944 1.098.435c.227-.501-.038-2.957-.995-6.797-.965-3.837-5.877-12.823-5.877-12.823l.53.436L564 232.83l2.887 2.32 6.24 2.289 3.385.54 2.186 4.376s1.559 7.54 1.46 11.339c-.1 3.807-.334 6.903-1.792 10.705-1.457 3.806-1.822 15.855-2.023 17.77-.2 1.923-.929 3.806-.929 3.806z'/%3e%3cpath fill='%238f4620' d='M574.737 266.486s1.306-1.556 1.88-3.695c.57-2.133.794-18.922-1.192-21-1.994-2.077-6.059-3.715-6.259-3.578-.2.137 1.624 5.473 1.624 5.473s.611.782 1.235 2.17c.344.774.816 2.172.897 2.683.225 1.445 1.416 4.849 1.592 9.235.168 4.384.223 8.712.223 8.712z'/%3e%3cpath fill='%234d2a15' d='M565.565 277.025s.855-7.943.456-13.76c-.395-5.816-.877-6.543-1.43-7.594a49.455 49.455 0 0 1-3.906-9.697c-1.352-4.844-2.229-8.561-3.104-9.53-.876-.97-2.63-3.069-3.025-2.502-.4.565-.4 1.777-.4 1.777l-2.39-.65-.556-1.533.766-2.473-.151-1.062-.28-1.75 3.087 2.457 6.338 4.343 3.184 13.145 2.951 8.18.415 13.853-.299 12.197zm3.727-37.9s1.658 1.564 2.626 2.106c.973.544 2.804 1.669 2.439 1.794-.358.125-2.078-.545-3.149-1.15a8.974 8.974 0 0 1-1.8-1.349z'/%3e%3cpath fill='%234d2a15' d='M556.943 273.894s1.264-2.788 1.063-6.324c-.2-3.535-1.888-12.051-2.42-13.13-.532-1.08-3.05-2.689-5.31-7.471-2.256-4.781-2.025-5.756-3.513-7.505a139.956 139.956 0 0 1-3.057-3.735l.464-5.118 5.508 2.794 2.356 1.177 2.79 13.394 2.49 3.737 1.057 5.356 1.332 12.485.724 9.93-.395.874zm-6.355-5.666s.147-3.939-.851-7.47c-.997-3.536-1.69-6.166-2.788-7.273-1.094-1.108-3.877-3.988-6.366-7.725-2.49-3.736-5.927-7.674-5.927-7.674l.09-5.011s1.653 1.555 3.062 2.239c1.409.684 3.52 1.865 3.52 1.865l1.472 5.746 1.9 4.134 2.784 3.697 1.779 1.642 1.134 6.186.61 3.48 1.467 4.968-.485 2.488-1.402-1.292zm-4.58.046-1.52-1.462s.821-.989.424-2.958c-.399-1.965-.922-3.861-1.819-5.728-.893-1.866-1.163-3.005-1.712-3.558-.551-.554-5.205-4.95-6.82-6.284-1.615-1.342-4.103-3.891-5.649-4.877-1.542-.98-2.664-1.235-2.664-1.235l-.871-6.161s2.043 2.726 3.262 3.18c1.22.456 3.213 1.086 3.213 1.086l4.324 7.65 1.47 1.944 4.006 3.204 1.642 3.307 1.22 3.814 1.518 5.253.274 3.178zm-8.506-1.718s-2.553-2.927-2.954-4.817c-.397-1.882.268-1.882-.532-4.036-.798-2.152-3.45-5.315-5.64-7.07-2.193-1.75-5.307-4.305-5.107-5.721.2-1.412.596-1.48.596-1.48l1.328 1.142 6.83 7.274 2.095 3.806 1.593 4.743 1.06 2.223 1.028 2.829zm24.652-35.68s4.709 5.841 5.906.472c.531-2.39-1.633-6.94-1.633-6.94s-4.377-7.667-5.868-9.519c-1.492-1.85-8.793-11.209-8.793-11.209l-5.337-2.49 1.822 3.132s3.98 3.97 9.061 12.754c5.073 8.785 4.077 13.631 4.077 13.631l.764.17zm-27.35-35.201s9.352 7.977 15.378 16.608c6.019 8.635 8.408 14.393 7.063 15.55-1.344 1.162-5.127-.653-6.664-3.078-1.544-2.423-2.844-6.664-8.514-13.129-5.674-6.46-8.408-7.421-8.408-7.421l-4.083-6.614zM529.93 214.8s5.524 4.594 9.006 8.33c3.487 3.737 5.279 6.412 5.279 6.412l2.236 2.22s-1.343-2.37-.595-3.18c.744-.806 1.644-.402 1.644-.402l-17.57-18.431zm-1.144.514s1.792 3.433 4.728 6.31a741.936 741.936 0 0 0 6.168 5.959l1.248 4.492s-8.012-6.156-8.062-4.644c-.052 1.514 1.942 4.644 1.942 4.644l-2.44-1.311-3.385-4.9-2.042-4.24-2.288-5.858 4.13-.452z'/%3e%3cpath fill='%234d2a15' d='M504.555 234.3s4.18 3.735 6.472.1c2.29-3.635.497-7.825.497-7.825s5.902 8.702 7.566.554c.299-1.464-3.585-7.12-3.585-7.12l1.393-1.309 2.981 5.048s2.795-1.262 2.795-4.747c0-3.483-2.886-7.978-2.886-7.978l2.751 3.063s5.456.12 5.558-3.215c.097-3.33-4.58-6.815-4.58-6.815s3.733.252 3.68-1.92c-.045-2.168-5.07-3.684-5.173-5.046-.099-1.364 1.492-3.689 3.783-2.426 2.29 1.262 5.474 2.273 6.767-.2 1.295-2.477-.099-2.978-.099-2.978s-2.94-.607-3.231-.707c-.304-.102-5.23-2.778-5.23-2.778l-4.137-1.564-4.27-.557 1.585 3.18 1.102 8.735.045 4.04.796 8.786-2.09 7.32-1.084 1.32-.77.982-1.822 3.865-2.557 2.769-3.271 4.184-2.985 3.238z'/%3e%3cpath fill='%23ab6d29' d='M534.185 250.703s-1.057-2.622-3.312-4.375c-2.26-1.753-5.843-1.886-5.843-1.886l6.134 6.5zm8.587 1.483s-1.99-3.968-4.31-6.395c-2.324-2.424-3.852-5.554-4.484-5.554-.627 0-1.091.135-1.091.135l.596 5.014 4.246 4.11s3.983 2.96 5.043 2.69zm7.068-.304s-.992-4.61-3.35-9.052c-2.35-4.444-4.842-6.262-4.842-6.262l.56 4.746 1.932 4.577 3.114 4.512zm5.77-2.593s1.66-9.492.168-12.12c-1.49-2.625-4.31-3.128-4.31-3.128l-.901 1.378.901 6.766 2.252 5.181zm5.679-15.82s1.392.707 3.084 3.903c1.69 3.198 4.082 12.659 4.044 13.163-.03.5-.893.385-1.124.272-.232-.124-5.974-9.093-5.974-9.093l-.911-8.382z'/%3e%3cpath d='M521.216 244.499s3.036-.657 3.036-1.716c0-1.062-3.629-3.183-3.331-4.9.145-.856 3.084.153 3.285-.454.198-.604-3.034-5.653-2.043-6.814.996-1.161 3.734 5.452 3.734 5.452s1.64 3.111 1.044 4.897c-1.842 5.503-5.725 3.535-5.725 3.535zm7.115-6.87c.147-.441 4.779.606 4.828.303.178-1.087-4.179-4.443-4.179-4.443s-.997-1.916-.693-2.219c.294-.304 3.083.303 3.235-.102.145-.404-3.19-4.797-3.19-5.603 0-.81.9-.103.9-.103s2.636 2.728 4.032 4.949c1.388 2.221 2.698 4.04 2.235 7.573-.493 3.785-7.561.856-7.168-.356zm20.913-6.964s-.751-3.13-.302-3.535c.451-.402 1.647-.757 1.647-.757s-2.469-1.539-3.638-1.566c-1.17-.025-1.342-.365-1.64.127-.301.49 2.114 3.533 2.114 3.533z'/%3e%3cpath d='M535.154 233.084s7.117 1.768 7.415 1.264c.299-.505-5.675-6.062-5.675-6.062s-.396-1.005-.296-1.36c.098-.352 2.586-.404 3.333.201.744.606 0 1.766.25 2.221.246.455 2.49 3.888 2.888 3.331.4-.554-.453-4.745-.25-5.047.197-.302 2.739 2.372 3.429 2.827.699.455 4.682 3.586 5.08 2.121.4-1.462.647-1.716.495-2.576-.147-.857 1.33 4.041-.531 4.644-1.857.609-3.996-.652-3.996-.652l-1.644-1.265-.962-1.01s1.064 3.788-.182 4.19c-1.242.406-2.687.204-2.687.204l-2.984-.304-3.683-2.726zm16.345-4.86s7.596 4.557 8.345 3.752c.751-.806-1.984-11.505-1.543-12.62.352-.893 6.167 12.15 3.334 13.934-2.166 1.359-3.235.403-3.235.403l-3.731-1.97-3.17-3.5zm21.135 19.195s.687.509 1.655.783c.308.088 1.222.366.969.393-.247.02-2.023.238-2.151.287-.123.05-.473-1.462-.473-1.462zm-7.372-25.106s.724.413 1.173.538c.449.127 1.022.406 1.022.481 0 .077-.561.315-.96.265a2.422 2.422 0 0 1-.647-.164l-.588-1.121zm-2.185-3.74s.779.358 1.773-.351c1-.707 1.064-1.178.984-1.55-.084-.37-1.646-.37-2.173-.725-.532-.35-.5-.99-.5-.99l-1.71-.034-.63.235zm6.706 22.035s2.324 1.364 2.975 1.492c.643.127 1.742.734 1.59.934-.146.202-1.863.354-2.734-.15-.872-.507-1.159-.194-1.159-.194l-.672-2.083zm-12.513-34.594.038.013c.13.037.56.147.929.107.442-.05.81-.32.966-.149.312.349.06 1.965-.57 2.426-.626.461-1.392.835-1.503.806-.116-.027-2.45-3.375-2.45-3.375zm-10.888-9.743s1.521-.09 2.28-.088c.76 0 1.642.55 2.325.982.683.432 1.367 5.02.995 5.886-.369.867-5.486-2.972-5.624-3.315-.146-.349-2.367-3.783-2.367-3.783zm-4.802-2.08s3.725.23 3.384-2.133c-.339-2.37-2.047-3.405-2.047-3.405l-4.462 3.172 3.124 2.366zm-9.99-4.359s.998.551 2.107.115c1.108-.432 4.037-4.24 6.17-4.703 2.135-.46 2.56-.43 2.963.06.396.489.197 2.654-.289 3.258-.48.608-6.684 3.232-6.684 3.232s-1.292-.077-2.294-.31a14.74 14.74 0 0 1-2.028-.668l.055-.984zm-1.156-6.857c-.942-2.201-2.617-3.098-3.244-2.952-.626.145 2.132 2.337 2.53 5.368.399 3.027.369 5.06.315 5.234-.056.17 1.28.19 1.28.19l.255-1.157.16-.826-.016-.746-.182-1.565-.329-1.235-.27-.948c-.001 0-.017-.227-.499-1.363zm-8.821-3.132c-2.855-3.333-8.029-5.706-8.381-5.706-.352 0 6.021 3.84 7.464 6.311 1.442 2.476 1.494 5.806 2.14 6.261.645.457 1.246-.225 1.297-.3.047-.078.521-.76.447-.962-.076-.2-.4-1.59-.4-1.59l-.991-1.665-.6-1.037zm-8.458-3.48c-3.612-3.183-10.156-4.696-15.457-4.77-5.303-.078-8.012.4-7.243 3.303.776 2.904 3.165 4.166 7.64 4.166 4.484 0 5.554-.479 7.966.277 2.415.759 4.626 2.123 5.498 3.03.874.91-1.665-2.221-3.953-3.938-2.29-1.715-3.794-2.615-3.794-2.615s-.44-.945 2.651-.514c3.08.426 7.21 2.424 8.332 4.999 1.119 2.576.945 3.99.921 4.543-.028.555 1.07-.302 1.07-.302l.447-1.264s.177-1.01-.42-2.144c-.597-1.137-.7-1.516-2.09-3.154-1.395-1.644-1.568-1.618-1.568-1.618zm-14.71 43.706c2.257-.067 7.3-4.375 8.034-10.364.73-5.993-2.989-18.178-3.851-19.456-.861-1.282 1.39-.607 2.62.672 1.231 1.279 3.75 9.964 3.75 16.291 0 6.331-1.261 8.145-4.646 11.378-3.384 3.23-6.106 2.894-6.106 2.894l.2-1.415zm7.84 17.782s1.126 1.414 2.383.94c2.326-.867 5.907-2.582 5.907-5.923 0-2.155-2.784-4.037-2.917-4.846-.133-.807 0-1.481 0-1.481l2.452.54.701 3.43s.96 1.012 1.956.608c1-.407 3.846-2.49 3.448-4.511-.395-2.021-3.115-4.51-3.38-5.52-.266-1.012.064-1.886.064-1.886l2.325.404.711 2.952s.612 1.021 1.942.75c1.327-.268 3.65-2.692 3.12-3.837-.532-1.143-2.256-3.839-2.389-4.105-.133-.269-.066-1.28-.066-1.28l.93.522s.895.353 2.687-.176c1.793-.53 3.536-1.742 3.507-2.979-.022-1.237-1.342-2.423-1.445-3.103-.098-.681-.024-.962-.024-.962l1.172.178 1.442 1.792.346 2.145-.52 1.842-2.188 2.375-2.168.91-.594-.053 1.32 2.299-.428 3.055-1.913 1.764-2.568 1.542-.197 2.853-1.418 3.08-3.285 1.943h-.965l-.378 1.867-2.06 2.93-3.558 2.371-2.592.48-1.492-2.171z'/%3e%3cpath d='M525.913 205.5s5.958 1.682 5.772-2.088c-.102-2.121-5.836-7-6.202-7.807-.364-.81-.265-1.92-.265-1.92l2.968 2.719s3.788.901 4.867-1.287c1.076-2.184.208-3.56.019-3.61-.186-.048.87-.19.87-.19l1.754.358-.21 3.372-1.943 8.48s.516 3.329-2.108 3.566c-2.621.238-5.522-1.592-5.522-1.592zm5.643 45.179s.102-1.718-1.225-2.914c-1.33-1.195-3.883-2.322-4.296-2.576-.416-.25 4.261 5.317 4.261 5.317zm8.633.28s-2.988-3.685-3.632-4.95c-.649-1.259-2.191-4.039-3.437-4.166-1.242-.125 1.172 4.595 1.172 4.595l4.849 4.421zm8.179-.08s-2.562-4.846-3.186-6.262c-.62-1.416-1.966-5.278-3.485-6.338-1.513-1.06.2 1.767.2 1.767l1.619 5.023 2.842 4.369zm6.028-3.518s-.174-4.136-.676-7.016c-.493-2.878-2.735-5.276-2.883-5.174-.15.102.17 5.124.17 5.124zm12.443 3.12s-2.09-4.975-2.936-7.323c-.846-2.348-2.935-6.286-3.159-6.336-.224-.05.622 4.517.622 4.517l2.537 7.272zm10.795-13.027s-1.916-1.969-6.048-3.587c-4.127-1.612-8.26-1.793-8.26-1.793l.499.531 1.875 1.592 4.318 2.22 5.638 1.364z'/%3e%3cpath fill='%23202020' d='M533.284 239.895s.033 3.603 1.89 5.792c1.86 2.19 6.238 6.192 7.103 7.002.863.805 1.592 5.25 2.887 8.952 1.289 3.7 1.595 6.734 2.155 7.775.564 1.04 1.723 2.724.864 2.557-.864-.168-1.662-1.179-2.193-2.524-.532-1.344-.366-1.344-.294-3.198.064-1.853-2.822-11.343-4.151-12.385-1.33-1.047-7.433-6.125-9.79-9.628-2.353-3.5-1.854-4.31-1.854-4.31l3.384-.034z'/%3e%3cpath fill='%23202020' d='M543.133 263.624c-1.295-2.659-1.526-5.014-1.925-6.597-.4-1.582-5.541-5.888-6.771-6.463-.93-.435-2.867.118-3.646-.471-.778-.587-5.641-6.106-5.641-6.106s-.731.69-.498.89c.233.205 5.274 5.656 7.096 7.403 1.832 1.752 2.822 5.656 4.151 8.686 1.329 3.025.797 2.422.931 3.9.132 1.484 1.062 2.328 1.99 2.328.927 0 1.16-.44.816-.694-.353-.25-2.245-2.471-3.338-5.351-.999-2.626-2.29-7.471-3.883-9.292-.102-.112-.222-.254-.358-.404.375-.044 1.009-.164 1.982-.217 1.231-.067 6.304 4.612 6.74 5.992.43 1.382-.036 1.917 2.09 6.531 2.123 4.614 3.116 5.688 3.116 5.688h.37s-1.93-3.164-3.22-5.823zm-7.98-30.54s3.685 2.323 4.777 2.626c1.091.302 1.891.405 1.891.405s.55 6.718 3.235 10.5c2.684 3.79 4.875 5.153 4.875 5.153s.1 7.317 2.092 12.369c1.993 5.047 2.388 11.156 1.94 12.113-.448.96-2.142-2.976-3.232-6.461-1.098-3.485-2.143-7.266-2.888-9.592-.746-2.323-2.788-5.809-3.93-6.767-1.15-.96-.227-.856.446-.253.67.607 2.612 3.005 3.857 6.87 1.242 3.86 1.74 7.773 2.412 7.8.673.023 1.192-.63 1.172-1.416-.027-.778-.872-2.8-1.492-6.411-.625-3.61-1.248-6.082-1.845-7.093-.6-1.008-1.47-1.186-3.78-5.225-2.314-4.038-3.336-6.285-3.736-8.155-.398-1.869.073-1.69-.325-1.969-.396-.277-.693.027-2.457-.957-1.77-.985-3.011-3.535-3.011-3.535z'/%3e%3cpath fill='%23202020' d='M544.7 231.717s2.255 1.751 3.514 2.29c1.262.537 3.086.636 3.086.636s-.46 6.363 2.028 10.505c2.487 4.14 5.074 6.561 5.074 6.561s.398 1.55 1.197 10.433c.797 8.89.827 9.055 1.06 12.623.232 3.568.343 16.21-.17 15.821-1.92-1.482-.33-8.348-1.29-11.172-.961-2.832-2.486-3.304-4.346-11.31-1.859-8.014-.667-9.832-1.99-12.826-1.327-2.998-3.085-3.265-3.085-3.265s2.453.471 3.482 2.995c1.031 2.523 1.188 9.231 2.027 12.556 1.89 7.505 4.479 11.307 4.479 11.307s-.566-9.424-1.295-14.774c-.731-5.356-.695-9.827-1.69-11.881-1-2.057-3.156-3.705-4.447-6.432-1.295-2.726-1.76-8.078-2.393-9.458-.627-1.38-.988-.951-1.888-1.311-2.92-1.178-3.354-3.3-3.354-3.3z'/%3e%3cpath fill='%23202020' d='M551.5 228.224s1.99 2.219 4.772 3.87c2.792 1.649 4.183 1.147 4.616 1.481.431.337-.565 5.992 2.356 11.208 2.92 5.218 3.982 5.319 4.049 6.029.065.701.595 16.087.963 21.302.362 5.217.759 22.72-1.396 22.72s-.2-12.929-1.26-15.955c-1.066-3.033-1.027-2.155-2.055-4.574-1.033-2.428-1.018-12.01-2.657-17.676-1.225-4.239-2.49-4.915-2.49-4.915s2.064 1.11 3.02 4.614c.963 3.498 1.262 15.248 2.39 17.128 1.125 1.888 2.752 4.21 3.119 5.963.367 1.747-.232-22.32-.729-23.764-.496-1.451-5.344-10.166-5.71-14.98-.36-4.811-.532-5.285-.957-5.652-.436-.375-1.823-.07-4.113-2.224-2.294-2.153-3.919-4.576-3.919-4.576z'/%3e%3cpath fill='%23202020' d='M562.446 230.993c.137-.463 1.519 2.587 5.848 4.306 4.33 1.715 8.462 1.413 9.01 1.866.547.454 3.286 6.97 3.382 15.65.105 8.687-1.493 7.878-2.834 15.353-1.342 7.472-1.396 22.665-2.24 24.99-.4.856-.847 1.209-1.297 2.677-.446 1.46.346 4.239-.997 4.289-1.34.05-1.491-2.12-1.491-3.282 0-1.161 1.396-5.3 1.396-9.441 0-4.142-.898-4.645-1.496-9.596-.597-4.945-.646-20.696-1.192-22.211-.548-1.512-3.251-4.792-3.251-4.792s2.903 1.863 3.6 3.982c.694 2.125.763 19.615 1.542 23.127.797 3.583.547-.808.846-2.83.296-2.017 1.344-10.602 1.192-15.196-.15-4.59-2.092-14.539-3.684-16.206 0 0 .829.965 1.74 3.151.023.062.585.637 1.238 1.015.689.396 1.477.599 1.5.67.023.053-.873-.074-1.578-.382-.521-.225-.904-.65-.887-.61.982 2.599 1.971 6.617 2.065 12.36.137 7.827-1.141 25.046.103 25.247 1.246.204 1-9.39 2.29-17.165 1.292-7.776 3.035-8.89 2.488-15.248-.547-6.361-2.237-13.23-3.58-14.088-1.342-.858-5.177-.555-8.565-2.728-3.379-2.168-5.289-4.447-5.147-4.907zm-54.864 8.762s1.247.555 2.688-.15c1.447-.708 5.277-3.735 5.277-5 0-1.262.053-2.524.053-2.524s.048.557 1.146.705c1.09.157 4.226-2.219 4.471-3.733.253-1.514.253-4.189-.094-4.745-.35-.555.943.555 1.59-.052.647-.606 3.682-2.575 3.637-4.593-.053-2.021-1.695-3.89-1.695-3.89s1.494.203 2.386 0c.9-.198 3.886-1.967 3.785-3.785-.1-1.818-1.142-4.594-3.485-4.797 0 0 1.743.406 3.437-.2 1.69-.606 2.29-1.566 2.29-3.487 0-1.917-3.435-6.056-4.033-6.41-.596-.35 3.681 1.212 4.777-.505 1.09-1.716 1.242-2.928.944-3.886-.298-.96-1.194-1.211-1.194-1.211s1.845.502 4.333-.76c2.487-1.261 4.676-2.926 5.822-2.876 1.144.05-3.635 2.573-3.885 3.99-.1.583 1.303 1.585 3.464 3.168.137.096.2.188.418.304.98.529 4.698.681 4.948.87.31.229-3.593.144-3.259.398 2.628 2.009 5.823 4.7 8.746 8.252.11.132.729.669 1.442.875.871.248 1.865.17 1.993.334.095.128-2.524-.065-2.429.06a100.076 100.076 0 0 1 5.017 7.198c.103.16.712.874 1.41 1.174.762.328 1.62.249 1.724.422.194.303-2.13.012-1.953.306a125.562 125.562 0 0 1 5.067 9.213s-4.686-8.24-10.414-14.654c-5.723-6.411-7.066-7.269-7.363-6.662-.3.605 4.28 6.26 6.719 10.246 2.435 3.991 4.652 8.952 4.652 8.952s-5.748-11.93-13.81-19.25c-8.065-7.32-8.906-8.532-9.803-8.23-.898.305-1.59 5.707-1.046 6.816.547 1.112 6.42 5.554 11.443 11.461 5.028 5.908 11.4 16.055 11.4 16.055s-4.526-7.32-12.192-15.45c-7.666-8.128-10.598-9.996-11.196-9.946-.597.05-.65 1.516-1.542 2.728-.897 1.21-2.74 1.059-2.793 1.616-.045.555 6.475 6.56 7.767 7.269 1.292.707 1.99.354 2.985.909.995.555 2.073 1.482 2.073 1.482s-1.371-.523-2.37-.825c-.997-.304-1.993-.355-1.993-.05 0 .3 5.278 6.762 6.171 7.167.897.406 1.395.203 2.59.658 1.191.455 2.89 1.666 2.89 1.666s-1.848-1.061-3.14-1.315c-1.292-.252-1.84 0-1.793.356.053.351 4.033 5.452 3.835 5.553-.197.1-6.17-7.07-11.249-11.562-5.077-4.494-7.364-5.453-7.615-5.301-.246.15-.098 1.466-1.343 1.919-1.244.454-2.39.606-2.39 1.06 0 .454 4.58 4.746 7.812 8.33a229.033 229.033 0 0 1 6.023 6.969s-3.283-3.283-6.866-6.665c-3.585-3.382-5.423-4.694-5.772-4.493-.35.2-.398 1.918-.052 2.372.348.455 6.97 8.282 6.771 8.482-.199.202-7.813-9.39-8.31-9.39-.502 0-.8 1.21-1.296 1.767-.5.556-2.638.556-2.638 1.311 0 .758 10.748 11.307 10.45 11.56 0 0-8.905-7.673-9.205-7.218-.3.454 3.73 7.825 3.482 7.977-.25.152-5.226-7.724-5.676-7.673-.44.048-.398.908-1.69 2.069-1.293 1.162-2.935.657-2.986 1.162-.05.504 7.417 8.786 7.215 8.936-.199.15-7.56-7.877-7.762-7.422-.05.12-.446.465-.247 1.161.548 1.937 2.21 5.458 1.99 5.755 0 0-2.389-4.897-3.038-4.695-.645.202-.645 1.164-1.743 1.869-1.09.707-1.987.556-2.089 1.06-.096.503 1.295 1.363 1.895 2.527.593 1.161 1.094 3.686 1.094 3.686s-.748-2.125-1.792-3.486c-1.045-1.364-1.994-2.273-2.788-2.273-.795 0-1.344.758-1.344.758l-.748-1.769z'/%3e%3cpath fill='%23202020' d='M577.319 237.174s2.436-.15 2.734-.655c.3-.507-.896-.154-3.085-2.524-2.188-2.375-7.779-18.564-13.884-26.712-9.996-13.33-19.358-19.435-19.358-19.435s11.136 6.445 19.76 19.034c8.754 12.792 10.88 22.822 13.331 25.446 2.459 2.625 4.847 3.095 4.715 3.837-.133.741-.533 1.279-1.462 1.414-.928.134-3.187.336-3.187.336l.435-.741zm-73.57-3.53s.065.196.516.248c.458.057 3.483-2.961 3.316-3.832 0 0-1.344-.504-2.434-1.615-1.094-1.111-1.347-2.878-1.347-2.878s.998 1.969 1.843 2.524c.846.554 2.19.857 2.687.454.5-.404 4.952-3.702 4.678-4.999 0 0-1.392.05-2.688-.909-1.292-.96-1.528-2.93-1.528-2.93s.835 1.583 2.162 2.225c1.321.64 2.618.37 2.985-.102.364-.473 3.284-4.48 2.95-5.653 0 0-1.49.167-2.819-.775-1.328-.945-2.023-3.3-2.023-3.3s.961 1.986 2.652 2.321c1.692.338 3.087-.672 3.35-1.882.265-1.212 1.195-5.722-.227-6.868 0 0-2.195.707-3.752-.1-1.555-.808-2.121-2.793-2.121-2.793s1.325 1.817 3.08 2.052c1.762.235 2.527-.705 2.821-1.414.304-.707.369-3.264-.164-4.677-.53-1.415-1.626-1.315-1.887-3.433 0 0-.57.84-2.826.84-2.255 0-3.451-2.558-3.451-2.558s1.796 1.651 3.585 1.516c1.79-.135 2.455-1.616 2.493-2.761.027-1.147-.901-2.156-1.395-3.333-.499-1.178-.534-2.592-.865-2.423-.332.168-.761 1.245-3.087.875-2.32-.368-2.82-1.953-2.82-1.953s1.693 1.18 2.985 1.078c1.3-.1 2.123-.707 2.123-1.58 0-.878-.494-2.494-3.415-4.985a89.147 89.147 0 0 0-5.308-4.205s3.783 2.086 6.236 4.14c2.46 2.053 3.848 4.04 3.848 4.04s2.692.874 2.988-.035c.296-.91.252-2.044-.596-3.66-.828-1.58-3.133-3.938-3.133-3.938s2.411 1.993 3.555 4.063c1.142 2.07.627 3.51.72 4.014.103.503 5.128 2.45 6.248 1.768 1.12-.682.597-2.146-.348-3.637-.943-1.488-1.722-2.725-1.722-2.725s1.173 1.29 2.017 2.751c.848 1.466 1.544 2.628 1.221 3.307-.32.682-1.021.985-.945 1.264.076.275 1.737 1.16 3.434 2.044 1.693.884 3.656 1.666 3.907 1.186.25-.48.423-1.641.278-3.282-.154-1.64-1.098-4.14-1.098-4.14s1.117 2.424 1.317 4.14c.198 1.718-.22 3.005.175 3.61.399.606 1.64.759 1.64.759s-.995.705-3.208.05c-2.214-.658-11.72-5.455-12.17-5-.446.454 4.431 3.409 6.671 5.53 2.241 2.119 3.334 4.34 3.334 4.34s-1.742-1.464-3.432-2.397c-1.692-.934-6.77-3.535-7.096-3.182-.317.355 1.92.807 2.09 1.214.175.404-1.59 1.993-1.59 2.65 0 .655 7.241 5.678 7.016 6.233-.223.557-1.839 1.869-2.137 1.794-.3-.077-3.88-2.828-3.88-2.398 0 .43 2.06 2.17 2.038 2.548-.023.38-1.367 1.289-1.125 2.147.253.858 4.038 3.965 4.011 5.023-.027 1.06-2.165 1.969-1.765 2.65.394.683 2.337 3.08 2.337 3.08s-2.091-1.388-2.765-2.118c-.672-.734-2.019-2.323-2.258-2.073-.251.255-1.595 3.208-1.471 3.865.127.655 1.817 1.664 2.14 3.455.324 1.794-.25 3.66-.376 3.66-.124 0-2.508-3.078-2.985-3.128-.47-.05-1.067.153-1.466.935-.4.782-1.795 3.23-1.616 3.685.169.453 2.507.984 2.561 2.853.05 1.869-1.47 3.608-1.618 3.608-.15 0-2.911-3.71-3.185-3.71s-3.41 3.485-3.484 3.912c-.077.43 2.139 1.996 1.743 2.603-.4.605-1.895-.23-2.742.25-.842.482-2.335 1.085-2.636 1.085-.296 0-.746-1.007-.746-1.007z'/%3e%3cpath fill='%23202020' d='M543.648 187.999s.25-.985.725-1.49c.47-.506 2.393-2.627 1.667-3.054-.72-.427-3.16.355-4.701.225-1.545-.124-2.564.254-7.043-3.458 0 0-14.204-9.93-36.206-11.208-6.969-.403-10.089 2.089-10.42 3.4-.03.302 1.828-2.828 8.826-2.726 3.087.033 25.24 1.822 36.728 10.838.6.47 4.405 4.115 7.963 3.71 3.56-.404 4.307-.807 4.231-.303-.074.505-1.192 1.819-1.442 2.421-.247.607-.494 1.719-.494 1.719zm-38.392 2.932s-.019-.064-.057-.18c-.199-.606-1.614-2.582-4.021-4.817-2.887-2.678-11.85-6.413-12.297-6.564-.446-.153 9.201 4.444 11.898 7.018 4.326 4.14 4.478 4.543 4.478 4.543z'/%3e%3cpath d='M505.233 206.738s-.588-.971-2.476-2.184a15.123 15.123 0 0 0-3.785-1.716l4.378 1.111c1.295 1.11 1.882 2.79 1.882 2.79zm-1.133-8.236s-.597-.858-3.284-1.717c-2.688-.858-3.333-.808-3.333-.808s2.488-1.06 4.377-.098c1.89.956 2.24 2.624 2.24 2.624zm-1.59-6.765s-.547-1.212-2.937-2.069c-2.388-.86-4.082-1.011-4.082-1.011s2.487-.704 4.88.253c2.389.958 2.14 2.827 2.14 2.827zm-2.885-4.346s-.7-.957-5.174-2.017c-4.483-1.063-6.225-1.114-6.225-1.114s6.372-.502 8.064.205c1.688.705 3.335 2.926 3.335 2.926zm-8.213-4.697s-2.734-.757-5.373-.96c-2.639-.201-6.771.151-6.771.151s7.666-1.21 9.704-.755c2.043.453 2.44 1.564 2.44 1.564z'/%3e%3c/g%3e%3cg fill='%23f8c83c' stroke='%23977c2e' stroke-width='.35'%3e%3cpath d='M466.199 277.562s1.362 2.39 4.048 2.49c2.689.1 4.777 3.94 4.777 3.94l-2.953 2.894-7.099.335-2.287-3.669 3.515-5.99zm.164-2.454c.232-.467-2.09-5.05-3.75-5.822-1.658-.77.564 1.483.2 2.424-.364.943-.61 2.105-.478 2.273.134.167 1.371 2.105.71 2.98-.665.874 3.318-1.854 3.318-1.854z'/%3e%3cpath d='M465.09 282.095s1.262.63 2.258.34c.995-.294 1.88-1.305 1.88-1.305m-5.423-.81s3.983-2.895 3.652-4.44c-.335-1.55-1.13-1.483-1.662-1.347-.53.133-2.984 2.153-3.116 2.623-.133.471 1.126 3.164 1.126 3.164z'/%3e%3cpath d='M460.989 282.306s.729 1.92 2.022 1.92c1.295 0 3.153-1.044 3.185-1.814.034-.781-1.294-2.193-2.157-2.594-.861-.402-2.853.638-2.853.638z'/%3e%3cpath d='M464.61 279.689c-.198.6-2.72 1.781-3.55 1.849-.828.067-2.52-2.053-1.826-2.359.7-.302 1.562-.271 2.191-.604.631-.34.797-1.178 1.162-1.213.364-.033 1.393.237 1.658.872.267.644.564.848.366 1.455z'/%3e%3cpath d='M462.017 281.36s-3.911 5.287-5.538 5.02c-1.626-.27.662-7.508.662-7.508s.632.405 1.925.81c1.294.402 2.589.874 2.951 1.677z'/%3e%3cpath d='M455.053 277.597s5.044.874 5.278 1.684c.231.808-2.424 1.884-3.85 1.884-1.428 0-1.428-3.568-1.428-3.568z'/%3e%3cpath fill='%23202220' stroke='none' d='M442.505 285.238s.667 2.425 2.857 2.56c2.19.136 4.246-2.29 4.246-2.29l-5.177-2.019z'/%3e%3cpath fill='%234b4139' stroke='none' d='m442.505 285.238-.112.033c0 .012.17.626.624 1.27.45.638 1.196 1.312 2.338 1.378l.184.008c2.206-.014 4.147-2.338 4.159-2.339l.11-.133-5.402-2.104-2.036 1.85.022.07.113-.033.085.09 1.868-1.702 5.106 1.994.043-.112-.088-.079s-.117.137-.332.353c-.637.64-2.122 1.903-3.648 1.897l-.17-.004c-1.05-.063-1.731-.674-2.158-1.277a4.346 4.346 0 0 1-.455-.823c-.047-.113-.08-.208-.103-.27l-.03-.097-.118.03.085.09z'/%3e%3cpath fill='%23202220' stroke='none' d='M443.966 284.56s.862 1.823 3.716 1.89c2.854.066 5.109-2.29 5.109-2.29l-4.512-3.568z'/%3e%3cpath fill='%234b4139' stroke='none' d='m443.966 284.56-.106.055c.005.02.91 1.888 3.819 1.956h.124c2.862-.004 5.064-2.32 5.075-2.324l.092-.097-4.696-3.713-4.454 4.099.04.079.106-.054.08.09 4.239-3.9 4.434 3.503.072-.093-.087-.088-.094.1c-.45.427-2.42 2.16-4.807 2.156h-.118c-1.402-.037-2.3-.493-2.857-.944a3.37 3.37 0 0 1-.585-.605 1.746 1.746 0 0 1-.13-.2l-.037-.07-.11.05.08.091-.08-.09z'/%3e%3cpath fill='%234b4139' stroke='none' d='M444.352 284.981s1.26 1.044 2.754 1.127c1.493.083 3.352-.386 3.352-.386l-1.71.618-1.227.138-1.162-.186-1.044-.388-.813-.605z'/%3e%3cpath fill='%23202220' stroke='none' d='M447.682 282.469s1.26 3.1 3.914 2.763c2.654-.34 2.72-1.884 2.72-1.884l-2.985-4.311-3.65 3.433z'/%3e%3cpath fill='%234b4139' stroke='none' d='m447.682 282.469-.11.05c.002.009.288.713.883 1.422.592.713 1.502 1.439 2.74 1.439.136 0 .275-.012.416-.029 1.348-.17 2.063-.653 2.432-1.11.371-.454.395-.873.395-.89v-.039l-3.09-4.455-3.808 3.583.03.079.11-.05.083.093 3.549-3.337 2.907 4.194.096-.07-.117-.005-.007.052c-.052.262-.328 1.415-2.61 1.715-.132.019-.26.026-.385.026-1.142 0-1.987-.67-2.559-1.35a6.108 6.108 0 0 1-.639-.938c-.069-.127-.12-.235-.156-.306a2.152 2.152 0 0 1-.05-.118l-.11.044.08.092z'/%3e%3cpath fill='%234b4139' stroke='none' d='M448.055 283.077s1.593 1.937 2.988 1.905c1.39-.035 2.272-.56 2.272-.56l.065.221-.731.37-1.262.256-1.292-.17-1.061-.64-.979-1.381zm-5.035 3.107s1.227 1.26 2.353 1.312c1.132.05 2.856-.91 2.856-.91l.215-.067-.297.27-1.163.638-1.41.405-1.112-.203-.845-.52-.515-.654z'/%3e%3cpath d='M454.75 277.329c1.193-.168 3.681 3.232 3.681 4.914 0 1.683-.728 4.209-1.956 4.141-1.23-.069-4.015-2.56-4.646-3.835-.631-1.28-1.26-2.157-.795-2.832.462-.673 3.716-2.388 3.716-2.388zm-12.373.303s-1.99-1.544-2.788-.738c-.796.805-.53 3.499 0 4.039.531.538 2.918-1.282 2.918-1.282z'/%3e%3cpath d='M442.109 279.514s-2.655.271-2.655 1.483c0 1.214 1.26 2.49 1.525 2.759.265.27 2.654-1.078 2.654-1.078z'/%3e%3cpath d='M443.171 281.733s-2.722.809-2.722 1.75c0 .938 1.195 2.693 2.055 2.693.866 0 1.53-1.688 1.86-2.02.333-.338-1.192-2.422-1.192-2.422zm1.332-7.874s-.53-.738-1.66-.27c-1.127.472-2.388 1.617-2.188 3.434.199 1.815.861 3.028.861 3.028l4.116-1.415z'/%3e%3cpath d='M444.83 277.025s-3.514 1.145-3.647 2.489c-.134 1.349.797 2.698 1.725 2.96.93.273 3.915-2.623 3.915-2.623z'/%3e%3cpath d='M447.88 282.621s-3.45 2.283-3.916 2.283c-.463 0-1.725-1.817-1.462-3.027.267-1.212 2.59-2.086 3.52-2.424.93-.338 1.858 3.168 1.858 3.168zm3.026-12.525s-1.095-.911-3.185-.756c-2.091.15-3.632 2.876-3.882 4.24-.25 1.36-.05 3.937.746 4.342.795.401 5.127-3.082 5.127-3.082z'/%3e%3cpath d='M446.676 280.436c-1.442-.153-2.737-2.224-2.49-3.482.248-1.265 3.088-3.437 4.58-3.182 1.492.25 1.192 3.99 1.192 3.99s-1.84 2.825-3.282 2.675z'/%3e%3cpath d='M451.268 280.12s-.73 1.686-2.19 2.428c-1.46.737-2.322.13-3.185-1.079-.861-1.213.399-1.752 1.063-2.359.663-.6 2.586-1.075 2.586-1.075z'/%3e%3cpath d='M448.944 275.681s-1.627 1.31-.696 2.828c.928 1.516 1.659 2.052 2.818 2.252 1.163.205 1.922-.267 2.855-1.381.929-1.11 2.288-1.613 2.157-2.995-.134-1.38-.665-2.457-1.494-2.86-.829-.402-3.35.035-5.64 2.156z'/%3e%3cpath fill='%23202220' stroke='none' d='M453.57 269.185s-1.678-.643-2.974.116c-1.293.757-2.188 2.298-2.236 3.708-.05 1.416.25 3.397.25 3.397s1.777-.506 2.921-1.466c1.145-.957 1.522-1.219 1.362-1.712-.097-.3-.567-.634-.567-1.82 0-2.073 1.244-2.223 1.244-2.223z'/%3e%3cpath fill='%234b4139' stroke='none' d='M453.57 269.185s-1.939-.327-2.908.304c-.971.628-1.793 1.565-2.141 2.826-.35 1.265-.1 1.593-.1 1.593s-.182-1.099.161-2.15c.398-1.205 1.387-2.405 2.353-2.688 1.177-.345 2.634.116 2.634.116z'/%3e%3cpath d='M503.527 305.976s1.402-.59 2.37-1.121c.973-.533 3.064-1.896 3.064-1.896l.67 3.488-2.686 2.07-2.341.023-1.415-1.032z'/%3e%3cpath d='M499.777 306.327s.037.044 1.673.08c1.63.043 1.789-.567 2.078-.427.288.14.748 1.883.748 1.883l-.597 1.091-2.353 1.333-1.985-1.091-.162-2.746zm18.635-1.122s-.468-.78-1.4-1.587l-3.319-2.895-.017 7.555 3.486-.086 1.663-2.336z'/%3e%3cpath d='M499.777 306.327s-.518-.765-1.995-.603c-1.466.16-3.024 1.36-3.18 2.38-.163 1.013 0 3.96.796 4.526.794.565 1.791.85 3.381.444 1.597-.404 9.716-5.414 9.716-5.414s-.955.2-2.07.448c-1.111.24-2.149-.247-2.149-.247s-1.115 1.255-2.387 1.457c-1.278.202-1.632-.607-1.874-1.21-.238-.604-.238-1.782-.238-1.782z'/%3e%3cpath d='M505.198 308.943s-1.196.457-1.647.786c-.446.326-2.053.892-2.053.892l.614 2.463 3.455.884 2.168-1.79.024-2.478zm16.076-1.74s-.547-.507-1.196-1.237c-.64-.73-1.44-.882-1.665-.759-.224.13-1.863 2.246-1.863 2.246l-.125 1.595 1.914 1.035 1.344.25 1.767-1.161z'/%3e%3cpath d='M509.404 305.987s-1.544.704-2.293 1.337c-.747.632-1.913 1.337-1.913 1.615 0 .276 1.743 2.083 1.743 2.083l1.766.143 3.83-2.68-.25-2.449-2.884-.048zm14.557 3.179s-.294-.606-.892-1.162c-.6-.558-1.342-.856-1.795-.807-.444.048-1.94 2.273-1.94 2.273l-.186.628 1.382 1.604 2.45.596 1.689-1.705z'/%3e%3cpath stroke-linecap='round' stroke-linejoin='round' d='m517.644 311.843 1.743.3s-.053.458.45.861c.495.403.546.096.546.096s.248 1.67 2.088 3.083c0 0 2.143.709 3.234.102 1.098-.607.945.186.945.186l3.087-3.82s0-.76-.746-.808c0 0 .545-2.374-1.445-2.88-1.987-.505-3.583.202-3.583.202s-1.527 2.8-2.436 2.423c-.213-.09-.733-.368-1.096-.755-.841-.912-1.096-1.364-1.096-1.364s-.645.203-1.392-.303c-.75-.505-1.392-1.72-1.392-1.72s-1.144-.2-1.542-.603c-.398-.404-.81-1.201-.81-1.201l-2.85 2.048s-.09.903-1.751 2.115c-1.658 1.215-2.651 1.215-2.651 1.215s-.463 2.488-2.324 2.08c-1.857-.4-3.119-2.483-3.119-2.483s-1.329-.203-2.191.937c-.863 1.147-1.265 1.552-1.265 2.695 0 1.145.733 2.758 1.33 3.299.601.536 2.46 2.016 4.645.872 2.193-1.143 1.462-3.026 1.462-3.026s-.066.135 1.262-.741c1.324-.878 2.783-2.223 3.78-2.624'/%3e%3cpath d='m514.241 296.618.015 4.884s.596 4.34-.353 5.704c-.942 1.363-4.38 1.06-4.872-.102-.498-1.16-.25-4.945-.25-4.945z'/%3e%3cpath stroke-linecap='round' stroke-linejoin='round' d='M510.386 311.42s-.731 1.294 1.528 1.48c.64.056 1.07-.173 1.358-.503.583-.674.455-1.234.455-1.234s-.2 1.805 1.833 1.872c2.26.08 2.06-2.087 2.06-2.087'/%3e%3cpath fill='%23202220' stroke='none' d='M491.81 315.428s-1.258-2.125.235-2.896c1.492-.775 2.289.035 3.181.068.896.035.604-2.298.407-2.77-.201-.47-.672-1.471-1.033-1.739-.367-.27-5.302.223-5.264 3.535.036 3.183 2.473 3.802 2.473 3.802zm7.733 7.909s-1.592-2.254-.729-3.6c.867-1.348 1.522-.539 1.96-.575.428-.031.627-1.008-.102-2.488-.733-1.483-1.625-2.225-2.157-2.293-.533-.066-3.505 2.12-2.917 4.915.703 3.379 3.945 4.04 3.945 4.04zm27.842-2.722s5.365 2.253 5.738-3.164c.2-2.895-2.39-4.897-3.217-4.878-.565.01-.995.333-1.956 1.478-.965 1.145-1.696 1.984-1.298 2.426.398.436 1.99-.47 2.688 1.243 1.196 2.931-1.955 2.895-1.955 2.895z'/%3e%3cpath fill='%234b4139' stroke='none' d='M499.543 323.337s-4.18-.921-4.145-5.008c.02-2.726 3.058-3.94 3.058-3.94s-2.81 1.492-2.858 3.888c-.087 4.158 3.945 5.06 3.945 5.06zm-7.676-7.91s-2.412-.531-2.674-4.002c-.264-3.47 5.461-3.334 5.461-3.334s-5.487.263-5.2 3.587c.296 3.432 2.413 3.75 2.413 3.75zm35.518 5.188s1.076.52 2.308.473c1.227-.048 2.704-.373 3.217-2.424.512-2.052.3-3.024-1.052-4.835-.95-1.26-1.82-1.236-1.82-1.236s.925.182 1.656 1.324c.731 1.146 1.793 2.426 1.063 4.73-.733 2.306-2.952 2.354-3.765 2.286a8.432 8.432 0 0 1-1.607-.318z'/%3e%3c/g%3e%3cg fill='%234d2a15'%3e%3cpath fill='%23904720' d='m463.36 206.949-1.01-.209.73-1.688 2.824-1.031 2.818-.114 2.967-.12 1.365.942 1.52 3.517-5.622 3.35-.91.304-.349-1.384-.861-2.27z'/%3e%3cpath fill='%23202020' d='m515.947 288.404-.35-8.436-22.745 7.02 9.007 8.43z'/%3e%3cpath fill='%23d2a567' d='m473.829 273.718-1.914-1.5s-1.374-.969-2.137-1.204c-.761-.238-1.74-.05-1.74-.05l-.314.448.298.781 2.075 2.419s3.383 1.752 3.466 1.786c.083.033 1.225 1.179 1.225 1.179l.798.337zm-.538 3.576 1.297.17 1.297 1.487.804 1.587 1.06 2.1.336 1.22-2.538-.557-7.367-2.283.636-1.752 1.29-1.181 1.066-.469 1.502-.227z'/%3e%3cpath fill='%23d2a567' d='m478.08 283.357 1.217-.101.823-.701-.387-2.758.449-8.834-5.985-7.076-1.221 4.078 1.758 7.152 1.296 4.288z'/%3e%3cpath fill='%23ab6d29' d='M473.794 267.2s-.397.737.1 3.059c.498 2.32 1.36 7.508 3.417 11.043 2.057 3.53-1.989-2.794-1.989-2.794s-3.185-7.17-2.689-12.59c.499-5.42 1.16 1.282 1.16 1.282z'/%3e%3cpath fill='%23ab6d29' d='M478.14 271.674s-1.294 1.686-1.493 2.93c-.2 1.241.1 3.365.1 3.365s-.2-1.613 1.128-1.988c1.326-.367 1.16 3.64 1.226 4.005.065.373.764-7.167.764-7.167zm.666 14.803-6.739-1.547c-3.48-1.55-5.324-2.764-5.257-3.602.067-.84 6.188.202 7.083.405.894.202 3.635 1.58 3.635 1.58h1.573l2.857-1.263.396 3.047-3.55 1.38zm-11.251-1.274s1.66 1.177.863 1.682c-.796.505-2.921.572-3.584.405a1718.039 1718.039 0 0 1 6.502 1.579s1.392-1.179 1.294-1.246c-.099-.07-5.075-2.42-5.075-2.42z'/%3e%3cpath fill='%23d2a567' d='M465.778 283.427c.25-.404.451.944 2.771 1.247 2.324.3 3.385-.405 3.385-.405l1.029.674 1.226.27-1.127 1.681-4.247-1.249-2.289-1.274z'/%3e%3cpath fill='%23ab6d29' d='m480.909 280.378 1.197 1.713.74-3.73-.05-3.89-2.436-1.612z'/%3e%3cpath d='m474.19 274.081-1.99-3.335-2.588-4.742 1.592-2.728 1.943 2.824s-.55 1.92-.2 3.737c.348 1.82 1.244 4.244 1.244 4.244z'/%3e%3cpath fill='%23d2a567' d='M460.556 286.196s.862-1.434 2.888-1.596c2.023-.173 3.648.27 3.648.27l4.113 2.147.831 1.351-7.763-1.041-3.716-1.13z'/%3e%3cpath fill='%238f4620' d='M480.757 272.469s.148 4.641.295 6.106c.15 1.463 1.05 2.876.9 3.483-.15.607-.45.91-1.447 1.262-.994.353-2.984 0-2.984 0s1.94-.254 2.039-.655c.1-.404-.596-2.17-.698-3.787-.098-1.616.102-3.383-.446-3.383s-1.144.707-1.245.91c-.099.202.545-5.757 1.194-6.414.65-.653 2.392 2.478 2.392 2.478z'/%3e%3cpath fill='%23ab6d29' d='M466.562 284.666s-.794-.742-.779-1.247c.016-.506.93 2.438 5.192 2.273 4.263-.168 4.014-.24 4.014-.24h1.991s-.446 1.857-.797 2.023c-.347.166-3.317 2.17-3.367 2.224l-1.064.584.086-.3-.2.015-.348-3.281-3.681-1.414z'/%3e%3cpath fill='%238f4620' d='M474.19 274.081s-4.927-5.101-6.568-8.482c-1.643-3.386-.647-8.03-.647-8.03l4.63 6.06s-.598 1.16-.4 3.078c.2 1.92 2.985 7.373 2.985 7.373z'/%3e%3cpath fill='%23ab6d29' d='M471.036 292.657c-.164-.353-.35-1.474.598-2.658 2.927-3.653 10.334-6.276 10.334-6.276l.008 4.466-9.505 4.57z'/%3e%3cpath fill='%238f4620' d='M471.597 289.28c.413-.296 2.07-1.525 2.129-2.054.067-.603-1.127-.705-3.282-1.143a15.417 15.417 0 0 1-3.916-1.412s2.654 2.052 3.684 2.457c1.026.406.93.808.796 1.078-.132.27.53 1.116.589 1.075zm12.723 1.04s-1.37-2.045-1.81-3.298c-.434-1.251-.456-3.27-.539-3.291-.078-.024-.914.666-1.528.951-.618.278-2.809.987-2.928 1.072-.12.078 3.024-.068 3.007 1.023-.02 1.095-4.521 1.56-4.54 1.638-.02.078 3.624-.805 3.404.078-.22.892-1.83.974-3.782 1.779-1.95.81-2.806 1.218-3.528 1.637-.722.415-1.07.734-1.07.734s.87.491 2.255.441c1.378-.052 4.438-.808 4.438-.808l5.876-2.235.745.28z'/%3e%3cpath fill='%23ab6d29' d='M484.32 290.32s-1.64-.572-2.804-7.415c-1.17-6.837-.828-8.68-.828-8.68l2.769 1.932 2.479 4.51z'/%3e%3cpath fill='%238f4620' d='M485.208 278.94s-1.293 3.836-1.293 6.061c0 2.218-.228 3.73.407 5.31.636 1.572 2.813 3.532 2.813 3.532l.992-1.038.447-3.102.25-5.152-3.615-5.61z'/%3e%3cpath fill='%23202020' d='M489.099 284.151s.627 9.658-1.817 9.923c-1.17.128-2.938-3.637-2.96-3.759-.026-.127 2.13 3.503 2.934 3.175 1.544-.63 1.07-10.044 1.07-10.044l.773.706zm-4.78 6.169s-.413-.18-1.085-1.275c-.672-1.096-.087.969-5.234 2.788-5.153 1.818-6.993.81-6.993.81s1.717 1.336 6.916-.18c5.201-1.513 4.728-1.844 5.422-1.993.701-.15.975-.15.975-.15z'/%3e%3cpath fill='%23ab6d29' d='M474.74 278.018s.811.694 1.74 2.575c.93 1.883 1.593 3.2 1.593 3.2l.232-.239s-.63-1.814-1.492-3.23c-.862-1.415-3.353-4.847-3.353-4.847z'/%3e%3cpath fill='%238f4620' d='M471.609 290.005s.53-1.807 0-2.143c-.533-.335-1.032.03-4.545-.404a52.222 52.222 0 0 1-6.505-1.264s2.388 1.465 4.677 2.071c2.29.604 5.275 1.278 5.275 1.278l.797.135z'/%3e%3cpath fill='%23202020' d='M471.609 290.005s.073-.426-.325-.86c-.397-.43-1.12.205-5.377-.984-4.253-1.182-5.348-1.966-5.348-1.966s1.517 1.338 5.275 2.297c3.758.96 5.775 1.513 5.775 1.513z'/%3e%3cpath fill='%23ab6d29' d='M473.524 277.282s-3.22.175-4.256 1.005c-1.03.834-2.453 3.043-2.453 3.043l2.093.243s-.26-1.944.736-2.917c.994-.97 2.501-1.06 3.88-1.374z'/%3e%3cpath fill='%238f4620' d='M467.426 271.16s1.295 1.714 2.638 2.321c1.344.606 2.687 1.112 3.336 1.766.644.656 1.343 2.776 1.343 2.776s-4.63-2.067-5.524-3.08c-.897-1.01-1.792-3.783-1.792-3.783z'/%3e%3cpath fill='%238f4620' d='M471.912 272.223s-.42-.692-1.69-1.273-2.203-.49-2.564-.228c-.36.266-.236.432-.236.432l1.692 2.55.945-.228s-2.515-1.585-1.927-2.083c1.23-1.05 3.78.83 3.78.83z'/%3e%3cpath fill='%23202020' d='m484.39 266.393 25.907-13.38 12.261 17.067-22.39 6.002-11.85 1.011-5.774-4.186z'/%3e%3cpath d='m519.124 273.706 32.296 27.97-3.577 2.46-7.568-2.155-15.727-15.544-5.822-5.863z'/%3e%3cpath d='M560.483 296.138s-8.022-6.325-18.445-14.064c-10.421-7.744-23.307-17.504-23.307-17.504l.595 8.347 26.66 24.502 8.793 4.24 4.446-1.345 2.257-2.356-1-1.82z'/%3e%3cpath fill='%23803f1d' d='M519.031 276.36s9.303 10.498 16.375 15.852c7.064 5.347 13.835 11.205 15.225 10.394 1.394-.809.896-1.712.896-1.712l-32.694-26.659.197 2.123z'/%3e%3cpath d='m541.871 303.195-3.284 2.555-3.778-1.542-19.86-20.3.998-3.736 2.78.404z'/%3e%3cpath fill='%23202020' d='M560.483 296.138s-2.434 5.741-7.611 4.399c-5.176-1.35-33.678-28.428-33.678-28.428l-.066 2.826s28.883 26.458 34.46 27.534c5.573 1.079 10.14-3.76 9.553-4.306-.39-.367-2.658-2.024-2.658-2.024z'/%3e%3cpath fill='%23803f1d' d='M515.841 280.6s9.209 11.813 14.087 16.154c4.88 4.344 9.06 7.773 11.05 7.374 1.988-.405-1.195-2.624-1.195-2.624l-13.936-13.736-7.115-7.168c-.001 0-2.787-1.11-2.89 0z'/%3e%3cpath fill='%23202020' d='M518.132 280.6s23.379 23.83 25.23 24.37c3.918 1.144 9.492-2.897 9.492-2.897l-2.059-1.21-.265.738s-.998 2.425-6.039 1.347c-5.044-1.073-25.562-23.155-25.562-23.155l-.798.806z'/%3e%3cpath d='m526.94 303.406-8.508-9.795-1.889-3.232-.505-4.142 16.974 17.068-2.387 1.613-2.095-.702z'/%3e%3cpath fill='%23202020' d='M542.316 303.744s-2.059 3.031-4.85 2.424c-2.784-.603-4.376-2.624-4.376-2.624l-16.274-15.935-.398-2.43s17.854 18.892 21.048 19.726c2.325.607 4.056-2.225 4.056-2.225l.794 1.08z'/%3e%3cpath fill='%23202020' d='M533.284 303.207s-.797 2.357-3.181 2.023c-2.394-.337-3.123-1.282-3.123-1.282l-9.968-11.846-.198-3.16s10.365 14.333 12.758 15.143c2.388.807 2.984-1.619 2.984-1.619l.73.741z'/%3e%3cpath fill='%23b07229' d='M522.63 272.141s9.655 8.28 10.453 8.685c.795.406 4.177.506 4.375 1.007.2.509-2.183 0-2.385.509-.196.502 4.877 4.646 5.672 4.744.796.103 4.879.103 4.78.605-.1.509-2.787 0-2.886.607-.1.605 4.382 4.142 5.174 4.242.8.102 5.971.102 5.971.603 0 .51-4.183-.098-4.078.81.097.908 7.068 5.249 6.767 5.858-.3.603-8.362-5.454-8.559-5.152-.201.302-.499 2.223-1 2.525-.493.303 0-2.525-.399-3.736-.397-1.212-5.073-4.746-5.57-4.34-.495.402-.098 2.523-.597 2.523-.498 0 .102-2.626-.4-3.535-.497-.908-4.876-4.546-5.471-4.546-.599 0-.2 1.923-.599 2.224-.4.302-.297-2.224-.896-3.03-.594-.805-10.75-9.994-10.352-10.603z'/%3e%3cpath d='M506.075 298.942s.076 3.658-1.569 4.192c-1.64.532-4.75-6.72-4.75-6.72l-.722-6.759 4.828 4.491 2.213 4.797zm12.944-1.857s.068-1.072-.057-1.951a39.666 39.666 0 0 0-.404-2.22l-.315-3.767-.895-2.523-.723-1.59-1.047.075-2.538 1.8-.87 2.443 1.341 4.572 1.245 4.165 1.889.606 2.375-1.61z'/%3e%3cpath d='M515.69 303.476c.57-.172-.53-5.182-.53-5.182l-2.984-7.407-.797-2.624-2.421-.913-1.593 1.822.364 2.929s2.321 4.877 3.453 6.599c1.127 1.712 3.517 5.08 4.507 4.776z'/%3e%3cpath fill='%23202020' d='M513.014 287.761c.867.603 1.86 2.592 2.09 3.936 0 0 1.992 5.45 1.727 5.991-.266.541-1.462.607-1.462.607s2.659 2.76 3.455 2.424c.794-.337.461-3.03.195-3.637-.264-.607-1.129-.2-1.457-.807-.333-.608-1.332-4.24-1.396-6.398-.065-2.149-.132-3.632.134-4.173.266-.537 2.257 4.51 2.257 7.208l.862 1.01s-.533-3.706-.862-4.85c-.332-1.142-1.061-3.097-1.061-3.5 0-.404.4-1.347.4-2.289 0-.941-.067-1.546-.067-1.546s1.057.736 1.458.674c.397-.07.994-.607 1.257-2.966.269-2.353-.263-9.204-.263-9.204l-10.35 13.65 3.083 3.871z'/%3e%3cpath fill='%23202020' d='M513.014 286.582s-.4 3.67.963 7.437c1.362 3.773 1.722 3.909 1.99 4.447.264.535.238 4.509-.268 5.012 0 0-2.648-6.764-3.543-10.097-.898-3.332-1.128-4.613-1.594-4.884-.465-.269-1.232-.336-1.232-.336z'/%3e%3cpath d='M512.033 306.116c.297-.062.114-1.558.114-1.558l-.43-3.533-3.634-7.46-3.983-3.584-2.091-3.231-.297 6.16s2.887 6.157 4.777 7.925c1.89 1.765 5.017 5.414 5.544 5.28z'/%3e%3cpath fill='%23202020' d='M497.16 289.304s.625 1.652.625 2.733v2.086s1.456 2.962 2.786 5.321c1.329 2.35 2.587 4.778 3.713 4.24 1.13-.54 1.531-2.29 1.596-2.494.065-.198-1.261 2.02-1.928 1.683-.661-.335-3.644-9.958-3.578-10.164.065-.202-.798-.604-1.463-1.278s-1.751-2.127-1.751-2.127zm10.842 8.389s-2.063-3.361-2.725-4.845c-.662-1.482-1.791-2.63-2.123-2.63-.332 0-.763-3.012-.763-3.012s1.095 2.004 2.487 2.675c1.396.673 2.253 1.214 2.924.944 0 0 .397 1.55.397 3.1 0 1.548-.197 3.768-.197 3.768z'/%3e%3cpath fill='%235c3a1d' d='M501.366 292.738s.695 2.118 2.055 4.138c1.36 2.021 3.593 4.447 3.593 4.447s-2.466-2.426-3.755-4.311c-1.296-1.886-2.158-4.347-2.158-4.347z'/%3e%3cpath fill='%23202020' d='M508.458 290.227s.657-1.832 1.227-1.92c.568-.085 1.765-.445 1.765-.445s-1.025-.255-1.847-1.214c-.862-1.019-1.062-.944-2-2.034 0 0 .532 2.034.693 2.993.162.96.162 2.62.162 2.62zm-.655.596s2.952 6.326 3.712 8.447c.76 2.123.631 5.29.631 5.29s-.365-2.256-1.027-4.11c-.666-1.851-3.354-7-3.581-7.605-.238-.608.265-2.023.265-2.023z'/%3e%3cpath d='m511.823 286.71.698-9.294-.698-3.282-4.184-9.287s-.2 1.364-1.244 1.31c-1.044-.052-3.831-1.512-4.782-2.778 0 0 .551 2.173.354 4.242-.2 2.073-.547 3.18-.547 3.18l8.061 15.148z'/%3e%3cpath fill='%238b441f' d='M495.793 292.809s1.259 1.518 1.99 1.315c.727-.2.46-3.099-.465-4.711-.931-1.615-10.753-14.743-12.211-15.552-1.458-.804 10.687 18.949 10.687 18.949z'/%3e%3cpath fill='%238b441f' stroke='%235c3a1d' stroke-width='.07' d='M502.5 287.388c.196.607.903 4.793-.795 5.183-2.343.541-13.135-14.366-14.804-16.412 0 0-6.773-4.236-6.905-5.315-.135-1.078 7.304 1.464 7.304 1.464l14.466 13.833s.53.64.733 1.247z'/%3e%3cpath fill='%23202020' d='M495.793 292.809s-1.195-2.12-1.3-3.632c-.096-1.514-.593-2.323-.692-2.83-.1-.502-7.962-11.91-8.76-12.622-.793-.704-3.481-2.219-3.481-2.219s.31 1.817.31 2.626c0 .806.088 1.035.088 1.035s2.489 4.724 6.071 8.862a702.928 702.928 0 0 0 7.764 8.78z'/%3e%3cpath d='M507.803 290.823c1.06-.607.595-4.24.2-5.386-.403-1.145-6.836-14.535-6.836-14.535l-1.93.737-3.645-2.86-2.053-2.222s.723 3.2.659 4.749c-.068 1.547-.133 2.488-.133 2.488l5.107 8.952 8.632 8.078zm7.232-8.074 1.53-2.018-.797-6.665-4.246-14.537s-1.063.268-2.126-.404c-1.06-.676-2.155-1.955-2.155-1.955l1.032 8.683 4.381 12.185.263 3.638 2.118 1.074z'/%3e%3cpath fill='%23202020' d='M501.764 286.15s-4.277-4.647-5.675-6.969a120.33 120.33 0 0 1-2.586-4.544s-1.192.506-2.688-.098c-1.494-.61-3.48-2.728-3.48-2.728s-1.195 2.321 4.975 8.582c7.064 7.167 9.454 5.756 9.454 5.756z'/%3e%3cpath fill='%238b441f' d='M512.068 287.715c1.8-.723 1.743-8.281.053-13.38-1.697-5.102-4.482-9.49-4.482-9.49s3.486 8.177 4.23 11.512c.746 3.333 0 5.701-.598 5.5-.597-.202-.597-1.965-1.99-5.201-1.39-3.228-2.336-4.036-2.336-4.036s4.924 13.477 3.529 13.226c-1.39-.253-8.26-15.197-8.557-15.602-.304-.405-.498.554-.498.554s6.12 18.73 10.65 16.917z'/%3e%3cpath d='m516.064 251.31 3.023 6.42.954 6.788.238 5.724s.197 11.294-1.192 11.563c-1.394.27-2.059-1.079-2.123-1.349-.068-.27-2.59-12.723-2.59-12.723l-2.651-12.991.941-.91.316-1.916 2.055-.138z'/%3e%3cpath fill='%238b441f' d='M507.803 290.823c1.202-.165 0-3.229 0-3.229s-.997 1.48-1.794.472c-.798-1.009-2.061-4.748-2.061-4.748l-.796-2.253s-.86 2.488-1.985 2.488c-1.132 0-6.97-9.895-6.97-9.895l-.698.977s8.227 17.031 14.304 16.188z'/%3e%3cpath fill='%23202020' d='M503.948 283.322s.997-2.423.598-4.642c-.398-2.225-3.38-7.773-3.38-7.773s-.898.203-2.09-.204c-1.195-.404-3.484-1.92-3.484-1.92s1.592 4.141 3.38 7.172c1.796 3.026 4.977 7.367 4.977 7.367zm4.778-3.435s-.746-5.255-3.131-10.101c-2.392-4.847-3.988-6.413-3.988-6.413s.202 1.063.152 3.031c-.047 1.967 0 2.371 0 2.371s2.19.81 3.836 3.738c1.64 2.929 3.131 7.375 3.131 7.375zm6.508-8.985s-.332-5.656-1.227-8.891c-.896-3.227-1.84-7.519-1.84-7.519s.112-.434.494-.659c.223-.138.549-.204 1-.05 1.192.404 1.69 3.383 1.69 3.383s-.147-4.593-.25-4.793c-.095-.204-.4-.76-.4-.76s-.394.202-.944.154a25.246 25.246 0 0 1-1.193-.155s.374 1.412-.224 2.072c-.435.479-.85-.43-1.092-.554-.092-.05-.226.653-.226.653s.446 1.615.547 3.031a10.353 10.353 0 0 1-.148 2.576s.877 3.379 1.822 5.454c.951 2.066 1.99 6.058 1.99 6.058zm5.047-.653s.995-8.128-.843-13.327c-1.846-5.204-3.388-6.565-3.388-6.565l-.843 1.012s2.77 4.414 3.58 8.529c.852 4.29 1.494 10.35 1.494 10.35zm-8.167 4.088s-.901-6.359-2.046-10.447c-1.143-4.094-1.466-5.556-1.466-5.556l-1.74-1.615s1.022 4.34.92 5.606c-.1 1.258-.2 2.12-.2 2.12s.847 2.17 1.993 3.983c1.143 1.82 2.54 5.91 2.54 5.91z'/%3e%3cpath fill='%23904720' d='M516.367 284.432c1.624.048.2-9.15-.464-11.507-.665-2.355-4.452-13.417-4.452-13.417s4.554 15.73 4.183 16.516c-.538 1.167-2.317-4.779-2.649-4.712-.33.063 3.382 10.635 2.05 10.77-1.322.136-1.983-2.225-1.983-2.225l.129 2.293s.864 2.222 3.186 2.283z'/%3e%3cpath fill='%23904720' d='M518.353 279.782c1.108 0-.31-8.68-1.103-12.52-.794-3.84-3.012-11.511-3.012-11.511s2.252 5.319 3.517 11.444c1.258 6.122 2.116 14.001.927 14.136-1.192.135-1.793-1.145-1.793-1.145l-.197-1.416s.53 1.013 1.662 1.013z'/%3e%3cpath fill='%23312317' d='M503.41 289.982c.171.618.138 3.597-1.441 3.383-1.581-.214-4.47-2.88-5.063-4.633 0 0 3.432 3.797 4.613 3.773 1.182-.026 1.178-3.92.98-4.929-.2-1.007.912 2.406.912 2.406z'/%3e%3cpath fill='%23d2a567' d='M511.67 248.635s2.043 1.308 3.684.35c1.643-.959 2.739-3.281 2.689-4.544-.053-1.26-.1-2.373-1.098-3.685-.993-1.312 1.592 1.11 1.545 3.535-.05 2.425.148 6.611-3.735 7.522-3.883.91-2.19-.202-2.19-.202z'/%3e%3cpath fill='%238f4620' d='M508.598 241.215s2.45 4.016 3.393 7.625c.946 3.61.771 4.997.174 5.071-.598.08-.82-.425-.971-1.334-.147-.913-2.596-11.36-2.596-11.36z'/%3e%3cpath fill='%231e2121' d='m465.627 246.146 16.22 23.53 20.31-22.923-12.842-13.229z'/%3e%3cpath d='m486.131 231.706-.941 3.686 1.988 6.261 3.385 3.485 3.927 2.617.898-2.928.948-3.427.991-.354 2.487.961 1.645-2.372 2.638-4.749-.549-1.84-.63-1.31-4.108-7.157-1.384 2.707-1.29.784-2.393-1.36-2.887 3.781-3.528-1.637z'/%3e%3cpath fill='%235c3818' d='M494.496 247.77s.703-.501 1-2.37c.301-1.868.35-7.573-.149-9.847-.496-2.269-1.992-6.763-2.29-6.41-.296.354 2.341 4.948 1.943 10.552-.398 5.603-.2 7.17-1.396 7.724-1.197.554.892.35.892.35z'/%3e%3cpath fill='%235c3818' d='M495.443 238.33s2.686 3.836 3.983 2.472c1.292-1.362.646-6.261-.196-8.178-.851-1.92-1.744-4.697-1.744-4.697l.798-.807s.892 3.23 1.39 5.252c.497 2.018 1.99 7.974.197 9.038-1.789 1.058-4.38-2.173-4.38-2.173l-.048-.908z'/%3e%3cpath fill='%238f4620' d='M486.762 240.97s.895-1.312 2.123-1.446c1.228-.135 1.464.403 1.464.403l1.092 3.163 1.825 3.267 1.624 1.612-.962.91-1.29.237s-3.856-2.02-3.917-2.154c-.066-.135-1.064-1.415-1.064-1.415l-.895-4.576z'/%3e%3cpath fill='%23d2a567' d='M493.141 274.384c-1.265.657-4.176-.795-5.818-2.243-1.642-1.444-10.3-10.281-10.3-10.281l-1.212-4.9 3.35.912 5.874-2.524 1.096-2.07 7.064-3.686 3.937-2.119 8.556-.152 2.041-4.192s2.871 4.964 3.35 7.002c.481 2.037.38 8.299-.365 8.7-.744.404-3.532-1.871-3.93-2.02-.4-.15 2.09 8.787 0 9.137-2.093.353-5.575-3.33-5.575-3.33s1.393 7.974-.247 8.027c-1.645.051-5.89-2-7.698-3.956 0 0 2.02 6.582-.123 7.695z'/%3e%3cpath fill='%238f4620' d='M491.459 264.033s1.379 2.023 1.807 2.658c.431.638-.074 4.42-.334 5.118-.532 1.448-2.488-1.715-3.551-4.51 0 0-3.114-5.184-3.315-5.856-.198-.675 5.393 2.59 5.393 2.59zm16.672-19.756s3.019 12.454 1.56 12.888c-1.461.438-5.61-3.939-6.072-4.577-.468-.638-6.239-9.826-6.239-9.826l-1.227-1.247.364-.64 2.454.94 9.16 2.46z'/%3e%3cpath fill='%238f4620' d='M486.762 268.204c-.672.433-1.957-1.615-2.553-2.153-.6-.536-2.622-3.032-4.613-5.05-1.988-2.016-3.449-3.5-3.449-3.905 0-.405-1.196-1.682-1.196-1.682l1.063-1.341 1.394-.206s8.229 6.562 8.792 7.602c.561 1.05.93 6.498.561 6.735zm12.384.105c-.388.306-5.839-3.638-8.13-6.902-2.291-3.265-4.678-6.126-5.244-7.642a112.547 112.547 0 0 1-1.029-2.892l1.66.367s13.37 16.561 12.744 17.069zm1.952-5.76c-.304.372-2.687-1.411-4.15-3.332-1.46-1.917-.692-4.306-.692-4.306s5.137 7.272 4.842 7.639zm3.049-.735c-.741.351-3.866-3.418-6.467-7.673-1.926-3.147-2.404-3.618-2.82-3.869-.713-.434-2.06-.639-2.06-.639l-.268-.404 1.396-.34 1.032-1.207 1.622-2.09 6.473 13.061s1.589 2.928 1.092 3.16z'/%3e%3cpath fill='%23ab6d29' d='M487.334 272.141c.052.475-.026.954-1.79.777-1.765-.177-10.998-5.1-15.156-11.89a3345.15 3345.15 0 0 1-4.702-7.7l1.843-2.095 14.657 16.71 5.149 4.198z'/%3e%3cpath fill='%238f4620' d='M487.334 272.141c.198.777-.728.979-1.657.741-.932-.234-4.614-1.548-10.486-8.078-5.87-6.53-8.16-11.206-8.16-11.31 0-.097-.298-2.793-.298-2.793l1.724-.74 10.088 15.38 8.79 6.8z'/%3e%3cpath d='M497.137 265.54s-3.04-2.173-4.981-4.495c-1.937-2.323-5.873-7.721-5.773-8.786.1-1.058 1.742-1.058 1.742-1.058l-.098-2.722.498-.916 2.838 1.162 3.58 4.397 1.314 1.783s2.321 5.586 1.87 6.091c-.445.506-3.731-3.13-4.13-2.675-.4.456 3.738 6.815 3.14 7.22zm-5.678-1.507s.995 1.515.543 2.575c-.441 1.058-.842 1.616-2.337-.604-1.494-2.225-3.298-4.712-3.465-4.533-.165.186.18 3.42-.564 3.42-.75 0-3.087-2.776-4.58-5-1.493-2.22-3.781-5.906-3.781-5.906s.2-.759.1-3.281c-.1-2.527-.3-3.836-.3-3.836s.217.79.481 1.38c.265.588.663 1.009.663 1.009l5.475 6.449 1.538-1.072 3.242 6.321 2.984 3.078zm-20.75-9.394s4.231 7.423 8.162 11.567c3.932 4.136 8.462 5.937 8.462 5.937l-12.788-15.127-3.836-2.376zm32.444 4.394c-.22.152-2.837-2.678-4.477-5.202-1.644-2.523-2.935-6.06-2.837-7.625.103-1.566.547-5.35.547-5.35s4.382 4.545 5.221 6.664c.851 2.123 2.652 5.011 2.256 5.368-.397.352-3.344-1.987-3.695-1.428-.35.555 3.435 7.268 2.985 7.573zm4.978-4.744c-.535.27-2.734-2.323-3.335-3.939-.598-1.618-.797-4.797-.797-4.797l-1.941-4.594.2-5.097 1.94-.306 2.934 4.042s1.147 2.371 1.097 5.805c-.052 3.433.496 8.582-.098 8.886zm-34.49 12.478c-3.932-4.847-6.32-9.394-6.32-9.394l-1.294-4.34.698.556s1.143 4.998 7.213 10.952c6.073 5.963 7.418 6.464 7.418 6.464s1.192 3.286.597 4.446c0 0-4.379-3.84-8.311-8.684z'/%3e%3cpath fill='%23202020' d='M480.196 273.718s-5.177-4.572-9.292-9.756c-4.113-5.183-6.702-10.165-6.702-10.165l1.793-1.685s3.417 7.977 5.872 11.143c2.456 3.164 8.329 10.464 8.329 10.464zm7.138-1.577s-6.005-5.955-9.057-9.321c-3.05-3.363-4.742-6.766-4.742-6.766l2.52.976s.996 2.624 3.185 5.354c2.193 2.726 8.094 9.757 8.094 9.757zm-1.133-10.678s-3.284-4.004-4.843-6.526c-1.562-2.524-3.155-5.756-3.155-5.756s4.414 5.049 5.708 5.383c1.293.34 1.26-.03 1.26-.03s-.53 1.815-.1 3.33c.432 1.517 1.13 3.6 1.13 3.6zm1.332-16.24s.532 2.822.167 4.475c-.363 1.647-1.242 1.636-1.242 1.636s1.706 2.403 2.704 3.41c.991 1.012 3.484 2.761 3.484 2.761s-1.994-2.76-2.792-4.172c-.796-1.414-1.956-2.996-1.455-4.377.495-1.383 3.185.945 3.945 1.583.767.637 3.919 4.376 3.919 4.376s-1.166-3.875-2.723-5.285c-1.56-1.412-6.007-4.407-6.007-4.407z'/%3e%3cpath fill='%23202020' d='M500.77 253.693s-1.692-4.068-2.659-6.56c-.961-2.493-2.468-7.892-2.468-7.892s.114 2.473-.02 4.292c-.132 1.817-.777 4.593-1.571 4.995-.798.404-.976.482-2.442.079-1.467-.405 1.02.682 1.02.682s1.494-.048 2.143-.781c.642-.737.79-2.302 1.494-2.074.694.23 1.439 2.602 2.016 3.637.567 1.033 2.487 3.623 2.487 3.623z'/%3e%3cpath fill='%23202020' d='M495.618 239.194s3.156 3.535 4.523 1.944c1.371-1.589.573-6.083.573-6.083s1.917.734 2.514.254c.598-.48.321-2.246.321-2.246s3.405 4.972 5.046 8.151c1.645 3.18 2.487 8.923 2.487 8.923s-2.817-4.58-4.246-8.923c-1.302-3.95-3.209-5.753-3.56-5.375-.346.377-.87 3.154-.447 4.594.427 1.437 1.592 3.308 2.39 5.352.797 2.043 1.689 5.251 1.689 5.251s-1.617-2.45-2.559-3.787c-.946-1.337-1.943-1.869-2.59-2.497-.645-.634-1.618-1.795-2.56-2.173-.948-.377-2.813-1.314-2.813-.58 0 .73-.373-1.44-.373-1.44z'/%3e%3cpath fill='%23171717' d='M485.045 254.336s1.741 3.487 3.132 5.303a327.882 327.882 0 0 1 3.288 4.393s-2.984-2.726-4.181-4.443c-1.196-1.719-2.24-5.253-2.24-5.253z'/%3e%3cpath fill='%238f4620' d='M505.595 255.247c-.448.178-1.895-.35-2.045.178-.146.527.824 2.602 1.895 3.688 1.065 1.083 1.518 1.131 1.768 1.007.247-.128-.114-1.086-.288-2.198-.175-1.11-.038-2.296-.162-2.653-.124-.35-1.168-.022-1.168-.022z'/%3e%3cpath fill='%23d2a567' d='m468.407 233.026-1.811 1.188-2.19 4.445.596 8.146s2.025 2.861 3.268 4.662c1.245 1.801 5.36 6.443 6.421 6.176 1.062-.27 2.192-3.498 2.323-5.25.133-1.754.266-4.98.266-4.98s.996 1.749 2.72 3.63c1.725 1.888 3.185 3.637 3.983 3.505.797-.137 3.182-4.915 3.248-5.522.065-.602-5.972-15.415-5.972-15.415l-2.685-1.392-10.167.808z'/%3e%3cpath fill='%23ab6d29' d='M481.96 245.351s1.042 3.785 1.69 5.656c.648 1.865-.018 3.483.333 3.533.347.046 3.5-4.192 3.547-6.108.052-1.917.052-3.887-.793-9.746-.85-5.856.273-7.559.273-7.559l-1.816-1.48-3.136 6.314-.098 9.391zm-10.609-3.33s.697 5.705 1.095 7.573c.4 1.869 1.492 5.047 2.092 4.995.597-.046 2.487-5.047 2.537-6.763 0 0-1.293-2.422-1.244-8.532.05-6.11-.598-6.715-.598-6.715l-3.882 9.443z'/%3e%3cpath fill='%2345392d' d='M463.174 230.234s-4.777 6.933-4.68 10.737c.101 3.802.73 2.96 1.828 6.391 1.093 3.44 1.692 8.521 1.756 8.959.067.434.763-.24.863-.742.1-.505.233-25.346.233-25.346z'/%3e%3cpath fill='%23ab6d29' d='M463.15 231.05s-4.18 6.462-3.88 10.032c.297 3.563.861 3.467 2.055 6.665 1.194 3.198 1.294 8.41 1.294 8.41s1.327-.4 2.82-1.462c1.492-1.063 2.836-3.23 2.836-3.23s-.512-1.162-1.476-3.246c-.961-2.09-1.062-2.898-1.062-2.898l-1.226-1.75.364-6.194 1.094-4.476v-1.685z'/%3e%3cpath fill='%23dbad6c' d='M485.734 242.174s-2.09-.455-2.936-.96c-.843-.504-1.193-1.716-1.193-1.716l.499-1.212z'/%3e%3cpath fill='%23d2a567' d='M464.003 231.752s-3.017 6.5-2.654 10.972c.367 4.48 2.821 10.2 3.053 10.268.233.067.13-.437.199-1.448.067-1.007-.131-13.361-.131-13.361l1.46-4.342.065-2.256-1.992.168z'/%3e%3cpath fill='%238f4620' d='M471.305 233.201s.4 1.953.132 2.762c-.264.807-1.857 1.817-2.52 3.096-.665 1.28-1.592 4.24-1.592 4.24s.728-1.682 1.725-2.758c.994-1.077 1.394-1.817 1.593-1.213.197.607.531 3.166.33 3.639-.197.467-.996 1.24-1.523 3.026-.565 1.902.064 3.637.064 3.637s.348-2.173.666-3.3c.277-.996 1.125-1.484 1.125-1.484l1.66 3.575s0-1.687.268-2.968c.264-1.276 1.655-3.078 2.103-3.078.45 0 1.146-.252-.548-1.112-.546-.352-.197-6.562.25-6.814.448-.25 2.786-.34 2.54-1.199-.25-.857-2.278-3.17-2.477-3.372-.2-.2-3.796 3.323-3.796 3.323z'/%3e%3cpath fill='%23dbad6c' d='M485.395 246.415s-1.448-.253-2.243-.405c-.795-.15-.895-.907-.895-.907l.252-.958 1.838 1.01z'/%3e%3cpath fill='%238f4620' d='M466.153 247.15c-.04.668-.534 1.349-.855 2.281-.388 1.128-.611 2.468-.611 2.468s-.45-2.982-.598-5.078c-.15-2.094-.298-3.458-.547-3.584-.25-.125-.971.983-.971.983s0-2.349.447-3.482c.448-1.135.82-2.752.424-3.005-.4-.253-1.244.456-1.616 1.06-.376.607-1.072 1.919-1.072 1.919s.447-1.993.92-2.801c.473-.809 2.738-3.41 3.161-4.42.422-1.008.423-2.095.423-2.095l1.57-.075s1.635 1.277 1.65 2.387c.01.626-1.567 1.327-1.602 1.4-.102.202-1.319-.102-1.618 5.099-.3 5.202 1.031 4.775.895 6.944zm14.311-13.306s.348 2.826.05 3.685c-.3.858-1.144 1.564-1.741 2.675-.598 1.111-.549 3.79-.549 3.79s.3-1.317.8-2.126c.494-.804.893-1.513 1.094-1.513.197 0 .795 1.012 1.193 2.477.399 1.462 1.196 3.935 1.196 3.935s-.346-1.92.147-1.92c.496 0 .695-.15 1.344.356a22.702 22.702 0 0 1 1.395 1.21s-.05-.705-.997-1.717c-.944-1.01-1.49-.957-1.793-2.321-.295-1.364-.442-2.726-.295-3.283.146-.552.796.356 1.342 1.01.548.657 2.29 2.173 2.29 2.173s-.746-1.162-.947-1.516c-.199-.355-.05-3.029 0-4.545.05-1.513-.05-2.926.495-3.328.551-.407.651-2.378.398-2.73-.245-.352-5.42 3.688-5.42 3.688z'/%3e%3cpath fill='%231e2121' d='M497.113 228.026s.135 3.194.567 5.049c.428 1.85 1.66 5.888 1.66 5.888s-1.66-2.995-2.392-5.587c-.731-2.59-1.395-5.383-2.058-5.586-.661-.202-1.426 1.245-1.426 2.322 0 1.076.698 5.117 1.595 6.53.896 1.415-1.429-1.852-1.994-3.601-.56-1.752-1.128-3.298-1.128-3.298s-.561 1.48-.33 3.13c.233 1.649 1.63 4.005 1.63 4.005s-.902-.775-1.463-1.449a8.652 8.652 0 0 0-1.064-1.075s.099 2.256.697 3.23c.594.976 1.758 2.524 1.758 2.524s-1.392-1.042-1.923-1.649c-.532-.604-.695-1.04-.695-1.04s.296 3.229.995 4.947c.695 1.714 2.221 4.544 2.221 4.544s-1.826-1.45-3.053-4.273c-1.225-2.83-1.826-11.258-1.527-12.54 0 0 .936-1.592 1.8-2.838.864-1.245 1.956-7.194 1.956-7.194s1.356 5.502 2.283 6.547c.932 1.041 1.89 1.414 1.89 1.414zm-13.167-1.66s.703 1.475 1.149 2.133c.447.657.897 1.5.897 1.5s-1.646 1.769-3.485 3.183c-1.845 1.412-4.283 2.977-4.829 2.171-.546-.81-.52-1.502-.52-1.502s2.025-1.212 3.618-2.827c1.59-1.616 2.14-2.464 2.491-3.32.349-.861.68-1.338.68-1.338zm-16.754 5.456s.286 3.435 1.73 3.383c1.445-.05 5.723-4.391 6.021-4.593.299-.202.585-1.264.585-1.618 0-.352-.26-1.162-.26-1.162s-4.606 4.723-6.246 4.875c-1.2.11-1.83-.885-1.83-.885zm.14-4.51s-.548 2.416-.472 3.098a4.917 4.917 0 0 0 .29 1.21s-3.301 1.16-3.848.152c-.549-1.01-.187-2.449-.187-2.449s1.53.007 2.376-.193c.847-.203 1.843-1.817 1.843-1.817zm31.16-4.848s1.346 3.54 2.21 4.957c.866 1.414 2.221 4.34 2.221 4.34s-2.221-2.59-2.918-3.163c-.697-.572-1.828-1.526-1.828-1.526s.326-.953.326-1.691c0-.741-.01-2.916-.01-2.916z'/%3e%3cpath fill='%23dbad6c' d='M462.6 229.345s1.228.153 1.982.11c.759-.04 1.255-.344 1.255-.344l1.254-1.875s-.639 2.22-.198 3.796c.438 1.575 1.352 1.817 1.71 1.817.358 0 2.11-.364 3.465-1.778 1.352-1.412 3.224-2.885 3.224-2.885s-.439 2.038.278 4.056c.718 2.021 1.869 1.98 3.423.729 1.552-1.252 3.149-3.396 4-4.345.467-.52 1.06-1.604 1.06-1.604l1.709-1.362 1.472-8.32-.797-1.092-2.155 1.028-2.58-1.028-.758-1.05-1.472 2.504-1.552 1.01-.786.13-1.803.355-.796-1.616-.479-1.252-.876-.403-3.71 3.743-2.101-.108-2.111 3.311-1.513 2.098-1.555 3.68z'/%3e%3cpath fill='%238f4620' d='M480.616 220.922s.3 2.071-.745 5.553c-1.044 3.485-2.487 5.959-2.487 5.959s3.731-2.273 5.526-6.361c1.785-4.092 1.372-8.788 1.372-8.788l-3.666 3.638zm4.522-3.797s.45.604.052 3.735c-.4 3.13-1.145 6.16-1.145 6.16s.443.757.945 1.767c.495 1.01 1.742 2.778 2.637 2.475.897-.304 2.288-1.364 3.233-3.437.946-2.069 1.793-4.087 2.14-4.392.349-.302.5.202.651.356.148.152.438 1.918 1.33 2.675.896.756 2.066 1.943 2.613 1.59.546-.352 1.081-1.386.983-1.895-.098-.503-1.992-6.159-1.992-6.159l-2.386-6.108-1.53-2.374-4.346.406-3.184 5.2z'/%3e%3cpath fill='%23ab6d29' d='M492.674 211.517s1.226 2.626 1.298 5.454c.066 2.828-.565 5.788-.565 5.788s.264-3.533-.134-5.653c-.398-2.12-1.028-3.502-.96-4.108.064-.605.36-1.482.36-1.482z'/%3e%3cpath d='M498.574 222.569s.246 2.44 0 3.599c-.25 1.164-1.945-.755-2.984-4.593-1.05-3.837-.85-4.695-1.646-6.563-.8-1.87-1.28-3.485-1.28-3.485l2.177-.3 3.733 11.343zm-10.644 7.127s4.15-2.353 4.677-9.443c.252-3.331-1.89-8.734-1.89-8.734s0 5.754-1.542 9.467c-1.543 3.71-2.814 6.186-2.814 6.186s.996-.431 1.496-1.036c.495-.605 1.191-1.642 1.191-1.642s.225 1.063-.147 2.45c-.373 1.388-.971 2.752-.971 2.752zm-3.656-12.42s-.134 1.568-1.876 2.98c-1.742 1.415-4.874 2.98-4.874 2.98s2.288-2.12 3.132-3.989c.849-1.87.2-3.08.2-3.08s-.296 1.008-1.292 1.767c-.995.76-2.438.908-2.438.908s.12-.958 1.015-1.967c.184-.207.15-.681.275-1.072.491-1.515 1.793-3.625 1.793-3.625s.995 2.223 1.99 3.182a78.667 78.667 0 0 0 2.074 1.916z'/%3e%3cpath fill='%231e2121' d='M497.253 208.9s.994 2.56 1.392 6.058c.399 3.503-.065 7.61-.065 7.61s-2.123-3.3-2.654-4.647c-.53-1.347-.53-3.365-.996-4.376-.279-.605-1.042-1.212-1.602-1.602-.369-.256-1.55-.2-1.55-.2s1.225-.587 1.33-1.664c.094-1.077 0-1.65 0-1.65s.793.404 2.09.574c1.291.167 2.055-.103 2.055-.103zm-9.3 14.943s2.267-3.165 2.859-7.07c.599-3.903-.098-5.25-.098-5.25s-.929-.134-1.69-.876c-.765-.74-1.955-2.659-1.955-2.659s.33 2.021-.105 4.477c-.428 2.456-2.686 4.81-2.686 4.81s1.198.416 2.258-.2c2.25-1.315 2.089-3.802 2.089-3.802s.496.302.43 3.397c-.068 3.1-1.101 7.173-1.101 7.173z'/%3e%3cpath fill='%238f4620' d='M461.152 229.24c-.48-.067 1.494-3.132 2.838-5.251l3.234-5.101s.351.355 1.145.304c.796-.052 2.837-.96 3.683-2.526.847-1.564 1.492-3.28 1.545-3.787.05-.503-.15 2.728 1.391 4.494 1.545 1.767 1.494 1.617 2.142 1.465 0 0-.05 2.223-.648 4.292-.597 2.07-1.194 5.05-1.194 5.05s.248-3.887-.4-5c-.645-1.11-.994.102-1.54 1.516-.548 1.412-1.741 2.423-1.741 2.423s.894-1.716 1.492-3.535c.596-1.816.3-1.868.147-1.918-.148-.05-.446-.1-1.092.657-.648.757-1.295.959-1.295.959s.796-.657 1.045-1.566c.25-.908.996-2.221 1.442-2.726.448-.505.747-1.112.747-1.464 0-.355-.1-1.112-.4-1.112-.295 0-.694.457-2.135 1.819-1.445 1.362-1.696 1.462-1.944 1.969-.25.504-.449 1.158-1.345 3.99-.894 2.825-1.492 3.989-1.64 4.241-.15.25-.797.672-.797.672s.498-1.582 1.244-3.652c.746-2.068 1.743-4.797 1.493-5.251-.248-.453-.896-.403-1.094 0-.198.404-1.643 2.17-3.086 4.29-1.444 2.123-1.444 4.748-1.792 4.848 0 0-.961-.032-1.445-.1z'/%3e%3cpath fill='%23874f20' d='M498.68 206.61c-.03.245.132 1.759-1.427 2.288-1.561.532-3.45-.1-3.651-.275-.197-.177-.197-2.173-.197-2.173z'/%3e%3cpath fill='%23b27129' d='M468.49 211.552s-.285 1.442-1.137 3.23c-.855 1.788-2.27 3.277-2.095 3.505.173.226.971 1.061 2.214 1.036 1.245-.026 1.692-7.45 1.692-7.45l-.218-.266z'/%3e%3cpath fill='%23dbad6c' d='M487.603 207.462s-.562 9.84-3.324 9.821c-2.761-.013-4.011-4.974-4.011-4.974s-.228 6.636-3.755 6.636c-1.593 0-3.273-5.123-2.914-6.053 0 0-.654 3.533-2.318 4.841-3.3 2.597-5.403 1.327-5.516.922-.114-.402 2.786-3.17 3.185-7.04 0 0 .51.175 1.307-.98.796-1.153 1.252-2.42 2.047-2.192.797.23 4.778-1.615 4.778-1.615l2.087-2.644s.245.856 1.78-.182c1.535-1.042 2.048-2.597 2.048-2.597l4.094 3.46.512 2.598z'/%3e%3cpath fill='%23b27129' d='M476.831 198.116s2.476 3.75 4.131 5.833c.097.122.91-.784.91-.784.546.75.848 1.4.681 1.793-.646 1.517-1.989 3.585-.896 5.757 0 0-.348-1.212.251-2.777.598-1.566 1.045-2.123 1.394-2.07.348.05.947 8.986 1.544 8.936.595-.052 1.392-4.04 1.392-6.866 0-2.83.565-.507.832.05.265.555 2.7 4.545 4.79 3.938 2.091-.605 1.796-4.292 1.742-5.097-.045-.812-1.49-5.707-1.49-5.707l-9.358-5.89s-.274.738-.772 2.405c-.5 1.667-5.15.48-5.15.48z'/%3e%3cpath fill='%238f4620' d='M490.115 197.24s.546.505 1.447 2.828c.893 2.323.991 9.846-.2 9.794-1.197-.05-3.587-1.412-3.982-2.424-.4-1.009.147-4.744-.647-5.756-.797-1.01-1.742-3.533-1.794-4.24-.051-.706.152-2.978.152-2.978l2.087-.76z'/%3e%3cpath d='m489.449 194.904 3.982 5.923 3.519 5.083s1.772.588 1.726.706c-.05.12-2.043 2.288-4.804.75-1.373-.768-.673-3.158-2.411-6.994-1.745-3.837-4.879-5.503-4.879-5.503l1.097-1.06z'/%3e%3cpath fill='%231e2121' d='M487.253 191.667s3.557 2.35 4.817 4.909c1.262 2.558 1.995 4.107 3.522 6.597 1.522 2.49 3.154 3.265 3.082 3.433-.064.17-1.093.405-1.857-.167-.766-.573-1.557-1.245-2.19-2.39s-2.854-5.318-3.685-6.397c-.829-1.076-3.48-3.095-3.548-2.893-.065.203.83.81 2.357 3.265 1.525 2.457 1.89 4.678 1.791 4.713-.1.035-.433-.91-1.76-3.13-1.326-2.224-4.212-5.085-4.379-4.68-.166.405 1.425 3.03 2.223 4.544.796 1.514 2.125 5.05 1.991 5.05-.132 0-1.062-1.987-2.657-4.445-1.59-2.457-1.89-2.153-2.555-2.96-.661-.81-2.081-2.673-2.081-2.673s1.422.45 2.812-.458c1.397-.91 2.117-2.318 2.117-2.318z'/%3e%3cpath fill='%238f4620' d='M478.198 198.221s2.29.528 3.53.376c1.248-.15 1.67-.1 1.67-.1s.744 1.011.744 2.17c0 1.162-.797 3.334-1.143 3.384-.349.05-.297-1.97-.841-2.676-.551-.707-3.96-3.154-3.96-3.154z'/%3e%3cpath fill='%23b27129' d='M479.413 204.227s.74 2.482.172 5.942c-.57 3.464-2.56 7.04-3.072 7.04-.511 0-.342-3.923-.568-5.998a59.615 59.615 0 0 0-.072-.635c-.033-.288-.784 2.616-.811 2.365-.031-.263.66-3.677.636-3.897-.099-.822-.16-1.304-.16-1.304l2.568-3.052z'/%3e%3cpath fill='%238f4620' d='M475.056 206.808c-.697.86-1.765.626-2.752.935-.926.287-1.26 1.7-1.26 1.7s.748-.556 1.096-.405c.348.152.763.12.066 1.833-.697 1.719-3.416 4.63-3.285 4.665.133.035 3.037-2.459 3.982-3.873.945-1.412.862-2.253 1.061-2.76.198-.504 1.327-1.11 1.575-1.16.25-.051.8.05 1.046 1.06.25 1.01.648 3.888.847 3.988.2.1.895-2.626 1.194-3.988.298-1.364.285-4.367.285-4.367s-.185-.075-.883-.23c-.696-.15-2.366-1.347-2.366-1.347s.328 2.798-.606 3.95z'/%3e%3cpath fill='%23dbad6c' d='M487.334 189.214s.945 2.348-.996 3.99c-.575.483-1.129.806-2.156.858-1.032.048-2.672-.834-2.672-.834l-5.949-2.475-3.134-.983-1.542-.43.221-1.716 4.654.203 4.605 1.764 2.015.657 1.715.302h1.296l1.07-.302s.494-.202.643-.478c.153-.28.23-.556.23-.556z'/%3e%3cpath fill='%23ab6d29' d='M487.334 189.214c.196.404-.35 1.716-.797 1.918-.45.203-1.249.555-3.038.15-1.79-.402-3.632-1.564-5.622-2.119-1.99-.555-3.484-1.061-5.028-1.011-1.543.053-.796-.657-.796-.657s3.534-.4 6.62.76c3.09 1.16 4.416 1.95 5.975 1.916 2.336-.048 2.686-.957 2.686-.957z'/%3e%3cpath d='M471.06 187.344s.695.15 1.294.05c.598-.101 1.047-.455 1.047-.455s.1.81-.3 1.062c-.399.252-1.592.15-1.793.15-.2 0-.248-.807-.248-.807z'/%3e%3cpath fill='%23dbad6c' d='M482.755 194.693s2.082 2.038 1.525 3.803l-4.013-1.845-6.545-2.725-3.545-1.06-.436-.556s.672-.63.994-1.235c.324-.607.225-1.187.225-1.187l4.329.581 4.528 1.39z'/%3e%3cpath fill='%23dbad6c' d='M478.303 197.613s3.733 4.822 2.861 6.412l-8.71-5.502-3.07 5.057-7.165-3.533s5.78-4.453 6.454-5.286c.67-.834.72-1.136.72-1.136l3.236.63 5.098 1.618z'/%3e%3cpath fill='%23ab6d29' d='M476.282 190.487s3.05.741 5.011 1.749c1.957 1.01 4.695 1.238 4.695 1.238s-1.1 1.16-3.237 1.22c-.631.017-2.156-1.211-3.153-1.916-.994-.71-3.865-1.55-3.865-1.55z'/%3e%3cpath d='M470.908 188.851s2.19.455 3.535 1.06c1.344.606 1.444.454 1.792.304.348-.152.397-.304.397-.304s.275 1.315-.771 1.315-1.467-.354-2.81-.961c-1.345-.605-2.241 0-2.241 0z'/%3e%3cpath fill='%23ab6d29' d='M483.012 197.322s1.562.976 1.26 1.177c-.296.202-1.079.572-2.437.657-1.358.085-2.009-.083-2.972-.523-.96-.437-1.557-2.121-3.88-3.028-2.323-.91-2.722-1.044-4.314-1.45-1.592-.402-1.957-.369-1.957-.369l1.462-.607 5.007 1.012 4.28 1.244 2.589 1.247.96.64zm-8.412 2.944.995 3.938-.547 2.375-1.344.857-1.244-.504-.349-.707s.548-.908 0-1.717c-.544-.807-3.084-1.816-3.084-1.816s.996-1.921 2.14-2.374c1.143-.454.594-1.918.594-1.918z'/%3e%3cpath d='M469.716 192.24s.795.672 2.423.841c.691.074 1.983.305 3.313.723.447.14 1.54-.466 1.63-.439l-.945.567c1.445.416 3.26 1.048 3.899 1.34 1.727.78 3.084 2.019 2.984 2.052-.054.017-.984-.54-2.984-1.382-1.452-.61-3.3-1.18-4.646-1.448-2.987-.586-5.973-.4-6.601-.605-.633-.2.264-.235.595-.572.332-.336.332-1.077.332-1.077z'/%3e%3cpath fill='%23ab6d29' d='M480.862 203.046s.948 1.01-.048 1.362c-.996.356-3.71.292-5.001-1.072 0 0-.325-1.3-.823-1.903-.496-.607-2.487-1.87-3.633-2.577-1.143-.707.396-.808.396-.808s4.084 1.566 5.578 2.373c1.493.81 3.53 2.625 3.53 2.625z'/%3e%3cpath d='M480.92 203.14s-2.01-2.778-7.596-4.98c-.153-.06 1.9-.352 1.74-.41-.24-.092-2.693.048-2.947-.04-.42-.144-.857-.288-1.314-.427-2.937-.891-3.15-.806-3.35-1.212-.2-.402-.565.067-.862.572-.3.505-1.128 1.6-1.063 1.5.066-.103 2.158-.59 3.815-.185 1.66.4 1.593 1.008 1.46 1.648-.132.64-2.156 3.098-1.923 3.165.232.066 1.392-2.326 2.918-1.986 1.527.337 2.026 1.177 2.026 1.177s-.035-.875-.33-1.247c-.301-.37-1.993-1.95-1.529-1.95.465 0 2.356.436 5.077 1.816 2.65 1.349 3.082 1.752 3.878 2.56z'/%3e%3cpath fill='%23dbad6c' d='M471.807 198.77s4.282 1.212 4.083 5.756c-.2 4.543-3.518 3.703-3.818 2.053-.296-1.65.399.791 1.594.571 1.304-.236 1.576-1.544 1.493-3.296-.08-1.682-.43-2.525-1.46-3.502a18.521 18.521 0 0 0-1.892-1.582z'/%3e%3cpath fill='%236c3f18' d='M453.29 187.824s.447.344-.771 3.552c-1.222 3.205-1.881 4.347-3.732 6.388-3.46 3.81-4.978 3.835-4.605 5.451.374 1.617 1.717 1.185 2.015 1.237.3.05 6.52-9.113 6.52-9.113l1.369-5.504-.324-1.539z'/%3e%3cpath fill='%23dbad6c' d='M468.723 181.27s1.792 2.688 1.226 7.772c-.563 5.082-7.262 9.526-7.262 9.526l-9.789 6.765-4.09-.244s-.633.09-1.226-.064c-.643-.168-1.247-.834-1.385-.834-.266 0-.764-1.719-.764-1.719l1.294-1.58 3.55-3.538 2.223-3.195s.996-1.852 1.128-3.636c.134-1.784-.33-2.693-.33-2.693l.83 1.28.463 2.692-.366 2.995 2.556-1.715 3.383-1.513s.932-.136 1.594-2.021c.662-1.886 1.22-4.656 1.23-5.89.013-1.24-.137-2.726-.137-2.726s.213-.014.426.113c.21.125 1.105 1.692 1.105 2.586 0 .897.572 4.193.572 4.193l1.57-1.593s1.155-1.452 1.467-2.206c.31-.758.745-1.953.732-2.756z'/%3e%3cpath fill='%23904720' d='M469.81 206.703s.671.555.422 2.399c-.249 1.843-1.766 2.853-2.51 2.878l.071-2.574-2.163-1.718-2.316-.705s.15-.127.423-.405c.275-.277 2.664-1.262 2.664-1.262z'/%3e%3cpath fill='%23ab6d29' d='M468.116 206.726s.67.656 1.742.378c1.07-.275 1.52-1.996.946-2.676-.573-.68-.324 1.642-1.019 1.895-.698.252-1.443-1.743-2.39-1.944-.946-.202-2.44.455-2.811 1.082-.374.634 1.519.13 1.519.13l1.017.276.748.177z'/%3e%3cpath fill='%23904720' d='M453.979 199.67s1.271.383 2.65.197c1.377-.188 4.762-1.6 4.762-1.6s1.558-.876 2.704-1.985c1.142-1.11 4.762-3.368 5.16-7.876.395-4.511-.532-7.135-.532-7.135s5.346 5.843.662 12.555c-3.05 4.374-5.705 5.654-5.705 5.654s5.177-1.515 5.641-.27c.461 1.244-.24 3.182-.375 3.485 0 0 2.936.682 3.359 2.17.254.895-3.334-1.036-6.045-.379-2.712.657-3.905 2.271-3.905 2.271s-.5-.782-2.913-.805c-2.415-.027-3.509 1.11-4.878 1.06-1.367-.052-5.67-.97-6.502-2.147 0 0 1.027-1.282 2.847-3.359 1.245-2.393 3.07-1.835 3.07-1.835z'/%3e%3cpath fill='%23ab6d29' d='M465.101 187.566s2.091-2.053 2.786-3.567c.7-1.515.832-2.727.832-2.727s.233 1.648-.995 3.5a19.807 19.807 0 0 1-2.586 3.132z'/%3e%3cpath fill='%23904720' d='M464.529 182.987s1.71 6.63-.117 9.356c-1.825 2.726-9.765 6.256-9.765 6.256s6.018-3.26 7.909-7.013c1.89-3.755 1.757-6.884 1.757-6.884l.217-1.715z'/%3e%3cpath fill='%231e2121' d='M456.63 199.857s2.54-.052 3.983-.91c1.444-.856 3.485-2.675 3.485-2.675s-1.892 1.666-2.44 1.666-.995-.856-.746-1.514c0 0-.448 1.262-1.593 2.119-1.143.859-2.689 1.314-2.689 1.314zm5.913-8.272s2.139-2.223 2.089-6.867c-.05-4.644-1.793-3.785-1.793-3.785s1.444 1.058 1.145 4.593c-.297 3.534-1.442 6.059-1.442 6.059zm2.594.456s2.41-.581 3.258-1.996c.844-1.412.822-4.113.822-4.113s-.25 2.473-.948 3.38c-.695.911-3.132 2.729-3.132 2.729zm-1.402 14.534s1.195-2.323 2.788-1.716c1.59.603 1.59 1.868 1.59 1.868s-.645-1.01-1.838-1.061c-1.197-.05-2.54.91-2.54.91zm-4.522-4.183s3.532-.861 5.623-1.516c2.089-.655 4.48-1.666 4.48-1.666s-1.742 2.17-4.332 3.635c-2.588 1.464-4.726 1.565-4.726 1.565s4.878-2.12 5.274-2.977c0 0-4.677 1.262-6.319.96z'/%3e%3cpath fill='%23fff' d='M453.558 196.936a4.048 4.124 67.762 0 1-4.646 6.68'/%3e%3cpath fill='%23f16e16' d='M453.348 197.392a3.565 3.632 67.771 0 1-4.176 5.808'/%3e%3cpath fill='%23000' d='M451.77 199.355a1.432 1.432 0 1 1-1.394 2.165'/%3e%3cpath fill='%23d5d3ca' d='M451.969 201.178a.458.458 0 1 1-.901-.158.456.456 0 0 1 .527-.377c.25.042.415.282.374.535z'/%3e%3cpath fill='%23ab6d29' d='M454.457 194.424s2.357-2.32 2.886-5.386c.532-3.063.21-4.804.21-4.804l1.285 1.337.495 2.326-.83 3.867 2.592-1.177c.86-1.176 2.22-6.429 1.755-9.658 0 0 .7 1.414-.231 5.822-.928 4.411-1.686 4.933-5.003 6.75-1.713.936-3.868 2.733-5.81 6.473-.866 1.662-3.204 4.29-3.58 4.674-.06.063 1.662-2.353 2.503-4.155 1.259-2.7 2.634-4.216 2.634-4.216l1.094-1.852z'/%3e%3cpath fill='%23904720' d='M453.36 196.282s1.027-3.098 1.027-4.78c0-1.682-1.094-3.67-1.094-3.67s1.492-.202 1.625 3.465c.132 3.673-.665 3.876-1.558 4.985z'/%3e%3cpath d='M458.092 192.333s1.093-2.726 1.021-4.545c-.077-1.817-1.567-3.56-1.567-3.56s1.84.355 1.99 3.664c.149 3.304-.424 3.331-1.444 4.44z'/%3e%3cpath fill='%23ab6d29' d='M447.226 204.764s-.851-1.094-.753-1.951c.1-.857.033-1.052 2.147-3.275 2.115-2.221 3.285-3.583 3.807-4.77.524-1.188 2.24-4.426.872-6.934 0 0 .945 3.655-1.17 6.557-2.116 2.901-3.333 4.415-5.076 5.704-1.74 1.287-1.915 1.892-1.866 2.626.05.73.224 1.464.523 1.64.53.314 1.516.403 1.516.403z'/%3e%3cpath fill='%236c4119' d='M467.73 211.973s.47.05.771-.505c.298-.555.298-1.489-.448-2.423-.747-.935-1.594-1.49-2.64-1.794-1.045-.302-3.057-.505-3.057-.505s.684 1.182 2.038 1.943c.662.377 1.793-.1 2.514.607.722.709.821 2.677.821 2.677z'/%3e%3cpath fill='%236c4119' d='M467.73 211.973s2.35-.763 2.512-3.028c.1-1.403-.199-1.895-.199-1.895s.347.732 1.294 1.01l.847-.328s-1.394 4.392-4.454 4.24z'/%3e%3c/g%3e%3cg fill='%23f9c83a'%3e%3cpath fill='%23bf802d' d='M451.327 211.54s.459.19 1.33 1.2c.872 1.01 1.283 1.34 1.283 1.34l5.698-1.464 1.843-1.819-1.544-2.446h-4.08z'/%3e%3cpath stroke='%238f4620' stroke-width='.481' d='m465.137 209.6-1.098-1.479s-.233-.571-1.062-1.01c-.829-.436-4.28-.404-4.28-.404l-2.488.505s-.697.64-1.959.37c-1.26-.267-4.047-1.413-4.047-1.413l-2.787-1.212s-2.089-.875-2.553-.707c-.467.167-2.19 2.053-2.19 2.053s-.3 1.011.364 1.042c.662.035-.996.338-.996.338s-4.33 2.375-5.025 6.617c-.7 4.237 7.115 10.499 10 7.318 0 0-4.23-3.13-3.383-5.756.845-2.625 2.787-4.242 6.12-4.44 3.335-.202 3.536-.609 4.978-1.618 1.443-1.01 4.13-1.615 6.121.454 1.99 2.07-7.564 4.042-7.564 4.042l1.043 1.512c.003 0 11.799-4.04 10.806-6.212z'/%3e%3cpath fill='%23fcf3d8' d='M443.09 219.66s-4.777-1.162-4.381-5.553c.4-4.39 4.381-6.007 5.077-6.209.697-.204.549-2.426 1.345-2.676.796-.253 2.324 0 3.022.656.697.657 2.177 1.275 2.177 1.275s-8.459 3.765-8.533 8.62c-.052 3.23 1.292 3.888 1.292 3.888z'/%3e%3cpath fill='%23fdeaaf' d='M465.112 209.134s-.577.352-.735.062c-.894-1.664-2.985-2.108-4.678-2.081-2.156.033-3.618.836-5.08.836-1.458 0-1.06-.233-2.785-.304-1.727-.066-5.408-2.791-6.24-2.522-.828.27-1.16 1.295-1.06 1.8.1.504-1.498.535-1.73.163-.233-.37 1.27-2.751 2.765-2.751 4.013 0 6.994 2.705 8.92 2.705 1.924 0 2.588-1.112 5.174-1.112 2.59 0 5.383 1.15 5.45 3.204z'/%3e%3cpath fill='%23513625' d='M451.969 212.253s1.919-.38 3.359-1.01c1.445-.63 3.367-1.134 3.367-1.134s-1.764 1.168-2.984 1.752c-1.22.577-3.194.897-3.194.897z'/%3e%3cpath d='M445.204 222.183c-.346.138-2.023.067-4.693-1.715-2.671-1.785-3.367-4.812-3.367-4.812s-.614-2.898 2.156-5.841c2.77-2.945 3.224-2.097 3.373-1.961.127.12-.14.262-.14.262l-2.439 1.987-1.21 2.036-1.073 1.833.084 2.167 1.235 2.178 3.821 2.386 2.253 1.481z'/%3e%3cpath fill='%238b5122' d='m443.744 205.559-.154-.365v.397c.124-.007.14-.03.154-.032l-.154-.365v.397-.403l-.275.287c.1.096.215.116.275.116v-.403l-.275.287.275-.287h-.395a.4.4 0 0 0 .12.287l.275-.287h-.395.393l-.36-.166c-.01.029-.03.06-.033.166h.393l-.36-.166.312.142-.278-.202-.033.06.312.142-.279-.202.07.05-.065-.053-.005.004.07.05-.066-.054c-.018.024-.108.122-.214.247-.163.19-.38.45-.564.736-.18.29-.352.587-.361.963l.012.139c.05.384.311.689.597.822.287.146.59.177.878.18.638-.003 1.227-.187 1.248-.191a.406.406 0 0 0 .265-.506.397.397 0 0 0-.496-.27l-.017.007c-.098.03-.575.152-1 .15-.216.003-.414-.034-.52-.092-.11-.063-.14-.092-.169-.226v-.012c-.006-.04.032-.178.12-.33a4.617 4.617 0 0 1 .515-.73c.09-.105.17-.198.234-.268l.078-.094.038-.046.03-.049.027-.057c.007-.027.023-.064.025-.143a.4.4 0 0 0-.4-.406c-.121.007-.142.029-.157.033a.405.405 0 0 0-.21.526.395.395 0 0 0 .52.216z'/%3e%3cpath d='M451.864 209.66s-5.713 1.598-5.859 1.702c-.42.302 1.831-.048 3.596-.102a6.675 6.675 0 0 1 2.055.26s.687-.02 1.382-.288c2.19-.856 6.8-2.57 7.229-.551.357 1.682-6.367 3.162-6.367 3.162l-.06.664 5.406-1.345 2.787-1.465.896-1.439-2.688-1.916h-3.932l-1.817.504z'/%3e%3cpath fill='%238f4620' d='M443.51 217.92c.423 1.186 1.378 2.913 2.455 3.464 0 0 .183.02.117.135-.067.119-.864.61-2.688.136-1.825-.471-4.612-1.212-6.304-6.326l.052 1.126.994 2.004 1.79 1.85 2.806 1.767 1.922.47 1.627-.42.73-.555-1.677-1.514-2.055-3.502s-.083.486.23 1.364z'/%3e%3c/g%3e%3cg fill='%23816c2a'%3e%3cpath fill='%23fcca3d' d='m462.543 268.718-.087 1.853-1.023-.101.18-2.321zm-7.162-52.82-1.889-2.125-1.228.184 1.87 2.662z'/%3e%3cpath d='M462.449 273.053c-.003 0-1.142-.75-2.619-1.432-1.508-.693-3.626-1.007-3.637-1.01l-.07.477s.128.02.345.06c.655.121 2.11.426 3.166.914a21.871 21.871 0 0 1 2.556 1.397zm-.164-4.732c-.002 0-1.044-.075-2.157-.075-.769 0-1.567.035-2.113.163-1.276.316-2.11.963-2.127.975l.288.385.032-.023a5.82 5.82 0 0 1 1.923-.865c.457-.113 1.246-.157 1.997-.15a26.51 26.51 0 0 1 2.123.074zm-.548-4.066c-.005.004-2.638 1.242-3.86 2.052-1.21.801-2.478 1.843-2.481 1.845l.301.38s.312-.258.776-.616a28.12 28.12 0 0 1 1.663-1.205c.58-.381 1.537-.892 2.339-1.298a57.071 57.071 0 0 1 1.462-.717zm-2.536-4.183v.007c.001.091-.022 1.065-.494 1.814-.116.186-.487.636-.961 1.171-.715.804-1.672 1.84-2.455 2.672-.779.826-1.38 1.452-1.38 1.452l.342.34a271.81 271.81 0 0 0 2.211-2.34 135.9 135.9 0 0 0 1.637-1.798c.482-.546.85-.985 1.01-1.235.559-.901.566-1.94.568-2.075v-.007h-.478zm-3.307-1.869.02.087c.037.177.11.614.11 1.198 0 .6-.08 1.357-.357 2.142-.32.922-.953 2.24-1.5 3.321-.275.544-.528 1.023-.712 1.376-.184.344-.298.553-.298.553l.414.24c.005-.007 1.869-3.403 2.547-5.33a6.949 6.949 0 0 0 .384-2.302c0-.834-.142-1.392-.147-1.408zm-3.2-.385s.02.19.04.505c.022.32.043.757.043 1.24.002.898-.074 1.96-.338 2.69-.287.814-.68 1.882-1.004 2.746l-.566 1.522.446.17s.992-2.638 1.575-4.276c.295-.834.363-1.927.365-2.852 0-.996-.085-1.793-.085-1.797zm-2.466-.012s-.003.813-.054 1.824c-.049 1.012-.146 2.218-.32 2.967-.37 1.58-.758 3.857-.758 3.857l.47.083s.097-.57.238-1.332c.143-.758.333-1.717.514-2.496.374-1.618.385-4.891.387-4.9zm-2.663.433s.034.298.066.759c.033.461.066 1.074.066 1.696 0 .715-.047 1.441-.176 1.933-.389 1.479-.62 3.798-.621 3.804l.476.052c0-.004.056-.577.162-1.334.106-.755.26-1.695.445-2.397.15-.57.19-1.324.19-2.058 0-1.28-.13-2.506-.134-2.51zm-2.091.28s.007.094.007.273c0 .571-.05 1.951-.446 3.372-.266.947-.579 2.067-.831 2.947-.247.882-.43 1.524-.43 1.524l.46.136s.729-2.577 1.26-4.48c.412-1.484.46-2.903.46-3.499 0-.186-.002-.292-.002-.294l-.478.02zm-2.338.023s.013.106.03.285c.012.189.028.449.028.762.002.893-.124 2.189-.677 3.201-.468.853-1.349 1.687-2.115 2.29a15.031 15.031 0 0 1-.988.725c-.128.086-.232.151-.303.198l-.11.066.243.42c.012-.014 2.638-1.558 3.692-3.468.617-1.13.735-2.494.735-3.43 0-.66-.06-1.104-.06-1.112zm-1.437-.456s-.036.12-.103.322c-.206.61-.726 1.963-1.462 2.877-.487.603-1.288 1.24-1.962 1.71-.337.238-.644.43-.865.571-.221.138-.356.213-.356.215l.234.421c.01-.007 2.237-1.274 3.318-2.613 1.072-1.333 1.649-3.347 1.654-3.364zm-2.278-1.144-.133.261c-.13.246-.339.63-.575.996-.236.372-.506.73-.726.923-.312.267-.931.663-1.457.972-.529.315-.971.555-.974.557l.225.428c.002-.004.453-.244.991-.565.539-.32 1.158-.711 1.524-1.028.384-.332.756-.907 1.05-1.408.294-.496.5-.921.5-.921zm-1.11-1.426s-.143.17-.373.434c-.35.397-.894.996-1.438 1.517a9.76 9.76 0 0 1-.783.684c-.24.187-.459.315-.584.353l.134.465c.31-.097.639-.338 1.006-.643 1.087-.928 2.399-2.49 2.4-2.496zm-.548-.958s-.133.107-.347.274c-.32.246-.826.619-1.333.921-.498.305-1.025.539-1.28.53h-.013v.484h.013c.309-.003.641-.13.992-.302 1.05-.522 2.261-1.53 2.268-1.53zm-.42-1.028c-.004 0-.532.306-1.142.62-.307.157-.63.318-.92.441-.283.123-.54.207-.656.219l.047.478c.222-.023.488-.12.794-.25.912-.387 2.108-1.09 2.115-1.09l-.24-.418zm-.504-2.126-.05.053a5.19 5.19 0 0 1-.82.713c-.398.285-.887.527-1.33.527l.006.484c.688-.015 1.31-.388 1.777-.739a5.55 5.55 0 0 0 .773-.72zm.176-3.342c-.002 0-.432.34-.906.79-.47.453-.984.99-1.175 1.483a.896.896 0 0 1-.14.19l-.104.088-.03.019h-.005l.007.029v-.03h-.007l.007.03v-.03.482c.23-.01.363-.136.476-.25.114-.127.195-.24.24-.354.113-.326.605-.876 1.06-1.301.226-.218.445-.412.608-.547.16-.138.265-.217.265-.217l-.297-.38zm16.403-19.616s1.076.006 1.756.006c.157 0 .29-.003.39-.003h.112l.035-.003h.02l.021-.004.036-.01.058-.026.058-.055.05-.145-.044-.14-.087-.074-.068-.026-.036-.003-.02.483.008-.188-.02.188h.012l.008-.188-.02.188.024-.23-.048.226.023.004.025-.232-.048.227.05-.237-.087.225.037.012.05-.237-.087.225.088-.225-.141.194.053.031.087-.224-.14.194-.055-.055.195-.14h-.238l.044.14.195-.14h-.238l.048-.145.095-.075.093.217-.027-.236-.066.019.093.217-.027-.237.017.16-.005-.16h-.012l.017.16-.005-.16h-.523l-1.752-.002-.005.484zm.058-1.437.152.01c.34-.003.678-.14 1.024-.322.515-.277 1.048-.676 1.53-1.005.24-.163.47-.31.667-.41.196-.1.366-.153.47-.153l-.008-.486c-.303.009-.593.152-.909.336-.473.278-.991.674-1.49.997-.494.33-.975.565-1.284.555l-.088-.003zm-.198-2.302c.357-.048.73-.221 1.131-.447.597-.337 1.244-.797 1.837-1.171.588-.378 1.143-.653 1.44-.65l-.007-.485c-.345.01-.701.162-1.089.369-.576.314-1.22.77-1.824 1.157-.603.39-1.18.705-1.547.746l.06.48zm-.854-2.138c.575-.306 1.445-.977 2.349-1.676.901-.698 1.83-1.422 2.455-1.803l-.248-.415c-.667.407-1.595 1.135-2.496 1.833-.896.695-1.778 1.366-2.278 1.631l.218.43zm-1.612-2.442c1.145-.807 3.944-2.812 4.992-3.478l-.252-.41c-1.076.683-3.866 2.685-5.011 3.492zm-2.138-2.348c.755-.643 1.825-1.36 2.81-1.992.99-.63 1.888-1.18 2.338-1.514l-.28-.39c-.415.307-1.323.863-2.314 1.495-.992.637-2.07 1.359-2.858 2.03zm-1.682-1.449c0-.002 1.126-.82 2.353-1.688a97.855 97.855 0 0 1 1.786-1.238c.53-.358.969-.635 1.132-.711l-.198-.439c-.232.11-.657.382-1.198.746-1.612 1.085-4.153 2.936-4.156 2.938z'/%3e%3cpath fill='%2378732e' d='m450.836 211.587.29.233c.654.533 2.298 1.95 3.771 3.797 1.474 1.847 2.764 4.124 2.759 6.347 0 .213-.01.428-.035.638-.33 2.894-1.783 5.442-3.796 7.798-3.02 3.532-7.296 6.611-10.83 9.732-1.77 1.558-3.353 3.13-4.504 4.793-1.148 1.662-1.865 3.422-1.865 5.323 0 .087.003.173.006.259.06 1.749.626 3.662 1.717 5.204 1.092 1.542 2.72 2.72 4.867 2.934.356.036.718.05 1.08.05 2.76-.002 5.767-.882 8.635-.878 2.415.004 4.704.599 6.743 2.828 1.946 2.127 2.544 5.55 2.54 8.843 0 2.36-.3 4.647-.6 6.346a38.43 38.43 0 0 1-.601 2.794l.458.133c.004-.014 1.221-4.477 1.221-9.273-.004-3.35-.589-6.882-2.672-9.173-2.129-2.34-4.604-2.99-7.09-2.982-2.958 0-5.971.881-8.635.876-.35 0-.695-.015-1.032-.048-1.996-.202-3.497-1.276-4.526-2.728-1.03-1.456-1.572-3.29-1.63-4.947l-.002-.238c0-2.37 1.183-4.53 3.026-6.634 2.767-3.158 6.983-6.143 10.647-9.453 3.663-3.308 6.794-6.96 7.317-11.504.026-.23.04-.462.04-.693-.007-2.758-1.776-5.432-3.52-7.434a26.415 26.415 0 0 0-3.492-3.326l-.286.383z'/%3e%3cpath fill='%23a8ac71' d='m447.214 216.284-.574-.494-.491.177.928.76zm1.542 1.46-.43-.443-.225.127.356.468z'/%3e%3cpath fill='%2378732e' d='m450.906 220.115-.368-.467-.225.29.375.43zm1.613 2.408-.269-.48-.43.075.56.607zm.91 2.266-.211-.658-.062.114-.039.5zm.106 2.278.025-.626-.287-.177.038.86zm-.094 1.46.063-.708-.187-.126.012.923zm-18.623 22.631s.05-.581.214-1.086c.158-.507-.46.238-.46.238l-.077.697.323.15z'/%3e%3cpath fill='%23fff' d='m434.666 252.607-.274.125.1.68.15-.214s.024-.381.024-.59z'/%3e%3cpath fill='%2378732e' d='m434.713 255.305-.038-.664-.199-.075v1.082z'/%3e%3cpath fill='%23fff' d='m434.889 256.812-.064-.6-.21.032-.014.568zm.408 2.174-.124-.581-.137.138.112.582zm.573 2.232-.237-.784-.175.075.237.753z'/%3e%3cpath fill='%23a8ac71' d='m437.318 264.208-.323-.487-.306-.05.393.594zm2.208 2.185s-.298-.177-.735-.53c-.434-.354-.173.329-.173.329l.623.33zm14.99 1.122s-.35-.239-.597-.353c-.25-.113.135.024.348.519.21.493.25-.166.25-.166z'/%3e%3cpath fill='%23fff' d='M455.801 268.554s-.286-.363-.475-.49c-.186-.124-.122.377-.122.377l.385.166z'/%3e%3cpath fill='%23a8ac71' d='M456.059 269.15c-.16-.213-.334.316-.334.316l.459.431s.037-.529-.125-.747zm.07 2.068s.1-.44.074-.721c-.024-.276-.248.099-.248.099l.025.622z'/%3e%3cpath fill='%23fff' d='m455.404 273.403.175-.544-.224.006-.138.563zm-22.818-79.855s.86-.177.21.796c-.646.971.435-.871.435-.871l-.347-.102z'/%3e%3c/g%3e%3cpath fill='%23f9c83a' d='m451.082 210.98.521.531s-.486-.127-.696-.152c-.211-.027.175-.38.175-.38z'/%3e%3cpath fill='%238f4620' d='M451.595 211.517s-.735.1-.994.138c-.262.037.298-.29.298-.29z'/%3e%3cpath fill='%23977c2e' d='M460.755 278.613s.624-.065.904-.448c.277-.38-.178.6-.178.6l-.4.15-.326-.3z'/%3e%3c/svg%3e";
            },
            7758: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 2800 1400'%3e%3cpath d='M0 0h2800v1400H0z' style='fill:%23cc0001'/%3e%3cpath id='a' d='M0 1300h2800v100H0z' style='fill:%23fff'/%3e%3cuse xlink:href='%23a' transform='translate(0 -200)'/%3e%3cuse xlink:href='%23a' transform='translate(0 -400)'/%3e%3cuse xlink:href='%23a' transform='translate(0 -600)'/%3e%3cuse xlink:href='%23a' transform='translate(0 -800)'/%3e%3cuse xlink:href='%23a' transform='translate(0 -1000)'/%3e%3cuse xlink:href='%23a' transform='translate(0 -1200)'/%3e%3cpath d='M0 0h1400v800H0z' style='fill:%23010066'/%3e%3cpath d='M576 100c-166.146 0-301 134.406-301 300s134.854 300 301 300c60.027 0 115.955-17.564 162.927-47.783-27.353 9.44-56.71 14.602-87.271 14.602-147.327 0-266.897-119.172-266.897-266.01 0-146.837 119.57-266.01 266.897-266.01 32.558 0 63.746 5.815 92.602 16.468C696.217 118.91 638.305 100 576 100z' style='fill:%23fc0'/%3e%3cpath d='m914.286 471.429-99.538-53.25 29.43 108.982-66.575-91.165-20.77 110.96-20.428-111.024-66.857 90.96L699.314 418l-99.701 52.943 74.065-85.192-112.8 4.441 103.694-44.62-103.555-44.94L673.8 305.42 600 220l99.538 53.25-29.43-108.982 66.575 91.165 20.77-110.96 20.428 111.023 66.857-90.959L814.97 273.43l99.702-52.944-74.065 85.193 112.8-4.441-103.694 44.62 103.555 44.94-112.785-4.79z' style='fill:%23fc0' transform='matrix(1.2738 0 0 1.2423 -89.443 -29.478)'/%3e%3c/svg%3e";
            },
            1598: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3cpath d='M0 0h900v600H0z'/%3e%3cpath fill='%23fff' d='M0 0h900v206.25H0z'/%3e%3cpath fill='%23007168' d='M0 0h900v187.5H0z'/%3e%3cpath fill='%23fff' d='M0 393.5h900V600H0z'/%3e%3cpath fill='%23fce100' d='M0 412.5h900V600H0z'/%3e%3cpath fill='%23d21034' d='M0 0v600l393.75-300z'/%3e%3cpath fill='%23fce100' d='m204.37 412.485-73.154-53.56L58.16 412.5l28.332-86.124-73.528-52.924 90.664.332 27.613-86.284 27.7 86.33 90.594-.403-73.544 53.023z'/%3e%3cpath fill='%23fff' fill-rule='evenodd' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.575' d='M67.724 352.427h52.699c4.24 4.757 13.7 6.697 22.711-.056 16.518-9.045 48.473.056 48.473.056l6.292-6.685-15.338-50.34-5.506-5.899s-11.797-7.078-34.215-4.719c-22.417 2.36-30.283-.786-30.283-.786s-19.663 2.36-25.17 5.112c-.604.49-6.292 6.292-6.292 6.292z'/%3e%3cpath fill='none' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.575' d='M78.343 339.45s50.339-6.293 64.89 12.977c-8.218 5.624-15.453 6.087-23.203.395 1.234-2.057 18.09-19.665 60.958-13.765'/%3e%3cpath stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.575' d='m132.221 289.11-.393 55.453m45.227-54.667 9.439 44.048m-98.587-44.74-5.238 22.716'/%3e%3cpath fill-rule='evenodd' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.575' d='m33.497 358.465 12.393 14.531c1.456.868 2.748.813 4.041 0l18.367-22.04 7.715-9.551c1.194-1.415 1.575-2.993 1.469-4.408l14.748-13.105c1.206.083 1.925.22 3.131.301-1.425-.369-2.47-1.063-1.349-2.625l3.306-2.571 2.571 3.305s-3.672 4.776-4.04 4.776h-4.04l-7.715 6.98 3.372 2.98 5.077 13.918 6.245-4.409-4.04-14.325 8.816-9.552-3.307-5.143 2.205-2.939s30.513 19.21 42.268 14.068c.318.115.71-13.7.71-13.7s-31.59-3.306-32.326-9.551c-.734-6.245 6.98-6.98 6.98-6.98l-3.307-4.775.736-2.572 5.51 6.98 12.49-10.654 73.468 83.755c4.011-1.626 4.868-2.607 5.144-6.612-.104-.1-72-82.653-72-82.653l5.51-5.876c1.086-1.225 1.468-1.745 1.47-3.675l8.448-7.346c2.541.873 4.161 2.396 5.51 4.407l23.228-19.685c.612.612 2.472 1.224 3.734.536l38.402-36.861-41.854 29.562-1.469-1.102c0-1.225 1.518-1.527 0-3.673-1.626-1.952-4.04 1.836-4.407 1.836-.368 0-6.058-2.01-7.305-4.558l-.41 6.762-10.653 9.919-8.081-.368-11.756 11.388-1.469 4.408 1.837 3.674s-6.246 5.51-6.246 5.142c0-.366-1.262-1.623-1.316-1.786l5.357-4.826.735-3.306-1.788-2.791c-.542.394-7.396 7.567-7.764 6.832-.612-.686-19.835-22.408-19.835-22.408l1.101-4.04-12.489-13.593c-4.553-1.572-11.755-1.836-13.225 8.082-1.144 2.33-10.653.367-10.653.367l-5.143 1.102-29.02 41.143 16.163 19.469 33.061-41.877.982-11.864 6.937 7.757c2.313.297 4.516.323 6.612-.735l19.588 21.863-3.262 3.183c1.102 1.224 1.86 2.006 2.963 3.23 1.102-.734 2.154-1.615 3.256-2.351.368.491.98 1.422 1.348 1.912-1.641.893-2.793 2.082-4.434 2.976-2.626-1.712-5.162-3.844-4.97-7.236l-11.02 9.183-.367 1.837-32.694 27.183-2.939.368-.734 8.449 21.306-17.632v-2.573l2.204 1.837 16.53-13.223s1.102 1.469.736 1.469c-.368 0-14.695 13.224-14.695 13.224l-.367 1.469-2.571 2.204-1.47-1.102-19.837 17.632h-2.938l-11.02 11.022c-2.843.247-5.306.548-7.715 2.203z'/%3e%3c/svg%3e";
            },
            6329: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 90 60'%3e%3cdefs%3e%3cclipPath id='a'%3e%3cpath d='M0 0h90v60H0z'/%3e%3c/clipPath%3e%3c/defs%3e%3cpath fill='%23003580' d='M0 60V0h90z'/%3e%3cpath fill='%23009543' d='M90 0v60H0z'/%3e%3cg fill='none' clip-path='url(%23a)'%3e%3cpath stroke='%23fff' stroke-width='20' d='M0 60 90 0'/%3e%3cpath stroke='%23d21034' stroke-width='15' d='M0 60 90 0'/%3e%3c/g%3e%3cg fill='%23ffce00' transform='translate(18 16.341)'%3e%3cpath d='m0-10 1.55 4.2L5-8.66l-.76 4.42L8.66-5 5.8-1.55 10 0 5.8 1.55 8.66 5l-4.42-.76L5 8.66 1.55 5.8 0 10l-1.55-4.2L-5 8.66l.76-4.42-4.42.76 2.86-3.45L-10 0l4.2-1.55L-8.66-5l4.42.76L-5-8.66l3.45 2.86z'/%3e%3ccircle r='5.5' stroke='%23003580'/%3e%3c/g%3e%3c/svg%3e";
            },
            4860: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 450'%3e%3cpath fill='%23009543' d='M0 0h900v450H0z'/%3e%3cpath fill='%23ed4135' d='M0 0h900v300H0z'/%3e%3cpath fill='%230035ad' d='M0 0h900v150H0z'/%3e%3ccircle cx='300' cy='225' r='147.48' fill='%23fae600' stroke='%23000' stroke-width='5'/%3e%3cpath stroke='%23000' stroke-width='6' d='M275 247h50m-50-37h50M300 78v252'/%3e%3cpath d='M240.62 360.419c60.191 24.58 116.608 1.51 116.608 1.51s-21.297-23.048-32.214-32.047c-10.653-8.778-41.991-8.431-52.685 0-8.924 7.038-34.52 32.97-31.709 30.537Z'/%3e%3cellipse cx='300' cy='293' rx='16.5' ry='24'/%3e%3cellipse cx='300' cy='228.5' rx='20' ry='12.66'/%3e%3ccircle cx='300' cy='170' r='20'/%3e%3cpath d='M324 95.5c-.006-.013 1.733 2.87-1.913 9.436-17.426 31.383-34.913 32.061-38.232 34.764-3.658 2.978-5.202 2.774-5.202 2.774.261-2.688.504-13.679.695-14.738 2.645-14.663 24.796-14.461 42.132-29.476 2.708-2.345 2.514-2.773 2.514-2.773Z'/%3e%3cpath id='a' d='M265.5 163s3.914 11.23 4.5 22.5c.935 17.997 18.18 18.5 30 18.5v-10c-8.859 0-16.553-1.317-23-14.5-3.18-6.503-11.5-16.5-11.5-16.5zm-.5 145s6.296-7.765 13.662-25.975C282.505 272.525 291.612 267 300 267v-14c-19.028 0-28.15 7.055-29.113 17.363C268.91 291.541 265 308 265 308z'/%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 600 0)'/%3e%3c/svg%3e";
            },
            3309: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 700 600'%3e%3cpath fill='%230DB02B' d='M0 0h700v600H0z'/%3e%3cpath fill='%23FFF' d='M0 0h700v400H0z'/%3e%3cpath fill='%23e05206' d='M0 0h700v200H0z'/%3e%3ccircle cx='350' cy='300' r='85' fill='%23e05206'/%3e%3c/svg%3e";
            },
            6376: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 920 460'%3e%3cpath fill='%23007934' d='M0 0h920v460H0z'/%3e%3cpath fill='%23fff' d='M280 0h360v460H280z'/%3e%3cpath fill='%23007934' d='m463.32 30.575-2.414 26.116-8.842 1.33s6.14 3.449 7.213 6.912c.172.555.103 1.014-.145 1.36a1.944 1.944 0 0 1-.32.318c-1.78 1.367-7.039.723-7.039.723s6.968 5.88 7.504 8.011c.012.05.028.096.03.145-.002.04.007.106 0 .144-.009.031-.047.086-.06.116a1.108 1.108 0 0 1-.232.318c-1.638 1.513-9.365 1.938-9.365 1.938s8.567 6.109 9.103 9.573c.486 3.139.079 4.977 0 5.292-.598-.511-14.415-12.122-23.327-8.734-.443.23-.706.45-.814.665a.55.55 0 0 0-.029.347c.624 1.932 13.227 3.91 22.018 11.511-.218 1.903-25.055-6.05-25.973-1.07.777 1.405 26.729 5.145 28.649 8.532-9.558.355-29.303-2.104-28.649 1.041-1.997 3.63 18.649 1.58 27.311 4.54 2.54 2.87 2.294 5.28-2.123 5.582-8.35-3.969-27.034-6.918-27.08-1.85v.028c.003.006.028.024.03.03.008.015.016.043.029.057.03.029.096.06.145.087 2.11 1.053 19.51.54 26.061 4.859-9.288 2.1-40.782-4.262-40.982-1.157.897 1.45 5.881 7.815 14.456 7.548 8.575-.266 28.414 3.467 29.755 6.131a.36.36 0 0 1 .03.232c-.581 1.858-26.127-5.669-35.95-1.041-10.183 4.796 29.197 1.888 35.63 7.75 6.43 5.862-12.857-.55-12.857-.55s-26.783-3.715-30.802-1.85c-4.02 1.866-8.58 6.131-8.58 6.131s2.672 5.317 5.352 4.252c.408-.163.687-.196.843-.145.004.002.026-.002.03 0 .003.002.025.027.029.029.006.004.023.024.029.029.004.006.024.023.029.029l.03.029a.538.538 0 0 1 .028.115c.063.8-1.832 3.124-1.832 3.124s37.532 9.041 45.839 17.034c8.306 7.994-47.7-12.523-47.7-12.523s-22.51 8.259 1.338 8.792c-2.659 3.867 1.1 6.247 1.337 6.391 0 0 39.668 8.268 43.687 14.663 4.02 6.395-27.063-6.138-34.03-9.601-6.721-3.343-25.432 1.767-26.497 3.326a.559.559 0 0 0-.029.057c-.002.006.002.024 0 .03a.388.388 0 0 0 0 .057v.03c.002.005-.002.023 0 .028.002.006.027.024.03.029.001.006-.003.024 0 .029a.926.926 0 0 0 .058.087c.004.006.024.023.029.029 1.198 1.313 9.55 3.121 9.802 5.379v.029a.863.863 0 0 1-.088.376c-1.052 2.028-11.016 2.89-11.43 4.8-.007.033-.03.083-.03.116 0 2.133 50.125 12.524 63.523 23.715s-39.382-13.333-39.382-13.333 2.948 3.995 0 5.062c-2.948 1.065-13.419-14.92-30.569-5.062-3.123 4.057 14.974 7.276 19.575 7.722-1.57 4.017-2.94 5.346 3.49 9.342.704.437 1.099.701 1.251.838l.03.03.028.028c.002.002 0 .027 0 .03v.028h-.058c-.996-.155-12.55-6.059-13.758-6.304-.012-.002-.049 0-.058 0h-.029c0 .533 1.338 6.94 1.338 6.94-5.937-4.795-13.114-6.241-19.836-1.33-.01.284-.06 4.883 6.69 7.722-3.804 7.729 4.298 5.33 17.16 12.523-19.115-4.968-20.646 4.26-6.98 6.392s51.19 3.467 60.033 14.923c1.865 2.417 2.372 3.632 2.007 4.02-1.475 1.329-15.044-8.43-17.015-8.792-.004.002-.025-.004-.03 0l-.028.029a.898.898 0 0 0-.088.144c-.481 1.06-.93 5.669-.93 5.669-5.717-3.29-10.963-6.241-17.8-7.635-.537 1.065-.424 2.579-.96 3.644-6.206-4.45-11.611-7.578-20.622-8.011l-1.077 4.28s-7.512-9.326-22.25 0c-8.23 5.867 31.088 2.124 37.52 9.052 6.43 6.927 1.337 7.982 1.337 7.982-5.359-1.953-10.696-3.888-16.055-5.842 0 0-19.044-3.481-24.403.781-5.359 4.264 78.243 14.658 80.654 26.116 1.626 6.214-19.642-6.506-38.044-11.973-.711 2.034-1.44 4.069-2.152 6.103-.436-.43-7.555-7.314-15.532-8.503-.002.004-.027.022-.03.029v.058c.013.874 1.63 7.114 1.63 7.114s-20.613-9.602-31.063-4.54c-10.451 5.062 36.433 7.726 40.72 12.523.469.524.664.907.64 1.157a.55.55 0 0 1-.059.144c-1.035 1.508-15.017-4.062-16.404-1.301-1.608 3.197-24.38-5.854-24.112-1.591.268 4.264 3.229 6.652 3.229 6.652s47.43 4.527 49.038 10.122c1.607 5.595-26.264-3.181-26.264-3.181s-2.696 3.977-.553 5.842c.084.072.15.142.175.173v.029h-.03c-.968-.318-16.07-10.153-14.6-2.603-5.91-2.34-21.167-9.586-19.023-3.991 2.112 5.513 41.905 13.363 43.076 13.593-1.052.082-17.88 1.482-17.102 5.87-22.555-13.662-22.502-5.469-21.989-4.829v.03c-1.267-.2-29.016-7.074-6.951 4.8 11.833 6.367 14.717 8.85 14.776 9.804 0 .021.002.067 0 .087-.004.025-.02.064-.029.087-.002.006-.026.023-.03.029-.01.016-.017.043-.028.058l-.03.029-.029.029-.029.029c-.006.004-.023.025-.029.029-.459.291-1.567.17-1.89.173h-.059a.133.133 0 0 0-.029.029l.03.029c.314.465 2.045 5.165 1.948 5.987-.002.014-.026.047-.03.057-.001.004.003.025 0 .03 0 .001-.027-.003-.028 0-.002 0 .002.027 0 .028h-.059c-.967-.242-15.58-8.007-20.593-8.531-5.092-.533-29.215 6.653-3.49 17.844s41.526-2.67 55.728-1.07c14.202 1.598 20.914 4.001 19.575 8.531-1.34 4.53-14.528-14.85-28.388 1.91-15.766-3.103-26.462-4.898-18.324 6.622-25.747-9.567-41.47 2.919-9.046 7.982 31.862.934 51.452-7.722 51.452-7.722s5.375 9.878 13.147 2.95c7.407-6.602 7.99 1.8 8.26 2.603.005.012.026.022.03.03.002.001-.002.027 0 .028h.029c.572-.143 7.475-3.21 7.475-3.21h1.89v63.944c8.665.089 17.31.171 25.973.26 0 0-8.307-55.674-3.752-63.134 4.414-7.227 8.587-6.447 8.842-6.391 0 0 16.885 5.05 18.76 4.251.022-.01.067-.018.088-.029.014-.008.045-.02.058-.029.033-.02.087-.063.116-.087.006-.004.024-.024.03-.029 1.372-1.245-.026-6.16 8.55-5.408 2.65-.958 1.639-5.156 3.346-6.189.03-.018.084-.042.116-.058.064-.03.161-.065.233-.086.1-.03.234-.047.349-.058 2.68-.267 54.392 14.376 65.646.52-2.948-7.726-13.143-.527-15.823-.26-2.412 0-12.602-4.796-18.498 0-5.36-3.996-29.726-6.652-29.726-6.652-3.216-3.197 58.149 1.588 61.632-.81 7.234-7.194-13.392-6.389-16.608-3.99-5.717-3.465-12.9-3.208-17.277-.81-2.099-4.992-22.024-2.83-33.1-4.252-3.544-2.067-2.954-3.254-.552-4.54 23.134.977 46.151 3.98 69.398 2.95 6.284-8.146-7.91-11.218-16.608-4.28-5.106-8.35-15.545-.272-22.512-1.071-6.966-.8-3.752-9.314 5.09-7.982 8.843 1.333 24.655-.544 27.602-4.54 2.947-3.997-1.76-8.046-16.346-4.252-4.937-4.798-15.792-.008-20.884 1.59-6.774-3.757-22.534-.522-27.893.81-5.246-3.242 27.602-8.531 27.602-8.531 12.68-.223 19.831-2.405 23.85-3.47 19.168-10.216-.267-11.3-10.325-3.876-6.243-4.847-12.173.419-17.8 2.285-5.275 1.748-15.032 3.021-16.23 2.516a.631.631 0 0 1-.058-.03c-.002-.001-.026-.026-.03-.028l-.028-.03v-.057a.473.473 0 0 1 .029-.057c.79-1.218 15.24-10.036 15.24-10.036s18.76-1.347 22.513-1.88c2.286-.325 10.299-4.096 10.296-5.495-.067-.868-3.406-.788-13.525 1.764-9.111.8-14.462.283-17.946.55-5.603-.576-7.964-1.163-8.435-1.678a.658.658 0 0 1-.058-.086c-.04-.093-.014-.2.058-.29.018-.02.063-.066.087-.086 1.374-1.091 10.238-1.88 10.238-1.88s27.063-2.468 28.853-3.876l.03-.029c.01-.012.022-.047.028-.058.002-.006.028-.023.03-.029.556-11.002-22.96-5.921-23.588-5.842.067-7.736-21.224-.113-22.221 0h-.03c-.916-.536-1.315-1.102-1.396-1.62a1.48 1.48 0 0 1 .058-.606c.534-1.596 3.752-2.835 3.752-2.835 5.896-1.42 14.71-1.864 17.015-3.73 0 0 16.64-.146 18.615-4.541-4.083-11.201-35.213 1.983-39.382 3.991-.835 0-1.346-.209-1.6-.55-1.368-1.988 5.387-8.537 5.614-8.762.002-.002.024-.027.03-.03 1.029-.29 25.883-1.554 37.752-17.554.838-9.894-14.194 5.581-14.194 5.581-1.122-12.83-16.345.814-25.188 1.88-8.842 1.065-9.1-4.001-2.937-4.8 6.162-.8 13.124-.277 16.608-9.602 3.482-9.326 13.947.543 15.823-2.921 1.816-3.356-3.424-6.217-3.752-6.392 0 0 7.765-8.017-4.829-7.75-12.467.263-28.585-1.554-28.91-1.591.781-.297 13.48-5.06 25.42-4.801 12.327.266 5.625-8.792-6.166-8.792-11.79 0-17.946-3.991-17.946-3.991l20.098-7.462-1.338-5.582s11.786-9.332-4.828-7.201c-16.614 2.132-18.498 2.4-18.498 2.4s-32.705 4.984-33.478 5.062h-.03c-.316-.05-3.555-1.05-4.158-2.285a1.567 1.567 0 0 1-.059-.145 1.126 1.126 0 0 1-.029-.173c-.004-.058-.01-.143 0-.203.135-.65 1.144-1.354 3.723-1.995 8.575-2.131 38.87-8.251 43.425-6.652.587.206 1.016.16 1.28-.058 1.708-1.537-3.974-11.338-17.917-12.725-16.078-1.598-25.973 3.991-25.973 3.991s-10.462-3.743-.814-6.94c9.646-3.197 24.926 1.07 24.926 1.07s17.14-5.07 2.937-7.202c-14.202-2.132-18.68 1.917-25.188 2.14-2.598-3.224 22.297-3.985 23.85-6.651-2.625-4.798-18.028 0-27.05 0-3.837-1.62-4.091-4.253.262-5.871 9.2-.356 17.849.181 27.05-.174-.268-4.884.006-10.675-.262-15.559-11.67-2.12-25.355 1.553-31.907 1.244 1.753-5.33 26.95-6.706 29.755-8.156 5.79-7.195-24.167-.111-24.897 0-5.317-.781-4.995-4.123-1.629-6.131 7.771-.889 25.197 1.132 23.88-4.107-1.01-4.91-12.083-2.28-16.638-1.215-4.555 1.066-11.256.26-11.256.26-2.917-3.904 26.27-2.308 26.003-5.32-.38-3.46-18.5-1.077-24.665-.81-4.74-3.253 22.286-5.415 23.56-5.843l.029-.029c1.01-8.857-18.76 0-22.512 0-.645 0-1.133-.16-1.484-.433a2.222 2.222 0 0 1-.233-.232c-1.288-1.494-.145-4.916-.145-4.916s7.045-3.148 7.475-3.905c.002-.006.027-.023.03-.029v-.059l-.03-.028a.576.576 0 0 0-.087-.087c-.827-.633-5.673-2.232-6.312-2.285h-.029c-.004-.001-.025-.027-.029-.029a.223.223 0 0 1-.03-.029c-.003-.004-.025-.023-.028-.029-.365-.745.087-6.044.087-6.044s5.582-4.16 5.933-5.813c.002-.014-.002-.045 0-.058.002-.014 0-.045 0-.058v-.058c0-.012.002-.046 0-.058v-.029c-.004-.016-.022-.042-.029-.058-.002-.006.002-.023 0-.029-.002-.004-.026-.024-.029-.029-.006-.01-.023-.02-.03-.029-.01-.014-.017-.045-.028-.057l-.03-.03a.938.938 0 0 0-.087-.057l-.058-.03c-1.41-.672-7.242 1.331-7.242 1.331v-5.321s5.106-.552 5.642-2.95c.032-.14.016-.279 0-.405-.008-.05-.014-.126-.029-.174a1.346 1.346 0 0 0-.145-.318c-.01-.014-.048-.044-.059-.058-1.168-1.5-5.933-1.706-5.933-1.706-.894-9.325-1.782-18.64-2.676-27.966zm-4.77 91.332v3.673s-6.01-.306-7.126-1.244c-.006-.004-.024-.024-.03-.029l-.028-.028-.03-.03-.029-.028c-.01-.014-.021-.043-.029-.058-.002-.004.002-.024 0-.029-.002-.004-.028-.024-.029-.029v-.144a.592.592 0 0 1 .029-.087c.002-.006.026-.024.03-.03a.798.798 0 0 1 .057-.086l.03-.029.058-.058c.04-.035.093-.079.145-.116 2.016-1.403 6.042-1.37 6.835-1.59.006-.002.023.002.03 0 .006-.002.024-.027.029-.03.004-.001.025.003.029 0 .004-.001.026-.026.029-.028zm8.522 4.888c.208 0 11.97.1 13.001 1.62.008.011.023.044.03.057.007.02.024.067.029.087.002.014-.001.044 0 .058 0 .02.004.065 0 .087a.973.973 0 0 1-.03.086c-.898 1.898-12.798 3.037-12.798 3.037l-.232-5.032zm-.669 7.259c.004.002.025-.002.03 0 .003.002.022-.002.028 0 .699.183 5.57.34 6.167 1.156.006.008.024.022.029.03.002.003-.002.024 0 .028.004.008.026.021.029.03v.143c-.002.004-.028.024-.03.029-.001.004.003.024 0 .028-.007.014-.02.044-.028.058l-.03.03c-.004.003.004.023 0 .028-1.01 1.227-5.505 1.562-5.73 1.562h-.029c-.002 0 .002-.028 0-.029-.004-.006-.025-.023-.029-.029-.205-.415-.407-3.065-.407-3.065zm-35.863 9.66c3.84-.2 11.462.7 25.77 4.627 0 .302.29 3.991.175 4.598-.001.004-.028.025-.03.029v.029c-.002.002-.025.028-.029.029-.224-.112-26.03-7.486-28.388-7.375-.064.002-.142.006-.203 0a1.945 1.945 0 0 1-.175-.029c-.064-.016-.147-.061-.203-.087-.021-.01-.068-.018-.088-.029-.006-.004-.023-.025-.03-.029a.826.826 0 0 1-.203-.202c-.004-.006-.025-.023-.029-.029l-.029-.058c-.002-.006.002-.023 0-.029-.004-.012-.026-.046-.029-.058v-.144a.703.703 0 0 1 .03-.116.873.873 0 0 1 .174-.26c.394-.384 1.382-.77 3.286-.868zm13.38 10.902c4.113-.146 13.968 2.211 14.513 2.083 0 .781.436 4.475-.058 5.234-.004.006-.024.023-.03.03-.003.005-.023.023-.028.028-.006.004-.024.025-.03.029a.685.685 0 0 1-.058.029c-.006.002-.023-.001-.03 0h-.057c-.006-.001-.022.002-.03 0-.837-.208-15.381-4.802-15.938-6.68-.008-.032-.001-.087 0-.117a.383.383 0 0 1 .087-.202c.006-.006.022-.023.03-.029l.028-.029c.28-.22.856-.35 1.6-.376zm40.486 10.122c3.928-.076 6.702.258 5.672 1.446-2.805 3.236-22.192 5.9-22.192 5.9l-.35-5.9c.417-.06 10.268-1.317 16.87-1.446zm-55.495 18.394c3.297-.174 10.974 1.626 28.068 8.821l.117 4.252s-28.948-8.73-29.958-10.18c-.498-.714-1.421-2.723 1.774-2.893zm56.717 6.334c.88-.045 1.5.044 1.716.26.006.006.025.023.03.03.011.02.021.065.028.086.004.022.03.063.03.087-.012.122-.104.286-.262.463-2.694 3.013-17.161 6.015-17.161 6.015v-3.904h.029c.66-.023 11.279-2.82 15.59-3.037zm-63.465.52c4.322-.227 14.08 2.052 35.95 12.35 0 .106.195 3.658.116 3.99h-.029c-1.296-.415-39.353-13.707-39.353-13.707-.04-.146-.613-2.425 3.316-2.632zm72.452 16.63c1.106-.046 1.832.05 2.007.29a.332.332 0 0 1 .03.116c-.005.115-.101.263-.292.433-3.45 3.1-25.453 6.854-26.235 6.912h-.029c-.002 0-.026.002-.029 0l-.03-.029a.41.41 0 0 1-.028-.057c-.002-.006.002-.024 0-.03-.004-.011-.026-.044-.03-.057-.14-.718.316-3.234.35-3.586v-.03c0 .002.027 0 .029 0 .004.001.024.03.029.03h.029c1.408-.024 18.27-3.745 24.199-3.991zm-64.686 9.69c6.55-.337 26.397 8.712 27.37 8.993h.03c-.103.405-.12 3.672-.204 4.194-.002.014.002.05 0 .058-.001.002-.029-.001-.03 0-.534-.285-27.735-11.51-28.94-10.614-.75-1.768.028-2.542 1.775-2.632zm58.52 2.37c1.363-.059 2.36.001 2.676.174a.248.248 0 0 1 .087.087c.002.004 0 .024 0 .029a.39.39 0 0 1 0 .029c-.002.012.006.046 0 .058-.004.006-.024.022-.029.029a.78.78 0 0 1-.087.086c-2.02 1.786-20.767 5.466-20.767 5.466s-.088-3.453-.088-3.788c.533-.113 12.635-1.925 18.208-2.17zm-1.512 11.945c1.319-.044 2.254.03 2.472.26l.029.029c.006.01-.002.047 0 .058 0 .006.029.023.03.029-.001.006-.03.023-.03.029-.002.012.006.045 0 .057-.004.006-.025.023-.03.03-.015.026-.034.059-.057.086-.018.02-.064.066-.088.087-2.023 1.737-17.917 5.061-17.917 5.061s-.436-3.792-.436-3.904c.44.01 11.067-1.658 16.026-1.822zm-67.071.954c3.834-.241 13.337 1.33 36.793 9.804l.785 4.57s-39.055-12.536-40.167-12.928c.002 0 0-.026 0-.03 0-.024-.006-.082 0-.144a.986.986 0 0 1 .204-.463c.275-.335.904-.717 2.385-.81zm51.452 9.92c.47.1 7.019.316 8.23 1.33a.213.213 0 0 1 .03.03l.03.028c.003.004.024.024.028.03.012.015.02.042.03.057.002.006.026.024.029.029.01.021.023.065.029.087v.144c-.002.012-.025.046-.03.057-.001.006.003.023 0 .03l-.028.057c-1.01 1.562-7.853 2.14-7.853 2.14s-.337-3.06-.495-4.02zm15.852 8.907c1.525-.036 2.619.138 2.85.579.13.299-.12.74-.843 1.33-5.61 4.575-17.83 5.466-17.83 5.466v-5.032h.029c.694-.082 10.73-2.222 15.794-2.343zm15.56 4.686c1.937-.073 2.772.25 3.026.694.02.04.046.103.058.145a.94.94 0 0 1 .029.26c-.062.573-.687 1.26-1.163 1.706-1.908 1.785-32.314 11.366-32.314 11.366s-.23-6.355-.117-6.912c17.777-5.357 26.472-7.108 30.482-7.259zm-19.661 17.989c1.933-.072 3.444.042 3.897.491.028.03.069.083.088.116.01.02.022.065.029.087.006.021-.002.064 0 .087 0 .038.01.102 0 .144-.022.086-.081.19-.146.29-2.601 2.538-15.241 2.92-15.241 2.92v-3.152c2.373-.08 7.657-.845 11.372-.983zm12.652 5.176c.6-.014.967.083 1.018.26a.28.28 0 0 1 0 .059c-.03.147-.207.37-.582.636-5.05 3.57-24.025 7.23-24.025 7.23s.235-2.495.349-3.095c.528-.008 18.699-4.979 23.239-5.09zm10.645 3.963c2.236-.021 3.942.307 4.915 1.012h.03v.116c-.096.691-1.517 3.945-6.516 5.35-6.234-.554-32.693 7.224-33.216 7.346-.002-.002-.028.002-.029 0-.002-.01.001-.043 0-.058-.014-.498.35-3.181.35-3.181 9.12-5.424 25.694-10.503 34.465-10.585zm-67.74 15.27h.174c11.445 1.227 15.72 5.487 16.928 7.2-2.282 3.983-20.37-4.947-18.469-6.853.218-.193.665-.333 1.367-.347zm65.588.752c.454-.018.87.075 1.163.26.12.08.238.194.32.318.11.178.184.418.204.694-1.196 1.837-7.38 1.035-7.766.983.311-.11 3.881-2.172 6.079-2.255zm-24.52 12.378c.85-.035 1.554.05 1.95.289.047.03.107.08.145.116.012.012.047.044.058.057.016.02.045.066.058.087.012.022.02.063.03.087.071.216.043.515-.146.868-1.795 3.347-9.656 2.11-9.656 2.11v-2.342h.029c.442.038 4.775-1.16 7.533-1.272zm-46.303 8.82c2.418-.12 4.532 1.457 6.748 2.719 4.936-1.004 15.066.78 15.066.78v4.455a.112.112 0 0 1-.03.029c-.004.002-.023-.002-.029 0-.922.16-12.793-.356-15.444-2.025-2.162 0-8.284-3.212-8.754-4.858-.004-.014-.027-.045-.03-.058-.004-.02.002-.067 0-.087v-.058c.001-.012-.002-.046 0-.058v-.029c.002-.012.026-.046.03-.058.002-.006-.002-.023 0-.029.846-.448 1.67-.684 2.443-.723zm51.918 2.199c1.857-.1 2.644.47 1.192 2.516-4.04 5.69-14.485 3.354-14.485 3.354l-.436-3.528c3.684.143 10.418-2.165 13.728-2.343zm-39.033 11.539c4.223-.196 8.813 1.475 8.813 1.475.108.214 2.27 4.451.349 5.87-.072.052-.15.102-.233.145-2.357 1.227-13.62-.959-14.281-5.466 1.325-1.391 3.289-1.929 5.352-2.024zm-43.541 2.198c3.862-.231 8.177 2.135 8.667 2.371.006.002.026 0 .03 0 0 .133-.146 4.28-.146 4.28s-7.647-2.12-10.064-6.391a7.581 7.581 0 0 1 1.512-.26zm73.558.578c4.308-.027 9.513.98 10.267 2.43.142.296.1.623-.175.954-2.132 2.565-14.252.231-14.252.231v-3.123c1.079-.314 2.564-.482 4.16-.492z'/%3e%3c/svg%3e";
            },
            476: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 3'%3e%3cpath fill='%23008751' d='M0 0h6v3H0z'/%3e%3cpath fill='%23FFF' d='M2 0h2v3H2z'/%3e%3c/svg%3e";
            },
            886: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1000 600'%3e%3cdefs%3e%3clinearGradient id='e' x1='498.738' x2='500.626' y1='289.055' y2='283.42' gradientUnits='userSpaceOnUse'%3e%3cstop offset='0' stop-color='%23510000'/%3e%3cstop offset='.3' stop-color='%238a0000'/%3e%3cstop offset='1' stop-color='%23a00'/%3e%3c/linearGradient%3e%3clinearGradient id='f' x1='501.444' x2='502.927' y1='291.373' y2='287.449' gradientUnits='userSpaceOnUse'%3e%3cstop offset='0' stop-color='%23ff2a2a'/%3e%3cstop offset='1' stop-color='red'/%3e%3c/linearGradient%3e%3clinearGradient id='j' x1='484.764' x2='484.764' y1='311.709' y2='317.647' gradientUnits='userSpaceOnUse'%3e%3cstop offset='0' stop-color='%23F5F549'/%3e%3cstop offset='1' stop-color='%2397C924'/%3e%3c/linearGradient%3e%3clinearGradient id='a'%3e%3cstop offset='0' stop-color='%23025'/%3e%3cstop offset='.5' stop-color='%2304a'/%3e%3cstop offset='1' stop-color='%23025'/%3e%3c/linearGradient%3e%3clinearGradient xlink:href='%23a' id='g' x1='444.509' x2='634.411' y1='317.486' y2='317.486' gradientUnits='userSpaceOnUse'/%3e%3cclipPath id='b'%3e%3cpath d='m500 226.375-63.702 110.332H563.7z'/%3e%3c/clipPath%3e%3c/defs%3e%3cpath fill='%230067C6' d='M0 0h1000v600H0z'/%3e%3cpath fill='%23fff' d='M0 200h1000v200H0z'/%3e%3cpath fill='%23c8a400' d='m410 299.329 9.979.667c.033-.486.064-.972.098-1.458l-3.925-.262c.099-1.603.233-3.205.304-4.81 1.388-1.004 2.778-2.006 4.161-3.017l.124-1.848-4.388 3.186c-.148-1.038-.722-2.107-1.765-2.468-.913-.33-2.032-.388-2.823.265-1.003.738-1.184 2.058-1.314 3.207-.175 2.177-.297 4.36-.451 6.538zm1.52-1.362c.12-1.638.194-3.28.35-4.914.124-.808.272-1.742.98-2.257.64-.424 1.584-.108 1.846.614.522 1.247.29 2.622.223 3.93l-.19 2.841c-1.07-.07-2.141-.142-3.21-.214zm-.221-13.961 9.738 2.274 2.213-9.478-1.383-.324-1.883 8.063-2.964-.692 1.696-7.266-1.377-.321-1.696 7.266-2.623-.613 1.812-7.76-1.39-.325-2.143 9.176zm3.508-13.077 9.445 3.285.48-1.38-3.715-1.292c.485-1.429 1.016-2.842 1.462-4.284.32-1.177.567-2.552-.126-3.647-.562-.809-1.562-1.327-2.55-1.296-1.088.046-1.975.847-2.458 1.775-.714 1.342-1.113 2.818-1.634 4.24l-.904 2.599zm1.825-.912c.506-1.417.962-2.852 1.51-4.254.34-.749.755-1.637 1.617-1.875.708-.163 1.451.382 1.513 1.108.173 1.336-.411 2.597-.821 3.837l-.78 2.241-3.039-1.057zm3.392-11.184c1.78 1.033 3.547 2.093 5.338 3.107 1.01.543 2.29.854 3.347.246 1.44-.798 2.343-2.271 3.05-3.708.559-1.21.963-2.713.252-3.95-.765-1.235-2.156-1.803-3.343-2.54l-3.457-2.022-.734 1.254c1.694.998 3.4 1.975 5.086 2.986.807.491 1.475 1.38 1.336 2.369-.16 1.178-.833 2.211-1.503 3.164-.554.77-1.483 1.393-2.47 1.185-1.029-.197-1.865-.87-2.769-1.357l-3.4-1.989-.733 1.255zm7.203-11.771 7.942 6.077c1.232-1.61 2.46-3.223 3.701-4.824.712-1.022 1.368-2.35.886-3.604-.439-.998-1.466-1.77-2.568-1.82-.497-.07-1.145.307-1.414.473.283-1.066-.59-2.068-1.572-2.35-1.182-.42-2.38.338-3.163 1.178-.92 1.001-1.688 2.129-2.53 3.195l-1.282 1.675zm2.014-.298c.93-1.19 1.81-2.421 2.783-3.576.453-.504 1.18-1.075 1.882-.705.64.277.798 1.085.492 1.666-.485 1.04-1.286 1.883-1.954 2.805l-1.09 1.426-2.113-1.616zm3.236 2.476c.965-1.233 1.873-2.513 2.89-3.703.52-.544 1.173-1.229 1.997-1.072.705.162 1.217.926.974 1.636-.397 1.309-1.376 2.311-2.165 3.396l-1.24 1.622-2.456-1.879zm3.754-12.785 6.867 7.269 5.883-5.558-.976-1.033-4.705 4.446-.12.114-.088-.092-5.805-6.144zm8.804-7.703 6.095 7.928 1.19-.915-6.096-7.927zm8.956-6.082c-.988.615-1.784 1.335-2.398 2.176-.611.837-.941 1.71-.989 2.622-.047.912.196 1.794.733 2.657a5.145 5.145 0 0 0 1.976 1.844c.82.439 1.706.601 2.676.493.965-.108 2.055-.535 3.27-1.292 1.165-.726 1.99-1.562 2.5-2.524.488-.924.625-1.904.416-2.948l-1.383.543c.362 1.998-.927 2.958-2.37 3.874-2.259 1.374-4.46 1.275-5.808-.79-1.398-2.327.13-4.25 2.051-5.5 1.364-.85 2.708-1.432 3.988-.618l1.082-.964c-.745-.514-1.592-.752-2.555-.7-1.012.056-2.069.429-3.189 1.127zm11.817-5.897-1.047 11.206 1.557-.628.315-3.474.006-.003 5.058-2.04 2.637 2.284 1.557-.627-8.526-7.346-1.558.628zm1.368 1.149 3.325 2.877-3.723 1.502.398-4.38zm20.55-7.331.624 9.98c1.805-.121 3.612-.206 5.414-.355 1.418-.163 2.939-.531 3.908-1.66 1.251-1.387 1.429-3.461.881-5.188-.46-1.52-1.827-2.671-3.375-2.963-1.525-.293-3.079-.061-4.614.008l-2.838.178zm1.54 1.327c1.436-.075 2.87-.216 4.309-.224a3.675 3.675 0 0 1 2.288.701c1 .684 1.588 1.916 1.457 3.125-.072 1.39-1.094 2.669-2.445 3.02-.772.2-1.576.257-2.367.344l-2.796.175-.447-7.14zM501.664 210l-.57 9.984 9.717.555.08-1.418c-2.755-.158-5.51-.316-8.266-.472.058-1.013.117-2.026.174-3.04l7.449.426.08-1.411c-2.482-.142-4.965-.285-7.449-.426l.154-2.689c2.652.15 5.304.303 7.956.454l.082-1.425-9.407-.538zm26.11 4.166-3.616 9.323 1.286.5 2.867-7.393.149-.384.16.427 3.448 9.918 1.684.653 3.616-9.323-1.29-.5-2.865 7.389-.146.377-.158-.422-3.454-9.913zm13.434 5.771-4.546 8.907-1.336-.682 4.546-8.907zm7.543 4.419c-.971-.64-1.958-1.065-2.978-1.271-1.015-.207-1.947-.142-2.795.195-.849.337-1.55.926-2.11 1.775a5.145 5.145 0 0 0-.851 2.565c-.056.928.165 1.8.669 2.637.5.832 1.344 1.645 2.537 2.432 1.147.757 2.251 1.158 3.338 1.22 1.043.058 1.991-.226 2.852-.852l-1.07-1.03c-1.665 1.163-3.075.392-4.51-.538-2.19-1.48-3.019-3.521-1.705-5.608 1.532-2.242 3.917-1.655 5.854-.43 1.343.885 2.432 1.863 2.226 3.366l1.328.581c.156-.892.02-1.76-.431-2.614-.473-.896-1.252-1.701-2.354-2.428zm9.521 7.182-10.454 4.17 1.269 1.1 3.236-1.301.005.005 4.119 3.575-.833 3.387 1.268 1.101 2.658-10.936-1.268-1.1zm-.4 1.741-1.048 4.27-3.032-2.631 4.08-1.639zm7.953 5.207-7.716 6.363.929 1.127 3.035-2.503c1.028 1.234 2.029 2.492 3.08 3.707-.322 1.683-.644 3.366-.957 5.05l1.178 1.43 1.006-5.33c.864.708 2.127 1.064 3.16.503.888-.42 1.67-1.228 1.716-2.257.108-1.379-.875-2.496-1.662-3.519-1.256-1.524-2.514-3.047-3.769-4.571zm-.17 2.034c1.08 1.334 2.214 2.626 3.246 3.998.475.708 1.068 1.702.523 2.528-.45.707-1.435.645-2.04.187-1.224-.824-2.033-2.087-2.989-3.184l-1.223-1.483 2.483-2.046zm11.868 13.881-11.243.515.838 1.456 3.484-.17.003.006 2.72 4.727-1.896 2.928.837 1.455 6.094-9.462-.837-1.455zm-.948 1.514-2.39 3.691-2.002-3.48 4.392-.21zm7.364 11.723c-.625-1.697-1.611-3.434-3.28-4.282-1.856-.933-4.328-.48-5.644 1.155-1.147 1.36-1.206 3.281-.9 4.952.362 1.918 1.242 3.744 2.563 5.186l-.747.268.479 1.331 4.684-1.683-1.822-5.059-1.082.39 1.34 3.728-1.587.57c-1.4-1.203-2.18-2.98-2.586-4.748-.301-1.327-.313-2.917.693-3.96 1.155-1.202 3.202-1.575 4.587-.55 1.367 1 2.139 2.621 2.529 4.233.266 1.06.223 2.32-.581 3.147-.225.168.131.403.192.605l.382.632a3.529 3.529 0 0 0 1.344-2.797c.028-1.064-.206-2.12-.564-3.118zm2.872 7.809-5.593 1.088c-1.037.202-1.815.53-2.334.968-.518.437-.85 1.052-1.009 1.871-.158.81-.136 1.803.097 3.01a.246.246 0 0 1 .005.029c.237 1.207.588 2.135 1.039 2.827.455.7.993 1.146 1.636 1.356.645.211 1.49.225 2.528.023l5.592-1.088-.277-1.427-5.458 1.062c-2.45.476-3.275-.813-3.696-3.019l-.005-.028c-.437-2.202-.155-3.707 2.295-4.184l5.458-1.061-.278-1.427zm3.068 17.02-10.348-4.425.121 1.675 3.212 1.362v.007l.394 5.44-2.981 1.811.121 1.675 9.602-5.87-.121-1.675zm-1.512.951-3.757 2.285-.29-4.004 4.047 1.72zm-170.615 24.917-1.451.382 1.604 6.092 1.45-.381zm164.531 0 1.45.382-1.603 6.092-1.45-.382zm-149.066 25.654-11.18 1.286.935 1.395 3.464-.409.004.006 3.039 4.53-1.692 3.05.936 1.395 5.43-9.858-.936-1.395zm-.842 1.576-2.13 3.846-2.237-3.333 4.367-.513zm5.122 4.533-7.127 6.665.952 1.018 6.006-5.617-3.151 8.67 1.091 1.167 8.612-2.614-5.898 5.516.951 1.017 7.127-6.664-1.445-1.546-8.751 2.614 3.276-8.469zm10.381 10.591-6.016 7.988 7.776 5.855.854-1.135-6.614-4.98 1.831-2.432 5.96 4.488.851-1.129-5.96-4.488 1.62-2.152 6.366 4.794.86-1.14-7.528-5.669zm9.784 7.161-4.71 8.823c.43.23.86.458 1.288.688l1.853-3.47c1.42.749 2.825 1.53 4.26 2.254.344 1.678.687 3.357 1.039 5.034l1.634.872-1.1-5.31c1.069.325 2.372.172 3.113-.74.63-.705 1.058-1.693.756-2.64-.351-1.303-1.634-1.985-2.717-2.617-1.803-.969-3.612-1.928-5.416-2.894zm.617 1.945c1.507.822 3.048 1.585 4.525 2.46.684.463 1.553 1.095 1.467 2.027-.076.818-.958 1.254-1.703 1.08-1.46-.241-2.69-1.111-3.99-1.76l-1.814-.969 1.515-2.838zm10.678 3.961-3.779 9.259 1.39.566 3.778-9.258zm9.018 3.115c-1.105-.367-2.167-.52-3.206-.455-1.034.065-1.917.369-2.649.915s-1.256 1.297-1.576 2.261a5.145 5.145 0 0 0-.156 2.699c.187.91.627 1.696 1.33 2.373.7.673 1.725 1.24 3.082 1.69 1.304.432 2.475.534 3.54.31 1.022-.214 1.864-.734 2.534-1.562l-1.301-.718c-1.306 1.556-2.868 1.178-4.495.652-2.5-.86-3.83-2.616-3.103-4.973.897-2.562 3.353-2.615 5.542-1.935 1.526.506 2.832 1.168 3.023 2.673l1.433.216c-.08-.902-.438-1.705-1.094-2.412-.69-.743-1.651-1.318-2.904-1.734zm10.054 2.251-6.54 9.16 1.662.24 2.019-2.845h.007l5.398.782 1.13 3.3 1.662.24-3.676-10.637-1.662-.24zm.605 1.68 1.426 4.16-3.973-.575 2.547-3.584zm22.836-1.609c-1.143.22-2.144.607-3.018 1.172-.87.563-1.492 1.26-1.863 2.094-.37.834-.46 1.746-.267 2.744a5.145 5.145 0 0 0 1.184 2.43c.609.703 1.377 1.172 2.322 1.418.94.245 2.11.236 3.515-.035 1.348-.26 2.418-.745 3.238-1.461.787-.688 1.267-1.554 1.445-2.603l-1.485.01c-.378 1.997-1.925 2.431-3.601 2.77-2.601.473-4.62-.408-5.14-2.819-.472-2.674 1.644-3.922 3.886-4.4 1.578-.305 3.041-.367 3.944.852l1.356-.513c-.512-.747-1.217-1.273-2.135-1.568-.965-.31-2.085-.341-3.381-.091zm6.678-1.183 2.844 9.587 9.331-2.769-.404-1.362-7.937 2.355-.866-2.918 7.153-2.122-.402-1.355-7.153 2.122-.766-2.582 7.64-2.267-.407-1.37-9.033 2.681zm10.818-3.4 4.198 9.076 1.252-.58-3.501-7.569c3.237 1.468 6.455 2.98 9.684 4.464.215.187.43.062.646-.053l1.259-.582-4.198-9.076-1.255.58 3.497 7.56c-3.324-1.507-6.63-3.054-9.946-4.577l-1.636.757zm10.981-5.158.783 1.19 3.572-2.35.136-.09.067.103 4.647 7.06 1.214-.799-4.647-7.06-.067-.103.138-.09 3.59-2.363-.784-1.19zm10.062-6.89 6.777 7.355 1.075-.99-2.666-2.892c1.176-1.095 2.376-2.163 3.532-3.279 1.698.228 3.396.457 5.095.678l1.362-1.255-5.376-.712c.66-.902.945-2.183.328-3.183-.468-.863-1.318-1.6-2.348-1.59-1.382-.031-2.444 1.012-3.422 1.854-1.452 1.337-2.905 2.678-4.357 4.014zm2.04.058c1.273-1.151 2.5-2.355 3.814-3.46.68-.514 1.64-1.16 2.496-.662.73.41.723 1.398.298 2.026-.756 1.27-1.975 2.147-3.018 3.163l-1.41 1.3-2.18-2.367zm9.594-11.702 4.473 10.327 1.064-1.3-1.396-3.197.004-.005 3.453-4.221 3.41.734 1.064-1.3-11.01-2.337-1.062 1.3zm1.752.349 4.3.923-2.543 3.107-1.757-4.03zm2.603-6.014 8.39 5.44 4.403-6.79-1.192-.772-3.522 5.431-.09.14-.106-.07-7.092-4.598z'/%3e%3cg clip-path='url(%23b)'%3e%3cpath fill='%23fff' d='m500.001 226.408-31.479 54.535-15.42 26.702H546.9l-14.714-25.484-32.184-55.753z'/%3e%3cg id='d'%3e%3cg id='c'%3e%3cpath fill='%2317c0eb' stroke='%2317c0eb' stroke-width='.129' d='m500.001 226.408-2.357 4.082 2.357 54.977 2.357-54.977z' opacity='.62'/%3e%3cpath fill='%23fff' d='m500.001 277.475-.134.003.134 3.111.134-3.111-.134-.003z'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='rotate(72 500.001 285.467)'/%3e%3cuse xlink:href='%23c' transform='rotate(144 500.001 285.467)'/%3e%3cuse xlink:href='%23c' transform='rotate(216 500.001 285.467)'/%3e%3cuse xlink:href='%23c' transform='rotate(288 500.001 285.467)'/%3e%3c/g%3e%3cuse xlink:href='%23d' transform='rotate(8 500.001 285.467)'/%3e%3cuse xlink:href='%23d' transform='rotate(16 500.001 285.467)'/%3e%3cuse xlink:href='%23d' transform='rotate(24 500.001 285.467)'/%3e%3cuse xlink:href='%23d' transform='rotate(32 500.001 285.467)'/%3e%3cuse xlink:href='%23d' transform='rotate(40 500.001 285.467)'/%3e%3cuse xlink:href='%23d' transform='rotate(48 500.001 285.467)'/%3e%3cuse xlink:href='%23d' transform='rotate(56 500.001 285.467)'/%3e%3cuse xlink:href='%23d' transform='rotate(64 500.001 285.467)'/%3e%3cpath fill='red' d='M500 265.844a44.236 44.236 0 0 0-28.969 10.75L456.375 302a44.728 44.728 0 0 0-.75 8.25h5.031c0-21.726 17.618-39.344 39.344-39.344 21.727 0 39.344 17.618 39.344 39.344h5.031c0-2.813-.25-5.582-.75-8.25l-14.656-25.406A44.249 44.249 0 0 0 500 265.844z'/%3e%3cpath fill='%23f60' d='M500 266.656c-11.764 0-22.44 4.675-30.281 12.25l-12.031 20.844a43.596 43.596 0 0 0-1.281 10.5h4.25c0-21.726 17.617-39.344 39.343-39.344 21.727 0 39.344 17.618 39.344 39.344h4.25c0-3.625-.447-7.164-1.281-10.531l-12.031-20.813c-7.841-7.574-18.518-12.25-30.282-12.25z'/%3e%3cpath fill='%23ff0' d='M500 267.469c-12.702 0-24.1 5.522-31.938 14.313l-8.718 15.093a42.733 42.733 0 0 0-2.125 13.375h3.437c0-21.726 17.618-39.344 39.344-39.344 21.726 0 39.344 17.618 39.344 39.344h3.437c0-4.673-.74-9.165-2.125-13.375l-8.719-15.095c-7.836-8.788-19.237-14.312-31.938-14.312z'/%3e%3cpath fill='%230f0' d='M500 268.25c-14.55 0-27.372 7.414-34.906 18.656l-2.813 4.875a41.818 41.818 0 0 0-4.282 18.47h2.657c0-21.727 17.617-39.345 39.343-39.345 21.727 0 39.344 17.618 39.344 39.344H542a41.824 41.824 0 0 0-4.28-18.437l-2.845-4.937c-7.536-11.227-20.337-18.625-34.875-18.625z'/%3e%3cpath fill='%230cf' d='M500 269.062c-22.747 0-41.188 18.44-41.188 41.188h1.844c0-21.727 17.618-39.344 39.344-39.344 21.726 0 39.344 17.617 39.344 39.344h1.844c0-22.748-18.44-41.188-41.188-41.188z'/%3e%3cpath fill='%2300f' d='M500 269.844c-22.306 0-40.375 18.1-40.375 40.406h1.344c0-21.56 17.472-39.031 39.031-39.031s39.031 17.472 39.031 39.031h1.375c0-22.306-18.1-40.406-40.406-40.406z'/%3e%3cpath fill='purple' d='M500.001 270.657c-21.864 0-39.589 17.725-39.589 39.589 0 .245.003.49.007.733h.801a35.827 35.827 0 0 1-.007-.733c0-21.422 17.366-38.788 38.788-38.788 21.422 0 38.788 17.366 38.788 38.788 0 .245-.002.49-.007.733h.797c.004-.243.007-.488.007-.733 0-21.864-17.721-39.589-39.585-39.589z'/%3e%3cpath fill='%23510000' d='M500.395 288.134c-.644-.124-1.226-.484-1.775-.61-.756.725-.835 1.457-.731 2.08.262.14.31.353.878.86s.496.773.462 1.965c-.015.503.07 1.581.579 1.682.548.11.932-.346 1.09-1.16.152-.79.417-1.216.698-1.702.306-1.852-.193-2.508-1.201-3.115z'/%3e%3cpath fill='red' d='M497.168 283.524c-.595.015-1.528 1.012-1.943.475-.239-.308-.279-.902-.037-1.4.559-1.151 1.124-1.716 2.167-2.33 2.378-1.401 3.89-.95 5.074 1.063 1.098 1.772 2.152 3.73 2.246 5.371.03.501.283 1.408-.156 1.86-1.348 1.39-4.596-1.435-6.497-.988-.64.15-1.377.617-1.98.218-.47-.31-.078-.997.272-1.294.612-.52 1.501-2.365 1.38-3.165-.067-.446-.08.179-.526.19z'/%3e%3cpath fill='url(%23e)' d='M496.927 282.548c-1.083.445-.966 1.076-1.51 1.59.154.058.766.31 1.364-.301.258-.214.548-.293.677-.362-.305.221-.523.554-.684.684-.404.329-1.034 1.083-1.34 1.846-.307.764-.43 1.673-.376 1.782.056.11.426.78 1.566 1.232 2.03.807 2.417 2.439 4.477 2.439 1.614 0 1.355-1.056 2.646-.832 1.12.194 1.714-.696.636-1.232-1.371-.468-4.092-.192-5.372.033-.414-4.083-.056-2.65-.152-4.405-.097-1.755-.623-1.86.072-3.281-.578.872-1.277.734-2.004.807z'/%3e%3cpath fill='%23ff2a2a' d='M500.938 279.795c-.04.223-.077.516-.056.6.087.339.175.693.278.994.115.336.162.58.24.928.082.36.401.5.694.722.37.28.084 1.037.315 1.069.184.025.488-1.072.49-1.247a3.8 3.8 0 0 0-.037-.647 15.3 15.3 0 0 0-.426-.872c-.002-.004-.007-.006-.009-.01a3.652 3.652 0 0 0-.194-.327 4.204 4.204 0 0 0-.786-.863l-.056-.047c-.084-.064-.17-.13-.259-.187-.062-.04-.129-.076-.194-.113z'/%3e%3cpath fill='url(%23f)' d='M501.249 287.398c-.718-.188-1.426-.543-2.037-.725-1.2-.359-2.48-1.134-3.366-.814-.317.14-.289.456-.39.91-.042.533-.596 1.32-.136 1.062.685-.383 2.49.733 3.095 1.106.287.177.892.524 1.082 1.022.19.498.092 1.756.041 2.296-.053.566.119 1.835.686 1.987.611.163 1.078-.323 1.316-1.23.23-.881.405-1.387.757-1.915s.756-.756 1.32-.863c.564-.106 1.382.462 1.382-.203 0-.437-.384-.855-.22-1.454.128-.472-.402-.378-.842-.572-1.036-.319-1.97-.42-2.688-.607z'/%3e%3cpath fill='%23910000' d='M498.363 288.902c-.327-.178-2.315-1.478-3.043-1.071-.23.128-.317-.016-.32-.257-.004-.241.109-.594.184-.866.074-.273.195-.792.516-1.062.687-.58 2.269.575 3.108.886-.072.436-.47 2.356-.445 2.37z'/%3e%3cpath fill='%23ff3a3a' d='M501.763 291.361c.916-1.603 1.508-1.397 2.613-1.374.369.008.477-.329.393-.667-.278.624-1.662-.07-2.415.263-1.573.692-1.28 3.77-2.027 4.07.776.651 1.124-1.746 1.436-2.292z'/%3e%3cg fill='url(%23g)'%3e%3cpath fill='%23fff' d='m453.103 307.645-9.955 17.237h113.708l-9.956-17.237h-93.797z'/%3e%3cg id='i'%3e%3cpath id='h' d='M449.705 321.364c-1.658 0-3.197.167-4.71.353l-.486.846c2.433-.216 4.697-.649 7.14-.709 3.293.08 6.283.83 9.786.83 1.518.014 3.027-.03 4.526 0 3.5 0 6.489-.75 9.783-.83 3.295.08 6.304.83 9.803.83 1.518.004 3.178-.024 4.53 0 3.5 0 6.474-.75 9.765-.83 3.293.08 6.27.83 9.769.83 1.53.014 3.033-.03 4.543 0 3.5 0 6.49-.75 9.787-.83 3.296.08 6.28.83 9.782.83 1.516.014 3.031-.03 4.53 0 3.499 0 6.475-.75 9.765-.83 2.55.062 4.92.518 7.486.724l-.515-.893c-1.403-.168-2.835-.321-4.368-.321-1.529-.02-3.036.03-4.547 0-3.5 0-6.474.748-9.765.829-3.296-.08-6.283-.829-9.786-.829-1.513-.02-3.03.031-4.526 0-3.5 0-6.493.749-9.786.829-3.294-.08-6.284-.829-9.783-.829-1.522-.02-3.042.03-4.547 0-3.5 0-6.476.749-9.765.829-3.294-.08-6.27-.829-9.769-.829-1.522-.021-3.026.031-4.526 0-3.502 0-6.49.749-9.786.829-3.294-.08-6.283-.829-9.783-.829-1.52-.02-3.043.031-4.547 0z'/%3e%3cuse xlink:href='%23h' y='-1.113'/%3e%3cuse xlink:href='%23h' y='-2.23'/%3e%3c/g%3e%3cuse xlink:href='%23i' y='-3.344'/%3e%3cuse xlink:href='%23i' y='-6.691'/%3e%3cpath d='m453.23 307.458-.123.215h93.79l-.124-.215H453.23zm-.219.377-.127.22h94.235l-.127-.22h-93.98zm-.2.346-.205.356h94.792l-.205-.356H452.81zm-.318.55-.25.434h95.518l-.25-.433h-95.018zm-.399.692-.25.434h96.316l-.25-.434h-95.816zm-.399.691-.247.43h97.107l-.247-.43h-96.613zm-.398.692-.25.43h97.91l-.25-.43h-97.41zm-.43.744-.304.53h98.877l-.303-.53h-98.27zm6.49.737c3.45.662 3.782 0 3.782 0zm81.503 0s.331.662 3.782 0z'/%3e%3c/g%3e%3cg fill='%23ccd11e'%3e%3cg id='k'%3e%3cpath fill='url(%23j)' d='M530.631 297.043c-1.709 0-2.232.862-2.232.862-2.736 10.576-11.807 21.333-22.6 21.333h-8.08v10.768c0 .003.01 0 .016 0h61.498l-6.187-10.954c-9.707-1.449-17.64-11.373-20.166-21.147 0 0-.54-.862-2.25-.862z'/%3e%3cpath fill='%2397c924' d='M530.631 297.465c-.784 0-1.26.18-1.538.355-.264.165-.315.276-.321.288 0 .007-.015.01-.018.016-1.4 5.323-4.352 10.669-8.334 14.707-4.012 4.07-9.07 6.83-14.605 6.83h-7.674v9.922h60.855l-5.68-10.058c-4.687-.612-8.973-3.163-12.458-6.694-3.986-4.038-6.932-9.384-8.334-14.707l-.017-.016c-.007-.012-.07-.105-.338-.271-.283-.176-.754-.372-1.538-.372z'/%3e%3cpath fill='%23ede71f' d='M530.63 297.465c.147 0 .28.021.406.034.024 3.017 0 8.11 0 10.801-.029 2.34-.83 4.223-2.012 6.441-.547 1.554-.986.963-2.35 2.857-1.83.654-3.186.909-5.138 1.216-2.517.398-8.121.75-10.887.136 3.641-1.068 6.961-3.27 9.771-6.12a30.57 30.57 0 0 0 2.13-2.4 33.663 33.663 0 0 0 3.01-4.48c.352-.626.686-1.248.997-1.893.467-.966.883-1.95 1.25-2.94.124-.331.245-.667.356-.998.222-.664.417-1.33.592-1.995.002-.006.015-.01.016-.017.006-.012.058-.122.321-.287.136-.085.332-.17.575-.237h.017c.252-.067.554-.118.946-.118z'/%3e%3cpath fill='%23c6cb24' d='M529.938 298.902c-.412 6.034-2.277 13.192-6.644 17.81-1.607 1.337-3.66 2.55-5.646 2.255 6.77-5.51 10.885-13.947 12.29-20.065z'/%3e%3cpath fill='%239ecb34' d='M524.494 309.281c-1.002 2.721-4.788 6.746-8.84 10.045-1.15.035-1.76.101-2.804.038 2.468-.225 8.221-5.083 11.644-10.083z'/%3e%3c/g%3e%3cuse xlink:href='%23k' x='-15.341'/%3e%3cg fill='%23c6cb24'%3e%3cpath fill='url(%23j)' d='M502.218 297.911c2.735 10.575 11.79 21.333 22.583 21.333h8.089v10.768c0 .003-.015 0-.017 0h-65.795c-.006 0-.017.003-.017 0v-10.768h8.072c10.792 0 19.863-10.758 22.6-21.333 0 0 .534-.866 2.243-.866s2.243.866 2.243.866z'/%3e%3cpath fill='%2397c924' d='M499.975 297.465c.784 0 1.255.196 1.538.372.269.166.332.259.339.27l.017.017c1.401 5.323 4.348 10.669 8.333 14.707 4.017 4.07 9.087 6.83 14.623 6.83h7.64v9.922h-64.98v-9.923h7.675c5.535 0 10.593-2.76 14.605-6.83 3.982-4.037 6.934-9.383 8.334-14.706.003-.007.015-.01.017-.016.006-.012.057-.123.32-.288.28-.174.755-.355 1.539-.355z'/%3e%3cpath fill='%23ede71f' d='M499.263 297.53a3.4 3.4 0 0 0-.242.055h-.018a2.184 2.184 0 0 0-.572.236c-.264.165-.314.274-.32.286-.003.006-.017.01-.018.017-.175.666-.37 1.333-.593 1.997a29.6 29.6 0 0 1-.356.995 34.21 34.21 0 0 1-1.249 2.942 34.21 34.21 0 0 1-.998 1.894 33.634 33.634 0 0 1-3.01 4.477 30.73 30.73 0 0 1-2.13 2.403c-2.81 2.85-6.128 5.05-9.769 6.117 2.765.615 4.032-.056 6.549-.454 1.952-.308 4.21-.563 6.043-1.217 1.364-1.894.899-1.3 1.446-2.854 1.181-2.218 2.906-4.222 3.334-6.681 1.619-3.022 1.903-8.614 1.903-10.213z'/%3e%3cpath d='M499.275 298.902c-.412 6.034-2.277 13.192-6.644 17.81-1.606 1.337-3.66 2.55-5.646 2.255 6.77-5.51 10.885-13.947 12.29-20.065z'/%3e%3cpath fill='%239ecb34' d='M493.832 309.281c-1.002 2.721-4.788 6.747-8.84 10.045-1.15.035-1.76.101-2.804.038 2.467-.225 8.222-5.083 11.644-10.083z'/%3e%3cpath fill='%23ede71f' d='M500.951 297.584h.018c.242.067.435.151.571.236.264.165.315.274.321.286.002.006.016.011.018.018.175.665.37 1.333.592 1.996.111.332.234.665.357.995.368.99.782 1.976 1.249 2.942.311.645.645 1.268.998 1.895a33.634 33.634 0 0 0 3.01 4.477 30.73 30.73 0 0 0 2.13 2.402c2.81 2.85 6.128 5.445 9.768 6.512-7.245.028-10.389-.63-13.022-4.016-2.633-3.387-3.606-4.868-4.14-6.937-.535-2.068-2.026-6.57-1.87-10.806z'/%3e%3cpath d='M501.476 298.902c.412 6.034 2.22 12.006 6.587 16.625 1.607 1.337 3.66 2.55 5.646 2.255-7.335-5.002-10.829-12.762-12.233-18.88z'/%3e%3c/g%3e%3cg id='l'%3e%3cpath fill='url(%23j)' d='M484.749 297.043c-1.71 0-2.248.862-2.248.862-2.523 9.747-11.825 22.318-21.497 23.811l-4.79 8.29h49.015v-11.348c-8.825-2.371-15.89-11.63-18.248-20.753 0 0-.523-.862-2.232-.862z'/%3e%3cpath fill='%2397c924' d='M484.749 297.465c-.784 0-1.255.196-1.538.372-.269.166-.332.259-.338.27l-.017.017c-1.402 5.323-4.678 10.705-8.08 14.99-3.402 4.283-9.72 8.617-14.042 9.076l-4.282 7.393h48.06V318.89c-3.554-1.091-6.8-3.267-9.552-6.06-3.982-4.037-6.934-9.383-8.334-14.706-.002-.007-.015-.01-.017-.016-.006-.012-.058-.123-.321-.288-.28-.174-.755-.355-1.539-.355z'/%3e%3cpath fill='%2393bc30' d='M483.445 298.903c-.617 9.043-5.653 20.454-11.34 22.42-1.855.64-5.099.864-6.227 1.008 9.948-4.731 15.828-15.853 17.567-23.428z'/%3e%3cpath fill='%23ede71f' d='M484.746 297.465c-.147 0-.28.021-.406.034-.023 3.017 0 8.11 0 10.801.03 2.34.831 4.223 2.012 6.441.069.194.136.354.203.49.41 1.086.713 1.463 2.282 2.654 4.987 3.787 11.17 4.353 14.808 4.04-1.14-.898-2.358-1.715-3.431-2.467 1.711-.056 3.35-.25 4.513-.508-3.64-1.067-6.96-3.27-9.77-6.12a30.523 30.523 0 0 1-1.403-1.554 34.487 34.487 0 0 0-.592-.812c-1.118-1.4-2.263-2.947-3.145-4.513a34.164 34.164 0 0 1-.997-1.894 34.023 34.023 0 0 1-1.606-3.938 31.676 31.676 0 0 1-.592-1.995c-.002-.006-.015-.01-.017-.017-.006-.012-.057-.122-.321-.287a2.207 2.207 0 0 0-.575-.237h-.017a3.614 3.614 0 0 0-.946-.118z'/%3e%3cpath d='M485.446 298.902c.412 6.034 2.277 13.192 6.644 17.81 1.606 1.337 3.66 2.55 5.646 2.255-6.77-5.51-10.886-13.947-12.29-20.065z'/%3e%3cpath fill='%239ecb34' d='M489.613 307.247c2.369 5.837 8.37 11.29 14.543 14.954 1.15.035 1.492.003 2.537-.06-4.419-2.371-11.539-5.754-17.08-14.894z'/%3e%3c/g%3e%3cuse xlink:href='%23l' x='-15.43' fill='%23c6cb24'/%3e%3c/g%3e%3cpath fill='%23fff' d='M556.5 324.692c-.574.203-4.421-.19-6.433-.044l-1.28.336c-1.123-.008-2.238.024-3.33 0-3.602 0-6.649.948-10.075.948-3.433 0-6.47-.948-10.075-.948-1.12-.008-2.234.025-3.33 0-3.602 0-6.647.948-10.076.948-3.43 0-6.473-.948-10.075-.948-1.131-.007-2.242.023-3.348 0-3.602 0-6.632.948-10.058.948-3.429 0-6.456-.948-10.058-.948-.267 0-.516.009-.776.017-.178-.004-.377-.017-.557-.017-.12 0-.222-.003-.34 0-.116-.003-.236 0-.355 0-.181 0-.345.013-.523.017-.26-.008-.511-.017-.78-.017-3.605 0-6.642.949-10.075.948-3.429 0-6.473-.948-10.075-.948-.262 0-.522.01-.776.017-.18-.004-.339-.017-.522-.017-.124 0-.252-.003-.374 0-.117-.003-.237 0-.356 0-.181 0-.362.013-.54.017-.26-.008-.509-.017-.776-.017-2.88 0-6.218.607-8.936.85l-6.273 10.858 62.972-.007 64.375.007z'/%3e%3cpath fill='url(%23a)' d='M547.993 323.111c-.2 0-.398 0-.596.007-3.24.095-5.564 1.115-11.2 1.115-5.638 0-6.219-1.019-12.584-.879-5.947.131-8.443 1.262-11.67 1.217-3.228-.044-8.473-.697-12.51-.275-4.037.423-8.828 1.284-11.973 1.291-3.909-.017-7.82-.73-11.906-.324-4.087.406-5.997 1.5-11.063 1.485-4.356-.013-9.083-.698-12.746-.695-3.435.003-7.267.957-10.086 1.443l-.843 1.464c2.247-.26 8.551-1.218 10.802-1.277 2.344-.061 10.717.483 15.335.325 4.618-.159 5.158-1.172 10.618-1.172 3.801 0 6.666.399 10.566.399 2.434 0 4.643-1.242 8.343-1.242.936-.027 1.865-.06 2.794-.091 3.119-.515 8.384.045 12.048.232 3.315.173 5.457-.615 8.914-.73 1.496-.068 2.998-.066 4.474-.148 3.46-.115 6.422.64 9.68.624 3.25-.2 6.403-.922 9.86-1.037 1.511-.071 2.998-.072 4.49-.148 2.287-.076 5.837.078 8.273.501l-.84-1.45c-2.379-.076-5.311-.635-8.18-.635z'/%3e%3cg id='n'%3e%3cpath id='m' fill='url(%23a)' d='M450.312 334.748c-3.457 0-6.402.853-9.652.945-1.21-.033-2.367-.183-3.535-.345l-.49.85c.486.032.975.063 1.488.063 1.502.018 2.99-.036 4.474 0 3.457 0 6.382-.852 9.634-.945 3.254.092 6.206.945 9.666.945 1.501.019 2.993-.036 4.474 0 3.457 0 6.412-.853 9.666-.945 3.256.092 6.23.945 9.687.945 1.495.018 2.993-.036 4.47 0 3.457 0 6.401-.853 9.652-.945 3.253.092 6.191.945 9.649.945 1.512.019 2.999-.036 4.49 0 3.458 0 6.41-.853 9.667-.945 3.257.092 6.21.945 9.67.945 1.495.018 2.991-.036 4.47 0 3.456 0 6.4-.853 9.651-.945 3.253.092 6.21.945 9.666.945 1.5.018 2.996-.036 4.474 0 .605 0 1.196-.034 1.778-.077l-.463-.797c-1.064.144-2.133.276-3.235.306-3.254-.092-6.195-.945-9.652-.945-1.51-.02-2.997.03-4.49 0-3.458 0-6.397.853-9.649.945-3.257-.091-6.206-.945-9.666-.945-1.496-.02-2.993.03-4.473 0-3.458 0-6.413.853-9.667.945-3.254-.092-6.209-.945-9.666-.945-1.503-.02-3.003.03-4.49 0-3.458 0-6.4.853-9.65.945-3.253-.092-6.194-.945-9.651-.945-1.506-.02-2.99.03-4.474 0-3.46 0-6.409.854-9.666.945-3.254-.092-6.208-.945-9.666-.945-1.502-.02-3.006.03-4.49 0z'/%3e%3cuse xlink:href='%23m' y='-1.289'/%3e%3cuse xlink:href='%23m' y='-2.575'/%3e%3c/g%3e%3cuse xlink:href='%23n' y='-3.867'/%3e%3cuse xlink:href='%23n' y='-7.729'/%3e%3cpath fill='%2397c924' d='m443.846 324.705-2.427 4.191c2.839-.47 7.102-1.703 10.634-1.706 3.663-.003 8.082.903 12.438.916 5.066.014 6.976-1.079 11.063-1.485 4.086-.407 7.998.527 11.906.545 3.145-.007 7.936-1.09 11.973-1.512 4.037-.422 7.737.293 12.603.369 4.866.075 5.63-1.18 11.576-1.31 6.366-.141 6.947.877 12.584.877 4.242.229 7.883-.854 11.666-1.121 3.784-.268 5.539.043 8.305.109l-1.838-3.253c-.03 0-.06.003-.092.004l-101.246 2.226z'/%3e%3cpath fill='%23fff' d='M550.067 324.648s2.71.148 3.847.276a91.39 91.39 0 0 0 2.955.253l-.37-.485c-.573.203-4.42-.19-6.432-.044z'/%3e%3c/g%3e%3cpath fill='%23c8a400' d='m500 224.874-32.142 55.686L435 337.459l64.298-.007 65.702.007-32.153-55.683L500 224.874zm0 3.002 31.55 54.652 30.85 53.428-63.102-.004-61.701.004 31.56-54.645z'/%3e%3c/svg%3e";
            },
            6829: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9 6'%3e%3cpath fill='%2321468B' d='M0 0h9v6H0z'/%3e%3cpath fill='%23FFF' d='M0 0h9v4H0z'/%3e%3cpath fill='%23AE1C28' d='M0 0h9v2H0z'/%3e%3c/svg%3e";
            },
            2888: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1100 800'%3e%3cpath fill='%23ef2b2d' d='M0 0h1100v800H0z'/%3e%3cpath fill='%23fff' d='M300 0h200v800H300z'/%3e%3cpath fill='%23fff' d='M0 300h1100v200H0z'/%3e%3cpath fill='%23002868' d='M350 0h100v800H350z'/%3e%3cpath fill='%23002868' d='M0 350h1100v100H0z'/%3e%3c/svg%3e";
            },
            8556: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-17.582 -4.664 71.571 87.246'%3e%3cuse xlink:href='%23a' stroke='%23003893' stroke-width='5.165'/%3e%3cpath id='a' fill='%23DC143C' d='M-15 37.574h60L-15 0v80h60l-60-60z'/%3e%3cg fill='%23fff'%3e%3cpath d='M-11.95 23.483a12.84 12.84 0 0 0 23.9 0 11.95 11.95 0 0 1-23.9 0'/%3e%3cg transform='translate(0 29.045) scale(5.56106)'%3e%3ccircle r='1'/%3e%3cg id='d'%3e%3cg id='c'%3e%3cpath id='b' d='M.195-.98 0-1.39l-.195.408' transform='rotate(11.25)'/%3e%3cuse xlink:href='%23b' transform='rotate(22.5)'/%3e%3cuse xlink:href='%23b' transform='rotate(45)'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='rotate(67.5)'/%3e%3c/g%3e%3cuse xlink:href='%23d' transform='scale(-1 1)'/%3e%3c/g%3e%3cg transform='translate(0 58.787) scale(8.1434)'%3e%3ccircle r='1'/%3e%3cg id='g'%3e%3cg id='f'%3e%3cpath id='e' d='M.259.966 0 1.576l-.259-.61'/%3e%3cuse xlink:href='%23e' transform='rotate(180)'/%3e%3c/g%3e%3cuse xlink:href='%23f' transform='rotate(90)'/%3e%3c/g%3e%3cuse xlink:href='%23g' transform='rotate(30)'/%3e%3cuse xlink:href='%23g' transform='rotate(60)'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";
            },
            5649: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 300'%3e%3cpath fill='%23002b7f' d='M0 0h600v300H0z'/%3e%3cpath fill='%23ffc61e' d='M0 137.5h600v25H0z'/%3e%3cpath fill='%23fff' d='m150 262.5-6.47-25.852L125 255.801l7.322-25.623L106.7 237.5l19.153-18.53L100 212.5l25.852-6.47-19.153-18.53 25.623 7.322L125 169.2l18.53 19.153L150 162.5l6.47 25.852L175 169.199l-7.322 25.623L193.3 187.5l-19.153 18.53L200 212.5l-25.852 6.47 19.153 18.53-25.623-7.322L175 255.8l-18.53-19.153L150 262.5z'/%3e%3c/svg%3e";
            },
            7923: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 120 60'%3e%3cclipPath id='a'%3e%3cpath d='M0 0v15h70v15H60zm0 30v10h30V0h30z'/%3e%3c/clipPath%3e%3cpath fill='%23012169' d='M0 0h120v60H0z'/%3e%3cg stroke='%23c8102e' stroke-width='6'%3e%3cpath stroke='%23fff' d='m0 0 60 30m0-30L0 30'/%3e%3cpath stroke-width='4' d='m0 0 60 30m0-30L0 30' clip-path='url(%23a)'/%3e%3cpath stroke='%23fff' stroke-width='10' d='M30 0v40M0 15h70'/%3e%3cpath d='M30 0v40M0 15h70'/%3e%3c/g%3e%3cpath fill='%23fedd00' d='M60 0h60v60H0V30h60z'/%3e%3cg transform='translate(30 15)'%3e%3cg transform='scale(5.1039)'%3e%3ccircle r='1' fill='%23012169'/%3e%3cpath id='b' fill='%23fedd00' d='m0-513674 301930 929245-790463-574305h977066l-790463 574305' transform='scale(0)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='matrix(3 0 0 3 -17.5 .29)'/%3e%3cuse xlink:href='%23b' transform='matrix(3 0 0 3 17.5 .29)'/%3e%3cuse xlink:href='%23b' transform='matrix(3 0 0 3 0 10.29)'/%3e%3cuse xlink:href='%23b' transform='matrix(3 0 0 3 0 -9.71)'/%3e%3c/g%3e%3c/svg%3e";
            },
            1606: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1200 600'%3e%3cdefs%3e%3cclipPath id='b'%3e%3cpath d='M0 0h600v300H0z'/%3e%3c/clipPath%3e%3cclipPath id='c'%3e%3cpath d='m0 0 300 150H0zm300 0h300L300 150zm0 150h300v150zm0 0v150H0z'/%3e%3c/clipPath%3e%3cg id='d'%3e%3cg id='a'%3e%3cpath d='M0-.325v.5l1-.5z'/%3e%3cpath d='m.19.263-.293-.405L1-.325z'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='scale(-1 1)'/%3e%3cuse xlink:href='%23a' transform='rotate(72 0 0)'/%3e%3cuse xlink:href='%23a' transform='rotate(-72 0 0)'/%3e%3cuse xlink:href='%23a' transform='scale(-1 1) rotate(72)'/%3e%3c/g%3e%3c/defs%3e%3cpath fill='%23012169' d='M0 0h1200v600H0z'/%3e%3cpath stroke='%23FFF' stroke-width='60' d='m0 0 600 300M0 300 600 0' clip-path='url(%23b)'/%3e%3cpath stroke='%23C8102E' stroke-width='40' d='m0 0 600 300M0 300 600 0' clip-path='url(%23c)'/%3e%3cpath stroke='%23FFF' stroke-width='100' d='M300 0v300M0 150h600' clip-path='url(%23b)'/%3e%3cpath stroke='%23C8102E' stroke-width='60' d='M300 0v300M0 150h600' clip-path='url(%23b)'/%3e%3cuse xlink:href='%23d' fill='%23FFF' transform='matrix(45.4 0 0 45.4 900 120)'/%3e%3cuse xlink:href='%23d' fill='%23C8102E' transform='matrix(30 0 0 30 900 120)'/%3e%3cg transform='rotate(82 900 240)'%3e%3cuse xlink:href='%23d' fill='%23FFF' transform='rotate(-82 519.022 -457.666) scale(40.4)'/%3e%3cuse xlink:href='%23d' fill='%23C8102E' transform='rotate(-82 519.022 -457.666) scale(25)'/%3e%3c/g%3e%3cg transform='rotate(82 900 240)'%3e%3cuse xlink:href='%23d' fill='%23FFF' transform='rotate(-82 668.57 -327.666) scale(45.4)'/%3e%3cuse xlink:href='%23d' fill='%23C8102E' transform='rotate(-82 668.57 -327.666) scale(30)'/%3e%3c/g%3e%3cuse xlink:href='%23d' fill='%23FFF' transform='matrix(50.4 0 0 50.4 900 480)'/%3e%3cuse xlink:href='%23d' fill='%23C8102E' transform='matrix(35 0 0 35 900 480)'/%3e%3c/svg%3e";
            },
            268: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1200 600'%3e%3cpath fill='%23db161b' d='M0 0h1200v600H0z'/%3e%3cpath fill='%23fff' d='M300 0h900v200H300z'/%3e%3cpath fill='green' d='M300 400h900v200H300z'/%3e%3cg id='a' fill='%23fff' fill-rule='evenodd' stroke='%23db161b' stroke-width='.352'%3e%3crect width='38.669' height='21.217' x='65.854' y='102.64' stroke-width='.378' rx='3.215' ry='3.015'/%3e%3crect width='36.686' height='19.449' x='66.846' y='103.52' rx='3.05' ry='2.764'/%3e%3cpath stroke-width='.222' d='m83.904 108.83 1.853.06.084.84 1.516.77 1.18-.96 1.431.77-1.347.84.337 1.16 1.684-.06v1.55l-1.347-.07-.674.97 1.516 1.1-1.179.9-1.264-.97-1.853.39.084 1.42-2.021.13-.253-1.36-1.684-.71-.927.97-1.432-.71.843-1.1-1.011-.71h-1.432l-.084-2 1.432.13 1.01-1.16-1.179-.9 1.516-1.04 1.095.84 1.853-.25.253-.84z'/%3e%3cellipse cx='68.944' cy='426.78' stroke-width='1pt' rx='11.049' ry='9.944' transform='matrix(.18418 0 0 .1752 71.766 38.246)'/%3e%3cpath d='m71.803 104.41-2.974 2.65m4.957-2.65-2.974 2.65m4.957-2.65-2.974 2.65m4.957-2.65-2.974 2.65m4.957-2.65-2.974 2.65m4.957-2.65-2.974 2.65m4.958-2.65-2.975 2.65m4.958-2.65-2.975 2.65m4.958-2.65-2.975 2.65m4.958-2.65-2.975 2.65m4.958-2.65-2.975 2.65m4.958-2.65-2.975 2.65m-4.957-2.65-2.975 2.65m12.89-2.65-2.975 2.65m4.958-2.65-2.975 2.65m4.958-2.65-2.975 2.65m4.959-2.65-2.976 2.65m0-2.65 2.976 2.65m-4.959-2.65 2.975 2.65m-4.958-2.65 2.975 2.65m-4.958-2.65 2.975 2.65m-4.958-2.65 2.975 2.65m-4.958-2.65 2.975 2.65m-4.958-2.65 2.975 2.65m-4.958-2.65 2.975 2.65m-4.958-2.65 2.975 2.65m-4.958-2.65 2.975 2.65m-4.958-2.65 2.975 2.65m-4.958-2.65 2.974 2.65m4.958-2.65 2.975 2.65m-12.89-2.65 2.974 2.65m-4.957-2.65 2.974 2.65m-4.957-2.65 2.974 2.65m-4.957-2.65 2.974 2.65m0 12.37-2.974 2.66m4.957-2.66-2.974 2.66m4.957-2.66-2.974 2.66m4.957-2.66-2.974 2.66m4.957-2.66-2.974 2.66m4.957-2.66-2.974 2.66m4.958-2.66-2.975 2.66m4.958-2.66-2.975 2.66m4.958-2.66-2.975 2.66m4.958-2.66-2.975 2.66m4.958-2.66-2.975 2.66m4.958-2.66-2.975 2.66m-4.957-2.66-2.975 2.66m12.89-2.66-2.975 2.66m4.958-2.66-2.975 2.66m4.958-2.66-2.975 2.66m4.959-2.66-2.976 2.66m0-2.66 2.976 2.66m-4.959-2.66 2.975 2.66m-4.958-2.66 2.975 2.66m-4.958-2.66 2.975 2.66m-4.958-2.66 2.975 2.66m-4.958-2.66 2.975 2.66m-4.958-2.66 2.975 2.66m-4.958-2.66 2.975 2.66m-4.958-2.66 2.975 2.66m-4.958-2.66 2.975 2.66m-4.958-2.66 2.975 2.66m-4.958-2.66 2.974 2.66m4.958-2.66 2.975 2.66m-12.89-2.66 2.974 2.66m-4.957-2.66 2.974 2.66m-4.957-2.66 2.974 2.66m-4.957-2.66 2.974 2.66'/%3e%3c/g%3e%3cuse xlink:href='%23a' x='-300' transform='scale(-1 1)'/%3e%3cg id='b' stroke='%23db161b'%3e%3cpath fill='%23fff' fill-rule='evenodd' stroke-width='.565' d='M126.51 147.12c-48.114 47.05-68.638 53-59.006 56.79s40.616-20.49 72.856-52.75c32.24-32.25 51.98-60.956 42.35-64.747-9.63-3.792-5.03 10.662-56.2 60.707z'/%3e%3cpath fill='%23fff' fill-rule='evenodd' stroke-width='.33' d='m86.008 181.31 16.852 4.42c-15.861 15.03-33.708 21.22-38.665 18.57-4.958-2.65 8.923-8.84 21.813-22.99z'/%3e%3cpath fill='%23fff' fill-rule='evenodd' stroke-width='.33' d='m86.008 183.08 13.881 3.54c-15.453 14.45-30.737 18.56-34.692 16.8-3.977-1.77 8.255-6.74 20.811-20.34z'/%3e%3cpath fill='none' stroke-width='.33' d='M137.79 145.06c-.04.23-.15 1.24-.25 1.64 0 .56-.06.98-.12 1.42-.16.38-.13.73-.62.87-.33.46-.54.58-.98.77-.3.23-.76.46-1.24.65-.49.19-.94.21-1.47.11-.44-.27-.75-.54-1.11-.76-.09-.35-.16-.86-.25-1.2.13.35.23.91.25 1.41-.05.55-.25.79-.49 1.2m1.72 1.2c-.04-.03-.08-.07-.12-.11.29.26.17.14-.5-.21-.47-.22-.98-.34-1.6-.44h-1.72c-.67 0-1.12.09-1.6.22-.35.31-.87.48-1.23.76-.38.23-.54.5-.74.87-.34.3-.56.76-.87.99-.13.5-.42.48-.61.87.58.04 1.05.11 1.35.43.52.24-.43-.23-.61-.43-.41-.11-.51-.22-1.11-.22-.56-.16-.9.13-1.48.22-.33.17-.43.22-.86.22m5.05 2.29c-.25.01-1.4.2-1.85 0-.5-.12-.8-.36-1.11-.77-.15-.29 0 .53 0 .88-.05.64-.27.65-.61 1.09-.36.2-.74.49-1.11.65-.31.24-.69.4-1.11.55-.37.15-.81.31-1.11.54-.41.26-.37.58-.61.98.04.54.14.84.49 1.1.14.36.47.73.74.98.3.5.64.73-.13.87-.42.16-.65.03-1.1 0m-.25.76c-.3-.06-1.38-.38-1.85-.54h-1.72c-.67.04-.8.22-1.36.43-.36.33-.61.56-1.11.77-.26.3-.78.81-.98 1.2-.15.37-.25.87-.25 1.42.01.63.2.74.25 1.31.14.46.36.89.74 1.3.05.14.09.18.24.22m.17 1.43c-.05 0-.17.28-.35.52-.39.4-.44.43-1.05.43-.54-.02-.49-.21-.87-.35-.18-.27-.41-.49-.61-.86-.14-.22-.27-.57-.44-.77-.16-.26-.36-.45-.53-.69-.16-.07-.22-.14-.43-.17.5.08.54.25.87.51.15.25.31.5.44.78.05.37.17.66.17 1.12 0 .47 0 .81-.17 1.2-.21.22-.36.44-.61.61-.21.19-.46.45-.62.68-.27.17-.47.31-.78.52-.27.15-.55.31-.96.35-.52-.04-.67-.18-1.05-.35-.33-.24-.59-.39-.88-.6-.23-.16-.46-.47-.61-.69-.47-.12-.77-.07-1.05.17-.24.16-.45.37-.61.6-.15.07-.38.28-.53.35m1.04.2c.14.06.64.41.87.54.14.45.36.7.43 1.18.12.47.11.98.11 1.51-.12.55-.35.95-.54 1.39-.35.24-.52.4-.98.65-.43.06-.86.11-1.41.11-.34.11-.98.16-1.31 0-.48-.07-.843-.26-1.194-.43-.402-.23-.649-.44-1.088-.65-.213-.31-.544-.59-.869-.97-.271-.36-.47-.56-.653-.96.161.46.405.86.544 1.29.247.45.391.62.435 1.18.151.45.109.99.109 1.5-.048.35-.073 1.01-.218 1.29v.33m-10.314 1.71v.16c0-.42-.011-.21.175.62.33.37 1.104.47 1.749.31.566-.41.548-.73 1.574-.93.991.06 1.369.32 1.924.62.658.29.962.44 1.399 1.09.217.53.338.89-.35 1.09-.547.35-1.197.54-1.924.63-.808 0-1.39-.09-1.749.31-.555.51-.524.82-.524 1.71-.187.28-.224 1.1-.35 1.41-.486.2-.771.31-1.574.31-.189-.48-.398-1.35-.525-1.87-.137-.56-.179-1.34-.525-1.72a4.51 4.51 0 0 0-1.224-1.09c-.214-.27-.622-.49-1.049-.62.686.31.784.65.874 1.4-.603.27-.764.46-1.749.47-.968-.07-1.202-.29-1.574-.78-.067.78-.348 1.04-.524 1.72-.36.47-.513.95-.875 1.55.154.76.486.79.525 1.72.227.61.202 1.19.699 1.56.222.24.388.29.875.31-1.013 0-1.603-.1-2.274-.47-.519-.28-.911-.64-1.399-.93-.619-.4-1.384-.77-2.099-.94-.808 0-1.39-.08-1.749.31-.495.32-.828.86-1.049 1.56-.162.81-.224 1.35.175 1.87.296.61.363.84 0 1.56-.407.51-1.012.57-1.924.78a6.678 6.678 0 0 1-1.749-.31'/%3e%3cpath fill='%23fff' fill-rule='evenodd' stroke-width='.447' d='M181.41 104.66c21.35-36.858 35.52-68.222 31.62-70.014-3.89-1.791-24.37 26.665-45.72 63.518l14.1 6.496z'/%3e%3cpath fill='%23fff' fill-rule='evenodd' stroke-width='.393' d='M180 104.01c20.59-35.557 34.78-65.574 31.67-67.007s-22.35 26.258-42.95 61.81'/%3e%3cpath fill='%23fff' fill-rule='evenodd' stroke-width='.446' d='M176.46 85.461c-2.51 4.157-5.16 8.908-7.74 13.352L180 104.01c2.57-4.448 5.38-9.13 7.73-13.356l-11.27-5.193z'/%3e%3cpath fill='%23fff' fill-rule='evenodd' stroke-width='.446' d='M177.41 86.895c-2.5 4.157-4.25 7.338-6.82 11.782l8.45 3.893c2.58-4.442 4.48-7.554 6.83-11.78l-8.46-3.895z'/%3e%3cpath fill='%23fff' stroke-width='.447' d='M-205.69 6.559h6.207v9.985h-6.207z' transform='matrix(-.90832 -.41827 -.50125 .8653 0 0)'/%3e%3cpath fill='%23fff' fill-rule='evenodd' stroke-width='.446' d='m183.55 91.712-10.64 6.043m5.63 2.595-.63-11.235m31.12-41.388-5.64-2.597'/%3e%3ccircle cx='545.67' cy='92.126' r='3.543' fill='%23db161b' stroke-width='1pt' transform='matrix(-.449 .1132 .10134 .39387 444.347 -55.798)'/%3e%3c/g%3e%3cuse xlink:href='%23b' x='-300' transform='scale(-1 1)'/%3e%3cpath fill='%23fff' fill-rule='evenodd' stroke='%23db161b' stroke-width='.407' d='M135.26 84.958c0 30.942.18 42.602-2.1 44.202-2.16 1.71-62.348 0-62.348 8.84s49.578 17.68 64.448 17.68c19.83 0 29.75-8.84 29.75-26.52V84.958h-29.75z'/%3e%3cpath fill='%23fff' fill-rule='evenodd' stroke='%23db161b' stroke-width='.352' d='M135.26 93.798v4.42a100.628 100.628 0 0 0 29.75 0v-4.42a100.628 100.628 0 0 1-29.75 0zm0-8.84v4.42a100.695 100.695 0 0 0 29.75 0v-4.42a100.695 100.695 0 0 1-29.75 0z'/%3e%3cpath fill='%23fff' fill-rule='evenodd' stroke='%23db161b' stroke-width='.352' d='M135.26 89.378v4.42a100.628 100.628 0 0 0 29.75 0v-4.42a100.695 100.695 0 0 1-29.75 0zm0 8.84v4.422c9.92 1.47 19.83 1.47 29.75 0v-4.422a100.628 100.628 0 0 1-29.75 0z'/%3e%3cellipse cx='256.89' cy='210.83' fill='%23fff' stroke='%23db161b' stroke-width='4.463' rx='8.858' ry='26.575' transform='matrix(.15263 0 0 .03588 97.403 84.326)'/%3e%3cellipse cx='292.32' cy='246.26' fill='%23fff' stroke='%23db161b' stroke-width='4.463' rx='8.858' ry='26.575' transform='matrix(.15263 0 0 .03588 97.403 83.53)'/%3e%3cellipse cx='327.76' cy='263.98' fill='%23fff' stroke='%23db161b' stroke-width='4.463' rx='8.858' ry='26.575' transform='matrix(.15263 0 0 .03588 97.403 83.372)'/%3e%3cellipse cx='363.19' cy='263.98' fill='%23fff' stroke='%23db161b' stroke-width='4.463' rx='8.858' ry='26.575' transform='matrix(.15263 0 0 .03588 97.403 83.372)'/%3e%3cellipse cx='398.62' cy='246.26' fill='%23fff' stroke='%23db161b' stroke-width='4.463' rx='8.858' ry='26.575' transform='matrix(.15263 0 0 .03588 97.403 83.53)'/%3e%3cellipse cx='434.06' cy='210.83' fill='%23fff' stroke='%23db161b' stroke-width='4.463' rx='8.858' ry='26.575' transform='matrix(.15263 0 0 .03588 97.403 84.326)'/%3e%3cpath fill='%23fff' fill-rule='evenodd' stroke='%23db161b' stroke-width='.352' d='m135.26 107.06 29.75 23.87m-26.78-23.87 26.78 21.21m-22.81-20.33 22.81 17.68m-19.83-17.68 19.83 15.03m-16.86-15.03 16.86 12.38m-13.89-12.38 13.89 9.73m-10.91-9.73 10.91 7.07m-7.94-7.07 7.94 5.31m-4.96-5.31 4.96 3.54m-1.99-3.54 1.99 1.77m-29.75 0 29.75 23.87m0-26.52-32.72 26.52m29.74-26.52-28.75 22.98m24.79-22.1-22.81 17.68m19.83-17.68-19.83 15.03m16.86-15.03-16.86 12.38m13.88-12.38-13.88 9.73m10.91-9.73-10.91 7.07m7.93-7.07-7.93 5.31m4.96-5.31-4.96 3.54m1.98-3.54-1.98 1.77m29.75 0-32.72 26.52m32.72-23.87-32.72 26.52m32.72-23.87-32.72 26.53m32.72-23.87-32.72 26.52m32.72-23.87-32.72 26.52m32.72-23.87-32.72 26.52m32.72-23.87-32.72 26.52m32.72-23.86-32.72 26.52m32.72-23.87-30.74 24.75m30.74-22.1-27.77 22.1m26.77-18.56L142.2 154.8m20.82-14.15-17.84 14.15m15.86-9.73-8.92 7.07m-16.86-39.78 28.75 22.99m-28.75-20.34L164.01 138m-28.75-20.33 27.76 22.1m-27.76-19.45 27.76 22.1m-27.76-19.45 26.77 21.22m-27.76-19.45 26.77 21.22m-26.77-18.57 24.79 19.45m-25.78-17.68 24.79 19.45m-25.78-17.68 23.79 18.56m-23.79-15.91 22.8 17.68m-22.8-15.03 19.83 15.91m-16.86-49.5v4.42c9.92 1.47 19.83 1.47 29.75 0v-4.42c-9.92 1.47-19.83 1.47-29.75 0zm-2.97 36.24 17.84 14.15m-17.84-11.49 15.86 12.37m-15.86-9.72 13.88 10.61m-13.88-7.96 9.91 7.96m-9.91-5.31 7.93 6.19m-7.93-3.54 4.95 3.54'/%3e%3cellipse cx='256.89' cy='210.83' fill='%23fff' stroke='%23db161b' stroke-width='4.463' rx='8.858' ry='26.575' transform='matrix(.15263 0 0 .03588 97.403 97.586)'/%3e%3cellipse cx='292.32' cy='246.26' fill='%23fff' stroke='%23db161b' stroke-width='4.463' rx='8.858' ry='26.575' transform='matrix(.15263 0 0 .03588 97.403 96.791)'/%3e%3cellipse cx='327.76' cy='263.98' fill='%23fff' stroke='%23db161b' stroke-width='4.463' rx='8.858' ry='26.575' transform='matrix(.15263 0 0 .03588 97.403 96.632)'/%3e%3cellipse cx='363.19' cy='263.98' fill='%23fff' stroke='%23db161b' stroke-width='4.463' rx='8.858' ry='26.575' transform='matrix(.15263 0 0 .03588 97.403 96.632)'/%3e%3cellipse cx='398.62' cy='246.26' fill='%23fff' stroke='%23db161b' stroke-width='4.463' rx='8.858' ry='26.575' transform='matrix(.15263 0 0 .03588 97.403 96.791)'/%3e%3cellipse cx='434.06' cy='210.83' fill='%23fff' stroke='%23db161b' stroke-width='4.463' rx='8.858' ry='26.575' transform='matrix(.15263 0 0 .03588 97.403 97.586)'/%3e%3cpath fill='%23fff' fill-rule='evenodd' stroke='%23db161b' stroke-width='.352' d='m92.625 148.61 35.695-18.57m-37.678 17.68 33.708-17.68m-34.699 15.92 30.739-15.92m-31.731 14.15 26.771-14.15m-28.754 12.38 24.784-12.38m-23.792 9.73 16.852-8.84M86.676 138l12.89-7.07m-12.89 4.42 8.924-4.42m0 18.56 33.71-17.68m-30.736 18.57 31.726-16.8m-28.75 17.68 29.74-15.91m-26.77 16.79 24.79-13.26m-20.82 13.26 21.81-11.49m-18.84 12.38 18.84-9.73m-15.86 10.61 14.87-7.95m-10.91 7.95 11.9-6.19m-7.93 7.08 7.93-4.42m-3.96 4.42 4.95-2.66m1.99-22.98h-4.96a71.66 71.66 0 0 0 0 26.52h4.96a71.236 71.236 0 0 1 0-26.52zm-58.502 12.38 11.898-8.84m-11.898 2.65 11.898 10.61'/%3e%3cpath fill='%23fff' fill-rule='evenodd' stroke='%23db161b' stroke-width='.251' d='m92.625 130.93-5.949.88c-1.322 5.6-1.322 10.31 0 15.91l5.949 1.77c-1.322-5.6-1.322-12.96 0-18.56z'/%3e%3cpath fill='%23fff' fill-rule='evenodd' stroke='%23db161b' stroke-width='.431' d='M164.97 86.726v-4.457c-4.45.037-7.43-2.615-7.43-5.305l-14.85.037c0 2.653-2.97 5.305-7.43 5.305v4.42h29.71z'/%3e%3cpath fill='%23fff' stroke='%23db161b' stroke-width='.364' d='M143.75 71.697h12.734v5.304H143.75zm1.06-5.304h10.612v5.304H144.81zm0-5.304h10.612v5.304H144.81z'/%3e%3cpath fill='%23fff' stroke='%23db161b' stroke-width='.364' d='M145.87 54.017h8.489v7.072h-8.489z'/%3e%3cpath fill='%23fff' stroke='%23db161b' stroke-width='.38' d='M145.51 47.829h9.221v6.188h-9.221z'/%3e%3cellipse cx='237.4' cy='161.22' fill='%23fff' stroke='%23db161b' stroke-width='1pt' rx='42.52' ry='33.661' transform='matrix(.28916 0 0 .2495 81.983 1.86)'/%3e%3cpath fill='%23fff' fill-rule='evenodd' stroke='%23db161b' stroke-width='.358' d='M156.78 41.64c0 2.319 3.07 6.189 3.07 6.189-2.23 1.52-5.83 2.652-9.22 2.652s-7.62-.631-9.22-2.652c0 0 3.07-3.87 3.07-6.189 0-2.318-3.07-5.304-3.07-5.304 2.22-1.52 5.83-2.652 9.22-2.652s6.99 1.132 9.22 2.652c0 0-3.07 2.986-3.07 5.304z'/%3e%3cpath fill='%23fff' fill-rule='evenodd' stroke='%23db161b' stroke-width='.358' d='M154.73 41.64c0 2.319 3.07 7.073 3.07 7.073-2.22 1.52-3.78 1.768-7.17 1.768s-5.57.253-7.17-1.768c0 0 3.07-4.754 3.07-7.073 0-2.318-3.07-6.188-3.07-6.188 2.22-1.52 3.78-1.768 7.17-1.768s4.95.248 7.17 1.768c0 0-3.07 3.87-3.07 6.188z'/%3e%3ccircle cx='194.88' cy='166.54' r='10.63' fill='%23fff' stroke='%23db161b' stroke-width='1pt' transform='matrix(.28916 0 0 .2495 81.983 .975)'/%3e%3ccircle cx='194.88' cy='166.54' r='10.63' fill='%23fff' stroke='%23db161b' stroke-width='1pt' transform='matrix(.28916 0 0 .2495 106.572 .975)'/%3e%3ccircle cx='194.88' cy='166.54' r='10.63' fill='%23fff' stroke='%23db161b' stroke-width='1pt' transform='matrix(.28916 0 0 .2495 94.278 .975)'/%3e%3ccircle cx='194.88' cy='166.54' r='10.63' fill='%23fff' stroke='%23db161b' stroke-width='1pt' transform='matrix(.28916 0 0 .2495 94.278 -7.865)'/%3e%3ccircle cx='194.88' cy='166.54' r='10.63' fill='%23fff' stroke='%23db161b' stroke-width='1pt' transform='matrix(.29948 0 0 .2495 83.264 42.524)'/%3e%3ccircle cx='194.88' cy='166.54' r='10.63' fill='%23fff' stroke='%23db161b' stroke-width='1pt' transform='matrix(.29948 0 0 .2495 100.242 42.524)'/%3e%3cpath fill='%23fff' fill-rule='evenodd' stroke='%23db161b' stroke-width='.364' d='M142.69 77.001h14.85l-7.42 7.957-7.43-7.957z'/%3e%3ccircle cx='194.88' cy='166.54' r='10.63' fill='%23fff' stroke='%23db161b' stroke-width='1pt' transform='matrix(.39931 0 0 .33266 72.298 27.79)'/%3e%3crect width='22.805' height='5.304' x='133.77' y='109.72' fill='%23fff' stroke='%23db161b' stroke-width='.33' rx='1.238' ry='.938'/%3e%3cpath fill='%23fff' fill-rule='evenodd' stroke='%23db161b' stroke-width='.33' d='M163.52 105.3c-2.75 0-4.96 2.06-4.96 4.62v4.02c0 2.56 2.21 4.62 4.96 4.62s4.96-2.06 4.96-4.62v-4.02c0-2.56-2.21-4.62-4.96-4.62zm0 1.77c-1.65 0-2.98 1.65-2.98 3.7v2.33c0 2.05 1.33 3.69 2.98 3.69s2.97-1.64 2.97-3.69v-2.33c0-2.05-1.32-3.7-2.97-3.7zm-25.78-.88c-1.65 0-2.97 1.64-2.97 3.69v4.1c0 2.05 1.32 3.7 2.97 3.7s2.97-1.65 2.97-3.7v-4.1c0-2.05-1.32-3.69-2.97-3.69zm0-1.77c-2.75 0-4.96 2.06-4.96 4.62v5.79c0 2.56 2.21 4.62 4.96 4.62s4.96-2.06 4.96-4.62v-5.79c0-2.56-2.21-4.62-4.96-4.62z'/%3e%3cpath fill='%23fff' fill-rule='evenodd' stroke='%23db161b' stroke-width='.33' d='M129.81 107.95c-1.65 0-2.98 1.65-2.98 3.7v.96c0 2.05 1.33 3.7 2.98 3.7s2.97-1.65 2.97-3.7v-.96c0-2.05-1.32-3.7-2.97-3.7zm0-1.76c-2.75 0-4.96 2.06-4.96 4.62v2.65c0 2.56 2.21 4.62 4.96 4.62 2.74 0 4.96-2.06 4.96-4.62v-2.65c0-2.56-2.22-4.62-4.96-4.62z'/%3e%3cpath fill='%23fff' fill-rule='evenodd' stroke='%23db161b' stroke-width='.33' d='M117.91 105.51c-2.97 0-5.35 1.84-5.35 4.13v4.58c0 2.29 2.38 4.13 5.35 4.13s5.35-1.84 5.35-4.13v-4.58c0-2.29-2.38-4.13-5.35-4.13zm0-1.98c-4.94 0-8.92 2.31-8.92 5.17v6.47c0 2.86 3.98 5.16 8.92 5.16s8.92-2.3 8.92-5.16v-6.47c0-2.86-3.98-5.17-8.92-5.17zm64.45 2.86c-2.97 0-5.36 1.85-5.36 4.14v4.58c0 2.29 2.39 4.13 5.36 4.13 2.96 0 5.35-1.84 5.35-4.13v-4.58c0-2.29-2.39-4.14-5.35-4.14zm0-1.97c-4.95 0-8.93 2.3-8.93 5.16v6.47c0 2.86 3.98 5.16 8.93 5.16 4.94 0 8.92-2.3 8.92-5.16v-6.47c0-2.86-3.98-5.16-8.92-5.16z'/%3e%3crect width='11.898' height='5.304' x='165.5' y='109.72' fill='%23fff' stroke='%23db161b' stroke-width='.33' rx='.646' ry='.938'/%3e%3crect width='6.941' height='7.072' x='154.6' y='108.84' fill='%23fff' stroke='%23db161b' stroke-width='.33' rx='.377' ry='1.251'/%3e%3crect width='6.941' height='7.072' x='121.88' y='108.84' fill='%23fff' stroke='%23db161b' stroke-width='.33' rx='.377' ry='1.251'/%3e%3crect width='13.881' height='8.84' x='100.06' y='107.95' fill='%23fff' stroke='%23db161b' stroke-width='.33' rx='.753' ry='1.563'/%3e%3crect width='12.89' height='8.84' x='186.32' y='108.84' fill='%23fff' stroke='%23db161b' stroke-width='.33' rx='.7' ry='1.563'/%3e%3c/svg%3e";
            },
            3172: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 36 24'%3e%3cpath fill='%23fff' d='M0 0h36v24H0z'/%3e%3cg fill='%23005293'%3e%3cg id='c' transform='translate(9 6)'%3e%3cg id='b'%3e%3cpath id='a' d='M0-3v3h1.5z' transform='rotate(18 0 -3)'/%3e%3cuse xlink:href='%23a' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(72)'/%3e%3cuse xlink:href='%23b' transform='rotate(144)'/%3e%3cuse xlink:href='%23b' transform='rotate(216)'/%3e%3cuse xlink:href='%23b' transform='rotate(288)'/%3e%3c/g%3e%3cpath d='M0 12h18v12H0z'/%3e%3c/g%3e%3cg fill='%23d21034'%3e%3cpath d='M18 0h18v12H18z'/%3e%3cuse xlink:href='%23c' x='18' y='12'/%3e%3c/g%3e%3c/svg%3e";
            },
            5385: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3e%3cpath fill='%23d91023' d='M0 0h900v600H0z'/%3e%3cpath fill='%23fff' d='M300 0h300v600H300z'/%3e%3cg fill='%2300a854' stroke='%23d4af37' stroke-width='2' transform='matrix(.25 0 0 .25 345 179.188)'%3e%3cg id='g' stroke-width='4.33' transform='matrix(.44722 -.20656 .2582 .35777 89.404 -67.294)'%3e%3cpath d='M480.212 566.87c31.28 33.04 62.37 68.152 78.925 111.21 25.21 69.711 18.346 151.527-22.518 213.983-34.388 51.789-85.32 91.514-141.97 116.401-51.945 21.524-112.113 23.773-164.827 3.54-20.114-7.373-38.889-17.914-57.51-28.315-8.441-1.44-13.874 8.648-6.988 13.292 62.35 40.624 130.86 42.249 202.053 28.197 36.106-9.534 69.76-27.273 98.991-50.401 44.36-33.229 82.625-77.439 99.76-130.902 26.131-78.994 9.286-171.344-45.167-234.649-13.723-16.785-28.875-32.351-44.687-47.168l3.938 4.813z'/%3e%3cpath d='M170.57 983.29c-8.079-.843-12.167 11.815-5.077 13.643 4.182-1.01 10.665-12.011 5.076-13.642zm304.265-430.885c-4.503-5.593-14.062-2.886-17.759-7.3-3.94-4.706 2.887-6.51-.226-9.991-3.113-3.48-7.746-1.747-11.998-6.498-4.251-4.75-.422-8.776-4.09-12.099-3.667-3.322-4.171.887-8.372-3.724-4.2-4.612-1.717-12.71-6.304-18.558-4.481-5.712-2.984-12.5 2.496-11.257 3.644.826 5.064 4.385 10.468 5.756 5.404 1.372 7.577-2.577 11.118.904 3.542 3.481.308 9.122 4.105 13.971 3.798 4.85 5.83 1.303 8.515 5.626 2.686 4.323.5 6.61 2.228 11.666 1.729 5.056 8.377 3.105 10.869 10.748 2.492 7.643-1.05 20.756-1.05 20.756z'/%3e%3cpath d='M478.146 564.793c-5.561-26.182-26.97-56.915-52.595-79.474 15.222 11.956 44.848 40.53 54.361 79.28l-1.766.194z'/%3e%3cpath d='M460.18 524.426c-4.162-2.885-7.254-2.85-10.507-3.257 2.963-.163 5.873-.472 9.492 1.156l1.014 2.101zm-15.179-18.949c-4.502-1.455-7.443-.392-10.62.29 2.794-1.147 5.51-2.419 9.262-2.021l1.358 1.73zm4.377 3.378c-2.195-5.54-2.198-9.678-2.533-14.028-.094 3.967-.298 7.863.952 12.69l1.58 1.338zm13.521 18.185c-2.195-5.54-2.198-9.677-2.533-14.027-.094 3.966-.298 7.863.953 12.69l1.58 1.338zm92.277 155.022c-8.257-3.177-17.17-.031-23.877-2.453-7.148-2.582 1.14-8.575-4.41-10.366-5.548-1.79-10.208 5.644-17.785 3.202-7.578-2.442-6.322-10.125-12.54-11.417-6.218-1.291-6.37 7.191-13.822 4.865-7.453-2.327-7.5-12.33-15.974-15.724-8.276-3.314-9.088-11.348-1.33-13.33 5.16-1.318 10.29 1.936 18.002.135s6.976-8.643 13.093-7.11c6.116 1.535 4.355 10.427 11.373 13.246 7.017 2.818 11.366-4.905 16.697-1.972 5.33 2.932.26 9.424 4.625 13.701 4.367 4.277 7.736-2.34 14.176 4.2 6.44 6.538 11.772 23.023 11.772 23.023z'/%3e%3cpath d='M563.504 691.584c-22.904-25.577-58.656-41.392-101.83-49.728 25.052 3.433 76.71 14.954 105.234 49.976l-3.404-.248z'/%3e%3cpath d='M524.282 661.447c-6.69-.536-10.766 1.355-15.236 2.88 3.851-1.95 7.573-4.02 13.029-4.48l2.207 1.6zm-27.871-10.811c-6.554 1.172-10.006 4.054-13.927 6.677 3.224-2.882 6.292-5.848 11.419-7.682l2.508 1.005zm7.178.925c-5.183-4.507-6.89-8.854-9.121-13.225 1.507 4.226 2.841 8.443 6.48 12.767l2.64.458zm25.365 11.002c-5.183-4.507-6.89-8.854-9.121-13.225 1.507 4.226 2.84 8.443 6.48 12.767l2.64.458zm25.786 223.042c6.924-5.379 9.128-14.933 14.625-19.391 5.859-4.753 6.268 5.877 10.646 2.066 4.377-3.81.889-12.104 6.864-17.31 5.974-5.206 11.467.264 15.799-4.413 4.332-4.678-2.387-9.643 3.43-14.807 5.815-5.163 13.859.495 21.071-4.949 7.045-5.317 13.915-1.447 11.39 6.438-1.679 5.243-7.007 7.856-9.652 15.597-2.645 7.74 3.23 10.999-1.243 15.45-4.472 4.452-10.667-2.148-16.646 2.356-5.98 4.504-2.095 12.69-7.272 15.661-5.177 2.97-7.692-5.144-13.435-3.78-5.743 1.366-2.226 8.069-10.882 9.95-8.655 1.883-24.696-2.868-24.696-2.868z'/%3e%3cpath d='M542.691 887.43c32.645-5.369 64.277-27.486 93.849-60.328-16.034 19.857-52.657 58.27-95.853 63.151l2.004-2.822z'/%3e%3cpath d='M587.643 870.452c3.977-5.52 4.621-10.146 5.77-14.907-.48 4.464-.794 8.885-3.317 13.897l-2.453 1.01zm23.442-18.107c2.535-6.374 2.056-11.022 2.032-15.93.6 4.448 1.352 8.81.103 14.318l-2.135 1.612zm-4.547 5.722c6.36-1.944 10.75-.953 15.437-.406-4.187-1.095-8.275-2.337-13.67-1.631l-1.767 2.037zm-22.267 15.817c6.36-1.945 10.75-.954 15.437-.406-4.187-1.096-8.275-2.337-13.67-1.632l-1.767 2.038zm2.23-83.944c5.85-6.618 6.32-16.43 10.93-21.87 4.915-5.797 7.205 4.57 10.83-.016 3.626-4.587-1.275-12.066 3.673-18.331 4.947-6.266 11.317-1.946 14.743-7.376 3.427-5.43-4.058-9.018.742-15.21 4.799-6.194 13.709-2.18 19.83-8.917 5.98-6.58 13.42-4.098 12.338 4.136-.72 5.476-5.492 9.068-6.717 17.184-1.225 8.116 5.127 10.189 1.522 15.423-3.605 5.235-10.865-.06-15.942 5.517-5.077 5.576.195 12.875-4.366 16.79-4.56 3.914-8.473-3.577-13.875-1.13-5.402 2.445-.755 8.356-8.927 11.87-8.173 3.514-24.78 1.93-24.78 1.93z'/%3e%3cpath d='M574.984 794.051c31.13-11.555 58.291-39.374 81.522-77.336-12.232 22.597-41.404 67.391-82.99 80.496l1.468-3.16z'/%3e%3cpath d='M616.148 768.72c2.928-6.189 2.74-10.86 3.023-15.759.322 4.48.798 8.884-.792 14.296l-2.23 1.463zm19.824-22.302c1.36-6.752.063-11.227-.832-16.047 1.38 4.257 2.893 8.4 2.644 14.052l-1.812 1.995zm-3.452 6.498c5.905-3.134 10.394-3.004 15.098-3.368-4.309-.271-8.547-.705-13.724 1.025l-1.375 2.343zm-19.076 19.826c5.905-3.135 10.395-3.005 15.099-3.368-4.309-.272-8.547-.706-13.724 1.025l-1.375 2.343zm-46.157-31.544c-7.882-5.63-18.267-4.844-24.713-9.25-6.871-4.697 3.657-8.628-1.737-12.051-5.395-3.424-12.475 3.027-19.843-1.644-7.368-4.672-3.841-12.336-10.09-15.426-6.25-3.09-8.83 5.718-16.099 1.202s-4.466-14.966-12.516-20.881c-7.863-5.778-6.436-14.388 2.386-14.282 5.868.07 10.4 4.904 19.12 5.186 8.722.281 5.015-4.332 11.087-1.017 6.073 3.314 4.839 12.095 11.504 17.002 6.665 4.907 15.195-4.66 20.032-.107 4.837 4.554-2.411 9.907 1.016 15.593s8.9-.273 13.89 8.353c4.99 8.627 5.963 27.322 5.963 27.322z'/%3e%3cpath d='M573.434 753.467c-17.083-33.105-50.623-59.625-94.197-80.421 25.684 10.602 77.379 37.099 97.75 81.634l-3.553-1.213z'/%3e%3cpath d='M540.285 711.031c-6.968-2.434-11.845-1.602-17.038-1.264 4.656-.955 9.207-2.073 15.145-1.024l1.893 2.288zm-26.58-19.091c-7.31-.612-11.806 1.427-16.727 3.065 4.253-2.103 8.365-4.339 14.344-4.815l2.383 1.75zm7.375 2.978c-4.23-6.155-4.807-11.169-5.936-16.355.4 4.831.616 9.606 3.257 15.137l2.68 1.218zm23.859 18.587c-4.23-6.155-4.807-11.169-5.936-16.355.399 4.831.616 9.606 3.256 15.137l2.68 1.218zm43.081 36.857c4.442-7.713 2.994-17.422 6.451-23.72 3.685-6.712 7.945 2.959 10.603-2.297 2.659-5.256-3.596-11.547.03-18.725 3.628-7.177 10.705-4.289 13.005-10.328 2.3-6.04-5.728-7.976-2.232-15.052 3.495-7.076 13.002-5.022 17.686-12.908 4.577-7.704 12.345-6.84 12.887 1.45.361 5.515-3.615 10.038-3.236 18.244.38 8.205 7.003 8.897 4.49 14.783-2.512 5.886-10.651 2.23-14.539 8.76-3.887 6.53 2.695 12.567-1.01 17.361-3.704 4.795-8.993-1.717-13.808 1.816-4.815 3.533.886 8.343-6.434 13.506-7.32 5.162-23.893 7.11-23.893 7.11z'/%3e%3cpath d='M577.541 756.813c28.24-17.872 49.428-50.836 64.795-92.905-7.584 24.705-27.44 74.716-65.618 96.309l.823-3.404z'/%3e%3cpath d='M612.927 723.337c1.664-6.678.572-11.212-.104-16.07 1.186 4.32 2.51 8.532 2.005 14.166l-1.9 1.904zm15.076-26.017c.019-6.898-2.122-11.007-3.936-15.538 2.18 3.877 4.467 7.615 5.323 13.203l-1.387 2.335zm-2.117 7.091c5.174-4.313 9.596-5.132 14.132-6.478-4.273.641-8.508 1.11-13.241 3.895l-.891 2.583zm-14.826 23.433c5.175-4.313 9.597-5.132 14.133-6.478-4.273.641-8.508 1.11-13.241 3.895l-.891 2.583zm-53.667-88.933c3.616-8.648.844-18.542 3.621-25.58 2.96-7.5 8.651 1.957 10.732-3.884 2.081-5.842-5.245-11.503-2.407-19.48s10.578-5.97 12.184-12.576c1.606-6.606-6.999-7.488-4.284-15.34 2.715-7.853 12.873-7.057 16.72-15.92 3.757-8.658 11.951-8.855 13.596-.309 1.094 5.685-2.453 10.95-.99 19.43 1.463 8.482 8.444 8.267 6.597 14.743-1.847 6.476-10.791 3.821-13.985 11.162-3.194 7.34 4.44 12.69 1.211 18.2-3.23 5.508-9.58-.518-14.13 3.835-4.548 4.354 2.01 8.552-4.934 14.954-6.943 6.403-23.931 10.765-23.931 10.765z'/%3e%3cpath d='M547.331 647.1c27.05-22.572 44.8-59.846 55.309-105.768-4.672 26.765-18.816 81.581-55.722 109.423l.413-3.656z'/%3e%3cpath d='M579.785 607.29c.86-7.18-.866-11.741-2.202-16.699 1.796 4.326 3.722 8.52 3.931 14.452l-1.73 2.247zm12.295-29.185c-.879-7.177-3.64-11.15-6.118-15.606 2.772 3.725 5.64 7.29 7.257 12.982l-1.138 2.624zm-1.279 7.674c4.821-5.216 9.315-6.69 13.859-8.731-4.361 1.27-8.707 2.353-13.268 5.918l-.59 2.813zm-12.371 26.463c4.821-5.216 9.315-6.691 13.859-8.731-4.362 1.27-8.707 2.353-13.269 5.918l-.59 2.813z'/%3e%3cpath d='M533.383 605.314c4.26-6.586-1.069-18.724 2.254-24.109 3.541-5.739 7.22 2.947 9.785-1.556 2.564-4.504-.434-10.335 3.065-16.486 3.5-6.15 8.534-1.658 10.788-6.866 2.254-5.208-2.035-5.336 1.341-11.402 3.377-6.067 12.051-3.846 16.538-10.574 4.383-6.571 11.49-5.472 11.791 1.839.2 4.863-2.913 7.166-2.76 14.395.152 7.229 4.65 9.567 2.204 14.63-2.446 5.064-8.907 1.554-12.63 7.124-3.723 5.57.338 7.774-3.175 11.827-3.514 4.052-6.377 1.487-10.88 4.382-4.502 2.895-.728 11.329-7.568 15.547s-20.753 1.249-20.753 1.249z'/%3e%3cpath d='M522.094 611.2c24.26-10.566 48.596-42.396 63.7-78.703-7.548 21.385-27.469 63.674-63.017 80.985l-.683-2.282z'/%3e%3cpath d='M556.883 582.647c1.686-5.797.792-9.83.287-14.13.986 3.85 2.1 7.61 1.503 12.54l-1.79 1.59zm14.455-22.209c.18-6.063-1.686-9.768-3.242-13.83 1.908 3.503 3.918 6.889 4.57 11.838l-1.328 1.992zm-2.112 6.14c4.85-3.565 8.928-4.091 13.122-5.077-3.936.378-7.833.604-12.243 2.845l-.88 2.232zm-14.163 19.95c4.85-3.566 8.928-4.092 13.123-5.077-3.936.377-7.834.603-12.244 2.845l-.879 2.232zm-173.275 425.745c3.569-9.036.931-19.718 3.674-27.08 2.923-7.845 8.403 2.52 10.462-3.601 2.06-6.121-5.034-12.523-2.226-20.882 2.808-8.358 10.325-5.832 11.926-12.792 1.601-6.959-6.764-8.331-4.076-16.563 2.687-8.233 12.564-6.875 16.358-16.128 3.706-9.039 11.678-8.837 13.227.354 1.03 6.113-2.451 11.546-1.078 20.658 1.374 9.112 8.166 9.234 6.33 16.043-1.834 6.81-10.52 3.53-13.67 11.194-3.15 7.662 4.245 13.748 1.071 19.457-3.174 5.709-9.316-1.033-13.767 3.379-4.45 4.411 1.903 9.215-4.888 15.69-6.792 6.474-23.343 10.271-23.343 10.271z'/%3e%3cpath d='M375.216 1016.418c26.447-22.698 40.67-57.455 51.163-105.87-4.703 28.292-15.521 81.925-51.587 109.746l.424-3.876z'/%3e%3cpath d='M403.757 979.697c.88-7.61-.773-12.557-2.044-17.907 1.722 4.7 3.57 9.266 3.739 15.598l-1.695 2.309zm12.133-30.487c-.813-7.694-3.476-12.066-5.86-16.94 2.675 4.11 5.443 8.053 6.983 14.2l-1.123 2.74zm-1.29 8.114c4.72-5.317 9.1-6.663 13.533-8.61-4.25 1.135-8.484 2.072-12.942 5.642l-.591 2.968zm-12.19 27.582c4.72-5.317 9.1-6.663 13.532-8.61-4.25 1.135-8.483 2.072-12.942 5.642l-.59 2.968zm158.672-152.738c-7.131-7.46-19.244-10.076-25.142-16.004-6.287-6.318 7.034-6.423 2.01-11.151-5.023-4.73-15.242-1.31-22.104-7.764-6.862-6.454-.297-12.072-6.405-16.78-6.11-4.707-11.974 2.218-18.774-4.068-6.8-6.286-.138-14.585-7.367-22.35-7.06-7.585-2.579-14.703 7.456-11.801 6.675 1.93 10.246 7.624 20.107 10.648 9.861 3.025 13.63-3.063 19.462 1.785 5.833 4.849-2.112 11.171 3.87 17.609 5.98 6.438 16.044 2.598 20.056 8.142 4.013 5.545-6.035 7.945-4.007 14.037 2.027 6.092 10.249 2.594 13.085 11.77 2.837 9.176-2.247 25.927-2.247 25.927z'/%3e%3cpath d='M540.258 797.04c-7.147-4.36-12.989-5.181-19.028-6.537 5.63.643 11.196 1.109 17.626 3.922l1.402 2.614zm-24.013-25.253c-8.14-2.867-13.947-2.505-20.108-2.63 5.552-.496 10.986-1.153 17.968.331l2.14 2.299zm7.432 4.966c-2.79-6.76-1.786-11.353-1.355-16.274-1.146 4.376-2.48 8.645-1.3 14.35l2.655 1.924zm21.073 23.944c-2.789-6.76-1.785-11.353-1.355-16.274-1.146 4.376-2.48 8.645-1.3 14.35l2.655 1.924z'/%3e%3cpath d='M561.704 840.054c-8.529-34.554-35.695-63.696-78.54-95.86 25.804 17.503 73.699 52.404 82.193 98.058l-3.653-2.198z'/%3e%3cg id='d'%3e%3cpath d='M527.296 890.544c-3.353-8.85-19.798-13.112-22.673-20.186-3.064-7.54 9.126-5.225 6.542-10.926-2.584-5.701-13.345-4.096-16.877-11.879-3.532-7.782 4.826-12.277 1.244-18.154-3.583-5.876-11.854.07-15.4-7.532-3.547-7.6 6.031-14.792 2.719-23.969-3.235-8.964 3.857-15.356 11.781-10.593 5.271 3.167 6.123 9.582 13.838 14.436 7.715 4.855 13.721-.624 16.993 5.346 3.271 5.97-6.643 10.926-3.907 18.532 2.736 7.606 13.533 5.547 14.85 11.89 1.318 6.344-8.857 6.948-9.58 13.485-.724 6.537 8.25 4.488 6.962 14.295-1.288 9.807-6.492 25.255-6.492 25.255z'/%3e%3cpath d='M520.011 853.111c-4.675-5.713-13.031-8.939-17.965-11.41 4.862 1.675 13.116 4.49 17.792 8.508l.173 2.902zm-9.929-24.886c.311-7.352 3.166-11.82 5.636-16.725-2.893 4.223-5.912 8.302-7.244 14.293l1.608 2.432zm12.421 26.064c.311-7.352-.15-9.81 2.32-14.714-2.892 4.222-2.596 6.292-3.928 12.283l1.608 2.431z'/%3e%3cpath d='M525.2 906.633c6.813-36.538-12.825-78.385-38.311-118.74 16.138 22.413 52.245 73.859 40.713 121.63l-2.402-2.89z'/%3e%3cpath d='M505.403 821.845c-6.213-4.382-11.66-5.071-17.225-6.319 5.271.507 10.504.83 16.244 3.602l.98 2.717z'/%3e%3c/g%3e%3cpath d='M493.56 566.123c-1.927-7.016-11.717-8.589-13.368-14.187-1.76-5.967 5.18-4.726 3.698-9.223-1.483-4.498-6.394-4.876-8.42-11.015-2.028-6.14 3.044-8.197.993-12.785-2.052-4.588-4.158-.956-6.193-6.947-2.035-5.99 3.4-12.339 1.494-19.622-1.861-7.115 2.16-12.683 6.68-9.229 3.006 2.298 2.912 6.15 7.313 9.69 4.4 3.541 7.928.853 9.803 5.533 1.875 4.68-3.284 8.464-1.71 14.502 1.573 6.037 4.815 3.657 5.578 8.743.764 5.087-2.126 6.251-2.523 11.602-.398 5.35 6.438 6.382 5.727 14.42-.71 8.037-9.071 18.518-9.071 18.518z'/%3e%3cpath d='M491.743 578.842c5.153-26.274-2.39-63.414-16.983-94.87 9.233 17.366 25.128 56.012 18.673 95.44l-1.69-.57z'/%3e%3cpath d='M491.108 534.358c-2.673-4.397-5.511-5.675-8.324-7.424 2.77 1.106 5.55 2.055 8.219 5.074l.105 2.35zm-6.458-23.738c-3.545-3.235-6.647-3.508-9.815-4.23 3 .135 5.978.123 9.25 2.074l.565 2.157zm2.677 4.94c.16-5.991 1.774-9.773 3.169-13.888-1.636 3.584-3.345 7.057-4.09 11.996l.92 1.892zm5.243 22.338c.16-5.991 1.775-9.773 3.17-13.888-1.637 3.583-3.346 7.057-4.09 11.996l.92 1.892zm17.102 37.322c-.207-6.888-6.92-11.393-7.205-16.889-.304-5.858 14.644-4.381 14.25-8.797-.392-4.416-5.461-4.804-6.001-10.832-.54-6.028 5.332-8.027 4.364-12.534-.968-4.506-4.128-.952-4.714-6.834-.586-5.883 1.959-12.396 1.845-19.545-.112-6.984 5.565-12.43 9.425-9.027 2.567 2.264 1.468 6.042 5.18 9.53 3.712 3.486 8.359.996 11.29 4.523 2.915 3.507 2.309 6.345 2.397 12.272.09 5.926 4.118 3.603 3.602 8.594-.517 4.99-3.861 6.123-5.668 11.368-1.807 5.246 5.12 6.282 2.285 14.161-2.835 7.88-31.05 24.01-31.05 24.01z'/%3e%3cpath d='M499.22 585.584c24.422-21.57 36.501-63.212 18.317-93.996 8.18 15.13 12.468 31.125 8.112 50.275-3.15 13.846-10.823 30.446-24.8 44.286l-1.63-.565z'/%3e%3cpath d='M522.267 550.763c-1.672-4.322-6.172-9.786-8.678-11.51 2.628 1.093 7.152 6.235 9.177 9.205l-.499 2.305zm4.02-26.817c-2.89-3.185-6.084-3.465-9.23-4.183 3.121.143 6.259.14 9.196 2.066l.034 2.117zm1.154.2c1.724-5.874 4.405-9.577 6.94-13.608-2.652 3.509-5.352 6.91-7.417 11.75l.477 1.858zm-4.271 27.524c1.723-5.874 7.855-3.776 12.463-5.225-3.495.052-10.876-1.474-12.942 3.368l.478 1.857zm-44.267 24.203c-6.493-4.618-4.563-15.69-9.703-19.496-5.479-4.057-6.718 3.84-10.79.614-4.074-3.225-2.685-8.63-8.243-13.035-5.56-4.406-9.503.287-13.463-3.581-3.96-3.868.525-4.807-4.88-9.168-5.403-4.36-13.875-.838-20.651-5.53-6.62-4.581-13.78-2.292-11.875 3.812 1.267 4.06 5.25 5.359 7.286 11.366 2.037 6.006-1.995 8.813 2.123 12.525 4.118 3.712 9.864-.446 15.482 3.436 5.619 3.882 2.006 6.494 6.943 9.162 4.937 2.668 7.176-.009 12.804 1.51 5.627 1.519 4.21 9.225 12.706 11.384 8.495 2.16 22.261-2.999 22.261-2.999z'/%3e%3cpath d='M492.596 578.547c-28.791-4.023-64.127-25.614-91.088-52.699 14.459 16.215 48.316 47.311 91.062 54.718l.026-2.02z'/%3e%3cpath d='M447.235 561.697c-3.54-4.466-3.822-7.974-4.597-11.627.13 3.374.099 6.7 2.227 10.66l2.37.967zm-21.992-15.555c-2.033-4.978-1.192-8.404-.785-12.065-.947 3.267-2.037 6.457-1.22 10.676l2.005 1.389zm4.094 4.667c-6.199-2.006-10.658-1.649-15.38-1.649 4.264-.452 8.443-1.023 13.774-.026l1.606 1.675zm20.997 13.743c-6.199-2.005-10.658-1.648-15.38-1.648 4.264-.453 8.443-1.023 13.774-.027l1.606 1.675zm50.183 41.025c-8.06-3.492-6.615-15.421-13.007-18.344-6.814-3.114-7.68 5.366-12.762 2.833-5.082-2.534-3.845-8.447-10.78-11.909-6.936-3.461-11.258 2.23-16.254-.997-4.996-3.226.255-5.115-6.493-8.56-6.748-3.446-16.535 1.944-24.936-1.567-8.207-3.43-16.533.41-13.805 6.384 1.815 3.972 6.641 4.517 9.518 10.363 2.876 5.845-1.695 9.59 3.476 12.62 5.172 3.032 11.675-2.469 18.64.435 6.966 2.905 2.878 6.36 8.942 8.137 6.064 1.777 8.517-1.468 15.313-1.028 6.796.44 5.704 8.758 15.953 9.281 10.248.524 26.195-7.648 26.195-7.648z'/%3e%3cpath d='M516.976 605.581c-34.484 1.658-78.077-13.661-112.15-36.407 18.4 13.96 60.967 39.483 112.273 38.517l-.123-2.11z'/%3e%3cpath d='M461.843 597.24c-4.542-3.935-5.146-7.533-6.345-11.182.413 3.488.63 6.96 3.458 10.655l2.887.527zm-27.293-11.741c-2.794-4.774-2.057-8.516-1.853-12.413-.875 3.597-1.925 7.142-.634 11.373l2.487 1.04zm5.216 4.031c-7.51-.83-12.777.447-18.383 1.407 5.028-1.338 9.945-2.782 16.35-2.826l2.033 1.419zm25.974 10.055c-7.511-.83-12.777.447-18.383 1.407 5.028-1.338 9.944-2.781 16.35-2.826l2.033 1.419z'/%3e%3cpath d='M517.502 629.672c-8.279-2.962-7.618-14.951-14.193-17.452-7.009-2.666-7.318 5.846-12.559 3.648-5.24-2.198-4.393-8.174-11.546-11.178-7.152-3.004-11.095 2.95-16.296.055-5.2-2.894-.08-5.117-7.045-8.117-6.965-3-16.384 3.007-25.005.048-8.42-2.89-16.482 1.477-13.366 7.257 2.073 3.844 6.928 4.076 10.184 9.72 3.255 5.643-1.063 9.67 4.3 12.36 5.363 2.688 11.496-3.216 18.642-.77 7.147 2.446 3.291 6.155 9.463 7.536 6.172 1.38 8.409-2.014 15.224-2.014 6.816-.001 6.27 8.364 16.539 8.225 10.269-.14 25.658-9.318 25.658-9.318z'/%3e%3cpath d='M533.937 628.613c-34.327 3.88-78.864-8.58-114.381-29.062 19.291 12.731 63.471 35.434 114.642 31.158l-.261-2.096z'/%3e%3cpath d='M478.335 623.855c-4.795-3.63-5.633-7.179-7.07-10.74.641 3.452 1.085 6.9 4.152 10.402l2.918.338zm-28.025-9.945c-3.104-4.58-2.613-8.359-2.666-12.258-.637 3.643-1.453 7.247.114 11.382l2.552.876zm5.472 3.683c-7.554-.344-12.73 1.271-18.264 2.59 4.933-1.66 9.748-3.416 16.14-3.874l2.124 1.284zm26.598 8.349c-7.555-.343-12.73 1.271-18.265 2.59 4.933-1.659 9.748-3.415 16.14-3.874l2.124 1.284z'/%3e%3cg id='a'%3e%3cpath d='M207.197 997.382c6.594-4.258 15.187-3.229 20.577-6.552 5.746-3.542-2.93-7.124 1.577-9.691 4.508-2.568 10.299 2.924 16.456-.579s3.323-9.842 8.535-12.107c5.212-2.265 7.249 4.965 13.322 1.584 6.072-3.38 3.87-11.948 10.607-16.432 6.58-4.38 5.496-11.406-1.813-11.654-4.862-.166-8.671 3.576-15.899 3.473-7.227-.103-8.111-6.094-13.18-3.641-5.068 2.453-1.515 9.734-7.092 13.454-5.577 3.72-11.157-2.076-15.216 1.427-4.06 3.503 1.884 8.112-1.02 12.586s-7.37-.559-11.601 6.237c-4.233 6.796-5.253 21.895-5.253 21.895z'/%3e%3cpath d='M201.964 1007.083c14.53-26.156 42.618-46.357 78.95-61.542-21.397 7.61-64.522 27.103-81.906 62.39l2.956-.848z'/%3e%3cpath d='M229.91 973.981c5.8-1.706 9.83-.848 14.128-.377-3.846-.95-7.603-2.027-12.534-1.404l-1.594 1.781zm22.236-14.448c6.062-.22 9.763 1.602 13.82 3.115-3.498-1.864-6.878-3.83-11.826-4.443l-1.994 1.327zm-6.143 2.13c3.575-4.823 4.11-8.86 5.104-13.017-.386 3.897-.62 7.754-2.87 12.133l-2.234.884zm-19.977 14.145c3.575-4.823 4.11-8.86 5.105-13.017-.386 3.896-.62 7.754-2.871 12.132l-2.234.885z'/%3e%3c/g%3e%3cg id='b'%3e%3cpath d='M210.31 1024.483c9.07 3.59 19.283 0 26.659 2.74 7.86 2.916-1.833 9.73 4.283 11.752 6.117 2.023 11.83-6.42 20.182-3.663 8.353 2.757 6.447 11.475 13.346 12.93 6.9 1.455 7.619-8.17 15.839-5.544 8.22 2.627 7.627 13.976 16.924 17.811 9.081 3.746 9.475 12.86.633 15.122-5.88 1.505-11.432-2.178-20.209-.12-8.777 2.057-8.393 9.818-15.164 8.089-6.77-1.73-4.218-11.822-11.918-15.007-7.7-3.185-13.082 5.584-18.88 2.267-5.797-3.318.317-10.693-4.31-15.538-4.628-4.844-8.839 2.668-15.65-4.738-6.81-7.407-11.734-26.101-11.734-26.101z'/%3e%3cpath d='M201.572 1013.693c24.073 28.978 63.205 46.859 111.156 56.24-27.914-3.851-85.188-16.83-114.963-56.515l3.807.275z'/%3e%3cpath d='M243.677 1047.816c7.48.597 12.179-1.557 17.298-3.294-4.452 2.218-8.765 4.574-14.923 5.107l-2.375-1.812zm30.604 12.217c7.437-1.342 11.5-4.618 16.073-7.601-3.807 3.275-7.445 6.647-13.32 8.736l-2.753-1.135zm-8.001-1.037c5.53 5.104 7.165 10.033 9.39 14.989-1.42-4.792-2.646-9.575-6.455-14.474l-2.935-.515zm-27.778-12.438c5.53 5.104 7.166 10.034 9.39 14.99-1.42-4.793-2.646-9.575-6.454-14.475l-2.936-.515z'/%3e%3c/g%3e%3cuse xlink:href='%23a' width='744.094' height='1052.362' transform='translate(43.941 17.372)'/%3e%3cuse xlink:href='%23b' width='744.094' height='1052.362' transform='translate(59.27 11.24)'/%3e%3cg id='e'%3e%3cpath d='M353.525 1034.119c9.75.938 18.788-5.287 26.67-4.699 8.403.627.695 9.792 7.17 10.044 6.474.252 9.888-9.375 18.729-9.035 8.84.34 9.205 9.186 16.298 8.681 7.093-.504 5.34-9.89 14.018-9.638 8.679.252 10.993 11.25 21.029 12.36 9.802 1.084 12.508 9.676 4.47 14.262-5.345 3.05-11.693 1.057-19.72 5.43-8.027 4.371-5.676 11.676-12.713 11.882-7.037.207-7.122-10.128-15.435-11.056-8.314-.928-11.323 8.921-17.817 7.345-6.494-1.576-2.416-10.294-8.16-13.65-5.743-3.355-7.93 4.972-16.454-.23-8.524-5.202-18.085-21.696-18.085-21.696z'/%3e%3cpath d='M342.262 1026.217c30.838 21.058 73.521 27.39 122.63 23.187-28.178 3.984-87.287 7.308-126.41-22.406l3.78-.781z'/%3e%3cpath d='M391.98 1047.238c7.44-1.483 11.469-4.828 16.014-7.891-3.772 3.34-7.374 6.772-13.238 8.97l-2.776-1.078zm32.93 3.265c6.904-3.321 10.028-7.563 13.723-11.666-2.874 4.171-5.56 8.388-10.751 11.995l-2.971-.329zm-8.06 1.206c6.689 3.355 9.539 7.612 12.969 11.732-2.605-4.185-5.018-8.414-9.977-12.046l-2.992.314zm-30.232-4.252c6.688 3.355 9.538 7.612 12.968 11.733-2.605-4.185-5.018-8.415-9.977-12.046l-2.991.313z'/%3e%3c/g%3e%3cpath d='M292.72 1024.547c4.983-5.068 13.172-6.262 17.286-10.274 4.385-4.277-4.539-5.162-1.043-8.344 3.495-3.182 10.25-.04 15.024-4.383 4.775-4.342.528-8.882 4.75-11.982 4.222-3.1 7.963 2.36 12.692-1.861 4.728-4.222.49-10.745 5.546-16.031 4.939-5.164 2.13-10.684-4.674-9.153-4.526 1.019-7.074 5-13.765 6.632-6.69 1.631-9.05-3.085-13.09.136-4.042 3.22 1.11 8.363-3.074 12.747-4.184 4.383-10.823.942-13.663 4.787-2.84 3.844 3.828 6.223 2.303 10.591-1.525 4.369-6.939 1.29-9.09 7.884-2.152 6.593.798 19.25.798 19.25z'/%3e%3cpath d='M292.089 1030.323c6.657-24.958 25.657-44.795 55.246-65.91-17.769 11.34-50.817 34.166-57.754 67.31l2.508-1.4z'/%3e%3cpath d='M307.634 999.911c4.908-2.78 8.845-3.032 12.929-3.665-3.79.132-7.533.139-11.919 1.822l-1.01 1.843zm16.78-17.161c5.533-1.62 9.415-1 13.547-.72-3.707-.702-7.33-1.516-12.05-.845l-1.497 1.565zm-5.116 3.21c2.054-4.814 1.507-8.261 1.352-11.915.649 3.296 1.427 6.523.48 10.658l-1.832 1.258zm-14.775 16.375c2.054-4.814 1.507-8.262 1.353-11.915.648 3.295 1.426 6.523.479 10.658l-1.832 1.257zm40.897 14.978c4.024-6.249 12.081-9.145 15.439-14.127 3.579-5.31-5.644-4.413-2.745-8.41 2.898-3.998 10.379-2.124 14.34-7.58 3.96-5.457-1.262-9.286 2.39-13.347 3.651-4.06 8.547.823 12.485-4.5 3.938-5.323-1.676-11.202 2.378-17.692 3.96-6.34-.004-11.472-6.59-8.508-4.38 1.971-6.157 6.603-12.608 9.647-6.45 3.045-9.795-1.35-13.24 2.8-3.443 4.148 2.819 8.416-.534 13.795-3.354 5.38-10.778 3.172-12.879 7.721-2.1 4.55 5.138 5.654 4.477 10.478-.662 4.823-6.771 2.742-7.618 9.992-.846 7.25 4.705 19.73 4.705 19.73z'/%3e%3cpath d='M345.948 1023.41c1.698-27.142 16.94-51.5 42.655-79.326-15.714 15.325-44.589 45.623-44.914 81.28l2.259-1.954z'/%3e%3cpath d='M355.549 988.827c4.412-3.87 8.351-4.929 12.362-6.413-3.815.907-7.606 1.673-11.71 4.304l-.652 2.109zm13.534-21.141c5.28-2.797 9.34-2.946 13.584-3.495-3.899.027-7.736-.078-12.383 1.574l-1.2 1.921zm-4.535 4.357c1.107-5.392-.145-8.843-1.04-12.588 1.324 3.274 2.765 6.451 2.642 10.916l-1.602 1.672zm-11.661 19.921c1.108-5.393-.144-8.844-1.04-12.588 1.324 3.274 2.765 6.451 2.642 10.916l-1.602 1.672z'/%3e%3cg id='f'%3e%3cpath d='M515.271 940.876c7.671-4.14 11.335-13.195 17.453-16.668 6.522-3.7 5.27 6.858 10.184 3.836 4.913-3.022 2.763-11.794 9.47-15.923 6.706-4.129 11.274 2.196 16.277-1.689 5.003-3.884-.853-9.918 5.69-14.032 6.545-4.114 13.6 2.827 21.565-1.327 7.78-4.059 13.956.92 10.236 8.274-2.474 4.891-8.14 6.57-11.955 13.762-3.816 7.192 1.473 11.399-3.634 15.037-5.106 3.638-10.19-3.92-16.792-.485-6.603 3.436-4.045 12.17-9.616 14.227-5.571 2.058-6.789-6.374-12.668-5.996-5.88.377-3.454 7.585-12.288 7.982-8.834.396-23.922-6.998-23.922-6.998z'/%3e%3cpath d='M503.099 940.643c33.048.211 67.707-16.276 102.004-43.693-18.915 16.888-61.038 48.614-104.421 46.14l2.417-2.447z'/%3e%3cpath d='M550.1 931.475c4.784-4.776 6.14-9.232 8.016-13.736-1.17 4.324-2.167 8.633-5.438 13.154l-2.578.582zm25.953-13.911c3.495-5.863 3.745-10.53 4.487-15.378-.1 4.492-.04 8.923-2.13 14.148l-2.357 1.23zm-5.379 4.879c6.58-.846 10.756.873 15.296 2.204-3.96-1.787-7.8-3.702-13.234-3.917l-2.062 1.713zm-24.435 11.85c6.578-.846 10.755.873 15.294 2.204-3.96-1.788-7.8-3.703-13.234-3.917l-2.06 1.713z'/%3e%3c/g%3e%3cpath d='M582.995 716.21c3.617-8.648.845-18.541 3.621-25.579 2.96-7.501 8.651 1.956 10.732-3.885 2.082-5.841-5.245-11.503-2.407-19.48s10.578-5.97 12.184-12.576c1.606-6.606-6.999-7.488-4.284-15.34 2.716-7.853 12.873-7.057 16.72-15.92 3.757-8.658 11.952-8.855 13.596-.308 1.094 5.684-2.453 10.95-.99 19.43 1.464 8.481 8.445 8.267 6.598 14.743-1.847 6.475-10.792 3.82-13.986 11.16-3.193 7.341 4.44 12.692 1.211 18.2-3.23 5.51-9.58-.517-14.13 3.837-4.548 4.353 2.01 8.552-4.934 14.954-6.943 6.402-23.931 10.764-23.931 10.764z'/%3e%3cpath d='M572.933 724.398c27.051-22.571 44.801-59.844 55.31-105.767-4.673 26.766-18.817 81.581-55.723 109.423l.413-3.656z'/%3e%3cpath d='M605.387 684.59c.861-7.18-.866-11.742-2.202-16.7 1.797 4.326 3.722 8.52 3.931 14.452l-1.729 2.248zm12.296-29.186c-.88-7.177-3.642-11.15-6.12-15.606 2.774 3.725 5.64 7.29 7.259 12.982l-1.139 2.624zm-1.279 7.674c4.82-5.216 9.315-6.69 13.858-8.731-4.361 1.27-8.706 2.354-13.268 5.918l-.59 2.813zm-12.372 26.462c4.821-5.215 9.315-6.69 13.86-8.73-4.362 1.27-8.708 2.354-13.27 5.918l-.59 2.813z'/%3e%3cpath d='M572.265 672.078c4.442-7.713 2.993-17.421 6.45-23.719 3.686-6.712 7.945 2.958 10.604-2.298 2.658-5.255-3.596-11.547.03-18.725 3.627-7.177 10.705-4.289 13.005-10.328 2.3-6.04-5.728-7.976-2.233-15.052 3.496-7.076 13.002-5.021 17.687-12.908 4.576-7.704 12.345-6.84 12.887 1.45.361 5.515-3.615 10.038-3.236 18.244.38 8.205 7.003 8.897 4.49 14.783-2.512 5.886-10.652 2.23-14.539 8.76-3.887 6.53 2.695 12.567-1.01 17.361-3.704 4.795-8.993-1.717-13.808 1.816-4.815 3.533.886 8.343-6.434 13.506s-23.893 7.11-23.893 7.11z'/%3e%3cpath d='M561.786 678.53c28.239-17.873 49.427-50.837 64.795-92.906-7.584 24.705-27.44 74.716-65.619 96.309l.824-3.404z'/%3e%3cpath d='M597.172 645.053c1.664-6.678.571-11.212-.105-16.07 1.186 4.32 2.51 8.532 2.005 14.166l-1.9 1.904zm15.076-26.017c.018-6.898-2.122-11.007-3.936-15.538 2.18 3.877 4.467 7.615 5.323 13.203l-1.387 2.335zm-2.118 7.091c5.174-4.313 9.597-5.132 14.132-6.478-4.272.642-8.507 1.11-13.24 3.895l-.891 2.583zm-14.825 23.433c5.174-4.313 9.597-5.132 14.132-6.478-4.272.642-8.507 1.11-13.24 3.895l-.892 2.583zm-28.563 126.375c-7.882-5.63-18.266-4.844-24.713-9.25-6.871-4.697 3.658-8.628-1.737-12.051-5.395-3.424-12.475 3.027-19.843-1.644-7.368-4.672-3.84-12.336-10.09-15.426-6.249-3.09-8.83 5.718-16.099 1.202-7.268-4.516-4.466-14.966-12.516-20.881-7.863-5.778-6.436-14.388 2.386-14.282 5.868.07 10.4 4.904 19.121 5.186 8.721.281 5.014-4.332 11.087-1.017 6.072 3.314 4.838 12.095 11.503 17.002 6.665 4.907 15.195-4.66 20.033-.107 4.837 4.554-2.412 9.907 1.015 15.593 3.427 5.686 8.9-.273 13.89 8.353 4.99 8.627 5.963 27.322 5.963 27.322z'/%3e%3cpath d='M572.89 788.204c-17.083-33.105-50.624-59.625-94.197-80.421 25.684 10.602 77.378 37.099 97.749 81.634l-3.552-1.213z'/%3e%3cpath d='M539.74 745.768c-6.968-2.434-11.845-1.602-17.037-1.264 4.655-.955 9.207-2.073 15.145-1.024l1.892 2.288zm-26.58-19.09c-7.31-.613-11.805 1.426-16.727 3.064 4.253-2.103 8.365-4.339 14.344-4.815l2.383 1.75zm7.376 2.977c-4.231-6.155-4.808-11.169-5.936-16.355.399 4.831.616 9.606 3.256 15.137l2.68 1.218zm23.858 18.587c-4.23-6.155-4.807-11.169-5.936-16.355.4 4.831.616 9.606 3.257 15.137l2.679 1.218zm30.299 95.148c5.85-6.617 6.32-16.43 10.93-21.87 4.915-5.796 7.205 4.571 10.83-.016 3.626-4.587-1.275-12.066 3.673-18.331 4.947-6.265 11.317-1.946 14.743-7.376 3.427-5.43-4.058-9.018.741-15.21 4.8-6.194 13.71-2.18 19.831-8.916 5.98-6.581 13.42-4.099 12.338 4.135-.72 5.476-5.492 9.069-6.717 17.184-1.225 8.116 5.127 10.189 1.522 15.424-3.605 5.235-10.865-.06-15.942 5.516s.195 12.875-4.366 16.79c-4.56 3.915-8.473-3.576-13.875-1.13-5.402 2.445-.755 8.356-8.927 11.87-8.173 3.515-24.78 1.93-24.78 1.93z'/%3e%3cpath d='M563.176 847.501c31.13-11.554 58.29-39.374 81.522-77.336-12.232 22.598-41.404 67.392-82.99 80.496l1.468-3.16z'/%3e%3cpath d='M604.34 822.17c2.928-6.189 2.74-10.859 3.023-15.759.322 4.48.798 8.884-.792 14.296l-2.23 1.464zm19.824-22.302c1.36-6.752.063-11.227-.832-16.046 1.38 4.256 2.893 8.399 2.644 14.051l-1.812 1.995zm-3.453 6.498c5.906-3.134 10.395-3.004 15.1-3.368-4.31-.271-8.548-.705-13.725 1.026l-1.375 2.342zm-19.076 19.826c5.906-3.134 10.396-3.004 15.1-3.368-4.31-.271-8.547-.705-13.725 1.025l-1.375 2.343z'/%3e%3cuse xlink:href='%23c' width='744.094' height='1052.362' transform='rotate(15 310.012 758.36)'/%3e%3cuse xlink:href='%23d' id='c' width='744.094' height='1052.362' transform='rotate(5 93.23 577.125)'/%3e%3cuse xlink:href='%23e' width='744.094' height='1052.362' transform='rotate(-10 274.952 690.264)'/%3e%3cuse xlink:href='%23f' width='744.094' height='1052.362' transform='rotate(10 225.439 653.89)'/%3e%3c/g%3e%3cuse xlink:href='%23g' width='1' height='1' transform='matrix(-1 0 0 1 840 .113)'/%3e%3c/g%3e%3cg stroke='%23d4af37' stroke-width='.75'%3e%3cpath fill='%23007ea8' d='m409.242 237.563-19.765 24.609c6.548 6.237 10.26 16.668 10.273 25.148.016 10.607-1.723 17.955-3.867 24.657-.023.07-.048.14-.07.21H450v-74.124c-11.935 7.409-28.331 10.36-40.758-.5z'/%3e%3cpath fill='%23fff' d='M490.758 237.563c-12.427 10.86-28.823 7.909-40.758.5v74.125h54.188c-.023-.071-.048-.14-.07-.211-2.145-6.702-3.884-14.05-3.868-24.657.013-8.48 3.725-18.911 10.273-25.148l-19.765-24.61z'/%3e%3cpath fill='%23d91023' d='M395.813 312.188c-2.952 9.169-6.658 17.15-7.813 30.414-1.705 19.584 14.046 30.306 20.555 33.375 10.034 4.731 20.518 3.095 31.25 4.468 4.98.638 7.766 3.789 10.195 6.368 2.429-2.58 5.215-5.73 10.195-6.368 10.732-1.373 21.216.263 31.25-4.468 6.509-3.07 22.26-13.791 20.555-33.375-1.155-13.264-4.861-21.245-7.813-30.414H395.813z'/%3e%3c/g%3e%3cg stroke='%23d4af37' stroke-width='3'%3e%3cg fill='%2300a854' stroke-width='6.156' transform='matrix(.119 0 0 .125 327.413 310.562)'%3e%3cg id='j' stroke-width='3.078'%3e%3cpath d='M1074.733-201.404s5.849-20.366 17.932-29.304c12.084-8.938 25.212-5.671 33.195-8.854-5.322 6.748-5.925 20.263-17.932 29.305-12.006 9.041-33.195 8.853-33.195 8.853zm48.699-36.346c-8.333 2.219-13.523-.31-24.954 3.897m17.285 1.827c-8.333 2.219-14.117-1.33-25.335 3.386m16.132 3.483c-7.912 2.781-11.632-1.2-22.466 4.03m13.263 2.838c-7.912 2.782-9.57-1.713-17.49 4.297m9.31 1.808c-5.168 1.667-7.531-.17-12.134 5.076m46.389-30.642c-4.497 7.358-3.55 13.053-10.835 22.815m3.166-17.091c-4.497 7.358-2.742 13.912-10.454 23.325m1.251-16.456c-4.918 6.794-2.159 11.492-10.256 20.39m1.053-13.522c-4.918 6.794-1.08 9.663-9.096 15.545m.916-9.44c-3.068 4.48-1.98 7.268-8.318 10.188'/%3e%3cpath d='M1130.782-243.633s-13.538 10.037-24.157 18.03c-10.62 7.992-31.636 24.008-31.636 24.008s21.334-15.59 32.017-23.497c10.684-7.907 24.158-18.03 24.158-18.03m-23.049-73.872s16.753 12.975 20.58 27.51c3.828 14.534-4.068 25.52-4.068 34.113-4.297-7.442-16.628-13.007-20.58-27.509-3.953-14.501 4.068-34.114 4.068-34.114zm15.728 58.696c1.025-8.562 5.296-12.446 5.62-24.622m-8.097 15.379c1.025-8.562 6.463-12.621 6.237-24.788m-9.209 13.696c.346-8.38 5.422-10.36 4.576-22.362m-7.548 11.27c.346-8.38 5.135-8.257 2.485-17.839m-5.127 7.979c.366-5.418 2.946-6.933-.222-13.15m11.285 54.437c-5.17-6.902-10.81-8.13-17.18-18.513m14.703 9.27c-5.17-6.902-11.908-7.699-17.796-18.348m14.824 7.256c-4.49-7.084-9.877-6.262-15.144-17.078m12.172 5.986c-4.49-7.084-8.576-4.583-11.072-14.206m8.43 4.346c-3.026-4.509-6.019-4.53-6.384-11.499'/%3e%3cpath d='M1126.586-249.291s-4.31-16.293-7.802-29.117c-3.491-12.824-10.586-38.277-10.586-38.277s6.581 25.59 9.97 38.442a5074.411 5074.411 0 0 0 7.802 29.117'/%3e%3cg id='h' stroke-width='3.078'%3e%3cpath d='M1206.423-261.845s16.752 12.975 20.58 27.51c3.828 14.534-4.069 25.519-4.069 34.113-4.297-7.443-16.628-13.008-20.58-27.509-3.952-14.501 4.069-34.114 4.069-34.114zm15.727 58.695c1.025-8.56 5.296-12.445 5.621-24.622m-8.098 15.379c1.026-8.561 6.464-12.62 6.238-24.787m-9.21 13.695c.347-8.38 5.423-10.36 4.576-22.36m-7.547 11.268c.345-8.38 5.135-8.256 2.485-17.838m-5.128 7.979c.366-5.418 2.947-6.933-.221-13.15m11.284 54.436c-5.169-6.901-10.81-8.13-17.18-18.512m14.703 9.269c-5.168-6.902-11.907-7.698-17.795-18.348m14.823 7.256c-4.49-7.084-9.876-6.26-15.143-17.077m12.172 5.985c-4.49-7.084-8.576-4.582-11.072-14.205m8.429 4.346c-3.025-4.51-6.018-4.53-6.383-11.5'/%3e%3cpath d='M1224.894-194.142s-4.31-16.293-7.802-29.117c-3.491-12.825-10.587-38.278-10.587-38.278s6.582 25.59 9.97 38.443a5154.98 5154.98 0 0 0 7.803 29.117m-53.774 57.257s2.86-20.996 13.533-31.579c10.673-10.582 24.135-9.236 31.578-13.533-4.297 7.443-2.951 20.904-13.534 31.578-10.582 10.673-31.577 13.533-31.577 13.533zm42.968-42.97c-7.928 3.394-13.427 1.637-24.135 7.444m17.368-.677c-7.927 3.393-14.161.714-24.585 6.993m16.465 1.127c-7.43 3.89-11.684.485-21.653 7.218m13.533.902c-7.43 3.89-9.718-.319-16.69 6.767m9.472.451c-4.874 2.392-7.477.915-11.277 6.767m41.502-36.992c-3.393 7.928-1.637 13.428-7.444 24.135m.677-17.368c-3.393 7.928-.713 14.162-6.992 24.586m-1.128-16.466c-3.89 7.43-.484 11.684-7.218 21.654m-.902-13.534c-3.89 7.43.32 9.718-6.767 16.692m-.451-9.474c-2.391 4.875-.914 7.477-6.766 11.278'/%3e%3cpath d='M1219.9-186.569s-11.954 11.88-21.315 21.315c-9.36 9.436-27.856 28.308-27.856 28.308s18.871-18.496 28.307-27.857a5074.411 5074.411 0 0 0 21.315-21.315'/%3e%3c/g%3e%3cpath d='M1057.073-278.588s20.562-5.119 34.344.877c13.783 5.996 17.517 18.999 24.265 24.321-8.505-1.235-20.511 5-34.344-.877-13.834-5.878-24.265-24.321-24.265-24.321zm55.825 24.001c-6.087-6.107-6.492-11.866-15.851-19.662m7.06 15.883c-6.088-6.108-5.907-12.891-15.6-20.249m5.05 15.713c-6.365-5.462-4.777-10.674-14.723-17.441m4.173 12.905c-6.365-5.462-3.302-9.145-12.466-12.999m3.089 8.967c-4.027-3.642-3.619-6.607-10.462-7.97m49.73 24.853c-8.62-.216-13.078 3.452-25.175 2.024m16.384-5.803c-8.62-.217-13.42 4.581-25.427 2.609m14.877-7.145c-8.343-.862-11.032 3.877-22.787 1.314m12.237-5.85c-8.342-.862-8.908 3.895-18.01-.105m8.633-3.927c-5.414-.416-7.284 1.92-12.982-2.109'/%3e%3cpath d='M1121.669-251.163s-15.462-6.705-27.693-11.906c-12.232-5.201-36.61-15.393-36.61-15.393s24.168 10.68 36.358 15.979a5135.657 5135.657 0 0 0 27.693 11.906m-49.134-133.333s14.687-15.274 29.546-17.531c14.86-2.257 24.941 6.766 33.486 7.682-7.858 3.479-14.706 15.147-29.546 17.53-14.84 2.385-33.486-7.681-33.486-7.681zm60.038-9.381c-8.404-1.933-11.81-6.593-23.883-8.214m14.428 9.691c-8.403-1.932-11.86-7.772-23.981-8.844m12.635 10.617c-8.295-1.238-9.723-6.496-21.745-6.934m10.4 8.707c-8.295-1.238-7.662-5.987-17.472-4.373m7.387 5.949c-5.348-.942-6.58-3.67-13.099-1.182m55.33-5.417c-7.414 4.403-9.237 9.881-20.239 15.108m10.784-13.631c-7.413 4.404-8.923 11.02-20.14 15.738m8.794-13.965c-7.522 3.709-7.278 9.152-18.594 13.237m7.249-11.464c-7.522 3.709-5.47 8.038-15.305 9.494m5.22-7.918c-4.806 2.527-5.146 5.5-12.114 5.121'/%3e%3cpath d='M1141.57-395.06s-16.66 2.55-29.783 4.654c-13.124 2.105-39.188 6.447-39.188 6.447s26.146-3.817 39.286-5.816c13.14-2 29.783-4.654 29.783-4.654m-39.535-60.472s19.984 7.045 28.19 19.637c8.207 12.592 4.168 25.504 6.872 33.661-6.42-5.713-19.876-7.115-28.19-19.637-8.314-12.52-6.872-33.661-6.872-33.661zm33.397 50.766c-1.721-8.45 1.11-13.48-2.412-25.14m-2.848 17.145c-1.72-8.449 2.164-14.013-1.878-25.49m-4.432 15.897c-2.309-8.063 1.887-11.54-2.693-22.665m-3.619 13.071c-2.308-8.063 2.277-9.452-3.253-17.714m-2.357 9.187c-1.357-5.258.616-7.508-4.347-12.413m27.839 48.122c-7.078-4.925-12.82-4.316-22.132-12.167m16.872 4.172c-7.078-4.925-13.725-3.56-22.664-11.817m16.354 2.224c-6.491-5.312-11.345-2.836-19.748-11.445m13.436 1.851c-6.49-5.311-9.582-1.651-14.979-10m9.369 1.473c-4.29-3.328-7.138-2.407-9.677-8.907'/%3e%3cpath d='M1140.968-396.448s-9.218-14.11-16.567-25.184c-7.349-11.075-22.092-33.003-22.092-33.003s14.299 22.22 21.56 33.354a5079.768 5079.768 0 0 0 16.566 25.183'/%3e%3cg id='i' stroke-width='3.078'%3e%3cpath d='M1213.668-401.795s16.753 12.975 20.58 27.51c3.828 14.534-4.068 25.519-4.068 34.113-4.297-7.443-16.628-13.008-20.58-27.51-3.953-14.5 4.068-34.113 4.068-34.113zm15.727 58.695c1.026-8.561 5.297-12.446 5.622-24.622m-8.098 15.379c1.025-8.561 6.463-12.62 6.237-24.787m-9.209 13.695c.346-8.38 5.422-10.36 4.575-22.36m-7.548 11.268c.347-8.38 5.136-8.256 2.486-17.838m-5.127 7.979c.365-5.418 2.946-6.933-.222-13.15m11.284 54.436c-5.168-6.901-10.81-8.13-17.179-18.512m14.703 9.269c-5.17-6.902-11.908-7.698-17.796-18.348m14.824 7.256c-4.49-7.084-9.877-6.26-15.144-17.077m12.171 5.985c-4.49-7.084-8.575-4.582-11.071-14.205m8.43 4.346c-3.026-4.51-6.019-4.531-6.384-11.5'/%3e%3cpath d='M1232.139-334.092s-4.31-16.293-7.802-29.117c-3.491-12.825-10.587-38.278-10.587-38.278s6.582 25.59 9.971 38.443a5074.411 5074.411 0 0 0 7.802 29.117m-64.409 39.02s8.197-19.54 21.245-27c13.05-7.458 25.704-2.674 34.005-4.899-6.077 6.077-8.261 19.429-21.245 27-12.984 7.57-34.005 4.899-34.005 4.899zm52.626-30.383c-8.536 1.225-13.393-1.895-25.239.943m16.951 3.841c-8.535 1.226-13.863-2.976-25.557.391m15.612 5.351c-8.184 1.834-11.41-2.556-22.783 1.368m12.838 4.374c-8.184 1.834-9.304-2.824-17.873 2.216m9.033 2.888c-5.327 1.048-7.459-1.052-12.644 3.617m49.662-24.989c-5.33 6.779-5.056 12.546-13.437 21.385m5.149-16.601c-5.329 6.78-4.354 13.495-13.117 21.938m3.172-16.196c-5.68 6.17-3.492 11.16-12.576 19.047m2.631-13.305c-5.68 6.17-2.206 9.47-10.856 14.37m2.016-9.266c-3.572 4.089-2.818 6.985-9.455 9.142'/%3e%3cpath d='M1227.73-330.272s-14.622 8.38-26.106 15.072c-11.484 6.692-34.233 20.133-34.233 20.133s23.015-12.98 34.552-19.58a5074.411 5074.411 0 0 0 26.105-15.072'/%3e%3c/g%3e%3cpath d='M1182.237-442.008s19.633-7.97 34.124-3.98c14.49 3.991 20.024 16.337 27.455 20.653-8.594-.022-19.6 7.845-34.124 3.98-14.525-3.867-27.455-20.653-27.455-20.653zm58.653 15.881c-6.888-5.187-8.102-10.83-18.467-17.228m9.231 14.727c-6.888-5.187-7.667-11.928-18.301-17.843m7.217 14.842c-7.072-4.508-6.236-9.893-17.038-15.188m5.953 12.187c-7.072-4.509-4.56-8.588-14.176-11.11m4.324 8.442c-4.5-3.037-4.515-6.03-11.482-6.414m52.739 17.585c-8.564 1.003-12.46 5.264-24.636 5.557m15.4-8.058c-8.564 1.003-12.638 6.43-24.804 6.172m13.72-9.173c-8.381.324-10.375 5.395-22.373 4.517m11.288-7.518c-8.38.324-8.27 5.113-17.844 2.438m7.992-5.106c-5.419.352-6.94 2.928-13.15-.256'/%3e%3cpath d='M1250.057-423.975s-16.253-4.456-29.096-7.879c-12.843-3.422-38.416-10.07-38.416-10.07s25.434 7.161 38.25 10.686a5074.41 5074.41 0 0 0 29.095 7.878m-34.755-73.778s19.518 8.248 26.943 21.316c7.425 13.068 2.608 25.71 4.81 34.017-6.06-6.093-19.406-8.312-26.943-21.316-7.537-13.004-4.81-34.017-4.81-34.017zm30.245 52.705c-1.203-8.539 1.93-13.388-.877-25.241m-3.886 16.941c-1.203-8.539 3.013-13.856-.324-25.558m-5.391 15.598c-1.813-8.189 2.586-11.404-1.308-22.787m-4.408 12.827c-1.813-8.189 2.848-9.297-2.17-17.88m-2.911 9.027c-1.034-5.33 1.072-7.456-3.584-12.654m24.859 49.727c-6.765-5.347-12.532-5.089-21.35-13.492m16.587 5.192c-6.765-5.347-13.483-4.39-21.903-13.175m16.188 3.215c-6.156-5.697-11.151-3.521-19.015-12.626m13.299 2.666c-6.155-5.697-9.464-2.232-14.342-10.894m9.261 2.041c-4.08-3.583-6.978-2.837-9.117-9.48'/%3e%3cpath d='M1250.34-436.43s-8.342-14.644-15.003-26.145c-6.662-11.502-20.043-34.286-20.043-34.286s12.92 23.049 19.49 34.603a5040.778 5040.778 0 0 0 15.003 26.145'/%3e%3cuse xlink:href='%23h' width='744.094' height='1052.362' transform='translate(-32 -18)'/%3e%3cpath d='M1142.423-297.845s16.752 12.975 20.58 27.51c3.828 14.534-4.069 25.519-4.069 34.113-4.297-7.443-16.628-13.008-20.58-27.509-3.952-14.501 4.069-34.114 4.069-34.114zm15.727 58.695c1.025-8.56 5.296-12.445 5.621-24.622m-8.098 15.379c1.026-8.561 6.464-12.62 6.238-24.787m-9.21 13.695c.347-8.38 5.423-10.36 4.576-22.36m-7.547 11.268c.345-8.38 5.135-8.256 2.485-17.838m-5.128 7.979c.366-5.418 2.947-6.933-.221-13.15m11.284 54.436c-5.169-6.901-10.81-8.13-17.18-18.512m14.703 9.269c-5.168-6.902-11.907-7.698-17.795-18.348m14.823 7.256c-4.49-7.084-9.876-6.26-15.143-17.077m12.172 5.985c-4.49-7.084-8.576-4.582-11.072-14.205m8.429 4.346c-3.025-4.51-6.018-4.53-6.383-11.5'/%3e%3cpath d='M1160.894-230.142s-4.31-16.293-7.802-29.117c-3.491-12.825-10.587-38.278-10.587-38.278s6.582 25.59 9.97 38.443a5154.98 5154.98 0 0 0 7.803 29.117m-53.774 57.257s2.86-20.996 13.533-31.579c10.673-10.582 24.135-9.236 31.578-13.533-4.297 7.443-2.951 20.904-13.534 31.578-10.582 10.673-31.577 13.533-31.577 13.533zm42.968-42.97c-7.928 3.394-13.427 1.637-24.135 7.444m17.368-.677c-7.927 3.393-14.161.714-24.585 6.993m16.465 1.127c-7.43 3.89-11.684.485-21.653 7.218m13.533.902c-7.43 3.89-9.718-.319-16.69 6.767m9.472.451c-4.874 2.392-7.477.915-11.277 6.767m41.502-36.992c-3.393 7.928-1.637 13.428-7.444 24.135m.677-17.368c-3.393 7.928-.713 14.162-6.992 24.586m-1.128-16.466c-3.89 7.43-.484 11.684-7.218 21.654m-.902-13.534c-3.89 7.43.32 9.718-6.767 16.692m-.451-9.474c-2.391 4.875-.914 7.477-6.766 11.278'/%3e%3cpath d='M1155.9-222.569s-11.954 11.88-21.315 21.315c-9.36 9.436-27.856 28.308-27.856 28.308s18.871-18.496 28.307-27.857a5074.411 5074.411 0 0 0 21.315-21.315'/%3e%3cuse xlink:href='%23i' width='744.094' height='1052.362' transform='translate(-62 -40)'/%3e%3cuse xlink:href='%23i' width='744.094' height='1052.362' transform='translate(-31 -20)'/%3e%3c/g%3e%3cuse xlink:href='%23j' width='744.094' height='1052.362' transform='matrix(-1 0 0 1 2501 0)'/%3e%3cpath fill='%23947245' d='M1250.5-437.125c-8.62 41.666-8.594 79.156-8.594 79.156-.505 13.948-7.41 23.678-13.781 20-54.887-31.689-60.291-37.57-89.125-59.669 24.306 26.461 31.231 38.23 86.719 70.266 10.728 6.193 12.062 16.378 11.625 29.469l-1.688 61.716c-.302 9.035 5.747 50.084-22.562 34.218-65.373-36.637-63.772-33.585-95.094-51.669 38.074 32.327 24.373 23.468 90.594 61.7 11.943 6.896 24.531 24.497 24.531 32.844 0 124.331 1.865 101.486-12.813 139.096h60.376c-14.678-37.61-12.813-14.765-12.813-139.096 0-8.347 12.588-25.948 24.531-32.844 66.221-38.232 51.52-29.373 89.594-61.7-31.322 18.084-28.72 15.032-94.094 51.67-28.309 15.865-22.26-25.184-22.562-34.22l-1.688-61.715c-.437-13.09.897-23.276 11.625-29.47 55.488-32.035 62.413-43.804 86.719-70.265-28.834 22.099-34.238 27.98-89.125 59.67-6.37 3.677-13.276-6.053-13.781-20 0 0 .027-37.49-8.594-79.157z'/%3e%3c/g%3e%3cg stroke-width='2.727'%3e%3cpath fill='%23e3e4e5' stroke-linecap='square' d='M264.452 424.637c-.25.946 1.503 12.373.546 15.66-.508 4.54-.635 5.238-1.704 11.12-1.069 5.881-2.364 17.308-4.391 24.163-.17.576-.408 1.358-.452 2.042-.567 3.502-.584 5.981-.211 10.35l3.512 19.415s1.634 1.918 1.881 2.722c.247.804-.172 2.006-.006 2.25.927 1.362 1.074 2.702 2.177 3.848.173.18.92.107 1.118.356.171.216 1.485.3 1.74.466.784.74.646 1.276 1.049 2.404l-6.321.026c.162-2.822-2.057-3.938-2.057-3.938-.244-.308-2.823-1.017-3.121-2.683-.413-2.392-.068-2.869-.068-2.869s-2.115-9.062-2.996-11.33c-.504-1.758-.605-2.592-.855-4.127-.76-4.24-1.017-6.075-3.32-12.405-.547-1.097-1.987-1.453-1.869-2.898.154-.557.427-.979.701-1.462l.072-1.11c.336-5.183.625-10.384 1.056-15.547a1.85 1.85 0 0 0 .236-.741c.602-8.797-4.079-17.02-7.1-24.897-.548-1.43-.075-2.995-.696-4.423-3.214-1.108-5.415-6.475-6.563-9.854-1.122-3.303-1.617-8.284-.764-11.589.278-1.077.434-1.814.964-2.522m63.313 36.682c1.026-.24 1.416-.319 2.51-.308 0 0 .74 1.02.959 1.499 1.529 2.753 3.371 15.341 4.434 21.193.33 1.814 1.094 5.943 1.434 7.866 0 0-.377 2.066.288 4.345.203.695.426 1.387.609 2.085.803 3.062 1.716 3.813 1.716 3.813.214.733 1.468 6.751 1.681 7.484 1.842 8.241 2.741 13.212 2.623 16.652-.115 4.714-.09 4.254.284 4.639 1.037 1.068 1.567.406 3.787 6.085.133.454.265-.217.505.234.287.538.78.477 1.18.53.73.096.59.23 1.181.307a6.248 6.248 0 0 0 1.58.015l5.461.037c-.67-1.992-2.887-3.369-4.828-3.386-.857-.528-1.85-1.282-2.155-2.287-1.251-2.003-1.608-2.427-2.262-3.335.108-.722-.414-1.692-.64-2.47l-1.958-23.232s.403-2.328.372-4.745c-.164-12.768.578-25.616 1.05-38.434.16-1.074 4.04-4.71 4.04-4.71' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath fill='%23fff' stroke-linecap='square' d='M356.761 323.788a7.326 7.326 0 0 0-5.446 2.507c-1.794 2.469-2.968 7.56-3.099 10.618-.034.807.3 1.426.045 2.149-.871 2.471-1.585 4.615-1.643 4.946-.757 4.317-.911 19.802-2 25.736-1.09 5.933-6.098 14.56-7.965 17.344-1.227 1.365-3.757 2.059-4.535 2.236-.779.177-7.197-.484-7.197-.484-8.468-.595-21.063-5.268-29.51-6.407-8.447-1.14-18.667-.597-26.626-1.443 0 0-9.95-3.678-19.116-1.016-9.031 2.623-14.11 7.479-21.957 19.542 0 0-3.37 4.117-3.41 5.468-.134 4.435 1.779 10.02 5.205 12.835 1.104 1.07.809.112.714-.165.01.019.011.014.027.048.304.659.664 2.389 1.099 2.991 1.166 1.62 2.383 3.41 3.312 5.198.778 1.498.373 3.254 1.072 4.762 3.846 8.304 2.058 16.825 2.024 26.49a2.067 2.067 0 0 1-.206.833c-.105 5.681-5.654 13.287-5.654 18.98v1.22c-.265.554-.532 1.042-.66 1.664-.028 1.591-2.167 1.838-1.493 2.982 2.955 6.687 3.364 8.665 4.491 13.22.381 1.653.55 2.554 1.223 4.424 1.12 2.39 4.063 12.08 4.063 12.08s-.342.554.277 3.126c.442 1.79 3.302 2.311 3.59 2.623 0 0 2.664 1.635 2.687 4.733 0 .394 2.52.222 2.857.222 1.02 0 1.998-.155 3.018-.155-.124-1.296-.45-2.056-1.357-2.787-.29-.157-1.46-.537-1.661-.755-.234-.254-.423-.769-.625-.949-1.283-1.143-1.538-2.591-2.643-3.987-.198-.25.174-1.605-.152-2.459-.325-.854-2.24-2.787-2.24-2.787l-5.198-20.858c-.714-4.734 2.864-7.443 3.234-11.325 0-.75 4.58-12.156 4.812-12.776 3.32-8.9 8.794-22.846 8.68-28.717-.126-6.571-.255 1.27.342-3.706.45-3.747-1.757-13.77-1.552-14.829 12.43 20.753 24.519 28.246 44.457 26.269 1.088-.098 1.498-.124 2.58.029 0 0 .44 1.085.518 1.578.72 2.868-1.1 15.308-1.74 21.119-.2 1.801-.638 5.903-.858 7.81 0 0-.973 1.955-.973 4.25 0 .7.02 1.4 0 2.1-.09 3.073.598 3.92.598 3.92 0 .737-.5 6.735-.5 7.472-.56 8.229-1.153 12.11-2.268 15.428-.198.591-.694 1.442-1.303 1.607-.574.43-1.53 1.332-1.634 2.11 0 .671.066 1.276.205 1.878.103.446.565 1.177.821 1.548.381 1.768.197 3.614.197 5.42 0 .458.204 1.187.312 1.656.13.559.637.564 1.018.667.696.189.454.622 1.018.775.467.126 1.008.106 1.536.106l5.402.03c-.088-2.019-2.06-3.058-3.429-4.027-.697-.623-.632-.767-.643-1.781 0-1.29-.143-2.736-.143-4.027 0-.695.298-.964.563-1.539.316-.686.08-1.694.08-2.477 1.006-6.872 2.164-13.925 3.992-20.616 1.465-1.898 2.108-4.32 2.544-6.708 0 0 1.177-3.191.777-4.888l4.964-30.15c.471-1.02 1.293-1.93 2.384-2.225 6.187-2.727 12.294-4.578 18.117-8.624 6.305-4.382 10.088-11.538 14.58-17.984.987-1.913 2.142-3.583 3.26-5.371 3.857-5.536 8.702-20.028 10-27.217 1.533-8.488.92-16.881 3.384-26.937.529-2.157 2.354-3.884 2.777-6.117l-.044-.406 1.232-.165c1.317-.155 2.943-.421 3.875-.445.979-.12 2.985-.107 3.16-.107.175 0 1.224.223 1.84.223.51 0 1.347.542 1.857.542.544 0 .95-.094 1.304-.542.65-.821.724-.563.893-1.297.056-.244.312.005.437-.039.471-.165.849-.777 1.411-.929.376-.102.662-.241.732-.62.088-.476.098-1.008.098-1.548 0-.791-.032-.831-.607-.987-.074-.02-.137-.08-.205-.116-.595-.161.098-1.33.098-1.994 0-.677-.018-1.162-.196-1.549-.232-.502-.334-.707-.822-1.103-.359-.292-.54-.676-.92-.88-2.81-2.42-4.042-4.224-6.018-6.089.33-.412.273-.616.152-1.297-.902-2.728-2.637-3.233-5.562-5.45-2.733-1.578-6.308-3.295-10.099-3.648h-1.634a6.64 6.64 0 0 0-.402-.01z' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath fill='%23d18219' stroke='none' d='M438.616 251.458a2.003 2.003 0 0 0-1.493.691c-.491.682-.813 2.086-.849 2.93-.01.223.082.393.012.593-.239.682-.434 1.273-.45 1.364-.208 1.191-.25 5.464-.548 7.101-.299 1.637-1.638 4.049-2.184 4.785-.302.408-1.03.568-1.243.617-.214.05-1.973-.133-1.973-.133-2.321-.164-5.774-1.454-8.09-1.768-2.315-.314-5.117-.165-7.299-.398 0 0-2.728-1.015-5.24-.28-2.476.723-3.868 2.063-6.02 5.391 0 0-.923 1.136-.934 1.51-.036 1.2.467 2.705 1.373 3.495.017.014.296.194.313.208.04-1.935.353-2.857.353-2.857-.021.972.16 1.915.47 2.809.203.588.699 1.131 1.013 1.693.486 1.314.851 5.16 1.095 6.762.126.825-.494 3.606-.906 4.853-.799 2.419-1.15 4.591-.21 2.954.42-.73 2.02-3.79 2.842-6.64.822-2.85 1.624-4.5 1.374-5.08-.081-.188-.314-4.142-.367-4.296a2.36 2.36 0 0 1-.07-.24c-.022-.091-.078-.165-.018-.479l.39-2.024c4.024 7.526 10.439 8.46 14.79 3.202-.655 2.134-.683 5.237-.606 6.545.076 1.309.066.749.044 1.207l-.769 7.184-.068.141s-.174.395-.174.767c0 .175.007.376 0 .606-.01.337-.003.525.04.577l.124.154a7.54 7.54 0 0 1-.025.767c-.005.086-.014.197-.022.296l.096-.12c.269-.338.418-.858.529-1.469 0 0 .008-.054.014-.077a4.054 4.054 0 0 0 .144-.473c.054-.222.064-.422.064-.422l-.041-.179.03-.181s1.358-8.274 1.36-8.319a.773.773 0 0 1 .071-.232c.26-.365.842-.773 1.057-1.023.221-.255 1.022-3.622.901-5.722-.278-4.815 6.057-6.183 8.178-3.806.796-.431 1.462-1.051 2.03-1.8.537-.709.98-1.538 1.355-2.44.05-.181.112-.377.157-.548.117-.454.21-.87.274-1.223.052-.293.095-.586.132-.878.037-.293.069-.587.096-.882.053-.59.092-1.185.14-1.794.047-.61.102-1.231.188-1.875a20.739 20.739 0 0 1 .372-2.003c.036-.149.094-.289.164-.427.069-.138.148-.273.227-.409.08-.135.157-.27.223-.41a1.89 1.89 0 0 0 .147-.441l-.012-.113.217-.029c.002-.006.002-.015.003-.021-1.025.215-.564.05-1.554.181-.293 0-.541-.017-.776-.12-.5-.351-.921-.813-1.136-1.42 0-.68.221-1.975.407-2.324.617-1.156 1.122-.28 2.349.06 1.166.325 2.907 1.238 3.564 1.87.076.074.962.116 1.05.068.065-.036.136-.025.203-.048.001-.018.011-.038.015-.057.003-.016 0-.027.005-.045.027-.109.073-.237.073-.328a2.39 2.39 0 0 0-.01-.238.646.646 0 0 0-.044-.192 1.029 1.029 0 0 0-.066-.123.639.639 0 0 0-.159-.182c-.098-.08-.148-.186-.252-.243-.77-.667-1.108-1.165-1.65-1.68.09-.113.075-.17.042-.357-.248-.753-.723-.892-1.525-1.504-.75-.435-1.73-.91-2.768-1.007h-.448a1.832 1.832 0 0 0-.11-.002z'/%3e%3cpath fill='none' stroke-linecap='square' d='M356.761 323.788a7.326 7.326 0 0 0-5.446 2.507c-1.794 2.469-2.968 7.56-3.099 10.618-.034.807.3 1.426.045 2.149-.871 2.471-1.585 4.615-1.643 4.946-.757 4.317-.911 19.802-2 25.736-1.09 5.933-6.098 14.56-7.965 17.344-1.227 1.365-3.757 2.059-4.535 2.236-.779.177-7.197-.484-7.197-.484-8.468-.595-21.063-5.268-29.51-6.407-8.447-1.14-18.667-.597-26.626-1.443 0 0-9.95-3.678-19.116-1.016-9.031 2.623-14.11 7.479-21.957 19.542 0 0-3.37 4.117-3.41 5.468-.134 4.435 1.779 10.02 5.205 12.835 1.104 1.07.809.112.714-.165.01.019.011.014.027.048.304.659.664 2.389 1.099 2.991 1.166 1.62 2.383 3.41 3.312 5.198.778 1.498.373 3.254 1.072 4.762 3.846 8.304 2.058 16.825 2.024 26.49a2.067 2.067 0 0 1-.206.833c-.105 5.681-5.654 13.287-5.654 18.98v1.22c-.265.554-.532 1.042-.66 1.664-.028 1.591-2.167 1.838-1.493 2.982 2.955 6.687 3.364 8.665 4.491 13.22.381 1.653.55 2.554 1.223 4.424 1.12 2.39 4.063 12.08 4.063 12.08s-.342.554.277 3.126c.442 1.79 3.302 2.311 3.59 2.623 0 0 2.664 1.635 2.687 4.733 0 .394 2.52.222 2.857.222 1.02 0 1.998-.155 3.018-.155-.124-1.296-.45-2.056-1.357-2.787-.29-.157-1.46-.537-1.661-.755-.234-.254-.423-.769-.625-.949-1.283-1.143-1.538-2.591-2.643-3.987-.198-.25.174-1.605-.152-2.459-.325-.854-2.24-2.787-2.24-2.787l-5.198-20.858c-.714-4.734 2.864-7.443 3.234-11.325 0-.75 4.58-12.156 4.812-12.776 3.32-8.9 8.794-22.846 8.68-28.717-.126-6.571-.255 1.27.342-3.706.45-3.747-1.757-13.77-1.552-14.829 12.43 20.753 24.519 28.246 44.457 26.269 1.088-.098 1.498-.124 2.58.029 0 0 .44 1.085.518 1.578.72 2.868-1.1 15.308-1.74 21.119-.2 1.801-.638 5.903-.858 7.81 0 0-.973 1.955-.973 4.25 0 .7.02 1.4 0 2.1-.09 3.073.598 3.92.598 3.92 0 .737-.5 6.735-.5 7.472-.56 8.229-1.153 12.11-2.268 15.428-.198.591-.694 1.442-1.303 1.607-.574.43-1.53 1.332-1.634 2.11 0 .671.066 1.276.205 1.878.103.446.565 1.177.821 1.548.381 1.768.197 3.614.197 5.42 0 .458.204 1.187.312 1.656.13.559.637.564 1.018.667.696.189.454.622 1.018.775.467.126 1.008.106 1.536.106l5.402.03c-.088-2.019-2.06-3.058-3.429-4.027-.697-.623-.632-.767-.643-1.781 0-1.29-.143-2.736-.143-4.027 0-.695.298-.964.563-1.539.316-.686.08-1.694.08-2.477 1.006-6.872 2.164-13.925 3.992-20.616 1.465-1.898 2.108-4.32 2.544-6.708 0 0 1.177-3.191.777-4.888l4.964-30.15c.471-1.02 1.293-1.93 2.384-2.225 6.187-2.727 12.294-4.578 18.117-8.624 6.305-4.382 10.088-11.538 14.58-17.984.987-1.913 2.142-3.583 3.26-5.371 3.857-5.536 8.702-20.028 10-27.217 1.533-8.488.92-16.881 3.384-26.937.529-2.157 2.354-3.884 2.777-6.117l-.044-.406 1.232-.165c1.317-.155 2.943-.421 3.875-.445.979-.12 2.985-.107 3.16-.107.175 0 1.224.223 1.84.223.51 0 1.347.542 1.857.542.544 0 .95-.094 1.304-.542.65-.821.724-.563.893-1.297.056-.244.312.005.437-.039.471-.165.849-.777 1.411-.929.376-.102.662-.241.732-.62.088-.476.098-1.008.098-1.548 0-.791-.032-.831-.607-.987-.074-.02-.137-.08-.205-.116-.595-.161.098-1.33.098-1.994 0-.677-.018-1.162-.196-1.549-.232-.502-.334-.707-.822-1.103-.359-.292-.54-.676-.92-.88-2.81-2.42-4.042-4.224-6.018-6.089.33-.412.273-.616.152-1.297-.902-2.728-2.637-3.233-5.562-5.45-2.733-1.578-6.308-3.295-10.099-3.648h-1.634a6.64 6.64 0 0 0-.402-.01z' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath fill='%23d39044' stroke-linecap='square' d='M382.265 343.818c0 .332-.169.795-.268 1.19-.015.064-.007.106-.017.165.083-.398.294-.837.294-1.22 0-.048-.009-.088-.009-.135z' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath fill='%23fff' fill-rule='evenodd' d='M334.948 432.87c-2.059 8.327-7.182 10.024-3.42 17.087 0 0-1.618-.118-2.592-2.837-.487-1.36-.813-3.37-.696-6.343.059-1.486.228-3.212.544-5.218.158-1.002.352-2.075.587-3.222' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath fill='%23fff' fill-rule='evenodd' d='M338.745 429.429c-2.058 8.327-7.182 10.024-3.42 17.087 0 0-2.025-.03-2.999-2.75-.487-1.359-.838-3.642-.858-5.371-.02-1.73.45-4.684.788-5.924.337-1.24 1.238-3.31 1.238-3.31' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath fill='%23fff' fill-rule='evenodd' d='M345.773 418.39c-2.934 5.509-5.297 10.213-6.52 14.3-1.225 4.089-1.996 6.272.31 10.602 0 0-1.567-.817-3.628-4.632-.65-1.204-1.086-3.867-.789-6.592a30.55 30.55 0 0 1 .776-4.396 30.07 30.07 0 0 1 .79-2.58' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath fill='%23fff' fill-rule='evenodd' d='M348.502 414.884c-1.818 2.792-2.406 5.465-3.414 7.733-2.016 4.537-3.085 7.944-3.085 10.44 0 2.029-.357 3.709 1.905 7.156 0 0-1.061-.124-1.753-.543-.692-.419-1.56-1.194-2.269-2.62-.708-1.427-1.255-3.504-1.303-6.527-.024-1.511.478-3.745.89-5.217.413-1.473 1.807-4.55 1.807-4.55' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath fill='%23d18219' fill-rule='evenodd' stroke-width='1.364' d='M353.27 334.537c.119-.233-11.574-3.636-13.242-13.858 2.275-2.15 14.25 5.702 14.438 12.987' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath fill-opacity='.502' fill-rule='evenodd' stroke-width='1.364' d='M340.423 320.825c.093.205 6.265.184 11.133 10.596-1.095-1.244-6.04 1.675-11.092-10.204' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath fill-rule='evenodd' stroke-width='1.364' d='M368.707 335.545c.165-.134.396-.452.122-.75-5.102-3.192-4.857.706-8.443.706 1.71 0 1.706.234 2.345.926 2.32 2.515 3.917 2.265 5.976-.176' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath fill='none' stroke-linecap='square' d='M381.193 349.763c-.565.67-2.538-.793-3.984-.967' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath fill-rule='evenodd' stroke-linecap='square' d='M382.326 345.923s-.54-.438-4.32-.932c.004.07 2.605-2.673 2.835.29' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath fill='%23fff' fill-rule='evenodd' d='M302.663 436.88a33.59 33.59 0 0 0-.914 1.815c-1.068 2.348-1.409 4.538.472 8.069 0 0-1.617-.117-2.591-2.837-.487-1.36-.813-3.37-.696-6.343.03-.743.086-1.546.175-2.414' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3cpath fill='none' d='M230.708 419.108s-1.55-6.161 2.09-13.014' transform='matrix(.27413 0 0 .2759 340.815 162.125)'/%3e%3c/g%3e%3cg fill='%23e7ca00' stroke-width='2.294'%3e%3cpath d='M401.415 879.458c-2.045-1.515-4.023-6.243-3.27-8.842-2.694-2.22-9.659 2.184-6.276 8.588 3.354 6.388 7.986 5.85 9.57.267l-.024-.013zm19.104 6.009c.56-3.612-.686-9.663-6.934-10.747-6.235-1.067-8.153 4.548-6.958 10.324 4.5-3.395 11.623-1.683 13.892.423z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M407.416 882.052c1.063-4.786 5.835-6.083 10.57-5.594-2.96-3.38-6.044-8.823-10.264-5.651-3.317 2.504-5.617 6.151-.299 11.225l-.008.02z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M404.77 879.344c.56-3.612 2.025-8.456 5.93-10.433-3.367-3.054-11.69-2.136-12.302 4.1-.632 6.231 3.047 7.49 6.383 6.307l-.01.026zm-15.883 40.031c5.28.85 12.283-1.796 10.307-13.708-1.878-11.299-10.192-14.04-10.816-11.348 4.77 1.667 4.154 17.65.475 25.103l.034-.047z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M396.765 918.122c5.294.946 13.706-2.13 9.908-13.822-3.71-11.462-12.224-10.052-12.808-7.164 4.779 1.845 6.512 13.045 2.871 21.008l.03-.022z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M376.728 918.168c3.859 3.455 13.822 4.688 17.015-6.829 3.011-10.905.276-14.41-3.62-16.18 1.943 5.672-5.07 21.665-13.412 22.991l.018.018zm25.423-.973c3.263-1.816 10.612-5.074 5.805-16.066-3.936-8.966-10.087-5.15-11.753-3.603 4.31 1.812 8.14 11.493 5.948 19.67z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M409.224 914.63c3.051-2.059 10.717-7.101 4.569-17.83-6.09-10.543-14.194-3.537-14.215-.648 3.563.888 9.641 9.955 9.673 18.46l-.027.017z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M416.718 907.263c2.017-2.81 7.176-9.719-.7-16.792-7.758-6.967-12.759 1.783-12.047 4.285 3.199-.447 10.595 5.25 12.77 12.52l-.023-.013z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M421.176 896.276c.56-3.612 2.045-12.624-7.034-14.705-8.902-2.034-9.573 8.603-8.069 10.431 2.395-2.185 10.557-1.078 15.103 4.274zm-50.284 18.646c3.375 4.144 13.412 7.063 18.657-4.145 4.966-10.665 2.772-14.71-.953-17.146 1.016 6.117-8.907 21.318-17.712 21.318l.009-.027z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M360.848 906.698c3.225 6.56 19.288 14.058 25.522 1.927 5.916-11.504 1.012-22.081-3.9-26.14 2.33 11.768-12.11 29.737-21.626 24.184l.004.029z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M352.366 898.402c7.864 17.16 24.132 14.152 29.643 1.691 5.229-11.823 3.75-18.756-2.177-24.424-4.094 15.2-12.2 23.738-27.49 22.705l.024.028z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M341.921 884.056c5.964 21.484 27.137 18.887 36.131 6.547 6.355-8.705 4.117-15.146.905-18.94-6.961 8.212-18.98 15.534-37.069 12.368l.033.025z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M337.98 870.931c.633 21.914 26.07 24.33 37.372 11.791 7.983-8.845 7.368-15.426 5.227-19.305-8.432 8.338-25.238 18.384-42.626 7.488l.026.026z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M332.703 850.203c-3.87 28.348 29.128 37.617 43.467 20.689 7.698-9.07 7.333-15.432 5.2-19.31-14.3 10.02-39.159 11.185-48.688-1.376l.021-.003z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M329.46 823.53c-9.486 30.632 19.29 41.583 38.047 38.528 14.855-2.403 23.204-19.886 21.094-23.738-18.552 13.087-55.366 1.82-59.157-14.759l.016-.032z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M329.06 799.67c-12.676 29.897 15.364 47.446 38.583 45.69 15.216-1.153 27.753-7.06 27.202-19.552-22.745 8.013-58.219-5.432-65.807-26.134l.021-.004z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M329.966 774.93c-12.693 30.576 14.747 55.711 43.465 56.342 14.648.316 21.34-3.593 27.196-13.299-20.73 3.532-64.889-27.938-70.661-43.044z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M329.57 765.272c-11.333 35.923 80.312 80.423 84.993 33.705-21.913 11.482-81.753-20.668-84.992-33.705z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M327.523 755.606c-15.379 19.757 93.055 78.167 95.506 28.363-9.762 5.009-29.87.684-49.265-8.106-19.38-8.787-33.155-22.855-46.237-20.233l-.005-.024z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M310.962 751.12c19.613.483 61.382 30.938 89.302 36.03 17.874 3.25 32.459-4.197 24.146-35.544-28.487 29.115-82.917-17.824-111.77-6.766-2.968-1.407.62 8.346-1.655 6.276l-.023.004z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M314.738 755.54c19.01-11.796 58.328 10.083 86.15 11.273 17.08.697 38.39-18.62 24.406-47.052-21.874 37.6-82.887 7.493-108.6 27.333-1.927 4.301-.85 9.998-1.984 8.422l.028.025z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M307.104 756.761c20.232-14.78 61.569-6.196 88.05-8.343 17.572-1.444 43.746-32.009 19.805-57.475-14.86 53.842-64.483 27.223-107.269 58.258-2.12 5.473.796 8.86-.59 7.531l.005.03z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M314.385 751.966c16.663-15.72 57.604-14.669 81.93-27.066 16.32-8.304 32.874-43.645 4.386-61.42-2.962 56.707-55.186 38.963-87.452 80.94-.782 6.006 2.732 8.47 1.112 7.55l.025-.003z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M316.126 744.463c12.345-22.09 50.302-27.61 70.82-45.993 18.351-16.443 23.318-46.355-7.626-55.908-2.63 59.192-43.855 46.685-60.74 82.265-3.214 7.812-1.534 20.485-2.45 19.665l-.004-.029z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cpath d='M325.504 721.914c12.654-20.094 22.161-13.181 42.356-33.822 17.383-17.772 22.62-60.366-7.793-61.346 4.545 51.455-15.245 51.997-29.134 79.625.503 6.14-3.665 15.957-5.404 15.54l-.025.003z' transform='matrix(.02666 -.34238 .30978 .02947 204.1 441.756)'/%3e%3cg stroke-width='3.041'%3e%3cpath fill-rule='evenodd' d='m310.424 602.663-10.497 5.67-49.929 153.76 18.14 40.066 17.139 2.478 20.712-1.52 30.737-138.479 8.666-56.418-21.061-12.406-13.907 6.85z' transform='matrix(.01816 -.28057 .21499 .02864 268.014 416.628)'/%3e%3cpath d='M309.263 597.474c.415 2.04.853 4.105 1.293 6.14 9.833-6.845 20.436-.176 23.345 15.636 2.902 15.806-3.027 38.861-13.668 56.633-6.681 14.63-14.639 32.223-16.986 56.246-1.823 18.767 1.856 41.713-2.283 62.595-2.528 10.013-7.857 9.093-18.2 8.451 4.162 6.833 9.334 10.587 16.036 10.365 14.42-3.208 24.74-16.165 28.494-44.84-4.283-23.95-3.188-47.936 9.852-72.08 11.634-11.987 22.336-25.543 26.268-49.987 1.883-12.145-.47-25.209-9.616-39.046-11.482-17.358-20.812-17.994-29.61-16.439-4.964 2.075-9.942 4.22-14.925 6.326z' transform='matrix(.01816 -.28057 .21499 .02864 268.014 416.628)'/%3e%3c/g%3e%3cpath fill-rule='evenodd' stroke-width='.5' d='M-325.656 629.664c.001-3.088 2.01-5.59 4.489-5.59 2.478 0 4.487 2.502 4.488 5.59h-8.977z' transform='matrix(1.42023 .479 .59921 -1.38227 519.312 1387.444)'/%3e%3cpath d='M295.504 723.041c-3.802 7.233-11.304 10.594-16.734 7.42-5.396-3.156-6.684-11.681-2.921-18.968 3.798-7.261 11.303-10.593 16.734-7.42 5.395 3.156 6.683 11.682 2.921 18.968zm-18.947-81.975c-2.604-3.571-6.329-5.807-10.315-5.098-2.38.416-4.722 1.872-6.674 3.928-.077-.335-.154-.67-.206-1.009-1.39-7.709 4.797-16.772 11.401-17.96 2.956-.504 5.787.562 8.115 2.677-1.25 2.797-1.784 5.89-1.26 8.804a15.217 15.217 0 0 0 1.071 3.588 18.318 18.318 0 0 0-2.107 5.066l-.025.003z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M300.305 632.437c-2.852-3.625-6.749-5.866-11.004-5.267-4.033.568-7.999 3.659-10.677 7.768a18.765 18.765 0 0 1-1.132-4.147c-1.379-8.954 6.038-19.14 13.72-20.221 1.936-.273 3.81.037 5.537.831a15.64 15.64 0 0 0 .075 4.016c.624 4.048 2.48 7.614 5.04 10.154-.948 2.18-1.497 4.524-1.564 6.837l.004.029zm-42.258 44.938c-.141.19-.302.418-.445.637-3.207-.469-6.187-2.176-8.529-4.746 2.477 2.462 5.648 3.974 8.97 4.08l.004.029zm6.708-13.625c-4.083-2.303-7.247-6.804-8.091-12.286-1.336-8.673 5.853-18.57 13.294-19.617a9.12 9.12 0 0 1 2.192-.044c-2.664 3.71-4.224 8.47-3.54 12.915.442 2.867 1.507 5.478 3.055 7.652-3.307 2.732-5.946 6.931-6.89 11.347l-.02.033z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M258.333 689.203c-2.006.599-4.083.405-5.87-.778-4.37-2.896-5.54-10.496-2.61-16.944 2.96-6.423 8.955-9.313 13.354-6.392 1.681 1.11 2.896 2.926 3.583 5.133a7.544 7.544 0 0 0-5.375.382c-4.698 2.155-7.138 8.593-5.42 14.328a11.05 11.05 0 0 0 2.343 4.3l-.004-.03z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M262.393 693.964c-3.06-.953-5.817-3.465-7.408-7.237-2.952-6.974-.85-15.61 4.763-19.248 2.876-1.84 6.1-2.036 8.974-.859-.526 3.151-.222 6.56 1.094 9.65 1.357 3.231 3.617 5.555 6.195 6.745-2.549-.671-5.28-.316-7.754 1.269-3.12 2.021-5.157 5.613-5.848 9.619l-.016.061zm-5.114 49.445c-7.009-4.475-11.336-13.985-9.674-21.123 1.4-5.975 6.675-8.44 12.495-6.39-2.556 5.19-3.25 11.933-1.444 18.2 1.494 5.228 4.476 9.203 8.076 11.404-2.763.647-6.115.052-9.429-2.095l-.024.003z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M251.674 769.938a12.338 12.338 0 0 1-.917-.99c-5.64-6.455-7.08-16.8-3.218-22.981 3.619-5.802 10.678-5.957 16.217-.642-2.971 6.512-2.259 15.325 1.637 22.195-3.235-1.473-6.876-1.563-10.343.132a14.099 14.099 0 0 0-3.352 2.282l-.024.003z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M268.083 783.814c-5.381-.309-10.723-6.313-12.475-14.487-1.953-9.153 1.305-17.664 7.28-18.91l.266-.037c2.876 4.717 7.182 7.526 11.73 7.725.033.047.066.1.105.184-6.72 4.626-9.86 15.335-7.062 25.003.05.162.101.332.156.522zm-2.875-66.22c-6.588 2.105-14.435-2.685-17.468-10.685-3.008-7.997-.113-16.28 6.5-18.396 1.694-.526 3.484-.6 5.256-.335 1.523 4.76 4.285 8.457 7.625 10.57-1.374 4.536-1.511 9.759-.05 14.727.264.942.58 1.847.956 2.685-.853.576-1.786 1.082-2.823 1.405l.004.029z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M269.946 727.884c-7.013-4.51-11.361-13.99-9.673-21.123 1.673-7.11 8.767-9.257 15.78-4.754 2.025 1.297 3.856 3.048 5.367 5.022-4.177 5.416-5.767 13.84-3.536 21.6.128.504.303 1.023.48 1.514-2.54.328-5.486-.376-8.418-2.26z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M284.7 750.888c-3.681 7.63-11.189 10.503-16.705 6.352-5.491-4.115-6.942-13.723-3.283-21.381 3.681-7.63 11.188-10.503 16.704-6.352 5.486 4.115 6.941 13.715 3.284 21.381zm-9.266-47.746c-3.779 1.886-7.908 2.151-11.274.358-6.168-3.363-7.576-12.505-3.14-20.38 3.15-5.529 8.39-8.998 13.392-9.385 2.208 1.985 5.027 2.972 7.878 2.57.168.146.341.328.495.505-7.94 3.422-12.165 13.327-9.413 22.051a16.01 16.01 0 0 0 2.034 4.263l.028.018z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M284.18 666.044c1.218 7.903-4.118 15.27-10.446 16.162-6.308.888-12.472-4.831-13.693-12.763-.864-5.605 1.874-11.709 5.799-15.11 2.616 4.35 6.942 6.957 11.389 6.33 1.595-.224 3.156-.841 4.56-1.82a23.142 23.142 0 0 1 2.367 7.204l.024-.003z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M287.201 705.726c-5.672 2.926-12.188-1.39-14.474-9.664-2.285-8.275.45-17.434 6.142-20.392 1.763-.903 3.602-1.11 5.392-.73a25.498 25.498 0 0 0-1.654 3.538c-3.388 9.103-1.72 20.056 3.749 24.342.9.713 1.867 1.21 2.867 1.466a9.937 9.937 0 0 1-2.001 1.408l-.02.032z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M304.5 667.948c.426 2.76-.017 5.464-1.083 7.859-5.203-3.176-12.142.017-15.889 7.242-4.182-1.796-7.535-6.13-8.367-11.533-1.183-7.679 5.123-16.42 11.7-17.457.027.342.078.674.13 1.012 1.146 7.435 7.098 12.89 13.466 12.427l.064.418-.02.032z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M303.513 696.658c-4.26 9.226-12.873 13.369-19.195 9.203-6.288-4.15-7.974-15.092-3.725-24.346 4.26-9.226 12.872-13.375 19.196-9.202 6.288 4.15 7.974 15.092 3.724 24.345zm-14.131-41.438c-1.417 2.99-3.648 5.49-6.347 6.878-6.282 3.152-13.95-.31-17.067-7.746-3.098-7.44.944-18.534 7.22-21.721 2.655-1.353 5.524-1.146 8.18.055-.028.151-.056.295-.079.475-1.667 9.692 1.944 19.186 8.093 22.06zm31.228-41.083c.4 2.594.033 5.177-.908 7.437-2.47-3.075-5.82-4.959-9.444-4.448-4.329.61-8.583 4.542-10.675 9.378-2.219-2.219-3.83-5.297-4.372-8.812-1.197-7.774 5.22-16.611 11.888-17.55 6.643-.935 12.326 6.176 13.526 13.97l-.015.025z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M322.452 630.627c1.01 6.556-3.192 12.756-8.577 14.633-2.38-3.426-5.837-5.648-9.628-5.114a9.624 9.624 0 0 0-2.845.894c-1.484-1.919-2.569-4.327-2.985-7.028-1.13-7.341 4.957-15.736 11.26-16.623 6.308-.888 11.69 5.862 12.824 13.231l-.05.007z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M293.229 654.4c-3.093 1.87-6.583 2.104-9.461.235-5.117-3.394-6.486-12.284-3.047-19.782 3.457-7.501 10.464-10.872 15.58-7.486 2.723 1.802 4.368 5.14 4.824 9.044-5.169 3.775-8.978 11.09-7.955 17.732l.04.259.019-.003zm-36.75 144.27c-5.803 2.083-12.089-2.383-14.383-10.509-2.41-8.633.555-18.22 6.643-21.323 5.695-2.9 12.154.88 14.95 8.45-6.2 4.464-9.267 14.214-7.215 23.353l.004.03z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M270.605 803.782c-6.263 2.781-13.224-1.096-15.517-8.766-2.294-7.67.943-16.318 7.258-19.217 5.442-2.496 11.415.057 14.436 5.725-5.846 4.71-8.578 13.89-6.18 22.237l.003.021z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M267.557 817.92c-5.657 2.577-11.968-.899-14.041-7.797-1.382-4.663-.507-9.733 1.976-13.306 3.978 3.385 9.068 4.39 13.799 2.083a14.505 14.505 0 0 0 3-1.976 14.325 14.325 0 0 1 1.746 3.78c.713 2.373.828 4.889.445 7.24-2.093 2.252-3.666 5.204-4.587 8.498-.7.585-1.49 1.071-2.338 1.478zm8.526 29.36c-6.371 2.907-13.464-1.01-15.799-8.786-2.325-7.754.966-16.497 7.33-19.403.46-.212.951-.391 1.45-.52a26.64 26.64 0 0 0 .932 9.415c2.072 7.178 6.908 11.988 12.306 13.068-1.376 2.755-3.518 5.014-6.215 6.255l-.004-.028z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M285.171 848.437c-6.135 2.792-12.96-.987-15.2-8.466a17.692 17.692 0 0 1-.001-9.943c4.011 3.6 9.243 4.704 14.112 2.348 2.663-1.295 4.898-3.48 6.55-6.207a16.606 16.606 0 0 1 1.591 3.596c2.239 7.479-.92 15.858-7.051 18.672z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M293.142 863.357c-6.142 2.793-12.968-.993-15.207-8.472-.611-2.041-.808-4.14-.683-6.197 2.383.415 4.88.086 7.294-1.056 4.181-2.024 7.283-6.259 8.816-11.362 3.03 1.414 5.585 4.388 6.8 8.42 2.238 7.471-.914 15.85-7.045 18.67l.025-.003zm-20.183-77.303c-2.764-1.739-5.05-4.729-6.214-8.59-2.452-8.252 1.007-17.505 7.788-20.616 6.75-3.108 14.31 1.09 16.794 9.337 1.87 6.236.33 13.062-3.474 17.366-3.14-1.972-6.987-2.409-10.58-.754-1.641.753-3.098 1.878-4.314 3.257zm46.864-134.414c1.07 6.56-5.47 16.885-12.166 18.31-6.695 1.424-10.884-1.834-13.949-6.191-3.064-4.357-4.273-10.017-2.61-15.188 1.663-5.171 6.083-10.364 10.441-12.278 4.358-1.915 7.371-1.174 10.919 1.74 3.547 2.914 6.296 7.046 7.365 13.606z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M285.163 808.599c-6.136 2.785-12.968-.993-15.207-8.472-2.231-7.473.92-15.851 7.052-18.673 6.135-2.792 12.961.994 15.195 8.438 2.239 7.479-.913 15.857-7.044 18.678l.004.029z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3cpath d='M283.132 834.193c-6.042 2.742-12.815-.985-15.011-8.352-2.197-7.368.9-15.657 6.962-18.432 6.043-2.779 12.81.956 15.01 8.345 2.197 7.368-.893 15.656-6.96 18.439z' transform='matrix(.02666 -.34324 .30978 .01956 205.666 443.535)'/%3e%3c/g%3e%3c/g%3e%3cpath fill='%23e7ca00' stroke='%23d4af37' stroke-width='.75' d='m409.148 236.484-.492.61-19.765 24.61-.43.538.5.477c6.348 6.046 10.027 16.339 10.039 24.601.016 10.524-1.697 17.768-3.828 24.43-2.945 9.203-6.749 17.31-7.922 30.79-.87 10.002 2.735 17.795 7.367 23.42 4.632 5.627 10.27 9.118 13.617 10.696 10.277 4.846 20.881 3.175 31.477 4.531 4.707.603 7.3 3.549 9.742 6.141l.547.578.547-.578c2.442-2.592 5.035-5.538 9.742-6.14 10.596-1.357 21.2.314 31.477-4.532 3.347-1.578 8.985-5.07 13.617-10.695 4.632-5.626 8.238-13.42 7.367-23.422-1.173-13.479-4.977-21.586-7.922-30.789-2.131-6.662-3.844-13.906-3.828-24.43.012-8.262 3.69-18.555 10.04-24.601l.5-.477-.43-.539-19.766-24.61-.492-.609-.586.516c-6.065 5.3-13.055 7.214-20.04 6.914-6.984-.3-13.953-2.845-19.828-6.492l-.398-.242-.398.242c-5.875 3.647-12.844 6.193-19.829 6.492-6.984.3-13.974-1.614-20.039-6.914l-.586-.516zm.211 2.125c6.226 5.172 13.403 7.108 20.477 6.805 6.851-.294 13.601-2.637 19.414-6.031v72.054h-52.414c2.045-6.542 3.68-13.83 3.664-24.117-.013-8.482-3.597-18.715-10.031-25.18l18.89-23.53zm81.282 0 18.89 23.532c-6.434 6.464-10.018 16.697-10.031 25.18-.016 10.286 1.619 17.574 3.664 24.116H450.75v-72.054c5.813 3.394 12.563 5.737 19.414 6.031 7.074.303 14.251-1.633 20.477-6.805zm-94.29 74.328h107.297c2.937 9 6.479 16.826 7.602 29.727.834 9.582-2.579 16.945-7.023 22.344-4.445 5.398-9.941 8.799-13.102 10.289-9.792 4.617-20.157 3.015-31.023 4.406-4.884.625-7.775 3.551-10.102 6.024-2.327-2.473-5.218-5.399-10.102-6.024-10.866-1.39-21.231.21-31.023-4.406-3.16-1.49-8.657-4.89-13.102-10.29-4.444-5.398-7.857-12.761-7.023-22.343 1.123-12.901 4.665-20.727 7.602-29.726z'/%3e%3cg fill='%23008f4c'%3e%3cpath fill='%2300a854' d='M524.96 203.558c-.109.012-.18.051-.211.13-.143.495-.574 3.182-.86 5.936-.214 2.753-.569 5.01-.64 5.01-.071 0-1.575-.634-3.36-1.41-4.354-1.907-13.421-2.968-13.921-1.627-.357.847.647 5.646 2.289 11.153.357 1.2-.07 1.56-2.64 2.336-1.714.494-3.646 1.339-4.36 1.904-1.214.847-1.07 1.13 2 3.954l3.36 3.037-1.579 1.272c-1.499 1.2-1.496 1.197 3.93 6.351 5.997 5.649 9.118 7.377 13.187 7.377 1.25 0 2.637.234 3.64-.054 1.336-.23 2.382-.68 5.665-1.033 3.548.312 7.041 2.05 8.445 2.82.345.76.639 1.446.86 2.013-2.539-2.755-8.164-3.851-9.336-3.893-1.173-.042-1.768.271-3.024.655s-1.735.964-2.93 2.621c-.856 2.189.844 4.466 2.914 4.748 2.57.353 4.493-1.061 4.493-3.391 0-1.907-1.094-3.283-.196-3.215 3.132.238 7.838 2.72 8.766 5.897 1.07 3.954.857 4.17-1.07 1.488-1.785-2.33-4.573-4.809-5.43-4.88-.643 0-2.07 3.464-2.07 5.088 0 1.059-.283 1.27-1.211.917-.714-.353-2.287-.707-3.5-.848l-2.211-.354.57 3.53c.286 1.906 1.215 4.806 2 6.359l1.5 2.89-3.43-1.056c-7.353-2.259-6.85-2.334-6.351 1.55.214 1.906.645 4.028.86 4.663.428 1.06.068 1.272-2.43 1.272-1.642 0-2.93.212-2.93.424 0 1.624 5.785 9.318 8.64 11.577 3.499 2.683 10.14 5.65 12.782 5.65.785 0 3.138.633 5.351 1.48l3.93 1.41v4.24c0 4.66-1.434 14.052-2.219 14.052-.214 0-1.496-1.977-2.781-4.448-2.927-5.366-2.785-5.294-3.57-4.024-.572.848-.711.777-.711-.423 0-2.048-3.29-8.19-5.36-10.167l-1.71-1.627-.86 1.904-.852 1.835-3.859-4.232c-2.142-2.33-4.136-4.097-4.422-3.885-.357.141-.784 2.052-1.07 4.17-.714 6.143-1.003 6.491-3.36 4.232l-2-1.904-.5 1.904c-.856 3.389.22 15.32 1.72 19.486.785 2.188 1.781 6.218 2.28 8.972.857 5.295 3.928 11.364 7.712 15.177 1.356 1.412 1.567 1.973.71 1.973-.57 0-1.568.566-2.21 1.272-2.785 3.036-.213 6.989 4 6.212 2.07-.353 2.496-.212 3.21 1.342 1.071 2.259 1.14 6.359.141 8.124-.714 1.341-4.927 3.103-5.64 2.397-.215-.212-.353-2.612-.282-5.295l.07-4.872-3.64 1.912c-8.781 4.66-16.167 16.664-18.047 25.914-.627 3.087-2.402 3.427-4.632 7.083-2.182 1.236-4.308 2.859-6.375 4.988-3.57 3.46-4.505 3.953-9.86 5.295-6.567 1.624-20.628 3.882-31.194 4.94-9.21.919-38.191 5.575-39.976 6.352-.785.353-2.643 1.131-4.07 1.696-1.428.565-3.146 1.839-3.86 2.898-1 1.553-1.066 2.048-.28 3.53 1.927 3.53 5.637 3.457 13.561-.285 3.499-1.694 7.78-3.105 10.922-3.6 2.784-.423 6.928-1.27 9.07-1.765 2.142-.565 8.134-1.627 13.203-2.474 28.842-4.59 39.407-6.85 51.187-10.945 7.853-2.754 7.789-2.749 15-2.043 8.138.777 18.412-1.768 22.624-5.58.928-.848 3.358-3.813 5.5-6.637 2.07-2.824 4.641-5.647 5.64-6.282 2.713-1.765 1.146-2.405-5.85-2.405h-5.86l2-4.37c2.284-5.084 4.639-11.794 4.21-12.217-.142-.142-2.207.136-4.491.701-2.356.494-4.359.85-4.43.779-.143-.142.142-1.197.57-2.398.571-1.553 1.356-2.4 2.64-2.682 1.072-.212 2.36-.568 2.93-.71.5-.14 2.142.001 3.641.425 2.642.706 2.716.848 2.36 3.037-.429 2.753 1.07 4.732 3.64 4.732 1.856 0 3.992-2.051 3.992-3.746 0-1.906-2.779-4.162-4.492-3.738-.857.141-3.288-.211-5.43-.917l-3.851-1.341 3.71-.779c5.64-1.2 7.497-.987 8.282.779.5 1.13 1.43 1.693 3 1.834 4.497.424 5.924-5.935 1.64-7.276-1.57-.494-5 1.203-5 2.474 0 .424-1.212.701-2.64.701-2.966.031-5.852.6-8.39 1.573l5.46-2.698c3.284-.988 7.573-2.543 9.5-3.46 6.354-2.966 12.636-10.308 14.992-17.297 1.5-4.449 3.784-18.36 3.07-18.36-.357 0-2.712.92-5.21 2.05-4.57 2.118-4.641 2.115-4.641.562.071-2.895 1.281-11.44 1.781-12.71.357-.777.213-1.195-.43-1.195-2.141 0-9.063 3.813-13.632 7.484-4.426 3.53-4.86 3.742-4.86 2.259 0-.918.645-2.683 1.43-3.954 1.285-2.118 1.641-2.258 4.211-1.835 2.499.424 2.93.206 4-1.418 1.5-2.26.646-4.943-1.781-5.72-1.357-.423-1.219-.632 1.351-1.903 3.213-1.554 6.641-5.153 9.211-9.812l1.711-2.899-2.57.286c-1.428.14-2.563.209-2.563.138 0-.07.5-1.482 1.07-3.106.572-1.624 1.07-4.305 1.07-5.858 0-2.966-2.64-13.77-3.64-14.9-.357-.423-1.787.216-3.43 1.557l-2.78 2.19-2.649-5.79c-1.428-3.176-2.779-5.932-2.922-6.073-.143-.212-1.07.423-2.07 1.341-2.213 2.048-2.357.92-.43-3.245 1.714-3.671 2.501-4.17 4.5-2.829 2.428 1.554 5.136.075 5.422-2.89.143-1.765-.144-2.474-1.5-3.392-.928-.565-2.211-.92-2.71-.709-.643.212-1.29-.354-1.86-1.696-.5-1.341-1.427-2.252-2.64-2.605-3.713-.918-6.284 3.738-3.571 6.42 1.07.99 1.074 1.768.289 6.923-1.285 8.33-1.711 9.106-2.71 5.364-1.143-4.165-.649-15.742.85-19.13 2.57-5.861 1.073-15.117-3.21-19.918-3.547-3.972-13.366-10.978-14.992-10.791zm-4.961 19.323c.62.021 3.29 2.277 7.625 7.4 3.622 4.298 7.933 11.711 10.726 17.235-.98-1.142-1.64-1.204-4.484-5.118-2.356-3.248-6.18-10.402-9.82-14.144-3.28-3.31-4.546-5.253-4.102-5.365a.196.196 0 0 1 .055-.008z'/%3e%3cpath d='M537.86 298.711c-.68 2.67-1.233 3.15.195 5.197.642.989 1.856 1.554 3.07 1.554 1.927 0 2.998 1.412 4.64 6.354.214.777.357.777.357-.212.072-.706-.571-2.47-1.356-4.024-.857-1.695-1.143-2.895-.714-3.177 1.356-.848.785-4.448-.857-5.578-2.213-1.553-2.932-1.139-5.336-.114z'/%3e%3c/g%3e%3cpath fill='%239eab05' d='M405.906 414.495c-1.499 1.209-1.888 3.13-.777 4.23 1.61 1.592 7.219.164 7.83-2.033.777-3.075-3.998-4.558-7.053-2.197z'/%3e%3cpath fill='%2375b52b' d='M526.632 209.418c.571 3.53 3.998 10.732 6.568 13.698 1.071 1.27 2.07 2.189 2.285 2.047.143-.212-1.856-4.448-4.498-9.39-3.712-7.06-4.712-8.473-4.355-6.355zm-23.773 18.993c.785.847 11.422 3.883 11.422 3.248 0-1.27-3.426-2.754-7.496-3.177-2.356-.283-4.14-.283-3.926-.07zm4.426 8.614c.857.847 13.35 6.566 16.777 7.696 2.07.706 4.783 1.13 6.068.988 2.142-.211 1.928-.353-2.57-1.835-2.713-.918-6.425-2.401-8.21-3.319-4.355-2.189-13.35-4.801-12.065-3.53zm40.622 18.145c-1.07 3.248-2.784 14.121-3.284 21.182-.357 4.59-.286 6.142.571 7.202.928 1.27 1.07.706 1.856-5.649 1.071-8.967 2.213-24.5 1.928-24.853-.143-.141-.643.848-1.071 2.118zm-11.994 5.86c.357 5.649 2.784 11.721 3.641 9.038.286-.847-.428-3.954-1.713-7.696l-2.213-6.284.285 4.943zm-7.996.142c.5.706 1.714 2.189 2.57 3.248l1.642 2.047v-1.836c0-1.059-.714-2.33-1.856-3.177-2.284-1.836-3.64-1.906-2.356-.282zm-10.067 17.439c0 .353 7.783 6.284 10.353 7.908 2.07 1.27 2.07 1.27-.571-1.836-2.713-3.177-7.14-6.354-8.853-6.354-.5 0-.928.141-.928.282zm3.927 15.251c1.857 7.837 3.285 12.285 4.07 12.78.5.282 1 .494 1.07.352.358-.353-3.355-11.085-4.497-13.062l-1.07-1.835.427 1.765zm8.211 6.142c0 1.06.642 3.248 1.427 4.802.786 1.553 1.285 2.33 1.143 1.694-.143-.635-.571-2.612-.786-4.448-.57-3.671-1.784-5.084-1.784-2.048zm-14.493 5.296c1.356 4.519 4.855 11.65 9.78 19.628 3.642 6.001 3.642 6.001 3.856 3.53.143-1.977-.571-3.742-3.213-8.19-1.856-3.107-4.997-8.614-6.996-12.144-1.928-3.6-3.784-6.496-4.07-6.496-.285 0 0 1.695.643 3.672zm44.335 1.059c-3.142 3.389-9.424 12.144-11.495 16.168-.714 1.413-.928 2.825-.642 3.954.428 1.624 1.428.353 8.495-10.802 4.355-6.99 7.71-12.638 7.425-12.638-.357 0-1.999 1.482-3.784 3.318zm-11.28 52.459c-1.071 1.977.285 4.237 2.57 4.237 2.07 0 3.355-2.472 2.284-4.448-.857-1.624-3.926-1.554-4.855.211z'/%3e%3cpath fill='%23d91023' d='M527.56 251.005c-2.713 1.906.143 6.707 2.999 5.013 1.713-1.13 1.999-3.884.428-5.013-.714-.495-1.5-.918-1.713-.918-.215 0-1 .423-1.714.918zm18.705-15.251c-1.642.424-2.285 2.612-1.285 4.448 1.428 2.613 4.997 1.553 4.997-1.483 0-2.118-1.642-3.389-3.712-2.965zm4.712 5.436c-.214.565-.286 1.766-.143 2.684.143 1.27.643 1.624 2.285 1.624 2.57 0 3.997-1.907 2.855-3.743-1-1.553-4.426-1.976-4.997-.564zm-26.772 105.555c-2.642 2.118-.143 5.86 3.141 4.59 1.5-.566 2.07-2.26 1.214-3.813-1-1.907-2.57-2.19-4.355-.777zm14.526-47.333c-.785.777-.57 3.389.357 4.307 2.142 2.118 5.355 0 4.57-3.036-.357-1.342-.929-1.765-2.5-1.765-1.07 0-2.212.212-2.427.494zm13.236-.095c-.5 2.047.714 3.883 2.57 3.883 1.713 0 2.999-1.694 2.713-3.671-.143-1.271-.714-1.695-2.499-1.836-1.999-.212-2.356.07-2.784 1.624zm1.865 52.088c-.5 2.047.714 3.883 2.57 3.883 1.714 0 2.999-1.694 2.713-3.671-.142-1.271-.713-1.695-2.498-1.836-2-.212-2.356.07-2.785 1.624zm-4.343 6.535c-2.642 2.118-.143 5.86 3.141 4.59 1.5-.565 2.07-2.26 1.214-3.813-1-1.907-2.57-2.19-4.355-.777z'/%3e%3cpath fill='%2375b52b' d='M519.886 223.47c.288.456 1.667 2.076 3.047 3.61 2.644 2.872 4.8 5.857 8.795 12.082 2.817 4.406 6.381 8.897 6.381 8.073 0-.853-6.323-11.456-8.824-14.81-3.305-4.378-8.565-9.807-9.571-9.807-.201 0-.144.313.172.853z'/%3e%3cpath fill='%23eac102' fill-opacity='.502' d='M538.141 312.72c-.086.483-.822 5.236-1.138 10.808-.747 12.905-1.408 19.846-2.874 28.175-.633 3.667-1.236 7.249-1.322 7.96l.19 1.182 1.178-1.649c1.264-1.734 2.586-2.985 4.483-4.264.633-.455 2.673-2.36 4.484-4.292 9.083-9.58 11.612-12.564 19.43-22.911 7.243-9.637 8.997-12.053 8.853-12.223-.287-.256-2.54 1.887-11.566 13.059-2.5 3.098-6.737 7.959-9.295 10.801-6.295 6.936-13.327 13.385-15.182 15.879-.17.229.258-1.62.603-2.985 1.61-6.794 2.271-14.27 2.472-28.88.086-6.368.115-11.57.029-11.57-.086 0-.23.398-.345.91zm-17.633 46.657c-.546.91-2.242 3.894-3.794 6.623-4.83 8.642-10.405 16.459-14.63 20.524-1.524 1.478-1.09 1.605-1.409 1.933-1.668 1.717 5.059 2.928 10.175 3.44 6.898.681 10.721-.683 29.145-10.405 4.312-2.274 5.461-2.984 4.599-2.842-1.696.284-4.369.91-12.36 4.719-7.817 3.695-11.312 5.31-14.848 6.106-2.76.625-6.806.682-9.192.113l-1.627-.108.863-.284c.718-.17 1.833-.21 2.207-.523.374-.342 1.84-1.388 3.248-2.098 3.19-1.62 6.703-4.542 11.532-8.863 3.707-3.298 10.836-10.49 10.836-10.944 0-.313-3.334 2.416-7.617 6.197-8.853 7.845-17.533 13.672-21.241 14.27l-1.092.17 1.15-1.023c.373-.54 1.77-2.604 3.207-4.708 3.45-5.031 4.771-7.43 7.99-13.997 2.96-6.054 4.18-9.664 3.979-9.835-.058-.057-.575.626-1.121 1.535zm.214-91.109c-.087.484 3.69 5.047 8.042 10.035 4.449 5.1 7.062 7.11 10.604 11.563 3.54 4.452 3.906 4.78 7.858 8.345 4.928-6.48 7.952-15.308 10.037-20.922 2.062-5.549 3.723-10.314 3.774-17.632-2.826 6.119-2.911 8.318-5.12 14.99-2.228 6.733-7.19 18.392-9.046 20.886-.17.229-10.422-12.355-14.895-17.57-4.749-5.54-11.273-10.272-11.254-9.695z'/%3e%3cpath fill='%23cab313' fill-opacity='.502' d='m524.08 208.323-.859 6.377-2.579-1.276c-2.722-1.275-9.743-2.763-13.11-2.763-1.863 0-1.935.142-1.577 2.267.43 2.268 2.221 8.715 2.866 10.132.143.425-1.075 1.134-2.723 1.63-1.719.496-3.653 1.346-4.37 1.913-1.29.921-1.146 1.134 1.576 3.543 3.224 2.905 3.51 3.684 1.72 4.96-1.075.779-.645 1.416 4.084 5.951 2.937 2.834 6.59 5.74 8.024 6.448 3.653 1.913 10.746 1.913 14.543 0 2.65-1.347 2.866-1.347 4.585-.213 1.72 1.063 1.791 1.063.86-.07-.573-.638-3.94-2.693-7.45-4.464-9.888-5.102-17.983-14.03-21.422-23.878-1.72-4.889-1.72-7.51.071-7.51 2.938 0 9.17 1.558 12.681 3.117 5.23 2.41 14.544 11.337 17.123 16.509 1.863 3.613 2.078 4.889 2.15 10.274 0 6.235 1.002 8.856 1.146 3.188.286-7.156.501-8.786 1.576-11.478 2.149-5.243 1.074-13.25-2.365-17.997-1.146-1.488-4.871-4.747-8.382-7.227-3.439-2.409-6.52-4.676-6.734-5.101-.287-.355-.932 2.196-1.433 5.668zm9.171 1.063c4.8 3.33 6.162 4.747 7.666 7.793 2.293 4.748 3.01 10.487 1.72 14.738l-1.004 3.188-1.862-3.967c-1.218-2.693-3.797-5.881-8.024-10.062-3.367-3.4-6.52-6.164-6.95-6.164-.788 0-.501-4.818.573-8.998.43-1.842 0-2.055 7.881 3.472zm-22.997 17.359c.645 1.133 1.79 2.338 2.436 2.834.716.496 1.433 1.559 1.647 2.338.359 1.275 0 1.417-3.367 1.417s-3.94-.213-6.52-2.834c-1.504-1.559-2.65-2.976-2.435-3.118.573-.566 5.23-2.48 6.09-2.55.501 0 1.432.85 2.149 1.913zm9.528 10.982c4.156 3.826 5.374 4.605 10.389 6.59 2.65 1.062 2.794 1.204 1.647 2.267-1.576 1.558-9.457 2.125-13.039.92-3.08-.991-14.257-11.052-13.11-11.761 1.218-.78 4.943-1.559 7.665-1.63 1.935-.07 3.153.638 6.448 3.614zm20.705 13.037c-.286.354 0 1.913.573 3.472 1.29 3.613 1.218 4.676-.071 7.156-.573 1.134-1.075 3.33-1.075 4.818 0 1.559-.358 3.826-.86 5.101l-.788 2.268-2.364-1.488c-1.29-.85-2.507-2.197-2.722-2.976-.645-2.126-.359-6.66.501-10.982.645-3.047 1.146-3.897 2.15-3.826 1.074.141 1.146-.071.358-.921-.717-.922-1.003-.922-1.791.212-.502.709-1.147 2.267-1.362 3.543-.43 2.338-.43 2.338-2.507 1.346-3.08-1.63-4.227-1.346-4.227.992s1.218 6.093 2.722 8.431c1.648 2.48 1.72 1.418.072-1.77-1.934-3.898-2.58-8.007-1.29-8.007.574 0 1.72.496 2.58 1.062 1.29.922 1.504 1.701 1.36 5.881-.07 5.669-.572 5.952-7.307 3.685-2.22-.78-4.227-1.276-4.442-1.134-.286.354.86 6.306 1.648 8.219.287.85-.215 1.063-2.937.78l-3.368-.213 2.006 3.4c4.442 7.724 10.89 12.33 19.774 14.171 2.794.567 6.161 1.56 7.38 2.197 1.719.921 2.005.921 1.36.142-.43-.567-2.077-1.488-3.582-1.984-4.083-1.488-8.024-4.322-13.182-9.778-5.158-5.456-7.81-10.061-7.81-13.604 0-1.842.216-2.267 1.075-1.913.645.213 3.081.921 5.517 1.559 6.018 1.488 7.594 2.409 11.463 6.518 4.084 4.322 5.445 6.873 6.663 12.683.573 2.55 1.146 4.747 1.36 4.96.932.992 1.219-2.267.43-5.03-1.289-4.677.646-13.746 4.73-21.753 1.79-3.542 7.307-8.927 8.167-7.935.286.283 1.217 3.33 2.149 6.73 1.934 7.228 1.648 9.353-1.791 16.51-2.508 5.101-4.872 8.077-8.597 10.77-2.794 1.983-2.006 2.62 1.862 1.629 3.44-.921 8.956-5.952 11.965-10.911l1.576-2.693-2.794.496-2.723.425 1.29-3.755c1.648-4.818 1.648-6.731 0-12.47-.788-2.622-1.576-5.668-1.863-6.731l-.43-1.984-2.292 1.63c-1.29.85-2.508 1.842-2.723 2.196-.86 1.204-1.862-.142-4.298-5.527-1.29-2.905-2.58-5.314-2.866-5.314-.358 0-1.433.85-2.507 1.913l-1.863 1.984.43-1.984c.358-1.346.215-1.842-.287-1.558-.358.212-.716 1.133-.716 1.984 0 3.4-1.218 3.4-2.293.07-.573-1.842-1.218-3.046-1.433-2.692zm10.388 17.855c-2.077 4.11-3.51 8.36-4.083 11.62l-.86 5.101-1.146-2.834c-.645-1.63-2.078-3.897-3.08-5.172-1.935-2.197-1.935-2.338-1.147-7.369 1.218-8.006 2.794-12.328 5.66-15.446l2.579-2.905 2.65 5.243 2.651 5.173-3.224 6.589zm-27.152 11.69c8.74 9.07 11.75 12.613 10.245 12.117-6.52-1.913-11.105-5.314-14.544-10.628-1.361-2.055-2.436-3.968-2.436-4.18 0-.213.86-.355 1.863-.355 1.29 0 2.866.992 4.872 3.047zm40.765 5.598c-2.866 4.535-4.586 6.235-7.738 7.794l-2.866 1.488 2.866-3.118c1.576-1.7 3.654-4.322 4.514-5.739 1.433-2.267 2.436-2.976 4.657-3.33.286 0-.359 1.276-1.433 2.905z'/%3e%3cpath fill='%23005000' d='M538.41 256.361c1.003 2.126 2.865 4.322 2.937 3.543 0-.425-.86-1.7-1.863-2.834-1.003-1.205-1.504-1.488-1.074-.709z'/%3e%3cpath fill='%23cab313' fill-opacity='.502' d='M519.496 293.347c-.287 1.488-.788 3.897-1.218 5.455l-.645 2.693-2.078-1.913-2.006-1.913-.573 3.33c-.645 4.605.144 11.478 2.15 17.926.93 2.976 1.934 7.014 2.22 8.998.86 6.519 6.233 14.17 13.183 18.918 1.29.921 1.79 2.126 2.22 5.314l.574 4.11-.143-3.897c-.072-2.126-.932-7.37-1.863-11.691-2.221-10.274-1.576-14.596 3.582-25.082l3.725-7.51 3.798 7.58c5.086 10.133 5.588 13.534 2.865 21.823-1.074 3.33-2.292 6.377-2.65 6.873-.359.496-.502 1.134-.359 1.488.215.283.072.992-.358 1.559-.573.85-.645.78-.287-.354.287-.78-.716-.071-2.364 1.77-1.576 1.772-3.009 3.827-3.224 4.606-.358 1.276-.286 1.276.86-.141a225.01 225.01 0 0 0 2.508-3.401c.716-.992 1.576-1.63 1.862-1.417 1.075.566 2.078-1.276 4.442-7.865 3.296-9.211 5.373-12.825 9.887-17.36 3.009-2.975 5.946-4.888 10.961-7.297 3.797-1.771 7.021-3.26 7.165-3.26.573 0-1.577 12.33-2.794 15.943-1.362 4.322-5.23 10.415-8.311 13.25-3.01 2.763-9.027 5.738-14.687 7.297-2.436.709-4.657 1.488-4.872 1.842-.358.638 5.302-.92 10.532-2.905 7.594-2.763 14.758-10.132 17.696-17.925 1.29-3.401 4.083-18.139 3.51-18.635-.143-.142-2.507.85-5.373 2.197l-5.087 2.409.43-4.748c.215-2.621.788-6.235 1.29-8.148.86-3.259.86-3.33-.645-2.905-3.582 1.063-10.03 4.96-13.899 8.503l-4.227 3.755.215-6.519c.215-4.393.072-6.093-.358-5.101-.358.78-.716 2.834-.716 4.605-.072 3.614-1.577 10.628-2.293 10.628-.287 0-1.576-2.054-2.866-4.605-2.364-4.393-3.439-5.597-3.582-3.755 0 .496-.716-.992-1.648-3.401-.86-2.338-2.507-5.456-3.653-6.944l-2.078-2.692-1.146 2.196-1.147 2.197-2.722-3.543c-1.505-1.984-3.367-3.897-4.084-4.251-1.146-.638-1.361-.355-1.72 1.913zm4.871 2.196c2.723 3.33 8.67 14.525 9.457 17.855l.43 1.772-1.29-1.772c-2.292-3.259-8.525-8.856-12.322-11.053-1.863-1.063-1.934-1.417-1.433-3.755.287-1.417.717-3.401 1.003-4.535.215-1.062.645-1.913.932-1.913.286.071 1.719 1.559 3.223 3.401zm9.959 6.873c2.078 4.322 2.507 7.014 1.361 8.786-.931 1.488-6.806-10.84-6.233-13.108.43-1.559.645-1.7 1.648-.85.645.496 2.078 2.834 3.224 5.172zm-12.681 2.267c4.585 3.047 9.242 7.652 10.46 10.416.645 1.275.43 2.267-.716 4.534-1.935 3.756-3.01 11.479-2.293 16.58.287 2.267.287 4.11 0 4.11-.931 0-6.09-6.59-8.454-10.7-4.728-8.29-8.096-21.822-6.95-27.845l.502-2.692 1.576 1.346c.86.78 3.51 2.693 5.875 4.251zm43.273 0c-.359 1.913-.789 5.173-1.003 7.298-.43 3.826-.502 3.968-4.657 6.519-2.365 1.488-5.588 4.322-7.308 6.518-1.648 2.126-3.224 3.755-3.51 3.543-.359-.142-.788-1.842-1.075-3.684-.215-1.843-.931-4.393-1.433-5.74-.931-2.125-.86-2.55.502-4.463 3.009-4.18 15.761-13.32 18.627-13.32.215 0 .143 1.487-.143 3.33zm-38.473 34.648c2.65 2.692 4.227 4.818 4.012 5.597-.143.992-.931.567-3.869-2.196-3.94-3.685-7.092-8.503-7.809-11.975-.43-1.842-.215-1.7 1.433 1.063 1.003 1.771 3.797 5.172 6.233 7.51z'/%3e%3cpath fill='%23cab313' fill-opacity='.502' d='M519.424 356.902c-7.737 5.172-14.263 15.949-16.256 24.587-.144 2.196-2.485 4.037-2.127 3.825.287 1.06 2.49-.047 3.484-3.542 1.881-6.616 7.09-18.493 13.896-23.24 2.078-1.417 4.155-2.622 4.514-2.622.358 0 .501 2.693.358 6.164-.143 4.748-.645 7.015-1.935 9.637-2.149 4.322-7.952 10.698-12.036 13.037-3.438 1.983-3.725 2.834-.573 1.63 3.51-1.347 11.821-9.92 14.042-14.526 1.147-2.338 2.078-4.676 2.078-5.172 0-.496.86-1.275 2.006-1.7 2.58-.992 15.403-4.18 15.69-3.827.573.567-4.898 12.04-6.689 14.378-2.722 3.471-9.242 8.431-12.466 9.423-1.504.425-4.744 2.17-7.138 2.615-2.605.483-3.387.522-6.428.85l-2.528 1.5 2.508-.424c1.361-.213 4.8-.638 7.522-.921 7.887-2.737 10.917-4.444 16.081-8.4l3.355-2.84 6.428.328 5.23.425-2.436 2.905a676.904 676.904 0 0 0-5.588 6.802c-1.648 2.126-4.012 4.393-5.23 5.102-3.44 1.984-10.962 3.613-17.266 3.613-5.732.071-5.875 0-8.74-2.55-2.938-2.622-4.085-3.118-4.514-1.984-.072.354-2.58 1.417-5.374 2.48-5.588 1.912-6.806 1.417-3.582-1.56 1.218-1.133 2.496-1.128 5.075-1.27 0 0 5.419 1.208 5.473.095.054-1.107-5.4-1.02-5.4-1.02-2.546.15-3.137.065-1.135-2.537 2.351-1.477 3.28-4.36 2-3.73-3.132 3.784-5.16 5.283-9.881 9.88-4.508 3.122-5.08 3.335-11.248 5.034-3.94.92-10.46 1.983-14.328 2.48-7.51.848-10.697 2.735-3.44 1.413 3.672-.669 8.38-1.2 14.4-2.264 8.681-2.126 9.258-2.27 13.54-4.538 3.5-3.6 4.072-4.023 2.222-1.062-.645 2.196.43 2.125 7.307-.496 5.445-2.126 5.589-2.126 6.95-.78 1.361 1.346 1.29 1.417-1.433 2.55-5.803 2.41-17.123 5.527-28.657 7.795-6.592 1.346-12.18 2.621-12.395 2.905-.573.567 7.81-.355 9.6-1.134.789-.283 6.735-1.842 13.255-3.33 6.52-1.559 13.97-3.684 16.62-4.747 4.443-1.772 5.16-1.842 8.956-1.134 4.8.85 12.753.071 18.556-1.842 4.442-1.417 7.522-4.039 12.036-10.345 1.863-2.621 4.227-5.384 5.23-6.093l1.862-1.346-6.304-.425c-3.439-.213-6.448-.567-6.591-.78-.144-.141.215-1.275.86-2.48.573-1.204 2.077-4.818 3.223-7.935l2.15-5.81-2.508.496c-1.361.212-3.654.638-5.015.85l-2.507.496 1.074-2.621c.573-1.418.932-2.551.717-2.551-.144 0-.788 1.133-1.362 2.48-1.217 2.763-2.65 3.33-2.149.85.215-1.134 0-.921-.86.708-.716 1.276-2.077 2.551-3.08 2.976-1.003.355-2.436.85-3.224 1.134-1.218.567-1.29.212-1.003-4.818.143-3.472 0-5.456-.502-5.456-.43 0-2.364 1.063-4.37 2.41z'/%3e%3cpath fill='%23cab313' fill-opacity='.502' d='M452.51 403.878c-4.156.354-12.538 1.63-26.509 3.897-7.307 1.134-13.612 2.125-14.113 2.196-.502 0-.717.284-.573.567.215.284-.788.709-2.15.921-3.152.638-6.806 3.614-6.806 5.669 0 2.054 2.364 4.18 4.084 3.755 1.146-.284 1.075-.355-.143-.425-3.153-.142-4.37-3.826-1.935-5.952 2.006-1.842 11.463-4.606 16.836-5.03 6.806-.567 26.437-3.26 27.296-3.827.43-.212 3.01-.78 5.803-1.275 4.729-.78 3.798-1.063-1.79-.496z'/%3e%3cpath fill='%23cab313' fill-opacity='.502' d='M440.688 410.75c-12.895 2.48-20.92 4.535-24.788 6.52-5.015 2.48-4.299 2.692 1.074.283 2.508-1.134 6.807-2.41 9.529-2.835 2.65-.425 8.597-1.558 13.11-2.48 4.514-.92 10.03-1.983 12.18-2.338l3.94-.637-3.224-.071c-1.79 0-7.092.708-11.82 1.559z'/%3e%3cpath fill='%23fff' d='M497.182 391.946c-2.24 1.348-4.552 4.011-2.046 3.609 1.901-.168 9.019-2.331 9.574-3.735-2.724.24-4.962-.417-7.528.126z'/%3e%3cg stroke='%23d4af37' stroke-width='.904'%3e%3cpath fill='%23fff' d='M367.709 432.44c-1.503.459-2.482.902-9.093.441-4.507-.307-10.173-1.117-13.102-1.194-5.56-.077-5.603.349-15.52 7.111-6.986 4.764-16 4.41-22.667 2.93-4.057-1.844-5.8-2.26-5.199-1.261 1.127 1.844 9.01 4.402 13.368 4.402 7.061 0 12.245-1.768 20.734-7.07 6.535-4.15 9.465-4.534 18.48-2.459 10.621 2.102 12.195 1.195 20.868-2.706-2.588-.073-3.194-.001-4.064.351 1.494-1.625 1.555-3.144 1.85-4.183.43-.566-.721.19-2.11 1.164-1.39.974-3.02 2.166-3.545 2.474z' transform='matrix(.83739 0 0 .82218 198.784 50.956)'/%3e%3cpath fill='%23d91023' d='M354.025 429.835c-4.883-.768-8.23-1.435-11.29-1.092-3.41.38-5.839 2.075-9.895 4.61-4.057 2.613-7.708 4.495-8.159 4.495-.526 0-5.764 1.22-9.746 1.22-1.878 0-5.913-1.245-8.617-2.244-5.71-2.151-7.794 1.329-1.86 3.865 5.276 1.8 10.625 2.506 15.617 1.763 4.991-.743 9.625-2.935 13.47-5.77 7.627-5.624 3.166-2.918 6.206-4.207 3.04-1.288 5.848-.851 5.848-.851 3.982.153 11.88 1.466 15.862 1.543 7.287-.658 6.037-.672 8.441-2.05.838-.48 3.488-2.234 3.65-2.63.16-.398 1.39-2.702 1.154-2.793-7.452 5.131-11.202 5.12-20.681 4.141z' transform='matrix(.83739 0 0 .82218 198.784 50.956)'/%3e%3cpath fill='%23d91023' d='M341.028 435.395c-1.052.461-4.207 2.306-7.137 3.996-6.16 3.765-11.96 5.57-18.748 5.647-3.08.463-13.072-3.606-11.57-3.145 1.608 3.033 3.952 3.425 9.676 4.508 3.993.756 6.582.13 11.062-.826 5.02-.615 7.078-2.888 8.956-4.271 4.357-3.228 11.893-5.37 13.996-5.37.977 0 4.757 2.065 8.902 2.962 4.145.896 6.145 1.127 10.443.444s8.724-4.2 12.84-6.924c-.669.21-2.132.214-4.14.276-5.895 3.474-15.88 4.783-21.134 2.425-5.333-1.306-10.517-.951-13.146.278z' transform='matrix(.83739 0 0 .82218 198.784 50.956)'/%3e%3c/g%3e%3cpath fill='%2300a854' d='M388.708 210.486c-9.086 2.995-18.677 10.198-24.662 18.471-1.298 1.783-2.452 3.138-2.596 2.996-.072-.143.577-3.78 1.586-8.06 1.01-4.278 1.803-8.557 1.731-9.556 0-1.64-.144-1.569-2.884 1.427-3.462 3.85-8.005 12.337-9.736 18.186-.937 3.137-1.298 6.632-1.298 13.122l.072 8.915-1.73-6.276c-1.803-6.704-3.678-11.268-5.553-13.622-.937-1.212-1.226-1.284-1.875-.357-1.37 2.069-.433 10.912 1.875 17.473.216.785-.649-.356-1.947-2.496-1.37-2.14-2.812-3.78-3.173-3.566-.865.428-.937 7.417-.072 10.341.649 2.069.649 2.069-1.803-.713-4.038-4.635-4.976-4.992-4.976-1.783 0 1.213.505 3.352 1.082 4.779.577 1.355 1.082 2.638 1.082 2.71 0 .07-1.01.356-2.308.641-3.173.642-4.182 1.64-4.182 4.28 0 2.852 1.947 9.485 2.956 10.127 1.082.641 1.442 0 2.38-4.137l.865-3.708 2.668 3.423c3.822 4.992 9.52 16.403 12.404 24.89 3.029 9.057 3.173 10.84.36 5.277-1.153-2.21-3.173-5.563-4.398-7.417-2.74-3.85-17.812-19.47-18.822-19.47-1.082 0 0 4.85 1.947 8.915.938 1.997 3.75 5.92 6.13 8.772 2.452 2.782 4.254 5.135 4.038 5.135-.216 0-1.947-1.14-3.75-2.496-3.678-2.781-7.427-4.92-7.932-4.493-.144.214 1.298 3.21 3.245 6.775l3.461 6.49-2.307-.356c-1.298-.214-3.03 0-3.894.427-1.298.714-1.515 1.498-1.515 4.921 0 4.565 1.154 9.414 2.236 9.414 1.01 0 2.812-4.493 2.812-6.918 0-1.925.072-1.854 3.678 1.57 5.12 4.992 11.97 13.478 18.75 23.32l5.696 8.344-6.706-4.992c-6.418-4.707-19.615-12.052-21.778-12.052-.577 0-1.082.285-1.082.641 0 .357 4.254 4.636 9.447 9.557l9.374 8.915-4.903-1.64c-2.669-.856-6.058-1.784-7.428-2.069-2.452-.499-2.452-.356 3.029 4.707 3.028 2.853 8.509 7.06 12.259 9.414 3.678 2.282 6.057 3.923 5.264 3.709-6.562-1.855-16.225-3.424-16.225-2.568 0 .999 4.976 4.921 8.509 6.704 1.947.927 6.85 2.924 10.961 4.28 8.365 2.923 13.413 5.562 17.668 9.27l2.884 2.568-5.048-2.211c-5.769-2.567-21.417-7.774-23.22-7.774-1.803 0 5.409 7.06 12.403 12.267 6.419 4.778 18.606 10.84 27.403 13.693 7.356 2.353 13.558 3.566 25.24 5.064 5.192.641 10.096 1.426 11.033 1.782.865.428 7.211 1.355 14.062 2.14 20.047 2.353 34.686 5.777 43.268 10.127 2.307 1.141 4.831 1.57 10.095 1.854 7.789.357 8.15.143 5.914-4.136-1.875-3.566-5.192-5.42-12.26-6.704-3.533-.713-9.374-1.854-12.98-2.567-7.572-1.57-22.138-4.137-40.6-7.06-19.83-3.21-28.412-6.633-37.714-14.978-13.774-12.266-20.985-32.164-18.75-51.847.505-4.208.794-7.703.65-7.845-.65-.57-5.265 8.914-6.49 13.193l-1.299 4.707.289-7.56c.505-11.767 4.903-22.75 11.538-29.097 1.442-1.355 2.596-2.71 2.596-2.995 0-.286-1.37-.143-3.029.285-2.163.5-4.255 1.854-6.85 4.493l-3.75 3.709 1.73-3.352c2.668-5.278 7.284-10.555 11.683-13.48l4.11-2.638-2.38-.214c-4.76-.5-13.34 5.705-18.1 13.122-2.74 4.35-2.74 2.996.072-3.637 2.668-6.49 6.779-12.837 11.25-17.544 2.524-2.639 2.956-3.495 2.019-3.495-3.75 0-10.096 4.85-15.36 11.768-1.515 2.068-1.515 1.925.216-2.14 2.164-4.85 5.48-10.27 8.582-13.693 2.235-2.567 1.586-2.924-2.164-1.212-3.39 1.64-8.87 7.702-12.043 13.55-1.514 2.71-2.596 4.28-2.38 3.495.217-.785.722-2.853 1.082-4.636 2.668-11.839 9.159-23.392 17.956-31.879 3.39-3.21 4.255-4.493 3.318-4.493-2.74 0-9.159 3.637-13.413 7.631-4.4 4.137-4.471 4.137-2.74 1.284 6.057-10.199 15.143-19.47 25.6-26.102 3.317-2.14 6.057-4.065 6.129-4.28 0-1.07-10.961 2.211-15.937 4.708-1.154.641-3.894 2.567-6.202 4.421-3.461 2.782-3.822 2.996-2.524 1.141 2.452-3.423 10.745-10.769 14.062-12.48 2.452-1.284 2.74-1.64 1.515-1.855-3.317-.499-12.548 4.35-19.76 10.342l-3.172 2.71 1.73-2.853c5.625-9.2 12.548-16.546 20.697-21.823 2.884-1.855 5.697-3.495 6.202-3.709.432-.142.72-.5.504-.713-.216-.214-2.812.357-5.697 1.355zm108.386 203.968c1.01 1.07 1.875 2.211 1.875 2.497 0 .356-1.587.641-3.606.641-3.461 0-3.605-.07-3.605-1.996 0-3.638 2.307-4.066 5.336-1.142z'/%3e%3cpath fill='%239eab05' d='M492.543 413.18c-1.731 1.64-1.443 4.35.505 4.85 3.028.784 6.994.498 6.994-.571 0-1.07-4.615-5.42-5.769-5.42-.36 0-1.153.499-1.73 1.14z'/%3e%3cpath fill='%23cab313' fill-opacity='.502' d='M392.463 209.25c-7.627 1.33-14.279 5.866-20.117 10.72-.815.751-1.259 1.178-1.29 1.286-.43.489-4.3 3.934-6.68 7.252-1.156 1.334-2.76 3.613-3.593 4.99.179-1.354 1.193-5.411 2.227-9.98 1.158-5.44 1.668-9.844 1.523-10.058-.724-.645-5.95 6.198-8.555 11.422-3.835 7.515-4.96 12.695-4.96 23.43l-.079 8.928-1.757-6.784c-1.882-7.085-5.121-14.463-6.64-14.892-.507-.143-1.079.875-1.368 2.378-.434 2.362-.032 4.636 3.008 16.803.217 1.002-.567.08-1.797-2.067-2.75-4.795-3.696-5.88-4.492-5.38l1.953 2.807c1.085 1.575 3.033 5.298 4.336 8.304 3.546 8.374 8.837 26.119 7.968 26.978-.217.143-.653-.434-1.015-1.365-.362-.93-1.358-3.642-2.227-6.003-.868-2.362-2.816-6.605-4.336-9.396-3.4-6.226-5.86-13.092-6.367-17.816l-.39-3.47c-1.002.779-.597 4.921.82 9.474.724 2.433 1.283 4.366 1.21 4.366-.144 0-1.711-2.004-3.593-4.366-2.605-3.292-3.634-4.147-4.14-3.43-.652 1.073-.27 3.203 1.25 7.211l.976 2.73h-2.383c-1.302 0-2.948.434-3.672.935-1.23.859-1.31 1.43-.586 5.224.833 4.688 1.998 8.13 2.891 8.187 1.43.09 1.388-1.412 2.11-5.497.29-1.171.787-1.894.898-2.573.306.43.747.953 1.367 1.598 6.089 8.285 11.569 19.632 14.101 27.29 2.027 6.083 5.786 22.104 5.352 22.533-.145.215-1.04-2.497-1.836-6.004-2.895-12.166-6.984-19.358-19.648-31.811 0 0-4.347-5.2-7.852-7.213.058 2.933.664 3.431.664 3.431.869 4.437 3.108 8.3 9.766 16.1 2.967 3.508 5.351 6.615 5.351 6.901 0 .215-1.65-1.102-3.75-2.963-3.835-3.363-9.772-7.2-10.351-6.627-.217.143 1.21 3.29 3.164 6.94 2.46 4.58 3.218 6.445 2.422 6.159-2.822-1.145-3.855-1.145-5.664 0-1.882 1.217-1.88 1.332-1.445 6.198.217 2.72.815 5.652 1.25 6.51.868 1.432.85 1.446 1.718-.272.507-.93 1.078-2.941 1.367-4.444.29-1.432.72-2.651.938-2.651.244 0 3.916 3.822 5.703 5.575a112.2 112.2 0 0 0 2.422 3.001c4.27 5.225 16.062 20.273 19.101 25.068l1.524 2.495-2.461-1.91c-8.178-7.002-21.575-14.832-26.64-16.335-1.419-.42-1.8-.016-1.133.74-.025.003-.064-.013-.079 0 3.477 4.695 13.69 13.262 16.368 15.517 2.677 2.254 2.65 3.092 2.578 3.235-.145.072-2.012-.797-5.196-1.87-8.177-2.864-10.304-2.927-9.218-1.638.506.572 1.732.98 2.89 1.052 4.198.072 14.845 4.73 22.227 9.669 4.776 3.22 16.214 14.095 17.734 16.958.796 1.575.512 1.426-2.383-.936-3.908-3.149-14.756-9.311-15.625-8.81-.29.215-2.836-.26-5.586-.975-2.822-.716-7.026-1.507-9.414-1.793l-4.257-.507 2.539 2.3c3.328 3.006 8.9 5.707 18.164 8.928 4.124 1.431 8.837 3.358 10.43 4.288 3.473 2.004 10.634 7.595 10.272 7.953-.144.143-2.78-.862-5.82-2.222-5.138-2.362-17.857-6.795-22.343-7.797-1.665-.358-1.1.345 3.242 4.64 2.894 2.719 7.831 6.74 11.015 8.888 15.342 10.09 29.249 14.537 55.156 17.543 4.125.5 7.21 1.123 6.992 1.481-.217.358 6.3 1.318 13.32 2.106 18.816 2.218 30.546 4.789 41.328 9.083 4.704 1.932 7.468 2.56 12.461 2.846 4.776.286 6.406.215 6.406-.429 0-1.646-2.07-4.87-4.531-7.017-2.171-1.861-3.61-2.974-12.148-4.406-5.355-.858-10.17-2.02-10.82-2.378-.652-.357-11.403-1.855-23.633-3.86-26.848-4.293-35.101-6.232-42.265-9.667-17.73-8.589-29.807-27.28-30.82-48.965-.218-4.366-.083-10.074.351-12.866.434-2.72.73-5.08.586-5.224-.651-.644-6.124 10.241-6.992 14.464l-.352 2.729-.273-4.912c-.072-11.165 3.525-20.885 9.531-29.044 0 0 4.009-3.943 4.57-4.99.039-.03.037-.08.04-.117.018-.055.019-.095 0-.117-.022-.024-.028-.054-.079-.039-.015-.015-.019-.024-.039-.039-2.863-.895-5.953 1.458-10.117 5.185-2.587 2.61-2.941 3.256-3.086 3.041.164-1.874 7.66-13.255 9.18-13.255.29 0 2.134-2.163 2.812-2.807.869-2.218-4.479 2.696-8.242 7.992-8.438 11.243-10.356 22.604-9.922 37.777.145 4.652-.2 8.303-.273 8.303-.362 0-2.547-5.42-3.633-8.927-2.75-8.875 1.469-27.387 8.633-36.763 1.23-1.574 4.22-4.987 4.687-5.77 1.014-1.932-4.938 4.778-7.109 8.07-.491.992-1.171 1.6-1.289 1.365-.118-.235.256-1.3.82-3.041 2.678-7.801 7.303-15.846 13.164-22.144 2.171-2.361 2.24-2.333.43-1.832-4.27 1.217-8.127 4.51-12.305 9.278-1.013 1.575-1.93 2.416-3.086 3.743.4-1.951 4.16-9.87 7.344-14.307 1.954-2.649 3.828-4.442 3.75-5.03-.078-.588-2.108.044-5.039 2.223-4.414 3.22-6.922 6.621-10.703 12.787-1.737 3.507-1.484 2.521-2.07 3.157 1.954-9.876 3.345-14.532 6.601-20.973 2.967-5.798 5.873-9.72 11.445-15.516 3.908-4.008 4.696-5.147 3.32-4.718-4.269 1.289-8.804 4.147-12.929 8.226-2.388 2.434-3.36 3.165-3.36 2.807 0-.358 1.167-2.354 3.556-6.004 5.065-7.729 12.39-15.762 19.843-20.7 3.69-2.506 9.519-5.263 8.867-5.692a.685.685 0 0 0-.312-.078c.388-.633-1.658-.19-6.836 1.403-5.138 1.575-10.639 4.634-16.211 8.928-2.154 2.015-1.728.351 3.555-4.873 2.822-2.863 7.165-6.347 9.336-7.564 3.618-2.147 3.33-2.645 1.015-2.144-5.427 1.074-15.867 7.006-18.906 10.8-.017.02-.022.017-.039.038-.13.05-.245.067-.43.156-1.643 1.01-3.231 3.275-2.851 2.3.38-.975 1.207-1.799 3.125-4.912 5.862-9.447 13.64-16.353 23.554-22.221 2.443-1.477 2.54-2.2.82-2.028zm-54.648 38.087c.021-.017.055-.025.078-.038l-.078-.078v.116zm48.944-35.398a.312.312 0 0 1 .196.078c.145.215-.774 1.006-2.149 1.793-2.677 1.718-11.714 10.6-14.609 14.464-3.69 4.795-7.997 12.584-10.312 18.596-1.303 3.363-2.305 5.562-2.305 4.99-.072-1.575 1.977-12.14 2.773-14.932a10.75 10.75 0 0 0 .43-2.027c.363-.227.931-.858 1.875-2.339a59.077 59.077 0 0 1 3.672-4.951c1.62-2.003 6.658-7.274 6.523-7.407-.02-.02-.094.025-.156.039.495-.354 1.01-.732 1.758-1.287 4.749-3.489 11.002-7.058 12.304-7.017zm-23.788 3.86c.052-.004.099.02.117.078.144.429-.758 6.65-2.422 13.878-3.329 15.244-5.76 27.2-6.484 35.36-.507 5.01-.66 5.454-1.094 3.235-.362-1.36-.765-8.313-1.055-15.399-.506-14.027.054-18.124 3.672-25.925 2.035-4.495 6.478-11.174 7.266-11.227zm19.492 11.734c.217 0-1.725 1.933-4.258 4.366-10.349 9.59-17.885 22.5-22.227 38.245l-1.367 4.99.43-4.64c.217-2.576.743-6.604 1.25-8.966.651-2.863 2.186-7.585 3.75-11.812 1.564-4.228 3.038-7.824 6.21-10.994.69-.728 2.145-2.032 2.5-2.612.76-.537 1.897-1.365 3.946-2.963 2.895-2.29 8.68-5.614 9.766-5.614zm8.554 3.626c.34-.017.508.037.508.234 0 .143-1.897 1.46-4.14 2.962-5.5 3.579-15.696 14.112-19.532 19.766-3.473 5.153-8.733 15.273-10.976 21.714-2.026 5.94-1.898 2.747.273-5.77 1.954-7.514 6.815-18.705 10.469-24.131.678-.984 1.083-1.598 2.07-2.924.98-1.107 1.28-1.657 1.64-1.442.363.214 2.014-.791 3.75-2.222 3.8-3.194 13.566-8.069 15.938-8.187zm-48.476 5.34c.181-.062.425.25.86.858.506.716 1.894 4.005 3.124 7.368 3.33 9.304 7.743 34.195 6.368 35.555-.218.286-.43-.188-.43-.975 0-.787-1.6-6.47-3.555-12.553-5.644-17.32-7.598-25.888-6.875-28.966.217-.787.327-1.224.508-1.286zm37.265 15.36c.145 0-1.456 1.74-3.554 3.743-9.697 9.805-16.05 23.123-18.438 38.868-.579 3.937-1.396 7.44-1.757 7.797-.29.287-.844-1.296-1.133-3.586-.941-7.443 1.595-19.546 5.937-28.42.941-1.933 1.035-2.772 1.797-3.977.51-.432.989-1.439 1.875-2.612 3.237-3.555 8.558-8.873 12.031-10.448 1.665-.716 3.098-1.364 3.242-1.364zm-46.913 1.794 1.445 1.793c.796 1.002 2.822 3.72 4.414 6.082 3.04 4.437 11 20.125 11.797 23.274.29 1.002-.707-.568-2.227-3.43-1.52-2.863-4.855-7.943-7.46-11.306-5.862-7.73-7.97-11.478-7.97-14.269v-2.144zm-1.64 10.409c.223-.023.49 0 .78 0 2.099 0 6.528 3.91 10.508 9.278 4.56 6.155 9.85 19.108 12.383 30.058 1.23 5.582 3.32 19.897 3.32 23.118v2.3l-1.172-2.144c-.651-1.217-1.57-4.817-2.148-8.109-1.665-9.447-4.277-18.585-7.461-26.744-3.184-8.087-10.007-19.566-13.047-22.572-.456-.445-.82-.69-1.054-.78-.49-.804-1.539-1.64-2.032-2.066-1.583-1.44-1.646-2.18-.078-2.339zm-3.556 1.209 1.72 1.052c2.406 1.703 3.33 2.382 2.773 4.561-.307 2.137-.66 4.19-1.094 4.834-.507 1.002-1.1.263-1.68-2.027-.434-1.574-.921-4.15-1.21-5.653l-.509-2.767zm47.54 9.55c.206.02.17.268-.157.78-.666.551-2.296 2.682-3.164 3.899-4.632 6.227-11.354 23.417-12.656 33.293-.724 5.153-1.608 2.797-1.68-4.288-.145-10.234 4.426-21.686 11.445-28.771 2.877-2.952 5.59-4.968 6.211-4.912zm-48.282 4.484c.673.141 2.713 2.118 7.54 6.94 4.486 4.58 9.288 10.067 10.663 12.358 2.75 4.652 5.644 11.463 6.367 14.97.362 2.004-.367 1.21-4.492-4.444-2.75-3.722-6.606-8.71-8.632-11.072-7.816-9.018-10.7-13.457-11.641-17.894-.136-.582-.11-.922.195-.858zm53.515 1.91c.145 0-1.618 2.147-3.789 4.796-2.17 2.72-5.115 7.15-6.562 9.94-2.895 5.726-7.191 18.696-8.71 26.783-1.593 8.302-1.73 8.141-1.368-1.091.651-17.75 7.039-32.102 16.953-38.4 1.81-1.074 3.332-2.028 3.476-2.028zm-52.773 12.748 2.188 1.131c1.23.644 4.169 2.746 6.484 4.678 2.388 2.004 4.555 3.366 4.844 3.08.362-.286.451-.234.234.195-.217.358 1.608 3.452 4.141 6.744 4.849 6.298 10.196 16.222 12.656 23.235.796 2.362 1.356 4.373 1.211 4.445-.072.143-2.233-3.14-4.766-7.29-5.5-9.09-12.009-17.168-16.64-20.818-2.533-2.004-4.42-4.465-6.953-9.045l-3.399-6.355zm57.031 9.435c.05 0 .073.002.117 0-1.287 1.066-4.023 4.171-4.023 4.171-3.618 3.936-7.738 11.304-9.258 17.816-1.664 7.443-1.116 26.564 1.055 34.58.796 2.934 1.395 5.425 1.25 5.497-.507.5-4.79-11.437-5.586-15.516-1.23-6.227-1.158-20.83 0-25.77 1.375-5.582 4.482-12.093 7.305-15.242 2.46-2.791 6.97-5.536 9.14-5.536zm-55.39 2.456c1.092.05 2.367.622 4.375 1.91 7.743 4.867 17.5 17.744 28.789 37.855 9.046 16.246 14.256 28.494 6.875 16.256-10.493-17.32-27.567-40.43-34.297-47.444-.705-.734-1.058-1.012-1.133-.975l-.117-.195c-.94-1.145-3.736-3.423-5.039-4.21-2.894-1.79-2.968-2.508-.508-3.08a3.5 3.5 0 0 1 1.055-.117zm-2.734 3.275c.579 0 1.44.44 1.875 1.013.868 1.074.382 6.568-.703 7.212-.796.573-1.18-.26-1.758-4.483-.434-3.006-.283-3.742.586-3.742zm50.741 19.336s-.083 3.769-.156 8.42c-.651 19.897 6.245 36.643 19.922 48.81 8.177 7.229 17.424 11.179 32.187 13.684 4.921.859 9.421 1.578 10 1.793.579.215 7.387.922 6.953 1.637-.217.287.432.45 1.445.234 2.895-.5 11.87 1.45 14.258 1.52 3.69.072 27.772 5.072 33.36 7.057 1.953.787 6.21 5.71 6.21 7.212 0 .43-2.236.592-6.289.234-4.92-.358-7.466-.998-11.953-3.002-9.335-4.15-22.354-7.106-38.203-8.537-8.177-.716-34.672-5.359-42.343-6.862-9.48-1.932-16.277-4.237-24.96-8.46-9.264-4.508-14.485-8.01-20.274-13.45l-4.688-4.483 3.985 1.131c11.65 3.364 21.061 7.599 32.93 14.97 9.334 5.797 12.433 7.289 17.499 8.577 4.631 1.217 6.016 1.294 6.016.507 0-.287-2.385-1.286-5.352-2.144-20.19-6.227-35.39-27.06-35.39-48.459 0-3.578.353-7.879.86-9.668.723-2.791 3.694-10.72 3.983-10.72zm-46.952 2.3c.363.154.729.293 1.054.351 4.27.644 21.437 11.512 27.227 17.31 2.026 2.003 4.79 5.669 6.093 8.03l2.305 4.367-3.984-3.236c-2.244-1.79-6.307-4.585-8.984-6.16-2.823-1.646-8.813-6.952-14.024-11.89-3.682-3.434-7.625-7.14-9.687-8.772zm11.836 30.136c.303-.013.814.06 1.601.195 1.375.214 5.058 1.006 8.242 1.793 11.434 2.648 25.123 11.287 32.07 20.233l3.125 4.016-3.203-1.638c-1.737-.859-3.113-1.78-2.969-2.066.435-.716-6.795-6.735-10.703-8.81-1.953-1.074-7.456-3.28-12.304-5.069-8.829-3.149-14.044-5.754-15.781-7.758-.498-.626-.584-.875-.078-.896z'/%3e%3cpath fill='%23cab313' fill-opacity='.502' d='M382.785 291.842c-1.583.548-4.01 2.864-5.592 4.038-3.166 2.349-3.591 3.201-.584 1.088 2.217-1.565 5.972-4.38 9.335-4.795.314-.038-1.335 1.61-2.206 2.55-1.187 1.33-.87 1.253 1.9-.548 1.82-1.174 3.324-2.27 3.324-2.426 0-.626-3.407-.925-6.177.093zm-48.802 53.376c0 1.79 22.196 18.156 23.21 17.154.144-.143-2.75-2.147-6.514-4.437-3.69-2.219-8.472-6.08-10.933-8.227-2.388-2.147-5.408-5.617-5.763-4.49z'/%3e%3cg stroke='%23d4af37' stroke-width='.904'%3e%3cpath fill='%23fff' d='M246.162 432.318c-5.483 1.69-12.845 1.998-16.376.691-1.277-.46-5.204-.206-6.18-.052 3.564 2.386 2.118 1.386 2.83 1.881 1.291.76.754.603 3.064 1.633-.395.45-.589.627-2.405 1.29 2.412.567 5.403.8 8.302.67a37.042 37.042 0 0 0 8.747-1.455c3.756-1.076 7.803-1.777 9.005-1.777 1.127 0 5.333 1.259 9.39 3.41 8.545 4.735 14.518 5.95 20.528 5.95 4.131 0 8.44-.922 13.329-4.113 3.613-2.36.568-2.302-3.027-.722-4.958 1.998-15.13 2.89-26.924-3.18-7.136-3.688-12.695-5.84-14.648-5.686-.376 0-2.93.691-5.635 1.46z' transform='matrix(.83739 0 0 .82218 198.784 50.956)'/%3e%3cpath fill='%23d91023' d='M219.856 429.486c1.465 1.23 1.25 1.471 3.79 3.53 3.558.349 10.643 1.11 13.273 1.11 2.328 0 6.826-.404 9.906-1.25 6.233-1.314 9.223-.93 20.567 4.056 13.146 6.763 20.53 5.524 27.29 2.22 9.43-3.586.254-2.04-3.165-3.031-1.127.384-2.568 1.84-5.253 2.817-3.754 1.367-5.765 1.324-10.272-.981-2.855-1.46-5.387-2.152-7.946-3.552-2.52-1.46-3.15-1.289-7.358-2.672l-6.196-1.22-9.38-.496c-8.113 1.69-16.09.4-21.5-1.29-5.408-1.69-6.385-1.393-3.756.759z' transform='matrix(.83739 0 0 .82218 198.784 50.956)'/%3e%3cpath fill='%23d91023' d='M244.35 436.83c-6.46 1.921-14.34 2.016-17.27.94-1.532.62-.008-.018-3.84 1.365-5.033 1.69-5.108 1.768-2.93 2.382 1.278.385 6.311.692 11.27.615 8.563 0 9.314-.153 14.047-2.459 2.78-1.383 5.86-2.459 6.911-2.459.977 0 4.602 2.067 7.757 3.68 8.79 4.61 12.134 5.969 19.42 5.892 7.287-.077 16.694-5.291 17.862-7.074-5.596 3.396-10.23 5.156-17.312 4.87-7.082-.287-12.552-2.834-19.764-6.907-5.784-3.227-7.812-3.304-16.151-.845z' transform='matrix(.83739 0 0 .82218 198.784 50.956)'/%3e%3cg stroke-width='.807'%3e%3cpath fill='%23fff' d='M293.47 417.689c1.216-1.4.855-1.915-2.49-2.381-8.288-1.323-18.856-6.3-23.113-10.888-2.129-2.334-3.117-2.567-3.117-.7 0 1.944 6.766 8.088 11.632 10.577 4.258 2.255 11.67 4.724 14.483 4.724.836 0 1.92-.477 2.604-1.332z' transform='matrix(-.29524 -.60606 -1.27207 .31586 1043.346 433.948)'/%3e%3cpath fill='%23d91023' d='M290.67 421.403c.238-.407-.408-2.4-3.112-2.97-6.682-1.384-14.159-5.289-18.931-9.845-3.58-3.5-5.332-3.843-4.139-.67 1.62 4.575 14.327 11.001 19.259 12.547 5.011 1.628 6.206 2.077 6.922.938z' transform='matrix(-.29524 -.60606 -1.27207 .31586 1043.346 433.948)'/%3e%3cpath fill='%23ed1c24' d='m295.457 415.365.827-1.39-4.033-2.547c-4.601-.588-12.942-3.604-18.55-6.766-2.517-1.398-5.249-2.575-6.112-2.575-1.51 0-1.61 0 .116 1.913 3.954 4.34 14.336 9.397 21.742 10.427 2.373.367 4.788 2.042 6.01.938z' transform='matrix(-.29524 -.60606 -1.27207 .31586 1043.346 433.948)'/%3e%3cpath fill='%23fff' d='M293.47 417.689c1.216-1.4.855-1.915-2.49-2.381-8.288-1.323-18.856-6.3-23.113-10.888-2.129-2.334-3.117-2.567-3.117-.7 0 1.944 6.766 8.088 11.632 10.577 4.258 2.255 11.67 4.724 14.483 4.724.836 0 1.92-.477 2.604-1.332z' transform='matrix(.33397 -.58616 1.24895 .39558 -143.25 396.105)'/%3e%3cpath fill='%23d91023' d='M288.923 420.615c.146-.251 1.314-1.57-1.365-2.182-6.682-1.384-14.159-5.289-18.931-9.845-4.24-4.604-6.35-5.55-4.139-.67 1.62 4.575 14.327 11.001 19.259 12.547 5.011 1.628 4.46 1.289 5.176.15z' transform='matrix(.33397 -.58616 1.24895 .39558 -143.25 396.105)'/%3e%3cpath fill='%23ed1c24' d='m295.457 415.365.827-1.39-4.033-2.547c-4.601-.588-12.942-3.604-18.55-6.766-2.517-1.398-5.249-2.575-6.112-2.575-1.51 0-1.61 0 .116 1.913 3.954 4.34 14.336 9.397 21.742 10.427 2.373.367 4.788 2.042 6.01.938z' transform='matrix(.33397 -.58616 1.24895 .39558 -143.25 396.105)'/%3e%3c/g%3e%3cpath fill='%23fff' d='M319.677 402.697c-6.356 1.817-11.424 5.84-16.665 13.131-2.07 2.879-4.032 4.339-2.635 5.038 1.538.77 2.898-1.393 5.658-4.15 6.96-6.955 12.479-9.89 19.997-9.972h5.969l-1.783-2.478c-2.17-2.973-4.573-3.303-10.541-1.569zm-50.443 2.385c-1.273 1.465-.895 2.003 2.604 2.491 8.67 1.384 19.727 6.591 24.181 11.392 2.227 2.44 3.261 2.685 3.261.732 0-2.034-7.079-8.462-12.17-11.066-4.454-2.36-12.208-4.942-15.152-4.942-.874 0-2.008.498-2.724 1.393z' transform='matrix(.83696 .02647 -.0267 .82176 210.874 47.246)'/%3e%3cpath fill='%23d91023' d='M318.582 399.536c-1.706.578-4.108 1.651-5.426 2.312-3.566 1.982-9.02 8.373-9.834 9.58-.87 1.29-2.14 2.793-3.002 4.19-1.274 2.068-1.482 3.204-.845 3.33.637.126 2.12-.758 3.527-2.73 6.022-8.443 11.55-12.223 19.765-13.874 4.263-.826 4.883-.826 6.356.66 1.162 1.074-.337-.236-.57-.979-.542-1.817-1.91-2.737-4.546-3.233-1.24-.165-3.72.083-5.425.744z' transform='matrix(.83696 .02647 -.0267 .82176 210.874 47.246)'/%3e%3cpath fill='%23d91023' d='M271.987 403.32c-.238.406 1.83 1.139 4.534 1.708 6.682 1.383 14.159 5.289 18.931 9.845 3.58 3.499 5.332 3.843 4.139.67-1.62-4.575-14.327-11.002-19.259-12.548-5.011-1.627-7.629-.815-8.345.324zm48.533 4.061c-4.884 1.734-9.767 4.79-13.642 8.506-3.953 3.882-5.738 6.35-4.188 6.35.31 0 2.715-1.89 4.343-3.294 7.053-6.029 19.763-9.425 25.421-7.36 2.713.99 1.436-2.011-.424-4.736-1.162-1.735-8.023-.705-11.51.534zm-53.097-.266-3.307 3.14 4.928.794c5.091.651 14.318 3.987 20.522 7.486 2.784 1.546 5.807 2.847 6.761 2.847 1.67 0 1.782 0-.127-2.115-4.375-4.8-15.86-10.396-24.053-11.535-2.625-.407-3.372-1.837-4.724-.617z' transform='matrix(.83696 .02647 -.0267 .82176 210.874 47.246)'/%3e%3cpath fill='%23d91023' d='M304.493 422.389c-1.651 5.417-1.432 10.396-.97 14.138 1.605-.193 2.662-.24 5.27-.725.273-2.198.686-4.745.573-7.435.338-3.7-.019-1.771 2.183-4.736-2.375-1.526-3.013-1.66-7.056-1.242z' transform='matrix(.83739 0 0 .82218 197.926 53.423)'/%3e%3cpath fill='%23fff' d='M296.203 428.628c-.084 4.215.317 5.13.27 7.137 2.355.385 7.422 1.07 7.121.225.02.922-.076-4.911-.002-7.985l.854-5.533-3.587-.549-3.23.405-1.426 6.3z' transform='matrix(.83739 0 0 .82218 197.926 53.423)'/%3e%3cpath fill='%23d91023' d='M291.002 428.828c.15 3.343-.53 4.487-.13 6.445 1.05.318 5.047.184 6.286.568-.176-4.355-.176-.547-.598-6.234l1.266-7.28-3.595.287s-2.221-.69-3.732-.72c1.303 2.274.503 6.934.503 6.934z' transform='matrix(.83739 0 0 .82218 197.926 53.423)'/%3e%3c/g%3e%3c/svg%3e";
            },
            9778: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 600 400'%3e%3cclipPath id='a'%3e%3cellipse cx='300' cy='201' rx='85.849' ry='88.189'/%3e%3c/clipPath%3e%3cpath fill='%23ce1126' d='M0 0h600v400H0z'/%3e%3cpath fill='%23fff' d='M0 100h600v200H0z'/%3e%3cg clip-path='url(%23a)'%3e%3cpath fill='%23ff9c10' d='m277.29 191.02-14.575-.42v-5.762l14.575 6.182zm-.06-1.68-14.515-7.383v-9.602s-1.7.24-1.458-1.681c.08-4.001 10.667 7.303 16.093 10.984l-.12 7.682zm-62.86 25.03 30.606.24v-18.966l-34.98-1.67 4.373 20.405zm-1.46-26.17 32.551 3.12-.242-13.443-31.822-12.484-.487 22.807zm6.56-26.88 25.021 12.003 3.573-3.686s-2.301-1.567-2.187-3.009c.043-1.458 2.314-1.68 2.358-3.262.041-1.458-2.573-1.633-2.602-3.092-.17-1.581 2.016-3.277 2.016-3.277l-22.591-19.446-5.588 23.768zm164.21 53.29h-32.307l-.242-18.485 35.464-2.641-2.915 21.127zm.79-26.7c-.408-3.001-.836-5.995-1.531-8.938a91.583 91.583 0 0 0-3.563-11.594c-.106-.278-.265-.534-.375-.812l-27.625 11.562.25 13.688 32.844-3.906zm-18.88-44.44-16.531 12.5c.027 1.196 1.22 2.116 1.548 3.26.763 1.607-.753 3.027-1.692 4.162-.76 1.047.879 1.58 1.424 2.199 1.2 1.232.154 3.162-1.124 3.879 1.54.92 2.318 2.645 2.656 4.344l24.75-12.875c-2.96-6.236-6.65-12.132-11.03-17.468zm-46.03 47.97 13.845-.6.242-5.523-14.088 6.123zm-.01-3-.06-6.241s13.116-11.703 15.91-13.864c0 2.4-1.518 4.26-1.518 4.26v9.124l-14.332 6.721zm-85.01-52.57c.242.24 14.718 16.14 14.718 16.14.406-1.507 3.744-1.736 7.144-1.495 3.402.24 6.113-.226 6.113 2.175 0 2.4-1.726 2.06-1.726 3.74s2.586 1.54 2.586 3.699c0 2.16-1.875 1.72-1.885 3.393-.006 1.383 1.956 1.456 1.956 1.456l13.785 13.205.06-14.105-28.42-44.052-14.33 15.845zm22.74-16.68c.216.64 19.25 38.906 19.25 38.906s.216-35.913 3.46-37.837l-5.406-9.834-17.303 8.765zm62.13-4.13-7.188 24.844a38.91 38.91 0 0 0 6.756.214c2.025.174.448 2.072.556 3.195l-.03 15.278 20.312-35.875c-4.67-2.438-9.627-4.248-14.616-5.905a67.174 67.174 0 0 0-5.79-1.751zm25.28 10.38-25.125 38.625-.031 14.875c5.594-5.322 11.217-10.617 16.794-15.957 1.058-1.499-3.36-2.233-1.152-4.059 2.001-.63 2.34-3.863.233-4.484-1.735-2.548 1.57-3.899 3.654-3.62 2.9.133 5.888-.631 8.725.174 1.561 1.493 3-2.255 4.532-3.099 3.03-3.047 6.063-6.092 9.058-9.173a80.56 80.56 0 0 0-16.688-13.282z'/%3e%3cg fill='%23083d9c' stroke='%23083d9c' stroke-width='1.932'%3e%3cpath stroke-width='2.057' d='M279.88 275.41c-6.178.349-12.334 4.518-15.219 6.75 5.18 2.267 10.71 4.037 16.594 5.25 9.375 1.574 18.75 1.563 28.125 1.563 1.53-.193 3.045-.411 4.531-.657l19.75-6.656s-9.5-6.271-17.03-6c-7.532.271-12.616 7.638-18.689 7.094-6.072-.544-8.505-7.344-17.25-7.344-.273 0-.539-.015-.812 0z'/%3e%3cpath d='m244.01 270.31 112.23.48s-9.716-10.323-21.134-10.563c-11.417-.241-8.258 4.802-17.003 5.52-8.744.722-10.932-5.28-18.948-5.04-8.015.239-12.632 5.04-18.703 5.282-6.073.24-13.846-6.003-18.462-5.762-4.616.24-21.134 7.202-21.134 7.202l3.158 2.88zm-14.33-13.21 138.46.481c2.186-3.12-6.802-10.563-15.06-11.284-6.804.24-11.66 6.962-17.247 7.203-5.587.24-11.902-6.963-18.219-6.721-6.315.24-12.874 6.721-19.19 6.721-6.315 0-10.931-6.963-18.946-6.963-8.016 0-11.66 7.682-17.733 7.203-6.074-.48-11.418-7.682-17.247-7.682-5.83 0-15.546 8.642-17.489 8.161-1.943-.48 2.428 3.602 2.672 2.881zm53.53-13.24 30.908-.018c.24-.24-6.92-10.55-15.449-9.823-9.502.246-15.956 9.841-15.459 9.841zm98.56-.74h-42.294s5.474-3.197 6.966-6.147c2.736 1.475 1.99 2.95 7.464 3.196 5.473.246 10.697-6.146 15.923-5.9 5.224.245 11.941 9.097 11.941 8.851zm-166.67 0h42.294s-5.474-3.197-6.966-6.147c-2.736 1.475-1.99 2.95-7.464 3.196-5.472.246-10.697-6.146-15.923-5.9-5.224.245-11.941 9.097-11.941 8.851zm3.16-13.14 30.121.24s-1.943-4.08-2.186-9.122c-7.775-2.64-14.09 5.761-19.676 6.001-5.586.24-11.415-6.001-11.415-6.001l3.157 8.882zm160.81 0-30.122.24s1.944-4.08 2.186-9.122c7.775-2.64 14.09 5.761 19.677 6.001 5.587.24 11.416-6.001 11.416-6.001l-3.157 8.882zm-88.18.24 15.302-.479s.244-4.562-7.773-4.562c-8.016 0-7.286 5.282-7.53 5.041z'/%3e%3c/g%3e%3cpath fill='%23ce1126' stroke='%23630810' stroke-linejoin='round' stroke-width='1.932' d='m282.87 181 31.823 8.403v-44.895c-14.576.721-26.72-27.368-.972-29.288-25.263-3.601-28.179 2.881-31.093 9.843l.243 55.937zm7.07 40.58c-6.921 11.33-25.425 7.97-29.752.06-1.296-.363-.53-48.8-.53-48.8s-2.067-.93-2.163-2.42c-.094-1.504 2.812-1.64 2.812-3.565 0-1.924-2.968-1.17-3.027-3.106.012-1.852 3.168-1.597 3.027-3.308-.167-1.928-3.534-1.643-3.677-3.42-.11-1.413 2.408-2.644 3.108-3.28-.453.023-2.339-.027-2.35-.033l-5.3.107c-3.766.004.064.811.01 2.958-.035 1.403-1.91 2.336-2.078 3.556-.06 1.252 2.683 2.131 2.717 3.634.032 1.34-2.694 1.432-2.596 2.677.17 2.109 2.414 2.573 2.38 3.85-.034 1.274-3.02 1.76-3.028 2.778.104 1.968.432 49.807.432 49.807 4.759 24.37 32.228 30.569 40.015-1.496zm18.11 0c6.921 11.33 25.424 7.97 29.751.06 1.296-.363.53-48.8.53-48.8s2.068-.93 2.163-2.42c.094-1.504-2.63-1.64-2.63-3.565 0-1.924 2.787-1.17 2.845-3.106-.012-1.852-2.925-1.716-2.784-3.428.166-1.928 2.454-1.703 2.584-3.48.109-1.531-1.436-2.464-2.136-3.099.453.022 2.217-.028 2.23-.034l5.299.107c3.766.004-.065.811-.01 2.958.035 1.403 1.91 2.336 2.078 3.556.059 1.252-2.684 2.131-2.718 3.634-.03 1.34 2.695 1.432 2.596 2.678-.17 2.108-2.414 2.572-2.38 3.848.034 1.275 3.021 1.761 3.028 2.779-.103 1.968-.431 49.807-.431 49.807-4.76 24.37-32.228 30.569-40.015-1.496z'/%3e%3cg fill='%23630810' stroke='%23630810' stroke-linecap='round' stroke-width='2.792'%3e%3cpath d='M281.66 223.73c2.672-1.442 5.101-2.88 6.802-6.243l-10.446.24s-4.856 2.882-7.287 6.003h10.931zm33.76 0c-2.672-1.442-5.1-2.88-6.801-6.243l10.445.24s4.857 2.882 7.286 6.003h-10.93zm-52.71-10.08 71.903.24'/%3e%3cpath id='b' d='m266.11 196.61 8.502 11.284m-8.502-.004 9.232-11.043m-4.372-.967-.243 6.962'/%3e%3cuse xlink:href='%23b' x='13.604'/%3e%3cuse xlink:href='%23b' x='27.45'/%3e%3cuse xlink:href='%23b' x='41.782'/%3e%3cuse xlink:href='%23b' x='55.628'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";
            },
            9305: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 768 576'%3e%3cpath d='M0 0h768v576H0z'/%3e%3cpath fill='%23ce1126' d='M0 0h768v576z'/%3e%3cpath fill='%23fcd116' d='M475.485 167.354c-5.673 7.326-19.095-7.37-35.175-7.706-16.08-.335-27.471 15.41-32.16 20.77-4.69 5.361-19.765 33.5-19.43 36.515.335 3.015 9.38-8.374 12.73-10.384.335 4.02-3.685 8.71-2.68 10.05 1.005 1.34 11.724-8.04 15.41-8.375 1.005 2.68-2.01 5.36-1.005 9.38 1.34 1.34 7.37-6.7 11.39-8.375.67 3.015-3.685 8.71-1.34 12.395 1.675.334 11.724-11.39 15.075-12.73 3.35-1.341-1.676 11.054 0 12.06 3.015-2.01 12.395-12.731 15.41-14.07 3.015-1.34-.334 13.735 1.005 13.735 3.685-2.68 13.065-15.41 14.07-17.42 1.005-2.01-1.005 19.43 9.38 30.82 10.385 11.39 26.131 24.455 27.805 24.455 2.01-3.685-.669-11.39 1.005-11.055 4.69 5.025 13.4 12.395 15.41 12.395s-1.34-8.04 1.34-8.04c5.36 5.025 20.77 24.79 50.92 33.835-2.01-5.695-6.366-10.72-6.7-13.4 2.01.335 9.046 3.686 10.385 3.35 1.34-.336-14.74-20.1-13.735-22.78 3.685-.335 5.36 2.01 6.7.334-1.675-2.68-15.745-18.424-15.745-22.11 0-3.685 4.356.67 5.695 0 1.34-.67-5.36-14.74-4.02-16.414 1.34-1.675 16.08 9.045 19.765 9.045 3.685 0 1.005-13.065 2.68-13.736 1.675-.67 14.071 7.035 16.75 7.035 2.68 0 2.345-5.695 3.35-5.025 1.005.67 30.15 29.816 20.1 63.986-10.05 24.455-30.149 37.52-59.63 26.8 1.675 2.68 17.42 15.745 34.505 11.055 17.085-4.69 37.854-18.09 35.51-51.59-2.345-33.5-13.401-38.19-15.075-43.215-1.675-5.025 2.681 1.34 6.365 2.68 3.685 1.341-.67-7.035-1.675-10.72-1.005-3.686 11.055 7.705 14.07 8.71 3.015 1.005-7.035-27.47-10.05-29.48-3.015-2.01 3.015.67 5.025 1.34 2.01.67-18.426-31.155-22.78-31.155-4.355 0 3.684-1.676 6.03-1.676 2.345 0-23.449-20.77-27.805-20.77-4.355 0 9.379-5.36 10.72-5.695 2.345.334-29.815-17.085-58.625.334-1.675-1.338 13.569-11.891 14.07-16.413.168-1.173-5.024-3.686-5.36-5.025-.335-1.34 8.04-5.36 8.375-8.375-2.01-2.68-5.695-1.675-7.705-2.345-.502-2.512 7.036-8.71 6.365-11.39-.502-1.507-6.03-2.01-7.37-1.004-1.34 1.005 3.518-7.035 2.68-9.38-.67-1.005-3.35-.335-6.03.335-1.675-.335 8.71-14.74 6.7-16.75-2.01-2.01-30.15 14.739-40.535 33.499-10.385 18.76-2.344 33.835-3.685 40.2-1.34 6.365-3.016 12.73-7.37 12.73-4.355 0-14.404-6.7-17.755-10.05-3.35-3.35-4.02-5.695-8.71-7.035-4.69-1.34-15.41 2.68-19.43 3.015-4.02.335-19.765-3.015-20.77-2.01-1.005 1.005 15.41 7.035 19.095 9.045 3.685 2.01 4.021 4.69 6.7 6.365 2.68 1.674 27.805 9.045 19.765 19.43zm98.155 47.235c8.04 8.04 62.31 44.22 62.31 88.44s-39.53 42.88-50.92 41.54c12.73 10.72 60.97 8.71 60.97-41.54 0-44.22-62.31-88.44-70.35-92.46-8.04-4.02-10.05-4.02-2.01 4.02z'/%3e%3cg fill='%23fff'%3e%3cpath d='m220.254 418.599 11.455-36.851L243.164 419 213 396.168h37.418z'/%3e%3cpath id='a' d='m192.418 178.496-22.909 73.702 60.327-44.862H155L215.327 253z'/%3e%3cuse xlink:href='%23a' x='-88' y='112.504'/%3e%3cuse xlink:href='%23a' x='87.582' y='104.504'/%3e%3cuse xlink:href='%23a' y='264.504'/%3e%3c/g%3e%3c/svg%3e";
            },
            6015: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 180 90'%3e%3cpath fill='%230038a8' d='M0 0h180v90H0z'/%3e%3cpath fill='%23ce1126' d='M0 45h180v45H0z'/%3e%3cpath fill='%23fff' d='M77.942 45 0 90V0'/%3e%3cg fill='%23fcd116' transform='translate(28 45)'%3e%3ccircle r='9'/%3e%3cg id='d'%3e%3cg id='c'%3e%3cg id='b'%3e%3cpath d='m-19 0 1.169 1.169L0 0l-17.831-1.169z'/%3e%3cpath id='a' d='m-.884.116.05.05L0 0z' transform='scale(19.2381)'/%3e%3cuse xlink:href='%23a' transform='scale(1 -1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(45)'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='rotate(90)'/%3e%3c/g%3e%3cuse xlink:href='%23d' transform='rotate(180)'/%3e%3cg transform='translate(-2.02)'%3e%3cg id='f' transform='translate(37.962)'%3e%3cpath id='e' d='M5 0 1.618 1.176l-.073 3.58-2.163-2.854-3.427 1.037L-2 0z'/%3e%3cuse xlink:href='%23e' transform='scale(1 -1)'/%3e%3c/g%3e%3cuse xlink:href='%23f' transform='rotate(120)'/%3e%3cuse xlink:href='%23f' transform='rotate(-120)'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";
            },
            675: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-75 -40 120 80'%3e%3cpath fill='%23fff' d='M-75-40H45v80H-75z'/%3e%3cpath fill='%2301411C' d='M-45-40h90v80h-90z'/%3e%3ccircle r='24' fill='%23fff'/%3e%3ccircle cx='-7' cy='-40' r='22' fill='%2301411C' transform='rotate(-41.634 45 -40)'/%3e%3cpath fill='%23fff' d='m8.751-17.959 10.11 11.373L3.997-9.844l13.94-6.1-7.692 13.129z'/%3e%3c/svg%3e";
            },
            7254: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 10'%3e%3cpath fill='%23fff' d='M0 0h16v10H0z'/%3e%3cpath fill='%23dc143c' d='M0 5h16v5H0z'/%3e%3c/svg%3e";
            },
            2282: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3cpath fill='%23ED2939' d='M0 0h900v600H0z'/%3e%3cpath fill='%23fff' d='M0 0h600v600H0z'/%3e%3cpath fill='%23002395' d='M0 0h300v600H0z'/%3e%3c/svg%3e";
            },
            9761: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 15'%3e%3cclipPath id='a'%3e%3cpath d='M0 0v75h350v75h-50zm300 0H150v200H0v-50z'/%3e%3c/clipPath%3e%3cpath fill='%23012169' d='M0 0h30v15H0z'/%3e%3cpath stroke='%23fff' stroke-width='1.5' d='m0 0 15 7.5M15 0 0 7.5'/%3e%3cpath stroke='%23c8102e' stroke-width='20' d='m0 0 300 150m0-150L0 150' clip-path='url(%23a)' transform='scale(.05)'/%3e%3cpath stroke='%23fff' stroke-width='2.5' d='M7.5 0v10M0 3.75h17.5'/%3e%3cpath stroke='%23c8102e' stroke-width='1.5' d='M7.5 0v10M0 3.75h17.5'/%3e%3cpath fill='%23012169' d='M15 0v7.5H0V15h30V0z'/%3e%3cg fill='%23F7E017' stroke='%23000' stroke-width='.015'%3e%3cpath d='M20.018 7.954c-.32.271-.625.667-.7 1.025-.211 1.007-.491 1.231-.923 1.015 0 .541.474.582.682.266 0 .507.184.947.599 1.322.175.158.208.05.125-.125-.083-.175-.083-.74-.249-1.064.266.191.657.083.624-.441-.341.2-.68.192-.715-.283-.043-.557.174-1.366.557-1.715zm-.405-4.005c.023-.2-.02-.405-.166-.534-.282-.248-.558-.166-.764.034-.308-.166-.471.423-.82.324.058.191.15.274.324.208-.183.166 0 .366-.216.565.391.125.599-.091.582-.466.15.133.382.125.507-.025-.208-.067-.209-.247-.125-.416.125-.249.711-.239.678.31z'/%3e%3cpath fill='%23337321' d='M20.515 6.842c-.441.233-1.247.133-1.322-.441-.075-.574.482-.832.632-.906.233-.117.416.091.341.333a.377.377 0 0 0 .191-.565c.341.025.657-.233.79-.599-.12.114-.446.037-.714.02.083-.091.082-.269.057-.361-.282.29-.69.157-1.23.997.083-.291.241-.873.333-1.256.009-.038.016-.076.021-.115.032-.549-.553-.559-.678-.309.137.154.065.334.016.607-.058.324-.183 1.073-.291 1.322-.033-.391-.291-.416-.341-.607-.075.05-.116.183-.1.274-.092-.1-.408.025-.524-.125-.125.249.075.499.283.607-.121.008-.15.154-.283.154.179.208.362.291.574.308.212.017.37.096.499.353.208.417 1 .687 1.746.309z'/%3e%3cpath d='M21.613 6.334c-.249.69-.931 1.181-1.239 1.256-.524.127-1.592.646-1.878.913a.332.332 0 0 1-.118-.048c-.141-.1-.258-.424-.008-.699.782-.732 1.622-.416 2.146-.915-.441.233-1.247.133-1.322-.441a2.029 2.029 0 0 0 2.012-.599c.091.101.357.417.407.533z'/%3e%3cpath fill='%23337321' d='M20.018 7.954c-.395.335-.6 1.158-.558 1.715.012.155.055.26.121.324.029-.316.249-1.133.81-1.497.474-.308 1.214-.998 1.489-1.788a.634.634 0 0 0-.291-.341c-.273.746-1.002 1.104-1.571 1.587z'/%3e%3cpath fill='%23316D3A' d='M21.359 6.014a1.854 1.854 0 0 1-.769.62.403.403 0 0 0 .091-.249c-.391.15-1.173.133-1.489.017a2.029 2.029 0 0 0 2.012-.599c.068.074.126.14.155.211z'/%3e%3cpath fill='%23337321' d='M18.37 7.756c-.636.595-.216 1.114.033 1.231-.066.416.324.366.316.715.158-.091.2-.333.175-.524.2.216.707-.025.815.374.067-.441-.274-.881-.698-.84.175-.158.075-.416-.091-.482-.033.324-.399.324-.541.225-.142-.1-.259-.424-.009-.699z'/%3e%3cpath d='M19.746 11.54c-.069.04-.064.129-.021.187.087.116-.062.38.22.437.083.017.147-.034.179-.129.087-.262-.191-.291-.216-.416-.025-.125-.104-.112-.162-.079z'/%3e%3cpath d='M19.983 12.031c-.093.043-.175.104-.137.403.015.124.008.424-.1.428.066.033.208.069.266-.008.056.094.183.067.233-.05.066.054.158-.037.158-.116.058.037.175-.017.145-.195.071.025.162-.025.195-.071-.104-.021-.366-.162-.428-.274-.062-.113-.224-.167-.332-.117z'/%3e%3cpath fill='none' d='M18.542 3.62c.042-.062.089-.12.141-.171m1.441 1.272c.073-.042.185-.047.309-.039m-.421 8.172c-.029-.042-.04-.216-.019-.322m.252.272a.493.493 0 0 1-.148-.262m.306.146c-.058-.027-.2-.21-.231-.328m.376.132a.825.825 0 0 1-.366-.297'/%3e%3cpath d='M24.382 7.765c1.023.857 1.089 1.538.931 1.938-.083-.374-.507-.956-.948-1.106l.017-.832z'/%3e%3cpath fill='%23337321' d='M22.553 7.282h1.896v2.245c0 1.913-1.064 3.044-2.146 3.642-1.081-.599-2.146-1.73-2.146-3.642V7.282h1.331a.729.729 0 0 0 .15.466c.314-.031.669-.266.915-.466z'/%3e%3cpath fill='%23006EC7' d='M24.449 7.282v2.245c0 .577-.097 1.084-.262 1.525l-1.883-3.455-1.883 3.455a4.327 4.327 0 0 1-.262-1.525V7.282h4.29z'/%3e%3cpath stroke='none' d='M24.244 10.887a4.274 4.274 0 0 1-.14.369l-1.8-3.346-1.8 3.346a3.969 3.969 0 0 1-.14-.369l1.941-3.598 1.939 3.598z'/%3e%3cpath d='M23.159 12.118c.05.025.142.071.183.088.1-.2.116-.482.083-.732-.108.275-.474.266-.574.432.061.031.118.071.167.106-.125.125-.417.334-.583.384v-1.784c0-.125-.042-.229-.042-.333V9.91c0-.083-.017-.204-.091-.204-.075 0-.091.121-.091.204v.369c0 .104-.042.225-.042.333v1.784c-.091-.266-.45-.175-.616-.441a.466.466 0 0 1 .2-.008c-.125-.424-.466-.457-.532-.582 0 .175-.075.582.042.757a.437.437 0 0 1 .113-.092c.141.308.777.309.927.816.12-.187.553-.403.856-.728z'/%3e%3cpath d='M22.303 10.634c.141 0 .59-.046.753-.046.042 0 .077-.063.077-.141s-.034-.141-.077-.141c-.162 0-.611-.046-.753-.046-.141 0-.59.046-.753.046-.042 0-.077.063-.077.141s.034.141.077.141c.163 0 .612.046.753.046z'/%3e%3cpath d='M22.212 9.903a.18.18 0 0 0-.113-.039c-.094 0-.171.07-.171.156s.076.156.171.156c.094 0 .17-.07.17-.156 0-.067.097-.067.097 0 0 .135-.12.244-.267.244-.148 0-.267-.109-.267-.244s.12-.244.267-.244c.044 0 .086.01.123.027-.003.022-.01.064-.01.1zm-.661.685c.042 0 .076-.063.076-.141s-.034-.141-.076-.141'/%3e%3cpath d='M21.613 10.588c.042 0 .076-.063.076-.141s-.034-.141-.076-.141m.411.311c.051 0 .092-.076.092-.17 0-.094-.041-.17-.092-.17m.095.347c.053 0 .096-.08.096-.178 0-.098-.043-.178-.096-.178m.32.358c.054 0 .097-.081.097-.18 0-.099-.044-.18-.097-.18m.1.355c.053 0 .096-.078.096-.174 0-.096-.043-.174-.096-.174m.447.317c.043 0 .078-.064.078-.144s-.035-.144-.078-.144m-1.61 1.728a.618.618 0 0 1 .178-.074m1.514.091-.049-.035m.14.106c.116-.125.213-.266.267-.428'/%3e%3cpath fill='%23FFF' d='M21.922 8.87c0-.041.033-.058.072-.087.047-.035.066-.052.108-.052h.546c.04 0 .05.01.05.048v.741c0 .037-.009.048-.05.048h-.726v-.706'/%3e%3cpath fill='%23E5E5E5' d='M22.513 9.633c.072 0 .059-.002.109-.052.053-.052.048-.048.048-.096v-.679c0-.035-.009-.045-.046-.045h-.505c-.04 0-.057.016-.1.049-.036.027-.066.044-.066.082v.741h.56z'/%3e%3cpath fill='%23FFF' d='M22.567 9.617c0 .037-.009.048-.05.048h-.546c-.041 0-.049-.01-.049-.048v-.742c0-.037.009-.048.049-.048h.546c.041 0 .05.01.05.048v.742z'/%3e%3cpath fill='%2396877D' d='M23.625 6.847a.419.419 0 0 1 .083.434h-.158c.066-.2.025-.39-.258-.415-.423-.037-.915.782-1.655.881-.216-.258-.205-.749.07-.982-.142-.409-.441-.859-.649-1.053a2.03 2.03 0 0 0-.394-.027c.108-.233.416-.478.666-.578.04-.059.084-.116.124-.167.025-.32 1.547-.17 1.871.029.001.359.142 1.554.3 1.878z'/%3e%3cpath fill='%23000' stroke='none' d='M21.781 7.066c-.036-.554-.26-1.011-.575-1.322.15.042.457.042.665-.108.274-.183.99-.503 1.252-.366.021.046.033.15.017.216-.062-.166-.753.091-.948.17-.187.087-.27.204-.204.466-.108-.091-.071-.179-.183-.245.045.108.082.303.095.461-.042-.112-.116-.353-.279-.495.141.274.264.933.206 1.283.112 0 .36-.11.459-.189-.087.125-.339.212-.501.245-.073.087-.123.312-.119.437-.011-.154.037-.529.115-.553zm1.844-.219c-.138-.153-.395-.236-.723-.147.05-.025.158-.067.254-.083-.012-.087-.091-.462-.104-.553l.092-.037c.046.225.104.482.141.586.029.008.096.021.154.05-.025-.087-.166-.715-.162-.782l.125-.067c.049.341.128.836.223 1.033z'/%3e%3cpath fill='%2396877D' d='M23.551 7.282c.066-.2.025-.39-.258-.415-.219-.019-.457.194-.738.415h.996zM21.713 5.49a1.648 1.648 0 0 1-.545-.054.64.64 0 0 1 .041-.118c-.087.058-.253.172-.316.251.2.042.612.063.82-.079z'/%3e%3cpath fill='none' d='M21.708 6.766c.046.133.076.261.08.375m-.457-2.033c-.075.11-.141.228-.163.328.141.046.42.071.545.054'/%3e%3cpath fill='none' d='M21.059 5.713c.054.009.104.019.147.031.15.042.457.042.665-.108.208-.15.773-.615 1.414-.665'/%3e%3cpath fill='none' d='M20.894 5.569c.2.042.612.062.819-.079.482-.328.948-.52 1.414-.545'/%3e%3cpath fill='%23337321' d='M24.382 7.765c.698.482 1.214.948 1.364 1.696.15.748.433.948.782.748-.083.432-.516.482-.881.15.033.499-.166 1.098-.682 1.314-.033-.299.165-.536.108-.782-.025-.108-.033-.358.108-.474-.274.091-.707-.083-.748-.491.316.15.723.175.881-.225.157-.398.091-1.08-.932-1.936zm.882-3.892c.216-.565.782-.507.973-.266.557-.316.632.399 1.106.258-.008.133-.166.258-.341.249.183.166-.075.416.316.565-.333.166-.798-.008-.923-.466-.108.216-.499.216-.657.042.341-.091.316-.407.125-.532-.193-.126-.533-.075-.599.15zm-1.687 1.245c.155.5.476.966.822 1.283.399.366 1.002.274 1.339-.075.008.696-.713.75-1.114.532-.177-.096-.32-.046-.15.108.258.233.822.406 1.488.549 1.164.249.749 1.173.408 1.164.098-.002.178-.104.037-.231-1.01-.909-3.064-.551-3.031-2.58-.216.532-1.106.324-.69-.308.133.108.366.116.433-.05.052-.129.018-.354-.215-.548.038-.003.121 0 .112-.096.01.056.061.139.192.111.037.059.077.098.13.077.01-.004.042-.02.029-.079.01.112.141.151.21.143z'/%3e%3cpath d='M24.623 6.858c.482.316 1.028.316 1.53-.266.158-.183.407-.341.582-.358.175-.017.166-.183.299-.216-.083-.025-.116-.125-.241-.112.312-.108.22-.358.374-.478-.125.046-.32-.141-.499.096.046-.108-.017-.237-.062-.287.017.125-.245.15-.295.466-.028.177-.125.166-.141-.108-.012-.201-.108-.757-.224-1.039-.116-.283-.143-.671.015-.729a.308.308 0 0 0-.098-.102c-.193-.126-.532-.075-.599.15-.216.565.391.89.341 1.505-.091-.457-.832-.574-.823-1.023-.241.108-.208.308-.116.466-.15-.233-.491.15-.782-.166-.033.416.333.574.632.59-.15.266.05.491.249.565.008-.466.963-.275.973.524.008.68-.724.738-1.115.522zm1.339.657c1.164.249.749 1.173.408 1.164-.217-.005-.424-.187-.437-.345-.249.133-.183.395.008.499-.524-.062-.744.283-.757.661.096-.175.387-.187.495-.15.108.037.387.058.499-.067-.092.079.058.262-.071.403.437-.017.628-.424.553-.603.566-.514.458-1.354-.698-1.562zm-.886 3.951c.076.047.066.147.015.21-.103.126.052.427-.265.478-.094.015-.163-.045-.194-.152-.086-.296.226-.316.259-.455.034-.138.121-.121.185-.081z'/%3e%3cpath d='M24.79 12.003c.102.052.19.124.136.456-.023.138-.028.473.093.482-.076.034-.235.067-.297-.021-.067.102-.207.066-.258-.066-.077.057-.175-.049-.171-.137-.067.039-.194-.026-.154-.224-.08.025-.18-.035-.215-.087.117-.019.415-.165.49-.288.074-.122.257-.175.376-.115z'/%3e%3cpath fill='none' d='M24.721 12.921c.034-.045.054-.24.035-.359m-.292.293a.545.545 0 0 0 .176-.286m-.348.149c.066-.028.232-.226.272-.357m-.426.133c.077-.013.318-.157.421-.316'/%3e%3cpath d='M23.376 5.869c-.014.852.34 1.284.831 1.564-.182-.109-.103-.483-.349-.604.058-.004.15.079.295.046-.071-.158-.187-.399-.457-.432.071-.008.225.017.324-.021-.141-.217-.515-.113-.644-.553zm-.088-.811c-.03-.01-.055-.04-.08-.079-.131.028-.182-.055-.192-.111.008.096-.074.092-.113.095.234.194.268.419.216.548-.067.166-.299.158-.433.05-.017.353.441.47.607.025 0 .075.096.067.121.166.118-.191.028-.466-.126-.694z'/%3e%3cpath fill='%23337321' d='M22.557 3.37a.994.994 0 0 1-.295-.694c.008-.183.083-.383.349-.299-.083 0-.025.166-.112.183.071.025.166-.033.179-.071.017.058.125.042.133.108.042-.033-.004-.195-.066-.229.046-.025.071-.154.05-.216-.042.008-.104.067-.116.15.021-.067-.004-.233-.121-.258-.033.046-.042.158.004.22-.108-.025-.266.046-.304.137.008-.11.024-.267.092-.366.023-.033-.033-.091-.077-.012-.081-.158-.297-.241-.393-.162s-.224-.037-.303.087c-.079.125-.347.138-.333.27.008.079-.011.201-.05.245-.096.108.046.187.071.283-.017-.316.486-.931.99-.69-.046.079-.086.237-.1.428-.021.283.021.682.295.915l.107-.029z'/%3e%3cpath fill='%23c8102e' d='M22.706 2.38c-.003-.075.127-.172.301-.17.21.002.372.193.54.175.168-.019.085.075.05.1-.035.025-.056.062-.044.108.012.046-.009.076-.077.033-.15-.094-.299.037-.497-.035-.169-.064-.268-.099-.273-.211z'/%3e%3cpath fill='%2396877D' d='M21.85 4.343c-.083-.262-.399-.549-.553-.615l-.008-.141c.083-.033.283-.191.374-.279.624.299 1.472-.125 1.863-.565l.15.091-.075.1-.079-.042a4.777 4.777 0 0 1-.561.523c.145.037.344.062.399.059.349-.25.623-.474.756-.491l.112.15-.1.071-.079-.046c-.374.308-.798.981-.965 1.43-.232-.05-1.064-.017-1.234-.245z'/%3e%3cpath fill='none' d='M22.961 3.415a.607.607 0 0 1-.129-.045c-.067.062-.233.116-.445.125'/%3e%3cpath fill='none' d='M21.883 4.251c-.056-.31.033-.653.191-.757.345.229.936.229 1.285-.021'/%3e%3cpath fill='none' d='M21.883 4.089a8.87 8.87 0 0 1 .985.058c.141.021.378.079.345.15m-1.207-.252.077-.076-.077-.076-.076.075.076.077z'/%3e%3cpath fill='%23337321' d='M22.187 2.497c-.096-.133-.359-.175-.416.004-.025.079-.062.162-.125.2-.062.037-.048.151-.021.2.066.121.008.237.137.316 0-.096.141-.195.262-.22.121-.025.303-.133.328-.254.026-.122.068-.222-.165-.246z'/%3e%3cpath fill='%2396877D' d='M21.588 3.694h.033l.001.227a.075.075 0 0 1 .02.01l.196-.113.017.029-.197.114c.001.007.002.015.001.022l.196.113-.017.029-.198-.112a.047.047 0 0 1-.019.012v.226h-.033v-.227a.075.075 0 0 1-.02-.01l-.196.113-.017-.029.197-.114c-.001-.007-.002-.015-.001-.022l-.196-.113.017-.029.197.113a.047.047 0 0 1 .019-.012v-.227z'/%3e%3cpath fill='%2396877D' d='M21.884 4.25a.393.393 0 1 1 .033-.517.887.887 0 0 0-.046.211.27.27 0 1 0-.268.296.276.276 0 0 0 .263-.202c.001.052.003.171.018.212z'/%3e%3cpath fill='%23337321' d='M21.438 4.625c-.025-.029-.071-.108-.066-.166a.217.217 0 0 1 .141.054c-.004-.042-.021-.133-.012-.175a.38.38 0 0 1 .175.133.603.603 0 0 1-.008-.216c.05.029.133.108.15.162a.716.716 0 0 1 .058-.254c.037.037.096.071.133.121.008-.067.042-.146.091-.166a.483.483 0 0 1 .108.245c.037-.012.087-.075.108-.108a.228.228 0 0 1 .029.162c.046-.042.1-.1.112-.15a.319.319 0 0 1 .112.154c-.008-.054-.004-.15-.021-.204a.24.24 0 0 1 .125.154c.017-.058.054-.162.087-.187a.455.455 0 0 1 .062.212c.021-.042.054-.116.087-.133.029.046.025.146.017.2a.4.4 0 0 1 .116-.108.348.348 0 0 1 0 .112c.037-.021.1-.133.121-.191a.29.29 0 0 1 .121.179.452.452 0 0 0 .15-.133c0 .029.013.108-.004.17.025-.025.05-.075.062-.096.017.042.004.141-.013.195a.219.219 0 0 1 .125-.054c.004.071-.046.195-.092.287-.398-.111-1.234-.153-2.074-.199z'/%3e%3cpath stroke='none' d='M22.83 2.423c-.002-.031.066-.1.189-.099.147.001.283.109.4.101.118-.008.06.031.035.041-.025.01-.039.026-.031.044.009.019-.006.031-.054.014-.105-.038-.21.015-.348-.014-.119-.027-.188-.041-.191-.087z'/%3e%3cpath d='M21.567 4.875c-.125.15-.249.125-.274.029-.025-.096.067-.141.033-.225-.033-.083.054-.121.096-.083.042.037.175-.083.233.042.058.125.104.212.071.262-.034.05-.134.025-.159-.025zm.536-.225c-.023-.055.106-.16.173-.085.067.075.171-.081.229.037.058.119.077.181.106.247.029.067-.158.102-.216.044.008.039-.162.07-.208-.042-.025-.059-.052-.128-.084-.201zm.865.069c-.031-.058.121-.141.2-.035.021-.044.171-.052.181.075l.019.252c.004.05-.091.096-.16-.031-.123.025-.179-.044-.193-.116a.54.54 0 0 0-.047-.145z'/%3e%3cpath fill='%23337321' d='M21.648 4.636c-.019-.042.106-.125.191-.062.085.062.203-.054.254.058.102.227.108.243.077.287-.031.044-.164.027-.198-.033-.006.042-.121.035-.181.002-.068-.038-.116-.177-.143-.252zm.875.01c-.029-.064.166-.121.252-.008.044-.04.139-.042.193.081.054.123.062.191.023.222-.028.022-.129.039-.162-.017-.046.029-.187.004-.218-.075-.031-.078-.058-.147-.088-.203zm.828.123c-.004-.058.102-.085.141 0 .04.085.166.008.177.15.002.027-.015.131-.054.181s-.233 0-.245-.106a2.419 2.419 0 0 1-.019-.225z'/%3e%3cpath fill='none' d='M21.567 4.875c-.046-.062-.108-.162-.187-.054m.593.064a.49.49 0 0 1-.075-.139m.497.148a.345.345 0 0 1-.096-.106m.058-.113c.073.008.123.077.145.108.023.031.071.087.108.094m.219.048c-.025-.04-.05-.075-.056-.104m.002-.183a.483.483 0 0 1 .058.098m.374.243a.345.345 0 0 0-.129-.143m.113-.086c.004.123.168.131.175.218m.126-.199a.238.238 0 0 1 .025.114'/%3e%3c/g%3e%3c/svg%3e";
            },
            3642: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23FFF' viewBox='0 0 900 600'%3e%3cpath d='M0 0h900v600H0'/%3e%3cpath stroke='%23E00' stroke-width='120' d='M0 60h900m0 240H0m0 240h900'/%3e%3cpath fill='%230050F0' d='M0 0v600l520-300'/%3e%3cpath d='m114 382 59-183 59 183L77 269h192'/%3e%3c/svg%3e";
            },
            5711: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 3'%3e%3cpath fill='%23007A3D' d='M0 0h6v3H0z'/%3e%3cpath fill='%23FFF' d='M0 0h6v2H0z'/%3e%3cpath d='M0 0h6v1H0z'/%3e%3cpath fill='%23CE1126' d='m0 0 2 1.5L0 3Z'/%3e%3c/svg%3e";
            },
            9668: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 600 400'%3e%3cpath fill='red' d='M0 0h600v400H0z'/%3e%3cpath fill='%23060' d='M0 0h240v400H0z'/%3e%3cg fill='%23ff0' fill-rule='evenodd' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.573'%3e%3cpath d='M318.24 262.04c-30.21-.91-168.74-87.38-169.69-101.15l7.65-12.757c13.74 19.966 155.36 104.06 169.27 101.08l-7.23 12.823'/%3e%3cpath d='M154.59 146.4c-2.71 7.294 36.149 31.318 82.903 59.754 46.752 28.434 87.065 46.006 90.053 43.486.183-.325 1.47-2.54 1.352-2.523-.56.844-1.923 1.11-4.05.497-12.632-3.643-45.576-18.765-86.375-43.506-40.798-24.743-76.294-47.544-81.81-57.232-.384-.671-.658-1.896-.602-2.848l-.134-.002-1.175 2.053-.161.322h-.001zm164.36 116.04c-.512.93-1.467.96-3.282.761-11.3-1.25-45.589-17.925-86.162-42.213-47.21-28.26-86.2-54.01-81.97-60.74l1.151-2.034.227.07c-3.804 11.405 76.948 57.578 81.702 60.522 46.724 28.947 86.115 45.851 89.601 41.458l-1.268 2.181v-.002z'/%3e%3cpath d='M240.17 169.23c30.237-.239 67.55-4.132 89.023-12.69l-4.627-7.517c-12.692 7.025-50.21 11.644-84.652 12.335-40.736-.375-69.49-4.168-83.897-13.835l-4.367 8.005c26.484 11.207 53.623 13.587 88.52 13.703'/%3e%3cpath d='M330.44 156.71c-.739 1.182-14.743 6.011-35.373 9.575-13.988 2.133-32.234 3.956-55.004 3.978-21.633.02-39.305-1.52-52.684-3.333-21.656-3.396-32.833-8.12-36.965-9.79.395-.785.65-1.337 1.03-2.07 11.895 4.736 23.124 7.591 36.28 9.615 13.29 1.8 30.75 3.362 52.275 3.342 22.664-.023 40.71-1.984 54.616-4.053 21.155-3.412 32.711-7.804 34.334-9.843l1.494 2.579h-.002zm-4.06-7.623c-2.293 1.842-13.718 5.894-33.82 9.104-13.414 1.922-30.471 3.643-52.264 3.664-20.704.02-37.62-1.375-50.485-3.249-20.414-2.666-31.28-7.475-35.196-8.877.39-.674.786-1.343 1.194-2.014 3.048 1.535 13.533 5.791 34.226 8.723 12.72 1.803 29.66 3.147 50.262 3.126 21.69-.022 38.553-1.776 51.883-3.688 20.205-2.78 31.077-7.948 32.728-9.241l1.473 2.45v.003zm-185.5 56.573c18.598 10.003 59.905 15.044 98.994 15.391 35.591.056 81.958-5.502 99.297-14.69l-.477-10.012c-5.425 8.477-55.113 16.609-99.206 16.276-44.093-.333-85.038-7.143-98.687-15.959l.08 8.991'/%3e%3cpath d='M340.12 204.22v2.387c-2.605 3.116-18.945 7.826-39.436 11.142-15.595 2.391-35.927 4.195-61.262 4.195-24.07 0-43.263-1.716-58.148-4.001-23.53-3.427-38.58-9.427-41.6-11.217l.013-2.786c9.075 6.034 33.661 10.447 41.917 11.798 14.788 2.27 33.868 3.974 57.817 3.974 25.216 0 45.434-1.792 60.931-4.167 14.701-2.123 35.644-7.646 39.767-11.324h.001zm.01-8.492v2.387c-2.605 3.114-18.945 7.824-39.436 11.14-15.595 2.391-35.927 4.195-61.262 4.195-24.07 0-43.263-1.715-58.148-4.002-23.53-3.424-38.58-9.424-41.6-11.216l.013-2.785c9.075 6.033 33.661 10.447 41.917 11.796 14.788 2.272 33.868 3.976 57.817 3.976 25.216 0 45.434-1.792 60.931-4.17 14.701-2.123 35.644-7.646 39.767-11.323l.001.002zM239.79 260.32c-42.772-.255-79.421-11.659-87.16-13.544l5.643 8.834c13.67 5.75 49.424 14.32 81.927 13.371 32.504-.948 60.91-3.466 80.928-13.21l5.787-9.156c-13.642 6.425-60.068 13.639-87.125 13.705'/%3e%3cpath stroke-width='.55' d='M323.3 253.72a134.08 134.08 0 0 1-2.596 3.83c-9.442 3.329-24.32 6.824-30.597 7.843-12.824 2.643-32.665 4.594-50.274 4.603-37.89-.554-68.905-7.972-83.496-14.299l-1.178-2.024.193-.304 1.996.774c25.948 9.284 55.091 12.987 82.698 13.652 17.538.062 35.095-2.01 49.292-4.549 21.771-4.362 30.574-7.65 33.275-9.14l.687-.386h0zm5.017-8.275.066.077a269.275 269.275 0 0 1-1.963 3.263c-5.035 1.8-18.702 5.798-38.659 8.589-13.149 1.791-21.322 3.526-47.479 4.034-49.015-1.247-80.75-10.831-88.289-13.195l-1.117-2.143c28.406 7.415 57.422 12.592 89.408 13.12 23.93-.509 34.112-2.271 47.152-4.05 23.27-3.618 34.996-7.449 38.515-8.555a2.667 2.667 0 0 0-.154-.2l2.523-.942-.002.002z'/%3e%3cpath d='M328.83 197.76c.139 28.137-14.26 53.386-25.858 64.525-16.408 15.759-38.163 25.896-63.569 26.363-28.37.521-55.12-17.974-62.295-26.099-14.028-15.885-25.449-36.057-25.815-63.243 1.738-30.709 13.793-52.1 31.268-66.769s40.743-21.813 60.121-21.302c22.358.59 48.475 11.558 66.521 33.332 11.823 14.266 16.943 29.748 19.627 53.193zm-89.186-96.342c54.485 0 99.296 44.338 99.296 98.703 0 54.364-44.811 98.704-99.296 98.704s-98.924-44.339-98.924-98.704 44.439-98.703 98.924-98.703'/%3e%3cpath d='M239.91 101.08c54.534 0 99.011 44.483 99.011 99.022 0 54.538-44.478 99.02-99.011 99.02-54.534 0-99.011-44.481-99.011-99.02s44.478-99.022 99.011-99.022zm-96.832 99.022c0 53.26 43.736 96.842 96.832 96.842 53.097 0 96.833-43.582 96.833-96.842 0-53.262-43.737-96.844-96.833-96.844s-96.832 43.584-96.832 96.844z'/%3e%3cpath d='M239.99 109.31c49.731 0 90.693 40.821 90.693 90.704 0 49.884-40.963 90.703-90.693 90.703s-90.693-40.819-90.693-90.703c0-49.883 40.964-90.704 90.693-90.704zm-88.515 90.703c0 48.685 39.979 88.524 88.515 88.524s88.515-39.839 88.515-88.524c0-48.686-39.978-88.525-88.515-88.525-48.536 0-88.515 39.84-88.515 88.525z'/%3e%3cpath d='M243.98 100.68h-8.485l.01 198.96h8.514z'/%3e%3cpath d='M243.13 99.546h2.16l.018 201.25h-2.161l-.016-201.25zm-8.421.002h2.176l.003 201.25h-2.178V99.548z'/%3e%3cpath d='M338.99 203.935v-7.355L333 191l-34-9-49-5-59 3-42 10-8.48 6.28v7.357L162 194l51-8h49l36 4 25 6z'/%3e%3cpath d='M239.95 184.77c23.383-.043 46.07 2.215 64.065 5.72 18.569 3.712 31.637 8.355 36.105 13.57l-.005 2.583c-5.388-6.49-22.973-11.248-36.518-13.968-17.858-3.474-40.393-5.717-63.647-5.674-24.538.046-47.387 2.37-64.984 5.803-14.12 2.802-32.951 8.368-35.302 13.858v-2.689c1.291-3.8 15.313-9.479 34.984-13.417 17.729-3.457 40.62-5.741 65.302-5.786zm.01-8.492c23.383-.042 46.07 2.217 64.065 5.72 18.569 3.713 31.637 8.355 36.105 13.57l-.005 2.583c-5.388-6.489-22.973-11.247-36.518-13.966-17.858-3.476-40.393-5.719-63.647-5.674-24.538.044-47.276 2.37-64.875 5.801-13.626 2.584-33.226 8.37-35.412 13.86v-2.69c1.291-3.76 15.597-9.642 34.985-13.417 17.729-3.458 40.62-5.74 65.302-5.787zm-.48-43.318c36.849-.184 68.99 5.152 83.695 12.685l5.364 9.279c-12.781-6.888-47.456-14.05-89.005-12.979-33.854.208-70.027 3.727-88.176 13.41l6.403-10.709c14.895-7.724 50.022-11.643 81.72-11.684'/%3e%3cpath d='M239.97 140.62c21.017-.056 41.325 1.13 57.476 4.044 15.041 2.799 29.385 7 31.436 9.26l1.59 2.81c-4.988-3.257-17.4-6.884-33.339-9.906-16.006-3.008-36.3-4.005-57.2-3.95-23.722-.081-42.152 1.171-57.969 3.929-16.728 3.13-28.334 7.601-31.197 9.726l1.558-2.97c5.564-2.838 14.39-6.26 29.223-8.93 16.357-2.988 34.983-3.884 58.423-4.013h0zm-.009-8.484c20.113-.053 39.972 1.068 55.452 3.85 12.209 2.377 24.283 6.088 28.704 9.39l2.326 3.695c-3.954-4.395-18.836-8.56-31.974-10.892-15.361-2.65-34.395-3.698-54.508-3.866-21.108.06-40.615 1.352-55.752 4.108-14.441 2.749-23.76 6.002-27.703 8.543l2.045-3.087c5.441-2.864 14.232-5.495 25.303-7.646 15.249-2.777 34.876-4.036 56.108-4.095zM289.15 241.26c-18.218-3.4-36.469-3.895-49.217-3.745-61.407.72-81.244 12.61-83.665 16.21l-4.59-7.482c15.635-11.332 49.074-17.687 88.588-17.037 20.518.336 38.224 1.698 53.119 4.583l-4.236 7.473'/%3e%3cpath stroke-width='.55' d='M239.58 236.46c17.082.255 33.849.96 50.033 3.978l-1.172 2.07c-15.031-2.775-31.055-3.837-48.803-3.75-22.663-.178-45.585 1.939-65.541 7.666-6.297 1.753-16.721 5.8-17.784 9.146l-1.166-1.923c.336-1.977 6.636-6.08 18.414-9.39 22.858-6.545 44.24-7.649 66.02-7.799v.002zm.775-8.596c17.698.33 35.975 1.149 53.74 4.668l-1.22 2.153c-16.042-3.184-31.37-4.246-52.415-4.57-22.735.042-46.851 1.663-68.778 8.037-7.08 2.063-19.297 6.52-19.704 10.05l-1.166-2.065c.265-3.206 10.842-7.388 20.358-10.156 22.096-6.424 46.275-8.076 69.186-8.117z'/%3e%3cpath d='m327.58 247.38-7.379 11.449L299 240l-55-37-62-34-32.19-11.01 6.86-12.72L159 144l20 5 66 34 38 24 32 23 13 15z'/%3e%3cpath d='M148.65 158.29c5.646-3.83 47.139 14.655 90.555 40.834 43.301 26.254 84.677 55.921 80.942 61.473l-1.228 1.932-.564.445c.12-.087.743-.848-.06-2.906-1.846-6.07-31.196-29.491-79.895-58.895-47.475-28.31-87.04-45.371-90.997-40.494l1.247-2.39h0zm180.44 88.927c3.57-7.052-34.916-36.044-82.632-64.272-48.813-27.666-83.994-43.951-90.42-39.095l-1.428 2.6c-.012.142.052-.178.354-.411 1.168-1.02 3.105-.95 3.979-.967 11.065.166 42.667 14.71 87.006 40.128 19.428 11.315 82.071 51.491 81.832 62.79.017.97.08 1.17-.285 1.651l1.594-2.423v-.002z'/%3e%3c/g%3e%3cpath fill='%23fff' stroke='%23000' stroke-width='.67' d='M180.6 211.01c0 16.271 6.663 30.987 17.457 41.742 10.815 10.778 25.512 17.579 41.809 17.579 16.381 0 31.247-6.653 42.016-17.389 10.769-10.735 17.443-25.552 17.446-41.88h-.002v-79.189l-118.74-.141.012 79.278h.002z'/%3e%3cpath fill='red' stroke='%23000' stroke-width='.507' d='M182.82 211.12v.045c0 15.557 6.441 29.724 16.775 40.009 10.354 10.305 24.614 16.712 40.214 16.712 15.681 0 29.912-6.36 40.222-16.626 10.308-10.265 16.697-24.433 16.699-40.044h-.002V134.39l-113.84-.019-.07 76.748m91.022-53.747.004 48.891-.041 5.172c0 1.361-.081 2.912-.24 4.233-.925 7.73-4.48 14.467-9.745 19.708-6.164 6.136-14.671 9.942-24.047 9.942-9.327 0-17.64-3.938-23.83-10.1-6.349-6.32-10.03-14.986-10.03-23.947l-.012-54.023 67.94.122.002.002z'/%3e%3cg id='e'%3e%3cg id='d' fill='%23ff0' stroke='%23000' stroke-width='.5'%3e%3cpath stroke='none' d='M190.19 154.43c.135-5.521 4.052-6.828 4.08-6.847.029-.019 4.232 1.407 4.218 6.898l-8.298-.051'/%3e%3cpath d='m186.81 147.69-.682 6.345 4.14.009c.04-5.25 3.975-6.123 4.07-6.103.09-.005 3.989 1.16 4.093 6.103h4.151l-.75-6.394-15.022.038v.002zm-.96 6.37h16.946c.357 0 .65.353.65.784 0 .43-.293.781-.65.781H185.85c-.357 0-.65-.35-.65-.781 0-.431.293-.784.65-.784z'/%3e%3cpath d='M192.01 154.03c.018-3.313 2.262-4.25 2.274-4.248 0 0 2.342.966 2.36 4.248h-4.634m-5.8-8.98h16.245c.342 0 .623.318.623.705 0 .387-.28.704-.623.704H186.21c-.342 0-.623-.315-.623-.704 0-.387.28-.705.623-.705zm.34 1.42h15.538c.327 0 .595.317.595.704 0 .388-.268.704-.595.704H186.55c-.327 0-.595-.316-.595-.704 0-.387.268-.704.595-.704zm5.02-10.59 1.227.002v.871h.895v-.89l1.257.004v.887h.897v-.89h1.258l-.002 2.01c0 .317-.254.521-.549.521h-4.41c-.297 0-.57-.237-.572-.526l-.003-1.988h.001zm4.62 2.69.277 6.451-4.303-.015.285-6.453 3.741.017'/%3e%3cpath id='a' d='m190.94 141.56.131 3.478-4.125.001.116-3.479h3.879-.001z'/%3e%3cuse xlink:href='%23a' x='10.609'/%3e%3cpath id='b' d='m186.3 139.04 1.2.003v.872h.877v-.892l1.23.004v.889h.879v-.893l1.23.002-.002 2.012c0 .314-.249.518-.536.518h-4.317c-.29 0-.559-.235-.56-.525l-.002-1.989z'/%3e%3cuse xlink:href='%23b' x='10.609'/%3e%3cpath fill='%23000' stroke='none' d='M193.9 140.61c-.026-.627.877-.634.866 0v1.536h-.866v-1.536'/%3e%3cpath id='c' fill='%23000' stroke='none' d='M188.57 142.84c-.003-.606.837-.618.826 0v1.187h-.826v-1.187'/%3e%3cuse xlink:href='%23c' x='10.641'/%3e%3c/g%3e%3cuse xlink:href='%23d' y='46.32'/%3e%3cuse xlink:href='%23d' transform='rotate(-45.202 312.766 180.004)'/%3e%3c/g%3e%3cuse xlink:href='%23d' x='45.714'/%3e%3cuse xlink:href='%23e' transform='matrix(-1 0 0 1 479.792 0)'/%3e%3cg id='f' fill='%23fff'%3e%3cpath fill='%23039' d='M232.636 202.406v.005c0 2.212.85 4.227 2.212 5.69 1.365 1.466 3.245 2.377 5.302 2.377 2.067 0 3.944-.905 5.303-2.365 1.358-1.459 2.202-3.472 2.202-5.693v-10.768l-14.992-.013-.028 10.766'/%3e%3ccircle cx='236.074' cy='195.735' r='1.486'/%3e%3ccircle cx='244.392' cy='195.742' r='1.486'/%3e%3ccircle cx='240.225' cy='199.735' r='1.486'/%3e%3ccircle cx='236.074' cy='203.916' r='1.486'/%3e%3ccircle cx='244.383' cy='203.905' r='1.486'/%3e%3c/g%3e%3cuse xlink:href='%23f' y='-26.016'/%3e%3cuse xlink:href='%23f' x='-20.799'/%3e%3cuse xlink:href='%23f' x='20.745'/%3e%3cuse xlink:href='%23f' y='25.784'/%3e%3c/svg%3e";
            },
            6103: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 500'%3e%3cpath fill='%234AADD6' d='M0 0h800v500H0z'/%3e%3ccircle cx='350' cy='250' r='150' fill='%23FFDE00'/%3e%3c/svg%3e";
            },
            6475: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 330'%3e%3cpath fill='%230038a8' d='M0 0h600v330H0z'/%3e%3cpath fill='%23fff' d='M0 0h600v220H0z'/%3e%3cpath fill='%23d52b1e' d='M0 0h600v110H0z'/%3e%3cg fill='none' stroke='%23000'%3e%3ccircle cx='300' cy='165' r='42.2' stroke-width='1.076'/%3e%3ccircle cx='300' cy='165' r='34.67' stroke-width='.478'/%3e%3ccircle cx='300' cy='165' r='26.56' stroke-width='.438'/%3e%3c/g%3e%3cpath d='m277.53 181.28-4.893 2.905-1.496-2.52c-.277-.467-.45-.848-.516-1.142a1.326 1.326 0 0 1 .09-.862c.128-.28.347-.513.659-.698.271-.16.54-.242.805-.243.266-.001.52.063.763.193.154.082.324.22.508.415a1.753 1.753 0 0 1-.053-.5c.007-.08.044-.212.113-.395a2.15 2.15 0 0 1 .178-.392l.984-1.574 1.015 1.71-1.016 1.695c-.132.217-.204.383-.214.497-.011.154.024.3.106.438l.08.134 1.985-1.18zm-3.812.21-.379-.638a2.65 2.65 0 0 0-.304-.36.465.465 0 0 0-.3-.155.526.526 0 0 0-.34.074c-.157.093-.249.215-.274.366s.044.363.208.64l.394.663zm-4.608-3.78-1.487-4.471 1.153-.384.93 2.8.859-.286-.864-2.597 1.102-.366.863 2.597 1.065-.354-.958-2.88 1.222-.407 1.514 4.552zm-1.95-6.65-.332-2.904c-.073-.632.024-1.123.288-1.472.265-.35.675-.556 1.23-.62.571-.065 1.037.055 1.397.362.361.306.582.812.662 1.516l.11.957 2.098-.24.2 1.754zm2.21-2.03-.05-.428c-.038-.337-.124-.567-.256-.69a.57.57 0 0 0-.473-.153.632.632 0 0 0-.43.23c-.11.131-.147.36-.11.687l.057.498zm-2.39-8.65.188-1.744 3.373.363c.334.037.645.123.93.259.286.136.529.328.727.574s.33.497.394.751c.089.353.108.768.057 1.244-.03.275-.082.573-.155.895a2.37 2.37 0 0 1-.318.791 2.056 2.056 0 0 1-.553.548c-.23.158-.461.259-.692.302a3.408 3.408 0 0 1-.975.058l-3.373-.363.189-1.745 3.453.373c.31.033.56-.026.752-.179.192-.152.304-.38.337-.684.032-.3-.028-.546-.18-.735-.153-.19-.386-.302-.7-.335zm.76-4.17 1.086-3.107c.181-.518.448-.87.802-1.058a1.32 1.32 0 0 1 1.098-.083c.317.11.555.305.713.582.105.185.158.42.157.705.228-.354.486-.582.776-.685.29-.103.605-.095.947.025a1.515 1.515 0 0 1 1.025 1.172c.032.167.017.398-.044.692a7.8 7.8 0 0 1-.187.77l-1.001 2.864zm2.692-.938.253-.722c.09-.259.108-.455.055-.587-.054-.133-.165-.228-.334-.287-.156-.055-.296-.047-.42.024s-.228.231-.316.483l-.256.733zm2.11.738.297-.847c.1-.286.12-.505.059-.657a.543.543 0 0 0-.347-.32c-.159-.055-.307-.041-.444.041s-.256.269-.358.56l-.295.842zm-2.112-6.64.908-1.505 3.673 2.216 1.418-2.35 1.2.724-2.327 3.855zm3.44-5.21 1.128-1.354 4.371 3.643-1.128 1.354zm7.65-2.94 1.472-.651c.203.395.315.775.335 1.14.02.365-.047.71-.2 1.038-.155.327-.425.656-.812.988-.469.403-.91.665-1.325.784-.415.119-.878.1-1.389-.059-.51-.158-.996-.505-1.457-1.04-.614-.715-.896-1.427-.846-2.137.05-.71.423-1.363 1.118-1.96.543-.468 1.065-.725 1.565-.772.5-.048 1.021.091 1.564.417l-.953 1.274a1.33 1.33 0 0 0-.377-.178 1.012 1.012 0 0 0-.477 0 1.031 1.031 0 0 0-.432.229c-.303.26-.43.58-.382.962.034.285.217.62.549 1.007.412.48.766.745 1.064.798.298.053.578-.034.841-.26.255-.219.387-.456.394-.712.007-.255-.077-.545-.252-.868zm6.06-2.18-1.767.942.198.959-1.585.845-.79-6.027 1.692-.902 4.564 4.015-1.623.865zm-.904-.912-1.517-1.51.41 2.1zm5.374-5.828 2.574-.445c.508-.087.93-.09 1.265-.006.337.084.629.237.877.46.249.222.449.496.6.822.15.326.259.68.325 1.062.103.6.115 1.076.036 1.43-.08.353-.221.663-.425.928a1.88 1.88 0 0 1-.703.58 4.079 4.079 0 0 1-1.006.332l-2.574.444zm1.952.97.53 3.064.424-.073c.362-.062.612-.147.752-.254s.234-.268.286-.483c.052-.215.04-.547-.038-.996-.102-.594-.27-.984-.501-1.17-.232-.185-.572-.24-1.02-.162zm5.358-1.95 4.708.201-.052 1.214-2.947-.126-.039.904 2.734.117-.05 1.159-2.733-.117-.048 1.12 3.032.13-.055 1.288-4.793-.205zm6.85.54 1.708.418-1.02 4.166 2.666.653-.333 1.36-4.374-1.07zm9.13 3.03 2.516 1.487c.548.324.881.697 1 1.12.119.421.036.873-.248 1.354-.293.494-.67.793-1.132.895-.462.103-.998-.026-1.608-.387l-.829-.49-1.074 1.818-1.52-.899zm.286 2.987.37.22c.292.172.527.242.705.21a.57.57 0 0 0 .408-.284.632.632 0 0 0 .077-.482c-.04-.167-.2-.334-.483-.502l-.431-.255zm4.934 6.633-1.467-1.364-.841.5-1.316-1.224 5.441-2.71 1.404 1.306-2.309 5.623-1.347-1.253zm.568-1.152.933-1.926-1.851 1.072zm.682 3.782 4.692-3.22 1.658 2.417c.307.448.504.817.59 1.106.085.29.074.579-.034.866-.109.288-.313.535-.611.74-.26.178-.523.277-.788.295a1.578 1.578 0 0 1-.774-.142 2.13 2.13 0 0 1-.534-.382c.06.213.09.378.086.497-.002.08-.03.213-.087.4a2.237 2.237 0 0 1-.152.404l-.88 1.634-1.124-1.639.903-1.758c.118-.226.179-.396.181-.51a.738.738 0 0 0-.135-.43l-.087-.129-1.905 1.307zm3.79-.459.42.612c.045.066.154.18.327.34a.465.465 0 0 0 .309.134.524.524 0 0 0 .334-.095c.152-.104.235-.232.25-.384.016-.151-.068-.36-.25-.624l-.436-.637zm1.76 8.519-.742-1.86-.975.092-.666-1.67 6.078-.122.71 1.781-4.492 4.095-.682-1.708zm1.006-.798 1.667-1.343-2.131.178zm1.484 6.218 1.17-.175.403 2.687-2.4.359c-.427-.462-.734-.881-.92-1.258-.185-.376-.319-.836-.4-1.378-.1-.668-.067-1.23.097-1.685.165-.455.455-.832.871-1.13.416-.3.916-.493 1.499-.58.614-.092 1.167-.045 1.66.14.492.185.892.505 1.2.958.24.355.407.854.504 1.499.093.622.106 1.095.04 1.42a1.832 1.832 0 0 1-.41.847 2.354 2.354 0 0 1-.831.593l-.55-1.632a.919.919 0 0 0 .434-.425c.088-.182.113-.4.075-.656-.057-.382-.235-.666-.534-.853-.299-.186-.735-.237-1.308-.151-.609.09-1.027.27-1.254.539-.227.268-.31.607-.248 1.016.03.195.085.376.168.544.082.168.209.356.378.563l.53-.079zm3.72 8.26-.156 1.748-3.379-.302a2.86 2.86 0 0 1-.935-.24 2.059 2.059 0 0 1-.737-.561 1.967 1.967 0 0 1-.407-.744c-.096-.352-.123-.766-.08-1.243.024-.275.07-.575.138-.897a2.37 2.37 0 0 1 .303-.797c.134-.21.315-.395.542-.558.228-.163.457-.268.687-.315.37-.076.695-.102.973-.077l3.38.302-.156 1.747-3.46-.308c-.31-.028-.56.036-.748.192-.19.156-.298.386-.325.69-.027.302.038.546.194.732.156.187.391.294.706.323zm-6.29 6.02.626-1.903-.807-.555.562-1.707 4.737 3.81-.599 1.82-6.073.255.574-1.748zm1.284.034 2.14.042-1.748-1.233zm2.036 4.626-1.004 1.675-2.238-.002 1.057 1.973-.998 1.664-1.699-3.597-2.044-1.226.906-1.511 2.044 1.225z'/%3e%3cg fill='%23009b3a' stroke='%23000' stroke-width='.1'%3e%3cpath d='M305.58 145.3s16.052 6.916 13.249 21.207-11.74 14.195-15.244 15.775c-3.504 1.58-5.922 3.84-7.305 3.523-1.382-.316-3.21-1.383-3.21-1.383s-.146 2.347 2.668 2.775 6.515-3.705 8.292-4.164c1.777-.46 12.688-1.644 15.343-16.185 3.098-15.522-13.693-21.092-13.792-21.548z'/%3e%3cpath d='M313.68 148.34a2.204.522 75.104 0 1-1.057.081 2.204.522 75.104 1 1 1.057-.081z'/%3e%3cpath d='M313.13 148.49a2.27.506 63.335 1 1-.957.35 2.27.506 63.335 0 1 .957-.35zm-1.61 1.06a2.15.535 17.053 0 1-.1 1.086 2.15.535 17.053 0 1 .1-1.086z'/%3e%3cpath d='M311.76 148.96a2.26.509 34.225 1 1-.462.916 2.26.509 34.225 1 1 .462-.916z'/%3e%3cpath d='M312.44 148.68a2.299.5 46.194 1 1-.699.716 2.299.5 46.194 0 1 .699-.716z'/%3e%3cpath d='M313.56 150.7c.009.01-.62.35-.762.4-.142.05-.335-.19-.744.02-.41.21-.69.593-.78.818-.089.225.116.32.611.079.495-.24.625-.621.863-.77.239-.15.639-.37.867-.45.098-.216.418-.677.584-.942.165-.265.815-.702 1.051-1.21.206-.422.129-.78-.147-.63-.277.15-.634.572-.8.876-.166.304-.023.69-.208.975-.146.206-.497.833-.535.834zm4.97 1.64a3.305.742 88.415 1 1-1.491-.357 3.305.742 88.415 1 1 1.491.357z'/%3e%3cpath d='M317.7 152.31a3.443.712 77.49 1 1-1.442.072 3.443.712 77.49 1 1 1.442-.072z'/%3e%3cpath d='M315.13 153.11a3.207.764 34.91 1 1-.499 1.511 3.207.764 34.91 1 1 .499-1.511z'/%3e%3cpath d='M315.65 152.38a3.43.715 50.904 0 1-.943 1.105 3.43.715 50.904 1 1 .943-1.105z'/%3e%3cpath d='M316.69 152.28a3.504.7 61.837 1 1-1.205.713 3.504.7 61.837 1 1 1.205-.713z'/%3e%3cpath d='M317.57 155.67c.01.018-.973.223-1.187.232-.214.009-.402-.422-1.038-.304s-1.152.54-1.35.823c-.198.282.055.508.82.385.764-.123 1.07-.61 1.45-.717.38-.107 1.006-.242 1.349-.257.207-.264.804-.781 1.12-1.086.317-.306 1.361-.641 1.857-1.264.425-.51.437-1.058.005-.967-.432.09-1.066.537-1.397.897-.331.36-.261.978-.611 1.303-.27.23-.965.971-1.017.955zm3.57 3.33a.738 3.32 8.74 1 1-1.393-.639.738 3.32 8.74 1 1 1.393.639z'/%3e%3cpath d='M320.35 158.8a3.465.707 87.95 1 1-1.422-.205 3.465.707 87.95 1 1 1.422.205z'/%3e%3cpath d='M317.69 159.1a3.223.76 46.026 1 1-.76 1.397 3.223.76 46.026 1 1 .76-1.397z'/%3e%3cpath d='M318.33 158.48a3.455.71 61.791 1 1-1.12.91 3.455.71 61.791 1 1 1.12-.91z'/%3e%3cpath d='M319.35 158.58a3.53.694 72.543 1 1-1.306.473 3.53.694 72.543 1 1 1.306-.473z'/%3e%3cpath d='M319.61 162.09c.006.02-.991.033-1.202 0-.21-.032-.316-.493-.96-.499-.643-.006-1.223.313-1.468.553-.244.24-.038.513.732.539.77.025 1.157-.397 1.547-.43.39-.033 1.027-.046 1.364.005.251-.22.927-.617 1.292-.858.365-.24 1.446-.371 2.043-.891.507-.423.617-.962.179-.955-.44.007-1.14.326-1.528.618-.389.293-.432.916-.833 1.17-.305.175-1.118.773-1.166.747m1.73 4.331a.738 3.32 31.311 0 1-1.013-1.168.738 3.32 31.311 0 1 1.013 1.168'/%3e%3cpath d='M320.69 165.91a.703 3.487 20.618 0 1-1.208-.778.703 3.487 20.618 0 1 1.208.778m-2.52-.82a3.276.748 69.934 0 1-1.23.98 3.276.748 69.934 0 1 1.23-.98'/%3e%3cpath d='M318.99 164.78a3.511.698 85.137 0 1-1.368.38 3.511.698 85.137 1 1 1.368-.38'/%3e%3cpath d='M319.88 165.3a.685 3.578 5.55 1 1-1.366-.102.685 3.578 5.55 1 1 1.366.102'/%3e%3cpath d='M318.75 168.66c-.002.02-.91-.38-1.089-.496-.178-.117-.094-.588-.674-.86-.58-.271-1.23-.216-1.544-.094-.315.122-.234.46.453.802.686.341 1.201.11 1.567.24.367.132.948.383 1.234.57.312-.101 1.078-.19 1.502-.262.424-.072 1.453.254 2.195.018.624-.182.933-.636.533-.811-.4-.175-1.158-.17-1.623-.059-.465.111-.747.671-1.208.74-.344.037-1.312.256-1.346.212m.59 5.29a.864 3.782 48.457 1 1-.73-1.656.864 3.782 48.457 1 1 .73 1.656'/%3e%3cpath d='M318.79 173.16a.821 3.982 37.466 1 1-1.073-1.296.821 3.982 37.466 1 1 1.073 1.296'/%3e%3cpath d='M316.29 171.34a3.81.858 86.522 1 1-1.677.638 3.81.858 86.522 1 1 1.677-.638'/%3e%3cpath d='M317.29 171.29a.806 4.054 11.633 0 1-1.63-.075.806 4.054 11.633 1 1 1.63.075'/%3e%3cpath d='M318.1 172.18a.795 4.11 22.119 1 1-1.47-.607.795 4.11 22.119 1 1 1.47.607'/%3e%3cpath d='M315.75 175.49c-.009.022-.878-.748-1.035-.941-.158-.194.089-.684-.46-1.194-.55-.509-1.282-.683-1.669-.662-.387.02-.408.423.235 1.049.644.625 1.287.556 1.647.833.36.277.918.765 1.17 1.075.377 0 1.25.18 1.74.254.49.074 1.516.805 2.41.814.746.025 1.236-.365.853-.703-.382-.338-1.219-.605-1.767-.651-.549-.047-1.042.47-1.573.38-.391-.084-1.529-.193-1.551-.254m-1.58 5.05a.967 4.17 79.752 1 1 .2-1.998.967 4.17 79.752 1 1-.2 1.998'/%3e%3cpath d='M314.09 179.47a.923 4.37 68.504 0 1-.328-1.853.923 4.37 68.504 0 1 .328 1.853'/%3e%3cpath d='M312.66 176.29a.964 4.183 26.238 0 1-1.966-.363.964 4.183 26.238 1 1 1.966.363'/%3e%3cpath d='M313.66 176.83a.91 4.434 41.823 0 1-1.533-1.014.91 4.434 41.823 0 1 1.533 1.014'/%3e%3cpath d='M313.95 178.15a.897 4.495 52.671 1 1-1.088-1.427.897 4.495 52.671 0 1 1.088 1.427'/%3e%3cpath d='M309.87 179.93c-.02.016-.439-1.219-.485-1.494-.046-.275.46-.599.208-1.4-.252-.803-.865-1.392-1.249-1.596-.384-.204-.625.166-.346 1.134.28.967.938 1.273 1.134 1.744.196.472.468 1.258.543 1.699.363.22 1.107.895 1.54 1.248.433.354 1.023 1.643 1.882 2.169.707.455 1.392.367 1.207-.175-.185-.543-.846-1.281-1.35-1.642-.504-.362-1.263-.156-1.725-.548-.332-.307-1.37-1.068-1.359-1.139'/%3e%3cpath d='M307.4 184.24a1.212 4.22 89.068 0 1 .007-2.425 1.212 4.22 89.068 0 1-.007 2.425'/%3e%3cpath d='M306.84 180.45a1.171 4.366 37.587 0 1-1.799-1.504 1.171 4.366 37.587 1 1 1.799 1.504'/%3e%3cpath d='M307.43 182.38a1.197 4.271 66.472 0 1-.857-2.239 1.197 4.271 66.472 0 1 .857 2.239m1.15-36.72a2.62.533 41.126 0 1-.995.542 2.62.533 41.126 1 1 .995-.542m-1.29 1.09a2.654.526 8.163 0 1 .202 1.09 2.654.526 8.163 1 1-.202-1.09'/%3e%3cpath d='M307.81 146.06a2.776.503 26.817 1 1-.526.861 2.776.503 26.817 0 1 .526-.861m-19.02 34.07s3.536.758 6.61 1.875c3.074 1.118 7.744 4.952 9 5.17 1.407.063 3.36-.417 4.101-2.45-2.168.578-3.469 1.457-5.539.32-.731-.278-3.126-2.458-5.752-3.626s-7.92-2.497-7.92-2.497l-.5 1.208m3.77-31.97c-.013-.03 4.07-2.147 4.07-2.147l-4.488 1.147-.522.79.94.21'/%3e%3cpath d='M296.42 149.15c-1.576-.286-4-.816-5.542-.94 1.066-1.181 2.536-3.179 3.442-4.405-.598 1.17-1.537 2.712-1.908 3.831 1.087.587 2.794 1.046 4.008 1.514'/%3e%3cpath d='M291.83 148.41c-.018-.028 3.617-2.8 3.617-2.8l-4.2 1.879-.375.868.958.053'/%3e%3cpath d='M295.69 149.11c-1.587-.302-4.029-.858-5.58-.991 1.048-1.217 2.485-3.276 3.37-4.54-.577 1.207-1.49 2.797-1.84 3.952 1.1.61 2.823 1.09 4.05 1.579'/%3e%3cpath d='M291.23 148.64c-.01-.031 4.26-1.784 4.26-1.784l-4.587.755-.592.74.919.289'/%3e%3cpath d='M295.21 149.15c-1.605-.134-4.086-.433-5.635-.4.893-1.35 2.072-3.6 2.8-4.981-.43 1.289-1.146 3.005-1.357 4.218 1.16.5 2.92.8 4.192 1.163'/%3e%3cpath d='M290.79 148.66c-.023-.024 2.885-3.516 2.885-3.516l-3.656 2.734-.17.932.941-.15'/%3e%3cpath d='M295.19 149.38c-1.72-.033-4.387-.184-6.03-.038.813-1.538 1.84-4.076 2.474-5.635-.327 1.437-.915 3.36-1.018 4.7 1.285.463 3.186.667 4.574.973'/%3e%3cpath d='M290.21 149.49c-.022-.03 3.504-3.362 3.504-3.362l-4.24 2.346-.29 1.005 1.026.011'/%3e%3cpath d='M294.42 149.49c-1.848.007-4.694-.093-6.497.109 1.196-1.715 2.83-4.536 3.837-6.27-.65 1.592-1.684 3.726-2.071 5.203 1.289.478 3.297.656 4.731.958'/%3e%3cpath d='M289.03 149.74c-.018-.033 4.476-3.791 4.476-3.791l-5.06 2.69-.52 1.114 1.104-.013'/%3e%3cpath d='M293.75 149.6c-1.83.264-4.664.562-6.422 1.01.94-1.838 2.154-4.816 2.904-6.645-.417 1.642-1.135 3.865-1.307 5.36 1.346.286 3.361.18 4.825.275'/%3e%3cpath d='M288.43 150.49c-.026-.027 3.449-4.777 3.449-4.777l-4.304 3.892-.23 1.192 1.085-.307'/%3e%3cpath d='M292.74 150.17c-1.843.172-4.69.327-6.47.686 1.041-1.788 2.421-4.7 3.273-6.489-.509 1.619-1.35 3.803-1.607 5.285 1.328.354 3.347.35 4.804.518'/%3e%3cpath d='M287.81 150.99c-.018-.034 4.39-3.8 4.39-3.8l-4.98 2.685-.504 1.122 1.094-.007'/%3e%3cpath d='M292.2 150.36c-1.837.387-4.687.878-6.442 1.442.858-1.876 1.937-4.896 2.604-6.751-.34 1.647-.955 3.888-1.054 5.373 1.375.19 3.407-.056 4.892-.064'/%3e%3cpath d='M287.08 151.19c-.03-.021 2.804-5.207 2.804-5.207l-3.795 4.502-.063 1.19 1.054-.485'/%3e%3cpath d='M292.2 150.66c-1.97.513-5.042 1.185-6.902 1.891.714-2.133 1.531-5.553 2.037-7.655-.172 1.855-.574 4.386-.502 6.048 1.534.152 3.737-.21 5.367-.284'/%3e%3cpath d='M286.53 152.39c-.03-.03 3.533-5.218 3.533-5.218l-4.518 4.217-.19 1.317 1.175-.316'/%3e%3cpath d='M291.42 151.25c-1.937.613-4.962 1.443-6.78 2.24.611-2.146 1.265-5.57 1.67-7.673-.085 1.842-.366 4.364-.217 6.003 1.533.067 3.708-.41 5.327-.57'/%3e%3cpath d='M285.82 153.16c-.034-.024 2.686-5.76 2.686-5.76l-3.819 4.96.017 1.325 1.116-.525'/%3e%3cpath d='M290.68 152.04c-1.985.452-5.072 1.032-6.954 1.679.803-2.09 1.764-5.45 2.359-7.513-.251 1.83-.76 4.32-.761 5.966 1.52.193 3.73-.105 5.356-.132'/%3e%3cpath d='M285.18 153.71c-.024-.035 4.388-4.508 4.388-4.508l-5.173 3.338-.421 1.266 1.206-.096'/%3e%3cpath d='M289.8 152.82c-1.966.264-5.017.548-6.894 1.02.913-2.047 2.058-5.37 2.765-7.412-.358 1.837-1.008 4.321-1.11 5.996 1.473.347 3.649.263 5.239.396'/%3e%3cpath d='M284.31 153.26c-.032-.027 2.986-5.64 2.986-5.64l-4.05 4.746-.063 1.344 1.127-.45'/%3e%3cpath d='M290.04 152.15c-2.138.876-5.478 2.096-7.481 3.175.657-2.538 1.35-6.56 1.779-9.03-.077 2.14-.367 5.086-.187 6.97 1.697-.053 4.1-.79 5.889-1.115'/%3e%3cpath d='M283.9 154.97c-.035-.03 3.574-6.473 3.574-6.473l-4.718 5.477-.13 1.53 1.274-.534'/%3e%3cpath d='M289.22 152.95c-2.095.985-5.374 2.377-7.326 3.555.543-2.538 1.055-6.539 1.374-8.998.019 2.114-.14 5.032.123 6.879 1.692-.15 4.057-1.014 5.829-1.436'/%3e%3cpath d='M283.17 155.95c-.04-.022 2.608-6.966 2.608-6.966l-3.903 6.221.099 1.509 1.196-.764'/%3e%3cpath d='M288.3 153.53c-2.09 1.001-5.363 2.42-7.308 3.613.527-2.54 1.014-6.543 1.317-9.003.032 2.112-.107 5.03.168 6.873 1.692-.164 4.052-1.047 5.823-1.483'/%3e%3cpath d='M282.58 156.78c-.032-.034 4.035-6.143 4.035-6.143l-5.087 5.028-.248 1.523 1.3-.408'/%3e%3cpath d='M288.11 153.21c-1.864 1.488-4.812 3.675-6.492 5.31-.003-2.565-.347-6.518-.554-8.949.468 2.013.932 4.84 1.584 6.534 1.642-.585 3.798-2.029 5.462-2.895'/%3e%3cpath d='M282.78 157.07c-.045-.006.467-7.361.467-7.361l-1.943 7.156.542 1.349.934-1.144'/%3e%3cpath d='M287.58 153.89c-1.869 1.478-4.825 3.65-6.512 5.276.008-2.566-.319-6.522-.516-8.955.459 2.016.911 4.846 1.557 6.545 1.643-.576 3.804-2.009 5.471-2.866'/%3e%3cpath d='M282.31 158.32c-.042-.018 1.88-7.193 1.88-7.193l-3.253 6.615.256 1.477 1.117-.899'/%3e%3cpath d='M287.37 154.06c-1.766 1.74-4.578 4.322-6.14 6.191-.276-2.631-1.054-6.648-1.528-9.119.698 2.012 1.48 4.86 2.335 6.523 1.634-.788 3.707-2.516 5.333-3.595'/%3e%3cpath d='M282.32 159.24c-.046-.007.352-7.65.352-7.65l-1.879 7.433.584 1.403.943-1.186'/%3e%3cpath d='M286.81 155.33c-1.89 1.563-4.884 3.862-6.582 5.576-.06-2.665-.5-6.77-.768-9.294.527 2.088 1.068 5.02 1.778 6.775 1.682-.623 3.874-2.142 5.572-3.057'/%3e%3cpath d='M281.76 160.11c-.04-.025 2.663-7.195 2.663-7.195l-3.993 6.375.104 1.58 1.226-.76'/%3e%3cpath d='M286.78 155.36c-1.673 1.77-4.337 4.396-5.815 6.296-.264-2.667-1.004-6.739-1.455-9.242.663 2.038 1.406 4.923 2.218 6.608 1.548-.805 3.511-2.563 5.052-3.662'/%3e%3cpath d='M281.86 160.48c-.047 0-.315-7.607-.315-7.607l-1.232 7.576.706 1.317.841-1.286'/%3e%3cpath d='M285.96 155.93c-1.619 1.786-4.201 4.437-5.622 6.351-.343-2.668-1.201-6.737-1.725-9.24.722 2.035 1.549 4.917 2.41 6.597 1.521-.818 3.43-2.595 4.937-3.708'/%3e%3cpath d='M281.43 161.24c-.043-.013.85-7.728.85-7.728l-2.266 7.31.451 1.5.965-1.082'/%3e%3cpath d='M285.61 156.23c-1.48 1.933-3.856 4.822-5.129 6.865-.544-2.62-1.71-6.585-2.423-9.023.876 1.954 1.92 4.74 2.906 6.327 1.457-.962 3.227-2.915 4.646-4.169'/%3e%3cpath d='M281.4 161.96c-.044-.002-.49-7.737-.49-7.737l-.974 7.676.701 1.352.763-1.291'/%3e%3cpath d='M285.46 156.67c-1.39 2.025-3.63 5.058-4.806 7.182-.68-2.61-2.051-6.54-2.89-8.959.978 1.921 2.167 4.672 3.238 6.218 1.416-1.045 3.096-3.104 4.458-4.441'/%3e%3cpath d='M281.88 162.68c-.043-.014.787-7.772.787-7.772l-2.215 7.305.467 1.53.961-1.063'/%3e%3cpath d='M285.18 157.39c-1.197 2.206-3.15 5.533-4.127 7.808-.91-2.5-2.626-6.217-3.677-8.504 1.144 1.774 2.573 4.343 3.776 5.731 1.312-1.235 2.796-3.517 4.028-5.035'/%3e%3cpath d='M281.61 163.32c-.043.012-2.172-7.37-2.172-7.37l.734 7.768.979 1.096.459-1.494'/%3e%3cpath d='M285.13 158.25c-1.248 2.2-3.28 5.517-4.301 7.785-.916-2.493-2.65-6.199-3.713-8.48 1.162 1.77 2.61 4.331 3.836 5.715 1.358-1.232 2.9-3.506 4.178-5.02'/%3e%3cpath d='M281.71 164.71c-.046 0-.797-7.75-.797-7.75l-.718 7.75.775 1.329.74-1.33'/%3e%3cpath d='M285.26 158.93c-1.283 2.17-3.369 5.439-4.426 7.683-.875-2.515-2.549-6.26-3.574-8.566 1.133 1.796 2.54 4.391 3.742 5.804 1.377-1.2 2.956-3.437 4.258-4.921'/%3e%3cpath d='M281.64 165.33c-.046.005-1.438-7.61-1.438-7.61l-.07 7.794.882 1.227.626-1.411'/%3e%3cpath d='M284.71 160.03c-1.384 2.078-3.622 5.198-4.784 7.366-.753-2.572-2.245-6.429-3.159-8.802 1.046 1.872 2.326 4.562 3.459 6.056 1.431-1.103 3.113-3.229 4.484-4.62'/%3e%3cpath d='M280.97 166.18c-.045-.012.644-7.779.644-7.779l-2.12 7.376.512 1.504.964-1.101'/%3e%3cpath d='M284.79 160.22c-1.183 2.25-3.118 5.651-4.073 7.96-.987-2.452-2.829-6.08-3.957-8.314 1.213 1.718 2.735 4.216 4 5.547 1.321-1.288 2.796-3.626 4.03-5.193'/%3e%3cpath d='M280.71 166.83c-.044.014-2.387-7.25-2.387-7.25l.919 7.71 1.028 1.049.44-1.509'/%3e%3cpath d='M284.47 160.8c-.826 2.47-2.22 6.234-2.812 8.712-1.34-2.194-3.7-5.357-5.146-7.305 1.452 1.423 3.327 3.545 4.772 4.576 1.107-1.554 2.207-4.174 3.186-5.983'/%3e%3cpath d='M282.83 167.42c-.044.016-2.585-7.15-2.585-7.15l1.13 7.668 1.056 1.007.399-1.525'/%3e%3cpath d='M284.45 161.56c-.808 2.478-2.175 6.257-2.749 8.74-1.357-2.179-3.738-5.317-5.199-7.25 1.463 1.408 3.352 3.51 4.805 4.526 1.096-1.566 2.177-4.197 3.143-6.016'/%3e%3cpath d='M282.85 168.64c-.042.022-3.326-6.687-3.326-6.687l1.937 7.425 1.156.835.233-1.573'/%3e%3cpath d='M284.2 162.18c-.517 2.573-1.438 6.515-1.722 9.06-1.596-1.967-4.32-4.737-5.991-6.443 1.613 1.186 3.73 2.999 5.287 3.798.907-1.71 1.677-4.473 2.426-6.415'/%3e%3cpath d='M283.07 169.69c-.045.009-1.793-7.498-1.793-7.498l.295 7.785.94 1.164.558-1.45'/%3e%3cpath d='M284.21 162.98c-.273 2.63-.82 6.678-.865 9.25-1.767-1.743-4.727-4.133-6.544-5.606 1.71.962 3.98 2.482 5.6 3.068.74-1.824 1.247-4.678 1.81-6.712'/%3e%3cpath d='M283.16 170.24c-.035.035-4.74-5.413-4.74-5.413l3.572 6.556 1.305.446-.137-1.589'/%3e%3cpath d='M284.31 163.9c-.284 2.628-.847 6.673-.902 9.243-1.76-1.752-4.71-4.159-6.521-5.642 1.706.973 3.969 2.505 5.587 3.1.747-1.82 1.266-4.67 1.836-6.701'/%3e%3cpath d='M283.69 171.49c-.041.024-3.641-6.525-3.641-6.525l2.287 7.324 1.195.782.159-1.58'/%3e%3cpath d='M284.52 164.98c-.173 2.644-.566 6.72-.513 9.293-1.83-1.644-4.875-3.87-6.745-5.244 1.744.869 4.066 2.263 5.706 2.76.67-1.864 1.068-4.745 1.552-6.809'/%3e%3cpath d='M284.15 172.69c-.037.032-4.499-5.704-4.499-5.704l3.28 6.77 1.286.528-.067-1.594'/%3e%3cpath d='M284.57 166.2c-.157 2.646-.525 6.726-.457 9.299-1.84-1.629-4.898-3.83-6.775-5.186 1.749.853 4.079 2.227 5.721 2.71.659-1.87 1.04-4.755 1.511-6.823'/%3e%3cpath d='M284.56 173.66c-.043.02-3.154-6.877-3.154-6.877l1.745 7.529 1.135.904.274-1.556'/%3e%3cpath d='M284.69 166.99c.09 2.655.105 6.766.412 9.317-1.977-1.373-5.215-3.152-7.205-4.25 1.815.615 4.255 1.669 5.929 1.928.48-1.95.589-4.873.864-6.995'/%3e%3cpath d='M285.11 173.39c-.027.043-5.762-3.945-5.762-3.945l4.885 5.383 1.357.07-.48-1.508'/%3e%3cpath d='M284.87 167.27c.23 2.643.459 6.74.9 9.27-2.052-1.293-5.387-2.944-7.437-3.962 1.85.543 4.347 1.501 6.038 1.696.378-1.962.334-4.879.499-7.004'/%3e%3cpath d='M285.73 174.86c-.035.034-4.8-5.518-4.8-5.518l3.635 6.625 1.314.48-.149-1.587'/%3e%3cpath d='M285.29 168.28c.34 2.632.742 6.719 1.288 9.226-2.098-1.172-5.492-2.623-7.577-3.519 1.866.433 4.395 1.242 6.087 1.335.294-1.987.128-4.904.202-7.042'/%3e%3cpath d='M286.69 175.79c-.027.043-5.718-4.04-5.718-4.04l4.823 5.461 1.358.094-.463-1.515'/%3e%3cpath d='M285.47 169.4c.512 2.6 1.183 6.652 1.891 9.109-2.161-.974-5.628-2.104-7.758-2.804 1.881.256 4.447.826 6.134.759.16-2.015-.199-4.918-.267-7.064'/%3e%3cpath d='M287.32 176.59c-.036.033-4.729-5.606-4.729-5.606l3.549 6.69 1.308.504-.128-1.588'/%3e%3cpath d='M285.78 170.12c.75 2.53 1.793 6.486 2.724 8.845-2.228-.683-5.762-1.348-7.933-1.762 1.884.004 4.474.23 6.136-.063-.031-2.034-.659-4.886-.927-7.02'/%3e%3cpath d='M287.57 176.6c-.01.052-6.606-1.415-6.606-1.415l6.282 3.123 1.27-.478-.946-1.23'/%3e%3cpath d='M286.21 170.91c.74 2.533 1.768 6.495 2.69 8.859-2.226-.696-5.758-1.381-7.928-1.807 1.884.015 4.474.255 6.137-.028-.023-2.034-.639-4.889-.899-7.024'/%3e%3cpath d='M288.65 177.3c-.02.047-6.32-3.053-6.32-3.053l5.668 4.596 1.359-.127-.707-1.416'/%3e%3cpath d='M285.88 171.35c1.255 2.308 3.09 5.948 4.487 8.05-2.315-.177-5.9-.047-8.105.027 1.84-.411 4.413-.762 5.974-1.415-.45-1.983-1.653-4.634-2.356-6.662'/%3e%3cpath d='M289.65 177.99c-.012.05-6.568-1.814-6.568-1.814l6.164 3.49 1.296-.395-.892-1.28'/%3e%3cpath d='M286.56 172.33c1.269 2.3 3.126 5.926 4.535 8.018-2.316-.157-5.897.002-8.1.096 1.836-.428 4.406-.8 5.96-1.467-.462-1.98-1.68-4.623-2.395-6.647'/%3e%3cpath d='M290.48 178.53c-.023.044-6.12-3.661-6.12-3.661l5.347 5.117 1.375.014-.602-1.47'/%3e%3cpath d='M287.07 172.91c1.47 2.146 3.646 5.55 5.232 7.47-2.289.143-5.791.77-7.945 1.15 1.76-.668 4.249-1.378 5.712-2.25-.647-1.931-2.1-4.429-2.999-6.37'/%3e%3cpath d='M290.93 179.07c-.002.054-6.607-.156-6.607-.156l6.537 1.932 1.162-.722-1.092-1.054m3.83-32.01c0-.02 4.753-.793 4.753-.793l-4.729.11-.825.424.801.259'/%3e%3cpath d='M297.37 148.07c-1.38-.417-3.463-1.115-4.879-1.423 1.505-.597 3.731-1.658 5.101-2.309-1.054.66-2.587 1.508-3.404 2.17.79.536 2.222 1.082 3.182 1.562'/%3e%3cpath d='M294.55 147.22c-.005-.02 4.599-1.263 4.599-1.263l-4.765.607-.718.493.884.163'/%3e%3cpath d='M297.59 148.41c-1.611-.152-4.083-.46-5.673-.477 1.198-1.06 2.878-2.835 3.912-3.925-.711 1.024-1.805 2.383-2.276 3.351 1.08.434 2.815.724 4.037 1.05'/%3e%3cpath d='M292.84 147.55c.004-.02 4.78-.54 4.78-.54l-4.658-.149-.87.383.748.306'/%3e%3cpath d='M296.38 148.59c-1.465-.28-3.692-.768-5.174-.942 1.408-.691 3.46-1.88 4.724-2.61-.943.712-2.335 1.642-3.039 2.336.892.443 2.435.842 3.489 1.216'/%3e%3cpath d='M292.43 147.5c-.012-.018 4.207-1.81 4.207-1.81l-4.608 1.216-.552.56.953.034'/%3e%3cpath d='M296.24 149.12c-1.22-.504-3.088-1.357-4.294-1.712.934-.869 2.25-2.392 3.061-3.326-.564.934-1.425 2.14-1.806 3.066.81.69 2.119 1.366 3.039 1.972'/%3e%3cpath d='M292.67 147.81c-.009-.028 3.273-1.418 3.273-1.418l-3.564.488-.439.635.73.295m-2.74 30.65c.003.052-6.783.051-6.783.051l6.868 1.68 1.127-.739-1.212-.992'/%3e%3cpath d='M291.15 178.9c-.008.05-6.89-1.602-6.89-1.602l6.616 3.243 1.297-.417-1.023-1.224'/%3e%3cpath d='M292.28 179.36c0 .052-6.84-.345-6.84-.345l6.84 2.062 1.172-.665-1.172-1.052'/%3e%3cpath d='M287.94 174.53c1.78 1.961 4.445 5.086 6.312 6.815-2.297.347-5.757 1.276-7.886 1.843 1.692-.813 4.114-1.73 5.476-2.714-.918-1.825-2.728-4.131-3.902-5.944'/%3e%3cpath d='M293.22 179.71c-.013.048-6.837-2.237-6.837-2.237l6.425 3.82 1.346-.284-.934-1.3'/%3e%3cpath d='M288.57 174.98c1.94 1.769 4.864 4.608 6.865 6.13-2.202.635-5.474 2.001-7.488 2.837 1.562-1.031 3.825-2.258 5.048-3.423-1.086-1.737-3.09-3.851-4.425-5.544'/%3e%3cpath d='M293.78 180.13c.01.053-6.487 1.276-6.487 1.276l6.836.466.965-.953-1.314-.789'/%3e%3cpath d='M292.43 179.72c.007.052-6.767.52-6.767.52l6.982 1.199 1.07-.814-1.285-.905'/%3e%3cpath d='M293.68 180.08c-.005.05-6.997-1.122-6.997-1.122l6.847 2.776 1.263-.505-1.113-1.149z'/%3e%3cpath d='M294.84 180.46c.004.052-6.853.128-6.853.128l6.982 1.583 1.12-.743-1.249-.968z'/%3e%3cpath d='M290.14 175.94c1.923 1.832 4.819 4.763 6.812 6.357-2.267.505-5.65 1.67-7.732 2.38 1.627-.926 3.975-2.007 5.26-3.082-1.052-1.756-3.032-3.93-4.34-5.655z'/%3e%3cpath d='M295.81 180.74c-.009.049-6.992-1.758-6.992-1.758l6.7 3.364 1.321-.376-1.029-1.23z'/%3e%3cpath d='M290.81 176.34c2.068 1.63 5.201 4.257 7.312 5.637-2.15.784-5.314 2.371-7.26 3.343 1.481-1.135 3.647-2.514 4.78-3.76-1.213-1.656-3.373-3.625-4.832-5.22z'/%3e%3cpath d='M296.4 181.12c.015.052-6.38 1.72-6.38 1.72l6.859-.008.891-1.016-1.37-.696z'/%3e%3c/g%3e%3cpath fill='%23fedf00' stroke='%23000' stroke-width='.299' d='m305.21 171.52-5.211-3.602-5.212 3.602 1.955-5.762-4.56-3.602h5.862l1.955-5.762 1.954 5.762h5.862l-4.56 3.602 1.955 5.762z'/%3e%3c/svg%3e";
            },
            3913: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1400 550'%3e%3cpath fill='%238d1b3d' d='M0 0h1400v550H0z'/%3e%3cpath fill='%23fff' d='M400 550H0V0h400l100 30.556L400 61.11l100 30.556-100 30.555 100 30.556-100 30.555 100 30.556-100 30.555L500 275l-100 30.556 100 30.555-100 30.556 100 30.555-100 30.556 100 30.555-100 30.556 100 30.555z'/%3e%3c/svg%3e";
            },
            3915: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3cpath fill='%23ED2939' d='M0 0h900v600H0z'/%3e%3cpath fill='%23fff' d='M0 0h600v600H0z'/%3e%3cpath fill='%23002395' d='M0 0h300v600H0z'/%3e%3c/svg%3e";
            },
            3886: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 2'%3e%3cpath fill='%23002B7F' d='M0 0h1v2H0z'/%3e%3cpath fill='%23FCD116' d='M1 0h1v2H1z'/%3e%3cpath fill='%23CE1126' d='M2 0h1v2H2z'/%3e%3c/svg%3e";
            },
            7357: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1350 900'%3e%3cpath fill='%23fff' d='M0 0h1350v900H0z'/%3e%3cpath fill='%230c4076' d='M0 0h1350v600H0z'/%3e%3cpath fill='%23c6363c' d='M0 0h1350v300H0z'/%3e%3cg transform='matrix(1 0 0 1.00437 0 -.33)'%3e%3cpath fill='%2321231e' d='M473.38 259.35zm1.01.03zm-93.13 5.25c-2.31-.26 3.48-.78 4.86-.75 29.24-1.82 58.48-3.65 87.74-5.02 0 2.15-3.95.67-5.64 1.28a6448 6448 0 0 0-87.42 5.1l.24-.33.22-.28zm-1 .2zm6.54 31.06-6.53-31.05c2.25-.16 1.38 4.47 2.35 6.27l5.17 24.57c-.4.52-.44.87-.99.21zm.51.4zm94.85-4.08c.04 2.3-4.1.53-5.78 1.2-29.7.92-59.38 2.04-89.07 2.88.2-2.23 4.52-.57 6.42-1.2 29.48-.88 58.95-1.99 88.43-2.88zm-.03 0zm94.37 3.47c2.17 1.02-3.86.39-5.14.45-29.75-.88-59.49-2-89.23-2.9.26-2.2 4.35-.33 6.22-.83 29.55.93 59.1 2.03 88.65 2.87l-.32.26-.18.15zm.98.21zm6.54-31.05-6.54 31.05c-2.11-.77.54-4.65.38-6.7l5.17-24.56c.52-.61.64-.33.99.2zm-.46-.62zm-93.66-4.84c.85-.7 3.25-.4 5.62-.28 29.36 1.44 58.7 3.27 88.04 5.12-.34 2.2-4.38.2-6.28.63-28.96-1.81-57.92-3.62-86.9-4.97l-.29-.3-.2-.2zm.48.5zm.52-.7zm-1 .03zm-7.78.33c-.26-2.1 3.14-.64 4.55-1.14 1.47.3 4.04-.8 4.73.78-1.25 1.64-1.02-2.07-.7.28-2.85-.18-5.72.03-8.58.08zm.04 0zm-8.27.16c1.01-.99-2.16.39-.12-1.29 2.8-.11 5.6.04 8.4.12.09 2.04-3.19.47-4.64.88-1.05-.12-3.4.15-3.78-.06-.19-1.12.33-1.12.14.35zm0-1.02zm-.5.5z'/%3e%3cpath fill='%2321231e' d='M595.05 245.94c.04-1.75-1.12 2.5-2.62 3.5-3.3 4.72-5.97 9.85-8.53 15-1.91-1 1.3-3.69 1.6-5.38 2.56-4.86 5.38-9.6 8.86-13.85l.69.73zm-19.26-3.89c1.12-2.16.75 3.65 1.7 4.68 1 4.16 6 4.87 9.3 3a38.01 38.01 0 0 0 7.66-4.61c1.1 2-3.51 3.1-4.96 4.43-3.69 2.33-9.93 3.71-12.32-1.08-1.14-2.1-1.52-4.5-1.71-6.86l.27.36.06.08zm.34-.96zm-2.32.51c-1.86-1.07 1.12-.83 2-.6.85.63-.33 1.29-1.08.86-.29-.1-2.06.15-.92-.26zm-.85-.55zm-25.3-5.27c-1.12-1.84 2.27 3.42 2.86 4.86 2.78 4.64 7.31 10.9 13.54 8.97 3.98-1.52 6.62-5.14 8.9-8.56 1.75 1.36-2 3.86-2.86 5.44-3.19 4.15-9.57 6.3-13.89 2.54-4.38-3.38-7.04-8.43-9.44-13.3l.46.03.42.02zm-.86-.54zm-28.4-.53c-1-1.98 2.04 3.38 2.51 4.73 2.43 4.83 7.24 10.87 13.37 8.53 5.68-2.37 9.24-7.8 12.52-12.73 1.74 1.46-2.18 4.15-2.94 5.96-3.59 4.7-9.6 10.43-15.96 7.49-5.4-2.82-8.05-8.78-10.37-14.1l.45.06.42.06zm-.8-.63zm-33.75.67c2.09-.5 2.52 3.57 4.36 4.98 3.49 5.15 10.38 8.69 16.37 5.64 5.34-2.4 9.4-6.84 13.03-11.3 1.56 1.65-2.62 3.88-3.57 5.6-4.93 5.29-12.95 10.37-20.16 6.41-4.51-2.44-7.7-6.89-10.03-11.33zm.06.25zm.95-2.34zm-1.01 0zm-.98.37c1.2-.5.16-.85 1.53-.66-.68.75.1 1.27.16-.17 1.74 1.2-1.12 1.57-1.69.83zm.38.27zm.33-1.12zm-.55-.27zm-.98 1.2c-.16-1.12.06-1.04.98-1.2.75 1.28-.24 1.05-.98 1.2zm.19 0zm-.63-.46c-2.47-.76 1.96-1.22.41.45-.36-.13-1.64-.1-.4-.45zm-.9-.47zm-.2.38zm.9.47zm-.97-.37c-2.17-.42.62 1.35-.52-.28.93-.54 1.75 1.18.35 1-1.6.4-1.1-2.14.17-.72zm-.71-.46zm-.3 2.55zm1.01 0zm-33.68-.16c-1.53-1.62 2.78 2.5 3.58 3.72 4.7 5.08 12.08 10.54 19.23 7.07 4.5-2.28 7.5-6.6 9.92-10.88 1.85 1.34-1.92 4.19-2.68 5.95-3.75 5.45-11.1 9.06-17.45 5.87-5.52-2.43-9.72-7-13.47-11.6l.46-.07.4-.06zm-.94-.39zm-28.3 1.53c-1.39-1.7 2.5 2.8 3.15 4.14 3.45 4.45 8.65 10.35 14.93 8.07 5.4-2.6 7.94-8.55 10.22-13.74 1.94 1.2-1.47 4.57-1.98 6.52-2.58 5.02-7.96 10.66-14.13 8.23-5.93-2.42-9.68-8.03-13.07-13.17l.45-.03.43-.02zm-.91-.44zm-25.7 6.54c.26-2.42 2.48 3.01 3.72 3.65 2.9 3.87 8.79 6.35 12.88 2.7 4.23-3.28 6.77-8.18 9.1-12.9 1.9 1.3-1.74 4.5-2.3 6.45-2.95 4.87-7.98 10.97-14.4 8.85-4.21-1.58-7.03-5.36-9.43-8.98l.4.22.03.01zm0-1.02zm-2.08.8c-2.21-.32.87-1 1.81-.8 1.1.98-.44 1.15-1.3 1.07-.36-.06-1.38.52-.5-.27zm-1-.08zm-17.9 3.68c-1.67-.03 3.14 1.52 4.4 2.92 3.42 2.18 9.45 4.5 11.91-.16 1.06-1.97 1.4-4.23 1.58-6.44 2.2.33.06 4.34-.24 5.98-1.44 4.64-7.2 5.12-10.88 2.98a40.12 40.12 0 0 1-7.46-4.55l.7-.73zm10.89 18.5c-.18 2.44-1.9-2.65-2.61-3.57-2.6-5-5.48-9.9-9.06-14.29 1.68-1.37 2.77 2.7 4.05 3.75 3.1 4.56 5.65 9.45 8.1 14.38l-.4-.23-.08-.05zm.04 1.01zm101.31-5.97c-.19 2.39-4.82.6-6.78 1.37-31.5 1.66-63.01 3.28-94.53 4.6.36-2.32 5.1-.6 7.21-1.33 31.38-1.35 62.74-3 94.1-4.64zm-.05 0zm101.33 4.95c-.22 2.39-4.9.13-6.83.73-31.5-1.36-63-3-94.5-4.67.56-2.27 5.12-.12 7.28-.63 31.33 1.64 62.78 3.27 94.05 4.57zm0 1.02zm0 0zm.45-.28z'/%3e%3cpath fill='%23edb92e' d='M583.45 264.21c3.27-6.6 6.7-13.07 11.3-18.68-11.75 8.74-17.93 7.42-18.8-3.96-.69-.25-1.63-.25-2.57-.25-8.96 13.98-17.68 12.04-26.16-5.81-11.54 18.35-21.44 18.02-29.22-1.12-13.31 16.73-24.53 16.77-33.65.36v-2.09c.51.23.16.3-1.03.13l-.2-.38-.98.2-.98-.2-.2.38c-1.19.17-1.53.1-1.03-.13v2.09c-9.12 16.41-20.33 16.37-33.64-.36-7.78 19.14-17.69 19.47-29.23 1.12-8.47 17.85-17.2 19.79-26.15 5.81-.95 0-1.89 0-2.58.25-.86 11.38-7.04 12.7-18.79 3.96 4.59 5.6 8.02 12.08 11.3 18.68 33.84-1.41 67.58-3.18 101.3-4.96 33.73 1.78 67.46 3.55 101.32 4.96z'/%3e%3cpath fill='%23EDB92E' d='m504.88 276.18-22.74 11.45-22.74-11.45 22.74-11.46z'/%3e%3cpath fill='%23edb92e' d='M473.89 259.19v.18c-17.5.78-48.48 2.52-93.13 5.36l6.54 31.05c29.65-.83 64.25-2.14 94.84-3.06 30.59.92 65.2 2.23 94.85 3.06l6.53-31.05c-44.64-2.86-75.63-4.6-93.12-5.38v-.18c1.76-.34-.98-.4-8.26-.15-7.27-.25-10.01-.2-8.25.16z'/%3e%3cpath fill='%23edb92e' d='m597.33 236.74-3.68-.62c-7.08 17.4-13.42 17.81-14.61 1.27 1.58-.57.95-3.33 2.74-2.23.94.58 2.14-1.07 1.36-1.98-2-1.48-3.79-1.25-5.54.4-.83-2.64-2.85-3.87-5.38-2.76-1.09.48-.71 2.46.38 2.35 1.77-.19 1.06 1.66 1.6 2.9-12.54 16.48-18.95 14.52-17.4-7.12-2.98-.62-6.46-1.24-9.57-2.36-11.55 23.35-19.76 24.35-26.42 3.4 1.43-1.06 1.02-3.75 3.1-2.89 1.18.49 2.16-1.6 1.12-2.49-2.44-2.06-5.08-1.36-6.84 1.29-1.42-2.85-3.95-3.88-6.62-2.15-1.16.75-.44 2.94.78 2.61 2.36-.64 1.3 2.47 3.08 3.54-5.1 19.7-30.87 21.02-26.65-8.13l-6.63.24-6.63-.24c4.22 29.15-21.55 27.83-26.65 8.13 1.78-1.07.72-4.17 3.07-3.54 1.23.33 1.95-1.86.8-2.61-2.68-1.73-5.2-.7-6.63 2.15-1.77-2.65-4.4-3.35-6.84-1.29-1.05.9-.06 2.98 1.11 2.5 2.09-.87 1.68 1.82 3.1 2.88-6.65 20.95-14.86 19.95-26.41-3.4-3.11 1.12-6.59 1.74-9.58 2.36 1.56 21.64-4.85 23.6-17.4 7.12.55-1.24-.16-3.09 1.61-2.9 1.1.11 1.47-1.87.38-2.35-2.53-1.11-4.55.12-5.38 2.76-1.75-1.65-3.53-1.88-5.54-.4-.78.91.42 2.56 1.36 1.98 1.79-1.1 1.16 1.66 2.74 2.23-1.19 16.54-7.53 16.12-14.6-1.27l-3.69.62a18.6 18.6 0 0 0 3.8 11.63c10.62 13.55 18.5 10.48 18.8-4.7 13.89 16.4 24.39 14.32 26.27-2.97 11.69 21.8 30.44 11.37 30.82-1.86 5.15 19.23 33.67 19.1 35.5-3 1.82 22.1 30.33 22.23 35.48 3 .39 13.23 19.14 23.67 30.82 1.86 1.89 17.29 12.39 19.36 26.28 2.97.29 15.18 8.18 18.25 18.79 4.7a18.6 18.6 0 0 0 3.8-11.63z'/%3e%3cpath fill='%2321231e' d='M593.72 235.62c4.42.05 4.1 2.48-.17 1-.24-.55-.74-.76.17-1zm-.55.3zm-14.31 1c1.16.8.75 3.84 1.44 6.24.45 2.4 1.82 7.19 5.1 5.32 3.95-3.12 5.78-8.08 7.77-12.55 1.99 1.06-1.31 4.29-1.7 6.15-1.9 3.11-4.05 8.36-8.46 7.76-4.07-2.5-3.89-8.18-4.49-12.41l.26-.4.08-.12zm-.34.51zm3.52-2.7c-.24 1.18-1.38.21-1.46 1.61-.08 1.42-2.4 1.82-1.4.37.75-1 1.07-3.23 2.86-1.98zm.79-1.13c1.4-2.17 1.4 2.38-.44 2.18-1.69-.01-.03-1 .42-1.6.2-.13-.11-.81.02-.58zm.6-.82zm-6.32.96c.83-.13.38-1.67 2.72-1.98 1.17-.28 4.43.43 3 1.84a3.44 3.44 0 0 0-4.9.36l-.45-.12-.37-.1zm.82.22zm-5.51-2.67c-1.1-1.94 3-1.63 3.93-.56 1.47.51 2.07 4.24.51 2.36a3.14 3.14 0 0 0-4.44-1.8zm.12 1.37c.49 2.56-2.62-.54-1.22-1.7.92-1.27 1.1.4.76 1.17.04.23.19.56.46.53zm2.06 3.72c-1.14-.33-1.04-.34-1.21-2 .08-.9-1.57-.9-.66-1.73 2.01-.12 1.69 2.45 1.87 3.73zm.06-.52zm-17.96-6.41c1.04-2.15.2 4.21.38 5.54.26 3.8-.25 8.93 3.3 11.34 4.48.55 7.56-3.98 10.38-6.8.87-1.8 5.23-5.6 2.7-1.67-3.5 3.86-7.04 9.44-12.76 9.6-4.65-1.61-4.34-7.7-4.63-11.77.2-1.36-.4-7.1.63-6.24zm.2-1zm-9.23-1.63c-1.97-1.45 2.82.35 3.89.5 1.58.68 4.56.36 5.25 1.59-.87 1.12-3.6-.53-5.17-.53-.76-.32-5.49-1.02-3.97-1.56zm-.9-.45zm-26.27 3.22c1.44.48 1.68 3.74 2.87 5.95 1.74 3.83 4.34 9.74 9.49 8.7 6.47-2.86 9.49-9.96 12.84-15.76 2.04-4.36 1.87.24.02 2.13-3.32 5.54-6.48 12.54-13.05 14.71-5.87.77-8.68-5.8-10.6-10.25-.46-1.75-1.84-3.7-1.57-5.48zm-.18.56zm3.78-3.51c-.29 1.1-1.9.73-1.97 2.4-.27 1.77-2.37 1.05-1.05-.17.53-1.28 1.24-3.13 3.02-2.23zm.59-1.63c1.53-2.09 1.8 2.68-.15 2.65-1.6.08-.14-1.02.33-1.57.13-.36.13-.83-.18-1.08zm-6.96 1.12c.6-.24.55-2.36 3.02-3 1.38-.6 4.46.09 4.3 1.46-.86.72-2.4-1.39-3.79-.55-1.59.12-2.08 2.4-3.53 2.09zm.87.06zm-6.77-2.01c-1.52-1.63 2.34-2.02 3.43-1.63 1.34.33 4.3 2.69 2.54 3.54-1.05-2.17-3.71-3.65-5.97-1.91zm.38 1.7c.9 2.26-2.41.23-1.73-1.17-.13-1.63 1.9-1.3 1.03-.06-.11.44.1 1.32.7 1.22zm3.7 4.15c-1.1.41-1.67-.25-2.2-2.08.09-1.47-1.63-.8-1.5-2.08 2.76-.77 2.23 2.96 3.7 4.16zm-.23-.56zm-26.9-7.19c.7-2.22-.03 4.13.05 5.55-.31 6.6 2.68 15.25 10.3 15.85 7.94.48 14.1-6.72 15.8-13.9 2.11.97-1.03 4.8-1.7 6.62-3.66 6.67-13.23 11.3-19.88 6.07-5.97-4.98-6.04-13.68-5.08-20.77l.31.35.2.23zm-.03-1.02zm-6.63 1.26c-.43-1.97 2.46-.7 3.64-1.15 1.07-.15 4.2-.27 2.59.93l-6.23.22zm.04 0zm-6.15-.82c-2.37-.09 1.54-.68 2.5-.33 1.2.38 4.01-.73 3.61 1.14l-6.63-.23.31-.35.2-.23zm-1 .15zm-26.41 7.62c1.33.6 1.58 3.93 3.11 6.05 3.3 6.35 12.3 11.09 18.63 6.12 5.62-4.8 5.55-13.06 4.67-19.8 2.31.09 1.02 4.89 1.44 6.9.14 6.85-3.4 15.38-11.17 15.95-8.45.58-15.1-7-16.91-14.66l.18-.43.05-.13zm-.23.56zm3.7-4.16c.17 1.35-1.61.57-1.5 2.09.07 1.23-1.98 3.35-1.74 1.34 1.12-1.2.7-4.22 3.24-3.43zm.38-1.69c1.26-2.27 2.13 2.44.18 2.65-1.58.29-.26-.99.13-1.6.1-.37.03-.83-.31-1.05zm-6.77 2c.56-.31.26-2.4 2.62-3.36 1.3-.78 4.44-.48 4.44.9-.75.82-2.55-1.07-3.82-.06-1.56.32-1.76 2.64-3.24 2.53zm.88-.05zm-6.97-1.12c-1.6-1.49 2.21-2.4 3.44-2.02 1.3.27 4.47 2.2 2.65 3.2-1.2-2.21-4.2-3.11-6.09-1.18zm.6 1.63c1.17 2.13-2.38.54-1.87-.94-.34-1.6 1.72-1.52 1.01-.2-.05.47.27 1.31.85 1.14zm3.77 3.51c-1.13.24-1.4-.16-2.13-1.85-.07-1.27-2.18-.53-1.43-1.75 2.28-.77 2.52 2.4 3.56 3.6zm-.18-.56zm-26.55-2.51c-.2-2.4 2.31 3.55 3.08 4.61 3.03 4.84 5.95 11.05 11.86 12.71 5.32 0 7.46-6.07 9.27-10.16.19-2.16 3.16-6.73 1.89-2.18-2.03 5.04-4 11.98-10 13.35-6.13-.03-9.5-6.36-12.52-10.84a110.81 110.81 0 0 1-4.2-7.75l.43.18.19.08zm-.34-.96zm-8.9 2.8c-2.45-.26 2.49-1.12 3.52-1.32 1.8-.07 4.29-1.7 5.54-1.04-.23 1.47-3.55 1.31-5.02 1.96-.8-.04-5.12 1.57-4.05.4zm-1.01.07zm-17.36 6.87c1.62-.26 2.72 2.83 4.52 4.37 2.65 2.61 5.6 6.69 9.75 6.1 3.68-2.52 3.04-7.87 3.32-11.81-.23-1.58-.3-8.21.86-4.21.03 5.39.96 11.72-2.62 16.22-3.99 2.9-8.26-1.74-10.95-4.4-1.64-1.99-3.9-3.93-4.88-6.27zm.06.52zm2.06-3.72c.06 1.11-1.3 1.28-.96 2.75-.02 1.54-1.66.42-.94-.65-.01-1.14.54-2.34 1.9-2.1zm.12-1.37c.8-2.42 2.3 1.77.52 2.24-1.54.47-.16-1.02-.18-1.75-.02-.2-.14-.4-.34-.49zm-5.51 2.67c.52-.5-.3-2.05 1.76-3.37 1-.94 4.8-1.15 3.75.7-1.95-1.12-4.29.38-4.69 2.45l-.45.12-.37.1zm.82-.22zm-5.64-.22c-1.87-1.15 1.86-2.1 2.92-1.76 1.26-.07 3.59 2.13 1.59 1.92-1.24-1.35-3.53-1.08-4.5-.16zm-.76-.67zm1.47 1.88c1.44 2.19-2.71.5-1.81-1.18.56-1.47 1.03.3 1.25 1 .14.14.36.3.56.18zm3.52 2.7c-1.02.43-1.4.35-2.17-1.34-.02-1.12-1.7-.37-1.16-1.47 2.09-1.07 2 2.07 3.33 2.81zm-.34-.52zm-14.7-.28c.13-2.42 1.95 3.46 2.76 4.55 1.76 2.89 3.35 7.2 7.1 7.79 3.7-1.84 3.45-7.02 4.08-10.6 1.43-3.12.96 2.89.46 4.23-.49 3.05-2.05 8.63-6.19 7.07-4.65-2.96-6.56-8.56-8.75-13.35l.4.23.15.08zm-.16-1.01zm-3.68.62c4.2-1.4 4.67 1 .16 1-.45-.44-.9-.47-.16-1zm-.43.49zm4.71 11.33c-1.96 1.27-2.9-3.48-3.76-5.01-.27-1.81-2.18-6.03.06-6.3a18.02 18.02 0 0 0 3.7 11.3zm18.78-4.72c-.58.1.6 3.23-.34 5.53-.42 4.37-3.71 10.06-8.86 8.35-4.4-1.4-7.55-5.07-10.37-8.53 1.93-1.14 3.27 3.4 5.27 4.26 2.7 2.84 8.33 5.52 10.99 1.2 1.98-3.1 2.29-6.9 2.42-10.49l.89-.32zm-.9.32zm27.24-3.2c-.74-.13.33 3.14-.83 5.27-.93 5.16-5.2 10.9-11.09 9.5-6.34-1.5-11.03-6.52-15.2-11.23 1.97-1.15 3.55 3.44 5.58 4.4 3.94 3.59 9.95 8.12 15.32 4.74 3.75-2.96 4.7-8.01 5.27-12.5l.95-.18zm-.95.18zm31.81-1.93c-.85-.53.5 3.54-1.16 5.52-2.98 8.15-13.67 12.4-21.1 7.44-4.2-2.47-7.2-6.51-9.5-10.73 2.13-.8 2.7 3.93 4.6 5.1 4.3 5.96 13.16 9.1 19.55 4.53a14.87 14.87 0 0 0 6.62-11.74l.99-.12zm35.5-2.91c-.9-.78.37 3.46-1.06 5.4-2.7 9.73-14.41 14.68-23.54 10.98a19.15 19.15 0 0 1-11.88-13.2c2.23-.26 1.9 4.47 3.83 5.86 6.2 9.32 21.7 10.25 28.23.83a19.81 19.81 0 0 0 3.42-9.87h1zm35.5 3.03c-.76-.72-.25 3.5-2.1 5.17-5.62 10.4-21.74 12.76-29.63 3.7-2.93-3.23-4.42-7.53-4.77-11.82 2.22.1.96 4.6 2.5 6.3 3.53 9.7 16.5 12.99 24.86 7.54a18.16 18.16 0 0 0 8.14-11l1 .1zm30.81 1.81c-.55-.32-1.23 3.58-3.2 5.2-4.32 6.41-13.33 10.45-20.5 6.22a15.88 15.88 0 0 1-8.13-13.2c2.14.17.9 4.48 2.61 6.06 3.35 7.35 13.47 10.37 20.02 5.35 3.58-2.45 6.2-6.04 8.25-9.81l.95.18zm-.95-.18zm27.23 3.2c-.5-.29-1.64 2.9-3.69 4.22-4.35 4.22-10.72 9.59-17.12 6.59-4.66-2.82-5.84-8.7-6.47-13.71 2.2-.03 1 4.31 2.23 6 1.02 4.62 5.47 9.12 10.49 7.24 5.64-1.83 9.86-6.33 13.67-10.66l.9.32zm-.89-.32zm18.78 4.72c1.6 1.56-2.43 3.74-3.44 5.3-3.06 3.27-9.2 6.32-12.56 1.8-2.39-3.3-2.76-7.53-2.9-11.48 2.24.25.6 4.66 1.79 6.54.48 3.72 4 7.8 8 5.77 3.78-1.58 6.59-4.83 9.1-7.93zm4.2-10.8c.7-2.34.53 3.82-.2 5.02-.75 2.03-1.77 5.65-3.57 6.12-.34-1.59 2.34-3.87 2.48-6.03.87-1.04.33-6.15 1.3-5.12zm0-1.03zm0 0zm0 1.02z'/%3e%3cpath fill='%23edb92e' d='M482.14 262.87c-33.98 0-67.97 1.7-101.77 5.22-7.83-.17-1.9-8.29 3.26-6.3a987.52 987.52 0 0 1 201.3.5c7.56 3.1-1.56 8.07-5.92 5.3a984.52 984.52 0 0 0-96.87-4.72z'/%3e%3cpath fill='%230c4076' d='M482.14 105.07c9.48 0 17.17 7.74 17.17 17.3 0 9.55-7.69 17.3-17.17 17.3a17.23 17.23 0 0 1-17.17-17.3c0-9.56 7.69-17.3 17.17-17.3z'/%3e%3cpath fill='%23edb92e' d='M485.26 84.9a3.12 3.12 0 0 0 3.03-3.14c0-1.7-1.35-3.09-3.03-3.13a3.124 3.124 0 0 0-3.12-3.12c-1.7 0-3.1 1.4-3.1 3.12a3.12 3.12 0 0 0-3.04 3.13c0 1.7 1.35 3.09 3.03 3.13v6.43h-5.5c0-1.72-1.39-3.12-3.1-3.12a3.13 3.13 0 0 0-3.11 3.06c-1.71 0-3.1 1.4-3.1 3.13a3.12 3.12 0 0 0 3.1 3.13 3.12 3.12 0 0 0 3.1 3.06 3.12 3.12 0 0 0 3.12-2.98h5.49v21.37h6.23V97.6h5.5a3.12 3.12 0 0 0 3.1 2.98c1.7 0 3.07-1.36 3.11-3.06 1.71 0 3.1-1.4 3.1-3.13a3.12 3.12 0 0 0-3.1-3.13 3.12 3.12 0 0 0-3.1-3.06c-1.72 0-3.1 1.4-3.12 3.12h-5.49v-6.43z'/%3e%3cpath fill='%2321231e' d='M487.78 81.76c.78-.16 1.27.07.9.9a3.64 3.64 0 0 1-3.4 2.74c-.06-.6-.16-1.17.6-1.11a2.63 2.63 0 0 0 1.9-2.53zm-3.03-3.13c.95.14.97-.12.63-.5a3.65 3.65 0 0 1 3.41 3.63c-.62.05-1.17.12-1.09-.64a2.63 2.63 0 0 0-2.46-1.98l-.5-.51zm.5.5zm-3.1-3.11c-.16-.78.06-1.28.9-.9a3.66 3.66 0 0 1 2.71 3.5c-.62.06-1.17.12-1.1-.64a2.62 2.62 0 0 0-2.52-1.96zm-3.1 3.12c.12-.95-.14-.98-.52-.63a3.65 3.65 0 0 1 3.61-3.51c.05.62.12 1.18-.65 1.1a2.63 2.63 0 0 0-1.95 2.53l-.5.5zm.49-.51zm-3.03 3.13c-.79.16-1.27-.07-.9-.9a3.64 3.64 0 0 1 3.41-2.74c.06.61.15 1.18-.6 1.11a2.63 2.63 0 0 0-1.91 2.53zm3.03 3.13c-.95-.14-.97.12-.64.5a3.65 3.65 0 0 1-3.4-3.63c.62-.04 1.17-.11 1.09.65a2.63 2.63 0 0 0 2.45 1.98l.5.5zm-.5-.5zm-.52 6.93v-6.43c.98-.25 1.17.28 1.02 1.16v5.27c-.5.58-.51.6-1.02 0zm1.02 0zm-6-.51h5.49c.25.98-.27 1.17-1.16 1.02h-4.33c-.58-.5-.59-.52 0-1.02zm0 1.02zm-3.11-3.12c-.16-.78.07-1.28.9-.9a3.66 3.66 0 0 1 2.72 3.5c-.63.06-1.18.12-1.1-.64a2.62 2.62 0 0 0-2.52-1.96zm-3.11 3.06c.14-.95-.12-.98-.5-.64a3.65 3.65 0 0 1 3.6-3.44c.05.62.13 1.18-.63 1.1a2.64 2.64 0 0 0-1.97 2.48l-.5.5zm.5-.5zm-3.09 3.12c-.8.16-1.27-.08-.9-.9a3.64 3.64 0 0 1 3.49-2.74c.04.62.12 1.18-.65 1.1a2.63 2.63 0 0 0-1.94 2.54zm3.1 3.12c-.96-.12-.97.14-.63.52a3.65 3.65 0 0 1-3.48-3.64c.63-.05 1.17-.1 1.1.66a2.62 2.62 0 0 0 2.5 1.96l.5.5zm-.5-.5zm3.1 3.06c.15.78-.07 1.28-.9.9a3.65 3.65 0 0 1-2.72-3.43c.62-.06 1.17-.15 1.11.61a2.62 2.62 0 0 0 2.5 1.92zm3.1-2.98c-.14.93.12.98.5.65a3.65 3.65 0 0 1-3.6 3.35c-.04-.61-.13-1.18.63-1.1a2.64 2.64 0 0 0 1.97-2.42l.5-.48zm-.5.48zm6 .54h-5.5c-.25-.98.28-1.18 1.16-1.02h4.34c.58.5.59.51 0 1.02zm0-1.02zm-.5 21.88V97.6c.97-.26 1.16.28 1 1.15v20.22c-.49.58-.5.6-1 0zm.5.5zm6.23 0h-6.23c-.25-.97.27-1.17 1.15-1.01h5.08c.58.5.59.52 0 1.02zm.5-.5zm0-21.37v21.37c-.97.25-1.16-.28-1-1.16V97.6c.49-.59.5-.6 1 0zm-1 0zm6 .5h-5.5c-.25-.97.27-1.17 1.16-1.01h4.33c.62.48.56.5 0 1.02zm0-1.01zm3.1 2.98c.15.77-.05 1.28-.88.91a3.66 3.66 0 0 1-2.73-3.36c.6-.07 1.16-.18 1.12.58a2.62 2.62 0 0 0 2.5 1.87zm3.1-3.06c-.13.95.13.98.51.64a3.64 3.64 0 0 1-3.6 3.44c-.05-.62-.13-1.18.63-1.1a2.63 2.63 0 0 0 1.97-2.48l.5-.5zm-.5.5zm3.1-3.12c.79-.16 1.27.08.9.9a3.64 3.64 0 0 1-3.49 2.74c-.05-.62-.12-1.18.65-1.1a2.63 2.63 0 0 0 1.94-2.54zm-3.1-3.12c.96.12.97-.14.63-.52a3.65 3.65 0 0 1 3.48 3.64c-.63.05-1.17.1-1.1-.66a2.62 2.62 0 0 0-2.5-1.96l-.5-.5zm.5.5zm-3.1-3.06c-.15-.77.06-1.28.9-.9a3.65 3.65 0 0 1 2.72 3.43c-.62.07-1.17.15-1.1-.61a2.62 2.62 0 0 0-2.52-1.92zm-3.11 3.12c.14-.96-.11-.98-.5-.63a3.65 3.65 0 0 1 3.61-3.5c.05.62.11 1.17-.65 1.1a2.63 2.63 0 0 0-1.95 2.52l-.51.5zm.5-.5zm-5.99-.52h5.49c.25.98-.27 1.17-1.16 1.02h-4.33c-.58-.5-.59-.52 0-1.02zm0 1.02zm.5-6.94v6.43c-.97.25-1.16-.28-1-1.16V84.9c.48-.6.5-.57 1 0zm-1 0zm.5 0zm-.5 0z'/%3e%3cpath fill='%2321231e' d='M499.82 122.37c-.7.1-1.26.06-1.03-.8a16.85 16.85 0 0 0-9.33-14.28 16.6 16.6 0 0 0-7.32-1.7c-.09-.71-.05-1.28.8-1a17.71 17.71 0 0 1 16.88 17.78zm-17.68 17.8c-.09-.69-.05-1.26.8-1.03a16.7 16.7 0 0 0 15.87-16.77c.7-.1 1.26-.05.99.8a17.86 17.86 0 0 1-9.76 15.13 17.6 17.6 0 0 1-7.9 1.88zm-17.67-17.8c.7-.1 1.26-.06 1.03.8a16.85 16.85 0 0 0 9.33 14.28 16.6 16.6 0 0 0 7.31 1.7c.1.71.06 1.28-.8 1a17.71 17.71 0 0 1-14.96-9.74 17.92 17.92 0 0 1-1.9-8.04zm17.67-17.8c.1.69.06 1.26-.8 1.03a16.7 16.7 0 0 0-15.86 16.77c-.7.1-1.26.05-.99-.8a17.86 17.86 0 0 1 9.77-15.13 17.6 17.6 0 0 1 7.89-1.88z'/%3e%3cpath fill='%23edb92e' d='M498.96 118.85a17.57 17.57 0 0 1 .18 5.96c-5.64-.2-11.3-.33-17-.33-5.69 0-11.34.14-16.99.33a17.47 17.47 0 0 1 .18-5.96c5.59-.2 11.19-.32 16.82-.32 5.63 0 11.23.13 16.8.32z'/%3e%3cpath fill='%2321231e' d='M499.82 122.37c-.3-.11-1.06.24-1.01-.22a16.92 16.92 0 0 0-.34-3.2c.31.06 1-.45 1.03.02.22 1.12.32 2.26.32 3.4zm-.7 2.96c-.07-.26.25-1.31-.18-.83-.4.47-.27 0-.23-.34.06-.6.1-1.2.1-1.8.28.1.98-.2 1 .17 0 .79-.06 1.58-.17 2.36l-.52.44zm.52-.44c.26.58-.9.57-.24.2l.24-.2zm-17.5.1c.12-.32-.26-1.13.3-1.01 5.57 0 11.15.13 16.72.33-.12.32.23 1.15-.33 1-5.56-.19-11.12-.3-16.68-.31zm-17.49-.1c.24-.12 1.33.01.78-.33-.66-.39.28-.22.6-.28 5.36-.18 10.74-.3 16.12-.3-.11.33.26 1.14-.3 1.02-5.56 0-11.12.13-16.68.33l-.52-.44zm.52.44c-.53.36-.71-.8-.24-.2l.24.2zm-.7-2.96c.3.1.97-.2 1.01.15 0 .75.07 1.5.17 2.23-.3-.06-.95.34-1.02-.01-.1-.79-.16-1.58-.16-2.37zm.85-4.02c.1.25-.17 1.3.25.83.43-.5.13.23.12.5-.14.9-.2 1.8-.2 2.69-.3-.11-1.09.25-1.02-.23.02-1.14.14-2.27.37-3.39l.48-.4zm-.48.4c-.06-.61.83-.43.1-.08l-.06.05-.04.03zm17.3-.73c-.1.33.27 1.14-.28 1.02-5.5 0-11 .13-16.51.32.1-.33-.3-1.13.25-1.03 5.52-.18 11.03-.3 16.55-.3zm17.32.73c-.24.14-1.32.06-.78.4.61.38-.42.14-.7.18-5.27-.17-10.55-.28-15.83-.28.1-.33-.27-1.14.29-1.02 5.51 0 11.02.13 16.54.32l.48.4zm-.48-.4c.6-.16.56.75.1.08l-.06-.05-.04-.03z'/%3e%3cpath fill='%23edb92e' d='M468.82 133.18c-3.63-2.26-4.27 1.24-4.18 4.75.35 13.23 2.87 25.83-.67 42.03-1.42 6.49-3.7 10.13-1.48 11.38 5.67 3.19 8.27 6.1 7.37 7.67 1.68 3.22 5.86 2.6 12.28 1.57 6.42 1.03 10.6 1.65 12.28-1.57-.9-1.57 1.7-4.48 7.37-7.67 2.22-1.25-.06-4.9-1.48-11.38-3.53-16.2-1.01-28.8-.67-42.03.1-3.51-.54-7-4.18-4.75-7.15 4.45-19.4 4.5-26.64 0z'/%3e%3cpath fill='%2321231e' d='M465.15 137.91c-1.13.4-1.1-.46-1-1.31.07-1.72.33-4.28 2.42-4.64.9-.08 1.76.32 2.52.78-.32 1.37-1.14.39-2.03.25-1.57-.13-1.75 1.9-1.87 3.04-.05.62-.05 1.25-.04 1.88zm-.69 42.15c-1.49.15-.72-1.14-.61-2.03 2.1-10.35 1.56-20.98.74-31.43-.2-2.89-.37-5.77-.45-8.66 1.43-.52.96.97 1.08 1.86.53 11.15 1.97 22.38.41 33.52a80.3 80.3 0 0 1-1.17 6.74zm-1.72 10.83c-.24 1.4-1.28.55-1.53-.35-.48-2.41.79-4.73 1.32-7.03.36-1.21.68-2.43.95-3.66 1.47-.15.74 1.1.56 1.98-.57 2.7-1.88 5.27-1.95 8.05.04.42.26.82.65 1.01zm7.57 7.88c-1.23.98-.69-.15-.89-.99-1.39-2.62-4.14-4.13-6.58-5.66-1.23-.4.16-1.83.85-.68 2.5 1.6 5.32 3.21 6.67 5.97.43.4-.05 2.49-.05 1.36zm-.9.47zm12.81.83c.16 1.34-.52 1.05-1.66 1.27-3.07.37-6.43 1.22-9.35-.21a4.5 4.5 0 0 1-1.8-1.89c.97-1.01 1.2.28 1.96.78 2.4 1.47 5.38.74 8.02.46.95-.12 1.89-.32 2.83-.41zm-.16 0zm11.93-.8c1.11-1.07 1.03.22.3.85-2.02 2.3-5.42 1.85-8.14 1.56-1.37-.17-2.73-.39-4.09-.6-.23-1.44 1.02-.84 1.9-.74 2.84.33 5.94 1.16 8.65-.12.66-.04 1.45-2 1.38-.96zm.87-.52zm6.69-7.86c1.05.98-.27 1.28-1 1.77-2.15 1.43-4.63 2.84-5.73 5.28.35.74-.93 1.9-1.04.73-.13-2.2 1.92-3.68 3.43-4.96a35.82 35.82 0 0 1 4.34-2.82zm-1.73-10.83c1.26-.74 1.14.67 1.4 1.52.6 2.82 2.01 5.5 1.98 8.43.02.64-.95 2.32-1.4 1.34-.57-.64.8-1.16.4-2.05-.46-3.15-1.79-6.1-2.38-9.24zm-.68-42.15c1.46-.44.9 1.03.94 1.92-.51 11.05-1.96 22.17-.44 33.2.29 2.29.69 4.56 1.17 6.82-1.3.76-1.13-.76-1.36-1.63-2.13-10.43-1.58-21.15-.76-31.7.2-2.86.37-5.74.45-8.61zm-3.4-4.3c-1-.84-.04-1.27.8-1.51 1.62-.68 3.15.76 3.34 2.32.26 1.15.3 2.34.27 3.52-1.45.43-.9-1.02-1.05-1.91-.13-1.14-.28-3.12-1.83-3.05a4.1 4.1 0 0 0-1.54.63zm-27.18 0c.35-1.48 1.34-.28 2.2.04 6.28 2.87 13.66 3.06 20.21 1.02 1.48-.48 2.9-1.11 4.23-1.93 1.07.9-.13 1.27-.9 1.67-6.57 3.13-14.35 3.38-21.25 1.25a20.93 20.93 0 0 1-4.5-2.05z'/%3e%3cg id='a'%3e%3cpath fill='%23edb92e' d='M363.03 212.12c-1.9-4.14-.37-9.93.25-11.23.32-.67-.61-2.12-1.02-2.7-12.9-18.27-13.12-19.9-4.23-26.75 8.03-6.18 26.16-12.19 39.14-16.23 2.7-2.06 4.42-4.87 6.87-7.18-24.93 1.8-51.94 11.92-65.57 23.76-7.2 6.25 1.56 18.89 12.28 38.1 6.63 4.79 9.74 7.01 12.28 2.23z'/%3e%3cpath fill='%2321231e' d='M362.83 200.67c1.42.16.52 1.2.38 2.07-.71 2.99-.97 6.29.28 9.17-1.16 1.09-1.29-.63-1.55-1.47-.67-3.22-.28-6.71.89-9.77zm-.98-2.17c.7-.98 1.16-.3 1.5.48.32.64.7 1.41.4 2.13-.67-.18-1.02-.45-1.05-1.12a7.78 7.78 0 0 0-.85-1.5zm-4.12-27.46c1.4 1-.63 1.53-1.24 2.28-2.2 1.75-4.73 4.22-3.98 7.33 1.16 4.64 4.24 8.48 6.8 12.43 1.11 1.62 2.24 3.22 3.37 4.83-1.05 1.37-1.52-.73-2.22-1.4-3.14-4.7-6.79-9.22-8.68-14.6-1.06-2.8.08-5.9 2.28-7.78 1.14-1.12 2.4-2.1 3.67-3.09zm39.13-16.23c1.5 1.18-.9 1.14-1.7 1.57-11.1 3.59-22.32 7.14-32.6 12.73a37.37 37.37 0 0 0-4.22 2.74c-1.36-.96.51-1.47 1.2-2.09 8.35-5.23 17.76-8.43 27.01-11.66a498.7 498.7 0 0 1 10.47-3.37l-.16.08zm.61.81zm6.61-7.07c-.28-2.03.76.33-.56.73-2 2.12-3.7 4.56-6.05 6.34-1.3-.9.35-1.4.92-2.14 1.87-1.84 3.39-4.02 5.31-5.82l.38.89zm-.07-1.02c2.15-.96.72 1.46.15.34l-.08-.18-.07-.16zm-65.2 24.65c-1.49-.95.64-1.63 1.28-2.37 10.32-7.95 22.54-13.06 34.92-16.84a137.29 137.29 0 0 1 29-5.44c.63 1.65-1.5.92-2.46 1.23a137.37 137.37 0 0 0-48.52 14.05 74.54 74.54 0 0 0-14.23 9.37zm12.24 37.3c-.69 1.77-1.22-.42-1.74-1.11-4.35-7.96-9.37-15.61-12.62-24.1-1.4-3.8-2.35-8.66.59-11.99.57-1.53 2.25-.12.8.61-2.76 3.12-1.68 7.65-.39 11.17 3.3 8.5 8.34 16.17 12.7 24.14.04.16 1.08 1.8.66 1.28zm-.6.83zm12.58 1.3c.03 1.33.67.76-.45 2.14-1.35 1.98-4.08 1.8-5.93.67-2.2-1.16-4.17-2.68-6.2-4.11.55-1.63 1.65.16 2.53.56 2.17 1.38 4.32 3.42 7.04 3.38 1.55-.14 1.96-1.88 3.01-2.64zm-.45.27zm.45.75zm.46-.72z'/%3e%3cpath fill='%23edb92e' d='M359.11 213.58a33.86 33.86 0 0 1-1.25-4.72c-.54-2.7-.3-5.52.6-8.15-2.98-4.21-6.32-8.78-8.73-13.33-1.72-3.24-3.04-6.86-2.03-10.56 1.08-3.94 4.5-6.63 7.58-9 3.7-2.85 8.62-5.35 13.61-7.47 11.17-4.64 20.05-6.9 26.56-7.11l-4.13 3.83c-12.11 3.92-26.4 9.09-33.28 14.38-8.9 6.85-8.68 8.47 4.23 26.76.4.57 1.33 2.02 1.02 2.68-.62 1.31-1.76 7.34.13 11.49-1.11 2.1-2.73 1-4.31 1.2z'/%3e%3cpath fill='%2321231e' d='M357.37 208.96c1.2-.7 1.12.5 1.32 1.35.25 1.05.55 2.08.9 3.1-.77.51-1.16.24-1.26-.6-.4-1.26-.72-2.58-.96-3.85zm1-.2zm-.33-7.76c1.08-1.17.92.16.56 1-.59 2.2-.69 4.52-.24 6.76-1.18.67-1.15-.51-1.22-1.39-.22-2.3.09-4.64.84-6.83l.06.46zm.83-.59zm-9.58-12.79c.88-.9 1.2.01 1.59.79 2.37 4.18 5.22 8.08 7.99 12-.76 1.02-1.2.13-1.67-.6-2.8-3.95-5.63-7.9-7.91-12.19zm-2.08-10.93c1.2-.04.9.75.72 1.58-.39 3.12.81 6.16 2.25 8.87-.86.89-1.2.03-1.52-.77-1.44-2.97-2.37-6.41-1.45-9.68zm7.76-9.28c1.04.73.16 1.2-.55 1.7-2.62 2.08-5.31 4.5-6.24 7.85-1.34.06-.8-.97-.44-1.77 1.49-3.31 4.43-5.62 7.23-7.78zm13.73-7.54c.86 1-.17 1.21-.98 1.54-4.24 1.89-8.43 3.99-12.13 6.8-1.2-.83.13-1.33.84-1.87a71.08 71.08 0 0 1 12.27-6.47zm0 0zm27.1-6.26c-1.33-1.57.38.52-1.1.17-8.9.63-17.4 3.71-25.62 7.04-.93-1.1.44-1.25 1.25-1.61 8.05-3.16 16.4-6.06 25.1-6.48l.37.88zm-.36-.88c1.59-.45 1.23.54.3.73l-.3-.73zm-4.46 3.97 4.13-3.84c1.31.75-.09 1.38-.7 2.05-1 .87-1.9 1.84-2.93 2.65l-.5-.86zm.69.75zm-33.32 14.4c-1.17-.8.06-1.3.78-1.81 7.13-4.63 15.18-7.56 23.13-10.45 2.96-1.04 5.93-2.04 8.9-3 .87 1.2-.59 1.2-1.42 1.54-9.46 3.17-19 6.39-27.72 11.3-1.26.74-2.5 1.53-3.67 2.43zm4.33 26.06c-.86 1.2-1.29-.13-1.83-.84-3.13-4.63-6.65-9.12-8.8-14.33-1.05-2.44-.88-5.45.97-7.47 1.35-1.63 3.05-2.92 4.71-4.22 1.2.83-.14 1.33-.8 1.92-2.15 1.76-4.84 3.95-4.5 7.05.56 3.8 2.95 6.98 4.93 10.16 1.72 2.61 3.52 5.17 5.32 7.73zm1.07 3.2c-.57-.21-1.04-.37-1.01-1.03a7.45 7.45 0 0 0-.88-1.58c.65-.85 1.12-.43 1.44.38.34.67.76 1.48.45 2.23zm.12 11.5c-1.12-.67-.96.26-1.38-1.3-.95-3.46-.81-7.25.34-10.64 1.22.16.72.98.51 1.8-.69 3.25-.67 6.74.54 9.85v.3zm.02-.45zm-4.78.9c.26 1.87-.58-.07.44-.02 1.19.06 2.86.56 3.43-.9 1.14.2.81.97.1 1.5-1.11.97-2.62.34-3.9.44l-.07-1.01zm0 1.03c-.43-1.42.94-.87 0 0zm.48-.68z'/%3e%3cpath fill='%23edb92e' d='M468.14 132.2c.11-2.32-.04-1.92-.39 1.65-.37-.72-.86-1.05-1.45-1.03-1.05.01-1.68 1.61-1.79 5.22l.2 2.76c-33.07-.74-52.67 4.28-57.72 13.92-4.16 7.93 2.91 21.06 13.58 36.05 1.3 1.82 1.25 1.66 0 3.16-1.8 2.16-3.75 5.82-2.29 9.04-6.46 3.56-14.16 4.43-20.87 1.48-1.11-2.96-3.53-4.37-5.49-5.71-.4-.28-1.83-.98-1.98-1.44-3.52-11.35-7.06-21.85-10.1-31.62-9.54-30.68 75.24-33.5 88.3-33.48z'/%3e%3cpath fill='%2321231e' d='M467.31 134.09c1.79-.7-.88.09.1-1.72.1-.7-.02-2.45 1.08-1.93.62.77-.01 2.58-.84 1.53-.18-1.4.15-.73.96-.99-.3.93 0 2.34-.58 2.97l-.72.14zm.95-.19c.63 2.82-1.74.42-.25.05l.23-.04h.02zm-1.95-.57c-.33-.92.17-1.28.9-.8.53.3 1.51 1.23.37 1.42-.43.36-.62-.8-1.27-.62zm0 0zm-1.28 4.68c-1.6.63-.84-1.2-.87-2.08.2-1.36.44-3.43 2.13-3.62.35.91-.3 1.03-.65 1.69-.51 1.23-.56 2.85-.61 4zm-1.01.06zm.68 3.24c.38-1.77-.75.25-.55-1.33.11-.71-.65-2.2.57-1.95.65.02.24 1.25.43 1.8.05.62.2 1.07-.45 1.48zm.51-.54zm-57.77 14.2c-1.86-.47.38-2.14.87-3.04 5.18-5.62 12.95-7.71 20.18-9.27 11.92-2.32 24.12-2.59 36.23-2.37.41 1.9-2.2.64-3.31.97-13.43-.03-27.1.35-40.05 4.27-5.32 1.76-11.07 4.3-13.92 9.43zm13.56 35.5c-1.23 1.47-1.76-1.29-2.62-1.97-5.12-7.61-10.47-15.44-12.64-24.48-.68-3.15-.71-6.62.82-9.55 1.77.4-.19 2.02-.03 3.19-.97 6.4 2.12 12.5 4.98 18 2.82 5.15 6.1 10.03 9.49 14.81zm-.02 3.78c-1.33-.52-.22-1.07.05-1.83-.33-.8-1.36-1.51-.03-1.95.83.89 1.57 2.34.4 3.29-.15.16-.29.33-.42.5zm-2.44 9.16c-.6-1.17-1.05-.04-1.22-2.14-.27-2.84 1.13-5.54 2.88-7.68 1.44.57.02 1.39-.35 2.22-1.27 2.01-2.13 4.64-1.09 6.94l-.22.66zm.22-.66zm-21.8 1.88c1.03-1 1.51-.12 3.17.26 5.98 1.74 12.54.62 17.93-2.38 1.3 1.45-1.6 1.65-2.48 2.3-5.82 2.38-12.81 2.78-18.52-.07l-.1-.11zm.27.28zm-5.57-5.75c.48-1.62 1.63.05 2.49.48a10.14 10.14 0 0 1 3.75 4.63c-1.16.96-1.2-.6-1.79-1.27-1.11-1.66-2.83-2.75-4.45-3.84zm-2.18-1.71c.74-.55 1.14-.24 1.72.25.79.32 1.38.82.42 1.44-.73-.5-1.74-.84-2.14-1.7zm-10.1-31.62c1.54-1 1.24 1.55 1.82 2.44 3.04 9.63 6.25 19.22 9.24 28.87-1.62 1-1.28-1.79-1.9-2.71-3-9.55-6.19-19.04-9.17-28.6zm88.27-33.66c2.32.15-.97.8-1.86.56-18.49.47-37.05 2.06-55.08 6.32-8.9 2.29-18.1 5.02-25.34 10.94-3.7 3.04-6.31 7.75-5.64 12.64.1 1.03 1.21 3.66-.4 2.97a14.3 14.3 0 0 1 2.82-13.75c5.03-5.87 12.48-8.89 19.64-11.33 16.13-5.13 33.09-7.03 49.91-8.22 5.48-.34 10.97-.6 16.46-.61l-.5.48zm1.01.05zm-.5-.02zm.5.02z'/%3e%3cpath fill='%23FFF' d='M404.99 190.16a6.4 6.4 0 0 1 6.37 6.41c0 3.55-2.85 6.42-6.37 6.42s-6.37-2.87-6.37-6.42a6.4 6.4 0 0 1 6.37-6.41z'/%3e%3cpath fill='%2321231e' d='M411.87 196.57h-1.01a5.93 5.93 0 0 0-5.86-5.9v-1.02a6.88 6.88 0 0 1 6.87 6.92zM405 203.5v-1.02a5.87 5.87 0 0 0 5.86-5.91h1.01a6.96 6.96 0 0 1-3.26 5.9 6.85 6.85 0 0 1-3.61 1.03zm-6.88-6.93h1.02a5.93 5.93 0 0 0 5.86 5.9v1.03a6.88 6.88 0 0 1-6.88-6.93zm6.88-6.92v1.01a5.87 5.87 0 0 0-5.86 5.91h-1.02a6.96 6.96 0 0 1 3.26-5.89 6.85 6.85 0 0 1 3.62-1.03z'/%3e%3cpath fill='%23FFF' d='M350.75 203.61a5.93 5.93 0 0 1 5.91 5.96c0 3.29-2.65 5.95-5.91 5.95a5.94 5.94 0 0 1-5.91-5.95 5.93 5.93 0 0 1 5.91-5.96z'/%3e%3cpath fill='%2321231e' d='M357.17 209.56h-1.01a5.47 5.47 0 0 0-5.4-5.45v-1.02a6.43 6.43 0 0 1 6.41 6.47zm-6.42 6.47V215a5.42 5.42 0 0 0 5.4-5.45h1.02a6.5 6.5 0 0 1-6.42 6.47zm-6.42-6.47h1.01a5.47 5.47 0 0 0 5.41 5.45v1.02a6.43 6.43 0 0 1-6.42-6.47zm6.42-6.47v1.02a5.42 5.42 0 0 0-5.4 5.45h-1.02a6.4 6.4 0 0 1 6.42-6.47z'/%3e%3cpath fill='%23FFF' d='M345.1 192.72a5.94 5.94 0 0 1 5.91 5.96 5.94 5.94 0 0 1-5.91 5.95 5.93 5.93 0 0 1-5.91-5.95 5.93 5.93 0 0 1 5.91-5.96z'/%3e%3cpath fill='%2321231e' d='M351.52 198.68h-1.01a5.47 5.47 0 0 0-5.4-5.45v-1.02a6.43 6.43 0 0 1 6.41 6.47zm-6.42 6.47v-1.02a5.42 5.42 0 0 0 5.4-5.45h1.02a6.5 6.5 0 0 1-3.04 5.5 6.4 6.4 0 0 1-3.38.97zm-6.42-6.47h1.02a5.47 5.47 0 0 0 5.4 5.45v1.02a6.42 6.42 0 0 1-6.42-6.47zm6.42-6.47v1.02a5.41 5.41 0 0 0-5.4 5.45h-1.02a6.42 6.42 0 0 1 6.42-6.47z'/%3e%3cpath fill='%23FFF' d='M339.79 181.71a5.93 5.93 0 0 1 5.91 5.96 5.93 5.93 0 0 1-5.91 5.95 5.94 5.94 0 0 1-5.91-5.95 5.93 5.93 0 0 1 5.91-5.96z'/%3e%3cpath fill='%2321231e' d='M346.21 187.66h-1.01a5.47 5.47 0 0 0-5.4-5.45v-1.02a6.42 6.42 0 0 1 6.41 6.47zm-6.42 6.47v-1.02a5.41 5.41 0 0 0 5.4-5.45h1.02a6.5 6.5 0 0 1-3.01 5.48 6.4 6.4 0 0 1-3.4.99zm-6.42-6.47h1.02a5.47 5.47 0 0 0 5.4 5.45v1.02a6.43 6.43 0 0 1-6.42-6.47zm6.42-6.47v1.02a5.42 5.42 0 0 0-5.4 5.45h-1.02a6.5 6.5 0 0 1 6.42-6.47z'/%3e%3cpath fill='%23edb92e' d='M444.27 202.15c3.42-.23 2.57 5.9 1.9 7.26-.88 1.78-1.7 1.84-2.81.19-.85-1.26-2.5-7.22.91-7.45z'/%3e%3cpath fill='%2321231e' d='m446.62 209.63-.9-.45c.32-.78.44-1.63.52-2.46a6.72 6.72 0 0 0-.35-3.08c-.2-.46-.58-.88-1.1-.96a2.1 2.1 0 0 0-.48-.03l-.07-1.01c.64-.05 1.32.12 1.81.55.71.6 1.02 1.54 1.15 2.44.18 1.32.06 2.67-.24 3.97-.08.35-.19.7-.34 1.03zm-3.68.25.84-.57c.25.35.5.74.9.94.26.1.45-.17.6-.34.17-.23.3-.48.44-.73l.9.45c-.31.61-.68 1.28-1.34 1.57-.52.23-1.12.02-1.52-.35a4.97 4.97 0 0 1-.82-.97zm1.3-8.25.07 1.02c-.5.03-.99.26-1.23.7-.38.66-.4 1.47-.35 2.22.1 1.15.37 2.3.84 3.36l.2.38-.83.57a8.71 8.71 0 0 1-.95-2.51 8.16 8.16 0 0 1-.16-3.58c.17-.76.6-1.5 1.32-1.86.33-.18.71-.26 1.09-.3z'/%3e%3cpath fill='%23FFF' d='M444.49 205.46c8.03-.55 6.04 13.85 4.46 17.05-2.07 4.2-4 4.32-6.6.45-2-2.96-5.89-16.95 2.14-17.5z'/%3e%3cpath fill='%2321231e' d='m449.4 222.74-.9-.45c.74-1.73 1.03-3.61 1.25-5.46.23-2.54.24-5.19-.62-7.62-.47-1.31-1.37-2.58-2.75-3.03-.6-.2-1.23-.24-1.86-.21l-.07-1.02c1.36-.1 2.78.25 3.81 1.15 1.5 1.3 2.13 3.29 2.42 5.19.43 3.03.17 6.14-.5 9.12-.2.8-.43 1.59-.78 2.33zm-7.47.5.84-.56c.67.94 1.37 1.97 2.45 2.47.74.33 1.5-.2 1.96-.75.54-.64.94-1.37 1.32-2.11l.9.45c-.64 1.23-1.35 2.57-2.6 3.26-.94.53-2.1.2-2.88-.45a10.3 10.3 0 0 1-1.99-2.3zm2.56-17.27v-1.02l.03 1.02c-1.23.07-2.49.6-3.2 1.66-1.04 1.48-1.2 3.37-1.18 5.13.1 2.89.78 5.75 1.86 8.42.22.51.46 1.02.77 1.5l-.84.57a19.76 19.76 0 0 1-2.1-5.53c-.62-2.64-.99-5.43-.43-8.13.35-1.62 1.23-3.23 2.75-4.01.7-.39 1.5-.56 2.3-.63l.04 1.02zm0-1.02v1.02l-.04-1.02h.04z'/%3e%3cpath fill='%23edb92e' d='M379.74 210.81c3.26-1.05 3.9 5.1 3.56 6.6-.43 1.94-1.21 2.19-2.68.85-1.13-1.02-4.14-6.4-.88-7.45z'/%3e%3cpath fill='%2321231e' d='m383.79 217.51-.99-.22c.13-.77.06-1.56-.04-2.33-.16-1.01-.4-2.04-.96-2.9-.3-.47-.8-.9-1.38-.86a2 2 0 0 0-.53.09l-.3-.97c.6-.2 1.29-.2 1.87.09.83.4 1.35 1.23 1.7 2.06.5 1.27.7 2.64.72 4 0 .35-.02.7-.09 1.04zm-3.51 1.13.67-.76c.34.28.69.62 1.13.7.26.01.38-.28.47-.47.12-.26.19-.54.25-.82l.99.22c-.16.67-.36 1.4-.93 1.85-.45.34-1.07.29-1.54.03-.39-.2-.72-.47-1.04-.75zm-.7-8.32.31.97c-.48.14-.9.5-1.03 1a4.1 4.1 0 0 0 .22 2.3c.37 1.07.9 2.1 1.6 2.99l.27.3-.67.76a8.77 8.77 0 0 1-1.53-2.24 8.18 8.18 0 0 1-.99-3.38c-.02-.8.23-1.63.84-2.15.28-.26.63-.43.98-.55z'/%3e%3cpath fill='%23FFF' d='M380.74 213.97c7.67-2.46 9.14 12 8.36 15.5-1.02 4.56-2.85 5.14-6.3 2.01-2.64-2.4-9.73-15.05-2.06-17.51z'/%3e%3cpath fill='%2321231e' d='m389.6 229.58-.99-.22c.32-1.86.16-3.75-.07-5.6-.38-2.53-1-5.1-2.4-7.25-.79-1.2-2.04-2.25-3.53-2.3a5.16 5.16 0 0 0-1.71.25l-.3-.97a5.23 5.23 0 0 1 3.97.2c1.77.92 2.86 2.72 3.59 4.5 1.12 2.84 1.59 5.9 1.64 8.94 0 .82-.03 1.65-.2 2.45zm-7.14 2.29.68-.76c.87.76 1.8 1.59 2.97 1.81.8.15 1.41-.54 1.72-1.2.38-.74.6-1.55.78-2.36l.99.22c-.33 1.35-.7 2.82-1.76 3.8-.78.73-1.99.7-2.9.24a10.26 10.26 0 0 1-2.48-1.75zm-1.87-18.38.3.97a4.15 4.15 0 0 0-2.74 2.43c-.66 1.78-.32 3.73.18 5.5.8 2.7 2.11 5.26 3.78 7.53.31.42.65.83 1.03 1.2l-.68.75a19.73 19.73 0 0 1-3.34-4.86c-1.23-2.43-2.25-5.05-2.34-7.8-.05-1.66.43-3.44 1.72-4.56a5.9 5.9 0 0 1 2.09-1.16zm.15.49c-.11-.37-.2-.64-.03-.12l.03.12z'/%3e%3cpath fill='%23edb92e' d='M464.2 137.77c-17.23-1.57-34.85.2-52.3 7.17-14.7 5.88-13.26 23.06 4.67 46.9-1.62 3.01-2.55 6.77-2.7 11.1 1.9-.1 3.23-.05 4.9-.1-1.3-2.88.16-6.42 1.8-8.91 1.07-1.63 1.3-1.34 0-3.16-10.67-15-17.74-28.12-13.58-36.05 5.05-9.64 24.66-14.66 57.71-13.92l-.18-2.67-.32-.36z'/%3e%3cpath fill='%2321231e' d='M412.09 145.42c-1.04-1.31.96-1.3 1.79-1.78 15.99-6.06 33.39-7.97 50.37-6.37.35 1.66-1.47.72-2.44.82-16.86-1.28-34 1-49.72 7.33zm4.93 46.66c-1.2-.55-.95.17-1.95-1.42-5.67-7.88-11.01-16.38-13.12-25.97-1.2-5.52-.66-11.96 3.52-16.15a17.8 17.8 0 0 1 6.25-4.07c1.05 1.32-.99 1.31-1.75 1.95a13.8 13.8 0 0 0-7.52 11.77c-.35 7.5 2.87 14.6 6.4 21.04 2.4 4.3 5.18 8.36 8.12 12.3l.05.55zm-.05-.55zm-3.12 10.9c.37 1.81-.87.28-.42-.69a25.1 25.1 0 0 1 2.7-10.15c1.56.3.21 1.47 0 2.39a26.6 26.6 0 0 0-1.75 8.98l-.53-.52zm.06 1.02zm4.4-.4c1.66-.99.34.84-.73.32-1.23 0-2.45 0-3.67.08-.57-1.5 1.14-.96 2.06-1.09.93 0 1.86 0 2.8-.02l-.45.72zm.93-.41zm.91-8.99c1.45.4.23 1.34-.1 2.18-1.04 2.06-1.78 4.58-.8 6.8-1.2 1.1-1.33-.7-1.45-1.59-.2-2.65.95-5.21 2.35-7.39zm.01-2.58c.8-1.12 1.33.02 1.7.8.4.9-.44 1.64-.86 2.34-1.24-.36-.51-1.04-.06-1.76.01-.51-.57-.95-.78-1.38zm-13.62-36.59c1.58.29.2 1.5.13 2.48-1.25 5.38.99 10.79 3.22 15.6 3.1 6.32 7.04 12.18 11.1 17.92-1 1.33-1.47-.58-2.14-1.27-5-7.32-10.09-14.84-12.7-23.41-1.02-3.67-1.43-7.82.4-11.32zm57.66-13.65c1.96-.31-.03.92-.98.45-13-.14-26.16.19-38.83 3.36-5.86 1.62-12.12 3.82-15.98 8.79-.28.96-1.7 2.15-1.68.73 3.17-5.4 9.3-8.01 15.01-9.83 12.14-3.54 24.9-4.05 37.48-4.1 1.83 0 3.66.03 5.5.06l-.52.54zm1.01-.07zm-1.07-2.29c.73-1.05 1.02-.34.95.55-.07.55.33 1.5-.06 1.76-.99.42-.88-.43-.9-1.1 0-.37-.18-1.55-.04-1.34l.05.13zm.76-.67zm-1.06-.39c.67 1.07.67.25.83.13.55.32-.37.8-.58.88-.22-.15-.38-.54-.25-1zm0 .71zm.72.01zm-.31-.86z'/%3e%3cpath fill='%23FFF' d='M380.59 142.66c3.4 0 6.14 2.77 6.14 6.19s-2.75 6.18-6.14 6.18-6.14-2.77-6.14-6.18 2.75-6.19 6.14-6.19z'/%3e%3cpath fill='%2321231e' d='M387.24 148.84h-1.01a5.7 5.7 0 0 0-5.64-5.67v-1.02a6.65 6.65 0 0 1 6.65 6.69zm-6.65 6.7v-1.02a5.64 5.64 0 0 0 5.64-5.68h1.01a6.72 6.72 0 0 1-3.15 5.7 6.6 6.6 0 0 1-3.5 1zm-6.64-6.7h1a5.7 5.7 0 0 0 5.64 5.68v1.02a6.65 6.65 0 0 1-6.64-6.7zm6.64-6.7v1.02a5.64 5.64 0 0 0-5.63 5.68h-1.01a6.72 6.72 0 0 1 3.12-5.67 6.6 6.6 0 0 1 3.52-1.03z'/%3e%3cpath fill='%23FFF' d='M392.62 138.7c3.4 0 6.14 2.77 6.14 6.19a6.16 6.16 0 0 1-6.14 6.18 6.16 6.16 0 0 1-6.14-6.18 6.16 6.16 0 0 1 6.14-6.19z'/%3e%3cpath fill='%2321231e' d='M399.27 144.88h-1.01a5.7 5.7 0 0 0-5.64-5.67v-1.02a6.65 6.65 0 0 1 6.65 6.69zm-6.65 6.7v-1.02a5.64 5.64 0 0 0 5.64-5.68h1.01a6.73 6.73 0 0 1-3.15 5.7c-1.04.65-2.27 1-3.5 1zm-6.64-6.7h1.01a5.7 5.7 0 0 0 5.63 5.68v1.02a6.65 6.65 0 0 1-6.64-6.7zm6.64-6.7v1.02a5.64 5.64 0 0 0-5.63 5.68h-1.01a6.73 6.73 0 0 1 3.18-5.71 6.62 6.62 0 0 1 3.46-.99z'/%3e%3cpath fill='%23edb92e' d='M394.22 143.97c.6.82 1.22 1.64 1.84 2.46-9.7 5.36-13.72 11.01-12.77 16.7.16.97 3.1 11.38 9.7 31.55 4.5 3.13 7.86 5.93 10.07 8.4-.25.3.7 1.17.42 1.4.68 3.09-2.77 2.46-5.09 1.7-1.11-2.96-4.51-6.1-6.47-7.44-.4-.28-1.83-.98-1.98-1.44-3.52-11.35-7.07-21.85-10.1-31.62-3.06-9.82 3.56-16.78 14.38-21.71z'/%3e%3cpath fill='%2321231e' d='M396.31 146.88c-.46-1.35-.47-.23-.82-.37l-1.67-2.23c.6-.76 1.06-.54 1.44.24.36.59 1 1.11 1.18 1.74l-.13.62zm.16-.76zm-12.68 16.93c-.94.45-1.2-.06-1.12-.95-.28-4.56 2.7-8.52 6.03-11.3a43.31 43.31 0 0 1 7.12-4.81c.9.86.03 1.2-.75 1.6-4.2 2.52-8.53 5.56-10.61 10.17a9.43 9.43 0 0 0-.67 5.3zm0 0zm9.5 31.22c-.5 1.28-.95.47-1.12-.47-3.23-10.05-6.52-20.07-9.3-30.25-.19-.7 1.39-.67 1.1.25 2.88 10.33 6.2 20.53 9.5 30.73l-.19-.26zm-.58.84zm10.73 8.33c-.92-1.32-.53.43-1.17-.46-2.85-3-6.18-5.5-9.56-7.87.37-1.2 1.06-.58 1.74-.02 3.2 2.3 6.34 4.74 9 7.67v.68zm0-.68zm.54 1.63c-.9.63-.96-.46-.94.02-.24-.5-.8-1.1-.35-1.65.36.56.8.47.92.6.28.43.7 1.09.2 1.53l.17-.5zm-.98.22zm-5.07 1.76c1.28-.14.26-.95 1.42-.43 1.12.23 2.57.76 3.55-.07.38-.65-.23-1.56.9-1.44.49.17.28 1.35.04 1.84-1 1.55-3.16 1.05-4.66.68-.44-.14-.96-.17-1.25-.58zm.31.3zm-6.6-7.5c.34-1.13.98-.72 1.61-.07 2.29 1.9 4.48 4.12 5.62 6.91-.83.62-1.15.13-1.42-.67a20.37 20.37 0 0 0-5.8-6.17zm.57-.85zm-2.74-.86c.5-.07.95-.59 1.29-.03.46.33.98.58 1.45.9-.3.63-.63 1.06-1.22.45-.55-.36-1.26-.68-1.52-1.32zm-10.1-31.62c1.05-.74 1.18.29 1.4 1.14 3.17 10.08 6.54 20.09 9.66 30.17-1 .7-1.18-.16-1.38-1.02-3.15-10.12-6.53-20.17-9.69-30.29zm15.26-22.17c-1.47.64.43.73-.94 1.12-5 2.42-10.12 5.56-12.76 10.65-1.6 3.1-1.66 6.81-.6 10.1-1 .7-1.2-.17-1.32-1.04a14.11 14.11 0 0 1 2.92-12.46c3.18-3.87 7.6-6.45 12.09-8.53l.61.16zm-.61-.16z'/%3e%3cpath fill='%23edb92e' d='m355.95 216.87-.37 1.98c-2.82.66-5.24.82-7.24.5 3.35-3.3 5.85-4 7.61-2.48z'/%3e%3cpath fill='%2321231e' d='m355.08 218.76.37-1.98 1 .19-.38 1.98-.38.4-.61-.59zm1 .19c-.05.1-.01.28-.1.34-.08 0-.37.12-.23 0l.32-.34zm-8.1.03.7.73-.27-.86c2.09.33 4.22.1 6.28-.32l.77-.17.23.99c-2.21.51-4.5.83-6.78.59a12.2 12.2 0 0 1-.66-.09l-.27-.87zm.27.87-.99-.16.72-.7.27.86zm8.2-2.88-1-.19.16.48a2.52 2.52 0 0 0-1.98-.63 6.23 6.23 0 0 0-2.77 1.23c-.78.55-1.5 1.19-2.18 1.85l-.7-.73a15 15 0 0 1 3.69-2.8c.97-.47 2.1-.76 3.18-.47.53.15 1.01.42 1.42.78l.17.48zm-.18-.48c.07.09.26.14.21.27-.02.16-.04.27-.1.05l-.1-.32zm-.33.38.5.1-.5-.1zm.33-.38c.07.09.26.14.21.27-.02.16-.04.27-.1.05l-.1-.32z'/%3e%3cpath fill='%23edb92e' d='M355.64 212.34c1.77.4 1.93.7 2.7.83 1 .17 2.36.1 3.3-.73 3.84-2.32 3.93 1.86 2.43 4.99-1.08 2.26-.52 4.82.51 6.76 1.22 2.3.96 3.34.1 3.96l-1.68 1.1c-1.03 1.22-1.82 1.01-1.96-.6-3.84-1.59-5.1-5.29-6.25-8.55-1.68-4.76-7.77-5.9.85-7.76z'/%3e%3cpath fill='%2321231e' d='m358.43 212.66-.17 1c-.83-.17-1.59-.6-2.43-.76-.43.03-.24-.32-.19-.6.03-.34.12-.57.48-.38.77.15 1.48.52 2.24.73l.07.01zm2.95-.66.52.87c.1-.06-.39.32-.56.39-.94.5-2.05.58-3.08.4l.17-1c1.01.17 2.16.05 2.95-.66zm-.07.05zm3.22 5.59-.91-.44c.56-1.26 1-2.66.78-4.05-.05-.49-.46-.99-1-.87a3.9 3.9 0 0 0-1.5.59l-.52-.87c.88-.52 2.02-1.04 3.02-.54.96.52 1.13 1.75 1.07 2.74a9.68 9.68 0 0 1-.94 3.44zm.5 6.3-.9.49c-1.14-2.13-1.6-4.78-.6-7.05.08-.39.48.09.7.12.44.06.2.36.1.62-.7 1.92-.24 4.07.7 5.82zm-.08 4.63c-.19-.27-.37-.62-.57-.84.62-.38.6-1.2.4-1.8a8.2 8.2 0 0 0-.65-1.5l.9-.49c.54 1.08 1.14 2.32.76 3.54a2.2 2.2 0 0 1-.84 1.1zm.02-.01-.02.01.02-.01zm-1.59 1-.77-.65c.57-.43 1.2-.78 1.79-1.2l.55.86-1.68 1.1.11-.1zm-.77-.65zm-1.77.2.39-.94c.19.24.36.48.36.8.05.18.07.44.25.54.33-.08.55-.37.77-.6l.77.65c-.46.56-1.19 1.2-1.96.89-.66-.31-.83-1.1-.9-1.76l.32.43zm.39-.94c.34-.07.4.7.16.23l-.16-.23zm-6.92-7.9.95-.35c.86 2.43 1.74 5 3.68 6.8.67.61 1.45 1.1 2.29 1.45l-.39.95a9.53 9.53 0 0 1-4.76-4.55c-.74-1.37-1.26-2.84-1.77-4.3zm1.33-8.45v1.02c.19-.01-.5.12-.65.16-1.07.29-2.22.5-3.14 1.14-.42.24-.1.72.1.99 1.01 1.25 2.2 2.39 2.91 3.85.15.3.28.62.4.94l-.95.34c-.58-1.7-1.88-2.99-3.01-4.33-.48-.57-.93-1.41-.49-2.12.55-.83 1.58-1.1 2.46-1.4.78-.24 1.57-.44 2.37-.59zm-.1.01zm.1 1.01v-1.02c.24.08-.02.56.02.8l-.02.22zm0-1.02z'/%3e%3cpath fill='%23edb92e' d='M357.15 212.5c3.34 1.2 3.7-.67 5.96-.57-.89 5.14-1.78 7.8-7.11 5.04-2.94-1.52-6.7.7-7.42 2.36-.26.6-1.97-.65-2.6-2.02-2.6-5.76 6.7-6.42 11.17-4.81z'/%3e%3cpath fill='%2321231e' d='m363.61 212.02-1-.18.48.6c-1.24-.1-2.23.83-3.43.94-.91.12-1.82-.1-2.68-.4l.34-.96c.99.37 2.12.56 3.12.1a5.65 5.65 0 0 1 2.7-.7l.47.6zm-.48-.6c.2.06.7-.11.54.23 0 .38-.1.4-.3.08l-.24-.3zm-7.36 6 .46-.9c1.1.54 2.29 1.12 3.55 1.04.9-.07 1.51-.87 1.82-1.65.54-1.3.76-2.7 1.01-4.07l1 .18c-.3 1.64-.55 3.35-1.35 4.84a3.05 3.05 0 0 1-2.54 1.72c-1.4.07-2.73-.54-3.95-1.15zm-6.72 2.12c-.3-.14-.62-.27-.93-.4a5.82 5.82 0 0 1 2.87-2.53 6.02 6.02 0 0 1 5.24-.09l-.46.9c-1.55-.8-3.43-.44-4.9.4-.71.42-1.44.95-1.82 1.72zm-3.52-2.02.92-.42c.39.77 1 1.47 1.78 1.85.26 0-.36.2.04.25l.78.34c-.21.52-.89.55-1.32.3a5.15 5.15 0 0 1-2.2-2.32zm11.8-5.5-.35.96c-2.09-.7-4.34-.86-6.53-.61-1.3.18-2.69.5-3.68 1.42-.71.62-.88 1.67-.6 2.54.07.27.18.51.28.77l-.92.42c-.49-1.07-.72-2.36-.2-3.47.64-1.3 2.02-2 3.35-2.37a15.83 15.83 0 0 1 8.64.34zm-.18.48c.07-.18.25-.7.09-.24l-.09.24z'/%3e%3cpath fill='%23FFF' d='M458.84 124.49c3.38 0 6.11 2.76 6.11 6.16s-2.73 6.16-6.11 6.16c-3.38 0-6.11-2.76-6.11-6.16s2.73-6.16 6.11-6.16z'/%3e%3cpath fill='%2321231e' d='M465.46 130.64h-1.01a5.67 5.67 0 0 0-5.6-5.65v-1.02a6.62 6.62 0 0 1 6.61 6.67zm-6.62 6.67v-1.02a5.61 5.61 0 0 0 5.6-5.65h1.02a6.7 6.7 0 0 1-3.14 5.67c-1.03.65-2.25 1-3.48 1zm-6.62-6.67h1.02a5.67 5.67 0 0 0 5.6 5.65v1.02a6.63 6.63 0 0 1-6.62-6.67zm6.62-6.67V125a5.62 5.62 0 0 0-5.6 5.65h-1.02a6.7 6.7 0 0 1 3.14-5.67c1.04-.65 2.26-1 3.48-1z'/%3e%3cpath fill='%23FFF' d='M446.31 124.49c3.38 0 6.11 2.76 6.11 6.16s-2.73 6.16-6.11 6.16-6.11-2.76-6.11-6.16 2.73-6.16 6.11-6.16z'/%3e%3cpath fill='%2321231e' d='M452.93 130.64h-1.01a5.67 5.67 0 0 0-5.6-5.65v-1.02a6.63 6.63 0 0 1 6.61 6.67zm-6.62 6.67v-1.02a5.62 5.62 0 0 0 5.6-5.65h1.02a6.7 6.7 0 0 1-3.14 5.67c-1.04.65-2.26 1-3.48 1zm-6.62-6.67h1.01a5.67 5.67 0 0 0 5.61 5.65v1.02a6.63 6.63 0 0 1-6.62-6.67zm6.62-6.67V125a5.62 5.62 0 0 0-5.6 5.65h-1.02a6.7 6.7 0 0 1 3.14-5.67c1.04-.65 2.26-1 3.48-1z'/%3e%3cpath fill='%23FFF' d='M433.79 125.48a6.14 6.14 0 0 1 6.11 6.16c0 3.4-2.73 6.16-6.11 6.16s-6.11-2.76-6.11-6.16c0-3.4 2.73-6.16 6.11-6.16z'/%3e%3cpath fill='%2321231e' d='M440.41 131.63h-1.01a5.67 5.67 0 0 0-5.6-5.65v-1.02a6.63 6.63 0 0 1 6.61 6.67zm-6.62 6.67v-1.02a5.62 5.62 0 0 0 5.6-5.65h1.02a6.7 6.7 0 0 1-3.14 5.67c-1.04.65-2.26 1-3.48 1zm-6.62-6.67h1.02a5.67 5.67 0 0 0 5.6 5.65v1.02a6.62 6.62 0 0 1-6.62-6.67zm6.62-6.67v1.02a5.61 5.61 0 0 0-5.6 5.65h-1.02a6.7 6.7 0 0 1 6.62-6.67z'/%3e%3cpath fill='%23FFF' d='M422.25 127.7a6.13 6.13 0 0 1 6.11 6.16c0 3.4-2.73 6.16-6.11 6.16a6.14 6.14 0 0 1-6.11-6.16c0-3.4 2.73-6.16 6.11-6.16z'/%3e%3cpath fill='%2321231e' d='M428.87 133.86h-1.01a5.67 5.67 0 0 0-5.6-5.65v-1.02a6.63 6.63 0 0 1 6.61 6.67zm-6.62 6.67v-1.02a5.62 5.62 0 0 0 5.6-5.65h1.02a6.7 6.7 0 0 1-3.14 5.67c-1.03.65-2.25 1-3.48 1zm-6.62-6.67h1.02a5.67 5.67 0 0 0 5.6 5.65v1.02a6.62 6.62 0 0 1-6.62-6.67zm6.62-6.67v1.02a5.62 5.62 0 0 0-5.6 5.65h-1.02a6.7 6.7 0 0 1 6.62-6.67z'/%3e%3cpath fill='%23FFF' d='M346.3 159.43c3.4 0 6.14 2.77 6.14 6.19a6.16 6.16 0 0 1-6.14 6.18 6.16 6.16 0 0 1-6.14-6.18 6.16 6.16 0 0 1 6.14-6.19z'/%3e%3cpath fill='%2321231e' d='M352.94 165.62h-1.01a5.7 5.7 0 0 0-5.64-5.68v-1.02a6.65 6.65 0 0 1 6.65 6.7zm-6.65 6.7v-1.02a5.64 5.64 0 0 0 5.64-5.68h1.01a6.72 6.72 0 0 1-3.12 5.67 6.6 6.6 0 0 1-3.53 1.03zm-6.64-6.7h1a5.7 5.7 0 0 0 5.64 5.67v1.02a6.65 6.65 0 0 1-6.64-6.69zm6.64-6.7v1.02a5.64 5.64 0 0 0-5.63 5.68h-1.01a6.73 6.73 0 0 1 3.15-5.7c1.04-.65 2.26-1 3.5-1z'/%3e%3cpath fill='%23FFF' d='M356.82 152.75a6.16 6.16 0 0 1 6.14 6.19c0 3.41-2.75 6.18-6.14 6.18s-6.14-2.77-6.14-6.18 2.75-6.19 6.14-6.19z'/%3e%3cpath fill='%2321231e' d='M363.47 158.94h-1.01a5.7 5.7 0 0 0-5.64-5.68v-1.02a6.65 6.65 0 0 1 6.65 6.7zm-6.65 6.7v-1.02a5.64 5.64 0 0 0 5.64-5.68h1.01a6.72 6.72 0 0 1-3.12 5.67 6.6 6.6 0 0 1-3.53 1.03zm-6.64-6.7h1.01a5.7 5.7 0 0 0 5.63 5.67v1.02a6.65 6.65 0 0 1-6.64-6.69zm6.64-6.7v1.02a5.64 5.64 0 0 0-5.63 5.68h-1.01a6.72 6.72 0 0 1 3.15-5.7 6.6 6.6 0 0 1 3.5-1z'/%3e%3cpath fill='%23FFF' d='M368.79 147.09c3.4 0 6.14 2.77 6.14 6.19a6.16 6.16 0 0 1-6.14 6.18 6.16 6.16 0 0 1-6.14-6.18 6.16 6.16 0 0 1 6.14-6.19z'/%3e%3cpath fill='%2321231e' d='M375.43 153.28h-1.01a5.7 5.7 0 0 0-5.64-5.68v-1.02a6.65 6.65 0 0 1 6.65 6.7zm-6.65 6.7v-1.02a5.64 5.64 0 0 0 5.64-5.68h1.01a6.72 6.72 0 0 1-3.15 5.7c-1.04.65-2.27 1-3.5 1zm-6.64-6.7h1.01a5.7 5.7 0 0 0 5.63 5.68v1.01a6.65 6.65 0 0 1-6.64-6.69zm6.64-6.7v1.02a5.64 5.64 0 0 0-5.63 5.68h-1.01a6.73 6.73 0 0 1 3.15-5.7c1.04-.65 2.26-1 3.5-1z'/%3e%3cpath fill='%23FFF' d='M338.16 169.49c3.4 0 6.14 2.77 6.14 6.19a6.16 6.16 0 0 1-6.14 6.18 6.16 6.16 0 0 1-6.14-6.18 6.16 6.16 0 0 1 6.14-6.19z'/%3e%3cpath fill='%2321231e' d='M344.8 175.68h-1.01a5.7 5.7 0 0 0-5.64-5.68v-1.02a6.65 6.65 0 0 1 6.65 6.7zm-6.65 6.7v-1.02a5.65 5.65 0 0 0 5.64-5.68h1.01a6.72 6.72 0 0 1-3.15 5.7 6.6 6.6 0 0 1-3.5 1zm-6.64-6.7h1.01a5.7 5.7 0 0 0 5.63 5.68v1.01a6.65 6.65 0 0 1-6.64-6.69zm6.64-6.7V170a5.64 5.64 0 0 0-5.63 5.68h-1.01a6.73 6.73 0 0 1 3.15-5.7c1.04-.65 2.26-1 3.5-1z'/%3e%3cpath fill='%23edb92e' d='m408.846 279.05 22.003-12.83 23.396 10.03-22.002 12.84z'/%3e%3cpath fill='%2321231e' d='m431.11 266.67-22 12.83-.5-.88 22-12.83.45-.03.05.91zm-.5-.88.21-.13.24.1-.46.03zm23.44 10.94-23.4-10.03.4-.94 23.4 10.03.05.91-.45.03zm.4-.94.93.4-.88.51-.05-.9zm-22.46 12.87 22-12.84.51.88-22 12.84-.45.03-.06-.91zm.5.88-.21.13-.23-.1.45-.03zm-23.44-10.95 23.4 10.04-.4.94-23.4-10.04-.05-.91.45-.03zm-.4.94-.93-.4.88-.51.06.9z'/%3e%3cpath fill='%23c6363c' d='M431.13 270.65c5.64-.35 10.4 2.44 10.63 6.23.23 3.8-4.16 7.14-9.8 7.5-5.64.34-10.4-2.45-10.63-6.24-.23-3.79 4.16-7.14 9.8-7.49z'/%3e%3cpath fill='%2321231e' d='m442.26 276.85-1.01.06c-.11-1.9-1.54-3.42-3.13-4.3a12.7 12.7 0 0 0-6.96-1.45l-.07-1.02c3.07-.17 6.33.48 8.78 2.43a6.07 6.07 0 0 1 2.39 4.28zm-10.27 8.03-.06-1.02c2.8-.18 5.7-1.12 7.72-3.15.99-1 1.7-2.36 1.6-3.8l1.01-.06c.14 2.1-1.08 4.04-2.68 5.3a13.52 13.52 0 0 1-7.6 2.73zm-11.17-6.7 1.01-.07c.11 1.88 1.51 3.4 3.08 4.28 2.12 1.2 4.6 1.61 7.02 1.47l.06 1.02c-3.07.18-6.33-.48-8.78-2.43a6.07 6.07 0 0 1-2.39-4.28zm10.27-8.04.07 1.02c-2.81.19-5.7 1.12-7.73 3.15-.99 1-1.7 2.37-1.6 3.8l-1 .06c-.15-2.11 1.1-4.07 2.71-5.33a13.54 13.54 0 0 1 7.55-2.7z'/%3e%3cpath fill='%23edb92e' d='m382.38 269.85 23.78 9.07-19.63 13.23c-5.09-1.7-9.12-19.12-4.15-22.3z'/%3e%3cpath fill='%2321231e' d='m405.98 279.4-23.78-9.07c.22-.27.15-1.17.63-.85l23.5 8.97c0 .4.35 1.08-.32.95h-.03zm.36-.95c.26.18 1.3.26.61.55-.49.5-.6.21-.6-.37l-.01-.18zm-20.09 13.27 19.63-13.22c.09.33.85.8.32 1l-19.39 13.07c-.62.3-.46-.41-.55-.8l-.01-.05zm.56.85zm-4.25-23.2c0 .3-.67 1.1-.07.93.31-.01-.56.46-.63.74-1.18 1.74-1.25 3.94-1.23 5.97a27.45 27.45 0 0 0 2.89 11.2c.76 1.36 1.66 2.84 3.17 3.45-.2.27-.11 1.2-.59.86-1.77-.82-2.84-2.6-3.7-4.28a28.55 28.55 0 0 1-2.78-11.48c-.02-2.24.17-4.7 1.6-6.53.37-.38.75-.9 1.34-.86zm-.45.05c.4-.26.55.06 0 0zm.27.43zm-.27-.43c.4-.26.55.06 0 0z'/%3e%3cpath fill='%230c4076' d='M382.83 274.26c5.62-.58 10.49 2.02 10.87 5.8.38 3.77-3.87 7.3-9.49 7.88-3.65.37-5.92-2.85-6.32-6.26-.4-3.42 1.09-7.02 4.94-7.42z'/%3e%3cpath fill='%2321231e' d='m394.21 280-1 .1c-.18-1.77-1.52-3.2-3.03-4.02a12.53 12.53 0 0 0-7.3-1.31l-.1-1.02c2.94-.29 6.06.18 8.55 1.84 1.5 1 2.7 2.57 2.88 4.41zm-9.94 8.44-.1-1.01c2.7-.3 5.45-1.28 7.39-3.25a5.2 5.2 0 0 0 1.65-4.08l1-.1c.2 1.96-.79 3.85-2.2 5.16-2.08 1.96-4.92 2.98-7.74 3.28zm-6.88-6.7 1-.12c.25 1.99 1.14 4.04 2.88 5.16.85.55 1.9.76 2.9.65l.1 1.01c-1.72.2-3.5-.46-4.68-1.73a8.68 8.68 0 0 1-2.2-4.98zm5.4-7.99.1 1.02a4.66 4.66 0 0 0-3.63 2.25 7.36 7.36 0 0 0-.86 4.6l-1 .11c-.26-2.22.22-4.68 1.83-6.33a5.71 5.71 0 0 1 3.55-1.65z'/%3e%3cpath fill='%23FFF' d='M457.46 280.42a3.2 3.2 0 0 1 3.2 3.22c0 1.77-1.44 3.21-3.2 3.21s-3.2-1.44-3.2-3.21a3.2 3.2 0 0 1 3.2-3.22z'/%3e%3cpath fill='%2321231e' d='M461.16 283.63h-1.01a2.71 2.71 0 0 0-2.69-2.7v-1.03a3.7 3.7 0 0 1 3.7 3.73zm-3.7 3.73v-1.02a2.7 2.7 0 0 0 2.69-2.7h1a3.74 3.74 0 0 1-3.69 3.72zm-3.7-3.73h1.01a2.71 2.71 0 0 0 2.69 2.7v1.03a3.7 3.7 0 0 1-3.7-3.73zm3.7-3.73v1.02a2.7 2.7 0 0 0-2.68 2.7h-1.02a3.75 3.75 0 0 1 3.7-3.72z'/%3e%3cpath fill='%23FFF' d='M408.71 283.14a3.2 3.2 0 0 1 3.2 3.22c0 1.77-1.44 3.21-3.2 3.21s-3.2-1.44-3.2-3.21a3.2 3.2 0 0 1 3.2-3.22z'/%3e%3cpath fill='%2321231e' d='M412.41 286.36h-1.01a2.71 2.71 0 0 0-2.69-2.7v-1.03a3.7 3.7 0 0 1 3.7 3.73zm-3.7 3.73v-1.02a2.7 2.7 0 0 0 2.69-2.7h1a3.74 3.74 0 0 1-3.69 3.72zm-3.7-3.73h1.01a2.71 2.71 0 0 0 2.69 2.7v1.03a3.7 3.7 0 0 1-3.7-3.73zm3.7-3.73v1.02a2.7 2.7 0 0 0-2.68 2.7H405a3.75 3.75 0 0 1 3.7-3.72z'/%3e%3cpath fill='%23FFF' d='M406.99 268.29c1.76 0 3.2 1.44 3.2 3.22s-1.44 3.21-3.2 3.21-3.2-1.44-3.2-3.21 1.44-3.22 3.2-3.22z'/%3e%3cpath fill='%2321231e' d='M410.69 271.51h-1.01a2.71 2.71 0 0 0-2.69-2.7v-1.03a3.7 3.7 0 0 1 3.7 3.73zm-3.7 3.73v-1.02a2.7 2.7 0 0 0 2.69-2.7h1a3.74 3.74 0 0 1-3.69 3.72zm-3.7-3.73h1.01a2.71 2.71 0 0 0 2.69 2.7v1.03a3.7 3.7 0 0 1-3.7-3.73zm3.7-3.73v1.02a2.7 2.7 0 0 0-2.68 2.7h-1.02a3.75 3.75 0 0 1 3.7-3.72z'/%3e%3cpath fill='%23FFF' d='M457.34 266.19a3.2 3.2 0 0 1 3.2 3.22 3.2 3.2 0 0 1-3.2 3.21 3.2 3.2 0 0 1-3.2-3.21 3.2 3.2 0 0 1 3.2-3.22z'/%3e%3cpath fill='%2321231e' d='M461.04 269.41h-1.01a2.71 2.71 0 0 0-2.69-2.7v-1.02a3.7 3.7 0 0 1 3.7 3.72zm-3.7 3.73v-1.02a2.7 2.7 0 0 0 2.69-2.7h1a3.75 3.75 0 0 1-3.69 3.72zm-3.7-3.73h1.01a2.71 2.71 0 0 0 2.7 2.7v1.03a3.7 3.7 0 0 1-3.7-3.73zm3.7-3.73v1.02a2.7 2.7 0 0 0-2.68 2.7h-1.02a3.74 3.74 0 0 1 3.7-3.72z'/%3e%3cpath fill='%23edb92e' d='M370.93 237.39c2.42-.74 6.2 4.64 7.1 4.54 1.18-3.07-1.24-10.43-5.54-16.25-2.92-.96-3.18-2.85-3.78-7.23-.18-1.31-2.68-.41-2.73 1.82-.05 2.39-.23 3.71.3 5.76.2.8.1 1.57-.8 2.3 4.55 1.82 5.67 4.05 5.45 9.06z'/%3e%3cpath fill='%2321231e' d='M377.56 241.75c.26.14.8.24.9.4-.24.27-.57.39-.88.18-1.07-.65-1.85-1.65-2.79-2.46-.94-.82-1.92-1.78-3.2-2.03-.4.07-.62 0-.66-.46-.25-.4-.05-.6.4-.56 1.41 0 2.58.97 3.62 1.83 1.04.87 1.92 1.93 3.01 2.74.23 0-.37.27-.4.36zm.94.37c-.04.45-.69.35-.1.08l.1-.08zm-6.16-15.96c.13-.28.18-.8.36-.93.5.4.78 1 1.16 1.51a31.9 31.9 0 0 1 4.7 10.7c.28 1.53.48 3.17-.06 4.68-.28-.15-.76-.21-.92-.42.5-1.62.15-3.34-.22-4.95a32.58 32.58 0 0 0-5.27-10.77l.25.18zm.32-.97zm-4.45-6.67c.32 0 .78-.2 1.02-.09.26 1.68.36 3.45 1.11 5a3.71 3.71 0 0 0 2.31 1.76c-.13.3-.17.79-.36.95a4.64 4.64 0 0 1-3.06-2.7c-.62-1.56-.76-3.27-1.02-4.92zm-1.71 1.76c-.32-.05-.8.06-1.01-.08.01-1.4 1.12-2.86 2.59-2.87.57 0 1.08.48 1.14 1.05-.33 0-.76.18-1.02.09-.15-.26-.56-.04-.76.07-.6.36-.94 1.05-.94 1.74zm.28 5.62c-.32.04-.75.28-1 .2-.53-1.9-.34-3.9-.3-5.84.32.05.8-.06 1.02.08-.04 1.86-.24 3.74.28 5.56zm-1.1 1.96c-.13.26-.28.82-.39.9.03-.3-.27-.73.01-.93.49-.4.7-1.08.5-1.68.31-.04.75-.28 1-.2a2.61 2.61 0 0 1-1 2.78l-.12-.87zm-.38.95c-.19-.16-1.03-.21-.62-.47.3-.3.6-.55.56.06l.06.41zm5.13 8.58h.96c-.29-.08-.87.13-.95-.14.06-2 .03-4.22-1.25-5.88-.98-1.25-2.45-1.97-3.89-2.56.16-.28.22-.77.43-.92 1.98.78 4.01 1.95 4.94 3.97.82 1.72.84 3.69.77 5.56l-1-.03zm1.01 0h-1c.2-.35.4-.63.72-.2l.28.2zm-1 0c-.27-.39.62-.68.18-.25l-.19.25z'/%3e%3cpath fill='%23edb92e' d='M368.78 218.51c-.42 1-.54 1.84-.64 3.37a4.77 4.77 0 0 0 1.09 3.23 10.3 10.3 0 0 0 3 2.52c.75.43 1.6 1.63 2.27 2.98a10.6 10.6 0 0 1 1.19 3.96c.1 3.58.79 6.7 2.42 7.32 1.06.4 1.49.34 2.31.15-.23-.64-.14-1.55-.72-2.45-.73-1.15-1.38-2.48-1.44-3.64-.05-.9-.48-1.51-.13-3.3.23-1.15.98-1.59.84-2.65-.25-2.06-1.87-6.02-4.24-6.02-2.35 0-3.44-.25-4.65-3.37-.41-1.06-.95-1.57-1.3-2.1z'/%3e%3cpath fill='%2321231e' d='M368.64 221.91c-.31-.06-.8.03-1-.12.07-1.18.2-2.38.67-3.48.28.16.76.24.91.45-.42 1-.52 2.08-.58 3.15zm.99 2.88c-.28.17-.58.55-.84.58a5.27 5.27 0 0 1-1.16-3.53c.31.06.8-.02 1 .13a4.32 4.32 0 0 0 1 2.82zm2.86 2.4c-.2.26-.33.73-.56.85a10.74 10.74 0 0 1-3.1-2.62c.27-.17.57-.55.83-.58a9.84 9.84 0 0 0 2.83 2.35zm2.46 3.2c-.3.1-.67.42-.93.4-.53-1-1.1-2.06-2.04-2.72.2-.26.33-.73.56-.85 1.1.76 1.8 2 2.41 3.16zm1.24 4.16c-.31-.03-.78.1-1-.03-.1-1.3-.59-2.52-1.14-3.68.3-.1.67-.43.93-.4a10.96 10.96 0 0 1 1.21 4.11zm2.1 6.86c-.15.29-.21.78-.41.93-1.3-.56-1.82-2.01-2.16-3.28a21 21 0 0 1-.54-4.48c.32.03.8-.1 1.02.03.08 1.96.2 4 1.09 5.78.23.42.53.84 1 1.02zm1.66.8c.28-.07.78-.34.92-.3-.18.27-.23.72-.64.7-.77.2-1.58.06-2.3-.24.15-.29.2-.77.4-.93a2.8 2.8 0 0 0 1.98.1l-.36.67zm.95-.34c.19.36.27.67-.25.64-.27.13.25-.56.25-.64zm-1.62-2 .85-.55c.52.75.54 1.69.77 2.55-.31.07-.72.34-.97.29-.24-.76-.2-1.61-.65-2.3zm-1.53-3.9 1.01-.05c.1 1.24.72 2.36 1.37 3.4-.29.14-.62.5-.88.5a8.57 8.57 0 0 1-1.5-3.85zm1.01-.05zm-1.12-3.36c.3.1.79.07.98.25-.21.9-.1 1.84.1 2.73.2.47-.26.4-.59.41-.37.13-.42-.08-.43-.4-.24-.98-.28-2-.06-3zm.83-2.5c.32 0 .78-.17 1.01-.07.17 1.03-.66 1.81-.85 2.76-.3-.1-.8-.07-.98-.25.1-.78.72-1.39.83-2.16v-.28zm-3.75-5.57c.04-.32-.07-.8.06-1.02 1.54.05 2.65 1.35 3.35 2.59a11.2 11.2 0 0 1 1.34 3.88c-.32 0-.77.17-1 .07a9.29 9.29 0 0 0-2.12-4.7c-.43-.44-.99-.82-1.63-.82zm-5.11-3.7.94-.37c.45 1.1.96 2.4 2.16 2.83.65.22 1.34.21 2.01.22-.03.32.08.8-.05 1.02-1.27.02-2.7-.12-3.6-1.13a7.9 7.9 0 0 1-1.46-2.57zm-.36-2.08c-.26-.13-.81-.3-.88-.4.31.04.78-.26.95.1.49.62.96 1.27 1.23 2.01-.31.08-.7.37-.96.32-.27-.73-.79-1.32-1.23-1.95l.89-.08zm-.94-.4c.15-.2.25-.9.43-.78.06.23.72.75.23.72l-.66.06zm.47.2zm-.47-.2c.15-.2.25-.9.43-.78.06.23.72.75.23.72l-.66.06z'/%3e%3cpath fill='%23edb92e' d='M359.96 227.08c.64-.5 1.4-.85 2.13-1.14a5.77 5.77 0 0 1 3.81-.17c5.61 1.7 8.07 11.67 1.92 14.07-1.21.15-2.33-.95-3.42-3.36-1.28-3.18-2.64-5.4-4.1-6.74-.9-1.13-.93-2.09-.34-2.66z'/%3e%3cpath fill='%2321231e' d='m361.91 225.47.37.95c-.7.28-1.4.6-2 1.06l-.62-.8c.67-.53 1.46-.9 2.25-1.21zm4.14-.18-.3.97a5.28 5.28 0 0 0-3.47.16l-.37-.95a6.3 6.3 0 0 1 4.14-.18zm1.84 15.05-.13-1c-.28.06.33-.16.42-.22a4.95 4.95 0 0 0 2.54-3.3 8.73 8.73 0 0 0-1.19-6.43 6.98 6.98 0 0 0-3.77-3.13l.29-.97a8.26 8.26 0 0 1 4.73 4.25 9.4 9.4 0 0 1 .77 7.06 5.88 5.88 0 0 1-3.31 3.61c-.12.05-.23.11-.35.13zm.12-.03zm-4.07-3.64c.3-.13.68-.24.93-.4.48 1.02 1 2.1 1.91 2.79.29.2.64.32.98.27l.13 1.01c-1.1.15-2.07-.6-2.69-1.45-.51-.68-.91-1.44-1.26-2.22zm0 .03zm-4.03-6.65.79-.63.38.37c1.73 1.85 2.84 4.18 3.8 6.5l-.94.38c-.9-2.2-1.96-4.41-3.6-6.18-.13-.15-.3-.29-.43-.44zm.05.06zm0-3.54v1.02c.2-.08.46-.23.21.03-.28.6.13 1.26.48 1.74.07.18-.34.3-.45.46-.2.22-.37.28-.49-.03-.55-.75-.91-1.83-.4-2.7a.99.99 0 0 1 .65-.52zm-.35.14c.16-.23.53-.13.1-.03-.04 0-.07.02-.1.03zm.35.88v-1.02l.31.91-.3.11zm.31-.1z'/%3e%3cpath fill='%23edb92e' d='M362.79 227.74c5.4-2.1 9.36 8.23 4.32 10.19-2.7 1.05-2.96-2.33-3.49-4.21-.7-2.54-6-3.96-.83-5.98z'/%3e%3cpath fill='%2321231e' d='m367.29 238.4-.37-.95c.8-.3 1.46-.97 1.73-1.78a5.82 5.82 0 0 0-.15-3.86 6.35 6.35 0 0 0-2.5-3.32 3.3 3.3 0 0 0-2.91-.32c-.21.13-.18-.24-.28-.36l-.2-.55c.81-.3 1.72-.4 2.57-.2a5.72 5.72 0 0 1 3.3 2.47 8.1 8.1 0 0 1 1.4 5.33 4.34 4.34 0 0 1-1.54 2.93c-.31.26-.68.45-1.05.61zm-4.16-4.55.98-.27c.32 1.14.44 2.36 1.05 3.4.23.4.68.7 1.16.63.2-.02.4-.09.6-.16l.37.95c-.74.3-1.65.36-2.31-.15-.82-.6-1.14-1.62-1.4-2.55-.16-.61-.28-1.24-.45-1.85zm-.53-6.59.37.95c-.65.28-1.36.53-1.83 1.08-.24.32.06.69.26.94.88.99 2.05 1.76 2.59 3.01.07.18.2.4-.09.4l-.77.21c-.3-.9-1.06-1.52-1.72-2.16-.56-.56-1.24-1.14-1.36-1.98-.09-.68.38-1.27.92-1.62.5-.35 1.07-.6 1.63-.83z'/%3e%3cpath fill='%230c4076' d='M363.35 229.27c2.63-1.02 6.24 5.14 2.95 6.54-2.22.94-3.98-.3-4.7-2.16-.7-1.86-.1-3.66 1.75-4.38z'/%3e%3cpath fill='%2321231e' d='m366.5 236.28-.4-.94c.47-.19.84-.59.95-1.08a3.67 3.67 0 0 0-.46-2.41 4.55 4.55 0 0 0-1.93-2.02 1.46 1.46 0 0 0-1.12-.08l-.37-.95a2.42 2.42 0 0 1 1.82.07c.93.4 1.67 1.17 2.2 2.01.57.9.97 1.95.93 3.02a2.63 2.63 0 0 1-1.62 2.38zm-5.36-2.44.94-.37a3.26 3.26 0 0 0 2.03 2.06c.66.2 1.37.08 2-.19l.39.94c-.96.42-2.1.51-3.08.08a4.39 4.39 0 0 1-2.28-2.52zm2.03-5.04.37.95c-.75.28-1.4.89-1.61 1.68-.2.67-.1 1.4.15 2.04l-.94.37a4.05 4.05 0 0 1 .1-3.4 3.66 3.66 0 0 1 1.93-1.64zm.18.47-.18-.47.18.47z'/%3e%3cpath fill='%23FFF' d='M400.08 179.66a6.4 6.4 0 0 1 6.37 6.41 6.4 6.4 0 0 1-6.37 6.42c-3.52 0-6.37-2.87-6.37-6.42s2.85-6.41 6.37-6.41z'/%3e%3cpath fill='%2321231e' d='M406.95 186.07h-1.01a5.93 5.93 0 0 0-5.86-5.9v-1.02a6.88 6.88 0 0 1 6.87 6.92zm-6.87 6.92v-1.02a5.87 5.87 0 0 0 5.86-5.9h1.01a6.96 6.96 0 0 1-3.26 5.89 6.85 6.85 0 0 1-3.61 1.03zm-6.88-6.92h1.02a5.93 5.93 0 0 0 5.86 5.9V193a6.88 6.88 0 0 1-6.88-6.92zm6.88-6.92v1.01a5.87 5.87 0 0 0-5.86 5.9h-1.02a6.96 6.96 0 0 1 3.26-5.88 6.85 6.85 0 0 1 3.62-1.04z'/%3e%3cpath fill='%23FFF' d='M395.43 169a6.4 6.4 0 0 1 6.37 6.42 6.4 6.4 0 0 1-6.37 6.41 6.4 6.4 0 0 1-6.37-6.41 6.4 6.4 0 0 1 6.37-6.42z'/%3e%3cpath fill='%2321231e' d='M402.31 175.42h-1.01a5.93 5.93 0 0 0-5.86-5.9v-1.03a6.88 6.88 0 0 1 6.87 6.93zm-6.87 6.92v-1.01a5.87 5.87 0 0 0 5.86-5.91h1.01a6.96 6.96 0 0 1-3.26 5.89 6.85 6.85 0 0 1-3.61 1.04zm-6.88-6.92h1.02a5.93 5.93 0 0 0 5.86 5.9v1.02a6.88 6.88 0 0 1-6.88-6.92zm6.88-6.93v1.02a5.87 5.87 0 0 0-5.86 5.91h-1.02a6.96 6.96 0 0 1 3.26-5.9 6.85 6.85 0 0 1 3.62-1.03z'/%3e%3cpath fill='%23FFF' d='M410.68 131.46c3.4 0 6.14 2.77 6.14 6.19s-2.75 6.18-6.14 6.18c-3.39 0-6.14-2.77-6.14-6.18s2.75-6.19 6.14-6.19z'/%3e%3cpath fill='%2321231e' d='M417.32 137.65h-1.01a5.7 5.7 0 0 0-5.64-5.68v-1.01a6.65 6.65 0 0 1 6.65 6.69zm-6.65 6.7v-1.02a5.64 5.64 0 0 0 5.64-5.68h1.01a6.72 6.72 0 0 1-3.15 5.7 6.6 6.6 0 0 1-3.5 1zm-6.64-6.7h1a5.7 5.7 0 0 0 5.64 5.68v1.02a6.65 6.65 0 0 1-6.64-6.7zm6.64-6.7v1.02a5.64 5.64 0 0 0-5.63 5.68h-1.01a6.72 6.72 0 0 1 3.12-5.67 6.6 6.6 0 0 1 3.52-1.03z'/%3e%3cpath fill='%23FFF' d='M400.36 136.18a6.4 6.4 0 0 1 6.37 6.41 6.4 6.4 0 0 1-6.37 6.42 6.4 6.4 0 0 1-6.37-6.42 6.4 6.4 0 0 1 6.37-6.41z'/%3e%3cpath fill='%2321231e' d='M407.23 142.59h-1.01a5.93 5.93 0 0 0-5.86-5.9v-1.02a6.88 6.88 0 0 1 6.87 6.92zm-6.87 6.93v-1.02a5.87 5.87 0 0 0 5.86-5.91h1.01a6.96 6.96 0 0 1-3.26 5.9 6.85 6.85 0 0 1-3.61 1.03zm-6.88-6.93h1.02a5.93 5.93 0 0 0 5.86 5.9v1.03a6.88 6.88 0 0 1-6.88-6.93zm6.88-6.92v1.01a5.87 5.87 0 0 0-5.86 5.91h-1.02a6.96 6.96 0 0 1 3.26-5.89 6.85 6.85 0 0 1 3.62-1.04z'/%3e%3cpath fill='%23FFF' d='M392.77 145.25a6.4 6.4 0 0 1 6.37 6.42 6.4 6.4 0 0 1-6.37 6.41 6.4 6.4 0 0 1-6.37-6.41 6.4 6.4 0 0 1 6.37-6.42z'/%3e%3cpath fill='%2321231e' d='M399.64 151.66h-1.01a5.93 5.93 0 0 0-5.86-5.9v-1.03a6.88 6.88 0 0 1 6.87 6.93zm-6.87 6.92v-1.01a5.87 5.87 0 0 0 5.86-5.9h1a6.96 6.96 0 0 1-3.25 5.88 6.85 6.85 0 0 1-3.61 1.04zm-6.88-6.92h1.02a5.93 5.93 0 0 0 5.86 5.9v1.02a6.88 6.88 0 0 1-6.88-6.92zm6.88-6.93v1.02a5.87 5.87 0 0 0-5.86 5.91h-1.02a6.96 6.96 0 0 1 3.26-5.9 6.85 6.85 0 0 1 3.62-1.03z'/%3e%3cpath fill='%23FFF' d='M391.54 156.66c3.52 0 6.37 2.87 6.37 6.41s-2.85 6.42-6.37 6.42-6.37-2.87-6.37-6.42 2.85-6.41 6.37-6.41z'/%3e%3cpath fill='%2321231e' d='M398.41 163.08h-1.01a5.93 5.93 0 0 0-5.86-5.9v-1.02a6.88 6.88 0 0 1 6.87 6.92zm-6.87 6.92v-1a5.87 5.87 0 0 0 5.86-5.91h1.01a6.95 6.95 0 0 1-6.87 6.92zm-6.88-6.92h1.02a5.93 5.93 0 0 0 5.86 5.9V170a6.88 6.88 0 0 1-6.88-6.92zm6.88-6.92v1.01a5.87 5.87 0 0 0-5.86 5.91h-1.02a6.96 6.96 0 0 1 3.26-5.89 6.85 6.85 0 0 1 3.62-1.04z'/%3e%3cpath fill='%23edb92e' d='M474.41 198.02c-2.7-5.03-5.57-8.25-8.6-9.65 4.18-13.16 5.16-30.15 2.7-51.1-.24-3.13-1.01-4.47-2.2-4.45-1.05.02-1.68 1.61-1.79 5.22.76 11.52 1.7 21.6 1.17 30.16-.47 7.65-2.26 14-4.24 21.16-.27 1 .44 1.77 3.87 3.71 2.54 1.44 4.14 3.22 4.67 5.07.74-.3 1.2-.2 1.47-.13 2.55.74 3.62.54 2.95 0v.01z'/%3e%3cpath fill='%2321231e' d='M465.33 188.22c1.38.84.31-.67 1.29-.01 3.76 2.12 6.2 5.88 8.23 9.57-.87.9-1.2.01-1.6-.78-1.9-3.21-4.2-6.49-7.65-8.16l-.27-.62zm.27.62zm2.41-51.52c1.13-.45 1.14.35 1.16 1.26 1.57 14.52 1.95 29.38-1.2 43.72a75.51 75.51 0 0 1-1.68 6.23c-1.23-.01-.86-.85-.54-1.68 3.9-13.53 4.09-27.82 3.03-41.78-.21-2.58-.47-5.17-.77-7.75zm0 .02zm-1.7-4c-.2-.77.05-1.33.83-.85 1.6.96 1.67 3.1 1.88 4.75-1.08.41-1.13-.34-1.16-1.22-.22-.9-.36-2.58-1.55-2.69zm-1.29 4.67c-1.02.36-1.15-.23-.95-1.1.17-1.51.17-3.41 1.52-4.4.74-.6.86.3.67.82-.93.47-.9 1.8-1.1 2.7-.08.6-.12 1.52-.14 1.98zm-1 .07zm2.17 30.16c-1.23.3-1.02-.67-.93-1.55.33-9.55-.66-19.09-1.25-28.61 1.2-.46 1.1.53 1.11 1.41.6 9.57 1.6 19.16 1.07 28.75zm-4.25 21.26c-1.2.03-.9-.78-.6-1.6 1.8-6.46 3.47-13 3.84-19.72 1.2-.3 1.05.6.91 1.46-.53 6.77-2.34 13.34-4.15 19.86zm3.63 3.13c-.24 1.06-.83.86-1.52.3-1.2-.83-3-1.55-3.16-3.2-.25-.79 1.26-.46 1.03.14.76 1.34 2.4 1.95 3.65 2.76zm0 0zm4.23 5.04c.77 1.02-.16 1.12-.45.18-.78-1.94-2.51-3.31-4.28-4.33.25-1.07.88-.83 1.55-.24 1.7 1.15 3.26 2.71 3.85 4.73l-.67-.34zm.37.95zm1.43-1.1c-.19.39-.06 1.17-.66.93-.38-.06-.89.42-.92-.21-.56-.66.24-.76.76-.8.27-.02.56 0 .82.09zm3.31.5c-1.5.4-.52-.77.11-.06.42.92-.86 1.21-1.52 1.02-.74-.09-1.47-.27-2.18-.47 0-1.1.65-.98 1.46-.68.45.1 1.14.18 1.47.15-.58 1.02.29.09.66.04zm-1 0c-.64-1.45 1.17-.7.44-.22l-.45.22zm0 0c1.32-.2.8.3.02.11l-.03-.1z'/%3e%3cpath fill='%23edb92e' d='M458.4 214.56c1.56-.99 1.87-.72 2.37-1.37.65-.83.66-2.2.46-3.5-.82-5.3 2.33-4.56 5.88-2.22 1.77 1.17 3.56 3.88 5.08 5.3 1.53 1.41 2.79 1.54 3.17 2.1.05 2.02.06 3.78.04 4.57.02.8 0 2.55-.04 4.57-.38.56-1.64.68-3.17 2.1-1.52 1.42-3.3 4.13-5.08 5.3-3.55 2.33-6.7 3.07-5.88-2.21.2-1.31.2-2.68-.46-3.51-.5-.65-.8-.39-2.37-1.37a6.96 6.96 0 0 1-2.28-2.25c-.51-.83-.24-1.73-.24-2.63 0-.9-.27-1.8.24-2.64.5-.83 1.26-1.6 2.28-2.24z'/%3e%3cpath fill='%2321231e' d='M460.37 212.87c1.19.43.47 1.23-.4 1.44-.7.32-1.65 1.06-1.79-.22.67-.52 1.58-.65 2.19-1.22zm.35-3.12c1.66-.73 1.09 1.77.96 2.69-.04.98-.97 1.26-1.22.3.51-.9.39-2 .26-2.99zm6.66-2.71c-.62 1.8-2.14-.6-3.31-.6-1.4-.85-2.82.38-2.47 1.87.22.82.12 1.75-.9 1.33-.2-1.46-.34-3.47 1.2-4.26 1.7-.62 3.4.43 4.84 1.25l.64.4zm5.15 5.35c-.83 1.6-1.77-.63-2.5-1.23-.98-1.17-1.95-2.38-3.2-3.27.56-1.72 1.84.37 2.55.95 1.07 1.17 2 2.45 3.15 3.55zm3.33 2.46c-.45-.08-1.04.08-1.06.2-.97-.6-2.08-1.02-2.87-1.85.46-1.56 1.54.22 2.43.43.52.34 1.35.53 1.5 1.22zm-.09-.28zm.13 4.86c-1.77.46-.73-1.92-1.02-2.9-.1-.87-.2-2.19.98-1.57.04 1.49.05 2.98.04 4.47zm-1.01 0zm0 0c.62 0 1.16.01.21.01h-.21zm0 .02v-.01zm.88 4.85c-.31-.46-1.06-.39-.91-.6.02-1.41.04-2.83.03-4.25 1.79-.48.75 1.96 1 2.95-.04.63.04 1.29-.12 1.9zm.09-.28zm-3.33 2.46c-1.49-.92.64-1.7 1.41-2.18.5-.59 1.72-.61 1.7.13-.94.82-2.25 1.08-3.11 2.05zm-5.15 5.35c-1.29-1.1.9-1.69 1.37-2.62 1.04-1.15 1.96-2.41 3.1-3.48 1.47.92-.72 1.83-1.15 2.77-1.01 1.2-2.02 2.43-3.32 3.33zm-6.66-2.72c1.64-.23.57 1.55.95 2.47.15 1.32 1.71 1.25 2.61.76.91-.22 1.9-1.17 2.6-1.23 1.15.93-.73 1.33-1.35 1.8-1.17.57-2.7 1.17-3.92.42-1.3-.98-1.07-2.8-.89-4.22zm-.35-3.11c1.18-1.53 1.58 1.17 1.47 2.07.35.94-.64 1.66-1.09.8.1-.96.2-2.04-.38-2.87zm-2.24-1.26c.39-1.5 1.66-.09 2.55.18 1.04.44-.5 1.52-.9.66-.59-.2-1.13-.5-1.65-.84zm.53-.86zm-2.98-1.55c1.1-1.22 1.55.88 2.54 1.25.94.27-.28 1.73-.78.68a7.12 7.12 0 0 1-1.76-1.93zm-.3-2.9c1.71-.47.51 1.54 1.16 2.37-1.1 1.23-1.4-.64-1.22-1.51l.05-.86zm.3-2.9c1.42.37.3 1.87.7 2.9-1.52.47-1.09-1.53-.93-2.42.06-.16.13-.33.23-.48zm2.44-2.4c1.2 1-.58 1.42-1.06 2.22-.2.83-1.19.73-1.28.01a7.59 7.59 0 0 1 2.34-2.24zm.54.86z'/%3e%3cpath fill='%2321231e' d='m475.52 220.24-.13.89a17.42 17.42 0 0 0-9.56 4.35c1.8-2.66 5.63-4.65 9.69-5.24zm0-1.6-.13-.89a17.43 17.43 0 0 1-9.56-4.35c1.8 2.66 5.63 4.65 9.69 5.24z'/%3e%3cpath fill='%23edb92e' d='M461.16 207.28c1.14.47 2.38.97 3.44 2 1.6 1.55.56 4.12-1.5 6.62-.66.78-.97 2.17-.97 3.56 0 1.38.33 2.76.96 3.52 2.07 2.5 3.1 5.07 1.5 6.63-1.04 1.02-2.29 1.52-3.43 1.99-.1-.6-.1-1.39.06-2.4.2-1.31.2-2.68-.45-3.51-.5-.65-.81-.38-2.38-1.37a7 7 0 0 1-2.28-2.24c-.5-.84-.23-1.74-.23-2.64 0-.9-.28-1.8.23-2.63.5-.84 1.27-1.6 2.28-2.25 1.57-.98 1.87-.72 2.38-1.37.65-.83.65-2.2.45-3.5a7.44 7.44 0 0 1-.06-2.41z'/%3e%3cpath fill='%2321231e' d='m464.95 208.9-.7.73a9.7 9.7 0 0 0-3.28-1.89l.38-.94c1.3.52 2.6 1.11 3.6 2.1zm-1.47 7.32-.77-.66c.98-1.23 1.98-2.6 2.16-4.2a2.09 2.09 0 0 0-.62-1.73l.7-.73c.99.9 1.13 2.4.71 3.62a11.37 11.37 0 0 1-2.18 3.7zm-.84 3.23h-1.01c.01-1.35.22-2.8 1.08-3.89l.77.66c-.68.9-.82 2.13-.84 3.23zm.84 3.2-.77.65c-.85-1.08-1.06-2.51-1.08-3.85h1c.03 1.1.18 2.3.85 3.2zm1.47 7.32-.7-.74c.84-.77.7-2.05.3-3a11.48 11.48 0 0 0-1.84-2.93l.77-.65c1.15 1.42 2.27 3.03 2.4 4.9.05.9-.28 1.8-.93 2.42zm-4.28 1.72 1-.19c-.14-.15-.9-.33-.54-.44a9.27 9.27 0 0 0 3.12-1.83l.7.74c-1 .99-2.3 1.58-3.6 2.1l-.68-.38zm.68.37c-.31.14-.7.41-.64-.14-.17-.49.42.1.64.14zm-.63-2.95 1 .16c-.1.74-.18 1.5-.06 2.23l-1 .19a8.25 8.25 0 0 1 .06-2.58zm-.35-3.11.8-.63c.82 1.11.74 2.6.55 3.9l-1-.16c.14-1.02.27-2.22-.35-3.11zm-2.24-1.26.53-.86c.64.45 1.4.67 2.07 1.06.16.15.63.4.26.57-.23.08-.51.63-.72.37-.48-.38-1.12-.5-1.64-.83l-.5-.3zm0 0-.08-.05c-.06 0 .11.05.08.05zm-2.45-2.4.86-.54a6.53 6.53 0 0 0 2.12 2.08l-.53.86a7.52 7.52 0 0 1-2.45-2.4zm0 0c.18.3.43.71.1.18l-.1-.18zm-.3-2.9h1c.03.78-.27 1.64.16 2.36l-.86.53c-.57-.87-.34-1.93-.3-2.9zm.3-2.9.86.53c-.42.72-.14 1.58-.16 2.36h-1c-.03-.97-.27-2.02.3-2.9zm2.45-2.42.53.87a6.53 6.53 0 0 0-2.12 2.07l-.86-.53a7.5 7.5 0 0 1 2.45-2.4zm2.24-1.25.8.63c-.53.73-1.51.8-2.21 1.3-.34.39-.46-.12-.65-.38-.38-.32.07-.45.34-.6.5-.35 1.14-.46 1.62-.83l.1-.12zm.35-3.12 1-.15c.19 1.3.27 2.78-.55 3.9l-.8-.63c.62-.9.49-2.1.35-3.12zm.44-1.97v-1.02c.16.29.6.5.46.86-.06.66 0 1.33.1 1.98l-1 .15a8.22 8.22 0 0 1-.05-2.57l.5.6zm0-1.02c.4-.03.77-.05.53.44.03.45-.41-.4-.53-.44zm0 0v1.02c-.4-.03 0-.58-.03-.85l.03-.17zM361 226.26l.68-.3c-1.54-2.14-1.88-4.2-1.29-6.26-1.3 1.64-.99 4.21.61 6.56z'/%3e%3cpath fill='%23edb92e' d='M410.74 199.91c1.33 1.69 1.17 2.09 1.89 2.57.94.63 2.22.41 3.4-.04 4.86-1.86 4.86 2 3.45 6.43-.68 2.14-2.76 4.47-3.68 6.3-.91 1.78-.71 3.12-1.12 3.57-1.76.3-3.28.51-3.97.59-.67.1-2.18.3-3.9.49-.57-.32-1.01-1.6-2.62-2.99-1.61-1.4-4.4-2.92-5.9-4.63-3.05-3.47-4.66-6.81.12-6.7 1.2.04 2.38-.18 2.92-1.04.42-.67.1-.97.51-2.93.27-1.28.74-2.3 1.35-3.04.61-.75 1.5-.58 2.33-.74.83-.15 1.59-.64 2.5-.18a8.35 8.35 0 0 1 2.72 2.34z'/%3e%3cpath fill='%2321231e' d='M412.91 202.06c-.24.18-.37.97-.7.75-.74-.6-1.01-1.58-1.64-2.29-.5-.37.25-.58.49-.86.27-.03.47.55.7.77.41.52.6 1.24 1.15 1.63zm-.56.85zm3.5-.95c.02.34.62.94.12 1.04-1.15.42-2.54.62-3.62-.09.25-.2.37-.92.7-.77.88.45 1.93.14 2.8-.18zm4.11 7.06c-.28-.2-1.14-.1-.88-.58.45-1.6.98-3.32.55-4.98-.2-.85-1.17-1.12-1.93-.95-.51.07-1 .23-1.49.4-.02-.34-.64-.96-.1-1.04 1.23-.45 2.84-.75 3.88.26 1.06 1.17.87 2.9.63 4.33-.16.87-.4 1.72-.66 2.56zm-3.7 6.38c-.25-.25-1.12-.29-.78-.71 1.11-2.03 2.75-3.77 3.52-5.98.26.2 1.09.1.89.53-.83 2.26-2.52 4.06-3.64 6.16zm-1.5 3.85c-.14-.27.05-1.23-.4-.87-.06-.02.14-.47.13-.66.16-.96.4-1.92.86-2.79.23.24 1.07.28.8.68-.51.98-.56 2.1-.88 3.12a.84.84 0 0 1-.5.52zm.3-.16zm-4.34.75c.07-.31-.13-1.01.08-1.03 1.27-.16 2.54-.36 3.8-.56-.05.32.41 1.02-.07 1.04-1.27.2-2.54.41-3.81.55zm.05 0zm.02 0-.11-.73c.06.7.02-.76.04-.08v.6c-.03-.68.02-.01.07.2zm-.16-1.01zm-4.07 1.43c.05-.3.8-.92.22-.94.29-.05.83-.1 1.21-.15.89-.1 1.77-.2 2.64-.34-.05.32.4 1-.05 1.04-1.26.17-2.53.36-3.79.44l-.23-.05zm.3.07zm-3-3.11c.28-.15.51-.97.82-.64.92.78 1.55 1.82 2.3 2.74.07.22-.31.81-.48.9-.8-.63-1.2-1.62-1.94-2.33a8.93 8.93 0 0 0-.7-.67zm-5.95-4.68c.31-.14.66-.92.94-.47 1.68 1.72 3.85 2.83 5.67 4.38-.29.17-.52 1-.86.6-1.89-1.54-4.1-2.69-5.75-4.51zm.52-7.54c-.12.3.21 1.06-.24 1.02-.75.03-1.72 0-2.2.7-.3.9.3 1.8.73 2.58.56.91 1.25 1.75 1.95 2.57-.31.13-.67.93-.94.46-1.17-1.42-2.44-2.9-2.81-4.74a2.02 2.02 0 0 1 1.45-2.35 6.17 6.17 0 0 1 2.06-.24zm2.47-.81c.19.25 1.01.38.75.7-.75.98-2.1 1.16-3.25 1.13.11-.31-.2-1.05.24-1.02.79-.02 1.78-.09 2.26-.81zm0 0zm.45-2.76c.26.17 1.04 0 .96.39-.24.85-.1 1.77-.39 2.6-.1.57-.52.04-.8-.1-.4-.12.07-.5-.04-.8.04-.7.12-1.4.27-2.09zm1.45-3.26c.16.26.88.47.69.77-.6.79-.94 1.74-1.15 2.7-.28-.17-1.12.02-.93-.46a7.43 7.43 0 0 1 1.39-3.01zm.78.65.34-.42-.34.42zm1.85-1.56c-.05.3.4.94.03 1.02-.64.12-1.42-.02-1.88.53-.17-.27-.98-.5-.63-.81.65-.69 1.63-.63 2.48-.74zm.19 1-.35.06.35-.06zm2.64-1.14c-.23.23-.26 1.02-.64.83-.68-.21-1.34.2-2 .3.04-.34-.46-1.03.08-1.06.83-.26 1.74-.53 2.56-.07zm2.99 2.8c-.3.09-1.2-.25-.92.25-.11-.07-.46-.54-.7-.75a7.14 7.14 0 0 0-1.83-1.4c.23-.22.27-1.04.65-.8 1.06.6 2 1.45 2.71 2.44l.09.25zm-.11-.33zm-.9.32c.2.03 1.14-.06.88.05-.34.02-.85.55-.88-.05zm.1.32z'/%3e%3cpath fill='%2321231e' d='m410.05 219.43-.8-.03a23.54 23.54 0 0 0-6.3-9.54c2.82 1.57 5.56 5.42 7.1 9.57zm1.38-.19.74-.24c-.5-4 .07-7.54 1.54-10.88-1.96 2.37-2.76 6.8-2.28 11.12z'/%3e%3cpath fill='%23edb92e' d='M418.3 201.97c-.18 1.42-.37 2.95-1.07 4.32-1.07 2.05-3.69 1.26-6.48-.7a4.82 4.82 0 0 0-3.48-.54c-1.24.22-2.38.79-2.88 1.61-1.6 2.64-3.51 4.12-5.31 2.61-1.2-1-2-2.29-2.75-3.47a5.03 5.03 0 0 1 2.09-.3c1.19.04 2.38-.18 2.91-1.04.43-.67.11-.97.52-2.92.27-1.29.74-2.31 1.34-3.05.62-.75 1.51-.58 2.34-.73.83-.16 1.59-.65 2.5-.19a8.35 8.35 0 0 1 2.72 2.34c1.32 1.68 1.16 2.09 1.89 2.58.94.62 2.21.4 3.4-.05a5.9 5.9 0 0 1 2.26-.47z'/%3e%3cpath fill='%2321231e' d='m417.68 206.53-.9-.47c.67-1.28.84-2.74 1.02-4.15l1 .13c-.18 1.53-.4 3.1-1.12 4.49zm-7.22-.52.58-.83c1.25.84 2.6 1.72 4.15 1.81.66.05 1.32-.32 1.6-.93l.89.47a2.68 2.68 0 0 1-2.7 1.47c-1.67-.15-3.17-1.06-4.52-1.99zm-3.1-.45-.18-1a5.3 5.3 0 0 1 3.86.62l-.58.83c-.9-.6-2.07-.62-3.1-.45zm-2.54 1.37-.86-.53c.7-1.1 2-1.62 3.22-1.85l.18 1c-.94.19-1.98.55-2.54 1.38zm-6.06 2.74.65-.78c.58.57 1.53.63 2.2.17a7.84 7.84 0 0 0 2.35-2.66l.86.53c-.83 1.33-1.83 2.74-3.36 3.31-.93.35-1.97.08-2.7-.57zm-2.63-4.33.4.93c.11-.16.14-.95.33-.58.73 1.15 1.49 2.31 2.55 3.2l-.65.78a14.78 14.78 0 0 1-2.86-3.6l.23-.73zm-.23.74c-.18-.28-.5-.6.03-.66.41-.26-.02.44-.02.64v.02zm2.53-1.08-.02 1.02c-.63 0-1.29 0-1.88.25l-.4-.94c.72-.3 1.53-.34 2.3-.33zm2.48-.8c.29.17.57.37.86.54-.7 1.09-2.1 1.3-3.3 1.28-.15-.17 0-.63-.04-.92.1-.22.61-.04.88-.13.59-.07 1.26-.24 1.6-.78zm0 0zm.45-2.76.99.21c-.22.83-.18 1.7-.33 2.53-.09.19-.17.73-.44.45-.17-.21-.8-.3-.58-.6.18-.7.1-1.46.28-2.17l.08-.42zm1.45-3.27.78.65a6.66 6.66 0 0 0-1.24 2.83l-.99-.21a7.62 7.62 0 0 1 1.45-3.27zm0 0c.21-.27.5-.6.11-.14l-.11.14zm2.63-.91.18 1c-.67.16-1.53-.04-2.03.56l-.78-.65c.57-.75 1.56-.82 2.42-.88.07 0 .14-.02.2-.03zm0 0c.26-.05.89-.17.29-.05l-.3.05zm2.82-.14-.45.91c-.72-.37-1.47.12-2.19.23l-.18-1c.86-.21 1.79-.62 2.66-.21l.16.07zm-.45.91zm3.34 1.57-.8.63a7.92 7.92 0 0 0-2.54-2.2l.45-.9a8.91 8.91 0 0 1 2.89 2.47zm1.77 2.47-.56.85c-.8-.53-1.06-1.51-1.65-2.22-.15-.24-.55-.5-.1-.67.25-.15.55-.65.72-.19.52.63.87 1.37 1.34 2.03.07.07.17.15.25.2zm-.56.85zm3.5-.96.36.96c-1.21.46-2.7.75-3.86 0l.56-.86c.9.56 2.03.24 2.94-.1zm2.95.08-1-.13c.09.2.74.66.22.58-.62.03-1.23.2-1.81.43l-.36-.96c.79-.29 1.62-.53 2.47-.5.15.2.32.4.48.58zm-.48-.57c.38-.04.68 0 .5.45.02.33-.4-.4-.5-.45z'/%3e%3cpath fill='%23edb92e' d='M391.76 221.18c.77-.94 1.08-.73 1.22-1.32.18-.77-.27-1.97-.85-3.1-2.33-4.58.15-4.2 3.51-2.4.86.47 1.84 1.28 2.83 2.11.99.85 1.97 1.73 2.8 2.32 1.66 1.2 2.7 1.24 3.18 1.72a141.54 141.54 0 0 1 1.6 4.2c.3.72.89 2.32 1.55 4.17-.1.52-1.07.66-1.78 1.98-.7 1.3-1.26 3.66-2.12 4.8-1.27 1.66-2.42 2.65-3.32 2.49-.9-.16-1.54-1.48-1.78-4.38a5.08 5.08 0 0 0-1.48-3.03c-.58-.55-.71-.32-2.15-1.13a9.26 9.26 0 0 1-2.34-1.87c-.63-.7-.72-1.47-1.02-2.24-.29-.78-.77-1.54-.7-2.27a3.8 3.8 0 0 1 .85-2.05z'/%3e%3cpath fill='%2321231e' d='M392.49 219.74c.28.12.83.09.97.3-.16.7-.95.9-1.31 1.47-.18-.26-.81-.47-.7-.75.27-.38.7-.61 1.02-.94l.02-.08zm.98.23zm-1.8-2.98c.3-.07.75-.58.96-.36.49 1.03 1.05 2.17.84 3.34-.28-.14-.87-.06-.97-.33.05-.94-.43-1.83-.82-2.65zm4.2-3.07c-.2.23-.28.9-.58.84-1.03-.5-2.09-1.13-3.26-1.13-.5.06-.27.73-.2 1.06.17.64.45 1.24.75 1.83-.3.06-.75.58-.96.35-.48-1.04-1.1-2.2-.83-3.38.27-.89 1.35-1.02 2.13-.8 1.04.25 2.02.73 2.96 1.23zm2.92 2.16c-.25.18-.47.81-.74.7-.85-.7-1.68-1.42-2.65-1.96.2-.23.3-.85.57-.85 1.02.58 1.92 1.36 2.82 2.11zm2.77 2.3c-.24.2-.4.8-.67.77-.96-.71-1.84-1.52-2.75-2.29.25-.17.47-.81.74-.7.89.75 1.74 1.53 2.68 2.22zm3.35 1.94c-.23.18-.95.2-.87.49.06.09-.4-.24-.57-.27-.88-.34-1.73-.77-2.5-1.33.24-.2.4-.86.69-.76.86.66 1.9.97 2.85 1.47.16.1.31.23.4.4zm-.11-.17zm1.73 4.39c-.3.05-.77.34-.98.27-.5-1.38-1.03-2.75-1.57-4.1.3-.04.8-.51.98-.27.54 1.36 1.08 2.72 1.57 4.1zm0-.01zm0-.01c-.23.17-.97.2-.87.47-.04.11.69.37.17 0a62 62 0 0 1-.22-.23c-.1 0 .22.57-.07-.06.1.34.69-.15.99-.16.07.37-.27-.61.02.15-.09-.07-.75-.75-.32-.32a46.5 46.5 0 0 1 .2.2c-.46-.37-.3-.36-.07-.27l.17.22zm-.17-.22zm1.73 4.69c-.28.02-.92-.36-.98-.08 0 .29-.22-.58-.31-.76-.4-1.09-.8-2.18-1.22-3.26.31-.06.74-.4.97-.3.53 1.39 1.06 2.78 1.53 4.18l.01.22zm-.02-.28zm-1.81 2.4c-.22-.22-.9-.3-.83-.6.38-.73 1.08-1.25 1.67-1.73.28.13.9.04.97.3-.3.74-1.18.97-1.57 1.64-.09.12-.17.25-.24.39zm-2.16 4.86c-.2-.25-.82-.43-.74-.72.91-1.43 1.22-3.14 2.01-4.63.22.21.9.3.83.6-.77 1.55-1.1 3.32-2.1 4.75zm-3.81 2.68c.12-.3.02-.87.27-1 .9-.1 1.51-.9 2.1-1.52.26-.19.45-.8.73-.7.15.23.88.4.59.7-.84 1.01-1.73 2.18-3.07 2.52-.2.04-.42.04-.62 0zm-2.2-4.84c.31.03.81-.17 1.02-.02.14 1.23.21 2.57.95 3.6.31.22.5.34.32.76.03.45-.2.61-.57.33-1.06-.65-1.3-2-1.53-3.12-.09-.51-.14-1.04-.19-1.55zm-1.32-2.7c.26-.17.5-.76.77-.66a5.56 5.56 0 0 1 1.56 3.28c-.3-.04-.85.2-1.01 0a4.55 4.55 0 0 0-1.32-2.62zm-2.05-1.05c.22-.22.31-.9.6-.83.69.44 1.56.55 2.14 1.14-.26.16-.5.78-.78.66-.55-.4-1.25-.52-1.82-.9l-.14-.07zm-2.47-1.97c.27-.16.55-.66.8-.62a8.77 8.77 0 0 0 2.17 1.7c-.21.22-.31.85-.59.83a9.75 9.75 0 0 1-2.38-1.91zm-1.11-2.41c.3-.05.75-.42.97-.28.25.68.38 1.45.89 2-.27.15-.56.71-.82.6-.58-.65-.76-1.52-1.04-2.32zm-.73-2.5c.3.07.77.01 1 .15 0 .72.44 1.33.67 1.99-.3.06-.73.38-.97.3-.3-.79-.8-1.57-.7-2.44zm1 .1zm.35-1.59c.03-.22-.07-1.08.05-.9.07.3.5.65.18.92a3.28 3.28 0 0 0-.58 1.57c-.3-.09-.85.03-1-.18.1-.82.43-1.6.96-2.24l.39.83zm0-1.02c.3.04.9-.07 1.03.05-.22.16-.52.87-.7.67l-.33-.72zm0 0v1.02c-.04-.3-.64-.82-.16-.94l.16-.08zm0 1.02c-.3-.04-.91.07-1.04-.05.23-.15.52-.87.7-.67l.34.72z'/%3e%3cpath fill='%2321231e' d='m406.51 226.13.22.94a8.8 8.8 0 0 0-3.64 1.76c-1 .81-1.8 1.86-2.42 3.12.22-1.4.91-2.64 1.93-3.64a8.82 8.82 0 0 1 3.9-2.18h.01zm-.59-1.68-.43-.93c-1.61-.14-3.17-.55-4.69-1.2a21.44 21.44 0 0 1-4.45-2.68 15.81 15.81 0 0 0 9.56 4.8h.01z'/%3e%3cpath fill='%23edb92e' d='M391.36 213.8c1 .37 1.66.82 2.8 1.77a4.53 4.53 0 0 1 1.52 2.94c.17 1.2.03 2.55-.3 3.89-.2.83.05 2.25.54 3.64a10.03 10.03 0 0 0 1.95 3.5c2.45 2.45 4.16 5.04 3.48 6.65a3.31 3.31 0 0 1-1.48 1.8c-.3-.6-.99-1.14-1.22-2.16-.3-1.31-.8-2.67-1.57-3.49-.6-.63-.73-1.35-2.22-2.27-.96-.6-1.78-.35-2.44-1.15-1.27-1.56-2.93-5.38-1.3-7.12 1.6-1.72 2.17-2.69.82-5.65-.46-1-.45-1.74-.58-2.35z'/%3e%3cpath fill='%2321231e' d='m394.49 215.17-.64.79a8.8 8.8 0 0 0-2.66-1.68l.35-.96a9.66 9.66 0 0 1 2.95 1.85zm1.7 3.27c-.33 0-.77.18-1.02.09a4.03 4.03 0 0 0-1.32-2.57l.64-.79c.98.8 1.53 2.03 1.7 3.27zm-.31 4.08-.98-.25c.3-1.2.45-2.45.28-3.69.32 0 .77-.18 1.01-.09a11 11 0 0 1-.31 4.03zm-.98-.25zm1.5 3.6c-.31.07-.72.33-.97.29-.4-1.25-.79-2.58-.53-3.89.3.12.78.12.97.3-.16 1.12.2 2.25.53 3.3zm1.84 3.31c-.25.2-.5.61-.76.68a10.6 10.6 0 0 1-2.03-3.65c.31-.07.71-.33.97-.29a9.56 9.56 0 0 0 1.82 3.26zm3.58 7.2c-.28-.16-.75-.24-.9-.45.3-1-.28-2-.78-2.85a18.87 18.87 0 0 0-2.62-3.18c.25-.2.5-.61.76-.68 1.43 1.48 2.87 3.07 3.55 5.05.21.68.28 1.45 0 2.11zm-2.4 1.82c.25-.15.78-.32.85-.46-.17-.1-.92-.1-.5-.3.54-.33.9-.88 1.12-1.46.28.16.76.25.91.46a3.9 3.9 0 0 1-1.64 1.96l-.74-.2zm.74.2c-.3.27-.59.44-.68-.08-.18-.27.53.1.68.08zm-2-2.46c.32-.03.75-.25 1-.17.18.77.82 1.3 1.17 1.99-.3.11-.66.39-.93.4-.46-.71-1.07-1.35-1.24-2.22zm-1.44-3.25.73-.7c.94 1.03 1.38 2.4 1.7 3.72-.32.04-.75.25-1 .18a7.3 7.3 0 0 0-1.43-3.2zm0 0zm-2.12-2.2.53-.86a6.5 6.5 0 0 1 2.15 2.16c.36.23-.11.42-.27.63-.24.4-.45.15-.63-.14a5.26 5.26 0 0 0-1.78-1.79zm-2.56-1.25.78-.65c.53.62 1.45.5 2.1.92.44.12-.1.5-.17.74-.1.43-.39.06-.64 0-.74-.22-1.58-.34-2.07-1.01zm-1.29-7.8.74.7c-.79.92-.56 2.25-.26 3.31.34 1.13.86 2.21 1.6 3.14l-.8.65a9.86 9.86 0 0 1-2.08-5.32c-.04-.89.19-1.82.8-2.47zm.74-5.08c.3-.1.68-.4.94-.38.6 1.33 1.14 2.92.45 4.32-.34.7-.87 1.28-1.39 1.84l-.74-.7c.75-.78 1.61-1.74 1.43-2.91a7.53 7.53 0 0 0-.7-2.17zm-.12-3.07v1.02c.15-.1.45-.78.52-.5.1.73.19 1.46.51 2.12-.3.1-.68.4-.94.38-.36-.76-.46-1.6-.59-2.4l.5-.62zm-.5.62c-.08-.34-.28-.78.26-.62.51-.08-.18.41-.26.61zm.5.4v-1.02c.37.03-.02.6.02.86l-.02.16zm0-1.02z'/%3e%3cpath fill='%23edb92e' d='M434.07 226.22c-1.28 1.1-1.6.88-1.96 1.55-.45.84-.24 2.13.15 3.33 1.54 4.76-1.36 4.34-4.84 2.52-1.73-.9-3.75-3.22-5.33-4.38-1.57-1.16-2.68-1.15-3.11-1.63-.44-1.88-.8-3.52-.94-4.28-.18-.75-.53-2.43-.9-4.41.22-.59 1.3-.86 2.38-2.46 1.08-1.62 2.16-4.64 3.57-6.1 2.87-3.02 5.76-4.31 5.92 1.47.04 1.4.29 2.82 1.04 3.59.59.6.83.3 2.47 1.1a7.21 7.21 0 0 1 2.53 2c.62.8.5 1.73.63 2.64.13.9.53 1.76.18 2.64-.36.87-.95 1.7-1.79 2.42z'/%3e%3cpath fill='%2321231e' d='M432.56 228.01c-.22-.22-.97-.3-.8-.63.46-.7 1.36-.9 1.92-1.5.18.04.77.62.61.82-.48.47-1.13.74-1.64 1.17-.04.04-.06.1-.09.14zm.18 2.93c-.33 0-.95.57-1.03.08-.33-1.12-.59-2.4-.04-3.5.25.26 1.06.3.79.74-.24.89.03 1.83.28 2.68zm-5.55 3.13c.24-.24.28-1.1.7-.78 1.14.53 2.35 1.19 3.63 1.06.77-.15.7-1.11.6-1.7-.07-.47-.2-.93-.34-1.4.34 0 .98-.58 1.04-.04.33 1.15.7 2.56-.12 3.6-.9.93-2.33.57-3.4.2-.73-.26-1.43-.59-2.11-.94zm-5.4-4.42c.27-.17.43-.98.76-.7 1.75 1.35 3.17 3.11 5.1 4.22-.24.24-.29 1.1-.7.77-1.92-1.16-3.38-2.94-5.15-4.29zm.6-.82zm-3.9-1.1c.26-.17 1.17-.04.86-.46.74.44 1.63.61 2.36 1.1.25.21.94.39.48.74-.22.38-.44.69-.8.26-.8-.58-1.8-.73-2.62-1.26a.82.82 0 0 1-.28-.38zm.11.22zm-.56-4.1c.08-.27-.2-1.28.21-.85.47.25.34.86.5 1.3l.72 3.2c-.33-.03-1 .48-1.04-.02-.31-1.34-.62-2.7-.89-4.05l.5.41zm0-1.03c.49-.31.68.76.23.2l-.23-.2zm-.5.62c.3 0 .86-.35 1-.11.07-.22-.53-.73-.5-.37-.1.2.23 1.07-.2.8-.2.12-.36-.72-.3-.32zm.99-.23zm-1.86-4.47c.31.01 1.02.64.97.08.28 1.47.56 2.94.89 4.4-.31-.03-.9.4-1.02.07-.3-1.44-.63-2.9-.86-4.34l.02-.2zm-.02.27zm2.45-2.84c.2.27 1.04.42.69.79-.55.84-1.39 1.41-2.13 2.07-.26.12-.67-.24-.99-.29.38-.82 1.34-1.15 1.88-1.85.2-.23.38-.46.55-.72zm3.62-6.17c.16.3.93.57.57.89-1.43 1.76-2.12 3.97-3.35 5.85-.21-.26-1.02-.4-.71-.77 1.2-1.96 1.93-4.24 3.5-5.97zm6.8 1.82c-.33-.1-1.1.28-1.02-.25-.09-1.04-.12-2.21-.85-3.03-.7-.56-1.6.02-2.22.42-.73.5-1.37 1.11-1.98 1.75-.16-.3-.97-.6-.53-.9 1.1-1.08 2.3-2.27 3.89-2.52 1.1-.15 2.02.77 2.3 1.77.3.89.38 1.83.4 2.76zm.89 3.24c-.28.13-.58.9-.85.57-.85-1.05-1-2.47-1.05-3.78.32.1 1.08-.28 1.02.22.07 1.03.17 2.2.88 3zm0 0zm2.33 1c-.23.24-.25 1.06-.65.82-.76-.45-1.78-.41-2.4-1.1.3-.15.57-.89.88-.58.64.32 1.38.43 2.02.79l.15.07zm2.71 2.15c-.29.1-.64.77-.89.5a6.82 6.82 0 0 0-2.26-1.73c.23-.24.26-1.07.65-.8.96.5 1.84 1.18 2.5 2.03zm-.8.63c.35.44.5.63.06.07l-.04-.05-.01-.02zm1.53 2.24c-.3-.06-.96.36-1.02 0-.1-.76 0-1.6-.5-2.24.3-.11.7-.85.93-.45.54.8.48 1.78.59 2.69zm.15 2.91c-.27-.22-1.08-.18-.87-.63.13-.72-.19-1.42-.28-2.13.3.04.92-.33 1.02 0 .2.9.5 1.86.13 2.76zm-1.93 2.62c-.12-.3-.83-.64-.51-.9a5.8 5.8 0 0 0 1.5-2.1c.24.2 1.03.19.86.56a6.93 6.93 0 0 1-1.85 2.44z'/%3e%3cpath fill='%2321231e' d='m417.9 222.59-.07-.87c3.2-.88 5.7-2.72 7.72-5.43-1.14 2.9-4.2 5.28-7.65 6.3zm.32 1.52.3.83a16.3 16.3 0 0 1 9.18 3.14c-2.06-2.34-5.82-3.83-9.48-3.97z'/%3e%3cpath fill='%23edb92e' d='M432.69 233.31c-1.09-.34-2.27-.69-3.36-1.53-1.67-1.29-1.18-3.78.24-6.35.46-.83.52-2.21.28-3.57-.24-1.36-.77-2.7-1.5-3.39-2.34-2.26-3.77-4.75-2.58-6.58.8-1.22 1.88-1.94 2.87-2.6.22.62.36 1.46.38 2.55.04 1.4.29 2.82 1.04 3.58.59.6.83.3 2.47 1.1a7.21 7.21 0 0 1 2.53 2c.62.8.49 1.74.63 2.64.13.9.53 1.76.17 2.64-.35.87-.94 1.7-1.78 2.42-1.28 1.1-1.6.89-1.96 1.55-.45.85-.24 2.13.15 3.34.3.91.43 1.64.42 2.2z'/%3e%3cpath fill='%2321231e' d='m429.01 232.18.62-.8a9.51 9.51 0 0 0 3.2 1.44l-.3.97c-1.24-.37-2.49-.8-3.52-1.61zm.11-7 .89.5c-.7 1.32-1.41 2.81-1.19 4.36.1.52.38 1.01.8 1.33l-.61.81c-1.14-.84-1.43-2.4-1.15-3.71.2-1.17.7-2.27 1.26-3.3zm.22-3.23 1-.18c.2 1.29.28 2.7-.33 3.9l-.89-.5c.49-.99.38-2.17.22-3.22zm-1.34-3.11.7-.74c.96.98 1.39 2.35 1.64 3.67l-1 .18a6.1 6.1 0 0 0-1.34-3.11zm0 0zm-2.66-7.24.84.56c-.7 1.07-.2 2.4.4 3.39.58.95 1.33 1.78 2.12 2.55l-.7.74c-1.36-1.35-2.72-2.9-3.11-4.83-.16-.82-.01-1.7.45-2.4zm3.77-2.48-.95.32c.16.13.94.17.62.36a8.53 8.53 0 0 0-2.6 2.36l-.84-.56c.74-1.16 1.88-2 3.01-2.74l.76.26zm-.76-.26c.3-.2.65-.58.68 0 .27.49-.42.02-.66 0h-.02zm1.17 2.96c-.32-.03-.78.1-1.01-.03-.03-.79-.1-1.59-.35-2.35l.96-.32c.29.87.37 1.79.4 2.7zm.89 3.24-.72.72c-.97-1.05-1.12-2.57-1.18-3.93.32.03.78-.1 1.01.03.06 1.09.13 2.33.89 3.18zm2.33 1-.44.92c-.68-.39-1.45-.51-2.15-.83-.2-.15-.66-.37-.26-.57.23-.11.44-.71.68-.37.57.3 1.25.38 1.83.7.11.04.23.1.34.16zm2.71 2.15-.8.63a6.76 6.76 0 0 0-2.35-1.86l.44-.91c1.04.5 2 1.23 2.71 2.14zm-.8.63c.17.22.59.75.2.24l-.2-.24zm1.53 2.24-1 .15c-.14-.8 0-1.7-.52-2.39l.8-.63c.66.81.6 1.9.72 2.87zm.14 2.91-.93-.38c.3-.79-.12-1.6-.21-2.38l1-.15c.17.96.55 1.96.14 2.91zm-1.92 2.62-.66-.78c.7-.6 1.3-1.36 1.65-2.22l.93.38a6.87 6.87 0 0 1-1.92 2.62zm-1.84 1.4-.9-.48c.4-.78 1.33-.97 1.9-1.55.28-.34.46.3.69.45.35.25-.25.43-.4.62-.38.35-.96.48-1.27.92l-.02.04zm.18 2.94-.96.31c-.36-1.19-.7-2.56-.11-3.73l.89.48c-.42.93-.09 2.01.18 2.94zm-.2 2.84.29-.97c-.2.06-.7.7-.66.29a7.44 7.44 0 0 0-.39-1.85l.96-.31c.25.76.46 1.56.45 2.37l-.66.47zm.65-.47c-.04.29.14.89-.34.57-.61-.06.07-.33.27-.53l.05-.03.02-.01zm-.5-.01c-.17.51-.17.52 0 0zm.5 0c-.04.3.14.9-.34.58-.61-.06.07-.33.27-.53l.05-.03.02-.01z'/%3e%3cpath fill='%23edb92e' d='M410.55 216.45c4.03-.2 7.91 3.32 8.49 7.63.57 4.31-2.25 7.66-6.1 7.7-3.87.05-7.45-3.1-8.19-7.27-.74-4.16 1.77-7.86 5.8-8.06z'/%3e%3cpath fill='%2321231e' d='m419.54 224.02-1 .13a8.48 8.48 0 0 0-6.37-7.06 6.48 6.48 0 0 0-1.6-.13c0-.34-.03-.68-.04-1.02 2.85-.13 5.57 1.46 7.22 3.72a9.5 9.5 0 0 1 1.79 4.36zm-6.6 8.28-.01-1.02a5.59 5.59 0 0 0 4.8-2.75c.78-1.3 1-2.88.8-4.38l1.01-.13a7.48 7.48 0 0 1-2.11 6.5 6.62 6.62 0 0 1-4.49 1.78zm-8.69-7.7 1-.17c.55 3.18 3.04 6.03 6.25 6.7.47.1.95.15 1.43.15l.01 1.02c-2.97.04-5.77-1.74-7.33-4.22a9.61 9.61 0 0 1-1.36-3.47zm6.28-8.66.05 1.02a5.52 5.52 0 0 0-4.57 2.75 6.92 6.92 0 0 0-.76 4.72l-1 .18a7.64 7.64 0 0 1 1.97-6.8 6.54 6.54 0 0 1 4.3-1.87z'/%3e%3cpath fill='%23edb92e' d='M410.89 218.57c2.94-.13 5.77 2.42 6.2 5.57.44 3.16-1.58 5.65-4.46 5.7-2.83.05-5.52-2.34-6.03-5.38-.54-3.1 1.35-5.76 4.29-5.89z'/%3e%3cpath fill='%2321231e' d='m417.59 224.07-1 .14a6.06 6.06 0 0 0-4.7-5.07 4.87 4.87 0 0 0-.98-.07l-.05-1.01a6.56 6.56 0 0 1 5.5 2.91 7.1 7.1 0 0 1 1.23 3.1zm-4.95 6.28-.02-1.02c1.39 0 2.75-.78 3.42-2 .55-.93.7-2.06.55-3.12l1-.14a5.7 5.7 0 0 1-1.43 4.78 5 5 0 0 1-3.52 1.5zm-6.55-5.8 1-.18a6.04 6.04 0 0 0 4.62 4.88c.3.05.6.08.91.08l.02 1.02a6.61 6.61 0 0 1-5.5-3.14 7.1 7.1 0 0 1-1.05-2.66zm4.77-6.5.05 1.02a3.94 3.94 0 0 0-3.28 1.95c-.59 1-.74 2.22-.54 3.35l-1 .17a5.73 5.73 0 0 1 1.44-5.04c.88-.89 2.1-1.4 3.33-1.44z'/%3e%3cpath fill='%230c4076' d='M411.22 220.72c1.84-.07 3.6 1.51 3.89 3.49.28 1.97-.99 3.57-2.8 3.6-1.8.04-3.5-1.46-3.81-3.4-.32-1.94.88-3.62 2.72-3.69z'/%3e%3cpath fill='%2321231e' d='m415.6 224.13-1 .15a3.63 3.63 0 0 0-2.8-3.01 2.89 2.89 0 0 0-.57-.05l-.04-1.01a4.33 4.33 0 0 1 3.63 1.96c.4.58.68 1.26.78 1.96zm-3.28 4.19-.02-1.02c.86 0 1.69-.53 2.05-1.3.27-.53.33-1.14.25-1.72l1-.15a3.73 3.73 0 0 1-1.12 3.35c-.58.53-1.37.82-2.16.84zm-4.33-3.83 1-.17a3.58 3.58 0 0 0 2.81 2.94c.17.03.33.04.5.04l.02 1.02a4.34 4.34 0 0 1-3.64-2.06 4.69 4.69 0 0 1-.69-1.77zm2.72-3.77h1l-.48.5a2.3 2.3 0 0 0-1.99 1.27 2.96 2.96 0 0 0-.25 1.83l-1 .17a3.78 3.78 0 0 1 1.05-3.4 3.3 3.3 0 0 1 2.15-.88l-.48.5zm1 0v.49l-.48.01.49-.5zm0 0h-1l.48-.51.53.5zm-1 0v-.5l.48-.01-.48.5z'/%3e%3c/g%3e%3cpath fill='%23FFF' d='M482.14 182.98a6.85 6.85 0 0 1 6.82 6.87c0 3.8-3.05 6.88-6.82 6.88a6.85 6.85 0 0 1-6.82-6.88c0-3.8 3.05-6.87 6.82-6.87z'/%3e%3cpath fill='%2321231e' d='M489.47 189.85h-1.01a6.39 6.39 0 0 0-6.32-6.36v-1.02a7.34 7.34 0 0 1 7.33 7.38zm-7.33 7.38v-1.02a6.33 6.33 0 0 0 6.32-6.36h1.01a7.41 7.41 0 0 1-3.7 6.42c-1.1.63-2.36.96-3.63.96zm-7.33-7.38h1.02a6.38 6.38 0 0 0 6.31 6.36v1.02a7.34 7.34 0 0 1-7.33-7.38zm7.33-7.38v1.02a6.33 6.33 0 0 0-6.31 6.36h-1.02a7.42 7.42 0 0 1 3.48-6.28 7.3 7.3 0 0 1 3.85-1.1z'/%3e%3cpath fill='%23FFF' d='M482.14 171.07a6.85 6.85 0 0 1 6.82 6.87c0 3.8-3.05 6.88-6.82 6.88a6.85 6.85 0 0 1-6.82-6.88c0-3.8 3.05-6.87 6.82-6.87z'/%3e%3cpath fill='%2321231e' d='M489.47 177.94h-1.01a6.39 6.39 0 0 0-6.32-6.36v-1.02a7.33 7.33 0 0 1 7.33 7.38zm-7.33 7.38v-1.02a6.33 6.33 0 0 0 6.32-6.36h1.01a7.41 7.41 0 0 1-3.7 6.42c-1.1.63-2.36.96-3.63.96zm-7.33-7.38h1.02a6.38 6.38 0 0 0 6.31 6.36v1.02a7.34 7.34 0 0 1-7.33-7.38zm7.33-7.38v1.02a6.33 6.33 0 0 0-6.31 6.36h-1.02a7.42 7.42 0 0 1 3.48-6.28 7.3 7.3 0 0 1 3.85-1.1z'/%3e%3cpath fill='%23FFF' d='M482.14 159.61c3.77 0 6.82 3.08 6.82 6.87s-3.05 6.88-6.82 6.88a6.85 6.85 0 0 1-6.82-6.88c0-3.8 3.05-6.87 6.82-6.87z'/%3e%3cpath fill='%2321231e' d='M489.47 166.49h-1.01a6.39 6.39 0 0 0-6.32-6.36v-1.02a7.33 7.33 0 0 1 7.33 7.38zm-7.33 7.38v-1.02a6.32 6.32 0 0 0 6.32-6.36h1.01a7.31 7.31 0 0 1-7.33 7.38zm-7.33-7.38h1.02a6.39 6.39 0 0 0 6.31 6.36v1.02a7.34 7.34 0 0 1-7.33-7.38zm7.33-7.38v1.02a6.33 6.33 0 0 0-6.31 6.36h-1.02a7.42 7.42 0 0 1 3.48-6.28 7.3 7.3 0 0 1 3.85-1.1z'/%3e%3cpath fill='%23FFF' d='M482.14 127.08a6.85 6.85 0 0 1 6.82 6.87c0 3.8-3.05 6.88-6.82 6.88a6.85 6.85 0 0 1-6.82-6.88c0-3.8 3.05-6.87 6.82-6.87z'/%3e%3cpath fill='%2321231e' d='M489.47 133.95h-1.01a6.39 6.39 0 0 0-6.32-6.36v-1.02a7.33 7.33 0 0 1 7.33 7.38zm-7.33 7.38v-1.02a6.33 6.33 0 0 0 6.32-6.36h1a7.41 7.41 0 0 1-3.66 6.4 7.3 7.3 0 0 1-3.66.98zm-7.33-7.38h1.02a6.39 6.39 0 0 0 6.31 6.36v1.02a7.33 7.33 0 0 1-7.33-7.38zm7.33-7.38v1.02a6.33 6.33 0 0 0-6.31 6.36h-1.02a7.42 7.42 0 0 1 3.48-6.28 7.3 7.3 0 0 1 3.85-1.1z'/%3e%3cpath fill='%23FFF' d='M482.14 137.16a6.85 6.85 0 0 1 6.82 6.87c0 3.8-3.05 6.88-6.82 6.88a6.85 6.85 0 0 1-6.82-6.88c0-3.8 3.05-6.87 6.82-6.87z'/%3e%3cpath fill='%2321231e' d='M489.47 144.03h-1.01a6.39 6.39 0 0 0-6.32-6.36v-1.02a7.34 7.34 0 0 1 7.33 7.38zm-7.33 7.38v-1.02a6.33 6.33 0 0 0 6.32-6.36h1a7.41 7.41 0 0 1-3.66 6.4 7.3 7.3 0 0 1-3.66.98zm-7.33-7.38h1.02a6.39 6.39 0 0 0 6.31 6.36v1.02a7.34 7.34 0 0 1-7.33-7.38zm7.33-7.38v1.02a6.33 6.33 0 0 0-6.31 6.36h-1.02a7.41 7.41 0 0 1 3.48-6.28 7.3 7.3 0 0 1 3.85-1.1z'/%3e%3cpath fill='%23FFF' d='M482.14 148.16a6.85 6.85 0 0 1 6.82 6.87c0 3.8-3.05 6.88-6.82 6.88a6.85 6.85 0 0 1-6.82-6.88c0-3.8 3.05-6.87 6.82-6.87z'/%3e%3cpath fill='%2321231e' d='M489.47 155.03h-1.01a6.39 6.39 0 0 0-6.32-6.36v-1.02a7.33 7.33 0 0 1 7.33 7.38zm-7.33 7.38v-1.02a6.33 6.33 0 0 0 6.32-6.36h1a7.41 7.41 0 0 1-3.66 6.4 7.3 7.3 0 0 1-3.66.98zm-7.33-7.38h1.02a6.39 6.39 0 0 0 6.31 6.36v1.02a7.33 7.33 0 0 1-7.33-7.38zm7.33-7.38v1.02a6.33 6.33 0 0 0-6.31 6.36h-1.02a7.42 7.42 0 0 1 3.48-6.28 7.3 7.3 0 0 1 3.85-1.1z'/%3e%3cpath fill='%23EDB92E' d='M486.99 195.51c.98 1.58.72 1.89 1.36 2.4.83.65 2.18.65 3.48.45 5.25-.83 4.52 2.35 2.2 5.93-1.16 1.78-3.86 3.58-5.26 5.12-1.4 1.53-1.53 2.8-2.08 3.19-2.02.05-3.75.06-4.54.04-.8.02-2.53 0-4.54-.04-.56-.38-.68-1.66-2.08-3.2-1.4-1.53-4.1-3.33-5.26-5.11-2.32-3.58-3.05-6.76 2.2-5.93 1.3.2 2.65.2 3.47-.46.65-.5.39-.81 1.37-2.39a7 7 0 0 1 2.22-2.3c.83-.51 1.72-.23 2.62-.23.9 0 1.78-.28 2.61.23a7 7 0 0 1 2.23 2.3z'/%3e%3cpath fill='%2321231e' d='M488.66 197.51c-.26.16-.45.92-.75.7-.65-.61-.74-1.58-1.26-2.28-.16-.28.63-.6.8-.62.46.64.66 1.41 1.07 2.07l.14.13zm-.62.8zm3.71-.45c-.05.33.42 1.05-.1 1.05-1.21.15-2.59.18-3.61-.6.25-.18.43-.87.74-.71.89.52 2 .4 2.97.26zm2.7 6.71c-.22-.27-1.08-.4-.7-.8.71-1.2 1.54-2.47 1.53-3.91-.04-.91-1.1-1.12-1.84-1.11a9.2 9.2 0 0 0-1.53.12c.05-.34-.43-1.08.12-1.05 1.28-.15 2.85-.26 3.8.8.87 1.13.35 2.65-.18 3.82-.34.74-.76 1.45-1.2 2.13zm-5.31 5.19c-.17-.3-1-.58-.55-.9 1.62-1.66 3.66-2.92 5.01-4.85.2.26 1.02.4.72.74-1.42 1.96-3.53 3.26-5.18 5zm-2.44 3.36c-.11-.3.22-1.2-.3-.94.51-.68.78-1.6 1.33-2.28.23-.23.48-.87.77-.74.2.29.9.54.4.87-.74.8-1.05 1.88-1.68 2.77a.84.84 0 0 1-.52.32zm.27-.1zm-4.82.14c.1-.29-.2-.99.15-1.02 1.46.01 2.92 0 4.37-.04-.1.32.28 1.1-.23 1.02-1.42.04-2.9.05-4.3.04zm0-1.02zm0 0v.88c0-.29-.03-.6 0-.88zm-.02 0h.01zm-4.81.89c.08-.3.88-.85.3-.93 1.48.03 3.02.06 4.51.04-.08.3.22.98-.14 1.02-1.48 0-2.98.02-4.46-.07l-.21-.06zm.27.09zm-2.44-3.36c.31-.14.65-.95.93-.49.77.82 1.18 1.88 1.73 2.84.14.27-.38.61-.49.92-.74-.63-.9-1.68-1.5-2.43-.2-.3-.43-.58-.67-.84zm-5.3-5.19c.32-.09.77-.8.99-.35 1.42 1.88 3.46 3.14 5.06 4.85-.3.14-.63.93-.92.5-1.68-1.7-3.77-3-5.14-5zm2.69-6.7c-.15.3.08 1.14-.43.96-.94-.09-2.05-.26-2.83.39-.57.74-.13 1.75.17 2.53.34.8.78 1.54 1.24 2.26-.33.1-.8.84-1 .32-.83-1.4-1.77-2.91-1.67-4.6.06-1.17 1.2-1.92 2.29-1.97.74-.08 1.5 0 2.23.1zm3.1-.36c.1.3.86.72.42.94-1.1.68-2.46.6-3.68.42.16-.3-.07-1.1.4-.97.94.1 2.04.2 2.85-.39zm1.24-2.26c.19.24.95.35.77.68-.56.74-.63 1.8-1.4 2.38-.1-.3-.8-.66-.47-.93.4-.65.6-1.41 1.04-2.04 0-.04.05-.06.06-.1zm0 0zm2.39-2.47c.07.3.69.74.38.96a6.62 6.62 0 0 0-1.92 2.05c-.2-.26-1.04-.37-.73-.74a7.4 7.4 0 0 1 2.27-2.27zm2.88-.3c-.1.3.2 1.01-.18 1-.73 0-1.51-.23-2.17.17-.07-.31-.77-.8-.33-.98.83-.44 1.78-.21 2.68-.2zm2.88.3c-.25.2-.34 1-.7.78-.7-.29-1.46-.05-2.18-.07.09-.3-.2-.97.15-1.02.92-.05 1.9-.23 2.73.31zm0 0zm1.96 3.25c-.05-.24.12-1.35-.13-.78-.18.48-.36.63-.59.1a6.25 6.25 0 0 0-1.77-1.7c.24-.2.35-1 .7-.76.9.6 1.65 1.43 2.22 2.36l-.43.78zm.43-.78c.1.28.83.93.13.78-.68.15-.53-.19-.22-.62l.09-.16zm-.43-.24c-.08.24.17 1.06-.12.95-.6-.13.03-.62.12-.95zm-.43.78c-.1-.3-.83-.93-.13-.78.72-.16.47.24.19.67l-.04.06-.02.05z'/%3e%3cpath fill='%2321231E' d='m481.35 212.77-.88-.13a17.67 17.67 0 0 0-4.33-9.63c2.65 1.8 4.62 5.67 5.21 9.76z'/%3e%3cpath fill='%23EDB92E' d='M494.21 198.3c-.47 1.15-.96 2.4-1.98 3.46-1.54 1.61-4.1.57-6.57-1.51-.78-.66-2.16-.98-3.54-.97-1.37 0-2.74.33-3.5.97-2.47 2.08-5.03 3.12-6.57 1.51-1.02-1.06-1.51-2.31-1.98-3.46.6-.11 1.38-.1 2.38.06 1.3.2 2.66.2 3.49-.45.64-.51.38-.82 1.36-2.4a6.97 6.97 0 0 1 2.22-2.3c.83-.51 1.73-.23 2.62-.23.9 0 1.79-.28 2.62.23a7 7 0 0 1 2.22 2.3c.98 1.58.72 1.89 1.36 2.4.83.65 2.18.65 3.48.45 1-.16 1.8-.17 2.39-.06z'/%3e%3cpath fill='%2321231e' d='m492.6 202.12-.73-.7c.9-.93 1.4-2.13 1.88-3.3l.93.38a10.7 10.7 0 0 1-2.08 3.62zm-7.26-1.48.65-.78c1.21.99 2.57 2 4.18 2.17.62.06 1.27-.15 1.7-.62l.73.71c-.9 1-2.39 1.14-3.6.72a11.24 11.24 0 0 1-3.66-2.2zm.64-.78.4.33-.4-.33zm-3.85-.07v-1.02c1.34.02 2.78.23 3.85 1.09l-.64.78c-.9-.69-2.12-.83-3.21-.85zm-3.18.85-.64-.78c1.07-.85 2.49-1.06 3.82-1.09v1.02c-1.1.02-2.29.17-3.18.85zm-7.26 1.48.73-.7c.76.84 2.04.7 2.99.3a11.31 11.31 0 0 0 2.9-1.86l.64.78c-1.4 1.15-3 2.29-4.86 2.42a3.05 3.05 0 0 1-2.4-.94zm-1.7-4.32.18 1c.14-.13.32-.9.44-.53a9.36 9.36 0 0 0 1.8 3.14c-.23.24-.48.47-.72.7a10.65 10.65 0 0 1-2.08-3.61l.38-.7zm-.38.7c-.13-.32-.4-.71.14-.65.49-.18-.1.42-.13.63l-.01.02zm2.93-.64-.16 1a7.06 7.06 0 0 0-2.21-.05l-.18-1a8.11 8.11 0 0 1 2.55.05zm3.1-.35.61.8c-1.1.83-2.58.74-3.87.56l.16-1.01c1.01.13 2.2.27 3.1-.35zm.61.8-.15.12.15-.12zm.62-3.06.86.54c-.46.64-.66 1.42-1.06 2.1-.16.18-.43.62-.59.2-.08-.24-.64-.51-.3-.71.36-.54.5-1.2.87-1.75l.22-.38zm2.4-2.47.52.87a6.53 6.53 0 0 0-2.06 2.14l-.86-.54a7.5 7.5 0 0 1 2.4-2.47zm2.87-.3v1.01c-.77.02-1.63-.27-2.35.16l-.52-.87c.86-.57 1.91-.34 2.87-.3zm2.89.3-.53.87c-.72-.43-1.58-.14-2.36-.16v-1.02c.97-.03 2.02-.26 2.89.3zm0 0zm2.39 2.47-.86.54a6.53 6.53 0 0 0-2.06-2.14c.17-.3.35-.58.53-.87a7.52 7.52 0 0 1 2.39 2.47zm1.24 2.26-.62.8c-.73-.54-.8-1.52-1.3-2.23-.38-.33.13-.46.38-.65.3-.36.43.03.58.3.35.52.46 1.18.84 1.68l.12.1zm-.62.8c-.39-.3-.38-.3 0 0zm3.71-.45.16 1c-1.3.2-2.77.28-3.87-.55l.62-.8c.88.62 2.08.49 3.1.35zm2.93.64-.93-.39c.03.2.6.8.17.66-.67-.07-1.35 0-2.01.1l-.16-1.01a8.1 8.1 0 0 1 2.56-.06l.37.7zm-.37-.7c.33.06.8.04.46.48-.11.5-.3-.3-.45-.46l-.01-.02zm-.1.5c.5.2.51.21.01 0zm.1-.5c.33.06.8.04.46.48-.11.5-.3-.3-.45-.46l-.01-.02z'/%3e%3cpath fill='%23EDB92E' d='M482.14 211.65c4.27 0 7.73 3.49 7.73 7.79s-3.46 7.79-7.73 7.79c-4.27 0-7.73-3.49-7.73-7.79s3.46-7.79 7.73-7.79z'/%3e%3cpath fill='%2321231e' d='m482.94 212.77.88-.13c.47-3.78 1.97-6.9 4.33-9.63-2.65 1.8-4.62 5.67-5.21 9.76z'/%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 964.29 0)'/%3e%3cpath fill='%23edb92e' stroke='%2321231e' stroke-width='1.01' d='M576.93 293.58c2 .3 3.06 1.57 3 2.86.06 1.3-1 2.56-3 2.86-.46.13-.97.22-1.53.27a1109.04 1109.04 0 0 1-186.51 0 8.72 8.72 0 0 1-1.53-.27c-2-.3-3.07-1.56-3-2.86-.07-1.3 1-2.56 3-2.86.45-.13.96-.22 1.53-.27a1109.17 1109.17 0 0 1 186.5 0 8.6 8.6 0 0 1 1.54.27z'/%3e%3cpath fill='%2321231e' d='M412.13 298.41c-.77-.03-.76-1.36 0-1.39.6.02 2.72-.21 3.92-.24 6.46-.38 12.93-.71 19.4-.98.66 2.12-2.21.98-3.43 1.36-3.7.17-7.39.35-11.08.56 4.85.26 9.7.5 14.56.7.56 2.14-2.08.8-3.25 1.07-6.7-.3-13.42-.65-20.12-1.08.07-.52-.04.05 0 0zm.04-.7zm46.62-2.63c.61 2.13-2.23.93-3.46 1.3-6.61.15-13.22.36-19.83.64-.66-2.12 2.21-.98 3.43-1.35 6.62-.26 13.24-.45 19.86-.59zm23.35-.22c.57 2.14-2.25.88-3.48 1.21-6.62.02-13.23.1-19.85.22-.61-2.12 2.24-.92 3.46-1.27 6.62-.11 13.25-.16 19.87-.16zm23.35.26c.52 2.15-2.27.83-3.5 1.14-6.62-.12-13.24-.18-19.85-.18-.58-2.14 2.25-.88 3.48-1.2 6.62.02 13.25.1 19.87.24zm23.34.74c.48 2.16-2.29.78-3.53 1.07-6.61-.26-13.23-.45-19.84-.6-.53-2.15 2.27-.83 3.5-1.13 6.63.16 13.25.38 19.87.66zm23.32 1.2c.35-.15.96.98.2 1.25-2.37.23-5.54.35-8.22.52-5.1.28-10.2.53-15.3.74-.67-2.1 2.2-.97 3.42-1.36 3.36-.15 6.72-.32 10.08-.5a1149 1149 0 0 0-13.56-.64c-.48-2.16 2.29-.78 3.53-1.06 6.62.3 13.24.65 19.85 1.06zm-.04.65zm-116.61.7c.78 0 .73 1.29-.05 1.22l.05-1.22zm93.33 1.16c-.78.07-.84-1.21-.06-1.2l.06 1.2zm-46.46-34.39-22.74 11.46-.45-.92 22.74-11.45h.45v.91zm-.45-.91.22-.11.23.1h-.45zm22.74 12.37-22.74-11.46.45-.91 22.74 11.45v.92h-.45zm.45-.92.9.46-.9.46v-.92zm-23.2 11.46 22.75-11.46.45.92-22.74 11.45h-.45v-.91zm.46.91-.23.11-.22-.11h.45zm-22.74-12.37 22.74 11.46-.45.91-22.74-11.46v-.9h.45zm-.45.91-.9-.45.9-.46v.91z'/%3e%3cpath fill='%230c4076' d='M482.14 269.15c5.65 0 10.23 3.08 10.23 6.87 0 3.8-4.58 6.88-10.23 6.88s-10.23-3.08-10.23-6.88 4.58-6.87 10.23-6.87z'/%3e%3cpath fill='%2321231e' d='M492.88 276.02c-.4-.08-1.17.25-1.03-.4-.24-2.32-2.25-3.98-4.27-4.87-1.7-.75-3.58-1.09-5.44-1.1.1-.37-.28-1.22.4-1 3.3.09 6.8 1.17 8.99 3.77a5.75 5.75 0 0 1 1.35 3.6zm-10.74 7.38c.1-.37-.28-1.21.4-1.02 3-.1 6.2-1.04 8.2-3.4a4.71 4.71 0 0 0 1.13-2.96c.38.08 1.2-.26 1 .4-.21 2.64-2.37 4.65-4.66 5.7a14.4 14.4 0 0 1-6.07 1.28zm-10.74-7.38c.4.08 1.18-.25 1.03.4.25 2.32 2.25 3.98 4.27 4.87 1.7.75 3.58 1.1 5.44 1.1-.1.37.28 1.22-.39 1-3.3-.09-6.81-1.17-9-3.77a5.75 5.75 0 0 1-1.35-3.6zm10.74-7.38c-.1.37.28 1.21-.4 1.02-3 .1-6.2 1.04-8.2 3.4a4.71 4.71 0 0 0-1.13 2.96c-.38-.08-1.2.26-1-.4.21-2.64 2.37-4.65 4.66-5.7a14.42 14.42 0 0 1 6.07-1.28z'/%3e%3cpath fill='%23edb92e' d='M482.14 211.65c4.27 0 7.73 3.49 7.73 7.79s-3.46 7.79-7.73 7.79c-4.27 0-7.73-3.49-7.73-7.79s3.46-7.79 7.73-7.79z'/%3e%3cpath fill='%2321231e' d='M490.38 219.44h-1.01a7.3 7.3 0 0 0-4-6.5c-.99-.52-2.1-.78-3.23-.78v-1.02a8.25 8.25 0 0 1 8.24 8.3zm-8.24 8.3v-1.02a7.24 7.24 0 0 0 7.23-7.28h1.01a8.33 8.33 0 0 1-4.09 7.17 8.17 8.17 0 0 1-4.15 1.13zm-8.23-8.3h1a7.3 7.3 0 0 0 4 6.5c1 .52 2.11.78 3.23.78v1.02a8.25 8.25 0 0 1-8.23-8.3zm8.23-8.3v1.02a7.24 7.24 0 0 0-7.22 7.28h-1.01a8.34 8.34 0 0 1 3.9-7.06 8.19 8.19 0 0 1 4.33-1.24z'/%3e%3cpath fill='%23edb92e' d='M482.14 213.71a5.7 5.7 0 0 1 5.68 5.73c0 3.16-2.54 5.73-5.68 5.73s-5.68-2.57-5.68-5.73a5.7 5.7 0 0 1 5.68-5.73z'/%3e%3cpath fill='%2321231e' d='M488.33 219.44h-1.01a5.24 5.24 0 0 0-5.18-5.22v-1.02a6.2 6.2 0 0 1 6.19 6.24zm-6.19 6.24v-1.02a5.19 5.19 0 0 0 5.18-5.22h1.01a6.27 6.27 0 0 1-2.9 5.29c-.98.62-2.13.95-3.29.95zm-6.2-6.24h1.02a5.24 5.24 0 0 0 5.18 5.22v1.02a6.2 6.2 0 0 1-6.2-6.24zm6.2-6.24v1.02a5.19 5.19 0 0 0-5.18 5.22h-1.01a6.18 6.18 0 0 1 6.2-6.24z'/%3e%3cpath fill='%230c4076' d='M482.14 215.83a3.6 3.6 0 0 1 3.58 3.6c0 2-1.6 3.61-3.58 3.61a3.6 3.6 0 0 1-3.58-3.6c0-2 1.6-3.61 3.58-3.61z'/%3e%3cpath fill='%2321231e' d='M486.23 219.44h-1.01a3.1 3.1 0 0 0-3.08-3.1v-1.02a4.09 4.09 0 0 1 4.09 4.12zm-4.08 4.12v-1.02a3.08 3.08 0 0 0 3.07-3.1h1.01a4.14 4.14 0 0 1-4.08 4.12zm-4.09-4.12h1.01a3.1 3.1 0 0 0 3.08 3.1v1.02a4.09 4.09 0 0 1-4.09-4.12zm4.09-4.12v1.02a3.08 3.08 0 0 0-3.08 3.1h-1.01a4.14 4.14 0 0 1 4.09-4.12zm.01 40.98c-43.82.22-67.8 2.12-101.63 5.29-2.02.19-3.09.9-3.5 1.21a3.4 3.4 0 0 0-1.22 3c.1.95 1.12 3.15 4.9 2.76 23.59-2.41 63.74-5.43 101.35-5.2 33.73.21 66.84 1.66 100.88 5.14 3 .3 4.78-.36 5.4-2.3.54-1.69-.43-3.15-1.9-3.86-2-.97-4.65-.95-8.4-1.28-31.18-2.76-67.33-4.9-95.88-4.76zm.12 1.09c28.75-.19 65.2 1.72 95.75 4.64 3.75.35 7.13.62 8 1.2 1.03.71 1.85 1.35 1.31 2.78-.33.9-1.04 1.8-4.28 1.46-33.25-3.55-67.8-4.95-100.9-5.13a951.23 951.23 0 0 0-101 5.13c-3.79.42-4.15-1.06-4.32-1.8-.2-.95.12-1.56 1.1-2.28.44-.32.76-.57 2.78-.77 30.67-3.07 57.72-4.94 101.56-5.23z'/%3e%3c/g%3e%3cpath fill='%23C6363C' d='M314.58 301.17v271.32c0 48.56 18.82 92.64 49.17 124.58s72.25 51.75 118.4 51.75c46.14 0 88.04-19.8 118.39-51.74 30.36-31.95 49.17-76.03 49.17-124.58V301.19H314.57z'/%3e%3cpath fill='%23FFF' d='M313.39 300c.2 94.24-.38 188.5.29 282.73 2.19 42.57 19.72 84.27 49.2 115.14 3.19-4.32-7.18-9.2-9.02-14.05-27.63-34.67-40.25-79.69-38.11-123.7V302.37h332.78c-.2 93.41.38 186.84-.29 280.25-2.85 67.34-47.2 132-111.11 155.15a158.13 158.13 0 0 1-55 9.88c1.15 5.44 12.2.64 17.23 1.43 63.88-6.28 119.6-53.78 140.58-113.74 11.26-28.96 11.56-60.35 10.95-90.95V300h-337.5z'/%3e%3cg fill='%23FFF' stroke='%2321231e' stroke-width='.99'%3e%3cpath d='M483.67 734.79c1.46-.24 3.91.07 5.77-1.4 2.47-1.94 1.49-9.78 1.27-14.74-1.14-25.36-2.18-68.04-3.47-127.97a16.7 16.7 0 0 0-5.1.07 16.68 16.68 0 0 0-5.08-.07c-1.3 59.93-2.33 102.62-3.47 127.97-.22 4.96-1.2 12.8 1.27 14.75 1.86 1.46 4.31 1.15 5.77 1.39h3.04z'/%3e%3cpath d='M499.55 734.06c-1.47-.1-3.89.42-5.87-.86-2.64-1.71-2.85-9.74-3.08-14.7-1.16-25.35-3.51-67.83-7.65-127.64 2.08-.48 3.62-.47 5.08-.38l.7-.16c9.52 59.16 13.12 101.14 19.64 126.46.9 3.5 2.84 12.25-.17 15.1-1.72 1.62-4.2 1.54-5.62 1.9l-3.03.28z'/%3e%3cpath d='M518.2 731.39c-1.48.03-3.84.77-5.93-.33-2.78-1.46-2.66-9.47-3.9-14.28-6.53-25.32-10.12-67.3-19.65-126.5 2.02-.66 3.56-.8 5.02-.84l.2-.07c15.16 57.54 19.7 98.1 31.46 123.15 1.09 3.47 4.05 12.7 1.22 15.9-1.57 1.78-4.04 1.92-5.43 2.42l-2.99.55z'/%3e%3cpath d='M536.98 726.08c-1.46.17-3.93 1.54-6.12.65-2.91-1.18-3.37-9.75-5.46-14.2-11.82-25.18-16.35-65.99-31.66-123.95a16.73 16.73 0 0 1 4.91-1.34c1.33-.6 1.08-.92 3.19-1.23 17.8 57.24 23.58 97.06 40.37 121.76 2.7 3.99 4.69 11.98 2.85 14.53-1.38 1.92-3.83 2.3-5.16 2.94l-2.92.84zm-72.23 7.98c1.47-.1 3.89.42 5.87-.86 2.64-1.71 2.85-9.74 3.08-14.7 1.17-25.35 3.51-67.83 7.65-127.64a16.72 16.72 0 0 0-5.08-.38l-.7-.16c-9.52 59.16-13.12 101.14-19.64 126.46-.9 3.5-2.84 12.25.17 15.1 1.72 1.62 4.2 1.54 5.62 1.9l3.03.28z'/%3e%3cpath d='M446.09 731.39c1.47.03 3.84.77 5.93-.33 2.77-1.46 2.66-9.47 3.9-14.28 6.53-25.32 10.12-67.3 19.66-126.5-2.03-.66-3.57-.8-5.03-.84l-.2-.07c-15.16 57.54-19.7 98.1-31.46 123.15-1.08 3.47-4.05 12.7-1.21 15.9 1.56 1.78 4.03 1.92 5.42 2.42l2.99.55z'/%3e%3cpath d='M427.31 726.08c1.46.17 3.93 1.54 6.12.65 2.91-1.18 3.37-9.75 5.47-14.2 11.8-25.18 16.34-65.99 31.65-123.95a16.73 16.73 0 0 0-4.91-1.34c-1.33-.6-1.08-.92-3.19-1.23-17.8 57.24-23.58 97.06-40.36 121.76-2.71 3.99-4.7 11.98-2.86 14.53 1.38 1.92 3.83 2.3 5.16 2.94l2.92.84zm99.74-43.24c-1.34.08-3.36.9-5.46-.1-2.8-1.34-4.63-9.07-6.13-13.88-11.92-23.54-22.8-65.34-40.63-123.45 1.73-.73 3.1-.91 4.43-1.01 1.18-.52 2.45-.99 4.38-1.16 19.21 57.5 27.84 99.07 46.62 121.97 3.1 3.78 5.4 12.02 3.93 14.41-1.1 1.8-3.33 2.03-4.51 2.57l-2.63.65z'/%3e%3cpath d='M511.85 685.82c-1.34-.03-3.45.63-5.43-.54-2.63-1.55-3.56-9.4-4.5-14.3-4.8-25.05-13.66-67.1-26.24-126.12 1.8-.59 3.2-.66 4.53-.65 1.23-.42 2.55-.8 4.49-.81 14.87 58.66 18.3 102.58 32.37 125.13 2.57 4.1 4 12.4 2.26 14.66-1.3 1.7-3.56 1.75-4.79 2.2l-2.7.43z'/%3e%3cpath d='M496.38 687.58c-1.33-.13-3.5.35-5.34-.97-2.44-1.76-2.46-9.64-2.83-14.6-1.9-25.31-5.88-67.87-11.62-127.63 1.86-.44 3.26-.4 4.58-.3a13.5 13.5 0 0 1 4.57-.44c8.05 59.58 12.73 102.71 17.83 127.14 1.02 4.88 2.55 12.67.56 14.78-1.5 1.59-3.74 1.46-5.02 1.8l-2.73.22z'/%3e%3cpath d='M437.24 682.84c1.34.08 3.36.9 5.46-.1 2.8-1.34 4.63-9.07 6.13-13.88 11.92-23.54 22.8-65.34 40.63-123.45-1.73-.73-3.1-.91-4.43-1.01a13 13 0 0 0-4.38-1.16c-19.21 57.5-27.84 99.07-46.62 121.97-3.1 3.78-5.4 12.02-3.93 14.41 1.1 1.8 3.33 2.03 4.51 2.57l2.63.65z'/%3e%3cpath d='M452.44 685.82c1.34-.03 3.45.63 5.43-.54 2.63-1.55 3.56-9.4 4.5-14.3 4.8-25.05 13.66-67.1 26.24-126.12-1.8-.59-3.2-.66-4.53-.65a13.31 13.31 0 0 0-4.49-.81c-14.87 58.66-18.3 102.58-32.38 125.13-2.56 4.1-4 12.4-2.25 14.66 1.3 1.7 3.55 1.75 4.79 2.2l2.69.43z'/%3e%3cpath d='M467.92 687.58c1.33-.13 3.5.35 5.34-.97 2.44-1.76 2.46-9.64 2.84-14.6 1.9-25.31 5.87-67.87 11.61-127.63-1.86-.44-3.26-.4-4.58-.3a13.51 13.51 0 0 0-4.57-.44c-8.05 59.58-12.73 102.71-17.83 127.14-1.02 4.88-2.55 12.67-.56 14.78 1.5 1.59 3.74 1.46 5.02 1.8l2.73.22z'/%3e%3cpath d='M483.52 688.09c1.31-.24 3.53.07 5.2-1.4 2.23-1.93 1.35-9.78 1.15-14.74-1.03-25.36-1.96-68.04-3.13-127.98a13.6 13.6 0 0 0-4.6.07c-1.3-.21-2.68-.36-4.59-.07-1.16 59.94-2.1 102.62-3.12 127.98-.2 4.96-1.08 12.8 1.14 14.75 1.68 1.46 3.9 1.15 5.2 1.39h2.75z'/%3e%3cpath d='M516.54 647.97c-1.03.08-2.57.9-4.19-.1-2.14-1.34-3.54-9.07-4.69-13.88-9.12-23.54-17.45-65.34-31.12-123.45a8.18 8.18 0 0 1 3.4-1c.9-.53 1.87-1 3.35-1.17 14.72 57.5 21.33 99.07 35.7 121.97 2.38 3.78 4.15 12.02 3.02 14.41-.85 1.8-2.56 2.03-3.46 2.57l-2.01.65z'/%3e%3cpath d='M504.9 650.96c-1.03-.03-2.64.63-4.16-.54-2.01-1.55-2.72-9.4-3.44-14.3-3.68-25.05-10.47-67.1-20.1-126.12a8.1 8.1 0 0 1 3.46-.65 8.13 8.13 0 0 1 3.44-.81c11.4 58.66 14.03 102.58 24.8 125.13 1.97 4.1 3.06 12.4 1.73 14.66-1 1.7-2.72 1.75-3.67 2.2l-2.06.43z'/%3e%3cpath d='M493.05 652.72c-1.02-.14-2.68.35-4.09-.97-1.87-1.76-1.89-9.64-2.17-14.6-1.45-25.31-4.5-67.87-8.9-127.63 1.43-.44 2.5-.4 3.51-.3a8.06 8.06 0 0 1 3.5-.44c6.17 59.58 9.75 102.71 13.66 127.14.78 4.88 1.95 12.67.43 14.78-1.15 1.59-2.87 1.46-3.85 1.8l-2.09.22z'/%3e%3cpath d='M447.75 647.97c1.03.08 2.57.9 4.19-.1 2.14-1.34 3.54-9.07 4.69-13.88 9.12-23.54 17.45-65.34 31.12-123.45a8.18 8.18 0 0 0-3.4-1 8.25 8.25 0 0 0-3.35-1.17c-14.72 57.5-21.33 99.07-35.7 121.97-2.38 3.78-4.15 12.02-3.02 14.41.85 1.8 2.56 2.03 3.46 2.57l2.01.65z'/%3e%3cpath d='M459.39 650.96c1.03-.03 2.64.63 4.16-.54 2.01-1.55 2.72-9.4 3.44-14.3 3.68-25.05 10.47-67.1 20.1-126.12a8.09 8.09 0 0 0-3.46-.65 8.13 8.13 0 0 0-3.44-.81c-11.4 58.66-14.03 102.58-24.8 125.13-1.97 4.1-3.07 12.4-1.73 14.66 1 1.7 2.72 1.75 3.67 2.2l2.06.43z'/%3e%3cpath d='M471.25 652.72c1.02-.14 2.68.35 4.09-.97 1.87-1.76 1.89-9.64 2.17-14.6 1.46-25.31 4.5-67.87 8.9-127.63a8.05 8.05 0 0 0-3.51-.3 8.05 8.05 0 0 0-3.5-.44c-6.17 59.58-9.75 102.71-13.66 127.14-.78 4.88-1.95 12.67-.43 14.78 1.15 1.59 2.87 1.46 3.85 1.8l2.09.22z'/%3e%3cpath d='M483.2 653.23c1-.24 2.7.07 3.99-1.4 1.7-1.93 1.03-9.78.87-14.74-.78-25.36-1.5-68.04-2.4-127.98a8.02 8.02 0 0 0-3.51.08c-1-.22-2.06-.37-3.52-.08-.9 59.94-1.6 102.62-2.4 127.98-.15 4.96-.82 12.8.88 14.75 1.29 1.46 2.98 1.15 3.99 1.39h2.1z'/%3e%3cpath d='M474.88 559.13c-.08 4.25-.13 9.02-.16 13.91l-.05.02-10.59 2.2c-.02 4.83 11.92 55.43 18.07 55.43s18.08-50.63 18.06-55.46l-10.59-2.17-.05-.02c-.03-4.9-.08-9.66-.16-13.91-2.22 1.85-4.68 5.07-7.26 7.98-2.6-2.9-5.04-6.13-7.27-7.98z'/%3e%3c/g%3e%3cg id='c'%3e%3cpath fill='%23EDB92E' stroke='%2321231E' stroke-width='.99' d='M412.13 584.52c-3.2.14-7.13 1.97-18.6 11.94-5.02 10.24-10.06 20.53-17.03 29.41-2.37 1.57-4.23 2.67-6.12 3.3-1.96.64-16.43.16-16.79-.45-4.5-4.09-11.38-1.17-9.08 3.14-1.79 1.7 2.14 7.9 5.3 5.32 2.9-2.36 12.98-.13 16.34-1.35-1.27 3.03-10.38 5-16.75 5.47-5.82.25-5.44 6.06-3.04 10.52 2.73 1.74.5-.46 1.48.82 2.6 3.87 8.18 3.36 8.37-.42.2-3.92 13.79-9.01 15.83-12.02-2.5 5.95-8.24 11.5-11.1 17.31-3.06 3.09-4.93 3.7-.96 9.92 4.4-.5 4.65-1.68 7.36.89 6.01-.66 6.98-2.45 6.01-7.21-1.03-5.04 3.18-14.14 4.58-16.71 1.29-2.38 1.6-4.84 2.86-6.33 2.18-2.58 12.57-7.75 15.23-6.33 4.9 2.61 8.64 1.03 9.25-3.72-1.58-1.22-.4-7.97-3.78-8.25-2.77-.24-4.41.62-6.96 2.7-4 3.28-6.07 5.03-7.39 4.66-3.12-.86 5.67-5.18 13.66-15.68 11.08-14.55 11.84-21.95 11.33-26.93z'/%3e%3cuse xlink:href='%23b' transform='matrix(-1 0 0 1 801.63 0)'/%3e%3cpath fill='%23EDB92E' stroke='%2321231E' stroke-width='.99' d='M345.18 634.54c-4.01-2.35-6.32-2.26-7.87-.5-.86.95-1.95.46-1.31-1.06 2.66-6.3 6.92-7.1 10.74-4.14 1.07 1 1.93 1.85 2.79 2.7-.64.94-3.83 2.27-4.35 3zm57.46-5.65c4.26-2.9 8.25-3.47 10.44-1.84 1.2.9 2.39.25 1.33-1.23-4.42-6.22-9.6-6.54-13.5-3.03-1.06 1.15-1.9 2.13-2.75 3.1 1.34 1.47 4.3 3.12 4.48 3zm-33.55 35.66c.13-.26-.98-5.44-2.71-7.06-1.35 1.08-2.86 2.04-4.29 3.52-4.26 4.46-4.24 11.01 2.42 16.73 1.64 1.41 2.39-.07 1.72-1.7-1.13-2.77.25-6.32 2.86-11.5zm-16.62-13.62c-3.96 1.64-5.32 3.73-5.18 6.46.08 1.5-.9 2.07-1.46.32-4.84-11.24.18-13.35 7.43-12.94.41 1.96-.62 6.09-.8 6.16h.01z'/%3e%3cpath fill='%2321231e' d='m383.95 621.26 1.01.61c-.32.51-.34 1.18-.06 1.71a4.8 4.8 0 0 0 1.93 1.8l-.6 1.03a5.9 5.9 0 0 1-2.39-2.3 2.9 2.9 0 0 1 .11-2.85zm6.5.82-.74.92c-.81-.65-1.6-1.34-2.5-1.85-.4-.2-.87-.43-1.31-.26-.43.2-.7.6-.94.98l-1.01-.6c.4-.66.93-1.31 1.69-1.54.7-.22 1.43 0 2.05.33.95.52 1.77 1.23 2.62 1.9l.15.12z'/%3e%3cpath fill='%2321231e' d='m387.33 617.58 1.01.61c-.32.51-.34 1.18-.06 1.71.41.8 1.17 1.35 1.93 1.8l-.6 1.03a5.9 5.9 0 0 1-2.39-2.3 2.9 2.9 0 0 1 .11-2.85zm6.5.82-.74.92c-.81-.65-1.6-1.34-2.5-1.85-.4-.2-.87-.43-1.31-.26-.43.2-.7.6-.94.98l-1.01-.6c.4-.66.92-1.3 1.67-1.53.7-.23 1.46 0 2.08.33.97.53 1.8 1.25 2.67 1.94l.09.07z'/%3e%3cpath fill='%2321231e' d='m390.88 612.83 1.06.55c-.43.8-.4 1.8 0 2.61a6.08 6.08 0 0 0 2.1 2.26l-.68.98a6.8 6.8 0 0 1-2.68-3.17 4.07 4.07 0 0 1 .2-3.23zm7.14 1.1-.82.87c-.89-.83-1.74-1.72-2.76-2.4-.38-.25-.84-.52-1.31-.4-.52.2-.81.71-1.08 1.16-.06.15-.12.28-.27.14l-.9-.47c.4-.75.89-1.52 1.68-1.89a2.3 2.3 0 0 1 1.99.14c.97.5 1.76 1.25 2.55 1.98l.92.87z'/%3e%3cpath fill='%2321231e' d='m394.82 607.72 1.07.52c-.49 1-.43 2.22.07 3.2.49 1 1.3 1.78 2.18 2.43l-.7.97a7.46 7.46 0 0 1-2.87-3.67 4.72 4.72 0 0 1 .25-3.45zm7.55 1.27-.85.84c-.95-.95-1.86-1.95-2.95-2.74-.4-.26-.89-.57-1.39-.42-.53.22-.84.76-1.11 1.24-.08.08-.1.33-.22.31l-1.03-.5c.4-.82.91-1.68 1.76-2.1a2.3 2.3 0 0 1 2.09.14c1.03.55 1.86 1.4 2.69 2.2l1.01 1.03z'/%3e%3cpath fill='%2321231e' d='m399.15 602.61 1 .63a2.98 2.98 0 0 0-.37 2.48 7.24 7.24 0 0 0 2.23 3.13l.45.4-.76.9a9.51 9.51 0 0 1-2.94-3.75 4.19 4.19 0 0 1 .39-3.79zm7.53 1.43-.87.8c-.88-.92-1.72-1.89-2.73-2.67-.42-.3-.93-.63-1.46-.46-.6.25-.99.82-1.35 1.34-.07.21-.19.19-.33.06l-.8-.5a4.84 4.84 0 0 1 1.94-1.95c.72-.34 1.57-.17 2.22.24 1.03.62 1.84 1.53 2.67 2.39l.7.75z'/%3e%3cpath fill='%23FFF' stroke='%2321231E' stroke-width='.99' d='m462.62 580.6-9.49-5.38c-4 2.87-6.95 13.52-.12 22.22 8.5 10.84 11.94 18.7 14.02 27.48 6.2-7.93 8.32-16.27 4.39-24.4-5.3-10.98-8.75-17.17-8.8-19.92z'/%3e%3cpath fill='%23FFF' stroke='%2321231E' stroke-width='.99' d='m470.37 573.01-9.49-5.38c-4 2.87-12.33 13.18-5.51 21.88 8.5 10.84 17.33 19.05 19.41 27.82 6.2-7.93 8.83-16.27 4.9-24.4-5.3-10.98-9.26-17.17-9.31-19.92z'/%3e%3cpath fill='%23FFF' stroke='%2321231E' stroke-width='.99' d='m449.43 569.16-9.49-5.38c-4 2.87-6.95 13.52-.12 22.22 8.5 10.84 11.94 18.7 14.02 27.48 6.2-7.93 8.32-16.27 4.4-24.4-5.31-10.98-8.76-17.17-8.81-19.92z'/%3e%3cpath fill='%23FFF' d='M405.49 468.99c.18 8.68-1.36 66.56-1.84 74.74-.48 8.14-4.1 13.7-7.94 16.88-3.52-4.85-5.63-11.4-6.13-19.16-.26-3.96.47-58.73.78-70 6.48-17.15 11.29-17.8 15.13-2.46z'/%3e%3cpath fill='%2321231e' d='M404.14 543.76c-1.71.36-.66-1.76-.86-2.77.8-23.27 1.45-46.54 1.72-69.82-.46-1.1.48-3.37.99-1.56-.15 21.32-.82 42.63-1.45 63.93-.12 3.4-.22 6.82-.4 10.22zm-8.84 17.14c1.2-.72-.38-.73 1.29-1.76 4.12-4.02 6.25-9.75 6.56-15.44 1.72-.36.65 1.74.7 2.74-.8 5.56-3.46 10.94-7.83 14.55l-.72-.09zm.72.1zm-6.94-19.52c1.6-.56.88 1.54 1.22 2.49.66 5.78 2.36 11.58 5.8 16.35-1.1 1.38-1.62-.98-2.29-1.71-3-5.2-4.34-11.19-4.73-17.13zm.8-70.2c1.64-.01.7 1.54.9 2.79-.37 22.16-.76 44.32-.74 66.48.16 1.88-1.66.54-1-.83.02-22.76.37-45.52.81-68.27l.04-.16zm-.03.17zm16.13-2.47c-1.6.63-1.1-1.41-1.68-2.46-.97-2.76-1.69-6.08-4.24-7.82-2.2-.75-3.66 1.74-4.73 3.25-1.89 3.03-3.23 6.36-4.52 9.69-1.8-.2.01-2.04.15-3.1 1.66-3.68 3.14-7.78 6.4-10.37 1.85-1.5 4.33-.12 5.27 1.75 1.7 2.76 2.56 5.95 3.35 9.06zm-.01-.1z'/%3e%3cpath fill='%23FFF' d='m367.87 454.83-2.46 79.58c-.77 7.06 8.42 49.08 13.45 57.36 12.43-5.31 15.06-33.82 12.72-61.59-2.34-27.77.39-51.76 2.29-56.75.16-6.28-.9-12.84-.96-19.38-7.92.47-17.12.3-25.04.78z'/%3e%3cpath fill='%2321231e' d='m364.91 534.4 2.46-79.58c2-.2.46 2.96.86 4.28l-2.33 75.37-.99-.07zm1 .03zm12.74 56.89c.72 2.28-1.44-1.1-1.58-2.06-4.5-11.78-7.16-24.19-9.73-36.52-1.07-6.07-2.51-12.18-2.43-18.38 1.9-.1.5 2.75 1.12 4 1.78 14.12 5.06 28.04 8.94 41.72 1.22 3.88 2.34 7.85 4.3 11.44l-.62-.2zm.4.91zm12.02-62c1.94-.46.81 2.7 1.3 3.94.82 14.43.94 29.2-2.94 43.25-1.78 5.79-4.55 12.14-10.39 14.82-1.04-1.58 2.04-1.67 2.72-2.92 5.79-5.65 7.46-14.02 8.77-21.69 1.79-12.37 1.54-24.97.54-37.4zm2.3-56.81c2.04-.3-.2 2.5.07 3.68-2.58 15.62-2.63 31.57-1.79 47.34.12 1.9.26 3.8.41 5.7-1.93.46-.8-2.7-1.29-3.93-.99-16.22-.97-32.62 1.58-48.71.23-1.3.61-3.11 1.01-4.08zm.98.02zm-1.42-18.89c.03-2.28.78 1.04.54 1.94.23 5.65 1.02 11.29.88 16.95-1.75.4-.67-1.92-1-2.96-.14-5.48-.9-10.93-.94-16.42l.52.5zm-.05-1zm-24.52 1.3c-2.37-.3 1.6-.81 2.5-.66 7.34-.3 14.69-.2 22.02-.63.44 1.9-2.56.75-3.75 1.17-7.08.26-14.17.19-21.24.6l.47-.48zm-1-.03zm.5.01zm-.5-.01z'/%3e%3cpath fill='%23FFF' d='m353.13 467.85 1.69 79.6c-.4 7.1 10.96 48.54 16.4 56.54 12.62-9.78 10.08-49.8 8.15-61.91-3.85-24.13-3.2-52.08-1.87-56.62-.16-6.29-.32-13.8-.72-20.34l-23.65 2.73z'/%3e%3cpath fill='%2321231e' d='m354.32 547.47-1.69-79.6c2-.3.62 2.96 1.09 4.27l1.6 75.35-1-.02zm1-.02zm15.6 56.16c1.16 2.08-1.5-.97-1.6-2.03-5.18-11.7-8.52-24.13-11.75-36.49-1.34-5.82-3.03-11.66-3.25-17.66 1.9-.2.65 2.72 1.33 3.95 2.52 14.03 6.52 27.76 11.12 41.24 1.42 3.78 2.73 7.65 4.87 11.1l-.72-.11zm.61.78zm7.35-62.23c1.9-.59.98 2.68 1.52 3.87 1.41 14.25 1.82 28.83-1.07 42.93-1.3 5.62-3.2 11.62-7.8 15.44-1.41-1.3 1.64-2.18 2-3.58 4.88-7.28 5.82-16.33 6.6-24.84.71-11.27.33-22.64-1.25-33.82zM377 485.48c1.95-.45.16 2.24.48 3.35-1.13 15.63-.34 31.36 1.49 46.9.26 2.1.56 4.19.89 6.28-1.9.6-1-2.65-1.57-3.83-2.1-16.23-2.93-32.68-1.84-49.02.08-1.12.35-3.11.55-3.68zm1-.03zm-1.17-19.83c-.08-2.3.85 1.06.58 1.97.3 5.95.43 11.9.59 17.86-1.76.48-.76-1.96-1.07-3-.15-5.77-.3-11.53-.65-17.29l.55.46zm-.11-.99zm-23.6 3.72c-.5-1.88 2.32-.87 3.48-1.4l20.12-2.31c.56 1.86-2.44.9-3.58 1.41l-20.01 2.3zm.07 0zm-.06-1zm-.5.52z'/%3e%3cpath fill='%23FFF' d='m342.19 486.7 20.91-.53c-1.78 8.68-.35 35.65 3.25 56.21 3.39 19.28 8.11 69.27-11.96 81.28-12.44-26.38-2.97-52.02-9.24-74.92-4.9-24.35-5.86-44.68-2.96-62.04z'/%3e%3cpath fill='%2321231e' d='m363.12 486.66-20.91.53c-.3-2 2.93-.63 4.23-1.1l16.65-.42c.39.5.77.55.03.99zm-.03-1zm3.76 56.63c-1.89.65-1.04-2.6-1.63-3.76-2.29-15.57-3.8-31.33-3.21-47.08.11-1.8.26-3.61.61-5.39 1.9.06.16 2.63.49 3.9-.82 14.52.55 29.07 2.37 43.46.4 2.97.85 5.93 1.37 8.87zm-12.9 81.58c.67-.58 1.03-1.43 2.82-2.59 6.99-6.34 9.4-16.03 10.84-25.02 2.42-17.32 1.17-34.96-1.47-52.19-.8-2.82 1.52-1.46 1.12.68 2.6 17.53 3.82 35.49 1.12 53.08-1.62 9.1-4.39 18.92-11.87 24.98-.84.37-1.6 1.65-2.56 1.06zm.7.21zm-9.98-75.25c1.88-.83 1.22 2.5 1.87 3.61 3.48 18.27-.6 37.09 3.2 55.33a67.5 67.5 0 0 0 5.1 15.67c-1.66 1.1-1.7-2.35-2.53-3.38-5.9-14.45-5.48-30.33-5.24-45.65.06-8.57-.13-17.26-2.4-25.58zm0 .04zm-2.49-62.67c.52.9.38 1.83.01 3.85-2.6 19.54-.36 39.36 3.46 58.59-1.88.68-1.1-2.6-1.74-3.76-3.54-19.15-5.37-38.93-2.2-58.27l.47-.41zm-.47.41zm.49.09zm-.5-.09z'/%3e%3cpath fill='%23FFF' d='M422.15 454.38c-.08 8.68-3.37 66.48-4.1 74.64-.73 8.13-4.5 13.56-8.45 16.62-3.38-4.96-5.28-11.57-5.55-19.34-.13-3.97 2.25-58.7 2.9-69.94 7-16.94 11.82-17.44 15.2-1.98z'/%3e%3cpath fill='%2321231e' d='M418.54 529.07c-1.72.3-.6-1.78-.78-2.8 1.51-23.23 2.87-46.47 3.84-69.72-.42-1.13.58-3.36 1.03-1.53-.8 21.44-2.12 42.86-3.4 64.27-.22 3.26-.42 6.52-.69 9.78zm-9.35 16.85c1.22-.68-.37-.74 1.33-1.72 4.25-3.89 6.56-9.55 7.03-15.22 1.73-.3.6 1.76.63 2.76-.98 5.52-3.8 10.83-8.28 14.3l-.71-.12zm.71.11zm-6.35-19.72c1.62-.57.85 1.4 1.13 2.32.47 5.87 2 11.8 5.33 16.73-1.16 1.35-1.6-1.02-2.24-1.78-2.85-5.28-4-11.32-4.22-17.27zm2.94-70.14c1.64.04.65 1.56.81 2.82-1.05 22.06-2.1 44.13-2.75 66.21.39 1.86-1.7 1.1-.99-.44.71-22.81 1.76-45.62 2.89-68.42l.04-.17zm-.04.17zm16.2-1.95c-1.63.57-1.07-1.45-1.61-2.52-.89-2.8-1.5-6.12-4-7.95-2.17-.82-3.72 1.62-4.83 3.1-1.98 2.97-3.42 6.25-4.8 9.54-1.8-.27.07-2.04.24-3.09 1.76-3.63 3.37-7.68 6.7-10.16 1.9-1.45 4.34.02 5.22 1.91 1.6 2.81 2.38 6.03 3.08 9.17zm-.02-.11zm-.48.1zm.48-.1z'/%3e%3cpath fill='%23FFF' d='M384.99 407.23c-.56 18.65-.87 59.1-.76 62.55.27 7.77 3.33 17.67 6.71 22.63 3.94-3.06 7.72-8.5 8.45-16.62.6-6.68.8-39.48.9-55.92a70.63 70.63 0 0 1-12.07-9.72s-3.1-2.76-3.23-2.92z'/%3e%3cpath fill='%2321231e' d='M384.72 469.76c-1.49.52-.9-1.15-1.02-2.05.06-20.17.27-40.34.79-60.5 1.53-.42.82 1.27.93 2.2-.46 20.03-.71 40.07-.7 60.1v.25zm5.9 22.25c1.3 1.26-.56.7-.74-.33-3.54-6.28-5.45-13.41-6.08-20.56-.71-1.16 1.03-2.11.95-.65a50.6 50.6 0 0 0 5.76 20.33c.1.54 1.63 1.74.12 1.21zm.62.8zm7.64-17.06c1.53-.34.78 1.23.74 2.13-.88 5.75-3.73 11.32-8.38 14.92-1.28-.88.38-1.4.94-2.14 4.05-3.88 6.23-9.38 6.7-14.91zm1.14-55.46c.8-1.78.85.5.76 1.35-.16 17.33-.13 34.67-.76 52-.22.82.41 2.7-1.03 2.12-.15-1.14.13-2.69.11-3.99.54-17.3.55-34.6.7-51.9l.22.42zm.54-.84zm-12.35-9.8c-.17 1.94.32-.77 1.14.94a71.3 71.3 0 0 0 11.2 8.86c-.4 1.52-1.46.1-2.27-.32a69.35 69.35 0 0 1-10.43-8.63l.36-.85zm-.36.85c-1.9-.95 1.09-1.4.01-.03v.03zm-2.37-3.26c-1.67.34-.24-.8.29.05l2.75 2.47c-.52 1.95-.09-1.14-.68.73-1.08-.98-2.2-1.93-3.25-2.95l.89-.3zm-1-.03c-.65-2.06 1.4-.63.39-.12l-.38.12z'/%3e%3cpath fill='%23FFF' d='M399.93 419.25c-.37 20.09-.15 51.74-.07 54.3.27 7.78 2.18 14.4 5.55 19.35 3.95-3.06 8.1-8.68 8.84-16.8.44-5 1.83-26.46 1.96-42.92-5.3-1.67-11.99-10.37-16.28-13.93z'/%3e%3cpath fill='%2321231e' d='M400.36 473.54c-1.2.42-1.05-.58-1.02-1.43-.16-17.63-.19-35.25.1-52.87 1.4-.43.9.99.96 1.87-.24 17.48-.24 34.96-.04 52.43zm4.75 18.97c1.27 1.14-.43.82-.67-.2-3.47-5.6-4.84-12.23-5.07-18.74 1.33-.48.98.84 1.08 1.7.41 6.09 1.92 12.25 5.37 17.35l-.71-.11zm.6.78zm8.04-17.24c1.43-.33.85 1.03.76 1.91a24.17 24.17 0 0 1-8.8 15.33c-1.09-.75-.04-1.22.6-1.8a23.62 23.62 0 0 0 7.44-15.44zm2.31-42.4c.23-1.71.89-.15.64.77-.22 13.92-.9 27.83-1.96 41.71-1.38.32-.88-.95-.85-1.82.98-13.7 1.67-27.41 1.83-41.14l.34.48zm.3-.95zm-15.93-13.44c-1.78.28-.09-.88.47.17 4.61 4.15 8.4 9.31 13.79 12.53.57.53 2.18.41 1.44 1.48-.54.38-1.66-.56-2.34-.84-5.48-3.44-9.34-8.78-14.18-12.97l.82-.37zm-1-.02c-.62-1.72 1.61-.31.11-.05l-.1.05z'/%3e%3cpath fill='%23FFF' d='m387.08 405.55-14.24-20.52c-2.88 10.12-6.39 82.77-2.27 88.72a36.53 36.53 0 0 0 6.45 19.32c3.94-3.06 9.82-8.56 8.13-16.78-1.7-8.23.2-62.26 1.93-70.73z'/%3e%3cpath fill='%2321231e' d='m373.25 384.74 14.24 20.53c-1.24 1.4-1.74-1.31-2.6-2l-12.46-17.96c-.31-.72.42-.38.82-.57zm-.89.15zm-1.29 88.84c-1.41.69-1.25-.68-1.7-1.95-1.39-8.26-1.12-16.68-1.15-25.02.27-18.27 1.03-36.56 2.97-54.73.3-2.4.58-4.8 1.17-7.14 1.78.02.25 1.97.4 3.04-1.9 13.6-2.48 27.34-3.1 41.04-.4 12.95-.91 25.95.13 38.89.23 1.99.41 4.04 1.28 5.87zm-.09-.26zm5.74 19.2c1.32 1.71-1.03.02-1.17-.97a36.76 36.76 0 0 1-5.47-17.93c1.64-.53.82 1.58 1.18 2.53.63 5.9 2.84 11.6 6.17 16.48l-.71-.11zm.6.79zm7.34-17.07c1.6-.82 1.08 1.6 1.28 2.56.16 6.03-4.03 11.08-8.61 14.5-1.37-.98.68-1.53 1.26-2.32 4.26-3.6 7.4-9 6.07-14.74zm2.42-70.34c.08-2.2.7.77.17 1.61-1.45 14.27-1.8 28.62-2.16 42.95-.05 8.38-.42 16.8.47 25.15-.64 1.7-1.37-.65-1.2-1.7-.75-12.66-.23-25.34.14-38 .45-10.04.7-20.12 2-30.1.03-.93.2-.26.58.1zm0-1zm0 0zm0 1z'/%3e%3cpath fill='%23FFF' d='M357.88 451.24c-.65 11.24-1.1 18.85-.97 22.81.27 7.78 2.18 14.39 5.55 19.35 3.95-3.06 8.96-8.48 8.45-16.62-2-31.46 1.45-61.09 5.45-89.57-3.38-2.48-9.07-5.16-12.45-7.64-6.75 38.36-9 62.16-6.03 71.67z'/%3e%3cpath fill='%2321231e' d='M357.41 474.03c-1.72.6-.79-1.64-1.01-2.58.14-6.76.62-13.5.98-20.24 1.82-.36.58 2 .82 3.05-.33 6.59-.87 13.18-.79 19.77zm4.75 18.97c1.33 1.73-1.06 0-1.15-1-3.12-5.43-4.37-11.73-4.6-17.93 1.67-.55.83 1.6 1.16 2.56.5 5.79 2.02 11.63 5.3 16.48l-.71-.11zm.6.79zm7.65-16.98c1.7-.6.85 1.71.96 2.68-.44 5.8-4.08 10.86-8.6 14.3-1.4-1 .71-1.55 1.26-2.37 4.1-3.68 6.84-9 6.38-14.61zm5.66-89.2c1.23-1.94.54 1.41.43 2.21-4.05 28.76-6.98 57.86-5.1 86.92-1.8.57-.79-2.07-1.17-3.12-1.55-28.94 1.57-57.87 5.64-86.49l.2.47zm.59-.81zm-12.26-7.15c-2.13-.56 1-.36 1.51.67 3.53 2.24 7.34 4.04 10.75 6.48-.67 1.7-2-.56-3.06-.83-3.3-2.03-6.82-3.74-9.98-6l.78-.32zm-.98-.17zm-5.9 71.4c1.43 1.69-1.04-.28-.62-1.5-1.59-9.29-.52-18.77.32-28.1 1.5-14 3.78-27.92 6.2-41.8 1.91-.1.26 2.28.42 3.4-2.97 17.72-6 35.5-6.71 53.48-.07 4.92-.14 9.95 1.22 14.73l-.82-.2zm.71.7zm0 0zm-.7-.7z'/%3e%3cpath fill='%23FFF' d='m343.64 471.82 3.86 14.63c.27 7.78 5.07 14.2 8.45 19.16 3.94-3.06 7.52-8.1 6.51-16.18-5.78-46.47-3.71-77.2 6.03-115.07-22.03 15.04-32.25 46.78-24.85 97.46z'/%3e%3cpath fill='%2321231e' d='m347.02 486.58-3.86-14.63c1.83-.77 1.27 2.57 2 3.7.94 3.6 1.92 7.18 2.84 10.79l-.98.14zm.96-.25zm7.66 18.89c1.26 1.86-1.17-.34-1.42-1.26-3.61-5.2-7-11-7.22-17.49 1.83-.43.77 2.32 1.42 3.43 1.2 5.76 4.65 10.67 7.94 15.43l-.72-.11zm.61.78zm5.72-16.51c1.86-.58.9 2.39 1.14 3.53a17 17 0 0 1-6.86 12.98c-1.42-1.25 1.5-2 2-3.23 3.23-3.56 4.38-8.59 3.72-13.28zm6.8-114.72c-.54-2.06.49 1.56-.53 2.62-6 23.5-9.08 47.77-8.41 72.03.3 13.36 1.49 26.69 3.12 39.94-1.92.52-.9-2.71-1.47-3.93-3.31-27.64-4.08-55.8.6-83.34a318.5 318.5 0 0 1 5.93-27.86l.77.54zm-.56-.82zm-24.09 97.74c-1.88.88-.91-2.5-1.49-3.58-2.6-20.5-3.22-41.8 2.87-61.76 3.93-12.8 11.49-24.83 22.71-32.4 1.36 1.42-1.8 2-2.51 3.11-12.5 9.87-19.23 25.28-21.95 40.64-3.22 17.81-2.15 36.25.37 54zm-.96.26zm.48-.13zm-.48.13z'/%3e%3cpath fill='%23FFF' d='m344.77 486.22-20.22-6.72c-2.58 20.22 1.38 45.62 6.83 79.12 4.67 28.76 2.21 51.52-1.36 66.12 21.57-2.96 30.7-30.77 19.88-83.1a234.62 234.62 0 0 1-5.13-55.42z'/%3e%3cpath fill='%2321231e' d='m324.71 479.03 20.22 6.72c-.43 2.01-3.14-.5-4.58-.48l-15.95-5.3c-.6-.66-.25-.54.31-.94zm-.65.4zm7.81 79.1c-1.96.57-1.02-2.88-1.67-4.13-3.3-21.25-7.2-42.58-6.91-64.16.08-3.61.32-7.22.77-10.8 2.02-.03.2 2.93.56 4.26-1.44 20.22 1.95 40.37 4.92 60.31.76 4.85 1.55 9.69 2.33 14.53zm-1.91 65.71c-.27 2.38-.26-2.1.36-3.03 4.3-20.54 3.9-41.86.57-62.51 1.94-.6 1.02 2.78 1.61 4 2.89 20.61 2.86 41.84-2 62.16l-.54-.62zm.13 1zm19.33-83.5c1.96-.62 1.12 2.98 1.84 4.22 3.18 17.46 5.42 35.58 1.97 53.18-1.97 9.49-6.59 19.5-15.76 23.9a25.32 25.32 0 0 1-7.38 2.2c-.54-1.95 2.82-1.01 3.97-1.92 9.15-2.75 14.81-11.59 17.18-20.39 4.2-15.36 2.87-31.57.7-47.14-.72-4.7-1.57-9.38-2.52-14.04zm-4.8-55.05c.92-2.26.57 2.35.6 3.29a234.43 234.43 0 0 0 5.17 51.56c-1.87.7-1.11-2.61-1.77-3.75a235.03 235.03 0 0 1-4.34-51.58l.17.24.17.24zm.31-.94z'/%3e%3cpath fill='%2321231e' d='M343.56 584.05c.43 0 1.63-.12.95.49-.38.31-.98 0-.95-.49zm-4.3-40.2c1.48-.85 1.32.82 1.57 1.83 2.5 12.64 4.32 25.5 3.91 38.41-1.67.48-1.07-1.16-1.13-2.21.14-12.8-1.8-25.53-4.35-38.03zm-5.41-50.21c1.63-.55 1.12 1.08 1.2 2.13.22 16.07 2.1 32.1 5.37 47.84-1.51.86-1.32-.87-1.6-1.89a251.66 251.66 0 0 1-4.97-48.08zm1.18-.01c-.44.01-1.63.18-.97-.45.37-.33.98-.04.97.45z'/%3e%3cpath fill='%23FFF' d='m343.96 367.25 13.27 2.23c-.65 2.85-4.02 20.32-4.63 23.3-4.96 24.27-8.24 52.87-4.48 84.25 1.39 11.64 3.86 21.16 7.48 28.51-14.56-1.65-23.9-15.87-22.69-40.67-2.53-28.96-1.41-51.99 3.27-69.3 1.38-5.08 5.8-24.22 7.78-28.32z'/%3e%3cpath fill='%2321231e' d='m357.15 369.98-13.27-2.23c.08-2.02 3-.06 4.36-.28l9.07 1.53c.45.58.54.6-.16.98zm.16-.98zm-4.22 23.88c-1.88.02-.22-2.32-.32-3.48 1.32-6.68 2.58-13.36 3.98-20.02 1.86 0 .2 2.28.3 3.44-1.35 6.68-2.63 13.38-3.96 20.06zm-4.48 84.1c-1.92.5-.9-2.72-1.43-3.96-2.76-26.82-.5-53.98 4.93-80.34 2 .1.02 2.84.2 4.16-5.13 26.34-6.93 53.44-3.7 80.13zm6.93 29.07c.3-.88-1.26-.69-1.6-2.95-3.5-8.26-5.23-17.14-6.32-26 1.93-.52.92 2.71 1.53 3.92 1.26 8.34 3.19 16.69 6.9 24.31l-.5.72zm.5-.72zm-23.62-40.4c2-.57.47 2.54.9 3.68-.02 10.42 1.68 21.76 8.95 29.75a21.38 21.38 0 0 0 13.38 6.7c.05 2.02-2.88.18-4.15.17-8.95-2.5-14.83-10.9-17.1-19.55-1.9-6.72-2.3-13.86-1.98-20.76zm.99-.1zm2.3-69.4c1.95.23-.12 2.78 0 4.12-4.73 21.41-4.08 43.57-2.3 65.29-1.95.45-.81-2.79-1.33-4.03-1.54-21.77-1.91-44.1 3.63-65.37zm8.33-28.66c.3 1 .05 1.58-.64 3.37-2.62 8.42-4.5 17.04-6.74 25.56-1.92-.16.05-2.59-.04-3.83 2.2-8.3 3.84-16.79 6.9-24.83.17-.1.35-.18.52-.27zm-.53.27zm.45.22zm-.45-.22z'/%3e%3cpath fill='%23FFF' d='m335.92 370.39 6.52 7.44c-1.85 1.32 1.28 7.03-.4 18.1-1.1 6.3-4.84 13.7-5.61 21.73-2.57 26.6-2.58 59.9 5.42 81.19-14.56-1.65-19.56-14.85-20.03-39.68-.4-20.52-.46-44.72 4.69-72.66 1.04-6.53 4.18-11.74 9.41-16.12z'/%3e%3cpath fill='%2321231e' d='m342.06 378.16-6.52-7.44c1.27-1.5 2.23 1.64 3.35 2.31 1.22 1.6 3 3.03 3.89 4.74.05.72-.23.4-.72.39zm.75-.66zm-.29 18.52c-1.96.11-.26-2.44-.59-3.63.5-4.48-.44-8.94-.57-13.4-.23-1.34 1.62-2 1.13-.46-.44 3.16.67 6.36.54 9.56a45 45 0 0 1-.5 7.93zm0-.01zm-5.6 21.7c-1.96.13-.32-2.63-.42-3.86 1.17-6.14 3.86-11.86 5.04-18 1.85-.1.3 2.16.29 3.24-1.71 6.19-4.3 12.18-4.9 18.62zm4.87 81.63c.23-.9-1.1-.66-1.3-2.86-5.26-16.46-6.12-33.93-6.07-51.1.1-9.26.63-18.53 1.51-27.76 1.95-.13.36 2.65.65 3.91-1.65 20.8-2.02 41.9 1.75 62.5a91.4 91.4 0 0 0 3.98 14.64l-.52.67zm.52-.67zm-21-39.49c1.93-.35.67 2.63 1.12 3.85.51 9.18 1.17 18.87 5.94 26.98 2.8 4.8 8.03 7.87 13.53 8.35.14 1.89-2.4.37-3.55.33-6.86-1.62-11.6-7.7-13.62-14.18-2.71-8.14-3.18-16.82-3.41-25.33zm4.7-72.75c1.97-.12.22 2.39.39 3.55-4 22.82-4.64 46.07-4.09 69.18-1.91.37-.65-2.56-1.06-3.76-.46-23.06.52-46.3 4.77-68.97zm.99.16zm9.3-16.53c-.66.8-.26 1.18-1.9 2.37a24.78 24.78 0 0 0-7.4 14.16c-1.83.12-.36-2.1-.33-3.18 1.42-5.29 4.73-9.94 8.93-13.4l.7.05zm-.7-.05z'/%3e%3cpath fill='%23FFF' d='m372.29 389.97-13.44-1.57c-2.46 12.7-4.35 21.69-4.81 26.21-.9 8.88 1.8 17.02 4.87 23.08 4.95-2.99 7.25-9.51 9.34-18.66 2.09-9.19 2.6-19.2 4.04-29.06z'/%3e%3cpath fill='%2321231e' d='m358.91 387.91 13.44 1.57c.09.86-.26 1.18-1.09.87l-12.46-1.45c-.45-.54-.55-.61.11-.99zm-.55.4zm-3.83 26.36c-.79.07-1.2-.17-.89-.98 1.02-7.23 2.61-14.37 3.97-21.54l.75-3.84c.87-.02 1.16.34.8 1.15-1.5 7.88-3.23 15.71-4.44 23.64l-.19 1.57zm4.12 22.6c.66.67.4 1.16-.28.45-3.59-7.1-5.64-15.17-4.83-23.15.83-.1 1.2.2.91 1.02-.56 7.58 1.48 15.16 4.9 21.88l-.7-.2zm.51.85zm8.6-19.2c.78.04 1.19.3.77 1.08-1.24 5.07-2.52 10.34-5.62 14.65a13.24 13.24 0 0 1-3.75 3.47c-.58-.62-.52-1.07.28-1.38 3.6-2.68 5.29-7.06 6.6-11.2.67-2.18 1.21-4.4 1.72-6.62zm4.53-28.45c-.23-.95.28-1.18.46-.21-1.4 9.62-1.88 19.38-4.02 28.88-.78-.03-1.19-.3-.78-1.08 1.98-9.28 2.47-18.79 3.85-28.16l.49.57zm0-1c.97-.25.45 1.11 0 0zm0 0c.04.62-.07 1.49-.02.35l.02-.35zm0 1z'/%3e%3cpath fill='%23FFF' d='m407.15 418.58-11.92.12c-.41 10.97-.7 18.38-.51 22.25.38 7.57 2.27 13.99 5.5 18.8 3.63-3.03 7.05-8.36 7.6-16.28.54-7.96-.6-16.43-.67-24.89z'/%3e%3cpath fill='%2321231e' d='m395.23 418.2 11.92-.12c.02.54.19 1.25-.61 1l-11.3.12c-.54-.5-.61-.52-.01-1zm-.5.48c-.17-.77.94-.5.05-.04l-.04.04zm.5 22.23c-.5.01-1.24.27-1.02-.5-.14-6.28.22-12.56.42-18.83l.1-2.9c.56.01 1.27-.13.98.66-.22 6.9-.62 13.78-.52 20.68l.03.9zm4.68 18.44c.36.42.98 1 .02.68-.44-.31-.66-.96-.99-1.41-3.1-5.34-4.4-11.54-4.71-17.66.55-.03 1.24-.23 1.03.58.4 6.26 1.86 12.64 5.38 17.92l-.73-.1zm.64.77c-.3.8-1.14-.39-.29-.04l.29.04zm6.78-16.7c.54.04 1.26-.08.94.7-.5 6.02-3.01 12.07-7.72 16-.35-.42-.93-.85-.17-1.17 4.38-3.91 6.58-9.76 6.95-15.52zm-.17-24.35c0-.55-.13-1.38.44-.56.14 1.09.06 2.27.13 3.4.26 7.19 1.06 14.38.59 21.58-.55-.03-1.27.1-.96-.69.44-8.08-.64-16.14-.7-24.22l.5.5zm0-1c.78-.23.54.95.05.06l-.05-.06z'/%3e%3cpath fill='%23FFF' d='m419.99 424.24-11.91.54c-.03 10.97-.07 18.4.26 22.25.65 7.55 2.76 13.9 6.16 18.59 3.51-3.15 6.75-8.6 7.02-16.53.26-7.97-1.16-16.4-1.53-24.85z'/%3e%3cpath fill='%2321231e' d='m408.06 424.28 11.91-.54c.04.55.23 1.25-.58 1.02l-11.29.51c-.52-.39-.59-.57-.04-.99zm-.48.5c-.2-.77.92-.53.04-.05l-.04.05zm1.26 22.2c-.5.03-1.22.3-1.03-.47-.36-6.42-.21-12.86-.23-19.28v-2.45c.55-.01 1.26-.18 1 .63.02 6.83-.13 13.67.18 20.5l.08 1.07zm5.33 18.26c.38.42 1.01.96.04.68-.45-.3-.7-.95-1.05-1.4-3.28-5.22-4.78-11.36-5.3-17.45.54-.06 1.23-.28 1.04.54.61 6.24 2.3 12.56 6 17.71l-.73-.08zm.66.75c-.27.8-1.16-.35-.28-.04l.28.04zm6.2-16.92c.55 0 1.26-.13.96.66-.28 6.04-2.59 12.17-7.16 16.26-.36-.4-.96-.81-.2-1.17 4.23-4.06 6.23-9.98 6.4-15.75zm-1.04-25.33c0 .56-.12 1.38.44.54.16.2.07 1.06.14 1.51.44 7.77 1.69 15.51 1.45 23.31-.55 0-1.26.13-.98-.66.16-8.1-1.2-16.11-1.54-24.18l.5-.52zm-.5.52c-.27-.8.96-.58.07-.07l-.06.07zm.5.47c0-.32 0-1.52.01-.54-.01.16.05.42 0 .54z'/%3e%3cpath fill='%23FFF' d='m395 412.42-11.9-.84c-1.29 10.89-2.18 18.26-2.3 22.12-.24 7.58 1.13 14.14 3.96 19.18 3.86-2.71 7.7-7.75 8.89-15.6 1.18-7.89.74-16.42 1.35-24.86z'/%3e%3cpath fill='%2321231e' d='m383.14 411.08 11.9.84c-.03.56.08 1.27-.7.95l-11.27-.8c-.48-.45-.53-.64.07-.99zm-.53.44c-.11-.8.97-.42.04-.04l-.04.04zm-1.32 22.2c-.58.02-1.22.08-.96-.68.4-6.45 1.29-12.85 2.01-19.27l.27-2.25c.64.01 1.23.06.9.83-.77 6.8-1.7 13.57-2.17 20.38l-.05.99zm3.19 18.76c.33.45.9 1.07-.05.67-.4-.36-.58-1.02-.87-1.5-2.66-5.58-3.44-11.85-3.26-17.96.61-.03 1.23-.07.98.73-.1 6.25.84 12.7 3.92 18.22l-.72-.16zm.57.81c-.37.78-1.11-.48-.28-.06l.28.06zm8.1-16.08c.64.03 1.24.1.87.86-1 5.93-3.99 11.7-8.97 15.22-.32-.44-.87-.91-.08-1.18 4.68-3.54 7.35-9.19 8.18-14.9zm1.81-24.3c.04-.55-.02-1.38.49-.5.02 1.3-.15 2.66-.17 4-.3 6.98-.12 14-1.14 20.95-.64-.04-1.23-.1-.88-.87 1.07-7.99.65-16.08 1.24-24.1l.46.53zm.08-.99c.8-.16.45 1 .04.06l-.04-.06z'/%3e%3cpath fill='%23FFF' d='m383.86 399.58-13.05-5.42c-2.22 8.82-5.23 37.87.12 50.13 4.34-2.95 8.72-8.49 10.18-17.22 1.47-8.77 1.91-18.1 2.75-27.49z'/%3e%3cpath fill='%2321231e' d='m371 393.7 13.05 5.42c-.15.86-.57 1.06-1.29.54l-12.14-5.04c-.43-.58-.21-.68.38-.92zm-.67.34c0-1 1.18-.17 0 0zm.31 49.84c.62.62.57 1.1-.21.51-2.17-5.34-2.64-11.17-2.91-16.87-.3-9.57.36-19.16 1.84-28.6.27-1.64.57-3.27.97-4.88.8.04 1.17.34.75 1.11-1.57 7.61-2.25 15.38-2.57 23.13-.2 7.36-.12 14.83 1.6 22.03.34 1.29.75 2.56 1.27 3.78l-.74-.21zm.56.82c-.68.79-1-.69 0 0zm9.42-17.72c.84-.03 1.17.3.81 1.1-1.23 6.52-4.66 12.84-10.23 16.62-.6-.57-.6-1.03.19-1.35 5.18-3.9 8.2-10.07 9.23-16.37zm3.05-26.94c.12-.87.7-1.1.65-.1-.81 9.08-1.23 18.2-2.72 27.2-.84.05-1.17-.27-.83-1.08 1.38-8.79 1.8-17.68 2.6-26.53l.3.5zm.38-.92zm-.2.46zm.2-.46z'/%3e%3cpath id='b' fill='%23EDB92E' stroke='%2321231E' stroke-width='.99' d='M387.75 701.16c7.96 6.38 15.25-8.22 8.19-27.51-5.23-14.28-30.77-8.74-16.54 10.47.67.9 1.62.49 1.49-.55-.81-3.94 1.7-6.23 5.57-5.5 10.58 1.98 10.91 22.07-.6 17.5-2.09-.14-.21 3.9 1.89 5.59z'/%3e%3cpath fill='%23EDB92E' stroke='%2321231E' stroke-width='.99' d='M400.05 639.16v.13c-1.04 3.35-4.91 7.54-7.92 10.68-4.67 4.87-3.57 12.24-.34 16.16 3.53 4.28 5.1 9.1 5.8 12.84.53 2.3 1.48 7.47.8 15.5-.35 3.96-2.74 6-4.98 7.77-1.14.9.49 3.05 4.25 5.88.4.3 1.54 1.08 2.08 3.04.2.47 1.95.47 2.16 0 .54-1.96 1.67-2.73 2.09-3.04 3.76-2.83 5.38-4.98 4.24-5.88-2.24-1.77-4.63-3.81-4.97-7.77-.69-8.03.26-13.2.79-15.5.7-3.75 2.28-8.56 5.8-12.84 3.23-3.92 4.33-11.3-.33-16.16-3.01-3.14-6.88-7.33-7.92-10.68v-.13c-.06-.65-.42-.98-.78-.98-.36 0-.72.33-.77.98z'/%3e%3cpath fill='%23EDB92E' d='M395.06 685.47h11.51c1.98 0 3.6 1.6 3.6 3.54a3.58 3.58 0 0 1-3.6 3.54h-11.51c-1.98 0-3.6-1.6-3.6-3.54a3.58 3.58 0 0 1 3.6-3.54z'/%3e%3cpath fill='%2321231e' d='M406.57 685.97h-11.51v-1h11.51v1zm4.1 3.04h-1a3.09 3.09 0 0 0-2.75-3.02c-.36.07-.4-.14-.35-.45.05-.2-.15-.67.21-.56a4.1 4.1 0 0 1 3.89 4.03zm-1 0h1-1zm-3.1 4.04v-1a3.1 3.1 0 0 0 3.1-2.77c-.1-.38.27-.25.52-.27.25 0 .6-.09.47.3a4.09 4.09 0 0 1-4.09 3.74zm-11.51-1h11.51v1h-11.51v-1zm-4.1-3.04h1a3.09 3.09 0 0 0 2.75 3.02c.36-.07.4.14.35.45-.05.2.15.67-.21.56a4.1 4.1 0 0 1-3.89-4.03zm1 0h-1 1zm3.1-4.04v1a3.1 3.1 0 0 0-3.1 2.77c.1.38-.27.25-.52.27-.25 0-.6.09-.47-.3a4.09 4.09 0 0 1 4.09-3.74z'/%3e%3cpath fill='%23FFF' d='m417.13 579.19.38-10.91c-4.38-2.23-15.17.06-19.73 10.13-5.68 12.56-11.06 19.25-17.87 25.14 9.88 1.85 18.25-.1 23.64-7.35 7.28-9.78 11.17-15.7 13.58-17.01z'/%3e%3cpath fill='%2321231e' d='m418.01 568.3-.38 10.91c-.86.17-1.2-.16-.96-1.01l.35-9.94c.48-.22.74-.73.99.04zm-.27-.46zm-19.5 10.78c-.86-.17-1.04-.6-.48-1.29 3-6.02 9.4-10.38 16.2-10.32a9 9 0 0 1 3.78.83c-.22.76-.57 1.05-1.27.55-3.67-1.01-7.61.09-10.84 1.93a18.27 18.27 0 0 0-7.4 8.3zM380 603.07c-.1.91-.23 1.16-.42.11A60.46 60.46 0 0 0 393.44 586a105.5 105.5 0 0 0 3.89-7.79c.85.18 1.04.6.5 1.3-3.7 8.07-8.38 15.82-14.87 21.94-.88.86-1.8 1.68-2.73 2.49l-.23-.87zm-.18.98c-.97-.04-1.16-.3-.28-.83.14.07.18.6.28.83zm23.33-8.14c.79.35.9.8.2 1.35a19.95 19.95 0 0 1-13.4 7.24c-3.37.42-6.8.16-10.13-.45-.02-.82.29-1.18 1.1-.82 5.73.96 12 .66 17.06-2.5a19.04 19.04 0 0 0 5.17-4.82zm13.49-16.73c.76-.14 1.32.16.44.63-2.3 1.8-3.91 4.3-5.7 6.57-2.48 3.37-4.93 6.76-7.43 10.12-.8-.35-.89-.81-.21-1.38 3.52-4.66 6.78-9.54 10.55-14.02.78-.87 1.58-1.75 2.6-2.34l-.25.42zm.99.03z'/%3e%3cpath fill='%23FFF' d='m425.16 580.63-11.79-4.97c-4.83 9.86-8.12 16.52-9.5 20.13-2.68 7.1-3.41 13.77-2.17 19.54 4.79-1.22 10.31-4.64 14.05-11.66 3.75-7.04 6.06-15.27 9.41-23.04z'/%3e%3cpath fill='%2321231e' d='m413.56 575.2 11.79 4.97c-.18.65-.42 1.16-1.1.61l-11.07-4.66c-.3-.6-.31-.78.38-.92zm-.64.24zm-8.58 20.52c-.65-.16-1.19-.38-.65-1.06 2.6-6.18 5.68-12.14 8.6-18.17.31-.33.36-1.45.9-1.16.85.13.48.69.18 1.22-2.95 6.1-6.07 12.12-8.7 18.36l-.33.81zm-2.77 18.88c.2.63.4 1.26-.36.58-1.41-6.63-.17-13.55 2.2-19.81.6.17 1.2.33.69 1-2.14 5.91-3.24 12.4-1.92 18.6l-.6-.37zm.25.96c-.76.43-.73-.83-.04-.02l.04.02zm13.49-12.36c.61.24 1.13.51.51 1.12-2.97 5.36-7.99 9.73-14 11.24-.23-.61-.38-1.17.47-1.16 5.7-1.67 10.3-6.01 13.02-11.2zm9.65-22.36c.22-.62.45-1.25.65-.26-3.3 7.63-5.53 15.71-9.42 23.08-.6-.24-1.14-.5-.54-1.12 3.66-7.18 5.86-14.98 9.05-22.35l.26.65zm.39-.92c.85.13.09 1.1.01.04l-.01-.04z'/%3e%3cpath fill='%23FFF' d='m428.55 580.62-12.64-1.93c-2.29 10.73-3.86 18-4.3 21.84-.88 7.53.03 14.18 2.65 19.48 4.34-2.36 8.87-7.02 10.78-14.74 1.92-7.75 2.16-16.3 3.51-24.65z'/%3e%3cpath fill='%2321231e' d='m415.98 578.2 12.64 1.93c-.03.65-.1 1.24-.88.87-3.97-.6-7.94-1.2-11.91-1.82-.42-.56-.54-.6.15-.98zm-.56.39c-.03-.8 1-.32.03-.02l-.03.02zm-3.32 22c-.6-.03-1.23-.02-.9-.77.96-6.42 2.45-12.76 3.77-19.12l.45-2.11c.65.07 1.22.18.82.93-1.38 6.66-2.94 13.29-4 20l-.14 1.07zm1.92 18.98c.35.57.68 1.12-.21.66-2.99-6.09-3.47-13.1-2.7-19.76.62.03 1.24.04.91.82-.63 6.24-.12 12.8 2.68 18.5l-.68-.22zm.47.88c-.61.6-.93-.62-.06-.02l.06.02zm10.07-15.3c.64.1 1.21.23.77.96-1.57 5.93-5.38 11.4-10.84 14.34-.36-.54-.65-1.04.16-1.24 5.13-3.02 8.54-8.35 9.9-14.06zm3.99-25.02c-.1.78.05 1.09.47.66-1.33 8.18-1.53 16.53-3.5 24.6-.64-.09-1.21-.22-.79-.96 1.8-7.85 2.03-15.95 3.33-23.89l.49-.41zm-.5.41zm.5.58c-.05-.4.06-1.53.04-.53l-.04.53z'/%3e%3cpath fill='%23FFF' d='m430.43 563.41 7.54-.06c4.4 2.18 9.02 12.22 3.68 21.9-6.65 12.07-8.8 20.39-9.44 29.38-7.38-6.83-10.81-14.72-8.24-23.38 3.48-11.69 6.85-25.12 6.46-27.84z'/%3e%3cpath fill='%2321231e' d='m437.97 563.85-7.54.06c-.26-.96.27-1.14 1.14-1 2.2.01 4.42-.11 6.62 0l-.22.94zm0-1zm4.11 22.65c-.94-.24-.88-.78-.36-1.47 2.85-5.79 2.42-13.27-1.7-18.35a7.72 7.72 0 0 0-2.27-1.88c.2-.9.7-.97 1.33-.35 3.3 2.54 4.93 6.73 5.37 10.78a19.3 19.3 0 0 1-2.37 11.27zm-10.2 29.5c1.01-.98.24-.35-.15-.62a62 62 0 0 1 5.86-22.21c1.11-2.43 2.33-4.81 3.62-7.15.97.24.87.8.33 1.48-4.23 7.75-7.58 16.13-8.53 24.96a70.2 70.2 0 0 0-.3 3.21l-.84.33zm.83-.33c.08 1.04-.19 1.16-.83.34.26-.12.55-.22.83-.34zm-9.22-23.56c.94.05 1.04.53.68 1.3-1.32 5.07-.2 10.57 2.58 14.96a33.2 33.2 0 0 0 5.8 6.9c-.45.83-.94.72-1.45 0-4.41-4.25-8.05-9.81-8.43-16.09-.17-2.38.15-4.78.82-7.07zm6.93-28.2c-.12 1 .12.92.5.55.06 2.85-.72 5.63-1.28 8.4a319.4 319.4 0 0 1-5.2 19.54c-1-.03-1.01-.6-.62-1.38 2.2-7.66 4.38-15.33 5.82-23.17.16-1.11.38-2.24.3-3.36l.48-.57zm-.49.58zm.5-.07zm-.5.07z'/%3e%3cpath fill='%23FFF' d='m433.79 558.16-12.05-4.28c-4.27 10.11-7.17 16.95-8.33 20.64-2.28 7.23-2.63 13.94-1.06 19.63 4.71-1.5 10.68-4.58 14-11.8 3.35-7.25 4.54-16.24 7.44-24.19z'/%3e%3cpath fill='%2321231e' d='m421.9 553.41 12.05 4.28c-.14.66-.35 1.19-1.05.68l-11.33-4.02c-.34-.57-.35-.76.33-.94zm-.62.27zm-7.4 20.99c-.65-.13-1.2-.31-.7-1.02 2.23-6.32 4.97-12.44 7.54-18.63.3-.36.28-1.47.82-1.22.87.08.53.66.26 1.21-2.6 6.26-5.36 12.45-7.64 18.82l-.28.84zm-1.68 19c.24.63.47 1.24-.33.61-1.79-6.54-.94-13.52 1.07-19.91.6.14 1.22.26.74.97-1.8 6.01-2.52 12.55-.85 18.67l-.63-.34zm.3.95c-.73.47-.78-.79-.04-.02l.04.02zm13.4-12.48c.64.21 1.16.46.58 1.1a21.82 21.82 0 0 1-11.26 10.38c-.89.38-1.8.7-2.72 1-.27-.6-.44-1.15.41-1.18 4.93-1.63 9.42-4.87 12.02-9.42.35-.6.68-1.24.98-1.88zm7.72-23.51c.19-.63.37-1.28.63-.3-2.9 7.95-3.94 16.49-7.44 24.23-.62-.2-1.16-.44-.6-1.1 3.23-7.54 4.3-15.78 7.11-23.47l.3.64zm.33-.94c.85.07.16 1.08.02.03l-.02-.03zm-.16.47zm.16-.47c.85.07.16 1.08.02.03l-.02-.03z'/%3e%3cpath fill='%23FFF' d='m425.6 549.74-2.64-16.4c-2.77-.76-6.45 5.72-10.05 9.5-.83.88-1.79 1.7-2.51 2.77a23.32 23.32 0 0 0-3.42 7.96c-3.01 13.45-7.4 20.45-12.87 27.61 10.04-.2 17.84-3.83 21.65-12.02 5.14-11.06 7.74-17.65 9.84-19.42z'/%3e%3cpath fill='%2321231e' d='m423.44 533.25 2.64 16.4c-.94.44-1.16-.13-1.16-1l-2.46-15.24c.45-.31.57-.9.98-.16zm-.36-.4zm-9.82 10.33c-.76-.44-.78-.9-.07-1.39 2.45-2.7 4.35-5.95 7.24-8.23.76-.54 1.7-.96 2.65-.71 0 .95-.52.95-1.29 1.07-2.19 1.16-3.57 3.35-5.13 5.2-1.1 1.38-2.18 2.78-3.4 4.06zm-2.46 2.7c-.5-.28-1.08-.58-.44-1.07.65-.83 1.45-1.55 2.18-2.31.9.48.62 1-.09 1.5-.6.59-1.18 1.2-1.65 1.88zm-3.34 7.8c-.9 0-1.11-.43-.73-1.2a23.78 23.78 0 0 1 3.25-7.15c.73.3.95.7.35 1.28a22.88 22.88 0 0 0-2.87 7.06zm-13.37 27c.3 1.22-.41.87-.24 0 4.24-5.43 7.81-11.44 10.04-17.99a82.13 82.13 0 0 0 2.6-9.24c1.04-.05 1.03.56.7 1.37-1.8 7.87-4.8 15.53-9.44 22.18a99.22 99.22 0 0 1-3.25 4.48l-.4-.8zm.02 1c-1.14.35-1-.46-.35-.7l.35.7zm21.2-12.74c.96.18.94.71.4 1.4-2.48 4.9-7.17 8.47-12.41 9.98a34.1 34.1 0 0 1-9.19 1.35c-.29-.98.28-1.14 1.14-1.03 5.96-.26 12.21-2 16.45-6.41a19.2 19.2 0 0 0 3.6-5.29zm9.8-19.13c.86-.36 1.25.05.45.65-2.03 2.56-3.21 5.66-4.63 8.58-1.58 3.44-3.13 6.9-4.73 10.32-.97-.17-.92-.72-.42-1.44 2.5-5.3 4.7-10.75 7.5-15.9.57-.96 1.16-1.93 2-2.67l-.18.46zm.98-.16z'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='matrix(-1 0 0 1 964.3 0)'/%3e%3cpath fill='%23FFF' stroke='%2321231E' d='M536.38 414.88c1.59-.33 3.2-.79 4.86-1.37-7.63-4.79-13.96-10.57-21.49-22.12-7.7-11.83 3.38-32.95 7.93-44.16 9.5-7.04 18.45-17.37 21.29-31 1.12-7.34-19.1-4.7-33 1.88-17 8.03-19.31 5.8-25.37 7.16-2.15 10.42 2.36 11.3 6.7 10.8-9.37 15.02-13.28 29.98-15.15 51.49-1.87-21.51-5.78-36.47-15.14-51.5 4.34.51 8.85-.37 6.7-10.79-6.07-1.36-8.38.87-25.38-7.16-13.9-6.57-34.12-9.22-33-1.89 2.85 13.63 11.8 23.97 21.3 31.01 4.54 11.2 15.63 32.33 7.92 44.16-7.52 11.55-13.85 17.34-21.48 22.12 1.65.58 3.27 1.04 4.85 1.37-1.15 1.58-11.04 4.66-12.2 3.84-7.58-5.36-14.96-17.95-21.4-25.26-18.25-20.72-27.35-36.7-24.13-49.6 4.58-13.89 20.93-29.48-.72-26.78-21.66 2.7-39.6 32.42-45.37 68.2-2.14 13.27-3.38 24.38-4.83 33.47 11.82-4.22 17.06-8.43 20.2-13.62a119.35 119.35 0 0 0-3.18 14.09c9.67-1.72 16.68-6.47 19.2-15.14a45.4 45.4 0 0 1 3.56-8.85c2.97 1.05 6.82 1 11.5-.16 1.79 4.25 15.1 19.1 22.26 30.01 8.09 12.33 20.23 21.75 24.24 22.26 2 .26 2.61-4.2 2.17-10.32 21.12.15 42.23.27 62.93-.43 20.7.7 41.82.58 62.94.43-.45 6.13.17 10.58 2.17 10.32 4-.51 16.15-9.93 24.23-22.26 7.16-10.9 20.48-25.76 22.26-30 4.68 1.14 8.54 1.2 11.5.15a45.4 45.4 0 0 1 3.57 8.85c2.51 8.67 9.53 13.42 19.2 15.14-.71-4.47-1.77-9.16-3.19-14.09 3.15 5.19 8.38 9.4 20.2 13.62-1.45-9.1-2.69-20.2-4.82-33.48-5.77-35.77-23.72-65.5-45.37-68.2-21.65-2.68-5.3 12.9-.72 26.79 3.21 12.9-5.89 28.88-24.13 49.6-6.44 7.3-13.82 19.9-21.4 25.26-1.16.82-11.05-2.26-12.2-3.84z'/%3e%3cg id='d'%3e%3cpath fill='%23EDB92E' d='M440.58 356.77c-2.04 1.78-8.76 1.8-17.96 2.4-14.81.52-23.4-3.96-25.3-13.45 5.56 6.63 12.2 9.9 19.73 8.04 10.16-2.52 15.98-4.32 18.3-3.87 1.56.55 3.84 3.38 5.23 6.88z'/%3e%3cpath fill='%2321231e' d='M422.64 359.67c-.03-.58-.23-1.25.6-1.04 4.68-.33 9.4-.35 14.03-1.12 1.04-.22 2.13-.44 2.98-1.1.38.4.94.85.15 1.1-2.18 1.15-4.72 1.24-7.12 1.5-3.54.29-7.1.43-10.64.66zm.01 0zm-24.95-14.26c-.56.45-1.01.83-.09.31.46-.14.3.95.54 1.3 1 3.74 3.68 6.92 7.1 8.69 4.9 2.56 10.56 3.04 16 3 .44.13 1.48-.38 1.37.34.3.84-.54.6-1.1.65-5.68.07-11.59-.43-16.7-3.1a15.03 15.03 0 0 1-7.5-8.87c-.2-.62-.35-1.26-.48-1.9l.86-.42zm19.23 7.88c.22.6.37 1.18-.49 1.13-4.38.96-9.07 0-12.84-2.42a28.56 28.56 0 0 1-6.66-5.95c.45-.48.9-.86 1.25-.08 3.28 3.78 7.6 7.03 12.7 7.69 2.01.27 4.07.11 6.04-.37zm18.58-3.87c-.28.5-.1 1.19-.77.9-2.7.05-5.31.88-7.93 1.48-3.22.81-6.42 1.66-9.64 2.45-.23-.61-.38-1.18.48-1.14 4.86-1.17 9.66-2.6 14.57-3.54 1.08-.17 2.2-.36 3.29-.15zm-.07-.02zm5.47 7.75c-.4-.61-.77-.8-.83-.28-.99-2.32-2.27-4.66-4.32-6.2-.73-.17-.52-.64-.27-1.19.43 0 .96.46 1.35.76 1.93 1.7 3.23 4 4.2 6.35l-.13.56zm.13-.56zm-21.51-35.44.09 1.58c-.68.07-1.11-.84-.63-1.32a.79.79 0 0 1 .54-.26zm15.27 3.91-.54 1.49c-3.55-1.26-7.04-2.76-10.75-3.51a15.86 15.86 0 0 0-3.9-.31l-.08-1.58c3.81-.2 7.48 1.1 11.02 2.35l4.25 1.56zm8.86 2.6.24 1.56c-1.4.12-2.77-.36-4.1-.73-1.87-.57-3.7-1.26-5.53-1.94l.53-1.49c2.59.94 5.16 2 7.86 2.53.33.05.68.1 1 .06zm.24 1.55-.24-1.56c.67-.13 1.19.73.76 1.25a.78.78 0 0 1-.52.31zm23.27 7.5.2-1.17c.39.05.62.54.41.88a.6.6 0 0 1-.61.29zm-9.86-2.07.32-1.14c3.2.9 6.46 1.5 9.73 2.04l-.2 1.17a91.54 91.54 0 0 1-9.85-2.07zm.32-1.14-.32 1.14c-.4-.1-.57-.63-.3-.94a.6.6 0 0 1 .62-.2z'/%3e%3cpath fill='%2321231e' d='m431.54 331.89-.77 1.38c-2.69-1.52-4.6-4.05-6.16-6.66-.77-1.3-1.47-2.64-2.19-3.97l1.38-.75c1.61 2.95 3.14 6.06 5.6 8.41.65.61 1.37 1.16 2.14 1.59zm7.6-5.16 1.4.74c-1.17 2.13-2.61 4.23-4.7 5.54a4.94 4.94 0 0 1-4.44.55c-.17-.11-.63-.17-.59-.37l.73-1.3c.96.58 2.18.5 3.14-.04 1.68-.9 2.87-2.48 3.86-4.06.21-.35.42-.71.6-1.06z'/%3e%3cpath fill='%2321231E' d='m429.59 330.91-2.19-2.2c-1.07-1.34-.45-3.14 1.85-5.4 1.69.74 3.04 1.3 4.38 1.86-.9 3.04-2.24 4.95-4.04 5.74z'/%3e%3cpath fill='%2321231e' d='M423.26 412.95c-.15.36-.24.82-.42 1.1-.57-.19-.42-1.13.19-1.13.08 0 .15 0 .23.03zm23.87-3.53.83.85a19.68 19.68 0 0 1-10.57 5.49c-4.88.84-9.9-.07-14.52-1.69l.4-1.12c4.67 1.64 9.79 2.54 14.7 1.49a18.48 18.48 0 0 0 9.16-5.02zm2.9-2.87.83.84-2.9 2.88-.83-.85 2.9-2.87zm.83.84c-.26-.28-.64-.57-.82-.86.4-.4 1.16.07.96.61a.6.6 0 0 1-.14.25z'/%3e%3cpath fill='%2321231e' d='m452.17 401.28-1.17-.16c.04-.54.83-.7 1.09-.23.07.12.1.26.08.39zm-5.5 15.93.29 1.14-.69-.81a58.6 58.6 0 0 0 4.73-16.42l1.17.16a59.5 59.5 0 0 1-4.37 15.7c-.14.35-.3.7-.45 1.04l-.69-.81zm-.4.33 1.08.48c-.19.52-1.03.43-1.11-.11a.6.6 0 0 1 .03-.37zm15.25-9.54.97.68c-2.54 3.66-6.34 6.28-10.42 7.97-1.66.7-3.37 1.25-5.11 1.7l-.3-1.14c4.52-1.18 8.97-3.11 12.4-6.35a18.6 18.6 0 0 0 2.46-2.86zm.97.68-.97-.68c.28-.45 1.06-.24 1.07.3a.6.6 0 0 1-.1.38z'/%3e%3cpath fill='%2321231e' d='m461.29 400.2-1.18.1c-.07-.5.62-.85.99-.48.1.1.17.24.19.38zm4.43 15.72.72.94c-.28-.06-.62-.05-.87-.17-3.16-4.55-4.76-10.02-5.37-15.49l-.09-.9 1.18-.1c.49 5.31 1.9 10.65 4.82 15.17l.46.68c-.28-.05-.57-.1-.85-.13zm-.12.81.97-.68c.32.42-.14 1.08-.65.91a.6.6 0 0 1-.32-.23zm7.67-12.6 1.14.28a22.28 22.28 0 0 1-7.87 12.38c-.22.15-.35-.37-.54-.5-.22-.23-.37-.44 0-.6a21.13 21.13 0 0 0 7.27-11.57zm1.14.28-1.14-.29c.1-.5.87-.6 1.1-.13a.6.6 0 0 1 .04.42z'/%3e%3cpath fill='%23EDB92E' d='M405.91 317.77c-16.62 1.8-15.83 12.67-.29 28.04 2.97 2.94 4 2.85 4.63-.2 1.1-5.35 7.02-8.5 10.12-4.44 2.11 2.77 1.64 4.36 8.68 3.38 8.89 7.46 16.12 12.7 4.5 12.26-5.12-.19-9.07 2.8-15.73 2.54 1.97 3.82 2.32 4.27 3.39 4.6 6.46 1.27 13.27-2.77 19.79-1.57 14.28 2.64-22.89-38.63-22.43-40.26 1.18-4.15-8.93-11.6-12.66-4.35z'/%3e%3cpath fill='%2321231e' d='M405.97 345.46c-.64 1.24-1.28.09-1.92-.52-4.06-4.28-8.13-8.88-10.15-14.52-1.12-3.03-1-6.84 1.47-9.18 2.77-2.71 6.77-3.5 10.49-3.96.53 1.22-.65 1.08-1.53 1.2-3.4.58-7.26 1.6-9.22 4.7-1.82 3.1-.55 6.9 1 9.84 2.5 4.7 6.13 8.69 9.86 12.44zm3.8.04c1.23-.12.92.82.56 1.63a1.73 1.73 0 0 1-2.69.99c-.89-.52-1.63-1.24-2.37-1.95.56-1.05 1.1-.38 1.7.23.59.4 1.32 1.31 2.08.94.45-.5.56-1.21.71-1.84zm11-4.63c-.76 1.08-1.2 0-1.95-.47-3.6-2-7.5 1.82-8.08 5.3-1.32.13-.86-.91-.52-1.72 1.17-3.04 4.37-5.8 7.8-5 1.1.27 2.06 1 2.75 1.9zm8.6 3.3c-.83.9-.03.97-1.47 1.02-2.21.23-5.05.5-6.48-1.61-.5-.69-.92-1.43-1.44-2.1.7-.97 1.16-.23 1.58.52.65 1.25 1.78 2.37 3.3 2.31 1.47.18 2.96-.25 4.4-.18l.1.04zm-.4-.12zm4.55 13.26c-.35-1.27.77-.96 1.64-.97 1.29-.1 2.86.06 3.85-.91.2-1.26-1.04-2.2-1.76-3.1-2.66-2.67-5.66-4.96-8.52-7.4.52-1.25 1.23-.25 1.9.3 3.01 2.61 6.34 4.95 8.77 8.14.83.97 1 2.75-.38 3.32-1.7.77-3.68.64-5.5.62zm-15.26 1.8c-1.27 1.04-.72-.54.32-.25 4.56.16 8.73-1.99 13.18-2.49.61.1 2.07-.52 1.78.53.04.8-1.24.22-1.82.48-4.28.54-8.3 2.52-12.68 2.48-.75-.08-1.74.32-.78-.74zm-.89.46zm3.93 3.88c.14 1.2-.74 1.01-1.37.35-1.14-1.21-1.76-2.8-2.55-4.23.87-.85 1.19.05 1.54.83.7 1.07 1.1 2.63 2.43 3.07l-.05-.02zm-.19.98zm19.98-2.54c.15 1.25-.8.9-1.65.8-6.19-.38-12.12 2.93-18.33 1.74-.13-1.24.8-.88 1.65-.78 6.2.43 12.12-2.88 18.33-1.76zm-23-39.9c1 .04 1.28.6 1.76 1.4 7.28 9.72 15.32 18.91 21.69 29.29 1.4 2.52 3.07 5.1 3.22 8.07 0 1.35-1.22 2.3-2.52 2.25-1 .33-1.85-.69-.86-1.08.95.23 2.43.06 2.4-1.22-.27-3.04-2.07-5.67-3.55-8.25-6.25-9.99-14-18.9-21.06-28.31-.43-.67-1.07-1.31-1.08-2.15zm-12.13-3.72c.07-1.28-.86-.47.07-1.64 1.48-2.35 4.67-2.93 7.13-1.9 2.71 1.07 5.37 3.23 5.97 6.21.35.96-.4 1.76-1 .9.2-2.25-1.72-4.03-3.42-5.22-2.1-1.47-5.4-2.15-7.35-.05-.59.47-.74 1.33-1.4 1.7zm.4-.27zm-.45-.23zm.44.23z'/%3e%3cpath fill='%2321231e' d='m406.86 317.22-1.13.4c-.17-.44.3-.94.74-.77.18.05.33.2.39.37zm7.7 10.54-.77.9c-3.08-2.6-5.78-5.74-7.42-9.45-.24-.52-.45-1.06-.64-1.6l1.13-.39a23.66 23.66 0 0 0 6.27 9.26c.46.44.94.86 1.43 1.28zm-.77.9.77-.9c.38.29.22.96-.25 1.04a.59.59 0 0 1-.52-.13z'/%3e%3cpath fill='%2321231E' d='M404.333 324.19c.774.081 1.304.75 1.197 1.505s-.809 1.296-1.583 1.215-1.304-.75-1.197-1.505.809-1.296 1.583-1.215z'/%3e%3cpath fill='%2321231e' d='M358.42 362.56c.6-.47 1.33.54.69.96l-.69-.96zm-22.68 56.14c1.47-10.11 5.01-19.79 8.48-29.35 3.4-8.53 6.68-17.31 12.16-24.75.46-1.33 3.24-2.74 2.3-.73-4.49 4.66-6.9 10.86-9.6 16.64-4.92 11.7-9.35 23.7-11.87 36.17-.45 1.13.44 2.66-1.47 2.02zm5.55 80.36c-5.79-16.16-6.83-33.54-6.97-50.56 0-9.95.5-19.9 1.42-29.8 2.25-.32.53 2.67.84 3.99-1.59 21-1.9 42.36 2.2 63.12a89.33 89.33 0 0 0 3.62 12.84l-1.1.41zm1.11-.41c.3.7-.87 1.13-1.1.41l1.1-.41z'/%3e%3c/g%3e%3cuse xlink:href='%23d' transform='matrix(-1 0 0 1 964.3 0)'/%3e%3cpath fill='%2321231e' d='M473.11 398.36c-.37.11-.52.44-.45.86a36.34 36.34 0 0 0 5.92 17.89 49 49 0 0 0 3.03 4.16c.22.19.67.2.93.1.54-.51.97-1.17 1.44-1.76a39.12 39.12 0 0 0 5.96-11.3 34.9 34.9 0 0 0 1.7-9.48c-.08-.37-.54-.6-.87-.4-.45.2-.28.87-.35 1.35a37.09 37.09 0 0 1-.84 5.48 36.31 36.31 0 0 1-4.77 11.1 51.75 51.75 0 0 1-2.67 3.7 49.32 49.32 0 0 1-2.93-4.16 37.2 37.2 0 0 1-3.35-6.81 35.87 35.87 0 0 1-1.69-6.62c-.19-1.24-.24-2.54-.38-3.77-.12-.24-.35-.38-.68-.34z'/%3e%3cpath fill='%23C6363C' d='M549.18 422.03v108.56a72.16 72.16 0 0 1-19.67 49.81c-12.14 12.77-28.9 20.7-47.36 20.7s-35.22-7.92-47.36-20.7a72.15 72.15 0 0 1-19.67-49.8V422.02h134.06z'/%3e%3cuse xlink:href='%23e' transform='matrix(-1 0 0 1 964.3 -90.09)'/%3e%3cpath fill='%23FFF' stroke='%2321231E' stroke-width='.99' d='M549.18 488.62v27.98h-53.06v82.94a63.64 63.64 0 0 1-27.93 0V516.6h-53.07v-27.98h53.07v-66.59h27.93v66.59h53.06z'/%3e%3cuse xlink:href='%23e' y='-90.09'/%3e%3cpath id='e' fill='%23FFF' stroke='%2321231E' stroke-width='.99' d='M459.14 567.32v-39.33c-8.56-2.3-29.4-10.62-30.49 7.61-.5 8.43 10.44 13.99 13.4 6.54 1.4-3.52-.13-6.01-2.19-6.82-2.22-.87-4.43.93-3.84 3.61-8.86-4.64 7.92-14.48 15.5-1.67 2.2 3.74-3.73 7.63-3.74 10.4 0 2.76 5.83 6.9 3.73 10.39-7.67 12.75-24.35 2.96-15.49-1.67-.59 2.68 1.62 4.48 3.84 3.6 2.06-.8 3.58-3.3 2.18-6.82-2.95-7.44-13.89-1.88-13.39 6.55 1.09 18.23 21.93 9.91 30.49 7.6z'/%3e%3cuse xlink:href='%23e' transform='matrix(-1 0 0 1 964.3 0)'/%3e%3cpath fill='%2321231e' d='M414 420.86c.08 37.95-.15 75.9.12 113.85 1.2 27.86 19.67 54.5 46.21 63.77 22.43 8.32 49 2.59 66.38-13.74 16.2-14.52 24.65-36.69 23.58-58.24V420.86H414zm2.27 2.36h131.79c-.08 37.12.15 74.25-.12 111.37-1.13 26.66-18.72 52.26-44.03 61.41-21.59 8.29-47.34 3.04-64.31-12.57-16.02-14.08-24.42-35.74-23.34-56.92V423.22z'/%3e%3c/svg%3e";
            },
            6517: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9 6'%3e%3cpath fill='%23fff' d='M0 0h9v3H0z'/%3e%3cpath fill='%23d52b1e' d='M0 3h9v3H0z'/%3e%3cpath fill='%230039a6' d='M0 2h9v2H0z'/%3e%3c/svg%3e";
            },
            950: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1080 720'%3e%3cpath fill='%2320603D' d='M0 0h1080v720H0z'/%3e%3cpath fill='%23FAD201' d='M0 0h1080v540H0z'/%3e%3cpath fill='%2300A1DE' d='M0 0h1080v360H0z'/%3e%3cg transform='translate(886.5 188.1)'%3e%3cg id='b'%3e%3cpath id='a' fill='%23E5BE01' d='M116.1 0 35.692 4.699l76.452 25.35L33.26 13.777l67.286 44.273L28.56 21.915l53.534 60.18-60.18-53.534 36.135 71.985L13.777 33.26l16.272 78.884-25.35-76.452L0 116.1-1-1z'/%3e%3cuse xlink:href='%23a' transform='scale(1 -1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='scale(-1 1)'/%3e%3ccircle r='34.3' fill='%23E5BE01' stroke='%2300A1DE' stroke-width='3.4'/%3e%3c/g%3e%3c/svg%3e";
            },
            4707: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 750 500'%3e%3cpath fill='%23006c35' d='M0 0h750v500H0z'/%3e%3cpath fill='%23fff' fill-rule='evenodd' d='M323.28 118.09c-.388-.011-.968.205-1.781.688-1.829 1.225-5.452 5-5.563 9.343-.11 2.45-.573 2.441 1.031 4 1.16 1.671 2.317 1.507 4.657.282 1.343-.99 1.797-1.622 2.25-3.282.557-2.784-2.93 1.318-3.375-1.78-.78-2.877 1.446-4.06 3.562-6.845.049-1.31.072-2.38-.781-2.406zm34.062.188c-.653.087-1.453.925-2.563 2.937-.795 2.108-4.225 5.297-1.75 11.875 2.025 4.17 2.857 10.949 1.938 18.5-1.403 2.146-1.723 2.885-3.563 5.031-2.584 2.78-5.383 2.069-7.53 1.031-2.008-1.352-3.585-2.046-4.5-6.343.165-6.85.564-18.06-.688-20.438-1.846-3.684-4.888-2.363-6.188-1.25-6.247 5.712-9.333 15.357-11.219 23.03-1.732 5.594-3.579 3.976-4.875 1.72-3.156-2.958-3.377-26.084-7.187-22.282-6.102 17.44 3.502 36.545 10.156 34.688 4.8 1.988 7.847-7.15 9.812-17.156 1.345-2.808 2.372-3.13 3.063-1.687-.178 13.306.954 16.274 4.375 20.312 7.63 5.887 13.943.746 14.438.25l5.937-5.938c1.323-1.39 3.07-1.475 4.938-.25 1.815 1.65 1.582 4.493 5.469 6.47 3.27 1.308 10.255.317 11.875-2.5 2.18-3.737 2.708-5.021 3.718-6.438 1.557-2.072 4.22-1.154 4.22-.5-.249 1.155-1.813 2.294-.75 4.375 1.85 1.388 2.28.496 3.374.187 3.872-1.85 6.781-10.25 6.781-10.25.172-3.132-1.61-2.895-2.75-2.25-1.485.908-1.576 1.217-3.062 2.125-1.893.281-5.56 1.53-7.375-1.281-1.854-3.38-1.864-8.091-3.281-11.5 0-.248-2.477-5.36-.188-5.687 1.155.214 3.64.856 4.031-1.22 1.212-2.022-2.614-7.76-5.218-10.655-2.261-2.482-5.383-2.784-8.407-.25-2.117 1.948-1.803 4.124-2.218 6.187-.54 2.37-.437 5.305 1.968 8.438 2.114 4.168 5.954 9.515 4.688 17.062 0 0-2.231 3.591-6.156 3.125-1.636-.357-4.302-1.065-5.72-11.531-1.072-7.923.27-19.022-3.093-24.22-.759-1.96-1.41-3.865-2.5-3.718zm-10.78.84c-1.017.088-2.144 1.273-3.063 3.562-.788 1.74-1.75 10.844-1.593 10.844-.63 2.71 2.83 3.857 4.406.375 2.362-6.384 2.373-9.104 2.531-11.812-.368-2.063-1.264-3.058-2.281-2.969zm39.812.718c-1.045.095-1.877.707-2.188 2.25-.416 3.63-.203 5.603.407 8.625.467 2.015 3.4 5.389 4.844 7.344 6.896 9.27 13.53 18.583 19.938 28.219a294.127 294.127 0 0 1 2.218 21.125c1.039 15.284 1.354 34.31.407 50.406 2.863.113 7.451-4.624 9.062-11.562 1.047-9.598-.373-29.18-.469-34.844-.067-2.351-.212-5.157-.375-8.094A526.562 526.562 0 0 1 442 222.555c2.588-1.23 2.014-15.798.5-17.844-5.68-12.227-13.529-24.296-16.03-28.938-.904-1.676-3.98-6.354-7.626-11.75-.67-7.698-1.4-14.219-1.875-16.188-1.172-8.138 3.345.918 2.72-3.812-1.466-8.127-5.952-13.65-11.25-21.094-1.71-2.421-1.676-2.915-4.313.594-1.577 3.576-1.556 6.552-1.094 9.343a49.551 49.551 0 0 0-2.781-3.687c-4.576-3.926-4.859-4.14-8.657-7.344-1.197-.85-3.477-2.158-5.218-2zm118 1.22c-.509-.08-1.063.17-1.688 1.093-1.193 1.046-2.476 2.94-2.437 5.375.29 4.289 1.054 8.68 1.344 12.969.102.574.21 1.145.312 1.719a16.723 16.723 0 0 0-1.093-1.282c-8.36-8.782 3.84-1.435-1.594-8.218-4.596-5.047-5.941-6.653-9.875-9.688-1.973-1.275-3.165-3.711-3.813.438-.258 3.644-.526 7.865-.281 10.938-.014 1.707 1.754 4.921 3.281 6.812a731.007 731.007 0 0 1 17 21.75c1.205 15.516 1.527 29.74 2.75 45.281-.173 6.647-2.218 15.476-4.156 16.312 0 0-2.96 1.7-4.938-.187-1.438-.578-7.187-9.594-7.187-9.594-2.943-2.698-4.906-1.927-7 0-5.776 5.577-8.388 16.023-12.312 23.219-1.012 1.605-3.862 2.972-7.031-.125-8.049-10.996-3.342-26.648-4.344-22.625-7.169 8.078-3.994 21.465-2.375 24.344 2.364 4.728 4.276 7.755 8.875 10.094 4.189 3.083 7.45 1.159 9.25-1 4.215-4.369 4.271-15.54 6.25-17.75 1.388-4.06 4.866-3.362 6.562-1.563 1.644 2.364 3.585 3.902 6 5.188 3.932 3.468 8.625 4.098 13.25.937 3.161-1.773 5.212-4.077 7.063-8.625 1.986-5.31 1.004-33.142.562-48.625a628.708 628.708 0 0 1 8.813 12.781c1.278 13.591 1.858 26.976 1.437 39.812-.3 2.552 8.907-7.62 8.844-12.438-.041-4.215.008-8.036 0-11.594 4.466 7.13 8.79 14.38 12.875 21.72 2.532-1.342 1.664-15.679.063-17.657-4.278-7.178-9.757-14.936-14-20.938-.839-7.575-1.98-16.512-2.5-19.25-.81-4.27-1.62-10.683-2.844-15.75-.336-1.978-1.349-8.298-1.031-8.906.499-1.414 2.384.045 3.312-1.594 1.39-1.515-4.818-17.598-7.969-22.188-1.132-2.057-3.181-1.345-5.718 2-2.353 2.202-1.492 7.224-.594 12 2.333 12.174 4.415 24.572 6.062 36.938a1389.254 1389.254 0 0 0-10.438-15.312c-.098-.51-.468-2.38-.468-2.406 0-.219-.505-9.959-.938-12.28-.075-.943-.3-1.215.688-1.095 1.047.881 1.19.929 1.843 1.22 1.058.193 1.982-1.595 1.344-3.25-3.27-6.033-6.542-12.093-9.812-18.126-.394-.387-.835-.796-1.344-.875zm-304.53.312c-1.812-.052-3.812 1.071-3.031 3.25-.455 1.187 3.547 5.2 4.25 7.406.63 1.57-.625 6.627.687 7.094 1.207.523 2.868-3.501 3.5-7.22.35-2.036.085-9.007-4.656-10.437a3.886 3.886 0 0 0-.75-.094zm346.91.04c-.413.04-.916.708-1.687 2.343-1.855 3.038-2.493 8.478-1.75 13.281 4.465 30.203 7.783 59.45 8.468 86.22-.384 2.54-.496 3.892-1.687 7.093-2.636 3.379-5.543 7.614-8.281 9.656-2.738 2.041-8.564 3.987-10.47 5.5-6.043 3.494-6.073 7.511-1.187 7.657 8.421-.978 18.386-1.669 25.25-12.031 1.837-2.904 4-10.776 4.094-15.594.642-28.247-.362-55.866-4.594-76.281-.271-1.99-1.15-6.56-.812-7.157.545-1.398 3.3.14 4.28-1.468 1.44-1.47-7.125-12.436-10.124-17.125-.6-1.178-.969-2.147-1.5-2.094zm-88.312.468c-.348.06-.861.59-1.812 1.844-2.353 7.692-3.18 13.973-2.282 18.75 6.043 31.534 12.234 60.263 11.25 90.281 2.866.02 6.179-6.555 7.594-13.062.775-8.963-.517-14.419-.75-19.688-.232-5.268-5.964-48.014-7.125-52-1.4-7.537 5.574-.991 4.813-5.375-2.411-5.526-8.43-13.574-10.312-18.375-.708-1.286-.796-2.475-1.375-2.375zm-215.03.594c-.743.129-1.46.74-1.719 1.75-.163.661.286 1.761-.312 2.094-.344.347-1.648.114-1.594-1.719 0-.584-.429-1.193-.688-1.562-.26-.17-.435-.22-.906-.22-.573.024-.56.175-.875.657-.14.49-.32.97-.32 1.53-.071.652-.333.873-.812.969-.537 0-.41.058-.844-.219-.258-.282-.563-.393-.563-.875 0-.499-.13-1.295-.28-1.625-.229-.3-.589-.457-1-.562-2.248.008-2.411 2.59-2.282 3.562-.168.183-.252 4.76 2.812 6.031 4.114 1.962 11.827 1.132 11.5-5.5 0-.586-.129-2.556-.187-3.094-.42-.977-1.195-1.347-1.938-1.218zm55.188.063a9.19 9.19 0 0 0-3.75 1.03c-2.726 2.611-3.366 6.796-1.219 9.407 2.09.987 4.174 3.09 2.781 4.25-5.908 6.311-21.287 16.857-22.062 18.781-.006.016-.027.048-.03.062-.003.014 0 .05 0 .063 0 .006-.002.026 0 .031a.29.29 0 0 0 .03.063c.004.004.027.027.032.03.005.004.025-.002.03 0 .007.004.025.03.032.032.007.002.023-.002.031 0l.031.031c.782.524 10.404.512 11.47.031.007-.004.024-.027.03-.03.004-.003.03.001.032 0 .002-.003-.002-.03 0-.032 3.307-1.219 19-19.156 19-19.156-.814-.696-1.563-1.21-2.375-1.906-.871-.754-.783-1.495 0-2.25 3.886-2.262 2.655-7.238.625-9.5-1.683-.755-3.266-1.01-4.688-.938zm144.25.062c-.413.041-.916.677-1.687 2.313-1.855 3.037-3.115 8.328-2.97 13.28 4.018 27.815 5.25 52.155 7.876 79.97.213 2.69-.181 6.598-1.97 8.156-6.613 6.906-16.15 15.424-26.53 19.344-1.117 1.254 2.777 6.599 7.812 6.594 8.422-.978 15.823-5.705 22.688-18.156 1.836-2.904 5.062-9.12 5.157-13.938.642-28.247-1.424-50.21-5.657-70.625-.27-1.989-.086-4.341.25-4.938.546-.651 2.395.015 3.375-1.594 1.44-1.47-3.844-13.655-6.843-18.344-.6-1.177-.97-2.115-1.5-2.062zm-223.47.85c-1.162.136-2.256 1.082-2.781 2.344-.195 4.461-.22 8.92.281 13.03 2.03 7.212 2.672 13.554 3.656 20.939.273 9.89-5.711 4.278-5.437-.625 1.382-6.37 1.009-16.396-.219-18.938-.974-2.541-2.101-3.168-4.469-2.75-1.88-.115-6.736 5.176-8.094 13.938 0 0-1.13 4.496-1.625 8.5-.664 4.524-3.661 7.729-5.75-.625-1.805-6.072-2.914-21.032-5.937-17.531-.866 11.68-1.894 32.235 8.031 34.344 12.005 1.154 5.374-20.294 9.719-24.188.821-1.924 2.344-1.959 2.469.469v18.219c-.11 5.922 3.787 7.682 6.812 8.906 3.148-.243 5.235-.157 6.469 2.906.492 10.502 1.008 21.03 1.5 31.531 0 0 7.277 2.091 7.625-17.719.349-11.632-2.316-21.393-.75-23.656.055-2.223 2.906-2.333 4.875-1.25 3.138 2.213 4.53 4.937 9.406 3.844 7.42-2.044 11.89-5.646 12-11.344-.433-5.415-1.06-10.835-3.406-16.25.328-.985-1.42-3.547-1.094-4.531 1.334 2.088 3.351 1.915 3.813 0-1.263-4.162-3.23-8.15-6.406-9.875-2.626-2.314-6.468-1.824-7.875 3-.653 5.558 2.014 12.147 6.062 17.53.86 2.104 2.062 5.603 1.531 8.75-2.154 1.23-4.29.718-6.094-1.187 0 0-5.906-4.421-5.906-5.406 1.568-10.035.338-11.184-.531-13.97-.607-3.843-2.429-5.06-3.906-7.687-1.478-1.566-3.482-1.566-4.438 0-2.61 4.526-1.386 14.242.5 18.594 1.363 4.003 3.453 6.5 2.47 6.5-.811 2.262-2.501 1.736-3.72-.875-1.74-5.395-2.094-13.437-2.094-17.062-.522-4.494-1.104-14.095-4.062-16.53-.79-1.076-1.721-1.45-2.625-1.344zm42.156.063c-.596.075-1.254.414-2.031.593-2.552.813-4.942 3.019-4.188 7.313 3.017 18.332 4.984 32.323 8 50.656.464 2.147-1.336 4.977-3.656 4.687-3.945-2.669-4.924-8.074-11.656-7.843-4.873.058-10.43 5.361-11.125 10.469-.812 4.059-1.102 8.46 0 12 3.425 4.118 7.528 3.679 11.125 2.75 2.958-1.218 5.392-4.133 6.438-3.438.003.003.028-.004.03 0 .004.004-.002.027 0 .031.646 1.128-.06 10.663-13.937 18.031-8.528 3.83-15.316 4.744-18.97-2.219-2.262-4.35.165-20.924-5.405-17.094-16.475 42.467 38.598 48.395 44.75 1.75.398-1.315 1.612-2.636 2.468-2.312.376.16.72.67.844 1.625-1.277 42.235-42.606 45.13-49.625 31.844-1.74-3.132-2.263-10.103-2.437-14.281-.319-2.528-.953-3.985-1.688-4.563-1.674-1.258-3.925 2.023-4.406 7.72-.697 4.582-.5 5.84-.5 10.25 2.204 33.358 55.388 19.025 64.031-8.532 4.279-14.246-.087-24.993 1.344-26.312.012-.01.05-.022.062-.031l.063-.031c.015-.006.046-.027.062-.032a.894.894 0 0 1 .188-.03c5.28 5.686 12.688.722 14.312-1.25.696-.988 2.438-1.62 3.656-.345 4.118 2.96 11.337 1.565 12.844-3.656.87-5.105 1.607-10.36 1.781-15.812-2.683.833-4.847 1.457-5.719 2.375-.207.227-.36.478-.406.75-.233 1.51-.455 3.023-.687 4.531-.025.125-.065.24-.125.344a1.455 1.455 0 0 1-.5.469c-.949.518-2.603.222-2.688-1.156-1.276-5.802-6.527-6.557-9.719 2.437-2.147 1.74-6.061 2.08-6.468-.531.522-6.034-1.91-6.843-6.782-4-1.566-11.951-3.12-23.361-4.687-35.312 2.03-.059 3.893 1.414 5.75-.906-2.01-6.249-6.26-18.963-8.656-20.156-.02-.01-.044-.024-.063-.031a3.182 3.182 0 0 0-.5-.47c-.044-.03-.112-.068-.156-.093a1.73 1.73 0 0 0-.313-.125 1.614 1.614 0 0 0-.656-.062zm164.34.093c-2.108-.062-4.44 1.266-3.531 3.906-.53 1.44 4.528 6.326 5.344 9 1.467 4.109-1.121 8.028.406 8.594 1.405.634 3.36-4.241 4.094-8.75.847-3.644-1.753-11.114-5.438-12.656a4.367 4.367 0 0 0-.875-.093zm-128.03 4.5c.96-.098 2.12.784 2.688 2.031.605 1.33.301 2.602-.688 2.844-.99.243-2.27-.638-2.875-1.969-.606-1.33-.302-2.632.688-2.875.061-.015.123-.024.187-.03zm237.5 6.156c-1.921-.067-4.016 1.392-3.187 4.25-.482 1.56 4.1 6.856 4.843 9.75.669 2.06-1.017 8.7.375 9.313 1.281.686 3.082-4.587 3.75-9.469.371-2.672-1.609-12.049-4.968-13.719a3.524 3.524 0 0 0-.813-.125zm-131.31 3.25c.176.784.351 1.573.469 2.375.394 1.732.733 3.452 1.094 5.157-1.517-2.089-2.773-3.777-3.313-4.375-3.432-4.08.077-2.679 1.75-3.157zm30.25 14.875c-.743.13-1.46.772-1.719 1.782-.163.66.318 1.73-.281 2.062-.344.347-1.68.145-1.625-1.687 0-.584-.429-1.224-.688-1.594-.26-.17-.435-.219-.906-.219-.573.023-.56.175-.875.656-.133.491-.312.975-.312 1.532-.072.652-.302.873-.782.968-.536 0-.44.059-.875-.218-.258-.283-.562-.394-.562-.875 0-.5-.131-1.296-.281-1.625-.228-.3-.588-.426-1-.532-2.247.008-2.38 2.559-2.25 3.532-.169.183-.283 4.79 2.78 6.062 4.114 1.961 11.859 1.101 11.532-5.531 0-.587-.16-2.557-.219-3.094-.42-.978-1.195-1.347-1.937-1.219zm-138.12 1.375c-.507-.051-1.172.135-1.937.594-3.638 1.968-5.047 7.804-2.782 11.22 2.116 3.007 5.461 1.905 5.907 1.905 3.564.446 5.687-6.687 5.687-6.687s.107-2.006-4.125 1.781c-1.781.334-2.023-.31-2.469-1.312-.37-1.856-.291-3.737.563-5.594.394-1.113.002-1.82-.844-1.906zm195.25.907c-2.02-.098-4.169 1.21-4.719 3.969.008 1.627.735 2.522.594 4-.21.844-1.08 1.4-3.156.406.324-.299-1.344-2.656-1.344-2.656-1.619-.986-3.78.053-5.188.968-.774 1.407-1.346 3.82-.468 6.281 2.323 4.293 10.293 11.618 14.094 11.688.07-3.87.446-9.017.656-12.219.09-1.208.373-2.54 1.531-2.843 1.157-.303 3.165 1.164 3.188-.094-.211-2.462-.703-6.096-2.094-7.813-.713-1.055-1.882-1.628-3.094-1.687zm-161.62 13.469c-.054.02-.107.065-.156.093-.024.015-.07.045-.094.063-.402.302-.877.999-1.937 1.75-1.79 2.035-2.11 3.452-2 7.531.101.432 3.396 9.592 6.187 16.031 1.882 6.693 3.623 14.356 2.344 21.594-4.406 9.569-13.263 18.15-21.812 22.812-4.356 1.395-8.118.92-9.125-.031l-.031-.031c-2.502-1.682-2.56-4.676-2.407-5.188v-.031l.032-.031c7.213-5.025 15.454-9.092 21.906-22.656 1.905-5.184 2.486-8.297.593-16.312-.738-2.987-1.649-5.445-3.687-7.563l.031-.03c1.228-.588 4.414 1.759 4.906.28-.754-3.827-3.346-8.965-6.28-11.594-2.571-2.334-5.367-2.604-7.72-.468-2.65 1.474-3.213 6.77-1.937 11.406 1.417 3.49 5.243 4.101 7.969 11.125v.03c.056.441.935 5.243-.438 7.188-1.114 3.474-15.424 14.76-16.438 15.438-.011.011-.083.052-.094.063l-.03.031c-.004.002-.025.024-.032.031l-.031.031h-.063a.706.706 0 0 1-.03-.03v-.032c-.007-.01-.026-.051-.032-.063-.043-.281.033-.999 0-2.156-.094-2.114.781-6.898.719-7.719v-.03l-.031-.032v-.031h-.032c-4.73 3.054-6.292 12.416-7.156 15.188-11.975 8.274-25.574 14.43-33.406 22.812-4.079 6.37 28.104-7.315 31.844-8.969.032.024.064.063.094.094.71.782.771 3.51 2.906 5.969 3.345 4.531 10.456 7.322 17.375 5.593 11.603-4.194 18.288-12.102 25.094-20.875.973-1.415 2.497-2.53 3.906-1.437 4.677 10.47 18.161 17.92 35.594 18.688 4.034-4.906 2.105-7.318.469-8.344-.504-.335-8.67-3.518-9.938-6.687-.798-2.95 1.143-5.565 5.032-7.532 11.193-1.353 22.196-2.857 32.844-6.28.108-3.578 2.215-8.928 3.625-11.25.979-1.613 1.608-1.772 1.843-2l.032-.032c.003-.004.028-.027.03-.031.007-.005.027-.026.032-.031v-.063c.006-.07 0-.193-.031-.312l-1.813-1.063-35.719-.156c-.44-.17-.769-.34-.968-.5-.016-.013-.05-.05-.063-.063l-.031-.03-.031-.032c-.005-.011-.027-.052-.031-.063l-.032-.03v-.032l-.03-.031v-.249c.005-.007.025-.026.03-.032.008-.016.02-.046.032-.062.174-.235.597-.457 1.125-.657 8.529-1.162 23.682-3.646 24.688-18.219-.158-7.59-3.249-12.56-12.562-13.938-6.844.53-11.725 7.15-10.938 14.438-.328 1.963.664 5.814-1.344 6.25-13.128 1.2-27.457 9.425-27.938 15.312h-.031l-.032.031-.062.032h-.063a1.44 1.44 0 0 1-.093.03h-.094a1.513 1.513 0 0 1-.094 0c-.034-.006-.095-.023-.125-.03-.854-.237-1.954-1.647-1.781-3.625-.5-10.177-3.812-21.693-9-30.562-1.851-1.851-2.658-2.601-3.187-2.688-.018-.002-.046.001-.063 0h-.187zm34.188 5.375c-.743.128-1.46.74-1.719 1.75-.163.66.318 1.76-.281 2.093-.344.347-1.68.145-1.625-1.687 0-.584-.429-1.224-.688-1.594-.26-.17-.404-.219-.875-.219-.573.024-.591.175-.906.657-.133.49-.312.975-.312 1.53-.072.653-.302.874-.782.97-.536 0-.409.058-.843-.22-.258-.281-.594-.392-.594-.874 0-.499-.1-1.295-.25-1.625-.228-.3-.62-.426-1.031-.531-2.247.008-2.38 2.558-2.25 3.53-.169.184-.283 4.791 2.781 6.063 4.113 1.962 13.916.807 11.531-5.53 0-.587-.16-2.557-.219-3.095-.42-.977-1.195-1.347-1.937-1.218zm137.97 5.656a.679.679 0 0 0-.344.031s-19.059 13.56-19.53 14.031c-1.89 1.68-.945 7.589 0 6.906 1.365.525 20.553-12.478 20.187-14 .837.05 1.239-6.689-.312-6.968zm-119.96 2.01c.778-.083 1.798.181 2.781.75 1.423.823 2.3 2.066 2.188 2.969-.004.024.005.07 0 .093-.006.024-.056.07-.063.094-.008.023-.022.071-.031.094-.006.015-.024.048-.031.062l-.031.063a1.25 1.25 0 0 1-.188.219c-.684.638-2.262.547-3.75-.313-1.41-.815-2.28-2.068-2.187-2.969.003-.024.026-.07.03-.093.024-.112.069-.214.126-.313.02-.035.038-.093.062-.125l.032-.031a1.43 1.43 0 0 1 .156-.156 1.78 1.78 0 0 1 .906-.344zm-166.91 3.437c-9.876.18-24.338 12.945-24.719 20.031 10.421-5.004 20.657-9.82 31.25-15-1.71-2.552-.104-4.851-6.531-5.03zm32 4.438c.968.01 1.99.489 2.531 1.844.488 1.242.023 2.542-.562 3.187-.003.005.003.026 0 .031-.01.015-.022.05-.031.063-.415.534-1.87.312-2.907.312-1.254-.055-1.872-.26-2.625-1.28-.36-1.135.736-2.249 1.22-3.095.004-.008.025-.023.03-.03.053-.08.138-.174.22-.25.374-.344 1.023-.665 1.718-.75.135-.017.268-.034.406-.032zm251.16 3.93c-1.756.216-3.425 1.877-2.656 4.531-.482 1.56 2.382 7.012 3.125 9.906.668 2.06-.86 7.888.531 8.5 1.281.687 4.65-3.459 4.531-8.656.371-2.672-.953-12.517-4.312-14.188a3.164 3.164 0 0 0-1.219-.094zm-213.31 9.625c-1.552.108-2.937.938-2.312 3.125-.094 1.586 4.385 3.515 4.656 7.187.64 1.514-.958 6.362.375 6.813 1.223.504 2.921-3.351 3.562-6.938.355-1.964-1.536-8.835-4.75-10.062a5.5 5.5 0 0 0-1.531-.125zm63.844 8.719c.118-.008.222 0 .344 0h.062c3.98 1.081 9.846 1.193 14.938 1.718 4.148.264 6.197 3.51 2.313 4.875-3.832 1.313-7.514 2.338-7.531 7.875.503 2.744.397 4.183-.032 4.844-.033.05-.087.116-.125.157l-.03.03-.032.032-.031.031-.031.031-.063.032a1.102 1.102 0 0 1-.187.093c-.054.018-.131.022-.188.031-.91.134-2.234-.735-3.219-1.25-2.362-1.696-8.993-5.805-9.937-14.625-.135-1.99 1.355-3.706 3.75-3.875zm-155.94 6.78c-.249.009-.746.752-1.406 1.595-5.875 9.36-6.398 23.33-3.156 27.5 1.722 1.97 4.562 2.835 6.656 2.218 3.69-1.6 5.313-9.077 4.437-11.812-1.231-1.928-2.207-2.233-3.437-.593-2.598 5.273-3.679 1.666-3.906-1.281-.399-5.59.143-10.736.75-14.812.323-2.09.31-2.82.062-2.813zm200.16 12.29a2.695 2.695 0 0 0-1.375.282c-.093 0-4.206 2.782-5.531 4.719-.809.615-.717 1.15-.469 2.219.63 1.448 1.74.994 3 .312 1.672-.228 2.48.867 2.344 2.875-.772 2.504.344 3.437.344 3.594 0 .157 1.61 1.54 3.5.438 3.989-1.523 6.475-3.005 12.062-4.22 1.466-.028 1.381-3.953-.938-4.093-3.026.152-5.818.307-8.844 2.687-1.861.43-2.18-.702-2.593-1.718-.473-2.521 1.064-4.298.75-6.188.083.083-.94-.836-2.25-.906zm128.16 4.782c-.742.023-1.524.126-2.656.219-1.225.26-1.652.796-1.875 2.281.088 2.252 1.465 2.14 2.875 3.031.816 1.04 1.347 1.98-.063 3.688-1.336 1.224-2.288 1.9-3.625 3.125-.63 1.076-1.024 2.73.907 3.25 3.564 1.002 11.812-4.357 11.812-4.469 1.336-1.002.893-2.906.78-2.906-.778-.891-2.537-.356-3.718-.5-.562 0-2.41-.274-1.531-1.906.733-1.016 1.003-1.624 1.5-2.875.556-1.225.067-2.05-1.938-2.72-1.02-.185-1.726-.241-2.468-.218zm-53.54 108.4c-.008.004-.023.026-.031.031-5.928 1.521-5.744 7.675-1.938 10.375-62.594 0-158.65-1.062-179.25-1.062-11.525 0-47.987-1.375-48.688-1.375 7.82 11.437 19.147 13.766 33.97 14 27.801 0 156.62-.344 193.28-.344-2.607 4.628.236 12.074 2.28 13.438.044.028.114.072.157.094.076.038.177.075.25.093.024.006.07-.003.093 0 2.428.573 3.496-1.184 4.313-2.468 3.937.347 26.097.667 28.125-.032.007-.003.024-.028.031-.03 1.372 2.018 2.733 3.926 5.344 3.593 4.569-.98 8.167-1.477 8.281-10.75 0 0-.467-15.802-10.844-14.812-2.455.371-9.344 1.063-9.344 1.063-7.971-.949-13.819-1.046-22.78-1.375.827-1.05 2.287-5.304.5-6.844-.467-.388-1.162-.604-2.126-.531h-.03c-.014-.001-.05.002-.063 0-.007-.002-.025-.03-.032-.032-.025-.009-.069-.016-.093-.03a.946.946 0 0 1-.157-.157c-.01-.014-.051-.048-.062-.063-.453-.66-.7-2.277-1-2.687l-.031-.031-.031-.032a.506.506 0 0 0-.063-.03h-.031c-.004 0-.028-.002-.031 0zm4.25 22.594c.01-.005.02.005.031 0 9.132.446 17.712.086 26.844.531 1.448 1.23.724 4.049-.219 4.563a1.032 1.032 0 0 1-.156.062c-.034.008-.09 0-.125 0-.034 0-.09.008-.125 0-2.97-.074-4.687-.144-7.656-.218a1.716 1.716 0 0 0-.063-.438c-.703-2.085-5.8-1.946-7-.312l-.062.093c-.02.033-.046.092-.063.125a1.894 1.894 0 0 0-.062.157c-.019.061-.023.153-.031.218-.008.075-.038.171-.031.25-4.009.482-7.617-.133-11.625-.28-1.177-1.465-1.04-4.114.343-4.75z'/%3e%3c/svg%3e";
            },
            4520: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 800 400'%3e%3cpath fill='%230051ba' d='M0 400V0h800z'/%3e%3cpath fill='%23215b33' d='M0 400h800V0z'/%3e%3cpath stroke='%23fcd116' stroke-width='36' d='M0 400 800 0'/%3e%3cg transform='translate(140 120)'%3e%3cg id='d' fill='%23fff'%3e%3cg id='c'%3e%3cg id='b'%3e%3cpath id='a' d='M0-40V0h20z' transform='rotate(18 0 -40)'/%3e%3cuse xlink:href='%23a' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(72)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(-72)'/%3e%3cuse xlink:href='%23c' transform='rotate(144)'/%3e%3c/g%3e%3cg id='f' transform='rotate(40.6)'%3e%3cuse xlink:href='%23d' id='e' x='-104' transform='rotate(-40.6 -104 0)'/%3e%3cuse xlink:href='%23e' x='208'/%3e%3c/g%3e%3cuse xlink:href='%23f' transform='scale(-1 1)'/%3e%3c/g%3e%3c/svg%3e";
            },
            9228: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 450'%3e%3cpath fill='%23d62828' d='M0 450h900V0H0z'/%3e%3cpath fill='%23fcd856' d='M0 450V0h600z'/%3e%3cpath fill='%23003f87' d='M0 450V0h300z'/%3e%3cpath fill='%23fff' d='M0 450h900V150z'/%3e%3cpath fill='%23007a3d' d='M0 450h900V300z'/%3e%3c/svg%3e";
            },
            9230: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 6'%3e%3cpath d='M0 0h12v6H0z'/%3e%3cpath fill='%23FFF' d='M0 0h12v4H0z'/%3e%3cpath fill='%23D21034' d='M0 0h12v2H0z'/%3e%3cpath fill='%23007229' d='m0 0 4 3-4 3z'/%3e%3c/svg%3e";
            },
            5738: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 10'%3e%3cpath fill='%23006aa7' d='M0 0h16v10H0z'/%3e%3cpath fill='%23fecc00' d='M5 0h2v10H5z'/%3e%3cpath fill='%23fecc00' d='M0 4h16v2H0z'/%3e%3c/svg%3e";
            },
            8623: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 4320 2880'%3e%3cpath fill='%23ed2939' d='M0 0h4320v1440H0z'/%3e%3cpath fill='%23fff' d='M0 1440h4320v1440H0zm1481.678-720a541.5 541.5 0 1 1-1083 0 541.5 541.5 0 1 1 1083 0z'/%3e%3cpath fill='%23ed2939' d='M1651.835 720a511.735 511.735 0 1 1-1023.47 0 511.735 511.735 0 1 1 1023.47 0z'/%3e%3cpath id='a' fill='%23fff' d='m1007.195 733.064-73.56-56.43-73.542 56.457 28.313-90.994-73.795-56.092 91.06.193 27.934-91.123 27.964 91.113 91.06-.226-73.777 56.119 28.343 90.983z'/%3e%3cuse xlink:href='%23a' transform='translate(577.189)'/%3e%3cuse xlink:href='%23a' transform='translate(288.889 -214.211)'/%3e%3cuse xlink:href='%23a' transform='translate(108 342.749)'/%3e%3cuse xlink:href='%23a' transform='translate(469.189 342.749)'/%3e%3c/svg%3e";
            },
            3226: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 30'%3e%3cclipPath id='a'%3e%3cpath d='M0 0v30h60V0z'/%3e%3c/clipPath%3e%3cclipPath id='b'%3e%3cpath d='M30 15h30v15zv15H0zH0V0zV0h30z'/%3e%3c/clipPath%3e%3cg clip-path='url(%23a)'%3e%3cpath fill='%23012169' d='M0 0v30h60V0z'/%3e%3cpath stroke='%23fff' stroke-width='6' d='m0 0 60 30m0-30L0 30'/%3e%3cpath stroke='%23C8102E' stroke-width='4' d='m0 0 60 30m0-30L0 30' clip-path='url(%23b)'/%3e%3cpath stroke='%23fff' stroke-width='10' d='M30 0v30M0 15h60'/%3e%3cpath stroke='%23C8102E' stroke-width='6' d='M30 0v30M0 15h60'/%3e%3c/g%3e%3c/svg%3e";
            },
            2775: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 12 6'%3e %3ctitle%3eFlag of Slovenia%3c/title%3e %3crect width='12' fill='%23ed1c24' height='6'/%3e %3crect width='12' fill='%23005da4' height='4'/%3e %3crect width='12' fill='%23fff' height='2'/%3e %3cg transform='translate(2.2238 1) scale(.12937)'%3e %3csvg width='12' viewBox='-120 -190.223125 240 309.188274' height='15.459'%3e %3cpath d='m110.26-19.478l9.74-143.75a280.22 280.22 0 0 0 -240 0l9.74 143.75a155.61 155.61 0 0 0 110.26 138.45 155.61 155.61 0 0 0 110.26 -138.45' fill='%23005da4'/%3e %3cpath d='m-90 0a138.29 138.29 0 0 0 90 100.77 138.29 138.29 0 0 0 90 -100.77l-45-60-18 24-27-54-27 54-18-24-45 60' fill='%23fff'/%3e %3cg id='wave' fill='%23005da4' transform='scale(5) translate(0 5.1962)'%3e %3cpath d='m-17.196-2.1962a6 6 0 0 0 8.1962 2.1962 6 6 0 0 1 6 0 6 6 0 0 0 6 0 6 6 0 0 1 6 0 6 6 0 0 0 8.1962 -2.1962v1.732a6 6 0 0 1 -8.1962 2.1962 6 6 0 0 0 -6 0 6 6 0 0 1 -6 0 6 6 0 0 0 -6 0 6 6 0 0 1 -8.1962 -2.1962z'/%3e %3c/g%3e %3cuse xlink:href='%23wave' transform='translate(0 17.321)'/%3e %3cg id='s' transform='translate(0,-120) scale(2.25)'%3e %3cpath stroke-width='.2' d='m0-5l1 3.2679 3.3301-0.7679-2.3301 2.5 2.3301 2.5-3.3301-0.7679-1 3.2679-1-3.2679-3.3301 0.7679 2.3301-2.5-2.3301-2.5 3.3301 0.7679z' fill='%23fd0'/%3e %3c/g%3e %3cuse xlink:href='%23s' transform='translate(-33.75,-45)'/%3e %3cuse xlink:href='%23s' transform='translate(33.75,-45)'/%3e %3cpath d='m-111.58-167.05l9.96 146.99a146.95 146.95 0 0 0 101.62 129.95 146.95 146.95 0 0 0 101.62 -129.95l9.96-146.99a280.22 280.22 0 0 0 8.42 3.82l-9.74 143.75a155.61 155.61 0 0 1 -110.26 138.45 155.61 155.61 0 0 1 -110.26 -138.45l-9.74-143.75a280.22 280.22 0 0 0 8.42 -3.82' fill='%23ed1c24'/%3e %3c/svg%3e %3c/g%3e %3c/svg%3e";
            },
            4989: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1100 800'%3e%3cpath fill='%23ef2b2d' d='M0 0h1100v800H0z'/%3e%3cpath fill='%23fff' d='M300 0h200v800H300z'/%3e%3cpath fill='%23fff' d='M0 300h1100v200H0z'/%3e%3cpath fill='%23002868' d='M350 0h100v800H350z'/%3e%3cpath fill='%23002868' d='M0 350h1100v100H0z'/%3e%3c/svg%3e";
            },
            5299: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9 6'%3e%3cpath fill='%23ee1c25' d='M0 0h9v6H0z'/%3e%3cpath fill='%230b4ea2' d='M0 0h9v4H0z'/%3e%3cpath fill='%23fff' d='M0 0h9v2H0z'/%3e%3cpath fill='%23fff' d='M3.163 4.635c-.538-.259-1.308-.773-1.308-1.79s.05-1.48.05-1.48H4.42s.049.463.049 1.48-.77 1.53-1.307 1.79z'/%3e%3cpath fill='%23ee1c25' d='M3.163 4.5c-.494-.238-1.2-.71-1.2-1.643S2.008 1.5 2.008 1.5h2.309s.045.424.045 1.357c0 .934-.706 1.405-1.2 1.643z'/%3e%3cpath fill='%23fff' d='M3.268 2.613c.134.002.394.007.626-.07 0 0-.006.083-.006.18 0 .096.006.18.006.18-.212-.072-.475-.074-.626-.072v.516h-.211V2.83c-.15-.002-.413 0-.626.071 0 0 .006-.083.006-.18 0-.096-.006-.18-.006-.18.232.078.492.073.626.07V2.29a1.481 1.481 0 0 0-.496.071s.007-.083.007-.18c0-.096-.007-.18-.007-.18.199.067.374.073.496.072-.007-.205-.066-.464-.066-.464s.122.01.172.01c.049 0 .172-.01.172-.01s-.06.259-.066.464A1.48 1.48 0 0 0 3.764 2s-.006.083-.006.18c0 .096.006.18.006.18a1.481 1.481 0 0 0-.496-.072v.324z'/%3e%3cpath fill='%230b4ea2' d='M3.163 3.29c-.249 0-.382.346-.382.346s-.074-.164-.277-.164c-.137 0-.238.122-.302.235.25.397.648.642.96.793.313-.15.712-.396.961-.793-.064-.113-.165-.235-.302-.235-.203 0-.277.164-.277.164s-.133-.345-.382-.345z'/%3e%3c/svg%3e";
            },
            5084: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 300'%3e%3cpath fill='%230072C6' d='M0 0h450v300H0z'/%3e%3cpath fill='%23FFF' d='M0 0h450v200H0z'/%3e%3cpath fill='%231EB53A' d='M0 0h450v100H0z'/%3e%3c/svg%3e";
            },
            694: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 800 600'%3e%3cpath fill='%235eb6e4' d='M0 0h800v600H0z'/%3e%3cpath fill='%23fff' d='M0 0h800v300H0z'/%3e%3cg fill='none' stroke='%23000' stroke-width='.93'%3e%3cg fill='%23fff'%3e%3ccircle cx='459.44' cy='171.23' r='4.04'/%3e%3ccircle cx='461.69' cy='157.02' r='5.08'/%3e%3ccircle cx='376.39' cy='141.72' r='3.91'/%3e%3ccircle cx='338.47' cy='157.02' r='5.08'/%3e%3ccircle cx='361.67' cy='143.37' r='4.22'/%3e%3ccircle cx='340.72' cy='171.23' r='4.04'/%3e%3ccircle cx='346.87' cy='147.12' r='4.88'/%3e%3ccircle cx='423.77' cy='141.72' r='3.91'/%3e%3ccircle cx='438.49' cy='143.37' r='4.22'/%3e%3ccircle cx='453.29' cy='147.12' r='4.89'/%3e%3c/g%3e%3cg stroke-width='1.09'%3e%3ccircle cx='459.44' cy='171.23' r='4.46'/%3e%3ccircle cx='461.69' cy='157.03' r='5.6'/%3e%3ccircle cx='376.39' cy='141.72' r='4.31'/%3e%3ccircle cx='338.47' cy='157.03' r='5.6'/%3e%3ccircle cx='361.67' cy='143.37' r='4.65'/%3e%3ccircle cx='340.72' cy='171.23' r='4.46'/%3e%3ccircle cx='346.87' cy='147.12' r='5.39'/%3e%3ccircle cx='423.77' cy='141.72' r='4.31'/%3e%3ccircle cx='438.49' cy='143.37' r='4.65'/%3e%3ccircle cx='453.29' cy='147.12' r='5.39'/%3e%3c/g%3e%3cg fill='%23000' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M392.49 132.02c-13.49 15.53-37.16 7.94-47.95 14-18.79 10.52 1.64 35.48 5.5 40.25l20.46-5.34c-7.51-6.01-22.59-16.23-18.05-24.53 4.66-8.5 29.37.13 40.18-18.04 2.28-3.82.53-7.12-.14-6.34z'/%3e%3cpath fill='%23f1bf31' d='M392.49 132.48c-13.49 15.54-36.4 8.1-47.19 14.15-18.78 10.52 2.43 34.87 6.28 39.64l17.68-5.34c-7.52-6.01-21.8-16.54-17.26-24.83 4.65-8.51 29.82-.04 40.63-18.2 2.28-3.82.53-6.2-.14-5.42z'/%3e%3cpath stroke-width='.63' d='M393.71 133.68c-14.6 19.71-36.52 9.76-45.94 17.45-10.64 8.7 4.86 25.8 12.34 32.57l1.17-.43c-6.07-5.76-24.06-22.84-12.63-32.07 8.22-6.64 31.33 2.02 45.11-17.05z'/%3e%3cpath fill='%23d99f31' stroke='none' d='M357.83 171.3c-.36.68-.9 1.86-1.26 3.34-6.24-7.44-10.91-15.14-6-21.5 4.48-5.8 15.46-3.18 26.88-7.2a29.75 29.75 0 0 0 14.75-9.49c-.42 1.14-.86 2.5-1.34 3.88-11.6 14.77-34.75 7.7-39.17 15.76-2.6 4.77 1.1 10.26 6.14 15.22z'/%3e%3cpath stroke='none' d='M352.11 169.98a5.25 5.25 0 0 0 2.7-1.94c.29.36.6.71.91 1.07a5.77 5.77 0 0 1-1.92 1.75 6.86 6.86 0 0 1-3.23.69c-.36-.48-.7-.96-1.04-1.45.86.09 1.83.1 2.58-.12zm-2.81-5.77a6 6 0 0 0 2.5-.8c.15.34.32.69.5 1.03-.75.44-1.37.7-2.42.92a8.63 8.63 0 0 1-3.12-.01c-.2-.44-.4-.89-.58-1.33.95.18 2.18.34 3.12.19zm1.54-4.81a8.77 8.77 0 0 1-5.5-2.83c.1-.41.23-.82.4-1.22.8 1.01 2.56 2.77 5.18 3-.05.34-.08.7-.08 1.05zm1.8-4.56a8.94 8.94 0 0 1-3.45-3.77c.27-.2.56-.38.86-.55a7.64 7.64 0 0 0 3.4 3.65c-.3.2-.56.43-.8.67zm3.99-6.15c.24 1.4.99 2.6 2.14 3.45l-1.11.26a6.26 6.26 0 0 1-1.94-3.58l.9-.13zm7.1-.62a5.94 5.94 0 0 0 2.09 2.7c.1.1.16.2.18.3l-1.1.13c-1-.84-1.75-1.89-2.11-3.06l.93-.07zm6.92-.69a8.14 8.14 0 0 0 2.68 2.56l-1.28.24a8.9 8.9 0 0 1-2.4-2.66l1-.14zm6.18-1.25c.9.86 2.03 1.5 3.25 1.92l-1.3.46a8.97 8.97 0 0 1-2.95-2.12l1-.26zm6.23-2.4c.83.6 1.93 1 2.9 1.24-.33.23-.66.45-1 .66-1-.31-2.02-.78-2.8-1.46l.9-.44zm4.6-2.9c.66.32 1.43.56 2.18.72l-.73.77c-.79-.21-1.58-.5-2.25-.9l.8-.6z'/%3e%3cpath fill='none' stroke-width='.6' d='M393.76 134.46c.04.95-.23 1.77-1.13 3.28-10.8 18.17-36.29 9.85-40.94 18.36-4.47 8.17 9.64 18.51 17.24 24.57-1.33.48-2.74.9-4.22 1.26l-1.32.72-1.97.62c-6.07-5.76-24.04-22.69-12.61-31.91 8.22-6.64 31.17 2.17 44.95-16.9z'/%3e%3cpath d='M407.52 132.02c13.49 15.53 37.16 7.94 47.95 14 18.79 10.52-1.64 35.48-5.49 40.25l-20.47-5.34c7.52-6.01 22.59-16.23 18.05-24.53-4.65-8.5-29.37.13-40.18-18.04-2.28-3.82-.53-7.12.14-6.34z'/%3e%3cpath fill='%23f1bf31' d='M407.67 132.48c13.48 15.54 36.4 8.1 47.19 14.15 18.78 10.52-2.43 34.87-6.28 39.64l-17.68-5.34c7.52-6.01 21.8-16.54 17.26-24.83-4.65-8.51-29.83-.04-40.63-18.2-2.28-3.82-.54-6.2.14-5.42z'/%3e%3cpath stroke-width='.63' d='M438.88 183.27c6.07-5.76 24.06-22.84 12.63-32.07-8.22-6.64-31.33 2.02-45.11-17.05l.05-.47c14.6 19.71 36.52 9.76 45.94 17.45 10.63 8.68-4.95 25.74-12.46 32.53z'/%3e%3cpath fill='%23d99f31' stroke='none' d='M442.33 171.3c.36.68.9 1.86 1.25 3.34 6.25-7.44 10.92-15.14 6-21.5-4.47-5.8-15.45-3.18-26.88-7.2a29.75 29.75 0 0 1-14.74-9.49c.42 1.13.86 2.5 1.34 3.88 11.6 14.77 34.76 7.7 39.17 15.76 2.6 4.77-1.1 10.26-6.14 15.22z'/%3e%3cpath stroke='none' d='M448.05 170.6c-1.5-.37-2.25-1.03-3.23-1.93-.3.35-.6.69-.92 1.02a8.3 8.3 0 0 0 2.46 1.8c.92.4 1.9.56 2.82.6.34-.45.68-.9 1-1.36a7.4 7.4 0 0 1-2.13-.13zm2.81-6.4a5.99 5.99 0 0 1-2.5-.8c-.15.35-.32.7-.51 1.04.76.44 1.38.7 2.43.92 1.05.22 2.15.15 3.12-.01l.58-1.34c-.95.19-2.18.35-3.12.2zm-1.54-4.8a8.77 8.77 0 0 0 5.5-2.83 8.6 8.6 0 0 0-.4-1.22c-.8 1.01-2.57 2.77-5.18 3 .05.34.08.7.08 1.04zm-1.8-4.56a8.94 8.94 0 0 0 3.45-3.77c-.27-.2-.56-.38-.86-.55a7.64 7.64 0 0 1-3.4 3.65c.3.2.56.43.8.67zm-3.99-6.15c-.24 1.4-.99 2.6-2.14 3.45l1.11.26a6.26 6.26 0 0 0 1.93-3.58l-.9-.13zm-7.1-.62a5.93 5.93 0 0 1-2.09 2.7.44.44 0 0 0-.18.3l1.1.13c1-.84 1.75-1.89 2.11-3.06l-.94-.07zm-6.92-.69a8.14 8.14 0 0 1-2.68 2.55l1.27.25a8.9 8.9 0 0 0 2.4-2.67l-.99-.13zm-6.19-1.26c-.9.87-2.03 1.51-3.24 1.92.43.17.87.32 1.3.47a8.96 8.96 0 0 0 2.95-2.12c-.34-.08-.67-.17-1-.27zm-6.23-2.39c-.82.6-1.92 1-2.9 1.24.34.23.67.45 1.01.66 1-.32 2.02-.79 2.8-1.46l-.9-.44zm-4.59-2.9a9.3 9.3 0 0 1-2.18.72c.24.26.48.52.73.76a8.8 8.8 0 0 0 2.25-.9c-.27-.18-.53-.38-.8-.59z'/%3e%3cpath fill='none' stroke-width='.6' d='M406.4 134.46c-.04.95.23 1.77 1.13 3.28 10.8 18.17 36.29 9.85 40.94 18.36 4.47 8.17-9.64 18.51-17.24 24.57 1.33.48 2.74.9 4.22 1.26l1.32.72 1.97.62c6.07-5.76 24.04-22.69 12.61-31.91-8.22-6.64-31.17 2.17-44.95-16.9z'/%3e%3c/g%3e%3cpath fill='%23000' d='M400.08 166.7h-6.84s.8-6.52-.1-10.94c-.75-3.58-3.6-7.68-3.6-10.68s3.26-11.46 3.26-11.46h14.56s3.1 8.45 3.1 11.46c0 3-2.7 7.1-3.43 10.68-.92 4.42-.1 10.94-.1 10.94h-6.85z'/%3e%3cpath fill='%23f1bf31' stroke='none' d='M400.08 166.7h-6.84s1.05-6.51.2-10.94c-.69-3.6-3.12-6.4-3.45-10.06-.45-5.16 4.05-12.08 4.05-12.08h12.08s4.35 6.92 3.89 12.08c-.32 3.66-2.6 6.45-3.3 10.06-.84 4.43.21 10.94.21 10.94h-6.84z'/%3e%3cpath fill='%23d99f31' stroke='none' d='M389.98 144.4c.43-.14.88-.25 1.32-.25 1.5 0 2.09.98 2.09.98s3.93-.9 6.69-.9c2.76 0 6.69.9 6.69.9s.6-.98 2.1-.98c.38 0 .77.08 1.16.2.02.46.02.91-.02 1.35-.32 3.66-2.6 6.45-3.3 10.06a29.12 29.12 0 0 0-.22 7.05l-6.41 3.05-6.42-3.05c.16-2.17.2-4.86-.22-7.05-.69-3.6-3.12-6.4-3.45-10.06a9.12 9.12 0 0 1-.01-1.3z'/%3e%3cpath fill='%23000' stroke='none' d='M407.1 146.81c-.3.95-.79 2.46-1.2 3.98a21.98 21.98 0 0 0-.82 4.04c-.19 3.87.47 8.07 1.24 11.87h-.27c-1.1-3.32-2.35-8.43-2.3-11.87.03-2.1 1.35-6.15 2.03-8.1.98-2.8.78-4.7.09-6.57-.7-1.88-1.87-3.75-2.84-6.5v-.04h1.3c.99 2.7 2.1 4.59 2.76 6.5a9.8 9.8 0 0 1 0 6.7zm-13.26 19.89c.78-3.83 1.42-7.97 1.25-11.86-.05-1-.4-2.53-.82-4.05-.42-1.52-.9-3.03-1.2-3.97-.88-2.81-.18-6.14.75-8.75.8-2.27 1.77-4.02 2.02-4.45h1.34c-.4.68-4.64 7.83-2.8 13.12.68 1.94 2 6 2.04 8.09.04 3.43-1.22 8.55-2.3 11.87h-.28z'/%3e%3cpath d='M400.08 166.7h-6.84s1.05-6.51.2-10.94c-.69-3.6-3.12-6.4-3.45-10.06-.45-5.16 4.05-12.08 4.05-12.08h12.08s4.35 6.92 3.89 12.08c-.32 3.66-2.6 6.45-3.3 10.06-.84 4.43.21 10.94.21 10.94h-6.84z'/%3e%3cellipse cx='400' cy='140.64' fill='%23fff' stroke-width='.92' rx='3.41' ry='2.51'/%3e%3cellipse cx='400' cy='140.49' stroke-width='1.03' rx='3.83' ry='2.73'/%3e%3ccircle cx='400' cy='148.23' r='3.68' fill='%23fff' stroke-width='.92'/%3e%3ccircle cx='400' cy='148.23' r='4.14' stroke-width='1.03'/%3e%3cpath stroke-width='.9' d='M360.41 204.28s-1.05-1.06-1.37-1.93c-.26-.69-.28-1.86-.28-1.86l-3.79-6.07 8.5-8.09 16.18-4.64 20.4-1.46h.03l20.4 1.46 16.17 4.64 8.5 8.1-3.78 6.06s-.02 1.17-.28 1.86a7.2 7.2 0 0 1-1.38 1.93l-18.97-6.41-20.66-.93-20.7.93-18.97 6.41z'/%3e%3cpath fill='%23f1bf31' d='M360.87 203.6s-.75-.95-1.04-1.66c-.42-1.02-.37-2.81-.37-2.81l-4.49-4.7 8.5-8.1 16.18-4.64 20.43-1.45 20.43 1.45 16.17 4.64 8.5 8.1-4.48 4.7s.05 1.79-.37 2.81c-.28.71-1.04 1.66-1.04 1.66l-18.52-5.73-20.69-.93-20.7.93-18.5 5.73z'/%3e%3cpath fill='%23000' d='M358.83 207.29a41.17 12.78 0 1 1 82.34 0 41.17 10.82 0 1 1-82.34 0z'/%3e%3cpath fill='%23f1bf31' d='M360.2 207.29a39.8 12.31 0 1 1 79.6 0 39.8 10.52 0 1 1-79.6 0z'/%3e%3cellipse cx='400' cy='208.41' fill='%23d99f31' rx='36.78' ry='9.39'/%3e%3cpath stroke-width='1.09' d='M436.52 209.68c-6.89 2.94-20.43 4.52-36.47 4.52s-29.58-1.58-36.47-4.52'/%3e%3cpath stroke-width='1.01' d='M435.9 206.26c-7.05 2.69-20.27 4.03-35.85 4.03-15.58 0-28.8-1.34-35.86-4.03'/%3e%3cpath d='M432.46 203.88c-7.5 2.18-19.1 3.4-32.41 3.4-13.32 0-24.91-1.22-32.4-3.4'/%3e%3cpath d='M427.48 202.07c-7.23 1.43-16.78 2.21-27.43 2.21s-20.2-.78-27.43-2.21m46.48-1.75c-5.67.62-12.13.95-19.05.95s-13.38-.33-19.04-.95'/%3e%3cellipse cx='400' cy='208.41' rx='36.48' ry='9.09'/%3e%3cpath fill='%23000' stroke-linejoin='round' d='M354.76 192.76c-3.61-4.8-6.83-8.07-14.65-10.83a13.45 13.45 0 0 1 4.8-2.1c2.97-.73 6-.33 7.96.69-1.55-5.55 1.43-11.1 1.43-11.1s4.82-.27 9.7 3.65c.16-6.73 2.13-9.92 2.13-9.92s5.07.24 10.26 5.4c.99-6.96 4.74-10.74 4.74-10.74s6.23 1.95 9.8 8.53c2.37-9.53 9.15-13.26 9.15-13.26s6.78 3.73 9.16 13.26c3.56-6.58 9.79-8.53 9.79-8.53s3.73 3.64 4.74 10.74c5.19-5.16 10.26-5.4 10.26-5.4s1.97 3.2 2.13 9.92c4.88-3.92 10.18-2.46 10.18-2.46s2.5 4.36.95 9.91c1.95-1.02 5-1.42 7.97-.69 1.82.45 3.72 1.23 4.8 2.1-7.01 2.54-11.2 6.03-14.81 10.83-3.38-6.9-21.46-14.5-45.17-14.5s-41.95 7.6-45.32 14.5z'/%3e%3cpath fill='%23f1bf31' stroke-linejoin='round' d='M354.76 191.99a25.8 25.8 0 0 0-12.17-10.18c1.07-.86 2.96-1.19 4.95-1.33 2.35-.16 4.3.17 5.95.95-1.55-5.55.97-11.23.97-11.23s4.96.02 9.85 3.94c.16-6.72 2.29-10.06 2.29-10.06s4.75.53 9.94 5.68c1.11-6.94 4.75-10.86 4.75-10.86s6.23 1.93 9.79 8.5c2.37-9.52 9-12.92 9-12.92s6.63 3.4 9 12.92c3.56-6.57 9.8-8.5 9.8-8.5s3.74 3.5 4.74 10.86c5.19-5.15 9.94-5.68 9.94-5.68s2.13 3.33 2.3 10.06c4.88-3.92 10.46-2.86 10.46-2.86s1.9 4.6.35 10.15c1.65-.78 3.6-1.11 5.94-.95 2 .14 3.89.47 4.96 1.33A25.8 25.8 0 0 0 445.4 192c-3.38-6.9-21.6-13.86-45.32-13.86-23.71 0-41.94 6.95-45.32 13.86z'/%3e%3cpath fill='%23000' d='M353 194.16c0-8.76 20.9-16.19 47.05-16.19s46.28 7.73 46.28 15.41c0 1.84-1.63 3.43-3.77 4.77.2-.58.31-1.17.31-1.76 0-7.68-16.67-13.9-42.82-13.9s-42.82 6.22-42.82 13.9c0 .6.1 1.18.31 1.76-2.14-1.34-4.54-2.15-4.54-4z'/%3e%3cpath fill='%23f1bf31' stroke-width='.9' d='M354.22 193.38c0-6.64 19.68-14.94 45.83-14.94s45.83 8.3 45.83 14.94c0 1.84-2.05 2.03-2.23 1.46-2.2-6.73-17.45-12.67-43.6-12.67-26.15 0-41.4 5.94-43.6 12.67-.18.57-2.23.38-2.23-1.46z'/%3e%3cpath fill='%23000' stroke-linejoin='round' stroke-width='.45' d='m399.58 172.1.46-7.57c0-.06.07-.83.08-.78l.43 8.34c.14 2.34.3 6.01.3 6.01 0 .03-.02.04-.05.04l-1.5.01a.04.04 0 0 1-.04-.04s.17-3.67.32-6.02zm38.45 13.54c.41-.8.92-1.84 1.3-2.65.74-1.66 2.1-4.3 2.1-4.3.02-.06-.04-.08-.07-.04 0 0-1.7 2.4-2.65 3.9-.5.78-1.19 1.78-1.73 2.56zm-12.8-4.64a76.5 76.5 0 0 1 2.12-4.42c.98-1.81 2.76-4.5 2.76-4.5.03-.05.1-.02.07.03 0 0-1.28 2.73-2.01 4.51-.72 1.74-1.72 4.51-1.72 4.51l-.66.01zm-11.6-2.09a103.3 103.3 0 0 1 3.1-10.59.04.04 0 0 1 .07.02 300.78 300.78 0 0 0-1.83 10.74zm-39.32 2.25h-.57c-.04-.03-1.03-2.8-1.75-4.54-.73-1.78-2.01-4.51-2.01-4.51-.03-.05.03-.08.06-.04 0 0 1.79 2.7 2.77 4.51.83 1.53 1.9 3.9 2.13 4.42zm10.88-2.08-.8-4.95c-.38-2.26-.61-3.53-1.03-5.79-.01-.05.05-.07.07-.02.75 2.18 1.15 3.42 1.79 5.64.46 1.58 1.03 3.83 1.32 4.95zm-23.18 6.62c-.41-.82-.94-1.88-1.32-2.71-.75-1.66-2.1-4.3-2.1-4.3-.03-.06.04-.08.06-.04 0 0 1.7 2.4 2.65 3.9.52.8 1.22 1.83 1.76 2.62z'/%3e%3cg stroke-linecap='round' stroke-linejoin='round' stroke-width='.78'%3e%3cpath fill='%23d99f31' stroke-width='.72' d='M361.6 197.42c-.33-1.9-1.98-3.44-3.25-3.21-1.27.22-3.07 2.12-2.74 4.02.34 1.9 2.72 3.3 4 3.07 1.26-.22 2.33-1.97 2-3.88z'/%3e%3cpath fill='%23f1bf31' stroke='none' d='M359.49 195.08a2.39 2.39 0 0 1-3.03 3.62 2.87 2.87 0 0 1-.14-.53c-.3-1.65.97-3.14 2.07-3.34l.24-.02c.3 0 .59.1.86.27z'/%3e%3cpath d='M360.9 197.47c-.29-1.65-1.41-2.83-2.51-2.64-1.1.2-2.36 1.69-2.08 3.34.3 1.65 2.06 2.85 3.16 2.65 1.1-.19 1.72-1.7 1.43-3.35z'/%3e%3cpath fill='%23d99f31' d='m375.4 192.85-.6-3.59-2.41-1.21s-2.6.7-4.21 1.27c-1.67.6-4.21 1.74-4.21 1.74l-.6 1.05.75 4.05 1.35 1.2 9.02-2.7.91-1.81z'/%3e%3cpath fill='%23f1bf31' stroke='none' d='m365.46 195.44 7.23-2.29.45-.74-.62-3.76-.26-.25-8.03 2.94.61 3.4z'/%3e%3cpath stroke-width='1.09' d='m365.46 195.44 7.23-2.29.45-.74-.47-3m2.55 3.44-2.08-.45'/%3e%3cpath fill='%23f1bf31' stroke='none' d='M385.72 189a1.5 1.5 0 1 1 3-.26 1.5 1.5 0 0 1-3 .26zm-3.48 3.33a1.5 1.5 0 1 1 3-.26 1.5 1.5 0 0 1-3 .26zm-3.55-2.67a1.5 1.5 0 0 1 1.36-1.63c.83-.07 1.41.54 1.48 1.37.07.82-.39 1.55-1.21 1.63a1.5 1.5 0 0 1-1.63-1.37zm3.03-3.33a1.5 1.5 0 1 1 3-.25 1.5 1.5 0 0 1-3 .25z'/%3e%3cpath fill='%23d99f31' stroke='none' d='M385.81 189.4a1.5 1.5 0 0 1 2.82 0 1.5 1.5 0 0 1-2.82 0zm-4-2.67a1.5 1.5 0 0 0 2.81 0 1.5 1.5 0 0 0-2.81 0zm-3.03 3.32a1.5 1.5 0 0 0 1.54.98 1.3 1.3 0 0 0 1.14-.95c-.18-.63-.7-1.06-1.4-1a1.5 1.5 0 0 0-1.28.97zm3.55 2.67a1.5 1.5 0 0 0 2.82 0 1.5 1.5 0 0 0-2.82 0z'/%3e%3cpath stroke-width='.93' d='M385.72 189a1.5 1.5 0 1 1 3-.26 1.5 1.5 0 0 1-3 .26zm-3.48 3.33a1.5 1.5 0 1 1 3-.26 1.5 1.5 0 0 1-3 .26zm-3.55-2.67a1.5 1.5 0 0 1 1.36-1.63c.83-.07 1.41.54 1.48 1.37.07.82-.39 1.55-1.21 1.63a1.5 1.5 0 0 1-1.63-1.37zm3.03-3.33a1.5 1.5 0 1 1 3-.25 1.5 1.5 0 0 1-3 .25z'/%3e%3cpath fill='%23d99f31' stroke='none' d='M392.85 190.4v-3.9l2.27-2.11h9.92l2.27 2.11v3.9l-2.27 1.96h-9.92z'/%3e%3cpath fill='%23f1bf31' stroke='none' d='m405.24 184.85-.8.81v3.72l-.63.62-7.51-.05-.63-.63v-3.56l-.67-.91z'/%3e%3cpath d='M392.85 190.4v-3.9l2.27-2.11h9.92l2.27 2.11v3.9l-2.27 1.96h-9.92z'/%3e%3cpath stroke-width='1.09' d='m393.46 190.23 2.21-.85m11 .91-2.23-.91m-9.05 2.72.9-2.1m8.42 2.1-.9-2.1m.63-4.34v3.72l-.63.62-7.51-.05-.63-.63v-3.71'/%3e%3cpath fill='%23f1bf31' stroke='none' d='M414.37 189a1.5 1.5 0 1 0-2.99-.26 1.5 1.5 0 0 0 3 .26zm3.49 3.33a1.5 1.5 0 1 0-3-.26 1.5 1.5 0 0 0 3 .26zm3.55-2.67a1.5 1.5 0 0 0-1.36-1.63c-.83-.07-1.41.54-1.48 1.37-.08.82.39 1.55 1.21 1.63a1.5 1.5 0 0 0 1.63-1.37zm-3.03-3.33a1.5 1.5 0 1 0-3-.25 1.5 1.5 0 0 0 3 .25z'/%3e%3cpath fill='%23d99f31' stroke='none' d='M414.29 189.4a1.5 1.5 0 0 0-2.82 0 1.5 1.5 0 0 0 2.81 0zm1.18-2.67a1.5 1.5 0 0 0 2.82 0 1.5 1.5 0 0 0-2.82 0zm3.17 3.35c.15.51.56.9 1.14.95a1.5 1.5 0 0 0 1.54-.98 1.5 1.5 0 0 0-1.28-.97c-.7-.06-1.21.37-1.4 1zm-3.7 2.64a1.5 1.5 0 0 0 2.83 0 1.5 1.5 0 0 0-2.82 0z'/%3e%3cpath stroke-width='.93' d='M414.37 189a1.5 1.5 0 1 0-2.99-.26 1.5 1.5 0 0 0 3 .26zm3.49 3.33a1.5 1.5 0 1 0-3-.26 1.5 1.5 0 0 0 3 .26zm3.55-2.67a1.5 1.5 0 0 0-1.36-1.63c-.83-.07-1.41.54-1.48 1.37-.08.82.39 1.55 1.21 1.63a1.5 1.5 0 0 0 1.63-1.37zm-3.03-3.33a1.5 1.5 0 1 0-3-.25 1.5 1.5 0 0 0 3 .25z'/%3e%3cpath fill='%23d99f31' d='m424.7 192.85.6-3.59 2.41-1.21s2.6.7 4.2 1.27c1.68.6 4.22 1.74 4.22 1.74l.6 1.05-.75 4.05-1.35 1.2-9.02-2.7-.91-1.81z'/%3e%3cpath fill='%23f1bf31' stroke='none' d='m434.63 195.44-7.22-2.29-.45-.74.63-3.76.25-.25 8.03 2.94-.61 3.4z'/%3e%3cpath stroke-width='1.09' d='m434.63 195.44-7.22-2.29-.45-.74.47-3m-1.88 4.95 1.86-1.2'/%3e%3cpath fill='%23d99f31' stroke-width='.72' d='M438.4 197.42c.34-1.9 1.99-3.44 3.26-3.21 1.27.22 3.07 2.12 2.74 4.02-.34 1.9-2.72 3.3-4 3.07-1.26-.22-2.33-1.97-2-3.88z'/%3e%3cpath fill='%23f1bf31' stroke='none' d='M439.95 196.63c0-.6.22-1.13.57-1.55a1.62 1.62 0 0 1 1.1-.25c1.1.2 2.36 1.69 2.07 3.34-.03.18-.08.36-.14.53a2.39 2.39 0 0 1-3.6-2.07z'/%3e%3cpath d='M439.1 197.47c.3-1.65 1.42-2.83 2.52-2.64 1.1.2 2.37 1.69 2.08 3.34-.3 1.65-2.06 2.85-3.16 2.65-1.1-.19-1.72-1.7-1.43-3.35z'/%3e%3cpath stroke-width='.83' d='m424.28 192.88.65-3.9 2.56-1.27s2.78.76 4.51 1.37c1.79.64 4.5 1.85 4.5 1.85l.65 1.13-.8 4.35-1.45 1.29-9.66-2.9-.96-1.92zm-31.9-6.53 2.39-2.25h10.62l2.4 2.25v4.2l-2.4 2.09h-10.62l-2.4-2.08v-4.21zm-16.56 6.53-.65-3.9-2.56-1.27s-2.78.76-4.51 1.37c-1.8.64-4.5 1.85-4.5 1.85l-.65 1.13.8 4.35 1.45 1.29 9.66-2.9.96-1.92z'/%3e%3c/g%3e%3cg stroke-linecap='round' stroke-linejoin='round'%3e%3cpath fill='%23d99f31' stroke-width='.95' d='M408.13 95.85c1.77 0 3.07 1.58 3.07 3.36 0 1.78-1.3 3.53-3.07 3.53-2.32 0-5.69-2.75-5.57-.56l.05 1.1 1.23 10.15c3.03.68-10.55.68-7.53 0l1.24-10.2.05-1.05c.11-2.18-3.34.56-5.57.56-1.78 0-3.07-1.75-3.07-3.53 0-1.78 1.3-3.36 3.07-3.36 1.75 0 3.68 1.63 4.92.86 1.95-1.2-.4-3.9-.4-5.73 0-1.77 1.75-3.22 3.53-3.22 1.78 0 3.52 1.45 3.52 3.22 0 1.83-2.36 4.45-.4 5.73 1.18.77 3.12-.86 4.93-.86z'/%3e%3cpath fill='%23f1bf31' stroke='none' d='M397.49 91.5c-.2-.24-.36-.51-.46-.8a3.3 3.3 0 0 1 3.05-2.37c.61 0 1.2.2 1.7.54-.1.36-.92.43-1.68 1.08-1.1.91-1.69 2.66-2.61 1.56zm.5 5.1c.15.2.22.41.22.64 0 1.1-1.9 1.98-4.24 1.98-1.96 0-3.62-.62-4.1-1.47a3.25 3.25 0 0 1 2.7-1.47c1.63 0 3.87 1.39 5.03.67.16-.1.3-.22.4-.35zm3.27.17c0-.51.25-1 .67-1.4-.1.63.02 1.18.64 1.58 1.1.72 3.33-.67 5.03-.67 1.07 0 2.09.57 2.66 1.43-.65 1.04-2.36 1.78-4.36 1.78-2.56 0-4.64-1.22-4.64-2.72z'/%3e%3cpath d='M407.6 96.28c1.65 0 3.15 1.35 3.15 3.01 0 1.66-1.5 3.02-3.15 3.02s-5.74-2.9-5.64-.7l.05 1.19.7 9.78c2.82.64-8.08.64-5.26 0l.7-9.82.05-1.14c.1-2.21-4.1.69-5.64.69-1.66 0-3.15-1.36-3.15-3.02s1.5-3.01 3.15-3.01c1.64 0 3.88 1.39 5.04.68 1.82-1.13-.69-3.78-.69-5.48 0-1.65 1.5-3.15 3.17-3.15 1.66 0 3.17 1.5 3.17 3.15 0 1.7-2.52 4.28-.68 5.48 1.1.7 3.33-.68 5.03-.68z'/%3e%3ccircle cx='400' cy='116.29' r='7.9' fill='%23f1f1f2' stroke-width='1.7'/%3e%3cpath fill='%23000' stroke='none' d='M401.46 121.28a7.7 7.7 0 0 0 1.36-2.29c.18-.57.77-.3.64.19a7.97 7.97 0 0 1-1.25 2.45zm-8.7-4.65.48-.4c.18-.16.4-.31.66-.46.33-.22.1-.74-.3-.55-.44.21-.79.43-1.02.59zm-.05 1.17.42.74c.57-.61 1.54-1.5 1.7-1.65.35-.33-.11-.73-.42-.5a13.95 13.95 0 0 0-1.7 1.41zm.6 1.76.52.6a23.2 23.2 0 0 0 2.46-2.27c.34-.37-.05-.88-.46-.5-.2.2-1.77 1.6-2.5 2.17h-.02zm10.78 1.34c.39-.44.8-1.04.94-1.74.05-.25.23-.36.4-.33.17.04.3.22.26.45a4.3 4.3 0 0 1-1 2.04zm-6.05.77a23.92 23.92 0 0 0 2.64-3.57c.11-.18.31-.22.46-.15.15.07.23.26.12.48-.46.93-1.07 1.9-1.62 2.6-.54.68-.95 1.16-.95 1.16zm-2.24-1.38a24.5 24.5 0 0 0 2.06-2.12c.27-.34.88-.08.53.43-.44.65-1.12 1.46-1.76 2.04z'/%3e%3cpath fill='%23d99f31' d='M406.13 133.63h-12.09c-1.02 1.72-4.25 2.9-6.9 1.52-1.88-.99-2.26-3.22-2.26-3.22s5.06.19 5.09-4.29c0-4.54 2.6-7.5 6.35-7.06a6.56 6.56 0 0 1 3.76 1.94 6.57 6.57 0 0 1 3.76-1.94c3.75-.44 6.35 2.52 6.35 7.02 0 4.52 5.09 4.34 5.09 4.34s-.39 2.22-2.26 3.2c-2.66 1.4-5.91.2-6.88-1.51z'/%3e%3cpath fill='%23d99f31' stroke='none' d='M406.14 133.62h-.42c-1.12 1.04-2.88 2.1-5.64 2.7-2.76-.6-4.52-1.66-5.64-2.7h-.4s-4.24 3.01-7.2.76c-1.1-.84-1.34-1.98-1.34-1.98s5.09-.28 5.09-4.8c0-4.5 2.44-6.4 5.73-6.4 1.44 0 2.75.71 3.76 1.63a5.7 5.7 0 0 1 3.76-1.63c3.29 0 5.73 1.9 5.73 6.4 0 4.52 5.09 4.8 5.09 4.8s-.24 1.14-1.33 1.98c-2.98 2.25-7.2-.76-7.2-.76z'/%3e%3cpath stroke='%23f1bf31' stroke-width='.9' d='M391.16 125.03c-.26.64.16 2.87.16 2.87s.14 2.02-1.45 3.55c-1.11 1.08-3.65 1.55-3.65 1.55m22.78-7.96c.27.63-.15 2.86-.15 2.86s-.14 2.02 1.45 3.55c1.1 1.08 3.64 1.55 3.64 1.55'/%3e%3cpath fill='%23f1bf31' stroke='none' d='M399.98 135.87c-6.3-1.43-7.11-5.33-6.94-5.29.42.1 1.87 2.95 7.04 4.39 5.17-1.44 6.62-4.29 7.03-4.39.18-.04-.64 3.86-6.93 5.29h-.2zm-7.73-11.12c0-1.53 2.52-2.8 5.93-3.15.7.3 1.35.73 1.9 1.23.55-.5 1.2-.94 1.9-1.23 3.4.35 5.91 1.63 5.91 3.15 0 3.6-4.12 5.35-7.82 5.35s-7.82-1.74-7.82-5.35z'/%3e%3cpath d='M406.14 133.62h-.42c-1.12 1.04-2.88 2.1-5.64 2.7-2.76-.6-4.52-1.66-5.64-2.7h-.4s-4.24 3.01-7.2.76c-1.1-.84-1.34-1.98-1.34-1.98s5.09-.28 5.09-4.8c0-4.5 2.44-6.4 5.73-6.4 1.44 0 2.75.71 3.76 1.63a5.7 5.7 0 0 1 3.76-1.63c3.29 0 5.73 1.9 5.73 6.4 0 4.52 5.09 4.8 5.09 4.8s-.24 1.14-1.33 1.98c-2.98 2.25-7.2-.76-7.2-.76z'/%3e%3cpath fill='%23000' d='M407.63 130.62s-.76 5.05-7.55 6.55c-6.8-1.5-7.55-6.55-7.55-6.55s.75 4.2 7.55 5.71c6.8-1.5 7.55-5.71 7.55-5.71z'/%3e%3c/g%3e%3c/g%3e%3cg stroke-linecap='round' stroke-linejoin='round' stroke-width='.93'%3e%3cpath fill='%23a0cfeb' d='M398.8 227.5c13.53-.25 71.81-10.02 71.81 70.92 0 77.3-70.56 108.04-70.56 108.04s-70.56-29.78-70.56-113.9c0-75.08 69.3-65.07 69.3-65.07z'/%3e%3cpath fill='%2394bb79' d='M421.68 348.39a28.54 28.54 0 0 1 13.95-3.62c8.24 0 15.66 3.47 20.9 9.03-20.6 37.02-56.48 52.66-56.48 52.66s-34.96-14.75-55.66-52.83a28.59 28.59 0 0 1 20.73-8.86c5.67 0 10.97 1.65 15.42 4.5a28.59 28.59 0 0 1 21-9.15c7.85 0 14.96 3.15 20.14 8.27z'/%3e%3cpath fill='%23658d5c' d='M433.97 345.16c3.55.41 9.77 3.76 12.78 8.27-2.34 3.86-6.83 10-9.3 13.37-5.5-8.06-16.89-18.86-16.1-18.08.12.1.6-.28.73-.36a52.1 52.1 0 0 1 3.13-1.64 28.48 28.48 0 0 1 6.35-1.67c.76-.02 1.56.01 2.4.11zm-24.18 50.77c-4.5 2.37-8 3.9-9.74 4.63-1.75-.73-5.25-2.26-9.74-4.63-8.7-7.05-26.64-23.5-39.27-47.43a28.09 28.09 0 0 1 13.77-3.58c.4 0 2.1.5 3.34 1.08 7.94 3.73 17.76 14.43 14.14 16.48-2.66 1.5-10.25-.96-10.65 1.98-.15 1.11 14.1 8.94 22.19 15.83 6.63 5.65 17 14.8 15.96 15.64zm17.3-7.03c-9.07-8.9-29.45-27-46.5-39.68a28.58 28.58 0 0 1 18.57-9l.39.05c9.84 1.4 18.76 11.96 15.14 14-2.66 1.5-10.26-.95-10.66 1.99-.13.98 10.2 7.22 16.24 12.41 5.93 5.1 9.82 8.77 14.22 13.58-2.5 2.4-4.98 4.62-7.4 6.65z'/%3e%3cpath d='M422.07 347.94c1.89 1.78 2.7 3.26 2.72 3.28.18.3-.03.99-.57.48 0 0-.75-.71-2.95-2.86-2.96-2.9-8.1-6.55-12.34-7.26-.4-.07-.58-.27-.53-.57a.6.6 0 0 1 .7-.5c.09 0 6.35 1.18 12.97 7.43zm-34.87 5.56c.2.17.24.41.14.6-.12.18-.36.22-.56.07-3.59-2.55-5.34-3.61-7.42-4.92-.16-.1-.27-.27-.15-.46.08-.12.25-.2.41-.24.33-.1.82-.11 1.14.08a58.08 58.08 0 0 1 6.44 4.87z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='1.24' d='M421.68 348.39c4.13-2.3 8.89-4.09 13.95-4.09 8.28 0 15.74 3.64 20.97 9.37m-112.31-.23a28.28 28.28 0 0 1 20.83-9.3c5.68 0 10.97 2.28 15.42 5.13 5.24-5.63 12.7-9.77 21-9.77 7.85 0 14.96 3.77 20.14 8.89'/%3e%3cpath fill='none' stroke='%234c819a' stroke-width='.78' d='M367.91 230.52h66.97m-75.92 3.71h84.13m-90.26 3.72h95.8m-100.45 3.71h104.64m-108.33 3.71h111.64m-114.66 3.71h117.38m-119.86 3.72h122.1m-124.17 3.7h126.05m-127.75 3.72h129.33m-130.75 3.72h132.08m-133.25 3.7h134.36m-135.3 3.72H467.9m-50.24 3.71h51m-137.72 0h51.35m51.99 3.71h35m-138.92 0h35.44m74.94 3.72h29.02m-139.83 0h29.24m87.87 3.71h23.08m-140.45 0h22.99m100.6 3.71h17.12m-140.86 0h17.1m111.11 3.71h12.8m-141.03 0h13.03m119.3 3.72h8.77m-141.03 0h8.49'/%3e%3cg fill='none'%3e%3cpath fill='%23000' d='m356.65 300.4-.01-7.23 7.75-3.02 7.75 2.1.01 8.15z'/%3e%3cpath fill='%23fff' d='m373.24 333.22 3.4 13.95a28.59 28.59 0 0 0-11.52-2.4l-.73-57.57 3.1.9v6.05l3.87 1v-6l5.27 1.38v9.85l-3.4 5.03v27.81z'/%3e%3cpath fill='%23bdbfc1' d='M364.39 332.15V287.2l-3.1 1.35v5.96l-3.88 1.55v-6l-5.27 2.25v9.53l3.79 4.54.09 27.4-3.88 14.08a28.53 28.53 0 0 1 12.25-3.1v-12.62z'/%3e%3cpath stroke='%23000' stroke-width='1.09' d='m364.25 332.04-8.23 1.74m-1.74 8.67 10.05-2.12 10.86 1.17m-11.22-5.23-8.87 1.81m17.65-24.68-8.36-1.74-8.49 2.59m16.85 3.1-8.36-1.6-8.49 2.45m0-7.86 8.49-2.74 8.36 1.77m-16.85 12.72 8.49-2.26 8.36 1.49m-16.77 4.66 8.4-2.08 8.45 1.39m-16.85 4.6 8.4-1.9 8.53 1.28m-3.1-24.42v3.84m-3.1-.58v3.91m3.1.83v3.92m-7.9-4.28v3.9m0 4.12v3.91m-3.72 1.36v3.6m0-19.41v3.6m3.72-9.1v3.91m2.5-10.98 12.22 2.98m-12.23-2.98-12.26 4.45'/%3e%3cpath stroke='%23000' stroke-width='1.24' d='M364.39 344.78V287.2'/%3e%3cpath fill='%23000' d='m370.59 334.68-3.73-.52v-11.78c0-1.45.89-2.33 1.68-2.33 1.4 0 2.05 1.58 2.05 2.95z'/%3e%3cpath stroke='%23000' d='m373.24 333.23 3.4 13.94a28.59 28.59 0 0 0-11.52-2.4c-4.67 0-9.08 1.11-12.98 3.1l3.88-14.08-.1-27.4-3.78-4.54v-9.53l5.27-2.24v5.99l3.88-1.55v-5.96l3.1-1.36 3.1.9v6.05l3.87 1v-6l5.27 1.39v9.84l-3.4 5.03v27.81zm3.1 13.42a29.68 29.68 0 0 0-11.22-2.2c-4.48 0-8.87 1.02-12.65 2.83l3.85-13.41-.08-27.48a.98.98 0 0 0-.07-.2l-3.72-4.45v-9.22l4.65-1.97v5.52c0 .25.2.38.43.28l3.87-1.54c.08-.03.2-.2.2-.28v-5.77l2.8-1.23 2.78.8v5.82c0 .1.12.27.23.3l3.87 1c.22.05.39-.08.39-.3v-5.6l4.65 1.22v9.51l-3.34 4.96-.05.17v27.81l3.4 13.42zm1.21.45c.08.3-.75.02-1.04-.1a28.26 28.26 0 0 0-11.4-2.39c-4.61 0-8.97 1.1-12.83 3.06-.3.16-1.15.43-1.06.11l4.49-14.04-.09-27.24-3.71-4.45a.93.93 0 0 1-.08-.2v-9.53c0-.09.12-.25.2-.29l5.26-2.24c.24-.1.43.03.43.29v5.53l3.26-1.3v-5.75c0-.08.1-.25.18-.28l3.1-1.36a.85.85 0 0 1 .21-.01l3.1.89c.1.03.23.19.23.3v5.8l3.25.84v-5.59c0-.23.17-.36.39-.3l5.27 1.39c.1.02.23.19.23.3v9.84l-.05.17-3.34 4.96v27.68l4 13.91zm-13.15-43.58 8.37 1.9m-8.37-1.9-8.47 2.87'/%3e%3c/g%3e%3cg fill='none'%3e%3cpath fill='%23000' d='m391.53 294.98-.02-7.39 7.75-2.79 7.75 2.4.01 7.77z'/%3e%3cpath fill='%23fff' d='m408.1 328.1 3.4 13.8a28.58 28.58 0 0 0-12.38-1.68l.14-58.44 3.1 1.04v6.06l3.87 1.07v-5.92l5.27 1.7v9.81l-3.4 4.84v27.73z'/%3e%3cpath fill='%23bdbfc1' d='M399.26 340.19v-58.41l-3.1 1.2v6.04l-3.88 1.39v-5.99l-5.27 2.08v9.64l3.8 4.64.08 27.58-3.88 15.7c3.65-2.14 7.8-3.5 12.25-3.85v-.02z'/%3e%3cpath stroke='%23000' stroke-width='1.09' d='m398.8 330.83-8.57 1.65m19.48 3.87-10.5-1.32-10.36 1.97m4.22-21.02v3.76m3.72 3.4v3.92m0-28.17v3.91m-3.72 1.43V308m3.72-1v3.9m7.9-3.3v3.9m-3.1-8.65v3.91m3.1-7.09v3.84m-13.82 20.88 8.4-1.8 8.52 1.57m-17-7.64 8.49-2.1 8.36 1.8m-16.85-3.59 8.49-2.3 8.36 1.91m-16.85-3.56 8.49-2.43 8.36 2.04m-16.85-3.58 8.49-2.54 8.36 2.15m.08 15.86-8.44-1.69-8.41 2m8.39 6.17-8.37 1.71m20.61-32.82-12.24-3.56-12.25 4.16m20.63 4.22-8.36-2.25-8.48 2.67'/%3e%3cpath stroke='%23000' stroke-width='1.24' d='M399.26 340.19v-58.41'/%3e%3cpath fill='%23000' d='m405.46 329.4-3.73-.58v-11.78c0-1.45.89-2.26 1.68-2.26 1.4 0 2.05 1.58 2.05 2.27z'/%3e%3cpath stroke='%23000' d='M411.22 341.41a29.86 29.86 0 0 0-23.89 2.02l3.86-15-.08-27.65a.94.94 0 0 0-.07-.2l-3.71-4.55v-9.31l4.65-1.84v5.53c0 .25.18.37.41.3l3.87-1.4c.1-.03.21-.2.21-.29v-5.83l2.8-1.08 2.78.93v5.84c0 .1.12.26.22.3l3.88 1.07c.22.06.4-.07.4-.3v-5.5l4.64 1.5v9.5l-3.34 4.75-.05.18v27.73l3.42 13.3zm1.2.41c.08.3-.74 0-1.03-.1a28.3 28.3 0 0 0-9.85-1.76 28.23 28.23 0 0 0-14.37 3.9c-.3.18-1.16.46-1.08.13l4.49-15.67-.09-27.43-3.72-4.55a.9.9 0 0 1-.07-.2v-9.64c0-.08.12-.25.2-.28l5.27-2.09c.24-.09.42.04.42.3v5.54l3.26-1.16v-5.83c0-.09.11-.26.2-.29l3.1-1.2h.2l3.1 1.04c.1.03.21.2.21.3v5.81l3.26.9v-5.5c0-.24.18-.37.4-.3l5.28 1.7c.1.03.21.19.21.29v9.81l-.05.18-3.34 4.75v27.6l4 13.75zm-4.31-13.71 3.4 13.79a28.58 28.58 0 0 0-9.97-1.78c-5.3 0-10.27 1.44-14.52 3.94l3.87-15.7-.09-27.58-3.78-4.64v-9.64l5.27-2.08v6l3.87-1.4v-6.04l3.1-1.2 3.1 1.04v6.06l3.87 1.07v-5.92l5.27 1.7v9.81l-3.4 4.84v27.73z'/%3e%3c/g%3e%3cg fill='none'%3e%3cpath fill='%23000' d='m426.4 300.55-.02-8.15 7.75-2.17 7.75 2.55.02 7.77z'/%3e%3cpath fill='%23fff' d='m442.98 333.53 3.4 13.32A28.59 28.59 0 0 0 434 344.8l.13-57.6 3.1 1.04v6.05l3.87 1.3v-5.91l5.27 1.77v9.7l-3.4 4.8v27.57z'/%3e%3cpath fill='%23bdbfc1' d='M434.13 332.15V287.2l-3.1.96v6.05l-3.87 1.15v-5.99l-5.27 1.7v9.76l3.78 4.85.1 27.55-3.88 15.03a28.5 28.5 0 0 1 12.24-3.46v-12.66z'/%3e%3cpath stroke='%23000' stroke-width='1.09' d='m423.57 342 10.5-1.63 10.7 1.41m-11.09-5.56-8.85 1.36m6.82-33.42v3.91m-3.72 1.28v3.76m0 12.13V329m3.72-8.65v3.92m0-12.02v3.92m7.9-3.09V317m-3.1-8.74v3.92m3.1-7.02V309m-13.82 20.42 8.4-1.42 8.52 1.58m-17-12 8.48-1.83 8.37 1.99m0 3.96-8.37-1.87-8.48 1.72m16.85-7.77-8.37-2.12-8.48 1.97m16.85-3.81-8.37-2.23-8.48 2.07m16.86-3.7-8.36-2.44-8.48 2.17m-3.78-4.85 12.26-3.44 12.22 3.75m-12.22 30.89-8.39 1.36m-.03-7.88 8.4-1.62 8.44 1.77'/%3e%3cpath stroke='%23000' stroke-width='1.24' d='M434.13 344.8v-57.6'/%3e%3cpath fill='%23000' d='m440.33 334.9-3.72-.58v-11.78c0-1.45.88-2.26 1.67-2.26 1.4 0 2.05 1.58 2.05 2.27z'/%3e%3cpath stroke='%23000' d='M446.08 346.34a29.77 29.77 0 0 0-23.87 1.33l3.85-14.35-.08-27.63a.86.86 0 0 0-.06-.19l-3.72-4.76v-9.44l4.65-1.5v5.57c0 .23.17.36.4.3l3.87-1.16c.1-.03.22-.19.22-.3v-5.81l2.79-.87 2.79.94v5.83c0 .1.12.26.2.3l3.88 1.3c.23.08.41-.05.41-.3v-5.48l4.65 1.57v9.36l-3.33 4.73-.06.18v27.57l3.4 12.8zm-3.1-12.8 3.4 13.3a28.59 28.59 0 0 0-10.75-2.07c-4.98 0-9.66 1.27-13.74 3.5l3.87-15.03-.09-27.55-3.78-4.85v-9.76l5.27-1.7v5.99l3.87-1.16v-6.04l3.1-.97 3.1 1.05v6.05l3.87 1.3v-5.91l5.27 1.77v9.7l-3.4 4.8v27.57zm4.31 13.23c.08.3-.74.02-1.03-.1a28.31 28.31 0 0 0-10.63-2.06c-4.92 0-9.56 1.26-13.6 3.47-.3.16-1-.18-.9-.5l4.32-14.38-.09-27.4-3.72-4.77a.89.89 0 0 1-.06-.19v-9.76c0-.1.12-.27.21-.3l5.27-1.7c.23-.07.4.06.4.3v5.57l3.26-.97v-5.8c0-.11.12-.27.22-.3l3.1-.97h.19l3.1 1.04c.1.03.2.2.2.3v5.83l3.26 1.1v-5.49c0-.24.18-.37.41-.3l5.27 1.78c.1.03.21.2.21.3v9.68l-.05.18-3.34 4.72v27.45l4 13.27z'/%3e%3c/g%3e%3cg id='a' stroke='%23000'%3e%3cpath d='M369.42 268.7c-.28-2.57-1.28-6.73-4.72-6.2.18 4.47 5.86 21.3-.64 22.46l-.21-.24c.08-7.64-7.55-15.97-6.07-22.62.98-4.38 4.3-6.75 8.7-6.75 8.05 0 9.17 10 3.29 13.5l-.35-.15z'/%3e%3cpath fill='%23fff' d='M369.85 267.53c-.65-2.87-2.23-6.61-5.84-5.97l-.24.31c.17 4.8 6.2 19.42.46 22-.15-8.37-7.7-13.8-5.76-21.64.54-2.18 2.7-4.88 4.81-5.67a8.85 8.85 0 0 1 3.2-.66c7.25.15 9.14 7.67 3.37 11.63z'/%3e%3cpath stroke='none' d='M359.57 264.71c.62-1.7 2.66-3.42 4.47-3.63.38-.05.68.29.83.7h-.17c-.21 0-.42.03-.62.08.01.31.04.63.08.97-.85.05-2.33.4-3.83 2.23-.7.86-1.07.5-.76-.35z'/%3e%3cpath stroke-width='1.09' d='m360 265.23 4.25-1.73m-3.93 3.26 4.2-1.8m-3.86 3.42 4.2-1.98m-3.4 3.53 3.79-1.96m-2.52 3.39 2.95-1.68m-.82 2.7 1.3-.72'/%3e%3cpath stroke='none' d='M369.14 259.6c-2.23-3.3-7.83-1.44-9.28.64-.1.15-.47-.08-.68-.16a.47.47 0 0 1-.08-.04c.39-.65.87-1.3 1.43-1.88 2.71-1.74 7.43-2.09 9.33.98.15.24.05.48-.13.58-.18.11-.44.1-.6-.13z'/%3e%3c/g%3e%3cuse xlink:href='%23a' x='35.34' y='-5.42'/%3e%3cuse xlink:href='%23a' x='70.67'/%3e%3cg stroke='%23000'%3e%3cpath d='M446.26 240.53c3.26 2.16 14.8 8.65 16.52 45.64 3.33 72.1-58.02 114.16-58.02 114.16s77.62-33.05 77.62-114.23c0-34.17-13.56-71.19-40.47-71.19l-14.8.05L405.64 225a6.78 6.78 0 0 0-5.35-2.6 6.79 6.79 0 0 0-5.35 2.6l-21.48-10.05-15.26-.05c-26.9 0-40.48 37.02-40.48 71.2 0 81.17 77.63 114.22 77.63 114.22S334 358.25 337.33 286.16c1.7-37 13.25-43.48 16.52-45.64l18.13 6.05 22.91-13.41c1.5 1.6 3.04 2.73 5.4 2.73 2.36 0 3.68-.93 5.4-2.73l22.76 13.57z'/%3e%3cpath fill='%23d99f31' d='m431.45 214.14-31.17 13.55-31.17-13.55-10.92.77c-26.9 0-40.48 37.02-40.48 71.2 0 81.17 77.62 114.22 77.62 114.22s-62.12-42.07-58.79-114.16c1.71-37 13.57-44.42 16.83-46.57l19.98 5.56 26.93-15.92 26.93 15.92 19.51-5.56c3.27 2.15 15.13 9.58 16.83 46.57 3.34 72.1-58.79 114.16-58.79 114.16s77.62-33.05 77.62-114.23c0-34.17-13.56-71.19-40.47-71.19z'/%3e%3cpath stroke='none' d='M437.34 228.91c-3.72.44-6.32 2.93-6.45 6.74-.08 2.04.9 5.06 2.3 6.34l-.84.92c-1.65-1.51-2.87-4.89-2.78-7.31.15-4.27 3.14-7.24 7.61-7.76zm-74.51-1.07c4.47.52 7.46 3.5 7.61 7.76.09 2.42-1.13 5.8-2.78 7.3l-.84-.9c1.4-1.29 2.38-4.31 2.3-6.35-.13-3.8-2.73-6.3-6.45-6.74zm-8.74 7.44c-5.4 3.49-10.3 10.1-13.03 16.93-.16.35-.39.46-.62.38-.22-.08-.3-.39-.2-.69a39.72 39.72 0 0 1 13.53-18.18l.32 1.56zm7.2-12.85c-13.21 0-23.02 9.3-29.64 26.47-.15.32-.45.56-.78.45-.26-.1-.3-.47-.17-.8 6.62-17.5 16.72-27.2 30.6-27.2 6.03 0 11.22 1.48 15.66 4.75l.24 1.6c-4.45-3.62-9.73-5.27-15.9-5.27zm0 3.56c-11.53 0-20.52 9.72-26.18 24.02-.16.34-.4.53-.71.4-.25-.1-.27-.47-.15-.77 5.38-14.46 14.82-24.73 27.04-24.73 6.13 0 11.39 1.94 15.81 6.2l-.2 1.38c-4.34-4.46-9.53-6.5-15.6-6.5zm13.22 12.6c-2.3-6.87-6.06-9.52-13.38-9.52-9.65 0-17.6 8.77-22.85 22.04-.13.3-.36.48-.64.38-.25-.08-.3-.42-.18-.73 5.11-13.48 13.32-23.08 23.67-23.08 7.69 0 11.8 3.16 14.02 9.84l-.64 1.07zm51.05.09-.67-.96c2.2-6.8 6.29-10.02 14-10.04 12.43.05 21.97 14.05 26.93 32.33.1.36.03.75-.3.81-.3.06-.56-.18-.65-.52-4.97-18.03-14.44-31.17-25.9-31.23-7.39.02-11.12 2.7-13.41 9.6zm43.38 21.76c.1.41.07.76-.3.85-.29.07-.55-.15-.65-.59-4.77-20.38-14.98-34.36-29.18-34.36-6.11 0-11.33 1.52-15.64 5.97l-.2-1.43c4.43-4.28 9.7-5.7 15.84-5.7 15.12 0 25.64 14.94 30.13 35.26zm3.83.54c.08.38-.05.75-.39.8-.31.05-.57-.22-.64-.6-4.7-22.3-15.8-38.71-33.15-38.71a24 24 0 0 0-15.73 5.75l.17-1.6a24.87 24.87 0 0 1 15.56-5.32c18.29 0 29.68 17.3 34.18 39.68zm-31.65-28.23c9.51 1.17 18.06 12.3 21.67 26.99.09.37 0 .74-.32.83-.3.08-.58-.12-.71-.6-4.12-15.82-12.27-24.67-20.76-25.75l.12-1.47z'/%3e%3cpath fill='none' d='M419.35 240.51c-.73-.86-2.93-3.99-2.93-10.27m-.3 8.37c-.68-.92-2.32-3.61-2.32-8.37m-.86 6.48a11.9 11.9 0 0 1-1.76-6.48m-1.35 4.65c-.4-.8-1.11-2.53-1.11-4.65m-27.5 10.27c.72-.86 2.92-3.99 2.92-10.27m.3 8.37c.68-.92 2.32-3.61 2.32-8.37m.86 6.48c.59-.9 1.76-3.11 1.76-6.48m1.35 4.65c.4-.8 1.12-2.53 1.12-4.65'/%3e%3ccircle cx='400.28' cy='229.24' r='6.2' fill='%23d99f31' stroke='none'/%3e%3cpath fill='none' d='M394.13 227.78a6.31 6.31 0 0 1 12-1.02m.33 4.06a6.38 6.38 0 0 1-12.1.7m7.55 1.62a4.23 4.23 0 0 1-5.86-3.74m7.87 2a4.24 4.24 0 0 1-2 1.74m-1.2-1.9a2.05 2.05 0 0 1-2.48-1.8m-2.12-1.23c.13-.56.37-.9.47-1.05'/%3e%3cpath fill='none' d='M394.13 227.78c0-2.92 2.56-5.36 6.15-5.36 2.74 0 5.85 1.92 5.85 4.34m.33 4.06c0 2.7-3.22 5.08-6.18 5.08-2.7 0-5.93-1.97-5.93-4.38'/%3e%3cpath d='M423.35 242.22a17.45 17.45 0 0 0 13.96 7.07c7.4 0 13.03-4.6 13.03-11.94-.17-3.9-2.8-8.7-9.02-8.7-4.04 0-7.47 3.89-7.47 7.93 0 2.23.43 3.58 1.8 5.26-5.53-1.78-9.2-4.73-9.2-11 0-6.45 4.28-11.06 11.27-11.64 23.39-1.95 37.68 24.01 40.43 59.9 3.93 51.17-23.68 91.97-65.64 115.26-5.85 3.25-10.45 5.85-12.43 6.7l-.03 6.36c15.97-6.1 34.5-17.9 46.05-28.44 21.99-20.1 42.97-54.08 39.79-99.85-2.02-28.91-11.02-48.3-22.07-57.87-18.89-16.39-44.65-9.84-44.65 9.57a18.5 18.5 0 0 0 4.18 11.39zm-46.6 0a17.45 17.45 0 0 1-13.96 7.07c-7.4 0-13.03-4.6-13.03-11.94.17-3.9 2.8-8.7 9.01-8.7 4.04 0 7.47 3.89 7.47 7.93 0 2.23-.42 3.58-1.8 5.26 5.54-1.78 9.2-4.73 9.2-11 0-6.45-4.27-11.06-11.27-11.64-23.38-1.95-37.67 24.01-40.42 59.9-3.93 51.17 23.67 91.97 65.63 115.26 5.86 3.25 10.45 5.85 12.44 6.7l.03 6.36c-15.98-6.1-34.5-17.9-46.05-28.44-21.99-20.1-42.97-54.08-39.79-99.85 2.01-28.91 11.02-48.3 22.06-57.87 18.9-16.39 44.66-9.84 44.66 9.57a18.5 18.5 0 0 1-4.18 11.39z'/%3e%3cpath fill='%23f1bf31' d='M400.05 406.96c-15.98-6.11-34.5-18.67-46.05-29.22-22-20.1-41.58-53.3-38.4-99.08 2.02-28.9 10.56-47.2 21.6-56.79 18.9-16.37 43.26-8.92 43.26 8.96 0 9.84-7.98 17.84-17.83 17.84-5.96 0-12.25-4.83-11.63-12.1a7.32 7.32 0 0 1 14.62.32c0 2.23-1.46 4.39-3.03 5.73 6.22-.22 11.67-5.5 11.67-11.79 0-6.44-4.89-11.82-11.89-12.4-23.38-1.95-38.5 24.63-41.04 60.66-3.63 51.2 24.3 92.6 66.25 115.9a126.8 126.8 0 0 0 12.47 6.08c1.97-.83 6.58-2.82 12.46-6.09 41.96-23.3 69.88-64.68 66.26-115.89-2.55-36.03-17.66-62.6-41.05-60.67-7 .59-11.88 5.97-11.88 12.41 0 6.29 5.45 11.57 11.67 11.8-1.57-1.35-3.04-3.5-3.04-5.74a7.32 7.32 0 0 1 14.63-.32c.62 7.27-5.67 12.1-11.63 12.1-9.85 0-17.83-8-17.83-17.84 0-17.88 24.36-25.33 43.25-8.96 11.05 9.58 19.59 27.89 21.6 56.79 3.18 45.77-16.4 78.99-38.4 99.08-11.55 10.55-30.07 23.1-46.04 29.22z'/%3e%3c/g%3e%3c/g%3e%3cg stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.93'%3e%3cpath d='M302.44 357.77s-3.28-1.33-4.74-2.06c-2.52-1.26-8.21-8.26-14.57-11.95-9.76-5.66-19.2-4.2-27.83-7.9 1.93 9.03 8.02 17.19 18.1 21.51 8.28 3.55 21.64.5 23.1.62 1.45.12 6.06 1.9 6.06 1.9l-.12-2.12zm-35.22 11.27.09-.26a138.2 138.2 0 0 0 15.53-3.25c11.5-2.92 16.9-.55 26.22 5.83.58.4 1.27.96 1.94 1.2 1.51.58 2.48.18 3.94.18l.14.03 2.18 1.7c.17.14.07.25-.09.28-1.9.4-4.5.39-6.5.21-3-.27-9.19 6.85-18 6.85-11.16 0-18.5-4.94-25.45-12.77z'/%3e%3cpath fill='%23658d5c' d='M316.3 374.32c-1.74.06-3.6.06-5.31.35-5.14.86-10.22 6.45-18.02 6.68-10.39.3-16.95-4.6-24.04-11.58 10.32-1.55 18.3-7.51 28.96-4.16 5.47 1.72 11.89 8.6 17.02 7.61l1.4 1.1z'/%3e%3cpath stroke-width='.45' d='M309.88 372.95s-9.11 1.5-14.79 1.5c-9.16.03-23.19-3.8-23.19-3.8s13.99 4.24 23.2 4.43c5.66.11 14.78-1.2 14.78-1.2v-.93z'/%3e%3cpath fill='none' stroke-width='.78' d='M284.54 262.68c.07-.3.02-.64-.16-1.07-.18-.44-.47-.92-.77-1.42-.3-.52-.64-1.08-.9-1.65a5.41 5.41 0 0 1-.5-1.87l1.4-.4a6.8 6.8 0 0 0 2.17 3.74l.43.45-1.18 2.62c-.08.2-.6 0-.5-.4z'/%3e%3cpath stroke-width='.78' d='M338.06 388.95c-.04-1.9.34-1.2 2.38-.36.44.18.12.6-.26.84-1.22.76-2.3 2.38-2.82 2.02-1.4-.99-.52-1.02.7-2.5z'/%3e%3cpath d='M289.16 254.94c-6.03 15.31-8.06 42.44-5.98 54.76 6.41 37.86 37.6 73.37 66.15 79.1 24.83 5 39.97 16.12 49.85 27.98 6.46 7.76 9.91 11.28 19.19 26.72 3.39 5.65-2.41 6.79-4.8 2.11-6.53-12.76-10.05-18.44-19.04-28.47-9.66-10.78-23.87-20.45-47.06-25.08-27.65-5.52-60.05-41.09-66.46-78.95-2.08-12.32-.26-41.73 6.07-57.28l2.08-.9'/%3e%3cpath d='M330.29 387.33c-4.3.48-7.21 6.72-11.53 10.65-7.95 7.24-20.68 7.96-28.8 3.13-.34-.2-.52-.66-.13-.75 10.1-2.29 11.41-16.07 32.46-14.71 2.47.16 3.5.66 5.99.66l2.01 1.02zm-15.99-64.06.15.07c.1 6.15 4.77 14.55 5.91 21.32 1 5.83-.43 10.7-2.67 16.13-.55 1.35-1.87 4.07-1.92 5.4-.04 1.25.73 2.4 1.4 3.42.22.37 1.62 2.2 1.47 2.55-5.57-4.83-2.3-1.68-4.61-6.13-1.2-2.3-2.63-4.38-3.81-6.7-6.26-12.2-6.38-26.06 4.09-36.06zm40.26 66.7c-2.74-.88-5.53-1.98-7.03-4.78-2.53-4.7-1.99-8.5-4.58-13.38-4.91-9.23-14.37-10.23-19.14-18.8-.97 7.89-2.03 19.66 10.24 28.08 4.32 2.96 10.9 3.64 12.5 4.83 1.58 1.2 2.54 2.9 2.54 2.9l5.47 1.15z'/%3e%3cpath fill='%23658d5c' d='M349.24 388.53c-.9-.96-1.9-1.92-2.98-2.7-2.5-1.8-7.92-1.98-12.02-4.98-5.71-4.2-8.67-8.09-10.26-15-.97-4.19-.22-7.54-.03-11.02 5.15 7.48 14.1 8.18 18.88 17.13 2.91 5.44 2.53 13.7 8.49 17l-2.08-.43z'/%3e%3cpath stroke-width='.78' d='M300.36 347.4s-.35.4-.83 1.77c-.2.62 1.14 2.47 1.03 1.83-.28-1.57.5-2.68.5-2.68l-.7-.92z'/%3e%3cpath fill='%23658d5c' d='M302.44 357.77s-3.28-.7-4.74-1.43c-2.52-1.27-8.11-8.6-14.57-12.27-9.26-5.26-17.33-4.16-26.44-6.82 2.59 9.72 7.53 15.54 16.7 19.66 8.23 3.69 21.65.5 23.1.62 1.46.12 6.07 2.06 6.07 2.06l-.12-1.82z'/%3e%3cpath fill='%23466343' d='M315.48 368.9c-.4-2.88-3.7-7.05-5.07-9.74a36.3 36.3 0 0 1-3.98-12.68c-.97-9.54 1.21-14.68 7.5-21.75.04 2.07.31 2.8.94 4.72 2.63 8.1 6.3 14.78 5.11 23.58-.59 4.33-4.12 10.5-4.28 13.14-.09 1.38.69 2.98 1.37 4.14l-1.6-1.4z'/%3e%3cpath d='M291.92 343.12c-6.73-11.2-22.53-6.18-32.89-15.58-5.02-4.57-7.27-11.44-8.27-17.97-.3-1.94-1.13-9.66-.67-11.15.08-.28.36-.35.57-.14 3.44 3.36 6.88 5.53 10.85 8.22 9.44 6.39 13.31 12.38 18.18 22.35 6.37 13.04 12.14 5.6 12.23 14.27z'/%3e%3cpath stroke-width='.45' d='M312.93 328.1s-2.14 11.2-1.81 18.4c.33 7.37 3.6 18.56 3.6 18.56h-.63s-3.38-11.18-3.6-18.55c-.2-7.24 2.44-18.4 2.44-18.4z'/%3e%3cpath fill='%23658d5c' d='M281.96 336.01c-3.62-1.15-7.78-1.85-12.2-2.91-4.14-1-7.52-3.26-10.68-6.1-4.9-4.42-6.51-10.35-7.47-16.7a48.74 48.74 0 0 1-.44-10.62c.4.7.9 1.38 1.55 1.85 3.21 2.3 6.56 3.9 9.78 6.23 2.81 2.04 4.81 3.38 7.12 5.98a54.2 54.2 0 0 1 7.4 10.73c1.62 3.07 3 6.66 5.1 9.44z'/%3e%3cpath fill='%23a48253' d='M282.12 333.91c1.08 1.45 5.45 3.32 7.05 3.53l1.54 3.85c-2.27-2.65-5.26-4.17-8.75-5.28z'/%3e%3ccircle cx='271.96' cy='304.79' r='4.42' fill='%23d99f31'/%3e%3cpath fill='%23f1bf31' stroke='none' d='M272.47 300.88a4.54 4.54 0 0 0-.36 1.78c0 1.94 1.15 3.53 2.56 3.53.4 0 .76-.13 1.1-.35a3.95 3.95 0 0 0-3.3-4.97z'/%3e%3ccircle cx='271.96' cy='304.79' r='4.72' fill='none' stroke-width='1.24'/%3e%3cpath d='M285.01 302.83s2.06-7.68 4-12.43c4.6-11.24 12.56-11.67 16.61-20.57 2.33 6.01 4.18 13.74.12 22.41-4.68 10.02-16.66 15.9-16.66 15.9l-4.07-5.31z'/%3e%3cpath fill='%23466343' d='M305.59 271.85c5.98 16.33-1.92 28.09-16.42 36.2l-3.82-5.29c2.49-10.48 4.28-15.65 12.3-23.1 3.16-2.95 5.94-3.9 7.94-7.81z'/%3e%3cpath fill='%23a48253' d='M288.71 255.67c-5.97 15.7-7.73 41.94-5.68 54.08 6.43 37.96 37.53 73.59 66.24 79.36 24.75 4.97 39.55 16.12 49.75 27.64 4.76 5.39 8.6 10.64 11.76 15.6 2.72 4.25 5.05 8.9 7.34 12.58.37.59-2.72 1.87-3.05 1.34-2.42-3.91-4.64-8.84-7.43-13.36-3.17-5.13-8.61-10.39-13.35-15.98-10.08-11.9-23.5-20.84-46.76-25.48-27.5-5.5-59.51-40.62-65.9-78.4-2.08-12.27-.55-40.74 4.92-55.78l2.16-1.6z'/%3e%3cpath d='M285.72 329.93c-1.23-1.18-3.01-2.3-4.2-3.54-11.02-11.44-8.13-31.44 3.97-41.2.41-.33.72-.18.78.31a51.95 51.95 0 0 0 2.73 12.26c3.69 10.13 4.29 15.94.94 24.57-2.05 5.26 0 9.9 0 9.9l-4.22-2.3z'/%3e%3cpath stroke-width='.62' d='M324.6 379.21c-7.05-2.41-14.34-1.76-20.2-7.85-6.78-7.03-8.24-17.9-6.47-24.17.08-.3.32-.55.51-.32 1.5 1.84 2.3 3.17 4.28 4.63 7.07 5.21 15.74 7.82 18.74 15.79.6 1.58.8 3.24 1.35 4.84 1.91 5.47 5.04 7.12 9.58 10.11l-7.79-3.03z'/%3e%3cpath fill='%23658d5c' d='M330.12 382.12c-6.6-5.6-18.5-3.6-25.58-11.18-5.2-5.58-7.4-14.37-6.1-22 6.28 5.6 13.59 7.15 19.3 13.43 6.74 7.4 1 12.38 13.68 19.58l-1.3.17z'/%3e%3cpath d='m294.87 341.94.01-.17c1.64-1.95.5-7.82-.03-10.17a28.63 28.63 0 0 1-.37-11.68c.78-4.76 3.4-9.07 6.07-13.02 1.2-1.76 5.07-7.26 5.47-9.25.03-.17.21-.16.29 0 1.48 3.23 2.25 7.16 2.85 10.64.83 4.88 1.1 9.31-.6 14.86a27.2 27.2 0 0 1-6.68 11.52c-1.32 1.42-4.42 4.53-4.88 6.2-.08.32-.6 2.56-.5 4.2l-1.63-3.13z'/%3e%3cpath stroke-width='.95' d='M283.94 277.75s.2.03 1.1-.56a6.28 6.28 0 0 0 2.4-2.89c.46-1.27 3.65-11.86 7.9-18.41 4.98-7.66 10.14-11.1 16.4-16.72.98 6.07 1.13 15.96-4 23.9-4.7 7.27-16.61 12.44-18 12.98-1.38.54-3.74.94-5.1 2.75-.77 1.02-1.3 3-1.3 3l.6-4.05z'/%3e%3cpath d='M282.44 278.76s-.52-.02-1.18-.97a7.13 7.13 0 0 1-1.34-3.9c0-3.16 3-12.64 1.51-19.81-2.84-13.7-7.14-19.18-7.8-24.26-.27-2.03-11.45 13.83-8.05 28.54 1.69 7.3 10.16 15.45 11.35 16.52 1.2 1.07 2.81 2.46 3.6 4.6.8 2.2.62 4.72.62 4.72l1.3-5.44zm6.56-23.55c.8-1.96 2.14-4.28 3.37-5.3 3.02-2.53 11.49-8.82 14.38-13.4 6.44-10.21 5.14-22.79 4.46-24.98-5.58 4.86-10.67 8.06-16.37 16.1-4.96 7.01-6.05 20.73-6.43 23.33-.42 2.83-1.68 5.9-1.68 5.9l2.27-1.65z'/%3e%3cpath fill='%23658d5c' stroke-width='.95' d='m284 279.97.22-1.97a6.82 6.82 0 0 0 3.52-3.6c2.66-6.38 4.29-12.87 8.04-18.76 4.86-7.66 10.07-10.64 15.33-14.84.25 6.76 1.44 13.89-3.95 22.76-3.06 5.03-11.98 10.02-17.53 12.2-2.48.99-4.26 1.78-5.63 4.21z'/%3e%3cpath d='M261.12 266.48c8.5 7.09 10.93 10.4 13.44 21.37.29 1.28 1.92 6.83 2.26 7.52.82 1.63 2.52 2.4 3.57 3.74.1.15.4 3.04.44 3.42.02.23-.15.22-.28.1-1.33-1.2-2.02-3.1-3.57-4.24-1.33-.97-5.82-1.93-7.75-2.73-4.95-2.04-8.99-5.86-11.85-10.33-3.78-5.9-4.2-13.94-3.3-20.7.21-1.56.42-3.43.97-4.9.08-.2.2-.16.3 0 2.02 3.15 3.31 4.7 5.77 6.75z'/%3e%3cpath fill='%23658d5c' d='m280 299.39.23 2c-4.04-5.46-5.4-3.85-10.98-6.16-4.86-2.01-8.81-5.76-11.64-10.16-4.22-6.56-4.14-16.27-2.36-23.66 2.27 4.46 11.13 8.94 14.54 14.52 2.18 3.58 3.54 7.84 4.63 11.88.54 2.02 1.15 6.1 1.99 7.76.62 1.25 2.5 2.92 3.58 3.82zm15.37 42.66c1.5-2.3.18-8.13-.3-10.78-.74-4.08-.8-7.61-.13-11.74 1.09-6.74 5.36-11.25 9.12-16.72a27.63 27.63 0 0 0 2.07-3.34c4.33 12.2 5.55 24.65-3.9 34.89-1.42 1.54-4.84 4.52-5.37 6.4-.28 1-.38 2.07-.46 3.1l-1.03-1.8z'/%3e%3cpath fill='%23a48253' d='M331.31 385.46s-.53.85-3.04.85l1.25 1.22.77-.2c2.4-.49 3.13-.42 4.7.19'/%3e%3cpath fill='%23466343' d='M328.27 386.31c-2.5 0-10.34-1.3-16.61.34-9.45 2.47-13.36 11.32-20.47 14.46 10.8 4.65 18.7 3.5 27.69-3.68 3.62-2.9 5.92-8.42 10.64-9.9z'/%3e%3cpath fill='none' d='M405.4 431s.1-1.38 1.7-1.93c1.37-.48 2.08.61 2.08.61'/%3e%3cpath fill='%23a48253' stroke-width='.78' d='M340.48 388.88s-.85.5-1.1.72c-.58.52-1.35.9-1.58 1.32l-.93-.08c.58-.48 1.18-1.3 1.51-1.7.2-.22 0-1.1 0-1.1l2.1.84z'/%3e%3cpath fill='%23658d5c' stroke='none' d='M287.56 255.57c1.7-4.8 1.66-10.15 2.6-15.13 2-10.52 5-13.94 12.6-20.97 2.41-2.25 4.9-3.88 7.53-5.86.42 3.02.62 5.56.31 8.6-1.5 14.86-7.82 18.37-18.43 27.45-2.06 1.76-2.6 4.23-4.61 5.91z'/%3e%3cpath fill='%23a48253' stroke='none' d='M287.96 254.32c.28-.4.54-.64.69-.57.11.05.13.29.06.62-.33.43-.7.83-1.15 1.2.14-.41.28-.83.4-1.25z'/%3e%3cpath fill='none' d='M287.56 255.57c1.7-4.8 1.66-10.15 2.6-15.13 2-10.52 5-13.94 12.6-20.97 2.41-2.25 4.9-3.88 7.53-5.86.42 3.02.62 5.56.31 8.6-1.5 14.86-7.82 18.37-18.43 27.45-2.06 1.76-2.6 4.23-4.61 5.91z'/%3e%3cpath stroke='none' d='M288.22 256.12s.39-1.17.96-2.66c.58-1.48.43.4.43.4l-.34 1.62-1.05.64z'/%3e%3cpath fill='%23658d5c' stroke='none' d='m282.06 278.96-.78 2.5c-.44-3.25-1.8-4.7-4.14-6.81-10.18-9.21-14.53-20.05-10.26-32.73a25.31 25.31 0 0 1 6.08-10.33 50.61 50.61 0 0 1 4.34 9.15c3.49 9.38 4.88 14.69 3.5 25.44-.5 3.8-2.32 8.42.2 11.8.28.36.62.8 1.06.98z'/%3e%3cpath fill='none' d='m282.06 278.96-.78 2.5c-.44-3.25-1.8-4.7-4.14-6.81-10.18-9.21-14.53-20.05-10.26-32.73a25.31 25.31 0 0 1 6.08-10.33 50.61 50.61 0 0 1 4.34 9.15c3.49 9.38 4.88 14.69 3.5 25.44-.5 3.8-2.32 8.42.2 11.8.28.36.62.8 1.06.98z'/%3e%3cpath fill='%23a48253' stroke='none' d='M281.76 284.47s.25-2.46-.13-3.96c-.19-.75-.68-1.85-.68-1.85s1.22.62 1.5.57c.28-.05-.68 5.24-.68 5.24zm4.16-24.14c-.59.24-2.39-2.3-2.6-4.02-.22-1.64-.89-.96-.8.34.14 2.42 3.03 5 2.63 6.54.54-1.32.8-2.27.77-2.86z'/%3e%3cpath fill='none' stroke-width='.78' d='M285.92 260.33c-.59.24-2.39-2.3-2.6-4.02-.22-1.64-.89-.96-.8.34.14 2.42 2.72 4.57 2.32 6.1'/%3e%3ccircle cx='281.44' cy='253.51' r='4.42' fill='%23d99f31' stroke='none'/%3e%3cpath fill='%23f1bf31' stroke='none' d='M281.7 253.09c-1.19-.84-1.72-2.16-1.17-2.94.55-.79 1.97-.75 3.17.1 1.2.83 1.72 2.15 1.17 2.93-.55.79-1.97.74-3.16-.1z'/%3e%3ccircle cx='281.4' cy='253.64' r='4.61' fill='none' stroke-width='1.31'/%3e%3ccircle cx='303.96' cy='344.42' r='4.57' fill='%23d99f31' stroke='none'/%3e%3cpath fill='%23f1bf31' stroke='none' d='M303.43 343.97c-.98-1.34-1-2.98-.07-3.66.93-.68 2.48-.14 3.45 1.2.98 1.35 1.01 2.98.08 3.66-.94.68-2.48.14-3.46-1.2z'/%3e%3ccircle cx='303.96' cy='344.42' r='4.8' fill='none' stroke-width='1.4'/%3e%3cpath fill='none' d='M406.8 432.55s.05-1.39 1.69-1.78a1.8 1.8 0 0 1 2.08.93m7.23 15.61c-2.99.62-4.81-3.13-3.79-4.05.67-.6 2.32-.48 3.54.12 2.16 1.05 1.58 3.66.25 3.93z'/%3e%3cpath fill='%23a48253' stroke='none' d='M417.8 447.31c-2.48.63-4.43-2.7-3.79-3.43.6-.68 1.85-.72 3.06-.13 2.17 1.06 2.05 3.23.73 3.56z'/%3e%3cpath fill='none' d='M417.8 447.31c-2.48.63-4.43-2.7-3.79-3.43.6-.68 1.85-.72 3.06-.13 2.17 1.06 2.05 3.23.73 3.56z'/%3e%3cpath stroke-width='.45' d='M287.44 256.18c3.14-9.16 4.9-15.6 10.1-24.55 3.54-6.08 10.48-14.7 10.48-14.7s-6.54 8.84-9.93 14.97c-4.8 8.66-5.87 12.39-9.7 23.46l-.95.82zm-14.89-20.36s-1.15 14.39.66 23.3c1.63 8 7.27 19.63 7.27 19.63s.32.23-1.32-4.08c-1.68-4.43-3.82-9.32-5.18-15.58-1.93-8.88-1.43-23.27-1.43-23.27zM259.1 273.2s1.9 4.98 3.54 7.96c4.48 8.17 8.32 12.44 15.97 17.77l.22-.69c-7.37-5.23-10.84-9.41-15.58-17.08-1.83-2.98-4.15-7.96-4.15-7.96zm27.38 3.34s9.16-8.45 13.84-15.06c4.14-5.85 9.1-16.21 9.1-16.21s-4.53 10.49-8.55 16.37c-4.5 6.6-13.15 14.9-13.15 14.9h-1.24zm8.97 66.26c1.75-4.2 4.37-9.98 6.32-16.64 2.46-8.35 3.91-12.42 4.2-21.93-.15 9.5-1.16 12.78-3.17 20.68a122.42 122.42 0 0 1-5.8 16.83l-1.55 1.05zm-5.21-42.13s6.9-6.03 9.98-11.43c4.06-7.12 4.74-12.83 4.74-12.83s-.06 5.74-4.12 12.86c-3.08 5.4-10.33 12.29-10.33 12.29l-.27-.9zm-7.86 34.21s-5.95-3.77-9.21-6.51c-12.66-10.67-20.59-25.04-20.59-25.04s7.25 15.18 20.12 25.66c3.42 2.78 9.68 6.67 9.68 6.67v-.77z'/%3e%3cpath fill='none' d='M283.2 336.41s-1.14-.48-.55-1.57'/%3e%3cpath stroke-width='.45' d='M328.64 380c-5.59-3.52-13.44-8.75-20.53-16.02a151 151 0 0 1-5.91-6.67s2.83 4.42 5.14 6.82c6.31 6.58 14.99 12.74 20.57 16.25l.73-.39zm19.33 6.7s-10.5-7.53-15.23-14.11a44.67 44.67 0 0 1-5.56-9.83 51.9 51.9 0 0 0 6.33 9.83c4.73 5.99 14.46 13.18 14.46 13.18v.93zm-52.02 13.51c15.45-2.15 21.46-11.17 34.61-13.22-1.38.07-1.13-.47-2.39-.2-11.6 2.44-18.7 11.22-32.22 13.42z'/%3e%3ccircle cx='314.8' cy='382.21' r='4.57' fill='%23d99f31' stroke='none'/%3e%3cpath fill='%23f1bf31' stroke='none' d='M319.29 381.34c-.04.15-.1.3-.18.43-.67 1.16-2.5 1.35-4.1.43-1.6-.92-2.34-2.6-1.67-3.76.19-.34.47-.59.82-.76a4.57 4.57 0 0 1 5.12 3.66z'/%3e%3ccircle cx='314.8' cy='382.21' r='4.8' fill='none' stroke-width='1.4'/%3e%3cpath fill='%23a48253' stroke='none' d='M330.8 384.33s.43.24.7.54c.26.3.36.66.17.89 0 0 .1.26.45.5.46.34 1.06.32 1.73.42.85.14 1.45.25 2.05.43.6.18 1.36.49 1.36.49l-3.43-1.7-3.03-1.57z'/%3e%3cpath stroke-width='.45' d='M297.76 357.55s-8.53-2.24-19.42-6.3c-10.9-4.07-18.24-10.87-18.24-10.87s7.34 6.18 18.24 10.25c10.9 4.06 19.42 5.99 19.42 5.99v.93z'/%3e%3ccircle cx='334.69' cy='394.97' r='4.88' fill='%23d99f31' stroke-width='1.24'/%3e%3cpath fill='%23f1bf31' stroke='none' d='M338.15 397.95c-1.46.56-3.39-.4-4.47-2.27-1.17-2.03-.92-4.37.57-5.23l.06-.03.37-.02a4.57 4.57 0 0 1 3.47 7.55z'/%3e%3ccircle cx='334.68' cy='394.97' r='4.57' fill='none'/%3e%3cpath fill='%23a48253' stroke='none' d='M289.6 332.55s.51 1.59.92 2.58c.3.73.84 1.85.84 1.85s-1.12.24-1.12.11c0-.12-.88-4.52-.88-4.52l.24-.02z'/%3e%3cpath fill='%23658d5c' stroke='none' d='M289 333.47c-1.65-2.52-5.16-5.34-7.14-7.4a22.64 22.64 0 0 1-6.31-12.5c-1.84-11.54 1.52-19.3 9.94-27.1.54 8.1 5.17 14.8 6.15 22.9 1.4 11.6-5.98 13.79-.85 25.14l-1.78-1.04z'/%3e%3cpath fill='%23a48253' stroke='none' d='m287.89 331.17.23 1.12c.33.4.63.8.88 1.18l1.47.85-.78-2.66-1.8-.49z'/%3e%3cpath fill='none' d='M289 333.47c-1.65-2.52-5.16-5.34-7.14-7.4a22.64 22.64 0 0 1-6.31-12.5c-1.84-11.54 1.52-19.3 9.94-27.1.54 8.1 5.17 14.8 6.15 22.9 1.4 11.6-5.98 13.79-.85 25.14'/%3e%3cpath stroke-width='.45' d='M289 331.08c-3.36-5.05-4.02-7.52-5.43-12.72-2.67-9.77-2.69-21.63-.18-25.97-2.5 4.34-3.03 16.14-.6 25.98 1.37 5.54 2.46 8.44 5.57 13.54l.64-.83z'/%3e%3cpath fill='none' d='M288.59 332.89c-.82-.96.23-2.53 1.17-1.15'/%3e%3c/g%3e%3cg stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='.93'%3e%3cpath stroke-width='.78' d='M514.67 257.68a.63.63 0 0 1 .04-.27s.3-.43.6-1.14c.3-.73.61-1.73.63-2.84l1.66.34c-1.39 4.94-1.44 6.7-1.44 6.7-.01.4-.49.47-.6.08l-.9-2.87z'/%3e%3cpath d='M519.12 275.31c1.33-.87 1.77-3.1 1.85-4.56.15-2.6-2.02-4.9-2.13-7.32-.07-1.55 1.27-1.7 1.52-2.91.22-1.08-3.96-4.86-2.83-7.84.8-2.13 2.5-1.08 3.15-3.3.68-2.36-1.44-5.73 1.29-7.31 1.32-.77 3.26.35 3.84-1.72.58-2.1.12-6.27 3.14-6.56 4.01-.4 4.63 7.82 5.37 8.4.76.6 1.8-.5 2.88-.07 2.95 1.17-.2 6.6-1.22 8.42 7.47.3.64 4.95-.5 7.02.31.75 2.22 1.03 2.54 2.18.2.76-.36 1.42-.89 1.88-1.67 1.48-4.17 2.04-5.99 3.23l-.25.18c-.06.68 1.84 2.68-.72 3.53-4.76 1.59-7.8 2.63-9.63 7.44-.5 1.3-.67 5.25-.76 4.85l-.66-5.54z'/%3e%3cpath fill='%23658d5c' d='m519.85 279.07-.83-3.63c.22-.12.41-.3.6-.48.97-.93 1.43-3.5 1.5-4.8.17-2.81-1.87-4.42-1.97-6.76-.06-1.21 1.29-1.65 1.5-2.8.28-1.45-3.75-4.99-2.7-7.75.73-1.88 2.47-.9 3.17-3.35.62-2.12-1.22-5.91 1.08-7.19 1.38-.76 3.38.47 4.05-2 .51-1.85.12-5.02 2.74-5.29 3.58-.35 4.11 6.82 5.04 7.53 1.03.79 1.85-.23 2.84.15 1.5.59 1.12 2.65.79 3.83-.4 1.38-1.06 2.52-1.64 3.8-.1.26-.11.5.2.62.93.35 1.73.2 2.06 1.43.44 1.67-2.13 3.5-2.7 4.83-.44 1.03 1.3 1.29 1.52 2.66.32 1.92-6.15 4.09-6.65 5-.06 1.26 1.62 2.56-.42 3.25-5.12 1.71-10.24 4.94-10.18 10.95z'/%3e%3cpath stroke-width='.45' d='M519.4 275.86s6.53-11.62 8.41-19.87c1.3-5.72 1.88-14.96 1.88-14.96s-.28 9.21-1.41 14.94c-1.72 8.7-8.47 20.98-8.47 20.98l-.41-1.09z'/%3e%3cpath stroke-width='.78' d='M519.6 286.9c0-.05.06-.23.09-.27 0 0 1.27-1.34 2.03-2.2.3-.33.48-.73.6-1.06.1-.32.13-.55.13-.55.03-.2.2-.32.4-.25l2.18.72c.3.1.33.36.08.54-.02.01-1.67 1.18-2.27 1.9a9.15 9.15 0 0 0-2.2 3.8c-.12.37-.53.34-.6-.06l-.43-2.57z'/%3e%3cpath fill='%23a48253' stroke-width='.78' d='M520.35 289.42c.54-1.67.91-2.3 2.25-3.9.63-.74 2.33-1.94 2.33-1.94l-2.17-.72s-.14 1.03-.8 1.78c-.77.86-2.05 2.2-2.05 2.2l.44 2.58z'/%3e%3cpath d='M511.7 247.35s2.72 5.43 5.07 13.79c4.83 17.25 5.46 39.65 3.38 51.97-6.41 37.86-40.67 73.27-68.32 78.8-23.2 4.62-36.87 14.5-46.6 25.23-7.55 8.73-10.47 13.94-17.33 27.9-2.1 4.3-9.01 5.15-6.04-.9 5.37-9.5 10.47-18.26 18.35-27.6 10.23-11.56 24.93-22.9 49.76-27.9 28.55-5.73 61.44-41.08 67.85-78.94 2.09-12.32 1.44-39.17-5.52-56.44l-.6-5.91'/%3e%3cpath stroke-width='.85' d='M497.25 240.33s-8.04-.3-4.17-6.4c-3.69-1.8-8.13-5.1-3.37-7.8-.22-.92-3.03-1.81-2.82-3.99.13-1.25 1.71-1.82 1.85-2.36-.53-.99-4.2-5.7-2.93-7.11 1.96-2.16 6.18.44 8.1 1.6.48-.3 1.19-.89 1.66-1.2 2.8-1.86 3 2.63 3.76 4.07.36.66 2.57-1.13 4.06-.33 2.59 1.36 1.45 4.7 2.1 6.95.65-.07 1.58-.6 2.22-.64 4.2-.28 1.92 7.1 1.75 9.41 6.66-.96 1.53 5.88 1.9 11.75.1 1.62-.4 5.2-1.65 3.82-3.94-4.34-14.9-3.15-12.45-7.77z'/%3e%3cpath stroke-width='.98' d='M496.32 264.53c-1.44-.12-4.56-.56-5.18-1.93-.97-2.17 1.56-2.91 1.43-3.07-.88-1.18-5-1.94-5.01-3.6-.02-1.15 1.92-1.98 1.58-3.04-.47-1.45-3.24-3.65-2.17-5.26 1.3-1.94 4.04.67 5.35.65.63 0 1.52-1.4 2.72-1.41 1.77-.03 2.85 3.4 3.52 3.32.74-.1 1.19-1.12 1.91-1.34 2.22-.67 2.85 1.73 3.38 3.3 1.03 3.08 2.14-.59 3.8.14 4.22 1.84 2.49 10.1 3.71 11.08.74.6 2.12.53 2.66 1.37 1.15 1.8-.43 5.42.46 8.66.36 1.31 4.45 5.13 4.45 5.13s.64 3.81.54 3.61c-1.85-3.55-2.25-4.39-5.55-6.91-3.18-2.43-8-.5-9.12-1.78-1.23-1.41.2-2.7-.45-3.33-.24-.23-3.97.16-4.53.1-2.65-.27-5.08-2.68-3.5-5.7z'/%3e%3cpath fill='%23658d5c' stroke-width='.98' d='m518.51 278.2.43 2.37c-6.8-9.72-12.34-5.85-13.8-7.43-1.1-1.2.3-2.07-.6-3.01-.95-1-6.67 1.11-8.36-3.32-.36-.93.9-2.45.27-2.58-1.45-.28-3.4-.24-4.39-1.55-.41-.54-.77-1.29-.23-1.88.28-.3.61-.56.85-.91.88-1.31-4.49-2.33-4.5-4.28-.02-1.12 1.46-1.52.92-2.9-.47-1.21-2.1-3.2-1.27-4.52 1-1.59 3.27.41 4.53.56.62.07 1.67-1.39 2.7-1.42 1.62-.05 2.31 2.97 3.55 2.85 1.22-.12 2.6-2 3.92-.37.92 1.15.9 4.48 3.07 3.52.52-.24 1.29-.87 1.87-.61 3.46 1.5 2.58 7.06 3.44 10.03.46 1.59 2.11 1.24 2.7 2.22.3.48.53 1.03.58 1.59.04.48-.03.95-.1 1.43-.27 1.92-.09 3.64.4 5.52.39 1.5 2.5 4.28 4.02 4.69z'/%3e%3cpath d='m520.09 307.84.34-.28c1.2-.02 2.02-2.5 2.39-3.45 1.5-3.93-1.2-10.46 3.34-10.44.24-1.62.57-5.62 2.05-6.69 1.07-.77 2.12.2 3.15-.1.76-1.53 1.12-4.44 3.3-4.85.7-.13 2.15 1 2.39.87.6-.3 1.3-3.42 3.05-3.89 1.07-.29 2.09.82 2.48.57.64-.4 1.26-1.07 1.79-1.64 2.28-2.43 5.12-2.48 5.04.77-.03 1.16-.76 2.79-1.18 3.84-.14.36 1.43 1.1 1.67 1.57.8 1.53-2.02 3.35-2.66 4.56.05.2 1.5.5 1.72.8 1.89 2.64-3.57 5.53-4.95 7.15-.54.64 1.32 2.06 1.06 3.16-1.04 4.43-7.86 2.8-9.37 3.49-.53.24-.69 2.6-1.13 3.21-1.92 2.6-9.53-.57-11.25 1.05-1.58 1.48-2.1 4.01-3.1 5.81-.22.4-.64.27-.6-.13l.47-5.38z'/%3e%3cpath fill='%23658d5c' d='M520.54 308.03c1.4-.07 2.28-2.63 2.7-3.75.56-1.45.81-2.9.87-4.45.08-2.25-1.53-6.2 1.97-5.67 0 0 .73-5.27 2.25-6.49.98-.8 2.74-.34 3.16-.66 1.01-.74.62-3.96 2.8-4.37.84-.16 2.35.68 2.99.36.8-.4 1.09-2.82 2.63-3.23.96-.25 2.23.78 2.86.4 1.33-.83 2.33-3.45 4.2-2.93 2.12.6 1.38 3.8.84 5.12-.39.94.68 1.28 1.06 1.97.71 1.3-1.65 3.36-1.94 4.5-.11.43.93.95 1.19 1.23 1.57 1.68-2.48 4.65-3.57 5.58-.32.27-1.03.82-1.06 1.27-.09.94.93 1.63.67 2.78-.9 3.9-6.32 2.74-8.45 3.46-.86.28-.99 2.03-1.52 2.76-1.7 2.34-9.18.08-11.2 1.91-1.2 1.1-2.16 2.98-2.82 4.46l.37-4.25z'/%3e%3cpath stroke-width='.45' d='M521.66 307.03c.23-.07 9.06-7.1 14.02-12.49 4.07-4.4 9.46-12.12 9.46-12.12s-5.33 7.86-9.3 12.43a144.33 144.33 0 0 1-14.18 13.57c-.24.07-.24-1.33 0-1.4z'/%3e%3cpath d='M523.7 284.44c-2.08-1.2-1.78-7.67 1.26-10.6 2.56-2.47 9.71 4.8 7.5 7.8-1.24 1.67-6.58 4.08-8.77 2.8z'/%3e%3cpath d='M532.5 280.53c-1.29 1.06-4.27-.32-5.79-1.84-1.39-1.4-2.23-3.52-1.4-4.5 1.64-1.95 6.2-4.74 8.4-2.9 2.18 1.83-.05 8.28-1.21 9.24z'/%3e%3cpath fill='%23a48253' d='M532.08 281.37c-1.17 1.58-6.26 3.61-8.15 2.52-1.64-.96-1.62-6.84 1.36-9.72 1.88-1.82 8.89 4.35 6.79 7.2z'/%3e%3cpath fill='%23d99f31' stroke-width='1.09' d='M533.25 271.8c1.82 1.53.06 7.46-1.05 8.37-.94.77-3.61-.26-5.16-1.8-1.4-1.42-2.08-3.39-1.53-4.04 1.68-2 5.92-4.05 7.74-2.52z'/%3e%3cpath fill='%23f1bf31' stroke='none' d='M531.9 271.84a3.83 3.83 0 0 0-.88 2.6c0 1.68.84 3.06 1.89 3.1.14-.45.27-.93.37-1.43.17-.86.26-1.73.19-2.44-.07-.7-.29-1.2-.58-1.45l-.01-.02a1.8 1.8 0 0 0-.97-.36h-.02z'/%3e%3cpath stroke-width='.86' d='M493.75 286.8c-.58-1.8-3.34-3.03-3.63-5.19-.13-.98.94-2.65.85-2.94-.48-1.55-3.07-3.56-1.74-5.5 1.72-2.5 4.16.08 6.2.67.33-.12.44-1.24 1.24-1.45 3.11-.83 5.83 4.23 6.65 4.54 2.41.91 4.3-3.36 5.62 5.98 1.04-.25 2.44-.5 3.07.56 2.57 4.4 1.06 13.9 6.2 16.44l.17.34c-.07.37-.24 3.18-1 2.26-1.3-1.57-2.31-3.8-4.57-4.2-2.39-.42-12.8 3.35-13.09-1.39-.03-.55.73-1.32.48-1.86-.6-1.3-6.86-.85-7.51-4.35-.26-1.37.7-2.62 1.06-3.91z'/%3e%3cpath fill='%23658d5c' stroke-width='.86' d='M517.58 301.94c-3.83-5.95-5.55-3.7-11.36-3.27-1.33.1-5.8.29-5.73-1.95.03-.64.51-.8.11-1.58-.84-1.64-6.08-1.34-6.87-4.38-.41-1.58.45-3.7.23-4.3-.73-1.98-3.98-3.83-3.02-6.42.13-.34.32-.66.39-1.03.2-1.14-2.15-3.77-1.1-5.45 1.2-1.97 3.31-.42 4.92.31 1.15.52.86-.5 1.62-.75 1.33-.44 2.98.83 3.87 1.68.5.48 2.08 2.36 2.48 2.55.94.44 2.53-.06 3.62.32.98.35 1.64 4.45 1.79 5.5l.19.13c.89-.2 2.2-.19 2.73.68 2.43 3.96 1.24 13.42 6.45 16.3l-.32 1.66z'/%3e%3cpath stroke-width='.45' d='M517.28 301.66s-6.92-11.44-12.9-17.43c-3.8-3.81-10.63-8.82-10.63-8.82s6.9 5.23 10.64 9.26c5.45 5.86 11.5 17 11.5 17h1.39z'/%3e%3cpath d='M509.88 319.28c.31.15.97.03 1.38.14 3.05.84-1.31 9.68-1.56 11.62-.06.51.27 2.19.24 2.3l-.67 3.76c-.12.4.07-3.74-.53-4.77-1.06-1.83-4.41-.84-6.13-1.1-2.85-.45-.63-2.88-1.86-3.37-2.04-.82-6.3.34-6.8-2.7-.2-1.13.55-2.34.47-3.31-1.46-1.7-5.22-2.07-4.78-5.05.15-1.03 1.65-2.12 1.6-2.8-.04-.8-3.14-3.07-2.4-4.73.45-1 1.32-1.01 1.4-1.6.1-.61-2.5-4.51-.32-5.57 2.62-1.26 4.79 1.7 6.68 1.83.96.07 1.8-1.5 3.25-1.17 1.53.34 1.7 2.38 2.4 3.52.67.02 1.33-.7 2.08-.77 3.2-.34 2.7 4.78 3.52 6.55.1.21 1.06-.37 1.46-.22.67.26.92 1 1.01 1.66.28 1.92-.74 3.97-.44 5.78zm20.26 7.68c.6 6.03-7.58.09-12.08 2.49-1.35.7-4.49 3.11-4.26 2.54l1.13-2.86c.38-.31 1.59-.32 2-.5.98-.45 2.32-2 3.21-3.67 1.24-2.33.4-4.95 1.15-6.66 1.16-2.61 2.96-.21 3.74-.77 1.44-1.05 1.69-6.33 5.2-6.38.93-.02.92.16 1.56.47.73-1.06.97-2.38 2.39-2.82 1.03-.32 1.73.6 2.68.58.68-.53 3.32-4.95 5.48-4.43 2.43.58.97 4.9.78 6.49.27.3.6.29 1.03.86 1.68 2.24-.95 4.63-1.85 6.4.24.52.92.49 1.06 1.16.6 2.74-4.59 3.07-5.13 3.8 0 .26.4.55.36 1.12-.26 3.35-8.03 2.46-8.45 2.18zm-52.55 19.91c.15-1.14-2.24-2.88-1.24-4.45.82-1.28 2.68-.62 3.43-1.27.65-2.03-.43-4.76 2.39-5.4 1.42-.31 2.2 1.14 2.67 2.24.18.4.8 2.93 1.05 3.02.53.19 1.93-.8 2.63-.71 1.9.27.4 3.84.98 4.85.4.7 1.42.15 2.07.37 1.92.66.43 3.86.43 5.23 0 .83 1.39 1.09 1.5 2.5.2 2.55-1.95 2.83-3.17 4.47-.17.24-.21.35-.02.58 2.1 2.57.91 3.82-1.42 5.52-2.75 2-6.98 3.26-5.42 7.53 0 0-1.4 2.85-1.54 1.9-.22-1.4.46-2.82.07-4.34-.41-1.62-5.36-3.74-5.56-5.49-.14-1.23 1.29-1.42 1.4-2.52.13-1.26-4.3-2.43-3.78-4.93.28-1.35 1.72-1.74 2.35-2.83-.1-1.06-5.04-4.83-.7-5.81.54-.13 1.4-.12 1.88-.46z'/%3e%3cpath fill='%23658d5c' d='M481.75 372.92c.17-1.23.32-2.9 0-4.1-.45-1.75-4.3-3.94-4.46-5.45-.11-.96.62-1.22.78-2.42.2-1.62-3.8-2.66-3.32-4.9.29-1.36 2-2.02 1.84-3.23-.1-.68-2.12-2.35-1.69-4.09.35-1.4 1.88-.84 2.76-1.55.97-.78-1.9-3.13-.98-4.55.72-1.13 2.71-.63 3.27-1.43.59-.83-.46-4.27 2.3-4.91 2.2-.5 2.64 4.2 3.57 4.87.88.65 1.27-.5 2.65-.32 1.35.18.3 3.5.84 4.49.58 1.08 1.5.22 2.44.55 1.51.54.02 3.75.02 4.86 0 1.17 1.23 1.17 1.34 2.55.18 2.24-1.95 2.8-3.08 4.18-.31.38-.34.74 0 1.1 2.04 2.2.6 3.5-1.37 4.93-3.06 2.22-6.66 3.44-5.12 7.9l-1.79 1.52z'/%3e%3cpath d='M531.06 337.06c1.52-.39 3.62-1.87 5.09-.7 2.79 2.23-2.07 6.14-2.97 8.22-.02.77 1.55 1.02 1.45 2.56-.18 2.7-3.77 2.12-5.46 3.08-.13.5.62.91.62 1.4 0 3.81-5.77 2.37-7.97 3.08-.7.23.48 2.25-2.02 3.2-1.08.4-2.62-.02-3.72-.22-1.32-.23-2.67-.5-4.03-.43-.56.03-1.13.18-1.7.13-.23-.02-.4-.14-.32-.41l6.3-18.59c.14-.4 2.88.64 3.49.64.68 0 1.34-1.42 1.82-1.86 1.64-1.5 2.43.64 3.8.64 1 0 3.82-5.58 5.62-.73z'/%3e%3cpath stroke-width='.78' d='M499.83 340.1c-.05-.8-1.63 1.6-1.63 1.6s1.12 1.1 1.89 1.76c.94.81 2.52 1.95 2.52 1.95l.15-1.17s-2.79-1.95-2.93-4.15z'/%3e%3cpath d='M498.15 332.52c.43.6.16 1.42-.13 2.03-.32.67-.51 1.07-.95 1.66-1.44 1.9-4.63 3.6-6.07 2.61-1.31-.9-4-8.78-1.9-10.14 2-1.29 7.18 1.2 9.05 3.84z'/%3e%3cpath d='M490.57 336.03a10.1 10.1 0 0 1 2.42-2.34c1.27-.96 4.48-2.68 5.9-1.3 1.86 1.8 2.76 7.23.6 9.12-2.85 2.5-7.47-.37-9.26-2.84-.62-.85-.17-1.87.34-2.64z'/%3e%3cpath fill='%23a48253' d='M493.3 334.18c1.94-1.44 4.15-2.25 4.99-1.37 2.25 2.37 2.36 6.9.8 8.23-1.57 1.34-5.23 1.23-8.38-2.75-.66-.84.62-2.64 2.58-4.1z'/%3e%3cpath fill='%23d99f31' stroke-width='1.09' d='M497.65 332.26c1.05 1.93-4.7 7.33-6.6 6.05-1.34-.88-3.15-7.68-1.84-8.85 1.84-1.67 7.52 1.11 8.44 2.8z'/%3e%3cpath fill='%23f1bf31' stroke='none' d='M490.64 329.5c-.47.03-.84.16-1.06.36a.83.83 0 0 0-.11.23c.78.39 2.18.74 3.6 1.38 2.05.9 3.47 2.1 4.07 1.76.1-.33.1-.59.03-.71a4.58 4.58 0 0 0-1.28-1.2c-.65-.44-1.47-.88-2.31-1.21a8.5 8.5 0 0 0-2.44-.61 3.77 3.77 0 0 0-.5 0z'/%3e%3cpath fill='%23466343' d='M512.04 356.94c2.87-.14 5.61 1.14 7.35.5 2.59-.92 1-2.93 2.25-3.05 1.25-.11 7.54.35 7.53-2.78 0-.6-.5-.83-.28-1.51.23-.68 4.96-.45 5.13-2.98.1-1.61-1.36-1.63-1.14-2.6.23-.98 5.3-5.77 2.77-7.76-1.74-1.37-4.59 1.02-4.85.32-.36-.9-.43-1.67-1.59-1.77-1.66-.16-2.67 2.5-3.76 2.5-1.09 0-1.58-1.1-2.7-1-1.46.13-1.68 2.37-2.93 2.37-1.25 0-3.19-.7-3.19-.7l-6.3 18.59s1.04-.1 1.7-.13z'/%3e%3cpath fill='none' stroke-width='.62' d='M515.12 349.61s5.92-2.24 9.4-4.26c3.32-1.94 8-5.72 8-5.72m-17.4 9.98s5.92-1.93 9.4-3.95c3.32-1.94 8-6.03 8-6.03'/%3e%3cpath stroke-width='.78' d='M477.3 379.03s2.34-.57 3.28-.57 1.49.46 1.49.46l1.07-1.96s-3.19.38-4.13.29l-1.71 1.78z'/%3e%3cpath fill='none' d='M463.17 400.05c-1.86-2.27 4.3-8.16 6.6-6.5 1.65 1.2 3.72 6.32 2.08 7.85-1.83 1.7-7.2.45-8.68-1.35z'/%3e%3cpath stroke-width='.78' d='m460.32 392.57-.68-.05c-1.2-1.5-1.64-1.56-3.4-2.04-.57-.16-.65-.75-.04-.91l2.13-.56c.34-.09 1.25.72 1.5.91.41.3 2.48.75 1.72 1.48l-1.23 1.17z'/%3e%3cpath fill='none' d='M459.86 391.23c.87-1.31 6.28-1.63 9.44 1.16 1.94 1.71.38 4.13-1.47 5.69-1.82 1.54-4.58 2.82-5.71 1.82-3.22-2.8-3.31-7.1-2.27-8.67z'/%3e%3cpath fill='%23658d5c' d='M513.1 333.13s2.62-2.72 4.73-3.78c4.1-2.06 10.75 1.25 11.73-.61.5-.95-.25-1.65.38-1.9.64-.26 7.9 1.18 8.18-2.1.06-.59-.75-.89-.13-1.52.64-.63 5.22-.94 4.76-3.1-.15-.7-1.14-.9-.89-1.59.26-.7 3.7-3.96 2.22-5.96-.42-.58-1.5-.47-1.42-1.18.25-2.22 1-5.65-.83-5.83-1.97-.19-4.27 3.82-5.04 3.97-.95.2-1.52-.75-2.47-.44-1.59.5-1.84 2.85-2.47 2.85-.64 0-.59-.66-1.6-.64-3.12.07-3.38 5.06-4.93 6.28-.89.7-1.41-.24-2.29-.06-2.15.44-1.51 5.83-2.66 7.54a17.64 17.64 0 0 1-4.12 4c-.5.25-1.5.25-1.5.25l-1.64 3.82z'/%3e%3cpath fill='%23a48253' stroke-width='.78' d='M455.15 390s1.98.66 3.28.73c.88.05 2.26-.13 2.26-.13s-.54.12-1.12-.3c-.2-.13-1.55-1.33-1.55-1.33l-2.87 1.02z'/%3e%3cpath fill='%23a48253' d='M460.4 391.64c1.45-1.65 5.66-1.47 8.74 1.25 1.54 1.35.52 3.38-1.3 4.99-1.83 1.62-4.16 2.52-4.95 1.83-3.08-2.7-3.56-6.86-2.5-8.07z'/%3e%3cpath fill='%23d99f31' stroke-width='1.09' d='M463.52 399.9c-.7-.8.41-3.21 1.88-4.54 1.3-1.17 3.42-1.97 3.88-1.48 1.8 1.93 3.64 5.36 2.21 7.07-1.43 1.7-6.42.73-7.97-1.05z'/%3e%3cpath fill='%23f1bf31' stroke='none' d='m469.06 394.48-.14.04c-1.5.31-2.34 2.27-1.89 4.39.2.94.63 1.76 1.17 2.34h.02c1.3.1 2.44-.15 2.86-.66.52-.62.49-1.68.01-2.9a11.36 11.36 0 0 0-2.03-3.2z'/%3e%3cpath fill='%23a48253' stroke-width='.78' d='M515.85 260.45s.05-1.77 1.45-6.76c.24-.87.9-1.35.9-1.35l-2.6-.36s.66.63.65 1.46a8.31 8.31 0 0 1-1.29 4.15l.89 2.86z'/%3e%3cpath fill='%23658d5c' stroke-width='.85' d='M512.96 255.11s-1.7-4.95-3.14-6.75c-1.54-1.92-2.64-2.32-5.42-3.21-2.46-.79-6.3-1.42-6.46-3.35-.17-1.93.06-1.57-.64-1.75-2.26-.6-5.09-1.34-4.55-3.58s1.38-2.58.4-3.05c-1.42-.7-5.18-2.88-4.73-4.8.45-1.91 2.12-1.94 1.42-3.11-.51-.84-2.32-1.76-2.18-3.3.1-1.04 1.43-1.38 1.39-2.3-.04-.94-3.6-5.07-1.5-6.8 1.9-1.57 5.26 1.24 6.12 1.6.86.35 1.85-1.47 3.11-1.17 1.62.38 1.7 2.8 2.19 3.67.87 1.56 2.66-.48 4.06.28 2.33 1.25 1.52 5.56 2.15 6.44.62.87 2.35-.53 3.57.15 1.9 1.05.27 7.34.4 8.38.12 1.03 1.5.14 2.3.76 2.1 1.63-.46 6.6-.06 10.79.14 1.44.49 3.7.49 3.7l1.08 7.4z'/%3e%3cpath d='M496.9 399.13c.65 1.13 1.85 1.91 2.41 3.08.79 1.64.05 3.3-1.93 3.19-.86-.06-1.65-.72-2.47-.78-.66-.06-2.57 2.49-4.4 2.4-2.52-.1-3.72-3.17-5.25-4.74-1.22-.26-2.12 1.54-3.48 1.3-2.78-.5-2.65-4.93-3.6-6.88-.78-.57-1.94.64-3.48-.45-2.39-1.69-1.14-6.99-3.7-8.47-2.25-1.3-7.02-.44-6.6-.66l2.65-1.38c.17-.09.67.16.84.2 4.36.86 10.19.14 14.65.14 2.14 0 1.8 1.73 2.14 2.09l.18.02c2.22.16 4.87 0 6.77 1.4 2.3 1.7.12 3.22.11 3.6l.1.05.5.17 1.49.44c1.16.37 2.46.88 3.24 1.87 1.13 1.44-.14 2.12-.18 3.4z'/%3e%3cpath fill='%23466343' d='M467.2 386.2c.95.6 13.78.2 15.5.2 1.86 0 1.25 1.47 1.89 2.02.77.35 9.58.06 7.57 3.39-.23.38-.53.73-.72 1.13l.04.37c.9.74 4.02.8 5.38 2.55.81 1.05-1.33 2.73-.41 3.39 1.76 1.27 5.7 6.91-1.46 5.22-1.72-.4-3.76 4.4-7.5.1-.46-.53-1.52-2.05-1.95-2.35-1.05-.73-2.38.95-3.67.74-2.36-.38-2.5-4.52-3.35-6.26-1.17-.82-2.15.16-3.55-.83-3.17-2.24.71-9.9-9.54-8.76l1.76-.92z'/%3e%3cpath stroke-width='.45' d='M466.26 386.4s9.65 1.96 15.2 4.76c5.09 2.56 11.92 8.46 11.92 8.46s-6.66-6.27-11.77-8.93c-5.28-2.75-14.58-4.6-14.58-4.6l-.77.32z'/%3e%3cpath d='M491.11 376.21c2.5 2.32-1.28 10.05-4.12 9.56-4.53-.77-7.02-5.89-6.17-8.07.91-2.33 7.59-4 10.3-1.49z'/%3e%3cpath fill='none' d='M486.6 384.99c-1.28-.92-.79-4.17.34-6.14 1.04-1.8 2.52-2.92 3.65-2.57 3.2 1 6.33 5.23 5.13 7.8-1.18 2.54-7.85 1.82-9.12.9z'/%3e%3cpath fill='%23a48253' d='M490.9 376.44c2.3 2.13-1.35 9.15-3.86 8.72-4.32-.74-5.87-5.18-5.35-7.01.54-1.9 6.66-4.08 9.21-1.71z'/%3e%3cpath d='M505.92 381.75c-.4.54-1.27 1.55-2.17 1.55-3.85-.04-3.58-3.32-5.6-5.5-.67-.17-1.17.63-2.5.33-1.73-.4-1.84-4.81-4.43-5.72-1.32-.45-4.97-.47-7 1.43l3.63-2.82c3.51 1.38 6.68-6.1 10.7-5.1 1.14.28 1.18 1.02 2.5.9 2.93-.26 5.92-2.18 9.45-1.02 2.12.7-.63 3.53 2.04 3.21 1.72-.2 4.28-.2 4.8 1.94.28 1.17-.33 1.7-.2 2.55.35.27 6.8 2.51 3.38 4.24.54 1.52 3.14 2.53 1.77 4.4-1.3 1.74-4.03-.2-4.8.52-.3.3-.3 1.14-.57 1.48-1.14 1.42-4.13-1.45-5.41-1.72-1.27 4.3-3.57 2.28-5.59-.67z'/%3e%3cpath fill='%23658d5c' d='M491.45 372.43c2.67.75 2.74 4.86 4.28 5.24 1.54.39 1.5-.42 2.46-.2.89.2 1.78 5.39 6.08 4.85 1.1-.13 1.64-1.3 1.64-1.3s1.58 2.58 3.23 2.81c2.38.34 1.7-1.8 2.3-1.88.97-.1 2.74 1.94 4.52 1.94 1 0 .85-1.7 1.91-1.7s3.14 1 4-.24c1.13-1.61-1.49-3.5-1.68-4.08-.2-.58.74-.6.65-1.15-.37-2.05-3.7-2.38-4-3.1-.28-.73.47-1.47.2-2.6-.48-1.91-3.2-1.98-4.43-1.7-2.85.63-.27-2.41-2.3-3.27-3.49-1.47-8.57 1.32-9.86.77a7.38 7.38 0 0 0-1.95-.6c-3.15-.55-6.05 4.04-8.04 5l1 1.2z'/%3e%3cpath stroke-width='.45' d='M490.47 371s9.65-.6 15.3 1.37c4.9 1.7 11.37 6.91 11.37 6.91s-6.97-5.12-12.15-6.63c-5.57-1.61-14.86-.73-14.86-.73l.34-.93zm-8.53.67s1.85-12.28 1.7-20.17c-.1-4.75-1.01-12.12-1.01-12.12s1.27 7.64 1.47 12.58c.29 7.34-1.38 18.78-1.38 18.78l-.78.93z'/%3e%3cpath d='M472.62 371.22c.18.53 1.96 1.04 1.8 3.03-.2 2.44-3.87 1.69-5.58 2.84-.64.43.77 2.52.03 3.52-1.33 1.77-5.84.71-6.16 1.15-.6.81 1.47 3.04-.72 4.27-3.04 1.7-9.45-1-12.91 2.07-.2.19-1.55 1.7-1.6 1.71-1.98.52-7.22 1.6-6.61 1.35 3.08-1.3 8.02-2.57 9-4.69.82-1.8.2-5.2.53-7.15.5-2.91 2.64-1.74 3.35-2.66.57-.75-.5-4.8 1.8-6.72 1.62-1.34 3.36-.42 4.83-1.48 1.54-1.11-.79-4.82 2.26-5.87 1.83-.63 3.74 1.41 4.15 1.32 1.14-.24 2.48-3.68 4.79-3.21 2.3.45 1.27 3.49 1.17 4.9 3.86.47 1.78 3.34-.13 5.62z'/%3e%3cpath fill='%23658d5c' d='M441.42 390.86s8.2-3.43 8.87-5.15c1.04-2.64-.09-6.63 1.35-7.59.93-.62 1.87-.31 2.49-1.2.61-.89-.19-5.2 2.03-6.93 1.4-1.1 2.64-.12 4.34-1.3 1.82-1.3-.48-4.47 2.3-5.5 1.64-.62 3.3 1.38 4.11 1.17 1.57-.4 2.4-3.54 4.7-3.2 1.86.27.95 2.15.84 3.94-.07 1.02 1.54.55 2.01 1.99.35 1.04-1.08 3.3-2.03 4.13-.55.48 1.66 1.31 1.53 2.8-.2 2.14-4.32 2.29-5.27 2.63-1.24.44-.13 2.29-.96 3.36-1.35 1.72-4.78.65-5.4 1.47-.56.75.69 2.68-.89 3.87-1.64 1.23-8.01.45-9.05.83a77.2 77.2 0 0 0-5.57 2.31l-5.4 2.37z'/%3e%3cpath stroke-width='.45' d='M450.2 386.04s8.98-6.45 13.57-12.22c2.53-3.18 5.87-8.02 5.87-8.02s-3.23 5.01-5.72 8.33c-4.53 6.04-13.56 12.95-13.56 12.95l-.15-1.04zm67.06-57.41c3.45-1.86 9.72-5.1 14.83-9.76 3.44-3.14 7.92-8.93 7.92-8.93s-4.45 6.1-7.92 9.4c-5.22 4.97-11.84 8.5-15.3 10.37l.47-1.08z'/%3e%3cpath fill='%23466343' d='m509.94 333.26-.8 2.64c0-3.64-.14-5.37-4.44-5.14-.67.03-1.36.1-2.02 0-2.19-.34-.5-1.66-1.2-2.66-.85-1.22-6.6-.12-7.08-3-.18-1.12 1.07-2.45.15-3.33-1.38-1.32-4.82-2.47-4.46-4.9.16-1 1.5-1.72 1.3-2.65-.26-1.24-2.73-3.4-2.13-4.76.49-1.09 1.37-.73 1.45-1.76.1-1.14-1.9-4-.12-4.87 2.35-1.14 3.95 1.1 5.97 1.26 1.17.09 1.96-1.3 3.19-1.03 1.58.35 1.59 2.9 2.6 3.42.38.19 1.5-.76 2.03-.82 2.83-.33 2.19 5.17 3.16 6.46.35.46 1.1 0 1.6.16 1.77.55-.13 6.56.6 7.36.25.28 1.15.12 1.55.23 1.48.42.45 4.24.2 5.18-.55 2.1-2.45 6.25-1.55 8.21z'/%3e%3cpath stroke-width='.45' d='M509.83 332.84s-2.75-10.94-6.65-16.81c-3.23-4.87-10.3-10.87-10.3-10.87s6.77 6.05 9.84 10.87c3.76 5.9 6.33 16.81 6.33 16.81h.78zm5.97-57.14s-6.5-10.55-12.08-16.04c-4.56-4.48-12.98-9.99-12.98-9.99s8.03 5.67 12.36 10.17c5.3 5.49 11.45 15.85 11.45 15.85h1.24z'/%3e%3cpath fill='%23a48253' d='M512.96 250.46c1.09 2.7 2.64 6.9 3.67 10.8 4.84 18.34 5.28 39.53 3.21 51.77-6.38 37.7-40.66 72.78-68.1 78.26-23.3 4.65-37.07 14.75-46.85 25.54a92.49 92.49 0 0 0-11.2 15.07c-2.84 4.82-4.7 8.96-7.23 13.1l-.14.06c-.17.07-.4.12-.66.17-.55.1-1.26.18-1.92.21a6.6 6.6 0 0 1-1.65-.09l-.08-.02 1.05-1.65c2.4-3.97 4.5-7.84 7.25-12.43a94.37 94.37 0 0 1 10.4-14.4c10.18-11.5 24.64-22.62 49.35-27.6 28.78-5.77 61.63-41.45 68.07-79.47 2.09-12.39 2.04-33.76-5.82-56.93l.65-2.4z'/%3e%3cpath stroke-width='.45' d='M511.84 248.25a78.38 78.38 0 0 0-7.52-14.97c-4.46-7.16-13.52-16.88-13.52-16.88s8.57 9.76 12.8 16.85a80.72 80.72 0 0 1 9.06 20.47l-.82-5.47z'/%3e%3cpath fill='%23a48253' stroke='none' d='M513.23 254.08s-.36-.9-.55-1.5c-.4-1.24-.71-3.27-.71-3.27l.98 2.35a51 51 0 0 1 .9 2.46l-.62-.04z'/%3e%3cpath d='M514.38 317c-1.78-1.47-6.65-5.97-6.65-8.26 0-2.74 2.55-2.27 3.17-2.67-.11-1.1-3.86-3.85-2.36-6.31 1-1.63 3.24-1.17 4.08-1.84.64-1.74-1.84-6.27.15-8.72 1.17-1.46 2.08-.37 2.63-.5.11-.77.1-1.55.18-2.31.15-1.35.64-2.7 2.21-2.78 2.2-.11 3.7 2.71 4.75 4.27.23-.14 1.38-.3 1.63-.42 2.7-1.32 1.72 7.08 1.8 8.38.63-.02 1.91-.38 2.47-.05 2.9 1.72-2.86 10.72-3.48 12.84-.25.88 3.05.17.51 3.37-1.47 1.87-3.36 3.52-5 5.25l-6.1-.25z'/%3e%3cpath fill='%23658d5c' d='M515.3 323.97c1.1-2.9.7-5.73-1.48-7.32-2.35-1.7-5.48-5.73-5.47-8.07 0-2.76 2.75-1.08 2.87-2.38.1-.98-3.6-3.9-2.28-6.05.86-1.4 3.15-1.23 3.73-1.93.96-1.16-1.43-6.33.46-8.74 1.04-1.32 1.85.09 2.54-.4.67-.48-.4-4.42 2.14-4.54 2.46-.1 4.26 4 4.65 3.88.8-.26 1.74-1.09 2.63-.24.87.83.6 7.85.6 7.85s1.67-.17 2.2.16c2.22 1.37-1.77 9.33-2.89 11.52-.95 1.86 1.85 2.1.41 4.01-2.36 3.16-7.09 6.94-7.84 11.58'/%3e%3cpath stroke-width='.45' d='M518.03 321.92s1.77-11.42 2.27-17.44c.4-4.94-.7-13.08-.7-13.08s.63 7.83.23 12.77c-.5 6.02-3.14 20.36-3.14 20.36l1.34-2.6z'/%3e%3cpath d='M492.06 364.37c1-2.56-1.93-10.05.28-11.36 1.26-.75 2.06.66 3.29-.55 1.57-1.55-.9-7.4 1.98-9.25 1.67-1.08 3 .47 4.6-.99 1.07-.97 1.12-4.88 3.83-5.56 1.8-.45 2.63.78 4.22 1 1.36.18 5.95-6.22 8.81-4.7 3 1.61.34 5-.26 7.28-.31 1.2 2.23 1.03 2 3.02-.22 1.82-2.3 3.65-2.3 4.41 0 .82 2.1 1.37 2.18 2.9.17 2.96-4.6 3.37-6.21 4.63-.84.66 1.08 2.8-.1 4.75-1.26 2.09-6.62.62-7.51 1.07-.73.37-.02 3.9-.92 5.15-1.47 2.03-8.47.12-11.06.55-3.47.56-4.98 1.27-7.17 3.87l4.34-6.22z'/%3e%3cpath fill='%23658d5c' d='M487.66 368.46s2.73-1.42 3.72-3c.97-1.56 1.1-2.12 1.05-4.58-.02-1.5-1.32-6.65.14-7.47 1.21-.68 1.88.64 3.38-.78 1.84-1.73-.85-7.72 1.76-9.34 1.57-.97 3 .75 4.81-.88 1.24-1.1 1.03-4.84 3.48-5.46 1.53-.38 2.75.81 4.2 1 1.77.25 5.8-5.64 8.34-4.26 1.1.6 1.43 1.45 1.23 2.67-.22 1.3-.96 2.47-1.25 3.75-.36 1.65 1.87 1.5 1.67 3.25-.2 1.65-2.15 3.24-2.15 4.31 0 1.18 1.76 1.94 1.88 3.38.21 2.74-5.52 2.8-5.98 4.3-.46 1.5.66 2.6-.43 4.36-1.17 1.9-5.2.22-6.78.87-1.31.53-.51 3.5-1.31 4.7-2.2 3.27-12.85-1.34-17.23 4.68l-.53-1.5z'/%3e%3cpath stroke-width='.45' d='M487.98 368.84s11.32-9.64 17.53-16.78c4.78-5.5 11.25-14.91 11.25-14.91s-6.04 9.53-10.63 15.07c-5.61 6.76-15.99 15.86-15.99 15.86l-2.16.76z'/%3e%3cpath fill='%23a48253' stroke='none' d='m486.96 369.1 1.86-.55s-.68.8-.96 1.05l-.84.78-.06-1.29z'/%3e%3cpath fill='%23d99f31' stroke-width='1.09' d='M486.87 384.76c-.92-.65-.68-3.67.48-5.67 1.05-1.82 2.68-2.7 3.35-2.4 2.48 1.17 5.59 5.07 4.6 7.2-.99 2.1-7.22 1.74-8.43.87z'/%3e%3cpath fill='%23f1bf31' stroke='none' d='M491.36 377.72c-.28.12-.53.27-.74.5-1.02 1.13-.54 3.23 1.07 4.67a4.8 4.8 0 0 0 2.64 1.25h.01c.22-.15.38-.32.46-.48.35-.75-.03-2.1-.94-3.41-.68-.98-1.61-1.9-2.5-2.53z'/%3e%3cpath d='M516.64 254.59c-2.35-.82-3.96-5.17-2.98-9.03.97-3.82 10.73-2.27 9.68 2.29-.83 3.59-4.7 7.43-6.7 6.74z'/%3e%3cpath d='M523.07 246.46c-.34 2.3-3.36 2.55-4.76 2.27-1.49-.3-4.3-1.88-3.96-3.78.7-4.03 3.94-7.13 5.86-6.83 2.1.33 3.42 4.65 2.86 8.34z'/%3e%3cpath fill='%23a48253' d='M516.85 253.84c-1.99-.3-3.54-4.4-2.59-8.13.9-3.5 9.24-1.29 8.48 2-.83 3.59-3.95 6.43-5.9 6.13z'/%3e%3cpath fill='%23d99f31' stroke-width='1.09' d='M520.13 238.73c1.63.26 3.36 3.93 2.8 7.66-.28 1.8-3.1 1.7-4.53 1.42-1.55-.32-4.15-1.35-3.9-2.78.68-3.98 4.14-6.54 5.63-6.3z'/%3e%3cpath fill='%23f1bf31' stroke='none' d='M519.86 239.27c-.07 0-.16.02-.25.04.1.66.51 1.62.7 2.72.25 1.46.22 3.85 1.24 3.67.63-.1.9-.6.9-1.57v-.02a9.46 9.46 0 0 0-.6-2.64c-.53-1.32-1.35-2.13-1.8-2.2h-.2z'/%3e%3cpath fill='none' d='M382.27 446.7c-.77-1.13.99-4.61 4.68-4.2 1.62.2.83 2.53-1.17 3.94-1.41.98-2.74 1.4-3.51.26z'/%3e%3cpath fill='%23a48253' d='M382.27 446.7c-.77-1.13.35-3.57 4.06-3.73 1.33-.05 1.45 2.06-.55 3.47-1.41.98-2.74 1.4-3.51.26z'/%3e%3cpath fill='none' d='M394.92 431s-.1-1.38-1.7-1.93a2.06 2.06 0 0 0-2.23.61m2.38 3.18s-.05-1.4-1.7-1.78a1.8 1.8 0 0 0-2.08.93'/%3e%3c/g%3e%3cpath fill='%23fff' d='M401.7 427.16c7.7-.09 13.48-.82 20.05-2.12-1.55 5.28-4.65 15.3 7.75 15.3 9.02 0 18.6-5.42 27.9-.65 20.3 10.42 35.64 2.98 48.04-10.96 0 0-9.17 1.95-18.6 1.54 0 0 7.06-6.02 7.75-13.94-6.2 4.64-12.4 5.32-18.6 5.32-6.2 0-10.16-3.74-18.28-5.02.46-2.8.95-5.66 1.68-9.6.8-4.3-.39-7.8-6.65-8.53-13.61-1.6-26.8 6.26-50.89 6.64-24.25-.38-40.88-8.24-54.5-6.64-6.25.74-7.44 4.23-6.64 8.53.73 3.94 1.22 6.8 1.67 9.6-8.1 1.28-12.07 5.02-18.27 5.02-6.2 0-12.4-.68-18.6-5.32.68 7.92 7.75 13.94 7.75 13.94-9.43.41-18.6-1.54-18.6-1.54 12.4 13.94 27.73 21.38 48.05 10.96 9.3-4.77 18.87.66 27.9.66 12.39 0 9.29-10.03 7.74-15.3a120.66 120.66 0 0 0 23.35 2.15v-.04z'/%3e%3cpath d='M337.7 427.3c-.9.42-1.36-.16-.34-.68.72-.37 3.83-1.72 6.08-2.17.08-.01.17.05.18.14l.08.6c.01.07-.05.16-.13.17a30.84 30.84 0 0 0-5.86 1.94zm.52 2.95c-.9.41-1.36-.16-.34-.68.71-.37 3.98-1.98 6.23-2.42.06-.01.15.04.18.1l.22.6c.04.1-.01.18-.11.2-2.12.38-5.42 1.85-6.18 2.2zm32.32 5.39c-3.87-.4-8.43-1.57-13.27-2.25-6.14-.85-11.47-.53-17.86 2.36-.35.16-.53.18-.67.18-.12 0-.3-.03-.34-.2-.03-.14.07-.27.15-.35.1-.1.25-.2.42-.28 5.95-3.04 12.16-3.59 18.4-2.74 4.84.66 9.45 1.67 13.3 2.07 2.17.23 4.65-.14 5.46-1.44.22-.35.83.4.63.71-1.23 1.98-4.12 2.16-6.22 1.94zm-33.6-11.04c-.17.06-.33.1-.44.1-.1 0-.26-.03-.3-.17-.05-.14.04-.25.1-.32.08-.08.2-.16.35-.23 2.34-1.08 2.94-1.27 6.37-2.18.29-.07.5.1.55.32a.44.44 0 0 1-.35.53 40.73 40.73 0 0 0-6.29 1.95zm-.54-3c-.15.06-.3.1-.4.09-.11 0-.24-.05-.3-.18-.04-.12.02-.24.08-.32a.9.9 0 0 1 .32-.23 23.6 23.6 0 0 1 6.6-2c.27-.05.5.1.57.3.08.22-.03.47-.32.52-3.21.61-4.35.94-6.55 1.82zm34.15 9c-2.64-.27-5.64-.86-8.82-1.38a.5.5 0 0 1-.42-.58.5.5 0 0 1 .58-.41c3.16.51 6.14 1.1 8.76 1.37a6.26 6.26 0 0 0 2.93-.38c.31-.12.56.06.65.29.1.22.03.53-.28.65a7.2 7.2 0 0 1-3.4.44zm-13.88 5.25a29.54 29.54 0 0 0-16.78 2.58c-.22.1-.42.14-.57.16-.12 0-.3 0-.38-.14a.25.25 0 0 1-.01-.22.51.51 0 0 1 .12-.17c.1-.1.26-.21.47-.33 7.41-3.59 13.07-3.35 17.47-2.85 4.73.54 8.87 1.56 13.39 1.9.4.03.5.39.6.7.1.27.27.79-1.15.64-4.47-.48-8.56-1.55-13.16-2.27zm13.83-2.98c-5-.52-11.64-2.22-18-2.5-.33-.02-.54-.24-.54-.5 0-.25.21-.46.55-.45 6.38.29 13.1 1.8 18.12 2.33 1.85.19 3.88-.18 4.85-1.05.3-.26 1.05.73.77.97-1.3 1.16-3.74 1.41-5.75 1.2zm-31.73.11c-.9.42-1.36-.16-.35-.68.82-.42 5.34-2.56 7.76-2.72.33-.02.57.18.64.42.08.26-.07.53-.42.55-2.17.15-6.76 2.03-7.63 2.43zm123.63-5.68c.9.42 1.36-.16.34-.68a30.38 30.38 0 0 0-6.08-2.17.16.16 0 0 0-.18.14l-.08.6c-.01.07.05.16.12.17 2.12.38 5.12 1.59 5.87 1.94zm-.53 2.95c.9.41 1.37-.16.35-.68-.72-.37-3.99-1.98-6.23-2.42-.07-.01-.16.04-.18.1l-.23.6c-.03.1.02.18.12.2 2.12.38 5.42 1.85 6.17 2.2zm-32.31 5.39c3.86-.4 8.43-1.57 13.27-2.25 6.13-.85 11.47-.53 17.85 2.36.35.16.54.18.68.18.12 0 .3-.03.33-.2.03-.14-.06-.27-.14-.35-.1-.1-.25-.2-.43-.28-5.94-3.04-12.16-3.59-18.4-2.74-4.83.66-9.44 1.67-13.3 2.07-2.16.23-4.64-.14-5.46-1.44-.21-.35-.83.4-.62.71 1.23 1.98 4.11 2.16 6.22 1.94zm33.6-11.04c.17.06.32.1.44.1.1 0 .25-.03.3-.17.05-.14-.04-.25-.1-.32-.08-.08-.2-.16-.35-.23-2.34-1.08-2.95-1.27-6.37-2.18-.3-.07-.5.1-.55.32-.05.21.06.46.35.53 2.67.64 3.98 1.05 6.29 1.95zm.53-3c.16.06.3.1.41.09.11 0 .24-.05.3-.18.04-.12-.02-.24-.09-.32a.89.89 0 0 0-.31-.23 23.6 23.6 0 0 0-6.6-2 .5.5 0 0 0-.57.3c-.09.22.02.47.32.52 3.21.61 4.35.94 6.54 1.82zm-34.14 9c2.64-.27 5.64-.86 8.82-1.38.33-.05.46-.34.42-.58a.5.5 0 0 0-.58-.41c-3.16.51-6.14 1.1-8.76 1.37a6.25 6.25 0 0 1-2.93-.38.49.49 0 0 0-.65.29.49.49 0 0 0 .28.65 7.2 7.2 0 0 0 3.4.44zm13.88 5.25c5.26-.82 11.75.07 16.78 2.58.22.1.42.14.57.16.12 0 .3 0 .38-.14a.26.26 0 0 0 0-.22.53.53 0 0 0-.1-.17c-.1-.1-.27-.21-.48-.33-7.41-3.59-13.07-3.35-17.48-2.85-4.72.54-8.86 1.56-13.38 1.9-.4.03-.5.39-.6.7-.1.27-.27.79 1.14.64 4.48-.48 8.57-1.55 13.17-2.27zm-13.84-2.98c5-.52 11.64-2.22 18-2.5.34-.02.54-.24.55-.5 0-.25-.22-.46-.55-.45-6.39.29-13.1 1.8-18.12 2.33-1.86.19-3.88-.18-4.86-1.05-.29-.26-1.04.73-.76.97 1.29 1.16 3.74 1.41 5.74 1.2zm31.74.11c.9.42 1.36-.16.35-.68-.83-.42-5.35-2.56-7.76-2.72a.61.61 0 0 0-.64.42c-.08.26.06.53.42.55 2.17.15 6.76 2.03 7.63 2.43z'/%3e%3cg stroke='%23000' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath stroke-width='.93' d='M400.04 427.33c-10.34 0-17.1-1.58-26.35-3.25-21.51-3.9-26.19-.94-26.19 2.78 0 1.2 1.1 1.55 1.9 1.2.41-.2.75-.88.75-.88-.76 0-1.26-.3-1.1-1.25.46-2.71 6.05-3.95 24.64-.92 9.27 1.5 16.01 2.78 26.36 2.78l-.01-.46zm.02 0c10.34 0 17.1-1.58 26.34-3.25 21.52-3.9 26.2-.94 26.2 2.78 0 1.2-1.1 1.55-1.9 1.2-.41-.2-.75-.88-.75-.88.76 0 1.26-.3 1.1-1.25-.46-2.71-6.05-3.95-24.65-.92-9.27 1.5-16 2.78-26.35 2.78v-.46z'/%3e%3cpath d='M342.37 416.79c-3.4.55-6.53 1.71-9.73 2.97-8.7 3.41-18.7 2.9-26.43-2.61a20.17 20.17 0 0 0 4.76 10.3c.61.73 2.49 2.59 2.49 2.59.31.32.26.53-.19.54-5.93.26-11.3.18-17.14-.9 13.76 15.13 27.59 18.9 46.43 9.74 9.9-4.81 18.15.62 28.04.62 10.5 0 9.5-6.87 7.2-14.63l1.25.14c1.7 4.77 4.34 16.52-8.45 15.57-9.86-.73-17.75-5.75-27.68-1.01-15.3 7.3-26.35 7.19-39.66-2.69-2.7-2-7.08-5.63-8.95-8.39-.45-.67 0-1.07.69-.86 5.05 1.57 12.7 1.57 16.6 1.47-3.16-3.17-6.7-9.05-6.55-13.27.02-.55.28-.65.74-.42 7.2 3.74 9.91 5.24 18.32 5.24 4.95 0 15.06-5.6 18.08-5.01l.18.61z'/%3e%3cpath stroke-width='.93' d='M457.72 416.79c3.41.55 6.54 1.71 9.73 2.97 8.71 3.41 18.7 2.9 26.44-2.61a20.17 20.17 0 0 1-4.76 10.3c-.61.73-2.5 2.59-2.5 2.59-.3.32-.25.53.2.54 5.92.26 11.3.18 17.13-.9-13.76 15.13-27.58 18.9-46.43 9.74-9.9-4.81-18.15.62-28.03.62-10.5 0-9.5-6.87-7.2-14.63l-1.25.14c-1.7 4.77-4.34 16.52 8.45 15.57 9.85-.73 17.75-5.75 27.68-1.01 15.3 7.3 26.35 7.19 39.65-2.69 2.72-2 7.09-5.63 8.95-8.39.46-.67 0-1.07-.68-.86-5.05 1.57-12.7 1.57-16.6 1.47 3.16-3.17 6.7-9.05 6.55-13.27-.02-.55-.28-.65-.74-.42-7.21 3.74-9.92 5.24-18.32 5.24-4.96 0-15.07-5.6-18.08-5.01l-.19.61z'/%3e%3cpath d='M399.47 405.15c-11.82.09-21.8-2.07-30.12-3.94-6.9-1.56-14.94-3.34-22.01-2.4-5.15.69-7.26 2.96-6.38 8.16 1.1 6.46 2.06 12.97 3.24 19.4.67 3.72 2.65 4.22 6.14 3.6 5.03-.89 21.15-4.5 24.77.09 3.48 4.39.09 7.55-4.75 7.63-.68.01-.46-.46-.23-.46 4.63 0 7.89-2.67 4.9-6.78-3.15-4.33-18.23-1.16-24.38.28-3.9.91-6.5.4-7.22-4.39-.99-6.6-1.6-11.15-3.7-19.7-3.53-14.44 22.25-7.75 29.67-6.02 10.13 2.35 18.58 3.86 30.59 4.22 12.03-.36 20.48-1.87 30.6-4.22 7.43-1.73 33.21-8.42 29.67 6.03-2.1 8.54-2.7 13.08-3.7 19.7-.71 4.79-3.31 5.29-7.22 4.38-6.14-1.44-21.22-4.6-24.37-.28-3 4.1.27 6.78 4.9 6.78.22 0 .44.47-.24.46-4.83-.08-8.22-3.24-4.74-7.63 3.62-4.58 19.74-.98 24.76-.09 3.5.62 5.47.12 6.15-3.6 1.17-6.43 2.14-12.94 3.23-19.4.88-5.2-1.22-7.47-6.38-8.16-7.07-.94-15.1.84-22 2.4-8.33 1.87-18.3 4.03-30.13 3.94h-1.05z'/%3e%3c/g%3e%3cpath d='M361.53 417.23c-1.62-.14-4.22-.29-4.22-.29l-.95-12.88 3.13.37.65 10.06c.32.01 1.73.1 2.66.21 1.07.12 2.79.39 2.79.39l.2 2.58s-2.63-.3-4.26-.44zm6.76.72-.7-12.43 3.15.49.7 12.42zm9.52-5.77 1.07.18c1.6.27 1.72-.28 1.71-.95-.02-.8-.4-1.3-2-1.58l-.83-.14.05 2.49zm.11 4.94 1.5.25c1.73.3 2.16-.02 2.14-.9-.02-1-.62-1.6-2.5-1.92l-1.19-.2.05 2.77zm1.84 2.76-5-.85-.23-12.27 4.5.76c3.08.53 4.75 1.88 4.8 4.21 0 .98-.54 1.63-1.14 1.98.86.48 2.1 1.59 2.13 3.21.04 2.28-1.34 3.6-5.06 2.96zm11.77 1.69a127 127 0 0 1-4.34-.53l-.12-6.19-.12-6.2 7.12.74.02 1.22.03 1.24-3.99-.42.05 2.55 4.2.43.04 2.31-4.19-.43.05 2.62c.32.05 1.75.27 2.71.35 1.08.1 2.86.14 2.86.14l.05 2.46s-2.7-.14-4.37-.3zm10.39-6.34c1.66-.03 2.39-.74 2.37-1.87-.02-1.19-.54-1.69-2.04-1.66l-1.4.02.06 3.52 1-.01zm6.96 6.42c-2.46-.09-3.78-1.32-5.07-2.77l-1.38-1.54c-.19.02-.4.02-.61.03l-.81.01.07 4.33-3.08.05-.21-12.38 4.78-.09c2.74-.04 4.77 1.19 4.82 3.94a3.7 3.7 0 0 1-1.85 3.31l1.19 1.25a5.1 5.1 0 0 0 2.72 1.47l-.57 2.39zm.12-9.97-.02-2.45 10.95-1.5.01 2.44-3.9.54.06 9.89-3.15.43-.06-9.88zm17.62-2.48c-.37 1.34-.77 2.68-1.18 4.02.86-.09 1.76-.24 2.59-.49-.37-1.2-.74-2.39-1.08-3.6l-.33.06zm3.35 9-1.21-3.33c-.65.23-1.34.37-2.04.48l-2.1.28-1.32 3.82-3.19.6 3.85-10.63-1.35.25-.02-2.45c2.85-.46 5.6-.98 8.36-1.57l.11 2.43-1.36.26 3.55 9.24-3.28.61zm8.33-.8c-2.02.04-3.1-.31-4.01-.8l.86-2.3c1.15.38 1.81.54 3.16.52 1.47-.03 2.2-.5 2.2-1.16.01-.45-.33-.76-.91-1.05-.59-.28-1.36-.52-2.14-.82-1.56-.6-3.17-1.5-3.13-3.64.04-2.43 2.75-3.66 4.92-3.7a8.84 8.84 0 0 1 4 .77l-.79 2.22c-.96-.26-1.92-.48-3.16-.46-1.22.02-1.93.65-1.94 1.1 0 .36.34.64.94.92.59.28 1.38.54 2.17.87 1.59.66 3.22 1.63 3.18 3.64-.05 2.75-2.82 3.85-5.35 3.89z'/%3e%3c/svg%3e";
            },
            9924: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3e%3cpath fill='%2300853f' d='M0 0h300v600H0z'/%3e%3cpath fill='%23fdef42' d='M300 0h300v600H300z'/%3e%3cpath fill='%23e31b23' d='M600 0h300v600H600z'/%3e%3cg fill='%2300853f' transform='translate(450 300)'%3e%3cg id='b'%3e%3cpath id='a' d='M0-100V0h50z' transform='rotate(18 0 -100)'/%3e%3cuse xlink:href='%23a' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(72)'/%3e%3cuse xlink:href='%23b' transform='rotate(144)'/%3e%3cuse xlink:href='%23b' transform='rotate(216)'/%3e%3cuse xlink:href='%23b' transform='rotate(288)'/%3e%3c/g%3e%3c/svg%3e";
            },
            1950: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 81 54'%3e%3cpath fill='%234189DD' d='M0 0h81v54H0z'/%3e%3cg transform='matrix(13 0 0 13 40.5 27)'%3e%3cg id='b'%3e%3cpath id='a' fill='%23FFF' d='M0 0v1h.5z' transform='rotate(18 3.157 -.5)'/%3e%3cuse xlink:href='%23a' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(72)'/%3e%3cuse xlink:href='%23b' transform='rotate(-72)'/%3e%3cuse xlink:href='%23b' transform='rotate(144)'/%3e%3cuse xlink:href='%23b' transform='rotate(-144)'/%3e%3c/g%3e%3c/svg%3e";
            },
            3071: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3cpath fill='%23377e3f' d='M0 0h900v600H0z'/%3e%3cpath fill='%23fff' d='M0 120h900v360H0z'/%3e%3cpath fill='%23b40a2d' d='M0 180h900v240H0z'/%3e%3cpath fill='%23ecc81d' d='m450 191.459 70.534 217.082-184.661-134.164h228.254L379.466 408.541z'/%3e%3c/svg%3e";
            },
            1336: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 10'%3e%3cpath fill='%23078930' d='M0 0h20v10H0z'/%3e%3cpath fill='%23FFF' d='M0 0h20v7H0z'/%3e%3cpath d='M0 0h20v3H0z'/%3e%3cpath fill='%23DA121A' d='M0 3.5h20v3H0z'/%3e%3cpath fill='%230F47AF' d='m0 0 8.66 5L0 10z'/%3e%3cpath fill='%23FCDD09' d='m1.287 5 2.894.94-1.789-2.462v3.044l1.79-2.462z'/%3e%3c/svg%3e";
            },
            2538: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 2800 1400'%3e%3cpath fill='%2312ad2b' d='M0 0h2800v1400H0z'/%3e%3cpath fill='%23ffce00' d='M0 400h2800v600H0z'/%3e%3cpath fill='%23d21034' d='M0 0v1400l700-700'/%3e%3cg id='c' fill='%23000' transform='translate(1400 700)'%3e%3cg id='b'%3e%3cpath id='a' d='M0-200V0h100' transform='rotate(18 0 -200)'/%3e%3cuse xlink:href='%23a' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(72)'/%3e%3cuse xlink:href='%23b' transform='rotate(144)'/%3e%3cuse xlink:href='%23b' transform='rotate(216)'/%3e%3cuse xlink:href='%23b' transform='rotate(288)'/%3e%3c/g%3e%3cuse xlink:href='%23c' x='700'/%3e%3c/svg%3e";
            },
            3908: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' data-name='Layer 1' viewBox='0 0 1005 567'%3e%3cpath fill='%23fff' fill-rule='evenodd' d='M0 0h1005v567H0z'/%3e%3cpath fill='%230047ab' fill-rule='evenodd' d='M0 378h1005v189H0zM0 0h1005v189H0z'/%3e%3cpath fill='%23fc0' d='m463.041 354.917-.035.035.8 5.406a2.833 2.833 0 0 0-3.418 1.5c-1 2.032-.148 3.565 1.813 4.57l2.617 1.29 4.812-9.417-1.917-1.012-1.884 3.837h-.069l-.419-5.058-2.3-1.15zm.453 7.22a2.492 2.492 0 0 1 1.29.28l.28.139-1.36 2.581-.279-.14c-.873-.5-1.444-1.027-.942-2.092a1.356 1.356 0 0 1 1.011-.768zm-8.872-2.3 1.286-1.875-2.9-1.943 1-1.434 2.811 1.875 1.592-2.376-2.965-1.943 1-1.5 4.773 3.18-5.928 8.852-4.71-3.18 1-1.44 2.964 1.874m-1.91-12.444v.035l-2.617 2.965-.766-.628c-1.723-1.524-3.41-1.449-4.849.21-1.592 1.874-1.007 3.48.8 4.987l2.163 1.883 6.871-8.056zM447 350.974a1.782 1.782 0 0 1 1.464.594l.314.279-1.883 2.163-.35-.176c-.763-.652-1.168-1.328-.383-2.266a1.6 1.6 0 0 1 .838-.594zm-7.4-.921-1.438-1.59 4.425-3.99c.937-.871 2.245-2.244 1-3.556-1.222-1.373-2.682-.195-3.684.637l-4.34 3.99-1.438-1.6 4.71-4.27c1.874-1.724 4.12-2.159 6.082 0 2.026 2.16 1.286 4.336-.633 6.083l-4.622 4.27m-4.146-20.019a2.467 2.467 0 0 0-.454.035 3.267 3.267 0 0 0-1.29.523 2.437 2.437 0 0 0-1.047 3.035 2.36 2.36 0 0 0-2.267.454c-1.722 1.155-1.643 2.606-.488 4.325l1.5 2.163 8.685-6-1.884-2.72a3.585 3.585 0 0 0-2.755-1.815zm.14 2.268c.642-.053 1.109.445 1.534 1.081l.28.35v.068l-2.269 1.5-.174-.28c-.48-.808-1.071-1.76-.069-2.475a1.468 1.468 0 0 1 .7-.244zm-3.105 3.069a1.389 1.389 0 0 1 1.046.732l.105.21-2.023 1.43-.174-.175c-.436-.652-.571-1.314.28-1.883a1.282 1.282 0 0 1 .766-.313zm-.148-9.818-1.438-2.684 1.5-.848 2.535 4.558-9.352 5.056-1.068-1.87 7.826-4.208m-1.591-7.545.785 2.026-9.7 4.275-.85-2.026 9.79-4.275m-10.988-7.322a3.4 3.4 0 0 0-.349 2.68 3.512 3.512 0 0 0 4.556 1.874 3.264 3.264 0 0 0 .5-6.15l2.31-.714a5.348 5.348 0 0 1 1.438 2.154 5.6 5.6 0 0 1-10.659 3.427 5.814 5.814 0 0 1-.2-2.534l2.377-.721m5.087-14.222-9.94 6 .314 1.674 11.44 2.3-.419-2.232-2.3-.523h-.07l-.7-3.767 2.093-1.221zm-3.14 4.395.42 2.511-3.977-.487zm-2.964-24.206a5.038 5.038 0 0 0-4.639 4.848L414 284.53l10.463.871.28-3.034a5.124 5.124 0 0 0-4.813-5.72 6.129 6.129 0 0 0-1.117 0zm.176 2.372a4.816 4.816 0 0 1 .731 0c1.9.152 3.091 1.18 2.895 3.557v.35l-6.348-.524.07-.349c.133-1.907 1.026-2.9 2.65-3.034zm-1.513-8.272 2.245.414.72-3.335 1.721.348-.633 3.336 2.814.632.719-3.466 1.743.283-1.155 5.647-10.345-2.159 1.068-5.58 1.81.348-.72 3.467m4.077-13.933 2.18.854 1.221-3.188 1.656.638-1.22 3.18 2.681 1 1.286-3.247 1.656.63-2.091 5.274-9.941-3.834 2.18-5.273 1.657.563-1.286 3.337m10.115-5.385 1.371-2.681 1.656.787-2.376 4.62-9.482-4.837 1-1.875 7.827 3.99m2.964-16.614a1.854 1.854 0 0 0-1.656.787 1.38 1.38 0 0 0 .065 1.808c1.439 1 3.466-2.964 6.365-.781a3.455 3.455 0 0 1 .72 5.055 4.022 4.022 0 0 1-3.685 1.5l-.195-1.936a2.144 2.144 0 0 0 2.376-.637 1.388 1.388 0 0 0-.349-2.026c-.85-.63-1.722 0-2.53.5-1.22.787-2.462 1.223-3.77.2a3.074 3.074 0 0 1-.633-4.425 4.542 4.542 0 0 1 2.747-1.719l.566 1.651m4.713-9.361-1.15 1.22 4.847 10.676 1.57-1.64-1.012-2.162.035-.07 2.685-2.721 2.163.907 1.57-1.64zm1.64 3.068h.07v.036l3.313 1.5-1.64 1.744zm11.262-2.468 2.377-1.876 1.068 1.352-4.056 3.27-6.67-8.26 1.723-1.374 5.494 6.888m6.735-6.825.065-.062-1.809-7.327 2.027-1.217L461.336 222l-1.067.63-9.418-6.953 1.962-1.223 6.082 4.622m7.773-12.54-1.5.732.559 11.65 2.022-.942-.069-2.372h.035L471.2 214l1.64 1.64 2.162-.838zm.419 3.487 2.581 2.652-2.162.94zm10.882-7.115a6.53 6.53 0 0 0-1.15.243l-2.9.769 2.964 10.219 2.93-.837a5.193 5.193 0 0 0 3.663-6.592 5.053 5.053 0 0 0-5.512-3.8zm.523 2.162a2.708 2.708 0 0 1 2.582 2.338c.588 1.83.01 3.38-2.3 4.01l-.28.105-1.814-6.14.35-.138a4.763 4.763 0 0 1 1.464-.175zm12.767-5.3c-.2 0-.39.01-.594.035A5.6 5.6 0 0 0 492.2 210.9a5.6 5.6 0 0 0-.942-11.127zm-.244 2.372a3.164 3.164 0 0 1 3.348 2.755c.13 1.434-.886 3.378-2.477 3.663-1.666.215-3.169-1.428-3.383-2.86a3.13 3.13 0 0 1 2.511-3.558zm9.138-2.86-.14 10.673h2.163v-4.291h.07l2.616 4.29 2.581.069v-.034l-3.035-4.569a2.771 2.771 0 0 0 2.268-2.9c.065-2.249-1.448-3.182-3.628-3.244zm2.092 1.883h.28c1.025 0 1.814.243 1.814 1.465 0 1.155-.78 1.43-1.85 1.43h-.209l-.035.035zm20.415 2.391-.567 2.25 3.333.781-.413 1.808-3.334-.847-.633 2.745 3.4.937-.419 1.724-5.49-1.44 2.528-10.29 5.58 1.373-.435 1.814-3.466-.855m7.98 0 1.435.57 2.617 9.069h.068l2.678-6.586 1.964.787L535.5 217.4l-1.44-.569-2.679-9.07-2.661 6.737-2.026-.781 4.058-10.14m14.186 16.893 2.533 1.595-.937 1.5-4.426-2.68 5.642-9.068 1.814 1.156-4.627 7.456m12.873-2-10.22 5.825 1.71 1.36 2.093-1.15.034.034 2.965 2.442-.732 2.232 1.813 1.43 3.627-11.092zm-1.64 3.14-1.22 3.453-1.779-1.43zm17.616 13.5-11.372 2.965 1.291 1.814 2.372-.593h.035l2.232 3.138-1.29 2.024 1.29 1.813 6.384-9.8zm-2.372 2.616-2.093 3.035-1.36-1.884zm7.555 14.642-7.172.715-.284-.63 4.839-5.146v-.061l-6.3 2.092-1-1.941 10.57-3.25.72 1.374-4.99 5.58 7.39-.786.72 1.373-9.07 6.368-.937-1.943 5.492-3.683m5.19 6.976-2.183.787 1.072 3.18-1.725.569-1.065-3.186-2.684.855 1.133 3.4-1.72.565-1.808-5.428 10.007-3.4 1.87 5.424-1.72.57-1.155-3.4m4 6.844-10.36 2.163.42 2.162 4.115-.942h.07l-3.628 3.558.488 2.511.07.035 3.768-3.907a2.759 2.759 0 0 0 3.313 1.5c2.243-.435 2.84-2.1 2.337-4.255zm-1.36 2.582v.173c.224 1.025.21 1.9-1.012 2.093-1.178.218-1.619-.432-1.813-1.5v-.21zm-7.084 11.15-.194-2.092 10.507-1.221.28 2.092-10.57 1.222m8.236 10.311a3.1 3.1 0 0 0 1.072-2.464 3.626 3.626 0 1 0-6.083 2.53l-2.461.065a6.616 6.616 0 0 1-.637-2.529 5.436 5.436 0 0 1 5.43-5.494 5.5 5.5 0 0 1 5.71 5.363 4.828 4.828 0 0 1-.564 2.463l-2.467.066m-7.838 1.976-.208 2.233 2.057 1.15-.487 3.837-2.3.489-.278 2.337 11.3-2.826.21-1.639zm3.559 4.36 3.348 1.5v.1l-3.628.766zm-3.193 26.1a3.129 3.129 0 0 0 1.936-1.808 3.443 3.443 0 0 0-2.16-4.426 3.527 3.527 0 0 0-4.553 1.658 3.828 3.828 0 0 0 .195 2.746l-2.31-.848a6.433 6.433 0 0 1 .285-2.6 5.371 5.371 0 0 1 7.1-2.963 5.485 5.485 0 0 1 3.338 7.1 6.1 6.1 0 0 1-1.5 2.094l-2.317-.939m-1.764 5.71-2.026-1.067-1.656 2.964-1.507-.782 1.573-3.03-2.528-1.373-1.724 3.182-1.507-.849 2.684-5.061 9.353 5.061-2.684 4.99-1.59-.849 1.657-3.12m-2.07 7.763-.855 1.223-9.414.278-.067.068 5.8 4.208-1.283 1.724-8.7-6.368.854-1.222 9.414-.346h.069l-5.867-4.275 1.284-1.724 8.768 6.457m-18.947 6.016 1.506-1.59 6.363 6.143 1.507-1.657 1.283 1.223-4.554 4.776-1.288-1.212 1.5-1.591-6.368-6.083m-3.1 3.131-1.675 1.29 2.76 3.353v.07l-4.85-1.605-1.953 1.64.035.07 5.2 1.43a2.762 2.762 0 0 0 .209 3.7c1.373 1.719 3.19 1.408 4.847.035l2.163-1.848-6.731-8.128zm2.058 5.929 1.883 2.268-.21.1c-.808.7-1.52 1.007-2.3.07-.72-.87-.36-1.582.488-2.3zm-8.615-.42-1.954 1.187.42 2.372h-.036l-3.244 2.023-1.884-1.43-1.953 1.22 9.383 7.011 1.36-.837-2.092-11.544zm-1.257 5.582.943 3.487h-.07l-2.895-2.267zm-10.45 3.173-2.813 1.222-.721-1.59 4.71-2.249 4.56 9.637-1.964.848-3.773-7.89m50.076-101.154 2.125 2.785h1.687l-1.466-2.785zm-154.113 88.7 3.477-.429 1.18 1.2-3.016.9z'/%3e%3cpath fill='%23090' d='M484.357 359.842s3.772-.285 4.425-.285c.567 0 1.876-2.6 2.443-3.03.566-.413 10.572-5.274 17.047-6.3 6.366-1 16.4-4.839 18.488-5.86 10.726-5.145 22.691-14.716 25.376-18.64 2.745-4.118 5.708-13.628 7.014-18.79.57-2.378 3.84-12.035 3.84-18.64a83.241 83.241 0 0 0-2.093-18.922c-1.155-4.993-9.7-19.64-14.933-26.12 0 0 11.752 18.205 13.778 25.247a77.632 77.632 0 0 1 2.46 20.884c-.128 4.12-3.487 19.142-8.476 30.17-3.968 8.85-7.456 9.855-13.629 14.782a90.148 90.148 0 0 1-13.187 8.417 91.74 91.74 0 0 1-17.33 5.642c-2.681.5-16.023 4.425-17.767 5.28a44.751 44.751 0 0 0-7.456 6.144'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M484.357 359.842s3.772-.285 4.425-.285c.567 0 1.876-2.6 2.443-3.03.566-.413 10.572-5.274 17.047-6.3 6.366-1 16.4-4.839 18.488-5.86 10.726-5.145 22.691-14.716 25.376-18.64 2.745-4.118 5.708-13.628 7.014-18.79.57-2.378 3.84-12.035 3.84-18.64a83.241 83.241 0 0 0-2.093-18.922c-1.155-4.993-9.7-19.64-14.933-26.12 0 0 11.752 18.205 13.778 25.247a77.632 77.632 0 0 1 2.46 20.884c-.128 4.12-3.487 19.142-8.476 30.17-3.968 8.85-7.456 9.855-13.629 14.782a90.148 90.148 0 0 1-13.187 8.417 91.74 91.74 0 0 1-17.33 5.642c-2.681.5-16.023 4.425-17.767 5.28a44.751 44.751 0 0 0-7.456 6.144z'/%3e%3cpath fill='%23090' d='M551.326 325.81c-.284-1.373-.413-2.371-.937-2.746-.347-.5-1.875-2.243-2.16-3.4a8.417 8.417 0 0 1 0-2.684 25.18 25.18 0 0 0-.413-2.59 10.612 10.612 0 0 1 1.29-2.969 11.891 11.891 0 0 0 2.31-3.03 3.831 3.831 0 0 0 .279 1.725 5.6 5.6 0 0 1 .636 2.962 17.848 17.848 0 0 0 0 3.9 6.871 6.871 0 0 1 .435 3.4c-.195 1.065-1.44 5.425-1.44 5.425'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M551.326 325.81c-.284-1.373-.413-2.371-.937-2.746-.347-.5-1.875-2.243-2.16-3.4a8.417 8.417 0 0 1 0-2.684 25.18 25.18 0 0 0-.413-2.59 10.612 10.612 0 0 1 1.29-2.969 11.891 11.891 0 0 0 2.31-3.03 3.831 3.831 0 0 0 .279 1.725 5.6 5.6 0 0 1 .636 2.962 17.848 17.848 0 0 0 0 3.9 6.871 6.871 0 0 1 .435 3.4c-.195 1.065-1.44 5.425-1.44 5.425'/%3e%3cpath fill='%23090' d='M551.7 324.377s3.4-4.276 3.4-6.084a6.569 6.569 0 0 1 .563-3.186 4.529 4.529 0 0 0 .5-5.426 7.141 7.141 0 0 1-1.374-2.31c-.563-1.59-1.718-1.59-1.874-3.184a34.009 34.009 0 0 0-.564 3.468 8.627 8.627 0 0 0 .28 3.026c.133.937-.413 1.941-.413 3.254 0 1.283.133 1.808.133 2.589 0 .419.564 6.016-.636 7.83'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M551.7 324.377s3.4-4.276 3.4-6.084a6.569 6.569 0 0 1 .563-3.186 4.529 4.529 0 0 0 .5-5.426 7.141 7.141 0 0 1-1.374-2.31c-.563-1.59-1.718-1.59-1.874-3.184a34.009 34.009 0 0 0-.564 3.468 8.627 8.627 0 0 0 .28 3.026c.133.937-.413 1.941-.413 3.254 0 1.283.133 1.808.133 2.589 0 .419.564 6.016-.636 7.83z'/%3e%3cpath fill='%23090' d='M514.092 347.285s2.812-.284 3.9-.5a20.218 20.218 0 0 0 3.466-.847 11.148 11.148 0 0 0 3.9-2.685c2.679-2.9 2.371-4.426 2.9-4.554 1-.128-1.5-.413-2.679-.2a7.48 7.48 0 0 0-3.838 1.942 39.092 39.092 0 0 1-3.335 2.59 6.824 6.824 0 0 0-1.657 1.44 7.667 7.667 0 0 1-2.681 2.812'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M514.092 347.285s2.812-.284 3.9-.5a20.218 20.218 0 0 0 3.466-.847 11.148 11.148 0 0 0 3.9-2.685c2.679-2.9 2.371-4.426 2.9-4.554 1-.128-1.5-.413-2.679-.2a7.48 7.48 0 0 0-3.838 1.942 39.092 39.092 0 0 1-3.335 2.59 6.824 6.824 0 0 0-1.657 1.44 7.667 7.667 0 0 1-2.681 2.812z'/%3e%3cpath fill='%23090' d='M510.255 349.333s7.107-3.18 7.76-3.772a17 17 0 0 0 2.685-2.461c.784-.786 3.768-2.31 4.27-3.336.351-.632 2.16-3.182 3.248-5.207.57-1.072-4.705.284-4.705.284-4.34 1.719-2.312.5-4.71 2.31a8.641 8.641 0 0 0-2.747 2.813c-.567 1.217-1.22 3.465-1.874 4.553a18.542 18.542 0 0 1-3.9 4.773'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M510.255 349.333s7.107-3.18 7.76-3.772a17 17 0 0 0 2.685-2.461c.784-.786 3.768-2.31 4.27-3.336.351-.632 2.16-3.182 3.248-5.207.57-1.072-4.705.284-4.705.284-4.34 1.719-2.312.5-4.71 2.31a8.641 8.641 0 0 0-2.747 2.813c-.567 1.217-1.22 3.465-1.874 4.553a18.542 18.542 0 0 1-3.9 4.773z'/%3e%3cpath fill='%23090' d='M506.419 350.21s5.776-1.508 8.48-5.146c1.875-2.467 1.94-1.724 2.747-2.528a27.944 27.944 0 0 0 3.77-4.342c-.13.195 1.593-5.8 1.593-6.452-.067-.413-2.246.285-4.056 1-1.5.652-2.376 1.875-3.683 2.679-1.592 1-1.723 3.555-2.464 4.71a6.307 6.307 0 0 0-1.155 3.466c0 1.284-.72 1.724-1.156 2.812-.5 1.284-2.028 1.066-4.055 3.773'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M506.419 350.21s5.776-1.508 8.48-5.146c1.875-2.467 1.94-1.724 2.747-2.528a27.944 27.944 0 0 0 3.77-4.342c-.13.195 1.593-5.8 1.593-6.452-.067-.413-2.246.285-4.056 1-1.5.652-2.376 1.875-3.683 2.679-1.592 1-1.723 3.555-2.464 4.71a6.307 6.307 0 0 0-1.155 3.466c0 1.284-.72 1.724-1.156 2.812-.5 1.284-2.028 1.066-4.055 3.773z'/%3e%3cpath fill='%23090' d='M515.77 348.312s4.993-2.25 5.712-2.4c.719-.128 1-.57 2.03-.848a5.765 5.765 0 0 1 3.682-.419c.849.2 4.488 1 5.426.57.853-.413-1.306 2.46-2.395 3.12a8.063 8.063 0 0 1-4.208.713c-1.506-.127-3.554 0-4.273 0a6.866 6.866 0 0 1-2.245-.127 6.392 6.392 0 0 0-3.772-.57'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M515.77 348.312s4.993-2.25 5.712-2.4c.719-.128 1-.57 2.03-.848a5.765 5.765 0 0 1 3.682-.419c.849.2 4.488 1 5.426.57.853-.413-1.306 2.46-2.395 3.12a8.063 8.063 0 0 1-4.208.713c-1.506-.127-3.554 0-4.273 0a6.866 6.866 0 0 1-2.245-.127 6.392 6.392 0 0 0-3.772-.57z'/%3e%3cpath fill='%23090' d='M512.37 348.312s5.58-1.44 6.518-1.44a34.052 34.052 0 0 1 4.624.413c1.066.133 4.4-.2 5.424.284a18.493 18.493 0 0 0 6.586.782c1.155-.195-2.311 3.186-3.773 3.555-4.492 1.29-3.114 1.072-6.016.351-1.808-.419-4.338-.569-5.21-.72-.872-.133-.72-.63-1.875-1.155a17.727 17.727 0 0 0-6.3-2.093'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M512.37 348.312s5.58-1.44 6.518-1.44a34.052 34.052 0 0 1 4.624.413c1.066.133 4.4-.2 5.424.284a18.493 18.493 0 0 0 6.586.782c1.155-.195-2.311 3.186-3.773 3.555-4.492 1.29-3.114 1.072-6.016.351-1.808-.419-4.338-.569-5.21-.72-.872-.133-.72-.63-1.875-1.155a17.727 17.727 0 0 0-6.3-2.093z'/%3e%3cpath fill='%23090' d='M507.792 350.645s5.581-2.31 9.919-1.155a26.341 26.341 0 0 0 4.12.937c1.352.194 2.529-.5 4.84.435 1.155.413 6.016 2.372 7.327 2.31 1.217-.066-3.84 3.249-5.212 3.03-4.493-.636-8.764.849-10.791.063-1.876-.715-2.966-1.218-3.9-1.5-.937-.352-1.439-1.223-2-1.591-.567-.5-.938-1.591-4.273-2.528'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M507.792 350.645s5.581-2.31 9.919-1.155a26.341 26.341 0 0 0 4.12.937c1.352.194 2.529-.5 4.84.435 1.155.413 6.016 2.372 7.327 2.31 1.217-.066-3.84 3.249-5.212 3.03-4.493-.636-8.764.849-10.791.063-1.876-.715-2.966-1.218-3.9-1.5-.937-.352-1.439-1.223-2-1.591-.567-.5-.938-1.591-4.273-2.528z'/%3e%3cpath fill='%23090' d='M537.614 337.781s3.249-3.556 3.834-3.99c.637-.5 2.16-1.59 2.97-2.31a5.99 5.99 0 0 1 3.331-2.378c.937-.195 3.12-.631 3.69-1.373.63-.782-.069 2.813-.788 3.773a7.52 7.52 0 0 1-3.466 2.528c-1.372.5-3.185 1.507-3.839 1.808a5.4 5.4 0 0 1-2.026.787 7.268 7.268 0 0 0-3.683 1.155'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M537.614 337.781s3.249-3.556 3.834-3.99c.637-.5 2.16-1.59 2.97-2.31a5.99 5.99 0 0 1 3.331-2.378c.937-.195 3.12-.631 3.69-1.373.63-.782-.069 2.813-.788 3.773a7.52 7.52 0 0 1-3.466 2.528c-1.372.5-3.185 1.507-3.839 1.808a5.4 5.4 0 0 1-2.026.787 7.268 7.268 0 0 0-3.683 1.155z'/%3e%3cpath fill='%23090' d='M534.584 339.242s5.492-3.838 6.3-4.207c.848-.413 2.4-.937 3.4-1.289 1.072-.28 3.84-2.243 4.928-2.243 1.072 0 3.181-.129 4.12-.787.853-.782.065 2.595-.939 3.621-3.549 3.115-1.066 2.154-4.051 2.747-1.725.345-4.12 1.372-4.928 1.59-.938.285-1-.285-2.243-.195a19.973 19.973 0 0 0-6.586.787'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M534.584 339.242s5.492-3.838 6.3-4.207c.848-.413 2.4-.937 3.4-1.289 1.072-.28 3.84-2.243 4.928-2.243 1.072 0 3.181-.129 4.12-.787.853-.782.065 2.595-.939 3.621-3.549 3.115-1.066 2.154-4.051 2.747-1.725.345-4.12 1.372-4.928 1.59-.938.285-1-.285-2.243-.195a19.973 19.973 0 0 0-6.586.787z'/%3e%3cpath fill='%23090' d='M533.256 340.265a18.849 18.849 0 0 1 6.669-2.155 27.17 27.17 0 0 0 4.057-1 12.306 12.306 0 0 1 4.119-.5c1.222-.128 6.083 1.44 7.238.787 1-.57-1.223 1.434-2.528 1.937-1.942.72-1.724 1.942-3.84 2.684-2.22.72-4.553 1.59-5.926 1.284-.938-.129-1.814-.63-3.187-.781-1.373-.135-3.834-2.16-6.58-2.25'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M533.256 340.265a18.849 18.849 0 0 1 6.669-2.155 27.17 27.17 0 0 0 4.057-1 12.306 12.306 0 0 1 4.119-.5c1.222-.128 6.083 1.44 7.238.787 1-.57-1.223 1.434-2.528 1.937-1.942.72-1.724 1.942-3.84 2.684-2.22.72-4.553 1.59-5.926 1.284-.938-.129-1.814-.63-3.187-.781-1.373-.135-3.834-2.16-6.58-2.25z'/%3e%3cpath fill='%23090' d='M532.82 339.176s-1.071-5.363-.133-6.585a6.2 6.2 0 0 0 1.155-2.813 11.074 11.074 0 0 1 1.59-4.208c.57-.714 1.814-4.119 1.44-4.989 0 0 3.12 3.03 2.964 4.989a6.32 6.32 0 0 0 0 2.317 11.919 11.919 0 0 1-1.284 4.7c-.63.853-.284 3.553-.938 4.056-.569.63-4.056 2.964-4.776 2.528'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M532.82 339.176s-1.071-5.363-.133-6.585a6.2 6.2 0 0 0 1.155-2.813 11.074 11.074 0 0 1 1.59-4.208c.57-.714 1.814-4.119 1.44-4.989 0 0 3.12 3.03 2.964 4.989a6.32 6.32 0 0 0 0 2.317 11.919 11.919 0 0 1-1.284 4.7c-.63.853-.284 3.553-.938 4.056-.569.63-4.056 2.964-4.776 2.528z'/%3e%3cpath fill='%23090' d='M533.256 340.265a15.3 15.3 0 0 1 2.9-2.094c1.071-.412 5.144-1.59 5.43-2.594.284-1.066 3.682-4.555 3.833-5.492a15.376 15.376 0 0 0 .57-2.746 18.318 18.318 0 0 0-.848-3.465c-.42-1.072-1.507-3.556-2.534-3.99 0 0-.848 2.745-1.156 3.772a9.421 9.421 0 0 1-1 2.813 19.859 19.859 0 0 0-2.094 4.426 41.535 41.535 0 0 1-1 5.078c-.068.72-2.813 3.772-4.052 4.336'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M533.256 340.265a15.3 15.3 0 0 1 2.9-2.094c1.071-.412 5.144-1.59 5.43-2.594.284-1.066 3.682-4.555 3.833-5.492a15.376 15.376 0 0 0 .57-2.746 18.318 18.318 0 0 0-.848-3.465c-.42-1.072-1.507-3.556-2.534-3.99 0 0-.848 2.745-1.156 3.772a9.421 9.421 0 0 1-1 2.813 19.859 19.859 0 0 0-2.094 4.426 41.535 41.535 0 0 1-1 5.078c-.068.72-2.813 3.772-4.052 4.336z'/%3e%3cpath fill='%23090' d='M551.326 325.81c-.194.787 2.16-.714 3.338-.714 1.217 0 4.705.413 5.58-.42.848-.847 2.155-2.526 2.6-2.812a13.1 13.1 0 0 0 2.528-4.335c.435-1.5 3.549-4.12 3.9-4.426 0 0-4.208-.848-6.892.847a8.529 8.529 0 0 1-3.331 1.6c-.57.278-5.146 4.118-5.43 5.58-.285 1.434-2.244 3.984-2.311 4.705'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M551.326 325.81c-.194.787 2.16-.714 3.338-.714 1.217 0 4.705.413 5.58-.42.848-.847 2.155-2.526 2.6-2.812a13.1 13.1 0 0 0 2.528-4.335c.435-1.5 3.549-4.12 3.9-4.426 0 0-4.208-.848-6.892.847a8.529 8.529 0 0 1-3.331 1.6c-.57.278-5.146 4.118-5.43 5.58-.285 1.434-2.244 3.984-2.311 4.705z'/%3e%3cpath fill='%23090' d='M551.326 325.81s3.773-2.678 4.622-2.528c.937.134 5.056-2.9 5.273-4.772.134-1 2.093-2.466 2.534-3.119 1-1.74 1.59-5.709 3.03-6.736 0 0-3.99 1-4.994 1.155-1.875.284-3.466.57-4.276 2.25-.63 1.59-1.283 2.9-1.875 3.029-.563.129-1.434 2.155-1.718 4.27-.285 2.026-2.6 6.452-2.6 6.452'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M551.326 325.81s3.773-2.678 4.622-2.528c.937.134 5.056-2.9 5.273-4.772.134-1 2.093-2.466 2.534-3.119 1-1.72 1.59-5.709 3.03-6.736 0 0-3.99 1-4.994 1.155-1.875.284-3.466.57-4.276 2.25-.63 1.59-1.283 2.9-1.875 3.029-.563.129-1.434 2.155-1.74 4.27-.285 2.026-2.6 6.452-2.6 6.452z'/%3e%3cpath fill='%23090' d='M558.52 305.8c-.63 1.006-.57-5.86-.938-6.514a10.334 10.334 0 0 0-1.59-2.812c-.57-.567-.57-2.594-.848-3.184a15.492 15.492 0 0 1 .279-5.58 14.381 14.381 0 0 1 1.814 1.591c.563.72 1.59 1 1.875 1.875.278.85.87.85 1.283 1.81a5.593 5.593 0 0 1 .57 3.466 8.585 8.585 0 0 0-.135 2.681 22.989 22.989 0 0 1-2.31 6.667'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M558.52 305.8c-.63 1.006-.57-5.86-.938-6.514a10.334 10.334 0 0 0-1.59-2.812c-.57-.567-.57-2.594-.848-3.184a15.492 15.492 0 0 1 .279-5.58 14.381 14.381 0 0 1 1.814 1.591c.563.72 1.59 1 1.875 1.875.278.85.87.85 1.283 1.81a5.593 5.593 0 0 1 .57 3.466 8.585 8.585 0 0 0-.135 2.681 22.989 22.989 0 0 1-2.31 6.667'/%3e%3cpath fill='%23090' d='M558.369 306.456s.285-1.941-.418-2.683c-.714-.719-1.434-.719-1.719-1.155-.284-.414-.195-1-.5-1.591a10.725 10.725 0 0 1-1-2.092c-.28-1.592-1.155-3.337-.413-5.058a8.785 8.785 0 0 1 2.026.85 4.711 4.711 0 0 1 1.942 2.593 4.1 4.1 0 0 0 .72 2.246c.413.72 1 2.9.284 4.207a8.235 8.235 0 0 0-.853 2.683'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M558.369 306.456s.285-1.941-.418-2.683c-.714-.719-1.434-.719-1.719-1.155-.284-.414-.195-1-.5-1.591a10.725 10.725 0 0 1-1-2.092c-.28-1.592-1.155-3.337-.413-5.058a8.785 8.785 0 0 1 2.026.85 4.711 4.711 0 0 1 1.942 2.593 4.1 4.1 0 0 0 .72 2.246c.413.72 1 2.9.284 4.207a8.235 8.235 0 0 0-.853 2.683z'/%3e%3cpath fill='%23090' d='M562.577 283.958s.28-4.274-.786-5.581c-1.223-1.286-1.507-3.771-4.209-5.145a5.115 5.115 0 0 1 0 1.81c-.067.632-.345 2.746 0 3.465.5.72 1.943 2.028 1.943 2.682a3.83 3.83 0 0 0 1.718 2.31 10.3 10.3 0 0 0 1.29.415'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M562.577 283.958s.28-4.274-.786-5.581c-1.223-1.286-1.507-3.771-4.209-5.145a5.115 5.115 0 0 1 0 1.81c-.067.632-.345 2.746 0 3.465.5.72 1.943 2.028 1.943 2.682a3.83 3.83 0 0 0 1.718 2.31 10.3 10.3 0 0 0 1.29.415z'/%3e%3cpath fill='%23090' d='M562.577 286.268s0-3.03-.786-3.9a17.826 17.826 0 0 1-1.791-1.876c-.435-.567-.877-2.094-1.875-2.682a9.29 9.29 0 0 1-2.968-2.594s-.413 3.619.569 5.58c1 1.875 1 2.9 2.243 3.336a5.484 5.484 0 0 1 1.747 1 3.121 3.121 0 0 0 1.724.718 2.4 2.4 0 0 1 1.155.415'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M562.577 286.268s0-3.03-.786-3.9a17.826 17.826 0 0 1-1.791-1.876c-.435-.567-.877-2.094-1.875-2.682a9.29 9.29 0 0 1-2.968-2.594s-.413 3.619.569 5.58c1 1.875 1 2.9 2.243 3.336a5.484 5.484 0 0 1 1.747 1 3.121 3.121 0 0 0 1.724.718 2.4 2.4 0 0 1 1.155.415z'/%3e%3cpath fill='%23090' d='M559.24 306.3c-.128.854-.72-1.875 2.31-1.875a9.774 9.774 0 0 0 6.585-2.243 22.447 22.447 0 0 0 2.093-2.245 8.408 8.408 0 0 0 1.72-3.03c.133-.851 1-4.12.853-4.71a6.7 6.7 0 0 0-2.31.85c-.72.634-2.093.634-2.813 1.07-.72.413-1.312 1.59-1.725 2.027-.413.414-1.718.414-2.31 1.285a15 15 0 0 0-1.808 3.685c-.067.85-1.155 1.722-1.875 2.158-.72.414-.57 2.157-.72 2.967'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M559.24 306.3c-.128.854-.72-1.875 2.31-1.875a9.774 9.774 0 0 0 6.585-2.243 22.447 22.447 0 0 0 2.093-2.245 8.408 8.408 0 0 0 1.72-3.03c.133-.851 1-4.12.853-4.71a6.7 6.7 0 0 0-2.31.85c-.72.634-2.093.634-2.813 1.07-.72.413-1.312 1.59-1.747 2.027-.413.414-1.718.414-2.31 1.285a15.222 15.222 0 0 0-1.809 3.685c-.066.85-1.154 1.722-1.874 2.158-.72.414-.57 2.157-.72 2.967z'/%3e%3cpath fill='%23090' d='M559.525 305.145s2.026-2.527 3.03-2.527c1.066 0 3.683-2.681 3.834-3.771a8.074 8.074 0 0 1 1.59-3.837 3.422 3.422 0 0 0 1.508-3.248c-.2-1.723-.2-4.622-.2-4.622s-.57 1.723-1.44 2.158c-.847.414-2.46 1-2.746 1.592-.285.567-1.44.567-1.964 2.376-.346 1.722-.346 1.592-.72 2.159a8.972 8.972 0 0 0-1.284 2.462c-.284 1.22-1.875 4.273-1.59 7.235'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M559.525 305.145s2.026-2.527 3.03-2.527c1.066 0 3.683-2.681 3.834-3.771a8.074 8.074 0 0 1 1.59-3.837 3.422 3.422 0 0 0 1.508-3.248c-.2-1.723-.2-4.622-.2-4.622s-.57 1.723-1.44 2.158c-.847.414-2.46 1-2.746 1.592-.285.567-1.44.567-1.964 2.376-.346 1.722-.346 1.592-.72 2.159a8.972 8.972 0 0 0-1.284 2.462c-.284 1.22-1.875 4.273-1.59 7.235z'/%3e%3cpath fill='%23090' d='M562.577 288.884c.061.785-1.155-1.5 1.59-2.377a9.414 9.414 0 0 0 5.425-3.836c.636-1.155.938-2.026 1.222-2.528a7.928 7.928 0 0 0 .72-3.249c-.067-.85-.194-4.054-.5-4.556a6.576 6.576 0 0 0-1.875 1.439c-.5.785-1.658 1.155-2.243 1.722a11.051 11.051 0 0 0-1 2.376c-.279.5-1.44.85-1.719 1.81a11.986 11.986 0 0 0-.569 3.836 4.068 4.068 0 0 1-1.155 2.53c-.5.566.133 2.092.133 2.812'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M562.577 288.884c.061.785-1.155-1.5 1.59-2.377a9.414 9.414 0 0 0 5.425-3.836c.636-1.155.938-2.026 1.222-2.528a7.928 7.928 0 0 0 .72-3.249c-.067-.85-.194-4.054-.5-4.556a6.576 6.576 0 0 0-1.875 1.439c-.5.785-1.658 1.155-2.243 1.722a11.051 11.051 0 0 0-1 2.376c-.279.5-1.44.85-1.719 1.81a11.986 11.986 0 0 0-.569 3.836 4.068 4.068 0 0 1-1.155 2.53c-.5.566.133 2.092.133 2.812z'/%3e%3cpath fill='%23090' d='M562.577 287.729s1.155-2.813 2.093-3.118c.938-.282 2.461-2.68 2.528-3.77.062-1.222.285-3.4.72-3.9a4.952 4.952 0 0 0 .563-3.9c-.63-1.591-1.59-3.685-1.59-3.685a18.852 18.852 0 0 0-1.283 2.159c-.788 1.5-1.507 1.592-1.657 2.158-.069.633-1.072 1-1.374 2.224-.419 1.656.061 1.59-.066 2.245a9.334 9.334 0 0 0-.5 2.593c.067 1.157-.564 4.34.569 6.956'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M562.577 287.729s1.155-2.813 2.093-3.118c.938-.282 2.461-2.68 2.528-3.77.062-1.222.285-3.4.72-3.9a4.952 4.952 0 0 0 .563-3.9c-.63-1.591-1.59-3.685-1.59-3.685a18.852 18.852 0 0 0-1.283 2.159c-.788 1.5-1.507 1.592-1.657 2.158-.069.633-1.072 1-1.374 2.224-.419 1.656.061 1.59-.066 2.245a9.334 9.334 0 0 0-.5 2.593c.067 1.157-.564 4.34.569 6.956z'/%3e%3cpath fill='%23090' d='M560.267 270.028c-.134-.415-1.005-.851-2.032-1.221-1-.284-2.656-2.6-3.332-3.183-.72-.633-1.071-1.5-1.941-2.028-.849-.5-1.507-2.31-1.724-4.119 0 0 2.466.565 3.185.721a7.627 7.627 0 0 1 2.814 1.718c.563.72 1.155 1.942 1.718 2.225s1.29 2.028 1.29 3.248v2.595'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M560.267 270.028c-.134-.415-1.005-.851-2.032-1.221-1-.284-2.656-2.6-3.332-3.183-.72-.633-1.071-1.5-1.941-2.028-.849-.5-1.507-2.31-1.748-4.119 0 0 2.468.565 3.188.721a7.628 7.628 0 0 1 2.812 1.718c.564.72 1.156 1.942 1.719 2.225s1.29 2.028 1.29 3.248v2.595z'/%3e%3cpath fill='%23090' d='M560.4 268.719s.128-1.722.128-2.528c0-.85.57-3.248-.714-5.145-.854-1.283-4.124-3.772-4.994-3.9a12.025 12.025 0 0 0-.413 3.03c.127.72.937 3.683 1.59 3.988.72.283 2.377 3.772 4.425 4.556'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M560.4 268.719s.128-1.722.128-2.528c0-.85.57-3.248-.714-5.145-.854-1.283-4.124-3.772-4.994-3.9a12.025 12.025 0 0 0-.413 3.03c.127.72.937 3.683 1.59 3.988.72.283 2.377 3.772 4.425 4.556z'/%3e%3cpath fill='%23090' d='M561.137 270.028c.346.632.129-2.225 1-2.9a3.434 3.434 0 0 0 1-2.965 22.923 22.923 0 0 0-.345-2.81c-.195-.72-2.377-3.773-2.25-4.621 0 0-1.216 2.807-1.59 3.616-.413 1 .284 2.093.134 2.963-.134.852-.854 2.465-.284 3.337.434.785 1.718 2.377 2.31 3.4'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M561.137 270.028c.346.632.129-2.225 1-2.9a3.434 3.434 0 0 0 1-2.965 22.923 22.923 0 0 0-.345-2.81c-.195-.72-2.377-3.773-2.25-4.621 0 0-1.216 2.807-1.59 3.616-.413 1 .284 2.093.134 2.963-.134.852-.854 2.465-.284 3.337.434.785 1.718 2.377 2.31 3.4z'/%3e%3cpath fill='%23090' d='M553.352 254.857s-.128-.442-1.44-.442c-1.283 0-3.248-.061-3.833-.714a11.452 11.452 0 0 0-2.16-1.595 4.378 4.378 0 0 1-1.72-2.244c-.2-.564-1.221-1.72-1.657-1.72a11.032 11.032 0 0 1 3.4.348c1.723.345 4.208 1.283 4.776 2.46.63 1.156 2.68 3.907 2.68 3.907'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M553.352 254.857s-.128-.442-1.44-.442c-1.283 0-3.248-.061-3.833-.714a11.452 11.452 0 0 0-2.16-1.595 4.532 4.532 0 0 1-1.741-2.244c-.2-.564-1.223-1.72-1.658-1.72a11.023 11.023 0 0 1 3.4.348c1.724.345 4.208 1.283 4.777 2.46.63 1.156 2.679 3.907 2.679 3.907z'/%3e%3cpath fill='%23090' d='M552.917 254.572c-.346 1-2.813-1-3.4-1.724-.568-.72-1.438-1.875-1.438-1.875a14.624 14.624 0 0 1-1.725-2.372c-.848-1.6-.631-4.493-.28-4.275a21.134 21.134 0 0 0 2.462 1.374 2.41 2.41 0 0 1 1.59 1.132 7.364 7.364 0 0 0 1.072 2.243 4.418 4.418 0 0 1 1.742 5.5'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M552.917 254.572c-.346 1-2.813-1-3.4-1.724-.568-.72-1.438-1.875-1.438-1.875a14.624 14.624 0 0 1-1.725-2.372c-.848-1.6-.631-4.493-.28-4.275a21.134 21.134 0 0 0 2.462 1.374 2.41 2.41 0 0 1 1.59 1.132 7.364 7.364 0 0 0 1.072 2.243 4.418 4.418 0 0 1 1.742 5.5z'/%3e%3cpath fill='%23090' d='M553.787 254.572a24.071 24.071 0 0 1-2.745-2.16c-.938-.847-.413-2.026-.938-2.595-.346-.564-1.44-1.936-1.155-2.812.285-.849.854-3.332.854-3.332s1.066.937 1.808 1.719a4.639 4.639 0 0 1 1.155 2.182 19.31 19.31 0 0 0 1.156 2.243 7.509 7.509 0 0 1-.135 3.03 6.7 6.7 0 0 0 0 1.724'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M553.787 254.572a24.071 24.071 0 0 1-2.745-2.16c-.938-.847-.413-2.026-.938-2.595-.346-.564-1.44-1.936-1.155-2.812.285-.849.854-3.332.854-3.332s1.066.937 1.808 1.719a4.639 4.639 0 0 1 1.155 2.182 19.31 19.31 0 0 0 1.156 2.243 7.509 7.509 0 0 1-.135 3.03 6.7 6.7 0 0 0 0 1.724'/%3e%3cpath fill='%23e60000' d='M530.878 337.278a.851.851 0 1 1 .85-.848.808.808 0 0 1-.85.848'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M530.878 337.278a.851.851 0 1 1 .85-.848.808.808 0 0 1-.85.848'/%3e%3cpath fill='%23e60000' d='M535.867 343.45a.814.814 0 0 1-.847-.853.864.864 0 0 1 .847-.848.916.916 0 0 1 .877.847.859.859 0 0 1-.877.855'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M535.867 343.45a.814.814 0 0 1-.847-.853.864.864 0 0 1 .847-.848.916.916 0 0 1 .877.847.859.859 0 0 1-.877.855'/%3e%3cpath fill='%23e60000' d='M547.492 324.091a.93.93 0 0 1-.937-.853.875.875 0 0 1 .937-.849.866.866 0 0 1 .849.848.913.913 0 0 1-.848.854'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M547.492 324.091a.93.93 0 0 1-.937-.853.875.875 0 0 1 .937-.849.866.866 0 0 1 .849.848.913.913 0 0 1-.848.854'/%3e%3cpath fill='%23e60000' d='M554.664 327.708a.973.973 0 0 1-1-1 .959.959 0 0 1 1-.936.946.946 0 0 1 .938.937.961.961 0 0 1-.937 1'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M554.664 327.708a.973.973 0 0 1-1-1 .959.959 0 0 1 1-.936.946.946 0 0 1 .938.937.961.961 0 0 1-.937 1'/%3e%3cpath fill='%23e60000' d='M555.97 305.932a1 1 0 0 1-1-.938 1.079 1.079 0 0 1 1-1 1.018 1.018 0 0 1 .938 1 .943.943 0 0 1-.938.937'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M555.97 305.932a1 1 0 0 1-1-.938 1.079 1.079 0 0 1 1-1 1.018 1.018 0 0 1 .938 1 .943.943 0 0 1-.938.937'/%3e%3cpath fill='%23e60000' d='M561.986 307.762a.924.924 0 0 1-.938-1 .908.908 0 0 1 .938-.938.947.947 0 0 1 .937.938.958.958 0 0 1-.937 1'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M561.986 307.762a.924.924 0 0 1-.938-1 .908.908 0 0 1 .938-.938.947.947 0 0 1 .937.938.958.958 0 0 1-.937 1'/%3e%3cpath fill='%23e60000' d='M558.934 288.382a1.026 1.026 0 0 1-1-1 .958.958 0 0 1 1-.937.944.944 0 0 1 .938.937 1 1 0 0 1-.938 1'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M558.934 288.382a1.026 1.026 0 0 1-1-1 .958.958 0 0 1 1-.937.944.944 0 0 1 .938.937 1 1 0 0 1-.938 1'/%3e%3cpath fill='%23e60000' d='M564.319 270.529a.886.886 0 0 1-.938-.85.96.96 0 0 1 .938-1 .973.973 0 0 1 1 1 .907.907 0 0 1-1 .85'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M564.319 270.529a.886.886 0 0 1-.938-.85.96.96 0 0 1 .938-1 .973.973 0 0 1 1 1 .907.907 0 0 1-1 .85'/%3e%3cpath fill='%23e60000' d='M557.431 272.337a.959.959 0 0 1-.937-1 .944.944 0 0 1 .937-.938.959.959 0 0 1 1 .938.972.972 0 0 1-1 1'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M557.431 272.337a.959.959 0 0 1-.937-1 .944.944 0 0 1 .937-.938.959.959 0 0 1 1 .938.972.972 0 0 1-1 1'/%3e%3cpath fill='%23e60000' d='M550.673 257.468a.94.94 0 1 1 0-1.875.938.938 0 0 1 0 1.875'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M550.673 257.468a.94.94 0 1 1 0-1.875.938.938 0 0 1 0 1.875'/%3e%3cpath fill='%23e60000' d='M555.82 253.417a.922.922 0 0 1-.939-1 .9.9 0 0 1 .938-.939.972.972 0 0 1 0 1.943'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M555.82 253.417a.922.922 0 0 1-.939-1 .9.9 0 0 1 .938-.939.972.972 0 0 1 0 1.943'/%3e%3cpath fill='%23e60000' d='M545.528 243.41a.971.971 0 0 1 0-1.941.971.971 0 1 1 0 1.941'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M545.528 243.41a.971.971 0 0 1 0-1.941.971.971 0 1 1 0 1.941'/%3e%3cpath fill='%23e60000' d='M566.5 288.449a.886.886 0 0 1-.937-.85.938.938 0 1 1 1.875 0 .872.872 0 0 1-.937.85'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M566.5 288.449a.886.886 0 0 1-.937-.85.938.938 0 1 1 1.875 0 .872.872 0 0 1-.937.85'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M530.008 340.918a18.057 18.057 0 0 0 .564-3.768s-.285 0-.721-.57m1.312 5.56a22.186 22.186 0 0 1 3.684.35 2.3 2.3 0 0 0 .284.782m13.076-15.128s.134-3.685-.564-3.986a2.96 2.96 0 0 1-1.155-.876m4.554 3.705a7.915 7.915 0 0 1 2.595 0 1.06 1.06 0 0 0 .569.721m.736-22.279.721.352c.786.346 2.249 3.834 2.249 3.834a12.793 12.793 0 0 1 3.331-1.875h1M567 288.1a1.116 1.116 0 0 1-1.156.282s-2.968 1.877-3.03 2.6c0 0-3.12-3.03-3.689-2.748 0 0-.28.415-.847-.13m5.514-18.072a2.925 2.925 0 0 1-.938.72 7.561 7.561 0 0 0-1.284 3.335s-2.461-2.158-3.181-2.027a2.279 2.279 0 0 1-1.44 0m-.4-18.945s-.564.72-1 .133c0 0-1.746 2.155-.72 3.835 0 0-2.466-.564-3.18-.129a.749.749 0 0 1-1.223.413m-4.111-14.767s.435 1-1.29.636'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M521.373 347.068s9.634-.068 10.571-1.284m-16.173 2.528s6.3 1.72 9.633 1.284a17.691 17.691 0 0 1 5.714.284 28.328 28.328 0 0 0 4.426-1.507m-26.225 2.272s4.838.847 5.863 1.155c1 .279 6.017 2.153 7.455 2.153 1.154 0 4.056-.06 4.842 0a17.292 17.292 0 0 0 6.145-.412m-5.95-14.515a30.9 30.9 0 0 0-4.274 2.9c-.564.786-3.836 3.4-4.425 3.4m8.7-10.882s-6.3 5.43-7.392 6.15c-1 .78-7.172 6.736-7.89 7.695m10.135-16.156s-4.991 3.99-5.58 5.582a15.563 15.563 0 0 1-2.027 3.465s-2.093 4.124-2.812 4.71a30.77 30.77 0 0 1-3.9 3.248m42.836-20.71s-5.3 4.425-6.736 5.273m8.918-2.438a63.615 63.615 0 0 1-7.607 4.553 41.549 41.549 0 0 1-9.42 2.31m-2.07 2.054s5.864-.284 6.887 0c1 .28 5.58-.72 6.735-1s5.865-1.155 6.457-1.289m-11.078-17.5a15.718 15.718 0 0 1-.2 4.554c-.413 1.289-2.462 5.056-2.31 6.016.128.853-1.156 4.838-2.311 5.58m-1.29-15.586s1.072 3.186.57 4.274a15.629 15.629 0 0 0-1.156 4.119 12.126 12.126 0 0 1-1 3.622c-.28.72.133 3.248-.565 3.9a21.8 21.8 0 0 0-1.59 2.094m35.18-25.465s-4.62 1.725-5.272 2.9c-.57 1.156-1.374 1.5-1.875 2.093m-10.136-9.42s-1.155 4.71-.853 5.865a24.717 24.717 0 0 1 .284 4.426c0 .854 1.29 4.425 1.072 4.994m1.395-19.208s.413 2.745.564 3.906a25.931 25.931 0 0 0 .285 3.834c.284.72.72 4.62 0 6.451M566 309.069s-3.84 3.247-4.71 4.123c-.848.848-4.771 5.056-4.99 6.144-.067 1-2.9 4.209-3.771 5m19.922-31.676s-3.772 3.771-4.119 4.621a8.029 8.029 0 0 1-2.594 2.813m-11.207-5.82s1.44 2.157 1.44 2.9a7.191 7.191 0 0 0 1.223 3.4c.346.5 1.59 2.594 1.44 3.9m-2.947-16.37s.569 2.027.854 3.467a25.253 25.253 0 0 0 1.373 3.836c.278.85 1.434 5.145 1 7.761m10.119-15.216a6.283 6.283 0 0 1-1.44 3.03c-1.005 1-2.6 2.529-2.746 3.335-.135.937-1.44 5.275-2.964 6.8a5.387 5.387 0 0 0-1.6 2.964m10.267-31.085s-.5 2.462-.72 3.181c-.278.72-1.522 3.99-2.678 4.993m-9.219-7.52a22.285 22.285 0 0 1 .848 2.964 10.751 10.751 0 0 0 1.155 2.31c.129.414.72 1.94.72 1.94m-5.408-5.187a22.3 22.3 0 0 0 1.943 3.989 6.847 6.847 0 0 0 1.875 3.117c.87.567 3.465 2.463 3.332 3.249m4.32-16s.128 3.183-.414 4.338c-.569 1.22-1.289 2.966-1.6 3.836a22.966 22.966 0 0 0-.412 3.337 9.2 9.2 0 0 1-1.155 3.683m-11.53-25.2s2.092 2.377 3.03 3.4c1 .936 4.705 4.991 4.84 5.71m-4.382-11.29s2.093 4.486 2.528 5.206c.413.787.848 1.942.848 1.942m1.92-7.305s-.129 3.555 0 4.425a9.806 9.806 0 0 1 0 2.75 31.383 31.383 0 0 0 .569 4.425m-17.552-20.73s4.622 2.812 5.364 3.55m-2.662-7.194 3.247 4.627.721 1.372m-.28-6.435a22.9 22.9 0 0 1 1.218 3.466 30.368 30.368 0 0 0 2.16 5.43'/%3e%3cpath fill='%23e60000' d='M472.454 337.278a.851.851 0 0 0 0-1.7.866.866 0 0 0-.85.853.85.85 0 0 0 .85.848'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M472.454 337.278a.851.851 0 0 0 0-1.7.866.866 0 0 0-.85.853.85.85 0 0 0 .85.848'/%3e%3cpath fill='%23e60000' d='M467.463 343.45a.888.888 0 0 0 .937-.853.931.931 0 0 0-.937-.848.912.912 0 0 0-.85.847.853.853 0 0 0 .85.855'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M467.463 343.45a.888.888 0 0 0 .937-.853.931.931 0 0 0-.937-.848.912.912 0 0 0-.85.847.853.853 0 0 0 .85.855'/%3e%3cpath fill='%23e60000' d='M455.908 324.091a.9.9 0 0 0 .85-.853.852.852 0 0 0-.85-.849.887.887 0 0 0-.937.848.931.931 0 0 0 .937.854'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M455.908 324.091a.9.9 0 0 0 .85-.853.852.852 0 0 0-.85-.849.887.887 0 0 0-.937.848.931.931 0 0 0 .937.854'/%3e%3cpath fill='%23e60000' d='M448.737 327.708a.969.969 0 1 0-1-1 .985.985 0 0 0 1 1'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M448.737 327.708a.969.969 0 1 0-1-1 .985.985 0 0 0 1 1'/%3e%3cpath fill='%23e60000' d='M447.428 305.932a.944.944 0 0 0 .937-.938 1 1 0 0 0-.937-1 1.029 1.029 0 0 0-1 1 .961.961 0 0 0 1 .937'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M447.428 305.932a.944.944 0 0 0 .937-.938 1 1 0 0 0-.937-1 1.029 1.029 0 0 0-1 1 .961.961 0 0 0 1 .937'/%3e%3cpath fill='%23e60000' d='M441.347 307.762a.972.972 0 1 0 0-1.942.947.947 0 0 0-.938.938.959.959 0 0 0 .938 1'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M441.347 307.762a.972.972 0 1 0 0-1.942.947.947 0 0 0-.938.938.959.959 0 0 0 .938 1'/%3e%3cpath fill='%23e60000' d='M444.464 288.382a1.019 1.019 0 0 0 .937-1 .944.944 0 0 0-.937-.937.96.96 0 0 0-1 .937 1.013 1.013 0 0 0 1 1'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M444.464 288.382a1.019 1.019 0 0 0 .937-1 .944.944 0 0 0-.937-.937.96.96 0 0 0-1 .937 1.013 1.013 0 0 0 1 1'/%3e%3cpath fill='%23e60000' d='M439.014 270.529a.948.948 0 0 0 1-.85 1.031 1.031 0 0 0-1-1 .962.962 0 0 0-.938 1 .874.874 0 0 0 .938.85'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M439.014 270.529a.948.948 0 0 0 1-.85 1.031 1.031 0 0 0-1-1 .962.962 0 0 0-.938 1 .874.874 0 0 0 .938.85'/%3e%3cpath fill='%23e60000' d='M445.9 272.337a.973.973 0 0 0 1-1 .961.961 0 0 0-1-.938.945.945 0 0 0-.937.938.96.96 0 0 0 .938 1'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M445.9 272.337a.973.973 0 0 0 1-1 .961.961 0 0 0-1-.938.945.945 0 0 0-.937.938.96.96 0 0 0 .938 1'/%3e%3cpath fill='%23e60000' d='M452.66 257.468a.94.94 0 1 0 0-1.875.948.948 0 0 0-.939.938.96.96 0 0 0 .939.937'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M452.66 257.468a.94.94 0 1 0 0-1.875.948.948 0 0 0-.939.938.96.96 0 0 0 .939.937'/%3e%3cpath fill='%23e60000' d='M447.494 253.417a.973.973 0 0 0 1-1 .971.971 0 1 0-1 1'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M447.494 253.417a.973.973 0 0 0 1-1 .971.971 0 1 0-1 1'/%3e%3cpath fill='%23e60000' d='M457.805 243.41a.971.971 0 1 0-.937-.938.9.9 0 0 0 .937.938'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M457.805 243.41a.971.971 0 1 0-.937-.938.9.9 0 0 0 .937.938'/%3e%3cpath fill='%23e60000' d='M436.833 288.449a.886.886 0 0 0 .937-.85.937.937 0 1 0-1.874 0 .873.873 0 0 0 .937.85'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M436.833 288.449a.886.886 0 0 0 .937-.85.937.937 0 1 0-1.874 0 .873.873 0 0 0 .937.85'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M473.326 340.918a18.227 18.227 0 0 1-.567-3.768s.284 0 .72-.57m-1.308 5.56a22.783 22.783 0 0 0-3.684.35 2.3 2.3 0 0 1-.283.782m-13.08-15.128s-.131-3.685.566-3.986a2.967 2.967 0 0 0 1.156-.876m-4.469 3.705a8.435 8.435 0 0 0-2.68 0 1.07 1.07 0 0 1-.569.721m-.763-22.279-.718.352c-.72.346-2.18 3.834-2.18 3.834a13.5 13.5 0 0 0-3.4-1.875h-1m-4.735-19.64a1.113 1.113 0 0 0 1.156.282s2.9 1.877 3.117 2.6c0 0 3.03-3.03 3.618-2.748 0 0 .35.415.938-.13m-5.56-18.072a2.484 2.484 0 0 0 .786.72 7.3 7.3 0 0 1 1.374 3.335s2.44-2.158 3.182-2.027a2.513 2.513 0 0 0 1.5 0m.327-18.945s.568.72 1 .133c0 0 1.744 2.155.719 3.835 0 0 2.465-.564 3.27-.129a.706.706 0 0 0 1.156.413M457 242.6s-.414 1 1.374.636'/%3e%3cpath fill='%23090' d='M518.975 359.842s-3.771-.285-4.337-.285-1.963-2.6-2.53-3.03c-.566-.413-10.508-5.274-17.047-6.3-6.453-1-16.393-4.839-18.422-5.86-10.725-5.145-22.758-14.716-25.461-18.64-2.747-4.118-5.712-13.628-7.02-18.79-.567-2.378-3.77-12.035-3.77-18.64a82.491 82.491 0 0 1 2.026-18.922c1.156-4.993 9.7-19.64 15-26.12 0 0-11.815 18.205-13.842 25.247a77.734 77.734 0 0 0-2.464 20.884c.065 4.12 3.554 19.142 8.48 30.17 3.99 8.85 7.456 9.855 13.69 14.782a93.228 93.228 0 0 0 13.124 8.417 91.7 91.7 0 0 0 17.331 5.642c2.594.5 16.023 4.425 17.767 5.28 1.809.87 6.3 4.837 7.455 6.144'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M518.975 359.842s-3.771-.285-4.337-.285-1.963-2.6-2.53-3.03c-.566-.413-10.508-5.274-17.047-6.3-6.453-1-16.393-4.839-18.422-5.86-10.725-5.145-22.758-14.716-25.461-18.64-2.747-4.118-5.712-13.628-7.02-18.79-.567-2.378-3.77-12.035-3.77-18.64a82.491 82.491 0 0 1 2.026-18.922c1.156-4.993 9.7-19.64 15-26.12 0 0-11.815 18.205-13.842 25.247a77.734 77.734 0 0 0-2.464 20.884c.065 4.12 3.554 19.142 8.48 30.17 3.99 8.85 7.456 9.855 13.69 14.782a93.228 93.228 0 0 0 13.124 8.417 91.7 91.7 0 0 0 17.331 5.642c2.594.5 16.023 4.425 17.767 5.28 1.809.87 6.3 4.837 7.455 6.144z'/%3e%3cpath fill='%23090' d='M452.071 325.81c.284-1.373.349-2.371.85-2.746a11.72 11.72 0 0 0 2.16-3.4 8.359 8.359 0 0 0 0-2.684 25.18 25.18 0 0 1 .413-2.59 10.7 10.7 0 0 0-1.286-2.969 13.814 13.814 0 0 1-2.376-3.03 2.558 2.558 0 0 1-.283 1.725 6.312 6.312 0 0 0-.568 2.962 17.91 17.91 0 0 1 0 3.9 6.625 6.625 0 0 0-.414 3.4q.744 2.715 1.5 5.425'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M452.071 325.81c.284-1.373.349-2.371.85-2.746a11.72 11.72 0 0 0 2.16-3.4 8.359 8.359 0 0 0 0-2.684 25.18 25.18 0 0 1 .413-2.59 10.7 10.7 0 0 0-1.286-2.969 13.814 13.814 0 0 1-2.376-3.03 2.558 2.558 0 0 1-.283 1.725 6.312 6.312 0 0 0-.568 2.962 17.91 17.91 0 0 1 0 3.9 6.625 6.625 0 0 0-.414 3.4q.744 2.715 1.5 5.425'/%3e%3cpath fill='%23090' d='M451.57 324.377s-3.335-4.276-3.335-6.084a6.481 6.481 0 0 0-.567-3.186 4.563 4.563 0 0 1-.435-5.426 8.145 8.145 0 0 0 1.285-2.31c.567-1.59 1.744-1.59 1.962-3.184 0 0 .35 1.873.5 3.468a12.278 12.278 0 0 1-.195 3.026c-.2.937.348 1.941.348 3.254 0 1.283-.13 1.808-.13 2.589 0 .419-.5 6.016.566 7.83'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M451.57 324.377s-3.335-4.276-3.335-6.084a6.481 6.481 0 0 0-.567-3.186 4.563 4.563 0 0 1-.435-5.426 8.145 8.145 0 0 0 1.285-2.31c.567-1.59 1.744-1.59 1.962-3.184 0 0 .35 1.873.5 3.468a12.278 12.278 0 0 1-.195 3.026c-.2.937.348 1.941.348 3.254 0 1.283-.13 1.808-.13 2.589 0 .419-.5 6.016.566 7.83z'/%3e%3cpath fill='%23090' d='M489.219 347.285s-2.813-.284-3.9-.5a18.278 18.278 0 0 1-3.4-.847 10.91 10.91 0 0 1-3.99-2.685c-2.66-2.9-2.377-4.426-2.9-4.554-.936-.128 1.5-.413 2.66-.2a7.731 7.731 0 0 1 3.838 1.942 30.616 30.616 0 0 0 3.4 2.59 5.672 5.672 0 0 1 1.592 1.44 7.09 7.09 0 0 0 2.68 2.812'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M489.219 347.285s-2.813-.284-3.9-.5a18.278 18.278 0 0 1-3.4-.847 10.91 10.91 0 0 1-3.99-2.685c-2.66-2.9-2.377-4.426-2.9-4.554-.936-.128 1.5-.413 2.66-.2a7.731 7.731 0 0 1 3.838 1.942 30.616 30.616 0 0 0 3.4 2.59 5.672 5.672 0 0 1 1.592 1.44 7.09 7.09 0 0 0 2.68 2.812z'/%3e%3cpath fill='%23090' d='M493.143 349.333s-7.107-3.18-7.827-3.772a20.766 20.766 0 0 1-2.747-2.462c-.632-.786-3.684-2.31-4.206-3.336-.284-.632-2.159-3.182-3.271-5.207-.566-1.072 4.709.284 4.709.284 4.272 1.719 2.4.5 4.709 2.31a9 9 0 0 1 2.812 2.813 42.184 42.184 0 0 0 1.81 4.553 19.454 19.454 0 0 0 3.988 4.773'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M493.143 349.333s-7.107-3.18-7.827-3.772a20.766 20.766 0 0 1-2.747-2.462c-.632-.786-3.684-2.31-4.206-3.336-.284-.632-2.159-3.182-3.271-5.207-.566-1.072 4.709.284 4.709.284 4.272 1.719 2.4.5 4.709 2.31a9 9 0 0 1 2.812 2.813 42.184 42.184 0 0 0 1.81 4.553 19.454 19.454 0 0 0 3.988 4.773z'/%3e%3cpath fill='%23090' d='M496.979 350.21s-5.864-1.508-8.545-5.146c-1.876-2.467-1.876-1.724-2.681-2.528a22.3 22.3 0 0 1-3.772-4.342c.065.195-1.723-5.8-1.591-6.452 0-.413 2.158.285 3.99 1 1.5.652 2.376 1.875 3.683 2.679 1.569 1 1.788 3.555 2.53 4.71a6.006 6.006 0 0 1 1.067 3.466c0 1.284.72 1.724 1.155 2.812.5 1.284 2.093 1.066 4.121 3.773'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M496.979 350.21s-5.864-1.508-8.545-5.146c-1.876-2.467-1.876-1.724-2.681-2.528a22.3 22.3 0 0 1-3.772-4.342c.065.195-1.744-5.8-1.591-6.452 0-.413 2.158.285 3.99 1 1.5.652 2.376 1.875 3.683 2.679 1.569 1 1.788 3.555 2.53 4.71a6.006 6.006 0 0 1 1.067 3.466c0 1.284.72 1.724 1.155 2.812.5 1.284 2.093 1.066 4.121 3.773z'/%3e%3cpath fill='%23090' d='M487.562 348.312s-4.993-2.25-5.646-2.4c-.785-.128-1.068-.57-2.093-.848a5.745 5.745 0 0 0-3.684-.419c-.85.2-4.491 1-5.363.57-.938-.413 1.286 2.46 2.31 3.12a8.2 8.2 0 0 0 4.273.713c1.44-.127 3.466 0 4.208 0a6.783 6.783 0 0 0 2.223-.127 6.433 6.433 0 0 1 3.772-.57'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M487.562 348.312s-4.993-2.25-5.646-2.4c-.785-.128-1.068-.57-2.093-.848a5.745 5.745 0 0 0-3.684-.419c-.85.2-4.491 1-5.363.57-.938-.413 1.286 2.46 2.31 3.12a8.2 8.2 0 0 0 4.273.713c1.44-.127 3.466 0 4.208 0a6.783 6.783 0 0 0 2.223-.127 6.433 6.433 0 0 1 3.772-.57z'/%3e%3cpath fill='%23090' d='M490.963 348.312s-5.581-1.44-6.519-1.44a37.6 37.6 0 0 0-4.709.413c-1 .133-4.338-.2-5.362.284a18.479 18.479 0 0 1-6.584.782c-1.155-.195 2.377 3.186 3.771 3.555 4.491 1.29 3.118 1.072 6.083.351 1.744-.419 4.273-.569 5.144-.72.938-.133.72-.63 1.94-1.155a16.821 16.821 0 0 1 6.236-2.093'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M490.963 348.312s-5.581-1.44-6.519-1.44a37.6 37.6 0 0 0-4.709.413c-1 .133-4.338-.2-5.362.284a18.479 18.479 0 0 1-6.584.782c-1.155-.195 2.377 3.186 3.771 3.555 4.491 1.29 3.118 1.072 6.083.351 1.744-.419 4.273-.569 5.144-.72.938-.133.72-.63 1.94-1.155a16.821 16.821 0 0 1 6.236-2.093z'/%3e%3cpath fill='%23090' d='M495.54 350.645s-5.58-2.31-9.918-1.155a24.8 24.8 0 0 1-4.12.937c-1.374.194-2.53-.5-4.84.435-1.068.413-5.952 2.372-7.325 2.31-1.22-.066 3.9 3.249 5.275 3.03 4.491-.636 8.7.849 10.726.063 1.875-.715 2.965-1.218 3.9-1.5.938-.352 1.44-1.223 2.027-1.591.567-.5.938-1.591 4.273-2.528'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M495.54 350.645s-5.58-2.31-9.918-1.155a24.8 24.8 0 0 1-4.12.937c-1.374.194-2.53-.5-4.84.435-1.068.413-5.952 2.372-7.325 2.31-1.22-.066 3.9 3.249 5.275 3.03 4.491-.636 8.7.849 10.726.063 1.875-.715 2.965-1.218 3.9-1.5.938-.352 1.44-1.223 2.027-1.591.567-.5.938-1.591 4.273-2.528'/%3e%3cpath fill='%23090' d='M465.718 337.781s-3.182-3.556-3.836-3.99c-.567-.5-2.093-1.59-2.9-2.31-.72-.57-1.374-1.876-3.466-2.378-.872-.195-3.03-.631-3.618-1.373-.568-.782.13 2.813.784 3.773a7.422 7.422 0 0 0 3.466 2.528c1.374.5 3.183 1.507 3.837 1.808a5.919 5.919 0 0 0 2.026.787 7.273 7.273 0 0 1 3.686 1.155'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M465.718 337.781s-3.182-3.556-3.836-3.99c-.567-.5-2.093-1.59-2.9-2.31-.72-.57-1.374-1.876-3.466-2.378-.872-.195-3.03-.631-3.618-1.373-.568-.782.13 2.813.784 3.773a7.422 7.422 0 0 0 3.466 2.528c1.374.5 3.183 1.507 3.837 1.808a5.919 5.919 0 0 0 2.026.787 7.273 7.273 0 0 1 3.686 1.155z'/%3e%3cpath fill='%23090' d='M468.749 339.242s-5.428-3.838-6.3-4.207c-.85-.413-2.376-.937-3.4-1.289-1.069-.28-3.838-2.243-4.927-2.243-1.069 0-3.118-.129-4.055-.787-1-.782-.131 2.595.937 3.621 3.467 3.115 1.068 2.154 3.99 2.747 1.722.345 4.12 1.372 4.992 1.59.85.285.937-.285 2.246-.195a19.62 19.62 0 0 1 6.517.787'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M468.749 339.242s-5.428-3.838-6.3-4.207c-.85-.413-2.376-.937-3.4-1.289-1.069-.28-3.838-2.243-4.927-2.243-1.069 0-3.118-.129-4.055-.787-1-.782-.131 2.595.937 3.621 3.467 3.115 1.068 2.154 3.99 2.747 1.722.345 4.12 1.372 4.992 1.59.85.285.937-.285 2.246-.195a19.62 19.62 0 0 1 6.517.787z'/%3e%3cpath fill='%23090' d='M470.056 340.265a18.861 18.861 0 0 0-6.67-2.155 29.631 29.631 0 0 1-4.055-1 12.328 12.328 0 0 0-4.121-.5c-1.22-.128-6.082 1.44-7.17.787-1.07-.57 1.153 1.434 2.527 1.937 1.875.72 1.657 1.942 3.772 2.684 2.245.72 4.621 1.59 5.93 1.284 1-.129 1.743-.63 3.182-.781 1.374-.135 3.837-2.16 6.584-2.25'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M470.056 340.265a18.861 18.861 0 0 0-6.67-2.155 29.631 29.631 0 0 1-4.055-1 12.328 12.328 0 0 0-4.121-.5c-1.22-.128-6.082 1.44-7.17.787-1.07-.57 1.153 1.434 2.527 1.937 1.875.72 1.657 1.942 3.772 2.684 2.245.72 4.621 1.59 5.93 1.284 1-.129 1.743-.63 3.182-.781 1.374-.135 3.837-2.16 6.584-2.25z'/%3e%3cpath fill='%23090' d='M470.514 339.176s1.156-5.363.2-6.585a4.9 4.9 0 0 1-1.222-2.813 10.021 10.021 0 0 0-1.59-4.208c-.568-.714-1.723-4.119-1.44-4.989 0 0-3.117 3.03-2.9 4.989a12.173 12.173 0 0 1 0 2.317c-.2.847.72 3.833 1.286 4.7.567.853.284 3.553.872 4.056.567.63 4.055 2.964 4.774 2.528'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M470.514 339.176s1.156-5.363.2-6.585a4.9 4.9 0 0 1-1.222-2.813 10.021 10.021 0 0 0-1.59-4.208c-.568-.714-1.744-4.119-1.44-4.989 0 0-3.117 3.03-2.9 4.989a12.173 12.173 0 0 1 0 2.317c-.2.847.72 3.833 1.286 4.7.567.853.284 3.553.872 4.056.567.63 4.055 2.964 4.774 2.528z'/%3e%3cpath fill='%23090' d='M470.056 340.265a13.207 13.207 0 0 0-2.9-2.094c-1-.412-5.145-1.59-5.428-2.594-.284-1.066-3.684-4.555-3.772-5.492-.13-.631-.784-2.026-.566-2.746a11.88 11.88 0 0 1 .85-3.465c.415-1.072 1.438-3.556 2.442-3.99 0 0 .85 2.745 1.155 3.772a9.524 9.524 0 0 0 1 2.813c.414.563 1.961 3.332 2.027 4.426.2 1 .938 4.424 1.068 5.078.13.72 2.9 3.772 4.055 4.336'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M470.056 340.265a13.207 13.207 0 0 0-2.9-2.094c-1-.412-5.145-1.59-5.428-2.594-.284-1.066-3.684-4.555-3.772-5.492-.13-.631-.784-2.026-.566-2.746a11.88 11.88 0 0 1 .85-3.465c.415-1.072 1.438-3.556 2.442-3.99 0 0 .85 2.745 1.155 3.772a9.524 9.524 0 0 0 1 2.813c.414.563 1.961 3.332 2.027 4.426.2 1 .938 4.424 1.068 5.078.13.72 2.9 3.772 4.055 4.336z'/%3e%3cpath fill='%23090' d='M452.071 325.81c.066.787-2.244-.714-3.4-.714s-4.709.413-5.582-.42a32.834 32.834 0 0 0-2.68-2.812 16.268 16.268 0 0 1-2.463-4.335c-.415-1.5-3.467-4.12-3.9-4.426 0 0 4.186-.848 6.89.847a8.535 8.535 0 0 0 3.334 1.6c.633.278 5.145 4.118 5.43 5.58.282 1.434 2.157 3.984 2.374 4.705'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M452.071 325.81c.066.787-2.244-.714-3.4-.714s-4.709.413-5.582-.42a32.834 32.834 0 0 0-2.68-2.812 16.268 16.268 0 0 1-2.463-4.335c-.415-1.5-3.467-4.12-3.9-4.426 0 0 4.186-.848 6.89.847a8.535 8.535 0 0 0 3.334 1.6c.633.278 5.145 4.118 5.43 5.58.282 1.434 2.157 3.984 2.374 4.705z'/%3e%3cpath fill='%23090' d='M452.071 325.81s-3.836-2.678-4.708-2.528c-.85.134-4.993-2.9-5.276-4.772-.13-1-2.158-2.466-2.463-3.119-1.068-1.74-1.657-5.709-3.117-6.736 0 0 3.99 1 4.992 1.155 1.874.284 3.466.57 4.207 2.25.784 1.59 1.374 2.9 1.962 3.029.567.129 1.439 2.155 1.722 4.27.284 2.026 2.66 6.452 2.66 6.452'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M452.071 325.81s-3.836-2.678-4.708-2.528c-.85.134-4.993-2.9-5.276-4.772-.13-1-2.158-2.466-2.463-3.119-1.068-1.72-1.657-5.709-3.117-6.736 0 0 3.99 1 4.992 1.155 1.874.284 3.466.57 4.207 2.25.784 1.59 1.374 2.9 1.962 3.029.567.129 1.439 2.155 1.722 4.27.284 2.026 2.66 6.452 2.66 6.452z'/%3e%3cpath fill='%23090' d='M444.9 305.8c.566 1.006.566-5.86.785-6.514a10.423 10.423 0 0 1 1.656-2.812c.568-.567.568-2.594.85-3.184a15.5 15.5 0 0 0-.282-5.58 10.477 10.477 0 0 0-1.723 1.591c-.633.72-1.592 1-1.94 1.875-.284.85-.85.85-1.286 1.81a5.7 5.7 0 0 0-.567 3.466 8.671 8.671 0 0 1 .13 2.681 21.431 21.431 0 0 0 2.377 6.667'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M444.9 305.8c.566 1.006.566-5.86.785-6.514a10.423 10.423 0 0 1 1.656-2.812c.568-.567.568-2.594.85-3.184a15.5 15.5 0 0 0-.282-5.58 10.477 10.477 0 0 0-1.723 1.591c-.633.72-1.592 1-1.94 1.875-.284.85-.85.85-1.286 1.81a5.7 5.7 0 0 0-.567 3.466 8.671 8.671 0 0 1 .13 2.681 21.431 21.431 0 0 0 2.377 6.667'/%3e%3cpath fill='%23090' d='M444.965 306.456s-.283-1.941.5-2.683c.72-.719 1.44-.719 1.723-1.155.282-.414.13-1 .436-1.591a10.759 10.759 0 0 0 1-2.092c.283-1.592 1.156-3.337.415-5.058a10.189 10.189 0 0 0-2.028.85 4.072 4.072 0 0 0-1.874 2.593 4.051 4.051 0 0 1-.786 2.246c-.414.72-1 2.9-.283 4.207a6.635 6.635 0 0 1 .85 2.683'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M444.965 306.456s-.283-1.941.5-2.683c.72-.719 1.44-.719 1.723-1.155.282-.414.13-1 .436-1.591a10.759 10.759 0 0 0 1-2.092c.283-1.592 1.156-3.337.415-5.058a10.189 10.189 0 0 0-2.028.85 4.072 4.072 0 0 0-1.874 2.593 4.051 4.051 0 0 1-.786 2.246c-.414.72-1 2.9-.283 4.207a6.635 6.635 0 0 1 .85 2.683z'/%3e%3cpath fill='%23090' d='M440.692 283.958s-.283-4.274.938-5.581c1.155-1.286 1.439-3.771 4.055-5.145a7.578 7.578 0 0 0 0 1.81c.195.632.5 2.746 0 3.465-.414.72-1.876 2.028-1.876 2.682a3.842 3.842 0 0 1-1.722 2.31 9.135 9.135 0 0 1-1.374.415'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M440.692 283.958s-.283-4.274.938-5.581c1.155-1.286 1.439-3.771 4.055-5.145a7.578 7.578 0 0 0 0 1.81c.195.632.5 2.746 0 3.465-.414.72-1.876 2.028-1.876 2.682a3.842 3.842 0 0 1-1.722 2.31 9.135 9.135 0 0 1-1.374.415z'/%3e%3cpath fill='%23090' d='M440.692 286.268s0-3.03.938-3.9c.85-.85 1.286-1.374 1.721-1.874.415-.567.85-2.094 1.876-2.682a10.052 10.052 0 0 0 2.964-2.594s.415 3.619-.566 5.58c-1.069 1.875-1.069 2.9-2.181 3.336a5.039 5.039 0 0 0-1.81 1 3.118 3.118 0 0 1-1.721.718 2.789 2.789 0 0 0-1.221.415'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M440.692 286.268s0-3.03.938-3.9c.85-.85 1.286-1.374 1.721-1.874.415-.567.85-2.094 1.876-2.682a10.052 10.052 0 0 0 2.964-2.594s.415 3.619-.566 5.58c-1.069 1.875-1.069 2.9-2.181 3.336a5.039 5.039 0 0 0-1.81 1 3.119 3.119 0 0 1-1.743.718 2.777 2.777 0 0 0-1.22.415z'/%3e%3cpath fill='%23090' d='M444.093 306.3c.13.854.785-1.875-2.31-1.875a9.885 9.885 0 0 1-6.606-2.243 17.33 17.33 0 0 1-2.006-2.245 7.42 7.42 0 0 1-1.81-3.03c-.13-.851-1-4.12-.849-4.71a6.277 6.277 0 0 1 2.31.85c.72.634 2.093.634 2.812 1.07.72.413 1.286 1.59 1.744 2.027.415.414 1.722.414 2.312 1.285a13.138 13.138 0 0 1 1.809 3.685 3.859 3.859 0 0 0 1.874 2.158c.72.414.567 2.157.72 2.967'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M444.093 306.3c.13.854.785-1.875-2.31-1.875a9.885 9.885 0 0 1-6.606-2.243 17.33 17.33 0 0 1-2.006-2.245 7.42 7.42 0 0 1-1.81-3.03c-.13-.851-1-4.12-.849-4.71a6.277 6.277 0 0 1 2.31.85c.72.634 2.093.634 2.812 1.07.72.413 1.286 1.59 1.744 2.027.415.414 1.722.414 2.312 1.285a13.138 13.138 0 0 1 1.809 3.685 3.859 3.859 0 0 0 1.874 2.158c.72.414.567 2.157.72 2.967z'/%3e%3cpath fill='%23090' d='M443.81 305.145s-2.027-2.527-3.118-2.527c-1 0-3.619-2.681-3.771-3.771a8.006 8.006 0 0 0-1.592-3.837 3.708 3.708 0 0 1-1.5-3.248c.218-1.723.218-4.622.218-4.622s.566 1.723 1.44 2.158c.849.414 2.463 1 2.746 1.592.283.567 1.438.567 1.961 2.376a5.761 5.761 0 0 0 .72 2.159 8.94 8.94 0 0 1 1.286 2.462c.284 1.22 1.874 4.273 1.592 7.235'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M443.81 305.145s-2.027-2.527-3.118-2.527c-1 0-3.619-2.681-3.771-3.771a8.006 8.006 0 0 0-1.592-3.837 3.708 3.708 0 0 1-1.5-3.248c.218-1.723.218-4.622.218-4.622s.566 1.723 1.44 2.158c.849.414 2.463 1 2.746 1.592.283.567 1.438.567 1.961 2.376a5.761 5.761 0 0 0 .72 2.159 8.94 8.94 0 0 1 1.286 2.462c.284 1.22 1.874 4.273 1.592 7.235z'/%3e%3cpath fill='%23090' d='M440.758 288.884c-.066.785 1.155-1.5-1.593-2.377a9.434 9.434 0 0 1-5.427-3.836c-.567-1.155-.938-2.026-1.221-2.528a8.025 8.025 0 0 1-.72-3.249c.066-.85.2-4.054.5-4.556a6.562 6.562 0 0 1 1.874 1.439c.5.785 1.656 1.155 2.245 1.722a11.1 11.1 0 0 1 1 2.376c.282.5 1.439.85 1.721 1.81a10.374 10.374 0 0 1 .567 3.836 4.089 4.089 0 0 0 1.155 2.53c.5.566-.065 2.092-.13 2.812'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M440.758 288.884c-.066.785 1.155-1.5-1.593-2.377a9.434 9.434 0 0 1-5.427-3.836c-.567-1.155-.938-2.026-1.221-2.528a8.025 8.025 0 0 1-.72-3.249c.066-.85.2-4.054.5-4.556a6.562 6.562 0 0 1 1.874 1.439c.5.785 1.656 1.155 2.245 1.722a11.1 11.1 0 0 1 1 2.376c.282.5 1.439.85 1.721 1.81a10.374 10.374 0 0 1 .567 3.836 4.089 4.089 0 0 0 1.155 2.53c.5.566-.065 2.092-.13 2.812z'/%3e%3cpath fill='%23090' d='M440.823 287.729s-1.221-2.813-2.18-3.118c-.85-.282-2.377-2.68-2.442-3.77-.13-1.222-.349-3.4-.719-3.9a4.681 4.681 0 0 1-.633-3.9c.633-1.591 1.658-3.685 1.658-3.685s.784 1.374 1.286 2.159c.72 1.5 1.5 1.592 1.59 2.158.131.633 1 1 1.374 2.224.437 1.656-.065 1.59.066 2.245a9.536 9.536 0 0 1 .5 2.593c-.065 1.157.567 4.34-.5 6.956'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M440.823 287.729s-1.221-2.813-2.18-3.118c-.85-.282-2.377-2.68-2.442-3.77-.13-1.222-.349-3.4-.719-3.9a4.681 4.681 0 0 1-.633-3.9c.633-1.591 1.658-3.685 1.658-3.685s.784 1.374 1.286 2.159c.72 1.5 1.5 1.592 1.59 2.158.131.633 1 1 1.374 2.224.437 1.656-.065 1.59.066 2.245a9.536 9.536 0 0 1 .5 2.593c-.065 1.157.567 4.34-.5 6.956z'/%3e%3cpath fill='%23090' d='M443.069 270.028c.13-.415 1-.851 2.092-1.221 1-.284 2.595-2.6 3.335-3.183.655-.633 1-1.5 1.963-2.028.85-.5 1.373-2.31 1.656-4.119 0 0-2.464.565-3.183.721a6.9 6.9 0 0 0-2.747 1.718c-.631.72-1.22 1.942-1.809 2.225-.567.284-1.286 2.028-1.286 3.248v2.595'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M443.069 270.028c.13-.415 1-.851 2.092-1.221 1-.284 2.595-2.6 3.335-3.183.655-.633 1-1.5 1.963-2.028.85-.5 1.373-2.31 1.656-4.119 0 0-2.464.565-3.183.721a6.9 6.9 0 0 0-2.747 1.718c-.631.72-1.22 1.942-1.809 2.225-.567.284-1.286 2.028-1.286 3.248v2.595z'/%3e%3cpath fill='%23090' d='M442.937 268.719s-.13-1.722-.13-2.528c0-.85-.567-3.248.719-5.145.85-1.283 4.12-3.772 4.992-3.9a13.109 13.109 0 0 1 .436 3.03c-.13.72-.937 3.683-1.591 3.988-.633.283-2.377 3.772-4.426 4.556'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M442.937 268.719s-.13-1.722-.13-2.528c0-.85-.567-3.248.719-5.145.85-1.283 4.12-3.772 4.992-3.9a13.109 13.109 0 0 1 .436 3.03c-.13.72-.937 3.683-1.591 3.988-.633.283-2.377 3.772-4.426 4.556'/%3e%3cpath fill='%23090' d='M442.2 270.028c-.349.632-.13-2.225-1-2.9a3.707 3.707 0 0 1-1-2.965 9.552 9.552 0 0 1 .415-2.81c.066-.72 2.311-3.773 2.158-4.621 0 0 1.286 2.807 1.59 3.616.5 1-.282 2.093-.13 2.963.13.852.85 2.465.35 3.337-.5.785-1.81 2.377-2.4 3.4'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M442.2 270.028c-.349.632-.13-2.225-1-2.9a3.707 3.707 0 0 1-1-2.965 9.552 9.552 0 0 1 .415-2.81c.066-.72 2.311-3.773 2.158-4.621 0 0 1.286 2.807 1.59 3.616.5 1-.282 2.093-.13 2.963.13.852.85 2.465.35 3.337-.5.785-1.81 2.377-2.4 3.4z'/%3e%3cpath fill='%23090' d='M449.979 254.857s.131-.442 1.5-.442c1.286 0 3.183-.061 3.772-.714a11.374 11.374 0 0 1 2.157-1.595 5.57 5.57 0 0 0 1.81-2.244c.131-.564 1.155-1.72 1.591-1.72a11.131 11.131 0 0 0-3.4.348c-1.723.345-4.208 1.283-4.775 2.46a38.561 38.561 0 0 1-2.68 3.907'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M449.979 254.857s.131-.442 1.5-.442c1.286 0 3.183-.061 3.772-.714a11.374 11.374 0 0 1 2.157-1.595 5.57 5.57 0 0 0 1.81-2.244c.131-.564 1.155-1.72 1.591-1.72a11.131 11.131 0 0 0-3.4.348c-1.723.345-4.208 1.283-4.775 2.46a38.561 38.561 0 0 1-2.68 3.907z'/%3e%3cpath fill='%23090' d='M450.48 254.572c.284 1 2.747-1 3.336-1.724.567-.72 1.439-1.875 1.439-1.875a20.088 20.088 0 0 0 1.722-2.372c.937-1.6.719-4.493.348-4.275-.5.284-2.093 1.222-2.528 1.374a2.409 2.409 0 0 0-1.592 1.132 7.288 7.288 0 0 1-1.068 2.243c-.348.441-3.03 1.875-1.657 5.5'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M450.48 254.572c.284 1 2.747-1 3.336-1.724.567-.72 1.439-1.875 1.439-1.875a20.088 20.088 0 0 0 1.722-2.372c.937-1.6.719-4.493.348-4.275-.5.284-2.093 1.222-2.528 1.374a2.409 2.409 0 0 0-1.592 1.132 7.288 7.288 0 0 1-1.068 2.243c-.348.441-3.03 1.875-1.657 5.5'/%3e%3cpath fill='%23090' d='M449.543 254.572s2.026-1.44 2.812-2.16c.85-.847.414-2.026.85-2.595.349-.564 1.439-1.936 1.155-2.812-.282-.849-.849-3.332-.849-3.332a19.352 19.352 0 0 0-1.722 1.719 4.085 4.085 0 0 0-1.222 2.182 19.313 19.313 0 0 1-1.155 2.243 7.594 7.594 0 0 0 .131 3.03 6.6 6.6 0 0 1 0 1.724'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M449.543 254.572s2.026-1.44 2.812-2.16c.85-.847.414-2.026.85-2.595.349-.564 1.439-1.936 1.155-2.812-.282-.849-.849-3.332-.849-3.332a21.681 21.681 0 0 0-1.744 1.719 4.077 4.077 0 0 0-1.221 2.182 19.467 19.467 0 0 1-1.156 2.243 7.63 7.63 0 0 0 .13 3.03 6.551 6.551 0 0 1 0 1.724z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M481.96 347.068s-9.636-.068-10.508-1.284m16.11 2.528s-6.3 1.72-9.635 1.284a17.682 17.682 0 0 0-5.712.284 31.069 31.069 0 0 1-4.426-1.507m26.226 2.272s-4.84.847-5.865 1.155c-1 .279-5.93 2.153-7.455 2.153-1.155 0-4.055-.06-4.84 0a17.3 17.3 0 0 1-6.147-.412m5.951-14.515a30.606 30.606 0 0 1 4.272 2.9c.568.786 3.837 3.4 4.426 3.4m-8.7-10.882s6.3 5.43 7.325 6.15c1.068.78 7.238 6.736 7.979 7.695M480.8 332.133s4.992 3.99 5.581 5.582a15.8 15.8 0 0 0 2.006 3.465s2.092 4.124 2.811 4.71a28.377 28.377 0 0 0 3.99 3.248m-42.815-20.71s5.21 4.425 6.67 5.273m-8.937-2.438a65.571 65.571 0 0 0 7.608 4.553 41.48 41.48 0 0 0 9.418 2.31m2.048 2.054s-5.864-.284-6.888 0c-1 .28-5.581-.72-6.736-1s-5.865-1.155-6.453-1.289m11.162-17.5a17.586 17.586 0 0 0 .13 4.554c.414 1.289 2.441 5.056 2.311 6.016-.13.853 1.155 4.838 2.377 5.58m1.2-15.586s-1 3.186-.567 4.274a13.366 13.366 0 0 1 1.134 4.119 12.1 12.1 0 0 0 1 3.622c.283.72-.131 3.248.565 3.9.721.788 1.659 2.094 1.659 2.094m-35.207-25.465s4.708 1.725 5.3 2.9c.5 1.156 1.439 1.5 1.875 2.093m10.092-9.42s1.222 4.71.939 5.865a24.8 24.8 0 0 0-.283 4.426c0 .854-1.287 4.425-1.222 4.994m-1.308-19.208s-.435 2.745-.566 3.906a26.5 26.5 0 0 1-.284 3.834c-.283.72-.72 4.62 0 6.451m-12.077-10.267s3.836 3.247 4.71 4.123c.849.848 4.839 5.056 4.99 6.144.131 1 2.9 4.209 3.773 5m-19.926-31.676s3.837 3.771 4.12 4.621a7.523 7.523 0 0 0 2.682 2.813m11.118-5.82s-1.439 2.157-1.439 2.9a7.821 7.821 0 0 1-1.155 3.4 7.541 7.541 0 0 0-1.5 3.9m2.942-16.37s-.566 2.027-.85 3.467-1.069 2.964-1.286 3.836c-.283.85-1.5 5.145-1.068 7.761M434.3 287.947a7.005 7.005 0 0 0 1.44 3.03c1 1 2.593 2.529 2.746 3.335.13.937 1.5 5.275 2.965 6.8a5.377 5.377 0 0 1 1.592 2.964m-10.268-31.085a29.019 29.019 0 0 0 .719 3.181c.283.72 1.5 3.99 2.682 4.993m9.286-7.52a15.394 15.394 0 0 0-.85 2.964 14.452 14.452 0 0 1-1.22 2.31c-.131.414-.72 1.94-.72 1.94m5.406-5.187c-.13.937-1.809 3.552-1.874 3.989-.2.5-1 2.529-1.94 3.117-.85.567-3.467 2.463-3.335 3.249m-4.318-16s-.13 3.183.414 4.338a27.422 27.422 0 0 1 1.592 3.836 12.479 12.479 0 0 1 .414 3.337c.2 1.068.567 2.964 1.222 3.683m11.532-25.2s-2.16 2.377-3.118 3.4c-.938.936-4.709 4.991-4.84 5.71m4.4-11.29s-2.027 4.486-2.529 5.206a14.752 14.752 0 0 0-.784 1.942m-1.985-7.305s.132 3.555 0 4.425a9.656 9.656 0 0 0 0 2.75 28.417 28.417 0 0 1-.567 4.425m17.615-20.73a61.769 61.769 0 0 0-5.428 3.55m2.594-7.194-3.183 4.627-.72 1.372m.284-6.435a18.428 18.428 0 0 0-1.155 3.466 29.505 29.505 0 0 1-2.245 5.43'/%3e%3cpath fill='%23004bb3' d='M501.273 348.027s.633-1.808 2.159-.195c0 0 1.744 4.118.414 4.27-1.286.133-2.594.418-2.747-.28a21.206 21.206 0 0 1 .131-3.772'/%3e%3cpath fill='%23004bb3' d='M503.148 347.375s.414-6.235 1.286-6.586c.85-.285 3.554-1.724 5.146-.413 1.591 1.35.13 7.824-.414 8.477-.567.57-1.44 2.377-4.84 1.942l-.414-1.59a8.439 8.439 0 0 0 2.9-.787c1.22-.564 1.59-1.066 1.5-1.72-.131-.853-.065-4.123-1-4.424-.85-.286-2.246-.721-2.246-.721s-1.285 4.928-1.59 6.3l-.283-.418m-2.072 4.364s-6.082 3.466-2.964 8.763a2.649 2.649 0 0 1-2.093-1.284S495 361.37 496 362.526c0 0-4.12-3.688-.937-8.047 3.248-4.426 5.864-4.119 5.864-4.119l.2 1.44'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.232' d='M501.121 351.8s-6.082 3.465-2.964 8.762a2.649 2.649 0 0 1-2.093-1.284S495 361.37 496 362.526c0 0-4.12-3.688-.937-8.047 3.248-4.426 5.864-4.119 5.864-4.119l.2 1.44'/%3e%3cpath fill='%23004bb3' d='M501.121 348.9a8.206 8.206 0 0 0-6.43-.781s-1.744-5.431-1.069-7.178a1.159 1.159 0 0 1 .85-.847s-1.874-1.156-1.285 3.99c.566 5.145 1.59 6.585 1.59 6.585s4.993.279 6.148-.285l.2-1.44'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.232' d='M501.121 348.9a8.206 8.206 0 0 0-6.43-.781s-1.744-5.431-1.069-7.178a1.159 1.159 0 0 1 .85-.847s-1.874-1.156-1.285 3.99c.566 5.145 1.59 6.585 1.59 6.585s4.993.279 6.148-.285l.2-1.44z'/%3e%3cpath fill='%23004bb3' d='M501.121 348.9s-5.275-8.851-6.67-8.851c0 0-1.5-.2 1.874-.564 1.22-.134 3.118 0 3.99 1.658.937 1.59 1.591 5.358 1.94 5.927a1.91 1.91 0 0 0-1.155 1.808'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.232' d='M501.121 348.9s-5.275-8.851-6.67-8.851c0 0-1.5-.2 1.874-.564 1.22-.134 3.118 0 3.99 1.658.937 1.59 1.591 5.358 1.94 5.927a1.91 1.91 0 0 0-1.155 1.808z'/%3e%3cpath fill='%23003' d='M501.121 348.9a36.814 36.814 0 0 1-3.99-2.093c-.413-.413-1.154-5.363-.784-5.056 0 0-1.374-1.657-1.875-1.657-.283 0-1.285.72-1 2.46a29.393 29.393 0 0 0 1.222 5.581 8.412 8.412 0 0 1 6.43.788'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.232' d='M501.121 348.9a36.814 36.814 0 0 1-3.99-2.093c-.413-.413-1.154-5.363-.784-5.056 0 0-1.374-1.657-1.875-1.657-.283 0-1.285.72-1 2.46a29.393 29.393 0 0 0 1.222 5.581 8.412 8.412 0 0 1 6.43.788z'/%3e%3cpath fill='%23004bb3' d='M504.3 351.8a4.235 4.235 0 0 1 1.875 3.4c0 2.158.937 6.149 2.68 7.019 0 0 .415-1.657 1-1.942 0 0 1.723 2.093 2.31 2.093a9.738 9.738 0 0 1-1-2.813c0-.848-.85-4.27-1.722-5.055a11.931 11.931 0 0 0-5.145-3.685v1'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.232' d='M504.3 351.8a4.235 4.235 0 0 1 1.875 3.4c0 2.158.937 6.149 2.68 7.019 0 0 .415-1.657 1-1.942 0 0 1.723 2.093 2.31 2.093a9.738 9.738 0 0 1-1-2.813c0-.848-.85-4.27-1.722-5.055a11.931 11.931 0 0 0-5.145-3.685v.983z'/%3e%3cpath fill='%23003' d='m505.045 341.487-1.59 6.3.413 1.373a1.332 1.332 0 0 0 .85-.847c.283-.788 1.156-6.151 1.657-6.39l-1.375-.414'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.232' d='m505.045 341.487-1.59 6.3.413 1.373a1.332 1.332 0 0 0 .85-.847c.283-.788 1.156-6.151 1.657-6.39l-1.375-.414z'/%3e%3cpath fill='%2300004b' d='M501.056 351.08s-2.9.848-3.99 3.114c0 0-.348-1.434 3.837-3.465l.131.35m3.356 0s2.029.782 2.53 1.936a27.232 27.232 0 0 0-2.529-1.434v-.5m-3.335-1.68s-4.491.72-5.516.5a23.591 23.591 0 0 0 5.582-.068l-.066-.413m7.26-2.767s.5 2.243.85 2.16c.348-.2 1.067-3.773 1.154-5.5.066-1.59-.719-2.026-1.35-1.875-.633 0-1 1.507-.938 2.16a27.323 27.323 0 0 0 .283 3.03'/%3e%3cpath fill='%2300004b' d='M503.454 347.81s1.81 4.052.414 4.269c-1.373.2.567.133-.349-2.59-.348-1.071-.938-2.376-1.221-2.376 0 0 1 .412 1.156.719'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.232' d='M501.273 348.027s.633-1.808 2.159-.195c0 0 1.744 4.118.414 4.27-1.286.133-2.594.418-2.747-.28a21.206 21.206 0 0 1 .131-3.772zm1.875-.652s.414-6.235 1.286-6.586c.85-.285 3.554-1.724 5.146-.413 1.591 1.35.13 7.824-.414 8.477-.567.57-1.44 2.377-4.84 1.942l-.414-1.59a8.439 8.439 0 0 0 2.9-.787c1.22-.564 1.59-1.066 1.5-1.72-.131-.853-.065-4.123-1-4.424-.85-.286-2.246-.721-2.246-.721s-1.285 4.928-1.59 6.3l-.283-.418z'/%3e%3cpath fill='%23004bb3' d='M496.63 240.576c-.349-.938-.414-7.238-.349-8.2.066-1.658 3.03-10.007 3.62-10.945.632-.937.413-1.154.72-1.718l.784-1.156a9.574 9.574 0 0 1 1.22 3.99 58.628 58.628 0 0 1-1 5.8 27.2 27.2 0 0 1-1.723 4.7c-.566 1.222-.5 2.31-.13 2.444l-3.117 5.056'/%3e%3cpath fill='%23fff' d='m501.624 232.227.5.5c1.286-1.44 1.374-4.342 1.374-4.342l-.851-5.86a58.677 58.677 0 0 1-1 5.8 27.424 27.424 0 0 1-1.721 4.706c-.85 2.092-.2 2.315-.132 2.444l1.876-3.248'/%3e%3cpath fill='%23004bb3' d='M502.146 232.729c1.286-1.44 1.373-4.342 1.373-4.342s.938 4.777.414 5.8c-.5 1-.5.715-.414 1.218l-1.373-2.68'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M503.52 235.408c-.066-.5-.066-.195.413-1.217.5-1-.414-5.8-.414-5.8l-.85-5.86a9.176 9.176 0 0 0-1.22-3.99l-.786 1.155c-.282.564-.065.782-.719 1.719-.567.938-3.553 9.27-3.619 10.945-.065.937 0 7.238.349 8.2'/%3e%3cpath fill='%23fc0' d='M501.624 219.3s-.066-.937-.132-1.289c-.066-.129.5.848.937.72a5.743 5.743 0 0 1 2.028 1.724c-.35.5-1.221 1.591-1.876 1.374-.5-.135-.414-.938-.566-1.441a3.8 3.8 0 0 1-.348-1.072'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M501.624 219.3s-.066-.937-.132-1.289c-.066-.129.5.848.937.72a5.743 5.743 0 0 1 2.028 1.724c-.35.5-1.221 1.591-1.876 1.374-.5-.135-.414-.938-.566-1.441a3.8 3.8 0 0 1-.348-1.072z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M501.71 218.515c.066.067.283.346.35.435.194.067.348 0 .631.129a9.432 9.432 0 0 1 1.505 1.44m-1.92-1.352a5.259 5.259 0 0 1 1.81 1.725v-.134'/%3e%3cpath fill='%23fc0' d='M500.75 218.643a10.393 10.393 0 0 0 1.134-.63c.131-.068-.632.786-.349 1.133a4.688 4.688 0 0 1-.937 2.528c-.567-.195-1.22-.195-1.722-1.155-.2-.346.348-.721.72-1.066.195-.135.718-.721 1.155-.787'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M500.75 218.643a10.393 10.393 0 0 0 1.134-.63c.131-.068-.632.786-.349 1.133a4.688 4.688 0 0 1-.937 2.528c-.567-.195-1.22-.195-1.722-1.155-.2-.346.348-.721.72-1.066.195-.135.718-.721 1.155-.787z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M501.558 218.365a1.083 1.083 0 0 0-.284.5c0 .2.13.351.065.636a8.733 8.733 0 0 1-.785 1.936m.567-2.266a4.6 4.6 0 0 1-1 2.244h.131'/%3e%3cpath fill='%23fc0' d='M502.06 218.013c.565-.631 1.655-1.284 2.157-.848a2.922 2.922 0 0 1 .567.5c.282.28.2.413.065.781-.349.721-1.352.352-2.027 0-.13-.066-.5-.412-.72-.284-.282.067-.2.067-.282.067.064.135.194.067.282.135a14.754 14.754 0 0 1 1.722.78c.5.2 1.44-.412 1.374-.937 0-.5-.85-1.5-1.286-1.5a3.472 3.472 0 0 0-2.377 1.371c.2-.133.349.129.5-.066'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M502.06 218.013c.565-.631 1.655-1.284 2.157-.848a2.922 2.922 0 0 1 .567.5c.282.28.2.413.065.781-.349.721-1.352.352-2.027 0-.13-.066-.5-.412-.72-.284-.282.067-.2.067-.282.067.064.135.194.067.282.135a14.754 14.754 0 0 1 1.722.78c.5.2 1.44-.412 1.374-.937 0-.5-.85-1.5-1.286-1.5a3.472 3.472 0 0 0-2.377 1.371c.2-.133.349.129.5-.066z'/%3e%3cpath fill='%23fc0' d='M501.558 218.013c-.567-.631-1.657-1.284-2.16-.848a2.37 2.37 0 0 0-.565.5.674.674 0 0 0-.066.781c.348.721 1.373.352 2.027 0 .131-.066.5-.412.72-.284.348.067.2.067.348.067-.13.135-.283.067-.414.135-.5.127-.938.5-1.657.78a1.284 1.284 0 0 1-1.438-.937c.065-.563.938-1.5 1.373-1.5a3.305 3.305 0 0 1 2.377 1.371c-.131-.133-.35.129-.5-.066'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M501.558 218.013c-.567-.631-1.657-1.284-2.16-.848a2.37 2.37 0 0 0-.565.5.674.674 0 0 0-.066.781c.348.721 1.373.352 2.027 0 .131-.066.5-.412.72-.284.348.067.2.067.348.067-.13.135-.283.067-.414.135-.5.127-.938.5-1.657.78a1.284 1.284 0 0 1-1.438-.937c.065-.563.938-1.5 1.373-1.5a3.305 3.305 0 0 1 2.377 1.371c-.131-.133-.35.129-.5-.066z'/%3e%3cpath fill='%23fc0' d='M501.776 217.645c-.284-.135-.568.127-.655.278-.065.2.065.57.284.57.348.128.85.066.938-.285.065-.346-.284-.413-.567-.563'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M501.776 217.645c-.284-.135-.568.127-.655.278-.065.2.065.57.284.57.348.128.85.066.938-.285.065-.346-.284-.413-.567-.563'/%3e%3cpath fill='%23fc0' d='M501.71 211.757a10.735 10.735 0 0 0 1.5 3.9 11.235 11.235 0 0 0-1.591 2.027 5.6 5.6 0 0 0-1.5-2.094 13.269 13.269 0 0 0 1.591-3.833'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M501.71 211.757a10.735 10.735 0 0 0 1.5 3.9 11.235 11.235 0 0 0-1.591 2.027 5.6 5.6 0 0 0-1.5-2.094 13.269 13.269 0 0 0 1.591-3.833m-.087 2.4a10.247 10.247 0 0 0 .632 1.656 4.063 4.063 0 0 0-.632.632 2.167 2.167 0 0 0-.567-.788 3.46 3.46 0 0 0 .567-1.5'/%3e%3cpath fill='%23fff' d='M528.613 277.2c1.434-3.554 2.963-10.944 2.9-12.623-.284-6.89-.2-8.984-.847-16.087l-7.112 8.2a26.264 26.264 0 0 1-1 10.267l6.085 10.224'/%3e%3cpath fill='%23004bb3' d='M522.53 266.975a27.289 27.289 0 0 0 1-4.991 28.241 28.241 0 0 0 0-5.274l-4.428 4.838 3.4 5.427m18.228 6.671c.129-1.591.195-3.335.195-4.12 0-4.992.564-7.76 0-13.056-.35-4.125-1.44-9.638-1.221-14.064.066-1.283-.129-2.528-.129-3.773l-8.918 9.857c.63 7.1.564 9.2.848 16.087.067 1.657-1.44 9.07-2.9 12.622l1.875 3.183 10.224-6.736'/%3e%3cpath fill='%23fc0' d='m518.452 260.9 20.82-23.066.346.5-20.512 23.194-.632-.63'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='m518.452 260.9 20.82-23.066.346.5-20.512 23.194-.632-.63z'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M539.076 244.259s-1.657 14.565-7.327 14'/%3e%3cpath fill='none' stroke='%2300056b' stroke-width='.232' d='M531.749 258.188c2.813.135 4.621-3.465 5.715-6.8a41.3 41.3 0 0 0 1.59-7.177'/%3e%3cpath fill='none' stroke='%23000b73' stroke-width='.232' d='M531.749 258.188c2.813-.128 4.621-3.773 5.648-6.887a42.121 42.121 0 0 0 1.657-7.11'/%3e%3cpath fill='none' stroke='%23001178' stroke-width='.232' d='M531.749 258.127c2.813-.2 4.621-3.99 5.648-6.96a47.856 47.856 0 0 0 1.657-7.013'/%3e%3cpath fill='none' stroke='%2300167c' stroke-width='.232' d='M531.749 258.06c2.813-.413 4.621-4.209 5.582-6.954a49.089 49.089 0 0 0 1.745-7.02'/%3e%3cpath fill='none' stroke='%23001e85' stroke-width='.232' d='M531.666 257.971c2.806-.564 4.7-4.487 5.58-6.953a50.784 50.784 0 0 0 1.808-7.018'/%3e%3cpath fill='none' stroke='%23002289' stroke-width='.232' d='M531.666 257.971c2.806-.781 4.7-4.771 5.58-7.02a47.72 47.72 0 0 0 1.808-6.951'/%3e%3cpath fill='none' stroke='%2300288f' stroke-width='.232' d='M531.666 257.91c2.806-.938 4.7-5 5.424-7.11a52.781 52.781 0 0 0 1.964-6.888'/%3e%3cpath fill='none' stroke='%23002d93' stroke-width='.232' d='M531.666 257.91c2.806-1.223 4.7-5.28 5.424-7.178a62.406 62.406 0 0 0 1.964-6.886'/%3e%3cpath fill='none' stroke='%2300359c' stroke-width='.232' d='M531.6 257.754c2.9-1.284 4.771-5.426 5.424-7.105a58.951 58.951 0 0 0 2.03-6.892'/%3e%3cpath fill='none' stroke='%230039a0' stroke-width='.232' d='M531.6 257.754c2.9-1.5 4.771-5.8 5.424-7.172 1-2.595 1.942-6.518 2.03-6.8'/%3e%3cpath fill='none' stroke='%23003ea6' stroke-width='.232' d='M531.6 257.686c2.812-1.652 4.771-6.016 5.274-7.17a47.658 47.658 0 0 0 2.16-6.8'/%3e%3cpath fill='none' stroke='%230046ad' stroke-width='.232' d='M531.531 257.686c2.9-1.875 4.84-6.295 5.363-7.322a66.792 66.792 0 0 0 2.16-6.735'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M538.988 243.606a39.676 39.676 0 0 1-2.16 6.67c-.436.785-2.372 5.211-5.274 7.237'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M538.86 240.927s-4.711 11.6-7.7 10.285'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='M531.163 251.235c1.217.569 3.18-1.719 4.772-4.487q1.574-2.839 2.9-5.8'/%3e%3cpath fill='none' stroke='%23001178' stroke-width='.232' d='M531.163 251.169c1.066.5 3.115-1.653 4.705-4.488q1.621-2.828 2.969-5.8'/%3e%3cpath fill='none' stroke='%2300187e' stroke-width='.232' d='M531.163 251.169c.848.44 3.03-1.653 4.62-4.555 1.81-3.248 3.031-5.708 3.031-5.708'/%3e%3cpath fill='none' stroke='%23002086' stroke-width='.232' d='M531.1 251.169c.787.283 3.03-1.653 4.71-4.622q1.567-2.826 3.03-5.708'/%3e%3cpath fill='none' stroke='%23002b91' stroke-width='.232' d='M531.1 251.084c.631.285 2.963-1.59 4.621-4.62 1.942-3.556 3.03-5.715 3.03-5.715'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M531.1 251.084c.413.195 2.9-1.59 4.621-4.777l3.03-5.642'/%3e%3cpath fill='none' stroke='%230039a0' stroke-width='.232' d='M531.1 251.084c.284.128 2.813-1.59 4.554-4.838 2.093-3.84 3.03-5.582 3.03-5.582'/%3e%3cpath fill='none' stroke='%230045ab' stroke-width='.232' d='M531.1 251.084a12.226 12.226 0 0 0 4.493-4.838c2.154-4.057 3.114-5.648 3.114-5.648'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M538.7 240.576s-.938 1.373-3.181 5.49a12.5 12.5 0 0 1-4.493 4.93m-7.494 8-3.993 2.16m3.708 1.612-3.686-.636'/%3e%3cpath fill='none' stroke='%230045ab' stroke-width='.232' d='m523.617 259.215-4.053 1.943'/%3e%3cpath fill='none' stroke='%23003ca2' stroke-width='.232' d='m523.534 259.366-4.057 1.875'/%3e%3cpath fill='none' stroke='%2300359c' stroke-width='.232' d='m523.534 259.583-4.057 1.658'/%3e%3cpath fill='none' stroke='%23002d93' stroke-width='.232' d='m523.534 259.718-4.123 1.59'/%3e%3cpath fill='none' stroke='%2300258b' stroke-width='.232' d='m523.534 259.868-4.123 1.44'/%3e%3cpath fill='none' stroke='%23001e85' stroke-width='.232' d='m523.534 260.086-4.123 1.223'/%3e%3cpath fill='none' stroke='%2300167c' stroke-width='.232' d='m523.534 260.237-4.21 1.154'/%3e%3cpath fill='none' stroke='%23000f75' stroke-width='.232' d='m523.534 260.46-4.275.931'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='m523.534 260.589-4.275.847'/%3e%3cpath fill='none' stroke='%230045ab' stroke-width='.232' d='m523.31 262.615-3.833-.565'/%3e%3cpath fill='none' stroke='%23003ca2' stroke-width='.232' d='m523.31 262.4-3.833-.413'/%3e%3cpath fill='none' stroke='%2300359c' stroke-width='.232' d='m523.31 262.178-3.9-.284'/%3e%3cpath fill='none' stroke='%23002d93' stroke-width='.232' d='m523.31 262.05-3.9-.134'/%3e%3cpath fill='none' stroke='%2300258b' stroke-width='.232' d='M523.31 261.833h-3.986'/%3e%3cpath fill='none' stroke='%23001e85' stroke-width='.232' d='m523.4 261.615-4.12.128'/%3e%3cpath fill='none' stroke='%2300167c' stroke-width='.232' d='m523.4 261.391-4.12.286'/%3e%3cpath fill='none' stroke='%23000f75' stroke-width='.232' d='m523.467 261.241-4.273.351'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='m523.467 261.023-4.273.57'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='m523.467 260.806-4.339.72'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.232' d='M540.734 273.646a28.761 28.761 0 0 0 .129-3.117c0-4.993.63-8.764.066-14.06-.35-4.124-1.44-9.637-1.221-14.063.066-1.283-.129-2.528-.129-3.773l-20.45 22.915'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M540.734 261.894a17.139 17.139 0 0 1-.938 4.34c-.937 1.875-3.772 4.621-7.02 6.671'/%3e%3cpath fill='none' stroke='%2300056b' stroke-width='.232' d='M532.687 272.926a28.555 28.555 0 0 0 5.363-4.49 12.982 12.982 0 0 0 1.59-2.245 15.238 15.238 0 0 0 1-4.336'/%3e%3cpath fill='none' stroke='%23000b73' stroke-width='.232' d='M532.6 272.926a28.323 28.323 0 0 0 5.274-4.621 13.218 13.218 0 0 0 1.657-2.158 16.79 16.79 0 0 0 1.066-4.337'/%3e%3cpath fill='none' stroke='%23001178' stroke-width='.232' d='M532.536 272.926a30.018 30.018 0 0 0 5.207-4.621A15.024 15.024 0 0 0 539.4 266a16.553 16.553 0 0 0 1.221-4.34'/%3e%3cpath fill='none' stroke='%2300167c' stroke-width='.232' d='M532.47 272.861a34.728 34.728 0 0 0 5.144-4.621 9.572 9.572 0 0 0 1.658-2.311 17.2 17.2 0 0 0 1.374-4.336'/%3e%3cpath fill='none' stroke='%23001e85' stroke-width='.232' d='M532.38 272.861a33.2 33.2 0 0 0 5.145-4.709 16.83 16.83 0 0 0 1.6-2.31 17.134 17.134 0 0 0 1.524-4.339'/%3e%3cpath fill='none' stroke='%23002289' stroke-width='.232' d='M532.319 272.861a31.313 31.313 0 0 0 5.078-4.84 12.606 12.606 0 0 0 1.657-2.244 26.293 26.293 0 0 0 1.59-4.34'/%3e%3cpath fill='none' stroke='%2300288f' stroke-width='.232' d='M532.251 272.861a31.683 31.683 0 0 0 5-4.926 16.491 16.491 0 0 0 1.652-2.246 26.4 26.4 0 0 0 1.747-4.337'/%3e%3cpath fill='none' stroke='%23002d93' stroke-width='.232' d='M532.162 272.861a32.291 32.291 0 0 0 5-4.991 14.374 14.374 0 0 0 1.59-2.246 28.094 28.094 0 0 0 1.875-4.338'/%3e%3cpath fill='none' stroke='%2300359c' stroke-width='.232' d='M532.1 272.861a45.035 45.035 0 0 0 4.923-5.058 13.626 13.626 0 0 0 1.6-2.31 32.516 32.516 0 0 0 1.937-4.335'/%3e%3cpath fill='none' stroke='%230039a0' stroke-width='.232' d='M532.034 272.861a41.421 41.421 0 0 0 4.839-5.144 16.6 16.6 0 0 0 1.59-2.311 38.844 38.844 0 0 0 2.093-4.338'/%3e%3cpath fill='none' stroke='%23003ea6' stroke-width='.232' d='M531.944 272.861c1.943-1.5 3.84-4.12 4.845-5.21a15.366 15.366 0 0 0 1.5-2.31 42.487 42.487 0 0 0 2.245-4.34'/%3e%3cpath fill='none' stroke='%230046ad' stroke-width='.232' d='M531.883 272.774a34.958 34.958 0 0 0 4.772-5.21 21.406 21.406 0 0 0 1.568-2.311c1.155-1.942 2.31-4.335 2.31-4.335'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M540.577 260.806a60.427 60.427 0 0 1-4.051 6.67c-.937 1-2.751 3.772-4.71 5.277'/%3e%3cpath fill='none' stroke='%2300004b' stroke-width='.232' d='M540.516 273.646c-2.968 2.028-3.772 2.528-10 6.518l-1.876-2.965s.72-1.656 1-2.528'/%3e%3cpath fill='none' stroke='%2300004f' stroke-width='.232' d='M540.45 273.646c-2.814 1.94-3.84 2.528-9.923 6.365l-.061-.065-1.725-2.812s.134-.349.285-.784a7.225 7.225 0 0 0 .63-1.657'/%3e%3cpath fill='none' stroke='%23000053' stroke-width='.232' d='M540.45 273.646c-2.746 1.876-4.058 2.681-9.923 6.3l-.061-.13c0-.066-1.591-2.813-1.591-2.813a3.4 3.4 0 0 1 .28-.719c.2-.5.35-1.156.5-1.591'/%3e%3cpath fill='none' stroke='%23000056' stroke-width='.232' d='M540.45 273.646c-2.685 1.723-4.119 2.681-9.923 6.147l-.061-.13c0-.066-1.507-2.747-1.507-2.747s.067-.283.2-.72c.2-.5.418-1.068.57-1.5'/%3e%3cpath fill='none' stroke='%23000058' stroke-width='.232' d='M540.45 273.581c-2.6 1.722-4.342 2.811-9.923 6.082l-.061-.066c0-.13-1.374-2.812-1.374-2.812a2.578 2.578 0 0 1 .129-.632 9.834 9.834 0 0 0 .5-1.439'/%3e%3cpath fill='none' stroke='%2300005c' stroke-width='.232' d='M540.45 273.581c-2.528 1.656-4.493 2.9-9.923 6.016l-.061-.13c0-.2-1.29-2.812-1.29-2.812a1.879 1.879 0 0 1 .134-.567 5.585 5.585 0 0 0 .413-1.374'/%3e%3cpath fill='none' stroke='%23000060' stroke-width='.232' d='M540.45 273.581c-2.377 1.59-4.622 2.964-9.923 5.864l-.061-.131c0-.2-1.156-2.747-1.156-2.747a.945.945 0 0 1 .062-.566 9.072 9.072 0 0 0 .35-1.286'/%3e%3cpath fill='none' stroke='%23000062' stroke-width='.232' d='M540.45 273.581c-2.31 1.5-4.839 2.964-9.923 5.712l-.061-.132c0-.2-1.072-2.747-1.072-2.747s-.061-.13.067-.5a4.927 4.927 0 0 0 .285-1.221'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M540.36 273.581c-2.16 1.439-4.928 3.03-9.85 5.646l-.067-.131c0-.283-1-2.747-.937-2.747 0 0-.134-.13 0-.5a3.55 3.55 0 0 0 .2-1.155'/%3e%3cpath fill='none' stroke='%2300056b' stroke-width='.232' d='M540.36 273.516a82.979 82.979 0 0 1-9.85 5.58c-.067 0-.067-.13-.067-.13 0-.283-.854-2.748-.854-2.748s-.128-.065 0-.414a2.761 2.761 0 0 0 .134-1.068'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='M540.36 273.516a78.009 78.009 0 0 1-9.85 5.427c-.067 0-.067-.065-.134-.13a16.441 16.441 0 0 0-.72-2.682h.067a.317.317 0 0 1-.067-.414 2.415 2.415 0 0 0 .067-1'/%3e%3cpath fill='none' stroke='%2300096f' stroke-width='.232' d='M540.36 273.516a76.082 76.082 0 0 1-9.85 5.362c-.067-.066-.067-.131-.134-.195 0-.285-.563-2.595-.563-2.595s-.2-.131-.068-.436a1.512 1.512 0 0 0 0-.938'/%3e%3cpath fill='none' stroke='%23000b73' stroke-width='.232' d='M540.36 273.516a78.353 78.353 0 0 1-9.85 5.21l-.134-.132c0-.414-.5-2.68-.5-2.68s-.194-.066-.128-.35a1.286 1.286 0 0 0 .067-.85'/%3e%3cpath fill='none' stroke='%23001178' stroke-width='.232' d='M540.36 273.516a68.1 68.1 0 0 1-9.917 5.078l-.067-.13c0-.436-.413-2.595-.346-2.681 0 0-.284-.066-.133-.284.066-.349 0-.349-.068-.785'/%3e%3cpath fill='none' stroke='%23001379' stroke-width='.232' d='M540.36 273.516a65.649 65.649 0 0 1-9.917 4.991.644.644 0 0 0-.067-.195c0-.415-.346-2.6-.284-2.6 0 0-.279-.065-.195-.283.133-.284 0-.284-.068-.72'/%3e%3cpath fill='none' stroke='%2300167c' stroke-width='.232' d='M540.293 273.428a47.69 47.69 0 0 1-9.85 4.927l-.067-.2c0-.414-.195-2.53-.129-2.595 0 0-.35 0-.284-.195.067-.284-.066-.284-.133-.634'/%3e%3cpath fill='none' stroke='%23001c82' stroke-width='.232' d='M540.293 273.428a45.953 45.953 0 0 1-9.85 4.773l-.067-.13c0-.5-.129-2.594-.067-2.681 0 0-.346.065-.279-.13.129-.284-.067-.2-.2-.567'/%3e%3cpath fill='none' stroke='%23001e85' stroke-width='.232' d='M540.293 273.363a44.1 44.1 0 0 1-9.85 4.773.662.662 0 0 0-.067-.2c0-.566 0-2.529.067-2.594 0 0-.413.065-.351-.13.067-.283-.129-.13-.195-.5'/%3e%3cpath fill='none' stroke='%23002086' stroke-width='.232' d='M540.293 273.363c-1.217.85-6.518 3.836-9.85 4.621a.641.641 0 0 0-.067-.2 23.465 23.465 0 0 1 .135-2.594s-.5.13-.352-.066c.067-.195-.195-.065-.285-.414'/%3e%3cpath fill='none' stroke='%2300258b' stroke-width='.232' d='M540.232 273.363c-1.094.785-6.586 3.9-9.789 4.49a.642.642 0 0 1-.067-.195 21.363 21.363 0 0 1 .2-2.53h.068s-.5.066-.413-.065c.061-.195-.2 0-.352-.349'/%3e%3cpath fill='none' stroke='%2300288f' stroke-width='.232' d='M540.232 273.363c-1 .719-6.736 3.989-9.789 4.425a.235.235 0 0 1-.067-.2 13.726 13.726 0 0 1 .352-2.53s-.5.066-.5-.065c.128-.195-.2.066-.352-.282'/%3e%3cpath fill='none' stroke='%23002b91' stroke-width='.232' d='M540.232 273.363c-.937.632-6.893 4.054-9.789 4.272-.067-.065-.067-.13-.134-.195a20.572 20.572 0 0 1 .5-2.53s-.565.131-.436 0c.067-.2-.346.131-.5-.2'/%3e%3cpath fill='none' stroke='%23002d93' stroke-width='.232' d='M540.232 273.363c-.877.5-7.021 4.054-9.789 4.207a1.709 1.709 0 0 0-.134-.282 9.8 9.8 0 0 1 .658-2.53s-.569.131-.569.066c.068-.2-.284.195-.5-.131'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M540.232 273.3c-.787.5-7.238 4.207-9.789 4.12a.484.484 0 0 1-.134-.284 8.12 8.12 0 0 1 .72-2.463s-.564.13-.564 0c.062-.065-.351.349-.568 0'/%3e%3cpath fill='none' stroke='%2300359c' stroke-width='.232' d='M540.232 273.3c-.636.5-7.394 4.272-9.789 3.989-.067-.066-.134-.13-.134-.2a6.5 6.5 0 0 1 .854-2.529s-.72.195-.636.13c.067-.13-.346.35-.63 0'/%3e%3cpath fill='none' stroke='%2300389e' stroke-width='.232' d='M540.232 273.3c-.57.348-7.545 4.337-9.789 3.836-.067 0-.134-.13-.134-.195a6.939 6.939 0 0 1 .938-2.465v-.065s-.72.283-.63.2c.066-.132-.413.414-.721.065'/%3e%3cpath fill='none' stroke='%23003ca2' stroke-width='.232' d='M540.165 273.3c-.413.282-7.674 4.337-9.7 3.77a2.143 2.143 0 0 1-.194-.282 6.361 6.361 0 0 1 1.154-2.465s-.72.285-.72.2c0-.13-.5.5-.72.13'/%3e%3cpath fill='none' stroke='%23003ea6' stroke-width='.232' d='M540.165 273.3c-.351.195-7.824 4.425-9.7 3.619a2.313 2.313 0 0 1-.194-.284c0-.785 1.154-2.312 1.216-2.464 0 0-.782.35-.72.2 0 0-.5.633-.782.284'/%3e%3cpath fill='none' stroke='%230042a8' stroke-width='.232' d='M540.165 273.3c-.285.13-7.98 4.49-9.789 3.552a.445.445 0 0 0-.129-.282 6.163 6.163 0 0 1 1.284-2.465s-.78.285-.72.285c0-.067-.564.567-.847.282'/%3e%3cpath fill='none' stroke='%230045ab' stroke-width='.232' d='M540.165 273.21c-.195.13-8.2 4.621-9.789 3.466 0-.065-.129-.13-.129-.283a4.79 4.79 0 0 1 1.435-2.377l-.78.284s-.632.633-.939.349'/%3e%3cpath fill='none' stroke='%230049af' stroke-width='.232' d='M540.165 273.21c-.068.065-8.327 4.709-9.789 3.335 0-.065-.129-.13-.129-.282 0-.938 1.435-2.312 1.5-2.377l-.782.283s-.658.786-1 .5'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M540.165 273.146s-9.482 5.361-9.917 2.963c0-.937 1.59-2.31 1.59-2.31l-.853.283s-.653.85-1 .567'/%3e%3cpath fill='%23fc0' d='M539.139 237.808c-.063-.938-.565-2.026-1.218-2.026a4.942 4.942 0 0 0-.786.061c-.346.134-.413.285-.5.636-.128.781.938 1.066 1.658 1.156.128 0 .653-.068.786.128.129.285.062.195.129.285a.444.444 0 0 1-.285-.135c-.564-.127-1.065-.127-1.875-.278-.563-.068-.937-1.156-.63-1.591.35-.351 1.59-.72 1.964-.42a3.169 3.169 0 0 1 1.155 2.468c-.067-.194-.35-.067-.35-.284'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M539.139 237.808c-.063-.938-.565-2.026-1.218-2.026a4.942 4.942 0 0 0-.786.061c-.346.134-.413.285-.5.636-.128.781.938 1.066 1.658 1.156.128 0 .653-.068.786.128.129.285.062.195.129.285a.444.444 0 0 1-.285-.135c-.564-.127-1.065-.127-1.875-.278-.563-.068-.937-1.156-.63-1.591.35-.351 1.59-.72 1.964-.42a3.169 3.169 0 0 1 1.155 2.468c-.067-.194-.35-.067-.35-.284z'/%3e%3cpath fill='%23fc0' d='M539.579 238.092c.847-.284 2.092-.134 2.31.413 0 .067.2.563.128.787.068.346-.066.5-.346.715-.72.35-1.378-.5-1.657-1.156a1.518 1.518 0 0 0-.418-.714c-.346-.068-.2 0-.346-.068.067.13.2.2.284.285.346.5.5.938.938 1.653.2.5 1.35.5 1.657.067a2.575 2.575 0 0 0-.2-2.026 3.015 3.015 0 0 0-2.747-.195c.195-.068.195.284.436.195'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M539.579 238.092c.847-.284 2.092-.134 2.31.413a2 2 0 0 1 .128.787c.068.346-.066.5-.346.715-.72.35-1.378-.5-1.657-1.156a1.518 1.518 0 0 0-.418-.714c-.346-.068-.2 0-.346-.068.067.13.2.2.284.285.346.5.5.938.938 1.653.2.5 1.35.5 1.657.067a2.575 2.575 0 0 0-.2-2.026 3.015 3.015 0 0 0-2.747-.195c.195-.068.195.284.436.195z'/%3e%3cpath fill='%23fc0' d='M539.64 237.673c.285 0 .351.42.285.637 0 .194-.346.345-.57.284-.345-.133-.63-.419-.5-.786.061-.352.5-.195.781-.135'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M539.64 237.673c.285 0 .351.42.285.637 0 .194-.346.345-.57.284-.345-.133-.63-.419-.5-.786.061-.352.5-.195.781-.135'/%3e%3cpath fill='%23fc0' d='M543.72 233.532a15.016 15.016 0 0 1-4.057 2.032 5.785 5.785 0 0 1 0 2.244 5.529 5.529 0 0 1 2.528-.5 9.226 9.226 0 0 1 1.507-3.773'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M543.72 233.532a15.016 15.016 0 0 1-4.057 2.032 5.785 5.785 0 0 1 0 2.244 5.529 5.529 0 0 1 2.528-.5 9.226 9.226 0 0 1 1.507-3.773z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M542.13 235.19a6.738 6.738 0 0 1-1.658.787 1.829 1.829 0 0 1 0 .848 2.8 2.8 0 0 1 1-.128 4 4 0 0 1 .636-1.507z'/%3e%3cpath fill='%23fc0' d='M539.947 239.549s-.569-.63-.787-.937c-.128-.129.285.937-.128 1.221a5.351 5.351 0 0 0 0 2.595 2.4 2.4 0 0 0 2.093-.345c.284-.285-.134-.855-.352-1.29-.128-.195-.346-.937-.781-1.222'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M539.947 239.549s-.569-.63-.787-.937c-.128-.129.285.937-.128 1.221a5.351 5.351 0 0 0 0 2.595 2.4 2.4 0 0 0 2.093-.345c.284-.285-.134-.855-.352-1.29-.128-.195-.346-.937-.781-1.222z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M539.356 239.113c0 .068.067.42.067.5-.068.195-.285.284-.285.569a8.175 8.175 0 0 0 .068 2.154m.217-2.416a6.081 6.081 0 0 0 .134 2.46h-.134m.156-.937a3.658 3.658 0 0 1 .129.938c.066-.062.194.067.284.067'/%3e%3cpath fill='%23fff' d='M501.624 326.9c-.066 0-.2-.134-.285-.195-.414-.2-1.067-.2-1.286-.42-1-1.154-.283-3.33.066-4.7a58.156 58.156 0 0 0 1.5-7.238h.065c.567 2.378.633 4.705 1.439 7.238.5 1.373 1.155 3.55.13 4.705-.195.2-.85.2-1.22.419-.13.061-.283.195-.414.195'/%3e%3cpath fill='%23004bb3' d='M501.624 314.213c.565 2.377.719 4.839 1.5 7.394.414 1.218 1.069 3.249.283 4.42l-.012-.156a2.87 2.87 0 0 0 1.067-.2c.13-.067.21.03.3-.105a3.206 3.206 0 0 1 .436-.5c.283-.133.566-.066.85-.2.066-.062.066-.13.13-.13a1.827 1.827 0 0 0 1.287-2.286 2.838 2.838 0 0 0-.284-.788 5.8 5.8 0 0 0-.5-1.065 8.08 8.08 0 0 0-.567-1.156 1.181 1.181 0 0 0-.283-.5 2.906 2.906 0 0 0-.284-.5c-.066-.195-.283-.285-.414-.5-.132-.128-.219-.128-.284-.284-.065 0-.283-.061-.2-.129a.7.7 0 0 1-.282-.128c-.284-.72-.655-1.072-.938-1.814a2.224 2.224 0 0 1-.2-1.155h-1.59'/%3e%3cpath fill='none' stroke='%23003' stroke-width='.232' d='M502.43 314.28a35.041 35.041 0 0 0 1.5 5c.567 1 2.813 2.808 1.286 5.709'/%3e%3cpath fill='none' stroke='%2300004b' stroke-width='.232' d='M502.276 314.28a28.091 28.091 0 0 0 1.592 5c.567 1.066 2.878 2.812 1.351 5.709'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M502.211 314.28a37.861 37.861 0 0 0 1.479 5.1c.567 1 2.812 2.963 1.22 5.865'/%3e%3cpath fill='none' stroke='%2300187e' stroke-width='.232' d='M502.06 314.28a36.435 36.435 0 0 0 1.59 5.146c.567 1 2.837 2.7 1.31 5.69'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M501.994 314.28s.936 4.209 1.59 5.212c.5 1 2.682 3.115 1.068 6.079'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M501.928 314.28a36.187 36.187 0 0 0 1.5 5.275c.567 1 2.682 3.185 1.068 6.15'/%3e%3cpath fill='none' stroke='%2300004b' stroke-width='.232' d='M502.5 314.28a30.09 30.09 0 0 0 1.591 4.928c.566 1.066 2.813 2.9 1.286 5.71'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M502.647 314.37a31.333 31.333 0 0 0 1.5 4.838c.566 1 2.9 2.9 1.373 5.71'/%3e%3cpath fill='none' stroke='%2300187e' stroke-width='.232' d='M502.713 314.37a27.5 27.5 0 0 0 1.59 4.838c.568 1 2.813 2.813 1.374 5.71'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M502.8 314.37a29.831 29.831 0 0 0 1.591 4.772c.567 1.071 2.9 2.9 1.374 5.714'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M502.93 314.37a25.7 25.7 0 0 0 1.592 4.772c.567 1 2.9 2.9 1.373 5.714'/%3e%3cpath fill='%23004bb3' d='M501.624 314.213c-.5 2.377-.633 4.839-1.5 7.394-.35 1.218-1 3.249-.2 4.42l-.066-.06h.066a3.169 3.169 0 0 1-1.069-.195c-.066-.069-.2-.069-.282-.2a1.8 1.8 0 0 0-.5-.5c-.2-.133-.5-.066-.719-.2-.065-.062-.13-.13-.2-.13a2.587 2.587 0 0 1-1.221-1.065 3.84 3.84 0 0 1-.066-1.221c.066-.286.2-.5.284-.788a5.751 5.751 0 0 1 .5-1.065 7.874 7.874 0 0 1 .567-1.156 190.615 190.615 0 0 1 .566-1c.066-.195.283-.285.415-.5.13-.128.194-.128.348-.284 0 0 .2-.061.2-.129a.142.142 0 0 0 .132-.128 11.373 11.373 0 0 0 1-1.814 2.224 2.224 0 0 0 .2-1.155h1.5'/%3e%3cpath fill='none' stroke='%23003' stroke-width='.232' d='M500.9 314.28a34.94 34.94 0 0 1-1.5 5c-.566 1-2.813 2.808-1.374 5.709'/%3e%3cpath fill='none' stroke='%2300004b' stroke-width='.232' d='M501.056 314.28a34.94 34.94 0 0 1-1.5 5c-.633 1.066-2.835 2.963-1.286 5.86'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M501.121 314.28a39 39 0 0 1-1.5 5.146c-.567 1-2.812 2.963-1.22 5.864'/%3e%3cpath fill='none' stroke='%2300187e' stroke-width='.232' d='M501.273 314.28a34.292 34.292 0 0 1-1.525 5.146c-.633 1-2.812 3.03-1.221 6.016'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M501.34 314.28a35.98 35.98 0 0 1-1.5 5.212c-.567 1-2.747 3.115-1.155 6.079'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M501.405 314.28s-.85 4.275-1.5 5.275c-.566 1-2.68 3.185-1.067 6.15'/%3e%3cpath fill='none' stroke='%2300004b' stroke-width='.232' d='M500.838 314.28a38.373 38.373 0 0 1-1.5 4.928c-.567 1.066-2.9 2.9-1.374 5.71'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M500.75 314.37a34.783 34.783 0 0 1-1.59 4.838c-.568 1-2.9 2.9-1.374 5.71'/%3e%3cpath fill='none' stroke='%2300187e' stroke-width='.232' d='M500.6 314.37a27.385 27.385 0 0 1-1.592 4.838c-.5 1-2.811 2.813-1.286 5.71'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M500.533 314.37a21.653 21.653 0 0 1-1.656 4.772c-.5 1.071-2.813 2.9-1.287 5.714'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M500.4 314.37a25.7 25.7 0 0 1-1.592 4.772c-.567 1-2.812 2.9-1.286 5.714'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.232' d='M498.157 317.768c-.132.2-.349.285-.415.5a1.378 1.378 0 0 0-.283.5 1.3 1.3 0 0 0-.283.5 10.655 10.655 0 0 0-.567 1.155 11.17 11.17 0 0 0-.5 1.066c-.065.285-.2.5-.282.787a3.809 3.809 0 0 0 .064 1.217 2.478 2.478 0 0 0 1.221 1.071c.066 0 .131.062.195.13.2.133.5.065.721.194a1.855 1.855 0 0 1 .5.5c.066.133.2.133.283.194a3.006 3.006 0 0 0 1.07.2h-.066l.065.061v-.06a.421.421 0 0 0 .132.279c.195.194.849.194 1.285.419.066.06.2.194.283.194.132 0 .284-.133.416-.194.349-.2 1-.2 1.22-.42a.337.337 0 0 0 .13-.279 2.756 2.756 0 0 0 1.07-.2c.13-.061.195-.061.282-.194a3.579 3.579 0 0 1 .437-.5c.282-.129.566-.061.85-.195.064-.068.13-.129.13-.129a1.836 1.836 0 0 0 1.287-2.288 2.831 2.831 0 0 0-.284-.787 5.661 5.661 0 0 0-.5-1.066 7.792 7.792 0 0 0-.569-1.155 1.131 1.131 0 0 0-.282-.5 2.78 2.78 0 0 0-.284-.5c-.066-.195-.283-.285-.415-.5'/%3e%3cpath fill='%23fff' d='m543.942 272.661-8.03 5.32a18.435 18.435 0 0 1-.2 4.821 23.061 23.061 0 0 1-1.222 4.274h-.04l6.678 11.145a32.89 32.89 0 0 0 3-10.667c.004-6.412.217-8.32-.186-14.893z'/%3e%3cpath fill='%23004bb3' d='M534.5 287.075a23.218 23.218 0 0 0 1.222-4.274 18.423 18.423 0 0 0 .2-4.84l-4.927 3.184 3.47 5.93'/%3e%3cpath fill='%23fc0' d='m530.51 280.4 23.277-15.216.419.567-23.2 15.434-.5-.785'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='m530.51 280.4 23.277-15.216.419.567-23.2 15.434-.5-.785'/%3e%3cpath fill='%23004bb3' d='M548.49 310.508a4.938 4.938 0 0 0 1.81-2.154c.5-1.657.418-1.6.853-3.471.2-1.066.2-2.244.413-3.334.285-1.068 1.809-4.621 1.875-6.016.129-4.622 1.658-7.76 1.284-12.753-.28-3.9-1.155-9.2-.72-13.276a30.281 30.281 0 0 0-.061-3.467l-10.007 6.52c.413 6.67.195 8.545.195 15 0 1.592-1.372 7.891-3.03 10.726l7.322 12.25'/%3e%3cpath fill='none' stroke='%2300004b' stroke-width='.232' d='m541.231 298.236 7.328 12.25a4.884 4.884 0 0 0 1.74-2.155 17.1 17.1 0 0 0 .854-3.465 29.155 29.155 0 0 0 .5-3.338c.28-1.068 1.808-4.622 1.875-6.017m.039-.021c-.062 1.373-1.59 4.84-1.875 5.93a22.612 22.612 0 0 1-.5 3.334 18.637 18.637 0 0 1-.854 3.466 5 5 0 0 1-1.741 2.093l-7.327-12.1'/%3e%3cpath fill='none' stroke='%2300004f' stroke-width='.232' d='M553.57 295.49c-.062 1.373-1.59 4.773-1.875 5.864a22.54 22.54 0 0 1-.5 3.333 20.423 20.423 0 0 1-.854 3.466 5.576 5.576 0 0 1-1.741 2.092s-7.238-11.965-7.327-12.03m12.294-2.725c-.062 1.373-1.5 4.773-1.875 5.864a22.9 22.9 0 0 1-.5 3.25 19.832 19.832 0 0 1-.854 3.4 4.884 4.884 0 0 1-1.741 2.025c-.067.067-7.238-11.748-7.327-11.813'/%3e%3cpath fill='none' stroke='%23000051' stroke-width='.232' d='M553.57 295.49c-.062 1.286-1.5 4.708-1.875 5.8a19.47 19.47 0 0 1-.5 3.182 18.442 18.442 0 0 1-.854 3.4 5.667 5.667 0 0 1-1.741 2.093c-.067 0-7.171-11.665-7.327-11.752m12.294-2.725c-.062 1.286-1.5 4.621-1.808 5.711-.195 1-.285 2.158-.564 3.185a16.616 16.616 0 0 1-.854 3.332 5.576 5.576 0 0 1-1.741 2.092c-.067 0-7.171-11.53-7.327-11.6'/%3e%3cpath fill='none' stroke='%23000053' stroke-width='.232' d='M553.57 295.49c-.062 1.286-1.5 4.556-1.808 5.646-.195 1-.285 2.158-.564 3.183a19.144 19.144 0 0 1-.854 3.337 5.437 5.437 0 0 1-1.741 2.026c-.134.067-7.171-11.38-7.327-11.446m12.294-2.747c-.062 1.286-1.5 4.557-1.808 5.582-.195 1.068-.285 2.158-.564 3.182a22.669 22.669 0 0 1-.854 3.247 4.9 4.9 0 0 1-1.741 2.027c-.195.066-7.11-11.225-7.327-11.312'/%3e%3cpath fill='none' stroke='%23000056' stroke-width='.232' d='M553.57 295.49c-.062 1.286-1.5 4.49-1.808 5.58-.195 1-.285 2.093-.564 3.118a17.988 17.988 0 0 1-.937 3.244 5.4 5.4 0 0 1-1.658 1.944c-.195.066-7.11-11.1-7.327-11.161m12.294-2.725c-.062 1.22-1.5 4.425-1.808 5.428-.195 1.068-.285 2.158-.564 3.182a22.842 22.842 0 0 1-.937 3.182 4.923 4.923 0 0 1-1.658 1.943c-.195.06-7.11-10.945-7.327-11.01m12.294-2.725c-.062 1.22-1.5 4.425-1.808 5.428-.195 1-.285 2.026-.564 3.03a18.787 18.787 0 0 1-.937 3.184 4.479 4.479 0 0 1-1.658 1.936c-.285.068-7.11-10.788-7.327-10.876'/%3e%3cpath fill='none' stroke='%23000058' stroke-width='.232' d='M553.57 295.49c-.062 1.22-1.434 4.338-1.808 5.363-.195 1-.285 2.092-.564 3.03a14.722 14.722 0 0 1-1 3.115 4.27 4.27 0 0 1-1.591 1.942c-.285.066-7.02-10.66-7.327-10.725m12.294-2.725c-.062 1.22-1.434 4.273-1.808 5.275-.195 1-.346 2.092-.564 2.964a14.3 14.3 0 0 1-1 3.186 4.148 4.148 0 0 1-1.658 1.874c-.194.129-6.887-10.443-7.238-10.574'/%3e%3cpath fill='none' stroke='%2300005c' stroke-width='.232' d='M553.57 295.49c-.062 1.22-1.434 4.273-1.808 5.275-.195.938-.346 1.94-.564 2.9a14.685 14.685 0 0 1-1 3.115 5.447 5.447 0 0 1-1.658 1.942c-.284.067-6.887-10.355-7.238-10.507m12.21-2.725c0 1.155-1.373 4.207-1.724 5.21-.195.937-.346 1.962-.57 2.9a19.473 19.473 0 0 1-1 3.12 5.405 5.405 0 0 1-1.657 1.87c-.286.067-6.888-10.221-7.238-10.353'/%3e%3cpath fill='none' stroke='%2300005e' stroke-width='.232' d='M553.508 295.49c0 1.155-1.373 4.12-1.724 5.144-.195.938-.346 1.94-.57 2.9a16.115 16.115 0 0 1-1 3.03 4.71 4.71 0 0 1-1.657 1.873c-.352.068-6.8-10.07-7.238-10.222m12.187-2.725c0 1.068-1.373 4.054-1.724 5.057-.195 1-.346 1.94-.57 2.9a18.362 18.362 0 0 1-1 2.965 4.7 4.7 0 0 1-1.657 1.874c-.352.129-6.8-9.918-7.238-10.071'/%3e%3cpath fill='none' stroke='%23000060' stroke-width='.232' d='M553.508 295.425c0 1.155-1.373 4.12-1.724 5.143-.195.852-.346 1.875-.631 2.813a22.023 22.023 0 0 1-.937 2.9 5.352 5.352 0 0 1-1.657 1.875c-.352.133-6.8-9.785-7.238-9.917m12.187-2.811c0 1.155-1.373 4.054-1.724 4.991a27.164 27.164 0 0 1-.631 2.813 26.858 26.858 0 0 1-.937 2.965 5.19 5.19 0 0 1-1.657 1.803c-.413.129-6.8-9.634-7.238-9.787m12.187-2.79c0 1.155-1.288 3.989-1.724 4.991a25.909 25.909 0 0 1-.631 2.747 17.93 17.93 0 0 1-1 2.964 4.545 4.545 0 0 1-1.591 1.724c-.413.129-6.737-9.483-7.238-9.636'/%3e%3cpath fill='none' stroke='%23000062' stroke-width='.232' d='M553.508 295.425c0 1.155-1.288 3.9-1.657 4.926-.285.937-.413 1.874-.72 2.747a15.445 15.445 0 0 1-1 2.9 4.542 4.542 0 0 1-1.59 1.719c-.5.134-6.737-9.35-7.239-9.482m12.21-2.811c0 1.067-1.288 3.9-1.657 4.838-.285.938-.413 1.876-.72 2.747a15.726 15.726 0 0 1-1 2.81 5.58 5.58 0 0 1-1.59 1.814c-.5.061-6.737-9.266-7.239-9.42'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M553.508 295.425c0 1.067-1.288 3.836-1.657 4.838-.285.85-.413 1.81-.72 2.682a13.433 13.433 0 0 1-1 2.747 3.983 3.983 0 0 1-1.59 1.725c-.5.194-6.67-8.984-7.239-9.2m12.21-2.79c0 1.067-1.288 3.836-1.657 4.773-.285.85-.413 1.809-.72 2.682a17.027 17.027 0 0 1-1 2.745 4.184 4.184 0 0 1-1.59 1.657c-.57.195-6.586-8.85-7.239-9.067'/%3e%3cpath fill='none' stroke='%23000268' stroke-width='.232' d='M553.508 295.425c0 1.067-1.288 3.77-1.657 4.708-.285.85-.413 1.809-.72 2.594a22.19 22.19 0 0 1-1 2.747 4.508 4.508 0 0 1-1.59 1.72c-.57.133-6.586-8.761-7.239-8.98m12.21-2.79c0 1.068-1.288 3.684-1.657 4.622-.285.872-.413 1.809-.72 2.616a28.971 28.971 0 0 1-1 2.745 5.481 5.481 0 0 1-1.59 1.658c-.632.128-6.586-8.632-7.239-8.85'/%3e%3cpath fill='none' stroke='%2300056b' stroke-width='.232' d='M553.508 295.425c0 1-1.222 3.618-1.657 4.621-.285.784-.413 1.656-.72 2.528a16.408 16.408 0 0 1-1.072 2.683 4.859 4.859 0 0 1-1.5 1.657c-.631.195-6.586-8.481-7.238-8.7m12.187-2.79c0 1-1.222 3.619-1.657 4.491-.285.85-.413 1.722-.72 2.594a15.352 15.352 0 0 1-1.072 2.591 4.232 4.232 0 0 1-1.59 1.658c-.564.2-6.452-8.325-7.172-8.543m12.211-2.79c0 1-1.222 3.552-1.657 4.49-.285.85-.413 1.657-.72 2.463a12.91 12.91 0 0 1-1.072 2.594 4.838 4.838 0 0 1-1.59 1.657c-.63.129-6.452-8.11-7.172-8.414'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='M553.508 295.425c0 .937-1.222 3.465-1.657 4.424-.285.785-.413 1.723-.72 2.464a15.352 15.352 0 0 1-1.072 2.591 5.408 5.408 0 0 1-1.59 1.592c-.63.2-6.452-7.976-7.172-8.26m12.211-2.811a15.414 15.414 0 0 1-1.657 4.338c-.285.784-.413 1.656-.72 2.462a12.921 12.921 0 0 1-1.072 2.53 4.1 4.1 0 0 1-1.59 1.59c-.63.195-6.384-7.825-7.172-8.109'/%3e%3cpath fill='none' stroke='%2300096f' stroke-width='.232' d='M553.508 295.425a15.414 15.414 0 0 1-1.657 4.338c-.285.784-.413 1.591-.72 2.376-.413 1.22-.57 1.285-1.072 2.526a4.29 4.29 0 0 1-1.59 1.507c-.72.194-6.384-7.674-7.172-7.979m12.211-2.768a15.039 15.039 0 0 1-1.657 4.272c-.285.72-.413 1.591-.72 2.376a24.486 24.486 0 0 1-1.072 2.464 7.8 7.8 0 0 1-1.59 1.59c-.781.134-6.3-7.608-7.172-7.891'/%3e%3cpath fill='none' stroke='%23000b73' stroke-width='.232' d='M553.508 295.425a13.979 13.979 0 0 1-1.657 4.207c-.285.784-.413 1.59-.72 2.31-.5 1.221-.57 1.286-1.072 2.46a4.863 4.863 0 0 1-1.59 1.508c-.781.284-6.3-7.39-7.172-7.674m12.211-2.811a14.447 14.447 0 0 1-1.657 4.12 18.829 18.829 0 0 1-.787 2.31A15.639 15.639 0 0 1 550 304.32a4.164 4.164 0 0 1-1.507 1.439c-.782.28-6.3-7.24-7.172-7.544'/%3e%3cpath fill='none' stroke='%23000f75' stroke-width='.232' d='M553.508 295.425a14.077 14.077 0 0 1-1.657 4.054 18.829 18.829 0 0 1-.787 2.31 12.735 12.735 0 0 1-1.065 2.4 5.075 5.075 0 0 1-1.591 1.5c-.787.195-6.15-7.172-7.11-7.456m12.21-2.811a13.731 13.731 0 0 1-1.657 3.989 18.829 18.829 0 0 1-.787 2.31A16.482 16.482 0 0 1 550 304.1a5.648 5.648 0 0 1-1.591 1.441c-.787.195-6.15-7.021-7.11-7.325m12.21-2.791a13.731 13.731 0 0 1-1.657 3.989c-.285.719-.413 1.5-.787 2.244a9.145 9.145 0 0 1-1.155 2.312 4.813 4.813 0 0 1-1.5 1.437c-.787.285-6.15-6.887-7.11-7.17'/%3e%3cpath fill='none' stroke='%23001178' stroke-width='.232' d='M553.508 295.425a11.351 11.351 0 0 1-1.657 3.9c-.285.72-.413 1.5-.787 2.246a14.394 14.394 0 0 1-1.155 2.245 4.158 4.158 0 0 1-1.5 1.44c-.855.195-6.083-6.671-7.11-7.021m12.21-2.811a11.628 11.628 0 0 1-1.657 3.836 16.643 16.643 0 0 1-.787 2.159 11.872 11.872 0 0 1-1.155 2.31 3.962 3.962 0 0 1-1.5 1.37c-.855.284-6.083-6.514-7.11-6.885'/%3e%3cpath fill='none' stroke='%23001379' stroke-width='.232' d='M553.508 295.425a12.23 12.23 0 0 1-1.657 3.836c-.285.632-.413 1.373-.787 2.093a11.971 11.971 0 0 1-1.155 2.245 3.978 3.978 0 0 1-1.5 1.373c-.855.285-6.083-6.365-7.11-6.736m12.21-2.811a10.254 10.254 0 0 1-1.657 3.683 16.643 16.643 0 0 1-.787 2.159 10.706 10.706 0 0 1-1.155 2.158 3.972 3.972 0 0 1-1.5 1.374c-.938.284-6.021-6.235-7.11-6.584'/%3e%3cpath fill='none' stroke='%2300167c' stroke-width='.232' d='M553.508 295.425a10.966 10.966 0 0 1-1.657 3.683 21.962 21.962 0 0 1-.787 2.093 20.141 20.141 0 0 1-1.155 2.158 4.2 4.2 0 0 1-1.5 1.284c-.938.285-6.021-6.079-7.11-6.45m12.21-2.768a10.693 10.693 0 0 1-1.657 3.618c-.285.72-.5 1.373-.787 2.093a21.792 21.792 0 0 1-1.155 2.093 5.7 5.7 0 0 1-1.5 1.374c-1 .28-5.933-6.017-7.11-6.367'/%3e%3cpath fill='none' stroke='%2300187e' stroke-width='.232' d='M553.508 295.425a10.413 10.413 0 0 1-1.657 3.552c-.285.634-.5 1.374-.787 2.094a21.78 21.78 0 0 1-1.155 2.092 6.54 6.54 0 0 1-1.5 1.284c-1 .285-5.933-5.861-7.11-6.232m12.21-2.79a9.889 9.889 0 0 1-1.657 3.465c-.285.72-.5 1.373-.787 2.028a10.478 10.478 0 0 1-1.222 2.092 3.988 3.988 0 0 1-1.434 1.221c-1 .35-5.933-5.645-7.11-6.016m12.21-2.79a10.141 10.141 0 0 1-1.657 3.465c-.285.633-.5 1.286-.787 1.94a10.577 10.577 0 0 1-1.222 2.027 4.681 4.681 0 0 1-1.434 1.287c-1.072.28-5.866-5.58-7.11-5.93'/%3e%3cpath fill='none' stroke='%23001c82' stroke-width='.232' d='M553.508 295.425a9.384 9.384 0 0 1-1.657 3.4c-.285.566-.5 1.285-.787 1.94a9.4 9.4 0 0 1-1.222 1.94 4.678 4.678 0 0 1-1.434 1.286c-1.072.351-5.866-5.428-7.11-5.8m12.21-2.767a9.146 9.146 0 0 1-1.657 3.334c-.285.633-.5 1.286-.787 1.875a10.577 10.577 0 0 1-1.222 2.027 5.729 5.729 0 0 1-1.434 1.221c-1.072.284-5.866-5.21-7.11-5.646'/%3e%3cpath fill='none' stroke='%23001e85' stroke-width='.232' d='M553.508 295.425a9.675 9.675 0 0 1-1.657 3.334c-.285.567-.5 1.222-.787 1.81-.5 1-.72 1.068-1.222 2.026a5.446 5.446 0 0 1-1.434 1.157c-1.156.348-5.782-5.058-7.11-5.5m12.21-2.832a8.32 8.32 0 0 1-1.6 3.182c-.347.632-.564 1.286-.849 1.874-.5.939-.72 1.07-1.222 1.941a5.458 5.458 0 0 1-1.434 1.155c-1.223.35-5.782-4.926-7.11-5.362'/%3e%3cpath fill='none' stroke='%23002086' stroke-width='.232' d='M553.508 295.337a8.45 8.45 0 0 1-1.6 3.27c-.28.566-.564 1.22-.849 1.81-.5.937-.72 1-1.222 1.873a4.819 4.819 0 0 1-1.5 1.157c-1.157.349-5.649-4.775-7.022-5.211m12.188-2.9a8.022 8.022 0 0 1-1.6 3.184 19.133 19.133 0 0 1-.938 1.81 9.438 9.438 0 0 1-1.217 1.809 3.655 3.655 0 0 1-1.44 1.155c-1.155.349-5.647-4.622-7.02-5.058'/%3e%3cpath fill='none' stroke='%23002289' stroke-width='.232' d='M553.508 295.337a7.416 7.416 0 0 1-1.6 3.117 19.012 19.012 0 0 1-.938 1.81 9.445 9.445 0 0 1-1.217 1.81 4.371 4.371 0 0 1-1.44 1.068c-1.221.414-5.647-4.426-7.02-4.927m12.21-2.878a7.533 7.533 0 0 1-1.6 3.03 11.252 11.252 0 0 1-.938 1.722 9.445 9.445 0 0 1-1.217 1.81 4.615 4.615 0 0 1-1.44 1.155c-1.221.349-5.58-4.338-7.02-4.84m12.21-2.877a7.533 7.533 0 0 1-1.6 3.03 14.873 14.873 0 0 1-.938 1.657 8.809 8.809 0 0 1-1.217 1.81 5.488 5.488 0 0 1-1.44 1.067c-1.221.349-5.58-4.207-7.02-4.709'/%3e%3cpath fill='none' stroke='%2300258b' stroke-width='.232' d='M553.508 295.337a8.092 8.092 0 0 1-1.6 2.965c-.28.5-.564 1.068-.938 1.656a12.247 12.247 0 0 1-1.283 1.723 2.808 2.808 0 0 1-1.374 1c-1.289.414-5.58-3.99-7.02-4.49m12.21-2.857a6.468 6.468 0 0 1-1.6 2.9 16.767 16.767 0 0 1-.938 1.656 8.974 8.974 0 0 1-1.283 1.658 3.4 3.4 0 0 1-1.374 1.068c-1.289.414-5.514-3.9-7.02-4.426'/%3e%3cpath fill='none' stroke='%2300288f' stroke-width='.232' d='M553.508 295.337a7.207 7.207 0 0 1-1.6 2.9c-.28.5-.564 1-.938 1.592a6.923 6.923 0 0 1-1.283 1.592 4.121 4.121 0 0 1-1.374 1.067c-1.289.414-5.514-3.77-7.02-4.272m12.21-2.878a6.312 6.312 0 0 1-1.6 2.747 14.684 14.684 0 0 1-.938 1.656 12.941 12.941 0 0 1-1.283 1.592 6.127 6.127 0 0 1-1.374 1c-1.372.348-5.514-3.619-7.02-4.12'/%3e%3cpath fill='none' stroke='%23002b91' stroke-width='.232' d='M553.508 295.337a6.825 6.825 0 0 1-1.6 2.747 8.343 8.343 0 0 1-1 1.5c-.35.785-.72.938-1.221 1.657a4.389 4.389 0 0 1-1.374.938c-1.372.414-5.514-3.466-7.02-3.99m12.21-2.855a6.261 6.261 0 0 1-1.6 2.68 8.32 8.32 0 0 1-1 1.5c-.35.72-.72.85-1.221 1.592a5.885 5.885 0 0 1-1.374.938c-1.44.414-5.43-3.336-7.02-3.837'/%3e%3cpath fill='none' stroke='%23002d93' stroke-width='.232' d='M553.508 295.337a5.944 5.944 0 0 1-1.6 2.594 8.314 8.314 0 0 1-1 1.5c-.35.72-.72.85-1.221 1.5a5.791 5.791 0 0 1-1.374.937c-1.44.414-5.363-3.182-7.02-3.77m12.21-2.77a5.925 5.925 0 0 1-1.6 2.53 6.226 6.226 0 0 1-1 1.439 5.912 5.912 0 0 1-1.221 1.5 4.632 4.632 0 0 1-1.374 1c-1.44.348-5.363-3.117-7.02-3.685m12.21-2.79a6.344 6.344 0 0 1-1.6 2.463 6.231 6.231 0 0 1-1 1.44c-.35.718-.72.849-1.288 1.5a3.679 3.679 0 0 1-1.284.849c-1.507.5-5.363-2.811-7.021-3.466'/%3e%3cpath fill='none' stroke='%23002f96' stroke-width='.232' d='M553.508 295.337a5.644 5.644 0 0 1-1.6 2.463 8.414 8.414 0 0 1-1 1.373 8.6 8.6 0 0 1-1.288 1.439 8.021 8.021 0 0 1-1.284.938c-1.507.414-5.363-2.747-7.021-3.4m12.188-2.813a5.523 5.523 0 0 1-1.6 2.4 7.491 7.491 0 0 1-1 1.352 12.328 12.328 0 0 1-1.288 1.44 8.61 8.61 0 0 1-1.374.85c-1.44.414-5.206-2.594-6.954-3.25'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M553.508 295.337a4.922 4.922 0 0 1-1.6 2.31 7.573 7.573 0 0 1-1 1.374c-.413.566-.787.784-1.288 1.374a5.529 5.529 0 0 1-1.374.85c-1.5.413-5.206-2.463-6.954-3.118m12.211-2.79a5.137 5.137 0 0 1-1.6 2.245 5.434 5.434 0 0 1-1 1.286 8.547 8.547 0 0 1-1.288 1.374 5.529 5.529 0 0 1-1.374.85c-1.59.5-5.206-2.31-6.954-2.965'/%3e%3cpath fill='none' stroke='%2300359c' stroke-width='.232' d='M553.508 295.337a5.676 5.676 0 0 1-1.6 2.245 7.758 7.758 0 0 1-1 1.221 10.228 10.228 0 0 1-1.288 1.286 4.439 4.439 0 0 1-1.374.85c-1.59.415-5.145-2.157-6.954-2.812m12.211-2.79a5.409 5.409 0 0 1-1.6 2.158 12.478 12.478 0 0 1-1 1.221 10.162 10.162 0 0 1-1.278 1.284 6.743 6.743 0 0 1-1.374.785c-1.59.5-5.078-2.028-6.954-2.681'/%3e%3cpath fill='none' stroke='%2300389e' stroke-width='.232' d='M553.508 295.337a4.909 4.909 0 0 1-1.6 2.092 10.786 10.786 0 0 1-2.373 2.442 3.632 3.632 0 0 1-1.288.785c-1.658.5-5.08-1.874-6.955-2.53m12.211-2.79a4.819 4.819 0 0 1-1.6 2.028 5.663 5.663 0 0 1-1 1.222 9.844 9.844 0 0 1-1.373 1.22 4.729 4.729 0 0 1-1.288.72c-1.658.5-5.08-1.723-6.955-2.378m12.211-2.811a4.119 4.119 0 0 1-1.6 1.94 6.856 6.856 0 0 1-1 1.221c-.5.5-.787.632-1.373 1.155a4.728 4.728 0 0 1-1.288.72c-1.658.5-5.08-1.591-6.955-2.246'/%3e%3cpath fill='none' stroke='%230039a0' stroke-width='.232' d='M553.508 295.337a5 5 0 0 1-1.6 1.94 10.857 10.857 0 0 1-1 1.068 17.129 17.129 0 0 1-1.373 1.156 6 6 0 0 1-1.372.785c-1.658.5-4.928-1.44-6.892-2.16m12.232-2.79a5.111 5.111 0 0 1-1.6 1.876 10.857 10.857 0 0 1-1 1.068 7.639 7.639 0 0 1-1.373 1.069 2.636 2.636 0 0 1-1.372.718c-1.658.567-4.928-1.22-6.892-1.94'/%3e%3cpath fill='none' stroke='%23003ca2' stroke-width='.232' d='M553.508 295.337a4.325 4.325 0 0 1-1.6 1.81 10.857 10.857 0 0 1-1 1.068 16.026 16.026 0 0 1-1.373 1.068 7.731 7.731 0 0 1-1.372.72c-1.658.5-4.928-1.156-6.892-1.876m12.232-2.79a3.814 3.814 0 0 1-1.6 1.722 6.864 6.864 0 0 1-1.067 1.068c-.413.436-.786.633-1.283 1.069a11.459 11.459 0 0 1-1.378.632c-1.72.5-4.839-1-6.888-1.722'/%3e%3cpath fill='none' stroke='%23003ea6' stroke-width='.232' d='M553.508 295.337a4.3 4.3 0 0 1-1.6 1.722 12.242 12.242 0 0 1-1.067 1c-.413.413-.786.566-1.283 1a11.459 11.459 0 0 1-1.378.632c-1.72.566-4.839-.85-6.888-1.591m12.211-2.77a4.3 4.3 0 0 1-1.6 1.657c-.28.284-.631.633-1.067 1a11.54 11.54 0 0 1-1.372.939 3.925 3.925 0 0 1-1.29.63c-1.807.5-4.838-.718-6.887-1.438'/%3e%3cpath fill='none' stroke='%230042a8' stroke-width='.232' d='M553.508 295.337a5.3 5.3 0 0 1-1.508 1.592c-.345.282-.72.632-1.155.937a4.934 4.934 0 0 1-1.372.937 3.91 3.91 0 0 1-1.29.632c-1.807.567-4.77-.567-6.887-1.286m12.211-2.812a4.485 4.485 0 0 1-1.507 1.5 8.127 8.127 0 0 1-1.155.937c-.413.349-.847.567-1.372.938a8.714 8.714 0 0 1-1.29.567c-1.807.566-4.77-.415-6.887-1.156m12.211-2.79a4.809 4.809 0 0 1-1.507 1.443c-.345.282-.72.567-1.155.937a6.293 6.293 0 0 1-1.44.85c-.346.2-.781.414-1.221.633-1.87.5-4.7-.35-6.888-1.07'/%3e%3cpath fill='none' stroke='%230045ab' stroke-width='.232' d='M553.508 295.337a5.728 5.728 0 0 1-1.508 1.439c-.345.2-.72.5-1.155.785a7.333 7.333 0 0 1-1.44.937 7.7 7.7 0 0 1-1.221.5c-1.87.566-4.7-.132-6.954-.85m12.277-2.813a4.886 4.886 0 0 1-1.507 1.376 6.293 6.293 0 0 1-1.155.784 9.026 9.026 0 0 1-1.44.85 4.277 4.277 0 0 1-1.221.5c-1.87.632-4.7 0-6.954-.72'/%3e%3cpath fill='none' stroke='%230046ad' stroke-width='.232' d='M553.508 295.337a6.155 6.155 0 0 1-1.508 1.286c-.345.2-.72.567-1.155.785a5.666 5.666 0 0 1-1.44.784c-.346.2-.781.35-1.221.567-1.937.567-4.622.13-6.954-.632m12.277-2.79a5.257 5.257 0 0 1-1.507 1.22 12.838 12.838 0 0 1-1.155.786c-.413.282-.937.5-1.44.784-.346.131-.781.349-1.221.5a12.454 12.454 0 0 1-6.954-.5'/%3e%3cpath fill='none' stroke='%230049af' stroke-width='.232' d='M553.508 295.337a5.257 5.257 0 0 1-1.507 1.22c-.345.2-.72.415-1.155.72a8.875 8.875 0 0 1-1.44.72 7.791 7.791 0 0 1-1.221.5 12.543 12.543 0 0 1-6.954-.349m12.277-2.812a18.1 18.1 0 0 1-1.508 1.156 13.435 13.435 0 0 0-1.155.72c-.413.195-.937.414-1.44.632a7.791 7.791 0 0 1-1.221.5 11.889 11.889 0 0 1-6.954-.2'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M553.508 295.337A11.274 11.274 0 0 1 552 296.4c-.345.2-.72.415-1.155.633a8.955 8.955 0 0 1-1.44.719c-.434.13-.781.282-1.221.414a12.2 12.2 0 0 1-6.954-.065m12.277-2.77s-6.239 4.927-12.316 2.813'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M553.787 275.892s-1.216 7.913-1.718 9.07c-.351 1-2.9 5.491-6.737 6.516'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='M553.787 275.892s-1.283 7.825-1.808 8.915c-.413 1-2.745 5.364-6.669 6.671'/%3e%3cpath fill='none' stroke='%23000b73' stroke-width='.232' d='M553.726 275.825s-1.29 7.762-1.813 8.982c-.5 1-2.59 5.08-6.58 6.671'/%3e%3cpath fill='none' stroke='%23001379' stroke-width='.232' d='M553.726 275.825s-1.373 7.762-1.875 8.917a14.188 14.188 0 0 1-6.519 6.671'/%3e%3cpath fill='none' stroke='%2300187e' stroke-width='.232' d='M553.726 275.825s-1.506 7.674-2.031 8.765a14.624 14.624 0 0 1-6.385 6.8'/%3e%3cpath fill='none' stroke='%23002086' stroke-width='.232' d='M553.726 275.825s-1.59 7.609-2.093 8.765a16.056 16.056 0 0 1-6.3 6.8'/%3e%3cpath fill='none' stroke='%2300258b' stroke-width='.232' d='M553.66 275.825s-1.591 7.543-2.094 8.7a16.477 16.477 0 0 1-6.234 6.8'/%3e%3cpath fill='none' stroke='%23002b91' stroke-width='.232' d='M553.66 275.825s-1.747 7.457-2.244 8.634c-.5 1.068-1.814 3.9-6.15 6.889'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M553.66 275.825s-1.809 7.391-2.311 8.547c-.5 1.067-1.724 3.683-6.083 6.954'/%3e%3cpath fill='none' stroke='%2300389e' stroke-width='.232' d='M553.66 275.76s-1.876 7.456-2.462 8.547c-.5 1.067-1.506 3.4-5.933 7.02'/%3e%3cpath fill='none' stroke='%23003ea6' stroke-width='.232' d='M553.66 275.76s-1.943 7.326-2.528 8.48c-.5 1.069-1.374 3.184-5.866 7.02'/%3e%3cpath fill='none' stroke='%230046ad' stroke-width='.232' d='M553.57 275.76s-1.958 7.326-2.528 8.415c-.564 1.069-1.223 2.965-5.8 7.02'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M553.57 275.674s-2.026 7.324-2.68 8.393c-.568 1.068-1.07 2.747-5.646 7.106'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M553.291 271.03s-1.005 11.162-8.985 14.214'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='M553.224 271.03a23.494 23.494 0 0 1-2.026 7.02 13.486 13.486 0 0 1-6.892 7.171'/%3e%3cpath fill='none' stroke='%23000b73' stroke-width='.232' d='M553.224 271.03a27.881 27.881 0 0 1-2.092 7.02c-1.156 2.376-3.25 5.581-6.8 7.171'/%3e%3cpath fill='none' stroke='%23001379' stroke-width='.232' d='M553.224 271.03a28.01 28.01 0 0 1-2.16 6.888c-1.155 2.312-3.248 5.582-6.736 7.238'/%3e%3cpath fill='none' stroke='%2300187e' stroke-width='.232' d='M553.224 271.03a31.509 31.509 0 0 1-2.31 6.888c-1 2.093-3.12 5.494-6.586 7.173'/%3e%3cpath fill='none' stroke='%23002086' stroke-width='.232' d='M553.224 271.03a31.937 31.937 0 0 1-2.377 6.8c-.938 1.876-3.03 5.43-6.519 7.238'/%3e%3cpath fill='none' stroke='%2300258b' stroke-width='.232' d='M553.134 271.03a30.443 30.443 0 0 1-2.377 6.736 17.281 17.281 0 0 1-6.451 7.326'/%3e%3cpath fill='none' stroke='%23002b91' stroke-width='.232' d='M553.134 270.964a31.082 31.082 0 0 1-2.46 6.737c-.787 1.5-2.9 5.276-6.368 7.325'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M553.134 270.964a38.848 38.848 0 0 1-2.528 6.671c-.787 1.44-2.812 5.277-6.3 7.39'/%3e%3cpath fill='none' stroke='%2300389e' stroke-width='.232' d='M553.134 270.964a32.032 32.032 0 0 1-2.679 6.671c-.636 1.156-2.66 5.145-6.15 7.39'/%3e%3cpath fill='none' stroke='%23003ea6' stroke-width='.232' d='M553.134 270.964a42.188 42.188 0 0 1-2.745 6.605c-.57 1-2.6 5.06-6.083 7.391'/%3e%3cpath fill='none' stroke='%230046ad' stroke-width='.232' d='M553.073 270.964a35.012 35.012 0 0 1-2.751 6.519c-.5.785-2.528 4.992-6.016 7.455'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M553.073 270.964a33.861 33.861 0 0 1-2.9 6.453c-.413.633-2.377 4.993-5.864 7.543'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M553.224 267.913s-2.31 8.981-8.762 11.161'/%3e%3cpath fill='none' stroke='%2300056b' stroke-width='.232' d='M553.224 267.913a21.757 21.757 0 0 1-3.03 6.235 12.256 12.256 0 0 1-5.715 4.926'/%3e%3cpath fill='none' stroke='%2300096f' stroke-width='.232' d='M553.224 267.913a23.269 23.269 0 0 1-3.12 6.147c-1.44 2.093-3.465 4.273-5.642 4.993'/%3e%3cpath fill='none' stroke='%23000f75' stroke-width='.232' d='M553.134 267.848A24.628 24.628 0 0 1 550.1 274c-1.5 2.158-3.684 4.338-5.731 5.058'/%3e%3cpath fill='none' stroke='%2300167c' stroke-width='.232' d='M553.134 267.782a26.179 26.179 0 0 1-3.113 6.234c-1.6 2.093-3.773 4.426-5.648 5.058'/%3e%3cpath fill='none' stroke='%23001c82' stroke-width='.232' d='M553.134 267.782a25.588 25.588 0 0 1-3.247 6.083c-1.591 2.223-3.835 4.556-5.514 5.144'/%3e%3cpath fill='none' stroke='%23002086' stroke-width='.232' d='M553.134 267.782a23.348 23.348 0 0 1-3.334 6.018c-1.657 2.31-3.99 4.708-5.43 5.21'/%3e%3cpath fill='none' stroke='%2300258b' stroke-width='.232' d='M553.134 267.7a26.119 26.119 0 0 1-3.331 6.017c-1.724 2.31-4.124 4.84-5.43 5.275'/%3e%3cpath fill='none' stroke='%23002b91' stroke-width='.232' d='M553.134 267.7a25.9 25.9 0 0 1-3.465 5.929c-1.72 2.377-4.208 4.927-5.3 5.276'/%3e%3cpath fill='none' stroke='%23002f96' stroke-width='.232' d='M553.134 267.7a29.511 29.511 0 0 1-3.554 5.865c-1.808 2.376-4.336 5.055-5.207 5.361'/%3e%3cpath fill='none' stroke='%2300359c' stroke-width='.232' d='M553.134 267.63a32.289 32.289 0 0 1-3.616 5.864c-1.875 2.375-4.425 5.21-5.145 5.427'/%3e%3cpath fill='none' stroke='%23003ca2' stroke-width='.232' d='M553.073 267.63a32.112 32.112 0 0 1-3.556 5.864c-1.941 2.375-4.559 5.21-5.211 5.427'/%3e%3cpath fill='none' stroke='%230042a8' stroke-width='.232' d='M553.073 267.63a32.831 32.831 0 0 1-3.69 5.71c-1.873 2.53-4.62 5.43-5.077 5.582'/%3e%3cpath fill='none' stroke='%230046ad' stroke-width='.232' d='M553.073 267.564a30.862 30.862 0 0 1-3.772 5.711 50.451 50.451 0 0 1-5 5.646'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M553.073 267.476a31.911 31.911 0 0 1-3.84 5.712c-2.025 2.6-4.927 5.647-4.927 5.647m-8.439 1.35-4.425.786m3.99 2.55-3.99-1.656'/%3e%3cpath fill='none' stroke='%230045ab' stroke-width='.232' d='m535.935 280.251-4.426.72'/%3e%3cpath fill='none' stroke='%23003ca2' stroke-width='.232' d='m535.867 280.47-4.425.5'/%3e%3cpath fill='none' stroke='%2300359c' stroke-width='.232' d='m535.867 280.622-4.425.349'/%3e%3cpath fill='none' stroke='%23002d93' stroke-width='.232' d='m535.867 280.753-4.487.282'/%3e%3cpath fill='none' stroke='%2300258b' stroke-width='.232' d='m535.867 280.971-4.487.065'/%3e%3cpath fill='none' stroke='%23001e85' stroke-width='.232' d='m535.867 281.124-4.553-.066'/%3e%3cpath fill='none' stroke='%2300167c' stroke-width='.232' d='m535.867 281.276-4.62-.2'/%3e%3cpath fill='none' stroke='%23000f75' stroke-width='.232' d='m535.807 281.406-4.56-.282'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='m535.807 281.56-4.621-.415'/%3e%3cpath fill='none' stroke='%230045ab' stroke-width='.232' d='m535.522 283.3-4.058-1.5'/%3e%3cpath fill='none' stroke='%23003ca2' stroke-width='.232' d='m535.522 283.15-4.12-1.438'/%3e%3cpath fill='none' stroke='%2300359c' stroke-width='.232' d='m535.522 283.02-4.12-1.374'/%3e%3cpath fill='none' stroke='%23002d93' stroke-width='.232' d='m535.589 282.8-4.275-1.22'/%3e%3cpath fill='none' stroke='%2300258b' stroke-width='.232' d='m535.589 282.65-4.342-1.156'/%3e%3cpath fill='none' stroke='%23001e85' stroke-width='.232' d='m535.589 282.5-4.342-1.07'/%3e%3cpath fill='none' stroke='%2300167c' stroke-width='.232' d='m535.65 282.28-4.487-.851'/%3e%3cpath fill='none' stroke='%23000f75' stroke-width='.232' d='m535.717 282.061-4.554-.785'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='m535.717 281.93-4.621-.654'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='m535.717 281.777-4.71-.565'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.232' d='M548.49 310.508a4.938 4.938 0 0 0 1.81-2.154c.5-1.657.418-1.6.853-3.471.2-1.066.2-2.244.413-3.334.285-1.068 1.809-4.621 1.875-6.016.129-4.622 1.658-7.76 1.284-12.753-.28-3.9-1.155-9.2-.72-13.276a30.281 30.281 0 0 0-.061-3.467l-22.977 15.217'/%3e%3cpath fill='%23fc0' d='M554.161 264.883c.2-.85-.066-2.03-.72-2.157a2.156 2.156 0 0 0-.786-.068c-.347 0-.413.13-.565.436-.35.785.565 1.287 1.285 1.5.133.066.569.13.63.349.134.349.068.2.134.349-.134-.065-.134-.2-.285-.284-.5-.282-1-.348-1.74-.72-.5-.194-.57-1.372-.2-1.657a2.3 2.3 0 0 1 2.03 0 3.561 3.561 0 0 1 .5 2.682c0-.195-.285-.13-.285-.414'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M554.161 264.883c.2-.85-.066-2.03-.72-2.157a2.156 2.156 0 0 0-.786-.068c-.347 0-.413.13-.565.436-.35.785.565 1.287 1.285 1.5.133.066.569.13.63.349.134.349.068.2.134.349-.134-.065-.134-.2-.285-.284-.5-.282-1-.348-1.74-.72-.5-.194-.57-1.372-.2-1.657a2.3 2.3 0 0 1 2.03 0 3.561 3.561 0 0 1 .5 2.682c0-.195-.285-.13-.285-.414z'/%3e%3cpath fill='%23fc0' d='M554.53 265.318c.938 0 2.026.349 2.093.938a3.64 3.64 0 0 1 0 .85c-.068.349-.129.5-.5.567-.847.2-1.217-.784-1.373-1.5a1.511 1.511 0 0 0-.195-.72c-.346-.13-.285-.066-.346-.13a.835.835 0 0 1 .195.283c.2.5.285 1.068.5 1.81.13.567 1.218.784 1.591.436a2.194 2.194 0 0 0 .285-1.94 3.319 3.319 0 0 0-2.6-.939c.194.066.128.414.345.35'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M554.53 265.318c.938 0 2.026.349 2.093.938a3.64 3.64 0 0 1 0 .85c-.068.349-.129.5-.5.567-.847.2-1.217-.784-1.373-1.5a1.511 1.511 0 0 0-.195-.72c-.346-.13-.285-.066-.346-.13a.835.835 0 0 1 .195.283c.2.5.285 1.068.5 1.81.13.567 1.218.784 1.591.436a2.194 2.194 0 0 0 .285-1.94 3.319 3.319 0 0 0-2.6-.939c.194.066.128.414.345.35'/%3e%3cpath fill='%23fc0' d='M554.725 264.948a.551.551 0 0 1 .134.632c-.134.2-.5.283-.63.13a.59.59 0 0 1-.351-.85c.195-.282.568-.065.847.067'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M554.725 264.948a.551.551 0 0 1 .134.632c-.134.2-.5.283-.63.13a.59.59 0 0 1-.351-.85c.195-.282.568-.065.847.067z'/%3e%3cpath fill='%23fc0' d='M559.586 261.833a13.626 13.626 0 0 1-4.425 1 6.749 6.749 0 0 1-.5 2.226 6.57 6.57 0 0 1 2.6.065 9.614 9.614 0 0 1 2.31-3.334'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M559.586 261.833a13.626 13.626 0 0 1-4.425 1 6.749 6.749 0 0 1-.5 2.226 6.57 6.57 0 0 1 2.6.065 9.614 9.614 0 0 1 2.31-3.334z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M557.65 263.05a5.141 5.141 0 0 1-1.747.418 2.969 2.969 0 0 1-.2.848 2.909 2.909 0 0 1 1 .065 2.961 2.961 0 0 1 .938-1.354z'/%3e%3cpath fill='%23fc0' d='M554.53 266.823s-.414-.785-.565-1.068c-.066-.13.063.937-.35 1.068a4.964 4.964 0 0 0-.63 2.593 2.16 2.16 0 0 0 2.092.066c.346-.2.128-.784-.067-1.286a2.287 2.287 0 0 0-.413-1.374'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M554.53 266.823s-.414-.785-.565-1.068c-.066-.13.063.937-.35 1.068a4.964 4.964 0 0 0-.63 2.593 2.16 2.16 0 0 0 2.092.066c.346-.2.128-.784-.067-1.286a2.287 2.287 0 0 0-.413-1.374z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M554.1 266.19a4.308 4.308 0 0 1-.068.567c0-.2-.2.2-.279.284a5.548 5.548 0 0 0-.569 2.31m.7-2.092a6.863 6.863 0 0 0-.346 2.245l-.067-.065m.48-1.308a4.035 4.035 0 0 0-.195 1.373l.279.13'/%3e%3cpath fill='%23004bb3' d='M531.944 314.213c-1.875 1.658-5.274 2.528-5.86 2.97a10.84 10.84 0 0 1-6.084 2.31c-2.31.195-3.335-.419-5.646-.72-2.66-.285.283.128-2.223-.42a29.641 29.641 0 0 0-3.03-.93c-1.286-.352-2.6-.637-3.4-1.725a2.054 2.054 0 0 1-.634-1.44h-1.72c-.131.5.348 1.44.5 1.808a4.222 4.222 0 0 1 .415.659c.282.5.2.345.719.78a5.714 5.714 0 0 0 .785.632 2.418 2.418 0 0 0 1 .636 22.489 22.489 0 0 1 4.12 1.155c1.57.413.719.346 1.94.63a21.431 21.431 0 0 0 2.31.631c1.069.195 1.222.352 2.312.57a27.571 27.571 0 0 0 8.328.285 14.057 14.057 0 0 0 4.927-1.29c1.72-1.222 5.581-1.719 7.238-2.9a9.7 9.7 0 0 0 1.5-.854c1.59-1.373 2.963-1.72 4.71-2.813h-12.25'/%3e%3cpath fill='%23fff' d='M518.54 314.213c-1.222.636-1.81 1.658-5.21 2.746-1.287 0-2.748.57-3.99.5 1.526.352 1.526.57 2.747.854 2.528.563-.415.129 2.223.413 2.31.285 3.335.938 5.646.72a10.655 10.655 0 0 0 6.084-2.31c.563-.413 3.99-1.29 5.865-2.97H518.5'/%3e%3cpath fill='%23004bb3' d='M518.54 314.213h-13.56a2.13 2.13 0 0 0 .633 1.44c.784 1.072 2.091 1.374 3.4 1.724 1.373.28 2.812-.419 4.272-.419 3.554-1.064 3.99-2.242 5.211-2.745'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='M531.666 314.213s2.371.135 2.528.135c.127 0 9.7-.135 9.7-.135'/%3e%3cpath fill='none' stroke='%23000b73' stroke-width='.232' d='M531.666 314.28s2.31.129 2.59.2c.2.068 9.637-.127 9.637-.127'/%3e%3cpath fill='none' stroke='%23001379' stroke-width='.232' d='M531.666 314.37s2.31.195 2.59.279c.418 0 9.509-.279 9.509-.279'/%3e%3cpath fill='none' stroke='%2300187e' stroke-width='.232' d='M531.666 314.37s2.176.279 2.679.346c.5.133 9.352-.285 9.352-.285'/%3e%3cpath fill='none' stroke='%23002086' stroke-width='.232' d='M531.6 314.43s2.16.286 2.745.42c.631.128 9.264-.42 9.264-.42'/%3e%3cpath fill='none' stroke='%2300258b' stroke-width='.232' d='M531.6 314.43s2.092.42 2.812.57c.781.129 9.2-.5 9.2-.5'/%3e%3cpath fill='none' stroke='%23002b91' stroke-width='.232' d='M531.531 314.43s2.093.5 2.964.721c.854.195 8.985-.564 8.985-.564'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M531.531 314.5s2.027.569 2.964.786c1 .128 8.918-.72 8.918-.72'/%3e%3cpath fill='none' stroke='%2300389e' stroke-width='.232' d='M531.531 314.587s1.943.63 3.03.848c1.156.2 8.852-.786 8.852-.786'/%3e%3cpath fill='none' stroke='%23003ea6' stroke-width='.232' d='M531.531 314.587a28.846 28.846 0 0 0 3.12 1c1.155.2 8.634-.848 8.634-.848'/%3e%3cpath fill='none' stroke='%230046ad' stroke-width='.232' d='M531.531 314.649a16.306 16.306 0 0 0 3.181 1c1.29.285 8.483-.937 8.483-.937'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M544 314.213h-12.334'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M543.128 314.805s-6.954 1.284-8.416 1a16.527 16.527 0 0 1-3.248-1.155'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='M529.94 319.643s-4.491.631-4.642.631c-.067 0-2.528-.194-2.66-.194l-2.18-.5'/%3e%3cpath fill='none' stroke='%23001178' stroke-width='.232' d='M530.136 319.577s-4.554.72-4.838.636c-.2-.068-2.445-.2-2.594-.2-.13 0-2.029-.413-2.029-.413'/%3e%3cpath fill='none' stroke='%2300187e' stroke-width='.232' d='M530.443 319.447a44.022 44.022 0 0 1-5.145.632c-.285 0-2.377-.129-2.528-.129-.2 0-1.876-.434-1.876-.434'/%3e%3cpath fill='none' stroke='%23002086' stroke-width='.232' d='M530.66 319.292a45.409 45.409 0 0 1-5.43.72c-.345 0-2.16-.128-2.46-.128-.2-.068-1.658-.352-1.658-.352'/%3e%3cpath fill='none' stroke='%23002b91' stroke-width='.232' d='M530.946 319.23a48.6 48.6 0 0 1-5.715.721c-.413-.068-2.093-.134-2.377-.2-.28 0-1.5-.194-1.5-.194'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M531.163 319.074s-4.994 1-6.016.787c-.5-.067-1.875-.128-2.31-.194a10.29 10.29 0 0 1-1.289-.2'/%3e%3cpath fill='none' stroke='%230039a0' stroke-width='.232' d='M531.443 319.013s-5.14 1-6.3.781c-.57-.061-1.814-.195-2.249-.195q-.607-.084-1.22-.128'/%3e%3cpath fill='none' stroke='%230045ab' stroke-width='.232' d='M531.666 318.923s-5.213 1.066-6.52.787a14 14 0 0 0-2.248-.194 7.5 7.5 0 0 0-1-.069'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='m529.634 319.794-4.336.57-2.66-.134-2.311-.564'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M531.944 318.8s-5.362 1.155-6.887.848a17.608 17.608 0 0 0-2.964-.284m-11.4.09s-2.748-1-4.21-1.508a4.693 4.693 0 0 1-2.9-3.616m7.417 4.247s-1.656-.636-3.03-1.155c-3.77-1.44-3.335-3.185-3.335-3.185'/%3e%3cpath fill='none' stroke='%23003ca2' stroke-width='.232' d='M511.28 318.706s-2.245-.787-3.335-1.223a7.127 7.127 0 0 1-1.722-.78 4.09 4.09 0 0 1-1.286-1.222 2.932 2.932 0 0 1-.415-1.223'/%3e%3cpath fill='none' stroke='%23002d93' stroke-width='.232' d='M511.5 318.923s-2.747-1-3.553-1.372a11.133 11.133 0 0 1-1.722-.72 14 14 0 0 1-1.374-1.156 9.457 9.457 0 0 1-.414-1.44'/%3e%3cpath fill='none' stroke='%23001e85' stroke-width='.232' d='M511.781 319.074s-3.335-1.155-3.836-1.373q-.858-.368-1.722-.72c-.2-.128-1.286-1.066-1.44-1.217a11.676 11.676 0 0 1-.435-1.506'/%3e%3cpath fill='none' stroke='%23000f75' stroke-width='.232' d='M512 319.292s-3.837-1.373-4.054-1.5c-.2-.069-1.592-.57-1.657-.632a15.145 15.145 0 0 1-1.5-1.222c-.066-.134-.567-1.59-.567-1.59'/%3e%3cpath fill='none' stroke='%23003ca2' stroke-width='.232' d='M511 319.447s-3.334-1.221-4.49-1.656a5.1 5.1 0 0 1-2.027-1.507 5.616 5.616 0 0 1-.785-1.936'/%3e%3cpath fill='none' stroke='%23002d93' stroke-width='.232' d='M511.346 319.447s-4.056-1.438-4.927-1.807a5.436 5.436 0 0 1-1.875-1.44 7.108 7.108 0 0 1-.785-1.875'/%3e%3cpath fill='none' stroke='%23001e85' stroke-width='.232' d='M511.65 319.516s-4.708-1.814-5.21-1.943a7.673 7.673 0 0 1-1.809-1.373 7.313 7.313 0 0 1-.719-1.875'/%3e%3cpath fill='none' stroke='%23000f75' stroke-width='.232' d='M511.934 319.516s-5.276-2.033-5.582-2.094a12.1 12.1 0 0 1-1.721-1.289c-.13-.195-.633-1.808-.633-1.808'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='m512.218 319.516-5.93-2.25-1.592-1.222-.566-1.719'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='M505.328 314.213s2.53.135 2.682.135c.13 0 10.071-.135 10.071-.135'/%3e%3cpath fill='none' stroke='%23000b73' stroke-width='.232' d='M505.328 314.28s2.464.129 2.682.2c.283.068 10-.127 10-.127'/%3e%3cpath fill='none' stroke='%23001379' stroke-width='.232' d='M505.263 314.37s2.441.195 2.813.279c.348 0 9.853-.279 9.853-.279'/%3e%3cpath fill='none' stroke='%2300187e' stroke-width='.232' d='M505.263 314.37s2.377.279 2.9.346c.5.133 9.7-.285 9.7-.285'/%3e%3cpath fill='none' stroke='%23002086' stroke-width='.232' d='M505.263 314.43s2.223.286 2.9.42c.633.128 9.635-.42 9.635-.42'/%3e%3cpath fill='none' stroke='%2300258b' stroke-width='.232' d='M505.263 314.43s2.158.42 2.965.57c.72.129 9.5-.5 9.5-.5'/%3e%3cpath fill='none' stroke='%23002b91' stroke-width='.232' d='M505.177 314.43s2.157.5 3.03.721c.936.195 9.416-.564 9.416-.564'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M505.177 314.5s2.092.569 3.117.786c1 .128 9.264-.72 9.264-.72'/%3e%3cpath fill='none' stroke='%2300389e' stroke-width='.232' d='M505.177 314.587s2 .63 3.117.848c1.155.2 9.2-.786 9.2-.786'/%3e%3cpath fill='none' stroke='%23003ea6' stroke-width='.232' d='M505.177 314.587a32.2 32.2 0 0 0 3.182 1c1.286.2 9.07-.848 9.07-.848'/%3e%3cpath fill='none' stroke='%230046ad' stroke-width='.232' d='M505.177 314.649a15.46 15.46 0 0 0 3.247 1c1.374.285 8.917-.937 8.917-.937'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M518.169 314.213h-12.754'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M517.23 314.805s-7.171 1.284-8.7 1a17.741 17.741 0 0 1-3.4-1.155'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.232' d='M503.214 314.213c-.131.5.348 1.44.5 1.814a4.215 4.215 0 0 1 .415.653c.283.5.195.346.72.781a5.943 5.943 0 0 0 .783.636 2.481 2.481 0 0 0 1 .631 22.871 22.871 0 0 1 4.12 1.156c1.569.413.72.346 1.94.63a20.545 20.545 0 0 0 2.31.63c1.07.2 1.221.352 2.311.57a27.56 27.56 0 0 0 8.326.285 13.908 13.908 0 0 0 4.927-1.29c1.724-1.216 5.582-1.718 7.238-2.9a9.013 9.013 0 0 0 1.508-.854c1.59-1.373 2.962-1.719 4.7-2.807'/%3e%3cpath fill='%23fff' d='M474.721 277.2c-1.438-3.554-2.964-10.944-2.9-12.623.349-6.89.2-8.984.85-16.087l7.172 8.2a23.291 23.291 0 0 0 0 5.274 26.769 26.769 0 0 0 .939 4.993l-6.082 10.221'/%3e%3cpath fill='%23004bb3' d='M480.8 266.975a28.277 28.277 0 0 1-.938-4.991 23.413 23.413 0 0 1 0-5.274l4.339 4.838-3.4 5.427m-18.2 6.671c-.065-1.591-.2-3.335-.2-4.12 0-4.992-.567-7.76 0-13.056.414-4.125 1.439-9.638 1.22-14.064a36.124 36.124 0 0 1 .2-3.773l8.85 9.857c-.63 7.1-.5 9.2-.849 16.087-.065 1.657 1.44 9.07 2.9 12.622l-1.875 3.183-10.224-6.736'/%3e%3cpath fill='%23fc0' d='m484.858 260.9-20.817-23.07-.415.5 20.6 23.194.632-.63'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='m484.858 260.9-20.817-23.07-.415.5 20.6 23.194.632-.63'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M464.258 244.259s1.656 14.565 7.325 14'/%3e%3cpath fill='none' stroke='%2300056b' stroke-width='.232' d='M471.583 258.188c-2.813.135-4.71-3.465-5.712-6.8a53.357 53.357 0 0 1-1.592-7.177'/%3e%3cpath fill='none' stroke='%23000b73' stroke-width='.232' d='M471.583 258.188c-2.813-.128-4.71-3.773-5.647-6.887a42.121 42.121 0 0 1-1.657-7.11'/%3e%3cpath fill='none' stroke='%23001178' stroke-width='.232' d='M471.67 258.127c-2.9-.2-4.774-3.99-5.712-6.96a59.13 59.13 0 0 1-1.656-7.013'/%3e%3cpath fill='none' stroke='%2300167c' stroke-width='.232' d='M471.67 258.06c-2.9-.413-4.774-4.209-5.647-6.954a67.931 67.931 0 0 1-1.744-7.02'/%3e%3cpath fill='none' stroke='%23001e85' stroke-width='.232' d='M471.67 257.971c-2.9-.564-4.774-4.487-5.582-6.953a70.184 70.184 0 0 1-1.809-7.018'/%3e%3cpath fill='none' stroke='%23002289' stroke-width='.232' d='M471.67 257.971c-2.812-.781-4.774-4.771-5.515-7.02a46.1 46.1 0 0 1-1.788-6.951'/%3e%3cpath fill='none' stroke='%2300288f' stroke-width='.232' d='M471.736 257.91c-2.9-.938-4.84-5-5.582-7.11a50.891 50.891 0 0 1-1.787-6.888'/%3e%3cpath fill='none' stroke='%23002d93' stroke-width='.232' d='M471.736 257.91c-2.9-1.223-4.84-5.28-5.43-7.178a36.75 36.75 0 0 1-1.939-6.886'/%3e%3cpath fill='none' stroke='%2300359c' stroke-width='.232' d='M471.736 257.754c-2.813-1.284-4.84-5.426-5.43-7.105a41.4 41.4 0 0 1-1.939-6.892'/%3e%3cpath fill='none' stroke='%230039a0' stroke-width='.232' d='M471.736 257.754c-2.813-1.5-4.84-5.8-5.364-7.172a42.026 42.026 0 0 1-2-6.8'/%3e%3cpath fill='none' stroke='%23003ea6' stroke-width='.232' d='M471.736 257.686c-2.813-1.652-4.84-6.016-5.277-7.17a44.031 44.031 0 0 1-2.092-6.8'/%3e%3cpath fill='none' stroke='%230046ad' stroke-width='.232' d='M471.8 257.686c-2.9-1.875-4.926-6.295-5.362-7.322a49.254 49.254 0 0 1-2.092-6.735'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M464.346 243.606a39.674 39.674 0 0 0 2.157 6.67c.35.785 2.377 5.211 5.275 7.237'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M464.476 240.927s4.708 11.6 7.76 10.285'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='M472.236 251.235c-1.286.569-3.248-1.719-4.84-4.487q-1.571-2.839-2.9-5.8'/%3e%3cpath fill='none' stroke='%23001178' stroke-width='.232' d='M472.236 251.169c-1.155.5-3.182-1.653-4.773-4.488q-1.6-2.835-2.965-5.8'/%3e%3cpath fill='none' stroke='%2300187e' stroke-width='.232' d='M472.236 251.169c-1 .44-3.117-1.653-4.773-4.555-1.81-3.248-2.9-5.708-2.9-5.708'/%3e%3cpath fill='none' stroke='%23002086' stroke-width='.232' d='M472.236 251.169c-.784.283-3.03-1.653-4.621-4.622-1.962-3.4-3.03-5.708-3.03-5.708'/%3e%3cpath fill='none' stroke='%23002b91' stroke-width='.232' d='M472.236 251.084c-.632.285-2.964-1.59-4.621-4.62-1.962-3.556-3.03-5.715-3.03-5.715'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M472.236 251.084c-.5.195-2.9-1.59-4.556-4.777-2.027-3.617-3.117-5.642-3.117-5.642'/%3e%3cpath fill='none' stroke='%230039a0' stroke-width='.232' d='M472.236 251.084c-.282.128-2.812-1.59-4.556-4.838-2.027-3.84-3.03-5.582-3.03-5.582'/%3e%3cpath fill='none' stroke='%230045ab' stroke-width='.232' d='M472.236 251.084a12.192 12.192 0 0 1-4.49-4.838c-2.093-4.057-3.118-5.648-3.118-5.648'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M464.628 240.576a47.8 47.8 0 0 1 3.117 5.49 13.028 13.028 0 0 0 4.491 4.93m7.63 8 3.9 2.16m-3.684 1.612 3.684-.636'/%3e%3cpath fill='none' stroke='%230045ab' stroke-width='.232' d='m479.715 259.215 4.053 1.943'/%3e%3cpath fill='none' stroke='%23003ca2' stroke-width='.232' d='m479.715 259.366 4.119 1.875'/%3e%3cpath fill='none' stroke='%2300359c' stroke-width='.232' d='m479.715 259.583 4.119 1.658'/%3e%3cpath fill='none' stroke='%23002d93' stroke-width='.232' d='m479.78 259.718 4.12 1.59'/%3e%3cpath fill='none' stroke='%2300258b' stroke-width='.232' d='m479.78 259.868 4.12 1.44'/%3e%3cpath fill='none' stroke='%23001e85' stroke-width='.232' d='m479.78 260.086 4.207 1.223'/%3e%3cpath fill='none' stroke='%2300167c' stroke-width='.232' d='m479.78 260.237 4.207 1.154'/%3e%3cpath fill='none' stroke='%23000f75' stroke-width='.232' d='m479.78 260.46 4.272.931'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='m479.78 260.589 4.272.847'/%3e%3cpath fill='none' stroke='%230045ab' stroke-width='.232' d='m480.085 262.615 3.683-.565'/%3e%3cpath fill='none' stroke='%23003ca2' stroke-width='.232' d='m480.085 262.4 3.771-.413'/%3e%3cpath fill='none' stroke='%2300359c' stroke-width='.232' d='m480 262.178 3.9-.284'/%3e%3cpath fill='none' stroke='%23002d93' stroke-width='.232' d='m480 262.05 3.9-.134'/%3e%3cpath fill='none' stroke='%2300258b' stroke-width='.232' d='M479.931 261.833h4.056'/%3e%3cpath fill='none' stroke='%23001e85' stroke-width='.232' d='m479.931 261.615 4.056.128'/%3e%3cpath fill='none' stroke='%2300167c' stroke-width='.232' d='m479.931 261.391 4.12.286'/%3e%3cpath fill='none' stroke='%23000f75' stroke-width='.232' d='m479.931 261.241 4.209.351'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='m479.931 261.023 4.274.57'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='m479.866 260.806 4.339.72'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.232' d='M462.6 273.646c-.064-1.155-.13-2.377-.13-3.117.066-4.993-.633-8.764-.065-14.06.414-4.124 1.439-9.637 1.22-14.063a36.124 36.124 0 0 1 .2-3.773l20.384 22.915'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M462.6 261.894a13.9 13.9 0 0 0 .938 4.34c.938 1.875 3.772 4.621 7.02 6.671'/%3e%3cpath fill='none' stroke='%2300056b' stroke-width='.232' d='M470.645 272.926a27.9 27.9 0 0 1-5.276-4.49 18.456 18.456 0 0 1-1.722-2.245 17.978 17.978 0 0 1-.937-4.336'/%3e%3cpath fill='none' stroke='%23000b73' stroke-width='.232' d='M470.733 272.926a28.179 28.179 0 0 1-5.276-4.621 10.667 10.667 0 0 1-1.592-2.158 15.28 15.28 0 0 1-1.134-4.337'/%3e%3cpath fill='none' stroke='%23001178' stroke-width='.232' d='M470.8 272.926a27.907 27.907 0 0 1-5.21-4.621 22.114 22.114 0 0 1-1.656-2.31 16.553 16.553 0 0 1-1.221-4.34'/%3e%3cpath fill='none' stroke='%2300167c' stroke-width='.232' d='M470.863 272.861a31.353 31.353 0 0 1-5.21-4.621 16.624 16.624 0 0 1-1.59-2.311 19.942 19.942 0 0 1-1.353-4.336'/%3e%3cpath fill='none' stroke='%23001e85' stroke-width='.232' d='M470.95 272.861a33.516 33.516 0 0 1-5.144-4.709 16.715 16.715 0 0 1-1.592-2.31 19.369 19.369 0 0 1-1.439-4.339'/%3e%3cpath fill='none' stroke='%23002289' stroke-width='.232' d='M471.016 272.861a30.149 30.149 0 0 1-5.058-4.84 12.208 12.208 0 0 1-1.591-2.244 19.643 19.643 0 0 1-1.592-4.34'/%3e%3cpath fill='none' stroke='%2300288f' stroke-width='.232' d='M471.08 272.861a35.725 35.725 0 0 1-4.99-4.926 16.618 16.618 0 0 1-1.658-2.246 22.971 22.971 0 0 1-1.656-4.337'/%3e%3cpath fill='none' stroke='%23002d93' stroke-width='.232' d='M471.169 272.861a35.784 35.784 0 0 1-4.993-4.991 20.963 20.963 0 0 1-1.592-2.246 25.281 25.281 0 0 1-1.809-4.338'/%3e%3cpath fill='none' stroke='%2300359c' stroke-width='.232' d='M471.234 272.861a45.024 45.024 0 0 1-4.927-5.058 13.574 13.574 0 0 1-1.591-2.31 24.962 24.962 0 0 1-1.94-4.335'/%3e%3cpath fill='none' stroke='%230039a0' stroke-width='.232' d='M471.3 272.861a41.287 41.287 0 0 1-4.84-5.144 16.953 16.953 0 0 1-1.592-2.311 39.447 39.447 0 0 1-2.093-4.338'/%3e%3cpath fill='none' stroke='%23003ea6' stroke-width='.232' d='M471.386 272.861c-1.962-1.5-3.77-4.12-4.774-5.21a14.617 14.617 0 0 1-1.657-2.31c-1.068-1.873-2.158-4.34-2.158-4.34'/%3e%3cpath fill='none' stroke='%230046ad' stroke-width='.232' d='M471.452 272.774c-1.94-1.5-3.772-4.12-4.774-5.21a15.13 15.13 0 0 1-1.5-2.311c-1.221-1.942-2.377-4.335-2.377-4.335'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M462.754 260.806a60.413 60.413 0 0 0 4.054 6.67c.937 1 2.813 3.772 4.71 5.277'/%3e%3cpath fill='none' stroke='%2300004b' stroke-width='.232' d='M462.82 273.646c3.029 2.028 3.77 2.528 10 6.518l1.88-2.964s-.72-1.656-1-2.528'/%3e%3cpath fill='none' stroke='%2300004f' stroke-width='.232' d='M462.884 273.646c2.9 1.94 3.837 2.528 9.94 6.365l.066-.065 1.657-2.812a3.29 3.29 0 0 0-.283-.784q-.312-.819-.567-1.657'/%3e%3cpath fill='none' stroke='%23000053' stroke-width='.232' d='M462.884 273.646c2.747 1.876 3.99 2.681 9.94 6.3l.066-.13c0-.066 1.592-2.813 1.592-2.813s-.066-.282-.2-.719c-.2-.5-.414-1.156-.567-1.591'/%3e%3cpath fill='none' stroke='%23000056' stroke-width='.232' d='M462.884 273.646c2.681 1.723 4.208 2.681 9.94 6.147l.066-.13c0-.066 1.439-2.747 1.439-2.747a1.962 1.962 0 0 0-.195-.72c-.132-.5-.35-1.068-.415-1.5'/%3e%3cpath fill='none' stroke='%23000058' stroke-width='.232' d='M462.884 273.581c2.616 1.722 4.338 2.811 9.94 6.082l.066-.066c0-.13 1.373-2.812 1.373-2.812a2.561 2.561 0 0 0-.13-.632 6.929 6.929 0 0 1-.414-1.439'/%3e%3cpath fill='none' stroke='%2300005c' stroke-width='.232' d='M462.884 273.581c2.53 1.656 4.491 2.9 9.94 6.016l.066-.13c0-.2 1.287-2.812 1.287-2.812a1.9 1.9 0 0 0-.132-.567 5.377 5.377 0 0 1-.348-1.374'/%3e%3cpath fill='none' stroke='%23000060' stroke-width='.232' d='M462.884 273.581c2.464 1.59 4.71 2.964 9.94 5.864l.132-.131c0-.2 1.068-2.747 1.068-2.747a.945.945 0 0 0-.065-.566 4.55 4.55 0 0 1-.284-1.286'/%3e%3cpath fill='none' stroke='%23000062' stroke-width='.232' d='M462.884 273.581c2.4 1.5 4.84 2.964 9.94 5.712l.132-.132c0-.2 1-2.747 1-2.747s.065-.13-.066-.5a11.292 11.292 0 0 1-.283-1.221'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M462.884 273.581c2.246 1.439 4.993 3.03 9.94 5.646l.132-.131c0-.283.937-2.747.85-2.747 0 0 .131-.13 0-.5a6.88 6.88 0 0 1-.2-1.155'/%3e%3cpath fill='none' stroke='%2300056b' stroke-width='.232' d='M462.972 273.516a90.978 90.978 0 0 0 9.853 5.58l.131-.13c0-.283.785-2.748.785-2.748s.13-.065 0-.414a2.821 2.821 0 0 1-.131-1.068'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='M462.972 273.516a72.127 72.127 0 0 0 9.853 5.427c.065 0 .131-.13.131-.13 0-.35.72-2.682.72-2.682a.446.446 0 0 0 .065-.414 1.693 1.693 0 0 1-.131-1'/%3e%3cpath fill='none' stroke='%2300096f' stroke-width='.232' d='M462.972 273.516a76.1 76.1 0 0 0 9.853 5.362c.065-.066.131-.131.131-.195 0-.285.567-2.595.567-2.595a.407.407 0 0 0 .13-.436 2.145 2.145 0 0 1-.13-.938'/%3e%3cpath fill='none' stroke='%23000b73' stroke-width='.232' d='M463.037 273.516a74.825 74.825 0 0 0 9.788 5.21l.131-.132c0-.414.5-2.68.5-2.68s.195-.066.13-.35a1.82 1.82 0 0 1-.065-.85'/%3e%3cpath fill='none' stroke='%23001178' stroke-width='.232' d='M463.037 273.516a69.139 69.139 0 0 0 9.788 5.078l.131-.13c0-.436.414-2.595.349-2.681 0 0 .349-.066.2-.284-.13-.349 0-.349 0-.785'/%3e%3cpath fill='none' stroke='%23001379' stroke-width='.232' d='M463.037 273.516a64.264 64.264 0 0 0 9.853 4.991l.066-.195c0-.415.349-2.6.283-2.6 0 0 .284-.065.2-.283-.13-.284 0-.284.066-.72'/%3e%3cpath fill='none' stroke='%2300167c' stroke-width='.232' d='M463.037 273.428a47.808 47.808 0 0 0 9.853 4.927c.066 0 .066-.2.066-.2 0-.414.2-2.53.2-2.595 0 0 .283 0 .2-.195-.13-.284.066-.284.131-.634'/%3e%3cpath fill='none' stroke='%23001c82' stroke-width='.232' d='M463.037 273.428a46.134 46.134 0 0 0 9.853 4.773c.066 0 .066-.13.066-.13 0-.5.13-2.594.065-2.681 0 0 .414.065.283-.13-.064-.284.131-.2.2-.567'/%3e%3cpath fill='none' stroke='%23001e85' stroke-width='.232' d='M463.037 273.363a45.7 45.7 0 0 0 9.853 4.773c.066-.064.066-.2.131-.2 0-.566-.065-2.529-.065-2.594 0 0 .349.065.283-.13-.065-.283.131-.13.284-.5'/%3e%3cpath fill='none' stroke='%23002086' stroke-width='.232' d='M463.037 273.363c1.286.85 6.518 3.836 9.853 4.621.066-.065.066-.13.131-.2a21.567 21.567 0 0 0-.2-2.594s.415.13.415-.066c-.132-.195.065-.065.282-.414'/%3e%3cpath fill='none' stroke='%2300258b' stroke-width='.232' d='M463.037 273.363c1.22.785 6.649 3.9 9.853 4.49.066 0 .131-.13.131-.195a15.021 15.021 0 0 0-.282-2.53s.5.066.413-.065c-.13-.195.13 0 .349-.349'/%3e%3cpath fill='none' stroke='%2300288f' stroke-width='.232' d='M463.1 273.363c1 .719 6.735 3.989 9.787 4.425.066-.065.131-.13.131-.2a24.235 24.235 0 0 0-.35-2.53s.5.066.351-.065c0-.195.283.066.413-.282'/%3e%3cpath fill='none' stroke='%23002b91' stroke-width='.232' d='M463.1 273.363c.937.632 6.888 4.054 9.787 4.272.066-.065.131-.13.131-.195a11.133 11.133 0 0 0-.5-2.53s.5.131.5 0c-.065-.2.283.131.414-.2'/%3e%3cpath fill='none' stroke='%23002d93' stroke-width='.232' d='M463.1 273.363c.85.5 7.106 4.054 9.853 4.207 0-.13.065-.2.065-.282a11.628 11.628 0 0 0-.567-2.53s.567.131.5.066c-.066-.2.283.195.5-.131'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M463.1 273.3c.784.5 7.238 4.207 9.853 4.12 0-.066.065-.2.065-.284a7.429 7.429 0 0 0-.72-2.463s.634.13.567 0c-.065-.065.35.349.567 0'/%3e%3cpath fill='none' stroke='%2300359c' stroke-width='.232' d='M463.1 273.3c.718.5 7.39 4.272 9.853 3.989 0-.066.065-.13.065-.2a8.225 8.225 0 0 0-.785-2.529s.567.195.567.13c-.065-.13.414.35.633 0'/%3e%3cpath fill='none' stroke='%2300389e' stroke-width='.232' d='M463.1 273.3c.632.348 7.608 4.337 9.853 3.836a.655.655 0 0 0 .065-.195 7.635 7.635 0 0 0-.85-2.465v-.065s.633.283.567.2c0-.132.414.414.72.065'/%3e%3cpath fill='none' stroke='%23003ca2' stroke-width='.232' d='M463.1 273.3c.5.282 7.76 4.337 9.853 3.77a.422.422 0 0 0 .065-.282 7.132 7.132 0 0 0-1-2.465s.72.285.633.2c0-.13.5.5.784.13'/%3e%3cpath fill='none' stroke='%23003ea6' stroke-width='.232' d='M463.168 273.3c.349.195 7.826 4.425 9.788 3.619.065-.067.065-.2.13-.284a8.378 8.378 0 0 0-1.155-2.464s.72.35.72.2c-.066 0 .5.633.784.284'/%3e%3cpath fill='none' stroke='%230042a8' stroke-width='.232' d='M463.168 273.3c.282.13 7.978 4.49 9.788 3.552a1.773 1.773 0 0 1 .13-.282 6.175 6.175 0 0 0-1.286-2.47s.784.285.719.285c0-.067.567.567.938.282'/%3e%3cpath fill='none' stroke='%230045ab' stroke-width='.232' d='M463.168 273.21c.2.13 8.109 4.621 9.788 3.466.065-.065.065-.13.13-.283 0-.85-1.285-2.311-1.373-2.377l.785.284c-.065-.065.567.633.85.349'/%3e%3cpath fill='none' stroke='%230049af' stroke-width='.232' d='M463.168 273.21c.13.065 8.327 4.709 9.788 3.335a.35.35 0 0 0 .13-.282c0-.938-1.373-2.312-1.5-2.377l.85.283s.566.786.937.5'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M463.255 273.146s9.417 5.361 9.853 2.963c0-.937-1.59-2.31-1.59-2.31l.85.283s.631.85 1 .567'/%3e%3cpath fill='%23fc0' d='M464.258 237.808c0-.938.5-2.026 1.155-2.026a4.925 4.925 0 0 1 .785.061c.35.134.414.285.5.636.132.781-.85 1.066-1.59 1.156-.2 0-.72-.068-.786.128-.2.285-.065.195-.2.285a.429.429 0 0 0 .283-.135c.633-.127 1.155-.127 1.94-.278.5-.068.85-1.156.567-1.591-.283-.351-1.591-.72-1.962-.42a3.15 3.15 0 0 0-1.155 2.468c.065-.194.349-.067.414-.284'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M464.258 237.808c0-.938.5-2.026 1.155-2.026a4.925 4.925 0 0 1 .785.061c.35.134.414.285.5.636.132.781-.85 1.066-1.59 1.156-.2 0-.72-.068-.786.128-.2.285-.065.195-.2.285a.429.429 0 0 0 .283-.135c.633-.127 1.155-.127 1.94-.278.5-.068.85-1.156.567-1.591-.283-.351-1.591-.72-1.962-.42a3.15 3.15 0 0 0-1.155 2.468c.065-.194.349-.067.414-.284z'/%3e%3cpath fill='%23fc0' d='M463.756 238.092c-.85-.284-2.006-.134-2.223.413a5.648 5.648 0 0 0-.2.787.68.68 0 0 0 .437.715c.632.35 1.286-.5 1.57-1.156a1.483 1.483 0 0 1 .413-.714c.349-.068.284 0 .349-.068-.065.13-.2.2-.283.285-.284.5-.5.938-.938 1.653a1.154 1.154 0 0 1-1.656.067 2.252 2.252 0 0 1 .283-2.026 2.822 2.822 0 0 1 2.66-.195c-.131-.068-.2.284-.415.195'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M463.756 238.092c-.85-.284-2.006-.134-2.223.413a3.882 3.882 0 0 0-.2.787.68.68 0 0 0 .437.715c.632.35 1.286-.5 1.57-1.156a1.483 1.483 0 0 1 .413-.714c.349-.068.284 0 .349-.068-.065.13-.2.2-.283.285-.284.5-.5.938-.938 1.653a1.154 1.154 0 0 1-1.656.067 2.252 2.252 0 0 1 .283-2.026 2.822 2.822 0 0 1 2.66-.195c-.131-.068-.2.284-.415.195z'/%3e%3cpath fill='%23fc0' d='M463.69 237.673c-.282 0-.348.42-.282.637 0 .194.348.345.566.284a.748.748 0 0 0 .567-.786c-.13-.352-.567-.195-.85-.135'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M463.69 237.673c-.282 0-.348.42-.282.637 0 .194.348.345.566.284a.748.748 0 0 0 .567-.786c-.13-.352-.567-.195-.85-.135'/%3e%3cpath fill='%23fc0' d='M459.68 233.532a15.319 15.319 0 0 0 3.99 2.032 5.785 5.785 0 0 0 0 2.244 5.536 5.536 0 0 0-2.53-.5 9.844 9.844 0 0 0-1.438-3.773'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M459.68 233.532a15.319 15.319 0 0 0 3.99 2.032 5.785 5.785 0 0 0 0 2.244 5.536 5.536 0 0 0-2.53-.5 9.844 9.844 0 0 0-1.438-3.773z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M461.294 235.19a5.7 5.7 0 0 0 1.59.787 1.8 1.8 0 0 0 0 .848 2.815 2.815 0 0 0-1-.128 3.466 3.466 0 0 0-.566-1.507z'/%3e%3cpath fill='%23fc0' d='M463.386 239.549a11.331 11.331 0 0 0 .85-.937c.065-.129-.35.937.065 1.221a5.388 5.388 0 0 1 0 2.595 2.232 2.232 0 0 1-2.026-.345c-.284-.285.065-.855.282-1.29a5.224 5.224 0 0 1 .785-1.222'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M463.386 239.549a11.331 11.331 0 0 0 .85-.937c.065-.129-.35.937.065 1.221a5.388 5.388 0 0 1 0 2.595 2.232 2.232 0 0 1-2.026-.345c-.284-.285.065-.855.282-1.29a5.224 5.224 0 0 1 .785-1.222z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M463.974 239.113c0 .068-.065.42-.065.5.065.195.283.284.349.569a13.243 13.243 0 0 1-.13 2.154m-.219-2.416a7.672 7.672 0 0 1-.065 2.46h.065m-.153-.937a2.006 2.006 0 0 0-.13.938c-.066-.062-.2.067-.283.067'/%3e%3cpath fill='%23fff' d='M501.624 326.9c.13 0 .282-.134.413-.195.349-.2 1-.2 1.22-.42 1-1.154.35-3.33-.13-4.7-.784-2.533-.85-4.844-1.439-7.238h-.065a55.114 55.114 0 0 1-1.5 7.238c-.35 1.373-1.069 3.55-.066 4.705.2.2.85.2 1.286.419.066.061.2.195.284.195'/%3e%3cpath fill='%23004bb3' d='M501.624 314.213c-.5 2.377-.633 4.839-1.5 7.394-.35 1.218-1 3.249-.2 4.42l-.066-.06h.066a3.169 3.169 0 0 1-1.069-.195c-.066-.069-.2-.069-.282-.2a1.8 1.8 0 0 0-.5-.5c-.2-.133-.5-.066-.719-.2-.065-.062-.13-.13-.2-.13a2.587 2.587 0 0 1-1.221-1.065 3.84 3.84 0 0 1-.066-1.221c.066-.286.2-.5.284-.788a5.751 5.751 0 0 1 .5-1.065 7.874 7.874 0 0 1 .567-1.156 190.615 190.615 0 0 1 .566-1c.066-.195.283-.285.415-.5.13-.128-.16 0-.006-.16a2.781 2.781 0 0 0 .358-.463c.065 0 .313-.1.313-.157.414-.72.73-.833 1.012-1.575a2.214 2.214 0 0 0 .2-1.155h1.5'/%3e%3cpath fill='none' stroke='%23003' stroke-width='.232' d='M500.9 314.28a34.94 34.94 0 0 1-1.5 5c-.566 1-2.813 2.808-1.374 5.709'/%3e%3cpath fill='none' stroke='%2300004b' stroke-width='.232' d='M501.056 314.28a34.94 34.94 0 0 1-1.5 5c-.633 1.066-2.835 2.963-1.286 5.86'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M501.121 314.28a39 39 0 0 1-1.5 5.146c-.567 1-2.812 2.963-1.22 5.864'/%3e%3cpath fill='none' stroke='%2300187e' stroke-width='.232' d='M501.273 314.28a34.292 34.292 0 0 1-1.525 5.146c-.633 1-2.812 3.03-1.221 6.016'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M501.34 314.28a35.98 35.98 0 0 1-1.5 5.212c-.567 1-2.747 3.115-1.155 6.079'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M501.405 314.28s-.85 4.275-1.5 5.275c-.566 1-2.68 3.185-1.067 6.15'/%3e%3cpath fill='none' stroke='%2300004b' stroke-width='.232' d='M500.838 314.28a38.373 38.373 0 0 1-1.5 4.928c-.567 1.066-2.9 2.9-1.374 5.71'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M500.75 314.37a34.783 34.783 0 0 1-1.59 4.838c-.568 1-2.9 2.9-1.374 5.71'/%3e%3cpath fill='none' stroke='%2300187e' stroke-width='.232' d='M500.6 314.37a27.385 27.385 0 0 1-1.592 4.838c-.5 1-2.811 2.813-1.286 5.71'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M500.533 314.37a21.653 21.653 0 0 1-1.656 4.772c-.5 1.071-2.813 2.9-1.287 5.714'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M500.4 314.37a25.7 25.7 0 0 1-1.592 4.772c-.567 1-2.812 2.9-1.286 5.714'/%3e%3cpath fill='%23004bb3' d='M501.624 314.213c.565 2.377.719 4.839 1.5 7.394.414 1.218 1.069 3.249.283 4.42l.01-.148a2.841 2.841 0 0 0 1.059-.216c.13-.069.195-.046.283-.18a2.5 2.5 0 0 1 .436-.409c.283-.134.567-.068.85-.2.066-.062.066-.13.13-.13a1.827 1.827 0 0 0 1.287-2.286 2.835 2.835 0 0 0-.283-.788 5.877 5.877 0 0 0-.5-1.065 8.08 8.08 0 0 0-.567-1.156 1.16 1.16 0 0 0-.283-.5 2.78 2.78 0 0 0-.284-.5c-.066-.195-.283-.285-.414-.5-.18-.32-.3-.281-.37-.438-.065 0-.092.063 0 0-.066 0-.168-.146-.256-.207a7.183 7.183 0 0 1-1.07-1.706 2.217 2.217 0 0 1-.2-1.156h-1.59'/%3e%3cpath fill='none' stroke='%23003' stroke-width='.232' d='M502.43 314.28a35.041 35.041 0 0 0 1.5 5c.567 1 2.813 2.808 1.286 5.709'/%3e%3cpath fill='none' stroke='%2300004b' stroke-width='.232' d='M502.276 314.28a28.091 28.091 0 0 0 1.592 5c.567 1.066 3.066 2.594 1.54 5.49'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M502.211 314.28a39 39 0 0 0 1.5 5.146c.567 1 2.885 2.8 1.293 5.7'/%3e%3cpath fill='none' stroke='%2300187e' stroke-width='.232' d='M502.06 314.28a36.435 36.435 0 0 0 1.59 5.146c.563 1 2.815 2.753 1.358 5.7-.007.013-.034.013-.04.027s.227-.251.04-.027'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M501.994 314.28s.936 4.209 1.59 5.212c.5 1 2.682 3.115 1.068 6.079'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M501.928 314.28a36.187 36.187 0 0 0 1.5 5.275c.567 1 2.682 3.185 1.068 6.15'/%3e%3cpath fill='none' stroke='%2300004b' stroke-width='.232' d='M502.5 314.28a30.09 30.09 0 0 0 1.591 4.928c.566 1.066 2.813 2.9 1.286 5.71'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M502.647 314.37a31.333 31.333 0 0 0 1.5 4.838c.566 1 2.9 2.9 1.373 5.71'/%3e%3cpath fill='none' stroke='%2300187e' stroke-width='.232' d='M502.713 314.37a27.5 27.5 0 0 0 1.59 4.838c.568 1 2.813 2.813 1.374 5.71'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M502.8 314.37a29.831 29.831 0 0 0 1.591 4.772c.567 1.071 2.9 2.9 1.374 5.714'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M502.93 314.37a25.7 25.7 0 0 0 1.592 4.772c.567 1 2.9 2.9 1.373 5.714'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.232' d='M504.85 317.461a7.077 7.077 0 0 1 .642 1 4.6 4.6 0 0 1 .283.5 1.291 1.291 0 0 1 .284.5 10.474 10.474 0 0 1 .567 1.155 10.931 10.931 0 0 1 .5 1.066 5.762 5.762 0 0 1 .282.787 2.541 2.541 0 0 1-.064 1.217 2.48 2.48 0 0 1-1.22 1.071s-.067.062-.132.129c-.283.133-.566.066-.85.195a3.884 3.884 0 0 0-.436.5c-.065.134-.13.134-.283.195a2.678 2.678 0 0 1-1.068.2.417.417 0 0 1-.132.28c-.2.194-.85.194-1.22.418-.13.062-.283.195-.414.195-.066 0-.2-.133-.283-.195-.415-.2-1.069-.2-1.287-.419a.338.338 0 0 1-.13-.28 3.013 3.013 0 0 1-1.069-.2c-.065-.062-.2-.062-.282-.2a1.888 1.888 0 0 0-.5-.5c-.2-.129-.5-.062-.721-.195-.064-.068-.13-.129-.195-.129a2.573 2.573 0 0 1-1.222-1.051 3.78 3.78 0 0 1-.066-1.218c.066-.283.2-.5.283-.786a5.737 5.737 0 0 1 .5-1.066 7.873 7.873 0 0 1 .567-1.155 1.142 1.142 0 0 1 .283-.5 1.16 1.16 0 0 1 .284-.5 10.327 10.327 0 0 1 .645-.874'/%3e%3cpath fill='%23fff' d='M459.37 272.661c-.341 6.572-.192 8.481-.192 14.894a31.329 31.329 0 0 0 3.006 10.68l6.678-11.159h-.027a23.483 23.483 0 0 1-1.22-4.273 18.507 18.507 0 0 1-.2-4.812z'/%3e%3cpath fill='%23004bb3' d='M468.836 287.075a23.365 23.365 0 0 1-1.221-4.274 18.582 18.582 0 0 1-.2-4.84l4.927 3.184-3.466 5.93'/%3e%3cpath fill='%23fc0' d='m472.825 280.4-23.283-15.216-.414.567 23.217 15.434.5-.785'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='m472.825 280.4-23.283-15.216-.414.567 23.217 15.434.5-.785z'/%3e%3cpath fill='%23004bb3' d='M454.84 310.508a5.157 5.157 0 0 1-1.723-2.154 17.677 17.677 0 0 1-.936-3.471c-.2-1.066-.2-2.244-.5-3.334-.132-1.068-1.723-4.621-1.81-6.016-.131-4.622-1.657-7.76-1.286-12.753.282-3.9 1.155-9.2.72-13.276a30.771 30.771 0 0 1 .065-3.467l10 6.52c-.347 6.67-.194 8.545-.194 15a31.226 31.226 0 0 0 3.03 10.726l-7.324 12.25'/%3e%3cpath fill='none' stroke='%2300004b' stroke-width='.232' d='m462.078 298.236-7.326 12.25a5.488 5.488 0 0 1-1.808-2.155c-.5-1.657-.414-1.657-.85-3.465-.2-1.071-.2-2.248-.414-3.338-.283-1.068-1.81-4.622-1.876-6.017m-.043-.021c.066 1.373 1.591 4.84 1.875 5.93.2 1.067.2 2.244.414 3.334a23.237 23.237 0 0 0 .937 3.466 4.974 4.974 0 0 0 1.744 2.093l7.325-12.1'/%3e%3cpath fill='none' stroke='%2300004f' stroke-width='.232' d='M449.761 295.49c.066 1.373 1.591 4.773 1.81 5.864.282 1.068.282 2.245.566 3.333a29.441 29.441 0 0 0 .85 3.466 5.536 5.536 0 0 0 1.744 2.092s7.238-11.965 7.325-12.03m-12.295-2.725c.066 1.373 1.591 4.773 1.81 5.864.282 1 .282 2.158.566 3.25a28.667 28.667 0 0 0 .85 3.4 4.855 4.855 0 0 0 1.744 2.025c.066.067 7.238-11.748 7.325-11.813'/%3e%3cpath fill='none' stroke='%23000051' stroke-width='.232' d='M449.761 295.49c.066 1.286 1.591 4.708 1.81 5.8.282 1.068.282 2.159.566 3.182a25.82 25.82 0 0 0 .85 3.4 5.626 5.626 0 0 0 1.744 2.093c.131 0 7.238-11.665 7.325-11.752m-12.295-2.725c.066 1.286 1.591 4.621 1.81 5.711.282 1 .282 2.158.566 3.185a15.4 15.4 0 0 0 .938 3.332 5.116 5.116 0 0 0 1.722 2.092c.065 0 7.106-11.53 7.238-11.6'/%3e%3cpath fill='none' stroke='%23000053' stroke-width='.232' d='M449.761 295.49c.066 1.286 1.5 4.556 1.81 5.646.282 1 .282 2.158.566 3.183a17.733 17.733 0 0 0 .938 3.337 4.986 4.986 0 0 0 1.722 2.026c.065.067 7.106-11.38 7.238-11.446m-12.275-2.747c.067 1.286 1.5 4.557 1.81 5.582.283 1.068.283 2.158.567 3.182a20.532 20.532 0 0 0 .938 3.247 4.532 4.532 0 0 0 1.722 2.027c.13.066 7.019-11.225 7.238-11.312'/%3e%3cpath fill='none' stroke='%23000056' stroke-width='.232' d='M449.761 295.49c.066 1.286 1.5 4.49 1.81 5.58.282 1 .282 2.093.566 3.118a25.181 25.181 0 0 0 .938 3.244 5.509 5.509 0 0 0 1.722 1.944c.13.066 7.019-11.1 7.238-11.161m-12.275-2.725c.067 1.22 1.5 4.425 1.81 5.428.283 1.068.283 2.158.567 3.182a21.934 21.934 0 0 0 .938 3.182 5.023 5.023 0 0 0 1.722 1.943c.13.06 7.019-10.945 7.238-11.01m-12.275-2.725c.067 1.22 1.5 4.425 1.81 5.428.283 1 .283 2.026.567 3.03a18.168 18.168 0 0 0 .938 3.184 4.568 4.568 0 0 0 1.722 1.936c.2.068 6.953-10.788 7.238-10.876'/%3e%3cpath fill='none' stroke='%23000058' stroke-width='.232' d='M449.761 295.49c.066 1.22 1.5 4.338 1.81 5.363.282 1 .282 2.092.566 3.03a28.323 28.323 0 0 0 .938 3.115 4.58 4.58 0 0 0 1.722 1.942c.2.066 6.953-10.66 7.238-10.725m-12.275-2.725c.067 1.22 1.5 4.273 1.81 5.275.283 1 .283 2.092.567 2.964a18.2 18.2 0 0 0 1 3.186 4.682 4.682 0 0 0 1.656 1.874c.284.129 6.955-10.443 7.238-10.574'/%3e%3cpath fill='none' stroke='%2300005c' stroke-width='.232' d='M449.761 295.49c.066 1.22 1.5 4.273 1.81 5.275.282.938.282 1.94.566 2.9a19.051 19.051 0 0 0 1 3.115 5.423 5.423 0 0 0 1.656 1.942c.284.067 6.89-10.355 7.238-10.507m-12.273-2.725c.066 1.155 1.438 4.207 1.81 5.21.282.937.282 1.962.566 2.9a19.39 19.39 0 0 0 1 3.12 5.373 5.373 0 0 0 1.656 1.87c.284.067 6.89-10.221 7.238-10.353'/%3e%3cpath fill='none' stroke='%2300005e' stroke-width='.232' d='M449.761 295.49c.066 1.155 1.438 4.12 1.81 5.144.282.938.348 1.94.566 2.9a16.05 16.05 0 0 0 1 3.03 4.686 4.686 0 0 0 1.656 1.873c.35.068 6.89-10.07 7.238-10.222m-12.273-2.725c.066 1.068 1.438 4.054 1.81 5.057.282 1 .348 1.94.566 2.9a18.287 18.287 0 0 0 1 2.965 4.676 4.676 0 0 0 1.656 1.874c.35.129 6.89-9.918 7.238-10.071'/%3e%3cpath fill='none' stroke='%23000060' stroke-width='.232' d='M449.761 295.425c.066 1.155 1.438 4.12 1.81 5.143.282.852.348 1.875.566 2.813a15.671 15.671 0 0 0 1 2.9 5.32 5.32 0 0 0 1.656 1.875c.35.133 6.8-9.785 7.238-9.917m-12.273-2.811a21.3 21.3 0 0 0 1.81 4.991c.282.938.348 1.94.566 2.813.5 1.5.5 1.5 1 2.965A4.622 4.622 0 0 0 454.8 308c.415.129 6.737-9.634 7.238-9.787m-12.273-2.79a22.413 22.413 0 0 0 1.81 4.991 26.158 26.158 0 0 0 .632 2.747 23.54 23.54 0 0 0 1 2.964 4.535 4.535 0 0 0 1.59 1.724c.5.129 6.737-9.483 7.239-9.636'/%3e%3cpath fill='none' stroke='%23000062' stroke-width='.232' d='M449.761 295.425c.066 1.155 1.352 3.9 1.81 4.926a26.216 26.216 0 0 0 .632 2.747 19.5 19.5 0 0 0 1 2.9 5.327 5.327 0 0 0 1.59 1.719c.5.134 6.737-9.35 7.239-9.482m-12.275-2.811a21.726 21.726 0 0 0 1.81 4.838 26.551 26.551 0 0 0 .633 2.747 20.244 20.244 0 0 0 1 2.81 6.005 6.005 0 0 0 1.656 1.814c.414.061 6.671-9.266 7.172-9.42'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M449.761 295.425a22.88 22.88 0 0 0 1.81 4.838c.195.85.348 1.81.632 2.682a16.74 16.74 0 0 0 1 2.747 4.681 4.681 0 0 0 1.656 1.725c.5.194 6.6-8.984 7.172-9.2m-12.273-2.79a21.127 21.127 0 0 0 1.81 4.773c.195.85.348 1.809.632 2.682a15.744 15.744 0 0 0 1.067 2.745 4.182 4.182 0 0 0 1.592 1.657c.5.195 6.6-8.85 7.172-9.067'/%3e%3cpath fill='none' stroke='%23000268' stroke-width='.232' d='M449.761 295.425a20.652 20.652 0 0 0 1.81 4.708 23.344 23.344 0 0 0 .632 2.594 12.569 12.569 0 0 0 1.067 2.747 4.505 4.505 0 0 0 1.592 1.72c.5.133 6.6-8.761 7.172-8.98m-12.273-2.79a19.992 19.992 0 0 0 1.81 4.622 23.738 23.738 0 0 0 .632 2.616 20.884 20.884 0 0 0 1.067 2.745 4.831 4.831 0 0 0 1.592 1.658c.567.128 6.517-8.632 7.172-8.85'/%3e%3cpath fill='none' stroke='%2300056b' stroke-width='.232' d='M449.761 295.425a19.336 19.336 0 0 0 1.81 4.621c.195.784.348 1.656.632 2.528a18.974 18.974 0 0 0 1.067 2.683 4.353 4.353 0 0 0 1.592 1.657c.567.195 6.453-8.481 7.172-8.7m-12.273-2.79a16.583 16.583 0 0 0 1.81 4.491 14.859 14.859 0 0 0 .718 2.594 10.409 10.409 0 0 0 1 2.591 4.251 4.251 0 0 0 1.592 1.658c.566.2 6.451-8.325 7.171-8.543m-12.295-2.79a17.489 17.489 0 0 0 1.81 4.49 12.2 12.2 0 0 0 .718 2.463 13.1 13.1 0 0 0 1 2.594 4.317 4.317 0 0 0 1.592 1.657c.63.129 6.451-8.11 7.171-8.414'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='M449.761 295.425a18.388 18.388 0 0 0 1.81 4.424 12.21 12.21 0 0 0 .718 2.464 15.508 15.508 0 0 0 1 2.591 5.438 5.438 0 0 0 1.592 1.592c.63.2 6.451-7.976 7.171-8.26m-12.295-2.811a17.505 17.505 0 0 0 1.81 4.338 13.571 13.571 0 0 0 .718 2.462 13.082 13.082 0 0 0 1 2.53 4.117 4.117 0 0 0 1.592 1.59c.718.195 6.386-7.825 7.171-8.109'/%3e%3cpath fill='none' stroke='%2300096f' stroke-width='.232' d='M449.761 295.425a17.505 17.505 0 0 0 1.81 4.338 19.575 19.575 0 0 0 .718 2.376 13.11 13.11 0 0 0 1.069 2.526 3.815 3.815 0 0 0 1.5 1.507c.72.194 6.388-7.674 7.172-7.979m-12.273-2.768a20.683 20.683 0 0 0 1.722 4.272c.283.72.5 1.591.785 2.376a11.084 11.084 0 0 0 1.068 2.464 5.516 5.516 0 0 0 1.5 1.59c.72.134 6.387-7.608 7.172-7.891'/%3e%3cpath fill='none' stroke='%23000b73' stroke-width='.232' d='M449.827 295.425a13.976 13.976 0 0 0 1.656 4.207c.283.784.5 1.59.785 2.31a10.957 10.957 0 0 0 1.068 2.46 4.293 4.293 0 0 0 1.5 1.508c.785.284 6.3-7.39 7.172-7.674m-12.186-2.811a14.447 14.447 0 0 0 1.657 4.12c.283.785.5 1.591.785 2.31a15.292 15.292 0 0 0 1.068 2.465 4.126 4.126 0 0 0 1.5 1.439c.785.28 6.3-7.24 7.172-7.544'/%3e%3cpath fill='none' stroke='%23000f75' stroke-width='.232' d='M449.827 295.425a14.074 14.074 0 0 0 1.656 4.054c.283.784.5 1.592.785 2.31a12.493 12.493 0 0 0 1.068 2.4 4.974 4.974 0 0 0 1.5 1.5c.785.195 6.3-7.172 7.172-7.456m-12.186-2.811a13.731 13.731 0 0 0 1.657 3.989c.283.784.5 1.592.785 2.31.414 1.156.567 1.221 1.068 2.376a6.638 6.638 0 0 0 1.5 1.441c.85.195 6.234-7.021 7.172-7.325m-12.186-2.791a13.731 13.731 0 0 0 1.657 3.989c.283.719.5 1.5.785 2.244a20.21 20.21 0 0 0 1.068 2.312 5.586 5.586 0 0 0 1.591 1.437c.85.285 6.147-6.887 7.107-7.17'/%3e%3cpath fill='none' stroke='%23001178' stroke-width='.232' d='M449.827 295.425c0 .85 1.154 3.03 1.656 3.9.283.72.5 1.5.785 2.246a14.748 14.748 0 0 0 1.155 2.245 4.134 4.134 0 0 0 1.5 1.44c.85.195 6.082-6.671 7.107-7.021m-12.207-2.811a13.705 13.705 0 0 0 1.656 3.836c.283.72.5 1.5.785 2.159a12.1 12.1 0 0 0 1.155 2.31 4.482 4.482 0 0 0 1.5 1.37c.85.284 6.082-6.514 7.107-6.885'/%3e%3cpath fill='none' stroke='%23001379' stroke-width='.232' d='M449.827 295.425c0 .784 1.154 2.9 1.656 3.836.283.632.5 1.373.785 2.093a12.214 12.214 0 0 0 1.155 2.245 4.5 4.5 0 0 0 1.5 1.373c.938.285 6.082-6.365 7.107-6.736m-12.207-2.811a10.2 10.2 0 0 0 1.656 3.683c.283.72.5 1.5.785 2.159a10.91 10.91 0 0 0 1.155 2.158 4.5 4.5 0 0 0 1.5 1.374c.938.284 6.017-6.235 7.107-6.584'/%3e%3cpath fill='none' stroke='%2300167c' stroke-width='.232' d='M449.827 295.425a10.9 10.9 0 0 0 1.656 3.683c.283.633.5 1.439.785 2.093a13 13 0 0 0 1.155 2.158 4.207 4.207 0 0 0 1.5 1.284c.938.285 6.017-6.079 7.107-6.45m-12.207-2.768a10.632 10.632 0 0 0 1.656 3.618c.283.72.5 1.373.785 2.093.5 1 .632 1.068 1.155 2.093a5.707 5.707 0 0 0 1.5 1.374c1 .28 6.017-6.017 7.107-6.367'/%3e%3cpath fill='none' stroke='%2300187e' stroke-width='.232' d='M449.827 295.425a10.353 10.353 0 0 0 1.656 3.552c.283.634.5 1.374.785 2.094.5 1 .632 1.068 1.155 2.092a6.556 6.556 0 0 0 1.5 1.284c1 .285 5.93-5.861 7.107-6.232m-12.207-2.79a8.821 8.821 0 0 0 1.656 3.465 18.756 18.756 0 0 0 .85 2.028 17.2 17.2 0 0 0 1.068 2.092 4.23 4.23 0 0 0 1.5 1.221c1 .35 5.93-5.645 7.106-6.016m-12.186-2.79a10.122 10.122 0 0 0 1.657 3.465c.283.633.5 1.286.85 1.94a10.414 10.414 0 0 0 1.156 2.027 5.648 5.648 0 0 0 1.438 1.287c1.069.28 5.865-5.58 7.107-5.93'/%3e%3cpath fill='none' stroke='%23001c82' stroke-width='.232' d='M449.827 295.425a9.364 9.364 0 0 0 1.656 3.4c.283.566.5 1.285.85 1.94a9.241 9.241 0 0 0 1.156 1.94 5.643 5.643 0 0 0 1.438 1.286c1.069.351 5.865-5.428 7.107-5.8m-12.207-2.767a9.126 9.126 0 0 0 1.656 3.334 18.061 18.061 0 0 0 .85 1.875 10.414 10.414 0 0 0 1.156 2.027 5.78 5.78 0 0 0 1.438 1.221c1.156.284 5.865-5.21 7.107-5.646'/%3e%3cpath fill='none' stroke='%23001e85' stroke-width='.232' d='M449.827 295.425a9.653 9.653 0 0 0 1.656 3.334c.283.567.5 1.222.85 1.81a8.215 8.215 0 0 0 1.22 2.026 4.362 4.362 0 0 0 1.374 1.157c1.156.348 5.8-5.058 7.107-5.5m-12.207-2.832a8.621 8.621 0 0 0 1.656 3.182 18.045 18.045 0 0 0 .85 1.874 9.58 9.58 0 0 0 1.22 1.941 4.369 4.369 0 0 0 1.374 1.155c1.156.35 5.8-4.926 7.107-5.362'/%3e%3cpath fill='none' stroke='%23002086' stroke-width='.232' d='M449.827 295.337a8.737 8.737 0 0 0 1.656 3.27c.283.566.5 1.22.85 1.81a9.165 9.165 0 0 0 1.22 1.873 4.362 4.362 0 0 0 1.374 1.157c1.221.349 5.8-4.775 7.107-5.211m-12.207-2.9a8.3 8.3 0 0 0 1.656 3.184c.283.566.5 1.22.85 1.81a9.457 9.457 0 0 0 1.22 1.809 3.662 3.662 0 0 0 1.44 1.155c1.155.349 5.646-4.622 7.02-5.058'/%3e%3cpath fill='none' stroke='%23002289' stroke-width='.232' d='M449.827 295.337a6.942 6.942 0 0 0 1.656 3.117c.283.567.5 1.22.85 1.81a16.674 16.674 0 0 0 1.22 1.81 5.192 5.192 0 0 0 1.44 1.068c1.155.414 5.646-4.426 7.02-4.927m-12.187-2.878a7.038 7.038 0 0 0 1.657 3.03 13.921 13.921 0 0 0 .85 1.722 16.674 16.674 0 0 0 1.22 1.81 5.531 5.531 0 0 0 1.44 1.155c1.22.349 5.646-4.338 7.02-4.84m-12.187-2.877a7.038 7.038 0 0 0 1.657 3.03c.283.5.5 1.155.85 1.657a14.774 14.774 0 0 0 1.22 1.81 6.873 6.873 0 0 0 1.44 1.067c1.286.349 5.646-4.207 7.02-4.709'/%3e%3cpath fill='none' stroke='%2300258b' stroke-width='.232' d='M449.827 295.337a7.511 7.511 0 0 0 1.656 2.965c.283.5.5 1.068.85 1.656a21 21 0 0 0 1.22 1.723 3.943 3.943 0 0 0 1.44 1c1.286.414 5.582-3.99 7.02-4.49m-12.187-2.857a6.923 6.923 0 0 0 1.657 2.9c.283.567.5 1.069.85 1.656a9.169 9.169 0 0 0 1.286 1.658 4.117 4.117 0 0 0 1.374 1.068c1.286.414 5.494-3.9 7.02-4.426'/%3e%3cpath fill='none' stroke='%2300288f' stroke-width='.232' d='M449.827 295.337a7.794 7.794 0 0 0 1.656 2.9c.283.5.5 1 .85 1.592a7.042 7.042 0 0 0 1.286 1.592 4.1 4.1 0 0 0 1.374 1.067c1.373.414 5.494-3.77 7.02-4.272m-12.187-2.878a6.8 6.8 0 0 0 1.657 2.747c.283.5.5 1.155.85 1.656.5.72.72.85 1.286 1.592a6.181 6.181 0 0 0 1.374 1c1.373.348 5.494-3.619 7.02-4.12'/%3e%3cpath fill='none' stroke='%23002b91' stroke-width='.232' d='M449.827 295.337a6.38 6.38 0 0 0 1.656 2.747 17.16 17.16 0 0 0 .85 1.5c.5.785.784.938 1.286 1.657a4.025 4.025 0 0 0 1.439.938c1.286.414 5.363-3.466 6.954-3.99m-12.186-2.855a5.875 5.875 0 0 0 1.657 2.68 17.045 17.045 0 0 0 .85 1.5c.5.72.784.85 1.286 1.592a5.158 5.158 0 0 0 1.439.938c1.373.414 5.363-3.336 6.954-3.837'/%3e%3cpath fill='none' stroke='%23002d93' stroke-width='.232' d='M449.827 295.337a5.945 5.945 0 0 0 1.59 2.594c.35.5.633 1 1 1.5a11.474 11.474 0 0 0 1.22 1.5 5.1 5.1 0 0 0 1.44.937c1.373.414 5.361-3.182 6.953-3.77m-12.207-2.77a5.925 5.925 0 0 0 1.59 2.53c.35.5.633 1 1 1.439a7.681 7.681 0 0 0 1.22 1.5 4.932 4.932 0 0 0 1.44 1c1.373.348 5.361-3.117 6.953-3.685m-12.207-2.79a5.642 5.642 0 0 0 1.59 2.463c.35.5.633 1 1 1.44a8.328 8.328 0 0 0 1.286 1.5 3.26 3.26 0 0 0 1.35.849c1.44.5 5.3-2.811 6.955-3.466'/%3e%3cpath fill='none' stroke='%23002f96' stroke-width='.232' d='M449.827 295.337a5.642 5.642 0 0 0 1.59 2.463c.35.415.633.938 1 1.373a8.678 8.678 0 0 0 1.286 1.439 4.683 4.683 0 0 0 1.35.938c1.44.414 5.212-2.747 6.955-3.4m-12.186-2.813a5.524 5.524 0 0 0 1.591 2.4c.35.415.633.938 1 1.352a12.484 12.484 0 0 0 1.286 1.44 9.628 9.628 0 0 0 1.35.85c1.5.414 5.212-2.594 6.955-3.25'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M449.827 295.337a4.919 4.919 0 0 0 1.59 2.31c.35.437.633.939 1 1.374.414.566.784.784 1.286 1.374a5.879 5.879 0 0 0 1.35.85c1.5.413 5.212-2.463 6.955-3.118m-12.186-2.79a5.137 5.137 0 0 0 1.591 2.245 15.526 15.526 0 0 0 1 1.286 6.3 6.3 0 0 0 1.373 1.374 4.124 4.124 0 0 0 1.286.85c1.591.5 5.145-2.31 6.954-2.965'/%3e%3cpath fill='none' stroke='%2300359c' stroke-width='.232' d='M449.827 295.337a5.671 5.671 0 0 0 1.59 2.245c.35.414.633.786 1 1.221a7.084 7.084 0 0 0 1.373 1.286 3.467 3.467 0 0 0 1.286.85c1.591.415 5.145-2.157 6.954-2.812m-12.207-2.79a5.4 5.4 0 0 0 1.59 2.158c.35.35.633.785 1 1.221a7.054 7.054 0 0 0 1.381 1.284 4.829 4.829 0 0 0 1.286.785c1.591.5 5.145-2.028 6.954-2.681'/%3e%3cpath fill='none' stroke='%2300389e' stroke-width='.232' d='M449.827 295.337a4.9 4.9 0 0 0 1.59 2.092c.35.35.633.873 1 1.222a9.315 9.315 0 0 0 1.373 1.22 3.589 3.589 0 0 0 1.286.785c1.656.5 5.145-1.874 6.954-2.53m-12.207-2.79a4.317 4.317 0 0 0 1.59 2.028c.35.414.633.85 1 1.222a15.69 15.69 0 0 0 1.373 1.22 4.684 4.684 0 0 0 1.286.72c1.656.5 5.058-1.723 6.954-2.378m-12.207-2.811a4.125 4.125 0 0 0 1.59 1.94 12.259 12.259 0 0 0 1 1.221c.414.5.85.632 1.373 1.155a4.651 4.651 0 0 0 1.286.72c1.744.5 5.058-1.591 6.954-2.246'/%3e%3cpath fill='none' stroke='%230039a0' stroke-width='.232' d='M449.827 295.337a5.006 5.006 0 0 0 1.59 1.94 10.939 10.939 0 0 0 1 1.068 8.917 8.917 0 0 0 1.373 1.156 7.546 7.546 0 0 0 1.286.785c1.744.5 5.058-1.44 6.954-2.16m-12.207-2.79a5.121 5.121 0 0 0 1.59 1.876 11.054 11.054 0 0 0 1 1.068 7.5 7.5 0 0 0 1.373 1.069 2.711 2.711 0 0 0 1.286.718c1.744.567 4.992-1.22 6.954-1.94'/%3e%3cpath fill='none' stroke='%23003ca2' stroke-width='.232' d='M449.827 295.337a5.131 5.131 0 0 0 1.59 1.81 11.292 11.292 0 0 0 1 1.068 10.19 10.19 0 0 0 1.439 1.068 5.534 5.534 0 0 0 1.286.72c1.722.5 4.926-1.156 6.888-1.876m-12.207-2.79a4.755 4.755 0 0 0 1.5 1.722l1.068 1.068c.5.436.85.633 1.44 1.069a5.476 5.476 0 0 0 1.285.632c1.723.5 4.84-1 6.89-1.722'/%3e%3cpath fill='none' stroke='%23003ea6' stroke-width='.232' d='M449.827 295.337a5.6 5.6 0 0 0 1.5 1.722 14.273 14.273 0 0 1 1.068 1c.5.413.938.566 1.44 1a5.476 5.476 0 0 0 1.285.632c1.723.566 4.84-.85 6.89-1.591m-12.187-2.77a5.64 5.64 0 0 0 1.5 1.657c.35.284.72.633 1.156 1 .414.35.85.567 1.374.939a3.934 3.934 0 0 0 1.286.63c1.809.5 4.84-.718 6.888-1.438'/%3e%3cpath fill='none' stroke='%230042a8' stroke-width='.232' d='M449.827 295.337a5.583 5.583 0 0 0 1.5 1.592c.35.282.72.632 1.156.937a6.092 6.092 0 0 0 1.374.937 4.679 4.679 0 0 0 1.286.632c1.809.567 4.773-.567 6.888-1.286m-12.207-2.812a4.691 4.691 0 0 0 1.5 1.5 8.369 8.369 0 0 0 1.156.937c.414.349.85.567 1.374.938a13.663 13.663 0 0 0 1.286.567c1.809.566 4.773-.415 6.888-1.156m-12.207-2.79a5.057 5.057 0 0 0 1.5 1.439c.35.282.72.567 1.156.937a7.648 7.648 0 0 0 1.374.85c.414.2.85.414 1.286.633 1.875.5 4.773-.35 6.888-1.07'/%3e%3cpath fill='none' stroke='%230045ab' stroke-width='.232' d='M449.827 295.337a6.091 6.091 0 0 0 1.5 1.439c.35.2.72.5 1.156.785a7.476 7.476 0 0 0 1.439.937 7.964 7.964 0 0 0 1.22.5c1.941.566 4.71-.132 6.889-.85m-12.207-2.813a11.879 11.879 0 0 0 2.659 2.158 6.357 6.357 0 0 0 1.439.85 4.355 4.355 0 0 0 1.22.5c1.941.632 4.71 0 6.889-.72'/%3e%3cpath fill='none' stroke='%230046ad' stroke-width='.232' d='M449.827 295.337a9.156 9.156 0 0 0 1.5 1.286c.35.2.72.567 1.156.785a5.694 5.694 0 0 0 1.439.784c.349.2.85.35 1.22.567 1.941.567 4.622.13 6.889-.632m-12.207-2.79a7.334 7.334 0 0 0 1.5 1.22 13.46 13.46 0 0 0 1.156.786c.414.282.937.5 1.439.784.414.131.85.349 1.22.5a12.183 12.183 0 0 0 6.889-.5'/%3e%3cpath fill='none' stroke='%230049af' stroke-width='.232' d='M449.827 295.337a5.256 5.256 0 0 0 1.5 1.22 13.08 13.08 0 0 1 1.156.72 8.946 8.946 0 0 0 1.439.72c.414.195.85.348 1.22.5a12.284 12.284 0 0 0 6.889-.349m-12.207-2.812a18.167 18.167 0 0 0 1.5 1.155c.35.2.72.414 1.221.72.35.195.85.414 1.352.632.415.195.85.348 1.22.5a11.665 11.665 0 0 0 6.89-.2'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M449.827 295.337a11.288 11.288 0 0 0 1.5 1.068 12.55 12.55 0 0 0 1.221.633 6.163 6.163 0 0 0 1.352.719c.415.13.85.282 1.22.414a11.978 11.978 0 0 0 6.89-.065m-12.187-2.77s6.3 4.927 12.252 2.813'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M449.543 275.892s1.22 7.913 1.722 9.07c.348 1 2.9 5.491 6.67 6.516'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='M449.543 275.892s1.286 7.825 1.81 8.915c.413 1 2.746 5.364 6.67 6.671'/%3e%3cpath fill='none' stroke='%23000b73' stroke-width='.232' d='M449.608 275.825s1.374 7.762 1.875 8.982a13.21 13.21 0 0 0 6.517 6.671'/%3e%3cpath fill='none' stroke='%23001379' stroke-width='.232' d='M449.608 275.825s1.438 7.762 1.94 8.917a13.506 13.506 0 0 0 6.452 6.671'/%3e%3cpath fill='none' stroke='%2300187e' stroke-width='.232' d='M449.608 275.825s1.5 7.674 2.027 8.765a14.687 14.687 0 0 0 6.366 6.8'/%3e%3cpath fill='none' stroke='%23002086' stroke-width='.232' d='M449.608 275.825s1.591 7.609 2.158 8.765a15.148 15.148 0 0 0 6.235 6.8'/%3e%3cpath fill='none' stroke='%2300258b' stroke-width='.232' d='M449.608 275.825s1.657 7.543 2.246 8.7a16 16 0 0 0 6.147 6.8'/%3e%3cpath fill='none' stroke='%23002b91' stroke-width='.232' d='M449.674 275.825s1.656 7.457 2.245 8.634a17.11 17.11 0 0 0 6.081 6.889'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M449.674 275.825s1.809 7.391 2.31 8.547c.567 1.067 1.744 3.683 6.083 6.954'/%3e%3cpath fill='none' stroke='%2300389e' stroke-width='.232' d='M449.761 275.76s1.81 7.456 2.376 8.547c.5 1.067 1.5 3.4 5.93 7.02'/%3e%3cpath fill='none' stroke='%23003ea6' stroke-width='.232' d='M449.761 275.76s1.875 7.326 2.442 8.48c.566 1.069 1.373 3.184 5.864 7.02'/%3e%3cpath fill='none' stroke='%230046ad' stroke-width='.232' d='M449.761 275.76s2.027 7.326 2.528 8.415c.567 1.069 1.286 2.965 5.865 7.02'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M449.761 275.674s2.093 7.324 2.594 8.393c.567 1.068 1.156 2.747 5.776 7.106'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M450.045 271.03s1 11.162 8.98 14.214'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='M450.045 271.03a32.315 32.315 0 0 0 2.092 7.02 13.478 13.478 0 0 0 6.888 7.171'/%3e%3cpath fill='none' stroke='%23000b73' stroke-width='.232' d='M450.11 271.03a27.714 27.714 0 0 0 2.093 7.02 14.707 14.707 0 0 0 6.8 7.171'/%3e%3cpath fill='none' stroke='%23001379' stroke-width='.232' d='M450.11 271.03a28.157 28.157 0 0 0 2.158 6.888c1.155 2.312 3.183 5.582 6.736 7.238'/%3e%3cpath fill='none' stroke='%2300187e' stroke-width='.232' d='M450.11 271.03a27.905 27.905 0 0 0 2.31 6.888c1 2.093 3.03 5.494 6.584 7.173'/%3e%3cpath fill='none' stroke='%23002086' stroke-width='.232' d='M450.11 271.03a31.6 31.6 0 0 0 2.376 6.8c.937 1.876 3.03 5.43 6.517 7.238'/%3e%3cpath fill='none' stroke='%2300258b' stroke-width='.232' d='M450.2 271.03a29.806 29.806 0 0 0 2.4 6.736 17.306 17.306 0 0 0 6.452 7.326'/%3e%3cpath fill='none' stroke='%23002b91' stroke-width='.232' d='M450.2 270.964a35.374 35.374 0 0 0 2.464 6.737c.784 1.5 2.9 5.276 6.365 7.325'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M450.2 270.964a30.745 30.745 0 0 0 2.616 6.671c.72 1.44 2.747 5.277 6.235 7.39'/%3e%3cpath fill='none' stroke='%2300389e' stroke-width='.232' d='M450.262 270.964a28.306 28.306 0 0 0 2.594 6.671c.634 1.156 2.66 5.145 6.147 7.39'/%3e%3cpath fill='none' stroke='%23003ea6' stroke-width='.232' d='M450.262 270.964a35.8 35.8 0 0 0 2.66 6.605c.633 1 2.594 5.06 6.082 7.391'/%3e%3cpath fill='none' stroke='%230046ad' stroke-width='.232' d='M450.262 270.964a32.025 32.025 0 0 0 2.813 6.519c.5.785 2.462 4.992 5.93 7.455'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M450.262 270.964a30.066 30.066 0 0 0 2.9 6.453c.414.633 2.375 4.993 5.864 7.543'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M450.11 267.913s2.31 8.981 8.85 11.161'/%3e%3cpath fill='none' stroke='%2300056b' stroke-width='.232' d='M450.11 267.913a24.726 24.726 0 0 0 3.03 6.235 12.044 12.044 0 0 0 5.8 4.926'/%3e%3cpath fill='none' stroke='%2300096f' stroke-width='.232' d='M450.11 267.913a24.568 24.568 0 0 0 3.03 6.147c1.5 2.093 3.554 4.273 5.8 4.993'/%3e%3cpath fill='none' stroke='%23000f75' stroke-width='.232' d='M450.11 267.848a24.906 24.906 0 0 0 3.183 6.152c1.5 2.158 3.618 4.338 5.646 5.058'/%3e%3cpath fill='none' stroke='%2300167c' stroke-width='.232' d='M450.2 267.782a25.035 25.035 0 0 0 3.182 6.234c1.506 2.093 3.772 4.426 5.581 5.058'/%3e%3cpath fill='none' stroke='%23001c82' stroke-width='.232' d='M450.2 267.782a25.8 25.8 0 0 0 3.248 6.083c1.591 2.223 3.837 4.556 5.494 5.144'/%3e%3cpath fill='none' stroke='%23002086' stroke-width='.232' d='M450.2 267.782a27.84 27.84 0 0 0 3.248 6.017c1.722 2.31 4.055 4.708 5.494 5.21'/%3e%3cpath fill='none' stroke='%2300258b' stroke-width='.232' d='M450.2 267.7a25.115 25.115 0 0 0 3.4 6.017c1.723 2.31 4.055 4.84 5.363 5.275'/%3e%3cpath fill='none' stroke='%23002b91' stroke-width='.232' d='M450.262 267.7a24.248 24.248 0 0 0 3.4 5.929c1.745 2.377 4.208 4.927 5.277 5.276'/%3e%3cpath fill='none' stroke='%23002f96' stroke-width='.232' d='M450.262 267.7a26.509 26.509 0 0 0 3.466 5.865c1.788 2.376 4.273 5.055 5.211 5.361'/%3e%3cpath fill='none' stroke='%2300359c' stroke-width='.232' d='M450.262 267.63a25.1 25.1 0 0 0 3.554 5.864c1.809 2.375 4.425 5.21 5.143 5.427'/%3e%3cpath fill='none' stroke='%23003ca2' stroke-width='.232' d='M450.262 267.63a30.293 30.293 0 0 0 3.62 5.864 36.75 36.75 0 0 0 5.057 5.427'/%3e%3cpath fill='none' stroke='%230042a8' stroke-width='.232' d='M450.262 267.63a32.839 32.839 0 0 0 3.684 5.71 49.01 49.01 0 0 0 4.993 5.582'/%3e%3cpath fill='none' stroke='%230046ad' stroke-width='.232' d='M450.262 267.564a30.756 30.756 0 0 0 3.771 5.711 50.2 50.2 0 0 0 4.993 5.646'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M450.262 267.476a37.055 37.055 0 0 0 3.837 5.712c2.027 2.6 4.927 5.647 4.927 5.647m8.436 1.35 4.426.786m-3.99 2.55 3.99-1.656'/%3e%3cpath fill='none' stroke='%230045ab' stroke-width='.232' d='m467.4 280.251 4.425.72'/%3e%3cpath fill='none' stroke='%23003ca2' stroke-width='.232' d='m467.4 280.47 4.49.5'/%3e%3cpath fill='none' stroke='%2300359c' stroke-width='.232' d='m467.463 280.622 4.49.349'/%3e%3cpath fill='none' stroke='%23002d93' stroke-width='.232' d='m467.463 280.753 4.49.282'/%3e%3cpath fill='none' stroke='%2300258b' stroke-width='.232' d='m467.463 280.971 4.556.065'/%3e%3cpath fill='none' stroke='%23001e85' stroke-width='.232' d='m467.463 281.124 4.556-.066'/%3e%3cpath fill='none' stroke='%2300167c' stroke-width='.232' d='m467.463 281.276 4.621-.2'/%3e%3cpath fill='none' stroke='%23000f75' stroke-width='.232' d='m467.463 281.406 4.708-.282'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='m467.528 281.56 4.622-.415'/%3e%3cpath fill='none' stroke='%230045ab' stroke-width='.232' d='m467.9 283.3 4.055-1.5'/%3e%3cpath fill='none' stroke='%23003ca2' stroke-width='.232' d='m467.81 283.15 4.121-1.438'/%3e%3cpath fill='none' stroke='%2300359c' stroke-width='.232' d='m467.81 283.02 4.209-1.374'/%3e%3cpath fill='none' stroke='%23002d93' stroke-width='.232' d='m467.745 282.8 4.274-1.22'/%3e%3cpath fill='none' stroke='%2300258b' stroke-width='.232' d='m467.745 282.65 4.34-1.156'/%3e%3cpath fill='none' stroke='%23001e85' stroke-width='.232' d='m467.745 282.5 4.426-1.07'/%3e%3cpath fill='none' stroke='%2300167c' stroke-width='.232' d='m467.68 282.28 4.491-.851'/%3e%3cpath fill='none' stroke='%23000f75' stroke-width='.232' d='m467.68 282.061 4.556-.785'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='m467.68 281.93 4.556-.654'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='m467.616 281.777 4.708-.565'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.232' d='M454.84 310.508a5.157 5.157 0 0 1-1.723-2.154 17.677 17.677 0 0 1-.936-3.471c-.2-1.066-.2-2.244-.5-3.334-.132-1.068-1.744-4.621-1.81-6.016-.131-4.622-1.657-7.76-1.286-12.753.282-3.9 1.155-9.2.72-13.276a30.771 30.771 0 0 1 .065-3.467l22.976 15.217'/%3e%3cpath fill='%23fc0' d='M449.172 264.883c-.13-.85.065-2.03.72-2.157a2.362 2.362 0 0 1 .784-.068c.349 0 .415.13.633.436.283.785-.633 1.287-1.286 1.5-.2.066-.633.13-.72.349-.13.349-.066.2-.13.349.13-.065.13-.2.283-.284.5-.282 1-.348 1.722-.72.567-.194.633-1.372.283-1.657a2.292 2.292 0 0 0-2.027 0 3.214 3.214 0 0 0-.567 2.682c0-.195.349-.13.283-.414'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M449.172 264.883c-.13-.85.065-2.03.72-2.157a2.152 2.152 0 0 1 .784-.068c.349 0 .415.13.633.436.283.785-.633 1.287-1.286 1.5-.2.066-.633.13-.72.349-.13.349-.066.2-.13.349.13-.065.13-.2.283-.284.5-.282 1-.348 1.722-.72.567-.194.633-1.372.283-1.657a2.292 2.292 0 0 0-2.027 0 3.214 3.214 0 0 0-.567 2.682c0-.195.349-.13.283-.414z'/%3e%3cpath fill='%23fc0' d='M448.8 265.318c-.85 0-2.028.349-2.094.938a3.7 3.7 0 0 0 0 .85c.066.349.2.5.5.567.85.2 1.22-.784 1.374-1.5 0-.13 0-.567.195-.72.35-.13.284-.066.35-.13a.786.786 0 0 0-.2.283c-.195.5-.195 1.068-.5 1.81-.13.567-1.22.784-1.591.436a2 2 0 0 1-.283-1.94 3.394 3.394 0 0 1 2.594-.939c-.13.066-.13.414-.35.35'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M448.8 265.318c-.85 0-2.028.349-2.094.938a3.7 3.7 0 0 0 0 .85c.066.349.2.5.5.567.85.2 1.22-.784 1.374-1.5 0-.13 0-.567.195-.72.35-.13.284-.066.35-.13a.786.786 0 0 0-.2.283c-.195.5-.195 1.068-.5 1.81-.13.567-1.22.784-1.591.436a2 2 0 0 1-.283-1.94 3.394 3.394 0 0 1 2.594-.939c-.13.066-.13.414-.35.35'/%3e%3cpath fill='%23fc0' d='M448.584 264.948a.465.465 0 0 0-.066.632.384.384 0 0 0 .567.13.592.592 0 0 0 .35-.85c-.2-.282-.5-.065-.851.067'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M448.584 264.948a.465.465 0 0 0-.066.632.384.384 0 0 0 .567.13.592.592 0 0 0 .35-.85c-.2-.282-.5-.065-.851.067z'/%3e%3cpath fill='%23fc0' d='M443.723 261.833a14.4 14.4 0 0 0 4.424 1 5.372 5.372 0 0 0 .5 2.226 6.527 6.527 0 0 0-2.594.065 9.683 9.683 0 0 0-2.311-3.334'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M443.723 261.833a14.4 14.4 0 0 0 4.424 1 5.372 5.372 0 0 0 .5 2.226 6.538 6.538 0 0 0-2.594.065 9.683 9.683 0 0 0-2.311-3.334z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M445.685 263.05a5.737 5.737 0 0 0 1.809.418 1.722 1.722 0 0 0 .2.848 2.9 2.9 0 0 0-1 .065 3.354 3.354 0 0 0-1-1.354z'/%3e%3cpath fill='%23fc0' d='M448.8 266.823s.414-.785.567-1.068c.065-.13-.065.937.349 1.068a5.161 5.161 0 0 1 .719 2.593 2.354 2.354 0 0 1-2.18.066c-.348-.2-.066-.784 0-1.286a5.307 5.307 0 0 1 .5-1.374'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M448.8 266.823s.414-.785.567-1.068c.065-.13-.065.937.349 1.068a5.161 5.161 0 0 1 .719 2.593 2.354 2.354 0 0 1-2.18.066c-.348-.2-.066-.784 0-1.286a5.307 5.307 0 0 1 .5-1.374z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M449.237 266.19a4.369 4.369 0 0 0 .067.567c0-.2.194.2.282.284a5.6 5.6 0 0 1 .567 2.31m-.7-2.092a6.857 6.857 0 0 1 .348 2.245l.13-.065m-.478-1.308c.13.632.065 1 .13 1.373l-.282.13'/%3e%3cpath fill='%23004bb3' d='M471.452 314.213c1.81 1.658 5.21 2.528 5.8 2.97a10.871 10.871 0 0 0 6.147 2.31c2.247.195 3.249-.419 5.582-.72 2.681-.285-.35.128 2.246-.42a25.884 25.884 0 0 1 3.117-.93c1.286-.352 2.594-.637 3.4-1.725a2.8 2.8 0 0 0 .567-1.44h1.743c.2.5-.282 1.44-.5 1.808-.066.135-.283.436-.414.659a2.166 2.166 0 0 1-.633.78c-.131.068-.72.57-.871.632a2.267 2.267 0 0 1-1.07.636 25.757 25.757 0 0 0-4.054 1.155c-1.591.413-.72.346-1.875.63-.632.13-1.787.57-2.376.631-1.067.195-1.22.352-2.31.57a27.572 27.572 0 0 1-8.328.285 14.051 14.051 0 0 1-4.927-1.29c-1.744-1.222-5.515-1.719-7.238-2.9a16.251 16.251 0 0 1-1.5-.854c-1.57-1.373-2.965-1.72-4.622-2.813h12.252'/%3e%3cpath fill='%23fff' d='M484.793 314.213c1.22.636 1.81 1.658 5.21 2.746 1.286 0 2.747.57 3.99.5-1.5.352-1.5.57-2.747.854-2.594.563.414.129-2.245.413-2.311.285-3.336.938-5.581.72a10.547 10.547 0 0 1-6.147-2.31c-.567-.413-3.99-1.29-5.8-2.97h13.342'/%3e%3cpath fill='%23004bb3' d='M484.793 314.213h13.56a2.941 2.941 0 0 1-.567 1.44c-.785 1.072-2.093 1.374-3.4 1.724-1.44.28-2.9-.419-4.34-.419-3.553-1.064-3.988-2.242-5.209-2.745'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='M471.67 314.213s-2.377.135-2.53.135c-.13 0-9.7-.135-9.7-.135'/%3e%3cpath fill='none' stroke='%23000b73' stroke-width='.232' d='M471.67 314.28s-2.377.129-2.53.2c-.282.068-9.634-.127-9.634-.127'/%3e%3cpath fill='none' stroke='%23001379' stroke-width='.232' d='M471.736 314.37s-2.312.195-2.66.279c-.35 0-9.5-.279-9.5-.279'/%3e%3cpath fill='none' stroke='%2300187e' stroke-width='.232' d='M471.736 314.37s-2.224.279-2.748.346c-.5.133-9.352-.285-9.352-.285'/%3e%3cpath fill='none' stroke='%23002086' stroke-width='.232' d='M471.736 314.43s-2.16.286-2.748.42c-.633.128-9.265-.42-9.265-.42'/%3e%3cpath fill='none' stroke='%2300258b' stroke-width='.232' d='M471.736 314.43s-2.094.42-2.813.57c-.72.129-9.134-.5-9.134-.5'/%3e%3cpath fill='none' stroke='%23002b91' stroke-width='.232' d='M471.736 314.43s-2.029.5-2.9.721c-.851.195-8.981-.564-8.981-.564'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M471.8 314.5s-2.027.569-3.03.786c-.937.128-8.85-.72-8.85-.72'/%3e%3cpath fill='none' stroke='%2300389e' stroke-width='.232' d='M471.8 314.587s-1.94.63-3.03.848c-1.068.2-8.763-.786-8.763-.786'/%3e%3cpath fill='none' stroke='%23003ea6' stroke-width='.232' d='M471.8 314.587a28.816 28.816 0 0 1-3.116 1c-1.221.2-8.634-.848-8.634-.848'/%3e%3cpath fill='none' stroke='%230046ad' stroke-width='.232' d='M471.8 314.649a16.8 16.8 0 0 1-3.116 1c-1.374.285-8.546-.937-8.546-.937'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M459.33 314.213h12.34'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M460.2 314.805s6.956 1.284 8.416 1a14.794 14.794 0 0 0 3.248-1.155'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='M473.48 319.643s4.425.631 4.555.631c.066 0 2.595-.194 2.682-.194l2.18-.5'/%3e%3cpath fill='none' stroke='%23001178' stroke-width='.232' d='M473.2 319.577s4.556.72 4.926.636c.13-.068 2.464-.2 2.53-.2.13 0 2.026-.413 2.026-.413'/%3e%3cpath fill='none' stroke='%2300187e' stroke-width='.232' d='M472.978 319.447a41.727 41.727 0 0 0 5.144.632c.2 0 2.312-.129 2.53-.129.13 0 1.809-.434 1.809-.434'/%3e%3cpath fill='none' stroke='%23002086' stroke-width='.232' d='M472.672 319.292a45.361 45.361 0 0 0 5.429.72c.348 0 2.245-.128 2.463-.128.2-.068 1.656-.352 1.656-.352'/%3e%3cpath fill='none' stroke='%23002b91' stroke-width='.232' d='M472.454 319.23a46.678 46.678 0 0 0 5.647.721c.414-.068 2.092-.134 2.463-.2.283 0 1.438-.194 1.438-.194'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M472.171 319.074s4.992 1 6.016.787c.5-.067 1.94-.128 2.312-.194a11.961 11.961 0 0 0 1.351-.2'/%3e%3cpath fill='none' stroke='%230039a0' stroke-width='.232' d='M471.953 319.013s5.08 1 6.234.781c.634-.061 1.876-.195 2.224-.195.414-.068 1.221-.128 1.221-.128'/%3e%3cpath fill='none' stroke='%230045ab' stroke-width='.232' d='M471.67 318.923s5.21 1.066 6.517.787a14.413 14.413 0 0 1 2.224-.194 7.546 7.546 0 0 1 1-.069'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='m473.7 319.794 4.338.57 2.682-.134 2.31-.564'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M471.452 318.8s5.362 1.155 6.8.848a17.631 17.631 0 0 1 2.966-.284m11.4.09s2.812-1 4.207-1.508a4.7 4.7 0 0 0 2.9-3.616m-7.39 4.252s1.655-.636 3.116-1.155c3.685-1.44 3.248-3.185 3.248-3.185'/%3e%3cpath fill='none' stroke='%23003ca2' stroke-width='.232' d='M492.118 318.706s2.158-.787 3.335-1.223a16.064 16.064 0 0 0 1.723-.78 5.436 5.436 0 0 0 1.286-1.222 2.928 2.928 0 0 0 .282-1.223'/%3e%3cpath fill='none' stroke='%23002d93' stroke-width='.232' d='M491.833 318.923s2.748-1 3.62-1.372c.35-.129 1.374-.57 1.656-.72a13.886 13.886 0 0 0 1.374-1.156 4.488 4.488 0 0 0 .415-1.44'/%3e%3cpath fill='none' stroke='%23001e85' stroke-width='.232' d='M491.616 319.074s3.27-1.155 3.837-1.373c.284-.128 1.44-.63 1.591-.72a8.026 8.026 0 0 0 1.5-1.217 11.121 11.121 0 0 0 .414-1.506'/%3e%3cpath fill='none' stroke='%23000f75' stroke-width='.232' d='M491.333 319.292s3.837-1.373 4.12-1.5c.066-.069 1.505-.57 1.591-.632a15.048 15.048 0 0 0 1.5-1.222 12.191 12.191 0 0 0 .566-1.59'/%3e%3cpath fill='none' stroke='%23003ca2' stroke-width='.232' d='M492.336 319.447s3.4-1.221 4.491-1.656a4.684 4.684 0 0 0 2.027-1.507 5.616 5.616 0 0 0 .785-1.936'/%3e%3cpath fill='none' stroke='%23002d93' stroke-width='.232' d='M491.987 319.447s4.055-1.438 4.927-1.807a5.422 5.422 0 0 0 1.874-1.44 6.909 6.909 0 0 0 .72-1.875'/%3e%3cpath fill='none' stroke='%23001e85' stroke-width='.232' d='M491.681 319.516s4.71-1.814 5.277-1.943a11.839 11.839 0 0 0 1.809-1.373 9.3 9.3 0 0 0 .633-1.875'/%3e%3cpath fill='none' stroke='%23000f75' stroke-width='.232' d='M491.4 319.516s5.276-2.033 5.582-2.094a17.531 17.531 0 0 0 1.721-1.289c.132-.195.655-1.808.655-1.808'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='m491.115 319.516 5.93-2.25 1.591-1.222.567-1.719'/%3e%3cpath fill='none' stroke='%2300066d' stroke-width='.232' d='M498 314.213s-2.53.135-2.594.135c-.131 0-10.137-.135-10.137-.135'/%3e%3cpath fill='none' stroke='%23000b73' stroke-width='.232' d='M498 314.28s-2.464.129-2.682.2c-.283.068-10-.127-10-.127'/%3e%3cpath fill='none' stroke='%23001379' stroke-width='.232' d='M498.069 314.37s-2.377.195-2.812.279c-.35 0-9.853-.279-9.853-.279'/%3e%3cpath fill='none' stroke='%2300187e' stroke-width='.232' d='M498.069 314.37s-2.31.279-2.812.346c-.5.133-9.788-.285-9.788-.285'/%3e%3cpath fill='none' stroke='%23002086' stroke-width='.232' d='M498.069 314.43s-2.245.286-2.9.42c-.632.128-9.634-.42-9.634-.42'/%3e%3cpath fill='none' stroke='%2300258b' stroke-width='.232' d='M498.069 314.43s-2.158.42-2.9.57c-.784.129-9.57-.5-9.57-.5'/%3e%3cpath fill='none' stroke='%23002b91' stroke-width='.232' d='M498.069 314.43s-2.092.5-2.964.721c-.85.195-9.418-.564-9.418-.564'/%3e%3cpath fill='none' stroke='%23039' stroke-width='.232' d='M498.157 314.5s-2.093.569-3.118.786c-1 .128-9.265-.72-9.265-.72'/%3e%3cpath fill='none' stroke='%2300389e' stroke-width='.232' d='M498.157 314.587a32.112 32.112 0 0 1-3.184.848c-1.068.2-9.134-.786-9.134-.786'/%3e%3cpath fill='none' stroke='%23003ea6' stroke-width='.232' d='M498.222 314.587s-2.027.72-3.249 1c-1.286.2-8.98-.848-8.98-.848'/%3e%3cpath fill='none' stroke='%230046ad' stroke-width='.232' d='M498.222 314.649a18.954 18.954 0 0 1-3.336 1c-1.373.285-8.85-.937-8.85-.937'/%3e%3cpath fill='none' stroke='%23006' stroke-width='.232' d='M485.163 314.213H498'/%3e%3cpath fill='none' stroke='%23004bb3' stroke-width='.232' d='M486.036 314.805s7.325 1.284 8.85 1a18.246 18.246 0 0 0 3.336-1.155'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.232' d='M500.1 314.213c.2.5-.282 1.44-.5 1.814-.066.129-.284.436-.415.653a2.107 2.107 0 0 1-.632.781c-.131.068-.72.57-.873.636a2.292 2.292 0 0 1-1.067.631 26.258 26.258 0 0 0-4.055 1.156c-1.591.413-.72.346-1.875.63-.633.134-1.788.569-2.377.63-1.068.2-1.22.352-2.31.57a27.57 27.57 0 0 1-8.328.285 13.908 13.908 0 0 1-4.926-1.29c-1.744-1.216-5.516-1.718-7.238-2.9a14.677 14.677 0 0 1-1.5-.854c-1.57-1.373-2.966-1.719-4.623-2.807'/%3e%3cpath fill='%23fc0' d='m550.673 314.213-49.028-81.964-48.963 81.964H550.7'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.58' d='m550.673 314.213-49.028-81.964-48.963 81.964h97.991z'/%3e%3cpath fill='%23fff' d='m545.964 311.534-44.319-73.99-44.166 73.99h88.507'/%3e%3cpath fill='none' stroke='%23fff' stroke-width='.173' d='m545.964 311.534-44.319-73.99-44.166 73.99h88.485z'/%3e%3cpath fill='none' stroke='%2300a8ff' stroke-width='.232' d='M493.95 250.516a10.875 10.875 0 0 1 7.608-2.68h.195c2.813 0 5.712.72 7.609 2.68'/%3e%3cpath fill='none' stroke='%23009eff' stroke-width='.232' d='M493.95 250.582c2.026-1.942 4.62-2.595 7.608-2.679h.195c2.9 0 5.865.714 7.674 2.68'/%3e%3cpath fill='none' stroke='%230096ff' stroke-width='.232' d='M493.862 250.65a10.694 10.694 0 0 1 7.7-2.685h.195c2.965 0 5.93.72 7.761 2.746'/%3e%3cpath fill='none' stroke='%23008bff' stroke-width='.232' d='M493.8 250.8c2.028-2.027 4.775-2.746 7.762-2.746h.282c2.965 0 5.93.72 7.827 2.813'/%3e%3cpath fill='none' stroke='%230082ff' stroke-width='.232' d='M493.731 250.867c2.027-2.032 4.84-2.747 7.892-2.813h.2c3.03.066 6.016.781 7.914 2.964'/%3e%3cpath fill='none' stroke='%230079ff' stroke-width='.232' d='M493.644 250.934c2.027-2.1 4.84-2.814 7.979-2.814h.2c3.117.062 6.082.849 7.978 3.031'/%3e%3cpath fill='none' stroke='%23006fff' stroke-width='.232' d='M493.644 251.084c1.961-2.093 4.84-2.9 7.979-2.9h.2c3.247.068 6.148.854 8.11 3.12'/%3e%3cpath fill='none' stroke='%231609ff' stroke-width='.232' d='M493.077 251.955c2.311-2.461 5.21-3.181 8.633-3.181h.195c3.772.061 6.956 1.283 8.852 3.9'/%3e%3cpath fill='none' stroke='%231316ff' stroke-width='.232' d='M493.143 251.826c2.245-2.31 5.144-3.03 8.545-3.12h.2c3.684.068 6.8 1.29 8.7 3.84'/%3e%3cpath fill='none' stroke='%231120ff' stroke-width='.232' d='M493.207 251.737c2.246-2.377 5.059-3.12 8.393-3.12h.2c3.618.067 6.8 1.223 8.7 3.773'/%3e%3cpath fill='none' stroke='%230f2dff' stroke-width='.232' d='M493.207 251.67c2.246-2.31 5.059-3.03 8.393-3.114h.2c3.553.061 6.67 1.155 8.633 3.683'/%3e%3cpath fill='none' stroke='%230938ff' stroke-width='.232' d='M493.36 251.52c2.093-2.244 4.927-2.964 8.263-2.964h.13c3.554 0 6.671 1 8.633 3.55'/%3e%3cpath fill='none' stroke='%230645ff' stroke-width='.232' d='M493.36 251.452c2.093-2.243 4.993-2.962 8.2-2.962h.195c3.466 0 6.584.937 8.48 3.4'/%3e%3cpath fill='none' stroke='%23054fff' stroke-width='.232' d='M493.426 251.39c2.027-2.248 4.927-2.968 8.11-2.968h.2c3.4 0 6.43.854 8.415 3.338'/%3e%3cpath fill='none' stroke='%23025cff' stroke-width='.232' d='M493.513 251.235c1.94-2.16 4.84-2.9 8.045-2.9h.13c3.4 0 6.453.78 8.393 3.247'/%3e%3cpath fill='none' stroke='%23ff0500' stroke-width='.232' d='M496.762 245.655a7.9 7.9 0 0 1 4.838-1.284 8.348 8.348 0 0 1 4.84 1.217'/%3e%3cpath fill='none' stroke='%23ff0b00' stroke-width='.232' d='M496.762 245.721a7.92 7.92 0 0 1 4.838-1.289 8.366 8.366 0 0 1 4.84 1.222'/%3e%3cpath fill='none' stroke='%23f10' stroke-width='.232' d='M496.7 245.788a8.278 8.278 0 0 1 4.928-1.29 9 9 0 0 1 4.992 1.223'/%3e%3cpath fill='none' stroke='%23ff1800' stroke-width='.232' d='M496.7 245.938a8.208 8.208 0 0 1 4.928-1.372 9.394 9.394 0 0 1 4.992 1.222'/%3e%3cpath fill='none' stroke='%23ff1e00' stroke-width='.232' d='M496.63 246.005a8.448 8.448 0 0 1 4.993-1.373 9.117 9.117 0 0 1 5.058 1.285'/%3e%3cpath fill='none' stroke='%23ff2500' stroke-width='.232' d='M496.544 246.067a8.821 8.821 0 0 1 5.056-1.374 9.122 9.122 0 0 1 5.058 1.29'/%3e%3cpath fill='none' stroke='%23ff2d00' stroke-width='.232' d='M496.544 246.224a7.963 7.963 0 0 1 5.056-1.44 9.471 9.471 0 0 1 5.146 1.283'/%3e%3cpath fill='none' stroke='%23f30' stroke-width='.232' d='M496.478 246.285a8.476 8.476 0 0 1 5.145-1.435 8.8 8.8 0 0 1 5.21 1.374'/%3e%3cpath fill='none' stroke='%23ff3900' stroke-width='.232' d='M496.478 246.374a8.363 8.363 0 0 1 5.145-1.44 9.184 9.184 0 0 1 5.276 1.373'/%3e%3cpath fill='none' stroke='%23ff3e00' stroke-width='.232' d='M496.412 246.44a8.662 8.662 0 0 1 5.212-1.44 9.522 9.522 0 0 1 5.275 1.374'/%3e%3cpath fill='none' stroke='%23ff4500' stroke-width='.232' d='M496.324 246.525a8.761 8.761 0 0 1 5.276-1.434 10.243 10.243 0 0 1 5.364 1.372'/%3e%3cpath fill='none' stroke='%23fff500' stroke-width='.232' d='M495.235 248.467a11.8 11.8 0 0 1 12.97 0'/%3e%3cpath fill='none' stroke='%23ffeb00' stroke-width='.232' d='M495.322 248.339a10.765 10.765 0 0 1 6.366-1.876 10.516 10.516 0 0 1 6.453 1.937'/%3e%3cpath fill='none' stroke='%23ffe000' stroke-width='.232' d='M495.388 248.249a11.631 11.631 0 0 1 12.665 0'/%3e%3cpath fill='none' stroke='%23ffd600' stroke-width='.232' d='M495.453 248.12a11.74 11.74 0 0 1 12.535 0'/%3e%3cpath fill='none' stroke='%23ffcf00' stroke-width='.232' d='M495.453 248.054a11.655 11.655 0 0 1 12.47 0'/%3e%3cpath fill='none' stroke='%23ffc500' stroke-width='.232' d='M495.54 247.9a10.689 10.689 0 0 1 6.17-1.814 9.995 9.995 0 0 1 6.147 1.876'/%3e%3cpath fill='none' stroke='%23ffb900' stroke-width='.232' d='M495.605 247.837a10.265 10.265 0 0 1 6.083-1.81 10.163 10.163 0 0 1 6.082 1.809'/%3e%3cpath fill='none' stroke='%23ffaf00' stroke-width='.232' d='M495.672 247.68a11.381 11.381 0 0 1 12.032 0'/%3e%3cpath fill='none' stroke='%23ffa600' stroke-width='.232' d='M495.76 247.619a9.8 9.8 0 0 1 5.95-1.725 10.215 10.215 0 0 1 5.93 1.725'/%3e%3cpath fill='none' stroke='%23ff9c00' stroke-width='.232' d='M495.824 247.462a9.78 9.78 0 0 1 5.864-1.651 10.34 10.34 0 0 1 5.864 1.65'/%3e%3cpath fill='none' stroke='%23ff9100' stroke-width='.232' d='M495.824 247.4a10.157 10.157 0 0 1 5.864-1.657 10.339 10.339 0 0 1 5.777 1.591'/%3e%3cpath fill='none' stroke='%23ff8600' stroke-width='.232' d='M495.954 247.245a9.51 9.51 0 0 1 5.734-1.657 9.663 9.663 0 0 1 5.712 1.657'/%3e%3cpath fill='none' stroke='%23ff7c00' stroke-width='.232' d='M495.954 247.183a9.7 9.7 0 0 1 5.734-1.657 10.325 10.325 0 0 1 5.712 1.59'/%3e%3cpath fill='none' stroke='%23ff7500' stroke-width='.232' d='M496.042 247.027a10.7 10.7 0 0 1 11.227 0'/%3e%3cpath fill='none' stroke='%23ff6b00' stroke-width='.232' d='M496.107 246.966a9.189 9.189 0 0 1 5.582-1.6 9.517 9.517 0 0 1 5.492 1.53'/%3e%3cpath fill='none' stroke='%23ff6000' stroke-width='.232' d='M496.172 246.81a9.365 9.365 0 0 1 5.516-1.5 9.5 9.5 0 0 1 5.493 1.5'/%3e%3cpath fill='none' stroke='%23ff5600' stroke-width='.232' d='M496.26 246.748a8.526 8.526 0 0 1 5.428-1.507 10.107 10.107 0 0 1 5.428 1.44'/%3e%3cpath fill='none' stroke='%23ebff00' stroke-width='.232' d='M495.018 248.617a11.774 11.774 0 0 1 6.67-1.936 10.51 10.51 0 0 1 6.583 2.026'/%3e%3cpath fill='none' stroke='%23d6ff00' stroke-width='.232' d='M494.952 248.774a11.112 11.112 0 0 1 6.736-2.026 11.336 11.336 0 0 1 6.736 2.087'/%3e%3cpath fill='none' stroke='%23c2ff00' stroke-width='.232' d='M494.886 248.9a10.977 10.977 0 0 1 6.8-2.093 11.207 11.207 0 0 1 6.736 2.093'/%3e%3cpath fill='none' stroke='%23adff00' stroke-width='.232' d='M494.821 249.059a10.813 10.813 0 0 1 6.89-2.16 11.145 11.145 0 0 1 6.8 2.16'/%3e%3cpath fill='none' stroke='%239f0' stroke-width='.232' d='M494.734 249.12a11.094 11.094 0 0 1 6.889-2.154 11.278 11.278 0 0 1 6.953 2.153'/%3e%3cpath fill='none' stroke='%2385ff00' stroke-width='.232' d='M494.668 249.276a10.474 10.474 0 0 1 6.956-2.249 10.991 10.991 0 0 1 7.019 2.249'/%3e%3cpath fill='none' stroke='%236fff00' stroke-width='.232' d='M494.668 249.427a10.111 10.111 0 0 1 6.956-2.311 11.384 11.384 0 0 1 7.1 2.221'/%3e%3cpath fill='none' stroke='%235cff00' stroke-width='.232' d='M494.516 249.555a10.2 10.2 0 0 1 7.107-2.439 11.2 11.2 0 0 1 7.106 2.377'/%3e%3cpath fill='none' stroke='%2346ff00' stroke-width='.232' d='M494.451 249.644a10.3 10.3 0 0 1 7.172-2.377 11.374 11.374 0 0 1 7.172 2.31'/%3e%3cpath fill='none' stroke='%2305b9e2' stroke-width='.232' d='M494.08 250.3a10.908 10.908 0 0 1 7.608-2.528c2.747 0 5.712.72 7.543 2.528'/%3e%3cpath fill='none' stroke='%2309c5c6' stroke-width='.232' d='M494.167 250.3a10.551 10.551 0 0 1 7.543-2.68 11.3 11.3 0 0 1 7.542 2.529'/%3e%3cpath fill='none' stroke='%2311ccab' stroke-width='.232' d='M494.167 250.147a10.92 10.92 0 0 1 7.543-2.528c2.748 0 5.646.72 7.456 2.438'/%3e%3cpath fill='none' stroke='%2316d38f' stroke-width='.232' d='M494.233 250.058a10.482 10.482 0 0 1 7.455-2.529 11.166 11.166 0 0 1 7.39 2.467'/%3e%3cpath fill='none' stroke='%231cde6f' stroke-width='.232' d='M494.233 250.058a10.289 10.289 0 0 1 7.39-2.6c2.747 0 5.646.787 7.39 2.467'/%3e%3cpath fill='none' stroke='%2320e653' stroke-width='.232' d='M494.3 250a10.06 10.06 0 0 1 7.326-2.533 11.471 11.471 0 0 1 7.389 2.377'/%3e%3cpath fill='none' stroke='%2328ed38' stroke-width='.232' d='M494.386 249.93a10 10 0 0 1 7.238-2.53 11.281 11.281 0 0 1 7.323 2.373'/%3e%3cpath fill='none' stroke='%232df81c' stroke-width='.232' d='M494.386 249.862a10.094 10.094 0 0 1 7.238-2.528c2.593 0 5.58.786 7.323 2.4'/%3e%3cpath fill='none' stroke='red' stroke-width='.232' d='M506.419 245.5a8.148 8.148 0 0 0-4.774-1.223 7.724 7.724 0 0 0-4.774 1.289'/%3e%3cpath fill='none' stroke='%231800ff' stroke-width='.232' d='M510.844 252.893c-1.874-2.746-5.21-4.058-9.07-4.058-3.552 0-6.364.72-8.762 3.186'/%3e%3cpath fill='none' stroke='%2300b3ff' stroke-width='.232' d='M509.319 250.3c-1.876-1.808-4.775-2.528-7.609-2.528a11.224 11.224 0 0 0-7.695 2.594'/%3e%3cpath fill='none' stroke='%2306f' stroke-width='.232' d='M510.038 251.452c-2.028-2.377-5.058-3.18-8.415-3.18-3.118 0-6.083.72-8.11 2.9'/%3e%3cpath fill='none' stroke='%23ff0' stroke-width='.232' d='M508.316 248.617a10.8 10.8 0 0 0-6.585-2.026 11.285 11.285 0 0 0-6.582 1.942'/%3e%3cpath fill='none' stroke='%23ff4b00' stroke-width='.232' d='M507.007 246.525a10.055 10.055 0 0 0-5.363-1.434 8.291 8.291 0 0 0-5.276 1.59'/%3e%3cpath fill='none' stroke='%233f0' stroke-width='.232' d='M508.881 249.644a11.65 11.65 0 0 0-7.237-2.377 9.981 9.981 0 0 0-7.172 2.528'/%3e%3cpath fill='%230088e8' d='m470.514 289.539-13.058 21.974h88.507l-13.188-21.974h-62.239'/%3e%3cpath fill='none' stroke='%2300ccb3' stroke-width='.347' d='m470.514 289.539-13.058 21.974h88.507l-13.188-21.974h-62.261z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M504.02 302.378a7.146 7.146 0 0 0 3.9.065c1.875-.414 3.684-1.5 5.93-1.285 1.59.13 3.77 1.5 6.452 1.5 2.592 0 3.486-.937 5.8-1.374a8.622 8.622 0 0 1 4.124.2c1.96.349 2.963 1.5 6.3 1.22'/%3e%3cpath fill='none' stroke='%23fff' stroke-width='.637' d='M469.926 305.58a7.949 7.949 0 0 1 6.082-1.155c2.594.569 3.684 1.222 6.517 1.222 2.029-.067 3.839-1.437 5.952-1.437 3.467 0 3.62.718 6.737 1.286a8.59 8.59 0 0 0 5.624-1.071c1-.5 3.466-.412 4.709-.28a10.208 10.208 0 0 1 3.553 1.155 7.147 7.147 0 0 0 3.9.127c1.875-.563 3.619-1.808 5.93-1.5 1.591.13 3.77 1.721 6.388 1.721 2.68 0 3.555-1.065 5.776-1.59a8.937 8.937 0 0 1 4.208.2c1.958.412 2.963 1.724 6.3 1.44'/%3e%3cpath fill='none' stroke='%23fff' stroke-width='.463' d='M464.912 303.12a8.622 8.622 0 0 1 6.082-1c2.594.5 3.77 1.068 6.517 1.068 2.094-.065 3.838-1.286 5.93-1.286 3.554 0 3.62.632 6.737 1.155a8.61 8.61 0 0 0 2.594 0 12.38 12.38 0 0 0 3.117-.937c.85-.414 3.4-.349 4.621-.283a10.192 10.192 0 0 1 3.554 1.067 10.576 10.576 0 0 0 3.9.066c1.874-.5 3.684-1.591 5.93-1.352 1.59.13 3.835 1.592 6.452 1.5 2.593 0 3.554-.938 5.775-1.374a8.618 8.618 0 0 1 4.123.2c1.937.414 3.031 1.5 6.363 1.221'/%3e%3cpath fill='none' stroke='%23fff' stroke-width='.837' d='M460.355 310.29a7.381 7.381 0 0 1 6.083-1.222c2.594.57 3.77 1.378 6.517 1.29 2.094 0 3.9-1.591 5.93-1.591 3.554 0 3.619.781 6.737 1.5a8.783 8.783 0 0 0 2.66 0 14.505 14.505 0 0 0 3.03-1.216c.937-.5 3.4-.419 4.62-.284a7.61 7.61 0 0 1 3.554 1.284 7.447 7.447 0 0 0 3.99.066c1.874-.63 3.619-1.942 5.864-1.657 1.59.128 3.836 1.875 6.453 1.875 2.594 0 3.553-1.155 5.8-1.724 1.592-.413 2.378-.129 4.12.2 2.026.5 3.03 1.937 6.367 1.653'/%3e%3cpath fill='none' stroke='%23fff' stroke-width='.463' d='M461.51 306.15a9.247 9.247 0 0 1 6.148-1c2.595.5 3.772 1.071 6.519 1.071a8.369 8.369 0 0 0 2.66-.569'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.406' d='M474.94 301.876a9.349 9.349 0 0 1 3.4-.718c3.554 0 1.286 0 4.426.567.785.13 3.03.13 3.684-.415m30.934 10.007a13.356 13.356 0 0 0 3.117-1c.937-.436 3.335-.346 4.623-.195a12.449 12.449 0 0 1 3.55 1 8.123 8.123 0 0 0 3.907.063c1.875-.5 3.682-1.591 5.926-1.374 1.591.195 3.84 1.59 6.451 1.59'/%3e%3cpath fill='none' stroke='%23fff' stroke-width='.463' d='M522.814 301.506c2.59 0 3.55-.937 5.8-1.373a8.6 8.6 0 0 1 4.119.2c2.026.348 3.03 1.5 6.367 1.22'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M460.487 310.575a8.745 8.745 0 0 1 6.082-1c2.594.5 3.77 1.072 6.583 1.072 2.027-.067 3.837-1.29 5.952-1.29 3.465 0 3.618.631 6.67 1.156a8.419 8.419 0 0 0 2.594 0 10.1 10.1 0 0 0 3.118-.938 12.478 12.478 0 0 1 4.621-.194 8.869 8.869 0 0 1 3.554 1'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.837' d='M466.067 307.305a9.143 9.143 0 0 1 6.083-1c2.593.5 3.77 1.155 6.517 1.072 2.094-.067 3.838-1.29 5.93-1.223 3.553 0 3.684.57 6.736 1.156a8.81 8.81 0 0 0 2.594 0 12.409 12.409 0 0 0 3.117-1 14.1 14.1 0 0 1 4.623-.195 12.691 12.691 0 0 1 3.552 1 8.11 8.11 0 0 0 3.9.068c1.874-.419 3.684-1.507 5.93-1.38 1.722.2 3.989 1.6 6.451 1.6 2.595 0 3.554-.938 5.8-1.373a8.166 8.166 0 0 1 4.208.195c1.875.346 2.963 1.5 6.234 1.217'/%3e%3cpath fill='none' stroke='%23fff3f3' stroke-width='.232' d='M492.706 252.48a19.3 19.3 0 0 1 8.917-2.16 20.064 20.064 0 0 1 9.2 2.594l9.418 15.653a18.639 18.639 0 1 1-37.278.065l9.7-16.175z'/%3e%3cpath fill='none' stroke='%23fff3ef' stroke-width='.232' d='M501.624 250.516a20.028 20.028 0 0 1 9.133 2.594l9.2 15.436a18.345 18.345 0 1 1-36.69.064l9.57-15.957a19.825 19.825 0 0 1 8.763-2.16z'/%3e%3cpath fill='none' stroke='%23ffefef' stroke-width='.232' d='M501.624 250.732a19.342 19.342 0 0 1 8.98 2.595s9.134 15.152 9.134 15.219a18.138 18.138 0 1 1-36.275.065c0-.065 9.352-15.652 9.418-15.74a19.529 19.529 0 0 1 8.7-2.16z'/%3e%3cpath fill='none' stroke='%23ffefed' stroke-width='.232' d='M501.624 250.934a19.714 19.714 0 0 1 8.849 2.528c.065.061 8.982 14.93 8.982 15.084a17.833 17.833 0 1 1-35.665.065c0-.132 9.135-15.456 9.2-15.523a19.455 19.455 0 0 1 8.611-2.154z'/%3e%3cpath fill='none' stroke='%23ffedeb' stroke-width='.232' d='M501.624 251.235a19.494 19.494 0 0 1 8.7 2.466c.132.129 8.917 14.713 8.917 14.931a17.615 17.615 0 1 1-35.229 0c0-.131 8.982-15.215 9.135-15.3a18.785 18.785 0 0 1 8.48-2.093m0 .217a19.533 19.533 0 0 1 8.632 2.468c.131.06 8.763 14.494 8.763 14.712a17.4 17.4 0 1 1-34.792 0c0-.2 8.917-14.93 9.07-15.087a18.8 18.8 0 0 1 8.327-2.093'/%3e%3cpath fill='none' stroke='%23ffebe8' stroke-width='.232' d='M501.624 251.737a18.533 18.533 0 0 1 8.479 2.377c.2.129 8.633 14.213 8.633 14.5a17.113 17.113 0 1 1-34.226 0c0-.2 8.611-14.714 8.85-14.87a18.041 18.041 0 0 1 8.263-2.027z'/%3e%3cpath fill='none' stroke='%23ffebe6' stroke-width='.232' d='M501.624 251.955a18.484 18.484 0 0 1 8.414 2.377c.195.128 8.48 13.908 8.48 14.279a16.9 16.9 0 1 1-33.79 0c0-.284 8.48-14.5 8.763-14.652a17.757 17.757 0 0 1 8.11-2.027z'/%3e%3cpath fill='none' stroke='%23ffe8e6' stroke-width='.232' d='M501.624 252.172a18.23 18.23 0 0 1 8.26 2.378c.284.128 8.329 13.69 8.329 14.06a16.612 16.612 0 1 1-33.224 0c0-.348 8.328-14.277 8.612-14.428a17.425 17.425 0 0 1 7.978-2.032z'/%3e%3cpath fill='none' stroke='%23ffe8e2' stroke-width='.232' d='M501.624 252.48a17.263 17.263 0 0 1 8.109 2.31c.282.128 8.26 13.406 8.26 13.842a16.393 16.393 0 1 1-32.786 0c0-.348 8.2-13.993 8.48-14.217a17.386 17.386 0 0 1 7.891-1.935z'/%3e%3cpath fill='none' stroke='%23ffe6e0' stroke-width='.232' d='M501.624 252.675a17.233 17.233 0 0 1 8.043 2.31c.283.195 8.044 13.19 8.044 13.626a16.1 16.1 0 1 1-32.2 0c0-.415 7.978-13.777 8.328-13.994a17.624 17.624 0 0 1 7.76-1.942z'/%3e%3cpath fill='none' stroke='%23ffe6de' stroke-width='.232' d='M501.624 252.981a17.484 17.484 0 0 1 7.912 2.222c.349.194 7.978 12.906 7.978 13.408a15.881 15.881 0 1 1-31.761.087c0-.5 7.825-13.624 8.2-13.841a17.113 17.113 0 0 1 7.674-1.876'/%3e%3cpath fill='none' stroke='%23ffe2de' stroke-width='.232' d='M501.624 253.2a16.541 16.541 0 0 1 7.76 2.243 153.017 153.017 0 0 1 7.825 13.19 15.619 15.619 0 1 1-31.238.086c0-.567 7.673-13.343 8.109-13.623a16.808 16.808 0 0 1 7.543-1.874z'/%3e%3cpath fill='none' stroke='%23ffe2dc' stroke-width='.232' d='M501.624 253.417a15.949 15.949 0 0 1 7.607 2.243c.5.195 7.761 12.405 7.761 12.972a15.37 15.37 0 0 1-30.739.156v-.088c0-.566 7.457-13.12 7.979-13.4a15.754 15.754 0 0 1 7.39-1.875'/%3e%3cpath fill='none' stroke='%23ffe0d9' stroke-width='.232' d='M501.624 253.7a16.217 16.217 0 0 1 7.542 2.155c.5.285 7.608 12.1 7.608 12.755a15.151 15.151 0 1 1-30.3.066c0-.634 7.39-12.905 7.913-13.19a16.11 16.11 0 0 1 7.238-1.808zm0 .219a16.06 16.06 0 0 1 7.389 2.092c.5.346 7.543 11.967 7.543 12.62a15 15 0 0 1-14.933 14.934 14.845 14.845 0 0 1-14.868-14.865c0-.72 7.172-12.686 7.7-12.97a16.339 16.339 0 0 1 7.172-1.808'/%3e%3cpath fill='none' stroke='%23ffded6' stroke-width='.232' d='M501.624 254.2a17 17 0 0 1 7.323 2.031c.5.347 7.326 11.749 7.326 12.4a14.65 14.65 0 1 1-29.3.065c0-.718 7.02-12.468 7.543-12.751a15.78 15.78 0 0 1 7.107-1.725z'/%3e%3cpath fill='none' stroke='%23ffded3' stroke-width='.232' d='M501.624 254.415a16.1 16.1 0 0 1 7.17 2.033c.5.345 7.239 11.443 7.239 12.184a14.577 14.577 0 0 1-14.433 14.5 14.4 14.4 0 0 1-14.343-14.432c0-.785 6.8-12.183 7.39-12.557a16.016 16.016 0 0 1 6.953-1.725z'/%3e%3cpath fill='none' stroke='%23ffdcd3' stroke-width='.232' d='M501.624 254.723a15.6 15.6 0 0 1 7.019 1.942c.566.346 7.106 11.226 7.106 11.967a14.137 14.137 0 1 1-28.274.066c0-.785 6.67-11.966 7.325-12.318a15.116 15.116 0 0 1 6.8-1.657z'/%3e%3cpath fill='none' stroke='%23ffdcd1' stroke-width='.232' d='M501.624 254.94a14.631 14.631 0 0 1 6.887 1.943c.633.346 7.02 10.943 7.02 11.75a13.919 13.919 0 1 1-27.838.086c0-.85 6.517-11.747 7.237-12.1a14.811 14.811 0 0 1 6.67-1.656z'/%3e%3cpath fill='none' stroke='%23ffd9cf' stroke-width='.232' d='M501.624 255.158a14.521 14.521 0 0 1 6.8 1.942c.633.413 6.8 10.66 6.8 11.532a13.625 13.625 0 1 1-27.249.087c0-.937 6.387-11.446 7.02-11.88a14.693 14.693 0 0 1 6.583-1.659zm0 .285a14.022 14.022 0 0 1 6.67 1.874c.719.413 6.735 10.443 6.735 11.315a13.407 13.407 0 1 1-26.814.087c0-.937 6.235-11.228 6.955-11.664a13.77 13.77 0 0 1 6.453-1.59z'/%3e%3cpath fill='none' stroke='%23ffd6cc' stroke-width='.232' d='M501.624 255.66a13.437 13.437 0 0 1 6.517 1.876c.784.413 6.583 10.16 6.583 11.1a13.156 13.156 0 1 1-26.312.087c0-1 6.082-11.01 6.8-11.446a13.811 13.811 0 0 1 6.365-1.59z'/%3e%3cpath fill='none' stroke='%23ffd6c9' stroke-width='.232' d='M501.624 255.945a13.614 13.614 0 0 1 6.386 1.808c.785.413 6.517 9.942 6.517 10.88a12.905 12.905 0 1 1-25.81.065c0-1 5.8-10.727 6.671-11.23a13.659 13.659 0 0 1 6.235-1.523'/%3e%3cpath fill='none' stroke='%23ffd3c9' stroke-width='.232' d='M501.624 256.163a13.19 13.19 0 0 1 6.3 1.808c.785.5 6.366 9.636 6.366 10.661a12.688 12.688 0 1 1-25.376.066c0-1.068 5.734-10.51 6.519-11.011a13.557 13.557 0 0 1 6.147-1.524z'/%3e%3cpath fill='none' stroke='%23ffd3c6' stroke-width='.232' d='M501.624 256.38a12.556 12.556 0 0 1 6.147 1.808c.85.5 6.234 9.42 6.234 10.444a12.4 12.4 0 1 1-24.809.065c0-1.067 5.495-10.29 6.367-10.787a13 13 0 0 1 6.016-1.507z'/%3e%3cpath fill='none' stroke='%23ffd1c5' stroke-width='.232' d='M501.624 256.687a13.483 13.483 0 0 1 6.08 1.658c.85.5 6.083 9.2 6.083 10.287a12.187 12.187 0 1 1-24.373.066c0-1.068 5.363-10.007 6.3-10.57a13.187 13.187 0 0 1 5.864-1.44z'/%3e%3cpath fill='none' stroke='%23ffd1c2' stroke-width='.232' d='M501.624 256.9a12.737 12.737 0 0 1 5.95 1.657c.937.564 5.93 8.914 5.93 10.136a11.925 11.925 0 1 1-23.85 0c0-1.156 5.211-9.857 6.17-10.353a13.033 13.033 0 0 1 5.776-1.44z'/%3e%3cpath fill='none' stroke='%23ffcfc2' stroke-width='.232' d='M501.624 257.189a13.112 13.112 0 0 1 5.8 1.59c1 .565 5.864 8.7 5.864 9.919a11.663 11.663 0 0 1-23.325.029v-.027c0-1.221 4.992-9.572 6.017-10.136a12.5 12.5 0 0 1 5.646-1.373'/%3e%3cpath fill='none' stroke='%23ffcfbe' stroke-width='.232' d='M501.624 257.407a11.2 11.2 0 0 1 5.645 1.59c1 .564 5.733 8.48 5.733 9.723a11.413 11.413 0 1 1-22.825 0c0-1.22 4.841-9.353 5.865-9.917a12.387 12.387 0 0 1 5.582-1.373z'/%3e%3cpath fill='none' stroke='%23ffccbc' stroke-width='.232' d='M501.624 257.686a12.071 12.071 0 0 1 5.58 1.507c1 .57 5.58 8.2 5.58 9.483a11.161 11.161 0 0 1-22.322 0c0-1.287 4.708-9.138 5.71-9.724a12.342 12.342 0 0 1 5.428-1.284zm0 .224a11.455 11.455 0 0 1 5.427 1.5c1.067.654 5.428 7.98 5.428 9.266a10.911 10.911 0 1 1-21.821 0c0-1.286 4.556-8.852 5.645-9.483a11.011 11.011 0 0 1 5.276-1.283z'/%3e%3cpath fill='none' stroke='%23ffc9b9' stroke-width='.232' d='M501.624 258.127a11.472 11.472 0 0 1 5.362 1.5c1 .631 5.275 7.7 5.275 9.07a10.66 10.66 0 1 1-21.32 0c0-1.374 4.338-8.634 5.494-9.265a11.068 11.068 0 0 1 5.144-1.29z'/%3e%3cpath fill='none' stroke='%23ffc9b8' stroke-width='.232' d='M501.624 258.345a10.89 10.89 0 0 1 5.209 1.5c1.068.632 5.144 7.392 5.144 8.853a10.409 10.409 0 0 1-20.817.081v-.079c0-1.44 4.207-8.417 5.361-9.07a10.785 10.785 0 0 1 5.058-1.283z'/%3e%3cpath fill='none' stroke='%23ffc6b8' stroke-width='.232' d='M501.624 258.624a9.984 9.984 0 0 1 5.056 1.44c1.155.636 5.08 7.173 5.08 8.634a10.181 10.181 0 1 1-20.362 0c0-1.44 4.055-8.11 5.276-8.852a10.492 10.492 0 0 1 4.926-1.222z'/%3e%3cpath fill='none' stroke='%23ffc6b5' stroke-width='.232' d='M501.624 258.841a10.655 10.655 0 0 1 4.991 1.44c1.155.72 4.927 6.891 4.927 8.417a9.931 9.931 0 0 1-19.861 0c0-1.5 3.838-7.892 5.08-8.634a10.891 10.891 0 0 1 4.84-1.223z'/%3e%3cpath fill='none' stroke='%23ffc5b3' stroke-width='.232' d='M501.624 259.065a9.85 9.85 0 0 1 4.838 1.434c1.221.72 4.774 6.673 4.774 8.2a9.668 9.668 0 1 1-19.336 0c0-1.5 3.77-7.675 4.992-8.417a10.125 10.125 0 0 1 4.708-1.216zm0 .3a8.933 8.933 0 0 1 4.708 1.374c1.307.719 4.708 6.366 4.708 7.979a9.49 9.49 0 0 1-9.417 9.418 9.351 9.351 0 0 1-9.418-9.418c0-1.59 3.553-7.389 4.84-8.2a9.218 9.218 0 0 1 4.555-1.155z'/%3e%3cpath fill='none' stroke='%23ffc2af' stroke-width='.232' d='M501.624 259.583a9.85 9.85 0 0 1 4.555 1.29c1.286.781 4.556 6.233 4.556 7.825a9.167 9.167 0 1 1-18.334 0c0-1.591 3.4-7.171 4.71-7.98a9.408 9.408 0 0 1 4.49-1.156z'/%3e%3cpath fill='none' stroke='%23ffc2ad' stroke-width='.232' d='M501.624 259.868a9.534 9.534 0 0 1 4.49 1.222c1.286.782 4.424 5.93 4.424 7.608a8.916 8.916 0 1 1-17.832 0c0-1.657 3.183-6.955 4.556-7.764a9.539 9.539 0 0 1 4.338-1.065z'/%3e%3cpath fill='none' stroke='%23ffbead' stroke-width='.232' d='M501.624 260.086a8.939 8.939 0 0 1 4.337 1.223c1.373.786 4.272 5.645 4.272 7.389a8.666 8.666 0 1 1-17.331.036v-.034c0-1.723 3.03-6.737 4.426-7.54a9.471 9.471 0 0 1 4.272-1.072z'/%3e%3cpath fill='none' stroke='%23ffbeab' stroke-width='.232' d='M501.624 260.37a8.453 8.453 0 0 1 4.271 1.156c1.353.87 4.121 5.428 4.121 7.172a8.448 8.448 0 1 1-16.9 0c0-1.723 2.9-6.452 4.34-7.323a8.806 8.806 0 0 1 4.119-1z'/%3e%3cpath fill='none' stroke='%23ffbca8' stroke-width='.232' d='M501.624 260.589a9 9 0 0 1 4.118 1.154c1.44.849 3.99 5.21 3.99 6.955a8.142 8.142 0 1 1-16.284 0c0-1.81 2.66-6.235 4.12-7.1a9.386 9.386 0 0 1 4.055-1'/%3e%3cpath fill='none' stroke='%23ffbca6' stroke-width='.232' d='M501.624 260.806a8.352 8.352 0 0 1 3.988 1.155c1.439.848 3.9 4.928 3.9 6.737a7.946 7.946 0 1 1-15.892.046v-.044c0-1.81 2.529-6.017 4.054-6.888a8.825 8.825 0 0 1 3.9-1z'/%3e%3cpath fill='none' stroke='%23ffb9a6' stroke-width='.232' d='M501.624 261.113a7.627 7.627 0 0 1 3.835 1.065c1.5.849 3.838 4.71 3.838 6.52a7.674 7.674 0 0 1-15.348.087v-.085c0-1.875 2.311-5.8 3.9-6.67a8.414 8.414 0 0 1 3.77-.938z'/%3e%3cpath fill='none' stroke='%23ffb9a2' stroke-width='.232' d='M501.624 261.33a7.887 7.887 0 0 1 3.77 1.067c1.5.937 3.619 4.426 3.619 6.3a7.423 7.423 0 1 1-14.846.008v-.005c0-1.941 2.158-5.493 3.837-6.452a7.347 7.347 0 0 1 3.619-.937z'/%3e%3cpath fill='none' stroke='%23ffb8a0' stroke-width='.232' d='M501.624 261.615a7.019 7.019 0 0 1 3.618 1c1.5.938 3.553 4.12 3.553 6.084a7.172 7.172 0 1 1-14.344 0c0-1.941 2.026-5.275 3.618-6.235a7.235 7.235 0 0 1 3.554-.848m0 .218a7.085 7.085 0 0 1 3.466 1 8.46 8.46 0 0 1 3.4 5.867 6.921 6.921 0 1 1-13.842 0 8.2 8.2 0 0 1 3.554-5.928 6.1 6.1 0 0 1 3.4-.937z'/%3e%3cpath fill='none' stroke='%23ffb59e' stroke-width='.232' d='M501.624 262.05a6.215 6.215 0 0 1 3.4 1 7.717 7.717 0 0 1 3.247 5.648 6.7 6.7 0 1 1-13.406 0 7.949 7.949 0 0 1 3.4-5.8 7.347 7.347 0 0 1 3.335-.847z'/%3e%3cpath fill='none' stroke='%23ffb59c' stroke-width='.232' d='M501.624 262.33a5.668 5.668 0 0 1 3.247.937 7.08 7.08 0 0 1 3.117 5.43 6.42 6.42 0 1 1-12.839 0 7.185 7.185 0 0 1 3.247-5.582 6.488 6.488 0 0 1 3.183-.787z'/%3e%3cpath fill='none' stroke='%23ffb39c' stroke-width='.232' d='M501.624 262.553a6.589 6.589 0 0 1 3.116.847 6.441 6.441 0 0 1 3.03 5.276 6.191 6.191 0 1 1-12.382.087 6.56 6.56 0 0 1 3.183-5.43 5.9 5.9 0 0 1 3.03-.78z'/%3e%3cpath fill='none' stroke='%23ffb399' stroke-width='.232' d='M501.624 274.671a5.838 5.838 0 0 0 5.862-5.814v-.05a5.9 5.9 0 1 0-5.863 5.864'/%3e%3cpath fill='none' stroke='%23fff' stroke-width='.173' d='M501.624 274.736a5.93 5.93 0 1 0-5.931-5.93 5.982 5.982 0 0 0 5.931 5.93'/%3e%3cpath fill='%23fff' d='M501.624 274.736a5.93 5.93 0 1 0-5.931-5.93 5.982 5.982 0 0 0 5.931 5.93'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='m502.93 262.92.633-3.118m-1.287 3.03.35-3.181m-1 3.18v-3.248m-.567 3.248-.283-3.18m-.37 3.27-.655-3.12m.065 3.338-1-3.12m.438 3.337-1.286-2.963m.762 3.18-1.656-2.745m1.09 3.1-1.876-2.593m1.44 3.03-2.246-2.465m1.722 2.9-2.377-2.159m2.028 2.682-2.594-1.94m2.224 2.378-2.812-1.593m2.506 2.159-2.964-1.286m2.747 1.874-3.03-1m2.833 1.57-3.117-.632m3.03 1.286-3.183-.35m3.183 1h-3.248m3.248.589-3.183.348m3.27.305-3.117.633m3.313-.044-3.117 1m3.335-.436-2.964 1.286m3.27-.7-3.466 2.094m3.75-1.592-6.955 4.991m7.39-4.49-7.543 6.584m7.914-6.147-6.155 6.89m6.649-6.517-4.621 6.3m5.144-5.865-4.84 8.482m5.407-8.263-2.68 6.147m3.269-5.864L497 283m3.314-8.327-1.155 5.71m1.81-5.645-.85 8.763m2.092-8.763.349 3.183m.305-3.248 1.875 8.262m-1.286-8.415 1.591 4.84m-1.025-5.06 3.772 8.11m-3.182-8.394 4.054 6.89m-3.553-7.26 5.8 7.608m-5.3-7.956 5.08 5.864m-4.645-6.3 7.544 6.8m-7.172-7.325 4.12 2.966m-3.75-3.467 2.812 1.592m-2.529-2.18 2.966 1.286m-2.748-1.852 3.03 1m-2.811-1.59 3.117.633m-3.052-1.287 3.183.349m-3.1-1h3.182m-3.27-.566 3.183-.283m-3.248-.305 3.117-.72m-3.336.065 3.118-1m-3.27.415 2.9-1.286m-3.184.719 2.813-1.592m-3.183 1.091 2.594-1.873m-2.943 1.35 2.377-2.16m-2.806 1.718 2.093-2.377m-2.615 1.94 1.874-2.532m-2.377 2.25 1.592-2.813m-2.18 2.528 1.286-2.963m-1.853 2.746 1-3.03m-2.9-4.884v-2.46m-2.747 2.744-.5-2.377m-2.2 3.248-1-2.243m-1.438 3.706-1.5-2.032m-.61 3.907-1.875-1.658m.218 3.99-2.18-1.289m1 3.816-2.377-.785m1.723 3.554-2.442-.2m2.442 3.03-2.442.284m3.095 2.528-2.462.72m27.052 1.9 2.18 1.22m-1-3.836 2.31.785m-1.743-3.531 2.441.282m-2.441-3.117 2.441-.195m-3.008-2.552 2.376-.785m-3.553-1.83 2.18-1.22m-3.837-1.027 1.875-1.742m-3.9-.15 1.373-2.032m-3.837.592 1-2.31m-3.772 1.35.5-2.378'/%3e%3cpath fill='%23e60000' d='M505.111 271.553a4.261 4.261 0 0 0-1.373-.414 17.848 17.848 0 0 0-3.62.13 1.842 1.842 0 0 0-.85.567 3.134 3.134 0 0 0 1.744.72 7.3 7.3 0 0 0 2.594-.2 5.4 5.4 0 0 0 1.5-.784'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M505.111 271.553a4.261 4.261 0 0 0-1.373-.414 17.848 17.848 0 0 0-3.62.13 1.842 1.842 0 0 0-.85.567 3.134 3.134 0 0 0 1.744.72 7.3 7.3 0 0 0 2.594-.2 5.4 5.4 0 0 0 1.5-.784z'/%3e%3cpath fill='%23e60000' d='M499.377 270.681A8.94 8.94 0 0 1 500.6 267a10.316 10.316 0 0 0-.567 1.068s-.632.35-1-.13c-.413-.349-.195-.5.066-1.157.282-.414.2-.849.567-1.154.282-.283.567-.349 1.373-.349a1.932 1.932 0 0 1 1.94 1c.567.784.938 1.5 1.222 1.94a5.1 5.1 0 0 1 .632 2.311l.2 1a4.254 4.254 0 0 0-1.374-.415 17.76 17.76 0 0 0-3.618.13 1.847 1.847 0 0 0-.85.568s-.348-.784.131-1.155'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M499.377 270.681A8.94 8.94 0 0 1 500.6 267a10.316 10.316 0 0 0-.567 1.068s-.632.35-1-.13c-.413-.349-.195-.5.066-1.157.282-.414.2-.849.567-1.154.282-.283.567-.349 1.373-.349a1.932 1.932 0 0 1 1.94 1c.567.784.938 1.5 1.222 1.94a5.1 5.1 0 0 1 .632 2.311l.2 1a4.254 4.254 0 0 0-1.374-.415 17.76 17.76 0 0 0-3.618.13 1.847 1.847 0 0 0-.85.568s-.348-.784.131-1.155z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M499.377 270.681a6.612 6.612 0 0 1 2.747-.348c2.528.065 2.594.195 2.748.414'/%3e%3cpath fill='%23fc0' d='M501.558 279.968v-8.7s.282-.282.937 0v8.632s.2 6.671-.5 6.585c-.851 0-.415-1.5-.415-6.52'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.173' d='M501.558 279.968v-8.7s.282-.282.937 0v8.632s.2 6.671-.5 6.585c-.851 0-.415-1.5-.415-6.52z'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.406' d='m545.964 311.534-44.319-73.99-44.166 73.99h88.485z'/%3e%3cpath fill='%23090' d='M467.245 295.054c.414.065 1.439-.72 1.722-.938.414-.2.632-.85.937-1.221a18.328 18.328 0 0 1 1.81-1.155 12.071 12.071 0 0 0 4.337-3.837 21.353 21.353 0 0 1 6.955-6.3 3.863 3.863 0 0 1 3.182.066 3.6 3.6 0 0 1 1 .718 13.867 13.867 0 0 0 4.708 2.16c1.875.566 2.31 1.808 3.77 3.116a9.808 9.808 0 0 0 2.465 1.592c.066.066.283.349.348.414.785.633 1.722 1.156 2.465 1.723 1.373 1.22 2.593 2.462 3.9 3.77.217.2.284.634.5.786a12.547 12.547 0 0 0 3.032 2.462 35.814 35.814 0 0 1 3.335 2.028c-11.249.415-21.539-.283-32.853.066h-2.092c-.785-.066-1.286 0-2.159 0-3.4 0-6.67 0-10.659-.066l3.183-5.428'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M467.245 295.054c.414.065 1.439-.72 1.722-.938.414-.2.632-.85.937-1.221a18.328 18.328 0 0 1 1.81-1.155 12.071 12.071 0 0 0 4.337-3.837 21.353 21.353 0 0 1 6.955-6.3 3.863 3.863 0 0 1 3.182.066 3.6 3.6 0 0 1 1 .718 13.867 13.867 0 0 0 4.708 2.16c1.875.566 2.31 1.808 3.77 3.116a9.808 9.808 0 0 0 2.465 1.592c.066.066.283.349.348.414.785.633 1.722 1.156 2.465 1.723 1.373 1.22 2.593 2.462 3.9 3.77.217.2.284.634.5.786a12.547 12.547 0 0 0 3.032 2.462 35.814 35.814 0 0 1 3.335 2.028c-11.249.415-21.539-.283-32.853.066h-2.092c-.785-.066-1.286 0-2.159 0-3.4 0-6.67 0-10.659-.066l3.183-5.428z'/%3e%3cpath fill='none' stroke='%2300b300' stroke-width='.173' d='M481.96 282.28c.566-.066.282-.2.784.13m-1.788.523c.567-.065.785-.414 1.222.065m-1.744.305a1.224 1.224 0 0 1 1.22.2m-1.788.524a2.18 2.18 0 0 1 1.287.065m-2.006.436c.567-.195.85.2 1.5.066m-2.245.675c.414 0 .5-.13.85 0 .436.066.349 0 .785.066m-2.42.654a4.451 4.451 0 0 1 .938 0 1.877 1.877 0 0 0 .85 0m-2.224.653a3.278 3.278 0 0 1 1.656.132m-2.833 1.4a2.056 2.056 0 0 1 1.656.065m-13.406 12.056c2.31-.35 5.08.065 7.39-.283m4.73-12.557c.567-.2.414-.131 1-.066.632.065.85.13 1 .065m-2.943 1.374a2.536 2.536 0 0 1 1.875 0m-.35.588a9.674 9.674 0 0 0-1.94 0m1.418.72a4.22 4.22 0 0 0-2.093-.131m-.872.633a7.887 7.887 0 0 1 2.464.064m-3.184.59a5.872 5.872 0 0 1 2.682.065m-3.553.435c.937-.065 1.809-.065 2.747-.065.13 0 .414-.13.567.065m-.262.524a26.7 26.7 0 0 1-4.208.13m3.4.59a13.183 13.183 0 0 1-1.788.13c-.065 0-.2-.13-.348-.13a7.386 7.386 0 0 0-2.093.195m-.349.524a1.176 1.176 0 0 1 .938-.066 16.015 16.015 0 0 1 2.528.2 2.132 2.132 0 0 0 .72.13m-4.687.11a9.04 9.04 0 0 1 1.875.065 14.934 14.934 0 0 0 2.376.348h-.065m-4.775.022a8.858 8.858 0 0 1 1.962.283c.85.13 1.81-.065 2.594.13m-5.34.023c.85.349 1.808.065 2.746.2.85.13 1.656.13 2.53.283m-5.865.24a28.553 28.553 0 0 1 4.054.2 3.343 3.343 0 0 0 1.5.13m-6.059.262a35.292 35.292 0 0 1 3.988.35 8.566 8.566 0 0 0 1.875.195h-.13m-6.257.458a.764.764 0 0 1 .35-.13c1.067 0 2.092.13 3.182.065a6.85 6.85 0 0 1 2.593.13h-.065m-6.562.589c2.094-.2 4.273.065 6.366 0m-6.736.654c2.245.195 4.49 0 6.671.195m-7.02.459c1 .2 1.94-.065 2.9.13a7.525 7.525 0 0 0 2.092.13 8.539 8.539 0 0 1 1.81-.064m9.09-9.265h.2m-.414.283c.065 0 .2-.13.2 0m-.5.37h.5m-.633.285h.567m-1 .37c.35 0 .633.066 1 .066h-.065m-1.22.435c.348-.13.783 0 1.155-.13h-.066m-1.613.719h1.526m-1.81.371a6.884 6.884 0 0 1 1.657.065m-2.027.5a10.346 10.346 0 0 1 2 .065m-2.377.523c.415-.065.786.2 1.222.283a1.879 1.879 0 0 0 .85-.065m-2.2.218a7.07 7.07 0 0 0 1.96.283m-2.331.218a5.567 5.567 0 0 1 1.591.283 2.619 2.619 0 0 0 .72 0m-3.03.524a3.637 3.637 0 0 1 2.245.13 3.1 3.1 0 0 0 .784 0h-.065m-3.03.37a3.708 3.708 0 0 1 2.376.132h.414m-3.313.523c1.068.2 2.18-.13 3.183.132m-3.466.3c.85.349 1.809 0 2.68.283a1.549 1.549 0 0 0 .939-.065m-4.186.437a2.232 2.232 0 0 1 1.155-.131 21.7 21.7 0 0 0 2.813.282m-4.491.5c.195 0 .414.13.632.065a38.281 38.281 0 0 1 3.836-.065m-4.752.5c1 .349 2.027 0 3.183.282a1.968 1.968 0 0 0 1.373 0m-4.927.46c1.5.064 3.03-.066 4.84.13m4.023-9.142c.13 0 .283.13.414.13m-.632.37a.85.85 0 0 1 .567-.065m-.7.5a1.625 1.625 0 0 1 .786.065m-1 .524a5.214 5.214 0 0 1 1 .065m-1.309.5c.414-.131.85.065 1.286-.066m-1.35.5a8.508 8.508 0 0 0 1.307.065v-.065m-1.526.653a3.466 3.466 0 0 1 1.155.066.48.48 0 0 0 .414-.065m-1.634.588c.567-.2 1.067.13 1.656 0m-1.875.72a16.791 16.791 0 0 0 1.81 0m-2.028.588c.2-.065.5-.282.785-.13a6.814 6.814 0 0 0 1.221.13m-2.159.654c.72-.283 1.44.131 2.159-.2m-2.224.85a2.565 2.565 0 0 1 1 0 2.849 2.849 0 0 0 1.286 0m-2.506.633a16.937 16.937 0 0 1 2.594-.066l-.065.065m-3.052.59c1.067-.066 2.245-.2 3.335-.2m-3.183.85a23.007 23.007 0 0 1 3.684-.13m-3.9.785a12.313 12.313 0 0 0 2.682-.066 9.007 9.007 0 0 0 1.44-.282h.718m-4.84.719c1.81-.132 3.772.13 5.647-.283m-13.777.064h1.5m5.69.219c.2.065.413-.067.5.065m6.606-.218c1.5-.13 3.03.283 4.557 0m-5.341-.5a5.571 5.571 0 0 1 2.811.13c.066 0 .066.131.131.2a10.148 10.148 0 0 0 2.442-.065m-10.77-.349h-1m-5.1-.218c-.631.065-1.286.065-2.026.13m14.8-14.343h.284m-.13.436a.835.835 0 0 0 .348-.066m-.282.72a.228.228 0 0 1 .064-.131h.414m-.326.567c.195-.13.414-.066.719-.066m.065.436a2.354 2.354 0 0 0-.632.131m.282.589a1.086 1.086 0 0 1 .633-.13m.305.5h-.937m.283.5a1.515 1.515 0 0 0 .938-.13m.24.7a2.507 2.507 0 0 0-1 .13m.2.61a1.845 1.845 0 0 0 1.156-.2m.088.414a9.5 9.5 0 0 1-1.069.284m.195.589c.415-.2 1 0 1.44-.13m.153.565a6.864 6.864 0 0 0-1.156 0 .684.684 0 0 1-.348.132m.26.959a1.537 1.537 0 0 1 .938-.284c0-.2.2 0 .348-.13.066-.066.2 0 .35 0m.261.633a7.322 7.322 0 0 0-1.656.13m.13.72c.633-.2 1.286-.2 1.962-.35m-1.9 1.156a10.883 10.883 0 0 0 2.158-.415m.523.48a8.556 8.556 0 0 0-2.377.349m.131.74a.681.681 0 0 0 .35.132 4.379 4.379 0 0 1 2.245-.5m.24.59a6.081 6.081 0 0 1-2.463.282c-.066 0-.132.066-.284.131m.283.545c.938-.13 1.81-.2 2.747-.349m.588.632c-.719.066-1.439-.065-2.158.066-.348.066-.654.2-1 .283m.11.589c.13 0 .283.065.349-.066a6.2 6.2 0 0 1 3.03-.348m.327.567a8.667 8.667 0 0 0-2.594.065 2.151 2.151 0 0 1-.939.282m.263.655c.5-.065.937-.283 1.373-.349a21.268 21.268 0 0 1 2.9-.065m0 .5a3.566 3.566 0 0 0-1.657 0 10.656 10.656 0 0 1-2.464.414m.5.457c.655-.065 1.286-.282 1.94-.414a6.983 6.983 0 0 1 1.657-.066m-3.6.85a20.4 20.4 0 0 0 3.03-.282c.35-.131.72.064 1.07 0m.042-.392c1.744.13 3.4-.2 5.08.13m-4.73.393c.195.065.348-.132.5-.132 1.374 0 2.748.065 4.208.132m-.5-3.554h.2m-.108.436c.13.066.349-.2.5 0m-.37.5h.851m-.633.72c.284-.349.72 0 1-.2m-.784.85c.349-.282.937.066 1.286-.282m-1.2.784c.566-.13 1.154.066 1.656-.282m-1.439.805c.85-.348 1.809.2 2.594-.414m-2.529.85c1.069-.349 2.18 0 3.248-.065m.676 0q2.79-.1 5.581 0m-6.387-.675c1.656.13 4.12 0 6.169.13'/%3e%3cpath fill='%23fc0' d='M511.434 300.22c-.939-.567-1.877-1.22-2.9-1.722a11.523 11.523 0 0 1-3.03-2.465c-.2-.13-.285-.565-.5-.784-1.286-1.286-2.528-2.528-3.9-3.77-.72-.568-1.657-1.07-2.464-1.723-.065-.065-.283-.349-.349-.414a9.37 9.37 0 0 1-2.463-1.59c-.938-.851-1.44-1.658-2.224-2.313v-.065c.5-.282 1-.632 1.5-.937a3.309 3.309 0 0 1 2.68.13 2.509 2.509 0 0 1 .851.5 11.631 11.631 0 0 0 3.9 1.875c1.592.414 1.941 1.438 3.183 2.53a6.893 6.893 0 0 0 1.94 1.285 4.486 4.486 0 0 1 .283.414 14.793 14.793 0 0 1 2.094 1.438q1.656 1.525 3.247 3.118c.131.131.2.5.35.654a11.014 11.014 0 0 0 2.593 2.027c.937.5 1.81 1.156 2.747 1.657-2.528.131-4.992.131-7.542.131h-.066'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M511.434 300.22c-.939-.567-1.877-1.22-2.9-1.722a11.523 11.523 0 0 1-3.03-2.465c-.2-.13-.285-.565-.5-.784-1.286-1.286-2.528-2.528-3.9-3.77-.72-.568-1.657-1.07-2.464-1.723-.065-.065-.283-.349-.349-.414a9.017 9.017 0 0 1-2.463-1.59c-.938-.851-1.44-1.658-2.224-2.313v-.065c.5-.282 1-.632 1.5-.937a3.309 3.309 0 0 1 2.68.13 2.509 2.509 0 0 1 .851.5 11.631 11.631 0 0 0 3.9 1.875c1.592.414 1.941 1.438 3.183 2.53a6.893 6.893 0 0 0 1.94 1.285 4.486 4.486 0 0 1 .283.414 14.793 14.793 0 0 1 2.094 1.438q1.656 1.525 3.247 3.118c.131.131.2.5.35.654a11.014 11.014 0 0 0 2.593 2.027c.937.5 1.81 1.156 2.747 1.657-2.528.131-4.992.131-7.542.131h-.066z'/%3e%3cpath fill='none' stroke='%2300b300' stroke-width='.173' d='M495.322 287.075c.131 0 1.222-.2 1.352-.2m-1 .48a3.524 3.524 0 0 0 1.44-.195m-.851.719 1-.2h.413m-.98.48c.131-.065 1.5 0 1.743-.065m.349.349a5.306 5.306 0 0 0-1.5.194m.937.612a3.238 3.238 0 0 1 1.22-.283m.654.5c-.348 0-1.067.066-1.439.066m.72.587a4.566 4.566 0 0 0 1.221-.282m.741.566c-.414 0-.937.065-1.439.065m.633.524a10.52 10.52 0 0 0 1.5-.065m.545.282a10.014 10.014 0 0 1-1.286.284m.632.59c.348-.2 1-.066 1.5-.2m.523.48a7.463 7.463 0 0 0-1.286.066 1.344 1.344 0 0 1-.349.065m3.161 1.025a7.9 7.9 0 0 0-1.81.13m.567.676a9.139 9.139 0 0 1 1.962-.35m-.5 2.094a4.592 4.592 0 0 0 .938-.065 8.04 8.04 0 0 1 2.092-.283m.523.414c-1.22.195-1.656.195-2.594.348-.13 0-.414.066-.5.066m.545.457c.937-.195 2.245-.13 3.183-.283m1.024.5c-.72.13-1.657 0-2.377.13-.282.065-.936.13-1.285.2m.915.61c.066 0 .284 0 .35-.065.719-.5 1.94-.35 3.029-.35m.763.48c-1.067 0-1.5 0-2.31.066a5.134 5.134 0 0 1-1.069.195m.83.61c1-.194 2.811-.348 1.721-.282 1-.066 1.156-.066 2.311-.066m.3.349a5.694 5.694 0 0 0-1.874.065 3.977 3.977 0 0 1-1.723.284m.567.306a5.1 5.1 0 0 0 1.44-.2 7.915 7.915 0 0 1 1.787-.065m-2.856.566a8.635 8.635 0 0 1 2.245-.065 4.649 4.649 0 0 0 .937-.065m-19.663-13.3a1.166 1.166 0 0 1 .85-.13c-.065-.2.2 0 .349-.131 0-.067.2 0 .349 0m-2.049-.241a1.455 1.455 0 0 1 .937-.065c-.131-.2.283 0 .283-.13.066-.066.283 0 .5 0m6.693 7.3a.841.841 0 0 1 .72-.131c-.13-.2.414 0 .5-.13 0-.066.5 0 .653 0m-.064 1.918a9.645 9.645 0 0 0 2.092-.414m1.025.72a12.626 12.626 0 0 0-2.594.348m-9.648-10.14c-.784-.066-.85.194-1.439.194'/%3e%3cpath fill='%23fc0' d='M501.405 286.487a5.1 5.1 0 0 1 1.068.348c1.591.414 1.94 1.438 3.183 2.528a6.791 6.791 0 0 0 1.94 1.286 4.815 4.815 0 0 1 .283.415 14.56 14.56 0 0 1 2.092 1.44q1.658 1.524 3.25 3.116c.13.131.2.5.348.654a11.029 11.029 0 0 0 2.594 2.028 17.206 17.206 0 0 1 2.31 1.438c2.094 0 4.121-.065 6.3-.13-.87-.5-1.59-1.068-2.527-1.5a9.343 9.343 0 0 1-2.312-1.875c-.13-.065-.2-.415-.349-.567q-1.449-1.44-2.964-2.812c-.567-.5-1.22-.85-1.875-1.374-.066 0-.195-.283-.283-.283a10.627 10.627 0 0 1-1.81-1.22c-1.067-1-1.439-1.875-2.9-2.312a13.141 13.141 0 0 1-3.554-1.656 2.516 2.516 0 0 0-.719-.5 2.974 2.974 0 0 0-2.463-.13 12.408 12.408 0 0 0-1.656 1.155'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M501.405 286.487a5.1 5.1 0 0 1 1.068.348c1.591.414 1.94 1.438 3.183 2.528a6.791 6.791 0 0 0 1.94 1.286 4.815 4.815 0 0 1 .283.415 14.56 14.56 0 0 1 2.092 1.44q1.658 1.524 3.25 3.116c.13.131.2.5.348.654a11.029 11.029 0 0 0 2.594 2.028 17.206 17.206 0 0 1 2.31 1.438c2.094 0 4.121-.065 6.3-.13-.87-.5-1.59-1.068-2.527-1.5a9.343 9.343 0 0 1-2.312-1.875c-.13-.065-.2-.415-.349-.567q-1.449-1.44-2.964-2.812c-.567-.5-1.22-.85-1.875-1.374-.066 0-.195-.283-.283-.283a10.627 10.627 0 0 1-1.81-1.22c-1.067-1-1.439-1.875-2.9-2.312a13.141 13.141 0 0 1-3.554-1.656 2.516 2.516 0 0 0-.719-.5 2.974 2.974 0 0 0-2.463-.13 12.408 12.408 0 0 0-1.656 1.155z'/%3e%3cpath fill='none' stroke='%2300b300' stroke-width='.173' d='M503.89 287.51c.065 0 .938-.13 1.068-.13m-.785.5c.5-.13.938 0 1.22-.2m-.783.633.849-.131a.915.915 0 0 1 .415-.066m-.829.546a9.581 9.581 0 0 1 1.5-.132m.3.35a11.5 11.5 0 0 0-1.439.195m.567.545a3.3 3.3 0 0 1 1.5-.2m.611.392c-.349 0-1.286.066-1.59.066m.5.458a5.6 5.6 0 0 0 1.592-.2m.567.545a10.025 10.025 0 0 0-1.352.064m.414.458a5.981 5.981 0 0 0 1.591-.13m.523.262a10.636 10.636 0 0 1-1.35.349m.7.457c.349-.195 1-.065 1.439-.195m.435.479a5.547 5.547 0 0 0-1.068.065c-.13 0-.2.13-.348.065m2.876.96a6.587 6.587 0 0 0-1.656.13m.5.61a10 10 0 0 1 1.874-.282m-.37 1.94c.13.065.567-.131.632-.131 1-.065 1.068-.283 2.027-.283m.48.413a11.1 11.1 0 0 1-2.4.284 1.55 1.55 0 0 0-.5.13m.479.393c.85-.13 2.093-.13 2.965-.2m.959.414c-.654.065-1.439 0-2.158.13-.282.067-.937.067-1.22.132m.849.61a.706.706 0 0 0 .349-.065 5.637 5.637 0 0 1 2.812-.349m.611.414a18.625 18.625 0 0 0-2.094.13c-.414.066-1 .2-1.067.2m.632.458c.937-.131 2.812-.283 1.81-.2.937-.065 1.154-.065 2.18-.065m.217.414a3.535 3.535 0 0 0-1.657 0 7.636 7.636 0 0 1-1.874.284m.48.283a12.094 12.094 0 0 0 1.591-.2 6.786 6.786 0 0 1 1.656-.065m-2.594.567a9.617 9.617 0 0 1 2.028-.131c.349 0 .5-.066.85-.066m-18.051-12.3c.2-.065.131-.131.5-.131.283-.065.5.066.567-.065a1.337 1.337 0 0 1 .349-.066m-2.071-.021c.282-.13.349-.284.719-.2.349-.065.5 0 .567-.13h.415m6.365 6.714c.195-.131.065-.2.5-.131-.13-.13.35 0 .415-.065a1.747 1.747 0 0 1 .654-.066m-.044 1.788a12.226 12.226 0 0 0 1.876-.349m.937.633a9.224 9.224 0 0 0-2.159.283m-9.068-9.287a2.679 2.679 0 0 0-1.723.567'/%3e%3cpath fill='%23fc0' d='M511.716 288.884a6.422 6.422 0 0 0 1 1.069 10.2 10.2 0 0 0 1.808 1.22c.067 0 .2.283.284.283.633.5 1.286.851 1.875 1.373 1 .939 1.94 1.81 2.965 2.813.131.131.2.5.348.567a9.4 9.4 0 0 0 2.312 1.875c.565.283 1.067.632 1.658.937h-.066c2.46 0 4.927 0 7.389-.065a14.952 14.952 0 0 0-2.026-1.222 9.092 9.092 0 0 1-1.876-1.5c-.133-.065-.133-.283-.284-.5-.781-.786-1.591-1.5-2.377-2.246a10.852 10.852 0 0 0-1.5-1.069c-.067-.065-.195-.195-.195-.282a5.763 5.763 0 0 1-1.506-.938c-.85-.785-1.068-1.591-2.246-1.874a8.571 8.571 0 0 1-2.9-1.374 2.859 2.859 0 0 0-.633-.414 2.7 2.7 0 0 0-1.94-.065 11.447 11.447 0 0 0-2.026 1.439'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M511.716 288.884a6.422 6.422 0 0 0 1 1.069 10.2 10.2 0 0 0 1.808 1.22c.067 0 .2.283.284.283.633.5 1.286.851 1.875 1.373 1 .939 1.94 1.81 2.965 2.813.131.131.2.5.348.567a9.4 9.4 0 0 0 2.312 1.875c.565.283 1.067.632 1.658.937h-.066c2.46 0 4.927 0 7.389-.065a14.952 14.952 0 0 0-2.026-1.222 9.092 9.092 0 0 1-1.876-1.5c-.133-.065-.133-.283-.284-.5-.781-.786-1.591-1.5-2.377-2.246a10.852 10.852 0 0 0-1.5-1.069c-.067-.065-.195-.195-.195-.282a5.763 5.763 0 0 1-1.506-.938c-.85-.785-1.068-1.591-2.246-1.874a8.571 8.571 0 0 1-2.9-1.374 2.859 2.859 0 0 0-.633-.414 2.7 2.7 0 0 0-1.94-.065 11.447 11.447 0 0 0-2.026 1.439z'/%3e%3cpath fill='none' stroke='%2300b300' stroke-width='.173' d='M512.588 289.756c.065 0 1.069-.13 1.069-.13m-.786.348a5.155 5.155 0 0 0 1.156-.13m-.72.5.785-.13c.065-.065.2 0 .349 0m-.85.414a4.846 4.846 0 0 1 1.374-.13m.239.282a2.858 2.858 0 0 0-1.068.131m.545.37a4.5 4.5 0 0 1 1-.13m.458.283c-.2 0-1 .066-1.221.066m.414.37a3.664 3.664 0 0 0 1.22-.195m.459.48h-1.07m.263.37a8.38 8.38 0 0 0 1.307-.066m.37.2a2.991 2.991 0 0 1-1.067.195m.348.393c.284-.131 1 0 1.286-.066m.437.285a3.948 3.948 0 0 0-.937.065h-.283m2.245.806a10.615 10.615 0 0 0-1.44.131m.5.37a9.225 9.225 0 0 1 1.5-.2m-.5 1.44a2.669 2.669 0 0 0 .72 0c.719-.066.85-.283 1.5-.2m.393.327c-.785.065-1.156.13-1.81.13-.065 0-.348.066-.5.066m.35.327c.632-.13 1.809-.065 2.46-.13m.681.348c-.5.065-1.158 0-1.66.065-.349.066-1 .132-1 .132m.48.458c.13 0 .72-.132.72-.132.85-.065 1.156-.13 1.96-.2m.5.327a11.483 11.483 0 0 0-1.657.13 7.422 7.422 0 0 0-1.067.2m.61.393c.568-.132 2.159-.284 1.506-.284a13.2 13.2 0 0 0 1.59-.065m.263.349a4.217 4.217 0 0 0-1.29 0 5.666 5.666 0 0 1-1.524.195m.413.24a7.035 7.035 0 0 0 1.223-.13 4.374 4.374 0 0 1 1.284-.066m-2.071.48a4.753 4.753 0 0 1 1.724-.13 2.621 2.621 0 0 0 .631-.066m-14.037-9.374c.2-.066.282-.2.566-.131.195-.065.348 0 .348-.065.066-.066.2-.066.35-.066m-1.626-.038c.2-.066.282-.2.566-.2H513c0-.065.2-.065.283-.065m4.73 5.123a1.218 1.218 0 0 1 .568-.067c-.13-.065.282 0 .349-.065h.414m.065 1.374a4.981 4.981 0 0 0 1.44-.284m.74.5a7.71 7.71 0 0 0-1.809.195m-6.91-7.084c-.5-.066-.633.13-1 .348'/%3e%3cpath fill='%23fc0' d='M530.878 298.76a8.662 8.662 0 0 0-1.506-.938 9.286 9.286 0 0 1-1.876-1.5c-.128-.065-.128-.284-.278-.5-.787-.785-1.59-1.5-2.377-2.245a10.827 10.827 0 0 0-1.508-1.068c-.061-.065-.195-.2-.195-.283a5.787 5.787 0 0 1-1.5-.938c-.719-.72-1-1.285-1.81-1.722h.066a6.891 6.891 0 0 1 1.22-.785 2.177 2.177 0 0 1 1.725.065c.062.067.28.2.5.35a6.193 6.193 0 0 0 2.467 1.154c.938.284 1.155.938 1.937 1.592a4.744 4.744 0 0 0 1.222.85c.067 0 .134.2.2.2a7.73 7.73 0 0 1 1.29.938c.72.633 1.373 1.285 2.026 1.94.133.13.133.349.284.414a8.586 8.586 0 0 0 1.59 1.22c.631.35 1.155.722 1.724 1.07-1.724.065-3.465.065-5.212.065v.065'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.347' d='M530.878 298.76a8.662 8.662 0 0 0-1.506-.938 9.286 9.286 0 0 1-1.876-1.5c-.128-.065-.128-.284-.278-.5-.787-.785-1.59-1.5-2.377-2.245a10.827 10.827 0 0 0-1.508-1.068c-.061-.065-.195-.2-.195-.283a5.787 5.787 0 0 1-1.5-.938c-.719-.72-1-1.285-1.81-1.722h.066a6.891 6.891 0 0 1 1.22-.785 2.177 2.177 0 0 1 1.725.065c.062.067.28.2.5.35a6.193 6.193 0 0 0 2.467 1.154c.938.284 1.155.938 1.937 1.592a4.744 4.744 0 0 0 1.222.85c.067 0 .134.2.2.2a7.73 7.73 0 0 1 1.29.938c.72.633 1.373 1.285 2.026 1.94.133.13.133.349.284.414a8.586 8.586 0 0 0 1.59 1.22c.631.35 1.155.722 1.724 1.07-1.724.065-3.465.065-5.212.065v.065z'/%3e%3cpath fill='none' stroke='%2300b300' stroke-width='.173' d='M520.5 290.126c.066 0 .937-.13 1-.13m-.72.414c.284-.066.85-.066 1-.2m-.719.413.85-.13h.283m-.7.566a5.853 5.853 0 0 1 1.157-.2m.305.195a3.818 3.818 0 0 0-1.22.2m.478.306a2.608 2.608 0 0 1 1.072-.132m.48.284a4.2 4.2 0 0 0-1.224.13m.414.241a3.353 3.353 0 0 0 1.155-.2m.435.415a11.175 11.175 0 0 0-1.222.13m.5.306a3.654 3.654 0 0 0 1.221-.132m.308.2a6.984 6.984 0 0 1-1.155.2m.563.391c.134-.13.854-.065 1.155-.13m.374.262a3.242 3.242 0 0 0-.854.065c-.062.065-.279.065-.346.065m2.137.676a7.729 7.729 0 0 0-1.289.131m.352.37a9.1 9.1 0 0 1 1.5-.2m-.48 1.374c.068 0 .57-.065.636-.065a5.826 5.826 0 0 1 1.435-.132m.307.262c-.72.13-1.066.13-1.658.2h-.413m.263.393c.563-.066 1.657-.13 2.243-.2m.743.326a12.293 12.293 0 0 0-1.591.066 5.8 5.8 0 0 0-.938.131m.48.392c.061 0 .63-.13.63-.13.721-.066 1.006-.131 1.81-.2m.479.327a9.994 9.994 0 0 0-1.5.065c-.353.066-.855.283-1.006.283m.547.284a7.545 7.545 0 0 1 1.435-.2 9.6 9.6 0 0 1 1.44-.065m.239.26a2.581 2.581 0 0 0-1.222 0 4.875 4.875 0 0 1-1.373.2m.352.174a3.4 3.4 0 0 0 1.155-.13 7.42 7.42 0 0 1 1.222 0m-2.032.435a11.794 11.794 0 0 1 1.658-.13h.57m-12.951-8.743a1 1 0 0 1 .5-.13h.436a.7.7 0 0 1 .282-.066m-1.525 0c.2-.13.2-.2.5-.13.195-.066.348 0 .414-.066a.7.7 0 0 1 .283-.066m4.316 4.753a1.135 1.135 0 0 1 .5-.065c-.067-.131.285 0 .346-.066h.441m-.134 1.221a9.861 9.861 0 0 0 1.44-.2m.742.415a8.36 8.36 0 0 0-1.875.13m-6.17-6.518c-.5-.065-.633.13-.938.349'/%3e%3cpath fill='%23090' d='M514.5 299.651a2.1 2.1 0 0 0-1.161-.287l-.906-.031.893-.062c.974-.069 1.025-.11.628-.507-.235-.234-.5-.244-2.2-.071a10.429 10.429 0 0 1-2.244.07c-.375-.15.737-.356 2.026-.376.487-.008.808-.09.808-.207 0-.2-2.291-.1-3.234.134-.34.086-.386.063-.222-.111a3.638 3.638 0 0 1 1.49-.3c1.375-.088 1.76-.362.562-.4-.4-.013-.552-.057-.341-.1.737-.142.386-.4-.425-.316-2.319.245-3.015.272-2.767.1a2.482 2.482 0 0 1 1.022-.178c.9 0 1.531-.152 1.531-.356 0-.08-.21-.113-.467-.073s-1 .112-1.66.16c-1.374.1-1.03-.132.468-.316 1.342-.166 1.269-.477-.085-.366l-1.064.086.809-.182c.445-.1.808-.25.808-.334 0-.189.03-.19-1.66.084-1.183.192-1.4.192-1.4 0 0-.165.244-.232.838-.232.887 0 1.42-.131 1.3-.321a3.526 3.526 0 0 0-1.233-.008c-1.264.116-1.858-.078-.792-.257.708-.12 1.208-.36 1.06-.509a1.283 1.283 0 0 0-.674.076c-.753.216-1.523.214-1.523 0 0-.093.25-.171.554-.172.536 0 1.137-.244.974-.393a3.611 3.611 0 0 0-1.017.057 2.32 2.32 0 0 1-1.1-.022c-.1-.088.166-.15.64-.15 1.188 0 .968-.315-.265-.38l-1.064-.056.723-.144c1.057-.212.905-.49-.192-.351-.6.074-.954.049-1.031-.074s.093-.187.49-.187c.964 0 .7-.337-.288-.37-.735-.023-.78-.04-.255-.095.35-.036.638-.149.638-.25 0-.12-.292-.15-.846-.083-.923.11-1.335-.119-.513-.283.52-.1.714-.451.253-.451-.14 0-.256-.085-.256-.19 0-.127-.245-.152-.75-.077-.462.07-.794.044-.862-.066s.092-.178.411-.178c.752 0 .643-.336-.118-.36-.35-.01-.5-.055-.338-.1.546-.143.142-.352-.6-.309-.4.024-.516.01-.258-.032.722-.114.553-.39-.255-.419-.509-.017-.585-.045-.256-.1.257-.04.468-.153.468-.253 0-.117-.263-.146-.727-.082a1.99 1.99 0 0 1-.979-.06c-.182-.116-.076-.16.387-.161.35 0 .638-.047.638-.1 0-.3-.58-.587-1.222-.608-.4-.012-.563-.056-.352-.1.471-.09.508-.39.047-.39-.243 0-.3-.078-.226-.285s.041-.258-.175-.175c-.158.06-.284.027-.284-.073s-.27-.157-.682-.118c-.374.036-.68 0-.68-.069s.172-.132.383-.133a1.4 1.4 0 0 0 .623-.156c.2-.127.195-.2-.049-.44-.227-.227-.454-.265-1.049-.176-.494.074-.76.051-.76-.067 0-.1.268-.18.6-.18.8 0 .762-.3-.043-.38l-.638-.06.808-.384c1.163-.552 2.127-.337 3.75.84a15.515 15.515 0 0 0 2.57 1.214 6.969 6.969 0 0 1 3.225 2 23.333 23.333 0 0 0 2.083 1.789 29.261 29.261 0 0 1 4.944 4.03 23.445 23.445 0 0 1 1.617 1.765 12.975 12.975 0 0 0 3.191 2.528 11.732 11.732 0 0 1 1.387.89 9.012 9.012 0 0 1-1.605.072c-1.2 0-1.669-.065-1.86-.256z'/%3e%3cpath fill='%23090' d='M521.309 299.14a1.808 1.808 0 0 1-.373-.621c-.112-.354-.177-.36-2.265-.27-1.2.054-1.962.035-1.726-.042a6.563 6.563 0 0 1 1.4-.156c.614-.01.98-.09.98-.212 0-.14-.448-.17-1.575-.1-.887.053-1.39.034-1.15-.043a5.632 5.632 0 0 1 1.235-.154c.444-.01.808-.093.808-.187s-.115-.17-.255-.17-.255-.077-.255-.17-.517-.184-1.15-.2c-.7-.017-.9-.054-.51-.095.35-.036.638-.137.638-.224a3.73 3.73 0 0 0-1.574-.074c-1.776.1-1.825-.006-.085-.174 1.182-.115 1.578-.41.6-.444-.3-.011-.419-.055-.255-.1.493-.128.337-.428-.17-.328-1.29.253-2.052.3-2.16.12-.078-.125.161-.185.735-.185a1.725 1.725 0 0 0 .965-.183c.077-.124-.246-.17-1.013-.142-1.29.047-1.626-.09-.618-.25.378-.06.687-.185.687-.279 0-.2-.227-.206-1.065-.011-.352.081-.677.087-.722.015s.261-.185.682-.248.764-.187.764-.277c0-.143-1.066-.076-1.654.1a.281.281 0 0 1-.308-.1c-.057-.092.162-.163.5-.163.97 0 .7-.338-.288-.357-.869-.017-.878-.023-.341-.195.825-.265.67-.467-.275-.355-.529.063-.87.03-.945-.093s.082-.191.487-.191c.7 0 .834-.334.138-.354-.257-.008-.372-.052-.255-.1.488-.2.156-.35-.58-.266-.569.064-.757.034-.67-.106a.581.581 0 0 1 .45-.2c.183 0 .332-.077.332-.17s-.116-.171-.256-.171-.256-.073-.256-.162-.363-.137-.808-.107-.6.023-.341-.018c.723-.115.554-.391-.254-.417-.4-.013-.552-.056-.341-.1.426-.08.528-.39.127-.39-.14 0-.255-.076-.255-.17s-.248-.18-.553-.19-.42-.054-.255-.1c.629-.165.259-.383-.51-.3-.679.073-.741.057-.39-.1a2.828 2.828 0 0 0 .488-.252c.124-.124-.45-.6-.725-.6-.147 0-.268-.078-.268-.17s-.114-.171-.255-.171-.236-.1-.213-.213-.088-.19-.253-.163c-.188.031-.263-.033-.207-.18.066-.17-.077-.218-.556-.188-.367.023-.46 0-.218-.048.667-.138.82-.4.246-.42-.286-.01-.374-.053-.2-.1.364-.1.4-.394.043-.394-.14 0-.255-.077-.255-.17s-.288-.173-.639-.176c-.6 0-.617-.021-.307-.255a2.323 2.323 0 0 1 2.323.17 32.609 32.609 0 0 0 4.058 1.974 5.889 5.889 0 0 1 2.213 1.5 16.621 16.621 0 0 0 1.8 1.532c1.993 1.307 3.452 2.593 6.939 6.113a11.279 11.279 0 0 0 2.125 1.586 8.681 8.681 0 0 1 1.235.76 4.192 4.192 0 0 1-1.094.073c-.748 0-1.176-.082-1.351-.257zm4.829-.608c0-.348-.49-.668-1.02-.668-.312 0-.49-.07-.428-.17s-.019-.171-.17-.171-.229-.076-.17-.17-.058-.17-.255-.17-.314-.077-.256-.17-.087-.17-.34-.17-.4-.074-.341-.17-.16-.18-.543-.194-.5-.052-.265-.1c.427-.082.527-.39.127-.39-.14 0-.255-.076-.255-.17s-.115-.17-.255-.17-.256-.076-.256-.17-.234-.17-.52-.17c-.307 0-.478-.071-.415-.172.119-.192-.3-.68-.585-.68a.177.177 0 0 1-.182-.17c0-.094-.158-.17-.35-.17s-.3-.077-.246-.17-.216-.181-.713-.2c-.62-.02-.685-.044-.265-.095.545-.069.792-.388.3-.388-.14 0-.255-.062-.255-.137s-.288-.112-.638-.082c-.556.045-.587.029-.243-.12s.368-.2.14-.427a.848.848 0 0 0-.438-.255.179.179 0 0 1-.183-.17.183.183 0 0 0-.192-.171.982.982 0 0 1-.494-.346 2.2 2.2 0 0 0-1.041-.493c-.408-.08-.607-.154-.443-.163.408-.026.376-.37-.042-.48-.188-.05-.341-.166-.341-.259s-.27-.137-.6-.1a1.272 1.272 0 0 1-1.15-.4l-.548-.471.457-.007c.579-.009.774-.3.388-.585-.268-.2-.238-.252.334-.6a2.608 2.608 0 0 1 2.957.288 10.343 10.343 0 0 0 2.038 1 4.835 4.835 0 0 1 2.167 1.342 24.389 24.389 0 0 0 2.553 2.077 29.988 29.988 0 0 1 3.522 3.09 17.6 17.6 0 0 0 2.469 2.223c1.283.678 1.265.691-.926.693-1.371 0-2.085-.059-2.085-.18zm6.819-.562c-.2-.367-.314-.4-1.263-.361-.576.023-.8.01-.493-.032s.553-.113.553-.161c0-.223-.541-.589-1.012-.682-.286-.058-.52-.172-.52-.253s-.11-.15-.243-.15-.293-.152-.353-.34a.5.5 0 0 0-.436-.34c-.182 0-.33-.076-.33-.17s-.25-.171-.553-.173c-.392 0-.483-.047-.313-.155.2-.129.2-.193-.03-.423a.9.9 0 0 0-.453-.27.178.178 0 0 1-.183-.171c0-.094-.115-.17-.255-.17s-.256-.077-.256-.17a.2.2 0 0 0-.217-.17.784.784 0 0 1-.463-.342.825.825 0 0 0-.559-.34c-.186 0-.266-.076-.195-.189.167-.272-.277-.493-.777-.385-.325.07-.367.05-.177-.083.211-.147.188-.228-.154-.524a1.534 1.534 0 0 0-.555-.351 1.612 1.612 0 0 1-.578-.425 1.558 1.558 0 0 0-.6-.425 2.567 2.567 0 0 1-1.007-.941 1.023 1.023 0 0 0-.274-.38c-.254-.254-.245-.286.1-.413a2.241 2.241 0 0 1 1.962.545 9.984 9.984 0 0 0 1.778.86 4.9 4.9 0 0 1 1.899 1.192 13.987 13.987 0 0 0 1.8 1.45 26.112 26.112 0 0 1 2.825 2.439 23.56 23.56 0 0 0 2.724 2.341l.9.559h-1.036c-.917 0-1.06-.041-1.251-.4z'/%3e%3cpath fill='%23e60000' d='m492.488 272.643.132.349-1.657.633.2.631-.2.065c-.131-.348-.284-.5-.72-.414l-.13-.282 2.376-1m-1.81-.72a.464.464 0 0 1-.283-.413c-.066-.414.066-.938.567-1 .283-.13.937-.13 1.155.721a.8.8 0 0 1-.5.937l-.13-.349c.348-.065.414-.283.348-.567a.581.581 0 0 0-.72-.414.557.557 0 0 0-.414.72c0 .13.132.283.35.348l.065.284-1.438.13-.284-1.286.283-.065.284 1.068.72-.066m-.72-4.752a.563.563 0 0 0-.567.557v.01c0 .2 0 .633.414.633.2 0 .283-.13.349-.284l.2-.72a.594.594 0 0 1 .72-.5c.632 0 .785.566.719 1.067a.964.964 0 0 1-.283.72.682.682 0 0 1-.72.195l.065-.283c.414 0 .567-.348.633-.718a.583.583 0 0 0-.35-.72c-.282 0-.348.065-.5.5l-.2.567a.624.624 0 0 1-.632.5.823.823 0 0 1-.719-1c.066-.85.566-.938.85-.938v.35m2.616-2.4-.567 1.875-2.529-.85.567-1.81.35.131-.5 1.439.72.2.5-1.374.284.132-.5 1.373.85.283.5-1.5.283.065m.415-.545-.2.284-2.246-1.354.632-1a.687.687 0 0 1 1-.284.7.7 0 0 1 .282 1.066l-.413.72.938.567m-1.025-3.335 1.5-1.5.2.195-.632.63 1.656 1.59-.194.286-1.658-1.658-.633.631-.195-.2m3.88.023-.283.195-1.5-2.16.2-.128 1.59 2.093M498 259.5l-1.722.938-1.22-2.4 1.744-.848.131.278-1.373.721.348.72 1.286-.631.13.284-1.285.63.414.788 1.373-.72.13.195m2.443-.524-.283-1.5c0-.067-.066-.35-.13-.636l-.2 2.311-.348.133-1.221-2.03a5.6 5.6 0 0 1 .13.568l.35 1.591h-.35l-.566-2.528.5-.067 1.22 2.031.284-2.377.5-.134.5 2.6-.348.067m.894-2.7h1.069c.5.061.784.346.719.72a.6.6 0 0 1-.349.564c.13.067.5.194.414.63a.7.7 0 0 1-.85.72l-1.156-.062.132-2.6m2.572 2.919-.283-.066.631-2.59 1.221.413c.415.067.785.346.633.848-.131.413-.35.413-.5.5.065.067.194.194.065.568l-.065.413c0 .195 0 .195.065.285v.061l-.414-.127c-.065-.135.065-.5.13-.632a.473.473 0 0 0-.348-.568l-.85-.195-.283 1.087m3.77 1.658-1.722-1 1.286-2.244 1.744.937-.2.285-1.286-.787-.415.72 1.222.72-.132.285-1.275-.722-.348.72 1.286.782-.066.284m2.877-.847.633.78a1.078 1.078 0 0 1-.2 1.658c-.5.413-1.221.72-1.81.067l-.632-.848 2.027-1.658m.415 5.448-.872-1.72 2.311-1.222.85 1.722-.283.13-.633-1.372-.784.346.719 1.288-.283.131-.633-1.286-.784.347.72 1.442-.285.13m.393 2.31v-.349l1.809-.2-.13-.567.282-.065c.132.414.132.567.568.567l.065.283-2.594.35m1.46 2.157a.627.627 0 0 1-.654.414c-.414 0-.784-.282-.784-.937a1.27 1.27 0 0 1 .195-.567.814.814 0 0 1 .655-.283.823.823 0 0 1 .633.5c.064-.2.195-.282.5-.282.283 0 .633.13.633.784 0 .567-.349.784-.72.719-.349 0-.414-.195-.5-.349m.174.938a.822.822 0 0 1 .719 1.068.838.838 0 0 1-.938.633c-.414-.131-.567-.415-.719-.938l-.065-.284c-.066-.348-.2-.5-.35-.5l-.347 1.352-.285-.066.415-1.723a.993.993 0 0 1 .871.85l.132.35c.065.283.13.5.5.567.132.065.415 0 .5-.35.132-.5-.282-.566-.414-.653v-.351m-2.55 2.6.13-.284 1.656.785.2-.567.284.066c-.2.414-.2.567.13.85l-.13.195-2.311-1.068'/%3e%3cpath fill='%23ffd1c5' d='m491.681 263.268.284-.5c.2-.286.2-.5-.065-.637-.2-.195-.414-.062-.567.134l-.349.563.72.42m9.92-5.844h.631c.283 0 .414-.067.5-.35 0-.286-.132-.347-.5-.347l-.567-.068-.065.787'/%3e%3cpath fill='%23ffe6d9' d='M501.624 258.562h.631c.349 0 .567-.134.567-.35 0-.347-.284-.414-.567-.414l-.632-.068v.855'/%3e%3cpath fill='%23ffd1c5' d='m504.39 257.754.721.195c.195 0 .5.067.566-.28a.388.388 0 0 0-.282-.5l-.785-.194-.2.78m4.752 3.99.348.413c.283.352.72.352 1.221-.061.414-.351.5-.786.2-1.072l-.414-.5-1.374 1.222m3.227 7.129c-.2 0-.5.065-.5.414 0 .2 0 .5.414.5.283 0 .435-.13.435-.414.067-.35-.13-.5-.348-.5m1.155.937a.317.317 0 0 0 .283-.349c.067-.348-.13-.414-.283-.414a.383.383 0 1 0 0 .763'/%3e%3cpath fill='%23fff' d='M501.624 335.538c1.5 0 3.116 0 9.852-1.658 6.737-1.59 12.337-5.715 13.626-6.3a8.106 8.106 0 0 1 3.248-.413 8.4 8.4 0 0 0-5.713-2.685c-2.964 0-1.721 0-4.272 1.071-2.464 1-7.674 4.2-16.459 4.2h-.13c-8.851 0-14.28-3.182-16.83-4.2-2.442-1.071-1.373-1.071-4.274-1.071a8.15 8.15 0 0 0-5.711 2.685 8.732 8.732 0 0 1 3.27.413c1.286.563 6.89 4.71 13.626 6.3 6.735 1.658 8.415 1.658 9.787 1.658'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.406' d='M501.624 335.538c1.5 0 3.116 0 9.852-1.658 6.737-1.59 12.337-5.715 13.626-6.3a8.106 8.106 0 0 1 3.248-.413 8.4 8.4 0 0 0-5.713-2.685c-2.964 0-1.721 0-4.272 1.071-2.464 1-7.674 4.2-16.459 4.2h-.13c-8.851 0-14.28-3.182-16.83-4.2-2.442-1.071-1.373-1.071-4.274-1.071a8.15 8.15 0 0 0-5.711 2.685 8.732 8.732 0 0 1 3.27.413c1.286.563 6.89 4.71 13.626 6.3 6.735 1.658 8.415 1.658 9.787 1.658z'/%3e%3cpath fill='%23fff' d='M475.66 329.74c.718-.352-.132-1.6-.132-1.6l2.682-.563a8.233 8.233 0 0 0-3.27-.413c-.5.413-.414.937-.5 1.283a1.719 1.719 0 0 0 .195 1.29c.284.194 1 0 1 0'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.406' d='M475.66 329.74c.718-.352-.132-1.6-.132-1.6l2.682-.563a8.233 8.233 0 0 0-3.27-.413c-.5.413-.414.937-.5 1.283a1.719 1.719 0 0 0 .195 1.29c.284.194 1 0 1 0z'/%3e%3cpath fill='%23fff' d='m478.187 327.557-2.68.563s.85 1.223.13 1.6l4.71-.854a25.078 25.078 0 0 0-2.16-1.283'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.406' d='m478.187 327.557-2.68.563s.85 1.223.13 1.6l4.71-.854a25.078 25.078 0 0 0-2.16-1.283z'/%3e%3cpath fill='%23fff' d='M527.675 329.74c-.72-.352.128-1.6.128-1.6l-2.679-.563a8.115 8.115 0 0 1 3.25-.413c.5.413.412.937.5 1.283a1.733 1.733 0 0 1-.2 1.29c-.28.194-1 0-1 0'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.406' d='M527.675 329.74c-.72-.352.128-1.6.128-1.6l-2.679-.563a8.115 8.115 0 0 1 3.25-.413c.5.413.412.937.5 1.283a1.733 1.733 0 0 1-.2 1.29c-.28.194-1 0-1 0'/%3e%3cpath fill='%23fff' d='m525.147 327.557 2.679.563s-.848 1.223-.129 1.6l-4.71-.854s.721-.5 2.16-1.283'/%3e%3cpath fill='none' stroke='%23000' stroke-width='.406' d='m525.147 327.557 2.679.563s-.848 1.223-.129 1.6l-4.71-.854s.721-.5 2.16-1.283z'/%3e%3cpath d='m482.984 325.75.567.194a1.6 1.6 0 1 1-1.243 2.941l-.567-.195 1.22-2.963m1.7 4.23-.35-.134 1.287-2.9.349.061-1.286 2.97m3.989 0a1.552 1.552 0 0 1-2.094.847 1.573 1.573 0 0 1-.784-2.091 1.606 1.606 0 0 1 2.093-.938 1.648 1.648 0 0 1 .785 2.16m2.092-.263c-.065-.2-.13-.351-.348-.413-.2-.067-.5 0-.567.195a.493.493 0 0 0 .131.565l.2.195c.349.284.567.569.349 1.071a.952.952 0 0 1-1.22.63 1.06 1.06 0 0 1-.568-1.222l.349.067a.626.626 0 0 0 .349.787.554.554 0 0 0 .72-.351c.13-.346-.067-.564-.284-.782l-.131-.134a.833.833 0 0 1-.283-.937.794.794 0 0 1 1.068-.5.834.834 0 0 1 .567.721l-.35.066m2.355.174-.5 1.808c-.13.5-.13 1 .414 1.16.567.195.85-.2 1-.72l.5-1.813.35.066-.567 1.943a1.058 1.058 0 0 1-1.374.847 1 1 0 0 1-.719-1.438l.5-1.937.349.061m2.354.547 1.722 2.9.414-2.317.35.067-.568 3.248-1.809-2.9-.414 2.31-.349-.066.633-3.248m3.138 3.9-.348-.06.348-3.12h.35l-.35 3.181m3.86-1.373a1.555 1.555 0 0 1-1.593 1.59 1.539 1.539 0 0 1-1.525-1.718 1.49 1.49 0 0 1 1.59-1.507 1.547 1.547 0 0 1 1.506 1.657m.37-1.763 2.464 2.243-.219-2.31h.414l.2 3.248-2.441-2.244.2 2.31h-.414l-.2-3.247m5.232 2.333.85-.134.13.351-1.286.2-.653-3.12.414-.06.5 2.746m1.788.022-.349.061-.72-3.03.35-.129.719 3.12m-.153-3.23.349-.13c.567-.128 1.068-.128 1.286.57a.754.754 0 0 1-.131.63.7.7 0 0 1 .785.565.966.966 0 0 1-.785 1.154l-.653.2-.851-3.029m2.115-.614 1.59-.563.066.345-1.155.413.283.854 1.156-.42.066.353-1.07.346.35 1.16 1.134-.418.13.352-1.5.5-1.069-2.97m5.015 1.575-.436.129-1.286-.849-.131.061.414 1.223-.283.133-1.226-2.966.414-.127a1.768 1.768 0 0 1 .786-.2.972.972 0 0 1 .632.563.838.838 0 0 1-.349 1.071l1.439.938m1.264-.547-.348.195-1.156-2.6-.633.284-.13-.284 1.591-.72.2.284-.72.286 1.22 2.528m1.07-1.374.065.849-.349.2-.2-3.622 2.747 2.244-.284.2-.72-.57-1.22.63m.959-3.18.5-.285a1.575 1.575 0 0 1 2.312.5 1.6 1.6 0 0 1-.72 2.244l-.5.284-1.592-2.746'/%3e%3cpath fill='%23fff' d='M482.33 328.427h.131a1.047 1.047 0 0 0 1.59-.5c.35-.782-.064-1.218-.783-1.5l-.066-.067-.872 2.093m5.864 1.29a1.152 1.152 0 0 0-.567-1.508 1.07 1.07 0 0 0-1.374.63 1.122 1.122 0 0 0 .5 1.508 1.085 1.085 0 0 0 1.439-.653m13.647 3.136a1.083 1.083 0 0 0-1-1.222 1.193 1.193 0 0 0-1.156 1.156 1.234 1.234 0 0 0 1.091 1.221 1.12 1.12 0 0 0 1.068-1.155m8.5-1.44.066-.061c.283-.067.567-.134.436-.57-.13-.412-.349-.412-.72-.284h-.065l.283.937m8.546-4.012.065 1.29.85-.5-.937-.787m2.856.57h.065a1.18 1.18 0 0 0 .633-1.658 1.154 1.154 0 0 0-1.722-.285l-.13.067 1.154 1.876m-11.03 4.794.282-.062c.284-.134.568-.285.416-.637-.067-.412-.5-.346-.786-.279h-.131l.2 1m3.945-2.79h.065c.35-.129.72-.346.5-.781-.13-.351-.567-.285-.85-.2l-.066.061.35.937'/%3e%3c/svg%3e";
            },
            2906: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 675 450'%3e%3cpath fill='%23dc171d' d='m0 0 298.571 225.241H675V0z'/%3e%3cpath d='m0 0 299.005 225.746L0 450z' style='fill:%23fff;stroke:%23fff'/%3e%3cpath fill='%23012a87' d='m0 450 298.571-224.759H675V450z'/%3e%3cpath fill='%23ff0' d='m150.828 170.286.092-3.484s-1.871-2.98.3-6.18c0 0-4.612-2.44-3.538-6.262 0 0-4.17-1.066-3.864-5.654 0 0-4.502-.312-4.968-4.144 0 0-4.502.741-6.483-2.993 0 0-4.392.858-5.63-2.22 0 0-4.269 1.479-6.802-2.14 0 0-4.508 1.822-6.397-1.594-1.865 3.404-6.372 1.594-6.372 1.594-2.503 3.606-6.802 2.11-6.802 2.11-1.196 3.09-5.575 2.214-5.575 2.214-1.975 3.735-6.47 2.993-6.47 2.993-.442 3.82-4.937 4.133-4.937 4.133.355 4.6-3.809 5.642-3.809 5.642 1.098 3.82-3.508 6.254-3.508 6.254 2.227 3.22.374 6.176.374 6.176l-.104 3.212 74.506.345'/%3e%3cpath d='m377.175 843.108.091-3.458s-1.857-2.958.298-6.136c0 0-4.578-2.422-3.512-6.215 0 0-4.139-1.059-3.835-5.613 0 0-4.468-.31-4.931-4.114 0 0-4.468.736-6.434-2.971 0 0-4.359.852-5.588-2.204 0 0-4.237 1.468-6.751-2.124 0 0-4.474 1.808-6.349-1.583-1.851 3.379-6.325 1.583-6.325 1.583-2.484 3.579-6.751 2.094-6.751 2.094-1.187 3.068-5.533 2.198-5.533 2.198-1.96 3.708-6.422 2.971-6.422 2.971-.438 3.793-4.9 4.103-4.9 4.103.353 4.566-3.78 5.601-3.78 5.601 1.09 3.792-3.482 6.208-3.482 6.208 2.21 3.196.371 6.131.371 6.131l-.103 3.189 73.949.342h-.012z' style='fill:%23f9d90f;stroke-width:.27124387;stroke:%23000' transform='matrix(1.00754 0 0 1.00735 -229.19 -679.021)'/%3e%3cpath fill='%23dc171d' d='M149.086 165.937c-11.702-1.172-25.177-3.949-35.579 1.908-6.973-4.11-16.683-3.858-24.95-3.053-4.49.802-9.77.802-14.462 1.57l-.735.103c-8.513.565-16.235-1.95-23.632-5.256 2.349 13.332 4.956 26.994 6.238 40.951 2.79 20.671-9.783 38.026-4.625 58.446 3.08 9.798 13.855 15.495 23.717 16.624 9.55.563 19.43 2.128 28.269 4.047 1.68.35 3.673 1.129 4.833 1.63 2.435 1.02 4.22 2.515 5.783 4.116 5.336-5.557 13.156-7.102 20.871-7.917 13.904-1.625 31.047-.741 39.56-13.336v-.713c4.624-6.965 4.01-17.592 2.005-25.485-.135-2.753-.87-5.181-1.27-7.806-8.494-22.431-1.22-47.658 2.436-70.268-4.465 2.44-9.446 3.593-14.413 4.814-3.961.528-8.377.288-12.388.072l-1.663-.447m17.485 64.376'/%3e%3cpath fill='%2362afe1' d='M166.566 230.313c-.056 1.477.742 2.637 1.03 4.003 1.626 9.806 3.197 22.793-6.899 28.877-11.169 7.1-25.815 4.06-38.738 7.818-2.582.717-6.139 3.091-7.954 4.77-1.166-.766-2.337-1.944-3.84-2.636-10.634-5.654-24.459-3.759-36.462-6.813-6.029-1.907-12.315-6.603-13.842-12.774-3.926-16.188 5.477-29.985 4.366-46.045-.717-12.264-2.778-24.037-5.612-35.535 9.385 4.372 20.246 5.101 30.796 3.005 7.813-1.092 16.91-1.116 24.232 2.189 4.035-1.736 8.759-2.514 13.107-2.993 8.268.804 17.154 2.3 25.668 2.238 5.686-.295 10.85-1.938 15.793-4.127-2.932 19.004-8.562 38.91-1.65 58.023'/%3e%3cpath fill='%23fff' d='m149.687 234.101-.092-17.869h2.201L124.48 198.59l-.05-9.168h2.638l-13.659-9.78-13.591 9.774h2.63l.05 9.161-27.17 17.619 2.17.012.092 17.857 72.09.05'/%3e%3cpath d='m376.042 906.458-.091-17.739h2.185l-27.113-17.513-.049-9.101h2.618l-13.557-9.709-13.49 9.703h2.611l.049 9.094-26.967 17.49 2.155.012.091 17.727 71.551.049.006-.013z' style='fill:none;stroke-width:1.16422367;stroke:%23000' transform='matrix(1.00754 0 0 1.00735 -229.19 -679.021)'/%3e%3cpath fill='%23fff' d='m158.083 257.576.006 5.592-88.005-.098-.036-5.568 88.043.075'/%3e%3cpath d='m384.376 929.761.006 5.551-87.347-.097-.036-5.527 87.384.074h-.006z' style='fill:none;stroke-width:1.16422367;stroke:%23000' transform='matrix(1.00754 0 0 1.00735 -229.19 -679.021)'/%3e%3cpath fill='%23fff' d='m75.929 257.238-.074-18.924 3.564-.007-.196 19.145.214-18.99-5.133-.148v-4.06l78.652.087.037 4.023h-4.85l.09 19.162-.17-19.162h3.612l.08 18.947'/%3e%3cpath d='m302.836 929.426-.073-18.786 3.537-.007-.195 19.005.213-18.852-5.095-.146v-4.03l78.064.086.037 3.993h-4.815l.091 19.023-.17-19.023h3.585l.079 18.809m-58.475-4.698-.055-13.1h-10.482l.061 13.087 10.476.013m0 0-.055-13.1h-10.482l.061 13.087 10.476.013m0 0-.055-13.1h-10.482l.061 13.087 10.476.013m0 0-.055-13.1h-10.482l.061 13.087 10.476.013m0 0-.055-13.1h-10.482l.061 13.087 10.476.013m-7.682-10.368.03 7.609h4.797l-.024-7.609h-4.803m58.925 10.404-.061-13.087-10.446-.012.049 13.099h10.458m-7.682-10.355.055 7.585h4.791l-.043-7.585h-4.803m7.603-10.975-.061-13.101h-10.458l.037 13.101h10.489-.006zm-7.682-10.343.03 7.597h4.791l-.006-7.597h-4.815m-43.567 10.295-.073-13.076-10.464-.013.049 13.082h10.489v.007zm-7.683-10.343.024 7.585 4.803.012-.036-7.597h-4.791m26.651 10.366-.049-13.076-10.47-.012.043 13.087h10.476m-7.676-10.353.024 7.585 4.797.024-.03-7.609h-4.791m22.298 10.379-.073-13.101-10.464-.012.049 13.087 10.489.025m-7.69-10.365.037 7.609h4.797l-.024-7.609h-4.809' style='fill:none;stroke-width:1.16422367;stroke:%23000' transform='matrix(1.00754 0 0 1.00735 -229.19 -679.021)'/%3e%3cpath fill='%23fff' d='m129.208 227.08.117 30.421-30.561-.05-.111-30.395 30.55.024'/%3e%3cpath d='m355.717 899.488.116 30.199-30.333-.049-.11-30.174 30.321.024h.006zm-30.51 8.62 30.54.024m-30.54-.024 30.54.024m-30.54-.024 30.54.024m-30.54-.024 30.54.024m-30.54-.024 30.54.024m-26.729 21.543-.103-21.342m23.228 21.354-.103-21.329m14.75-21.732-17.081-12.474-19.193-.024-16.947 12.449 53.222.049m-34.797-22.827.03 7.609 16.144.012-.03-7.609-16.144-.012m0 0 .03 7.609 16.144.012-.03-7.609-16.144-.012' style='fill:none;stroke-width:1.16422367;stroke:%23000' transform='matrix(1.00754 0 0 1.00735 -229.19 -679.021)'/%3e%3cpath d='m331.994 863.799.03 7.609 16.144.012-.03-7.609-16.144-.012' style='fill:none;stroke-width:1.16422367;stroke:%23000' transform='matrix(1.00754 0 0 1.00735 -229.19 -679.021)'/%3e%3cpath d='m336.371 865.686.024 3.792h7.414l-.024-3.792h-7.414m3.665-10.544 8.979 6.348-17.891-.024 8.912-6.325m0 .001 8.979 6.348-17.891-.024 8.912-6.325m0 .001 8.979 6.348-17.891-.024 8.912-6.325m0 .001 8.979 6.348-17.891-.024 8.912-6.325m0 .001 8.979 6.348-17.891-.024 8.912-6.325' style='fill:none;stroke-width:1.16422367;stroke:%23000' transform='matrix(1.00754 0 0 1.00735 -229.19 -679.021)'/%3e%3cpath fill='%23fff' d='M149.988 178.073c2.57-.062 3.232 10.584 3.238 15.857 2.208.62 7.102 3.698 9.267 6.482l-24.827-.037c2.134-2.747 6.992-5.837 9.181-6.456 0-5.28.54-15.919 3.14-15.858'/%3e%3cpath d='M376.341 850.838c2.551-.061 3.208 10.507 3.214 15.742 2.191.615 7.049 3.671 9.198 6.434l-24.642-.036c2.118-2.727 6.94-5.795 9.113-6.409 0-5.242.536-15.803 3.117-15.742m-49.533 49.508h2.21l-.645 1.186m-1.565-1.186h2.21l-.645 1.186m-1.565-1.186h2.21l-.645 1.186m-1.565-1.186h2.21l-.645 1.186m-1.565-1.186h2.21l-.645 1.186s1.065 1.37.018 2.94l.578 1.09h-2.131l.578-1.035s-1.09-1.82.049-2.995l-.657-1.186m4.505 0h2.21l-.639 1.186s1.065 1.334.006 2.94l.572 1.09h-2.124l.572-1.035s-1.065-1.82.055-2.995l-.651-1.186m4.911 0h2.204l-.657 1.186s1.077 1.37.018 2.94l.578 1.114-2.112-.024.566-1.035s-1.077-1.808.043-2.995l-.645-1.186h.006zm5.546.011h2.222l-.651 1.199s1.065 1.346.006 2.922l.597 1.108h-2.143l.572-1.035s-1.065-1.832.073-2.995l-.67-1.199h-.006zm4.93 0h2.204l-.651 1.199s1.071 1.346.012 2.916l.584 1.114h-2.124l.554-1.035s-1.071-1.82.085-2.995l-.664-1.199m4.901.013 2.204-.012-.651 1.199s1.09 1.346.03 2.922l.554 1.108h-2.131l.572-1.035s-1.065-1.82.073-2.995l-.651-1.187' style='fill:none;stroke-width:1.16422367;stroke:%23000' transform='matrix(1.00754 0 0 1.00735 -229.19 -679.021)'/%3e%3cpath fill='%23f9d90f' d='M114.077 296.496c11.445.037 25.52-2.3 32.113-5.709l14.48-1.282.289 17.667c-12.267 6.763-40.59 8.216-46.821 8.167-6.238.05-34.91-1.428-47.233-8.216l.16-17.679 14.511 1.307c6.594 3.392 21.098 5.746 32.53 5.746h-.03'/%3e%3cpath d='M340.699 968.397c11.359.037 25.329-2.283 31.873-5.667l14.372-1.273.286 17.538c-12.175 6.714-40.286 8.156-46.471 8.108-6.191.049-34.649-1.418-46.879-8.156l.158-17.55 14.403 1.297c6.544 3.367 20.94 5.704 32.287 5.704h-.03' style='fill:none;stroke-width:.27124387;stroke:%23000' transform='matrix(1.00754 0 0 1.00735 -229.19 -679.021)'/%3e%3cpath fill='%23f9d90f' d='m29.63 221.138 12.757 4.06-3.858 20.653-12.076 1.876s-2.036-10.86 3.177-26.601'/%3e%3cpath d='m256.883 893.589 12.662 4.03-3.829 20.503-11.986 1.862s-2.021-10.781 3.153-26.407v.012z' style='fill:none;stroke-width:.27124387;stroke:%23000' transform='matrix(1.00754 0 0 1.00735 -229.19 -679.021)'/%3e%3cpath fill='%237e7e7e' d='m38.522 245.624-12.07 2.103 7.636-10.86 4.434 8.757'/%3e%3cpath d='m265.709 917.896-11.98 2.088 7.579-10.781 4.401 8.693' style='fill:%23f9b60f;stroke-width:.27124387;stroke:%23000' transform='matrix(1.00754 0 0 1.00735 -229.19 -679.021)'/%3e%3cpath fill='%23f9d90f' d='m22 236.015 12.297.889c.276 10.419 1.54 50.18 49.022 52.338l-1.478 14.465c-57.8.6-62.191-48.768-59.841-67.692'/%3e%3cpath d='m249.31 908.358 12.205.882c.274 10.343 1.528 49.813 48.656 51.956l-1.467 14.36c-57.367.596-61.726-48.413-59.394-67.198zm44.797 70.138 14.384-3.141m-14.384 3.141 14.384-3.141m-14.384 3.141 14.384-3.141m-14.384 3.141 14.384-3.141m-14.384 3.141 14.384-3.141' style='fill:none;stroke-width:.27124387;stroke:%23000' transform='matrix(1.00754 0 0 1.00735 -229.19 -679.021)'/%3e%3cpath fill='%23ff0' d='m197.52 221.285-12.708 4.022 4.03 20.623 12.1 1.943s1.945-10.853-3.423-26.6'/%3e%3cpath d='m423.518 893.735-12.613 3.993 3.999 20.472 12.01 1.929s1.93-10.774-3.397-26.406v.012z' style='fill:%23f9d90f;stroke-width:.27124387;stroke:%23000' transform='matrix(1.00754 0 0 1.00735 -229.19 -679.021)'/%3e%3cpath fill='%237e7e7e' d='m188.842 245.715 12.1 2.171-7.74-10.865-4.36 8.694'/%3e%3cpath d='m414.904 917.987 12.01 2.155-7.682-10.786-4.328 8.631' style='fill:%23f9b60f;stroke-width:.27124387;stroke:%23000' transform='matrix(1.00754 0 0 1.00735 -229.19 -679.021)'/%3e%3cpath fill='%23f9d90f' d='m205.29 236.18-12.315.842c-.178 10.406-1.085 50.184-48.569 52.293l1.613 14.454c57.787.668 61.762-48.677 59.272-67.594'/%3e%3cpath d='m431.23 908.522-12.223.835c-.177 10.33-1.077 49.818-48.206 51.912l1.601 14.348c57.355.663 61.3-48.322 58.828-67.101v.005zm-44.194 70.053-14.421-3.159' style='fill:none;stroke-width:.27124387;stroke:%23000' transform='matrix(1.00754 0 0 1.00735 -229.19 -679.021)'/%3e%3cpath fill='%23012a87' d='M106.393 305.203c-.326.209-.767.264-1.276.24l-2.294-.118.197-2.863 2.275.122c.447.03.803.117 1.024.252.46.239.662.681.62 1.294-.03.527-.215.87-.552 1.072m-3.852 4.508.227-3.49 2.674.185c.864.068 1.508-.159 1.944-.601.454-.43.687-.993.718-1.631.055-.743-.135-1.35-.577-1.797-.423-.43-1.024-.656-1.778-.73l-3.82-.238-.529 8.216 1.135.074m8.322-6.862 2.797.03m-2.797-.03 2.797.03m-2.797-.03 2.797.03m-2.797-.03 2.797.03m-2.797-.03 2.797.03c.405.038.724.086.957.197.43.202.632.607.632 1.196 0 .552-.16.92-.473 1.14-.3.202-.735.295-1.257.295l-2.686-.03.024-2.827m-.043 7.28.024-3.508 2.625.037c.466 0 .81.036 1.048.153.387.178.577.552.595 1.067l.067 1.38c.019.331.025.534.044.669.037.098.055.202.104.277h1.41l-.024-.178c-.16-.086-.288-.251-.344-.503-.05-.16-.073-.4-.085-.7l-.025-1.097c-.018-.497-.103-.84-.294-1.03a1.474 1.474 0 0 0-.742-.529c.393-.207.687-.447.901-.742.203-.325.307-.735.307-1.238 0-.944-.386-1.589-1.172-1.938-.423-.19-.963-.29-1.601-.3l-3.943-.038-.03 8.241h1.134m8.753-1.748c-.502-.613-.773-1.38-.834-2.287-.055-1.141.165-2.012.687-2.601.528-.638 1.208-.944 2.098-.993.896-.05 1.631.239 2.177.803.558.552.877 1.318.932 2.275.03.92-.129 1.735-.552 2.452-.417.73-1.11 1.141-2.134 1.166-1.067.055-1.865-.196-2.374-.816m-1.349-5.188c-.528.816-.742 1.76-.687 2.901.08 1.232.46 2.25 1.178 3.017.797.767 1.852 1.152 3.152 1.079 1.393-.062 2.442-.588 3.153-1.557.576-.877.852-1.896.79-3.152-.079-1.123-.404-2.036-1.01-2.717-.767-.914-1.89-1.318-3.411-1.256-1.435.091-2.49.618-3.17 1.685m38.737-11.852c.79-.135 1.478-.097 2.104.117.92.288 1.54.97 1.925 2.012l-1.134.159c-.245-.563-.595-.95-1.067-1.165-.46-.202-1.037-.252-1.7-.154a2.648 2.648 0 0 0-1.827 1.123c-.429.661-.558 1.545-.368 2.672.16.933.503 1.724 1.067 2.25.521.54 1.288.73 2.289.589.748-.123 1.349-.422 1.772-.938.441-.49.57-1.233.423-2.189l-2.644.405-.135-.908 3.68-.565.717 4.36-.73.11-.453-1.005c-.306.455-.613.804-.883 1.006-.454.356-1.067.583-1.834.693-.994.153-1.901-.025-2.724-.552-.901-.669-1.484-1.662-1.704-3.041-.239-1.355-.024-2.515.601-3.428.595-.883 1.46-1.398 2.625-1.564m8.322-.625 2.638-.957c.362-.134.675-.179.944-.146.485.036.84.324 1.043.9.19.49.19.92-.024 1.221-.227.312-.583.54-1.099.73l-2.477.889-1.025-2.637m2.638 6.813-1.288-3.305 2.454-.883c.46-.147.778-.227 1.018-.202.435.055.767.32.988.821l.558 1.259c.123.312.22.502.3.588.037.11.117.178.178.25l1.331-.489-.073-.178c-.197 0-.386-.111-.528-.326-.104-.153-.203-.373-.344-.63l-.435-1.03c-.197-.448-.399-.724-.632-.89a2.106 2.106 0 0 0-.876-.239c.27-.313.466-.627.54-.994.08-.374.043-.791-.135-1.256-.338-.877-.957-1.355-1.828-1.417-.46-.036-.987.062-1.595.275l-3.705 1.319 2.994 7.75 1.085-.398m9.64-4.108-4.704-6.863 5.164-3.293.57.828-4.23 2.704 1.447 2.098 3.907-2.515.534.803-3.907 2.514 1.595 2.312 4.305-2.754.57.81-5.256 3.355m4.12-12.129 1.35-1.484c.626-.662 1.288-.963 2.012-.876.723.061 1.46.441 2.245 1.128.214.165.405.38.601.62.344.447.546.84.675 1.233.111.491.086.938-.085 1.368-.104.213-.289.465-.565.766l-1.355 1.472-4.875-4.237m7.127 3.23c.957-1.053 1.166-2.188.608-3.47a5.873 5.873 0 0 0-1.509-1.956c-.864-.767-1.766-1.16-2.717-1.232-1.055-.08-1.95.3-2.73 1.152l-2.3 2.465 6.342 5.532 2.3-2.477m4.916-6.411-7.299-4.286.595-.944 7.31 4.262-.601.98m2.86-4.99-7.882-3.153 2.325-5.544.957.368-1.895 4.568 2.373.933 1.773-4.208.907.375-1.754 4.2 2.656 1.08 1.945-4.623.957.361-2.368 5.643m3.624-9.677-8.292-1.833.276-1.282 7.66-2.588-6.728-1.484.246-1.005 8.292 1.784-.264 1.245-7.672 2.644 6.728 1.453-.239 1.067m-.664-10.53.104-1.043c.479.014.884-.061 1.19-.226.602-.326.951-.944 1.043-1.859.037-.428.018-.803-.08-1.16-.178-.685-.564-1.066-1.184-1.127-.46-.05-.79.061-1.03.313-.215.288-.442.704-.614 1.293l-.38 1.085c-.245.711-.472 1.202-.717 1.477-.393.516-.944.693-1.65.645-.754-.08-1.367-.38-1.803-.957-.447-.528-.632-1.282-.52-2.214.073-.853.355-1.57.858-2.146.466-.528 1.19-.78 2.115-.681l-.085 1.042c-.454 0-.816.08-1.08.264-.478.264-.742.822-.821 1.637-.068.675.024 1.129.282 1.473.258.288.582.472.963.503.405.037.723-.092.944-.404.16-.216.35-.681.608-1.436l.373-1.14c.185-.528.405-.932.662-1.22.46-.478 1.061-.68 1.816-.624.92.097 1.576.478 1.913 1.177.332.705.46 1.484.38 2.367-.104 1-.43 1.784-1.03 2.312-.602.54-1.35.724-2.258.65M27.63 252.45l.19 1.03c-.46.092-.828.277-1.098.516-.485.453-.65 1.134-.485 2.06.074.392.215.777.393 1.085.368.625.847.876 1.454.777.447-.08.743-.25.884-.57.135-.313.232-.792.264-1.404l.055-1.16c.037-.717.117-1.28.276-1.594.252-.564.724-.914 1.429-1.03a2.454 2.454 0 0 1 1.987.466c.576.399.957 1.092 1.098 2.011.178.841.098 1.595-.233 2.275-.32.663-.932 1.067-1.87 1.239l-.185-1.042c.435-.159.76-.313.975-.527.368-.411.479-1.006.338-1.822-.111-.663-.338-1.092-.681-1.306-.338-.252-.676-.35-1.043-.288-.411.061-.681.288-.81.655-.08.245-.141.754-.197 1.534l-.055 1.201c-.03.564-.117 1.03-.306 1.35-.3.588-.81.95-1.552 1.067-.938.16-1.663-.055-2.177-.656-.528-.588-.853-1.293-1.018-2.17-.184-1.043-.05-1.852.368-2.502.423-.669 1.092-1.055 1.999-1.184m-.521 10.862 8.107-2.441 1.89 5.709-.988.312-1.545-4.691-2.466.742 1.429 4.335-.944.3-1.417-4.347-2.747.821 1.57 4.795-.97.277-1.92-5.813m3.595 9.897 7.457-3.955.797 1.391-5.127 5.42 7.49-1.28.772 1.38-7.44 3.93-.528-.914 4.392-2.311c.16-.093.405-.228.76-.417.35-.16.743-.375 1.135-.578l-7.457 1.27-.547-.97 5.092-5.402-.245.123c-.16.092-.436.227-.81.441a6.053 6.053 0 0 1-.823.442l-4.378 2.348-.54-.932M44.6 284.2c-.374-.086-.743-.3-1.105-.675L41.92 281.9l2.121-1.944 1.59 1.62c.306.3.502.594.607.846.147.484 0 .926-.447 1.343-.405.374-.81.528-1.19.435m-5.992.755 2.6-2.386 1.846 1.87c.595.608 1.202.884 1.84.872a2.597 2.597 0 0 0 1.699-.742c.552-.49.816-1.067.816-1.685-.006-.602-.282-1.166-.791-1.693l-2.65-2.705-6.17 5.667.797.803m7.45 6.621 4.472-7.01 5.286 3.214-.552.834-4.342-2.6-1.343 2.122 3.993 2.422-.515.803-4-2.41-1.52 2.373 4.397 2.643-.528.828-5.348-3.219m13.236-1.356 2.687.853c.38.116.655.263.84.43.343.325.435.79.233 1.354-.166.49-.418.81-.81.945-.35.06-.791.06-1.307-.099l-2.533-.808.89-2.675m-2.319 6.886 1.116-3.342 2.503.816c.448.117.773.277.932.441.306.276.4.687.246 1.197l-.374 1.33c-.085.325-.129.54-.165.637 0 .105 0 .216.018.288l1.319.43.08-.191c-.141-.11-.221-.312-.215-.563.03-.154.074-.399.16-.681l.319-1.067c.129-.466.178-.816.061-1.067a1.678 1.678 0 0 0-.54-.729c.417-.074.779-.202 1.085-.43a2.28 2.28 0 0 0 .681-1.091c.3-.89.135-1.632-.528-2.196-.331-.294-.803-.546-1.422-.779l-3.753-1.158-2.625 7.818 1.098.337m11.394-142.282'/%3e%3cpath fill='%23bc715f' d='M68.354 154.826c.97-2.337 9.949-8.709 39.412-5.918 0 0 4.98 3.04 7.906 2.649 1.669-.216-.981.104-3.158-1.705-2.221-1.809-2.693-5.519 2.38-5.421 5.047.129 23.943 1.196 24.3 2.894.33 1.717-9.992 2.435-13.831 2.336-3.858-.104-3.41 1.847.429 1.7 11.997-.43 25.09-4.655 38.921 5.126 1.65 1.189-4.17 1.38-8.673-.534 0 0-12.2.633-17.474-.233 0 0-4.054 3.298-9.334 2.974.687 1.71-1.95 8.094-18.553 3.292-2.742.841-12.732 2.514-11.641-.453-2.63 0-7.243.846-7.93-.65-.662-1.472 8.12-3.699 9.66-5.293 0 0-18.578.179-22.099-1.104 0 0-10.96 2.46-10.316.326'/%3e%3cpath fill='%23008830' d='M74.31 180.838c.399-.54.558-1.508 1.404-1.484 1.84.49 3.091 3.856 5.354 1.673.803-.178 1.11.915 1.773 1.043.423 1.87 1.925-.38 3.047-.252 2.398-1.067 5.367-1.319 8.207-.79.085 1.832-1.35 3.856-3.153 4.899.038 1.846 1.711 3.03 1.68 4.888-.287.693-.049 1.784-1.097 2.011-1.331-.239-2.644-.38-3.747-1.122-.135-.135-.245-.399-.528-.312-.135.62.834 1.233 1.214 1.864-.67 1.14-1.779.098-2.712.111-.276.656-.012 1.484-.687 1.907-1.178-.036-1.416-1.318-2.14-1.956-.742.803.521 1.281.7 1.919-.454 2.415-.393 4.777-2.81 6.36l-1.619.803c-.44-1.214-.165-3.054-.46-4.323-.957 1.557-1.705 2.919-3.11 4.236-1.643-.54-2.6-2.477-2.961-4.083-.688-1.871-.295-4.11 1.183-5.464-.502-.981-2.226-.755-2.471-2.152-2.582-1.681-4.011 2.944-5.68.539-.54-2.243.104-5.035 1.73-6.709-.361-.919-1.563-.68-2.275-1.208-1.625-1.38-3.968-2.838-3.851-5.33 4.446-1.679 9.764-.447 12.996 2.932'/%3e%3cpath fill='%23f9d90f' d='M76.616 180.587c-.104 2.035 1.374.55 2.472 1.784-.859-.338-1.485 1.484-2.325.441l-.528.504c.307.698.902.79.282 1.557-.92.35-1.104-.803-1.533-1.257-.074-.201.141-.582-.197-.717-.52.441-1.067.601-1.784.528-.196-.393-.576-.908-.19-1.208.705-.951 1.797.342 2.33-.326.086-.588-.43-1.306.239-1.711.46.08 1.049-.171 1.24.405m5.495 1.668c.056.393-.202.944.313 1.221.669-.363 1.38-.087 1.766.576-.006.355.104.821-.362.993l-1.043-.195c.074-.202-.258-.331-.387-.528-.46-.14-.73.233-1.073.46.258.392.853.607.712 1.11-.614.612-.914-.528-1.59-.24-.46-.177.166-1.134-.557-1.423-.859 0-.289 1.41-1.387.859-.393-.442-.779-1.037-.355-1.533.46-.308 1.239-.228 1.63.17.67-.74.736-3.605 2.337-1.47m-6.854 2.956c.447.644-.098 1.52.473 2.238.895-1.673 1.76.362 2.827.202.325.4.11.951.171 1.405-1.319.35-2.907.766-4.072-.288l-.326.373c.693.645 1.35 1.374.797 2.453-.987.215-2.515.239-3.011-.778-.258-.84.601-1.447-.307-2.122-.656.816-.625 1.908-1.993 1.166-.846-.467-1.098-1.429-.675-2.239.884-1.392 2.43.044 3.386-.637.135-1.196-.307-2.239.79-2.9.939-.167 1.375.538 1.945 1.127'/%3e%3cpath fill='%23fff' d='M79.008 185.94c-.441 2.036-1.975-.104-2.692-.19.957-1.699 1.558.552 2.692.19m4.778 2.214c-1.067.3-.902-1.03-1.429-1.552l.411-.374c.387.466.681 1.307 1.019 1.926'/%3e%3cpath fill='%23f9d90f' d='M82.338 187.75c.306.704-.693 1.27.16 1.783.27-.226.6-.54.742-.669.73.216 1.575.345 2.085 1.067.546 1.497-.969 1.46-1.827 1.877l-.853-.036c.203-.418-.368-.595-.509-.883-.393-.098-.717.024-.938.355.19.95 1.35 1.692.154 2.538-1.012-.066-2.583.326-2.49-1.073-.38-.79 1.03-2.011-.479-2.06-.496 1.067-1.042 2.097-2.336 1.085l.159-1.52c1.24.035 2.705.25 3.262-1.135.356-1.005-.62-1.932.252-2.729 1.264-.288 1.975.558 2.619 1.397'/%3e%3cpath d='M81.43 190.036c.32.754-.54.804-.944 1.177-.546.044-.926-.17-1.257-.54-.245-.913.435-1.005.957-1.366.607-.252.858.453 1.245.729'/%3e%3cpath fill='%23fff' d='M80.689 190.526c-.135.179-.326.123-.528.172l-.19-.913c.404.036.931.165.717.741'/%3e%3c/svg%3e";
            },
            5862: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 180 120'%3e%3cpath d='M0 0h180v120H0z'/%3e%3cpath fill='%23fff' d='M0 0h180v80H0z'/%3e%3cpath fill='%23ce1126' d='M0 0h180v40H0z'/%3e%3cg id='d' fill='%23007a3d'%3e%3cg id='c'%3e%3cg id='b'%3e%3cpath id='a' d='M54 47v13h8' transform='rotate(18 54 47)'/%3e%3cuse xlink:href='%23a' x='-108' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(72 54 60)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(-72 54 60)'/%3e%3cuse xlink:href='%23c' transform='rotate(144 54 60)'/%3e%3c/g%3e%3cuse xlink:href='%23d' x='72'/%3e%3c/svg%3e";
            },
            6324: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3e%3cpath fill='%233e5eb9' d='M0 0h900v600H0z'/%3e%3cpath fill='%23ffd900' d='M0 112.5h900v375H0z'/%3e%3cpath fill='%23b10c0c' d='M0 150h900v300H0z'/%3e%3cg fill='%23ffd900' stroke='%23000' stroke-width='1.008' transform='scale(1.5)'%3e%3cg id='a'%3e%3cpath fill='%23fff' d='m492.85 154.28-24.285 8.571 24.285 8.571 24.285-8.571z'/%3e%3crect width='357.13' height='5.714' x='122.85' y='160' rx='3.106' ry='2.857'/%3e%3cpath d='M471.44 165.71c1.427 0 2.859-1.429 2.859-2.857 0-1.428-1.431-2.857-2.858-2.857m-2.861 5.714c1.427 0 2.859-1.429 2.859-2.857 0-1.428-1.431-2.857-2.858-2.857m-2.861 5.714c1.427 0 2.859-1.429 2.859-2.857 0-1.428-1.431-2.857-2.858-2.857'/%3e%3c/g%3e%3cuse xlink:href='%23a' width='100%25' height='100%25' x='-23.27' y='17.15'/%3e%3crect width='485.7' height='8.571' x='59.812' y='195.72' stroke-width='1.08' rx='4.224' ry='4.286'/%3e%3c/g%3e%3cpath fill='%23fff' stroke='%23000' stroke-width='1.512' d='M664.275 300c-42.856 42.853-100.002 128.566-214.29 128.566-100.002 0-171.42-85.712-214.29-128.566 42.857-42.861 114.282-128.574 214.29-128.574 114.282 0 171.42 85.713 214.29 128.574z'/%3e%3cpath d='M435.03 216.15c11.402 12.823 1.881 17.994 13.95 18.835 12.727.935 5.512 13.551 16.218 13.99 7.485.327-.747 30.226 6.457 40.093 7.34 10.286 13.487 3.014 13.616 10.444.127 7.686-19.976 6.911-20.328 30.585-.59 13.644-16.965 14.517-17.747 23.297-.972 8.257 32.261 12.892 31.817 20.284-.456 7.37-35.883 6.216-37.425 14.621-.79 7.55 48.669 13.737 52.647 35.57-7.38 2.413-28.379 4.685-44.249 4.697-99.985.072-171.42-85.72-214.275-128.574 42.857-42.86 114.282-128.574 214.29-128.574 0 0-29.683 27.123-14.956 44.723z'/%3e%3cg stroke='%23fff' transform='scale(1.5)'%3e%3cg id='d' stroke-width='6.927'%3e%3cg id='c'%3e%3cpath id='b' d='M213.933 192.377V169.52m13.85 0v22.857m13.86-22.857v22.857'/%3e%3cuse xlink:href='%23b' width='100%25' height='100%25' y='38.1'/%3e%3c/g%3e%3cuse xlink:href='%23c' width='100%25' height='100%25' x='41.56'/%3e%3c/g%3e%3c/g%3e%3cuse xlink:href='%23d' width='100%25' height='100%25' x='104.76' stroke='%23000' transform='scale(1.5)'/%3e%3cg fill='%23a70000'%3e%3cpath fill='%233d5da7' stroke='%23000' stroke-width='1.282' d='M767.025 294.9c-6.492 11.244 4.982-3.74 32.978 15.084 5.188 3.497 9.721 12.734 9.721 19.139-1.317-.881-2.295-2.841-3.745-4.115-2.031 2.035 1.939 11.366 2.52 15.775-4.377-2.449-3.956-3.609-5.41-6.619.29 3.639-.751 13.66.99 17.52-3.45-.986-3.22-3.762-5.021-4.32 1.225 4.368-1.068 9.122-.46 14.033-2.015-1.995-4.163-3.558-5.1-4.364-.157 2.338-3.877 8.484-3.961 10.695-1.71-1.033-2.175-2.644-2.46-3.729-2.126 2.671-9.681 12.537-10.165 15.546-5.822-5.142-20.735-17.663-22.676-24.309-1.716 3.772-4.2 5.046-9.11 7.8-1.939-10.533-9.194-22.372-5.314-31.401-2.75 1.63-5.013 3.261-7.761 5.267 2.604-15.255 15.88-33.143 34.979-42.002z'/%3e%3cpath d='M742.815 350.58c2.695-5.388 5.178-7.096 6.92-10.566 3.076-6.098 3.515-10.949 6.196-10.238 2.68.711 2.677 3.209-.795 9.204-3.473 5.996-5.124 7.277-12.321 11.6zm18.225 12.84c-.347-4.103.843-5.816.627-8.457-.37-4.649-2.271-7.839.201-8.066 2.472-.226 3.627 1.36 3.634 6.044.008 4.685-.717 5.915-4.46 10.48zm13.83 8.04c-1.08-5.727-.271-8.267-.963-11.957-1.203-6.492-3.583-10.765-1.293-11.359 2.29-.594 3.674 1.506 4.54 8.09.868 6.583.41 8.392-2.284 15.226zm14.385-40.125c-3.378-2.564-5.349-2.736-7.527-4.383-3.837-2.89-5.778-5.985-7.013-4.449-1.234 1.536-.358 3.216 3.663 5.883 4.02 2.667 5.382 2.877 10.878 2.949zm-2.385 19.005c-1.78-3.697-3.654-4.635-4.806-7.014-2.035-4.18-2.038-7.797-4.246-6.87-2.208.927-2.385 2.82-.024 6.867 2.36 4.046 3.597 4.779 9.076 7.017z'/%3e%3cpath fill='%233d5da7' stroke='%23000' stroke-width='1.6' d='M121.174 305.73c-.363-3.274.338-3.666-1.677-6.135 2.933 1.227 3.044 4.488 6.61 2.174 1.309-.678 1.88-.7.289-4.337 3.718.173 15.894 4.348 17.844 4.444 5.12.236 14.466-5.378 20.953 1.525 6.227 6.294 4.148 12.826 4.148 21.543-2.502-1.199-1.296-1.79-3.951-4.907 1.99 7.619-.106 21.356-.106 29.436-1.022-1.948-.872-1.103-1.871-3.12-2.655 7.375-5.837 8.893-5.837 17.61-.958-3.418-.033-2.696-1.099-4.494-2.58 5.6-19.89 10.385-13.22 16.029-6.02-3.53-8.66-3.159-11.39-6.334-1.177.759-2.111 2.196-3.205 4.165-10.585-4.87-6.8-15.375-15.093-22.392-1.435 2.942-.781 2.516-2.332 7.304-1.679-6.651-2.138-10.877-4.026-15.767-1.629 2.71-1.484 1.671-4.442 5.768-1.224-8.102-3.216-10.014-2.428-15.375-3.144 2.218-1.086 1.32-4.229 4.05 2.978-20.76 15.837-36.101 25.065-31.188z'/%3e%3cpath d='M108.151 339.615c2.728-6.684 5.186-8.783 6.949-13.086 3.112-7.563 3.619-13.61 6.233-12.687 2.615.922 2.573 4.037-.925 11.467-3.498 7.433-5.135 9.008-12.257 14.304zm10.326 16.725c1.094-5.992 2.819-8.175 3.528-12.034 1.259-6.786.557-11.84 2.987-11.573 2.43.266 2.979 2.828 1.362 9.578-1.617 6.751-2.733 8.349-7.878 14.029zm12.351 11.625c.308-5.81 1.67-8.077 1.874-11.82.369-6.582-.898-11.293 1.419-11.32 2.317-.027 3.143 2.34 2.433 8.929-.71 6.59-1.567 8.234-5.726 14.211zm26.522-37.995c-5.071-5.052-8.137-5.996-11.409-9.245-5.763-5.706-8.547-11.064-10.599-9.165-2.052 1.9-.817 4.746 5.25 10.176 6.068 5.43 8.178 6.222 16.758 8.234zm-3.09 19.53c-3.303-5.073-5.727-6.387-7.86-9.651-3.76-5.736-5.054-10.665-7.185-9.444-2.133 1.221-1.656 3.796 2.42 9.357 4.075 5.559 5.714 6.582 12.625 9.74z'/%3e%3cpath fill='%233d5da7' stroke='%23000' stroke-width='1.239' d='M380.7 194.25c-5.937 11.482 10.395-3.819 35.997 15.404 4.745 3.571 11.546 17.68 11.546 24.22-5.451-1.16-15.104-6.54-15.104-6.54s11.328 11.346 11.328 24.426c-4.002-2.502-6.004-2.127-7.335-5.199 0 4.234 3.56 6.933 3.56 13.473a52.938 52.938 0 0 0-7.78-5.19c3.776 6.54-6.88 19.227-1.547 23.462-9.327-1.349-18.87-7.308-22.646-13.848-2.001 1.348-2.218 3.466-2.296 5.723.294.245-14.198-10.756-12.866-14.982-1.944 2.727-2.217 4.226-2.661 7.3-5.323-5.25-10.203-10.5-11.979-17.288-2.365 3.073-2.514 3.073-4.88 6.147-1.774-10.757-1.774-10.373 1.775-19.592-2.514 1.665-4.584 3.33-7.098 5.38 2.38-15.578 14.523-33.845 31.988-42.892z'/%3e%3cpath d='M366.06 250.35c.95-7.912 3.018-10.893 3.636-15.988 1.103-8.961-.206-15.512 2.97-15.345 3.176.165 4.09 3.47 2.52 12.414-1.569 8.941-2.893 11.113-9.126 18.92zm16.575 14.49c-.643-6.675.59-9.517.18-13.818-.705-7.566-3.042-12.691-.274-13.162 2.767-.471 4.167 2.067 4.465 9.706.299 7.64-.441 9.675-4.372 17.274zm25.875 11.82c-2.814-5.777-5.232-7.499-7.048-11.217-3.209-6.534-3.88-11.87-6.354-10.904-2.475.968-2.339 3.728 1.236 10.124 3.574 6.396 5.19 7.701 12.166 11.997zm8.955-51.735c-7.167-3.773-10.848-3.82-15.466-6.245-8.133-4.25-12.867-9.052-14.547-6.409-1.682 2.643.562 5.271 8.947 9.135s10.96 4.047 21.067 3.519zm2.625 21.615c-5.218-4.341-8.304-4.98-11.67-7.773-5.93-4.9-8.88-9.714-10.861-7.762-1.98 1.951-.657 4.528 5.566 9.145 6.224 4.617 8.352 5.19 16.965 6.39z'/%3e%3c/g%3e%3c/svg%3e";
            },
            4524: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 9600 4800'%3e%3cdefs%3e%3cclipPath id='a'%3e%3cpath d='M0 0v15h65v15h-5zm60 0H30v35H0v-5z'/%3e%3c/clipPath%3e%3cpath id='b' d='M840-1000v720C840 200 600 717 0 997-600 717-840 200-840-280v-720z'/%3e%3c/defs%3e%3cg fill='%23012169'%3e%3cpath d='M0 0h4800A2683.282 2683.282 0 0 1 0 2400z'/%3e%3cg fill='none'%3e%3cpath stroke='%23fff' stroke-width='480' d='m0 0 4800 2400M0 2400 4800 0'/%3e%3cpath stroke='%23ce1126' stroke-width='4' d='m0 0 60 30M0 30 60 0' clip-path='url(%23a)' transform='scale(80)'/%3e%3cpath stroke='%23fff' stroke-width='800' d='M2400-400v3200M-400 1200h5600'/%3e%3cpath stroke='%23ce1126' stroke-width='480' d='M2400 0v2800M0 1200h5200'/%3e%3c/g%3e%3cpath d='M0 2400h4800V0h4800v4800H0'/%3e%3c/g%3e%3cg fill='none' stroke='%23000' transform='translate(7200 2400)'%3e%3cuse xlink:href='%23b' fill='%23fcd116' stroke-width='64'/%3e%3cuse xlink:href='%23b' stroke='%23fff' stroke-width='56'/%3e%3cg stroke-linecap='round' stroke-linejoin='round' stroke-width='2.2'%3e%3cpath fill='%23fcad56' d='M-303-207c-22 37-59 45-88 33-30-12-57-82-87-120-29-37-37-21-57-43-19-21-49-37-96-59-26-12-53-23-71-69 7-19 26-35 41-41 15-5 27-27 29-46 2-18 18-38 40-53-10 2-31-2-41-9-9-8-24-6-33 1-9 6-20 8-36 6 6-5 17-16 18-26s13-15 36-15c22 0 37-26 55-26-13 0-10-22-3-23-32-6-28-32-15-32-1-4-5-8-20-13-14-5-7-18 4-26-10-20-1-35 15-48-22-1 2-32 8-49 6-16 9-18 16-8 8 9 26 30 47 36 20 6 32 17 36 34 4 18 12 27 34 35 23 7 54 26 50 69 18 1 31 6 42 15'/%3e%3cpath fill='%23ffa1a1' d='M-248-749c0 24 11 39 25 51 15 12 28 22 25 37-3 16 3 26 16 36 14 10 24 22 20 42s-1 32 7 47 22 27 16 51-3 56 5 72c7 15 0 27-14 54-14 26-22 36-51 46-30 9-32 27-32 58 0 32-21 48-60 42-40 33-65-6-75-55s-12-102-71-145c-58-44-35-118 14-148 49-29 43-115 37-168-5-53 30-83 57-112 36 14 81 69 81 92z'/%3e%3cpath fill='%23f1b2dc' d='M-333-408c-11-26-23-52 6-108 30-57 11-100 2-129-9-28-11-54 0-66 12-11 17-18 18-37 1-18 16-12 18-3s4 24-12 51c-16 28 45 96 17 169-19 51 6 116 16 161s16 153-50 169c45-22 3-165-15-207z'/%3e%3cpath d='M-630-416c11 2 17-4 20-11s5-11 15-12c10 0 26-3 30-11 3-8 15-1 26-21 10-21 17-45 44-54m74-174c-10 0-39 1-51 27m-83-151c24 7 14 23 26 32 22 17 2 35 20 40s17 8 13 28c-6 23 16 24 8 39m-104 79c14-13 49-23 57-37m-58-32c21-1 49 7 53-1m-56-22c10 0 31-7 35-21m-50-11c12 0 27-1 42-12m-58-27c9-7 25 1 40-9m-25-39c7 0 22-2 22 7'/%3e%3cg fill='%239e540a' transform='translate(400 -400)'%3e%3cg id='d'%3e%3cpath d='M-55-233s-70-59-128-99-128-89-128-99c11-8 70 30 151 79 82 50 128 99 128 99zm-5 40s-68-41-135-70c-70-29-175-29-186-39 0-10 122-16 209 19 89 41 135 70 135 70zm-1 68s-74-34-146-50c-70-16-170-10-182-19 0-10 124-30 217 0 94 29 134 49 134 49zm-4 69s-56-38-130-46c-70-7-163 46-175 36 0-10 81-69 182-59 99 10 146 49 146 49zm23-218s-71-65-71-109c0-39 43-99 62-99-10 20-43 60-43 99 0 40 75 89 75 89z'/%3e%3cpath d='M-42-274s14-65 14-109c0-59-42-113-38-128 15 15 57 59 57 128 0 60-10 89-10 89z'/%3e%3cg stroke='none'%3e%3cuse xlink:href='%23c' stroke='%23fcd116' stroke-width='12'/%3e%3cpath id='c' d='M-25-295c0-19-7-36-19-49-16-19-40-25-65-21-30 5-54 23-69 51-20 37-22 77-23 116 0 135 5 190 9 323 1 39 8 119-10 182-7 27-15 52-27 78 8-33 12-50 16-75 11-65 8-126 6-186-4-123-11-186-15-335-1-45 3-79 24-115 22-37 60-64 103-64 18 0 33 3 48 12 30 16 44 49 44 82z'/%3e%3c/g%3e%3cpath d='M-19 187s-28 50-49 86-38 44-54 33c-15-11-2-40 10-54s79-79 79-79z'/%3e%3cpath d='M-12 191s-11 57-20 98c-8 41-22 55-39 50-18-4-15-37-8-54s49-103 49-103z'/%3e%3cpath d='M0 193v100c0 42-10 59-29 58-18-1-22-33-18-52 3-18 28-111 28-111z'/%3e%3c/g%3e%3cuse xlink:href='%23d' transform='scale(-1 1)'/%3e%3cg id='e'%3e%3cpath d='M0 192c-53-1-58-20-58-20s-7-24-8-39c-1-2-15-32-11-45-5-12-17-41-6-46-5-14-13-30-14-45-4-11-14-35-6-43 0 0-19-40-10-50 0 0-9-39 0-49 0 0 0-40 10-50 0 0 0-39 9-49 0 2 28-55 94-55l-1 85h1z'/%3e%3cpath fill='none' d='M0-26c-85-1-103-20-103-20M0-76c-85 0-113-20-113-20M0-125c-85-1-113-20-113-20M0-175c-85-1-103-20-103-20m102-19c1 0-64 0-74-10l-19-19M0 152c-25 0-53-4-66-19m66-21c-47 0-75-19-75-19s-1-2-2-5M0 63c-62-1-79-14-83-21M0 23C-85 23-94 3-94 3l-3-6'/%3e%3c/g%3e%3cuse xlink:href='%23e' transform='scale(-1 1)'/%3e%3c/g%3e%3cg id='f'%3e%3cpath fill='%23009e49' d='M0 712c-43 40-126 14-152-4-27 9-99-19-118-50-52 7-70-67-61-86 14-28-11-46 7-65 25-24-14-47 10-63 24-17-6-45 18-63 25-19-13-45 13-58s-3-47 19-60-13-46 17-61c29-15 3-41 26-52 25-13 2-40 25-49 26-11 7-40 29-48 19-7 7-25 19-41H0'/%3e%3cpath d='M-99 18c-20 20 4 35-16 59-21 25-2 38-19 60s8 33-11 58c-19 24 4 39-17 59-20 21 4 39-17 61-20 23 4 38-16 58-21 21 3 43-17 63-20 21 4 47-19 71-22 24 4 43-14 61-19 19-2 38-15 51s-15 31-10 39M-60 25c-18 25 10 36-7 56-17 21 7 28-6 52s10 30-7 54 9 43-9 67c-19 24 9 37-8 61-16 25 8 38-7 56-15 19 11 37-8 60-18 22 8 39-7 59-15 21 6 43-7 60-13 16 9 41-10 63-18 22 4 37-7 52s-20 37-9 43'/%3e%3c/g%3e%3cuse xlink:href='%23f' transform='scale(-1 1)'/%3e%3cpath stroke='%23009e49' d='M0 712V12'/%3e%3cpath d='M0 48c-9 39 13 73 0 106-13 32 9 45 2 71-8 26 9 45-2 73s15 50 0 87c-15 36 10 45 0 82-11 42 19 64 0 94s17 37 2 71c-15 33 9 46-2 80'/%3e%3cpath fill='%23fcd116' d='M15 174c-5 11 15 37 4 57-12 19 6 49-6 73s19 54 7 82c-13 28 6 63 0 89-5 26 13 76 0 94-13 19 13 24-2 70s-25 7-16-7c19-31-21-41-2-71s-11-52 0-94c10-37-15-46 0-82 15-37-11-59 0-87s-6-47 2-73c7-26-15-39-2-71 10-32 20 9 15 20zm-84 32c-7 12 12 35-5 58-12 16 8 35-9 58-11 16 11 36-4 59-10 13 7 38-5 57-12 20 6 36-15 62-12 14 9 49-4 60s-1 54-10 60c-8 7 0 38-22 45 11-15-11-30 7-52 19-22-3-47 10-63 13-17-8-39 7-60 15-20-11-37 7-59 19-23-7-41 8-60 15-18-9-31 7-56 17-24-11-37 8-61 18-24-8-43 9-67s-6-30 7-54c24 9 12 61 4 73zm-50-65c-10 16 4 35-11 55-15 21 0 47-15 64-15 16 4 48-15 61s-7 52-22 65 0 50-17 69-9 58-19 67c-9 9 13 28-3 41-17 13-17 39-39 56 13-13-4-32 15-51 18-18-8-37 14-61 23-24-1-50 19-71 20-20-4-42 17-63 20-20-4-35 16-58 21-22-3-40 17-61 21-20-2-35 17-59 19-25-6-36 11-58 8-10 8-19 8-27 12-31 12 23 7 31z'/%3e%3cpath fill='%23ce1126' d='M-139 35c0-210 29-283 139-283s139 73 139 283z'/%3e%3cpath fill='%23000' d='M-139 35c0-210 29-283 139-283-50 0-81 39-89 65-9 26-4 24 7 14s6 12-4 24c-9 12-18 47-5 36 13-12 23 1 9 21-14 19-26 65-12 49s17 10 8 23c-8 13-7 25 0 19 8-6 7 21 0 32zm191-4C52 0 53-73 36-97c-12-19-12-39 2-17s21 11 11-11c-12-28-28-59-24-65 5-7 8-4 18 11s12-7 1-22c-11-14-10-17 13-7 41 17 61 66 61 231z'/%3e%3cpath fill='%23ce1126' d='M0 65c-44 0-92-7-124-20-38-15-40-28-27-44 10-12 30-5 50 4 19 8 73 14 101 14s82-6 101-15c20-8 40-15 50-3 13 16 11 29-27 44C92 58 44 65 0 65z'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";
            },
            2346: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 300'%3e%3cpath fill='%23C60C30' d='M0 0h450v300H0z'/%3e%3cpath fill='%23FECB00' d='M0 0h300v300H0z'/%3e%3cpath fill='%23002664' d='M0 0h150v300H0z'/%3e%3c/svg%3e";
            },
            9418: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 600 400'%3e%3cdefs%3e%3cpath id='a' fill='%23fff' d='M0-1 .588.809-.952-.309H.952L-.588.809z' transform='scale(21)'/%3e%3c/defs%3e%3cpath fill='%23002395' d='M0 0h600v400H0z'/%3e%3cpath fill='%23fff' d='M0 0h244v164H0z'/%3e%3cpath fill='%23002395' d='M0 0h80v160H0z'/%3e%3cpath fill='%23ED2939' d='M160 0h80v160h-80z'/%3e%3cpath fill='%23fff' d='m355 183 12.875 20.5H404.5V275L377 232l-37 59h18l19-34 39 70 39-70 19 34h18l-37-59-27.5 43v-39.5H444l12.25-19.5H427.5v-12.5h36.625L477 183H355zm43 87.5h-40v14h40zm76 0h-40v14h40z'/%3e%3cuse xlink:href='%23a' x='416' y='362'/%3e%3cuse xlink:href='%23a' x='371' y='328'/%3e%3cuse xlink:href='%23a' x='461' y='328'/%3e%3cuse xlink:href='%23a' x='333' y='227'/%3e%3cuse xlink:href='%23a' x='499' y='227'/%3e%3c/svg%3e";
            },
            3969: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 809 500'%3e%3cpath fill='%23006a4e' d='M0 0h809v500H0z'/%3e%3cpath fill='%23ffce00' d='M0 100h809v100H0zm0 200h809v100H0z'/%3e%3cpath fill='%23d21034' d='M0 0h300v300H0z'/%3e%3cg fill='%23fff' transform='translate(150 150)'%3e%3cg id='b'%3e%3cpath id='a' d='M0-95V0h50' transform='rotate(18 0 -95)'/%3e%3cuse xlink:href='%23a' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(72)'/%3e%3cuse xlink:href='%23b' transform='rotate(144)'/%3e%3cuse xlink:href='%23b' transform='rotate(216)'/%3e%3cuse xlink:href='%23b' transform='rotate(288)'/%3e%3c/g%3e%3c/svg%3e";
            },
            9493: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3cpath fill='%23A51931' d='M0 0h900v600H0z'/%3e%3cpath fill='%23F4F5F8' d='M0 100h900v400H0z'/%3e%3cpath fill='%232D2A4A' d='M0 200h900v200H0z'/%3e%3c/svg%3e";
            },
            5437: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1400 700'%3e%3cpath fill='%23060' d='M0 0h1400v700H0z'/%3e%3cpath fill='%23fff' d='M0 0h1400v500H0z'/%3e%3cpath fill='%23c00' d='M0 0h1400v200H0z'/%3e%3cg fill='%23f8c300'%3e%3cpath d='M672 340.7a12.5 12.5 0 0 1 23.3 5.9v50h9.4v-50a12.5 12.5 0 0 1 23.3-5.9 29.5 29.5 0 1 0-56 0'/%3e%3cpath fill='%23fff' d='M678.7 327.65a20 20 0 0 1 21.3 9.55 20 20 0 0 1 21.3-9.55 21.5 21.5 0 0 0-42.6 0'/%3e%3cpath id='a' d='M695.3 376.627a38 38 0 0 1-63.845 24.316 39.5 39.5 0 0 1-59.734 17.467c3.65 36.426 58.252 28.989 62.32-6.429 17.154 30.115 54.873 21.49 65.91-15.4z'/%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 1400 0)'/%3e%3cpath id='b' d='M658.84 441.31c-7.618 16.446-22.845 19.271-36.164 5.995 0 0 5.354-3.783 11.086-4.826-1.075-4.574 1.13-10.902 4.235-14.324 3.258 2.227 7.804 6.689 8.96 11.874 8.03-1.04 11.883 1.282 11.883 1.282z'/%3e%3cuse xlink:href='%23b' transform='rotate(9.37 700 804)'/%3e%3cuse xlink:href='%23b' transform='rotate(18.74 700 804)'/%3e%3cpath fill='none' stroke='%23f8c300' stroke-width='16' d='M603 478a340 340 0 0 1 194 0'/%3e%3cg transform='translate(700 380)'%3e%3cg transform='translate(0 -140)'%3e%3cpath id='c' d='m0-513674 301930 929245-790463-574305h977066l-790463 574305z' transform='scale(.00005)'/%3e%3c/g%3e%3cg id='d'%3e%3cuse xlink:href='%23c' transform='translate(-70 -121.244)'/%3e%3cuse xlink:href='%23c' transform='translate(-121.244 -70)'/%3e%3cuse xlink:href='%23c' transform='translate(-140)'/%3e%3c/g%3e%3cuse xlink:href='%23d' transform='scale(-1 1)'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";
            },
            7238: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1800 900'%3e%3cdefs%3e%3cg id='b'%3e%3cg id='a'%3e%3cpath d='M1-.325H0v.5z'/%3e%3cpath d='M1-.325.191.263l-.294-.405z'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='rotate(72)'/%3e%3cuse xlink:href='%23a' transform='rotate(144)'/%3e%3cuse xlink:href='%23a' transform='rotate(216)'/%3e%3cuse xlink:href='%23a' transform='rotate(288)'/%3e%3c/g%3e%3c/defs%3e%3cpath fill='%2300247d' d='M0 0h1800v900H0z'/%3e%3cpath fill='%23fed100' d='M329.376 777.265c-17.934-.15 168.624-99.431 324.77-226.6C858.788 384 1299.54 117.157 1429.115 73.796c13.543-4.532-27.776 23.073-33.14 32.016-138.341 163.74-27.925 472.724 144.973 628.048 51.99 39.763 49.327 41.85 145.707 45.746v9l-1357.28-11.34zm-11.251 18.06S304.962 804.727 305 811.73c.043 7.772 14.766 18.047 14.766 18.047l1338.745 14.765 24.609-16.406-34.453-21.328-1330.542-11.484z'/%3e%3cg fill='%23fff'%3e%3cuse xlink:href='%23b' transform='matrix(45 0 0 45 342.957 112.581)'/%3e%3cuse xlink:href='%23b' transform='matrix(37.5 0 0 37.5 521.205 267.53)'/%3e%3cuse xlink:href='%23b' transform='matrix(45 0 0 45 135 321.808)'/%3e%3cuse xlink:href='%23b' transform='matrix(52.5 0 0 52.5 342.957 652.581)'/%3e%3c/g%3e%3c/svg%3e";
            },
            7246: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 600'%3e%3cpath fill='%23dc241f' d='M1200 600V0H0v600z'/%3e%3cpath fill='%23ffc726' d='M0 0v600l600-300z'/%3e%3cpath d='M0 0v600l400-300z'/%3e%3cpath fill='%23fff' d='m92.858 208.928 19.76 189.181 95.212-164.663-173.817 77.251 186.025 39.67-127.18-141.44'/%3e%3c/svg%3e";
            },
            4698: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 900 600'%3e%3cpath fill='%2328ae66' d='M0 0h900v600H0z'/%3e%3cg fill='%23fff'%3e%3cpath d='M446.821 66.543c26.6 11.42 45.236 37.85 45.236 68.627 0 41.225-33.43 74.655-74.654 74.655-18.455 0-35.345-6.704-48.377-17.805a74.443 74.443 0 0 0 26.15 5.951c41.185 1.798 76.042-30.142 77.84-71.327 1.044-23.91-9.287-45.687-26.195-60.101z'/%3e%3cpath id='a' d='m375.616 121.42 8.458-26.033-22.145 16.09h27.373l-22.145-16.09z'/%3e%3cuse xlink:href='%23a' height='600' y='-38.4'/%3e%3cuse xlink:href='%23a' x='37.937' y='-18.722'/%3e%3cuse xlink:href='%23a' x='-37.936' y='18.722'/%3e%3cuse xlink:href='%23a' height='600' y='38.4'/%3e%3c/g%3e%3cg fill='%23383739'%3e%3cpath fill='%23ca3745' d='M107.998 0h162v600h-162z'/%3e%3cg id='c'%3e%3cg id='b'%3e%3cpath d='M107.998-39.619v5.88l9.11 8.527-3.072 2.86 6.515 6.038-2.86 2.596v-3.761h-5.562v4.502l12.553 11.759h6.356l.689-4.132h-3.655l3.972-3.707L142.002 0l-9.958 9.11-3.972-3.708h3.655l-.689-4.184h-6.356L112.13 12.977v4.502h5.562v-3.76l2.86 2.594-6.515 6.039 3.072 2.913-9.11 8.474v5.88l15.413-14.354-3.072-2.913 6.462-6.039-5.562-5.19 3.708-3.39 7.097 6.568L147.617 0l-15.573-14.3-7.097 6.62-3.708-3.443 5.562-5.19-6.462-6.039 3.072-2.86-15.413-14.407zm0 28.549v22.14l3.602-3.655v-4.29h3.813L118.485 0l-3.072-3.072H111.6v-4.343l-3.602-3.655zm26.271 7.839-.53 3.019.53 3.072 3.284-3.072-3.284-3.02z'/%3e%3cpath fill='%23faae29' d='M107.998-38.983v4.66l9.746 9.11-3.072 2.861 6.514 6.038-3.919 3.655v-4.396h-4.714v3.92l12.341 11.493h5.72l.583-3.284h-4.237l5.084-4.767L142.638 0l-10.594 9.693-5.084-4.714h4.237l-.584-3.337h-5.72L112.55 13.135v3.92h4.715v-4.396l3.919 3.654-6.515 6.038 3.072 2.913-9.745 9.058v4.66l14.777-13.718-3.072-2.913 6.462-6.038-5.562-5.19 4.344-4.026 7.097 6.62L146.927 0l-14.884-13.718-7.097 6.62-4.344-4.025 5.562-5.19-6.462-6.039 3.072-2.86-14.777-13.771zm0 28.548v20.87l3.178-3.179V2.648h4.078L117.903 0l-2.649-2.648h-4.078v-4.609l-3.178-3.177zm26.589 8.051-.37 2.172.37 2.172 2.33-2.172-2.33-2.172z'/%3e%3c/g%3e%3cuse xlink:href='%23b' y='109.207'/%3e%3cuse xlink:href='%23b' y='222.005'/%3e%3cuse xlink:href='%23b' y='334.802'/%3e%3cuse xlink:href='%23b' y='447.598'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='matrix(-1 0 0 1 377.996 0)'/%3e%3cpath id='d' fill='%23faae29' d='M121.14 530.824c.8 3.407 3.508 5.979 4.154 9.513 1.292-3.685 2.484-6.773 1.594-10.804-.637-2.883-3.062-4.94-3.343-7.902-2.644 2.377-3.213 5.749-2.405 9.193zm-.67 14.276c2.243 3.075 5.36 5.434 8.803 7.007-.678-2.694.594-4.722 2.006-6.86 1.7-2.574 2.53-5.103 1.143-8.067-.646 1.541-1.514 2.821-2.533 4.139-1.506 2.055-2.497 3.883-2.73 6.52-1.742-1.292-2.507-3.22-3.439-5.086-1.42-2.673-3.712-4.908-6.345-6.369.7 2.998 1.238 6.169 3.095 8.716zm12.578 9.166c-.48 1.708-.893 3.4-.8 5.186-1.482-1.597-3.45-2.799-5.206-4.085-2.39-1.934-5.178-3.298-7.133-5.76.292 3.624 1.843 6.578 4.788 8.783 3.113 2.33 6.867 3.583 9.933 6.03-.46-3.297.752-5.937 1.784-8.967.86-2.895.028-5.834-1.935-8.04.029 2.445-.743 4.545-1.43 6.853zm6.986 11.133c.645 2.5 2.437 4.534 3.66 6.764-3.299-1.023-6.21-2.812-9.191-4.495-3.552-1.934-7.41-3.165-10.625-5.719 1.6 5.924 5.567 9.359 11.369 11.11 3.967 1.198 7.31.6 12.124 2.546-.552-3.259-1.525-6.776-3.066-9.714-1.195-2.125-2.521-4.221-3.26-6.562-1.07 1.923-1.576 3.879-1.011 6.07zm12.139 9.065a15.21 15.21 0 0 0 4.494 4.875c-4.683.299-8.451-2.669-13.017-2.798-2.82-.08-5.497.796-8.373.533 3.413 2.303 6.986 4.314 11.141 4.851 5.401.699 10.382-.66 16.341-.129-2.785-1.965-4.178-4.595-5.914-7.423-2.26-3.533-4.393-6.05-8.789-6.618 1.765 1.983 2.792 4.44 4.117 6.71zm16.631 7.773c-8.25 1.403-16.156 3.218-24.581 3.301 9.431 3.288 18.318 3.883 27.672.488 5.055-1.835 8.93-2.817 12.748-2.544 5.58.401 12.36 2.603 19.865 10.517l2.95-2.36c-10.756-9.583-24.829-11.753-38.654-9.403z'/%3e%3cuse xlink:href='%23d' transform='matrix(-1 0 0 1 378.036 0)'/%3e%3cpath d='m128.266 70.34-12.981-7.961V43.244l12.981-7.96V25.159l12.267-7.388h9.8l18.648-10.488h40.033l18.648 10.488h9.8l12.267 7.388v10.125l12.981 7.96v19.135l-12.98 7.96v10.125l-12.268 7.387h-9.8L209.014 98.34h-40.033l-18.648-10.489h-9.8l-12.267-7.387z'/%3e%3cpath fill='%2328ae66' d='M169.068 7.733 150.424 18.22h-9.746l-11.97 7.203V35.54l-12.977 7.945v18.644l12.977 7.945v10.17l11.917 7.203h9.799l18.644 10.487h39.83l18.644-10.487h9.8l11.97-7.204v-10.17l12.976-7.944V43.485l-12.976-7.945V25.423l-11.97-7.203h-9.8L208.898 7.733h-39.83zm1.112 3.866h37.66l18.643 10.488h9.746l9.057 5.455V37.66l13.03 7.945V60.01l-13.03 7.945v10.117l-9.057 5.455h-9.746L207.84 94.015h-37.66l-18.644-10.488h-9.745l-9.11-5.455V67.955l-12.977-7.945V45.604l12.976-7.945V27.542l9.11-5.455h9.746l18.644-10.488z'/%3e%3cpath fill='%23faae29' d='M188.783 53.025V12.017h-18.506L151.63 22.505h-9.722l-8.795 5.296v10.1l-12.98 7.96v6.736h69.08v41.009h18.506l18.648-10.489h9.723l8.794-5.296v-10.1l12.98-7.96v-6.735z'/%3e%3cpath fill='%23fff' d='M120.131 53.025v6.736l12.98 7.96v10.1l8.795 5.296h9.722l18.648 10.489h18.506v-41.01h69.081v-6.735l-12.98-7.96v-10.1l-8.795-5.296h-9.723l-18.648-10.488h-18.505v41.008z'/%3e%3cg id='f'%3e%3cg id='e'%3e%3cpath d='m148.448 26.28-3.196-2.978-3.166 1.952 3.201 2.985-4.11 2.546h8.969l7.73 7.29 2.472-2.61-7.515-7.09v-4.811z'/%3e%3cpath d='m163.573 24.972-3.196-2.978-3.166 1.952 3.201 2.984-4.11 2.547h8.969l7.73 7.29 2.472-2.61-7.515-7.09v-4.812zm-16.234 9.864-3.196-2.979-3.165 1.953 3.2 2.984-4.11 2.547h8.97l7.728 7.29 2.473-2.611-7.515-7.089v-4.812z'/%3e%3cpath d='M188.997 11.589h-8.093l-4.235 4.081h-8.255l-6.1 3.166 1.422 3.467 5.44-2.858h2.383l8.341 9.647 9.097-5.54z'/%3e%3cpath fill='%23ca3745' d='m145.199 23.838 2.872 2.676-2.406 1.49-2.876-2.68 2.41-1.486zm7.205.495v4.227l7.338 6.921-1.884 1.99-7.542-7.114h-7.635l9.723-6.024zm7.92-1.803 2.872 2.676-2.406 1.49-2.876-2.68 2.41-1.487zm7.205.494v4.227l7.338 6.922-1.884 1.99-7.542-7.114h-7.635l9.723-6.025z'/%3e%3cpath fill='%23ca3745' d='m144.091 32.393 2.871 2.677-2.406 1.49-2.875-2.68 2.41-1.487zm7.205.495v4.227l7.337 6.922-1.883 1.99-7.542-7.114h-7.636l9.724-6.025zm37.487-20.871h-7.706l-4.235 4.08h-8.324l-5.66 2.938 1.095 2.67 5.117-2.688h2.685l8.232 9.521 8.796-5.356z'/%3e%3c/g%3e%3cuse xlink:href='%23e' transform='matrix(1 0 0 -1 0 105.623)'/%3e%3cpath d='m143.054 39.71-3.859-1.441-.092.064-4.982 3.457v.93l-7.98 10.091 7.98 10.092v.93l5.074 3.52 3.859-1.441-2.355-1.56v-2.967l.936-1.12h4.181V45.358h-4.181l-.936-1.12V41.27z'/%3e%3cpath fill='%23ca3745' d='m134.549 42.014 4.706-3.266 2.862 1.07-1.846 1.223v3.352l1.164 1.392h3.952v14.053h-3.952l-1.164 1.392v3.352l1.846 1.223-2.862 1.07-4.706-3.266v-.855l-7.862-9.943 7.863-9.943z'/%3e%3c/g%3e%3cuse xlink:href='%23f' transform='matrix(-1 0 0 1 377.994 0)'/%3e%3cpath d='m136.203 61.282-2.173-1.88v-.906l-4.66-5.685 4.661-5.685v-.906l2.173-1.88 3.902 3.174-2.252-.017 3.328 3.378h7.605l5.98-4.677V33.863h14.96l17.372-10.66v-2.796l-2.657-1.771h-.842l-2.893 1.936-.448 1.444-2.264-3.09 4.399-3.695h.703l4.964-3.642h1.871l4.964 3.642h.703l4.399 3.695-2.263 3.09-.448-1.444-2.894-1.936h-.841l-2.657 1.77v2.797l17.372 10.66h14.959v12.335l5.98 4.677h7.606l3.328-3.378-2.253.017 3.903-3.173 2.172 1.88v.905l4.662 5.685-4.662 5.685v.906l-2.172 1.88-3.903-3.173 2.253.017-3.328-3.378h-7.605l-5.981 4.677V71.76h-14.959l-17.372 10.66v2.796l2.657 1.77h.841l2.894-1.935.448-1.445 2.263 3.09-4.399 3.696h-.703l-4.964 3.642h-1.871l-4.964-3.642h-.703l-4.4-3.696 2.265-3.09.448 1.445 2.892 1.936h.842l2.658-1.77V82.42l-17.373-10.66h-14.958V59.424l-5.982-4.677h-7.604l-3.328 3.378 2.252-.017z'/%3e%3cpath fill='%23faae29' d='m189.211 87.319 1.901 1.454-1.901 1.453V87.32zm-6.044 2.644h.07l4.964 3.643h.58v-2.842l-2.604-1.991 2.604-1.992v-5.337l-18.589-11.408H156.45V58.574l-7.095-5.55h-10.701l-2.69 3.042-2.69-3.041h-3.176l4.36 5.318v.863l1.727 1.5 2.774-2.16-1.628.013v-.54l3.629-3.7h7.974l6.262 4.898V71.33h14.651l17.68 10.85v3.264l-2.956 1.97h-1.103l-3.126-2.093-.24-.777-1.525 2.08 3.973 3.338h.617zm-47.2-39.76 2.117 2.394h-4.236l2.118-2.394zm52.815-34.807-1.9 1.453 1.9 1.454v-2.907zm51.127 37.63 2.118 2.393 2.118-2.394h-4.236zm-45.154-37.367-4.964-3.642h-.58v2.84l2.606 1.993-2.606 1.992v5.337l18.59 11.407h13.741V47.05l7.095 5.549h10.7l2.69-3.041 2.69 3.04h3.177l-4.36-5.317v-.864l-1.726-1.5-2.775 2.16 1.629-.013v.54l-3.63 3.7h-7.973l-6.262-4.898V34.29h-14.652l-17.679-10.85v-3.264l2.956-1.97h1.102l3.127 2.094.24.776 1.525-2.08-3.973-3.339h-.688z'/%3e%3cpath fill='%23fff' d='m188.782 90.226-1.9-1.453 1.9-1.453v2.906zm-50.698-37.2-2.118 2.394-2.118-2.394h4.236zm56.741 36.937h-.07l-4.964 3.643h-.58v-2.84l2.606-1.993-2.606-1.993v-5.336l18.59-11.408h13.741V58.574l7.095-5.549h10.7l2.69 3.041 2.69-3.041h3.177l-4.36 5.318v.863l-1.726 1.5-2.775-2.16 1.629.013v-.54l-3.63-3.7h-7.973l-6.262 4.898v12.115h-14.652L190.466 82.18v3.264l2.956 1.97h1.102l3.127-2.093.24-.777 1.525 2.081-3.973 3.337h-.618zm47.202-39.76-2.118 2.394h4.237l-2.119-2.394zM183.24 15.66l4.963-3.642h.58v2.84l-2.605 1.993 2.606 1.992v5.337l-18.59 11.408h-13.74V47.05l-7.096 5.549h-10.703l-2.69-3.041-2.69 3.04H130.1l4.36-5.317v-.863l1.727-1.5 2.773 2.16-1.628-.014v.541l3.63 3.698h7.973l6.262-4.897V34.291h14.651l17.68-10.849v-3.265l-2.956-1.969h-1.102l-3.127 2.093-.24.776-1.525-2.08 3.974-3.338h.687zm5.972 2.645 1.901-1.454-1.901-1.454v2.908z'/%3e%3cpath fill='%2328ae66' d='M188.783 53.025V24.68l-18.469 11.334H156.88v11.243l-6.828 5.34h39.16v28.345l18.467-11.334h13.435V58.366l6.828-5.34z'/%3e%3cpath fill='%23ca3745' d='m150.051 53.025 6.829 5.34v11.243h13.434l18.469 11.334V52.596l39.159.001-6.828-5.34V36.014h-13.435l-18.467-11.333v28.344z'/%3e%3cpath d='m169.118 39.063-3.195-2.978-3.166 1.952 3.2 2.984-4.11 2.547h8.97l7.729 7.29 2.472-2.61-7.515-7.09v-4.811zm39.755 27.497 3.196 2.978 3.165-1.953-3.2-2.984 4.11-2.546h-8.97l-7.728-7.291-2.473 2.611 7.515 7.09v4.811zm-39.755 0-3.196 2.978-3.165-1.953 3.2-2.984-4.11-2.546h8.97l7.728-7.291 2.473 2.611-7.515 7.09v4.811zm39.755-27.497 3.196-2.978 3.165 1.952-3.2 2.984 4.11 2.547h-8.97l-7.728 7.29-2.473-2.61 7.515-7.09v-4.811z'/%3e%3cpath fill='%23ca3745' d='m212.122 69.002-2.871-2.677 2.406-1.49 2.875 2.68-2.41 1.487zm-7.205-.495V64.28l-7.337-6.921 1.884-1.99 7.541 7.114h7.636l-9.724 6.024zM165.87 36.62l2.872 2.677-2.407 1.49-2.875-2.68 2.41-1.487zm7.206.496v4.226l7.337 6.922-1.884 1.99-7.541-7.114h-7.636l9.724-6.024z'/%3e%3cpath fill='%2328ae66' d='m212.122 36.62-2.871 2.677 2.406 1.49 2.875-2.68-2.41-1.487zm-7.205.496v4.226l-7.337 6.922 1.884 1.99 7.541-7.114h7.636l-9.724-6.024zM165.87 69.002l2.871-2.677-2.406-1.49-2.875 2.68 2.41 1.487zm7.205-.495V64.28l7.338-6.921-1.884-1.99-7.541 7.114h-7.636l9.723 6.024z'/%3e%3cpath d='m208.856 52.812-19.859 13.235-19.859-13.235 19.859-13.236z'/%3e%3cpath fill='%23fff' d='m188.783 40.233-18.551 12.364h37.531l-18.551-12.364V65.39l18.552-12.365h-37.533l18.552 12.365z'/%3e%3cpath d='M194.308 57.363v3.639h-10.62v-3.64h-6.874V48.26h6.873v-3.64h10.621v3.64h6.873v9.103z'/%3e%3cpath fill='%23ca3745' d='M184.116 45.048v3.64h-6.873v3.909h11.54v-7.549h-4.667zm5.096 7.549h11.54v-3.91h-6.872v-3.639h-4.668v7.549zm-11.969.428v3.91h6.873v3.639h4.667v-7.549h-11.54zm11.97 7.549h4.667v-3.639h6.873v-3.91h-11.54v7.55z'/%3e%3cpath d='M222.877 203.61v-5.83h15.988v-5.83h15.988v-52.682h-15.988v-5.83h-15.988v-5.83h-15.988v-5.83h-35.782v5.83h-15.989v5.83H139.13v5.83h-15.99v52.682h15.989v5.83h15.988v5.83h15.989v5.83h35.782v-5.83z'/%3e%3cpath fill='%23ca3745' d='M171.558 122.193v5.826h-15.996v5.827h-15.996v5.826H123.57v51.854h15.996v5.827h15.996v5.825h15.996v5.826h34.903v-5.826h15.997v-5.825h15.997v-5.827h15.994v-51.854h-15.994v-5.826h-15.997v-5.827h-15.997v-5.826h-34.903zm4.237 4.237h26.43v5.826h15.996v5.827h15.996v5.826h15.995v43.38h-15.995v5.826h-15.996v5.826h-15.997v5.825h-26.429v-5.825H159.8v-5.826h-15.996v-5.827h-15.996v-43.38h15.996v-5.825H159.8v-5.827h15.996v-5.826z'/%3e%3cpath fill='%23ca3745' d='M160.209 198.519v-5.83h-15.988v-5.83h-15.989v-42.5h15.989v-5.831h15.988v-5.83h15.988v-5.83h25.601v5.83h15.989v5.83h15.987v5.83h15.99v42.5h-15.99v5.83h-15.987v5.831h-15.989v5.83h-25.6v-5.83z'/%3e%3cpath d='m163.921 137.014-4.141-3.13v6.01l-3.966 2.52-.01-3.762-3.803 3.416-3.804-3.416-.01 3.763-4.394-2.793v5.573l-3.552 2.571-.01-3.417-4.219 3.056-4.219-3.056-.01 3.417-3.98-2.881v16.881h-4.662v7.685h4.662v16.881l3.98-2.882.01 3.418 4.22-3.056 4.218 3.056.01-3.418 3.551 2.571v5.574l4.395-2.793.01 3.763 3.803-3.416 3.804 3.416.01-3.763 3.965 2.52v6.011l4.142-3.13.009 4.198 4.058-3.63 4.059 3.63.009-4.198 3.713 2.806v6.411l5.551-5.06v5.946l7.678-4.936 7.678 4.936v-5.946l5.551 5.06v-6.41l3.712-2.807.01 4.198 4.058-3.63 4.06 3.63.008-4.198 4.14 3.13v-6.011l3.967-2.52.01 3.763 3.804-3.416 3.803 3.416.01-3.763 4.395 2.793v-5.574l3.552-2.57.01 3.417 4.218-3.056 4.22 3.056.01-3.418 3.98 2.882V169.45h4.661v-7.685h-4.662v-16.881l-3.98 2.881-.01-3.417-4.219 3.056-4.219-3.056-.009 3.417-3.551-2.571v-5.573l-4.395 2.793-.01-3.763-3.804 3.416-3.804-3.416-.01 3.763-3.966-2.521v-6.01l-4.14 3.13-.01-4.199-4.058 3.63-4.06-3.63-.008 4.199-3.713-2.807v-6.41l-5.55 5.06v-5.946l-7.679 4.936-7.678-4.936v5.946l-5.55-5.06v6.41l-3.714 2.807-.009-4.199-4.059 3.63-4.058-3.63z'/%3e%3cpath fill='%2328ae66' d='m132.21 148.604.01-3.418 3.793 2.748.127-.093 3.665-2.655.01 3.418 3.978-2.88v39.769l-3.978-2.88-.01 3.418-3.792-2.748-3.793 2.748-.01-3.418-3.978 2.88v-16.471h-4.662v-6.827h4.662v-16.47zm32.146-14.832 3.632 3.248 3.633-3.248.009 4.102 4.139-3.129v61.728l-4.14-3.13-.008 4.103-3.633-3.249-3.632 3.249-.008-4.102-4.139 3.129v-61.728l4.139 3.13zm49.284 0-3.632 3.248-3.633-3.248-.009 4.102-4.138-3.129v61.728l4.138-3.13.01 4.103 3.632-3.249 3.632 3.249.009-4.102 4.139 3.129v-61.728l-4.139 3.13zm32.146 14.832-.01-3.418-3.793 2.748-.128-.093-3.665-2.655-.01 3.418-3.977-2.88v39.769l3.977-2.88.01 3.418 3.793-2.748 3.793 2.748.01-3.418 3.977 2.88v-16.471h4.662v-6.827h-4.662v-16.47z'/%3e%3cpath fill='%23faae29' d='m148.623 139.611 3.377 3.034 3.378-3.034.01 3.583 4.392-2.792v50.413l-4.392-2.791-.01 3.582-3.378-3.033-3.377 3.033-.01-3.582-4.393 2.791v-50.413l4.393 2.792zm33.125-5.784-5.551-5.06v73.683l5.551-5.06v6.131l7.249-4.66 7.25 4.66v-6.131l5.55 5.06v-73.683l-5.55 5.06v-6.131l-7.25 4.66-7.249-4.66zm47.625 5.784-3.377 3.034-3.378-3.034-.01 3.583-4.393-2.792v50.413l4.394-2.791.009 3.582 3.378-3.033 3.377 3.033.01-3.582 4.393 2.791v-50.413l-4.393 2.792z'/%3e%3cg id='h'%3e%3cg id='g'%3e%3cpath d='M134.288 158.366c.485.49 1.066.737 1.724.737.659 0 1.239-.247 1.725-.737 1.518-1.53 1.57-4.297 1.554-6.289l-2.072 2.19-1.207-2.083s-.985 1.702-1.207 2.083l-2.072-2.19c-.015 1.992.036 4.759 1.555 6.289zm16.678-4.286-1.28-1.278v-2.546l-2.937 2.722L152 158.23l5.252-5.252-2.938-2.722v2.546l-1.279 1.278v-4.511l2.265-1.945-3.3-2.834-3.3 2.834 2.266 1.945zm15.987-5.06-1.279-1.279v-2.546l-2.937 2.723 5.251 5.251 5.251-5.251-2.937-2.723v2.546l-1.28 1.279v-4.512l2.266-1.945-3.3-2.833-3.3 2.833 2.265 1.945z'/%3e%3cpath fill='%23fff' d='m136.013 153.039 1.123 1.94 1.709-1.806c-.06 2.25-.553 4.026-1.412 4.89-.402.406-.88.612-1.42.612-.54 0-1.018-.206-1.42-.611-.859-.865-1.353-2.642-1.412-4.89l1.708 1.805 1.124-1.94zm32.582-8.727v5.743l2.136-2.135v-1.743l1.891 1.754-4.633 4.633-4.634-4.633 1.891-1.754v1.743l2.136 2.135v-5.743l-2.035-1.748 2.642-2.268 2.642 2.268z'/%3e%3cpath fill='%23ca3745' d='M152.607 149.372v5.743l2.136-2.136v-1.742l1.891 1.753-4.634 4.634-4.633-4.634 1.891-1.753v1.742l2.136 2.136v-5.743l-2.035-1.748 2.641-2.268 2.643 2.268z'/%3e%3c/g%3e%3cuse xlink:href='%23g' transform='matrix(-1 0 0 1 377.996 0)'/%3e%3cpath d='m195.282 150.937-1.72-2.377 4.411-4.072-4.113-3.38v2.394l-1.72 1.472v-4.342l3.885-2.864-7.029-5.18-7.029 5.18 3.887 2.864v4.342l-1.72-1.472v-2.394l-4.114 3.38 4.412 4.072-1.72 2.377z'/%3e%3cpath fill='%23ca3745' d='m183.552 150.509 1.45-2.006-4.328-3.996 3.032-2.491v1.684l2.577 2.206v-5.49l-3.592-2.647 6.307-4.649 6.306 4.649-3.591 2.647v5.49l2.577-2.206v-1.684l3.032 2.491-4.329 3.996 1.451 2.006z'/%3e%3cpath d='m185.785 137.769 3.212 2.367 3.212-2.367-3.212-2.368-.127.095z'/%3e%3cpath fill='%2328ae66' d='m188.997 135.934 2.49 1.835-2.49 1.835-2.49-1.835 2.49-1.835z'/%3e%3c/g%3e%3cuse xlink:href='%23h' transform='matrix(1 0 0 -1 0 331.216)'/%3e%3cpath d='M245.902 163.15h-7.037v-2.805h-21.511l-14.974-9.836h-26.765l-14.974 9.836h-21.51v2.805h-7.038v4.918h7.037v2.805h21.511l14.974 9.836h26.765l14.974-9.836h21.51v-2.805h7.038z'/%3e%3cpath fill='%23ca3745' d='m175.742 150.953-14.99 9.799h-21.186v2.807h-7.044v4.078h7.044v2.808h21.187l14.989 9.851h26.536l14.936-9.851h21.24v-2.808h7.044v-4.078h-7.044v-2.807h-21.24l-14.936-9.799zm.318 1.43h25.847l13.718 9.004v1.377h15.308v5.72h-15.308v1.378l-13.718 8.951H176.06l-13.665-8.951v-1.377h-15.36v-5.72h15.36v-1.378z'/%3e%3cpath fill='%23ca3745' d='m201.799 152.826 13.379 8.783v1.56h15.332v4.88h-15.332v1.559l-13.379 8.783h-25.604l-13.38-8.783v-1.56h-15.331v-4.88h15.332v-1.559l13.379-8.783z'/%3e%3cpath d='m169.551 170.598 5.793 4.349 3.81-2.862-2.215-1.663-1.595 1.198-1.362-1.022 21.815-16.379h-4.43zm12.645 6.4h4.43l21.816-16.378-5.792-4.348-3.811 2.86 2.215 1.663 1.596-1.198 1.362 1.023zm9.171 0h4.43l-21.815-16.378 1.362-1.023 1.595 1.198 2.216-1.662-3.811-2.861-5.793 4.348zm12.645-6.4-1.362 1.022-1.596-1.198-2.215 1.663 3.811 2.862 5.792-4.349-21.816-16.379h-4.43zm-38.848-4.989 3.893 2.586 3.894-2.586-3.894-2.586z'/%3e%3cpath d='m185.104 165.609 3.893 2.586 3.894-2.586-3.894-2.586zm27.728 0-3.893 2.586-3.894-2.586 3.894-2.586z'/%3e%3cpath fill='%23faae29' d='m207.729 170.598-5.078 3.813-3.098-2.326 1.502-1.127 1.596 1.198 2.075-1.558-21.245-15.95h3.003zm-13.216 5.972h-3.003l-21.244-15.95 5.079-3.813 3.096 2.326-1.501 1.126-1.595-1.198-2.076 1.559zm-8.029 0h-3.003l21.245-15.95-2.075-1.559-1.596 1.198-1.502-1.126 3.098-2.326 5.078 3.813zm5.026-21.922h3.003l-21.244 15.95 2.076 1.558 1.595-1.198 1.501 1.127-3.096 2.326-5.08-3.813z'/%3e%3cpath fill='%2328ae66' d='m169.057 163.538 3.119 2.071-3.119 2.071-3.119-2.07zm19.941 0 3.119 2.071-3.119 2.071-3.118-2.07zm19.941 0-3.119 2.071 3.119 2.071 3.118-2.07z'/%3e%3cpath d='m120.514 274.151-1.528 2.16 2.739 2.095-2.74 2.094 1.528 2.16 3.182.37 3.081-2.38 7.682 4.88v-4.053l-4.835-3.071 4.835-3.071v-4.053l-7.682 4.88-3.08-2.38z'/%3e%3cpath d='m120.514 260.073-1.528 2.161 2.739 2.094-2.74 2.094 1.528 2.161 3.182.37 3.081-2.381 7.682 4.88v-4.053l-4.835-3.07 4.835-3.072v-4.053l-7.682 4.88-3.08-2.38zm0 36.666-1.528-2.16 2.739-2.095-2.74-2.094 1.528-2.16 3.182-.37 3.081 2.38 7.682-4.88v4.053l-4.835 3.071 4.835 3.071v4.053l-7.682-4.88-3.08 2.38zm136.968-22.588 1.528 2.16-2.739 2.095 2.739 2.094-1.528 2.16-3.181.37-3.081-2.38-7.683 4.88v-4.053l4.836-3.071-4.836-3.071v-4.053l7.683 4.88 3.08-2.38z'/%3e%3cpath d='m257.482 260.073 1.528 2.161-2.739 2.094 2.739 2.094-1.528 2.161-3.181.37-3.081-2.381-7.683 4.88v-4.053l4.836-3.07-4.836-3.072v-4.053l7.683 4.88 3.08-2.38zm0 36.666 1.528-2.16-2.739-2.095 2.739-2.094-1.528-2.16-3.181-.37-3.081 2.38-7.683-4.88v4.053l4.836 3.071-4.836 3.071v4.053l7.683-4.88 3.08 2.38zm-30.755-61.009v5.856h4.26v2.588h4.184v-4.713h-3.732v-3.731h-4.712zm12.556 9.235v5.855h4.255v2.589h4.189v-4.713h-3.732v-3.731h-4.712zm-88.014-9.235v5.856h-4.26v2.588h-4.184v-4.713h3.732v-3.731h4.712zm75.458 85.353v-5.856h4.26v-2.588h4.184v4.712h-3.732v3.732h-4.712zm-75.458 0v-5.856h-4.26v-2.588h-4.184v4.712h3.732v3.732h4.712zm88.014-9.235v-5.855h4.255v-2.589h4.189v4.712h-3.732v3.732h-4.712zm-100.569-66.883v5.855h-4.256v2.589h-4.188v-4.713h3.732v-3.731h4.712zm0 66.883v-5.855h-4.256v-2.589h-4.188v4.712h3.732v3.732h4.712zm66.039-76.254-3.25-3.156-3.194 2.959 2.783 2.701-3.592 3.488h5.334l1.919-1.863 1.92 1.863h5.333l-3.593-3.488 2.783-2.701-3.193-2.959c-1.085 1.05-2.167 2.104-3.25 3.156zm-15.755 0-3.25-3.156-3.193 2.959 2.783 2.701-3.593 3.488h5.334l1.919-1.863 1.92 1.863h5.333l-3.592-3.488 2.782-2.701-3.192-2.959c-1.085 1.05-2.167 2.104-3.251 3.156zm-15.754 0 3.25-3.156 3.194 2.959-2.783 2.701 3.592 3.488h-5.334l-1.919-1.863-1.92 1.863h-5.333l3.593-3.488-2.783-2.701 3.193-2.959c1.085 1.05 2.167 2.104 3.25 3.156zm31.509 85.625-3.25 3.155-3.194-2.958 2.783-2.701-3.592-3.488h5.334l1.919 1.863 1.92-1.863h5.333l-3.593 3.488 2.783 2.7-3.193 2.96c-1.085-1.051-2.167-2.104-3.25-3.156zm-15.755 0-3.25 3.155-3.193-2.958 2.783-2.701-3.593-3.488h5.334l1.919 1.863 1.92-1.863h5.333l-3.592 3.488 2.782 2.7-3.192 2.96c-1.085-1.051-2.167-2.104-3.251-3.156zm-15.754 0 3.25 3.155 3.194-2.958-2.783-2.701 3.592-3.488h-5.334l-1.919 1.863-1.92-1.863h-5.333l3.593 3.488-2.783 2.7 3.193 2.96c1.085-1.051 2.167-2.104 3.25-3.156z'/%3e%3cpath fill='%2328ae66' d='M134.029 281.713v3.037l-7.278-4.623-3.18 2.458-2.819-.327-1.178-1.668 2.856-2.184-2.856-2.184 1.179-1.667 2.817-.327 3.181 2.458 7.278-4.623v3.036l-5.206 3.307zm0-14.078v3.037l-7.278-4.623-3.18 2.458-2.819-.327-1.178-1.668 2.856-2.184-2.856-2.183 1.179-1.667 2.817-.328 3.181 2.458 7.278-4.623v3.037l-5.206 3.306zm0 21.543v-3.037l-7.278 4.623-3.18-2.458-2.819.327-1.178 1.668 2.856 2.184-2.856 2.184 1.179 1.667 2.817.327 3.181-2.458 7.278 4.623v-3.036l-5.206-3.307zm109.938-7.465v3.037l7.278-4.623 3.18 2.458 2.818-.327 1.179-1.668-2.856-2.184 2.856-2.184-1.179-1.667-2.818-.327-3.18 2.458-7.278-4.623v3.036l5.206 3.307zm0-14.078v3.037l7.278-4.623 3.18 2.458 2.818-.327 1.179-1.668-2.856-2.184 2.856-2.183-1.179-1.667-2.818-.328-3.18 2.458-7.278-4.623v3.037l5.206 3.306zm0 21.543v-3.037l7.278 4.623 3.18-2.458 2.818.327 1.179 1.668-2.856 2.184 2.856 2.184-1.179 1.667-2.818.327-3.18-2.458-7.278 4.623v-3.036l5.206-3.307zm-12.956-53.019v3.732h3.731v3.855h-3.326v-2.588h-4.26v-4.999h3.855zm12.555 9.234v3.731h3.731v3.856h-3.327v-2.588h-4.259v-4.999h3.855zm-96.581-9.234v3.732h-3.731v3.855h3.327v-2.588h4.259v-4.999h-3.855zm84.026 84.494v-3.731h3.731v-3.855h-3.326v2.587h-4.26v4.999h3.855zm-84.026 0v-3.731h-3.732v-3.855h3.327v2.587h4.26v4.999h-3.855zm96.581-9.234v-3.731h3.731v-3.855h-3.327v2.587h-4.259v4.999h3.855zM134.43 245.393v3.731h-3.731v3.856h3.327v-2.588h4.259v-4.999h-3.855zm.001 66.026v-3.731h-3.732v-3.855h3.327v2.587h4.26v4.999h-3.855zm67.065-78.39 3.257 3.162 3.257-3.162 2.564 2.375-2.776 2.694 3.151 3.06h-4.102l-2.094-2.033-2.094 2.033h-4.102l3.151-3.06-2.776-2.694 2.564-2.375zm-15.755 0 3.257 3.162 3.257-3.162 2.563 2.375-2.775 2.694 3.151 3.06h-4.103l-2.093-2.033-2.094 2.033h-4.102l3.15-3.06-2.775-2.694 2.564-2.375zm-9.239 0-3.257 3.162-3.257-3.162-2.564 2.375 2.776 2.694-3.151 3.06h4.102l2.094-2.033 2.094 2.033h4.102l-3.151-3.06 2.776-2.694-2.564-2.375zm24.994 90.755 3.257-3.163 3.257 3.163 2.564-2.375-2.776-2.694 3.151-3.06h-4.102l-2.094 2.032-2.094-2.032h-4.102l3.151 3.06-2.776 2.694 2.564 2.375zm-15.755 0 3.257-3.163 3.257 3.163 2.563-2.375-2.775-2.694 3.151-3.06h-4.103l-2.093 2.032-2.094-2.032h-4.102l3.15 3.06-2.775 2.694 2.564 2.375zm-9.239 0-3.257-3.163-3.257 3.163-2.564-2.375 2.776-2.694-3.151-3.06h4.102l2.094 2.032 2.094-2.032h4.102l-3.151 3.06 2.776 2.694-2.564 2.375z'/%3e%3cpath d='M146.58 306.421v9.234h84.836v-9.234h12.55v-56.03h-12.55v-9.233H146.58v9.234h-12.55v56.029z'/%3e%3cpath fill='%23ca3745' d='M147.034 241.578v9.217h-12.553v55.19h12.553v9.217h83.95v-9.217h12.555v-55.19h-12.554v-9.217h-83.951zm5.403 3.55h73.146v8.897l3.019 2.226h11.388v44.332h-11.44l-2.967 2.171v8.951h-73.146v-8.898l-3.02-2.224h-11.44v-44.332h11.388l3.072-2.226v-8.898z'/%3e%3cpath fill='%23ca3745' d='M152.86 245.551v8.158l11.017-8.158H152.86zm61.228 0 11.017 8.158v-8.158h-11.017zm-75.635 11.124v7.627l10.382-7.627h-10.381zm90.679 0 10.434 7.68v-7.68h-10.434zm10.434 35.75-10.434 7.734h10.434v-7.734zm-101.113.053v7.681h10.381l-10.381-7.681zm14.407 10.647v8.104h10.964l-10.964-8.104zm72.245 0-10.963 8.104h10.963v-8.104z'/%3e%3cpath fill='%2328ae66' d='m213.377 245.559 26.188 19.342v27.01l-26.188 19.342h-48.76l-26.187-19.342V264.9l26.187-19.342h48.76z'/%3e%3cpath d='m144.667 295.021-3.01-3.494 2.826-3.28-2.827-3.28 2.827-3.28-2.827-3.28 2.827-3.28-2.827-3.281 2.826-3.28-2.826-3.28 3.011-3.494h88.661l3.011 3.494-2.826 3.28 2.826 3.28-2.826 3.28 2.826 3.28-2.826 3.28 2.826 3.28-2.826 3.28 2.826 3.28-3.01 3.495zm60.946-45.236-3.495-3.011-3.28 2.826-3.28-2.826-3.28 2.826-3.28-2.826-3.28 2.826-3.281-2.826-3.28 2.826-3.28-2.826-3.494 3.01v57.244l3.494 3.011 3.28-2.827 3.28 2.826 3.28-2.826 3.28 2.826 3.28-2.826 3.28 2.826 3.28-2.826 3.281 2.827 3.495-3.011z'/%3e%3cg fill='%23faae29'%3e%3cpath d='m198.623 249.981-3.065-2.642-3.066 2.642v56.85l3.066 2.641 3.065-2.641zm-13.12 0-3.066-2.642-3.065 2.642v56.85l3.065 2.641 3.066-2.641z'/%3e%3cpath d='m144.863 294.593-2.641-3.066 2.641-3.066h88.269l2.641 3.066-2.641 3.066zm88.269-19.253 2.642 3.066-2.642 3.065h-88.268l-2.642-3.065 2.642-3.066zm0-6.988 2.641-3.066-2.641-3.065h-88.269l-2.641 3.065 2.641 3.066z'/%3e%3c/g%3e%3cg fill='%23ca3745'%3e%3cpath d='m205.184 249.981-3.065-2.642-3.066 2.642v56.85l3.066 2.641 3.064-2.64zm-26.241 0-3.066-2.642-3.066 2.642v56.85l3.066 2.641 3.066-2.641z'/%3e%3cpath d='m144.864 288.032-2.642-3.066 2.642-3.066h88.268l2.642 3.066-2.642 3.066zm0-13.12-2.642-3.066 2.642-3.066h88.268l2.642 3.066-2.642 3.066z'/%3e%3cpath d='m192.064 306.831-3.066 2.641-3.066-2.641v-56.85l3.066-2.642 3.066 2.642z'/%3e%3c/g%3e%3cpath d='M218.631 251.09h-59.48v4.724h-7.602v45.185h7.602v4.723h59.694v-4.723h7.602v-45.185h-7.602v-4.724h-.214z'/%3e%3cpath fill='%23ca3745' d='M159.587 251.535v4.715h-7.627v44.332h7.627v4.714h6.25l-12.447-10.434V261.97l12.447-10.434h-6.25zm52.596 0 12.393 10.434v32.893l-12.393 10.434h6.25v-4.714h7.574V256.25h-7.575v-4.715h-6.249z'/%3e%3cg fill='%2328ae66'%3e%3cpath d='m166.525 251.535-12.712 10.646v32.468c.15.127 12.594 10.547 12.712 10.646h44.968l12.659-10.646v-32.468l-12.659-10.646zm.636 1.8h43.644l11.546 9.694v30.773l-11.546 9.64H167.16l-11.494-9.64v-30.773z'/%3e%3cpath d='m178.72 294.289 1.954.844.359 2.282-2.46 2.164 3.573 3.454h-3.437l-2.458-2.366-2.458 2.366h-3.438l3.573-3.454-2.46-2.164.36-2.282 1.953-.844 2.47 1.975.134-.107zm12.748 0 1.953.844.36 2.282-2.46 2.164 3.573 3.454h-3.437l-2.459-2.366-2.457 2.366h-3.438l3.573-3.454-2.46-2.164.36-2.282 1.953-.844 2.47 1.975.133-.107zm7.809 0-1.953.844-.36 2.282 2.46 2.164-3.573 3.454h3.437l2.459-2.366 2.457 2.366h3.438l-3.573-3.454 2.46-2.164-.36-2.282-1.953-.844-2.47 1.975-.134-.107zm-20.557-31.766 1.954-.844.359-2.281-2.46-2.164 3.573-3.454h-3.437l-2.458 2.365-2.458-2.365h-3.438l3.573 3.454-2.46 2.163.36 2.282 1.953.844 2.47-1.974.134.107zm12.748 0 1.953-.844.36-2.281-2.46-2.164 3.573-3.454h-3.437l-2.459 2.365-2.457-2.365h-3.438l3.573 3.454-2.46 2.163.36 2.282 1.953.844 2.47-1.974.133.107zm7.809 0-1.953-.844-.36-2.281 2.46-2.164-3.573-3.454h3.437l2.459 2.365 2.457-2.365h3.438l-3.573 3.454 2.46 2.163-.36 2.282-1.953.844-2.47-1.974-.134.107zm22.624 3.644-1.95 1.615 1.95 1.614v2.676l-2.999-2.471-2.152 1.95-2.308-.29-.813-1.5 1.986-1.98-1.986-1.98.813-1.5c.192-.023 2.135-.268 2.308-.29l2.152 1.95 2.999-2.47v2.676zm0 10.625-1.95 1.615 1.95 1.613v2.677l-2.999-2.471-2.152 1.95c-.173-.022-2.116-.267-2.308-.29l-.813-1.5 1.986-1.98-1.986-1.98.813-1.5c.192-.023 2.135-.268 2.308-.29l2.152 1.95 2.999-2.47v2.676zm0 13.854-1.95-1.615 1.95-1.614v-2.676l-2.999 2.471-2.152-1.95-2.308.29-.813 1.5 1.986 1.98-1.986 1.98.813 1.5c.192.023 2.135.268 2.308.29l2.152-1.95 2.999 2.47v-2.676zm-65.804-24.479 1.95 1.615-1.95 1.614v2.676l2.999-2.471 2.152 1.95 2.308-.29.813-1.5-1.986-1.98 1.986-1.98-.813-1.5c-.192-.023-2.136-.268-2.308-.29l-2.152 1.95-2.999-2.47v2.676zm0 10.625 1.95 1.615-1.95 1.613v2.677l2.999-2.471 2.152 1.95c.172-.022 2.116-.267 2.308-.29l.813-1.5-1.986-1.98 1.986-1.98-.813-1.5c-.192-.023-2.136-.268-2.308-.29l-2.152 1.95-2.999-2.47v2.676zm0 13.854 1.95-1.615-1.95-1.614v-2.676l2.999 2.471 2.152-1.95 2.308.29.813 1.5-1.986 1.98 1.986 1.98-.813 1.5c-.192.023-2.136.268-2.308.29l-2.152-1.95-2.999 2.47v-2.676z'/%3e%3c/g%3e%3cpath fill='%23ca3745' d='M167.32 253.761c-.116.097-10.602 8.876-11.07 9.27.945.783 1.86 1.602 2.807 2.383.24-.217 2.066-1.855 2.066-1.855l2.701.371 1.06 1.96-1.907 1.907c.259.257 1.906 1.906 1.906 1.906l-1.059 1.96-2.701.318s-1.826-1.584-2.066-1.8l-2.966 2.488v.848c.998.826 1.965 1.664 2.966 2.49.24-.217 2.066-1.801 2.066-1.801l2.701.317 1.06 1.96-1.907 1.907c.259.257 1.906 1.907 1.906 1.907l-1.059 2.012-2.701.318s-1.826-1.636-2.066-1.854l-2.966 2.49v.9l2.966 2.49c.24-.217 2.066-1.854 2.066-1.854l2.701.37 1.06 1.96-1.907 1.907 1.906 1.907-1.059 1.96-2.701.37s-1.826-1.636-2.066-1.854c-.944.778-1.865 1.554-2.807 2.331l11.07 9.27h2.436l3.55-3.444-2.278-2.012.423-2.755 2.384-1.006 2.436 1.907 2.384-1.907 2.383 1.006.477 2.755-2.33 2.012 3.442 3.284 3.443-3.284-2.33-2.012.423-2.755 2.437-1.006 2.383 1.907 2.436-1.907 2.384 1.006.424 2.755-2.278 2.012 3.39 3.337 3.443-3.337-2.278-2.012.424-2.755 2.436-1.006 2.384 1.907 2.383-1.907 2.437 1.006.424 2.755-2.278 2.012 3.549 3.443h2.383l11.07-9.269c-.943-.777-1.862-1.551-2.807-2.33-.24.217-2.013 1.853-2.013 1.853l-2.701-.37-1.112-1.96 1.906-1.907-1.906-1.907 1.112-1.96 2.701-.37s1.773 1.637 2.013 1.854l2.966-2.49v-.9l-2.966-2.49c-.24.218-2.013 1.854-2.013 1.854l-2.701-.318-1.112-2.012 1.906-1.907-1.906-1.907 1.112-1.96 2.701-.317s1.773 1.584 2.013 1.8c.994-.819 1.974-1.62 2.966-2.436v-.953l-2.966-2.437c-.24.217-2.013 1.8-2.013 1.8l-2.701-.317-1.112-1.96 1.906-1.906-1.906-1.907 1.112-1.96 2.701-.37s1.773 1.637 2.013 1.853c.95-.782 1.911-1.548 2.86-2.33l-11.123-9.322h-2.383l-3.549 3.442 2.277 2.013-.423 2.754-2.437 1.06-2.383-1.907-2.384 1.907-2.436-1.06-.424-2.754 2.278-2.013-3.39-3.284-3.443 3.284 2.278 2.013-.424 2.754-2.384 1.06-2.436-1.907-2.383 1.907-2.437-1.06-.424-2.754 2.33-2.013-3.442-3.284-3.443 3.284 2.33 2.013-.476 2.754-2.383 1.06-2.384-1.907-2.436 1.907-2.384-1.06-.423-2.754 2.277-2.013-3.602-3.442zm-11.229 23.57v2.171l1.271-1.112z'/%3e%3cpath fill='%23fff' d='m176.271 301.271-1.854 1.747h3.654l-1.8-1.747zm12.712 0-1.8 1.747h3.654l-1.854-1.747zm12.764 0-1.853 1.747h3.707l-1.854-1.747zm-27.383-47.51 1.907 1.8 1.854-1.8h-3.761zm12.765 0 1.854 1.8 1.907-1.8h-3.761zm12.766 0 1.853 1.8 1.854-1.8h-3.707zm21.98 12.976-1.271 1.06 1.271 1.006v-2.066zm0 10.593-1.271 1.06 1.271 1.059v-2.119zm0 10.646-1.271 1.06 1.271 1.059v-2.119zm-65.784-21.291v2.171l1.271-1.06-1.271-1.111zm0 10.645v2.171l1.271-1.112-1.271-1.059zm0 10.594v2.171l1.271-1.06-1.271-1.111z'/%3e%3cpath d='M199.901 274.857v-3.791h-3.837v-4.157h-14.132v4.157h-3.837v3.791h-5.299v7.098h5.3v3.79h3.836v4.158h14.132v-4.157h3.837v-3.791h5.299v-7.098z'/%3e%3cpath fill='%23faae29' d='M188.783 267.338v4.285l-6.074 3.453v3.116h-9.485v-2.906h5.299v-3.791h3.837v-4.157zm.429 22.137v-4.285l6.074-3.453v-3.116h9.485v2.906h-5.299v3.791h-3.837v4.157z'/%3e%3cpath fill='%23fff' d='M195.286 278.192v-3.116l-6.074-3.453v-4.285h6.423v4.157h3.837v3.79h5.299v2.907zm-22.061.429h9.484v3.116l6.075 3.453v4.285h-6.423v-4.157h-3.837v-3.791h-5.299z'/%3e%3cpath fill='%23ca3745' d='M183.138 278.621v2.888l5.645 3.21v-6.098z'/%3e%3cpath fill='%2328ae66' d='m188.783 272.094-5.645 3.21v2.888h5.645z'/%3e%3cpath fill='%23ca3745' d='M194.858 278.192v-2.888l-5.645-3.21v6.098z'/%3e%3cpath fill='%2328ae66' d='m189.212 284.719 5.645-3.21v-2.888h-5.645z'/%3e%3cpath d='M137.647 353.73v11.717h-11.165v10.627h-11.317v30.259h11.317v10.627h11.165v11.717h40.598l7.14 4.29-3.432 2.06h-14.476l-1.248-1.408h13.119l-3.696-3.721h-18.767l8.503 8.851h17.598l6.011-3.612 6.012 3.612h17.599l8.502-8.851h-18.766l-3.696 3.721h13.12l-1.25 1.409h-14.477l-3.43-2.061 7.14-4.29h40.597V416.96h11.166v-10.627h11.316v-30.259h-11.316v-10.627h-11.166V353.73h-40.597l-7.14-4.29 3.43-2.061h14.477l1.25 1.408h-13.12l3.696 3.722h18.766l-8.502-8.852h-17.6l-6.01 3.612-6.012-3.612h-17.598l-8.503 8.852h18.767l3.696-3.722h-13.12l1.25-1.408h14.475l3.431 2.062-7.14 4.289z'/%3e%3cpath fill='%23ca3745' d='M199.629 428.23h40.307v-11.706h11.123v-10.646h11.335v-29.396h-11.335v-10.593h-11.123v-11.706H199.63l-16.737-10.116h-17.32l-7.68 7.998h17.584l2.86-2.86h-13.082l2.013-2.278h14.83l18.962 11.44h34.64v11.706h11.176v10.646h11.335v20.975h-11.335v10.646H235.7v11.706h-34.64l-18.962 11.387h-14.83l-2.013-2.224h13.083l-2.86-2.86h-17.585l7.68 7.998h17.32zm-22.722-4.184h-34.64V412.34h-11.123v-10.646h-11.335v-20.975h11.335v-10.646h11.123v-11.705h34.64l19.014-11.441H210.7l2.013 2.278h-13.03l2.86 2.86h17.585l-7.68-7.998h-17.32l-16.737 10.116h-40.307v11.706h-11.176v10.593h-11.335v29.396h11.335v10.647h11.176v11.705h40.307l16.737 10.117h17.32l7.68-7.998h-17.585l-2.86 2.86h13.03l-2.013 2.224h-14.777z'/%3e%3cpath fill='%23faae29' d='m188.983 351.59-11.97 7.203H142.69V370.5h-11.123v10.646h-11.335v20.127h11.335v10.646h11.123v11.706h34.322l11.97 7.15 11.97-7.15h34.322v-11.706h11.176v-10.646h11.335v-20.127H246.45V370.5h-11.176v-11.706h-34.322zm0 2.966 11.282 6.78h32.521v11.705h11.176v10.593h11.282v15.096h-11.282v10.646h-11.176v11.705h-32.521l-11.282 6.78-11.229-6.78h-32.521v-11.705h-11.176V398.73h-11.334v-15.096h11.334v-10.593h11.176v-11.705h32.521z'/%3e%3cpath fill='%2328ae66' d='M232.342 408.954v11.717h-32.2l-11.145 6.696-11.144-6.696h-32.2v-11.717h-11.166v-10.628h-11.316V384.08h11.316v-10.627h11.166v-11.717h32.2l11.144-6.696 11.145 6.696h32.2v11.717h11.165v10.627h11.316v14.246h-11.316v10.628z'/%3e%3cpath d='M149.869 404.849v11.34h17.7l-17.7-11.74zm0-27.291v-11.34h17.7l-17.7 11.739zm78.258 27.291v11.34h-17.7l17.7-11.74zm0-27.291v-11.34h-17.7l17.7 11.739z'/%3e%3cpath fill='%23ca3745' d='m150.298 405.248 15.85 10.513h-15.85zm0-28.089c.616-.41 14.77-9.797 15.85-10.513h-15.85v10.513zm77.4 28.089-15.85 10.513h15.85v-10.513zm0-28.089-15.85-10.513h15.85v10.513z'/%3e%3cg id='i'%3e%3cpath d='M172.445 388.094v-5.791h-1.975l-9.477-5.925-.113.071-9.362 5.854h-1.976v5.791h-4.455v6.22h4.455v5.79h1.976l9.475 5.925 9.477-5.925h1.975v-5.79h6.782v-6.22z'/%3e%3cpath fill='%23ca3745' d='m160.994 376.884 8.668 5.42h-17.335l8.667-5.42zm8.667 23.22-8.667 5.42-8.666-5.42h17.333zm-2.099-11.581v5.363h-10.809v-5.363z'/%3e%3cpath fill='%23faae29' d='M172.017 394.313v5.363h-10.809v-5.363zm-11.237 0v5.363h-10.809v-5.363zm18.019-5.79v5.363H167.99v-5.363zm-22.474 0v5.363h-10.809v-5.363zm15.692-5.791v5.362h-10.809v-5.362zm-11.237 0v5.362h-10.809v-5.362z'/%3e%3cpath d='M153.349 389.714v2.98h-4.855v-2.98zm4.455-5.791v2.98h-4.855v-2.98zm11.236 0v2.98h-4.855v-2.98zm-4.455 5.791v2.98h-4.855v-2.98zm11.237 0v2.98h-4.855v-2.98zm-6.782 5.791v2.98h-4.855v-2.98zm-11.236 0v2.98h-4.855v-2.98z'/%3e%3cpath fill='%23fff' d='M152.891 390.171h-3.94v2.065h3.94zm4.455-5.791h-3.94v2.065h3.94zm11.237 0h-3.94v2.065h3.94zm-4.455 5.791h-3.94v2.065h3.94zm11.237 0h-3.94v2.065h3.94zm-6.782 5.791h-3.94v2.065h3.94zm-11.237 0h-3.94v2.065h3.94z'/%3e%3c/g%3e%3cuse xlink:href='%23i' transform='matrix(-1 0 0 1 377.995 0)'/%3e%3cg id='j'%3e%3cpath d='M200.449 378.42v5.79h-1.975l-9.477 5.926-.113-.071-9.362-5.854h-1.976v-5.791h-5.618v-6.22h5.618v-5.79h1.976l9.475-5.926 9.477 5.926h1.975v5.79h5.618v6.22z'/%3e%3cpath fill='%23faae29' d='m188.998 389.63 8.668-5.42H180.33l8.667 5.42zm8.667-23.22-8.667-5.42-8.666 5.42h17.333z'/%3e%3cpath fill='%23ca3745' d='M200.021 372.2v-5.362h-10.809v5.362zm-11.237 0v-5.362h-10.809v5.362zm16.855 5.791v-5.363H194.83v5.363zm-11.237 0v-5.363h-10.809v5.363zm-11.237 0v-5.363h-10.808v5.363zm16.856 5.791v-5.363h-10.809v5.363zm-11.237 0v-5.363h-10.809v5.363z'/%3e%3cpath d='M185.807 368.029v2.98h-4.855v-2.98zm11.237 0v2.98h-4.855v-2.98zm-16.856 5.791v2.98h-4.855v-2.98zm11.238 0v2.98h-4.855v-2.98zm11.237 0v2.98h-4.855v-2.98zm-16.856 5.791v2.98h-4.855v-2.98zm11.237 0v2.98h-4.855v-2.98z'/%3e%3cpath fill='%23fff' d='M185.35 368.486h-3.94v2.065h3.94zm11.237 0h-3.94v2.065h3.94zm-16.856 5.791h-3.94v2.065h3.94zm11.238 0h-3.94v2.065h3.94zm11.236 0h-3.94v2.065h3.94zm-16.855 5.791h-3.94v2.065h3.94zm11.237 0h-3.94v2.065h3.94z'/%3e%3c/g%3e%3cuse xlink:href='%23j' y='31.788'/%3e%3cpath d='m127.676 479.354 42.052-22.631h38.539l42.051 22.631v37.29l-42.051 22.63h-38.54l-42.051-22.63z'/%3e%3cpath fill='%2328ae66' d='m169.863 457.151-41.738 22.458v36.757l41.738 22.458h38.293l41.74-22.458V479.61l-41.74-22.458h-38.293zm.74 3.019h36.812l39.514 21.239v33.21l-39.514 21.239h-36.834l-39.512-21.24v-33.21z'/%3e%3cpath fill='%23faae29' d='M189.212 497.784v37.64h18.095l39.183-21.087v-16.124h-57.706v-37.64h-18.095l-39.184 21.086v16.125z'/%3e%3cpath fill='%23fff' d='M188.783 497.784v37.64h-18.095l-39.183-21.087v-16.124h57.706v-37.64h18.096l39.183 21.086v16.125z'/%3e%3cpath d='M192.514 533.317v-10.88l-3.517 2.232-3.518-2.231v10.879h-10.942l7.383-5.414v-7.723l-11.26-7.144h-7.867v-30.073h7.868l11.26-7.144v-7.723l-7.384-5.414h10.942v10.88l3.518-2.232 3.517 2.232v-10.88h10.942l-7.383 5.414v7.723l11.26 7.144h7.867v30.073h-7.868l-11.26 7.144v7.723l7.384 5.414z'/%3e%3cpath fill='%23faae29' d='M192.956 463.135v11.229l-3.761-2.383v3.178l17.214 10.962h5.667v11.655h2.702v-14.407h-7.575l-11.545-7.31V467.9l6.513-4.766h-9.215zm-29.714 35.064v14.407h7.52l11.6 7.361v8.158l-6.514 4.766h9.216v-11.229l3.707 2.385v-3.285l-17.213-10.857h-5.615v-11.706h-2.701z'/%3e%3cpath fill='%23fff' d='m175.847 463.135 6.515 4.766v8.158l-11.6 7.31h-7.52v14.407h2.7V486.12h5.615l17.214-10.91v-3.23l-3.707 2.383v-11.229h-9.217zm36.229 35.064v11.705h-5.668l-17.214 10.858v3.285l3.761-2.385v11.229h9.216l-6.514-4.766v-8.158l11.546-7.36h7.574v-14.408h-2.701z'/%3e%3cpath fill='%23ca3745' d='M166.352 509.458h5.338l17.307 10.98 17.307-10.98h5.338v-22.916h-5.338l-17.307-10.981-17.307 10.98h-5.338z'/%3e%3cpath d='M200.977 503.445h3.695v-1.748h-2.78v-3.179h5.942v8.106h-5.696v5.53h-11.724v-7.946h5.16v3.178h-1.999v1.59h5.402v-3.039l-21.961-13.383h-3.695v1.748h2.78v3.178h-5.942v-8.104h5.696v-5.53h11.724v7.945h-5.16v-3.178h1.999v-1.589h-5.402v3.038zm-2-13.383v-3.038h-5.402v1.589h1.999v3.178h-5.16v-7.945h11.725v5.53h5.695v8.104h-5.941v-3.178h2.78v-1.748h-3.696l-21.96 13.383v3.038h5.4v-1.59h-1.998v-3.177h5.16v7.945h-11.724v-5.53h-5.696v-8.105h5.942v3.179h-2.78v1.748h3.695z'/%3e%3cpath fill='%23fff' d='M199.406 505.697v3.707h-6.26v-2.446h2v-2.321h-4.303v7.088h10.867v-5.53h5.696v-7.247h-5.085v2.32h2.78v2.606h-4.244l-22.27-13.571v-3.707h6.26v2.446h-1.999v2.321h4.303v-7.088h-10.867v5.53h-5.695v7.247h5.083v-2.321h-2.78v-2.605h4.244zm1.451-13.571h4.245v2.605h-2.78v2.321h5.084v-7.248h-5.695v-5.53h-10.868v7.089h4.303v-2.321h-1.999v-2.446h6.259v3.707l-22.27 13.57h-4.243v-2.605h2.78v-2.321h-5.084v7.248h5.695v5.53h10.867v-7.089h-4.303v2.322h1.999v2.445h-6.26v-3.707z'/%3e%3cpath d='M238.042 499.884v11.762h-5.005v-4.154h-5.046v4.154h-5.005v-11.762h5.005v4.154h5.046v-4.154zm-17.91 15.615v11.762h-5.005v-4.154h-5.046v4.154h-5.005v-11.762h5.005v4.154h5.046V515.5zm17.91-19.386v-11.762h-5.005v4.154h-5.046v-4.154h-5.005v11.762h5.005v-4.154h5.046v4.154zm-98.089 3.771v11.762h5.005v-4.154h5.046v4.154h5.005v-11.762h-5.005v4.154h-5.046v-4.154zm0-3.771v-11.762h5.005v4.154h5.046v-4.154h5.005v11.762h-5.005v-4.154h-5.046v4.154zm80.179-15.614v-11.762h-5.005v4.154h-5.046v-4.154h-5.005V480.5h5.005v-4.154h5.046v4.154zm-62.268 35v11.762h5.005v-4.154h5.046v4.154h5.005v-11.762h-5.005v4.154h-5.046V515.5zm0-35v-11.762h5.005v4.154h5.046v-4.154h5.005V480.5h-5.005v-4.154h-5.046v4.154zm65.254-8.243v8.932h16.597zm-68.241 51.486v-8.932H138.28zm0-51.486v8.932H138.28zm68.241 51.486v-8.932h16.597z'/%3e%3cpath fill='%23ca3745' d='M233.465 507.064v4.154h4.148v-10.905h-4.148v4.154h-5.903v-4.154h-4.148v10.905h4.148v-4.154zm-17.91 15.614v4.154h4.148v-10.905h-4.148v4.154h-5.903v-4.154h-4.148v10.905h4.148v-4.154zm17.91-33.744v-4.154h4.148v10.905h-4.148v-4.155h-5.903v4.155h-4.148V484.78h4.148v4.154zm-88.935 18.13v4.154h-4.148v-10.905h4.148v4.154h5.903v-4.154h4.148v10.905h-4.148v-4.154zm0-18.13v-4.154h-4.148v10.905h4.148v-4.155h5.903v4.155h4.148V484.78h-4.148v4.154zm71.025-15.614v-4.154h4.148v10.905h-4.148v-4.155h-5.903v4.155h-4.148v-10.905h4.148v4.154zm-53.115 49.358v4.154h-4.148v-10.905h4.148v4.154h5.903v-4.154h4.148v10.905h-4.148v-4.154zm0-49.358v-4.154h-4.148v10.905h4.148v-4.155h5.903v4.155h4.148v-10.905h-4.148v4.154z'/%3e%3cpath fill='%23faae29' d='M223.57 472.986v7.786h14.461l-14.461-7.786zm-83.58 42.268 14.46 7.786v-7.786h-14.46z'/%3e%3cpath fill='%23fff' d='m154.449 472.986-14.46 7.786h14.46v-7.786zm69.12 42.268v7.786l14.461-7.786h-14.46z'/%3e%3c/g%3e%3c/svg%3e";
            },
            8736: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-60 -40 120 80'%3e%3cg fill='%23E70013'%3e%3cpath d='M-60-40H60v80H-60z'/%3e%3ccircle r='20' fill='%23FFF'/%3e%3ccircle r='15'/%3e%3ccircle cx='4' r='12' fill='%23FFF'/%3e%3cpath d='m-5 0 16.281-5.29L1.22 8.56V-8.56L11.28 5.29z'/%3e%3c/g%3e%3c/svg%3e";
            },
            2439: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 96 48'%3e%3cg fill='%23C10000'%3e%3cpath d='M0 0h96v48H0z'/%3e%3cpath fill='%23fff' d='M0 0h40v24H0z'/%3e%3cpath d='M17 3h6v18h-6z'/%3e%3cpath d='M11 9h18v6H11z'/%3e%3c/g%3e%3c/svg%3e";
            },
            1900: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 800'%3e%3cpath fill='%23E30A17' d='M0 0h1200v800H0z'/%3e%3ccircle cx='425' cy='400' r='200' style='fill:%23fff'/%3e%3ccircle cx='475' cy='400' r='160' style='fill:%23e30a17'/%3e%3cpath d='m583.334 400 180.901 58.779-111.804-153.885v190.212l111.804-153.885z' style='fill:%23fff'/%3e%3c/svg%3e";
            },
            8627: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 18'%3e%3cpath fill='%23CE1126' d='M0 0h30v18H0z'/%3e%3cpath fill='%23FFF' d='m0 0 20.825 18H30L9.175 0z'/%3e%3cpath d='m1.53 0 20.824 18h6.117L7.646 0z'/%3e%3c/svg%3e";
            },
            6754: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 600'%3e%3cclipPath id='a'%3e%3cpath d='M0 0h650v350H0z'/%3e%3c/clipPath%3e%3cclipPath id='b'%3e%3cpath d='M0 0v150h650v150h-50zm0 300v50h300V0h300z'/%3e%3c/clipPath%3e%3cpath fill='%23012169' d='M0 0h1200v600H0z'/%3e%3cpath stroke='%23fff' stroke-width='60' d='m0 0 600 300m0-300L0 300' clip-path='url(%23a)'/%3e%3cpath stroke='%23c8102e' stroke-width='40' d='m0 0 600 300m0-300L0 300' clip-path='url(%23b)'/%3e%3cpath stroke='%23fff' stroke-width='100' d='M0 150h650M300 0v350'/%3e%3cpath stroke='%23c8102e' stroke-width='60' d='M0 150h650M300 0v350'/%3e%3cpath fill='%23009cde' d='M0 300h600V0h600v600H0z'/%3e%3cpath fill='%23fedd00' d='m645.34 490.913 29.436 90.597-77.066-55.992h95.26l-77.067 55.993zM817.462 464l-29.436 90.597L758.589 464l77.066 55.992h-95.26zm0-121.984-29.436 90.597-29.437-90.597 77.066 55.992-95.26.001zm126.005 91.152-29.437 90.597-29.436-90.597 77.066 55.992-95.26.001zm0-265.413-29.437 90.597-29.436-90.597 77.066 55.992H866.4zm52.975 172.21 29.436 90.597-77.066-55.992h95.26l-77.067 55.993zm52.923-208.404-29.437 90.597-29.437-90.597 77.067 55.992-95.26.001zm53.471 139.913 29.437 90.597-77.067-55.992h95.26l-77.067 55.993zm0-234.069 29.437 90.597-77.067-55.992h95.26l-77.067 55.993z'/%3e%3c/svg%3e";
            },
            8065: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-60 -40 240 160'%3e%3crect width='100%25' height='100%25' x='-60' y='-40' fill='%23fe0000'/%3e%3crect width='50%25' height='50%25' x='-60' y='-40' fill='%23000095'/%3e%3cpath id='a' fill='%23fff' d='M8 0 0 30-8 0l8-30M0 8l30-8L0-8l-30 8'/%3e%3cuse xlink:href='%23a' transform='rotate(30)'/%3e%3cuse xlink:href='%23a' transform='rotate(60)'/%3e%3ccircle r='17' fill='%23000095'/%3e%3ccircle r='15' fill='%23fff'/%3e%3c/svg%3e";
            },
            5454: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 72 48'%3e%3cpath fill='%231eb53a' d='M0 48V0h72z'/%3e%3cpath fill='%2300a3dd' d='M0 48h72V0z'/%3e%3cpath stroke='%23fcd116' stroke-width='19' d='M0 48 72 0'/%3e%3cpath stroke='%23000' stroke-width='13' d='M0 48 72 0'/%3e%3c/svg%3e";
            },
            8505: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 800'%3e%3cpath fill='%23005BBB' d='M0 0h1200v800H0z'/%3e%3cpath fill='%23FFD500' d='M0 400h1200v400H0z'/%3e%3c/svg%3e";
            },
            8855: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3cpath d='M0 0h900v600H0z'/%3e%3cpath fill='%23fcdc04' d='M0 100h900v100H0z'/%3e%3cpath fill='%23d90000' d='M0 200h900v100H0z'/%3e%3cpath fill='%23fcdc04' d='M0 400h900v100H0z'/%3e%3cpath fill='%23d90000' d='M0 500h900v100H0z'/%3e%3ccircle cx='450' cy='300' r='93.5' fill='%23fff'/%3e%3cg stroke='%23000'%3e%3cpath fill='%23d90000' d='m433.52 228.39-6.064-11.17c2.34-2.34 6.277-4.149 12.553-4.149 0 .426-.638 12.235-.638 12.235z'/%3e%3cpath fill='%23fcdc04' d='m439.371 225.412.851-12.34s12.554-.745 19.362 7.446c.107-.106-6.702 9.574-6.702 9.574z'/%3e%3cpath fill='%23d90000' d='m453.095 229.986 6.17-9.574c4.15 4.362 5.85 7.447 6.49 12.128.106.106-9.788 2.446-9.788 2.34 0-.107-2.765-4.788-2.872-4.894z'/%3e%3cpath d='M436.605 388.073s11.596-13.298 34.15-10.425c-3.405-5.533-14.362-4.894-14.362-4.894s-3.404-25.851-.745-27.128c2.66-1.277 13.936.106 13.936.106 1.489 0 4.043-4.042 2.022-6.595-2.022-2.554-7.98-12.341-5.533-14.256 2.448-1.915 15.745 1.064 15.745 1.064l-37.553-48.086s-3.83-18.085 3.83-26.809c9.256-7.66 8.298-15.957 7.979-15.851-1.277-8.404-14.043-14.469-22.66-6.702-5.107 6.17-1.703 10.851-1.703 10.851s-13.404 3.617-13.936 5.957c-.532 2.341 15.107-.425 15.107-.425l-1.49 10.745s-30.426 27.66-7.127 51.596c.212-.106.744-1.064.744-1.064s8.192 10.107 16.809 12.34c8.085 8.299 7.34 7.022 7.34 7.022s1.596 13.086.107 15.639c-2.021-.639-22.66-1.383-25.745-.213-2.766.851-13.404.319-10.745 17.66 2.021-4.681 3.83-8.83 3.83-8.83s-.32 6.276 2.234 8.51c-.425-6.596 2.447-11.063 2.447-11.063s.532 7.234 2.127 8.297c1.596 1.064 1.596-11.702 10.427-10.638 8.829 1.064 15.212.745 15.212.745s2.979 25 2.021 27.34c-6.383-1.489-21.595.64-22.553 4.469 8.936-.532 13.086.531 13.086.531s-7.234 6.384-5 10.107z'/%3e%3cpath fill='%239ca69c' stroke='%239ca69c' d='M440.191 251.66s-22.139 24.403-12.587 43.076c.508-2.604.286-4.24.606-4.134-.532-.32 2.745 2.247 2.496 1.747.07-1.35-.998-4.243-.998-4.243l2.995.749-1.748-3.245 4.244.499s-1.498-3.994-.998-3.994c.499 0 3.494.25 3.494.25-6.296-11.3-.356-20.683 2.496-30.705zm7.691-20.93s1.17 8.405-3.404 10.852c-.745.532-3.617 1.49-3.192 3.192.532 2.34 1.808 1.915 3.617 1.489 4.787-.851 10.32-11.064 2.979-15.532z'/%3e%3ccircle cx='438' cy='238' r='1.8' fill='%23fff' stroke='none'/%3e%3cpath fill='%23d90000' d='M432.563 244.986c-1.17.958-7.34 7.341-1.277 9.681 6.277-1.702 4.574-2.872 5.958-4.255.035-2.872-3.121-3.617-4.681-5.426z'/%3e%3cpath fill='%239ca69c' stroke='%239ca69c' d='M445.967 305.307c-.32 1.383-1.702 6.489.212 10.425 5.32-2.234 7.767-1.596 9.575-.426-4.36-3.51-6.063-5-9.787-10z'/%3e%3cpath fill='%23fff' stroke='%23fff' d='m455.116 329.455.32 11.915s4.148.745 6.063 0-.107-8.298-6.383-11.915z'/%3e%3cpath fill='%239ca69c' d='M485.223 330.945s-7.66-18.51-27.235-23.192c-19.575-4.681-17.022-25.532-15.426-26.809.852-1.809 1.49-4.574 7.128-1.914 5.639 2.66 31.596 15.744 35.32 16.382 3.723.639.532 35.959.213 35.533z'/%3e%3cpath fill='%23d90000' d='M466.606 307.647c-.32.212 26.17 15.637 18.191 28.936 7.554-5 5.107-13.723 5.107-13.723s6.17 16.064-8.83 23.936c1.596 1.384 2.66 1.064 2.66 1.064l-2.554 2.553s-1.17 1.915 8.937-2.98c-2.767 2.235-2.979 3.83-2.979 3.83s.744 2.129 7.34-3.616c-5.32 5.745-6.49 8.723-6.49 8.617 14.362-1.277 45.64-47.979-9.893-61.81 2.98 3.086 2.553 2.66 2.553 2.66z'/%3e%3cpath fill='%23fff' d='M467.776 303.072c3.617 2.553 4.893 3.404 5.319 4.681-3.298-.744-6.277-.532-6.277-.532s-7.127-6.808-8.404-7.34c-.958 0-6.49-3.511-6.49-3.511-2.765-1.383-5.318-10.957 4.895-8.192 10.53 5 12.02 5.426 12.02 5.426 4.185 1.312 8.369 2.625 12.554 3.936l7.234 8.086s-12.872-6.384-14.468-6.49c3.51 2.872 5.532 6.808 5.532 6.808-4.078-1.17-7.624-2.234-11.915-2.872z'/%3e%3cpath stroke='%23fff' d='M417.669 245.944s12.34-2.979 13.83-2.553'/%3e%3c/g%3e%3c/svg%3e";
            },
            7639: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 7410 3900'%3e%3cpath fill='%23b22234' d='M0 0h7410v3900H0z'/%3e%3cpath stroke='%23fff' stroke-width='300' d='M0 450h7410m0 600H0m0 600h7410m0 600H0m0 600h7410m0 600H0'/%3e%3cpath fill='%233c3b6e' d='M0 0h2964v2100H0z'/%3e%3cg fill='%23fff'%3e%3cg id='d'%3e%3cg id='c'%3e%3cg id='e'%3e%3cg id='b'%3e%3cpath id='a' d='m247 90 70.534 217.082-184.66-134.164h228.253L176.466 307.082z'/%3e%3cuse xlink:href='%23a' y='420'/%3e%3cuse xlink:href='%23a' y='840'/%3e%3cuse xlink:href='%23a' y='1260'/%3e%3c/g%3e%3cuse xlink:href='%23a' y='1680'/%3e%3c/g%3e%3cuse xlink:href='%23b' x='247' y='210'/%3e%3c/g%3e%3cuse xlink:href='%23c' x='494'/%3e%3c/g%3e%3cuse xlink:href='%23d' x='988'/%3e%3cuse xlink:href='%23c' x='1976'/%3e%3cuse xlink:href='%23e' x='2470'/%3e%3c/g%3e%3c/svg%3e";
            },
            3945: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 7410 3900'%3e%3cpath fill='%23b22234' d='M0 0h7410v3900H0z'/%3e%3cpath stroke='%23fff' stroke-width='300' d='M0 450h7410m0 600H0m0 600h7410m0 600H0m0 600h7410m0 600H0'/%3e%3cpath fill='%233c3b6e' d='M0 0h2964v2100H0z'/%3e%3cg fill='%23fff'%3e%3cg id='d'%3e%3cg id='c'%3e%3cg id='e'%3e%3cg id='b'%3e%3cpath id='a' d='m247 90 70.534 217.082-184.66-134.164h228.253L176.466 307.082z'/%3e%3cuse xlink:href='%23a' y='420'/%3e%3cuse xlink:href='%23a' y='840'/%3e%3cuse xlink:href='%23a' y='1260'/%3e%3c/g%3e%3cuse xlink:href='%23a' y='1680'/%3e%3c/g%3e%3cuse xlink:href='%23b' x='247' y='210'/%3e%3c/g%3e%3cuse xlink:href='%23c' x='494'/%3e%3c/g%3e%3cuse xlink:href='%23d' x='988'/%3e%3cuse xlink:href='%23c' x='1976'/%3e%3cuse xlink:href='%23e' x='2470'/%3e%3c/g%3e%3c/svg%3e";
            },
            603: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-5 -5 27 18'%3e%3cpath fill='%23fff' d='M-5-5h27v18H-5z'/%3e%3cpath fill='%230038a8' d='M5-3h17v2H5zm0 4h17v2H5zM-5 5h27v2H-5zm0 4h27v2H-5z'/%3e%3cg fill='%23fcd116' stroke='%23000' stroke-miterlimit='20' stroke-width='.6' transform='scale(.11)'%3e%3cg id='c'%3e%3cg id='b'%3e%3cg id='a'%3e%3cpath stroke-linecap='square' d='m-2.058 8.889 3.01 4.494c-12.367 8.949-4.817 14.24-13.58 17.105 5.45-5.32-.859-5.767 3.733-16.854'/%3e%3cpath fill='none' d='M-4.21 10.163c-6.822 11.245-2.348 17.428-8.419 20.325'/%3e%3cpath d='M0 0h6L0 33-6 0h6v33'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='rotate(45)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(90)'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='rotate(180)'/%3e%3ccircle r='11'/%3e%3c/g%3e%3cg transform='scale(.011)'%3e%3cg id='d'%3e%3cpath d='M81-44c-7 8-11-6-36-6S16-35 12-38s21-21 29-22 31 7 40 16m-29 9c7 6 1 19-6 19S26-28 32-36'/%3e%3cpath d='M19-26c1-12 11-14 27-14s23 12 29 15c-7 0-13-10-29-10s-16 0-27 10m3 2c4-6 9 6 20 6s17-3 24-8-10 12-21 12-26-6-23-10'/%3e%3cpath d='M56-17c13-7 5-17 0-19 2 2 10 12 0 19M0 43c6 0 8-2 16-2s27 11 38 7c-23 9-14 3-54 3h-5m63 6c-4-7-3-5-11-16 8 6 10 9 11 16M0 67c25 0 21-5 54-19-24 3-29 11-54 11h-5m5-29c7 0 9-5 17-5s19 3 24 7c1 1-3-8-11-9S25 9 16 7c0 4 3 3 4 9 0 5-9 5-11 0 2 8-4 8-9 8'/%3e%3c/g%3e%3cuse xlink:href='%23d' transform='scale(-1 1)'/%3e%3cpath d='M0 76c-5 0-18 3 0 3s5-3 0-3'/%3e%3c/g%3e%3c/svg%3e";
            },
            814: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 500 250'%3e%3cpath fill='%231eb53a' d='M0 0h500v250H0z'/%3e%3cpath fill='%230099b5' d='M0 0h500v125H0z'/%3e%3cpath fill='%23ce1126' d='M0 80h500v90H0z'/%3e%3cpath fill='%23fff' d='M0 85h500v80H0z'/%3e%3ccircle cx='70' cy='40' r='30' fill='%23fff'/%3e%3ccircle cx='80' cy='40' r='30' fill='%230099b5'/%3e%3cg fill='%23fff' transform='translate(136 64)'%3e%3cg id='e'%3e%3cg id='d'%3e%3cg id='c'%3e%3cg id='b'%3e%3cpath id='a' d='M0-6v6h3' transform='rotate(18 0 -6)'/%3e%3cuse xlink:href='%23a' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(72)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(-72)'/%3e%3cuse xlink:href='%23c' transform='rotate(144)'/%3e%3c/g%3e%3cuse xlink:href='%23d' y='-24'/%3e%3cuse xlink:href='%23d' y='-48'/%3e%3c/g%3e%3cuse xlink:href='%23e' x='24'/%3e%3cuse xlink:href='%23e' x='48'/%3e%3cuse xlink:href='%23d' x='-48'/%3e%3cuse xlink:href='%23d' x='-24'/%3e%3cuse xlink:href='%23d' x='-24' y='-24'/%3e%3c/g%3e%3c/svg%3e";
            },
            793: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 2500 2500'%3e%3cpath fill='%23fff' d='M0 0h2500v2500H0z'/%3e%3cpath fill='%23ffe000' d='M0 0h1250v2500H0z'/%3e%3cg stroke='%23000' stroke-linejoin='round' stroke-width='3.205'%3e%3cg fill='%23ce9d09' stroke-linecap='round'%3e%3cg id='a'%3e%3cpath fill='%23fff' d='m1781.07 990.292 16.106 3.841 25.663 4.17 11.76 1.292-2.076 49.916s-2.808 33.178-7.688 48.961c-3.618 11.701-15.781 33.18-15.781 33.18l-7.688 11.736-45.32-39.25s7.725-10.948 10.52-16.996c3.508-7.589 7.689-23.874 7.689-23.874l4.45-25.897 2.428-32.776zm-56.991 151.477 41.273 36.013s-8.345 7.428-13.353 9.711c-9.824 4.48-20.767 7.517-31.562 7.284-7.728-.167-15.32-2.973-22.35-6.186-15.722-7.184-33.032-14.73-43.168-28.732-3.587-4.954-5.003-11.57-4.89-17.685.128-6.933 6.281-19.832 6.281-19.832s2.391 8.636 5.133 12.023c4.513 5.572 11.118 9.302 17.597 12.375 4.848 2.299 10.144 4.022 15.5 4.336 6.951.407 14.163-.674 20.637-3.237 3.339-1.323 8.902-6.07 8.902-6.07z'/%3e%3cpath fill='%23fff' d='M1658.65 877.67s3.294 6.6 4.297 10.128c1.715 6.033 2.908 12.326 2.861 18.598-.047 6.287-1.468 12.539-3.147 18.598-2.516 9.08-6.32 17.783-10.3 26.323-2.525 5.416-6.055 10.324-8.584 15.737-4.08 8.729-6.994 17.956-10.587 26.896-2.999 7.46-6.864 14.61-9.156 22.318-3.044 10.238-4.562 20.891-6.009 31.474-1.244 9.103-2.228 18.28-2.289 27.468-.07 10.899.257 21.91 2.29 32.618 2.013 10.61 4.976 21.204 9.728 30.901 3.83 7.817 8.931 15.104 14.878 21.46 4.916 5.253 10.706 9.756 16.882 13.448 5.61 3.354 11.95 5.31 18.025 7.725 8.392 3.336 25.433 9.335 25.433 9.335s-23.527-11.592-31.727-21.352c-6.784-8.074-10.521-18.62-12.876-28.899-2.727-11.905-2.383-24.473-1.144-36.624 1.332-13.072 5.179-25.817 9.156-38.34 4.196-13.218 10.095-25.836 15.45-38.627 3.86-9.22 8.276-18.201 12.018-27.468 4.417-10.942 8.764-21.935 12.303-33.19 2.158-6.866 4.85-13.722 5.43-20.895.631-7.792-.383-15.742-2.17-23.353-2.503-10.663-5.598-21.65-11.836-30.652-3.754-5.419-8.898-10.153-14.77-13.151-5.732-2.927-12.543-5.401-18.857-4.154-2.11.417-5.299 3.678-5.299 3.678z'/%3e%3cpath fill='%23fff' d='M1711.59 945.594s4.454-17.99 5.208-27.187c.646-7.867.225-15.822-.607-23.672-.924-8.734-1.468-17.793-4.855-25.897-3.514-8.406-9.025-16.13-15.579-22.457-6.46-6.237-14.294-11.306-22.66-14.568-8.801-3.431-18.491-4.278-27.92-4.855-8.088-.495-16.24.191-24.279 1.214-4.644.59-9.323 1.33-13.757 2.832-4.115 1.393-11.735 5.665-11.735 5.665l29.943 48.962s9.373-5.518 14.567-6.88c5.494-1.439 11.326-1.545 16.995-1.213 5.757.337 11.726.894 16.995 3.237 6.707 2.983 12.49 7.984 17.547 13.304 6.102 6.42 11.549 13.787 14.96 21.961 3.166 7.59 3.581 16.072 4.72 24.217.248 1.769.457 5.337.457 5.337z'/%3e%3cpath d='M1717.05 906.676s-5.334-16.56-10.37-23.474c-5.85-8.031-13.365-15.391-22.255-19.828-9.428-4.704-30.994-6.216-30.994-6.216l11.414 21.128-19.966-.487-10.427-17.435-19.232 8.706-9.568-15.645 20.431-9.473-9.414-15.185 20.423-1.943 8.892 14.7s15.874.048 23.588 1.668c5.238 1.1 10.385 2.91 15.12 5.405 4.532 2.388 8.698 5.521 12.447 9.012 4.508 4.2 8.732 8.865 11.874 14.164 3.054 5.15 6.542 16.727 6.542 16.727z'/%3e%3cpath d='m1581.65 845.092 31.9 46.592m-17.97-54.736-15.032 8.789-14.307 10.872 30.902 47.21 13.734-10.586 14.12-8.183zm58.21 198.922 17.883-36.91 19.139 7.613 7.755-19.059-19.026-8.869 9.872-21.316-14.02-6.295-10.587 20.458-19.194-8.024-8.428 19.963 18.609 7.803-17.168 36.625zm143.13-11.04 18.209-.405v21.042l17.533.831-2.982 21.358-16.358-1.03s-2.698 12.575-5.121 18.496c-2.513 6.14-9.662 17.4-9.662 17.4l-19.423-4.856s7.026-11.049 9.711-16.995c2.405-5.326 5.665-16.59 5.665-16.59l-19.939-2.517 3.47-20.192 18.088 1.262z'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 3717.75 0)'/%3e%3cpath fill='%23fff' d='m1756.66 735.602-27.42 29.446 16.881 50.93 9.666 35.795-27.723 25.826 50.729 71.05-17.366 19.818c-1.817 2.329-2.455 5.662-2.144 8.6.286 2.693 1.582 5.464 3.577 7.296 4.56 4.187 11.328 5.133 17.31 6.724 21.066 5.602 42.928 8.102 64.665 9.728 4.668.35 14.042 0 14.042 0s9.358.35 14.043 0c21.737-1.626 43.6-4.126 64.664-9.728 5.983-1.59 12.751-2.537 17.31-6.724 1.996-1.832 3.292-4.603 3.578-7.296.311-2.938-.327-6.271-2.145-8.6l-16.301-35.876 51.819-55.52-19.776-17.835-.436-43.258 16.882-50.93-25.412-25.724-22.943-61.258s-4.801-17.08-8.87-24.893c-2.433-4.67-5.832-8.791-9.156-12.876-3.983-4.894-8.002-9.87-12.876-13.877-4.416-3.63-9.536-6.346-14.592-9.013-5.433-2.866-10.892-5.956-16.845-7.472-6.14-1.563-18.944-1.54-18.944-1.54s-12.787-.027-18.943 1.54c-5.953 1.515-11.412 4.606-16.845 7.472-5.056 2.667-10.176 5.382-14.592 9.013-4.875 4.007-8.893 8.983-12.876 13.877-3.324 4.085-6.723 8.205-9.156 12.876-4.07 7.812-8.87 24.893-8.87 24.893z'/%3e%3cpath d='M1963.27 933.128s-3.177-2.845-4.96-4a64.476 64.476 0 0 0-11.937-6.07c-5.607-2.147-11.553-3.288-17.4-4.653-6.697-1.563-13.414-3.14-20.232-4.046-7.973-1.06-16.033-1.538-24.076-1.619-8.607-.086-25.793 1.214-25.793 1.214s-17.17-1.3-25.794-1.214c-8.043.082-16.102.558-24.076 1.619-6.817.907-13.534 2.483-20.232 4.046-5.846 1.365-11.793 2.506-17.4 4.654a64.476 64.476 0 0 0-11.936 6.07c-1.783 1.154-4.96 3.999-4.96 3.999m218.71-42.693s-5.183-5.268-8.602-5.918c-2.21-.42-4.741.214-6.575 1.517-2.372 1.685-3.956 4.56-4.654 7.385-.624 2.528-.353 5.368.607 7.79.813 2.05 2.1 4.337 4.148 5.158 4.8 1.926 15.384-2.024 15.384-2.024zm5.156-3.592c5.801.17 7.914 3.108 9.454 6.475m-243.23-2.882-.307 13.907s10.583 3.95 15.383 2.024c2.048-.821 3.335-3.108 4.148-5.159.96-2.42 1.232-5.261.607-7.79-.698-2.824-2.282-5.699-4.654-7.384-1.833-1.303-4.368-1.95-6.575-1.517-3.445.676-8.602 5.919-8.602 5.919zm-5.156-3.593c-5.801.17-7.914 3.108-9.454 6.475m198.167 1.346-8.447-.946m-130.044.946 8.447-.946m75.992.814c-2.865-.422-7.6-4.21-7.6-4.21m-22.786 4.21c2.865-.422 7.6-4.21 7.6-4.21m140.936-19.346s-4.215 3.347-7.285 3.858l-1.211.644s-1.947 5.728-3.662 8.174c-1.719 2.451-6.465 6.25-6.465 6.25s-4.787-4.144-7.744-4.951c-1.94-.53-4.163-.544-6.025.215-1.976.804-3.548 2.535-4.737 4.306-1.403 2.093-2.706 4.583-2.588 7.1.141 3.014 3.877 8.184 3.877 8.184l-2.578 4.511-3.662 2.373c-6.314-1.913-12.63-3.935-18.945-7.539-1.732-1.888-3.358-4.302-4.522-9.033 0 0 4.544-2.693 5.596-4.951 1.182-2.538 1.668-6.006.215-8.399-1.616-2.66-5.276-4.042-8.389-4.091-2.28-.037-4.689 1.14-6.25 2.802-1.679 1.788-2.975 4.465-2.578 6.885.404 2.466 4.736 5.81 4.736 5.81s-1.8 4.559-3.838 5.43c-6.011 2.572-9.978 4.04-15.244 4.854-5.21.804-11.072 1.465-16.298-.02-3.376-.958-6.845-2.73-8.965-5.527-.631-.833-.86-3.008-.86-3.008s6.467-1.679 9.043-3.662c2.56-1.97 5.283-4.568 5.81-7.754.532-3.2-1.17-6.59-3.017-9.258-1.83-2.644-4.582-4.738-7.53-6.025-1.329-.58-4.306-.645-4.306-.645s-.63.571-.937.86c-1.244 1.598-2.954 2.862-4.766 3.808-.032.019-.076.051-.107.069-.044.024-.129.044-.176.068-.38.19-.75.41-1.133.567-.2.081-.51.093-.742.156-1.27.429-2.47.781-2.47.781s3.863 1.196 4.95 2.735c.672.95.963 2.109 1.084 3.31.149.713.235 1.434.206 2.129-.047 1.11-.323 2.233-.704 3.33-.348 1.278-.839 2.507-1.67 3.496-.45.537-1.003.985-1.591 1.387-.028.023-.05.056-.078.078-.03.023-.086.036-.118.059a12.406 12.406 0 0 1-3.378 1.494c-1.372.382-4.186.08-4.288.068.104 0 5.51-.01 7.666-1.562.067-.043.13-.092.196-.137 1.51-1.205 2.6-2.976 3.261-4.883.21-.766.415-1.543.489-2.314a16.43 16.43 0 0 0 .01-3.145c-.33-1.584-1.061-3.123-2.217-4.15-2.417-2.148-9.324-2.409-9.414-2.412-.107.004-6.99.267-9.404 2.412-1.156 1.027-1.887 2.566-2.217 4.15a16.272 16.272 0 0 0 .01 3.145c.073.77.279 1.548.488 2.314.662 1.907 1.752 3.678 3.262 4.883.065.045.128.094.195.137 2.156 1.553 7.562 1.562 7.666 1.562-.101.011-2.916.314-4.287-.068a12.406 12.406 0 0 1-3.379-1.494c-.031-.023-.087-.036-.117-.059-.03-.022-.05-.055-.078-.078-.588-.402-1.14-.85-1.592-1.387-.83-.989-1.321-2.218-1.67-3.496-.38-1.097-.656-2.22-.703-3.33-.029-.695.057-1.416.205-2.129.121-1.201.422-2.36 1.094-3.31 1.088-1.539 4.941-2.735 4.941-2.735s-1.2-.352-2.47-.781c-.23-.063-.535-.076-.733-.156-.389-.159-.768-.384-1.152-.576-.042-.022-.117-.037-.156-.06-.026-.014-.062-.043-.088-.058-1.822-.947-3.546-2.213-4.795-3.818-.309-.289-.938-.86-.938-.86s-2.967.064-4.297.645c-2.947 1.287-5.709 3.38-7.539 6.026-1.847 2.668-3.548 6.056-3.017 9.257.528 3.186 3.261 5.785 5.82 7.754 2.576 1.983 9.033 3.662 9.033 3.662s-.228 2.176-.86 3.008c-2.12 2.797-5.588 4.569-8.964 5.527-5.227 1.485-11.089.824-16.299.02-5.266-.813-9.233-2.281-15.244-4.854-2.038-.871-3.838-5.43-3.838-5.43s4.332-3.344 4.736-5.81c.397-2.42-.899-5.097-2.578-6.885-1.561-1.662-3.96-2.839-6.24-2.802-3.113.05-6.782 1.431-8.398 4.092-1.454 2.392-.968 5.86.214 8.398 1.053 2.258 5.596 4.951 5.596 4.951-1.163 4.731-2.79 7.146-4.521 9.033-6.315 3.604-12.631 5.626-18.946 7.54l-3.652-2.374-2.588-4.511s3.736-5.17 3.877-8.184c.118-2.517-1.184-5.007-2.588-7.1-1.188-1.771-2.76-3.502-4.736-4.306-1.862-.759-4.086-.744-6.026-.215-2.957.807-7.744 4.951-7.744 4.951s-4.746-3.798-6.465-6.25c-1.714-2.446-3.652-8.174-3.652-8.174l-1.21-.644c-3.071-.505-7.296-3.858-7.296-3.858l-4.443.938s-4.102 2.195-4.15 4.15c-.068 2.7 3.725 3.919 5.439 6.006a75.74 75.74 0 0 1 4.14 5.586c1.226 1.808 2.843 3.475 3.438 5.576.65 2.294-.974 4.972 0 7.149 1.228 2.743 3.773 5.415 6.719 6.015 2.615.533 7.588-2.578 7.588-2.578l-.147 19.883 10.303 9.307 9.727 20.312-3.858 5.147 1.143 10c7.48-9.585 20.501-13.792 32.187-17.149 15.732-4.52 44.57-4.841 58.008-4.717 4.48.042 7.256.137 7.256.137s44.295-1.442 65.254 4.58c11.685 3.358 24.706 7.564 32.187 17.149l1.143-10-3.858-5.147 9.727-20.312 10.303-9.307-.147-19.883s4.973 3.111 7.588 2.578c2.946-.6 5.491-3.272 6.719-6.015.974-2.177-.65-4.855 0-7.149.595-2.101 2.212-3.768 3.437-5.576a75.867 75.867 0 0 1 4.15-5.586c1.715-2.087 5.497-3.306 5.43-6.006-.049-1.955-4.15-4.15-4.15-4.15l-4.443-.938zm-148.33-2.607c1.049.982 3.103 2.847 4.795 3.818.08.042.163.077.244.117.505.265 1.202.502 1.885.733 2.913.792 7.935.267 8.047.254h.03c.111.012 5.133.536 8.047-.254.676-.229 1.37-.461 1.875-.723.094-.047.19-.088.283-.137 1.692-.976 3.72-2.83 4.766-3.808.522-.671.965-1.392 1.298-2.158 1.156-2.661 1.102-6.112-.205-8.702-1.537-3.046-5.175-4.496-8.086-6.279-2.506-1.535-7.912-3.725-7.998-3.76-.1.04-5.475 2.227-7.978 3.76-2.91 1.783-6.558 3.233-8.096 6.28-1.307 2.59-1.36 6.04-.205 8.7a10.03 10.03 0 0 0 1.299 2.159z'/%3e%3cpath d='M1980.77 829.789s-10.886-5.061-16.59-6.879c-10.413-3.319-21.236-5.216-31.967-7.283-12.467-2.403-25.26-3.052-37.622-5.944-3.892-.91-7.53-2.769-11.445-3.576-5.4-1.114-11.061-2.874-16.452-1.717-2.968.637-7.82 4.578-7.82 4.578s-4.867-3.94-7.82-4.578c-5.389-1.165-11.051.603-16.451 1.717-3.915.807-7.554 2.666-11.445 3.576-12.363 2.892-25.156 3.541-37.622 5.944-10.732 2.067-21.555 3.964-31.967 7.283-5.704 1.818-16.59 6.879-16.59 6.879m197.456-45.121s5.35-2.824 7.286-5.059c1.283-1.482 2.506-3.297 2.636-5.254.151-2.277-.62-4.853-2.226-6.474-1.561-1.577-4.061-2.219-6.28-2.227-1.855-.006-3.842.613-5.254 1.817-1.63 1.39-2.78 3.537-3.037 5.664-.218 1.814.51 3.698 1.368 5.312 1.3 2.447 5.507 6.22 5.507 6.22zm-151.123 0s4.208-3.774 5.508-6.22c.858-1.615 1.586-3.499 1.367-5.313-.256-2.127-1.407-4.274-3.037-5.664-1.412-1.204-3.398-1.823-5.254-1.817-2.218.008-4.708.65-6.27 2.227-1.605 1.621-2.377 4.197-2.226 6.474.13 1.957 1.344 3.772 2.627 5.254 1.935 2.235 7.285 5.059 7.285 5.059zm-41.074 18.008-11.933 15.576s-.084 4.109.81 5.87c1.231 2.423 5.86 5.663 5.86 5.663l.85 21.387-11.31 19.6-.986.205 7.295 3.857c.342.056.68.112.986.088 4.378-.342 7.07-5.258 10.88-7.442 4.848-2.779 10.01-4.988 15.165-7.148 7.125-2.986 14.36-5.733 21.739-8.018 9.303-2.88 18.69-5.76 28.33-7.148a141.79 141.79 0 0 1 22.1-1.445c2.462.033 4.92.127 7.372.293 6.57.444 19.37 3.404 19.473 3.427.086-.02 12.91-2.982 19.482-3.427 9.809-.664 19.742-.25 29.473 1.152 9.64 1.389 19.027 4.269 28.33 7.148 7.38 2.285 14.614 5.032 21.738 8.018 5.155 2.16 10.317 4.37 15.166 7.148 3.81 2.184 6.501 7.1 10.88 7.442.308.024.65-.03.995-.088l7.286-3.857-.987-.206-11.308-19.6.85-21.386s4.637-3.24 5.868-5.664c.895-1.76.801-5.87.801-5.87l-11.933-15.575s-6.016 6.007-9.913 7.285c-2.05.672-4.413.64-6.474 0-2.501-.777-4.435-2.811-6.475-4.453-4.609-3.71-9.225-7.541-12.949-12.139-2.133-2.633-5.264-8.701-5.264-8.701s-12.907 10.142-20.634 12.139c-7.577 1.958-15.96 1.605-23.467-.606-1.884-.555-5.03-3.066-5.03-3.066-8.826-5.622-17.651-8.698-26.425-7.852-8.774-.846-17.6 2.23-26.426 7.852 0 0-3.155 2.511-5.04 3.066-7.506 2.211-15.89 2.564-23.466.606-7.727-1.998-20.635-12.14-20.635-12.14s-3.13 6.069-5.263 8.702c-3.724 4.598-8.34 8.43-12.95 12.139-2.04 1.642-3.973 3.676-6.474 4.453-2.061.64-4.424.672-6.475 0-3.896-1.278-9.912-7.285-9.912-7.285z'/%3e%3cpath d='M1985.89 796.364s.448-5.703-.162-8.455c-.558-2.52-1.694-4.94-3.136-7.081-1.513-2.247-5.647-5.842-5.647-5.842m-1.434 27.69s3.394.123 4.853-.605c2.603-1.3 6.074-6.27 6.074-6.27s6.662 4.608 10.313 4.043c1.8-.278 3.294-1.885 4.248-3.437 1.01-1.646 1.651-3.782 1.22-5.664-.343-1.5-1.657-2.65-2.831-3.643-2.282-1.929-6.396-1.662-7.891-4.248-1.182-2.044-.457-4.81.195-7.08 1.36-4.736 4.751-8.648 7.49-12.744 1.74-2.601 5.294-4.383 5.665-7.49.2-1.68-2.022-4.659-2.022-4.659s-5.222-.118-7.686.616c-4.077 1.213-8.307 2.995-11.2 6.113-2.406 2.592-3.121 6.365-4.386 9.668-.96 2.51-2.421 7.685-2.421 7.685s-6.042-.013-8.702 1.211c-3.515 1.618-7.11 4.158-8.7 7.686-1.248 2.767-1.074 6.272 0 9.111 1.08 2.86 3.492 5.236 6.073 6.875 2.847 1.808 9.708 2.832 9.708 2.832zm-234.71-27.69s-4.135 3.595-5.648 5.842c-1.442 2.141-2.577 4.56-3.136 7.081-.61 2.752-.162 8.455-.162 8.455m-16.936-45.485s-2.222 2.98-2.021 4.659c.37 3.107 3.924 4.889 5.664 7.49 2.739 4.096 6.13 8.008 7.49 12.744.652 2.27 1.377 5.036.195 7.08-1.495 2.586-5.61 2.32-7.89 4.248-1.175.993-2.49 2.144-2.832 3.643-.431 1.882.21 4.018 1.22 5.664.954 1.553 2.448 3.159 4.248 3.437 3.651.565 10.313-4.043 10.313-4.043s3.471 4.97 6.074 6.27c1.46.728 4.854.605 4.854.605s6.87-1.024 9.716-2.832c2.582-1.64 4.983-4.014 6.065-6.875 1.073-2.838 1.247-6.344 0-9.111-1.59-3.528-5.186-6.068-8.701-7.686-2.66-1.224-8.702-1.21-8.702-1.21s-1.46-5.176-2.421-7.686c-1.265-3.303-1.98-7.076-4.385-9.668-2.894-3.118-7.124-4.9-11.201-6.113-2.464-.734-7.686-.616-7.686-.616zm135.626 14.318 8.325-2.438 8.324 2.438m-14.492 20.082s-6.481-5.91-7.689-9.914c-.527-1.748-.45-3.849.405-5.463 1.168-2.205 5.867-4.653 5.867-4.653s-7.085-3.443-8.902-6.677c-1.029-1.83-1.158-4.245-.607-6.271.874-3.216 3.3-5.97 5.868-8.093 3.185-2.633 11.226-5.26 11.226-5.26s8.026 2.62 11.226 5.26c2.57 2.12 4.993 4.877 5.867 8.093.551 2.026.422 4.44-.607 6.271-1.817 3.234-8.902 6.677-8.902 6.677s4.699 2.448 5.867 4.653c.855 1.614.932 3.715.405 5.463-1.207 4.004-7.688 9.914-7.688 9.914l-6.168.405zm22.672-26.888s13.436 5.727 17.989 11.107c1.27 1.5 2.352 3.5 2.225 5.462-.448 6.962-10.318 18.21-10.318 18.21l-19.928-8.283h-12.944l-19.928 8.282s-9.87-11.247-10.319-18.209c-.126-1.962.956-3.961 2.226-5.462 4.552-5.38 17.989-11.107 17.989-11.107'/%3e%3cpath d='m1844.36 669.248 8.056-6.2 6.507.14-6.656-.144s-3.591-2.447-4.578-4.292c-.958-1.79-1.415-4.02-1.002-6.008.553-2.655 2.086-5.459 4.428-6.825 2.237-1.305 7.755-.471 7.755-.471s5.503-.842 7.755.471c2.343 1.366 3.876 4.17 4.428 6.825.414 1.988-.043 4.218-1.001 6.008-.987 1.845-4.578 4.292-4.578 4.292l-6.656.143 6.506-.14 8.057 6.201m52.584 5.068-2.68 4.655m32.633-20.004-7.515.982m8.513 8.804-11.517.604m-1.498-13.748c1.468.937 4.155 2.86 4.595 4.635.776 3.13-.675 7.07-3.14 9.149-2.388 2.014-9.251 1.501-9.251 1.501m-181.69 33.587s11.294-2.82 16.954-4.177c8.081-1.939 16.1-4.196 24.279-5.665 9.262-1.664 18.62-2.885 28.007-3.554 11.71-.836 35.215-.573 35.215-.573s23.488-.264 35.216.573c9.387.67 18.745 1.89 28.007 3.554 8.18 1.469 16.198 3.726 24.279 5.665 5.66 1.357 16.954 4.177 16.954 4.177m-171.55-30.165 2.68 4.655m-32.634-20.004 7.515.982m-8.513 8.804 11.517.604m-6.475 16.076s12.542-3.187 18.875-4.506c6.924-1.442 13.873-2.82 20.887-3.72 8.068-1.035 16.2-1.555 24.325-1.928 9.63-.443 28.917-.367 28.917-.367s19.27-.076 28.917.367c8.125.373 16.257.893 24.325 1.928 7.014.9 13.964 2.278 20.887 3.72 6.333 1.319 18.875 4.506 18.875 4.506m-170.239-14.539s-6.863.513-9.252-1.501c-2.465-2.079-3.915-6.02-3.139-9.149.611-2.464 5.55-5.213 5.55-5.213m63.138 74.002c-11.977.723-24.01 1.474-35.81 3.642-12.293 2.258-24.486 5.397-36.216 9.711-11.113 4.088-22.869 22.644-32.096 15.223-1.983-1.595.753-5.084 1.717-7.44 1.866-4.556 4.43-8.932 7.726-12.59 2.413-2.677 7.975-3.026 8.583-6.58.442-2.581-3.474-4.093-4.292-6.58-1.043-3.177-1.538-6.814-.572-10.015 1.24-4.109 6.526-6.18 7.726-10.3 1.043-3.583-2.548-7.833-.859-11.16 2.133-4.2 11.337-2.777 12.017-7.439.332-2.273-3.825-2.98-4.578-5.15-.532-1.535.31-3.24.287-4.864-.031-2.202.392-4.602-.573-6.581-.857-1.76-3.702-2.14-4.292-4.006-.558-1.766-.171-4.134 1.145-5.436 1.037-1.027 3.632.442 4.292-.859 1.332-2.626-2.539-5.314-3.72-8.011-1.406-3.213-3.207-6.314-4.006-9.729-.63-2.7-2.958-6.886-.572-8.297 2.733-1.616 5.477 3.239 8.012 5.15 3.345 2.523 7.11 4.817 9.442 8.298 1.683 2.511.743 6.509 2.948 8.577 2.647 2.481 7.758.491 10.5 2.868 2.356 2.042 4.441 5.55 3.72 8.584-.69 2.898-7.532 2.817-6.868 5.722.79 3.45 6.814 3.18 10.3 2.575 2.034-.352 3.463-2.247 5.151-3.433 1.311-.922 2.39-2.233 3.863-2.862 1.69-.721 5.436-.93 5.436-.93l-2.146-.5s-3.171-2.528-3.505-4.364c-.314-1.728.437-3.731 1.645-5.007 1.356-1.43 3.538-2.16 5.508-2.146 1.647.012 3.446.664 4.578 1.86 1.161 1.227 1.825 3.113 1.646 4.793-.157 1.467-1.128 2.88-2.29 3.79-1.257.988-4.577 1.431-4.577 1.431l2.289.644 6.151 8.44 26.539-1.453s3.273-3.34 2.63-5.16c-.689-1.95-2.503-2.667-5.665-2.528-8.581.376-10.34-6.829-10.015-12.038.27-4.334 5.484-7.275 9.51-8.903 3.876-1.567 10.787 3.593 12.543-.202 1.54-3.326-5.818-5.02-6.98-8.497-.503-1.505-.508-3.336.202-4.755 1.813-3.622 5.714-6.03 9.408-7.688 1.557-.7 5.056-.81 5.056-.81s3.482.105 5.055.81c3.696 1.655 7.595 4.066 9.408 7.688.71 1.419.705 3.25.202 4.755-1.162 3.476-8.52 5.17-6.98 8.497 1.757 3.795 8.667-1.365 12.544.202 4.025 1.628 9.24 4.569 9.51 8.903.324 5.21-1.435 12.414-10.016 12.038-3.162-.14-4.976.579-5.665 2.529-.643 1.82 2.63 5.159 2.63 5.159l26.54 1.454 6.15-8.44 2.29-.645s-3.32-.443-4.578-1.43c-1.162-.911-2.133-2.324-2.29-3.791-.178-1.68.485-3.566 1.646-4.793 1.132-1.196 2.93-1.848 4.578-1.86 1.97-.014 4.153.716 5.508 2.146 1.208 1.276 1.959 3.279 1.645 5.007-.333 1.836-3.505 4.364-3.505 4.364l-2.146.5s3.746.209 5.436.93c1.474.63 2.552 1.94 3.863 2.862 1.688 1.186 3.117 3.081 5.15 3.433 3.488.604 9.512.875 10.301-2.575.664-2.905-6.177-2.824-6.867-5.722-.722-3.034 1.363-6.542 3.72-8.584 2.74-2.377 7.852-.387 10.5-2.868 2.205-2.068 1.264-6.066 2.947-8.577 2.333-3.48 6.097-5.775 9.443-8.298 2.534-1.911 5.279-6.766 8.011-5.15 2.386 1.411.06 5.598-.572 8.297-.799 3.415-2.6 6.516-4.006 9.729-1.18 2.697-5.051 5.385-3.72 8.011.66 1.301 3.256-.168 4.292.859 1.316 1.302 1.703 3.67 1.145 5.436-.59 1.866-3.435 2.246-4.292 4.006-.964 1.98-.541 4.379-.572 6.58-.023 1.625.818 3.33.286 4.865-.753 2.17-4.91 2.877-4.578 5.15.68 4.662 9.884 3.239 12.017 7.44 1.69 3.326-1.901 7.576-.858 11.158 1.2 4.12 6.485 6.192 7.725 10.3.967 3.202.472 6.839-.572 10.015-.818 2.488-4.734 4-4.292 6.581.608 3.554 6.17 3.903 8.584 6.58 3.296 3.658 5.86 8.034 7.725 12.59.964 2.356 3.7 5.845 1.717 7.44-9.227 7.42-20.983-11.135-32.096-15.223-11.73-4.314-23.922-7.453-36.215-9.711-11.801-2.168-23.834-2.918-35.81-3.642-6.969-.42-20.938-.404-20.938-.404s-13.953-.018-20.938.404zm31.128-133.632-10.184.117-10.183-.117m16.931-33.88c2.642-5.6-1.975-9.75-6.748-13.857-4.772 4.107-9.39 8.256-6.747 13.857m14.066 46.73c3.894.287 8.632 4.268 11.588 1.717 1.336-1.153.675-3.663 0-5.293-1.574-3.801-8.413-4.625-8.727-8.727-.27-3.538 5.191-5.212 6.295-8.584.549-1.677.68-3.666 0-5.293-2.751-6.578-14.493-6.952-16.527-13.68-.901-2.982 5.932-6.494 6.8-6.87 4.34-1.879 9.703 2.659 13.988.8 2.899-1.259 6.125-4.124 6.07-7.284-.06-3.438-3.726-6.317-6.88-7.688-6.108-2.657-16.22 5.904-19.978.404-3.459-5.061 8.643-11.08 7.03-16.995-.767-2.81-6.978-5.26-6.978-5.26s-6.202 2.438-6.977 5.26c-1.624 5.912 10.488 11.934 7.03 16.995-3.758 5.5-13.87-3.061-19.979-.404-3.153 1.371-6.818 4.25-6.878 7.688-.056 3.16 3.17 6.025 6.07 7.283 4.283 1.86 9.648-2.678 13.987-.799.867.376 7.7 3.888 6.8 6.87-2.034 6.729-13.776 7.102-16.527 13.68-.681 1.627-.55 3.616 0 5.293 1.104 3.372 6.565 5.046 6.294 8.584-.313 4.102-7.152 4.926-8.726 8.727-.676 1.63-1.336 4.14 0 5.293 2.956 2.55 7.693-1.43 11.588-1.717 2.433-.18 7.318 0 7.318 0s4.869-.18 7.319 0z'/%3e%3cpath fill='none' d='M1953.74 953.499s-7.154-3.02-10.804-4.34c-6.597-2.388-13.259-4.632-20.03-6.474-6.599-1.796-13.232-3.69-20.03-4.451-14.575-1.634-44.001-.203-44.001-.203s-29.409-1.433-44.002.203c-6.797.761-13.43 2.655-20.03 4.45-6.77 1.843-13.432 4.087-20.03 6.475-3.65 1.32-10.804 4.34-10.804 4.34m201.9-222.5s-11.953-4.756-18.026-6.867c-5.1-1.773-10.206-3.582-15.451-4.864-6.397-1.565-12.932-2.538-19.457-3.434a376.605 376.605 0 0 0-28.307-2.784c-8.584-.523-25.793-.607-25.793-.607s-17.192.083-25.793.607a376.49 376.49 0 0 0-28.307 2.784c-6.525.896-13.06 1.87-19.457 3.434-5.245 1.282-10.35 3.091-15.45 4.864-6.074 2.11-18.026 6.867-18.026 6.867m-14.157 120.41s17.56-5.918 26.405-8.671c9.129-2.84 18.174-6.063 27.516-8.093 11.184-2.43 22.61-3.63 33.99-4.856 11.058-1.191 33.279-2.427 33.279-2.427s22.203 1.234 33.28 2.427c11.378 1.226 22.805 2.426 33.989 4.856 9.342 2.03 18.387 5.252 27.516 8.093 8.846 2.753 26.405 8.671 26.405 8.671'/%3e%3c/g%3e%3cg fill='%23ccc'%3e%3cg id='b'%3e%3cpath d='m1533.28 904.042 101.171 86.713s-5.133 11.214-7.279 16.99c-1.979 5.326-3.817 10.726-5.146 16.251-1.958 8.145-4.135 24.789-4.135 24.789L1499.95 940.75c1.673-24.69 15.567-33.488 33.331-36.708zm-14.29 54.155-24.283 27.167 15.164 14.593-23.462 22.89-15.165-15.165-25.514 27.202-.237 33.743 58.084 45.494 20.029-14.879-1.145-32.332 15.45 8.584 15.452-9.443.858 29.185-12.59-9.156-13.734 18.026-1.43 32.046 43.777 38.913 53.05-47.079-4.009-14.112-2.305-12.678-1.247-25.129 1.98-27.44z'/%3e%3cpath d='m1494.71 985.364-.621 29.993 15.643-15.261z'/%3e%3cpath fill='none' d='m1571.935 1140.425-1.82 34.262m-18.61-139.675.644 31.785m-14.81-17.34.83 25.884m-14.426-36.34.542 28.924m-21.435 15.225.312 30.648m24.737-9.675 44.063 36.897 45.056-39.54M1446 1034.605l57.579 49.193 18.884-16.881-14.879-12.59 16.596-15.737 12.875 11.16 14.593-14.88 18.884 18.313-17.15 13.447 16.005 14.593-15.164 14.02'/%3e%3cpath d='m1901.35 1229.35 48.602 44.58 10.763 31.428-62.642-6.673-35.663-35.277-37.97-35.175-164.039-142.138s3.479-13.101 5.635-19.522c3.124-9.3 6.867-18.384 10.565-27.472.928-2.28 2.915-6.785 2.915-6.785l183.014 162.24z'/%3e%3cpath d='M1942.67 1236.04c27.095 37.868 72.691 73.638 86.537 90.842 13.845 17.203 22.764 33.54 2.583 55.538-20.182 21.998-43.064 9.515-61.136-2.583-18.07-12.099-49.602-51.303-94.716-81.37z'/%3e%3cpath d='m1926.7 1299.75-35.17-15.874m40.929-38.287c2.423 7.965.574 16.774 3.624 24.416 3.015 7.555 14.022 19.973 14.022 19.973s-6.998.978-10.262 2.245c-4.73 1.838-11.956 2.71-13.172 7.638-1.063 4.309 4.062 8.026 7.09 11.27 2.905 3.112 6.645 5.372 10.316 7.526 6.137 3.6 12.391 7.654 19.393 8.917 8.765 1.58 25.13-10.756 26.647-1.98.631 3.65-7.39 1.313-10.713 2.946-7.758 3.813-11.65 12.118-4.82 17.894 4.384 3.71 11.274 2.347 16.998 2.821 5.49.455 11.758-2.745 16.523.016 5.61 3.25 12.668 11.106 9.692 16.867-3.063 5.928-14.484 5.77-19.927 1.91-4.025-2.854-2.947-9.474-3.542-14.371-.177-1.458 0-2.937 0-4.406'/%3e%3ccircle cx='2154.665' cy='1480.147' r='129.687'/%3e%3cpath fill='%23fff' d='M2106.13 1485.65c-22.355 0-40.478 18.123-40.478 40.478 0 22.356 18.123 40.478 40.478 40.478s40.478-18.122 40.478-40.478l14.026-.609c0 22.356 18.123 40.478 40.478 40.478s40.478-18.122 40.478-40.478-18.122-40.478-40.478-40.478l.61-7.937c22.355 0 40.477-18.123 40.477-40.478s-18.122-40.479-40.478-40.479c-22.355 0-40.478 18.123-40.478 40.479l-14.026-1.218c0-22.356-18.123-40.478-40.478-40.478-22.356 0-40.478 18.122-40.478 40.478 0 22.355 18.122 40.478 40.478 40.478z'/%3e%3ccircle cx='2154.667' cy='1446.052' r='14.613'/%3e%3ccircle cx='2189.367' cy='1480.148' r='14.613'/%3e%3ccircle cx='2155.277' cy='1511.2' r='14.613'/%3e%3ccircle cx='2119.347' cy='1480.148' r='14.613'/%3e%3cpath fill='%23fff' d='M2152.23 1558.42c-5.338 10.957-12.62 15.941-21.919 21.919 13.247 5.754 29.4 4.697 43.838 0-9.299-4.65-16.041-11.996-21.919-21.919zm-76.579-80.232c-10.956-5.338-15.94-12.62-21.919-21.919-5.753 13.248-4.696 29.4 0 43.838 4.65-9.299 11.996-16.041 21.92-21.919zm159.246 3.653c10.957-5.337 15.941-12.62 21.92-21.919 5.753 13.248 4.696 29.4 0 43.838-4.65-9.298-11.996-16.041-21.92-21.919zm-78.405-80.84c-5.338-10.957-12.62-15.941-21.919-21.92 13.248-5.753 29.4-4.696 43.838 0-9.299 4.65-16.041 11.997-21.919 21.92z'/%3e%3c/g%3e%3cg fill='%23ce9d09'%3e%3cg id='c'%3e%3cpath d='M1533.48 903.819s.703-5.061 0-7.44c-1.144-3.868-3.574-7.467-6.58-10.157-2.544-2.275-5.808-3.923-9.157-4.578-3.615-.706-7.464-.115-11.016.859-2.42.663-6.753 3.322-6.753 3.322l-14.85 6.12-5.51 17.667s-3.174 5.58-3.931 8.656c-.81 3.293-1.41 6.871-.573 10.158.983 3.86 3.232 7.611 6.295 10.157 2.833 2.355 6.627 3.73 10.3 4.006 2.827.213 8.298-1.86 8.298-1.86 1.58-18.611 9.856-32.813 33.477-36.91z'/%3e%3cpath d='m1500.27 885.645-38.753-17.02-3.147 3.005 21.118 38.201s5.925-8.738 9.354-12.736c3.51-4.093 11.428-11.45 11.428-11.45z'/%3e%3ccircle cx='1457.292' cy='865.263' r='15.951'/%3e%3cpath d='M1566.19 932.256c3.39 27.952 7.322 55.904 16.025 83.856l31.069 28.46c-6.625-29.232-18.443-58.464-18.369-87.695z'/%3e%3cpath d='m1613.05 972.415-85.487-6.369 27.2 24.916 78.068 3.38 1.147-3.99zm105.31 94.505c-22.445 8.46-31.418 22.309-37.857 37.171-6.353.56-12.306.618-14.41-4.133 5.347-34.7 30.21-45.552 35.753-47.747 14.95-2.825 12.178 8.85 16.514 14.709zm27.52 25.9c-22.445 8.46-31.418 22.309-37.857 37.171-6.353.559-12.306.618-14.41-4.134 5.347-34.7 30.21-45.55 35.753-47.746 14.95-2.825 12.179 8.85 16.514 14.709zm312.78 261.87c-7.337-.202-15.078 1.504-15.078 1.504.303 8.02-2.946 16.583-11.797 26.23-7.64 8.327-15.666 11.704-23.672 12.041l-.01.01s-2.84 17.652 2.588 23.252c6.356 6.558 27.12 3.877 27.12 3.877l1.767-1.132a129.688 129.688 0 0 1 31.914-39.795l.332-1.26s3.038-16.523-2.149-21.5c-2.35-2.27-6.613-3.072-11.015 0z'/%3e%3ccircle cx='2254.517' cy='1375.424' r='17.657'/%3e%3ccircle cx='2260.607' cy='1580.001' r='17.657'/%3e%3ccircle cx='2062.117' cy='1591.57' r='17.657'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg fill='%23ce9d09' transform='matrix(-1 0 0 1 3718.256 0)'%3e%3cuse xlink:href='%23b'/%3e%3cuse xlink:href='%23c' fill='%23ccc'/%3e%3c/g%3e%3cg fill='%23fa0204'%3e%3cpath id='d' d='M1869.19 1175.78c0 5.38-4.5 7.458-13.243 7.458s-12.786-2.534-12.786-7.915c0-5.38 4.043-6.697 12.786-6.697s13.243 1.774 13.243 7.154z'/%3e%3cuse xlink:href='%23d' x='6.391' y='14.309'/%3e%3cpath d='M1877.34 1208.69c-1.772 5.08-6.705 5.56-14.96 2.681-8.255-2.88-11.238-6.605-9.466-11.685 1.772-5.08 6.023-4.992 14.278-2.112 8.255 2.879 11.92 6.036 10.148 11.116z'/%3e%3cpath id='e' d='M1877.51 1222.51c-1.065 5.274-5.887 6.42-14.457 4.69s-12.031-5.016-10.966-10.29c1.065-5.274 5.289-5.765 13.858-4.034 8.57 1.73 12.63 4.36 11.565 9.634z'/%3e%3cuse xlink:href='%23e' x='3.96' y='16.142'/%3e%3cpath d='M1921.73 1216.2c-2.59-.691-2.303-5.303-1.583-7.886 1.107-3.968 8.354-9.11 8.354-9.11s1.767 5.563.95 8.185c-1.162 3.729-3.948 9.818-7.721 8.811z'/%3e%3cpath d='M1912.29 1224.42c-2.822-.622-3.182-5.523-2.444-8.316 1.142-4.324 9.645-9.325 9.645-9.325s1.477 6.041.52 8.83c-1.267 3.694-3.907 9.651-7.721 8.811zm-10.77 15.59c-4.292-1.138-3.805-8.762-2.66-13.052.947-3.543 3.716-9.12 7.278-8.249 4.167 1.018 4.115 8.321 3.103 12.49-.92 3.795-3.947 9.812-7.721 8.811z'/%3e%3cpath d='M1888.73 1252.19c-4.214-.926-6.007-7.638-5.164-11.87.885-4.442 5.36-10.41 9.782-9.431 4.463.988 6.005 8.353 4.93 12.795-1.004 4.143-5.385 9.421-9.548 8.506zm-2.22 7.39c-1.077 5.087-7.504 6.86-11.461 5.57-4.154-1.356-9.579-7.187-8.442-12.525 1.147-5.385 8.179-6.813 12.324-5.225 3.866 1.48 8.643 7.155 7.579 12.18zm-85.04-49.29s5.138 2.531 7.349 4.792c2.32 2.373 5.11 3.322 3.709 6.923-1.415 3.634-5.843 2.388-8.127-.156-2.13-2.372-2.931-11.559-2.931-11.559zm25.37 8.77c5.212 1.047 5.108 7.12 2.443 10.847-2.797 3.91-10.883 8.992-16.349 7.887-5.515-1.116-4.844-7.758-1.795-11.658 2.843-3.638 10.553-8.11 15.701-7.076z'/%3e%3cpath id='f' d='M1844.26 1230.55c4.853 2.169 3.415 8.07 0 11.118-3.59 3.199-12.597 6.375-17.685 4.093-5.134-2.302-3.016-8.633.816-11.767 3.575-2.922 12.08-5.586 16.874-3.444z'/%3e%3cuse xlink:href='%23f' x='13.998' y='10.661'/%3e%3cpath d='M1862.97 1250.68c4.787.754 6.069 7.415 4.585 11.696-1.56 4.494-7.474 10.67-12.496 9.87-5.068-.806-5.982-8.132-4.2-12.634 1.66-4.199 7.383-9.678 12.112-8.932z'/%3e%3cpath d='M1875.1 1265.33c3.965 2.308 3.033 9.59.41 13.533-2.754 4.14-9.845 8.622-14.002 6.194-4.195-2.451-2.735-10.302.216-14.38 2.752-3.8 9.46-7.626 13.377-5.347zm-86.08-39.89c4.244-.376 7.182 5.965 7.127 10.585-.06 4.85-3.317 12.403-7.771 12.79-4.495.39-7.309-6.7-7.065-11.611.227-4.58 3.518-11.393 7.71-11.765z'/%3e%3cpath d='M1802.91 1237.65c4.157.932 5.027 7.867 3.57 12.251-1.532 4.602-6.933 10.806-11.294 9.82-4.4-.995-4.924-8.606-3.198-13.21 1.609-4.293 6.817-9.782 10.923-8.861z'/%3e%3cpath d='M1815.79 1246.24c4.921 1.158 5.952 9.77 4.226 15.215-1.814 5.716-8.208 13.42-13.37 12.196-5.21-1.236-5.83-10.689-3.787-16.406 1.905-5.332 8.07-12.15 12.932-11.005z'/%3e%3cpath d='M1826.22 1256.8c5.014-.644 9.005 7.057 9.301 12.761.31 5.988-2.97 15.448-8.234 16.115-5.312.673-9.213-7.96-9.309-14.03-.089-5.661 3.29-14.21 8.243-14.847z'/%3e%3cpath id='g' d='M1838.59 1265.66c4.556-.534 8.182 5.85 8.451 10.578.282 4.964-2.699 12.805-7.482 13.358-4.826.558-8.371-6.598-8.458-11.63-.08-4.693 2.989-11.779 7.49-12.307z'/%3e%3cuse xlink:href='%23g' x='12.788' y='10.35'/%3e%3cpath id='h' d='M1929.28 1250.88c-3.243 2.846-9.712.313-12.621-2.874-3.054-3.345-5.21-10.486-1.801-13.468 3.44-3.01 10.287.112 13.228 3.61 2.742 3.264 4.398 9.92 1.194 12.732z'/%3e%3cuse xlink:href='%23h' x='-6.999' y='12.792'/%3e%3cuse xlink:href='%23h' x='-19.479' y='23.452'/%3e%3cpath d='M1905.19 1281.18c-1.138 4.162-7.933 5.613-12.116 4.557-4.392-1.11-10.126-5.88-8.924-10.247 1.213-4.407 8.646-5.575 13.028-4.276 4.086 1.212 9.137 5.855 8.012 9.966z'/%3e%3cpath d='M1887.18 1278.19c3.641 2.539 2.786 10.55.377 14.889-2.53 4.554-9.042 9.485-12.86 6.813-3.853-2.696-2.512-11.334.198-15.819 2.528-4.182 8.689-8.39 12.286-5.883z'/%3e%3cpath d='M1869.62 1287.55c3.965 2.308 3.033 9.59.41 13.533-2.754 4.14-9.844 8.622-14.002 6.194-4.195-2.451-2.735-10.302.216-14.38 2.752-3.8 9.46-7.626 13.377-5.347z'/%3e%3cpath id='i' d='M1831.34 1312.91c-3.392 3.235-.755 11.272 2.773 15.282 3.706 4.209 11.795 8.104 15.349 4.703 3.586-3.433.292-12.024-3.594-16.132-3.624-3.83-11.179-7.048-14.53-3.853z'/%3e%3cuse xlink:href='%23i' x='-7.319' y='13.781'/%3e%3cpath id='j' d='M1820.83 1339.55c-4.348 1.749-4.876 10.19-3.083 15.222 1.883 5.282 7.954 11.896 12.516 10.053 4.602-1.861 4.724-11.061 2.635-16.315-1.948-4.9-7.774-10.687-12.069-8.96z'/%3e%3cuse xlink:href='%23j' x='-10.548' y='14.852'/%3e%3cpath id='k' d='M1802.66 1371.04c-4.57 1.037-6.43 9.289-5.458 14.54 1.022 5.515 5.967 13.008 10.763 11.91 4.84-1.107 6.419-10.171 5.19-15.69-1.147-5.147-5.981-11.785-10.496-10.76z'/%3e%3cuse xlink:href='%23k' x='-10.121' y='15.932'/%3e%3cpath id='l' d='M1784.06 1403.3c-4.684.171-8.042 7.935-8.06 13.276-.02 5.608 3.451 13.888 8.367 13.7 4.961-.19 8.194-8.805 8.01-14.456-.172-5.27-3.692-12.69-8.318-12.52z'/%3e%3cuse xlink:href='%23l' x='-10.33' y='19.16'/%3e%3cuse xlink:href='%23l' x='-22.39' y='37.02'/%3e%3cuse xlink:href='%23l' x='-34.87' y='52.31'/%3e%3cuse xlink:href='%23l' x='-47.79' y='66.51'/%3e%3cuse xlink:href='%23l' x='-61.99' y='78.14'/%3e%3cuse xlink:href='%23l' x='-75.56' y='90.62'/%3e%3cpath d='m1692.79 1500.17-5.262 20.595s2.935 7.335 6 7.026c5.48-.552 6.964-9.047 8.01-14.455.947-8.424-8.748-13.166-8.748-13.166zm324.42 13.08c1.61 6.124 15.26 11.314 15.26 11.314l-6.651-27.758c-5.717.154-9.495 12.436-8.609 16.444z'/%3e%3cpath d='M2016.01 1490.95c-4.359-1.722-10.549 4.043-12.709 8.928-2.266 5.13-2.409 14.107 2.17 15.906 4.62 1.815 11.038-4.779 13.136-10.03 1.956-4.896 1.708-13.104-2.597-14.805z'/%3e%3cpath id='m' d='M2000.82 1478.67c-4.68-.243-8.711 7.193-9.202 12.512-.514 5.584 2.21 14.139 7.124 14.385 4.958.249 8.94-8.046 9.256-13.691.295-5.265-2.556-12.966-7.179-13.207z'/%3e%3cuse xlink:href='%23m' x='-13.4' y='-13.7'/%3e%3cuse xlink:href='%23m' x='-25.88' y='-29.23'/%3e%3cuse xlink:href='%23m' x='-38.66' y='-42.32'/%3e%3cuse xlink:href='%23m' x='-49.01' y='-60.28'/%3e%3cuse xlink:href='%23m' x='-60.28' y='-76.41'/%3e%3cuse xlink:href='%23m' x='-70.63' y='-93.46'/%3e%3cuse xlink:href='%23m' x='-79.76' y='-113.25'/%3e%3cuse xlink:href='%23m' x='-89.81' y='-131.21'/%3e%3cuse xlink:href='%23m' x='-98.03' y='-152.52'/%3e%3cpath d='M1883.85 1304.56s-1.647 26.676 8.037 28.389c6.039 1.068 10.779-14.91 10.779-14.91z'/%3e%3cpath id='n' d='M1862.02 1610.75c-2.878 3.699.914 11.26 4.995 14.706 4.285 3.617 12.86 6.278 15.874 2.39 3.041-3.924-1.483-11.936-5.931-15.426-4.15-3.254-12.096-5.324-14.939-1.67z'/%3e%3cuse xlink:href='%23n' x='18.3' y='-2.15'/%3e%3cuse xlink:href='%23n' x='36.81' y='-5.81'/%3e%3cpath id='o' d='M1916.18 1603.8c-2.29 4.09 2.594 10.995 7.147 13.79 4.78 2.932 13.656 4.275 16.052-.021 2.418-4.336-3.258-11.578-8.18-14.36-4.59-2.595-12.758-3.448-15.02.591z'/%3e%3cuse xlink:href='%23o' x='20.02' y='-3.22'/%3e%3cpath id='p' d='M1953.48 1595.43c-1.903 4.283 3.598 10.709 8.389 13.071 5.03 2.479 13.993 2.997 15.982-1.503 2.007-4.54-4.313-11.228-9.47-13.544-4.811-2.159-13.023-2.254-14.902 1.976z'/%3e%3cuse xlink:href='%23p' x='18.94' y='-5.59'/%3e%3cpath id='q' d='M1991.26 1583.89c-1.646 4.388 4.225 10.477 9.147 12.553 5.167 2.177 14.145 2.164 15.865-2.445 1.735-4.651-4.968-10.953-10.255-12.96-4.93-1.872-13.132-1.482-14.758 2.852z'/%3e%3cuse xlink:href='%23q' x='19.16' y='-6.24'/%3e%3cuse xlink:href='%23q' x='37.67' y='-13.99'/%3e%3cuse xlink:href='%23q' x='57.48' y='-22.17'/%3e%3cuse xlink:href='%23q' x='77.5' y='-28.63'/%3e%3cuse xlink:href='%23q' x='79.87' y='-44.34'/%3e%3cpath d='M2066.71 1534.88s13.55 1.992 14.79-2.875c1.645-6.462-15.422-12.745-15.422-12.745z'/%3e%3cpath id='r' d='M1701.62 1575.59c-3.986 2.465-3.066 10.873-.44 15.525 2.756 4.883 9.866 10.365 14.046 7.77 4.218-2.619 2.768-11.705-.186-16.526-2.756-4.495-9.483-9.204-13.421-6.77z'/%3e%3cuse xlink:href='%23r' x='18.94' y='7.75'/%3e%3cuse xlink:href='%23r' x='37.03' y='10.55'/%3e%3cuse xlink:href='%23r' x='56.83' y='15.5'/%3e%3cuse xlink:href='%23r' x='74.7' y='18.08'/%3e%3cuse xlink:href='%23r' x='92.35' y='21.74'/%3e%3cuse xlink:href='%23r' x='110.43' y='26.69'/%3e%3cuse xlink:href='%23r' x='128.3' y='29.92'/%3e%3cuse xlink:href='%23r' x='146.6' y='32.72'/%3e%3cpath d='M1648.16 1517.51c-4.167-2.145-10.898 2.977-13.531 7.625-2.764 4.879-3.796 13.797.582 16.041 4.418 2.265 11.457-3.66 14.065-8.677 2.433-4.678 3-12.87-1.116-14.99z'/%3e%3cpath d='M1642.01 1534.4c-4.415-1.572-10.405 4.4-12.396 9.357-2.09 5.204-1.926 14.18 2.711 15.822 4.68 1.657 10.868-5.153 12.786-10.472 1.788-4.96 1.26-13.155-3.102-14.708z'/%3e%3cpath d='M1647.74 1549.94c-4.54-1.165-9.963 5.326-11.496 10.443-1.61 5.372-.632 14.297 4.135 15.51 4.811 1.226 10.356-6.117 11.783-11.588 1.33-5.102.061-13.215-4.423-14.366z'/%3e%3cpath d='M1662.37 1556.31c-4.499-1.313-10.132 4.998-11.832 10.062-1.784 5.316-1.099 14.268 3.626 15.637 4.769 1.382 10.55-5.775 12.156-11.197 1.497-5.056.493-13.206-3.95-14.503z'/%3e%3cpath id='s' d='M1671.91 1558.81c-4.547 1.134-6.232 9.423-5.148 14.653 1.138 5.491 6.242 12.878 11.013 11.68 4.815-1.21 6.202-10.306 4.856-15.798-1.256-5.121-6.23-11.655-10.722-10.535z'/%3e%3cuse xlink:href='%23s' x='16.79' y='6.24'/%3e%3cuse xlink:href='%23i' x='8.611' y='-11.189'/%3e%3cuse xlink:href='%23i' x='4.66' y='6.47'/%3e%3cuse xlink:href='%23i' x='4.911' y='26.679'/%3e%3cuse xlink:href='%23i' x='4.66' y='47.87'/%3e%3cuse xlink:href='%23i' x='5.57' y='68.57'/%3e%3cuse xlink:href='%23i' x='2.22' y='87.75'/%3e%3cuse xlink:href='%23i' x='4.66' y='109.06'/%3e%3cuse xlink:href='%23i' x='2.22' y='126.41'/%3e%3cuse xlink:href='%23i' x='4.66' y='143.46'/%3e%3cuse xlink:href='%23i' x='4.66' y='163.86'/%3e%3cuse xlink:href='%23i' x='3.44' y='183.95'/%3e%3cuse xlink:href='%23i' x='3.74' y='203.13'/%3e%3cuse xlink:href='%23i' x='4.35' y='223.52'/%3e%3cuse xlink:href='%23i' x='4.35' y='243.31'/%3e%3cuse xlink:href='%23i' x='3.74' y='263.1'/%3e%3cuse xlink:href='%23i' x='2.52' y='283.19'/%3e%3cuse xlink:href='%23i' x='2.52' y='305.11'/%3e%3cuse xlink:href='%23i' x='1.92' y='327.94'/%3e%3cuse xlink:href='%23i' x='1.92' y='349.25'/%3e%3cuse xlink:href='%23i' x='1.92' y='369.04'/%3e%3cuse xlink:href='%23i' x='1.31' y='391.27'/%3e%3cpath id='t' d='M1882.24 1303.18c2.442 3.707-1.32 10.832-5.164 13.97-4.036 3.293-11.911 5.463-14.468 1.566-2.58-3.931 1.863-11.458 6.042-14.62 3.896-2.95 11.178-4.577 13.59-.916z'/%3e%3cuse xlink:href='%23t' x='2.74' y='16.13'/%3e%3cuse xlink:href='%23t' x='2.43' y='34.1'/%3e%3cuse xlink:href='%23t' x='2.13' y='52.36'/%3e%3cuse xlink:href='%23t' x='1.82' y='69.11'/%3e%3cuse xlink:href='%23t' x='2.74' y='87.07'/%3e%3cuse xlink:href='%23t' x='1.52' y='104.42'/%3e%3cpath d='M1883.25 1426.06c2.696 3.834-1.456 11.203-5.7 14.448-4.454 3.406-13.147 5.65-15.97 1.62-2.848-4.066 2.057-11.85 6.67-15.12 4.3-3.05 12.338-4.735 15.001-.948z'/%3e%3cpath id='u' d='M1882.09 1443.58c3.392 3.235.755 11.272-2.773 15.282-3.706 4.209-11.795 8.104-15.349 4.702-3.586-3.432-.292-12.024 3.594-16.13 3.624-3.83 11.179-7.049 14.529-3.854z'/%3e%3cuse xlink:href='%23u' x='.61' y='20.4'/%3e%3cuse xlink:href='%23u' x='.92' y='40.49'/%3e%3cuse xlink:href='%23u' x='.31' y='62.11'/%3e%3cuse xlink:href='%23u' x='.92' y='82.2'/%3e%3cuse xlink:href='%23u' x='.31' y='102.6'/%3e%3cuse xlink:href='%23u' x='.61' y='122.99'/%3e%3cuse xlink:href='%23u' x='.61' y='143.69'/%3e%3cuse xlink:href='%23u' x='-.3' y='164.4'/%3e%3cuse xlink:href='%23u' x='.92' y='183.27'/%3e%3cuse xlink:href='%23u' x='.92' y='203.06'/%3e%3cuse xlink:href='%23u' x='.31' y='224.37'/%3e%3cuse xlink:href='%23u' x='.31' y='245.37'/%3e%3c/g%3e%3cpath fill='%23fa0204' d='M1849.64 1848.26c19.902 5.524 31.76 5.236 48.22.43l-17.437-27.984'/%3e%3cpath fill='%23ce9d09' d='m1888.31 1776.16-31.708-8.141s.366-35.184 20.389-32.116c16.62 2.547 11.985 40.341 11.319 40.257z'/%3e%3ccircle cx='1872.886' cy='1722.971' r='12.916' fill='%23ce9d09'/%3e%3cpath fill='%23fa0204' d='M1885.37 1791.86c7.048 17.864 11.37 33.241 4.736 53.386m7.597 3.412c-10.226-8.255-36.582-5.832-47.981-.347-4.453 0-16.446-83.24 25.722-81.183 38.72 1.89 24.949 81.915 22.259 81.53z'/%3e%3cpath fill='%23fa0204' d='M1815.2 1866.34c19.292 12.239 37.25 11.14 54.247.43l-40.255-41.976'/%3e%3ccircle cx='1843.396' cy='1738.255' r='12.916' fill='%23ce9d09'/%3e%3cpath fill='%23ce9d09' d='m1859.33 1780.02-32.72-.646s-4.245-26.612 16.145-27.769c16.924-.96 17.251 28.363 16.575 28.415z'/%3e%3cpath fill='%23fa0204' d='M1843.61 1860.74c-6.261-13.91-6.91-31.026-5.166-49.51m-9.472 50.371c-7.682-13.183-9.107-30.015-3.014-51.233m43.404 56.636c-4.926-6.191-40.227-8.83-54.096-.392-5.02 0-18.54-93.848 29-91.529 43.656 2.13 28.129 92.354 25.096 91.92z'/%3e%3c/g%3e%3c/svg%3e";
            },
            4261: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 72 48'%3e%3cpath fill='%23009e60' d='M0 0h72v48H0z'/%3e%3cpath fill='%23fcd116' d='M0 0h54v48H0z'/%3e%3cpath fill='%230072c6' d='M0 0h18v48H0z'/%3e%3cpath fill='%23009e60' d='m32 34 4 8 4-8-4-8zm-5-10 4 8 4-8-4-8zm10 0 4 8 4-8-4-8z'/%3e%3c/svg%3e";
            },
            8574: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 180 120'%3e%3cdefs%3e%3cg id='d' transform='translate(0 -36)'%3e%3cg id='c'%3e%3cg id='b'%3e%3cpath id='a' fill='%23fff' d='M0-5v5h3z' transform='rotate(18 0 -5)'/%3e%3cuse xlink:href='%23a' transform='scale(-1 1)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(72)'/%3e%3c/g%3e%3cuse xlink:href='%23b' transform='rotate(-72)'/%3e%3cuse xlink:href='%23c' transform='rotate(144)'/%3e%3c/g%3e%3c/defs%3e%3cpath fill='%23cf142b' d='M0 0h180v120H0z'/%3e%3cpath fill='%2300247d' d='M0 0h180v80H0z'/%3e%3cpath fill='%23fc0' d='M0 0h180v40H0z'/%3e%3cg transform='translate(90 84)'%3e%3cg id='f'%3e%3cg id='e'%3e%3cuse xlink:href='%23d' transform='rotate(10)'/%3e%3cuse xlink:href='%23d' transform='rotate(30)'/%3e%3c/g%3e%3cuse xlink:href='%23e' transform='rotate(40)'/%3e%3c/g%3e%3cuse xlink:href='%23f' transform='rotate(-80)'/%3e%3c/g%3e%3c/svg%3e";
            },
            8728: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 1200 600'%3e%3cdefs%3e%3clinearGradient id='b' x1='103.083' x2='92.551' y1='111.276' y2='107.764' gradientTransform='matrix(.99614 0 0 2.25255 703.842 -75.047)' gradientUnits='userSpaceOnUse'%3e%3cstop offset='0' stop-color='red'/%3e%3cstop offset='1' stop-color='%23ff0'/%3e%3c/linearGradient%3e%3cclipPath id='a'%3e%3cpath d='M0 0v150h700v150H600zm600 0H300v350H0v-50z'/%3e%3c/clipPath%3e%3c/defs%3e%3cpath fill='%23012169' d='M0 0h1200v600H0z'/%3e%3cpath stroke='%23fff' stroke-width='60' d='m0 0 600 300m0-300L0 300'/%3e%3cpath stroke='%23c8102e' stroke-width='40' d='m0 0 600 300m0-300L0 300' clip-path='url(%23a)'/%3e%3cpath stroke='%23fff' stroke-width='100' d='M300 0v350M0 150h700'/%3e%3cpath stroke='%23c8102e' stroke-width='60' d='M300 0v350M0 150h700'/%3e%3cpath fill='%23012169' d='M0 300h600V0h600v600H0z'/%3e%3cpath fill='%23fff' d='m776.26 144.068 250.401-.93-.465 222.993s8.827 33.913-104.992 85.48c40.882-4.181 85.48-47.85 85.48-47.85s18.119-23.228 26.946-10.22c8.826 13.007 17.188 19.511 23.692 24.621 6.504 5.11 11.614 19.048 1.859 29.268s-25.087 11.614-29.268-.93c-6.504 3.253-46.457 51.568-128.22 53.89-83.157-1.393-128.685-54.354-128.685-54.354s-11.15 17.654-26.945 3.717c-15.33-18.118-3.716-29.732-3.716-29.732s13.007-7.433 16.724-12.544c6.04-6.968 7.898-16.26 18.118-16.26 12.079.93 16.724 10.685 16.724 10.685s41.811 44.134 86.874 49.709c-101.736-48.783-105.453-78.98-104.988-86.413l.465-221.133z'/%3e%3cpath fill='%23006129' stroke='%23000' stroke-width='1.887' d='m782.299 150.107 238.787-1.394v214.63c.465 27.874-46.457 56.213-119.858 92.449-75.724-39.024-119.394-62.716-119.858-92.913l.93-212.771z'/%3e%3cg id='c' fill='%23ffc72c' stroke='%23000' stroke-width='.944'%3e%3cpath fill='none' stroke='%23ffc72c' stroke-width='1.887' d='m814.794 181.829 14.095-20.701 14.164 20.744'/%3e%3cpath d='M831.719 174.09a2.8 2.8 0 1 1-5.598.002 2.8 2.8 0 0 1 5.598-.002z'/%3e%3cpath d='m817.444 197.119 21.852.062s.342-2.836-2.283-4.56c11.446-1.573 8.472-11.669 18.058-12.241 1.86.286-5.008 4.292-5.008 4.292s-5.779 4.078-3.147 6.152c2.09 1.646 3.004-1.001 3.29-3.004.286-2.003 9.3-3.29 8.012-9.014-2.146-4.72-14.736 3.148-14.736 3.148l-8.982-.05c-.56-1.008-3.035-5.05-5.592-5.07-3.033.111-5.17 5.12-5.17 5.12h-20.315s-.696 5.212 9.605 6.214c2.319 3.029 4.117 3.875 6.133 4.659-1.344 1.12-1.723 2.475-1.717 4.292zm1.573-4.435 18.2-.062m-26.536-10.669s1.456 8.513 8.176 10.529'/%3e%3cpath fill='url(%23b)' d='M809.561 181.841c.672-3.248 1.904-3.808 3.248-7.952.224-4.033-3.248-3.585-2.24-6.16 1.792-2.8.896-5.49-2.464-7.617.672 3.696-4.368 7.168-4.368 10.192 0 3.025 2.576 2.353 2.24 6.945.224 2.688-.672 2.016-.896 4.592h4.48z'/%3e%3cpath d='M831.495 161.657a2.575 2.575 0 1 1-5.15.002 2.575 2.575 0 0 1 5.15-.002z'/%3e%3c/g%3e%3cuse xlink:href='%23c' x='-.772' y='41.304'/%3e%3cuse xlink:href='%23c' x='-1.089' y='82.013'/%3e%3cuse xlink:href='%23c' x='25.627' y='126.099'/%3e%3cuse xlink:href='%23c' x='-4.574' y='162.163'/%3e%3cuse xlink:href='%23c' x='-3.782' y='204.773'/%3e%3cuse xlink:href='%23c' x='146.28' y='.672'/%3e%3cuse xlink:href='%23c' x='144.936' y='41.218'/%3e%3cuse xlink:href='%23c' x='143.144' y='82.661'/%3e%3cuse xlink:href='%23c' x='145.16' y='123.431'/%3e%3cuse xlink:href='%23c' x='144.712' y='164.201'/%3e%3cuse xlink:href='%23c' x='144.936' y='205.195'/%3e%3cg fill='%23ffc6b5' stroke='%23000' stroke-width='.944'%3e%3cpath fill='%23ffc72c' d='M915.843 406.315s5.702 13.147 12.197 5.069c6.494-8.079 4.118-11.563 4.118-11.563l-14.573-7.92-4.276 9.028 2.534 5.386z'/%3e%3cpath d='M928.357 404.572s.95.159 1.742-1.267-1.742-2.06-2.85-3.643l-1.268 2.534 2.376 2.376zm-32.948-3.485-12.83 6.97s-6.337 1.267-6.812 0c-.475-1.268.159-2.376 3.485-2.535 3.327-.158 12.355-8.395 12.355-8.395l3.802 3.96zm.159-227.938s.317 3.01.475 4.594c.159 1.584-2.534 4.91-2.693 4.752s-1.425.158-1.267 1.108c.159.95 2.06 1.268 2.06 1.268s-.793 3.326 0 3.484c.791.159-2.06 4.277 0 5.386 2.059 1.109 5.543 2.534 7.127 2.218 1.584-.317 0 6.177 0 6.177l-4.435 9.504 24.394-2.534-5.069-8.079s-2.376-1.584-1.742-6.177c.633-4.594-.317-25.344-.317-25.344l-17.424-2.376-1.109 6.019zm-4.436 36.115s-7.92 3.643-7.603 13.464c-2.06 9.504-3.168 19.008-3.168 19.008s-9.346 10.613-12.197 14.415c-2.851 3.801-7.128 11.563-8.712 13.622-1.584 2.06-7.762 8.87-7.603 11.405.158 2.534-1.426 13.78 4.752 15.048 1.584.633 6.653-12.99 6.653-12.99s.316-5.86-1.426-6.969c-1.742-1.108 3.802-4.91 3.802-4.91s10.612-7.762 12.988-9.663c2.376-1.9 8.87-9.187 8.87-9.187l3.644-43.243z'/%3e%3cpath fill='%23fff' d='M900.161 201.82s2.06 5.544 6.653 4.594c4.594-.95 9.98-5.228 9.98-5.228s4.276-.158 4.91.476c.633.633 11.563 11.246 11.246 14.572-.317 3.327-5.069 2.376-6.811 4.594-1.743 2.218-4.594 7.762-3.802 11.88.792 4.119 3.168 9.504 2.851 11.563-.316 2.06-2.059 2.693-2.059 3.802s1.426 3.01 1.426 5.069c0 2.06-1.901 5.069-1.584 7.128.317 2.06.475 8.078.475 8.078l-.475 27.879s1.584.95 1.742 2.534c.159 1.584 10.771 47.679 10.771 47.679s-.475 1.425-1.584 1.267c-1.108-.159 4.277 7.128 4.436 9.187.158 2.06 5.544 18.216 5.385 20.434-.158 2.217-.95 7.128-1.425 7.286-.476.158 3.484 10.138 2.85 11.722-.633 1.584-7.127 1.425-7.127 1.425l-1.743-.316s.159 2.059-1.108 2.217-10.613-.475-10.613-.475-2.693 4.118-4.277 3.96c-1.584-.158-3.643-3.01-4.119-2.534-.475.475 1.426 3.167.95 3.96-.474.792-8.553 2.534-10.137-1.268-1.584-3.801.95-2.85.476-3.643-.476-.792-4.119-2.851-5.228-2.217-1.109.633 2.852 1.584 2.693 3.168-.158 1.584-3.485 3.96-4.752 3.96s-4.277-5.861-8.712-5.228c-4.435.634-7.286 1.743-7.286 1.743s-5.228 2.217-7.445 1.742c-2.218-.475-3.168-2.218-3.168-3.168 0-.95 1.584-5.069 1.425-6.336s-1.425-2.534-1.425-4.435c0-1.9 3.643-8.395 3.643-8.395l-.158-29.146s-3.327 0-3.485-2.06 5.069-46.094 5.86-48.945c.793-2.851 2.852-12.989 2.852-12.989s-2.376 1.109-2.535 0c-.158-1.109 7.128-26.294 7.128-26.294s1.268-12.514 1.268-15.84c0-3.327-.634-7.92-.634-7.92s-6.503-2.753-6.653-6.97c-.595-6.709 6.178-10.454 6.97-12.672l3.168-8.87s3.485-6.02 9.187-6.97z'/%3e%3cpath fill='%23ffc72c' d='M897.785 402.988s-15.365 8.079-17.582 8.712c-2.218.634-3.644-2.693-1.426-3.326 2.218-.634 5.702-.95 5.702-.95s-5.227-4.12-5.068-4.278c.158-.158 7.128-2.692 7.286-2.692s2.218 4.118 3.643 3.801c1.426-.317 5.544-3.484 5.544-3.484s2.218 2.534 1.901 2.217z'/%3e%3cpath d='M919.432 407.423c1.453 1.874 2.02 5.123 5.347 3.222 3.327-1.9-1.704-5.428-1.704-5.428l-3.643 2.206z'/%3e%3cpath d='M925.505 407.106s1.584 1.267 3.01-.158-2.852-4.436-2.852-4.436l-2.059 2.376 1.901 2.218zm6.812-190.146c.158 0 5.227 15.682 5.86 19.642.634 3.96 2.694 19.8 1.902 22.017-.792 2.218-8.87 12.83-9.821 15.523-.95 2.693-6.653 12.99-6.653 12.99s-1.426 10.137-2.06 10.612c-.633.476 1.636 2.964 1.426 3.802-.314.943-4.593 5.386-6.494 4.91-1.9-.475-4.91-2.693-5.069-4.752s.158-8.87 1.584-10.612c1.426-1.743 8.87-19.325 9.346-20.434.475-1.109 6.81-14.89 6.97-17.266.158-2.376-1.972-7.87-4.212-9.886-4.985-14.673-3.026-23.522 7.221-26.546z'/%3e%3cpath fill='%239c5100' d='M895.092 172.199s3.485.475 5.386-.634c1.9-1.108 4.118-1.584 5.702.634 1.584 2.218 2.693 2.06 2.693 2.06s-2.376 5.86 0 6.494c2.376.633 3.485.633 3.643 1.425.159.792-2.06 2.535-1.426 3.327.634.792 1.743 1.742 1.901 2.376.159.633-1.425 3.326-.95 3.96.475.633 1.9 3.168 2.851 3.168.95 0 .317 3.96 3.168 3.01s2.693-3.486 2.693-3.486 3.01-.475 3.802-3.168c.791-2.692 2.692-3.326 2.692-3.326s3.802-2.06-1.267-5.227c0-22.176-14.573-19.8-14.573-19.8s-1.742-3.96-4.593-3.485-3.01 3.802-5.07 3.485c-2.058-.317-2.533-1.743-2.692-1.584-.158.158-1.9 3.326-1.9 4.118 0 .792-5.545-1.109-5.07 3.01.476 4.118 3.168 3.96 3.01 3.643z'/%3e%3cg fill='none'%3e%3cpath d='M920.753 207.997s-14.098 9.029-13.78 12.197m16.948-10.613s-3.168 3.485-3.326 3.485m7.603.317s-6.97 5.702-5.86 9.346m-27.087-15.524s-2.06 4.277-1.584 5.702c.475 1.426 3.96 6.812 4.435 10.138.475 3.326 0 5.703 0 5.703m-6.494-13.623s.634 5.069 1.584 6.02c.95.95 3.485 5.226 3.802 6.969m-6.653 8.078s4.118 2.06 7.92-5.86m6.177-5.544c-.158 0-3.01 7.762 2.06 10.613 5.068 2.851 8.87 2.534 11.087 1.742 2.218-.792 4.594-2.217 4.594-2.217m-19.958-.634s.317 10.455 15.682 20.75m-15.049-10.93s-.158 9.187 5.86 13.306m-9.028-24.077s-4.594 13.622-8.237 15.048m6.812-5.069s-.158 9.82-1.426 13.306m-1.267 2.376s3.168 3.96 6.653 3.643c3.485-.316 4.91-4.435 7.286-3.801 2.376.633 4.594 2.534 10.138 2.059m-7.92 4.118s0 8.078 1.426 8.87.792 8.237.792 8.237M892.4 261.22s-.158 7.603-1.109 10.296c-.95 2.693-2.851 7.287-2.534 11.247m-6.02 4.434c.792-.317 3.485-2.693 3.485-2.693m1.426 1.743s-6.811 29.146-4.91 46.57m6.494-45.144s-3.485 21.86-1.9 25.978m.157-26.612c.158 0 13.306.95 13.306.95m1.901-1.742s3.643 1.9 8.712 1.584m-10.296 9.029s-.634 37.383-1.584 45.62m21.067-37.067s4.118 32.789 6.494 35.798m-14.414-31.679s2.534 28.987 3.96 31.522m-39.917 10.137s4.91-1.584 9.345-6.336c5.07 6.811 12.831.317 12.831.317s12.038 8.237 17.424-.95c8.237 5.385 12.355-.793 12.355-.793s3.01 4.594 5.228 4.119m-13.148 3.168s6.178 28.987 15.365 37.224m-47.203-40.234s.792 24.235 2.218 41.342m-3.327-13.938s-.792 15.84-1.743 16.949m-7.603 1.583s1.742 6.811 10.454.475 8.87 2.376 9.188 3.327c.316.95 1.742 7.761 5.068 2.059m6.971-9.345s-1.426 14.097 11.088 3.801c12.514-10.295 14.573-.158 14.89 3.01m-25.82-230.156s-1.109 6.97 6.336 6.336c-.95 3.802 1.9 5.069 1.9 5.069m5.545 4.277c.159 0 3.326 2.06-.158 4.594m-10.613.95s1.584 1.9 3.326 1.426c1.743-.475 4.594 1.742 4.594 1.742s2.376.792 2.693.317m-20.276 2.534s5.386 2.06 8.87-6.494m-18.849-2.535 3.168.158m-38.312 99.737.248 6.942m-6.758-7.457s4.45 7.443 4.079 11.41'/%3e%3cpath stroke-linejoin='round' d='M894.142 188.197h2.851l-2.534 1.109m17.206 110.656s3.328-.35 3.223 5.206c2.125-6.902 6.446-7.066 6.446-7.066'/%3e%3cpath stroke-linejoin='round' stroke-width='1.699' d='M898.102 179.327c.475 0 2.217-.634 2.534-.158.317.475-1.9.792-2.534.158z'/%3e%3c/g%3e%3c/g%3e%3cg fill='none' stroke='%23000' stroke-width='1.887'%3e%3cpath fill='%23ffc72c' d='M900.299 458.579c66.898-1.858 110.102-50.173 109.638-50.638-.465-.464 8.827-13.472 16.26-11.614 7.433 1.858 18.118 23.693 31.126 28.338 6.504 10.22-1.859 19.512-4.646 21.37-2.787 1.859-15.33 6.97-17.189-.464-1.858-7.433-5.575-6.04-5.575-6.04s-59.464 58.071-128.22 55.749c-71.078.464-129.614-55.748-129.614-55.748l-5.11 5.574s-5.575 6.04-8.362 5.575c-2.787-.464-14.866-8.362-15.795-16.26-.93-7.897 7.433-13.007 7.433-13.007s20.44-15.796 22.764-24.158c4.645-4.646 13.472 3.252 13.472 3.252s53.89 61.787 113.819 58.07z'/%3e%3cpath d='M748.855 422.646s5.528-1.474 7.555.83c2.027 2.302 15.938 15.938 15.938 15.938'/%3e%3cpath d='m761.477 429.095-5.528 4.146s13.912 2.763 10.78 11.885m285.611-22.941s-2.764-1.474-7.094 1.75c-4.33 3.225-15.294 15.479-15.294 15.479'/%3e%3cpath d='m1039.9 428.727 5.989 4.607s-12.53.829-9.766 12.714'/%3e%3c/g%3e%3cpath d='M819.664 437.396c-.362 1.052-1.321-.029-2.117.183-2.094.079-3.834 1.445-5.628 2.377l-18.407 10.731c-.62-.203-.473-.704-.322-1.206 1.636-7.663 3.335-15.313 4.925-22.986.264-1.342.69-3.01-.606-3.986-.551-.376.301-1.14.655-.446l9.41 6.71c-.302.885-.837.265-1.372-.094-1.303-1.253-2.873-.095-2.835 1.488-1.119 5.052-2.21 10.11-3.318 15.165 4.165-2.476 8.378-4.874 12.506-7.412 1.474-.656 2.56-2.631 1.029-3.855-.582-.343-1.544-1.28-.585-1.422l6.665 4.753zm6.611 31.986c-.168.572-.466.698-.922.286l-11.074-6.056c.167-.572.466-.698.922-.286 1 .68 2.634.938 3.363-.255 1.466-2.35 2.701-4.839 4.06-7.253 1.845-3.42 3.769-6.8 5.559-10.248.856-1.222-.1-2.728-1.298-3.251-.405-.217-1.001-.378-.49-.864.247-.304.772.345 1.13.423l10.617 5.806c-.168.572-.467.698-.923.286-1-.68-2.642-.94-3.38.245-1.465 2.351-2.7 4.84-4.058 7.254-1.847 3.42-3.77 6.8-5.56 10.248-.855 1.23.097 2.747 1.314 3.26l.74.405zm42.609-9.994-3.007 8.443c-1.232-.13-.413-1.708-.796-2.54-.44-3.8-3.243-7.347-7.06-8.16-2.92-.795-6 .708-7.715 3.082-2.59 3.537-4.165 7.853-4.387 12.235-.148 2.49.995 5.046 3.17 6.357 1.723 1.136 3.817 1.593 5.863 1.536.722-2.13 1.586-4.215 2.187-6.381.247-1.41-1.21-2.26-2.375-2.583-.181-.41.27-.912.745-.472l11.037 3.932c-.132 1.358-1.667-.109-2.517.433-1.36.522-1.476 2.157-1.991 3.34l-1.345 3.775c-4.946.35-10.044-.696-14.348-3.186-4.185-2.637-7.015-7.728-6.192-12.722.638-4.274 3.301-8.277 7.242-10.165 3.62-1.924 8.037-1.916 11.796-.392 2.055.693 3.83 1.964 5.42 3.41.964 1.3 2.829 1.303 3.62-.175l.653.233m17.952 28.813c-.022.449-.072.86-.61.61l-12.638-1.915c.023-.449.073-.86.61-.61 1.096.224 2.564.206 3.093-.976.535-1.688.642-3.476.95-5.215.723-4.856 1.495-9.706 2.186-14.567.268-1.048-.09-2.233-1.175-2.64-.614-.29-1.299-.334-1.96-.444.023-.45.073-.86.61-.61l12.638 1.915c-.022.449-.072.86-.61.609-1.101-.227-2.563-.197-3.111.974-.535 1.688-.642 3.476-.95 5.215-.723 4.856-1.495 9.706-2.186 14.567-.266 1.045.094 2.254 1.185 2.648.62.282 1.305.33 1.968.44zm34.118-8.287-.5 8.962-22.546 1.15c-.138-.548.01-.84.606-.725 1.133.029 2.593-.452 2.737-1.752.1-2.227-.15-4.455-.224-6.681-.243-4.442-.419-8.887-.71-13.325.125-1.322-1.066-2.301-2.32-2.261-.398-.202-1.475.415-1.367-.31-.182-.589.635-.276.98-.388l12.541-.64c.138.549-.009.84-.606.725-1.158-.006-2.665.276-2.985 1.584-.183 1.926.086 3.864.137 5.795.254 4.625.434 9.256.74 13.877-.094 1.21.877 2.28 2.13 2.047 1.83-.091 3.7-.013 5.487-.473 2.507-.667 3.874-3.15 4.56-5.47.45-.627.078-2.191 1.071-2.101l.269-.014m17.577-21.695c-.598.01-.334.773-.486 1.173-.998 7.476-1.944 14.96-2.976 22.432-.251 1.655-.664 3.588-2.297 4.425-.603.214-.072 1.162.48.635l7.529-2.259c-.095-1.268-1.54-.116-2.35-.339-1.727-.002-1.984-2.1-1.744-3.41l.313-2.657 8.625-2.594c1.1 1.386 2.314 2.69 3.31 4.153.747 1.41-1.07 2.055-2.125 2.327-.493.052-.063 1.085.387.605l11.334-3.397c-.034-1.283-1.677-.08-2.369-.937-2.121-1.594-3.644-3.812-5.4-5.775l-12.231-14.382zm-.063 8.969 6.125 7.312-7.343 2.188 1.218-9.5zm38.632-25.809 3.259 6.06c-1.014.872-1.541-1.149-2.46-1.457-1.507-1.268-3.779-1.508-5.457-.432-.687.357-1.365.73-2.048 1.095 3.277 6.068 6.509 12.16 9.815 18.212.511 1.552 2.418 1.843 3.648.968.476-.345.906-.54 1.06.188-1.664.965-3.482 1.882-5.205 2.828l-6.509 3.5c-.51-.53-.169-.803.407-1.006 1.542-.573 2.135-2.445 1.102-3.763-3.206-6.025-6.46-12.026-9.685-18.042-1.796.995-4.09 1.892-4.543 4.132-.51 1.41.24 3.135.24 4.334-.553.574-.698-.209-.954-.623l-2.785-5.18L977.1 441.38zm15.251-9.042 6.233 8.263c1.445-.919 2.652-2.56 2.218-4.353.167-1.4-1.836-2.988-1.148-3.97.453-.281.72.767 1.095 1.044l7.118 9.436c-.928 1.057-1.6-1.098-2.583-1.331-1.387-.986-3.333-1.477-4.82-.397-1.11.354-1.058.977-.303 1.662 1.67 2.156 3.22 4.41 5.003 6.475 1.091 1.059 2.448-.048 3.372-.784 2.388-1.626 4.485-4.165 4.362-7.21.156-1.33-.679-2.814-.67-3.935.535-.713.685.393.992.755l3.366 6.08-17.544 13.233c-.761-.54-.012-.857.468-1.23 1.638-1.012 1.117-3.078-.088-4.213-3.748-4.936-7.43-9.924-11.226-14.823-.972-1.318-2.765-.624-3.745.295-.407.577-1.044-.579-.273-.664l16.543-12.479 4.528 6.003c-1.049 1.064-1.978-1.307-3.175-1.431-2.173-1.131-4.757-.22-6.553 1.21-1.074.764-2.114 1.575-3.17 2.364'/%3e%3c/svg%3e";
            },
            3545: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='1488.189 992.126 1275 850'%3e%3cpath fill='%23FFF' d='M1488.189 992.126h1275v850h-1275z'/%3e%3cpath fill='%23369443' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M1885.935 1567.623s-1.033-6.99 12.242-12.116c13.275-5.126 14.307-24.232 11.652-36.97 0 0-6.932 12.116-15.339 16.155 0 0-13.717 7.146-14.345 20.795 0 0-.109 4.99-1.142 8.873-.565 2.126-6.637-17.087 4.867-31.377 11.872-14.748 15.192-26.717 5.752-50.017 0 0-.885 14.135-10.177 22.213-9.292 8.077-10.474 8.699-10.325 27.96 0 0 .148 6.679-3.392 8.854 0 0-7.227-10.563-9.145-17.553-1.917-6.99-2.802-9.941 5.457-18.019 0 0 26.461-17.1 7.375-54.522 0 0-.59 12.893-9.735 20.504-9.145 7.611-8.407 12.737-8.85 25.941-.443 13.203-1.328 12.271-2.36 14.135 0 0-16.814-30.911-3.835-47.377s20.207-19.883 5.9-50.483c0 0 .635 15.689-10.818 23.456-11.453 7.767-8.798 25.941-8.798 25.941s.737 6.835-1.622 11.805c0 0-16.202-31.601-.737-48.62 13.127-14.446 14.012-24.543 6.932-45.047 0 0-.885 9.476-8.112 14.601-7.227 5.126-12.979 10.252-11.652 29.979 0 0 .59 13.825-1.18 17.708 0 0-6.785-12.582-8.702-20.815-1.917-8.233-2.655-13.048 2.36-21.281 5.015-8.233 24.927-31.844 1.18-65.861 0 0-.737 11.029-6.785 20.97-6.047 9.941-3.245 21.747-1.917 30.756s-3.097 17.708-3.097 17.708-10.325-18.951-8.112-40.697c2.212-21.747-6.637-39.61-26.697-52.503 0 0-14.602 33.863 5.31 51.105 0 0 16.962 16.776 21.239 37.125 0 0-12.832-1.243-24.484-23.921-11.652-22.679-35.841-19.106-37.464-19.261 0 0 3.983 35.105 41.151 45.047 0 0 23.747 4.039 28.172 21.436 0 0 3.982 11.961 5.605 18.329 0 0-7.522-2.951-14.455-13.203-6.932-10.252-6.047-11.495-29.499-13.825 0 0-9.44-1.088-14.455-7.767 0 0 9.882 37.125 35.251 36.814 0 0 23.157-2.485 36.136 27.96 0 0-2.507-1.553-5.9-3.884-3.392-2.33-11.947-6.679-28.909-4.66s-21.682-.777-25.959-2.175c0 0 17.109 31.377 41.299 22.057 24.189-9.32 35.872 24.665 36.136 25.319 0 0-3.245-2.486-7.522-6.68-4.277-4.194-13.157-9.366-29.942-4.039 0 0-12.094 4.66-24.337.932 0 0 11.8 22.834 39.381 18.951 27.581-3.884 34.514 20.349 34.514 20.349s-3.687-2.175-6.195-4.194c-2.507-2.019-11.8-7.301-31.711-1.398-19.912 5.903-27.139-.932-27.139-.932s11.062 20.193 32.301 22.523c0 0 11.8-.155 16.814-2.019 5.015-1.864 18.289-4.815 27.434 8.388 0 0-2.507.466-6.342-1.243 0 0-14.159-5.126-24.927 3.883 0 0-9.587 9.786-23.157 7.922 0 0 17.552 17.087 45.428 2.641 0 0 9.44-6.835 16.372-1.553 6.934 5.285 23.011-5.123 23.011-5.123z'/%3e%3cpath fill='%23F4C53D' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M2041.1 1146.669s-3.238-28.908 19.863-31.688c24.091-2.9 35.989 2.175 35.989 2.175l10.816 21.229-3.737 14.291-14.946 6.835s2.557-21.954-17.568-22.411c-5.099-.116-8.096 1.906-16.161.626-8.111-1.288-12.449 7.625-14.256 8.943z'/%3e%3cpath fill='%23F4C53D' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M2203.639 1218.226c-3.442 4.453-17.208 6.006-17.208 6.006s14.159 10.873 20.256 26.407c6.097 15.533-164.113.103-164.113.103s7.375-5.281 12.39-15.223c0 0-7.522 2.796-15.044-4.66 0 0 5.605 1.864 12.979-9.32 0 0 10.915-13.98 18.584-17.708 0 0-3.54 2.175-12.094-2.485 0 0 14.75-1.864 20.059-27.028 0 0 .885-5.592 6.49-13.669 5.605-8.078 4.425 1.553 14.75-10.874 0 0 4.72-8.802.59-14.187s-8.555-3.417-17.208-8.595c-8.653-5.178-12.488-8.078-9.538-16.051 2.95-7.974 10.62-6.731 11.701-6.731 1.082 0 1.672-6.938 11.112-11.702s34.514-2.693 38.25-.621c3.737 2.071 18.879 6.524 27.729 28.892 8.85 22.368-2.36 30.756 21.731 64.515 0 0-9.636 2.071-15.831.207 0 0 12.487 22.161 34.415 32.724z'/%3e%3cpath fill='none' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M2098.328 1123.835c-19.617-.932-12.094-19.624-12.094-19.624'/%3e%3cpath fill='%23F4C53D' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M2132.399 1126.398s-3.466-1.631-6.398-5.514c-4.115-5.449-13.292-8.077-18.233-2.951 0 0-5.015 5.592-9.44 5.903 0 0 5.015 1.553 8.481 4.738 3.466 3.184 7.08 5.514 12.242 4.815 5.162-.699 5.974-3.417 8.407-5.048 2.434-1.633 4.941-1.943 4.941-1.943z'/%3e%3cpath fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2259.981 1405.765s18.29 14.912 33.629 0c0 0 6.195 7.456 18.584 5.281 12.39-2.175 14.455-8.699 15.635-12.427 0 0 10.718 6.253 19.764 1.314 9.047-4.939 9.047-12.394 9.047-12.394s15.733 3.101 23.796-7.562c8.063-10.663 3.147-21.226-1.18-22.469 0 0 17.01 4.456 21.633-10.148 3.933-12.427-4.917-18.847-4.917-18.847s35.841-.172 50.542-11.391c0 0 12.193-7.663 4.917-15.74 0 0 32.252-5.178 40.315-18.019 0 0 3.54-3.521 2.36-9.734 0 0-.197-3.521-3.737-3.728 0 0 36.78-5.681 47.395-17.812 0 0 5.113-5.592 2.557-13.048 0 0-.541-1.968-1.426-3.288 0 0 33.481-7.068 50-21.98 0 0 9.536-8.496 4.62-19.887 0 0 55.951-15.322 42.972-39.968 0 0 26.156-8.492 17.896-32.102 0 0 21.633-10.977 12.193-28.374-9.034-16.65-36.775 2.899-69.624 11.988 0 0-88.884 27.985-132.656 35.432l-124.372 185.167-72.568 27.96-7.375 51.776z'/%3e%3cpath fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2259.097 1269.382s11.657-8.751 32.449 1.553c0 0 7 4.82 12.507-.461 4.601-4.413 5.032-12.549-1.297-17.247-15.487-11.495-21.24-45.979 2.36-60.269 0 0 34.219-20.297 159.696-52.229 0 0 10.513-2.915 16.118-1.517 6.172 1.539 10.423 6.835 11.295 11.366 0 0 5.615 15.956-13.262 25.086 0 0-8.522 3.9-17.306 6.421 0 0 9.648-2.086 13.766 7.456 3.933 9.113-1.77 18.433-19.469 24.439 0 0-4.787 1.863-11.603 3.521 0 0 15.143 4.349 7.866 16.569 0 0-6.49 12.841-29.401 15.119 0 0 17.109 1.864 5.015 18.122 0 0-5.31 8.906-22.026 12.22 0 0 12.685.414 6.293 11.805-6.391 11.391-21.432 17.812-36.232 18.847 0 0-8.016.414-13.621-.829 0 0 14.061 7.042 5.801 18.847 0 0-6.096 8.388-21.337 7.974 0 0 3.956 13.183-7.227 18.174-8.702 3.883-15.929-2.33-15.929-2.33s2.95 14.135-9.735 19.106c0 0-6.342 3.262-15.782 0 0 0-7.227 16.155-32.891 4.815-25.666-11.338-6.048-106.558-6.048-106.558z'/%3e%3cpath fill='none' stroke='%23010002' stroke-width='3' d='M2654.383 1121.815s-40.315 23.342-165.869 46.684'/%3e%3cpath fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M1934.384 1534.589s-14.946 25.682-33.039 26.096c0 0-31.122-3.788-39.922 4.349-6.136 5.675-12.39 10.356-14.946 24.854s4.916 17.605 6.686 18.226c0 0 1.377 10.356 11.603 7.663 0 0 .59 10.77 18.683 5.592s25.566-3.521 29.106-21.54c3.54-18.019 6.808-17.724 10.03-19.883 4.327-2.9 12.455-5.64 18.486-9.113 5.418-3.12 26.156-13.67 33.235-14.498 7.08-.828 5.506-24.646 5.506-24.646h-18.289l-8.85-13.048-18.289 15.948z'/%3e%3cpath fill='none' stroke='%23010002' stroke-width='3' d='M2636.487 1153.918s-109.115 35.594-159.93 39.968m116.958 0s-64.011 20.094-138.971 32.774m84.35 9.093s-72.322 17.372-106.849 20.255'/%3e%3cpath fill='none' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M2490.368 1269.9s-61.173 12.758-76.672 14.292'/%3e%3cpath fill='%230081C6' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='m2421.511 1362.939 3.063 97.066-17.139-9.943-28.534 123.179-11.773-8.458 27.776-118.011-19.368.356z'/%3e%3cpath fill='none' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M2451.43 1301.381s-44.642 6.783-62.409 6.42m6.951 20.712s-18.05-.848-26.724-2.288m10.007 31.284s-15.34-4.142-24.386-9.941m1.771 39.972s-11.8-4.556-17.503-16.983m-11.308 28.063s-9.145-8.181-9.735-17.294'/%3e%3cpath fill='%230081C6' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='m2532.37 1406.102-40.565 87.218-10.701-17.253-85.643 101.197-9.273-10.381 85.318-99.916-17.259-9.262z'/%3e%3cpath fill='none' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M2293.61 1405.765s3.424-2.953 1.082-15.792'/%3e%3cpath fill='%230081C6' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='m2495.369 1342.078-20.896 94.594-14.112-14.276-76.651 147.389-11.812-6.895 77.167-147.088-18.795-4.935z'/%3e%3cpath fill='none' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M2298.035 1371.126s1.77-3.676 1.18-9.475'/%3e%3cpath fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M1991.986 1405.766s-18.289 14.912-33.629 0c0 0-6.195 7.456-18.584 5.281s-14.455-8.699-15.635-12.427c0 0-10.718 6.253-19.764 1.314-9.047-4.939-9.047-12.395-9.047-12.395s-15.733 3.101-23.796-7.562c-8.063-10.663-3.147-21.226 1.18-22.469 0 0-17.01 4.456-21.633-10.148-3.933-12.427 4.917-18.847 4.917-18.847s-35.841-.172-50.542-11.391c0 0-12.193-7.663-4.916-15.74 0 0-32.252-5.178-40.315-18.019 0 0-3.54-3.521-2.36-9.734 0 0 .197-3.521 3.736-3.728 0 0-36.78-5.681-47.395-17.812 0 0-5.113-5.592-2.557-13.048 0 0 .541-1.968 1.426-3.288 0 0-33.481-7.068-50.001-21.98 0 0-9.536-8.496-4.62-19.887 0 0-55.952-15.322-42.972-39.968 0 0-26.156-8.492-17.896-32.102 0 0-21.633-10.977-12.193-28.374 9.034-16.65 36.776 2.899 69.624 11.988 0 0 88.884 27.985 132.656 35.432l124.372 185.167 72.568 27.96 7.376 51.777z'/%3e%3cpath fill='none' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M2362.54 1187.263s-20.649 8.285-27.532 19.676c-6.883 11.391-2.35 22.462 0 28.814 1.181 3.192 15.733 31.248-1.377 51.545'/%3e%3cpath fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M1992.871 1269.383s-11.657-8.751-32.449 1.553c0 0-7 4.82-12.506-.461-4.601-4.413-5.033-12.549 1.297-17.247 15.487-11.495 21.239-45.979-2.36-60.269 0 0-34.219-20.297-159.696-52.229 0 0-10.513-2.915-16.118-1.517-6.172 1.539-10.423 6.835-11.295 11.366 0 0-5.615 15.956 13.262 25.086 0 0 8.522 3.9 17.306 6.421 0 0-9.648-2.086-13.766 7.456-3.933 9.113 1.77 18.433 19.469 24.439 0 0 4.787 1.863 11.603 3.521 0 0-15.143 4.349-7.866 16.569 0 0 6.49 12.841 29.401 15.119 0 0-17.109 1.864-5.015 18.122 0 0 5.31 8.906 22.026 12.22 0 0-12.685.414-6.293 11.805 6.391 11.391 21.432 17.812 36.233 18.847 0 0 8.016.414 13.621-.828 0 0-14.061 7.042-5.801 18.847 0 0 6.096 8.388 21.338 7.974 0 0-3.956 13.184 7.227 18.174 8.702 3.883 15.929-2.33 15.929-2.33s-2.95 14.135 9.735 19.106c0 0 6.342 3.262 15.782 0 0 0 7.227 16.155 32.891 4.815 25.662-11.34 6.045-106.559 6.045-106.559z'/%3e%3cpath fill='none' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M2362.245 1309.355s-.098-.104-7.375-2.382m50.935-27.442s-12.308 2.478-24.386 2.589m41.397-32.931s-14.455 1.45-28.024 1.243m49.558-32.931s-20.846 4.142-32.056 4.349m49.362-39.765s-25.709 7.338-44.839 9.941m-42.478 15.119s18.486 17.19-3.737 33.138c0 0 9.243 14.498-9.243 29.617'/%3e%3cpath fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M1994.394 1416.2s-3.766 20.218-33.627 45.666c0 0-23.04 20.324-22.45 43.727.601 23.832-4.13 26.51-13.176 34.588 0 0 18.683 1.45 27.729-10.977 0 0-.393 20.711-3.147 22.575 0 0 5.859.374 14.356-8.906 0 0 5.113-5.385 9.833-7.456 0 0-5.506 14.291-1.18 27.546 0 0 1.377-5.178 8.653-7.456 0 0 13.176-2.693 18.29-21.747 0 0 3.343-12.634 23.992-23.818 0 0 23.402-8.827 22.813-20.361s-52.086-73.381-52.086-73.381z'/%3e%3cpath fill='none' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M2366.276 1277.046s2.753 27.646-31.072 27.648c0 0 6.49 24.647-26.156 23.819 0 0-3.737 19.675-27.336 15.74'/%3e%3cpath fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2317.618 1534.589s14.946 25.682 33.039 26.096c0 0 31.122-3.788 39.922 4.349 6.136 5.675 12.39 10.356 14.946 24.854 2.557 14.498-4.917 17.604-6.687 18.226 0 0-1.377 10.356-11.603 7.663 0 0-.59 10.77-18.683 5.592s-25.566-3.521-29.106-21.54c-3.54-18.019-6.808-17.724-10.03-19.883-4.327-2.9-12.455-5.64-18.486-9.113-5.418-3.12-26.156-13.669-33.235-14.498-7.08-.828-5.507-24.646-5.507-24.646h18.289l8.85-13.048 18.291 15.948z'/%3e%3cpath fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2257.608 1416.2s3.766 20.218 33.627 45.666c0 0 23.04 20.324 22.45 43.727-.601 23.832 4.13 26.51 13.176 34.588 0 0-18.683 1.45-27.729-10.977 0 0 .393 20.711 3.147 22.575 0 0-5.86.374-14.356-8.906 0 0-5.113-5.385-9.833-7.456 0 0 5.506 14.291 1.18 27.546 0 0-1.377-5.178-8.653-7.456 0 0-13.176-2.692-18.29-21.747 0 0-3.343-12.634-23.992-23.818 0 0-23.403-8.827-22.813-20.361.59-11.534 52.086-73.381 52.086-73.381z'/%3e%3cpath fill='none' stroke='%23010002' stroke-width='3' d='M2333.695 1560.685s5.352 1.191 16.962 0'/%3e%3cpath fill='none' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M2383.303 1575.183s16.323-2.485 15.536 32.931m-25.369-24.854s14.75-1.864 13.766 32.517'/%3e%3cpath fill='none' stroke='%23010002' stroke-width='3' d='M2231.088 1500.416s7.08 1.45 11.997 7.042c4.916 5.592 14.356 4.556 14.356 4.556s-5.113-4.142-6.883-14.498-7.473-13.462-7.473-13.462m16.889-9.807s7.08 1.45 11.996 7.042 14.356 4.556 14.356 4.556-5.113-4.142-6.883-14.498-7.473-13.462-7.473-13.462m-7.128 56.562s6.182 1.266 10.474 6.149c4.293 4.882 12.535 3.978 12.535 3.978s-4.465-3.617-6.01-12.658c-1.545-9.042-6.525-11.754-6.525-11.754'/%3e%3cpath fill='%23F4C53D' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M2149.136 1676.875s5.361 23.657 23.993 21.747c0 0 13.176-1.243 12.193-23.197 0 0 19.469 10.356 22.616-15.326 0 0 17.699 4.142 17.503-19.883 0 0 16.52 2.9 14.553-18.433 0 0 17.896 4.763 17.896-15.326 0 0 41.888-6.947-45.428-86.573l-77.877 46.393 14.551 110.598z'/%3e%3cpath fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2140.483 1570.709s12.979 11.516 22.222-5.675c0 0 12.586-.621 14.553-10.148 0 0 10.227-1.036 12.193-10.77 0 0 13.963-1.45 13.57-13.255 0 0 25.385-1.96.008-30.7-25.377-28.741-68.446 47.684-68.446 47.684l5.9 22.864z'/%3e%3cpath fill='none' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M2185.322 1675.425s-1.967-41.63-38.047-101.278m60.663 85.952s5.605-24.025-45.232-95.064c0 0 5.9-16.983-12.193-27.857m74.927 103.038s1.573-25.993-48.181-85.33c0 0 4.395-15.326-13.634-27.546m76.368 94.443s-1.868-26.303-50.542-77.667c0 0 2.435-15.74-15.007-25.475m83.445 87.816s-3.54-30.031-54.868-75.596c0 0 1.77-11.805-15.34-23.818'/%3e%3cpath fill='%23F4C53D' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M2102.865 1676.875s-5.361 23.657-23.992 21.747c0 0-13.176-1.243-12.193-23.197 0 0-19.469 10.356-22.616-15.326 0 0-17.699 4.142-17.503-19.883 0 0-16.52 2.9-14.553-18.433 0 0-17.896 4.764-17.896-15.326 0 0-41.888-6.947 45.428-86.573l77.877 46.393-14.552 110.598z'/%3e%3cpath fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2111.519 1570.709s-12.979 11.516-22.223-5.674c0 0-12.586-.621-14.552-10.148 0 0-10.227-1.036-12.193-10.77 0 0-13.963-1.45-13.57-13.255 0 0-25.385-1.96-.008-30.7 25.377-28.741 68.446 47.683 68.446 47.683l-5.9 22.864z'/%3e%3cpath fill='none' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M2066.68 1675.425s1.966-41.63 38.047-101.278m-60.663 85.952s-5.605-24.025 45.232-95.064c0 0-5.9-16.983 12.193-27.856'/%3e%3cpath fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2126.001 1563.585c12.582 0 26.839 78.599 23.139 125.953-1.344 17.198-10.557 31.245-23.139 31.245s-21.795-14.047-23.139-31.245c-3.7-47.354 10.557-125.953 23.139-125.953'/%3e%3cpath fill='none' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M2026.561 1640.216s-1.573-25.993 48.182-85.33c0 0-4.395-15.326 13.634-27.546m-76.369 94.443s1.868-26.303 50.542-77.667c0 0-2.435-15.74 15.007-25.475'/%3e%3cellipse cx='2126.001' cy='1562.963' fill='%23F4C53D' stroke='%23010002' stroke-width='3' rx='17.41' ry='25.785'/%3e%3cpath fill='none' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M1994.112 1606.457s3.54-30.031 54.868-75.596c0 0-1.77-11.805 15.34-23.818'/%3e%3cpath fill='%23FFF' stroke='%23010002' stroke-width='3' d='M2126.001 1557.331s147.66-65.433 148.029-216.805h-296.058c.369 151.372 148.029 216.805 148.029 216.805z'/%3e%3cpath fill='none' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M2046.293 1340.525h22.774m-68.321 0h22.774m68.321 0h22.773'/%3e%3cpath fill='%23A60032' stroke='%23010002' stroke-width='3' d='M2000.746 1340.525v96.719s11.31 22.432 22.774 36.5v-133.219h-22.774zm45.547 0v159.435s14.242 13.965 22.774 20.697v-180.132h-22.774zm45.548 0v197.076s16.248 10.494 22.774 13.937v-211.013h-22.774z'/%3e%3cpath fill='none' stroke='%23010002' stroke-width='3' d='M2000.746 1340.525h22.774m22.773 0h22.774m22.774 0h22.773'/%3e%3cpath fill='%23A60032' stroke='%23010002' stroke-width='3' d='M2251.256 1340.525v96.719s-11.31 22.432-22.773 36.5v-133.219h22.773zm-45.548 0v159.435s-14.242 13.965-22.774 20.697v-180.132h22.774zm-45.547 0v197.076s-16.248 10.494-22.774 13.937v-211.013h22.774z'/%3e%3cpath fill='none' d='m2281.978 1703.708-13.717 16.776m-17.005-18.639 37.801 34.948'/%3e%3cpath fill='%230081C6' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='m2364.725 1614.728-5.742 23.475 15.719 15.659-22.216 93.839-19.76-26.542-29.279 13.665 22.216-93.839 20.597-5.743 5.348-23.433s6.23-2.44 13.117 2.919z'/%3e%3cpath fill='%230081C6' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='m2369.988 1599.248-11.315 21.11 11.335 19.41-44.521 84.586-12.564-31.023-31.64 5.219 44.521-84.586 21.306.067 10.924-21.177c.001 0 7.948-.017 11.954 6.394z'/%3e%3cpath fill='%230081C6' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='m2371.898 1605.387-30.096 38.235 6.898 21.598-61.447 71.871-5.615-33.205-31.943-2.411 61.447-71.871 20.746 5.113 31.924-40.59c-.001.001 8.561 4.253 8.086 11.26z'/%3e%3cpath fill='none' stroke='%23010002' stroke-width='3' d='M1597.585 1121.816s40.315 23.342 165.869 46.684m-147.973-14.582s109.115 35.594 159.93 39.968m-116.958 0s64.011 20.094 138.971 32.774m-84.351 9.093s72.322 17.371 106.849 20.255'/%3e%3cpath fill='none' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M1761.599 1269.901s61.173 12.758 76.672 14.292m-37.733 17.189s44.642 6.783 62.409 6.42m-6.951 20.711s18.05-.848 26.724-2.288m-10.008 31.284s15.34-4.142 24.386-9.941m-1.77 39.972s11.8-4.556 17.503-16.983m11.308 28.064s9.145-8.181 9.735-17.294m24.484 24.439s-3.424-2.953-1.082-15.792m-3.343-18.848s-1.77-3.676-1.18-9.475m-63.325-174.388s20.649 8.284 27.532 19.675c6.883 11.391 2.35 22.462 0 28.814-1.181 3.192-15.733 31.248 1.377 51.545m-28.614 22.058s.098-.104 7.375-2.382m-50.935-27.442s12.308 2.478 24.386 2.589m-41.397-32.931s14.455 1.45 28.024 1.243'/%3e%3cpath fill='%23369443' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M1882.877 1610.513s-.442-12.581 15.486-13.513l46.901 65.237s-1.77 4.194-23.008 3.728c0 0-2.249-.015-3.429 2.47-1.812 3.815-35.95-57.922-35.95-57.922z'/%3e%3cpath fill='none' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M1807.618 1217.501s20.846 4.142 32.056 4.349m-49.362-39.765s25.709 7.338 44.839 9.941m42.478 15.12s-18.486 17.19 3.736 33.138c0 0-9.243 14.498 9.243 29.617m-4.916 7.146s-2.753 27.646 31.072 27.648c0 0-6.49 24.647 26.156 23.819 0 0 3.736 19.676 27.336 15.74'/%3e%3cpath fill='none' stroke='%23010002' stroke-width='3' d='M1918.258 1560.685s-5.352 1.191-16.962 0'/%3e%3cpath fill='none' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M1868.651 1575.183s-16.323-2.485-15.536 32.931m25.369-24.854s-14.75-1.864-13.766 32.516'/%3e%3cpath fill='none' stroke='%23010002' stroke-width='3' d='M2020.914 1500.415s-7.08 1.45-11.996 7.042-14.356 4.556-14.356 4.556 5.113-4.142 6.883-14.498 7.473-13.462 7.473-13.462m-16.89-9.806s-7.08 1.45-11.996 7.042-14.356 4.556-14.356 4.556 5.113-4.142 6.883-14.498 7.473-13.462 7.473-13.462m7.128 56.561s-6.182 1.266-10.474 6.148c-4.293 4.883-12.535 3.978-12.535 3.978s4.465-3.617 6.01-12.659c1.545-9.042 6.525-11.754 6.525-11.754'/%3e%3cpath fill='%23162667' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M2274.03 1230.549s-72.456 37.901-148.029-3.107c-75.573 41.008-148.029 3.107-148.029 3.107v109.976h296.058v-109.976z'/%3e%3cpath fill='%230081C6' stroke='%23010002' stroke-miterlimit='10' stroke-width='3' d='M1609.306 1515.748c7.175-2.929 12.342-5.756 12.32-13.412-.005-1.825-1.019-5.863-3.055-12.114l-48.177-147.24c-2.853-8.747-5.01-13.947-6.01-15.863-2.166-4.147-6.417-5.835-12.143-8.22h61.232c-6.652 3.143-12.716 5.639-12.659 12.691.022 2.693.779 6.49 2.341 11.393l36.907 115.541 36.871-115.541c1.562-4.903 2.369-8.7 2.343-11.393-.071-7.248-6.386-9.86-12.591-12.691h59.343c-5.426 2.174-9.848 3.878-12.12 8.22-1.002 1.916-3.157 7.116-6.009 15.863l-48.177 147.24c-2.038 6.25-2.775 10.357-3.056 12.258 0 0-2.217 9.312 12.32 13.267l-59.68.001zm1026.68-15.143v-166.709c0-2.884-.476-5.095-1.425-6.634-.951-1.537-5.09-5.969-10.995-8.364h55.175c-5.906 1.955-10.046 6.706-10.995 8.292-.951 1.586-1.425 3.821-1.425 6.706v166.709c0 2.981.491 5.264 1.476 6.85.983 1.586 5.039 5.458 10.944 8.292h-55.175c5.906-2.687 10.044-6.825 10.995-8.364.949-1.536 1.425-3.797 1.425-6.778z'/%3e%3c/svg%3e";
            },
            1590: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-15 -10 30 20'%3e%3cpath fill='%23DA251d' d='M-20-15h40v30h-40z'/%3e%3cg id='b' transform='translate(0 -6)'%3e%3cpath id='a' fill='%23FF0' d='M0 0v6h4' transform='rotate(18)'/%3e%3cuse xlink:href='%23a' transform='scale(-1 1)'/%3e%3c/g%3e%3cg id='c' transform='rotate(72)'%3e%3cuse xlink:href='%23b'/%3e%3cuse xlink:href='%23b' transform='rotate(72)'/%3e%3c/g%3e%3cuse xlink:href='%23c' transform='scale(-1 1)'/%3e%3c/svg%3e";
            },
            5546: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 950 570'%3e%3cpath fill='%23d21034' d='M0 0h950v285H0z'/%3e%3cpath fill='%23009543' d='M0 285h950v285H0z'/%3e%3cpath d='m0 0 552.813 285L0 570z'/%3e%3cpath d='M0 234h950v102H0z'/%3e%3cpath fill='%23fdce12' d='M0 40.502 474.251 285 0 529.496z'/%3e%3cpath fill='%23fdce12' d='M0 270h950v30H0z'/%3e%3cpath d='M0 74.255 408.782 285 0 495.745z'/%3e%3cpath fill='%23fdce12' d='M115.481 339.524V372c28.253 0 83.7-21.65 83.7-91.356 0-69.706-59.144-82.644-76.835-82.644C104.656 198 50 210.674 50 267.706c0 57.032 53.6 62.313 64.161 62.313s50.167-9.506 45.679-52.28c0 12.146-13.73 37.758-42.511 37.758-28.78 0-46.734-21.388-46.734-42.51 0-21.124 17.426-49.376 47.79-49.376s52.543 26.931 52.543 54.128c0 27.196-21.386 61.785-55.447 61.785z'/%3e%3cg id='a' fill='%23fdce12'%3e%3cpath stroke='%23fdce12' d='m90.728 297.245 1.683 1.089s13.367-30.496 49.309-52.18c-4.555 2.475-28.615 14.456-50.992 51.091z'/%3e%3cpath d='M94.193 291.997s-4.158-8.515-.495-12.277c3.664-3.763 1.981 10 1.981 10l1.584-2.277s-2.476-10.397.297-12.575c2.772-2.178 1.386 10 1.386 10l1.683-2.178s-1.782-10.099.891-11.981c2.674-1.881.991 9.506.991 9.506l1.98-2.278s-1.485-9.604 1.782-11.881c3.268-2.278.396 9.109.396 9.109l2.178-2.376s-.99-8.813 1.783-10.793c2.772-1.98.396 8.317.396 8.317l1.98-2.079s-.594-8.218 2.079-10.099c2.674-1.882.198 7.822.198 7.822l2.08-1.981s-.495-8.218 2.871-9.802c3.366-1.584-.594 7.723-.594 7.723l2.277-1.98s.693-9.604 3.565-10.496c2.871-.891-1.287 8.516-1.287 8.516l2.079-1.684s1.089-8.218 4.257-9.208c3.169-.99-1.98 7.525-1.98 7.525l2.079-1.584s2.278-8.218 5.248-9.109c2.971-.891-3.069 7.723-3.069 7.723l1.98-1.386s3.267-7.427 5.941-7.922c2.673-.495-2.971 6.139-2.971 6.139l2.476-1.485s4.257-7.723 5.743-5.347c1.485 2.377-5.941 5.842-5.941 5.842l-2.476 1.386s9.011-4.257 10.1-2.079c1.089 2.178-12.377 3.565-12.377 3.565l-2.178 1.485s9.01-2.476 7.921-.198c-1.089 2.277-10 1.782-10 1.782l-2.08 1.485s9.01-2.178 7.822-.099c-1.188 2.079-10 1.881-10 1.881l-2.178 1.783s8.812-2.278 7.525.396c-1.288 2.673-11.288 2.574-11.288 2.574l-2.475 2.277s9.307-3.168 8.515-.693c-.792 2.476-11.387 3.763-11.387 3.763l-2.376 2.376s10-3.366 7.03-.297c-2.97 3.07-10.198 3.862-10.198 3.862l-2.872 3.465s9.902-5.941 8.515-2.574c-1.386 3.366-11.089 5.644-11.089 5.644l-1.98 2.376s8.911-5.149 8.02-2.277c-.891 2.871-10.397 5.94-10.397 5.94l-1.584 2.179s10.495-6.238 9.604-3.07c-.891 3.169-10.891 5.446-10.891 5.446l-1.287 1.98s9.703-5.544 9.802-2.871c.099 2.673-11.387 5.347-11.387 5.347l-.198-2.278z'/%3e%3c/g%3e%3cuse xlink:href='%23a' transform='matrix(-1 0 0 1 238.5 0)'/%3e%3c/svg%3e";
            },
            3301: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 150 100'%3e%3cpath fill='%23ED2939' d='M0 0h150v100H0z'/%3e%3cpath fill='%23FFF' d='M0 0h40v40H0z'/%3e%3cpath fill='%23002395' d='M0 0h20v40H0z'/%3e%3cpath fill='none' stroke='%23FFF' d='M0 40h60V0'/%3e%3cpath fill='%23FFF' d='M105 46 93 34h24zm-4 4L89 38v24zm4 4L93 66h24zm4-4 12-12v24z'/%3e%3c/svg%3e";
            },
            7170: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 2880 1440'%3e%3cdefs%3e%3cpath id='a' d='m0 0 .309.951L-.5.363h1l-.809.588z'/%3e%3c/defs%3e%3cpath fill='%23ce1126' d='M0 0h2880v1440H0z'/%3e%3cpath fill='%23002b7f' d='M0 0h1440v720H0z'/%3e%3cg fill='%23fff'%3e%3cuse xlink:href='%23a' transform='matrix(160 0 0 160 720 30)'/%3e%3cuse xlink:href='%23a' transform='matrix(160 0 0 160 500 210)'/%3e%3cuse xlink:href='%23a' transform='matrix(150 0 0 150 945 180)'/%3e%3cuse xlink:href='%23a' transform='matrix(100 0 0 100 830 364.894)'/%3e%3cuse xlink:href='%23a' transform='matrix(200 0 0 200 720 499.789)'/%3e%3c/g%3e%3c/svg%3e";
            },
            8419: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 840 600'%3e%3cpath fill='%23244aa5' d='M0 0h840v600H0z'/%3e%3cpath fill='%23d0a650' d='M424.541 190.135c3.515 4.101 5.868 8.2 5.868 13.185-2.951 1.459-7.028 2.054-9.381 4.69 14.651-2.055 17.57 14.934 33.978 8.487.596 2.353 2.95 4.407 5.867 3.519l1.757-4.68c6.432-1.756 4.675 8.785 11.731 6.73 3.517 2.934 1.164 7.907 3.517 11.437 0 4.094 1.758 7.608 3.513 11.122 1.759-2.04 2.92-4.974 7.028-4.095 2.919 3.217 5.272 6.15 5.865 9.664-1.19 6.745-2.947 12.596 4.08 16.11v2.054c4.707 2.055 15.249-2.054 15.249 6.15-.598 2.934 2.917.298 4.109 2.055 2.919-1.177 7.028-.58 10.541-.58 2.919 6.15-3.513 10.541-5.27 16.11 2.917 2.919 1.757 8.204 1.161 11.702l-1.758.879c4.675.878 10.54-.565 14.652 2.07l7.624 2.918c3.513-2.038 7.593-2.352 12.298-2.038 3.514 2.636-1.191 7.027 1.758 9.067 4.11 0 7.624.597 8.189 4.111l.595 1.16c2.919-5.271 11.138-1.758 14.653-5.552 5.866 0 7.026 6.432 9.944 9.946 1.193 9.097-9.944 13.209-6.431 22.275-2.353 4.391-7.028 7.907-10.541 12.016 1.16.596.564 2.04.564 2.918-3.514 2.071-.564 8.22-5.271 8.787-.565 3.826-7.593 2.352-5.27 6.46 4.704 6.15-2.323 9.947-2.323 15.531-2.95 3.231-8.816-2.95-8.816 3.231-3.514.878-7.027-3.23-9.35.284-1.19 4.11 2.323 5.553 1.758 9.663 5.836-.597 7.593 5.27 9.946 8.785l5.867 5.866c-5.867 4.675-13.491-.597-20.52 2.039-1.757-.878 0-3.2-1.757-4.078-1.758-2.072-5.27-2.072-8.189-2.638.565 2.638-4.705 3.515-2.352 6.715 0 .878 1.16 3.514-1.162 3.514-4.706 1.475-4.11-4.078-8.22-2.04-5.27 2.04-1.16 9.947-8.784 9.068 1.16 7.06-11.703 11.735-2.919 17.884 1.16 1.162.565 3.514.565 5.27-5.272 4.707-14.623 2.95-20.488 1.192-4.706-1.191-1.757-7.058-3.513-10.258-1.758-2.95-7.028-4.989-7.028-9.099-3.517-1.445-6.463-2.35-8.816-5.271-8.188 7.906-18.163 15.53-29.869 15.812-5.27 2.636-8.219 13.21-16.408 8.815-3.216 5.273-12.895 0-13.476 7.595-3.812 1.474-2.055 6.462-4.392 8.784-.879 5.866 0 10.854 4.973 14.37 2.054 4.391-4.393 4.391-1.758 8.503.597 1.444 0 3.513-.878 4.109-1.757.878-2.337 1.758-1.757 3.514-1.459 0-2.053.878-3.216 2.039-1.475 2.918-6.15 4.392-9.38 6.432-3.217.878-5.57-1.444-7.61-3.514-.596 3.231-3.23 4.989-6.446 4.989-4.691 0-3.812-4.11-7.327-5.867 1.46-5.271-3.23-7.593-1.757-12.3 3.811-2.917 10.244-4.987 8.487-11.136-4.094-4.958-2.635-12.3-6.73-18.166-2.635-2.322-7.027-5.835-5.569-11.42 3.812-4.392 0-9.663-2.054-14.338-.878-3.827-3.216-7.34-3.216-11.734-6.447-3.796-6.746-13.773-15.828-14.651-6.447 0-7.608-8.19-14.056-7.625-.595-1.16-2.054-2.038-3.23-3.2-4.675 3.2-10.542-.878-16.394.565-3.812-6.432 3.216-15.217-7.043-19.045v-4.078c1.177.564 1.757-.598 2.055-1.193.58-4.392-7.327-4.957-4.094-9.946-1.758-1.474-3.812-2.07-2.636-4.988-4.407-9.068-17.585-8.189-20.518-17.287 2.352-2.038 2.352-4.11 3.232-5.866-2.056-3.515-2.636-7.311-2.056-11.107 2.056-.597 3.216-3.231 4.393-5.303-2.636-1.756-5.853-4.391-8.786-3.513-5.27-.878-9.083-4.957-13.773-7.31-1.176-1.162-.58-3.231-.58-4.675 6.447-2.072-.878-11.154 7.028-9.977 2.056-2.635 6.447-3.514 9.665-5.569 3.23-.58 5.866.596 9.082 1.475 2.635 3.499 7.326 2.04 9.96 4.972 2.636-.595 5.868-2.055 9.084-.595 0-4.974 2.338-7.907 5.866-11.422.58-2.04 3.797-3.513 6.432-4.675 4.99 1.162 10.84 1.162 14.37-2.353 2.338 1.474 4.393-1.458 7.028-1.458 3.215-.596 5.851.282 8.204 1.757.283-5.868 10.541-.88 12.597-7.907 2.338-4.691-6.447-6.447-5.867-10.557-1.46-4.691 2.055-7.028 3.811-10.244 2.055-.88 4.393-2.055 7.028-1.475 6.746-2.338 1.474-16.11 12.315-11.122 0 1.46-.596 3.216.282 3.514 3.812 0 4.397-4.396 7.044-5.866 1.16-4.094-1.474-9.082 2.04-12.3 1.757-.297 3.23-.877 4.392-2.352 0-3.216-1.757-4.972-4.393-7.028-.878 1.464-3.216.298-4.686.88 0-3.515-2.044-5.852-2.64-9.084-1.757-.878-2.635-2.337-2.04-4.393 2.636-2.635 0-9.082 6.15-7.62 2.338-2.043 6.447-.584 8.785-4.099 6.15-3.513 14.353-3.513 19.044-9.96 2.055.297 4.393-1.757 6.447 0 .582 3.81 6.151 2.336 6.151 5.858'/%3e%3cpath fill='%23fff' d='m469.9 110.7-8.1-24.9-8 24.9h-26.2l21.2 15.4-8.1 24.9 21.1-15.4L483 151l-8.1-24.9 21.2-15.4zm82.4 14.5-8.1-24.8-8 24.8H510l21.2 15.4-8.1 24.9 21.1-15.4 21.2 15.4-8.1-24.9 21.2-15.4zm78.6 28.6-8-24.8-8.1 24.8h-26.2l21.2 15.4-8.1 24.9 21.2-15.4 21.1 15.4-8.1-24.9 21.2-15.4zm-244.7-43.1-8-24.9-8.1 24.9h-26.2l21.2 15.4L357 151l21.2-15.4 21.1 15.4-8.1-24.9 21.2-15.4zm-82.4 14.5-8-24.8-8.1 24.8h-26.2l21.2 15.4-8.1 24.9 21.2-15.4 21.1 15.4-8.1-24.9 21.2-15.4zm-78.6 28.6-8.1-24.8-8 24.8h-26.2l21.2 15.4-8.1 24.9 21.1-15.4 21.2 15.4-8.1-24.9 21.2-15.4z'/%3e%3c/svg%3e";
            },
            8274: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 450 300'%3e%3cpath d='M0 0h450v300H0z'/%3e%3cpath fill='%23FFF' d='M0 0h450v200H0z'/%3e%3cpath fill='%23CE1126' d='M0 0h450v100H0z'/%3e%3c/svg%3e";
            },
            2699: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 900 600'%3e%3cpath fill='%23ED2939' d='M0 0h900v600H0z'/%3e%3cpath fill='%23fff' d='M0 0h600v600H0z'/%3e%3cpath fill='%23002395' d='M0 0h300v600H0z'/%3e%3c/svg%3e";
            },
            9638: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 9 6'%3e%3cclipPath id='c'%3e%3cpath id='b' d='m0 0 4.5 3L0 6'/%3e%3c/clipPath%3e%3cclipPath id='a'%3e%3cpath d='M0 0h9v6H0z'/%3e%3c/clipPath%3e%3cg clip-path='url(%23a)'%3e%3cpath fill='%23001489' d='M0 0v6h9V0z'/%3e%3cpath fill='%23e03c31' d='M0 0v3h9V0z'/%3e%3cg stroke='%23fff' stroke-width='2'%3e%3cpath id='d' d='m0 0 4.5 3L0 6m4.5-3H9'/%3e%3cuse xlink:href='%23b' stroke='%23ffb81c' clip-path='url(%23c)'/%3e%3c/g%3e%3cuse xlink:href='%23d' fill='none' stroke='%23007749' stroke-width='1.2'/%3e%3c/g%3e%3c/svg%3e";
            },
            6320: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2100 1400'%3e%3cpath fill='%23198a00' d='M0 0h2100v1400H0z'/%3e%3cpath fill='%23ef7d00' d='M1850 500h250v900h-250z'/%3e%3cpath d='M1600 500h250v900h-250z'/%3e%3cpath fill='%23de2010' d='M1350 500h250v900h-250z'/%3e%3cg fill='%23ef7d00' stroke='%23000' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.25'%3e%3cpath d='M1916.425 168.334s86.002-33.706 94.334-40.656c3.79 4.17-34.476 46.564-108.731 62.2 67.435-14.594 125.023-60.462 136.768-59.072 3.41.695 2.65 44.826-151.923 83.05 106.837-25.715 168.97-72.973 168.213-67.76.757 1.042-10.608 37.18-104.185 65.327 26.141-5.56 96.987-45.174 96.23-37.529 2.272 3.128-68.574 86.524-196.627 59.421 102.292 24.324 168.59-34.402 178.062-33.36 1.895.348-18.944 51.429-147.753 54.556 61.755-5.907 43.946-.348 43.946-.348s-36.37 26.061-80.317 8.341c34.476 8.688 38.264 9.034 39.021 11.814-2.272 3.474-30.687 8.687-57.964-4.866 21.973 8.34 41.674 9.73 42.052 12.858-.378 1.042-14.395 8.34-26.897 3.128-12.502-5.214-127.676-70.193-127.676-70.193l196.249-49.343zm-230.712 175.771c-17.257 0-17.734 14.085-17.734 14.085s-1.424 1.017-.474 7.844c2.85-4.649 4.275-6.1 4.275-6.1 1.9.29 9.816 2.468 22.324-6.535-11.4 10.89-4.59 14.957-4.59 14.957s-2.692 8.568 6.014 10.311c-2.69-3.486-1.107-6.535-1.107-6.535s12.19-1.161 11.4-14.811c.475 12.341 7.758 15.391 7.758 15.391s0 6.825 7.915 7.407c-4.273-3.486-3.325-8.859-3.325-8.859s10.292-6.825 1.584-18.443c5.225-2.76 9.5-10.455 9.5-10.455s-7.124-2.76-10.449-5.082c-1.585-3.051-.158-19.75-.158-19.75l-4.276-21.639-12.192 33.693c.474-4.793.792 14.521-16.465 14.521z'/%3e%3cpath d='M1770.944 295.514c.378.348 12.882 13.206 25.004 12.51 4.545-3.474-9.472-11.119-9.472-12.857 4.925 4.17 25.762 20.501 39.023 14.594 5.303-6.95-9.472-5.906-25.763-24.671 11.365 6.95 39.78 22.239 53.04 16.332 5.685-5.56-29.551-22.936-41.296-36.487l-30.307-14.246-41.296 30.927zm-46.599-105.635s14.017-7.645 70.088-3.823c6.062.695 38.264-10.077 48.494-13.204 16.29-2.78 68.193-13.205 82.212-22.935 9.85-1.042-2.654 16.68-15.154 20.85-13.262 5.56-61.376 20.849-78.425 18.764 20.459.348 9.094 15.637-25.005 8.34 16.292 8.34 10.23 9.73 10.23 9.73s-28.792 1.39-36.37-4.518c19.323 6.602 11.366 9.035 11.366 9.035s-19.7 1.737-28.794-2.085c14.017 3.822 6.82 6.255 6.82 6.255s-11.365 1.737-20.837-1.39c-9.47-3.128-23.868-25.02-24.625-25.02zm22.482 112.837 2.06 33.982s-1.11 1.743-2.06 2.76c-.95 1.016-26.283-3.632-22.8 14.085 0 7.262.16 9.149 5.543 13.215-1.426-4.792-.95-8.131-.95-8.131s7.124 3.921 14.091-6.825c-4.75 10.6-1.426 14.376-.317 14.667 1.109 1.889-1.899 10.455 7.6 10.31-3.64-3.195-1.9-7.843-1.9-7.843s9.976-1.45 6.492-18.006c3.642-3.34 5.066-.145 5.066-.145s1.108 9.874 9.816 7.842c3.96 2.032-.632 7.405-.632 7.405s6.332.146 8.232-4.792c1.9-4.937 4.117-13.796-6.334-17.426-1.266-3.484 4.118-3.775 4.118-3.775s6.65 2.032 8.549 5.082c1.9 3.05 1.267-7.986-6.966-9.149-10.133-.291-10.766-2.178-10.766-2.613 0-.437-1.741-24.687-2.533-31.658z'/%3e%3cpath d='M1782.069 331.675c.124-1.558-17.286-23.059-12.869-25.838 4.415.833 11.656 10.613 17.522 7.438-1.778-3.811-7.018-1.665-12.97-11.423-5.948-11.032-6.817-27.593-27.654-45.658 13.49 19.116 44.092 30.322 45.388 24.748 1.296-5.575-26.946-26.653-25.5-31.733 5.617 10.433 33.975 33.678 54.868 31.753 1.432-4.475-17.11-13.508-21.881-21.942-13.347-8.224-49.065-36.462-49.78-43.011-12.998-17.387-21.111-22.647-24.89-24.65-1.46-1.577-1.826-3.085-2.112-4.044-8.068-17.446 2.619-23.11 8.874-23.949 5.147-.524 6.642.182 10.346-1.463-4.386-1.574-8.77-3.046-13.156-4.62 5.719 3.848 20.325.46 17.16 11.542 6.403-2.235 20.03-17.104-15.444-20.46-11.545-12.147-59.009-19.128-70.89 33.888.95.743 1.446 1.354 4.465 3.422-14.989-6.663-55.421-11.802-69.992-13.961-39.364-10.417-80.244-35.52-84.174-32.433-5.256 2.14 23.784 26.92 22.274 27.468-25.18-13.466-48.182-23.006-69.585-31.687-15.058-5.163-30.14-17.182-31.802-14.896-5.542 10.53 24.14 36.996 29.662 40.11 5.523 2.978 48.947 21.453 48.307 21.684-65.406-27.229-76.372-32.165-79.654-35.305-5.764-1.19-19.807-18.581-23.72-17.463-2.143 1.93 2.154 29.41 33.364 41.744 5.087 3.4 66.9 23.739 66.295 25.333-.15.399-70.798-26.743-73.542-27.714-13.621-4.899-30.334-22.07-33.459-20.14-2.982 1.753 7.705 20.339 21.468 26.168 7.215 2.92 34.887 15.492 59.819 23.493 1.591.527-44.815-16.141-67.126-24.693-10.116-5.15-14.88-11.568-16.42-10.187-2.28 1.38 3.682 28.837 75.38 44.33 1.888.737 25.237-5.074 24.083-4.303-.289.193-23.186 4.765-25.415 4.608-1.984-.278-14.528 1.362-14.755 1.959-.758 1.857 4.545 11.688 41.564 9.638 4.733-.261 30.416-8.579 28.258-6.79-1.08.896-34.973 10.997-37.554 11.196-2.242.291-14.15 1.433-14.59 2.595-.537 1.584 8.814 8.58 28.694 9.702 17.602.857 51.05-9.865 50.378-9.17-.67.695-32.244 10.618-33.07 11.223-1.142.593-12.704 1.168-13.11 1.982-.942 2.026 16.678 17.138 68.787 1.01-5.235 6.486-30.493 10.921-30.457 12.09-.117.847 5.565 5.882 14.396 7.684 4.415.9 10.46.717 15.982-.083 9.918-1.821 20.37-5.42 33.65-16.678 1.587 3.533-33.174 19.668-31.542 21.207 7.537 6.41 32.576-.827 34.216-1.667 1.641-.842 48.215-24.93 48.055-27.718.723 3.573-60.046 33.859-59.39 35.101 3.9 5.71 24.66-.3 25.652-.825.99-.523 26.493-13.16 27.192-13.532.697-.373-29.973 16.464-27.24 19.027-1.321 10.933 47.898-7.546 51.755-9.847 1.929-1.15-23.644 10.313-23.712 15.759 8.235 12.77 34.603 8.719 38.67 5.91 2.035-1.405-2.393 9.486-.967 8.497.497-.205 5.735-5.886 7.75-9.998-.643 3.568-3.534 9.189-5.22 15.638-1.69 6.449-2.173 13.726-4.49 21.458-.532 3.396 16.247-6.64 13.81-30.631 1.436 12.479-5.299 35.813-3.536 37.026 3.525 2.426 13.27-11.621 14.255-21.12 2.894 4.798 8.968 14.813 14.193 17.117-.569-7.258.1-6.925-2.252-14.059 1.357-9.47 1.546-22.578 1.874-37.38 14.199 24.948 19.862 35.483 15.895 54.588 4.222 1.615 10.966-13.335 10.422-21.03 5.422 21.381 28.825 24.587 29.197 23.965z'/%3e%3cpath d='M1545.575 173.288s-9.664 6.697-21.69 6.303c3.006 11.03 27.918 2.56 27.918 2.56s-12.027 12.213-20.617 14.183c5.154 3.94 26.845 2.56 30.497.591 3.65-1.97 10.093-9.652 10.093-9.652s-22.335 23.637-25.557 23.44c-.43 2.758 23.41 1.773 28.35-2.363 4.938-4.137 17.394-10.243 17.394-10.243s-32.643 20.88-34.147 20.88c12.241 2.954 36.724-3.546 52.402-12.41-23.195 14.182-25.34 16.743-37.153 21.47 10.524 2.167 15.89 8.668 51.542-5.515 20.403-8.864 31.998-25.016 31.998-25.016-12.67 15.561-32.644 28.76-54.762 41.76-1.29 2.363 23.622 12.014 55.406-18.32m60.992 18.122s2.148 9.258 10.738 16.35c8.592 7.09 9.236 13.984 9.236 13.984m-24.268-90.609s3.006 8.273 11.811 13.592c9.02 5.318 22.552 22.06 23.625 25.016 1.04 3.576 6.227 29.35 5.798 32.106'/%3e%3cpath d='M1659.184 191.606c.644 3.152-12.672 19.107 5.582 37.82-16.537 18.515-16.535 20.88-16.535 20.88s9.234 4.727 25.77-8.274c27.274 30.73 18.186 44.792 18.186 44.792'/%3e%3cpath d='M1690.014 265.13s-2.512-3.3 1.967-15.626c4.033 4.456 8.518 5.407 10.484 7.211 1.965 1.804 22.558 4.538 23.867 17.16m-12.109-124.443c0-.927-4.147-9.088-19.616 1.113 8.29.464 16.48 4.822 19.616-1.113zm147.646 37.319c.757.348 46.22 9.382 61.375 4.865-19.322 23.63-57.965 7.645-57.965 7.645 18.942 5.212 19.701 4.865 25.761 9.73 1.895 4.517-34.854 2.432-46.978-3.823 33.719 9.73 34.476 9.035 35.614 12.857 1.517 5.212-55.314-1.39-60.239-8.34 15.155 10.772 23.49 12.857 31.824 17.722-10.23 4.17-29.171 8.339-64.027-14.247 45.84 38.224 87.137 35.79 93.579 42.74-15.912 21.545-77.667-12.856-106.082-30.23-28.414-17.375 62.133 42.046 70.47 41.003-4.17 5.907-34.098.695-35.993-2.085'/%3e%3cpath d='M1873.613 226.712c-5.302.695-21.214.695-23.487.348m-317.866-60.076s34.576 16.743 49.18 15.562c-3.866 3.348-9.666 4.727-9.666 4.727 3.652 1.379 13.746 6.303 28.995 3.152-3.652 3.348-8.377 7.091-8.377 7.091s13.101 4.53 27.92-2.56c-4.51 5.12-7.089 8.863-7.089 8.863l10.31.591'/%3e%3c/g%3e%3c/svg%3e";
            },
            7064: (c)=>{
                c.exports = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 252 126'%3e%3cpath fill='%23319208' d='M0 0h252v126H0z'/%3e%3cpath fill='%23FFD200' d='M0 18h252v90H0z'/%3e%3cpath fill='%23DE2010' d='M0 36h252v54H0z'/%3e%3cpath d='M0 54h252v18H0z'/%3e%3cpath d='m4.583 0 84 63-84 63H0V0h4.583z'/%3e%3cpath fill='%23FFF' d='m0 0 84 63-84 63'/%3e%3cpath fill='%23DE2010' d='m46.161 66.045 18.273-12.934-21.029-3.055L34 31l-9.405 19.056-21.029 3.055 18.273 12.934-4.003 19.203L34 76l16.164 9.248z'/%3e%3cpath fill='%23FFC618' d='M28.635 55.109c1.976 4.305 2.47 4.588 7.411 6.282 4.94 1.694 18.898 3.3 20.274 3.458-.9-.9-16.621-12.545-19.85-14.875-3.229-2.329-4.129-3.388-4.129-3.388s-2.911-5.24-3.917-6.776c-1.006-1.535-2.858-3.705-5.293-3.705s-3.917 1.429-4.623 3.97c-.388.106-2.47 1.376-2.4 2.682.6-.071 4.376-1.129 5.682 3.141s1.376 11.257.035 14.716c-1.341 3.459-3.423 6.07-3.423 9.105 0 .423.282 1.27.988 1.27.247 1.341 2.223 10.904 2.223 10.904h28.161l4.473-17.292'/%3e%3cg fill='none' stroke='%23000' stroke-width='.212'%3e%3cpath d='M28.635 55.109c1.976 4.305 2.47 4.588 7.411 6.282 4.94 1.694 18.898 3.3 20.274 3.458-.9-.9-16.621-12.545-19.85-14.875-3.229-2.329-4.129-3.388-4.129-3.388s-2.911-5.24-3.917-6.776c-1.006-1.535-2.858-3.705-5.293-3.705s-3.917 1.429-4.623 3.97c-.388.106-2.47 1.376-2.4 2.682.6-.071 4.376-1.129 5.682 3.141s1.376 11.257.035 14.716c-1.341 3.459-3.423 6.07-3.423 9.105 0 .423.282 1.27.988 1.27.247 1.341 2.223 10.904 2.223 10.904h28.161l4.473-17.292'/%3e%3cpath d='M19.39 70.99s5.999-.353 7.623-.353c1.623 0 16.734.019 25.165 1.968'/%3e%3cpath d='M21.508 70.871s-.601-.728-.213-2.175c.388-1.447 4.623-5.188 4.623-10.481m-.776 12.422s-.494-2.364 4.905-4.376c1.518-.459 5.858-2.894 5.999-4.87'/%3e%3cpath d='M29.473 66.485s13.243.058 23.724 2.175m-20.404-3.755s4.551.156 5.292-.056c.741-.212 2.053-.762 2.575-2.313'/%3e%3cpath d='M35.49 64.959s2.434-1.265 2.911-2.911m-10.26 19.846s-1.041-7.216-1.253-11.257l2.717 2.594 2.875-2.514 2.472 2.638 2.858-2.425 2.471 2.778 2.83-2.407 2.252 2.618 2.822-2.041 3.355 3.189'/%3e%3cpath d='M50.951 77.345c-10.081-1.444-23.57-1.35-23.57-1.35m-4.687-24.943s8.2-3.918 9.647-4.465'/%3e%3c/g%3e%3cg fill='none' stroke='%23000' transform='translate(16 36) scale(.21174)'%3e%3cpath d='m52.487 177.086 13.018 11.852 11.762-11.762 11.896 12.266 12.846-11.358 11.827 12.43 13.339-11.013 10.897 12.728 13.27-10.145 13.947 12.319'/%3e%3ccircle cx='89.425' cy='154.584' r='5.167'/%3e%3ccircle cx='111.237' cy='156.047' r='5.167'/%3e%3ccircle cx='30.05' cy='16.5' r='4'/%3e%3c/g%3e%3c/svg%3e";
            },
            8156: (a)=>{
                "use strict";
                a.exports = c;
            }
        }, e = {};
        function i(c) {
            var o = e[c];
            if (void 0 !== o) return o.exports;
            var l = e[c] = {
                exports: {}
            };
            return a[c](l, l.exports, i), l.exports;
        }
        i.n = (c)=>{
            var a = c && c.__esModule ? ()=>c.default : ()=>c;
            return i.d(a, {
                a: a
            }), a;
        }, i.d = (c, a)=>{
            for(var e in a)i.o(a, e) && !i.o(c, e) && Object.defineProperty(c, e, {
                enumerable: !0,
                get: a[e]
            });
        }, i.o = (c, a)=>Object.prototype.hasOwnProperty.call(c, a), i.r = (c)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(c, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(c, "__esModule", {
                value: !0
            });
        };
        var o = {};
        return (()=>{
            "use strict";
            i.r(o), i.d(o, {
                default: ()=>Tm
            });
            var c = i(8156), a = i.n(c), e = i(3630), l = i.n(e), n = i(8679), t = i.n(n), m = i(133), s = i.n(m), r = i(6772), f = i.n(r), d = i(5897), h = i.n(d), p = i(1648), k = i.n(p), u = i(9263), z = i.n(u), g = i(1426), M = i.n(g), v = i(1195), b = i.n(v), w = i(6448), x = i.n(w), y = i(8512), S = i.n(y), R = i(3928), A = i.n(R), B = i(5611), C = i.n(B), F = i(1791), j = i.n(F), H = i(3875), G = i.n(H), P = i(3170), K = i.n(P), T = i(1477), E = i.n(T), N = i(4324), L = i.n(N), I = i(2594), U = i.n(I), V = i(768), D = i.n(V), q = i(8194), O = i.n(q), Z = i(3121), J = i.n(Z), _ = i(1096), W = i.n(_), Y = i(9197), $ = i.n(Y), Q = i(744), X = i.n(Q), cc = i(7709), ac = i.n(cc), ec = i(2603), ic = i.n(ec), oc = i(9704), lc = i.n(oc), nc = i(6576), tc = i.n(nc), mc = i(7184), sc = i.n(mc), rc = i(5779), fc = i.n(rc), dc = i(6902), hc = i.n(dc), pc = i(2823), kc = i.n(pc), uc = i(9301), zc = i.n(uc), gc = i(988), Mc = i.n(gc), vc = i(4827), bc = i.n(vc), wc = i(6783), xc = i.n(wc), yc = i(4790), Sc = i.n(yc), Rc = i(1022), Ac = i.n(Rc), Bc = i(957), Cc = i.n(Bc), Fc = i(2867), jc = i.n(Fc), Hc = i(2882), Gc = i.n(Hc), Pc = i(956), Kc = i.n(Pc), Tc = i(2857), Ec = i.n(Tc), Nc = i(7464), Lc = i.n(Nc), Ic = i(4039), Uc = i.n(Ic), Vc = i(5294), Dc = i.n(Vc), qc = i(4564), Oc = i.n(qc), Zc = i(2170), Jc = i.n(Zc), _c = i(7160), Wc = i.n(_c), Yc = i(1516), $c = i.n(Yc), Qc = i(2440), Xc = i.n(Qc), ca = i(2177), aa = i.n(ca), ea = i(8168), ia = i.n(ea), oa = i(7628), la = i.n(oa), na = i(3250), ta = i.n(na), ma = i(49), sa = i.n(ma), ra = i(7558), fa = i.n(ra), da = i(540), ha = i.n(da), pa = i(8280), ka = i.n(pa), ua = i(4944), za = i.n(ua), ga = i(7316), Ma = i.n(ga), va = i(5606), ba = i.n(va), wa = i(734), xa = i.n(wa), ya = i(9927), Sa = i.n(ya), Ra = i(5174), Aa = i.n(Ra), Ba = i(346), Ca = i.n(Ba), Fa = i(3553), ja = i.n(Fa), Ha = i(1934), Ga = i.n(Ha), Pa = i(4178), Ka = i.n(Pa), Ta = i(4617), Ea = i.n(Ta), Na = i(9314), La = i.n(Na), Ia = i(5916), Ua = i.n(Ia), Va = i(7971), Da = i.n(Va), qa = i(2883), Oa = i.n(qa), Za = i(2619), Ja = i.n(Za), _a = i(9206), Wa = i.n(_a), Ya = i(9297), $a = i.n(Ya), Qa = i(4170), Xa = i.n(Qa), ce = i(9488), ae = i.n(ce), ee = i(3782), ie = i.n(ee), oe = i(1365), le = i.n(oe), ne = i(5564), te = i.n(ne), me = i(1898), se = i.n(me), re = i(5676), fe = i.n(re), de = i(9209), he = i.n(de), pe = i(9654), ke = i.n(pe), ue = i(3426), ze = i.n(ue), ge = i(3983), Me = i.n(ge), ve = i(9860), be = i.n(ve), we = i(3671), xe = i.n(we), ye = i(5948), Se = i.n(ye), Re = i(3797), Ae = i.n(Re), Be = i(1836), Ce = i.n(Be), Fe = i(8281), je = i.n(Fe), He = i(4273), Ge = i.n(He), Pe = i(4523), Ke = i.n(Pe), Te = i(6296), Ee = i.n(Te), Ne = i(2203), Le = i.n(Ne), Ie = i(5418), Ue = i.n(Ie), Ve = i(9588), De = i.n(Ve), qe = i(6382), Oe = i.n(qe), Ze = i(5220), Je = i.n(Ze), _e = i(1276), We = i.n(_e), Ye = i(2032), $e = i.n(Ye), Qe = i(7710), Xe = i.n(Qe), ci = i(2126), ai = i.n(ci), ei = i(7884), ii = i.n(ei), oi = i(9571), li = i.n(oi), ni = i(2509), ti = i.n(ni), mi = i(2908), si = i.n(mi), ri = i(141), fi = i.n(ri), di = i(8247), hi = i.n(di), pi = i(9339), ki = i.n(pi), ui = i(74), zi = i.n(ui), gi = i(8451), Mi = i.n(gi), vi = i(2306), bi = i.n(vi), wi = i(6413), xi = i.n(wi), yi = i(9191), Si = i.n(yi), Ri = i(3923), Ai = i.n(Ri), Bi = i(6755), Ci = i.n(Bi), Fi = i(3867), ji = i.n(Fi), Hi = i(3108), Gi = i.n(Hi), Pi = i(9584), Ki = i.n(Pi), Ti = i(740), Ei = i.n(Ti), Ni = i(1552), Li = i.n(Ni), Ii = i(4848), Ui = i.n(Ii), Vi = i(9831), Di = i.n(Vi), qi = i(970), Oi = i.n(qi), Zi = i(3941), Ji = i.n(Zi), _i = i(3025), Wi = i.n(_i), Yi = i(5984), $i = i.n(Yi), Qi = i(2012), Xi = i.n(Qi), co = i(9875), ao = i.n(co), eo = i(325), io = i.n(eo), oo = i(1616), lo = i.n(oo), no = i(7073), to = i.n(no), mo = i(7192), so = i.n(mo), ro = i(6906), fo = i.n(ro), ho = i(9207), po = i.n(ho), ko = i(5590), uo = i.n(ko), zo = i(1084), go = i.n(zo), Mo = i(3365), vo = i.n(Mo), bo = i(6072), wo = i.n(bo), xo = i(4399), yo = i.n(xo), So = i(6249), Ro = i.n(So), Ao = i(82), Bo = i.n(Ao), Co = i(3675), Fo = i.n(Co), jo = i(8562), Ho = i.n(jo), Go = i(8006), Po = i.n(Go), Ko = i(3692), To = i.n(Ko), Eo = i(9086), No = i.n(Eo), Lo = i(4158), Io = i.n(Lo), Uo = i(2914), Vo = i.n(Uo), Do = i(8787), qo = i.n(Do), Oo = i(8125), Zo = i.n(Oo), Jo = i(1727), _o = i.n(Jo), Wo = i(8643), Yo = i.n(Wo), $o = i(7698), Qo = i.n($o), Xo = i(6550), cl = i.n(Xo), al = i(9709), el = i.n(al), il = i(448), ol = i.n(il), ll = i(7925), nl = i.n(ll), tl = i(7758), ml = i.n(tl), sl = i(1598), rl = i.n(sl), fl = i(6329), dl = i.n(fl), hl = i(4860), pl = i.n(hl), kl = i(3309), ul = i.n(kl), zl = i(6376), gl = i.n(zl), Ml = i(476), vl = i.n(Ml), bl = i(886), wl = i.n(bl), xl = i(6829), yl = i.n(xl), Sl = i(2888), Rl = i.n(Sl), Al = i(8556), Bl = i.n(Al), Cl = i(5649), Fl = i.n(Cl), jl = i(7923), Hl = i.n(jl), Gl = i(1606), Pl = i.n(Gl), Kl = i(268), Tl = i.n(Kl), El = i(3172), Nl = i.n(El), Ll = i(5385), Il = i.n(Ll), Ul = i(9778), Vl = i.n(Ul), Dl = i(9305), ql = i.n(Dl), Ol = i(6015), Zl = i.n(Ol), Jl = i(675), _l = i.n(Jl), Wl = i(7254), Yl = i.n(Wl), $l = i(2282), Ql = i.n($l), Xl = i(9761), cn = i.n(Xl), an = i(3642), en = i.n(an), on = i(5711), ln = i.n(on), nn = i(9668), tn = i.n(nn), mn = i(6103), sn = i.n(mn), rn = i(6475), fn = i.n(rn), dn = i(3913), hn = i.n(dn), pn = i(3915), kn = i.n(pn), un = i(3886), zn = i.n(un), gn = i(7357), Mn = i.n(gn), vn = i(6517), bn = i.n(vn), wn = i(950), xn = i.n(wn), yn = i(4707), Sn = i.n(yn), Rn = i(4520), An = i.n(Rn), Bn = i(9228), Cn = i.n(Bn), Fn = i(9230), jn = i.n(Fn), Hn = i(5738), Gn = i.n(Hn), Pn = i(8623), Kn = i.n(Pn), Tn = i(3226), En = i.n(Tn), Nn = i(2775), Ln = i.n(Nn), In = i(4989), Un = i.n(In), Vn = i(5299), Dn = i.n(Vn), qn = i(5084), On = i.n(qn), Zn = i(694), Jn = i.n(Zn), _n = i(9924), Wn = i.n(_n), Yn = i(1950), $n = i.n(Yn), Qn = i(3071), Xn = i.n(Qn), ct = i(1336), at = i.n(ct), et = i(2538), it = i.n(et), ot = i(3908), lt = i.n(ot), nt = i(2906), tt = i.n(nt), mt = i(5862), st = i.n(mt), rt = i(6324), ft = i.n(rt), dt = i(4524), ht = i.n(dt), pt = i(2346), kt = i.n(pt), ut = i(9418), zt = i.n(ut), gt = i(3969), Mt = i.n(gt), vt = i(9493), bt = i.n(vt), wt = i(5437), xt = i.n(wt), yt = i(7238), St = i.n(yt), Rt = i(7246), At = i.n(Rt), Bt = i(4698), Ct = i.n(Bt), Ft = i(8736), jt = i.n(Ft), Ht = i(2439), Gt = i.n(Ht), Pt = i(1900), Kt = i.n(Pt), Tt = i(8627), Et = i.n(Tt), Nt = i(6754), Lt = i.n(Nt), It = i(8065), Ut = i.n(It), Vt = i(5454), Dt = i.n(Vt), qt = i(8505), Ot = i.n(qt), Zt = i(8855), Jt = i.n(Zt), _t = i(7639), Wt = i.n(_t), Yt = i(3945), $t = i.n(Yt), Qt = i(603), Xt = i.n(Qt), cm = i(814), am = i.n(cm), em = i(793), im = i.n(em), om = i(4261), lm = i.n(om), nm = i(8574), tm = i.n(nm), mm = i(8728), sm = i.n(mm), rm = i(3545), fm = i.n(rm), dm = i(1590), hm = i.n(dm), pm = i(5546), km = i.n(pm), um = i(3301), zm = i.n(um), gm = i(8419), Mm = i.n(gm), vm = i(7170), bm = i.n(vm), wm = i(8274), xm = i.n(wm), ym = i(2699), Sm = i.n(ym), Rm = i(9638), Am = i.n(Rm), Bm = i(6320), Cm = i.n(Bm), Fm = i(7064), jm = i.n(Fm);
            const Hm = {
                flag_AD: l(),
                flag_AE: t(),
                flag_AF: s(),
                flag_AG: f(),
                flag_AI: h(),
                flag_AL: k(),
                flag_AM: z(),
                flag_AN: M(),
                flag_AO: b(),
                flag_AQ: x(),
                flag_AR: S(),
                flag_AS: A(),
                flag_AT: C(),
                flag_AU: j(),
                flag_AW: G(),
                flag_AX: K(),
                flag_AZ: E(),
                flag_BA: L(),
                flag_BB: U(),
                flag_BD: D(),
                flag_BE: O(),
                flag_BF: J(),
                flag_BG: W(),
                flag_BH: $(),
                flag_BI: X(),
                flag_BJ: ac(),
                flag_BL: ic(),
                flag_BM: lc(),
                flag_BN: tc(),
                flag_BO: sc(),
                flag_BQ: fc(),
                flag_BR: hc(),
                flag_BS: kc(),
                flag_BT: zc(),
                flag_BV: Mc(),
                flag_BW: bc(),
                flag_BY: xc(),
                flag_BZ: Sc(),
                flag_CA: Ac(),
                flag_CC: Cc(),
                flag_CD: jc(),
                flag_CF: Gc(),
                flag_CG: Kc(),
                flag_CH: Ec(),
                flag_CI: Lc(),
                flag_CK: Uc(),
                flag_CL: Dc(),
                flag_CM: Oc(),
                flag_CN: Jc(),
                flag_CO: Wc(),
                flag_CR: $c(),
                flag_CU: Xc(),
                flag_CV: aa(),
                flag_CW: ia(),
                flag_CX: la(),
                flag_CY: ta(),
                flag_CZ: sa(),
                flag_DE: fa(),
                flag_DJ: ha(),
                flag_DK: ka(),
                flag_DM: za(),
                flag_DO: Ma(),
                flag_DZ: ba(),
                flag_EC: xa(),
                flag_EE: Sa(),
                flag_EG: Aa(),
                flag_EH: Ca(),
                flag_ER: ja(),
                flag_ES: Ga(),
                flag_ET: Ka(),
                flag_EU: Ea(),
                flag_FI: La(),
                flag_FJ: Ua(),
                flag_FK: Da(),
                flag_FM: Oa(),
                flag_FO: Ja(),
                flag_FR: Wa(),
                flag_GA: $a(),
                flag_GB_ENG: Xa(),
                flag_GB_NIR: ae(),
                flag_GB_SCT: ie(),
                flag_GB_WLS: le(),
                flag_GB: te(),
                flag_GD: se(),
                flag_GE: fe(),
                flag_GF: he(),
                flag_GG: ke(),
                flag_GH: ze(),
                flag_GI: Me(),
                flag_GL: be(),
                flag_GM: xe(),
                flag_GN: Se(),
                flag_GP: Ae(),
                flag_GQ: Ce(),
                flag_GR: je(),
                flag_GS: Ge(),
                flag_GT: Ke(),
                flag_GU: Ee(),
                flag_GW: Le(),
                flag_GY: Ue(),
                flag_HK: De(),
                flag_HM: Oe(),
                flag_HN: Je(),
                flag_HR: We(),
                flag_HT: $e(),
                flag_HU: Xe(),
                flag_ID: ai(),
                flag_IE: ii(),
                flag_IL: li(),
                flag_IM: ti(),
                flag_IN: si(),
                flag_IO: fi(),
                flag_IQ: hi(),
                flag_IR: ki(),
                flag_IS: zi(),
                flag_IT: Mi(),
                flag_JE: bi(),
                flag_JM: xi(),
                flag_JO: Si(),
                flag_JP: Ai(),
                flag_KE: Ci(),
                flag_KG: ji(),
                flag_KH: Gi(),
                flag_KI: Ki(),
                flag_KM: Ei(),
                flag_KN: Li(),
                flag_KP: Ui(),
                flag_KR: Di(),
                flag_KW: Oi(),
                flag_KY: Ji(),
                flag_KZ: Wi(),
                flag_LA: $i(),
                flag_LB: Xi(),
                flag_LC: ao(),
                flag_LI: io(),
                flag_LK: lo(),
                flag_LR: to(),
                flag_LS: so(),
                flag_LT: fo(),
                flag_LU: po(),
                flag_LV: uo(),
                flag_LY: go(),
                flag_MA: vo(),
                flag_MC: wo(),
                flag_MD: yo(),
                flag_ME: Ro(),
                flag_MF: Bo(),
                flag_MG: Fo(),
                flag_MH: Ho(),
                flag_MK: Po(),
                flag_ML: To(),
                flag_MM: No(),
                flag_MN: Io(),
                flag_MO: Vo(),
                flag_MP: qo(),
                flag_MQ: Zo(),
                flag_MR: _o(),
                flag_MS: Yo(),
                flag_MT: Qo(),
                flag_MU: cl(),
                flag_MV: el(),
                flag_MW: ol(),
                flag_MX: nl(),
                flag_MY: ml(),
                flag_MZ: rl(),
                flag_NA: dl(),
                flag_NC: pl(),
                flag_NE: ul(),
                flag_NF: gl(),
                flag_NG: vl(),
                flag_NI: wl(),
                flag_NL: yl(),
                flag_NO: Rl(),
                flag_NP: Bl(),
                flag_NR: Fl(),
                flag_NU: Hl(),
                flag_NZ: Pl(),
                flag_OM: Tl(),
                flag_PA: Nl(),
                flag_PE: Il(),
                flag_PF: Vl(),
                flag_PG: ql(),
                flag_PH: Zl(),
                flag_PK: _l(),
                flag_PL: Yl(),
                flag_PM: Ql(),
                flag_PN: cn(),
                flag_PR: en(),
                flag_PS: ln(),
                flag_PT: tn(),
                flag_PW: sn(),
                flag_PY: fn(),
                flag_QA: hn(),
                flag_RE: kn(),
                flag_RO: zn(),
                flag_RS: Mn(),
                flag_RU: bn(),
                flag_RW: xn(),
                flag_SA: Sn(),
                flag_SB: An(),
                flag_SC: Cn(),
                flag_SD: jn(),
                flag_SE: Gn(),
                flag_SG: Kn(),
                flag_SH: En(),
                flag_SI: Ln(),
                flag_SJ: Un(),
                flag_SK: Dn(),
                flag_SL: On(),
                flag_SM: Jn(),
                flag_SN: Wn(),
                flag_SO: $n(),
                flag_SR: Xn(),
                flag_SS: at(),
                flag_ST: it(),
                flag_SV: lt(),
                flag_SX: tt(),
                flag_SY: st(),
                flag_SZ: ft(),
                flag_TC: ht(),
                flag_TD: kt(),
                flag_TF: zt(),
                flag_TG: Mt(),
                flag_TH: bt(),
                flag_TJ: xt(),
                flag_TK: St(),
                flag_TL: At(),
                flag_TM: Ct(),
                flag_TN: jt(),
                flag_TO: Gt(),
                flag_TR: Kt(),
                flag_TT: Et(),
                flag_TV: Lt(),
                flag_TW: Ut(),
                flag_TZ: Dt(),
                flag_UA: Ot(),
                flag_UG: Jt(),
                flag_UM: Wt(),
                flag_US: $t(),
                flag_UY: Xt(),
                flag_UZ: am(),
                flag_VA: im(),
                flag_VC: lm(),
                flag_VE: tm(),
                flag_VG: sm(),
                flag_VI: fm(),
                flag_VN: hm(),
                flag_VU: km(),
                flag_WF: zm(),
                flag_XK: Mm(),
                flag_WS: bm(),
                flag_YE: xm(),
                flag_YT: Sm(),
                flag_ZA: Am(),
                flag_ZM: Cm(),
                flag_ZW: jm()
            }, Gm = JSON.parse('[{"name":{"common":"Aruba","official":"Aruba","native":{"nld":{"official":"Aruba","common":"Aruba"},"pap":{"official":"Aruba","common":"Aruba"}}},"tld":[".aw"],"cca2":"AW","ccn3":"533","cca3":"ABW","cioc":"ARU","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"AWG":{"name":"Aruban florin","symbol":"\u0192"}},"idd":{"root":"+2","suffixes":["97"]},"capital":["Oranjestad"],"altSpellings":["AW"],"region":"Americas","subregion":"Caribbean","languages":{"nld":"Dutch","pap":"Papiamento"},"translations":{"ces":{"official":"Aruba","common":"Aruba"},"deu":{"official":"Aruba","common":"Aruba"},"est":{"official":"Aruba","common":"Aruba"},"fin":{"official":"Aruba","common":"Aruba"},"fra":{"official":"Aruba","common":"Aruba"},"hrv":{"official":"Aruba","common":"Aruba"},"hun":{"official":"Aruba","common":"Aruba"},"ita":{"official":"Aruba","common":"Aruba"},"jpn":{"official":"\u30A2\u30EB\u30D0","common":"\u30A2\u30EB\u30D0"},"kor":{"official":"\uC544\uB8E8\uBC14","common":"\uC544\uB8E8\uBC14"},"nld":{"official":"Aruba","common":"Aruba"},"per":{"official":"\u0622\u0631\u0648\u0628\u0627","common":"\u0622\u0631\u0648\u0628\u0627"},"pol":{"official":"Aruba","common":"Aruba"},"por":{"official":"Aruba","common":"Aruba"},"rus":{"official":"\u0410\u0440\u0443\u0431\u0430","common":"\u0410\u0440\u0443\u0431\u0430"},"slk":{"official":"Aruba","common":"Aruba"},"spa":{"official":"Aruba","common":"Aruba"},"swe":{"official":"Aruba","common":"Aruba"},"urd":{"official":"\u0627\u0631\u0648\u0628\u0627","common":"\u0627\u0631\u0648\u0628\u0627"},"zho":{"official":"\u963F\u9C81\u5DF4","common":"\u963F\u9C81\u5DF4"}},"latlng":[12.5,-69.96666666],"landlocked":false,"borders":[],"area":180,"flag":"\uD83C\uDDE6\uD83C\uDDFC","demonyms":{"eng":{"f":"Aruban","m":"Aruban"},"fra":{"f":"Arubaise","m":"Arubais"}}},{"name":{"common":"Afghanistan","official":"Islamic Republic of Afghanistan","native":{"prs":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0633\u0644\u0627\u0645\u06CC \u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646","common":"\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646"},"pus":{"official":"\u062F \u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646 \u0627\u0633\u0644\u0627\u0645\u064A \u062C\u0645\u0647\u0648\u0631\u06CC\u062A","common":"\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646"},"tuk":{"official":"Owganystan Yslam Respublikasy","common":"Owganystan"}}},"tld":[".af"],"cca2":"AF","ccn3":"004","cca3":"AFG","cioc":"AFG","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"AFN":{"name":"Afghan afghani","symbol":"\u060B"}},"idd":{"root":"+9","suffixes":["3"]},"capital":["Kabul"],"altSpellings":["AF","Af\u0121\u0101nist\u0101n"],"region":"Asia","subregion":"Southern Asia","languages":{"prs":"Dari","pus":"Pashto","tuk":"Turkmen"},"translations":{"ces":{"official":"Afgh\xe1nsk\xe1 isl\xe1msk\xe1 republika","common":"Afgh\xe1nist\xe1n"},"cym":{"official":"Gweriniaeth Islamaidd Affganistan","common":"Affganistan"},"deu":{"official":"Islamische Republik Afghanistan","common":"Afghanistan"},"est":{"official":"Afganistani Islamivabariik","common":"Afganistan"},"fin":{"official":"Afganistanin islamilainen tasavalta","common":"Afganistan"},"fra":{"official":"R\xe9publique islamique d\'Afghanistan","common":"Afghanistan"},"hrv":{"official":"Islamska Republika Afganistan","common":"Afganistan"},"hun":{"official":"Afganiszt\xe1ni Iszl\xe1m K\xf6zt\xe1rsas\xe1g","common":"Afganiszt\xe1n"},"ita":{"official":"Repubblica islamica dell\'Afghanistan","common":"Afghanistan"},"jpn":{"official":"\u30A2\u30D5\u30AC\u30CB\u30B9\u30BF\u30F3\xb7\u30A4\u30B9\u30E9\u30E0\u5171\u548C\u56FD","common":"\u30A2\u30D5\u30AC\u30CB\u30B9\u30BF\u30F3"},"kor":{"official":"\uC544\uD504\uAC00\uB2C8\uC2A4\uD0C4 \uC774\uC2AC\uB78C \uACF5\uD654\uAD6D","common":"\uC544\uD504\uAC00\uB2C8\uC2A4\uD0C4"},"nld":{"official":"Islamitische Republiek Afghanistan","common":"Afghanistan"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0633\u0644\u0627\u0645\u06CC \u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646","common":"\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646"},"pol":{"official":"Islamska Republika Afganistanu","common":"Afganistan"},"por":{"official":"Rep\xfablica Isl\xe2mica do Afeganist\xe3o","common":"Afeganist\xe3o"},"rus":{"official":"\u0418\u0441\u043B\u0430\u043C\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0410\u0444\u0433\u0430\u043D\u0438\u0441\u0442\u0430\u043D","common":"\u0410\u0444\u0433\u0430\u043D\u0438\u0441\u0442\u0430\u043D"},"slk":{"official":"Afg\xe1nsky islamsk\xfd \u0161t\xe1t","common":"Afganistan"},"spa":{"official":"Rep\xfablica Isl\xe1mica de Afganist\xe1n","common":"Afganist\xe1n"},"swe":{"official":"Islamiska republiken Afghanistan","common":"Afghanistan"},"urd":{"official":"\u0627\u0633\u0644\u0627\u0645\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646","common":"\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646"},"zho":{"official":"\u963F\u5BCC\u6C57\u4F0A\u65AF\u5170\u5171\u548C\u56FD","common":"\u963F\u5BCC\u6C57"}},"latlng":[33,65],"landlocked":true,"borders":["IRN","PAK","TKM","UZB","TJK","CHN"],"area":652230,"flag":"\uD83C\uDDE6\uD83C\uDDEB","demonyms":{"eng":{"f":"Afghan","m":"Afghan"},"fra":{"f":"Afghane","m":"Afghan"}}},{"name":{"common":"Angola","official":"Republic of Angola","native":{"por":{"official":"Rep\xfablica de Angola","common":"Angola"}}},"tld":[".ao"],"cca2":"AO","ccn3":"024","cca3":"AGO","cioc":"ANG","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"AOA":{"name":"Angolan kwanza","symbol":"Kz"}},"idd":{"root":"+2","suffixes":["44"]},"capital":["Luanda"],"altSpellings":["AO","Rep\xfablica de Angola","\u0281\u025Bpublika de an\'\u0261\u0254la"],"region":"Africa","subregion":"Middle Africa","languages":{"por":"Portuguese"},"translations":{"ces":{"official":"Angolsk\xe1 republika","common":"Angola"},"cym":{"official":"Gweriniaeth Angola","common":"Angola"},"deu":{"official":"Republik Angola","common":"Angola"},"est":{"official":"Angola Vabariik","common":"Angola"},"fin":{"official":"Angolan tasavalta","common":"Angola"},"fra":{"official":"R\xe9publique d\'Angola","common":"Angola"},"hrv":{"official":"Republika Angola","common":"Angola"},"hun":{"official":"Angola","common":"Angola"},"ita":{"official":"Repubblica dell\'Angola","common":"Angola"},"jpn":{"official":"\u30A2\u30F3\u30B4\u30E9\u5171\u548C\u56FD","common":"\u30A2\u30F3\u30B4\u30E9"},"kor":{"official":"\uC559\uACE8\uB77C \uACF5\uD654\uAD6D","common":"\uC559\uACE8\uB77C"},"nld":{"official":"Republiek Angola","common":"Angola"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0622\u0646\u06AF\u0648\u0644\u0627","common":"\u0622\u0646\u06AF\u0648\u0644\u0627"},"pol":{"official":"Republika Angoli","common":"Angola"},"por":{"official":"Rep\xfablica de Angola","common":"Angola"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0410\u043D\u0433\u043E\u043B\u0430","common":"\u0410\u043D\u0433\u043E\u043B\u0430"},"slk":{"official":"Angolsk\xe1 republika","common":"Angola"},"spa":{"official":"Rep\xfablica de Angola","common":"Angola"},"swe":{"official":"Republiken Angola","common":"Angola"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0627\u0646\u06AF\u0648\u0644\u06C1","common":"\u0627\u0646\u06AF\u0648\u0644\u06C1"},"zho":{"official":"\u5B89\u54E5\u62C9\u5171\u548C\u56FD","common":"\u5B89\u54E5\u62C9"}},"latlng":[-12.5,18.5],"landlocked":false,"borders":["COG","COD","ZMB","NAM"],"area":1246700,"flag":"\uD83C\uDDE6\uD83C\uDDF4","demonyms":{"eng":{"f":"Angolan","m":"Angolan"},"fra":{"f":"Angolaise","m":"Angolais"}}},{"name":{"common":"Anguilla","official":"Anguilla","native":{"eng":{"official":"Anguilla","common":"Anguilla"}}},"tld":[".ai"],"cca2":"AI","ccn3":"660","cca3":"AIA","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"XCD":{"name":"Eastern Caribbean dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["264"]},"capital":["The Valley"],"altSpellings":["AI"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Anguilla","common":"Anguilla"},"deu":{"official":"Anguilla","common":"Anguilla"},"est":{"official":"Anguilla","common":"Anguilla"},"fin":{"official":"Anguilla","common":"Anguilla"},"fra":{"official":"Anguilla","common":"Anguilla"},"hrv":{"official":"Anguilla","common":"Angvila"},"hun":{"official":"Anguilla","common":"Anguilla"},"ita":{"official":"Anguilla","common":"Anguilla"},"jpn":{"official":"\u30A2\u30F3\u30B0\u30A3\u30E9","common":"\u30A2\u30F3\u30AE\u30E9"},"kor":{"official":"\uC575\uADC8\uB77C","common":"\uC575\uADC8\uB77C"},"nld":{"official":"Anguilla","common":"Anguilla"},"per":{"official":"\u0622\u0646\u06AF\u0648\u06CC\u0644\u0627","common":"\u0622\u0646\u06AF\u0648\u06CC\u0644\u0627"},"pol":{"official":"Anguilla","common":"Anguilla"},"por":{"official":"Anguilla","common":"Anguilla"},"rus":{"official":"\u0410\u043D\u0433\u0438\u043B\u044C\u044F","common":"\u0410\u043D\u0433\u0438\u043B\u044C\u044F"},"slk":{"official":"Anguilla","common":"Anguilla"},"spa":{"official":"Anguila","common":"Anguilla"},"swe":{"official":"Anguilla","common":"Anguilla"},"urd":{"official":"\u0627\u06CC\u0646\u06AF\u0648\u06CC\u0644\u0627","common":"\u0627\u06CC\u0646\u06AF\u0648\u06CC\u0644\u0627"},"zho":{"official":"\u5B89\u572D\u62C9","common":"\u5B89\u572D\u62C9"}},"latlng":[18.25,-63.16666666],"landlocked":false,"borders":[],"area":91,"flag":"\uD83C\uDDE6\uD83C\uDDEE","demonyms":{"eng":{"f":"Anguillian","m":"Anguillian"},"fra":{"f":"Anguillane","m":"Anguillan"}}},{"name":{"common":"\xc5land Islands","official":"\xc5land Islands","native":{"swe":{"official":"Landskapet \xc5land","common":"\xc5land"}}},"tld":[".ax"],"cca2":"AX","ccn3":"248","cca3":"ALA","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["5818"]},"capital":["Mariehamn"],"altSpellings":["AX","Aaland","Aland","Ahvenanmaa"],"region":"Europe","subregion":"Northern Europe","languages":{"swe":"Swedish"},"translations":{"ces":{"official":"\xc5landsk\xe9 ostrovy","common":"\xc5landy"},"deu":{"official":"\xc5land-Inseln","common":"\xc5land"},"est":{"official":"Ahvenamaa maakond","common":"Ahvenamaa"},"fin":{"official":"Ahvenanmaan maakunta","common":"Ahvenanmaa"},"fra":{"official":"Ahvenanmaa","common":"Ahvenanmaa"},"hrv":{"official":"Aland Islands","common":"\xc5landski otoci"},"hun":{"official":"\xc5land-szigetek","common":"\xc5land-szigetek"},"ita":{"official":"Isole \xc5land","common":"Isole Aland"},"jpn":{"official":"\u30AA\u30FC\u30E9\u30F3\u30C9\u8AF8\u5CF6","common":"\u30AA\u30FC\u30E9\u30F3\u30C9\u8AF8\u5CF6"},"kor":{"official":"\uC62C\uB780\uB4DC \uC81C\uB3C4","common":"\uC62C\uB780\uB4DC \uC81C\uB3C4"},"nld":{"official":"\xc5land eilanden","common":"\xc5landeilanden"},"per":{"official":"\u062C\u0632\u0627\u06CC\u0631 \u0627\u0644\u0646\u062F","common":"\u062C\u0632\u0627\u06CC\u0631 \u0627\u0644\u0646\u062F"},"pol":{"official":"Wyspy Alandzkie","common":"Wyspy Alandzkie"},"por":{"official":"Ilhas \xc5land","common":"Al\xe2ndia"},"rus":{"official":"\u0410\u043B\u0430\u043D\u0434\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430","common":"\u0410\u043B\u0430\u043D\u0434\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430"},"slk":{"official":"Alandsk\xe9 ostrovy","common":"Alandy"},"spa":{"official":"Islas \xc5land","common":"Alandia"},"swe":{"official":"\xc5land","common":"\xc5land"},"urd":{"official":"\u062C\u0632\u0627\u0626\u0631 \u0627\u0648\u0644\u0646\u062F","common":"\u062C\u0632\u0627\u0626\u0631 \u0627\u0648\u0644\u0646\u062F"},"zho":{"official":"\u5965\u5170\u7FA4\u5C9B","common":"\u5965\u5170\u7FA4\u5C9B"}},"latlng":[60.116667,19.9],"landlocked":false,"borders":[],"area":1580,"flag":"\uD83C\uDDE6\uD83C\uDDFD","demonyms":{"eng":{"f":"\xc5landish","m":"\xc5landish"},"fra":{"f":"\xc5landaise","m":"\xc5landais"}}},{"name":{"common":"Albania","official":"Republic of Albania","native":{"sqi":{"official":"Republika e Shqip\xebris\xeb","common":"Shqip\xebria"}}},"tld":[".al"],"cca2":"AL","ccn3":"008","cca3":"ALB","cioc":"ALB","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"ALL":{"name":"Albanian lek","symbol":"L"}},"idd":{"root":"+3","suffixes":["55"]},"capital":["Tirana"],"altSpellings":["AL","Shqip\xebri","Shqip\xebria","Shqipnia"],"region":"Europe","subregion":"Southeast Europe","languages":{"sqi":"Albanian"},"translations":{"ces":{"official":"Alb\xe1nsk\xe1 republika","common":"Alb\xe1nie"},"cym":{"official":"Gweriniaeth Albania","common":"Albania"},"deu":{"official":"Republik Albanien","common":"Albanien"},"est":{"official":"Albaania Vabariik","common":"Albaania"},"fin":{"official":"Albanian tasavalta","common":"Albania"},"fra":{"official":"R\xe9publique d\'Albanie","common":"Albanie"},"hrv":{"official":"Republika Albanija","common":"Albanija"},"hun":{"official":"Alb\xe1n K\xf6zt\xe1rsas\xe1g","common":"Alb\xe1nia"},"ita":{"official":"Repubblica d\'Albania","common":"Albania"},"jpn":{"official":"\u30A2\u30EB\u30D0\u30CB\u30A2\u5171\u548C\u56FD","common":"\u30A2\u30EB\u30D0\u30CB\u30A2"},"kor":{"official":"\uC54C\uBC14\uB2C8\uC544 \uACF5\uD654\uAD6D","common":"\uC54C\uBC14\uB2C8\uC544"},"nld":{"official":"Republiek Albani\xeb","common":"Albani\xeb"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0622\u0644\u0628\u0627\u0646\u06CC","common":"\u0622\u0644\u0628\u0627\u0646\u06CC"},"pol":{"official":"Republika Albanii","common":"Albania"},"por":{"official":"Rep\xfablica da Alb\xe2nia","common":"Alb\xe2nia"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0410\u043B\u0431\u0430\u043D\u0438\u044F","common":"\u0410\u043B\u0431\u0430\u043D\u0438\u044F"},"slk":{"official":"Alb\xe1nska republika","common":"Alb\xe1nsko"},"spa":{"official":"Rep\xfablica de Albania","common":"Albania"},"swe":{"official":"Republiken Albanien","common":"Albanien"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0627\u0644\u0628\u0627\u0646\u06CC\u0627","common":"\u0627\u0644\u0628\u0627\u0646\u06CC\u0627"},"zho":{"official":"\u963F\u5C14\u5DF4\u5C3C\u4E9A\u5171\u548C\u56FD","common":"\u963F\u5C14\u5DF4\u5C3C\u4E9A"}},"latlng":[41,20],"landlocked":false,"borders":["MNE","GRC","MKD","UNK"],"area":28748,"flag":"\uD83C\uDDE6\uD83C\uDDF1","demonyms":{"eng":{"f":"Albanian","m":"Albanian"},"fra":{"f":"Albanaise","m":"Albanais"}}},{"name":{"common":"Andorra","official":"Principality of Andorra","native":{"cat":{"official":"Principat d\'Andorra","common":"Andorra"}}},"tld":[".ad"],"cca2":"AD","ccn3":"020","cca3":"AND","cioc":"AND","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["76"]},"capital":["Andorra la Vella"],"altSpellings":["AD","Principality of Andorra","Principat d\'Andorra"],"region":"Europe","subregion":"Southern Europe","languages":{"cat":"Catalan"},"translations":{"ces":{"official":"Andorrsk\xe9 kn\xed\u017Eectv\xed","common":"Andorra"},"cym":{"official":"Tywysogaeth Andorra","common":"Andorra"},"deu":{"official":"F\xfcrstentum Andorra","common":"Andorra"},"est":{"official":"Andorra V\xfcrstiriik","common":"Andorra"},"fin":{"official":"Andorran ruhtinaskunta","common":"Andorra"},"fra":{"official":"Principaut\xe9 d\'Andorre","common":"Andorre"},"hrv":{"official":"Kne\u017Eevina Andora","common":"Andora"},"hun":{"official":"Andorra","common":"Andorra"},"ita":{"official":"Principato di Andorra","common":"Andorra"},"jpn":{"official":"\u30A2\u30F3\u30C9\u30E9\u516C\u56FD","common":"\u30A2\u30F3\u30C9\u30E9"},"kor":{"official":"\uC548\uB3C4\uB77C \uACF5\uAD6D","common":"\uC548\uB3C4\uB77C"},"nld":{"official":"Prinsdom Andorra","common":"Andorra"},"per":{"official":"\u0634\u0627\u0647\u0632\u0627\u062F\u0647\u200C\u0646\u0634\u06CC\u0646 \u0622\u0646\u062F\u0648\u0631\u0627","common":"\u0622\u0646\u062F\u0648\u0631\u0627"},"pol":{"official":"Ksi\u0119stwo Andory","common":"Andora"},"por":{"official":"Principado de Andorra","common":"Andorra"},"rus":{"official":"\u041A\u043D\u044F\u0436\u0435\u0441\u0442\u0432\u043E \u0410\u043D\u0434\u043E\u0440\u0440\u0430","common":"\u0410\u043D\u0434\u043E\u0440\u0440\u0430"},"slk":{"official":"Andorrsk\xe9 knie\u017Eatstvo","common":"Andorra"},"spa":{"official":"Principado de Andorra","common":"Andorra"},"swe":{"official":"Furstend\xf6met Andorra","common":"Andorra"},"urd":{"official":"\u0627\u0645\u0627\u0631\u0627\u062A\u0650 \u0627\u0646\u0688\u0648\u0631\u0627","common":"\u0627\u0646\u0688\u0648\u0631\u0627"},"zho":{"official":"\u5B89\u9053\u5C14\u516C\u56FD","common":"\u5B89\u9053\u5C14"}},"latlng":[42.5,1.5],"landlocked":true,"borders":["FRA","ESP"],"area":468,"flag":"\uD83C\uDDE6\uD83C\uDDE9","demonyms":{"eng":{"f":"Andorran","m":"Andorran"},"fra":{"f":"Andorrane","m":"Andorran"}}},{"name":{"common":"United Arab Emirates","official":"United Arab Emirates","native":{"ara":{"official":"\u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629","common":"\u062F\u0648\u0644\u0629 \u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629"}}},"tld":[".ae","\u0627\u0645\u0627\u0631\u0627\u062A."],"cca2":"AE","ccn3":"784","cca3":"ARE","cioc":"UAE","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"AED":{"name":"United Arab Emirates dirham","symbol":"\u062F.\u0625"}},"idd":{"root":"+9","suffixes":["71"]},"capital":["Abu Dhabi"],"altSpellings":["AE","UAE","Emirates"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Spojen\xe9 arabsk\xe9 emir\xe1ty","common":"Spojen\xe9 arabsk\xe9 emir\xe1ty"},"deu":{"official":"Vereinigte Arabische Emirate","common":"Vereinigte Arabische Emirate"},"est":{"official":"Araabia \xdchendemiraadid","common":"Araabia \xdchendemiraadid"},"fin":{"official":"Yhdistyneet arabiemiirikunnat","common":"Arabiemiraatit"},"fra":{"official":"\xc9mirats arabes unis","common":"\xc9mirats arabes unis"},"hrv":{"official":"Ujedinjeni Arapski Emirati","common":"Ujedinjeni Arapski Emirati"},"hun":{"official":"Egyes\xfclt Arab Em\xedrs\xe9gek","common":"Egyes\xfclt Arab Em\xedrs\xe9gek"},"ita":{"official":"Emirati Arabi Uniti","common":"Emirati Arabi Uniti"},"jpn":{"official":"\u30A2\u30E9\u30D6\u9996\u9577\u56FD\u9023\u90A6","common":"\u30A2\u30E9\u30D6\u9996\u9577\u56FD\u9023\u90A6"},"kor":{"official":"\uC544\uB78D \uD1A0\uD6C4\uAD6D \uC5F0\uBC29","common":"\uC544\uB78D\uC5D0\uBBF8\uB9AC\uD2B8"},"nld":{"official":"Verenigde Arabische Emiraten","common":"Verenigde Arabische Emiraten"},"per":{"official":"\u0627\u0645\u0627\u0631\u0627\u062A \u0645\u062A\u062D\u062F\u0647 \u0639\u0631\u0628\u06CC","common":"\u0627\u0645\u0627\u0631\u0627\u062A"},"pol":{"official":"Zjednoczone Emiraty Arabskie","common":"Zjednoczone Emiraty Arabskie"},"por":{"official":"Emirados \xc1rabes Unidos","common":"Emirados \xc1rabes Unidos"},"rus":{"official":"\u041E\u0431\u044A\u0435\u0434\u0438\u043D\u0435\u043D\u043D\u044B\u0435 \u0410\u0440\u0430\u0431\u0441\u043A\u0438\u0435 \u042D\u043C\u0438\u0440\u0430\u0442\u044B","common":"\u041E\u0431\u044A\u0435\u0434\u0438\u043D\u0451\u043D\u043D\u044B\u0435 \u0410\u0440\u0430\u0431\u0441\u043A\u0438\u0435 \u042D\u043C\u0438\u0440\u0430\u0442\u044B"},"slk":{"official":"Spojen\xe9 arabsk\xe9 emir\xe1ty","common":"Spojen\xe9 arabsk\xe9 emir\xe1ty"},"spa":{"official":"Emiratos \xc1rabes Unidos","common":"Emiratos \xc1rabes Unidos"},"swe":{"official":"F\xf6renade Arabemiraten","common":"F\xf6renade Arabemiraten"},"urd":{"official":"\u0645\u062A\u062D\u062F\u06C1 \u0639\u0631\u0628 \u0627\u0645\u0627\u0631\u0627\u062A","common":"\u0645\u062A\u062D\u062F\u06C1 \u0639\u0631\u0628 \u0627\u0645\u0627\u0631\u0627\u062A"},"zho":{"official":"\u963F\u62C9\u4F2F\u8054\u5408\u914B\u957F\u56FD","common":"\u963F\u62C9\u4F2F\u8054\u5408\u914B\u957F\u56FD"}},"latlng":[24,54],"landlocked":false,"borders":["OMN","SAU"],"area":83600,"flag":"\uD83C\uDDE6\uD83C\uDDEA","demonyms":{"eng":{"f":"Emirati","m":"Emirati"},"fra":{"f":"Emirienne","m":"Emirien"}}},{"name":{"common":"Argentina","official":"Argentine Republic","native":{"grn":{"official":"Argentine Republic","common":"Argentina"},"spa":{"official":"Rep\xfablica Argentina","common":"Argentina"}}},"tld":[".ar"],"cca2":"AR","ccn3":"032","cca3":"ARG","cioc":"ARG","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"ARS":{"name":"Argentine peso","symbol":"$"}},"idd":{"root":"+5","suffixes":["4"]},"capital":["Buenos Aires"],"altSpellings":["AR","Argentine Republic","Rep\xfablica Argentina"],"region":"Americas","subregion":"South America","languages":{"grn":"Guaran\xed","spa":"Spanish"},"translations":{"ces":{"official":"Argentinsk\xe1 republika","common":"Argentina"},"cym":{"official":"Gweriniaeth yr Ariannin","common":"Ariannin"},"deu":{"official":"Argentinische Republik","common":"Argentinien"},"est":{"official":"Argentina Vabariik","common":"Argentina"},"fin":{"official":"Argentiinan tasavalta","common":"Argentiina"},"fra":{"official":"R\xe9publique argentine","common":"Argentine"},"hrv":{"official":"Argentinski Republika","common":"Argentina"},"hun":{"official":"Argentin K\xf6zt\xe1rsas\xe1g","common":"Argent\xedna"},"ita":{"official":"Repubblica Argentina","common":"Argentina"},"jpn":{"official":"\u30A2\u30EB\u30BC\u30F3\u30C1\u30F3\u5171\u548C\u56FD","common":"\u30A2\u30EB\u30BC\u30F3\u30C1\u30F3"},"kor":{"official":"\uC544\uB974\uD5E8\uD2F0\uB098 \uACF5\uD654\uAD6D","common":"\uC544\uB974\uD5E8\uD2F0\uB098"},"nld":{"official":"Argentijnse Republiek","common":"Argentini\xeb"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0622\u0631\u0698\u0627\u0646\u062A\u06CC\u0646","common":"\u0622\u0631\u0698\u0627\u0646\u062A\u06CC\u0646"},"pol":{"official":"Republika Argenty\u0144ska","common":"Argentyna"},"por":{"official":"Rep\xfablica Argentina","common":"Argentina"},"rus":{"official":"\u0410\u0440\u0433\u0435\u043D\u0442\u0438\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u0410\u0440\u0433\u0435\u043D\u0442\u0438\u043D\u0430"},"slk":{"official":"Argent\xednska republika","common":"Argent\xedna"},"spa":{"official":"Rep\xfablica Argentina","common":"Argentina"},"swe":{"official":"Republiken Argentina","common":"Argentina"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0627\u0631\u062C\u0646\u0679\u0627\u0626\u0646","common":"\u0627\u0631\u062C\u0646\u0679\u0627\u0626\u0646"},"zho":{"official":"\u963F\u6839\u5EF7\u5171\u548C\u56FD","common":"\u963F\u6839\u5EF7"}},"latlng":[-34,-64],"landlocked":false,"borders":["BOL","BRA","CHL","PRY","URY"],"area":2780400,"flag":"\uD83C\uDDE6\uD83C\uDDF7","demonyms":{"eng":{"f":"Argentine","m":"Argentine"},"fra":{"f":"Argentine","m":"Argentin"}}},{"name":{"common":"Armenia","official":"Republic of Armenia","native":{"hye":{"official":"\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576\u056B \u0540\u0561\u0576\u0580\u0561\u057A\u0565\u057F\u0578\u0582\u0569\u0575\u0578\u0582\u0576","common":"\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576"}}},"tld":[".am"],"cca2":"AM","ccn3":"051","cca3":"ARM","cioc":"ARM","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"AMD":{"name":"Armenian dram","symbol":"\u058F"}},"idd":{"root":"+3","suffixes":["74"]},"capital":["Yerevan"],"altSpellings":["AM","Hayastan","Republic of Armenia","\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576\u056B \u0540\u0561\u0576\u0580\u0561\u057A\u0565\u057F\u0578\u0582\u0569\u0575\u0578\u0582\u0576"],"region":"Asia","subregion":"Western Asia","languages":{"hye":"Armenian"},"translations":{"ces":{"official":"Arm\xe9nsk\xe1 republika","common":"Arm\xe9nie"},"cym":{"official":"Gweriniaeth Armenia","common":"Armenia"},"deu":{"official":"Republik Armenien","common":"Armenien"},"est":{"official":"Armeenia Vabariik","common":"Armeenia"},"fin":{"official":"Armenian tasavalta","common":"Armenia"},"fra":{"official":"R\xe9publique d\'Arm\xe9nie","common":"Arm\xe9nie"},"hrv":{"official":"Republika Armenija","common":"Armenija"},"hun":{"official":"\xd6rm\xe9nyorsz\xe1g","common":"\xd6rm\xe9nyorsz\xe1g"},"ita":{"official":"Repubblica di Armenia","common":"Armenia"},"jpn":{"official":"\u30A2\u30EB\u30E1\u30CB\u30A2\u5171\u548C\u56FD","common":"\u30A2\u30EB\u30E1\u30CB\u30A2"},"kor":{"official":"\uC544\uB974\uBA54\uB2C8\uC544 \uACF5\uD654\uAD6D","common":"\uC544\uB974\uBA54\uB2C8\uC544"},"nld":{"official":"Republiek Armeni\xeb","common":"Armeni\xeb"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0631\u0645\u0646\u0633\u062A\u0627\u0646","common":"\u0627\u0631\u0645\u0646\u0633\u062A\u0627\u0646"},"pol":{"official":"Republika Armenii","common":"Armenia"},"por":{"official":"Rep\xfablica da Arm\xe9nia","common":"Arm\xe9nia"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0410\u0440\u043C\u0435\u043D\u0438\u044F","common":"\u0410\u0440\u043C\u0435\u043D\u0438\u044F"},"slk":{"official":"Arm\xe9nska republika","common":"Arm\xe9nsko"},"spa":{"official":"Rep\xfablica de Armenia","common":"Armenia"},"swe":{"official":"Republiken Armenien","common":"Armenien"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0622\u0631\u0645\u06CC\u0646\u06CC\u0627","common":"\u0622\u0631\u0645\u06CC\u0646\u06CC\u0627"},"zho":{"official":"\u4E9A\u7F8E\u5C3C\u4E9A\u5171\u548C\u56FD","common":"\u4E9A\u7F8E\u5C3C\u4E9A"}},"latlng":[40,45],"landlocked":true,"borders":["AZE","GEO","IRN","TUR"],"area":29743,"flag":"\uD83C\uDDE6\uD83C\uDDF2","demonyms":{"eng":{"f":"Armenian","m":"Armenian"},"fra":{"f":"Arm\xe9nienne","m":"Arm\xe9nien"}}},{"name":{"common":"American Samoa","official":"American Samoa","native":{"eng":{"official":"American Samoa","common":"American Samoa"},"smo":{"official":"S\u0101moa Amelika","common":"S\u0101moa Amelika"}}},"tld":[".as"],"cca2":"AS","ccn3":"016","cca3":"ASM","cioc":"ASA","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["684"]},"capital":["Pago Pago"],"altSpellings":["AS","Amerika S\u0101moa","Amelika S\u0101moa","S\u0101moa Amelika"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English","smo":"Samoan"},"translations":{"ces":{"official":"Americk\xe1 Samoa","common":"Americk\xe1 Samoa"},"deu":{"official":"Amerikanisch-Samoa","common":"Amerikanisch-Samoa"},"est":{"official":"Ameerika Samoa","common":"Ameerika Samoa"},"fin":{"official":"Amerikan Samoa","common":"Amerikan Samoa"},"fra":{"official":"Samoa am\xe9ricaines","common":"Samoa am\xe9ricaines"},"hrv":{"official":"ameri\u010Dka Samoa","common":"Ameri\u010Dka Samoa"},"hun":{"official":"Szamoa","common":"Szamoa"},"ita":{"official":"Samoa americane","common":"Samoa Americane"},"jpn":{"official":"\u7C73\u30B5\u30E2\u30A2","common":"\u30A2\u30E1\u30EA\u30AB\u9818\u30B5\u30E2\u30A2"},"kor":{"official":"\uC544\uBA54\uB9AC\uCE78\uC0AC\uBAA8\uC544","common":"\uC544\uBA54\uB9AC\uCE78\uC0AC\uBAA8\uC544"},"nld":{"official":"Amerikaans Samoa","common":"Amerikaans Samoa"},"per":{"official":"\u0633\u0627\u0645\u0648\u0622\u06CC \u0622\u0645\u0631\u06CC\u06A9\u0627","common":"\u0633\u0627\u0645\u0648\u0622\u06CC \u0622\u0645\u0631\u06CC\u06A9\u0627"},"pol":{"official":"Samoa Ameryka\u0144skie","common":"Samoa Ameryka\u0144skie"},"por":{"official":"Samoa americana","common":"Samoa Americana"},"rus":{"official":"\u0430\u043C\u0435\u0440\u0438\u043A\u0430\u043D\u0441\u043A\u043E\u0435 \u0421\u0430\u043C\u043E\u0430","common":"\u0410\u043C\u0435\u0440\u0438\u043A\u0430\u043D\u0441\u043A\u043E\u0435 \u0421\u0430\u043C\u043E\u0430"},"slk":{"official":"Americk\xe1 Samoa","common":"Americk\xe1 Samoa"},"spa":{"official":"Samoa Americana","common":"Samoa Americana"},"swe":{"official":"Amerikanska Samoa","common":"Amerikanska Samoa"},"urd":{"official":"\u0627\u0645\u0631\u06CC\u06A9\u06CC \u0633\u0645\u0648\u0648\u0627","common":"\u0627\u0645\u0631\u06CC\u06A9\u06CC \u0633\u0645\u0648\u0648\u0627"},"zho":{"official":"\u7F8E\u5C5E\u8428\u6469\u4E9A","common":"\u7F8E\u5C5E\u8428\u6469\u4E9A"}},"latlng":[-14.33333333,-170],"landlocked":false,"borders":[],"area":199,"flag":"\uD83C\uDDE6\uD83C\uDDF8","demonyms":{"eng":{"f":"American Samoan","m":"American Samoan"},"fra":{"f":"Samoane","m":"Samoan"}}},{"name":{"common":"Antarctica","official":"Antarctica","native":{}},"tld":[".aq"],"cca2":"AQ","ccn3":"010","cca3":"ATA","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{},"idd":{"root":"","suffixes":[]},"capital":[],"altSpellings":["AQ"],"region":"Antarctic","subregion":"","languages":{},"translations":{"ces":{"official":"Antarktida","common":"Antarktida"},"cym":{"official":"Yr Antarctig","common":"Yr Antarctig"},"deu":{"official":"Antarktika","common":"Antarktis"},"est":{"official":"Antarktika","common":"Antarktika"},"fin":{"official":"Etel\xe4manner","common":"Etel\xe4manner"},"fra":{"official":"Antarctique","common":"Antarctique"},"hrv":{"official":"Antarktika","common":"Antarktika"},"hun":{"official":"Antarktisz","common":"Antarktisz"},"ita":{"official":"Antartide","common":"Antartide"},"jpn":{"official":"\u5357\u6975\u5927\u9678","common":"\u5357\u6975"},"kor":{"official":"\uB0A8\uADF9","common":"\uB0A8\uADF9"},"nld":{"official":"Antarctica","common":"Antarctica"},"per":{"official":"\u062C\u0646\u0648\u0628\u06AF\u0627\u0646","common":"\u062C\u0646\u0648\u0628\u06AF\u0627\u0646"},"pol":{"official":"Antarktyka","common":"Antarktyka"},"por":{"official":"Ant\xe1rtica","common":"Ant\xe1rtida"},"rus":{"official":"\u0410\u043D\u0442\u0430\u0440\u043A\u0442\u0438\u0434\u0430","common":"\u0410\u043D\u0442\u0430\u0440\u043A\u0442\u0438\u0434\u0430"},"slk":{"official":"Antarkt\xedda","common":"Antarkt\xedda"},"spa":{"official":"Ant\xe1rtida","common":"Ant\xe1rtida"},"swe":{"official":"Antarktis","common":"Antarktis"},"urd":{"official":"\u0627\u0646\u0679\u0627\u0631\u06A9\u0679\u06A9\u0627","common":"\u0627\u0646\u0679\u0627\u0631\u06A9\u0679\u06A9\u0627"},"zho":{"official":"\u5357\u6781\u6D32","common":"\u5357\u6781\u6D32"}},"latlng":[-90,0],"landlocked":false,"borders":[],"area":14000000,"flag":"\uD83C\uDDE6\uD83C\uDDF6","demonyms":{"eng":{"f":"Antarctican","m":"Antarctican"},"fra":{"f":"Antarcticaine","m":"Antarcticain"}}},{"name":{"common":"French Southern and Antarctic Lands","official":"Territory of the French Southern and Antarctic Lands","native":{"fra":{"official":"Territoire des Terres australes et antarctiques fran\xe7aises","common":"Terres australes et antarctiques fran\xe7aises"}}},"tld":[".tf"],"cca2":"TF","ccn3":"260","cca3":"ATF","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+2","suffixes":["62"]},"capital":["Port-aux-Fran\xe7ais"],"altSpellings":["TF","French Southern Territories"],"region":"Antarctic","subregion":"","languages":{"fra":"French"},"translations":{"ces":{"official":"Teritorium Francouzsk\xe1 ji\u017En\xed a antarktick\xe1 \xfazem\xed","common":"Francouzsk\xe1 ji\u017En\xed a antarktick\xe1 \xfazem\xed"},"deu":{"official":"Gebiet der Franz\xf6sisch S\xfcd- und Antarktisgebiete","common":"Franz\xf6sische S\xfcd- und Antarktisgebiete"},"est":{"official":"Prantsuse L\xf5unaalad","common":"Prantsuse L\xf5unaalad"},"fin":{"official":"Ranskan etel\xe4iset ja antarktiset alueet","common":"Ranskan etel\xe4iset ja antarktiset alueet"},"fra":{"official":"Territoire des Terres australes et antarctiques fran\xe7aises","common":"Terres australes et antarctiques fran\xe7aises"},"hrv":{"official":"Teritoriju Francuski ju\u017Eni i antarkti\u010Dki teritoriji","common":"Francuski ju\u017Eni i antarkti\u010Dki teritoriji"},"hun":{"official":"Francia d\xe9li \xe9s antarktiszi ter\xfcletek","common":"Francia d\xe9li \xe9s antarktiszi ter\xfcletek"},"ita":{"official":"Territorio della australi e antartiche francesi Terre","common":"Territori Francesi del Sud"},"jpn":{"official":"\u30D5\u30E9\u30F3\u30B9\u9818\u5357\u65B9\xb7\u5357\u6975\u5730\u57DF\u306E\u9818\u571F","common":"\u30D5\u30E9\u30F3\u30B9\u9818\u5357\u65B9\u30FB\u5357\u6975\u5730\u57DF"},"kor":{"official":"\uD504\uB791\uC2A4\uB839 \uB0A8\uBD80\uC640 \uB0A8\uADF9 \uC9C0\uC5ED","common":"\uD504\uB791\uC2A4\uB839 \uB0A8\uBD80\uC640 \uB0A8\uADF9 \uC9C0\uC5ED"},"nld":{"official":"Grondgebied van de Franse Zuidelijke en Antarctische gebieden","common":"Franse Gebieden in de zuidelijke Indische Oceaan"},"per":{"official":"\u0633\u0631\u0632\u0645\u06CC\u0646\u200C\u0647\u0627\u06CC \u062C\u0646\u0648\u0628\u06CC \u0648 \u062C\u0646\u0648\u0628\u06AF\u0627\u0646\u06CC \u0641\u0631\u0627\u0646\u0633\u0647","common":"\u0633\u0631\u0632\u0645\u06CC\u0646\u200C\u0647\u0627\u06CC \u062C\u0646\u0648\u0628\u06CC \u0648 \u062C\u0646\u0648\u0628\u06AF\u0627\u0646\u06CC \u0641\u0631\u0627\u0646\u0633\u0647"},"pol":{"official":"Francuskie Terytoria Po\u0142udniowe i Antarktyczne","common":"Francuskie Terytoria Po\u0142udniowe i Antarktyczne"},"por":{"official":"Territ\xf3rio do Sul e Ant\xe1rtica Francesa","common":"Terras Austrais e Ant\xe1rticas Francesas"},"rus":{"official":"\u0422\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044F \u0424\u0440\u0430\u043D\u0446\u0443\u0437\u0441\u043A\u0438\u0435 \u042E\u0436\u043D\u044B\u0435 \u0438 \u0410\u043D\u0442\u0430\u0440\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0437\u0435\u043C\u043B\u0438","common":"\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u0441\u043A\u0438\u0435 \u042E\u0436\u043D\u044B\u0435 \u0438 \u0410\u043D\u0442\u0430\u0440\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438"},"slk":{"official":"Franc\xfazske ju\u017En\xe9 a antarktick\xe9 \xfazemia","common":"Franc\xfazske ju\u017Dn\xe9 a antarktick\xe9 \xfazemia"},"spa":{"official":"Territorio del Franc\xe9s Tierras australes y ant\xe1rticas","common":"Tierras Australes y Ant\xe1rticas Francesas"},"swe":{"official":"Franska syd- och Antarktisterritorierna","common":"Franska s\xf6dra territorierna"},"urd":{"official":"\u0633\u0631\u0632\u0645\u06CC\u0646\u0650 \u062C\u0646\u0648\u0628\u06CC \u0641\u0631\u0627\u0646\u0633\u06CC\u0633\u06CC\u06C1 \u0648 \u0627\u0646\u0679\u0627\u0631\u06A9\u0679\u06CC\u06A9\u06C1","common":"\u0633\u0631\u0632\u0645\u06CC\u0646 \u062C\u0646\u0648\u0628\u06CC \u0641\u0631\u0627\u0646\u0633\u06CC\u0633\u06CC\u06C1 \u0648 \u0627\u0646\u0679\u0627\u0631\u06A9\u0679\u06CC\u06A9\u0627"},"zho":{"official":"\u6CD5\u56FD\u5357\u90E8\u548C\u5357\u6781\u571F\u5730","common":"\u6CD5\u56FD\u5357\u90E8\u548C\u5357\u6781\u571F\u5730"}},"latlng":[-49.25,69.167],"landlocked":false,"borders":[],"area":7747,"flag":"\uD83C\uDDF9\uD83C\uDDEB","demonyms":{"eng":{"f":"French","m":"French"},"fra":{"f":"Fran\xe7aise","m":"Fran\xe7ais"}}},{"name":{"common":"Antigua and Barbuda","official":"Antigua and Barbuda","native":{"eng":{"official":"Antigua and Barbuda","common":"Antigua and Barbuda"}}},"tld":[".ag"],"cca2":"AG","ccn3":"028","cca3":"ATG","cioc":"ANT","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"XCD":{"name":"Eastern Caribbean dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["268"]},"capital":["Saint John\'s"],"altSpellings":["AG"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Antigua a Barbuda","common":"Antigua a Barbuda"},"cym":{"official":"Antigwa a Barbiwda","common":"Antigwa a Barbiwda"},"deu":{"official":"Antigua und Barbuda","common":"Antigua und Barbuda"},"est":{"official":"Antigua ja Barbuda","common":"Antigua ja Barbuda"},"fin":{"official":"Antigua ja Barbuda","common":"Antigua ja Barbuda"},"fra":{"official":"Antigua -et-Barbuda","common":"Antigua-et-Barbuda"},"hrv":{"official":"Antigva i Barbuda","common":"Antigva i Barbuda"},"hun":{"official":"Antigua \xe9s Barbuda","common":"Antigua \xe9s Barbuda"},"ita":{"official":"Antigua e Barbuda","common":"Antigua e Barbuda"},"jpn":{"official":"\u30A2\u30F3\u30C1\u30B0\u30A2\u30D0\u30FC\u30D6\u30FC\u30C0","common":"\u30A2\u30F3\u30C6\u30A3\u30B0\u30A2\u30FB\u30D0\u30FC\u30D6\u30FC\u30C0"},"kor":{"official":"\uC564\uD2F0\uAC00 \uBC14\uBD80\uB2E4","common":"\uC564\uD2F0\uAC00 \uBC14\uBD80\uB2E4"},"nld":{"official":"Antigua en Barbuda","common":"Antigua en Barbuda"},"per":{"official":"\u0622\u0646\u062A\u06CC\u06AF\u0648\u0627 \u0648 \u0628\u0627\u0631\u0628\u0648\u062F\u0627","common":"\u0622\u0646\u062A\u06CC\u06AF\u0648\u0627 \u0648 \u0628\u0627\u0631\u0628\u0648\u062F\u0627"},"pol":{"official":"Antigua i Barbuda","common":"Antigua i Barbuda"},"por":{"official":"Antigua e Barbuda","common":"Ant\xedgua e Barbuda"},"rus":{"official":"\u0410\u043D\u0442\u0438\u0433\u0443\u0430 \u0438 \u0411\u0430\u0440\u0431\u0443\u0434\u0430","common":"\u0410\u043D\u0442\u0438\u0433\u0443\u0430 \u0438 \u0411\u0430\u0440\u0431\u0443\u0434\u0430"},"slk":{"official":"Antigua a Barbuda","common":"Antigua a Barbuda"},"spa":{"official":"Antigua y Barbuda","common":"Antigua y Barbuda"},"swe":{"official":"Antigua och Barbuda","common":"Antigua och Barbuda"},"urd":{"official":"\u0627\u06CC\u0646\u0679\u06CC\u06AF\u0648\u0627 \u0648 \u0628\u0627\u0631\u0628\u0648\u0688\u0627","common":"\u0627\u06CC\u0646\u0679\u06CC\u06AF\u0648\u0627 \u0648 \u0628\u0627\u0631\u0628\u0648\u0688\u0627"},"zho":{"official":"\u5B89\u63D0\u74DC\u548C\u5DF4\u5E03\u8FBE","common":"\u5B89\u63D0\u74DC\u548C\u5DF4\u5E03\u8FBE"}},"latlng":[17.05,-61.8],"landlocked":false,"borders":[],"area":442,"flag":"\uD83C\uDDE6\uD83C\uDDEC","demonyms":{"eng":{"f":"Antiguan, Barbudan","m":"Antiguan, Barbudan"},"fra":{"f":"Antiguaise et barbudienne","m":"Antiguaise et barbudien"}}},{"name":{"common":"Australia","official":"Commonwealth of Australia","native":{"eng":{"official":"Commonwealth of Australia","common":"Australia"}}},"tld":[".au"],"cca2":"AU","ccn3":"036","cca3":"AUS","cioc":"AUS","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"AUD":{"name":"Australian dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["1"]},"capital":["Canberra"],"altSpellings":["AU"],"region":"Oceania","subregion":"Australia and New Zealand","languages":{"eng":"English"},"translations":{"ces":{"official":"Australsk\xe9 spole\u010Denstv\xed","common":"Austr\xe1lie"},"cym":{"official":"Cymanwlad Awstralia","common":"Awstralia"},"deu":{"official":"Commonwealth Australien","common":"Australien"},"est":{"official":"Austraalia \xdchendus","common":"Austraalia"},"fin":{"official":"Australian liittovaltio","common":"Australia"},"fra":{"official":"Australie","common":"Australie"},"hrv":{"official":"Commonwealth of Australia","common":"Australija"},"hun":{"official":"Ausztr\xe1l \xc1llamsz\xf6vets\xe9g","common":"Ausztr\xe1lia"},"ita":{"official":"Commonwealth dell\'Australia","common":"Australia"},"jpn":{"official":"\u30AA\u30FC\u30B9\u30C8\u30E9\u30EA\u30A2\u9023\u90A6","common":"\u30AA\u30FC\u30B9\u30C8\u30E9\u30EA\u30A2"},"kor":{"official":"\uC624\uC2A4\uD2B8\uB808\uC77C\uB9AC\uC544 \uC5F0\uBC29","common":"\uD638\uC8FC"},"nld":{"official":"Gemenebest van Australi\xeb","common":"Australi\xeb"},"per":{"official":"\u0642\u0644\u0645\u0631\u0648 \u0647\u0645\u0633\u0648\u062F \u0627\u0633\u062A\u0631\u0627\u0644\u06CC\u0627","common":"\u0627\u0633\u062A\u0631\u0627\u0644\u06CC\u0627"},"pol":{"official":"Zwi\u0105zek Australijski","common":"Australia"},"por":{"official":"Comunidade da Austr\xe1lia","common":"Austr\xe1lia"},"rus":{"official":"\u0421\u043E\u0434\u0440\u0443\u0436\u0435\u0441\u0442\u0432\u043E \u0410\u0432\u0441\u0442\u0440\u0430\u043B\u0438\u0438","common":"\u0410\u0432\u0441\u0442\u0440\u0430\u043B\u0438\u044F"},"slk":{"official":"Austr\xe1lsky zv\xe4z","common":"Austr\xe1lia"},"spa":{"official":"Mancomunidad de Australia","common":"Australia"},"swe":{"official":"Australiska statsf\xf6rbundet","common":"Australien"},"urd":{"official":"\u062F\u0648\u0644\u062A\u0650 \u0645\u0634\u062A\u0631\u06A9\u06C1 \u0622\u0633\u0679\u0631\u06CC\u0644\u06CC\u0627","common":"\u0622\u0633\u0679\u0631\u06CC\u0644\u06CC\u0627"},"zho":{"official":"\u6FB3\u5927\u5229\u4E9A\u8054\u90A6","common":"\u6FB3\u5927\u5229\u4E9A"}},"latlng":[-27,133],"landlocked":false,"borders":[],"area":7692024,"flag":"\uD83C\uDDE6\uD83C\uDDFA","demonyms":{"eng":{"f":"Australian","m":"Australian"},"fra":{"f":"Australienne","m":"Australien"}}},{"name":{"common":"Austria","official":"Republic of Austria","native":{"bar":{"official":"Republik \xd6sterreich","common":"\xd6sterreich"}}},"tld":[".at"],"cca2":"AT","ccn3":"040","cca3":"AUT","cioc":"AUT","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+4","suffixes":["3"]},"capital":["Vienna"],"altSpellings":["AT","Osterreich","Oesterreich"],"region":"Europe","subregion":"Central Europe","languages":{"bar":"Austro-Bavarian German"},"translations":{"ces":{"official":"Rakousk\xe1 republika","common":"Rakousko"},"cym":{"official":"Gweriniaeth Awstria","common":"Awstria"},"deu":{"official":"Republik \xd6sterreich","common":"\xd6sterreich"},"est":{"official":"Austria Vabariik","common":"Austria"},"fin":{"official":"It\xe4vallan tasavalta","common":"It\xe4valta"},"fra":{"official":"R\xe9publique d\'Autriche","common":"Autriche"},"hrv":{"official":"Republika Austrija","common":"Austrija"},"hun":{"official":"Ausztria","common":"Ausztria"},"ita":{"official":"Repubblica d\'Austria","common":"Austria"},"jpn":{"official":"\u30AA\u30FC\u30B9\u30C8\u30EA\u30A2\u5171\u548C\u56FD","common":"\u30AA\u30FC\u30B9\u30C8\u30EA\u30A2"},"kor":{"official":"\uC624\uC2A4\uD2B8\uB9AC\uC544 \uACF5\uD654\uAD6D","common":"\uC624\uC2A4\uD2B8\uB9AC\uC544"},"nld":{"official":"Republiek Oostenrijk","common":"Oostenrijk"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u062A\u0631\u06CC\u0634","common":"\u0627\u062A\u0631\u06CC\u0634"},"pol":{"official":"Republika Austrii","common":"Austria"},"por":{"official":"Rep\xfablica da \xc1ustria","common":"\xc1ustria"},"rus":{"official":"\u0410\u0432\u0441\u0442\u0440\u0438\u0439\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u0410\u0432\u0441\u0442\u0440\u0438\u044F"},"slk":{"official":"Rak\xfaska republika","common":"Rak\xfasko"},"spa":{"official":"Rep\xfablica de Austria","common":"Austria"},"swe":{"official":"Republiken \xd6sterrike","common":"\xd6sterrike"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0622\u0633\u0679\u0631\u06CC\u0627","common":"\u0622\u0633\u0679\u0631\u06CC\u0627"},"zho":{"official":"\u5965\u5730\u5229\u5171\u548C\u56FD","common":"\u5965\u5730\u5229"}},"latlng":[47.33333333,13.33333333],"landlocked":true,"borders":["CZE","DEU","HUN","ITA","LIE","SVK","SVN","CHE"],"area":83871,"flag":"\uD83C\uDDE6\uD83C\uDDF9","demonyms":{"eng":{"f":"Austrian","m":"Austrian"},"fra":{"f":"Autrichienne","m":"Autrichien"}}},{"name":{"common":"Azerbaijan","official":"Republic of Azerbaijan","native":{"aze":{"official":"Az\u0259rbaycan Respublikas\u0131","common":"Az\u0259rbaycan"},"rus":{"official":"\u0410\u0437\u0435\u0440\u0431\u0430\u0439\u0434\u0436\u0430\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u0410\u0437\u0435\u0440\u0431\u0430\u0439\u0434\u0436\u0430\u043D"}}},"tld":[".az"],"cca2":"AZ","ccn3":"031","cca3":"AZE","cioc":"AZE","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"AZN":{"name":"Azerbaijani manat","symbol":"\u20BC"}},"idd":{"root":"+9","suffixes":["94"]},"capital":["Baku"],"altSpellings":["AZ","Republic of Azerbaijan","Az\u0259rbaycan Respublikas\u0131"],"region":"Asia","subregion":"Western Asia","languages":{"aze":"Azerbaijani","rus":"Russian"},"translations":{"ces":{"official":"\xc1zerb\xe1jd\u017E\xe1nsk\xe1 republika","common":"\xc1zerb\xe1jd\u017E\xe1n"},"cym":{"official":"Gweriniaeth Aserbaijan","common":"Aserbaijan"},"deu":{"official":"Republik Aserbaidschan","common":"Aserbaidschan"},"est":{"official":"Aserbaid\u017Eaani Vabariik","common":"Aserbaid\u017Eaan"},"fin":{"official":"Azerbaidzanin tasavalta","common":"Azerbaidzan"},"fra":{"official":"R\xe9publique d\'Azerba\xefdjan","common":"Azerba\xefdjan"},"hrv":{"official":"Republika Azerbajd\u017Ean","common":"Azerbajd\u017Ean"},"hun":{"official":"Azerbajdzs\xe1n","common":"Azerbajdzs\xe1n"},"ita":{"official":"Repubblica dell\'Azerbaigian","common":"Azerbaijan"},"jpn":{"official":"\u30A2\u30BC\u30EB\u30D0\u30A4\u30B8\u30E3\u30F3\u5171\u548C\u56FD","common":"\u30A2\u30BC\u30EB\u30D0\u30A4\u30B8\u30E3\u30F3"},"kor":{"official":"\uC544\uC81C\uB974\uBC14\uC774\uC794 \uACF5\uD654\uAD6D","common":"\uC544\uC81C\uB974\uBC14\uC774\uC794"},"nld":{"official":"Republiek Azerbeidzjan","common":"Azerbeidzjan"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0622\u0630\u0631\u0628\u0627\u06CC\u062C\u0627\u0646","common":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0622\u0630\u0631\u0628\u0627\u06CC\u062C\u0627\u0646"},"pol":{"official":"Republika Azerbejd\u017Canu","common":"Azerbejd\u017Can"},"por":{"official":"Rep\xfablica do Azerbaij\xe3o","common":"Azerbeij\xe3o"},"rus":{"official":"\u0410\u0437\u0435\u0440\u0431\u0430\u0439\u0434\u0436\u0430\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u0410\u0437\u0435\u0440\u0431\u0430\u0439\u0434\u0436\u0430\u043D"},"slk":{"official":"Azerbaj\u01C6ansk\xe1 republika","common":"Azerbaj\u01C7an"},"spa":{"official":"Rep\xfablica de Azerbaiy\xe1n","common":"Azerbaiy\xe1n"},"swe":{"official":"Republiken Azerbajdzjan","common":"Azerbajdzjan"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0622\u0630\u0631\u0628\u0627\u0626\u06CC\u062C\u0627\u0646","common":"\u0622\u0630\u0631\u0628\u0627\u0626\u06CC\u062C\u0627\u0646"},"zho":{"official":"\u963F\u585E\u62DC\u7586\u5171\u548C\u56FD","common":"\u963F\u585E\u62DC\u7586"}},"latlng":[40.5,47.5],"landlocked":true,"borders":["ARM","GEO","IRN","RUS","TUR"],"area":86600,"flag":"\uD83C\uDDE6\uD83C\uDDFF","demonyms":{"eng":{"f":"Azerbaijani","m":"Azerbaijani"},"fra":{"f":"Azerba\xefdjanaise","m":"Azerba\xefdjanais"}}},{"name":{"common":"Burundi","official":"Republic of Burundi","native":{"fra":{"official":"R\xe9publique du Burundi","common":"Burundi"},"run":{"official":"Republika y\'Uburundi ","common":"Uburundi"}}},"tld":[".bi"],"cca2":"BI","ccn3":"108","cca3":"BDI","cioc":"BDI","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"BIF":{"name":"Burundian franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["57"]},"capital":["Gitega"],"altSpellings":["BI","Republic of Burundi","Republika y\'Uburundi","R\xe9publique du Burundi"],"region":"Africa","subregion":"Eastern Africa","languages":{"fra":"French","run":"Kirundi"},"translations":{"ces":{"official":"Burundsk\xe1 republika","common":"Burundi"},"cym":{"official":"Gweriniaeth Bwrwndi","common":"Bwrwndi"},"deu":{"official":"Republik Burundi","common":"Burundi"},"est":{"official":"Burundi Vabariik","common":"Burundi"},"fin":{"official":"Burundin tasavalta","common":"Burundi"},"fra":{"official":"R\xe9publique du Burundi","common":"Burundi"},"hrv":{"official":"Burundi","common":"Burundi"},"hun":{"official":"Burundi","common":"Burundi"},"ita":{"official":"Repubblica del Burundi","common":"Burundi"},"jpn":{"official":"\u30D6\u30EB\u30F3\u30B8\u5171\u548C\u56FD","common":"\u30D6\u30EB\u30F3\u30B8"},"kor":{"official":"\uBD80\uB8EC\uB514","common":"\uBD80\uB8EC\uB514"},"nld":{"official":"Republiek Burundi","common":"Burundi"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0628\u0648\u0631\u0648\u0646\u062F\u06CC","common":"\u0628\u0648\u0631\u0648\u0646\u062F\u06CC"},"pol":{"official":"Republika Burundi","common":"Burundi"},"por":{"official":"Rep\xfablica do Burundi","common":"Burundi"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0411\u0443\u0440\u0443\u043D\u0434\u0438","common":"\u0411\u0443\u0440\u0443\u043D\u0434\u0438"},"slk":{"official":"Burundsk\xe1 republika","common":"Burundi"},"spa":{"official":"Rep\xfablica de Burundi","common":"Burundi"},"swe":{"official":"Republiken Burundi","common":"Burundi"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0628\u0631\u0648\u0646\u0688\u06CC","common":"\u0628\u0631\u0648\u0646\u0688\u06CC"},"zho":{"official":"\u5E03\u9686\u8FEA\u5171\u548C\u56FD","common":"\u5E03\u9686\u8FEA"}},"latlng":[-3.5,30],"landlocked":true,"borders":["COD","RWA","TZA"],"area":27834,"flag":"\uD83C\uDDE7\uD83C\uDDEE","demonyms":{"eng":{"f":"Burundian","m":"Burundian"},"fra":{"f":"Burundaise","m":"Burundais"}}},{"name":{"common":"Belgium","official":"Kingdom of Belgium","native":{"deu":{"official":"K\xf6nigreich Belgien","common":"Belgien"},"fra":{"official":"Royaume de Belgique","common":"Belgique"},"nld":{"official":"Koninkrijk Belgi\xeb","common":"Belgi\xeb"}}},"tld":[".be"],"cca2":"BE","ccn3":"056","cca3":"BEL","cioc":"BEL","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["2"]},"capital":["Brussels"],"altSpellings":["BE","Belgi\xeb","Belgie","Belgien","Belgique","Kingdom of Belgium","Koninkrijk Belgi\xeb","Royaume de Belgique","K\xf6nigreich Belgien"],"region":"Europe","subregion":"Western Europe","languages":{"deu":"German","fra":"French","nld":"Dutch"},"translations":{"ces":{"official":"Belgick\xe9 kr\xe1lovstv\xed","common":"Belgie"},"cym":{"official":"Teyrnas Gwlad Belg","common":"Gwlad Belg"},"deu":{"official":"K\xf6nigreich Belgien","common":"Belgien"},"est":{"official":"Belgia Kuningriik","common":"Belgia"},"fin":{"official":"Belgian kuningaskunta","common":"Belgia"},"fra":{"official":"Royaume de Belgique","common":"Belgique"},"hrv":{"official":"Kraljevina Belgija","common":"Belgija"},"hun":{"official":"Belga Kir\xe1lys\xe1g","common":"Belgium"},"ita":{"official":"Regno del Belgio","common":"Belgio"},"jpn":{"official":"\u30D9\u30EB\u30AE\u30FC\u738B\u56FD","common":"\u30D9\u30EB\u30AE\u30FC"},"kor":{"official":"\uBCA8\uAE30\uC5D0 \uC655\uAD6D","common":"\uBCA8\uAE30\uC5D0"},"nld":{"official":"Koninkrijk Belgi\xeb","common":"Belgi\xeb"},"per":{"official":"\u067E\u0627\u062F\u0634\u0627\u0647\u06CC \u0628\u0644\u0698\u06CC\u06A9","common":"\u0628\u0644\u0698\u06CC\u06A9"},"pol":{"official":"Kr\xf3lestwo Belgii","common":"Belgia"},"por":{"official":"Reino da B\xe9lgica","common":"B\xe9lgica"},"rus":{"official":"\u041A\u043E\u0440\u043E\u043B\u0435\u0432\u0441\u0442\u0432\u043E \u0411\u0435\u043B\u044C\u0433\u0438\u044F","common":"\u0411\u0435\u043B\u044C\u0433\u0438\u044F"},"slk":{"official":"Belgick\xe9 kr\xe1\u013Eovstvo","common":"Belgicko"},"spa":{"official":"Reino de B\xe9lgica","common":"B\xe9lgica"},"swe":{"official":"Konungariket Belgien","common":"Belgien"},"urd":{"official":"\u0645\u0645\u0644\u06A9\u062A\u0650 \u0628\u0644\u062C\u0626\u06CC\u0645","common":"\u0628\u0644\u062C\u0626\u06CC\u0645"},"zho":{"official":"\u6BD4\u5229\u65F6\u738B\u56FD","common":"\u6BD4\u5229\u65F6"}},"latlng":[50.83333333,4],"landlocked":false,"borders":["FRA","DEU","LUX","NLD"],"area":30528,"flag":"\uD83C\uDDE7\uD83C\uDDEA","demonyms":{"eng":{"f":"Belgian","m":"Belgian"},"fra":{"f":"Belge","m":"Belge"}}},{"name":{"common":"Benin","official":"Republic of Benin","native":{"fra":{"official":"R\xe9publique du B\xe9nin","common":"B\xe9nin"}}},"tld":[".bj"],"cca2":"BJ","ccn3":"204","cca3":"BEN","cioc":"BEN","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"XOF":{"name":"West African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["29"]},"capital":["Porto-Novo"],"altSpellings":["BJ","Republic of Benin","R\xe9publique du B\xe9nin"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"ces":{"official":"Beninsk\xe1 republika","common":"Benin"},"cym":{"official":"Gweriniaeth Benin","common":"Benin"},"deu":{"official":"Republik Benin","common":"Benin"},"est":{"official":"Benini Vabariik","common":"Benin"},"fin":{"official":"Beninin tasavalta","common":"Benin"},"fra":{"official":"R\xe9publique du B\xe9nin","common":"B\xe9nin"},"hrv":{"official":"Republika Benin","common":"Benin"},"hun":{"official":"Benini K\xf6zt\xe1rsas\xe1g","common":"Benin"},"ita":{"official":"Repubblica del Benin","common":"Benin"},"jpn":{"official":"\u30D9\u30CA\u30F3\u5171\u548C\u56FD","common":"\u30D9\u30CA\u30F3"},"kor":{"official":"\uBCA0\uB0C9 \uACF5\uD654\uAD6D","common":"\uBCA0\uB0C9"},"nld":{"official":"Republiek Benin","common":"Benin"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0628\u0646\u06CC\u0646","common":"\u0628\u0646\u06CC\u0646"},"pol":{"official":"Benin","common":"Benin"},"por":{"official":"Rep\xfablica do Benin","common":"Benin"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0411\u0435\u043D\u0438\u043D","common":"\u0411\u0435\u043D\u0438\u043D"},"slk":{"official":"Beninsk\xe1 republika","common":"Benin"},"spa":{"official":"Rep\xfablica de Benin","common":"Ben\xedn"},"swe":{"official":"Republiken Benin","common":"Benin"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0628\u06CC\u0646\u0646","common":"\u0628\u06CC\u0646\u0646"},"zho":{"official":"\u8D1D\u5B81\u5171\u548C\u56FD","common":"\u8D1D\u5B81"}},"latlng":[9.5,2.25],"landlocked":false,"borders":["BFA","NER","NGA","TGO"],"area":112622,"flag":"\uD83C\uDDE7\uD83C\uDDEF","demonyms":{"eng":{"f":"Beninese","m":"Beninese"},"fra":{"f":"B\xe9ninoise","m":"B\xe9ninois"}}},{"name":{"common":"Burkina Faso","official":"Burkina Faso","native":{"fra":{"official":"R\xe9publique du Burkina","common":"Burkina Faso"}}},"tld":[".bf"],"cca2":"BF","ccn3":"854","cca3":"BFA","cioc":"BUR","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"XOF":{"name":"West African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["26"]},"capital":["Ouagadougou"],"altSpellings":["BF"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"ces":{"official":"Burkina Faso","common":"Burkina Faso"},"cym":{"official":"Bwrcina Ffaso","common":"Bwrcina Ffaso"},"deu":{"official":"Burkina Faso","common":"Burkina Faso"},"est":{"official":"Burkina Faso","common":"Burkina Faso"},"fin":{"official":"Burkina Faso","common":"Burkina Faso"},"fra":{"official":"R\xe9publique du Burkina","common":"Burkina Faso"},"hrv":{"official":"Burkina Faso","common":"Burkina Faso"},"hun":{"official":"Burkina Faso","common":"Burkina"},"ita":{"official":"Burkina Faso","common":"Burkina Faso"},"jpn":{"official":"\u30D6\u30EB\u30AD\u30CA\u30D5\u30A1\u30BD","common":"\u30D6\u30EB\u30AD\u30CA\u30D5\u30A1\u30BD"},"kor":{"official":"\uBD80\uB974\uD0A4\uB098\uD30C\uC18C","common":"\uBD80\uB974\uD0A4\uB098\uD30C\uC18C"},"nld":{"official":"Burkina Faso","common":"Burkina Faso"},"per":{"official":"\u0628\u0648\u0631\u06A9\u06CC\u0646\u0627\u0641\u0627\u0633\u0648","common":"\u0628\u0648\u0631\u06A9\u06CC\u0646\u0627\u0641\u0627\u0633\u0648"},"pol":{"official":"Burkina Faso","common":"Burkina Faso"},"por":{"official":"Burkina Faso","common":"Burkina Faso"},"rus":{"official":"\u0411\u0443\u0440\u043A\u0438\u043D\u0430 -\u0424\u0430\u0441\u043E","common":"\u0411\u0443\u0440\u043A\u0438\u043D\u0430-\u0424\u0430\u0441\u043E"},"slk":{"official":"Burkina Faso","common":"Burkina Faso"},"spa":{"official":"Burkina Faso","common":"Burkina Faso"},"swe":{"official":"Burkina Faso","common":"Burkina Faso"},"urd":{"official":"\u0628\u0631\u06A9\u06CC\u0646\u0627 \u0641\u0627\u0633\u0648","common":"\u0628\u0631\u06A9\u06CC\u0646\u0627 \u0641\u0627\u0633\u0648"},"zho":{"official":"\u5E03\u57FA\u7EB3\u6CD5\u7D22","common":"\u5E03\u57FA\u7EB3\u6CD5\u7D22"}},"latlng":[13,-2],"landlocked":true,"borders":["BEN","CIV","GHA","MLI","NER","TGO"],"area":272967,"flag":"\uD83C\uDDE7\uD83C\uDDEB","demonyms":{"eng":{"f":"Burkinabe","m":"Burkinabe"},"fra":{"f":"Burkinab\xe9e","m":"Burkinab\xe9"}}},{"name":{"common":"Bangladesh","official":"People\'s Republic of Bangladesh","native":{"ben":{"official":"\u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6 \u0997\u09A3\u09AA\u09CD\u09B0\u099C\u09BE\u09A4\u09A8\u09CD\u09A4\u09CD\u09B0\u09C0","common":"\u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6"}}},"tld":[".bd"],"cca2":"BD","ccn3":"050","cca3":"BGD","cioc":"BAN","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"BDT":{"name":"Bangladeshi taka","symbol":"\u09F3"}},"idd":{"root":"+8","suffixes":["80"]},"capital":["Dhaka"],"altSpellings":["BD","People\'s Republic of Bangladesh","G\xf4n\xf4pr\xf4jat\xf4ntri Bangladesh"],"region":"Asia","subregion":"Southern Asia","languages":{"ben":"Bengali"},"translations":{"ces":{"official":"Banglad\xe9\u0161sk\xe1 lidov\xe1 republika","common":"Banglad\xe9\u0161"},"cym":{"official":"Gweriniaeth Pobl Bangladesh","common":"Bangladesh"},"deu":{"official":"Volksrepublik Bangladesch","common":"Bangladesch"},"est":{"official":"Bangladeshi Rahvavabariik","common":"Bangladesh"},"fin":{"official":"Bangladeshin kansantasavalta","common":"Bangladesh"},"fra":{"official":"La R\xe9publique populaire du Bangladesh","common":"Bangladesh"},"hrv":{"official":"Narodna Republika Banglade\u0161","common":"Banglade\u0161"},"hun":{"official":"Banglades","common":"Banglades"},"ita":{"official":"Repubblica popolare del Bangladesh","common":"Bangladesh"},"jpn":{"official":"\u30D0\u30F3\u30B0\u30E9\u30C7\u30B7\u30E5\u4EBA\u6C11\u5171\u548C\u56FD","common":"\u30D0\u30F3\u30B0\u30E9\u30C7\u30B7\u30E5"},"kor":{"official":"\uBC29\uAE00\uB77C\uB370\uC2DC \uC778\uBBFC \uACF5\uD654\uAD6D","common":"\uBC29\uAE00\uB77C\uB370\uC2DC"},"nld":{"official":"Volksrepubliek Bangladesh","common":"Bangladesh"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u062E\u0644\u0642 \u0628\u0646\u06AF\u0644\u0627\u062F\u0634","common":"\u0628\u0646\u06AF\u0644\u0627\u062F\u0634"},"pol":{"official":"Ludowa Republika Bangladeszu","common":"Bangladesz"},"por":{"official":"Rep\xfablica Popular do Bangladesh","common":"Bangladesh"},"rus":{"official":"\u041D\u0430\u0440\u043E\u0434\u043D\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0411\u0430\u043D\u0433\u043B\u0430\u0434\u0435\u0448","common":"\u0411\u0430\u043D\u0433\u043B\u0430\u0434\u0435\u0448"},"slk":{"official":"Banglad\xe9\u0161ska \u013Eudov\xe1 republika","common":"Banglad\xe9\u0161"},"spa":{"official":"Rep\xfablica Popular de Bangladesh","common":"Bangladesh"},"swe":{"official":"Folkrepubliken Bangladesh","common":"Bangladesh"},"urd":{"official":"\u0639\u0648\u0627\u0645\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0628\u0646\u06AF\u0644\u06C1 \u062F\u06CC\u0634","common":"\u0628\u0646\u06AF\u0644\u06C1 \u062F\u06CC\u0634"},"zho":{"official":"\u5B5F\u52A0\u62C9\u4EBA\u6C11\u5171\u548C\u56FD","common":"\u5B5F\u52A0\u62C9\u56FD"}},"latlng":[24,90],"landlocked":false,"borders":["MMR","IND"],"area":147570,"flag":"\uD83C\uDDE7\uD83C\uDDE9","demonyms":{"eng":{"f":"Bangladeshi","m":"Bangladeshi"},"fra":{"f":"Bangladaise","m":"Bangladais"}}},{"name":{"common":"Bulgaria","official":"Republic of Bulgaria","native":{"bul":{"official":"\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F","common":"\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F"}}},"tld":[".bg"],"cca2":"BG","ccn3":"100","cca3":"BGR","cioc":"BUL","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"BGN":{"name":"Bulgarian lev","symbol":"\u043B\u0432"}},"idd":{"root":"+3","suffixes":["59"]},"capital":["Sofia"],"altSpellings":["BG","Republic of Bulgaria","\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F"],"region":"Europe","subregion":"Southeast Europe","languages":{"bul":"Bulgarian"},"translations":{"ces":{"official":"Bulharsk\xe1 republika","common":"Bulharsko"},"cym":{"official":"Gweriniaeth Bwlgaria","common":"Bwlgaria"},"deu":{"official":"Republik Bulgarien","common":"Bulgarien"},"est":{"official":"Bulgaaria Vabariik","common":"Bulgaaria"},"fin":{"official":"Bulgarian tasavalta","common":"Bulgaria"},"fra":{"official":"R\xe9publique de Bulgarie","common":"Bulgarie"},"hrv":{"official":"Republika Bugarska","common":"Bugarska"},"hun":{"official":"Bolg\xe1r K\xf6zt\xe1rsas\xe1g","common":"Bulg\xe1ria"},"ita":{"official":"Repubblica di Bulgaria","common":"Bulgaria"},"jpn":{"official":"\u30D6\u30EB\u30AC\u30EA\u30A2\u5171\u548C\u56FD","common":"\u30D6\u30EB\u30AC\u30EA\u30A2"},"kor":{"official":"\uBD88\uAC00\uB9AC\uC544 \uACF5\uD654\uAD6D","common":"\uBD88\uAC00\uB9AC\uC544"},"nld":{"official":"Republiek Bulgarije","common":"Bulgarije"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0628\u0644\u063A\u0627\u0631\u0633\u062A\u0627\u0646","common":"\u0628\u0644\u063A\u0627\u0631\u0633\u062A\u0627\u0646"},"pol":{"official":"Republika Bu\u0142garii","common":"Bu\u0142garia"},"por":{"official":"Rep\xfablica da Bulg\xe1ria","common":"Bulg\xe1ria"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0411\u043E\u043B\u0433\u0430\u0440\u0438\u044F","common":"\u0411\u043E\u043B\u0433\u0430\u0440\u0438\u044F"},"slk":{"official":"Bulharsk\xe1 republika","common":"Bulharsko"},"spa":{"official":"Rep\xfablica de Bulgaria","common":"Bulgaria"},"swe":{"official":"Republiken Bulgarien","common":"Bulgarien"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0628\u0644\u063A\u0627\u0631\u06CC\u06C1","common":"\u0628\u0644\u063A\u0627\u0631\u06CC\u06C1"},"zho":{"official":"\u4FDD\u52A0\u5229\u4E9A\u5171\u548C\u56FD","common":"\u4FDD\u52A0\u5229\u4E9A"}},"latlng":[43,25],"landlocked":false,"borders":["GRC","MKD","ROU","SRB","TUR"],"area":110879,"flag":"\uD83C\uDDE7\uD83C\uDDEC","demonyms":{"eng":{"f":"Bulgarian","m":"Bulgarian"},"fra":{"f":"Bulgare","m":"Bulgare"}}},{"name":{"common":"Bahrain","official":"Kingdom of Bahrain","native":{"ara":{"official":"\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0628\u062D\u0631\u064A\u0646","common":"\u200F\u0627\u0644\u0628\u062D\u0631\u064A\u0646"}}},"tld":[".bh"],"cca2":"BH","ccn3":"048","cca3":"BHR","cioc":"BRN","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"BHD":{"name":"Bahraini dinar","symbol":".\u062F.\u0628"}},"idd":{"root":"+9","suffixes":["73"]},"capital":["Manama"],"altSpellings":["BH","Kingdom of Bahrain","Mamlakat al-Ba\u1E25rayn"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Kr\xe1lovstv\xed Bahrajn","common":"Bahrajn"},"cym":{"official":"Teyrnas Bahrein","common":"Bahrain"},"deu":{"official":"K\xf6nigreich Bahrain","common":"Bahrain"},"est":{"official":"Bahreini Kuningriik","common":"Bahrein"},"fin":{"official":"Bahrainin kuningaskunta","common":"Bahrain"},"fra":{"official":"Royaume de Bahre\xefn","common":"Bahre\xefn"},"hrv":{"official":"Kraljevina Bahrein","common":"Bahrein"},"hun":{"official":"Bahreini Kir\xe1lys\xe1g","common":"Bahrein"},"ita":{"official":"Regno del Bahrain","common":"Bahrein"},"jpn":{"official":"\u30D0\u30FC\u30EC\u30FC\u30F3\u738B\u56FD","common":"\u30D0\u30FC\u30EC\u30FC\u30F3"},"kor":{"official":"\uBC14\uB808\uC778 \uC655\uAD6D","common":"\uBC14\uB808\uC778"},"nld":{"official":"Koninkrijk Bahrein","common":"Bahrein"},"per":{"official":"\u067E\u0627\u062F\u0634\u0627\u0647\u06CC \u0628\u062D\u0631\u06CC\u0646","common":"\u0628\u062D\u0631\u06CC\u0646"},"pol":{"official":"Kr\xf3lestwo Bahrajnu","common":"Bahrajn"},"por":{"official":"Reino do Bahrein","common":"Bahrein"},"rus":{"official":"\u041A\u043E\u0440\u043E\u043B\u0435\u0432\u0441\u0442\u0432\u043E \u0411\u0430\u0445\u0440\u0435\u0439\u043D","common":"\u0411\u0430\u0445\u0440\u0435\u0439\u043D"},"slk":{"official":"Bahrajnsk\xe9 kr\xe1\u013Eovstvo","common":"Bahrajn"},"spa":{"official":"Reino de Bahrein","common":"Bahrein"},"swe":{"official":"Konungariket Bahrain","common":"Bahrain"},"urd":{"official":"\u0645\u0645\u0644\u06A9\u062A\u0650 \u0628\u062D\u0631\u06CC\u0646","common":"\u0628\u062D\u0631\u06CC\u0646"},"zho":{"official":"\u5DF4\u6797\u738B\u56FD","common":"\u5DF4\u6797"}},"latlng":[26,50.55],"landlocked":false,"borders":[],"area":765,"flag":"\uD83C\uDDE7\uD83C\uDDED","demonyms":{"eng":{"f":"Bahraini","m":"Bahraini"},"fra":{"f":"Bahre\xefnienne","m":"Bahre\xefnien"}}},{"name":{"common":"Bahamas","official":"Commonwealth of the Bahamas","native":{"eng":{"official":"Commonwealth of the Bahamas","common":"Bahamas"}}},"tld":[".bs"],"cca2":"BS","ccn3":"044","cca3":"BHS","cioc":"BAH","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"BSD":{"name":"Bahamian dollar","symbol":"$"},"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["242"]},"capital":["Nassau"],"altSpellings":["BS","Commonwealth of the Bahamas"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Bahamsk\xe9 spole\u010Denstv\xed","common":"Bahamy"},"cym":{"official":"Cymanwlad y Bahamas","common":"Bahamas"},"deu":{"official":"Commonwealth der Bahamas","common":"Bahamas"},"est":{"official":"Bahama \xdchendus","common":"Bahama"},"fin":{"official":"Bahaman liittovaltio","common":"Bahamasaaret"},"fra":{"official":"Commonwealth des Bahamas","common":"Bahamas"},"hrv":{"official":"Zajednica Bahama","common":"Bahami"},"hun":{"official":"Bahamai K\xf6z\xf6ss\xe9g","common":"Bahama-szigetek"},"ita":{"official":"Commonwealth delle Bahamas","common":"Bahamas"},"jpn":{"official":"\u30D0\u30CF\u30DE","common":"\u30D0\u30CF\u30DE"},"kor":{"official":"\uBC14\uD558\uB9C8 \uC5F0\uBC29","common":"\uBC14\uD558\uB9C8"},"nld":{"official":"Gemenebest van de Bahama\'s","common":"Bahama\u2019s"},"per":{"official":"\u0642\u0644\u0645\u0631\u0648 \u0647\u0645\u0633\u0648\u062F \u0628\u0627\u0647\u0627\u0645\u0627","common":"\u0628\u0627\u0647\u0627\u0645\u0627"},"pol":{"official":"Bahamy","common":"Bahamy"},"por":{"official":"Comunidade das Bahamas","common":"Bahamas"},"rus":{"official":"\u0421\u043E\u0434\u0440\u0443\u0436\u0435\u0441\u0442\u0432\u043E \u0411\u0430\u0433\u0430\u043C\u0441\u043A\u0438\u0445 \u041E\u0441\u0442\u0440\u043E\u0432\u043E\u0432","common":"\u0411\u0430\u0433\u0430\u043C\u0441\u043A\u0438\u0435 \u041E\u0441\u0442\u0440\u043E\u0432\u0430"},"slk":{"official":"Bahamsk\xe9 spolo\u010Denstvo","common":"Bahamy"},"spa":{"official":"Commonwealth de las Bahamas","common":"Bahamas"},"swe":{"official":"Samv\xe4ldet Bahamas","common":"Bahamas"},"urd":{"official":"\u062F\u0648\u0644\u062A\u0650 \u0645\u0634\u062A\u0631\u06A9\u06C1 \u0628\u06C1\u0627\u0645\u0627\u0633","common":"\u0628\u06C1\u0627\u0645\u0627\u0633"},"zho":{"official":"\u5DF4\u54C8\u9A6C\u8054\u90A6","common":"\u5DF4\u54C8\u9A6C"}},"latlng":[24.25,-76],"landlocked":false,"borders":[],"area":13943,"flag":"\uD83C\uDDE7\uD83C\uDDF8","demonyms":{"eng":{"f":"Bahamian","m":"Bahamian"},"fra":{"f":"Bahamienne","m":"Bahamien"}}},{"name":{"common":"Bosnia and Herzegovina","official":"Bosnia and Herzegovina","native":{"bos":{"official":"Bosna i Hercegovina","common":"Bosna i Hercegovina"},"hrv":{"official":"Bosna i Hercegovina","common":"Bosna i Hercegovina"},"srp":{"official":"\u0411\u043E\u0441\u043Da \u0438 \u0425\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430","common":"\u0411\u043E\u0441\u043Da \u0438 \u0425\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430"}}},"tld":[".ba"],"cca2":"BA","ccn3":"070","cca3":"BIH","cioc":"BIH","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"BAM":{"name":"Bosnia and Herzegovina convertible mark","symbol":"KM"}},"idd":{"root":"+3","suffixes":["87"]},"capital":["Sarajevo"],"altSpellings":["BA","Bosnia-Herzegovina","\u0411\u043E\u0441\u043D\u0430 \u0438 \u0425\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430"],"region":"Europe","subregion":"Southeast Europe","languages":{"bos":"Bosnian","hrv":"Croatian","srp":"Serbian"},"translations":{"ces":{"official":"Bosna a Hercegovina","common":"Bosna a Hercegovina"},"cym":{"official":"Bosnia a Hercegovina","common":"Bosnia a Hercegovina"},"deu":{"official":"Bosnien und Herzegowina","common":"Bosnien und Herzegowina"},"est":{"official":"Bosnia ja Hertsegoviina","common":"Bosnia ja Hertsegoviina"},"fin":{"official":"Bosnia ja Hertsegovina","common":"Bosnia ja Hertsegovina"},"fra":{"official":"Bosnie-et-Herz\xe9govine","common":"Bosnie-Herz\xe9govine"},"hrv":{"official":"Bosna i Hercegovina","common":"Bosna i Hercegovina"},"hun":{"official":"Bosznia-Hercegovina","common":"Bosznia-Hercegovina"},"ita":{"official":"Bosnia-Erzegovina","common":"Bosnia ed Erzegovina"},"jpn":{"official":"\u30DC\u30B9\u30CB\u30A2\xb7\u30D8\u30EB\u30C4\u30A7\u30B4\u30D3\u30CA","common":"\u30DC\u30B9\u30CB\u30A2\u30FB\u30D8\u30EB\u30C4\u30A7\u30B4\u30D3\u30CA"},"kor":{"official":"\uBCF4\uC2A4\uB2C8\uC544 \uD5E4\uB974\uCCB4\uACE0\uBE44\uB098","common":"\uBCF4\uC2A4\uB2C8\uC544 \uD5E4\uB974\uCCB4\uACE0\uBE44\uB098"},"nld":{"official":"Bosni\xeb-Herzegovina","common":"Bosni\xeb en Herzegovina"},"per":{"official":"\u0628\u0648\u0633\u0646\u06CC \u0648 \u0647\u0631\u0632\u06AF\u0648\u06CC\u0646","common":"\u0628\u0648\u0633\u0646\u06CC \u0648 \u0647\u0631\u0632\u06AF\u0648\u06CC\u0646"},"pol":{"official":"Bo\u015Bnia i Hercegowina","common":"Bo\u015Bnia i Hercegowina"},"por":{"official":"B\xf3snia e Herzegovina","common":"B\xf3snia e Herzegovina"},"rus":{"official":"\u0411\u043E\u0441\u043D\u0438\u044F \u0438 \u0413\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430","common":"\u0411\u043E\u0441\u043D\u0438\u044F \u0438 \u0413\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430"},"slk":{"official":"Republika Bosny a Hercegoviny","common":"Bosna a Hercegovina"},"spa":{"official":"Bosnia y Herzegovina","common":"Bosnia y Herzegovina"},"swe":{"official":"Bosnien och Hercegovina","common":"Bosnien och Hercegovina"},"urd":{"official":"\u0628\u0648\u0633\u0646\u06CC\u0627 \u0648 \u06C1\u0631\u0632\u06CC\u06AF\u0648\u0648\u06CC\u0646\u0627","common":"\u0628\u0648\u0633\u0646\u06CC\u0627 \u0648 \u06C1\u0631\u0632\u06CC\u06AF\u0648\u0648\u06CC\u0646\u0627"},"zho":{"official":"\u6CE2\u65AF\u5C3C\u4E9A\u548C\u9ED1\u585E\u54E5\u7EF4\u90A3","common":"\u6CE2\u65AF\u5C3C\u4E9A\u548C\u9ED1\u585E\u54E5\u7EF4\u90A3"}},"latlng":[44,18],"landlocked":false,"borders":["HRV","MNE","SRB"],"area":51209,"flag":"\uD83C\uDDE7\uD83C\uDDE6","demonyms":{"eng":{"f":"Bosnian, Herzegovinian","m":"Bosnian, Herzegovinian"},"fra":{"f":"Bosnienne","m":"Bosnien"}}},{"name":{"common":"Saint Barth\xe9lemy","official":"Collectivity of Saint Barth\xe9lemy","native":{"fra":{"official":"Collectivit\xe9 de Saint-Barth\xe9lemy","common":"Saint-Barth\xe9lemy"}}},"tld":[".bl"],"cca2":"BL","ccn3":"652","cca3":"BLM","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+5","suffixes":["90"]},"capital":["Gustavia"],"altSpellings":["BL","St. Barthelemy","Collectivity of Saint Barth\xe9lemy","Collectivit\xe9 de Saint-Barth\xe9lemy"],"region":"Americas","subregion":"Caribbean","languages":{"fra":"French"},"translations":{"ces":{"official":"Svat\xfd Bartolom\u011Bj","common":"Svat\xfd Bartolom\u011Bj"},"deu":{"official":"Gebietsk\xf6rperschaft Saint-Barth\xe9lemy","common":"Saint-Barth\xe9lemy"},"est":{"official":"Saint-Barth\xe9lemy territoriaal\xfchendus","common":"Saint-Barth\xe9lemy"},"fin":{"official":"Saint-Barth\xe9lemyn yhteis\xf6","common":"Saint-Barth\xe9lemy"},"fra":{"official":"Collectivit\xe9 de Saint-Barth\xe9lemy","common":"Saint-Barth\xe9lemy"},"hrv":{"official":"Kolektivnost sv Barth\xe9lemy","common":"Saint Barth\xe9lemy"},"hun":{"official":"Saint-Barth\xe9lemy","common":"Saint-Barth\xe9lemy"},"ita":{"official":"Collettivit\xe0 di Saint Barth\xe9lemy","common":"Antille Francesi"},"jpn":{"official":"\u30B5\u30F3\xb7\u30D0\u30EB\u30C6\u30EB\u30DF\u30FC\u5CF6\u306E\u96C6\u5408\u4F53","common":"\u30B5\u30F3\u30FB\u30D0\u30EB\u30C6\u30EB\u30DF\u30FC"},"kor":{"official":"\uC0DD\uBC14\uB974\uD154\uB808\uBBF8","common":"\uC0DD\uBC14\uB974\uD154\uB808\uBBF8"},"nld":{"official":"Gemeenschap Saint Barth\xe9lemy","common":"Saint Barth\xe9lemy"},"per":{"official":"\u0633\u0646 \u0628\u0627\u0631\u062A\u0644\u0645\u06CC","common":"\u0633\u0646 \u0628\u0627\u0631\u062A\u0644\u0645\u06CC"},"pol":{"official":"Saint-Barth\xe9lemy","common":"Saint-Barth\xe9lemy"},"por":{"official":"Coletividade de Saint Barth\xe9lemy","common":"S\xe3o Bartolomeu"},"rus":{"official":"\u041A\u043E\u043B\u043B\u0435\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C \u0421\u0430\u043D\u043A\u0442 -\u0411\u0430\u0440\u0442\u0435\u043B\u044C\u043C\u0438","common":"\u0421\u0435\u043D-\u0411\u0430\u0440\u0442\u0435\u043B\u0435\u043C\u0438"},"slk":{"official":"Sv\xe4t\xfd Bartolomej","common":"Sv\xe4t\xfd Bartolomej"},"spa":{"official":"Colectividad de San Barth\xe9lemy","common":"San Bartolom\xe9"},"swe":{"official":"Saint-Barth\xe9lemy","common":"Saint-Barth\xe9lemy"},"urd":{"official":"\u0633\u06CC\u0646\u0679 \u0628\u0627\u0631\u062A\u06BE\u06CC\u0645\u0644\u06D2","common":"\u0633\u06CC\u0646\u0679 \u0628\u0627\u0631\u062A\u06BE\u06CC\u0645\u0644\u06D2"},"zho":{"official":"\u5723\u5DF4\u6CF0\u52D2\u7C73\u96C6\u4F53","common":"\u5723\u5DF4\u6CF0\u52D2\u7C73"}},"latlng":[18.5,-63.41666666],"landlocked":false,"borders":[],"area":21,"flag":"\uD83C\uDDE7\uD83C\uDDF1","demonyms":{"eng":{"f":"Saint Barth\xe9lemy Islander","m":"Saint Barth\xe9lemy Islander"},"fra":{"f":"Barth\xe9lom\xe9enne","m":"Barth\xe9lom\xe9en"}}},{"name":{"common":"Saint Helena, Ascension and Tristan da Cunha","official":"Saint Helena, Ascension and Tristan da Cunha","native":{"eng":{"official":"Saint Helena, Ascension and Tristan da Cunha","common":"Saint Helena, Ascension and Tristan da Cunha"}}},"tld":[".sh",".ac"],"cca2":"SH","ccn3":"654","cca3":"SHN","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"GBP":{"name":"Pound sterling","symbol":"\xa3"},"SHP":{"name":"Saint Helena pound","symbol":"\xa3"}},"idd":{"root":"+2","suffixes":["90","47"]},"capital":["Jamestown"],"altSpellings":["Saint Helena","St. Helena, Ascension and Tristan da Cunha"],"region":"Africa","subregion":"Western Africa","languages":{"eng":"English"},"translations":{"ces":{"official":"Svat\xe1 Helena, Ascension a Tristan da Cunha","common":"Svat\xe1 Helena, Ascension a Tristan da Cunha"},"deu":{"official":"Sankt Helena, Ascension und Tristan da Cunha","common":"St. Helena, Ascension und Tristan da Cunha"},"est":{"official":"Saint Helena, Ascension ja Tristan da Cunha","common":"Saint Helena, Ascension ja Tristan da Cunha"},"fin":{"official":"Saint Helena, Ascension ja Tristan da Cunha","common":"Saint Helena, Ascension ja Tristan da Cunha"},"fra":{"official":"Sainte-H\xe9l\xe8ne, Ascension et Tristan da Cunha","common":"Sainte-H\xe9l\xe8ne, Ascension et Tristan da Cunha"},"hrv":{"official":"Sveta Helena","common":"Sveta Helena"},"hun":{"official":"Szent Ilona","common":"Szent Ilona-sziget"},"ita":{"official":"Sant\'Elena, Ascensione e Tristan da Cunha","common":"Sant\'Elena, Ascensione e Tristan da Cunha"},"jpn":{"official":"\u30BB\u30F3\u30C8\u30D8\u30EC\u30CA\u30FB\u30A2\u30BB\u30F3\u30B7\u30E7\u30F3\u304A\u3088\u3073\u30C8\u30EA\u30B9\u30BF\u30F3\u30C0\u30AF\u30FC\u30CB\u30E3","common":"\u30BB\u30F3\u30C8\u30D8\u30EC\u30CA\u30FB\u30A2\u30BB\u30F3\u30B7\u30E7\u30F3\u304A\u3088\u3073\u30C8\u30EA\u30B9\u30BF\u30F3\u30C0\u30AF\u30FC\u30CB\u30E3"},"kor":{"official":"\uC138\uC778\uD2B8\uD5EC\uB808\uB098","common":"\uC138\uC778\uD2B8\uD5EC\uB808\uB098"},"nld":{"official":"Sint-Helena, Ascension en Tristan da Cunha","common":"Sint-Helena, Ascension en Tristan da Cunha"},"per":{"official":"\u0633\u0646\u062A \u0647\u0644\u0646","common":"\u0633\u0646\u062A \u0647\u0644\u0646"},"pol":{"official":"Wyspa \u015Awi\u0119tej Heleny, Wyspa Wniebowst\u0105pienia i Tristan da Cunha","common":"Wyspa \u015Awi\u0119tej Heleny, Wyspa Wniebowst\u0105pienia i Tristan da Cunha"},"por":{"official":"Santa Helena, Ascens\xe3o e Trist\xe3o da Cunha","common":"Santa Helena, Ascens\xe3o e Trist\xe3o da Cunha"},"rus":{"official":"\u041E\u0441\u0442\u0440\u043E\u0432\u0430 \u0421\u0432\u044F\u0442\u043E\u0439 \u0415\u043B\u0435\u043D\u044B, \u0412\u043E\u0437\u043D\u0435\u0441\u0435\u043D\u0438\u044F \u0438 \u0422\u0440\u0438\u0441\u0442\u0430\u043D-\u0434\u0430-\u041A\u0443\u043D\u044C\u044F","common":"\u041E\u0441\u0442\u0440\u043E\u0432\u0430 \u0421\u0432\u044F\u0442\u043E\u0439 \u0415\u043B\u0435\u043D\u044B, \u0412\u043E\u0437\u043D\u0435\u0441\u0435\u043D\u0438\u044F \u0438 \u0422\u0440\u0438\u0441\u0442\u0430\u043D-\u0434\u0430-\u041A\u0443\u043D\u044C\u044F"},"slk":{"official":"Sv\xe4t\xe1 Helena (z\xe1morsk\xe9 \xfazemie)","common":"Sv\xe4t\xe1 Helena (z\xe1morsk\xe9 \xfazemie)"},"spa":{"official":"Santa Elena, Ascensi\xf3n y Trist\xe1n de Acu\xf1a","common":"Santa Elena, Ascensi\xf3n y Trist\xe1n de Acu\xf1a"},"swe":{"official":"Sankta Helena","common":"Sankta Helena"},"urd":{"official":"\u0633\u06CC\u0646\u0679 \u06C1\u0644\u06CC\u0646\u0627\u060C \u0627\u0633\u06CC\u0646\u0634\u0646 \u0648 \u062A\u0631\u0633\u0679\u0627\u0646 \u062F\u0627 \u06A9\u0648\u0646\u06CC\u0627","common":"\u0633\u06CC\u0646\u0679 \u06C1\u0644\u06CC\u0646\u0627\u060C \u0627\u0633\u06CC\u0646\u0634\u0646 \u0648 \u062A\u0631\u0633\u0679\u0627\u0646 \u062F\u0627 \u06A9\u0648\u0646\u06CC\u0627"},"zho":{"official":"\u5723\u8D6B\u52D2\u62FF\u3001\u963F\u68EE\u677E\u548C\u7279\u91CC\u65AF\u5766-\u8FBE\u5E93\u5C3C\u4E9A","common":"\u5723\u8D6B\u52D2\u62FF\u3001\u963F\u68EE\u677E\u548C\u7279\u91CC\u65AF\u5766-\u8FBE\u5E93\u5C3C\u4E9A"}},"latlng":[-15.95,-5.72],"landlocked":false,"borders":[],"area":394,"flag":"\uD83C\uDDF8\uD83C\uDDED","demonyms":{"eng":{"f":"Saint Helenian","m":"Saint Helenian"},"fra":{"f":"Sainte-H\xe9l\xe9noise","m":"Sainte-H\xe9l\xe8nois"}}},{"name":{"common":"Belarus","official":"Republic of Belarus","native":{"bel":{"official":"\u0420\u044D\u0441\u043F\u0443\u0431\u043B\u0456\u043A\u0430 \u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C","common":"\u0411\u0435\u043B\u0430\u0440\u0443\u0301\u0441\u044C"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C","common":"\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C"}}},"tld":[".by"],"cca2":"BY","ccn3":"112","cca3":"BLR","cioc":"BLR","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"BYN":{"name":"Belarusian ruble","symbol":"Br"}},"idd":{"root":"+3","suffixes":["75"]},"capital":["Minsk"],"altSpellings":["BY","Bielaru\u015B","Republic of Belarus","\u0411\u0435\u043B\u043E\u0440\u0443\u0441\u0441\u0438\u044F","\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0411\u0435\u043B\u043E\u0440\u0443\u0441\u0441\u0438\u044F"],"region":"Europe","subregion":"Eastern Europe","languages":{"bel":"Belarusian","rus":"Russian"},"translations":{"ces":{"official":"B\u011Blorusk\xe1 republika","common":"B\u011Blorusko"},"cym":{"official":"Gweriniaeth Belarws","common":"Belarws"},"deu":{"official":"Republik Belarus","common":"Wei\xdfrussland"},"est":{"official":"Valgevene Vabariik","common":"Valgevene"},"fin":{"official":"Valko-Ven\xe4j\xe4n tasavalta","common":"Valko-Ven\xe4j\xe4"},"fra":{"official":"R\xe9publique de Bi\xe9lorussie","common":"Bi\xe9lorussie"},"hrv":{"official":"Republika Bjelorusija","common":"Bjelorusija"},"hun":{"official":"Feh\xe9rorosz K\xf6zt\xe1rsas\xe1g","common":"Feh\xe9roroszorsz\xe1g"},"ita":{"official":"Repubblica di Belarus","common":"Bielorussia"},"jpn":{"official":"\u30D9\u30E9\u30EB\u30FC\u30B7\u5171\u548C\u56FD","common":"\u30D9\u30E9\u30EB\u30FC\u30B7"},"kor":{"official":"\uBCA8\uB77C\uB8E8\uC2A4 \uACF5\uD654\uAD6D","common":"\uBCA8\uB77C\uB8E8\uC2A4"},"nld":{"official":"Republiek Belarus","common":"Wit-Rusland"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0628\u0644\u0627\u0631\u0648\u0633","common":"\u0628\u0644\u0627\u0631\u0648\u0633"},"pol":{"official":"Republika Bia\u0142orusi","common":"Bia\u0142oru\u015B"},"por":{"official":"Rep\xfablica da Bielorr\xfassia","common":"Bielor\xfassia"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C","common":"\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C"},"slk":{"official":"Bielorusk\xe1 republika","common":"Bielorusko"},"spa":{"official":"Rep\xfablica de Belar\xfas","common":"Bielorrusia"},"swe":{"official":"Republiken Vitryssland","common":"Belarus"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0628\u06CC\u0644\u0627\u0631\u0648\u0633","common":"\u0628\u06CC\u0644\u0627\u0631\u0648\u0633"},"zho":{"official":"\u767D\u4FC4\u7F57\u65AF\u5171\u548C\u56FD","common":"\u767D\u4FC4\u7F57\u65AF"}},"latlng":[53,28],"landlocked":true,"borders":["LVA","LTU","POL","RUS","UKR"],"area":207600,"flag":"\uD83C\uDDE7\uD83C\uDDFE","demonyms":{"eng":{"f":"Belarusian","m":"Belarusian"},"fra":{"f":"Bi\xe9lorusse","m":"Bi\xe9lorusse"}}},{"name":{"common":"Belize","official":"Belize","native":{"bjz":{"official":"Belize","common":"Belize"},"eng":{"official":"Belize","common":"Belize"},"spa":{"official":"Belice","common":"Belice"}}},"tld":[".bz"],"cca2":"BZ","ccn3":"084","cca3":"BLZ","cioc":"BIZ","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"BZD":{"name":"Belize dollar","symbol":"$"}},"idd":{"root":"+5","suffixes":["01"]},"capital":["Belmopan"],"altSpellings":["BZ"],"region":"Americas","subregion":"Central America","languages":{"bjz":"Belizean Creole","eng":"English","spa":"Spanish"},"translations":{"ces":{"official":"Belize","common":"Belize"},"cym":{"official":"Bel\xees","common":"Bel\xees"},"deu":{"official":"Belize","common":"Belize"},"est":{"official":"Belize","common":"Belize"},"fin":{"official":"Belize","common":"Belize"},"fra":{"official":"Belize","common":"Belize"},"hrv":{"official":"Belize","common":"Belize"},"hun":{"official":"Belize","common":"Belize"},"ita":{"official":"Belize","common":"Belize"},"jpn":{"official":"\u30D9\u30EA\u30FC\u30BA","common":"\u30D9\u30EA\u30FC\u30BA"},"kor":{"official":"\uBCA8\uB9AC\uC988","common":"\uBCA8\uB9AC\uC988"},"nld":{"official":"Belize","common":"Belize"},"per":{"official":"\u0628\u0644\u06CC\u0632","common":"\u0628\u0644\u06CC\u0632"},"pol":{"official":"Belize","common":"Belize"},"por":{"official":"Belize","common":"Belize"},"rus":{"official":"\u0411\u0435\u043B\u0438\u0437","common":"\u0411\u0435\u043B\u0438\u0437"},"slk":{"official":"Belize","common":"Belize"},"spa":{"official":"Belice","common":"Belice"},"swe":{"official":"Belize","common":"Belize"},"urd":{"official":"\u0628\u06CC\u0644\u06CC\u0632","common":"\u0628\u06CC\u0644\u06CC\u0632"},"zho":{"official":"\u4F2F\u5229\u5179","common":"\u4F2F\u5229\u5179"}},"latlng":[17.25,-88.75],"landlocked":false,"borders":["GTM","MEX"],"area":22966,"flag":"\uD83C\uDDE7\uD83C\uDDFF","demonyms":{"eng":{"f":"Belizean","m":"Belizean"},"fra":{"f":"B\xe9lizienne","m":"B\xe9lizien"}}},{"name":{"common":"Bermuda","official":"Bermuda","native":{"eng":{"official":"Bermuda","common":"Bermuda"}}},"tld":[".bm"],"cca2":"BM","ccn3":"060","cca3":"BMU","cioc":"BER","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"BMD":{"name":"Bermudian dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["441"]},"capital":["Hamilton"],"altSpellings":["BM","The Islands of Bermuda","The Bermudas","Somers Isles"],"region":"Americas","subregion":"North America","languages":{"eng":"English"},"translations":{"ces":{"official":"Bermudsk\xe9 ostrovy","common":"Bermudy"},"cym":{"official":"Bermiwda","common":"Bermiwda"},"deu":{"official":"Bermuda","common":"Bermuda"},"est":{"official":"Bermuda","common":"Bermuda"},"fin":{"official":"Bermuda","common":"Bermuda"},"fra":{"official":"Bermudes","common":"Bermudes"},"hrv":{"official":"Bermuda","common":"Bermudi"},"hun":{"official":"Bermuda","common":"Bermuda"},"ita":{"official":"Bermuda","common":"Bermuda"},"jpn":{"official":"\u30D0\u30DF\u30E5\u30FC\u30C0","common":"\u30D0\u30DF\u30E5\u30FC\u30C0"},"kor":{"official":"\uBC84\uBBA4\uB2E4","common":"\uBC84\uBBA4\uB2E4"},"nld":{"official":"Bermuda","common":"Bermuda"},"per":{"official":"\u062C\u0632\u0627\u06CC\u0631 \u0628\u0631\u0645\u0648\u062F\u0627","common":"\u0628\u0631\u0645\u0648\u062F\u0627"},"pol":{"official":"Bermudy","common":"Bermudy"},"por":{"official":"Bermudas","common":"Bermudas"},"rus":{"official":"\u0411\u0435\u0440\u043C\u0443\u0434\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430","common":"\u0411\u0435\u0440\u043C\u0443\u0434\u0441\u043A\u0438\u0435 \u041E\u0441\u0442\u0440\u043E\u0432\u0430"},"slk":{"official":"Bermudy","common":"Bermudy"},"spa":{"official":"Bermuda","common":"Bermudas"},"swe":{"official":"Bermuda","common":"Bermuda"},"urd":{"official":"\u0628\u0631\u0645\u0648\u062F\u0627","common":"\u0628\u0631\u0645\u0648\u062F\u0627"},"zho":{"official":"\u767E\u6155\u5927","common":"\u767E\u6155\u5927"}},"latlng":[32.33333333,-64.75],"landlocked":false,"borders":[],"area":54,"flag":"\uD83C\uDDE7\uD83C\uDDF2","demonyms":{"eng":{"f":"Bermudian","m":"Bermudian"},"fra":{"f":"Bermudienne","m":"Bermudien"}}},{"name":{"common":"Bolivia","official":"Plurinational State of Bolivia","native":{"aym":{"official":"Wuliwya Suyu","common":"Wuliwya"},"grn":{"official":"Tet\xe3 Vol\xedvia","common":"Vol\xedvia"},"que":{"official":"Buliwya Mamallaqta","common":"Buliwya"},"spa":{"official":"Estado Plurinacional de Bolivia","common":"Bolivia"}}},"tld":[".bo"],"cca2":"BO","ccn3":"068","cca3":"BOL","cioc":"BOL","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"BOB":{"name":"Bolivian boliviano","symbol":"Bs."}},"idd":{"root":"+5","suffixes":["91"]},"capital":["Sucre"],"altSpellings":["BO","Buliwya","Wuliwya","Bolivia, Plurinational State of","Plurinational State of Bolivia","Estado Plurinacional de Bolivia","Buliwya Mamallaqta","Wuliwya Suyu","Tet\xe3 Vol\xedvia"],"region":"Americas","subregion":"South America","languages":{"aym":"Aymara","grn":"Guaran\xed","que":"Quechua","spa":"Spanish"},"translations":{"ces":{"official":"Mnohon\xe1rodnostn\xed st\xe1t Bol\xedvie","common":"Bol\xedvie"},"cym":{"official":"Gweriniaeth Bolifia","common":"Bolifia"},"deu":{"official":"Plurinationaler Staat Bolivien","common":"Bolivien"},"est":{"official":"Boliivia Paljurahvuseline Riik","common":"Boliivia"},"fin":{"official":"Bolivian monikansainen valtio","common":"Bolivia"},"fra":{"official":"\xc9tat plurinational de Bolivie","common":"Bolivie"},"hrv":{"official":"Plurinational State of Bolivia","common":"Bolivija"},"hun":{"official":"Bol\xedviai T\xf6bbnemzetis\xe9g\u0171 \xc1llam","common":"Bol\xedvia"},"ita":{"official":"Stato Plurinazionale della Bolivia","common":"Bolivia"},"jpn":{"official":"\u30DC\u30EA\u30D3\u30A2\u306E\u591A\u6C11\u65CF\u56FD","common":"\u30DC\u30EA\u30D3\u30A2\u591A\u6C11\u65CF\u56FD"},"kor":{"official":"\uBCFC\uB9AC\uBE44\uC544 \uB2E4\uBBFC\uC871\uAD6D","common":"\uBCFC\uB9AC\uBE44\uC544"},"nld":{"official":"Plurinationale Staat van Bolivia","common":"Bolivia"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0628\u0648\u0644\u06CC\u0648\u06CC","common":"\u0628\u0648\u0644\u06CC\u0648\u06CC"},"pol":{"official":"Wielonarodowe Pa\u0144stwo Boliwia","common":"Boliwia"},"por":{"official":"Estado Plurinacional da Bol\xedvia","common":"Bol\xedvia"},"rus":{"official":"\u041C\u043D\u043E\u0433\u043E\u043D\u0430\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0435 \u0413\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u043E \u0411\u043E\u043B\u0438\u0432\u0438\u044F","common":"\u0411\u043E\u043B\u0438\u0432\u0438\u044F"},"slk":{"official":"Bol\xedvijsk\xe1 republika","common":"Bol\xedvia"},"spa":{"official":"Estado Plurinacional de Bolivia","common":"Bolivia"},"swe":{"official":"M\xe5ngnationella staten Bolivia","common":"Bolivia"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0628\u0648\u0644\u06CC\u0648\u06CC\u0627","common":"\u0628\u0648\u0644\u06CC\u0648\u06CC\u0627"},"zho":{"official":"\u591A\u6C11\u65CF\u73BB\u5229\u7EF4\u4E9A\u56FD","common":"\u73BB\u5229\u7EF4\u4E9A"}},"latlng":[-17,-65],"landlocked":true,"borders":["ARG","BRA","CHL","PRY","PER"],"area":1098581,"flag":"\uD83C\uDDE7\uD83C\uDDF4","demonyms":{"eng":{"f":"Bolivian","m":"Bolivian"},"fra":{"f":"Bolivienne","m":"Bolivien"}}},{"name":{"common":"Caribbean Netherlands","official":"Bonaire, Sint Eustatius and Saba","native":{"nld":{"official":"Bonaire, Sint Eustatius en Saba","common":"Caribisch Nederland"},"pap":{"official":"Boneiru, Sint Eustatius y Saba","common":"Boneiru, Sint Eustatius y Saba"}}},"tld":[".bq",".nl"],"cca2":"BQ","ccn3":"535","cca3":"BES","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+5","suffixes":["99"]},"capital":["Kralendijk","Oranjestad","The Bottom"],"altSpellings":["BES islands"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English","nld":"Dutch","pap":"Papiamento"},"translations":{"ces":{"official":"Karibsk\xe9 Nizozemsko","common":"Karibsk\xe9 Nizozemsko"},"deu":{"official":"Bonaire, Sint Eustatius und Saba","common":"Karibische Niederlande"},"est":{"official":"Bonaire, Sint Eustatius ja Saba","common":"Bonaire, Sint Eustatius ja Saba"},"fin":{"official":"Bonaire, Sint Eustatius ja Saba","common":"Bonaire, Sint Eustatius ja Saba"},"fra":{"official":"Bonaire, Saint-Eustache et Saba","common":"Pays-Bas carib\xe9ens"},"hrv":{"official":"Bonaire, Sint Eustatius i Saba","common":"Bonaire, Sint Eustatius i Saba"},"hun":{"official":"Bonaire","common":"Bonaire"},"ita":{"official":"Bonaire, Sint Eustatius e Saba","common":"Paesi Bassi caraibici"},"jpn":{"official":"\u30DC\u30CD\u30FC\u30EB\u3001\u30B7\u30F3\u30C8\u30FB\u30E6\u30FC\u30B9\u30BF\u30C6\u30A3\u30A6\u30B9\u304A\u3088\u3073\u30B5\u30D0","common":"\u30DC\u30CD\u30FC\u30EB\u3001\u30B7\u30F3\u30C8\u30FB\u30E6\u30FC\u30B9\u30BF\u30C6\u30A3\u30A6\u30B9\u304A\u3088\u3073\u30B5\u30D0"},"kor":{"official":"\uBCF4\uB124\uB974, \uC2E0\uD2B8\uC678\uC2A4\uD0C0\uD2F0\uC704\uC2A4, \uC0AC\uBC14","common":"\uCE74\uB9AC\uBE0C \uB124\uB35C\uB780\uB4DC"},"nld":{"official":"Bonaire, Sint Eustatius en Saba","common":"Caribisch Nederland"},"per":{"official":"\u062C\u0632\u0627\u06CC\u0631 \u06A9\u0627\u0631\u0627\u0626\u06CC\u0628 \u0647\u0644\u0646\u062F","common":"\u062C\u0632\u0627\u06CC\u0631 \u06A9\u0627\u0631\u0627\u0626\u06CC\u0628 \u0647\u0644\u0646\u062F"},"pol":{"official":"Bonaire, Sint Eustatius i Saba","common":"Antyle Holenderskie"},"por":{"official":"Bonaire, Saba e Santo Eust\xe1quio","common":"Pa\xedses Baixos Caribenhos"},"rus":{"official":"\u0411\u043E\u043D\u044D\u0439\u0440, \u0421\u0438\u043D\u0442-\u042D\u0441\u0442\u0430\u0442\u0438\u0443\u0441 \u0438 \u0421\u0430\u0431\u0430","common":"\u041A\u0430\u0440\u0438\u0431\u0441\u043A\u0438\u0435 \u041D\u0438\u0434\u0435\u0440\u043B\u0430\u043D\u0434\u044B"},"slk":{"official":"Bonaire, Sint Eustatius a Saba","common":"Bonaire, Sint Eustatius a Saba"},"spa":{"official":"Bonaire, San Eustaquio y Saba","common":"Caribe Neerland\xe9s"},"swe":{"official":"Bonaire, Sint Eustatius and Saba","common":"Karibiska Nederl\xe4nderna"},"urd":{"official":"\u0628\u0648\u0646\u0627\u06CC\u0631\u060C \u0633\u06CC\u0646\u0679 \u0627\u06CC\u0648\u0633\u0679\u0627\u0626\u06CC\u0633 \u0627\u0648\u0631 \u0633\u0627\u0628\u0627","common":"\u06A9\u06CC\u0631\u06CC\u0628\u06CC\u0646 \u0646\u06CC\u062F\u0631\u0644\u06CC\u0646\u0688\u0632"},"zho":{"official":"\u8377\u862D\u52A0\u52D2\u6BD4\u5340","common":"\u8377\u862D\u52A0\u52D2\u6BD4\u5340"}},"latlng":[12.18,-68.25],"landlocked":false,"borders":[],"area":328,"flag":"","demonyms":{"eng":{"f":"Dutch","m":"Dutch"},"fra":{"f":"N\xe9erlandaise","m":"N\xe9erlandais"}}},{"name":{"common":"Brazil","official":"Federative Republic of Brazil","native":{"por":{"official":"Rep\xfablica Federativa do Brasil","common":"Brasil"}}},"tld":[".br"],"cca2":"BR","ccn3":"076","cca3":"BRA","cioc":"BRA","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"BRL":{"name":"Brazilian real","symbol":"R$"}},"idd":{"root":"+5","suffixes":["5"]},"capital":["Bras\xedlia"],"altSpellings":["BR","Brasil","Federative Republic of Brazil","Rep\xfablica Federativa do Brasil"],"region":"Americas","subregion":"South America","languages":{"por":"Portuguese"},"translations":{"ces":{"official":"Brazilsk\xe1 federativn\xed republika","common":"Braz\xedlie"},"cym":{"official":"Gweriniaeth Ffederal Brasil","common":"Brasil"},"deu":{"official":"F\xf6derative Republik Brasilien","common":"Brasilien"},"est":{"official":"Brasiilia Liitvabariik","common":"Brasiilia"},"fin":{"official":"Brasilian liittotasavalta","common":"Brasilia"},"fra":{"official":"R\xe9publique f\xe9d\xe9rative du Br\xe9sil","common":"Br\xe9sil"},"hrv":{"official":"Savezne Republike Brazil","common":"Brazil"},"hun":{"official":"Brazil Sz\xf6vets\xe9gi K\xf6zt\xe1rsas\xe1g","common":"Braz\xedlia"},"ita":{"official":"Repubblica federativa del Brasile","common":"Brasile"},"jpn":{"official":"\u30D6\u30E9\u30B8\u30EB\u9023\u90A6\u5171\u548C\u56FD","common":"\u30D6\u30E9\u30B8\u30EB"},"kor":{"official":"\uBE0C\uB77C\uC9C8 \uC5F0\uBC29 \uACF5\uD654\uAD6D","common":"\uBE0C\uB77C\uC9C8"},"nld":{"official":"Federale Republiek Brazili\xeb","common":"Brazili\xeb"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0641\u062F\u0631\u0627\u062A\u06CC\u0648 \u0628\u0631\u0632\u06CC\u0644","common":"\u0628\u0631\u0632\u06CC\u0644"},"pol":{"official":"Federacyjna Republika Brazylii","common":"Brazylia"},"por":{"official":"Rep\xfablica Federativa do Brasil","common":"Brasil"},"rus":{"official":"\u0424\u0435\u0434\u0435\u0440\u0430\u0442\u0438\u0432\u043D\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0411\u0440\u0430\u0437\u0438\u043B\u0438\u044F","common":"\u0411\u0440\u0430\u0437\u0438\u043B\u0438\u044F"},"slk":{"official":"Braz\xedlska federat\xedvna republika","common":"Braz\xedlia"},"spa":{"official":"Rep\xfablica Federativa del Brasil","common":"Brasil"},"swe":{"official":"F\xf6rbundsrepubliken Brasilien","common":"Brasilien"},"urd":{"official":"\u0648\u0641\u0627\u0642\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0628\u0631\u0627\u0632\u06CC\u0644","common":"\u0628\u0631\u0627\u0632\u06CC\u0644"},"zho":{"official":"\u5DF4\u897F\u8054\u90A6\u5171\u548C\u56FD","common":"\u5DF4\u897F"}},"latlng":[-10,-55],"landlocked":false,"borders":["ARG","BOL","COL","GUF","GUY","PRY","PER","SUR","URY","VEN"],"area":8515767,"flag":"\uD83C\uDDE7\uD83C\uDDF7","demonyms":{"eng":{"f":"Brazilian","m":"Brazilian"},"fra":{"f":"Br\xe9silienne","m":"Br\xe9silien"}}},{"name":{"common":"Barbados","official":"Barbados","native":{"eng":{"official":"Barbados","common":"Barbados"}}},"tld":[".bb"],"cca2":"BB","ccn3":"052","cca3":"BRB","cioc":"BAR","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"BBD":{"name":"Barbadian dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["246"]},"capital":["Bridgetown"],"altSpellings":["BB"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Barbados","common":"Barbados"},"cym":{"official":"Barbados","common":"Barbados"},"deu":{"official":"Barbados","common":"Barbados"},"est":{"official":"Barbados","common":"Barbados"},"fin":{"official":"Barbados","common":"Barbados"},"fra":{"official":"Barbade","common":"Barbade"},"hrv":{"official":"Barbados","common":"Barbados"},"hun":{"official":"Barbados","common":"Barbados"},"ita":{"official":"Barbados","common":"Barbados"},"jpn":{"official":"\u30D0\u30EB\u30D0\u30C9\u30B9","common":"\u30D0\u30EB\u30D0\u30C9\u30B9"},"kor":{"official":"\uBC14\uBCA0\uC774\uB3C4\uC2A4","common":"\uBC14\uBCA0\uC774\uB3C4\uC2A4"},"nld":{"official":"Barbados","common":"Barbados"},"per":{"official":"\u0628\u0627\u0631\u0628\u0627\u062F\u0648\u0633","common":"\u0628\u0627\u0631\u0628\u0627\u062F\u0648\u0633"},"pol":{"official":"Barbados","common":"Barbados"},"por":{"official":"Barbados","common":"Barbados"},"rus":{"official":"\u0411\u0430\u0440\u0431\u0430\u0434\u043E\u0441","common":"\u0411\u0430\u0440\u0431\u0430\u0434\u043E\u0441"},"slk":{"official":"Barbados","common":"Barbados"},"spa":{"official":"Barbados","common":"Barbados"},"swe":{"official":"Barbados","common":"Barbados"},"urd":{"official":"\u0628\u0627\u0631\u0628\u0627\u0688\u0648\u0633","common":"\u0628\u0627\u0631\u0628\u0627\u0688\u0648\u0633"},"zho":{"official":"\u5DF4\u5DF4\u591A\u65AF","common":"\u5DF4\u5DF4\u591A\u65AF"}},"latlng":[13.16666666,-59.53333333],"landlocked":false,"borders":[],"area":430,"flag":"\uD83C\uDDE7\uD83C\uDDE7","demonyms":{"eng":{"f":"Barbadian","m":"Barbadian"},"fra":{"f":"Barbadienne","m":"Barbadien"}}},{"name":{"common":"Brunei","official":"Nation of Brunei, Abode of Peace","native":{"msa":{"official":"Nation of Brunei, Abode Damai","common":"Negara Brunei Darussalam"}}},"tld":[".bn"],"cca2":"BN","ccn3":"096","cca3":"BRN","cioc":"BRU","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"BND":{"name":"Brunei dollar","symbol":"$"},"SGD":{"name":"Singapore dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["73"]},"capital":["Bandar Seri Begawan"],"altSpellings":["BN","Brunei Darussalam","Nation of Brunei","the Abode of Peace"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"msa":"Malay"},"translations":{"ces":{"official":"Sultan\xe1t Brunej","common":"Brunej"},"cym":{"official":"Teyrnas Brwnei","common":"Brunei"},"deu":{"official":"Sultanat Brunei Darussalam","common":"Brunei"},"est":{"official":"Brunei Darussalami Riik","common":"Brunei"},"fin":{"official":"Brunei Darussalamin valtio","common":"Brunei"},"fra":{"official":"\xc9tat de Brunei Darussalam","common":"Brunei"},"hrv":{"official":"Nacija od Bruneja, Ku\u0107u Mira","common":"Brunej"},"hun":{"official":"Brunei Szultan\xe1tus","common":"Brunei"},"ita":{"official":"Nazione di Brunei, Dimora della Pace","common":"Brunei"},"jpn":{"official":"\u30D6\u30EB\u30CD\u30A4\u3001\u5E73\u548C\u306E\u7CBE\u820E\u306E\u56FD\u5BB6","common":"\u30D6\u30EB\u30CD\u30A4\u30FB\u30C0\u30EB\u30B5\u30E9\u30FC\u30E0"},"kor":{"official":"\uBE0C\uB8E8\uB098\uC774 \uB2E4\uB8E8\uC0B4\uB78C\uAD6D","common":"\uBE0C\uB8E8\uB098\uC774"},"nld":{"official":"Natie van Brunei, de verblijfplaats van de Vrede","common":"Brunei"},"per":{"official":"\u0628\u0631\u0648\u0646\u0626\u06CC \u0633\u0631\u0627\u06CC \u0635\u0644\u062D","common":"\u0628\u0631\u0648\u0646\u0626\u06CC"},"pol":{"official":"Pa\u0144stwo Brunei Darussalam","common":"Brunei"},"por":{"official":"Na\xe7\xe3o do Brunei, Morada da Paz","common":"Brunei"},"rus":{"official":"\u041D\u0430\u0446\u0438\u044F \u0411\u0440\u0443\u043D\u0435\u0439, \u043E\u0431\u0438\u0442\u0435\u043B\u044C \u043C\u0438\u0440\u0430","common":"\u0411\u0440\u0443\u043D\u0435\u0439"},"slk":{"official":"Brunejsk\xfd sultan\xe2t","common":"Brunej"},"spa":{"official":"Naci\xf3n de Brunei, Morada de la Paz","common":"Brunei"},"swe":{"official":"Brunei Darussalam","common":"Brunei"},"urd":{"official":"\u0631\u06CC\u0627\u0633\u062A\u0650 \u0628\u0631\u0648\u0646\u0627\u0626\u06CC \u062F\u0627\u0631\u0627\u0644\u0633\u0644\u0627\u0645","common":"\u0628\u0631\u0648\u0646\u0627\u0626\u06CC"},"zho":{"official":"\u6587\u83B1\u548C\u5E73\u4E4B\u56FD","common":"\u6587\u83B1"}},"latlng":[4.5,114.66666666],"landlocked":false,"borders":["MYS"],"area":5765,"flag":"\uD83C\uDDE7\uD83C\uDDF3","demonyms":{"eng":{"f":"Bruneian","m":"Bruneian"},"fra":{"f":"Brun\xe9ienne","m":"Brun\xe9ien"}}},{"name":{"common":"Bhutan","official":"Kingdom of Bhutan","native":{"dzo":{"official":"\u0F60\u0F56\u0FB2\u0F74\u0F42\u0F0B\u0F62\u0F92\u0FB1\u0F63\u0F0B\u0F41\u0F56\u0F0B","common":"\u0F60\u0F56\u0FB2\u0F74\u0F42\u0F0B\u0F61\u0F74\u0F63\u0F0B"}}},"tld":[".bt"],"cca2":"BT","ccn3":"064","cca3":"BTN","cioc":"BHU","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"BTN":{"name":"Bhutanese ngultrum","symbol":"Nu."},"INR":{"name":"Indian rupee","symbol":"\u20B9"}},"idd":{"root":"+9","suffixes":["75"]},"capital":["Thimphu"],"altSpellings":["BT","Kingdom of Bhutan"],"region":"Asia","subregion":"Southern Asia","languages":{"dzo":"Dzongkha"},"translations":{"ces":{"official":"Bh\xfat\xe1nsk\xe9 kr\xe1lovstv\xed","common":"Bh\xfat\xe1n"},"cym":{"official":"Teyrnas Bhwtan","common":"Bhwtan"},"deu":{"official":"K\xf6nigreich Bhutan","common":"Bhutan"},"est":{"official":"Bhutani Kuningriik","common":"Bhutan"},"fin":{"official":"Bhutanin kuningaskunta","common":"Bhutan"},"fra":{"official":"Royaume du Bhoutan","common":"Bhoutan"},"hrv":{"official":"Kraljevina Butan","common":"Butan"},"hun":{"official":"Bhut\xe1ni Kir\xe1lys\xe1g","common":"Bhut\xe1n"},"ita":{"official":"Regno del Bhutan","common":"Bhutan"},"jpn":{"official":"\u30D6\u30FC\u30BF\u30F3\u738B\u56FD","common":"\u30D6\u30FC\u30BF\u30F3"},"kor":{"official":"\uBD80\uD0C4 \uC655\uAD6D","common":"\uBD80\uD0C4"},"nld":{"official":"Koninkrijk Bhutan","common":"Bhutan"},"per":{"official":"\u067E\u0627\u062F\u0634\u0627\u0647\u06CC \u0628\u0648\u062A\u0627\u0646","common":"\u0628\u0648\u062A\u0627\u0646"},"pol":{"official":"Bhutan","common":"Bhutan"},"por":{"official":"Reino do But\xe3o","common":"But\xe3o"},"rus":{"official":"\u041A\u043E\u0440\u043E\u043B\u0435\u0432\u0441\u0442\u0432\u043E \u0411\u0443\u0442\u0430\u043D","common":"\u0411\u0443\u0442\u0430\u043D"},"slk":{"official":"Bhut\xe1nske kr\xe2\u013Eovstvo","common":"Bhut\xe1n"},"spa":{"official":"Reino de But\xe1n","common":"But\xe1n"},"swe":{"official":"Konungariket Bhutan","common":"Bhutan"},"urd":{"official":"\u0633\u0644\u0637\u0646\u062A \u0628\u06BE\u0648\u0679\u0627\u0646","common":"\u0628\u06BE\u0648\u0679\u0627\u0646"},"zho":{"official":"\u4E0D\u4E39\u738B\u56FD","common":"\u4E0D\u4E39"}},"latlng":[27.5,90.5],"landlocked":true,"borders":["CHN","IND"],"area":38394,"flag":"\uD83C\uDDE7\uD83C\uDDF9","demonyms":{"eng":{"f":"Bhutanese","m":"Bhutanese"},"fra":{"f":"Bhoutanaise","m":"Bhoutanais"}}},{"name":{"common":"Bouvet Island","official":"Bouvet Island","native":{"nor":{"official":"Bouvet\xf8ya","common":"Bouvet\xf8ya"}}},"tld":[".bv"],"cca2":"BV","ccn3":"074","cca3":"BVT","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{},"idd":{"root":"+4","suffixes":["7"]},"capital":[],"altSpellings":["BV","Bouvet\xf8ya","Bouvet-\xf8ya"],"region":"Antarctic","subregion":"","languages":{"nor":"Norwegian"},"translations":{"ces":{"official":"Bouvet\u016Fv ostrov","common":"Bouvet\u016Fv ostrov"},"deu":{"official":"Bouvetinsel","common":"Bouvetinsel"},"est":{"official":"Bouvet\u2019 saar","common":"Bouvet\u2019 saar"},"fin":{"official":"Bouvet\'nsaari","common":"Bouvet\'nsaari"},"fra":{"official":"\xcele Bouvet","common":"\xcele Bouvet"},"hrv":{"official":"Bouvet Island","common":"Otok Bouvet"},"hun":{"official":"Bouvet-sziget","common":"Bouvet-sziget"},"ita":{"official":"Isola Bouvet","common":"Isola Bouvet"},"jpn":{"official":"\u30D6\u30FC\u30F4\u30A7\u5CF6","common":"\u30D6\u30FC\u30D9\u5CF6"},"kor":{"official":"\uBD80\uBCA0 \uC12C","common":"\uBD80\uBCA0 \uC12C"},"nld":{"official":"Bouvet Island","common":"Bouveteiland"},"per":{"official":"\u062C\u0632\u06CC\u0631\u0647\u0654 \u0628\u0648\u0648\u0647","common":"\u062C\u0632\u06CC\u0631\u0647\u0654 \u0628\u0648\u0648\u0647"},"pol":{"official":"Wyspa Bouveta","common":"Wyspa Bouveta"},"por":{"official":"Ilha Bouvet","common":"Ilha Bouvet"},"rus":{"official":"\u041E\u0441\u0442\u0440\u043E\u0432 \u0411\u0443\u0432\u0435","common":"\u041E\u0441\u0442\u0440\u043E\u0432 \u0411\u0443\u0432\u0435"},"slk":{"official":"Bouvetov ostrov","common":"Bouvetov ostrov"},"spa":{"official":"Isla Bouvet","common":"Isla Bouvet"},"swe":{"official":"Bouvet\xf6n","common":"Bouvet\xf6n"},"urd":{"official":"\u062C\u0632\u06CC\u0631\u06C1 \u0628\u0648\u0648\u06C1","common":"\u062C\u0632\u06CC\u0631\u06C1 \u0628\u0648\u0648\u06C1"},"zho":{"official":"\u5E03\u7EF4\u5C9B","common":"\u5E03\u7EF4\u5C9B"}},"latlng":[-54.43333333,3.4],"landlocked":false,"borders":[],"area":49,"flag":"\uD83C\uDDE7\uD83C\uDDFB","demonyms":{"eng":{"f":"","m":""},"fra":{"f":"","m":""}}},{"name":{"common":"Botswana","official":"Republic of Botswana","native":{"eng":{"official":"Republic of Botswana","common":"Botswana"},"tsn":{"official":"Lefatshe la Botswana","common":"Botswana"}}},"tld":[".bw"],"cca2":"BW","ccn3":"072","cca3":"BWA","cioc":"BOT","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"BWP":{"name":"Botswana pula","symbol":"P"}},"idd":{"root":"+2","suffixes":["67"]},"capital":["Gaborone"],"altSpellings":["BW","Republic of Botswana","Lefatshe la Botswana"],"region":"Africa","subregion":"Southern Africa","languages":{"eng":"English","tsn":"Tswana"},"translations":{"ces":{"official":"Botswansk\xe1 republika","common":"Botswana"},"deu":{"official":"Republik Botsuana","common":"Botswana"},"est":{"official":"Botswana Vabariik","common":"Botswana"},"fin":{"official":"Botswanan tasavalta","common":"Botswana"},"fra":{"official":"R\xe9publique du Botswana","common":"Botswana"},"hrv":{"official":"Republika Bocvana","common":"Bocvana"},"hun":{"official":"Botswanai K\xf6zt\xe1rsas\xe1g","common":"Botswana"},"ita":{"official":"Repubblica del Botswana","common":"Botswana"},"jpn":{"official":"\u30DC\u30C4\u30EF\u30CA\u5171\u548C\u56FD","common":"\u30DC\u30C4\u30EF\u30CA"},"kor":{"official":"\uBCF4\uCE20\uC640\uB098 \uACF5\uD654\uAD6D","common":"\uBCF4\uCE20\uC640\uB098"},"nld":{"official":"Republiek Botswana","common":"Botswana"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0628\u0648\u062A\u0633\u0648\u0627\u0646\u0627","common":"\u0628\u0648\u062A\u0633\u0648\u0627\u0646\u0627"},"pol":{"official":"Republika Botswany","common":"Botswana"},"por":{"official":"Rep\xfablica do Botswana","common":"Botswana"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0411\u043E\u0442\u0441\u0432\u0430\u043D\u0430","common":"\u0411\u043E\u0442\u0441\u0432\u0430\u043D\u0430"},"slk":{"official":"Botswansk\xe1 republika","common":"Botswana"},"spa":{"official":"Rep\xfablica de Botswana","common":"Botswana"},"swe":{"official":"Republiken Botswana","common":"Botswana"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0628\u0648\u0679\u0633\u0648\u0627\u0646\u0627","common":"\u0628\u0648\u0679\u0633\u0648\u0627\u0646\u0627"},"zho":{"official":"\u535A\u8328\u74E6\u7EB3\u5171\u548C\u56FD","common":"\u535A\u8328\u74E6\u7EB3"}},"latlng":[-22,24],"landlocked":true,"borders":["NAM","ZAF","ZMB","ZWE"],"area":582000,"flag":"\uD83C\uDDE7\uD83C\uDDFC","demonyms":{"eng":{"f":"Motswana","m":"Motswana"},"fra":{"f":"Botswanaise","m":"Botswanais"}}},{"name":{"common":"Central African Republic","official":"Central African Republic","native":{"fra":{"official":"R\xe9publique centrafricaine","common":"R\xe9publique centrafricaine"},"sag":{"official":"K\xf6d\xf6r\xf6s\xease t\xee B\xeaafr\xeeka","common":"B\xeaafr\xeeka"}}},"tld":[".cf"],"cca2":"CF","ccn3":"140","cca3":"CAF","cioc":"CAF","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"XAF":{"name":"Central African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["36"]},"capital":["Bangui"],"altSpellings":["CF","Central African Republic","R\xe9publique centrafricaine"],"region":"Africa","subregion":"Middle Africa","languages":{"fra":"French","sag":"Sango"},"translations":{"ces":{"official":"St\u0159edoafrick\xe1 republika","common":"St\u0159edoafrick\xe1 republika"},"cym":{"official":"Gweriniaeth Canolbarth Affrica","common":"Gweriniaeth Canolbarth Affrica"},"deu":{"official":"Zentralafrikanische Republik","common":"Zentralafrikanische Republik"},"est":{"official":"Kesk-Aafrika Vabariik","common":"Kesk-Aafrika Vabariik"},"fin":{"official":"Keski-Afrikan tasavalta","common":"Keski-Afrikan tasavalta"},"fra":{"official":"R\xe9publique centrafricaine","common":"R\xe9publique centrafricaine"},"hrv":{"official":"Centralna Afri\u010Dka Republika","common":"Srednjoafri\u010Dka Republika"},"hun":{"official":"K\xf6z\xe9p-afrikai K\xf6zt\xe1rsas\xe1g","common":"K\xf6z\xe9p-afrikai K\xf6zt\xe1rsas\xe1g"},"ita":{"official":"Repubblica Centrafricana","common":"Repubblica Centrafricana"},"jpn":{"official":"\u4E2D\u592E\u30A2\u30D5\u30EA\u30AB\u5171\u548C\u56FD","common":"\u4E2D\u592E\u30A2\u30D5\u30EA\u30AB\u5171\u548C\u56FD"},"kor":{"official":"\uC911\uC559\uC544\uD504\uB9AC\uCE74 \uACF5\uD654\uAD6D","common":"\uC911\uC559\uC544\uD504\uB9AC\uCE74 \uACF5\uD654\uAD6D"},"nld":{"official":"Centraal-Afrikaanse Republiek","common":"Centraal-Afrikaanse Republiek"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0622\u0641\u0631\u06CC\u0642\u0627\u06CC \u0645\u0631\u06A9\u0632\u06CC","common":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0622\u0641\u0631\u06CC\u0642\u0627\u06CC \u0645\u0631\u06A9\u0632\u06CC"},"pol":{"official":"Republika \u015Arodkowoafryka\u0144ska","common":"Republika \u015Arodkowoafryka\u0144ska"},"por":{"official":"Rep\xfablica Centro-Africano","common":"Rep\xfablica Centro-Africana"},"rus":{"official":"\u0426\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u043E-\u0410\u0444\u0440\u0438\u043A\u0430\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u0426\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u043E\u0430\u0444\u0440\u0438\u043A\u0430\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430"},"slk":{"official":"Stredoafrick\xe1 republika","common":"Stredoafrick\xe1 republika"},"spa":{"official":"Rep\xfablica Centroafricana","common":"Rep\xfablica Centroafricana"},"swe":{"official":"Centralafrikanska republiken","common":"Centralafrikanska republiken"},"urd":{"official":"\u0648\u0633\u0637\u06CC \u0627\u0641\u0631\u06CC\u0642\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1","common":"\u0648\u0633\u0637\u06CC \u0627\u0641\u0631\u06CC\u0642\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1"},"zho":{"official":"\u4E2D\u975E\u5171\u548C\u56FD","common":"\u4E2D\u975E\u5171\u548C\u56FD"}},"latlng":[7,21],"landlocked":true,"borders":["CMR","TCD","COD","COG","SSD","SDN"],"area":622984,"flag":"\uD83C\uDDE8\uD83C\uDDEB","demonyms":{"eng":{"f":"Central African","m":"Central African"},"fra":{"f":"Centrafricaine","m":"Centrafricain"}}},{"name":{"common":"Canada","official":"Canada","native":{"eng":{"official":"Canada","common":"Canada"},"fra":{"official":"Canada","common":"Canada"}}},"tld":[".ca"],"cca2":"CA","ccn3":"124","cca3":"CAN","cioc":"CAN","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"CAD":{"name":"Canadian dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["204","226","236","249","250","263","289","306","343","354","365","367","368","382","387","403","416","418","428","431","437","438","450","468","474","506","514","519","548","579","581","584","587","600","604","613","622","633","639","644","647","655","672","677","683","688","705","709","742","753","778","780","782","782","807","819","825","867","867","867","873","879","902","902","905","942"]},"capital":["Ottawa"],"altSpellings":["CA"],"region":"Americas","subregion":"North America","languages":{"eng":"English","fra":"French"},"translations":{"ces":{"official":"Kanada","common":"Kanada"},"cym":{"official":"Canada","common":"Canada"},"deu":{"official":"Kanada","common":"Kanada"},"est":{"official":"Kanada","common":"Kanada"},"fin":{"official":"Kanada","common":"Kanada"},"fra":{"official":"Canada","common":"Canada"},"hrv":{"official":"Kanada","common":"Kanada"},"hun":{"official":"Kanada","common":"Kanada"},"ita":{"official":"Canada","common":"Canada"},"jpn":{"official":"\u30AB\u30CA\u30C0","common":"\u30AB\u30CA\u30C0"},"kor":{"official":"\uCE90\uB098\uB2E4","common":"\uCE90\uB098\uB2E4"},"nld":{"official":"Canada","common":"Canada"},"per":{"official":"\u06A9\u0627\u0646\u0627\u062F\u0627","common":"\u06A9\u0627\u0646\u0627\u062F\u0627"},"pol":{"official":"Kanada","common":"Kanada"},"por":{"official":"Canad\xe1","common":"Canad\xe1"},"rus":{"official":"\u041A\u0430\u043D\u0430\u0434\u0430","common":"\u041A\u0430\u043D\u0430\u0434\u0430"},"slk":{"official":"Kanada","common":"Kanada"},"spa":{"official":"Canad\xe1","common":"Canad\xe1"},"swe":{"official":"Kanada","common":"Kanada"},"urd":{"official":"\u06A9\u06CC\u0646\u06CC\u0688\u0627","common":"\u06A9\u06CC\u0646\u06CC\u0688\u0627"},"zho":{"official":"\u52A0\u62FF\u5927","common":"\u52A0\u62FF\u5927"}},"latlng":[60,-95],"landlocked":false,"borders":["USA"],"area":9984670,"flag":"\uD83C\uDDE8\uD83C\uDDE6","demonyms":{"eng":{"f":"Canadian","m":"Canadian"},"fra":{"f":"Canadienne","m":"Canadien"}}},{"name":{"common":"Cocos (Keeling) Islands","official":"Territory of the Cocos (Keeling) Islands","native":{"eng":{"official":"Territory of the Cocos (Keeling) Islands","common":"Cocos (Keeling) Islands"}}},"tld":[".cc"],"cca2":"CC","ccn3":"166","cca3":"CCK","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"AUD":{"name":"Australian dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["1"]},"capital":["West Island"],"altSpellings":["CC","Keeling Islands","Cocos Islands"],"region":"Oceania","subregion":"Australia and New Zealand","languages":{"eng":"English"},"translations":{"ces":{"official":"Kokosov\xe9 ostrovy","common":"Kokosov\xe9 ostrovy"},"cym":{"official":"Tiriogaeth yr Ynysoedd Cocos (Keeling)","common":"Ynysoedd Cocos"},"deu":{"official":"Gebiet der Kokos- (Keeling-) Inseln","common":"Kokosinseln"},"est":{"official":"Kookossaarte ala","common":"Kookossaared"},"fin":{"official":"Kookossaaret","common":"Kookossaaret"},"fra":{"official":"Territoire des \xeeles Cocos (Keeling)","common":"\xceles Cocos"},"hrv":{"official":"Teritoriju Kokosovi (Keeling) Islands","common":"Kokosovi Otoci"},"hun":{"official":"K\xf3kusz-szigetek","common":"K\xf3kusz-szigetek"},"ita":{"official":"Territorio della (Keeling) Isole Cocos","common":"Isole Cocos e Keeling"},"jpn":{"official":"\u30B3\u30B3\u30B9\u8AF8\u5CF6\u306E\u9818\u571F","common":"\u30B3\u30B3\u30B9\uFF08\u30AD\u30FC\u30EA\u30F3\u30B0\uFF09\u8AF8\u5CF6"},"kor":{"official":"\uCF54\uCF54\uC2A4 \uC81C\uB3C4","common":"\uCF54\uCF54\uC2A4 \uC81C\uB3C4"},"nld":{"official":"Grondgebied van de Eilanden Cocos (Keeling )","common":"Cocoseilanden"},"per":{"official":"\u062C\u0632\u0627\u06CC\u0631 \u06A9\u0648\u06A9\u0648\u0633","common":"\u062C\u0632\u0627\u06CC\u0631 \u06A9\u0648\u06A9\u0648\u0633"},"pol":{"official":"Wyspy Kokosowe","common":"Wyspy Kokosowe"},"por":{"official":"Territ\xf3rio dos Cocos (Keeling)","common":"Ilhas Cocos (Keeling)"},"rus":{"official":"\u0422\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044F \u041A\u043E\u043A\u043E\u0441\u043E\u0432\u044B\u0435 (\u041A\u0438\u043B\u0438\u043D\u0433) \u043E\u0441\u0442\u0440\u043E\u0432\u0430","common":"\u041A\u043E\u043A\u043E\u0441\u043E\u0432\u044B\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430"},"slk":{"official":"Kokosov\xe9 ostrovy","common":"Kokosov\xe9 ostrovy"},"spa":{"official":"Territorio de los (Keeling) Islas Cocos","common":"Islas Cocos o Islas Keeling"},"swe":{"official":"Kokos\xf6arna","common":"Kokos\xf6arna"},"urd":{"official":"\u062C\u0632\u0627\u0626\u0631 (\u06A9\u06CC\u0644\u0646\u06AF) \u06A9\u0648\u06A9\u0648\u0633","common":"\u062C\u0632\u0627\u0626\u0631 \u06A9\u0648\u06A9\u0648\u0633"},"zho":{"official":"\u79D1\u79D1\u65AF","common":"\u79D1\u79D1\u65AF"}},"latlng":[-12.5,96.83333333],"landlocked":false,"borders":[],"area":14,"flag":"\uD83C\uDDE8\uD83C\uDDE8","demonyms":{"eng":{"f":"Cocos Islander","m":"Cocos Islander"},"fra":{"f":"","m":""}}},{"name":{"common":"Switzerland","official":"Swiss Confederation","native":{"fra":{"official":"Conf\xe9d\xe9ration suisse","common":"Suisse"},"gsw":{"official":"Schweizerische Eidgenossenschaft","common":"Schweiz"},"ita":{"official":"Confederazione Svizzera","common":"Svizzera"},"roh":{"official":"Confederaziun svizra","common":"Svizra"}}},"tld":[".ch"],"cca2":"CH","ccn3":"756","cca3":"CHE","cioc":"SUI","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"CHF":{"name":"Swiss franc","symbol":"Fr."}},"idd":{"root":"+4","suffixes":["1"]},"capital":["Bern"],"altSpellings":["CH","Swiss Confederation","Schweiz","Suisse","Svizzera","Svizra"],"region":"Europe","subregion":"Western Europe","languages":{"fra":"French","gsw":"Swiss German","ita":"Italian","roh":"Romansh"},"translations":{"ces":{"official":"\u0160v\xfdcarsk\xe1 konfederace","common":"\u0160v\xfdcarsko"},"deu":{"official":"Schweizerische Eidgenossenschaft","common":"Schweiz"},"est":{"official":"\u0160veitsi Konf\xf6deratsioon","common":"\u0160veits"},"fin":{"official":"Sveitsin valaliitto","common":"Sveitsi"},"fra":{"official":"Conf\xe9d\xe9ration suisse","common":"Suisse"},"hrv":{"official":"\u0161vicarska Konfederacija","common":"\u0160vicarska"},"hun":{"official":"Sv\xe1jc","common":"Sv\xe1jc"},"ita":{"official":"Confederazione svizzera","common":"Svizzera"},"jpn":{"official":"\u30B9\u30A4\u30B9\u9023\u90A6","common":"\u30B9\u30A4\u30B9"},"kor":{"official":"\uC2A4\uC704\uC2A4 \uC5F0\uBC29","common":"\uC2A4\uC704\uC2A4"},"nld":{"official":"Zwitserse Confederatie","common":"Zwitserland"},"per":{"official":"\u06A9\u0646\u0641\u062F\u0631\u0627\u0633\u06CC\u0648\u0646 \u0633\u0648\u0626\u06CC\u0633","common":"\u0633\u0648\u0626\u06CC\u0633"},"pol":{"official":"Konfederacja Szwajcarska","common":"Szwajcaria"},"por":{"official":"Confedera\xe7\xe3o Su\xed\xe7a","common":"Su\xed\xe7a"},"rus":{"official":"\u0428\u0432\u0435\u0439\u0446\u0430\u0440\u0441\u043A\u0430\u044F \u041A\u043E\u043D\u0444\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u044F","common":"\u0428\u0432\u0435\u0439\u0446\u0430\u0440\u0438\u044F"},"slk":{"official":"\u0160vaj\u010Diarska konfeder\xe1cia","common":"\u0160vaj\u010Diarsko"},"spa":{"official":"Confederaci\xf3n Suiza","common":"Suiza"},"swe":{"official":"Schweiziska edsf\xf6rbundet","common":"Schweiz"},"urd":{"official":"\u0633\u0648\u0626\u06CC\u0633  \u0645\u062A\u062D\u062F\u06C1","common":"\u0633\u0648\u06CC\u0679\u0630\u0631\u0644\u06CC\u0646\u0688"},"zho":{"official":"\u745E\u58EB\u8054\u90A6","common":"\u745E\u58EB"}},"latlng":[47,8],"landlocked":true,"borders":["AUT","FRA","ITA","LIE","DEU"],"area":41284,"flag":"\uD83C\uDDE8\uD83C\uDDED","demonyms":{"eng":{"f":"Swiss","m":"Swiss"},"fra":{"f":"Suisse","m":"Suisse"}}},{"name":{"common":"Chile","official":"Republic of Chile","native":{"spa":{"official":"Rep\xfablica de Chile","common":"Chile"}}},"tld":[".cl"],"cca2":"CL","ccn3":"152","cca3":"CHL","cioc":"CHI","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"CLP":{"name":"Chilean peso","symbol":"$"}},"idd":{"root":"+5","suffixes":["6"]},"capital":["Santiago"],"altSpellings":["CL","Republic of Chile","Rep\xfablica de Chile"],"region":"Americas","subregion":"South America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Chilsk\xe1 republika","common":"Chile"},"cym":{"official":"Gweriniaeth Chile","common":"Chile"},"deu":{"official":"Republik Chile","common":"Chile"},"est":{"official":"T\u0161iili Vabariik","common":"T\u0161iili"},"fin":{"official":"Chilen tasavalta","common":"Chile"},"fra":{"official":"R\xe9publique du Chili","common":"Chili"},"hrv":{"official":"Republika \u010Cile","common":"\u010Cile"},"hun":{"official":"Chilei K\xf6zt\xe1rsas\xe1g","common":"Chile"},"ita":{"official":"Repubblica del Cile","common":"Cile"},"jpn":{"official":"\u30C1\u30EA\u5171\u548C\u56FD","common":"\u30C1\u30EA"},"kor":{"official":"\uCE60\uB808 \uACF5\uD654\uAD6D","common":"\uCE60\uB808"},"nld":{"official":"Republiek Chili","common":"Chili"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0634\u06CC\u0644\u06CC","common":"\u0634\u06CC\u0644\u06CC"},"pol":{"official":"Republika Chile","common":"Chile"},"por":{"official":"Rep\xfablica do Chile","common":"Chile"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0427\u0438\u043B\u0438","common":"\u0427\u0438\u043B\u0438"},"slk":{"official":"\u010C\xedlska republika","common":"\u010Cile"},"spa":{"official":"Rep\xfablica de Chile","common":"Chile"},"swe":{"official":"Republiken Chile","common":"Chile"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0686\u0644\u06CC","common":"\u0686\u0644\u06CC"},"zho":{"official":"\u667A\u5229\u5171\u548C\u56FD","common":"\u667A\u5229"}},"latlng":[-30,-71],"landlocked":false,"borders":["ARG","BOL","PER"],"area":756102,"flag":"\uD83C\uDDE8\uD83C\uDDF1","demonyms":{"eng":{"f":"Chilean","m":"Chilean"},"fra":{"f":"Chilienne","m":"Chilien"}}},{"name":{"common":"China","official":"People\'s Republic of China","native":{"zho":{"official":"\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD","common":"\u4E2D\u56FD"}}},"tld":[".cn",".\u4E2D\u56FD",".\u4E2D\u570B",".\u516C\u53F8",".\u7F51\u7EDC"],"cca2":"CN","ccn3":"156","cca3":"CHN","cioc":"CHN","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"CNY":{"name":"Chinese yuan","symbol":"\xa5"}},"idd":{"root":"+8","suffixes":["6"]},"capital":["Beijing"],"altSpellings":["CN","Zh\u014Dnggu\xf3","Zhongguo","Zhonghua","People\'s Republic of China","\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD","Zh\u014Dnghu\xe1 R\xe9nm\xedn G\xf2ngh\xe9gu\xf3"],"region":"Asia","subregion":"Eastern Asia","languages":{"zho":"Chinese"},"translations":{"ces":{"official":"\u010C\xednsk\xe1 lidov\xe1 republika","common":"\u010C\xedna"},"cym":{"official":"Gweriniaeth Pobl Tsieina","common":"Tsieina"},"deu":{"official":"Volksrepublik China","common":"China"},"est":{"official":"Hiina Rahvavabariik","common":"Hiina"},"fin":{"official":"Kiinan kansantasavalta","common":"Kiina"},"fra":{"official":"R\xe9publique populaire de Chine","common":"Chine"},"hrv":{"official":"Narodna Republika Kina","common":"Kina"},"hun":{"official":"K\xednai N\xe9pk\xf6zt\xe1rsas\xe1g","common":"K\xedna"},"ita":{"official":"Repubblica popolare cinese","common":"Cina"},"jpn":{"official":"\u4E2D\u83EF\u4EBA\u6C11\u5171\u548C\u56FD","common":"\u4E2D\u56FD"},"kor":{"official":"\uC911\uD654\uC778\uBBFC\uACF5\uD654\uAD6D","common":"\uC911\uAD6D"},"nld":{"official":"Volksrepubliek China","common":"China"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u062E\u0644\u0642 \u0686\u06CC\u0646","common":"\u0686\u06CC\u0646"},"pol":{"official":"Chi\u0144ska Republika Ludowa","common":"Chiny"},"por":{"official":"Rep\xfablica Popular da China","common":"China"},"rus":{"official":"\u041D\u0430\u0440\u043E\u0434\u043D\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u0438\u0442\u0430\u0439","common":"\u041A\u0438\u0442\u0430\u0439"},"slk":{"official":"\u010C\xednska \u013Eudov\xe1 republika","common":"\u010C\xedna"},"spa":{"official":"Rep\xfablica Popular de China","common":"China"},"swe":{"official":"Folkrepubliken Kina","common":"Kina"},"urd":{"official":"\u0639\u0648\u0627\u0645\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0686\u06CC\u0646","common":"\u0686\u06CC\u0646"}},"latlng":[35,105],"landlocked":false,"borders":["AFG","BTN","MMR","HKG","IND","KAZ","NPL","PRK","KGZ","LAO","MAC","MNG","PAK","RUS","TJK","VNM"],"area":9706961,"flag":"\uD83C\uDDE8\uD83C\uDDF3","demonyms":{"eng":{"f":"Chinese","m":"Chinese"},"fra":{"f":"Chinoise","m":"Chinois"}}},{"name":{"common":"Ivory Coast","official":"Republic of C\xf4te d\'Ivoire","native":{"fra":{"official":"R\xe9publique de C\xf4te d\'Ivoire","common":"C\xf4te d\'Ivoire"}}},"tld":[".ci"],"cca2":"CI","ccn3":"384","cca3":"CIV","cioc":"CIV","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"XOF":{"name":"West African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["25"]},"capital":["Yamoussoukro"],"altSpellings":["CI","C\xf4te d\'Ivoire","Ivory Coast","Republic of C\xf4te d\'Ivoire","R\xe9publique de C\xf4te d\'Ivoire"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"ces":{"official":"Republika Pob\u0159e\u017E\xed slonoviny","common":"Pob\u0159e\u017E\xed slonoviny"},"deu":{"official":"Republik C\xf4te d\'Ivoire","common":"Elfenbeink\xfcste"},"est":{"official":"C\xf4te d\u2019Ivoire\u2019i Vabariik","common":"Elevandiluurannik"},"fin":{"official":"Norsunluurannikon tasavalta","common":"Norsunluurannikko"},"fra":{"official":"R\xe9publique de C\xf4te d\' Ivoire","common":"C\xf4te d\'Ivoire"},"hrv":{"official":"Republika C\xf4te d\'Ivoire","common":"Obala Bjelokosti"},"hun":{"official":"Elef\xe1ntcsontparti K\xf6zt\xe1rsas\xe1g","common":"Elef\xe1ntcsontpart"},"ita":{"official":"Repubblica della Costa d\'Avorio","common":"Costa d\'Avorio"},"jpn":{"official":"\u30B3\u30FC\u30C8\u30B8\u30DC\u30EF\u30FC\u30EB\u5171\u548C\u56FD","common":"\u30B3\u30FC\u30C8\u30B8\u30DC\u30EF\u30FC\u30EB"},"kor":{"official":"\uCF54\uD2B8\uB514\uBD80\uC544\uB974 \uACF5\uD654\uAD6D","common":"\uCF54\uD2B8\uB514\uBD80\uC544\uB974"},"nld":{"official":"Republiek Ivoorkust","common":"Ivoorkust"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0633\u0627\u062D\u0644 \u0639\u0627\u062C","common":"\u0633\u0627\u062D\u0644 \u0639\u0627\u062C"},"pol":{"official":"Republika Wybrze\u017Ba Ko\u015Bci S\u0142oniowej","common":"Wybrze\u017Be Ko\u015Bci S\u0142oniowej"},"por":{"official":"Rep\xfablica da C\xf4te d\'Ivoire","common":"Costa do Marfim"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u0442-\u0434\'\u0418\u0432\u0443\u0430\u0440\u0435","common":"\u041A\u043E\u0442-\u0434\u2019\u0418\u0432\u0443\u0430\u0440"},"slk":{"official":"Republika Pobre\u017Eie Slonoviny","common":"Pobr\u017Eie Slonoviny"},"spa":{"official":"Rep\xfablica de C\xf4te d\'Ivoire","common":"Costa de Marfil"},"swe":{"official":"Republiken Elfenbenskusten","common":"Elfenbenskusten"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06A9\u0648\u062A \u062F\u06CC\u0648\u0627\u063A","common":"\u0622\u0626\u06CC\u0648\u0631\u06CC \u06A9\u0648\u0633\u0679"},"zho":{"official":"\u79D1\u7279\u8FEA\u74E6\u5171\u548C\u56FD","common":"\u79D1\u7279\u8FEA\u74E6"}},"latlng":[8,-5],"landlocked":false,"borders":["BFA","GHA","GIN","LBR","MLI"],"area":322463,"flag":"\uD83C\uDDE8\uD83C\uDDEE","demonyms":{"eng":{"f":"Ivorian","m":"Ivorian"},"fra":{"f":"Ivoirienne","m":"Ivoirien"}}},{"name":{"common":"Cameroon","official":"Republic of Cameroon","native":{"eng":{"official":"Republic of Cameroon","common":"Cameroon"},"fra":{"official":"R\xe9publique du Cameroun","common":"Cameroun"}}},"tld":[".cm"],"cca2":"CM","ccn3":"120","cca3":"CMR","cioc":"CMR","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"XAF":{"name":"Central African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["37"]},"capital":["Yaound\xe9"],"altSpellings":["CM","Republic of Cameroon","R\xe9publique du Cameroun"],"region":"Africa","subregion":"Middle Africa","languages":{"eng":"English","fra":"French"},"translations":{"ces":{"official":"Kamerunsk\xe1 republika","common":"Kamerun"},"cym":{"official":"Gweriniaeth Camer\u0175n","common":"Camer\u0175n"},"deu":{"official":"Republik Kamerun","common":"Kamerun"},"est":{"official":"Kameruni Vabariik","common":"Kamerun"},"fin":{"official":"Kamerunin tasavalta","common":"Kamerun"},"fra":{"official":"R\xe9publique du Cameroun","common":"Cameroun"},"hrv":{"official":"Republika Kamerun","common":"Kamerun"},"hun":{"official":"Kameruni K\xf6zt\xe1rsas\xe1g","common":"Kamerun"},"ita":{"official":"Repubblica del Camerun","common":"Camerun"},"jpn":{"official":"\u30AB\u30E1\u30EB\u30FC\u30F3\u5171\u548C\u56FD","common":"\u30AB\u30E1\u30EB\u30FC\u30F3"},"kor":{"official":"\uCE74\uBA54\uB8EC \uACF5\uD654\uAD6D","common":"\uCE74\uBA54\uB8EC"},"nld":{"official":"Republiek Kameroen","common":"Kameroen"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u06A9\u0627\u0645\u0650\u0631\u0648\u0646","common":"\u06A9\u0627\u0645\u0650\u0631\u0648\u0646"},"pol":{"official":"Republika Wybrze\u017Ba Ko\u015Bci S\u0142oniowej","common":"Wybrze\u017Be Ko\u015Bci S\u0142oniowej"},"por":{"official":"Rep\xfablica dos Camar\xf5es","common":"Camar\xf5es"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u0430\u043C\u0435\u0440\u0443\u043D","common":"\u041A\u0430\u043C\u0435\u0440\u0443\u043D"},"slk":{"official":"Kamerunsk\xe1 republika","common":"Kamerun"},"spa":{"official":"Rep\xfablica de Camer\xfan","common":"Camer\xfan"},"swe":{"official":"Republiken Kamerun","common":"Kamerun"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06A9\u06CC\u0645\u0631\u0648\u0646","common":"\u06A9\u06CC\u0645\u0631\u0648\u0646"},"zho":{"official":"\u5580\u9EA6\u9686\u5171\u548C\u56FD","common":"\u5580\u9EA6\u9686"}},"latlng":[6,12],"landlocked":false,"borders":["CAF","TCD","COG","GNQ","GAB","NGA"],"area":475442,"flag":"\uD83C\uDDE8\uD83C\uDDF2","demonyms":{"eng":{"f":"Cameroonian","m":"Cameroonian"},"fra":{"f":"Camerounaise","m":"Camerounais"}}},{"name":{"common":"DR Congo","official":"Democratic Republic of the Congo","native":{"fra":{"official":"R\xe9publique d\xe9mocratique du Congo","common":"RD Congo"},"kon":{"official":"Repubilika ya Kongo Demokratiki","common":"Repubilika ya Kongo Demokratiki"},"lin":{"official":"Republiki ya Kong\xf3 Demokratiki","common":"Republiki ya Kong\xf3 Demokratiki"},"lua":{"official":"Ditunga dia Kongu wa Mungalaata","common":"Ditunga dia Kongu wa Mungalaata"},"swa":{"official":"Jamhuri ya Kidemokrasia ya Kongo","common":"Jamhuri ya Kidemokrasia ya Kongo"}}},"tld":[".cd"],"cca2":"CD","ccn3":"180","cca3":"COD","cioc":"COD","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"CDF":{"name":"Congolese franc","symbol":"FC"}},"idd":{"root":"+2","suffixes":["43"]},"capital":["Kinshasa"],"altSpellings":["CD","DR Congo","Congo-Kinshasa","Congo, the Democratic Republic of the","DRC"],"region":"Africa","subregion":"Middle Africa","languages":{"fra":"French","kon":"Kikongo","lin":"Lingala","lua":"Tshiluba","swa":"Swahili"},"translations":{"ces":{"official":"Demokratick\xe1 republika Kongo","common":"DR Kongo"},"cym":{"official":"Gweriniaeth Ddemocrataidd Congo","common":"Gweriniaeth Ddemocrataidd Congo"},"deu":{"official":"Demokratische Republik Kongo","common":"Kongo (Dem. Rep.)"},"est":{"official":"Kongo Demokraatlik Vabariik","common":"Kongo DV"},"fin":{"official":"Kongon demokraattinen tasavalta","common":"Kongon demokraattinen tasavalta"},"fra":{"official":"R\xe9publique d\xe9mocratique du Congo","common":"Congo (R\xe9p. d\xe9m.)"},"hrv":{"official":"Demokratska Republika Kongo","common":"Kongo, Demokratska Republika"},"hun":{"official":"Kong\xf3i Demokratikus K\xf6zt\xe1rsas\xe1g","common":"Kong\xf3i Demokratikus K\xf6zt\xe1rsas\xe1g"},"ita":{"official":"Repubblica Democratica del Congo","common":"Congo (Rep. Dem.)"},"jpn":{"official":"\u30B3\u30F3\u30B4\u6C11\u4E3B\u5171\u548C\u56FD","common":"\u30B3\u30F3\u30B4\u6C11\u4E3B\u5171\u548C\u56FD"},"kor":{"official":"\uCF69\uACE0 \uBBFC\uC8FC \uACF5\uD654\uAD6D","common":"\uCF69\uACE0 \uBBFC\uC8FC \uACF5\uD654\uAD6D"},"nld":{"official":"Democratische Republiek Congo","common":"Congo (DRC)"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u062F\u0645\u0648\u06A9\u0631\u0627\u062A\u06CC\u06A9 \u06A9\u0646\u06AF\u0648","common":"\u06A9\u0646\u06AF\u0648 \u062F\u0645\u0648\u06A9\u0631\u0627\u062A\u06CC\u06A9"},"pol":{"official":"Demokratyczna Republika Konga","common":"Demokratyczna Republika Konga"},"por":{"official":"Rep\xfablica Democr\xe1tica do Congo","common":"Rep\xfablica Democr\xe1tica do Congo"},"rus":{"official":"\u0414\u0435\u043C\u043E\u043A\u0440\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u043D\u0433\u043E","common":"\u0414\u0435\u043C\u043E\u043A\u0440\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u043D\u0433\u043E"},"slk":{"official":"Kon\u017Esk\xe1 demokratick\xe1 republika","common":"Kongo"},"spa":{"official":"Rep\xfablica Democr\xe1tica del Congo","common":"Congo (Rep. Dem.)"},"swe":{"official":"Demokratiska republiken Kongo","common":"Kongo-Kinshasa"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06A9\u0627\u0646\u06AF\u0648","common":"\u06A9\u0627\u0646\u06AF\u0648"},"zho":{"official":"\u521A\u679C\u6C11\u4E3B\u5171\u548C\u56FD","common":"\u6C11\u4E3B\u521A\u679C"}},"latlng":[0,25],"landlocked":false,"borders":["AGO","BDI","CAF","COG","RWA","SSD","TZA","UGA","ZMB"],"area":2344858,"flag":"\uD83C\uDDE8\uD83C\uDDE9","demonyms":{"eng":{"f":"Congolese","m":"Congolese"},"fra":{"f":"Congolaise","m":"Congolais"}}},{"name":{"common":"Republic of the Congo","official":"Republic of the Congo","native":{"fra":{"official":"R\xe9publique du Congo","common":"R\xe9publique du Congo"},"kon":{"official":"Repubilika ya Kongo","common":"Repubilika ya Kongo"},"lin":{"official":"Republ\xedki ya Kong\xf3","common":"Republ\xedki ya Kong\xf3"}}},"tld":[".cg"],"cca2":"CG","ccn3":"178","cca3":"COG","cioc":"CGO","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"XAF":{"name":"Central African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["42"]},"capital":["Brazzaville"],"altSpellings":["CG","Congo","Congo-Brazzaville"],"region":"Africa","subregion":"Middle Africa","languages":{"fra":"French","kon":"Kikongo","lin":"Lingala"},"translations":{"ces":{"official":"Kon\u017Esk\xe1 republika","common":"Kongo"},"cym":{"official":"Gweriniaeth y Congo","common":"Gweriniaeth y Congo"},"deu":{"official":"Republik Kongo","common":"Kongo"},"est":{"official":"Kongo Vabariik","common":"Kongo Vabariik"},"fin":{"official":"Kongon tasavalta","common":"Kongo-Brazzaville"},"fra":{"official":"R\xe9publique du Congo","common":"Congo"},"hrv":{"official":"Republika Kongo","common":"Kongo"},"hun":{"official":"Kong\xf3i K\xf6zt\xe1rsas\xe1g","common":"Kong\xf3i K\xf6zt\xe1rsas\xe1g"},"ita":{"official":"Repubblica del Congo","common":"Congo"},"jpn":{"official":"\u30B3\u30F3\u30B4\u5171\u548C\u56FD","common":"\u30B3\u30F3\u30B4\u5171\u548C\u56FD"},"kor":{"official":"\uCF69\uACE0","common":"\uCF69\uACE0"},"nld":{"official":"Republiek Congo","common":"Congo"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0628\u0631\u0627\u0632\u0627\u0648\u06CC\u0644 \u06A9\u064F\u0646\u06AF\u0648","common":"\u062C\u0645\u0647\u0648\u0631\u06CC \u06A9\u064F\u0646\u06AF\u0648"},"pol":{"official":"Republika Konga","common":"Kongo"},"por":{"official":"Rep\xfablica do Congo","common":"Congo"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u043D\u0433\u043E","common":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u043D\u0433\u043E"},"slk":{"official":"Kon\u017Esk\xe1 republika","common":"Kongo"},"spa":{"official":"Rep\xfablica del Congo","common":"Congo"},"swe":{"official":"Republiken Kongo","common":"Kongo-Brazzaville"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06A9\u0627\u0646\u06AF\u0648","common":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06A9\u0627\u0646\u06AF\u0648"},"zho":{"official":"\u521A\u679C\u5171\u548C\u56FD","common":"\u521A\u679C"}},"latlng":[-1,15],"landlocked":false,"borders":["AGO","CMR","CAF","COD","GAB"],"area":342000,"flag":"\uD83C\uDDE8\uD83C\uDDEC","demonyms":{"eng":{"f":"Congolese","m":"Congolese"},"fra":{"f":"Congolaise","m":"Congolais"}}},{"name":{"common":"Cook Islands","official":"Cook Islands","native":{"eng":{"official":"Cook Islands","common":"Cook Islands"},"rar":{"official":"K\u016Bki \'\u0100irani","common":"K\u016Bki \'\u0100irani"}}},"tld":[".ck"],"cca2":"CK","ccn3":"184","cca3":"COK","cioc":"COK","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"CKD":{"name":"Cook Islands dollar","symbol":"$"},"NZD":{"name":"New Zealand dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["82"]},"capital":["Avarua"],"altSpellings":["CK","K\u016Bki \'\u0100irani"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English","rar":"Cook Islands M\u0101ori"},"translations":{"ces":{"official":"Cookovy ostrovy","common":"Cookovy ostrovy"},"cym":{"official":"Ynysoedd Cook","common":"Ynysoedd Cook"},"deu":{"official":"Cookinseln","common":"Cookinseln"},"est":{"official":"Cooki saared","common":"Cooki saared"},"fin":{"official":"Cookinsaaret","common":"Cookinsaaret"},"fra":{"official":"\xceles Cook","common":"\xceles Cook"},"hrv":{"official":"Cook Islands","common":"Cookovo Oto\u010Dje"},"hun":{"official":"Cook-szigetek","common":"Cook-szigetek"},"ita":{"official":"Isole Cook","common":"Isole Cook"},"jpn":{"official":"\u30AF\u30C3\u30AF\u8AF8\u5CF6","common":"\u30AF\u30C3\u30AF\u8AF8\u5CF6"},"kor":{"official":"\uCFE1 \uC81C\uB3C4","common":"\uCFE1 \uC81C\uB3C4"},"nld":{"official":"Cook eilanden","common":"Cookeilanden"},"per":{"official":"\u062C\u0632\u0627\u06CC\u0631 \u06A9\u0648\u06A9","common":"\u062C\u0632\u0627\u06CC\u0631 \u06A9\u0648\u06A9"},"pol":{"official":"Wyspy Cooka","common":"Wyspy Cooka"},"por":{"official":"Ilhas Cook","common":"Ilhas Cook"},"rus":{"official":"\u043E\u0441\u0442\u0440\u043E\u0432\u0430 \u041A\u0443\u043A\u0430","common":"\u041E\u0441\u0442\u0440\u043E\u0432\u0430 \u041A\u0443\u043A\u0430"},"slk":{"official":"Cookove ostrovy","common":"Cookove ostrovy"},"spa":{"official":"Islas Cook","common":"Islas Cook"},"swe":{"official":"Cook\xf6arna","common":"Cook\xf6arna"},"urd":{"official":"\u062C\u0632\u0627\u0626\u0631 \u06A9\u06A9","common":"\u062C\u0632\u0627\u0626\u0631 \u06A9\u06A9"},"zho":{"official":"\u5E93\u514B\u7FA4\u5C9B","common":"\u5E93\u514B\u7FA4\u5C9B"}},"latlng":[-21.23333333,-159.76666666],"landlocked":false,"borders":[],"area":236,"flag":"\uD83C\uDDE8\uD83C\uDDF0","demonyms":{"eng":{"f":"Cook Islander","m":"Cook Islander"},"fra":{"f":"Cookienne","m":"Cookien"}}},{"name":{"common":"Colombia","official":"Republic of Colombia","native":{"spa":{"official":"Rep\xfablica de Colombia","common":"Colombia"}}},"tld":[".co"],"cca2":"CO","ccn3":"170","cca3":"COL","cioc":"COL","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"COP":{"name":"Colombian peso","symbol":"$"}},"idd":{"root":"+5","suffixes":["7"]},"capital":["Bogot\xe1"],"altSpellings":["CO","Republic of Colombia","Rep\xfablica de Colombia"],"region":"Americas","subregion":"South America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Kolumbijsk\xe1 republika","common":"Kolumbie"},"cym":{"official":"Gweriniaeth Colombia","common":"Colombia"},"deu":{"official":"Republik Kolumbien","common":"Kolumbien"},"est":{"official":"Colombia Vabariik","common":"Colombia"},"fin":{"official":"Kolumbian tasavalta","common":"Kolumbia"},"fra":{"official":"R\xe9publique de Colombie","common":"Colombie"},"hrv":{"official":"Republika Kolumbija","common":"Kolumbija"},"hun":{"official":"Kolumbiai K\xf6zt\xe1rsas\xe1g","common":"Kolumbia"},"ita":{"official":"Repubblica di Colombia","common":"Colombia"},"jpn":{"official":"\u30B3\u30ED\u30F3\u30D3\u30A2\u5171\u548C\u56FD","common":"\u30B3\u30ED\u30F3\u30D3\u30A2"},"kor":{"official":"\uCF5C\uB86C\uBE44\uC544 \uACF5\uD654\uAD6D","common":"\uCF5C\uB86C\uBE44\uC544"},"nld":{"official":"Republiek Colombia","common":"Colombia"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u06A9\u0644\u0645\u0628\u06CC\u0627","common":"\u06A9\u0644\u0645\u0628\u06CC\u0627"},"pol":{"official":"Republika Kolumbii","common":"Kolumbia"},"por":{"official":"Rep\xfablica da Col\xf4mbia","common":"Col\xf4mbia"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u043B\u0443\u043C\u0431\u0438\u044F","common":"\u041A\u043E\u043B\u0443\u043C\u0431\u0438\u044F"},"slk":{"official":"Kolumbijsk\xe1 republika","common":"Kolumbia"},"spa":{"official":"Rep\xfablica de Colombia","common":"Colombia"},"swe":{"official":"Republiken Colombia","common":"Colombia"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06A9\u0648\u0644\u0645\u0628\u06CC\u0627","common":"\u06A9\u0648\u0644\u0645\u0628\u06CC\u0627"},"zho":{"official":"\u54E5\u4F26\u6BD4\u4E9A\u5171\u548C\u56FD","common":"\u54E5\u4F26\u6BD4\u4E9A"}},"latlng":[4,-72],"landlocked":false,"borders":["BRA","ECU","PAN","PER","VEN"],"area":1141748,"flag":"\uD83C\uDDE8\uD83C\uDDF4","demonyms":{"eng":{"f":"Colombian","m":"Colombian"},"fra":{"f":"Colombienne","m":"Colombien"}}},{"name":{"common":"Comoros","official":"Union of the Comoros","native":{"ara":{"official":"\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0642\u0645\u0631\u064A","common":"\u0627\u0644\u0642\u0645\u0631\u200E"},"fra":{"official":"Union des Comores","common":"Comores"},"zdj":{"official":"Udzima wa Komori","common":"Komori"}}},"tld":[".km"],"cca2":"KM","ccn3":"174","cca3":"COM","cioc":"COM","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"KMF":{"name":"Comorian franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["69"]},"capital":["Moroni"],"altSpellings":["KM","Union of the Comoros","Union des Comores","Udzima wa Komori","al-Itti\u1E25\u0101d al-Qumur\u012B"],"region":"Africa","subregion":"Eastern Africa","languages":{"ara":"Arabic","fra":"French","zdj":"Comorian"},"translations":{"ces":{"official":"Komorsk\xfd svaz","common":"Komory"},"cym":{"official":"Undeb y Comoros","common":"Y Comoros"},"deu":{"official":"Union der Komoren","common":"Komoren"},"est":{"official":"Komoori Liit","common":"Komoorid"},"fin":{"official":"Komorien liitto","common":"Komorit"},"fra":{"official":"Union des Comores","common":"Comores"},"hrv":{"official":"Savez Komori","common":"Komori"},"hun":{"official":"Comore-szigeteki Uni\xf3","common":"Comore-szigetek"},"ita":{"official":"Unione delle Comore","common":"Comore"},"jpn":{"official":"\u30B3\u30E2\u30ED\u9023\u5408","common":"\u30B3\u30E2\u30ED"},"kor":{"official":"\uCF54\uBAA8\uB85C \uC5F0\uBC29","common":"\uCF54\uBAA8\uB85C"},"nld":{"official":"Unie van de Comoren","common":"Comoren"},"per":{"official":"\u0645\u062C\u0645\u0639\u200C\u0627\u0644\u062C\u0632\u0627\u06CC\u0631 \u0642\u0645\u0631","common":"\u0627\u062A\u062D\u0627\u062F \u0642\u064F\u0645\u064F\u0631"},"pol":{"official":"Zwi\u0105zek Komor\xf3w","common":"Komory"},"por":{"official":"Uni\xe3o das Comores","common":"Comores"},"rus":{"official":"\u0421\u043E\u044E\u0437 \u041A\u043E\u043C\u043E\u0440\u0441\u043A\u0438\u0445 \u041E\u0441\u0442\u0440\u043E\u0432\u043E\u0432","common":"\u041A\u043E\u043C\u043E\u0440\u044B"},"slk":{"official":"Komorsk\xe1 \xfania","common":"Komory"},"spa":{"official":"Uni\xf3n de las Comoras","common":"Comoras"},"swe":{"official":"Unionen Komorerna","common":"Komorerna"},"urd":{"official":"\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0642\u0645\u0631\u06CC","common":"\u0627\u0644\u0642\u0645\u0631\u06CC"},"zho":{"official":"\u79D1\u6469\u7F57\u8054\u76DF","common":"\u79D1\u6469\u7F57"}},"latlng":[-12.16666666,44.25],"landlocked":false,"borders":[],"area":1862,"flag":"\uD83C\uDDF0\uD83C\uDDF2","demonyms":{"eng":{"f":"Comoran","m":"Comoran"},"fra":{"f":"Comorienne","m":"Comorien"}}},{"name":{"common":"Cape Verde","official":"Republic of Cabo Verde","native":{"por":{"official":"Rep\xfablica de Cabo Verde","common":"Cabo Verde"}}},"tld":[".cv"],"cca2":"CV","ccn3":"132","cca3":"CPV","cioc":"CPV","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"CVE":{"name":"Cape Verdean escudo","symbol":"Esc"}},"idd":{"root":"+2","suffixes":["38"]},"capital":["Praia"],"altSpellings":["CV","Republic of Cabo Verde","Rep\xfablica de Cabo Verde"],"region":"Africa","subregion":"Western Africa","languages":{"por":"Portuguese"},"translations":{"ces":{"official":"Kapverdsk\xe1 republika","common":"Kapverdy"},"cym":{"official":"Gweriniaeth Cabo Verde","common":"Penrhyn Verde"},"deu":{"official":"Republik Cabo Verde","common":"Kap Verde"},"est":{"official":"Cabo Verde Vabariik","common":"Roheneemesaared"},"fin":{"official":"Kap Verden tasavalta","common":"Kap Verde"},"fra":{"official":"R\xe9publique du Cap-Vert","common":"\xceles du Cap-Vert"},"hrv":{"official":"Republika Cabo Verde","common":"Zelenortska Republika"},"hun":{"official":"Z\xf6ld-foki K\xf6zt\xe1rsas\xe1g","common":"Z\xf6ld-foki K\xf6zt\xe1rsas\xe1g"},"ita":{"official":"Repubblica di Capo Verde","common":"Capo Verde"},"jpn":{"official":"\u30AB\u30FC\u30DC\u30D9\u30EB\u30C7\u5171\u548C\u56FD","common":"\u30AB\u30FC\u30DC\u30D9\u30EB\u30C7"},"kor":{"official":"\uCE74\uBCF4\uBCA0\uB974\uB370 \uACF5\uD654\uAD6D","common":"\uCE74\uBCF4\uBCA0\uB974\uB370"},"nld":{"official":"Republiek van Cabo Verde","common":"Kaapverdi\xeb"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u06A9\u0628\u0648 \u0648\u0631\u062F","common":"\u062F\u0645\u0627\u063A\u0647\u0654 \u0633\u0628\u0632"},"pol":{"official":"Republika Zielonego Przyl\u0105dka","common":"Republika Zielonego Przyl\u0105dka"},"por":{"official":"Rep\xfablica de Cabo Verde","common":"Cabo Verde"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u0430\u0431\u043E -\u0412\u0435\u0440\u0434\u0435","common":"\u041A\u0430\u0431\u043E-\u0412\u0435\u0440\u0434\u0435"},"slk":{"official":"Kapverdsk\xe1 republika","common":"Kapverdy"},"spa":{"official":"Rep\xfablica de Cabo Verde","common":"Cabo Verde"},"swe":{"official":"Republiken Kap Verde","common":"Kap Verde"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06A9\u06CC\u067E \u0648\u0631\u0688\u06CC","common":"\u06A9\u06CC\u067E \u0648\u0631\u0688\u06CC"},"zho":{"official":"\u4F5B\u5F97\u89D2\u5171\u548C\u56FD","common":"\u4F5B\u5F97\u89D2"}},"latlng":[16,-24],"landlocked":false,"borders":[],"area":4033,"flag":"\uD83C\uDDE8\uD83C\uDDFB","demonyms":{"eng":{"f":"Cape Verdian","m":"Cape Verdian"},"fra":{"f":"Cap-verdienne","m":"Cap-verdien"}}},{"name":{"common":"Costa Rica","official":"Republic of Costa Rica","native":{"spa":{"official":"Rep\xfablica de Costa Rica","common":"Costa Rica"}}},"tld":[".cr"],"cca2":"CR","ccn3":"188","cca3":"CRI","cioc":"CRC","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"CRC":{"name":"Costa Rican col\xf3n","symbol":"\u20A1"}},"idd":{"root":"+5","suffixes":["06"]},"capital":["San Jos\xe9"],"altSpellings":["CR","Republic of Costa Rica","Rep\xfablica de Costa Rica"],"region":"Americas","subregion":"Central America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Kostarick\xe1 republika","common":"Kostarika"},"cym":{"official":"Gweriniaeth Costa Rica","common":"Costa Rica"},"deu":{"official":"Republik Costa Rica","common":"Costa Rica"},"est":{"official":"Costa Rica Vabariik","common":"Costa Rica"},"fin":{"official":"Costa Rican tasavalta","common":"Costa Rica"},"fra":{"official":"R\xe9publique du Costa Rica","common":"Costa Rica"},"hrv":{"official":"Republika Kostarika","common":"Kostarika"},"hun":{"official":"Costa Rica-i K\xf6zt\xe1rsas\xe1g","common":"Costa Rica"},"ita":{"official":"Repubblica di Costa Rica","common":"Costa Rica"},"jpn":{"official":"\u30B3\u30B9\u30BF\u30EA\u30AB\u5171\u548C\u56FD","common":"\u30B3\u30B9\u30BF\u30EA\u30AB"},"kor":{"official":"\uCF54\uC2A4\uD0C0\uB9AC\uCE74 \uACF5\uD654\uAD6D","common":"\uCF54\uC2A4\uD0C0\uB9AC\uCE74"},"nld":{"official":"Republiek Costa Rica","common":"Costa Rica"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u06A9\u0627\u0633\u062A\u0627\u0631\u06CC\u06A9\u0627","common":"\u06A9\u0627\u0633\u062A\u0627\u0631\u06CC\u06A9\u0627"},"pol":{"official":"Republika Kostaryki","common":"Kostaryka"},"por":{"official":"Rep\xfablica da Costa Rica","common":"Costa Rica"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u0441\u0442\u0430-\u0420\u0438\u043A\u0430","common":"\u041A\u043E\u0441\u0442\u0430-\u0420\u0438\u043A\u0430"},"slk":{"official":"Kostarick\xe1 republika","common":"Kostarika"},"spa":{"official":"Rep\xfablica de Costa Rica","common":"Costa Rica"},"swe":{"official":"Republiken Costa Rica","common":"Costa Rica"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06A9\u0648\u0633\u0679\u0627\u0631\u06CC\u06A9\u0627","common":"\u06A9\u0648\u0633\u0679\u0627\u0631\u06CC\u06A9\u0627"},"zho":{"official":"\u54E5\u65AF\u8FBE\u9ECE\u52A0\u5171\u548C\u56FD","common":"\u54E5\u65AF\u8FBE\u9ECE\u52A0"}},"latlng":[10,-84],"landlocked":false,"borders":["NIC","PAN"],"area":51100,"flag":"\uD83C\uDDE8\uD83C\uDDF7","demonyms":{"eng":{"f":"Costa Rican","m":"Costa Rican"},"fra":{"f":"Costaricaine","m":"Costaricain"}}},{"name":{"common":"Cuba","official":"Republic of Cuba","native":{"spa":{"official":"Rep\xfablica de Cuba","common":"Cuba"}}},"tld":[".cu"],"cca2":"CU","ccn3":"192","cca3":"CUB","cioc":"CUB","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"CUC":{"name":"Cuban convertible peso","symbol":"$"},"CUP":{"name":"Cuban peso","symbol":"$"}},"idd":{"root":"+5","suffixes":["3"]},"capital":["Havana"],"altSpellings":["CU","Republic of Cuba","Rep\xfablica de Cuba"],"region":"Americas","subregion":"Caribbean","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Kub\xe1nsk\xe1 republika","common":"Kuba"},"cym":{"official":"Gweriniaeth Ciwba","common":"Ciwba"},"deu":{"official":"Republik Kuba","common":"Kuba"},"est":{"official":"Kuuba Vabariik","common":"Kuuba"},"fin":{"official":"Kuuban tasavalta","common":"Kuuba"},"fra":{"official":"R\xe9publique de Cuba","common":"Cuba"},"hrv":{"official":"Republika Kuba","common":"Kuba"},"hun":{"official":"Kubai K\xf6zt\xe1rsas\xe1g","common":"Kuba"},"ita":{"official":"Repubblica di Cuba","common":"Cuba"},"jpn":{"official":"\u30AD\u30E5\u30FC\u30D0\u5171\u548C\u56FD","common":"\u30AD\u30E5\u30FC\u30D0"},"kor":{"official":"\uCFE0\uBC14 \uACF5\uD654\uAD6D","common":"\uCFE0\uBC14"},"nld":{"official":"Republiek Cuba","common":"Cuba"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u06A9\u0648\u0628\u0627","common":"\u06A9\u0648\u0628\u0627"},"pol":{"official":"Republika Kuby","common":"Kuba"},"por":{"official":"Rep\xfablica de Cuba","common":"Cuba"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u0443\u0431\u0430","common":"\u041A\u0443\u0431\u0430"},"slk":{"official":"Kub\xe1nska republika","common":"Kuba"},"spa":{"official":"Rep\xfablica de Cuba","common":"Cuba"},"swe":{"official":"Republiken Kuba","common":"Kuba"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06A9\u06CC\u0648\u0628\u0627","common":"\u06A9\u06CC\u0648\u0628\u0627"},"zho":{"official":"\u53E4\u5DF4\u5171\u548C\u56FD","common":"\u53E4\u5DF4"}},"latlng":[21.5,-80],"landlocked":false,"borders":[],"area":109884,"flag":"\uD83C\uDDE8\uD83C\uDDFA","demonyms":{"eng":{"f":"Cuban","m":"Cuban"},"fra":{"f":"Cubaine","m":"Cubain"}}},{"name":{"common":"Cura\xe7ao","official":"Country of Cura\xe7ao","native":{"eng":{"official":"Country of Cura\xe7ao","common":"Cura\xe7ao"},"nld":{"official":"Land Cura\xe7ao","common":"Cura\xe7ao"},"pap":{"official":"Pais K\xf2rsou","common":"Pais K\xf2rsou"}}},"tld":[".cw"],"cca2":"CW","ccn3":"531","cca3":"CUW","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"ANG":{"name":"Netherlands Antillean guilder","symbol":"\u0192"}},"idd":{"root":"+5","suffixes":["99"]},"capital":["Willemstad"],"altSpellings":["CW","Curacao","K\xf2rsou","Country of Cura\xe7ao","Land Cura\xe7ao","Pais K\xf2rsou"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English","nld":"Dutch","pap":"Papiamento"},"translations":{"ces":{"official":"Autonomn\xed zem\u011B Cura\xe7ao","common":"Cura\xe7ao"},"deu":{"official":"Land Cura\xe7ao","common":"Cura\xe7ao"},"est":{"official":"Cura\xe7ao","common":"Cura\xe7ao"},"fin":{"official":"Cura\xe7ao","common":"Cura\xe7ao"},"fra":{"official":"Pays de Cura\xe7ao","common":"Cura\xe7ao"},"hun":{"official":"Cura\xe7ao","common":"Cura\xe7ao"},"ita":{"official":"Paese di Cura\xe7ao","common":"Cura\xe7ao"},"kor":{"official":"\uD034\uB77C\uC18C","common":"\uD034\uB77C\uC18C"},"nld":{"official":"Land Cura\xe7ao","common":"Cura\xe7ao"},"per":{"official":"\u06A9\u0648\u0631\u0627\u0633\u0627\u0626\u0648","common":"\u06A9\u0648\u0631\u0627\u0633\u0627\u0626\u0648"},"pol":{"official":"Cura\xe7ao","common":"Cura\xe7ao"},"por":{"official":"Pa\xeds de Cura\xe7ao","common":"ilha da Cura\xe7\xe3o"},"rus":{"official":"\u0421\u0442\u0440\u0430\u043D\u0430 \u041A\u044E\u0440\u0430\u0441\u0430\u043E","common":"\u041A\u044E\u0440\u0430\u0441\u0430\u043E"},"slk":{"official":"Curacao","common":"Curacao"},"spa":{"official":"Pa\xeds de Curazao","common":"Curazao"},"swe":{"official":"Cura\xe7ao","common":"Cura\xe7ao"},"urd":{"official":"\u0645\u0645\u0644\u06A9\u062A\u0650 \u06A9\u06CC\u0648\u0631\u0627\u0633\u0627\u0624","common":"\u06A9\u06CC\u0648\u0631\u0627\u0633\u0627\u0624"},"zho":{"official":"\u5E93\u62C9\u7D22","common":"\u5E93\u62C9\u7D22"}},"latlng":[12.116667,-68.933333],"landlocked":false,"borders":[],"area":444,"flag":"\uD83C\uDDE8\uD83C\uDDFC","demonyms":{"eng":{"f":"Cura\xe7aoan","m":"Cura\xe7aoan"},"fra":{"f":"Curacienne","m":"Curacien"}}},{"name":{"common":"Christmas Island","official":"Territory of Christmas Island","native":{"eng":{"official":"Territory of Christmas Island","common":"Christmas Island"}}},"tld":[".cx"],"cca2":"CX","ccn3":"162","cca3":"CXR","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"AUD":{"name":"Australian dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["1"]},"capital":["Flying Fish Cove"],"altSpellings":["CX","Territory of Christmas Island"],"region":"Oceania","subregion":"Australia and New Zealand","languages":{"eng":"English"},"translations":{"ces":{"official":"Teritorium V\xe1no\u010Dn\xedho ostrova","common":"V\xe1no\u010Dn\xed ostrov"},"cym":{"official":"Tiriogaeth yr Ynys y Nadolig","common":"Ynys y Nadolig"},"deu":{"official":"Gebiet der Weihnachtsinsel","common":"Weihnachtsinsel"},"est":{"official":"J\xf5ulusaare ala","common":"J\xf5ulusaar"},"fin":{"official":"Joulusaaren alue","common":"Joulusaari"},"fra":{"official":"Territoire de l\'\xeele Christmas","common":"\xcele Christmas"},"hrv":{"official":"Teritorij Bo\u017Ei\u0107ni otok","common":"Bo\u017Ei\u0107ni otok"},"hun":{"official":"Kar\xe1csony-sziget","common":"Kar\xe1csony-sziget"},"ita":{"official":"Territorio di Christmas Island","common":"Isola di Natale"},"jpn":{"official":"\u30AF\u30EA\u30B9\u30DE\u30B9\u5CF6\u306E\u9818\u571F","common":"\u30AF\u30EA\u30B9\u30DE\u30B9\u5CF6"},"kor":{"official":"\uD06C\uB9AC\uC2A4\uB9C8\uC2A4 \uC12C","common":"\uD06C\uB9AC\uC2A4\uB9C8\uC2A4 \uC12C"},"nld":{"official":"Grondgebied van Christmas Island","common":"Christmaseiland"},"per":{"official":"\u062C\u0632\u06CC\u0631\u0647\u0654 \u06A9\u0631\u06CC\u0633\u0645\u0633","common":"\u062C\u0632\u06CC\u0631\u0647\u0654 \u06A9\u0631\u06CC\u0633\u0645\u0633"},"pol":{"official":"Wyspa Bo\u017Cego Narodzenia","common":"Wyspa Bo\u017Cego Narodzenia"},"por":{"official":"Territ\xf3rio da Ilha Christmas","common":"Ilha do Natal"},"rus":{"official":"\u0422\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044F \u043E\u0441\u0442\u0440\u043E\u0432\u0430 \u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u0430","common":"\u041E\u0441\u0442\u0440\u043E\u0432 \u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u0430"},"slk":{"official":"Terit\xf3rium Viano\u010Dn\xe9ho ostrova","common":"Viano\u010Dn\xfa ostrov"},"spa":{"official":"Territorio de la Isla de Navidad","common":"Isla de Navidad"},"swe":{"official":"Jul\xf6n","common":"Jul\xf6n"},"urd":{"official":"\u0631\u06CC\u0627\u0633\u062A\u0650 \u062C\u0632\u06CC\u0631\u06C1 \u06A9\u0631\u0633\u0645\u0633","common":"\u062C\u0632\u06CC\u0631\u06C1 \u06A9\u0631\u0633\u0645\u0633"},"zho":{"official":"\u5723\u8BDE\u5C9B","common":"\u5723\u8BDE\u5C9B"}},"latlng":[-10.5,105.66666666],"landlocked":false,"borders":[],"area":135,"flag":"\uD83C\uDDE8\uD83C\uDDFD","demonyms":{"eng":{"f":"Christmas Islander","m":"Christmas Islander"},"fra":{"f":"","m":""}}},{"name":{"common":"Cayman Islands","official":"Cayman Islands","native":{"eng":{"official":"Cayman Islands","common":"Cayman Islands"}}},"tld":[".ky"],"cca2":"KY","ccn3":"136","cca3":"CYM","cioc":"CAY","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"KYD":{"name":"Cayman Islands dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["345"]},"capital":["George Town"],"altSpellings":["KY"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Kajmansk\xe9 ostrovy","common":"Kajmansk\xe9 ostrovy"},"cym":{"official":"Ynysoedd Cayman","common":"Ynysoedd Cayman"},"deu":{"official":"Cayman-Inseln","common":"Kaimaninseln"},"est":{"official":"Kaimanisaared","common":"Kaimanisaared"},"fin":{"official":"Caymansaaret","common":"Caymansaaret"},"fra":{"official":"\xceles Ca\xefmans","common":"\xceles Ca\xefmans"},"hrv":{"official":"Kajmanski otoci","common":"Kajmanski otoci"},"hun":{"official":"Kajm\xe1n-szigetek","common":"Kajm\xe1n-szigetek"},"ita":{"official":"Isole Cayman","common":"Isole Cayman"},"jpn":{"official":"\u30B1\u30A4\u30DE\u30F3\u8AF8\u5CF6","common":"\u30B1\u30A4\u30DE\u30F3\u8AF8\u5CF6"},"kor":{"official":"\uCF00\uC774\uB9E8 \uC81C\uB3C4","common":"\uCF00\uC774\uB9E8 \uC81C\uB3C4"},"nld":{"official":"Caymaneilanden","common":"Caymaneilanden"},"per":{"official":"\u062C\u0632\u0627\u06CC\u0631 \u06A9\u06CC\u0645\u0646","common":"\u062C\u0632\u0627\u06CC\u0631 \u06A9\u06CC\u0645\u0646"},"pol":{"official":"Kajmany","common":"Kajmany"},"por":{"official":"Ilhas Cayman","common":"Ilhas Caim\xe3o"},"rus":{"official":"\u041A\u0430\u0439\u043C\u0430\u043D\u043E\u0432\u044B \u043E\u0441\u0442\u0440\u043E\u0432\u0430","common":"\u041A\u0430\u0439\u043C\u0430\u043D\u043E\u0432\u044B \u043E\u0441\u0442\u0440\u043E\u0432\u0430"},"slk":{"official":"Kajmanie ostrovy","common":"Kajmanie ostrovy"},"spa":{"official":"Islas Caim\xe1n","common":"Islas Caim\xe1n"},"swe":{"official":"Cayman\xf6arna","common":"Cayman\xf6arna"},"urd":{"official":"\u062C\u0632\u0627\u0626\u0631 \u06A9\u06CC\u0645\u06CC\u0646","common":"\u062C\u0632\u0627\u0626\u0631 \u06A9\u06CC\u0645\u06CC\u0646"},"zho":{"official":"\u5F00\u66FC\u7FA4\u5C9B","common":"\u5F00\u66FC\u7FA4\u5C9B"}},"latlng":[19.5,-80.5],"landlocked":false,"borders":[],"area":264,"flag":"\uD83C\uDDF0\uD83C\uDDFE","demonyms":{"eng":{"f":"Caymanian","m":"Caymanian"},"fra":{"f":"Ca\xefmanienne","m":"Ca\xefmanien"}}},{"name":{"common":"Cyprus","official":"Republic of Cyprus","native":{"ell":{"official":"\u0394\u03B7\u03BC\u03BF\u03BA\u03C1\u03B1\u03C4\u03AF\u03B1 \u03C4\u03B7\u03C2 \u039A\u03CD\u03C0\u03C1\u03BF\u03C2","common":"\u039A\u03CD\u03C0\u03C1\u03BF\u03C2"},"tur":{"official":"K\u0131br\u0131s Cumhuriyeti","common":"K\u0131br\u0131s"}}},"tld":[".cy"],"cca2":"CY","ccn3":"196","cca3":"CYP","cioc":"CYP","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["57"]},"capital":["Nicosia"],"altSpellings":["CY","K\xfdpros","K\u0131br\u0131s","Republic of Cyprus","\u039A\u03C5\u03C0\u03C1\u03B9\u03B1\u03BA\u03AE \u0394\u03B7\u03BC\u03BF\u03BA\u03C1\u03B1\u03C4\u03AF\u03B1","K\u0131br\u0131s Cumhuriyeti"],"region":"Europe","subregion":"Southern Europe","languages":{"ell":"Greek","tur":"Turkish"},"translations":{"ces":{"official":"Kypersk\xe1 republika","common":"Kypr"},"cym":{"official":"Gweriniaeth Cyprus","common":"Cyprus"},"deu":{"official":"Republik Zypern","common":"Zypern"},"est":{"official":"K\xfcprose Vabariik","common":"K\xfcpros"},"fin":{"official":"Kyproksen tasavalta","common":"Kypros"},"fra":{"official":"R\xe9publique de Chypre","common":"Chypre"},"hrv":{"official":"Republika Cipar","common":"Cipar"},"hun":{"official":"Ciprusi K\xf6zt\xe1rsas\xe1g","common":"Ciprus"},"ita":{"official":"Repubblica di Cipro","common":"Cipro"},"jpn":{"official":"\u30AD\u30D7\u30ED\u30B9\u5171\u548C\u56FD","common":"\u30AD\u30D7\u30ED\u30B9"},"kor":{"official":"\uD0A4\uD504\uB85C\uC2A4 \uACF5\uD654\uAD6D","common":"\uD0A4\uD504\uB85C\uC2A4"},"nld":{"official":"Republiek Cyprus","common":"Cyprus"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0642\u0628\u0631\u0633","common":"\u0642\u0650\u0628\u0631\u0650\u0633"},"pol":{"official":"Republika Cypryjska","common":"Cypr"},"por":{"official":"Rep\xfablica de Chipre","common":"Chipre"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u0438\u043F\u0440","common":"\u041A\u0438\u043F\u0440"},"slk":{"official":"Cypersk\xe1 republika","common":"Cyprus"},"spa":{"official":"Rep\xfablica de Chipre","common":"Chipre"},"swe":{"official":"Republiken Cypern","common":"Cypern"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0642\u0628\u0631\u0635","common":"\u0642\u0628\u0631\u0635"},"zho":{"official":"\u585E\u6D66\u8DEF\u65AF\u5171\u548C\u56FD","common":"\u585E\u6D66\u8DEF\u65AF"}},"latlng":[35,33],"landlocked":false,"borders":[],"area":9251,"flag":"\uD83C\uDDE8\uD83C\uDDFE","demonyms":{"eng":{"f":"Cypriot","m":"Cypriot"},"fra":{"f":"Chypriote","m":"Chypriote"}}},{"name":{"common":"Czechia","official":"Czech Republic","native":{"ces":{"official":"\u010Cesk\xe1 republika","common":"\u010Cesko"},"slk":{"official":"\u010Cesk\xe1 republika","common":"\u010Cesko"}}},"tld":[".cz"],"cca2":"CZ","ccn3":"203","cca3":"CZE","cioc":"CZE","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"CZK":{"name":"Czech koruna","symbol":"K\u010D"}},"idd":{"root":"+4","suffixes":["20"]},"capital":["Prague"],"altSpellings":["CZ","\u010Cesk\xe1 republika","\u010Cesko"],"region":"Europe","subregion":"Central Europe","languages":{"ces":"Czech","slk":"Slovak"},"translations":{"ces":{"official":"\u010Cesk\xe1 republika","common":"\u010Cesko"},"cym":{"official":"Y Weriniaeth Tsiec","common":"Y Weriniaeth Tsiec"},"deu":{"official":"Tschechische Republik","common":"Tschechien"},"est":{"official":"T\u0161ehhi Vabariik","common":"T\u0161ehhi"},"fin":{"official":"T\u0161ekin tasavalta","common":"T\u0161ekki"},"fra":{"official":"R\xe9publique tch\xe8que","common":"Tch\xe9quie"},"hrv":{"official":"\u010Ce\u0161ka","common":"\u010Ce\u0161ka"},"hun":{"official":"Cseh K\xf6zt\xe1rsas\xe1g","common":"Csehorsz\xe1g"},"ita":{"official":"Repubblica Ceca","common":"Cechia"},"jpn":{"official":"\u30C1\u30A7\u30B3\u5171\u548C\u56FD","common":"\u30C1\u30A7\u30B3"},"kor":{"official":"\uCCB4\uCF54","common":"\uCCB4\uCF54"},"nld":{"official":"Tsjechische Republiek","common":"Tsjechi\xeb"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0686\u06A9","common":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0686\u06A9"},"pol":{"official":"Republika Czeska","common":"Czechy"},"por":{"official":"Rep\xfablica Checa","common":"Ch\xe9quia"},"rus":{"official":"\u0427\u0435\u0448\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u0427\u0435\u0445\u0438\u044F"},"slk":{"official":"\u010Cesk\xe1 republika","common":"\u010Cesko"},"spa":{"official":"Rep\xfablica Checa","common":"Chequia"},"swe":{"official":"Republiken Tjeckien","common":"Tjeckien"},"urd":{"official":"\u0686\u064A\u06A9 \u062C\u0645\u06C1\u0648\u0631\u064A\u06C1","common":"\u0686\u064A\u06A9"},"zho":{"official":"\u6377\u514B\u5171\u548C\u56FD","common":"\u6377\u514B"}},"latlng":[49.75,15.5],"landlocked":true,"borders":["AUT","DEU","POL","SVK"],"area":78865,"flag":"\uD83C\uDDE8\uD83C\uDDFF","demonyms":{"eng":{"f":"Czech","m":"Czech"},"fra":{"f":"Tch\xe8que","m":"Tch\xe8que"}}},{"name":{"common":"Germany","official":"Federal Republic of Germany","native":{"deu":{"official":"Bundesrepublik Deutschland","common":"Deutschland"}}},"tld":[".de"],"cca2":"DE","ccn3":"276","cca3":"DEU","cioc":"GER","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+4","suffixes":["9"]},"capital":["Berlin"],"altSpellings":["DE","Federal Republic of Germany","Bundesrepublik Deutschland"],"region":"Europe","subregion":"Western Europe","languages":{"deu":"German"},"translations":{"ces":{"official":"Spolkov\xe1 republika N\u011Bmecko","common":"N\u011Bmecko"},"deu":{"official":"Bundesrepublik Deutschland","common":"Deutschland"},"est":{"official":"Saksamaa Liitvabariik","common":"Saksamaa"},"fin":{"official":"Saksan liittotasavalta","common":"Saksa"},"fra":{"official":"R\xe9publique f\xe9d\xe9rale d\'Allemagne","common":"Allemagne"},"hrv":{"official":"Njema\u010Dka Federativna Republika","common":"Njema\u010Dka"},"hun":{"official":"N\xe9met Sz\xf6vets\xe9gi K\xf6zt\xe1rsas\xe1g","common":"N\xe9metorsz\xe1g"},"ita":{"official":"Repubblica federale di Germania","common":"Germania"},"jpn":{"official":"\u30C9\u30A4\u30C4\u9023\u90A6\u5171\u548C\u56FD","common":"\u30C9\u30A4\u30C4"},"kor":{"official":"\uB3C5\uC77C \uC5F0\uBC29 \uACF5\uD654\uAD6D","common":"\uB3C5\uC77C"},"nld":{"official":"Bondsrepubliek Duitsland","common":"Duitsland"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0641\u062F\u0631\u0627\u0644 \u0622\u0644\u0645\u0627\u0646","common":"\u0622\u0644\u0645\u0627\u0646"},"pol":{"official":"Republika Federalna Niemiec","common":"Niemcy"},"por":{"official":"Rep\xfablica Federal da Alemanha","common":"Alemanha"},"rus":{"official":"\u0424\u0435\u0434\u0435\u0440\u0430\u0442\u0438\u0432\u043D\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0413\u0435\u0440\u043C\u0430\u043D\u0438\u044F","common":"\u0413\u0435\u0440\u043C\u0430\u043D\u0438\u044F"},"slk":{"official":"Nemeck\xe1 spolkov\xe1 republika","common":"Nemecko"},"spa":{"official":"Rep\xfablica Federal de Alemania","common":"Alemania"},"swe":{"official":"F\xf6rbundsrepubliken Tyskland","common":"Tyskland"},"urd":{"official":"\u0648\u0641\u0627\u0642\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u062C\u0631\u0645\u0646\u06CC","common":"\u062C\u0631\u0645\u0646\u06CC"},"zho":{"official":"\u5FB7\u610F\u5FD7\u8054\u90A6\u5171\u548C\u56FD","common":"\u5FB7\u56FD"}},"latlng":[51,9],"landlocked":false,"borders":["AUT","BEL","CZE","DNK","FRA","LUX","NLD","POL","CHE"],"area":357114,"flag":"\uD83C\uDDE9\uD83C\uDDEA","demonyms":{"eng":{"f":"German","m":"German"},"fra":{"f":"Allemande","m":"Allemand"}}},{"name":{"common":"Djibouti","official":"Republic of Djibouti","native":{"ara":{"official":"\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u062C\u064A\u0628\u0648\u062A\u064A","common":"\u062C\u064A\u0628\u0648\u062A\u064A\u200E"},"fra":{"official":"R\xe9publique de Djibouti","common":"Djibouti"}}},"tld":[".dj"],"cca2":"DJ","ccn3":"262","cca3":"DJI","cioc":"DJI","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"DJF":{"name":"Djiboutian franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["53"]},"capital":["Djibouti"],"altSpellings":["DJ","Jabuuti","Gabuuti","Republic of Djibouti","R\xe9publique de Djibouti","Gabuutih Ummuuno","Jamhuuriyadda Jabuuti"],"region":"Africa","subregion":"Eastern Africa","languages":{"ara":"Arabic","fra":"French"},"translations":{"ces":{"official":"D\u017Eibutsk\xe1 republika","common":"D\u017Eibutsko"},"cym":{"official":"Gweriniaeth Jibwti","common":"Jibwti"},"deu":{"official":"Republik Dschibuti","common":"Dschibuti"},"est":{"official":"Djibouti Vabariik","common":"Djibouti"},"fin":{"official":"Dijiboutin tasavalta","common":"Dijibouti"},"fra":{"official":"R\xe9publique de Djibouti","common":"Djibouti"},"hrv":{"official":"Republika D\u017Eibuti","common":"D\u017Eibuti"},"hun":{"official":"Dzsibuti K\xf6zt\xe1rsas\xe1g","common":"Dzsibuti"},"ita":{"official":"Repubblica di Gibuti","common":"Gibuti"},"jpn":{"official":"\u30B8\u30D6\u30C1\u5171\u548C\u56FD","common":"\u30B8\u30D6\u30C1"},"kor":{"official":"\uC9C0\uBD80\uD2F0 \uACF5\uD654\uAD6D","common":"\uC9C0\uBD80\uD2F0"},"nld":{"official":"Republiek Djibouti","common":"Djibouti"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u062C\u06CC\u0628\u0648\u062A\u06CC","common":"\u062C\u06CC\u0628\u0648\u062A\u06CC"},"pol":{"official":"Republika D\u017Cibuti","common":"D\u017Cibuti"},"por":{"official":"Rep\xfablica do Djibouti","common":"Djibouti"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0414\u0436\u0438\u0431\u0443\u0442\u0438","common":"\u0414\u0436\u0438\u0431\u0443\u0442\u0438"},"slk":{"official":"\u01C5ibutsk\xe1 republika","common":"\u01C5ibutsko"},"spa":{"official":"Rep\xfablica de Djibouti","common":"Djibouti"},"swe":{"official":"Republiken Djibouti","common":"Djibouti"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u062C\u0628\u0648\u062A\u06CC","common":"\u062C\u0628\u0648\u062A\u06CC"},"zho":{"official":"\u5409\u5E03\u63D0\u5171\u548C\u56FD","common":"\u5409\u5E03\u63D0"}},"latlng":[11.5,43],"landlocked":false,"borders":["ERI","ETH","SOM"],"area":23200,"flag":"\uD83C\uDDE9\uD83C\uDDEF","demonyms":{"eng":{"f":"Djibouti","m":"Djibouti"},"fra":{"f":"Djiboutienne","m":"Djiboutien"}}},{"name":{"common":"Dominica","official":"Commonwealth of Dominica","native":{"eng":{"official":"Commonwealth of Dominica","common":"Dominica"}}},"tld":[".dm"],"cca2":"DM","ccn3":"212","cca3":"DMA","cioc":"DMA","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"XCD":{"name":"Eastern Caribbean dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["767"]},"capital":["Roseau"],"altSpellings":["DM","Dominique","Wai\u2018tu kubuli","Commonwealth of Dominica"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Dominik\xe1nsk\xe9 spole\u010Denstv\xed","common":"Dominika"},"cym":{"official":"Cymanwlad Dominica","common":"Dominica"},"deu":{"official":"Commonwealth von Dominica","common":"Dominica"},"est":{"official":"Dominica \xdchendus","common":"Dominica"},"fin":{"official":"Dominican liittovaltio","common":"Dominica"},"fra":{"official":"Commonwealth de la Dominique","common":"Dominique"},"hrv":{"official":"Zajednica Dominika","common":"Dominika"},"hun":{"official":"Dominikai K\xf6z\xf6ss\xe9g","common":"Dominikai K\xf6z\xf6ss\xe9g"},"ita":{"official":"Commonwealth di Dominica","common":"Dominica"},"jpn":{"official":"\u30C9\u30DF\u30CB\u30AB\u56FD","common":"\u30C9\u30DF\u30CB\u30AB\u56FD"},"kor":{"official":"\uB3C4\uBBF8\uB2C8\uCE74 \uACF5\uD654\uAD6D","common":"\uB3C4\uBBF8\uB2C8\uCE74 \uACF5\uD654\uAD6D"},"nld":{"official":"Gemenebest Dominica","common":"Dominica"},"per":{"official":"\u0642\u0644\u0645\u0631\u0648 \u0647\u0645\u0633\u0648\u062F \u062F\u0648\u0645\u06CC\u0646\u06CC\u06A9\u0627","common":"\u062F\u0648\u0645\u06CC\u0646\u06CC\u06A9\u0627"},"pol":{"official":"Wsp\xf3lnota Dominiki","common":"Dominika"},"por":{"official":"Comunidade da Dominica","common":"Dominica"},"rus":{"official":"\u0421\u043E\u0434\u0440\u0443\u0436\u0435\u0441\u0442\u0432\u043E \u0414\u043E\u043C\u0438\u043D\u0438\u043A\u0438","common":"\u0414\u043E\u043C\u0438\u043D\u0438\u043A\u0430"},"slk":{"official":"Dominick\xe9 spolo\u010Denstvo","common":"Dominika"},"spa":{"official":"Mancomunidad de Dominica","common":"Dominica"},"swe":{"official":"Samv\xe4ldet Dominica","common":"Dominica"},"urd":{"official":"\u062F\u0648\u0644\u062A\u0650 \u0645\u0634\u062A\u0631\u06A9\u06C1 \u0688\u0648\u0645\u06CC\u0646\u06CC\u06A9\u0627","common":"\u0688\u0648\u0645\u06CC\u0646\u06CC\u06A9\u0627"},"zho":{"official":"\u591A\u7C73\u5C3C\u52A0\u5171\u548C\u56FD","common":"\u591A\u7C73\u5C3C\u52A0"}},"latlng":[15.41666666,-61.33333333],"landlocked":false,"borders":[],"area":751,"flag":"\uD83C\uDDE9\uD83C\uDDF2","demonyms":{"eng":{"f":"Dominican","m":"Dominican"},"fra":{"f":"Dominiquaise","m":"Dominiquais"}}},{"name":{"common":"Denmark","official":"Kingdom of Denmark","native":{"dan":{"official":"Kongeriget Danmark","common":"Danmark"}}},"tld":[".dk"],"cca2":"DK","ccn3":"208","cca3":"DNK","cioc":"DEN","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"DKK":{"name":"Danish krone","symbol":"kr"}},"idd":{"root":"+4","suffixes":["5"]},"capital":["Copenhagen"],"altSpellings":["DK","Danmark","Kingdom of Denmark","Kongeriget Danmark"],"region":"Europe","subregion":"Northern Europe","languages":{"dan":"Danish"},"translations":{"ces":{"official":"D\xe1nsk\xe9 kr\xe1lovstv\xed","common":"D\xe1nsko"},"cym":{"official":"Teyrnas Denmarc","common":"Denmarc"},"deu":{"official":"K\xf6nigreich D\xe4nemark","common":"D\xe4nemark"},"est":{"official":"Taani Kuningriik","common":"Taani"},"fin":{"official":"Tanskan kuningaskunta","common":"Tanska"},"fra":{"official":"Royaume du Danemark","common":"Danemark"},"hrv":{"official":"Kraljevina Danska","common":"Danska"},"hun":{"official":"D\xe1n Kir\xe1lys\xe1g","common":"D\xe1nia"},"ita":{"official":"Regno di Danimarca","common":"Danimarca"},"jpn":{"official":"\u30C7\u30F3\u30DE\u30FC\u30AF\u738B\u56FD","common":"\u30C7\u30F3\u30DE\u30FC\u30AF"},"kor":{"official":"\uB374\uB9C8\uD06C \uC655\uAD6D","common":"\uB374\uB9C8\uD06C"},"nld":{"official":"Koninkrijk Denemarken","common":"Denemarken"},"per":{"official":"\u067E\u0627\u062F\u0634\u0627\u0647\u06CC \u062F\u0627\u0646\u0645\u0627\u0631\u06A9","common":"\u062F\u0627\u0646\u0645\u0627\u0631\u06A9"},"pol":{"official":"Kr\xf3lestwo Danii","common":"Dania"},"por":{"official":"Reino da Dinamarca","common":"Dinamarca"},"rus":{"official":"\u041A\u043E\u0440\u043E\u043B\u0435\u0432\u0441\u0442\u0432\u043E \u0414\u0430\u043D\u0438\u044F","common":"\u0414\u0430\u043D\u0438\u044F"},"slk":{"official":"D\xe1nske kr\xe1\u013Eovstvo","common":"D\xe1nsko"},"spa":{"official":"Reino de Dinamarca","common":"Dinamarca"},"swe":{"official":"Konungariket Danmark","common":"Danmark"},"urd":{"official":"\u0645\u0645\u0644\u06A9\u062A\u0650 \u0688\u0646\u0645\u0627\u0631\u06A9","common":"\u0688\u0646\u0645\u0627\u0631\u06A9"},"zho":{"official":"\u4E39\u9EA6\u738B\u56FD","common":"\u4E39\u9EA6"}},"latlng":[56,10],"landlocked":false,"borders":["DEU"],"area":43094,"flag":"\uD83C\uDDE9\uD83C\uDDF0","demonyms":{"eng":{"f":"Danish","m":"Danish"},"fra":{"f":"Danoise","m":"Danois"}}},{"name":{"common":"Dominican Republic","official":"Dominican Republic","native":{"spa":{"official":"Rep\xfablica Dominicana","common":"Rep\xfablica Dominicana"}}},"tld":[".do"],"cca2":"DO","ccn3":"214","cca3":"DOM","cioc":"DOM","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"DOP":{"name":"Dominican peso","symbol":"$"}},"idd":{"root":"+1","suffixes":["809","829","849"]},"capital":["Santo Domingo"],"altSpellings":["DO"],"region":"Americas","subregion":"Caribbean","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Dominik\xe1nsk\xe1 republika","common":"Dominik\xe1nsk\xe1 republika"},"cym":{"official":"Gweriniaeth Dominica","common":"Gweriniaeth Dominica"},"deu":{"official":"Dominikanische Republik","common":"Dominikanische Republik"},"est":{"official":"Dominikaani Vabariik","common":"Dominikaani Vabariik"},"fin":{"official":"Dominikaaninen tasavalta","common":"Dominikaaninen tasavalta"},"fra":{"official":"R\xe9publique Dominicaine","common":"R\xe9publique dominicaine"},"hrv":{"official":"Dominikanska Republika","common":"Dominikanska Republika"},"hun":{"official":"Dominikai K\xf6zt\xe1rsas\xe1g","common":"Dominikai K\xf6zt\xe1rsas\xe1g"},"ita":{"official":"Repubblica Dominicana","common":"Repubblica Dominicana"},"jpn":{"official":"\u30C9\u30DF\u30CB\u30AB\u5171\u548C\u56FD","common":"\u30C9\u30DF\u30CB\u30AB\u5171\u548C\u56FD"},"kor":{"official":"\uB3C4\uBBF8\uB2C8\uCE74 \uACF5\uD654\uAD6D","common":"\uB3C4\uBBF8\uB2C8\uCE74 \uACF5\uD654\uAD6D"},"nld":{"official":"Dominicaanse Republiek","common":"Dominicaanse Republiek"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u062F\u0648\u0645\u06CC\u0646\u06CC\u06A9\u0646","common":"\u062C\u0645\u0647\u0648\u0631\u06CC \u062F\u0648\u0645\u06CC\u0646\u06CC\u06A9\u0646"},"pol":{"official":"Republika Dominika\u0144ska","common":"Dominikana"},"por":{"official":"Rep\xfablica Dominicana","common":"Rep\xfablica Dominicana"},"rus":{"official":"\u0414\u043E\u043C\u0438\u043D\u0438\u043A\u0430\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u0414\u043E\u043C\u0438\u043D\u0438\u043A\u0430\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430"},"slk":{"official":"Dominik\xe1nska republika","common":"Dominik\xe1nska republika"},"spa":{"official":"Rep\xfablica Dominicana","common":"Rep\xfablica Dominicana"},"swe":{"official":"Dominikanska republiken","common":"Dominikanska republiken"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0688\u0648\u0645\u06CC\u0646\u06CC\u06A9\u0646","common":"\u0688\u0648\u0645\u06CC\u0646\u06CC\u06A9\u0646"},"zho":{"official":"\u591A\u660E\u5C3C\u52A0\u5171\u548C\u56FD","common":"\u591A\u660E\u5C3C\u52A0"}},"latlng":[19,-70.66666666],"landlocked":false,"borders":["HTI"],"area":48671,"flag":"\uD83C\uDDE9\uD83C\uDDF4","demonyms":{"eng":{"f":"Dominican","m":"Dominican"},"fra":{"f":"Dominicaine","m":"Dominicain"}}},{"name":{"common":"Algeria","official":"People\'s Democratic Republic of Algeria","native":{"ara":{"official":"\u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u062F\u064A\u0645\u0642\u0631\u0627\u0637\u064A\u0629 \u0627\u0644\u0634\u0639\u0628\u064A\u0629 \u0627\u0644\u062C\u0632\u0627\u0626\u0631\u064A\u0629","common":"\u0627\u0644\u062C\u0632\u0627\u0626\u0631"}}},"tld":[".dz","\u0627\u0644\u062C\u0632\u0627\u0626\u0631."],"cca2":"DZ","ccn3":"012","cca3":"DZA","cioc":"ALG","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"DZD":{"name":"Algerian dinar","symbol":"\u062F.\u062C"}},"idd":{"root":"+2","suffixes":["13"]},"capital":["Algiers"],"altSpellings":["DZ","Dzayer","Alg\xe9rie"],"region":"Africa","subregion":"Northern Africa","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Al\u017E\xedrsk\xe1 demokratick\xe1 a lidov\xe1 republika","common":"Al\u017E\xedrsko"},"cym":{"official":"Gweriniaeth Ddemocrataidd Pobl Algeria","common":"Algeria"},"deu":{"official":"Demokratische Volksrepublik Algerien","common":"Algerien"},"est":{"official":"Al\u017Eeeria Demokraatlik Rahvavabariik","common":"Al\u017Eeeria"},"fin":{"official":"Algerian demokraattinen kansantasavalta","common":"Algeria"},"fra":{"official":"R\xe9publique d\xe9mocratique et populaire d\'Alg\xe9rie","common":"Alg\xe9rie"},"hrv":{"official":"Narodna Demokratska Republika Al\u017Eir","common":"Al\u017Eir"},"hun":{"official":"Alg\xe9riai N\xe9pi Demokratikus K\xf6zt\xe1rsas\xe1g","common":"Alg\xe9ria"},"ita":{"official":"Repubblica popolare democratica di Algeria","common":"Algeria"},"jpn":{"official":"\u30A2\u30EB\u30B8\u30A7\u30EA\u30A2\u4EBA\u6C11\u6C11\u4E3B\u5171\u548C\u56FD","common":"\u30A2\u30EB\u30B8\u30A7\u30EA\u30A2"},"kor":{"official":"\uC54C\uC81C\uB9AC \uC778\uBBFC \uBBFC\uC8FC \uACF5\uD654\uAD6D","common":"\uC54C\uC81C\uB9AC"},"nld":{"official":"Democratische Volksrepubliek Algerije","common":"Algerije"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u062F\u0645\u0648\u06A9\u0631\u0627\u062A\u06CC\u06A9 \u062E\u0644\u0642 \u0627\u0644\u062C\u0632\u0627\u06CC\u0631","common":"\u0627\u0644\u062C\u0632\u0627\u06CC\u0631"},"pol":{"official":"Algierska Republika Ludowo-Demokratyczna","common":"Algieria"},"por":{"official":"Rep\xfablica Argelina Democr\xe1tica e Popular","common":"Arg\xe9lia"},"rus":{"official":"\u041D\u0430\u0440\u043E\u0434\u043D\u043E-\u0414\u0435\u043C\u043E\u043A\u0440\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0410\u043B\u0436\u0438\u0440","common":"\u0410\u043B\u0436\u0438\u0440"},"slk":{"official":"Al\u017E\xedrska demokratick\xe1 \u013Eudov\xe1 republika","common":"Al\u017E\xedrsko"},"spa":{"official":"Rep\xfablica Argelina Democr\xe1tica y Popular","common":"Argelia"},"swe":{"official":"Demokratiska folkrepubliken Algeriet","common":"Algeriet"},"urd":{"official":"\u0639\u0648\u0627\u0645\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0627\u0644\u062C\u0632\u0627\u0626\u0631","common":"\u0627\u0644\u062C\u0632\u0627\u0626\u0631"},"zho":{"official":"\u963F\u5C14\u53CA\u5229\u4E9A\u4EBA\u6C11\u6C11\u4E3B\u5171\u548C\u56FD","common":"\u963F\u5C14\u53CA\u5229\u4E9A"}},"latlng":[28,3],"landlocked":false,"borders":["TUN","LBY","NER","ESH","MRT","MLI","MAR"],"area":2381741,"flag":"\uD83C\uDDE9\uD83C\uDDFF","demonyms":{"eng":{"f":"Algerian","m":"Algerian"},"fra":{"f":"Alg\xe9rienne","m":"Alg\xe9rien"}}},{"name":{"common":"Ecuador","official":"Republic of Ecuador","native":{"spa":{"official":"Rep\xfablica del Ecuador","common":"Ecuador"}}},"tld":[".ec"],"cca2":"EC","ccn3":"218","cca3":"ECU","cioc":"ECU","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+5","suffixes":["93"]},"capital":["Quito"],"altSpellings":["EC","Republic of Ecuador","Rep\xfablica del Ecuador"],"region":"Americas","subregion":"South America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Ekv\xe1dorsk\xe1 republika","common":"Ekv\xe1dor"},"cym":{"official":"Gweriniaeth Ecwador","common":"Ecwador"},"deu":{"official":"Republik Ecuador","common":"Ecuador"},"est":{"official":"Ecuadori Vabariik","common":"Ecuador"},"fin":{"official":"Ecuadorin tasavalta","common":"Ecuador"},"fra":{"official":"R\xe9publique de l\'\xc9quateur","common":"\xc9quateur"},"hrv":{"official":"Republika Ekvador","common":"Ekvador"},"hun":{"official":"Ecuadori K\xf6zt\xe1rsas\xe1g","common":"Ecuador"},"ita":{"official":"Repubblica dell\'Ecuador","common":"Ecuador"},"jpn":{"official":"\u30A8\u30AF\u30A2\u30C9\u30EB\u5171\u548C\u56FD","common":"\u30A8\u30AF\u30A2\u30C9\u30EB"},"kor":{"official":"\uC5D0\uCF70\uB3C4\uB974 \uACF5\uD654\uAD6D","common":"\uC5D0\uCF70\uB3C4\uB974"},"nld":{"official":"Republiek Ecuador","common":"Ecuador"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u06A9\u0648\u0627\u062F\u0648\u0631","common":"\u0627\u06A9\u0648\u0627\u062F\u0648\u0631"},"pol":{"official":"Ekwador","common":"Ekwador"},"por":{"official":"Rep\xfablica do Equador","common":"Equador"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u042D\u043A\u0432\u0430\u0434\u043E\u0440","common":"\u042D\u043A\u0432\u0430\u0434\u043E\u0440"},"slk":{"official":"Ekv\xe1dorsk\xe1 republika","common":"Ekv\xe1dor"},"spa":{"official":"Rep\xfablica del Ecuador","common":"Ecuador"},"swe":{"official":"Republiken Ecuador","common":"Ecuador"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0627\u06CC\u06A9\u0648\u0688\u0648\u0631","common":"\u0627\u06CC\u06A9\u0648\u0627\u0688\u0648\u0631"},"zho":{"official":"\u5384\u74DC\u591A\u5C14\u5171\u548C\u56FD","common":"\u5384\u74DC\u591A\u5C14"}},"latlng":[-2,-77.5],"landlocked":false,"borders":["COL","PER"],"area":276841,"flag":"\uD83C\uDDEA\uD83C\uDDE8","demonyms":{"eng":{"f":"Ecuadorean","m":"Ecuadorean"},"fra":{"f":"\xc9quatorienne","m":"\xc9quatorien"}}},{"name":{"common":"Egypt","official":"Arab Republic of Egypt","native":{"ara":{"official":"\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0645\u0635\u0631 \u0627\u0644\u0639\u0631\u0628\u064A\u0629","common":"\u0645\u0635\u0631"}}},"tld":[".eg",".\u0645\u0635\u0631"],"cca2":"EG","ccn3":"818","cca3":"EGY","cioc":"EGY","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EGP":{"name":"Egyptian pound","symbol":"\xa3"}},"idd":{"root":"+2","suffixes":["0"]},"capital":["Cairo"],"altSpellings":["EG","Arab Republic of Egypt"],"region":"Africa","subregion":"Northern Africa","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Egyptsk\xe1 arabsk\xe1 republika","common":"Egypt"},"cym":{"official":"Gweriniaeth Arabaidd yr Aifft","common":"Yr Aifft"},"deu":{"official":"Arabische Republik \xc4gypten","common":"\xc4gypten"},"est":{"official":"Egiptuse Araabia Vabariik","common":"Egiptus"},"fin":{"official":"Egyptin arabitasavalta","common":"Egypti"},"fra":{"official":"R\xe9publique arabe d\'\xc9gypte","common":"\xc9gypte"},"hrv":{"official":"Arapska Republika Egipat","common":"Egipat"},"hun":{"official":"Egyiptomi Arab K\xf6zt\xe1rsas\xe1g","common":"Egyiptom"},"ita":{"official":"Repubblica araba d\'Egitto","common":"Egitto"},"jpn":{"official":"\u30A8\u30B8\u30D7\u30C8\xb7\u30A2\u30E9\u30D6\u5171\u548C\u56FD","common":"\u30A8\u30B8\u30D7\u30C8"},"kor":{"official":"\uC774\uC9D1\uD2B8 \uC544\uB78D \uACF5\uD654\uAD6D","common":"\uC774\uC9D1\uD2B8"},"nld":{"official":"Arabische Republiek Egypte","common":"Egypte"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0639\u0631\u0628\u06CC \u0645\u0635\u0631","common":"\u0645\u0635\u0631"},"pol":{"official":"Arabska Republika Egiptu","common":"Egipt"},"por":{"official":"Rep\xfablica \xc1rabe do Egipto","common":"Egito"},"rus":{"official":"\u0410\u0440\u0430\u0431\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0415\u0433\u0438\u043F\u0435\u0442","common":"\u0415\u0433\u0438\u043F\u0435\u0442"},"slk":{"official":"Egyptsk\xe1 arabsk\xe1 republika","common":"Egypt"},"spa":{"official":"Rep\xfablica \xc1rabe de Egipto","common":"Egipto"},"swe":{"official":"Arabrepubliken Egypten","common":"Egypten"},"urd":{"official":"\u0645\u0635\u0631\u06CC \u0639\u0631\u0628 \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1","common":"\u0645\u0635\u0631"},"zho":{"official":"\u963F\u62C9\u4F2F\u57C3\u53CA\u5171\u548C\u56FD","common":"\u57C3\u53CA"}},"latlng":[27,30],"landlocked":false,"borders":["ISR","LBY","PSE","SDN"],"area":1002450,"flag":"\uD83C\uDDEA\uD83C\uDDEC","demonyms":{"eng":{"f":"Egyptian","m":"Egyptian"},"fra":{"f":"\xc9gyptienne","m":"\xc9gyptien"}}},{"name":{"common":"Eritrea","official":"State of Eritrea","native":{"ara":{"official":"\u062F\u0648\u0644\u0629 \u0625\u0631\u062A\u0631\u064A\u0627","common":"\u0625\u0631\u062A\u0631\u064A\u0627\u200E"},"eng":{"official":"State of Eritrea","common":"Eritrea"},"tir":{"official":"\u1203\u1308\u1228 \u12A4\u122D\u1275\u122B","common":"\u12A4\u122D\u1275\u122B"}}},"tld":[".er"],"cca2":"ER","ccn3":"232","cca3":"ERI","cioc":"ERI","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"ERN":{"name":"Eritrean nakfa","symbol":"Nfk"}},"idd":{"root":"+2","suffixes":["91"]},"capital":["Asmara"],"altSpellings":["ER","State of Eritrea","\u1203\u1308\u1228 \u12A4\u122D\u1275\u122B","Dawlat Iritriy\xe1","\u02BEErtr\u0101","Iritriy\u0101"],"region":"Africa","subregion":"Eastern Africa","languages":{"ara":"Arabic","eng":"English","tir":"Tigrinya"},"translations":{"ces":{"official":"St\xe1t Eritrea","common":"Eritrea"},"cym":{"official":"Gwladwriaeth Eritrea","common":"Eritrea"},"deu":{"official":"Staat Eritrea","common":"Eritrea"},"est":{"official":"Eritrea Riik","common":"Eritrea"},"fin":{"official":"Eritrean valtio","common":"Eritrea"},"fra":{"official":"\xc9tat d\'\xc9rythr\xe9e","common":"\xc9rythr\xe9e"},"hrv":{"official":"Dr\u017Eava Eritreji","common":"Eritreja"},"hun":{"official":"Eritrea","common":"Eritrea"},"ita":{"official":"Stato di Eritrea","common":"Eritrea"},"jpn":{"official":"\u30A8\u30EA\u30C8\u30EA\u30A2\u56FD","common":"\u30A8\u30EA\u30C8\u30EA\u30A2"},"kor":{"official":"\uC5D0\uB9AC\uD2B8\uB808\uC544\uAD6D","common":"\uC5D0\uB9AC\uD2B8\uB808\uC544"},"nld":{"official":"Staat Eritrea","common":"Eritrea"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0631\u06CC\u062A\u0631\u0647","common":"\u0627\u0631\u06CC\u062A\u0631\u0647"},"pol":{"official":"Pa\u0144stwo Erytrea","common":"Erytrea"},"por":{"official":"Estado da Eritreia","common":"Eritreia"},"rus":{"official":"\u0413\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u043E \u042D\u0440\u0438\u0442\u0440\u0435\u044F","common":"\u042D\u0440\u0438\u0442\u0440\u0435\u044F"},"slk":{"official":"Eritrejsk\xfd \u0161t\xe1t","common":"Eritrea"},"spa":{"official":"Estado de Eritrea","common":"Eritrea"},"swe":{"official":"Staten Eritrea","common":"Eritrea"},"urd":{"official":"\u0631\u06CC\u0627\u0633\u062A\u0650 \u0627\u0631\u062A\u0631\u06CC\u0627","common":"\u0627\u0631\u062A\u0631\u06CC\u0627"},"zho":{"official":"\u5384\u7ACB\u7279\u91CC\u4E9A","common":"\u5384\u7ACB\u7279\u91CC\u4E9A"}},"latlng":[15,39],"landlocked":false,"borders":["DJI","ETH","SDN"],"area":117600,"flag":"\uD83C\uDDEA\uD83C\uDDF7","demonyms":{"eng":{"f":"Eritrean","m":"Eritrean"},"fra":{"f":"\xc9rythr\xe9enne","m":"\xc9rythr\xe9en"}}},{"name":{"common":"Western Sahara","official":"Sahrawi Arab Democratic Republic","native":{"ber":{"official":"Sahrawi Arab Democratic Republic","common":"Western Sahara"},"mey":{"official":"\u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0635\u062D\u0631\u0627\u0648\u064A\u0629 \u0627\u0644\u062F\u064A\u0645\u0642\u0631\u0627\u0637\u064A\u0629","common":"\u0627\u0644\u0635\u062D\u0631\u0627\u0621 \u0627\u0644\u063A\u0631\u0628\u064A\u0629"},"spa":{"official":"Rep\xfablica \xc1rabe Saharaui Democr\xe1tica","common":"Sahara Occidental"}}},"tld":[".eh"],"cca2":"EH","ccn3":"732","cca3":"ESH","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"DZD":{"name":"Algerian dinar","symbol":"\u062F\u062C"},"MAD":{"name":"Moroccan dirham","symbol":"DH"},"MRU":{"name":"Mauritanian ouguiya","symbol":"UM"}},"idd":{"root":"+2","suffixes":["125288","125289"]},"capital":["El Aai\xfan"],"altSpellings":["EH","Tane\u1E93roft Tutrimt"],"region":"Africa","subregion":"Northern Africa","languages":{"ber":"Berber","mey":"Hassaniya","spa":"Spanish"},"translations":{"ces":{"official":"Z\xe1padn\xed Sahara","common":"Z\xe1padn\xed Sahara"},"deu":{"official":"Demokratische Arabische Republik Sahara","common":"Westsahara"},"est":{"official":"L\xe4\xe4ne-Sahara","common":"L\xe4\xe4ne-Sahara"},"fin":{"official":"L\xe4nsi-Sahara","common":"L\xe4nsi-Sahara"},"fra":{"official":"R\xe9publique arabe sahraouie d\xe9mocratique","common":"Sahara Occidental"},"hrv":{"official":"Sahrawi Arab Demokratska Republika","common":"Zapadna Sahara"},"hun":{"official":"Nyugat-Szahara","common":"Nyugat-Szahara"},"ita":{"official":"Repubblica Araba Saharawi Democratica","common":"Sahara Occidentale"},"jpn":{"official":"\u30B5\u30CF\u30E9\u30A2\u30E9\u30D6\u6C11\u4E3B\u5171\u548C\u56FD","common":"\u897F\u30B5\u30CF\u30E9"},"kor":{"official":"\uC0AC\uD558\uB77C \uC544\uB78D \uBBFC\uC8FC \uACF5\uD654\uAD6D","common":"\uC11C\uC0AC\uD558\uB77C"},"nld":{"official":"Sahrawi Arabische Democratische Republiek","common":"Westelijke Sahara"},"per":{"official":"\u0635\u062D\u0631\u0627\u06CC \u063A\u0631\u0628\u06CC","common":"\u0635\u062D\u0631\u0627\u06CC \u063A\u0631\u0628\u06CC"},"pol":{"official":"Saharyjska Arabska Republika Demokratyczna","common":"Sahara Zachodnia"},"por":{"official":"Rep\xfablica \xc1rabe Saharaui Democr\xe1tica","common":"Saara Ocidental"},"rus":{"official":"Sahrawi \u0410\u0440\u0430\u0431\u0441\u043A\u0430\u044F \u0414\u0435\u043C\u043E\u043A\u0440\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u0417\u0430\u043F\u0430\u0434\u043D\u0430\u044F \u0421\u0430\u0445\u0430\u0440\u0430"},"slk":{"official":"Z\xe1padn\xe1 Sahara","common":"Z\xe1padn\xe1 Sahara"},"spa":{"official":"Rep\xfablica \xc1rabe Saharaui Democr\xe1tica","common":"Sahara Occidental"},"swe":{"official":"V\xe4stsahara","common":"V\xe4stsahara"},"urd":{"official":"\u0635\u062D\u0631\u0627\u0648\u06CC \u0639\u0631\u0628 \u0639\u0648\u0627\u0645\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1","common":"\u0645\u063A\u0631\u0628\u06CC \u0635\u062D\u0627\u0631\u0627"},"zho":{"official":"\u963F\u62C9\u4F2F\u6492\u54C8\u62C9\u6C11\u4E3B\u5171\u548C\u56FD","common":"\u897F\u6492\u54C8\u62C9"}},"latlng":[24.5,-13],"landlocked":false,"borders":["DZA","MRT","MAR"],"area":266000,"flag":"\uD83C\uDDEA\uD83C\uDDED","demonyms":{"eng":{"f":"Sahrawi","m":"Sahrawi"},"fra":{"f":"","m":""}}},{"name":{"common":"Spain","official":"Kingdom of Spain","native":{"spa":{"official":"Reino de Espa\xf1a","common":"Espa\xf1a"}}},"tld":[".es"],"cca2":"ES","ccn3":"724","cca3":"ESP","cioc":"ESP","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["4"]},"capital":["Madrid"],"altSpellings":["ES","Kingdom of Spain","Reino de Espa\xf1a"],"region":"Europe","subregion":"Southern Europe","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"\u0160pan\u011Blsk\xe9 kr\xe1lovstv\xed","common":"\u0160pan\u011Blsko"},"deu":{"official":"K\xf6nigreich Spanien","common":"Spanien"},"est":{"official":"Hispaania Kuningriik","common":"Hispaania"},"fin":{"official":"Espanjan kuningaskunta","common":"Espanja"},"fra":{"official":"Royaume d\'Espagne","common":"Espagne"},"hrv":{"official":"Kraljevina \u0160panjolska","common":"\u0160panjolska"},"hun":{"official":"Spanyol Kir\xe1lys\xe1g","common":"Spanyolorsz\xe1g"},"ita":{"official":"Regno di Spagna","common":"Spagna"},"jpn":{"official":"\u30B9\u30DA\u30A4\u30F3\u738B\u56FD","common":"\u30B9\u30DA\u30A4\u30F3"},"kor":{"official":"\uC5D0\uC2A4\uD30C\uB0D0 \uC655\uAD6D","common":"\uC2A4\uD398\uC778"},"nld":{"official":"Koninkrijk Spanje","common":"Spanje"},"per":{"official":"\u067E\u0627\u062F\u0634\u0627\u0647\u06CC \u0627\u0633\u067E\u0627\u0646\u06CC\u0627","common":"\u0627\u0633\u067E\u0627\u0646\u06CC\u0627"},"pol":{"official":"Kr\xf3lestwo Hiszpanii ","common":"Hiszpania"},"por":{"official":"Reino de Espanha","common":"Espanha"},"rus":{"official":"\u041A\u043E\u0440\u043E\u043B\u0435\u0432\u0441\u0442\u0432\u043E \u0418\u0441\u043F\u0430\u043D\u0438\u044F","common":"\u0418\u0441\u043F\u0430\u043D\u0438\u044F"},"slk":{"official":"\u0160panielske kr\xe1\u013Eovstvo","common":"\u0160panielsko"},"spa":{"official":"Reino de Espa\xf1a","common":"Espa\xf1a"},"swe":{"official":"Konungariket Spanien","common":"Spanien"},"urd":{"official":"\u0645\u0645\u0644\u06A9\u062A\u0650 \u06C1\u0633\u067E\u0627\u0646\u06CC\u06C1","common":"\u06C1\u0633\u067E\u0627\u0646\u06CC\u06C1"},"zho":{"official":"\u897F\u73ED\u7259\u738B\u56FD","common":"\u897F\u73ED\u7259"}},"latlng":[40,-4],"landlocked":false,"borders":["AND","FRA","GIB","PRT","MAR"],"area":505992,"flag":"\uD83C\uDDEA\uD83C\uDDF8","demonyms":{"eng":{"f":"Spanish","m":"Spanish"},"fra":{"f":"Espagnole","m":"Espagnol"}}},{"name":{"common":"Estonia","official":"Republic of Estonia","native":{"est":{"official":"Eesti Vabariik","common":"Eesti"}}},"tld":[".ee"],"cca2":"EE","ccn3":"233","cca3":"EST","cioc":"EST","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["72"]},"capital":["Tallinn"],"altSpellings":["EE","Eesti","Republic of Estonia","Eesti Vabariik"],"region":"Europe","subregion":"Northern Europe","languages":{"est":"Estonian"},"translations":{"ces":{"official":"Estonsk\xe1 republika","common":"Estonsko"},"cym":{"official":"Gweriniaeth Estonia","common":"Estonia"},"deu":{"official":"Republik Estland","common":"Estland"},"est":{"official":"Eesti Vabariik","common":"Eesti"},"fin":{"official":"Viron tasavalta","common":"Viro"},"fra":{"official":"R\xe9publique d\'Estonie","common":"Estonie"},"hrv":{"official":"Republika Estonija","common":"Estonija"},"hun":{"official":"\xc9szt K\xf6zt\xe1rsas\xe1g","common":"\xc9sztorsz\xe1g"},"ita":{"official":"Repubblica di Estonia","common":"Estonia"},"jpn":{"official":"\u30A8\u30B9\u30C8\u30CB\u30A2\u5171\u548C\u56FD","common":"\u30A8\u30B9\u30C8\u30CB\u30A2"},"kor":{"official":"\uC5D0\uC2A4\uD1A0\uB2C8\uC544 \uACF5\uD654\uAD6D","common":"\uC5D0\uC2A4\uD1A0\uB2C8\uC544"},"nld":{"official":"Republiek Estland","common":"Estland"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0633\u062A\u0648\u0646\u06CC","common":"\u0627\u0650\u0633\u062A\u0648\u0646\u06CC"},"pol":{"official":"Republika Esto\u0144ska","common":"Estonia"},"por":{"official":"Rep\xfablica da Est\xf3nia","common":"Est\xf3nia"},"rus":{"official":"\u042D\u0441\u0442\u043E\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u042D\u0441\u0442\u043E\u043D\u0438\u044F"},"slk":{"official":"Est\xf3nska republika","common":"Est\xf3nsko"},"spa":{"official":"Rep\xfablica de Estonia","common":"Estonia"},"swe":{"official":"Republiken Estland","common":"Estland"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0627\u0633\u0679\u0648\u0646\u06CC\u0627","common":"\u0627\u0633\u0679\u0648\u0646\u06CC\u0627"},"zho":{"official":"\u7231\u6C99\u5C3C\u4E9A\u5171\u548C\u56FD","common":"\u7231\u6C99\u5C3C\u4E9A"}},"latlng":[59,26],"landlocked":false,"borders":["LVA","RUS"],"area":45227,"flag":"\uD83C\uDDEA\uD83C\uDDEA","demonyms":{"eng":{"f":"Estonian","m":"Estonian"},"fra":{"f":"Estonienne","m":"Estonien"}}},{"name":{"common":"Ethiopia","official":"Federal Democratic Republic of Ethiopia","native":{"amh":{"official":"\u12E8\u12A2\u1275\u12EE\u1335\u12EB \u134C\u12F4\u122B\u120B\u12CA \u12F2\u121E\u12AD\u122B\u1232\u12EB\u12CA \u122A\u1350\u1265\u120A\u12AD","common":"\u12A2\u1275\u12EE\u1335\u12EB"}}},"tld":[".et"],"cca2":"ET","ccn3":"231","cca3":"ETH","cioc":"ETH","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"ETB":{"name":"Ethiopian birr","symbol":"Br"}},"idd":{"root":"+2","suffixes":["51"]},"capital":["Addis Ababa"],"altSpellings":["ET","\u02BE\u012Aty\u014D\u1E57\u1E57y\u0101","Federal Democratic Republic of Ethiopia","\u12E8\u12A2\u1275\u12EE\u1335\u12EB \u134C\u12F4\u122B\u120B\u12CA \u12F2\u121E\u12AD\u122B\u1232\u12EB\u12CA \u122A\u1350\u1265\u120A\u12AD"],"region":"Africa","subregion":"Eastern Africa","languages":{"amh":"Amharic"},"translations":{"ces":{"official":"Etiopsk\xe1 federativn\xed demokratick\xe1 republika","common":"Etiopie"},"cym":{"official":"Gweriniaeth Ddemocrataidd Ffederal Ethiopia","common":"Ethiopia"},"deu":{"official":"Demokratische Bundesrepublik \xc4thiopien","common":"\xc4thiopien"},"est":{"official":"Etioopia Demokraatlik Liitvabariik","common":"Etioopia"},"fin":{"official":"Etiopian demokraattinen liittotasavalta","common":"Etiopia"},"fra":{"official":"R\xe9publique f\xe9d\xe9rale d\xe9mocratique d\'\xc9thiopie","common":"\xc9thiopie"},"hrv":{"official":"Savezna Demokratska Republika Etiopija","common":"Etiopija"},"hun":{"official":"Eti\xf3p Sz\xf6vets\xe9gi Demokratikus K\xf6zt\xe1rsas\xe1g","common":"Eti\xf3pia"},"ita":{"official":"Repubblica federale democratica di Etiopia","common":"Etiopia"},"jpn":{"official":"\u30A8\u30C1\u30AA\u30D4\u30A2\u9023\u90A6\u6C11\u4E3B\u5171\u548C\u56FD","common":"\u30A8\u30C1\u30AA\u30D4\u30A2"},"kor":{"official":"\uC5D0\uD2F0\uC624\uD53C\uC544 \uC5F0\uBC29 \uBBFC\uC8FC \uACF5\uD654\uAD6D","common":"\uC5D0\uD2F0\uC624\uD53C\uC544"},"nld":{"official":"Federale Democratische Republiek Ethiopi\xeb","common":"Ethiopi\xeb"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0641\u062F\u0631\u0627\u0644 \u062F\u0645\u0648\u06A9\u0631\u0627\u062A\u06CC\u06A9 \u0627\u062A\u06CC\u0648\u067E\u06CC","common":"\u0627\u0650\u062A\u06CC\u0648\u067E\u06CC"},"pol":{"official":"Federalna Demokratyczna Republika Etiopii","common":"Etiopia"},"por":{"official":"Rep\xfablica Federal Democr\xe1tica da Eti\xf3pia","common":"Eti\xf3pia"},"rus":{"official":"\u0424\u0435\u0434\u0435\u0440\u0430\u0442\u0438\u0432\u043D\u0430\u044F \u0414\u0435\u043C\u043E\u043A\u0440\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u042D\u0444\u0438\u043E\u043F\u0438\u044F","common":"\u042D\u0444\u0438\u043E\u043F\u0438\u044F"},"slk":{"official":"Eti\xf3pska federat\xedvna demokratick\xe1 republika","common":"Eti\xf3pia"},"spa":{"official":"Rep\xfablica Democr\xe1tica Federal de Etiop\xeda","common":"Etiop\xeda"},"swe":{"official":"Demokratiska f\xf6rbundsrepubliken Etiopien","common":"Etiopien"},"urd":{"official":"\u0648\u0641\u0627\u0642\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0627\u06CC\u062A\u06BE\u0648\u067E\u06CC\u0627","common":"\u0627\u06CC\u062A\u06BE\u0648\u067E\u06CC\u0627"},"zho":{"official":"\u57C3\u585E\u4FC4\u6BD4\u4E9A\u8054\u90A6\u6C11\u4E3B\u5171\u548C\u56FD","common":"\u57C3\u585E\u4FC4\u6BD4\u4E9A"}},"latlng":[8,38],"landlocked":true,"borders":["DJI","ERI","KEN","SOM","SSD","SDN"],"area":1104300,"flag":"\uD83C\uDDEA\uD83C\uDDF9","demonyms":{"eng":{"f":"Ethiopian","m":"Ethiopian"},"fra":{"f":"\xc9thiopienne","m":"\xc9thiopien"}}},{"name":{"common":"Finland","official":"Republic of Finland","native":{"fin":{"official":"Suomen tasavalta","common":"Suomi"},"swe":{"official":"Republiken Finland","common":"Finland"}}},"tld":[".fi"],"cca2":"FI","ccn3":"246","cca3":"FIN","cioc":"FIN","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["58"]},"capital":["Helsinki"],"altSpellings":["FI","Suomi","Republic of Finland","Suomen tasavalta","Republiken Finland"],"region":"Europe","subregion":"Northern Europe","languages":{"fin":"Finnish","swe":"Swedish"},"translations":{"ces":{"official":"Finsk\xe1 republika","common":"Finsko"},"deu":{"official":"Republik Finnland","common":"Finnland"},"est":{"official":"Soome Vabariik","common":"Soome"},"fin":{"official":"Suomen tasavalta","common":"Suomi"},"fra":{"official":"R\xe9publique de Finlande","common":"Finlande"},"hrv":{"official":"Republika Finska","common":"Finska"},"hun":{"official":"Finn K\xf6zt\xe1rsas\xe1g","common":"Finnorsz\xe1g"},"ita":{"official":"Repubblica di Finlandia","common":"Finlandia"},"jpn":{"official":"\u30D5\u30A3\u30F3\u30E9\u30F3\u30C9\u5171\u548C\u56FD","common":"\u30D5\u30A3\u30F3\u30E9\u30F3\u30C9"},"kor":{"official":"\uD540\uB780\uB4DC \uACF5\uD654\uAD6D","common":"\uD540\uB780\uB4DC"},"nld":{"official":"Republiek Finland","common":"Finland"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0641\u0646\u0644\u0627\u0646\u062F","common":"\u0641\u0646\u0644\u0627\u0646\u062F"},"pol":{"official":"Republika Finlandii","common":"Finlandia"},"por":{"official":"Rep\xfablica da Finl\xe2ndia","common":"Finl\xe2ndia"},"rus":{"official":"\u0424\u0438\u043D\u043B\u044F\u043D\u0434\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u0424\u0438\u043D\u043B\u044F\u043D\u0434\u0438\u044F"},"slk":{"official":"F\xednska republika","common":"F\xednsko"},"spa":{"official":"Rep\xfablica de Finlandia","common":"Finlandia"},"swe":{"official":"Republiken Finland","common":"Finland"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0641\u0646 \u0644\u06CC\u0646\u0688","common":"\u0641\u0646 \u0644\u06CC\u0646\u0688"},"zho":{"official":"\u82AC\u5170\u5171\u548C\u56FD","common":"\u82AC\u5170"}},"latlng":[64,26],"landlocked":false,"borders":["NOR","SWE","RUS"],"area":338424,"flag":"\uD83C\uDDEB\uD83C\uDDEE","demonyms":{"eng":{"f":"Finnish","m":"Finnish"},"fra":{"f":"Finlandaise","m":"Finlandais"}}},{"name":{"common":"Fiji","official":"Republic of Fiji","native":{"eng":{"official":"Republic of Fiji","common":"Fiji"},"fij":{"official":"Matanitu Tugalala o Viti","common":"Viti"},"hif":{"official":"\u0930\u093F\u092A\u092C\u094D\u0932\u093F\u0915 \u0911\u092B \u092B\u0940\u091C\u0940","common":"\u092B\u093F\u091C\u0940"}}},"tld":[".fj"],"cca2":"FJ","ccn3":"242","cca3":"FJI","cioc":"FIJ","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"FJD":{"name":"Fijian dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["79"]},"capital":["Suva"],"altSpellings":["FJ","Viti","Republic of Fiji","Matanitu ko Viti","Fij\u012B Ga\u1E47ar\u0101jya"],"region":"Oceania","subregion":"Melanesia","languages":{"eng":"English","fij":"Fijian","hif":"Fiji Hindi"},"translations":{"ces":{"official":"Republika Fid\u017Eijsk\xfdch ostrov\u016F","common":"Fid\u017Ei"},"deu":{"official":"Republik Fidschi","common":"Fidschi"},"est":{"official":"Fid\u017Ei Vabariik","common":"Fid\u017Ei"},"fin":{"official":"Fid\u017Ein tasavalta","common":"Fid\u017Ei"},"fra":{"official":"R\xe9publique des Fidji","common":"Fidji"},"hrv":{"official":"Republika Fid\u017Ei","common":"Fi\u0111i"},"hun":{"official":"Fidzsi-szigeteki K\xf6zt\xe1rsas\xe1g","common":"Fidzsi-szigetek"},"ita":{"official":"Repubblica di Figi","common":"Figi"},"jpn":{"official":"\u30D5\u30A3\u30B8\u30FC\u5171\u548C\u56FD","common":"\u30D5\u30A3\u30B8\u30FC"},"kor":{"official":"\uD53C\uC9C0 \uACF5\uD654\uAD6D","common":"\uD53C\uC9C0"},"nld":{"official":"Republiek Fiji","common":"Fiji"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u062C\u0632\u0627\u06CC\u0631 \u0641\u06CC\u062C\u06CC","common":"\u0641\u06CC\u062C\u06CC"},"pol":{"official":"Republika Fid\u017Ci","common":"Fid\u017Ci"},"por":{"official":"Rep\xfablica de Fiji","common":"Fiji"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0424\u0438\u0434\u0436\u0438","common":"\u0424\u0438\u0434\u0436\u0438"},"slk":{"official":"Fi\u01C6ijsk\xe1 republika","common":"Fi\u01C6i"},"spa":{"official":"Rep\xfablica de Fiji","common":"Fiyi"},"swe":{"official":"Republiken Fiji","common":"Fiji"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0641\u062C\u06CC","common":"\u0641\u062C\u06CC"},"zho":{"official":"\u6590\u6D4E\u5171\u548C\u56FD","common":"\u6590\u6D4E"}},"latlng":[-18,175],"landlocked":false,"borders":[],"area":18272,"flag":"\uD83C\uDDEB\uD83C\uDDEF","demonyms":{"eng":{"f":"Fijian","m":"Fijian"},"fra":{"f":"Fidjienne","m":"Fidjien"}}},{"name":{"common":"Falkland Islands","official":"Falkland Islands","native":{"eng":{"official":"Falkland Islands","common":"Falkland Islands"}}},"tld":[".fk"],"cca2":"FK","ccn3":"238","cca3":"FLK","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"FKP":{"name":"Falkland Islands pound","symbol":"\xa3"}},"idd":{"root":"+5","suffixes":["00"]},"capital":["Stanley"],"altSpellings":["FK","Islas Malvinas","Falkland Islands (Malvinas)"],"region":"Americas","subregion":"South America","languages":{"eng":"English"},"translations":{"ces":{"official":"Falklandsk\xe9 ostrovy","common":"Falklandy"},"deu":{"official":"Falklandinseln","common":"Falklandinseln"},"est":{"official":"Falklandi saared","common":"Falklandi saared"},"fin":{"official":"Falkandinsaaret","common":"Falkandinsaaret"},"fra":{"official":"\xceles Malouines","common":"\xceles Malouines"},"hrv":{"official":"Falklandski otoci","common":"Falklandski Otoci"},"hun":{"official":"Falkland-szigetek","common":"Falkland-szigetek"},"ita":{"official":"Isole Falkland","common":"Isole Falkland o Isole Malvine"},"jpn":{"official":"\u30D5\u30A9\u30FC\u30AF\u30E9\u30F3\u30C9","common":"\u30D5\u30A9\u30FC\u30AF\u30E9\u30F3\u30C9\uFF08\u30DE\u30EB\u30D3\u30CA\u30B9\uFF09\u8AF8\u5CF6"},"kor":{"official":"\uD3EC\uD074\uB79C\uB4DC \uC81C\uB3C4","common":"\uD3EC\uD074\uB79C\uB4DC \uC81C\uB3C4"},"nld":{"official":"Falkland eilanden","common":"Falklandeilanden"},"per":{"official":"\u062C\u0632\u0627\u06CC\u0631 \u0641\u0627\u0644\u06A9\u0644\u0646\u062F","common":"\u062C\u0632\u0627\u06CC\u0631 \u0641\u0627\u0644\u06A9\u0644\u0646\u062F"},"pol":{"official":"Falklandy","common":"Falklandy"},"por":{"official":"Ilhas Malvinas","common":"Ilhas Malvinas"},"rus":{"official":"\u0424\u043E\u043B\u043A\u043B\u0435\u043D\u0434\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430","common":"\u0424\u043E\u043B\u043A\u043B\u0435\u043D\u0434\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430"},"slk":{"official":"Falklandsk\xe9 ostrovy","common":"Falklandy"},"spa":{"official":"islas Malvinas","common":"Islas Malvinas"},"swe":{"official":"Falklands\xf6arna","common":"Falklands\xf6arna"},"urd":{"official":"\u062C\u0632\u0627\u0626\u0631 \u0641\u0627\u06A9\u0644\u06CC\u0646\u0688","common":"\u062C\u0632\u0627\u0626\u0631 \u0641\u0627\u06A9\u0644\u06CC\u0646\u0688"},"zho":{"official":"\u798F\u514B\u5170\u7FA4\u5C9B","common":"\u798F\u514B\u5170\u7FA4\u5C9B"}},"latlng":[-51.75,-59],"landlocked":false,"borders":[],"area":12173,"flag":"\uD83C\uDDEB\uD83C\uDDF0","demonyms":{"eng":{"f":"Falkland Islander","m":"Falkland Islander"},"fra":{"f":"Malouinne","m":"Malouin"}}},{"name":{"common":"France","official":"French Republic","native":{"fra":{"official":"R\xe9publique fran\xe7aise","common":"France"}}},"tld":[".fr"],"cca2":"FR","ccn3":"250","cca3":"FRA","cioc":"FRA","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["3"]},"capital":["Paris"],"altSpellings":["FR","French Republic","R\xe9publique fran\xe7aise"],"region":"Europe","subregion":"Western Europe","languages":{"fra":"French"},"translations":{"ces":{"official":"Francouzsk\xe1 republika","common":"Francie"},"deu":{"official":"Franz\xf6sische Republik","common":"Frankreich"},"est":{"official":"Prantsuse Vabariik","common":"Prantsusmaa"},"fin":{"official":"Ranskan tasavalta","common":"Ranska"},"fra":{"official":"R\xe9publique fran\xe7aise","common":"France"},"hrv":{"official":"Francuska Republika","common":"Francuska"},"hun":{"official":"Francia K\xf6zt\xe1rsas\xe1g","common":"Franciaorsz\xe1g"},"ita":{"official":"Repubblica francese","common":"Francia"},"jpn":{"official":"\u30D5\u30E9\u30F3\u30B9\u5171\u548C\u56FD","common":"\u30D5\u30E9\u30F3\u30B9"},"kor":{"official":"\uD504\uB791\uC2A4 \uACF5\uD654\uAD6D","common":"\uD504\uB791\uC2A4"},"nld":{"official":"Franse Republiek","common":"Frankrijk"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0641\u0631\u0627\u0646\u0633\u0647","common":"\u0641\u0631\u0627\u0646\u0633\u0647"},"pol":{"official":"Republika Francuska","common":"Francja"},"por":{"official":"Rep\xfablica Francesa","common":"Fran\xe7a"},"rus":{"official":"\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u0424\u0440\u0430\u043D\u0446\u0438\u044F"},"slk":{"official":"Franc\xfazska republika","common":"Franc\xfazsko"},"spa":{"official":"Rep\xfablica franc\xe9s","common":"Francia"},"swe":{"official":"Republiken Frankrike","common":"Frankrike"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0641\u0631\u0627\u0646\u0633","common":"\u0641\u0631\u0627\u0646\u0633"},"zho":{"official":"\u6CD5\u5170\u897F\u5171\u548C\u56FD","common":"\u6CD5\u56FD"}},"latlng":[46,2],"landlocked":false,"borders":["AND","BEL","DEU","ITA","LUX","MCO","ESP","CHE"],"area":551695,"flag":"\uD83C\uDDEB\uD83C\uDDF7","demonyms":{"eng":{"f":"French","m":"French"},"fra":{"f":"Fran\xe7aise","m":"Fran\xe7ais"}}},{"name":{"common":"Faroe Islands","official":"Faroe Islands","native":{"dan":{"official":"F\xe6r\xf8erne","common":"F\xe6r\xf8erne"},"fao":{"official":"F\xf8royar","common":"F\xf8royar"}}},"tld":[".fo"],"cca2":"FO","ccn3":"234","cca3":"FRO","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"DKK":{"name":"Danish krone","symbol":"kr"},"FOK":{"name":"Faroese kr\xf3na","symbol":"kr"}},"idd":{"root":"+2","suffixes":["98"]},"capital":["T\xf3rshavn"],"altSpellings":["FO","F\xf8royar","F\xe6r\xf8erne"],"region":"Europe","subregion":"Northern Europe","languages":{"dan":"Danish","fao":"Faroese"},"translations":{"ces":{"official":"Faersk\xe9 ostrovy","common":"Faersk\xe9 ostrovy"},"deu":{"official":"F\xe4r\xf6er","common":"F\xe4r\xf6er-Inseln"},"est":{"official":"F\xe4\xe4ri saared","common":"F\xe4\xe4ri saared"},"fin":{"official":"F\xe4rsaaret","common":"F\xe4rsaaret"},"fra":{"official":"\xceles F\xe9ro\xe9","common":"\xceles F\xe9ro\xe9"},"hrv":{"official":"Farski Otoci","common":"Farski Otoci"},"hun":{"official":"Fer\xf6er","common":"Fer\xf6er"},"ita":{"official":"Isole Faroe","common":"Isole Far Oer"},"jpn":{"official":"\u30D5\u30A7\u30ED\u30FC\u8AF8\u5CF6","common":"\u30D5\u30A7\u30ED\u30FC\u8AF8\u5CF6"},"kor":{"official":"\uD398\uB85C \uC81C\uB3C4","common":"\uD398\uB85C \uC81C\uB3C4"},"nld":{"official":"Faer\xf6er","common":"Faer\xf6er"},"per":{"official":"\u062C\u0632\u0627\u06CC\u0631 \u0641\u0627\u0631\u0648\u0626\u0647","common":"\u062C\u0632\u0627\u06CC\u0631 \u0641\u0627\u0631\u0648\u0626\u0647"},"pol":{"official":"Wyspy Owcze","common":"Wyspy Owcze"},"por":{"official":"Ilhas Faroe","common":"Ilhas Faro\xe9"},"rus":{"official":"\u0424\u0430\u0440\u0435\u0440\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430","common":"\u0424\u0430\u0440\u0435\u0440\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430"},"slk":{"official":"Faersk\xe9 ostrovy","common":"Faersk\xe9 ostrovy"},"spa":{"official":"Islas Feroe","common":"Islas Faroe"},"swe":{"official":"F\xe4r\xf6arna","common":"F\xe4r\xf6arna"},"urd":{"official":"\u062C\u0632\u0627\u0626\u0631 \u0641\u0627\u0631\u0648","common":"\u062C\u0632\u0627\u0626\u0631 \u0641\u0627\u0631\u0648"},"zho":{"official":"\u6CD5\u7F57\u7FA4\u5C9B","common":"\u6CD5\u7F57\u7FA4\u5C9B"}},"latlng":[62,-7],"landlocked":false,"borders":[],"area":1393,"flag":"\uD83C\uDDEB\uD83C\uDDF4","demonyms":{"eng":{"f":"Faroese","m":"Faroese"},"fra":{"f":"F\xe9ro\xefenne","m":"F\xe9ro\xefen"}}},{"name":{"common":"Micronesia","official":"Federated States of Micronesia","native":{"eng":{"official":"Federated States of Micronesia","common":"Micronesia"}}},"tld":[".fm"],"cca2":"FM","ccn3":"583","cca3":"FSM","cioc":"FSM","independent":true,"status":"officially-assigned","unMember":true,"currencies":{},"idd":{"root":"+6","suffixes":["91"]},"capital":["Palikir"],"altSpellings":["FM","Federated States of Micronesia","Micronesia, Federated States of"],"region":"Oceania","subregion":"Micronesia","languages":{"eng":"English"},"translations":{"ces":{"official":"Federativn\xed st\xe1ty Mikron\xe9sie","common":"Mikron\xe9sie"},"deu":{"official":"F\xf6derierte Staaten von Mikronesien","common":"Mikronesien"},"est":{"official":"Mikroneesia Liiduriigid","common":"Mikroneesia"},"fin":{"official":"Mikronesian liittovaltio","common":"Mikronesia"},"fra":{"official":"\xc9tats f\xe9d\xe9r\xe9s de Micron\xe9sie","common":"Micron\xe9sie"},"hrv":{"official":"Savezne Dr\u017Eave Mikronezije","common":"Mikronezija"},"hun":{"official":"Mikron\xe9ziai Sz\xf6vets\xe9gi \xc1llamok","common":"Mikron\xe9ziai Sz\xf6vets\xe9gi \xc1llamok"},"ita":{"official":"Stati federati di Micronesia","common":"Micronesia"},"jpn":{"official":"\u30DF\u30AF\u30ED\u30CD\u30B7\u30A2\u9023\u90A6","common":"\u30DF\u30AF\u30ED\u30CD\u30B7\u30A2\u9023\u90A6"},"kor":{"official":"\uBBF8\uD06C\uB85C\uB124\uC2DC\uC544 \uC5F0\uBC29","common":"\uBBF8\uD06C\uB85C\uB124\uC2DC\uC544"},"nld":{"official":"Federale Staten van Micronesia","common":"Micronesi\xeb"},"per":{"official":"\u0627\u06CC\u0627\u0644\u0627\u062A \u0641\u062F\u0631\u0627\u0644 \u0645\u06CC\u06A9\u0631\u0648\u0646\u0632\u06CC","common":"\u0645\u06CC\u06A9\u0631\u0648\u0646\u0632\u06CC"},"pol":{"official":"Sfederowane Stany Mikronezji","common":"Mikronezja"},"por":{"official":"Estados Federados da Micron\xe9sia","common":"Micron\xe9sia"},"rus":{"official":"\u0424\u0435\u0434\u0435\u0440\u0430\u0442\u0438\u0432\u043D\u044B\u0435 \u0428\u0442\u0430\u0442\u044B \u041C\u0438\u043A\u0440\u043E\u043D\u0435\u0437\u0438\u0438","common":"\u0424\u0435\u0434\u0435\u0440\u0430\u0442\u0438\u0432\u043D\u044B\u0435 \u0428\u0442\u0430\u0442\u044B \u041C\u0438\u043A\u0440\u043E\u043D\u0435\u0437\u0438\u0438"},"slk":{"official":"Mikron\xe9zske federat\xedvne \u0161t\xe1ty","common":"Mikron\xe9zia"},"spa":{"official":"Estados Federados de Micronesia","common":"Micronesia"},"swe":{"official":"Mikronesiska federationen","common":"Mikronesiska federationen"},"urd":{"official":"\u0631\u06CC\u0627\u0633\u062A\u06C1\u0627\u0626\u06D2 \u0648\u0641\u0627\u0642\u06CC\u06C1 \u0645\u0627\u0626\u06A9\u0631\u0648\u0646\u06CC\u0634\u06CC\u0627","common":"\u0645\u0627\u0626\u06A9\u0631\u0648\u0646\u06CC\u0634\u06CC\u0627"},"zho":{"official":"\u5BC6\u514B\u7F57\u5C3C\u897F\u4E9A\u8054\u90A6","common":"\u5BC6\u514B\u7F57\u5C3C\u897F\u4E9A"}},"latlng":[6.91666666,158.25],"landlocked":false,"borders":[],"area":702,"flag":"\uD83C\uDDEB\uD83C\uDDF2","demonyms":{"eng":{"f":"Micronesian","m":"Micronesian"},"fra":{"f":"Micron\xe9sienne","m":"Micron\xe9sien"}}},{"name":{"common":"Gabon","official":"Gabonese Republic","native":{"fra":{"official":"R\xe9publique gabonaise","common":"Gabon"}}},"tld":[".ga"],"cca2":"GA","ccn3":"266","cca3":"GAB","cioc":"GAB","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"XAF":{"name":"Central African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["41"]},"capital":["Libreville"],"altSpellings":["GA","Gabonese Republic","R\xe9publique Gabonaise"],"region":"Africa","subregion":"Middle Africa","languages":{"fra":"French"},"translations":{"ces":{"official":"Gabonsk\xe1 republika","common":"Gabon"},"deu":{"official":"Gabunische Republik","common":"Gabun"},"est":{"official":"Gaboni Vabariik","common":"Gabon"},"fin":{"official":"Gabonin tasavalta","common":"Gabon"},"fra":{"official":"R\xe9publique gabonaise","common":"Gabon"},"hrv":{"official":"Gabon Republika","common":"Gabon"},"hun":{"official":"Gaboni K\xf6zt\xe1rsas\xe1g","common":"Gabon"},"ita":{"official":"Repubblica gabonese","common":"Gabon"},"jpn":{"official":"\u30AC\u30DC\u30F3\u5171\u548C\u56FD","common":"\u30AC\u30DC\u30F3"},"kor":{"official":"\uAC00\uBD09 \uACF5\uD654\uAD6D","common":"\uAC00\uBD09"},"nld":{"official":"Republiek Gabon","common":"Gabon"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u06AF\u0627\u0628\u064F\u0646","common":"\u06AF\u0627\u0628\u0646"},"pol":{"official":"Republika Gabo\u0144ska","common":"Gabon"},"por":{"official":"Rep\xfablica do Gab\xe3o","common":"Gab\xe3o"},"rus":{"official":"\u0413\u0430\u0431\u043E\u043D\u0430 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u0413\u0430\u0431\u043E\u043D"},"slk":{"official":"Gabonsk\xe1 republika","common":"Gabon"},"spa":{"official":"Rep\xfablica de Gab\xf3n","common":"Gab\xf3n"},"swe":{"official":"Republiken Gabon","common":"Gabon"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06AF\u06CC\u0628\u0648\u0646","common":"\u06AF\u06CC\u0628\u0648\u0646"},"zho":{"official":"\u52A0\u84EC\u5171\u548C\u56FD","common":"\u52A0\u84EC"}},"latlng":[-1,11.75],"landlocked":false,"borders":["CMR","COG","GNQ"],"area":267668,"flag":"\uD83C\uDDEC\uD83C\uDDE6","demonyms":{"eng":{"f":"Gabonese","m":"Gabonese"},"fra":{"f":"Gabonaise","m":"Gabonais"}}},{"name":{"common":"United Kingdom","official":"United Kingdom of Great Britain and Northern Ireland","native":{"eng":{"official":"United Kingdom of Great Britain and Northern Ireland","common":"United Kingdom"}}},"tld":[".uk"],"cca2":"GB","ccn3":"826","cca3":"GBR","cioc":"GBR","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"GBP":{"name":"British pound","symbol":"\xa3"}},"idd":{"root":"+4","suffixes":["4"]},"capital":["London"],"altSpellings":["GB","UK","Great Britain"],"region":"Europe","subregion":"Northern Europe","languages":{"eng":"English"},"translations":{"ces":{"official":"Spojen\xe9 kr\xe1lovstv\xed Velk\xe9 Brit\xe1nie a Severn\xedho Irska","common":"Spojen\xe9 kr\xe1lovstv\xed"},"deu":{"official":"Vereinigtes K\xf6nigreich Gro\xdfbritannien und Nordirland","common":"Vereinigtes K\xf6nigreich"},"est":{"official":"Suurbritannia ja P\xf5hja-Iiri \xdchendkuningriik","common":"Suurbritannia"},"fin":{"official":"Ison-Britannian ja Pohjois-Irlannin yhdistynyt kuningaskunta","common":"Yhdistynyt kuningaskunta"},"fra":{"official":"Royaume-Uni de Grande-Bretagne et d\'Irlande du Nord","common":"Royaume-Uni"},"hrv":{"official":"Ujedinjeno Kraljevstvo Velike Britanije i Sjeverne Irske","common":"Ujedinjeno Kraljevstvo"},"hun":{"official":"Nagy-Britannia \xe9s \xc9szak-\xcdrorsz\xe1g Egyes\xfclt Kir\xe1lys\xe1ga","common":"Egyes\xfclt Kir\xe1lys\xe1g"},"ita":{"official":"Regno Unito di Gran Bretagna e Irlanda del Nord","common":"Regno Unito"},"jpn":{"official":"\u30B0\u30EC\u30FC\u30C8\xb7\u30D6\u30EA\u30C6\u30F3\u304A\u3088\u3073\u5317\u30A2\u30A4\u30EB\u30E9\u30F3\u30C9\u9023\u5408\u738B\u56FD","common":"\u30A4\u30AE\u30EA\u30B9"},"kor":{"official":"\uADF8\uB808\uC774\uD2B8\uBE0C\uB9AC\uD2BC \uBD81\uC544\uC77C\uB79C\uB4DC \uC5F0\uD569 \uC655\uAD6D","common":"\uC601\uAD6D"},"nld":{"official":"Verenigd Koninkrijk van Groot-Brittanni\xeb en Noord-Ierland","common":"Verenigd Koninkrijk"},"per":{"official":"\u067E\u0627\u062F\u0634\u0627\u0647\u06CC \u0645\u062A\u062D\u062F \u0628\u0631\u06CC\u062A\u0627\u0646\u06CC\u0627\u06CC \u06A9\u0628\u06CC\u0631 \u0648 \u0627\u06CC\u0631\u0644\u0646\u062F \u0634\u0645\u0627\u0644\u06CC","common":"\u0627\u0646\u06AF\u0644\u06CC\u0633"},"pol":{"official":"Zjednoczone Kr\xf3lestwo Wielkiej Brytanii i Irlandii P\xf3\u0142nocnej","common":"Zjednoczone Kr\xf3lestwo"},"por":{"official":"Reino Unido da Gr\xe3-Bretanha e Irlanda do Norte","common":"Reino Unido"},"rus":{"official":"\u0421\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u043D\u043E\u0435 \u041A\u043E\u0440\u043E\u043B\u0435\u0432\u0441\u0442\u0432\u043E \u0412\u0435\u043B\u0438\u043A\u043E\u0431\u0440\u0438\u0442\u0430\u043D\u0438\u0438 \u0438 \u0421\u0435\u0432\u0435\u0440\u043D\u043E\u0439 \u0418\u0440\u043B\u0430\u043D\u0434\u0438\u0438","common":"\u0412\u0435\u043B\u0438\u043A\u043E\u0431\u0440\u0438\u0442\u0430\u043D\u0438\u044F"},"slk":{"official":"Spojen\xe9 kr\xe1\u013Eovstvo Ve\u013Ekej Brit\xe1nie a Severn\xe9ho\xccrska","common":"Ve\u013Ek\xe1 Brit\xe1nia (Spojen\xe9 kr\xe1\u013Eovstvo)"},"spa":{"official":"Reino Unido de Gran Breta\xf1a e Irlanda del Norte","common":"Reino Unido"},"swe":{"official":"F\xf6renade konungariket Storbritannien och Nordirland","common":"Storbritannien"},"urd":{"official":"\u0645\u0645\u0644\u06A9\u062A\u0650 \u0645\u062A\u062D\u062F\u06C1 \u0628\u0631\u0637\u0627\u0646\u06CC\u06C1 \u0639\u0638\u0645\u06CC \u0648 \u0634\u0645\u0627\u0644\u06CC \u0622\u0626\u0631\u0644\u06CC\u0646\u0688","common":"\u0645\u0645\u0644\u06A9\u062A\u0650 \u0645\u062A\u062D\u062F\u06C1"},"zho":{"official":"\u5927\u4E0D\u5217\u98A0\u53CA\u5317\u7231\u5C14\u5170\u8054\u5408\u738B\u56FD","common":"\u82F1\u56FD"}},"latlng":[54,-2],"landlocked":false,"borders":["IRL"],"area":242900,"flag":"\uD83C\uDDEC\uD83C\uDDE7","demonyms":{"eng":{"f":"British","m":"British"},"fra":{"f":"Britannique","m":"Britannique"}}},{"name":{"common":"Georgia","official":"Georgia","native":{"kat":{"official":"\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD","common":"\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD"}}},"tld":[".ge"],"cca2":"GE","ccn3":"268","cca3":"GEO","cioc":"GEO","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"GEL":{"name":"lari","symbol":"\u20BE"}},"idd":{"root":"+9","suffixes":["95"]},"capital":["Tbilisi"],"altSpellings":["GE","Sakartvelo"],"region":"Asia","subregion":"Western Asia","languages":{"kat":"Georgian"},"translations":{"ces":{"official":"Gruzie","common":"Gruzie"},"deu":{"official":"Georgien","common":"Georgien"},"est":{"official":"Gruusia","common":"Gruusia"},"fin":{"official":"Georgia","common":"Georgia"},"fra":{"official":"R\xe9publique de G\xe9orgie","common":"G\xe9orgie"},"hrv":{"official":"Gruzija","common":"Gruzija"},"hun":{"official":"Gr\xfazia","common":"Gr\xfazia"},"ita":{"official":"Georgia","common":"Georgia"},"jpn":{"official":"\u30B0\u30EB\u30B8\u30A2","common":"\u30B0\u30EB\u30B8\u30A2"},"kor":{"official":"\uC870\uC9C0\uC544","common":"\uC870\uC9C0\uC544"},"nld":{"official":"Georgia","common":"Georgi\xeb"},"per":{"official":"\u06AF\u0631\u062C\u0633\u062A\u0627\u0646","common":"\u06AF\u0631\u062C\u0633\u062A\u0627\u0646"},"pol":{"official":"Gruzja","common":"Gruzja"},"por":{"official":"Georgia","common":"Ge\xf3rgia"},"rus":{"official":"\u0413\u0440\u0443\u0437\u0438\u044F","common":"\u0413\u0440\u0443\u0437\u0438\u044F"},"slk":{"official":"Gruz\xednsko","common":"Gruz\xednsko"},"spa":{"official":"Georgia","common":"Georgia"},"swe":{"official":"Georgien","common":"Georgien"},"urd":{"official":"\u062C\u0627\u0631\u062C\u06CC\u0627","common":"\u062C\u0627\u0631\u062C\u06CC\u0627"},"zho":{"official":"\u683C\u9C81\u5409\u4E9A","common":"\u683C\u9C81\u5409\u4E9A"}},"latlng":[42,43.5],"landlocked":false,"borders":["ARM","AZE","RUS","TUR"],"area":69700,"flag":"\uD83C\uDDEC\uD83C\uDDEA","demonyms":{"eng":{"f":"Georgian","m":"Georgian"},"fra":{"f":"G\xe9orgienne","m":"G\xe9orgien"}}},{"name":{"common":"Guernsey","official":"Bailiwick of Guernsey","native":{"eng":{"official":"Bailiwick of Guernsey","common":"Guernsey"},"fra":{"official":"Bailliage de Guernesey","common":"Guernesey"},"nfr":{"official":"Dg\xe8rn\xe9siais","common":"Dg\xe8rn\xe9siais"}}},"tld":[".gg"],"cca2":"GG","ccn3":"831","cca3":"GGY","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"GBP":{"name":"British pound","symbol":"\xa3"},"GGP":{"name":"Guernsey pound","symbol":"\xa3"}},"idd":{"root":"+4","suffixes":["4"]},"capital":["St. Peter Port"],"altSpellings":["GG","Bailiwick of Guernsey","Bailliage de Guernesey"],"region":"Europe","subregion":"Northern Europe","languages":{"eng":"English","fra":"French","nfr":"Guern\xe9siais"},"translations":{"ces":{"official":"Rycht\xe1\u0159stv\xed Guernsey","common":"Guernsey"},"deu":{"official":"Vogtei Guernsey","common":"Guernsey"},"est":{"official":"Guernsey foogtkond","common":"Guernsey"},"fin":{"official":"Guernsey","common":"Guernsey"},"fra":{"official":"Bailliage de Guernesey","common":"Guernesey"},"hrv":{"official":"Struka Guernsey","common":"Guernsey"},"hun":{"official":"Guernsey","common":"Guernsey"},"ita":{"official":"Baliato di Guernsey","common":"Guernsey"},"jpn":{"official":"\u30AC\u30FC\u30F3\u30B8\u30FC\u306E\u5F97\u610F\u5206\u91CE","common":"\u30AC\u30FC\u30F3\u30B8\u30FC"},"kor":{"official":"\uAC74\uC9C0 \uC12C","common":"\uAC74\uC9C0 \uC12C"},"nld":{"official":"Baljuwschap Guernsey","common":"Guernsey"},"per":{"official":"\u06AF\u0631\u0646\u0632\u06CC","common":"\u06AF\u0631\u0646\u0632\u06CC"},"pol":{"official":"Baliwat Guernsey","common":"Guernsey"},"por":{"official":"Bailiado de Guernsey","common":"Guernsey"},"rus":{"official":"\u041A\u043E\u0440\u043E\u043D\u043D\u043E\u0435 \u0432\u043B\u0430\u0434\u0435\u043D\u0438\u0435 \u0413\u0435\u0440\u043D\u0441\u0438","common":"\u0413\u0435\u0440\u043D\u0441\u0438"},"slk":{"official":"Guernsey","common":"Guernsey"},"spa":{"official":"Bail\xeda de Guernsey","common":"Guernsey"},"swe":{"official":"Guernsey","common":"Guernsey"},"urd":{"official":"\u06AF\u0631\u0646\u0632\u06CC \u0631\u0648\u062F\u0628\u0627\u0631","common":"\u06AF\u0631\u0646\u0632\u06CC"},"zho":{"official":"\u6839\u897F\u5C9B","common":"\u6839\u897F\u5C9B"}},"latlng":[49.46666666,-2.58333333],"landlocked":false,"borders":[],"area":78,"flag":"\uD83C\uDDEC\uD83C\uDDEC","demonyms":{"eng":{"f":"Channel Islander","m":"Channel Islander"},"fra":{"f":"Guernesiaise","m":"Guernesiais"}}},{"name":{"common":"Ghana","official":"Republic of Ghana","native":{"eng":{"official":"Republic of Ghana","common":"Ghana"}}},"tld":[".gh"],"cca2":"GH","ccn3":"288","cca3":"GHA","cioc":"GHA","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"GHS":{"name":"Ghanaian cedi","symbol":"\u20B5"}},"idd":{"root":"+2","suffixes":["33"]},"capital":["Accra"],"altSpellings":["GH"],"region":"Africa","subregion":"Western Africa","languages":{"eng":"English"},"translations":{"ces":{"official":"Ghansk\xe1 republika","common":"Ghana"},"deu":{"official":"Republik Ghana","common":"Ghana"},"est":{"official":"Ghana Vabariik","common":"Ghana"},"fin":{"official":"Ghanan tasavalta","common":"Ghana"},"fra":{"official":"R\xe9publique du Ghana","common":"Ghana"},"hrv":{"official":"Republika Gana","common":"Gana"},"hun":{"official":"Gh\xe1nai K\xf6zt\xe1rsas\xe1g","common":"Gh\xe1na"},"ita":{"official":"Repubblica del Ghana","common":"Ghana"},"jpn":{"official":"\u30AC\u30FC\u30CA\u5171\u548C\u56FD","common":"\u30AC\u30FC\u30CA"},"kor":{"official":"\uAC00\uB098 \uACF5\uD654\uAD6D","common":"\uAC00\uB098"},"nld":{"official":"Republiek Ghana","common":"Ghana"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u063A\u0646\u0627","common":"\u063A\u0646\u0627"},"pol":{"official":"Republika Ghany","common":"Ghana"},"por":{"official":"Rep\xfablica do Gana","common":"Gana"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0413\u0430\u043D\u0430","common":"\u0413\u0430\u043D\u0430"},"slk":{"official":"Ghansk\xe1 republika","common":"Ghana"},"spa":{"official":"Rep\xfablica de Ghana","common":"Ghana"},"swe":{"official":"Republiken Ghana","common":"Ghana"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06AF\u06BE\u0627\u0646\u0627","common":"\u06AF\u06BE\u0627\u0646\u0627"},"zho":{"official":"\u52A0\u7EB3\u5171\u548C\u56FD","common":"\u52A0\u7EB3"}},"latlng":[8,-2],"landlocked":false,"borders":["BFA","CIV","TGO"],"area":238533,"flag":"\uD83C\uDDEC\uD83C\uDDED","demonyms":{"eng":{"f":"Ghanaian","m":"Ghanaian"},"fra":{"f":"Ghan\xe9enne","m":"Ghan\xe9en"}}},{"name":{"common":"Gibraltar","official":"Gibraltar","native":{"eng":{"official":"Gibraltar","common":"Gibraltar"}}},"tld":[".gi"],"cca2":"GI","ccn3":"292","cca3":"GIB","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"GIP":{"name":"Gibraltar pound","symbol":"\xa3"}},"idd":{"root":"+3","suffixes":["50"]},"capital":["Gibraltar"],"altSpellings":["GI"],"region":"Europe","subregion":"Southern Europe","languages":{"eng":"English"},"translations":{"ces":{"official":"Gibraltar","common":"Gibraltar"},"deu":{"official":"Gibraltar","common":"Gibraltar"},"est":{"official":"Gibraltar","common":"Gibraltar"},"fin":{"official":"Gibraltar","common":"Gibraltar"},"fra":{"official":"Gibraltar","common":"Gibraltar"},"hrv":{"official":"Gibraltar","common":"Gibraltar"},"hun":{"official":"Gibralt\xe1r","common":"Gibralt\xe1r"},"ita":{"official":"Gibilterra","common":"Gibilterra"},"jpn":{"official":"\u30B8\u30D6\u30E9\u30EB\u30BF\u30EB","common":"\u30B8\u30D6\u30E9\u30EB\u30BF\u30EB"},"kor":{"official":"\uC9C0\uBE0C\uB864\uD130","common":"\uC9C0\uBE0C\uB864\uD130"},"nld":{"official":"Gibraltar","common":"Gibraltar"},"per":{"official":"\u062C\u0628\u0644 \u0637\u0627\u0631\u0642","common":"\u062C\u0628\u0644 \u0637\u0627\u0631\u0642"},"pol":{"official":"Gibraltar","common":"Gibraltar"},"por":{"official":"Gibraltar","common":"Gibraltar"},"rus":{"official":"\u0413\u0438\u0431\u0440\u0430\u043B\u0442\u0430\u0440","common":"\u0413\u0438\u0431\u0440\u0430\u043B\u0442\u0430\u0440"},"slk":{"official":"Gibralt\xe1r","common":"Gibralt\xe1r"},"spa":{"official":"Gibraltar","common":"Gibraltar"},"swe":{"official":"Gibraltar","common":"Gibraltar"},"urd":{"official":"\u062C\u0628\u0644 \u0627\u0644\u0637\u0627\u0631\u0642","common":"\u062C\u0628\u0644 \u0627\u0644\u0637\u0627\u0631\u0642"},"zho":{"official":"\u76F4\u5E03\u7F57\u9640","common":"\u76F4\u5E03\u7F57\u9640"}},"latlng":[36.13333333,-5.35],"landlocked":false,"borders":["ESP"],"area":6,"flag":"\uD83C\uDDEC\uD83C\uDDEE","demonyms":{"eng":{"f":"Gibraltar","m":"Gibraltar"},"fra":{"f":"Gibraltarienne","m":"Gibraltarien"}}},{"name":{"common":"Guinea","official":"Republic of Guinea","native":{"fra":{"official":"R\xe9publique de Guin\xe9e","common":"Guin\xe9e"}}},"tld":[".gn"],"cca2":"GN","ccn3":"324","cca3":"GIN","cioc":"GUI","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"GNF":{"name":"Guinean franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["24"]},"capital":["Conakry"],"altSpellings":["GN","Republic of Guinea","R\xe9publique de Guin\xe9e"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"ces":{"official":"Guinejsk\xe1 republika","common":"Guinea"},"deu":{"official":"Republik Guinea","common":"Guinea"},"est":{"official":"Guinea Vabariik","common":"Guinea"},"fin":{"official":"Guinean tasavalta","common":"Guinea"},"fra":{"official":"R\xe9publique de Guin\xe9e","common":"Guin\xe9e"},"hrv":{"official":"Republika Gvineja","common":"Gvineja"},"hun":{"official":"Guineai K\xf6zt\xe1rsas\xe1g","common":"Guinea"},"ita":{"official":"Repubblica di Guinea","common":"Guinea"},"jpn":{"official":"\u30AE\u30CB\u30A2\u5171\u548C\u56FD","common":"\u30AE\u30CB\u30A2"},"kor":{"official":"\uAE30\uB2C8 \uACF5\uD654\uAD6D","common":"\uAE30\uB2C8"},"nld":{"official":"Republiek Guinee","common":"Guinee"},"per":{"official":"\u0645\u0645\u0644\u06A9\u062A \u0645\u0633\u062A\u0642\u0644 \u067E\u0627\u067E\u0648\u0622 \u06AF\u06CC\u0646\u0647 \u0646\u0648","common":"\u067E\u0627\u067E\u0648\u0622 \u06AF\u06CC\u0646\u0647 \u0646\u0648"},"pol":{"official":"Republika Gwinei","common":"Gwinea"},"por":{"official":"Rep\xfablica da Guin\xe9","common":"Guin\xe9"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0413\u0432\u0438\u043D\u0435\u044F","common":"\u0413\u0432\u0438\u043D\u0435\u044F"},"slk":{"official":"Guinejsk\xe1 republika","common":"Guinea"},"spa":{"official":"Rep\xfablica de Guinea","common":"Guinea"},"swe":{"official":"Republiken Guinea","common":"Guinea"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06AF\u0646\u06CC","common":"\u06AF\u0646\u06CC"},"zho":{"official":"\u51E0\u5185\u4E9A\u5171\u548C\u56FD","common":"\u51E0\u5185\u4E9A"}},"latlng":[11,-10],"landlocked":false,"borders":["CIV","GNB","LBR","MLI","SEN","SLE"],"area":245857,"flag":"\uD83C\uDDEC\uD83C\uDDF3","demonyms":{"eng":{"f":"Guinean","m":"Guinean"},"fra":{"f":"Guin\xe9enne","m":"Guin\xe9en"}}},{"name":{"common":"Guadeloupe","official":"Guadeloupe","native":{"fra":{"official":"Guadeloupe","common":"Guadeloupe"}}},"tld":[".gp"],"cca2":"GP","ccn3":"312","cca3":"GLP","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+5","suffixes":["90"]},"capital":["Basse-Terre"],"altSpellings":["GP","Gwadloup"],"region":"Americas","subregion":"Caribbean","languages":{"fra":"French"},"translations":{"ces":{"official":"Guadeloupe","common":"Guadeloupe"},"deu":{"official":"Guadeloupe","common":"Guadeloupe"},"est":{"official":"Guadeloupe\u2019i ja s\xf5ltkondade departemang","common":"Guadeloupe"},"fin":{"official":"Guadeloupen departmentti","common":"Guadeloupe"},"fra":{"official":"Guadeloupe","common":"Guadeloupe"},"hrv":{"official":"Gvadalupa","common":"Gvadalupa"},"hun":{"official":"Guadeloupe","common":"Guadeloupe"},"ita":{"official":"Guadeloupe","common":"Guadeloupa"},"jpn":{"official":"\u30B0\u30A2\u30C9\u30EB\u30FC\u30D7\u5CF6","common":"\u30B0\u30A2\u30C9\u30EB\u30FC\u30D7"},"kor":{"official":"\uACFC\uB4E4\uB8E8\uD504","common":"\uACFC\uB4E4\uB8E8\uD504"},"nld":{"official":"Guadeloupe","common":"Guadeloupe"},"per":{"official":"\u06AF\u0648\u0627\u062F\u0644\u0648\u067E","common":"\u06AF\u0648\u0627\u062F\u0644\u0648\u067E"},"pol":{"official":"Gwadelupa","common":"Gwadelupa"},"por":{"official":"Guadalupe","common":"Guadalupe"},"rus":{"official":"\u0413\u0432\u0430\u0434\u0435\u043B\u0443\u043F\u0430","common":"\u0413\u0432\u0430\u0434\u0435\u043B\u0443\u043F\u0430"},"slk":{"official":"Guadeloupe","common":"Guadeloupe"},"spa":{"official":"Guadalupe","common":"Guadalupe"},"swe":{"official":"Guadeloupe","common":"Guadeloupe"},"urd":{"official":"\u06AF\u0648\u0627\u0688\u06CC\u0644\u0648\u067E","common":"\u06AF\u0648\u0627\u0688\u06CC\u0644\u0648\u067E"},"zho":{"official":"\u74DC\u5FB7\u7F57\u666E\u5C9B","common":"\u74DC\u5FB7\u7F57\u666E\u5C9B"}},"latlng":[16.25,-61.583333],"landlocked":false,"borders":[],"area":1628,"flag":"\uD83C\uDDEC\uD83C\uDDF5","demonyms":{"eng":{"f":"Guadeloupian","m":"Guadeloupian"},"fra":{"f":"Guadeloup\xe9enne","m":"Guadeloup\xe9en"}}},{"name":{"common":"Gambia","official":"Republic of the Gambia","native":{"eng":{"official":"Republic of the Gambia","common":"Gambia"}}},"tld":[".gm"],"cca2":"GM","ccn3":"270","cca3":"GMB","cioc":"GAM","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"GMD":{"name":"dalasi","symbol":"D"}},"idd":{"root":"+2","suffixes":["20"]},"capital":["Banjul"],"altSpellings":["GM","Republic of the Gambia"],"region":"Africa","subregion":"Western Africa","languages":{"eng":"English"},"translations":{"ces":{"official":"Gambijsk\xe1 republika","common":"Gambie"},"deu":{"official":"Republik Gambia","common":"Gambia"},"est":{"official":"Gambia Vabariik","common":"Gambia"},"fin":{"official":"Gambian tasavalta","common":"Gambia"},"fra":{"official":"R\xe9publique de Gambie","common":"Gambie"},"hrv":{"official":"Republika Gambija","common":"Gambija"},"hun":{"official":"Gambiai K\xf6zt\xe1rsas\xe1g","common":"Gambia"},"ita":{"official":"Repubblica del Gambia","common":"Gambia"},"jpn":{"official":"\u30AC\u30F3\u30D3\u30A2\u5171\u548C\u56FD","common":"\u30AC\u30F3\u30D3\u30A2"},"kor":{"official":"\uAC10\uBE44\uC544 \uACF5\uD654\uAD6D","common":"\uAC10\uBE44\uC544"},"nld":{"official":"Republiek Gambia","common":"Gambia"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u06AF\u0627\u0645\u0628\u06CC\u0627","common":"\u06AF\u0627\u0645\u0628\u06CC\u0627"},"pol":{"official":"Republika Gambii","common":"Gambia"},"por":{"official":"Rep\xfablica da G\xe2mbia","common":"G\xe2mbia"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0413\u0430\u043C\u0431\u0438\u044F","common":"\u0413\u0430\u043C\u0431\u0438\u044F"},"slk":{"official":"Gambijsk\xe1 republika","common":"Gambia"},"spa":{"official":"Rep\xfablica de Gambia","common":"Gambia"},"swe":{"official":"Republiken Gambia","common":"Gambia"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06AF\u06CC\u0645\u0628\u06CC\u0627","common":"\u06AF\u06CC\u0645\u0628\u06CC\u0627"},"zho":{"official":"\u5188\u6BD4\u4E9A\u5171\u548C\u56FD","common":"\u5188\u6BD4\u4E9A"}},"latlng":[13.46666666,-16.56666666],"landlocked":false,"borders":["SEN"],"area":10689,"flag":"\uD83C\uDDEC\uD83C\uDDF2","demonyms":{"eng":{"f":"Gambian","m":"Gambian"},"fra":{"f":"Gambienne","m":"Gambien"}}},{"name":{"common":"Guinea-Bissau","official":"Republic of Guinea-Bissau","native":{"por":{"official":"Rep\xfablica da Guin\xe9-Bissau","common":"Guin\xe9-Bissau"},"pov":{"official":"Rep\xfablica da Guin\xe9-Bissau","common":"Guin\xe9-Bissau"}}},"tld":[".gw"],"cca2":"GW","ccn3":"624","cca3":"GNB","cioc":"GBS","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"XOF":{"name":"West African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["45"]},"capital":["Bissau"],"altSpellings":["GW","Republic of Guinea-Bissau","Rep\xfablica da Guin\xe9-Bissau"],"region":"Africa","subregion":"Western Africa","languages":{"por":"Portuguese","pov":"Upper Guinea Creole"},"translations":{"ces":{"official":"Republika Guinea-Bissau","common":"Guinea-Bissau"},"deu":{"official":"Republik Guinea-Bissau","common":"Guinea-Bissau"},"est":{"official":"Guinea-Bissau Vabariik","common":"Guinea-Bissau"},"fin":{"official":"Guinea-Bissaun tasavalta","common":"Guinea-Bissau"},"fra":{"official":"R\xe9publique de Guin\xe9e-Bissau","common":"Guin\xe9e-Bissau"},"hrv":{"official":"Republika Gvineja Bisau","common":"Gvineja Bisau"},"hun":{"official":"Bissau-Guineai K\xf6zt\xe1rsas\xe1g","common":"Bissau-Guinea"},"ita":{"official":"Repubblica di Guinea-Bissau","common":"Guinea-Bissau"},"jpn":{"official":"\u30AE\u30CB\u30A2\u30D3\u30B5\u30A6\u5171\u548C\u56FD","common":"\u30AE\u30CB\u30A2\u30D3\u30B5\u30A6"},"kor":{"official":"\uAE30\uB2C8\uBE44\uC0AC\uC6B0 \uACF5\uD654\uAD6D","common":"\uAE30\uB2C8\uBE44\uC0AC\uC6B0"},"nld":{"official":"Republiek Guinee-Bissau","common":"Guinee-Bissau"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u06AF\u06CC\u0646\u0647 \u0628\u06CC\u0633\u0627\u0626\u0648","common":"\u06AF\u06CC\u0646\u0647 \u0628\u06CC\u0633\u0627\u0626\u0648"},"pol":{"official":"Republika Gwinei Bissau","common":"Gwinea Bissau"},"por":{"official":"Rep\xfablica da Guin\xe9-Bissau","common":"Guin\xe9-Bissau"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0413\u0432\u0438\u043D\u0435\u044F -\u0411\u0438\u0441\u0430\u0443","common":"\u0413\u0432\u0438\u043D\u0435\u044F-\u0411\u0438\u0441\u0430\u0443"},"slk":{"official":"Guinejsko-bissausk\xe1 republika","common":"Guinea-Bissau"},"spa":{"official":"Rep\xfablica de Guinea-Bissau","common":"Guinea-Bis\xe1u"},"swe":{"official":"Republiken Guinea-Bissau","common":"Guinea-Bissau"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06AF\u0646\u06CC \u0628\u0633\u0627\u0624","common":"\u06AF\u0646\u06CC \u0628\u0633\u0627\u0624"},"zho":{"official":"\u51E0\u5185\u4E9A\u6BD4\u7ECD\u5171\u548C\u56FD","common":"\u51E0\u5185\u4E9A\u6BD4\u7ECD"}},"latlng":[12,-15],"landlocked":false,"borders":["GIN","SEN"],"area":36125,"flag":"\uD83C\uDDEC\uD83C\uDDFC","demonyms":{"eng":{"f":"Guinea-Bissauan","m":"Guinea-Bissauan"},"fra":{"f":"Bissau-Guin\xe9enne","m":"Bissau-Guin\xe9en"}}},{"name":{"common":"Equatorial Guinea","official":"Republic of Equatorial Guinea","native":{"fra":{"official":"R\xe9publique de la Guin\xe9e \xc9quatoriale","common":"Guin\xe9e \xe9quatoriale"},"por":{"official":"Rep\xfablica da Guin\xe9 Equatorial","common":"Guin\xe9 Equatorial"},"spa":{"official":"Rep\xfablica de Guinea Ecuatorial","common":"Guinea Ecuatorial"}}},"tld":[".gq"],"cca2":"GQ","ccn3":"226","cca3":"GNQ","cioc":"GEQ","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"XAF":{"name":"Central African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["40"]},"capital":["Malabo"],"altSpellings":["GQ","Republic of Equatorial Guinea","Rep\xfablica de Guinea Ecuatorial","R\xe9publique de Guin\xe9e \xe9quatoriale","Rep\xfablica da Guin\xe9 Equatorial"],"region":"Africa","subregion":"Middle Africa","languages":{"fra":"French","por":"Portuguese","spa":"Spanish"},"translations":{"ces":{"official":"Republika Rovn\xedkov\xe1 Guinea","common":"Rovn\xedkov\xe1 Guinea"},"cym":{"official":"Gweriniaeth Gini Gyhydeddol","common":"Gini Gyhydeddol"},"deu":{"official":"Republik \xc4quatorialguinea","common":"\xc4quatorialguinea"},"est":{"official":"Ekvatoriaal-Guinea Vabariik","common":"Ekvatoriaal-Guinea"},"fin":{"official":"P\xe4iv\xe4ntasaajan Guinean tasavalta","common":"P\xe4iv\xe4ntasaajan Guinea"},"fra":{"official":"R\xe9publique de Guin\xe9e \xe9quatoriale","common":"Guin\xe9e \xe9quatoriale"},"hrv":{"official":"Republika Ekvatorska Gvineja","common":"Ekvatorijalna Gvineja"},"hun":{"official":"Egyenl\xedt\u0151i-Guinea-i K\xf6zt\xe1rsas\xe1g","common":"Egyenl\xedt\u0151i-Guinea"},"ita":{"official":"Repubblica della Guinea Equatoriale","common":"Guinea Equatoriale"},"jpn":{"official":"\u8D64\u9053\u30AE\u30CB\u30A2\u5171\u548C\u56FD","common":"\u8D64\u9053\u30AE\u30CB\u30A2"},"kor":{"official":"\uC801\uB3C4 \uAE30\uB2C8 \uACF5\uD654\uAD6D","common":"\uC801\uB3C4 \uAE30\uB2C8"},"nld":{"official":"Republiek Equatoriaal-Guinea","common":"Equatoriaal-Guinea"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u06AF\u06CC\u0646\u0647 \u0627\u0633\u062A\u0648\u0627\u06CC\u06CC","common":"\u06AF\u06CC\u0646\u0647 \u0627\u0633\u062A\u0648\u0627\u06CC\u06CC"},"pol":{"official":"Republika Gwinei R\xf3wnikowej","common":"Gwinea R\xf3wnikowa"},"por":{"official":"Rep\xfablica da Guin\xe9 Equatorial","common":"Guin\xe9 Equatorial"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u042D\u043A\u0432\u0430\u0442\u043E\u0440\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u0413\u0432\u0438\u043D\u0435\u044F","common":"\u042D\u043A\u0432\u0430\u0442\u043E\u0440\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u0413\u0432\u0438\u043D\u0435\u044F"},"slk":{"official":"Republika rovn\xedkovej Guiney","common":"Rovn\xedkov\xe1 Guinea"},"spa":{"official":"Rep\xfablica de Guinea Ecuatorial","common":"Guinea Ecuatorial"},"swe":{"official":"Republiken Ekvatorialguinea","common":"Ekvatorialguinea"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0627\u0633\u062A\u0648\u0627\u0626\u06CC \u06AF\u0646\u06CC","common":"\u0627\u0633\u062A\u0648\u0627\u0626\u06CC \u06AF\u0646\u06CC"},"zho":{"official":"\u8D64\u9053\u51E0\u5185\u4E9A\u5171\u548C\u56FD","common":"\u8D64\u9053\u51E0\u5185\u4E9A"}},"latlng":[2,10],"landlocked":false,"borders":["CMR","GAB"],"area":28051,"flag":"\uD83C\uDDEC\uD83C\uDDF6","demonyms":{"eng":{"f":"Equatorial Guinean","m":"Equatorial Guinean"},"fra":{"f":"\xc9quato-guin\xe9enne","m":"\xc9quato-guin\xe9en"}}},{"name":{"common":"Greece","official":"Hellenic Republic","native":{"ell":{"official":"\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AE \u0394\u03B7\u03BC\u03BF\u03BA\u03C1\u03B1\u03C4\u03AF\u03B1","common":"\u0395\u03BB\u03BB\u03AC\u03B4\u03B1"}}},"tld":[".gr"],"cca2":"GR","ccn3":"300","cca3":"GRC","cioc":"GRE","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["0"]},"capital":["Athens"],"altSpellings":["GR","Ell\xe1da","Hellenic Republic","\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AE \u0394\u03B7\u03BC\u03BF\u03BA\u03C1\u03B1\u03C4\u03AF\u03B1"],"region":"Europe","subregion":"Southern Europe","languages":{"ell":"Greek"},"translations":{"ces":{"official":"\u0158eck\xe1 republika","common":"\u0158ecko"},"deu":{"official":"Hellenische Republik","common":"Griechenland"},"est":{"official":"Kreeka Vabariik","common":"Kreeka"},"fin":{"official":"Helleenien tasavalta","common":"Kreikka"},"fra":{"official":"R\xe9publique hell\xe9nique","common":"Gr\xe8ce"},"hrv":{"official":"Helenska Republika","common":"Gr\u010Dka"},"hun":{"official":"G\xf6r\xf6g K\xf6zt\xe1rsas\xe1g","common":"G\xf6r\xf6gorsz\xe1g"},"ita":{"official":"Repubblica ellenica","common":"Grecia"},"jpn":{"official":"\u30AE\u30EA\u30B7\u30E3\u5171\u548C\u56FD","common":"\u30AE\u30EA\u30B7\u30E3"},"kor":{"official":"\uADF8\uB9AC\uC2A4 \uACF5\uD654\uAD6D","common":"\uADF8\uB9AC\uC2A4"},"nld":{"official":"Helleense Republiek","common":"Griekenland"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u06CC\u0648\u0646\u0627\u0646","common":"\u06CC\u0648\u0646\u0627\u0646"},"pol":{"official":"Republika Grecka","common":"Grecja"},"por":{"official":"Rep\xfablica Hel\xe9nica","common":"Gr\xe9cia"},"rus":{"official":"\u0413\u0440\u0435\u0447\u0435\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u0413\u0440\u0435\u0446\u0438\u044F"},"slk":{"official":"Gr\xe9cka republika","common":"Gre\xe9cko"},"spa":{"official":"Rep\xfablica Hel\xe9nica","common":"Grecia"},"swe":{"official":"Republiken Grekland","common":"Grekland"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06C1\u06CC\u0644\u06CC\u0646\u06CC\u06C1","common":"\u06CC\u0648\u0646\u0627\u0646"},"zho":{"official":"\u5E0C\u814A\u5171\u548C\u56FD","common":"\u5E0C\u814A"}},"latlng":[39,22],"landlocked":false,"borders":["ALB","BGR","TUR","MKD"],"area":131990,"flag":"\uD83C\uDDEC\uD83C\uDDF7","demonyms":{"eng":{"f":"Greek","m":"Greek"},"fra":{"f":"Grecque","m":"Grec"}}},{"name":{"common":"Grenada","official":"Grenada","native":{"eng":{"official":"Grenada","common":"Grenada"}}},"tld":[".gd"],"cca2":"GD","ccn3":"308","cca3":"GRD","cioc":"GRN","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"XCD":{"name":"Eastern Caribbean dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["473"]},"capital":["St. George\'s"],"altSpellings":["GD"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Grenada","common":"Grenada"},"deu":{"official":"Grenada","common":"Grenada"},"est":{"official":"Grenada","common":"Grenada"},"fin":{"official":"Grenada","common":"Grenada"},"fra":{"official":"Grenade","common":"Grenade"},"hrv":{"official":"Grenada","common":"Grenada"},"hun":{"official":"Grenada","common":"Grenada"},"ita":{"official":"Grenada","common":"Grenada"},"jpn":{"official":"\u30B0\u30EC\u30CA\u30C0","common":"\u30B0\u30EC\u30CA\u30C0"},"kor":{"official":"\uADF8\uB808\uB098\uB2E4","common":"\uADF8\uB808\uB098\uB2E4"},"nld":{"official":"Grenada","common":"Grenada"},"per":{"official":"\u06AF\u0631\u0646\u0627\u062F\u0627","common":"\u06AF\u0631\u0646\u0627\u062F\u0627"},"pol":{"official":"Grenada","common":"Grenada"},"por":{"official":"Grenada","common":"Granada"},"rus":{"official":"\u0413\u0440\u0435\u043D\u0430\u0434\u0430","common":"\u0413\u0440\u0435\u043D\u0430\u0434\u0430"},"slk":{"official":"Grenada","common":"Grenada"},"spa":{"official":"Granada","common":"Grenada"},"swe":{"official":"Grenada","common":"Grenada"},"urd":{"official":"\u06AF\u0631\u06CC\u0646\u0627\u0688\u0627","common":"\u06AF\u0631\u06CC\u0646\u0627\u0688\u0627"},"zho":{"official":"\u683C\u6797\u7EB3\u8FBE","common":"\u683C\u6797\u7EB3\u8FBE"}},"latlng":[12.11666666,-61.66666666],"landlocked":false,"borders":[],"area":344,"flag":"\uD83C\uDDEC\uD83C\uDDE9","demonyms":{"eng":{"f":"Grenadian","m":"Grenadian"},"fra":{"f":"Grenadienne","m":"Grenadien"}}},{"name":{"common":"Greenland","official":"Greenland","native":{"kal":{"official":"Kalaallit Nunaat","common":"Kalaallit Nunaat"}}},"tld":[".gl"],"cca2":"GL","ccn3":"304","cca3":"GRL","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"DKK":{"name":"krone","symbol":"kr."}},"idd":{"root":"+2","suffixes":["99"]},"capital":["Nuuk"],"altSpellings":["GL","Gr\xf8nland"],"region":"Americas","subregion":"North America","languages":{"kal":"Greenlandic"},"translations":{"ces":{"official":"Gr\xf3nsko","common":"Gr\xf3nsko"},"deu":{"official":"Gr\xf6nland","common":"Gr\xf6nland"},"est":{"official":"Gr\xf6\xf6nimaa","common":"Gr\xf6\xf6nimaa"},"fin":{"official":"Gro\xf6nlanti","common":"Gro\xf6nlanti"},"fra":{"official":"Groenland","common":"Groenland"},"hrv":{"official":"Grenland","common":"Grenland"},"hun":{"official":"Gr\xf6nland","common":"Gr\xf6nland"},"ita":{"official":"Groenlandia","common":"Groenlandia"},"jpn":{"official":"\u30B0\u30EA\u30FC\u30F3\u30E9\u30F3\u30C9","common":"\u30B0\u30EA\u30FC\u30F3\u30E9\u30F3\u30C9"},"kor":{"official":"\uADF8\uB9B0\uB780\uB4DC","common":"\uADF8\uB9B0\uB780\uB4DC"},"nld":{"official":"Groenland","common":"Groenland"},"per":{"official":"\u06AF\u0631\u0648\u0626\u0646\u0644\u0646\u062F","common":"\u06AF\u0631\u06CC\u0646\u0644\u0646\u062F"},"pol":{"official":"Grenlandia","common":"Grenlandia"},"por":{"official":"Groenl\xe2ndia","common":"Gronel\xe2ndia"},"rus":{"official":"\u0413\u0440\u0435\u043D\u043B\u0430\u043D\u0434\u0438\u044F","common":"\u0413\u0440\u0435\u043D\u043B\u0430\u043D\u0434\u0438\u044F"},"slk":{"official":"Gr\xf3nsko","common":"Gr\xf3nsko"},"spa":{"official":"Groenlandia","common":"Groenlandia"},"swe":{"official":"Gr\xf6nland","common":"Gr\xf6nland"},"urd":{"official":"\u06AF\u0631\u06CC\u0646 \u0644\u06CC\u0646\u0688","common":"\u06AF\u0631\u06CC\u0646 \u0644\u06CC\u0646\u0688"},"zho":{"official":"\u683C\u9675\u5170","common":"\u683C\u9675\u5170"}},"latlng":[72,-40],"landlocked":false,"borders":[],"area":2166086,"flag":"\uD83C\uDDEC\uD83C\uDDF1","demonyms":{"eng":{"f":"Greenlandic","m":"Greenlandic"},"fra":{"f":"Groenlandaise","m":"Groenlandais"}}},{"name":{"common":"Guatemala","official":"Republic of Guatemala","native":{"spa":{"official":"Rep\xfablica de Guatemala","common":"Guatemala"}}},"tld":[".gt"],"cca2":"GT","ccn3":"320","cca3":"GTM","cioc":"GUA","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"GTQ":{"name":"Guatemalan quetzal","symbol":"Q"}},"idd":{"root":"+5","suffixes":["02"]},"capital":["Guatemala City"],"altSpellings":["GT"],"region":"Americas","subregion":"Central America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Republika Guatemala","common":"Guatemala"},"deu":{"official":"Republik Guatemala","common":"Guatemala"},"est":{"official":"Guatemala Vabariik","common":"Guatemala"},"fin":{"official":"Guatemalan tasavalta","common":"Guatemala"},"fra":{"official":"R\xe9publique du Guatemala","common":"Guatemala"},"hrv":{"official":"Republika Gvatemala","common":"Gvatemala"},"hun":{"official":"Guatemalai K\xf6zt\xe1rsas\xe1g","common":"Guatemala"},"ita":{"official":"Repubblica del Guatemala","common":"Guatemala"},"jpn":{"official":"\u30B0\u30A2\u30C6\u30DE\u30E9\u5171\u548C\u56FD","common":"\u30B0\u30A2\u30C6\u30DE\u30E9"},"kor":{"official":"\uACFC\uD14C\uB9D0\uB77C \uACF5\uD654\uAD6D","common":"\uACFC\uD14C\uB9D0\uB77C"},"nld":{"official":"Republiek Guatemala","common":"Guatemala"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u06AF\u0648\u0627\u062A\u0650\u0645\u0627\u0644\u0627","common":"\u06AF\u0648\u0627\u062A\u0650\u0645\u0627\u0644\u0627"},"pol":{"official":"Republika Gwatemali","common":"Gwatemala"},"por":{"official":"Rep\xfablica da Guatemala","common":"Guatemala"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0413\u0432\u0430\u0442\u0435\u043C\u0430\u043B\u0430","common":"\u0413\u0432\u0430\u0442\u0435\u043C\u0430\u043B\u0430"},"slk":{"official":"Guatemalsk\xe1 republika","common":"Guatemala"},"spa":{"official":"Rep\xfablica de Guatemala","common":"Guatemala"},"swe":{"official":"Republiken Guatemala","common":"Guatemala"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06AF\u0648\u0627\u062A\u06CC\u0645\u0627\u0644\u0627","common":"\u06AF\u0648\u0627\u062A\u06CC\u0645\u0627\u0644\u0627"},"zho":{"official":"\u5371\u5730\u9A6C\u62C9\u5171\u548C\u56FD","common":"\u5371\u5730\u9A6C\u62C9"}},"latlng":[15.5,-90.25],"landlocked":false,"borders":["BLZ","SLV","HND","MEX"],"area":108889,"flag":"\uD83C\uDDEC\uD83C\uDDF9","demonyms":{"eng":{"f":"Guatemalan","m":"Guatemalan"},"fra":{"f":"Guat\xe9malt\xe8que","m":"Guat\xe9malt\xe8que"}}},{"name":{"common":"French Guiana","official":"Guiana","native":{"fra":{"official":"Guyane","common":"Guyane fran\xe7aise"}}},"tld":[".gf"],"cca2":"GF","ccn3":"254","cca3":"GUF","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+5","suffixes":["94"]},"capital":["Cayenne"],"altSpellings":["GF","Guiana","Guyane"],"region":"Americas","subregion":"South America","languages":{"fra":"French"},"translations":{"ces":{"official":"Francouzsk\xe1 Guyana","common":"Francouzsk\xe1 Guyana"},"deu":{"official":"Franz\xf6sisch-Guayana","common":"Franz\xf6sisch-Guayana"},"est":{"official":"Guajaana departemang","common":"Prantsuse Guajaana"},"fin":{"official":"Ranskan Guayana","common":"Ranskan Guayana"},"fra":{"official":"Guyane","common":"Guyane"},"hrv":{"official":"Gijana","common":"Francuska Gvajana"},"hun":{"official":"Francia Guyana","common":"Francia Guyana"},"ita":{"official":"Guiana","common":"Guyana francese"},"jpn":{"official":"\u30AE\u30A2\u30CA","common":"\u30D5\u30E9\u30F3\u30B9\u9818\u30AE\u30A2\u30CA"},"kor":{"official":"\uD504\uB791\uC2A4\uB839 \uAE30\uC544\uB098","common":"\uD504\uB791\uC2A4\uB839 \uAE30\uC544\uB098"},"nld":{"official":"Guyana","common":"Frans-Guyana"},"per":{"official":"\u06AF\u0648\u06CC\u0627\u0646 \u0641\u0631\u0627\u0646\u0633\u0647","common":"\u06AF\u0648\u06CC\u0627\u0646 \u0641\u0631\u0627\u0646\u0633\u0647"},"pol":{"official":"Gujana Francuska","common":"Gujana Francuska"},"por":{"official":"Guiana","common":"Guiana Francesa"},"rus":{"official":"\u0413\u0432\u0438\u0430\u043D\u0430","common":"\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u0441\u043A\u0430\u044F \u0413\u0432\u0438\u0430\u043D\u0430"},"slk":{"official":"Franc\xfazska Guyana","common":"Guyana"},"spa":{"official":"Guayana","common":"Guayana Francesa"},"swe":{"official":"Franska Guyana","common":"Franska Guyana"},"urd":{"official":"\u06AF\u06CC\u0627\u0646\u0627","common":"\u0641\u0631\u0627\u0646\u0633\u06CC\u0633\u06CC \u06AF\u06CC\u0627\u0646\u0627"},"zho":{"official":"\u6CD5\u5C5E\u572D\u4E9A\u90A3","common":"\u6CD5\u5C5E\u572D\u4E9A\u90A3"}},"latlng":[4,-53],"landlocked":false,"borders":["BRA","SUR"],"area":83534,"flag":"\uD83C\uDDEC\uD83C\uDDEB","demonyms":{"eng":{"f":"Guianan","m":"Guianan"},"fra":{"f":"Guyanaise","m":"Guyanais"}}},{"name":{"common":"Guam","official":"Guam","native":{"cha":{"official":"Gu\xe5h\xe5n","common":"Gu\xe5h\xe5n"},"eng":{"official":"Guam","common":"Guam"},"spa":{"official":"Guam","common":"Guam"}}},"tld":[".gu"],"cca2":"GU","ccn3":"316","cca3":"GUM","cioc":"GUM","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["671"]},"capital":["Hag\xe5t\xf1a"],"altSpellings":["GU","Gu\xe5h\xe5n"],"region":"Oceania","subregion":"Micronesia","languages":{"cha":"Chamorro","eng":"English","spa":"Spanish"},"translations":{"ces":{"official":"Guam","common":"Guam"},"deu":{"official":"Guam","common":"Guam"},"est":{"official":"Guami ala","common":"Guam"},"fin":{"official":"Guam","common":"Guam"},"fra":{"official":"Guam","common":"Guam"},"hrv":{"official":"Guam","common":"Guam"},"hun":{"official":"Guam","common":"Guam"},"ita":{"official":"Guam","common":"Guam"},"jpn":{"official":"\u30B0\u30A2\u30E0","common":"\u30B0\u30A2\u30E0"},"kor":{"official":"\uAD0C","common":"\uAD0C"},"nld":{"official":"Guam","common":"Guam"},"per":{"official":"\u06AF\u0648\u0622\u0645","common":"\u06AF\u0648\u0622\u0645"},"pol":{"official":"Terytorium Guamu","common":"Guam"},"por":{"official":"Guam","common":"Guam"},"rus":{"official":"\u0413\u0443\u0430\u043C","common":"\u0413\u0443\u0430\u043C"},"slk":{"official":"Guam","common":"Guam"},"spa":{"official":"Guam","common":"Guam"},"swe":{"official":"Guam","common":"Guam"},"urd":{"official":"\u06AF\u0648\u0627\u0645","common":"\u06AF\u0648\u0627\u0645"},"zho":{"official":"\u5173\u5C9B","common":"\u5173\u5C9B"}},"latlng":[13.46666666,144.78333333],"landlocked":false,"borders":[],"area":549,"flag":"\uD83C\uDDEC\uD83C\uDDFA","demonyms":{"eng":{"f":"Guamanian","m":"Guamanian"},"fra":{"f":"","m":""}}},{"name":{"common":"Guyana","official":"Co-operative Republic of Guyana","native":{"eng":{"official":"Co-operative Republic of Guyana","common":"Guyana"}}},"tld":[".gy"],"cca2":"GY","ccn3":"328","cca3":"GUY","cioc":"GUY","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"GYD":{"name":"Guyanese dollar","symbol":"$"}},"idd":{"root":"+5","suffixes":["92"]},"capital":["Georgetown"],"altSpellings":["GY","Co-operative Republic of Guyana"],"region":"Americas","subregion":"South America","languages":{"eng":"English"},"translations":{"ces":{"official":"Kooperativn\xed republika Guyana","common":"Guyana"},"deu":{"official":"Kooperative Republik Guyana","common":"Guyana"},"est":{"official":"Guyana Vabariik","common":"Guyana"},"fin":{"official":"Guayanan osuustoiminnallinen tasavalta","common":"Guayana"},"fra":{"official":"R\xe9publique coop\xe9rative de Guyana","common":"Guyana"},"hrv":{"official":"Zadruga Republika Gvajana","common":"Gvajana"},"hun":{"official":"Guyanai Sz\xf6vetkezeti K\xf6zt\xe1rsas\xe1g","common":"Guyana"},"ita":{"official":"Co -operative Republic of Guyana","common":"Guyana"},"jpn":{"official":"\u30AC\u30A4\u30A2\u30CA\u306E\u5354\u540C\u5171\u548C\u56FD","common":"\u30AC\u30A4\u30A2\u30CA"},"kor":{"official":"\uAC00\uC774\uC544\uB098 \uD611\uB3D9 \uACF5\uD654\uAD6D","common":"\uAC00\uC774\uC544\uB098"},"nld":{"official":"Co\xf6peratieve Republiek Guyana","common":"Guyana"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u062A\u0639\u0627\u0648\u0646\u06CC \u06AF\u0648\u06CC\u0627\u0646","common":"\u06AF\u0648\u06CC\u0627\u0646"},"pol":{"official":"Kooperacyjna Republika Gujany","common":"Gujana"},"por":{"official":"Co -operative Rep\xfablica da Guiana","common":"Guiana"},"rus":{"official":"\u041A\u043E\u043E\u043F\u0435\u0440\u0430\u0442\u0438\u0432\u043D\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0413\u0430\u0439\u0430\u043D\u0430","common":"\u0413\u0430\u0439\u0430\u043D\u0430"},"slk":{"official":"Guyansk\xe1 kooperat\xedvna republika","common":"Guyana"},"spa":{"official":"Rep\xfablica Cooperativa de Guyana","common":"Guyana"},"swe":{"official":"Kooperativa republiken Guyana","common":"Guyana"},"urd":{"official":"\u062A\u0639\u0627\u0648\u0646\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06AF\u06CC\u0627\u0646\u0627","common":"\u06AF\u06CC\u0627\u0646\u0627"},"zho":{"official":"\u572D\u4E9A\u90A3\u5171\u548C\u56FD","common":"\u572D\u4E9A\u90A3"}},"latlng":[5,-59],"landlocked":false,"borders":["BRA","SUR","VEN"],"area":214969,"flag":"\uD83C\uDDEC\uD83C\uDDFE","demonyms":{"eng":{"f":"Guyanese","m":"Guyanese"},"fra":{"f":"Guyanienne","m":"Guyanien"}}},{"name":{"common":"Hong Kong","official":"Hong Kong Special Administrative Region of the People\'s Republic of China","native":{"eng":{"official":"Hong Kong Special Administrative Region of the People\'s Republic of China","common":"Hong Kong"},"zho":{"official":"\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u9999\u6E2F\u7279\u522B\u884C\u653F\u533A","common":"\u9999\u6E2F"}}},"tld":[".hk",".\u9999\u6E2F"],"cca2":"HK","ccn3":"344","cca3":"HKG","cioc":"HKG","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"HKD":{"name":"Hong Kong dollar","symbol":"$"}},"idd":{"root":"+8","suffixes":["52"]},"capital":["City of Victoria"],"altSpellings":["HK"],"region":"Asia","subregion":"Eastern Asia","languages":{"eng":"English","zho":"Chinese"},"translations":{"ces":{"official":"Zvl\xe1\u0161tn\xed administrativn\xed oblast \u010C\xednsk\xe9 lidov\xe9 republiky Hongkong","common":"Hongkong"},"deu":{"official":"Sonderverwaltungszone Hongkong der Volksrepublik China","common":"Hongkong"},"est":{"official":"Hongkongi erihalduspiirkond","common":"Hongkong"},"fin":{"official":"Hong Kongin erityishallintoalue","common":"Hongkong"},"fra":{"official":"R\xe9gion administrative sp\xe9ciale de Hong Kong de la R\xe9publique populaire de Chine","common":"Hong Kong"},"hrv":{"official":"Hong Kong Posebnog upravnog podru\u010DjaNarodne Republike Kine","common":"Hong Kong"},"hun":{"official":"Hongkong","common":"Hongkong"},"ita":{"official":"Hong Kong Regione amministrativa speciale della Repubblica Popolare Cinese","common":"Hong Kong"},"jpn":{"official":"\u4E2D\u83EF\u4EBA\u6C11\u5171\u548C\u56FD\u9999\u6E2F\u7279\u5225\u884C\u653F\u533A","common":"\u9999\u6E2F"},"kor":{"official":"\uC911\uD654\uC778\uBBFC\uACF5\uD654\uAD6D \uD64D\uCF69 \uD2B9\uBCC4\uD589\uC815\uAD6C","common":"\uD64D\uCF69"},"nld":{"official":"Hong Kong Speciale Administratieve Regio van de Volksrepubliek China","common":"Hongkong"},"per":{"official":"\u0647\u064F\u0646\u06AF \u06A9\u064F\u0646\u06AF","common":"\u0647\u064F\u0646\u06AF \u06A9\u064F\u0646\u06AF"},"pol":{"official":"Specjalny Region Administracyjny Chi\u0144skiej Republiki Ludowej Hongkong","common":"Hongkong"},"por":{"official":"Hong Kong Regi\xe3o Administrativa Especial da Rep\xfablica Popular da China","common":"Hong Kong"},"rus":{"official":"Hong Kong \u0421\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u0438\u0432\u043D\u044B\u0439 \u0440\u0430\u0439\u043E\u043D \u041A\u0438\u0442\u0430\u0439\u0441\u043A\u043E\u0439 \u041D\u0430\u0440\u043E\u0434\u043D\u043E\u0439 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0438 \u041A\u0438\u0442\u0430\u044F","common":"\u0413\u043E\u043D\u043A\u043E\u043D\u0433"},"slk":{"official":"\u0160peci\xe1lna administrat\xedvna oblas\u0165\u010C\xednskej \u013Eudovej republiky Hongkong","common":"Hongkong"},"spa":{"official":"Hong Kong Regi\xf3n Administrativa Especial de la Rep\xfablica Popular China","common":"Hong Kong"},"swe":{"official":"Hongkong","common":"Hongkong"},"urd":{"official":"\u06C1\u0627\u0646\u06AF \u06A9\u0627\u0646\u06AF \u0639\u0648\u0627\u0645\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0686\u06CC\u0646 \u06A9\u0627 \u062E\u0635\u0648\u0635\u06CC \u0627\u0646\u062A\u0638\u0627\u0645\u06CC \u0639\u0644\u0627\u0642\u06C1","common":"\u06C1\u0627\u0646\u06AF \u06A9\u0627\u0646\u06AF"}},"latlng":[22.267,114.188],"landlocked":false,"borders":["CHN"],"area":1104,"flag":"\uD83C\uDDED\uD83C\uDDF0","demonyms":{"eng":{"f":"Hong Konger","m":"Hong Konger"},"fra":{"f":"Hongkongaise","m":"Hongkongais"}}},{"name":{"common":"Heard Island and McDonald Islands","official":"Heard Island and McDonald Islands","native":{"eng":{"official":"Heard Island and McDonald Islands","common":"Heard Island and McDonald Islands"}}},"tld":[".hm",".aq"],"cca2":"HM","ccn3":"334","cca3":"HMD","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{},"idd":{"root":"","suffixes":[]},"capital":[],"altSpellings":["HM","Heard Island and McDonald Islands"],"region":"Antarctic","subregion":"","languages":{"eng":"English"},"translations":{"ces":{"official":"Heard\u016Fv ostrov a McDonaldovy ostrovy","common":"Heard\u016Fv ostrov a McDonaldovy ostrovy"},"deu":{"official":"Heard und McDonaldinseln","common":"Heard und die McDonaldinseln"},"est":{"official":"Heardi ja McDonaldi saarte ala","common":"Heard ja McDonald"},"fin":{"official":"Heard ja McDonaldinsaaret","common":"Heard ja McDonaldinsaaret"},"fra":{"official":"\xceles Heard-et-MacDonald","common":"\xceles Heard-et-MacDonald"},"hrv":{"official":"Otok Heard i oto\u010Dje McDonald","common":"Otok Heard i oto\u010Dje McDonald"},"hun":{"official":"Heard-sziget \xe9s McDonald-szigetek","common":"Heard-sziget \xe9s McDonald-szigetek"},"ita":{"official":"Isole Heard e McDonald","common":"Isole Heard e McDonald"},"jpn":{"official":"\u30CF\u30FC\u30C9\u5CF6\u3068\u30DE\u30AF\u30C9\u30CA\u30EB\u30C9\u8AF8\u5CF6","common":"\u30CF\u30FC\u30C9\u5CF6\u3068\u30DE\u30AF\u30C9\u30CA\u30EB\u30C9\u8AF8\u5CF6"},"kor":{"official":"\uD5C8\uB4DC \uB9E5\uB3C4\uB110\uB4DC \uC81C\uB3C4","common":"\uD5C8\uB4DC \uB9E5\uB3C4\uB110\uB4DC \uC81C\uB3C4"},"nld":{"official":"Heard en McDonaldeilanden","common":"Heard-en McDonaldeilanden"},"per":{"official":"\u062C\u0632\u06CC\u0631\u0647 \u0647\u0631\u062F \u0648 \u062C\u0632\u0627\u06CC\u0631 \u0645\u06A9\u200C\u062F\u0648\u0646\u0627\u0644\u062F","common":"\u062C\u0632\u06CC\u0631\u0647 \u0647\u0631\u062F \u0648 \u062C\u0632\u0627\u06CC\u0631 \u0645\u06A9\u200C\u062F\u0648\u0646\u0627\u0644\u062F"},"pol":{"official":"Terytorium Wysp Heard i McDonalda","common":"Wyspy Heard i McDonalda"},"por":{"official":"Ilha Heard e Ilhas McDonald","common":"Ilha Heard e Ilhas McDonald"},"rus":{"official":"\u041E\u0441\u0442\u0440\u043E\u0432 \u0425\u0435\u0440\u0434 \u0438 \u043E\u0441\u0442\u0440\u043E\u0432\u0430 \u041C\u0430\u043A\u0434\u043E\u043D\u0430\u043B\u044C\u0434","common":"\u041E\u0441\u0442\u0440\u043E\u0432 \u0425\u0435\u0440\u0434 \u0438 \u043E\u0441\u0442\u0440\u043E\u0432\u0430 \u041C\u0430\u043A\u0434\u043E\u043D\u0430\u043B\u044C\u0434"},"slk":{"official":"Terit\xf3rium Heardovho ostrova a Macdonaldov\xfdch ostrovov","common":"Heardov ostrov"},"spa":{"official":"Islas Heard y McDonald","common":"Islas Heard y McDonald"},"swe":{"official":"Heard- och McDonald\xf6arna","common":"Heard- och McDonald\xf6arna"},"urd":{"official":"\u062C\u0632\u06CC\u0631\u06C1 \u06C1\u0631\u0688 \u0648 \u062C\u0632\u0627\u0626\u0631 \u0645\u06A9\u0688\u0648\u0646\u0644\u0688","common":"\u062C\u0632\u06CC\u0631\u06C1 \u06C1\u0631\u0688 \u0648 \u062C\u0632\u0627\u0626\u0631 \u0645\u06A9\u0688\u0648\u0646\u0644\u0688"},"zho":{"official":"\u8D6B\u5FB7\u5C9B\u548C\u9EA6\u5F53\u52B3\u7FA4\u5C9B","common":"\u8D6B\u5FB7\u5C9B\u548C\u9EA6\u5F53\u52B3\u7FA4\u5C9B"}},"latlng":[-53.1,72.51666666],"landlocked":false,"borders":[],"area":412,"flag":"\uD83C\uDDED\uD83C\uDDF2","demonyms":{"eng":{"f":"Heard and McDonald Islander","m":"Heard and McDonald Islander"},"fra":{"f":"","m":""}}},{"name":{"common":"Honduras","official":"Republic of Honduras","native":{"spa":{"official":"Rep\xfablica de Honduras","common":"Honduras"}}},"tld":[".hn"],"cca2":"HN","ccn3":"340","cca3":"HND","cioc":"HON","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"HNL":{"name":"Honduran lempira","symbol":"L"}},"idd":{"root":"+5","suffixes":["04"]},"capital":["Tegucigalpa"],"altSpellings":["HN","Republic of Honduras","Rep\xfablica de Honduras"],"region":"Americas","subregion":"Central America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Hondurask\xe1 republika","common":"Honduras"},"deu":{"official":"Republik Honduras","common":"Honduras"},"est":{"official":"Hondurase Vabariik","common":"Honduras"},"fin":{"official":"Hondurasin tasavalta","common":"Honduras"},"fra":{"official":"R\xe9publique du Honduras","common":"Honduras"},"hrv":{"official":"Republika Honduras","common":"Honduras"},"hun":{"official":"Hondurasi K\xf6zt\xe1rsas\xe1g","common":"Honduras"},"ita":{"official":"Repubblica di Honduras","common":"Honduras"},"jpn":{"official":"\u30DB\u30F3\u30B8\u30E5\u30E9\u30B9\u5171\u548C\u56FD","common":"\u30DB\u30F3\u30B8\u30E5\u30E9\u30B9"},"kor":{"official":"\uC628\uB450\uB77C\uC2A4 \uACF5\uD654\uAD6D","common":"\uC628\uB450\uB77C\uC2A4"},"nld":{"official":"Republiek Honduras","common":"Honduras"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0647\u0646\u062F\u0648\u0631\u0627\u0633","common":"\u0647\u064F\u0646\u062F\u0648\u0631\u0627\u0633"},"pol":{"official":"Republika Hondurasu","common":"Honduras"},"por":{"official":"Rep\xfablica de Honduras","common":"Honduras"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0413\u043E\u043D\u0434\u0443\u0440\u0430\u0441","common":"\u0413\u043E\u043D\u0434\u0443\u0440\u0430\u0441"},"slk":{"official":"Hondurask\xe1 republika","common":"Honduras"},"spa":{"official":"Rep\xfablica de Honduras","common":"Honduras"},"swe":{"official":"Republiken Honduras","common":"Honduras"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06C1\u0648\u0646\u0688\u0648\u0631\u0627\u0633","common":"\u06C1\u0648\u0646\u0688\u0648\u0631\u0627\u0633"},"zho":{"official":"\u6D2A\u90FD\u62C9\u65AF\u5171\u548C\u56FD","common":"\u6D2A\u90FD\u62C9\u65AF"}},"latlng":[15,-86.5],"landlocked":false,"borders":["GTM","SLV","NIC"],"area":112492,"flag":"\uD83C\uDDED\uD83C\uDDF3","demonyms":{"eng":{"f":"Honduran","m":"Honduran"},"fra":{"f":"Hondurienne","m":"Hondurien"}}},{"name":{"common":"Croatia","official":"Republic of Croatia","native":{"hrv":{"official":"Republika Hrvatska","common":"Hrvatska"}}},"tld":[".hr"],"cca2":"HR","ccn3":"191","cca3":"HRV","cioc":"CRO","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["85"]},"capital":["Zagreb"],"altSpellings":["HR","Hrvatska","Republic of Croatia","Republika Hrvatska"],"region":"Europe","subregion":"Southeast Europe","languages":{"hrv":"Croatian"},"translations":{"ces":{"official":"Chorvatsk\xe1 republika","common":"Chorvatsko"},"cym":{"official":"Gweriniaeth Croatia","common":"Croatia"},"deu":{"official":"Republik Kroatien","common":"Kroatien"},"est":{"official":"Horvaatia Vabariik","common":"Horvaatia"},"fin":{"official":"Kroatian tasavalta","common":"Kroatia"},"fra":{"official":"R\xe9publique de Croatie","common":"Croatie"},"hrv":{"official":"Republika Hrvatska","common":"Hrvatska"},"hun":{"official":"Horv\xe1t K\xf6zt\xe1rsas\xe1g","common":"Horv\xe1torsz\xe1g"},"ita":{"official":"Repubblica di Croazia","common":"Croazia"},"jpn":{"official":"\u30AF\u30ED\u30A2\u30C1\u30A2\u5171\u548C\u56FD","common":"\u30AF\u30ED\u30A2\u30C1\u30A2"},"kor":{"official":"\uD06C\uB85C\uC544\uD2F0\uC544 \uACF5\uD654\uAD6D","common":"\uD06C\uB85C\uC544\uD2F0\uC544"},"nld":{"official":"Republiek Kroati\xeb","common":"Kroati\xeb"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u06A9\u0631\u0648\u0627\u0633\u06CC","common":"\u06A9\u0631\u064F\u0648\u0627\u0633\u06CC"},"pol":{"official":"Republika Chorwacji","common":"Chorwacja"},"por":{"official":"Rep\xfablica da Cro\xe1cia","common":"Cro\xe1cia"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0425\u043E\u0440\u0432\u0430\u0442\u0438\u044F","common":"\u0425\u043E\u0440\u0432\u0430\u0442\u0438\u044F"},"slk":{"official":"Chorv\xe1tska republika","common":"Chorv\xe1tsko"},"spa":{"official":"Rep\xfablica de Croacia","common":"Croacia"},"swe":{"official":"Republiken Kroatien","common":"Kroatien"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06A9\u0631\u0648\u06CC\u0626\u0634\u0627","common":"\u06A9\u0631\u0648\u06CC\u0626\u0634\u0627"},"zho":{"official":"\u514B\u7F57\u5730\u4E9A\u5171\u548C\u56FD","common":"\u514B\u7F57\u5730\u4E9A"}},"latlng":[45.16666666,15.5],"landlocked":false,"borders":["BIH","HUN","MNE","SRB","SVN"],"area":56594,"flag":"\uD83C\uDDED\uD83C\uDDF7","demonyms":{"eng":{"f":"Croatian","m":"Croatian"},"fra":{"f":"Croate","m":"Croate"}}},{"name":{"common":"Haiti","official":"Republic of Haiti","native":{"fra":{"official":"R\xe9publique d\'Ha\xefti","common":"Ha\xefti"},"hat":{"official":"Repiblik Ayiti","common":"Ayiti"}}},"tld":[".ht"],"cca2":"HT","ccn3":"332","cca3":"HTI","cioc":"HAI","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"HTG":{"name":"Haitian gourde","symbol":"G"}},"idd":{"root":"+5","suffixes":["09"]},"capital":["Port-au-Prince"],"altSpellings":["HT","Republic of Haiti","R\xe9publique d\'Ha\xefti","Repiblik Ayiti"],"region":"Americas","subregion":"Caribbean","languages":{"fra":"French","hat":"Haitian Creole"},"translations":{"ces":{"official":"Republika Haiti","common":"Haiti"},"deu":{"official":"Republik Haiti","common":"Haiti"},"est":{"official":"Haiti Vabariik","common":"Haiti"},"fin":{"official":"Haitin tasavalta","common":"Haiti"},"fra":{"official":"R\xe9publique d\'Ha\xefti","common":"Ha\xefti"},"hrv":{"official":"Republika Haiti","common":"Haiti"},"hun":{"official":"Haiti K\xf6zt\xe1rsas\xe1g","common":"Haiti"},"ita":{"official":"Repubblica di Haiti","common":"Haiti"},"jpn":{"official":"\u30CF\u30A4\u30C1\u5171\u548C\u56FD","common":"\u30CF\u30A4\u30C1"},"kor":{"official":"\uC544\uC774\uD2F0 \uACF5\uD654\uAD6D","common":"\uC544\uC774\uD2F0"},"nld":{"official":"Republiek Ha\xefti","common":"Ha\xefti"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0647\u0627\u0626\u06CC\u062A\u06CC","common":"\u0647\u0627\u0626\u06CC\u062A\u06CC"},"pol":{"official":"Republika Haiti","common":"Haiti"},"por":{"official":"Rep\xfablica do Haiti","common":"Haiti"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0413\u0430\u0438\u0442\u0438","common":"\u0413\u0430\u0438\u0442\u0438"},"slk":{"official":"Haitsk\xe1 republika","common":"Haiti"},"spa":{"official":"Rep\xfablica de Hait\xed","common":"Hait\xed"},"swe":{"official":"Republiken Haiti","common":"Haiti"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06C1\u06CC\u0679\u06CC","common":"\u06C1\u06CC\u0679\u06CC"},"zho":{"official":"\u6D77\u5730\u5171\u548C\u56FD","common":"\u6D77\u5730"}},"latlng":[19,-72.41666666],"landlocked":false,"borders":["DOM"],"area":27750,"flag":"\uD83C\uDDED\uD83C\uDDF9","demonyms":{"eng":{"f":"Haitian","m":"Haitian"},"fra":{"f":"Ha\xeftienne","m":"Ha\xeftien"}}},{"name":{"common":"Hungary","official":"Hungary","native":{"hun":{"official":"Magyarorsz\xe1g","common":"Magyarorsz\xe1g"}}},"tld":[".hu"],"cca2":"HU","ccn3":"348","cca3":"HUN","cioc":"HUN","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"HUF":{"name":"Hungarian forint","symbol":"Ft"}},"idd":{"root":"+3","suffixes":["6"]},"capital":["Budapest"],"altSpellings":["HU"],"region":"Europe","subregion":"Central Europe","languages":{"hun":"Hungarian"},"translations":{"ces":{"official":"Ma\u010Farsko","common":"Ma\u010Farsko"},"deu":{"official":"Ungarn","common":"Ungarn"},"est":{"official":"Ungari","common":"Ungari"},"fin":{"official":"Unkari","common":"Unkari"},"fra":{"official":"Hongrie","common":"Hongrie"},"hrv":{"official":"Mad\u017Earska","common":"Ma\u0111arska"},"hun":{"official":"Magyarorsz\xe1g","common":"Magyarorsz\xe1g"},"ita":{"official":"Ungheria","common":"Ungheria"},"jpn":{"official":"\u30CF\u30F3\u30AC\u30EA\u30FC","common":"\u30CF\u30F3\u30AC\u30EA\u30FC"},"kor":{"official":"\uD5DD\uAC00\uB9AC","common":"\uD5DD\uAC00\uB9AC"},"nld":{"official":"Hongarije","common":"Hongarije"},"per":{"official":"\u0645\u062C\u0627\u0631\u0633\u062A\u0627\u0646","common":"\u0645\u062C\u0627\u0631\u0633\u062A\u0627\u0646"},"pol":{"official":"W\u0119gry","common":"W\u0119gry"},"por":{"official":"Hungria","common":"Hungria"},"rus":{"official":"\u0412\u0435\u043D\u0433\u0440\u0438\u044F","common":"\u0412\u0435\u043D\u0433\u0440\u0438\u044F"},"slk":{"official":"Ma\u010Farsko","common":"Ma\u010Farsko"},"spa":{"official":"Hungr\xeda","common":"Hungr\xeda"},"swe":{"official":"Ungern","common":"Ungern"},"urd":{"official":"\u0645\u062C\u0627\u0631\u0633\u062A\u0627\u0646","common":"\u0645\u062C\u0627\u0631\u0633\u062A\u0627\u0646"},"zho":{"official":"\u5308\u7259\u5229","common":"\u5308\u7259\u5229"}},"latlng":[47,20],"landlocked":true,"borders":["AUT","HRV","ROU","SRB","SVK","SVN","UKR"],"area":93028,"flag":"\uD83C\uDDED\uD83C\uDDFA","demonyms":{"eng":{"f":"Hungarian","m":"Hungarian"},"fra":{"f":"Hongroise","m":"Hongrois"}}},{"name":{"common":"Indonesia","official":"Republic of Indonesia","native":{"ind":{"official":"Republik Indonesia","common":"Indonesia"}}},"tld":[".id"],"cca2":"ID","ccn3":"360","cca3":"IDN","cioc":"INA","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"IDR":{"name":"Indonesian rupiah","symbol":"Rp"}},"idd":{"root":"+6","suffixes":["2"]},"capital":["Jakarta"],"altSpellings":["ID","Republic of Indonesia","Republik Indonesia"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"ind":"Indonesian"},"translations":{"ces":{"official":"Indon\xe9sk\xe1 republika","common":"Indon\xe9sie"},"deu":{"official":"Republik Indonesien","common":"Indonesien"},"est":{"official":"Indoneesia Vabariik","common":"Indoneesia"},"fin":{"official":"Indonesian tasavalta","common":"Indonesia"},"fra":{"official":"R\xe9publique d\'Indon\xe9sie","common":"Indon\xe9sie"},"hrv":{"official":"Republika Indonezija","common":"Indonezija"},"hun":{"official":"Indon\xe9z K\xf6zt\xe1rsas\xe1g","common":"Indon\xe9zia"},"ita":{"official":"Repubblica di Indonesia","common":"Indonesia"},"jpn":{"official":"\u30A4\u30F3\u30C9\u30CD\u30B7\u30A2\u5171\u548C\u56FD","common":"\u30A4\u30F3\u30C9\u30CD\u30B7\u30A2"},"kor":{"official":"\uC778\uB3C4\uB124\uC2DC\uC544 \uACF5\uD654\uAD6D","common":"\uC778\uB3C4\uB124\uC2DC\uC544"},"nld":{"official":"Republiek Indonesi\xeb","common":"Indonesi\xeb"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0646\u062F\u0648\u0646\u0632\u06CC","common":"\u0627\u0646\u062F\u0648\u0646\u0632\u06CC"},"pol":{"official":"Republika Indonezji","common":"Indonezja"},"por":{"official":"Rep\xfablica da Indon\xe9sia","common":"Indon\xe9sia"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0418\u043D\u0434\u043E\u043D\u0435\u0437\u0438\u044F","common":"\u0418\u043D\u0434\u043E\u043D\u0435\u0437\u0438\u044F"},"slk":{"official":"Indon\xe9zska republika","common":"Indon\xe9zia"},"spa":{"official":"Rep\xfablica de Indonesia","common":"Indonesia"},"swe":{"official":"Republiken Indonesien","common":"Indonesien"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0627\u0646\u0688\u0648\u0646\u06CC\u0634\u06CC\u0627","common":"\u0627\u0646\u0688\u0648\u0646\u06CC\u0634\u06CC\u0627"},"zho":{"official":"\u5370\u5EA6\u5C3C\u897F\u4E9A\u5171\u548C\u56FD","common":"\u5370\u5EA6\u5C3C\u897F\u4E9A"}},"latlng":[-5,120],"landlocked":false,"borders":["TLS","MYS","PNG"],"area":1904569,"flag":"\uD83C\uDDEE\uD83C\uDDE9","demonyms":{"eng":{"f":"Indonesian","m":"Indonesian"},"fra":{"f":"Indon\xe9sienne","m":"Indon\xe9sien"}}},{"name":{"common":"Isle of Man","official":"Isle of Man","native":{"eng":{"official":"Isle of Man","common":"Isle of Man"},"glv":{"official":"Ellan Vannin or Mannin","common":"Mannin"}}},"tld":[".im"],"cca2":"IM","ccn3":"833","cca3":"IMN","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"GBP":{"name":"British pound","symbol":"\xa3"},"IMP":{"name":"Manx pound","symbol":"\xa3"}},"idd":{"root":"+4","suffixes":["4"]},"capital":["Douglas"],"altSpellings":["IM","Ellan Vannin","Mann","Mannin"],"region":"Europe","subregion":"Northern Europe","languages":{"eng":"English","glv":"Manx"},"translations":{"ces":{"official":"Ostrov Man","common":"Ostrov Man"},"deu":{"official":"Isle of Man","common":"Insel Man"},"est":{"official":"Mani saar","common":"Mani saar"},"fin":{"official":"Mansaari","common":"Mansaari"},"fra":{"official":"Isle of Man","common":"\xcele de Man"},"hrv":{"official":"Mana ostrvo","common":"Otok Man"},"hun":{"official":"Man","common":"Man"},"ita":{"official":"Isola di Man","common":"Isola di Man"},"jpn":{"official":"\u30DE\u30F3\u5CF6","common":"\u30DE\u30F3\u5CF6"},"kor":{"official":"\uB9E8\uC12C","common":"\uB9E8\uC12C"},"nld":{"official":"Isle of Man","common":"Isle of Man"},"per":{"official":"\u062C\u0632\u06CC\u0631\u0647\u0654 \u0645\u064E\u0646","common":"\u062C\u0632\u06CC\u0631\u0647\u0654 \u0645\u064E\u0646"},"pol":{"official":"Wyspa Man","common":"Wyspa Man"},"por":{"official":"Isle of Man","common":"Ilha de Man"},"rus":{"official":"\u041E\u0441\u0442\u0440\u043E\u0432 \u041C\u044D\u043D","common":"\u041E\u0441\u0442\u0440\u043E\u0432 \u041C\u044D\u043D"},"slk":{"official":"Ostrov Man","common":"Man"},"spa":{"official":"Isla de Man","common":"Isla de Man"},"swe":{"official":"Isle of Man","common":"Isle of Man"},"urd":{"official":"\u0622\u0626\u0644 \u0622\u0641 \u0645\u06CC\u0646","common":"\u0622\u0626\u0644 \u0622\u0641 \u0645\u06CC\u0646"},"zho":{"official":"\u9A6C\u6069\u5C9B","common":"\u9A6C\u6069\u5C9B"}},"latlng":[54.25,-4.5],"landlocked":false,"borders":[],"area":572,"flag":"\uD83C\uDDEE\uD83C\uDDF2","demonyms":{"eng":{"f":"Manx","m":"Manx"},"fra":{"f":"","m":""}}},{"name":{"common":"India","official":"Republic of India","native":{"eng":{"official":"Republic of India","common":"India"},"hin":{"official":"\u092D\u093E\u0930\u0924 \u0917\u0923\u0930\u093E\u091C\u094D\u092F","common":"\u092D\u093E\u0930\u0924"},"tam":{"official":"\u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0B95\u0BCD \u0B95\u0BC1\u0B9F\u0BBF\u0BAF\u0BB0\u0B9A\u0BC1","common":"\u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0BBE"}}},"tld":[".in"],"cca2":"IN","ccn3":"356","cca3":"IND","cioc":"IND","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"INR":{"name":"Indian rupee","symbol":"\u20B9"}},"idd":{"root":"+9","suffixes":["1"]},"capital":["New Delhi"],"altSpellings":["IN","Bh\u0101rat","Republic of India","Bharat Ganrajya","\u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0BBE"],"region":"Asia","subregion":"Southern Asia","languages":{"eng":"English","hin":"Hindi","tam":"Tamil"},"translations":{"ces":{"official":"Indick\xe1 republika","common":"Indie"},"deu":{"official":"Republik Indien","common":"Indien"},"est":{"official":"India Vabariik","common":"India"},"fin":{"official":"Intian tasavalta","common":"Intia"},"fra":{"official":"R\xe9publique de l\'Inde","common":"Inde"},"hrv":{"official":"Republika Indija","common":"Indija"},"hun":{"official":"Indiai K\xf6zt\xe1rsas\xe1g","common":"India"},"ita":{"official":"Repubblica dell\'India","common":"India"},"jpn":{"official":"\u30A4\u30F3\u30C9\u5171\u548C\u56FD","common":"\u30A4\u30F3\u30C9"},"kor":{"official":"\uC778\uB3C4 \uACF5\uD654\uAD6D","common":"\uC778\uB3C4"},"nld":{"official":"Republiek India","common":"India"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0647\u0646\u062F\u0648\u0633\u062A\u0627\u0646","common":"\u0647\u0646\u062F"},"pol":{"official":"Republika Indii","common":"Indie"},"por":{"official":"Rep\xfablica da \xcdndia","common":"\xcdndia"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0418\u043D\u0434\u0438\u044F","common":"\u0418\u043D\u0434\u0438\u044F"},"slk":{"official":"Indick\xe1 republika","common":"India"},"spa":{"official":"Rep\xfablica de la India","common":"India"},"swe":{"official":"Republiken Indien","common":"Indien"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0628\u06BE\u0627\u0631\u062A","common":"\u0628\u06BE\u0627\u0631\u062A"},"zho":{"official":"\u5370\u5EA6\u5171\u548C\u56FD","common":"\u5370\u5EA6"}},"latlng":[20,77],"landlocked":false,"borders":["BGD","BTN","MMR","CHN","NPL","PAK"],"area":3287590,"flag":"\uD83C\uDDEE\uD83C\uDDF3","demonyms":{"eng":{"f":"Indian","m":"Indian"},"fra":{"f":"Indienne","m":"Indien"}}},{"name":{"common":"British Indian Ocean Territory","official":"British Indian Ocean Territory","native":{"eng":{"official":"British Indian Ocean Territory","common":"British Indian Ocean Territory"}}},"tld":[".io"],"cca2":"IO","ccn3":"086","cca3":"IOT","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+2","suffixes":["46"]},"capital":["Diego Garcia"],"altSpellings":["IO"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English"},"translations":{"ces":{"official":"Britsk\xe9 indickooce\xe1nsk\xe9 \xfazem\xed","common":"Britsk\xe9 indickooce\xe1nsk\xe9 \xfazem\xed"},"cym":{"official":"Tiriogaeth Brydeinig Cefnfor India","common":"Tiriogaeth Brydeinig Cefnfor India"},"deu":{"official":"Britisches Territorium im Indischen Ozean","common":"Britisches Territorium im Indischen Ozean"},"est":{"official":"Briti India ookeani ala","common":"Briti India ookeani ala"},"fin":{"official":"Brittil\xe4inen Intian valtameren alue","common":"Brittil\xe4inen Intian valtameren alue"},"fra":{"official":"Territoire britannique de l\' oc\xe9an Indien","common":"Territoire britannique de l\'oc\xe9an Indien"},"hrv":{"official":"British Indian Ocean Territory","common":"Britanski Indijskooceanski teritorij"},"hun":{"official":"Brit Indiai-\xf3ce\xe1ni Ter\xfclet","common":"Brit Indiai-\xf3ce\xe1ni Ter\xfclet"},"ita":{"official":"Territorio britannico dell\'Oceano Indiano","common":"Territorio britannico dell\'oceano indiano"},"jpn":{"official":"\u30A4\u30AE\u30EA\u30B9\u9818\u30A4\u30F3\u30C9\u6D0B\u5730\u57DF","common":"\u30A4\u30AE\u30EA\u30B9\u9818\u30A4\u30F3\u30C9\u6D0B\u5730\u57DF"},"kor":{"official":"\uC778\uB3C4 \uACF5\uD654\uAD6D","common":"\uC778\uB3C4"},"nld":{"official":"Brits Indische Oceaan Territorium","common":"Britse Gebieden in de Indische Oceaan"},"per":{"official":"\u0642\u0644\u0645\u0631\u0648 \u0628\u0631\u06CC\u062A\u0627\u0646\u06CC\u0627 \u062F\u0631 \u0627\u0642\u06CC\u0627\u0646\u0648\u0633 \u0647\u0646\u062F","common":"\u0642\u0644\u0645\u0631\u0648 \u0628\u0631\u06CC\u062A\u0627\u0646\u06CC\u0627 \u062F\u0631 \u0627\u0642\u06CC\u0627\u0646\u0648\u0633 \u0647\u0646\u062F"},"pol":{"official":"Brytyjskie Terytorium Oceanu Indyjskiego","common":"Brytyjskie Terytorium Oceanu Indyjskiego"},"por":{"official":"British Indian Ocean Territory","common":"Territ\xf3rio Brit\xe2nico do Oceano \xcdndico"},"rus":{"official":"\u0411\u0440\u0438\u0442\u0430\u043D\u0441\u043A\u0430\u044F \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044F \u0418\u043D\u0434\u0438\u0439\u0441\u043A\u043E\u0433\u043E \u043E\u043A\u0435\u0430\u043D\u0430","common":"\u0411\u0440\u0438\u0442\u0430\u043D\u0441\u043A\u0430\u044F \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044F \u0432 \u0418\u043D\u0434\u0438\u0439\u0441\u043A\u043E\u043C \u043E\u043A\u0435\u0430\u043D\u0435"},"slk":{"official":"Britsk\xe9 indickooce\xe1nske \xfazemie","common":"Britsk\xe9 indickooce\xe1nske \xfazemie"},"spa":{"official":"Territorio Brit\xe1nico del Oc\xe9ano \xcdndico","common":"Territorio Brit\xe1nico del Oc\xe9ano \xcdndico"},"swe":{"official":"Brittiska territoriet i Indiska Oceanen","common":"Brittiska territoriet i Indiska Oceanen"},"urd":{"official":"\u0628\u0631\u0637\u0627\u0646\u0648\u06CC \u0628\u062D\u0631\u06C1\u0646\u062F \u062E\u0637\u06C1","common":"\u0628\u0631\u0637\u0627\u0646\u0648\u06CC \u0628\u062D\u0631\u06C1\u0646\u062F \u062E\u0637\u06C1"},"zho":{"official":"\u82F1\u5C5E\u5370\u5EA6\u6D0B\u9886\u5730","common":"\u82F1\u5C5E\u5370\u5EA6\u6D0B\u9886\u5730"}},"latlng":[-6,71.5],"landlocked":false,"borders":[],"area":60,"flag":"\uD83C\uDDEE\uD83C\uDDF4","demonyms":{"eng":{"f":"Indian","m":"Indian"},"fra":{"f":"","m":""}}},{"name":{"common":"Ireland","official":"Republic of Ireland","native":{"eng":{"official":"Republic of Ireland","common":"Ireland"},"gle":{"official":"Poblacht na h\xc9ireann","common":"\xc9ire"}}},"tld":[".ie"],"cca2":"IE","ccn3":"372","cca3":"IRL","cioc":"IRL","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["53"]},"capital":["Dublin"],"altSpellings":["IE","\xc9ire","Republic of Ireland","Poblacht na h\xc9ireann"],"region":"Europe","subregion":"Northern Europe","languages":{"eng":"English","gle":"Irish"},"translations":{"ces":{"official":"Irsko","common":"Irsko"},"deu":{"official":"Republik Irland","common":"Irland"},"est":{"official":"Iirimaa","common":"Iirimaa"},"fin":{"official":"Irlannin tasavalta","common":"Irlanti"},"fra":{"official":"R\xe9publique d\'Irlande","common":"Irlande"},"hrv":{"official":"Republika Irska","common":"Irska"},"hun":{"official":"\xcdr K\xf6zt\xe1rsas\xe1g","common":"\xcdrorsz\xe1g"},"ita":{"official":"Repubblica d\'Irlanda","common":"Irlanda"},"jpn":{"official":"\u30A2\u30A4\u30EB\u30E9\u30F3\u30C9\u5171\u548C\u56FD","common":"\u30A2\u30A4\u30EB\u30E9\u30F3\u30C9"},"kor":{"official":"\uC544\uC77C\uB79C\uB4DC \uACF5\uD654\uAD6D","common":"\uC544\uC77C\uB79C\uB4DC"},"nld":{"official":"Republic of Ireland","common":"Ierland"},"per":{"official":"\u0627\u06CC\u0631\u0644\u0646\u062F","common":"\u0627\u06CC\u0631\u0644\u0646\u062F"},"pol":{"official":"Republika Irlandii","common":"Irlandia"},"por":{"official":"Rep\xfablica da Irlanda","common":"Irlanda"},"rus":{"official":"\u0418\u0440\u043B\u0430\u043D\u0434\u0438\u044F","common":"\u0418\u0440\u043B\u0430\u043D\u0434\u0438\u044F"},"slk":{"official":"\xcdrska republika","common":"\xcdrsko"},"spa":{"official":"Rep\xfablica de Irlanda","common":"Irlanda"},"swe":{"official":"Irland","common":"Irland"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u062C\u0632\u06CC\u0631\u06C1 \u0622\u0626\u0631\u0644\u06CC\u0646\u0688","common":"\u062C\u0632\u06CC\u0631\u06C1 \u0622\u0626\u0631\u0644\u06CC\u0646\u0688"},"zho":{"official":"\u7231\u5C14\u5170\u5171\u548C\u56FD","common":"\u7231\u5C14\u5170"}},"latlng":[53,-8],"landlocked":false,"borders":["GBR"],"area":70273,"flag":"\uD83C\uDDEE\uD83C\uDDEA","demonyms":{"eng":{"f":"Irish","m":"Irish"},"fra":{"f":"Irlandaise","m":"Irlandais"}}},{"name":{"common":"Iran","official":"Islamic Republic of Iran","native":{"fas":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0633\u0644\u0627\u0645\u06CC \u0627\u06CC\u0631\u0627\u0646","common":"\u0627\u06CC\u0631\u0627\u0646"}}},"tld":[".ir","\u0627\u06CC\u0631\u0627\u0646."],"cca2":"IR","ccn3":"364","cca3":"IRN","cioc":"IRI","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"IRR":{"name":"Iranian rial","symbol":"\uFDFC"}},"idd":{"root":"+9","suffixes":["8"]},"capital":["Tehran"],"altSpellings":["IR","Islamic Republic of Iran","Iran, Islamic Republic of","Jomhuri-ye Esl\u0101mi-ye Ir\u0101n"],"region":"Asia","subregion":"Southern Asia","languages":{"fas":"Persian (Farsi)"},"translations":{"ces":{"official":"Isl\xe1msk\xe1 republika \xcdr\xe1n","common":"\xcdr\xe1n"},"deu":{"official":"Islamische Republik Iran","common":"Iran"},"est":{"official":"Iraani Islamivabariik","common":"Iraan"},"fin":{"official":"Iranin islamilainen tasavalta","common":"Iran"},"fra":{"official":"R\xe9publique islamique d\'Iran","common":"Iran"},"hrv":{"official":"Islamska Republika Iran","common":"Iran"},"hun":{"official":"Ir\xe1ni Iszl\xe1m K\xf6zt\xe1rsas\xe1g","common":"Ir\xe1n"},"ita":{"official":"Repubblica islamica dell\'Iran","common":"Iran"},"jpn":{"official":"\u30A4\u30E9\u30F3\xb7\u30A4\u30B9\u30E9\u30E0\u5171\u548C\u56FD","common":"\u30A4\u30E9\u30F3\u30FB\u30A4\u30B9\u30E9\u30E0\u5171\u548C\u56FD"},"kor":{"official":"\uC774\uB780 \uC774\uC2AC\uB78C \uACF5\uD654\uAD6D","common":"\uC774\uB780"},"nld":{"official":"Islamitische Republiek Iran","common":"Iran"},"pol":{"official":"Islamska Republika Iranu","common":"Iran"},"por":{"official":"Rep\xfablica Isl\xe2mica do Ir\xe3","common":"Ir\xe3o"},"rus":{"official":"\u0418\u0441\u043B\u0430\u043C\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0418\u0440\u0430\u043D","common":"\u0418\u0440\u0430\u043D"},"slk":{"official":"Ir\xe1nska islamsk\xe1 republika","common":"Ir\xe1n"},"spa":{"official":"Rep\xfablica Isl\xe1mica de Ir\xe1n","common":"Iran"},"swe":{"official":"Islamiska republiken Iran","common":"Iran"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0627\u06CC\u0631\u0627\u0646","common":"\u0627\u06CC\u0631\u0627\u0646"},"zho":{"official":"\u4F0A\u6717\u4F0A\u65AF\u5170\u5171\u548C\u56FD","common":"\u4F0A\u6717"}},"latlng":[32,53],"landlocked":false,"borders":["AFG","ARM","AZE","IRQ","PAK","TUR","TKM"],"area":1648195,"flag":"\uD83C\uDDEE\uD83C\uDDF7","demonyms":{"eng":{"f":"Iranian","m":"Iranian"},"fra":{"f":"Iranienne","m":"Iranien"}}},{"name":{"common":"Iraq","official":"Republic of Iraq","native":{"ara":{"official":"\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0639\u0631\u0627\u0642","common":"\u0627\u0644\u0639\u0631\u0627\u0642"},"arc":{"official":"\u0729\u0718\u073C\u071B\u0722\u0735\u0710 \u0710\u071D\u073C\u072A\u0732\u0729","common":"\u0729\u0718\u073C\u071B\u0722\u0735\u0710"},"ckb":{"official":"\u06A9\u06C6\u0645\u0627\u0631\u06CC \u0639\u06CE\u0631\u0627\u0642","common":"\u06A9\u06C6\u0645\u0627\u0631\u06CC"}}},"tld":[".iq"],"cca2":"IQ","ccn3":"368","cca3":"IRQ","cioc":"IRQ","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"IQD":{"name":"Iraqi dinar","symbol":"\u0639.\u062F"}},"idd":{"root":"+9","suffixes":["64"]},"capital":["Baghdad"],"altSpellings":["IQ","Republic of Iraq","Jumh\u016Briyyat al-\u2018Ir\u0101q"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic","arc":"Aramaic","ckb":"Sorani"},"translations":{"ces":{"official":"Ir\xe1ck\xe1 republika","common":"Ir\xe1k"},"deu":{"official":"Republik Irak","common":"Irak"},"est":{"official":"Iraagi Vabariik","common":"Iraak"},"fin":{"official":"Irakin tasavalta","common":"Irak"},"fra":{"official":"R\xe9publique d\'Irak","common":"Irak"},"hrv":{"official":"Republika Irak","common":"Irak"},"hun":{"official":"Iraki K\xf6zt\xe1rsas\xe1g","common":"Irak"},"ita":{"official":"Repubblica dell\'Iraq","common":"Iraq"},"jpn":{"official":"\u30A4\u30E9\u30AF\u5171\u548C\u56FD","common":"\u30A4\u30E9\u30AF"},"kor":{"official":"\uC774\uB77C\uD06C \uACF5\uD654\uAD6D","common":"\uC774\uB77C\uD06C"},"nld":{"official":"Republiek Irak","common":"Irak"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0639\u0631\u0627\u0642","common":"\u0639\u0631\u0627\u0642"},"pol":{"official":"Republika Iraku","common":"Irak"},"por":{"official":"Rep\xfablica do Iraque","common":"Iraque"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0418\u0440\u0430\u043A","common":"\u0418\u0440\u0430\u043A"},"slk":{"official":"Irack\xe1 republika","common":"Irak"},"spa":{"official":"Rep\xfablica de Irak","common":"Irak"},"swe":{"official":"Republiken Irak","common":"Irak"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0639\u0631\u0627\u0642","common":"\u0639\u0631\u0627\u0642"},"zho":{"official":"\u4F0A\u62C9\u514B\u5171\u548C\u56FD","common":"\u4F0A\u62C9\u514B"}},"latlng":[33,44],"landlocked":false,"borders":["IRN","JOR","KWT","SAU","SYR","TUR"],"area":438317,"flag":"\uD83C\uDDEE\uD83C\uDDF6","demonyms":{"eng":{"f":"Iraqi","m":"Iraqi"},"fra":{"f":"Irakienne","m":"Irakien"}}},{"name":{"common":"Iceland","official":"Iceland","native":{"isl":{"official":"\xcdsland","common":"\xcdsland"}}},"tld":[".is"],"cca2":"IS","ccn3":"352","cca3":"ISL","cioc":"ISL","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"ISK":{"name":"Icelandic kr\xf3na","symbol":"kr"}},"idd":{"root":"+3","suffixes":["54"]},"capital":["Reykjavik"],"altSpellings":["IS","Island","Republic of Iceland","L\xfd\xf0veldi\xf0 \xcdsland"],"region":"Europe","subregion":"Northern Europe","languages":{"isl":"Icelandic"},"translations":{"ces":{"official":"Island","common":"Island"},"deu":{"official":"Island","common":"Island"},"est":{"official":"Islandi Vabariik","common":"Island"},"fin":{"official":"Islanti","common":"Islanti"},"fra":{"official":"R\xe9publique d\'Islande","common":"Islande"},"hrv":{"official":"Island","common":"Island"},"hun":{"official":"Izland","common":"Izland"},"ita":{"official":"Islanda","common":"Islanda"},"jpn":{"official":"\u30A2\u30A4\u30B9\u30E9\u30F3\u30C9","common":"\u30A2\u30A4\u30B9\u30E9\u30F3\u30C9"},"kor":{"official":"\uC544\uC774\uC2AC\uB780\uB4DC \uACF5\uD654\uAD6D","common":"\uC544\uC774\uC2AC\uB780\uB4DC"},"nld":{"official":"IJsland","common":"IJsland"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u06CC\u0633\u0644\u0646\u062F","common":"\u0627\u06CC\u0633\u0644\u0646\u062F"},"pol":{"official":"Republika Islandii","common":"Islandia"},"por":{"official":"Isl\xe2ndia","common":"Isl\xe2ndia"},"rus":{"official":"\u0418\u0441\u043B\u0430\u043D\u0434\u0438\u044F","common":"\u0418\u0441\u043B\u0430\u043D\u0434\u0438\u044F"},"slk":{"official":"Islandsk\xe1 republika","common":"Island"},"spa":{"official":"Islandia","common":"Islandia"},"swe":{"official":"Island","common":"Island"},"urd":{"official":"\u0622\u0626\u0633 \u0644\u06CC\u0646\u0688","common":"\u0622\u0626\u0633 \u0644\u06CC\u0646\u0688"},"zho":{"official":"\u51B0\u5C9B","common":"\u51B0\u5C9B"}},"latlng":[65,-18],"landlocked":false,"borders":[],"area":103000,"flag":"\uD83C\uDDEE\uD83C\uDDF8","demonyms":{"eng":{"f":"Icelander","m":"Icelander"},"fra":{"f":"Islandaise","m":"Islandais"}}},{"name":{"common":"Israel","official":"State of Israel","native":{"ara":{"official":"\u062F\u0648\u0644\u0629 \u0625\u0633\u0631\u0627\u0626\u064A\u0644","common":"\u0625\u0633\u0631\u0627\u0626\u064A\u0644"},"heb":{"official":"\u05DE\u05D3\u05D9\u05E0\u05EA \u05D9\u05E9\u05E8\u05D0\u05DC","common":"\u05D9\u05E9\u05E8\u05D0\u05DC"}}},"tld":[".il"],"cca2":"IL","ccn3":"376","cca3":"ISR","cioc":"ISR","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"ILS":{"name":"Israeli new shekel","symbol":"\u20AA"}},"idd":{"root":"+9","suffixes":["72"]},"capital":["Jerusalem"],"altSpellings":["IL","State of Israel","Med\u012Bnat Yisr\u0101\'el"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic","heb":"Hebrew"},"translations":{"ces":{"official":"St\xe1t Izrael","common":"Izrael"},"deu":{"official":"Staat Israel","common":"Israel"},"est":{"official":"Iisraeli Riik","common":"Iisrael"},"fin":{"official":"Israelin valtio","common":"Israel"},"fra":{"official":"\xc9tat d\'Isra\xebl","common":"Isra\xebl"},"hrv":{"official":"Dr\u017Eava Izrael","common":"Izrael"},"hun":{"official":"Izrael","common":"Izrael"},"ita":{"official":"Stato di Israele","common":"Israele"},"jpn":{"official":"\u30A4\u30B9\u30E9\u30A8\u30EB\u56FD","common":"\u30A4\u30B9\u30E9\u30A8\u30EB"},"kor":{"official":"\uC774\uC2A4\uB77C\uC5D8\uAD6D","common":"\uC774\uC2A4\uB77C\uC5D8"},"nld":{"official":"Staat Isra\xebl","common":"Isra\xebl"},"per":{"official":"\u0641\u0644\u0633\u0637\u064A\u0646 \u0627\u0634\u063A\u0627\u0644\u06CC","common":"\u0641\u0644\u0633\u0637\u064A\u0646 \u0627\u0634\u063A\u0627\u0644\u06CC"},"pol":{"official":"Pa\u0144stwo Izrael","common":"Izrael"},"por":{"official":"Estado de Israel","common":"Israel"},"rus":{"official":"\u0413\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u043E \u0418\u0437\u0440\u0430\u0438\u043B\u044C","common":"\u0418\u0437\u0440\u0430\u0438\u043B\u044C"},"slk":{"official":"Izraelsk\xfd \u0161t\xe1t","common":"Izrael"},"spa":{"official":"Estado de Israel","common":"Israel"},"swe":{"official":"Staten Israel","common":"Israel"},"urd":{"official":"\u0631\u06CC\u0627\u0633\u062A\u0650 \u0627\u0633\u0631\u0627\u0626\u06CC\u0644","common":"\u0627\u0633\u0631\u0627\u0626\u06CC\u0644"},"zho":{"official":"\u4EE5\u8272\u5217\u56FD","common":"\u4EE5\u8272\u5217"}},"latlng":[31.47,35.13],"landlocked":false,"borders":["EGY","JOR","LBN","PSE","SYR"],"area":20770,"flag":"\uD83C\uDDEE\uD83C\uDDF1","demonyms":{"eng":{"f":"Israeli","m":"Israeli"},"fra":{"f":"Isra\xe9lienne","m":"Isra\xe9lien"}}},{"name":{"common":"Italy","official":"Italian Republic","native":{"ita":{"official":"Repubblica italiana","common":"Italia"}}},"tld":[".it"],"cca2":"IT","ccn3":"380","cca3":"ITA","cioc":"ITA","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["9"]},"capital":["Rome"],"altSpellings":["IT","Italian Republic","Repubblica italiana"],"region":"Europe","subregion":"Southern Europe","languages":{"ita":"Italian"},"translations":{"ces":{"official":"Italsk\xe1 republika","common":"It\xe1lie"},"deu":{"official":"Italienische Republik","common":"Italien"},"est":{"official":"Itaalia Vabariik","common":"Itaalia"},"fin":{"official":"Italian tasavalta","common":"Italia"},"fra":{"official":"R\xe9publique italienne","common":"Italie"},"hrv":{"official":"talijanska Republika","common":"Italija"},"hun":{"official":"Olasz K\xf6zt\xe1rsas\xe1g","common":"Olaszorsz\xe1g"},"ita":{"official":"Repubblica italiana","common":"Italia"},"jpn":{"official":"\u30A4\u30BF\u30EA\u30A2\u5171\u548C\u56FD","common":"\u30A4\u30BF\u30EA\u30A2"},"kor":{"official":"\uC774\uD0C8\uB9AC\uC544 \uACF5\uD654\uAD6D","common":"\uC774\uD0C8\uB9AC\uC544"},"nld":{"official":"Italiaanse Republiek","common":"Itali\xeb"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u06CC\u062A\u0627\u0644\u06CC\u0627","common":"\u0627\u06CC\u062A\u0627\u0644\u06CC\u0627"},"pol":{"official":"Republika W\u0142oska","common":"W\u0142ochy"},"por":{"official":"Rep\xfablica Italiana","common":"It\xe1lia"},"rus":{"official":"\u0438\u0442\u0430\u043B\u044C\u044F\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u0418\u0442\u0430\u043B\u0438\u044F"},"slk":{"official":"Talianska republika","common":"Taliansko"},"spa":{"official":"Rep\xfablica Italiana","common":"Italia"},"swe":{"official":"Republiken Italien","common":"Italien"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0627\u0637\u0627\u0644\u06CC\u06C1","common":"\u0627\u0637\u0627\u0644\u06CC\u06C1"},"zho":{"official":"\u610F\u5927\u5229\u5171\u548C\u56FD","common":"\u610F\u5927\u5229"}},"latlng":[42.83333333,12.83333333],"landlocked":false,"borders":["AUT","FRA","SMR","SVN","CHE","VAT"],"area":301336,"flag":"\uD83C\uDDEE\uD83C\uDDF9","demonyms":{"eng":{"f":"Italian","m":"Italian"},"fra":{"f":"Italienne","m":"Italien"}}},{"name":{"common":"Jamaica","official":"Jamaica","native":{"eng":{"official":"Jamaica","common":"Jamaica"},"jam":{"official":"Jamaica","common":"Jamaica"}}},"tld":[".jm"],"cca2":"JM","ccn3":"388","cca3":"JAM","cioc":"JAM","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"JMD":{"name":"Jamaican dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["876"]},"capital":["Kingston"],"altSpellings":["JM"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English","jam":"Jamaican Patois"},"translations":{"ces":{"official":"Jamajka","common":"Jamajka"},"deu":{"official":"Jamaika","common":"Jamaika"},"est":{"official":"Jamaica","common":"Jamaica"},"fin":{"official":"Jamaika","common":"Jamaika"},"fra":{"official":"Jama\xefque","common":"Jama\xefque"},"hrv":{"official":"Jamajka","common":"Jamajka"},"hun":{"official":"Jamaica","common":"Jamaica"},"ita":{"official":"Giamaica","common":"Giamaica"},"jpn":{"official":"\u30B8\u30E3\u30DE\u30A4\u30AB","common":"\u30B8\u30E3\u30DE\u30A4\u30AB"},"kor":{"official":"\uC790\uBA54\uC774\uCE74","common":"\uC790\uBA54\uC774\uCE74"},"nld":{"official":"Jamaica","common":"Jamaica"},"per":{"official":"\u062C\u0627\u0645\u0627\u0626\u06CC\u06A9\u0627","common":"\u062C\u0627\u0645\u0627\u0626\u06CC\u06A9\u0627"},"pol":{"official":"Jamajka","common":"Jamajka"},"por":{"official":"Jamaica","common":"Jamaica"},"rus":{"official":"\u042F\u043C\u0430\u0439\u043A\u0430","common":"\u042F\u043C\u0430\u0439\u043A\u0430"},"slk":{"official":"Jamajka","common":"Jamajka"},"spa":{"official":"Jamaica","common":"Jamaica"},"swe":{"official":"Jamaica","common":"Jamaica"},"urd":{"official":"\u062C\u0645\u06CC\u06A9\u0627","common":"\u062C\u0645\u06CC\u06A9\u0627"},"zho":{"official":"\u7259\u4E70\u52A0","common":"\u7259\u4E70\u52A0"}},"latlng":[18.25,-77.5],"landlocked":false,"borders":[],"area":10991,"flag":"\uD83C\uDDEF\uD83C\uDDF2","demonyms":{"eng":{"f":"Jamaican","m":"Jamaican"},"fra":{"f":"Jama\xefcaine","m":"Jama\xefcain"}}},{"name":{"common":"Jersey","official":"Bailiwick of Jersey","native":{"eng":{"official":"Bailiwick of Jersey","common":"Jersey"},"fra":{"official":"Bailliage de Jersey","common":"Jersey"},"nrf":{"official":"Bailliage d\xe9 J\xe8rri","common":"J\xe8rri"}}},"tld":[".je"],"cca2":"JE","ccn3":"832","cca3":"JEY","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"GBP":{"name":"British pound","symbol":"\xa3"},"JEP":{"name":"Jersey pound","symbol":"\xa3"}},"idd":{"root":"+4","suffixes":["4"]},"capital":["Saint Helier"],"altSpellings":["JE","Bailiwick of Jersey","Bailliage de Jersey","Bailliage d\xe9 J\xe8rri"],"region":"Europe","subregion":"Northern Europe","languages":{"eng":"English","fra":"French","nrf":"J\xe8rriais"},"translations":{"ces":{"official":"Rycht\xe1\u0159stv\xed Jersey","common":"Jersey"},"deu":{"official":"Vogtei Jersey","common":"Jersey"},"est":{"official":"Jersey foogtkond","common":"Jersey"},"fin":{"official":"Jersey","common":"Jersey"},"fra":{"official":"Bailliage de Jersey","common":"Jersey"},"hrv":{"official":"Struka od Jersey","common":"Jersey"},"hun":{"official":"Jersey","common":"Jersey"},"ita":{"official":"Baliato di Jersey","common":"Isola di Jersey"},"jpn":{"official":"\u30B8\u30E3\u30FC\u30B8\u306E\u5F97\u610F\u5206\u91CE","common":"\u30B8\u30E3\u30FC\u30B8\u30FC"},"kor":{"official":"\uC800\uC9C0 \uC12C","common":"\uC800\uC9C0 \uC12C"},"nld":{"official":"Baljuwschap Jersey","common":"Jersey"},"per":{"official":"\u062C\u0631\u0632\u06CC","common":"\u062C\u0631\u0632\u06CC"},"pol":{"official":"Jersey","common":"Jersey"},"por":{"official":"Bailiado de Jersey","common":"Jersey"},"rus":{"official":"\u041A\u043E\u0440\u043E\u043D\u043D\u043E\u0435 \u0432\u043B\u0430\u0434\u0435\u043D\u0438\u0435 \u0414\u0436\u0435\u0440\u0441\u0438","common":"\u0414\u0436\u0435\u0440\u0441\u0438"},"slk":{"official":"Bailiwick Jersey","common":"Jersey"},"spa":{"official":"Bail\xeda de Jersey","common":"Jersey"},"swe":{"official":"Jersey","common":"Jersey"},"urd":{"official":"\u062C\u0631\u0632\u06CC","common":"\u062C\u0631\u0632\u06CC"},"zho":{"official":"\u6CFD\u897F\u5C9B","common":"\u6CFD\u897F\u5C9B"}},"latlng":[49.25,-2.16666666],"landlocked":false,"borders":[],"area":116,"flag":"\uD83C\uDDEF\uD83C\uDDEA","demonyms":{"eng":{"f":"Channel Islander","m":"Channel Islander"},"fra":{"f":"Jersiaise","m":"Jersiais"}}},{"name":{"common":"Jordan","official":"Hashemite Kingdom of Jordan","native":{"ara":{"official":"\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0623\u0631\u062F\u0646\u064A\u0629 \u0627\u0644\u0647\u0627\u0634\u0645\u064A\u0629","common":"\u0627\u0644\u0623\u0631\u062F\u0646"}}},"tld":[".jo","\u0627\u0644\u0627\u0631\u062F\u0646."],"cca2":"JO","ccn3":"400","cca3":"JOR","cioc":"JOR","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"JOD":{"name":"Jordanian dinar","symbol":"\u062F.\u0627"}},"idd":{"root":"+9","suffixes":["62"]},"capital":["Amman"],"altSpellings":["JO","Hashemite Kingdom of Jordan","al-Mamlakah al-Urdun\u012Byah al-H\u0101shim\u012Byah"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Jord\xe1nsk\xe9 h\xe1\u0161imovsk\xe9 kr\xe1lovstv\xed","common":"Jord\xe1nsko"},"deu":{"official":"Haschemitisches K\xf6nigreich Jordanien","common":"Jordanien"},"est":{"official":"Jordaania Ha\u0161imiidi Kuningriik","common":"Jordaania"},"fin":{"official":"Jordanian ha\u0161emiittinen kunigaskunta","common":"Jordania"},"fra":{"official":"Royaume hach\xe9mite de Jordanie","common":"Jordanie"},"hrv":{"official":"Ha\u0161emitske Kraljevine Jordan","common":"Jordan"},"hun":{"official":"Jord\xe1nia","common":"Jord\xe1nia"},"ita":{"official":"Regno hascemita di Giordania","common":"Giordania"},"jpn":{"official":"\u30E8\u30EB\u30C0\u30F3\xb7\u30CF\u30B7\u30DF\u30C6\u738B\u56FD","common":"\u30E8\u30EB\u30C0\u30F3"},"kor":{"official":"\uC694\uB974\uB2E8 \uD558\uC2EC \uC655\uAD6D","common":"\uC694\uB974\uB2E8"},"nld":{"official":"Hasjemitisch Koninkrijk Jordani\xeb","common":"Jordani\xeb"},"per":{"official":"\u067E\u0627\u062F\u0634\u0627\u0647\u06CC \u0627\u064F\u0631\u062F\u064F\u0646 \u0647\u0627\u0634\u0645\u06CC","common":"\u0627\u0631\u062F\u0646"},"pol":{"official":"Jorda\u0144skie Kr\xf3lestwo Haszymidzkie","common":"Jordania"},"por":{"official":"Reino Hachemita da Jord\xe2nia","common":"Jord\xe2nia"},"rus":{"official":"\u0418\u043E\u0440\u0434\u0430\u043D\u0441\u043A\u043E\u0433\u043E \u0425\u0430\u0448\u0438\u043C\u0438\u0442\u0441\u043A\u043E\u0433\u043E \u041A\u043E\u0440\u043E\u043B\u0435\u0432\u0441\u0442\u0432\u0430","common":"\u0418\u043E\u0440\u0434\u0430\u043D\u0438\u044F"},"slk":{"official":"Jord\xe1nske h\xe1\u0161imovsk\xe9 kr\xe1\u013Eovstvo","common":"Jord\xe1nsko"},"spa":{"official":"Reino Hachemita de Jordania","common":"Jordania"},"swe":{"official":"Hashimitiska kungad\xf6met Jordanien","common":"Jordanien"},"urd":{"official":"\u06BE\u0627\u0634\u0645\u06CC \u0645\u0645\u0644\u06A9\u062A\u0650 \u0627\u0631\u062F\u0646","common":"\u0627\u0631\u062F\u0646"},"zho":{"official":"\u7EA6\u65E6\u54C8\u5E0C\u59C6\u738B\u56FD","common":"\u7EA6\u65E6"}},"latlng":[31,36],"landlocked":false,"borders":["IRQ","ISR","PSE","SAU","SYR"],"area":89342,"flag":"\uD83C\uDDEF\uD83C\uDDF4","demonyms":{"eng":{"f":"Jordanian","m":"Jordanian"},"fra":{"f":"Jordanienne","m":"Jordanien"}}},{"name":{"common":"Japan","official":"Japan","native":{"jpn":{"official":"\u65E5\u672C","common":"\u65E5\u672C"}}},"tld":[".jp",".\u307F\u3093\u306A"],"cca2":"JP","ccn3":"392","cca3":"JPN","cioc":"JPN","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"JPY":{"name":"Japanese yen","symbol":"\xa5"}},"idd":{"root":"+8","suffixes":["1"]},"capital":["Tokyo"],"altSpellings":["JP","Nippon","Nihon"],"region":"Asia","subregion":"Eastern Asia","languages":{"jpn":"Japanese"},"translations":{"ces":{"official":"Japonsko","common":"Japonsko"},"deu":{"official":"Japan","common":"Japan"},"est":{"official":"Jaapan","common":"Jaapan"},"fin":{"official":"Japani","common":"Japani"},"fra":{"official":"Japon","common":"Japon"},"hrv":{"official":"Japan","common":"Japan"},"hun":{"official":"Jap\xe1n","common":"Jap\xe1n"},"ita":{"official":"Giappone","common":"Giappone"},"jpn":{"official":"\u65E5\u672C","common":"\u65E5\u672C"},"kor":{"official":"\uC77C\uBCF8\uAD6D","common":"\uC77C\uBCF8"},"nld":{"official":"Japan","common":"Japan"},"per":{"official":"\u0698\u0627\u067E\u0646","common":"\u0698\u0627\u067E\u0646"},"pol":{"official":"Japonia","common":"Japonia"},"por":{"official":"Jap\xe3o","common":"Jap\xe3o"},"rus":{"official":"\u042F\u043F\u043E\u043D\u0438\u044F","common":"\u042F\u043F\u043E\u043D\u0438\u044F"},"slk":{"official":"Japonsko","common":"Japonsko"},"spa":{"official":"Jap\xf3n","common":"Jap\xf3n"},"swe":{"official":"Japan","common":"Japan"},"urd":{"official":"\u062C\u0627\u067E\u0627\u0646","common":"\u062C\u0627\u067E\u0627\u0646"},"zho":{"official":"\u65E5\u672C\u56FD","common":"\u65E5\u672C"}},"latlng":[36,138],"landlocked":false,"borders":[],"area":377930,"flag":"\uD83C\uDDEF\uD83C\uDDF5","demonyms":{"eng":{"f":"Japanese","m":"Japanese"},"fra":{"f":"Japonaise","m":"Japonais"}}},{"name":{"common":"Kazakhstan","official":"Republic of Kazakhstan","native":{"kaz":{"official":"\u049A\u0430\u0437\u0430\u049B\u0441\u0442\u0430\u043D \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0441\u044B","common":"\u049A\u0430\u0437\u0430\u049B\u0441\u0442\u0430\u043D"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D","common":"\u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D"}}},"tld":[".kz",".\u049B\u0430\u0437"],"cca2":"KZ","ccn3":"398","cca3":"KAZ","cioc":"KAZ","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"KZT":{"name":"Kazakhstani tenge","symbol":"\u20B8"}},"idd":{"root":"+7","suffixes":["6","7"]},"capital":["Nur-Sultan"],"altSpellings":["KZ","Qazaqstan","\u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D","Republic of Kazakhstan","\u049A\u0430\u0437\u0430\u049B\u0441\u0442\u0430\u043D \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0441\u044B","Qazaqstan Respubl\xefkas\u0131","\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D","Respublika Kazakhstan"],"region":"Asia","subregion":"Central Asia","languages":{"kaz":"Kazakh","rus":"Russian"},"translations":{"ces":{"official":"Republika Kazachst\xe1n","common":"Kazachst\xe1n"},"deu":{"official":"Republik Kasachstan","common":"Kasachstan"},"est":{"official":"Kasahstani Vabariik","common":"Kasahstan"},"fin":{"official":"Kazakstanin tasavalta","common":"Kazakstan"},"fra":{"official":"R\xe9publique du Kazakhstan","common":"Kazakhstan"},"hrv":{"official":"Republika Kazahstan","common":"Kazahstan"},"hun":{"official":"Kazah K\xf6zt\xe1rsas\xe1g","common":"Kazahszt\xe1n"},"ita":{"official":"Repubblica del Kazakhstan","common":"Kazakistan"},"jpn":{"official":"\u30AB\u30B6\u30D5\u30B9\u30BF\u30F3\u5171\u548C\u56FD","common":"\u30AB\u30B6\u30D5\u30B9\u30BF\u30F3"},"kor":{"official":"\uCE74\uC790\uD750\uC2A4\uD0C4 \uACF5\uD654\uAD6D","common":"\uCE74\uC790\uD750\uC2A4\uD0C4"},"nld":{"official":"Republiek Kazachstan","common":"Kazachstan"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0642\u0632\u0627\u0642\u0633\u062A\u0627\u0646","common":"\u0642\u0632\u0627\u0642\u0633\u062A\u0627\u0646"},"pol":{"official":"Republika Kazachstanu","common":"Kazachstan"},"por":{"official":"Rep\xfablica do Cazaquist\xe3o","common":"Cazaquist\xe3o"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D","common":"\u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D"},"slk":{"official":"Kaza\u0161sk\xe1 republika","common":"Kazachstan"},"spa":{"official":"Rep\xfablica de Kazajst\xe1n","common":"Kazajist\xe1n"},"swe":{"official":"Republiken Kazakstan","common":"Kazakstan"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0642\u0627\u0632\u0642\u0633\u062A\u0627\u0646","common":"\u0642\u0627\u0632\u0642\u0633\u062A\u0627\u0646"},"zho":{"official":"\u54C8\u8428\u514B\u65AF\u5766\u5171\u548C\u56FD","common":"\u54C8\u8428\u514B\u65AF\u5766"}},"latlng":[48,68],"landlocked":true,"borders":["CHN","KGZ","RUS","TKM","UZB"],"area":2724900,"flag":"\uD83C\uDDF0\uD83C\uDDFF","demonyms":{"eng":{"f":"Kazakhstani","m":"Kazakhstani"},"fra":{"f":"Kazakhstanaise","m":"Kazakhstanais"}}},{"name":{"common":"Kenya","official":"Republic of Kenya","native":{"eng":{"official":"Republic of Kenya","common":"Kenya"},"swa":{"official":"Republic of Kenya","common":"Kenya"}}},"tld":[".ke"],"cca2":"KE","ccn3":"404","cca3":"KEN","cioc":"KEN","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"KES":{"name":"Kenyan shilling","symbol":"Sh"}},"idd":{"root":"+2","suffixes":["54"]},"capital":["Nairobi"],"altSpellings":["KE","Republic of Kenya","Jamhuri ya Kenya"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English","swa":"Swahili"},"translations":{"ces":{"official":"Ke\u0148sk\xe1 republika","common":"Ke\u0148a"},"deu":{"official":"Republik Kenia","common":"Kenia"},"est":{"official":"Keenia Vabariik","common":"Keenia"},"fin":{"official":"Kenian tasavalta","common":"Kenia"},"fra":{"official":"R\xe9publique du Kenya","common":"Kenya"},"hrv":{"official":"Republika Kenija","common":"Kenija"},"hun":{"official":"Kenyai K\xf6zt\xe1rsas\xe1g","common":"Kenya"},"ita":{"official":"Repubblica del Kenya","common":"Kenya"},"jpn":{"official":"\u30B1\u30CB\u30A2\u5171\u548C\u56FD","common":"\u30B1\u30CB\u30A2"},"kor":{"official":"\uCF00\uB0D0 \uACF5\uD654\uAD6D","common":"\uCF00\uB0D0"},"nld":{"official":"Republiek Kenia","common":"Kenia"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u06A9\u0646\u06CC\u0627","common":"\u06A9\u0646\u06CC\u0627"},"pol":{"official":"Republika Kenii","common":"Kenia"},"por":{"official":"Rep\xfablica do Qu\xe9nia","common":"Qu\xe9nia"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u0435\u043D\u0438\u044F","common":"\u041A\u0435\u043D\u0438\u044F"},"slk":{"official":"Kensk\xe1 republika","common":"Ke\u0148a"},"spa":{"official":"Rep\xfablica de Kenya","common":"Kenia"},"swe":{"official":"Republiken Kenya","common":"Kenya"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06A9\u06CC\u0646\u06CC\u0627","common":"\u06A9\u06CC\u0646\u06CC\u0627"},"zho":{"official":"\u80AF\u5C3C\u4E9A\u5171\u548C\u56FD","common":"\u80AF\u5C3C\u4E9A"}},"latlng":[1,38],"landlocked":false,"borders":["ETH","SOM","SSD","TZA","UGA"],"area":580367,"flag":"\uD83C\uDDF0\uD83C\uDDEA","demonyms":{"eng":{"f":"Kenyan","m":"Kenyan"},"fra":{"f":"K\xe9nyane","m":"K\xe9nyan"}}},{"name":{"common":"Kyrgyzstan","official":"Kyrgyz Republic","native":{"kir":{"official":"\u041A\u044B\u0440\u0433\u044B\u0437 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0441\u044B","common":"\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D"},"rus":{"official":"\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u041A\u0438\u0440\u0433\u0438\u0437\u0438\u044F"}}},"tld":[".kg"],"cca2":"KG","ccn3":"417","cca3":"KGZ","cioc":"KGZ","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"KGS":{"name":"Kyrgyzstani som","symbol":"\u0441"}},"idd":{"root":"+9","suffixes":["96"]},"capital":["Bishkek"],"altSpellings":["KG","\u041A\u0438\u0440\u0433\u0438\u0437\u0438\u044F","Kyrgyz Republic","\u041A\u044B\u0440\u0433\u044B\u0437 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0441\u044B","Kyrgyz Respublikasy"],"region":"Asia","subregion":"Central Asia","languages":{"kir":"Kyrgyz","rus":"Russian"},"translations":{"ces":{"official":"Kyrgyzsk\xe1 republika","common":"Kyrgyzst\xe1n"},"deu":{"official":"Kirgisische Republik","common":"Kirgisistan"},"est":{"official":"Kirgiisi Vabariik","common":"K\xf5rg\xf5zstan"},"fin":{"official":"Kirgisian tasavalta","common":"Kirgisia"},"fra":{"official":"R\xe9publique kirghize","common":"Kirghizistan"},"hrv":{"official":"Kirgistanu","common":"Kirgistan"},"hun":{"official":"Kirgiz K\xf6zt\xe1rsas\xe1g","common":"Kirgiziszt\xe1n"},"ita":{"official":"Kirghizistan","common":"Kirghizistan"},"jpn":{"official":"\u30AD\u30EB\u30AE\u30B9\u5171\u548C\u56FD","common":"\u30AD\u30EB\u30AE\u30B9"},"kor":{"official":"\uD0A4\uB974\uAE30\uC2A4 \uACF5\uD654\uAD6D","common":"\uD0A4\uB974\uAE30\uC2A4\uC2A4\uD0C4"},"nld":{"official":"Kirgizische Republiek","common":"Kirgizi\xeb"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0642\u0650\u0631\u0642\u06CC\u0632\u0633\u062A\u0627\u0646","common":"\u0642\u0631\u0642\u06CC\u0632\u0633\u062A\u0627\u0646"},"pol":{"official":"Republika Kirgiska","common":"Kirgistan"},"por":{"official":"Rep\xfablica do Quirguist\xe3o","common":"Quirguist\xe3o"},"rus":{"official":"\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u041A\u0438\u0440\u0433\u0438\u0437\u0438\u044F"},"slk":{"official":"Kirgizsk\xe1 republika","common":"Kirgizsko"},"spa":{"official":"Rep\xfablica Kirguisa","common":"Kirguizist\xe1n"},"swe":{"official":"Republiken Kirgizistan","common":"Kirgizistan"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06A9\u0631\u063A\u06CC\u0632\u0633\u062A\u0627\u0646","common":"\u06A9\u0631\u063A\u06CC\u0632\u0633\u062A\u0627\u0646"},"zho":{"official":"\u5409\u5C14\u5409\u65AF\u65AF\u5766\u5171\u548C\u56FD","common":"\u5409\u5C14\u5409\u65AF\u65AF\u5766"}},"latlng":[41,75],"landlocked":true,"borders":["CHN","KAZ","TJK","UZB"],"area":199951,"flag":"\uD83C\uDDF0\uD83C\uDDEC","demonyms":{"eng":{"f":"Kirghiz","m":"Kirghiz"},"fra":{"f":"Kirghize","m":"Kirghize"}}},{"name":{"common":"Cambodia","official":"Kingdom of Cambodia","native":{"khm":{"official":"\u1796\u17D2\u179A\u17C7\u179A\u17B6\u1787\u17B6\u178E\u17B6\u1785\u1780\u17D2\u179A\u1780\u1798\u17D2\u1796\u17BB\u1787\u17B6","common":"K\xe2mp\u016Dch\xe9a"}}},"tld":[".kh"],"cca2":"KH","ccn3":"116","cca3":"KHM","cioc":"CAM","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"KHR":{"name":"Cambodian riel","symbol":"\u17DB"},"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+8","suffixes":["55"]},"capital":["Phnom Penh"],"altSpellings":["KH","Kingdom of Cambodia"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"khm":"Khmer"},"translations":{"ces":{"official":"Kambod\u017Esk\xe9 kr\xe1lovstv\xed","common":"Kambod\u017Ea"},"cym":{"official":"Teyrnas Cambodia","common":"Cambodia"},"deu":{"official":"K\xf6nigreich Kambodscha","common":"Kambodscha"},"est":{"official":"Kambod\u017Ea Kuningriik","common":"Kambod\u017Ea"},"fin":{"official":"Kambod\u017Ean kuningaskunta","common":"Kambod\u017Ea"},"fra":{"official":"Royaume du Cambodge","common":"Cambodge"},"hrv":{"official":"Kraljevina Kambod\u017Ea","common":"Kambod\u017Ea"},"hun":{"official":"Kambodzsai Kir\xe1lys\xe1g","common":"Kambodzsa"},"ita":{"official":"Regno di Cambogia","common":"Cambogia"},"jpn":{"official":"\u30AB\u30F3\u30DC\u30B8\u30A2\u738B\u56FD","common":"\u30AB\u30F3\u30DC\u30B8\u30A2"},"kor":{"official":"\uCE84\uBCF4\uB514\uC544 \uC655\uAD6D","common":"\uCE84\uBCF4\uB514\uC544"},"nld":{"official":"Koninkrijk Cambodja","common":"Cambodja"},"per":{"official":"\u067E\u0627\u062F\u0634\u0627\u0647\u06CC \u06A9\u0627\u0645\u0628\u0648\u062C","common":"\u06A9\u0627\u0645\u0628\u0648\u062C"},"pol":{"official":"Kr\xf3lestwo Kambod\u017Cy","common":"Kambod\u017Ca"},"por":{"official":"Reino do Camboja","common":"Camboja"},"rus":{"official":"\u041A\u043E\u0440\u043E\u043B\u0435\u0432\u0441\u0442\u0432\u043E \u041A\u0430\u043C\u0431\u043E\u0434\u0436\u0430","common":"\u041A\u0430\u043C\u0431\u043E\u0434\u0436\u0430"},"slk":{"official":"Kambo\u01C6sk\xe9 kr\xe1\u013Eovstvo","common":"Kambo\u01C6a"},"spa":{"official":"Reino de Camboya","common":"Camboya"},"swe":{"official":"Konungariket Kambodja","common":"Kambodja"},"urd":{"official":"\u0645\u0645\u0644\u06A9\u062A\u0650 \u06A9\u0645\u0628\u0648\u0688\u06CC\u0627","common":"\u06A9\u0645\u0628\u0648\u0688\u06CC\u0627"},"zho":{"official":"\u67EC\u57D4\u5BE8\u738B\u56FD","common":"\u67EC\u57D4\u5BE8"}},"latlng":[13,105],"landlocked":false,"borders":["LAO","THA","VNM"],"area":181035,"flag":"\uD83C\uDDF0\uD83C\uDDED","demonyms":{"eng":{"f":"Cambodian","m":"Cambodian"},"fra":{"f":"Cambodgienne","m":"Cambodgien"}}},{"name":{"common":"Kiribati","official":"Independent and Sovereign Republic of Kiribati","native":{"eng":{"official":"Independent and Sovereign Republic of Kiribati","common":"Kiribati"},"gil":{"official":"Ribaberiki Kiribati","common":"Kiribati"}}},"tld":[".ki"],"cca2":"KI","ccn3":"296","cca3":"KIR","cioc":"KIR","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"AUD":{"name":"Australian dollar","symbol":"$"},"KID":{"name":"Kiribati dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["86"]},"capital":["South Tarawa"],"altSpellings":["KI","Republic of Kiribati","Ribaberiki Kiribati"],"region":"Oceania","subregion":"Micronesia","languages":{"eng":"English","gil":"Gilbertese"},"translations":{"ces":{"official":"Republika Kiribati","common":"Kiribati"},"deu":{"official":"Republik Kiribati","common":"Kiribati"},"est":{"official":"Kiribati Vabariik","common":"Kiribati"},"fin":{"official":"Kiribatin tasavalta","common":"Kiribati"},"fra":{"official":"R\xe9publique de Kiribati","common":"Kiribati"},"hrv":{"official":"Samostalne i suverene Republike Kiribati","common":"Kiribati"},"hun":{"official":"Kiribati K\xf6zt\xe1rsas\xe1g","common":"Kiribati"},"ita":{"official":"Repubblica indipendente e sovrano di Kiribati","common":"Kiribati"},"jpn":{"official":"\u30AD\u30EA\u30D0\u30B9\u306E\u72EC\u7ACB\u3068\u4E3B\u6A29\u5171\u548C\u56FD","common":"\u30AD\u30EA\u30D0\u30B9"},"kor":{"official":"\uD0A4\uB9AC\uBC14\uC2DC \uACF5\uD654\uAD6D","common":"\uD0A4\uB9AC\uBC14\uC2DC"},"nld":{"official":"Onafhankelijke en soevereine republiek Kiribati","common":"Kiribati"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u06A9\u06CC\u0631\u06CC\u0628\u0627\u062A\u06CC","common":"\u06A9\u06CC\u0631\u06CC\u0628\u0627\u062A\u06CC"},"pol":{"official":"Republika Kiribati","common":"Kiribati"},"por":{"official":"Independente e soberano Rep\xfablica de Kiribati","common":"Kiribati"},"rus":{"official":"\u041D\u0435\u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0439 \u0438 \u0441\u0443\u0432\u0435\u0440\u0435\u043D\u043D\u043E\u0439 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0438 \u041A\u0438\u0440\u0438\u0431\u0430\u0442\u0438","common":"\u041A\u0438\u0440\u0438\u0431\u0430\u0442\u0438"},"slk":{"official":"Kiribatsk\xe1 republika","common":"Kiribati"},"spa":{"official":"Rep\xfablica Independiente y Soberano de Kiribati","common":"Kiribati"},"swe":{"official":"Republiken Kiribati","common":"Kiribati"},"urd":{"official":"\u0633\u0644\u0637\u0646\u062A \u0622\u0632\u0627\u062F \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06A9\u06CC\u0631\u06CC\u0628\u0627\u062A\u06CC","common":"\u06A9\u06CC\u0631\u06CC\u0628\u0627\u062A\u06CC"},"zho":{"official":"\u57FA\u91CC\u5DF4\u65AF\u5171\u548C\u56FD","common":"\u57FA\u91CC\u5DF4\u65AF"}},"latlng":[1.41666666,173],"landlocked":false,"borders":[],"area":811,"flag":"\uD83C\uDDF0\uD83C\uDDEE","demonyms":{"eng":{"f":"I-Kiribati","m":"I-Kiribati"},"fra":{"f":"Kiribatienne","m":"Kiribatien"}}},{"name":{"common":"Saint Kitts and Nevis","official":"Federation of Saint Christopher and Nevis","native":{"eng":{"official":"Federation of Saint Christopher and Nevis","common":"Saint Kitts and Nevis"}}},"tld":[".kn"],"cca2":"KN","ccn3":"659","cca3":"KNA","cioc":"SKN","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"XCD":{"name":"Eastern Caribbean dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["869"]},"capital":["Basseterre"],"altSpellings":["KN","Federation of Saint Christopher and Nevis"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Federace Sv. Kry\u0161tof a Nevis","common":"Svat\xfd Kry\u0161tof a Nevis"},"deu":{"official":"F\xf6deration von St. Kitts und Nevis","common":"St. Kitts und Nevis"},"est":{"official":"Saint Kittsi ja Nevise F\xf6deratsioon","common":"Saint Kitts ja Nevis"},"fin":{"official":"Saint Christopherin ja Nevisin federaatio","common":"Saint Kitts ja Nevis"},"fra":{"official":"F\xe9d\xe9ration de Saint-Christophe-et-Ni\xe9v\xe8s","common":"Saint-Christophe-et-Ni\xe9v\xe8s"},"hrv":{"official":"Federacija Sv.Kristofora i Nevisa","common":"Sveti Kristof i Nevis"},"hun":{"official":"Saint Christopher \xe9s Nevis \xc1llamsz\xf6vets\xe9g","common":"Saint Kitts \xe9s Nevis"},"ita":{"official":"Federazione di Saint Christopher e Nevis","common":"Saint Kitts e Nevis"},"jpn":{"official":"\u30BB\u30F3\u30C8\u30AF\u30EA\u30B9\u30C8\u30D5\u30A1\u30FCNevis\u9023\u76DF","common":"\u30BB\u30F3\u30C8\u30AF\u30EA\u30B9\u30C8\u30D5\u30A1\u30FC\u30FB\u30CD\u30A4\u30D3\u30B9"},"kor":{"official":"\uC138\uC778\uD2B8\uD0A4\uCE20 \uB124\uBE44\uC2A4 \uC5F0\uBC29","common":"\uC138\uC778\uD2B8\uD0A4\uCE20 \uB124\uBE44\uC2A4"},"nld":{"official":"Federatie van Saint Kitts en Nevis","common":"Saint Kitts en Nevis"},"per":{"official":"\u0641\u062F\u0631\u0627\u0633\u06CC\u0648\u0646 \u0633\u0646\u062A \u06A9\u06CC\u062A\u0633 \u0648 \u0646\u0648\u06CC\u0633","common":"\u0633\u0646\u062A \u06A9\u06CC\u062A\u0633 \u0648 \u0646\u0648\u06CC\u0633"},"pol":{"official":"Federacja Saint Kitts i Nevis","common":"Saint Kitts i Nevis"},"por":{"official":"Federa\xe7\xe3o de S\xe3o Crist\xf3v\xe3o e Nevis","common":"S\xe3o Crist\xf3v\xe3o e Nevis"},"rus":{"official":"\u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u044F \u0421\u0435\u043D\u0442-\u041A\u0440\u0438\u0441\u0442\u043E\u0444\u0435\u0440 \u0438 \u041D \u0435 \u0432 \u0438 \u0441","common":"\u0421\u0435\u043D\u0442-\u041A\u0438\u0442\u0441 \u0438 \u041D\u0435\u0432\u0438\u0441"},"slk":{"official":"Feder\u0EE1cia Sv\xe4t\xe9ho Kri\u0161tofa a Nevisu","common":"Sv\xe4t\xfd Kri\u0161tof a Nevis"},"spa":{"official":"Federaci\xf3n de San Crist\xf3bal y Nevis","common":"San Crist\xf3bal y Nieves"},"swe":{"official":"Federationen Saint Kitts och Nevis","common":"Saint Kitts och Nevis"},"urd":{"official":"\u0648\u0641\u0627\u0642\u0650 \u0633\u06CC\u0646\u0679 \u06A9\u06CC\u0679\u0632 \u0648 \u0646\u0627\u0648\u06CC\u0633","common":"\u0633\u06CC\u0646\u0679 \u06A9\u06CC\u0679\u0632 \u0648 \u0646\u0627\u0648\u06CC\u0633"},"zho":{"official":"\u5723\u514B\u91CC\u65AF\u6258\u5F17\u548C\u5C3C\u7EF4\u65AF\u8054\u90A6","common":"\u5723\u57FA\u8328\u548C\u5C3C\u7EF4\u65AF"}},"latlng":[17.33333333,-62.75],"landlocked":false,"borders":[],"area":261,"flag":"\uD83C\uDDF0\uD83C\uDDF3","demonyms":{"eng":{"f":"Kittitian or Nevisian","m":"Kittitian or Nevisian"},"fra":{"f":"Kittitienne-et-nevicienne","m":"Kittitien-et-nevicien"}}},{"name":{"common":"South Korea","official":"Republic of Korea","native":{"kor":{"official":"\uB300\uD55C\uBBFC\uAD6D","common":"\uD55C\uAD6D"}}},"tld":[".kr",".\uD55C\uAD6D"],"cca2":"KR","ccn3":"410","cca3":"KOR","cioc":"KOR","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"KRW":{"name":"South Korean won","symbol":"\u20A9"}},"idd":{"root":"+8","suffixes":["2"]},"capital":["Seoul"],"altSpellings":["KR","Korea, Republic of","Republic of Korea","\uB0A8\uD55C","\uB0A8\uC870\uC120"],"region":"Asia","subregion":"Eastern Asia","languages":{"kor":"Korean"},"translations":{"ces":{"official":"Korejsk\xe1 republika","common":"Ji\u017En\xed Korea"},"deu":{"official":"Republik Korea","common":"S\xfcdkorea"},"est":{"official":"Korea Vabariik","common":"L\xf5una-Korea"},"fin":{"official":"Korean tasavalta","common":"Etel\xe4-Korea"},"fra":{"official":"R\xe9publique de Cor\xe9e","common":"Cor\xe9e du Sud"},"hrv":{"official":"Republika Koreja","common":"Ju\u017Ena Koreja"},"hun":{"official":"Koreai K\xf6zt\xe1rsas\xe1g","common":"D\xe9l-Korea"},"ita":{"official":"Repubblica di Corea","common":"Corea del Sud"},"jpn":{"official":"\u5927\u97D3\u6C11\u56FD","common":"\u97D3\u56FD"},"kor":{"official":"\uB300\uD55C\uBBFC\uAD6D","common":"\uD55C\uAD6D"},"nld":{"official":"Republiek Korea","common":"Zuid-Korea"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u06A9\u0631\u0647","common":"\u06A9\u0631\u0647\u0654 \u062C\u0646\u0648\u0628\u06CC"},"pol":{"official":"Republika Korei","common":"Korea Po\u0142udniowa"},"por":{"official":"Rep\xfablica da Coreia","common":"Coreia do Sul"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u0440\u0435\u044F","common":"\u042E\u0436\u043D\u0430\u044F \u041A\u043E\u0440\u0435\u044F"},"slk":{"official":"K\xf3rejsk\xe1 republika","common":"Ju\u017En\xe1 K\xf3rea"},"spa":{"official":"Rep\xfablica de Corea","common":"Corea del Sur"},"swe":{"official":"Republiken Korea","common":"Sydkorea"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06A9\u0648\u0631\u06CC\u0627 ","common":"\u062C\u0646\u0648\u0628\u06CC \u06A9\u0648\u0631\u06CC\u0627"},"zho":{"official":"\u5927\u97E9\u6C11\u56FD","common":"\u97E9\u56FD"}},"latlng":[37,127.5],"landlocked":false,"borders":["PRK"],"area":100210,"flag":"\uD83C\uDDF0\uD83C\uDDF7","demonyms":{"eng":{"f":"South Korean","m":"South Korean"},"fra":{"f":"Sud-cor\xe9enne","m":"Sud-cor\xe9en"}}},{"name":{"common":"Kosovo","official":"Republic of Kosovo","native":{"sqi":{"official":"Republika e Kosov\xebs","common":"Kosova"},"srp":{"official":"\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u0441\u043E\u0432\u043E","common":"\u041A\u043E\u0441\u043E\u0432\u043E"}}},"tld":[".xk"],"cca2":"XK","ccn3":"","cca3":"UNK","cioc":"KOS","independent":null,"status":"user-assigned","unMember":false,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["83"]},"capital":["Pristina"],"altSpellings":["XK","\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u0441\u043E\u0432\u043E"],"region":"Europe","subregion":"Southeast Europe","languages":{"sqi":"Albanian","srp":"Serbian"},"translations":{"ces":{"official":"Kosovsk\xe1 republika","common":"Kosovo"},"deu":{"official":"Republik Kosovo","common":"Kosovo"},"est":{"official":"Kosovo Vabariik","common":"Kosovo"},"fin":{"official":"Kosovon tasavalta","common":"Kosovo"},"fra":{"official":"R\xe9publique du Kosovo","common":"Kosovo"},"hrv":{"official":"Republika Kosovo","common":"Kosovo"},"hun":{"official":"Koszov\xf3","common":"Koszov\xf3"},"ita":{"official":"Repubblica del Kosovo","common":"Kosovo"},"kor":{"official":"\uCF54\uC18C\uBCF4 \uACF5\uD654\uAD6D","common":"\uCF54\uC18C\uBCF4"},"nld":{"official":"Republiek Kosovo","common":"Kosovo"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u06A9\u0648\u0632\u0648\u0648","common":"\u06A9\u0648\u0632\u0648\u0648"},"pol":{"official":"Republika Kosowa","common":"Kosowo"},"por":{"official":"Rep\xfablica do Kosovo","common":"Kosovo"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u0441\u043E\u0432\u043E","common":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u0441\u043E\u0432\u043E"},"slk":{"official":"Republika Kosovo","common":"Kosovo"},"spa":{"official":"Rep\xfablica de Kosovo","common":"Kosovo"},"swe":{"official":"Republiken Kosovo","common":"Kosovo"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06A9\u0648\u0633\u0648\u0648\u06C1","common":"\u06A9\u0648\u0633\u0648\u0648\u06C1"},"zho":{"official":"\u79D1\u7D22\u6C83\u5171\u548C\u56FD","common":"\u79D1\u7D22\u6C83"}},"latlng":[42.666667,21.166667],"landlocked":true,"borders":["ALB","MKD","MNE","SRB"],"area":10908,"flag":"\uD83C\uDDFD\uD83C\uDDF0","demonyms":{"eng":{"f":"Kosovar","m":"Kosovar"},"fra":{"f":"Kosovare","m":"Kosovar"}}},{"name":{"common":"Kuwait","official":"State of Kuwait","native":{"ara":{"official":"\u062F\u0648\u0644\u0629 \u0627\u0644\u0643\u0648\u064A\u062A","common":"\u0627\u0644\u0643\u0648\u064A\u062A"}}},"tld":[".kw"],"cca2":"KW","ccn3":"414","cca3":"KWT","cioc":"KUW","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"KWD":{"name":"Kuwaiti dinar","symbol":"\u062F.\u0643"}},"idd":{"root":"+9","suffixes":["65"]},"capital":["Kuwait City"],"altSpellings":["KW","State of Kuwait","Dawlat al-Kuwait"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"St\xe1t Kuvajt","common":"Kuvajt"},"deu":{"official":"Staat Kuwait","common":"Kuwait"},"est":{"official":"Kuveidi Riik","common":"Kuveit"},"fin":{"official":"Kuwaitin valtio","common":"Kuwait"},"fra":{"official":"\xc9tat du Kowe\xeft","common":"Kowe\xeft"},"hrv":{"official":"Dr\u017Eava Kuvajt","common":"Kuvajt"},"hun":{"official":"Kuvaiti \xc1llam","common":"Kuvait"},"ita":{"official":"Stato del Kuwait","common":"Kuwait"},"jpn":{"official":"\u30AF\u30A6\u30A7\u30FC\u30C8\u56FD","common":"\u30AF\u30A6\u30A7\u30FC\u30C8"},"kor":{"official":"\uCFE0\uC6E8\uC774\uD2B8\uAD6D","common":"\uCFE0\uC6E8\uC774\uD2B8"},"nld":{"official":"Staat Koeweit","common":"Koeweit"},"per":{"official":"\u062F\u0648\u0644\u062A \u06A9\u0648\u06CC\u062A","common":"\u06A9\u064F\u0648\u06CC\u062A"},"pol":{"official":"Pa\u0144stwo Kuwejt","common":"Kuwejt"},"por":{"official":"Estado do Kuwait","common":"Kuwait"},"rus":{"official":"\u0413\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u043E \u041A\u0443\u0432\u0435\u0439\u0442","common":"\u041A\u0443\u0432\u0435\u0439\u0442"},"slk":{"official":"Kuvajtsk\xfd \u0161t\xe1t","common":"Kuvajt"},"spa":{"official":"Estado de Kuwait","common":"Kuwait"},"swe":{"official":"Staten Kuwait","common":"Kuwait"},"urd":{"official":"\u062F\u0648\u0644\u062A\u0650 \u06A9\u0648\u06CC\u062A","common":"\u06A9\u0648\u06CC\u062A"},"zho":{"official":"\u79D1\u5A01\u7279\u56FD","common":"\u79D1\u5A01\u7279"}},"latlng":[29.5,45.75],"landlocked":false,"borders":["IRQ","SAU"],"area":17818,"flag":"\uD83C\uDDF0\uD83C\uDDFC","demonyms":{"eng":{"f":"Kuwaiti","m":"Kuwaiti"},"fra":{"f":"Kowe\xeftienne","m":"Kowe\xeftien"}}},{"name":{"common":"Laos","official":"Lao People\'s Democratic Republic","native":{"lao":{"official":"\u0EAA\u0EB2\u0E97\u0EB2\u0EA5\u0EB0\u0E99\u0EB0 \u0E8A\u0EB2\u0E97\u0EB4\u0E9B\u0EB0\u0EC4\u0E95 \u0E84\u0EBB\u0E99\u0EA5\u0EB2\u0EA7 \u0E82\u0EAD\u0E87","common":"\u0EAA\u0E9B\u0E9B\u0EA5\u0EB2\u0EA7"}}},"tld":[".la"],"cca2":"LA","ccn3":"418","cca3":"LAO","cioc":"LAO","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"LAK":{"name":"Lao kip","symbol":"\u20AD"}},"idd":{"root":"+8","suffixes":["56"]},"capital":["Vientiane"],"altSpellings":["LA","Lao","Lao People\'s Democratic Republic","Sathalanalat Paxathipatai Paxaxon Lao"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"lao":"Lao"},"translations":{"ces":{"official":"Laosk\xe1 lidov\u011B demokratick\xe1 republika","common":"Laos"},"deu":{"official":"Demokratische Volksrepublik Laos","common":"Laos"},"est":{"official":"Laose Demokraatlik Rahvavabariik","common":"Laos"},"fin":{"official":"Laosin demokraattinen kansantasavalta","common":"Laos"},"fra":{"official":"R\xe9publique d\xe9mocratique populaire lao","common":"Laos"},"hrv":{"official":"Narodna Demokratska Republika","common":"Laos"},"hun":{"official":"Laoszi N\xe9pi Demokratikus K\xf6zt\xe1rsas\xe1g","common":"Laosz"},"ita":{"official":"Repubblica democratica popolare del Laos","common":"Laos"},"jpn":{"official":"\u30E9\u30AA\u30B9\u4EBA\u6C11\u6C11\u4E3B\u5171\u548C\u56FD","common":"\u30E9\u30AA\u30B9\u4EBA\u6C11\u6C11\u4E3B\u5171\u548C\u56FD"},"kor":{"official":"\uB77C\uC624 \uC778\uBBFC \uBBFC\uC8FC \uACF5\uD654\uAD6D","common":"\uB77C\uC624\uC2A4"},"nld":{"official":"Lao Democratische Volksrepubliek","common":"Laos"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u062F\u0645\u0648\u06A9\u0631\u0627\u062A\u06CC\u06A9 \u062E\u0644\u0642 \u0644\u0627\u0626\u0648\u0633","common":"\u0644\u0627\u0626\u0648\u0633"},"pol":{"official":"Laota\u0144ska Republika Ludowo-Demokratyczna","common":"Laos"},"por":{"official":"Laos, Rep\xfablica Democr\xe1tica","common":"Laos"},"rus":{"official":"\u041B\u0430\u043E\u0441\u0441\u043A\u0430\u044F \u041D\u0430\u0440\u043E\u0434\u043D\u043E-\u0414\u0435\u043C\u043E\u043A\u0440\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u041B\u0430\u043E\u0441"},"slk":{"official":"Laosk\xe1 \u013Eudovodemokratick\xe1 republika","common":"Laos"},"spa":{"official":"Rep\xfablica Democr\xe1tica Popular Lao","common":"Laos"},"swe":{"official":"Demokratiska folkrepubliken Laos","common":"Laos"},"urd":{"official":"\u0639\u0648\u0627\u0645\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0644\u0627\u0624","common":"\u0644\u0627\u0624\u0633"},"zho":{"official":"\u8001\u631D\u4EBA\u6C11\u6C11\u4E3B\u5171\u548C\u56FD","common":"\u8001\u631D"}},"latlng":[18,105],"landlocked":true,"borders":["MMR","KHM","CHN","THA","VNM"],"area":236800,"flag":"\uD83C\uDDF1\uD83C\uDDE6","demonyms":{"eng":{"f":"Laotian","m":"Laotian"},"fra":{"f":"Laotienne","m":"Laotien"}}},{"name":{"common":"Lebanon","official":"Lebanese Republic","native":{"ara":{"official":"\u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0644\u0628\u0646\u0627\u0646\u064A\u0629","common":"\u0644\u0628\u0646\u0627\u0646"},"fra":{"official":"R\xe9publique libanaise","common":"Liban"}}},"tld":[".lb"],"cca2":"LB","ccn3":"422","cca3":"LBN","cioc":"LBN","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"LBP":{"name":"Lebanese pound","symbol":"\u0644.\u0644"}},"idd":{"root":"+9","suffixes":["61"]},"capital":["Beirut"],"altSpellings":["LB","Lebanese Republic","Al-Jumh\u016Br\u012Byah Al-Libn\u0101n\u012Byah"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic","fra":"French"},"translations":{"ces":{"official":"Libanonsk\xe1 republika","common":"Libanon"},"deu":{"official":"Libanesische Republik","common":"Libanon"},"est":{"official":"Liibanoni Vabariik","common":"Liibanon"},"fin":{"official":"Libanonin tasavalta","common":"Libanon"},"fra":{"official":"R\xe9publique libanaise","common":"Liban"},"hrv":{"official":"Libanonska Republika","common":"Libanon"},"hun":{"official":"Libanoni K\xf6zt\xe1rsas\xe1g","common":"Libanon"},"ita":{"official":"Repubblica libanese","common":"Libano"},"jpn":{"official":"\u30EC\u30D0\u30CE\u30F3\u5171\u548C\u56FD","common":"\u30EC\u30D0\u30CE\u30F3"},"kor":{"official":"\uB808\uBC14\uB17C \uACF5\uD654\uAD6D","common":"\uB808\uBC14\uB17C"},"nld":{"official":"Libanese Republiek","common":"Libanon"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0644\u0628\u0646\u0627\u0646","common":"\u0644\u0628\u0646\u0627\u0646"},"pol":{"official":"Republika Liba\u0144ska","common":"Liban"},"por":{"official":"Rep\xfablica Libanesa","common":"L\xedbano"},"rus":{"official":"\u041B\u0438\u0432\u0430\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u041B\u0438\u0432\u0430\u043D"},"slk":{"official":"Libanonsk\xe1 republika","common":"Libanon"},"spa":{"official":"Rep\xfablica Libanesa","common":"L\xedbano"},"swe":{"official":"Republiken Libanon","common":"Libanon"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0644\u0628\u0646\u0627\u0646","common":"\u0644\u0628\u0646\u0627\u0646"},"zho":{"official":"\u9ECE\u5DF4\u5AE9\u5171\u548C\u56FD","common":"\u9ECE\u5DF4\u5AE9"}},"latlng":[33.83333333,35.83333333],"landlocked":false,"borders":["ISR","SYR"],"area":10452,"flag":"\uD83C\uDDF1\uD83C\uDDE7","demonyms":{"eng":{"f":"Lebanese","m":"Lebanese"},"fra":{"f":"Libanaise","m":"Libanais"}}},{"name":{"common":"Liberia","official":"Republic of Liberia","native":{"eng":{"official":"Republic of Liberia","common":"Liberia"}}},"tld":[".lr"],"cca2":"LR","ccn3":"430","cca3":"LBR","cioc":"LBR","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"LRD":{"name":"Liberian dollar","symbol":"$"}},"idd":{"root":"+2","suffixes":["31"]},"capital":["Monrovia"],"altSpellings":["LR","Republic of Liberia"],"region":"Africa","subregion":"Western Africa","languages":{"eng":"English"},"translations":{"ces":{"official":"Liberijsk\xe1 republika","common":"Lib\xe9rie"},"deu":{"official":"Republik Liberia","common":"Liberia"},"est":{"official":"Libeeria Vabariik","common":"Libeeria"},"fin":{"official":"Liberian tasavalta","common":"Liberia"},"fra":{"official":"R\xe9publique du Lib\xe9ria","common":"Liberia"},"hrv":{"official":"Republika Liberija","common":"Liberija"},"hun":{"official":"Lib\xe9riai K\xf6zt\xe1rsas\xe1g","common":"Lib\xe9ria"},"ita":{"official":"Repubblica di Liberia","common":"Liberia"},"jpn":{"official":"\u30EA\u30D9\u30EA\u30A2\u5171\u548C\u56FD","common":"\u30EA\u30D9\u30EA\u30A2"},"kor":{"official":"\uB77C\uC774\uBCA0\uB9AC\uC544 \uACF5\uD654\uAD6D","common":"\uB77C\uC774\uBCA0\uB9AC\uC544"},"nld":{"official":"Republiek Liberia","common":"Liberia"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0644\u06CC\u0628\u0631\u06CC\u0627","common":"\u0644\u06CC\u0628\u0640\u0650\u0631\u06CC\u0627"},"pol":{"official":"Republika Liberii","common":"Liberia"},"por":{"official":"Rep\xfablica da Lib\xe9ria","common":"Lib\xe9ria"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041B\u0438\u0431\u0435\u0440\u0438\u044F","common":"\u041B\u0438\u0431\u0435\u0440\u0438\u044F"},"slk":{"official":"Lib\xe9rijsk\xe1 republika","common":"Lib\xe9ria"},"spa":{"official":"Rep\xfablica de Liberia","common":"Liberia"},"swe":{"official":"Republiken Liberia","common":"Liberia"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0644\u0627\u0626\u0628\u06CC\u0631\u06CC\u0627","common":"\u0644\u0627\u0626\u0628\u06CC\u0631\u06CC\u0627"},"zho":{"official":"\u5229\u6BD4\u91CC\u4E9A\u5171\u548C\u56FD","common":"\u5229\u6BD4\u91CC\u4E9A"}},"latlng":[6.5,-9.5],"landlocked":false,"borders":["GIN","CIV","SLE"],"area":111369,"flag":"\uD83C\uDDF1\uD83C\uDDF7","demonyms":{"eng":{"f":"Liberian","m":"Liberian"},"fra":{"f":"Lib\xe9rienne","m":"Lib\xe9rien"}}},{"name":{"common":"Libya","official":"State of Libya","native":{"ara":{"official":"\u0627\u0644\u062F\u0648\u0644\u0629 \u0644\u064A\u0628\u064A\u0627","common":"\u200F\u0644\u064A\u0628\u064A\u0627"}}},"tld":[".ly"],"cca2":"LY","ccn3":"434","cca3":"LBY","cioc":"LBA","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"LYD":{"name":"Libyan dinar","symbol":"\u0644.\u062F"}},"idd":{"root":"+2","suffixes":["18"]},"capital":["Tripoli"],"altSpellings":["LY","State of Libya","Dawlat Libya"],"region":"Africa","subregion":"Northern Africa","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"St\xe1t Libye","common":"Libye"},"deu":{"official":"Staat Libyen","common":"Libyen"},"est":{"official":"Liib\xfca","common":"Liib\xfca"},"fin":{"official":"Libyan valtio","common":"Libya"},"fra":{"official":"Grande R\xe9publique arabe libyenne populaire et socialiste","common":"Libye"},"hrv":{"official":"Dr\u017Eava Libiji","common":"Libija"},"hun":{"official":"L\xedbia \xc1llam","common":"L\xedbia"},"ita":{"official":"Stato della Libia","common":"Libia"},"jpn":{"official":"\u30EA\u30D3\u30A2\u306E\u56FD\u5BB6","common":"\u30EA\u30D3\u30A2"},"kor":{"official":"\uB9AC\uBE44\uC544","common":"\uB9AC\uBE44\uC544"},"nld":{"official":"Staat van Libi\xeb","common":"Libi\xeb"},"per":{"official":"\u062F\u0648\u0644\u062A \u0644\u06CC\u0628\u06CC","common":"\u0644\u06CC\u0628\u06CC"},"pol":{"official":"Pa\u0144stwo Libia","common":"Libia"},"por":{"official":"Estado da L\xedbia","common":"L\xedbia"},"rus":{"official":"\u0413\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u043E \u041B\u0438\u0432\u0438\u0438","common":"\u041B\u0438\u0432\u0438\u044F"},"slk":{"official":"L\xedbya","common":"L\xedbya"},"spa":{"official":"Estado de Libia","common":"Libia"},"swe":{"official":"Staten Libyen","common":"Libyen"},"urd":{"official":"\u0631\u06CC\u0627\u0633\u062A\u0650 \u0644\u06CC\u0628\u06CC\u0627","common":"\u0644\u06CC\u0628\u06CC\u0627"},"zho":{"official":"\u5229\u6BD4\u4E9A\u56FD","common":"\u5229\u6BD4\u4E9A"}},"latlng":[25,17],"landlocked":false,"borders":["DZA","TCD","EGY","NER","SDN","TUN"],"area":1759540,"flag":"\uD83C\uDDF1\uD83C\uDDFE","demonyms":{"eng":{"f":"Libyan","m":"Libyan"},"fra":{"f":"Libyenne","m":"Libyen"}}},{"name":{"common":"Saint Lucia","official":"Saint Lucia","native":{"eng":{"official":"Saint Lucia","common":"Saint Lucia"}}},"tld":[".lc"],"cca2":"LC","ccn3":"662","cca3":"LCA","cioc":"LCA","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"XCD":{"name":"Eastern Caribbean dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["758"]},"capital":["Castries"],"altSpellings":["LC"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Svat\xe1 Lucie","common":"Svat\xe1 Lucie"},"deu":{"official":"St. Lucia","common":"St. Lucia"},"est":{"official":"Saint Lucia","common":"Saint Lucia"},"fin":{"official":"Saint Lucia","common":"Saint Lucia"},"fra":{"official":"Sainte-Lucie","common":"Sainte-Lucie"},"hrv":{"official":"Sveta Lucija","common":"Sveta Lucija"},"hun":{"official":"Saint Lucia","common":"Saint Lucia"},"ita":{"official":"Santa Lucia","common":"Santa Lucia"},"jpn":{"official":"\u30BB\u30F3\u30C8\u30EB\u30B7\u30A2","common":"\u30BB\u30F3\u30C8\u30EB\u30B7\u30A2"},"kor":{"official":"\uC138\uC778\uD2B8\uB8E8\uC2DC\uC544","common":"\uC138\uC778\uD2B8\uB8E8\uC2DC\uC544"},"nld":{"official":"Saint Lucia","common":"Saint Lucia"},"per":{"official":"\u0633\u0646\u062A \u0644\u0648\u0633\u06CC\u0627","common":"\u0633\u0646\u062A \u0644\u0648\u0633\u06CC\u0627"},"pol":{"official":"Saint Lucia","common":"Saint Lucia"},"por":{"official":"Santa L\xfacia","common":"Santa L\xfacia"},"rus":{"official":"\u0421\u0435\u043D\u0442-\u041B\u044E\u0441\u0438\u044F","common":"\u0421\u0435\u043D\u0442-\u041B\u044E\u0441\u0438\u044F"},"slk":{"official":"Sv\xe4t\xe1 Lucia","common":"Sv\xe4t\xe1 Lucia"},"spa":{"official":"Santa Luc\xeda","common":"Santa Luc\xeda"},"swe":{"official":"Saint Lucia","common":"Saint Lucia"},"urd":{"official":"\u0633\u06CC\u0646\u0679 \u0644\u0648\u0633\u06CC\u0627","common":"\u0633\u06CC\u0646\u0679 \u0644\u0648\u0633\u06CC\u0627"},"zho":{"official":"\u5723\u5362\u897F\u4E9A","common":"\u5723\u5362\u897F\u4E9A"}},"latlng":[13.88333333,-60.96666666],"landlocked":false,"borders":[],"area":616,"flag":"\uD83C\uDDF1\uD83C\uDDE8","demonyms":{"eng":{"f":"Saint Lucian","m":"Saint Lucian"},"fra":{"f":"Saint-Lucienne","m":"Saint-Lucien"}}},{"name":{"common":"Liechtenstein","official":"Principality of Liechtenstein","native":{"deu":{"official":"F\xfcrstentum Liechtenstein","common":"Liechtenstein"}}},"tld":[".li"],"cca2":"LI","ccn3":"438","cca3":"LIE","cioc":"LIE","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"CHF":{"name":"Swiss franc","symbol":"Fr"}},"idd":{"root":"+4","suffixes":["23"]},"capital":["Vaduz"],"altSpellings":["LI","Principality of Liechtenstein","F\xfcrstentum Liechtenstein"],"region":"Europe","subregion":"Western Europe","languages":{"deu":"German"},"translations":{"ces":{"official":"Kn\xed\u017Eectv\xed Lichten\u0161tejnsk\xe9","common":"Lichten\u0161tejnsko"},"deu":{"official":"F\xfcrstentum Liechtenstein","common":"Liechtenstein"},"est":{"official":"Liechtensteini V\xfcrstiriik","common":"Liechtenstein"},"fin":{"official":"Liechensteinin ruhtinaskunta","common":"Liechenstein"},"fra":{"official":"Principaut\xe9 du Liechtenstein","common":"Liechtenstein"},"hrv":{"official":"Kne\u017Eevina Lihten\u0161tajn","common":"Lihten\u0161tajn"},"hun":{"official":"Liechtensteini Hercegs\xe9g","common":"Liechtenstein"},"ita":{"official":"Principato del Liechtenstein","common":"Liechtenstein"},"jpn":{"official":"\u30EA\u30D2\u30C6\u30F3\u30B7\u30E5\u30BF\u30A4\u30F3\u516C\u56FD","common":"\u30EA\u30D2\u30C6\u30F3\u30B7\u30E5\u30BF\u30A4\u30F3"},"kor":{"official":"\uB9AC\uD788\uD150\uC288\uD0C0\uC778 \uACF5\uAD6D","common":"\uB9AC\uD788\uD150\uC288\uD0C0\uC778"},"nld":{"official":"Vorstendom Liechtenstein","common":"Liechtenstein"},"per":{"official":"\u0634\u0627\u0647\u0632\u0627\u062F\u0647\u200C\u0646\u0634\u06CC\u0646 \u0644\u06CC\u062E\u062A\u0646\u200C\u0627\u0634\u062A\u0627\u06CC\u0646","common":"\u0644\u06CC\u062E\u062A\u0646\u200C\u0627\u0634\u062A\u0627\u06CC\u0646"},"pol":{"official":"Ksi\u0119stwo Liechtensteinu","common":"Liechtenstein"},"por":{"official":"Principado de Liechtenstein","common":"Liechtenstein"},"rus":{"official":"\u041A\u043D\u044F\u0436\u0435\u0441\u0442\u0432\u043E \u041B\u0438\u0445\u0442\u0435\u043D\u0448\u0442\u0435\u0439\u043D","common":"\u041B\u0438\u0445\u0442\u0435\u043D\u0448\u0442\u0435\u0439\u043D"},"slk":{"official":"Lichten\u0161tajnsk\xe9 knie\u017Eatstvo","common":"Lichten\u0161tajnsko"},"spa":{"official":"Principado de Liechtenstein","common":"Liechtenstein"},"swe":{"official":"Furstend\xf6met Liechtenstein","common":"Liechtenstein"},"urd":{"official":"\u0627\u0645\u0627\u0631\u0627\u062A \u0644\u06CC\u062E\u062A\u06CC\u0646\u0633\u062A\u0627\u0626\u0646","common":"\u0644\u06CC\u062E\u062A\u06CC\u0646\u0633\u062A\u0627\u0626\u0646"},"zho":{"official":"\u5217\u652F\u6566\u58EB\u767B\u516C\u56FD","common":"\u5217\u652F\u6566\u58EB\u767B"}},"latlng":[47.26666666,9.53333333],"landlocked":true,"borders":["AUT","CHE"],"area":160,"flag":"\uD83C\uDDF1\uD83C\uDDEE","demonyms":{"eng":{"f":"Liechtensteiner","m":"Liechtensteiner"},"fra":{"f":"Liechtensteinoise","m":"Liechtensteinois"}}},{"name":{"common":"Sri Lanka","official":"Democratic Socialist Republic of Sri Lanka","native":{"sin":{"official":"\u0DC1\u0DCA\u200D\u0DBB\u0DD3 \u0DBD\u0D82\u0D9A\u0DCF \u0DB4\u0DCA\u200D\u0DBB\u0DA2\u0DCF\u0DAD\u0DCF\u0DB1\u0DCA\u0DAD\u0DCA\u200D\u0DBB\u0DD2\u0D9A \u0DC3\u0DB8\u0DCF\u0DA2\u0DC0\u0DCF\u0DAF\u0DD3 \u0DA2\u0DB1\u0DBB\u0DA2\u0DBA","common":"\u0DC1\u0DCA\u200D\u0DBB\u0DD3 \u0DBD\u0D82\u0D9A\u0DCF\u0DC0"},"tam":{"official":"\u0B87\u0BB2\u0B99\u0BCD\u0B95\u0BC8 \u0B9A\u0BA9\u0BA8\u0BBE\u0BAF\u0B95 \u0B9A\u0BCB\u0B9A\u0BB2\u0BBF\u0B9A\u0B95\u0BCD \u0B95\u0BC1\u0B9F\u0BBF\u0BAF\u0BB0\u0B9A\u0BC1","common":"\u0B87\u0BB2\u0B99\u0BCD\u0B95\u0BC8"}}},"tld":[".lk",".\u0B87\u0BB2\u0B99\u0BCD\u0B95\u0BC8",".\u0DBD\u0D82\u0D9A\u0DCF"],"cca2":"LK","ccn3":"144","cca3":"LKA","cioc":"SRI","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"LKR":{"name":"Sri Lankan rupee","symbol":"Rs  \u0DBB\u0DD4"}},"idd":{"root":"+9","suffixes":["4"]},"capital":["Colombo"],"altSpellings":["LK","ila\u1E45kai","Democratic Socialist Republic of Sri Lanka"],"region":"Asia","subregion":"Southern Asia","languages":{"sin":"Sinhala","tam":"Tamil"},"translations":{"ces":{"official":"Sr\xedlansk\xe1 demokratick\xe1 socialistick\xe1 republika","common":"Sr\xed Lanka"},"deu":{"official":"Demokratische Sozialistische Republik Sri Lanka","common":"Sri Lanka"},"est":{"official":"Sri Lanka Demokraatlik Sotsialistlik Vabariik","common":"Sri Lanka"},"fin":{"official":"Sri Lankan demokraattinen sosialistinen tasavalta","common":"Sri Lanka"},"fra":{"official":"R\xe9publique d\xe9mocratique socialiste du Sri Lanka","common":"Sri Lanka"},"hrv":{"official":"Demokratska Socijalisti\u010Dke Republike \u0160ri Lanke","common":"\u0160ri Lanka"},"hun":{"official":"Sr\xed Lanka-i Demokratikus Szocialista K\xf6zt\xe1rsas\xe1g","common":"Sr\xed Lanka"},"ita":{"official":"Repubblica democratica socialista dello Sri Lanka","common":"Sri Lanka"},"jpn":{"official":"\u30B9\u30EA\u30E9\u30F3\u30AB\u6C11\u4E3B\u793E\u4F1A\u4E3B\u7FA9\u5171\u548C\u56FD","common":"\u30B9\u30EA\u30E9\u30F3\u30AB"},"kor":{"official":"\uC2A4\uB9AC\uB791\uCE74 \uBBFC\uC8FC \uC0AC\uD68C\uC8FC\uC758 \uACF5\uD654\uAD6D","common":"\uC2A4\uB9AC\uB791\uCE74"},"nld":{"official":"Democratische Socialistische Republiek Sri Lanka","common":"Sri Lanka"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u062F\u0645\u0648\u06A9\u0631\u0627\u062A\u06CC\u06A9 \u0633\u0648\u0633\u06CC\u0627\u0644\u06CC\u0633\u062A\u06CC \u0633\u0631\u06CC\u200C\u0644\u0627\u0646\u06A9\u0627","common":"\u0633\u0631\u06CC\u200C\u0644\u0627\u0646\u06A9\u0627"},"pol":{"official":"Demokratyczno-Socjalistyczna Republika Sri Lanki","common":"Sri Lanka"},"por":{"official":"Rep\xfablica Democr\xe1tica Socialista do Sri Lanka","common":"Sri Lanka"},"rus":{"official":"\u0414\u0435\u043C\u043E\u043A\u0440\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0421\u043E\u0446\u0438\u0430\u043B\u0438\u0441\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0428\u0440\u0438-\u041B\u0430\u043D\u043A\u0430","common":"\u0428\u0440\u0438-\u041B\u0430\u043D\u043A\u0430"},"slk":{"official":"Sr\xedlansk\xe1 demokratick\xe1 socialistick\xe1 republika","common":"Sr\xed Lanka"},"spa":{"official":"Rep\xfablica Democr\xe1tica Socialista de Sri Lanka","common":"Sri Lanka"},"swe":{"official":"Demokratiska socialistiska republiken Sri Lanka","common":"Sri Lanka"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC \u0648 \u0627\u0634\u062A\u0631\u0627\u06A9\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0633\u0631\u06CC \u0644\u0646\u06A9\u0627","common":"\u0633\u0631\u06CC \u0644\u0646\u06A9\u0627"},"zho":{"official":"\u65AF\u91CC\u5170\u5361\u6C11\u4E3B\u793E\u4F1A\u4E3B\u4E49\u5171\u548C\u56FD","common":"\u65AF\u91CC\u5170\u5361"}},"latlng":[7,81],"landlocked":false,"borders":["IND"],"area":65610,"flag":"\uD83C\uDDF1\uD83C\uDDF0","demonyms":{"eng":{"f":"Sri Lankan","m":"Sri Lankan"},"fra":{"f":"Sri-lankaise","m":"Sri-lankais"}}},{"name":{"common":"Lesotho","official":"Kingdom of Lesotho","native":{"eng":{"official":"Kingdom of Lesotho","common":"Lesotho"},"sot":{"official":"Kingdom of Lesotho","common":"Lesotho"}}},"tld":[".ls"],"cca2":"LS","ccn3":"426","cca3":"LSO","cioc":"LES","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"LSL":{"name":"Lesotho loti","symbol":"L"},"ZAR":{"name":"South African rand","symbol":"R"}},"idd":{"root":"+2","suffixes":["66"]},"capital":["Maseru"],"altSpellings":["LS","Kingdom of Lesotho","Muso oa Lesotho"],"region":"Africa","subregion":"Southern Africa","languages":{"eng":"English","sot":"Sotho"},"translations":{"ces":{"official":"Lesothsk\xe9 kr\xe1lovstv\xed","common":"Lesotho"},"deu":{"official":"K\xf6nigreich Lesotho","common":"Lesotho"},"est":{"official":"Lesotho Kuningriik","common":"Lesotho"},"fin":{"official":"Lesothon kuningaskunta","common":"Lesotho"},"fra":{"official":"Royaume du Lesotho","common":"Lesotho"},"hrv":{"official":"Kraljevina Lesoto","common":"Lesoto"},"hun":{"official":"Lesoth\xf3i Kir\xe1lys\xe1g","common":"Lesotho"},"ita":{"official":"Regno del Lesotho","common":"Lesotho"},"jpn":{"official":"\u30EC\u30BD\u30C8\u738B\u56FD","common":"\u30EC\u30BD\u30C8"},"kor":{"official":"\uB808\uC18C\uD1A0 \uC655\uAD6D","common":"\uB808\uC18C\uD1A0"},"nld":{"official":"Koninkrijk Lesotho","common":"Lesotho"},"per":{"official":"\u067E\u0627\u062F\u0634\u0627\u0647\u06CC \u0644\u0633\u0648\u062A\u0648","common":"\u0644\u0633\u0648\u062A\u0648"},"pol":{"official":"Kr\xf3lestwo Lesotho","common":"Lesotho"},"por":{"official":"Reino do Lesoto","common":"Lesoto"},"rus":{"official":"\u041A\u043E\u0440\u043E\u043B\u0435\u0432\u0441\u0442\u0432\u043E \u041B\u0435\u0441\u043E\u0442\u043E","common":"\u041B\u0435\u0441\u043E\u0442\u043E"},"slk":{"official":"Lesothsk\xe9 kr\xe1\u013Eovstvo","common":"Lesotho"},"spa":{"official":"Reino de Lesotho","common":"Lesotho"},"swe":{"official":"Konungariket Lesotho","common":"Lesotho"},"urd":{"official":"\u0645\u0645\u0644\u06A9\u062A\u0650 \u0644\u06CC\u0633\u0648\u062A\u06BE\u0648","common":"\u0644\u06CC\u0633\u0648\u062A\u06BE\u0648"},"zho":{"official":"\u83B1\u7D22\u6258\u738B\u56FD","common":"\u83B1\u7D22\u6258"}},"latlng":[-29.5,28.5],"landlocked":true,"borders":["ZAF"],"area":30355,"flag":"\uD83C\uDDF1\uD83C\uDDF8","demonyms":{"eng":{"f":"Mosotho","m":"Mosotho"},"fra":{"f":"L\xe9sothienne","m":"L\xe9sothien"}}},{"name":{"common":"Lithuania","official":"Republic of Lithuania","native":{"lit":{"official":"Lietuvos Respublikos","common":"Lietuva"}}},"tld":[".lt"],"cca2":"LT","ccn3":"440","cca3":"LTU","cioc":"LTU","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["70"]},"capital":["Vilnius"],"altSpellings":["LT","Republic of Lithuania","Lietuvos Respublika"],"region":"Europe","subregion":"Northern Europe","languages":{"lit":"Lithuanian"},"translations":{"ces":{"official":"Litevsk\xe1 republika","common":"Litva"},"deu":{"official":"Republik Litauen","common":"Litauen"},"est":{"official":"Leedu Vabariik","common":"Leedu"},"fin":{"official":"Liettuan tasavalta","common":"Liettua"},"fra":{"official":"R\xe9publique de Lituanie","common":"Lituanie"},"hrv":{"official":"Republika Litva","common":"Litva"},"hun":{"official":"Litv\xe1n K\xf6zt\xe1rsas\xe1g","common":"Litv\xe1nia"},"ita":{"official":"Repubblica di Lituania","common":"Lituania"},"jpn":{"official":"\u30EA\u30C8\u30A2\u30CB\u30A2\u5171\u548C\u56FD","common":"\u30EA\u30C8\u30A2\u30CB\u30A2"},"kor":{"official":"\uB9AC\uD22C\uC544\uB2C8\uC544 \uACF5\uD654\uAD6D","common":"\uB9AC\uD22C\uC544\uB2C8\uC544"},"nld":{"official":"Republiek Litouwen","common":"Litouwen"},"per":{"official":"\u0644\u06CC\u062A\u0648\u0627\u0646\u06CC\u0627\u06CC\u06CC\u200C\u0647\u0627","common":"\u0644\u06CC\u062A\u0648\u0627\u0646\u06CC\u0627\u06CC\u06CC\u200C\u0647\u0627"},"pol":{"official":"Republika Litewska","common":"Litwa"},"por":{"official":"Rep\xfablica da Litu\xe2nia","common":"Litu\xe2nia"},"rus":{"official":"\u041B\u0438\u0442\u043E\u0432\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u041B\u0438\u0442\u0432\u0430"},"slk":{"official":"Litovsk\xe1 republika","common":"Litva"},"spa":{"official":"Rep\xfablica de Lituania","common":"Lituania"},"swe":{"official":"Republiken Litauen","common":"Litauen"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0644\u062A\u06BE\u0648\u0648\u06CC\u0646\u06CC\u0627","common":"\u0644\u062A\u06BE\u0648\u0648\u06CC\u0646\u06CC\u0627"},"zho":{"official":"\u7ACB\u9676\u5B9B\u5171\u548C\u56FD","common":"\u7ACB\u9676\u5B9B"}},"latlng":[56,24],"landlocked":false,"borders":["BLR","LVA","POL","RUS"],"area":65300,"flag":"\uD83C\uDDF1\uD83C\uDDF9","demonyms":{"eng":{"f":"Lithuanian","m":"Lithuanian"},"fra":{"f":"Lituanienne","m":"Lituanien"}}},{"name":{"common":"Luxembourg","official":"Grand Duchy of Luxembourg","native":{"deu":{"official":"Gro\xdfherzogtum Luxemburg","common":"Luxemburg"},"fra":{"official":"Grand-Duch\xe9 de Luxembourg","common":"Luxembourg"},"ltz":{"official":"Groussherzogtum L\xebtzebuerg","common":"L\xebtzebuerg"}}},"tld":[".lu"],"cca2":"LU","ccn3":"442","cca3":"LUX","cioc":"LUX","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["52"]},"capital":["Luxembourg"],"altSpellings":["LU","Grand Duchy of Luxembourg","Grand-Duch\xe9 de Luxembourg","Gro\xdfherzogtum Luxemburg","Groussherzogtum L\xebtzebuerg"],"region":"Europe","subregion":"Western Europe","languages":{"deu":"German","fra":"French","ltz":"Luxembourgish"},"translations":{"ces":{"official":"Lucembursk\xe9 velkov\xe9vodstv\xed","common":"Lucembursko"},"deu":{"official":"Gro\xdfherzogtum Luxemburg,","common":"Luxemburg"},"est":{"official":"Luksemburgi Suurhertsogiriik","common":"Luksemburg"},"fin":{"official":"Luxemburgin suurherttuakunta","common":"Luxemburg"},"fra":{"official":"Grand-Duch\xe9 de Luxembourg","common":"Luxembourg"},"hrv":{"official":"Veliko Vojvodstvo Luksemburg","common":"Luksemburg"},"hun":{"official":"Luxemburgi Nagyhercegs\xe9g","common":"Luxemburg"},"ita":{"official":"Granducato di Lussemburgo","common":"Lussemburgo"},"jpn":{"official":"\u30EB\u30AF\u30BB\u30F3\u30D6\u30EB\u30AF\u5927\u516C\u56FD","common":"\u30EB\u30AF\u30BB\u30F3\u30D6\u30EB\u30AF"},"kor":{"official":"\uB8E9\uC148\uBD80\uB974\uD06C \uB300\uACF5\uAD6D","common":"\uB8E9\uC148\uBD80\uB974\uD06C"},"nld":{"official":"Groothertogdom Luxemburg","common":"Luxemburg"},"per":{"official":"\u062F\u0648\u06A9\u200C\u0646\u0634\u06CC\u0646 \u0644\u0648\u06A9\u0632\u0627\u0645\u0628\u0648\u0631\u06AF","common":"\u0644\u0648\u06A9\u0632\u0627\u0645\u0628\u0648\u0631\u06AF"},"pol":{"official":"Wielkie Ksi\u0119stwo Luksemburga","common":"Luksemburg"},"por":{"official":"Gr\xe3o-Ducado do Luxemburgo","common":"Luxemburgo"},"rus":{"official":"\u0412\u0435\u043B\u0438\u043A\u043E\u0435 \u0413\u0435\u0440\u0446\u043E\u0433\u0441\u0442\u0432\u043E \u041B\u044E\u043A\u0441\u0435\u043C\u0431\u0443\u0440\u0433","common":"\u041B\u044E\u043A\u0441\u0435\u043C\u0431\u0443\u0440\u0433"},"slk":{"official":"Luxembursk\xe9 ve\u013Ekovojvodstvo","common":"Luxembursko"},"spa":{"official":"Gran Ducado de Luxemburgo","common":"Luxemburgo"},"swe":{"official":"Storhertigd\xf6met Luxemburg","common":"Luxemburg"},"urd":{"official":"\u062F\u0648\u0642\u06CC\u06C1 \u06A9\u0628\u06CC\u0631\u0644\u06A9\u0633\u0645\u0628\u0631\u06AF","common":"\u0644\u06A9\u0633\u0645\u0628\u0631\u06AF"},"zho":{"official":"\u5362\u68EE\u5821\u5927\u516C\u56FD","common":"\u5362\u68EE\u5821"}},"latlng":[49.75,6.16666666],"landlocked":true,"borders":["BEL","FRA","DEU"],"area":2586,"flag":"\uD83C\uDDF1\uD83C\uDDFA","demonyms":{"eng":{"f":"Luxembourger","m":"Luxembourger"},"fra":{"f":"Luxembourgeoise","m":"Luxembourgeois"}}},{"name":{"common":"Latvia","official":"Republic of Latvia","native":{"lav":{"official":"Latvijas Republikas","common":"Latvija"}}},"tld":[".lv"],"cca2":"LV","ccn3":"428","cca3":"LVA","cioc":"LAT","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["71"]},"capital":["Riga"],"altSpellings":["LV","Republic of Latvia","Latvijas Republika"],"region":"Europe","subregion":"Northern Europe","languages":{"lav":"Latvian"},"translations":{"ces":{"official":"Loty\u0161sk\xe1 republika","common":"Loty\u0161sko"},"deu":{"official":"Republik Lettland","common":"Lettland"},"est":{"official":"L\xe4ti Vabariik","common":"L\xe4ti"},"fin":{"official":"Latvian tasavalta","common":"Latvia"},"fra":{"official":"R\xe9publique de Lettonie","common":"Lettonie"},"hrv":{"official":"Republika Latvija","common":"Latvija"},"hun":{"official":"Lett K\xf6zt\xe1rsas\xe1g","common":"Lettorsz\xe1g"},"ita":{"official":"Repubblica di Lettonia","common":"Lettonia"},"jpn":{"official":"\u30E9\u30C8\u30D3\u30A2\u5171\u548C\u56FD","common":"\u30E9\u30C8\u30D3\u30A2"},"kor":{"official":"\uB77C\uD2B8\uBE44\uC544 \uACF5\uD654\uAD6D","common":"\uB77C\uD2B8\uBE44\uC544"},"nld":{"official":"Republiek Letland","common":"Letland"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0644\u062A\u0648\u0646\u06CC","common":"\u0644\u062A\u0648\u0646\u06CC"},"pol":{"official":"Republika \u0141otewska","common":"\u0141otwa"},"por":{"official":"Rep\xfablica da Let\xf3nia","common":"Let\xf3nia"},"rus":{"official":"\u041B\u0430\u0442\u0432\u0438\u0439\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u041B\u0430\u0442\u0432\u0438\u044F"},"slk":{"official":"Loty\u0161sk\xe1 republika","common":"Loty\u0161sko"},"spa":{"official":"Rep\xfablica de Letonia","common":"Letonia"},"swe":{"official":"Republiken Lettland","common":"Lettland"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0644\u0679\u0648\u06CC\u0627","common":"\u0644\u0679\u0648\u06CC\u0627"},"zho":{"official":"\u62C9\u8131\u7EF4\u4E9A\u5171\u548C\u56FD","common":"\u62C9\u8131\u7EF4\u4E9A"}},"latlng":[57,25],"landlocked":false,"borders":["BLR","EST","LTU","RUS"],"area":64559,"flag":"\uD83C\uDDF1\uD83C\uDDFB","demonyms":{"eng":{"f":"Latvian","m":"Latvian"},"fra":{"f":"Lettone","m":"Letton"}}},{"name":{"common":"Macau","official":"Macao Special Administrative Region of the People\'s Republic of China","native":{"por":{"official":"Regi\xe3o Administrativa Especial de Macau da Rep\xfablica Popular da China","common":"Macau"},"zho":{"official":"\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u6FB3\u95E8\u7279\u522B\u884C\u653F\u533A","common":"\u6FB3\u95E8"}}},"tld":[".mo"],"cca2":"MO","ccn3":"446","cca3":"MAC","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"MOP":{"name":"Macanese pataca","symbol":"P"}},"idd":{"root":"+8","suffixes":["53"]},"capital":[],"altSpellings":["MO","\u6FB3\u95E8","Macao","Macao Special Administrative Region of the People\'s Republic of China","\u4E2D\u83EF\u4EBA\u6C11\u5171\u548C\u570B\u6FB3\u9580\u7279\u5225\u884C\u653F\u5340","Regi\xe3o Administrativa Especial de Macau da Rep\xfablica Popular da China"],"region":"Asia","subregion":"Eastern Asia","languages":{"por":"Portuguese","zho":"Chinese"},"translations":{"ces":{"official":"Zvl\xe1\u0161tn\xed spr\xe1vn\xed oblast \u010C\xednsk\xe9 lidov\xe9 republiky Macao","common":"Macao"},"deu":{"official":"Sonderverwaltungsregion Macau der Volksrepublik China","common":"Macao"},"est":{"official":"Macau erihalduspiirkond","common":"Macau"},"fin":{"official":"Macaon Kiinan kansantasavallan erityishallintoalue","common":"Macao"},"fra":{"official":"R\xe9gion administrative sp\xe9ciale de Macao de la R\xe9publique populaire de Chine","common":"Macao"},"hrv":{"official":"Makao Posebnog upravnog podru\u010DjaNarodne Republike Kine","common":"Makao"},"hun":{"official":"Maka\xf3","common":"Maka\xf3"},"ita":{"official":"Macao Regione amministrativa speciale della Repubblica Popolare Cinese","common":"Macao"},"jpn":{"official":"\u4E2D\u83EF\u4EBA\u6C11\u5171\u548C\u56FD\u30DE\u30AB\u30AA\u7279\u5225\u884C\u653F\u533A","common":"\u30DE\u30AB\u30AA"},"kor":{"official":"\uC911\uD654\uC778\uBBFC\uACF5\uD654\uAD6D \uB9C8\uCE74\uC624 \uD2B9\uBCC4\uD589\uC815\uAD6C","common":"\uB9C8\uCE74\uC624"},"nld":{"official":"Speciale Administratieve Regio Macau van de Volksrepubliek China","common":"Macao"},"per":{"official":"\u0645\u0627\u06A9\u0627\u0626\u0648","common":"\u0645\u0627\u06A9\u0627\u0626\u0648"},"pol":{"official":"Specjalny Region Administracyjny Chi\u0144skiej Republiki Ludowej Makau","common":"Makau"},"por":{"official":"Macau Regi\xe3o Administrativa Especial da Rep\xfablica Popular da China","common":"Macau"},"rus":{"official":"\u0421\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u0438\u0432\u043D\u044B\u0439 \u0440\u0430\u0439\u043E\u043D \u041C\u0430\u043A\u0430\u043E \u041A\u0438\u0442\u0430\u0439\u0441\u043A\u043E\u0439 \u041D\u0430\u0440\u043E\u0434\u043D\u043E\u0439 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0438 \u041A\u0438\u0442\u0430\u0439","common":"\u041C\u0430\u043A\u0430\u043E"},"slk":{"official":"Macao, \u0160peci\xe0lna administrat\xedvna oblas\u0166","common":"Macao"},"spa":{"official":"Macao, Regi\xf3n Administrativa Especial de la Rep\xfablica Popular China","common":"Macao"},"swe":{"official":"Macao","common":"Macao"},"urd":{"official":"\u0645\u06A9\u0627\u0624 \u0639\u0648\u0627\u0645\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0686\u06CC\u0646 \u06A9\u0627 \u062E\u0635\u0648\u0635\u06CC \u0627\u0646\u062A\u0638\u0627\u0645\u06CC \u0639\u0644\u0627\u0642\u06C1","common":"\u0645\u06A9\u0627\u0624"}},"latlng":[22.16666666,113.55],"landlocked":false,"borders":["CHN"],"area":30,"flag":"\uD83C\uDDF2\uD83C\uDDF4","demonyms":{"eng":{"f":"Macanese","m":"Macanese"},"fra":{"f":"Macanaise","m":"Macanais"}}},{"name":{"common":"Saint Martin","official":"Saint Martin","native":{"fra":{"official":"Saint-Martin","common":"Saint-Martin"}}},"tld":[".fr",".gp"],"cca2":"MF","ccn3":"663","cca3":"MAF","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+5","suffixes":["90"]},"capital":["Marigot"],"altSpellings":["MF","Collectivity of Saint Martin","Collectivit\xe9 de Saint-Martin","Saint Martin (French part)"],"region":"Americas","subregion":"Caribbean","languages":{"fra":"French"},"translations":{"ces":{"official":"Svat\xfd Martin","common":"Svat\xfd Martin (Francie)"},"deu":{"official":"Saint-Martin","common":"Saint-Martin"},"est":{"official":"Saint-Martini \xfchendus","common":"Saint-Martin"},"fin":{"official":"Saint-Martin","common":"Saint-Martin"},"fra":{"official":"Saint-Martin","common":"Saint-Martin"},"hrv":{"official":"Saint Martin","common":"Sveti Martin"},"hun":{"official":"Saint-Martin K\xf6z\xf6ss\xe9g","common":"Saint-Martin"},"ita":{"official":"saint Martin","common":"Saint Martin"},"jpn":{"official":"\u30B5\u30F3\u30DE\u30EB\u30BF\u30F3\u5CF6","common":"\u30B5\u30F3\u30FB\u30DE\u30EB\u30BF\u30F3\uFF08\u30D5\u30E9\u30F3\u30B9\u9818\uFF09"},"kor":{"official":"\uC0DD\uB9C8\uB974\uD0F1","common":"\uC0DD\uB9C8\uB974\uD0F1"},"nld":{"official":"Saint Martin","common":"Saint-Martin"},"per":{"official":"\u0633\u0646 \u0645\u0627\u0631\u062A\u0646","common":"\u0633\u0646 \u0645\u0627\u0631\u062A\u0646"},"pol":{"official":"Wsp\xf3lnota Saint-Martin","common":"Saint-Martin"},"por":{"official":"saint Martin","common":"S\xe3o Martinho"},"rus":{"official":"\u0421\u0435\u043D-\u041C\u0430\u0440\u0442\u0435\u043D","common":"\u0421\u0435\u043D-\u041C\u0430\u0440\u0442\u0435\u043D"},"slk":{"official":"Saint-Martin","common":"Saint-Martin"},"spa":{"official":"Saint Martin","common":"Saint Martin"},"swe":{"official":"F\xf6rvaltningsomr\xe5det Saint-Martin","common":"Saint-Martin"},"urd":{"official":"\u0633\u06CC\u0646\u0679 \u0645\u0627\u0631\u0679\u0646","common":"\u0633\u06CC\u0646\u0679 \u0645\u0627\u0631\u0679\u0646"},"zho":{"official":"\u5723\u9A6C\u4E01","common":"\u5723\u9A6C\u4E01"}},"latlng":[18.08333333,-63.95],"landlocked":false,"borders":["SXM"],"area":53,"flag":"\uD83C\uDDF2\uD83C\uDDEB","demonyms":{"eng":{"f":"Saint Martin Islander","m":"Saint Martin Islander"},"fra":{"f":"Saint-Martinoise","m":"Saint-Martinois"}}},{"name":{"common":"Morocco","official":"Kingdom of Morocco","native":{"ara":{"official":"\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0645\u063A\u0631\u0628\u064A\u0629","common":"\u0627\u0644\u0645\u063A\u0631\u0628"},"ber":{"official":"\u2D5C\u2D30\u2D33\u2D4D\u2D37\u2D49\u2D5C \u2D4F \u2D4D\u2D4E\u2D56\u2D54\u2D49\u2D31","common":"\u2D4D\u2D4E\u2D30\u2D56\u2D54\u2D49\u2D31"}}},"tld":[".ma","\u0627\u0644\u0645\u063A\u0631\u0628."],"cca2":"MA","ccn3":"504","cca3":"MAR","cioc":"MAR","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"MAD":{"name":"Moroccan dirham","symbol":"\u062F.\u0645."}},"idd":{"root":"+2","suffixes":["12"]},"capital":["Rabat"],"altSpellings":["MA","Kingdom of Morocco","Al-Mamlakah al-Ma\u0121ribiyah"],"region":"Africa","subregion":"Northern Africa","languages":{"ara":"Arabic","ber":"Berber"},"translations":{"ces":{"official":"Marock\xe9 kr\xe1lovstv\xed","common":"Maroko"},"deu":{"official":"K\xf6nigreich Marokko","common":"Marokko"},"est":{"official":"Maroko Kuningriik","common":"Maroko"},"fin":{"official":"Marokon kuningaskunta","common":"Marokko"},"fra":{"official":"Royaume du Maroc","common":"Maroc"},"hrv":{"official":"Kraljevina Maroko","common":"Maroko"},"hun":{"official":"Marokk\xf3i Kir\xe1lys\xe1g","common":"Marokk\xf3"},"ita":{"official":"Regno del Marocco","common":"Marocco"},"jpn":{"official":"\u30E2\u30ED\u30C3\u30B3\u738B\u56FD","common":"\u30E2\u30ED\u30C3\u30B3"},"kor":{"official":"\uBAA8\uB85C\uCF54 \uC655\uAD6D","common":"\uBAA8\uB85C\uCF54"},"nld":{"official":"Koninkrijk Marokko","common":"Marokko"},"per":{"official":"\u067E\u0627\u062F\u0634\u0627\u0647\u06CC \u0645\u0631\u0627\u06A9\u0634","common":"\u0645\u0631\u0627\u06A9\u0634"},"pol":{"official":"Kr\xf3lestwo Maroka\u0144skie","common":"Maroko"},"por":{"official":"Reino de Marrocos","common":"Marrocos"},"rus":{"official":"\u041A\u043E\u0440\u043E\u043B\u0435\u0432\u0441\u0442\u0432\u043E \u041C\u0430\u0440\u043E\u043A\u043A\u043E","common":"\u041C\u0430\u0440\u043E\u043A\u043A\u043E"},"slk":{"official":"Marock\xe9 knie\u017Eatstvo","common":"Maroko"},"spa":{"official":"Reino de Marruecos","common":"Marruecos"},"swe":{"official":"Konungariket Marocko","common":"Marocko"},"urd":{"official":"\u0645\u0645\u0644\u06A9\u062A\u0650 \u0645\u0631\u0627\u06A9\u0634","common":"\u0645\u0631\u0627\u06A9\u0634"},"zho":{"official":"\u6469\u6D1B\u54E5\u738B\u56FD","common":"\u6469\u6D1B\u54E5"}},"latlng":[32,-5],"landlocked":false,"borders":["DZA","ESH","ESP"],"area":446550,"flag":"\uD83C\uDDF2\uD83C\uDDE6","demonyms":{"eng":{"f":"Moroccan","m":"Moroccan"},"fra":{"f":"Marocaine","m":"Marocain"}}},{"name":{"common":"Monaco","official":"Principality of Monaco","native":{"fra":{"official":"Principaut\xe9 de Monaco","common":"Monaco"}}},"tld":[".mc"],"cca2":"MC","ccn3":"492","cca3":"MCO","cioc":"MON","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["77"]},"capital":["Monaco"],"altSpellings":["MC","Principality of Monaco","Principaut\xe9 de Monaco"],"region":"Europe","subregion":"Western Europe","languages":{"fra":"French"},"translations":{"ces":{"official":"Monack\xe9 kn\xed\u017Eectv\xed","common":"Monako"},"deu":{"official":"F\xfcrstentum Monaco","common":"Monaco"},"est":{"official":"Monaco V\xfcrstiriik","common":"Monaco"},"fin":{"official":"Monacon ruhtinaskunta","common":"Monaco"},"fra":{"official":"Principaut\xe9 de Monaco","common":"Monaco"},"hrv":{"official":"Kne\u017Eevina Monako","common":"Monako"},"hun":{"official":"Monac\xf3i Hercegs\xe9g","common":"Monaco"},"ita":{"official":"Principato di Monaco","common":"Principato di Monaco"},"jpn":{"official":"\u30E2\u30CA\u30B3\u516C\u56FD","common":"\u30E2\u30CA\u30B3"},"kor":{"official":"\uBAA8\uB098\uCF54 \uACF5\uAD6D","common":"\uBAA8\uB098\uCF54"},"nld":{"official":"Vorstendom Monaco","common":"Monaco"},"per":{"official":"\u0634\u0627\u0647\u0632\u0627\u062F\u0647\u200C\u0646\u0634\u06CC\u0646 \u0645\u0648\u0646\u0627\u06A9\u0648","common":"\u0645\u0648\u0646\u0627\u06A9\u0648"},"pol":{"official":"Ksi\u0119stwo Monako","common":"Monako"},"por":{"official":"Principado do M\xf3naco","common":"M\xf3naco"},"rus":{"official":"\u041A\u043D\u044F\u0436\u0435\u0441\u0442\u0432\u043E \u041C\u043E\u043D\u0430\u043A\u043E","common":"\u041C\u043E\u043D\u0430\u043A\u043E"},"slk":{"official":"Monack\xe9 knie\u017Eatstvo","common":"Monako"},"spa":{"official":"Principado de M\xf3naco","common":"M\xf3naco"},"swe":{"official":"Furstend\xf6met Monaco","common":"Monaco"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0645\u0646\u0627\u06A9\u0648","common":"\u0645\u0648\u0646\u0627\u06A9\u0648"},"zho":{"official":"\u6469\u7EB3\u54E5\u516C\u56FD","common":"\u6469\u7EB3\u54E5"}},"latlng":[43.73333333,7.4],"landlocked":false,"borders":["FRA"],"area":2.02,"flag":"\uD83C\uDDF2\uD83C\uDDE8","demonyms":{"eng":{"f":"Monegasque","m":"Monegasque"},"fra":{"f":"Mon\xe9gasque","m":"Mon\xe9gasque"}}},{"name":{"common":"Moldova","official":"Republic of Moldova","native":{"ron":{"official":"Republica Moldova","common":"Moldova"}}},"tld":[".md"],"cca2":"MD","ccn3":"498","cca3":"MDA","cioc":"MDA","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"MDL":{"name":"Moldovan leu","symbol":"L"}},"idd":{"root":"+3","suffixes":["73"]},"capital":["Chi\u0219in\u0103u"],"altSpellings":["MD","Moldova, Republic of","Republic of Moldova","Republica Moldova"],"region":"Europe","subregion":"Eastern Europe","languages":{"ron":"Moldavian"},"translations":{"ces":{"official":"Moldavsk\xe1 republika","common":"Moldavsko"},"deu":{"official":"Republik Moldau","common":"Moldawien"},"est":{"official":"Moldova Vabariik","common":"Moldova"},"fin":{"official":"Moldovan tasavalta","common":"Moldova"},"fra":{"official":"R\xe9publique de Moldavie","common":"Moldavie"},"hrv":{"official":"Moldavija","common":"Moldova"},"hun":{"official":"Moldovai K\xf6zt\xe1rsas\xe1g","common":"Moldova"},"ita":{"official":"Repubblica di Moldova","common":"Moldavia"},"jpn":{"official":"\u30E2\u30EB\u30C9\u30D0\u5171\u548C\u56FD","common":"\u30E2\u30EB\u30C9\u30D0\u5171\u548C\u56FD"},"kor":{"official":"\uBAB0\uB3C4\uBC14 \uACF5\uD654\uAD6D","common":"\uBAB0\uB3C4\uBC14"},"nld":{"official":"Republiek Moldavi\xeb","common":"Moldavi\xeb"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0645\u0648\u0644\u062F\u0627\u0648\u06CC","common":"\u0645\u0648\u0644\u062F\u0627\u0648\u06CC"},"pol":{"official":"Republika Mo\u0142dawii","common":"Mo\u0142dawia"},"por":{"official":"Rep\xfablica da Mold\xe1via","common":"Mold\xe1via"},"rus":{"official":"\u041C\u043E\u043B\u0434\u043E\u0432\u0430","common":"\u041C\u043E\u043B\u0434\u0430\u0432\u0438\u044F"},"slk":{"official":"Moldavsk\xe1 republika","common":"Moldavsko"},"spa":{"official":"Rep\xfablica de Moldova","common":"Moldavia"},"swe":{"official":"Republiken Moldavien","common":"Moldavien"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0645\u0627\u0644\u062F\u0648\u0648\u0627","common":"\u0645\u0627\u0644\u062F\u0648\u0648\u0627"},"zho":{"official":"\u6469\u5C14\u591A\u74E6\u5171\u548C\u56FD","common":"\u6469\u5C14\u591A\u74E6"}},"latlng":[47,29],"landlocked":true,"borders":["ROU","UKR"],"area":33846,"flag":"\uD83C\uDDF2\uD83C\uDDE9","demonyms":{"eng":{"f":"Moldovan","m":"Moldovan"},"fra":{"f":"Moldave","m":"Moldave"}}},{"name":{"common":"Madagascar","official":"Republic of Madagascar","native":{"fra":{"official":"R\xe9publique de Madagascar","common":"Madagascar"},"mlg":{"official":"Repoblikan\'i Madagasikara","common":"Madagasikara"}}},"tld":[".mg"],"cca2":"MG","ccn3":"450","cca3":"MDG","cioc":"MAD","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"MGA":{"name":"Malagasy ariary","symbol":"Ar"}},"idd":{"root":"+2","suffixes":["61"]},"capital":["Antananarivo"],"altSpellings":["MG","Republic of Madagascar","Repoblikan\'i Madagasikara","R\xe9publique de Madagascar"],"region":"Africa","subregion":"Eastern Africa","languages":{"fra":"French","mlg":"Malagasy"},"translations":{"ces":{"official":"Madagaskarsk\xe1 republika","common":"Madagaskar"},"deu":{"official":"Republik Madagaskar","common":"Madagaskar"},"est":{"official":"Madagaskari Vabariik","common":"Madagaskar"},"fin":{"official":"Madagaskarin tasavalta","common":"Madagaskar"},"fra":{"official":"R\xe9publique de Madagascar","common":"Madagascar"},"hrv":{"official":"Republika Madagaskar","common":"Madagaskar"},"hun":{"official":"Madagaszk\xe1ri K\xf6zt\xe1rsas\xe1g","common":"Madagaszk\xe1r"},"ita":{"official":"Repubblica del Madagascar","common":"Madagascar"},"jpn":{"official":"\u30DE\u30C0\u30AC\u30B9\u30AB\u30EB\u5171\u548C\u56FD","common":"\u30DE\u30C0\u30AC\u30B9\u30AB\u30EB"},"kor":{"official":"\uB9C8\uB2E4\uAC00\uC2A4\uCE74\uB974 \uACF5\uD654\uAD6D","common":"\uB9C8\uB2E4\uAC00\uC2A4\uCE74\uB974"},"nld":{"official":"Republiek Madagaskar","common":"Madagaskar"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0645\u0627\u062F\u0627\u06AF\u0627\u0633\u06A9\u0627\u0631","common":"\u0645\u0627\u062F\u0627\u06AF\u0627\u0633\u06A9\u0627\u0631"},"pol":{"official":"Republika Madagaskaru","common":"Madagaskar"},"por":{"official":"Rep\xfablica de Madag\xe1scar","common":"Madag\xe1scar"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041C\u0430\u0434\u0430\u0433\u0430\u0441\u043A\u0430\u0440","common":"\u041C\u0430\u0434\u0430\u0433\u0430\u0441\u043A\u0430\u0440"},"slk":{"official":"Madagaskarsk\xe1 republika","common":"Madagaskar"},"spa":{"official":"Rep\xfablica de Madagascar","common":"Madagascar"},"swe":{"official":"Republiken Madagaskar","common":"Madagaskar"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0645\u0688\u063A\u0627\u0633\u06A9\u0631","common":"\u0645\u0688\u063A\u0627\u0633\u06A9\u0631"},"zho":{"official":"\u9A6C\u8FBE\u52A0\u65AF\u52A0\u5171\u548C\u56FD","common":"\u9A6C\u8FBE\u52A0\u65AF\u52A0"}},"latlng":[-20,47],"landlocked":false,"borders":[],"area":587041,"flag":"\uD83C\uDDF2\uD83C\uDDEC","demonyms":{"eng":{"f":"Malagasy","m":"Malagasy"},"fra":{"f":"Malgache","m":"Malgache"}}},{"name":{"common":"Maldives","official":"Republic of the Maldives","native":{"div":{"official":"\u078B\u07A8\u0788\u07AC\u0780\u07A8\u0783\u07A7\u0787\u07B0\u0796\u07AD\u078E\u07AC \u0796\u07AA\u0789\u07B0\u0780\u07AB\u0783\u07A8\u0787\u07B0\u0794\u07A7","common":"\u078B\u07A8\u0788\u07AC\u0780\u07A8\u0783\u07A7\u0787\u07B0\u0796\u07AD\u078E\u07AC"}}},"tld":[".mv"],"cca2":"MV","ccn3":"462","cca3":"MDV","cioc":"MDV","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"MVR":{"name":"Maldivian rufiyaa","symbol":".\u0783"}},"idd":{"root":"+9","suffixes":["60"]},"capital":["Mal\xe9"],"altSpellings":["MV","Maldive Islands","Republic of the Maldives","Dhivehi Raajjeyge Jumhooriyya"],"region":"Asia","subregion":"Southern Asia","languages":{"div":"Maldivian"},"translations":{"ces":{"official":"Maledivsk\xe1 republika","common":"Maledivy"},"deu":{"official":"Republik Malediven","common":"Malediven"},"est":{"official":"Maldiivi Vabariik","common":"Maldiivid"},"fin":{"official":"Malediivien tasavalta","common":"Malediivit"},"fra":{"official":"R\xe9publique des Maldives","common":"Maldives"},"hrv":{"official":"Republika Maldivi","common":"Maldivi"},"hun":{"official":"Mald\xedv-szigetek","common":"Mald\xedv-szigetek"},"ita":{"official":"Repubblica delle Maldive","common":"Maldive"},"jpn":{"official":"\u30E2\u30EB\u30C7\u30A3\u30D6\u5171\u548C\u56FD","common":"\u30E2\u30EB\u30C7\u30A3\u30D6"},"kor":{"official":"\uBAB0\uB514\uBE0C \uACF5\uD654\uAD6D","common":"\uBAB0\uB514\uBE0C"},"nld":{"official":"Republiek van de Malediven","common":"Maldiven"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0645\u0627\u0644\u062F\u06CC\u0648","common":"\u0645\u0627\u0644\u062F\u06CC\u0648"},"pol":{"official":"Republika Malediw\xf3w","common":"Malediwy"},"por":{"official":"Rep\xfablica das Maldivas","common":"Maldivas"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041C\u0430\u043B\u044C\u0434\u0438\u0432\u044B","common":"\u041C\u0430\u043B\u044C\u0434\u0438\u0432\u044B"},"slk":{"official":"Maldivsk\xe1 republika","common":"Maldivy"},"spa":{"official":"Rep\xfablica de las Maldivas","common":"Maldivas"},"swe":{"official":"Republiken Maldiverna","common":"Maldiverna"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0645\u0627\u0644\u062F\u06CC\u067E","common":"\u0645\u0627\u0644\u062F\u06CC\u067E"},"zho":{"official":"\u9A6C\u5C14\u4EE3\u592B\u5171\u548C\u56FD","common":"\u9A6C\u5C14\u4EE3\u592B"}},"latlng":[3.25,73],"landlocked":false,"borders":[],"area":300,"flag":"\uD83C\uDDF2\uD83C\uDDFB","demonyms":{"eng":{"f":"Maldivan","m":"Maldivan"},"fra":{"f":"Maldivienne","m":"Maldivien"}}},{"name":{"common":"Mexico","official":"United Mexican States","native":{"spa":{"official":"Estados Unidos Mexicanos","common":"M\xe9xico"}}},"tld":[".mx"],"cca2":"MX","ccn3":"484","cca3":"MEX","cioc":"MEX","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"MXN":{"name":"Mexican peso","symbol":"$"}},"idd":{"root":"+5","suffixes":["2"]},"capital":["Mexico City"],"altSpellings":["MX","Mexicanos","United Mexican States","Estados Unidos Mexicanos"],"region":"Americas","subregion":"North America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Spojen\xe9 st\xe1ty mexick\xe9","common":"Mexiko"},"deu":{"official":"Vereinigte Mexikanische Staaten","common":"Mexiko"},"est":{"official":"Mehhiko \xdchendriigid","common":"Mehhiko"},"fin":{"official":"Meksikon yhdysvallat","common":"Meksiko"},"fra":{"official":"\xc9tats-Unis du Mexique","common":"Mexique"},"hrv":{"official":"Sjedinjene Meksi\u010Dke Dr\u017Eave","common":"Meksiko"},"hun":{"official":"Mexik\xf3i Egyes\xfclt \xc1llamok","common":"Mexik\xf3"},"ita":{"official":"Stati Uniti del Messico","common":"Messico"},"jpn":{"official":"\u30E1\u30AD\u30B7\u30B3\u5408\u8846\u56FD","common":"\u30E1\u30AD\u30B7\u30B3"},"kor":{"official":"\uBA55\uC2DC\uCF54 \uD569\uC911\uAD6D","common":"\uBA55\uC2DC\uCF54"},"nld":{"official":"Verenigde Mexicaanse Staten","common":"Mexico"},"per":{"official":"\u0627\u06CC\u0627\u0644\u0627\u062A \u0645\u062A\u062D\u062F \u0645\u06A9\u0632\u06CC\u06A9","common":"\u0645\u06A9\u0632\u06CC\u06A9"},"pol":{"official":"Meksyka\u0144skie Stany Zjednoczone","common":"Meksyk"},"por":{"official":"Estados Unidos Mexicanos","common":"M\xe9xico"},"rus":{"official":"\u041C\u0435\u043A\u0441\u0438\u043A\u0430\u043D\u0441\u043A\u0438\u0435 \u0421\u043E\u0435\u0434\u0438\u043D\u0451\u043D\u043D\u044B\u0435 \u0428\u0442\u0430\u0442\u044B","common":"\u041C\u0435\u043A\u0441\u0438\u043A\u0430"},"slk":{"official":"Spojen\xe9 \u0161t\xe1\u0161y mexick\xe9","common":"Mexiko"},"spa":{"official":"Estados Unidos Mexicanos","common":"M\xe9xico"},"swe":{"official":"Mexikos f\xf6renta stater","common":"Mexiko"},"urd":{"official":"\u0631\u06CC\u0627\u0633\u062A\u06C1\u0627\u0626\u06D2 \u0645\u062A\u062D\u062F\u06C1 \u0645\u06CC\u06A9\u0633\u06CC\u06A9\u0648","common":"\u0645\u06CC\u06A9\u0633\u06CC\u06A9\u0648"},"zho":{"official":"\u58A8\u897F\u54E5\u5408\u4F17\u56FD","common":"\u58A8\u897F\u54E5"}},"latlng":[23,-102],"landlocked":false,"borders":["BLZ","GTM","USA"],"area":1964375,"flag":"\uD83C\uDDF2\uD83C\uDDFD","demonyms":{"eng":{"f":"Mexican","m":"Mexican"},"fra":{"f":"Mexicaine","m":"Mexicain"}}},{"name":{"common":"Marshall Islands","official":"Republic of the Marshall Islands","native":{"eng":{"official":"Republic of the Marshall Islands","common":"Marshall Islands"},"mah":{"official":"Republic of the Marshall Islands","common":"M\u0327aje\u013C"}}},"tld":[".mh"],"cca2":"MH","ccn3":"584","cca3":"MHL","cioc":"MHL","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["92"]},"capital":["Majuro"],"altSpellings":["MH","Republic of the Marshall Islands","Aolep\u0101n Aor\u014Dkin M\u0327aje\u013C"],"region":"Oceania","subregion":"Micronesia","languages":{"eng":"English","mah":"Marshallese"},"translations":{"ces":{"official":"Republika Marshallovy ostrovy","common":"Marshallovy ostrovy"},"deu":{"official":"Republik Marshallinseln","common":"Marshallinseln"},"est":{"official":"Marshalli Saarte Vabariik","common":"Marshalli Saared"},"fin":{"official":"Marshallinsaarten tasavalta","common":"Marshallinsaaret"},"fra":{"official":"R\xe9publique des \xceles Marshall","common":"\xceles Marshall"},"hrv":{"official":"Republika Mar\u0161alovi Otoci","common":"Mar\u0161alovi Otoci"},"hun":{"official":"Marshall-szigetek","common":"Marshall-szigetek"},"ita":{"official":"Repubblica delle Isole Marshall","common":"Isole Marshall"},"jpn":{"official":"\u30DE\u30FC\u30B7\u30E3\u30EB\u8AF8\u5CF6\u5171\u548C\u56FD","common":"\u30DE\u30FC\u30B7\u30E3\u30EB\u8AF8\u5CF6"},"kor":{"official":"\uB9C8\uC15C \uC81C\uB3C4 \uACF5\uD654\uAD6D","common":"\uB9C8\uC15C \uC81C\uB3C4"},"nld":{"official":"Republiek van de Marshall-eilanden","common":"Marshalleilanden"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u062C\u0632\u0627\u06CC\u0631 \u0645\u0627\u0631\u0634\u0627\u0644","common":"\u062C\u0632\u0627\u06CC\u0631 \u0645\u0627\u0631\u0634\u0627\u0644"},"pol":{"official":"Republika Wysp Marshalla","common":"Wyspy Marshalla"},"por":{"official":"Rep\xfablica das Ilhas Marshall","common":"Ilhas Marshall"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041C\u0430\u0440\u0448\u0430\u043B\u043B\u043E\u0432\u044B \u043E\u0441\u0442\u0440\u043E\u0432\u0430","common":"\u041C\u0430\u0440\u0448\u0430\u043B\u043B\u043E\u0432\u044B \u041E\u0441\u0442\u0440\u043E\u0432\u0430"},"slk":{"official":"Republika Marshallov\xfdch ostrovov","common":"Marshallove ostrovy"},"spa":{"official":"Rep\xfablica de las Islas Marshall","common":"Islas Marshall"},"swe":{"official":"Republiken Marshall\xf6arna","common":"Marshall\xf6arna"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u062C\u0632\u0627\u0626\u0631 \u0645\u0627\u0631\u0634\u0644","common":"\u062C\u0632\u0627\u0626\u0631 \u0645\u0627\u0631\u0634\u0644"},"zho":{"official":"\u9A6C\u7ECD\u5C14\u7FA4\u5C9B\u5171\u548C\u56FD","common":"\u9A6C\u7ECD\u5C14\u7FA4\u5C9B"}},"latlng":[9,168],"landlocked":false,"borders":[],"area":181,"flag":"\uD83C\uDDF2\uD83C\uDDED","demonyms":{"eng":{"f":"Marshallese","m":"Marshallese"},"fra":{"f":"Marshallaise","m":"Marshallais"}}},{"name":{"common":"North Macedonia","official":"Republic of North Macedonia","native":{"mkd":{"official":"\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u0435\u0432\u0435\u0440\u043D\u0430 \u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430","common":"\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430"}}},"tld":[".mk"],"cca2":"MK","ccn3":"807","cca3":"MKD","cioc":"MKD","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"MKD":{"name":"denar","symbol":"den"}},"idd":{"root":"+3","suffixes":["89"]},"capital":["Skopje"],"altSpellings":["MK","The former Yugoslav Republic of Macedonia","Republic of North Macedonia","Macedonia, The Former Yugoslav Republic of","\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u0435\u0432\u0435\u0440\u043D\u0430 \u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430"],"region":"Europe","subregion":"Southeast Europe","languages":{"mkd":"Macedonian"},"translations":{"ces":{"official":"Republika Severn\xed Makedonie","common":"Severn\xed Makedonie"},"deu":{"official":"Republik Nordmazedonien","common":"Nordmazedonien"},"est":{"official":"P\xf5hja-Makedoonia Vabariik","common":"P\xf5hja-Makedoonia"},"fin":{"official":"Pohjois-Makedonian tasavalta","common":"Pohjois-Makedonia"},"fra":{"official":"R\xe9publique de Mac\xe9doine du Nord","common":"Mac\xe9doine du Nord"},"hrv":{"official":"Republika Sjeverna Makedonija","common":"Sjeverna Makedonija"},"hun":{"official":"\xc9szak-maced\xf3n K\xf6zt\xe1rsas\xe1g","common":"\xc9szak-Maced\xf3nia"},"ita":{"official":"Repubblica di Macedonia del Nord","common":"Macedonia del Nord"},"jpn":{"official":"\u5317\u30DE\u30B1\u30C9\u30CB\u30A2\u5171\u548C\u56FD","common":"\u5317\u30DE\u30B1\u30C9\u30CB\u30A2 "},"kor":{"official":"\uBD81\uB9C8\uCF00\uB3C4\uB2C8\uC544 \uACF5\uD654\uAD6D","common":"\uBD81\uB9C8\uCF00\uB3C4\uB2C8\uC544"},"nld":{"official":"Republiek Noord-Macedoni\xeb","common":"Noord-Macedoni\xeb"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0645\u0642\u062F\u0648\u0646\u06CC\u0647 \u0634\u0645\u0627\u0644\u06CC","common":"\u0645\u0642\u062F\u0648\u0646\u06CC\u0647 \u0634\u0645\u0627\u0644\u06CC"},"pol":{"official":"Republika Macedonii P\xf3\u0142nocnej","common":"Macedonia P\xf3\u0142nocna"},"por":{"official":"Rep\xfablica da Maced\xf4nia do Norte","common":"Maced\xf3nia do Norte"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u0435\u0432\u0435\u0440\u043D\u0430\u044F \u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u044F","common":"\u0421\u0435\u0432\u0435\u0440\u043D\u0430\u044F \u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u044F"},"slk":{"official":"Severomaced\xf3nska republika","common":"Severn\xe9 Maced\xf3nsko"},"spa":{"official":"Rep\xfablica de Macedonia del Norte","common":"Macedonia del Norte"},"swe":{"official":"Republiken Nordmakedonien","common":"Nordmakedonien"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0645\u0642\u062F\u0648\u0646\u06CC\u06C1","common":"\u0634\u0645\u0627\u0644\u06CC \u0645\u0642\u062F\u0648\u0646\u06CC\u06C1"},"zho":{"official":"\u5317\u99AC\u5176\u9813\u5171\u548C\u570B","common":"\u5317\u99AC\u5176\u9813"}},"latlng":[41.83333333,22],"landlocked":true,"borders":["ALB","BGR","GRC","UNK","SRB"],"area":25713,"flag":"\uD83C\uDDF2\uD83C\uDDF0","demonyms":{"eng":{"f":"Macedonian","m":"Macedonian"},"fra":{"f":"Mac\xe9donienne","m":"Mac\xe9donien"}}},{"name":{"common":"Mali","official":"Republic of Mali","native":{"fra":{"official":"R\xe9publique du Mali","common":"Mali"}}},"tld":[".ml"],"cca2":"ML","ccn3":"466","cca3":"MLI","cioc":"MLI","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"XOF":{"name":"West African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["23"]},"capital":["Bamako"],"altSpellings":["ML","Republic of Mali","R\xe9publique du Mali"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"ces":{"official":"Republika Mali","common":"Mali"},"deu":{"official":"Republik Mali","common":"Mali"},"est":{"official":"Mali Vabariik","common":"Mali"},"fin":{"official":"Malin tasavalta","common":"Mali"},"fra":{"official":"R\xe9publique du Mali","common":"Mali"},"hrv":{"official":"Republika Mali","common":"Mali"},"hun":{"official":"Mali K\xf6zt\xe1rsas\xe1g","common":"Mali"},"ita":{"official":"Repubblica del Mali","common":"Mali"},"jpn":{"official":"\u30DE\u30EA\u5171\u548C\u56FD","common":"\u30DE\u30EA"},"kor":{"official":"\uB9D0\uB9AC \uACF5\uD654\uAD6D","common":"\uB9D0\uB9AC"},"nld":{"official":"Republiek Mali","common":"Mali"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0645\u0627\u0644\u06CC","common":"\u0645\u0627\u0644\u06CC"},"pol":{"official":"Republika Mali","common":"Mali"},"por":{"official":"Rep\xfablica do Mali","common":"Mali"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041C\u0430\u043B\u0438","common":"\u041C\u0430\u043B\u0438"},"slk":{"official":"Malijsk\xe1 republika","common":"Mali"},"spa":{"official":"Rep\xfablica de Mal\xed","common":"Mali"},"swe":{"official":"Republiken Mali","common":"Mali"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0645\u0627\u0644\u06CC","common":"\u0645\u0627\u0644\u06CC"},"zho":{"official":"\u9A6C\u91CC\u5171\u548C\u56FD","common":"\u9A6C\u91CC"}},"latlng":[17,-4],"landlocked":true,"borders":["DZA","BFA","GIN","CIV","MRT","NER","SEN"],"area":1240192,"flag":"\uD83C\uDDF2\uD83C\uDDF1","demonyms":{"eng":{"f":"Malian","m":"Malian"},"fra":{"f":"Malienne","m":"Malien"}}},{"name":{"common":"Malta","official":"Republic of Malta","native":{"eng":{"official":"Republic of Malta","common":"Malta"},"mlt":{"official":"Repubblika ta \' Malta","common":"Malta"}}},"tld":[".mt"],"cca2":"MT","ccn3":"470","cca3":"MLT","cioc":"MLT","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["56"]},"capital":["Valletta"],"altSpellings":["MT","Republic of Malta","Repubblika ta\' Malta"],"region":"Europe","subregion":"Southern Europe","languages":{"eng":"English","mlt":"Maltese"},"translations":{"ces":{"official":"Maltsk\xe1 republika","common":"Malta"},"deu":{"official":"Republik Malta","common":"Malta"},"est":{"official":"Malta Vabariik","common":"Malta"},"fin":{"official":"Maltan tasavalta","common":"Malta"},"fra":{"official":"R\xe9publique de Malte","common":"Malte"},"hrv":{"official":"Republika Malta","common":"Malta"},"hun":{"official":"M\xe1ltai K\xf6zt\xe1rsas\xe1g","common":"M\xe1lta"},"ita":{"official":"Repubblica di Malta","common":"Malta"},"jpn":{"official":"\u30DE\u30EB\u30BF\u5171\u548C\u56FD","common":"\u30DE\u30EB\u30BF"},"kor":{"official":"\uBAB0\uD0C0 \uACF5\uD654\uAD6D","common":"\uBAB0\uD0C0"},"nld":{"official":"Republiek Malta","common":"Malta"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0645\u0627\u0644\u062A","common":"\u0645\u0627\u0644\u062A"},"pol":{"official":"Republika Malty","common":"Malta"},"por":{"official":"Rep\xfablica de Malta","common":"Malta"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041C\u0430\u043B\u044C\u0442\u0430","common":"\u041C\u0430\u043B\u044C\u0442\u0430"},"slk":{"official":"Maltsk\xe1 republika","common":"Malta"},"spa":{"official":"Rep\xfablica de Malta","common":"Malta"},"swe":{"official":"Republiken Malta","common":"Malta"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0645\u0627\u0644\u0679\u0627","common":"\u0645\u0627\u0644\u0679\u0627"},"zho":{"official":"\u9A6C\u8033\u4ED6\u5171\u548C\u56FD","common":"\u9A6C\u8033\u4ED6"}},"latlng":[35.83333333,14.58333333],"landlocked":false,"borders":[],"area":316,"flag":"\uD83C\uDDF2\uD83C\uDDF9","demonyms":{"eng":{"f":"Maltese","m":"Maltese"},"fra":{"f":"Maltaise","m":"Maltais"}}},{"name":{"common":"Myanmar","official":"Republic of the Union of Myanmar","native":{"mya":{"official":"\u1015\u103C\u100A\u103A\u1011\u1031\u102C\u1004\u103A\u1005\u102F \u101E\u1019\u1039\u1019\u1010 \u1019\u103C\u1014\u103A\u1019\u102C\u1014\u102D\u102F\u1004\u103A\u1004\u1036\u1010\u1031\u102C\u103A","common":"\u1019\u103C\u1014\u103A\u1019\u102C"}}},"tld":[".mm"],"cca2":"MM","ccn3":"104","cca3":"MMR","cioc":"MYA","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"MMK":{"name":"Burmese kyat","symbol":"Ks"}},"idd":{"root":"+9","suffixes":["5"]},"capital":["Naypyidaw"],"altSpellings":["MM","Burma","Republic of the Union of Myanmar","Pyidaunzu Thanm\u0103da My\u0103ma Nainngandaw"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"mya":"Burmese"},"translations":{"ces":{"official":"Republika Myanmarsk\xfd svaz","common":"Myanmar"},"deu":{"official":"Republik der Union Myanmar","common":"Myanmar"},"est":{"official":"Myanmari Liidu Vabariik","common":"Myanmar"},"fin":{"official":"Myanmarin liiton tasavalta","common":"Myanmar"},"fra":{"official":"R\xe9publique de l\'Union du Myanmar","common":"Birmanie"},"hrv":{"official":"Republika Unije Mijanmar","common":"Mijanmar"},"hun":{"official":"Mianmari \xc1llamsz\xf6vets\xe9g K\xf6zt\xe1rsas\xe1ga","common":"Mianmar"},"ita":{"official":"Repubblica dell\'Unione di Myanmar","common":"Birmania"},"jpn":{"official":"\u30DF\u30E3\u30F3\u30DE\u30FC\u9023\u90A6\u5171\u548C\u56FD","common":"\u30DF\u30E3\u30F3\u30DE\u30FC"},"kor":{"official":"\uBBF8\uC580\uB9C8 \uC5F0\uBC29 \uACF5\uD654\uAD6D","common":"\uBBF8\uC580\uB9C8"},"nld":{"official":"Republiek van de Unie van Myanmar","common":"Myanmar"},"per":{"official":"\u0627\u062A\u062D\u0627\u062F\u06CC\u0647 \u062C\u0645\u0647\u0648\u0631\u06CC \u0645\u06CC\u0627\u0646\u0645\u0627\u0631","common":"\u0645\u06CC\u0627\u0646\u0645\u0627\u0631"},"pol":{"official":"Republika Zwi\u0105zku Mjanmy","common":"Mjanma"},"por":{"official":"Rep\xfablica da Uni\xe3o de Myanmar","common":"Myanmar"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u043E\u044E\u0437\u0430 \u041C\u044C\u044F\u043D\u043C\u0430","common":"\u041C\u044C\u044F\u043D\u043C\u0430"},"slk":{"official":"Mjanmarsk\xe1 zv\xe4zov\xe1 republika","common":"Mjanmarsko"},"spa":{"official":"Rep\xfablica de la Uni\xf3n de Myanmar","common":"Myanmar"},"swe":{"official":"Republiken Unionen Myanmar","common":"Myanmar"},"urd":{"official":"\u0645\u062A\u062D\u062F\u06C1 \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0645\u06CC\u0627\u0646\u0645\u0627\u0631","common":"\u0645\u06CC\u0627\u0646\u0645\u0627\u0631"},"zho":{"official":"\u7F05\u7538\u8054\u90A6\u5171\u548C\u56FD","common":"\u7F05\u7538"}},"latlng":[22,98],"landlocked":false,"borders":["BGD","CHN","IND","LAO","THA"],"area":676578,"flag":"\uD83C\uDDF2\uD83C\uDDF2","demonyms":{"eng":{"f":"Burmese","m":"Burmese"},"fra":{"f":"Birmane","m":"Birman"}}},{"name":{"common":"Montenegro","official":"Montenegro","native":{"cnr":{"official":"\u0426\u0440\u043D\u0430 \u0413\u043E\u0440\u0430","common":"\u0426\u0440\u043D\u0430 \u0413\u043E\u0440\u0430"}}},"tld":[".me"],"cca2":"ME","ccn3":"499","cca3":"MNE","cioc":"MNE","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["82"]},"capital":["Podgorica"],"altSpellings":["ME","Crna Gora"],"region":"Europe","subregion":"Southeast Europe","languages":{"cnr":"Montenegrin"},"translations":{"ces":{"official":"\u010Cern\xe1 Hora","common":"\u010Cern\xe1 Hora"},"deu":{"official":"Montenegro","common":"Montenegro"},"est":{"official":"Montenegro","common":"Montenegro"},"fin":{"official":"Montenegro","common":"Montenegro"},"fra":{"official":"Mont\xe9n\xe9gro","common":"Mont\xe9n\xe9gro"},"hrv":{"official":"Crna Gora","common":"Crna Gora"},"hun":{"official":"Montenegr\xf3","common":"Montenegr\xf3"},"ita":{"official":"Montenegro","common":"Montenegro"},"jpn":{"official":"\u30E2\u30F3\u30C6\u30CD\u30B0\u30ED","common":"\u30E2\u30F3\u30C6\u30CD\u30B0\u30ED"},"kor":{"official":"\uBAAC\uD14C\uB124\uADF8\uB85C","common":"\uBAAC\uD14C\uB124\uADF8\uB85C"},"nld":{"official":"Montenegro","common":"Montenegro"},"per":{"official":"\u0645\u0648\u0646\u062A\u0647\u200C\u0646\u06AF\u0631\u0648","common":"\u0645\u0648\u0646\u062A\u0647\u200C\u0646\u06AF\u0631\u0648"},"pol":{"official":"Czarnog\xf3ra","common":"Czarnog\xf3ra"},"por":{"official":"Montenegro","common":"Montenegro"},"rus":{"official":"\u0427\u0435\u0440\u043D\u043E\u0433\u043E\u0440\u0438\u044F","common":"\u0427\u0435\u0440\u043D\u043E\u0433\u043E\u0440\u0438\u044F"},"slk":{"official":"\u010Cierna Hora","common":"\u010Cierna Hora"},"spa":{"official":"Montenegro","common":"Montenegro"},"swe":{"official":"Montenegro","common":"Montenegro"},"urd":{"official":"\u0645\u0648\u0646\u0679\u06CC\u0646\u06CC\u06AF\u0631\u0648","common":"\u0645\u0648\u0646\u0679\u06CC\u0646\u06CC\u06AF\u0631\u0648"},"zho":{"official":"\u9ED1\u5C71","common":"\u9ED1\u5C71"}},"latlng":[42.5,19.3],"landlocked":false,"borders":["ALB","BIH","HRV","UNK","SRB"],"area":13812,"flag":"\uD83C\uDDF2\uD83C\uDDEA","demonyms":{"eng":{"f":"Montenegrin","m":"Montenegrin"},"fra":{"f":"Mont\xe9n\xe9grine","m":"Mont\xe9n\xe9grin"}}},{"name":{"common":"Mongolia","official":"Mongolia","native":{"mon":{"official":"\u041C\u043E\u043D\u0433\u043E\u043B \u0443\u043B\u0441","common":"\u041C\u043E\u043D\u0433\u043E\u043B \u0443\u043B\u0441"}}},"tld":[".mn"],"cca2":"MN","ccn3":"496","cca3":"MNG","cioc":"MGL","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"MNT":{"name":"Mongolian t\xf6gr\xf6g","symbol":"\u20AE"}},"idd":{"root":"+9","suffixes":["76"]},"capital":["Ulan Bator"],"altSpellings":["MN"],"region":"Asia","subregion":"Eastern Asia","languages":{"mon":"Mongolian"},"translations":{"ces":{"official":"St\xe1t Mongolsko","common":"Mongolsko"},"deu":{"official":"Mongolei","common":"Mongolei"},"est":{"official":"Mongoolia","common":"Mongoolia"},"fin":{"official":"Mongolian tasavalta","common":"Mongolia"},"fra":{"official":"Mongolie","common":"Mongolie"},"hrv":{"official":"Mongolija","common":"Mongolija"},"hun":{"official":"Mong\xf3lia","common":"Mong\xf3lia"},"ita":{"official":"Mongolia","common":"Mongolia"},"jpn":{"official":"\u30E2\u30F3\u30B4\u30EB","common":"\u30E2\u30F3\u30B4\u30EB"},"kor":{"official":"\uBABD\uACE8","common":"\uBABD\uACE8\uAD6D"},"nld":{"official":"Mongoli\xeb","common":"Mongoli\xeb"},"per":{"official":"\u0645\u063A\u0648\u0644\u0633\u062A\u0627\u0646","common":"\u0645\u063A\u0648\u0644\u0633\u062A\u0627\u0646"},"pol":{"official":"Mongolia","common":"Mongolia"},"por":{"official":"Mong\xf3lia","common":"Mong\xf3lia"},"rus":{"official":"\u041C\u043E\u043D\u0433\u043E\u043B\u0438\u044F","common":"\u041C\u043E\u043D\u0433\u043E\u043B\u0438\u044F"},"slk":{"official":"Mongolsko","common":"Mongolsko"},"spa":{"official":"Mongolia","common":"Mongolia"},"swe":{"official":"Mongoliet","common":"Mongoliet"},"urd":{"official":"\u0645\u0646\u06AF\u0648\u0644\u06CC\u0627","common":"\u0645\u0646\u06AF\u0648\u0644\u06CC\u0627"},"zho":{"official":"\u8499\u53E4","common":"\u8499\u53E4"}},"latlng":[46,105],"landlocked":true,"borders":["CHN","RUS"],"area":1564110,"flag":"\uD83C\uDDF2\uD83C\uDDF3","demonyms":{"eng":{"f":"Mongolian","m":"Mongolian"},"fra":{"f":"Mongole","m":"Mongol"}}},{"name":{"common":"Northern Mariana Islands","official":"Commonwealth of the Northern Mariana Islands","native":{"cal":{"official":"Commonwealth of the Northern Mariana Islands","common":"Northern Mariana Islands"},"cha":{"official":"Sankattan Siha Na Islas Mari\xe5nas","common":"Na Islas Mari\xe5nas"},"eng":{"official":"Commonwealth of the Northern Mariana Islands","common":"Northern Mariana Islands"}}},"tld":[".mp"],"cca2":"MP","ccn3":"580","cca3":"MNP","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["670"]},"capital":["Saipan"],"altSpellings":["MP","Commonwealth of the Northern Mariana Islands","Sankattan Siha Na Islas Mari\xe5nas"],"region":"Oceania","subregion":"Micronesia","languages":{"cal":"Carolinian","cha":"Chamorro","eng":"English"},"translations":{"ces":{"official":"Spole\u010Denstv\xed Severn\xedch Marian","common":"Severn\xed Mariany"},"deu":{"official":"Commonwealth der N\xf6rdlichen Marianen","common":"N\xf6rdliche Marianen"},"est":{"official":"P\xf5hja-Mariaani \xdchendus","common":"P\xf5hja-Mariaanid"},"fin":{"official":"Pohjois-Mariaanit","common":"Pohjois-Mariaanit"},"fra":{"official":"Commonwealth des \xeeles Mariannes du Nord","common":"\xceles Mariannes du Nord"},"hrv":{"official":"Zajednica je Sjeverni Marijanski otoci","common":"Sjevernomarijanski otoci"},"hun":{"official":"\xc9szaki-Mariana-szigetek","common":"\xc9szaki-Mariana-szigetek"},"ita":{"official":"Commonwealth delle Isole Marianne Settentrionali","common":"Isole Marianne Settentrionali"},"jpn":{"official":"\u5317\u30DE\u30EA\u30A2\u30CA\u8AF8\u5CF6","common":"\u5317\u30DE\u30EA\u30A2\u30CA\u8AF8\u5CF6"},"kor":{"official":"\uBD81\uB9C8\uB9AC\uC544\uB098 \uC81C\uB3C4","common":"\uBD81\uB9C8\uB9AC\uC544\uB098 \uC81C\uB3C4"},"nld":{"official":"Commonwealth van de Noordelijke Marianen","common":"Noordelijke Marianeneilanden"},"per":{"official":"\u062C\u0632\u0627\u06CC\u0631 \u0645\u0627\u0631\u06CC\u0627\u0646\u0627\u06CC \u0634\u0645\u0627\u0644\u06CC","common":"\u062C\u0632\u0627\u06CC\u0631 \u0645\u0627\u0631\u06CC\u0627\u0646\u0627\u06CC \u0634\u0645\u0627\u0644\u06CC"},"pol":{"official":"Wsp\xf3lnota Marian\xf3w P\xf3\u0142nocnych","common":"Mariany P\xf3\u0142nocne"},"por":{"official":"Comunidade das Ilhas Marianas do Norte","common":"Marianas Setentrionais"},"rus":{"official":"\u0421\u043E\u0434\u0440\u0443\u0436\u0435\u0441\u0442\u0432\u043E \u0421\u0435\u0432\u0435\u0440\u043D\u044B\u0445 \u041C\u0430\u0440\u0438\u0430\u043D\u0441\u043A\u0438\u0445 \u043E\u0441\u0442\u0440\u043E\u0432\u043E\u0432","common":"\u0421\u0435\u0432\u0435\u0440\u043D\u044B\u0435 \u041C\u0430\u0440\u0438\u0430\u043D\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430"},"slk":{"official":"Spolo\u010Denstvo ostrovov Severn\xe9 Mari\xe1ny","common":"Severn\xe9 Mari\xe1ny"},"spa":{"official":"Mancomunidad de las Islas Marianas del Norte","common":"Islas Marianas del Norte"},"swe":{"official":"Nordmarianerna","common":"Nordmarianerna"},"urd":{"official":"\u062F\u0648\u0644\u062A\u0650 \u0645\u0634\u062A\u0631\u06A9\u06C1 \u062C\u0632\u0627\u0626\u0631 \u0634\u0645\u0627\u0644\u06CC \u0645\u0627\u0631\u06CC\u0627\u0646\u0627","common":"\u062C\u0632\u0627\u0626\u0631 \u0634\u0645\u0627\u0644\u06CC \u0645\u0627\u0631\u06CC\u0627\u0646\u0627"},"zho":{"official":"\u5317\u9A6C\u91CC\u4E9A\u7EB3\u7FA4\u5C9B","common":"\u5317\u9A6C\u91CC\u4E9A\u7EB3\u7FA4\u5C9B"}},"latlng":[15.2,145.75],"landlocked":false,"borders":[],"area":464,"flag":"\uD83C\uDDF2\uD83C\uDDF5","demonyms":{"eng":{"f":"American","m":"American"},"fra":{"f":"Am\xe9ricaine","m":"Am\xe9rican"}}},{"name":{"common":"Mozambique","official":"Republic of Mozambique","native":{"por":{"official":"Rep\xfablica de Mo\xe7ambique","common":"Mo\xe7ambique"}}},"tld":[".mz"],"cca2":"MZ","ccn3":"508","cca3":"MOZ","cioc":"MOZ","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"MZN":{"name":"Mozambican metical","symbol":"MT"}},"idd":{"root":"+2","suffixes":["58"]},"capital":["Maputo"],"altSpellings":["MZ","Republic of Mozambique","Rep\xfablica de Mo\xe7ambique"],"region":"Africa","subregion":"Eastern Africa","languages":{"por":"Portuguese"},"translations":{"ces":{"official":"Mosambick\xe1 republika","common":"Mosambik"},"deu":{"official":"Republik Mosambik","common":"Mosambik"},"est":{"official":"Mosambiigi Vabariik","common":"Mosambiik"},"fin":{"official":"Mosambikin tasavalta","common":"Mosambik"},"fra":{"official":"R\xe9publique du Mozambique","common":"Mozambique"},"hrv":{"official":"Republika Mozambiku","common":"Mozambik"},"hun":{"official":"Mozambiki K\xf6zt\xe1rsas\xe1g","common":"Mozambik"},"ita":{"official":"Repubblica del Mozambico","common":"Mozambico"},"jpn":{"official":"\u30E2\u30B6\u30F3\u30D3\u30FC\u30AF\u5171\u548C\u56FD","common":"\u30E2\u30B6\u30F3\u30D3\u30FC\u30AF"},"kor":{"official":"\uBAA8\uC7A0\uBE44\uD06C \uACF5\uD654\uAD6D","common":"\uBAA8\uC7A0\uBE44\uD06C"},"nld":{"official":"Republiek Mozambique","common":"Mozambique"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0645\u0648\u0632\u0627\u0645\u0628\u06CC\u06A9","common":"\u0645\u0648\u0632\u0627\u0645\u0628\u06CC\u06A9"},"pol":{"official":"Republika Mozambiku","common":"Mozambik"},"por":{"official":"Rep\xfablica de Mo\xe7ambique","common":"Mo\xe7ambique"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041C\u043E\u0437\u0430\u043C\u0431\u0438\u043A","common":"\u041C\u043E\u0437\u0430\u043C\u0431\u0438\u043A"},"slk":{"official":"Mozambick\xe1 republika","common":"Mozambik"},"spa":{"official":"Rep\xfablica de Mozambique","common":"Mozambique"},"swe":{"official":"Republiken Mo\xe7ambique","common":"Mo\xe7ambique"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0645\u0648\u0632\u0645\u0628\u06CC\u0642","common":"\u0645\u0648\u0632\u0645\u0628\u06CC\u0642"},"zho":{"official":"\u83AB\u6851\u6BD4\u514B\u5171\u548C\u56FD","common":"\u83AB\u6851\u6BD4\u514B"}},"latlng":[-18.25,35],"landlocked":false,"borders":["MWI","ZAF","SWZ","TZA","ZMB","ZWE"],"area":801590,"flag":"\uD83C\uDDF2\uD83C\uDDFF","demonyms":{"eng":{"f":"Mozambican","m":"Mozambican"},"fra":{"f":"Mozambicaine","m":"Mozambicain"}}},{"name":{"common":"Mauritania","official":"Islamic Republic of Mauritania","native":{"ara":{"official":"\u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0625\u0633\u0644\u0627\u0645\u064A\u0629 \u0627\u0644\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0629","common":"\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627"}}},"tld":[".mr"],"cca2":"MR","ccn3":"478","cca3":"MRT","cioc":"MTN","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"MRU":{"name":"Mauritanian ouguiya","symbol":"UM"}},"idd":{"root":"+2","suffixes":["22"]},"capital":["Nouakchott"],"altSpellings":["MR","Islamic Republic of Mauritania","al-Jumh\u016Briyyah al-\u02BEIsl\u0101miyyah al-M\u016Br\u012Bt\u0101niyyah"],"region":"Africa","subregion":"Western Africa","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Maurit\xe1nsk\xe1 isl\xe1msk\xe1 republika","common":"Maurit\xe1nie"},"deu":{"official":"Islamische Republik Mauretanien","common":"Mauretanien"},"est":{"official":"Mauritaania Islamivabariik","common":"Mauritaania"},"fin":{"official":"Mauritanian islamilainen tasavalta","common":"Mauritania"},"fra":{"official":"R\xe9publique islamique de Mauritanie","common":"Mauritanie"},"hrv":{"official":"Islamska Republika Mauritanija","common":"Mauritanija"},"hun":{"official":"Maurit\xe1niai Iszl\xe1m K\xf6zt\xe1rsas\xe1g","common":"Maurit\xe1nia"},"ita":{"official":"Repubblica islamica di Mauritania","common":"Mauritania"},"jpn":{"official":"\u30E2\u30FC\u30EA\u30BF\u30CB\u30A2\xb7\u30A4\u30B9\u30E9\u30E0\u5171\u548C\u56FD","common":"\u30E2\u30FC\u30EA\u30BF\u30CB\u30A2"},"kor":{"official":"\uBAA8\uB9AC\uD0C0\uB2C8 \uC774\uC2AC\uB78C \uACF5\uD654\uAD6D","common":"\uBAA8\uB9AC\uD0C0\uB2C8"},"nld":{"official":"Islamitische Republiek Mauritani\xeb","common":"Mauritani\xeb"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0633\u0644\u0627\u0645\u06CC \u0645\u0648\u0631\u06CC\u062A\u0627\u0646\u06CC","common":"\u0645\u0648\u0631\u06CC\u062A\u0627\u0646\u06CC"},"pol":{"official":"Islamska Republika Maureta\u0144ska","common":"Mauretania"},"por":{"official":"Rep\xfablica Isl\xe2mica da Maurit\xe2nia","common":"Maurit\xe2nia"},"rus":{"official":"\u0418\u0441\u043B\u0430\u043C\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041C\u0430\u0432\u0440\u0438\u0442\u0430\u043D\u0438\u044F","common":"\u041C\u0430\u0432\u0440\u0438\u0442\u0430\u043D\u0438\u044F"},"slk":{"official":"Maurit\xe1nska islamsk\xe1 republika","common":"Maurit\xe1nia"},"spa":{"official":"Rep\xfablica Isl\xe1mica de Mauritania","common":"Mauritania"},"swe":{"official":"Islamiska republiken Mauretanien","common":"Mauretanien"},"urd":{"official":"\u0627\u0633\u0644\u0627\u0645\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0645\u0648\u0631\u06CC\u062A\u0627\u0646\u06CC\u06C1","common":"\u0645\u0648\u0631\u06CC\u062A\u0627\u0646\u06CC\u06C1"},"zho":{"official":"\u6BDB\u91CC\u5854\u5C3C\u4E9A\u4F0A\u65AF\u5170\u5171\u548C\u56FD","common":"\u6BDB\u91CC\u5854\u5C3C\u4E9A"}},"latlng":[20,-12],"landlocked":false,"borders":["DZA","MLI","SEN","ESH"],"area":1030700,"flag":"\uD83C\uDDF2\uD83C\uDDF7","demonyms":{"eng":{"f":"Mauritanian","m":"Mauritanian"},"fra":{"f":"Mauritanienne","m":"Mauritanien"}}},{"name":{"common":"Montserrat","official":"Montserrat","native":{"eng":{"official":"Montserrat","common":"Montserrat"}}},"tld":[".ms"],"cca2":"MS","ccn3":"500","cca3":"MSR","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"XCD":{"name":"Eastern Caribbean dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["664"]},"capital":["Plymouth"],"altSpellings":["MS"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Montserrat","common":"Montserrat"},"deu":{"official":"Montserrat","common":"Montserrat"},"est":{"official":"Montserrat","common":"Montserrat"},"fin":{"official":"Montserrat","common":"Montserrat"},"fra":{"official":"Montserrat","common":"Montserrat"},"hrv":{"official":"Montserrat","common":"Montserrat"},"hun":{"official":"Montserrat","common":"Montserrat"},"ita":{"official":"Montserrat","common":"Montserrat"},"jpn":{"official":"\u30E2\u30F3\u30C8\u30BB\u30E9\u30C8","common":"\u30E2\u30F3\u30C8\u30BB\u30E9\u30C8"},"kor":{"official":"\uBAAC\uD2B8\uC138\uB7AB","common":"\uBAAC\uD2B8\uC138\uB7AB"},"nld":{"official":"Montserrat","common":"Montserrat"},"per":{"official":"\u0645\u0648\u0646\u062A\u0633\u0631\u0627\u062A","common":"\u0645\u0648\u0646\u062A\u0633\u0631\u0627\u062A"},"pol":{"official":"Montserrat","common":"Montserrat"},"por":{"official":"Montserrat","common":"Montserrat"},"rus":{"official":"\u041C\u043E\u043D\u0442\u0441\u0435\u0440\u0440\u0430\u0442","common":"\u041C\u043E\u043D\u0442\u0441\u0435\u0440\u0440\u0430\u0442"},"slk":{"official":"Montserrat","common":"Montserrat"},"spa":{"official":"Montserrat","common":"Montserrat"},"swe":{"official":"Montserrat","common":"Montserrat"},"urd":{"official":"\u0645\u0627\u0646\u0679\u0633\u0631\u06CC\u0679","common":"\u0645\u0627\u0646\u0679\u0633\u0631\u06CC\u0679"},"zho":{"official":"\u8499\u7279\u585E\u62C9\u7279","common":"\u8499\u7279\u585E\u62C9\u7279"}},"latlng":[16.75,-62.2],"landlocked":false,"borders":[],"area":102,"flag":"\uD83C\uDDF2\uD83C\uDDF8","demonyms":{"eng":{"f":"Montserratian","m":"Montserratian"},"fra":{"f":"Montserratienne","m":"Montserratien"}}},{"name":{"common":"Martinique","official":"Martinique","native":{"fra":{"official":"Martinique","common":"Martinique"}}},"tld":[".mq"],"cca2":"MQ","ccn3":"474","cca3":"MTQ","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+5","suffixes":["96"]},"capital":["Fort-de-France"],"altSpellings":["MQ"],"region":"Americas","subregion":"Caribbean","languages":{"fra":"French"},"translations":{"ces":{"official":"Martinik","common":"Martinik"},"deu":{"official":"Martinique","common":"Martinique"},"est":{"official":"Martinique\u2019i departemang","common":"Martinique"},"fin":{"official":"Martinique","common":"Martinique"},"fra":{"official":"Martinique","common":"Martinique"},"hrv":{"official":"Martinique","common":"Martinique"},"hun":{"official":"Martinique","common":"Martinique"},"ita":{"official":"Martinique","common":"Martinica"},"jpn":{"official":"\u30DE\u30EB\u30C6\u30A3\u30CB\u30FC\u30AF\u5CF6","common":"\u30DE\u30EB\u30C6\u30A3\u30CB\u30FC\u30AF"},"kor":{"official":"\uB9C8\uB974\uD2F0\uB2C8\uD06C","common":"\uB9C8\uB974\uD2F0\uB2C8\uD06C"},"nld":{"official":"Martinique","common":"Martinique"},"per":{"official":"\u0645\u0627\u0631\u062A\u06CC\u0646\u06CC\u06A9","common":"\u0645\u0627\u0631\u062A\u06CC\u0646\u06CC\u06A9"},"pol":{"official":"Martynika","common":"Martynika"},"por":{"official":"Martinique","common":"Martinica"},"rus":{"official":"\u041C\u0430\u0440\u0442\u0438\u043D\u0438\u043A\u0430","common":"\u041C\u0430\u0440\u0442\u0438\u043D\u0438\u043A\u0430"},"slk":{"official":"Martinique","common":"Martinique"},"spa":{"official":"Martinica","common":"Martinica"},"swe":{"official":"Martinique","common":"Martinique"},"urd":{"official":"\u0645\u0627\u0631\u0679\u06CC\u0646\u06CC\u06A9","common":"\u0645\u0627\u0631\u0679\u06CC\u0646\u06CC\u06A9"},"zho":{"official":"\u9A6C\u63D0\u5C3C\u514B","common":"\u9A6C\u63D0\u5C3C\u514B"}},"latlng":[14.666667,-61],"landlocked":false,"borders":[],"area":1128,"flag":"\uD83C\uDDF2\uD83C\uDDF6","demonyms":{"eng":{"f":"Martinican","m":"Martinican"},"fra":{"f":"Martiniquaise","m":"Martiniquais"}}},{"name":{"common":"Mauritius","official":"Republic of Mauritius","native":{"eng":{"official":"Republic of Mauritius","common":"Mauritius"},"fra":{"official":"R\xe9publique de Maurice","common":"Maurice"},"mfe":{"official":"Republik Moris","common":"Moris"}}},"tld":[".mu"],"cca2":"MU","ccn3":"480","cca3":"MUS","cioc":"MRI","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"MUR":{"name":"Mauritian rupee","symbol":"\u20A8"}},"idd":{"root":"+2","suffixes":["30"]},"capital":["Port Louis"],"altSpellings":["MU","Republic of Mauritius","R\xe9publique de Maurice"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English","fra":"French","mfe":"Mauritian Creole"},"translations":{"ces":{"official":"Mauricijsk\xe1 republika","common":"Mauricius"},"deu":{"official":"Republik Mauritius","common":"Mauritius"},"est":{"official":"Mauritiuse Vabariik","common":"Mauritius"},"fin":{"official":"Mauritiuksen tasavalta","common":"Mauritius"},"fra":{"official":"R\xe9publique de Maurice","common":"\xcele Maurice"},"hrv":{"official":"Republika Mauricijus","common":"Mauricijus"},"hun":{"official":"Mauritiusi K\xf6zt\xe1rsas\xe1g","common":"Mauritius"},"ita":{"official":"Repubblica di Mauritius","common":"Mauritius"},"jpn":{"official":"\u30E2\u30FC\u30EA\u30B7\u30E3\u30B9\u5171\u548C\u56FD","common":"\u30E2\u30FC\u30EA\u30B7\u30E3\u30B9"},"kor":{"official":"\uBAA8\uB9AC\uC154\uC2A4 \uACF5\uD654\uAD6D","common":"\uBAA8\uB9AC\uC154\uC2A4"},"nld":{"official":"Republiek Mauritius","common":"Mauritius"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0645\u0648\u0631\u06CC\u0633","common":"\u0645\u0648\u0631\u06CC\u0633"},"pol":{"official":"Republika Mauritiusu","common":"Mauritius"},"por":{"official":"Rep\xfablica das Maur\xedcias","common":"Maur\xedcio"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041C\u0430\u0432\u0440\u0438\u043A\u0438\u0439","common":"\u041C\u0430\u0432\u0440\u0438\u043A\u0438\u0439"},"slk":{"official":"Maur\xedcijsk\xe1 republika","common":"Maur\xedcius"},"spa":{"official":"Rep\xfablica de Mauricio","common":"Mauricio"},"swe":{"official":"Republiken Mauritius","common":"Mauritius"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0645\u0648\u0631\u06CC\u0634\u0633","common":"\u0645\u0648\u0631\u06CC\u0634\u0633"},"zho":{"official":"\u6BDB\u91CC\u6C42\u65AF\u5171\u548C\u56FD","common":"\u6BDB\u91CC\u6C42\u65AF"}},"latlng":[-20.28333333,57.55],"landlocked":false,"borders":[],"area":2040,"flag":"\uD83C\uDDF2\uD83C\uDDFA","demonyms":{"eng":{"f":"Mauritian","m":"Mauritian"},"fra":{"f":"Mauricienne","m":"Mauricien"}}},{"name":{"common":"Malawi","official":"Republic of Malawi","native":{"eng":{"official":"Republic of Malawi","common":"Malawi"},"nya":{"official":"Chalo cha Malawi, Dziko la Mala\u0175i","common":"Mala\u0175i"}}},"tld":[".mw"],"cca2":"MW","ccn3":"454","cca3":"MWI","cioc":"MAW","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"MWK":{"name":"Malawian kwacha","symbol":"MK"}},"idd":{"root":"+2","suffixes":["65"]},"capital":["Lilongwe"],"altSpellings":["MW","Republic of Malawi"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English","nya":"Chewa"},"translations":{"ces":{"official":"Malawisk\xe1 republika","common":"Malawi"},"deu":{"official":"Republik Malawi","common":"Malawi"},"est":{"official":"Malawi Vabariik","common":"Malawi"},"fin":{"official":"Malawin tasavalta","common":"Malawi"},"fra":{"official":"R\xe9publique du Malawi","common":"Malawi"},"hrv":{"official":"Republika Malavi","common":"Malavi"},"hun":{"official":"Malawi K\xf6zt\xe1rsas\xe1g","common":"Malawi"},"ita":{"official":"Repubblica del Malawi","common":"Malawi"},"jpn":{"official":"\u30DE\u30E9\u30A6\u30A4\u5171\u548C\u56FD","common":"\u30DE\u30E9\u30A6\u30A4"},"kor":{"official":"\uB9D0\uB77C\uC704 \uACF5\uD654\uAD6D","common":"\uB9D0\uB77C\uC704"},"nld":{"official":"Republiek Malawi","common":"Malawi"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0645\u0627\u0644\u0627\u0648\u06CC","common":"\u0645\u0627\u0644\u0627\u0648\u06CC"},"pol":{"official":"Republika Malawi","common":"Malawi"},"por":{"official":"Rep\xfablica do Malawi","common":"Malawi"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041C\u0430\u043B\u0430\u0432\u0438","common":"\u041C\u0430\u043B\u0430\u0432\u0438"},"slk":{"official":"Malawijsk\xe1 republika","common":"Malawi"},"spa":{"official":"Rep\xfablica de Malawi","common":"Malawi"},"swe":{"official":"Republiken Malawi","common":"Malawi"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0645\u0644\u0627\u0648\u06CC","common":"\u0645\u0644\u0627\u0648\u06CC"},"zho":{"official":"\u9A6C\u62C9\u7EF4\u5171\u548C\u56FD","common":"\u9A6C\u62C9\u7EF4"}},"latlng":[-13.5,34],"landlocked":true,"borders":["MOZ","TZA","ZMB"],"area":118484,"flag":"\uD83C\uDDF2\uD83C\uDDFC","demonyms":{"eng":{"f":"Malawian","m":"Malawian"},"fra":{"f":"Malawienne","m":"Malawien"}}},{"name":{"common":"Malaysia","official":"Malaysia","native":{"eng":{"official":"Malaysia","common":"Malaysia"},"msa":{"official":"\u0645\u0644\u064A\u0633\u064A\u0627","common":"\u0645\u0644\u064A\u0633\u064A\u0627"}}},"tld":[".my"],"cca2":"MY","ccn3":"458","cca3":"MYS","cioc":"MAS","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"MYR":{"name":"Malaysian ringgit","symbol":"RM"}},"idd":{"root":"+6","suffixes":["0"]},"capital":["Kuala Lumpur"],"altSpellings":["MY"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"eng":"English","msa":"Malay"},"translations":{"ces":{"official":"Malajsie","common":"Malajsie"},"deu":{"official":"Malaysia","common":"Malaysia"},"est":{"official":"Malaisia","common":"Malaisia"},"fin":{"official":"Malesia","common":"Malesia"},"fra":{"official":"F\xe9d\xe9ration de Malaisie","common":"Malaisie"},"hrv":{"official":"Malezija","common":"Malezija"},"hun":{"official":"Malajzia","common":"Malajzia"},"ita":{"official":"Malaysia","common":"Malesia"},"jpn":{"official":"\u30DE\u30EC\u30FC\u30B7\u30A2","common":"\u30DE\u30EC\u30FC\u30B7\u30A2"},"kor":{"official":"\uB9D0\uB808\uC774\uC2DC\uC544","common":"\uB9D0\uB808\uC774\uC2DC\uC544"},"nld":{"official":"Maleisi\xeb","common":"Maleisi\xeb"},"per":{"official":"\u0641\u062F\u0631\u0627\u0633\u06CC\u0648\u0646 \u0645\u0627\u0644\u0632\u06CC","common":"\u0645\u0627\u0644\u0632\u06CC"},"pol":{"official":"Malezja","common":"Malezja"},"por":{"official":"Mal\xe1sia","common":"Mal\xe1sia"},"rus":{"official":"\u041C\u0430\u043B\u0430\u0439\u0437\u0438\u044F","common":"\u041C\u0430\u043B\u0430\u0439\u0437\u0438\u044F"},"slk":{"official":"Malajzia","common":"Malajzia"},"spa":{"official":"Malasia","common":"Malasia"},"swe":{"official":"Malaysia","common":"Malaysia"},"urd":{"official":"\u0645\u0644\u0627\u0626\u06CC\u0634\u06CC\u0627","common":"\u0645\u0644\u0627\u0626\u06CC\u0634\u06CC\u0627"},"zho":{"official":"\u9A6C\u6765\u897F\u4E9A","common":"\u9A6C\u6765\u897F\u4E9A"}},"latlng":[2.5,112.5],"landlocked":false,"borders":["BRN","IDN","THA"],"area":330803,"flag":"\uD83C\uDDF2\uD83C\uDDFE","demonyms":{"eng":{"f":"Malaysian","m":"Malaysian"},"fra":{"f":"Malaisienne","m":"Malaisien"}}},{"name":{"common":"Mayotte","official":"Department of Mayotte","native":{"fra":{"official":"D\xe9partement de Mayotte","common":"Mayotte"}}},"tld":[".yt"],"cca2":"YT","ccn3":"175","cca3":"MYT","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+2","suffixes":["62"]},"capital":["Mamoudzou"],"altSpellings":["YT","Department of Mayotte","D\xe9partement de Mayotte"],"region":"Africa","subregion":"Eastern Africa","languages":{"fra":"French"},"translations":{"ces":{"official":"Mayotte","common":"Mayotte"},"deu":{"official":"\xdcbersee-D\xe9partement Mayotte","common":"Mayotte"},"est":{"official":"Mayotte","common":"Mayotte"},"fin":{"official":"Mayotte","common":"Mayotte"},"fra":{"official":"D\xe9partement de Mayotte","common":"Mayotte"},"hrv":{"official":"Odjel Mayotte","common":"Mayotte"},"hun":{"official":"Mayotte","common":"Mayotte"},"ita":{"official":"Dipartimento di Mayotte","common":"Mayotte"},"jpn":{"official":"\u30DE\u30E8\u30C3\u30C8\u79D1","common":"\u30DE\u30E8\u30C3\u30C8"},"kor":{"official":"\uB9C8\uC694\uD2B8","common":"\uB9C8\uC694\uD2B8"},"nld":{"official":"Afdeling Mayotte","common":"Mayotte"},"per":{"official":"\u0645\u062C\u0645\u0648\u0639\u0647 \u0634\u0647\u0631\u0633\u062A\u0627\u0646\u06CC \u0645\u0627\u06CC\u0648\u062A","common":"\u0645\u0627\u06CC\u0648\u062A"},"pol":{"official":"Majotta","common":"Majotta"},"por":{"official":"Departamento de Mayotte","common":"Mayotte"},"rus":{"official":"\u0414\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442 \u041C\u0430\u0439\u043E\u0442\u0442\u0430","common":"\u041C\u0430\u0439\u043E\u0442\u0442\u0430"},"slk":{"official":"Department Mayotte","common":"Mayotte"},"spa":{"official":"Departamento de Mayotte","common":"Mayotte"},"swe":{"official":"Departementsomr\xe5det Mayotte","common":"Mayotte"},"urd":{"official":"\u0645\u0627\u06CC\u0648\u0679","common":"\u0645\u0627\u06CC\u0648\u0679"},"zho":{"official":"\u9A6C\u7EA6\u7279","common":"\u9A6C\u7EA6\u7279"}},"latlng":[-12.83333333,45.16666666],"landlocked":false,"borders":[],"area":374,"flag":"\uD83C\uDDFE\uD83C\uDDF9","demonyms":{"eng":{"f":"Mahoran","m":"Mahoran"},"fra":{"f":"Mahoraise","m":"Mahorais"}}},{"name":{"common":"Namibia","official":"Republic of Namibia","native":{"afr":{"official":"Republiek van Namibi\xeb","common":"Namibi\xeb"},"deu":{"official":"Republik Namibia","common":"Namibia"},"eng":{"official":"Republic of Namibia","common":"Namibia"},"her":{"official":"Republic of Namibia","common":"Namibia"},"hgm":{"official":"Republic of Namibia","common":"Namibia"},"kwn":{"official":"Republic of Namibia","common":"Namibia"},"loz":{"official":"Republic of Namibia","common":"Namibia"},"ndo":{"official":"Republic of Namibia","common":"Namibia"},"tsn":{"official":"Lefatshe la Namibia","common":"Namibia"}}},"tld":[".na"],"cca2":"NA","ccn3":"516","cca3":"NAM","cioc":"NAM","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"NAD":{"name":"Namibian dollar","symbol":"$"},"ZAR":{"name":"South African rand","symbol":"R"}},"idd":{"root":"+2","suffixes":["64"]},"capital":["Windhoek"],"altSpellings":["NA","Namibi\xeb","Republic of Namibia"],"region":"Africa","subregion":"Southern Africa","languages":{"afr":"Afrikaans","deu":"German","eng":"English","her":"Herero","hgm":"Khoekhoe","kwn":"Kwangali","loz":"Lozi","ndo":"Ndonga","tsn":"Tswana"},"translations":{"ces":{"official":"Namibijsk\xe1 republika","common":"Namibie"},"deu":{"official":"Republik Namibia","common":"Namibia"},"est":{"official":"Namiibia Vabariik","common":"Namiibia"},"fin":{"official":"Namibian tasavalta","common":"Namibia"},"fra":{"official":"R\xe9publique de Namibie","common":"Namibie"},"hrv":{"official":"Republika Namibija","common":"Namibija"},"hun":{"official":"Nam\xedbiai K\xf6zt\xe1rsas\xe1g","common":"Nam\xedbia"},"ita":{"official":"Repubblica di Namibia","common":"Namibia"},"jpn":{"official":"\u30CA\u30DF\u30D3\u30A2\u5171\u548C\u56FD","common":"\u30CA\u30DF\u30D3\u30A2"},"kor":{"official":"\uB098\uBBF8\uBE44\uC544 \uACF5\uD654\uAD6D","common":"\uB098\uBBF8\uBE44\uC544"},"nld":{"official":"Republiek Namibi\xeb","common":"Namibi\xeb"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0646\u0627\u0645\u06CC\u0628\u06CC\u0627","common":"\u0646\u0627\u0645\u06CC\u0628\u06CC\u0627"},"pol":{"official":"Republika Namibii","common":"Namibia"},"por":{"official":"Rep\xfablica da Nam\xedbia","common":"Nam\xedbia"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041D\u0430\u043C\u0438\u0431\u0438\u044F","common":"\u041D\u0430\u043C\u0438\u0431\u0438\u044F"},"slk":{"official":"Nam\xedbijsk\xe1 republika","common":"Nam\xedbia"},"spa":{"official":"Rep\xfablica de Namibia","common":"Namibia"},"swe":{"official":"Republiken Namibia","common":"Namibia"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0646\u0645\u06CC\u0628\u06CC\u0627","common":"\u0646\u0645\u06CC\u0628\u06CC\u0627"},"zho":{"official":"\u7EB3\u7C73\u6BD4\u4E9A\u5171\u548C\u56FD","common":"\u7EB3\u7C73\u6BD4\u4E9A"}},"latlng":[-22,17],"landlocked":false,"borders":["AGO","BWA","ZAF","ZMB"],"area":825615,"flag":"\uD83C\uDDF3\uD83C\uDDE6","demonyms":{"eng":{"f":"Namibian","m":"Namibian"},"fra":{"f":"Namibienne","m":"Namibien"}}},{"name":{"common":"New Caledonia","official":"New Caledonia","native":{"fra":{"official":"Nouvelle-Cal\xe9donie","common":"Nouvelle-Cal\xe9donie"}}},"tld":[".nc"],"cca2":"NC","ccn3":"540","cca3":"NCL","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"XPF":{"name":"CFP franc","symbol":"\u20A3"}},"idd":{"root":"+6","suffixes":["87"]},"capital":["Noum\xe9a"],"altSpellings":["NC"],"region":"Oceania","subregion":"Melanesia","languages":{"fra":"French"},"translations":{"ces":{"official":"Nov\xe1 Kaledonie","common":"Nov\xe1 Kaledonie"},"deu":{"official":"Neukaledonien","common":"Neukaledonien"},"est":{"official":"Uus-Kaledoonia","common":"Uus-Kaledoonia"},"fin":{"official":"Uusi-Kaledonia","common":"Uusi-Kaledonia"},"fra":{"official":"Nouvelle-Cal\xe9donie","common":"Nouvelle-Cal\xe9donie"},"hrv":{"official":"Nova Kaledonija","common":"Nova Kaledonija"},"hun":{"official":"\xdaj-Kaled\xf3nia","common":"\xdaj-Kaled\xf3nia"},"ita":{"official":"Nuova Caledonia","common":"Nuova Caledonia"},"jpn":{"official":"\u30CB\u30E5\u30FC\u30AB\u30EC\u30C9\u30CB\u30A2","common":"\u30CB\u30E5\u30FC\u30AB\u30EC\u30C9\u30CB\u30A2"},"kor":{"official":"\uB204\uBCA8\uCE7C\uB808\uB3C4\uB2C8","common":"\uB204\uBCA8\uCE7C\uB808\uB3C4\uB2C8"},"nld":{"official":"nieuw -Caledoni\xeb","common":"Nieuw-Caledoni\xeb"},"per":{"official":"\u06A9\u0627\u0644\u062F\u0648\u0646\u06CC\u0627\u06CC \u062C\u062F\u06CC\u062F","common":"\u06A9\u0627\u0644\u062F\u0648\u0646\u06CC\u0627\u06CC \u062C\u062F\u06CC\u062F"},"pol":{"official":"Nowa Kaledonia","common":"Nowa Kaledonia"},"por":{"official":"New Caledonia","common":"Nova Caled\xf3nia"},"rus":{"official":"\u041D\u043E\u0432\u0430\u044F \u041A\u0430\u043B\u0435\u0434\u043E\u043D\u0438\u044F","common":"\u041D\u043E\u0432\u0430\u044F \u041A\u0430\u043B\u0435\u0434\u043E\u043D\u0438\u044F"},"slk":{"official":"Nov\xe1 Kaled\xf3nia","common":"Nov\xe1 Kaled\xf3nia"},"spa":{"official":"nueva Caledonia","common":"Nueva Caledonia"},"swe":{"official":"Nya Kaledonien","common":"Nya Kaledonien"},"urd":{"official":"\u0646\u06CC\u0648 \u06A9\u06CC\u0644\u06CC\u0688\u0648\u0646\u06CC\u0627","common":"\u0646\u06CC\u0648 \u06A9\u06CC\u0644\u06CC\u0688\u0648\u0646\u06CC\u0627"},"zho":{"official":"\u65B0\u5580\u91CC\u591A\u5C3C\u4E9A","common":"\u65B0\u5580\u91CC\u591A\u5C3C\u4E9A"}},"latlng":[-21.5,165.5],"landlocked":false,"borders":[],"area":18575,"flag":"\uD83C\uDDF3\uD83C\uDDE8","demonyms":{"eng":{"f":"New Caledonian","m":"New Caledonian"},"fra":{"f":"N\xe9o-Cal\xe9donienne","m":"N\xe9o-Cal\xe9donien"}}},{"name":{"common":"Niger","official":"Republic of Niger","native":{"fra":{"official":"R\xe9publique du Niger","common":"Niger"}}},"tld":[".ne"],"cca2":"NE","ccn3":"562","cca3":"NER","cioc":"NIG","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"XOF":{"name":"West African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["27"]},"capital":["Niamey"],"altSpellings":["NE","Nijar"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"ces":{"official":"Nigersk\xe1 republika","common":"Niger"},"deu":{"official":"Republik Niger","common":"Niger"},"est":{"official":"Nigeri Vabariik","common":"Niger"},"fin":{"official":"Nigerin tasavalta","common":"Niger"},"fra":{"official":"R\xe9publique du Niger","common":"Niger"},"hrv":{"official":"Republika Niger","common":"Niger"},"hun":{"official":"Nigeri K\xf6zt\xe1rsas\xe1g","common":"Niger"},"ita":{"official":"Repubblica del Niger","common":"Niger"},"jpn":{"official":"\u30CB\u30B8\u30A7\u30FC\u30EB\u5171\u548C\u56FD","common":"\u30CB\u30B8\u30A7\u30FC\u30EB"},"kor":{"official":"\uB2C8\uC81C\uB974 \uACF5\uD654\uAD6D","common":"\uB2C8\uC81C\uB974"},"nld":{"official":"Republiek Niger","common":"Niger"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0646\u06CC\u062C\u0631","common":"\u0646\u06CC\u062C\u0631"},"pol":{"official":"Republika Nigru","common":"Niger"},"por":{"official":"Rep\xfablica do N\xedger","common":"N\xedger"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041D\u0438\u0433\u0435\u0440","common":"\u041D\u0438\u0433\u0435\u0440"},"slk":{"official":"Nig\xe9rsk\xe1 republika","common":"Niger"},"spa":{"official":"Rep\xfablica de N\xedger","common":"N\xedger"},"swe":{"official":"Republiken Niger","common":"Niger"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0646\u0627\u0626\u062C\u0631","common":"\u0646\u0627\u0626\u062C\u0631"},"zho":{"official":"\u5C3C\u65E5\u5C14\u5171\u548C\u56FD","common":"\u5C3C\u65E5\u5C14"}},"latlng":[16,8],"landlocked":true,"borders":["DZA","BEN","BFA","TCD","LBY","MLI","NGA"],"area":1267000,"flag":"\uD83C\uDDF3\uD83C\uDDEA","demonyms":{"eng":{"f":"Nigerien","m":"Nigerien"},"fra":{"f":"Nig\xe9rienne","m":"Nig\xe9rien"}}},{"name":{"common":"Norfolk Island","official":"Territory of Norfolk Island","native":{"eng":{"official":"Territory of Norfolk Island","common":"Norfolk Island"},"pih":{"official":"Teratri of Norf\'k Ailen","common":"Norf\'k Ailen"}}},"tld":[".nf"],"cca2":"NF","ccn3":"574","cca3":"NFK","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"AUD":{"name":"Australian dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["72"]},"capital":["Kingston"],"altSpellings":["NF","Territory of Norfolk Island","Teratri of Norf\'k Ailen"],"region":"Oceania","subregion":"Australia and New Zealand","languages":{"eng":"English","pih":"Norfuk"},"translations":{"ces":{"official":"Teritorium ostrova Norfolk","common":"Norfolk"},"deu":{"official":"Gebiet der Norfolkinsel","common":"Norfolkinsel"},"est":{"official":"Norfolki saare ala","common":"Norfolk"},"fin":{"official":"Norfolkinsaaren territorio","common":"Norfolkinsaari"},"fra":{"official":"Territoire de l\'\xeele Norfolk","common":"\xcele Norfolk"},"hrv":{"official":"Teritorij Norfolk Island","common":"Otok Norfolk"},"hun":{"official":"Norfolk-sziget","common":"Norfolk-sziget"},"ita":{"official":"Territorio di Norfolk Island","common":"Isola Norfolk"},"jpn":{"official":"\u30CE\u30FC\u30D5\u30A9\u30FC\u30AF\u5CF6\u306E\u9818\u571F","common":"\u30CE\u30FC\u30D5\u30A9\u30FC\u30AF\u5CF6"},"kor":{"official":"\uB178\uD37D \uC12C","common":"\uB178\uD37D \uC12C"},"nld":{"official":"Grondgebied van Norfolk Island","common":"Norfolkeiland"},"per":{"official":"\u0642\u0644\u0645\u0631\u0648 \u062C\u0632\u0627\u06CC\u0631 \u0646\u0648\u0631\u0641\u06A9","common":"\u062C\u0632\u06CC\u0631\u0647 \u0646\u0648\u0631\u0641\u06A9"},"pol":{"official":"Terytorium Wyspy Norfolk","common":"Wyspa Norfolk"},"por":{"official":"Territ\xf3rio da Ilha Norfolk","common":"Ilha Norfolk"},"rus":{"official":"\u0422\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044F \u043E\u0441\u0442\u0440\u043E\u0432\u0430 \u041D\u043E\u0440\u0444\u043E\u043B\u043A","common":"\u041D\u043E\u0440\u0444\u043E\u043B\u043A"},"slk":{"official":"Terit\xf3rium ostrova Norfolk","common":"Norfolk"},"spa":{"official":"Territorio de la Isla Norfolk","common":"Isla de Norfolk"},"swe":{"official":"Norfolk\xf6n","common":"Norfolk\xf6n"},"urd":{"official":"\u062C\u0632\u06CC\u0631\u06C1 \u0646\u0648\u0631\u0641\u06A9 \u062E\u0637\u06C1","common":"\u062C\u0632\u06CC\u0631\u06C1 \u0646\u0648\u0631\u0641\u06A9"},"zho":{"official":"\u8BFA\u798F\u514B\u5C9B","common":"\u8BFA\u798F\u514B\u5C9B"}},"latlng":[-29.03333333,167.95],"landlocked":false,"borders":[],"area":36,"flag":"\uD83C\uDDF3\uD83C\uDDEB","demonyms":{"eng":{"f":"Norfolk Islander","m":"Norfolk Islander"},"fra":{"f":"Norfolkaise","m":"Norfolkais"}}},{"name":{"common":"Nigeria","official":"Federal Republic of Nigeria","native":{"eng":{"official":"Federal Republic of Nigeria","common":"Nigeria"}}},"tld":[".ng"],"cca2":"NG","ccn3":"566","cca3":"NGA","cioc":"NGR","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"NGN":{"name":"Nigerian naira","symbol":"\u20A6"}},"idd":{"root":"+2","suffixes":["34"]},"capital":["Abuja"],"altSpellings":["NG","Nijeriya","Na\xedj\xedr\xed\xe0","Federal Republic of Nigeria"],"region":"Africa","subregion":"Western Africa","languages":{"eng":"English"},"translations":{"ces":{"official":"Nigerijsk\xe1 federativn\xed republika","common":"Nig\xe9rie"},"deu":{"official":"Bundesrepublik Nigeria","common":"Nigeria"},"est":{"official":"Nigeeria Liitvabariik","common":"Nigeeria"},"fin":{"official":"Nigerian liittotasavalta","common":"Nigeria"},"fra":{"official":"R\xe9publique f\xe9d\xe9rale du Nigeria","common":"Nig\xe9ria"},"hrv":{"official":"Savezna Republika Nigerija","common":"Nigerija"},"hun":{"official":"Nig\xe9ria","common":"Nig\xe9ria"},"ita":{"official":"Repubblica federale di Nigeria","common":"Nigeria"},"jpn":{"official":"\u30CA\u30A4\u30B8\u30A7\u30EA\u30A2\u9023\u90A6\u5171\u548C\u56FD","common":"\u30CA\u30A4\u30B8\u30A7\u30EA\u30A2"},"kor":{"official":"\uB098\uC774\uC9C0\uB9AC\uC544 \uC5F0\uBC29 \uACF5\uD654\uAD6D","common":"\uB098\uC774\uC9C0\uB9AC\uC544"},"nld":{"official":"Federale Republiek Nigeria","common":"Nigeria"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0641\u062F\u0631\u0627\u0644 \u0646\u06CC\u062C\u0631\u06CC\u0647","common":"\u0646\u06CC\u062C\u0631\u06CC\u0647"},"pol":{"official":"Federalna Republika Nigerii","common":"Nigeria"},"por":{"official":"Rep\xfablica Federal da Nig\xe9ria","common":"Nig\xe9ria"},"rus":{"official":"\u0424\u0435\u0434\u0435\u0440\u0430\u0442\u0438\u0432\u043D\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041D\u0438\u0433\u0435\u0440\u0438\u044F","common":"\u041D\u0438\u0433\u0435\u0440\u0438\u044F"},"slk":{"official":"Nig\xe9rijsk\xe1 federat\xedvna republika","common":"Nig\xe9ria"},"spa":{"official":"Rep\xfablica Federal de Nigeria","common":"Nigeria"},"swe":{"official":"F\xf6rbundsrepubliken Nigeria","common":"Nigeria"},"urd":{"official":"\u0648\u0641\u0627\u0642\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0646\u0627\u0626\u062C\u06CC\u0631\u06CC\u0627","common":"\u0646\u0627\u0626\u062C\u06CC\u0631\u06CC\u0627"},"zho":{"official":"\u5C3C\u65E5\u5229\u4E9A\u8054\u90A6\u5171\u548C\u56FD","common":"\u5C3C\u65E5\u5229\u4E9A"}},"latlng":[10,8],"landlocked":false,"borders":["BEN","CMR","TCD","NER"],"area":923768,"flag":"\uD83C\uDDF3\uD83C\uDDEC","demonyms":{"eng":{"f":"Nigerian","m":"Nigerian"},"fra":{"f":"Nig\xe9riane","m":"Nig\xe9rian"}}},{"name":{"common":"Nicaragua","official":"Republic of Nicaragua","native":{"spa":{"official":"Rep\xfablica de Nicaragua","common":"Nicaragua"}}},"tld":[".ni"],"cca2":"NI","ccn3":"558","cca3":"NIC","cioc":"NCA","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"NIO":{"name":"Nicaraguan c\xf3rdoba","symbol":"C$"}},"idd":{"root":"+5","suffixes":["05"]},"capital":["Managua"],"altSpellings":["NI","Republic of Nicaragua","Rep\xfablica de Nicaragua"],"region":"Americas","subregion":"Central America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Republika Nikaragua","common":"Nikaragua"},"deu":{"official":"Republik Nicaragua","common":"Nicaragua"},"est":{"official":"Nicaragua Vabariik","common":"Nicaragua"},"fin":{"official":"Nicaraguan tasavalta","common":"Nicaragua"},"fra":{"official":"R\xe9publique du Nicaragua","common":"Nicaragua"},"hrv":{"official":"Republika Nikaragva","common":"Nikaragva"},"hun":{"official":"Nicaraguai K\xf6zt\xe1rsas\xe1g","common":"Nicaragua"},"ita":{"official":"Repubblica del Nicaragua","common":"Nicaragua"},"jpn":{"official":"\u30CB\u30AB\u30E9\u30B0\u30A2\u5171\u548C\u56FD","common":"\u30CB\u30AB\u30E9\u30B0\u30A2"},"kor":{"official":"\uB2C8\uCE74\uB77C\uACFC \uACF5\uD654\uAD6D","common":"\uB2C8\uCE74\uB77C\uACFC"},"nld":{"official":"Republiek Nicaragua","common":"Nicaragua"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0646\u06CC\u06A9\u0627\u0631\u0627\u06AF\u0648\u0626\u0647","common":"\u0646\u06CC\u06A9\u0627\u0631\u0627\u06AF\u0648\u0626\u0647"},"pol":{"official":"Republika Nikaragui","common":"Nikaragua"},"por":{"official":"Rep\xfablica da Nicar\xe1gua","common":"Nicar\xe1gua"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041D\u0438\u043A\u0430\u0440\u0430\u0433\u0443\u0430","common":"\u041D\u0438\u043A\u0430\u0440\u0430\u0433\u0443\u0430"},"slk":{"official":"Nikaragujsk\xe1 republika","common":"Nikaragua"},"spa":{"official":"Rep\xfablica de Nicaragua","common":"Nicaragua"},"swe":{"official":"Republiken Nicaragua","common":"Nicaragua"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0646\u06A9\u0627\u0631\u0627\u06AF\u0648\u0627","common":"\u0646\u06A9\u0627\u0631\u0627\u06AF\u0648\u0627"},"zho":{"official":"\u5C3C\u52A0\u62C9\u74DC\u5171\u548C\u56FD","common":"\u5C3C\u52A0\u62C9\u74DC"}},"latlng":[13,-85],"landlocked":false,"borders":["CRI","HND"],"area":130373,"flag":"\uD83C\uDDF3\uD83C\uDDEE","demonyms":{"eng":{"f":"Nicaraguan","m":"Nicaraguan"},"fra":{"f":"Nicaraguayenne","m":"Nicaraguayen"}}},{"name":{"common":"Niue","official":"Niue","native":{"eng":{"official":"Niue","common":"Niue"},"niu":{"official":"Niu\u0113","common":"Niu\u0113"}}},"tld":[".nu"],"cca2":"NU","ccn3":"570","cca3":"NIU","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"NZD":{"name":"New Zealand dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["83"]},"capital":["Alofi"],"altSpellings":["NU"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English","niu":"Niuean"},"translations":{"ces":{"official":"Niue","common":"Niue"},"deu":{"official":"Niue","common":"Niue"},"est":{"official":"Niue","common":"Niue"},"fin":{"official":"Niue","common":"Niue"},"fra":{"official":"Niue","common":"Niue"},"hrv":{"official":"Niue","common":"Niue"},"hun":{"official":"Niue","common":"Niue"},"ita":{"official":"Niue","common":"Niue"},"jpn":{"official":"\u30CB\u30A6\u30A8","common":"\u30CB\u30A6\u30A8"},"kor":{"official":"\uB2C8\uC6B0\uC5D0","common":"\uB2C8\uC6B0\uC5D0"},"nld":{"official":"Niue","common":"Niue"},"per":{"official":"\u0646\u06CC\u0648\u0648\u06CC","common":"\u0646\u06CC\u0648\u0648\u06CC"},"pol":{"official":"Niue","common":"Niue"},"por":{"official":"Niue","common":"Niue"},"rus":{"official":"\u041D\u0438\u0443\u044D","common":"\u041D\u0438\u0443\u044D"},"slk":{"official":"Niue","common":"Niue"},"spa":{"official":"Niue","common":"Niue"},"swe":{"official":"Niue","common":"Niue"},"urd":{"official":"\u0646\u06CC\u0648\u0648\u06D2","common":"\u0646\u06CC\u0648\u0648\u06D2"},"zho":{"official":"\u7EBD\u57C3","common":"\u7EBD\u57C3"}},"latlng":[-19.03333333,-169.86666666],"landlocked":false,"borders":[],"area":260,"flag":"\uD83C\uDDF3\uD83C\uDDFA","demonyms":{"eng":{"f":"Niuean","m":"Niuean"},"fra":{"f":"Niu\xe9enne","m":"Niu\xe9en"}}},{"name":{"common":"Netherlands","official":"Kingdom of the Netherlands","native":{"nld":{"official":"Koninkrijk der Nederlanden","common":"Nederland"}}},"tld":[".nl"],"cca2":"NL","ccn3":"528","cca3":"NLD","cioc":"NED","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["1"]},"capital":["Amsterdam"],"altSpellings":["NL","Holland","Nederland","The Netherlands"],"region":"Europe","subregion":"Western Europe","languages":{"nld":"Dutch"},"translations":{"ces":{"official":"Nizozemsk\xe9 kr\xe1lovstv\xed","common":"Nizozemsko"},"deu":{"official":"Niederlande","common":"Niederlande"},"est":{"official":"Madalmaade Kuningriik","common":"Holland"},"fin":{"official":"Alankomaat","common":"Alankomaat"},"fra":{"official":"Pays-Bas","common":"Pays-Bas"},"hrv":{"official":"Holandija","common":"Nizozemska"},"hun":{"official":"Holland Kir\xe1lys\xe1g","common":"Hollandia"},"ita":{"official":"Paesi Bassi","common":"Paesi Bassi"},"jpn":{"official":"\u30AA\u30E9\u30F3\u30C0","common":"\u30AA\u30E9\u30F3\u30C0"},"kor":{"official":"\uB124\uB35C\uB780\uB4DC \uC655\uAD6D","common":"\uB124\uB35C\uB780\uB4DC"},"nld":{"official":"Nederland","common":"Nederland"},"per":{"official":"\u0647\u0644\u0646\u062F","common":"\u0647\u0644\u0646\u062F"},"pol":{"official":"Kr\xf3lestwo Niderland\xf3w","common":"Holandia"},"por":{"official":"Holanda","common":"Holanda"},"rus":{"official":"\u041D\u0438\u0434\u0435\u0440\u043B\u0430\u043D\u0434\u044B","common":"\u041D\u0438\u0434\u0435\u0440\u043B\u0430\u043D\u0434\u044B"},"slk":{"official":"Holandsk\xe9 kr\xe1\u013Eovstvo","common":"Holansko"},"spa":{"official":"Pa\xedses Bajos","common":"Pa\xedses Bajos"},"swe":{"official":"Nederl\xe4nderna","common":"Nederl\xe4nderna"},"urd":{"official":"\u0645\u0645\u0644\u06A9\u062A\u0650 \u0646\u06CC\u062F\u0631\u0644\u06CC\u0646\u0688\u0632","common":"\u0646\u06CC\u062F\u0631\u0644\u06CC\u0646\u0688\u0632"},"zho":{"official":"\u8377\u5170","common":"\u8377\u5170"}},"latlng":[52.5,5.75],"landlocked":false,"borders":["BEL","DEU"],"area":41850,"flag":"\uD83C\uDDF3\uD83C\uDDF1","demonyms":{"eng":{"f":"Dutch","m":"Dutch"},"fra":{"f":"N\xe9erlandaise","m":"N\xe9erlandais"}}},{"name":{"common":"Norway","official":"Kingdom of Norway","native":{"nno":{"official":"Kongeriket Noreg","common":"Noreg"},"nob":{"official":"Kongeriket Norge","common":"Norge"},"smi":{"official":"Norgga gonagasriika","common":"Norgga"}}},"tld":[".no"],"cca2":"NO","ccn3":"578","cca3":"NOR","cioc":"NOR","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"NOK":{"name":"Norwegian krone","symbol":"kr"}},"idd":{"root":"+4","suffixes":["7"]},"capital":["Oslo"],"altSpellings":["NO","Norge","Noreg","Kingdom of Norway","Kongeriket Norge","Kongeriket Noreg"],"region":"Europe","subregion":"Northern Europe","languages":{"nno":"Norwegian Nynorsk","nob":"Norwegian Bokm\xe5l","smi":"Sami"},"translations":{"ces":{"official":"Norsk\xe9 kr\xe1lovstv\xed","common":"Norsko"},"deu":{"official":"K\xf6nigreich Norwegen","common":"Norwegen"},"est":{"official":"Norra Kuningriik","common":"Norra"},"fin":{"official":"Norjan kuningaskunta","common":"Norja"},"fra":{"official":"Royaume de Norv\xe8ge","common":"Norv\xe8ge"},"hrv":{"official":"Kraljevina Norve\u0161ka","common":"Norve\u0161ka"},"hun":{"official":"Norv\xe9g Kir\xe1lys\xe1g","common":"Norv\xe9gia"},"ita":{"official":"Regno di Norvegia","common":"Norvegia"},"jpn":{"official":"\u30CE\u30EB\u30A6\u30A7\u30FC\u738B\u56FD","common":"\u30CE\u30EB\u30A6\u30A7\u30FC"},"kor":{"official":"\uB178\uB974\uC6E8\uC774 \uC655\uAD6D","common":"\uB178\uB974\uC6E8\uC774"},"nld":{"official":"Koninkrijk Noorwegen","common":"Noorwegen"},"per":{"official":"\u067E\u0627\u062F\u0634\u0627\u0647\u06CC \u0646\u0631\u0648\u0698","common":"\u0646\u0631\u0648\u0698"},"pol":{"official":"Kr\xf3lestwo Norwegii","common":"Norwegia"},"por":{"official":"Reino da Noruega","common":"Noruega"},"rus":{"official":"\u041A\u043E\u0440\u043E\u043B\u0435\u0432\u0441\u0442\u0432\u043E \u041D\u043E\u0440\u0432\u0435\u0433\u0438\u044F","common":"\u041D\u043E\u0440\u0432\u0435\u0433\u0438\u044F"},"slk":{"official":"N\xf3rske kr\xe1\u013Eovstvo","common":"N\xf3rsko"},"spa":{"official":"Reino de Noruega","common":"Noruega"},"swe":{"official":"Konungariket Norge","common":"Norge"},"urd":{"official":"\u0645\u0645\u0644\u06A9\u062A\u0650 \u0646\u0627\u0631\u0648\u06D2","common":"\u0646\u0627\u0631\u0648\u06D2"},"zho":{"official":"\u632A\u5A01\u738B\u56FD","common":"\u632A\u5A01"}},"latlng":[62,10],"landlocked":false,"borders":["FIN","SWE","RUS"],"area":323802,"flag":"\uD83C\uDDF3\uD83C\uDDF4","demonyms":{"eng":{"f":"Norwegian","m":"Norwegian"},"fra":{"f":"Norv\xe9gienne","m":"Norv\xe9gien"}}},{"name":{"common":"Nepal","official":"Federal Democratic Republic of Nepal","native":{"nep":{"official":"\u0928\u0947\u092A\u093E\u0932 \u0938\u0902\u0918\u0940\u092F \u0932\u094B\u0915\u0924\u093E\u0928\u094D\u0924\u094D\u0930\u093F\u0915 \u0917\u0923\u0924\u0928\u094D\u0924\u094D\u0930","common":"\u0928\u0947\u092A\u093E\u0932"}}},"tld":[".np"],"cca2":"NP","ccn3":"524","cca3":"NPL","cioc":"NEP","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"NPR":{"name":"Nepalese rupee","symbol":"\u20A8"}},"idd":{"root":"+9","suffixes":["77"]},"capital":["Kathmandu"],"altSpellings":["NP","Federal Democratic Republic of Nepal","Lokt\u0101ntrik Ganatantra Nep\u0101l"],"region":"Asia","subregion":"Southern Asia","languages":{"nep":"Nepali"},"translations":{"ces":{"official":"Federativn\xed demokratick\xe1 republika Nep\xe1l","common":"Nep\xe1l"},"deu":{"official":"Demokratische Bundesrepublik Nepal","common":"Nepal"},"est":{"official":"Nepali Demokraatlik Liitvabariik","common":"Nepal"},"fin":{"official":"Nepalin demokraattinen liittotasavalta","common":"Nepal"},"fra":{"official":"R\xe9publique du N\xe9pal","common":"N\xe9pal"},"hrv":{"official":"Savezna Demokratska Republika Nepal","common":"Nepal"},"hun":{"official":"Nep\xe1li Sz\xf6vets\xe9gi Demokratikus K\xf6zt\xe1rsas\xe1g","common":"Nep\xe1l"},"ita":{"official":"Repubblica federale democratica del Nepal","common":"Nepal"},"jpn":{"official":"\u30CD\u30D1\u30FC\u30EB\u9023\u90A6\u6C11\u4E3B\u5171\u548C\u56FD","common":"\u30CD\u30D1\u30FC\u30EB"},"kor":{"official":"\uB124\uD314 \uC5F0\uBC29 \uBBFC\uC8FC \uACF5\uD654\uAD6D","common":"\uB124\uD314"},"nld":{"official":"Federale Democratische Republiek Nepal","common":"Nepal"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0641\u062F\u0631\u0627\u0644 \u062F\u0645\u0648\u06A9\u0631\u0627\u062A\u06CC\u06A9 \u0646\u067E\u0627\u0644","common":"\u0646\u067E\u0627\u0644"},"pol":{"official":"Federalna Demokratyczna Republika Nepalu","common":"Nepal"},"por":{"official":"Rep\xfablica Democr\xe1tica Federal do Nepal","common":"Nepal"},"rus":{"official":"\u0424\u0435\u0434\u0435\u0440\u0430\u0442\u0438\u0432\u043D\u0430\u044F \u0414\u0435\u043C\u043E\u043A\u0440\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041D\u0435\u043F\u0430\u043B","common":"\u041D\u0435\u043F\u0430\u043B"},"slk":{"official":"Nep\xe1lska federat\xedvna demokratick\xe1 republika","common":"Nep\xe1l"},"spa":{"official":"Rep\xfablica Democr\xe1tica Federal de Nepal","common":"Nepal"},"swe":{"official":"Demokratiska f\xf6rbundsrepubliken Nepal","common":"Nepal"},"urd":{"official":"\u0648\u0641\u0627\u0642\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0646\u06CC\u067E\u0627\u0644","common":"\u0646\u06CC\u067E\u0627\u0644"},"zho":{"official":"\u5C3C\u6CCA\u5C14\u8054\u90A6\u6C11\u4E3B\u5171\u548C\u56FD","common":"\u5C3C\u6CCA\u5C14"}},"latlng":[28,84],"landlocked":true,"borders":["CHN","IND"],"area":147181,"flag":"\uD83C\uDDF3\uD83C\uDDF5","demonyms":{"eng":{"f":"Nepalese","m":"Nepalese"},"fra":{"f":"N\xe9palaise","m":"N\xe9palais"}}},{"name":{"common":"Nauru","official":"Republic of Nauru","native":{"eng":{"official":"Republic of Nauru","common":"Nauru"},"nau":{"official":"Republic of Nauru","common":"Nauru"}}},"tld":[".nr"],"cca2":"NR","ccn3":"520","cca3":"NRU","cioc":"NRU","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"AUD":{"name":"Australian dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["74"]},"capital":["Yaren"],"altSpellings":["NR","Naoero","Pleasant Island","Republic of Nauru","Ripublik Naoero"],"region":"Oceania","subregion":"Micronesia","languages":{"eng":"English","nau":"Nauru"},"translations":{"ces":{"official":"Republika Nauru","common":"Nauru"},"deu":{"official":"Republik Nauru","common":"Nauru"},"est":{"official":"Nauru Vabariik","common":"Nauru"},"fin":{"official":"Naurun tasavalta","common":"Nauru"},"fra":{"official":"R\xe9publique de Nauru","common":"Nauru"},"hrv":{"official":"Republika Nauru","common":"Nauru"},"hun":{"official":"Naurui K\xf6zt\xe1rsas\xe1g","common":"Nauru"},"ita":{"official":"Repubblica di Nauru","common":"Nauru"},"jpn":{"official":"\u30CA\u30A6\u30EB\u5171\u548C\u56FD","common":"\u30CA\u30A6\u30EB"},"kor":{"official":"\uB098\uC6B0\uB8E8 \uACF5\uD654\uAD6D","common":"\uB098\uC6B0\uB8E8"},"nld":{"official":"Republiek Nauru","common":"Nauru"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0646\u0627\u0626\u0648\u0631\u0648","common":"\u0646\u0627\u0626\u0648\u0631\u0648"},"pol":{"official":"Republika Nauru","common":"Nauru"},"por":{"official":"Rep\xfablica de Nauru","common":"Nauru"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041D\u0430\u0443\u0440\u0443","common":"\u041D\u0430\u0443\u0440\u0443"},"slk":{"official":"Naursk\xe1 republika","common":"Nauru"},"spa":{"official":"Rep\xfablica de Nauru","common":"Nauru"},"swe":{"official":"Republiken Nauru","common":"Nauru"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0646\u0627\u0648\u0631\u0648","common":"\u0646\u0627\u0648\u0631\u0648"},"zho":{"official":"\u7459\u9C81\u5171\u548C\u56FD","common":"\u7459\u9C81"}},"latlng":[-0.53333333,166.91666666],"landlocked":false,"borders":[],"area":21,"flag":"\uD83C\uDDF3\uD83C\uDDF7","demonyms":{"eng":{"f":"Nauruan","m":"Nauruan"},"fra":{"f":"Nauruane","m":"Nauruan"}}},{"name":{"common":"New Zealand","official":"New Zealand","native":{"eng":{"official":"New Zealand","common":"New Zealand"},"mri":{"official":"Aotearoa","common":"Aotearoa"},"nzs":{"official":"New Zealand","common":"New Zealand"}}},"tld":[".nz"],"cca2":"NZ","ccn3":"554","cca3":"NZL","cioc":"NZL","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"NZD":{"name":"New Zealand dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["4"]},"capital":["Wellington"],"altSpellings":["NZ","Aotearoa"],"region":"Oceania","subregion":"Australia and New Zealand","languages":{"eng":"English","mri":"M\u0101ori","nzs":"New Zealand Sign Language"},"translations":{"ces":{"official":"Nov\xfd Z\xe9land","common":"Nov\xfd Z\xe9land"},"deu":{"official":"Neuseeland","common":"Neuseeland"},"est":{"official":"Uus-Meremaa","common":"Uus-Meremaa"},"fin":{"official":"Uusi-Seelanti","common":"Uusi-Seelanti"},"fra":{"official":"Nouvelle-Z\xe9lande","common":"Nouvelle-Z\xe9lande"},"hrv":{"official":"Novi Zeland","common":"Novi Zeland"},"hun":{"official":"\xdaj-Z\xe9land","common":"\xdaj-Z\xe9land"},"ita":{"official":"Nuova Zelanda","common":"Nuova Zelanda"},"jpn":{"official":"\u30CB\u30E5\u30FC\u30B8\u30FC\u30E9\u30F3\u30C9","common":"\u30CB\u30E5\u30FC\u30B8\u30FC\u30E9\u30F3\u30C9"},"kor":{"official":"\uB274\uC9C8\uB79C\uB4DC","common":"\uB274\uC9C8\uB79C\uB4DC"},"nld":{"official":"Nieuw Zeeland","common":"Nieuw-Zeeland"},"per":{"official":"\u0646\u06CC\u0648\u0632\u06CC\u0644\u0646\u062F","common":"\u0646\u06CC\u0648\u0632\u06CC\u0644\u0646\u062F"},"pol":{"official":"Nowa Zelandia","common":"Nowa Zelandia"},"por":{"official":"nova Zel\xe2ndia","common":"Nova Zel\xe2ndia"},"rus":{"official":"\u041D\u043E\u0432\u0430\u044F \u0417\u0435\u043B\u0430\u043D\u0434\u0438\u044F","common":"\u041D\u043E\u0432\u0430\u044F \u0417\u0435\u043B\u0430\u043D\u0434\u0438\u044F"},"slk":{"official":"Nov\xfd Z\xe9land","common":"Nov\xfd Z\xe9land"},"spa":{"official":"nueva Zelanda","common":"Nueva Zelanda"},"swe":{"official":"Nya Zeeland","common":"Nya Zeeland"},"urd":{"official":"\u0646\u06CC\u0648\u0632\u06CC \u0644\u06CC\u0646\u0688","common":"\u0646\u06CC\u0648\u0632\u06CC \u0644\u06CC\u0646\u0688"},"zho":{"official":"\u65B0\u897F\u5170","common":"\u65B0\u897F\u5170"}},"latlng":[-41,174],"landlocked":false,"borders":[],"area":270467,"flag":"\uD83C\uDDF3\uD83C\uDDFF","demonyms":{"eng":{"f":"New Zealander","m":"New Zealander"},"fra":{"f":"Neo-Z\xe9landaise","m":"Neo-Z\xe9landais"}}},{"name":{"common":"Oman","official":"Sultanate of Oman","native":{"ara":{"official":"\u0633\u0644\u0637\u0646\u0629 \u0639\u0645\u0627\u0646","common":"\u0639\u0645\u0627\u0646"}}},"tld":[".om"],"cca2":"OM","ccn3":"512","cca3":"OMN","cioc":"OMA","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"OMR":{"name":"Omani rial","symbol":"\u0631.\u0639."}},"idd":{"root":"+9","suffixes":["68"]},"capital":["Muscat"],"altSpellings":["OM","Sultanate of Oman","Sal\u1E6Danat \u02BBUm\u0101n"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Sultan\xe1t Om\xe1n","common":"Om\xe1n"},"deu":{"official":"Sultanat Oman","common":"Oman"},"est":{"official":"Omaani Sultaniriik","common":"Omaan"},"fin":{"official":"Omanin sulttaanikunta","common":"Oman"},"fra":{"official":"Sultanat d\'Oman","common":"Oman"},"hrv":{"official":"Sultanat Oman","common":"Oman"},"hun":{"official":"Om\xe1ni Szultan\xe1tus","common":"Om\xe1n"},"ita":{"official":"Sultanato dell\'Oman","common":"oman"},"jpn":{"official":"\u30AA\u30DE\u30FC\u30F3\xb7\u30B9\u30EB\u30BF\u30F3\u56FD","common":"\u30AA\u30DE\u30FC\u30F3"},"kor":{"official":"\uC624\uB9CC \uC220\uD0C4\uAD6D","common":"\uC624\uB9CC"},"nld":{"official":"Sultanaat van Oman","common":"Oman"},"per":{"official":"\u0633\u0644\u0637\u0627\u0646\u200C\u0646\u0634\u06CC\u0646 \u0639\u064F\u0645\u0627\u0646","common":"\u0639\u0645\u0627\u0646"},"pol":{"official":"Su\u0142tanat Omanu","common":"Oman"},"por":{"official":"Sultanato de Om\xe3","common":"Om\xe3"},"rus":{"official":"\u0421\u0443\u043B\u0442\u0430\u043D\u0430\u0442 \u041E\u043C\u0430\u043D","common":"\u041E\u043C\u0430\u043D"},"slk":{"official":"Om\xe1nsky sultan\xe1t","common":"Om\xe1n"},"spa":{"official":"Sultanato de Om\xe1n","common":"Om\xe1n"},"swe":{"official":"Sultanatet Oman","common":"Oman"},"urd":{"official":"\u0633\u0644\u0637\u0646\u062A \u0639\u0645\u0627\u0646","common":"\u0639\u0645\u0627\u0646"},"zho":{"official":"\u963F\u66FC\u82CF\u4E39\u56FD","common":"\u963F\u66FC"}},"latlng":[21,57],"landlocked":false,"borders":["SAU","ARE","YEM"],"area":309500,"flag":"\uD83C\uDDF4\uD83C\uDDF2","demonyms":{"eng":{"f":"Omani","m":"Omani"},"fra":{"f":"Omanaise","m":"Omanais"}}},{"name":{"common":"Pakistan","official":"Islamic Republic of Pakistan","native":{"eng":{"official":"Islamic Republic of Pakistan","common":"Pakistan"},"urd":{"official":"\u0627\u0633\u0644\u0627\u0645\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C2 \u067E\u0627\u0643\u0633\u062A\u0627\u0646","common":"\u067E\u0627\u0643\u0633\u062A\u0627\u0646"}}},"tld":[".pk"],"cca2":"PK","ccn3":"586","cca3":"PAK","cioc":"PAK","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"PKR":{"name":"Pakistani rupee","symbol":"\u20A8"}},"idd":{"root":"+9","suffixes":["2"]},"capital":["Islamabad"],"altSpellings":["PK","P\u0101kist\u0101n","Islamic Republic of Pakistan","Isl\u0101m\u012B Jumh\u016Briya\'eh P\u0101kist\u0101n"],"region":"Asia","subregion":"Southern Asia","languages":{"eng":"English","urd":"Urdu"},"translations":{"ces":{"official":"P\xe1kist\xe1nsk\xe1 isl\xe1msk\xe1 republika","common":"P\xe1kist\xe1n"},"deu":{"official":"Islamische Republik Pakistan","common":"Pakistan"},"est":{"official":"Pakistani Islamivabariik","common":"Pakistan"},"fin":{"official":"Pakistanin islamilainen tasavalta","common":"Pakistan"},"fra":{"official":"R\xe9publique islamique du Pakistan","common":"Pakistan"},"hrv":{"official":"Islamska Republika Pakistan","common":"Pakistan"},"hun":{"official":"Pakiszt\xe1n","common":"Pakiszt\xe1n"},"ita":{"official":"Repubblica islamica del Pakistan","common":"Pakistan"},"jpn":{"official":"\u30D1\u30AD\u30B9\u30BF\u30F3","common":"\u30D1\u30AD\u30B9\u30BF\u30F3"},"kor":{"official":"\uD30C\uD0A4\uC2A4\uD0C4 \uC774\uC2AC\uB78C \uACF5\uD654\uAD6D","common":"\uD30C\uD0A4\uC2A4\uD0C4"},"nld":{"official":"Islamitische Republiek Pakistan","common":"Pakistan"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0633\u0644\u0627\u0645\u06CC \u067E\u0627\u06A9\u0633\u062A\u0627\u0646","common":"\u067E\u0627\u06A9\u0633\u062A\u0627\u0646"},"pol":{"official":"Islamska Republika Pakistanu","common":"Pakistan"},"por":{"official":"Rep\xfablica Isl\xe2mica do Paquist\xe3o","common":"Paquist\xe3o"},"rus":{"official":"\u0418\u0441\u043B\u0430\u043C\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041F\u0430\u043A\u0438\u0441\u0442\u0430\u043D","common":"\u041F\u0430\u043A\u0438\u0441\u0442\u0430\u043D"},"slk":{"official":"Pakistansk\xe1 islamsk\xe1 republika","common":"Pakistan"},"spa":{"official":"Rep\xfablica Isl\xe1mica de Pakist\xe1n","common":"Pakist\xe1n"},"swe":{"official":"Islamiska republiken Pakistan","common":"Pakistan"},"urd":{"official":"\u0627\u0633\u0644\u0627\u0645\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u067E\u0627\u06A9\u0633\u062A\u0627\u0646","common":"\u067E\u0627\u06A9\u0633\u062A\u0627\u0646"},"zho":{"official":"\u5DF4\u57FA\u65AF\u5766\u4F0A\u65AF\u5170\u5171\u548C\u56FD","common":"\u5DF4\u57FA\u65AF\u5766"}},"latlng":[30,70],"landlocked":false,"borders":["AFG","CHN","IND","IRN"],"area":881912,"flag":"\uD83C\uDDF5\uD83C\uDDF0","demonyms":{"eng":{"f":"Pakistani","m":"Pakistani"},"fra":{"f":"Pakistanaise","m":"Pakistanais"}}},{"name":{"common":"Panama","official":"Republic of Panama","native":{"spa":{"official":"Rep\xfablica de Panam\xe1","common":"Panam\xe1"}}},"tld":[".pa"],"cca2":"PA","ccn3":"591","cca3":"PAN","cioc":"PAN","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"PAB":{"name":"Panamanian balboa","symbol":"B/."},"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+5","suffixes":["07"]},"capital":["Panama City"],"altSpellings":["PA","Republic of Panama","Rep\xfablica de Panam\xe1"],"region":"Americas","subregion":"Central America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Panamsk\xe1 republika","common":"Panama"},"deu":{"official":"Republik Panama","common":"Panama"},"est":{"official":"Panama Vabariik","common":"Panama"},"fin":{"official":"Panaman tasavalta","common":"Panama"},"fra":{"official":"R\xe9publique du Panama","common":"Panama"},"hrv":{"official":"Republika Panama","common":"Panama"},"hun":{"official":"Panamai K\xf6zt\xe1rsas\xe1g","common":"Panama"},"ita":{"official":"Repubblica di Panama","common":"Panama"},"jpn":{"official":"\u30D1\u30CA\u30DE\u5171\u548C\u56FD","common":"\u30D1\u30CA\u30DE"},"kor":{"official":"\uD30C\uB098\uB9C8 \uACF5\uD654\uAD6D","common":"\uD30C\uB098\uB9C8"},"nld":{"official":"Republiek Panama","common":"Panama"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u067E\u0627\u0646\u0627\u0645\u0627","common":"\u067E\u0627\u0646\u0627\u0645\u0627"},"pol":{"official":"Republika Panamy","common":"Panama"},"por":{"official":"Rep\xfablica do Panam\xe1","common":"Panam\xe1"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041F\u0430\u043D\u0430\u043C\u0430","common":"\u041F\u0430\u043D\u0430\u043C\u0430"},"slk":{"official":"Panamsk\xe1 republika","common":"Panama"},"spa":{"official":"Rep\xfablica de Panam\xe1","common":"Panam\xe1"},"swe":{"official":"Republiken Panama","common":"Panama"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u067E\u0627\u0646\u0627\u0645\u0627","common":"\u067E\u0627\u0646\u0627\u0645\u0627"},"zho":{"official":"\u5DF4\u62FF\u9A6C\u5171\u548C\u56FD","common":"\u5DF4\u62FF\u9A6C"}},"latlng":[9,-80],"landlocked":false,"borders":["COL","CRI"],"area":75417,"flag":"\uD83C\uDDF5\uD83C\uDDE6","demonyms":{"eng":{"f":"Panamanian","m":"Panamanian"},"fra":{"f":"Panam\xe9enne","m":"Panam\xe9en"}}},{"name":{"common":"Pitcairn Islands","official":"Pitcairn Group of Islands","native":{"eng":{"official":"Pitcairn Group of Islands","common":"Pitcairn Islands"}}},"tld":[".pn"],"cca2":"PN","ccn3":"612","cca3":"PCN","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"NZD":{"name":"New Zealand dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["4"]},"capital":["Adamstown"],"altSpellings":["PN","Pitcairn","Pitcairn Henderson Ducie and Oeno Islands"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English"},"translations":{"ces":{"official":"Pitcairnovy ostrovy","common":"Pitcairnovy ostrovy"},"deu":{"official":"Pitcairninseln","common":"Pitcairninseln"},"est":{"official":"Pitcairni, Hendersoni, Ducie ja Oeno saar","common":"Pitcairn"},"fin":{"official":"Pitcairn","common":"Pitcairn"},"fra":{"official":"Groupe d\'\xeeles Pitcairn","common":"\xceles Pitcairn"},"hrv":{"official":"Pitcairn skupine otoka","common":"Pitcairnovo oto\u010Dje"},"hun":{"official":"Pitcairn-szigetek","common":"Pitcairn-szigetek"},"ita":{"official":"Pitcairn gruppo di isole","common":"Isole Pitcairn"},"jpn":{"official":"\u5CF6\u306E\u30D4\u30C8\u30B1\u30A2\u30F3\u30B0\u30EB\u30FC\u30D7","common":"\u30D4\u30C8\u30B1\u30A2\u30F3"},"kor":{"official":"\uD54F\uCF00\uC5B8 \uC81C\uB3C4","common":"\uD54F\uCF00\uC5B8 \uC81C\uB3C4"},"nld":{"official":"Pitcairn groep eilanden","common":"Pitcairneilanden"},"per":{"official":"\u062C\u0632\u0627\u06CC\u0631 \u067E\u06CC\u062A\u200C\u06A9\u0631\u0646","common":"\u062C\u0632\u0627\u06CC\u0631 \u067E\u06CC\u062A\u200C\u06A9\u0631\u0646"},"pol":{"official":"Wyspy Pitcairn, Henderson, Ducie i Oeno","common":"Pitcairn"},"por":{"official":"Pitcairn grupo de ilhas","common":"Ilhas Pitcairn"},"rus":{"official":"\u041F\u0438\u0442\u043A\u044D\u0440\u043D \u0433\u0440\u0443\u043F\u043F\u0430 \u043E\u0441\u0442\u0440\u043E\u0432\u043E\u0432","common":"\u041E\u0441\u0442\u0440\u043E\u0432\u0430 \u041F\u0438\u0442\u043A\u044D\u0440\u043D"},"slk":{"official":"Pitcairnove ostrovy","common":"Pitcairnove ostrovy"},"spa":{"official":"Grupo de Islas Pitcairn","common":"Islas Pitcairn"},"swe":{"official":"Pitcairn\xf6arna","common":"Pitcairn\xf6arna"},"urd":{"official":"\u067E\u0679\u06A9\u06CC\u0631\u0646 \u062C\u0632\u0627\u0626\u0631","common":"\u062C\u0632\u0627\u0626\u0631 \u067E\u0679\u06A9\u06CC\u0631\u0646"},"zho":{"official":"\u76AE\u7279\u51EF\u6069\u7FA4\u5C9B","common":"\u76AE\u7279\u51EF\u6069\u7FA4\u5C9B"}},"latlng":[-25.06666666,-130.1],"landlocked":false,"borders":[],"area":47,"flag":"\uD83C\uDDF5\uD83C\uDDF3","demonyms":{"eng":{"f":"Pitcairn Islander","m":"Pitcairn Islander"},"fra":{"f":"Pitcairnaise","m":"Pitcairnais"}}},{"name":{"common":"Peru","official":"Republic of Peru","native":{"aym":{"official":"Piruw Suyu","common":"Piruw"},"que":{"official":"Piruw Ripuwlika","common":"Piruw"},"spa":{"official":"Rep\xfablica del Per\xfa","common":"Per\xfa"}}},"tld":[".pe"],"cca2":"PE","ccn3":"604","cca3":"PER","cioc":"PER","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"PEN":{"name":"Peruvian sol","symbol":"S/."}},"idd":{"root":"+5","suffixes":["1"]},"capital":["Lima"],"altSpellings":["PE","Republic of Peru","Rep\xfablica del Per\xfa"],"region":"Americas","subregion":"South America","languages":{"aym":"Aymara","que":"Quechua","spa":"Spanish"},"translations":{"ces":{"official":"Peru\xe1nsk\xe1 republika","common":"Peru"},"deu":{"official":"Republik Peru","common":"Peru"},"est":{"official":"Peruu Vabariik","common":"Peruu"},"fin":{"official":"Perun tasavalta","common":"Peru"},"fra":{"official":"R\xe9publique du P\xe9rou","common":"P\xe9rou"},"hrv":{"official":"Republika Peru","common":"Peru"},"hun":{"official":"Perui K\xf6zt\xe1rsas\xe1g","common":"Peru"},"ita":{"official":"Repubblica del Per\xf9","common":"Per\xf9"},"jpn":{"official":"\u30DA\u30EB\u30FC\u5171\u548C\u56FD","common":"\u30DA\u30EB\u30FC"},"kor":{"official":"\uD398\uB8E8 \uACF5\uD654\uAD6D","common":"\uD398\uB8E8"},"nld":{"official":"Republiek Peru","common":"Peru"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u067E\u0631\u0648","common":"\u067E\u0631\u0648"},"pol":{"official":"Republika Peru","common":"Peru"},"por":{"official":"Rep\xfablica do Peru","common":"Per\xfa"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041F\u0435\u0440\u0443","common":"\u041F\u0435\u0440\u0443"},"slk":{"official":"Peru\xe1nska republika","common":"Peru"},"spa":{"official":"Rep\xfablica de Per\xfa","common":"Per\xfa"},"swe":{"official":"Republiken Peru","common":"Peru"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u067E\u06CC\u0631\u0648","common":"\u067E\u06CC\u0631\u0648"},"zho":{"official":"\u79D8\u9C81\u5171\u548C\u56FD","common":"\u79D8\u9C81"}},"latlng":[-10,-76],"landlocked":false,"borders":["BOL","BRA","CHL","COL","ECU"],"area":1285216,"flag":"\uD83C\uDDF5\uD83C\uDDEA","demonyms":{"eng":{"f":"Peruvian","m":"Peruvian"},"fra":{"f":"P\xe9ruvienne","m":"P\xe9ruvien"}}},{"name":{"common":"Philippines","official":"Republic of the Philippines","native":{"eng":{"official":"Republic of the Philippines","common":"Philippines"},"fil":{"official":"Republic of the Philippines","common":"Pilipinas"}}},"tld":[".ph"],"cca2":"PH","ccn3":"608","cca3":"PHL","cioc":"PHI","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"PHP":{"name":"Philippine peso","symbol":"\u20B1"}},"idd":{"root":"+6","suffixes":["3"]},"capital":["Manila"],"altSpellings":["PH","Republic of the Philippines","Rep\xfablika ng Pilipinas"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"eng":"English","fil":"Filipino"},"translations":{"ces":{"official":"Filip\xednsk\xe1 republika","common":"Filip\xedny"},"deu":{"official":"Republik der Philippinen","common":"Philippinen"},"est":{"official":"Filipiini Vabariik","common":"Filipiinid"},"fin":{"official":"Filippiinien tasavalta","common":"Filippiinit"},"fra":{"official":"R\xe9publique des Philippines","common":"Philippines"},"hrv":{"official":"Republika Filipini","common":"Filipini"},"hun":{"official":"F\xfcl\xf6p-szigeteki K\xf6zt\xe1rsas\xe1g","common":"F\xfcl\xf6p-szigetek"},"ita":{"official":"Repubblica delle Filippine","common":"Filippine"},"jpn":{"official":"\u30D5\u30A3\u30EA\u30D4\u30F3\u5171\u548C\u56FD","common":"\u30D5\u30A3\u30EA\u30D4\u30F3"},"kor":{"official":"\uD544\uB9AC\uD540 \uACF5\uD654\uAD6D","common":"\uD544\uB9AC\uD540"},"nld":{"official":"Republiek der Filipijnen","common":"Filipijnen"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0641\u06CC\u0644\u06CC\u067E\u06CC\u0646","common":"\u0641\u06CC\u0644\u06CC\u067E\u06CC\u0646"},"pol":{"official":"Republika Filipin","common":"Filipiny"},"por":{"official":"Rep\xfablica das Filipinas","common":"Filipinas"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0424\u0438\u043B\u0438\u043F\u043F\u0438\u043D\u044B","common":"\u0424\u0438\u043B\u0438\u043F\u043F\u0438\u043D\u044B"},"slk":{"official":"Filip\xednska republika","common":"Filip\xedny"},"spa":{"official":"Rep\xfablica de las Filipinas","common":"Filipinas"},"swe":{"official":"Republiken Filippinerna","common":"Filippinerna"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0641\u0644\u067E\u0627\u0626\u0646","common":"\u0641\u0644\u067E\u0627\u0626\u0646"},"zho":{"official":"\u83F2\u5F8B\u5BBE\u5171\u548C\u56FD","common":"\u83F2\u5F8B\u5BBE"}},"latlng":[13,122],"landlocked":false,"borders":[],"area":342353,"flag":"\uD83C\uDDF5\uD83C\uDDED","demonyms":{"eng":{"f":"Filipino","m":"Filipino"},"fra":{"f":"Philippine","m":"Philippin"}}},{"name":{"common":"Palau","official":"Republic of Palau","native":{"eng":{"official":"Republic of Palau","common":"Palau"},"pau":{"official":"Beluu er a Belau","common":"Belau"}}},"tld":[".pw"],"cca2":"PW","ccn3":"585","cca3":"PLW","cioc":"PLW","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["80"]},"capital":["Ngerulmud"],"altSpellings":["PW","Republic of Palau","Beluu er a Belau"],"region":"Oceania","subregion":"Micronesia","languages":{"eng":"English","pau":"Palauan"},"translations":{"ces":{"official":"Republika Palau","common":"Palau"},"deu":{"official":"Republik Palau","common":"Palau"},"est":{"official":"Belau Vabariik","common":"Belau"},"fin":{"official":"Palaun tasavalta","common":"Palau"},"fra":{"official":"R\xe9publique des Palaos (Palau)","common":"Palaos (Palau)"},"hrv":{"official":"Republika Palau","common":"Palau"},"hun":{"official":"Palaui K\xf6zt\xe1rsas\xe1g","common":"Palau"},"ita":{"official":"Repubblica di Palau","common":"Palau"},"jpn":{"official":"\u30D1\u30E9\u30AA\u5171\u548C\u56FD","common":"\u30D1\u30E9\u30AA"},"kor":{"official":"\uD314\uB77C\uC6B0 \uACF5\uD654\uAD6D","common":"\uD314\uB77C\uC6B0"},"nld":{"official":"Republiek van Palau","common":"Palau"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u067E\u0627\u0644\u0627\u0626\u0648","common":"\u067E\u0627\u0644\u0627\u0626\u0648"},"pol":{"official":"Republika Palau","common":"Palau"},"por":{"official":"Rep\xfablica de Palau","common":"Palau"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041F\u0430\u043B\u0430\u0443","common":"\u041F\u0430\u043B\u0430\u0443"},"slk":{"official":"Palausk\xe1 republika","common":"Palau"},"spa":{"official":"Rep\xfablica de Palau","common":"Palau"},"swe":{"official":"Republiken Palau","common":"Palau"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u067E\u0644\u0627\u0624","common":"\u067E\u0644\u0627\u0624"},"zho":{"official":"\u5E15\u52B3\u5171\u548C\u56FD","common":"\u5E15\u52B3"}},"latlng":[7.5,134.5],"landlocked":false,"borders":[],"area":459,"flag":"\uD83C\uDDF5\uD83C\uDDFC","demonyms":{"eng":{"f":"Palauan","m":"Palauan"},"fra":{"f":"Paluane","m":"Paluan"}}},{"name":{"common":"Papua New Guinea","official":"Independent State of Papua New Guinea","native":{"eng":{"official":"Independent State of Papua New Guinea","common":"Papua New Guinea"},"hmo":{"official":"Independen Stet bilong Papua Niugini","common":"Papua Niu Gini"},"tpi":{"official":"Independen Stet bilong Papua Niugini","common":"Papua Niugini"}}},"tld":[".pg"],"cca2":"PG","ccn3":"598","cca3":"PNG","cioc":"PNG","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"PGK":{"name":"Papua New Guinean kina","symbol":"K"}},"idd":{"root":"+6","suffixes":["75"]},"capital":["Port Moresby"],"altSpellings":["PG","Independent State of Papua New Guinea","Independen Stet bilong Papua Niugini"],"region":"Oceania","subregion":"Melanesia","languages":{"eng":"English","hmo":"Hiri Motu","tpi":"Tok Pisin"},"translations":{"ces":{"official":"Nez\xe1visl\xfd st\xe1t Papua Nov\xe1 Guinea","common":"Papua-Nov\xe1 Guinea"},"deu":{"official":"Unabh\xe4ngiger Staat Papua-Neuguinea","common":"Papua-Neuguinea"},"est":{"official":"Paapua Uus-Guinea Iseseisvusriik","common":"Paapua Uus-Guinea"},"fin":{"official":"Papua-Uuden-Guinean Itsen\xe4inen valtio","common":"Papua-Uusi-Guinea"},"fra":{"official":"\xc9tat ind\xe9pendant de Papouasie-Nouvelle-Guin\xe9e","common":"Papouasie-Nouvelle-Guin\xe9e"},"hrv":{"official":"Nezavisna Dr\u017Eava Papui Novoj Gvineji","common":"Papua Nova Gvineja"},"hun":{"official":"P\xe1pua \xdaj-Guinea F\xfcggetlen \xc1llam","common":"P\xe1pua \xdaj-Guinea"},"ita":{"official":"Stato indipendente di Papua Nuova Guinea","common":"Papua Nuova Guinea"},"jpn":{"official":"\u30D1\u30D7\u30A2\u30CB\u30E5\u30FC\u30AE\u30CB\u30A2\u72EC\u7ACB\u56FD","common":"\u30D1\u30D7\u30A2\u30CB\u30E5\u30FC\u30AE\u30CB\u30A2"},"kor":{"official":"\uD30C\uD478\uC544\uB274\uAE30\uB2C8 \uB3C5\uB9BD\uAD6D","common":"\uD30C\uD478\uC544\uB274\uAE30\uB2C8"},"nld":{"official":"Onafhankelijke Staat Papoea -Nieuw-Guinea","common":"Papoea-Nieuw-Guinea"},"per":{"official":"\u0645\u0645\u0644\u06A9\u062A \u0645\u0633\u062A\u0642\u0644 \u067E\u0627\u067E\u0648\u0622 \u06AF\u06CC\u0646\u0647\u0654 \u0646\u0648","common":"\u067E\u0627\u067E\u0648\u0622 \u06AF\u06CC\u0646\u0647 \u0646\u0648"},"pol":{"official":"Niezale\u017Cne Pa\u0144stwo Papui-Nowej Gwinei","common":"Papua-Nowa Gwinea"},"por":{"official":"Estado Independente da Papua Nova Guin\xe9","common":"Papua Nova Guin\xe9"},"rus":{"official":"\u041D\u0435\u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0435 \u0413\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u043E \u041F\u0430\u043F\u0443\u0430-\u041D\u043E\u0432\u043E\u0439 \u0413\u0432\u0438\u043D\u0435\u0438","common":"\u041F\u0430\u043F\u0443\u0430 \u2014 \u041D\u043E\u0432\u0430\u044F \u0413\u0432\u0438\u043D\u0435\u044F"},"slk":{"official":"Nez\xe1visl\xfd \u0161t\xe1t Papua-Nov\xe1 Guinea","common":"Papua-Nov\xe1 Guinea"},"spa":{"official":"Estado Independiente de Pap\xfaa Nueva Guinea","common":"Pap\xfaa Nueva Guinea"},"swe":{"official":"Den oberoende staten Papua Nya Guinea","common":"Papua Nya Guinea"},"urd":{"official":"\u0622\u0632\u0627\u062F \u0631\u06CC\u0627\u0633\u062A\u0650 \u067E\u0627\u067E\u0648\u0627 \u0646\u06CC\u0648 \u06AF\u0646\u06CC","common":"\u067E\u0627\u067E\u0648\u0627 \u0646\u06CC\u0648 \u06AF\u0646\u06CC"},"zho":{"official":"\u5DF4\u5E03\u4E9A\u65B0\u51E0\u5185\u4E9A","common":"\u5DF4\u5E03\u4E9A\u65B0\u51E0\u5185\u4E9A"}},"latlng":[-6,147],"landlocked":false,"borders":["IDN"],"area":462840,"flag":"\uD83C\uDDF5\uD83C\uDDEC","demonyms":{"eng":{"f":"Papua New Guinean","m":"Papua New Guinean"},"fra":{"f":"Papouasienne","m":"Papouasien"}}},{"name":{"common":"Poland","official":"Republic of Poland","native":{"pol":{"official":"Rzeczpospolita Polska","common":"Polska"}}},"tld":[".pl"],"cca2":"PL","ccn3":"616","cca3":"POL","cioc":"POL","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"PLN":{"name":"Polish z\u0142oty","symbol":"z\u0142"}},"idd":{"root":"+4","suffixes":["8"]},"capital":["Warsaw"],"altSpellings":["PL","Republic of Poland","Rzeczpospolita Polska"],"region":"Europe","subregion":"Central Europe","languages":{"pol":"Polish"},"translations":{"ces":{"official":"Polsk\xe1 republika","common":"Polsko"},"deu":{"official":"Republik Polen","common":"Polen"},"est":{"official":"Poola Vabariik","common":"Poola"},"fin":{"official":"Puolan tasavalta","common":"Puola"},"fra":{"official":"R\xe9publique de Pologne","common":"Pologne"},"hrv":{"official":"Republika Poljska","common":"Poljska"},"hun":{"official":"Lengyel K\xf6zt\xe1rsas\xe1g","common":"Lengyelorsz\xe1g"},"ita":{"official":"Repubblica di Polonia","common":"Polonia"},"jpn":{"official":"\u30DD\u30FC\u30E9\u30F3\u30C9\u5171\u548C\u56FD","common":"\u30DD\u30FC\u30E9\u30F3\u30C9"},"kor":{"official":"\uD3F4\uB780\uB4DC \uACF5\uD654\uAD6D","common":"\uD3F4\uB780\uB4DC"},"nld":{"official":"Republiek Polen","common":"Polen"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0644\u0647\u0633\u062A\u0627\u0646","common":"\u0644\u0647\u0633\u062A\u0627\u0646"},"pol":{"official":"Rzeczpospolita Polska","common":"Polska"},"por":{"official":"Rep\xfablica da Pol\xf3nia","common":"Pol\xf3nia"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041F\u043E\u043B\u044C\u0448\u0430","common":"\u041F\u043E\u043B\u044C\u0448\u0430"},"slk":{"official":"Po\u013Esk\xe1 republika","common":"Po\u013Esko"},"spa":{"official":"Rep\xfablica de Polonia","common":"Polonia"},"swe":{"official":"Republiken Polen","common":"Polen"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u067E\u0648\u0644\u06CC\u0646\u0688","common":"\u067E\u0648\u0644\u06CC\u0646\u0688"},"zho":{"official":"\u6CE2\u5170\u5171\u548C\u56FD","common":"\u6CE2\u5170"}},"latlng":[52,20],"landlocked":false,"borders":["BLR","CZE","DEU","LTU","RUS","SVK","UKR"],"area":312679,"flag":"\uD83C\uDDF5\uD83C\uDDF1","demonyms":{"eng":{"f":"Polish","m":"Polish"},"fra":{"f":"Polonaise","m":"Polonais"}}},{"name":{"common":"Puerto Rico","official":"Commonwealth of Puerto Rico","native":{"eng":{"official":"Commonwealth of Puerto Rico","common":"Puerto Rico"},"spa":{"official":"Estado Libre Asociado de Puerto Rico","common":"Puerto Rico"}}},"tld":[".pr"],"cca2":"PR","ccn3":"630","cca3":"PRI","cioc":"PUR","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["787","939"]},"capital":["San Juan"],"altSpellings":["PR","Commonwealth of Puerto Rico","Estado Libre Asociado de Puerto Rico"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English","spa":"Spanish"},"translations":{"ces":{"official":"Portoriko","common":"Portoriko"},"deu":{"official":"Freistaat Puerto Rico","common":"Puerto Rico"},"est":{"official":"Puerto Rico \xdchendus","common":"Puerto Rico"},"fin":{"official":"Puerto Rico","common":"Puerto Rico"},"fra":{"official":"Porto Rico","common":"Porto Rico"},"hrv":{"official":"Zajednica Puerto Rico","common":"Portoriko"},"hun":{"official":"Puerto Rico","common":"Puerto Rico"},"ita":{"official":"Commonwealth di Porto Rico","common":"Porto Rico"},"jpn":{"official":"\u30D7\u30A8\u30EB\u30C8\u30EA\u30B3\u306E\u30B3\u30E2\u30F3\u30A6\u30A7\u30EB\u30B9","common":"\u30D7\u30A8\u30EB\u30C8\u30EA\u30B3"},"kor":{"official":"\uD478\uC5D0\uB974\uD1A0\uB9AC\uCF54","common":"\uD478\uC5D0\uB974\uD1A0\uB9AC\uCF54"},"nld":{"official":"Gemenebest van Puerto Rico","common":"Puerto Rico"},"per":{"official":"\u0642\u0644\u0645\u0631\u0648 \u0647\u0645\u0633\u0648\u062F \u067E\u0648\u0631\u062A\u0648\u0631\u06CC\u06A9\u0648","common":"\u067E\u0648\u0631\u062A\u0648\u0631\u06CC\u06A9\u0648"},"pol":{"official":"Wolne Stowarzyszone Pa\u0144stwo Portoryko","common":"Portoryko"},"por":{"official":"Commonwealth of Puerto Rico","common":"Porto Rico"},"rus":{"official":"\u0421\u043E\u0434\u0440\u0443\u0436\u0435\u0441\u0442\u0432\u043E \u041F\u0443\u044D\u0440\u0442\u043E-\u0420\u0438\u043A\u043E","common":"\u041F\u0443\u044D\u0440\u0442\u043E-\u0420\u0438\u043A\u043E"},"slk":{"official":"Portorick\xe9 spolo\u010Denstvo","common":"Portoriko"},"spa":{"official":"Asociado de Puerto Rico","common":"Puerto Rico"},"swe":{"official":"Puerto Rico","common":"Puerto Rico"},"urd":{"official":" \u062F\u0648\u0644\u062A\u0650 \u0645\u0634\u062A\u0631\u06A9\u06C1 \u067E\u0648\u0631\u0679\u0648 \u0631\u06CC\u06A9\u0648","common":"\u067E\u0648\u0631\u0679\u0648 \u0631\u06CC\u06A9\u0648"},"zho":{"official":"\u6CE2\u591A\u9ECE\u5404\u8054\u90A6","common":"\u6CE2\u591A\u9ECE\u5404"}},"latlng":[18.25,-66.5],"landlocked":false,"borders":[],"area":8870,"flag":"\uD83C\uDDF5\uD83C\uDDF7","demonyms":{"eng":{"f":"Puerto Rican","m":"Puerto Rican"},"fra":{"f":"Portoricaine","m":"Portoricain"}}},{"name":{"common":"North Korea","official":"Democratic People\'s Republic of Korea","native":{"kor":{"official":"\uC870\uC120\uBBFC\uC8FC\uC8FC\uC758\uC778\uBBFC\uACF5\uD654\uAD6D","common":"\uC870\uC120"}}},"tld":[".kp"],"cca2":"KP","ccn3":"408","cca3":"PRK","cioc":"PRK","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"KPW":{"name":"North Korean won","symbol":"\u20A9"}},"idd":{"root":"+8","suffixes":["50"]},"capital":["Pyongyang"],"altSpellings":["KP","Democratic People\'s Republic of Korea","DPRK","\uC870\uC120\uBBFC\uC8FC\uC8FC\uC758\uC778\uBBFC\uACF5\uD654\uAD6D","Chos\u014Fn Minjuju\u016Di Inmin Konghwaguk","Korea, Democratic People\'s Republic of","\uBD81\uD55C","\uBD81\uC870\uC120"],"region":"Asia","subregion":"Eastern Asia","languages":{"kor":"Korean"},"translations":{"ces":{"official":"Korejsk\xe1 lidov\u011B demokratick\xe1 republika","common":"Severn\xed Korea"},"deu":{"official":"Demokratische Volksrepublik Korea","common":"Nordkorea"},"est":{"official":"Korea Rahvademokraatlik Vabariik","common":"P\xf5hja-Korea"},"fin":{"official":"Korean demokraattinen kansantasavalta","common":"Pohjois-Korea"},"fra":{"official":"R\xe9publique populaire d\xe9mocratique de Cor\xe9e","common":"Cor\xe9e du Nord"},"hrv":{"official":"Demokratska Narodna Republika Koreja","common":"Sjeverna Koreja"},"hun":{"official":"Koreai N\xe9pi Demokratikus K\xf6zt\xe1rsas\xe1g","common":"\xc9szak-Korea"},"ita":{"official":"Repubblica democratica popolare di Corea","common":"Corea del Nord"},"jpn":{"official":"\u671D\u9BAE\u6C11\u4E3B\u4E3B\u7FA9\u4EBA\u6C11\u5171\u548C\u56FD","common":"\u671D\u9BAE\u6C11\u4E3B\u4E3B\u7FA9\u4EBA\u6C11\u5171\u548C\u56FD"},"kor":{"official":"\uC870\uC120\uBBFC\uC8FC\uC8FC\uC758\uC778\uBBFC\uACF5\uD654\uAD6D","common":"\uC870\uC120"},"nld":{"official":"Democratische Volksrepubliek Korea","common":"Noord-Korea"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u062F\u0645\u0648\u06A9\u0631\u0627\u062A\u06CC\u06A9 \u062E\u0644\u0642 \u06A9\u0631\u0647","common":"\u06A9\u064F\u0631\u0647 \u0634\u0645\u0627\u0644\u06CC"},"pol":{"official":"Korea\u0144ska Republika Ludowo-Demokratyczna","common":"Korea P\xf3\u0142nocna"},"por":{"official":"Rep\xfablica Popular Democr\xe1tica da Coreia","common":"Coreia do Norte"},"rus":{"official":"\u041A\u043E\u0440\u0435\u0439\u0441\u043A\u0430\u044F \u041D\u0430\u0440\u043E\u0434\u043D\u043E-\u0414\u0435\u043C\u043E\u043A\u0440\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u0440\u0435\u044F","common":"\u0421\u0435\u0432\u0435\u0440\u043D\u0430\u044F \u041A\u043E\u0440\u0435\u044F"},"slk":{"official":"K\xf3rejsk\xe1 \u013Eudovodemokratick\xe1 republika","common":"K\xf3rejsk\xe1 \u013Eudovodemokratick\xe1 republika (K\u013DR, Severn\xe1 K\xf3rea)"},"spa":{"official":"Rep\xfablica Popular Democr\xe1tica de Corea","common":"Corea del Norte"},"swe":{"official":"Demokratiska Folkrepubliken Korea","common":"Nordkorea"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC \u0639\u0648\u0627\u0645\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06A9\u0648\u0631\u06CC\u0627","common":"\u0634\u0645\u0627\u0644\u06CC \u06A9\u0648\u0631\u06CC\u0627"},"zho":{"official":"\u671D\u9C9C\u4EBA\u6C11\u6C11\u4E3B\u5171\u548C\u56FD","common":"\u671D\u9C9C"}},"latlng":[40,127],"landlocked":false,"borders":["CHN","KOR","RUS"],"area":120538,"flag":"\uD83C\uDDF0\uD83C\uDDF5","demonyms":{"eng":{"f":"North Korean","m":"North Korean"},"fra":{"f":"Nord-cor\xe9enne","m":"Nord-cor\xe9en"}}},{"name":{"common":"Portugal","official":"Portuguese Republic","native":{"por":{"official":"Rep\xfablica portugu\xeas","common":"Portugal"}}},"tld":[".pt"],"cca2":"PT","ccn3":"620","cca3":"PRT","cioc":"POR","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["51"]},"capital":["Lisbon"],"altSpellings":["PT","Portuguesa","Portuguese Republic","Rep\xfablica Portuguesa"],"region":"Europe","subregion":"Southern Europe","languages":{"por":"Portuguese"},"translations":{"ces":{"official":"Portugalsk\xe1 republika","common":"Portugalsko"},"deu":{"official":"Portugiesische Republik","common":"Portugal"},"est":{"official":"Portugali Vabariik","common":"Portugal"},"fin":{"official":"Portugalin tasavalta","common":"Portugali"},"fra":{"official":"R\xe9publique portugaise","common":"Portugal"},"hrv":{"official":"Portugalska Republika","common":"Portugal"},"hun":{"official":"Portug\xe1l K\xf6zt\xe1rsas\xe1g","common":"Portug\xe1lia"},"ita":{"official":"Repubblica portoghese","common":"Portogallo"},"jpn":{"official":"\u30DD\u30EB\u30C8\u30AC\u30EB\u5171\u548C\u56FD","common":"\u30DD\u30EB\u30C8\u30AC\u30EB"},"kor":{"official":"\uD3EC\uB974\uD22C\uAC08 \uACF5\uD654\uAD6D","common":"\uD3EC\uB974\uD22C\uAC08"},"nld":{"official":"Portugese Republiek","common":"Portugal"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u067E\u0631\u062A\u063A\u0627\u0644","common":"\u067E\u0631\u062A\u063A\u0627\u0644"},"pol":{"official":"Republika Portugalska","common":"Portugalia"},"por":{"official":"Rep\xfablica portugu\xeas","common":"Portugal"},"rus":{"official":"\u041F\u043E\u0440\u0442\u0443\u0433\u0430\u043B\u044C\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u041F\u043E\u0440\u0442\u0443\u0433\u0430\u043B\u0438\u044F"},"slk":{"official":"Portugalsk\xe1 republika","common":"Portugalsko"},"spa":{"official":"Rep\xfablica Portuguesa","common":"Portugal"},"swe":{"official":"Republiken Portugal","common":"Portugal"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u067E\u0631\u062A\u06AF\u0627\u0644","common":"\u067E\u0631\u062A\u06AF\u0627\u0644"},"zho":{"official":"\u8461\u8404\u7259\u5171\u548C\u56FD","common":"\u8461\u8404\u7259"}},"latlng":[39.5,-8],"landlocked":false,"borders":["ESP"],"area":92090,"flag":"\uD83C\uDDF5\uD83C\uDDF9","demonyms":{"eng":{"f":"Portuguese","m":"Portuguese"},"fra":{"f":"Portugaise","m":"Portugais"}}},{"name":{"common":"Paraguay","official":"Republic of Paraguay","native":{"grn":{"official":"Tet\xe3 Paragu\xe1i","common":"Paragu\xe1i"},"spa":{"official":"Rep\xfablica de Paraguay","common":"Paraguay"}}},"tld":[".py"],"cca2":"PY","ccn3":"600","cca3":"PRY","cioc":"PAR","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"PYG":{"name":"Paraguayan guaran\xed","symbol":"\u20B2"}},"idd":{"root":"+5","suffixes":["95"]},"capital":["Asunci\xf3n"],"altSpellings":["PY","Republic of Paraguay","Rep\xfablica del Paraguay","Tet\xe3 Paragu\xe1i"],"region":"Americas","subregion":"South America","languages":{"grn":"Guaran\xed","spa":"Spanish"},"translations":{"ces":{"official":"Paraguaysk\xe1 republika","common":"Paraguay"},"deu":{"official":"Republik Paraguay","common":"Paraguay"},"est":{"official":"Paraguay Vabariik","common":"Paraguay"},"fin":{"official":"Paraguayn tasavalta","common":"Paraguay"},"fra":{"official":"R\xe9publique du Paraguay","common":"Paraguay"},"hrv":{"official":"Republika Paragvaj","common":"Paragvaj"},"hun":{"official":"Paraguayi K\xf6zt\xe1rsas\xe1g","common":"Paraguay"},"ita":{"official":"Repubblica del Paraguay","common":"Paraguay"},"jpn":{"official":"\u30D1\u30E9\u30B0\u30A2\u30A4\u5171\u548C\u56FD","common":"\u30D1\u30E9\u30B0\u30A2\u30A4"},"kor":{"official":"\uD30C\uB77C\uACFC\uC774 \uACF5\uD654\uAD6D","common":"\uD30C\uB77C\uACFC\uC774"},"nld":{"official":"Republiek Paraguay","common":"Paraguay"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u067E\u0627\u0631\u0627\u06AF\u0648\u0626\u0647","common":"\u067E\u0627\u0631\u0627\u06AF\u0648\u0626\u0647"},"pol":{"official":"Republika Paragwaju","common":"Paragwaj"},"por":{"official":"Rep\xfablica do Paraguai","common":"Paraguai"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041F\u0430\u0440\u0430\u0433\u0432\u0430\u0439","common":"\u041F\u0430\u0440\u0430\u0433\u0432\u0430\u0439"},"slk":{"official":"Paraguajsk\xe1 republika","common":"Paraguaj"},"spa":{"official":"Rep\xfablica de Paraguay","common":"Paraguay"},"swe":{"official":"Republiken Paraguay","common":"Paraguay"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u067E\u06CC\u0631\u0627\u06AF\u0648\u0626\u06D2","common":"\u067E\u06CC\u0631\u0627\u06AF\u0648\u0626\u06D2"},"zho":{"official":"\u5DF4\u62C9\u572D\u5171\u548C\u56FD","common":"\u5DF4\u62C9\u572D"}},"latlng":[-23,-58],"landlocked":true,"borders":["ARG","BOL","BRA"],"area":406752,"flag":"\uD83C\uDDF5\uD83C\uDDFE","demonyms":{"eng":{"f":"Paraguayan","m":"Paraguayan"},"fra":{"f":"Paraguayenne","m":"Paraguayen"}}},{"name":{"common":"Palestine","official":"State of Palestine","native":{"ara":{"official":"\u062F\u0648\u0644\u0629 \u0641\u0644\u0633\u0637\u064A\u0646","common":"\u0641\u0644\u0633\u0637\u064A\u0646"}}},"tld":[".ps","\u0641\u0644\u0633\u0637\u064A\u0646."],"cca2":"PS","ccn3":"275","cca3":"PSE","cioc":"PLE","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"EGP":{"name":"Egyptian pound","symbol":"E\xa3"},"ILS":{"name":"Israeli new shekel","symbol":"\u20AA"},"JOD":{"name":"Jordanian dinar","symbol":"JD"}},"idd":{"root":"+9","suffixes":["70"]},"capital":["Ramallah"],"altSpellings":["PS","Palestine, State of","State of Palestine","Dawlat Filas\u1E6Din"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"St\xe1t Palestina","common":"Palestina"},"deu":{"official":"Staat Pal\xe4stina","common":"Pal\xe4stina"},"est":{"official":"Palestiina Riik","common":"Palestiina"},"fin":{"official":"Palestiinan valtio","common":"Palestiina"},"fra":{"official":"\xc9tat de Palestine","common":"Palestine"},"hrv":{"official":"State of Palestine","common":"Palestina"},"hun":{"official":"Palesztin Auton\xf3mia","common":"Palesztina"},"ita":{"official":"Stato di Palestina","common":"Palestina"},"jpn":{"official":"\u30D1\u30EC\u30B9\u30C1\u30CA\u81EA\u6CBB\u653F\u5E9C","common":"\u30D1\u30EC\u30B9\u30C1\u30CA"},"kor":{"official":"\uD314\uB808\uC2A4\uD0C0\uC778\uAD6D","common":"\uD314\uB808\uC2A4\uD0C0\uC778"},"nld":{"official":"Staat Palestina","common":"Palestijnse gebieden"},"per":{"official":"\u062F\u0648\u0644\u062A \u0641\u0644\u0633\u0637\u06CC\u0646","common":"\u0641\u0644\u0633\u0637\u06CC\u0646"},"pol":{"official":"Pa\u0144stwo Palestyna","common":"Palestyna"},"por":{"official":"Estado da Palestina","common":"Palestina"},"rus":{"official":"\u0413\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u043E \u041F\u0430\u043B\u0435\u0441\u0442\u0438\u043D\u0430","common":"\u041F\u0430\u043B\u0435\u0441\u0442\u0438\u043D\u0430"},"slk":{"official":"Palest\xednsky \u0161t\xe1t","common":"Palest\xedna"},"spa":{"official":"Estado de Palestina","common":"Palestina"},"swe":{"official":"Palestina","common":"Palestina"},"urd":{"official":"\u0631\u06CC\u0627\u0633\u062A\u0650 \u0641\u0644\u0633\u0637\u06CC\u0646","common":"\u0641\u0644\u0633\u0637\u06CC\u0646"},"zho":{"official":"\u5DF4\u52D2\u65AF\u5766\u56FD","common":"\u5DF4\u52D2\u65AF\u5766"}},"latlng":[31.9,35.2],"landlocked":false,"borders":["ISR","EGY","JOR"],"area":6220,"flag":"\uD83C\uDDF5\uD83C\uDDF8","demonyms":{"eng":{"f":"Palestinian","m":"Palestinian"},"fra":{"f":"Palestinienne","m":"Palestinien"}}},{"name":{"common":"French Polynesia","official":"French Polynesia","native":{"fra":{"official":"Polyn\xe9sie fran\xe7aise","common":"Polyn\xe9sie fran\xe7aise"}}},"tld":[".pf"],"cca2":"PF","ccn3":"258","cca3":"PYF","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"XPF":{"name":"CFP franc","symbol":"\u20A3"}},"idd":{"root":"+6","suffixes":["89"]},"capital":["Papeet\u0113"],"altSpellings":["PF","Polyn\xe9sie fran\xe7aise","French Polynesia","P\u014Dr\u012Bnetia Far\u0101ni"],"region":"Oceania","subregion":"Polynesia","languages":{"fra":"French"},"translations":{"ces":{"official":"Francouzsk\xe1 Polyn\xe9sie","common":"Francouzsk\xe1 Polyn\xe9sie"},"deu":{"official":"Franz\xf6sisch-Polynesien","common":"Franz\xf6sisch-Polynesien"},"est":{"official":"Prantsuse Pol\xfcneesia","common":"Prantsuse Pol\xfcneesia"},"fin":{"official":"Ranskan Polynesia","common":"Ranskan Polynesia"},"fra":{"official":"Polyn\xe9sie fran\xe7aise","common":"Polyn\xe9sie fran\xe7aise"},"hrv":{"official":"Francuska Polinezija","common":"Francuska Polinezija"},"hun":{"official":"Francia Polin\xe9zia","common":"Francia Polin\xe9zia"},"ita":{"official":"Polinesia Francese","common":"Polinesia Francese"},"jpn":{"official":"\u30D5\u30E9\u30F3\u30B9\u9818\u30DD\u30EA\u30CD\u30B7\u30A2","common":"\u30D5\u30E9\u30F3\u30B9\u9818\u30DD\u30EA\u30CD\u30B7\u30A2"},"kor":{"official":"\uD504\uB791\uC2A4\uB839 \uD3F4\uB9AC\uB124\uC2DC\uC544","common":"\uD504\uB791\uC2A4\uB839 \uD3F4\uB9AC\uB124\uC2DC\uC544"},"nld":{"official":"Frans-Polynesi\xeb","common":"Frans-Polynesi\xeb"},"per":{"official":"\u067E\u064F\u0644\u06CC\u200C\u0646\u0650\u0632\u06CC \u0641\u0631\u0627\u0646\u0633\u0647","common":"\u067E\u064F\u0644\u06CC\u200C\u0646\u0650\u0632\u06CC \u0641\u0631\u0627\u0646\u0633\u0647"},"pol":{"official":"Polinezja Francuska","common":"Polinezja Francuska"},"por":{"official":"Polin\xe9sia Francesa","common":"Polin\xe9sia Francesa"},"rus":{"official":"\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u0441\u043A\u0430\u044F \u041F\u043E\u043B\u0438\u043D\u0435\u0437\u0438\u044F","common":"\u0424\u0440\u0430\u043D\u0446\u0443\u0437\u0441\u043A\u0430\u044F \u041F\u043E\u043B\u0438\u043D\u0435\u0437\u0438\u044F"},"slk":{"official":"Franc\xfazska Polyn\xe9zia","common":"Franc\xfazska Polyn\xe9zia"},"spa":{"official":"Polinesia franc\xe9s","common":"Polinesia Francesa"},"swe":{"official":"Franska Polynesien","common":"Franska Polynesien"},"urd":{"official":"\u0641\u0631\u0627\u0646\u0633\u06CC\u0633\u06CC \u067E\u0648\u0644\u06CC\u0646\u06CC\u0634\u06CC\u0627","common":"\u0641\u0631\u0627\u0646\u0633\u06CC\u0633\u06CC \u067E\u0648\u0644\u06CC\u0646\u06CC\u0634\u06CC\u0627"},"zho":{"official":"\u6CD5\u5C5E\u6CE2\u5229\u5C3C\u897F\u4E9A","common":"\u6CD5\u5C5E\u6CE2\u5229\u5C3C\u897F\u4E9A"}},"latlng":[-15,-140],"landlocked":false,"borders":[],"area":4167,"flag":"\uD83C\uDDF5\uD83C\uDDEB","demonyms":{"eng":{"f":"French Polynesian","m":"French Polynesian"},"fra":{"f":"Polyn\xe9sienne","m":"Polyn\xe9sien"}}},{"name":{"common":"Qatar","official":"State of Qatar","native":{"ara":{"official":"\u062F\u0648\u0644\u0629 \u0642\u0637\u0631","common":"\u0642\u0637\u0631"}}},"tld":[".qa","\u0642\u0637\u0631."],"cca2":"QA","ccn3":"634","cca3":"QAT","cioc":"QAT","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"QAR":{"name":"Qatari riyal","symbol":"\u0631.\u0642"}},"idd":{"root":"+9","suffixes":["74"]},"capital":["Doha"],"altSpellings":["QA","State of Qatar","Dawlat Qa\u1E6Dar"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"St\xe1t Katar","common":"Katar"},"deu":{"official":"Staat Katar","common":"Katar"},"est":{"official":"Katari Riik","common":"Katar"},"fin":{"official":"Qatarin valtio","common":"Qatar"},"fra":{"official":"\xc9tat du Qatar","common":"Qatar"},"hrv":{"official":"Dr\u017Eava Katar","common":"Katar"},"hun":{"official":"Katari \xc1llam","common":"Katar"},"ita":{"official":"Stato del Qatar","common":"Qatar"},"jpn":{"official":"\u30AB\u30BF\u30FC\u30EB\u56FD","common":"\u30AB\u30BF\u30FC\u30EB"},"kor":{"official":"\uCE74\uD0C0\uB974\uAD6D","common":"\uCE74\uD0C0\uB974"},"nld":{"official":"Staat Qatar","common":"Qatar"},"per":{"official":"\u062F\u0648\u0644\u062A \u0642\u0637\u0631","common":"\u0642\u0637\u0631"},"pol":{"official":"Pa\u0144stwo Katar","common":"Katar"},"por":{"official":"Estado do Qatar","common":"Catar"},"rus":{"official":"\u0413\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u043E \u041A\u0430\u0442\u0430\u0440","common":"\u041A\u0430\u0442\u0430\u0440"},"slk":{"official":"Katarsk\xfd \u0161t\xe1t","common":"Katar"},"spa":{"official":"Estado de Qatar","common":"Catar"},"swe":{"official":"Staten Qatar","common":"Qatar"},"urd":{"official":"\u0631\u06CC\u0627\u0633\u062A\u0650 \u0642\u0637\u0631","common":"\u0642\u0637\u0631"},"zho":{"official":"\u5361\u5854\u5C14\u56FD","common":"\u5361\u5854\u5C14"}},"latlng":[25.5,51.25],"landlocked":false,"borders":["SAU"],"area":11586,"flag":"\uD83C\uDDF6\uD83C\uDDE6","demonyms":{"eng":{"f":"Qatari","m":"Qatari"},"fra":{"f":"Qatarienne","m":"Qatarien"}}},{"name":{"common":"R\xe9union","official":"R\xe9union Island","native":{"fra":{"official":"Ile de la R\xe9union","common":"La R\xe9union"}}},"tld":[".re"],"cca2":"RE","ccn3":"638","cca3":"REU","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+2","suffixes":["62"]},"capital":["Saint-Denis"],"altSpellings":["RE","Reunion"],"region":"Africa","subregion":"Eastern Africa","languages":{"fra":"French"},"translations":{"ces":{"official":"R\xe9union","common":"R\xe9union"},"deu":{"official":"R\xe9union","common":"R\xe9union"},"est":{"official":"R\xe9unioni departemang","common":"R\xe9union"},"fin":{"official":"R\xe9union","common":"R\xe9union"},"fra":{"official":"Ile de la R\xe9union","common":"R\xe9union"},"hrv":{"official":"R\xe9union Island","common":"R\xe9union"},"hun":{"official":"R\xe9union","common":"R\xe9union"},"ita":{"official":"R\xe9union","common":"Riunione"},"jpn":{"official":"\u30EC\u30E6\u30CB\u30AA\u30F3\u5CF6","common":"\u30EC\u30E6\u30CB\u30AA\u30F3"},"kor":{"official":"\uB808\uC704\uB2C8\uC639","common":"\uB808\uC704\uB2C8\uC639"},"nld":{"official":"R\xe9union","common":"R\xe9union"},"per":{"official":"\u0631\u0626\u0648\u0646\u06CC\u0648\u0646","common":"\u0631\u0626\u0648\u0646\u06CC\u0648\u0646"},"pol":{"official":"Reunion","common":"Reunion"},"por":{"official":"Ilha da Reuni\xe3o","common":"Reuni\xe3o"},"rus":{"official":"\u0420\u0435\u044E\u043D\u044C\u043E\u043D","common":"\u0420\u0435\u044E\u043D\u044C\u043E\u043D"},"slk":{"official":"R\xe9unionsk\xfd z\xe1morsk\xfd departm\xe1n","common":"R\xe9union"},"spa":{"official":"Isla de la Reuni\xf3n","common":"Reuni\xf3n"},"swe":{"official":"R\xe9union","common":"R\xe9union"},"urd":{"official":"\u0631\u06D2 \u06CC\u0648\u0646\u06CC\u0648\u06BA \u062C\u0632\u06CC\u0631\u06C1","common":"\u0631\u06D2 \u06CC\u0648\u0646\u06CC\u0648\u06BA"},"zho":{"official":"\u7559\u5C3C\u65FA\u5C9B","common":"\u7559\u5C3C\u65FA\u5C9B"}},"latlng":[-21.15,55.5],"landlocked":false,"borders":[],"area":2511,"flag":"\uD83C\uDDF7\uD83C\uDDEA","demonyms":{"eng":{"f":"R\xe9unionese","m":"R\xe9unionese"},"fra":{"f":"R\xe9unionnaise","m":"R\xe9unionnais"}}},{"name":{"common":"Romania","official":"Romania","native":{"ron":{"official":"Rom\xe2nia","common":"Rom\xe2nia"}}},"tld":[".ro"],"cca2":"RO","ccn3":"642","cca3":"ROU","cioc":"ROU","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"RON":{"name":"Romanian leu","symbol":"lei"}},"idd":{"root":"+4","suffixes":["0"]},"capital":["Bucharest"],"altSpellings":["RO","Rumania","Roumania","Rom\xe2nia"],"region":"Europe","subregion":"Southeast Europe","languages":{"ron":"Romanian"},"translations":{"ces":{"official":"Rumunsko","common":"Rumunsko"},"deu":{"official":"Rum\xe4nien","common":"Rum\xe4nien"},"est":{"official":"Rumeenia","common":"Rumeenia"},"fin":{"official":"Romania","common":"Romania"},"fra":{"official":"Roumanie","common":"Roumanie"},"hrv":{"official":"Rumunija","common":"Rumunjska"},"hun":{"official":"Rom\xe1nia","common":"Rom\xe1nia"},"ita":{"official":"Romania","common":"Romania"},"jpn":{"official":"\u30EB\u30FC\u30DE\u30CB\u30A2","common":"\u30EB\u30FC\u30DE\u30CB\u30A2"},"kor":{"official":"\uB8E8\uB9C8\uB2C8\uC544","common":"\uB8E8\uB9C8\uB2C8\uC544"},"nld":{"official":"Roemeni\xeb","common":"Roemeni\xeb"},"per":{"official":"\u0631\u0648\u0645\u0627\u0646\u06CC","common":"\u0631\u0648\u0645\u0627\u0646\u06CC"},"pol":{"official":"Rumunia","common":"Rumunia"},"por":{"official":"Rom\xeania","common":"Rom\xe9nia"},"rus":{"official":"\u0420\u0443\u043C\u044B\u043D\u0438\u044F","common":"\u0420\u0443\u043C\u044B\u043D\u0438\u044F"},"slk":{"official":"Rumunsko","common":"Rumunsko"},"spa":{"official":"Rumania","common":"Rumania"},"swe":{"official":"Rum\xe4nien","common":"Rum\xe4nien"},"urd":{"official":"\u0631\u0648\u0645\u0627\u0646\u06CC\u06C1","common":"\u0631\u0648\u0645\u0627\u0646\u06CC\u06C1"},"zho":{"official":"\u7F57\u9A6C\u5C3C\u4E9A","common":"\u7F57\u9A6C\u5C3C\u4E9A"}},"latlng":[46,25],"landlocked":false,"borders":["BGR","HUN","MDA","SRB","UKR"],"area":238391,"flag":"\uD83C\uDDF7\uD83C\uDDF4","demonyms":{"eng":{"f":"Romanian","m":"Romanian"},"fra":{"f":"Roumaine","m":"Roumain"}}},{"name":{"common":"Russia","official":"Russian Federation","native":{"rus":{"official":"\u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u0430\u044F \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u044F","common":"\u0420\u043E\u0441\u0441\u0438\u044F"}}},"tld":[".ru",".su",".\u0440\u0444"],"cca2":"RU","ccn3":"643","cca3":"RUS","cioc":"RUS","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"RUB":{"name":"Russian ruble","symbol":"\u20BD"}},"idd":{"root":"+7","suffixes":["3","4","5","8","9"]},"capital":["Moscow"],"altSpellings":["RU","Russian Federation","\u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u0430\u044F \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u044F"],"region":"Europe","subregion":"Eastern Europe","languages":{"rus":"Russian"},"translations":{"ces":{"official":"Rusk\xe1 federace","common":"Rusko"},"deu":{"official":"Russische F\xf6deration","common":"Russland"},"est":{"official":"Venemaa F\xf6deratsioon","common":"Venemaa"},"fin":{"official":"Ven\xe4j\xe4n federaatio","common":"Ven\xe4j\xe4"},"fra":{"official":"F\xe9d\xe9ration de Russie","common":"Russie"},"hrv":{"official":"Ruska Federacija","common":"Rusija"},"hun":{"official":"Oroszorsz\xe1gi F\xf6der\xe1ci\xf3","common":"Oroszorsz\xe1g"},"ita":{"official":"Federazione russa","common":"Russia"},"jpn":{"official":"\u30ED\u30B7\u30A2\u9023\u90A6","common":"\u30ED\u30B7\u30A2\u9023\u90A6"},"kor":{"official":"\uB7EC\uC2DC\uC544 \uC5F0\uBC29","common":"\uB7EC\uC2DC\uC544"},"nld":{"official":"Russische Federatie","common":"Rusland"},"per":{"official":"\u0641\u062F\u0631\u0627\u0633\u06CC\u0648\u0646 \u0631\u0648\u0633\u06CC\u0647","common":"\u0631\u0648\u0633\u06CC\u0647"},"pol":{"official":"Federacja Rosyjska","common":"Rosja"},"por":{"official":"Federa\xe7\xe3o Russa","common":"R\xfassia"},"rus":{"official":"\u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u0430\u044F \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u044F","common":"\u0420\u043E\u0441\u0441\u0438\u044F"},"slk":{"official":"Rusk\xe1 feder\xe1cia","common":"Rusko"},"spa":{"official":"Federaci\xf3n de Rusia","common":"Rusia"},"swe":{"official":"Ryska federationen","common":"Ryssland"},"urd":{"official":"\u0631\u0648\u0633\u06CC \u0648\u0641\u0627\u0642","common":"\u0631\u0648\u0633"},"zho":{"official":"\u4FC4\u7F57\u65AF\u8054\u90A6","common":"\u4FC4\u7F57\u65AF"}},"latlng":[60,100],"landlocked":false,"borders":["AZE","BLR","CHN","EST","FIN","GEO","KAZ","PRK","LVA","LTU","MNG","NOR","POL","UKR"],"area":17098242,"flag":"\uD83C\uDDF7\uD83C\uDDFA","demonyms":{"eng":{"f":"Russian","m":"Russian"},"fra":{"f":"Russe","m":"Russe"}}},{"name":{"common":"Rwanda","official":"Republic of Rwanda","native":{"eng":{"official":"Republic of Rwanda","common":"Rwanda"},"fra":{"official":"R\xe9publique rwandaise","common":"Rwanda"},"kin":{"official":"Repubulika y\'u Rwanda","common":"Rwanda"}}},"tld":[".rw"],"cca2":"RW","ccn3":"646","cca3":"RWA","cioc":"RWA","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"RWF":{"name":"Rwandan franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["50"]},"capital":["Kigali"],"altSpellings":["RW","Republic of Rwanda","Repubulika y\'u Rwanda","R\xe9publique du Rwanda"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English","fra":"French","kin":"Kinyarwanda"},"translations":{"ces":{"official":"Rwandsk\xe1 republika","common":"Rwanda"},"deu":{"official":"Republik Ruanda","common":"Ruanda"},"est":{"official":"Rwanda Vabariik","common":"Rwanda"},"fin":{"official":"Ruandan tasavalta","common":"Ruanda"},"fra":{"official":"R\xe9publique rwandaise","common":"Rwanda"},"hrv":{"official":"Republika Ruandi","common":"Ruanda"},"hun":{"official":"Ruandai K\xf6zt\xe1rsas\xe1g","common":"Ruanda"},"ita":{"official":"Repubblica del Ruanda","common":"Ruanda"},"jpn":{"official":"\u30EB\u30EF\u30F3\u30C0\u5171\u548C\u56FD","common":"\u30EB\u30EF\u30F3\u30C0"},"kor":{"official":"\uB974\uC644\uB2E4 \uACF5\uD654\uAD6D","common":"\uB974\uC644\uB2E4"},"nld":{"official":"Republiek Rwanda","common":"Rwanda"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0631\u0648\u0627\u0646\u062F\u0627","common":"\u0631\u0648\u0627\u0646\u062F\u0627"},"pol":{"official":"Republika Rwandy","common":"Rwanda"},"por":{"official":"Rep\xfablica do Ruanda","common":"Ruanda"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0420\u0443\u0430\u043D\u0434\u0430","common":"\u0420\u0443\u0430\u043D\u0434\u0430"},"slk":{"official":"Rwandsk\xe1 republika","common":"Rwanda"},"spa":{"official":"Rep\xfablica de Rwanda","common":"Ruanda"},"swe":{"official":"Republiken Rwanda","common":"Rwanda"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0631\u0648\u0627\u0646\u0688\u0627","common":"\u0631\u0648\u0627\u0646\u0688\u0627"},"zho":{"official":"\u5362\u65FA\u8FBE\u5171\u548C\u56FD","common":"\u5362\u65FA\u8FBE"}},"latlng":[-2,30],"landlocked":true,"borders":["BDI","COD","TZA","UGA"],"area":26338,"flag":"\uD83C\uDDF7\uD83C\uDDFC","demonyms":{"eng":{"f":"Rwandan","m":"Rwandan"},"fra":{"f":"Rwandaise","m":"Rwandais"}}},{"name":{"common":"Saudi Arabia","official":"Kingdom of Saudi Arabia","native":{"ara":{"official":"\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629","common":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629"}}},"tld":[".sa",".\u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629"],"cca2":"SA","ccn3":"682","cca3":"SAU","cioc":"KSA","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"SAR":{"name":"Saudi riyal","symbol":"\u0631.\u0633"}},"idd":{"root":"+9","suffixes":["66"]},"capital":["Riyadh"],"altSpellings":["Saudi","SA","Kingdom of Saudi Arabia","Al-Mamlakah al-\u2018Arabiyyah as-Su\u2018\u016Bdiyyah"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Sa\xfadskoarabsk\xe9 kr\xe1lovstv\xed","common":"Sa\xfadsk\xe1 Ar\xe1bie"},"deu":{"official":"K\xf6nigreich Saudi-Arabien","common":"Saudi-Arabien"},"est":{"official":"Saudi Araabia Kuningriik","common":"Saudi Araabia"},"fin":{"official":"Saudi-Arabian kuningaskunta","common":"Saudi-Arabia"},"fra":{"official":"Royaume d\'Arabie Saoudite","common":"Arabie Saoudite"},"hrv":{"official":"Kraljevina Saudijska Arabija","common":"Saudijska Arabija"},"hun":{"official":"Sza\xfad-Ar\xe1bia","common":"Sza\xfad-Ar\xe1bia"},"ita":{"official":"Arabia Saudita","common":"Arabia Saudita"},"jpn":{"official":"\u30B5\u30A6\u30B8\u30A2\u30E9\u30D3\u30A2\u738B\u56FD","common":"\u30B5\u30A6\u30B8\u30A2\u30E9\u30D3\u30A2"},"kor":{"official":"\uC0AC\uC6B0\uB514\uC544\uB77C\uBE44\uC544 \uC655\uAD6D","common":"\uC0AC\uC6B0\uB514\uC544\uB77C\uBE44\uC544"},"nld":{"official":"Koninkrijk van Saoedi-Arabi\xeb","common":"Saoedi-Arabi\xeb"},"per":{"official":"\u067E\u0627\u062F\u0634\u0627\u0647\u06CC \u0639\u0631\u0628\u06CC \u0633\u064E\u0639\u0648\u062F\u06CC","common":"\u0639\u0631\u0628\u0633\u062A\u0627\u0646 \u0633\u0639\u0648\u062F\u06CC"},"pol":{"official":"Kr\xf3lestwo Arabii Saudyjskiej","common":"Arabia Saudyjska"},"por":{"official":"Reino da Ar\xe1bia Saudita","common":"Ar\xe1bia Saudita"},"rus":{"official":"\u041A\u043E\u0440\u043E\u043B\u0435\u0432\u0441\u0442\u0432\u043E \u0421\u0430\u0443\u0434\u043E\u0432\u0441\u043A\u0430\u044F \u0410\u0440\u0430\u0432\u0438\u044F","common":"\u0421\u0430\u0443\u0434\u043E\u0432\u0441\u043A\u0430\u044F \u0410\u0440\u0430\u0432\u0438\u044F"},"slk":{"official":"Saudskoarabsk\xe9 kr\xe1\u013Eovstvo","common":"Saudsk\xe1 Ar\xe1bia"},"spa":{"official":"Reino de Arabia Saudita","common":"Arabia Saud\xed"},"swe":{"official":"Kungad\xf6met Saudiarabien","common":"Saudiarabien"},"urd":{"official":"\u0645\u0645\u0644\u06A9\u062A\u0650 \u0633\u0639\u0648\u062F\u06CC \u0639\u0631\u0628","common":"\u0633\u0639\u0648\u062F\u06CC \u0639\u0631\u0628"},"zho":{"official":"\u6C99\u7279\u963F\u62C9\u4F2F\u738B\u56FD","common":"\u6C99\u7279\u963F\u62C9\u4F2F"}},"latlng":[25,45],"landlocked":false,"borders":["IRQ","JOR","KWT","OMN","QAT","ARE","YEM"],"area":2149690,"flag":"\uD83C\uDDF8\uD83C\uDDE6","demonyms":{"eng":{"f":"Saudi Arabian","m":"Saudi Arabian"},"fra":{"f":"Saoudienne","m":"Saoudien"}}},{"name":{"common":"Sudan","official":"Republic of the Sudan","native":{"ara":{"official":"\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0633\u0648\u062F\u0627\u0646","common":"\u0627\u0644\u0633\u0648\u062F\u0627\u0646"},"eng":{"official":"Republic of the Sudan","common":"Sudan"}}},"tld":[".sd"],"cca2":"SD","ccn3":"729","cca3":"SDN","cioc":"SUD","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"SDG":{"name":"Sudanese pound","symbol":"PT"}},"idd":{"root":"+2","suffixes":["49"]},"capital":["Khartoum"],"altSpellings":["SD","Republic of the Sudan","Jumh\u016Br\u012Byat as-S\u016Bd\u0101n"],"region":"Africa","subregion":"Northern Africa","languages":{"ara":"Arabic","eng":"English"},"translations":{"ces":{"official":"S\xfad\xe1nsk\xe1 republika","common":"S\xfad\xe1n"},"deu":{"official":"Republik Sudan","common":"Sudan"},"est":{"official":"Sudaani Vabariik","common":"Sudaan"},"fin":{"official":"Sudanin tasavalta","common":"Sudan"},"fra":{"official":"R\xe9publique du Soudan","common":"Soudan"},"hrv":{"official":"Republika Sudan","common":"Sudan"},"hun":{"official":"Szud\xe1ni K\xf6zt\xe1rsas\xe1g","common":"Szud\xe1n"},"ita":{"official":"Repubblica del Sudan","common":"Sudan"},"jpn":{"official":"\u30B9\u30FC\u30C0\u30F3\u5171\u548C\u56FD","common":"\u30B9\u30FC\u30C0\u30F3"},"kor":{"official":"\uC218\uB2E8 \uACF5\uD654\uAD6D","common":"\uC218\uB2E8"},"nld":{"official":"Republiek Soedan","common":"Soedan"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0633\u0648\u062F\u0627\u0646","common":"\u0633\u0648\u062F\u0627\u0646"},"pol":{"official":"Republika Sudanu","common":"Sudan"},"por":{"official":"Rep\xfablica do Sud\xe3o","common":"Sud\xe3o"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u0443\u0434\u0430\u043D","common":"\u0421\u0443\u0434\u0430\u043D"},"slk":{"official":"Sud\xe1nska republika","common":"Sud\xe1n"},"spa":{"official":"Rep\xfablica de Sud\xe1n","common":"Sud\xe1n"},"swe":{"official":"Republiken Sudan","common":"Sudan"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0633\u0648\u062F\u0627\u0646","common":"\u0633\u0648\u062F\u0627\u0646"},"zho":{"official":"\u82CF\u4E39\u5171\u548C\u56FD","common":"\u82CF\u4E39"}},"latlng":[15,30],"landlocked":false,"borders":["CAF","TCD","EGY","ERI","ETH","LBY","SSD"],"area":1886068,"flag":"\uD83C\uDDF8\uD83C\uDDE9","demonyms":{"eng":{"f":"Sudanese","m":"Sudanese"},"fra":{"f":"Soudanaise","m":"Soudanais"}}},{"name":{"common":"Senegal","official":"Republic of Senegal","native":{"fra":{"official":"R\xe9publique du S\xe9n\xe9gal","common":"S\xe9n\xe9gal"}}},"tld":[".sn"],"cca2":"SN","ccn3":"686","cca3":"SEN","cioc":"SEN","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"XOF":{"name":"West African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["21"]},"capital":["Dakar"],"altSpellings":["SN","Republic of Senegal","R\xe9publique du S\xe9n\xe9gal"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"ces":{"official":"Senegalsk\xe1 republika","common":"Senegal"},"deu":{"official":"Republik Senegal","common":"Senegal"},"est":{"official":"Senegali Vabariik","common":"Senegal"},"fin":{"official":"Senegalin tasavalta","common":"Senegal"},"fra":{"official":"R\xe9publique du S\xe9n\xe9gal","common":"S\xe9n\xe9gal"},"hrv":{"official":"Republika Senegal","common":"Senegal"},"hun":{"official":"Szeneg\xe1li K\xf6zt\xe1rsas\xe1g","common":"Szeneg\xe1l"},"ita":{"official":"Repubblica del Senegal","common":"Senegal"},"jpn":{"official":"\u30BB\u30CD\u30AC\u30EB\u5171\u548C\u56FD","common":"\u30BB\u30CD\u30AC\u30EB"},"kor":{"official":"\uC138\uB124\uAC08 \uACF5\uD654\uAD6D","common":"\uC138\uB124\uAC08"},"nld":{"official":"Republiek Senegal","common":"Senegal"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0633\u0646\u06AF\u0627\u0644","common":"\u0633\u0646\u06AF\u0627\u0644"},"pol":{"official":"Senegal","common":"Senegal"},"por":{"official":"Rep\xfablica do Senegal","common":"Senegal"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u0435\u043D\u0435\u0433\u0430\u043B","common":"\u0421\u0435\u043D\u0435\u0433\u0430\u043B"},"slk":{"official":"Senegalsk\xe1 republika","common":"Senegal"},"spa":{"official":"Rep\xfablica de Senegal","common":"Senegal"},"swe":{"official":"Republiken Senegal","common":"Senegal"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0633\u06CC\u0646\u06CC\u06AF\u0627\u0644","common":"\u0633\u06CC\u0646\u06CC\u06AF\u0627\u0644"},"zho":{"official":"\u585E\u5185\u52A0\u5C14\u5171\u548C\u56FD","common":"\u585E\u5185\u52A0\u5C14"}},"latlng":[14,-14],"landlocked":false,"borders":["GMB","GIN","GNB","MLI","MRT"],"area":196722,"flag":"\uD83C\uDDF8\uD83C\uDDF3","demonyms":{"eng":{"f":"Senegalese","m":"Senegalese"},"fra":{"f":"S\xe9n\xe9galaise","m":"S\xe9n\xe9galais"}}},{"name":{"common":"Singapore","official":"Republic of Singapore","native":{"zho":{"official":"\u65B0\u52A0\u5761\u5171\u548C\u56FD","common":"\u65B0\u52A0\u5761"},"eng":{"official":"Republic of Singapore","common":"Singapore"},"msa":{"official":"Republik Singapura","common":"Singapura"},"tam":{"official":"\u0B9A\u0BBF\u0B99\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0BC2\u0BB0\u0BCD \u0B95\u0BC1\u0B9F\u0BBF\u0BAF\u0BB0\u0B9A\u0BC1","common":"\u0B9A\u0BBF\u0B99\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0BC2\u0BB0\u0BCD"}}},"tld":[".sg",".\u65B0\u52A0\u5761",".\u0B9A\u0BBF\u0B99\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0BC2\u0BB0\u0BCD"],"cca2":"SG","ccn3":"702","cca3":"SGP","cioc":"SGP","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"SGD":{"name":"Singapore dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["5"]},"capital":["Singapore"],"altSpellings":["SG","Singapura","Republik Singapura","\u65B0\u52A0\u5761\u5171\u548C\u56FD"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"zho":"Chinese","eng":"English","msa":"Malay","tam":"Tamil"},"translations":{"ces":{"official":"Singapursk\xe1 republika","common":"Singapur"},"deu":{"official":"Republik Singapur","common":"Singapur"},"est":{"official":"Singapuri Vabariik","common":"Singapur"},"fin":{"official":"Singaporen tasavalta","common":"Singapore"},"fra":{"official":"R\xe9publique de Singapour","common":"Singapour"},"hrv":{"official":"Republika Singapur","common":"Singapur"},"hun":{"official":"Szingap\xfari K\xf6zt\xe1rsas\xe1g","common":"Szingap\xfar"},"ita":{"official":"Repubblica di Singapore","common":"Singapore"},"jpn":{"official":"\u30B7\u30F3\u30AC\u30DD\u30FC\u30EB\u5171\u548C\u56FD","common":"\u30B7\u30F3\u30AC\u30DD\u30FC\u30EB"},"kor":{"official":"\uC2F1\uAC00\uD3EC\uB974 \uACF5\uD654\uAD6D","common":"\uC2F1\uAC00\uD3EC\uB974"},"nld":{"official":"Republiek Singapore","common":"Singapore"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0633\u0646\u06AF\u0627\u067E\u0648\u0631","common":"\u0633\u0646\u06AF\u0627\u067E\u0648\u0631"},"pol":{"official":"Republika Singapuru","common":"Singapur"},"por":{"official":"Rep\xfablica de Singapura","common":"Singapura"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u0438\u043D\u0433\u0430\u043F\u0443\u0440","common":"\u0421\u0438\u043D\u0433\u0430\u043F\u0443\u0440"},"slk":{"official":"Singapursk\xe1 republika","common":"Singapur"},"spa":{"official":"Rep\xfablica de Singapur","common":"Singapur"},"swe":{"official":"Republiken Singapore","common":"Singapore"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0633\u0646\u06AF\u0627\u067E\u0648\u0631","common":"\u0633\u0646\u06AF\u0627\u067E\u0648\u0631"}},"latlng":[1.36666666,103.8],"landlocked":false,"borders":[],"area":710,"flag":"\uD83C\uDDF8\uD83C\uDDEC","demonyms":{"eng":{"f":"Singaporean","m":"Singaporean"},"fra":{"f":"Singapourienne","m":"Singapourien"}}},{"name":{"common":"South Georgia","official":"South Georgia and the South Sandwich Islands","native":{"eng":{"official":"South Georgia and the South Sandwich Islands","common":"South Georgia"}}},"tld":[".gs"],"cca2":"GS","ccn3":"239","cca3":"SGS","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"SHP":{"name":"Saint Helena pound","symbol":"\xa3"}},"idd":{"root":"+5","suffixes":["00"]},"capital":["King Edward Point"],"altSpellings":["GS","South Georgia and the South Sandwich Islands"],"region":"Antarctic","subregion":"","languages":{"eng":"English"},"translations":{"ces":{"official":"Ji\u017En\xed Georgie a Ji\u017En\xed Sandwichovy ostrovy","common":"Ji\u017En\xed Georgie a Ji\u017En\xed Sandwichovy ostrovy"},"deu":{"official":"S\xfcdgeorgien und die S\xfcdlichen Sandwichinseln","common":"S\xfcdgeorgien und die S\xfcdlichen Sandwichinseln"},"est":{"official":"L\xf5una-Georgia ja L\xf5una-Sandwichi saared","common":"L\xf5una-Georgia ja L\xf5una-Sandwichi saared"},"fin":{"official":"Etel\xe4-Georgia ja Etel\xe4iset Sandwichsaaret","common":"Etel\xe4-Georgia ja Etel\xe4iset Sandwichsaaret"},"fra":{"official":"G\xe9orgie du Sud et les \xeeles Sandwich du Sud","common":"G\xe9orgie du Sud-et-les \xceles Sandwich du Sud"},"hrv":{"official":"Ju\u017Ena D\u017Eord\u017Eija i Otoci Ju\u017Eni Sendvi\u010D","common":"Ju\u017Ena Georgija i oto\u010Dje Ju\u017Eni Sandwich"},"hun":{"official":"D\xe9li-Georgia \xe9s D\xe9li-Sandwich-szigetek","common":"D\xe9li-Georgia \xe9s D\xe9li-Sandwich-szigetek"},"ita":{"official":"Georgia del Sud e isole Sandwich del Sud","common":"Georgia del Sud e Isole Sandwich Meridionali"},"jpn":{"official":"\u30B5\u30A6\u30B9\u30B8\u30E7\u30FC\u30B8\u30A2\xb7\u30B5\u30A6\u30B9\u30B5\u30F3\u30C9\u30A6\u30A3\u30C3\u30C1\u8AF8\u5CF6","common":"\u30B5\u30A6\u30B9\u30B8\u30E7\u30FC\u30B8\u30A2\u30FB\u30B5\u30A6\u30B9\u30B5\u30F3\u30C9\u30A6\u30A3\u30C3\u30C1\u8AF8\u5CF6"},"kor":{"official":"\uC870\uC9C0\uC544","common":"\uC870\uC9C0\uC544"},"nld":{"official":"Zuid-Georgi\xeb en de Zuidelijke Sandwich-eilanden","common":"Zuid-Georgia en Zuidelijke Sandwicheilanden"},"per":{"official":"\u062C\u0632\u0627\u06CC\u0631 \u062C\u0648\u0631\u062C\u06CC\u0627\u06CC \u062C\u0646\u0648\u0628\u06CC \u0648 \u0633\u0627\u0646\u062F\u0648\u06CC\u0686 \u062C\u0646\u0648\u0628\u06CC","common":"\u062C\u0632\u0627\u06CC\u0631 \u062C\u0648\u0631\u062C\u06CC\u0627\u06CC \u062C\u0646\u0648\u0628\u06CC \u0648 \u0633\u0627\u0646\u062F\u0648\u06CC\u0686 \u062C\u0646\u0648\u0628\u06CC"},"pol":{"official":"Georgia Po\u0142udniowa i Sandwich Po\u0142udniowy","common":"Georgia Po\u0142udniowa i Sandwich Po\u0142udniowy"},"por":{"official":"Ge\xf3rgia do Sul e Sandwich do Sul","common":"Ilhas Ge\xf3rgia do Sul e Sandwich do Sul"},"rus":{"official":"\u042E\u0436\u043D\u0430\u044F \u0413\u0435\u043E\u0440\u0433\u0438\u044F \u0438 \u042E\u0436\u043D\u044B\u0435 \u0421\u0430\u043D\u0434\u0432\u0438\u0447\u0435\u0432\u044B \u043E\u0441\u0442\u0440\u043E\u0432\u0430","common":"\u042E\u0436\u043D\u0430\u044F \u0413\u0435\u043E\u0440\u0433\u0438\u044F \u0438 \u042E\u0436\u043D\u044B\u0435 \u0421\u0430\u043D\u0434\u0432\u0438\u0447\u0435\u0432\u044B \u043E\u0441\u0442\u0440\u043E\u0432\u0430"},"slk":{"official":"Ju\u017En\xe1 Georgia a Ju\u017En\xe9 Sandwichove ostrovy","common":"Ju\u017En\xe1 Georgia a Ju\u017En\xe9 Sandwichove ostrovy"},"spa":{"official":"Georgia del Sur y las Islas Sandwich del Sur","common":"Islas Georgias del Sur y Sandwich del Sur"},"swe":{"official":"Sydgeorgien","common":"Sydgeorgien"},"urd":{"official":"\u062C\u0646\u0648\u0628\u06CC \u062C\u0627\u0631\u062C\u06CC\u0627 \u0648 \u062C\u0632\u0627\u0626\u0631 \u062C\u0646\u0648\u0628\u06CC \u0633\u06CC\u0646\u0688\u0648\u0686","common":"\u062C\u0646\u0648\u0628\u06CC \u062C\u0627\u0631\u062C\u06CC\u0627"},"zho":{"official":"\u5357\u4E54\u6CBB\u4E9A\u5C9B\u548C\u5357\u6851\u5A01\u5947\u7FA4\u5C9B","common":"\u5357\u4E54\u6CBB\u4E9A"}},"latlng":[-54.5,-37],"landlocked":false,"borders":[],"area":3903,"flag":"\uD83C\uDDEC\uD83C\uDDF8","demonyms":{"eng":{"f":"South Georgian South Sandwich Islander","m":"South Georgian South Sandwich Islander"},"fra":{"f":"","m":""}}},{"name":{"common":"Svalbard and Jan Mayen","official":"Svalbard og Jan Mayen","native":{"nor":{"official":"Svalbard og Jan Mayen","common":"Svalbard og Jan Mayen"}}},"tld":[".sj"],"cca2":"SJ","ccn3":"744","cca3":"SJM","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"NOK":{"name":"krone","symbol":"kr"}},"idd":{"root":"+4","suffixes":["779"]},"capital":["Longyearbyen"],"altSpellings":["SJ","Svalbard and Jan Mayen Islands"],"region":"Europe","subregion":"Northern Europe","languages":{"nor":"Norwegian"},"translations":{"ces":{"official":"\u0160picberky a Jan Mayen","common":"\u0160picberky a Jan Mayen"},"deu":{"official":"Spitzbergen und Jan Mayen","common":"Spitzbergen und Jan Mayen"},"est":{"official":"Svalbard","common":"Svalbard"},"fin":{"official":"Huippuvuoret","common":"Huippuvuoret"},"fra":{"official":"Jan Mayen Svalbard","common":"Svalbard et Jan Mayen"},"hrv":{"official":"Svalbard og Jan Mayen","common":"Svalbard i Jan Mayen"},"hun":{"official":"Svalbard \xe9s Jan Mayen","common":"Svalbard \xe9s Jan Mayen"},"ita":{"official":"Svalbard og Jan Mayen","common":"Svalbard e Jan Mayen"},"jpn":{"official":"\u30B9\u30D0\u30FC\u30EB\u30D0\u30EB\u8AF8\u5CF6OG\u30E4\u30F3\u30DE\u30A4\u30A8\u30F3","common":"\u30B9\u30F4\u30A1\u30FC\u30EB\u30D0\u30EB\u8AF8\u5CF6\u304A\u3088\u3073\u30E4\u30F3\u30DE\u30A4\u30A8\u30F3\u5CF6"},"kor":{"official":"\uC2A4\uBC1C\uBC14\uB974 \uC580\uB9C8\uC60C \uC81C\uB3C4","common":"\uC2A4\uBC1C\uBC14\uB974 \uC580\uB9C8\uC60C \uC81C\uB3C4"},"nld":{"official":"Svalbard og Jan Mayen","common":"Svalbard en Jan Mayen"},"per":{"official":"\u0633\u0648\u0627\u0644\u0628\u0627\u0631\u062F \u0648 \u06CC\u0627\u0646 \u0645\u0627\u06CC\u0646","common":"\u0633\u0648\u0627\u0644\u0628\u0627\u0631\u062F \u0648 \u06CC\u0627\u0646 \u0645\u0627\u06CC\u0646"},"pol":{"official":"Svalbard i Jan Mayen","common":"Svalbard i Jan Mayen"},"por":{"official":"Svalbard og Jan Mayen","common":"Ilhas Svalbard e Jan Mayen"},"rus":{"official":"\u0421\u0432\u0430\u043B\u044C\u0431\u0430\u0440\u0434\u0430 \u043E\u0433 \u042F\u043D-\u041C\u0430\u0439\u0435\u043D","common":"\u0428\u043F\u0438\u0446\u0431\u0435\u0440\u0433\u0435\u043D \u0438 \u042F\u043D-\u041C\u0430\u0439\u0435\u043D"},"slk":{"official":"Svalbard a Jan Mayen","common":"Svalbard a Jan Mayen"},"spa":{"official":"Svalbard og Jan Mayen","common":"Islas Svalbard y Jan Mayen"},"swe":{"official":"Svalbard och Jan Mayen","common":"Svalbard och Jan Mayen"},"urd":{"official":"\u0633\u0648\u0627\u0644\u0628\u0627\u0631\u0688 \u0627\u0648\u0631 \u062C\u0627\u0646 \u0645\u06CC\u0626\u0646","common":"\u0633\u0648\u0627\u0644\u0628\u0627\u0631\u0688 \u0627\u0648\u0631 \u062C\u0627\u0646 \u0645\u06CC\u0626\u0646"},"zho":{"official":"\u65AF\u74E6\u5C14\u5DF4\u7279","common":"\u65AF\u74E6\u5C14\u5DF4\u7279"}},"latlng":[78,20],"landlocked":false,"borders":[],"area":-1,"flag":"\uD83C\uDDF8\uD83C\uDDEF","demonyms":{"eng":{"f":"Norwegian","m":"Norwegian"},"fra":{"f":"","m":""}}},{"name":{"common":"Solomon Islands","official":"Solomon Islands","native":{"eng":{"official":"Solomon Islands","common":"Solomon Islands"}}},"tld":[".sb"],"cca2":"SB","ccn3":"090","cca3":"SLB","cioc":"SOL","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"SBD":{"name":"Solomon Islands dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["77"]},"capital":["Honiara"],"altSpellings":["SB"],"region":"Oceania","subregion":"Melanesia","languages":{"eng":"English"},"translations":{"ces":{"official":"\u0160alamounovy ostrovy","common":"\u0160alamounovy ostrovy"},"deu":{"official":"Salomonen","common":"Salomonen"},"est":{"official":"Saalomoni Saared","common":"Saalomoni Saared"},"fin":{"official":"Salomonsaaret","common":"Salomonsaaret"},"fra":{"official":"\xceles Salomon","common":"\xceles Salomon"},"hrv":{"official":"Solomonski Otoci","common":"Solomonski Otoci"},"hun":{"official":"Salamon-szigetek","common":"Salamon-szigetek"},"ita":{"official":"Isole Salomone","common":"Isole Salomone"},"jpn":{"official":"\u30BD\u30ED\u30E2\u30F3\u8AF8\u5CF6","common":"\u30BD\u30ED\u30E2\u30F3\u8AF8\u5CF6"},"kor":{"official":"\uC194\uB85C\uBAAC \uC81C\uB3C4","common":"\uC194\uB85C\uBAAC \uC81C\uB3C4"},"nld":{"official":"Solomon eilanden","common":"Salomonseilanden"},"per":{"official":"\u062C\u0632\u0627\u06CC\u0631 \u0633\u0644\u06CC\u0645\u0627\u0646","common":"\u062C\u0632\u0627\u06CC\u0631 \u0633\u0644\u06CC\u0645\u0627\u0646"},"pol":{"official":"Wyspy Salomona","common":"Wyspy Salomona"},"por":{"official":"Ilhas Salom\xe3o","common":"Ilhas Salom\xe3o"},"rus":{"official":"\u0421\u043E\u043B\u043E\u043C\u043E\u043D\u043E\u0432\u044B \u043E\u0441\u0442\u0440\u043E\u0432\u0430","common":"\u0421\u043E\u043B\u043E\u043C\u043E\u043D\u043E\u0432\u044B \u041E\u0441\u0442\u0440\u043E\u0432\u0430"},"slk":{"official":"Salomonove ostrovy","common":"Salomonove ostrovy"},"spa":{"official":"islas Salom\xf3n","common":"Islas Salom\xf3n"},"swe":{"official":"Salomon\xf6arna","common":"Salomon\xf6arna"},"urd":{"official":"\u062C\u0632\u0627\u0626\u0631 \u0633\u0644\u06CC\u0645\u0627\u0646","common":"\u062C\u0632\u0627\u0626\u0631 \u0633\u0644\u06CC\u0645\u0627\u0646"},"zho":{"official":"\u6240\u7F57\u95E8\u7FA4\u5C9B","common":"\u6240\u7F57\u95E8\u7FA4\u5C9B"}},"latlng":[-8,159],"landlocked":false,"borders":[],"area":28896,"flag":"\uD83C\uDDF8\uD83C\uDDE7","demonyms":{"eng":{"f":"Solomon Islander","m":"Solomon Islander"},"fra":{"f":"Salomonienne","m":"Salomonien"}}},{"name":{"common":"Sierra Leone","official":"Republic of Sierra Leone","native":{"eng":{"official":"Republic of Sierra Leone","common":"Sierra Leone"}}},"tld":[".sl"],"cca2":"SL","ccn3":"694","cca3":"SLE","cioc":"SLE","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"SLL":{"name":"Sierra Leonean leone","symbol":"Le"}},"idd":{"root":"+2","suffixes":["32"]},"capital":["Freetown"],"altSpellings":["SL","Republic of Sierra Leone"],"region":"Africa","subregion":"Western Africa","languages":{"eng":"English"},"translations":{"ces":{"official":"Republika Sierra Leone","common":"Sierra Leone"},"deu":{"official":"Republik Sierra Leone","common":"Sierra Leone"},"est":{"official":"Sierra Leone Vabariik","common":"Sierra Leone"},"fin":{"official":"Sierra Leonen tasavalta","common":"Sierra Leone"},"fra":{"official":"R\xe9publique de Sierra Leone","common":"Sierra Leone"},"hrv":{"official":"Republika Sijera Leone","common":"Sijera Leone"},"hun":{"official":"Sierra Leone K\xf6zt\xe1rsas\xe1g","common":"Sierra Leone"},"ita":{"official":"Repubblica della Sierra Leone","common":"Sierra Leone"},"jpn":{"official":"\u30B7\u30A8\u30E9\u30EC\u30AA\u30CD\u5171\u548C\u56FD","common":"\u30B7\u30A8\u30E9\u30EC\u30AA\u30CD"},"kor":{"official":"\uC2DC\uC5D0\uB77C\uB9AC\uC628 \uACF5\uD654\uAD6D","common":"\uC2DC\uC5D0\uB77C\uB9AC\uC628"},"nld":{"official":"Republiek Sierra Leone","common":"Sierra Leone"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0633\u06CC\u0631\u0627\u0644\u0626\u0648\u0646","common":"\u0633\u06CC\u0631\u0627\u0644\u0626\u0648\u0646"},"pol":{"official":"Sierra Leone","common":"Sierra Leone"},"por":{"official":"Rep\xfablica da Serra Leoa","common":"Serra Leoa"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u044C\u0435\u0440\u0440\u0430-\u041B\u0435\u043E\u043D\u0435","common":"\u0421\u044C\u0435\u0440\u0440\u0430-\u041B\u0435\u043E\u043D\u0435"},"slk":{"official":"Sierraleonsk\xe1 republika","common":"Sierra Leone"},"spa":{"official":"Rep\xfablica de Sierra Leona","common":"Sierra Leone"},"swe":{"official":"Republiken Sierra Leone","common":"Sierra Leone"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0633\u06CC\u0631\u0627\u0644\u06CC\u0648\u0646","common":"\u0633\u06CC\u0631\u0627\u0644\u06CC\u0648\u0646"},"zho":{"official":"\u585E\u62C9\u5229\u6602\u5171\u548C\u56FD","common":"\u585E\u62C9\u5229\u6602"}},"latlng":[8.5,-11.5],"landlocked":false,"borders":["GIN","LBR"],"area":71740,"flag":"\uD83C\uDDF8\uD83C\uDDF1","demonyms":{"eng":{"f":"Sierra Leonean","m":"Sierra Leonean"},"fra":{"f":"Sierra-leonaise","m":"Sierra-leonais"}}},{"name":{"common":"El Salvador","official":"Republic of El Salvador","native":{"spa":{"official":"Rep\xfablica de El Salvador","common":"El Salvador"}}},"tld":[".sv"],"cca2":"SV","ccn3":"222","cca3":"SLV","cioc":"ESA","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+5","suffixes":["03"]},"capital":["San Salvador"],"altSpellings":["SV","Republic of El Salvador","Rep\xfablica de El Salvador"],"region":"Americas","subregion":"Central America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Salvadorsk\xe1 republika","common":"Salvador"},"cym":{"official":"Gweriniaeth El Salfador","common":"El Salfador"},"deu":{"official":"Republik El Salvador","common":"El Salvador"},"est":{"official":"El Salvadori Vabariik","common":"El Salvador"},"fin":{"official":"El Salvadorin tasavalta","common":"El Salvador"},"fra":{"official":"R\xe9publique du Salvador","common":"Salvador"},"hrv":{"official":"Republika El Salvador","common":"Salvador"},"hun":{"official":"Salvadori K\xf6zt\xe1rsas\xe1g","common":"Salvador"},"ita":{"official":"Repubblica di El Salvador","common":"El Salvador"},"jpn":{"official":"\u30A8\u30EB\u30B5\u30EB\u30D0\u30C9\u30EB\u5171\u548C\u56FD","common":"\u30A8\u30EB\u30B5\u30EB\u30D0\u30C9\u30EB"},"kor":{"official":"\uC5D8\uC0B4\uBC14\uB3C4\uB974 \uACF5\uD654\uAD6D","common":"\uC5D8\uC0B4\uBC14\uB3C4\uB974"},"nld":{"official":"Republiek El Salvador","common":"El Salvador"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0644\u0633\u0627\u0644\u0648\u0627\u062F\u0648\u0631","common":"\u0627\u0644\u0633\u0627\u0644\u0648\u0627\u062F\u0648\u0631"},"pol":{"official":"Republika Salwadoru","common":"Salwador"},"por":{"official":"Rep\xfablica de El Salvador","common":"El Salvador"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u042D\u043B\u044C-\u0421\u0430\u043B\u044C\u0432\u0430\u0434\u043E\u0440","common":"\u0421\u0430\u043B\u044C\u0432\u0430\u0434\u043E\u0440"},"slk":{"official":"Salv\xe1dorsk\xe1 republika","common":"Salv\xe1dor"},"spa":{"official":"Rep\xfablica de El Salvador","common":"El Salvador"},"swe":{"official":"Republiken El Salvador","common":"El Salvador"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0627\u06CC\u0644 \u0633\u06CC\u0644\u0648\u0627\u0688\u0648\u0631","common":"\u0627\u06CC\u0644 \u0633\u06CC\u0644\u0648\u0627\u0688\u0648\u0631"},"zho":{"official":"\u8428\u5C14\u74E6\u591A\u5171\u548C\u56FD","common":"\u8428\u5C14\u74E6\u591A"}},"latlng":[13.83333333,-88.91666666],"landlocked":false,"borders":["GTM","HND"],"area":21041,"flag":"\uD83C\uDDF8\uD83C\uDDFB","demonyms":{"eng":{"f":"Salvadoran","m":"Salvadoran"},"fra":{"f":"Salvadorienne","m":"Salvadorien"}}},{"name":{"common":"San Marino","official":"Most Serene Republic of San Marino","native":{"ita":{"official":"Serenissima Repubblica di San Marino","common":"San Marino"}}},"tld":[".sm"],"cca2":"SM","ccn3":"674","cca3":"SMR","cioc":"SMR","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["78"]},"capital":["City of San Marino"],"altSpellings":["SM","Republic of San Marino","Repubblica di San Marino"],"region":"Europe","subregion":"Southern Europe","languages":{"ita":"Italian"},"translations":{"ces":{"official":"Republika San Marino","common":"San Marino"},"deu":{"official":"Republik San Marino","common":"San Marino"},"est":{"official":"San Marino Vabariik","common":"San Marino"},"fin":{"official":"San Marinon seesteinen tasavalta","common":"San Marino"},"fra":{"official":"R\xe9publique de Saint-Marin","common":"Saint-Marin"},"hrv":{"official":"Ve\u0107ina Serene Republika San Marino","common":"San Marino"},"hun":{"official":"San Marino K\xf6zt\xe1rsas\xe1g","common":"San Marino"},"ita":{"official":"Serenissima Repubblica di San Marino","common":"San Marino"},"jpn":{"official":"\u30B5\u30F3\u30DE\u30EA\u30CE\u306E\u307B\u3068\u3093\u3069\u30BB\u30EA\u30FC\u30CC\u5171\u548C\u56FD","common":"\u30B5\u30F3\u30DE\u30EA\u30CE"},"kor":{"official":"\uC0B0\uB9C8\uB9AC\uB178 \uACF5\uD654\uAD6D","common":"\uC0B0\uB9C8\uB9AC\uB178"},"nld":{"official":"Meest Serene Republiek San Marino","common":"San Marino"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0633\u0627\u0646 \u0645\u0627\u0631\u06CC\u0646\u0648","common":"\u0633\u0627\u0646 \u0645\u0627\u0631\u06CC\u0646\u0648"},"pol":{"official":"Republika San Marino","common":"San Marino"},"por":{"official":"Seren\xedssima Rep\xfablica de San Marino","common":"San Marino"},"rus":{"official":"\u0411\u043E\u043B\u044C\u0448\u0438\u043D\u0441\u0442\u0432\u043E Serene \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u0430\u043D-\u041C\u0430\u0440\u0438\u043D\u043E","common":"\u0421\u0430\u043D-\u041C\u0430\u0440\u0438\u043D\u043E"},"slk":{"official":"Sanmar\xednska republika","common":"San Mar\xedno"},"spa":{"official":"Seren\xedsima Rep\xfablica de San Marino","common":"San Marino"},"swe":{"official":"Republiken San Marino","common":"San Marino"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0633\u0627\u0646 \u0645\u0627\u0631\u06CC\u0646\u0648","common":"\u0633\u0627\u0646 \u0645\u0627\u0631\u06CC\u0646\u0648"},"zho":{"official":"\u5723\u9A6C\u529B\u8BFA\u5171\u548C\u56FD","common":"\u5723\u9A6C\u529B\u8BFA"}},"latlng":[43.76666666,12.41666666],"landlocked":true,"borders":["ITA"],"area":61,"flag":"\uD83C\uDDF8\uD83C\uDDF2","demonyms":{"eng":{"f":"Sammarinese","m":"Sammarinese"},"fra":{"f":"Saint-Marinaise","m":"Saint-Marinais"}}},{"name":{"common":"Somalia","official":"Federal Republic of Somalia","native":{"ara":{"official":"\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0635\u0648\u0645\u0627\u0644\u200E\u200E","common":"\u0627\u0644\u0635\u0648\u0645\u0627\u0644\u200E\u200E"},"som":{"official":"Jamhuuriyadda Federaalka Soomaaliya","common":"Soomaaliya"}}},"tld":[".so"],"cca2":"SO","ccn3":"706","cca3":"SOM","cioc":"SOM","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"SOS":{"name":"Somali shilling","symbol":"Sh"}},"idd":{"root":"+2","suffixes":["52"]},"capital":["Mogadishu"],"altSpellings":["SO","a\u1E63-\u1E62\u016Bm\u0101l","Federal Republic of Somalia","Jamhuuriyadda Federaalka Soomaaliya","Jumh\u016Briyyat a\u1E63-\u1E62\u016Bm\u0101l al-Fider\u0101liyya"],"region":"Africa","subregion":"Eastern Africa","languages":{"ara":"Arabic","som":"Somali"},"translations":{"ces":{"official":"Som\xe1lsk\xe1 demokratick\xe1 republika","common":"Som\xe1lsko"},"deu":{"official":"Bundesrepublik Somalia","common":"Somalia"},"est":{"official":"Somaalia Liitvabariik","common":"Somaalia"},"fin":{"official":"Somalian liittotasavalta","common":"Somalia"},"fra":{"official":"R\xe9publique f\xe9d\xe9rale de Somalie","common":"Somalie"},"hrv":{"official":"Savezna Republika Somaliji","common":"Somalija"},"hun":{"official":"Szom\xe1li Sz\xf6vets\xe9gi K\xf6zt\xe1rsas\xe1g","common":"Szom\xe1lia"},"ita":{"official":"Repubblica federale di Somalia","common":"Somalia"},"jpn":{"official":"\u30BD\u30DE\u30EA\u30A2\u9023\u90A6\u5171\u548C\u56FD","common":"\u30BD\u30DE\u30EA\u30A2"},"kor":{"official":" \uC18C\uB9D0\uB9AC\uC544 \uC5F0\uBC29 \uACF5\uD654\uAD6D","common":"\uC18C\uB9D0\uB9AC\uC544"},"nld":{"official":"Federale Republiek Somali\xeb","common":"Somali\xeb"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0641\u062F\u0631\u0627\u0644 \u0633\u0648\u0645\u0627\u0644\u06CC","common":"\u0633\u0648\u0645\u0627\u0644\u06CC"},"pol":{"official":"Federalna Republika Somalii","common":"Somalia"},"por":{"official":"Rep\xfablica Federal da Som\xe1lia","common":"Som\xe1lia"},"rus":{"official":"\u0424\u0435\u0434\u0435\u0440\u0430\u0442\u0438\u0432\u043D\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u043E\u043C\u0430\u043B\u0438","common":"\u0421\u043E\u043C\u0430\u043B\u0438"},"slk":{"official":"Som\xe1lska federat\xedvna republika","common":"Som\xe1lsko"},"spa":{"official":"Rep\xfablica Federal de Somalia","common":"Somalia"},"swe":{"official":"F\xf6rbundsrepubliken Somalia","common":"Somalia"},"urd":{"official":"\u0648\u0641\u0627\u0642\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0635\u0648\u0645\u0627\u0644\u06CC\u06C1","common":"\u0635\u0648\u0645\u0627\u0644\u06CC\u06C1"},"zho":{"official":"\u7D22\u9A6C\u91CC\u5171\u548C\u56FD","common":"\u7D22\u9A6C\u91CC"}},"latlng":[10,49],"landlocked":false,"borders":["DJI","ETH","KEN"],"area":637657,"flag":"\uD83C\uDDF8\uD83C\uDDF4","demonyms":{"eng":{"f":"Somali","m":"Somali"},"fra":{"f":"Somalienne","m":"Somalien"}}},{"name":{"common":"Saint Pierre and Miquelon","official":"Saint Pierre and Miquelon","native":{"fra":{"official":"Collectivit\xe9 territoriale de Saint-Pierre-et-Miquelon","common":"Saint-Pierre-et-Miquelon"}}},"tld":[".pm"],"cca2":"PM","ccn3":"666","cca3":"SPM","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+5","suffixes":["08"]},"capital":["Saint-Pierre"],"altSpellings":["PM","Collectivit\xe9 territoriale de Saint-Pierre-et-Miquelon"],"region":"Americas","subregion":"North America","languages":{"fra":"French"},"translations":{"ces":{"official":"Saint-Pierre a Miquelon","common":"Saint-Pierre a Miquelon"},"deu":{"official":"St. Pierre und Miquelon","common":"St. Pierre und Miquelon"},"est":{"official":"Saint-Pierre\u2019i ja Miqueloni territoriaal\xfchendus","common":"Saint-Pierre ja Miquelon"},"fin":{"official":"Saint-Pierre ja Miquelon","common":"Saint-Pierre ja Miquelon"},"fra":{"official":"Saint-Pierre-et-Miquelon","common":"Saint-Pierre-et-Miquelon"},"hrv":{"official":"Saint Pierre i Miquelon","common":"Sveti Petar i Mikelon"},"hun":{"official":"Saint-Pierre \xe9s Miquelon","common":"Saint-Pierre \xe9s Miquelon"},"ita":{"official":"Saint Pierre e Miquelon","common":"Saint-Pierre e Miquelon"},"jpn":{"official":"\u30B5\u30F3\u30D4\u30A8\u30FC\u30EB\u5CF6\xb7\u30DF\u30AF\u30ED\u30F3\u5CF6","common":"\u30B5\u30F3\u30D4\u30A8\u30FC\u30EB\u5CF6\u30FB\u30DF\u30AF\u30ED\u30F3\u5CF6"},"kor":{"official":"\uC0DD\uD53C\uC5D0\uB974 \uBBF8\uD074\uB871","common":"\uC0DD\uD53C\uC5D0\uB974 \uBBF8\uD074\uB871"},"nld":{"official":"Saint-Pierre en Miquelon","common":"Saint Pierre en Miquelon"},"per":{"official":"\u0633\u0646-\u067E\u06CC\u0631-\u0627-\u0645\u06CC\u06A9\u0644\u0648\u0646","common":"\u0633\u0646-\u067E\u06CC\u0650\u0631 \u0648 \u0645\u06CC\u06A9\u0644\u064F\u0646"},"pol":{"official":"Saint-Pierre i Miquelon","common":"Saint-Pierre i Miquelon"},"por":{"official":"Saint Pierre e Miquelon","common":"Saint-Pierre e Miquelon"},"rus":{"official":"\u0421\u0435\u043D-\u041F\u044C\u0435\u0440 \u0438 \u041C\u0438\u043A\u0435\u043B\u043E\u043D","common":"\u0421\u0435\u043D-\u041F\u044C\u0435\u0440 \u0438 \u041C\u0438\u043A\u0435\u043B\u043E\u043D"},"slk":{"official":"Ostrovy Saint Pierre a Miquelon","common":"Saint Pierre a Miquelon"},"spa":{"official":"San Pedro y Miquel\xf3n","common":"San Pedro y Miquel\xf3n"},"swe":{"official":"Saint-Pierre och Miquelon","common":"Saint-Pierre och Miquelon"},"urd":{"official":"\u0633\u06CC\u0646\u0679 \u067E\u06CC\u0626\u0631 \u0648 \u0645\u06CC\u06A9\u06CC\u0644\u0648\u0646","common":"\u0633\u06CC\u0646\u0679 \u067E\u06CC\u0626\u0631 \u0648 \u0645\u06CC\u06A9\u06CC\u0644\u0648\u0646"},"zho":{"official":"\u5723\u76AE\u57C3\u5C14\u548C\u5BC6\u514B\u9686","common":"\u5723\u76AE\u57C3\u5C14\u548C\u5BC6\u514B\u9686"}},"latlng":[46.83333333,-56.33333333],"landlocked":false,"borders":[],"area":242,"flag":"\uD83C\uDDF5\uD83C\uDDF2","demonyms":{"eng":{"f":"Saint-Pierrais, Miquelonnais","m":"Saint-Pierrais, Miquelonnais"},"fra":{"f":"Saint-Pierraise, Miquelonaise","m":"Saint-Pierrais, Miquelonais"}}},{"name":{"common":"Serbia","official":"Republic of Serbia","native":{"srp":{"official":"\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u0440\u0431\u0438\u0458\u0430","common":"\u0421\u0440\u0431\u0438\u0458\u0430"}}},"tld":[".rs",".\u0441\u0440\u0431"],"cca2":"RS","ccn3":"688","cca3":"SRB","cioc":"SRB","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"RSD":{"name":"Serbian dinar","symbol":"\u0434\u0438\u043D."}},"idd":{"root":"+3","suffixes":["81"]},"capital":["Belgrade"],"altSpellings":["RS","Srbija","Republic of Serbia","\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u0440\u0431\u0438\u0458\u0430","Republika Srbija"],"region":"Europe","subregion":"Southeast Europe","languages":{"srp":"Serbian"},"translations":{"ces":{"official":"Srbsk\xe1 republika","common":"Srbsko"},"deu":{"official":"Republik Serbien","common":"Serbien"},"est":{"official":"Serbia Vabariik","common":"Serbia"},"fin":{"official":"Serbian tasavalta","common":"Serbia"},"fra":{"official":"R\xe9publique de Serbie","common":"Serbie"},"hrv":{"official":"Republika Srbija","common":"Srbija"},"hun":{"official":"Szerb K\xf6zt\xe1rsas\xe1g","common":"Szerbia"},"ita":{"official":"Repubblica di Serbia","common":"Serbia"},"jpn":{"official":"\u30BB\u30EB\u30D3\u30A2\u5171\u548C\u56FD","common":"\u30BB\u30EB\u30D3\u30A2"},"kor":{"official":"\uC138\uB974\uBE44\uC544 \uACF5\uD654\uAD6D","common":"\uC138\uB974\uBE44\uC544"},"nld":{"official":"Republiek Servi\xeb","common":"Servi\xeb"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0635\u0631\u0628\u0633\u062A\u0627\u0646","common":"\u0635\u0631\u0628\u0633\u062A\u0627\u0646"},"pol":{"official":"Republika Serbii","common":"Serbia"},"por":{"official":"Rep\xfablica da S\xe9rvia","common":"S\xe9rvia"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u0435\u0440\u0431\u0438\u044F","common":"\u0421\u0435\u0440\u0431\u0438\u044F"},"slk":{"official":"Srbsk\xe1 republika","common":"Srbsko"},"spa":{"official":"Rep\xfablica de Serbia","common":"Serbia"},"swe":{"official":"Republiken Serbien","common":"Serbien"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0633\u0631\u0628\u06CC\u0627","common":"\u0633\u0631\u0628\u06CC\u0627"},"zho":{"official":"\u585E\u5C14\u7EF4\u4E9A\u5171\u548C\u56FD","common":"\u585E\u5C14\u7EF4\u4E9A"}},"latlng":[44,21],"landlocked":true,"borders":["BIH","BGR","HRV","HUN","UNK","MKD","MNE","ROU"],"area":88361,"flag":"\uD83C\uDDF7\uD83C\uDDF8","demonyms":{"eng":{"f":"Serbian","m":"Serbian"},"fra":{"f":"Serbe","m":"Serbe"}}},{"name":{"common":"South Sudan","official":"Republic of South Sudan","native":{"eng":{"official":"Republic of South Sudan","common":"South Sudan"}}},"tld":[".ss"],"cca2":"SS","ccn3":"728","cca3":"SSD","cioc":"","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"SSP":{"name":"South Sudanese pound","symbol":"\xa3"}},"idd":{"root":"+2","suffixes":["11"]},"capital":["Juba"],"altSpellings":["SS"],"region":"Africa","subregion":"Middle Africa","languages":{"eng":"English"},"translations":{"ces":{"official":"Jihos\xfad\xe1nsk\xe1 republika","common":"Ji\u017En\xed S\xfad\xe1n"},"deu":{"official":"Republik S\xfcdsudan","common":"S\xfcdsudan"},"est":{"official":"L\xf5una-Sudaani Vabariik","common":"L\xf5una-Sudaan"},"fin":{"official":"Etel\xe4-Sudanin tasavalta","common":"Etel\xe4-Sudan"},"fra":{"official":"R\xe9publique du Soudan du Sud","common":"Soudan du Sud"},"hrv":{"official":"Republika Ju\u017Eni Sudan","common":"Ju\u017Eni Sudan"},"hun":{"official":"D\xe9l-szud\xe1ni K\xf6zt\xe1rsas\xe1g","common":"D\xe9l-Szud\xe1n"},"ita":{"official":"Repubblica del Sudan del Sud","common":"Sudan del sud"},"jpn":{"official":"\u5357\u30B9\u30FC\u30C0\u30F3\u5171\u548C\u56FD","common":"\u5357\u30B9\u30FC\u30C0\u30F3"},"kor":{"official":"\uB0A8\uC218\uB2E8 \uACF5\uD654\uAD6D","common":"\uB0A8\uC218\uB2E8"},"nld":{"official":"Republiek Zuid-Soedan","common":"Zuid-Soedan"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0633\u0648\u062F\u0627\u0646 \u062C\u0646\u0648\u0628\u06CC","common":"\u0633\u0648\u062F\u0627\u0646 \u062C\u0646\u0648\u0628\u06CC"},"pol":{"official":"Republika Sudanu","common":"Sudan"},"por":{"official":"Rep\xfablica do Sud\xe3o do Sul","common":"Sud\xe3o do Sul"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u042E\u0436\u043D\u044B\u0439 \u0421\u0443\u0434\u0430\u043D","common":"\u042E\u0436\u043D\u044B\u0439 \u0421\u0443\u0434\u0430\u043D"},"slk":{"official":"Juhosud\xe1nska republika","common":"Ju\u017En\xfd Sud\xe1n"},"spa":{"official":"Rep\xfablica de Sud\xe1n del Sur","common":"Sud\xe1n del Sur"},"swe":{"official":"Republiken Sydsudan","common":"Sydsudan"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u062C\u0646\u0648\u0628\u06CC \u0633\u0648\u0688\u0627\u0646","common":"\u062C\u0646\u0648\u0628\u06CC \u0633\u0648\u0688\u0627\u0646"},"zho":{"official":"\u5357\u82CF\u4E39\u5171\u548C\u56FD","common":"\u5357\u82CF\u4E39"}},"latlng":[7,30],"landlocked":true,"borders":["CAF","COD","ETH","KEN","SDN","UGA"],"area":619745,"flag":"\uD83C\uDDF8\uD83C\uDDF8","demonyms":{"eng":{"f":"South Sudanese","m":"South Sudanese"},"fra":{"f":"Sud-Soudanaise","m":"Sud-Soudanais"}}},{"name":{"common":"S\xe3o Tom\xe9 and Pr\xedncipe","official":"Democratic Republic of S\xe3o Tom\xe9 and Pr\xedncipe","native":{"por":{"official":"Rep\xfablica Democr\xe1tica do S\xe3o Tom\xe9 e Pr\xedncipe","common":"S\xe3o Tom\xe9 e Pr\xedncipe"}}},"tld":[".st"],"cca2":"ST","ccn3":"678","cca3":"STP","cioc":"STP","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"STN":{"name":"S\xe3o Tom\xe9 and Pr\xedncipe dobra","symbol":"Db"}},"idd":{"root":"+2","suffixes":["39"]},"capital":["S\xe3o Tom\xe9"],"altSpellings":["ST","Democratic Republic of S\xe3o Tom\xe9 and Pr\xedncipe","Sao Tome and Principe","Rep\xfablica Democr\xe1tica de S\xe3o Tom\xe9 e Pr\xedncipe"],"region":"Africa","subregion":"Middle Africa","languages":{"por":"Portuguese"},"translations":{"ces":{"official":"Demokratick\xe1 republika Svat\xfd Tom\xe1\u0161 a Princ\u016Fv ostrov","common":"Svat\xfd Tom\xe1\u0161 a Princ\u016Fv ostrov"},"deu":{"official":"Demokratische Republik S\xe3o Tom\xe9 und Pr\xedncipe","common":"S\xe3o Tom\xe9 und Pr\xedncipe"},"est":{"official":"S\xe3o Tom\xe9 ja Pr\xedncipe Demokraatlik Vabariik","common":"S\xe3o Tom\xe9 ja Pr\xedncipe"},"fin":{"official":"S\xe3o Tom\xe9 ja Pr\xedncipen demokraattinen tasavalta","common":"S\xe3o T\xe9me ja Pr\xedncipe"},"fra":{"official":"R\xe9publique d\xe9mocratique de S\xe3o Tom\xe9 et Pr\xedncipe","common":"S\xe3o Tom\xe9 et Pr\xedncipe"},"hrv":{"official":"Demokratska Republika S\xe3o Tome i Principe","common":"Sveti Toma i Princip"},"hun":{"official":"S\xe3o Tom\xe9 \xe9s Pr\xedncipe Demokratikus K\xf6zt\xe1rsas\xe1g","common":"S\xe3o Tom\xe9 \xe9s Pr\xedncipe"},"ita":{"official":"Repubblica democratica di S\xe3o Tom\xe9 e Pr\xedncipe","common":"S\xe3o Tom\xe9 e Pr\xedncipe"},"jpn":{"official":"\u30B5\u30F3\u30C8\u30E1\xb7\u30D7\u30EA\u30F3\u30B7\u30DA\u6C11\u4E3B\u5171\u548C\u56FD","common":"\u30B5\u30F3\u30C8\u30E1\u30FB\u30D7\u30EA\u30F3\u30B7\u30DA"},"kor":{"official":"\uC0C1\uD22C\uBA54 \uD504\uB9B0\uC2DC\uD398 \uBBFC\uC8FC \uACF5\uD654\uAD6D","common":"\uC0C1\uD22C\uBA54 \uD504\uB9B0\uC2DC\uD398"},"nld":{"official":"Democratische Republiek Sao Tom\xe9 en Principe","common":"Sao Tom\xe9 en Principe"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u062F\u0645\u0648\u06A9\u0631\u0627\u062A\u06CC\u06A9 \u0633\u0627\u0626\u0648\u062A\u0648\u0645\u0647 \u0648 \u067E\u0631\u0646\u0633\u06CC\u067E","common":"\u0633\u0627\u0626\u0648\u062A\u0648\u0645\u0647 \u0648 \u067E\u0631\u0646\u0633\u06CC\u067E"},"pol":{"official":"Demokratyczna Republika Wysp \u015Awi\u0119tego Tomasza i Ksi\u0105\u017C\u0119cej","common":"Wyspy \u015Awi\u0119tego Tomasza i Ksi\u0105\u017C\u0119ca"},"por":{"official":"Rep\xfablica Democr\xe1tica de S\xe3o Tom\xe9 e Pr\xedncipe","common":"S\xe3o Tom\xe9 e Pr\xedncipe"},"rus":{"official":"\u0414\u0435\u043C\u043E\u043A\u0440\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u0430\u043D-\u0422\u043E\u043C\u0435 \u0438 \u041F\u0440\u0438\u043D\u0441\u0438\u043F\u0438","common":"\u0421\u0430\u043D-\u0422\u043E\u043C\u0435 \u0438 \u041F\u0440\u0438\u043D\u0441\u0438\u043F\u0438"},"slk":{"official":"Demokratick\xe1 republika Sv\xe4t\xe9ho Tom\xe1\u0161a A princovho ostrova","common":"Sv\xe4t\xfd Tom\xe1\u0161 a Princov ostrov"},"spa":{"official":"Rep\xfablica Democr\xe1tica de Santo Tom\xe9 y Pr\xedncipe","common":"Santo Tom\xe9 y Pr\xedncipe"},"swe":{"official":"Demokratiska republiken S\xe3o Tom\xe9 och Pr\xedncipe","common":"S\xe3o Tom\xe9 och Pr\xedncipe"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0633\u0627\u0624 \u0679\u0648\u0645\u06D2 \u0648 \u067E\u0631\u0646\u0633\u067E\u06D2","common":"\u0633\u0627\u0624 \u0679\u0648\u0645\u06D2 \u0648 \u067E\u0631\u0646\u0633\u067E\u06D2"},"zho":{"official":"\u5723\u591A\u7F8E\u548C\u666E\u6797\u897F\u6BD4\u6C11\u4E3B\u5171\u548C\u56FD","common":"\u5723\u591A\u7F8E\u548C\u666E\u6797\u897F\u6BD4"}},"latlng":[1,7],"landlocked":false,"borders":[],"area":964,"flag":"\uD83C\uDDF8\uD83C\uDDF9","demonyms":{"eng":{"f":"Sao Tomean","m":"Sao Tomean"},"fra":{"f":"Santom\xe9enne","m":"Santom\xe9en"}}},{"name":{"common":"Suriname","official":"Republic of Suriname","native":{"nld":{"official":"Republiek Suriname","common":"Suriname"}}},"tld":[".sr"],"cca2":"SR","ccn3":"740","cca3":"SUR","cioc":"SUR","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"SRD":{"name":"Surinamese dollar","symbol":"$"}},"idd":{"root":"+5","suffixes":["97"]},"capital":["Paramaribo"],"altSpellings":["SR","Sarnam","Sranangron","Republic of Suriname","Republiek Suriname"],"region":"Americas","subregion":"South America","languages":{"nld":"Dutch"},"translations":{"ces":{"official":"Republika Surinam","common":"Surinam"},"deu":{"official":"Republik Suriname","common":"Suriname"},"est":{"official":"Suriname Vabariik","common":"Suriname"},"fin":{"official":"Surinamen tasavalta","common":"Suriname"},"fra":{"official":"R\xe9publique du Suriname","common":"Surinam"},"hrv":{"official":"Republika Surinam","common":"Surinam"},"hun":{"official":"Suriname K\xf6zt\xe1rsas\xe1g","common":"Suriname"},"ita":{"official":"Repubblica del Suriname","common":"Suriname"},"jpn":{"official":"\u30B9\u30EA\u30CA\u30E0\u5171\u548C\u56FD","common":"\u30B9\u30EA\u30CA\u30E0"},"kor":{"official":"\uC218\uB9AC\uB0A8 \uACF5\uD654\uAD6D","common":"\uC218\uB9AC\uB0A8"},"nld":{"official":"Republiek Suriname","common":"Suriname"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0633\u0648\u0631\u06CC\u0646\u0627\u0645","common":"\u0633\u0648\u0631\u06CC\u0646\u0627\u0645"},"pol":{"official":"Republika Surinamu","common":"Surinam"},"por":{"official":"Rep\xfablica do Suriname","common":"Suriname"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u0443\u0440\u0438\u043D\u0430\u043C","common":"\u0421\u0443\u0440\u0438\u043D\u0430\u043C"},"slk":{"official":"Surinamsk\xe1 republika","common":"Surinam"},"spa":{"official":"Rep\xfablica de Suriname","common":"Surinam"},"swe":{"official":"Republiken Surinam","common":"Surinam"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0633\u0631\u06CC\u0646\u0627\u0645","common":"\u0633\u0631\u06CC\u0646\u0627\u0645"},"zho":{"official":"\u82CF\u91CC\u5357\u5171\u548C\u56FD","common":"\u82CF\u91CC\u5357"}},"latlng":[4,-56],"landlocked":false,"borders":["BRA","GUF","GUY"],"area":163820,"flag":"\uD83C\uDDF8\uD83C\uDDF7","demonyms":{"eng":{"f":"Surinamer","m":"Surinamer"},"fra":{"f":"Surinamaise","m":"Surinamais"}}},{"name":{"common":"Slovakia","official":"Slovak Republic","native":{"slk":{"official":"Slovensk\xe1 republika","common":"Slovensko"}}},"tld":[".sk"],"cca2":"SK","ccn3":"703","cca3":"SVK","cioc":"SVK","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+4","suffixes":["21"]},"capital":["Bratislava"],"altSpellings":["SK","Slovak Republic","Slovensk\xe1 republika"],"region":"Europe","subregion":"Central Europe","languages":{"slk":"Slovak"},"translations":{"ces":{"official":"Slovensk\xe1 republika","common":"Slovensko"},"deu":{"official":"Slowakische Republik","common":"Slowakei"},"est":{"official":"Slovaki Vabariik","common":"Slovakkia"},"fin":{"official":"Slovakian tasavalta","common":"Slovakia"},"fra":{"official":"R\xe9publique slovaque","common":"Slovaquie"},"hrv":{"official":"slova\u010Dka","common":"Slova\u010Dka"},"hun":{"official":"Szlov\xe1k K\xf6zt\xe1rsas\xe1g","common":"Szlov\xe1kia"},"ita":{"official":"Repubblica slovacca","common":"Slovacchia"},"jpn":{"official":"\u30B9\u30ED\u30D0\u30AD\u30A2\u5171\u548C\u56FD","common":"\u30B9\u30ED\u30D0\u30AD\u30A2"},"kor":{"official":"\uC2AC\uB85C\uBC14\uD0A4\uC544 \uACF5\uD654\uAD6D","common":"\uC2AC\uB85C\uBC14\uD0A4\uC544"},"nld":{"official":"Slowaakse Republiek","common":"Slowakije"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0633\u0644\u0648\u0627\u06A9\u06CC","common":"\u0627\u0650\u0633\u0644\u064F\u0648\u0627\u06A9\u06CC"},"pol":{"official":"Republika S\u0142owacka","common":"S\u0142owacja"},"por":{"official":"Rep\xfablica Eslovaca","common":"Eslov\xe1quia"},"rus":{"official":"\u0421\u043B\u043E\u0432\u0430\u0446\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u0421\u043B\u043E\u0432\u0430\u043A\u0438\u044F"},"slk":{"official":"Slovensk\xe1 republika","common":"Slovensko"},"spa":{"official":"Rep\xfablica Eslovaca","common":"Rep\xfablica Eslovaca"},"swe":{"official":"Republiken Slovakien","common":"Slovakien"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0633\u0644\u0648\u0648\u0627\u06A9\u06CC\u06C1","common":"\u0633\u0644\u0648\u0648\u0627\u06A9\u06CC\u06C1"},"zho":{"official":"\u65AF\u6D1B\u4F10\u514B\u5171\u548C\u56FD","common":"\u65AF\u6D1B\u4F10\u514B"}},"latlng":[48.66666666,19.5],"landlocked":true,"borders":["AUT","CZE","HUN","POL","UKR"],"area":49037,"flag":"\uD83C\uDDF8\uD83C\uDDF0","demonyms":{"eng":{"f":"Slovak","m":"Slovak"},"fra":{"f":"Slovaque","m":"Slovaque"}}},{"name":{"common":"Slovenia","official":"Republic of Slovenia","native":{"slv":{"official":"Republika Slovenija","common":"Slovenija"}}},"tld":[".si"],"cca2":"SI","ccn3":"705","cca3":"SVN","cioc":"SLO","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["86"]},"capital":["Ljubljana"],"altSpellings":["SI","Republic of Slovenia","Republika Slovenija"],"region":"Europe","subregion":"Central Europe","languages":{"slv":"Slovene"},"translations":{"ces":{"official":"Slovinsk\xe1 republika","common":"Slovinsko"},"deu":{"official":"Republik Slowenien","common":"Slowenien"},"est":{"official":"Sloveenia Vabariik","common":"Sloveenia"},"fin":{"official":"Slovenian tasavalta","common":"Slovenia"},"fra":{"official":"R\xe9publique de Slov\xe9nie","common":"Slov\xe9nie"},"hrv":{"official":"Republika Slovenija","common":"Slovenija"},"hun":{"official":"Szlov\xe9n K\xf6zt\xe1rsas\xe1g","common":"Szlov\xe9nia"},"ita":{"official":"Repubblica di Slovenia","common":"Slovenia"},"jpn":{"official":"\u30B9\u30ED\u30D9\u30CB\u30A2\u5171\u548C\u56FD","common":"\u30B9\u30ED\u30D9\u30CB\u30A2"},"kor":{"official":"\uC2AC\uB85C\uBCA0\uB2C8\uC544 \uACF5\uD654\uAD6D","common":"\uC2AC\uB85C\uBCA0\uB2C8\uC544"},"nld":{"official":"Republiek Sloveni\xeb","common":"Sloveni\xeb"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0633\u0644\u0648\u0648\u0646\u06CC","common":"\u0627\u0633\u0644\u0648\u0648\u0646\u06CC"},"pol":{"official":"Republika S\u0142owenii","common":"S\u0142owenia"},"por":{"official":"Rep\xfablica da Eslov\xe9nia","common":"Eslov\xe9nia"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u043B\u043E\u0432\u0435\u043D\u0438\u044F","common":"\u0421\u043B\u043E\u0432\u0435\u043D\u0438\u044F"},"slk":{"official":"Slovinsk\xe1 republika","common":"Slovinsko"},"spa":{"official":"Rep\xfablica de Eslovenia","common":"Eslovenia"},"swe":{"official":"Republiken Slovenien","common":"Slovenien"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0633\u0644\u0648\u0648\u06CC\u0646\u06CC\u0627","common":"\u0633\u0644\u0648\u0648\u06CC\u0646\u06CC\u0627"},"zho":{"official":"\u65AF\u6D1B\u6587\u5C3C\u4E9A\u5171\u548C\u56FD","common":"\u65AF\u6D1B\u6587\u5C3C\u4E9A"}},"latlng":[46.11666666,14.81666666],"landlocked":false,"borders":["AUT","HRV","ITA","HUN"],"area":20273,"flag":"\uD83C\uDDF8\uD83C\uDDEE","demonyms":{"eng":{"f":"Slovene","m":"Slovene"},"fra":{"f":"Slov\xe8ne","m":"Slov\xe8ne"}}},{"name":{"common":"Sweden","official":"Kingdom of Sweden","native":{"swe":{"official":"Konungariket Sverige","common":"Sverige"}}},"tld":[".se"],"cca2":"SE","ccn3":"752","cca3":"SWE","cioc":"SWE","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"SEK":{"name":"Swedish krona","symbol":"kr"}},"idd":{"root":"+4","suffixes":["6"]},"capital":["Stockholm"],"altSpellings":["SE","Kingdom of Sweden","Konungariket Sverige"],"region":"Europe","subregion":"Northern Europe","languages":{"swe":"Swedish"},"translations":{"ces":{"official":"\u0160v\xe9dsk\xe9 kr\xe1lovstv\xed","common":"\u0160v\xe9dsko"},"deu":{"official":"K\xf6nigreich Schweden","common":"Schweden"},"est":{"official":"Rootsi Kuningriik","common":"Rootsi"},"fin":{"official":"Ruotsin kuningaskunta","common":"Ruotsi"},"fra":{"official":"Royaume de Su\xe8de","common":"Su\xe8de"},"hrv":{"official":"Kraljevina \u0160vedska","common":"\u0160vedska"},"hun":{"official":"Sv\xe9d Kir\xe1lys\xe1g","common":"Sv\xe9dorsz\xe1g"},"ita":{"official":"Regno di Svezia","common":"Svezia"},"jpn":{"official":"\u30B9\u30A6\u30A7\u30FC\u30C7\u30F3\u738B\u56FD","common":"\u30B9\u30A6\u30A7\u30FC\u30C7\u30F3"},"kor":{"official":"\uC2A4\uC6E8\uB374 \uC655\uAD6D","common":"\uC2A4\uC6E8\uB374"},"nld":{"official":"Koninkrijk Zweden","common":"Zweden"},"per":{"official":"\u067E\u0627\u062F\u0634\u0627\u0647\u06CC \u0633\u0648\u0626\u062F","common":"\u0633\u0648\u0626\u062F"},"pol":{"official":"Kr\xf3lestwo Szwecji","common":"Szwecja"},"por":{"official":"Reino da Su\xe9cia","common":"Su\xe9cia"},"rus":{"official":"\u041A\u043E\u0440\u043E\u043B\u0435\u0432\u0441\u0442\u0432\u043E \u0428\u0432\u0435\u0446\u0438\u044F","common":"\u0428\u0432\u0435\u0446\u0438\u044F"},"slk":{"official":"\u0160v\xe9dske kr\xe1\u013Eovstvo","common":"\u0160v\xe9dsko"},"spa":{"official":"Reino de Suecia","common":"Suecia"},"swe":{"official":"Konungariket Sverige","common":"Sverige"},"urd":{"official":"\u0645\u0645\u0644\u06A9\u062A\u0650 \u0633\u0648\u06CC\u0688\u0646","common":"\u0633\u0648\u06CC\u0688\u0646"},"zho":{"official":"\u745E\u5178\u738B\u56FD","common":"\u745E\u5178"}},"latlng":[62,15],"landlocked":false,"borders":["FIN","NOR"],"area":450295,"flag":"\uD83C\uDDF8\uD83C\uDDEA","demonyms":{"eng":{"f":"Swedish","m":"Swedish"},"fra":{"f":"Su\xe9doise","m":"Su\xe9dois"}}},{"name":{"common":"Eswatini","official":"Kingdom of Eswatini","native":{"eng":{"official":"Kingdom of Eswatini","common":"Eswatini"},"ssw":{"official":"Umbuso weSwatini","common":"eSwatini"}}},"tld":[".sz"],"cca2":"SZ","ccn3":"748","cca3":"SWZ","cioc":"SWZ","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"SZL":{"name":"Swazi lilangeni","symbol":"L"},"ZAR":{"name":"South African rand","symbol":"R"}},"idd":{"root":"+2","suffixes":["68"]},"capital":["Lobamba"],"altSpellings":["SZ","Swaziland","weSwatini","Swatini","Ngwane","Kingdom of Eswatini","Umbuso weSwatini"],"region":"Africa","subregion":"Southern Africa","languages":{"eng":"English","ssw":"Swazi"},"translations":{"ces":{"official":"Svazijsk\xe9 kr\xe1lovstv\xed","common":"Svazijsko"},"deu":{"official":"K\xf6nigreich Eswatini","common":"Swasiland"},"est":{"official":"eSwatini Kuningriik","common":"Svaasimaa"},"fin":{"official":"Swazimaan kuningaskunta","common":"Swazimaa"},"fra":{"official":"Royaume d\u2019Eswatini","common":"Swaziland"},"hrv":{"official":"Kraljevina eSwatini","common":"Svazi"},"hun":{"official":"Szv\xe1zif\xf6ldi Kir\xe1lys\xe1g","common":"Szv\xe1zif\xf6ld"},"ita":{"official":"Regno di eSwatini","common":"Swaziland"},"jpn":{"official":"\u30B9\u30EF\u30B8\u30E9\u30F3\u30C9\u738B\u56FD","common":"\u30B9\u30EF\u30B8\u30E9\u30F3\u30C9"},"kor":{"official":"\uC5D0\uC2A4\uC640\uD2F0\uB2C8 \uC655\uAD6D","common":"\uC5D0\uC2A4\uC640\uD2F0\uB2C8"},"nld":{"official":"Koninkrijk eSwatini","common":"Swaziland"},"per":{"official":"\u067E\u0627\u062F\u0634\u0627\u0647\u06CC \u0633\u0648\u0627\u0632\u06CC\u0644\u0646\u062F","common":"\u0627\u0633\u0648\u0627\u062A\u06CC\u0646\u06CC"},"pol":{"official":"Kr\xf3lestwo Suazi","common":"Suazi"},"por":{"official":"Reino de eSwatini","common":"Suazil\xe2ndia"},"rus":{"official":"\u041A\u043E\u0440\u043E\u043B\u0435\u0432\u0441\u0442\u0432\u043E \u0421\u0432\u0430\u0437\u0438\u043B\u0435\u043D\u0434","common":"\u0421\u0432\u0430\u0437\u0438\u043B\u0435\u043D\u0434"},"slk":{"official":"Svazijsk\xe9 kr\xe1\u013Eovstvo","common":"Svazijsko"},"spa":{"official":"Reino de eSwatini","common":"Suazilandia"},"swe":{"official":"Konungariket Eswatini","common":"Swaziland"},"urd":{"official":"\u0645\u0645\u0644\u06A9\u062A\u0650 \u0633\u0648\u0627\u0632\u06CC \u0644\u06CC\u0646\u0688","common":"\u0633\u0648\u0627\u0632\u06CC \u0644\u06CC\u0646\u0688"},"zho":{"official":"\u65AF\u5A01\u58EB\u5170\u738B\u56FD","common":"\u65AF\u5A01\u58EB\u5170"}},"latlng":[-26.5,31.5],"landlocked":true,"borders":["MOZ","ZAF"],"area":17364,"flag":"\uD83C\uDDF8\uD83C\uDDFF","demonyms":{"eng":{"f":"Swazi","m":"Swazi"},"fra":{"f":"Swazie","m":"Swazie"}}},{"name":{"common":"Sint Maarten","official":"Sint Maarten","native":{"eng":{"official":"Sint Maarten","common":"Sint Maarten"},"fra":{"official":"Saint-Martin","common":"Saint-Martin"},"nld":{"official":"Sint Maarten","common":"Sint Maarten"}}},"tld":[".sx"],"cca2":"SX","ccn3":"534","cca3":"SXM","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"ANG":{"name":"Netherlands Antillean guilder","symbol":"\u0192"}},"idd":{"root":"+1","suffixes":["721"]},"capital":["Philipsburg"],"altSpellings":["SX","Sint Maarten (Dutch part)"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English","fra":"French","nld":"Dutch"},"translations":{"ces":{"official":"Svat\xfd Martin","common":"Svat\xfd Martin (Nizozemsko)"},"deu":{"official":"Sint Maarten","common":"Sint Maarten"},"est":{"official":"Sint Maarten","common":"Sint Maarten"},"fin":{"official":"Sint Maarten","common":"Sint Maarten"},"fra":{"official":"Sint Maarten","common":"Saint-Martin"},"hrv":{"official":"Sveti Martin","common":"Sveti Martin"},"hun":{"official":"Sint Maarten","common":"Sint Maarten"},"ita":{"official":"Sint Maarten","common":"Sint Maarten"},"jpn":{"official":"\u30B7\u30F3\u30C8\u30DE\u30FC\u30EB\u30C6\u30F3\u5CF6","common":"\u30B7\u30F3\u30C8\u30FB\u30DE\u30FC\u30EB\u30C6\u30F3"},"kor":{"official":"\uC2E0\uD2B8\uB9C8\uB974\uD134","common":"\uC2E0\uD2B8\uB9C8\uB974\uD134"},"nld":{"official":"Sint Maarten","common":"Sint Maarten"},"per":{"official":"\u0633\u0646 \u0645\u0627\u0631\u062A\u0646","common":"\u0633\u0646 \u0645\u0627\u0631\u062A\u0646"},"pol":{"official":"Sint Maarten","common":"Sint Maarten"},"por":{"official":"Sint Maarten","common":"S\xe3o Martinho"},"rus":{"official":"\u0421\u0438\u043D\u0442-\u041C\u0430\u0430\u0440\u0442\u0435\u043D","common":"\u0421\u0438\u043D\u0442-\u041C\u0430\u0440\u0442\u0435\u043D"},"slk":{"official":"Sint Maarten","common":"Sint Maarten"},"spa":{"official":"Sint Maarten","common":"Sint Maarten"},"swe":{"official":"Sint Maarten","common":"Sint Maarten"},"urd":{"official":"\u0633\u0646\u0679 \u0645\u0627\u0631\u0679\u0646","common":"\u0633\u0646\u0679 \u0645\u0627\u0631\u0679\u0646"},"zho":{"official":"\u5723\u9A6C\u4E01\u5C9B","common":"\u5723\u9A6C\u4E01\u5C9B"}},"latlng":[18.033333,-63.05],"landlocked":false,"borders":["MAF"],"area":34,"flag":"\uD83C\uDDF8\uD83C\uDDFD","demonyms":{"eng":{"f":"St. Maartener","m":"St. Maartener"},"fra":{"f":"Saint-Martinoise","m":"Saint-Martinois"}}},{"name":{"common":"Seychelles","official":"Republic of Seychelles","native":{"crs":{"official":"Repiblik Sesel","common":"Sesel"},"eng":{"official":"Republic of Seychelles","common":"Seychelles"},"fra":{"official":"R\xe9publique des Seychelles","common":"Seychelles"}}},"tld":[".sc"],"cca2":"SC","ccn3":"690","cca3":"SYC","cioc":"SEY","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"SCR":{"name":"Seychellois rupee","symbol":"\u20A8"}},"idd":{"root":"+2","suffixes":["48"]},"capital":["Victoria"],"altSpellings":["SC","Republic of Seychelles","Repiblik Sesel","R\xe9publique des Seychelles"],"region":"Africa","subregion":"Eastern Africa","languages":{"crs":"Seychellois Creole","eng":"English","fra":"French"},"translations":{"ces":{"official":"Seychelsk\xe1 republika","common":"Seychely"},"deu":{"official":"Republik der Seychellen","common":"Seychellen"},"est":{"official":"Sei\u0161elli Vabariik","common":"Sei\u0161ellid"},"fin":{"official":"Seychellien tasavalta","common":"Seychellit"},"fra":{"official":"R\xe9publique des Seychelles","common":"Seychelles"},"hrv":{"official":"Republika Sej\u0161eli","common":"Sej\u0161eli"},"hun":{"official":"Seychelle K\xf6zt\xe1rsas\xe1g","common":"Seychelle-szigetek"},"ita":{"official":"Repubblica delle Seychelles","common":"Seychelles"},"jpn":{"official":"\u30BB\u30A4\u30B7\u30A7\u30EB\u5171\u548C\u56FD","common":"\u30BB\u30FC\u30B7\u30A7\u30EB"},"kor":{"official":"\uC138\uC774\uC178 \uACF5\uD654\uAD6D","common":"\uC138\uC774\uC178"},"nld":{"official":"Republiek der Seychellen","common":"Seychellen"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0633\u06CC\u0634\u0644","common":"\u0633\u06CC\u0634\u0644"},"pol":{"official":"Republika Seszeli","common":"Seszele"},"por":{"official":"Rep\xfablica das Seychelles","common":"Seicheles"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u0435\u0439\u0448\u0435\u043B\u044C\u0441\u043A\u0438\u0435 \u041E\u0441\u0442\u0440\u043E\u0432\u0430","common":"\u0421\u0435\u0439\u0448\u0435\u043B\u044C\u0441\u043A\u0438\u0435 \u041E\u0441\u0442\u0440\u043E\u0432\u0430"},"slk":{"official":"Seychelsk\xe1 republika","common":"Seychely"},"spa":{"official":"Rep\xfablica de las Seychelles","common":"Seychelles"},"swe":{"official":"Republiken Seychellerna","common":"Seychellerna"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0633\u06CC\u0686\u06CC\u0644\u06CC\u0633","common":"\u0633\u06CC\u0686\u06CC\u0644\u06CC\u0633"},"zho":{"official":"\u585E\u820C\u5C14\u5171\u548C\u56FD","common":"\u585E\u820C\u5C14"}},"latlng":[-4.58333333,55.66666666],"landlocked":false,"borders":[],"area":452,"flag":"\uD83C\uDDF8\uD83C\uDDE8","demonyms":{"eng":{"f":"Seychellois","m":"Seychellois"},"fra":{"f":"Seychelloise","m":"Seychellois"}}},{"name":{"common":"Syria","official":"Syrian Arab Republic","native":{"ara":{"official":"\u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0648\u0631\u064A\u0629","common":"\u0633\u0648\u0631\u064A\u0627"}}},"tld":[".sy","\u0633\u0648\u0631\u064A\u0627."],"cca2":"SY","ccn3":"760","cca3":"SYR","cioc":"SYR","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"SYP":{"name":"Syrian pound","symbol":"\xa3"}},"idd":{"root":"+9","suffixes":["63"]},"capital":["Damascus"],"altSpellings":["SY","Syrian Arab Republic","Al-Jumh\u016Br\u012Byah Al-\u02BBArab\u012Byah As-S\u016Br\u012Byah"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Syrsk\xe1 arabsk\xe1 republika","common":"S\xfdrie"},"deu":{"official":"Arabische Republik Syrien","common":"Syrien"},"est":{"official":"S\xfc\xfcria Araabia Vabariik","common":"S\xfc\xfcria"},"fin":{"official":"Syyrian arabitasavalta","common":"Syyria"},"fra":{"official":"R\xe9publique arabe syrienne","common":"Syrie"},"hrv":{"official":"Sirijska Arapska Republika","common":"Sirija"},"hun":{"official":"Sz\xedriai Arab K\xf6zt\xe1rsas\xe1g","common":"Sz\xedria"},"ita":{"official":"Repubblica araba siriana","common":"Siria"},"jpn":{"official":"\u30B7\u30EA\u30A2\u30A2\u30E9\u30D6\u5171\u548C\u56FD","common":"\u30B7\u30EA\u30A2\u30FB\u30A2\u30E9\u30D6\u5171\u548C\u56FD"},"kor":{"official":"\uC2DC\uB9AC\uC544 \uC544\uB78D \uACF5\uD654\uAD6D","common":"\uC2DC\uB9AC\uC544"},"nld":{"official":"Syrische Arabische Republiek","common":"Syri\xeb"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0639\u0631\u0628\u06CC \u0633\u0648\u0631\u06CC\u0647","common":"\u0633\u0648\u0631\u06CC\u0647"},"pol":{"official":"Syryjska Republika Arabska","common":"Syria"},"por":{"official":"Rep\xfablica \xc1rabe S\xedria","common":"S\xedria"},"rus":{"official":"\u0421\u0438\u0440\u0438\u0439\u0441\u043A\u0430\u044F \u0410\u0440\u0430\u0431\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u0421\u0438\u0440\u0438\u044F"},"slk":{"official":"S\xfdrska arabsk\xe1 republika","common":"S\xfdria"},"spa":{"official":"Rep\xfablica \xc1rabe Siria","common":"Siria"},"swe":{"official":"Syriska arabiska republiken","common":"Syrien"},"urd":{"official":"\u0639\u0631\u0628 \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0633\u0648\u0631\u06CC\u06C1","common":"\u0633\u0648\u0631\u06CC\u06C1"},"zho":{"official":"\u53D9\u5229\u4E9A\u963F\u62C9\u4F2F\u5171\u548C\u56FD","common":"\u53D9\u5229\u4E9A"}},"latlng":[35,38],"landlocked":false,"borders":["IRQ","ISR","JOR","LBN","TUR"],"area":185180,"flag":"\uD83C\uDDF8\uD83C\uDDFE","demonyms":{"eng":{"f":"Syrian","m":"Syrian"},"fra":{"f":"Syrienne","m":"Syrien"}}},{"name":{"common":"Turks and Caicos Islands","official":"Turks and Caicos Islands","native":{"eng":{"official":"Turks and Caicos Islands","common":"Turks and Caicos Islands"}}},"tld":[".tc"],"cca2":"TC","ccn3":"796","cca3":"TCA","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["649"]},"capital":["Cockburn Town"],"altSpellings":["TC"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Turks a Caicos","common":"Turks a Caicos"},"deu":{"official":"Turks und Caicos Inseln","common":"Turks-und Caicosinseln"},"est":{"official":"Turksi ja Caicose saared","common":"Turks ja Caicos"},"fin":{"official":"Turks-ja Caicossaaret","common":"Turks-ja Caicossaaret"},"fra":{"official":"\xceles Turques et Ca\xefques","common":"\xceles Turques-et-Ca\xefques"},"hrv":{"official":"Otoci Turks i Caicos","common":"Otoci Turks i Caicos"},"hun":{"official":"Turks- \xe9s Caicos-szigetek","common":"Turks- \xe9s Caicos-szigetek"},"ita":{"official":"Turks e Caicos","common":"Isole Turks e Caicos"},"jpn":{"official":"\u30BF\u30FC\u30AF\u30B9\xb7\u30AB\u30A4\u30B3\u30B9\u8AF8\u5CF6","common":"\u30BF\u30FC\u30AF\u30B9\u30FB\u30AB\u30A4\u30B3\u30B9\u8AF8\u5CF6"},"kor":{"official":"\uD130\uD06C\uC2A4 \uCF00\uC774\uCEE4\uC2A4 \uC81C\uB3C4","common":"\uD130\uD06C\uC2A4 \uCF00\uC774\uCEE4\uC2A4 \uC81C\uB3C4"},"nld":{"official":"Turks-en Caicoseilanden","common":"Turks-en Caicoseilanden"},"per":{"official":"\u062C\u0632\u0627\u06CC\u0631 \u062A\u0648\u0631\u06A9\u0633 \u0648 \u06A9\u0627\u06CC\u06A9\u0648\u0633","common":"\u062C\u0632\u0627\u06CC\u0631 \u062A\u0648\u0631\u06A9\u0633 \u0648 \u06A9\u0627\u06CC\u06A9\u0648\u0633"},"pol":{"official":"Turks i Caicos","common":"Turks i Caicos"},"por":{"official":"Ilhas Turks e Caicos","common":"Ilhas Turks e Caicos"},"rus":{"official":"\u0422\u0435\u0440\u043A\u0441 \u0438 \u041A\u0430\u0439\u043A\u043E\u0441 \u043E\u0441\u0442\u0440\u043E\u0432\u0430","common":"\u0422\u0435\u0440\u043A\u0441 \u0438 \u041A\u0430\u0439\u043A\u043E\u0441"},"slk":{"official":"Ostrovy Turks a Caicos","common":"Turks a Caicos"},"spa":{"official":"Islas Turcas y Caicos","common":"Islas Turks y Caicos"},"swe":{"official":"Turks- och Caicos\xf6arna","common":"Turks- och Caicos\xf6arna"},"urd":{"official":"\u062C\u0632\u0627\u0626\u0631 \u06A9\u06CC\u06A9\u0633 \u0648 \u062A\u0631\u06A9\u06CC\u06C1","common":"\u062C\u0632\u0627\u0626\u0631 \u06A9\u06CC\u06A9\u0633 \u0648 \u062A\u0631\u06A9\u06CC\u06C1"},"zho":{"official":"\u7279\u514B\u65AF\u548C\u51EF\u79D1\u65AF\u7FA4\u5C9B","common":"\u7279\u514B\u65AF\u548C\u51EF\u79D1\u65AF\u7FA4\u5C9B"}},"latlng":[21.75,-71.58333333],"landlocked":false,"borders":[],"area":948,"flag":"\uD83C\uDDF9\uD83C\uDDE8","demonyms":{"eng":{"f":"Turks and Caicos Islander","m":"Turks and Caicos Islander"},"fra":{"f":"","m":""}}},{"name":{"common":"Chad","official":"Republic of Chad","native":{"ara":{"official":"\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u062A\u0634\u0627\u062F","common":"\u062A\u0634\u0627\u062F\u200E"},"fra":{"official":"R\xe9publique du Tchad","common":"Tchad"}}},"tld":[".td"],"cca2":"TD","ccn3":"148","cca3":"TCD","cioc":"CHA","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"XAF":{"name":"Central African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["35"]},"capital":["N\'Djamena"],"altSpellings":["TD","Tchad","Republic of Chad","R\xe9publique du Tchad"],"region":"Africa","subregion":"Middle Africa","languages":{"ara":"Arabic","fra":"French"},"translations":{"ces":{"official":"\u010Cadsk\xe1 republika","common":"\u010Cad"},"cym":{"official":"Gweriniaeth Tsiad","common":"Tsiad"},"deu":{"official":"Republik Tschad","common":"Tschad"},"est":{"official":"T\u0161aadi Vabariik","common":"T\u0161aad"},"fin":{"official":"T\u0161adin tasavalta","common":"T\u0161ad"},"fra":{"official":"R\xe9publique du Tchad","common":"Tchad"},"hrv":{"official":"\u010Cadu","common":"\u010Cad"},"hun":{"official":"Cs\xe1d K\xf6zt\xe1rsas\xe1g","common":"Cs\xe1d"},"ita":{"official":"Repubblica del Ciad","common":"Ciad"},"jpn":{"official":"\u30C1\u30E3\u30C9\u5171\u548C\u56FD","common":"\u30C1\u30E3\u30C9"},"kor":{"official":"\uCC28\uB4DC \uACF5\uD654\uAD6D","common":"\uCC28\uB4DC"},"nld":{"official":"Republiek Tsjaad","common":"Tsjaad"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0686\u0627\u062F","common":"\u0686\u0627\u062F"},"pol":{"official":"Republika Czadu","common":"Czad"},"por":{"official":"Rep\xfablica do Chade","common":"Chade"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0427\u0430\u0434","common":"\u0427\u0430\u0434"},"slk":{"official":"\u010Cadsk\xe1 republika","common":"\u010Cad"},"spa":{"official":"Rep\xfablica de Chad","common":"Chad"},"swe":{"official":"Republiken Tchad","common":"Tchad"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0686\u0627\u0688","common":"\u0686\u0627\u0688"},"zho":{"official":"\u4E4D\u5F97\u5171\u548C\u56FD","common":"\u4E4D\u5F97"}},"latlng":[15,19],"landlocked":true,"borders":["CMR","CAF","LBY","NER","NGA","SDN"],"area":1284000,"flag":"\uD83C\uDDF9\uD83C\uDDE9","demonyms":{"eng":{"f":"Chadian","m":"Chadian"},"fra":{"f":"Tchadienne","m":"Tchadien"}}},{"name":{"common":"Togo","official":"Togolese Republic","native":{"fra":{"official":"R\xe9publique togolaise","common":"Togo"}}},"tld":[".tg"],"cca2":"TG","ccn3":"768","cca3":"TGO","cioc":"TOG","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"XOF":{"name":"West African CFA franc","symbol":"Fr"}},"idd":{"root":"+2","suffixes":["28"]},"capital":["Lom\xe9"],"altSpellings":["TG","Togolese","Togolese Republic","R\xe9publique Togolaise"],"region":"Africa","subregion":"Western Africa","languages":{"fra":"French"},"translations":{"ces":{"official":"Republika Togo","common":"Togo"},"deu":{"official":"Republik Togo","common":"Togo"},"est":{"official":"Togo Vabariik","common":"Togo"},"fin":{"official":"Togon tasavalta","common":"Togo"},"fra":{"official":"R\xe9publique togolaise","common":"Togo"},"hrv":{"official":"Togolese Republika","common":"Togo"},"hun":{"official":"Tog\xf3i K\xf6zt\xe1rsas\xe1g","common":"Togo"},"ita":{"official":"Repubblica del Togo","common":"Togo"},"jpn":{"official":"\u30C8\u30FC\u30B4\u5171\u548C\u56FD","common":"\u30C8\u30FC\u30B4"},"kor":{"official":"\uD1A0\uACE0 \uACF5\uD654\uAD6D","common":"\uD1A0\uACE0"},"nld":{"official":"Republiek Togo","common":"Togo"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u062A\u0648\u06AF\u0648","common":"\u062A\u0648\u06AF\u0648"},"pol":{"official":"Republika Togijska","common":"Togo"},"por":{"official":"Rep\xfablica do Togo","common":"Togo"},"rus":{"official":"\u0422\u043E\u0433\u043E \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u0422\u043E\u0433\u043E"},"slk":{"official":"Togsk\xe1 republika","common":"Togo"},"spa":{"official":"Rep\xfablica de Togo","common":"Togo"},"swe":{"official":"Republiken Togo","common":"Togo"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0679\u0648\u06AF\u0648","common":"\u0679\u0648\u06AF\u0648"},"zho":{"official":"\u591A\u54E5\u5171\u548C\u56FD","common":"\u591A\u54E5"}},"latlng":[8,1.16666666],"landlocked":false,"borders":["BEN","BFA","GHA"],"area":56785,"flag":"\uD83C\uDDF9\uD83C\uDDEC","demonyms":{"eng":{"f":"Togolese","m":"Togolese"},"fra":{"f":"Togolaise","m":"Togolais"}}},{"name":{"common":"Thailand","official":"Kingdom of Thailand","native":{"tha":{"official":"\u0E23\u0E32\u0E0A\u0E2D\u0E32\u0E13\u0E32\u0E08\u0E31\u0E01\u0E23\u0E44\u0E17\u0E22","common":"\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E44\u0E17\u0E22"}}},"tld":[".th",".\u0E44\u0E17\u0E22"],"cca2":"TH","ccn3":"764","cca3":"THA","cioc":"THA","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"THB":{"name":"Thai baht","symbol":"\u0E3F"}},"idd":{"root":"+6","suffixes":["6"]},"capital":["Bangkok"],"altSpellings":["TH","Prathet","Thai","Kingdom of Thailand","\u0E23\u0E32\u0E0A\u0E2D\u0E32\u0E13\u0E32\u0E08\u0E31\u0E01\u0E23\u0E44\u0E17\u0E22","Ratcha Anachak Thai"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"tha":"Thai"},"translations":{"ces":{"official":"Thajsk\xe9 kr\xe1lovstv\xed","common":"Thajsko"},"deu":{"official":"K\xf6nigreich Thailand","common":"Thailand"},"est":{"official":"Tai Kuningriik","common":"Tai"},"fin":{"official":"Thaimaan kuningaskunta","common":"Thaimaa"},"fra":{"official":"Royaume de Tha\xeflande","common":"Tha\xeflande"},"hrv":{"official":"Kraljevina Tajland","common":"Tajland"},"hun":{"official":"Thaif\xf6ldi Kir\xe1lys\xe1g","common":"Thaif\xf6ld"},"ita":{"official":"Regno di Thailandia","common":"Tailandia"},"jpn":{"official":"\u30BF\u30A4\u738B\u56FD","common":"\u30BF\u30A4"},"kor":{"official":"\uD0C0\uC774 \uC655\uAD6D","common":"\uD0DC\uAD6D"},"nld":{"official":"Koninkrijk Thailand","common":"Thailand"},"per":{"official":"\u067E\u0627\u062F\u0634\u0627\u0647\u06CC \u062A\u0627\u06CC\u0644\u0646\u062F","common":"\u062A\u0627\u06CC\u0644\u0646\u062F"},"pol":{"official":"Kr\xf3lestwo Tajlandii","common":"Tajlandia"},"por":{"official":"Reino da Tail\xe2ndia","common":"Tail\xe2ndia"},"rus":{"official":"\u041A\u043E\u0440\u043E\u043B\u0435\u0432\u0441\u0442\u0432\u043E \u0422\u0430\u0438\u043B\u0430\u043D\u0434","common":"\u0422\u0430\u0438\u043B\u0430\u043D\u0434"},"slk":{"official":"Thajsk\xe9 kr\xe1\u013Eovstvo","common":"Thajsko"},"spa":{"official":"Reino de Tailandia","common":"Tailandia"},"swe":{"official":"Konungariket Thailand","common":"Thailand"},"urd":{"official":"\u0645\u0645\u0644\u06A9\u062A\u0650 \u062A\u06BE\u0627\u0626\u06CC \u0644\u06CC\u0646\u0688","common":"\u062A\u06BE\u0627\u0626\u06CC \u0644\u06CC\u0646\u0688"},"zho":{"official":"\u6CF0\u738B\u56FD","common":"\u6CF0\u56FD"}},"latlng":[15,100],"landlocked":false,"borders":["MMR","KHM","LAO","MYS"],"area":513120,"flag":"\uD83C\uDDF9\uD83C\uDDED","demonyms":{"eng":{"f":"Thai","m":"Thai"},"fra":{"f":"Tha\xeflandaise","m":"Tha\xeflandais"}}},{"name":{"common":"Tajikistan","official":"Republic of Tajikistan","native":{"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0422\u0430\u0434\u0436\u0438\u043A\u0438\u0441\u0442\u0430\u043D","common":"\u0422\u0430\u0434\u0436\u0438\u043A\u0438\u0441\u0442\u0430\u043D"},"tgk":{"official":"\u04B6\u0443\u043C\u04B3\u0443\u0440\u0438\u0438 \u0422\u043E\u04B7\u0438\u043A\u0438\u0441\u0442\u043E\u043D","common":"\u0422\u043E\u04B7\u0438\u043A\u0438\u0441\u0442\u043E\u043D"}}},"tld":[".tj"],"cca2":"TJ","ccn3":"762","cca3":"TJK","cioc":"TJK","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"TJS":{"name":"Tajikistani somoni","symbol":"\u0405\u041C"}},"idd":{"root":"+9","suffixes":["92"]},"capital":["Dushanbe"],"altSpellings":["TJ","To\xe7ikiston","Republic of Tajikistan","\u04B6\u0443\u043C\u04B3\u0443\u0440\u0438\u0438 \u0422\u043E\u04B7\u0438\u043A\u0438\u0441\u0442\u043E\u043D","\xc7umhuriyi To\xe7ikiston"],"region":"Asia","subregion":"Central Asia","languages":{"rus":"Russian","tgk":"Tajik"},"translations":{"ces":{"official":"Republika T\xe1d\u017Eikist\xe1n","common":"T\xe1d\u017Eikist\xe1n"},"deu":{"official":"Republik Tadschikistan","common":"Tadschikistan"},"est":{"official":"Tad\u017Eikistani Vabariik","common":"Tad\u017Eikistan"},"fin":{"official":"Tad\u017Eikistanin tasavalta","common":"Tad\u017Eikistan"},"fra":{"official":"R\xe9publique du Tadjikistan","common":"Tadjikistan"},"hrv":{"official":"Republika Tad\u017Eikistan","common":"Ta\u0111ikistan"},"hun":{"official":"T\xe1dzsik K\xf6zt\xe1rsas\xe1g","common":"T\xe1dzsikiszt\xe1n"},"ita":{"official":"Repubblica del Tajikistan","common":"Tagikistan"},"jpn":{"official":"\u30BF\u30B8\u30AD\u30B9\u30BF\u30F3\u5171\u548C\u56FD","common":"\u30BF\u30B8\u30AD\u30B9\u30BF\u30F3"},"kor":{"official":"\uD0C0\uC9C0\uD0A4\uC2A4\uD0C4 \uACF5\uD654\uAD6D","common":"\uD0C0\uC9C0\uD0A4\uC2A4\uD0C4"},"nld":{"official":"Tadzjikistan","common":"Tadzjikistan"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u062A\u0627\u062C\u06CC\u06A9\u0633\u062A\u0627\u0646","common":"\u062A\u0627\u062C\u06CC\u06A9\u0650\u0633\u062A\u0627\u0646"},"pol":{"official":"Republika Tad\u017Cykistanu","common":"Tad\u017Cykistan"},"por":{"official":"Rep\xfablica do Tajiquist\xe3o","common":"Tajiquist\xe3o"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0422\u0430\u0434\u0436\u0438\u043A\u0438\u0441\u0442\u0430\u043D","common":"\u0422\u0430\u0434\u0436\u0438\u043A\u0438\u0441\u0442\u0430\u043D"},"slk":{"official":"Ta\u01C6ick\xe1 republika","common":"Ta\u01C6ikistan"},"spa":{"official":"Rep\xfablica de Tayikist\xe1n","common":"Tayikist\xe1n"},"swe":{"official":"Republiken Tadzjikistan","common":"Tadzjikistan"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u062A\u0627\u062C\u06A9\u0633\u062A\u0627\u0646","common":"\u062A\u0627\u062C\u06A9\u0633\u062A\u0627\u0646"},"zho":{"official":"\u5854\u5409\u514B\u65AF\u5766\u5171\u548C\u56FD","common":"\u5854\u5409\u514B\u65AF\u5766"}},"latlng":[39,71],"landlocked":true,"borders":["AFG","CHN","KGZ","UZB"],"area":143100,"flag":"\uD83C\uDDF9\uD83C\uDDEF","demonyms":{"eng":{"f":"Tadzhik","m":"Tadzhik"},"fra":{"f":"Tadjike","m":"Tadjike"}}},{"name":{"common":"Tokelau","official":"Tokelau","native":{"eng":{"official":"Tokelau","common":"Tokelau"},"smo":{"official":"Tokelau","common":"Tokelau"},"tkl":{"official":"Tokelau","common":"Tokelau"}}},"tld":[".tk"],"cca2":"TK","ccn3":"772","cca3":"TKL","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"NZD":{"name":"New Zealand dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["90"]},"capital":["Fakaofo"],"altSpellings":["TK"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English","smo":"Samoan","tkl":"Tokelauan"},"translations":{"ces":{"official":"Tokelau","common":"Tokelau"},"deu":{"official":"Tokelau","common":"Tokelau"},"est":{"official":"Tokelau","common":"Tokelau"},"fin":{"official":"Tokelau","common":"Tokelau"},"fra":{"official":"\xceles Tokelau","common":"Tokelau"},"hrv":{"official":"Tokelau","common":"Tokelau"},"hun":{"official":"Tokelau-szigetek","common":"Tokelau-szigetek"},"ita":{"official":"Tokelau","common":"Isole Tokelau"},"jpn":{"official":"\u30C8\u30B1\u30E9\u30A6\u8AF8\u5CF6","common":"\u30C8\u30B1\u30E9\u30A6"},"kor":{"official":"\uD1A0\uCF08\uB77C\uC6B0","common":"\uD1A0\uCF08\uB77C\uC6B0"},"nld":{"official":"Tokelau","common":"Tokelau"},"per":{"official":"\u062A\u0648\u06A9\u0644\u0627\u0626\u0648","common":"\u062A\u0648\u06A9\u0644\u0627\u0626\u0648"},"pol":{"official":"Tokelau","common":"Tokelau"},"por":{"official":"Tokelau","common":"Tokelau"},"rus":{"official":"\u0422\u043E\u043A\u0435\u043B\u0430\u0443","common":"\u0422\u043E\u043A\u0435\u043B\u0430\u0443"},"slk":{"official":"Tokelausk\xe9 ostrovy","common":"Tokelau"},"spa":{"official":"Tokelau","common":"Islas Tokelau"},"swe":{"official":"Tokelau\xf6arna","common":"Tokelau\xf6arna"},"urd":{"official":"\u0679\u0648\u06A9\u06CC\u0644\u0627\u0624","common":"\u0679\u0648\u06A9\u06CC\u0644\u0627\u0624"},"zho":{"official":"\u6258\u514B\u52B3","common":"\u6258\u514B\u52B3"}},"latlng":[-9,-172],"landlocked":false,"borders":[],"area":12,"flag":"\uD83C\uDDF9\uD83C\uDDF0","demonyms":{"eng":{"f":"Tokelauan","m":"Tokelauan"},"fra":{"f":"","m":""}}},{"name":{"common":"Turkmenistan","official":"Turkmenistan","native":{"rus":{"official":"\u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D","common":"\u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u044F"},"tuk":{"official":"T\xfcrkmenistan","common":"T\xfcrkmenistan"}}},"tld":[".tm"],"cca2":"TM","ccn3":"795","cca3":"TKM","cioc":"TKM","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"TMT":{"name":"Turkmenistan manat","symbol":"m"}},"idd":{"root":"+9","suffixes":["93"]},"capital":["Ashgabat"],"altSpellings":["TM"],"region":"Asia","subregion":"Central Asia","languages":{"rus":"Russian","tuk":"Turkmen"},"translations":{"ces":{"official":"Turkmenist\xe1n","common":"Turkmenist\xe1n"},"deu":{"official":"Turkmenistan","common":"Turkmenistan"},"est":{"official":"T\xfcrkmenistan","common":"T\xfcrkmenistan"},"fin":{"official":"Turkmenistan","common":"Turkmenistan"},"fra":{"official":"Turkm\xe9nistan","common":"Turkm\xe9nistan"},"hrv":{"official":"Turkmenistan","common":"Turkmenistan"},"hun":{"official":"T\xfcrkm\xe9n K\xf6zt\xe1rsas\xe1g","common":"T\xfcrkmeniszt\xe1n"},"ita":{"official":"Turkmenistan","common":"Turkmenistan"},"jpn":{"official":"\u30C8\u30EB\u30AF\u30E1\u30CB\u30B9\u30BF\u30F3","common":"\u30C8\u30EB\u30AF\u30E1\u30CB\u30B9\u30BF\u30F3"},"kor":{"official":"\uD22C\uB974\uD06C\uBA54\uB2C8\uC2A4\uD0C4","common":"\uD22C\uB974\uD06C\uBA54\uB2C8\uC2A4\uD0C4"},"nld":{"official":"Turkmenistan","common":"Turkmenistan"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u062E\u0644\u0642 \u062A\u0631\u06A9\u0645\u0646\u0633\u062A\u0627\u0646","common":"\u062A\u0631\u06A9\u0645\u0646\u0633\u062A\u0627\u0646"},"pol":{"official":"Republika Turkmenistanu","common":"Turkmenistan"},"por":{"official":"Turcomenist\xe3o","common":"Turquemenist\xe3o"},"rus":{"official":"\u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D","common":"\u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u044F"},"slk":{"official":"Turkm\xe9nsko","common":"Turkm\xe9nsko"},"spa":{"official":"Turkmenist\xe1n","common":"Turkmenist\xe1n"},"swe":{"official":"Turkmenistan","common":"Turkmenistan"},"urd":{"official":"\u062A\u0631\u06A9\u0645\u0627\u0646\u0633\u062A\u0627\u0646","common":"\u062A\u0631\u06A9\u0645\u0627\u0646\u0633\u062A\u0627\u0646"},"zho":{"official":"\u571F\u5E93\u66FC\u65AF\u5766","common":"\u571F\u5E93\u66FC\u65AF\u5766"}},"latlng":[40,60],"landlocked":true,"borders":["AFG","IRN","KAZ","UZB"],"area":488100,"flag":"\uD83C\uDDF9\uD83C\uDDF2","demonyms":{"eng":{"f":"Turkmen","m":"Turkmen"},"fra":{"f":"Turkm\xe8ne","m":"Turkm\xe8ne"}}},{"name":{"common":"Timor-Leste","official":"Democratic Republic of Timor-Leste","native":{"por":{"official":"Rep\xfablica Democr\xe1tica de Timor-Leste","common":"Timor-Leste"},"tet":{"official":"Rep\xfablika Demokr\xe1tika Tim\xf3r-Leste","common":"Tim\xf3r-Leste"}}},"tld":[".tl"],"cca2":"TL","ccn3":"626","cca3":"TLS","cioc":"TLS","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["70"]},"capital":["Dili"],"altSpellings":["TL","East Timor","Democratic Republic of Timor-Leste","Rep\xfablica Democr\xe1tica de Timor-Leste","Rep\xfablika Demokr\xe1tika Tim\xf3r-Leste","Tim\xf3r Lorosa\'e","Timor Lorosae"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"por":"Portuguese","tet":"Tetum"},"translations":{"ces":{"official":"Demokratick\xe1 republika V\xfdchodn\xed Timor","common":"V\xfdchodn\xed Timor"},"deu":{"official":"Demokratische Republik Timor-Leste","common":"Osttimor"},"est":{"official":"Timor-Leste Demokraatlik Vabariik","common":"Ida-Timor"},"fin":{"official":"It\xe4-Timorin demokraattinen tasavalta","common":"It\xe4-Timor"},"fra":{"official":"R\xe9publique d\xe9mocratique du Timor oriental","common":"Timor oriental"},"hrv":{"official":"Demokratska Republika Timor-Leste","common":"Isto\u010Dni Timor"},"hun":{"official":"Kelet-timori Demokratikus K\xf6zt\xe1rsas\xe1g","common":"Kelet-Timor"},"ita":{"official":"Repubblica Democratica di Timor Est","common":"Timor Est"},"jpn":{"official":"\u6771\u30C6\u30A3\u30E2\u30FC\u30EB\u6C11\u4E3B\u5171\u548C\u56FD","common":"\u6771\u30C6\u30A3\u30E2\u30FC\u30EB"},"kor":{"official":"\uB3D9\uD2F0\uBAA8\uB974 \uBBFC\uC8FC \uACF5\uD654\uAD6D","common":"\uB3D9\uD2F0\uBAA8\uB974"},"nld":{"official":"Democratische Republiek Oost-Timor","common":"Oost-Timor"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u062F\u0645\u0648\u06A9\u0631\u0627\u062A\u06CC\u06A9 \u062A\u06CC\u0645\u0648\u0631 \u0634\u0631\u0642\u06CC","common":"\u062A\u06CC\u0645\u0648\u0631 \u0634\u0631\u0642\u06CC"},"pol":{"official":"Demokratyczna Republika Timoru Wschodniego","common":"Timor Wschodni"},"por":{"official":"Rep\xfablica Democr\xe1tica de Timor-Leste","common":"Timor-Leste"},"rus":{"official":"\u0414\u0435\u043C\u043E\u043A\u0440\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0422\u0438\u043C\u043E\u0440 -\u041B\u0435\u0448\u0442\u0438","common":"\u0412\u043E\u0441\u0442\u043E\u0447\u043D\u044B\u0439 \u0422\u0438\u043C\u043E\u0440"},"slk":{"official":"V\xfdchodotimorsk\xe1 demokratick\xe1 republika","common":"V\xfdchodn\xfd Timor"},"spa":{"official":"Rep\xfablica Democr\xe1tica de Timor-Leste","common":"Timor Oriental"},"swe":{"official":"Demokratiska republiken \xd6sttimor","common":"\xd6sttimor"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0645\u0634\u0631\u0642\u06CC \u062A\u06CC\u0645\u0648\u0631","common":"\u0645\u0634\u0631\u0642\u06CC \u062A\u06CC\u0645\u0648\u0631"},"zho":{"official":"\u4E1C\u5E1D\u6C76\u6C11\u4E3B\u5171\u548C\u56FD","common":"\u4E1C\u5E1D\u6C76"}},"latlng":[-8.83333333,125.91666666],"landlocked":false,"borders":["IDN"],"area":14874,"flag":"\uD83C\uDDF9\uD83C\uDDF1","demonyms":{"eng":{"f":"East Timorese","m":"East Timorese"},"fra":{"f":"Est-timoraise","m":"Est-timorais"}}},{"name":{"common":"Tonga","official":"Kingdom of Tonga","native":{"eng":{"official":"Kingdom of Tonga","common":"Tonga"},"ton":{"official":"Kingdom of Tonga","common":"Tonga"}}},"tld":[".to"],"cca2":"TO","ccn3":"776","cca3":"TON","cioc":"TGA","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"TOP":{"name":"Tongan pa\u02BBanga","symbol":"T$"}},"idd":{"root":"+6","suffixes":["76"]},"capital":["Nuku\'alofa"],"altSpellings":["TO"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English","ton":"Tongan"},"translations":{"ces":{"official":"Kr\xe1lovstv\xed Tonga","common":"Tonga"},"deu":{"official":"K\xf6nigreich Tonga","common":"Tonga"},"est":{"official":"Tonga Kuningriik","common":"Tonga"},"fin":{"official":"Tongan kuningaskunta","common":"Tonga"},"fra":{"official":"Royaume des Tonga","common":"Tonga"},"hrv":{"official":"Kraljevina Tonga","common":"Tonga"},"hun":{"official":"Tongai Kir\xe1lys\xe1g","common":"Tonga"},"ita":{"official":"Regno di Tonga","common":"Tonga"},"jpn":{"official":"\u30C8\u30F3\u30AC\u738B\u56FD","common":"\u30C8\u30F3\u30AC"},"kor":{"official":"\uD1B5\uAC00 \uC655\uAD6D","common":"\uD1B5\uAC00"},"nld":{"official":"Koninkrijk Tonga","common":"Tonga"},"per":{"official":"\u067E\u0627\u062F\u0634\u0627\u0647\u06CC \u062A\u0648\u0646\u06AF\u0627","common":"\u062A\u0648\u0646\u06AF\u0627"},"pol":{"official":"Kr\xf3lestwo Tonga","common":"Tonga"},"por":{"official":"Reino de Tonga","common":"Tonga"},"rus":{"official":"\u041A\u043E\u0440\u043E\u043B\u0435\u0432\u0441\u0442\u0432\u043E \u0422\u043E\u043D\u0433\u0430","common":"\u0422\u043E\u043D\u0433\u0430"},"slk":{"official":"Tongsk\xe9 kr\xe1\u013Eovstvo","common":"Tonga"},"spa":{"official":"Reino de Tonga","common":"Tonga"},"swe":{"official":"Konungariket Tonga","common":"Tonga"},"urd":{"official":"\u0645\u0645\u0644\u06A9\u062A\u0650 \u0679\u0648\u0646\u06AF\u0627","common":"\u0679\u0648\u0646\u06AF\u0627"},"zho":{"official":"\u6C64\u52A0\u738B\u56FD","common":"\u6C64\u52A0"}},"latlng":[-20,-175],"landlocked":false,"borders":[],"area":747,"flag":"\uD83C\uDDF9\uD83C\uDDF4","demonyms":{"eng":{"f":"Tongan","m":"Tongan"},"fra":{"f":"Tonguienne","m":"Tonguien"}}},{"name":{"common":"Trinidad and Tobago","official":"Republic of Trinidad and Tobago","native":{"eng":{"official":"Republic of Trinidad and Tobago","common":"Trinidad and Tobago"}}},"tld":[".tt"],"cca2":"TT","ccn3":"780","cca3":"TTO","cioc":"TTO","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"TTD":{"name":"Trinidad and Tobago dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["868"]},"capital":["Port of Spain"],"altSpellings":["TT","Republic of Trinidad and Tobago"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Republika Trinidad a Tobago","common":"Trinidad a Tobago"},"deu":{"official":"Republik Trinidad und Tobago","common":"Trinidad und Tobago"},"est":{"official":"Trinidadi ja Tobago Vabariik","common":"Trinidad ja Tobago"},"fin":{"official":"Trinidadin ja Tobagon tasavalta","common":"Trinidad ja Tobago"},"fra":{"official":"R\xe9publique de Trinit\xe9-et-Tobago","common":"Trinit\xe9-et-Tobago"},"hrv":{"official":"Republika Trinidad i Tobago","common":"Trinidad i Tobago"},"hun":{"official":"Trinidad \xe9s Tobago K\xf6zt\xe1rsas\xe1g","common":"Trinidad \xe9s Tobago"},"ita":{"official":"Repubblica di Trinidad e Tobago","common":"Trinidad e Tobago"},"jpn":{"official":"\u30C8\u30EA\u30CB\u30C0\u30FC\u30C9\xb7\u30C8\u30D0\u30B4\u5171\u548C\u56FD","common":"\u30C8\u30EA\u30CB\u30C0\u30FC\u30C9\u30FB\u30C8\u30D0\u30B4"},"kor":{"official":"\uD2B8\uB9AC\uB2C8\uB2E4\uB4DC \uD1A0\uBC14\uACE0 \uACF5\uD654\uAD6D","common":"\uD2B8\uB9AC\uB2C8\uB2E4\uB4DC \uD1A0\uBC14\uACE0"},"nld":{"official":"Republiek Trinidad en Tobago","common":"Trinidad en Tobago"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u062A\u0631\u06CC\u0646\u06CC\u062F\u0627\u062F \u0648 \u062A\u0648\u0628\u0627\u06AF\u0648","common":"\u062A\u0631\u06CC\u0646\u06CC\u062F\u0627\u062F \u0648 \u062A\u0648\u0628\u0627\u06AF\u0648"},"pol":{"official":"Trynidad i Tobago","common":"Trynidad i Tobago"},"por":{"official":"Rep\xfablica de Trinidad e Tobago","common":"Trinidade e Tobago"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0422\u0440\u0438\u043D\u0438\u0434\u0430\u0434 \u0438 \u0422\u043E\u0431\u0430\u0433\u043E","common":"\u0422\u0440\u0438\u043D\u0438\u0434\u0430\u0434 \u0438 \u0422\u043E\u0431\u0430\u0433\u043E"},"slk":{"official":"Republika Trinidad a Tobaga","common":"Trinidad a Tobago"},"spa":{"official":"Rep\xfablica de Trinidad y Tobago","common":"Trinidad y Tobago"},"swe":{"official":"Republiken Trinidad och Tobago","common":"Trinidad och Tobago"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0679\u0631\u06CC\u0646\u06CC\u0688\u0627\u0688 \u0648 \u0679\u0648\u0628\u0627\u06AF\u0648","common":"\u0679\u0631\u06CC\u0646\u06CC\u0688\u0627\u0688 \u0648 \u0679\u0648\u0628\u0627\u06AF\u0648"},"zho":{"official":"\u7279\u7ACB\u5C3C\u8FBE\u548C\u591A\u5DF4\u54E5\u5171\u548C\u56FD","common":"\u7279\u7ACB\u5C3C\u8FBE\u548C\u591A\u5DF4\u54E5"}},"latlng":[11,-61],"landlocked":false,"borders":[],"area":5130,"flag":"\uD83C\uDDF9\uD83C\uDDF9","demonyms":{"eng":{"f":"Trinidadian","m":"Trinidadian"},"fra":{"f":"Trinidadienne","m":"Trinidadien"}}},{"name":{"common":"Tunisia","official":"Tunisian Republic","native":{"ara":{"official":"\u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u062A\u0648\u0646\u0633\u064A\u0629","common":"\u062A\u0648\u0646\u0633"}}},"tld":[".tn"],"cca2":"TN","ccn3":"788","cca3":"TUN","cioc":"TUN","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"TND":{"name":"Tunisian dinar","symbol":"\u062F.\u062A"}},"idd":{"root":"+2","suffixes":["16"]},"capital":["Tunis"],"altSpellings":["TN","Republic of Tunisia","al-Jumh\u016Briyyah at-T\u016Bnisiyyah"],"region":"Africa","subregion":"Northern Africa","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Tunisk\xe1 republika","common":"Tunisko"},"deu":{"official":"Tunesische Republik","common":"Tunesien"},"est":{"official":"Tuneesia Vabariik","common":"Tuneesia"},"fin":{"official":"Tunisian tasavalta","common":"Tunisia"},"fra":{"official":"R\xe9publique tunisienne","common":"Tunisie"},"hrv":{"official":"Tuniski Republika","common":"Tunis"},"hun":{"official":"Tun\xe9ziai K\xf6zt\xe1rsas\xe1g","common":"Tun\xe9zia"},"ita":{"official":"Repubblica tunisina","common":"Tunisia"},"jpn":{"official":"\u30C1\u30E5\u30CB\u30B8\u30A2\u5171\u548C\u56FD","common":"\u30C1\u30E5\u30CB\u30B8\u30A2"},"kor":{"official":"\uD280\uB2C8\uC9C0 \uACF5\uD654\uAD6D","common":"\uD280\uB2C8\uC9C0"},"nld":{"official":"Republiek Tunesi\xeb","common":"Tunesi\xeb"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u062A\u0648\u0646\u0633","common":"\u062A\u0648\u0646\u0633"},"pol":{"official":"Republika Tunezyjska","common":"Tunezja"},"por":{"official":"Rep\xfablica da Tun\xedsia","common":"Tun\xedsia"},"rus":{"official":"\u0422\u0443\u043D\u0438\u0441\u0441\u043A\u043E\u0439 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0438","common":"\u0422\u0443\u043D\u0438\u0441"},"slk":{"official":"Tunisk\xe1 republika","common":"Tunisko"},"spa":{"official":"Rep\xfablica de T\xfanez","common":"T\xfanez"},"swe":{"official":"Republiken Tunisien","common":"Tunisien"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u062A\u0648\u0646\u0633","common":"\u062A\u0648\u0646\u0633"},"zho":{"official":"\u7A81\u5C3C\u65AF\u5171\u548C\u56FD","common":"\u7A81\u5C3C\u65AF"}},"latlng":[34,9],"landlocked":false,"borders":["DZA","LBY"],"area":163610,"flag":"\uD83C\uDDF9\uD83C\uDDF3","demonyms":{"eng":{"f":"Tunisian","m":"Tunisian"},"fra":{"f":"Tunisienne","m":"Tunisien"}}},{"name":{"common":"Turkey","official":"Republic of T\xfcrkiye","native":{"tur":{"official":"T\xfcrkiye Cumhuriyeti","common":"T\xfcrkiye"}}},"tld":[".tr"],"cca2":"TR","ccn3":"792","cca3":"TUR","cioc":"TUR","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"TRY":{"name":"Turkish lira","symbol":"\u20BA"}},"idd":{"root":"+9","suffixes":["0"]},"capital":["Ankara"],"altSpellings":["TR","Turkiye","Republic of Turkey","T\xfcrkiye Cumhuriyeti"],"region":"Asia","subregion":"Western Asia","languages":{"tur":"Turkish"},"translations":{"ces":{"official":"Tureck\xe1 republika","common":"Turecko"},"deu":{"official":"Republik T\xfcrkei","common":"T\xfcrkei"},"est":{"official":"T\xfcrgi Vabariik","common":"T\xfcrgi"},"fin":{"official":"Turkin tasavalta","common":"Turkki"},"fra":{"official":"R\xe9publique de Turquie","common":"Turquie"},"hrv":{"official":"Republika Turska","common":"Turska"},"hun":{"official":"T\xf6r\xf6k K\xf6zt\xe1rsas\xe1g","common":"T\xf6r\xf6korsz\xe1g"},"ita":{"official":"Repubblica di Turchia","common":"Turchia"},"jpn":{"official":"\u30C8\u30EB\u30B3\u5171\u548C\u56FD","common":"\u30C8\u30EB\u30B3"},"kor":{"official":"\uD130\uD0A4 \uACF5\uD654\uAD6D","common":"\uD130\uD0A4"},"nld":{"official":"Republiek Turkije","common":"Turkije"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u062A\u0631\u06A9\u06CC\u0647","common":"\u062A\u0631\u06A9\u06CC\u0647"},"pol":{"official":"Republika Turcji","common":"Turcja"},"por":{"official":"Rep\xfablica da Turquia","common":"Turquia"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0422\u0443\u0440\u0446\u0438\u0438","common":"\u0422\u0443\u0440\u0446\u0438\u044F"},"slk":{"official":"Tureck\xe1 republika","common":"Turecko"},"spa":{"official":"Rep\xfablica de Turqu\xeda","common":"Turqu\xeda"},"swe":{"official":"Republiken Turkiet","common":"Turkiet"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u062A\u0631\u06A9\u06CC","common":"\u062A\u0631\u06A9\u06CC"},"zho":{"official":"\u571F\u8033\u5176\u5171\u548C\u56FD","common":"\u571F\u8033\u5176"}},"latlng":[39,35],"landlocked":false,"borders":["ARM","AZE","BGR","GEO","GRC","IRN","IRQ","SYR"],"area":783562,"flag":"\uD83C\uDDF9\uD83C\uDDF7","demonyms":{"eng":{"f":"Turkish","m":"Turkish"},"fra":{"f":"Turque","m":"Turc"}}},{"name":{"common":"Tuvalu","official":"Tuvalu","native":{"eng":{"official":"Tuvalu","common":"Tuvalu"},"tvl":{"official":"Tuvalu","common":"Tuvalu"}}},"tld":[".tv"],"cca2":"TV","ccn3":"798","cca3":"TUV","cioc":"TUV","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"AUD":{"name":"Australian dollar","symbol":"$"},"TVD":{"name":"Tuvaluan dollar","symbol":"$"}},"idd":{"root":"+6","suffixes":["88"]},"capital":["Funafuti"],"altSpellings":["TV"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English","tvl":"Tuvaluan"},"translations":{"ces":{"official":"Tuvalu","common":"Tuvalu"},"deu":{"official":"Tuvalu","common":"Tuvalu"},"est":{"official":"Tuvalu","common":"Tuvalu"},"fin":{"official":"Tuvalu","common":"Tuvalu"},"fra":{"official":"Tuvalu","common":"Tuvalu"},"hrv":{"official":"Tuvalu","common":"Tuvalu"},"hun":{"official":"Tuvalu","common":"Tuvalu"},"ita":{"official":"Tuvalu","common":"Tuvalu"},"jpn":{"official":"\u30C4\u30D0\u30EB","common":"\u30C4\u30D0\u30EB"},"kor":{"official":"\uD22C\uBC1C\uB8E8","common":"\uD22C\uBC1C\uB8E8"},"nld":{"official":"Tuvalu","common":"Tuvalu"},"per":{"official":"\u062A\u0648\u0648\u0627\u0644\u0648","common":"\u062A\u0648\u0648\u0627\u0644\u0648"},"pol":{"official":"Tuvalu","common":"Tuvalu"},"por":{"official":"Tuvalu","common":"Tuvalu"},"rus":{"official":"\u0422\u0443\u0432\u0430\u043B\u0443","common":"\u0422\u0443\u0432\u0430\u043B\u0443"},"slk":{"official":"Tuvalu","common":"Tuvalu"},"spa":{"official":"Tuvalu","common":"Tuvalu"},"swe":{"official":"Tuvalu","common":"Tuvalu"},"urd":{"official":"\u062A\u0648\u0648\u0627\u0644\u0648","common":"\u062A\u0648\u0648\u0627\u0644\u0648"},"zho":{"official":"\u56FE\u74E6\u5362","common":"\u56FE\u74E6\u5362"}},"latlng":[-8,178],"landlocked":false,"borders":[],"area":26,"flag":"\uD83C\uDDF9\uD83C\uDDFB","demonyms":{"eng":{"f":"Tuvaluan","m":"Tuvaluan"},"fra":{"f":"Tuvaluane","m":"Tuvaluan"}}},{"name":{"common":"Taiwan","official":"Republic of China (Taiwan)","native":{"zho":{"official":"\u4E2D\u83EF\u6C11\u570B","common":"\u53F0\u7063"}}},"tld":[".tw",".\u53F0\u7063",".\u53F0\u6E7E"],"cca2":"TW","ccn3":"158","cca3":"TWN","cioc":"TPE","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"TWD":{"name":"New Taiwan dollar","symbol":"$"}},"idd":{"root":"+8","suffixes":["86"]},"capital":["Taipei"],"altSpellings":["TW","T\xe1iw\u0101n","Republic of China","\u4E2D\u83EF\u6C11\u570B","Zh\u014Dnghu\xe1 M\xedngu\xf3","Chinese Taipei"],"region":"Asia","subregion":"Eastern Asia","languages":{"zho":"Chinese"},"translations":{"ces":{"official":"\u010C\xednsk\xe1 republika","common":"Tchaj-wan"},"deu":{"official":"Republik China (Taiwan)","common":"Taiwan"},"est":{"official":"Taiwani","common":"Taiwan"},"fin":{"official":"Kiinan tasavalta","common":"Taiwan"},"fra":{"official":"R\xe9publique de Chine (Ta\xefwan)","common":"Ta\xefwan"},"hrv":{"official":"Republika Kina","common":"Tajvan"},"hun":{"official":"K\xednai K\xf6zt\xe1rsas\xe1g","common":"Tajvan"},"ita":{"official":"Repubblica cinese (Taiwan)","common":"Taiwan"},"jpn":{"official":"\u4E2D\u83EF\u6C11\u56FD","common":"\u53F0\u6E7E"},"kor":{"official":"\uC911\uD654\uBBFC\uAD6D","common":"\uB300\uB9CC"},"nld":{"official":"Republiek China (Taiwan)","common":"Taiwan"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0686\u06CC\u0646","common":"\u062A\u0627\u06CC\u0648\u0627\u0646"},"pol":{"official":"Republika Chi\u0144ska (Tajwan)","common":"Tajwan"},"por":{"official":"Rep\xfablica da China","common":"Ilha Formosa"},"rus":{"official":"\u041A\u0438\u0442\u0430\u0439\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u0422\u0430\u0439\u0432\u0430\u043D\u044C"},"slk":{"official":"\u010C\xednska republika","common":"Taiwan"},"spa":{"official":"Rep\xfablica de China en Taiw\xe1n","common":"Taiw\xe1n"},"swe":{"official":"Republiken Kina","common":"Taiwan"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0686\u06CC\u0646 (\u062A\u0627\u0626\u06CC\u0648\u0627\u0646)","common":"\u062A\u0627\u0626\u06CC\u0648\u0627\u0646"}},"latlng":[23.5,121],"landlocked":false,"borders":[],"area":36193,"flag":"\uD83C\uDDF9\uD83C\uDDFC","demonyms":{"eng":{"f":"Taiwanese","m":"Taiwanese"},"fra":{"f":"Ta\xefwanaise","m":"Ta\xefwanais"}}},{"name":{"common":"Tanzania","official":"United Republic of Tanzania","native":{"eng":{"official":"United Republic of Tanzania","common":"Tanzania"},"swa":{"official":"Jamhuri ya Muungano wa Tanzania","common":"Tanzania"}}},"tld":[".tz"],"cca2":"TZ","ccn3":"834","cca3":"TZA","cioc":"TAN","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"TZS":{"name":"Tanzanian shilling","symbol":"Sh"}},"idd":{"root":"+2","suffixes":["55"]},"capital":["Dodoma"],"altSpellings":["TZ","Tanzania, United Republic of","United Republic of Tanzania","Jamhuri ya Muungano wa Tanzania"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English","swa":"Swahili"},"translations":{"ces":{"official":"Sjednocen\xe1 tanzansk\xe1 republika","common":"Tanzanie"},"deu":{"official":"Vereinigte Republik Tansania","common":"Tansania"},"est":{"official":"Tansaania \xdchendvabariik","common":"Tansaania"},"fin":{"official":"Tansanian yhdistynyt tasavalta","common":"Tansania"},"fra":{"official":"R\xe9publique -Unie de Tanzanie","common":"Tanzanie"},"hrv":{"official":"Ujedinjena Republika Tanzanija","common":"Tanzanija"},"hun":{"official":"T\xe1dzsik K\xf6zt\xe1rsas\xe1g","common":"T\xe1dzsikiszt\xe1n"},"ita":{"official":"Repubblica Unita di Tanzania","common":"Tanzania"},"jpn":{"official":"\u30BF\u30F3\u30B6\u30CB\u30A2\u9023\u5408\u5171\u548C\u56FD","common":"\u30BF\u30F3\u30B6\u30CB\u30A2"},"kor":{"official":"\uD0C4\uC790\uB2C8\uC544 \uC5F0\uD569 \uACF5\uD654\uAD6D","common":"\uD0C4\uC790\uB2C8\uC544"},"nld":{"official":"Verenigde Republiek Tanzania","common":"Tanzania"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0645\u062A\u062D\u062F \u062A\u0627\u0646\u0632\u0627\u0646\u06CC\u0627","common":"\u062A\u0627\u0646\u0632\u0627\u0646\u06CC\u0627"},"pol":{"official":"Zjednoczona Republika Tanzanii","common":"Tanzania"},"por":{"official":"Rep\xfablica Unida da Tanz\xe2nia","common":"Tanz\xe2nia"},"rus":{"official":"\u041E\u0431\u044A\u0435\u0434\u0438\u043D\u0435\u043D\u043D\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0422\u0430\u043D\u0437\u0430\u043D\u0438\u044F","common":"\u0422\u0430\u043D\u0437\u0430\u043D\u0438\u044F"},"slk":{"official":"Tanz\xe1nijsk\xe1 zjednoten\xe1 republika","common":"Tanz\xe1nia"},"spa":{"official":"Rep\xfablica Unida de Tanzania","common":"Tanzania"},"swe":{"official":"F\xf6renade republiken Tanzania","common":"Tanzania"},"urd":{"official":"\u0645\u062A\u062D\u062F\u06C1 \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u062A\u0646\u0632\u0627\u0646\u06CC\u06C1","common":"\u062A\u0646\u0632\u0627\u0646\u06CC\u06C1"},"zho":{"official":"\u5766\u6851\u5C3C\u4E9A\u8054\u5408\u5171\u548C\u56FD","common":"\u5766\u6851\u5C3C\u4E9A"}},"latlng":[-6,35],"landlocked":false,"borders":["BDI","COD","KEN","MWI","MOZ","RWA","UGA","ZMB"],"area":945087,"flag":"\uD83C\uDDF9\uD83C\uDDFF","demonyms":{"eng":{"f":"Tanzanian","m":"Tanzanian"},"fra":{"f":"Tanzanienne","m":"Tanzanien"}}},{"name":{"common":"Uganda","official":"Republic of Uganda","native":{"eng":{"official":"Republic of Uganda","common":"Uganda"},"swa":{"official":"Republic of Uganda","common":"Uganda"}}},"tld":[".ug"],"cca2":"UG","ccn3":"800","cca3":"UGA","cioc":"UGA","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"UGX":{"name":"Ugandan shilling","symbol":"Sh"}},"idd":{"root":"+2","suffixes":["56"]},"capital":["Kampala"],"altSpellings":["UG","Republic of Uganda","Jamhuri ya Uganda"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English","swa":"Swahili"},"translations":{"ces":{"official":"Ugandsk\xe1 republika","common":"Uganda"},"deu":{"official":"Republik Uganda","common":"Uganda"},"est":{"official":"Uganda Vabariik","common":"Uganda"},"fin":{"official":"Ugandan tasavalta","common":"Uganda"},"fra":{"official":"R\xe9publique de l\'Ouganda","common":"Ouganda"},"hrv":{"official":"Republika Uganda","common":"Uganda"},"hun":{"official":"Ugandai K\xf6zt\xe1rsas\xe1g","common":"Uganda"},"ita":{"official":"Repubblica di Uganda","common":"Uganda"},"jpn":{"official":"\u30A6\u30AC\u30F3\u30C0\u5171\u548C\u56FD","common":"\u30A6\u30AC\u30F3\u30C0"},"kor":{"official":"\uC6B0\uAC04\uB2E4 \uACF5\uD654\uAD6D","common":"\uC6B0\uAC04\uB2E4"},"nld":{"official":"Republiek Uganda","common":"Oeganda"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0648\u06AF\u0627\u0646\u062F\u0627","common":"\u0627\u0648\u06AF\u0627\u0646\u062F\u0627"},"pol":{"official":"Republika Ugandy","common":"Uganda"},"por":{"official":"Rep\xfablica do Uganda","common":"Uganda"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0423\u0433\u0430\u043D\u0434\u0430","common":"\u0423\u0433\u0430\u043D\u0434\u0430"},"slk":{"official":"Ugandsk\xe1 republika","common":"Uganda"},"spa":{"official":"Rep\xfablica de Uganda","common":"Uganda"},"swe":{"official":"Republiken Uganda","common":"Uganda"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06CC\u0648\u06AF\u0646\u0688\u0627","common":"\u06CC\u0648\u06AF\u0646\u0688\u0627"},"zho":{"official":"\u4E4C\u5E72\u8FBE\u5171\u548C\u56FD","common":"\u4E4C\u5E72\u8FBE"}},"latlng":[1,32],"landlocked":true,"borders":["COD","KEN","RWA","SSD","TZA"],"area":241550,"flag":"\uD83C\uDDFA\uD83C\uDDEC","demonyms":{"eng":{"f":"Ugandan","m":"Ugandan"},"fra":{"f":"Ougandaise","m":"Ougandais"}}},{"name":{"common":"Ukraine","official":"Ukraine","native":{"ukr":{"official":"\u0423\u043A\u0440\u0430\u0457\u043D\u0430","common":"\u0423\u043A\u0440\u0430\u0457\u043D\u0430"}}},"tld":[".ua",".\u0443\u043A\u0440"],"cca2":"UA","ccn3":"804","cca3":"UKR","cioc":"UKR","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"UAH":{"name":"Ukrainian hryvnia","symbol":"\u20B4"}},"idd":{"root":"+3","suffixes":["80"]},"capital":["Kyiv"],"altSpellings":["UA","Ukrayina"],"region":"Europe","subregion":"Eastern Europe","languages":{"ukr":"Ukrainian"},"translations":{"ces":{"official":"Ukrajina","common":"Ukrajina"},"deu":{"official":"Ukraine","common":"Ukraine"},"est":{"official":"Ukraina","common":"Ukraina"},"fin":{"official":"Ukraina","common":"Ukraina"},"fra":{"official":"Ukraine","common":"Ukraine"},"hrv":{"official":"Ukrajina","common":"Ukrajina"},"hun":{"official":"Ukrajna","common":"Ukrajna"},"ita":{"official":"Ucraina","common":"Ucraina"},"jpn":{"official":"\u30A6\u30AF\u30E9\u30A4\u30CA","common":"\u30A6\u30AF\u30E9\u30A4\u30CA"},"kor":{"official":"\uC6B0\uD06C\uB77C\uC774\uB098","common":"\uC6B0\uD06C\uB77C\uC774\uB098"},"nld":{"official":"Oekra\xefne","common":"Oekra\xefne"},"per":{"official":"\u0627\u0648\u06A9\u0631\u0627\u06CC\u0646","common":"\u0627\u0648\u06A9\u0631\u0627\u06CC\u0646"},"pol":{"official":"Ukraina","common":"Ukraina"},"por":{"official":"Ucr\xe2nia","common":"Ucr\xe2nia"},"rus":{"official":"\u0423\u043A\u0440\u0430\u0438\u043D\u0430","common":"\u0423\u043A\u0440\u0430\u0438\u043D\u0430"},"slk":{"official":"Ukrajina","common":"Ukrajina"},"spa":{"official":"Ucrania","common":"Ucrania"},"swe":{"official":"Ukraina","common":"Ukraina"},"urd":{"official":"\u06CC\u0648\u06A9\u0631\u06CC\u0646","common":"\u06CC\u0648\u06A9\u0631\u06CC\u0646"},"zho":{"official":"\u4E4C\u514B\u5170","common":"\u4E4C\u514B\u5170"}},"latlng":[49,32],"landlocked":false,"borders":["BLR","HUN","MDA","POL","ROU","RUS","SVK"],"area":603500,"flag":"\uD83C\uDDFA\uD83C\uDDE6","demonyms":{"eng":{"f":"Ukrainian","m":"Ukrainian"},"fra":{"f":"Ukrainienne","m":"Ukrainien"}}},{"name":{"common":"United States Minor Outlying Islands","official":"United States Minor Outlying Islands","native":{"eng":{"official":"United States Minor Outlying Islands","common":"United States Minor Outlying Islands"}}},"tld":[".us"],"cca2":"UM","ccn3":"581","cca3":"UMI","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+2","suffixes":["68"]},"capital":[],"altSpellings":["UM"],"region":"Americas","subregion":"North America","languages":{"eng":"English"},"translations":{"ces":{"official":"Men\u0161\xed odlehl\xe9 ostrovy Spojen\xfdch st\xe1t\u016F americk\xfdch","common":"Men\u0161\xed odlehl\xe9 ostrovy USA"},"deu":{"official":"USA, kleinere ausgelagerte Inseln","common":"Kleinere Inselbesitzungen der Vereinigten Staaten"},"est":{"official":"\xdchendriikide v\xe4ikesed hajasaared","common":"\xdchendriikide hajasaared"},"fin":{"official":"Yhdysvaltain asumattomat saaret","common":"Yhdysvaltain asumattomat saaret"},"fra":{"official":"\xceles mineures \xe9loign\xe9es des \xc9tats-Unis","common":"\xceles mineures \xe9loign\xe9es des \xc9tats-Unis"},"hrv":{"official":"Mali udaljeni otoci SAD-a","common":"Mali udaljeni otoci SAD-a"},"hun":{"official":"Az Amerikai Egyes\xfclt \xc1llamok lakatlan k\xfclbirtokai","common":"Az Amerikai Egyes\xfclt \xc1llamok lakatlan k\xfclbirtokai"},"ita":{"official":"Stati Uniti Isole Minori","common":"Isole minori esterne degli Stati Uniti d\'America"},"jpn":{"official":"\u30A2\u30E1\u30EA\u30AB\u5408\u8846\u56FD\u5916\u8AF8\u5CF6","common":"\u5408\u8846\u56FD\u9818\u6709\u5C0F\u96E2\u5CF6"},"kor":{"official":"\uBBF8\uAD6D\uB839 \uAD70\uC18C \uC81C\uB3C4","common":"\uBBF8\uAD6D\uB839 \uAD70\uC18C \uC81C\uB3C4"},"nld":{"official":"Kleine afgelegen eilanden van de Verenigde Staten","common":"Kleine afgelegen eilanden van de Verenigde Staten"},"per":{"official":"\u062C\u0632\u0627\u06CC\u0631 \u06A9\u0648\u0686\u06A9 \u062D\u0627\u0634\u06CC\u0647\u200C\u0627\u06CC \u0627\u06CC\u0627\u0644\u0627\u062A \u0645\u062A\u062D\u062F\u0647 \u0622\u0645\u0631\u06CC\u06A9\u0627","common":"\u062C\u0632\u0627\u06CC\u0631 \u06A9\u0648\u0686\u06A9 \u062D\u0627\u0634\u06CC\u0647\u200C\u0627\u06CC \u0627\u06CC\u0627\u0644\u0627\u062A \u0645\u062A\u062D\u062F\u0647 \u0622\u0645\u0631\u06CC\u06A9\u0627"},"pol":{"official":"Dalekie Wyspy Mniejsze Stan\xf3w Zjednoczonych","common":"Dalekie Wyspy Mniejsze Stan\xf3w Zjednoczonych"},"por":{"official":"Estados Unidos Ilhas Menores Distantes","common":"Ilhas Menores Distantes dos Estados Unidos"},"rus":{"official":"\u0412\u043D\u0435\u0448\u043D\u0438\u0435 \u043C\u0430\u043B\u044B\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430 \u0421\u0428\u0410","common":"\u0412\u043D\u0435\u0448\u043D\u0438\u0435 \u043C\u0430\u043B\u044B\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430 \u0421\u0428\u0410"},"slk":{"official":"Men\u0161ie od\u013Eahl\xe9 ostrovy Spjoen\xfdch \u0161t\xe1tov","common":"Men\u0161ie od\u013Eahl\xe9 ostrovy USA"},"spa":{"official":"Estados Unidos Islas menores alejadas de","common":"Islas Ultramarinas Menores de Estados Unidos"},"swe":{"official":"F\xf6renta staternas mindre \xf6ar i Oceanien och V\xe4stindien","common":"F\xf6renta staternas mindre \xf6ar i Oceanien och V\xe4stindien"},"urd":{"official":"\u0627\u0645\u0631\u06CC\u06A9\u06CC \u0686\u06BE\u0648\u0679\u06D2 \u0628\u06CC\u0631\u0648\u0646\u06CC \u062C\u0632\u0627\u0626\u0631","common":"\u0627\u0645\u0631\u06CC\u06A9\u06CC \u0686\u06BE\u0648\u0679\u06D2 \u0628\u06CC\u0631\u0648\u0646\u06CC \u062C\u0632\u0627\u0626\u0631"},"zho":{"official":"\u7F8E\u56FD\u672C\u571F\u5916\u5C0F\u5C9B\u5C7F","common":"\u7F8E\u56FD\u672C\u571F\u5916\u5C0F\u5C9B\u5C7F"}},"latlng":[19.3,166.633333],"landlocked":false,"borders":[],"area":34.2,"flag":"\uD83C\uDDFA\uD83C\uDDF2","demonyms":{"eng":{"f":"American Islander","m":"American Islander"},"fra":{"f":"","m":""}}},{"name":{"common":"Uruguay","official":"Oriental Republic of Uruguay","native":{"spa":{"official":"Rep\xfablica Oriental del Uruguay","common":"Uruguay"}}},"tld":[".uy"],"cca2":"UY","ccn3":"858","cca3":"URY","cioc":"URU","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"UYU":{"name":"Uruguayan peso","symbol":"$"}},"idd":{"root":"+5","suffixes":["98"]},"capital":["Montevideo"],"altSpellings":["UY","Oriental Republic of Uruguay","Rep\xfablica Oriental del Uruguay"],"region":"Americas","subregion":"South America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Uruguaysk\xe1 v\xfdchodn\xed republika","common":"Uruguay"},"deu":{"official":"Republik \xd6stlich des Uruguay","common":"Uruguay"},"est":{"official":"Uruguay Idavabariik","common":"Uruguay"},"fin":{"official":"Uruguayn it\xe4inen tasavalta","common":"Uruguay"},"fra":{"official":"R\xe9publique orientale de l\'Uruguay","common":"Uruguay"},"hrv":{"official":"Orijentalna Republika Urugvaj","common":"Urugvaj"},"hun":{"official":"Uruguayi Keleti K\xf6zt\xe1rsas\xe1g","common":"Uruguay"},"ita":{"official":"Repubblica Orientale dell\'Uruguay","common":"Uruguay"},"jpn":{"official":"\u30A6\u30EB\u30B0\u30A2\u30A4\u6771\u65B9\u5171\u548C\u56FD","common":"\u30A6\u30EB\u30B0\u30A2\u30A4"},"kor":{"official":"\uC6B0\uB8E8\uACFC\uC774 \uB3D9\uBC29 \uACF5\uD654\uAD6D","common":"\uC6B0\uB8E8\uACFC\uC774"},"nld":{"official":"Oosterse Republiek Uruguay","common":"Uruguay"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0631\u0648\u06AF\u0648\u0626\u0647","common":"\u0627\u0631\u0648\u06AF\u0648\u0626\u0647"},"pol":{"official":"Wschodnia Republika Urugwaju","common":"Urugwaj"},"por":{"official":"Rep\xfablica Oriental do Uruguai","common":"Uruguai"},"rus":{"official":"\u0412\u043E\u0441\u0442\u043E\u0447\u043D\u043E\u0439 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0438 \u0423\u0440\u0443\u0433\u0432\u0430\u0439","common":"\u0423\u0440\u0443\u0433\u0432\u0430\u0439"},"slk":{"official":"Uruguajsk\xe1 v\xfdchodn\xe1 republika","common":"Uruguaj"},"spa":{"official":"Rep\xfablica Oriental del Uruguay","common":"Uruguay"},"swe":{"official":"Republiken Uruguay","common":"Uruguay"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0634\u0631\u0642\u06CC\u06C1 \u06CC\u0648\u0631\u0627\u06AF\u0648\u0626\u06D2","common":"\u06CC\u0648\u0631\u0627\u06AF\u0648\u0626\u06D2"},"zho":{"official":"\u4E4C\u62C9\u572D\u4E1C\u5CB8\u5171\u548C\u56FD","common":"\u4E4C\u62C9\u572D"}},"latlng":[-33,-56],"landlocked":false,"borders":["ARG","BRA"],"area":181034,"flag":"\uD83C\uDDFA\uD83C\uDDFE","demonyms":{"eng":{"f":"Uruguayan","m":"Uruguayan"},"fra":{"f":"Uruguayenne","m":"Uruguayen"}}},{"name":{"common":"United States","official":"United States of America","native":{"eng":{"official":"United States of America","common":"United States"}}},"tld":[".us"],"cca2":"US","ccn3":"840","cca3":"USA","cioc":"USA","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["201","202","203","205","206","207","208","209","210","212","213","214","215","216","217","218","219","220","223","224","225","227","228","229","231","234","239","240","248","251","252","253","254","256","260","262","267","269","270","272","274","276","279","281","283","301","302","303","304","305","307","308","309","310","312","313","314","315","316","317","318","319","320","321","323","325","326","327","330","331","332","334","336","337","339","341","346","347","351","352","360","361","364","380","385","386","401","402","404","405","406","407","408","409","410","412","413","414","415","417","419","423","424","425","430","432","434","435","440","442","443","445","447","448","458","463","464","469","470","475","478","479","480","484","500","501","502","503","504","505","507","508","509","510","512","513","515","516","517","518","520","521","522","523","524","525","526","527","528","529","530","531","532","533","534","535","538","539","540","541","542","543","544","545","546","547","549","550","551","552","553","554","556","557","558","559","561","562","563","564","566","567","569","570","571","572","573","574","575","577","578","580","582","585","586","588","589","601","602","603","605","606","607","608","609","610","612","614","615","616","617","618","619","620","623","626","628","629","630","631","636","640","641","646","650","651","656","657","659","660","661","662","667","669","678","679","680","681","682","689","700","701","702","703","704","706","707","708","710","712","713","714","715","716","717","718","719","720","724","725","726","727","730","731","732","734","737","740","743","747","754","757","760","762","763","765","769","770","771","772","773","774","775","779","781","785","786","801","802","803","804","805","806","808","810","812","813","814","815","816","817","818","820","826","828","830","831","832","838","839","840","843","845","847","848","850","854","856","857","858","859","860","862","863","864","865","870","872","878","901","903","904","906","907","908","909","910","912","913","914","915","916","917","918","919","920","925","928","929","930","931","934","936","937","938","940","941","943","945","947","948","949","951","952","954","956","959","970","971","972","973","975","978","979","980","983","984","985","986","989"]},"capital":["Washington D.C."],"altSpellings":["US","USA","United States of America"],"region":"Americas","subregion":"North America","languages":{"eng":"English"},"translations":{"ces":{"official":"Spojen\xe9 st\xe1ty americk\xe9","common":"Spojen\xe9 st\xe1ty"},"deu":{"official":"Vereinigte Staaten von Amerika","common":"Vereinigte Staaten"},"est":{"official":"Ameerika \xdchendriigid","common":"Ameerika \xdchendriigid"},"fin":{"official":"Amerikan yhdysvallat","common":"Yhdysvallat"},"fra":{"official":"Les \xe9tats-unis d\'Am\xe9rique","common":"\xc9tats-Unis"},"hrv":{"official":"Sjedinjene Dr\u017Eave Amerike","common":"Sjedinjene Ameri\u010Dke Dr\u017Eave"},"hun":{"official":"Amerikai Egyes\xfclt \xc1llamok","common":"Amerikai Egyes\xfclt \xc1llamok"},"ita":{"official":"Stati Uniti d\'America","common":"Stati Uniti d\'America"},"jpn":{"official":"\u30A2\u30E1\u30EA\u30AB\u5408\u8846\u56FD","common":"\u30A2\u30E1\u30EA\u30AB\u5408\u8846\u56FD"},"kor":{"official":"\uC544\uBA54\uB9AC\uCE74 \uD569\uC911\uAD6D","common":"\uBBF8\uAD6D"},"nld":{"official":"Verenigde Staten van Amerika","common":"Verenigde Staten"},"per":{"official":"\u0627\u06CC\u0627\u0644\u0627\u062A \u0645\u062A\u062D\u062F\u0647 \u0622\u0645\u0631\u06CC\u06A9\u0627","common":"\u0627\u06CC\u0627\u0644\u0627\u062A \u0645\u062A\u062D\u062F\u0647 \u0622\u0645\u0631\u06CC\u06A9\u0627"},"pol":{"official":"Stany Zjednoczone Ameryki","common":"Stany Zjednoczone"},"por":{"official":"Estados Unidos da Am\xe9rica","common":"Estados Unidos"},"rus":{"official":"\u0421\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u043D\u044B\u0435 \u0428\u0442\u0430\u0442\u044B \u0410\u043C\u0435\u0440\u0438\u043A\u0438","common":"\u0421\u043E\u0435\u0434\u0438\u043D\u0451\u043D\u043D\u044B\u0435 \u0428\u0442\u0430\u0442\u044B \u0410\u043C\u0435\u0440\u0438\u043A\u0438"},"slk":{"official":"Spojen\xe9 \u0161t\xe1ty Americk\xe9","common":"Spojen\xe9 \u0161t\xe1ty americk\xe9"},"spa":{"official":"Estados Unidos de Am\xe9rica","common":"Estados Unidos"},"swe":{"official":"Amerikas f\xf6renta stater","common":"USA"},"urd":{"official":"\u0631\u06CC\u0627\u0633\u062A\u06C1\u0627\u0626\u06D2 \u0645\u062A\u062D\u062F\u06C1 \u0627\u0645\u0631\u06CC\u06A9\u0627","common":"\u0631\u06CC\u0627\u0633\u062A\u06C1\u0627\u0626\u06D2 \u0645\u062A\u062D\u062F\u06C1"},"zho":{"official":"\u7F8E\u5229\u575A\u5408\u4F17\u56FD","common":"\u7F8E\u56FD"}},"latlng":[38,-97],"landlocked":false,"borders":["CAN","MEX"],"area":9372610,"flag":"\uD83C\uDDFA\uD83C\uDDF8","demonyms":{"eng":{"f":"American","m":"American"},"fra":{"f":"Am\xe9ricaine","m":"Am\xe9ricain"}}},{"name":{"common":"Uzbekistan","official":"Republic of Uzbekistan","native":{"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0423\u0437\u0431\u0435\u043A\u0438\u0441\u0442\u0430\u043D","common":"\u0423\u0437\u0431\u0435\u043A\u0438\u0441\u0442\u0430\u043D"},"uzb":{"official":"O\'zbekiston Respublikasi","common":"O\u2018zbekiston"}}},"tld":[".uz"],"cca2":"UZ","ccn3":"860","cca3":"UZB","cioc":"UZB","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"UZS":{"name":"Uzbekistani so\u02BBm","symbol":"so\'m"}},"idd":{"root":"+9","suffixes":["98"]},"capital":["Tashkent"],"altSpellings":["UZ","Republic of Uzbekistan","O\u2018zbekiston Respublikasi","\u040E\u0437\u0431\u0435\u043A\u0438\u0441\u0442\u043E\u043D \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0441\u0438"],"region":"Asia","subregion":"Central Asia","languages":{"rus":"Russian","uzb":"Uzbek"},"translations":{"ces":{"official":"Republika Uzbekist\xe1n","common":"Uzbekist\xe1n"},"deu":{"official":"Republik Usbekistan","common":"Usbekistan"},"est":{"official":"Usbekistani Vabariik","common":"Usbekistan"},"fin":{"official":"Uzbekistanin tasavalta","common":"Uzbekistan"},"fra":{"official":"R\xe9publique d\'Ouzb\xe9kistan","common":"Ouzb\xe9kistan"},"hrv":{"official":"Republika Uzbekistan","common":"Uzbekistan"},"hun":{"official":"\xdczb\xe9g K\xf6zt\xe1rsas\xe1g","common":"\xdczbegiszt\xe1n"},"ita":{"official":"Repubblica di Uzbekistan","common":"Uzbekistan"},"jpn":{"official":"\u30A6\u30BA\u30D9\u30AD\u30B9\u30BF\u30F3\u5171\u548C\u56FD","common":"\u30A6\u30BA\u30D9\u30AD\u30B9\u30BF\u30F3"},"kor":{"official":"\uC6B0\uC988\uBCA0\uD0A4\uC2A4\uD0C4 \uACF5\uD654\uAD6D","common":"\uC6B0\uC988\uBCA0\uD0A4\uC2A4\uD0C4"},"nld":{"official":"Republiek Oezbekistan","common":"Oezbekistan"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0632\u0628\u06A9\u0633\u062A\u0627\u0646","common":"\u0627\u0632\u0628\u06A9\u0633\u062A\u0627\u0646"},"pol":{"official":"Republika Uzbekistanu","common":"Uzbekistan"},"por":{"official":"Rep\xfablica do Usbequist\xe3o","common":"Uzbequist\xe3o"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0423\u0437\u0431\u0435\u043A\u0438\u0441\u0442\u0430\u043D","common":"\u0423\u0437\u0431\u0435\u043A\u0438\u0441\u0442\u0430\u043D"},"slk":{"official":"Uzbeck\xe1 republika","common":"Uzbekistan"},"spa":{"official":"Rep\xfablica de Uzbekist\xe1n","common":"Uzbekist\xe1n"},"swe":{"official":"Republiken Uzbekistan","common":"Uzbekistan"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0627\u0632\u0628\u06A9\u0633\u062A\u0627\u0646","common":"\u0627\u0632\u0628\u06A9\u0633\u062A\u0627\u0646"},"zho":{"official":"\u4E4C\u5179\u522B\u514B\u65AF\u5766\u5171\u548C\u56FD","common":"\u4E4C\u5179\u522B\u514B\u65AF\u5766"}},"latlng":[41,64],"landlocked":true,"borders":["AFG","KAZ","KGZ","TJK","TKM"],"area":447400,"flag":"\uD83C\uDDFA\uD83C\uDDFF","demonyms":{"eng":{"f":"Uzbekistani","m":"Uzbekistani"},"fra":{"f":"Ouzb\xe8ke","m":"Ouzb\xe8ke"}}},{"name":{"common":"Vatican City","official":"Vatican City State","native":{"ita":{"official":"Stato della Citt\xe0 del Vaticano","common":"Vaticano"},"lat":{"official":"Status Civitatis Vatican\xe6","common":"Vatican\xe6"}}},"tld":[".va"],"cca2":"VA","ccn3":"336","cca3":"VAT","cioc":"","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"EUR":{"name":"Euro","symbol":"\u20AC"}},"idd":{"root":"+3","suffixes":["906698","79"]},"capital":["Vatican City"],"altSpellings":["VA","Holy See (Vatican City State)","Vatican City State","Stato della Citt\xe0 del Vaticano"],"region":"Europe","subregion":"Southern Europe","languages":{"ita":"Italian","lat":"Latin"},"translations":{"ces":{"official":"M\u011Bstsk\xfd st\xe1t Vatik\xe1n","common":"Vatik\xe1n"},"deu":{"official":"Staat Vatikanstadt","common":"Vatikanstadt"},"est":{"official":"Vatikani Linnriik","common":"Vatikan"},"fin":{"official":"Vatikaanin kaupunkivaltio","common":"Vatikaani"},"fra":{"official":"Cit\xe9 du Vatican","common":"Cit\xe9 du Vatican"},"hrv":{"official":"Vatikan","common":"Vatikan"},"hun":{"official":"Vatik\xe1n \xc1llam","common":"Vatik\xe1n"},"ita":{"official":"Citt\xe0 del Vaticano","common":"Citt\xe0 del Vaticano"},"jpn":{"official":"\u30D0\u30C1\u30AB\u30F3\u5E02\u56FD\u306E\u72B6\u614B","common":"\u30D0\u30C1\u30AB\u30F3\u5E02\u56FD"},"kor":{"official":"\uBC14\uD2F0\uCE78 \uC2DC\uAD6D","common":"\uBC14\uD2F0\uCE78"},"nld":{"official":"Vaticaanstad","common":"Vaticaanstad"},"per":{"official":"\u062F\u0648\u0644\u062A\u200C\u0634\u0647\u0631 \u0648\u0627\u062A\u06CC\u06A9\u0627\u0646","common":"\u0648\u0627\u062A\u06CC\u06A9\u0627\u0646"},"pol":{"official":"Pa\u0144stwo Watyka\u0144skie","common":"Watykan"},"por":{"official":"Cidade do Vaticano","common":"Cidade do Vaticano"},"rus":{"official":"\u0413\u043E\u0440\u043E\u0434-\u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u043E \u0412\u0430\u0442\u0438\u043A\u0430\u043D","common":"\u0412\u0430\u0442\u0438\u043A\u0430\u043D"},"slk":{"official":"Sv\xe4t\xe1 stolica (Vatik\xe1nsky mestsk\xfd \u0161t\xe1t","common":"Vatik\xe1n"},"spa":{"official":"Ciudad del Vaticano","common":"Ciudad del Vaticano"},"swe":{"official":"Vatikanstaten","common":"Vatikanstaten"},"urd":{"official":"\u0648\u06CC\u0679\u06CC\u06A9\u0646 \u0633\u0679\u06CC","common":"\u0648\u06CC\u0679\u06CC\u06A9\u0646 \u0633\u0679\u06CC"},"zho":{"official":"\u68B5\u8482\u5188\u57CE\u56FD","common":"\u68B5\u8482\u5188"}},"latlng":[41.9,12.45],"landlocked":true,"borders":["ITA"],"area":0.44,"flag":"\uD83C\uDDFB\uD83C\uDDE6","demonyms":{"eng":{"f":"Vatican","m":"Vatican"},"fra":{"f":"Vaticane","m":"Vatican"}}},{"name":{"common":"Saint Vincent and the Grenadines","official":"Saint Vincent and the Grenadines","native":{"eng":{"official":"Saint Vincent and the Grenadines","common":"Saint Vincent and the Grenadines"}}},"tld":[".vc"],"cca2":"VC","ccn3":"670","cca3":"VCT","cioc":"VIN","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"XCD":{"name":"Eastern Caribbean dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["784"]},"capital":["Kingstown"],"altSpellings":["VC"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Svat\xfd Vincenc a Grenadiny","common":"Svat\xfd Vincenc a Grenadiny"},"deu":{"official":"St. Vincent und die Grenadinen","common":"St. Vincent und die Grenadinen"},"est":{"official":"Saint Vincent ja Grenadiinid","common":"Saint Vincent"},"fin":{"official":"Saint Vincent ja Grenadiinit","common":"Saint Vincent ja Grenadiinit"},"fra":{"official":"Saint-Vincent-et-les Grenadines","common":"Saint-Vincent-et-les-Grenadines"},"hrv":{"official":"Sveti Vincent i Grenadini","common":"Sveti Vincent i Grenadini"},"hun":{"official":"Saint Vincent \xe9s a Grenadine-szigetek","common":"Saint Vincent \xe9s a Grenadine-szigetek"},"ita":{"official":"Saint Vincent e Grenadine","common":"Saint Vincent e Grenadine"},"jpn":{"official":"\u30BB\u30F3\u30C8\u30D3\u30F3\u30BB\u30F3\u30C8\u304A\u3088\u3073\u30B0\u30EC\u30CA\u30C7\u30A3\u30FC\u30F3\u8AF8\u5CF6","common":"\u30BB\u30F3\u30C8\u30D3\u30F3\u30BB\u30F3\u30C8\u304A\u3088\u3073\u30B0\u30EC\u30CA\u30C7\u30A3\u30FC\u30F3\u8AF8\u5CF6"},"kor":{"official":"\uC138\uC778\uD2B8\uBE48\uC13C\uD2B8 \uADF8\uB808\uB098\uB518","common":"\uC138\uC778\uD2B8\uBE48\uC13C\uD2B8 \uADF8\uB808\uB098\uB518"},"nld":{"official":"Saint Vincent en de Grenadines","common":"Saint Vincent en de Grenadines"},"per":{"official":"\u0633\u0646\u062A \u0648\u06CC\u0646\u0633\u0646\u062A \u0648 \u06AF\u0631\u0646\u0627\u062F\u06CC\u0646\u200C\u0647\u0627","common":"\u0633\u0646\u062A \u0648\u06CC\u0646\u0633\u0646\u062A \u0648 \u06AF\u0631\u0646\u0627\u062F\u06CC\u0646\u200C\u0647\u0627"},"pol":{"official":"Saint Vincent i Grenadyny","common":"Saint Vincent i Grenadyny"},"por":{"official":"S\xe3o Vicente e Granadinas","common":"S\xe3o Vincente e Granadinas"},"rus":{"official":"\u0421\u0435\u043D\u0442-\u0412\u0438\u043D\u0441\u0435\u043D\u0442 \u0438 \u0413\u0440\u0435\u043D\u0430\u0434\u0438\u043D\u044B","common":"\u0421\u0435\u043D\u0442-\u0412\u0438\u043D\u0441\u0435\u043D\u0442 \u0438 \u0413\u0440\u0435\u043D\u0430\u0434\u0438\u043D\u044B"},"slk":{"official":"Sv\xe4t\xfd Vincent a Grenad\xedny","common":"Sv\xe4t\xfd Vincent a Grenad\xedny"},"spa":{"official":"San Vicente y las Granadinas","common":"San Vicente y Granadinas"},"swe":{"official":"Saint Vincent och Grenadinerna","common":"Saint Vincent och Grenadinerna"},"urd":{"official":"\u0633\u06CC\u0646\u0679 \u0648\u06CC\u0646\u0633\u06CC\u0646\u0679 \u0648 \u06AF\u0631\u06CC\u0646\u0627\u0688\u0627\u0626\u0646\u0632","common":"\u0633\u06CC\u0646\u0679 \u0648\u06CC\u0646\u0633\u06CC\u0646\u0679 \u0648 \u06AF\u0631\u06CC\u0646\u0627\u0688\u0627\u0626\u0646\u0632"},"zho":{"official":"\u5723\u6587\u68EE\u7279\u548C\u683C\u6797\u7EB3\u4E01\u65AF","common":"\u5723\u6587\u68EE\u7279\u548C\u683C\u6797\u7EB3\u4E01\u65AF"}},"latlng":[13.25,-61.2],"landlocked":false,"borders":[],"area":389,"flag":"\uD83C\uDDFB\uD83C\uDDE8","demonyms":{"eng":{"f":"Saint Vincentian","m":"Saint Vincentian"},"fra":{"f":"Vincentaise","m":"Vincentais"}}},{"name":{"common":"Venezuela","official":"Bolivarian Republic of Venezuela","native":{"spa":{"official":"Rep\xfablica Bolivariana de Venezuela","common":"Venezuela"}}},"tld":[".ve"],"cca2":"VE","ccn3":"862","cca3":"VEN","cioc":"VEN","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"VES":{"name":"Venezuelan bol\xedvar soberano","symbol":"Bs.S."}},"idd":{"root":"+5","suffixes":["8"]},"capital":["Caracas"],"altSpellings":["VE","Bolivarian Republic of Venezuela","Venezuela, Bolivarian Republic of","Rep\xfablica Bolivariana de Venezuela"],"region":"Americas","subregion":"South America","languages":{"spa":"Spanish"},"translations":{"ces":{"official":"Bol\xedvarsk\xe1 republika Venezuela","common":"Venezuela"},"deu":{"official":"Bolivarische Republik Venezuela","common":"Venezuela"},"est":{"official":"Venezuela Bol\xedvari Vabariik","common":"Venezuela"},"fin":{"official":"Venezuelan bolivariaainen tasavalta","common":"Venezuela"},"fra":{"official":"R\xe9publique bolivarienne du Venezuela","common":"Venezuela"},"hrv":{"official":"BOLIVARIJANSKA Republika Venezuela","common":"Venezuela"},"hun":{"official":"Venezuelai Boliv\xe1ri K\xf6zt\xe1rsas\xe1g","common":"Venezuela"},"ita":{"official":"Repubblica Bolivariana del Venezuela","common":"Venezuela"},"jpn":{"official":"\u30D9\u30CD\u30BA\u30A8\u30E9\xb7\u30DC\u30EA\u30D0\u30EB\u5171\u548C\u56FD","common":"\u30D9\u30CD\u30BA\u30A8\u30E9\u30FB\u30DC\u30EA\u30D0\u30EB\u5171\u548C\u56FD"},"kor":{"official":"\uBCA0\uB124\uC218\uC5D8\uB77C \uBCFC\uB9AC\uBC14\uB974 \uACF5\uD654\uAD6D","common":"\uBCA0\uB124\uC218\uC5D8\uB77C"},"nld":{"official":"Bolivariaanse Republiek Venezuela","common":"Venezuela"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0628\u0648\u0644\u06CC\u0648\u0627\u0631\u06CC \u0648\u0646\u0632\u0648\u0626\u0644\u0627","common":"\u0648\u0646\u0632\u0648\u0626\u0644\u0627"},"pol":{"official":"Boliwaria\u0144ska Republika Wenezueli","common":"Wenezuela"},"por":{"official":"Rep\xfablica Bolivariana da Venezuela","common":"Venezuela"},"rus":{"official":"\u0411\u043E\u043B\u0438\u0432\u0430\u0440\u0438\u0430\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0412\u0435\u043D\u0435\u0441\u0443\u044D\u043B\u0430","common":"\u0412\u0435\u043D\u0435\u0441\u0443\u044D\u043B\u0430"},"slk":{"official":"Venezuelsk\xe1 bol\xedvarovsk\xe1 republika","common":"Venezuela"},"spa":{"official":"Rep\xfablica Bolivariana de Venezuela","common":"Venezuela"},"swe":{"official":"Bolivarianska republiken Venezuela","common":"Venezuela"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0648\u06CC\u0646\u06CC\u0632\u0648\u06CC\u0644\u0627","common":"\u0648\u06CC\u0646\u06CC\u0632\u0648\u06CC\u0644\u0627"},"zho":{"official":"\u59D4\u5185\u745E\u62C9\u73BB\u5229\u74E6\u5C14\u5171\u548C\u56FD","common":"\u59D4\u5185\u745E\u62C9"}},"latlng":[8,-66],"landlocked":false,"borders":["BRA","COL","GUY"],"area":916445,"flag":"\uD83C\uDDFB\uD83C\uDDEA","demonyms":{"eng":{"f":"Venezuelan","m":"Venezuelan"},"fra":{"f":"V\xe9n\xe9zu\xe9lienne","m":"V\xe9n\xe9zu\xe9lien"}}},{"name":{"common":"British Virgin Islands","official":"Virgin Islands","native":{"eng":{"official":"Virgin Islands","common":"British Virgin Islands"}}},"tld":[".vg"],"cca2":"VG","ccn3":"092","cca3":"VGB","cioc":"IVB","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["284"]},"capital":["Road Town"],"altSpellings":["VG","Virgin Islands, British"],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Britsk\xe9 Panensk\xe9 ostrovy","common":"Britsk\xe9 Panensk\xe9 ostrovy"},"deu":{"official":"Jungferninseln","common":"Britische Jungferninseln"},"est":{"official":"Neitsisaared","common":"Briti Neitsisaared"},"fin":{"official":"Brittil\xe4iset Neitsytsaaret","common":"Neitsytsaaret"},"fra":{"official":"\xeeles Vierges","common":"\xceles Vierges britanniques"},"hrv":{"official":"Djevi\u010Danski Otoci","common":"Britanski Djevi\u010Danski Otoci"},"hun":{"official":"Brit Virgin-szigetek","common":"Brit Virgin-szigetek"},"ita":{"official":"Isole Vergini","common":"Isole Vergini Britanniche"},"jpn":{"official":"\u30D0\u30FC\u30B8\u30F3\u8AF8\u5CF6","common":"\u30A4\u30AE\u30EA\u30B9\u9818\u30F4\u30A1\u30FC\u30B8\u30F3\u8AF8\u5CF6"},"kor":{"official":"\uC601\uAD6D\uB839 \uBC84\uC9C4\uC544\uC77C\uB79C\uB4DC","common":"\uC601\uAD6D\uB839 \uBC84\uC9C4\uC544\uC77C\uB79C\uB4DC"},"nld":{"official":"Maagdeneilanden","common":"Britse Maagdeneilanden"},"per":{"official":"\u062C\u0632\u0627\u06CC\u0631 \u0648\u06CC\u0631\u062C\u06CC\u0646 \u0628\u0631\u06CC\u062A\u0627\u0646\u06CC\u0627","common":"\u062C\u0632\u0627\u06CC\u0631 \u0648\u06CC\u0631\u062C\u06CC\u0646 \u0628\u0631\u06CC\u062A\u0627\u0646\u06CC\u0627"},"pol":{"official":"Brytyjskie Wyspy Dziewicze","common":"Brytyjskie Wyspy Dziewicze"},"por":{"official":"Ilhas Virgens","common":"Ilhas Virgens"},"rus":{"official":"\u0412\u0438\u0440\u0433\u0438\u043D\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430","common":"\u0411\u0440\u0438\u0442\u0430\u043D\u0441\u043A\u0438\u0435 \u0412\u0438\u0440\u0433\u0438\u043D\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430"},"slk":{"official":"Panensk\xe9 ostrovy","common":"Panensk\xe9 ostrovy"},"spa":{"official":"Islas V\xedrgenes","common":"Islas V\xedrgenes del Reino Unido"},"swe":{"official":"Brittiska Jungfru\xf6arna","common":"Brittiska Jungfru\xf6arna"},"urd":{"official":"\u0628\u0631\u0637\u0627\u0646\u0648\u06CC \u062C\u0632\u0627\u0626\u0631 \u0648\u0631\u062C\u0646","common":"\u0628\u0631\u0637\u0627\u0646\u0648\u06CC \u062C\u0632\u0627\u0626\u0631 \u0648\u0631\u062C\u0646"},"zho":{"official":"\u82F1\u5C5E\u7EF4\u5C14\u4EAC\u7FA4\u5C9B","common":"\u82F1\u5C5E\u7EF4\u5C14\u4EAC\u7FA4\u5C9B"}},"latlng":[18.431383,-64.62305],"landlocked":false,"borders":[],"area":151,"flag":"\uD83C\uDDFB\uD83C\uDDEC","demonyms":{"eng":{"f":"Virgin Islander","m":"Virgin Islander"},"fra":{"f":"","m":""}}},{"name":{"common":"United States Virgin Islands","official":"Virgin Islands of the United States","native":{"eng":{"official":"Virgin Islands of the United States","common":"United States Virgin Islands"}}},"tld":[".vi"],"cca2":"VI","ccn3":"850","cca3":"VIR","cioc":"ISV","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"USD":{"name":"United States dollar","symbol":"$"}},"idd":{"root":"+1","suffixes":["340"]},"capital":["Charlotte Amalie"],"altSpellings":["VI","Virgin Islands, U.S."],"region":"Americas","subregion":"Caribbean","languages":{"eng":"English"},"translations":{"ces":{"official":"Americk\xe9 Panensk\xe9 ostrovy","common":"Americk\xe9 Panensk\xe9 ostrovy"},"deu":{"official":"Amerikanische Jungferninseln","common":"Amerikanische Jungferninseln"},"est":{"official":"\xdchendriikide Neitsisaared","common":"Neitsisaared, USA"},"fin":{"official":"Yhdysvaltain Neitsytsaaret","common":"Neitsytsaaret"},"fra":{"official":"\xceles Vierges des \xc9tats-Unis","common":"\xceles Vierges des \xc9tats-Unis"},"hrv":{"official":"Djevi\u010Danski Otoci SAD","common":"Ameri\u010Dki Djevi\u010Danski Otoci"},"hun":{"official":"Amerikai Virgin-szigetek","common":"Amerikai Virgin-szigetek"},"ita":{"official":"Isole Vergini degli Stati Uniti","common":"Isole Vergini americane"},"jpn":{"official":"\u7C73\u56FD\u306E\u30D0\u30FC\u30B8\u30F3\u8AF8\u5CF6","common":"\u30A2\u30E1\u30EA\u30AB\u9818\u30F4\u30A1\u30FC\u30B8\u30F3\u8AF8\u5CF6"},"kor":{"official":"\uBBF8\uAD6D\uB839 \uBC84\uC9C4\uC544\uC77C\uB79C\uB4DC","common":"\uBBF8\uAD6D\uB839 \uBC84\uC9C4\uC544\uC77C\uB79C\uB4DC"},"nld":{"official":"Maagdeneilanden van de Verenigde Staten","common":"Amerikaanse Maagdeneilanden"},"per":{"official":"\u062C\u0632\u0627\u06CC\u0631 \u0648\u06CC\u0631\u062C\u06CC\u0646 \u0627\u06CC\u0627\u0644\u0627\u062A \u0645\u062A\u062D\u062F\u0647 \u0622\u0645\u0631\u06CC\u06A9\u0627","common":"\u062C\u0632\u0627\u06CC\u0631 \u0648\u06CC\u0631\u062C\u06CC\u0646 \u0627\u06CC\u0627\u0644\u0627\u062A \u0645\u062A\u062D\u062F\u0647 \u0622\u0645\u0631\u06CC\u06A9\u0627"},"pol":{"official":"Wyspy Dziewicze Stan\xf3w Zjednoczonych","common":"Wyspy Dziewicze Stan\xf3w Zjednoczonych"},"por":{"official":"Ilhas Virgens dos Estados Unidos","common":"Ilhas Virgens dos Estados Unidos"},"rus":{"official":"\u0412\u0438\u0440\u0433\u0438\u043D\u0441\u043A\u0438\u0435 \u043E\u0441\u0442\u0440\u043E\u0432\u0430 \u0421\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u043D\u044B\u0445 \u0428\u0442\u0430\u0442\u043E\u0432","common":"\u0412\u0438\u0440\u0433\u0438\u043D\u0441\u043A\u0438\u0435 \u041E\u0441\u0442\u0440\u043E\u0432\u0430"},"slk":{"official":"Americk\xe9 Panensk\xe9 ostrovy","common":"Americk\xe9 Panensk\xe9 ostrovy"},"spa":{"official":"Islas V\xedrgenes de los Estados Unidos","common":"Islas V\xedrgenes de los Estados Unidos"},"swe":{"official":"Amerikanska Jungfru\xf6arna","common":"Amerikanska Jungfru\xf6arna"},"urd":{"official":"\u0627\u0645\u0631\u06CC\u06A9\u06CC \u062C\u0632\u0627\u0626\u0631 \u0648\u0631\u062C\u0646","common":"\u0627\u0645\u0631\u06CC\u06A9\u06CC \u062C\u0632\u0627\u0626\u0631 \u0648\u0631\u062C\u0646"},"zho":{"official":"\u7F8E\u5C5E\u7EF4\u5C14\u4EAC\u7FA4\u5C9B","common":"\u7F8E\u5C5E\u7EF4\u5C14\u4EAC\u7FA4\u5C9B"}},"latlng":[18.35,-64.933333],"landlocked":false,"borders":[],"area":347,"flag":"\uD83C\uDDFB\uD83C\uDDEE","demonyms":{"eng":{"f":"Virgin Islander","m":"Virgin Islander"},"fra":{"f":"","m":""}}},{"name":{"common":"Vietnam","official":"Socialist Republic of Vietnam","native":{"vie":{"official":"C\u1ED9ng h\xf2a x\xe3 h\u1ED9i ch\u1EE7 ngh\u0129a Vi\u1EC7t Nam","common":"Vi\u1EC7t Nam"}}},"tld":[".vn"],"cca2":"VN","ccn3":"704","cca3":"VNM","cioc":"VIE","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"VND":{"name":"Vietnamese \u0111\u1ED3ng","symbol":"\u20AB"}},"idd":{"root":"+8","suffixes":["4"]},"capital":["Hanoi"],"altSpellings":["VN","Socialist Republic of Vietnam","C\u1ED9ng h\xf2a X\xe3 h\u1ED9i ch\u1EE7 ngh\u0129a Vi\u1EC7t Nam","Viet Nam"],"region":"Asia","subregion":"South-Eastern Asia","languages":{"vie":"Vietnamese"},"translations":{"ces":{"official":"Vietnamsk\xe1 socialistick\xe1 republika","common":"Vietnam"},"deu":{"official":"Sozialistische Republik Vietnam","common":"Vietnam"},"est":{"official":"Vietnami Sotsialistlik Vabariik","common":"Vietnam"},"fin":{"official":"Vietnamin sosialistinen tasavalta","common":"Vietnam"},"fra":{"official":"R\xe9publique socialiste du Vi\xeat Nam","common":"Vi\xeat Nam"},"hrv":{"official":"Socijalisti\u010Dka Republika Vijetnam","common":"Vijetnam"},"hun":{"official":"Vietn\xe1mi Szocialista K\xf6zt\xe1rsas\xe1g","common":"Vietn\xe1m"},"ita":{"official":"Repubblica socialista del Vietnam","common":"Vietnam"},"jpn":{"official":"\u30D9\u30C8\u30CA\u30E0\u793E\u4F1A\u4E3B\u7FA9\u5171\u548C\u56FD","common":"\u30D9\u30C8\u30CA\u30E0"},"kor":{"official":"\uBCA0\uD2B8\uB0A8 \uC0AC\uD68C\uC8FC\uC758 \uACF5\uD654\uAD6D","common":"\uBCA0\uD2B8\uB0A8"},"nld":{"official":"Socialistische Republiek Vietnam","common":"Vietnam"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0633\u0648\u0633\u06CC\u0627\u0644\u06CC\u0633\u062A\u06CC \u0648\u06CC\u062A\u0646\u0627\u0645","common":"\u0648\u06CC\u062A\u0646\u0627\u0645"},"pol":{"official":"Socjalistyczna Republika Wietnamu","common":"Wietnam"},"por":{"official":"Rep\xfablica Socialista do Vietname","common":"Vietname"},"rus":{"official":"\u0421\u043E\u0446\u0438\u0430\u043B\u0438\u0441\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0412\u044C\u0435\u0442\u043D\u0430\u043C","common":"\u0412\u044C\u0435\u0442\u043D\u0430\u043C"},"slk":{"official":"Vietnamsk\xe1 socialistick\xe1 republika","common":"Vietnam"},"spa":{"official":"Rep\xfablica Socialista de Vietnam","common":"Vietnam"},"swe":{"official":"Socialistiska republiken Vietnam","common":"Vietnam"},"urd":{"official":"\u0627\u0634\u062A\u0631\u0627\u06A9\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0648\u06CC\u062A\u0646\u0627\u0645","common":"\u0648\u06CC\u062A\u0646\u0627\u0645"},"zho":{"official":"\u8D8A\u5357\u793E\u4F1A\u4E3B\u4E49\u5171\u548C\u56FD","common":"\u8D8A\u5357"}},"latlng":[16.16666666,107.83333333],"landlocked":false,"borders":["KHM","CHN","LAO"],"area":331212,"flag":"\uD83C\uDDFB\uD83C\uDDF3","demonyms":{"eng":{"f":"Vietnamese","m":"Vietnamese"},"fra":{"f":"Vietnamienne","m":"Vietnamien"}}},{"name":{"common":"Vanuatu","official":"Republic of Vanuatu","native":{"bis":{"official":"Ripablik blong Vanuatu","common":"Vanuatu"},"eng":{"official":"Republic of Vanuatu","common":"Vanuatu"},"fra":{"official":"R\xe9publique de Vanuatu","common":"Vanuatu"}}},"tld":[".vu"],"cca2":"VU","ccn3":"548","cca3":"VUT","cioc":"VAN","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"VUV":{"name":"Vanuatu vatu","symbol":"Vt"}},"idd":{"root":"+6","suffixes":["78"]},"capital":["Port Vila"],"altSpellings":["VU","Republic of Vanuatu","Ripablik blong Vanuatu","R\xe9publique de Vanuatu"],"region":"Oceania","subregion":"Melanesia","languages":{"bis":"Bislama","eng":"English","fra":"French"},"translations":{"ces":{"official":"Republika Vanuatu","common":"Vanuatu"},"deu":{"official":"Vanuatu","common":"Vanuatu"},"est":{"official":"Vanuatu Vabariik","common":"Vanuatu"},"fin":{"official":"Vanuatun tasavalta","common":"Vanuatu"},"fra":{"official":"R\xe9publique de Vanuatu","common":"Vanuatu"},"hrv":{"official":"Republika Vanuatu","common":"Vanuatu"},"hun":{"official":"Vanuatui K\xf6zt\xe1rsas\xe1g","common":"Vanuatu"},"ita":{"official":"Repubblica di Vanuatu","common":"Vanuatu"},"jpn":{"official":"\u30D0\u30CC\u30A2\u30C4\u5171\u548C\u56FD","common":"\u30D0\u30CC\u30A2\u30C4"},"kor":{"official":"\uBC14\uB204\uC544\uD22C \uACF5\uD654\uAD6D","common":"\uBC14\uB204\uC544\uD22C"},"nld":{"official":"Republiek Vanuatu","common":"Vanuatu"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0648\u0627\u0646\u0648\u0627\u062A\u0648","common":"\u0648\u0627\u0646\u0648\u0627\u062A\u0648"},"pol":{"official":"Republika Vanuatu","common":"Vanuatu"},"por":{"official":"Rep\xfablica de Vanuatu","common":"Vanuatu"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0412\u0430\u043D\u0443\u0430\u0442\u0443","common":"\u0412\u0430\u043D\u0443\u0430\u0442\u0443"},"slk":{"official":"Vanuatsk\xe1 republika","common":"Vanuatu"},"spa":{"official":"Rep\xfablica de Vanuatu","common":"Vanuatu"},"swe":{"official":"Republiken Vanuatu","common":"Vanuatu"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0648\u0627\u0646\u0648\u0627\u062A\u0648","common":"\u0648\u0627\u0646\u0648\u0627\u062A\u0648"},"zho":{"official":"\u74E6\u52AA\u963F\u56FE\u5171\u548C\u56FD","common":"\u74E6\u52AA\u963F\u56FE"}},"latlng":[-16,167],"landlocked":false,"borders":[],"area":12189,"flag":"\uD83C\uDDFB\uD83C\uDDFA","demonyms":{"eng":{"f":"Ni-Vanuatu","m":"Ni-Vanuatu"},"fra":{"f":"Vanuatuane","m":"Vanuatuan"}}},{"name":{"common":"Wallis and Futuna","official":"Territory of the Wallis and Futuna Islands","native":{"fra":{"official":"Territoire des \xeeles Wallis et Futuna","common":"Wallis et Futuna"}}},"tld":[".wf"],"cca2":"WF","ccn3":"876","cca3":"WLF","cioc":"","independent":false,"status":"officially-assigned","unMember":false,"currencies":{"XPF":{"name":"CFP franc","symbol":"\u20A3"}},"idd":{"root":"+6","suffixes":["81"]},"capital":["Mata-Utu"],"altSpellings":["WF","Territory of the Wallis and Futuna Islands","Territoire des \xeeles Wallis et Futuna"],"region":"Oceania","subregion":"Polynesia","languages":{"fra":"French"},"translations":{"ces":{"official":"Teritorium ostrov\u016F Wallis a Futuna","common":"Wallis a Futuna"},"deu":{"official":"Gebiet der Wallis und Futuna","common":"Wallis und Futuna"},"est":{"official":"Wallise ja Futuna ala","common":"Wallis ja Futuna"},"fin":{"official":"Wallisin ja Futunan yhteis\xf6","common":"Wallis ja Futuna"},"fra":{"official":"Territoire des \xeeles Wallis et Futuna","common":"Wallis-et-Futuna"},"hrv":{"official":"Teritoriju Wallis i Futuna","common":"Wallis i Fortuna"},"hun":{"official":"Wallis \xe9s Futuna","common":"Wallis \xe9s Futuna"},"ita":{"official":"Territorio delle Isole Wallis e Futuna","common":"Wallis e Futuna"},"jpn":{"official":"\u30A6\u30A9\u30EA\u30B9\xb7\u30D5\u30C4\u30CA\u8AF8\u5CF6\u306E\u9818\u571F","common":"\u30A6\u30A9\u30EA\u30B9\u30FB\u30D5\u30C4\u30CA"},"kor":{"official":"\uC648\uB9AC\uC2A4 \uD4CC\uD280\uB098","common":"\uC648\uB9AC\uC2A4 \uD4CC\uD280\uB098"},"nld":{"official":"Grondgebied van de Wallis en Futuna","common":"Wallis en Futuna"},"per":{"official":"\u062C\u0632\u0627\u06CC\u0631 \u0648\u0627\u0644\u06CC\u0633 \u0648 \u0641\u0648\u062A\u0648\u0646\u0627","common":"\u0648\u0627\u0644\u06CC\u0633 \u0648 \u0641\u0648\u062A\u0648\u0646\u0627"},"pol":{"official":"Terytorium Wysp Wallis i Futuna","common":"Wallis i Futuna"},"por":{"official":"Territ\xf3rio das Ilhas Wallis e Futuna","common":"Wallis e Futuna"},"rus":{"official":"\u0422\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044F \u0423\u043E\u043B\u043B\u0438\u0441 \u0438 \u0424\u0443\u0442\u0443\u043D\u0430 \u043E\u0441\u0442\u0440\u043E\u0432\u0430","common":"\u0423\u043E\u043B\u043B\u0438\u0441 \u0438 \u0424\u0443\u0442\u0443\u043D\u0430"},"slk":{"official":"Terit\xf3rium ostrovov Wallis a Futuna","common":"Wallis a Futuna"},"spa":{"official":"Territorio de las Islas Wallis y Futuna","common":"Wallis y Futuna"},"swe":{"official":"Territoriet Wallis- och Futuna\xf6arna","common":"Wallis- och Futuna\xf6arna"},"urd":{"official":"\u0633\u0631 \u0632\u0645\u06CC\u0646\u0650 \u0648\u0627\u0644\u0633 \u0648 \u0641\u062A\u0648\u0646\u06C1 \u062C\u0632\u0627\u0626\u0631","common":"\u0648\u0627\u0644\u0633 \u0648 \u0641\u062A\u0648\u0646\u06C1"},"zho":{"official":"\u74E6\u5229\u65AF\u548C\u5BCC\u56FE\u7EB3\u7FA4\u5C9B","common":"\u74E6\u5229\u65AF\u548C\u5BCC\u56FE\u7EB3\u7FA4\u5C9B"}},"latlng":[-13.3,-176.2],"landlocked":false,"borders":[],"area":142,"flag":"\uD83C\uDDFC\uD83C\uDDEB","demonyms":{"eng":{"f":"Wallis and Futuna Islander","m":"Wallis and Futuna Islander"},"fra":{"f":"","m":""}}},{"name":{"common":"Samoa","official":"Independent State of Samoa","native":{"eng":{"official":"Independent State of Samoa","common":"Samoa"},"smo":{"official":"Malo Sa\u02BBoloto Tuto\u02BBatasi o S\u0101moa","common":"S\u0101moa"}}},"tld":[".ws"],"cca2":"WS","ccn3":"882","cca3":"WSM","cioc":"SAM","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"WST":{"name":"Samoan t\u0101l\u0101","symbol":"T"}},"idd":{"root":"+6","suffixes":["85"]},"capital":["Apia"],"altSpellings":["WS","Independent State of Samoa","Malo Sa\u02BBoloto Tuto\u02BBatasi o S\u0101moa"],"region":"Oceania","subregion":"Polynesia","languages":{"eng":"English","smo":"Samoan"},"translations":{"ces":{"official":"Nez\xe1visl\xfd st\xe1t Samoa","common":"Samoa"},"deu":{"official":"Unabh\xe4ngige Staat Samoa","common":"Samoa"},"est":{"official":"Samoa Iseseisvusriik","common":"Samoa"},"fin":{"official":"Samoan itsen\xe4inen valtio","common":"Samoa"},"fra":{"official":"Samoa","common":"Samoa"},"hrv":{"official":"Nezavisna Dr\u017Eava Samoa","common":"Samoa"},"hun":{"official":"Szamoai F\xfcggetlen \xc1llam","common":"Szamoa"},"ita":{"official":"Stato indipendente di Samoa","common":"Samoa"},"jpn":{"official":"\u30B5\u30E2\u30A2\u72EC\u7ACB\u56FD","common":"\u30B5\u30E2\u30A2"},"kor":{"official":"\uC0AC\uBAA8\uC544 \uB3C5\uB9BD\uAD6D","common":"\uC0AC\uBAA8\uC544"},"nld":{"official":"Onafhankelijke Staat Samoa","common":"Samoa"},"per":{"official":"\u0627\u06CC\u0627\u0644\u062A \u0645\u0633\u062A\u0642\u0644 \u0633\u0627\u0645\u0648\u0622","common":"\u0633\u0627\u0645\u0648\u0622"},"pol":{"official":"Niezale\u017Cne Pa\u0144stwo Samoa","common":"Samoa"},"por":{"official":"Estado Independente de Samoa","common":"Samoa"},"rus":{"official":"\u041D\u0435\u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0435 \u0413\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u043E \u0421\u0430\u043C\u043E\u0430","common":"\u0421\u0430\u043C\u043E\u0430"},"slk":{"official":"Nez\xe1visl\xfd \u0161t\xe1tSamoa","common":"Samoa"},"spa":{"official":"Estado Independiente de Samoa","common":"Samoa"},"swe":{"official":"Sj\xe4lvst\xe4ndiga staten Samoa","common":"Samoa"},"urd":{"official":"\u0622\u0632\u0627\u062F \u0633\u0644\u0637\u0646\u062A\u0650 \u0633\u0627\u0645\u0648\u0627","common":"\u0633\u0627\u0645\u0648\u0648\u0627"},"zho":{"official":"\u8428\u6469\u4E9A\u72EC\u7ACB\u56FD","common":"\u8428\u6469\u4E9A"}},"latlng":[-13.58333333,-172.33333333],"landlocked":false,"borders":[],"area":2842,"flag":"\uD83C\uDDFC\uD83C\uDDF8","demonyms":{"eng":{"f":"Samoan","m":"Samoan"},"fra":{"f":"Samoane","m":"Samoan"}}},{"name":{"common":"Yemen","official":"Republic of Yemen","native":{"ara":{"official":"\u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u064A\u0645\u0646\u064A\u0629","common":"\u0627\u0644\u064A\u064E\u0645\u064E\u0646"}}},"tld":[".ye"],"cca2":"YE","ccn3":"887","cca3":"YEM","cioc":"YEM","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"YER":{"name":"Yemeni rial","symbol":"\uFDFC"}},"idd":{"root":"+9","suffixes":["67"]},"capital":["Sana\'a"],"altSpellings":["YE","Yemeni Republic","al-Jumh\u016Briyyah al-Yamaniyyah"],"region":"Asia","subregion":"Western Asia","languages":{"ara":"Arabic"},"translations":{"ces":{"official":"Jemensk\xe1 republika","common":"Jemen"},"deu":{"official":"Republik Jemen","common":"Jemen"},"est":{"official":"Jeemeni Vabariik","common":"Jeemen"},"fin":{"official":"Jemenin tasavalta","common":"Jemen"},"fra":{"official":"R\xe9publique du Y\xe9men","common":"Y\xe9men"},"hrv":{"official":"Republika Jemen","common":"Jemen"},"hun":{"official":"Jemeni K\xf6zt\xe1rsas\xe1g","common":"Jemen"},"ita":{"official":"Repubblica dello Yemen","common":"Yemen"},"jpn":{"official":"\u30A4\u30A8\u30E1\u30F3\u5171\u548C\u56FD","common":"\u30A4\u30A8\u30E1\u30F3"},"kor":{"official":"\uC608\uBA58 \uACF5\uD654\uAD6D","common":"\uC608\uBA58"},"nld":{"official":"Republiek Jemen","common":"Jemen"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u06CC\u0645\u0646","common":"\u06CC\u0645\u0646"},"pol":{"official":"Republika Jeme\u0144ska","common":"Jemen"},"por":{"official":"Rep\xfablica do I\xeamen","common":"I\xe9men"},"rus":{"official":"\u0419\u0435\u043C\u0435\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u0419\u0435\u043C\u0435\u043D"},"slk":{"official":"Jemensk\xe1 republika","common":"Jemen"},"spa":{"official":"Rep\xfablica de Yemen","common":"Yemen"},"swe":{"official":"Republiken Jemen","common":"Jemen"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u06CC\u0645\u0646","common":"\u06CC\u0645\u0646"},"zho":{"official":"\u4E5F\u95E8\u5171\u548C\u56FD","common":"\u4E5F\u95E8"}},"latlng":[15,48],"landlocked":false,"borders":["OMN","SAU"],"area":527968,"flag":"\uD83C\uDDFE\uD83C\uDDEA","demonyms":{"eng":{"f":"Yemeni","m":"Yemeni"},"fra":{"f":"Y\xe9m\xe9nite","m":"Y\xe9m\xe9nite"}}},{"name":{"common":"South Africa","official":"Republic of South Africa","native":{"afr":{"official":"Republiek van Suid-Afrika","common":"South Africa"},"eng":{"official":"Republic of South Africa","common":"South Africa"},"nbl":{"official":"IRiphabliki yeSewula Afrika","common":"Sewula Afrika"},"nso":{"official":"Rephaboliki ya Afrika-Borwa ","common":"Afrika-Borwa"},"sot":{"official":"Rephaboliki ya Afrika Borwa","common":"Afrika Borwa"},"ssw":{"official":"IRiphabhulikhi yeNingizimu Afrika","common":"Ningizimu Afrika"},"tsn":{"official":"Rephaboliki ya Aforika Borwa","common":"Aforika Borwa"},"tso":{"official":"Riphabliki ra Afrika Dzonga","common":"Afrika Dzonga"},"ven":{"official":"Riphabu\u1E3Diki ya Afurika Tshipembe","common":"Afurika Tshipembe"},"xho":{"official":"IRiphabliki yaseMzantsi Afrika","common":"Mzantsi Afrika"},"zul":{"official":"IRiphabliki yaseNingizimu Afrika","common":"Ningizimu Afrika"}}},"tld":[".za"],"cca2":"ZA","ccn3":"710","cca3":"ZAF","cioc":"RSA","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"ZAR":{"name":"South African rand","symbol":"R"}},"idd":{"root":"+2","suffixes":["7"]},"capital":["Pretoria","Bloemfontein","Cape Town"],"altSpellings":["ZA","RSA","Suid-Afrika","Republic of South Africa"],"region":"Africa","subregion":"Southern Africa","languages":{"afr":"Afrikaans","eng":"English","nbl":"Southern Ndebele","nso":"Northern Sotho","sot":"Southern Sotho","ssw":"Swazi","tsn":"Tswana","tso":"Tsonga","ven":"Venda","xho":"Xhosa","zul":"Zulu"},"translations":{"ces":{"official":"Jihoafrick\xe1 republika","common":"Jihoafrick\xe1 republika"},"deu":{"official":"Republik S\xfcdafrika","common":"S\xfcdafrika"},"est":{"official":"L\xf5una-Aafrika Vabariik","common":"L\xf5una-Aafrika Vabariik"},"fin":{"official":"Etel\xe4-Afrikan tasavalta","common":"Etel\xe4-Afrikka"},"fra":{"official":"R\xe9publique d\'Afrique du Sud","common":"Afrique du Sud"},"hrv":{"official":"Ju\u017Enoafri\u010Dka Republika","common":"Ju\u017Enoafri\u010Dka Republika"},"hun":{"official":"D\xe9l-afrikai K\xf6zt\xe1rsas\xe1g","common":"D\xe9l-afrikai K\xf6zt\xe1rsas\xe1g"},"ita":{"official":"Repubblica del Sud Africa","common":"Sud Africa"},"jpn":{"official":"\u5357\u30A2\u30D5\u30EA\u30AB\u5171\u548C\u56FD","common":"\u5357\u30A2\u30D5\u30EA\u30AB"},"kor":{"official":"\uB0A8\uC544\uD504\uB9AC\uCE74 \uACF5\uD654\uAD6D","common":"\uB0A8\uC544\uD504\uB9AC\uCE74"},"nld":{"official":"Republiek Zuid-Afrika","common":"Zuid-Afrika"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0622\u0641\u0631\u06CC\u0642\u0627\u06CC \u062C\u0646\u0648\u0628\u06CC","common":"\u0622\u0641\u0631\u06CC\u0642\u0627\u06CC \u062C\u0646\u0648\u0628\u06CC"},"pol":{"official":"Republika Po\u0142udniowej Afryki","common":"Po\u0142udniowa Afryka"},"por":{"official":"Rep\xfablica da \xc1frica do Sul","common":"\xc1frica do Sul"},"rus":{"official":"\u042E\u0436\u043D\u043E-\u0410\u0444\u0440\u0438\u043A\u0430\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430","common":"\u042E\u0436\u043D\u043E-\u0410\u0444\u0440\u0438\u043A\u0430\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430"},"slk":{"official":"Juhoafrick\xe1 republika","common":"Juhoafrick\xe1 republika"},"spa":{"official":"Rep\xfablica de Sud\xe1frica","common":"Rep\xfablica de Sud\xe1frica"},"swe":{"official":"Republiken Sydafrika","common":"Sydafrika"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u062C\u0646\u0648\u0628\u06CC \u0627\u0641\u0631\u06CC\u0642\u0627","common":"\u062C\u0646\u0648\u0628\u06CC \u0627\u0641\u0631\u06CC\u0642\u0627"},"zho":{"official":"\u5357\u975E\u5171\u548C\u56FD","common":"\u5357\u975E"}},"latlng":[-29,24],"landlocked":false,"borders":["BWA","LSO","MOZ","NAM","SWZ","ZWE"],"area":1221037,"flag":"\uD83C\uDDFF\uD83C\uDDE6","demonyms":{"eng":{"f":"South African","m":"South African"},"fra":{"f":"Sud-africaine","m":"Sud-africain"}}},{"name":{"common":"Zambia","official":"Republic of Zambia","native":{"eng":{"official":"Republic of Zambia","common":"Zambia"}}},"tld":[".zm"],"cca2":"ZM","ccn3":"894","cca3":"ZMB","cioc":"ZAM","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"ZMW":{"name":"Zambian kwacha","symbol":"ZK"}},"idd":{"root":"+2","suffixes":["60"]},"capital":["Lusaka"],"altSpellings":["ZM","Republic of Zambia"],"region":"Africa","subregion":"Eastern Africa","languages":{"eng":"English"},"translations":{"ces":{"official":"Zambijsk\xe1 republika","common":"Zambie"},"deu":{"official":"Republik Sambia","common":"Sambia"},"est":{"official":"Sambia Vabariik","common":"Sambia"},"fin":{"official":"Sambian tasavalta","common":"Sambia"},"fra":{"official":"R\xe9publique de Zambie","common":"Zambie"},"hrv":{"official":"Republika Zambija","common":"Zambija"},"hun":{"official":"Zambiai K\xf6zt\xe1rsas\xe1g","common":"Zambia"},"ita":{"official":"Repubblica di Zambia","common":"Zambia"},"jpn":{"official":"\u30B6\u30F3\u30D3\u30A2\u5171\u548C\u56FD","common":"\u30B6\u30F3\u30D3\u30A2"},"kor":{"official":"\uC7A0\uBE44\uC544 \uACF5\uD654\uAD6D","common":"\uC7A0\uBE44\uC544"},"nld":{"official":"Republiek Zambia","common":"Zambia"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0632\u0627\u0645\u0628\u06CC\u0627","common":"\u0632\u0627\u0645\u0628\u06CC\u0627"},"pol":{"official":"Republika Zambii","common":"Zambia"},"por":{"official":"Rep\xfablica da Z\xe2mbia","common":"Z\xe2mbia"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0417\u0430\u043C\u0431\u0438\u044F","common":"\u0417\u0430\u043C\u0431\u0438\u044F"},"slk":{"official":"Zambijsk\xe1 republika","common":"Zambia"},"spa":{"official":"Rep\xfablica de Zambia","common":"Zambia"},"swe":{"official":"Republiken Zambia","common":"Zambia"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0632\u06CC\u0645\u0628\u06CC\u0627","common":"\u0632\u06CC\u0645\u0628\u06CC\u0627"},"zho":{"official":"\u8D5E\u6BD4\u4E9A\u5171\u548C\u56FD","common":"\u8D5E\u6BD4\u4E9A"}},"latlng":[-15,30],"landlocked":true,"borders":["AGO","BWA","COD","MWI","MOZ","NAM","TZA","ZWE"],"area":752612,"flag":"\uD83C\uDDFF\uD83C\uDDF2","demonyms":{"eng":{"f":"Zambian","m":"Zambian"},"fra":{"f":"Zambienne","m":"Zambien"}}},{"name":{"common":"Zimbabwe","official":"Republic of Zimbabwe","native":{"bwg":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"eng":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"kck":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"khi":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"ndc":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"nde":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"nya":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"sna":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"sot":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"toi":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"tsn":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"tso":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"ven":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"xho":{"official":"Republic of Zimbabwe","common":"Zimbabwe"},"zib":{"official":"Republic of Zimbabwe","common":"Zimbabwe"}}},"tld":[".zw"],"cca2":"ZW","ccn3":"716","cca3":"ZWE","cioc":"ZIM","independent":true,"status":"officially-assigned","unMember":true,"currencies":{"BWP":{"name":"Botswana pula","symbol":"P"},"CNY":{"name":"Chinese yuan","symbol":"\xa5"},"EUR":{"name":"Euro","symbol":"\u20AC"},"GBP":{"name":"British pound","symbol":"\xa3"},"INR":{"name":"Indian rupee","symbol":"\u20B9"},"JPY":{"name":"Japanese yen","symbol":"\xa5"},"USD":{"name":"United States dollar","symbol":"$"},"ZAR":{"name":"South African rand","symbol":"Rs"},"ZWB":{"name":"Zimbabwean bonds","symbol":"$"}},"idd":{"root":"+2","suffixes":["63"]},"capital":["Harare"],"altSpellings":["ZW","Republic of Zimbabwe"],"region":"Africa","subregion":"Eastern Africa","languages":{"bwg":"Chibarwe","eng":"English","kck":"Kalanga","khi":"Khoisan","ndc":"Ndau","nde":"Northern Ndebele","nya":"Chewa","sna":"Shona","sot":"Sotho","toi":"Tonga","tsn":"Tswana","tso":"Tsonga","ven":"Venda","xho":"Xhosa","zib":"Zimbabwean Sign Language"},"translations":{"ces":{"official":"Zimbabwsk\xe1 republika","common":"Zimbabwe"},"deu":{"official":"Republik Simbabwe","common":"Simbabwe"},"est":{"official":"Zimbabwe Vabariik","common":"Zimbabwe"},"fin":{"official":"Zimbabwen tasavalta","common":"Zimbabwe"},"fra":{"official":"R\xe9publique du Zimbabwe","common":"Zimbabwe"},"hrv":{"official":"Republika Zimbabve","common":"Zimbabve"},"hun":{"official":"Zimbabwei K\xf6zt\xe1rsas\xe1g","common":"Zimbabwe"},"ita":{"official":"Repubblica dello Zimbabwe","common":"Zimbabwe"},"jpn":{"official":"\u30B8\u30F3\u30D0\u30D6\u30A8\u5171\u548C\u56FD","common":"\u30B8\u30F3\u30D0\u30D6\u30A8"},"kor":{"official":"\uC9D0\uBC14\uBE0C\uC6E8 \uACF5\uD654\uAD6D","common":"\uC9D0\uBC14\uBE0C\uC6E8"},"nld":{"official":"Republiek Zimbabwe","common":"Zimbabwe"},"per":{"official":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0632\u06CC\u0645\u0628\u0627\u0628\u0648\u0647","common":"\u0632\u06CC\u0645\u0628\u0627\u0628\u0648\u0647"},"pol":{"official":"Republika Zimbabwe","common":"Zimbabwe"},"por":{"official":"Rep\xfablica do Zimbabwe","common":"Zimbabwe"},"rus":{"official":"\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0417\u0438\u043C\u0431\u0430\u0431\u0432\u0435","common":"\u0417\u0438\u043C\u0431\u0430\u0431\u0432\u0435"},"slk":{"official":"Zimbabwianska republika","common":"Zimbabwe"},"spa":{"official":"Rep\xfablica de Zimbabue","common":"Zimbabue"},"swe":{"official":"Republiken Zimbabwe","common":"Zimbabwe"},"urd":{"official":"\u062C\u0645\u06C1\u0648\u0631\u06CC\u06C1 \u0632\u0645\u0628\u0627\u0628\u0648\u06D2","common":"\u0632\u0645\u0628\u0627\u0628\u0648\u06D2"},"zho":{"official":"\u6D25\u5DF4\u5E03\u97E6\u5171\u548C\u56FD","common":"\u6D25\u5DF4\u5E03\u97E6"}},"latlng":[-20,30],"landlocked":true,"borders":["BWA","MOZ","ZAF","ZMB"],"area":390757,"flag":"\uD83C\uDDFF\uD83C\uDDFC","demonyms":{"eng":{"f":"Zimbabwean","m":"Zimbabwean"},"fra":{"f":"Zimbabw\xe9enne","m":"Zimbabw\xe9en"}}}]');
            var Pm = [
                "code",
                "fallback"
            ];
            function Km() {
                return Km = Object.assign ? Object.assign.bind() : function(c) {
                    for(var a = 1; a < arguments.length; a++){
                        var e = arguments[a];
                        for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && (c[i] = e[i]);
                    }
                    return c;
                }, Km.apply(this, arguments);
            }
            const Tm = function(c) {
                var e = c.code, i = c.fallback, o = void 0 === i ? null : i, l = function(c, a) {
                    if (null == c) return {};
                    var e, i, o = function(c, a) {
                        if (null == c) return {};
                        var e, i, o = {}, l = Object.keys(c);
                        for(i = 0; i < l.length; i++)e = l[i], a.indexOf(e) >= 0 || (o[e] = c[e]);
                        return o;
                    }(c, a);
                    if (Object.getOwnPropertySymbols) {
                        var l = Object.getOwnPropertySymbols(c);
                        for(i = 0; i < l.length; i++)e = l[i], a.indexOf(e) >= 0 || Object.prototype.propertyIsEnumerable.call(c, e) && (o[e] = c[e]);
                    }
                    return o;
                }(c, Pm);
                if (!e) return o;
                var n = function(c) {
                    var a = String(c).toUpperCase(), e = Gm.find(function(c) {
                        return c.cca2 === a || c.ccn3 === a || c.cca3 == a;
                    });
                    return e && e.cca2 || c;
                }(e), t = Hm["flag_" + n.replace("-", "_")];
                return t ? a().createElement("img", Km({}, l, {
                    src: t
                })) : o;
            };
        })(), o;
    })());



var $114d365489223ff2$exports = {};
"use strict";
var $114d365489223ff2$var$__createBinding = $114d365489223ff2$exports && $114d365489223ff2$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $114d365489223ff2$var$__setModuleDefault = $114d365489223ff2$exports && $114d365489223ff2$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $114d365489223ff2$var$__importStar = $114d365489223ff2$exports && $114d365489223ff2$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $114d365489223ff2$var$__createBinding(result, mod, k);
    }
    $114d365489223ff2$var$__setModuleDefault(result, mod);
    return result;
};
var $114d365489223ff2$var$__importDefault = $114d365489223ff2$exports && $114d365489223ff2$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($114d365489223ff2$exports, "__esModule", {
    value: true
});

const $114d365489223ff2$var$anser_1 = $114d365489223ff2$var$__importDefault((parcelRequire("jVFZf")));
var $08fb14d0b91f67a1$exports = {};
/**
 * Escape carrigage returns like a terminal
 * @param {string} txt - String to escape.
 * @return {string}    - Escaped string.
 */ function $08fb14d0b91f67a1$var$escapeCarriageReturn(txt) {
    if (!txt) return "";
    if (!/\r/.test(txt)) return txt;
    txt = txt.replace(/\r+\n/gm, "\n"); // \r followed by \n --> newline
    while(/\r./.test(txt))txt = txt.replace(/^([^\r\n]*)\r+([^\r\n]+)/gm, function(_, base, insert) {
        return insert + base.slice(insert.length);
    });
    return txt;
}
function $08fb14d0b91f67a1$var$findLongestString(arr) {
    var longest = 0;
    for(var i = 0; i < arr.length; i++)if (arr[longest].length <= arr[i].length) longest = i;
    return longest;
}
function $08fb14d0b91f67a1$var$escapeSingleLineSafe(txt) {
    if (!/\r/.test(txt)) return txt;
    var arr = txt.split("\r");
    var res = [];
    while(arr.length > 0){
        var longest = $08fb14d0b91f67a1$var$findLongestString(arr);
        res.push(arr[longest]);
        arr = arr.slice(longest + 1);
    }
    return res.join("\r");
}
/**
 * Safely escape carrigage returns like a terminal.
 * This allows to escape carrigage returns while allowing future output to be appended
 * without loosing information.
 * Use this as a intermediate escape step if your stream hasn't completed yet.
 * @param {string} txt - String to escape.
 * @return {string}    - Escaped string.
 */ function $08fb14d0b91f67a1$var$escapeCarriageReturnSafe(txt) {
    if (!txt) return "";
    if (!/\r/.test(txt)) return txt;
    if (!/\n/.test(txt)) return $08fb14d0b91f67a1$var$escapeSingleLineSafe(txt);
    txt = txt.replace(/\r+\n/gm, "\n"); // \r followed by \n --> newline
    var idx = txt.lastIndexOf("\n");
    return $08fb14d0b91f67a1$var$escapeCarriageReturn(txt.slice(0, idx)) + "\n" + $08fb14d0b91f67a1$var$escapeSingleLineSafe(txt.slice(idx + 1));
}
$08fb14d0b91f67a1$exports = $08fb14d0b91f67a1$var$escapeCarriageReturn;
$08fb14d0b91f67a1$exports.escapeCarriageReturn = $08fb14d0b91f67a1$var$escapeCarriageReturn;
$08fb14d0b91f67a1$exports.escapeCarriageReturnSafe = $08fb14d0b91f67a1$var$escapeCarriageReturnSafe;



const $114d365489223ff2$var$React = $114d365489223ff2$var$__importStar((parcelRequire("exYeM")));
/**
 * Converts ANSI strings into JSON output.
 * @name ansiToJSON
 * @function
 * @param {String} input The input string.
 * @param {boolean} use_classes If `true`, HTML classes will be appended
 *                              to the HTML output.
 * @return {Array} The parsed input.
 */ function $114d365489223ff2$var$ansiToJSON(input, use_classes = false) {
    input = (0, $08fb14d0b91f67a1$exports.escapeCarriageReturn)($114d365489223ff2$var$fixBackspace(input));
    return $114d365489223ff2$var$anser_1.default.ansiToJson(input, {
        json: true,
        remove_empty: true,
        use_classes: use_classes
    });
}
/**
 * Create a class string.
 * @name createClass
 * @function
 * @param {AnserJsonEntry} bundle
 * @return {String} class name(s)
 */ function $114d365489223ff2$var$createClass(bundle) {
    let classNames = "";
    if (bundle.bg) classNames += `${bundle.bg}-bg `;
    if (bundle.fg) classNames += `${bundle.fg}-fg `;
    if (bundle.decoration) classNames += `ansi-${bundle.decoration} `;
    if (classNames === "") return null;
    classNames = classNames.substring(0, classNames.length - 1);
    return classNames;
}
/**
 * Create the style attribute.
 * @name createStyle
 * @function
 * @param {AnserJsonEntry} bundle
 * @return {Object} returns the style object
 */ function $114d365489223ff2$var$createStyle(bundle) {
    const style = {};
    if (bundle.bg) style.backgroundColor = `rgb(${bundle.bg})`;
    if (bundle.fg) style.color = `rgb(${bundle.fg})`;
    switch(bundle.decoration){
        case "bold":
            style.fontWeight = "bold";
            break;
        case "dim":
            style.opacity = "0.5";
            break;
        case "italic":
            style.fontStyle = "italic";
            break;
        case "hidden":
            style.visibility = "hidden";
            break;
        case "strikethrough":
            style.textDecoration = "line-through";
            break;
        case "underline":
            style.textDecoration = "underline";
            break;
        case "blink":
            style.textDecoration = "blink";
            break;
        default:
            break;
    }
    return style;
}
/**
 * Converts an Anser bundle into a React Node.
 * @param linkify whether links should be converting into clickable anchor tags.
 * @param useClasses should render the span with a class instead of style.
 * @param bundle Anser output.
 * @param key
 */ function $114d365489223ff2$var$convertBundleIntoReact(linkify, useClasses, bundle, key) {
    const style = useClasses ? null : $114d365489223ff2$var$createStyle(bundle);
    const className = useClasses ? $114d365489223ff2$var$createClass(bundle) : null;
    if (!linkify) return $114d365489223ff2$var$React.createElement("span", {
        style: style,
        key: key,
        className: className
    }, bundle.content);
    const content = [];
    const linkRegex = /(\s|^)(https?:\/\/(?:www\.|(?!www))[^\s.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})/g;
    let index = 0;
    let match;
    while((match = linkRegex.exec(bundle.content)) !== null){
        const [, pre, url] = match;
        const startIndex = match.index + pre.length;
        if (startIndex > index) content.push(bundle.content.substring(index, startIndex));
        // Make sure the href we generate from the link is fully qualified. We assume http
        // if it starts with a www because many sites don't support https
        const href = url.startsWith("www.") ? `http://${url}` : url;
        content.push($114d365489223ff2$var$React.createElement("a", {
            key: index,
            href: href,
            target: "_blank"
        }, `${url}`));
        index = linkRegex.lastIndex;
    }
    if (index < bundle.content.length) content.push(bundle.content.substring(index));
    return $114d365489223ff2$var$React.createElement("span", {
        style: style,
        key: key,
        className: className
    }, content);
}
function $114d365489223ff2$var$Ansi(props) {
    const { className: className, useClasses: useClasses, children: children, linkify: linkify } = props;
    return $114d365489223ff2$var$React.createElement("code", {
        className: className
    }, $114d365489223ff2$var$ansiToJSON(children !== null && children !== void 0 ? children : "", useClasses !== null && useClasses !== void 0 ? useClasses : false).map($114d365489223ff2$var$convertBundleIntoReact.bind(null, linkify !== null && linkify !== void 0 ? linkify : false, useClasses !== null && useClasses !== void 0 ? useClasses : false)));
}
$114d365489223ff2$exports.default = $114d365489223ff2$var$Ansi;
// This is copied from the Jupyter Classic source code
// notebook/static/base/js/utils.js to handle \b in a way
// that is **compatible with Jupyter classic**.   One can
// argue that this behavior is questionable:
//   https://stackoverflow.com/questions/55440152/multiple-b-doesnt-work-as-expected-in-jupyter#
function $114d365489223ff2$var$fixBackspace(txt) {
    let tmp = txt;
    do {
        txt = tmp;
        // Cancel out anything-but-newline followed by backspace
        tmp = txt.replace(/[^\n]\x08/gm, "");
    }while (tmp.length < txt.length);
    return txt;
}



var $jawKn = parcelRequire("jawKn");




var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

// src/index.ts
// src/hooks/useChain.ts

var $exYeM = parcelRequire("exYeM");
var $fafba8d3e1bed3b4$var$__defProp = Object.defineProperty;
var $fafba8d3e1bed3b4$var$__export = (target, all)=>{
    for(var name in all)$fafba8d3e1bed3b4$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/globals.ts
var $fafba8d3e1bed3b4$export$cceeabf822b64fc0 = {};
$fafba8d3e1bed3b4$var$__export($fafba8d3e1bed3b4$export$cceeabf822b64fc0, {
    assign: ()=>$fafba8d3e1bed3b4$var$assign,
    colors: ()=>$fafba8d3e1bed3b4$var$colors,
    createStringInterpolator: ()=>$fafba8d3e1bed3b4$var$createStringInterpolator,
    skipAnimation: ()=>$fafba8d3e1bed3b4$var$skipAnimation,
    to: ()=>$fafba8d3e1bed3b4$var$to,
    willAdvance: ()=>$fafba8d3e1bed3b4$var$willAdvance
});
// ../rafz/dist/react-spring_rafz.modern.mjs
var $fafba8d3e1bed3b4$var$updateQueue = $fafba8d3e1bed3b4$var$makeQueue();
var $fafba8d3e1bed3b4$export$27f233d61a9e2fa4 = (fn)=>$fafba8d3e1bed3b4$var$schedule(fn, $fafba8d3e1bed3b4$var$updateQueue);
var $fafba8d3e1bed3b4$var$writeQueue = $fafba8d3e1bed3b4$var$makeQueue();
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.write = (fn)=>$fafba8d3e1bed3b4$var$schedule(fn, $fafba8d3e1bed3b4$var$writeQueue);
var $fafba8d3e1bed3b4$var$onStartQueue = $fafba8d3e1bed3b4$var$makeQueue();
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.onStart = (fn)=>$fafba8d3e1bed3b4$var$schedule(fn, $fafba8d3e1bed3b4$var$onStartQueue);
var $fafba8d3e1bed3b4$var$onFrameQueue = $fafba8d3e1bed3b4$var$makeQueue();
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.onFrame = (fn)=>$fafba8d3e1bed3b4$var$schedule(fn, $fafba8d3e1bed3b4$var$onFrameQueue);
var $fafba8d3e1bed3b4$var$onFinishQueue = $fafba8d3e1bed3b4$var$makeQueue();
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.onFinish = (fn)=>$fafba8d3e1bed3b4$var$schedule(fn, $fafba8d3e1bed3b4$var$onFinishQueue);
var $fafba8d3e1bed3b4$var$timeouts = [];
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    const time = $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.now() + ms;
    const cancel = ()=>{
        const i = $fafba8d3e1bed3b4$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $fafba8d3e1bed3b4$var$timeouts.splice(i, 1);
        $fafba8d3e1bed3b4$var$pendingCount -= ~i ? 1 : 0;
    };
    const timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $fafba8d3e1bed3b4$var$timeouts.splice($fafba8d3e1bed3b4$var$findTimeout(time), 0, timeout);
    $fafba8d3e1bed3b4$var$pendingCount += 1;
    $fafba8d3e1bed3b4$var$start();
    return timeout;
};
var $fafba8d3e1bed3b4$var$findTimeout = (time)=>~(~$fafba8d3e1bed3b4$var$timeouts.findIndex((t)=>t.time > time) || ~$fafba8d3e1bed3b4$var$timeouts.length);
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $fafba8d3e1bed3b4$var$onStartQueue.delete(fn);
    $fafba8d3e1bed3b4$var$onFrameQueue.delete(fn);
    $fafba8d3e1bed3b4$var$onFinishQueue.delete(fn);
    $fafba8d3e1bed3b4$var$updateQueue.delete(fn);
    $fafba8d3e1bed3b4$var$writeQueue.delete(fn);
};
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.sync = (fn)=>{
    $fafba8d3e1bed3b4$var$sync = true;
    $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $fafba8d3e1bed3b4$var$sync = false;
};
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $fafba8d3e1bed3b4$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
var $fafba8d3e1bed3b4$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : // eslint-disable-next-line @typescript-eslint/no-empty-function
()=>{};
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.use = (impl)=>$fafba8d3e1bed3b4$var$nativeRaf = impl;
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.catch = console.error;
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.frameLoop = "always";
$fafba8d3e1bed3b4$export$27f233d61a9e2fa4.advance = ()=>{
    if ($fafba8d3e1bed3b4$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $fafba8d3e1bed3b4$var$update();
};
var $fafba8d3e1bed3b4$var$ts = -1;
var $fafba8d3e1bed3b4$var$pendingCount = 0;
var $fafba8d3e1bed3b4$var$sync = false;
function $fafba8d3e1bed3b4$var$schedule(fn, queue) {
    if ($fafba8d3e1bed3b4$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $fafba8d3e1bed3b4$var$start();
    }
}
function $fafba8d3e1bed3b4$var$start() {
    if ($fafba8d3e1bed3b4$var$ts < 0) {
        $fafba8d3e1bed3b4$var$ts = 0;
        if ($fafba8d3e1bed3b4$export$27f233d61a9e2fa4.frameLoop !== "demand") $fafba8d3e1bed3b4$var$nativeRaf($fafba8d3e1bed3b4$var$loop);
    }
}
function $fafba8d3e1bed3b4$var$stop() {
    $fafba8d3e1bed3b4$var$ts = -1;
}
function $fafba8d3e1bed3b4$var$loop() {
    if (~$fafba8d3e1bed3b4$var$ts) {
        $fafba8d3e1bed3b4$var$nativeRaf($fafba8d3e1bed3b4$var$loop);
        $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.batchedUpdates($fafba8d3e1bed3b4$var$update);
    }
}
function $fafba8d3e1bed3b4$var$update() {
    const prevTs = $fafba8d3e1bed3b4$var$ts;
    $fafba8d3e1bed3b4$var$ts = $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.now();
    const count = $fafba8d3e1bed3b4$var$findTimeout($fafba8d3e1bed3b4$var$ts);
    if (count) {
        $fafba8d3e1bed3b4$var$eachSafely($fafba8d3e1bed3b4$var$timeouts.splice(0, count), (t)=>t.handler());
        $fafba8d3e1bed3b4$var$pendingCount -= count;
    }
    if (!$fafba8d3e1bed3b4$var$pendingCount) {
        $fafba8d3e1bed3b4$var$stop();
        return;
    }
    $fafba8d3e1bed3b4$var$onStartQueue.flush();
    $fafba8d3e1bed3b4$var$updateQueue.flush(prevTs ? Math.min(64, $fafba8d3e1bed3b4$var$ts - prevTs) : 16.667);
    $fafba8d3e1bed3b4$var$onFrameQueue.flush();
    $fafba8d3e1bed3b4$var$writeQueue.flush();
    $fafba8d3e1bed3b4$var$onFinishQueue.flush();
}
function $fafba8d3e1bed3b4$var$makeQueue() {
    let next = /* @__PURE__ */ new Set();
    let current = next;
    return {
        add (fn) {
            $fafba8d3e1bed3b4$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $fafba8d3e1bed3b4$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = /* @__PURE__ */ new Set();
                $fafba8d3e1bed3b4$var$pendingCount -= current.size;
                $fafba8d3e1bed3b4$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $fafba8d3e1bed3b4$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $fafba8d3e1bed3b4$var$eachSafely(values, each2) {
    values.forEach((value)=>{
        try {
            each2(value);
        } catch (e) {
            $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
// src/helpers.ts
function $fafba8d3e1bed3b4$export$8793edee2d425525() {}
var $fafba8d3e1bed3b4$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
var $fafba8d3e1bed3b4$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === void 0
};
function $fafba8d3e1bed3b4$export$248d38f6296296c5(a, b) {
    if ($fafba8d3e1bed3b4$export$226b3eccf92c9ed9.arr(a)) {
        if (!$fafba8d3e1bed3b4$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
var $fafba8d3e1bed3b4$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
function $fafba8d3e1bed3b4$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($fafba8d3e1bed3b4$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
var $fafba8d3e1bed3b4$export$45b10814cc054894 = (a)=>$fafba8d3e1bed3b4$export$226b3eccf92c9ed9.und(a) ? [] : $fafba8d3e1bed3b4$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $fafba8d3e1bed3b4$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $fafba8d3e1bed3b4$export$79b2f7037acddd43(items, iterator);
    }
}
var $fafba8d3e1bed3b4$export$7ba486852759e806 = (queue, ...args)=>$fafba8d3e1bed3b4$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
var $fafba8d3e1bed3b4$export$48d7c418edadb60c = ()=>typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
// src/globals.ts
var $fafba8d3e1bed3b4$var$createStringInterpolator;
var $fafba8d3e1bed3b4$var$to;
var $fafba8d3e1bed3b4$var$colors = null;
var $fafba8d3e1bed3b4$var$skipAnimation = false;
var $fafba8d3e1bed3b4$var$willAdvance = $fafba8d3e1bed3b4$export$8793edee2d425525;
var $fafba8d3e1bed3b4$var$assign = (globals)=>{
    if (globals.to) $fafba8d3e1bed3b4$var$to = globals.to;
    if (globals.now) $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.now = globals.now;
    if (globals.colors !== void 0) $fafba8d3e1bed3b4$var$colors = globals.colors;
    if (globals.skipAnimation != null) $fafba8d3e1bed3b4$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $fafba8d3e1bed3b4$var$createStringInterpolator = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $fafba8d3e1bed3b4$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.frameLoop = globals.frameLoop;
};
// src/FrameLoop.ts
var $fafba8d3e1bed3b4$var$startQueue = /* @__PURE__ */ new Set();
var $fafba8d3e1bed3b4$var$currentFrame = [];
var $fafba8d3e1bed3b4$var$prevFrame = [];
var $fafba8d3e1bed3b4$var$priority = 0;
var $fafba8d3e1bed3b4$export$a57f5080a3bcc90a = {
    get idle () {
        return !$fafba8d3e1bed3b4$var$startQueue.size && !$fafba8d3e1bed3b4$var$currentFrame.length;
    },
    /** Advance the given animation on every frame until idle. */ start (animation) {
        if ($fafba8d3e1bed3b4$var$priority > animation.priority) {
            $fafba8d3e1bed3b4$var$startQueue.add(animation);
            $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.onStart($fafba8d3e1bed3b4$var$flushStartQueue);
        } else {
            $fafba8d3e1bed3b4$var$startSafely(animation);
            $fafba8d3e1bed3b4$export$27f233d61a9e2fa4($fafba8d3e1bed3b4$var$advance);
        }
    },
    advance: /** Advance all animations by the given time. */ $fafba8d3e1bed3b4$var$advance,
    /** Call this when an animation's priority changes. */ sort (animation) {
        if ($fafba8d3e1bed3b4$var$priority) $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.onFrame(()=>$fafba8d3e1bed3b4$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $fafba8d3e1bed3b4$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $fafba8d3e1bed3b4$var$currentFrame.splice(prevIndex, 1);
                $fafba8d3e1bed3b4$var$startUnsafely(animation);
            }
        }
    },
    /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */ clear () {
        $fafba8d3e1bed3b4$var$currentFrame = [];
        $fafba8d3e1bed3b4$var$startQueue.clear();
    }
};
function $fafba8d3e1bed3b4$var$flushStartQueue() {
    $fafba8d3e1bed3b4$var$startQueue.forEach($fafba8d3e1bed3b4$var$startSafely);
    $fafba8d3e1bed3b4$var$startQueue.clear();
    $fafba8d3e1bed3b4$export$27f233d61a9e2fa4($fafba8d3e1bed3b4$var$advance);
}
function $fafba8d3e1bed3b4$var$startSafely(animation) {
    if (!$fafba8d3e1bed3b4$var$currentFrame.includes(animation)) $fafba8d3e1bed3b4$var$startUnsafely(animation);
}
function $fafba8d3e1bed3b4$var$startUnsafely(animation) {
    $fafba8d3e1bed3b4$var$currentFrame.splice($fafba8d3e1bed3b4$var$findIndex($fafba8d3e1bed3b4$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $fafba8d3e1bed3b4$var$advance(dt) {
    const nextFrame = $fafba8d3e1bed3b4$var$prevFrame;
    for(let i = 0; i < $fafba8d3e1bed3b4$var$currentFrame.length; i++){
        const animation = $fafba8d3e1bed3b4$var$currentFrame[i];
        $fafba8d3e1bed3b4$var$priority = animation.priority;
        if (!animation.idle) {
            $fafba8d3e1bed3b4$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $fafba8d3e1bed3b4$var$priority = 0;
    $fafba8d3e1bed3b4$var$prevFrame = $fafba8d3e1bed3b4$var$currentFrame;
    $fafba8d3e1bed3b4$var$prevFrame.length = 0;
    $fafba8d3e1bed3b4$var$currentFrame = nextFrame;
    return $fafba8d3e1bed3b4$var$currentFrame.length > 0;
}
function $fafba8d3e1bed3b4$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
// src/clamp.ts
var $fafba8d3e1bed3b4$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);
// src/colors.ts
var $fafba8d3e1bed3b4$export$8f45430ccf837300 = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
// src/colorMatchers.ts
var $fafba8d3e1bed3b4$var$NUMBER = "[-+]?\\d*\\.?\\d+";
var $fafba8d3e1bed3b4$var$PERCENTAGE = $fafba8d3e1bed3b4$var$NUMBER + "%";
function $fafba8d3e1bed3b4$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var $fafba8d3e1bed3b4$export$8972dc0e6ad9238f = new RegExp("rgb" + $fafba8d3e1bed3b4$var$call($fafba8d3e1bed3b4$var$NUMBER, $fafba8d3e1bed3b4$var$NUMBER, $fafba8d3e1bed3b4$var$NUMBER));
var $fafba8d3e1bed3b4$export$4e46ac54fc82cf3b = new RegExp("rgba" + $fafba8d3e1bed3b4$var$call($fafba8d3e1bed3b4$var$NUMBER, $fafba8d3e1bed3b4$var$NUMBER, $fafba8d3e1bed3b4$var$NUMBER, $fafba8d3e1bed3b4$var$NUMBER));
var $fafba8d3e1bed3b4$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $fafba8d3e1bed3b4$var$call($fafba8d3e1bed3b4$var$NUMBER, $fafba8d3e1bed3b4$var$PERCENTAGE, $fafba8d3e1bed3b4$var$PERCENTAGE));
var $fafba8d3e1bed3b4$export$810b04175080204c = new RegExp("hsla" + $fafba8d3e1bed3b4$var$call($fafba8d3e1bed3b4$var$NUMBER, $fafba8d3e1bed3b4$var$PERCENTAGE, $fafba8d3e1bed3b4$var$PERCENTAGE, $fafba8d3e1bed3b4$var$NUMBER));
var $fafba8d3e1bed3b4$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $fafba8d3e1bed3b4$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $fafba8d3e1bed3b4$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
var $fafba8d3e1bed3b4$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
// src/normalizeColor.ts
function $fafba8d3e1bed3b4$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
    if (match = $fafba8d3e1bed3b4$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($fafba8d3e1bed3b4$var$colors && $fafba8d3e1bed3b4$var$colors[color] !== void 0) return $fafba8d3e1bed3b4$var$colors[color];
    if (match = $fafba8d3e1bed3b4$export$8972dc0e6ad9238f.exec(color)) return ($fafba8d3e1bed3b4$var$parse255(match[1]) << 24 | // r
    $fafba8d3e1bed3b4$var$parse255(match[2]) << 16 | // g
    $fafba8d3e1bed3b4$var$parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
    if (match = $fafba8d3e1bed3b4$export$4e46ac54fc82cf3b.exec(color)) return ($fafba8d3e1bed3b4$var$parse255(match[1]) << 24 | // r
    $fafba8d3e1bed3b4$var$parse255(match[2]) << 16 | // g
    $fafba8d3e1bed3b4$var$parse255(match[3]) << 8 | // b
    $fafba8d3e1bed3b4$var$parse1(match[4])) >>> // a
    0;
    if (match = $fafba8d3e1bed3b4$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    "ff", // a
    16) >>> 0;
    if (match = $fafba8d3e1bed3b4$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $fafba8d3e1bed3b4$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
    if (match = $fafba8d3e1bed3b4$export$8f4a7c0bb78e6ea8.exec(color)) return ($fafba8d3e1bed3b4$var$hslToRgb($fafba8d3e1bed3b4$var$parse360(match[1]), // h
    $fafba8d3e1bed3b4$var$parsePercentage(match[2]), // s
    $fafba8d3e1bed3b4$var$parsePercentage(match[3])) | 255) >>> // a
    0;
    if (match = $fafba8d3e1bed3b4$export$810b04175080204c.exec(color)) return ($fafba8d3e1bed3b4$var$hslToRgb($fafba8d3e1bed3b4$var$parse360(match[1]), // h
    $fafba8d3e1bed3b4$var$parsePercentage(match[2]), // s
    $fafba8d3e1bed3b4$var$parsePercentage(match[3])) | $fafba8d3e1bed3b4$var$parse1(match[4])) >>> // a
    0;
    return null;
}
function $fafba8d3e1bed3b4$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $fafba8d3e1bed3b4$var$hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $fafba8d3e1bed3b4$var$hue2rgb(p, q, h + 1 / 3);
    const g = $fafba8d3e1bed3b4$var$hue2rgb(p, q, h);
    const b = $fafba8d3e1bed3b4$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $fafba8d3e1bed3b4$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $fafba8d3e1bed3b4$var$parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $fafba8d3e1bed3b4$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $fafba8d3e1bed3b4$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
// src/colorToRgba.ts
function $fafba8d3e1bed3b4$export$61db176b839af1f(input) {
    let int32Color = $fafba8d3e1bed3b4$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    const r = (int32Color & 4278190080) >>> 24;
    const g = (int32Color & 16711680) >>> 16;
    const b = (int32Color & 65280) >>> 8;
    const a = (int32Color & 255) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// src/createInterpolator.ts
var $fafba8d3e1bed3b4$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($fafba8d3e1bed3b4$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($fafba8d3e1bed3b4$export$226b3eccf92c9ed9.arr(range)) return $fafba8d3e1bed3b4$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($fafba8d3e1bed3b4$export$226b3eccf92c9ed9.str(range.output[0])) return $fafba8d3e1bed3b4$var$createStringInterpolator(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range2 = $fafba8d3e1bed3b4$var$findRange(input, inputRange);
        return $fafba8d3e1bed3b4$var$interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $fafba8d3e1bed3b4$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $fafba8d3e1bed3b4$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
// src/easings.ts
var $fafba8d3e1bed3b4$var$steps = (steps2, direction = "end")=>(progress2)=>{
        progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
        const expanded = progress2 * steps2;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return $fafba8d3e1bed3b4$export$7d15b64cf5a3a4c4(0, 1, rounded / steps2);
    };
var $fafba8d3e1bed3b4$var$c1 = 1.70158;
var $fafba8d3e1bed3b4$var$c2 = $fafba8d3e1bed3b4$var$c1 * 1.525;
var $fafba8d3e1bed3b4$var$c3 = $fafba8d3e1bed3b4$var$c1 + 1;
var $fafba8d3e1bed3b4$var$c4 = 2 * Math.PI / 3;
var $fafba8d3e1bed3b4$var$c5 = 2 * Math.PI / 4.5;
var $fafba8d3e1bed3b4$var$bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
var $fafba8d3e1bed3b4$export$15a0bf1b4bbacad8 = {
    linear: (x)=>x,
    easeInQuad: (x)=>x * x,
    easeOutQuad: (x)=>1 - (1 - x) * (1 - x),
    easeInOutQuad: (x)=>x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: (x)=>x * x * x,
    easeOutCubic: (x)=>1 - Math.pow(1 - x, 3),
    easeInOutCubic: (x)=>x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: (x)=>x * x * x * x,
    easeOutQuart: (x)=>1 - Math.pow(1 - x, 4),
    easeInOutQuart: (x)=>x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: (x)=>x * x * x * x * x,
    easeOutQuint: (x)=>1 - Math.pow(1 - x, 5),
    easeInOutQuint: (x)=>x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: (x)=>1 - Math.cos(x * Math.PI / 2),
    easeOutSine: (x)=>Math.sin(x * Math.PI / 2),
    easeInOutSine: (x)=>-(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: (x)=>x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: (x)=>x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: (x)=>1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: (x)=>x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: (x)=>$fafba8d3e1bed3b4$var$c3 * x * x * x - $fafba8d3e1bed3b4$var$c1 * x * x,
    easeOutBack: (x)=>1 + $fafba8d3e1bed3b4$var$c3 * Math.pow(x - 1, 3) + $fafba8d3e1bed3b4$var$c1 * Math.pow(x - 1, 2),
    easeInOutBack: (x)=>x < 0.5 ? Math.pow(2 * x, 2) * (($fafba8d3e1bed3b4$var$c2 + 1) * 2 * x - $fafba8d3e1bed3b4$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (($fafba8d3e1bed3b4$var$c2 + 1) * (x * 2 - 2) + $fafba8d3e1bed3b4$var$c2) + 2) / 2,
    easeInElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $fafba8d3e1bed3b4$var$c4),
    easeOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * $fafba8d3e1bed3b4$var$c4) + 1,
    easeInOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $fafba8d3e1bed3b4$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $fafba8d3e1bed3b4$var$c5) / 2 + 1,
    easeInBounce: (x)=>1 - $fafba8d3e1bed3b4$var$bounceOut(1 - x),
    easeOutBounce: $fafba8d3e1bed3b4$var$bounceOut,
    easeInOutBounce: (x)=>x < 0.5 ? (1 - $fafba8d3e1bed3b4$var$bounceOut(1 - 2 * x)) / 2 : (1 + $fafba8d3e1bed3b4$var$bounceOut(2 * x - 1)) / 2,
    steps: $fafba8d3e1bed3b4$var$steps
};
// src/fluids.ts
var $fafba8d3e1bed3b4$var$$get = Symbol.for("FluidValue.get");
var $fafba8d3e1bed3b4$var$$observers = Symbol.for("FluidValue.observers");
var $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$fafba8d3e1bed3b4$var$$get]);
var $fafba8d3e1bed3b4$export$e37b7520edd66839 = (arg)=>arg && arg[$fafba8d3e1bed3b4$var$$get] ? arg[$fafba8d3e1bed3b4$var$$get]() : arg;
var $fafba8d3e1bed3b4$export$133f54e9f7cf1796 = (target)=>target[$fafba8d3e1bed3b4$var$$observers] || null;
function $fafba8d3e1bed3b4$export$8cbca1207adce0c0(observer2, event) {
    if (observer2.eventObserved) observer2.eventObserved(event);
    else observer2(event);
}
function $fafba8d3e1bed3b4$export$31752c40a5fab62a(target, event) {
    const observers = target[$fafba8d3e1bed3b4$var$$observers];
    if (observers) observers.forEach((observer2)=>{
        $fafba8d3e1bed3b4$export$8cbca1207adce0c0(observer2, event);
    });
}
var $fafba8d3e1bed3b4$export$aff8e1ac1a016a2 = class {
    constructor(get){
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $fafba8d3e1bed3b4$export$a3b4618659637aa3(this, get);
    }
};
$fafba8d3e1bed3b4$var$$get, $fafba8d3e1bed3b4$var$$observers;
var $fafba8d3e1bed3b4$export$a3b4618659637aa3 = (target, get)=>$fafba8d3e1bed3b4$var$setHidden(target, $fafba8d3e1bed3b4$var$$get, get);
function $fafba8d3e1bed3b4$export$72d604e3f8d000a5(target, observer2) {
    if (target[$fafba8d3e1bed3b4$var$$get]) {
        let observers = target[$fafba8d3e1bed3b4$var$$observers];
        if (!observers) $fafba8d3e1bed3b4$var$setHidden(target, $fafba8d3e1bed3b4$var$$observers, observers = /* @__PURE__ */ new Set());
        if (!observers.has(observer2)) {
            observers.add(observer2);
            if (target.observerAdded) target.observerAdded(observers.size, observer2);
        }
    }
    return observer2;
}
function $fafba8d3e1bed3b4$export$7a0eb830d336339b(target, observer2) {
    const observers = target[$fafba8d3e1bed3b4$var$$observers];
    if (observers && observers.has(observer2)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer2);
        else target[$fafba8d3e1bed3b4$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer2);
    }
}
var $fafba8d3e1bed3b4$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
// src/regexs.ts
var $fafba8d3e1bed3b4$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var $fafba8d3e1bed3b4$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var $fafba8d3e1bed3b4$var$unitRegex = new RegExp(`(${$fafba8d3e1bed3b4$var$numberRegex.source})(%|[a-z]+)`, "i");
var $fafba8d3e1bed3b4$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var $fafba8d3e1bed3b4$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
// src/variableToRgba.ts
var $fafba8d3e1bed3b4$var$variableToRgba = (input)=>{
    const [token, fallback] = $fafba8d3e1bed3b4$var$parseCSSVariable(input);
    if (!token || $fafba8d3e1bed3b4$export$48d7c418edadb60c()) return input;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (value2) return value2;
        else return input;
    } else if (fallback && $fafba8d3e1bed3b4$var$cssVariableRegex.test(fallback)) return $fafba8d3e1bed3b4$var$variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
var $fafba8d3e1bed3b4$var$parseCSSVariable = (current)=>{
    const match = $fafba8d3e1bed3b4$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
};
// src/stringInterpolation.ts
var $fafba8d3e1bed3b4$var$namedColorRegex;
var $fafba8d3e1bed3b4$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var $fafba8d3e1bed3b4$export$4759a013d387347a = (config)=>{
    if (!$fafba8d3e1bed3b4$var$namedColorRegex) $fafba8d3e1bed3b4$var$namedColorRegex = $fafba8d3e1bed3b4$var$colors ? // match color names, ignore partial matches
    new RegExp(`(${Object.keys($fafba8d3e1bed3b4$var$colors).join("|")})(?!\\w)`, "g") : // never match
    /^\b$/;
    const output = config.output.map((value)=>{
        return $fafba8d3e1bed3b4$export$e37b7520edd66839(value).replace($fafba8d3e1bed3b4$var$cssVariableRegex, $fafba8d3e1bed3b4$var$variableToRgba).replace($fafba8d3e1bed3b4$var$colorRegex, $fafba8d3e1bed3b4$export$61db176b839af1f).replace($fafba8d3e1bed3b4$var$namedColorRegex, $fafba8d3e1bed3b4$export$61db176b839af1f);
    });
    const keyframes = output.map((value)=>value.match($fafba8d3e1bed3b4$var$numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output2)=>$fafba8d3e1bed3b4$export$b12af43b97697ef5({
            ...config,
            output: output2
        }));
    return (input)=>{
        const missingUnit = !$fafba8d3e1bed3b4$var$unitRegex.test(output[0]) && output.find((value)=>$fafba8d3e1bed3b4$var$unitRegex.test(value))?.replace($fafba8d3e1bed3b4$var$numberRegex, "");
        let i = 0;
        return output[0].replace($fafba8d3e1bed3b4$var$numberRegex, ()=>`${interpolators[i++](input)}${missingUnit || ""}`).replace($fafba8d3e1bed3b4$var$rgbaRegex, $fafba8d3e1bed3b4$var$rgbaRound);
    };
};
// src/deprecations.ts
var $fafba8d3e1bed3b4$export$82e9f45cca5ba907 = "react-spring: ";
var $fafba8d3e1bed3b4$export$d2de3aaeafa91619 = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$fafba8d3e1bed3b4$export$82e9f45cca5ba907}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
var $fafba8d3e1bed3b4$var$warnInterpolate = $fafba8d3e1bed3b4$export$d2de3aaeafa91619(console.warn);
function $fafba8d3e1bed3b4$export$2abfcde8ae218ba8() {
    $fafba8d3e1bed3b4$var$warnInterpolate(`${$fafba8d3e1bed3b4$export$82e9f45cca5ba907}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var $fafba8d3e1bed3b4$var$warnDirectCall = $fafba8d3e1bed3b4$export$d2de3aaeafa91619(console.warn);
function $fafba8d3e1bed3b4$export$d99d974913ad3b12() {
    $fafba8d3e1bed3b4$var$warnDirectCall(`${$fafba8d3e1bed3b4$export$82e9f45cca5ba907}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
// src/isAnimatedString.ts
function $fafba8d3e1bed3b4$export$75bed621f62abfa9(value) {
    return $fafba8d3e1bed3b4$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
    !$fafba8d3e1bed3b4$export$48d7c418edadb60c() && $fafba8d3e1bed3b4$var$cssVariableRegex.test(value) || value in ($fafba8d3e1bed3b4$var$colors || {}));
}
// src/dom-events/resize/resizeElement.ts
var $fafba8d3e1bed3b4$var$observer;
var $fafba8d3e1bed3b4$var$resizeHandlers = /* @__PURE__ */ new WeakMap();
var $fafba8d3e1bed3b4$var$handleObservation = (entries)=>entries.forEach(({ target: target, contentRect: contentRect })=>{
        return $fafba8d3e1bed3b4$var$resizeHandlers.get(target)?.forEach((handler)=>handler(contentRect));
    });
function $fafba8d3e1bed3b4$var$resizeElement(handler, target) {
    if (!$fafba8d3e1bed3b4$var$observer) {
        if (typeof ResizeObserver !== "undefined") $fafba8d3e1bed3b4$var$observer = new ResizeObserver($fafba8d3e1bed3b4$var$handleObservation);
    }
    let elementHandlers = $fafba8d3e1bed3b4$var$resizeHandlers.get(target);
    if (!elementHandlers) {
        elementHandlers = /* @__PURE__ */ new Set();
        $fafba8d3e1bed3b4$var$resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if ($fafba8d3e1bed3b4$var$observer) $fafba8d3e1bed3b4$var$observer.observe(target);
    return ()=>{
        const elementHandlers2 = $fafba8d3e1bed3b4$var$resizeHandlers.get(target);
        if (!elementHandlers2) return;
        elementHandlers2.delete(handler);
        if (!elementHandlers2.size && $fafba8d3e1bed3b4$var$observer) $fafba8d3e1bed3b4$var$observer.unobserve(target);
    };
}
// src/dom-events/resize/resizeWindow.ts
var $fafba8d3e1bed3b4$var$listeners = /* @__PURE__ */ new Set();
var $fafba8d3e1bed3b4$var$cleanupWindowResizeHandler;
var $fafba8d3e1bed3b4$var$createResizeHandler = ()=>{
    const handleResize = ()=>{
        $fafba8d3e1bed3b4$var$listeners.forEach((callback)=>callback({
                width: window.innerWidth,
                height: window.innerHeight
            }));
    };
    window.addEventListener("resize", handleResize);
    return ()=>{
        window.removeEventListener("resize", handleResize);
    };
};
var $fafba8d3e1bed3b4$var$resizeWindow = (callback)=>{
    $fafba8d3e1bed3b4$var$listeners.add(callback);
    if (!$fafba8d3e1bed3b4$var$cleanupWindowResizeHandler) $fafba8d3e1bed3b4$var$cleanupWindowResizeHandler = $fafba8d3e1bed3b4$var$createResizeHandler();
    return ()=>{
        $fafba8d3e1bed3b4$var$listeners.delete(callback);
        if (!$fafba8d3e1bed3b4$var$listeners.size && $fafba8d3e1bed3b4$var$cleanupWindowResizeHandler) {
            $fafba8d3e1bed3b4$var$cleanupWindowResizeHandler();
            $fafba8d3e1bed3b4$var$cleanupWindowResizeHandler = void 0;
        }
    };
};
// src/dom-events/resize/index.ts
var $fafba8d3e1bed3b4$export$45b39e67d4ce4921 = (callback, { container: container = document.documentElement } = {})=>{
    if (container === document.documentElement) return $fafba8d3e1bed3b4$var$resizeWindow(callback);
    else return $fafba8d3e1bed3b4$var$resizeElement(callback, container);
};
// src/progress.ts
var $fafba8d3e1bed3b4$var$progress = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);
// src/dom-events/scroll/ScrollHandler.ts
var $fafba8d3e1bed3b4$var$SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
var $fafba8d3e1bed3b4$var$ScrollHandler = class {
    constructor(callback, container){
        this.createAxis = ()=>({
                current: 0,
                progress: 0,
                scrollLength: 0
            });
        this.updateAxis = (axisName)=>{
            const axis = this.info[axisName];
            const { length: length, position: position } = $fafba8d3e1bed3b4$var$SCROLL_KEYS[axisName];
            axis.current = this.container[`scroll${position}`];
            axis.scrollLength = this.container["scroll" + length] - this.container["client" + length];
            axis.progress = $fafba8d3e1bed3b4$var$progress(0, axis.scrollLength, axis.current);
        };
        this.update = ()=>{
            this.updateAxis("x");
            this.updateAxis("y");
        };
        this.sendEvent = ()=>{
            this.callback(this.info);
        };
        this.advance = ()=>{
            this.update();
            this.sendEvent();
        };
        this.callback = callback;
        this.container = container;
        this.info = {
            time: 0,
            x: this.createAxis(),
            y: this.createAxis()
        };
    }
};
// src/dom-events/scroll/index.ts
var $fafba8d3e1bed3b4$var$scrollListeners = /* @__PURE__ */ new WeakMap();
var $fafba8d3e1bed3b4$var$resizeListeners = /* @__PURE__ */ new WeakMap();
var $fafba8d3e1bed3b4$var$onScrollHandlers = /* @__PURE__ */ new WeakMap();
var $fafba8d3e1bed3b4$var$getTarget = (container)=>container === document.documentElement ? window : container;
var $fafba8d3e1bed3b4$export$d4d89fd61e5416ee = (callback, { container: container = document.documentElement } = {})=>{
    let containerHandlers = $fafba8d3e1bed3b4$var$onScrollHandlers.get(container);
    if (!containerHandlers) {
        containerHandlers = /* @__PURE__ */ new Set();
        $fafba8d3e1bed3b4$var$onScrollHandlers.set(container, containerHandlers);
    }
    const containerHandler = new $fafba8d3e1bed3b4$var$ScrollHandler(callback, container);
    containerHandlers.add(containerHandler);
    if (!$fafba8d3e1bed3b4$var$scrollListeners.has(container)) {
        const listener = ()=>{
            containerHandlers?.forEach((handler)=>handler.advance());
            return true;
        };
        $fafba8d3e1bed3b4$var$scrollListeners.set(container, listener);
        const target = $fafba8d3e1bed3b4$var$getTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $fafba8d3e1bed3b4$var$resizeListeners.set(container, $fafba8d3e1bed3b4$export$45b39e67d4ce4921(listener, {
            container: container
        }));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const animateScroll = $fafba8d3e1bed3b4$var$scrollListeners.get(container);
    $fafba8d3e1bed3b4$export$27f233d61a9e2fa4(animateScroll);
    return ()=>{
        $fafba8d3e1bed3b4$export$27f233d61a9e2fa4.cancel(animateScroll);
        const containerHandlers2 = $fafba8d3e1bed3b4$var$onScrollHandlers.get(container);
        if (!containerHandlers2) return;
        containerHandlers2.delete(containerHandler);
        if (containerHandlers2.size) return;
        const listener = $fafba8d3e1bed3b4$var$scrollListeners.get(container);
        $fafba8d3e1bed3b4$var$scrollListeners.delete(container);
        if (listener) {
            $fafba8d3e1bed3b4$var$getTarget(container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            $fafba8d3e1bed3b4$var$resizeListeners.get(container)?.();
        }
    };
};
function $fafba8d3e1bed3b4$export$fe4300aa8eebea86(init) {
    const ref = (0, $exYeM.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
var $fafba8d3e1bed3b4$export$700979bc83e7db82 = $fafba8d3e1bed3b4$export$48d7c418edadb60c() ? (0, $exYeM.useEffect) : (0, $exYeM.useLayoutEffect);
// src/hooks/useIsMounted.ts
var $fafba8d3e1bed3b4$var$useIsMounted = ()=>{
    const isMounted = (0, $exYeM.useRef)(false);
    $fafba8d3e1bed3b4$export$700979bc83e7db82(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
// src/hooks/useForceUpdate.ts
function $fafba8d3e1bed3b4$export$91db9bc4f8ac944a() {
    const update2 = (0, $exYeM.useState)()[1];
    const isMounted = $fafba8d3e1bed3b4$var$useIsMounted();
    return ()=>{
        if (isMounted.current) update2(Math.random());
    };
}
function $fafba8d3e1bed3b4$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $exYeM.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $exYeM.useRef)();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && $fafba8d3e1bed3b4$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $exYeM.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = void 0;
    }, [
        cache
    ]);
    return cache.result;
}
function $fafba8d3e1bed3b4$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
var $fafba8d3e1bed3b4$export$392544347a18b6ea = (effect)=>(0, $exYeM.useEffect)(effect, $fafba8d3e1bed3b4$var$emptyDeps);
var $fafba8d3e1bed3b4$var$emptyDeps = [];
function $fafba8d3e1bed3b4$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $exYeM.useRef)();
    (0, $exYeM.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
var $fafba8d3e1bed3b4$export$6a42007cf1e7b6f8 = ()=>{
    const [reducedMotion, setReducedMotion] = (0, $exYeM.useState)(null);
    $fafba8d3e1bed3b4$export$700979bc83e7db82(()=>{
        const mql = window.matchMedia("(prefers-reduced-motion)");
        const handleMediaChange = (e)=>{
            setReducedMotion(e.matches);
            $fafba8d3e1bed3b4$var$assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        mql.addEventListener("change", handleMediaChange);
        return ()=>{
            mql.removeEventListener("change", handleMediaChange);
        };
    }, []);
    return reducedMotion;
};



var $exYeM = parcelRequire("exYeM");
// src/Animated.ts


var $exYeM = parcelRequire("exYeM");
var $7bf293f4fe511ca6$var$$node = Symbol.for("Animated:node");
var $7bf293f4fe511ca6$export$3df5e165e801a70f = (value)=>!!value && value[$7bf293f4fe511ca6$var$$node] === value;
var $7bf293f4fe511ca6$export$6b63995194a3a9e4 = (owner)=>owner && owner[$7bf293f4fe511ca6$var$$node];
var $7bf293f4fe511ca6$export$b553cb5b22b81b04 = (owner, node)=>(0, $fafba8d3e1bed3b4$export$5c74248ea0e35446)(owner, $7bf293f4fe511ca6$var$$node, node);
var $7bf293f4fe511ca6$export$ccab2b64c5d440 = (owner)=>owner && owner[$7bf293f4fe511ca6$var$$node] && owner[$7bf293f4fe511ca6$var$$node].getPayload();
var $7bf293f4fe511ca6$export$31627395a3b18e54 = class {
    constructor(){
        $7bf293f4fe511ca6$export$b553cb5b22b81b04(this, this);
    }
    /** Get every `AnimatedValue` used by this node. */ getPayload() {
        return this.payload || [];
    }
};
var $7bf293f4fe511ca6$export$cb1e8f3c05d37ad5 = class extends $7bf293f4fe511ca6$export$31627395a3b18e54 {
    constructor(_value){
        super();
        this._value = _value;
        this.done = true;
        this.durationProgress = 0;
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).num(this._value)) this.lastPosition = this._value;
    }
    /** @internal */ static create(value) {
        return new $7bf293f4fe511ca6$export$cb1e8f3c05d37ad5(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done } = this;
        this.done = false;
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
};
var $7bf293f4fe511ca6$export$f6c6c4cbd7fa5b93 = class extends $7bf293f4fe511ca6$export$cb1e8f3c05d37ad5 {
    constructor(value){
        super(0);
        this._string = null;
        this._toString = (0, $fafba8d3e1bed3b4$export$b12af43b97697ef5)({
            output: [
                value,
                value
            ]
        });
    }
    /** @internal */ static create(value) {
        return new $7bf293f4fe511ca6$export$f6c6c4cbd7fa5b93(value);
    }
    getValue() {
        const value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $fafba8d3e1bed3b4$export$b12af43b97697ef5)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
};
// src/context.ts
var $7bf293f4fe511ca6$var$TreeContext = {
    dependencies: null
};
// src/AnimatedObject.ts
var $7bf293f4fe511ca6$export$f1b0b9e366a6e2d4 = class extends $7bf293f4fe511ca6$export$31627395a3b18e54 {
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
    getValue(animated) {
        const values = {};
        (0, $fafba8d3e1bed3b4$export$f4c6fe153f5a944e)(this.source, (source, key)=>{
            if ($7bf293f4fe511ca6$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(source)) values[key] = (0, $fafba8d3e1bed3b4$export$e37b7520edd66839)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    /** Replace the raw object data */ setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(this.payload, (node)=>node.reset());
    }
    /** Create a payload set. */ _makePayload(source) {
        if (source) {
            const payload = /* @__PURE__ */ new Set();
            (0, $fafba8d3e1bed3b4$export$f4c6fe153f5a944e)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    /** Add to a payload set. */ _addToPayload(source) {
        if ($7bf293f4fe511ca6$var$TreeContext.dependencies && (0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(source)) $7bf293f4fe511ca6$var$TreeContext.dependencies.add(source);
        const payload = $7bf293f4fe511ca6$export$ccab2b64c5d440(source);
        if (payload) (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(payload, (node)=>this.add(node));
    }
};
// src/AnimatedArray.ts
var $7bf293f4fe511ca6$export$ede394683406942d = class extends $7bf293f4fe511ca6$export$f1b0b9e366a6e2d4 {
    constructor(source){
        super(source);
    }
    /** @internal */ static create(source) {
        return new $7bf293f4fe511ca6$export$ede394683406942d(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($7bf293f4fe511ca6$var$makeAnimated));
        return true;
    }
};
function $7bf293f4fe511ca6$var$makeAnimated(value) {
    const nodeType = (0, $fafba8d3e1bed3b4$export$75bed621f62abfa9)(value) ? $7bf293f4fe511ca6$export$f6c6c4cbd7fa5b93 : $7bf293f4fe511ca6$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $7bf293f4fe511ca6$export$e6b77ddbe47b132e(value) {
    const parentNode = $7bf293f4fe511ca6$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).arr(value) ? $7bf293f4fe511ca6$export$ede394683406942d : (0, $fafba8d3e1bed3b4$export$75bed621f62abfa9)(value) ? $7bf293f4fe511ca6$export$f6c6c4cbd7fa5b93 : $7bf293f4fe511ca6$export$cb1e8f3c05d37ad5;
}
var $7bf293f4fe511ca6$var$withAnimated = (Component, host)=>{
    const hasInstance = // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $exYeM.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $exYeM.useRef)(null);
        const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $exYeM.useCallback)((value)=>{
            instanceRef.current = $7bf293f4fe511ca6$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $7bf293f4fe511ca6$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $fafba8d3e1bed3b4$export$91db9bc4f8ac944a)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new $7bf293f4fe511ca6$var$PropsObserver(callback, deps);
        const observerRef = (0, $exYeM.useRef)();
        (0, $fafba8d3e1bed3b4$export$700979bc83e7db82)(()=>{
            observerRef.current = observer;
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(deps, (dep)=>(0, $fafba8d3e1bed3b4$export$72d604e3f8d000a5)(dep, observer));
            return ()=>{
                if (observerRef.current) {
                    (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(observerRef.current.deps, (dep)=>(0, $fafba8d3e1bed3b4$export$7a0eb830d336339b)(dep, observerRef.current));
                    (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).cancel(observerRef.current.update);
                }
            };
        });
        (0, $exYeM.useEffect)(callback, []);
        (0, $fafba8d3e1bed3b4$export$392544347a18b6ea)(()=>()=>{
                const observer2 = observerRef.current;
                (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(observer2.deps, (dep)=>(0, $fafba8d3e1bed3b4$export$7a0eb830d336339b)(dep, observer2));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return /* @__PURE__ */ $exYeM.createElement(Component, {
            ...usedProps,
            ref: ref
        });
    });
};
var $7bf293f4fe511ca6$var$PropsObserver = class {
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
    eventObserved(event) {
        if (event.type == "change") (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).write(this.update);
    }
};
function $7bf293f4fe511ca6$var$getAnimatedState(props, host) {
    const dependencies = /* @__PURE__ */ new Set();
    $7bf293f4fe511ca6$var$TreeContext.dependencies = dependencies;
    if (props.style) props = {
        ...props,
        style: host.createAnimatedStyle(props.style)
    };
    props = new $7bf293f4fe511ca6$export$f1b0b9e366a6e2d4(props);
    $7bf293f4fe511ca6$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $7bf293f4fe511ca6$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
// src/createHost.ts
var $7bf293f4fe511ca6$var$cacheKey = Symbol.for("AnimatedComponent");
var $7bf293f4fe511ca6$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: applyAnimatedValues = ()=>false, createAnimatedStyle: createAnimatedStyle = (style)=>new $7bf293f4fe511ca6$export$f1b0b9e366a6e2d4(style), getComponentProps: getComponentProps = (props)=>props } = {})=>{
    const hostConfig = {
        applyAnimatedValues: applyAnimatedValues,
        createAnimatedStyle: createAnimatedStyle,
        getComponentProps: getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $7bf293f4fe511ca6$var$getDisplayName(Component) || "Anonymous";
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).str(Component)) Component = animated[Component] || (animated[Component] = $7bf293f4fe511ca6$var$withAnimated(Component, hostConfig));
        else Component = Component[$7bf293f4fe511ca6$var$cacheKey] || (Component[$7bf293f4fe511ca6$var$cacheKey] = $7bf293f4fe511ca6$var$withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $fafba8d3e1bed3b4$export$f4c6fe153f5a944e)(components, (Component, key)=>{
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).arr(components)) key = $7bf293f4fe511ca6$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
var $7bf293f4fe511ca6$var$getDisplayName = (arg)=>(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).str(arg) ? arg : arg && (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).str(arg.displayName) ? arg.displayName : (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(arg) && arg.name || null;


// src/utils.ts
var $f1caa117d6d189d7$export$b24b633b1364b94b = class {
};


function $9f726edb03f4840c$var$callProp(value, ...args) {
    return (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(value) ? value(...args) : value;
}
var $9f726edb03f4840c$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(value) ? value(key) : (0, $fafba8d3e1bed3b4$export$45b10814cc054894)(value).includes(key)));
var $9f726edb03f4840c$var$resolveProp = (prop, key)=>(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(prop) ? key && prop[key] : prop;
var $9f726edb03f4840c$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var $9f726edb03f4840c$var$noopTransform = (value)=>value;
var $9f726edb03f4840c$var$getDefaultProps = (props, transform = $9f726edb03f4840c$var$noopTransform)=>{
    let keys = $9f726edb03f4840c$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults2 = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(value)) defaults2[key] = value;
    }
    return defaults2;
};
var $9f726edb03f4840c$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
var $9f726edb03f4840c$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    // Transition props
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    // Internal props
    keys: 1,
    callId: 1,
    parentId: 1
};
function $9f726edb03f4840c$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $fafba8d3e1bed3b4$export$f4c6fe153f5a944e)(props, (value, prop)=>{
        if (!$9f726edb03f4840c$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $9f726edb03f4840c$export$b971039a739bf227(props) {
    const to2 = $9f726edb03f4840c$var$getForwardProps(props);
    if (to2) {
        const out = {
            to: to2
        };
        (0, $fafba8d3e1bed3b4$export$f4c6fe153f5a944e)(props, (val, key)=>key in to2 || (out[key] = val));
        return out;
    }
    return {
        ...props
    };
}
function $9f726edb03f4840c$var$computeGoal(value) {
    value = (0, $fafba8d3e1bed3b4$export$e37b7520edd66839)(value);
    return (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).arr(value) ? value.map($9f726edb03f4840c$var$computeGoal) : (0, $fafba8d3e1bed3b4$export$75bed621f62abfa9)(value) ? (0, $fafba8d3e1bed3b4$export$cceeabf822b64fc0).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $9f726edb03f4840c$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $9f726edb03f4840c$var$isAsyncTo(to2) {
    return (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(to2) || (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).arr(to2) && (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(to2[0]);
}
function $9f726edb03f4840c$var$detachRefs(ctrl, ref) {
    ctrl.ref?.delete(ctrl);
    ref?.delete(ctrl);
}
function $9f726edb03f4840c$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        ctrl.ref?.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
// src/hooks/useChain.ts
function $9f726edb03f4840c$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1e3) {
    (0, $fafba8d3e1bed3b4$export$700979bc83e7db82)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(controllers, (ctrl)=>{
                        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $9f726edb03f4840c$var$callProp(memoizedDelayProp || 0, key);
                        });
                    });
                    ref.start();
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(controllers, (ctrl, i)=>(0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(queues[i] || [], (update2)=>ctrl.queue.push(update2)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
// src/constants.ts
var $9f726edb03f4840c$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
// src/AnimationConfig.ts
var $9f726edb03f4840c$var$defaults = {
    ...$9f726edb03f4840c$export$e506a1d27d1eaa20.default,
    mass: 1,
    damping: 1,
    easing: (0, $fafba8d3e1bed3b4$export$15a0bf1b4bbacad8).linear,
    clamp: false
};
var $9f726edb03f4840c$var$AnimationConfig = class {
    constructor(){
        /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */ this.velocity = 0;
        Object.assign(this, $9f726edb03f4840c$var$defaults);
    }
};
function $9f726edb03f4840c$var$mergeConfig(config2, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = {
            ...defaultConfig
        };
        $9f726edb03f4840c$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = {
            ...defaultConfig,
            ...newConfig
        };
    }
    $9f726edb03f4840c$var$sanitizeConfig(config2, newConfig);
    Object.assign(config2, newConfig);
    for(const key in $9f726edb03f4840c$var$defaults)if (config2[key] == null) config2[key] = $9f726edb03f4840c$var$defaults[key];
    let { frequency: frequency, damping: damping } = config2;
    const { mass: mass } = config2;
    if (!(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config2.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config2;
}
function $9f726edb03f4840c$var$sanitizeConfig(config2, props) {
    if (!(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props.decay)) config2.duration = void 0;
    else {
        const isTensionConfig = !(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props.tension) || !(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props.friction);
        if (isTensionConfig || !(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props.frequency) || !(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props.damping) || !(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props.mass)) {
            config2.duration = void 0;
            config2.decay = void 0;
        }
        if (isTensionConfig) config2.frequency = void 0;
    }
}
// src/Animation.ts
var $9f726edb03f4840c$var$emptyArray = [];
var $9f726edb03f4840c$var$Animation = class {
    constructor(){
        this.changed = false;
        this.values = $9f726edb03f4840c$var$emptyArray;
        this.toValues = null;
        this.fromValues = $9f726edb03f4840c$var$emptyArray;
        this.config = new $9f726edb03f4840c$var$AnimationConfig();
        this.immediate = false;
    }
};
function $9f726edb03f4840c$var$scheduleProps(callId, { key: key, props: props, defaultProps: defaultProps, state: state, actions: actions }) {
    return new Promise((resolve, reject)=>{
        let delay;
        let timeout;
        let cancel = $9f726edb03f4840c$var$matchProp(props.cancel ?? defaultProps?.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props.pause)) state.paused = $9f726edb03f4840c$var$matchProp(props.pause, key);
            let pause = defaultProps?.pause;
            if (pause !== true) pause = state.paused || $9f726edb03f4840c$var$matchProp(pause, key);
            delay = $9f726edb03f4840c$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $fafba8d3e1bed3b4$export$cceeabf822b64fc0).skipAnimation) {
                state.delayed = true;
                timeout = (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start({
                    ...props,
                    callId: callId,
                    cancel: cancel
                }, resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
// src/AnimationResult.ts
var $9f726edb03f4840c$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $9f726edb03f4840c$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $9f726edb03f4840c$var$getNoopResult(target.get()) : $9f726edb03f4840c$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
var $9f726edb03f4840c$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
var $9f726edb03f4840c$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
var $9f726edb03f4840c$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
// src/runAsync.ts
function $9f726edb03f4840c$var$runAsync(to2, props, state, target) {
    const { callId: callId, parentId: parentId, onRest: onRest } = props;
    const { asyncTo: prevTo, promise: prevPromise } = state;
    if (!parentId && to2 === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to2;
        const defaultProps = $9f726edb03f4840c$var$getDefaultProps(props, (value, key)=>// The `onRest` prop is only called when the `runAsync` promise is resolved.
            key === "onRest" ? void 0 : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = // The `cancel` prop or `stop` method was used.
            callId <= (state.cancelId || 0) && $9f726edb03f4840c$var$getCancelledResult(target) || // The async `to` prop was replaced.
            callId !== state.asyncId && $9f726edb03f4840c$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new $9f726edb03f4840c$export$d362d093fa99dc7();
            const skipAnimationSignal = new $9f726edb03f4840c$var$SkipAnimationSignal();
            return (async ()=>{
                if ((0, $fafba8d3e1bed3b4$export$cceeabf822b64fc0).skipAnimation) {
                    $9f726edb03f4840c$var$stopAsync(state);
                    skipAnimationSignal.result = $9f726edb03f4840c$var$getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props2 = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(arg1) ? {
                    ...arg1
                } : {
                    ...arg2,
                    to: arg1
                };
                props2.parentId = callId;
                (0, $fafba8d3e1bed3b4$export$f4c6fe153f5a944e)(defaultProps, (value, key)=>{
                    if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props2[key])) props2[key] = value;
                });
                const result2 = await target.start(props2);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result2;
            })();
        };
        let result;
        if ((0, $fafba8d3e1bed3b4$export$cceeabf822b64fc0).skipAnimation) {
            $9f726edb03f4840c$var$stopAsync(state);
            return $9f726edb03f4840c$var$getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).arr(to2)) animating = (async (queue)=>{
                for (const props2 of queue)await animate(props2);
            })(to2);
            else animating = Promise.resolve(to2(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $9f726edb03f4840c$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $9f726edb03f4840c$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $9f726edb03f4840c$var$SkipAnimationSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : void 0;
                state.promise = parentId ? prevPromise : void 0;
            }
        }
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(onRest)) (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function $9f726edb03f4840c$var$stopAsync(state, cancelId) {
    (0, $fafba8d3e1bed3b4$export$4909b86c8034bf73)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = void 0;
    if (cancelId) state.cancelId = cancelId;
}
var $9f726edb03f4840c$export$d362d093fa99dc7 = class extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
};
var $9f726edb03f4840c$var$SkipAnimationSignal = class extends Error {
    constructor(){
        super("SkipAnimationSignal");
    }
};
var $9f726edb03f4840c$var$isFrameValue = (value)=>value instanceof $9f726edb03f4840c$export$8229896f80e2495e;
var $9f726edb03f4840c$var$nextId = 1;
var $9f726edb03f4840c$export$8229896f80e2495e = class extends (0, $fafba8d3e1bed3b4$export$aff8e1ac1a016a2) {
    constructor(){
        super(...arguments);
        this.id = $9f726edb03f4840c$var$nextId++;
        this._priority = 0;
    }
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    /** Get the current value */ get() {
        const node = (0, $7bf293f4fe511ca6$export$6b63995194a3a9e4)(this);
        return node && node.getValue();
    }
    /** Create a spring that maps our value to another value */ to(...args) {
        return (0, $fafba8d3e1bed3b4$export$cceeabf822b64fc0).to(this, args);
    }
    /** @deprecated Use the `to` method instead. */ interpolate(...args) {
        (0, $fafba8d3e1bed3b4$export$2abfcde8ae218ba8)();
        return (0, $fafba8d3e1bed3b4$export$cceeabf822b64fc0).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    /** Called when the first child is added. */ _attach() {}
    /** Called when the last child is removed. */ _detach() {}
    /** Tell our children about our new value */ _onChange(value, idle = false) {
        (0, $fafba8d3e1bed3b4$export$31752c40a5fab62a)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    /** Tell our children about our new priority */ _onPriorityChange(priority) {
        if (!this.idle) (0, $fafba8d3e1bed3b4$export$a57f5080a3bcc90a).sort(this);
        (0, $fafba8d3e1bed3b4$export$31752c40a5fab62a)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
};
// src/SpringPhase.ts
var $9f726edb03f4840c$var$$P = Symbol.for("SpringPhase");
var $9f726edb03f4840c$var$HAS_ANIMATED = 1;
var $9f726edb03f4840c$var$IS_ANIMATING = 2;
var $9f726edb03f4840c$var$IS_PAUSED = 4;
var $9f726edb03f4840c$var$hasAnimated = (target)=>(target[$9f726edb03f4840c$var$$P] & $9f726edb03f4840c$var$HAS_ANIMATED) > 0;
var $9f726edb03f4840c$var$isAnimating = (target)=>(target[$9f726edb03f4840c$var$$P] & $9f726edb03f4840c$var$IS_ANIMATING) > 0;
var $9f726edb03f4840c$var$isPaused = (target)=>(target[$9f726edb03f4840c$var$$P] & $9f726edb03f4840c$var$IS_PAUSED) > 0;
var $9f726edb03f4840c$var$setActiveBit = (target, active)=>active ? target[$9f726edb03f4840c$var$$P] |= $9f726edb03f4840c$var$IS_ANIMATING | $9f726edb03f4840c$var$HAS_ANIMATED : target[$9f726edb03f4840c$var$$P] &= ~$9f726edb03f4840c$var$IS_ANIMATING;
var $9f726edb03f4840c$var$setPausedBit = (target, paused)=>paused ? target[$9f726edb03f4840c$var$$P] |= $9f726edb03f4840c$var$IS_PAUSED : target[$9f726edb03f4840c$var$$P] &= ~$9f726edb03f4840c$var$IS_PAUSED;
// src/SpringValue.ts
var $9f726edb03f4840c$export$5854d13427d5a954 = class extends $9f726edb03f4840c$export$8229896f80e2495e {
    constructor(arg1, arg2){
        super();
        /** The animation state */ this.animation = new $9f726edb03f4840c$var$Animation();
        /** Some props have customizable default values */ this.defaultProps = {};
        /** The state for `runAsync` calls */ this._state = {
            paused: false,
            delayed: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The promise resolvers of pending `start` calls */ this._pendingCalls = /* @__PURE__ */ new Set();
        /** The counter for tracking `scheduleProps` calls */ this._lastCallId = 0;
        /** The last `scheduleProps` call that changed the `to` prop */ this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(arg1) || !(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(arg2)) {
            const props = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(arg1) ? {
                ...arg1
            } : {
                ...arg2,
                from: arg1
            };
            if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props.default)) props.default = true;
            this.start(props);
        }
    }
    /** Equals true when not advancing on each frame. */ get idle() {
        return !($9f726edb03f4840c$var$isAnimating(this) || this._state.asyncTo) || $9f726edb03f4840c$var$isPaused(this);
    }
    get goal() {
        return (0, $fafba8d3e1bed3b4$export$e37b7520edd66839)(this.animation.to);
    }
    get velocity() {
        const node = (0, $7bf293f4fe511ca6$export$6b63995194a3a9e4)(this);
        return node instanceof (0, $7bf293f4fe511ca6$export$cb1e8f3c05d37ad5) ? node.lastVelocity || 0 : node.getPayload().map((node2)=>node2.lastVelocity || 0);
    }
    /**
   * When true, this value has been animated at least once.
   */ get hasAnimated() {
        return $9f726edb03f4840c$var$hasAnimated(this);
    }
    /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */ get isAnimating() {
        return $9f726edb03f4840c$var$isAnimating(this);
    }
    /**
   * When true, all current and future animations are paused.
   */ get isPaused() {
        return $9f726edb03f4840c$var$isPaused(this);
    }
    /**
   *
   *
   */ get isDelayed() {
        return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */ advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { toValues: toValues } = anim;
        const { config: config2 } = anim;
        const payload = (0, $7bf293f4fe511ca6$export$ccab2b64c5d440)(anim.to);
        if (!payload && (0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(anim.to)) toValues = (0, $fafba8d3e1bed3b4$export$45b10814cc054894)((0, $fafba8d3e1bed3b4$export$e37b7520edd66839)(anim.to));
        anim.values.forEach((node2, i)=>{
            if (node2.done) return;
            const to2 = // Animated strings always go from 0 to 1.
            node2.constructor == (0, $7bf293f4fe511ca6$export$f6c6c4cbd7fa5b93) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to2;
            if (!finished) {
                position = node2.lastPosition;
                if (config2.tension <= 0) {
                    node2.done = true;
                    return;
                }
                let elapsed = node2.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node2.v0 != null ? node2.v0 : node2.v0 = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
                let velocity;
                const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
                if (!(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(config2.duration)) {
                    let p = 1;
                    if (config2.duration > 0) {
                        if (this._memoizedDuration !== config2.duration) {
                            this._memoizedDuration = config2.duration;
                            if (node2.durationProgress > 0) {
                                node2.elapsedTime = config2.duration * node2.durationProgress;
                                elapsed = node2.elapsedTime += dt;
                            }
                        }
                        p = (config2.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node2.durationProgress = p;
                    }
                    position = from + config2.easing(p) * (to2 - from);
                    velocity = (position - node2.lastPosition) / dt;
                    finished = p == 1;
                } else if (config2.decay) {
                    const decay = config2.decay === true ? 0.998 : config2.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node2.lastPosition - position) <= precision;
                    velocity = v0 * e;
                } else {
                    velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
                    const restVelocity = config2.restVelocity || precision / 10;
                    const bounceFactor = config2.clamp ? 0 : config2.bounce;
                    const canBounce = !(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(bounceFactor);
                    const isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to2 - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to2 || position > to2 == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to2;
                            }
                        }
                        const springForce = -config2.tension * 1e-6 * (position - to2);
                        const dampingForce = -config2.friction * 1e-3 * velocity;
                        const acceleration = (springForce + dampingForce) / config2.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node2.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node2.done = true;
            else idle = false;
            if (node2.setValue(position, config2.round)) changed = true;
        });
        const node = (0, $7bf293f4fe511ca6$export$6b63995194a3a9e4)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $fafba8d3e1bed3b4$export$e37b7520edd66839)(anim.to);
            if ((currVal !== finalVal || changed) && !config2.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config2.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    /** Set the current value, while stopping the current animation */ set(value) {
        (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */ pause() {
        this._update({
            pause: true
        });
    }
    /** Resume the animation if paused. */ resume() {
        this._update({
            pause: false
        });
    }
    /** Skip to the end of the current animation. */ finish() {
        if ($9f726edb03f4840c$var$isAnimating(this)) {
            const { to: to2, config: config2 } = this.animation;
            (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                this._onStart();
                if (!config2.decay) this._set(to2, false);
                this._stop();
            });
        }
        return this;
    }
    /** Push props into the pending queue. */ update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to2, arg2) {
        let queue;
        if (!(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(to2)) queue = [
            (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(to2) ? to2 : {
                ...arg2,
                to: to2
            }
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>{
            const up = this._update(props);
            return up;
        })).then((results)=>$9f726edb03f4840c$var$getCombinedResult(this, results));
    }
    /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */ stop(cancel) {
        const { to: to2 } = this.animation;
        this._focus(this.get());
        $9f726edb03f4840c$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).batchedUpdates(()=>this._stop(to2, cancel));
        return this;
    }
    /** Restart the animation. */ reset() {
        this._update({
            reset: true
        });
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */ _prepareNode(props) {
        const key = this.key || "";
        let { to: to2, from: from } = props;
        to2 = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(to2) ? to2[key] : to2;
        if (to2 == null || $9f726edb03f4840c$var$isAsyncTo(to2)) to2 = void 0;
        from = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(from) ? from[key] : from;
        if (from == null) from = void 0;
        const range = {
            to: to2,
            from: from
        };
        if (!$9f726edb03f4840c$var$hasAnimated(this)) {
            if (props.reverse) [to2, from] = [
                from,
                to2
            ];
            from = (0, $fafba8d3e1bed3b4$export$e37b7520edd66839)(from);
            if (!(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(from)) this._set(from);
            else if (!(0, $7bf293f4fe511ca6$export$6b63995194a3a9e4)(this)) this._set(to2);
        }
        return range;
    }
    /** Every update is processed by this method before merging. */ _update({ ...props }, isLoop) {
        const { key: key, defaultProps: defaultProps } = this;
        if (props.default) Object.assign(defaultProps, $9f726edb03f4840c$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $9f726edb03f4840c$var$resolveProp(value, key) : value));
        $9f726edb03f4840c$var$mergeActiveFn(this, props, "onProps");
        $9f726edb03f4840c$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $9f726edb03f4840c$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$9f726edb03f4840c$var$isPaused(this)) {
                        $9f726edb03f4840c$var$setPausedBit(this, true);
                        (0, $fafba8d3e1bed3b4$export$7ba486852759e806)(state.pauseQueue);
                        $9f726edb03f4840c$var$sendEvent(this, "onPause", $9f726edb03f4840c$var$getFinishedResult(this, $9f726edb03f4840c$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($9f726edb03f4840c$var$isPaused(this)) {
                        $9f726edb03f4840c$var$setPausedBit(this, false);
                        if ($9f726edb03f4840c$var$isAnimating(this)) this._resume();
                        (0, $fafba8d3e1bed3b4$export$7ba486852759e806)(state.resumeQueue);
                        $9f726edb03f4840c$var$sendEvent(this, "onResume", $9f726edb03f4840c$var$getFinishedResult(this, $9f726edb03f4840c$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $9f726edb03f4840c$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    /** Merge props into the current animation */ _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($9f726edb03f4840c$var$getCancelledResult(this));
        }
        const hasToProp = !(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(range.to);
        const hasFromProp = !(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($9f726edb03f4840c$var$getCancelledResult(this));
        }
        const { key: key, defaultProps: defaultProps, animation: anim } = this;
        const { to: prevTo, from: prevFrom } = anim;
        let { to: to2 = prevTo, from: from = prevFrom } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(to2))) to2 = from;
        if (props.reverse) [to2, from] = [
            from,
            to2
        ];
        const hasFromChanged = !(0, $fafba8d3e1bed3b4$export$248d38f6296296c5)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $fafba8d3e1bed3b4$export$e37b7520edd66839)(from);
        const hasToChanged = !(0, $fafba8d3e1bed3b4$export$248d38f6296296c5)(to2, prevTo);
        if (hasToChanged) this._focus(to2);
        const hasAsyncTo = $9f726edb03f4840c$var$isAsyncTo(props.to);
        const { config: config2 } = anim;
        const { decay: decay, velocity: velocity } = config2;
        if (hasToProp || hasFromProp) config2.velocity = 0;
        if (props.config && !hasAsyncTo) $9f726edb03f4840c$var$mergeConfig(config2, $9f726edb03f4840c$var$callProp(props.config, key), // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? $9f726edb03f4840c$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $7bf293f4fe511ca6$export$6b63995194a3a9e4)(this);
        if (!node || (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(to2)) return resolve($9f726edb03f4840c$var$getFinishedResult(this, true));
        const reset = // When `reset` is undefined, the `from` prop implies `reset: true`,
        // except for declarative updates. When `reset` is defined, there
        // must exist a value to animate from.
        (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props.reset) ? hasFromProp && !props.default : !(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(from) && $9f726edb03f4840c$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $9f726edb03f4840c$var$computeGoal(to2);
        const isAnimatable = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).num(goal) || (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).arr(goal) || (0, $fafba8d3e1bed3b4$export$75bed621f62abfa9)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $9f726edb03f4840c$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $7bf293f4fe511ca6$export$e6b77ddbe47b132e)(to2);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(to2);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$9f726edb03f4840c$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $fafba8d3e1bed3b4$export$248d38f6296296c5)($9f726edb03f4840c$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $fafba8d3e1bed3b4$export$248d38f6296296c5)(anim.immediate, immediate) && !immediate || !(0, $fafba8d3e1bed3b4$export$248d38f6296296c5)(config2.decay, decay) || !(0, $fafba8d3e1bed3b4$export$248d38f6296296c5)(config2.velocity, velocity)) started = true;
        }
        if (finished && $9f726edb03f4840c$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(to2) ? null : goalType == (0, $7bf293f4fe511ca6$export$f6c6c4cbd7fa5b93) ? [
                    1
                ] : (0, $fafba8d3e1bed3b4$export$45b10814cc054894)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest } = anim;
                (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)($9f726edb03f4840c$var$ACTIVE_EVENTS, (type)=>$9f726edb03f4840c$var$mergeActiveFn(this, props, type));
                const result = $9f726edb03f4840c$var$getFinishedResult(this, $9f726edb03f4840c$var$checkFinished(this, prevTo));
                (0, $fafba8d3e1bed3b4$export$7ba486852759e806)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    anim.changed = !reset;
                    onRest?.(result, this);
                    if (reset) $9f726edb03f4840c$var$callProp(defaultProps.onRest, result);
                    else anim.onStart?.(result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($9f726edb03f4840c$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($9f726edb03f4840c$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($9f726edb03f4840c$var$getNoopResult(value));
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */ _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $fafba8d3e1bed3b4$export$133f54e9f7cf1796)(this)) this._detach();
            anim.to = value;
            if ((0, $fafba8d3e1bed3b4$export$133f54e9f7cf1796)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to2 } = this.animation;
        if ((0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(to2)) {
            (0, $fafba8d3e1bed3b4$export$72d604e3f8d000a5)(to2, this);
            if ($9f726edb03f4840c$var$isFrameValue(to2)) priority = to2.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to2 } = this.animation;
        if ((0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(to2)) (0, $fafba8d3e1bed3b4$export$7a0eb830d336339b)(to2, this);
    }
    /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */ _set(arg, idle = true) {
        const value = (0, $fafba8d3e1bed3b4$export$e37b7520edd66839)(arg);
        if (!(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(value)) {
            const oldNode = (0, $7bf293f4fe511ca6$export$6b63995194a3a9e4)(this);
            if (!oldNode || !(0, $fafba8d3e1bed3b4$export$248d38f6296296c5)(value, oldNode.getValue())) {
                const nodeType = (0, $7bf293f4fe511ca6$export$e6b77ddbe47b132e)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $7bf293f4fe511ca6$export$b553cb5b22b81b04)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $7bf293f4fe511ca6$export$6b63995194a3a9e4)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $9f726edb03f4840c$var$sendEvent(this, "onStart", $9f726edb03f4840c$var$getFinishedResult(this, $9f726edb03f4840c$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            $9f726edb03f4840c$var$callProp(this.animation.onChange, value, this);
        }
        $9f726edb03f4840c$var$callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
    _start() {
        const anim = this.animation;
        (0, $7bf293f4fe511ca6$export$6b63995194a3a9e4)(this).reset((0, $fafba8d3e1bed3b4$export$e37b7520edd66839)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$9f726edb03f4840c$var$isAnimating(this)) {
            $9f726edb03f4840c$var$setActiveBit(this, true);
            if (!$9f726edb03f4840c$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $fafba8d3e1bed3b4$export$cceeabf822b64fc0).skipAnimation) this.finish();
        else (0, $fafba8d3e1bed3b4$export$a57f5080a3bcc90a).start(this);
    }
    /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */ _stop(goal, cancel) {
        if ($9f726edb03f4840c$var$isAnimating(this)) {
            $9f726edb03f4840c$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = void 0;
            (0, $fafba8d3e1bed3b4$export$31752c40a5fab62a)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $9f726edb03f4840c$var$getCancelledResult(this.get()) : $9f726edb03f4840c$var$getFinishedResult(this.get(), $9f726edb03f4840c$var$checkFinished(this, goal ?? anim.to));
            (0, $fafba8d3e1bed3b4$export$7ba486852759e806)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                $9f726edb03f4840c$var$sendEvent(this, "onRest", result, this);
            }
        }
    }
};
function $9f726edb03f4840c$var$checkFinished(target, to2) {
    const goal = $9f726edb03f4840c$var$computeGoal(to2);
    const value = $9f726edb03f4840c$var$computeGoal(target.get());
    return (0, $fafba8d3e1bed3b4$export$248d38f6296296c5)(value, goal);
}
function $9f726edb03f4840c$var$createLoopUpdate(props, loop = props.loop, to2 = props.to) {
    const loopRet = $9f726edb03f4840c$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $9f726edb03f4840c$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $9f726edb03f4840c$var$createUpdate({
            ...props,
            loop: loop,
            // Avoid updating default props when looping.
            default: false,
            // Never loop the `pause` prop.
            pause: void 0,
            // For the "reverse" prop to loop as expected, the "to" prop
            // must be undefined. The "reverse" prop is ignored when the
            // "to" prop is an array or function.
            to: !reverse || $9f726edb03f4840c$var$isAsyncTo(to2) ? to2 : void 0,
            // Ignore the "from" prop except on reset.
            from: reset ? props.from : void 0,
            reset: reset,
            // The "loop" prop can return a "useSpring" props object to
            // override any of the original props.
            ...overrides
        });
    }
}
function $9f726edb03f4840c$var$createUpdate(props) {
    const { to: to2, from: from } = props = $9f726edb03f4840c$export$b971039a739bf227(props);
    const keys = /* @__PURE__ */ new Set();
    if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(to2)) $9f726edb03f4840c$var$findDefined(to2, keys);
    if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(from)) $9f726edb03f4840c$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $9f726edb03f4840c$var$declareUpdate(props) {
    const update2 = $9f726edb03f4840c$var$createUpdate(props);
    if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(update2.default)) update2.default = $9f726edb03f4840c$var$getDefaultProps(update2);
    return update2;
}
function $9f726edb03f4840c$var$findDefined(values, keys) {
    (0, $fafba8d3e1bed3b4$export$f4c6fe153f5a944e)(values, (value, key)=>value != null && keys.add(key));
}
var $9f726edb03f4840c$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $9f726edb03f4840c$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $9f726edb03f4840c$var$getDefaultProp(props, type) ? $9f726edb03f4840c$var$resolveProp(props[type], target.key) : void 0;
}
function $9f726edb03f4840c$var$sendEvent(target, type, ...args) {
    target.animation[type]?.(...args);
    target.defaultProps[type]?.(...args);
}
var $9f726edb03f4840c$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
var $9f726edb03f4840c$var$nextId2 = 1;
var $9f726edb03f4840c$export$bd0bf19f25da8474 = class {
    constructor(props, flush3){
        this.id = $9f726edb03f4840c$var$nextId2++;
        /** The animated values */ this.springs = {};
        /** The queue of props passed to the `update` method. */ this.queue = [];
        /** The counter for tracking `scheduleProps` calls */ this._lastAsyncId = 0;
        /** The values currently being animated */ this._active = /* @__PURE__ */ new Set();
        /** The values that changed recently */ this._changed = /* @__PURE__ */ new Set();
        /** Equals false when `onStart` listeners can be called */ this._started = false;
        /** State used by the `runAsync` function */ this._state = {
            paused: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The event queues that are flushed once per frame maximum */ this._events = {
            onStart: /* @__PURE__ */ new Map(),
            onChange: /* @__PURE__ */ new Map(),
            onRest: /* @__PURE__ */ new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush3) this._flush = flush3;
        if (props) this.start({
            default: true,
            ...props
        });
    }
    /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */ get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>{
            return spring.idle && !spring.isDelayed && !spring.isPaused;
        });
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    /** Get the current values of our springs */ get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    /** Set the current values without animating. */ set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(value)) this.springs[key].set(value);
        }
    }
    /** Push an update onto the queue of each value. */ update(props) {
        if (props) this.queue.push($9f726edb03f4840c$var$createUpdate(props));
        return this;
    }
    /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */ start(props) {
        let { queue: queue } = this;
        if (props) queue = (0, $fafba8d3e1bed3b4$export$45b10814cc054894)(props).map($9f726edb03f4840c$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $9f726edb03f4840c$var$prepareKeys(this, queue);
        return $9f726edb03f4840c$var$flushUpdateQueue(this, queue);
    }
    /** @internal */ stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)((0, $fafba8d3e1bed3b4$export$45b10814cc054894)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $9f726edb03f4840c$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    /** Freeze the active animation in time */ pause(keys) {
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)((0, $fafba8d3e1bed3b4$export$45b10814cc054894)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    /** Resume the animation if paused. */ resume(keys) {
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)((0, $fafba8d3e1bed3b4$export$45b10814cc054894)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    /** Call a function once per spring value */ each(iterator) {
        (0, $fafba8d3e1bed3b4$export$f4c6fe153f5a944e)(this.springs, iterator);
    }
    /** @internal Called at the end of every animation frame */ _onFrame() {
        const { onStart: onStart, onChange: onChange, onRest: onRest } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $fafba8d3e1bed3b4$export$4909b86c8034bf73)(onStart, ([onStart2, result])=>{
                result.value = this.get();
                onStart2(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $fafba8d3e1bed3b4$export$4909b86c8034bf73)(onChange, ([onChange2, result])=>{
            result.value = values;
            onChange2(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $fafba8d3e1bed3b4$export$4909b86c8034bf73)(onRest, ([onRest2, result])=>{
                result.value = values;
                onRest2(result, this, this._item);
            });
        }
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).onFrame(this._onFrame);
    }
};
function $9f726edb03f4840c$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$9f726edb03f4840c$var$flushUpdate(ctrl, props))).then((results)=>$9f726edb03f4840c$var$getCombinedResult(ctrl, results));
}
async function $9f726edb03f4840c$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys, to: to2, from: from, loop: loop, onRest: onRest, onResolve: onResolve } = props;
    const defaults2 = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to2 === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).arr(to2) || (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(to2) ? to2 : void 0;
    if (asyncTo) {
        props.to = void 0;
        props.onRest = void 0;
        if (defaults2) defaults2.onRest = void 0;
    } else (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)($9f726edb03f4840c$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished, cancelled: cancelled })=>{
                const result2 = queue.get(handler);
                if (result2) {
                    if (!finished) result2.finished = false;
                    if (cancelled) result2.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults2) defaults2[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $fafba8d3e1bed3b4$export$7ba486852759e806)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $9f726edb03f4840c$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($9f726edb03f4840c$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $fafba8d3e1bed3b4$export$8793edee2d425525),
            resume: (0, $fafba8d3e1bed3b4$export$8793edee2d425525),
            start (props2, resolve) {
                if (cancel) {
                    $9f726edb03f4840c$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($9f726edb03f4840c$var$getCancelledResult(ctrl));
                } else {
                    props2.onRest = onRest;
                    resolve($9f726edb03f4840c$var$runAsync(asyncTo, props2, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $9f726edb03f4840c$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = $9f726edb03f4840c$var$createLoopUpdate(props, loop, to2);
        if (nextProps) {
            $9f726edb03f4840c$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $9f726edb03f4840c$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function $9f726edb03f4840c$var$getSprings(ctrl, props) {
    const springs = {
        ...ctrl.springs
    };
    if (props) (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)((0, $fafba8d3e1bed3b4$export$45b10814cc054894)(props), (props2)=>{
        if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props2.keys)) props2 = $9f726edb03f4840c$var$createUpdate(props2);
        if (!(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(props2.to)) props2 = {
            ...props2,
            to: void 0
        };
        $9f726edb03f4840c$var$prepareSprings(springs, props2, (key)=>{
            return $9f726edb03f4840c$var$createSpring(key);
        });
    });
    $9f726edb03f4840c$var$setSprings(ctrl, springs);
    return springs;
}
function $9f726edb03f4840c$var$setSprings(ctrl, springs) {
    (0, $fafba8d3e1bed3b4$export$f4c6fe153f5a944e)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $fafba8d3e1bed3b4$export$72d604e3f8d000a5)(spring, ctrl);
        }
    });
}
function $9f726edb03f4840c$var$createSpring(key, observer) {
    const spring = new $9f726edb03f4840c$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $fafba8d3e1bed3b4$export$72d604e3f8d000a5)(spring, observer);
    return spring;
}
function $9f726edb03f4840c$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $9f726edb03f4840c$var$prepareKeys(ctrl, queue) {
    (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(queue, (props)=>{
        $9f726edb03f4840c$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $9f726edb03f4840c$var$createSpring(key, ctrl);
        });
    });
}
var $9f726edb03f4840c$export$f12a216ec50d2cf1 = ({ children: children, ...props })=>{
    const inherited = (0, $exYeM.useContext)($9f726edb03f4840c$var$ctx);
    const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $fafba8d3e1bed3b4$export$b6feb8998cd9b342)(()=>({
            pause: pause,
            immediate: immediate
        }), [
        pause,
        immediate
    ]);
    const { Provider: Provider } = $9f726edb03f4840c$var$ctx;
    return /* @__PURE__ */ $exYeM.createElement(Provider, {
        value: props
    }, children);
};
var $9f726edb03f4840c$var$ctx = $9f726edb03f4840c$var$makeContext($9f726edb03f4840c$export$f12a216ec50d2cf1, {});
$9f726edb03f4840c$export$f12a216ec50d2cf1.Provider = $9f726edb03f4840c$var$ctx.Provider;
$9f726edb03f4840c$export$f12a216ec50d2cf1.Consumer = $9f726edb03f4840c$var$ctx.Consumer;
function $9f726edb03f4840c$var$makeContext(target, init) {
    Object.assign(target, $exYeM.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
var $9f726edb03f4840c$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef2 = function(props) {
        (0, $fafba8d3e1bed3b4$export$d99d974913ad3b12)();
        const results = [];
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = _getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.current = current;
    SpringRef2.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef2.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef2.pause = function() {
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef2.resume = function() {
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef2.set = function(values) {
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            const update2 = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(values) ? values(i, ctrl) : values;
            if (update2) ctrl.set(update2);
        });
    };
    SpringRef2.start = function(props) {
        const results = [];
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = this._getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.stop = function() {
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef2.update = function(props) {
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function(arg, ctrl, index) {
        return (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef2._getProps = _getProps;
    return SpringRef2;
};
// src/hooks/useSprings.ts
function $9f726edb03f4840c$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $exYeM.useMemo)(()=>propsFn || arguments.length == 3 ? $9f726edb03f4840c$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $exYeM.useRef)(0);
    const forceUpdate = (0, $fafba8d3e1bed3b4$export$91db9bc4f8ac944a)();
    const state = (0, $exYeM.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates2) {
                const springs2 = $9f726edb03f4840c$var$getSprings(ctrl, updates2);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? $9f726edb03f4840c$var$flushUpdateQueue(ctrl, updates2) : new Promise((resolve)=>{
                    $9f726edb03f4840c$var$setSprings(ctrl, springs2);
                    state.queue.push(()=>{
                        resolve($9f726edb03f4840c$var$flushUpdateQueue(ctrl, updates2));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $exYeM.useRef)([
        ...state.ctrls
    ]);
    const updates = [];
    const prevLength = (0, $fafba8d3e1bed3b4$export$ef7ad0c4e19d7fbf)(length) || 0;
    (0, $exYeM.useMemo)(()=>{
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $9f726edb03f4840c$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $exYeM.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $9f726edb03f4840c$export$bd0bf19f25da8474(null, state.flush));
            const update2 = propsFn ? propsFn(i, ctrl) : props[i];
            if (update2) updates[i] = $9f726edb03f4840c$var$declareUpdate(update2);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$9f726edb03f4840c$var$getSprings(ctrl, updates[i]));
    const context = (0, $exYeM.useContext)($9f726edb03f4840c$export$f12a216ec50d2cf1);
    const prevContext = (0, $fafba8d3e1bed3b4$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $9f726edb03f4840c$var$hasProps(context);
    (0, $fafba8d3e1bed3b4$export$700979bc83e7db82)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue } = state;
        if (queue.length) {
            state.queue = [];
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(queue, (cb)=>cb());
        }
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(ctrls.current, (ctrl, i)=>{
            ref?.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update2 = updates[i];
            if (update2) {
                $9f726edb03f4840c$var$replaceRef(ctrl, update2.ref);
                if (ctrl.ref) ctrl.queue.push(update2);
                else ctrl.start(update2);
            }
        });
    });
    (0, $fafba8d3e1bed3b4$export$392544347a18b6ea)(()=>()=>{
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>({
            ...x
        }));
    return ref ? [
        values,
        ref
    ] : values;
}
// src/hooks/useSpring.ts
function $9f726edb03f4840c$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(props);
    const [[values], ref] = $9f726edb03f4840c$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
var $9f726edb03f4840c$var$initSpringRef = ()=>$9f726edb03f4840c$export$2471ae76e2946684();
var $9f726edb03f4840c$export$564bff9c23cad2ca = ()=>(0, $exYeM.useState)($9f726edb03f4840c$var$initSpringRef)[0];
var $9f726edb03f4840c$export$ab73804b080feffc = (initial, props)=>{
    const springValue = (0, $fafba8d3e1bed3b4$export$fe4300aa8eebea86)(()=>new $9f726edb03f4840c$export$5854d13427d5a954(initial, props));
    (0, $fafba8d3e1bed3b4$export$392544347a18b6ea)(()=>()=>{
            springValue.stop();
        });
    return springValue;
};
function $9f726edb03f4840c$export$250279104b4672ed(length, propsArg, deps) {
    const propsFn = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    let passedRef = void 0;
    const result = $9f726edb03f4840c$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, // Ensure the props function is called when no deps exist.
    // This works around the 3 argument rule.
    deps || [
        {}
    ]);
    (0, $fafba8d3e1bed3b4$export$700979bc83e7db82)(()=>{
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(result[1].current, (ctrl, i)=>{
            const parent = result[1].current[i + (reverse ? 1 : -1)];
            $9f726edb03f4840c$var$replaceRef(ctrl, passedRef);
            if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
                return;
            }
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        const ref = passedRef ?? result[1];
        ref["_getProps"] = (propsArg2, ctrl, i)=>{
            const props = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
function $9f726edb03f4840c$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(props) && props;
    const { reset: reset, sort: sort, trail: trail = 0, expires: expires = true, exitBeforeEnter: exitBeforeEnter = false, onDestroyed: onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
    const ref = (0, $exYeM.useMemo)(()=>propsFn || arguments.length == 3 ? $9f726edb03f4840c$export$2471ae76e2946684() : void 0, []);
    const items = (0, $fafba8d3e1bed3b4$export$45b10814cc054894)(data);
    const transitions = [];
    const usedTransitions = (0, $exYeM.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $fafba8d3e1bed3b4$export$700979bc83e7db82)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $fafba8d3e1bed3b4$export$392544347a18b6ea)(()=>{
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(transitions, (t)=>{
            ref?.add(t.ctrl);
            t.ctrl.ref = ref;
        });
        return ()=>{
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $9f726edb03f4840c$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    const keys = $9f726edb03f4840c$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $fafba8d3e1bed3b4$export$700979bc83e7db82)(()=>(0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(expired, ({ ctrl: ctrl, item: item, key: key })=>{
            $9f726edb03f4840c$var$detachRefs(ctrl, ref);
            $9f726edb03f4840c$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: "mount" /* MOUNT */ ,
                ctrl: new $9f726edb03f4840c$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave } = propsFn ? propsFn() : props;
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = {
                    ...t,
                    item: items[keyIndex]
                };
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, $fafba8d3e1bed3b4$export$91db9bc4f8ac944a)();
    const defaultProps = $9f726edb03f4840c$var$getDefaultProps(props);
    const changes = /* @__PURE__ */ new Map();
    const exitingTransitions = (0, $exYeM.useRef)(/* @__PURE__ */ new Map());
    const forceChange = (0, $exYeM.useRef)(false);
    (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to2;
        let phase;
        const propsDelay = $9f726edb03f4840c$var$callProp(p.delay || 0, key);
        if (prevPhase == "mount" /* MOUNT */ ) {
            to2 = p.enter;
            phase = "enter" /* ENTER */ ;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != "leave" /* LEAVE */ ) {
                if (isLeave) {
                    to2 = p.leave;
                    phase = "leave" /* LEAVE */ ;
                } else if (to2 = p.update) phase = "update" /* UPDATE */ ;
                else return;
            } else if (!isLeave) {
                to2 = p.enter;
                phase = "enter" /* ENTER */ ;
            } else return;
        }
        to2 = $9f726edb03f4840c$var$callProp(to2, t.item, i);
        to2 = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).obj(to2) ? $9f726edb03f4840c$export$b971039a739bf227(to2) : {
            to: to2
        };
        if (!to2.config) {
            const config2 = propsConfig || defaultProps.config;
            to2.config = $9f726edb03f4840c$var$callProp(config2, t.item, i, phase);
        }
        delay += trail;
        const payload = {
            ...defaultProps,
            // we need to add our props.delay value you here.
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            // This prevents implied resets.
            reset: false,
            // Merge any phase-specific props.
            ...to2
        };
        if (phase == "enter" /* ENTER */  && (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(payload.from)) {
            const p2 = propsFn ? propsFn() : props;
            const from = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(p2.initial) || prevTransitions ? p2.from : p2.initial;
            payload.from = $9f726edb03f4840c$var$callProp(from, t.item, i);
        }
        const { onResolve: onResolve } = payload;
        payload.onResolve = (result)=>{
            $9f726edb03f4840c$var$callProp(onResolve, result);
            const transitions2 = usedTransitions.current;
            const t2 = transitions2.find((t3)=>t3.key === key);
            if (!t2) return;
            if (result.cancelled && t2.phase != "update" /* UPDATE */ ) return;
            if (t2.ctrl.idle) {
                const idle = transitions2.every((t3)=>t3.ctrl.idle);
                if (t2.phase == "leave" /* LEAVE */ ) {
                    const expiry = $9f726edb03f4840c$var$callProp(expires, t2.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t2.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 2147483647) t2.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions2.some((t3)=>t3.expired)) {
                    exitingTransitions.current.delete(t2);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        const springs = $9f726edb03f4840c$var$getSprings(t.ctrl, payload);
        if (phase === "leave" /* LEAVE */  && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    const context = (0, $exYeM.useContext)($9f726edb03f4840c$export$f12a216ec50d2cf1);
    const prevContext = (0, $fafba8d3e1bed3b4$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $9f726edb03f4840c$var$hasProps(context);
    (0, $fafba8d3e1bed3b4$export$700979bc83e7db82)(()=>{
        if (hasContext) (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(changes, (_, t)=>{
        if (exitingTransitions.current.size) {
            const ind = transitions.findIndex((state)=>state.key === t.key);
            transitions.splice(ind, 1);
        }
    });
    (0, $fafba8d3e1bed3b4$export$700979bc83e7db82)(()=>{
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({ phase: phase, payload: payload }, t)=>{
            const { ctrl: ctrl } = t;
            t.phase = phase;
            ref?.add(ctrl);
            if (hasContext && phase == "enter" /* ENTER */ ) ctrl.start({
                default: context
            });
            if (payload) {
                $9f726edb03f4840c$var$replaceRef(ctrl, payload.ref);
                if ((ctrl.ref || ref) && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>/* @__PURE__ */ $exYeM.createElement($exYeM.Fragment, null, transitions.map((t, i)=>{
            const { springs: springs } = changes.get(t) || t.ctrl;
            const elem = render({
                ...springs
            }, t.item, t, i);
            return elem && elem.type ? /* @__PURE__ */ $exYeM.createElement(elem.type, {
                ...elem.props,
                key: (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).str(t.key) || (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            }) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
var $9f726edb03f4840c$var$nextKey = 1;
function $9f726edb03f4840c$var$getKeys(items, { key: key, keys: keys = key }, prevTransitions) {
    if (keys === null) {
        const reused = /* @__PURE__ */ new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t2)=>t2.item === item && t2.phase !== "leave" /* LEAVE */  && !reused.has(t2));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $9f726edb03f4840c$var$nextKey++;
        });
    }
    return (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(keys) ? items : (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(keys) ? items.map(keys) : (0, $fafba8d3e1bed3b4$export$45b10814cc054894)(keys);
}
var $9f726edb03f4840c$export$d928051c8cd740b = ({ container: container, ...springOptions } = {})=>{
    const [scrollValues, api] = $9f726edb03f4840c$export$c4af9125706c4d30(()=>({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0,
            ...springOptions
        }), []);
    (0, $fafba8d3e1bed3b4$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $fafba8d3e1bed3b4$export$d4d89fd61e5416ee)(({ x: x, y: y })=>{
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(Object.values(scrollValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
var $9f726edb03f4840c$export$e8b771555dc4a003 = ({ container: container, ...springOptions })=>{
    const [sizeValues, api] = $9f726edb03f4840c$export$c4af9125706c4d30(()=>({
            width: 0,
            height: 0,
            ...springOptions
        }), []);
    (0, $fafba8d3e1bed3b4$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $fafba8d3e1bed3b4$export$45b39e67d4ce4921)(({ width: width, height: height })=>{
            api.start({
                width: width,
                height: height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(Object.values(sizeValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
var $9f726edb03f4840c$var$defaultThresholdOptions = {
    any: 0,
    all: 1
};
function $9f726edb03f4840c$export$2f62ee6831462844(props, args) {
    const [isInView, setIsInView] = (0, $exYeM.useState)(false);
    const ref = (0, $exYeM.useRef)();
    const propsFn = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(props) && props;
    const springsProps = propsFn ? propsFn() : {};
    const { to: to2 = {}, from: from = {}, ...restSpringProps } = springsProps;
    const intersectionArguments = propsFn ? args : props;
    const [springs, api] = $9f726edb03f4840c$export$c4af9125706c4d30(()=>({
            from: from,
            ...restSpringProps
        }), []);
    (0, $fafba8d3e1bed3b4$export$700979bc83e7db82)(()=>{
        const element = ref.current;
        const { root: root, once: once, amount: amount = "any", ...restArgs } = intersectionArguments ?? {};
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        const activeIntersections = /* @__PURE__ */ new WeakMap();
        const onEnter = ()=>{
            if (to2) api.start(to2);
            setIsInView(true);
            const cleanup = ()=>{
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? void 0 : cleanup;
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                const onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    const newOnLeave = onEnter();
                    if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections.delete(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, {
            root: root && root.current || void 0,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : $9f726edb03f4840c$var$defaultThresholdOptions[amount],
            ...restArgs
        });
        observer.observe(element);
        return ()=>observer.unobserve(element);
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
// src/components/Spring.tsx
function $9f726edb03f4840c$export$a500e5b516cedfc({ children: children, ...props }) {
    return children($9f726edb03f4840c$export$c4af9125706c4d30(props));
}
function $9f726edb03f4840c$export$3b8b9d47fbf8fd2b({ items: items, children: children, ...props }) {
    const trails = $9f726edb03f4840c$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).fun(result) ? result(trails[index]) : result;
    });
}
// src/components/Transition.tsx
function $9f726edb03f4840c$export$be58926105124dd4({ items: items, children: children, ...props }) {
    return $9f726edb03f4840c$export$7b286972b8d8ccbf(items, props)(children);
}
var $9f726edb03f4840c$export$b0cc4f9860136880 = class extends $9f726edb03f4840c$export$8229896f80e2495e {
    constructor(source, args){
        super();
        this.source = source;
        /** Equals false when in the frameloop */ this.idle = true;
        /** The inputs which are currently animating */ this._active = /* @__PURE__ */ new Set();
        this.calc = (0, $fafba8d3e1bed3b4$export$b12af43b97697ef5)(...args);
        const value = this._get();
        const nodeType = (0, $7bf293f4fe511ca6$export$e6b77ddbe47b132e)(value);
        (0, $7bf293f4fe511ca6$export$b553cb5b22b81b04)(this, nodeType.create(value));
    }
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, $fafba8d3e1bed3b4$export$248d38f6296296c5)(value, oldValue)) {
            (0, $7bf293f4fe511ca6$export$6b63995194a3a9e4)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $9f726edb03f4840c$var$checkIdle(this._active)) $9f726edb03f4840c$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).arr(this.source) ? this.source.map((0, $fafba8d3e1bed3b4$export$e37b7520edd66839)) : (0, $fafba8d3e1bed3b4$export$45b10814cc054894)((0, $fafba8d3e1bed3b4$export$e37b7520edd66839)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$9f726edb03f4840c$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)((0, $7bf293f4fe511ca6$export$ccab2b64c5d440)(this), (node)=>{
                node.done = false;
            });
            if ((0, $fafba8d3e1bed3b4$export$cceeabf822b64fc0).skipAnimation) {
                (0, $fafba8d3e1bed3b4$export$27f233d61a9e2fa4).batchedUpdates(()=>this.advance());
                $9f726edb03f4840c$var$becomeIdle(this);
            } else (0, $fafba8d3e1bed3b4$export$a57f5080a3bcc90a).start(this);
        }
    }
    // Observe our sources only when we're observed.
    _attach() {
        let priority = 1;
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)((0, $fafba8d3e1bed3b4$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(source)) (0, $fafba8d3e1bed3b4$export$72d604e3f8d000a5)(source, this);
            if ($9f726edb03f4840c$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    // Stop observing our sources once we have no observers.
    _detach() {
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)((0, $fafba8d3e1bed3b4$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(source)) (0, $fafba8d3e1bed3b4$export$7a0eb830d336339b)(source, this);
        });
        this._active.clear();
        $9f726edb03f4840c$var$becomeIdle(this);
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $fafba8d3e1bed3b4$export$45b10814cc054894)(this.source).reduce((highest, parent)=>Math.max(highest, ($9f726edb03f4840c$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
};
function $9f726edb03f4840c$var$isIdle(source) {
    return source.idle !== false;
}
function $9f726edb03f4840c$var$checkIdle(active) {
    return !active.size || Array.from(active).every($9f726edb03f4840c$var$isIdle);
}
function $9f726edb03f4840c$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)((0, $7bf293f4fe511ca6$export$ccab2b64c5d440)(self), (node)=>{
            node.done = true;
        });
        (0, $fafba8d3e1bed3b4$export$31752c40a5fab62a)(self, {
            type: "idle",
            parent: self
        });
    }
}
// src/interpolate.ts
var $9f726edb03f4840c$export$2c618a4308a30424 = (source, ...args)=>new $9f726edb03f4840c$export$b0cc4f9860136880(source, args);
var $9f726edb03f4840c$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $fafba8d3e1bed3b4$export$2abfcde8ae218ba8)(), new $9f726edb03f4840c$export$b0cc4f9860136880(source, args));
(0, $fafba8d3e1bed3b4$export$cceeabf822b64fc0).assign({
    createStringInterpolator: $fafba8d3e1bed3b4$export$4759a013d387347a,
    to: (source, args)=>new $9f726edb03f4840c$export$b0cc4f9860136880(source, args)
});
var $9f726edb03f4840c$export$722fbec263ad908a = (0, $fafba8d3e1bed3b4$export$a57f5080a3bcc90a).advance;





// src/applyAnimatedValues.ts
var $f9aea5876333360d$var$isCustomPropRE = /^--/;
function $f9aea5876333360d$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$f9aea5876333360d$var$isCustomPropRE.test(name) && !($f9aea5876333360d$var$isUnitlessNumber.hasOwnProperty(name) && $f9aea5876333360d$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
var $f9aea5876333360d$var$attributeCache = {};
function $f9aea5876333360d$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const { style: style, children: children, scrollTop: scrollTop, scrollLeft: scrollLeft, viewBox: viewBox, ...attributes } = props;
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $f9aea5876333360d$var$attributeCache[name] || ($f9aea5876333360d$var$attributeCache[name] = name.replace(/([A-Z])/g, // Attributes are written in dash case
        (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(const name in style)if (style.hasOwnProperty(name)) {
        const value = $f9aea5876333360d$var$dangerousStyleValue(name, style[name]);
        if ($f9aea5876333360d$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
}
var $f9aea5876333360d$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
var $f9aea5876333360d$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
var $f9aea5876333360d$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$f9aea5876333360d$var$isUnitlessNumber = Object.keys($f9aea5876333360d$var$isUnitlessNumber).reduce((acc, prop)=>{
    $f9aea5876333360d$var$prefixes.forEach((prefix)=>acc[$f9aea5876333360d$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $f9aea5876333360d$var$isUnitlessNumber);
var $f9aea5876333360d$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var $f9aea5876333360d$var$pxTransforms = /^(translate)/;
var $f9aea5876333360d$var$degTransforms = /^(rotate|skew)/;
var $f9aea5876333360d$var$addUnit = (value, unit)=>(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).num(value) && value !== 0 ? value + unit : value;
var $f9aea5876333360d$var$isValueIdentity = (value, id)=>(0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).arr(value) ? value.every((v)=>$f9aea5876333360d$var$isValueIdentity(v, id)) : (0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).num(value) ? value === id : parseFloat(value) === id;
var $f9aea5876333360d$var$AnimatedStyle = class extends (0, $7bf293f4fe511ca6$export$f1b0b9e366a6e2d4) {
    constructor({ x: x, y: y, z: z, ...style }){
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$f9aea5876333360d$var$addUnit(v, "px")).join(",")})`,
                    // prettier-ignore
                    $f9aea5876333360d$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $fafba8d3e1bed3b4$export$f4c6fe153f5a944e)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($f9aea5876333360d$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).und(value)) return;
                const unit = $f9aea5876333360d$var$pxTransforms.test(key) ? "px" : $f9aea5876333360d$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $fafba8d3e1bed3b4$export$45b10814cc054894)(value));
                transforms.push(key === "rotate3d" ? ([x2, y2, z2, deg])=>[
                        `rotate3d(${x2},${y2},${z2},${$f9aea5876333360d$var$addUnit(deg, unit)})`,
                        $f9aea5876333360d$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$f9aea5876333360d$var$addUnit(v, unit)).join(",")})`,
                        $f9aea5876333360d$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $f9aea5876333360d$var$FluidTransform(inputs, transforms);
        super(style);
    }
};
var $f9aea5876333360d$var$FluidTransform = class extends (0, $fafba8d3e1bed3b4$export$aff8e1ac1a016a2) {
    constructor(inputs, transforms){
        super();
        this.inputs = inputs;
        this.transforms = transforms;
        this._value = null;
    }
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(this.inputs, (input, i)=>{
            const arg1 = (0, $fafba8d3e1bed3b4$export$e37b7520edd66839)(input[0]);
            const [t, id] = this.transforms[i]((0, $fafba8d3e1bed3b4$export$226b3eccf92c9ed9).arr(arg1) ? arg1 : input.map((0, $fafba8d3e1bed3b4$export$e37b7520edd66839)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    // Start observing our inputs once we have an observer.
    observerAdded(count) {
        if (count == 1) (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(input, (value)=>(0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(value) && (0, $fafba8d3e1bed3b4$export$72d604e3f8d000a5)(value, this)));
    }
    // Stop observing our inputs once we have no observers.
    observerRemoved(count) {
        if (count == 0) (0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $fafba8d3e1bed3b4$export$79b2f7037acddd43)(input, (value)=>(0, $fafba8d3e1bed3b4$export$57ea7e3a7f6280c7)(value) && (0, $fafba8d3e1bed3b4$export$7a0eb830d336339b)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $fafba8d3e1bed3b4$export$31752c40a5fab62a)(this, event);
    }
};
// src/primitives.ts
var $f9aea5876333360d$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
(0, $fafba8d3e1bed3b4$export$cceeabf822b64fc0).assign({
    batchedUpdates: (0, $97dc602bd7e23afa$exports.unstable_batchedUpdates),
    createStringInterpolator: $fafba8d3e1bed3b4$export$4759a013d387347a,
    colors: $fafba8d3e1bed3b4$export$8f45430ccf837300
});
var $f9aea5876333360d$var$host = (0, $7bf293f4fe511ca6$export$4ee5c78f6dcbcef)($f9aea5876333360d$var$primitives, {
    applyAnimatedValues: $f9aea5876333360d$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $f9aea5876333360d$var$AnimatedStyle(style),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getComponentProps: ({ scrollTop: scrollTop, scrollLeft: scrollLeft, ...props })=>props
});
var $f9aea5876333360d$export$407448d2b89b1813 = $f9aea5876333360d$var$host.animated;



var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
const $75cac0ff5bfda227$export$5176c37028d33346 = /*#__PURE__*/ $exYeM.createContext({
    isInitialized: false,
    data: {
        xAxis: {},
        yAxis: {},
        xAxisIds: [],
        yAxisIds: []
    }
});


const $27adb4455fa596cf$export$2785a2cc09fc5c5f = ()=>{
    const { data: data } = $exYeM.useContext((0, $75cac0ff5bfda227$export$5176c37028d33346));
    return data;
};



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");
parcelRequire("exYeM");


var $2f0D3 = parcelRequire("2f0D3");


var $dC5O8 = parcelRequire("dC5O8");

var $jawKn = parcelRequire("jawKn");

var $1tQWc = parcelRequire("1tQWc");

var $kY7HX = parcelRequire("kY7HX");


var $exYeM = parcelRequire("exYeM");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

var $aSiaI = parcelRequire("aSiaI");
const $4791e4ada5496d01$export$d6ef105978afa6a = /*#__PURE__*/ $exYeM.createContext({
    item: null,
    axis: {
        x: null,
        y: null
    },
    useVoronoiInteraction: false,
    dispatch: ()=>null
});
const $4791e4ada5496d01$var$dataReducer = (prevState, action)=>{
    switch(action.type){
        case "enterItem":
            return (0, $aJx1R.default)({}, prevState, {
                item: action.data
            });
        case "exitChart":
            if (prevState.item === null && prevState.axis.x === null && prevState.axis.y === null) return prevState;
            return (0, $aJx1R.default)({}, prevState, {
                axis: {
                    x: null,
                    y: null
                },
                item: null
            });
        case "updateVoronoiUsage":
            return (0, $aJx1R.default)({}, prevState, {
                useVoronoiInteraction: action.useVoronoiInteraction
            });
        case "leaveItem":
            if (prevState.item === null || Object.keys(action.data).some((key)=>action.data[key] !== prevState.item[key])) // The item is already something else
            return prevState;
            return (0, $aJx1R.default)({}, prevState, {
                item: null
            });
        case "updateAxis":
            if (action.data.x === prevState.axis.x && action.data.y === prevState.axis.y) return prevState;
            return (0, $aJx1R.default)({}, prevState, {
                axis: action.data
            });
        default:
            return prevState;
    }
};
function $4791e4ada5496d01$export$b26a2376c25d222f(props) {
    const { children: children } = props;
    const [data, dispatch] = $exYeM.useReducer($4791e4ada5496d01$var$dataReducer, {
        item: null,
        axis: {
            x: null,
            y: null
        },
        useVoronoiInteraction: false
    });
    const value = $exYeM.useMemo(()=>(0, $aJx1R.default)({}, data, {
            dispatch: dispatch
        }), [
        data
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($4791e4ada5496d01$export$d6ef105978afa6a.Provider, {
        value: value,
        children: children
    });
}



var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
const $77115235116b4adb$export$2e389f0a2b27c92f = /*#__PURE__*/ $exYeM.createContext({
    isInitialized: false,
    data: {
        highlightedItem: null,
        setHighlighted: ()=>{},
        clearHighlighted: ()=>{},
        isHighlighted: ()=>false,
        isFaded: ()=>false
    }
});


function $8a562b34f08ca902$export$a53285c6c973a5db() {
    const { isInitialized: isInitialized, data: data } = $exYeM.useContext((0, $77115235116b4adb$export$2e389f0a2b27c92f));
    if (!isInitialized) throw new Error([
        "MUI X: Could not find the highlighted ref context.",
        "It looks like you rendered your component outside of a ChartsContainer parent component."
    ].join("\n"));
    return data;
}


const $d203c2c9b69fd133$export$306117b585a4c625 = (skip)=>{
    const { dispatch: dispatchInteraction } = $exYeM.useContext((0, $4791e4ada5496d01$export$d6ef105978afa6a));
    const { setHighlighted: setHighlighted, clearHighlighted: clearHighlighted } = (0, $8a562b34f08ca902$export$a53285c6c973a5db)();
    if (skip) return ()=>({});
    const getInteractionItemProps = (data)=>{
        const onPointerDown = (event)=>{
            if (event.currentTarget.hasPointerCapture(event.pointerId)) event.currentTarget.releasePointerCapture(event.pointerId);
        };
        const onPointerEnter = ()=>{
            dispatchInteraction({
                type: "enterItem",
                data: data
            });
            setHighlighted({
                seriesId: data.seriesId,
                dataIndex: data.dataIndex
            });
        };
        const onPointerLeave = (event)=>{
            event.currentTarget.releasePointerCapture(event.pointerId);
            dispatchInteraction({
                type: "leaveItem",
                data: data
            });
            clearHighlighted();
        };
        return {
            onPointerEnter: onPointerEnter,
            onPointerLeave: onPointerLeave,
            onPointerDown: onPointerDown
        };
    };
    return getInteractionItemProps;
};



function $773c45430f70b33a$export$df217abb95936ce9(item) {
    const highlighted = (0, $8a562b34f08ca902$export$a53285c6c973a5db)();
    if (!item) return {
        isHighlighted: false,
        isFaded: false
    };
    const isHighlighted = highlighted.isHighlighted(item);
    const isFaded = !isHighlighted && highlighted.isFaded(item);
    return {
        isHighlighted: isHighlighted,
        isFaded: isFaded
    };
}



var $aSiaI = parcelRequire("aSiaI");
const $393647d9097ddec4$var$_excluded = [
    "id",
    "dataIndex",
    "classes",
    "color",
    "slots",
    "slotProps",
    "style",
    "onClick"
];
function $393647d9097ddec4$export$bca07fd828d50aac(slot) {
    return (0, $dC5O8.default)("MuiBarElement", slot);
}
const $393647d9097ddec4$export$3915529b13069888 = (0, $kY7HX.default)("MuiBarElement", [
    "root"
]);
const $393647d9097ddec4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, id: id } = ownerState;
    const slots = {
        root: [
            "root",
            `series-${id}`
        ]
    };
    return (0, $2f0D3.default)(slots, $393647d9097ddec4$export$bca07fd828d50aac, classes);
};
const $393647d9097ddec4$export$dbc95734d0447bf7 = (0, $jawKn.default)((0, $f9aea5876333360d$export$407448d2b89b1813).rect, {
    name: "MuiBarElement",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ ownerState: ownerState })=>({
        stroke: "none",
        fill: ownerState.isHighlighted ? (0, $1tQWc.default)(ownerState.color).brighter(0.5).formatHex() : ownerState.color,
        transition: "opacity 0.2s ease-in, fill 0.2s ease-in",
        opacity: ownerState.isFaded && 0.3 || 1
    }));
function $393647d9097ddec4$export$a16ed71bf4b07672(props) {
    const { id: id, dataIndex: dataIndex, classes: innerClasses, color: color, slots: slots, slotProps: slotProps, style: style, onClick: onClick } = props, other = (0, $3L80X.default)(props, $393647d9097ddec4$var$_excluded);
    const getInteractionItemProps = (0, $d203c2c9b69fd133$export$306117b585a4c625)();
    const { isFaded: isFaded, isHighlighted: isHighlighted } = (0, $773c45430f70b33a$export$df217abb95936ce9)({
        seriesId: id,
        dataIndex: dataIndex
    });
    const ownerState = {
        id: id,
        dataIndex: dataIndex,
        classes: innerClasses,
        color: color,
        isFaded: isFaded,
        isHighlighted: isHighlighted
    };
    const classes = $393647d9097ddec4$var$useUtilityClasses(ownerState);
    const Bar = slots?.bar ?? $393647d9097ddec4$export$dbc95734d0447bf7;
    const barProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: Bar,
        externalSlotProps: slotProps?.bar,
        externalForwardedProps: other,
        additionalProps: (0, $aJx1R.default)({}, getInteractionItemProps({
            type: "bar",
            seriesId: id,
            dataIndex: dataIndex
        }), {
            style: style,
            onClick: onClick,
            cursor: onClick ? "pointer" : "unset"
        }),
        className: classes.root,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)(Bar, (0, $aJx1R.default)({}, barProps));
}


function $69b8a720613cd165$export$2e2bcd8739ae039(series, xAxis, yAxis) {
    const verticalLayout = series.layout === "vertical";
    const bandColorScale = verticalLayout ? xAxis?.colorScale : yAxis?.colorScale;
    const valueColorScale = verticalLayout ? yAxis?.colorScale : xAxis?.colorScale;
    const bandValues = verticalLayout ? xAxis?.data : yAxis?.data;
    if (valueColorScale) return (dataIndex)=>{
        const value = series.data[dataIndex];
        const color = value === null ? series.color : valueColorScale(value);
        if (color === null) return series.color;
        return color;
    };
    if (bandColorScale && bandValues) return (dataIndex)=>{
        const value = bandValues[dataIndex];
        const color = value === null ? series.color : bandColorScale(value);
        if (color === null) return series.color;
        return color;
    };
    return ()=>series.color;
}



var $exYeM = parcelRequire("exYeM");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");
const $f7012dce0f399219$export$85ea9370ff307a1f = "DEFAULT_X_AXIS_KEY";
const $f7012dce0f399219$export$59bb26725f1fe1e8 = "DEFAULT_Y_AXIS_KEY";
const $f7012dce0f399219$export$d588676965164366 = {
    top: 50,
    bottom: 50,
    left: 50,
    right: 50
};


const $7cacf80aa658a6ca$var$useChartDimensions = (width, height, margin)=>{
    const defaultizedMargin = (0, $aJx1R.default)({}, (0, $f7012dce0f399219$export$d588676965164366), margin);
    const drawingArea = $exYeM.useMemo(()=>({
            left: defaultizedMargin.left,
            top: defaultizedMargin.top,
            right: defaultizedMargin.right,
            bottom: defaultizedMargin.bottom,
            width: Math.max(0, width - defaultizedMargin.left - defaultizedMargin.right),
            height: Math.max(0, height - defaultizedMargin.top - defaultizedMargin.bottom)
        }), [
        width,
        height,
        defaultizedMargin.top,
        defaultizedMargin.bottom,
        defaultizedMargin.left,
        defaultizedMargin.right
    ]);
    return drawingArea;
};
var $7cacf80aa658a6ca$export$2e2bcd8739ae039 = $7cacf80aa658a6ca$var$useChartDimensions;



var $aSiaI = parcelRequire("aSiaI");
const $7e3726a4b537e82f$export$6b4b60c0e05835fe = /*#__PURE__*/ $exYeM.createContext({
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    height: 300,
    width: 400,
    chartId: "",
    isPointInside: ()=>false
});
const $7e3726a4b537e82f$export$38ebea5d49ec5192 = /*#__PURE__*/ $exYeM.createContext({
    isInitialized: false,
    data: {
        current: null
    }
});
function $7e3726a4b537e82f$export$31c1e6ea05ec4673(props) {
    const { width: width, height: height, margin: margin, svgRef: svgRef, children: children } = props;
    const drawingArea = (0, $7cacf80aa658a6ca$export$2e2bcd8739ae039)(width, height, margin);
    const chartId = (0, $43c7ad0c22f8e14a$export$2e2bcd8739ae039)();
    const isPointInside = $exYeM.useCallback(({ x: x, y: y })=>x >= drawingArea.left && x <= drawingArea.left + drawingArea.width && y >= drawingArea.top && y <= drawingArea.top + drawingArea.height, [
        drawingArea
    ]);
    const value = $exYeM.useMemo(()=>(0, $aJx1R.default)({
            chartId: chartId ?? ""
        }, drawingArea, {
            isPointInside: isPointInside
        }), [
        chartId,
        drawingArea,
        isPointInside
    ]);
    const refValue = $exYeM.useMemo(()=>({
            isInitialized: true,
            data: svgRef
        }), [
        svgRef
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($7e3726a4b537e82f$export$38ebea5d49ec5192.Provider, {
        value: refValue,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($7e3726a4b537e82f$export$6b4b60c0e05835fe.Provider, {
            value: value,
            children: children
        })
    });
}


function $0b3940f442933067$export$310c4c2c8f792eac() {
    const { chartId: chartId } = $exYeM.useContext((0, $7e3726a4b537e82f$export$6b4b60c0e05835fe));
    return $exYeM.useMemo(()=>chartId, [
        chartId
    ]);
}



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");
parcelRequire("exYeM");

/**
 * Returns if the corner should have a radius or not based on the layout and the data.
 * @param {GetRadiusCorner} corner The corner to check.
 * @param {GetRadiusData} cornerData The data for the corner.
 * @returns {number} The radius for the corner.
 */ const $807a75ca3c7379a6$export$35724d9c2979edc5 = (corner, { hasNegative: hasNegative, hasPositive: hasPositive, borderRadius: borderRadius, layout: layout })=>{
    if (!borderRadius) return 0;
    const isVertical = layout === "vertical";
    if (corner === "top-left" && (isVertical && hasPositive || !isVertical && hasNegative)) return borderRadius;
    if (corner === "top-right" && (isVertical && hasPositive || !isVertical && hasPositive)) return borderRadius;
    if (corner === "bottom-right" && (isVertical && hasNegative || !isVertical && hasPositive)) return borderRadius;
    if (corner === "bottom-left" && (isVertical && hasNegative || !isVertical && hasNegative)) return borderRadius;
    return 0;
};



var $aSiaI = parcelRequire("aSiaI");
const $dcd8e30357627c99$var$_excluded = [
    "style",
    "maskId"
];
const $dcd8e30357627c99$var$buildInset = (corners)=>`inset(0px round ${corners.topLeft}px ${corners.topRight}px ${corners.bottomRight}px ${corners.bottomLeft}px)`;
function $dcd8e30357627c99$var$BarClipRect(props) {
    const radiusData = props.ownerState;
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f9aea5876333360d$export$407448d2b89b1813).rect, {
        style: (0, $aJx1R.default)({}, props.style, {
            clipPath: (props.ownerState.layout === "vertical" ? props.style?.height : props.style?.width).to((value)=>$dcd8e30357627c99$var$buildInset({
                    topLeft: Math.min(value, (0, $807a75ca3c7379a6$export$35724d9c2979edc5)("top-left", radiusData)),
                    topRight: Math.min(value, (0, $807a75ca3c7379a6$export$35724d9c2979edc5)("top-right", radiusData)),
                    bottomRight: Math.min(value, (0, $807a75ca3c7379a6$export$35724d9c2979edc5)("bottom-right", radiusData)),
                    bottomLeft: Math.min(value, (0, $807a75ca3c7379a6$export$35724d9c2979edc5)("bottom-left", radiusData))
                }))
        })
    });
}
/**
 * @ignore - internal component.
 */ function $dcd8e30357627c99$export$3b82c9de4265d9c8(props) {
    const { style: style, maskId: maskId } = props, rest = (0, $3L80X.default)(props, $dcd8e30357627c99$var$_excluded);
    if (!props.borderRadius || props.borderRadius <= 0) return null;
    return /*#__PURE__*/ (0, $aSiaI.jsx)("clipPath", {
        id: maskId,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($dcd8e30357627c99$var$BarClipRect, {
            ownerState: rest,
            style: style
        })
    });
}



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");
parcelRequire("exYeM");



var $dC5O8 = parcelRequire("dC5O8");

var $kY7HX = parcelRequire("kY7HX");

var $2f0D3 = parcelRequire("2f0D3");
function $c8359eecf064d1d0$export$c9e4549d727cd2c1(slot) {
    return (0, $dC5O8.default)("MuiBarLabel", slot);
}
const $c8359eecf064d1d0$export$13970c4fa2d1fff4 = (0, $kY7HX.default)("MuiBarLabel", [
    "root",
    "highlighted",
    "faded"
]);
const $c8359eecf064d1d0$export$5e4431114dfa28a8 = (ownerState)=>{
    const { classes: classes, seriesId: seriesId, isFaded: isFaded, isHighlighted: isHighlighted } = ownerState;
    const slots = {
        root: [
            "root",
            `series-${seriesId}`,
            isHighlighted && "highlighted",
            isFaded && "faded"
        ]
    };
    return (0, $2f0D3.default)(slots, $c8359eecf064d1d0$export$c9e4549d727cd2c1, classes);
};


const $9f3d15c94f984b6b$export$36b75fa6134afd52 = (options)=>{
    const { barLabel: barLabel, value: value, dataIndex: dataIndex, seriesId: seriesId, height: height, width: width } = options;
    if (barLabel === "value") // We don't want to show the label if the value is 0
    return value ? value?.toString() : null;
    return barLabel({
        seriesId: seriesId,
        dataIndex: dataIndex,
        value: value
    }, {
        bar: {
            height: height,
            width: width
        }
    });
};



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");
parcelRequire("exYeM");

var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");




var $aSiaI = parcelRequire("aSiaI");
const $2e8b00e576463e73$var$_excluded = [
    "seriesId",
    "dataIndex",
    "color",
    "isFaded",
    "isHighlighted",
    "classes"
];
const $2e8b00e576463e73$export$8cde33bb7ee8a8f5 = (0, $jawKn.default)((0, $f9aea5876333360d$export$407448d2b89b1813).text, {
    name: "MuiBarLabel",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            {
                [`&.${(0, $c8359eecf064d1d0$export$13970c4fa2d1fff4).faded}`]: styles.faded
            },
            {
                [`&.${(0, $c8359eecf064d1d0$export$13970c4fa2d1fff4).highlighted}`]: styles.highlighted
            },
            styles.root
        ]
})(({ theme: theme })=>(0, $aJx1R.default)({}, theme?.typography?.body2, {
        stroke: "none",
        fill: (theme.vars || theme)?.palette?.text?.primary,
        transition: "opacity 0.2s ease-in, fill 0.2s ease-in",
        textAnchor: "middle",
        dominantBaseline: "central",
        pointerEvents: "none",
        opacity: 1,
        [`&.${(0, $c8359eecf064d1d0$export$13970c4fa2d1fff4).faded}`]: {
            opacity: 0.3
        }
    }));
function $2e8b00e576463e73$export$9b4ae4ffae296a25(props) {
    const themeProps = (0, $7PWLt.default)({
        props: props,
        name: "MuiBarLabel"
    });
    const otherProps = (0, $3L80X.default)(themeProps, $2e8b00e576463e73$var$_excluded);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($2e8b00e576463e73$export$8cde33bb7ee8a8f5, (0, $aJx1R.default)({}, otherProps));
}




var $aSiaI = parcelRequire("aSiaI");
const $6e5bd95818df1bcb$var$_excluded = [
    "seriesId",
    "classes",
    "color",
    "style",
    "dataIndex",
    "barLabel",
    "slots",
    "slotProps",
    "height",
    "width",
    "value"
], $6e5bd95818df1bcb$var$_excluded2 = [
    "ownerState"
];
/**
 * @ignore - internal component.
 */ function $6e5bd95818df1bcb$export$6b2b63bec3aef5c8(props) {
    const { seriesId: seriesId, classes: innerClasses, color: color, style: style, dataIndex: dataIndex, barLabel: barLabel, slots: slots, slotProps: slotProps, height: height, width: width, value: value } = props, other = (0, $3L80X.default)(props, $6e5bd95818df1bcb$var$_excluded);
    const { isFaded: isFaded, isHighlighted: isHighlighted } = (0, $773c45430f70b33a$export$df217abb95936ce9)({
        seriesId: seriesId,
        dataIndex: dataIndex
    });
    const ownerState = {
        seriesId: seriesId,
        classes: innerClasses,
        color: color,
        isFaded: isFaded,
        isHighlighted: isHighlighted,
        dataIndex: dataIndex
    };
    const classes = (0, $c8359eecf064d1d0$export$5e4431114dfa28a8)(ownerState);
    const Component = slots?.barLabel ?? (0, $2e8b00e576463e73$export$9b4ae4ffae296a25);
    const _useSlotProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: Component,
        externalSlotProps: slotProps?.barLabel,
        additionalProps: (0, $aJx1R.default)({}, other, {
            style: style,
            className: classes.root
        }),
        ownerState: ownerState
    }), { ownerState: barLabelOwnerState } = _useSlotProps, barLabelProps = (0, $3L80X.default)(_useSlotProps, $6e5bd95818df1bcb$var$_excluded2);
    if (!barLabel) return null;
    const formattedLabelText = (0, $9f3d15c94f984b6b$export$36b75fa6134afd52)({
        barLabel: barLabel,
        value: value,
        dataIndex: dataIndex,
        seriesId: seriesId,
        height: height,
        width: width
    });
    if (!formattedLabelText) return null;
    return /*#__PURE__*/ (0, $aSiaI.jsx)(Component, (0, $aJx1R.default)({}, barLabelProps, barLabelOwnerState, {
        children: formattedLabelText
    }));
}



var $aSiaI = parcelRequire("aSiaI");
const $33f962996fddd3a0$var$_excluded = [
    "bars",
    "skipAnimation"
];
const $33f962996fddd3a0$var$leaveStyle = ({ layout: layout, yOrigin: yOrigin, x: x, width: width, y: y, xOrigin: xOrigin, height: height })=>(0, $aJx1R.default)({}, layout === "vertical" ? {
        y: yOrigin,
        x: x + width / 2,
        height: 0,
        width: width
    } : {
        y: y + height / 2,
        x: xOrigin,
        height: height,
        width: 0
    });
const $33f962996fddd3a0$var$enterStyle = ({ x: x, width: width, y: y, height: height })=>({
        x: x + width / 2,
        y: y + height / 2,
        height: height,
        width: width
    });
/**
 * @ignore - internal component.
 */ function $33f962996fddd3a0$export$af391adffc455ace(props) {
    const { bars: bars, skipAnimation: skipAnimation } = props, other = (0, $3L80X.default)(props, $33f962996fddd3a0$var$_excluded);
    const barLabelTransition = (0, $9f726edb03f4840c$export$7b286972b8d8ccbf)(bars, {
        keys: (bar)=>`${bar.seriesId}-${bar.dataIndex}`,
        from: $33f962996fddd3a0$var$leaveStyle,
        leave: null,
        enter: $33f962996fddd3a0$var$enterStyle,
        update: $33f962996fddd3a0$var$enterStyle,
        immediate: skipAnimation
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)($exYeM.Fragment, {
        children: barLabelTransition((style, { seriesId: seriesId, dataIndex: dataIndex, color: color, value: value, width: width, height: height })=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $6e5bd95818df1bcb$export$6b2b63bec3aef5c8), (0, $aJx1R.default)({
                seriesId: seriesId,
                dataIndex: dataIndex,
                value: value,
                color: color,
                width: width,
                height: height
            }, other, {
                style: style
            })))
    });
}



function $8f2aed6b99517e2d$export$5edb9af10389fa8f(scaleConfig) {
    return scaleConfig.scaleType === "band";
}
function $8f2aed6b99517e2d$export$6f8eeb227d19c9f7(scaleConfig) {
    return scaleConfig.scaleType === "point";
}


const $3fe03e732108f166$var$getAxisMessage = (axisDirection, axisKey)=>{
    const axisName = `${axisDirection}-axis`;
    const axisKeyName = `${axisDirection}Axis`;
    const axisDefaultKey = axisDirection === "x" ? (0, $f7012dce0f399219$export$85ea9370ff307a1f) : (0, $f7012dce0f399219$export$59bb26725f1fe1e8);
    return axisKey === axisDefaultKey ? `The first \`${axisKeyName}\`` : `The ${axisName} with id "${axisKey}"`;
};
function $3fe03e732108f166$export$580a14631bdcae07(verticalLayout, seriesId, xAxisKey, xAxis, yAxisKey, yAxis) {
    const xAxisConfig = xAxis[xAxisKey];
    const yAxisConfig = yAxis[yAxisKey];
    const discreteAxisConfig = verticalLayout ? xAxisConfig : yAxisConfig;
    const continuousAxisConfig = verticalLayout ? yAxisConfig : xAxisConfig;
    const discreteAxisKey = verticalLayout ? xAxisKey : yAxisKey;
    const continuousAxisKey = verticalLayout ? yAxisKey : xAxisKey;
    const discreteAxisDirection = verticalLayout ? "x" : "y";
    const continuousAxisDirection = verticalLayout ? "y" : "x";
    if (!(0, $8f2aed6b99517e2d$export$5edb9af10389fa8f)(discreteAxisConfig)) throw new Error(`MUI X Charts: ${$3fe03e732108f166$var$getAxisMessage(discreteAxisDirection, discreteAxisKey)} should be of type "band" to display the bar series of id "${seriesId}".`);
    if (discreteAxisConfig.data === undefined) throw new Error(`MUI X Charts: ${$3fe03e732108f166$var$getAxisMessage(discreteAxisDirection, discreteAxisKey)} should have data property.`);
    if ((0, $8f2aed6b99517e2d$export$5edb9af10389fa8f)(continuousAxisConfig) || (0, $8f2aed6b99517e2d$export$6f8eeb227d19c9f7)(continuousAxisConfig)) throw new Error(`MUI X Charts: ${$3fe03e732108f166$var$getAxisMessage(continuousAxisDirection, continuousAxisKey)} should be a continuous type to display the bar series of id "${seriesId}".`);
}



var $exYeM = parcelRequire("exYeM");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $aJx1R = parcelRequire("aJx1R");
const $c77afd6f68db30b3$var$DEFAULT_COLORS = [
    "#1f77b4",
    "#ff7f0e",
    "#2ca02c",
    "#d62728",
    "#9467bd",
    "#8c564b",
    "#e377c2",
    "#7f7f7f",
    "#bcbd22",
    "#17becf"
];
function $c77afd6f68db30b3$export$9813999d982b786e(series, seriesIndex, colors = $c77afd6f68db30b3$var$DEFAULT_COLORS) {
    if (series.type === "pie") return (0, $aJx1R.default)({}, series, {
        data: series.data.map((d, index)=>(0, $aJx1R.default)({
                color: colors[index % colors.length]
            }, d))
    });
    return (0, $aJx1R.default)({
        color: colors[seriesIndex % colors.length]
    }, series);
}


const $2ae3d32bf4f192d3$export$8d8ed2252b600aa0 = [
    "#02B2AF",
    "#2E96FF",
    "#B800D8",
    "#60009B",
    "#2731C8",
    "#03008D"
];
const $2ae3d32bf4f192d3$export$399833b5df3d8db9 = [
    "#02B2AF",
    "#72CCFF",
    "#DA00FF",
    "#9001CB",
    "#2E96FF",
    "#3B48E0"
];
const $2ae3d32bf4f192d3$export$8ed706fea94b7822 = (mode)=>mode === "dark" ? $2ae3d32bf4f192d3$export$399833b5df3d8db9 : $2ae3d32bf4f192d3$export$8d8ed2252b600aa0;
const $2ae3d32bf4f192d3$export$623f2758b04a3d15 = [
    "#173A5E",
    "#00A3A0",
    "#C91B63",
    "#EF5350",
    "#FFA726",
    "#B800D8",
    "#60009B",
    "#2E96FF",
    "#2731C8",
    "#03008D"
];
const $2ae3d32bf4f192d3$export$d0742eafc2d1c5fb = [
    "#41698F",
    "#19D0CD",
    "#DE196B",
    "#FC5F5C",
    "#FFD771",
    "#DA00FF",
    "#9001CB",
    "#72CCFF",
    "#2E96FF",
    "#3B48E0"
];
const $2ae3d32bf4f192d3$export$74421f4c46dde79c = (mode)=>mode === "dark" ? $2ae3d32bf4f192d3$export$d0742eafc2d1c5fb : $2ae3d32bf4f192d3$export$623f2758b04a3d15;
const $2ae3d32bf4f192d3$export$ad540a1534457fe5 = [
    "#0059B2",
    "#2E96FF",
    "#FFC24C",
    "#FF9F0E",
    "#F38200",
    "#2ABFDE",
    "#1F94AD",
    "#BD2C38",
    "#FF3143",
    "#FF8282"
];
const $2ae3d32bf4f192d3$export$a23534b9199d12ab = [
    "#003A75",
    "#007FFF",
    "#FFC24C",
    "#FF9D09",
    "#CA6C00",
    "#127D94",
    "#1F94AD",
    "#C82634",
    "#FF3143",
    "#FF7E7E"
];
const $2ae3d32bf4f192d3$export$eee733ebb00110ce = (mode)=>mode === "dark" ? $2ae3d32bf4f192d3$export$ad540a1534457fe5 : $2ae3d32bf4f192d3$export$a23534b9199d12ab;



var $aSiaI = parcelRequire("aSiaI");
const $c5c85aa0666bb83f$export$9d78c59083e52684 = /*#__PURE__*/ $exYeM.createContext({
    isInitialized: false,
    data: {}
});
/**
 * This methods is the interface between what the developer is providing and what components receives
 * To simplify the components behaviors, it groups series by type, such that LinePlots props are not updated if some line data are modified
 * It also add defaultized values such as the ids, colors
 * @param series The array of series provided by devs
 * @param colors The color palette used to defaultize series colors
 * @returns An object structuring all the series by type.
 */ const $c5c85aa0666bb83f$var$preprocessSeries = (series, colors, seriesFormatters, dataset)=>{
    // Group series by type
    const seriesGroups = {};
    series.forEach((seriesData, seriesIndex)=>{
        const { id: id = `auto-generated-id-${seriesIndex}`, type: type } = seriesData;
        if (seriesGroups[type] === undefined) seriesGroups[type] = {
            series: {},
            seriesOrder: []
        };
        if (seriesGroups[type]?.series[id] !== undefined) throw new Error(`MUI X Charts: series' id "${id}" is not unique.`);
        seriesGroups[type].series[id] = (0, $aJx1R.default)({
            id: id
        }, (0, $c77afd6f68db30b3$export$9813999d982b786e)(seriesData, seriesIndex, colors));
        seriesGroups[type].seriesOrder.push(id);
    });
    const formattedSeries = {};
    // Apply formatter on a type group
    Object.keys(seriesFormatters).forEach((type)=>{
        const group = seriesGroups[type];
        if (group !== undefined) formattedSeries[type] = seriesFormatters[type]?.(group, dataset) ?? seriesGroups[type];
    });
    return formattedSeries;
};
function $c5c85aa0666bb83f$export$41d46bc18e30c447(props) {
    const { series: series, dataset: dataset, colors: colors = (0, $2ae3d32bf4f192d3$export$8ed706fea94b7822), seriesFormatters: seriesFormatters, children: children } = props;
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const formattedSeries = $exYeM.useMemo(()=>({
            isInitialized: true,
            data: $c5c85aa0666bb83f$var$preprocessSeries(series, typeof colors === "function" ? colors(theme.palette.mode) : colors, seriesFormatters, dataset)
        }), [
        series,
        colors,
        theme.palette.mode,
        seriesFormatters,
        dataset
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($c5c85aa0666bb83f$export$9d78c59083e52684.Provider, {
        value: formattedSeries,
        children: children
    });
}


function $ba69253362075717$export$23a245cc02c91dfa() {
    const { isInitialized: isInitialized, data: data } = $exYeM.useContext((0, $c5c85aa0666bb83f$export$9d78c59083e52684));
    if (!isInitialized) throw new Error([
        "MUI X: Could not find the series ref context.",
        "It looks like you rendered your component outside of a ChartsContainer parent component."
    ].join("\n"));
    return data;
}
function $ba69253362075717$export$c3f6a4f3effc82b1() {
    const series = $ba69253362075717$export$23a245cc02c91dfa();
    return $exYeM.useMemo(()=>series.pie, [
        series.pie
    ]);
}
function $ba69253362075717$export$f7090460c70512f0() {
    const series = $ba69253362075717$export$23a245cc02c91dfa();
    return $exYeM.useMemo(()=>series.line, [
        series.line
    ]);
}
function $ba69253362075717$export$824329d5fef8f659() {
    const series = $ba69253362075717$export$23a245cc02c91dfa();
    return $exYeM.useMemo(()=>series.bar, [
        series.bar
    ]);
}
function $ba69253362075717$export$df17f1fe7b18aa42() {
    const series = $ba69253362075717$export$23a245cc02c91dfa();
    return $exYeM.useMemo(()=>series.scatter, [
        series.scatter
    ]);
}



var $aSiaI = parcelRequire("aSiaI");
const $122f27ba37011048$var$_excluded = [
    "skipAnimation",
    "onItemClick",
    "borderRadius",
    "barLabel"
];
function $122f27ba37011048$var$getBandSize({ bandWidth: W, numberOfGroups: N, gapRatio: r }) {
    if (r === 0) return {
        barWidth: W / N,
        offset: 0
    };
    const barWidth = W / (N + (N - 1) * r);
    const offset = r * barWidth;
    return {
        barWidth: barWidth,
        offset: offset
    };
}
const $122f27ba37011048$var$useAggregatedData = ()=>{
    const seriesData = (0, $ba69253362075717$export$824329d5fef8f659)() ?? {
        series: {},
        stackingGroups: [],
        seriesOrder: []
    };
    const axisData = (0, $27adb4455fa596cf$export$2785a2cc09fc5c5f)();
    const chartId = (0, $0b3940f442933067$export$310c4c2c8f792eac)();
    const { series: series, stackingGroups: stackingGroups } = seriesData;
    const { xAxis: xAxis, yAxis: yAxis, xAxisIds: xAxisIds, yAxisIds: yAxisIds } = axisData;
    const defaultXAxisId = xAxisIds[0];
    const defaultYAxisId = yAxisIds[0];
    const masks = {};
    const data = stackingGroups.flatMap(({ ids: groupIds }, groupIndex)=>{
        return groupIds.flatMap((seriesId)=>{
            const xAxisKey = series[seriesId].xAxisKey ?? defaultXAxisId;
            const yAxisKey = series[seriesId].yAxisKey ?? defaultYAxisId;
            const xAxisConfig = xAxis[xAxisKey];
            const yAxisConfig = yAxis[yAxisKey];
            const verticalLayout = series[seriesId].layout === "vertical";
            (0, $3fe03e732108f166$export$580a14631bdcae07)(verticalLayout, seriesId, xAxisKey, xAxis, yAxisKey, yAxis);
            const baseScaleConfig = verticalLayout ? xAxisConfig : yAxisConfig;
            const xScale = xAxisConfig.scale;
            const yScale = yAxisConfig.scale;
            const colorGetter = (0, $69b8a720613cd165$export$2e2bcd8739ae039)(series[seriesId], xAxis[xAxisKey], yAxis[yAxisKey]);
            const bandWidth = baseScaleConfig.scale.bandwidth();
            const { barWidth: barWidth, offset: offset } = $122f27ba37011048$var$getBandSize({
                bandWidth: bandWidth,
                numberOfGroups: stackingGroups.length,
                gapRatio: baseScaleConfig.barGapRatio
            });
            const barOffset = groupIndex * (barWidth + offset);
            const { stackedData: stackedData } = series[seriesId];
            return stackedData.map((values, dataIndex)=>{
                const valueCoordinates = values.map((v)=>verticalLayout ? yScale(v) : xScale(v));
                const minValueCoord = Math.round(Math.min(...valueCoordinates));
                const maxValueCoord = Math.round(Math.max(...valueCoordinates));
                const stackId = series[seriesId].stack;
                const result = {
                    seriesId: seriesId,
                    dataIndex: dataIndex,
                    layout: series[seriesId].layout,
                    x: verticalLayout ? xScale(xAxis[xAxisKey].data?.[dataIndex]) + barOffset : minValueCoord,
                    y: verticalLayout ? minValueCoord : yScale(yAxis[yAxisKey].data?.[dataIndex]) + barOffset,
                    xOrigin: xScale(0),
                    yOrigin: yScale(0),
                    height: verticalLayout ? maxValueCoord - minValueCoord : barWidth,
                    width: verticalLayout ? barWidth : maxValueCoord - minValueCoord,
                    color: colorGetter(dataIndex),
                    value: series[seriesId].data[dataIndex],
                    maskId: `${chartId}_${stackId || seriesId}_${groupIndex}_${dataIndex}`
                };
                if (!masks[result.maskId]) masks[result.maskId] = {
                    id: result.maskId,
                    width: 0,
                    height: 0,
                    hasNegative: false,
                    hasPositive: false,
                    layout: result.layout,
                    xOrigin: xScale(0),
                    yOrigin: yScale(0),
                    x: 0,
                    y: 0
                };
                const mask = masks[result.maskId];
                mask.width = result.layout === "vertical" ? result.width : mask.width + result.width;
                mask.height = result.layout === "vertical" ? mask.height + result.height : result.height;
                mask.x = Math.min(mask.x === 0 ? Infinity : mask.x, result.x);
                mask.y = Math.min(mask.y === 0 ? Infinity : mask.y, result.y);
                mask.hasNegative = mask.hasNegative || (result.value ?? 0) < 0;
                mask.hasPositive = mask.hasPositive || (result.value ?? 0) > 0;
                return result;
            });
        });
    });
    return {
        completedData: data,
        masksData: Object.values(masks)
    };
};
const $122f27ba37011048$var$leaveStyle = ({ layout: layout, yOrigin: yOrigin, x: x, width: width, y: y, xOrigin: xOrigin, height: height })=>(0, $aJx1R.default)({}, layout === "vertical" ? {
        y: yOrigin,
        x: x,
        height: 0,
        width: width
    } : {
        y: y,
        x: xOrigin,
        height: height,
        width: 0
    });
const $122f27ba37011048$var$enterStyle = ({ x: x, width: width, y: y, height: height })=>({
        y: y,
        x: x,
        height: height,
        width: width
    });
/**
 * Demos:
 *
 * - [Bars](https://mui.com/x/react-charts/bars/)
 * - [Bar demonstration](https://mui.com/x/react-charts/bar-demo/)
 * - [Stacking](https://mui.com/x/react-charts/stacking/)
 *
 * API:
 *
 * - [BarPlot API](https://mui.com/x/api/charts/bar-plot/)
 */ function $122f27ba37011048$export$bb9821b32a110f1f(props) {
    const { completedData: completedData, masksData: masksData } = $122f27ba37011048$var$useAggregatedData();
    const { skipAnimation: skipAnimation, onItemClick: onItemClick, borderRadius: borderRadius, barLabel: barLabel } = props, other = (0, $3L80X.default)(props, $122f27ba37011048$var$_excluded);
    const transition = (0, $9f726edb03f4840c$export$7b286972b8d8ccbf)(completedData, {
        keys: (bar)=>`${bar.seriesId}-${bar.dataIndex}`,
        from: $122f27ba37011048$var$leaveStyle,
        leave: $122f27ba37011048$var$leaveStyle,
        enter: $122f27ba37011048$var$enterStyle,
        update: $122f27ba37011048$var$enterStyle,
        immediate: skipAnimation
    });
    const maskTransition = (0, $9f726edb03f4840c$export$7b286972b8d8ccbf)(masksData, {
        keys: (v)=>v.id,
        from: $122f27ba37011048$var$leaveStyle,
        leave: $122f27ba37011048$var$leaveStyle,
        enter: $122f27ba37011048$var$enterStyle,
        update: $122f27ba37011048$var$enterStyle,
        immediate: skipAnimation
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
        children: [
            maskTransition((style, { id: id, hasPositive: hasPositive, hasNegative: hasNegative, layout: layout })=>{
                return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dcd8e30357627c99$export$3b82c9de4265d9c8), {
                    maskId: id,
                    borderRadius: borderRadius,
                    hasNegative: hasNegative,
                    hasPositive: hasPositive,
                    layout: layout,
                    style: style
                });
            }),
            transition((style, { seriesId: seriesId, dataIndex: dataIndex, color: color, maskId: maskId })=>{
                const barElement = /*#__PURE__*/ (0, $aSiaI.jsx)((0, $393647d9097ddec4$export$a16ed71bf4b07672), (0, $aJx1R.default)({
                    id: seriesId,
                    dataIndex: dataIndex,
                    color: color
                }, other, {
                    onClick: onItemClick && ((event)=>{
                        onItemClick(event, {
                            type: "bar",
                            seriesId: seriesId,
                            dataIndex: dataIndex
                        });
                    }),
                    style: style
                }));
                if (!borderRadius || borderRadius <= 0) return barElement;
                return /*#__PURE__*/ (0, $aSiaI.jsx)("g", {
                    clipPath: `url(#${maskId})`,
                    children: barElement
                });
            }),
            barLabel && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $33f962996fddd3a0$export$af391adffc455ace), (0, $aJx1R.default)({
                bars: completedData,
                skipAnimation: skipAnimation,
                barLabel: barLabel
            }, other))
        ]
    });
}



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");





var $exYeM = parcelRequire("exYeM");

var $aSiaI = parcelRequire("aSiaI");
const $dfcbbd289db5098e$export$f8ec96023ad51b86 = /*#__PURE__*/ $exYeM.createContext({});
function $dfcbbd289db5098e$export$c8d11923ce5dd047(props) {
    const { colorProcessors: colorProcessors, children: children } = props;
    return /*#__PURE__*/ (0, $aSiaI.jsx)($dfcbbd289db5098e$export$f8ec96023ad51b86.Provider, {
        value: colorProcessors,
        children: children
    });
}



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $jawKn = parcelRequire("jawKn");


var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");


function $83a42db726948b22$export$ee3f06150b977754(scale) {
    return scale.bandwidth !== undefined;
}


/**
 * Transform mouse event position to coordinates inside the SVG.
 * @param svg The SVG element
 * @param event The mouseEvent to transform
 */ function $c8fb4d74c9316c50$export$b8e7c910eb57b330(svg, event) {
    const pt = svg.createSVGPoint();
    pt.x = event.clientX;
    pt.y = event.clientY;
    return pt.matrixTransform(svg.getScreenCTM().inverse());
}



var $exYeM = parcelRequire("exYeM");

function $ae025d5d266ffedb$export$839818ed0cc5fa73() {
    const { isInitialized: isInitialized, data: data } = $exYeM.useContext((0, $7e3726a4b537e82f$export$38ebea5d49ec5192));
    if (!isInitialized) throw new Error([
        "MUI X: Could not find the svg ref context.",
        "It looks like you rendered your component outside of a ChartsContainer parent component."
    ].join("\n"));
    return data;
}



var $exYeM = parcelRequire("exYeM");

function $767eebe86d6e6272$export$389be1739214a0a2() {
    const { left: left, top: top, width: width, height: height, bottom: bottom, right: right, isPointInside: isPointInside } = $exYeM.useContext((0, $7e3726a4b537e82f$export$6b4b60c0e05835fe));
    return $exYeM.useMemo(()=>({
            left: left,
            top: top,
            width: width,
            height: height,
            bottom: bottom,
            right: right,
            isPointInside: isPointInside
        }), [
        height,
        left,
        top,
        width,
        bottom,
        right,
        isPointInside
    ]);
}


function $9d667f017e50a88a$var$getAsANumber(value) {
    return value instanceof Date ? value.getTime() : value;
}
const $9d667f017e50a88a$export$f359f4630565c8fa = (disableAxisListener)=>{
    const svgRef = (0, $ae025d5d266ffedb$export$839818ed0cc5fa73)();
    const drawingArea = (0, $767eebe86d6e6272$export$389be1739214a0a2)();
    const { xAxis: xAxis, yAxis: yAxis, xAxisIds: xAxisIds, yAxisIds: yAxisIds } = (0, $27adb4455fa596cf$export$2785a2cc09fc5c5f)();
    const { dispatch: dispatch } = $exYeM.useContext((0, $4791e4ada5496d01$export$d6ef105978afa6a));
    const usedXAxis = xAxisIds[0];
    const usedYAxis = yAxisIds[0];
    // Use a ref to avoid rerendering on every mousemove event.
    const mousePosition = $exYeM.useRef({
        x: -1,
        y: -1
    });
    $exYeM.useEffect(()=>{
        const element = svgRef.current;
        if (element === null || disableAxisListener) return ()=>{};
        function getNewAxisState(axisConfig, mouseValue) {
            const { scale: scale, data: axisData, reverse: reverse } = axisConfig;
            if (!(0, $83a42db726948b22$export$ee3f06150b977754)(scale)) {
                const value = scale.invert(mouseValue);
                if (axisData === undefined) return {
                    value: value
                };
                const valueAsNumber = $9d667f017e50a88a$var$getAsANumber(value);
                const closestIndex = axisData?.findIndex((pointValue, index)=>{
                    const v = $9d667f017e50a88a$var$getAsANumber(pointValue);
                    if (v > valueAsNumber) {
                        if (index === 0 || Math.abs(valueAsNumber - v) <= Math.abs(valueAsNumber - $9d667f017e50a88a$var$getAsANumber(axisData[index - 1]))) return true;
                    }
                    if (v <= valueAsNumber) {
                        if (index === axisData.length - 1 || Math.abs($9d667f017e50a88a$var$getAsANumber(value) - v) < Math.abs($9d667f017e50a88a$var$getAsANumber(value) - $9d667f017e50a88a$var$getAsANumber(axisData[index + 1]))) return true;
                    }
                    return false;
                });
                return {
                    value: closestIndex !== undefined && closestIndex >= 0 ? axisData[closestIndex] : value,
                    index: closestIndex
                };
            }
            const dataIndex = scale.bandwidth() === 0 ? Math.floor((mouseValue - Math.min(...scale.range()) + scale.step() / 2) / scale.step()) : Math.floor((mouseValue - Math.min(...scale.range())) / scale.step());
            if (dataIndex < 0 || dataIndex >= axisData.length) return null;
            if (reverse) {
                const reverseIndex = axisData.length - 1 - dataIndex;
                return {
                    index: reverseIndex,
                    value: axisData[reverseIndex]
                };
            }
            return {
                index: dataIndex,
                value: axisData[dataIndex]
            };
        }
        const handleOut = ()=>{
            mousePosition.current = {
                x: -1,
                y: -1
            };
            dispatch({
                type: "exitChart"
            });
        };
        const handleMove = (event)=>{
            const target = "targetTouches" in event ? event.targetTouches[0] : event;
            const svgPoint = (0, $c8fb4d74c9316c50$export$b8e7c910eb57b330)(element, target);
            mousePosition.current = {
                x: svgPoint.x,
                y: svgPoint.y
            };
            if (!drawingArea.isPointInside(svgPoint)) {
                dispatch({
                    type: "exitChart"
                });
                return;
            }
            const newStateX = getNewAxisState(xAxis[usedXAxis], svgPoint.x);
            const newStateY = getNewAxisState(yAxis[usedYAxis], svgPoint.y);
            dispatch({
                type: "updateAxis",
                data: {
                    x: newStateX,
                    y: newStateY
                }
            });
        };
        const handleDown = (event)=>{
            const target = event.currentTarget;
            if (!target) return;
            if (target.hasPointerCapture(event.pointerId)) target.releasePointerCapture(event.pointerId);
        };
        element.addEventListener("pointerdown", handleDown);
        element.addEventListener("pointermove", handleMove);
        element.addEventListener("pointerout", handleOut);
        element.addEventListener("pointercancel", handleOut);
        element.addEventListener("pointerleave", handleOut);
        return ()=>{
            element.removeEventListener("pointerdown", handleDown);
            element.removeEventListener("pointermove", handleMove);
            element.removeEventListener("pointerout", handleOut);
            element.removeEventListener("pointercancel", handleOut);
            element.removeEventListener("pointerleave", handleOut);
        };
    }, [
        svgRef,
        dispatch,
        usedYAxis,
        yAxis,
        usedXAxis,
        xAxis,
        disableAxisListener,
        drawingArea
    ]);
};



var $aSiaI = parcelRequire("aSiaI");
const $cf2e11b8d493cfa0$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "disableAxisListener",
    "className",
    "title",
    "desc"
];
const $cf2e11b8d493cfa0$var$ChartChartsSurfaceStyles = (0, $jawKn.default)("svg", {
    name: "MuiChartsSurface",
    slot: "Root"
})(()=>({
        // This prevents default touch actions when using the svg on mobile devices.
        // For example, prevent page scroll & zoom.
        touchAction: "none"
    }));
const $cf2e11b8d493cfa0$export$2880d8f25d9cea27 = /*#__PURE__*/ $exYeM.forwardRef(function ChartsSurface(props, ref) {
    const { children: children, width: width, height: height, viewBox: viewBox, disableAxisListener: disableAxisListener = false, className: className, title: title, desc: desc } = props, other = (0, $3L80X.default)(props, $cf2e11b8d493cfa0$var$_excluded);
    const svgView = (0, $aJx1R.default)({
        width: width,
        height: height,
        x: 0,
        y: 0
    }, viewBox);
    (0, $9d667f017e50a88a$export$f359f4630565c8fa)(disableAxisListener);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($cf2e11b8d493cfa0$var$ChartChartsSurfaceStyles, (0, $aJx1R.default)({
        width: width,
        height: height,
        viewBox: `${svgView.x} ${svgView.y} ${svgView.width} ${svgView.height}`,
        ref: ref,
        className: className
    }, other, {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("desc", {
                children: desc
            }),
            children
        ]
    }));
});



var $exYeM = parcelRequire("exYeM");




var $aJx1R = parcelRequire("aJx1R");
function $fac1aedae8692883$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}


function $1ec9baa7d5ff9a04$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $1ec9baa7d5ff9a04$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}


class $e8cd6884d2a38292$export$dcc6fb7d82b5bc7b extends Map {
    constructor(entries, key = $e8cd6884d2a38292$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($e8cd6884d2a38292$var$intern_get(this, key));
    }
    has(key) {
        return super.has($e8cd6884d2a38292$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($e8cd6884d2a38292$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($e8cd6884d2a38292$var$intern_delete(this, key));
    }
}
class $e8cd6884d2a38292$export$55278c3294239828 extends Set {
    constructor(values, key = $e8cd6884d2a38292$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($e8cd6884d2a38292$var$intern_get(this, value));
    }
    add(value) {
        return super.add($e8cd6884d2a38292$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($e8cd6884d2a38292$var$intern_delete(this, value));
    }
}
function $e8cd6884d2a38292$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $e8cd6884d2a38292$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $e8cd6884d2a38292$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $e8cd6884d2a38292$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}



const $b5f1e5e45355bfef$export$e4f898ab14d9d460 = Symbol("implicit");
function $b5f1e5e45355bfef$export$2e2bcd8739ae039() {
    var index = new (0, $e8cd6884d2a38292$export$dcc6fb7d82b5bc7b)(), domain = [], range = [], unknown = $b5f1e5e45355bfef$export$e4f898ab14d9d460;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $b5f1e5e45355bfef$export$e4f898ab14d9d460) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, $e8cd6884d2a38292$export$dcc6fb7d82b5bc7b)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $b5f1e5e45355bfef$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $1ec9baa7d5ff9a04$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}


function $66ab919e2a60291e$export$2e2bcd8739ae039() {
    var scale = (0, $b5f1e5e45355bfef$export$2e2bcd8739ae039)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $fac1aedae8692883$export$2e2bcd8739ae039)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $66ab919e2a60291e$export$2e2bcd8739ae039(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $1ec9baa7d5ff9a04$export$23c7bb9e6558da2a).apply(rescale(), arguments);
}
function $66ab919e2a60291e$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $66ab919e2a60291e$var$pointish(copy());
    };
    return scale;
}
function $66ab919e2a60291e$export$105684a3041cb6f3() {
    return $66ab919e2a60291e$var$pointish($66ab919e2a60291e$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}

const $9939f74c1c819889$var$t0 = new Date, $9939f74c1c819889$var$t1 = new Date;
function $9939f74c1c819889$export$1a539c8b2950ab40(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = (date)=>{
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = (date)=>{
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = (date)=>{
        const d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = (date, step)=>{
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = (start, stop, step)=>{
        const range = [];
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        let previous;
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = (test)=>{
        return $9939f74c1c819889$export$1a539c8b2950ab40((date)=>{
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, (date, step)=>{
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = (start, end)=>{
            $9939f74c1c819889$var$t0.setTime(+start), $9939f74c1c819889$var$t1.setTime(+end);
            floori($9939f74c1c819889$var$t0), floori($9939f74c1c819889$var$t1);
            return Math.floor(count($9939f74c1c819889$var$t0, $9939f74c1c819889$var$t1));
        };
        interval.every = (step)=>{
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
        };
    }
    return interval;
}


const $df9831fb4f95f7fb$export$79ef0e34099623dc = 1000;
const $df9831fb4f95f7fb$export$683905d551c33fa9 = $df9831fb4f95f7fb$export$79ef0e34099623dc * 60;
const $df9831fb4f95f7fb$export$4157bf0c8e241659 = $df9831fb4f95f7fb$export$683905d551c33fa9 * 60;
const $df9831fb4f95f7fb$export$353686095f4fbf45 = $df9831fb4f95f7fb$export$4157bf0c8e241659 * 24;
const $df9831fb4f95f7fb$export$c241eb88520d5016 = $df9831fb4f95f7fb$export$353686095f4fbf45 * 7;
const $df9831fb4f95f7fb$export$ab95684df7020b26 = $df9831fb4f95f7fb$export$353686095f4fbf45 * 30;
const $df9831fb4f95f7fb$export$61f8ee2d834c6959 = $df9831fb4f95f7fb$export$353686095f4fbf45 * 365;


const $20c9bda5cc5feed8$export$8888529b966033e5 = (0, $9939f74c1c819889$export$1a539c8b2950ab40)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $df9831fb4f95f7fb$export$683905d551c33fa9)) / (0, $df9831fb4f95f7fb$export$353686095f4fbf45), (date)=>date.getDate() - 1);
const $20c9bda5cc5feed8$export$6657a54f3034cf45 = $20c9bda5cc5feed8$export$8888529b966033e5.range;
const $20c9bda5cc5feed8$export$c8cbc42cefd47140 = (0, $9939f74c1c819889$export$1a539c8b2950ab40)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $df9831fb4f95f7fb$export$353686095f4fbf45);
}, (date)=>{
    return date.getUTCDate() - 1;
});
const $20c9bda5cc5feed8$export$d277e198508549a1 = $20c9bda5cc5feed8$export$c8cbc42cefd47140.range;
const $20c9bda5cc5feed8$export$fb065be2d7ea4a71 = (0, $9939f74c1c819889$export$1a539c8b2950ab40)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $df9831fb4f95f7fb$export$353686095f4fbf45);
}, (date)=>{
    return Math.floor(date / (0, $df9831fb4f95f7fb$export$353686095f4fbf45));
});
const $20c9bda5cc5feed8$export$a491caaf5e9481aa = $20c9bda5cc5feed8$export$fb065be2d7ea4a71.range;



const $54c52d7793bb6b78$export$46c68a5833bc315b = (0, $9939f74c1c819889$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $df9831fb4f95f7fb$export$79ef0e34099623dc) - date.getMinutes() * (0, $df9831fb4f95f7fb$export$683905d551c33fa9));
}, (date, step)=>{
    date.setTime(+date + step * (0, $df9831fb4f95f7fb$export$4157bf0c8e241659));
}, (start, end)=>{
    return (end - start) / (0, $df9831fb4f95f7fb$export$4157bf0c8e241659);
}, (date)=>{
    return date.getHours();
});
const $54c52d7793bb6b78$export$fb843f9087cd5235 = $54c52d7793bb6b78$export$46c68a5833bc315b.range;
const $54c52d7793bb6b78$export$31f6f2b3c63ac75e = (0, $9939f74c1c819889$export$1a539c8b2950ab40)((date)=>{
    date.setUTCMinutes(0, 0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $df9831fb4f95f7fb$export$4157bf0c8e241659));
}, (start, end)=>{
    return (end - start) / (0, $df9831fb4f95f7fb$export$4157bf0c8e241659);
}, (date)=>{
    return date.getUTCHours();
});
const $54c52d7793bb6b78$export$6e7a76cd5f50b719 = $54c52d7793bb6b78$export$31f6f2b3c63ac75e.range;



const $63c90b161916de7a$export$a7e4c34a52f0576 = (0, $9939f74c1c819889$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $df9831fb4f95f7fb$export$79ef0e34099623dc));
}, (date, step)=>{
    date.setTime(+date + step * (0, $df9831fb4f95f7fb$export$683905d551c33fa9));
}, (start, end)=>{
    return (end - start) / (0, $df9831fb4f95f7fb$export$683905d551c33fa9);
}, (date)=>{
    return date.getMinutes();
});
const $63c90b161916de7a$export$186d65358374c0a2 = $63c90b161916de7a$export$a7e4c34a52f0576.range;
const $63c90b161916de7a$export$efe6712d6003761b = (0, $9939f74c1c819889$export$1a539c8b2950ab40)((date)=>{
    date.setUTCSeconds(0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $df9831fb4f95f7fb$export$683905d551c33fa9));
}, (start, end)=>{
    return (end - start) / (0, $df9831fb4f95f7fb$export$683905d551c33fa9);
}, (date)=>{
    return date.getUTCMinutes();
});
const $63c90b161916de7a$export$cedd563624e8ee50 = $63c90b161916de7a$export$efe6712d6003761b.range;


const $0510ad95fe0d8745$export$7e1084fb688591c1 = (0, $9939f74c1c819889$export$1a539c8b2950ab40)((date)=>{
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setMonth(date.getMonth() + step);
}, (start, end)=>{
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date)=>{
    return date.getMonth();
});
const $0510ad95fe0d8745$export$3e24aa839cd0f1c4 = $0510ad95fe0d8745$export$7e1084fb688591c1.range;
const $0510ad95fe0d8745$export$cd49b3d2bcfe50d5 = (0, $9939f74c1c819889$export$1a539c8b2950ab40)((date)=>{
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end)=>{
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date)=>{
    return date.getUTCMonth();
});
const $0510ad95fe0d8745$export$49159f585997498 = $0510ad95fe0d8745$export$cd49b3d2bcfe50d5.range;



const $8f97853afe54cc4a$export$3d3c77ce7df7d30d = (0, $9939f74c1c819889$export$1a539c8b2950ab40)((date)=>{
    date.setTime(date - date.getMilliseconds());
}, (date, step)=>{
    date.setTime(+date + step * (0, $df9831fb4f95f7fb$export$79ef0e34099623dc));
}, (start, end)=>{
    return (end - start) / (0, $df9831fb4f95f7fb$export$79ef0e34099623dc);
}, (date)=>{
    return date.getUTCSeconds();
});
const $8f97853afe54cc4a$export$4792e48abc550fa1 = $8f97853afe54cc4a$export$3d3c77ce7df7d30d.range;

function $b9a39bb6f3499963$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $e5d655064a12cb62$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $ab71cf57ae8c76e8$export$2e2bcd8739ae039(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, $b9a39bb6f3499963$export$2e2bcd8739ae039);
        compare2 = (d, x)=>(0, $b9a39bb6f3499963$export$2e2bcd8739ae039)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, $b9a39bb6f3499963$export$2e2bcd8739ae039) || f === (0, $e5d655064a12cb62$export$2e2bcd8739ae039) ? f : $ab71cf57ae8c76e8$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $ab71cf57ae8c76e8$var$zero() {
    return 0;
}

const $e70716585309e68a$var$e10 = Math.sqrt(50), $e70716585309e68a$var$e5 = Math.sqrt(10), $e70716585309e68a$var$e2 = Math.sqrt(2);
function $e70716585309e68a$var$tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= $e70716585309e68a$var$e10 ? 10 : error >= $e70716585309e68a$var$e5 ? 5 : error >= $e70716585309e68a$var$e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return $e70716585309e68a$var$tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function $e70716585309e68a$export$2e2bcd8739ae039(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? $e70716585309e68a$var$tickSpec(stop, start, count) : $e70716585309e68a$var$tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function $e70716585309e68a$export$bc64d00cc98e7e95(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return $e70716585309e68a$var$tickSpec(start, stop, count)[2];
}
function $e70716585309e68a$export$81087d9b915d4ede(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? $e70716585309e68a$export$bc64d00cc98e7e95(stop, start, count) : $e70716585309e68a$export$bc64d00cc98e7e95(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}




const $3a0c7fd69e52994c$export$edc5e5cb87280477 = (0, $9939f74c1c819889$export$1a539c8b2950ab40)(()=>{
// noop
}, (date, step)=>{
    date.setTime(+date + step);
}, (start, end)=>{
    return end - start;
});
// An optimized implementation for this simple case.
$3a0c7fd69e52994c$export$edc5e5cb87280477.every = (k)=>{
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $3a0c7fd69e52994c$export$edc5e5cb87280477;
    return (0, $9939f74c1c819889$export$1a539c8b2950ab40)((date)=>{
        date.setTime(Math.floor(date / k) * k);
    }, (date, step)=>{
        date.setTime(+date + step * k);
    }, (start, end)=>{
        return (end - start) / k;
    });
};
const $3a0c7fd69e52994c$export$9a27fac83d67afd3 = $3a0c7fd69e52994c$export$edc5e5cb87280477.range;








function $0c15e9d65f86b7e7$var$timeWeekday(i) {
    return (0, $9939f74c1c819889$export$1a539c8b2950ab40)((date)=>{
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setDate(date.getDate() + step * 7);
    }, (start, end)=>{
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $df9831fb4f95f7fb$export$683905d551c33fa9)) / (0, $df9831fb4f95f7fb$export$c241eb88520d5016);
    });
}
const $0c15e9d65f86b7e7$export$22ee6205b762968c = $0c15e9d65f86b7e7$var$timeWeekday(0);
const $0c15e9d65f86b7e7$export$e79bbe0177cf1b01 = $0c15e9d65f86b7e7$var$timeWeekday(1);
const $0c15e9d65f86b7e7$export$57c0658c29f77708 = $0c15e9d65f86b7e7$var$timeWeekday(2);
const $0c15e9d65f86b7e7$export$3fbeef226c256e43 = $0c15e9d65f86b7e7$var$timeWeekday(3);
const $0c15e9d65f86b7e7$export$608689422d5cf9f4 = $0c15e9d65f86b7e7$var$timeWeekday(4);
const $0c15e9d65f86b7e7$export$548e5227aa183dca = $0c15e9d65f86b7e7$var$timeWeekday(5);
const $0c15e9d65f86b7e7$export$c56a3ad248908e19 = $0c15e9d65f86b7e7$var$timeWeekday(6);
const $0c15e9d65f86b7e7$export$eac514c8a8674eba = $0c15e9d65f86b7e7$export$22ee6205b762968c.range;
const $0c15e9d65f86b7e7$export$f7219b1481948356 = $0c15e9d65f86b7e7$export$e79bbe0177cf1b01.range;
const $0c15e9d65f86b7e7$export$77e22b12c5bed05b = $0c15e9d65f86b7e7$export$57c0658c29f77708.range;
const $0c15e9d65f86b7e7$export$b85d407a471809e8 = $0c15e9d65f86b7e7$export$3fbeef226c256e43.range;
const $0c15e9d65f86b7e7$export$c1bc1c49254c8855 = $0c15e9d65f86b7e7$export$608689422d5cf9f4.range;
const $0c15e9d65f86b7e7$export$3691a1557fff46f1 = $0c15e9d65f86b7e7$export$548e5227aa183dca.range;
const $0c15e9d65f86b7e7$export$b755452d02cba8d2 = $0c15e9d65f86b7e7$export$c56a3ad248908e19.range;
function $0c15e9d65f86b7e7$var$utcWeekday(i) {
    return (0, $9939f74c1c819889$export$1a539c8b2950ab40)((date)=>{
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, (start, end)=>{
        return (end - start) / (0, $df9831fb4f95f7fb$export$c241eb88520d5016);
    });
}
const $0c15e9d65f86b7e7$export$4898b06303a92011 = $0c15e9d65f86b7e7$var$utcWeekday(0);
const $0c15e9d65f86b7e7$export$9cfc53b9cfafd080 = $0c15e9d65f86b7e7$var$utcWeekday(1);
const $0c15e9d65f86b7e7$export$2a6d545f77eceb15 = $0c15e9d65f86b7e7$var$utcWeekday(2);
const $0c15e9d65f86b7e7$export$a5c25d8ed64433c4 = $0c15e9d65f86b7e7$var$utcWeekday(3);
const $0c15e9d65f86b7e7$export$1db08111baec2f53 = $0c15e9d65f86b7e7$var$utcWeekday(4);
const $0c15e9d65f86b7e7$export$29265e34dd5921f7 = $0c15e9d65f86b7e7$var$utcWeekday(5);
const $0c15e9d65f86b7e7$export$85b74dad05049604 = $0c15e9d65f86b7e7$var$utcWeekday(6);
const $0c15e9d65f86b7e7$export$6f3e1c2b0f7d7880 = $0c15e9d65f86b7e7$export$4898b06303a92011.range;
const $0c15e9d65f86b7e7$export$1d2d8b858bb366f9 = $0c15e9d65f86b7e7$export$9cfc53b9cfafd080.range;
const $0c15e9d65f86b7e7$export$1d5f6785fc7f30f8 = $0c15e9d65f86b7e7$export$2a6d545f77eceb15.range;
const $0c15e9d65f86b7e7$export$7a75faf0e37ef4af = $0c15e9d65f86b7e7$export$a5c25d8ed64433c4.range;
const $0c15e9d65f86b7e7$export$417eb959611b2f2f = $0c15e9d65f86b7e7$export$1db08111baec2f53.range;
const $0c15e9d65f86b7e7$export$59d308db7af08c64 = $0c15e9d65f86b7e7$export$29265e34dd5921f7.range;
const $0c15e9d65f86b7e7$export$a124108a0a7f34c8 = $0c15e9d65f86b7e7$export$85b74dad05049604.range;




const $9ad421df7f9e054b$export$cd17cfe45df0c046 = (0, $9939f74c1c819889$export$1a539c8b2950ab40)((date)=>{
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setFullYear(date.getFullYear() + step);
}, (start, end)=>{
    return end.getFullYear() - start.getFullYear();
}, (date)=>{
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$9ad421df7f9e054b$export$cd17cfe45df0c046.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $9939f74c1c819889$export$1a539c8b2950ab40)((date)=>{
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step * k);
    });
};
const $9ad421df7f9e054b$export$69a4e90dd2cc3bd1 = $9ad421df7f9e054b$export$cd17cfe45df0c046.range;
const $9ad421df7f9e054b$export$d5c3802e389714c4 = (0, $9939f74c1c819889$export$1a539c8b2950ab40)((date)=>{
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end)=>{
    return end.getUTCFullYear() - start.getUTCFullYear();
}, (date)=>{
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$9ad421df7f9e054b$export$d5c3802e389714c4.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $9939f74c1c819889$export$1a539c8b2950ab40)((date)=>{
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
const $9ad421df7f9e054b$export$3e24d311e17f5802 = $9ad421df7f9e054b$export$d5c3802e389714c4.range;


function $7950f1d39469ffa7$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, $8f97853afe54cc4a$export$3d3c77ce7df7d30d),
            1,
            (0, $df9831fb4f95f7fb$export$79ef0e34099623dc)
        ],
        [
            (0, $8f97853afe54cc4a$export$3d3c77ce7df7d30d),
            5,
            5 * (0, $df9831fb4f95f7fb$export$79ef0e34099623dc)
        ],
        [
            (0, $8f97853afe54cc4a$export$3d3c77ce7df7d30d),
            15,
            15 * (0, $df9831fb4f95f7fb$export$79ef0e34099623dc)
        ],
        [
            (0, $8f97853afe54cc4a$export$3d3c77ce7df7d30d),
            30,
            30 * (0, $df9831fb4f95f7fb$export$79ef0e34099623dc)
        ],
        [
            minute,
            1,
            (0, $df9831fb4f95f7fb$export$683905d551c33fa9)
        ],
        [
            minute,
            5,
            5 * (0, $df9831fb4f95f7fb$export$683905d551c33fa9)
        ],
        [
            minute,
            15,
            15 * (0, $df9831fb4f95f7fb$export$683905d551c33fa9)
        ],
        [
            minute,
            30,
            30 * (0, $df9831fb4f95f7fb$export$683905d551c33fa9)
        ],
        [
            hour,
            1,
            (0, $df9831fb4f95f7fb$export$4157bf0c8e241659)
        ],
        [
            hour,
            3,
            3 * (0, $df9831fb4f95f7fb$export$4157bf0c8e241659)
        ],
        [
            hour,
            6,
            6 * (0, $df9831fb4f95f7fb$export$4157bf0c8e241659)
        ],
        [
            hour,
            12,
            12 * (0, $df9831fb4f95f7fb$export$4157bf0c8e241659)
        ],
        [
            day,
            1,
            (0, $df9831fb4f95f7fb$export$353686095f4fbf45)
        ],
        [
            day,
            2,
            2 * (0, $df9831fb4f95f7fb$export$353686095f4fbf45)
        ],
        [
            week,
            1,
            (0, $df9831fb4f95f7fb$export$c241eb88520d5016)
        ],
        [
            month,
            1,
            (0, $df9831fb4f95f7fb$export$ab95684df7020b26)
        ],
        [
            month,
            3,
            3 * (0, $df9831fb4f95f7fb$export$ab95684df7020b26)
        ],
        [
            year,
            1,
            (0, $df9831fb4f95f7fb$export$61f8ee2d834c6959)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $ab71cf57ae8c76e8$export$2e2bcd8739ae039)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $e70716585309e68a$export$81087d9b915d4ede)(start / (0, $df9831fb4f95f7fb$export$61f8ee2d834c6959), stop / (0, $df9831fb4f95f7fb$export$61f8ee2d834c6959), count));
        if (i === 0) return (0, $3a0c7fd69e52994c$export$edc5e5cb87280477).every(Math.max((0, $e70716585309e68a$export$81087d9b915d4ede)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$7950f1d39469ffa7$export$826ba5ae907e9767, $7950f1d39469ffa7$export$6262d8d056ea44c4] = $7950f1d39469ffa7$var$ticker((0, $9ad421df7f9e054b$export$d5c3802e389714c4), (0, $0510ad95fe0d8745$export$cd49b3d2bcfe50d5), (0, $0c15e9d65f86b7e7$export$4898b06303a92011), (0, $20c9bda5cc5feed8$export$fb065be2d7ea4a71), (0, $54c52d7793bb6b78$export$31f6f2b3c63ac75e), (0, $63c90b161916de7a$export$efe6712d6003761b));
const [$7950f1d39469ffa7$export$60c76498552d28a6, $7950f1d39469ffa7$export$69511150134dd174] = $7950f1d39469ffa7$var$ticker((0, $9ad421df7f9e054b$export$cd17cfe45df0c046), (0, $0510ad95fe0d8745$export$7e1084fb688591c1), (0, $0c15e9d65f86b7e7$export$22ee6205b762968c), (0, $20c9bda5cc5feed8$export$8888529b966033e5), (0, $54c52d7793bb6b78$export$46c68a5833bc315b), (0, $63c90b161916de7a$export$a7e4c34a52f0576));



function $f2cb13c9517eb983$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $f2cb13c9517eb983$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $f2cb13c9517eb983$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $f2cb13c9517eb983$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $f2cb13c9517eb983$var$formatRe(locale_periods), periodLookup = $f2cb13c9517eb983$var$formatLookup(locale_periods), weekdayRe = $f2cb13c9517eb983$var$formatRe(locale_weekdays), weekdayLookup = $f2cb13c9517eb983$var$formatLookup(locale_weekdays), shortWeekdayRe = $f2cb13c9517eb983$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $f2cb13c9517eb983$var$formatLookup(locale_shortWeekdays), monthRe = $f2cb13c9517eb983$var$formatRe(locale_months), monthLookup = $f2cb13c9517eb983$var$formatLookup(locale_months), shortMonthRe = $f2cb13c9517eb983$var$formatRe(locale_shortMonths), shortMonthLookup = $f2cb13c9517eb983$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $f2cb13c9517eb983$var$formatDayOfMonth,
        "e": $f2cb13c9517eb983$var$formatDayOfMonth,
        "f": $f2cb13c9517eb983$var$formatMicroseconds,
        "g": $f2cb13c9517eb983$var$formatYearISO,
        "G": $f2cb13c9517eb983$var$formatFullYearISO,
        "H": $f2cb13c9517eb983$var$formatHour24,
        "I": $f2cb13c9517eb983$var$formatHour12,
        "j": $f2cb13c9517eb983$var$formatDayOfYear,
        "L": $f2cb13c9517eb983$var$formatMilliseconds,
        "m": $f2cb13c9517eb983$var$formatMonthNumber,
        "M": $f2cb13c9517eb983$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $f2cb13c9517eb983$var$formatUnixTimestamp,
        "s": $f2cb13c9517eb983$var$formatUnixTimestampSeconds,
        "S": $f2cb13c9517eb983$var$formatSeconds,
        "u": $f2cb13c9517eb983$var$formatWeekdayNumberMonday,
        "U": $f2cb13c9517eb983$var$formatWeekNumberSunday,
        "V": $f2cb13c9517eb983$var$formatWeekNumberISO,
        "w": $f2cb13c9517eb983$var$formatWeekdayNumberSunday,
        "W": $f2cb13c9517eb983$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $f2cb13c9517eb983$var$formatYear,
        "Y": $f2cb13c9517eb983$var$formatFullYear,
        "Z": $f2cb13c9517eb983$var$formatZone,
        "%": $f2cb13c9517eb983$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $f2cb13c9517eb983$var$formatUTCDayOfMonth,
        "e": $f2cb13c9517eb983$var$formatUTCDayOfMonth,
        "f": $f2cb13c9517eb983$var$formatUTCMicroseconds,
        "g": $f2cb13c9517eb983$var$formatUTCYearISO,
        "G": $f2cb13c9517eb983$var$formatUTCFullYearISO,
        "H": $f2cb13c9517eb983$var$formatUTCHour24,
        "I": $f2cb13c9517eb983$var$formatUTCHour12,
        "j": $f2cb13c9517eb983$var$formatUTCDayOfYear,
        "L": $f2cb13c9517eb983$var$formatUTCMilliseconds,
        "m": $f2cb13c9517eb983$var$formatUTCMonthNumber,
        "M": $f2cb13c9517eb983$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $f2cb13c9517eb983$var$formatUnixTimestamp,
        "s": $f2cb13c9517eb983$var$formatUnixTimestampSeconds,
        "S": $f2cb13c9517eb983$var$formatUTCSeconds,
        "u": $f2cb13c9517eb983$var$formatUTCWeekdayNumberMonday,
        "U": $f2cb13c9517eb983$var$formatUTCWeekNumberSunday,
        "V": $f2cb13c9517eb983$var$formatUTCWeekNumberISO,
        "w": $f2cb13c9517eb983$var$formatUTCWeekdayNumberSunday,
        "W": $f2cb13c9517eb983$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $f2cb13c9517eb983$var$formatUTCYear,
        "Y": $f2cb13c9517eb983$var$formatUTCFullYear,
        "Z": $f2cb13c9517eb983$var$formatUTCZone,
        "%": $f2cb13c9517eb983$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $f2cb13c9517eb983$var$parseDayOfMonth,
        "e": $f2cb13c9517eb983$var$parseDayOfMonth,
        "f": $f2cb13c9517eb983$var$parseMicroseconds,
        "g": $f2cb13c9517eb983$var$parseYear,
        "G": $f2cb13c9517eb983$var$parseFullYear,
        "H": $f2cb13c9517eb983$var$parseHour24,
        "I": $f2cb13c9517eb983$var$parseHour24,
        "j": $f2cb13c9517eb983$var$parseDayOfYear,
        "L": $f2cb13c9517eb983$var$parseMilliseconds,
        "m": $f2cb13c9517eb983$var$parseMonthNumber,
        "M": $f2cb13c9517eb983$var$parseMinutes,
        "p": parsePeriod,
        "q": $f2cb13c9517eb983$var$parseQuarter,
        "Q": $f2cb13c9517eb983$var$parseUnixTimestamp,
        "s": $f2cb13c9517eb983$var$parseUnixTimestampSeconds,
        "S": $f2cb13c9517eb983$var$parseSeconds,
        "u": $f2cb13c9517eb983$var$parseWeekdayNumberMonday,
        "U": $f2cb13c9517eb983$var$parseWeekNumberSunday,
        "V": $f2cb13c9517eb983$var$parseWeekNumberISO,
        "w": $f2cb13c9517eb983$var$parseWeekdayNumberSunday,
        "W": $f2cb13c9517eb983$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $f2cb13c9517eb983$var$parseYear,
        "Y": $f2cb13c9517eb983$var$parseFullYear,
        "Z": $f2cb13c9517eb983$var$parseZone,
        "%": $f2cb13c9517eb983$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $f2cb13c9517eb983$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $f2cb13c9517eb983$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $f2cb13c9517eb983$var$utcDate($f2cb13c9517eb983$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $0c15e9d65f86b7e7$export$9cfc53b9cfafd080).ceil(week) : (0, $0c15e9d65f86b7e7$export$9cfc53b9cfafd080)(week);
                    week = (0, $20c9bda5cc5feed8$export$c8cbc42cefd47140).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $f2cb13c9517eb983$var$localDate($f2cb13c9517eb983$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $0c15e9d65f86b7e7$export$e79bbe0177cf1b01).ceil(week) : (0, $0c15e9d65f86b7e7$export$e79bbe0177cf1b01)(week);
                    week = (0, $20c9bda5cc5feed8$export$8888529b966033e5).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $f2cb13c9517eb983$var$utcDate($f2cb13c9517eb983$var$newDate(d.y, 0, 1)).getUTCDay() : $f2cb13c9517eb983$var$localDate($f2cb13c9517eb983$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $f2cb13c9517eb983$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $f2cb13c9517eb983$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $f2cb13c9517eb983$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $f2cb13c9517eb983$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $f2cb13c9517eb983$var$numberRe = /^\s*\d+/, $f2cb13c9517eb983$var$percentRe = /^%/, $f2cb13c9517eb983$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $f2cb13c9517eb983$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $f2cb13c9517eb983$var$requote(s) {
    return s.replace($f2cb13c9517eb983$var$requoteRe, "\\$&");
}
function $f2cb13c9517eb983$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($f2cb13c9517eb983$var$requote).join("|") + ")", "i");
}
function $f2cb13c9517eb983$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $f2cb13c9517eb983$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseWeekNumberSunday(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseWeekNumberISO(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseWeekNumberMonday(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseFullYear(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseYear(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseQuarter(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseMonthNumber(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseDayOfMonth(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseDayOfYear(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseHour24(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseMinutes(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseSeconds(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseMilliseconds(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseMicroseconds(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseLiteralPercent(d, string, i) {
    var n = $f2cb13c9517eb983$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $f2cb13c9517eb983$var$parseUnixTimestamp(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $f2cb13c9517eb983$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $f2cb13c9517eb983$var$formatDayOfMonth(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getDate(), p, 2);
}
function $f2cb13c9517eb983$var$formatHour24(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getHours(), p, 2);
}
function $f2cb13c9517eb983$var$formatHour12(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $f2cb13c9517eb983$var$formatDayOfYear(d, p) {
    return $f2cb13c9517eb983$var$pad(1 + (0, $20c9bda5cc5feed8$export$8888529b966033e5).count((0, $9ad421df7f9e054b$export$cd17cfe45df0c046)(d), d), p, 3);
}
function $f2cb13c9517eb983$var$formatMilliseconds(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getMilliseconds(), p, 3);
}
function $f2cb13c9517eb983$var$formatMicroseconds(d, p) {
    return $f2cb13c9517eb983$var$formatMilliseconds(d, p) + "000";
}
function $f2cb13c9517eb983$var$formatMonthNumber(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getMonth() + 1, p, 2);
}
function $f2cb13c9517eb983$var$formatMinutes(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getMinutes(), p, 2);
}
function $f2cb13c9517eb983$var$formatSeconds(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getSeconds(), p, 2);
}
function $f2cb13c9517eb983$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $f2cb13c9517eb983$var$formatWeekNumberSunday(d, p) {
    return $f2cb13c9517eb983$var$pad((0, $0c15e9d65f86b7e7$export$22ee6205b762968c).count((0, $9ad421df7f9e054b$export$cd17cfe45df0c046)(d) - 1, d), p, 2);
}
function $f2cb13c9517eb983$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $0c15e9d65f86b7e7$export$608689422d5cf9f4)(d) : (0, $0c15e9d65f86b7e7$export$608689422d5cf9f4).ceil(d);
}
function $f2cb13c9517eb983$var$formatWeekNumberISO(d, p) {
    d = $f2cb13c9517eb983$var$dISO(d);
    return $f2cb13c9517eb983$var$pad((0, $0c15e9d65f86b7e7$export$608689422d5cf9f4).count((0, $9ad421df7f9e054b$export$cd17cfe45df0c046)(d), d) + ((0, $9ad421df7f9e054b$export$cd17cfe45df0c046)(d).getDay() === 4), p, 2);
}
function $f2cb13c9517eb983$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $f2cb13c9517eb983$var$formatWeekNumberMonday(d, p) {
    return $f2cb13c9517eb983$var$pad((0, $0c15e9d65f86b7e7$export$e79bbe0177cf1b01).count((0, $9ad421df7f9e054b$export$cd17cfe45df0c046)(d) - 1, d), p, 2);
}
function $f2cb13c9517eb983$var$formatYear(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getFullYear() % 100, p, 2);
}
function $f2cb13c9517eb983$var$formatYearISO(d, p) {
    d = $f2cb13c9517eb983$var$dISO(d);
    return $f2cb13c9517eb983$var$pad(d.getFullYear() % 100, p, 2);
}
function $f2cb13c9517eb983$var$formatFullYear(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getFullYear() % 10000, p, 4);
}
function $f2cb13c9517eb983$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $0c15e9d65f86b7e7$export$608689422d5cf9f4)(d) : (0, $0c15e9d65f86b7e7$export$608689422d5cf9f4).ceil(d);
    return $f2cb13c9517eb983$var$pad(d.getFullYear() % 10000, p, 4);
}
function $f2cb13c9517eb983$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $f2cb13c9517eb983$var$pad(z / 60 | 0, "0", 2) + $f2cb13c9517eb983$var$pad(z % 60, "0", 2);
}
function $f2cb13c9517eb983$var$formatUTCDayOfMonth(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getUTCDate(), p, 2);
}
function $f2cb13c9517eb983$var$formatUTCHour24(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getUTCHours(), p, 2);
}
function $f2cb13c9517eb983$var$formatUTCHour12(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $f2cb13c9517eb983$var$formatUTCDayOfYear(d, p) {
    return $f2cb13c9517eb983$var$pad(1 + (0, $20c9bda5cc5feed8$export$c8cbc42cefd47140).count((0, $9ad421df7f9e054b$export$d5c3802e389714c4)(d), d), p, 3);
}
function $f2cb13c9517eb983$var$formatUTCMilliseconds(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $f2cb13c9517eb983$var$formatUTCMicroseconds(d, p) {
    return $f2cb13c9517eb983$var$formatUTCMilliseconds(d, p) + "000";
}
function $f2cb13c9517eb983$var$formatUTCMonthNumber(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $f2cb13c9517eb983$var$formatUTCMinutes(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getUTCMinutes(), p, 2);
}
function $f2cb13c9517eb983$var$formatUTCSeconds(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getUTCSeconds(), p, 2);
}
function $f2cb13c9517eb983$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $f2cb13c9517eb983$var$formatUTCWeekNumberSunday(d, p) {
    return $f2cb13c9517eb983$var$pad((0, $0c15e9d65f86b7e7$export$4898b06303a92011).count((0, $9ad421df7f9e054b$export$d5c3802e389714c4)(d) - 1, d), p, 2);
}
function $f2cb13c9517eb983$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $0c15e9d65f86b7e7$export$1db08111baec2f53)(d) : (0, $0c15e9d65f86b7e7$export$1db08111baec2f53).ceil(d);
}
function $f2cb13c9517eb983$var$formatUTCWeekNumberISO(d, p) {
    d = $f2cb13c9517eb983$var$UTCdISO(d);
    return $f2cb13c9517eb983$var$pad((0, $0c15e9d65f86b7e7$export$1db08111baec2f53).count((0, $9ad421df7f9e054b$export$d5c3802e389714c4)(d), d) + ((0, $9ad421df7f9e054b$export$d5c3802e389714c4)(d).getUTCDay() === 4), p, 2);
}
function $f2cb13c9517eb983$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $f2cb13c9517eb983$var$formatUTCWeekNumberMonday(d, p) {
    return $f2cb13c9517eb983$var$pad((0, $0c15e9d65f86b7e7$export$9cfc53b9cfafd080).count((0, $9ad421df7f9e054b$export$d5c3802e389714c4)(d) - 1, d), p, 2);
}
function $f2cb13c9517eb983$var$formatUTCYear(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $f2cb13c9517eb983$var$formatUTCYearISO(d, p) {
    d = $f2cb13c9517eb983$var$UTCdISO(d);
    return $f2cb13c9517eb983$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $f2cb13c9517eb983$var$formatUTCFullYear(d, p) {
    return $f2cb13c9517eb983$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $f2cb13c9517eb983$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $0c15e9d65f86b7e7$export$1db08111baec2f53)(d) : (0, $0c15e9d65f86b7e7$export$1db08111baec2f53).ceil(d);
    return $f2cb13c9517eb983$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $f2cb13c9517eb983$var$formatUTCZone() {
    return "+0000";
}
function $f2cb13c9517eb983$var$formatLiteralPercent() {
    return "%";
}
function $f2cb13c9517eb983$var$formatUnixTimestamp(d) {
    return +d;
}
function $f2cb13c9517eb983$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $c537a5fd3791a39f$var$locale;
var $c537a5fd3791a39f$export$94f4d87fad5dcf9a;
var $c537a5fd3791a39f$export$32b9cd16e1b8c8d2;
var $c537a5fd3791a39f$export$1a08fe38f63ebbbb;
var $c537a5fd3791a39f$export$3edae9cf8e233729;
$c537a5fd3791a39f$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $c537a5fd3791a39f$export$2e2bcd8739ae039(definition) {
    $c537a5fd3791a39f$var$locale = (0, $f2cb13c9517eb983$export$2e2bcd8739ae039)(definition);
    $c537a5fd3791a39f$export$94f4d87fad5dcf9a = $c537a5fd3791a39f$var$locale.format;
    $c537a5fd3791a39f$export$32b9cd16e1b8c8d2 = $c537a5fd3791a39f$var$locale.parse;
    $c537a5fd3791a39f$export$1a08fe38f63ebbbb = $c537a5fd3791a39f$var$locale.utcFormat;
    $c537a5fd3791a39f$export$3edae9cf8e233729 = $c537a5fd3791a39f$var$locale.utcParse;
    return $c537a5fd3791a39f$var$locale;
}




function $b9db87649c27653e$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $b9db87649c27653e$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}


const $55e3050441957f85$var$ascendingBisect = (0, $ab71cf57ae8c76e8$export$2e2bcd8739ae039)((0, $b9a39bb6f3499963$export$2e2bcd8739ae039));
const $55e3050441957f85$export$4d945ad3ad5751b0 = $55e3050441957f85$var$ascendingBisect.right;
const $55e3050441957f85$export$df7d25c84ebd12a5 = $55e3050441957f85$var$ascendingBisect.left;
const $55e3050441957f85$export$c1cb828b1117c77b = (0, $ab71cf57ae8c76e8$export$2e2bcd8739ae039)((0, $b9db87649c27653e$export$2e2bcd8739ae039)).center;
var $55e3050441957f85$export$2e2bcd8739ae039 = $55e3050441957f85$export$4d945ad3ad5751b0;



var $1tQWc = parcelRequire("1tQWc");

var $1tQWc = parcelRequire("1tQWc");
function $e81fa1172944234a$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $e81fa1172944234a$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $e81fa1172944234a$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $838b1762decf7fe9$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $e81fa1172944234a$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $ea3d5457baf78b6a$export$2e2bcd8739ae039 = (x)=>()=>x;


function $60d0a75f48d588f4$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $60d0a75f48d588f4$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $60d0a75f48d588f4$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $60d0a75f48d588f4$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $ea3d5457baf78b6a$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $60d0a75f48d588f4$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $60d0a75f48d588f4$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $60d0a75f48d588f4$var$exponential(a, b, y) : (0, $ea3d5457baf78b6a$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $60d0a75f48d588f4$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $60d0a75f48d588f4$var$linear(a, d) : (0, $ea3d5457baf78b6a$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $fa6c794a4958fdf6$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $60d0a75f48d588f4$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $1tQWc.rgb)(start)).r, (end = (0, $1tQWc.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $60d0a75f48d588f4$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $fa6c794a4958fdf6$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $1tQWc.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $fa6c794a4958fdf6$export$2c0e28f2e2852d3f = $fa6c794a4958fdf6$var$rgbSpline((0, $e81fa1172944234a$export$2e2bcd8739ae039));
var $fa6c794a4958fdf6$export$53d5214f625ccd4c = $fa6c794a4958fdf6$var$rgbSpline((0, $838b1762decf7fe9$export$2e2bcd8739ae039));



function $f47ee41c426b8632$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $f47ee41c426b8632$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $c384a95c8d1ce37f$export$2e2bcd8739ae039(a, b) {
    return ((0, $f47ee41c426b8632$export$5cd576d1827d40c8)(b) ? (0, $f47ee41c426b8632$export$2e2bcd8739ae039) : $c384a95c8d1ce37f$export$15d09067c6a5ee49)(a, b);
}
function $c384a95c8d1ce37f$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $aeb7fc2c29323e59$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $e579c8d711a959eb$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $d9f27e55086f64c0$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $72d783271dbdb2d5$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $aeb7fc2c29323e59$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $1ef9a1579573abd1$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $1ef9a1579573abd1$var$reB = new RegExp($1ef9a1579573abd1$var$reA.source, "g");
function $1ef9a1579573abd1$var$zero(b) {
    return function() {
        return b;
    };
}
function $1ef9a1579573abd1$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $1ef9a1579573abd1$export$2e2bcd8739ae039(a, b) {
    var bi = $1ef9a1579573abd1$var$reA.lastIndex = $1ef9a1579573abd1$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $1ef9a1579573abd1$var$reA.exec(a)) && (bm = $1ef9a1579573abd1$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $d9f27e55086f64c0$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $1ef9a1579573abd1$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $1ef9a1579573abd1$var$one(q[0].x) : $1ef9a1579573abd1$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $aeb7fc2c29323e59$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $ea3d5457baf78b6a$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $d9f27e55086f64c0$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $1tQWc.default)(b)) ? (b = c, $fa6c794a4958fdf6$export$2e2bcd8739ae039) : (0, $1ef9a1579573abd1$export$2e2bcd8739ae039) : b instanceof (0, $1tQWc.default) ? (0, $fa6c794a4958fdf6$export$2e2bcd8739ae039) : b instanceof Date ? (0, $e579c8d711a959eb$export$2e2bcd8739ae039) : (0, $f47ee41c426b8632$export$5cd576d1827d40c8)(b) ? (0, $f47ee41c426b8632$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $c384a95c8d1ce37f$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $72d783271dbdb2d5$export$2e2bcd8739ae039) : (0, $d9f27e55086f64c0$export$2e2bcd8739ae039))(a, b);
}

function $b11128915dee5d67$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}


function $43b1c28d54e5a201$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $bc4281a4abd21e9a$export$2e2bcd8739ae039(x) {
    return +x;
}


var $cd4d28050bb392d2$var$unit = [
    0,
    1
];
function $cd4d28050bb392d2$export$f0954fd7d5368655(x) {
    return x;
}
function $cd4d28050bb392d2$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $43b1c28d54e5a201$export$2e2bcd8739ae039)(isNaN(b) ? NaN : 0.5);
}
function $cd4d28050bb392d2$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $cd4d28050bb392d2$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $cd4d28050bb392d2$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $cd4d28050bb392d2$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $cd4d28050bb392d2$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $cd4d28050bb392d2$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $55e3050441957f85$export$2e2bcd8739ae039)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $cd4d28050bb392d2$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $cd4d28050bb392d2$export$6b468dcfb64c653c() {
    var domain = $cd4d28050bb392d2$var$unit, range = $cd4d28050bb392d2$var$unit, interpolate = (0, $aeb7fc2c29323e59$export$2e2bcd8739ae039), transform, untransform, unknown, clamp = $cd4d28050bb392d2$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $cd4d28050bb392d2$export$f0954fd7d5368655) clamp = $cd4d28050bb392d2$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $cd4d28050bb392d2$var$polymap : $cd4d28050bb392d2$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $d9f27e55086f64c0$export$2e2bcd8739ae039))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $bc4281a4abd21e9a$export$2e2bcd8739ae039)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $b11128915dee5d67$export$2e2bcd8739ae039), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $cd4d28050bb392d2$export$f0954fd7d5368655, rescale()) : clamp !== $cd4d28050bb392d2$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $cd4d28050bb392d2$export$2e2bcd8739ae039() {
    return $cd4d28050bb392d2$export$6b468dcfb64c653c()($cd4d28050bb392d2$export$f0954fd7d5368655, $cd4d28050bb392d2$export$f0954fd7d5368655);
}



function $a195ded6081247dd$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}


function $e031e928df7f8c43$var$date(t) {
    return new Date(t);
}
function $e031e928df7f8c43$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $e031e928df7f8c43$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $cd4d28050bb392d2$export$2e2bcd8739ae039)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $e031e928df7f8c43$var$number)) : domain().map($e031e928df7f8c43$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $a195ded6081247dd$export$2e2bcd8739ae039)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $cd4d28050bb392d2$export$784d13d8ee351f07)(scale, $e031e928df7f8c43$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $e031e928df7f8c43$export$2e2bcd8739ae039() {
    return (0, $1ec9baa7d5ff9a04$export$23c7bb9e6558da2a).apply($e031e928df7f8c43$export$56bbcdb8aca31149((0, $7950f1d39469ffa7$export$60c76498552d28a6), (0, $7950f1d39469ffa7$export$69511150134dd174), (0, $9ad421df7f9e054b$export$cd17cfe45df0c046), (0, $0510ad95fe0d8745$export$7e1084fb688591c1), (0, $0c15e9d65f86b7e7$export$22ee6205b762968c), (0, $20c9bda5cc5feed8$export$8888529b966033e5), (0, $54c52d7793bb6b78$export$46c68a5833bc315b), (0, $63c90b161916de7a$export$a7e4c34a52f0576), (0, $8f97853afe54cc4a$export$3d3c77ce7df7d30d), (0, $c537a5fd3791a39f$export$94f4d87fad5dcf9a)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}










function $ff17805088e05908$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $ff17805088e05908$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}


function $bd533b60d24b385f$export$2e2bcd8739ae039(x) {
    return x = (0, $ff17805088e05908$export$8f8e23dd27dc19f5)(Math.abs(x)), x ? x[1] : NaN;
}


function $82dcf17ce1685e34$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}


function $daafadc4feed89e8$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}


// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $1cc1184461dd471b$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $1cc1184461dd471b$export$2e2bcd8739ae039(specifier) {
    if (!(match = $1cc1184461dd471b$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $1cc1184461dd471b$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$1cc1184461dd471b$export$2e2bcd8739ae039.prototype = $1cc1184461dd471b$export$963aac351db36ed4.prototype; // instanceof
function $1cc1184461dd471b$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$1cc1184461dd471b$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};


// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $5fb0b368199b6db0$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}




var $4c6d222e27627e6f$export$6863724d9a42263;
function $4c6d222e27627e6f$export$2e2bcd8739ae039(x, p) {
    var d = (0, $ff17805088e05908$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($4c6d222e27627e6f$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $ff17805088e05908$export$8f8e23dd27dc19f5)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}



function $3d26a2d469b438ff$export$2e2bcd8739ae039(x, p) {
    var d = (0, $ff17805088e05908$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}


var $29b9d3e665d17e28$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $ff17805088e05908$export$2e2bcd8739ae039),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $3d26a2d469b438ff$export$2e2bcd8739ae039)(x * 100, p),
    "r": (0, $3d26a2d469b438ff$export$2e2bcd8739ae039),
    "s": (0, $4c6d222e27627e6f$export$2e2bcd8739ae039),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};



function $fb31816b92782fa8$export$2e2bcd8739ae039(x) {
    return x;
}


var $cd1467c2bfb64221$var$map = Array.prototype.map, $cd1467c2bfb64221$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $cd1467c2bfb64221$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $fb31816b92782fa8$export$2e2bcd8739ae039) : (0, $82dcf17ce1685e34$export$2e2bcd8739ae039)($cd1467c2bfb64221$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $fb31816b92782fa8$export$2e2bcd8739ae039) : (0, $daafadc4feed89e8$export$2e2bcd8739ae039)($cd1467c2bfb64221$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $1cc1184461dd471b$export$2e2bcd8739ae039)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $29b9d3e665d17e28$export$2e2bcd8739ae039)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $29b9d3e665d17e28$export$2e2bcd8739ae039)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $5fb0b368199b6db0$export$2e2bcd8739ae039)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $cd1467c2bfb64221$var$prefixes[8 + (0, $4c6d222e27627e6f$export$6863724d9a42263) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $1cc1184461dd471b$export$2e2bcd8739ae039)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $bd533b60d24b385f$export$2e2bcd8739ae039)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $cd1467c2bfb64221$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}


var $f6601bd7ba54f431$var$locale;
var $f6601bd7ba54f431$export$d9468344d3651243;
var $f6601bd7ba54f431$export$8d85692a469dde6f;
$f6601bd7ba54f431$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $f6601bd7ba54f431$export$2e2bcd8739ae039(definition) {
    $f6601bd7ba54f431$var$locale = (0, $cd1467c2bfb64221$export$2e2bcd8739ae039)(definition);
    $f6601bd7ba54f431$export$d9468344d3651243 = $f6601bd7ba54f431$var$locale.format;
    $f6601bd7ba54f431$export$8d85692a469dde6f = $f6601bd7ba54f431$var$locale.formatPrefix;
    return $f6601bd7ba54f431$var$locale;
}


function $8baa6cfb27653488$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $bd533b60d24b385f$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $1c4c7f60569acb2c$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $bd533b60d24b385f$export$2e2bcd8739ae039)(value) / 3))) * 3 - (0, $bd533b60d24b385f$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $6016a442155d6b65$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $bd533b60d24b385f$export$2e2bcd8739ae039)(max) - (0, $bd533b60d24b385f$export$2e2bcd8739ae039)(step)) + 1;
}


function $690650bc4737c146$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $e70716585309e68a$export$81087d9b915d4ede)(start, stop, count), precision;
    specifier = (0, $1cc1184461dd471b$export$2e2bcd8739ae039)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $1c4c7f60569acb2c$export$2e2bcd8739ae039)(step, value))) specifier.precision = precision;
            return (0, $f6601bd7ba54f431$export$8d85692a469dde6f)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $6016a442155d6b65$export$2e2bcd8739ae039)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $8baa6cfb27653488$export$2e2bcd8739ae039)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $f6601bd7ba54f431$export$d9468344d3651243)(specifier);
}


function $200a922019157658$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $e70716585309e68a$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $690650bc4737c146$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $e70716585309e68a$export$bc64d00cc98e7e95)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $200a922019157658$export$2e2bcd8739ae039() {
    var scale = (0, $cd4d28050bb392d2$export$2e2bcd8739ae039)();
    scale.copy = function() {
        return (0, $cd4d28050bb392d2$export$784d13d8ee351f07)(scale, $200a922019157658$export$2e2bcd8739ae039());
    };
    (0, $1ec9baa7d5ff9a04$export$23c7bb9e6558da2a).apply(scale, arguments);
    return $200a922019157658$export$16a5d4b4a61a274d(scale);
}







function $1d0e690dbd31296e$var$transformLog(x) {
    return Math.log(x);
}
function $1d0e690dbd31296e$var$transformExp(x) {
    return Math.exp(x);
}
function $1d0e690dbd31296e$var$transformLogn(x) {
    return -Math.log(-x);
}
function $1d0e690dbd31296e$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $1d0e690dbd31296e$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $1d0e690dbd31296e$var$powp(base) {
    return base === 10 ? $1d0e690dbd31296e$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $1d0e690dbd31296e$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $1d0e690dbd31296e$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $1d0e690dbd31296e$export$860836db074028f0(transform) {
    const scale = transform($1d0e690dbd31296e$var$transformLog, $1d0e690dbd31296e$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $1d0e690dbd31296e$var$logp(base), pows = $1d0e690dbd31296e$var$powp(base);
        if (domain()[0] < 0) {
            logs = $1d0e690dbd31296e$var$reflect(logs), pows = $1d0e690dbd31296e$var$reflect(pows);
            transform($1d0e690dbd31296e$var$transformLogn, $1d0e690dbd31296e$var$transformExpn);
        } else transform($1d0e690dbd31296e$var$transformLog, $1d0e690dbd31296e$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $e70716585309e68a$export$2e2bcd8739ae039)(u, v, n);
        } else z = (0, $e70716585309e68a$export$2e2bcd8739ae039)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $1cc1184461dd471b$export$2e2bcd8739ae039)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $f6601bd7ba54f431$export$d9468344d3651243)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $a195ded6081247dd$export$2e2bcd8739ae039)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $1d0e690dbd31296e$export$2e2bcd8739ae039() {
    const scale = $1d0e690dbd31296e$export$860836db074028f0((0, $cd4d28050bb392d2$export$6b468dcfb64c653c)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $cd4d28050bb392d2$export$784d13d8ee351f07)(scale, $1d0e690dbd31296e$export$2e2bcd8739ae039()).base(scale.base());
    (0, $1ec9baa7d5ff9a04$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}





function $52ee0a5773c968a2$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $52ee0a5773c968a2$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $52ee0a5773c968a2$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($52ee0a5773c968a2$var$transformSymlog(c), $52ee0a5773c968a2$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($52ee0a5773c968a2$var$transformSymlog(c = +_), $52ee0a5773c968a2$var$transformSymexp(c)) : c;
    };
    return (0, $200a922019157658$export$16a5d4b4a61a274d)(scale);
}
function $52ee0a5773c968a2$export$2e2bcd8739ae039() {
    var scale = $52ee0a5773c968a2$export$4602684e614eba38((0, $cd4d28050bb392d2$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $cd4d28050bb392d2$export$784d13d8ee351f07)(scale, $52ee0a5773c968a2$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $1ec9baa7d5ff9a04$export$23c7bb9e6558da2a).apply(scale, arguments);
}





function $d5fcc9a22585ff93$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $d5fcc9a22585ff93$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $d5fcc9a22585ff93$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $d5fcc9a22585ff93$export$34695211ec403a46(transform) {
    var scale = transform((0, $cd4d28050bb392d2$export$f0954fd7d5368655), (0, $cd4d28050bb392d2$export$f0954fd7d5368655)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $cd4d28050bb392d2$export$f0954fd7d5368655), (0, $cd4d28050bb392d2$export$f0954fd7d5368655)) : exponent === 0.5 ? transform($d5fcc9a22585ff93$var$transformSqrt, $d5fcc9a22585ff93$var$transformSquare) : transform($d5fcc9a22585ff93$var$transformPow(exponent), $d5fcc9a22585ff93$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $200a922019157658$export$16a5d4b4a61a274d)(scale);
}
function $d5fcc9a22585ff93$export$2e2bcd8739ae039() {
    var scale = $d5fcc9a22585ff93$export$34695211ec403a46((0, $cd4d28050bb392d2$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $cd4d28050bb392d2$export$784d13d8ee351f07)(scale, $d5fcc9a22585ff93$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $1ec9baa7d5ff9a04$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}
function $d5fcc9a22585ff93$export$eba8049fb5020b81() {
    return $d5fcc9a22585ff93$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}


function $1fbd210729a53e59$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, $cd4d28050bb392d2$export$f0954fd7d5368655), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $aeb7fc2c29323e59$export$2e2bcd8739ae039));
    scale.rangeRound = range((0, $b11128915dee5d67$export$2e2bcd8739ae039));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $1fbd210729a53e59$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $1fbd210729a53e59$export$2e2bcd8739ae039() {
    var scale = (0, $200a922019157658$export$16a5d4b4a61a274d)($1fbd210729a53e59$var$transformer()((0, $cd4d28050bb392d2$export$f0954fd7d5368655)));
    scale.copy = function() {
        return $1fbd210729a53e59$export$784d13d8ee351f07(scale, $1fbd210729a53e59$export$2e2bcd8739ae039());
    };
    return (0, $1ec9baa7d5ff9a04$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $1fbd210729a53e59$export$6843e08bf2ff981f() {
    var scale = (0, $1d0e690dbd31296e$export$860836db074028f0)($1fbd210729a53e59$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $1fbd210729a53e59$export$784d13d8ee351f07(scale, $1fbd210729a53e59$export$6843e08bf2ff981f()).base(scale.base());
    };
    return (0, $1ec9baa7d5ff9a04$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $1fbd210729a53e59$export$9d4af4de62c81941() {
    var scale = (0, $52ee0a5773c968a2$export$4602684e614eba38)($1fbd210729a53e59$var$transformer());
    scale.copy = function() {
        return $1fbd210729a53e59$export$784d13d8ee351f07(scale, $1fbd210729a53e59$export$9d4af4de62c81941()).constant(scale.constant());
    };
    return (0, $1ec9baa7d5ff9a04$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $1fbd210729a53e59$export$de9f78581b4f2405() {
    var scale = (0, $d5fcc9a22585ff93$export$34695211ec403a46)($1fbd210729a53e59$var$transformer());
    scale.copy = function() {
        return $1fbd210729a53e59$export$784d13d8ee351f07(scale, $1fbd210729a53e59$export$de9f78581b4f2405()).exponent(scale.exponent());
    };
    return (0, $1ec9baa7d5ff9a04$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $1fbd210729a53e59$export$413d935127ed466e() {
    return $1fbd210729a53e59$export$de9f78581b4f2405.apply(null, arguments).exponent(0.5);
}



function $931ac71004624cfe$export$2e2bcd8739ae039() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $55e3050441957f85$export$2e2bcd8739ae039)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $931ac71004624cfe$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $1ec9baa7d5ff9a04$export$23c7bb9e6558da2a).apply(scale, arguments);
}


function $8bcb3f3dc2767cc6$export$3c410d9d0181bae0(config) {
    if (config.type === "piecewise") return (0, $931ac71004624cfe$export$2e2bcd8739ae039)(config.thresholds, config.colors);
    return (0, $1fbd210729a53e59$export$2e2bcd8739ae039)([
        config.min ?? 0,
        config.max ?? 100
    ], config.color);
}
function $8bcb3f3dc2767cc6$export$c3ea10dbbf6bbab3(config) {
    if (config.values) return (0, $b5f1e5e45355bfef$export$2e2bcd8739ae039)(config.values, config.colors).unknown(config.unknownColor ?? null);
    return (0, $b5f1e5e45355bfef$export$2e2bcd8739ae039)(config.colors.map((_, index)=>index), config.colors).unknown(config.unknownColor ?? null);
}
function $8bcb3f3dc2767cc6$export$75f9af112506f7de(config) {
    return config.type === "ordinal" ? $8bcb3f3dc2767cc6$export$c3ea10dbbf6bbab3(config) : $8bcb3f3dc2767cc6$export$3c410d9d0181bae0(config);
}



var $exYeM = parcelRequire("exYeM");

function $06d6ba1dd373d3d8$export$5cba5dd579f10074(params) {
    const { tickMaxStep: tickMaxStep, tickMinStep: tickMinStep, tickNumber: tickNumber, range: range, domain: domain } = params;
    const maxTicks = tickMinStep === undefined ? 999 : Math.floor(Math.abs(domain[1] - domain[0]) / tickMinStep);
    const minTicks = tickMaxStep === undefined ? 2 : Math.ceil(Math.abs(domain[1] - domain[0]) / tickMaxStep);
    const defaultizedTickNumber = tickNumber ?? Math.floor(Math.abs(range[1] - range[0]) / 50);
    return Math.min(maxTicks, Math.max(minTicks, defaultizedTickNumber));
}
const $06d6ba1dd373d3d8$var$offsetRatio = {
    start: 0,
    extremities: 0,
    end: 1,
    middle: 0.5
};
function $06d6ba1dd373d3d8$export$99da48a3c6ab2fa1(options) {
    const { scale: scale, tickNumber: tickNumber, valueFormatter: valueFormatter, tickInterval: tickInterval, tickPlacement: tickPlacement = "extremities", tickLabelPlacement: tickLabelPlacement = "middle" } = options;
    return $exYeM.useMemo(()=>{
        // band scale
        if ((0, $83a42db726948b22$export$ee3f06150b977754)(scale)) {
            const domain = scale.domain();
            if (scale.bandwidth() > 0) {
                // scale type = 'band'
                const filteredDomain = typeof tickInterval === "function" && domain.filter(tickInterval) || typeof tickInterval === "object" && tickInterval || domain;
                return [
                    ...filteredDomain.map((value)=>({
                            value: value,
                            formattedValue: valueFormatter?.(value, {
                                location: "tick"
                            }) ?? `${value}`,
                            offset: scale(value) - (scale.step() - scale.bandwidth()) / 2 + $06d6ba1dd373d3d8$var$offsetRatio[tickPlacement] * scale.step(),
                            labelOffset: tickLabelPlacement === "tick" ? 0 : scale.step() * ($06d6ba1dd373d3d8$var$offsetRatio[tickLabelPlacement] - $06d6ba1dd373d3d8$var$offsetRatio[tickPlacement])
                        })),
                    ...tickPlacement === "extremities" ? [
                        {
                            formattedValue: undefined,
                            offset: scale.range()[1],
                            labelOffset: 0
                        }
                    ] : []
                ];
            }
            // scale type = 'point'
            const filteredDomain = typeof tickInterval === "function" && domain.filter(tickInterval) || typeof tickInterval === "object" && tickInterval || domain;
            return filteredDomain.map((value)=>({
                    value: value,
                    formattedValue: valueFormatter?.(value, {
                        location: "tick"
                    }) ?? `${value}`,
                    offset: scale(value),
                    labelOffset: 0
                }));
        }
        if (scale.domain().length === 0 || scale.domain()[0] === scale.domain()[1]) // The axis should not be visible, so ticks should also be hidden.
        return [];
        const ticks = typeof tickInterval === "object" ? tickInterval : scale.ticks(tickNumber);
        return ticks.map((value)=>({
                value: value,
                formattedValue: valueFormatter?.(value, {
                    location: "tick"
                }) ?? scale.tickFormat(tickNumber)(value),
                offset: scale(value),
                labelOffset: 0
            }));
    }, [
        scale,
        tickInterval,
        tickNumber,
        valueFormatter,
        tickPlacement,
        tickLabelPlacement
    ]);
}






function $5130b88d88e34ca7$export$2e2bcd8739ae039() {
    return (0, $1ec9baa7d5ff9a04$export$23c7bb9e6558da2a).apply((0, $e031e928df7f8c43$export$56bbcdb8aca31149)((0, $7950f1d39469ffa7$export$826ba5ae907e9767), (0, $7950f1d39469ffa7$export$6262d8d056ea44c4), (0, $9ad421df7f9e054b$export$d5c3802e389714c4), (0, $0510ad95fe0d8745$export$cd49b3d2bcfe50d5), (0, $0c15e9d65f86b7e7$export$4898b06303a92011), (0, $20c9bda5cc5feed8$export$c8cbc42cefd47140), (0, $54c52d7793bb6b78$export$31f6f2b3c63ac75e), (0, $63c90b161916de7a$export$efe6712d6003761b), (0, $8f97853afe54cc4a$export$3d3c77ce7df7d30d), (0, $c537a5fd3791a39f$export$1a08fe38f63ebbbb)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}


function $6088e4eb29dc39ab$export$5cdac61cf538712e(scaleType, domain, range) {
    switch(scaleType){
        case "log":
            return (0, $1d0e690dbd31296e$export$2e2bcd8739ae039)(domain, range);
        case "pow":
            return (0, $d5fcc9a22585ff93$export$2e2bcd8739ae039)(domain, range);
        case "sqrt":
            return (0, $d5fcc9a22585ff93$export$eba8049fb5020b81)(domain, range);
        case "time":
            return (0, $e031e928df7f8c43$export$2e2bcd8739ae039)(domain, range);
        case "utc":
            return (0, $5130b88d88e34ca7$export$2e2bcd8739ae039)(domain, range);
        default:
            return (0, $200a922019157658$export$2e2bcd8739ae039)(domain, range);
    }
}


const $5f5f064e87dd67bd$var$axisExtremumCallback = (acc, chartType, axis, getters, isDefaultAxis, formattedSeries)=>{
    const getter = getters[chartType];
    const series = formattedSeries[chartType]?.series ?? {};
    const [minChartTypeData, maxChartTypeData] = getter?.({
        series: series,
        axis: axis,
        isDefaultAxis: isDefaultAxis
    }) ?? [
        null,
        null
    ];
    const [minData, maxData] = acc;
    if (minData === null || maxData === null) return [
        minChartTypeData,
        maxChartTypeData
    ];
    if (minChartTypeData === null || maxChartTypeData === null) return [
        minData,
        maxData
    ];
    return [
        Math.min(minChartTypeData, minData),
        Math.max(maxChartTypeData, maxData)
    ];
};
const $5f5f064e87dd67bd$export$d38f1673835300df = (axis, getters, isDefaultAxis, formattedSeries)=>{
    const charTypes = Object.keys(getters);
    return charTypes.reduce((acc, charType)=>$5f5f064e87dd67bd$var$axisExtremumCallback(acc, charType, axis, getters, isDefaultAxis, formattedSeries), [
        null,
        null
    ]);
};



var $aJx1R = parcelRequire("aJx1R");
const $49228dc79533dc34$export$2925cba56f2206ca = (axis, dataset, axisName)=>{
    return axis?.map((axisConfig)=>{
        const dataKey = axisConfig.dataKey;
        if (dataKey === undefined || axisConfig.data !== undefined) return axisConfig;
        if (dataset === undefined) throw Error(`MUI X Charts: ${axisName}-axis uses \`dataKey\` but no \`dataset\` is provided.`);
        return (0, $aJx1R.default)({}, axisConfig, {
            data: dataset.map((d)=>d[dataKey])
        });
    }) ?? [];
};


const $7f527f768f56f694$var$getRange = (drawingArea, axisDirection, isReverse)=>{
    const range = axisDirection === "x" ? [
        drawingArea.left,
        drawingArea.left + drawingArea.width
    ] : [
        drawingArea.top + drawingArea.height,
        drawingArea.top
    ];
    return isReverse ? range.reverse() : range;
};
const $7f527f768f56f694$var$zoomedScaleRange = (scaleRange, zoomRange)=>{
    const rangeGap = scaleRange[1] - scaleRange[0];
    const zoomGap = zoomRange[1] - zoomRange[0];
    // If current zoom show the scale between p1 and p2 percents
    // The range should be extended by adding [0, p1] and [p2, 100] segments
    const min = scaleRange[0] - zoomRange[0] * rangeGap / zoomGap;
    const max = scaleRange[1] + (100 - zoomRange[1]) * rangeGap / zoomGap;
    return [
        min,
        max
    ];
};
const $7f527f768f56f694$var$isDateData = (data)=>data?.[0] instanceof Date;
function $7f527f768f56f694$var$createDateFormatter(axis, range) {
    const timeScale = (0, $e031e928df7f8c43$export$2e2bcd8739ae039)(axis.data, range);
    return (v, { location: location })=>location === "tick" ? timeScale.tickFormat(axis.tickNumber)(v) : `${v.toLocaleString()}`;
}
const $7f527f768f56f694$var$DEFAULT_CATEGORY_GAP_RATIO = 0.2;
const $7f527f768f56f694$var$DEFAULT_BAR_GAP_RATIO = 0.1;
function $7f527f768f56f694$export$7685d094ee72ae6b({ drawingArea: drawingArea, formattedSeries: formattedSeries, axis: inAxis, extremumGetters: extremumGetters, dataset: dataset, axisDirection: axisDirection, zoomData: zoomData }) {
    const allAxis = (0, $49228dc79533dc34$export$2925cba56f2206ca)(inAxis, dataset, axisDirection);
    const completeAxis = {};
    allAxis.forEach((axis, axisIndex)=>{
        const isDefaultAxis = axisIndex === 0;
        const [minData, maxData] = (0, $5f5f064e87dd67bd$export$d38f1673835300df)(axis, extremumGetters, isDefaultAxis, formattedSeries);
        const zoom = zoomData?.find(({ axisId: axisId })=>axisId === axis.id);
        const zoomRange = zoom ? [
            zoom.start,
            zoom.end
        ] : [
            0,
            100
        ];
        const range = $7f527f768f56f694$var$getRange(drawingArea, axisDirection, axis.reverse);
        if ((0, $8f2aed6b99517e2d$export$5edb9af10389fa8f)(axis)) {
            const categoryGapRatio = axis.categoryGapRatio ?? $7f527f768f56f694$var$DEFAULT_CATEGORY_GAP_RATIO;
            const barGapRatio = axis.barGapRatio ?? $7f527f768f56f694$var$DEFAULT_BAR_GAP_RATIO;
            // Reverse range because ordinal scales are presented from top to bottom on y-axis
            const scaleRange = axisDirection === "x" ? range : [
                range[1],
                range[0]
            ];
            const zoomedRange = $7f527f768f56f694$var$zoomedScaleRange(scaleRange, zoomRange);
            completeAxis[axis.id] = (0, $aJx1R.default)({
                categoryGapRatio: categoryGapRatio,
                barGapRatio: barGapRatio
            }, axis, {
                scale: (0, $66ab919e2a60291e$export$2e2bcd8739ae039)(axis.data, zoomedRange).paddingInner(categoryGapRatio).paddingOuter(categoryGapRatio / 2),
                tickNumber: axis.data.length,
                colorScale: axis.colorMap && (axis.colorMap.type === "ordinal" ? (0, $8bcb3f3dc2767cc6$export$c3ea10dbbf6bbab3)((0, $aJx1R.default)({
                    values: axis.data
                }, axis.colorMap)) : (0, $8bcb3f3dc2767cc6$export$75f9af112506f7de)(axis.colorMap))
            });
            if ($7f527f768f56f694$var$isDateData(axis.data)) {
                const dateFormatter = $7f527f768f56f694$var$createDateFormatter(axis, scaleRange);
                completeAxis[axis.id].valueFormatter = axis.valueFormatter ?? dateFormatter;
            }
        }
        if ((0, $8f2aed6b99517e2d$export$6f8eeb227d19c9f7)(axis)) {
            const scaleRange = axisDirection === "x" ? range : [
                ...range
            ].reverse();
            const zoomedRange = $7f527f768f56f694$var$zoomedScaleRange(scaleRange, zoomRange);
            completeAxis[axis.id] = (0, $aJx1R.default)({}, axis, {
                scale: (0, $66ab919e2a60291e$export$105684a3041cb6f3)(axis.data, zoomedRange),
                tickNumber: axis.data.length,
                colorScale: axis.colorMap && (axis.colorMap.type === "ordinal" ? (0, $8bcb3f3dc2767cc6$export$c3ea10dbbf6bbab3)((0, $aJx1R.default)({
                    values: axis.data
                }, axis.colorMap)) : (0, $8bcb3f3dc2767cc6$export$75f9af112506f7de)(axis.colorMap))
            });
            if ($7f527f768f56f694$var$isDateData(axis.data)) {
                const dateFormatter = $7f527f768f56f694$var$createDateFormatter(axis, scaleRange);
                completeAxis[axis.id].valueFormatter = axis.valueFormatter ?? dateFormatter;
            }
        }
        if (axis.scaleType === "band" || axis.scaleType === "point") // Could be merged with the two previous "if conditions" but then TS does not get that `axis.scaleType` can't be `band` or `point`.
        return;
        const scaleType = axis.scaleType ?? "linear";
        const extremums = [
            axis.min ?? minData,
            axis.max ?? maxData
        ];
        const rawTickNumber = (0, $06d6ba1dd373d3d8$export$5cba5dd579f10074)((0, $aJx1R.default)({}, axis, {
            range: range,
            domain: extremums
        }));
        const tickNumber = rawTickNumber / ((zoomRange[1] - zoomRange[0]) / 100);
        const zoomedRange = $7f527f768f56f694$var$zoomedScaleRange(range, zoomRange);
        // TODO: move nice to prop? Disable when there is zoom?
        const scale = (0, $6088e4eb29dc39ab$export$5cdac61cf538712e)(scaleType, extremums, zoomedRange).nice(rawTickNumber);
        const [minDomain, maxDomain] = scale.domain();
        const domain = [
            axis.min ?? minDomain,
            axis.max ?? maxDomain
        ];
        completeAxis[axis.id] = (0, $aJx1R.default)({}, axis, {
            scaleType: scaleType,
            scale: scale.domain(domain),
            tickNumber: tickNumber,
            colorScale: axis.colorMap && (0, $8bcb3f3dc2767cc6$export$75f9af112506f7de)(axis.colorMap)
        });
    });
    return {
        axis: completeAxis,
        axisIds: allAxis.map(({ id: id })=>id)
    };
}



var $aSiaI = parcelRequire("aSiaI");
function $1b42945ca95acfb3$export$9f8f479612604f8f(props) {
    const { xAxis: xAxis, yAxis: yAxis, dataset: dataset, xExtremumGetters: xExtremumGetters, yExtremumGetters: yExtremumGetters, children: children } = props;
    const formattedSeries = (0, $ba69253362075717$export$23a245cc02c91dfa)();
    const drawingArea = (0, $767eebe86d6e6272$export$389be1739214a0a2)();
    const xValues = $exYeM.useMemo(()=>(0, $7f527f768f56f694$export$7685d094ee72ae6b)({
            drawingArea: drawingArea,
            formattedSeries: formattedSeries,
            axis: xAxis,
            extremumGetters: xExtremumGetters,
            dataset: dataset,
            axisDirection: "x"
        }), [
        drawingArea,
        formattedSeries,
        xAxis,
        xExtremumGetters,
        dataset
    ]);
    const yValues = $exYeM.useMemo(()=>(0, $7f527f768f56f694$export$7685d094ee72ae6b)({
            drawingArea: drawingArea,
            formattedSeries: formattedSeries,
            axis: yAxis,
            extremumGetters: yExtremumGetters,
            dataset: dataset,
            axisDirection: "y"
        }), [
        drawingArea,
        formattedSeries,
        yAxis,
        yExtremumGetters,
        dataset
    ]);
    const value = $exYeM.useMemo(()=>({
            isInitialized: true,
            data: {
                xAxis: xValues.axis,
                yAxis: yValues.axis,
                xAxisIds: xValues.axisIds,
                yAxisIds: yValues.axisIds
            }
        }), [
        xValues,
        yValues
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $75cac0ff5bfda227$export$5176c37028d33346).Provider, {
        value: value,
        children: children
    });
}



var $exYeM = parcelRequire("exYeM");




var $exYeM = parcelRequire("exYeM");

var $aSiaI = parcelRequire("aSiaI");
function $2b0dc05bd145b6f1$export$2e2bcd8739ae039(props) {
    const { isReversed: isReversed, gradientId: gradientId, size: size, direction: direction, scale: scale, colorMap: colorMap } = props;
    return /*#__PURE__*/ (0, $aSiaI.jsx)("linearGradient", {
        id: gradientId,
        x1: "0",
        x2: "0",
        y1: "0",
        y2: "0",
        [`${direction}${isReversed ? 1 : 2}`]: `${size}px`,
        gradientUnits: "userSpaceOnUse" // Use the SVG coordinate instead of the component ones.
        ,
        children: colorMap.thresholds.map((threshold, index)=>{
            const x = scale(threshold);
            if (x === undefined) return null;
            const offset = isReversed ? 1 - x / size : x / size;
            return /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)("stop", {
                        offset: offset,
                        stopColor: colorMap.colors[index],
                        stopOpacity: 1
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)("stop", {
                        offset: offset,
                        stopColor: colorMap.colors[index + 1],
                        stopOpacity: 1
                    })
                ]
            }, threshold.toString() + index);
        })
    });
}


parcelRequire("exYeM");


var $aSiaI = parcelRequire("aSiaI");
const $3cba9963ea90cd25$var$PX_PRECISION = 10;
function $3cba9963ea90cd25$export$2e2bcd8739ae039(props) {
    const { gradientUnits: gradientUnits, isReversed: isReversed, gradientId: gradientId, size: size, direction: direction, scale: scale, colorScale: colorScale, colorMap: colorMap } = props;
    const extremValues = [
        colorMap.min ?? 0,
        colorMap.max ?? 100
    ];
    const extremPositions = extremValues.map(scale).filter((p)=>p !== undefined);
    if (extremPositions.length !== 2) return null;
    const interpolator = typeof extremValues[0] === "number" ? (0, $d9f27e55086f64c0$export$2e2bcd8739ae039)(extremValues[0], extremValues[1]) : (0, $e579c8d711a959eb$export$2e2bcd8739ae039)(extremValues[0], extremValues[1]);
    const numberOfPoints = Math.round((Math.max(...extremPositions) - Math.min(...extremPositions)) / $3cba9963ea90cd25$var$PX_PRECISION);
    const keyPrefix = `${extremValues[0]}-${extremValues[1]}-`;
    return /*#__PURE__*/ (0, $aSiaI.jsx)("linearGradient", {
        id: gradientId,
        x1: "0",
        x2: "0",
        y1: "0",
        y2: "0",
        [`${direction}${isReversed ? 1 : 2}`]: gradientUnits === "objectBoundingBox" ? 1 : `${size}px`,
        gradientUnits: gradientUnits ?? "userSpaceOnUse" // Use the SVG coordinate instead of the component ones.
        ,
        children: Array.from({
            length: numberOfPoints + 1
        }, (_, index)=>{
            const value = interpolator(index / numberOfPoints);
            if (value === undefined) return null;
            const x = scale(value);
            if (x === undefined) return null;
            const offset = isReversed ? 1 - x / size : x / size;
            const color = colorScale(value);
            if (color === null) return null;
            return /*#__PURE__*/ (0, $aSiaI.jsx)("stop", {
                offset: offset,
                stopColor: color,
                stopOpacity: 1
            }, keyPrefix + index);
        })
    });
}



var $aSiaI = parcelRequire("aSiaI");
function $8d0bf2f3d2b10f17$export$fa70c633f5692acb() {
    const { chartId: chartId } = $exYeM.useContext((0, $7e3726a4b537e82f$export$6b4b60c0e05835fe));
    return $exYeM.useCallback((axisId, direction)=>`${chartId}-gradient-${direction}-${axisId}`, [
        chartId
    ]);
}
function $8d0bf2f3d2b10f17$export$769667455a4ecbb4() {
    const { top: top, height: height, bottom: bottom, left: left, width: width, right: right } = (0, $767eebe86d6e6272$export$389be1739214a0a2)();
    const svgHeight = top + height + bottom;
    const svgWidth = left + width + right;
    const getGradientId = $8d0bf2f3d2b10f17$export$fa70c633f5692acb();
    const { xAxisIds: xAxisIds, xAxis: xAxis, yAxisIds: yAxisIds, yAxis: yAxis } = (0, $27adb4455fa596cf$export$2785a2cc09fc5c5f)();
    return /*#__PURE__*/ (0, $aSiaI.jsxs)("defs", {
        children: [
            yAxisIds.filter((axisId)=>yAxis[axisId].colorMap !== undefined).map((axisId)=>{
                const gradientId = getGradientId(axisId, "y");
                const { colorMap: colorMap, scale: scale, colorScale: colorScale, reverse: reverse } = yAxis[axisId];
                if (colorMap?.type === "piecewise") return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2b0dc05bd145b6f1$export$2e2bcd8739ae039), {
                    isReversed: !reverse,
                    scale: scale,
                    colorMap: colorMap,
                    size: svgHeight,
                    gradientId: gradientId,
                    direction: "y"
                }, gradientId);
                if (colorMap?.type === "continuous") return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3cba9963ea90cd25$export$2e2bcd8739ae039), {
                    isReversed: !reverse,
                    scale: scale,
                    colorScale: colorScale,
                    colorMap: colorMap,
                    size: svgHeight,
                    gradientId: gradientId,
                    direction: "y"
                }, gradientId);
                return null;
            }),
            xAxisIds.filter((axisId)=>xAxis[axisId].colorMap !== undefined).map((axisId)=>{
                const gradientId = getGradientId(axisId, "x");
                const { colorMap: colorMap, scale: scale, reverse: reverse, colorScale: colorScale } = xAxis[axisId];
                if (colorMap?.type === "piecewise") return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2b0dc05bd145b6f1$export$2e2bcd8739ae039), {
                    isReversed: reverse,
                    scale: scale,
                    colorMap: colorMap,
                    size: svgWidth,
                    gradientId: gradientId,
                    direction: "x"
                }, gradientId);
                if (colorMap?.type === "continuous") return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3cba9963ea90cd25$export$2e2bcd8739ae039), {
                    isReversed: reverse,
                    scale: scale,
                    colorScale: colorScale,
                    colorMap: colorMap,
                    size: svgWidth,
                    gradientId: gradientId,
                    direction: "x"
                }, gradientId);
                return null;
            })
        ]
    });
}



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");



const $840f28969a5b0686$export$1194a97ce20fac7d = (highlightScope, highlightedItem)=>(input)=>{
        if (!highlightScope) return false;
        if (highlightScope.fade === "series") return input.seriesId === highlightedItem?.seriesId && input.dataIndex !== highlightedItem?.dataIndex;
        if (highlightScope.fade === "global") return input.seriesId !== highlightedItem?.seriesId || input.dataIndex !== highlightedItem?.dataIndex;
        return false;
    };


const $f01e83b9a2126e4e$export$7f0a973806859aab = (highlightScope, highlightedItem)=>(input)=>{
        if (!highlightScope) return false;
        if (highlightScope.highlight === "series") return input.seriesId === highlightedItem?.seriesId;
        if (highlightScope.highlight === "item") return input.dataIndex === highlightedItem?.dataIndex && input.seriesId === highlightedItem?.seriesId;
        return false;
    };




var $aSiaI = parcelRequire("aSiaI");
const $5d5cb2545700647f$var$_excluded = [
    "highlighted",
    "faded"
];
const $5d5cb2545700647f$var$mergeDeprecatedOptions = (options)=>{
    const _ref = options ?? {}, { highlighted: highlighted, faded: faded } = _ref, other = (0, $3L80X.default)(_ref, $5d5cb2545700647f$var$_excluded);
    return (0, $aJx1R.default)({
        highlight: highlighted,
        fade: faded
    }, other);
};
function $5d5cb2545700647f$export$173f89ed4324027e({ children: children, highlightedItem: highlightedItemProps, onHighlightChange: onHighlightChange }) {
    const [highlightedItem, setHighlightedItem] = (0, $d86ef59ee77e84fd$export$2e2bcd8739ae039)({
        controlled: highlightedItemProps,
        default: null,
        name: "HighlightedProvider",
        state: "highlightedItem"
    });
    const series = (0, $ba69253362075717$export$23a245cc02c91dfa)();
    const seriesById = $exYeM.useMemo(()=>{
        const map = new Map();
        Object.keys(series).forEach((seriesType)=>{
            const seriesData = series[seriesType];
            Object.keys(seriesData?.series ?? {}).forEach((seriesId)=>{
                const seriesItem = seriesData?.series[seriesId];
                map.set(seriesId, $5d5cb2545700647f$var$mergeDeprecatedOptions(seriesItem?.highlightScope));
            });
        });
        return map;
    }, [
        series
    ]);
    const highlightScope = highlightedItem && highlightedItem.seriesId ? seriesById.get(highlightedItem.seriesId) ?? undefined : undefined;
    const providerValue = $exYeM.useMemo(()=>{
        return {
            isInitialized: true,
            data: {
                highlightScope: highlightScope,
                highlightedItem: highlightedItem,
                setHighlighted: (itemData)=>{
                    setHighlightedItem(itemData);
                    onHighlightChange?.(itemData);
                },
                clearHighlighted: ()=>{
                    setHighlightedItem(null);
                    onHighlightChange?.(null);
                },
                isHighlighted: (0, $f01e83b9a2126e4e$export$7f0a973806859aab)(highlightScope, highlightedItem),
                isFaded: (0, $840f28969a5b0686$export$1194a97ce20fac7d)(highlightScope, highlightedItem)
            }
        };
    }, [
        highlightedItem,
        highlightScope,
        setHighlightedItem,
        onHighlightChange
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $77115235116b4adb$export$2e389f0a2b27c92f).Provider, {
        value: providerValue,
        children: children
    });
}


var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");



var $aSiaI = parcelRequire("aSiaI");
const $8b281edd23d106fe$export$7dd085f121653b41 = /*#__PURE__*/ $exYeM.createContext({
    zAxis: {},
    zAxisIds: []
});
function $8b281edd23d106fe$export$efded640791f3d7c(props) {
    const { zAxis: inZAxis, dataset: dataset, children: children } = props;
    const zAxis = $exYeM.useMemo(()=>inZAxis?.map((axisConfig)=>{
            const dataKey = axisConfig.dataKey;
            if (dataKey === undefined || axisConfig.data !== undefined) return axisConfig;
            if (dataset === undefined) throw Error("MUI X Charts: z-axis uses `dataKey` but no `dataset` is provided.");
            return (0, $aJx1R.default)({}, axisConfig, {
                data: dataset.map((d)=>d[dataKey])
            });
        }), [
        inZAxis,
        dataset
    ]);
    const value = $exYeM.useMemo(()=>{
        const allZAxis = zAxis?.map((axis, index)=>(0, $aJx1R.default)({
                id: `defaultized-z-axis-${index}`
            }, axis)) ?? [];
        const completedZAxis = {};
        allZAxis.forEach((axis)=>{
            completedZAxis[axis.id] = (0, $aJx1R.default)({}, axis, {
                colorScale: axis.colorMap && (axis.colorMap.type === "ordinal" && axis.data ? (0, $8bcb3f3dc2767cc6$export$c3ea10dbbf6bbab3)((0, $aJx1R.default)({
                    values: axis.data
                }, axis.colorMap)) : (0, $8bcb3f3dc2767cc6$export$75f9af112506f7de)(axis.colorMap.type === "continuous" ? (0, $aJx1R.default)({
                    min: axis.min,
                    max: axis.max
                }, axis.colorMap) : axis.colorMap))
            });
        });
        return {
            zAxis: completedZAxis,
            zAxisIds: allZAxis.map(({ id: id })=>id)
        };
    }, [
        zAxis
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($8b281edd23d106fe$export$7dd085f121653b41.Provider, {
        value: value,
        children: children
    });
}



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");


var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");
const $084eee9e310de281$var$getBaseExtremum = (params)=>{
    const { axis: axis } = params;
    const minX = Math.min(...axis.data ?? []);
    const maxX = Math.max(...axis.data ?? []);
    return [
        minX,
        maxX
    ];
};
const $084eee9e310de281$var$getValueExtremum = (params)=>{
    const { series: series, axis: axis, isDefaultAxis: isDefaultAxis } = params;
    return Object.keys(series).filter((seriesId)=>series[seriesId].yAxisKey === axis.id || isDefaultAxis && series[seriesId].yAxisKey === undefined).reduce((acc, seriesId)=>{
        const [seriesMin, seriesMax] = series[seriesId].stackedData?.reduce((seriesAcc, values)=>[
                Math.min(...values, ...seriesAcc[0] === null ? [] : [
                    seriesAcc[0]
                ]),
                Math.max(...values, ...seriesAcc[1] === null ? [] : [
                    seriesAcc[1]
                ])
            ], series[seriesId].stackedData[0]) ?? [
            null,
            null
        ];
        return [
            acc[0] === null ? seriesMin : Math.min(seriesMin, acc[0]),
            acc[1] === null ? seriesMax : Math.max(seriesMax, acc[1])
        ];
    }, [
        null,
        null
    ]);
};
const $084eee9e310de281$export$a94fe0eef2545d5 = (params)=>{
    // Notice that bar should be all horizontal or all vertical.
    // Don't think it's a problem for now
    const isHorizontal = Object.keys(params.series).some((seriesId)=>params.series[seriesId].layout === "horizontal");
    if (isHorizontal) return $084eee9e310de281$var$getValueExtremum(params);
    return $084eee9e310de281$var$getBaseExtremum(params);
};
const $084eee9e310de281$export$515d15353d6b16e2 = (params)=>{
    const isHorizontal = Object.keys(params.series).some((seriesId)=>params.series[seriesId].layout === "horizontal");
    if (isHorizontal) return $084eee9e310de281$var$getBaseExtremum(params);
    return $084eee9e310de281$var$getValueExtremum(params);
};



var $aJx1R = parcelRequire("aJx1R");
var $3fa1b8e94adeb982$export$58adb3bec8346d0f = Array.prototype.slice;
function $3fa1b8e94adeb982$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}


function $daa29d5b1d6b2092$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}


function $356453f5f6c893bd$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}


function $565374c5743884d0$export$2e2bcd8739ae039(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}


function $d92dace652ac813f$var$stackValue(d, key) {
    return d[key];
}
function $d92dace652ac813f$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $d92dace652ac813f$export$2e2bcd8739ae039() {
    var keys = (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)([]), order = (0, $565374c5743884d0$export$2e2bcd8739ae039), offset = (0, $356453f5f6c893bd$export$2e2bcd8739ae039), value = $d92dace652ac813f$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $d92dace652ac813f$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $3fa1b8e94adeb982$export$2e2bcd8739ae039)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? (0, $565374c5743884d0$export$2e2bcd8739ae039) : typeof _ === "function" ? _ : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? (0, $356453f5f6c893bd$export$2e2bcd8739ae039) : _, stack) : offset;
    };
    return stack;
}


function $9a56ce3478a08fdb$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}


function $e4e84889629ec4cc$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $356453f5f6c893bd$export$2e2bcd8739ae039)(series, order);
}


function $6e1048d5eee93fed$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $356453f5f6c893bd$export$2e2bcd8739ae039)(series, order);
}


function $b4cd4be6d0f12a30$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $356453f5f6c893bd$export$2e2bcd8739ae039)(series, order);
}


function $dd5ba68e0385aa00$export$2e2bcd8739ae039(series) {
    var peaks = series.map($dd5ba68e0385aa00$var$peak);
    return (0, $565374c5743884d0$export$2e2bcd8739ae039)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $dd5ba68e0385aa00$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}


function $9199984cf878c516$export$2e2bcd8739ae039(series) {
    var sums = series.map($9199984cf878c516$export$8a63f25cc62965f1);
    return (0, $565374c5743884d0$export$2e2bcd8739ae039)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $9199984cf878c516$export$8a63f25cc62965f1(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}


function $b9dea38e26768ee4$export$2e2bcd8739ae039(series) {
    return (0, $9199984cf878c516$export$2e2bcd8739ae039)(series).reverse();
}



function $4e05ca6e54a3159d$export$2e2bcd8739ae039(series) {
    var n = series.length, i, j, sums = series.map((0, $9199984cf878c516$export$8a63f25cc62965f1)), order = (0, $dd5ba68e0385aa00$export$2e2bcd8739ae039)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}


function $594cb2c79d8ca59b$export$2e2bcd8739ae039(series) {
    return (0, $565374c5743884d0$export$2e2bcd8739ae039)(series).reverse();
}


const $479cb6438fbf674e$export$9ce2720c31788711 = {
    /**
   * Series order such that the earliest series (according to the maximum value) is at the bottom.
   * */ appearance: (0, $dd5ba68e0385aa00$export$2e2bcd8739ae039),
    /**
   *  Series order such that the smallest series (according to the sum of values) is at the bottom.
   * */ ascending: (0, $9199984cf878c516$export$2e2bcd8739ae039),
    /**
   * Series order such that the largest series (according to the sum of values) is at the bottom.
   */ descending: (0, $b9dea38e26768ee4$export$2e2bcd8739ae039),
    /**
   * Series order such that the earliest series (according to the maximum value) are on the inside and the later series are on the outside. This order is recommended for streamgraphs in conjunction with the wiggle offset. See Stacked Graphs—Geometry & Aesthetics by Byron & Wattenberg for more information.
   */ insideOut: (0, $4e05ca6e54a3159d$export$2e2bcd8739ae039),
    /**
   * Given series order [0, 1, … n - 1] where n is the number of elements in series. Thus, the stack order is given by the key accessor.
   */ none: (0, $565374c5743884d0$export$2e2bcd8739ae039),
    /**
   * Reverse of the given series order [n - 1, n - 2, … 0] where n is the number of elements in series. Thus, the stack order is given by the reverse of the key accessor.
   */ reverse: (0, $594cb2c79d8ca59b$export$2e2bcd8739ae039)
};
const $479cb6438fbf674e$export$2c7ace4a5b652c47 = {
    /**
   * Applies a zero baseline and normalizes the values for each point such that the topline is always one.
   * */ expand: (0, $e4e84889629ec4cc$export$2e2bcd8739ae039),
    /**
   * Positive values are stacked above zero, negative values are stacked below zero, and zero values are stacked at zero.
   * */ diverging: (0, $9a56ce3478a08fdb$export$2e2bcd8739ae039),
    /**
   * Applies a zero baseline.
   * */ none: (0, $356453f5f6c893bd$export$2e2bcd8739ae039),
    /**
   * Shifts the baseline down such that the center of the streamgraph is always at zero.
   * */ silhouette: (0, $6e1048d5eee93fed$export$2e2bcd8739ae039),
    /**
   * Shifts the baseline so as to minimize the weighted wiggle of layers. This offset is recommended for streamgraphs in conjunction with the inside-out order. See Stacked Graphs—Geometry & Aesthetics by Bryon & Wattenberg for more information.
   * */ wiggle: (0, $b4cd4be6d0f12a30$export$2e2bcd8739ae039)
};
const $479cb6438fbf674e$export$6e9d89f3a97ffe72 = (params)=>{
    const { series: series, seriesOrder: seriesOrder, defaultStrategy: defaultStrategy } = params;
    const stackingGroups = [];
    const stackIndex = {};
    seriesOrder.forEach((id)=>{
        const { stack: stack, stackOrder: stackOrder, stackOffset: stackOffset } = series[id];
        if (stack === undefined) stackingGroups.push({
            ids: [
                id
            ],
            stackingOrder: $479cb6438fbf674e$export$9ce2720c31788711.none,
            stackingOffset: $479cb6438fbf674e$export$2c7ace4a5b652c47.none
        });
        else if (stackIndex[stack] === undefined) {
            stackIndex[stack] = stackingGroups.length;
            stackingGroups.push({
                ids: [
                    id
                ],
                stackingOrder: $479cb6438fbf674e$export$9ce2720c31788711[stackOrder ?? defaultStrategy?.stackOrder ?? "none"],
                stackingOffset: $479cb6438fbf674e$export$2c7ace4a5b652c47[stackOffset ?? defaultStrategy?.stackOffset ?? "diverging"]
            });
        } else {
            stackingGroups[stackIndex[stack]].ids.push(id);
            if (stackOrder !== undefined) stackingGroups[stackIndex[stack]].stackingOrder = $479cb6438fbf674e$export$9ce2720c31788711[stackOrder];
            if (stackOffset !== undefined) stackingGroups[stackIndex[stack]].stackingOffset = $479cb6438fbf674e$export$2c7ace4a5b652c47[stackOffset];
        }
    });
    return stackingGroups;
};



var $aJx1R = parcelRequire("aJx1R");
function $d03f3347095d7b26$export$f969421fe32d3ee6(series, defaultValueFormatter) {
    const defaultizedSeries = {};
    Object.keys(series).forEach((seriesId)=>{
        defaultizedSeries[seriesId] = (0, $aJx1R.default)({}, series[seriesId], {
            valueFormatter: series[seriesId].valueFormatter ?? defaultValueFormatter
        });
    });
    return defaultizedSeries;
}


let $e7095fdfb61dd21d$var$warnOnce = false;
const $e7095fdfb61dd21d$var$formatter = (params, dataset)=>{
    const { seriesOrder: seriesOrder, series: series } = params;
    const stackingGroups = (0, $479cb6438fbf674e$export$6e9d89f3a97ffe72)(params);
    // Create a data set with format adapted to d3
    const d3Dataset = dataset ?? [];
    seriesOrder.forEach((id)=>{
        const data = series[id].data;
        if (data !== undefined) data.forEach((value, index)=>{
            if (d3Dataset.length <= index) d3Dataset.push({
                [id]: value
            });
            else d3Dataset[index][id] = value;
        });
        else if (dataset === undefined) throw new Error([
            `MUI X Charts: bar series with id='${id}' has no data.`,
            "Either provide a data property to the series or use the dataset prop."
        ].join("\n"));
    });
    const completedSeries = {};
    stackingGroups.forEach((stackingGroup)=>{
        const { ids: ids, stackingOffset: stackingOffset, stackingOrder: stackingOrder } = stackingGroup;
        // Get stacked values, and derive the domain
        const stackedSeries = (0, $d92dace652ac813f$export$2e2bcd8739ae039)().keys(ids.map((id)=>{
            // Use dataKey if needed and available
            const dataKey = series[id].dataKey;
            return series[id].data === undefined && dataKey !== undefined ? dataKey : id;
        })).value((d, key)=>d[key] ?? 0) // defaultize null value to 0
        .order(stackingOrder).offset(stackingOffset)(d3Dataset);
        ids.forEach((id, index)=>{
            const dataKey = series[id].dataKey;
            completedSeries[id] = (0, $aJx1R.default)({
                layout: "vertical"
            }, series[id], {
                data: dataKey ? dataset.map((data)=>{
                    const value = data[dataKey];
                    if (typeof value !== "number") return 0;
                    return value;
                }) : series[id].data,
                stackedData: stackedSeries[index].map(([a, b])=>[
                        a,
                        b
                    ])
            });
        });
    });
    return {
        seriesOrder: seriesOrder,
        stackingGroups: stackingGroups,
        series: (0, $d03f3347095d7b26$export$f969421fe32d3ee6)(completedSeries, (v)=>v == null ? "" : v.toLocaleString())
    };
};
var $e7095fdfb61dd21d$export$2e2bcd8739ae039 = $e7095fdfb61dd21d$var$formatter;



const $30f0f5aefe476717$export$ca524d3785e2543 = {
    seriesType: "bar",
    seriesFormatter: (0, $e7095fdfb61dd21d$export$2e2bcd8739ae039),
    colorProcessor: (0, $69b8a720613cd165$export$2e2bcd8739ae039),
    xExtremumGetter: (0, $084eee9e310de281$export$a94fe0eef2545d5),
    yExtremumGetter: (0, $084eee9e310de281$export$515d15353d6b16e2)
};


const $04231f276de95e44$var$mergeMinMax = (acc, val)=>{
    if (acc[0] === null || acc[1] === null) return val;
    if (val[0] === null || val[1] === null) return acc;
    return [
        Math.min(acc[0], val[0]),
        Math.max(acc[1], val[1])
    ];
};
const $04231f276de95e44$export$a94fe0eef2545d5 = (params)=>{
    const { series: series, axis: axis, isDefaultAxis: isDefaultAxis } = params;
    return Object.keys(series).filter((seriesId)=>series[seriesId].xAxisKey === axis.id || series[seriesId].xAxisKey === undefined && isDefaultAxis).reduce((acc, seriesId)=>{
        const seriesMinMax = series[seriesId].data.reduce((accSeries, { x: x })=>{
            const val = [
                x,
                x
            ];
            return $04231f276de95e44$var$mergeMinMax(accSeries, val);
        }, [
            null,
            null
        ]);
        return $04231f276de95e44$var$mergeMinMax(acc, seriesMinMax);
    }, [
        null,
        null
    ]);
};
const $04231f276de95e44$export$515d15353d6b16e2 = (params)=>{
    const { series: series, axis: axis, isDefaultAxis: isDefaultAxis } = params;
    return Object.keys(series).filter((seriesId)=>series[seriesId].yAxisKey === axis.id || series[seriesId].yAxisKey === undefined && isDefaultAxis).reduce((acc, seriesId)=>{
        const seriesMinMax = series[seriesId].data.reduce((accSeries, { y: y })=>{
            const val = [
                y,
                y
            ];
            return $04231f276de95e44$var$mergeMinMax(accSeries, val);
        }, [
            null,
            null
        ]);
        return $04231f276de95e44$var$mergeMinMax(acc, seriesMinMax);
    }, [
        null,
        null
    ]);
};



const $8d282dca62bbfaab$var$formatter = ({ series: series, seriesOrder: seriesOrder })=>{
    return {
        series: (0, $d03f3347095d7b26$export$f969421fe32d3ee6)(series, (v)=>`(${v.x}, ${v.y})`),
        seriesOrder: seriesOrder
    };
};
var $8d282dca62bbfaab$export$2e2bcd8739ae039 = $8d282dca62bbfaab$var$formatter;


function $9640c80cf196e6a9$export$2e2bcd8739ae039(series, xAxis, yAxis, zAxis) {
    const zColorScale = zAxis?.colorScale;
    const yColorScale = yAxis?.colorScale;
    const xColorScale = xAxis?.colorScale;
    if (zColorScale) return (dataIndex)=>{
        if (zAxis?.data?.[dataIndex] !== undefined) {
            const color = zColorScale(zAxis?.data?.[dataIndex]);
            if (color !== null) return color;
        }
        const value = series.data[dataIndex];
        const color = value === null ? series.color : zColorScale(value.z);
        if (color === null) return series.color;
        return color;
    };
    if (yColorScale) return (dataIndex)=>{
        const value = series.data[dataIndex];
        const color = value === null ? series.color : yColorScale(value.y);
        if (color === null) return series.color;
        return color;
    };
    if (xColorScale) return (dataIndex)=>{
        const value = series.data[dataIndex];
        const color = value === null ? series.color : xColorScale(value.x);
        if (color === null) return series.color;
        return color;
    };
    return ()=>series.color;
}


const $e9897d2b3873e5b8$export$ca524d3785e2543 = {
    seriesType: "scatter",
    seriesFormatter: (0, $8d282dca62bbfaab$export$2e2bcd8739ae039),
    colorProcessor: (0, $9640c80cf196e6a9$export$2e2bcd8739ae039),
    xExtremumGetter: (0, $04231f276de95e44$export$a94fe0eef2545d5),
    yExtremumGetter: (0, $04231f276de95e44$export$515d15353d6b16e2)
};


const $737cd97154a10ebc$export$a94fe0eef2545d5 = (params)=>{
    const { axis: axis } = params;
    const minX = Math.min(...axis.data ?? []);
    const maxX = Math.max(...axis.data ?? []);
    return [
        minX,
        maxX
    ];
};
function $737cd97154a10ebc$var$getSeriesExtremums(getValues, stackedData) {
    if (stackedData.length === 0) return [
        null,
        null
    ];
    return stackedData.reduce((seriesAcc, stackedValue)=>{
        const [base, value] = getValues(stackedValue);
        if (seriesAcc[0] === null) return [
            Math.min(base, value),
            Math.max(base, value)
        ];
        return [
            Math.min(base, value, seriesAcc[0]),
            Math.max(base, value, seriesAcc[1])
        ];
    }, getValues(stackedData[0]));
}
const $737cd97154a10ebc$export$515d15353d6b16e2 = (params)=>{
    const { series: series, axis: axis, isDefaultAxis: isDefaultAxis } = params;
    return Object.keys(series).filter((seriesId)=>series[seriesId].yAxisKey === axis.id || isDefaultAxis && series[seriesId].yAxisKey === undefined).reduce((acc, seriesId)=>{
        const { area: area, stackedData: stackedData } = series[seriesId];
        const isArea = area !== undefined;
        const getValues = isArea && axis.scaleType !== "log" ? (d)=>d : (d)=>[
                d[1],
                d[1]
            ]; // Since this series is not used to display an area, we do not consider the base (the d[0]).
        const seriesExtremums = $737cd97154a10ebc$var$getSeriesExtremums(getValues, stackedData);
        if (acc[0] === null) return seriesExtremums;
        if (seriesExtremums[0] === null) return acc;
        const [seriesMin, seriesMax] = seriesExtremums;
        return [
            Math.min(seriesMin, acc[0]),
            Math.max(seriesMax, acc[1])
        ];
    }, [
        null,
        null
    ]);
};



var $aJx1R = parcelRequire("aJx1R");



let $bf7c7d7ac0335315$var$warnedOnce = false;
// For now it's a copy past of bar charts formatter, but maybe will diverge later
const $bf7c7d7ac0335315$var$formatter = (params, dataset)=>{
    const { seriesOrder: seriesOrder, series: series } = params;
    const stackingGroups = (0, $479cb6438fbf674e$export$6e9d89f3a97ffe72)((0, $aJx1R.default)({}, params, {
        defaultStrategy: {
            stackOffset: "none"
        }
    }));
    // Create a data set with format adapted to d3
    const d3Dataset = dataset ?? [];
    seriesOrder.forEach((id)=>{
        const data = series[id].data;
        if (data !== undefined) data.forEach((value, index)=>{
            if (d3Dataset.length <= index) d3Dataset.push({
                [id]: value
            });
            else d3Dataset[index][id] = value;
        });
    });
    const completedSeries = {};
    stackingGroups.forEach((stackingGroup)=>{
        // Get stacked values, and derive the domain
        const { ids: ids, stackingOrder: stackingOrder, stackingOffset: stackingOffset } = stackingGroup;
        const stackedSeries = (0, $d92dace652ac813f$export$2e2bcd8739ae039)().keys(ids.map((id)=>{
            // Use dataKey if needed and available
            const dataKey = series[id].dataKey;
            return series[id].data === undefined && dataKey !== undefined ? dataKey : id;
        })).value((d, key)=>d[key] ?? 0) // defaultize null value to 0
        .order(stackingOrder).offset(stackingOffset)(d3Dataset);
        ids.forEach((id, index)=>{
            const dataKey = series[id].dataKey;
            completedSeries[id] = (0, $aJx1R.default)({}, series[id], {
                data: dataKey ? dataset.map((data)=>{
                    const value = data[dataKey];
                    if (typeof value !== "number") return null;
                    return value;
                }) : series[id].data,
                stackedData: stackedSeries[index].map(([a, b])=>[
                        a,
                        b
                    ])
            });
        });
    });
    return {
        seriesOrder: seriesOrder,
        stackingGroups: stackingGroups,
        series: (0, $d03f3347095d7b26$export$f969421fe32d3ee6)(completedSeries, (v)=>v == null ? "" : v.toLocaleString())
    };
};
var $bf7c7d7ac0335315$export$2e2bcd8739ae039 = $bf7c7d7ac0335315$var$formatter;


function $cb7b0a4c0c04d36c$export$2e2bcd8739ae039(series, xAxis, yAxis) {
    const yColorScale = yAxis?.colorScale;
    const xColorScale = xAxis?.colorScale;
    if (yColorScale) return (dataIndex)=>{
        const value = series.data[dataIndex];
        const color = value === null ? series.color : yColorScale(value);
        if (color === null) return series.color;
        return color;
    };
    if (xColorScale) return (dataIndex)=>{
        const value = xAxis.data?.[dataIndex];
        const color = value === null ? series.color : xColorScale(value);
        if (color === null) return series.color;
        return color;
    };
    return ()=>series.color;
}


const $d0164922e580e345$export$ca524d3785e2543 = {
    seriesType: "line",
    colorProcessor: (0, $cb7b0a4c0c04d36c$export$2e2bcd8739ae039),
    seriesFormatter: (0, $bf7c7d7ac0335315$export$2e2bcd8739ae039),
    xExtremumGetter: (0, $737cd97154a10ebc$export$a94fe0eef2545d5),
    yExtremumGetter: (0, $737cd97154a10ebc$export$515d15353d6b16e2)
};



var $aJx1R = parcelRequire("aJx1R");


function $adf300414f61b3b6$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $f61fe3822a1d259b$export$2e2bcd8739ae039(d) {
    return d;
}



var $4yPBQ = parcelRequire("4yPBQ");
function $ed30c20e7922b910$export$2e2bcd8739ae039() {
    var value = (0, $f61fe3822a1d259b$export$2e2bcd8739ae039), sortValues = (0, $adf300414f61b3b6$export$2e2bcd8739ae039), sort = null, startAngle = (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(0), endAngle = (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)((0, $4yPBQ.tau)), padAngle = (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(0);
    function pie(data) {
        var i, n = (data = (0, $3fa1b8e94adeb982$export$2e2bcd8739ae039)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, $4yPBQ.tau), Math.max(-(0, $4yPBQ.tau), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
        // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        });
        // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(+_), pie) : padAngle;
    };
    return pie;
}


function $218fa0efd181b45d$export$236350842f3cd9bc(value, location) {
    return typeof value === "function" ? value(location) : value;
}


const $1b93794278944fa9$var$getSortingComparator = (comparator = "none")=>{
    if (typeof comparator === "function") return comparator;
    switch(comparator){
        case "none":
            return null;
        case "desc":
            return (a, b)=>b - a;
        case "asc":
            return (a, b)=>a - b;
        default:
            return null;
    }
};
const $1b93794278944fa9$var$formatter = (params)=>{
    const { seriesOrder: seriesOrder, series: series } = params;
    const defaultizedSeries = {};
    seriesOrder.forEach((seriesId)=>{
        const arcs = (0, $ed30c20e7922b910$export$2e2bcd8739ae039)().startAngle(2 * Math.PI * (series[seriesId].startAngle ?? 0) / 360).endAngle(2 * Math.PI * (series[seriesId].endAngle ?? 360) / 360).padAngle(2 * Math.PI * (series[seriesId].paddingAngle ?? 0) / 360).sortValues($1b93794278944fa9$var$getSortingComparator(series[seriesId].sortingValues ?? "none"))(series[seriesId].data.map((piePoint)=>piePoint.value));
        defaultizedSeries[seriesId] = (0, $aJx1R.default)({
            valueFormatter: (item)=>item.value.toLocaleString()
        }, series[seriesId], {
            data: series[seriesId].data.map((item, index)=>(0, $aJx1R.default)({}, item, {
                    id: item.id ?? `auto-generated-pie-id-${seriesId}-${index}`
                }, arcs[index])).map((item, index)=>(0, $aJx1R.default)({}, item, {
                    formattedValue: series[seriesId].valueFormatter?.((0, $aJx1R.default)({}, item, {
                        label: (0, $218fa0efd181b45d$export$236350842f3cd9bc)(item.label, "arc")
                    }), {
                        dataIndex: index
                    }) ?? item.value.toLocaleString()
                }))
        });
    });
    return {
        seriesOrder: seriesOrder,
        series: defaultizedSeries
    };
};
var $1b93794278944fa9$export$2e2bcd8739ae039 = $1b93794278944fa9$var$formatter;


function $c525c9efa36755f9$export$2e2bcd8739ae039(series) {
    return (dataIndex)=>{
        return series.data[dataIndex].color;
    };
}


const $32f18564affba514$export$ca524d3785e2543 = {
    seriesType: "pie",
    colorProcessor: (0, $c525c9efa36755f9$export$2e2bcd8739ae039),
    seriesFormatter: (0, $1b93794278944fa9$export$2e2bcd8739ae039)
};


const $75dc0d2f0e30df57$export$b5ecb47695d6786e = [
    (0, $30f0f5aefe476717$export$ca524d3785e2543),
    (0, $e9897d2b3873e5b8$export$ca524d3785e2543),
    (0, $d0164922e580e345$export$ca524d3785e2543),
    (0, $32f18564affba514$export$ca524d3785e2543)
];


function $ecd69b992dacde64$export$37234e0b7f325706(plugins) {
    const defaultizedPlugins = plugins ?? (0, $75dc0d2f0e30df57$export$b5ecb47695d6786e);
    return $exYeM.useMemo(()=>{
        const seriesFormatters = {};
        const colorProcessors = {};
        const xExtremumGetters = {};
        const yExtremumGetters = {};
        for(let i = 0; i < defaultizedPlugins.length; i += 1){
            const plugin = defaultizedPlugins[i];
            // To remove those any we will need to solve this union discrimination issue:
            // https://www.typescriptlang.org/play/?#code/FDAuE8AcFMAIDkCuBbARtATgYQPYDsAzASwHNYBeWAb2FlgGsi8ATALlgHI8V0MOBuWrBwwMAQ1A4M7ABQAPdtzSYAlBQB8sJb0EBfEBBiwAyqAxMSuQqQrUhjFuw4BnMxYFCRmCVNkLYruZ4JGrkmoEWeiAAxviuWqhWxCTsSMrY+Mm2VAxMbLAARNqYBQA0wqI+0rByGrAATLAAVDWw+rF48YFJpOymQZaZNpQ5DvkFEcFlFd6S1bVhsAAG9S0AJFRyukttMXGgsB3JzrYA2niJQyTl3VcAugZQcADylXPOALJikJAW2ULFDAAflSPEwPRIpw4XnEcw4d1KQkmJBBJjcwQhUJhVXhiN0gmAHXi2LmXx+FnYr1mUk+31+wWy+JABCksBkABtoAcjjYcARDldnGoaCA6AB6MWwADqUnoJxw9FgRH5AHc4L9ooroGJogALQ5iZxwPJEABuRGYiDE7PASJVRFAerZPJIADoxsKhHRooa4FwwXxWF66DNYVIyfTIS73Xk7rZoySpIIQyHUBhtfRkyGfUbOMiOEGU3RExgIxZTtGxnHKAm3kng8xoAQxIh2aBC0W0xms-pvftqLkWOUS2141chBLYABJDimuB4HBKxtiWBiVA4RAHXU4FWwSSwTkHAAqxlgiBYmFcYhYAusbrGq5vtepGFX6YPTHo0GYnjrpbp5ZVrYJZ6EAA
            seriesFormatters[plugin.seriesType] = plugin.seriesFormatter;
            colorProcessors[plugin.seriesType] = plugin.colorProcessor;
            if (plugin.xExtremumGetter) xExtremumGetters[plugin.seriesType] = plugin.xExtremumGetter;
            if (plugin.yExtremumGetter) yExtremumGetters[plugin.seriesType] = plugin.yExtremumGetter;
        }
        return {
            seriesFormatters: seriesFormatters,
            colorProcessors: colorProcessors,
            xExtremumGetters: xExtremumGetters,
            yExtremumGetters: yExtremumGetters
        };
    }, [
        defaultizedPlugins
    ]);
}



const $f9ad4bea6c0b903d$export$6a42007cf1e7b6f8 = ()=>{
    // Taken from: https://github.com/pmndrs/react-spring/blob/02ec877bbfab0df46da0e4a47d5f68d3e731206a/packages/shared/src/hooks/useReducedMotion.ts#L13
    (0, $fafba8d3e1bed3b4$export$700979bc83e7db82)(()=>{
        if (!window.matchMedia) {
            // skip animation in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
            (0, $fafba8d3e1bed3b4$export$cceeabf822b64fc0).assign({
                skipAnimation: true
            });
            return ()=>{};
        }
        const mql = window.matchMedia("(prefers-reduced-motion)");
        const handleMediaChange = (e)=>{
            (0, $fafba8d3e1bed3b4$export$cceeabf822b64fc0).assign({
                // Modification such the react-spring implementation such that this hook can remove animation but never activate animation.
                skipAnimation: e.matches || undefined
            });
        };
        handleMediaChange(mql);
        // MatchMedia is not fully supported in all environments, so we need to check if it exists before calling addEventListener
        mql.addEventListener?.("change", handleMediaChange);
        return ()=>{
            mql.removeEventListener?.("change", handleMediaChange);
        };
    }, []);
};


const $5a1b5f08ce1a39a8$export$efb8e6a4071fd6d0 = (ref, plugins)=>{
    const svgRef = $exYeM.useRef(null);
    const chartSurfaceRef = (0, $21de68ba780e9ec5$export$2e2bcd8739ae039)(ref, svgRef);
    const { xExtremumGetters: xExtremumGetters, yExtremumGetters: yExtremumGetters, seriesFormatters: seriesFormatters, colorProcessors: colorProcessors } = (0, $ecd69b992dacde64$export$37234e0b7f325706)(plugins);
    (0, $f9ad4bea6c0b903d$export$6a42007cf1e7b6f8)(); // a11y reduce motion (see: https://react-spring.dev/docs/utilities/use-reduced-motion)
    return {
        svgRef: svgRef,
        chartSurfaceRef: chartSurfaceRef,
        xExtremumGetters: xExtremumGetters,
        yExtremumGetters: yExtremumGetters,
        seriesFormatters: seriesFormatters,
        colorProcessors: colorProcessors
    };
};



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

const $880089bb62363b09$var$defaultizeAxis = (inAxis, axisName)=>{
    const DEFAULT_AXIS_KEY = axisName === "x" ? (0, $f7012dce0f399219$export$85ea9370ff307a1f) : (0, $f7012dce0f399219$export$59bb26725f1fe1e8);
    return [
        ...inAxis?.map((axis, index)=>(0, $aJx1R.default)({
                id: `defaultized-${axisName}-axis-${index}`
            }, axis)) ?? [],
        ...inAxis === undefined || inAxis.findIndex(({ id: id })=>id === DEFAULT_AXIS_KEY) === -1 ? [
            {
                id: DEFAULT_AXIS_KEY,
                scaleType: "linear"
            }
        ] : []
    ];
};
const $880089bb62363b09$export$25ddcb236206fd9c = (inXAxis, inYAxis)=>{
    const xAxis = $exYeM.useMemo(()=>$880089bb62363b09$var$defaultizeAxis(inXAxis, "x"), [
        inXAxis
    ]);
    const yAxis = $exYeM.useMemo(()=>$880089bb62363b09$var$defaultizeAxis(inYAxis, "y"), [
        inYAxis
    ]);
    return [
        xAxis,
        yAxis
    ];
};


const $ba777b7acd08cbe0$var$_excluded = [
    "width",
    "height",
    "series",
    "margin",
    "xAxis",
    "yAxis",
    "zAxis",
    "colors",
    "dataset",
    "sx",
    "title",
    "desc",
    "disableAxisListener",
    "highlightedItem",
    "onHighlightChange",
    "plugins",
    "children"
];
const $ba777b7acd08cbe0$export$89b2b3e6fbda6258 = (props, ref)=>{
    const { width: width, height: height, series: series, margin: margin, xAxis: xAxis, yAxis: yAxis, zAxis: zAxis, colors: colors, dataset: dataset, sx: sx, title: title, desc: desc, disableAxisListener: disableAxisListener, highlightedItem: highlightedItem, onHighlightChange: onHighlightChange, plugins: plugins, children: children } = props, other = (0, $3L80X.default)(props, $ba777b7acd08cbe0$var$_excluded);
    const { svgRef: svgRef, chartSurfaceRef: chartSurfaceRef, xExtremumGetters: xExtremumGetters, yExtremumGetters: yExtremumGetters, seriesFormatters: seriesFormatters, colorProcessors: colorProcessors } = (0, $5a1b5f08ce1a39a8$export$efb8e6a4071fd6d0)(ref, plugins);
    const [defaultizedXAxis, defaultizedYAxis] = (0, $880089bb62363b09$export$25ddcb236206fd9c)(xAxis, yAxis);
    const drawingProviderProps = {
        width: width,
        height: height,
        margin: margin,
        svgRef: svgRef
    };
    const colorProviderProps = {
        colorProcessors: colorProcessors
    };
    const seriesContextProps = {
        series: series,
        colors: colors,
        dataset: dataset,
        seriesFormatters: seriesFormatters
    };
    const cartesianContextProps = {
        xAxis: defaultizedXAxis,
        yAxis: defaultizedYAxis,
        dataset: dataset,
        xExtremumGetters: xExtremumGetters,
        yExtremumGetters: yExtremumGetters
    };
    const zAxisContextProps = {
        zAxis: zAxis,
        dataset: dataset
    };
    const highlightedProviderProps = {
        highlightedItem: highlightedItem,
        onHighlightChange: onHighlightChange
    };
    const chartsSurfaceProps = (0, $aJx1R.default)({}, other, {
        width: width,
        height: height,
        ref: chartSurfaceRef,
        sx: sx,
        title: title,
        desc: desc,
        disableAxisListener: disableAxisListener
    });
    return {
        children: children,
        drawingProviderProps: drawingProviderProps,
        colorProviderProps: colorProviderProps,
        seriesContextProps: seriesContextProps,
        cartesianContextProps: cartesianContextProps,
        zAxisContextProps: zAxisContextProps,
        highlightedProviderProps: highlightedProviderProps,
        chartsSurfaceProps: chartsSurfaceProps,
        xAxis: defaultizedXAxis,
        yAxis: defaultizedYAxis
    };
};



var $aSiaI = parcelRequire("aSiaI");
const $03ff22f4767fa616$export$57a8e701bcb0acd5 = /*#__PURE__*/ $exYeM.forwardRef(function ChartContainer(props, ref) {
    const { children: children, drawingProviderProps: drawingProviderProps, colorProviderProps: colorProviderProps, seriesContextProps: seriesContextProps, cartesianContextProps: cartesianContextProps, zAxisContextProps: zAxisContextProps, highlightedProviderProps: highlightedProviderProps, chartsSurfaceProps: chartsSurfaceProps } = (0, $ba777b7acd08cbe0$export$89b2b3e6fbda6258)(props, ref);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7e3726a4b537e82f$export$31c1e6ea05ec4673), (0, $aJx1R.default)({}, drawingProviderProps, {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dfcbbd289db5098e$export$c8d11923ce5dd047), (0, $aJx1R.default)({}, colorProviderProps, {
            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c5c85aa0666bb83f$export$41d46bc18e30c447), (0, $aJx1R.default)({}, seriesContextProps, {
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1b42945ca95acfb3$export$9f8f479612604f8f), (0, $aJx1R.default)({}, cartesianContextProps, {
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8b281edd23d106fe$export$efded640791f3d7c), (0, $aJx1R.default)({}, zAxisContextProps, {
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $4791e4ada5496d01$export$b26a2376c25d222f), {
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $5d5cb2545700647f$export$173f89ed4324027e), (0, $aJx1R.default)({}, highlightedProviderProps, {
                                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $cf2e11b8d493cfa0$export$2880d8f25d9cea27), (0, $aJx1R.default)({}, chartsSurfaceProps, {
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8d0bf2f3d2b10f17$export$769667455a4ecbb4), {}),
                                        children
                                    ]
                                }))
                            }))
                        })
                    }))
                }))
            }))
        }))
    }));
});



var $jawKn = parcelRequire("jawKn");
const $b9ba5426c469e14c$export$43a8c1eafbd09f7a = (0, $jawKn.default)("div", {
    name: "MuiResponsiveChart",
    slot: "Container"
})(({ ownerState: ownerState })=>({
        width: ownerState.width ?? "100%",
        height: ownerState.height ?? "100%",
        display: "flex",
        position: "relative",
        flexGrow: 1,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        "&>svg": {
            width: "100%",
            height: "100%"
        }
    }));



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


const $394dea9e757326bb$export$b4f1fb90899ffa61 = (inWidth, inHeight)=>{
    const displayError = $exYeM.useRef(false);
    const rootRef = $exYeM.useRef(null);
    const [width, setWidth] = $exYeM.useState(0);
    const [height, setHeight] = $exYeM.useState(0);
    // Adaptation of the `computeSizeAndPublishResizeEvent` from the grid.
    const computeSize = $exYeM.useCallback(()=>{
        const mainEl = rootRef?.current;
        if (!mainEl) return;
        const win = (0, $9a18bdeaa27f655f$export$2e2bcd8739ae039)(mainEl);
        const computedStyle = win.getComputedStyle(mainEl);
        const newHeight = Math.floor(parseFloat(computedStyle.height)) || 0;
        const newWidth = Math.floor(parseFloat(computedStyle.width)) || 0;
        setWidth(newWidth);
        setHeight(newHeight);
    }, []);
    $exYeM.useEffect(()=>{
        // Ensure the error detection occurs after the first rendering.
        displayError.current = true;
    }, []);
    (0, $c4c3f9798cb7fddc$export$2e2bcd8739ae039)(()=>{
        if (inWidth !== undefined && inHeight !== undefined) return ()=>{};
        computeSize();
        const elementToObserve = rootRef.current;
        if (typeof ResizeObserver === "undefined") return ()=>{};
        let animationFrame;
        const observer = new ResizeObserver(()=>{
            // See https://github.com/mui/mui-x/issues/8733
            animationFrame = requestAnimationFrame(()=>{
                computeSize();
            });
        });
        if (elementToObserve) observer.observe(elementToObserve);
        return ()=>{
            if (animationFrame) window.cancelAnimationFrame(animationFrame);
            if (elementToObserve) observer.unobserve(elementToObserve);
        };
    }, [
        computeSize,
        inHeight,
        inWidth
    ]);
    return {
        containerRef: rootRef,
        width: inWidth ?? width,
        height: inHeight ?? height
    };
};


const $3d7c0a19dbc6377d$var$_excluded = [
    "width",
    "height",
    "margin",
    "children",
    "series",
    "colors",
    "dataset",
    "desc",
    "disableAxisListener",
    "highlightedItem",
    "onHighlightChange",
    "plugins",
    "sx",
    "title",
    "viewBox",
    "xAxis",
    "yAxis",
    "zAxis"
];
const $3d7c0a19dbc6377d$export$8a777b08ce683e4 = (props, ref)=>{
    const { width: width, height: height, margin: margin, children: children, series: series, colors: colors, dataset: dataset, desc: desc, disableAxisListener: disableAxisListener, highlightedItem: highlightedItem, onHighlightChange: onHighlightChange, plugins: plugins, sx: sx, title: title, viewBox: viewBox, xAxis: xAxis, yAxis: yAxis, zAxis: zAxis } = props, other = (0, $3L80X.default)(props, $3d7c0a19dbc6377d$var$_excluded);
    const { containerRef: containerRef, width: dWidth, height: dHeight } = (0, $394dea9e757326bb$export$b4f1fb90899ffa61)(width, height);
    const resizableChartContainerProps = (0, $aJx1R.default)({}, other, {
        ownerState: {
            width: width,
            height: height
        },
        ref: containerRef
    });
    const chartContainerProps = {
        margin: margin,
        children: children,
        series: series,
        colors: colors,
        dataset: dataset,
        desc: desc,
        disableAxisListener: disableAxisListener,
        highlightedItem: highlightedItem,
        onHighlightChange: onHighlightChange,
        plugins: plugins,
        sx: sx,
        title: title,
        viewBox: viewBox,
        xAxis: xAxis,
        yAxis: yAxis,
        zAxis: zAxis,
        width: dWidth,
        height: dHeight,
        ref: ref
    };
    return {
        hasIntrinsicSize: dWidth && dHeight,
        chartContainerProps: chartContainerProps,
        resizableChartContainerProps: resizableChartContainerProps
    };
};



var $aSiaI = parcelRequire("aSiaI");
const $254a2fff30bc08f0$export$5f31fc7dc92fc998 = /*#__PURE__*/ $exYeM.forwardRef(function ResponsiveChartContainer(props, ref) {
    const { hasIntrinsicSize: hasIntrinsicSize, chartContainerProps: chartContainerProps, resizableChartContainerProps: resizableChartContainerProps } = (0, $3d7c0a19dbc6377d$export$8a777b08ce683e4)(props, ref);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b9ba5426c469e14c$export$43a8c1eafbd09f7a), (0, $aJx1R.default)({}, resizableChartContainerProps, {
        children: hasIntrinsicSize ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $03ff22f4767fa616$export$57a8e701bcb0acd5), (0, $aJx1R.default)({}, chartContainerProps)) : null
    }));
});



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");
parcelRequire("exYeM");



var $2f0D3 = parcelRequire("2f0D3");

var $7PWLt = parcelRequire("7PWLt");



var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
function $725f3a9213718c10$export$9b8905719dbc407a(slot) {
    return (0, $dC5O8.default)("MuiChartsAxis", slot);
}
const $725f3a9213718c10$export$9fae26af7cbff56d = (0, $kY7HX.default)("MuiChartsAxis", [
    "root",
    "line",
    "tickContainer",
    "tick",
    "tickLabel",
    "label",
    "directionX",
    "directionY",
    "top",
    "bottom",
    "left",
    "right"
]);



var $aJx1R = parcelRequire("aJx1R");

var $jawKn = parcelRequire("jawKn");

const $42e938f73d23f5fe$export$3b2f37585eb46f2e = (0, $jawKn.default)("g", {
    name: "MuiChartsAxis",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        [`& .${(0, $725f3a9213718c10$export$9fae26af7cbff56d).tickLabel}`]: (0, $aJx1R.default)({}, theme.typography.caption, {
            fill: (theme.vars || theme).palette.text.primary
        }),
        [`& .${(0, $725f3a9213718c10$export$9fae26af7cbff56d).label}`]: (0, $aJx1R.default)({}, theme.typography.body1, {
            fill: (theme.vars || theme).palette.text.primary
        }),
        [`& .${(0, $725f3a9213718c10$export$9fae26af7cbff56d).line}`]: {
            stroke: (theme.vars || theme).palette.text.primary,
            shapeRendering: "crispEdges",
            strokeWidth: 1
        },
        [`& .${(0, $725f3a9213718c10$export$9fae26af7cbff56d).tick}`]: {
            stroke: (theme.vars || theme).palette.text.primary,
            shapeRendering: "crispEdges"
        }
    }));



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $aJx1R = parcelRequire("aJx1R");

var $aJx1R = parcelRequire("aJx1R");
// DOM utils taken from
// https://github.com/recharts/recharts/blob/master/src/util/DOMUtils.ts
function $97e98ca559c99c16$var$isSsr() {
    return typeof window === "undefined";
}
const $97e98ca559c99c16$var$stringCache = {
    widthCache: {},
    cacheCount: 0
};
const $97e98ca559c99c16$var$MAX_CACHE_NUM = 2000;
const $97e98ca559c99c16$var$SPAN_STYLE = {
    position: "absolute",
    top: "-20000px",
    left: 0,
    padding: 0,
    margin: 0,
    border: "none",
    whiteSpace: "pre"
};
const $97e98ca559c99c16$var$STYLE_LIST = [
    "minWidth",
    "maxWidth",
    "width",
    "minHeight",
    "maxHeight",
    "height",
    "top",
    "left",
    "fontSize",
    "padding",
    "margin",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    "paddingBottom",
    "marginLeft",
    "marginRight",
    "marginTop",
    "marginBottom"
];
const $97e98ca559c99c16$var$MEASUREMENT_SPAN_ID = "mui_measurement_span";
/**
 *
 * @param name CSS property name
 * @param value
 * @returns add 'px' for distance properties
 */ function $97e98ca559c99c16$var$autoCompleteStyle(name, value) {
    if ($97e98ca559c99c16$var$STYLE_LIST.indexOf(name) >= 0 && value === +value) return `${value}px`;
    return value;
}
/**
 *
 * @param text camelcase css property
 * @returns css property
 */ function $97e98ca559c99c16$var$camelToMiddleLine(text) {
    const strs = text.split("");
    const formatStrs = strs.reduce((result, entry)=>{
        if (entry === entry.toUpperCase()) return [
            ...result,
            "-",
            entry.toLowerCase()
        ];
        return [
            ...result,
            entry
        ];
    }, []);
    return formatStrs.join("");
}
const $97e98ca559c99c16$export$9a2c38fb88d8e30 = (style)=>Object.keys(style).sort().reduce((result, s)=>`${result}${$97e98ca559c99c16$var$camelToMiddleLine(s)}:${$97e98ca559c99c16$var$autoCompleteStyle(s, style[s])};`, "");
const $97e98ca559c99c16$export$e5560531f057ad5d = (text, style = {})=>{
    if (text === undefined || text === null || $97e98ca559c99c16$var$isSsr()) return {
        width: 0,
        height: 0
    };
    const str = `${text}`;
    const styleString = $97e98ca559c99c16$export$9a2c38fb88d8e30(style);
    const cacheKey = `${str}-${styleString}`;
    if ($97e98ca559c99c16$var$stringCache.widthCache[cacheKey]) return $97e98ca559c99c16$var$stringCache.widthCache[cacheKey];
    try {
        let measurementSpan = document.getElementById($97e98ca559c99c16$var$MEASUREMENT_SPAN_ID);
        if (measurementSpan === null) {
            measurementSpan = document.createElement("span");
            measurementSpan.setAttribute("id", $97e98ca559c99c16$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute("aria-hidden", "true");
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        const measurementSpanStyle = (0, $aJx1R.default)({}, $97e98ca559c99c16$var$SPAN_STYLE, style);
        Object.keys(measurementSpanStyle).map((styleKey)=>{
            measurementSpan.style[$97e98ca559c99c16$var$camelToMiddleLine(styleKey)] = $97e98ca559c99c16$var$autoCompleteStyle(styleKey, measurementSpanStyle[styleKey]);
            return styleKey;
        });
        measurementSpan.textContent = str;
        const rect = measurementSpan.getBoundingClientRect();
        const result = {
            width: rect.width,
            height: rect.height
        };
        $97e98ca559c99c16$var$stringCache.widthCache[cacheKey] = result;
        if ($97e98ca559c99c16$var$stringCache.cacheCount + 1 > $97e98ca559c99c16$var$MAX_CACHE_NUM) {
            $97e98ca559c99c16$var$stringCache.cacheCount = 0;
            $97e98ca559c99c16$var$stringCache.widthCache = {};
        } else $97e98ca559c99c16$var$stringCache.cacheCount += 1;
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};


function $43abefa5cfeb5cf7$export$86ba3bfd091ebe4f({ style: style, needsComputation: needsComputation, text: text }) {
    return text.split("\n").map((subText)=>(0, $aJx1R.default)({
            text: subText
        }, needsComputation ? (0, $97e98ca559c99c16$export$e5560531f057ad5d)(subText, style) : {
            width: 0,
            height: 0
        }));
}



var $aSiaI = parcelRequire("aSiaI");
const $e3425be3b415617b$var$_excluded = [
    "x",
    "y",
    "style",
    "text",
    "ownerState"
], $e3425be3b415617b$var$_excluded2 = [
    "angle",
    "textAnchor",
    "dominantBaseline"
];
/**
 * Helper component to manage multiline text in SVG
 */ function $e3425be3b415617b$export$a928758019bf149f(props) {
    const { x: x, y: y, style: styleProps, text: text } = props, textProps = (0, $3L80X.default)(props, $e3425be3b415617b$var$_excluded);
    const _ref = styleProps ?? {}, { angle: angle, textAnchor: textAnchor, dominantBaseline: dominantBaseline } = _ref, style = (0, $3L80X.default)(_ref, $e3425be3b415617b$var$_excluded2);
    const wordsByLines = $exYeM.useMemo(()=>(0, $43abefa5cfeb5cf7$export$86ba3bfd091ebe4f)({
            style: style,
            needsComputation: text.includes("\n"),
            text: text
        }), [
        style,
        text
    ]);
    let startDy;
    switch(dominantBaseline){
        case "hanging":
            startDy = 0;
            break;
        case "central":
            startDy = (wordsByLines.length - 1) / 2 * -wordsByLines[0].height;
            break;
        default:
            startDy = (wordsByLines.length - 1) * -wordsByLines[0].height;
            break;
    }
    const transforms = [];
    // if (scaleToFit) {
    //   const lineWidth = wordsByLines[0].width;
    //   transforms.push(`scale(${(isNumber(width as number) ? (width as number) / lineWidth : 1) / lineWidth})`);
    // }
    if (angle) transforms.push(`rotate(${angle}, ${x}, ${y})`);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("text", (0, $aJx1R.default)({}, textProps, {
        transform: transforms.length > 0 ? transforms.join(" ") : undefined,
        x: x,
        y: y,
        textAnchor: textAnchor,
        dominantBaseline: dominantBaseline,
        style: style,
        children: wordsByLines.map((line, index)=>/*#__PURE__*/ (0, $aSiaI.jsx)("tspan", {
                x: x,
                dy: `${index === 0 ? startDy : wordsByLines[0].height}px`,
                dominantBaseline: dominantBaseline // Propagated to fix Safari issue: https://github.com/mui/mui-x/issues/10808
                ,
                children: line.text
            }, index))
    }));
}


const $8636d2b331c184d5$var$ANGLE_APPROX = 5; // Angle (in deg) for which we approximate the rectangle as perfectly horizontal/vertical
let $8636d2b331c184d5$var$warnedOnce = false;
function $8636d2b331c184d5$export$43646a13413d25e0(width, height, angle = 0) {
    const standardAngle = Math.min(Math.abs(angle) % 180, Math.abs(Math.abs(angle) % 180 - 180) % 180); // Map from R to [0, 90]
    if (standardAngle < $8636d2b331c184d5$var$ANGLE_APPROX) // It's nearly horizontal
    return width;
    if (standardAngle > 90 - $8636d2b331c184d5$var$ANGLE_APPROX) // It's nearly vertical
    return height;
    const radAngle = standardAngle * Math.PI / 180;
    const angleSwich = Math.atan2(height, width);
    if (radAngle < angleSwich) return width / Math.cos(radAngle);
    return height / Math.sin(radAngle);
}



var $exYeM = parcelRequire("exYeM");

function $a9d8b024631ef776$export$bce3bfec9f56c837(defer = false) {
    const [mountedState, setMountedState] = $exYeM.useState(false);
    (0, $c4c3f9798cb7fddc$export$2e2bcd8739ae039)(()=>{
        if (!defer) setMountedState(true);
    }, [
        defer
    ]);
    $exYeM.useEffect(()=>{
        if (defer) setMountedState(true);
    }, [
        defer
    ]);
    return mountedState;
}





var $aSiaI = parcelRequire("aSiaI");
const $1f7e64a184e961f0$var$_excluded = [
    "scale",
    "tickNumber",
    "reverse"
];
const $1f7e64a184e961f0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, position: position } = ownerState;
    const slots = {
        root: [
            "root",
            "directionX",
            position
        ],
        line: [
            "line"
        ],
        tickContainer: [
            "tickContainer"
        ],
        tick: [
            "tick"
        ],
        tickLabel: [
            "tickLabel"
        ],
        label: [
            "label"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $725f3a9213718c10$export$9b8905719dbc407a), classes);
};
function $1f7e64a184e961f0$var$addLabelDimension(xTicks, { tickLabelStyle: style, tickLabelInterval: tickLabelInterval, reverse: reverse, isMounted: isMounted }) {
    const withDimension = xTicks.map((tick)=>{
        if (!isMounted || tick.formattedValue === undefined) return (0, $aJx1R.default)({}, tick, {
            width: 0,
            height: 0
        });
        const tickSizes = (0, $43abefa5cfeb5cf7$export$86ba3bfd091ebe4f)({
            style: style,
            needsComputation: true,
            text: tick.formattedValue
        });
        return (0, $aJx1R.default)({}, tick, {
            width: Math.max(...tickSizes.map((size)=>size.width)),
            height: Math.max(tickSizes.length * tickSizes[0].height)
        });
    });
    if (typeof tickLabelInterval === "function") return withDimension.map((item, index)=>(0, $aJx1R.default)({}, item, {
            skipLabel: !tickLabelInterval(item.value, index)
        }));
    // Filter label to avoid overlap
    let currentTextLimit = 0;
    let previousTextLimit = 0;
    const direction = reverse ? -1 : 1;
    return withDimension.map((item, labelIndex)=>{
        const { width: width, offset: offset, labelOffset: labelOffset, height: height } = item;
        const distance = (0, $8636d2b331c184d5$export$43646a13413d25e0)(width, height, style?.angle);
        const textPosition = offset + labelOffset;
        const gapRatio = 1.2; // Ratio applied to the minimal distance to add some margin.
        currentTextLimit = textPosition - direction * (gapRatio * distance) / 2;
        if (labelIndex > 0 && direction * currentTextLimit < direction * previousTextLimit) // Except for the first label, we skip all label that overlap with the last accepted.
        // Notice that the early return prevents `previousTextLimit` from being updated.
        return (0, $aJx1R.default)({}, item, {
            skipLabel: true
        });
        previousTextLimit = textPosition + direction * (gapRatio * distance) / 2;
        return item;
    });
}
const $1f7e64a184e961f0$var$defaultProps = {
    position: "bottom",
    disableLine: false,
    disableTicks: false,
    tickSize: 6
};
/**
 * Demos:
 *
 * - [Axis](https://mui.com/x/react-charts/axis/)
 *
 * API:
 *
 * - [ChartsXAxis API](https://mui.com/x/api/charts/charts-x-axis/)
 */ function $1f7e64a184e961f0$export$7249a852e1fbff8(inProps) {
    const { xAxisIds: xAxisIds, xAxis: xAxis } = (0, $27adb4455fa596cf$export$2785a2cc09fc5c5f)();
    const _xAxis = xAxis[inProps.axisId ?? xAxisIds[0]], { scale: xScale, tickNumber: tickNumber, reverse: reverse } = _xAxis, settings = (0, $3L80X.default)(_xAxis, $1f7e64a184e961f0$var$_excluded);
    const isMounted = (0, $a9d8b024631ef776$export$bce3bfec9f56c837)();
    const themedProps = (0, $7PWLt.default)({
        props: (0, $aJx1R.default)({}, settings, inProps),
        name: "MuiChartsXAxis"
    });
    const defaultizedProps = (0, $aJx1R.default)({}, $1f7e64a184e961f0$var$defaultProps, themedProps);
    const { position: position, disableLine: disableLine, disableTicks: disableTicks, tickLabelStyle: tickLabelStyle, label: label, labelStyle: labelStyle, tickFontSize: tickFontSize, labelFontSize: labelFontSize, tickSize: tickSizeProp, valueFormatter: valueFormatter, slots: slots, slotProps: slotProps, tickInterval: tickInterval, tickLabelInterval: tickLabelInterval, tickPlacement: tickPlacement, tickLabelPlacement: tickLabelPlacement } = defaultizedProps;
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const classes = $1f7e64a184e961f0$var$useUtilityClasses((0, $aJx1R.default)({}, defaultizedProps, {
        theme: theme
    }));
    const { left: left, top: top, width: width, height: height } = (0, $767eebe86d6e6272$export$389be1739214a0a2)();
    const tickSize = disableTicks ? 4 : tickSizeProp;
    const positionSign = position === "bottom" ? 1 : -1;
    const Line = slots?.axisLine ?? "line";
    const Tick = slots?.axisTick ?? "line";
    const TickLabel = slots?.axisTickLabel ?? (0, $e3425be3b415617b$export$a928758019bf149f);
    const Label = slots?.axisLabel ?? (0, $e3425be3b415617b$export$a928758019bf149f);
    const axisTickLabelProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: TickLabel,
        externalSlotProps: slotProps?.axisTickLabel,
        additionalProps: {
            style: (0, $aJx1R.default)({
                textAnchor: "middle",
                dominantBaseline: position === "bottom" ? "hanging" : "auto",
                fontSize: tickFontSize ?? 12
            }, tickLabelStyle)
        },
        className: classes.tickLabel,
        ownerState: {}
    });
    const xTicks = (0, $06d6ba1dd373d3d8$export$99da48a3c6ab2fa1)({
        scale: xScale,
        tickNumber: tickNumber,
        valueFormatter: valueFormatter,
        tickInterval: tickInterval,
        tickPlacement: tickPlacement,
        tickLabelPlacement: tickLabelPlacement
    });
    const xTicksWithDimension = $1f7e64a184e961f0$var$addLabelDimension(xTicks, {
        tickLabelStyle: axisTickLabelProps.style,
        tickLabelInterval: tickLabelInterval,
        reverse: reverse,
        isMounted: isMounted
    });
    const labelRefPoint = {
        x: left + width / 2,
        y: positionSign * (tickSize + 22)
    };
    const axisLabelProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: Label,
        externalSlotProps: slotProps?.axisLabel,
        additionalProps: {
            style: (0, $aJx1R.default)({
                fontSize: labelFontSize ?? 14,
                textAnchor: "middle",
                dominantBaseline: position === "bottom" ? "hanging" : "auto"
            }, labelStyle)
        },
        ownerState: {}
    });
    const domain = xScale.domain();
    if (domain.length === 0 || domain[0] === domain[1]) // Skip axis rendering if
    // - the data is empty (for band and point axis)
    // - No data is associated to the axis (other scale types)
    return null;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $42e938f73d23f5fe$export$3b2f37585eb46f2e), {
        transform: `translate(0, ${position === "bottom" ? top + height : top})`,
        className: classes.root,
        children: [
            !disableLine && /*#__PURE__*/ (0, $aSiaI.jsx)(Line, (0, $aJx1R.default)({
                x1: left,
                x2: left + width,
                className: classes.line
            }, slotProps?.axisLine)),
            xTicksWithDimension.map(({ formattedValue: formattedValue, offset: offset, labelOffset: labelOffset, skipLabel: skipLabel }, index)=>{
                const xTickLabel = labelOffset ?? 0;
                const yTickLabel = positionSign * (tickSize + 3);
                const showTick = offset >= left - 1 && offset <= left + width + 1;
                const showTickLabel = offset + xTickLabel >= left - 1 && offset + xTickLabel <= left + width + 1;
                return /*#__PURE__*/ (0, $aSiaI.jsxs)("g", {
                    transform: `translate(${offset}, 0)`,
                    className: classes.tickContainer,
                    children: [
                        !disableTicks && showTick && /*#__PURE__*/ (0, $aSiaI.jsx)(Tick, (0, $aJx1R.default)({
                            y2: positionSign * tickSize,
                            className: classes.tick
                        }, slotProps?.axisTick)),
                        formattedValue !== undefined && !skipLabel && showTickLabel && /*#__PURE__*/ (0, $aSiaI.jsx)(TickLabel, (0, $aJx1R.default)({
                            x: xTickLabel,
                            y: yTickLabel
                        }, axisTickLabelProps, {
                            text: formattedValue.toString()
                        }))
                    ]
                }, index);
            }),
            label && /*#__PURE__*/ (0, $aSiaI.jsx)("g", {
                className: classes.label,
                children: /*#__PURE__*/ (0, $aSiaI.jsx)(Label, (0, $aJx1R.default)({}, labelRefPoint, axisLabelProps, {
                    text: label
                }))
            })
        ]
    });
}



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");
parcelRequire("exYeM");



var $2f0D3 = parcelRequire("2f0D3");

var $7PWLt = parcelRequire("7PWLt");







var $aSiaI = parcelRequire("aSiaI");
const $076f388a6e39882d$var$_excluded = [
    "scale",
    "tickNumber"
];
const $076f388a6e39882d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, position: position } = ownerState;
    const slots = {
        root: [
            "root",
            "directionY",
            position
        ],
        line: [
            "line"
        ],
        tickContainer: [
            "tickContainer"
        ],
        tick: [
            "tick"
        ],
        tickLabel: [
            "tickLabel"
        ],
        label: [
            "label"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $725f3a9213718c10$export$9b8905719dbc407a), classes);
};
const $076f388a6e39882d$var$defaultProps = {
    position: "left",
    disableLine: false,
    disableTicks: false,
    tickFontSize: 12,
    labelFontSize: 14,
    tickSize: 6
};
/**
 * Demos:
 *
 * - [Axis](https://mui.com/x/react-charts/axis/)
 *
 * API:
 *
 * - [ChartsYAxis API](https://mui.com/x/api/charts/charts-y-axis/)
 */ function $076f388a6e39882d$export$c8f552d0fd2f14ba(inProps) {
    const { yAxisIds: yAxisIds, yAxis: yAxis } = (0, $27adb4455fa596cf$export$2785a2cc09fc5c5f)();
    const _yAxis = yAxis[inProps.axisId ?? yAxisIds[0]], { scale: yScale, tickNumber: tickNumber } = _yAxis, settings = (0, $3L80X.default)(_yAxis, $076f388a6e39882d$var$_excluded);
    const themedProps = (0, $7PWLt.default)({
        props: (0, $aJx1R.default)({}, settings, inProps),
        name: "MuiChartsYAxis"
    });
    const defaultizedProps = (0, $aJx1R.default)({}, $076f388a6e39882d$var$defaultProps, themedProps);
    const { position: position, disableLine: disableLine, disableTicks: disableTicks, tickFontSize: tickFontSize, label: label, labelFontSize: labelFontSize, labelStyle: labelStyle, tickLabelStyle: tickLabelStyle, tickSize: tickSizeProp, valueFormatter: valueFormatter, slots: slots, slotProps: slotProps, tickPlacement: tickPlacement, tickLabelPlacement: tickLabelPlacement, tickInterval: tickInterval, tickLabelInterval: tickLabelInterval } = defaultizedProps;
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === "rtl";
    const classes = $076f388a6e39882d$var$useUtilityClasses((0, $aJx1R.default)({}, defaultizedProps, {
        theme: theme
    }));
    const { left: left, top: top, width: width, height: height } = (0, $767eebe86d6e6272$export$389be1739214a0a2)();
    const tickSize = disableTicks ? 4 : tickSizeProp;
    const yTicks = (0, $06d6ba1dd373d3d8$export$99da48a3c6ab2fa1)({
        scale: yScale,
        tickNumber: tickNumber,
        valueFormatter: valueFormatter,
        tickPlacement: tickPlacement,
        tickLabelPlacement: tickLabelPlacement,
        tickInterval: tickInterval
    });
    const positionSign = position === "right" ? 1 : -1;
    const labelRefPoint = {
        x: positionSign * (tickFontSize + tickSize + 10),
        y: top + height / 2
    };
    const Line = slots?.axisLine ?? "line";
    const Tick = slots?.axisTick ?? "line";
    const TickLabel = slots?.axisTickLabel ?? (0, $e3425be3b415617b$export$a928758019bf149f);
    const Label = slots?.axisLabel ?? (0, $e3425be3b415617b$export$a928758019bf149f);
    const revertAnchor = !isRTL && position === "right" || isRTL && position !== "right";
    const axisTickLabelProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: TickLabel,
        externalSlotProps: slotProps?.axisTickLabel,
        additionalProps: {
            style: (0, $aJx1R.default)({
                fontSize: tickFontSize,
                textAnchor: revertAnchor ? "start" : "end",
                dominantBaseline: "central"
            }, tickLabelStyle)
        },
        className: classes.tickLabel,
        ownerState: {}
    });
    const axisLabelProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: Label,
        externalSlotProps: slotProps?.axisLabel,
        additionalProps: {
            style: (0, $aJx1R.default)({
                fontSize: labelFontSize,
                angle: positionSign * 90,
                textAnchor: "middle",
                dominantBaseline: "auto"
            }, labelStyle)
        },
        ownerState: {}
    });
    const lineSlotProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: Line,
        externalSlotProps: slotProps?.axisLine,
        additionalProps: {
            strokeLinecap: "square"
        },
        ownerState: {}
    });
    const domain = yScale.domain();
    if (domain.length === 0 || domain[0] === domain[1]) // Skip axis rendering if
    // - the data is empty (for band and point axis)
    // - No data is associated to the axis (other scale types)
    return null;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $42e938f73d23f5fe$export$3b2f37585eb46f2e), {
        transform: `translate(${position === "right" ? left + width : left}, 0)`,
        className: classes.root,
        children: [
            !disableLine && /*#__PURE__*/ (0, $aSiaI.jsx)(Line, (0, $aJx1R.default)({
                y1: top,
                y2: top + height,
                className: classes.line
            }, lineSlotProps)),
            yTicks.map(({ formattedValue: formattedValue, offset: offset, labelOffset: labelOffset, value: value }, index)=>{
                const xTickLabel = positionSign * (tickSize + 2);
                const yTickLabel = labelOffset;
                const skipLabel = typeof tickLabelInterval === "function" && !tickLabelInterval?.(value, index);
                const showLabel = offset >= top - 1 && offset <= height + top + 1;
                if (!showLabel) return null;
                return /*#__PURE__*/ (0, $aSiaI.jsxs)("g", {
                    transform: `translate(0, ${offset})`,
                    className: classes.tickContainer,
                    children: [
                        !disableTicks && /*#__PURE__*/ (0, $aSiaI.jsx)(Tick, (0, $aJx1R.default)({
                            x2: positionSign * tickSize,
                            className: classes.tick
                        }, slotProps?.axisTick)),
                        formattedValue !== undefined && !skipLabel && /*#__PURE__*/ (0, $aSiaI.jsx)(TickLabel, (0, $aJx1R.default)({
                            x: xTickLabel,
                            y: yTickLabel,
                            text: formattedValue.toString()
                        }, axisTickLabelProps))
                    ]
                }, index);
            }),
            label && /*#__PURE__*/ (0, $aSiaI.jsx)("g", {
                className: classes.label,
                children: /*#__PURE__*/ (0, $aSiaI.jsx)(Label, (0, $aJx1R.default)({}, labelRefPoint, axisLabelProps, {
                    text: label
                }))
            })
        ]
    });
}



var $aSiaI = parcelRequire("aSiaI");
const $98aeda3d167bbb73$var$getAxisId = (propsValue, defaultAxisId)=>{
    if (propsValue == null) return null;
    if (typeof propsValue === "object") return propsValue.axisId ?? defaultAxisId ?? null;
    return propsValue;
};
const $98aeda3d167bbb73$var$mergeProps = (axisConfig, slots, slotProps)=>{
    return typeof axisConfig === "object" ? (0, $aJx1R.default)({}, axisConfig, {
        slots: (0, $aJx1R.default)({}, slots, axisConfig?.slots),
        slotProps: (0, $aJx1R.default)({}, slotProps, axisConfig?.slotProps)
    }) : {
        slots: slots,
        slotProps: slotProps
    };
};
/**
 * Demos:
 *
 * - [Axis](https://mui.com/x/react-charts/axis/)
 *
 * API:
 *
 * - [ChartsAxis API](https://mui.com/x/api/charts/charts-axis/)
 */ function $98aeda3d167bbb73$export$2423790cc2b08d6f(props) {
    const { topAxis: topAxis, leftAxis: leftAxis, rightAxis: rightAxis, bottomAxis: bottomAxis, slots: slots, slotProps: slotProps } = props;
    const { xAxis: xAxis, xAxisIds: xAxisIds, yAxis: yAxis, yAxisIds: yAxisIds } = (0, $27adb4455fa596cf$export$2785a2cc09fc5c5f)();
    // TODO: use for plotting line without ticks or any thing
    // const drawingArea = React.useContext(DrawingContext);
    const leftId = $98aeda3d167bbb73$var$getAxisId(leftAxis === undefined ? yAxisIds[0] : leftAxis, yAxisIds[0]);
    const bottomId = $98aeda3d167bbb73$var$getAxisId(bottomAxis === undefined ? xAxisIds[0] : bottomAxis, xAxisIds[0]);
    const topId = $98aeda3d167bbb73$var$getAxisId(topAxis, xAxisIds[0]);
    const rightId = $98aeda3d167bbb73$var$getAxisId(rightAxis, yAxisIds[0]);
    if (topId !== null && !xAxis[topId]) throw Error([
        `MUI X Charts: id used for top axis "${topId}" is not defined.`,
        `Available ids are: ${xAxisIds.join(", ")}.`
    ].join("\n"));
    if (leftId !== null && !yAxis[leftId]) throw Error([
        `MUI X Charts: id used for left axis "${leftId}" is not defined.`,
        `Available ids are: ${yAxisIds.join(", ")}.`
    ].join("\n"));
    if (rightId !== null && !yAxis[rightId]) throw Error([
        `MUI X Charts: id used for right axis "${rightId}" is not defined.`,
        `Available ids are: ${yAxisIds.join(", ")}.`
    ].join("\n"));
    if (bottomId !== null && !xAxis[bottomId]) throw Error([
        `MUI X Charts: id used for bottom axis "${bottomId}" is not defined.`,
        `Available ids are: ${xAxisIds.join(", ")}.`
    ].join("\n"));
    const topAxisProps = $98aeda3d167bbb73$var$mergeProps(topAxis, slots, slotProps);
    const bottomAxisProps = $98aeda3d167bbb73$var$mergeProps(bottomAxis, slots, slotProps);
    const leftAxisProps = $98aeda3d167bbb73$var$mergeProps(leftAxis, slots, slotProps);
    const rightAxisProps = $98aeda3d167bbb73$var$mergeProps(rightAxis, slots, slotProps);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
        children: [
            topId && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1f7e64a184e961f0$export$7249a852e1fbff8), (0, $aJx1R.default)({}, topAxisProps, {
                position: "top",
                axisId: topId
            })),
            bottomId && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1f7e64a184e961f0$export$7249a852e1fbff8), (0, $aJx1R.default)({}, bottomAxisProps, {
                position: "bottom",
                axisId: bottomId
            })),
            leftId && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $076f388a6e39882d$export$c8f552d0fd2f14ba), (0, $aJx1R.default)({}, leftAxisProps, {
                position: "left",
                axisId: leftId
            })),
            rightId && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $076f388a6e39882d$export$c8f552d0fd2f14ba), (0, $aJx1R.default)({}, rightAxisProps, {
                position: "right",
                axisId: rightId
            }))
        ]
    });
}



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $2f0D3 = parcelRequire("2f0D3");

var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");


var $exYeM = parcelRequire("exYeM");



var $aSiaI = parcelRequire("aSiaI");
"use client";
/**
 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
 *
 * This component can be useful in a variety of situations:
 *
 * *   Escape hatch for broken dependencies not supporting SSR.
 * *   Improve the time-to-first paint on the client by only rendering above the fold.
 * *   Reduce the rendering time on the server.
 * *   Under too heavy server load, you can turn on service degradation.
 *
 * Demos:
 *
 * - [No SSR](https://mui.com/base-ui/react-no-ssr/)
 *
 * API:
 *
 * - [NoSsr API](https://mui.com/base-ui/react-no-ssr/components-api/#no-ssr)
 */ function $c27d28e494a69d08$export$24fbf80485c43cdb(props) {
    const { children: children, defer: defer = false, fallback: fallback = null } = props;
    const [mountedState, setMountedState] = $exYeM.useState(false);
    (0, $c4c3f9798cb7fddc$export$2e2bcd8739ae039)(()=>{
        if (!defer) setMountedState(true);
    }, [
        defer
    ]);
    $exYeM.useEffect(()=>{
        if (defer) setMountedState(true);
    }, [
        defer
    ]);
    // We need the Fragment here to force react-docgen to recognise NoSsr as a component.
    return /*#__PURE__*/ (0, $aSiaI.jsx)($exYeM.Fragment, {
        children: mountedState ? children : fallback
    });
}





var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");

function $730398f6bf2a49fe$export$d4b7b7371f0d81ec(mousePosition) {
    if (mousePosition === null) return {
        getBoundingClientRect: ()=>({
                width: 0,
                height: 0,
                x: 0,
                y: 0,
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                toJSON: ()=>""
            })
    };
    const { x: x, y: y } = mousePosition;
    const boundingBox = {
        width: 0,
        height: 0,
        x: x,
        y: y,
        top: y,
        right: x,
        bottom: y,
        left: x
    };
    return {
        getBoundingClientRect: ()=>(0, $aJx1R.default)({}, boundingBox, {
                toJSON: ()=>JSON.stringify(boundingBox)
            })
    };
}
function $730398f6bf2a49fe$export$8e1ecadc806b01be() {
    const svgRef = (0, $ae025d5d266ffedb$export$839818ed0cc5fa73)();
    // Use a ref to avoid rerendering on every mousemove event.
    const [mousePosition, setMousePosition] = $exYeM.useState(null);
    $exYeM.useEffect(()=>{
        const element = svgRef.current;
        if (element === null) return ()=>{};
        const handleOut = ()=>{
            setMousePosition(null);
        };
        const handleMove = (event)=>{
            setMousePosition({
                x: event.clientX,
                y: event.clientY,
                height: event.height,
                pointerType: event.pointerType
            });
        };
        element.addEventListener("pointerdown", handleMove);
        element.addEventListener("pointermove", handleMove);
        element.addEventListener("pointerup", handleOut);
        return ()=>{
            element.removeEventListener("pointerdown", handleMove);
            element.removeEventListener("pointermove", handleMove);
            element.removeEventListener("pointerup", handleOut);
        };
    }, [
        svgRef
    ]);
    return mousePosition;
}
function $730398f6bf2a49fe$export$7956c823ff9eda51(trigger, displayedData) {
    if (trigger === "item") return displayedData !== null;
    const hasAxisXData = displayedData.x !== null;
    const hasAxisYData = displayedData.y !== null;
    return hasAxisXData || hasAxisYData;
}
function $730398f6bf2a49fe$export$a4d939afe4ef2e5f(v) {
    if (v instanceof Date) return v.toUTCString();
    return v.toLocaleString();
}



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $aJx1R = parcelRequire("aJx1R");
parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");

var $jawKn = parcelRequire("jawKn");


var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
function $e8384b9e4a67e37b$export$ce5b27bcf797dfe(slot) {
    return (0, $dC5O8.default)("MuiChartsTooltip", slot);
}
const $e8384b9e4a67e37b$export$b5ae871d141649c9 = (0, $kY7HX.default)("MuiChartsTooltip", [
    "root",
    "table",
    "row",
    "cell",
    "mark",
    "markCell",
    "labelCell",
    "valueCell"
]);


const $f0d37b5b47b03ba2$export$7b5d07ee7a85aced = (0, $jawKn.default)("div", {
    name: "MuiChartsTooltip",
    slot: "Container"
})(({ theme: theme })=>({
        boxShadow: theme.shadows[1],
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow"),
        borderRadius: theme.shape.borderRadius
    }));
const $f0d37b5b47b03ba2$export$f52f18b5b3229424 = (0, $jawKn.default)("table", {
    name: "MuiChartsTooltip",
    slot: "Table"
})(({ theme: theme })=>({
        borderSpacing: 0,
        "& thead td": {
            borderBottom: `solid ${(theme.vars || theme).palette.divider} 1px`
        }
    }));
const $f0d37b5b47b03ba2$export$4a107d2c017058e2 = (0, $jawKn.default)("tr", {
    name: "MuiChartsTooltip",
    slot: "Row"
})(({ theme: theme })=>({
        "tr:first-of-type& td": {
            paddingTop: theme.spacing(1)
        },
        "tr:last-of-type& td": {
            paddingBottom: theme.spacing(1)
        }
    }));
const $f0d37b5b47b03ba2$export$a226896f9df34839 = (0, $jawKn.default)("td", {
    name: "MuiChartsTooltip",
    slot: "Cell"
})(({ theme: theme })=>({
        verticalAlign: "middle",
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $e8384b9e4a67e37b$export$b5ae871d141649c9).labelCell}`]: {
            paddingLeft: theme.spacing(1)
        },
        [`&.${(0, $e8384b9e4a67e37b$export$b5ae871d141649c9).valueCell}`]: {
            paddingLeft: theme.spacing(4),
            color: (theme.vars || theme).palette.text.primary
        },
        "td:first-of-type&": {
            paddingLeft: theme.spacing(2)
        },
        "td:last-of-type&": {
            paddingRight: theme.spacing(2)
        }
    }));
const $f0d37b5b47b03ba2$export$5c802cf9f436bc34 = (0, $jawKn.default)("div", {
    name: "MuiChartsTooltip",
    slot: "Mark",
    shouldForwardProp: (prop)=>(0, $b601c8f3fa89e057$export$3ba67b570e26eea0)(prop) && prop !== "color"
})(({ theme: theme, color: color })=>({
        width: theme.spacing(1),
        height: theme.spacing(1),
        borderRadius: "50%",
        boxShadow: theme.shadows[1],
        backgroundColor: color,
        borderColor: (theme.vars || theme).palette.background.paper,
        border: `solid ${(theme.vars || theme).palette.background.paper} ${theme.spacing(0.25)}`,
        boxSizing: "content-box"
    }));




var $aSiaI = parcelRequire("aSiaI");
function $8dc5e067647a9149$export$e82e84c0be165214(props) {
    const { series: series, itemData: itemData, sx: sx, classes: classes, getColor: getColor } = props;
    if (itemData.dataIndex === undefined || !series.data[itemData.dataIndex]) return null;
    const { displayedLabel: displayedLabel, color: color } = series.type === "pie" ? {
        color: getColor(itemData.dataIndex),
        displayedLabel: (0, $218fa0efd181b45d$export$236350842f3cd9bc)(series.data[itemData.dataIndex].label, "tooltip")
    } : {
        color: getColor(itemData.dataIndex),
        displayedLabel: (0, $218fa0efd181b45d$export$236350842f3cd9bc)(series.label, "tooltip")
    };
    const value = series.type === "pie" ? (0, $aJx1R.default)({}, series.data[itemData.dataIndex], {
        label: (0, $218fa0efd181b45d$export$236350842f3cd9bc)(series.data[itemData.dataIndex].label, "tooltip")
    }) : series.data[itemData.dataIndex];
    const formattedValue = series.valueFormatter?.(value, {
        dataIndex: itemData.dataIndex
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f0d37b5b47b03ba2$export$7b5d07ee7a85aced), {
        sx: sx,
        className: classes.root,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f0d37b5b47b03ba2$export$f52f18b5b3229424), {
            className: classes.table,
            children: /*#__PURE__*/ (0, $aSiaI.jsx)("tbody", {
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $f0d37b5b47b03ba2$export$4a107d2c017058e2), {
                    className: classes.row,
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f0d37b5b47b03ba2$export$a226896f9df34839), {
                            className: (0, $4qr5a.default)(classes.markCell, classes.cell),
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f0d37b5b47b03ba2$export$5c802cf9f436bc34), {
                                color: color,
                                className: classes.mark
                            })
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f0d37b5b47b03ba2$export$a226896f9df34839), {
                            className: (0, $4qr5a.default)(classes.labelCell, classes.cell),
                            children: displayedLabel
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f0d37b5b47b03ba2$export$a226896f9df34839), {
                            className: (0, $4qr5a.default)(classes.valueCell, classes.cell),
                            children: formattedValue
                        })
                    ]
                })
            })
        })
    });
}





var $exYeM = parcelRequire("exYeM");

function $8dd9df3de89a5aab$export$a6a725758253c1ff(seriesType) {
    const colorProcessors = $exYeM.useContext((0, $dfcbbd289db5098e$export$f8ec96023ad51b86));
    if (!seriesType) return colorProcessors;
    return colorProcessors[seriesType];
}




var $aSiaI = parcelRequire("aSiaI");
/**
 * @ignore - internal component.
 */ function $e0c13e56d595e68d$export$f4c7c58862ed765e(props) {
    const { content: content, itemData: itemData, sx: sx, classes: classes, contentProps: contentProps } = props;
    const series = (0, $ba69253362075717$export$23a245cc02c91dfa)()[itemData.type].series[itemData.seriesId];
    const { xAxis: xAxis, yAxis: yAxis, xAxisIds: xAxisIds, yAxisIds: yAxisIds } = (0, $27adb4455fa596cf$export$2785a2cc09fc5c5f)();
    const { zAxis: zAxis, zAxisIds: zAxisIds } = $exYeM.useContext((0, $8b281edd23d106fe$export$7dd085f121653b41));
    const colorProcessors = (0, $8dd9df3de89a5aab$export$a6a725758253c1ff)();
    const xAxisKey = series.xAxisKey ?? xAxisIds[0];
    const yAxisKey = series.yAxisKey ?? yAxisIds[0];
    const zAxisKey = series.zAxisKey ?? zAxisIds[0];
    const getColor = colorProcessors[series.type]?.(series, xAxisKey && xAxis[xAxisKey], yAxisKey && yAxis[yAxisKey], zAxisKey && zAxis[zAxisKey]) ?? (()=>"");
    const Content = content ?? (0, $8dc5e067647a9149$export$e82e84c0be165214);
    const chartTooltipContentProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: Content,
        externalSlotProps: contentProps,
        additionalProps: {
            itemData: itemData,
            series: series,
            sx: sx,
            classes: classes,
            getColor: getColor
        },
        ownerState: {}
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)(Content, (0, $aJx1R.default)({}, chartTooltipContentProps));
}



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


parcelRequire("exYeM");


var $4qr5a = parcelRequire("4qr5a");




let $25ab8e3183cad035$var$instance;
class $25ab8e3183cad035$var$CartesianSeriesTypes {
    constructor(){
        this.types = new Set();
        if ($25ab8e3183cad035$var$instance) throw new Error("You can only create one instance!");
        $25ab8e3183cad035$var$instance = this.types;
    }
    addType(value) {
        this.types.add(value);
    }
    getTypes() {
        return this.types;
    }
}
const $25ab8e3183cad035$export$d8e758037cb28ccd = new $25ab8e3183cad035$var$CartesianSeriesTypes();
$25ab8e3183cad035$export$d8e758037cb28ccd.addType("bar");
$25ab8e3183cad035$export$d8e758037cb28ccd.addType("line");
$25ab8e3183cad035$export$d8e758037cb28ccd.addType("scatter");


function $62fdbe7922f1fc6a$export$c2530dd1b663d12f(seriesType) {
    return (0, $25ab8e3183cad035$export$d8e758037cb28ccd).getTypes().has(seriesType);
}
function $62fdbe7922f1fc6a$export$7f38979a990c3a53(series) {
    return $62fdbe7922f1fc6a$export$c2530dd1b663d12f(series.type);
}



var $aSiaI = parcelRequire("aSiaI");
function $244224f764b45df2$export$cda6e65f58619a7a(props) {
    const { series: series, axis: axis, dataIndex: dataIndex, axisValue: axisValue, sx: sx, classes: classes } = props;
    if (dataIndex == null) return null;
    const axisFormatter = axis.valueFormatter ?? ((v)=>axis.scaleType === "utc" ? (0, $730398f6bf2a49fe$export$a4d939afe4ef2e5f)(v) : v.toLocaleString());
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f0d37b5b47b03ba2$export$7b5d07ee7a85aced), {
        sx: sx,
        className: classes.root,
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $f0d37b5b47b03ba2$export$f52f18b5b3229424), {
            className: classes.table,
            children: [
                axisValue != null && !axis.hideTooltip && /*#__PURE__*/ (0, $aSiaI.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f0d37b5b47b03ba2$export$4a107d2c017058e2), {
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f0d37b5b47b03ba2$export$a226896f9df34839), {
                            colSpan: 3,
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                                children: axisFormatter(axisValue, {
                                    location: "tooltip"
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)("tbody", {
                    children: series.filter((0, $62fdbe7922f1fc6a$export$7f38979a990c3a53)).map(({ id: id, label: label, valueFormatter: valueFormatter, data: data, getColor: getColor })=>{
                        // @ts-ignore
                        const formattedValue = valueFormatter(data[dataIndex] ?? null, {
                            dataIndex: dataIndex
                        });
                        if (formattedValue == null) return null;
                        const formattedLabel = (0, $218fa0efd181b45d$export$236350842f3cd9bc)(label, "tooltip");
                        const color = getColor(dataIndex);
                        return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $f0d37b5b47b03ba2$export$4a107d2c017058e2), {
                            className: classes.row,
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f0d37b5b47b03ba2$export$a226896f9df34839), {
                                    className: (0, $4qr5a.default)(classes.markCell, classes.cell),
                                    children: color && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f0d37b5b47b03ba2$export$5c802cf9f436bc34), {
                                        color: color,
                                        className: classes.mark
                                    })
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f0d37b5b47b03ba2$export$a226896f9df34839), {
                                    className: (0, $4qr5a.default)(classes.labelCell, classes.cell),
                                    children: formattedLabel ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                                        children: formattedLabel
                                    }) : null
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f0d37b5b47b03ba2$export$a226896f9df34839), {
                                    className: (0, $4qr5a.default)(classes.valueCell, classes.cell),
                                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                                        children: formattedValue
                                    })
                                })
                            ]
                        }, id);
                    })
                })
            ]
        })
    });
}







var $aSiaI = parcelRequire("aSiaI");
/**
 * @ignore - internal component.
 */ function $555b1938ac06485f$export$1b7d100ba8b47325(props) {
    const { content: content, contentProps: contentProps, axisData: axisData, sx: sx, classes: classes } = props;
    const isXaxis = (axisData.x && axisData.x.index) !== undefined;
    const dataIndex = isXaxis ? axisData.x && axisData.x.index : axisData.y && axisData.y.index;
    const axisValue = isXaxis ? axisData.x && axisData.x.value : axisData.y && axisData.y.value;
    const { xAxisIds: xAxisIds, xAxis: xAxis, yAxisIds: yAxisIds, yAxis: yAxis } = (0, $27adb4455fa596cf$export$2785a2cc09fc5c5f)();
    const { zAxisIds: zAxisIds, zAxis: zAxis } = $exYeM.useContext((0, $8b281edd23d106fe$export$7dd085f121653b41));
    const series = (0, $ba69253362075717$export$23a245cc02c91dfa)();
    const colorProcessors = (0, $8dd9df3de89a5aab$export$a6a725758253c1ff)();
    const USED_AXIS_ID = isXaxis ? xAxisIds[0] : yAxisIds[0];
    const relevantSeries = $exYeM.useMemo(()=>{
        const rep = [];
        Object.keys(series).filter((0, $62fdbe7922f1fc6a$export$c2530dd1b663d12f)).forEach((seriesType)=>{
            series[seriesType].seriesOrder.forEach((seriesId)=>{
                const item = series[seriesType].series[seriesId];
                const axisKey = isXaxis ? item.xAxisKey : item.yAxisKey;
                if (axisKey === undefined || axisKey === USED_AXIS_ID) {
                    const seriesToAdd = series[seriesType].series[seriesId];
                    const zAxisKey = seriesToAdd.zAxisKey ?? zAxisIds[0];
                    const getColor = colorProcessors[seriesType]?.(seriesToAdd, xAxis[seriesToAdd.xAxisKey ?? xAxisIds[0]], yAxis[seriesToAdd.yAxisKey ?? yAxisIds[0]], zAxisKey && zAxis[zAxisKey]) ?? (()=>"");
                    rep.push((0, $aJx1R.default)({}, seriesToAdd, {
                        getColor: getColor
                    }));
                }
            });
        });
        return rep;
    }, [
        USED_AXIS_ID,
        colorProcessors,
        isXaxis,
        series,
        xAxis,
        xAxisIds,
        yAxis,
        yAxisIds,
        zAxis,
        zAxisIds
    ]);
    const relevantAxis = $exYeM.useMemo(()=>{
        return isXaxis ? xAxis[USED_AXIS_ID] : yAxis[USED_AXIS_ID];
    }, [
        USED_AXIS_ID,
        isXaxis,
        xAxis,
        yAxis
    ]);
    const Content = content ?? (0, $244224f764b45df2$export$cda6e65f58619a7a);
    const chartTooltipContentProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: Content,
        externalSlotProps: contentProps,
        additionalProps: {
            axisData: axisData,
            series: relevantSeries,
            axis: relevantAxis,
            dataIndex: dataIndex,
            axisValue: axisValue,
            sx: sx,
            classes: classes
        },
        ownerState: {}
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)(Content, (0, $aJx1R.default)({}, chartTooltipContentProps));
}




var $aSiaI = parcelRequire("aSiaI");
const $e0f2ff2fe9ecd767$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        table: [
            "table"
        ],
        row: [
            "row"
        ],
        cell: [
            "cell"
        ],
        mark: [
            "mark"
        ],
        markCell: [
            "markCell"
        ],
        labelCell: [
            "labelCell"
        ],
        valueCell: [
            "valueCell"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $e8384b9e4a67e37b$export$ce5b27bcf797dfe), classes);
};
const $e0f2ff2fe9ecd767$var$ChartsTooltipRoot = (0, $jawKn.default)((0, $52cebc1858d4dde2$export$badac9ada3a0bdf9), {
    name: "MuiChartsTooltip",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        pointerEvents: "none",
        zIndex: theme.zIndex.modal
    }));
/**
 * Demos:
 *
 * - [ChartsTooltip](https://mui.com/x/react-charts/tooltip/)
 *
 * API:
 *
 * - [ChartsTooltip API](https://mui.com/x/api/charts/charts-tool-tip/)
 */ function $e0f2ff2fe9ecd767$export$638edc2f884926bd(props) {
    const themeProps = (0, $7PWLt.default)({
        props: props,
        name: "MuiChartsTooltip"
    });
    const { trigger: trigger = "axis", itemContent: itemContent, axisContent: axisContent, slots: slots, slotProps: slotProps } = themeProps;
    const mousePosition = (0, $730398f6bf2a49fe$export$8e1ecadc806b01be)();
    const { item: item, axis: axis } = $exYeM.useContext((0, $4791e4ada5496d01$export$d6ef105978afa6a));
    const displayedData = trigger === "item" ? item : axis;
    const tooltipHasData = (0, $730398f6bf2a49fe$export$7956c823ff9eda51)(trigger, displayedData);
    const popperOpen = mousePosition !== null && tooltipHasData;
    const classes = $e0f2ff2fe9ecd767$var$useUtilityClasses({
        classes: themeProps.classes
    });
    const PopperComponent = slots?.popper ?? $e0f2ff2fe9ecd767$var$ChartsTooltipRoot;
    const popperProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: PopperComponent,
        externalSlotProps: slotProps?.popper,
        additionalProps: {
            open: popperOpen,
            placement: mousePosition?.pointerType === "mouse" ? "right-start" : "top",
            anchorEl: (0, $730398f6bf2a49fe$export$d4b7b7371f0d81ec)(mousePosition),
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            mousePosition?.pointerType === "touch" ? 40 - mousePosition.height : 0
                        ]
                    }
                }
            ]
        },
        ownerState: {}
    });
    if (trigger === "none") return null;
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c27d28e494a69d08$export$24fbf80485c43cdb), {
        children: popperOpen && /*#__PURE__*/ (0, $aSiaI.jsx)(PopperComponent, (0, $aJx1R.default)({}, popperProps, {
            children: trigger === "item" ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e0c13e56d595e68d$export$f4c7c58862ed765e), {
                itemData: displayedData,
                content: slots?.itemContent ?? itemContent,
                contentProps: slotProps?.itemContent,
                sx: {
                    mx: 2
                },
                classes: classes
            }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $555b1938ac06485f$export$1b7d100ba8b47325), {
                axisData: displayedData,
                content: slots?.axisContent ?? axisContent,
                contentProps: slotProps?.axisContent,
                sx: {
                    mx: 2
                },
                classes: classes
            })
        }))
    });
}



var $aJx1R = parcelRequire("aJx1R");
parcelRequire("exYeM");



var $2f0D3 = parcelRequire("2f0D3");

var $7PWLt = parcelRequire("7PWLt");

const $395f208e64bb569d$var$legendGetter = (params)=>{
    const { seriesOrder: seriesOrder, series: series } = params;
    return seriesOrder.reduce((acc, seriesId)=>{
        const formattedLabel = (0, $218fa0efd181b45d$export$236350842f3cd9bc)(series[seriesId].label, "legend");
        if (formattedLabel === undefined) return acc;
        acc.push({
            color: series[seriesId].color,
            label: formattedLabel,
            id: seriesId
        });
        return acc;
    }, []);
};
var $395f208e64bb569d$export$2e2bcd8739ae039 = $395f208e64bb569d$var$legendGetter;



const $d2d8cda9f18b016c$var$legendGetter = (params)=>{
    const { seriesOrder: seriesOrder, series: series } = params;
    return seriesOrder.reduce((acc, seriesId)=>{
        const formattedLabel = (0, $218fa0efd181b45d$export$236350842f3cd9bc)(series[seriesId].label, "legend");
        if (formattedLabel === undefined) return acc;
        acc.push({
            color: series[seriesId].color,
            label: formattedLabel,
            id: seriesId
        });
        return acc;
    }, []);
};
var $d2d8cda9f18b016c$export$2e2bcd8739ae039 = $d2d8cda9f18b016c$var$legendGetter;



const $57f1c8b7700ef24f$var$legendGetter = (params)=>{
    const { seriesOrder: seriesOrder, series: series } = params;
    return seriesOrder.reduce((acc, seriesId)=>{
        const formattedLabel = (0, $218fa0efd181b45d$export$236350842f3cd9bc)(series[seriesId].label, "legend");
        if (formattedLabel === undefined) return acc;
        acc.push({
            color: series[seriesId].color,
            label: formattedLabel,
            id: seriesId
        });
        return acc;
    }, []);
};
var $57f1c8b7700ef24f$export$2e2bcd8739ae039 = $57f1c8b7700ef24f$var$legendGetter;



const $2d7d8654c79f2ce1$var$legendGetter = (params)=>{
    const { seriesOrder: seriesOrder, series: series } = params;
    return seriesOrder.reduce((acc, seriesId)=>{
        series[seriesId].data.forEach((item)=>{
            const formattedLabel = (0, $218fa0efd181b45d$export$236350842f3cd9bc)(item.label, "legend");
            if (formattedLabel === undefined) return;
            acc.push({
                color: item.color,
                label: formattedLabel,
                id: item.id
            });
        });
        return acc;
    }, []);
};
var $2d7d8654c79f2ce1$export$2e2bcd8739ae039 = $2d7d8654c79f2ce1$var$legendGetter;


const $fde0f43f7268f224$var$legendGetter = {
    bar: (0, $395f208e64bb569d$export$2e2bcd8739ae039),
    scatter: (0, $d2d8cda9f18b016c$export$2e2bcd8739ae039),
    line: (0, $57f1c8b7700ef24f$export$2e2bcd8739ae039),
    pie: (0, $2d7d8654c79f2ce1$export$2e2bcd8739ae039)
};
function $fde0f43f7268f224$export$9aa8b92502563cc4(series) {
    return Object.keys(series).flatMap((seriesType)=>{
        const getter = $fde0f43f7268f224$var$legendGetter[seriesType];
        return getter === undefined ? [] : getter(series[seriesType]);
    });
}



var $dC5O8 = parcelRequire("dC5O8");
var $kY7HX = parcelRequire("kY7HX");
function $d7dcae8fd8e27627$export$9c99214d2a5cbfe4(slot) {
    return (0, $dC5O8.default)("MuiChartsLegend", slot);
}
const $d7dcae8fd8e27627$export$562c92ffc54f00c = (0, $kY7HX.default)("MuiChartsLegend", [
    "root",
    "series",
    "mark",
    "label",
    "column",
    "row"
]);



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");
parcelRequire("exYeM");


var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $jawKn = parcelRequire("jawKn");



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");
const $51c9a53aa0060966$var$_excluded = [
    "label"
];
function $51c9a53aa0060966$export$20c684af33ddb1e(itemsToDisplay, getItemSpace, labelStyle, direction, availableWidth, availableHeight, itemGap) {
    // Start at 0, 0. Will be modified later by padding and position.
    let x = 0;
    let y = 0;
    // total values used to align legend later.
    let totalWidthUsed = 0;
    let totalHeightUsed = 0;
    let rowIndex = 0;
    const rowMaxHeight = [
        0
    ];
    const seriesWithRawPosition = itemsToDisplay.map((_ref)=>{
        let { label: label } = _ref, other = (0, $3L80X.default)(_ref, $51c9a53aa0060966$var$_excluded);
        const itemSpace = getItemSpace(label, labelStyle);
        const rep = (0, $aJx1R.default)({}, other, {
            label: label,
            positionX: x,
            positionY: y,
            innerHeight: itemSpace.innerHeight,
            innerWidth: itemSpace.innerWidth,
            outerHeight: itemSpace.outerHeight,
            outerWidth: itemSpace.outerWidth,
            rowIndex: rowIndex
        });
        if (direction === "row") {
            if (x + itemSpace.innerWidth > availableWidth) {
                // This legend item would create overflow along the x-axis, so we start a new row.
                x = 0;
                y += rowMaxHeight[rowIndex];
                rowIndex += 1;
                if (rowMaxHeight.length <= rowIndex) rowMaxHeight.push(0);
                rep.positionX = x;
                rep.positionY = y;
                rep.rowIndex = rowIndex;
            }
            totalWidthUsed = Math.max(totalWidthUsed, x + itemSpace.outerWidth);
            totalHeightUsed = Math.max(totalHeightUsed, y + itemSpace.outerHeight);
            rowMaxHeight[rowIndex] = Math.max(rowMaxHeight[rowIndex], itemSpace.outerHeight);
            x += itemSpace.outerWidth;
        }
        if (direction === "column") {
            if (y + itemSpace.innerHeight > availableHeight) {
                // This legend item would create overflow along the y-axis, so we start a new column.
                x = totalWidthUsed + itemGap;
                y = 0;
                rowIndex = 0;
                rep.positionX = x;
                rep.positionY = y;
                rep.rowIndex = rowIndex;
            }
            if (rowMaxHeight.length <= rowIndex) rowMaxHeight.push(0);
            totalWidthUsed = Math.max(totalWidthUsed, x + itemSpace.outerWidth);
            totalHeightUsed = Math.max(totalHeightUsed, y + itemSpace.outerHeight);
            rowIndex += 1;
            y += itemSpace.outerHeight;
        }
        return rep;
    });
    return [
        seriesWithRawPosition.map((item)=>(0, $aJx1R.default)({}, item, {
                positionY: item.positionY + (direction === "row" ? rowMaxHeight[item.rowIndex] / 2 // Get the center of the entire row
                 : item.outerHeight / 2 // Get the center of the item
                )
            })),
        totalWidthUsed,
        totalHeightUsed
    ];
}




var $aSiaI = parcelRequire("aSiaI");
const $5ea43a4dfdf05f92$var$_excluded = [
    "rotate",
    "dominantBaseline"
];
const $5ea43a4dfdf05f92$export$3c232c8801a6dfd3 = (0, $jawKn.default)("g", {
    name: "MuiChartsLegend",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * Transforms number or partial padding object to a defaultized padding object.
 */ const $5ea43a4dfdf05f92$var$getStandardizedPadding = (padding)=>{
    if (typeof padding === "number") return {
        left: padding,
        right: padding,
        top: padding,
        bottom: padding
    };
    return (0, $aJx1R.default)({
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    }, padding);
};
function $5ea43a4dfdf05f92$export$539baab0f6115259(props) {
    const { hidden: hidden, position: position, direction: direction, itemsToDisplay: itemsToDisplay, classes: classes, itemMarkWidth: itemMarkWidth = 20, itemMarkHeight: itemMarkHeight = 20, markGap: markGap = 5, itemGap: itemGap = 10, padding: paddingProps = 10, labelStyle: inLabelStyle } = props;
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === "rtl";
    const drawingArea = (0, $767eebe86d6e6272$export$389be1739214a0a2)();
    const labelStyle = $exYeM.useMemo(()=>(0, $aJx1R.default)({}, theme.typography.subtitle1, {
            color: "inherit",
            dominantBaseline: "central",
            textAnchor: "start",
            fill: (theme.vars || theme).palette.text.primary,
            lineHeight: 1
        }, inLabelStyle), // To say to TS that the dominantBaseline and textAnchor are correct
    [
        inLabelStyle,
        theme
    ]);
    const padding = $exYeM.useMemo(()=>$5ea43a4dfdf05f92$var$getStandardizedPadding(paddingProps), [
        paddingProps
    ]);
    const getItemSpace = $exYeM.useCallback((label, inStyle = {})=>{
        const style = (0, $3L80X.default)(inStyle, $5ea43a4dfdf05f92$var$_excluded);
        const linesSize = (0, $43abefa5cfeb5cf7$export$86ba3bfd091ebe4f)({
            style: style,
            needsComputation: true,
            text: label
        });
        const innerSize = {
            innerWidth: itemMarkWidth + markGap + Math.max(...linesSize.map((size)=>size.width)),
            innerHeight: Math.max(itemMarkHeight, linesSize.length * linesSize[0].height)
        };
        return (0, $aJx1R.default)({}, innerSize, {
            outerWidth: innerSize.innerWidth + itemGap,
            outerHeight: innerSize.innerHeight + itemGap
        });
    }, [
        itemGap,
        itemMarkHeight,
        itemMarkWidth,
        markGap
    ]);
    const totalWidth = drawingArea.left + drawingArea.width + drawingArea.right;
    const totalHeight = drawingArea.top + drawingArea.height + drawingArea.bottom;
    const availableWidth = totalWidth - padding.left - padding.right;
    const availableHeight = totalHeight - padding.top - padding.bottom;
    const [itemsWithPosition, legendWidth, legendHeight] = $exYeM.useMemo(()=>(0, $51c9a53aa0060966$export$20c684af33ddb1e)(itemsToDisplay, getItemSpace, labelStyle, direction, availableWidth, availableHeight, itemGap), [
        itemsToDisplay,
        getItemSpace,
        labelStyle,
        direction,
        availableWidth,
        availableHeight,
        itemGap
    ]);
    const gapX = $exYeM.useMemo(()=>{
        switch(position.horizontal){
            case "left":
                return padding.left;
            case "right":
                return totalWidth - padding.right - legendWidth;
            default:
                return (totalWidth - legendWidth) / 2;
        }
    }, [
        position.horizontal,
        padding.left,
        padding.right,
        totalWidth,
        legendWidth
    ]);
    const gapY = $exYeM.useMemo(()=>{
        switch(position.vertical){
            case "top":
                return padding.top;
            case "bottom":
                return totalHeight - padding.bottom - legendHeight;
            default:
                return (totalHeight - legendHeight) / 2;
        }
    }, [
        position.vertical,
        padding.top,
        padding.bottom,
        totalHeight,
        legendHeight
    ]);
    if (hidden) return null;
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c27d28e494a69d08$export$24fbf80485c43cdb), {
        children: /*#__PURE__*/ (0, $aSiaI.jsx)($5ea43a4dfdf05f92$export$3c232c8801a6dfd3, {
            className: classes?.root,
            children: itemsWithPosition.map(({ id: id, label: label, color: color, positionX: positionX, positionY: positionY })=>/*#__PURE__*/ (0, $aSiaI.jsxs)("g", {
                    className: classes?.series,
                    transform: `translate(${gapX + (isRTL ? legendWidth - positionX : positionX)} ${gapY + positionY})`,
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
                            className: classes?.mark,
                            x: isRTL ? -itemMarkWidth : 0,
                            y: -itemMarkHeight / 2,
                            width: itemMarkWidth,
                            height: itemMarkHeight,
                            fill: color
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e3425be3b415617b$export$a928758019bf149f), {
                            style: labelStyle,
                            text: label,
                            x: (isRTL ? -1 : 1) * (itemMarkWidth + markGap),
                            y: 0
                        })
                    ]
                }, id))
        })
    });
}



var $aSiaI = parcelRequire("aSiaI");
const $c4e48a50b08f51f8$var$_excluded = [
    "drawingArea",
    "seriesToDisplay"
];
function $c4e48a50b08f51f8$export$3f12acb0bda6f314(props) {
    const { seriesToDisplay: seriesToDisplay } = props, other = (0, $3L80X.default)(props, $c4e48a50b08f51f8$var$_excluded);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $5ea43a4dfdf05f92$export$539baab0f6115259), (0, $aJx1R.default)({}, other, {
        itemsToDisplay: seriesToDisplay
    }));
}





var $aSiaI = parcelRequire("aSiaI");
const $8dc35cebfdf94a31$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, direction: direction } = ownerState;
    const slots = {
        root: [
            "root",
            direction
        ],
        mark: [
            "mark"
        ],
        label: [
            "label"
        ],
        series: [
            "series"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $d7dcae8fd8e27627$export$9c99214d2a5cbfe4), classes);
};
const $8dc35cebfdf94a31$var$defaultProps = {
    position: {
        horizontal: "middle",
        vertical: "top"
    },
    direction: "row"
};
function $8dc35cebfdf94a31$export$2741855b57a06a05(inProps) {
    const props = (0, $7PWLt.default)({
        props: (0, $aJx1R.default)({}, $8dc35cebfdf94a31$var$defaultProps, inProps),
        name: "MuiChartsLegend"
    });
    const { position: position, direction: direction, hidden: hidden, slots: slots, slotProps: slotProps } = props;
    const theme = (0, $3b0ffd30506eb290$export$2e2bcd8739ae039)();
    const classes = $8dc35cebfdf94a31$var$useUtilityClasses((0, $aJx1R.default)({}, props, {
        theme: theme
    }));
    const drawingArea = (0, $767eebe86d6e6272$export$389be1739214a0a2)();
    const series = (0, $ba69253362075717$export$23a245cc02c91dfa)();
    const seriesToDisplay = (0, $fde0f43f7268f224$export$9aa8b92502563cc4)(series);
    const ChartLegendRender = slots?.legend ?? (0, $c4e48a50b08f51f8$export$3f12acb0bda6f314);
    const chartLegendRenderProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: ChartLegendRender,
        externalSlotProps: slotProps?.legend,
        additionalProps: {
            position: position,
            direction: direction,
            classes: classes,
            drawingArea: drawingArea,
            series: series,
            hidden: hidden,
            seriesToDisplay: seriesToDisplay
        },
        ownerState: {}
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)(ChartLegendRender, (0, $aJx1R.default)({}, chartLegendRenderProps));
}



var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $2f0D3 = parcelRequire("2f0D3");

var $dC5O8 = parcelRequire("dC5O8");

var $kY7HX = parcelRequire("kY7HX");

var $jawKn = parcelRequire("jawKn");




function $e81e7811b728a974$export$5acf30f46eb8262f(identifier) {
    const { xAxis: xAxis, xAxisIds: xAxisIds } = (0, $27adb4455fa596cf$export$2785a2cc09fc5c5f)();
    const id = typeof identifier === "string" ? identifier : xAxisIds[identifier ?? 0];
    return xAxis[id];
}
function $e81e7811b728a974$export$db526816f6980005(identifier) {
    const { yAxis: yAxis, yAxisIds: yAxisIds } = (0, $27adb4455fa596cf$export$2785a2cc09fc5c5f)();
    const id = typeof identifier === "string" ? identifier : yAxisIds[identifier ?? 0];
    return yAxis[id];
}


function $fe42cc92ff5d0a37$export$612517523e588e9d(scale) {
    if ((0, $83a42db726948b22$export$ee3f06150b977754)(scale)) return (value)=>(scale(value) ?? 0) + scale.bandwidth() / 2;
    return (value)=>scale(value);
}
function $fe42cc92ff5d0a37$export$757ded1184410372(identifier) {
    const axis = (0, $e81e7811b728a974$export$5acf30f46eb8262f)(identifier);
    return axis.scale;
}
function $fe42cc92ff5d0a37$export$be6a547e100ea91b(identifier) {
    const axis = (0, $e81e7811b728a974$export$db526816f6980005)(identifier);
    return axis.scale;
}




var $aSiaI = parcelRequire("aSiaI");
function $95e22bde0fffcfc7$export$7717a178c0a9fc5(slot) {
    return (0, $dC5O8.default)("MuiChartsAxisHighlight", slot);
}
const $95e22bde0fffcfc7$export$b94033c576d1d166 = (0, $kY7HX.default)("MuiChartsAxisHighlight", [
    "root"
]);
const $95e22bde0fffcfc7$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $2f0D3.default)(slots, $95e22bde0fffcfc7$export$7717a178c0a9fc5);
};
const $95e22bde0fffcfc7$export$63f198db05280db9 = (0, $jawKn.default)("path", {
    name: "MuiChartsAxisHighlight",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ ownerState: ownerState, theme: theme })=>(0, $aJx1R.default)({
        pointerEvents: "none"
    }, ownerState.axisHighlight === "band" && {
        fill: theme.palette.mode === "light" ? "gray" : "white",
        fillOpacity: 0.1
    }, ownerState.axisHighlight === "line" && {
        strokeDasharray: "5 2",
        stroke: theme.palette.mode === "light" ? "#000000" : "#ffffff"
    }));
/**
 * Demos:
 *
 * - [Custom components](https://mui.com/x/react-charts/components/)
 *
 * API:
 *
 * - [ChartsAxisHighlight API](https://mui.com/x/api/charts/charts-axis-highlight/)
 */ function $95e22bde0fffcfc7$export$598ced0854cbcf58(props) {
    const { x: xAxisHighlight, y: yAxisHighlight } = props;
    const { xAxisIds: xAxisIds, xAxis: xAxis, yAxisIds: yAxisIds, yAxis: yAxis } = (0, $27adb4455fa596cf$export$2785a2cc09fc5c5f)();
    const classes = $95e22bde0fffcfc7$var$useUtilityClasses();
    const USED_X_AXIS_ID = xAxisIds[0];
    const USED_Y_AXIS_ID = yAxisIds[0];
    const xScale = xAxis[USED_X_AXIS_ID].scale;
    const yScale = yAxis[USED_Y_AXIS_ID].scale;
    const { axis: axis } = $exYeM.useContext((0, $4791e4ada5496d01$export$d6ef105978afa6a));
    const getXPosition = (0, $fe42cc92ff5d0a37$export$612517523e588e9d)(xScale);
    const getYPosition = (0, $fe42cc92ff5d0a37$export$612517523e588e9d)(yScale);
    const axisX = axis.x;
    const axisY = axis.y;
    const isBandScaleX = xAxisHighlight === "band" && axisX !== null && (0, $83a42db726948b22$export$ee3f06150b977754)(xScale);
    const isBandScaleY = yAxisHighlight === "band" && axisY !== null && (0, $83a42db726948b22$export$ee3f06150b977754)(yScale);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
        children: [
            isBandScaleX && xScale(axisX.value) !== undefined && /*#__PURE__*/ (0, $aSiaI.jsx)($95e22bde0fffcfc7$export$63f198db05280db9, {
                d: `M ${xScale(axisX.value) - (xScale.step() - xScale.bandwidth()) / 2} ${yScale.range()[0]} l ${xScale.step()} 0 l 0 ${yScale.range()[1] - yScale.range()[0]} l ${-xScale.step()} 0 Z`,
                className: classes.root,
                ownerState: {
                    axisHighlight: "band"
                }
            }),
            isBandScaleY && yScale(axisY.value) !== undefined && /*#__PURE__*/ (0, $aSiaI.jsx)($95e22bde0fffcfc7$export$63f198db05280db9, {
                d: `M ${xScale.range()[0]} ${// @ts-expect-error, yScale value is checked in the statement above
                yScale(axisY.value) - (yScale.step() - yScale.bandwidth()) / 2} l 0 ${yScale.step()} l ${xScale.range()[1] - xScale.range()[0]} 0 l 0 ${-yScale.step()} Z`,
                className: classes.root,
                ownerState: {
                    axisHighlight: "band"
                }
            }),
            xAxisHighlight === "line" && axis.x !== null && /*#__PURE__*/ (0, $aSiaI.jsx)($95e22bde0fffcfc7$export$63f198db05280db9, {
                d: `M ${getXPosition(axis.x.value)} ${yScale.range()[0]} L ${getXPosition(axis.x.value)} ${yScale.range()[1]}`,
                className: classes.root,
                ownerState: {
                    axisHighlight: "line"
                }
            }),
            yAxisHighlight === "line" && axis.y !== null && /*#__PURE__*/ (0, $aSiaI.jsx)($95e22bde0fffcfc7$export$63f198db05280db9, {
                d: `M ${xScale.range()[0]} ${getYPosition(axis.y.value)} L ${xScale.range()[1]} ${getYPosition(axis.y.value)}`,
                className: classes.root,
                ownerState: {
                    axisHighlight: "line"
                }
            })
        ]
    });
}



var $aJx1R = parcelRequire("aJx1R");
parcelRequire("exYeM");



var $aSiaI = parcelRequire("aSiaI");
/**
 * API:
 *
 * - [ChartsClipPath API](https://mui.com/x/api/charts/charts-clip-path/)
 */ function $58540b004b2b5e3b$export$325f8d4978f9d570(props) {
    const { id: id, offset: offsetProps } = props;
    const { left: left, top: top, width: width, height: height } = (0, $767eebe86d6e6272$export$389be1739214a0a2)();
    const offset = (0, $aJx1R.default)({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, offsetProps);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("clipPath", {
        id: id,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("rect", {
            x: left - offset.left,
            y: top - offset.top,
            width: width + offset.left + offset.right,
            height: height + offset.top + offset.bottom
        })
    });
}



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");
parcelRequire("exYeM");


var $2f0D3 = parcelRequire("2f0D3");

var $jawKn = parcelRequire("jawKn");
var $7PWLt = parcelRequire("7PWLt");



var $dC5O8 = parcelRequire("dC5O8");

var $kY7HX = parcelRequire("kY7HX");
function $5667b7d1aab09c6e$export$ddcb63835449cf7e(slot) {
    return (0, $dC5O8.default)("MuiChartsGrid", slot);
}
const $5667b7d1aab09c6e$export$60e7495de106dfc3 = (0, $kY7HX.default)("MuiChartsGrid", [
    "root",
    "line",
    "horizontalLine",
    "verticalLine"
]);



var $aSiaI = parcelRequire("aSiaI");
const $e0157911446d288c$var$_excluded = [
    "vertical",
    "horizontal"
];
const $e0157911446d288c$var$GridRoot = (0, $jawKn.default)("g", {
    name: "MuiChartsGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, $5667b7d1aab09c6e$export$60e7495de106dfc3).verticalLine}`]: styles.verticalLine
            },
            {
                [`&.${(0, $5667b7d1aab09c6e$export$60e7495de106dfc3).horizontalLine}`]: styles.horizontalLine
            },
            styles.root
        ]
})({});
const $e0157911446d288c$var$GridLine = (0, $jawKn.default)("line", {
    name: "MuiChartsGrid",
    slot: "Line",
    overridesResolver: (props, styles)=>styles.line
})(({ theme: theme })=>({
        stroke: (theme.vars || theme).palette.divider,
        shapeRendering: "crispEdges",
        strokeWidth: 1
    }));
const $e0157911446d288c$var$useUtilityClasses = ({ classes: classes })=>{
    const slots = {
        root: [
            "root"
        ],
        verticalLine: [
            "line",
            "verticalLine"
        ],
        horizontalLine: [
            "line",
            "horizontalLine"
        ]
    };
    return (0, $2f0D3.default)(slots, (0, $5667b7d1aab09c6e$export$ddcb63835449cf7e), classes);
};
/**
 * Demos:
 *
 * - [Axis](https://mui.com/x/react-charts/axis/)
 *
 * API:
 *
 * - [ChartsGrid API](https://mui.com/x/api/charts/charts-axis/)
 */ function $e0157911446d288c$export$689c47245a555af2(props) {
    const themeProps = (0, $7PWLt.default)({
        props: props,
        name: "MuiChartsGrid"
    });
    const { vertical: vertical, horizontal: horizontal } = themeProps, other = (0, $3L80X.default)(themeProps, $e0157911446d288c$var$_excluded);
    const { xAxis: xAxis, xAxisIds: xAxisIds, yAxis: yAxis, yAxisIds: yAxisIds } = (0, $27adb4455fa596cf$export$2785a2cc09fc5c5f)();
    const classes = $e0157911446d288c$var$useUtilityClasses(themeProps);
    const horizontalAxisId = yAxisIds[0];
    const verticalAxisId = xAxisIds[0];
    const { scale: xScale, tickNumber: xTickNumber, tickInterval: xTickInterval } = xAxis[verticalAxisId];
    const { scale: yScale, tickNumber: yTickNumber, tickInterval: yTickInterval } = yAxis[horizontalAxisId];
    const xTicks = (0, $06d6ba1dd373d3d8$export$99da48a3c6ab2fa1)({
        scale: xScale,
        tickNumber: xTickNumber,
        tickInterval: xTickInterval
    });
    const yTicks = (0, $06d6ba1dd373d3d8$export$99da48a3c6ab2fa1)({
        scale: yScale,
        tickNumber: yTickNumber,
        tickInterval: yTickInterval
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($e0157911446d288c$var$GridRoot, (0, $aJx1R.default)({}, other, {
        className: classes.root,
        children: [
            vertical && xTicks.map(({ formattedValue: formattedValue, offset: offset })=>/*#__PURE__*/ (0, $aSiaI.jsx)($e0157911446d288c$var$GridLine, {
                    y1: yScale.range()[0],
                    y2: yScale.range()[1],
                    x1: offset,
                    x2: offset,
                    className: classes.verticalLine
                }, `vertical-${formattedValue}`)),
            horizontal && yTicks.map(({ formattedValue: formattedValue, offset: offset })=>/*#__PURE__*/ (0, $aSiaI.jsx)($e0157911446d288c$var$GridLine, {
                    y1: offset,
                    y2: offset,
                    x1: xScale.range()[0],
                    x2: xScale.range()[1],
                    className: classes.horizontalLine
                }, `horizontal-${formattedValue}`))
        ]
    }));
}



var $exYeM = parcelRequire("exYeM");






var $aSiaI = parcelRequire("aSiaI");
function $93047e9f465eed81$export$770a9d3016cdbedd(props) {
    const { onAxisClick: onAxisClick } = props;
    const svgRef = (0, $ae025d5d266ffedb$export$839818ed0cc5fa73)();
    const series = (0, $ba69253362075717$export$23a245cc02c91dfa)();
    const { axis: axis } = $exYeM.useContext((0, $4791e4ada5496d01$export$d6ef105978afa6a));
    const { xAxisIds: xAxisIds, xAxis: xAxis, yAxisIds: yAxisIds, yAxis: yAxis } = (0, $27adb4455fa596cf$export$2785a2cc09fc5c5f)();
    $exYeM.useEffect(()=>{
        const element = svgRef.current;
        if (element === null || !onAxisClick) return ()=>{};
        const handleMouseClick = (event)=>{
            event.preventDefault();
            const isXaxis = (axis.x && axis.x.index) !== undefined;
            const USED_AXIS_ID = isXaxis ? xAxisIds[0] : yAxisIds[0];
            const dataIndex = isXaxis ? axis.x && axis.x.index : axis.y && axis.y.index;
            if (dataIndex == null) return;
            const seriesValues = {};
            Object.keys(series).filter((seriesType)=>[
                    "bar",
                    "line"
                ].includes(seriesType)).forEach((seriesType)=>{
                series[seriesType]?.seriesOrder.forEach((seriesId)=>{
                    const seriesItem = series[seriesType].series[seriesId];
                    const axisKey = isXaxis ? seriesItem.xAxisKey : seriesItem.yAxisKey;
                    if (axisKey === undefined || axisKey === USED_AXIS_ID) seriesValues[seriesId] = seriesItem.data[dataIndex];
                });
            });
            const axisValue = (isXaxis ? xAxis : yAxis)[USED_AXIS_ID].data?.[dataIndex];
            onAxisClick(event, {
                dataIndex: dataIndex,
                axisValue: axisValue,
                seriesValues: seriesValues
            });
        };
        element.addEventListener("click", handleMouseClick);
        return ()=>{
            element.removeEventListener("click", handleMouseClick);
        };
    }, [
        axis.x,
        axis.y,
        onAxisClick,
        series,
        svgRef,
        xAxis,
        xAxisIds,
        yAxis,
        yAxisIds
    ]);
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/ (0, $aSiaI.jsx)($exYeM.Fragment, {});
}



var $aJx1R = parcelRequire("aJx1R");
parcelRequire("exYeM");

var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");
parcelRequire("exYeM");

var $jawKn = parcelRequire("jawKn");


var $aSiaI = parcelRequire("aSiaI");
const $33a0626d01fd7c6e$var$_excluded = [
    "message"
];
const $33a0626d01fd7c6e$var$StyledText = (0, $jawKn.default)("text")(({ theme: theme })=>(0, $aJx1R.default)({}, theme.typography.body2, {
        stroke: "none",
        fill: theme.palette.text.primary,
        shapeRendering: "crispEdges",
        textAnchor: "middle",
        dominantBaseline: "middle"
    }));
function $33a0626d01fd7c6e$export$b8ccea7e6542067(props) {
    const { message: message } = props, other = (0, $3L80X.default)(props, $33a0626d01fd7c6e$var$_excluded);
    const { top: top, left: left, height: height, width: width } = (0, $767eebe86d6e6272$export$389be1739214a0a2)();
    return /*#__PURE__*/ (0, $aSiaI.jsx)($33a0626d01fd7c6e$var$StyledText, (0, $aJx1R.default)({
        x: left + width / 2,
        y: top + height / 2
    }, other, {
        children: message ?? "Loading data\u2026"
    }));
}




var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");
parcelRequire("exYeM");

var $jawKn = parcelRequire("jawKn");


var $aSiaI = parcelRequire("aSiaI");
const $6f29ea535ed09399$var$_excluded = [
    "message"
];
const $6f29ea535ed09399$var$StyledText = (0, $jawKn.default)("text")(({ theme: theme })=>(0, $aJx1R.default)({}, theme.typography.body2, {
        stroke: "none",
        fill: theme.palette.text.primary,
        shapeRendering: "crispEdges",
        textAnchor: "middle",
        dominantBaseline: "middle"
    }));
function $6f29ea535ed09399$export$11d4ac08df2a3a67(props) {
    const { message: message } = props, other = (0, $3L80X.default)(props, $6f29ea535ed09399$var$_excluded);
    const { top: top, left: left, height: height, width: width } = (0, $767eebe86d6e6272$export$389be1739214a0a2)();
    return /*#__PURE__*/ (0, $aSiaI.jsx)($6f29ea535ed09399$var$StyledText, (0, $aJx1R.default)({
        x: left + width / 2,
        y: top + height / 2
    }, other, {
        children: message ?? "No data to display"
    }));
}



var $aSiaI = parcelRequire("aSiaI");
function $7700a9920847bf61$export$39e4e4558e4ba179() {
    const seriesPerType = (0, $ba69253362075717$export$23a245cc02c91dfa)();
    return Object.values(seriesPerType).every((seriesOfGivenType)=>{
        if (!seriesOfGivenType) return true;
        const { series: series, seriesOrder: seriesOrder } = seriesOfGivenType;
        return seriesOrder.every((seriesId)=>series[seriesId].data.length === 0);
    });
}
function $7700a9920847bf61$export$3729bf444e26c9a6(props) {
    const noData = $7700a9920847bf61$export$39e4e4558e4ba179();
    if (props.loading) {
        const LoadingOverlay = props.slots?.loadingOverlay ?? (0, $33a0626d01fd7c6e$export$b8ccea7e6542067);
        return /*#__PURE__*/ (0, $aSiaI.jsx)(LoadingOverlay, (0, $aJx1R.default)({}, props.slotProps?.loadingOverlay));
    }
    if (noData) {
        const NoDataOverlay = props.slots?.noDataOverlay ?? (0, $6f29ea535ed09399$export$11d4ac08df2a3a67);
        return /*#__PURE__*/ (0, $aSiaI.jsx)(NoDataOverlay, (0, $aJx1R.default)({}, props.slotProps?.noDataOverlay));
    }
    return null;
}



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");


const $7c5b971a6cf691d2$var$_excluded = [
    "xAxis",
    "yAxis",
    "series",
    "width",
    "height",
    "margin",
    "colors",
    "dataset",
    "sx",
    "tooltip",
    "onAxisClick",
    "axisHighlight",
    "legend",
    "grid",
    "topAxis",
    "leftAxis",
    "rightAxis",
    "bottomAxis",
    "children",
    "slots",
    "slotProps",
    "skipAnimation",
    "loading",
    "layout",
    "onItemClick",
    "highlightedItem",
    "onHighlightChange",
    "borderRadius",
    "barLabel",
    "className"
];
const $7c5b971a6cf691d2$export$86d23ae5dfe1d76b = (props)=>{
    const { xAxis: xAxis, yAxis: yAxis, series: series, width: width, height: height, margin: margin, colors: colors, dataset: dataset, sx: sx, tooltip: tooltip, onAxisClick: onAxisClick, axisHighlight: axisHighlight, legend: legend, grid: grid, topAxis: topAxis, leftAxis: leftAxis, rightAxis: rightAxis, bottomAxis: bottomAxis, children: children, slots: slots, slotProps: slotProps, skipAnimation: skipAnimation, loading: loading, layout: layout, onItemClick: onItemClick, highlightedItem: highlightedItem, onHighlightChange: onHighlightChange, borderRadius: borderRadius, barLabel: barLabel, className: className } = props, rest = (0, $3L80X.default)(props, $7c5b971a6cf691d2$var$_excluded);
    const id = (0, $43c7ad0c22f8e14a$export$2e2bcd8739ae039)();
    const clipPathId = `${id}-clip-path`;
    const hasHorizontalSeries = layout === "horizontal" || layout === undefined && series.some((item)=>item.layout === "horizontal");
    const defaultAxisConfig = {
        scaleType: "band",
        data: Array.from({
            length: Math.max(...series.map((s)=>(s.data ?? dataset ?? []).length))
        }, (_, index)=>index)
    };
    const chartContainerProps = (0, $aJx1R.default)({}, rest, {
        series: series.map((s)=>(0, $aJx1R.default)({
                type: "bar"
            }, s, {
                layout: hasHorizontalSeries ? "horizontal" : "vertical"
            })),
        width: width,
        height: height,
        margin: margin,
        colors: colors,
        dataset: dataset,
        xAxis: xAxis ?? (hasHorizontalSeries ? undefined : [
            (0, $aJx1R.default)({
                id: (0, $f7012dce0f399219$export$85ea9370ff307a1f)
            }, defaultAxisConfig)
        ]),
        yAxis: yAxis ?? (hasHorizontalSeries ? [
            (0, $aJx1R.default)({
                id: (0, $f7012dce0f399219$export$59bb26725f1fe1e8)
            }, defaultAxisConfig)
        ] : undefined),
        sx: sx,
        highlightedItem: highlightedItem,
        onHighlightChange: onHighlightChange,
        disableAxisListener: tooltip?.trigger !== "axis" && axisHighlight?.x === "none" && axisHighlight?.y === "none" && !onAxisClick,
        className: className
    });
    const barPlotProps = {
        onItemClick: onItemClick,
        slots: slots,
        slotProps: slotProps,
        skipAnimation: skipAnimation,
        borderRadius: borderRadius,
        barLabel: barLabel
    };
    const axisClickHandlerProps = {
        onAxisClick: onAxisClick
    };
    const gridProps = {
        vertical: grid?.vertical,
        horizontal: grid?.horizontal
    };
    const clipPathGroupProps = {
        clipPath: `url(#${clipPathId})`
    };
    const clipPathProps = {
        id: clipPathId
    };
    const overlayProps = {
        slots: slots,
        slotProps: slotProps,
        loading: loading
    };
    const chartsAxisProps = {
        topAxis: topAxis,
        leftAxis: leftAxis,
        rightAxis: rightAxis,
        bottomAxis: bottomAxis,
        slots: slots,
        slotProps: slotProps
    };
    const axisHighlightProps = (0, $aJx1R.default)({}, hasHorizontalSeries ? {
        y: "band"
    } : {
        x: "band"
    }, axisHighlight);
    const legendProps = (0, $aJx1R.default)({}, legend, {
        slots: slots,
        slotProps: slotProps
    });
    const tooltipProps = (0, $aJx1R.default)({}, tooltip, {
        slots: slots,
        slotProps: slotProps
    });
    return {
        chartContainerProps: chartContainerProps,
        barPlotProps: barPlotProps,
        axisClickHandlerProps: axisClickHandlerProps,
        gridProps: gridProps,
        clipPathProps: clipPathProps,
        clipPathGroupProps: clipPathGroupProps,
        overlayProps: overlayProps,
        chartsAxisProps: chartsAxisProps,
        axisHighlightProps: axisHighlightProps,
        legendProps: legendProps,
        tooltipProps: tooltipProps,
        children: children
    };
};



var $aSiaI = parcelRequire("aSiaI");
/**
 * Demos:
 *
 * - [Bars](https://mui.com/x/react-charts/bars/)
 * - [Bar demonstration](https://mui.com/x/react-charts/bar-demo/)
 * - [Stacking](https://mui.com/x/react-charts/stacking/)
 *
 * API:
 *
 * - [BarChart API](https://mui.com/x/api/charts/bar-chart/)
 */ const $07dda412218ab630$export$94aefc399ef206a9 = /*#__PURE__*/ $exYeM.forwardRef(function BarChart(props, ref) {
    const { chartContainerProps: chartContainerProps, barPlotProps: barPlotProps, axisClickHandlerProps: axisClickHandlerProps, gridProps: gridProps, clipPathProps: clipPathProps, clipPathGroupProps: clipPathGroupProps, overlayProps: overlayProps, chartsAxisProps: chartsAxisProps, axisHighlightProps: axisHighlightProps, legendProps: legendProps, tooltipProps: tooltipProps, children: children } = (0, $7c5b971a6cf691d2$export$86d23ae5dfe1d76b)(props);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $254a2fff30bc08f0$export$5f31fc7dc92fc998), (0, $aJx1R.default)({
        ref: ref
    }, chartContainerProps, {
        children: [
            props.onAxisClick && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $93047e9f465eed81$export$770a9d3016cdbedd), (0, $aJx1R.default)({}, axisClickHandlerProps)),
            props.grid && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e0157911446d288c$export$689c47245a555af2), (0, $aJx1R.default)({}, gridProps)),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("g", (0, $aJx1R.default)({}, clipPathGroupProps, {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $122f27ba37011048$export$bb9821b32a110f1f), (0, $aJx1R.default)({}, barPlotProps)),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7700a9920847bf61$export$3729bf444e26c9a6), (0, $aJx1R.default)({}, overlayProps)),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $95e22bde0fffcfc7$export$598ced0854cbcf58), (0, $aJx1R.default)({}, axisHighlightProps))
                ]
            })),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $98aeda3d167bbb73$export$2423790cc2b08d6f), (0, $aJx1R.default)({}, chartsAxisProps)),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8dc35cebfdf94a31$export$2741855b57a06a05), (0, $aJx1R.default)({}, legendProps)),
            !props.loading && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e0f2ff2fe9ecd767$export$638edc2f884926bd), (0, $aJx1R.default)({}, tooltipProps)),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $58540b004b2b5e3b$export$325f8d4978f9d570), (0, $aJx1R.default)({}, clipPathProps)),
            children
        ]
    }));
});





var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");

const $e7957d28d2172cc5$export$9a70222c5bedabe3 = ({ value: value })=>{
    if (!value) return null;
    let dateValue = null;
    if (typeof value === "string") dateValue = new Date(value);
    else if (Object.prototype.toString.call(value) === "[object Date]") dateValue = value;
    if (!dateValue) return null;
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            dateValue.toISOString(),
            /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
            (0, $08c0c798d1b2bf8a$export$2e2bcd8739ae039)(dateValue, {
                addSuffix: true
            })
        ]
    });
};



var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");





const $6c7022748d6b058b$export$222b3b6ff15ce4b0 = ({ emoji: emoji, item: item, total: total, hidePercentage: hidePercentage })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                    fontSize: "xx-large",
                    children: emoji
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                    fontSize: "larger",
                    fontWeight: 600,
                    children: item.count
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                children: !hidePercentage && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                    fontSize: "larger",
                    children: [
                        Math.round(item.count * 100 / total),
                        "%"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                children: item.description || ""
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                sx: {
                    maxWidth: 300
                },
                children: item.countries && Object.keys(item.countries).map((key)=>({
                        key: key,
                        value: item.countries[key]
                    })).sort((a, b)=>b.value - a.value).map(({ key: key, value: value })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8b19ed05d27c6095$export$2e2bcd8739ae039), {
                                label: value,
                                size: "small",
                                icon: /*#__PURE__*/ (0, $aSiaI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8c326551a00e77e9$exports))), {
                                    code: key,
                                    width: 16
                                })
                            }),
                            " "
                        ]
                    }))
            })
        ]
    });


const $01bb1c4a0639f9ce$var$CACHE_KEY = "cache-gateways";
const $01bb1c4a0639f9ce$var$CustomWidthTooltip = (0, $jawKn.default)(({ className: className, ...props })=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), {
        ...props,
        classes: {
            popper: className
        }
    }))({
    [`& .${(0, $398b111a0d579b06$export$2e2bcd8739ae039).tooltip}`]: {
        maxWidth: 800,
        maxHeight: "80vh",
        overflowY: "auto"
    }
});
const $01bb1c4a0639f9ce$export$35b3358ed859f59f = {
    entryGateway: "Entry Gateway (mixnet mode)",
    exitGatewayWithIPR: "Exit Gateway with IPR",
    exitGatewayWithSocks5: "Exit Gateway with SOCKS5 NR",
    exitPolicyEnabled: "Exit Policy Enabled",
    runsNymNode: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            "Runs ",
            /*#__PURE__*/ (0, $aSiaI.jsx)("code", {
                children: "nym-node"
            })
        ]
    }),
    runsMinVersion: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            "Runs ",
            /*#__PURE__*/ (0, $aSiaI.jsx)("code", {
                children: "nym-node"
            }),
            " ",
            ">",
            " v",
            (0, $8d995646af892e7d$export$149ea0a63fc31f44)
        ]
    }),
    runsAuthentictorServiceProvider: "Runs Auth Service Provider"
};
const $01bb1c4a0639f9ce$export$449ac6ab2e997139 = (value)=>{
    if (value >= (0, $8d995646af892e7d$export$8387896f8e84cb45).panda.minScore) return (0, $8d995646af892e7d$export$8387896f8e84cb45).panda.emoji;
    if (value >= (0, $8d995646af892e7d$export$8387896f8e84cb45).dolphin.minScore) return (0, $8d995646af892e7d$export$8387896f8e84cb45).dolphin.emoji;
    if (value >= (0, $8d995646af892e7d$export$8387896f8e84cb45).fox.minScore) return (0, $8d995646af892e7d$export$8387896f8e84cb45).fox.emoji;
    if (value >= (0, $8d995646af892e7d$export$8387896f8e84cb45).mouse.minScore) return (0, $8d995646af892e7d$export$8387896f8e84cb45).mouse.emoji;
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: "\u274C"
    });
};
const $01bb1c4a0639f9ce$export$374d712138427485 = (value)=>{
    if (!value) return "\u274C";
    if (value >= (0, $8d995646af892e7d$export$5e9c3d4235c9a19).peanut.minScore) return (0, $8d995646af892e7d$export$5e9c3d4235c9a19).peanut.emoji;
    if (value >= (0, $8d995646af892e7d$export$5e9c3d4235c9a19).icecream.minScore) return (0, $8d995646af892e7d$export$5e9c3d4235c9a19).icecream.emoji;
    if (value >= (0, $8d995646af892e7d$export$5e9c3d4235c9a19).popcorn.minScore) return (0, $8d995646af892e7d$export$5e9c3d4235c9a19).popcorn.emoji;
    if (value >= (0, $8d995646af892e7d$export$5e9c3d4235c9a19).lollipop.minScore) return (0, $8d995646af892e7d$export$5e9c3d4235c9a19).lollipop.emoji;
    return "\u274C";
};
const $01bb1c4a0639f9ce$export$931ac62b58f99256 = ()=>{
    const [allGateways, setAllGateways] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState([]);
    const [gateways, setGateways] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState([]);
    const [gatewayCount, setGatewayCount] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState();
    const [lastUpdated, setLastUpdated] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState();
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [busyMessage, setBusyMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState();
    const [summary, setSummary] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(null);
    const countCountries = (item)=>item.filter((i)=>Boolean(i.explorer_pretty_bond?.location?.two_letter_iso_country_code)).map((i)=>i.explorer_pretty_bond.location.two_letter_iso_country_code).reduce((acc, cur)=>{
            if (!acc[cur]) acc[cur] = 1;
            else acc[cur] += 1;
            return acc;
        }, {});
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        if (gateways) {
            const pandas = gateways.filter((g)=>g.config_score_calculated >= (0, $8d995646af892e7d$export$8387896f8e84cb45).panda.minScore);
            const dolphins = gateways.filter((g)=>g.config_score_calculated >= (0, $8d995646af892e7d$export$8387896f8e84cb45).dolphin.minScore && g.config_score_calculated < (0, $8d995646af892e7d$export$8387896f8e84cb45).panda.minScore);
            const foxes = gateways.filter((g)=>g.config_score_calculated >= (0, $8d995646af892e7d$export$8387896f8e84cb45).fox.minScore && g.config_score_calculated < (0, $8d995646af892e7d$export$8387896f8e84cb45).dolphin.minScore);
            const mouses = gateways.filter((g)=>g.config_score_calculated >= (0, $8d995646af892e7d$export$8387896f8e84cb45).mouse.minScore && g.config_score_calculated < (0, $8d995646af892e7d$export$8387896f8e84cb45).fox.minScore);
            const peanuts = gateways.filter((g)=>g.probe_score_calculated >= (0, $8d995646af892e7d$export$5e9c3d4235c9a19).peanut.minScore);
            const icecreams = gateways.filter((g)=>g.probe_score_calculated < (0, $8d995646af892e7d$export$5e9c3d4235c9a19).peanut.minScore && g.probe_score_calculated >= (0, $8d995646af892e7d$export$5e9c3d4235c9a19).icecream.minScore);
            const popcorns = gateways.filter((g)=>g.probe_score_calculated < (0, $8d995646af892e7d$export$5e9c3d4235c9a19).icecream.minScore && g.probe_score_calculated >= (0, $8d995646af892e7d$export$5e9c3d4235c9a19).popcorn.minScore);
            const lollies = gateways.filter((g)=>g.probe_score_calculated < (0, $8d995646af892e7d$export$5e9c3d4235c9a19).popcorn.minScore);
            setSummary({
                termsAndConditions: {
                    count: gateways.filter((g)=>g.self_described?.auxiliary_details?.accepted_operator_terms_and_conditions === true).length,
                    description: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
                        children: "\u2705 Accepted operator terms & conditions"
                    })
                },
                unbonded: {
                    count: allGateways.length ? allGateways.length - gateways.length : 0,
                    description: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
                        children: "Unbonded nodes"
                    })
                },
                configScores: {
                    pandas: {
                        count: pandas.length,
                        countries: countCountries(pandas),
                        description: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                            children: [
                                "\u2705 ",
                                $01bb1c4a0639f9ce$export$35b3358ed859f59f.entryGateway,
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                "\u2705 ",
                                $01bb1c4a0639f9ce$export$35b3358ed859f59f.exitGatewayWithIPR,
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                "\u2705 ",
                                $01bb1c4a0639f9ce$export$35b3358ed859f59f.exitGatewayWithSocks5,
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                "\u2705 ",
                                $01bb1c4a0639f9ce$export$35b3358ed859f59f.exitPolicyEnabled,
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                "\u2705 ",
                                $01bb1c4a0639f9ce$export$35b3358ed859f59f.runsNymNode,
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                "\u2705 ",
                                $01bb1c4a0639f9ce$export$35b3358ed859f59f.runsMinVersion,
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                "\u2705 ",
                                $01bb1c4a0639f9ce$export$35b3358ed859f59f.runsAuthentictorServiceProvider
                            ]
                        })
                    },
                    dolphins: {
                        count: dolphins.length,
                        countries: countCountries(dolphins),
                        description: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                            children: [
                                "\u2705 ",
                                $01bb1c4a0639f9ce$export$35b3358ed859f59f.entryGateway,
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                "\u2705 ",
                                $01bb1c4a0639f9ce$export$35b3358ed859f59f.exitGatewayWithIPR,
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                "\u2705 ",
                                $01bb1c4a0639f9ce$export$35b3358ed859f59f.exitGatewayWithSocks5,
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                "\u2705 ",
                                $01bb1c4a0639f9ce$export$35b3358ed859f59f.exitPolicyEnabled,
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                "\u2705 ",
                                $01bb1c4a0639f9ce$export$35b3358ed859f59f.runsNymNode,
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                "\u2705 ",
                                $01bb1c4a0639f9ce$export$35b3358ed859f59f.runsAuthentictorServiceProvider
                            ]
                        })
                    },
                    foxes: {
                        count: foxes.length,
                        countries: countCountries(foxes),
                        description: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                            children: [
                                "\u2705 ",
                                $01bb1c4a0639f9ce$export$35b3358ed859f59f.entryGateway,
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                "\u2705 ",
                                $01bb1c4a0639f9ce$export$35b3358ed859f59f.exitGatewayWithIPR,
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                "\u2705 ",
                                $01bb1c4a0639f9ce$export$35b3358ed859f59f.exitGatewayWithSocks5,
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                "\u2705 ",
                                $01bb1c4a0639f9ce$export$35b3358ed859f59f.exitPolicyEnabled
                            ]
                        })
                    },
                    mouses: {
                        count: mouses.length,
                        countries: countCountries(mouses),
                        description: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                            children: [
                                "\u2705 ",
                                $01bb1c4a0639f9ce$export$35b3358ed859f59f.entryGateway
                            ]
                        })
                    }
                },
                routingScores: {
                    peanuts: {
                        count: peanuts.length,
                        countries: countCountries(peanuts),
                        description: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                            children: [
                                "\u2197\uFE0F Entry Gateway Connects",
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                "\uD83D\uDD00 Entry Gateway Routes",
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                "\u27A1\uFE0F Exit Gateway Connects",
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    style: {
                                        opacity: 0.5
                                    },
                                    children: "4\uFE0F\u20E3\uFE0F6\uFE0F\u20E3"
                                }),
                                " Exit Gateway ipv4 and ipv6 routes internally",
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    children: "4\uFE0F\u20E3\uFE0F6\uFE0F\u20E3"
                                }),
                                " Exit Gateway ipv4 and ipv6 routes externally",
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    children: "\u269B\uFE0F"
                                }),
                                " Can register Wireguard peers and complete handshake",
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    children: "\uD83D\uDD24"
                                }),
                                " Resolves DNS when Wireguard active",
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    children: "\uD83D\uDEDC"
                                }),
                                " Wireguard performance > 0.75"
                            ]
                        })
                    },
                    icecreams: {
                        count: icecreams.length,
                        countries: countCountries(icecreams),
                        description: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                            children: [
                                "\u2197\uFE0F Entry Gateway Connects",
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                "\uD83D\uDD00 Entry Gateway Routes",
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                "\u27A1\uFE0F Exit Gateway Connects",
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    style: {
                                        opacity: 0.5
                                    },
                                    children: "4\uFE0F\u20E3\uFE0F6\uFE0F\u20E3"
                                }),
                                " Exit Gateway ipv4 and ipv6 routes internally",
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    children: "4\uFE0F\u20E3\uFE0F6\uFE0F\u20E3"
                                }),
                                " Exit Gateway ipv4 and ipv6 routes externally",
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    children: "\u269B\uFE0F"
                                }),
                                " Can register Wireguard peers and complete handshake",
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    children: "\uD83D\uDD24"
                                }),
                                " Resolves DNS when Wireguard active",
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    style: {
                                        opacity: 0.5
                                    },
                                    children: "\uD83D\uDEDC"
                                }),
                                " Wireguard performance < 0.75"
                            ]
                        })
                    },
                    popcorns: {
                        count: popcorns.length,
                        countries: countCountries(popcorns),
                        description: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                            children: [
                                "\u2197\uFE0F Entry Gateway Connects",
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                "\uD83D\uDD00 Entry Gateway Routes",
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                "\u27A1\uFE0F Exit Gateway Connects",
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    style: {
                                        opacity: 0.5
                                    },
                                    children: "4\uFE0F\u20E3\uFE0F6\uFE0F\u20E3"
                                }),
                                " Exit Gateway ipv4 and ipv6 routes internally",
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    children: "4\uFE0F\u20E3\uFE0F6\uFE0F\u20E3"
                                }),
                                " Exit Gateway ipv4 and ipv6 routes externally",
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                    style: {
                                        opacity: 0.2
                                    },
                                    children: "\u269B\uFE0F"
                                }),
                                " Can register Wireguard peers, handshake fails"
                            ]
                        })
                    },
                    lollies: {
                        count: lollies.length,
                        countries: countCountries(lollies),
                        description: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                            children: [
                                "\u2197\uFE0F Entry Gateway Connects",
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                "\uD83D\uDD00 Entry Gateway Routes",
                                /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                "\u274C Exit Gateway does not route ipv4 or ipv6"
                            ]
                        })
                    }
                }
            });
        }
    }, [
        gateways,
        allGateways
    ]);
    const gatewayVersions = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useMemo(()=>{
        const versions = {
            unknown: 0
        };
        gateways.filter((g)=>g.bonded).forEach((g)=>{
            const version = g.self_described?.build_information?.build_version;
            if (version) {
                if (!versions[version]) versions[version] = 0;
                versions[version] += 1;
            } else versions.unknown += 1;
        });
        return Object.keys(versions).map((v)=>({
                version: v,
                count: versions[v]
            })).sort((a, b)=>{
            if (a.version === "unknown" || b.version === "unknown") return -1;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6abb42b6d3bcba21$exports)))(a.version, b.version);
        });
    }, [
        gateways
    ]);
    const refreshGateways = async ()=>{
        try {
            let items = await (0, $f66fa928cd4a99c0$export$644d8ea042df96a6).gateways();
            setAllGateways(items);
            items = items.filter((g)=>g.bonded);
            try {
                window.sessionStorage.setItem($01bb1c4a0639f9ce$var$CACHE_KEY, JSON.stringify(items));
            } catch (ex) {
                console.error("Failed to store cache for gateways in session storage", ex);
            }
            setGateways(items);
            setGatewayCount(items.length);
            setBusyMessage("Gateway data updated...");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("Error getting services", e);
        }
    };
    const refresh = async ()=>{
        try {
            setBusy(true);
            setBusyMessage("Getting latest data...");
            await Promise.all([
                refreshGateways()
            ]);
            setLastUpdated(new Date());
            setBusyMessage("Finishing refresh...");
        } finally{
            setBusy(false);
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const storedGateways = window.sessionStorage.getItem($01bb1c4a0639f9ce$var$CACHE_KEY);
        if (storedGateways?.length) try {
            setGateways(JSON.parse(storedGateways));
            setLastUpdated(new Date());
        } catch (_) {
        // do nothing
        }
        refresh();
        const timer = setInterval(refresh, 300000);
        return ()=>clearInterval(timer);
    }, []);
    const columns = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useMemo(()=>[
            {
                header: "Identity Key",
                accessorKey: "gateway_identity_key",
                Cell: ({ cell: cell })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $c14ca1eac99fe440$export$2e2bcd8739ae039), {
                        component: (0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a),
                        to: `/gateway/${cell.getValue()}`,
                        children: [
                            cell.getValue().slice(0, 10),
                            "..."
                        ]
                    })
            },
            {
                header: "Moniker",
                accessorKey: "description.moniker"
            },
            {
                header: "Config Score",
                accessorKey: "config_score_calculated",
                id: "configScore",
                Cell: ({ cell: cell })=>{
                    const value = cell.getValue();
                    return $01bb1c4a0639f9ce$export$449ac6ab2e997139(value);
                }
            },
            {
                header: "Probe Score",
                accessorKey: "probe_score_calculated",
                id: "probeScoreCalculated",
                Cell: ({ cell: cell })=>{
                    const value = cell.getValue();
                    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                        fontSize: "large",
                        children: $01bb1c4a0639f9ce$export$374d712138427485(value)
                    });
                }
            },
            {
                header: "Location",
                accessorKey: "explorer_pretty_bond.location.two_letter_iso_country_code",
                Cell: ({ cell: cell })=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8c326551a00e77e9$exports))), {
                        code: cell.getValue(),
                        width: "20"
                    })
            },
            {
                header: "Role",
                accessorKey: "self_described.role"
            },
            {
                header: "Bonded",
                accessorKey: "bonded",
                Cell: ({ cell: cell })=>cell.getValue() ? "\u2705" : "\u274C"
            },
            {
                header: "Blacklisted",
                accessorKey: "blacklisted",
                Cell: ({ cell: cell })=>cell.getValue() ? "\uD83D\uDD34" : ""
            },
            {
                header: "Mixnet Performance",
                accessorKey: "performance",
                Cell: ({ cell: cell })=>`${cell.getValue()}%`
            },
            {
                header: "Wireguard Performance",
                accessorKey: "wg_performance",
                Cell: ({ cell: cell })=>`${cell.getValue()}%`
            },
            {
                header: "Accepted Operator T&Cs",
                accessorKey: "self_described.auxiliary_details.accepted_operator_terms_and_conditions",
                Cell: ({ cell: cell })=>cell.getValue() ? "\u2705" : "\u274C"
            },
            {
                header: "Probe result",
                accessorKey: "last_probe_result",
                Cell: ({ cell: cell })=>{
                    const value = cell.getValue();
                    const logLines = cell.row.original?.last_probe_log || "";
                    const badges = [];
                    if (value?.outcome?.as_entry?.can_connect) badges.push(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
                        children: "\u2197\uFE0F"
                    }));
                    if (value?.outcome?.as_entry?.can_route) badges.push(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
                        children: "\uD83D\uDD00"
                    }));
                    if (value?.outcome?.as_exit?.can_connect) badges.push(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
                        children: "\u27A1\uFE0F"
                    }));
                    if (value?.outcome?.as_exit?.can_route_ip_v4) badges.push(/*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        style: {
                            opacity: 0.5
                        },
                        children: "4\uFE0F\u20E3"
                    }));
                    if (value?.outcome?.as_exit?.can_route_ip_v6) badges.push(/*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        style: {
                            opacity: 0.5
                        },
                        children: "6\uFE0F\u20E3"
                    }));
                    if (value?.outcome?.as_exit?.can_route_ip_external_v4) badges.push(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
                        children: "4\uFE0F\u20E3"
                    }));
                    if (value?.outcome?.as_exit?.can_route_ip_external_v6) badges.push(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
                        children: "6\uFE0F\u20E3"
                    }));
                    if (value?.outcome?.wg?.can_register && value?.outcome?.wg?.can_handshake) badges.push(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
                        children: "\u269B\uFE0F"
                    }));
                    if (value?.outcome?.wg?.can_register && !value?.outcome?.wg?.can_handshake) badges.push(/*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                        style: {
                            opacity: 0.2
                        },
                        children: "\u269B\uFE0F"
                    }));
                    if (value?.outcome?.wg?.can_resolve_dns) badges.push(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
                        children: "\uD83D\uDD24"
                    }));
                    if (value?.outcome?.wg?.ping_hosts_performance > 0.75 && value?.outcome?.wg?.ping_ips_performance > 0.75) badges.push(/*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
                        children: "\uD83D\uDEDC"
                    }));
                    return /*#__PURE__*/ (0, $aSiaI.jsx)($01bb1c4a0639f9ce$var$CustomWidthTooltip, {
                        placement: "left",
                        title: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                            py: 0,
                            my: 0,
                            component: "pre",
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("pre", {
                                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($114d365489223ff2$exports))), {
                                    children: logLines
                                })
                            })
                        }),
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c962e347330081ad$export$2e2bcd8739ae039), {
                            placement: "right",
                            title: /*#__PURE__*/ (0, $aSiaI.jsx)("pre", {
                                children: JSON.stringify(value, null, 2)
                            }),
                            children: /*#__PURE__*/ (0, $aSiaI.jsx)("span", {
                                children: badges
                            })
                        })
                    });
                }
            },
            {
                header: "Entry Gateway registers Wireguard peer?",
                accessorKey: "last_probe_result.outcome.wg.can_register",
                Cell: ({ cell: cell })=>cell.getValue() ? "\u2705" : "\u274C"
            },
            {
                header: "Entry Gateway does Wireguard handshake?",
                accessorKey: "last_probe_result.outcome.wg.can_handshake",
                Cell: ({ cell: cell })=>cell.getValue() ? "\u2705" : "\u274C"
            },
            {
                header: "Exit Gateway has IPR?",
                accessorKey: "self_described.ip_packet_router.address",
                Cell: ({ cell: cell })=>cell.getValue() ? "\u2705" : null
            },
            {
                header: "Exit Gateway has NR",
                accessorKey: "self_described.network_requester.address",
                Cell: ({ cell: cell })=>cell.getValue() ? "\u2705" : null
            },
            {
                header: "NR (uses exit policy)",
                accessorKey: "self_described.network_requester.uses_exit_policy",
                Cell: ({ cell: cell })=>cell.getValue() ? "\u2705" : null
            },
            {
                header: "Software Version",
                accessorKey: "self_described.build_information.build_version"
            },
            {
                header: "Git Commit Hash",
                accessorKey: "self_described.build_information.commit_sha",
                Cell: ({ cell: cell })=>/*#__PURE__*/ (0, $aSiaI.jsx)("code", {
                        children: cell.getValue()?.slice(0, 6)
                    })
            },
            {
                header: "Last Updated",
                accessorKey: "last_updated_utc",
                Cell: ({ cell: cell })=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $e7957d28d2172cc5$export$9a70222c5bedabe3), {
                        value: cell.getValue()
                    })
            },
            {
                header: "Last Successful Test Run",
                accessorKey: "last_testrun_utc",
                Cell: ({ cell: cell })=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $e7957d28d2172cc5$export$9a70222c5bedabe3), {
                        value: cell.getValue()
                    })
            }
        ], []);
    const table = (0, $35fd956d2f1c2be7$export$f43e1b352a4cbffc)({
        columns: columns,
        initialState: {
            pagination: {
                pageSize: 25,
                pageIndex: 0
            },
            density: "compact",
            showColumnFilters: true,
            sorting: [
                {
                    id: "probeScoreCalculated",
                    desc: true
                }
            ]
        },
        data: allGateways,
        enableRowSelection: true,
        enableColumnOrdering: false,
        enableGlobalFilter: false
    });
    if (!lastUpdated) return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        mt: 4,
        display: "flex",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8a947ac56b8361c3$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                fontSize: "larger",
                ml: 2,
                children: "Please wait while gathering rainbows and sorting kittens... \uD83C\uDF08\uD83D\uDE3C"
            })
        ]
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        children: [
            summary && gateways && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                mt: 2,
                pb: 2,
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e10e66deff206ed9$export$2e2bcd8739ae039), {
                    direction: "row",
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                                    fontWeight: 600,
                                    children: "Config scores"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f486dbc13fd8431d$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e5ef275ef7d6f0a3$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6c7022748d6b058b$export$222b3b6ff15ce4b0), {
                                                emoji: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d40123128680762a$export$2e2bcd8739ae039), {
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "right"
                                                    },
                                                    badgeContent: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                                                        fontSize: 30,
                                                        children: "\uD83D\uDE00"
                                                    }),
                                                    overlap: "circular",
                                                    children: "\uD83D\uDC3C"
                                                }),
                                                item: summary.termsAndConditions,
                                                total: gateways.length
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6c7022748d6b058b$export$222b3b6ff15ce4b0), {
                                                emoji: (0, $8d995646af892e7d$export$8387896f8e84cb45).panda.emoji,
                                                item: summary.configScores.pandas,
                                                total: gateways.length
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6c7022748d6b058b$export$222b3b6ff15ce4b0), {
                                                emoji: (0, $8d995646af892e7d$export$8387896f8e84cb45).dolphin.emoji,
                                                item: summary.configScores.dolphins,
                                                total: gateways.length
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6c7022748d6b058b$export$222b3b6ff15ce4b0), {
                                                emoji: (0, $8d995646af892e7d$export$8387896f8e84cb45).fox.emoji,
                                                item: summary.configScores.foxes,
                                                total: gateways.length
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6c7022748d6b058b$export$222b3b6ff15ce4b0), {
                                                emoji: (0, $8d995646af892e7d$export$8387896f8e84cb45).mouse.emoji,
                                                item: summary.configScores.mouses,
                                                total: gateways.length
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6c7022748d6b058b$export$222b3b6ff15ce4b0), {
                                                emoji: "\u2620\uFE0F",
                                                item: summary.unbonded,
                                                total: allGateways.length,
                                                hidePercentage: true
                                            })
                                        ]
                                    })
                                }),
                                gatewayVersions.length && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                                            fontWeight: 600,
                                            mt: 3,
                                            children: "Software versions"
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $07dda412218ab630$export$94aefc399ef206a9), {
                                            dataset: gatewayVersions,
                                            xAxis: [
                                                {
                                                    scaleType: "band",
                                                    dataKey: "version",
                                                    label: "Versions"
                                                }
                                            ],
                                            series: [
                                                {
                                                    dataKey: "count"
                                                }
                                            ],
                                            width: 500,
                                            height: 300,
                                            yAxis: [
                                                {
                                                    label: "Gateways"
                                                }
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                                    fontWeight: 600,
                                    children: "Routing scores"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f486dbc13fd8431d$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e5ef275ef7d6f0a3$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6c7022748d6b058b$export$222b3b6ff15ce4b0), {
                                                emoji: "\uD83E\uDD5C",
                                                item: summary.routingScores.peanuts,
                                                total: gateways.length
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6c7022748d6b058b$export$222b3b6ff15ce4b0), {
                                                emoji: "\uD83C\uDF66",
                                                item: summary.routingScores.icecreams,
                                                total: gateways.length
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6c7022748d6b058b$export$222b3b6ff15ce4b0), {
                                                emoji: "\uD83C\uDF7F",
                                                item: summary.routingScores.popcorns,
                                                total: gateways.length
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6c7022748d6b058b$export$222b3b6ff15ce4b0), {
                                                emoji: "\uD83C\uDF6D",
                                                item: summary.routingScores.lollies,
                                                total: gateways.length
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                mt: 5,
                py: 2,
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                        display: "flex",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                                children: busy ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                                    children: busyMessage || "Refreshing..."
                                }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $980dfff3cab72cf4$export$2e2bcd8739ae039), {
                                    variant: "outlined",
                                    onClick: refresh,
                                    children: "Refresh"
                                })
                            }),
                            lastUpdated && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e10e66deff206ed9$export$2e2bcd8739ae039), {
                                direction: "row",
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                                        children: "Last updated"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("strong", {
                                                children: (0, $08c0c798d1b2bf8a$export$2e2bcd8739ae039)(lastUpdated, {
                                                    addSuffix: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                            lastUpdated.toISOString()
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $35fd956d2f1c2be7$export$2506d3bf41f97512), {
                        table: table
                    })
                ]
            })
        ]
    });
};


/* eslint-disable react/no-unstable-nested-components */ 
var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


















const $f7e2d66ed9faf4d4$var$CACHE_KEY = "cache-mixnodes";
const $f7e2d66ed9faf4d4$export$a26ee9dff86d9aae = ()=>{
    const [mixnodes, setMixnodes] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState([]);
    const [mixnodeCount, setMixnodeCount] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState();
    const [lastUpdated, setLastUpdated] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState();
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [busyMessage, setBusyMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState();
    const [summary, setSummary] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(null);
    const refreshMixnodes = async ()=>{
        try {
            const items = await (0, $f66fa928cd4a99c0$export$644d8ea042df96a6).mixnodes();
            try {
                window.sessionStorage.setItem($f7e2d66ed9faf4d4$var$CACHE_KEY, JSON.stringify(items));
            } catch (ex) {
                console.error("Failed to store cache for mixnodes in session storage", ex);
            }
            setMixnodes(items);
            setMixnodeCount(items.length);
            setBusyMessage("Mixnode data updated...");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("Error getting services", e);
        }
    };
    const refresh = async ()=>{
        try {
            setBusy(true);
            setBusyMessage("Getting latest data...");
            await Promise.all([
                refreshMixnodes()
            ]);
            setLastUpdated(new Date());
            setBusyMessage("Finishing refresh...");
        } finally{
            setBusy(false);
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const storedMixnodes = window.sessionStorage.getItem($f7e2d66ed9faf4d4$var$CACHE_KEY);
        if (storedMixnodes?.length) try {
            setMixnodes(JSON.parse(storedMixnodes));
            setLastUpdated(new Date());
        } catch (_) {
        // do nothing
        }
        refresh();
        const timer = setInterval(refresh, 300000);
        return ()=>clearInterval(timer);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        setSummary({
            termsAndConditions: {
                count: mixnodes.filter((node)=>node.configScore?.acceptsTermsAndConditions === true).length,
                description: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
                    children: "\u2705 Accepted operator terms & conditions"
                })
            },
            latestNymNodes: {
                count: mixnodes.filter((node)=>node.configScore?.minBuildVersion === true).length,
                description: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                    children: [
                        "Runs ",
                        /*#__PURE__*/ (0, $aSiaI.jsx)("code", {
                            children: "nym-node"
                        }),
                        " ",
                        ">",
                        " v",
                        (0, $8d995646af892e7d$export$149ea0a63fc31f44)
                    ]
                })
            },
            nymNodes: {
                count: mixnodes.filter((node)=>node.configScore?.runsNymnode === true && node.configScore?.minBuildVersion === false).length,
                description: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                    children: [
                        "Runs ",
                        /*#__PURE__*/ (0, $aSiaI.jsx)("code", {
                            children: "nym-node"
                        })
                    ]
                })
            },
            unbonded: {
                count: mixnodes.filter((node)=>!node.bonded).length,
                description: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
                    children: "Unbonded nodes"
                })
            }
        });
    }, [
        mixnodes
    ]);
    const mixnodeVersions = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useMemo(()=>{
        const versions = {
            unknown: 0
        };
        mixnodes.filter((g)=>g.bonded).map((g)=>g.self_described?.self_described?.build_information?.build_version).forEach((version)=>{
            if (version) {
                if (!versions[version]) versions[version] = 0;
                versions[version] += 1;
            } else versions.unknown += 1;
        });
        return Object.keys(versions).map((v)=>({
                version: v,
                count: versions[v]
            })).sort((a, b)=>{
            if (a.version === "unknown" || b.version === "unknown") return -1;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6abb42b6d3bcba21$exports)))(a.version, b.version);
        });
    }, [
        mixnodes
    ]);
    const columns = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useMemo(()=>[
            {
                header: "Mix Id",
                accessorKey: "mix_id",
                Cell: ({ cell: cell })=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $c14ca1eac99fe440$export$2e2bcd8739ae039), {
                        component: (0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a),
                        to: `/mixnode/${cell.getValue()}`,
                        children: cell.getValue()
                    })
            },
            {
                header: "Moniker",
                accessorKey: "description.moniker"
            },
            {
                header: "Identity Key",
                accessorKey: "full_details.mixnode_details.bond_information.mix_node.identity_key",
                Cell: ({ cell: cell })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $c14ca1eac99fe440$export$2e2bcd8739ae039), {
                        component: (0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a),
                        to: `/mixnode/${cell.row.original.mix_id}`,
                        children: [
                            cell.getValue().slice(0, 10),
                            "..."
                        ]
                    })
            },
            {
                header: "Total Stake",
                accessorKey: "total_stake",
                Cell: ({ cell: cell })=>{
                    const value = cell.getValue();
                    if (!value) return "-";
                    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                        textAlign: "right",
                        mr: 2,
                        children: [
                            (value.valueOf() / 1e6).toLocaleString("lookup", {
                                style: "decimal",
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            }),
                            " ",
                            "NYM"
                        ]
                    });
                }
            },
            {
                header: "Bonded",
                accessorKey: "bonded",
                Cell: ({ cell: cell })=>cell.getValue() ? "\u2705" : "\u274C"
            },
            {
                header: "Blacklisted",
                accessorKey: "blacklisted",
                Cell: ({ cell: cell })=>cell.getValue() ? "\uD83D\uDD34" : ""
            },
            {
                header: "DP Delegatee",
                accessorKey: "is_dp_delegatee",
                Cell: ({ cell: cell })=>cell.getValue() ? "\u2705" : "\u274C"
            },
            {
                header: "Accepted T&Cs",
                accessorKey: "self_described.self_described.auxiliary_details.accepted_operator_terms_and_conditions",
                Cell: ({ cell: cell })=>cell.getValue() ? "\u2705" : "\u274C"
            },
            {
                header: "Performance",
                accessorKey: "full_details.performance"
            },
            {
                header: "Stake Saturation",
                accessorKey: "full_details.stake_saturation"
            },
            {
                header: "Software Version",
                accessorKey: "self_described.self_described.build_information.build_version"
            },
            {
                header: "Git Commit Hash",
                accessorKey: "self_described.self_described.build_information.commit_sha",
                Cell: ({ cell: cell })=>/*#__PURE__*/ (0, $aSiaI.jsx)("code", {
                        children: cell.getValue()?.slice(0, 6)
                    })
            },
            {
                header: "Last Updated",
                accessorKey: "last_updated_utc",
                Cell: ({ cell: cell })=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $e7957d28d2172cc5$export$9a70222c5bedabe3), {
                        value: cell.getValue()
                    })
            }
        ], []);
    const table = (0, $35fd956d2f1c2be7$export$f43e1b352a4cbffc)({
        columns: columns,
        initialState: {
            pagination: {
                pageSize: 25,
                pageIndex: 0
            },
            density: "compact",
            showColumnFilters: true,
            sorting: [
                {
                    id: "total_stake",
                    desc: true
                }
            ]
        },
        data: mixnodes,
        enableRowSelection: true,
        enableColumnOrdering: false,
        enableGlobalFilter: false
    });
    if (!lastUpdated) return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        mt: 4,
        display: "flex",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8a947ac56b8361c3$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                fontSize: "larger",
                ml: 2,
                children: "Please wait while gathering rainbows and sorting kittens... \uD83C\uDF08\uD83D\uDE3C"
            })
        ]
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
            mt: 5,
            py: 2,
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                    mt: 2,
                    pb: 4,
                    children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e10e66deff206ed9$export$2e2bcd8739ae039), {
                        direction: "row",
                        spacing: 4,
                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                                    fontWeight: 600,
                                    children: "Config scores"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f486dbc13fd8431d$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e5ef275ef7d6f0a3$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6c7022748d6b058b$export$222b3b6ff15ce4b0), {
                                                emoji: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d40123128680762a$export$2e2bcd8739ae039), {
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "right"
                                                    },
                                                    badgeContent: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                                                        fontSize: 30,
                                                        children: "\uD83D\uDE00"
                                                    }),
                                                    overlap: "circular",
                                                    children: "\uD83D\uDC3C"
                                                }),
                                                item: summary.termsAndConditions,
                                                total: mixnodes.length
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6c7022748d6b058b$export$222b3b6ff15ce4b0), {
                                                emoji: "\uD83D\uDC3C\uFE0F",
                                                item: summary.latestNymNodes,
                                                total: mixnodes.length
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6c7022748d6b058b$export$222b3b6ff15ce4b0), {
                                                emoji: "\uD83D\uDC2C",
                                                item: summary.nymNodes,
                                                total: mixnodes.length
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6c7022748d6b058b$export$222b3b6ff15ce4b0), {
                                                emoji: "\u2620\uFE0F",
                                                item: summary.unbonded,
                                                total: mixnodes.length,
                                                hidePercentage: true
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                }),
                mixnodeVersions.length && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                            fontWeight: 600,
                            mt: 3,
                            children: "Software versions"
                        }),
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $07dda412218ab630$export$94aefc399ef206a9), {
                            dataset: mixnodeVersions,
                            xAxis: [
                                {
                                    scaleType: "band",
                                    dataKey: "version",
                                    label: "Versions"
                                }
                            ],
                            series: [
                                {
                                    dataKey: "count"
                                }
                            ],
                            width: 500,
                            height: 300,
                            yAxis: [
                                {
                                    label: "Mixnodes"
                                }
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                    display: "flex",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                            children: busy ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                                children: busyMessage || "Refreshing..."
                            }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $980dfff3cab72cf4$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                onClick: refresh,
                                children: "Refresh"
                            })
                        }),
                        lastUpdated && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e10e66deff206ed9$export$2e2bcd8739ae039), {
                            direction: "row",
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                                    children: "Last updated"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("strong", {
                                            children: (0, $08c0c798d1b2bf8a$export$2e2bcd8739ae039)(lastUpdated, {
                                                addSuffix: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                        lastUpdated.toISOString()
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $35fd956d2f1c2be7$export$2506d3bf41f97512), {
                    table: table
                })
            ]
        })
    });
};




var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");

var $aJx1R = parcelRequire("aJx1R");

var $exYeM = parcelRequire("exYeM");


var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");
parcelRequire("exYeM");



function $604fd653e4bbe463$var$Linear(context) {
    this._context = context;
}
$604fd653e4bbe463$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $604fd653e4bbe463$export$2e2bcd8739ae039(context) {
    return new $604fd653e4bbe463$var$Linear(context);
}





const $2283eeea20a117ed$var$pi = Math.PI, $2283eeea20a117ed$var$tau = 2 * $2283eeea20a117ed$var$pi, $2283eeea20a117ed$var$epsilon = 1e-6, $2283eeea20a117ed$var$tauEpsilon = $2283eeea20a117ed$var$tau - $2283eeea20a117ed$var$epsilon;
function $2283eeea20a117ed$var$append(strings) {
    this._ += strings[0];
    for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
}
function $2283eeea20a117ed$var$appendRound(digits) {
    let d = Math.floor(digits);
    if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
    if (d > 15) return $2283eeea20a117ed$var$append;
    const k = 10 ** d;
    return function(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
    };
}
class $2283eeea20a117ed$export$4b2950bdac9b6ee9 {
    constructor(digits){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
        this._append = digits == null ? $2283eeea20a117ed$var$append : $2283eeea20a117ed$var$appendRound(digits);
    }
    moveTo(x, y) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._append`Z`;
        }
    }
    lineTo(x, y) {
        this._append`L${this._x1 = +x},${this._y1 = +y}`;
    }
    quadraticCurveTo(x1, y1, x, y) {
        this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
    }
    arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._append`M${this._x1 = x1},${this._y1 = y1}`;
        else if (!(l01_2 > $2283eeea20a117ed$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $2283eeea20a117ed$var$epsilon) || !r) this._append`L${this._x1 = x1},${this._y1 = y1}`;
        else {
            let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($2283eeea20a117ed$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $2283eeea20a117ed$var$epsilon) this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
            this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
        }
    }
    arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._append`M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $2283eeea20a117ed$var$epsilon || Math.abs(this._y1 - y0) > $2283eeea20a117ed$var$epsilon) this._append`L${x0},${y0}`;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $2283eeea20a117ed$var$tau + $2283eeea20a117ed$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $2283eeea20a117ed$var$tauEpsilon) this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
        else if (da > $2283eeea20a117ed$var$epsilon) this._append`A${r},${r},0,${+(da >= $2283eeea20a117ed$var$pi)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
    rect(x, y, w, h) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
    }
    toString() {
        return this._;
    }
}
function $2283eeea20a117ed$export$bb654e07daaf8c3a() {
    return new $2283eeea20a117ed$export$4b2950bdac9b6ee9;
}
// Allow instanceof d3.path
$2283eeea20a117ed$export$bb654e07daaf8c3a.prototype = $2283eeea20a117ed$export$4b2950bdac9b6ee9.prototype;
function $2283eeea20a117ed$export$e181c6ece8d9cc5f(digits = 3) {
    return new $2283eeea20a117ed$export$4b2950bdac9b6ee9(+digits);
}


function $4c5e3c9f20f937f2$export$fb6e83118a5dcd45(shape) {
    let digits = 3;
    shape.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        return shape;
    };
    return ()=>new (0, $2283eeea20a117ed$export$4b2950bdac9b6ee9)(digits);
}


function $e0ce667ae06f073b$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $e0ce667ae06f073b$export$4a5767248b18ef41(p) {
    return p[1];
}


function $174f59d7958167f4$export$2e2bcd8739ae039(x, y) {
    var defined = (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(true), context = null, curve = (0, $604fd653e4bbe463$export$2e2bcd8739ae039), output = null, path = (0, $4c5e3c9f20f937f2$export$fb6e83118a5dcd45)(line);
    x = typeof x === "function" ? x : x === undefined ? (0, $e0ce667ae06f073b$export$d141bba7fdc215a3) : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(x);
    y = typeof y === "function" ? y : y === undefined ? (0, $e0ce667ae06f073b$export$4a5767248b18ef41) : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(y);
    function line(data) {
        var i, n = (data = (0, $3fa1b8e94adeb982$export$2e2bcd8739ae039)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = path());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}




function $d30574d09f1dcc18$export$2e2bcd8739ae039(x0, y0, y1) {
    var x1 = null, defined = (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(true), context = null, curve = (0, $604fd653e4bbe463$export$2e2bcd8739ae039), output = null, path = (0, $4c5e3c9f20f937f2$export$fb6e83118a5dcd45)(area);
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? (0, $e0ce667ae06f073b$export$d141bba7fdc215a3) : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(0) : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? (0, $e0ce667ae06f073b$export$4a5767248b18ef41) : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $3fa1b8e94adeb982$export$2e2bcd8739ae039)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = path());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $174f59d7958167f4$export$2e2bcd8739ae039)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}




var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");
parcelRequire("exYeM");


var $2f0D3 = parcelRequire("2f0D3");


var $dC5O8 = parcelRequire("dC5O8");

var $kY7HX = parcelRequire("kY7HX");


var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $jawKn = parcelRequire("jawKn");

var $1tQWc = parcelRequire("1tQWc");


var $exYeM = parcelRequire("exYeM");


function $a90ba9a122a54b04$var$usePrevious(value) {
    const ref = $exYeM.useRef(null);
    $exYeM.useEffect(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
const $a90ba9a122a54b04$export$6b8391a1442f2172 = (path, skipAnimation)=>{
    const previousPath = $a90ba9a122a54b04$var$usePrevious(path);
    const interpolator = $exYeM.useMemo(()=>previousPath ? (0, $1ef9a1579573abd1$export$2e2bcd8739ae039)(previousPath, path) : ()=>path, [
        previousPath,
        path
    ]);
    const { value: value } = (0, $9f726edb03f4840c$export$c4af9125706c4d30)({
        from: {
            value: 0
        },
        to: {
            value: 1
        },
        reset: true,
        immediate: skipAnimation
    });
    return (0, $9f726edb03f4840c$export$2c618a4308a30424)([
        value
    ], interpolator);
};


/**
 * Remove spaces to have viable ids
 */ function $b30b938d228df3cc$export$596bdd6a1862c0b0(id) {
    return id.replace(" ", "_");
}




var $aSiaI = parcelRequire("aSiaI");
const $21b0f4bff9ad8246$var$_excluded = [
    "d",
    "skipAnimation",
    "ownerState"
];
const $21b0f4bff9ad8246$export$5271074bdf2bc646 = (0, $jawKn.default)((0, $f9aea5876333360d$export$407448d2b89b1813).path, {
    name: "MuiAreaElement",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ ownerState: ownerState })=>({
        stroke: "none",
        fill: ownerState.gradientId && `url(#${ownerState.gradientId})` || ownerState.isHighlighted && (0, $1tQWc.default)(ownerState.color).brighter(1).formatHex() || (0, $1tQWc.default)(ownerState.color).brighter(0.5).formatHex(),
        transition: "opacity 0.2s ease-in, fill 0.2s ease-in",
        opacity: ownerState.isFaded ? 0.3 : 1
    }));
/**
 * Demos:
 *
 * - [Lines](https://mui.com/x/react-charts/lines/)
 * - [Areas demonstration](https://mui.com/x/react-charts/areas-demo/)
 *
 * API:
 *
 * - [AreaElement API](https://mui.com/x/api/charts/animated-area/)
 */ function $21b0f4bff9ad8246$export$2233419e879e015b(props) {
    const { d: d, skipAnimation: skipAnimation, ownerState: ownerState } = props, other = (0, $3L80X.default)(props, $21b0f4bff9ad8246$var$_excluded);
    const { left: left, top: top, right: right, bottom: bottom, width: width, height: height } = (0, $767eebe86d6e6272$export$389be1739214a0a2)();
    const chartId = (0, $0b3940f442933067$export$310c4c2c8f792eac)();
    const path = (0, $a90ba9a122a54b04$export$6b8391a1442f2172)(d, skipAnimation);
    const { animatedWidth: animatedWidth } = (0, $9f726edb03f4840c$export$c4af9125706c4d30)({
        from: {
            animatedWidth: left
        },
        to: {
            animatedWidth: width + left + right
        },
        reset: false,
        immediate: skipAnimation
    });
    const clipId = (0, $b30b938d228df3cc$export$596bdd6a1862c0b0)(`${chartId}-${ownerState.id}-area-clip`);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("clipPath", {
                id: clipId,
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f9aea5876333360d$export$407448d2b89b1813).rect, {
                    x: 0,
                    y: 0,
                    width: animatedWidth,
                    height: top + height + bottom
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("g", {
                clipPath: `url(#${clipId})`,
                children: /*#__PURE__*/ (0, $aSiaI.jsx)($21b0f4bff9ad8246$export$5271074bdf2bc646, (0, $aJx1R.default)({}, other, {
                    ownerState: ownerState,
                    d: path
                }))
            })
        ]
    });
}




var $aSiaI = parcelRequire("aSiaI");
const $522e445bb8fc0d23$var$_excluded = [
    "id",
    "classes",
    "color",
    "gradientId",
    "slots",
    "slotProps",
    "onClick"
];
function $522e445bb8fc0d23$export$9792cf2d88857da6(slot) {
    return (0, $dC5O8.default)("MuiAreaElement", slot);
}
const $522e445bb8fc0d23$export$f7dbc3de6c62ee50 = (0, $kY7HX.default)("MuiAreaElement", [
    "root",
    "highlighted",
    "faded"
]);
const $522e445bb8fc0d23$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, id: id, isFaded: isFaded, isHighlighted: isHighlighted } = ownerState;
    const slots = {
        root: [
            "root",
            `series-${id}`,
            isHighlighted && "highlighted",
            isFaded && "faded"
        ]
    };
    return (0, $2f0D3.default)(slots, $522e445bb8fc0d23$export$9792cf2d88857da6, classes);
};
/**
 * Demos:
 *
 * - [Lines](https://mui.com/x/react-charts/lines/)
 * - [Areas demonstration](https://mui.com/x/react-charts/areas-demo/)
 *
 * API:
 *
 * - [AreaElement API](https://mui.com/x/api/charts/area-element/)
 */ function $522e445bb8fc0d23$export$f7195779a3039be(props) {
    const { id: id, classes: innerClasses, color: color, gradientId: gradientId, slots: slots, slotProps: slotProps, onClick: onClick } = props, other = (0, $3L80X.default)(props, $522e445bb8fc0d23$var$_excluded);
    const getInteractionItemProps = (0, $d203c2c9b69fd133$export$306117b585a4c625)();
    const { isFaded: isFaded, isHighlighted: isHighlighted } = (0, $773c45430f70b33a$export$df217abb95936ce9)({
        seriesId: id
    });
    const ownerState = {
        id: id,
        classes: innerClasses,
        color: color,
        gradientId: gradientId,
        isFaded: isFaded,
        isHighlighted: isHighlighted
    };
    const classes = $522e445bb8fc0d23$var$useUtilityClasses(ownerState);
    const Area = slots?.area ?? (0, $21b0f4bff9ad8246$export$2233419e879e015b);
    const areaProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: Area,
        externalSlotProps: slotProps?.area,
        additionalProps: (0, $aJx1R.default)({}, getInteractionItemProps({
            type: "line",
            seriesId: id
        }), {
            onClick: onClick,
            cursor: onClick ? "pointer" : "unset"
        }),
        className: classes.root,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)(Area, (0, $aJx1R.default)({}, other, areaProps));
}




var $dYto6 = parcelRequire("dYto6");function $a3ea6bad8f970c89$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $a3ea6bad8f970c89$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($a3ea6bad8f970c89$var$sign(s0) + $a3ea6bad8f970c89$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $a3ea6bad8f970c89$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $a3ea6bad8f970c89$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $a3ea6bad8f970c89$var$MonotoneX(context) {
    this._context = context;
}
$a3ea6bad8f970c89$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $a3ea6bad8f970c89$var$point(this, this._t0, $a3ea6bad8f970c89$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $a3ea6bad8f970c89$var$point(this, $a3ea6bad8f970c89$var$slope2(this, t1 = $a3ea6bad8f970c89$var$slope3(this, x, y)), t1);
                break;
            default:
                $a3ea6bad8f970c89$var$point(this, this._t0, t1 = $a3ea6bad8f970c89$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $a3ea6bad8f970c89$var$MonotoneY(context) {
    this._context = new $a3ea6bad8f970c89$var$ReflectContext(context);
}
($a3ea6bad8f970c89$var$MonotoneY.prototype = Object.create($a3ea6bad8f970c89$var$MonotoneX.prototype)).point = function(x, y) {
    $a3ea6bad8f970c89$var$MonotoneX.prototype.point.call(this, y, x);
};
function $a3ea6bad8f970c89$var$ReflectContext(context) {
    this._context = context;
}
$a3ea6bad8f970c89$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $a3ea6bad8f970c89$export$99563b5420dbdc55(context) {
    return new $a3ea6bad8f970c89$var$MonotoneX(context);
}
function $a3ea6bad8f970c89$export$8b5360456d6bdb88(context) {
    return new $a3ea6bad8f970c89$var$MonotoneY(context);
}

function $bcd9f70ddee99a66$var$Natural(context) {
    this._context = context;
}
$bcd9f70ddee99a66$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $bcd9f70ddee99a66$var$controlPoints(x), py = $bcd9f70ddee99a66$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $bcd9f70ddee99a66$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $bcd9f70ddee99a66$export$2e2bcd8739ae039(context) {
    return new $bcd9f70ddee99a66$var$Natural(context);
}

function $43a583537398228e$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$43a583537398228e$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $43a583537398228e$export$2e2bcd8739ae039(context) {
    return new $43a583537398228e$var$Step(context, 0.5);
}
function $43a583537398228e$export$10eafa5b7478b343(context) {
    return new $43a583537398228e$var$Step(context, 0);
}
function $43a583537398228e$export$793b3db073781cbb(context) {
    return new $43a583537398228e$var$Step(context, 1);
}


function $70e0c377af2239cf$export$2e2bcd8739ae039(curveType) {
    switch(curveType){
        case "catmullRom":
            return (0, $dYto6.default).alpha(0.5);
        case "linear":
            return 0, $604fd653e4bbe463$export$2e2bcd8739ae039;
        case "monotoneX":
            return 0, $a3ea6bad8f970c89$export$99563b5420dbdc55;
        case "monotoneY":
            return 0, $a3ea6bad8f970c89$export$8b5360456d6bdb88;
        case "natural":
            return 0, $bcd9f70ddee99a66$export$2e2bcd8739ae039;
        case "step":
            return 0, $43a583537398228e$export$2e2bcd8739ae039;
        case "stepBefore":
            return 0, $43a583537398228e$export$10eafa5b7478b343;
        case "stepAfter":
            return 0, $43a583537398228e$export$793b3db073781cbb;
        default:
            return 0, $a3ea6bad8f970c89$export$99563b5420dbdc55;
    }
}






var $aSiaI = parcelRequire("aSiaI");
const $dfed42648ba8d93b$var$_excluded = [
    "slots",
    "slotProps",
    "onItemClick",
    "skipAnimation"
];
const $dfed42648ba8d93b$var$useAggregatedData = ()=>{
    const seriesData = (0, $ba69253362075717$export$f7090460c70512f0)();
    const axisData = (0, $27adb4455fa596cf$export$2785a2cc09fc5c5f)();
    if (seriesData === undefined) return [];
    const { series: series, stackingGroups: stackingGroups } = seriesData;
    const { xAxis: xAxis, yAxis: yAxis, xAxisIds: xAxisIds, yAxisIds: yAxisIds } = axisData;
    const defaultXAxisId = xAxisIds[0];
    const defaultYAxisId = yAxisIds[0];
    return stackingGroups.flatMap(({ ids: groupIds })=>{
        return [
            ...groupIds
        ].reverse() // Revert stacked area for a more pleasant animation
        .map((seriesId)=>{
            const { xAxisKey: xAxisKey = defaultXAxisId, yAxisKey: yAxisKey = defaultYAxisId, stackedData: stackedData, data: data, connectNulls: connectNulls } = series[seriesId];
            const xScale = (0, $fe42cc92ff5d0a37$export$612517523e588e9d)(xAxis[xAxisKey].scale);
            const yScale = yAxis[yAxisKey].scale;
            const xData = xAxis[xAxisKey].data;
            const gradientUsed = yAxis[yAxisKey].colorScale && [
                yAxisKey,
                "y"
            ] || xAxis[xAxisKey].colorScale && [
                xAxisKey,
                "x"
            ] || undefined;
            const areaPath = (0, $d30574d09f1dcc18$export$2e2bcd8739ae039)().x((d)=>xScale(d.x)).defined((_, i)=>connectNulls || data[i] != null).y0((d)=>{
                const value = d.y && yScale(d.y[0]);
                if (Number.isNaN(value)) return yScale.range()[0];
                return value;
            }).y1((d)=>d.y && yScale(d.y[1]));
            const curve = (0, $70e0c377af2239cf$export$2e2bcd8739ae039)(series[seriesId].curve);
            const formattedData = xData?.map((x, index)=>({
                    x: x,
                    y: stackedData[index]
                })) ?? [];
            const d3Data = connectNulls ? formattedData.filter((_, i)=>data[i] != null) : formattedData;
            const d = areaPath.curve(curve)(d3Data) || "";
            return (0, $aJx1R.default)({}, series[seriesId], {
                gradientUsed: gradientUsed,
                d: d,
                seriesId: seriesId
            });
        });
    });
};
/**
 * Demos:
 *
 * - [Lines](https://mui.com/x/react-charts/lines/)
 * - [Areas demonstration](https://mui.com/x/react-charts/areas-demo/)
 * - [Stacking](https://mui.com/x/react-charts/stacking/)
 *
 * API:
 *
 * - [AreaPlot API](https://mui.com/x/api/charts/area-plot/)
 */ function $dfed42648ba8d93b$export$6a7fe11371d21fcb(props) {
    const { slots: slots, slotProps: slotProps, onItemClick: onItemClick, skipAnimation: skipAnimation } = props, other = (0, $3L80X.default)(props, $dfed42648ba8d93b$var$_excluded);
    const getGradientId = (0, $8d0bf2f3d2b10f17$export$fa70c633f5692acb)();
    const completedData = $dfed42648ba8d93b$var$useAggregatedData();
    return /*#__PURE__*/ (0, $aSiaI.jsx)("g", (0, $aJx1R.default)({}, other, {
        children: completedData.map(({ d: d, seriesId: seriesId, color: color, area: area, gradientUsed: gradientUsed })=>!!area && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $522e445bb8fc0d23$export$f7195779a3039be), {
                id: seriesId,
                d: d,
                color: color,
                gradientId: gradientUsed && getGradientId(...gradientUsed),
                slots: slots,
                slotProps: slotProps,
                onClick: onItemClick && ((event)=>onItemClick(event, {
                        type: "line",
                        seriesId: seriesId
                    })),
                skipAnimation: skipAnimation
            }, seriesId))
    }));
}



var $3L80X = parcelRequire("3L80X");

var $aJx1R = parcelRequire("aJx1R");
parcelRequire("exYeM");




var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");
parcelRequire("exYeM");


var $2f0D3 = parcelRequire("2f0D3");


var $dC5O8 = parcelRequire("dC5O8");

var $kY7HX = parcelRequire("kY7HX");


var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");



var $1tQWc = parcelRequire("1tQWc");

var $jawKn = parcelRequire("jawKn");





var $aSiaI = parcelRequire("aSiaI");
const $2ea6193d23b2718e$var$_excluded = [
    "d",
    "skipAnimation",
    "ownerState"
];
const $2ea6193d23b2718e$export$7e7694aa04689c4d = (0, $jawKn.default)((0, $f9aea5876333360d$export$407448d2b89b1813).path, {
    name: "MuiLineElement",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ ownerState: ownerState })=>({
        strokeWidth: 2,
        strokeLinejoin: "round",
        fill: "none",
        stroke: ownerState.gradientId && `url(#${ownerState.gradientId})` || ownerState.isHighlighted && (0, $1tQWc.default)(ownerState.color).brighter(0.5).formatHex() || ownerState.color,
        transition: "opacity 0.2s ease-in, stroke 0.2s ease-in",
        opacity: ownerState.isFaded ? 0.3 : 1
    }));
/**
 * Demos:
 *
 * - [Lines](https://mui.com/x/react-charts/lines/)
 * - [Line demonstration](https://mui.com/x/react-charts/line-demo/)
 *
 * API:
 *
 * - [AnimatedLine API](https://mui.com/x/api/charts/animated-line/)
 */ function $2ea6193d23b2718e$export$137267c173e9e757(props) {
    const { d: d, skipAnimation: skipAnimation, ownerState: ownerState } = props, other = (0, $3L80X.default)(props, $2ea6193d23b2718e$var$_excluded);
    const { left: left, top: top, bottom: bottom, width: width, height: height, right: right } = (0, $767eebe86d6e6272$export$389be1739214a0a2)();
    const chartId = (0, $0b3940f442933067$export$310c4c2c8f792eac)();
    const path = (0, $a90ba9a122a54b04$export$6b8391a1442f2172)(d, skipAnimation);
    const { animatedWidth: animatedWidth } = (0, $9f726edb03f4840c$export$c4af9125706c4d30)({
        from: {
            animatedWidth: left
        },
        to: {
            animatedWidth: width + left + right
        },
        reset: false,
        immediate: skipAnimation
    });
    const clipId = (0, $b30b938d228df3cc$export$596bdd6a1862c0b0)(`${chartId}-${ownerState.id}-line-clip`);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)($exYeM.Fragment, {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)("clipPath", {
                id: clipId,
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f9aea5876333360d$export$407448d2b89b1813).rect, {
                    x: 0,
                    y: 0,
                    width: animatedWidth,
                    height: top + height + bottom
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("g", {
                clipPath: `url(#${clipId})`,
                children: /*#__PURE__*/ (0, $aSiaI.jsx)($2ea6193d23b2718e$export$7e7694aa04689c4d, (0, $aJx1R.default)({}, other, {
                    ownerState: ownerState,
                    d: path
                }))
            })
        ]
    });
}




var $aSiaI = parcelRequire("aSiaI");
const $ef0215d7047ce5ce$var$_excluded = [
    "id",
    "classes",
    "color",
    "gradientId",
    "slots",
    "slotProps",
    "onClick"
];
function $ef0215d7047ce5ce$export$6779aa8f484ea3bb(slot) {
    return (0, $dC5O8.default)("MuiLineElement", slot);
}
const $ef0215d7047ce5ce$export$4e84c3c498217c95 = (0, $kY7HX.default)("MuiLineElement", [
    "root",
    "highlighted",
    "faded"
]);
const $ef0215d7047ce5ce$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, id: id, isFaded: isFaded, isHighlighted: isHighlighted } = ownerState;
    const slots = {
        root: [
            "root",
            `series-${id}`,
            isHighlighted && "highlighted",
            isFaded && "faded"
        ]
    };
    return (0, $2f0D3.default)(slots, $ef0215d7047ce5ce$export$6779aa8f484ea3bb, classes);
};
/**
 * Demos:
 *
 * - [Lines](https://mui.com/x/react-charts/lines/)
 * - [Line demonstration](https://mui.com/x/react-charts/line-demo/)
 *
 * API:
 *
 * - [LineElement API](https://mui.com/x/api/charts/line-element/)
 */ function $ef0215d7047ce5ce$export$55e463fa7bcd3469(props) {
    const { id: id, classes: innerClasses, color: color, gradientId: gradientId, slots: slots, slotProps: slotProps, onClick: onClick } = props, other = (0, $3L80X.default)(props, $ef0215d7047ce5ce$var$_excluded);
    const getInteractionItemProps = (0, $d203c2c9b69fd133$export$306117b585a4c625)();
    const { isFaded: isFaded, isHighlighted: isHighlighted } = (0, $773c45430f70b33a$export$df217abb95936ce9)({
        seriesId: id
    });
    const ownerState = {
        id: id,
        classes: innerClasses,
        color: color,
        gradientId: gradientId,
        isFaded: isFaded,
        isHighlighted: isHighlighted
    };
    const classes = $ef0215d7047ce5ce$var$useUtilityClasses(ownerState);
    const Line = slots?.line ?? (0, $2ea6193d23b2718e$export$137267c173e9e757);
    const lineProps = (0, $49b1f8e5a9993ff9$export$1e5c9e6e4e15efe3)({
        elementType: Line,
        externalSlotProps: slotProps?.line,
        additionalProps: (0, $aJx1R.default)({}, getInteractionItemProps({
            type: "line",
            seriesId: id
        }), {
            onClick: onClick,
            cursor: onClick ? "pointer" : "unset"
        }),
        className: classes.root,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $aSiaI.jsx)(Line, (0, $aJx1R.default)({}, other, lineProps));
}








var $aSiaI = parcelRequire("aSiaI");
const $08ee19062e976d48$var$_excluded = [
    "slots",
    "slotProps",
    "skipAnimation",
    "onItemClick"
];
const $08ee19062e976d48$var$useAggregatedData = ()=>{
    const seriesData = (0, $ba69253362075717$export$f7090460c70512f0)();
    const axisData = (0, $27adb4455fa596cf$export$2785a2cc09fc5c5f)();
    if (seriesData === undefined) return [];
    const { series: series, stackingGroups: stackingGroups } = seriesData;
    const { xAxis: xAxis, yAxis: yAxis, xAxisIds: xAxisIds, yAxisIds: yAxisIds } = axisData;
    const defaultXAxisId = xAxisIds[0];
    const defaultYAxisId = yAxisIds[0];
    return stackingGroups.flatMap(({ ids: groupIds })=>{
        return groupIds.flatMap((seriesId)=>{
            const { xAxisKey: xAxisKey = defaultXAxisId, yAxisKey: yAxisKey = defaultYAxisId, stackedData: stackedData, data: data, connectNulls: connectNulls } = series[seriesId];
            const xScale = (0, $fe42cc92ff5d0a37$export$612517523e588e9d)(xAxis[xAxisKey].scale);
            const yScale = yAxis[yAxisKey].scale;
            const xData = xAxis[xAxisKey].data;
            const gradientUsed = yAxis[yAxisKey].colorScale && [
                yAxisKey,
                "y"
            ] || xAxis[xAxisKey].colorScale && [
                xAxisKey,
                "x"
            ] || undefined;
            const linePath = (0, $174f59d7958167f4$export$2e2bcd8739ae039)().x((d)=>xScale(d.x)).defined((_, i)=>connectNulls || data[i] != null).y((d)=>yScale(d.y[1]));
            const formattedData = xData?.map((x, index)=>({
                    x: x,
                    y: stackedData[index]
                })) ?? [];
            const d3Data = connectNulls ? formattedData.filter((_, i)=>data[i] != null) : formattedData;
            const d = linePath.curve((0, $70e0c377af2239cf$export$2e2bcd8739ae039)(series[seriesId].curve))(d3Data) || "";
            return (0, $aJx1R.default)({}, series[seriesId], {
                gradientUsed: gradientUsed,
                d: d,
                seriesId: seriesId
            });
        });
    });
};
/**
 * Demos:
 *
 * - [Lines](https://mui.com/x/react-charts/lines/)
 * - [Line demonstration](https://mui.com/x/react-charts/line-demo/)
 *
 * API:
 *
 * - [LinePlot API](https://mui.com/x/api/charts/line-plot/)
 */ function $08ee19062e976d48$export$43894928ea4c1421(props) {
    const { slots: slots, slotProps: slotProps, skipAnimation: skipAnimation, onItemClick: onItemClick } = props, other = (0, $3L80X.default)(props, $08ee19062e976d48$var$_excluded);
    const getGradientId = (0, $8d0bf2f3d2b10f17$export$fa70c633f5692acb)();
    const completedData = $08ee19062e976d48$var$useAggregatedData();
    return /*#__PURE__*/ (0, $aSiaI.jsx)("g", (0, $aJx1R.default)({}, other, {
        children: completedData.map(({ d: d, seriesId: seriesId, color: color, gradientUsed: gradientUsed })=>{
            return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $ef0215d7047ce5ce$export$55e463fa7bcd3469), {
                id: seriesId,
                d: d,
                color: color,
                gradientId: gradientUsed && getGradientId(...gradientUsed),
                skipAnimation: skipAnimation,
                slots: slots,
                slotProps: slotProps,
                onClick: onItemClick && ((event)=>onItemClick(event, {
                        type: "line",
                        seriesId: seriesId
                    }))
            }, seriesId);
        })
    }));
}




var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");
parcelRequire("exYeM");



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");


var $2f0D3 = parcelRequire("2f0D3");

var $dC5O8 = parcelRequire("dC5O8");

var $jawKn = parcelRequire("jawKn");

var $kY7HX = parcelRequire("kY7HX");



var $4yPBQ = parcelRequire("4yPBQ");
const $416ea7421344a620$var$sqrt3 = (0, $4yPBQ.sqrt)(3);
var $416ea7421344a620$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $4yPBQ.sqrt)(size + (0, $4yPBQ.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $416ea7421344a620$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};



var $4yPBQ = parcelRequire("4yPBQ");
var $f5bf3b44999085fb$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $4yPBQ.sqrt)(size / (0, $4yPBQ.pi));
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, (0, $4yPBQ.tau));
    }
};



var $4yPBQ = parcelRequire("4yPBQ");
var $00565e26c7fc5be0$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $4yPBQ.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};



var $4yPBQ = parcelRequire("4yPBQ");
const $fae5c3fb74081a20$var$tan30 = (0, $4yPBQ.sqrt)(1 / 3);
const $fae5c3fb74081a20$var$tan30_2 = $fae5c3fb74081a20$var$tan30 * 2;
var $fae5c3fb74081a20$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const y = (0, $4yPBQ.sqrt)(size / $fae5c3fb74081a20$var$tan30_2);
        const x = y * $fae5c3fb74081a20$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};



var $4yPBQ = parcelRequire("4yPBQ");
var $2599f2a775a9ba5a$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $4yPBQ.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};



var $4yPBQ = parcelRequire("4yPBQ");
var $ff3707871ad74f8b$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $4yPBQ.sqrt)(size - (0, $4yPBQ.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};



var $4yPBQ = parcelRequire("4yPBQ");
var $8c8b5f141f5b4f7e$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const w = (0, $4yPBQ.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};



var $4yPBQ = parcelRequire("4yPBQ");
var $337dc11df97e49e9$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $4yPBQ.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};



var $4yPBQ = parcelRequire("4yPBQ");
const $615ae6be541f1c53$var$ka = 0.89081309152928522810;
const $615ae6be541f1c53$var$kr = (0, $4yPBQ.sin)((0, $4yPBQ.pi) / 10) / (0, $4yPBQ.sin)(7 * (0, $4yPBQ.pi) / 10);
const $615ae6be541f1c53$var$kx = (0, $4yPBQ.sin)((0, $4yPBQ.tau) / 10) * $615ae6be541f1c53$var$kr;
const $615ae6be541f1c53$var$ky = -(0, $4yPBQ.cos)((0, $4yPBQ.tau) / 10) * $615ae6be541f1c53$var$kr;
var $615ae6be541f1c53$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $4yPBQ.sqrt)(size * $615ae6be541f1c53$var$ka);
        const x = $615ae6be541f1c53$var$kx * r;
        const y = $615ae6be541f1c53$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = (0, $4yPBQ.tau) * i / 5;
            const c = (0, $4yPBQ.cos)(a);
            const s = (0, $4yPBQ.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};



var $4yPBQ = parcelRequire("4yPBQ");
const $fe234cf6f2778f5d$var$sqrt3 = (0, $4yPBQ.sqrt)(3);
var $fe234cf6f2778f5d$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const y = -(0, $4yPBQ.sqrt)(size / ($fe234cf6f2778f5d$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$fe234cf6f2778f5d$var$sqrt3 * y, -y);
        context.lineTo($fe234cf6f2778f5d$var$sqrt3 * y, -y);
        context.closePath();
    }
};



var $4yPBQ = parcelRequire("4yPBQ");
const $ee0c8cb9cc5b50f5$var$sqrt3 = (0, $4yPBQ.sqrt)(3);
var $ee0c8cb9cc5b50f5$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const s = (0, $4yPBQ.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $ee0c8cb9cc5b50f5$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};



var $4yPBQ = parcelRequire("4yPBQ");
const $ded6892d7d2d30f1$var$c = -0.5;
const $ded6892d7d2d30f1$var$s = (0, $4yPBQ.sqrt)(3) / 2;
const $ded6892d7d2d30f1$var$k = 1 / (0, $4yPBQ.sqrt)(12);
const $ded6892d7d2d30f1$var$a = ($ded6892d7d2d30f1$var$k / 2 + 1) * 3;
var $ded6892d7d2d30f1$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $4yPBQ.sqrt)(size / $ded6892d7d2d30f1$var$a);
        const x0 = r / 2, y0 = r * $ded6892d7d2d30f1$var$k;
        const x1 = x0, y1 = r * $ded6892d7d2d30f1$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($ded6892d7d2d30f1$var$c * x0 - $ded6892d7d2d30f1$var$s * y0, $ded6892d7d2d30f1$var$s * x0 + $ded6892d7d2d30f1$var$c * y0);
        context.lineTo($ded6892d7d2d30f1$var$c * x1 - $ded6892d7d2d30f1$var$s * y1, $ded6892d7d2d30f1$var$s * x1 + $ded6892d7d2d30f1$var$c * y1);
        context.lineTo($ded6892d7d2d30f1$var$c * x2 - $ded6892d7d2d30f1$var$s * y2, $ded6892d7d2d30f1$var$s * x2 + $ded6892d7d2d30f1$var$c * y2);
        context.lineTo($ded6892d7d2d30f1$var$c * x0 + $ded6892d7d2d30f1$var$s * y0, $ded6892d7d2d30f1$var$c * y0 - $ded6892d7d2d30f1$var$s * x0);
        context.lineTo($ded6892d7d2d30f1$var$c * x1 + $ded6892d7d2d30f1$var$s * y1, $ded6892d7d2d30f1$var$c * y1 - $ded6892d7d2d30f1$var$s * x1);
        context.lineTo($ded6892d7d2d30f1$var$c * x2 + $ded6892d7d2d30f1$var$s * y2, $ded6892d7d2d30f1$var$c * y2 - $ded6892d7d2d30f1$var$s * x2);
        context.closePath();
    }
};



var $4yPBQ = parcelRequire("4yPBQ");
var $58d083fba0c3789a$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $4yPBQ.sqrt)(size - (0, $4yPBQ.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};


const $4bfd2a11fe1b1b9c$export$19158c96a6700c15 = [
    (0, $f5bf3b44999085fb$export$2e2bcd8739ae039),
    (0, $00565e26c7fc5be0$export$2e2bcd8739ae039),
    (0, $fae5c3fb74081a20$export$2e2bcd8739ae039),
    (0, $8c8b5f141f5b4f7e$export$2e2bcd8739ae039),
    (0, $615ae6be541f1c53$export$2e2bcd8739ae039),
    (0, $fe234cf6f2778f5d$export$2e2bcd8739ae039),
    (0, $ded6892d7d2d30f1$export$2e2bcd8739ae039)
];
const $4bfd2a11fe1b1b9c$export$915e06de6acf8fe = [
    (0, $f5bf3b44999085fb$export$2e2bcd8739ae039),
    (0, $ff3707871ad74f8b$export$2e2bcd8739ae039),
    (0, $58d083fba0c3789a$export$2e2bcd8739ae039),
    (0, $ee0c8cb9cc5b50f5$export$2e2bcd8739ae039),
    (0, $416ea7421344a620$export$2e2bcd8739ae039),
    (0, $337dc11df97e49e9$export$2e2bcd8739ae039),
    (0, $2599f2a775a9ba5a$export$2e2bcd8739ae039)
];
function $4bfd2a11fe1b1b9c$export$2e2bcd8739ae039(type, size) {
    let context = null, path = (0, $4c5e3c9f20f937f2$export$fb6e83118a5dcd45)(symbol);
    type = typeof type === "function" ? type : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(type || (0, $f5bf3b44999085fb$export$2e2bcd8739ae039));
    size = typeof size === "function" ? size : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = path();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $daa29d5b1d6b2092$export$2e2bcd8739ae039)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}



// Returns the index of a defined shape
function $6705a6e457c0e2c6$export$57af67db727bc7c7(shape) {
    const symbolNames = "circle cross diamond square star triangle wye".split(/ /);
    return symbolNames.indexOf(shape) || 0;
}






var $aSiaI = parcelRequire("aSiaI");
const $ed0f2a56ba7c3b6c$var$_excluded = [
    "x",
    "y",
    "id",
    "classes",
    "color",
    "shape",
    "dataIndex",
    "onClick",
    "skipAnimation"
];
function $ed0f2a56ba7c3b6c$export$d02b446db8b3af00(slot) {
    return (0, $dC5O8.default)("MuiMarkElement", slot);
}
const $ed0f2a56ba7c3b6c$export$86af242896daa858 = (0, $kY7HX.default)("MuiMarkElement", [
    "root",
    "highlighted",
    "faded"
]);
const $ed0f2a56ba7c3b6c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, id: id, isFaded: isFaded, isHighlighted: isHighlighted } = ownerState;
    const slots = {
        root: [
            "root",
            `series-${id}`,
            isHighlighted && "highlighted",
            isFaded && "faded"
        ]
    };
    return (0, $2f0D3.default)(slots, $ed0f2a56ba7c3b6c$export$d02b446db8b3af00, classes);
};
const $ed0f2a56ba7c3b6c$var$MarkElementPath = (0, $jawKn.default)((0, $f9aea5876333360d$export$407448d2b89b1813).path, {
    name: "MuiMarkElement",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ ownerState: ownerState, theme: theme })=>({
        fill: (theme.vars || theme).palette.background.paper,
        stroke: ownerState.color,
        strokeWidth: 2
    }));
/**
 * Demos:
 *
 * - [Lines](https://mui.com/x/react-charts/lines/)
 * - [Line demonstration](https://mui.com/x/react-charts/line-demo/)
 *
 * API:
 *
 * - [MarkElement API](https://mui.com/x/api/charts/mark-element/)
 */ function $ed0f2a56ba7c3b6c$export$f3069f755c1eba0b(props) {
    const { x: x, y: y, id: id, classes: innerClasses, color: color, shape: shape, dataIndex: dataIndex, onClick: onClick, skipAnimation: skipAnimation } = props, other = (0, $3L80X.default)(props, $ed0f2a56ba7c3b6c$var$_excluded);
    const getInteractionItemProps = (0, $d203c2c9b69fd133$export$306117b585a4c625)();
    const { isFaded: isFaded, isHighlighted: isHighlighted } = (0, $773c45430f70b33a$export$df217abb95936ce9)({
        seriesId: id
    });
    const { axis: axis } = $exYeM.useContext((0, $4791e4ada5496d01$export$d6ef105978afa6a));
    const position = (0, $9f726edb03f4840c$export$c4af9125706c4d30)({
        x: x,
        y: y,
        immediate: skipAnimation
    });
    const ownerState = {
        id: id,
        classes: innerClasses,
        isHighlighted: axis.x?.index === dataIndex || isHighlighted,
        isFaded: isFaded,
        color: color
    };
    const classes = $ed0f2a56ba7c3b6c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($ed0f2a56ba7c3b6c$var$MarkElementPath, (0, $aJx1R.default)({}, other, {
        style: {
            transform: (0, $9f726edb03f4840c$export$2c618a4308a30424)([
                position.x,
                position.y
            ], (pX, pY)=>`translate(${pX}px, ${pY}px)`),
            transformOrigin: (0, $9f726edb03f4840c$export$2c618a4308a30424)([
                position.x,
                position.y
            ], (pX, pY)=>`${pX}px ${pY}px`)
        },
        ownerState: ownerState,
        className: classes.root,
        d: (0, $4bfd2a11fe1b1b9c$export$2e2bcd8739ae039)((0, $4bfd2a11fe1b1b9c$export$19158c96a6700c15)[(0, $6705a6e457c0e2c6$export$57af67db727bc7c7)(shape)])(),
        onClick: onClick,
        cursor: onClick ? "pointer" : "unset"
    }, getInteractionItemProps({
        type: "line",
        seriesId: id,
        dataIndex: dataIndex
    })));
}










var $aSiaI = parcelRequire("aSiaI");
const $187a37910407cd0f$var$_excluded = [
    "slots",
    "slotProps",
    "skipAnimation",
    "onItemClick"
];
/**
 * Demos:
 *
 * - [Lines](https://mui.com/x/react-charts/lines/)
 * - [Line demonstration](https://mui.com/x/react-charts/line-demo/)
 *
 * API:
 *
 * - [MarkPlot API](https://mui.com/x/api/charts/mark-plot/)
 */ function $187a37910407cd0f$export$827a8f2f03eed638(props) {
    const { slots: slots, slotProps: slotProps, skipAnimation: skipAnimation, onItemClick: onItemClick } = props, other = (0, $3L80X.default)(props, $187a37910407cd0f$var$_excluded);
    const seriesData = (0, $ba69253362075717$export$f7090460c70512f0)();
    const axisData = (0, $27adb4455fa596cf$export$2785a2cc09fc5c5f)();
    const chartId = (0, $0b3940f442933067$export$310c4c2c8f792eac)();
    const drawingArea = (0, $767eebe86d6e6272$export$389be1739214a0a2)();
    const Mark = slots?.mark ?? (0, $ed0f2a56ba7c3b6c$export$f3069f755c1eba0b);
    if (seriesData === undefined) return null;
    const { series: series, stackingGroups: stackingGroups } = seriesData;
    const { xAxis: xAxis, yAxis: yAxis, xAxisIds: xAxisIds, yAxisIds: yAxisIds } = axisData;
    const defaultXAxisId = xAxisIds[0];
    const defaultYAxisId = yAxisIds[0];
    return /*#__PURE__*/ (0, $aSiaI.jsx)("g", (0, $aJx1R.default)({}, other, {
        children: stackingGroups.flatMap(({ ids: groupIds })=>{
            return groupIds.map((seriesId)=>{
                const { xAxisKey: xAxisKey = defaultXAxisId, yAxisKey: yAxisKey = defaultYAxisId, stackedData: stackedData, data: data, showMark: showMark = true } = series[seriesId];
                if (showMark === false) return null;
                const xScale = (0, $fe42cc92ff5d0a37$export$612517523e588e9d)(xAxis[xAxisKey].scale);
                const yScale = yAxis[yAxisKey].scale;
                const xData = xAxis[xAxisKey].data;
                if (xData === undefined) throw new Error(`MUI X Charts: ${xAxisKey === (0, $f7012dce0f399219$export$85ea9370ff307a1f) ? "The first `xAxis`" : `The x-axis with id "${xAxisKey}"`} should have data property to be able to display a line plot.`);
                const clipId = (0, $b30b938d228df3cc$export$596bdd6a1862c0b0)(`${chartId}-${seriesId}-line-clip`); // We assume that if displaying line mark, the line will also be rendered
                const colorGetter = (0, $cb7b0a4c0c04d36c$export$2e2bcd8739ae039)(series[seriesId], xAxis[xAxisKey], yAxis[yAxisKey]);
                return /*#__PURE__*/ (0, $aSiaI.jsx)("g", {
                    clipPath: `url(#${clipId})`,
                    children: xData?.map((x, index)=>{
                        const value = data[index] == null ? null : stackedData[index][1];
                        return {
                            x: xScale(x),
                            y: value === null ? null : yScale(value),
                            position: x,
                            value: value,
                            index: index
                        };
                    }).filter(({ x: x, y: y, index: index, position: position, value: value })=>{
                        if (value === null || y === null) // Remove missing data point
                        return false;
                        if (!drawingArea.isPointInside({
                            x: x,
                            y: y
                        })) // Remove out of range
                        return false;
                        if (showMark === true) return true;
                        return showMark({
                            x: x,
                            y: y,
                            index: index,
                            position: position,
                            value: value
                        });
                    }).map(({ x: x, y: y, index: index })=>{
                        return /*#__PURE__*/ (0, $aSiaI.jsx)(Mark, (0, $aJx1R.default)({
                            id: seriesId,
                            dataIndex: index,
                            shape: "circle",
                            color: colorGetter(index),
                            x: x,
                            y: y // Don't know why TS doesn't get from the filter that y can't be null
                            ,
                            skipAnimation: skipAnimation,
                            onClick: onItemClick && ((event)=>onItemClick(event, {
                                    type: "line",
                                    seriesId: seriesId,
                                    dataIndex: index
                                }))
                        }, slotProps?.mark), `${seriesId}-${index}`);
                    })
                }, seriesId);
            });
        })
    }));
}








var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");

var $exYeM = parcelRequire("exYeM");



var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");
parcelRequire("exYeM");


var $2f0D3 = parcelRequire("2f0D3");

var $dC5O8 = parcelRequire("dC5O8");

var $jawKn = parcelRequire("jawKn");

var $kY7HX = parcelRequire("kY7HX");

var $aSiaI = parcelRequire("aSiaI");
const $8a9bea9bdfeaecc4$var$_excluded = [
    "x",
    "y",
    "id",
    "classes",
    "color"
];
function $8a9bea9bdfeaecc4$export$c4646afa18e482a3(slot) {
    return (0, $dC5O8.default)("MuiHighlightElement", slot);
}
const $8a9bea9bdfeaecc4$export$8767d64871368da2 = (0, $kY7HX.default)("MuiHighlightElement", [
    "root"
]);
const $8a9bea9bdfeaecc4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, id: id } = ownerState;
    const slots = {
        root: [
            "root",
            `series-${id}`
        ]
    };
    return (0, $2f0D3.default)(slots, $8a9bea9bdfeaecc4$export$c4646afa18e482a3, classes);
};
const $8a9bea9bdfeaecc4$var$HighlightElement = (0, $jawKn.default)("circle", {
    name: "MuiHighlightElement",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ ownerState: ownerState })=>({
        transform: `translate(${ownerState.x}px, ${ownerState.y}px)`,
        transformOrigin: `${ownerState.x}px ${ownerState.y}px`,
        fill: ownerState.color
    }));
/**
 * Demos:
 *
 * - [Lines](https://mui.com/x/react-charts/lines/)
 * - [Line demonstration](https://mui.com/x/react-charts/line-demo/)
 *
 * API:
 *
 * - [LineHighlightElement API](https://mui.com/x/api/charts/line-highlight-element/)
 */ function $8a9bea9bdfeaecc4$export$d4225609fd6bec6c(props) {
    const { x: x, y: y, id: id, classes: innerClasses, color: color } = props, other = (0, $3L80X.default)(props, $8a9bea9bdfeaecc4$var$_excluded);
    const ownerState = {
        id: id,
        classes: innerClasses,
        color: color,
        x: x,
        y: y
    };
    const classes = $8a9bea9bdfeaecc4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $aSiaI.jsx)($8a9bea9bdfeaecc4$var$HighlightElement, (0, $aJx1R.default)({
        pointerEvents: "none",
        ownerState: ownerState,
        className: classes.root,
        cx: 0,
        cy: 0,
        r: other.r === undefined ? 5 : other.r
    }, other));
}









var $aSiaI = parcelRequire("aSiaI");
const $bda0527cca320731$var$_excluded = [
    "slots",
    "slotProps"
];
/**
 * Demos:
 *
 * - [Lines](https://mui.com/x/react-charts/lines/)
 * - [Line demonstration](https://mui.com/x/react-charts/line-demo/)
 *
 * API:
 *
 * - [LineHighlightPlot API](https://mui.com/x/api/charts/line-highlight-plot/)
 */ function $bda0527cca320731$export$a58d49d7071a53bb(props) {
    const { slots: slots, slotProps: slotProps } = props, other = (0, $3L80X.default)(props, $bda0527cca320731$var$_excluded);
    const seriesData = (0, $ba69253362075717$export$f7090460c70512f0)();
    const axisData = (0, $27adb4455fa596cf$export$2785a2cc09fc5c5f)();
    const drawingArea = (0, $767eebe86d6e6272$export$389be1739214a0a2)();
    const { axis: axis } = $exYeM.useContext((0, $4791e4ada5496d01$export$d6ef105978afa6a));
    const highlightedIndex = axis.x?.index;
    if (highlightedIndex === undefined) return null;
    if (seriesData === undefined) return null;
    const { series: series, stackingGroups: stackingGroups } = seriesData;
    const { xAxis: xAxis, yAxis: yAxis, xAxisIds: xAxisIds, yAxisIds: yAxisIds } = axisData;
    const defaultXAxisId = xAxisIds[0];
    const defaultYAxisId = yAxisIds[0];
    const Element = slots?.lineHighlight ?? (0, $8a9bea9bdfeaecc4$export$d4225609fd6bec6c);
    return /*#__PURE__*/ (0, $aSiaI.jsx)("g", (0, $aJx1R.default)({}, other, {
        children: stackingGroups.flatMap(({ ids: groupIds })=>{
            return groupIds.flatMap((seriesId)=>{
                const { xAxisKey: xAxisKey = defaultXAxisId, yAxisKey: yAxisKey = defaultYAxisId, stackedData: stackedData, data: data, disableHighlight: disableHighlight } = series[seriesId];
                if (disableHighlight || data[highlightedIndex] == null) return null;
                const xScale = (0, $fe42cc92ff5d0a37$export$612517523e588e9d)(xAxis[xAxisKey].scale);
                const yScale = yAxis[yAxisKey].scale;
                const xData = xAxis[xAxisKey].data;
                if (xData === undefined) throw new Error(`MUI X Charts: ${xAxisKey === (0, $f7012dce0f399219$export$85ea9370ff307a1f) ? "The first `xAxis`" : `The x-axis with id "${xAxisKey}"`} should have data property to be able to display a line plot.`);
                const x = xScale(xData[highlightedIndex]);
                const y = yScale(stackedData[highlightedIndex][1]); // This should not be undefined since y should not be a band scale
                if (!drawingArea.isPointInside({
                    x: x,
                    y: y
                })) return null;
                const colorGetter = (0, $cb7b0a4c0c04d36c$export$2e2bcd8739ae039)(series[seriesId], xAxis[xAxisKey], yAxis[yAxisKey]);
                return /*#__PURE__*/ (0, $aSiaI.jsx)(Element, (0, $aJx1R.default)({
                    id: seriesId,
                    color: colorGetter(highlightedIndex),
                    x: x,
                    y: y
                }, slotProps?.lineHighlight), `${seriesId}`);
            });
        })
    }));
}






var $aJx1R = parcelRequire("aJx1R");

var $3L80X = parcelRequire("3L80X");


const $614e1729da0fe91b$var$_excluded = [
    "xAxis",
    "yAxis",
    "series",
    "width",
    "height",
    "margin",
    "colors",
    "dataset",
    "sx",
    "tooltip",
    "onAxisClick",
    "onAreaClick",
    "onLineClick",
    "onMarkClick",
    "axisHighlight",
    "disableLineItemHighlight",
    "legend",
    "grid",
    "topAxis",
    "leftAxis",
    "rightAxis",
    "bottomAxis",
    "children",
    "slots",
    "slotProps",
    "skipAnimation",
    "loading",
    "highlightedItem",
    "onHighlightChange",
    "className"
];
const $614e1729da0fe91b$export$53a32b7b4ff3ee12 = (props)=>{
    const { xAxis: xAxis, yAxis: yAxis, series: series, width: width, height: height, margin: margin, colors: colors, dataset: dataset, sx: sx, tooltip: tooltip, onAxisClick: onAxisClick, onAreaClick: onAreaClick, onLineClick: onLineClick, onMarkClick: onMarkClick, axisHighlight: axisHighlight, disableLineItemHighlight: disableLineItemHighlight, legend: legend, grid: grid, topAxis: topAxis, leftAxis: leftAxis, rightAxis: rightAxis, bottomAxis: bottomAxis, children: children, slots: slots, slotProps: slotProps, skipAnimation: skipAnimation, loading: loading, highlightedItem: highlightedItem, onHighlightChange: onHighlightChange, className: className } = props, other = (0, $3L80X.default)(props, $614e1729da0fe91b$var$_excluded);
    const id = (0, $43c7ad0c22f8e14a$export$2e2bcd8739ae039)();
    const clipPathId = `${id}-clip-path`;
    const chartContainerProps = (0, $aJx1R.default)({}, other, {
        series: series.map((s)=>(0, $aJx1R.default)({
                disableHighlight: !!disableLineItemHighlight,
                type: "line"
            }, s)),
        width: width,
        height: height,
        margin: margin,
        colors: colors,
        dataset: dataset,
        xAxis: xAxis ?? [
            {
                id: (0, $f7012dce0f399219$export$85ea9370ff307a1f),
                scaleType: "point",
                data: Array.from({
                    length: Math.max(...series.map((s)=>(s.data ?? dataset ?? []).length))
                }, (_, index)=>index)
            }
        ],
        yAxis: yAxis,
        sx: sx,
        highlightedItem: highlightedItem,
        onHighlightChange: onHighlightChange,
        disableAxisListener: tooltip?.trigger !== "axis" && axisHighlight?.x === "none" && axisHighlight?.y === "none" && !onAxisClick,
        className: className
    });
    const axisClickHandlerProps = {
        onAxisClick: onAxisClick
    };
    const gridProps = {
        vertical: grid?.vertical,
        horizontal: grid?.horizontal
    };
    const clipPathGroupProps = {
        clipPath: `url(#${clipPathId})`
    };
    const clipPathProps = {
        id: clipPathId
    };
    const areaPlotProps = {
        slots: slots,
        slotProps: slotProps,
        onItemClick: onAreaClick,
        skipAnimation: skipAnimation
    };
    const linePlotProps = {
        slots: slots,
        slotProps: slotProps,
        onItemClick: onLineClick,
        skipAnimation: skipAnimation
    };
    const markPlotProps = {
        slots: slots,
        slotProps: slotProps,
        onItemClick: onMarkClick,
        skipAnimation: skipAnimation
    };
    const overlayProps = {
        slots: slots,
        slotProps: slotProps,
        loading: loading
    };
    const chartsAxisProps = {
        topAxis: topAxis,
        leftAxis: leftAxis,
        rightAxis: rightAxis,
        bottomAxis: bottomAxis,
        slots: slots,
        slotProps: slotProps
    };
    const axisHighlightProps = (0, $aJx1R.default)({
        x: "line"
    }, axisHighlight);
    const lineHighlightPlotProps = {
        slots: slots,
        slotProps: slotProps
    };
    const legendProps = (0, $aJx1R.default)({}, legend, {
        slots: slots,
        slotProps: slotProps
    });
    const tooltipProps = (0, $aJx1R.default)({}, tooltip, {
        slots: slots,
        slotProps: slotProps
    });
    return {
        chartContainerProps: chartContainerProps,
        axisClickHandlerProps: axisClickHandlerProps,
        gridProps: gridProps,
        clipPathProps: clipPathProps,
        clipPathGroupProps: clipPathGroupProps,
        areaPlotProps: areaPlotProps,
        linePlotProps: linePlotProps,
        markPlotProps: markPlotProps,
        overlayProps: overlayProps,
        chartsAxisProps: chartsAxisProps,
        axisHighlightProps: axisHighlightProps,
        lineHighlightPlotProps: lineHighlightPlotProps,
        legendProps: legendProps,
        tooltipProps: tooltipProps,
        children: children
    };
};



var $aSiaI = parcelRequire("aSiaI");
/**
 * Demos:
 *
 * - [Lines](https://mui.com/x/react-charts/lines/)
 * - [Line demonstration](https://mui.com/x/react-charts/line-demo/)
 *
 * API:
 *
 * - [LineChart API](https://mui.com/x/api/charts/line-chart/)
 */ const $d861b67a0a1bf4a6$export$54d0e8420ac838ac = /*#__PURE__*/ $exYeM.forwardRef(function LineChart(props, ref) {
    const { chartContainerProps: chartContainerProps, axisClickHandlerProps: axisClickHandlerProps, gridProps: gridProps, clipPathProps: clipPathProps, clipPathGroupProps: clipPathGroupProps, areaPlotProps: areaPlotProps, linePlotProps: linePlotProps, markPlotProps: markPlotProps, overlayProps: overlayProps, chartsAxisProps: chartsAxisProps, axisHighlightProps: axisHighlightProps, lineHighlightPlotProps: lineHighlightPlotProps, legendProps: legendProps, tooltipProps: tooltipProps, children: children } = (0, $614e1729da0fe91b$export$53a32b7b4ff3ee12)(props);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $254a2fff30bc08f0$export$5f31fc7dc92fc998), (0, $aJx1R.default)({
        ref: ref
    }, chartContainerProps, {
        children: [
            props.onAxisClick && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $93047e9f465eed81$export$770a9d3016cdbedd), (0, $aJx1R.default)({}, axisClickHandlerProps)),
            props.grid && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e0157911446d288c$export$689c47245a555af2), (0, $aJx1R.default)({}, gridProps)),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("g", (0, $aJx1R.default)({}, clipPathGroupProps, {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $dfed42648ba8d93b$export$6a7fe11371d21fcb), (0, $aJx1R.default)({}, areaPlotProps)),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $08ee19062e976d48$export$43894928ea4c1421), (0, $aJx1R.default)({}, linePlotProps)),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7700a9920847bf61$export$3729bf444e26c9a6), (0, $aJx1R.default)({}, overlayProps)),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $95e22bde0fffcfc7$export$598ced0854cbcf58), (0, $aJx1R.default)({}, axisHighlightProps))
                ]
            })),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $98aeda3d167bbb73$export$2423790cc2b08d6f), (0, $aJx1R.default)({}, chartsAxisProps)),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $187a37910407cd0f$export$827a8f2f03eed638), (0, $aJx1R.default)({}, markPlotProps)),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $bda0527cca320731$export$a58d49d7071a53bb), (0, $aJx1R.default)({}, lineHighlightPlotProps)),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8dc35cebfdf94a31$export$2741855b57a06a05), (0, $aJx1R.default)({}, legendProps)),
            !props.loading && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $e0f2ff2fe9ecd767$export$638edc2f884926bd), (0, $aJx1R.default)({}, tooltipProps)),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $58540b004b2b5e3b$export$325f8d4978f9d570), (0, $aJx1R.default)({}, clipPathProps)),
            children
        ]
    }));
});


const $675085a179d8b1b0$export$ea6cfe4958a2f784 = ({ summaryHistory: summaryHistory })=>{
    const xLabels = $exYeM.useMemo(()=>{
        if (!summaryHistory) return [];
        return summaryHistory.map((item)=>item.date);
    }, [
        summaryHistory
    ]);
    const series = $exYeM.useMemo(()=>{
        if (!summaryHistory) return [];
        const mixnodesBonded = summaryHistory.map((item)=>item.value_json.mixnodes.bonded.count + Math.round(Math.random() * 30));
        const mixnodesActive = summaryHistory.map((item)=>item.value_json.mixnodes.bonded.active);
        const mixnodesInactive = summaryHistory.map((item)=>item.value_json.mixnodes.bonded.inactive);
        const mixnodesReserve = summaryHistory.map((item)=>item.value_json.mixnodes.bonded.reserve + Math.round(Math.random() * 30));
        const mixnodesBlacklisted = summaryHistory.map((item)=>item.value_json.mixnodes.blacklisted.count + Math.round(Math.random() * 50));
        const gatewaysBonded = summaryHistory.map((item)=>item.value_json.gateways.bonded.count + Math.round(Math.random() * 30));
        const gatewaysBlacklisted = summaryHistory.map((item)=>item.value_json.gateways.blacklisted.count + Math.round(Math.random() * 30));
        return [
            {
                data: mixnodesBonded,
                label: "Mixnodes Bonded"
            },
            {
                data: mixnodesActive,
                label: "Mixnodes Active"
            },
            {
                data: mixnodesInactive,
                label: "Mixnodes Inactive"
            },
            {
                data: mixnodesReserve,
                label: "Mixnodes Reserve"
            },
            {
                data: mixnodesBlacklisted,
                label: "Mixnodes Blacklisted"
            },
            {
                data: gatewaysBonded,
                label: "Gateways Bonded"
            },
            {
                data: gatewaysBlacklisted,
                label: "Gateways Blacklisted"
            }
        ];
    }, [
        summaryHistory
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d861b67a0a1bf4a6$export$54d0e8420ac838ac), {
        width: 1200,
        height: 500,
        series: series,
        xAxis: [
            {
                scaleType: "point",
                data: xLabels
            }
        ],
        slotProps: {
            legend: {
                direction: "row",
                position: {
                    vertical: "top",
                    horizontal: "middle"
                },
                padding: 0
            }
        }
    });
};



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


const $1099e6148ee474ba$export$d962ff6a3d1da899 = ({ mixnetStats: mixnetStats })=>{
    const xLabels = $exYeM.useMemo(()=>{
        if (!mixnetStats) return [];
        return mixnetStats.map((item)=>item.date_utc);
    }, [
        mixnetStats
    ]);
    const series = $exYeM.useMemo(()=>{
        if (!mixnetStats) return [];
        const totalPacketsReceived = mixnetStats.map((item)=>item.total_packets_received);
        const totalPacketsSent = mixnetStats.map((item)=>item.total_packets_sent);
        const totalPacketsDropped = mixnetStats.map((item)=>item.total_packets_dropped);
        return [
            {
                data: totalPacketsReceived,
                label: "Total Packets Received",
                yAxisId: "packets"
            },
            {
                data: totalPacketsSent,
                label: "Total Packets Sent",
                yAxisId: "packets"
            },
            {
                data: totalPacketsDropped,
                label: "Total Packets Dropped",
                yAxisId: "packets"
            }
        ];
    }, [
        mixnetStats
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        sx: {
            width: "100%",
            maxWidth: 1200
        },
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d861b67a0a1bf4a6$export$54d0e8420ac838ac), {
            height: 500,
            series: series,
            xAxis: [
                {
                    scaleType: "point",
                    data: xLabels
                }
            ],
            slotProps: {
                legend: {
                    direction: "row",
                    position: {
                        vertical: "top",
                        horizontal: "middle"
                    },
                    padding: 0
                }
            },
            margin: {
                left: 100,
                right: 100,
                top: 80,
                bottom: 80
            }
        })
    });
};
const $1099e6148ee474ba$export$d3ad77aea4b0402e = ({ mixnetStats: mixnetStats, height: height })=>{
    const xLabels = $exYeM.useMemo(()=>{
        if (!mixnetStats) return [];
        return mixnetStats.map((item)=>item.date_utc);
    }, [
        mixnetStats
    ]);
    const series = $exYeM.useMemo(()=>{
        if (!mixnetStats) return [];
        const totalStakeNyms = mixnetStats.map((item)=>item.total_stake / 1e6);
        return [
            {
                data: totalStakeNyms,
                label: "Total Mixnode Delegations (NYM)",
                yAxisId: "tokens"
            }
        ];
    }, [
        mixnetStats
    ]);
    return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        sx: {
            width: "100%",
            maxWidth: 1200
        },
        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d861b67a0a1bf4a6$export$54d0e8420ac838ac), {
            height: height,
            series: series,
            xAxis: [
                {
                    scaleType: "point",
                    data: xLabels
                }
            ],
            slotProps: {
                legend: {
                    direction: "row",
                    position: {
                        vertical: "top",
                        horizontal: "middle"
                    },
                    padding: 0
                }
            },
            margin: {
                left: 100,
                right: 100,
                top: 80,
                bottom: 80
            }
        })
    });
};


const $01b08ce9a4c73722$export$f13fe7ffb954e56d = ()=>{
    const [summaryHistory, setSummaryHistory] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(null);
    const [mixnetStats, setMixnetStats] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(null);
    const refresh = async ()=>{
        try {
            const newSummaryHistory = await (0, $f66fa928cd4a99c0$export$644d8ea042df96a6).summaryHistory();
            setSummaryHistory(newSummaryHistory);
        } catch (e) {
            console.error("Failed to get summary history", e);
        }
        try {
            const newMixnetStats = await (0, $f66fa928cd4a99c0$export$644d8ea042df96a6).mixnodeStats();
            setMixnetStats(newMixnetStats);
        } catch (e) {
            console.error("Failed to get stats", e);
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        refresh();
        const timer = setInterval(refresh, 300000);
        return ()=>clearInterval(timer);
    }, []);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                pb: 4,
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("h2", {
                    children: "\uD83C\uDFF4\u200D\u2620\uFE0F because pirates \u2764\uFE0F charts \uD83D\uDDFA\uFE0F"
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                mb: 4,
                pt: 5,
                pb: 3,
                pl: 3,
                sx: {
                    border: "2px solid #eee",
                    borderRadius: 3,
                    width: 1250
                },
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $675085a179d8b1b0$export$ea6cfe4958a2f784), {
                    summaryHistory: summaryHistory
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                mb: 4,
                pt: 5,
                pb: 3,
                pl: 3,
                sx: {
                    border: "2px solid #eee",
                    borderRadius: 3,
                    width: 1250
                },
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1099e6148ee474ba$export$d962ff6a3d1da899), {
                    mixnetStats: mixnetStats
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                mb: 4,
                pt: 5,
                pb: 3,
                pl: 3,
                sx: {
                    border: "2px solid #eee",
                    borderRadius: 3,
                    width: 1250
                },
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $1099e6148ee474ba$export$d3ad77aea4b0402e), {
                    mixnetStats: mixnetStats,
                    height: 300
                })
            })
        ]
    });
};


const $05636b8232b20ed1$export$b94310965bed44e6 = ()=>{
    const [summary, setSummary] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(null);
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("1");
    const handleChange = (event, newValue)=>{
        setValue(newValue);
    };
    const refresh = async ()=>{
        try {
            const newSummary = await (0, $f66fa928cd4a99c0$export$644d8ea042df96a6).summary();
            setSummary(newSummary);
        } catch (e) {
            console.error("Failed to get summary", e);
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        refresh();
        const timer = setInterval(refresh, 300000);
        return ()=>clearInterval(timer);
    }, []);
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        p: 4,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $93231a89f687f087$export$ddc5e865495e96fb), {}),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $75a69f56048afb85$export$2e2bcd8739ae039), {
                value: value,
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                        sx: {
                            borderBottom: 1,
                            borderColor: "divider"
                        },
                        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $d0439740c0b4ed74$export$2e2bcd8739ae039), {
                            onChange: handleChange,
                            "aria-label": "lab API tabs example",
                            children: [
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8db679d8467240be$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $aSiaI.jsxs)("h2", {
                                        children: [
                                            "Gateways ",
                                            summary && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                                children: [
                                                    "(",
                                                    summary.gateways.bonded.count,
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    value: "1"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8db679d8467240be$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $aSiaI.jsxs)("h2", {
                                        children: [
                                            "Mixnodes ",
                                            summary && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                                                children: [
                                                    "(",
                                                    summary.mixnodes.bonded.count,
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    value: "2"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8db679d8467240be$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $aSiaI.jsx)("h2", {
                                        children: "Gateways for mixFetch"
                                    }),
                                    value: "3"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8db679d8467240be$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $aSiaI.jsx)("h2", {
                                        children: "SOCKS5 Network Requesters"
                                    }),
                                    value: "4"
                                }),
                                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8db679d8467240be$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $aSiaI.jsx)("h2", {
                                        children: "Charts"
                                    }),
                                    value: "5"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3ec252815a085386$export$2e2bcd8739ae039), {
                        value: "1",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $01bb1c4a0639f9ce$export$931ac62b58f99256), {})
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3ec252815a085386$export$2e2bcd8739ae039), {
                        value: "2",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f7e2d66ed9faf4d4$export$a26ee9dff86d9aae), {})
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3ec252815a085386$export$2e2bcd8739ae039), {
                        value: "3",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $025a3f487640efd2$export$68d8ed05fb20d71), {})
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3ec252815a085386$export$2e2bcd8739ae039), {
                        value: "4",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b95301175869a770$export$c447b0cdbd1cd184), {})
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3ec252815a085386$export$2e2bcd8739ae039), {
                        value: "5",
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $01b08ce9a4c73722$export$f13fe7ffb954e56d), {})
                    })
                ]
            })
        ]
    });
};



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");


















/* eslint-disable react/no-unstable-nested-components */ 
var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");










var $29ac6f35d66955fc$exports = {};
"use strict";
"use client";

var $iQtbn = parcelRequire("iQtbn");
Object.defineProperty($29ac6f35d66955fc$exports, "__esModule", {
    value: true
});
$29ac6f35d66955fc$exports.default = void 0;

var $29ac6f35d66955fc$var$_createSvgIcon = $iQtbn((parcelRequire("eXuaq")));

var $aSiaI = parcelRequire("aSiaI");
var $29ac6f35d66955fc$var$_default = $29ac6f35d66955fc$exports.default = (0, $29ac6f35d66955fc$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $aSiaI.jsx)("path", {
    d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), "ArrowForward");




var $exYeM = parcelRequire("exYeM");

var $exYeM = parcelRequire("exYeM");

var $bisEj = parcelRequire("bisEj");

var $exYeM = parcelRequire("exYeM");



var $aSiaI = parcelRequire("aSiaI");
function $f506dcc23858008c$var$v() {
    return $f506dcc23858008c$var$v = Object.assign ? Object.assign.bind() : function(t) {
        for(var i = 1; i < arguments.length; i++){
            var o = arguments[i];
            for(var n in o)Object.prototype.hasOwnProperty.call(o, n) && (t[n] = o[n]);
        }
        return t;
    }, $f506dcc23858008c$var$v.apply(this, arguments);
}
var $f506dcc23858008c$var$x = {
    pointerEvents: "none",
    position: "absolute",
    zIndex: 10,
    top: 0,
    left: 0
}, $f506dcc23858008c$var$m = function(t, i) {
    return "translate(" + t + "px, " + i + "px)";
}, $f506dcc23858008c$export$57a09c4864b20b90 = (0, $exYeM.memo)(function(t) {
    var o, n = t.position, r = t.anchor, e = t.children, l = (0, $5c76f646ce642491$export$93d4e7f90805808f)(), d = (0, $5c76f646ce642491$export$72acc3dc9629d75d)(), y = d.animate, f = d.config, b = (0, $5c76f646ce642491$export$e295b0c537d32d7d)(), g = b[0], w = b[1], T = (0, $exYeM.useRef)(!1), C = void 0, E = !1, P = w.width > 0 && w.height > 0, j = Math.round(n[0]), N = Math.round(n[1]);
    P && ("top" === r ? (j -= w.width / 2, N -= w.height + 14) : "right" === r ? (j += 14, N -= w.height / 2) : "bottom" === r ? (j -= w.width / 2, N += 14) : "left" === r ? (j -= w.width + 14, N -= w.height / 2) : "center" === r && (j -= w.width / 2, N -= w.height / 2), C = {
        transform: $f506dcc23858008c$var$m(j, N)
    }, T.current || (E = !0), T.current = [
        j,
        N
    ]);
    var O = (0, $9f726edb03f4840c$export$c4af9125706c4d30)({
        to: C,
        config: f,
        immediate: !y || E
    }), V = $f506dcc23858008c$var$v({}, $f506dcc23858008c$var$x, l.tooltip.wrapper, {
        transform: null != (o = O.transform) ? o : $f506dcc23858008c$var$m(j, N),
        opacity: O.transform ? 1 : 0
    });
    return (0, $aSiaI.jsx)((0, $f9aea5876333360d$export$407448d2b89b1813).div, {
        ref: g,
        style: V,
        children: e
    });
});
$f506dcc23858008c$export$57a09c4864b20b90.displayName = "TooltipWrapper";
var $f506dcc23858008c$export$5a7f9a6004988d01 = (0, $exYeM.memo)(function(t) {
    var i = t.size, o = void 0 === i ? 12 : i, n = t.color, r = t.style;
    return (0, $aSiaI.jsx)("span", {
        style: $f506dcc23858008c$var$v({
            display: "block",
            width: o,
            height: o,
            background: n
        }, void 0 === r ? {} : r)
    });
}), $f506dcc23858008c$export$d5f52d71198e271a = (0, $exYeM.memo)(function(t) {
    var i, o = t.id, n = t.value, r = t.format, e = t.enableChip, l = void 0 !== e && e, a = t.color, c = t.renderContent, h = (0, $5c76f646ce642491$export$93d4e7f90805808f)(), u = (0, $5c76f646ce642491$export$422f9765e6971fdf)(r);
    if ("function" == typeof c) i = c();
    else {
        var f = n;
        void 0 !== u && void 0 !== f && (f = u(f)), i = (0, $aSiaI.jsxs)("div", {
            style: h.tooltip.basic,
            children: [
                l && (0, $aSiaI.jsx)($f506dcc23858008c$export$5a7f9a6004988d01, {
                    color: a,
                    style: h.tooltip.chip
                }),
                void 0 !== f ? (0, $aSiaI.jsxs)("span", {
                    children: [
                        o,
                        ": ",
                        (0, $aSiaI.jsx)("strong", {
                            children: "" + f
                        })
                    ]
                }) : o
            ]
        });
    }
    return (0, $aSiaI.jsx)("div", {
        style: h.tooltip.container,
        children: i
    });
}), $f506dcc23858008c$var$T = {
    width: "100%",
    borderCollapse: "collapse"
}, $f506dcc23858008c$export$4b779126465c60ce = (0, $exYeM.memo)(function(t) {
    var i, o = t.title, n = t.rows, r = void 0 === n ? [] : n, e = t.renderContent, l = (0, $5c76f646ce642491$export$93d4e7f90805808f)();
    return r.length ? (i = "function" == typeof e ? e() : (0, $aSiaI.jsxs)("div", {
        children: [
            o && o,
            (0, $aSiaI.jsx)("table", {
                style: $f506dcc23858008c$var$v({}, $f506dcc23858008c$var$T, l.tooltip.table),
                children: (0, $aSiaI.jsx)("tbody", {
                    children: r.map(function(t, i) {
                        return (0, $aSiaI.jsx)("tr", {
                            children: t.map(function(t, i) {
                                return (0, $aSiaI.jsx)("td", {
                                    style: l.tooltip.tableCell,
                                    children: t
                                }, i);
                            })
                        }, i);
                    })
                })
            })
        ]
    }), (0, $aSiaI.jsx)("div", {
        style: l.tooltip.container,
        children: i
    })) : null;
});
$f506dcc23858008c$export$4b779126465c60ce.displayName = "TableTooltip";
var $f506dcc23858008c$var$E = (0, $exYeM.memo)(function(t) {
    var i = t.x0, n = t.x1, r = t.y0, e = t.y1, l = (0, $5c76f646ce642491$export$93d4e7f90805808f)(), u = (0, $5c76f646ce642491$export$72acc3dc9629d75d)(), d = u.animate, y = u.config, f = (0, $exYeM.useMemo)(function() {
        return $f506dcc23858008c$var$v({}, l.crosshair.line, {
            pointerEvents: "none"
        });
    }, [
        l.crosshair.line
    ]), x = (0, $9f726edb03f4840c$export$c4af9125706c4d30)({
        x1: i,
        x2: n,
        y1: r,
        y2: e,
        config: y,
        immediate: !d
    });
    return (0, $aSiaI.jsx)((0, $f9aea5876333360d$export$407448d2b89b1813).line, $f506dcc23858008c$var$v({}, x, {
        fill: "none",
        style: f
    }));
});
$f506dcc23858008c$var$E.displayName = "CrosshairLine";
var $f506dcc23858008c$export$2a195a185c8aa9e = (0, $exYeM.memo)(function(t) {
    var i, o, n = t.width, r = t.height, e = t.type, l = t.x, a = t.y;
    return "cross" === e ? (i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: r
    }, o = {
        x0: 0,
        x1: n,
        y0: a,
        y1: a
    }) : "top-left" === e ? (i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: a
    }, o = {
        x0: 0,
        x1: l,
        y0: a,
        y1: a
    }) : "top" === e ? i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: a
    } : "top-right" === e ? (i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: a
    }, o = {
        x0: l,
        x1: n,
        y0: a,
        y1: a
    }) : "right" === e ? o = {
        x0: l,
        x1: n,
        y0: a,
        y1: a
    } : "bottom-right" === e ? (i = {
        x0: l,
        x1: l,
        y0: a,
        y1: r
    }, o = {
        x0: l,
        x1: n,
        y0: a,
        y1: a
    }) : "bottom" === e ? i = {
        x0: l,
        x1: l,
        y0: a,
        y1: r
    } : "bottom-left" === e ? (i = {
        x0: l,
        x1: l,
        y0: a,
        y1: r
    }, o = {
        x0: 0,
        x1: l,
        y0: a,
        y1: a
    }) : "left" === e ? o = {
        x0: 0,
        x1: l,
        y0: a,
        y1: a
    } : "x" === e ? i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: r
    } : "y" === e && (o = {
        x0: 0,
        x1: n,
        y0: a,
        y1: a
    }), (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            i && (0, $aSiaI.jsx)($f506dcc23858008c$var$E, {
                x0: i.x0,
                x1: i.x1,
                y0: i.y0,
                y1: i.y1
            }),
            o && (0, $aSiaI.jsx)($f506dcc23858008c$var$E, {
                x0: o.x0,
                x1: o.x1,
                y0: o.y0,
                y1: o.y1
            })
        ]
    });
});
$f506dcc23858008c$export$2a195a185c8aa9e.displayName = "Crosshair";
var $f506dcc23858008c$export$d344f0e974db1e2e = (0, $exYeM.createContext)({
    showTooltipAt: function() {},
    showTooltipFromEvent: function() {},
    hideTooltip: function() {}
}), $f506dcc23858008c$export$3a517200cf5bfc1b = {
    isVisible: !1,
    position: [
        null,
        null
    ],
    content: null,
    anchor: null
}, $f506dcc23858008c$export$c7027a64d546bf1d = (0, $exYeM.createContext)($f506dcc23858008c$export$3a517200cf5bfc1b), $f506dcc23858008c$export$85cc26a2c4544aaa = function(t) {
    var i = (0, $exYeM.useState)($f506dcc23858008c$export$3a517200cf5bfc1b), n = i[0], l = i[1], a = (0, $exYeM.useCallback)(function(t, i, o) {
        var n = i[0], r = i[1];
        void 0 === o && (o = "top"), l({
            isVisible: !0,
            position: [
                n,
                r
            ],
            anchor: o,
            content: t
        });
    }, [
        l
    ]), c = (0, $exYeM.useCallback)(function(i, o, n) {
        void 0 === n && (n = "top");
        var r = t.current.getBoundingClientRect(), e = t.current.offsetWidth, a = e === r.width ? 1 : e / r.width, c = "touches" in o ? o.touches[0] : o, s = c.clientX, h = c.clientY, u = (s - r.left) * a, d = (h - r.top) * a;
        "left" !== n && "right" !== n || (n = u < r.width / 2 ? "right" : "left"), l({
            isVisible: !0,
            position: [
                u,
                d
            ],
            anchor: n,
            content: i
        });
    }, [
        t,
        l
    ]), s = (0, $exYeM.useCallback)(function() {
        l($f506dcc23858008c$export$3a517200cf5bfc1b);
    }, [
        l
    ]);
    return {
        actions: (0, $exYeM.useMemo)(function() {
            return {
                showTooltipAt: a,
                showTooltipFromEvent: c,
                hideTooltip: s
            };
        }, [
            a,
            c,
            s
        ]),
        state: n
    };
}, $f506dcc23858008c$export$1c4b08e0eca38426 = function() {
    var t = (0, $exYeM.useContext)($f506dcc23858008c$export$d344f0e974db1e2e);
    if (void 0 === t) throw new Error("useTooltip must be used within a TooltipProvider");
    return t;
}, $f506dcc23858008c$export$b6b30c61d706ffee = function() {
    var t = (0, $exYeM.useContext)($f506dcc23858008c$export$c7027a64d546bf1d);
    if (void 0 === t) throw new Error("useTooltipState must be used within a TooltipProvider");
    return t;
}, $f506dcc23858008c$export$dd4f39ed288d94c9 = function(t) {
    return t.isVisible;
}, $f506dcc23858008c$export$28c660c63b792dea = function() {
    var t = $f506dcc23858008c$export$b6b30c61d706ffee();
    return $f506dcc23858008c$export$dd4f39ed288d94c9(t) ? (0, $aSiaI.jsx)($f506dcc23858008c$export$57a09c4864b20b90, {
        position: t.position,
        anchor: t.anchor,
        children: t.content
    }) : null;
}, $f506dcc23858008c$export$f78649fb9ca566b8 = function(t) {
    var i = t.container, o = t.children, n = $f506dcc23858008c$export$85cc26a2c4544aaa(i), r = n.actions, e = n.state;
    return (0, $aSiaI.jsx)($f506dcc23858008c$export$d344f0e974db1e2e.Provider, {
        value: r,
        children: (0, $aSiaI.jsx)($f506dcc23858008c$export$c7027a64d546bf1d.Provider, {
            value: e,
            children: o
        })
    });
};


var $9213bdecf42e3980$exports = {};
var $6f004cf8c84264f3$exports = {};
var $8bfbce7e35b86105$exports = {};
var $9655ef897f0bbdba$exports = {};
var $ed640afc4605eeaf$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $ed640afc4605eeaf$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$ed640afc4605eeaf$exports = $ed640afc4605eeaf$var$listCacheClear;


var $8dacab0aad959c1a$exports = {};
var $a5c18ae4f7c751db$exports = {};
var $6f80be9883321bbe$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $6f80be9883321bbe$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$6f80be9883321bbe$exports = $6f80be9883321bbe$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a5c18ae4f7c751db$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($6f80be9883321bbe$exports(array[length][0], key)) return length;
    }
    return -1;
}
$a5c18ae4f7c751db$exports = $a5c18ae4f7c751db$var$assocIndexOf;


/** Used for built-in method references. */ var $8dacab0aad959c1a$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $8dacab0aad959c1a$var$splice = $8dacab0aad959c1a$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $8dacab0aad959c1a$var$listCacheDelete(key) {
    var data = this.__data__, index = $a5c18ae4f7c751db$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $8dacab0aad959c1a$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$8dacab0aad959c1a$exports = $8dacab0aad959c1a$var$listCacheDelete;


var $822f7d857aa2dcb8$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $822f7d857aa2dcb8$var$listCacheGet(key) {
    var data = this.__data__, index = $a5c18ae4f7c751db$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$822f7d857aa2dcb8$exports = $822f7d857aa2dcb8$var$listCacheGet;


var $5edb34374c74a495$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $5edb34374c74a495$var$listCacheHas(key) {
    return $a5c18ae4f7c751db$exports(this.__data__, key) > -1;
}
$5edb34374c74a495$exports = $5edb34374c74a495$var$listCacheHas;


var $315b693937a70245$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $315b693937a70245$var$listCacheSet(key, value) {
    var data = this.__data__, index = $a5c18ae4f7c751db$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$315b693937a70245$exports = $315b693937a70245$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9655ef897f0bbdba$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$9655ef897f0bbdba$var$ListCache.prototype.clear = $ed640afc4605eeaf$exports;
$9655ef897f0bbdba$var$ListCache.prototype["delete"] = $8dacab0aad959c1a$exports;
$9655ef897f0bbdba$var$ListCache.prototype.get = $822f7d857aa2dcb8$exports;
$9655ef897f0bbdba$var$ListCache.prototype.has = $5edb34374c74a495$exports;
$9655ef897f0bbdba$var$ListCache.prototype.set = $315b693937a70245$exports;
$9655ef897f0bbdba$exports = $9655ef897f0bbdba$var$ListCache;


var $f4765b9de3cd25a2$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $f4765b9de3cd25a2$var$stackClear() {
    this.__data__ = new $9655ef897f0bbdba$exports;
    this.size = 0;
}
$f4765b9de3cd25a2$exports = $f4765b9de3cd25a2$var$stackClear;


var $4e48da7de9bc0080$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4e48da7de9bc0080$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$4e48da7de9bc0080$exports = $4e48da7de9bc0080$var$stackDelete;


var $21c09588dffa6b32$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $21c09588dffa6b32$var$stackGet(key) {
    return this.__data__.get(key);
}
$21c09588dffa6b32$exports = $21c09588dffa6b32$var$stackGet;


var $2739006159eb7a0c$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2739006159eb7a0c$var$stackHas(key) {
    return this.__data__.has(key);
}
$2739006159eb7a0c$exports = $2739006159eb7a0c$var$stackHas;


var $0ab5431b23eb293c$exports = {};

var $1b8f1205e4056240$exports = {};
var $97e6c72a80d118d2$exports = {};
var $105e649bd3deec51$exports = {};
var $63bef038e059393f$exports = {};
var $852d1f971b259156$exports = {};
var $a090581360ce8173$exports = {};

var $8ThvE = parcelRequire("8ThvE");
/** Built-in value references. */ var $a090581360ce8173$var$Symbol = $8ThvE.Symbol;
$a090581360ce8173$exports = $a090581360ce8173$var$Symbol;


var $f2cc4cee927d37c7$exports = {};

/** Used for built-in method references. */ var $f2cc4cee927d37c7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f2cc4cee927d37c7$var$hasOwnProperty = $f2cc4cee927d37c7$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f2cc4cee927d37c7$var$nativeObjectToString = $f2cc4cee927d37c7$var$objectProto.toString;
/** Built-in value references. */ var $f2cc4cee927d37c7$var$symToStringTag = $a090581360ce8173$exports ? $a090581360ce8173$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $f2cc4cee927d37c7$var$getRawTag(value) {
    var isOwn = $f2cc4cee927d37c7$var$hasOwnProperty.call(value, $f2cc4cee927d37c7$var$symToStringTag), tag = value[$f2cc4cee927d37c7$var$symToStringTag];
    try {
        value[$f2cc4cee927d37c7$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $f2cc4cee927d37c7$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$f2cc4cee927d37c7$var$symToStringTag] = tag;
        else delete value[$f2cc4cee927d37c7$var$symToStringTag];
    }
    return result;
}
$f2cc4cee927d37c7$exports = $f2cc4cee927d37c7$var$getRawTag;


var $934b51efa189f09c$exports = {};
/** Used for built-in method references. */ var $934b51efa189f09c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $934b51efa189f09c$var$nativeObjectToString = $934b51efa189f09c$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $934b51efa189f09c$var$objectToString(value) {
    return $934b51efa189f09c$var$nativeObjectToString.call(value);
}
$934b51efa189f09c$exports = $934b51efa189f09c$var$objectToString;


/** `Object#toString` result references. */ var $852d1f971b259156$var$nullTag = "[object Null]", $852d1f971b259156$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $852d1f971b259156$var$symToStringTag = $a090581360ce8173$exports ? $a090581360ce8173$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $852d1f971b259156$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $852d1f971b259156$var$undefinedTag : $852d1f971b259156$var$nullTag;
    return $852d1f971b259156$var$symToStringTag && $852d1f971b259156$var$symToStringTag in Object(value) ? $f2cc4cee927d37c7$exports(value) : $934b51efa189f09c$exports(value);
}
$852d1f971b259156$exports = $852d1f971b259156$var$baseGetTag;


var $db5dfd0661742a1a$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $db5dfd0661742a1a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$db5dfd0661742a1a$exports = $db5dfd0661742a1a$var$isObject;


/** `Object#toString` result references. */ var $63bef038e059393f$var$asyncTag = "[object AsyncFunction]", $63bef038e059393f$var$funcTag = "[object Function]", $63bef038e059393f$var$genTag = "[object GeneratorFunction]", $63bef038e059393f$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $63bef038e059393f$var$isFunction(value) {
    if (!$db5dfd0661742a1a$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $852d1f971b259156$exports(value);
    return tag == $63bef038e059393f$var$funcTag || tag == $63bef038e059393f$var$genTag || tag == $63bef038e059393f$var$asyncTag || tag == $63bef038e059393f$var$proxyTag;
}
$63bef038e059393f$exports = $63bef038e059393f$var$isFunction;


var $989d09d10c86a3af$exports = {};
var $69576d09d95c0935$exports = {};

var $8ThvE = parcelRequire("8ThvE");
/** Used to detect overreaching core-js shims. */ var $69576d09d95c0935$var$coreJsData = $8ThvE["__core-js_shared__"];
$69576d09d95c0935$exports = $69576d09d95c0935$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $989d09d10c86a3af$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($69576d09d95c0935$exports && $69576d09d95c0935$exports.keys && $69576d09d95c0935$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $989d09d10c86a3af$var$isMasked(func) {
    return !!$989d09d10c86a3af$var$maskSrcKey && $989d09d10c86a3af$var$maskSrcKey in func;
}
$989d09d10c86a3af$exports = $989d09d10c86a3af$var$isMasked;



var $3d1b4ae41857d3b0$exports = {};
/** Used for built-in method references. */ var $3d1b4ae41857d3b0$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $3d1b4ae41857d3b0$var$funcToString = $3d1b4ae41857d3b0$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $3d1b4ae41857d3b0$var$toSource(func) {
    if (func != null) {
        try {
            return $3d1b4ae41857d3b0$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$3d1b4ae41857d3b0$exports = $3d1b4ae41857d3b0$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $105e649bd3deec51$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $105e649bd3deec51$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $105e649bd3deec51$var$funcProto = Function.prototype, $105e649bd3deec51$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $105e649bd3deec51$var$funcToString = $105e649bd3deec51$var$funcProto.toString;
/** Used to check objects for own properties. */ var $105e649bd3deec51$var$hasOwnProperty = $105e649bd3deec51$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $105e649bd3deec51$var$reIsNative = RegExp("^" + $105e649bd3deec51$var$funcToString.call($105e649bd3deec51$var$hasOwnProperty).replace($105e649bd3deec51$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $105e649bd3deec51$var$baseIsNative(value) {
    if (!$db5dfd0661742a1a$exports(value) || $989d09d10c86a3af$exports(value)) return false;
    var pattern = $63bef038e059393f$exports(value) ? $105e649bd3deec51$var$reIsNative : $105e649bd3deec51$var$reIsHostCtor;
    return pattern.test($3d1b4ae41857d3b0$exports(value));
}
$105e649bd3deec51$exports = $105e649bd3deec51$var$baseIsNative;


var $5c63d0177b86ffa5$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $5c63d0177b86ffa5$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$5c63d0177b86ffa5$exports = $5c63d0177b86ffa5$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $97e6c72a80d118d2$var$getNative(object, key) {
    var value = $5c63d0177b86ffa5$exports(object, key);
    return $105e649bd3deec51$exports(value) ? value : undefined;
}
$97e6c72a80d118d2$exports = $97e6c72a80d118d2$var$getNative;



var $8ThvE = parcelRequire("8ThvE");
/* Built-in method references that are verified to be native. */ var $1b8f1205e4056240$var$Map = $97e6c72a80d118d2$exports($8ThvE, "Map");
$1b8f1205e4056240$exports = $1b8f1205e4056240$var$Map;


var $f6389c21d76f2f82$exports = {};
var $b06f33fda863a736$exports = {};
var $1e733182a9700f13$exports = {};
var $8fe1870119bc2ce4$exports = {};
var $1a89124de4ced368$exports = {};

/* Built-in method references that are verified to be native. */ var $1a89124de4ced368$var$nativeCreate = $97e6c72a80d118d2$exports(Object, "create");
$1a89124de4ced368$exports = $1a89124de4ced368$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $8fe1870119bc2ce4$var$hashClear() {
    this.__data__ = $1a89124de4ced368$exports ? $1a89124de4ced368$exports(null) : {};
    this.size = 0;
}
$8fe1870119bc2ce4$exports = $8fe1870119bc2ce4$var$hashClear;


var $7b046508d0c4b2bb$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7b046508d0c4b2bb$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$7b046508d0c4b2bb$exports = $7b046508d0c4b2bb$var$hashDelete;


var $570123ba6240e679$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $570123ba6240e679$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $570123ba6240e679$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $570123ba6240e679$var$hasOwnProperty = $570123ba6240e679$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $570123ba6240e679$var$hashGet(key) {
    var data = this.__data__;
    if ($1a89124de4ced368$exports) {
        var result = data[key];
        return result === $570123ba6240e679$var$HASH_UNDEFINED ? undefined : result;
    }
    return $570123ba6240e679$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$570123ba6240e679$exports = $570123ba6240e679$var$hashGet;


var $75e6b0027cb55f48$exports = {};

/** Used for built-in method references. */ var $75e6b0027cb55f48$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $75e6b0027cb55f48$var$hasOwnProperty = $75e6b0027cb55f48$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $75e6b0027cb55f48$var$hashHas(key) {
    var data = this.__data__;
    return $1a89124de4ced368$exports ? data[key] !== undefined : $75e6b0027cb55f48$var$hasOwnProperty.call(data, key);
}
$75e6b0027cb55f48$exports = $75e6b0027cb55f48$var$hashHas;


var $315cb19b5f7dc6c3$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $315cb19b5f7dc6c3$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $315cb19b5f7dc6c3$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $1a89124de4ced368$exports && value === undefined ? $315cb19b5f7dc6c3$var$HASH_UNDEFINED : value;
    return this;
}
$315cb19b5f7dc6c3$exports = $315cb19b5f7dc6c3$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1e733182a9700f13$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$1e733182a9700f13$var$Hash.prototype.clear = $8fe1870119bc2ce4$exports;
$1e733182a9700f13$var$Hash.prototype["delete"] = $7b046508d0c4b2bb$exports;
$1e733182a9700f13$var$Hash.prototype.get = $570123ba6240e679$exports;
$1e733182a9700f13$var$Hash.prototype.has = $75e6b0027cb55f48$exports;
$1e733182a9700f13$var$Hash.prototype.set = $315cb19b5f7dc6c3$exports;
$1e733182a9700f13$exports = $1e733182a9700f13$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $b06f33fda863a736$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $1e733182a9700f13$exports,
        "map": new ($1b8f1205e4056240$exports || $9655ef897f0bbdba$exports),
        "string": new $1e733182a9700f13$exports
    };
}
$b06f33fda863a736$exports = $b06f33fda863a736$var$mapCacheClear;


var $5f4eea80c864f4a3$exports = {};
var $ee96f1b7eaa44ac5$exports = {};
var $3bd39081531a18a3$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $3bd39081531a18a3$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$3bd39081531a18a3$exports = $3bd39081531a18a3$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $ee96f1b7eaa44ac5$var$getMapData(map, key) {
    var data = map.__data__;
    return $3bd39081531a18a3$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$ee96f1b7eaa44ac5$exports = $ee96f1b7eaa44ac5$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $5f4eea80c864f4a3$var$mapCacheDelete(key) {
    var result = $ee96f1b7eaa44ac5$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$5f4eea80c864f4a3$exports = $5f4eea80c864f4a3$var$mapCacheDelete;


var $54d2d6191fb8ab24$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $54d2d6191fb8ab24$var$mapCacheGet(key) {
    return $ee96f1b7eaa44ac5$exports(this, key).get(key);
}
$54d2d6191fb8ab24$exports = $54d2d6191fb8ab24$var$mapCacheGet;


var $e8338a2a89515313$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e8338a2a89515313$var$mapCacheHas(key) {
    return $ee96f1b7eaa44ac5$exports(this, key).has(key);
}
$e8338a2a89515313$exports = $e8338a2a89515313$var$mapCacheHas;


var $26a7fc4b70d5469b$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $26a7fc4b70d5469b$var$mapCacheSet(key, value) {
    var data = $ee96f1b7eaa44ac5$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$26a7fc4b70d5469b$exports = $26a7fc4b70d5469b$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f6389c21d76f2f82$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$f6389c21d76f2f82$var$MapCache.prototype.clear = $b06f33fda863a736$exports;
$f6389c21d76f2f82$var$MapCache.prototype["delete"] = $5f4eea80c864f4a3$exports;
$f6389c21d76f2f82$var$MapCache.prototype.get = $54d2d6191fb8ab24$exports;
$f6389c21d76f2f82$var$MapCache.prototype.has = $e8338a2a89515313$exports;
$f6389c21d76f2f82$var$MapCache.prototype.set = $26a7fc4b70d5469b$exports;
$f6389c21d76f2f82$exports = $f6389c21d76f2f82$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $0ab5431b23eb293c$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $0ab5431b23eb293c$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $9655ef897f0bbdba$exports) {
        var pairs = data.__data__;
        if (!$1b8f1205e4056240$exports || pairs.length < $0ab5431b23eb293c$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $f6389c21d76f2f82$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$0ab5431b23eb293c$exports = $0ab5431b23eb293c$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8bfbce7e35b86105$var$Stack(entries) {
    var data = this.__data__ = new $9655ef897f0bbdba$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$8bfbce7e35b86105$var$Stack.prototype.clear = $f4765b9de3cd25a2$exports;
$8bfbce7e35b86105$var$Stack.prototype["delete"] = $4e48da7de9bc0080$exports;
$8bfbce7e35b86105$var$Stack.prototype.get = $21c09588dffa6b32$exports;
$8bfbce7e35b86105$var$Stack.prototype.has = $2739006159eb7a0c$exports;
$8bfbce7e35b86105$var$Stack.prototype.set = $0ab5431b23eb293c$exports;
$8bfbce7e35b86105$exports = $8bfbce7e35b86105$var$Stack;


var $f95886c925458d4e$exports = {};
var $48f1054f3ca5da26$exports = {};
var $f6dfd7dc5e5ac807$exports = {};

var $f6dfd7dc5e5ac807$var$defineProperty = function() {
    try {
        var func = $97e6c72a80d118d2$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$f6dfd7dc5e5ac807$exports = $f6dfd7dc5e5ac807$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $48f1054f3ca5da26$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $f6dfd7dc5e5ac807$exports) $f6dfd7dc5e5ac807$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$48f1054f3ca5da26$exports = $48f1054f3ca5da26$var$baseAssignValue;



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $f95886c925458d4e$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$6f80be9883321bbe$exports(object[key], value) || value === undefined && !(key in object)) $48f1054f3ca5da26$exports(object, key, value);
}
$f95886c925458d4e$exports = $f95886c925458d4e$var$assignMergeValue;


var $964779a63aa00972$exports = {};
var $5167005b932b675c$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $5167005b932b675c$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$5167005b932b675c$exports = $5167005b932b675c$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $964779a63aa00972$var$baseFor = $5167005b932b675c$exports();
$964779a63aa00972$exports = $964779a63aa00972$var$baseFor;


var $9f628b4265dd17e9$exports = {};


var $4vs1M = parcelRequire("4vs1M");
var $265d56dce3afa249$exports = {};
var $7ab071444f25f0fd$exports = {};
var $ddf8457b0c355418$exports = {};

var $8ThvE = parcelRequire("8ThvE");
/** Built-in value references. */ var $ddf8457b0c355418$var$Uint8Array = $8ThvE.Uint8Array;
$ddf8457b0c355418$exports = $ddf8457b0c355418$var$Uint8Array;


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $7ab071444f25f0fd$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $ddf8457b0c355418$exports(result).set(new $ddf8457b0c355418$exports(arrayBuffer));
    return result;
}
$7ab071444f25f0fd$exports = $7ab071444f25f0fd$var$cloneArrayBuffer;


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $265d56dce3afa249$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $7ab071444f25f0fd$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$265d56dce3afa249$exports = $265d56dce3afa249$var$cloneTypedArray;


var $cf08566b5f17aa4f$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $cf08566b5f17aa4f$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$cf08566b5f17aa4f$exports = $cf08566b5f17aa4f$var$copyArray;


var $cdfd1eab1ed286bf$exports = {};
var $e9b96b6ee5614800$exports = {};

/** Built-in value references. */ var $e9b96b6ee5614800$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $e9b96b6ee5614800$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$db5dfd0661742a1a$exports(proto)) return {};
        if ($e9b96b6ee5614800$var$objectCreate) return $e9b96b6ee5614800$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$e9b96b6ee5614800$exports = $e9b96b6ee5614800$var$baseCreate;


var $7a9433312306cf5b$exports = {};
var $10bd1c09b9f64069$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $10bd1c09b9f64069$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$10bd1c09b9f64069$exports = $10bd1c09b9f64069$var$overArg;


/** Built-in value references. */ var $7a9433312306cf5b$var$getPrototype = $10bd1c09b9f64069$exports(Object.getPrototypeOf, Object);
$7a9433312306cf5b$exports = $7a9433312306cf5b$var$getPrototype;


var $9fb63971f28e98ce$exports = {};
/** Used for built-in method references. */ var $9fb63971f28e98ce$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $9fb63971f28e98ce$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $9fb63971f28e98ce$var$objectProto;
    return value === proto;
}
$9fb63971f28e98ce$exports = $9fb63971f28e98ce$var$isPrototype;


/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $cdfd1eab1ed286bf$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$9fb63971f28e98ce$exports(object) ? $e9b96b6ee5614800$exports($7a9433312306cf5b$exports(object)) : {};
}
$cdfd1eab1ed286bf$exports = $cdfd1eab1ed286bf$var$initCloneObject;


var $c09020d853f4dd56$exports = {};
var $673e072344569ebe$exports = {};

var $5475ba594a8bdf91$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $5475ba594a8bdf91$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$5475ba594a8bdf91$exports = $5475ba594a8bdf91$var$isObjectLike;


/** `Object#toString` result references. */ var $673e072344569ebe$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $673e072344569ebe$var$baseIsArguments(value) {
    return $5475ba594a8bdf91$exports(value) && $852d1f971b259156$exports(value) == $673e072344569ebe$var$argsTag;
}
$673e072344569ebe$exports = $673e072344569ebe$var$baseIsArguments;



/** Used for built-in method references. */ var $c09020d853f4dd56$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c09020d853f4dd56$var$hasOwnProperty = $c09020d853f4dd56$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $c09020d853f4dd56$var$propertyIsEnumerable = $c09020d853f4dd56$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $c09020d853f4dd56$var$isArguments = $673e072344569ebe$exports(function() {
    return arguments;
}()) ? $673e072344569ebe$exports : function(value) {
    return $5475ba594a8bdf91$exports(value) && $c09020d853f4dd56$var$hasOwnProperty.call(value, "callee") && !$c09020d853f4dd56$var$propertyIsEnumerable.call(value, "callee");
};
$c09020d853f4dd56$exports = $c09020d853f4dd56$var$isArguments;


var $8cb3ae215df00a00$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $8cb3ae215df00a00$var$isArray = Array.isArray;
$8cb3ae215df00a00$exports = $8cb3ae215df00a00$var$isArray;


var $895dc4b9d7f15545$exports = {};
var $887f7dd95a2dee62$exports = {};

var $9ad3d04370aa37c9$exports = {};
/** Used as references for various `Number` constants. */ var $9ad3d04370aa37c9$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $9ad3d04370aa37c9$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $9ad3d04370aa37c9$var$MAX_SAFE_INTEGER;
}
$9ad3d04370aa37c9$exports = $9ad3d04370aa37c9$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $887f7dd95a2dee62$var$isArrayLike(value) {
    return value != null && $9ad3d04370aa37c9$exports(value.length) && !$63bef038e059393f$exports(value);
}
$887f7dd95a2dee62$exports = $887f7dd95a2dee62$var$isArrayLike;



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $895dc4b9d7f15545$var$isArrayLikeObject(value) {
    return $5475ba594a8bdf91$exports(value) && $887f7dd95a2dee62$exports(value);
}
$895dc4b9d7f15545$exports = $895dc4b9d7f15545$var$isArrayLikeObject;



var $7HKs8 = parcelRequire("7HKs8");


var $58f2645d8a82ddb4$exports = {};



/** `Object#toString` result references. */ var $58f2645d8a82ddb4$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $58f2645d8a82ddb4$var$funcProto = Function.prototype, $58f2645d8a82ddb4$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $58f2645d8a82ddb4$var$funcToString = $58f2645d8a82ddb4$var$funcProto.toString;
/** Used to check objects for own properties. */ var $58f2645d8a82ddb4$var$hasOwnProperty = $58f2645d8a82ddb4$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $58f2645d8a82ddb4$var$objectCtorString = $58f2645d8a82ddb4$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $58f2645d8a82ddb4$var$isPlainObject(value) {
    if (!$5475ba594a8bdf91$exports(value) || $852d1f971b259156$exports(value) != $58f2645d8a82ddb4$var$objectTag) return false;
    var proto = $7a9433312306cf5b$exports(value);
    if (proto === null) return true;
    var Ctor = $58f2645d8a82ddb4$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $58f2645d8a82ddb4$var$funcToString.call(Ctor) == $58f2645d8a82ddb4$var$objectCtorString;
}
$58f2645d8a82ddb4$exports = $58f2645d8a82ddb4$var$isPlainObject;


var $32e7db2a0777bb6d$exports = {};
var $404e7686b4834cf1$exports = {};



/** `Object#toString` result references. */ var $404e7686b4834cf1$var$argsTag = "[object Arguments]", $404e7686b4834cf1$var$arrayTag = "[object Array]", $404e7686b4834cf1$var$boolTag = "[object Boolean]", $404e7686b4834cf1$var$dateTag = "[object Date]", $404e7686b4834cf1$var$errorTag = "[object Error]", $404e7686b4834cf1$var$funcTag = "[object Function]", $404e7686b4834cf1$var$mapTag = "[object Map]", $404e7686b4834cf1$var$numberTag = "[object Number]", $404e7686b4834cf1$var$objectTag = "[object Object]", $404e7686b4834cf1$var$regexpTag = "[object RegExp]", $404e7686b4834cf1$var$setTag = "[object Set]", $404e7686b4834cf1$var$stringTag = "[object String]", $404e7686b4834cf1$var$weakMapTag = "[object WeakMap]";
var $404e7686b4834cf1$var$arrayBufferTag = "[object ArrayBuffer]", $404e7686b4834cf1$var$dataViewTag = "[object DataView]", $404e7686b4834cf1$var$float32Tag = "[object Float32Array]", $404e7686b4834cf1$var$float64Tag = "[object Float64Array]", $404e7686b4834cf1$var$int8Tag = "[object Int8Array]", $404e7686b4834cf1$var$int16Tag = "[object Int16Array]", $404e7686b4834cf1$var$int32Tag = "[object Int32Array]", $404e7686b4834cf1$var$uint8Tag = "[object Uint8Array]", $404e7686b4834cf1$var$uint8ClampedTag = "[object Uint8ClampedArray]", $404e7686b4834cf1$var$uint16Tag = "[object Uint16Array]", $404e7686b4834cf1$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $404e7686b4834cf1$var$typedArrayTags = {};
$404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$float32Tag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$float64Tag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$int8Tag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$int16Tag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$int32Tag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$uint8Tag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$uint8ClampedTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$uint16Tag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$uint32Tag] = true;
$404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$argsTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$arrayTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$arrayBufferTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$boolTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$dataViewTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$dateTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$errorTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$funcTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$mapTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$numberTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$objectTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$regexpTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$setTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$stringTag] = $404e7686b4834cf1$var$typedArrayTags[$404e7686b4834cf1$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $404e7686b4834cf1$var$baseIsTypedArray(value) {
    return $5475ba594a8bdf91$exports(value) && $9ad3d04370aa37c9$exports(value.length) && !!$404e7686b4834cf1$var$typedArrayTags[$852d1f971b259156$exports(value)];
}
$404e7686b4834cf1$exports = $404e7686b4834cf1$var$baseIsTypedArray;


var $a37b20fb7156577b$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $a37b20fb7156577b$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$a37b20fb7156577b$exports = $a37b20fb7156577b$var$baseUnary;



var $7vc1R = parcelRequire("7vc1R");
/* Node.js helper references. */ var $32e7db2a0777bb6d$var$nodeIsTypedArray = $7vc1R && $7vc1R.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $32e7db2a0777bb6d$var$isTypedArray = $32e7db2a0777bb6d$var$nodeIsTypedArray ? $a37b20fb7156577b$exports($32e7db2a0777bb6d$var$nodeIsTypedArray) : $404e7686b4834cf1$exports;
$32e7db2a0777bb6d$exports = $32e7db2a0777bb6d$var$isTypedArray;


var $fcee1f8a14d7a674$exports = {};
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $fcee1f8a14d7a674$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
$fcee1f8a14d7a674$exports = $fcee1f8a14d7a674$var$safeGet;


var $60e51bee682d4267$exports = {};
var $31c6b882f05692c6$exports = {};
var $6a410827939ce210$exports = {};


/** Used for built-in method references. */ var $6a410827939ce210$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6a410827939ce210$var$hasOwnProperty = $6a410827939ce210$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $6a410827939ce210$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($6a410827939ce210$var$hasOwnProperty.call(object, key) && $6f80be9883321bbe$exports(objValue, value)) || value === undefined && !(key in object)) $48f1054f3ca5da26$exports(object, key, value);
}
$6a410827939ce210$exports = $6a410827939ce210$var$assignValue;



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $31c6b882f05692c6$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $48f1054f3ca5da26$exports(object, key, newValue);
        else $6a410827939ce210$exports(object, key, newValue);
    }
    return object;
}
$31c6b882f05692c6$exports = $31c6b882f05692c6$var$copyObject;


var $9db77247add89d2e$exports = {};
var $1a01a48c6e6e7ac2$exports = {};
var $29cd5707c05bf6b8$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $29cd5707c05bf6b8$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$29cd5707c05bf6b8$exports = $29cd5707c05bf6b8$var$baseTimes;





var $7HKs8 = parcelRequire("7HKs8");
var $1a5c8861aefb5e25$exports = {};
/** Used as references for various `Number` constants. */ var $1a5c8861aefb5e25$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $1a5c8861aefb5e25$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $1a5c8861aefb5e25$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $1a5c8861aefb5e25$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $1a5c8861aefb5e25$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$1a5c8861aefb5e25$exports = $1a5c8861aefb5e25$var$isIndex;



/** Used for built-in method references. */ var $1a01a48c6e6e7ac2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1a01a48c6e6e7ac2$var$hasOwnProperty = $1a01a48c6e6e7ac2$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $1a01a48c6e6e7ac2$var$arrayLikeKeys(value, inherited) {
    var isArr = $8cb3ae215df00a00$exports(value), isArg = !isArr && $c09020d853f4dd56$exports(value), isBuff = !isArr && !isArg && $7HKs8(value), isType = !isArr && !isArg && !isBuff && $32e7db2a0777bb6d$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $29cd5707c05bf6b8$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $1a01a48c6e6e7ac2$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $1a5c8861aefb5e25$exports(key, length)))) result.push(key);
    return result;
}
$1a01a48c6e6e7ac2$exports = $1a01a48c6e6e7ac2$var$arrayLikeKeys;


var $a4e56b5838b2897c$exports = {};


var $292ee6609f4e7a59$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $292ee6609f4e7a59$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$292ee6609f4e7a59$exports = $292ee6609f4e7a59$var$nativeKeysIn;


/** Used for built-in method references. */ var $a4e56b5838b2897c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a4e56b5838b2897c$var$hasOwnProperty = $a4e56b5838b2897c$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $a4e56b5838b2897c$var$baseKeysIn(object) {
    if (!$db5dfd0661742a1a$exports(object)) return $292ee6609f4e7a59$exports(object);
    var isProto = $9fb63971f28e98ce$exports(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$a4e56b5838b2897c$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$a4e56b5838b2897c$exports = $a4e56b5838b2897c$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $9db77247add89d2e$var$keysIn(object) {
    return $887f7dd95a2dee62$exports(object) ? $1a01a48c6e6e7ac2$exports(object, true) : $a4e56b5838b2897c$exports(object);
}
$9db77247add89d2e$exports = $9db77247add89d2e$var$keysIn;


/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $60e51bee682d4267$var$toPlainObject(value) {
    return $31c6b882f05692c6$exports(value, $9db77247add89d2e$exports(value));
}
$60e51bee682d4267$exports = $60e51bee682d4267$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $9f628b4265dd17e9$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $fcee1f8a14d7a674$exports(object, key), srcValue = $fcee1f8a14d7a674$exports(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $f95886c925458d4e$exports(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $8cb3ae215df00a00$exports(srcValue), isBuff = !isArr && $7HKs8(srcValue), isTyped = !isArr && !isBuff && $32e7db2a0777bb6d$exports(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($8cb3ae215df00a00$exports(objValue)) newValue = objValue;
            else if ($895dc4b9d7f15545$exports(objValue)) newValue = $cf08566b5f17aa4f$exports(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $4vs1M(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $265d56dce3afa249$exports(srcValue, true);
            } else newValue = [];
        } else if ($58f2645d8a82ddb4$exports(srcValue) || $c09020d853f4dd56$exports(srcValue)) {
            newValue = objValue;
            if ($c09020d853f4dd56$exports(objValue)) newValue = $60e51bee682d4267$exports(objValue);
            else if (!$db5dfd0661742a1a$exports(objValue) || $63bef038e059393f$exports(objValue)) newValue = $cdfd1eab1ed286bf$exports(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    $f95886c925458d4e$exports(object, key, newValue);
}
$9f628b4265dd17e9$exports = $9f628b4265dd17e9$var$baseMergeDeep;





/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $6f004cf8c84264f3$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $964779a63aa00972$exports(source, function(srcValue, key) {
        stack || (stack = new $8bfbce7e35b86105$exports);
        if ($db5dfd0661742a1a$exports(srcValue)) $9f628b4265dd17e9$exports(object, source, key, srcIndex, $6f004cf8c84264f3$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($fcee1f8a14d7a674$exports(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $f95886c925458d4e$exports(object, key, newValue);
        }
    }, $9db77247add89d2e$exports);
}
$6f004cf8c84264f3$exports = $6f004cf8c84264f3$var$baseMerge;


var $9b71cf9fbbde505e$exports = {};
var $0eac8e78ce21f81f$exports = {};
var $836ffceb73715ab3$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $836ffceb73715ab3$var$identity(value) {
    return value;
}
$836ffceb73715ab3$exports = $836ffceb73715ab3$var$identity;


var $3879afe6bb0554cb$exports = {};
var $68f1f5a725c2969b$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $68f1f5a725c2969b$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$68f1f5a725c2969b$exports = $68f1f5a725c2969b$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $3879afe6bb0554cb$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $3879afe6bb0554cb$var$overRest(func, start, transform) {
    start = $3879afe6bb0554cb$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $3879afe6bb0554cb$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $68f1f5a725c2969b$exports(func, this, otherArgs);
    };
}
$3879afe6bb0554cb$exports = $3879afe6bb0554cb$var$overRest;


var $8a6ee1bbc2814f43$exports = {};
var $e850b3a4f5dcee62$exports = {};
var $2b0d250fa73ace74$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $2b0d250fa73ace74$var$constant(value) {
    return function() {
        return value;
    };
}
$2b0d250fa73ace74$exports = $2b0d250fa73ace74$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $e850b3a4f5dcee62$var$baseSetToString = !$f6dfd7dc5e5ac807$exports ? $836ffceb73715ab3$exports : function(func, string) {
    return $f6dfd7dc5e5ac807$exports(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $2b0d250fa73ace74$exports(string),
        "writable": true
    });
};
$e850b3a4f5dcee62$exports = $e850b3a4f5dcee62$var$baseSetToString;


var $8741d62e42b35f49$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $8741d62e42b35f49$var$HOT_COUNT = 800, $8741d62e42b35f49$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8741d62e42b35f49$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $8741d62e42b35f49$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $8741d62e42b35f49$var$nativeNow(), remaining = $8741d62e42b35f49$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $8741d62e42b35f49$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$8741d62e42b35f49$exports = $8741d62e42b35f49$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $8a6ee1bbc2814f43$var$setToString = $8741d62e42b35f49$exports($e850b3a4f5dcee62$exports);
$8a6ee1bbc2814f43$exports = $8a6ee1bbc2814f43$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $0eac8e78ce21f81f$var$baseRest(func, start) {
    return $8a6ee1bbc2814f43$exports($3879afe6bb0554cb$exports(func, start, $836ffceb73715ab3$exports), func + "");
}
$0eac8e78ce21f81f$exports = $0eac8e78ce21f81f$var$baseRest;


var $f8ab7f41928d2285$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $f8ab7f41928d2285$var$isIterateeCall(value, index, object) {
    if (!$db5dfd0661742a1a$exports(object)) return false;
    var type = typeof index;
    if (type == "number" ? $887f7dd95a2dee62$exports(object) && $1a5c8861aefb5e25$exports(index, object.length) : type == "string" && index in object) return $6f80be9883321bbe$exports(object[index], value);
    return false;
}
$f8ab7f41928d2285$exports = $f8ab7f41928d2285$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $9b71cf9fbbde505e$var$createAssigner(assigner) {
    return $0eac8e78ce21f81f$exports(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && $f8ab7f41928d2285$exports(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
$9b71cf9fbbde505e$exports = $9b71cf9fbbde505e$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $9213bdecf42e3980$var$merge = $9b71cf9fbbde505e$exports(function(object, source, srcIndex) {
    $6f004cf8c84264f3$exports(object, source, srcIndex);
});
$9213bdecf42e3980$exports = $9213bdecf42e3980$var$merge;


var $37f57525b6598a05$exports = {};
var $01f8d472cea3b7ad$exports = {};
var $026916563a5fc8ad$exports = {};

var $ebf30b1c72800438$exports = {};

var $b7350b23d035986b$exports = {};


/** `Object#toString` result references. */ var $b7350b23d035986b$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $b7350b23d035986b$var$isSymbol(value) {
    return typeof value == "symbol" || $5475ba594a8bdf91$exports(value) && $852d1f971b259156$exports(value) == $b7350b23d035986b$var$symbolTag;
}
$b7350b23d035986b$exports = $b7350b23d035986b$var$isSymbol;


/** Used to match property names within property paths. */ var $ebf30b1c72800438$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $ebf30b1c72800438$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $ebf30b1c72800438$var$isKey(value, object) {
    if ($8cb3ae215df00a00$exports(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $b7350b23d035986b$exports(value)) return true;
    return $ebf30b1c72800438$var$reIsPlainProp.test(value) || !$ebf30b1c72800438$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$ebf30b1c72800438$exports = $ebf30b1c72800438$var$isKey;


var $2171f479fe1b9e27$exports = {};
var $b8ba2ed78ec192fa$exports = {};
var $af3456543921feb4$exports = {};

/** Error message constants. */ var $af3456543921feb4$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $af3456543921feb4$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($af3456543921feb4$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($af3456543921feb4$var$memoize.Cache || $f6389c21d76f2f82$exports);
    return memoized;
}
// Expose `MapCache`.
$af3456543921feb4$var$memoize.Cache = $f6389c21d76f2f82$exports;
$af3456543921feb4$exports = $af3456543921feb4$var$memoize;


/** Used as the maximum memoize cache size. */ var $b8ba2ed78ec192fa$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $b8ba2ed78ec192fa$var$memoizeCapped(func) {
    var result = $af3456543921feb4$exports(func, function(key) {
        if (cache.size === $b8ba2ed78ec192fa$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$b8ba2ed78ec192fa$exports = $b8ba2ed78ec192fa$var$memoizeCapped;


/** Used to match property names within property paths. */ var $2171f479fe1b9e27$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $2171f479fe1b9e27$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2171f479fe1b9e27$var$stringToPath = $b8ba2ed78ec192fa$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($2171f479fe1b9e27$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($2171f479fe1b9e27$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$2171f479fe1b9e27$exports = $2171f479fe1b9e27$var$stringToPath;


var $22f1dff9b3c6ff0c$exports = {};
var $c59f41c766f8804e$exports = {};

var $c0d7b47ee8b12bf1$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $c0d7b47ee8b12bf1$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$c0d7b47ee8b12bf1$exports = $c0d7b47ee8b12bf1$var$arrayMap;




/** Used as references for various `Number` constants. */ var $c59f41c766f8804e$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $c59f41c766f8804e$var$symbolProto = $a090581360ce8173$exports ? $a090581360ce8173$exports.prototype : undefined, $c59f41c766f8804e$var$symbolToString = $c59f41c766f8804e$var$symbolProto ? $c59f41c766f8804e$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $c59f41c766f8804e$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($8cb3ae215df00a00$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $c0d7b47ee8b12bf1$exports(value, $c59f41c766f8804e$var$baseToString) + "";
    if ($b7350b23d035986b$exports(value)) return $c59f41c766f8804e$var$symbolToString ? $c59f41c766f8804e$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$c59f41c766f8804e$var$INFINITY ? "-0" : result;
}
$c59f41c766f8804e$exports = $c59f41c766f8804e$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $22f1dff9b3c6ff0c$var$toString(value) {
    return value == null ? "" : $c59f41c766f8804e$exports(value);
}
$22f1dff9b3c6ff0c$exports = $22f1dff9b3c6ff0c$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $026916563a5fc8ad$var$castPath(value, object) {
    if ($8cb3ae215df00a00$exports(value)) return value;
    return $ebf30b1c72800438$exports(value, object) ? [
        value
    ] : $2171f479fe1b9e27$exports($22f1dff9b3c6ff0c$exports(value));
}
$026916563a5fc8ad$exports = $026916563a5fc8ad$var$castPath;


var $e56d6cac75d4b6e0$exports = {};

/** Used as references for various `Number` constants. */ var $e56d6cac75d4b6e0$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $e56d6cac75d4b6e0$var$toKey(value) {
    if (typeof value == "string" || $b7350b23d035986b$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$e56d6cac75d4b6e0$var$INFINITY ? "-0" : result;
}
$e56d6cac75d4b6e0$exports = $e56d6cac75d4b6e0$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $01f8d472cea3b7ad$var$baseGet(object, path) {
    path = $026916563a5fc8ad$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$e56d6cac75d4b6e0$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$01f8d472cea3b7ad$exports = $01f8d472cea3b7ad$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $37f57525b6598a05$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $01f8d472cea3b7ad$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$37f57525b6598a05$exports = $37f57525b6598a05$var$get;


var $3562d0f3c7a1534b$exports = {};
var $097557fa8f04edd6$exports = {};





/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $097557fa8f04edd6$var$baseSet(object, path, value, customizer) {
    if (!$db5dfd0661742a1a$exports(object)) return object;
    path = $026916563a5fc8ad$exports(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $e56d6cac75d4b6e0$exports(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $db5dfd0661742a1a$exports(objValue) ? objValue : $1a5c8861aefb5e25$exports(path[index + 1]) ? [] : {};
        }
        $6a410827939ce210$exports(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
$097557fa8f04edd6$exports = $097557fa8f04edd6$var$baseSet;


/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $3562d0f3c7a1534b$var$set(object, path, value) {
    return object == null ? object : $097557fa8f04edd6$exports(object, path, value);
}
$3562d0f3c7a1534b$exports = $3562d0f3c7a1534b$var$set;




var $21e1eeed4365622d$exports = {};



/** `Object#toString` result references. */ var $21e1eeed4365622d$var$stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $21e1eeed4365622d$var$isString(value) {
    return typeof value == "string" || !$8cb3ae215df00a00$exports(value) && $5475ba594a8bdf91$exports(value) && $852d1f971b259156$exports(value) == $21e1eeed4365622d$var$stringTag;
}
$21e1eeed4365622d$exports = $21e1eeed4365622d$var$isString;



var $aSiaI = parcelRequire("aSiaI");
var $37b3ad643dcadb8d$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $37b3ad643dcadb8d$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$37b3ad643dcadb8d$exports = $37b3ad643dcadb8d$var$last;






function $5b716f584c76f524$export$2e2bcd8739ae039() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $55e3050441957f85$export$2e2bcd8739ae039)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $5b716f584c76f524$export$2e2bcd8739ae039().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, $1ec9baa7d5ff9a04$export$23c7bb9e6558da2a).apply((0, $200a922019157658$export$16a5d4b4a61a274d)(scale), arguments);
}


function $8c1cec2d8bf99503$export$2e2bcd8739ae039(specifier) {
    var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
    while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
    return colors;
}



var $dbca4c68100d735c$export$2e2bcd8739ae039 = (scheme)=>(0, $fa6c794a4958fdf6$export$2c0e28f2e2852d3f)(scheme[scheme.length - 1]);


var $8840bb703ed77f74$export$3005042704f95a69 = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $8840bb703ed77f74$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($8840bb703ed77f74$export$3005042704f95a69);



var $bd8720e4c6eb3871$export$3005042704f95a69 = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $bd8720e4c6eb3871$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($bd8720e4c6eb3871$export$3005042704f95a69);



var $372f913b55d41ecc$export$3005042704f95a69 = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $372f913b55d41ecc$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($372f913b55d41ecc$export$3005042704f95a69);



var $2825d6fdb7b61318$export$3005042704f95a69 = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $2825d6fdb7b61318$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($2825d6fdb7b61318$export$3005042704f95a69);


var $imKCb = parcelRequire("imKCb");

var $1tQWc = parcelRequire("1tQWc");
const $8d295036553b2548$export$8449e153fbd325fc = Math.PI / 180;
const $8d295036553b2548$export$41fc368e1a942b97 = 180 / Math.PI;


var $335760f80acd369a$var$A = -0.14861, $335760f80acd369a$var$B = 1.78277, $335760f80acd369a$var$C = -0.29227, $335760f80acd369a$var$D = -0.90649, $335760f80acd369a$var$E = 1.97294, $335760f80acd369a$var$ED = $335760f80acd369a$var$E * $335760f80acd369a$var$D, $335760f80acd369a$var$EB = $335760f80acd369a$var$E * $335760f80acd369a$var$B, $335760f80acd369a$var$BC_DA = $335760f80acd369a$var$B * $335760f80acd369a$var$C - $335760f80acd369a$var$D * $335760f80acd369a$var$A;
function $335760f80acd369a$var$cubehelixConvert(o) {
    if (o instanceof $335760f80acd369a$export$57ed4bde61a1e2f2) return new $335760f80acd369a$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $1tQWc.Rgb))) o = (0, $1tQWc.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($335760f80acd369a$var$BC_DA * b + $335760f80acd369a$var$ED * r - $335760f80acd369a$var$EB * g) / ($335760f80acd369a$var$BC_DA + $335760f80acd369a$var$ED - $335760f80acd369a$var$EB), bl = b - l, k = ($335760f80acd369a$var$E * (g - l) - $335760f80acd369a$var$C * bl) / $335760f80acd369a$var$D, s = Math.sqrt(k * k + bl * bl) / ($335760f80acd369a$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $8d295036553b2548$export$41fc368e1a942b97) - 120 : NaN;
    return new $335760f80acd369a$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $335760f80acd369a$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $335760f80acd369a$var$cubehelixConvert(h) : new $335760f80acd369a$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $335760f80acd369a$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $imKCb.default)($335760f80acd369a$export$57ed4bde61a1e2f2, $335760f80acd369a$export$2e2bcd8739ae039, (0, $imKCb.extend)((0, $1tQWc.Color), {
    brighter (k) {
        k = k == null ? (0, $1tQWc.brighter) : Math.pow((0, $1tQWc.brighter), k);
        return new $335760f80acd369a$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? (0, $1tQWc.darker) : Math.pow((0, $1tQWc.darker), k);
        return new $335760f80acd369a$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $8d295036553b2548$export$8449e153fbd325fc), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $1tQWc.Rgb)(255 * (l + a * ($335760f80acd369a$var$A * cosh + $335760f80acd369a$var$B * sinh)), 255 * (l + a * ($335760f80acd369a$var$C * cosh + $335760f80acd369a$var$D * sinh)), 255 * (l + a * ($335760f80acd369a$var$E * cosh)), this.opacity);
    }
}));




function $921322526170352b$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $335760f80acd369a$export$2e2bcd8739ae039)(start)).h, (end = (0, $335760f80acd369a$export$2e2bcd8739ae039)(end)).h), s = (0, $60d0a75f48d588f4$export$2e2bcd8739ae039)(start.s, end.s), l = (0, $60d0a75f48d588f4$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $60d0a75f48d588f4$export$2e2bcd8739ae039)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $921322526170352b$export$2e2bcd8739ae039 = $921322526170352b$var$cubehelix((0, $60d0a75f48d588f4$export$97d7b0c7ddb78dcf));
var $921322526170352b$export$934fa09ad474a1b4 = $921322526170352b$var$cubehelix((0, $60d0a75f48d588f4$export$2e2bcd8739ae039));


var $b3f27dfcd9dec59e$export$fc70efcec537be98 = (0, $921322526170352b$export$934fa09ad474a1b4)((0, $335760f80acd369a$export$2e2bcd8739ae039)(-100, 0.75, 0.35), (0, $335760f80acd369a$export$2e2bcd8739ae039)(80, 1.50, 0.8));
var $b3f27dfcd9dec59e$export$c5cedbc1ab3be2c3 = (0, $921322526170352b$export$934fa09ad474a1b4)((0, $335760f80acd369a$export$2e2bcd8739ae039)(260, 0.75, 0.35), (0, $335760f80acd369a$export$2e2bcd8739ae039)(80, 1.50, 0.8));
var $b3f27dfcd9dec59e$var$c = (0, $335760f80acd369a$export$2e2bcd8739ae039)();
function $b3f27dfcd9dec59e$export$2e2bcd8739ae039(t) {
    if (t < 0 || t > 1) t -= Math.floor(t);
    var ts = Math.abs(t - 0.5);
    $b3f27dfcd9dec59e$var$c.h = 360 * t - 100;
    $b3f27dfcd9dec59e$var$c.s = 1.5 - 1.5 * ts;
    $b3f27dfcd9dec59e$var$c.l = 0.8 - 0.9 * ts;
    return $b3f27dfcd9dec59e$var$c + "";
}



var $125f10a46720bcdb$export$2e2bcd8739ae039 = (0, $921322526170352b$export$934fa09ad474a1b4)((0, $335760f80acd369a$export$2e2bcd8739ae039)(300, 0.5, 0.0), (0, $335760f80acd369a$export$2e2bcd8739ae039)(-240, 0.5, 1.0));



var $f2a890cad3a27696$export$3005042704f95a69 = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $f2a890cad3a27696$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($f2a890cad3a27696$export$3005042704f95a69);



var $e82b4ef470f808a2$export$3005042704f95a69 = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $e82b4ef470f808a2$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($e82b4ef470f808a2$export$3005042704f95a69);



var $649d1bf6470207d9$export$3005042704f95a69 = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $649d1bf6470207d9$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($649d1bf6470207d9$export$3005042704f95a69);


function $ddc7c718e0c3feb8$var$ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
var $ddc7c718e0c3feb8$export$2e2bcd8739ae039 = $ddc7c718e0c3feb8$var$ramp((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var $ddc7c718e0c3feb8$export$c41e69203f572e8d = $ddc7c718e0c3feb8$var$ramp((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var $ddc7c718e0c3feb8$export$ad0c8285c8ea6dbd = $ddc7c718e0c3feb8$var$ramp((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var $ddc7c718e0c3feb8$export$6664860a633d9daf = $ddc7c718e0c3feb8$var$ramp((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));



var $3903e186315f0f9e$export$3005042704f95a69 = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $3903e186315f0f9e$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($3903e186315f0f9e$export$3005042704f95a69);



var $87356452b311f839$export$3005042704f95a69 = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $87356452b311f839$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($87356452b311f839$export$3005042704f95a69);



var $b02ac8d684257c07$export$3005042704f95a69 = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $b02ac8d684257c07$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($b02ac8d684257c07$export$3005042704f95a69);



var $4b0f24737a26d9f4$export$3005042704f95a69 = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $4b0f24737a26d9f4$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($4b0f24737a26d9f4$export$3005042704f95a69);



var $90194d49605c0308$export$3005042704f95a69 = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $90194d49605c0308$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($90194d49605c0308$export$3005042704f95a69);



var $4e5155d770ff652d$export$3005042704f95a69 = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $4e5155d770ff652d$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($4e5155d770ff652d$export$3005042704f95a69);



var $724b7315788895fd$export$3005042704f95a69 = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $724b7315788895fd$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($724b7315788895fd$export$3005042704f95a69);



var $04ba4a284749d9bd$export$3005042704f95a69 = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $04ba4a284749d9bd$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($04ba4a284749d9bd$export$3005042704f95a69);



var $e8bf982b60493aee$export$3005042704f95a69 = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $e8bf982b60493aee$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($e8bf982b60493aee$export$3005042704f95a69);



var $88940571a49090a6$export$3005042704f95a69 = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $88940571a49090a6$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($88940571a49090a6$export$3005042704f95a69);



var $ec8d7a22851dff21$export$3005042704f95a69 = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $ec8d7a22851dff21$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($ec8d7a22851dff21$export$3005042704f95a69);



var $01f4b40ef05e1844$export$3005042704f95a69 = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $01f4b40ef05e1844$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($01f4b40ef05e1844$export$3005042704f95a69);



var $9f68712eea8cd6ac$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $9f68712eea8cd6ac$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($9f68712eea8cd6ac$export$3005042704f95a69);



var $3139fdec064b7c51$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $3139fdec064b7c51$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($3139fdec064b7c51$export$3005042704f95a69);



var $be17f4730443c624$export$3005042704f95a69 = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $be17f4730443c624$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($be17f4730443c624$export$3005042704f95a69);


var $1tQWc = parcelRequire("1tQWc");
var $20342c4b269ec35e$var$c = (0, $1tQWc.rgb)(), $20342c4b269ec35e$var$pi_1_3 = Math.PI / 3, $20342c4b269ec35e$var$pi_2_3 = Math.PI * 2 / 3;
function $20342c4b269ec35e$export$2e2bcd8739ae039(t) {
    var x;
    t = (0.5 - t) * Math.PI;
    $20342c4b269ec35e$var$c.r = 255 * (x = Math.sin(t)) * x;
    $20342c4b269ec35e$var$c.g = 255 * (x = Math.sin(t + $20342c4b269ec35e$var$pi_1_3)) * x;
    $20342c4b269ec35e$var$c.b = 255 * (x = Math.sin(t + $20342c4b269ec35e$var$pi_2_3)) * x;
    return $20342c4b269ec35e$var$c + "";
}



var $833721ceefd949c4$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $833721ceefd949c4$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($833721ceefd949c4$export$3005042704f95a69);



var $be9a3b4b45a77417$export$3005042704f95a69 = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $be9a3b4b45a77417$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($be9a3b4b45a77417$export$3005042704f95a69);



var $6ccbc8010af45a8e$export$3005042704f95a69 = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $6ccbc8010af45a8e$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($6ccbc8010af45a8e$export$3005042704f95a69);



var $66e2852028a8e0c6$export$3005042704f95a69 = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $66e2852028a8e0c6$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($66e2852028a8e0c6$export$3005042704f95a69);



var $6c8f5a395d15fa82$export$3005042704f95a69 = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map((0, $8c1cec2d8bf99503$export$2e2bcd8739ae039));
var $6c8f5a395d15fa82$export$2e2bcd8739ae039 = (0, $dbca4c68100d735c$export$2e2bcd8739ae039)($6c8f5a395d15fa82$export$3005042704f95a69);


var $02c0c6c3f7e43cc1$export$2e2bcd8739ae039 = (0, $8c1cec2d8bf99503$export$2e2bcd8739ae039)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");


var $6cf55a52784c4c94$export$2e2bcd8739ae039 = (0, $8c1cec2d8bf99503$export$2e2bcd8739ae039)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");


var $23ad0b7aebc66491$export$2e2bcd8739ae039 = (0, $8c1cec2d8bf99503$export$2e2bcd8739ae039)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");


var $daa8fec60be60ffe$export$2e2bcd8739ae039 = (0, $8c1cec2d8bf99503$export$2e2bcd8739ae039)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");


var $4c7989bc9a50cdfa$export$2e2bcd8739ae039 = (0, $8c1cec2d8bf99503$export$2e2bcd8739ae039)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");


var $2880c7e0dc26a886$export$2e2bcd8739ae039 = (0, $8c1cec2d8bf99503$export$2e2bcd8739ae039)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");


var $55d4a8bbe5640080$export$2e2bcd8739ae039 = (0, $8c1cec2d8bf99503$export$2e2bcd8739ae039)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");


var $2f896875c60cd30c$export$2e2bcd8739ae039 = (0, $8c1cec2d8bf99503$export$2e2bcd8739ae039)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");


var $9978eafa53379e60$export$2e2bcd8739ae039 = (0, $8c1cec2d8bf99503$export$2e2bcd8739ae039)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");



var $a253959d914688f0$exports = {};
var $eee570bdbb3bfbab$exports = {};
var $32da07863e46acec$exports = {};

var $868090bb248ca2fc$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $868090bb248ca2fc$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $868090bb248ca2fc$var$setCacheAdd(value) {
    this.__data__.set(value, $868090bb248ca2fc$var$HASH_UNDEFINED);
    return this;
}
$868090bb248ca2fc$exports = $868090bb248ca2fc$var$setCacheAdd;


var $ba2e6a93841338dc$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $ba2e6a93841338dc$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$ba2e6a93841338dc$exports = $ba2e6a93841338dc$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $32da07863e46acec$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $f6389c21d76f2f82$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$32da07863e46acec$var$SetCache.prototype.add = $32da07863e46acec$var$SetCache.prototype.push = $868090bb248ca2fc$exports;
$32da07863e46acec$var$SetCache.prototype.has = $ba2e6a93841338dc$exports;
$32da07863e46acec$exports = $32da07863e46acec$var$SetCache;


var $5dded6cf8f2bedb3$exports = {};
var $10c0f51080bcfbbc$exports = {};
var $aae67ca3990c9463$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $aae67ca3990c9463$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$aae67ca3990c9463$exports = $aae67ca3990c9463$var$baseFindIndex;


var $0236eee1c797b6fe$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $0236eee1c797b6fe$var$baseIsNaN(value) {
    return value !== value;
}
$0236eee1c797b6fe$exports = $0236eee1c797b6fe$var$baseIsNaN;


var $0ff2ea5489757810$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $0ff2ea5489757810$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$0ff2ea5489757810$exports = $0ff2ea5489757810$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $10c0f51080bcfbbc$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $0ff2ea5489757810$exports(array, value, fromIndex) : $aae67ca3990c9463$exports(array, $0236eee1c797b6fe$exports, fromIndex);
}
$10c0f51080bcfbbc$exports = $10c0f51080bcfbbc$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5dded6cf8f2bedb3$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $10c0f51080bcfbbc$exports(array, value, 0) > -1;
}
$5dded6cf8f2bedb3$exports = $5dded6cf8f2bedb3$var$arrayIncludes;


var $4c1a89b755dfa22b$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $4c1a89b755dfa22b$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$4c1a89b755dfa22b$exports = $4c1a89b755dfa22b$var$arrayIncludesWith;




var $c0081f1c22a5c7b6$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c0081f1c22a5c7b6$var$cacheHas(cache, key) {
    return cache.has(key);
}
$c0081f1c22a5c7b6$exports = $c0081f1c22a5c7b6$var$cacheHas;


/** Used as the size to enable large array optimizations. */ var $eee570bdbb3bfbab$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $eee570bdbb3bfbab$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $5dded6cf8f2bedb3$exports, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $c0d7b47ee8b12bf1$exports(values, $a37b20fb7156577b$exports(iteratee));
    if (comparator) {
        includes = $4c1a89b755dfa22b$exports;
        isCommon = false;
    } else if (values.length >= $eee570bdbb3bfbab$var$LARGE_ARRAY_SIZE) {
        includes = $c0081f1c22a5c7b6$exports;
        isCommon = false;
        values = new $32da07863e46acec$exports(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
$eee570bdbb3bfbab$exports = $eee570bdbb3bfbab$var$baseDifference;




/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $a253959d914688f0$var$without = $0eac8e78ce21f81f$exports(function(array, values) {
    return $895dc4b9d7f15545$exports(array) ? $eee570bdbb3bfbab$exports(array, values) : [];
});
$a253959d914688f0$exports = $a253959d914688f0$var$without;


function $8ac4ed992c4f3772$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $8ac4ed992c4f3772$export$957f7263e89bedd2(context) {
    this._context = context;
}
$8ac4ed992c4f3772$export$957f7263e89bedd2.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $8ac4ed992c4f3772$export$105684a3041cb6f3(this, this._x1, this._y1); // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // falls through
            default:
                $8ac4ed992c4f3772$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $8ac4ed992c4f3772$export$2e2bcd8739ae039(context) {
    return new $8ac4ed992c4f3772$export$957f7263e89bedd2(context);
}

function $e804f14446a9edaa$export$2e2bcd8739ae039() {}



function $65992fe420daf471$var$BasisClosed(context) {
    this._context = context;
}
$65992fe420daf471$var$BasisClosed.prototype = {
    areaStart: (0, $e804f14446a9edaa$export$2e2bcd8739ae039),
    areaEnd: (0, $e804f14446a9edaa$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $8ac4ed992c4f3772$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $65992fe420daf471$export$2e2bcd8739ae039(context) {
    return new $65992fe420daf471$var$BasisClosed(context);
}


function $61997a9b1773375f$var$BasisOpen(context) {
    this._context = context;
}
$61997a9b1773375f$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $8ac4ed992c4f3772$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $61997a9b1773375f$export$2e2bcd8739ae039(context) {
    return new $61997a9b1773375f$var$BasisOpen(context);
}


function $466fdd409d5c4d5b$var$Bundle(context, beta) {
    this._basis = new (0, $8ac4ed992c4f3772$export$957f7263e89bedd2)(context);
    this._beta = beta;
}
$466fdd409d5c4d5b$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $466fdd409d5c4d5b$export$2e2bcd8739ae039 = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, $8ac4ed992c4f3772$export$957f7263e89bedd2)(context) : new $466fdd409d5c4d5b$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);


var $emMsn = parcelRequire("emMsn");

var $emMsn = parcelRequire("emMsn");
function $b5c4bff3ad559049$export$da3940d7e9162858(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$b5c4bff3ad559049$export$da3940d7e9162858.prototype = {
    areaStart: (0, $e804f14446a9edaa$export$2e2bcd8739ae039),
    areaEnd: (0, $e804f14446a9edaa$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $emMsn.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $b5c4bff3ad559049$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $b5c4bff3ad559049$export$da3940d7e9162858(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);


var $emMsn = parcelRequire("emMsn");
function $98223b13f7340e00$export$cd7d1a617282f2f1(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$98223b13f7340e00$export$cd7d1a617282f2f1.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $emMsn.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $98223b13f7340e00$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $98223b13f7340e00$export$cd7d1a617282f2f1(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);


var $dYto6 = parcelRequire("dYto6");


var $dYto6 = parcelRequire("dYto6");
function $2c46b9fe24bf35b1$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$2c46b9fe24bf35b1$var$CatmullRomClosed.prototype = {
    areaStart: (0, $e804f14446a9edaa$export$2e2bcd8739ae039),
    areaEnd: (0, $e804f14446a9edaa$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $dYto6.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $2c46b9fe24bf35b1$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $2c46b9fe24bf35b1$var$CatmullRomClosed(context, alpha) : new (0, $b5c4bff3ad559049$export$da3940d7e9162858)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);



var $dYto6 = parcelRequire("dYto6");
function $bd0015e5fe75ddae$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$bd0015e5fe75ddae$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $dYto6.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $bd0015e5fe75ddae$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $bd0015e5fe75ddae$var$CatmullRomOpen(context, alpha) : new (0, $98223b13f7340e00$export$cd7d1a617282f2f1)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);


function $e5ed7244a27163f2$var$LinearClosed(context) {
    this._context = context;
}
$e5ed7244a27163f2$var$LinearClosed.prototype = {
    areaStart: (0, $e804f14446a9edaa$export$2e2bcd8739ae039),
    areaEnd: (0, $e804f14446a9edaa$export$2e2bcd8739ae039),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $e5ed7244a27163f2$export$2e2bcd8739ae039(context) {
    return new $e5ed7244a27163f2$var$LinearClosed(context);
}


function $7e0b107123c71652$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $7e0b107123c71652$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}


function $159ecd298bf9faa1$export$2e2bcd8739ae039(x) {
    return x = (0, $7e0b107123c71652$export$8f8e23dd27dc19f5)(Math.abs(x)), x ? x[1] : NaN;
}


function $756cdabae631218d$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}


function $dcc94ce2ce415cd6$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}


// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $da728aec5df8dbab$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $da728aec5df8dbab$export$2e2bcd8739ae039(specifier) {
    if (!(match = $da728aec5df8dbab$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $da728aec5df8dbab$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$da728aec5df8dbab$export$2e2bcd8739ae039.prototype = $da728aec5df8dbab$export$963aac351db36ed4.prototype; // instanceof
function $da728aec5df8dbab$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$da728aec5df8dbab$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};


// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $c233efce5b97b56e$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}




var $1d9c80b12d30630d$export$6863724d9a42263;
function $1d9c80b12d30630d$export$2e2bcd8739ae039(x, p) {
    var d = (0, $7e0b107123c71652$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($1d9c80b12d30630d$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $7e0b107123c71652$export$8f8e23dd27dc19f5)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}



function $9e297ac8c90e196a$export$2e2bcd8739ae039(x, p) {
    var d = (0, $7e0b107123c71652$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}


var $0b0ddd95ddfb2fa1$export$2e2bcd8739ae039 = {
    "%": function(x, p) {
        return (x * 100).toFixed(p);
    },
    "b": function(x) {
        return Math.round(x).toString(2);
    },
    "c": function(x) {
        return x + "";
    },
    "d": (0, $7e0b107123c71652$export$2e2bcd8739ae039),
    "e": function(x, p) {
        return x.toExponential(p);
    },
    "f": function(x, p) {
        return x.toFixed(p);
    },
    "g": function(x, p) {
        return x.toPrecision(p);
    },
    "o": function(x) {
        return Math.round(x).toString(8);
    },
    "p": function(x, p) {
        return (0, $9e297ac8c90e196a$export$2e2bcd8739ae039)(x * 100, p);
    },
    "r": (0, $9e297ac8c90e196a$export$2e2bcd8739ae039),
    "s": (0, $1d9c80b12d30630d$export$2e2bcd8739ae039),
    "X": function(x) {
        return Math.round(x).toString(16).toUpperCase();
    },
    "x": function(x) {
        return Math.round(x).toString(16);
    }
};



function $9c63aff3718a0fcd$export$2e2bcd8739ae039(x) {
    return x;
}


var $7b6b661dc89bc945$var$map = Array.prototype.map, $7b6b661dc89bc945$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $7b6b661dc89bc945$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $9c63aff3718a0fcd$export$2e2bcd8739ae039) : (0, $756cdabae631218d$export$2e2bcd8739ae039)($7b6b661dc89bc945$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $9c63aff3718a0fcd$export$2e2bcd8739ae039) : (0, $dcc94ce2ce415cd6$export$2e2bcd8739ae039)($7b6b661dc89bc945$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "-" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $da728aec5df8dbab$export$2e2bcd8739ae039)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $0b0ddd95ddfb2fa1$export$2e2bcd8739ae039)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $0b0ddd95ddfb2fa1$export$2e2bcd8739ae039)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $c233efce5b97b56e$export$2e2bcd8739ae039)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $7b6b661dc89bc945$var$prefixes[8 + (0, $1d9c80b12d30630d$export$6863724d9a42263) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $da728aec5df8dbab$export$2e2bcd8739ae039)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $159ecd298bf9faa1$export$2e2bcd8739ae039)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $7b6b661dc89bc945$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}


var $735c69117027b821$var$locale;
var $735c69117027b821$export$d9468344d3651243;
var $735c69117027b821$export$8d85692a469dde6f;
$735c69117027b821$export$2e2bcd8739ae039({
    decimal: ".",
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ],
    minus: "-"
});
function $735c69117027b821$export$2e2bcd8739ae039(definition) {
    $735c69117027b821$var$locale = (0, $7b6b661dc89bc945$export$2e2bcd8739ae039)(definition);
    $735c69117027b821$export$d9468344d3651243 = $735c69117027b821$var$locale.format;
    $735c69117027b821$export$8d85692a469dde6f = $735c69117027b821$var$locale.formatPrefix;
    return $735c69117027b821$var$locale;
}


var $ff31241426847d4a$var$t0 = new Date, $ff31241426847d4a$var$t1 = new Date;
function $ff31241426847d4a$export$2e2bcd8739ae039(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $ff31241426847d4a$export$2e2bcd8739ae039(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $ff31241426847d4a$var$t0.setTime(+start), $ff31241426847d4a$var$t1.setTime(+end);
            floori($ff31241426847d4a$var$t0), floori($ff31241426847d4a$var$t1);
            return Math.floor(count($ff31241426847d4a$var$t0, $ff31241426847d4a$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}


const $8640b01d9736c06f$export$79ef0e34099623dc = 1000;
const $8640b01d9736c06f$export$683905d551c33fa9 = $8640b01d9736c06f$export$79ef0e34099623dc * 60;
const $8640b01d9736c06f$export$4157bf0c8e241659 = $8640b01d9736c06f$export$683905d551c33fa9 * 60;
const $8640b01d9736c06f$export$353686095f4fbf45 = $8640b01d9736c06f$export$4157bf0c8e241659 * 24;
const $8640b01d9736c06f$export$c241eb88520d5016 = $8640b01d9736c06f$export$353686095f4fbf45 * 7;
const $8640b01d9736c06f$export$ab95684df7020b26 = $8640b01d9736c06f$export$353686095f4fbf45 * 30;
const $8640b01d9736c06f$export$61f8ee2d834c6959 = $8640b01d9736c06f$export$353686095f4fbf45 * 365;


var $7765f3f0871825e3$var$day = (0, $ff31241426847d4a$export$2e2bcd8739ae039)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $8640b01d9736c06f$export$683905d551c33fa9)) / (0, $8640b01d9736c06f$export$353686095f4fbf45), (date)=>date.getDate() - 1);
var $7765f3f0871825e3$export$2e2bcd8739ae039 = $7765f3f0871825e3$var$day;
var $7765f3f0871825e3$export$3cf5dda4201cc0f2 = $7765f3f0871825e3$var$day.range;



function $1b2b37ccdf359dfa$var$weekday(i) {
    return (0, $ff31241426847d4a$export$2e2bcd8739ae039)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $8640b01d9736c06f$export$683905d551c33fa9)) / (0, $8640b01d9736c06f$export$c241eb88520d5016);
    });
}
var $1b2b37ccdf359dfa$export$fb3ee18ed410cc21 = $1b2b37ccdf359dfa$var$weekday(0);
var $1b2b37ccdf359dfa$export$6416afaab03bc9b8 = $1b2b37ccdf359dfa$var$weekday(1);
var $1b2b37ccdf359dfa$export$cb8f040f5d17ac7b = $1b2b37ccdf359dfa$var$weekday(2);
var $1b2b37ccdf359dfa$export$347581849975dfc8 = $1b2b37ccdf359dfa$var$weekday(3);
var $1b2b37ccdf359dfa$export$2f2b56683a3e5629 = $1b2b37ccdf359dfa$var$weekday(4);
var $1b2b37ccdf359dfa$export$59b8c2ccd931d806 = $1b2b37ccdf359dfa$var$weekday(5);
var $1b2b37ccdf359dfa$export$478ceadebff4d377 = $1b2b37ccdf359dfa$var$weekday(6);
var $1b2b37ccdf359dfa$export$e8daabaa40641211 = $1b2b37ccdf359dfa$export$fb3ee18ed410cc21.range;
var $1b2b37ccdf359dfa$export$74e5b559c235c00e = $1b2b37ccdf359dfa$export$6416afaab03bc9b8.range;
var $1b2b37ccdf359dfa$export$e7d6aa4fb107bc56 = $1b2b37ccdf359dfa$export$cb8f040f5d17ac7b.range;
var $1b2b37ccdf359dfa$export$fcd5880b20bb06a8 = $1b2b37ccdf359dfa$export$347581849975dfc8.range;
var $1b2b37ccdf359dfa$export$682716b7bbe33641 = $1b2b37ccdf359dfa$export$2f2b56683a3e5629.range;
var $1b2b37ccdf359dfa$export$482924968ca86084 = $1b2b37ccdf359dfa$export$59b8c2ccd931d806.range;
var $1b2b37ccdf359dfa$export$7d755172c9cda9d2 = $1b2b37ccdf359dfa$export$478ceadebff4d377.range;


var $9ea361cba436d700$var$year = (0, $ff31241426847d4a$export$2e2bcd8739ae039)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$9ea361cba436d700$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $ff31241426847d4a$export$2e2bcd8739ae039)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $9ea361cba436d700$export$2e2bcd8739ae039 = $9ea361cba436d700$var$year;
var $9ea361cba436d700$export$6fda41c7fb23acf9 = $9ea361cba436d700$var$year.range;



var $214ef2c611201234$var$utcDay = (0, $ff31241426847d4a$export$2e2bcd8739ae039)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, $8640b01d9736c06f$export$353686095f4fbf45);
}, function(date) {
    return date.getUTCDate() - 1;
});
var $214ef2c611201234$export$2e2bcd8739ae039 = $214ef2c611201234$var$utcDay;
var $214ef2c611201234$export$d277e198508549a1 = $214ef2c611201234$var$utcDay.range;



function $5a6387263550cc4b$var$utcWeekday(i) {
    return (0, $ff31241426847d4a$export$2e2bcd8739ae039)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, $8640b01d9736c06f$export$c241eb88520d5016);
    });
}
var $5a6387263550cc4b$export$4898b06303a92011 = $5a6387263550cc4b$var$utcWeekday(0);
var $5a6387263550cc4b$export$9cfc53b9cfafd080 = $5a6387263550cc4b$var$utcWeekday(1);
var $5a6387263550cc4b$export$2a6d545f77eceb15 = $5a6387263550cc4b$var$utcWeekday(2);
var $5a6387263550cc4b$export$a5c25d8ed64433c4 = $5a6387263550cc4b$var$utcWeekday(3);
var $5a6387263550cc4b$export$1db08111baec2f53 = $5a6387263550cc4b$var$utcWeekday(4);
var $5a6387263550cc4b$export$29265e34dd5921f7 = $5a6387263550cc4b$var$utcWeekday(5);
var $5a6387263550cc4b$export$85b74dad05049604 = $5a6387263550cc4b$var$utcWeekday(6);
var $5a6387263550cc4b$export$6f3e1c2b0f7d7880 = $5a6387263550cc4b$export$4898b06303a92011.range;
var $5a6387263550cc4b$export$1d2d8b858bb366f9 = $5a6387263550cc4b$export$9cfc53b9cfafd080.range;
var $5a6387263550cc4b$export$1d5f6785fc7f30f8 = $5a6387263550cc4b$export$2a6d545f77eceb15.range;
var $5a6387263550cc4b$export$7a75faf0e37ef4af = $5a6387263550cc4b$export$a5c25d8ed64433c4.range;
var $5a6387263550cc4b$export$417eb959611b2f2f = $5a6387263550cc4b$export$1db08111baec2f53.range;
var $5a6387263550cc4b$export$59d308db7af08c64 = $5a6387263550cc4b$export$29265e34dd5921f7.range;
var $5a6387263550cc4b$export$a124108a0a7f34c8 = $5a6387263550cc4b$export$85b74dad05049604.range;


var $ad32a995918c6200$var$utcYear = (0, $ff31241426847d4a$export$2e2bcd8739ae039)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$ad32a995918c6200$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $ff31241426847d4a$export$2e2bcd8739ae039)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $ad32a995918c6200$export$2e2bcd8739ae039 = $ad32a995918c6200$var$utcYear;
var $ad32a995918c6200$export$3e24d311e17f5802 = $ad32a995918c6200$var$utcYear.range;


function $77837e32cbb84067$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $77837e32cbb84067$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $77837e32cbb84067$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $77837e32cbb84067$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $77837e32cbb84067$var$formatRe(locale_periods), periodLookup = $77837e32cbb84067$var$formatLookup(locale_periods), weekdayRe = $77837e32cbb84067$var$formatRe(locale_weekdays), weekdayLookup = $77837e32cbb84067$var$formatLookup(locale_weekdays), shortWeekdayRe = $77837e32cbb84067$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $77837e32cbb84067$var$formatLookup(locale_shortWeekdays), monthRe = $77837e32cbb84067$var$formatRe(locale_months), monthLookup = $77837e32cbb84067$var$formatLookup(locale_months), shortMonthRe = $77837e32cbb84067$var$formatRe(locale_shortMonths), shortMonthLookup = $77837e32cbb84067$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $77837e32cbb84067$var$formatDayOfMonth,
        "e": $77837e32cbb84067$var$formatDayOfMonth,
        "f": $77837e32cbb84067$var$formatMicroseconds,
        "g": $77837e32cbb84067$var$formatYearISO,
        "G": $77837e32cbb84067$var$formatFullYearISO,
        "H": $77837e32cbb84067$var$formatHour24,
        "I": $77837e32cbb84067$var$formatHour12,
        "j": $77837e32cbb84067$var$formatDayOfYear,
        "L": $77837e32cbb84067$var$formatMilliseconds,
        "m": $77837e32cbb84067$var$formatMonthNumber,
        "M": $77837e32cbb84067$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $77837e32cbb84067$var$formatUnixTimestamp,
        "s": $77837e32cbb84067$var$formatUnixTimestampSeconds,
        "S": $77837e32cbb84067$var$formatSeconds,
        "u": $77837e32cbb84067$var$formatWeekdayNumberMonday,
        "U": $77837e32cbb84067$var$formatWeekNumberSunday,
        "V": $77837e32cbb84067$var$formatWeekNumberISO,
        "w": $77837e32cbb84067$var$formatWeekdayNumberSunday,
        "W": $77837e32cbb84067$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $77837e32cbb84067$var$formatYear,
        "Y": $77837e32cbb84067$var$formatFullYear,
        "Z": $77837e32cbb84067$var$formatZone,
        "%": $77837e32cbb84067$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $77837e32cbb84067$var$formatUTCDayOfMonth,
        "e": $77837e32cbb84067$var$formatUTCDayOfMonth,
        "f": $77837e32cbb84067$var$formatUTCMicroseconds,
        "g": $77837e32cbb84067$var$formatUTCYearISO,
        "G": $77837e32cbb84067$var$formatUTCFullYearISO,
        "H": $77837e32cbb84067$var$formatUTCHour24,
        "I": $77837e32cbb84067$var$formatUTCHour12,
        "j": $77837e32cbb84067$var$formatUTCDayOfYear,
        "L": $77837e32cbb84067$var$formatUTCMilliseconds,
        "m": $77837e32cbb84067$var$formatUTCMonthNumber,
        "M": $77837e32cbb84067$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $77837e32cbb84067$var$formatUnixTimestamp,
        "s": $77837e32cbb84067$var$formatUnixTimestampSeconds,
        "S": $77837e32cbb84067$var$formatUTCSeconds,
        "u": $77837e32cbb84067$var$formatUTCWeekdayNumberMonday,
        "U": $77837e32cbb84067$var$formatUTCWeekNumberSunday,
        "V": $77837e32cbb84067$var$formatUTCWeekNumberISO,
        "w": $77837e32cbb84067$var$formatUTCWeekdayNumberSunday,
        "W": $77837e32cbb84067$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $77837e32cbb84067$var$formatUTCYear,
        "Y": $77837e32cbb84067$var$formatUTCFullYear,
        "Z": $77837e32cbb84067$var$formatUTCZone,
        "%": $77837e32cbb84067$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $77837e32cbb84067$var$parseDayOfMonth,
        "e": $77837e32cbb84067$var$parseDayOfMonth,
        "f": $77837e32cbb84067$var$parseMicroseconds,
        "g": $77837e32cbb84067$var$parseYear,
        "G": $77837e32cbb84067$var$parseFullYear,
        "H": $77837e32cbb84067$var$parseHour24,
        "I": $77837e32cbb84067$var$parseHour24,
        "j": $77837e32cbb84067$var$parseDayOfYear,
        "L": $77837e32cbb84067$var$parseMilliseconds,
        "m": $77837e32cbb84067$var$parseMonthNumber,
        "M": $77837e32cbb84067$var$parseMinutes,
        "p": parsePeriod,
        "q": $77837e32cbb84067$var$parseQuarter,
        "Q": $77837e32cbb84067$var$parseUnixTimestamp,
        "s": $77837e32cbb84067$var$parseUnixTimestampSeconds,
        "S": $77837e32cbb84067$var$parseSeconds,
        "u": $77837e32cbb84067$var$parseWeekdayNumberMonday,
        "U": $77837e32cbb84067$var$parseWeekNumberSunday,
        "V": $77837e32cbb84067$var$parseWeekNumberISO,
        "w": $77837e32cbb84067$var$parseWeekdayNumberSunday,
        "W": $77837e32cbb84067$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $77837e32cbb84067$var$parseYear,
        "Y": $77837e32cbb84067$var$parseFullYear,
        "Z": $77837e32cbb84067$var$parseZone,
        "%": $77837e32cbb84067$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $77837e32cbb84067$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $77837e32cbb84067$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $77837e32cbb84067$var$utcDate($77837e32cbb84067$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $5a6387263550cc4b$export$9cfc53b9cfafd080).ceil(week) : (0, $5a6387263550cc4b$export$9cfc53b9cfafd080)(week);
                    week = (0, $214ef2c611201234$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $77837e32cbb84067$var$localDate($77837e32cbb84067$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $1b2b37ccdf359dfa$export$6416afaab03bc9b8).ceil(week) : (0, $1b2b37ccdf359dfa$export$6416afaab03bc9b8)(week);
                    week = (0, $7765f3f0871825e3$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $77837e32cbb84067$var$utcDate($77837e32cbb84067$var$newDate(d.y, 0, 1)).getUTCDay() : $77837e32cbb84067$var$localDate($77837e32cbb84067$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $77837e32cbb84067$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $77837e32cbb84067$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $77837e32cbb84067$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $77837e32cbb84067$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $77837e32cbb84067$var$numberRe = /^\s*\d+/, $77837e32cbb84067$var$percentRe = /^%/, $77837e32cbb84067$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $77837e32cbb84067$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $77837e32cbb84067$var$requote(s) {
    return s.replace($77837e32cbb84067$var$requoteRe, "\\$&");
}
function $77837e32cbb84067$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($77837e32cbb84067$var$requote).join("|") + ")", "i");
}
function $77837e32cbb84067$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $77837e32cbb84067$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $77837e32cbb84067$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $77837e32cbb84067$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $77837e32cbb84067$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $77837e32cbb84067$var$parseWeekNumberSunday(d, string, i) {
    var n = $77837e32cbb84067$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $77837e32cbb84067$var$parseWeekNumberISO(d, string, i) {
    var n = $77837e32cbb84067$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $77837e32cbb84067$var$parseWeekNumberMonday(d, string, i) {
    var n = $77837e32cbb84067$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $77837e32cbb84067$var$parseFullYear(d, string, i) {
    var n = $77837e32cbb84067$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $77837e32cbb84067$var$parseYear(d, string, i) {
    var n = $77837e32cbb84067$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $77837e32cbb84067$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $77837e32cbb84067$var$parseQuarter(d, string, i) {
    var n = $77837e32cbb84067$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $77837e32cbb84067$var$parseMonthNumber(d, string, i) {
    var n = $77837e32cbb84067$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $77837e32cbb84067$var$parseDayOfMonth(d, string, i) {
    var n = $77837e32cbb84067$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $77837e32cbb84067$var$parseDayOfYear(d, string, i) {
    var n = $77837e32cbb84067$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $77837e32cbb84067$var$parseHour24(d, string, i) {
    var n = $77837e32cbb84067$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $77837e32cbb84067$var$parseMinutes(d, string, i) {
    var n = $77837e32cbb84067$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $77837e32cbb84067$var$parseSeconds(d, string, i) {
    var n = $77837e32cbb84067$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $77837e32cbb84067$var$parseMilliseconds(d, string, i) {
    var n = $77837e32cbb84067$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $77837e32cbb84067$var$parseMicroseconds(d, string, i) {
    var n = $77837e32cbb84067$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $77837e32cbb84067$var$parseLiteralPercent(d, string, i) {
    var n = $77837e32cbb84067$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $77837e32cbb84067$var$parseUnixTimestamp(d, string, i) {
    var n = $77837e32cbb84067$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $77837e32cbb84067$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $77837e32cbb84067$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $77837e32cbb84067$var$formatDayOfMonth(d, p) {
    return $77837e32cbb84067$var$pad(d.getDate(), p, 2);
}
function $77837e32cbb84067$var$formatHour24(d, p) {
    return $77837e32cbb84067$var$pad(d.getHours(), p, 2);
}
function $77837e32cbb84067$var$formatHour12(d, p) {
    return $77837e32cbb84067$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $77837e32cbb84067$var$formatDayOfYear(d, p) {
    return $77837e32cbb84067$var$pad(1 + (0, $7765f3f0871825e3$export$2e2bcd8739ae039).count((0, $9ea361cba436d700$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $77837e32cbb84067$var$formatMilliseconds(d, p) {
    return $77837e32cbb84067$var$pad(d.getMilliseconds(), p, 3);
}
function $77837e32cbb84067$var$formatMicroseconds(d, p) {
    return $77837e32cbb84067$var$formatMilliseconds(d, p) + "000";
}
function $77837e32cbb84067$var$formatMonthNumber(d, p) {
    return $77837e32cbb84067$var$pad(d.getMonth() + 1, p, 2);
}
function $77837e32cbb84067$var$formatMinutes(d, p) {
    return $77837e32cbb84067$var$pad(d.getMinutes(), p, 2);
}
function $77837e32cbb84067$var$formatSeconds(d, p) {
    return $77837e32cbb84067$var$pad(d.getSeconds(), p, 2);
}
function $77837e32cbb84067$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $77837e32cbb84067$var$formatWeekNumberSunday(d, p) {
    return $77837e32cbb84067$var$pad((0, $1b2b37ccdf359dfa$export$fb3ee18ed410cc21).count((0, $9ea361cba436d700$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $77837e32cbb84067$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $1b2b37ccdf359dfa$export$2f2b56683a3e5629)(d) : (0, $1b2b37ccdf359dfa$export$2f2b56683a3e5629).ceil(d);
}
function $77837e32cbb84067$var$formatWeekNumberISO(d, p) {
    d = $77837e32cbb84067$var$dISO(d);
    return $77837e32cbb84067$var$pad((0, $1b2b37ccdf359dfa$export$2f2b56683a3e5629).count((0, $9ea361cba436d700$export$2e2bcd8739ae039)(d), d) + ((0, $9ea361cba436d700$export$2e2bcd8739ae039)(d).getDay() === 4), p, 2);
}
function $77837e32cbb84067$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $77837e32cbb84067$var$formatWeekNumberMonday(d, p) {
    return $77837e32cbb84067$var$pad((0, $1b2b37ccdf359dfa$export$6416afaab03bc9b8).count((0, $9ea361cba436d700$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $77837e32cbb84067$var$formatYear(d, p) {
    return $77837e32cbb84067$var$pad(d.getFullYear() % 100, p, 2);
}
function $77837e32cbb84067$var$formatYearISO(d, p) {
    d = $77837e32cbb84067$var$dISO(d);
    return $77837e32cbb84067$var$pad(d.getFullYear() % 100, p, 2);
}
function $77837e32cbb84067$var$formatFullYear(d, p) {
    return $77837e32cbb84067$var$pad(d.getFullYear() % 10000, p, 4);
}
function $77837e32cbb84067$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $1b2b37ccdf359dfa$export$2f2b56683a3e5629)(d) : (0, $1b2b37ccdf359dfa$export$2f2b56683a3e5629).ceil(d);
    return $77837e32cbb84067$var$pad(d.getFullYear() % 10000, p, 4);
}
function $77837e32cbb84067$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $77837e32cbb84067$var$pad(z / 60 | 0, "0", 2) + $77837e32cbb84067$var$pad(z % 60, "0", 2);
}
function $77837e32cbb84067$var$formatUTCDayOfMonth(d, p) {
    return $77837e32cbb84067$var$pad(d.getUTCDate(), p, 2);
}
function $77837e32cbb84067$var$formatUTCHour24(d, p) {
    return $77837e32cbb84067$var$pad(d.getUTCHours(), p, 2);
}
function $77837e32cbb84067$var$formatUTCHour12(d, p) {
    return $77837e32cbb84067$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $77837e32cbb84067$var$formatUTCDayOfYear(d, p) {
    return $77837e32cbb84067$var$pad(1 + (0, $214ef2c611201234$export$2e2bcd8739ae039).count((0, $ad32a995918c6200$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $77837e32cbb84067$var$formatUTCMilliseconds(d, p) {
    return $77837e32cbb84067$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $77837e32cbb84067$var$formatUTCMicroseconds(d, p) {
    return $77837e32cbb84067$var$formatUTCMilliseconds(d, p) + "000";
}
function $77837e32cbb84067$var$formatUTCMonthNumber(d, p) {
    return $77837e32cbb84067$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $77837e32cbb84067$var$formatUTCMinutes(d, p) {
    return $77837e32cbb84067$var$pad(d.getUTCMinutes(), p, 2);
}
function $77837e32cbb84067$var$formatUTCSeconds(d, p) {
    return $77837e32cbb84067$var$pad(d.getUTCSeconds(), p, 2);
}
function $77837e32cbb84067$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $77837e32cbb84067$var$formatUTCWeekNumberSunday(d, p) {
    return $77837e32cbb84067$var$pad((0, $5a6387263550cc4b$export$4898b06303a92011).count((0, $ad32a995918c6200$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $77837e32cbb84067$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $5a6387263550cc4b$export$1db08111baec2f53)(d) : (0, $5a6387263550cc4b$export$1db08111baec2f53).ceil(d);
}
function $77837e32cbb84067$var$formatUTCWeekNumberISO(d, p) {
    d = $77837e32cbb84067$var$UTCdISO(d);
    return $77837e32cbb84067$var$pad((0, $5a6387263550cc4b$export$1db08111baec2f53).count((0, $ad32a995918c6200$export$2e2bcd8739ae039)(d), d) + ((0, $ad32a995918c6200$export$2e2bcd8739ae039)(d).getUTCDay() === 4), p, 2);
}
function $77837e32cbb84067$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $77837e32cbb84067$var$formatUTCWeekNumberMonday(d, p) {
    return $77837e32cbb84067$var$pad((0, $5a6387263550cc4b$export$9cfc53b9cfafd080).count((0, $ad32a995918c6200$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $77837e32cbb84067$var$formatUTCYear(d, p) {
    return $77837e32cbb84067$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $77837e32cbb84067$var$formatUTCYearISO(d, p) {
    d = $77837e32cbb84067$var$UTCdISO(d);
    return $77837e32cbb84067$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $77837e32cbb84067$var$formatUTCFullYear(d, p) {
    return $77837e32cbb84067$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $77837e32cbb84067$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $5a6387263550cc4b$export$1db08111baec2f53)(d) : (0, $5a6387263550cc4b$export$1db08111baec2f53).ceil(d);
    return $77837e32cbb84067$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $77837e32cbb84067$var$formatUTCZone() {
    return "+0000";
}
function $77837e32cbb84067$var$formatLiteralPercent() {
    return "%";
}
function $77837e32cbb84067$var$formatUnixTimestamp(d) {
    return +d;
}
function $77837e32cbb84067$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $d5273d04d2f294a3$var$locale;
var $d5273d04d2f294a3$export$94f4d87fad5dcf9a;
var $d5273d04d2f294a3$export$32b9cd16e1b8c8d2;
var $d5273d04d2f294a3$export$1a08fe38f63ebbbb;
var $d5273d04d2f294a3$export$3edae9cf8e233729;
$d5273d04d2f294a3$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $d5273d04d2f294a3$export$2e2bcd8739ae039(definition) {
    $d5273d04d2f294a3$var$locale = (0, $77837e32cbb84067$export$2e2bcd8739ae039)(definition);
    $d5273d04d2f294a3$export$94f4d87fad5dcf9a = $d5273d04d2f294a3$var$locale.format;
    $d5273d04d2f294a3$export$32b9cd16e1b8c8d2 = $d5273d04d2f294a3$var$locale.parse;
    $d5273d04d2f294a3$export$1a08fe38f63ebbbb = $d5273d04d2f294a3$var$locale.utcFormat;
    $d5273d04d2f294a3$export$3edae9cf8e233729 = $d5273d04d2f294a3$var$locale.utcParse;
    return $d5273d04d2f294a3$var$locale;
}



var $199ff7b1f42755ea$exports = {};
var $93e1d5bfbf60bd7c$exports = {};
var $be31e234e94cb32d$exports = {};



/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $be31e234e94cb32d$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $01f8d472cea3b7ad$exports(object, path);
        if (predicate(value, path)) $097557fa8f04edd6$exports(result, $026916563a5fc8ad$exports(path, object), value);
    }
    return result;
}
$be31e234e94cb32d$exports = $be31e234e94cb32d$var$basePickBy;


var $ef091009ae184c05$exports = {};
var $c33ef5d4bef3db8d$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $c33ef5d4bef3db8d$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$c33ef5d4bef3db8d$exports = $c33ef5d4bef3db8d$var$baseHasIn;


var $f29e6f17be0e64f1$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $f29e6f17be0e64f1$var$hasPath(object, path, hasFunc) {
    path = $026916563a5fc8ad$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $e56d6cac75d4b6e0$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $9ad3d04370aa37c9$exports(length) && $1a5c8861aefb5e25$exports(key, length) && ($8cb3ae215df00a00$exports(object) || $c09020d853f4dd56$exports(object));
}
$f29e6f17be0e64f1$exports = $f29e6f17be0e64f1$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $ef091009ae184c05$var$hasIn(object, path) {
    return object != null && $f29e6f17be0e64f1$exports(object, path, $c33ef5d4bef3db8d$exports);
}
$ef091009ae184c05$exports = $ef091009ae184c05$var$hasIn;


/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $93e1d5bfbf60bd7c$var$basePick(object, paths) {
    return $be31e234e94cb32d$exports(object, paths, function(value, path) {
        return $ef091009ae184c05$exports(object, path);
    });
}
$93e1d5bfbf60bd7c$exports = $93e1d5bfbf60bd7c$var$basePick;


var $775d6f4a2b89e18d$exports = {};
var $405272f65bf7591c$exports = {};
var $8ed4fb10b1b0390d$exports = {};
var $3fc9dba05ba16d53$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $3fc9dba05ba16d53$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$3fc9dba05ba16d53$exports = $3fc9dba05ba16d53$var$arrayPush;


var $625d9a3c2ebcb040$exports = {};



/** Built-in value references. */ var $625d9a3c2ebcb040$var$spreadableSymbol = $a090581360ce8173$exports ? $a090581360ce8173$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $625d9a3c2ebcb040$var$isFlattenable(value) {
    return $8cb3ae215df00a00$exports(value) || $c09020d853f4dd56$exports(value) || !!($625d9a3c2ebcb040$var$spreadableSymbol && value && value[$625d9a3c2ebcb040$var$spreadableSymbol]);
}
$625d9a3c2ebcb040$exports = $625d9a3c2ebcb040$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $8ed4fb10b1b0390d$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $625d9a3c2ebcb040$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $8ed4fb10b1b0390d$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $3fc9dba05ba16d53$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$8ed4fb10b1b0390d$exports = $8ed4fb10b1b0390d$var$baseFlatten;


/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $405272f65bf7591c$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $8ed4fb10b1b0390d$exports(array, 1) : [];
}
$405272f65bf7591c$exports = $405272f65bf7591c$var$flatten;




/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $775d6f4a2b89e18d$var$flatRest(func) {
    return $8a6ee1bbc2814f43$exports($3879afe6bb0554cb$exports(func, undefined, $405272f65bf7591c$exports), func + "");
}
$775d6f4a2b89e18d$exports = $775d6f4a2b89e18d$var$flatRest;


/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $199ff7b1f42755ea$var$pick = $775d6f4a2b89e18d$exports(function(object, paths) {
    return object == null ? {} : $93e1d5bfbf60bd7c$exports(object, paths);
});
$199ff7b1f42755ea$exports = $199ff7b1f42755ea$var$pick;


var $cd9547e820692bcd$exports = {};
var $6219f680e6e19178$exports = {};
var $bfbd466526f8d698$exports = {};

var $d78075cec53d5845$exports = {};

var $71c492a50c15e5ea$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $71c492a50c15e5ea$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$71c492a50c15e5ea$exports = $71c492a50c15e5ea$var$arraySome;



/** Used to compose bitmasks for value comparisons. */ var $d78075cec53d5845$var$COMPARE_PARTIAL_FLAG = 1, $d78075cec53d5845$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $d78075cec53d5845$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $d78075cec53d5845$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $d78075cec53d5845$var$COMPARE_UNORDERED_FLAG ? new $32da07863e46acec$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$71c492a50c15e5ea$exports(other, function(othValue, othIndex) {
                if (!$c0081f1c22a5c7b6$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$d78075cec53d5845$exports = $d78075cec53d5845$var$equalArrays;


var $a632bfd5cacb9484$exports = {};




var $65965bd4fe27ade2$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $65965bd4fe27ade2$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$65965bd4fe27ade2$exports = $65965bd4fe27ade2$var$mapToArray;


var $eee7f5e5109334c4$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $eee7f5e5109334c4$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$eee7f5e5109334c4$exports = $eee7f5e5109334c4$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $a632bfd5cacb9484$var$COMPARE_PARTIAL_FLAG = 1, $a632bfd5cacb9484$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $a632bfd5cacb9484$var$boolTag = "[object Boolean]", $a632bfd5cacb9484$var$dateTag = "[object Date]", $a632bfd5cacb9484$var$errorTag = "[object Error]", $a632bfd5cacb9484$var$mapTag = "[object Map]", $a632bfd5cacb9484$var$numberTag = "[object Number]", $a632bfd5cacb9484$var$regexpTag = "[object RegExp]", $a632bfd5cacb9484$var$setTag = "[object Set]", $a632bfd5cacb9484$var$stringTag = "[object String]", $a632bfd5cacb9484$var$symbolTag = "[object Symbol]";
var $a632bfd5cacb9484$var$arrayBufferTag = "[object ArrayBuffer]", $a632bfd5cacb9484$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $a632bfd5cacb9484$var$symbolProto = $a090581360ce8173$exports ? $a090581360ce8173$exports.prototype : undefined, $a632bfd5cacb9484$var$symbolValueOf = $a632bfd5cacb9484$var$symbolProto ? $a632bfd5cacb9484$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $a632bfd5cacb9484$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $a632bfd5cacb9484$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $a632bfd5cacb9484$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $ddf8457b0c355418$exports(object), new $ddf8457b0c355418$exports(other))) return false;
            return true;
        case $a632bfd5cacb9484$var$boolTag:
        case $a632bfd5cacb9484$var$dateTag:
        case $a632bfd5cacb9484$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $6f80be9883321bbe$exports(+object, +other);
        case $a632bfd5cacb9484$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $a632bfd5cacb9484$var$regexpTag:
        case $a632bfd5cacb9484$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $a632bfd5cacb9484$var$mapTag:
            var convert = $65965bd4fe27ade2$exports;
        case $a632bfd5cacb9484$var$setTag:
            var isPartial = bitmask & $a632bfd5cacb9484$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $eee7f5e5109334c4$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $a632bfd5cacb9484$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $d78075cec53d5845$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $a632bfd5cacb9484$var$symbolTag:
            if ($a632bfd5cacb9484$var$symbolValueOf) return $a632bfd5cacb9484$var$symbolValueOf.call(object) == $a632bfd5cacb9484$var$symbolValueOf.call(other);
    }
    return false;
}
$a632bfd5cacb9484$exports = $a632bfd5cacb9484$var$equalByTag;


var $b4663e3cbde1ff22$exports = {};
var $860bb4b6843d7563$exports = {};
var $9d3e3231281d182b$exports = {};


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9d3e3231281d182b$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $8cb3ae215df00a00$exports(object) ? result : $3fc9dba05ba16d53$exports(result, symbolsFunc(object));
}
$9d3e3231281d182b$exports = $9d3e3231281d182b$var$baseGetAllKeys;


var $0eabf8f27c57cf11$exports = {};
var $68bbccdd4a21a80e$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $68bbccdd4a21a80e$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$68bbccdd4a21a80e$exports = $68bbccdd4a21a80e$var$arrayFilter;


var $11b31dfc90d4eeeb$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $11b31dfc90d4eeeb$var$stubArray() {
    return [];
}
$11b31dfc90d4eeeb$exports = $11b31dfc90d4eeeb$var$stubArray;


/** Used for built-in method references. */ var $0eabf8f27c57cf11$var$objectProto = Object.prototype;
/** Built-in value references. */ var $0eabf8f27c57cf11$var$propertyIsEnumerable = $0eabf8f27c57cf11$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0eabf8f27c57cf11$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $0eabf8f27c57cf11$var$getSymbols = !$0eabf8f27c57cf11$var$nativeGetSymbols ? $11b31dfc90d4eeeb$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $68bbccdd4a21a80e$exports($0eabf8f27c57cf11$var$nativeGetSymbols(object), function(symbol) {
        return $0eabf8f27c57cf11$var$propertyIsEnumerable.call(object, symbol);
    });
};
$0eabf8f27c57cf11$exports = $0eabf8f27c57cf11$var$getSymbols;


var $b104760b34d6b7b1$exports = {};

var $eb634362e8bab00b$exports = {};

var $d1eeca103b9aa761$exports = {};

/* Built-in method references for those with the same name as other `lodash` methods. */ var $d1eeca103b9aa761$var$nativeKeys = $10bd1c09b9f64069$exports(Object.keys, Object);
$d1eeca103b9aa761$exports = $d1eeca103b9aa761$var$nativeKeys;


/** Used for built-in method references. */ var $eb634362e8bab00b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $eb634362e8bab00b$var$hasOwnProperty = $eb634362e8bab00b$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $eb634362e8bab00b$var$baseKeys(object) {
    if (!$9fb63971f28e98ce$exports(object)) return $d1eeca103b9aa761$exports(object);
    var result = [];
    for(var key in Object(object))if ($eb634362e8bab00b$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$eb634362e8bab00b$exports = $eb634362e8bab00b$var$baseKeys;



/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $b104760b34d6b7b1$var$keys(object) {
    return $887f7dd95a2dee62$exports(object) ? $1a01a48c6e6e7ac2$exports(object) : $eb634362e8bab00b$exports(object);
}
$b104760b34d6b7b1$exports = $b104760b34d6b7b1$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $860bb4b6843d7563$var$getAllKeys(object) {
    return $9d3e3231281d182b$exports(object, $b104760b34d6b7b1$exports, $0eabf8f27c57cf11$exports);
}
$860bb4b6843d7563$exports = $860bb4b6843d7563$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $b4663e3cbde1ff22$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $b4663e3cbde1ff22$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b4663e3cbde1ff22$var$hasOwnProperty = $b4663e3cbde1ff22$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $b4663e3cbde1ff22$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $b4663e3cbde1ff22$var$COMPARE_PARTIAL_FLAG, objProps = $860bb4b6843d7563$exports(object), objLength = objProps.length, othProps = $860bb4b6843d7563$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $b4663e3cbde1ff22$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$b4663e3cbde1ff22$exports = $b4663e3cbde1ff22$var$equalObjects;


var $e16b2168665de4fd$exports = {};
var $17dcac0166b81916$exports = {};


var $8ThvE = parcelRequire("8ThvE");
/* Built-in method references that are verified to be native. */ var $17dcac0166b81916$var$DataView = $97e6c72a80d118d2$exports($8ThvE, "DataView");
$17dcac0166b81916$exports = $17dcac0166b81916$var$DataView;



var $94f6808d7ce0e1fd$exports = {};


var $8ThvE = parcelRequire("8ThvE");
/* Built-in method references that are verified to be native. */ var $94f6808d7ce0e1fd$var$Promise = $97e6c72a80d118d2$exports($8ThvE, "Promise");
$94f6808d7ce0e1fd$exports = $94f6808d7ce0e1fd$var$Promise;


var $1a2f39184944fa46$exports = {};


var $8ThvE = parcelRequire("8ThvE");
/* Built-in method references that are verified to be native. */ var $1a2f39184944fa46$var$Set = $97e6c72a80d118d2$exports($8ThvE, "Set");
$1a2f39184944fa46$exports = $1a2f39184944fa46$var$Set;


var $7138f8441ce5e43e$exports = {};


var $8ThvE = parcelRequire("8ThvE");
/* Built-in method references that are verified to be native. */ var $7138f8441ce5e43e$var$WeakMap = $97e6c72a80d118d2$exports($8ThvE, "WeakMap");
$7138f8441ce5e43e$exports = $7138f8441ce5e43e$var$WeakMap;




/** `Object#toString` result references. */ var $e16b2168665de4fd$var$mapTag = "[object Map]", $e16b2168665de4fd$var$objectTag = "[object Object]", $e16b2168665de4fd$var$promiseTag = "[object Promise]", $e16b2168665de4fd$var$setTag = "[object Set]", $e16b2168665de4fd$var$weakMapTag = "[object WeakMap]";
var $e16b2168665de4fd$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $e16b2168665de4fd$var$dataViewCtorString = $3d1b4ae41857d3b0$exports($17dcac0166b81916$exports), $e16b2168665de4fd$var$mapCtorString = $3d1b4ae41857d3b0$exports($1b8f1205e4056240$exports), $e16b2168665de4fd$var$promiseCtorString = $3d1b4ae41857d3b0$exports($94f6808d7ce0e1fd$exports), $e16b2168665de4fd$var$setCtorString = $3d1b4ae41857d3b0$exports($1a2f39184944fa46$exports), $e16b2168665de4fd$var$weakMapCtorString = $3d1b4ae41857d3b0$exports($7138f8441ce5e43e$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $e16b2168665de4fd$var$getTag = $852d1f971b259156$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($17dcac0166b81916$exports && $e16b2168665de4fd$var$getTag(new $17dcac0166b81916$exports(new ArrayBuffer(1))) != $e16b2168665de4fd$var$dataViewTag || $1b8f1205e4056240$exports && $e16b2168665de4fd$var$getTag(new $1b8f1205e4056240$exports) != $e16b2168665de4fd$var$mapTag || $94f6808d7ce0e1fd$exports && $e16b2168665de4fd$var$getTag($94f6808d7ce0e1fd$exports.resolve()) != $e16b2168665de4fd$var$promiseTag || $1a2f39184944fa46$exports && $e16b2168665de4fd$var$getTag(new $1a2f39184944fa46$exports) != $e16b2168665de4fd$var$setTag || $7138f8441ce5e43e$exports && $e16b2168665de4fd$var$getTag(new $7138f8441ce5e43e$exports) != $e16b2168665de4fd$var$weakMapTag) $e16b2168665de4fd$var$getTag = function(value) {
    var result = $852d1f971b259156$exports(value), Ctor = result == $e16b2168665de4fd$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $3d1b4ae41857d3b0$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $e16b2168665de4fd$var$dataViewCtorString:
            return $e16b2168665de4fd$var$dataViewTag;
        case $e16b2168665de4fd$var$mapCtorString:
            return $e16b2168665de4fd$var$mapTag;
        case $e16b2168665de4fd$var$promiseCtorString:
            return $e16b2168665de4fd$var$promiseTag;
        case $e16b2168665de4fd$var$setCtorString:
            return $e16b2168665de4fd$var$setTag;
        case $e16b2168665de4fd$var$weakMapCtorString:
            return $e16b2168665de4fd$var$weakMapTag;
    }
    return result;
};
$e16b2168665de4fd$exports = $e16b2168665de4fd$var$getTag;




var $7HKs8 = parcelRequire("7HKs8");

/** Used to compose bitmasks for value comparisons. */ var $bfbd466526f8d698$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $bfbd466526f8d698$var$argsTag = "[object Arguments]", $bfbd466526f8d698$var$arrayTag = "[object Array]", $bfbd466526f8d698$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $bfbd466526f8d698$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bfbd466526f8d698$var$hasOwnProperty = $bfbd466526f8d698$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $bfbd466526f8d698$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $8cb3ae215df00a00$exports(object), othIsArr = $8cb3ae215df00a00$exports(other), objTag = objIsArr ? $bfbd466526f8d698$var$arrayTag : $e16b2168665de4fd$exports(object), othTag = othIsArr ? $bfbd466526f8d698$var$arrayTag : $e16b2168665de4fd$exports(other);
    objTag = objTag == $bfbd466526f8d698$var$argsTag ? $bfbd466526f8d698$var$objectTag : objTag;
    othTag = othTag == $bfbd466526f8d698$var$argsTag ? $bfbd466526f8d698$var$objectTag : othTag;
    var objIsObj = objTag == $bfbd466526f8d698$var$objectTag, othIsObj = othTag == $bfbd466526f8d698$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $7HKs8(object)) {
        if (!$7HKs8(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $8bfbce7e35b86105$exports);
        return objIsArr || $32e7db2a0777bb6d$exports(object) ? $d78075cec53d5845$exports(object, other, bitmask, customizer, equalFunc, stack) : $a632bfd5cacb9484$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $bfbd466526f8d698$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $bfbd466526f8d698$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $bfbd466526f8d698$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $8bfbce7e35b86105$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $8bfbce7e35b86105$exports);
    return $b4663e3cbde1ff22$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$bfbd466526f8d698$exports = $bfbd466526f8d698$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $6219f680e6e19178$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$5475ba594a8bdf91$exports(value) && !$5475ba594a8bdf91$exports(other)) return value !== value && other !== other;
    return $bfbd466526f8d698$exports(value, other, bitmask, customizer, $6219f680e6e19178$var$baseIsEqual, stack);
}
$6219f680e6e19178$exports = $6219f680e6e19178$var$baseIsEqual;


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $cd9547e820692bcd$var$isEqual(value, other) {
    return $6219f680e6e19178$exports(value, other);
}
$cd9547e820692bcd$exports = $cd9547e820692bcd$var$isEqual;


var $5c76f646ce642491$export$164de7ab8df77ef0 = {
    background: "transparent",
    text: {
        fontFamily: "sans-serif",
        fontSize: 11,
        fill: "#333333",
        outlineWidth: 0,
        outlineColor: "transparent",
        outlineOpacity: 1
    },
    axis: {
        domain: {
            line: {
                stroke: "transparent",
                strokeWidth: 1
            }
        },
        ticks: {
            line: {
                stroke: "#777777",
                strokeWidth: 1
            },
            text: {}
        },
        legend: {
            text: {
                fontSize: 12
            }
        }
    },
    grid: {
        line: {
            stroke: "#dddddd",
            strokeWidth: 1
        }
    },
    legends: {
        hidden: {
            symbol: {
                fill: "#333333",
                opacity: .6
            },
            text: {
                fill: "#333333",
                opacity: .6
            }
        },
        text: {},
        ticks: {
            line: {
                stroke: "#777777",
                strokeWidth: 1
            },
            text: {
                fontSize: 10
            }
        },
        title: {
            text: {}
        }
    },
    labels: {
        text: {}
    },
    markers: {
        lineColor: "#000000",
        lineStrokeWidth: 1,
        text: {}
    },
    dots: {
        text: {}
    },
    tooltip: {
        container: {
            background: "white",
            color: "inherit",
            fontSize: "inherit",
            borderRadius: "2px",
            boxShadow: "0 1px 2px rgba(0, 0, 0, 0.25)",
            padding: "5px 9px"
        },
        basic: {
            whiteSpace: "pre",
            display: "flex",
            alignItems: "center"
        },
        chip: {
            marginRight: 7
        },
        table: {},
        tableCell: {
            padding: "3px 5px"
        },
        tableCellValue: {
            fontWeight: "bold"
        }
    },
    crosshair: {
        line: {
            stroke: "#000000",
            strokeWidth: 1,
            strokeOpacity: .75,
            strokeDasharray: "6 6"
        }
    },
    annotations: {
        text: {
            fontSize: 13,
            outlineWidth: 2,
            outlineColor: "#ffffff",
            outlineOpacity: 1
        },
        link: {
            stroke: "#000000",
            strokeWidth: 1,
            outlineWidth: 2,
            outlineColor: "#ffffff",
            outlineOpacity: 1
        },
        outline: {
            fill: "none",
            stroke: "#000000",
            strokeWidth: 2,
            outlineWidth: 2,
            outlineColor: "#ffffff",
            outlineOpacity: 1
        },
        symbol: {
            fill: "#000000",
            outlineWidth: 2,
            outlineColor: "#ffffff",
            outlineOpacity: 1
        }
    }
};
function $5c76f646ce642491$var$jr() {
    return $5c76f646ce642491$var$jr = Object.assign ? Object.assign.bind() : function(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = arguments[r];
            for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
        return e;
    }, $5c76f646ce642491$var$jr.apply(this, arguments);
}
function $5c76f646ce642491$var$Sr(e, r) {
    return $5c76f646ce642491$var$Sr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, r) {
        return e.__proto__ = r, e;
    }, $5c76f646ce642491$var$Sr(e, r);
}
function $5c76f646ce642491$var$Br(e, r) {
    if (null == e) return {};
    var t, n, i = {}, o = Object.keys(e);
    for(n = 0; n < o.length; n++)t = o[n], r.indexOf(t) >= 0 || (i[t] = e[t]);
    return i;
}
var $5c76f646ce642491$var$Gr = [
    "axis.ticks.text",
    "axis.legend.text",
    "legends.title.text",
    "legends.text",
    "legends.ticks.text",
    "legends.title.text",
    "labels.text",
    "dots.text",
    "markers.text",
    "annotations.text"
], $5c76f646ce642491$export$3c296778d829b724 = function(e, r) {
    return $5c76f646ce642491$var$jr({}, r, e);
}, $5c76f646ce642491$export$582fa4e2a9b13dde = function(e, r) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($9213bdecf42e3980$exports)))({}, e, r);
    return $5c76f646ce642491$var$Gr.forEach(function(e) {
        (0, (/*@__PURE__*/$parcel$interopDefault($3562d0f3c7a1534b$exports)))(t, e, $5c76f646ce642491$export$3c296778d829b724((0, (/*@__PURE__*/$parcel$interopDefault($37f57525b6598a05$exports)))(t, e), t.text));
    }), t;
}, $5c76f646ce642491$export$1855e60b4fae8997 = (0, $exYeM.createContext)(), $5c76f646ce642491$export$465303079ec41f9d = {
    animate: !0,
    config: "default"
}, $5c76f646ce642491$export$e9d875263f86dcb4 = function(e) {
    var t = e.children, n = e.animate, i = void 0 === n || n, o = e.config, l = void 0 === o ? "default" : o, a = (0, $exYeM.useMemo)(function() {
        var e = (0, (/*@__PURE__*/$parcel$interopDefault($21e1eeed4365622d$exports)))(l) ? (0, $9f726edb03f4840c$export$e506a1d27d1eaa20)[l] : l;
        return {
            animate: i,
            config: e
        };
    }, [
        i,
        l
    ]);
    return (0, $aSiaI.jsx)($5c76f646ce642491$export$1855e60b4fae8997.Provider, {
        value: a,
        children: t
    });
}, $5c76f646ce642491$export$99a092eaa44be1c8 = {
    animate: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    motionConfig: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf(Object.keys((0, $9f726edb03f4840c$export$e506a1d27d1eaa20))),
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).shape({
            mass: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
            tension: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
            friction: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
            clamp: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
            precision: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
            velocity: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
            duration: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
            easing: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func
        })
    ])
};
$5c76f646ce642491$export$e9d875263f86dcb4.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).node.isRequired,
    animate: $5c76f646ce642491$export$99a092eaa44be1c8.animate,
    config: $5c76f646ce642491$export$99a092eaa44be1c8.motionConfig
};
var $5c76f646ce642491$export$72acc3dc9629d75d = function() {
    return (0, $exYeM.useContext)($5c76f646ce642491$export$1855e60b4fae8997);
}, $5c76f646ce642491$export$6b8391a1442f2172 = function(e) {
    var t = $5c76f646ce642491$export$72acc3dc9629d75d(), o = t.animate, l = t.config, a = function(e) {
        var r = (0, $exYeM.useRef)();
        return (0, $exYeM.useEffect)(function() {
            r.current = e;
        }, [
            e
        ]), r.current;
    }(e), d = (0, $exYeM.useMemo)(function() {
        return (0, $1ef9a1579573abd1$export$2e2bcd8739ae039)(a, e);
    }, [
        a,
        e
    ]), s = (0, $9f726edb03f4840c$export$c4af9125706c4d30)({
        from: {
            value: 0
        },
        to: {
            value: 1
        },
        reset: !0,
        config: l,
        immediate: !o
    }).value;
    return (0, $9f726edb03f4840c$export$2c618a4308a30424)(s, d);
}, $5c76f646ce642491$export$77ddf829b5125d20 = {
    nivo: [
        "#d76445",
        "#f47560",
        "#e8c1a0",
        "#97e3d5",
        "#61cdbb",
        "#00b0a7"
    ],
    BrBG: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $bd8720e4c6eb3871$export$3005042704f95a69)),
    PRGn: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $4b0f24737a26d9f4$export$3005042704f95a69)),
    PiYG: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $b02ac8d684257c07$export$3005042704f95a69)),
    PuOr: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $724b7315788895fd$export$3005042704f95a69)),
    RdBu: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $88940571a49090a6$export$3005042704f95a69)),
    RdGy: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $ec8d7a22851dff21$export$3005042704f95a69)),
    RdYlBu: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $9f68712eea8cd6ac$export$3005042704f95a69)),
    RdYlGn: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $3139fdec064b7c51$export$3005042704f95a69)),
    spectral: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $833721ceefd949c4$export$3005042704f95a69)),
    blues: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $8840bb703ed77f74$export$3005042704f95a69)),
    greens: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $e82b4ef470f808a2$export$3005042704f95a69)),
    greys: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $649d1bf6470207d9$export$3005042704f95a69)),
    oranges: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $3903e186315f0f9e$export$3005042704f95a69)),
    purples: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $e8bf982b60493aee$export$3005042704f95a69)),
    reds: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $be17f4730443c624$export$3005042704f95a69)),
    BuGn: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $372f913b55d41ecc$export$3005042704f95a69)),
    BuPu: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $2825d6fdb7b61318$export$3005042704f95a69)),
    GnBu: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $f2a890cad3a27696$export$3005042704f95a69)),
    OrRd: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $87356452b311f839$export$3005042704f95a69)),
    PuBuGn: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $4e5155d770ff652d$export$3005042704f95a69)),
    PuBu: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $90194d49605c0308$export$3005042704f95a69)),
    PuRd: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $04ba4a284749d9bd$export$3005042704f95a69)),
    RdPu: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $01f4b40ef05e1844$export$3005042704f95a69)),
    YlGnBu: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $6ccbc8010af45a8e$export$3005042704f95a69)),
    YlGn: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $be9a3b4b45a77417$export$3005042704f95a69)),
    YlOrBr: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $66e2852028a8e0c6$export$3005042704f95a69)),
    YlOrRd: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $6c8f5a395d15fa82$export$3005042704f95a69))
}, $5c76f646ce642491$export$6dc823b35197e3c3 = Object.keys($5c76f646ce642491$export$77ddf829b5125d20), $5c76f646ce642491$export$8d3d36a98ebb26b6 = function(e) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($63bef038e059393f$exports)))(e)) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($63bef038e059393f$exports)))(e.domain)) throw new Error("Provided colors should be a valid quantize scale providing a 'domain()' function");
        return e;
    }
    if ($5c76f646ce642491$export$77ddf829b5125d20[e]) return (0, $5b716f584c76f524$export$2e2bcd8739ae039)().range($5c76f646ce642491$export$77ddf829b5125d20[e]);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8cb3ae215df00a00$exports)))(e)) return (0, $5b716f584c76f524$export$2e2bcd8739ae039)().range(e);
    throw new Error("Unable to guess quantize color scale from '" + e + "',\nmust be a function or one of:\n'" + $5c76f646ce642491$export$6dc823b35197e3c3.join("', '") + "'");
}, $5c76f646ce642491$var$Nr = {
    nivo: [
        "#e8c1a0",
        "#f47560",
        "#f1e15b",
        "#e8a838",
        "#61cdbb",
        "#97e3d5"
    ],
    category10: (0, $6cf55a52784c4c94$export$2e2bcd8739ae039),
    accent: (0, $02c0c6c3f7e43cc1$export$2e2bcd8739ae039),
    dark2: (0, $23ad0b7aebc66491$export$2e2bcd8739ae039),
    paired: (0, $daa8fec60be60ffe$export$2e2bcd8739ae039),
    pastel1: (0, $4c7989bc9a50cdfa$export$2e2bcd8739ae039),
    pastel2: (0, $2880c7e0dc26a886$export$2e2bcd8739ae039),
    set1: (0, $55d4a8bbe5640080$export$2e2bcd8739ae039),
    set2: (0, $2f896875c60cd30c$export$2e2bcd8739ae039),
    set3: (0, $9978eafa53379e60$export$2e2bcd8739ae039),
    brown_blueGreen: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $bd8720e4c6eb3871$export$3005042704f95a69)),
    purpleRed_green: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $4b0f24737a26d9f4$export$3005042704f95a69)),
    pink_yellowGreen: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $b02ac8d684257c07$export$3005042704f95a69)),
    purple_orange: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $724b7315788895fd$export$3005042704f95a69)),
    red_blue: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $88940571a49090a6$export$3005042704f95a69)),
    red_grey: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $ec8d7a22851dff21$export$3005042704f95a69)),
    red_yellow_blue: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $9f68712eea8cd6ac$export$3005042704f95a69)),
    red_yellow_green: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $3139fdec064b7c51$export$3005042704f95a69)),
    spectral: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $833721ceefd949c4$export$3005042704f95a69)),
    blues: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $8840bb703ed77f74$export$3005042704f95a69)),
    greens: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $e82b4ef470f808a2$export$3005042704f95a69)),
    greys: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $649d1bf6470207d9$export$3005042704f95a69)),
    oranges: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $3903e186315f0f9e$export$3005042704f95a69)),
    purples: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $e8bf982b60493aee$export$3005042704f95a69)),
    reds: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $be17f4730443c624$export$3005042704f95a69)),
    blue_green: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $372f913b55d41ecc$export$3005042704f95a69)),
    blue_purple: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $2825d6fdb7b61318$export$3005042704f95a69)),
    green_blue: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $f2a890cad3a27696$export$3005042704f95a69)),
    orange_red: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $87356452b311f839$export$3005042704f95a69)),
    purple_blue_green: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $4e5155d770ff652d$export$3005042704f95a69)),
    purple_blue: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $90194d49605c0308$export$3005042704f95a69)),
    purple_red: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $04ba4a284749d9bd$export$3005042704f95a69)),
    red_purple: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $01f4b40ef05e1844$export$3005042704f95a69)),
    yellow_green_blue: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $6ccbc8010af45a8e$export$3005042704f95a69)),
    yellow_green: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $be9a3b4b45a77417$export$3005042704f95a69)),
    yellow_orange_brown: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $66e2852028a8e0c6$export$3005042704f95a69)),
    yellow_orange_red: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))((0, $6c8f5a395d15fa82$export$3005042704f95a69))
}, $5c76f646ce642491$export$b48661626a811234 = [
    "nivo",
    "category10",
    "accent",
    "dark2",
    "paired",
    "pastel1",
    "pastel2",
    "set1",
    "set2",
    "set3",
    "brown_blueGreen",
    "purpleRed_green",
    "pink_yellowGreen",
    "purple_orange",
    "red_blue",
    "red_grey",
    "red_yellow_blue",
    "red_yellow_green",
    "spectral",
    "blues",
    "greens",
    "greys",
    "oranges",
    "purples",
    "reds",
    "blue_green",
    "blue_purple",
    "green_blue",
    "orange_red",
    "purple_blue_green",
    "purple_blue",
    "purple_red",
    "red_purple",
    "yellow_green_blue",
    "yellow_green",
    "yellow_orange_brown",
    "yellow_orange_red"
], $5c76f646ce642491$export$6638ab0298ebe095 = {
    brown_blueGreen: (0, $bd8720e4c6eb3871$export$2e2bcd8739ae039),
    purpleRed_green: (0, $4b0f24737a26d9f4$export$2e2bcd8739ae039),
    pink_yellowGreen: (0, $b02ac8d684257c07$export$2e2bcd8739ae039),
    purple_orange: (0, $724b7315788895fd$export$2e2bcd8739ae039),
    red_blue: (0, $88940571a49090a6$export$2e2bcd8739ae039),
    red_grey: (0, $ec8d7a22851dff21$export$2e2bcd8739ae039),
    red_yellow_blue: (0, $9f68712eea8cd6ac$export$2e2bcd8739ae039),
    red_yellow_green: (0, $3139fdec064b7c51$export$2e2bcd8739ae039),
    spectral: (0, $833721ceefd949c4$export$2e2bcd8739ae039),
    blues: (0, $8840bb703ed77f74$export$2e2bcd8739ae039),
    greens: (0, $e82b4ef470f808a2$export$2e2bcd8739ae039),
    greys: (0, $649d1bf6470207d9$export$2e2bcd8739ae039),
    oranges: (0, $3903e186315f0f9e$export$2e2bcd8739ae039),
    purples: (0, $e8bf982b60493aee$export$2e2bcd8739ae039),
    reds: (0, $be17f4730443c624$export$2e2bcd8739ae039),
    viridis: (0, $ddc7c718e0c3feb8$export$2e2bcd8739ae039),
    inferno: (0, $ddc7c718e0c3feb8$export$ad0c8285c8ea6dbd),
    magma: (0, $ddc7c718e0c3feb8$export$c41e69203f572e8d),
    plasma: (0, $ddc7c718e0c3feb8$export$6664860a633d9daf),
    warm: (0, $b3f27dfcd9dec59e$export$fc70efcec537be98),
    cool: (0, $b3f27dfcd9dec59e$export$c5cedbc1ab3be2c3),
    cubehelixDefault: (0, $125f10a46720bcdb$export$2e2bcd8739ae039),
    blue_green: (0, $372f913b55d41ecc$export$2e2bcd8739ae039),
    blue_purple: (0, $2825d6fdb7b61318$export$2e2bcd8739ae039),
    green_blue: (0, $f2a890cad3a27696$export$2e2bcd8739ae039),
    orange_red: (0, $87356452b311f839$export$2e2bcd8739ae039),
    purple_blue_green: (0, $4e5155d770ff652d$export$2e2bcd8739ae039),
    purple_blue: (0, $90194d49605c0308$export$2e2bcd8739ae039),
    purple_red: (0, $04ba4a284749d9bd$export$2e2bcd8739ae039),
    red_purple: (0, $01f4b40ef05e1844$export$2e2bcd8739ae039),
    yellow_green_blue: (0, $6ccbc8010af45a8e$export$2e2bcd8739ae039),
    yellow_green: (0, $be9a3b4b45a77417$export$2e2bcd8739ae039),
    yellow_orange_brown: (0, $66e2852028a8e0c6$export$2e2bcd8739ae039),
    yellow_orange_red: (0, $6c8f5a395d15fa82$export$2e2bcd8739ae039),
    rainbow: (0, $b3f27dfcd9dec59e$export$2e2bcd8739ae039),
    sinebow: (0, $20342c4b269ec35e$export$2e2bcd8739ae039)
}, $5c76f646ce642491$export$277274330ffd2780 = [
    "brown_blueGreen",
    "purpleRed_green",
    "pink_yellowGreen",
    "purple_orange",
    "red_blue",
    "red_grey",
    "red_yellow_blue",
    "red_yellow_green",
    "spectral",
    "blues",
    "greens",
    "greys",
    "oranges",
    "purples",
    "reds",
    "viridis",
    "inferno",
    "magma",
    "plasma",
    "warm",
    "cool",
    "cubehelixDefault",
    "blue_green",
    "blue_purple",
    "green_blue",
    "orange_red",
    "purple_blue_green",
    "purple_blue",
    "purple_red",
    "red_purple",
    "yellow_green_blue",
    "yellow_green",
    "yellow_orange_brown",
    "yellow_orange_red",
    "rainbow",
    "sinebow"
], $5c76f646ce642491$export$cec134b1a1fa53dd = function() {
    return (0, $b5f1e5e45355bfef$export$2e2bcd8739ae039)([
        "#e8c1a0",
        "#f47560",
        "#f1e15b",
        "#e8a838",
        "#61cdbb",
        "#97e3d5"
    ]);
}, $5c76f646ce642491$export$75f9af112506f7de = function(e, r) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($21e1eeed4365622d$exports)))(e)) {
        var t = $5c76f646ce642491$var$Nr[e];
        if (void 0 !== t) {
            var n = (0, $b5f1e5e45355bfef$export$2e2bcd8739ae039)(t);
            return n.type = "ordinal", n;
        }
        if (void 0 !== r && 0 === e.indexOf("seq:")) {
            var i = $5c76f646ce642491$export$6638ab0298ebe095[e.slice(4)];
            if (void 0 !== i) {
                var o = (0, $1fbd210729a53e59$export$2e2bcd8739ae039)(i).domain(r.domain());
                return o.type = "sequential", o;
            }
        }
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8cb3ae215df00a00$exports)))(e)) {
        var l = (0, $b5f1e5e45355bfef$export$2e2bcd8739ae039)(e);
        return l.type = "ordinal", l;
    }
    return function() {
        return e;
    };
}, $5c76f646ce642491$export$51f2761e5fe5ca10 = (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf($5c76f646ce642491$export$6dc823b35197e3c3),
    (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string)
]), $5c76f646ce642491$export$3794d272a0540747 = {
    basis: (0, $8ac4ed992c4f3772$export$2e2bcd8739ae039),
    basisClosed: (0, $65992fe420daf471$export$2e2bcd8739ae039),
    basisOpen: (0, $61997a9b1773375f$export$2e2bcd8739ae039),
    bundle: (0, $466fdd409d5c4d5b$export$2e2bcd8739ae039),
    cardinal: (0, $emMsn.default),
    cardinalClosed: (0, $b5c4bff3ad559049$export$2e2bcd8739ae039),
    cardinalOpen: (0, $98223b13f7340e00$export$2e2bcd8739ae039),
    catmullRom: (0, $dYto6.default),
    catmullRomClosed: (0, $2c46b9fe24bf35b1$export$2e2bcd8739ae039),
    catmullRomOpen: (0, $bd0015e5fe75ddae$export$2e2bcd8739ae039),
    linear: (0, $604fd653e4bbe463$export$2e2bcd8739ae039),
    linearClosed: (0, $e5ed7244a27163f2$export$2e2bcd8739ae039),
    monotoneX: (0, $a3ea6bad8f970c89$export$99563b5420dbdc55),
    monotoneY: (0, $a3ea6bad8f970c89$export$8b5360456d6bdb88),
    natural: (0, $bcd9f70ddee99a66$export$2e2bcd8739ae039),
    step: (0, $43a583537398228e$export$2e2bcd8739ae039),
    stepAfter: (0, $43a583537398228e$export$793b3db073781cbb),
    stepBefore: (0, $43a583537398228e$export$10eafa5b7478b343)
}, $5c76f646ce642491$export$a2965cde22c100c0 = Object.keys($5c76f646ce642491$export$3794d272a0540747), $5c76f646ce642491$export$2a904d581bf09f5e = $5c76f646ce642491$export$a2965cde22c100c0.filter(function(e) {
    return e.endsWith("Closed");
}), $5c76f646ce642491$export$66e85fc6ea12b97e = (0, (/*@__PURE__*/$parcel$interopDefault($a253959d914688f0$exports)))($5c76f646ce642491$export$a2965cde22c100c0, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed"), $5c76f646ce642491$export$6d32fc0bcd3f8555 = (0, (/*@__PURE__*/$parcel$interopDefault($a253959d914688f0$exports)))($5c76f646ce642491$export$a2965cde22c100c0, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed"), $5c76f646ce642491$export$99f526a753d63ebe = function(e) {
    if (!$5c76f646ce642491$export$3794d272a0540747[e]) throw new TypeError("'" + e + "', is not a valid curve interpolator identifier.");
    return $5c76f646ce642491$export$3794d272a0540747[e];
}, $5c76f646ce642491$export$9c0ef4eef492d11d = {
    ascending: (0, $9199984cf878c516$export$2e2bcd8739ae039),
    descending: (0, $b9dea38e26768ee4$export$2e2bcd8739ae039),
    insideOut: (0, $4e05ca6e54a3159d$export$2e2bcd8739ae039),
    none: (0, $565374c5743884d0$export$2e2bcd8739ae039),
    reverse: (0, $594cb2c79d8ca59b$export$2e2bcd8739ae039)
}, $5c76f646ce642491$export$a8ec30103cd71280 = Object.keys($5c76f646ce642491$export$9c0ef4eef492d11d), $5c76f646ce642491$export$1d5443ca84f6d0f0 = function(e) {
    return $5c76f646ce642491$export$9c0ef4eef492d11d[e];
}, $5c76f646ce642491$export$ab3c04d5a3b28998 = {
    expand: (0, $e4e84889629ec4cc$export$2e2bcd8739ae039),
    diverging: (0, $9a56ce3478a08fdb$export$2e2bcd8739ae039),
    none: (0, $356453f5f6c893bd$export$2e2bcd8739ae039),
    silhouette: (0, $6e1048d5eee93fed$export$2e2bcd8739ae039),
    wiggle: (0, $b4cd4be6d0f12a30$export$2e2bcd8739ae039)
}, $5c76f646ce642491$export$31340e546ce1c184 = Object.keys($5c76f646ce642491$export$ab3c04d5a3b28998), $5c76f646ce642491$export$5c9f4d1b003c0909 = function(e) {
    return $5c76f646ce642491$export$ab3c04d5a3b28998[e];
}, $5c76f646ce642491$export$5d66dd569e74301b = (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).shape({
    top: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
    right: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
    bottom: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
    left: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number
}).isRequired, $5c76f646ce642491$export$34f44898ffea24c3 = [
    "normal",
    "multiply",
    "screen",
    "overlay",
    "darken",
    "lighten",
    "color-dodge",
    "color-burn",
    "hard-light",
    "soft-light",
    "difference",
    "exclusion",
    "hue",
    "saturation",
    "color",
    "luminosity"
], $5c76f646ce642491$export$6da2372f044c5e36 = (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf($5c76f646ce642491$export$34f44898ffea24c3), $5c76f646ce642491$export$1db72d8ab19b94d9 = function(e) {
    return (0, $exYeM.useMemo)(function() {
        return $5c76f646ce642491$export$99f526a753d63ebe(e);
    }, [
        e
    ]);
}, $5c76f646ce642491$export$2785d5ef2943fe58 = !0, $5c76f646ce642491$export$a4dcb37d1b87cf96 = $5c76f646ce642491$export$cec134b1a1fa53dd, $5c76f646ce642491$export$1570875fb8f3b023 = (0, $b5f1e5e45355bfef$export$2e2bcd8739ae039)((0, $9978eafa53379e60$export$2e2bcd8739ae039)), $5c76f646ce642491$export$6728fea658cfb92e = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
}, $5c76f646ce642491$export$d04af0e501fb729f = function(e, t, n) {
    return void 0 === n && (n = {}), (0, $exYeM.useMemo)(function() {
        var r = $5c76f646ce642491$var$jr({}, $5c76f646ce642491$export$6728fea658cfb92e, n);
        return {
            margin: r,
            innerWidth: e - r.left - r.right,
            innerHeight: t - r.top - r.bottom,
            outerWidth: e,
            outerHeight: t
        };
    }, [
        e,
        t,
        n.top,
        n.right,
        n.bottom,
        n.left
    ]);
}, $5c76f646ce642491$export$e295b0c537d32d7d = function() {
    var e = (0, $exYeM.useRef)(null), r = (0, $exYeM.useState)({
        left: 0,
        top: 0,
        width: 0,
        height: 0
    }), t = r[0], l = r[1], a = (0, $exYeM.useState)(function() {
        return "undefined" == typeof ResizeObserver ? null : new ResizeObserver(function(e) {
            var r = e[0];
            return l(r.contentRect);
        });
    })[0];
    return (0, $exYeM.useEffect)(function() {
        return e.current && null !== a && a.observe(e.current), function() {
            null !== a && a.disconnect();
        };
    }, []), [
        e,
        t
    ];
}, $5c76f646ce642491$export$7394831711fe34f = function(e) {
    return (0, $exYeM.useMemo)(function() {
        return $5c76f646ce642491$export$582fa4e2a9b13dde($5c76f646ce642491$export$164de7ab8df77ef0, e);
    }, [
        e
    ]);
}, $5c76f646ce642491$export$f037bf6aad5a4e75 = function(e) {
    return "function" == typeof e ? e : "string" == typeof e ? 0 === e.indexOf("time:") ? (0, $d5273d04d2f294a3$export$94f4d87fad5dcf9a)(e.slice("5")) : (0, $735c69117027b821$export$d9468344d3651243)(e) : function(e) {
        return "" + e;
    };
}, $5c76f646ce642491$export$422f9765e6971fdf = function(e) {
    return (0, $exYeM.useMemo)(function() {
        return $5c76f646ce642491$export$f037bf6aad5a4e75(e);
    }, [
        e
    ]);
}, $5c76f646ce642491$export$84c6f02482759c25 = (0, $exYeM.createContext)(), $5c76f646ce642491$var$Ct = {}, $5c76f646ce642491$export$d8964aec282183a3 = function(e) {
    var r = e.theme, t = void 0 === r ? $5c76f646ce642491$var$Ct : r, n = e.children, i = $5c76f646ce642491$export$7394831711fe34f(t);
    return (0, $aSiaI.jsx)($5c76f646ce642491$export$84c6f02482759c25.Provider, {
        value: i,
        children: n
    });
};
$5c76f646ce642491$export$d8964aec282183a3.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).node.isRequired,
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object
};
var $5c76f646ce642491$export$93d4e7f90805808f = function() {
    return (0, $exYeM.useContext)($5c76f646ce642491$export$84c6f02482759c25);
}, $5c76f646ce642491$var$Tt = [
    "outlineWidth",
    "outlineColor",
    "outlineOpacity"
], $5c76f646ce642491$export$c30625df7c8afdb5 = function(e) {
    return e.outlineWidth, e.outlineColor, e.outlineOpacity, $5c76f646ce642491$var$Br(e, $5c76f646ce642491$var$Tt);
}, $5c76f646ce642491$var$Pt = function(e) {
    var r = e.children, t = e.condition, n = e.wrapper;
    return t ? (0, $exYeM.cloneElement)(n, {}, r) : r;
};
$5c76f646ce642491$var$Pt.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).node.isRequired,
    condition: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool.isRequired,
    wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).element.isRequired
};
var $5c76f646ce642491$var$jt = {
    position: "relative"
}, $5c76f646ce642491$export$42a852a2b6b56249 = function(e) {
    var r = e.children, t = e.theme, i = e.renderWrapper, o = void 0 === i || i, l = e.isInteractive, a = void 0 === l || l, d = e.animate, s = e.motionConfig, u = (0, $exYeM.useRef)(null);
    return (0, $aSiaI.jsx)($5c76f646ce642491$export$d8964aec282183a3, {
        theme: t,
        children: (0, $aSiaI.jsx)($5c76f646ce642491$export$e9d875263f86dcb4, {
            animate: d,
            config: s,
            children: (0, $aSiaI.jsx)((0, $f506dcc23858008c$export$f78649fb9ca566b8), {
                container: u,
                children: (0, $aSiaI.jsxs)($5c76f646ce642491$var$Pt, {
                    condition: o,
                    wrapper: (0, $aSiaI.jsx)("div", {
                        style: $5c76f646ce642491$var$jt,
                        ref: u
                    }),
                    children: [
                        r,
                        a && (0, $aSiaI.jsx)((0, $f506dcc23858008c$export$28c660c63b792dea), {})
                    ]
                })
            })
        })
    });
};
$5c76f646ce642491$export$42a852a2b6b56249.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).element.isRequired,
    isInteractive: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    renderWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    animate: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    motionConfig: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string
};
var $5c76f646ce642491$export$8793edee2d425525 = function() {}, $5c76f646ce642491$var$Gt = {
    position: "relative"
}, $5c76f646ce642491$export$c2b4ab1564fcaab4 = function(e) {
    var t = e.children, i = e.theme, o = e.isInteractive, l = void 0 === o || o, d = e.renderWrapper, s = void 0 === d || d, u = e.animate, c = e.motionConfig, f = (0, $exYeM.useRef)(null), m = (0, $f506dcc23858008c$export$85cc26a2c4544aaa)(f), y = m.actions, v = m.state, _ = (0, $exYeM.useCallback)(function(e, r) {
        return y.showTooltipFromEvent(e, r);
    }, [
        y.showTooltipFromEvent
    ]), w = (0, $exYeM.useMemo)(function() {
        return {
            showTooltip: l ? _ : $5c76f646ce642491$export$8793edee2d425525,
            hideTooltip: l ? y.hideTooltip : $5c76f646ce642491$export$8793edee2d425525
        };
    }, [
        y.hideTooltip,
        l,
        _
    ]);
    return (0, $aSiaI.jsx)($5c76f646ce642491$export$d8964aec282183a3, {
        theme: i,
        children: (0, $aSiaI.jsx)($5c76f646ce642491$export$e9d875263f86dcb4, {
            animate: u,
            config: c,
            children: (0, $aSiaI.jsx)((0, $f506dcc23858008c$export$d344f0e974db1e2e).Provider, {
                value: y,
                children: (0, $aSiaI.jsx)((0, $f506dcc23858008c$export$c7027a64d546bf1d).Provider, {
                    value: v,
                    children: (0, $aSiaI.jsxs)($5c76f646ce642491$var$Pt, {
                        condition: s,
                        wrapper: (0, $aSiaI.jsx)("div", {
                            style: $5c76f646ce642491$var$Gt,
                            ref: f
                        }),
                        children: [
                            t(w),
                            l && (0, $aSiaI.jsx)((0, $f506dcc23858008c$export$28c660c63b792dea), {})
                        ]
                    })
                })
            })
        })
    });
};
$5c76f646ce642491$export$c2b4ab1564fcaab4.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func.isRequired,
    isInteractive: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    renderWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object.isRequired,
    animate: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool.isRequired,
    motionConfig: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string
};
var $5c76f646ce642491$export$fa6e408d6a7d6214 = function(e) {
    var r = e.children, t = $5c76f646ce642491$export$e295b0c537d32d7d(), n = t[0], i = t[1], o = i.width > 0 && i.height > 0;
    return (0, $aSiaI.jsx)("div", {
        ref: n,
        style: {
            width: "100%",
            height: "100%"
        },
        children: o && r({
            width: i.width,
            height: i.height
        })
    });
};
$5c76f646ce642491$export$fa6e408d6a7d6214.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func.isRequired
};
var $5c76f646ce642491$var$Yt = [
    "id",
    "colors"
], $5c76f646ce642491$export$39a41c7169757633 = function(e) {
    var r = e.id, t = e.colors, n = $5c76f646ce642491$var$Br(e, $5c76f646ce642491$var$Yt);
    return (0, $aSiaI.jsx)("linearGradient", $5c76f646ce642491$var$jr({
        id: r,
        x1: 0,
        x2: 0,
        y1: 0,
        y2: 1
    }, n, {
        children: t.map(function(e) {
            var r = e.offset, t = e.color, n = e.opacity;
            return (0, $aSiaI.jsx)("stop", {
                offset: r + "%",
                stopColor: t,
                stopOpacity: void 0 !== n ? n : 1
            }, r);
        })
    }));
};
$5c76f646ce642491$export$39a41c7169757633.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired,
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).shape({
        offset: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired,
        color: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired,
        opacity: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number
    })).isRequired,
    gradientTransform: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string
};
var $5c76f646ce642491$export$78f14b2164360f92 = function(e, r, t) {
    return void 0 === t && (t = {}), $5c76f646ce642491$var$jr({
        id: e,
        type: "linearGradient",
        colors: r
    }, t);
}, $5c76f646ce642491$export$a3bca081a57901da = {
    linearGradient: $5c76f646ce642491$export$39a41c7169757633
}, $5c76f646ce642491$export$10b6027261f7f537 = {
    color: "#000000",
    background: "#ffffff",
    size: 4,
    padding: 4,
    stagger: !1
}, $5c76f646ce642491$export$5e799d98c1ab7521 = (0, $exYeM.memo)(function(e) {
    var r = e.id, t = e.background, n = void 0 === t ? $5c76f646ce642491$export$10b6027261f7f537.background : t, i = e.color, o = void 0 === i ? $5c76f646ce642491$export$10b6027261f7f537.color : i, l = e.size, a = void 0 === l ? $5c76f646ce642491$export$10b6027261f7f537.size : l, d = e.padding, s = void 0 === d ? $5c76f646ce642491$export$10b6027261f7f537.padding : d, u = e.stagger, c = void 0 === u ? $5c76f646ce642491$export$10b6027261f7f537.stagger : u, f = a + s, p = a / 2, h = s / 2;
    return !0 === c && (f = 2 * a + 2 * s), (0, $aSiaI.jsxs)("pattern", {
        id: r,
        width: f,
        height: f,
        patternUnits: "userSpaceOnUse",
        children: [
            (0, $aSiaI.jsx)("rect", {
                width: f,
                height: f,
                fill: n
            }),
            (0, $aSiaI.jsx)("circle", {
                cx: h + p,
                cy: h + p,
                r: p,
                fill: o
            }),
            c && (0, $aSiaI.jsx)("circle", {
                cx: 1.5 * s + a + p,
                cy: 1.5 * s + a + p,
                r: p,
                fill: o
            })
        ]
    });
});
$5c76f646ce642491$export$5e799d98c1ab7521.displayName = "PatternDots", $5c76f646ce642491$export$5e799d98c1ab7521.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired,
    background: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired,
    padding: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired,
    stagger: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool.isRequired
};
var $5c76f646ce642491$export$27feaeda534cb3 = function(e, r) {
    return void 0 === r && (r = {}), $5c76f646ce642491$var$jr({
        id: e,
        type: "patternDots"
    }, r);
}, $5c76f646ce642491$export$6eec49b1a6289c4e = 2 * Math.PI, $5c76f646ce642491$export$c9fcf1a7df975d78 = function(e) {
    return e * Math.PI / 180;
}, $5c76f646ce642491$export$c41dd2a8460d3196 = function(e) {
    return 180 * e / Math.PI;
}, $5c76f646ce642491$export$61f3799bad189d2e = function(e) {
    return e.startAngle + (e.endAngle - e.startAngle) / 2;
}, $5c76f646ce642491$export$2e16b01652730550 = function(e, r) {
    return {
        x: Math.cos(e) * r,
        y: Math.sin(e) * r
    };
}, $5c76f646ce642491$export$c2f0a4925e526958 = function(e) {
    var r = e % 360;
    return r < 0 && (r += 360), r;
}, $5c76f646ce642491$export$c2bacc09869b390f = function(e) {
    return e - $5c76f646ce642491$export$6eec49b1a6289c4e * Math.floor((e + Math.PI) / $5c76f646ce642491$export$6eec49b1a6289c4e);
}, $5c76f646ce642491$export$e3df76cf4464bc81 = function(e) {
    return e < 0 ? 360 - -e % 360 : e % 360;
}, $5c76f646ce642491$export$a9f93668da7e35c9 = function(e, r, t) {
    void 0 === t && (t = 360);
    var n = r;
    return Math.abs(r - e) > t && (n = e + (r > e ? t : -t)), [
        e,
        n
    ];
}, $5c76f646ce642491$export$1abb91cfca1e2069 = {
    svg: {
        align: {
            left: "start",
            center: "middle",
            right: "end",
            start: "start",
            middle: "middle",
            end: "end"
        },
        baseline: {
            top: "text-before-edge",
            center: "central",
            bottom: "alphabetic"
        }
    },
    canvas: {
        align: {
            left: "left",
            center: "center",
            right: "right",
            start: "left",
            middle: "center",
            end: "right"
        },
        baseline: {
            top: "top",
            center: "middle",
            bottom: "bottom"
        }
    }
}, $5c76f646ce642491$export$60f5dce4201c524 = function(e, r, t, n) {
    void 0 === n && (n = "svg");
    var i = $5c76f646ce642491$export$1abb91cfca1e2069[n], o = $5c76f646ce642491$export$2e16b01652730550(r - Math.PI / 2, e), l = o.x, a = o.y, d = $5c76f646ce642491$export$c41dd2a8460d3196(r), s = i.align.center, u = i.baseline.bottom;
    return t > 0 ? (s = i.align.right, u = i.baseline.center) : t < 0 && (s = i.align.left, u = i.baseline.center), 0 !== t && d > 180 && (d -= 180, s = s === i.align.right ? i.align.left : i.align.right), {
        x: l,
        y: a,
        rotate: d += t,
        align: s,
        baseline: u
    };
}, $5c76f646ce642491$export$ab8a77d3b63d684d = {
    spacing: 5,
    rotation: 0,
    background: "#000000",
    color: "#ffffff",
    lineWidth: 2
}, $5c76f646ce642491$export$ace8c9d56fb83ed1 = (0, $exYeM.memo)(function(e) {
    var r = e.id, t = e.spacing, n = void 0 === t ? $5c76f646ce642491$export$ab8a77d3b63d684d.spacing : t, i = e.rotation, o = void 0 === i ? $5c76f646ce642491$export$ab8a77d3b63d684d.rotation : i, l = e.background, a = void 0 === l ? $5c76f646ce642491$export$ab8a77d3b63d684d.background : l, d = e.color, s = void 0 === d ? $5c76f646ce642491$export$ab8a77d3b63d684d.color : d, u = e.lineWidth, c = void 0 === u ? $5c76f646ce642491$export$ab8a77d3b63d684d.lineWidth : u, f = Math.round(o) % 360, p = Math.abs(n);
    f > 180 ? f -= 360 : f > 90 ? f -= 180 : f < -180 ? f += 360 : f < -90 && (f += 180);
    var h, g = p, b = p;
    return 0 === f ? h = "\n                M 0 0 L " + g + " 0\n                M 0 " + b + " L " + g + " " + b + "\n            " : 90 === f ? h = "\n                M 0 0 L 0 " + b + "\n                M " + g + " 0 L " + g + " " + b + "\n            " : (g = Math.abs(p / Math.sin($5c76f646ce642491$export$c9fcf1a7df975d78(f))), b = p / Math.sin($5c76f646ce642491$export$c9fcf1a7df975d78(90 - f)), h = f > 0 ? "\n                    M 0 " + -b + " L " + 2 * g + " " + b + "\n                    M " + -g + " " + -b + " L " + g + " " + b + "\n                    M " + -g + " 0 L " + g + " " + 2 * b + "\n                " : "\n                    M " + -g + " " + b + " L " + g + " " + -b + "\n                    M " + -g + " " + 2 * b + " L " + 2 * g + " " + -b + "\n                    M 0 " + 2 * b + " L " + 2 * g + " 0\n                "), (0, $aSiaI.jsxs)("pattern", {
        id: r,
        width: g,
        height: b,
        patternUnits: "userSpaceOnUse",
        children: [
            (0, $aSiaI.jsx)("rect", {
                width: g,
                height: b,
                fill: a,
                stroke: "rgba(255, 0, 0, 0.1)",
                strokeWidth: 0
            }),
            (0, $aSiaI.jsx)("path", {
                d: h,
                strokeWidth: c,
                stroke: s,
                strokeLinecap: "square"
            })
        ]
    });
});
$5c76f646ce642491$export$ace8c9d56fb83ed1.displayName = "PatternLines", $5c76f646ce642491$export$ace8c9d56fb83ed1.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired,
    spacing: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired,
    rotation: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired,
    background: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired,
    lineWidth: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired
};
var $5c76f646ce642491$export$5487da9d0b1282d9 = function(e, r) {
    return void 0 === r && (r = {}), $5c76f646ce642491$var$jr({
        id: e,
        type: "patternLines"
    }, r);
}, $5c76f646ce642491$export$412f5384ba9b0c31 = {
    color: "#000000",
    background: "#ffffff",
    size: 4,
    padding: 4,
    stagger: !1
}, $5c76f646ce642491$export$e9fa09500a728054 = (0, $exYeM.memo)(function(e) {
    var r = e.id, t = e.color, n = void 0 === t ? $5c76f646ce642491$export$412f5384ba9b0c31.color : t, i = e.background, o = void 0 === i ? $5c76f646ce642491$export$412f5384ba9b0c31.background : i, l = e.size, a = void 0 === l ? $5c76f646ce642491$export$412f5384ba9b0c31.size : l, d = e.padding, s = void 0 === d ? $5c76f646ce642491$export$412f5384ba9b0c31.padding : d, u = e.stagger, c = void 0 === u ? $5c76f646ce642491$export$412f5384ba9b0c31.stagger : u, f = a + s, p = s / 2;
    return !0 === c && (f = 2 * a + 2 * s), (0, $aSiaI.jsxs)("pattern", {
        id: r,
        width: f,
        height: f,
        patternUnits: "userSpaceOnUse",
        children: [
            (0, $aSiaI.jsx)("rect", {
                width: f,
                height: f,
                fill: o
            }),
            (0, $aSiaI.jsx)("rect", {
                x: p,
                y: p,
                width: a,
                height: a,
                fill: n
            }),
            c && (0, $aSiaI.jsx)("rect", {
                x: 1.5 * s + a,
                y: 1.5 * s + a,
                width: a,
                height: a,
                fill: n
            })
        ]
    });
});
$5c76f646ce642491$export$e9fa09500a728054.displayName = "PatternSquares", $5c76f646ce642491$export$e9fa09500a728054.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired,
    background: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired,
    padding: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired,
    stagger: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool.isRequired
};
var $5c76f646ce642491$export$1b1d9cb2f82cf47f = function(e, r) {
    return void 0 === r && (r = {}), $5c76f646ce642491$var$jr({
        id: e,
        type: "patternSquares"
    }, r);
}, $5c76f646ce642491$export$691ec77bd278f3b0 = {
    patternDots: $5c76f646ce642491$export$5e799d98c1ab7521,
    patternLines: $5c76f646ce642491$export$ace8c9d56fb83ed1,
    patternSquares: $5c76f646ce642491$export$e9fa09500a728054
}, $5c76f646ce642491$var$cn = [
    "type"
], $5c76f646ce642491$var$fn = $5c76f646ce642491$var$jr({}, $5c76f646ce642491$export$a3bca081a57901da, $5c76f646ce642491$export$691ec77bd278f3b0), $5c76f646ce642491$var$pn = function(e) {
    var r = e.defs;
    return !r || r.length < 1 ? null : (0, $aSiaI.jsx)("defs", {
        "aria-hidden": !0,
        children: r.map(function(e) {
            var r = e.type, t = $5c76f646ce642491$var$Br(e, $5c76f646ce642491$var$cn);
            return $5c76f646ce642491$var$fn[r] ? (0, $exYeM.createElement)($5c76f646ce642491$var$fn[r], $5c76f646ce642491$var$jr({
                key: t.id
            }, t)) : null;
        })
    });
};
$5c76f646ce642491$var$pn.propTypes = {
    defs: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).shape({
        type: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf(Object.keys($5c76f646ce642491$var$fn)).isRequired,
        id: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired
    }))
};
var $5c76f646ce642491$export$b2bdceae9588b42d = (0, $exYeM.memo)($5c76f646ce642491$var$pn), $5c76f646ce642491$export$21d9f1931ef75b56 = function(e) {
    var r = e.width, t = e.height, n = e.margin, i = e.defs, o = e.children, l = e.role, a = e.ariaLabel, d = e.ariaLabelledBy, s = e.ariaDescribedBy, u = e.isFocusable, c = $5c76f646ce642491$export$93d4e7f90805808f();
    return (0, $aSiaI.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: r,
        height: t,
        role: l,
        "aria-label": a,
        "aria-labelledby": d,
        "aria-describedby": s,
        focusable: u,
        tabIndex: u ? 0 : void 0,
        children: [
            (0, $aSiaI.jsx)($5c76f646ce642491$export$b2bdceae9588b42d, {
                defs: i
            }),
            (0, $aSiaI.jsx)("rect", {
                width: r,
                height: t,
                fill: c.background
            }),
            (0, $aSiaI.jsx)("g", {
                transform: "translate(" + n.left + "," + n.top + ")",
                children: o
            })
        ]
    });
};
$5c76f646ce642491$export$21d9f1931ef75b56.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired,
    margin: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).shape({
        top: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired,
        left: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired
    }).isRequired,
    defs: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).array,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).node),
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).node
    ]).isRequired,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    isFocusable: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).bool,
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    ariaLabelledBy: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    ariaDescribedBy: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string
};
var $5c76f646ce642491$var$bn = function(e) {
    var r = e.size, t = e.color, n = e.borderWidth, i = e.borderColor;
    return (0, $aSiaI.jsx)("circle", {
        r: r / 2,
        fill: t,
        stroke: i,
        strokeWidth: n,
        style: {
            pointerEvents: "none"
        }
    });
};
$5c76f646ce642491$var$bn.propTypes = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired,
    borderWidth: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired,
    borderColor: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired
};
var $5c76f646ce642491$var$mn = (0, $exYeM.memo)($5c76f646ce642491$var$bn), $5c76f646ce642491$var$yn = function(e) {
    var r = e.x, t = e.y, n = e.symbol, i = void 0 === n ? $5c76f646ce642491$var$mn : n, o = e.size, l = e.datum, a = e.color, d = e.borderWidth, u = e.borderColor, c = e.label, f = e.labelTextAnchor, p = void 0 === f ? "middle" : f, h = e.labelYOffset, g = void 0 === h ? -12 : h, b = $5c76f646ce642491$export$93d4e7f90805808f(), m = $5c76f646ce642491$export$72acc3dc9629d75d(), y = m.animate, v = m.config, _ = (0, $9f726edb03f4840c$export$c4af9125706c4d30)({
        transform: "translate(" + r + ", " + t + ")",
        config: v,
        immediate: !y
    });
    return (0, $aSiaI.jsxs)((0, $f9aea5876333360d$export$407448d2b89b1813).g, {
        transform: _.transform,
        style: {
            pointerEvents: "none"
        },
        children: [
            (0, $exYeM.createElement)(i, {
                size: o,
                color: a,
                datum: l,
                borderWidth: d,
                borderColor: u
            }),
            c && (0, $aSiaI.jsx)("text", {
                textAnchor: p,
                y: g,
                style: $5c76f646ce642491$export$c30625df7c8afdb5(b.dots.text),
                children: c
            })
        ]
    });
};
$5c76f646ce642491$var$yn.propTypes = {
    x: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired,
    y: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired,
    datum: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object.isRequired,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired,
    borderWidth: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired,
    borderColor: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired,
    symbol: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object
    ]),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number
    ]),
    labelTextAnchor: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "start",
        "middle",
        "end"
    ]),
    labelYOffset: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number
};
var $5c76f646ce642491$export$ca30f0ad55489a87 = (0, $exYeM.memo)($5c76f646ce642491$var$yn), $5c76f646ce642491$var$_n = function(e) {
    var r = e.width, t = e.height, n = e.axis, i = e.scale, o = e.value, l = e.lineStyle, a = e.textStyle, d = e.legend, s = e.legendPosition, u = void 0 === s ? "top-right" : s, c = e.legendOffsetX, f = void 0 === c ? 14 : c, p = e.legendOffsetY, h = void 0 === p ? 14 : p, g = e.legendOrientation, b = void 0 === g ? "horizontal" : g, m = $5c76f646ce642491$export$93d4e7f90805808f(), y = 0, v = 0, _ = 0, w = 0;
    "y" === n ? (_ = i(o), v = r) : (y = i(o), w = t);
    var k = null;
    if (d) {
        var R = function(e) {
            var r = e.axis, t = e.width, n = e.height, i = e.position, o = e.offsetX, l = e.offsetY, a = e.orientation, d = 0, s = 0, u = "vertical" === a ? -90 : 0, c = "start";
            if ("x" === r) switch(i){
                case "top-left":
                    d = -o, s = l, c = "end";
                    break;
                case "top":
                    s = -l, c = "horizontal" === a ? "middle" : "start";
                    break;
                case "top-right":
                    d = o, s = l, c = "horizontal" === a ? "start" : "end";
                    break;
                case "right":
                    d = o, s = n / 2, c = "horizontal" === a ? "start" : "middle";
                    break;
                case "bottom-right":
                    d = o, s = n - l, c = "start";
                    break;
                case "bottom":
                    s = n + l, c = "horizontal" === a ? "middle" : "end";
                    break;
                case "bottom-left":
                    s = n - l, d = -o, c = "horizontal" === a ? "end" : "start";
                    break;
                case "left":
                    d = -o, s = n / 2, c = "horizontal" === a ? "end" : "middle";
            }
            else switch(i){
                case "top-left":
                    d = o, s = -l, c = "start";
                    break;
                case "top":
                    d = t / 2, s = -l, c = "horizontal" === a ? "middle" : "start";
                    break;
                case "top-right":
                    d = t - o, s = -l, c = "horizontal" === a ? "end" : "start";
                    break;
                case "right":
                    d = t + o, c = "horizontal" === a ? "start" : "middle";
                    break;
                case "bottom-right":
                    d = t - o, s = l, c = "end";
                    break;
                case "bottom":
                    d = t / 2, s = l, c = "horizontal" === a ? "middle" : "end";
                    break;
                case "bottom-left":
                    d = o, s = l, c = "horizontal" === a ? "start" : "end";
                    break;
                case "left":
                    d = -o, c = "horizontal" === a ? "end" : "middle";
            }
            return {
                x: d,
                y: s,
                rotation: u,
                textAnchor: c
            };
        }({
            axis: n,
            width: r,
            height: t,
            position: u,
            offsetX: f,
            offsetY: h,
            orientation: b
        });
        k = (0, $aSiaI.jsx)("text", {
            transform: "translate(" + R.x + ", " + R.y + ") rotate(" + R.rotation + ")",
            textAnchor: R.textAnchor,
            dominantBaseline: "central",
            style: a,
            children: d
        });
    }
    return (0, $aSiaI.jsxs)("g", {
        transform: "translate(" + y + ", " + _ + ")",
        children: [
            (0, $aSiaI.jsx)("line", {
                x1: 0,
                x2: v,
                y1: 0,
                y2: w,
                stroke: m.markers.lineColor,
                strokeWidth: m.markers.lineStrokeWidth,
                style: l
            }),
            k
        ]
    });
};
$5c76f646ce642491$var$_n.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired,
    axis: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "x",
        "y"
    ]).isRequired,
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).instanceOf(Date)
    ]).isRequired,
    lineStyle: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    textStyle: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
    legend: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    legendPosition: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "top-left",
        "top",
        "top-right",
        "right",
        "bottom-right",
        "bottom",
        "bottom-left",
        "left"
    ]),
    legendOffsetX: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired,
    legendOffsetY: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired,
    legendOrientation: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
        "horizontal",
        "vertical"
    ]).isRequired
};
var $5c76f646ce642491$export$2b29c35b9bad49e4 = (0, $exYeM.memo)($5c76f646ce642491$var$_n), $5c76f646ce642491$var$kn = function(e) {
    var r = e.markers, t = e.width, n = e.height, i = e.xScale, o = e.yScale;
    return r && 0 !== r.length ? r.map(function(e, r) {
        return (0, $aSiaI.jsx)($5c76f646ce642491$export$2b29c35b9bad49e4, $5c76f646ce642491$var$jr({}, e, {
            width: t,
            height: n,
            scale: "y" === e.axis ? o : i
        }), r);
    }) : null;
};
$5c76f646ce642491$var$kn.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number.isRequired,
    xScale: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func.isRequired,
    yScale: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func.isRequired,
    markers: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).shape({
        axis: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOf([
            "x",
            "y"
        ]).isRequired,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).instanceOf(Date)
        ]).isRequired,
        lineStyle: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object,
        textStyle: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object
    }))
};
var $5c76f646ce642491$export$81759e11f9e58ea4 = (0, $exYeM.memo)($5c76f646ce642491$var$kn), $5c76f646ce642491$var$xn = [
    "theme",
    "renderWrapper",
    "animate",
    "motionConfig"
], $5c76f646ce642491$export$4cbbe0314aa930ae = function(e) {
    return function(r) {
        var t, n;
        function i() {
            return r.apply(this, arguments) || this;
        }
        return n = r, (t = i).prototype = Object.create(n.prototype), t.prototype.constructor = t, $5c76f646ce642491$var$Sr(t, n), i.prototype.render = function() {
            var r = this.props, t = r.theme, n = r.renderWrapper, i = r.animate, o = r.motionConfig, l = $5c76f646ce642491$var$Br(r, $5c76f646ce642491$var$xn);
            return (0, $aSiaI.jsx)($5c76f646ce642491$export$42a852a2b6b56249, {
                theme: t,
                renderWrapper: n,
                isInteractive: l.isInteractive,
                animate: i,
                motionConfig: o,
                children: (0, $aSiaI.jsx)(e, $5c76f646ce642491$var$jr({}, l))
            });
        }, i;
    }((0, $exYeM.Component));
}, $5c76f646ce642491$export$192dc59ac6f86c95 = function(e, r) {
    var t, n = (0, (/*@__PURE__*/$parcel$interopDefault($63bef038e059393f$exports)))(e) ? e : function(r) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($37f57525b6598a05$exports)))(r, e);
    };
    return r && (t = (0, (/*@__PURE__*/$parcel$interopDefault($63bef038e059393f$exports)))(r) ? r : (0, $735c69117027b821$export$d9468344d3651243)(r)), t ? function(e) {
        return t(n(e));
    } : n;
}, $5c76f646ce642491$export$3cc9373c3cf93eff = function(e) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($63bef038e059393f$exports)))(e) ? e : function(r) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($37f57525b6598a05$exports)))(r, e);
    };
}, $5c76f646ce642491$export$2d590546cbb7e3ad = function(e) {
    return (0, $exYeM.useMemo)(function() {
        return $5c76f646ce642491$export$3cc9373c3cf93eff(e);
    }, [
        e
    ]);
}, $5c76f646ce642491$export$605481d5cadc9728 = [
    "center",
    "top-left",
    "top",
    "top-right",
    "right",
    "bottom-right",
    "bottom",
    "bottom-left",
    "left"
], $5c76f646ce642491$export$d3a11e7b798643fd = function(e, r, t) {
    var n = r.width - e.width, i = r.height - e.height, o = 0, l = 0;
    return "center" === t && (o = n / 2, l = i / 2), "top" === t && (o = n / 2), "top-right" === t && (o = n), "right" === t && (o = n, l = i / 2), "bottom-right" === t && (o = n, l = i), "bottom" === t && (o = n / 2, l = i), "bottom-left" === t && (l = i), "left" === t && (l = i / 2), [
        o,
        l
    ];
}, $5c76f646ce642491$export$79376507b09a66f = function(e, r, t, n) {
    var i = t - e, o = n - r;
    return i *= i, o *= o, Math.sqrt(i + o);
}, $5c76f646ce642491$export$b363da9ded343252 = function(e, r, t, n) {
    var i = Math.atan2(n - r, t - e) - Math.PI / 2;
    return i > 0 ? i : 2 * Math.PI + i;
}, $5c76f646ce642491$export$be302859f014f482 = function(e, r, t, n, i, o) {
    return e <= i && i <= e + t && r <= o && o <= r + n;
}, $5c76f646ce642491$export$2396fb9a7906fd81 = function(e, r) {
    var t, n = "touches" in r ? r.touches[0] : r, i = n.clientX, o = n.clientY, l = e.getBoundingClientRect(), a = (t = void 0 !== e.getBBox ? e.getBBox() : {
        width: e.offsetWidth || 0,
        height: e.offsetHeight || 0
    }).width === l.width ? 1 : t.width / l.width;
    return [
        (i - l.left) * a,
        (o - l.top) * a
    ];
}, $5c76f646ce642491$var$Bn = Object.keys($5c76f646ce642491$export$a3bca081a57901da), $5c76f646ce642491$var$Gn = Object.keys($5c76f646ce642491$export$691ec77bd278f3b0), $5c76f646ce642491$export$468af463e7cc9c6f = function(e, r, t) {
    if ("*" === e) return !0;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($63bef038e059393f$exports)))(e)) return e(r);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($58f2645d8a82ddb4$exports)))(e)) {
        var n = t ? (0, (/*@__PURE__*/$parcel$interopDefault($37f57525b6598a05$exports)))(r, t) : r;
        return (0, (/*@__PURE__*/$parcel$interopDefault($cd9547e820692bcd$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($199ff7b1f42755ea$exports)))(n, Object.keys(e)), e);
    }
    return !1;
}, $5c76f646ce642491$export$dc35cf769e3afe34 = function(e, r, t, n) {
    var i = void 0 === n ? {} : n, o = i.dataKey, l = i.colorKey, a = void 0 === l ? "color" : l, d = i.targetKey, s = void 0 === d ? "fill" : d, u = [], c = {};
    return e.length && r.length && (u = [].concat(e), r.forEach(function(r) {
        for(var n = function() {
            var n = t[i], l = n.id, d = n.match;
            if ($5c76f646ce642491$export$468af463e7cc9c6f(d, r, o)) {
                var f = e.find(function(e) {
                    return e.id === l;
                });
                if (f) {
                    if ($5c76f646ce642491$var$Gn.includes(f.type)) {
                        if ("inherit" === f.background || "inherit" === f.color) {
                            var p = (0, (/*@__PURE__*/$parcel$interopDefault($37f57525b6598a05$exports)))(r, a), h = f.background, g = f.color, b = l;
                            "inherit" === f.background && (b = b + ".bg." + p, h = p), "inherit" === f.color && (b = b + ".fg." + p, g = p), (0, (/*@__PURE__*/$parcel$interopDefault($3562d0f3c7a1534b$exports)))(r, s, "url(#" + b + ")"), c[b] || (u.push($5c76f646ce642491$var$jr({}, f, {
                                id: b,
                                background: h,
                                color: g
                            })), c[b] = 1);
                        } else (0, (/*@__PURE__*/$parcel$interopDefault($3562d0f3c7a1534b$exports)))(r, s, "url(#" + l + ")");
                    } else if ($5c76f646ce642491$var$Bn.includes(f.type)) {
                        if (f.colors.map(function(e) {
                            return e.color;
                        }).includes("inherit")) {
                            var m = (0, (/*@__PURE__*/$parcel$interopDefault($37f57525b6598a05$exports)))(r, a), _ = l, w = $5c76f646ce642491$var$jr({}, f, {
                                colors: f.colors.map(function(e, r) {
                                    return "inherit" !== e.color ? e : (_ = _ + "." + r + "." + m, $5c76f646ce642491$var$jr({}, e, {
                                        color: "inherit" === e.color ? m : e.color
                                    }));
                                })
                            });
                            w.id = _, (0, (/*@__PURE__*/$parcel$interopDefault($3562d0f3c7a1534b$exports)))(r, s, "url(#" + _ + ")"), c[_] || (u.push(w), c[_] = 1);
                        } else (0, (/*@__PURE__*/$parcel$interopDefault($3562d0f3c7a1534b$exports)))(r, s, "url(#" + l + ")");
                    }
                }
                return "break";
            }
        }, i = 0; i < t.length; i++){
            if ("break" === n()) break;
        }
    })), u;
};



var $exYeM = parcelRequire("exYeM");


var $c4c88a499234a96a$var$t0 = new Date, $c4c88a499234a96a$var$t1 = new Date;
function $c4c88a499234a96a$export$2e2bcd8739ae039(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $c4c88a499234a96a$export$2e2bcd8739ae039(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $c4c88a499234a96a$var$t0.setTime(+start), $c4c88a499234a96a$var$t1.setTime(+end);
            floori($c4c88a499234a96a$var$t0), floori($c4c88a499234a96a$var$t1);
            return Math.floor(count($c4c88a499234a96a$var$t0, $c4c88a499234a96a$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}


const $23af0c38eab2917f$export$79ef0e34099623dc = 1000;
const $23af0c38eab2917f$export$683905d551c33fa9 = $23af0c38eab2917f$export$79ef0e34099623dc * 60;
const $23af0c38eab2917f$export$4157bf0c8e241659 = $23af0c38eab2917f$export$683905d551c33fa9 * 60;
const $23af0c38eab2917f$export$353686095f4fbf45 = $23af0c38eab2917f$export$4157bf0c8e241659 * 24;
const $23af0c38eab2917f$export$c241eb88520d5016 = $23af0c38eab2917f$export$353686095f4fbf45 * 7;
const $23af0c38eab2917f$export$ab95684df7020b26 = $23af0c38eab2917f$export$353686095f4fbf45 * 30;
const $23af0c38eab2917f$export$61f8ee2d834c6959 = $23af0c38eab2917f$export$353686095f4fbf45 * 365;


var $8b01d49a0f078906$var$day = (0, $c4c88a499234a96a$export$2e2bcd8739ae039)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $23af0c38eab2917f$export$683905d551c33fa9)) / (0, $23af0c38eab2917f$export$353686095f4fbf45), (date)=>date.getDate() - 1);
var $8b01d49a0f078906$export$2e2bcd8739ae039 = $8b01d49a0f078906$var$day;
var $8b01d49a0f078906$export$3cf5dda4201cc0f2 = $8b01d49a0f078906$var$day.range;



function $0d5944ea891afb23$var$weekday(i) {
    return (0, $c4c88a499234a96a$export$2e2bcd8739ae039)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $23af0c38eab2917f$export$683905d551c33fa9)) / (0, $23af0c38eab2917f$export$c241eb88520d5016);
    });
}
var $0d5944ea891afb23$export$fb3ee18ed410cc21 = $0d5944ea891afb23$var$weekday(0);
var $0d5944ea891afb23$export$6416afaab03bc9b8 = $0d5944ea891afb23$var$weekday(1);
var $0d5944ea891afb23$export$cb8f040f5d17ac7b = $0d5944ea891afb23$var$weekday(2);
var $0d5944ea891afb23$export$347581849975dfc8 = $0d5944ea891afb23$var$weekday(3);
var $0d5944ea891afb23$export$2f2b56683a3e5629 = $0d5944ea891afb23$var$weekday(4);
var $0d5944ea891afb23$export$59b8c2ccd931d806 = $0d5944ea891afb23$var$weekday(5);
var $0d5944ea891afb23$export$478ceadebff4d377 = $0d5944ea891afb23$var$weekday(6);
var $0d5944ea891afb23$export$e8daabaa40641211 = $0d5944ea891afb23$export$fb3ee18ed410cc21.range;
var $0d5944ea891afb23$export$74e5b559c235c00e = $0d5944ea891afb23$export$6416afaab03bc9b8.range;
var $0d5944ea891afb23$export$e7d6aa4fb107bc56 = $0d5944ea891afb23$export$cb8f040f5d17ac7b.range;
var $0d5944ea891afb23$export$fcd5880b20bb06a8 = $0d5944ea891afb23$export$347581849975dfc8.range;
var $0d5944ea891afb23$export$682716b7bbe33641 = $0d5944ea891afb23$export$2f2b56683a3e5629.range;
var $0d5944ea891afb23$export$482924968ca86084 = $0d5944ea891afb23$export$59b8c2ccd931d806.range;
var $0d5944ea891afb23$export$7d755172c9cda9d2 = $0d5944ea891afb23$export$478ceadebff4d377.range;


var $1c7da0bfbc30ab33$var$year = (0, $c4c88a499234a96a$export$2e2bcd8739ae039)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$1c7da0bfbc30ab33$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $c4c88a499234a96a$export$2e2bcd8739ae039)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $1c7da0bfbc30ab33$export$2e2bcd8739ae039 = $1c7da0bfbc30ab33$var$year;
var $1c7da0bfbc30ab33$export$6fda41c7fb23acf9 = $1c7da0bfbc30ab33$var$year.range;



var $73833ea189ae3476$var$utcDay = (0, $c4c88a499234a96a$export$2e2bcd8739ae039)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, $23af0c38eab2917f$export$353686095f4fbf45);
}, function(date) {
    return date.getUTCDate() - 1;
});
var $73833ea189ae3476$export$2e2bcd8739ae039 = $73833ea189ae3476$var$utcDay;
var $73833ea189ae3476$export$d277e198508549a1 = $73833ea189ae3476$var$utcDay.range;



function $fd73635ea420e678$var$utcWeekday(i) {
    return (0, $c4c88a499234a96a$export$2e2bcd8739ae039)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, $23af0c38eab2917f$export$c241eb88520d5016);
    });
}
var $fd73635ea420e678$export$4898b06303a92011 = $fd73635ea420e678$var$utcWeekday(0);
var $fd73635ea420e678$export$9cfc53b9cfafd080 = $fd73635ea420e678$var$utcWeekday(1);
var $fd73635ea420e678$export$2a6d545f77eceb15 = $fd73635ea420e678$var$utcWeekday(2);
var $fd73635ea420e678$export$a5c25d8ed64433c4 = $fd73635ea420e678$var$utcWeekday(3);
var $fd73635ea420e678$export$1db08111baec2f53 = $fd73635ea420e678$var$utcWeekday(4);
var $fd73635ea420e678$export$29265e34dd5921f7 = $fd73635ea420e678$var$utcWeekday(5);
var $fd73635ea420e678$export$85b74dad05049604 = $fd73635ea420e678$var$utcWeekday(6);
var $fd73635ea420e678$export$6f3e1c2b0f7d7880 = $fd73635ea420e678$export$4898b06303a92011.range;
var $fd73635ea420e678$export$1d2d8b858bb366f9 = $fd73635ea420e678$export$9cfc53b9cfafd080.range;
var $fd73635ea420e678$export$1d5f6785fc7f30f8 = $fd73635ea420e678$export$2a6d545f77eceb15.range;
var $fd73635ea420e678$export$7a75faf0e37ef4af = $fd73635ea420e678$export$a5c25d8ed64433c4.range;
var $fd73635ea420e678$export$417eb959611b2f2f = $fd73635ea420e678$export$1db08111baec2f53.range;
var $fd73635ea420e678$export$59d308db7af08c64 = $fd73635ea420e678$export$29265e34dd5921f7.range;
var $fd73635ea420e678$export$a124108a0a7f34c8 = $fd73635ea420e678$export$85b74dad05049604.range;


var $53a69846f427b674$var$utcYear = (0, $c4c88a499234a96a$export$2e2bcd8739ae039)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$53a69846f427b674$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $c4c88a499234a96a$export$2e2bcd8739ae039)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $53a69846f427b674$export$2e2bcd8739ae039 = $53a69846f427b674$var$utcYear;
var $53a69846f427b674$export$3e24d311e17f5802 = $53a69846f427b674$var$utcYear.range;


function $26b1af715175c115$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $26b1af715175c115$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $26b1af715175c115$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $26b1af715175c115$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $26b1af715175c115$var$formatRe(locale_periods), periodLookup = $26b1af715175c115$var$formatLookup(locale_periods), weekdayRe = $26b1af715175c115$var$formatRe(locale_weekdays), weekdayLookup = $26b1af715175c115$var$formatLookup(locale_weekdays), shortWeekdayRe = $26b1af715175c115$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $26b1af715175c115$var$formatLookup(locale_shortWeekdays), monthRe = $26b1af715175c115$var$formatRe(locale_months), monthLookup = $26b1af715175c115$var$formatLookup(locale_months), shortMonthRe = $26b1af715175c115$var$formatRe(locale_shortMonths), shortMonthLookup = $26b1af715175c115$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $26b1af715175c115$var$formatDayOfMonth,
        "e": $26b1af715175c115$var$formatDayOfMonth,
        "f": $26b1af715175c115$var$formatMicroseconds,
        "g": $26b1af715175c115$var$formatYearISO,
        "G": $26b1af715175c115$var$formatFullYearISO,
        "H": $26b1af715175c115$var$formatHour24,
        "I": $26b1af715175c115$var$formatHour12,
        "j": $26b1af715175c115$var$formatDayOfYear,
        "L": $26b1af715175c115$var$formatMilliseconds,
        "m": $26b1af715175c115$var$formatMonthNumber,
        "M": $26b1af715175c115$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $26b1af715175c115$var$formatUnixTimestamp,
        "s": $26b1af715175c115$var$formatUnixTimestampSeconds,
        "S": $26b1af715175c115$var$formatSeconds,
        "u": $26b1af715175c115$var$formatWeekdayNumberMonday,
        "U": $26b1af715175c115$var$formatWeekNumberSunday,
        "V": $26b1af715175c115$var$formatWeekNumberISO,
        "w": $26b1af715175c115$var$formatWeekdayNumberSunday,
        "W": $26b1af715175c115$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $26b1af715175c115$var$formatYear,
        "Y": $26b1af715175c115$var$formatFullYear,
        "Z": $26b1af715175c115$var$formatZone,
        "%": $26b1af715175c115$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $26b1af715175c115$var$formatUTCDayOfMonth,
        "e": $26b1af715175c115$var$formatUTCDayOfMonth,
        "f": $26b1af715175c115$var$formatUTCMicroseconds,
        "g": $26b1af715175c115$var$formatUTCYearISO,
        "G": $26b1af715175c115$var$formatUTCFullYearISO,
        "H": $26b1af715175c115$var$formatUTCHour24,
        "I": $26b1af715175c115$var$formatUTCHour12,
        "j": $26b1af715175c115$var$formatUTCDayOfYear,
        "L": $26b1af715175c115$var$formatUTCMilliseconds,
        "m": $26b1af715175c115$var$formatUTCMonthNumber,
        "M": $26b1af715175c115$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $26b1af715175c115$var$formatUnixTimestamp,
        "s": $26b1af715175c115$var$formatUnixTimestampSeconds,
        "S": $26b1af715175c115$var$formatUTCSeconds,
        "u": $26b1af715175c115$var$formatUTCWeekdayNumberMonday,
        "U": $26b1af715175c115$var$formatUTCWeekNumberSunday,
        "V": $26b1af715175c115$var$formatUTCWeekNumberISO,
        "w": $26b1af715175c115$var$formatUTCWeekdayNumberSunday,
        "W": $26b1af715175c115$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $26b1af715175c115$var$formatUTCYear,
        "Y": $26b1af715175c115$var$formatUTCFullYear,
        "Z": $26b1af715175c115$var$formatUTCZone,
        "%": $26b1af715175c115$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $26b1af715175c115$var$parseDayOfMonth,
        "e": $26b1af715175c115$var$parseDayOfMonth,
        "f": $26b1af715175c115$var$parseMicroseconds,
        "g": $26b1af715175c115$var$parseYear,
        "G": $26b1af715175c115$var$parseFullYear,
        "H": $26b1af715175c115$var$parseHour24,
        "I": $26b1af715175c115$var$parseHour24,
        "j": $26b1af715175c115$var$parseDayOfYear,
        "L": $26b1af715175c115$var$parseMilliseconds,
        "m": $26b1af715175c115$var$parseMonthNumber,
        "M": $26b1af715175c115$var$parseMinutes,
        "p": parsePeriod,
        "q": $26b1af715175c115$var$parseQuarter,
        "Q": $26b1af715175c115$var$parseUnixTimestamp,
        "s": $26b1af715175c115$var$parseUnixTimestampSeconds,
        "S": $26b1af715175c115$var$parseSeconds,
        "u": $26b1af715175c115$var$parseWeekdayNumberMonday,
        "U": $26b1af715175c115$var$parseWeekNumberSunday,
        "V": $26b1af715175c115$var$parseWeekNumberISO,
        "w": $26b1af715175c115$var$parseWeekdayNumberSunday,
        "W": $26b1af715175c115$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $26b1af715175c115$var$parseYear,
        "Y": $26b1af715175c115$var$parseFullYear,
        "Z": $26b1af715175c115$var$parseZone,
        "%": $26b1af715175c115$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $26b1af715175c115$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $26b1af715175c115$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $26b1af715175c115$var$utcDate($26b1af715175c115$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $fd73635ea420e678$export$9cfc53b9cfafd080).ceil(week) : (0, $fd73635ea420e678$export$9cfc53b9cfafd080)(week);
                    week = (0, $73833ea189ae3476$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $26b1af715175c115$var$localDate($26b1af715175c115$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $0d5944ea891afb23$export$6416afaab03bc9b8).ceil(week) : (0, $0d5944ea891afb23$export$6416afaab03bc9b8)(week);
                    week = (0, $8b01d49a0f078906$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $26b1af715175c115$var$utcDate($26b1af715175c115$var$newDate(d.y, 0, 1)).getUTCDay() : $26b1af715175c115$var$localDate($26b1af715175c115$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $26b1af715175c115$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $26b1af715175c115$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $26b1af715175c115$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $26b1af715175c115$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $26b1af715175c115$var$numberRe = /^\s*\d+/, $26b1af715175c115$var$percentRe = /^%/, $26b1af715175c115$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $26b1af715175c115$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $26b1af715175c115$var$requote(s) {
    return s.replace($26b1af715175c115$var$requoteRe, "\\$&");
}
function $26b1af715175c115$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($26b1af715175c115$var$requote).join("|") + ")", "i");
}
function $26b1af715175c115$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $26b1af715175c115$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $26b1af715175c115$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $26b1af715175c115$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $26b1af715175c115$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $26b1af715175c115$var$parseWeekNumberSunday(d, string, i) {
    var n = $26b1af715175c115$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $26b1af715175c115$var$parseWeekNumberISO(d, string, i) {
    var n = $26b1af715175c115$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $26b1af715175c115$var$parseWeekNumberMonday(d, string, i) {
    var n = $26b1af715175c115$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $26b1af715175c115$var$parseFullYear(d, string, i) {
    var n = $26b1af715175c115$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $26b1af715175c115$var$parseYear(d, string, i) {
    var n = $26b1af715175c115$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $26b1af715175c115$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $26b1af715175c115$var$parseQuarter(d, string, i) {
    var n = $26b1af715175c115$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $26b1af715175c115$var$parseMonthNumber(d, string, i) {
    var n = $26b1af715175c115$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $26b1af715175c115$var$parseDayOfMonth(d, string, i) {
    var n = $26b1af715175c115$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $26b1af715175c115$var$parseDayOfYear(d, string, i) {
    var n = $26b1af715175c115$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $26b1af715175c115$var$parseHour24(d, string, i) {
    var n = $26b1af715175c115$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $26b1af715175c115$var$parseMinutes(d, string, i) {
    var n = $26b1af715175c115$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $26b1af715175c115$var$parseSeconds(d, string, i) {
    var n = $26b1af715175c115$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $26b1af715175c115$var$parseMilliseconds(d, string, i) {
    var n = $26b1af715175c115$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $26b1af715175c115$var$parseMicroseconds(d, string, i) {
    var n = $26b1af715175c115$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $26b1af715175c115$var$parseLiteralPercent(d, string, i) {
    var n = $26b1af715175c115$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $26b1af715175c115$var$parseUnixTimestamp(d, string, i) {
    var n = $26b1af715175c115$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $26b1af715175c115$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $26b1af715175c115$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $26b1af715175c115$var$formatDayOfMonth(d, p) {
    return $26b1af715175c115$var$pad(d.getDate(), p, 2);
}
function $26b1af715175c115$var$formatHour24(d, p) {
    return $26b1af715175c115$var$pad(d.getHours(), p, 2);
}
function $26b1af715175c115$var$formatHour12(d, p) {
    return $26b1af715175c115$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $26b1af715175c115$var$formatDayOfYear(d, p) {
    return $26b1af715175c115$var$pad(1 + (0, $8b01d49a0f078906$export$2e2bcd8739ae039).count((0, $1c7da0bfbc30ab33$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $26b1af715175c115$var$formatMilliseconds(d, p) {
    return $26b1af715175c115$var$pad(d.getMilliseconds(), p, 3);
}
function $26b1af715175c115$var$formatMicroseconds(d, p) {
    return $26b1af715175c115$var$formatMilliseconds(d, p) + "000";
}
function $26b1af715175c115$var$formatMonthNumber(d, p) {
    return $26b1af715175c115$var$pad(d.getMonth() + 1, p, 2);
}
function $26b1af715175c115$var$formatMinutes(d, p) {
    return $26b1af715175c115$var$pad(d.getMinutes(), p, 2);
}
function $26b1af715175c115$var$formatSeconds(d, p) {
    return $26b1af715175c115$var$pad(d.getSeconds(), p, 2);
}
function $26b1af715175c115$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $26b1af715175c115$var$formatWeekNumberSunday(d, p) {
    return $26b1af715175c115$var$pad((0, $0d5944ea891afb23$export$fb3ee18ed410cc21).count((0, $1c7da0bfbc30ab33$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $26b1af715175c115$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $0d5944ea891afb23$export$2f2b56683a3e5629)(d) : (0, $0d5944ea891afb23$export$2f2b56683a3e5629).ceil(d);
}
function $26b1af715175c115$var$formatWeekNumberISO(d, p) {
    d = $26b1af715175c115$var$dISO(d);
    return $26b1af715175c115$var$pad((0, $0d5944ea891afb23$export$2f2b56683a3e5629).count((0, $1c7da0bfbc30ab33$export$2e2bcd8739ae039)(d), d) + ((0, $1c7da0bfbc30ab33$export$2e2bcd8739ae039)(d).getDay() === 4), p, 2);
}
function $26b1af715175c115$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $26b1af715175c115$var$formatWeekNumberMonday(d, p) {
    return $26b1af715175c115$var$pad((0, $0d5944ea891afb23$export$6416afaab03bc9b8).count((0, $1c7da0bfbc30ab33$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $26b1af715175c115$var$formatYear(d, p) {
    return $26b1af715175c115$var$pad(d.getFullYear() % 100, p, 2);
}
function $26b1af715175c115$var$formatYearISO(d, p) {
    d = $26b1af715175c115$var$dISO(d);
    return $26b1af715175c115$var$pad(d.getFullYear() % 100, p, 2);
}
function $26b1af715175c115$var$formatFullYear(d, p) {
    return $26b1af715175c115$var$pad(d.getFullYear() % 10000, p, 4);
}
function $26b1af715175c115$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $0d5944ea891afb23$export$2f2b56683a3e5629)(d) : (0, $0d5944ea891afb23$export$2f2b56683a3e5629).ceil(d);
    return $26b1af715175c115$var$pad(d.getFullYear() % 10000, p, 4);
}
function $26b1af715175c115$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $26b1af715175c115$var$pad(z / 60 | 0, "0", 2) + $26b1af715175c115$var$pad(z % 60, "0", 2);
}
function $26b1af715175c115$var$formatUTCDayOfMonth(d, p) {
    return $26b1af715175c115$var$pad(d.getUTCDate(), p, 2);
}
function $26b1af715175c115$var$formatUTCHour24(d, p) {
    return $26b1af715175c115$var$pad(d.getUTCHours(), p, 2);
}
function $26b1af715175c115$var$formatUTCHour12(d, p) {
    return $26b1af715175c115$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $26b1af715175c115$var$formatUTCDayOfYear(d, p) {
    return $26b1af715175c115$var$pad(1 + (0, $73833ea189ae3476$export$2e2bcd8739ae039).count((0, $53a69846f427b674$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $26b1af715175c115$var$formatUTCMilliseconds(d, p) {
    return $26b1af715175c115$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $26b1af715175c115$var$formatUTCMicroseconds(d, p) {
    return $26b1af715175c115$var$formatUTCMilliseconds(d, p) + "000";
}
function $26b1af715175c115$var$formatUTCMonthNumber(d, p) {
    return $26b1af715175c115$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $26b1af715175c115$var$formatUTCMinutes(d, p) {
    return $26b1af715175c115$var$pad(d.getUTCMinutes(), p, 2);
}
function $26b1af715175c115$var$formatUTCSeconds(d, p) {
    return $26b1af715175c115$var$pad(d.getUTCSeconds(), p, 2);
}
function $26b1af715175c115$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $26b1af715175c115$var$formatUTCWeekNumberSunday(d, p) {
    return $26b1af715175c115$var$pad((0, $fd73635ea420e678$export$4898b06303a92011).count((0, $53a69846f427b674$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $26b1af715175c115$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $fd73635ea420e678$export$1db08111baec2f53)(d) : (0, $fd73635ea420e678$export$1db08111baec2f53).ceil(d);
}
function $26b1af715175c115$var$formatUTCWeekNumberISO(d, p) {
    d = $26b1af715175c115$var$UTCdISO(d);
    return $26b1af715175c115$var$pad((0, $fd73635ea420e678$export$1db08111baec2f53).count((0, $53a69846f427b674$export$2e2bcd8739ae039)(d), d) + ((0, $53a69846f427b674$export$2e2bcd8739ae039)(d).getUTCDay() === 4), p, 2);
}
function $26b1af715175c115$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $26b1af715175c115$var$formatUTCWeekNumberMonday(d, p) {
    return $26b1af715175c115$var$pad((0, $fd73635ea420e678$export$9cfc53b9cfafd080).count((0, $53a69846f427b674$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $26b1af715175c115$var$formatUTCYear(d, p) {
    return $26b1af715175c115$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $26b1af715175c115$var$formatUTCYearISO(d, p) {
    d = $26b1af715175c115$var$UTCdISO(d);
    return $26b1af715175c115$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $26b1af715175c115$var$formatUTCFullYear(d, p) {
    return $26b1af715175c115$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $26b1af715175c115$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $fd73635ea420e678$export$1db08111baec2f53)(d) : (0, $fd73635ea420e678$export$1db08111baec2f53).ceil(d);
    return $26b1af715175c115$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $26b1af715175c115$var$formatUTCZone() {
    return "+0000";
}
function $26b1af715175c115$var$formatLiteralPercent() {
    return "%";
}
function $26b1af715175c115$var$formatUnixTimestamp(d) {
    return +d;
}
function $26b1af715175c115$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $5fd29e3c907fe830$var$locale;
var $5fd29e3c907fe830$export$94f4d87fad5dcf9a;
var $5fd29e3c907fe830$export$32b9cd16e1b8c8d2;
var $5fd29e3c907fe830$export$1a08fe38f63ebbbb;
var $5fd29e3c907fe830$export$3edae9cf8e233729;
$5fd29e3c907fe830$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $5fd29e3c907fe830$export$2e2bcd8739ae039(definition) {
    $5fd29e3c907fe830$var$locale = (0, $26b1af715175c115$export$2e2bcd8739ae039)(definition);
    $5fd29e3c907fe830$export$94f4d87fad5dcf9a = $5fd29e3c907fe830$var$locale.format;
    $5fd29e3c907fe830$export$32b9cd16e1b8c8d2 = $5fd29e3c907fe830$var$locale.parse;
    $5fd29e3c907fe830$export$1a08fe38f63ebbbb = $5fd29e3c907fe830$var$locale.utcFormat;
    $5fd29e3c907fe830$export$3edae9cf8e233729 = $5fd29e3c907fe830$var$locale.utcParse;
    return $5fd29e3c907fe830$var$locale;
}


function $bf4780286b14417c$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $bf4780286b14417c$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}


function $2bc1fb25850d3edc$export$2e2bcd8739ae039(x) {
    return x = (0, $bf4780286b14417c$export$8f8e23dd27dc19f5)(Math.abs(x)), x ? x[1] : NaN;
}


function $450aa7135aa724c3$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}


function $d642aa278dd1e019$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}


// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $f9413e8c5d9aabb6$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $f9413e8c5d9aabb6$export$2e2bcd8739ae039(specifier) {
    if (!(match = $f9413e8c5d9aabb6$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $f9413e8c5d9aabb6$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$f9413e8c5d9aabb6$export$2e2bcd8739ae039.prototype = $f9413e8c5d9aabb6$export$963aac351db36ed4.prototype; // instanceof
function $f9413e8c5d9aabb6$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$f9413e8c5d9aabb6$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};


// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $6b547f7820ab9a12$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}




var $9939bd388be3946f$export$6863724d9a42263;
function $9939bd388be3946f$export$2e2bcd8739ae039(x, p) {
    var d = (0, $bf4780286b14417c$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($9939bd388be3946f$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $bf4780286b14417c$export$8f8e23dd27dc19f5)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}



function $4cdf5531349a4076$export$2e2bcd8739ae039(x, p) {
    var d = (0, $bf4780286b14417c$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}


var $78414df2a9ba8520$export$2e2bcd8739ae039 = {
    "%": function(x, p) {
        return (x * 100).toFixed(p);
    },
    "b": function(x) {
        return Math.round(x).toString(2);
    },
    "c": function(x) {
        return x + "";
    },
    "d": (0, $bf4780286b14417c$export$2e2bcd8739ae039),
    "e": function(x, p) {
        return x.toExponential(p);
    },
    "f": function(x, p) {
        return x.toFixed(p);
    },
    "g": function(x, p) {
        return x.toPrecision(p);
    },
    "o": function(x) {
        return Math.round(x).toString(8);
    },
    "p": function(x, p) {
        return (0, $4cdf5531349a4076$export$2e2bcd8739ae039)(x * 100, p);
    },
    "r": (0, $4cdf5531349a4076$export$2e2bcd8739ae039),
    "s": (0, $9939bd388be3946f$export$2e2bcd8739ae039),
    "X": function(x) {
        return Math.round(x).toString(16).toUpperCase();
    },
    "x": function(x) {
        return Math.round(x).toString(16);
    }
};



function $2d5d0aa7033972a4$export$2e2bcd8739ae039(x) {
    return x;
}


var $aa71c1447bd2e97f$var$map = Array.prototype.map, $aa71c1447bd2e97f$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $aa71c1447bd2e97f$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $2d5d0aa7033972a4$export$2e2bcd8739ae039) : (0, $450aa7135aa724c3$export$2e2bcd8739ae039)($aa71c1447bd2e97f$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $2d5d0aa7033972a4$export$2e2bcd8739ae039) : (0, $d642aa278dd1e019$export$2e2bcd8739ae039)($aa71c1447bd2e97f$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "-" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $f9413e8c5d9aabb6$export$2e2bcd8739ae039)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $78414df2a9ba8520$export$2e2bcd8739ae039)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $78414df2a9ba8520$export$2e2bcd8739ae039)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $6b547f7820ab9a12$export$2e2bcd8739ae039)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $aa71c1447bd2e97f$var$prefixes[8 + (0, $9939bd388be3946f$export$6863724d9a42263) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $f9413e8c5d9aabb6$export$2e2bcd8739ae039)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $2bc1fb25850d3edc$export$2e2bcd8739ae039)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $aa71c1447bd2e97f$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}


var $aab7a294d70d2095$var$locale;
var $aab7a294d70d2095$export$d9468344d3651243;
var $aab7a294d70d2095$export$8d85692a469dde6f;
$aab7a294d70d2095$export$2e2bcd8739ae039({
    decimal: ".",
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ],
    minus: "-"
});
function $aab7a294d70d2095$export$2e2bcd8739ae039(definition) {
    $aab7a294d70d2095$var$locale = (0, $aa71c1447bd2e97f$export$2e2bcd8739ae039)(definition);
    $aab7a294d70d2095$export$d9468344d3651243 = $aab7a294d70d2095$var$locale.format;
    $aab7a294d70d2095$export$8d85692a469dde6f = $aab7a294d70d2095$var$locale.formatPrefix;
    return $aab7a294d70d2095$var$locale;
}


var $cacf893e18dd1b21$exports = {};
var $8ce90ffd4f947785$exports = {};




var $509fe6d4458f6ca1$exports = {};

var $ac2e64c1aea751cb$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $ac2e64c1aea751cb$var$noop() {
// No operation performed.
}
$ac2e64c1aea751cb$exports = $ac2e64c1aea751cb$var$noop;



/** Used as references for various `Number` constants. */ var $509fe6d4458f6ca1$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $509fe6d4458f6ca1$var$createSet = !($1a2f39184944fa46$exports && 1 / $eee7f5e5109334c4$exports(new $1a2f39184944fa46$exports([
    ,
    -0
]))[1] == $509fe6d4458f6ca1$var$INFINITY) ? $ac2e64c1aea751cb$exports : function(values) {
    return new $1a2f39184944fa46$exports(values);
};
$509fe6d4458f6ca1$exports = $509fe6d4458f6ca1$var$createSet;



/** Used as the size to enable large array optimizations. */ var $8ce90ffd4f947785$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $8ce90ffd4f947785$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $5dded6cf8f2bedb3$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $4c1a89b755dfa22b$exports;
    } else if (length >= $8ce90ffd4f947785$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $509fe6d4458f6ca1$exports(array);
        if (set) return $eee7f5e5109334c4$exports(set);
        isCommon = false;
        includes = $c0081f1c22a5c7b6$exports;
        seen = new $32da07863e46acec$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$8ce90ffd4f947785$exports = $8ce90ffd4f947785$var$baseUniq;


/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $cacf893e18dd1b21$var$uniq(array) {
    return array && array.length ? $8ce90ffd4f947785$exports(array) : [];
}
$cacf893e18dd1b21$exports = $cacf893e18dd1b21$var$uniq;


var $0461ecd8a7b18161$exports = {};
var $52849359d0c345c9$exports = {};
var $1a6ab9420533a54c$exports = {};
var $85df9b6b26a2a3d6$exports = {};


/** Used to compose bitmasks for value comparisons. */ var $85df9b6b26a2a3d6$var$COMPARE_PARTIAL_FLAG = 1, $85df9b6b26a2a3d6$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $85df9b6b26a2a3d6$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $8bfbce7e35b86105$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $6219f680e6e19178$exports(srcValue, objValue, $85df9b6b26a2a3d6$var$COMPARE_PARTIAL_FLAG | $85df9b6b26a2a3d6$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$85df9b6b26a2a3d6$exports = $85df9b6b26a2a3d6$var$baseIsMatch;


var $9d7de89299ad2e3c$exports = {};
var $fdfd165136cf00fc$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $fdfd165136cf00fc$var$isStrictComparable(value) {
    return value === value && !$db5dfd0661742a1a$exports(value);
}
$fdfd165136cf00fc$exports = $fdfd165136cf00fc$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $9d7de89299ad2e3c$var$getMatchData(object) {
    var result = $b104760b34d6b7b1$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $fdfd165136cf00fc$exports(value)
        ];
    }
    return result;
}
$9d7de89299ad2e3c$exports = $9d7de89299ad2e3c$var$getMatchData;


var $84046984492b1213$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $84046984492b1213$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$84046984492b1213$exports = $84046984492b1213$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $1a6ab9420533a54c$var$baseMatches(source) {
    var matchData = $9d7de89299ad2e3c$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $84046984492b1213$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $85df9b6b26a2a3d6$exports(object, source, matchData);
    };
}
$1a6ab9420533a54c$exports = $1a6ab9420533a54c$var$baseMatches;


var $f70cedfd69c2edab$exports = {};







/** Used to compose bitmasks for value comparisons. */ var $f70cedfd69c2edab$var$COMPARE_PARTIAL_FLAG = 1, $f70cedfd69c2edab$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $f70cedfd69c2edab$var$baseMatchesProperty(path, srcValue) {
    if ($ebf30b1c72800438$exports(path) && $fdfd165136cf00fc$exports(srcValue)) return $84046984492b1213$exports($e56d6cac75d4b6e0$exports(path), srcValue);
    return function(object) {
        var objValue = $37f57525b6598a05$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $ef091009ae184c05$exports(object, path) : $6219f680e6e19178$exports(srcValue, objValue, $f70cedfd69c2edab$var$COMPARE_PARTIAL_FLAG | $f70cedfd69c2edab$var$COMPARE_UNORDERED_FLAG);
    };
}
$f70cedfd69c2edab$exports = $f70cedfd69c2edab$var$baseMatchesProperty;




var $3931b06dee0ed94b$exports = {};
var $805c81fb4b9151f2$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $805c81fb4b9151f2$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$805c81fb4b9151f2$exports = $805c81fb4b9151f2$var$baseProperty;


var $93a5b3a3d4a8ecc6$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $93a5b3a3d4a8ecc6$var$basePropertyDeep(path) {
    return function(object) {
        return $01f8d472cea3b7ad$exports(object, path);
    };
}
$93a5b3a3d4a8ecc6$exports = $93a5b3a3d4a8ecc6$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $3931b06dee0ed94b$var$property(path) {
    return $ebf30b1c72800438$exports(path) ? $805c81fb4b9151f2$exports($e56d6cac75d4b6e0$exports(path)) : $93a5b3a3d4a8ecc6$exports(path);
}
$3931b06dee0ed94b$exports = $3931b06dee0ed94b$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $52849359d0c345c9$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $836ffceb73715ab3$exports;
    if (typeof value == "object") return $8cb3ae215df00a00$exports(value) ? $f70cedfd69c2edab$exports(value[0], value[1]) : $1a6ab9420533a54c$exports(value);
    return $3931b06dee0ed94b$exports(value);
}
$52849359d0c345c9$exports = $52849359d0c345c9$var$baseIteratee;



/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $0461ecd8a7b18161$var$uniqBy(array, iteratee) {
    return array && array.length ? $8ce90ffd4f947785$exports(array, $52849359d0c345c9$exports(iteratee, 2)) : [];
}
$0461ecd8a7b18161$exports = $0461ecd8a7b18161$var$uniqBy;


var $0dbc7cb2f4eca1aa$exports = {};

var $13d944a66d55fe17$exports = {};



var $20f6957cb6a19f51$exports = {};
var $eb9d77a605684a7d$exports = {};
var $c40d9c5aec6b4ec6$exports = {};


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $c40d9c5aec6b4ec6$var$baseForOwn(object, iteratee) {
    return object && $964779a63aa00972$exports(object, iteratee, $b104760b34d6b7b1$exports);
}
$c40d9c5aec6b4ec6$exports = $c40d9c5aec6b4ec6$var$baseForOwn;


var $c808fa36ed14e2e9$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $c808fa36ed14e2e9$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$887f7dd95a2dee62$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$c808fa36ed14e2e9$exports = $c808fa36ed14e2e9$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $eb9d77a605684a7d$var$baseEach = $c808fa36ed14e2e9$exports($c40d9c5aec6b4ec6$exports);
$eb9d77a605684a7d$exports = $eb9d77a605684a7d$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $20f6957cb6a19f51$var$baseMap(collection, iteratee) {
    var index = -1, result = $887f7dd95a2dee62$exports(collection) ? Array(collection.length) : [];
    $eb9d77a605684a7d$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$20f6957cb6a19f51$exports = $20f6957cb6a19f51$var$baseMap;


var $5a1c7c51fd3f8647$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $5a1c7c51fd3f8647$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$5a1c7c51fd3f8647$exports = $5a1c7c51fd3f8647$var$baseSortBy;



var $b11ced764ad76bcc$exports = {};
var $7d39698013edfeb5$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $7d39698013edfeb5$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $b7350b23d035986b$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $b7350b23d035986b$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$7d39698013edfeb5$exports = $7d39698013edfeb5$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $b11ced764ad76bcc$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $7d39698013edfeb5$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$b11ced764ad76bcc$exports = $b11ced764ad76bcc$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $13d944a66d55fe17$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $c0d7b47ee8b12bf1$exports(iteratees, function(iteratee) {
        if ($8cb3ae215df00a00$exports(iteratee)) return function(value) {
            return $01f8d472cea3b7ad$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $836ffceb73715ab3$exports
    ];
    var index = -1;
    iteratees = $c0d7b47ee8b12bf1$exports(iteratees, $a37b20fb7156577b$exports($52849359d0c345c9$exports));
    var result = $20f6957cb6a19f51$exports(collection, function(value, key, collection) {
        var criteria = $c0d7b47ee8b12bf1$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            "criteria": criteria,
            "index": ++index,
            "value": value
        };
    });
    return $5a1c7c51fd3f8647$exports(result, function(object, other) {
        return $b11ced764ad76bcc$exports(object, other, orders);
    });
}
$13d944a66d55fe17$exports = $13d944a66d55fe17$var$baseOrderBy;




/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $0dbc7cb2f4eca1aa$var$sortBy = $0eac8e78ce21f81f$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $f8ab7f41928d2285$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $f8ab7f41928d2285$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $13d944a66d55fe17$exports(collection, $8ed4fb10b1b0390d$exports(iteratees, 1), []);
});
$0dbc7cb2f4eca1aa$exports = $0dbc7cb2f4eca1aa$var$sortBy;



var $140a48eb88266f4f$exports = {};
var $47e4bcf82de5b1b1$exports = {};


/** `Object#toString` result references. */ var $47e4bcf82de5b1b1$var$dateTag = "[object Date]";
/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */ function $47e4bcf82de5b1b1$var$baseIsDate(value) {
    return $5475ba594a8bdf91$exports(value) && $852d1f971b259156$exports(value) == $47e4bcf82de5b1b1$var$dateTag;
}
$47e4bcf82de5b1b1$exports = $47e4bcf82de5b1b1$var$baseIsDate;




var $7vc1R = parcelRequire("7vc1R");
/* Node.js helper references. */ var $140a48eb88266f4f$var$nodeIsDate = $7vc1R && $7vc1R.isDate;
/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */ var $140a48eb88266f4f$var$isDate = $140a48eb88266f4f$var$nodeIsDate ? $a37b20fb7156577b$exports($140a48eb88266f4f$var$nodeIsDate) : $47e4bcf82de5b1b1$exports;
$140a48eb88266f4f$exports = $140a48eb88266f4f$var$isDate;


var $ae993b74de2d70b3$var$t0 = new Date, $ae993b74de2d70b3$var$t1 = new Date;
function $ae993b74de2d70b3$export$2e2bcd8739ae039(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $ae993b74de2d70b3$export$2e2bcd8739ae039(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $ae993b74de2d70b3$var$t0.setTime(+start), $ae993b74de2d70b3$var$t1.setTime(+end);
            floori($ae993b74de2d70b3$var$t0), floori($ae993b74de2d70b3$var$t1);
            return Math.floor(count($ae993b74de2d70b3$var$t0, $ae993b74de2d70b3$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}


var $a3e4e2040f036adf$export$79ef0e34099623dc = 1e3;
var $a3e4e2040f036adf$export$683905d551c33fa9 = 6e4;
var $a3e4e2040f036adf$export$4157bf0c8e241659 = 36e5;
var $a3e4e2040f036adf$export$353686095f4fbf45 = 864e5;
var $a3e4e2040f036adf$export$c241eb88520d5016 = 6048e5;


var $e9995e8cb68fab98$var$day = (0, $ae993b74de2d70b3$export$2e2bcd8739ae039)(function(date) {
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setDate(date.getDate() + step);
}, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $a3e4e2040f036adf$export$683905d551c33fa9)) / (0, $a3e4e2040f036adf$export$353686095f4fbf45);
}, function(date) {
    return date.getDate() - 1;
});
var $e9995e8cb68fab98$export$2e2bcd8739ae039 = $e9995e8cb68fab98$var$day;
var $e9995e8cb68fab98$export$3cf5dda4201cc0f2 = $e9995e8cb68fab98$var$day.range;



function $bdbb4ef11b8c6229$var$weekday(i) {
    return (0, $ae993b74de2d70b3$export$2e2bcd8739ae039)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $a3e4e2040f036adf$export$683905d551c33fa9)) / (0, $a3e4e2040f036adf$export$c241eb88520d5016);
    });
}
var $bdbb4ef11b8c6229$export$fb3ee18ed410cc21 = $bdbb4ef11b8c6229$var$weekday(0);
var $bdbb4ef11b8c6229$export$6416afaab03bc9b8 = $bdbb4ef11b8c6229$var$weekday(1);
var $bdbb4ef11b8c6229$export$cb8f040f5d17ac7b = $bdbb4ef11b8c6229$var$weekday(2);
var $bdbb4ef11b8c6229$export$347581849975dfc8 = $bdbb4ef11b8c6229$var$weekday(3);
var $bdbb4ef11b8c6229$export$2f2b56683a3e5629 = $bdbb4ef11b8c6229$var$weekday(4);
var $bdbb4ef11b8c6229$export$59b8c2ccd931d806 = $bdbb4ef11b8c6229$var$weekday(5);
var $bdbb4ef11b8c6229$export$478ceadebff4d377 = $bdbb4ef11b8c6229$var$weekday(6);
var $bdbb4ef11b8c6229$export$e8daabaa40641211 = $bdbb4ef11b8c6229$export$fb3ee18ed410cc21.range;
var $bdbb4ef11b8c6229$export$74e5b559c235c00e = $bdbb4ef11b8c6229$export$6416afaab03bc9b8.range;
var $bdbb4ef11b8c6229$export$e7d6aa4fb107bc56 = $bdbb4ef11b8c6229$export$cb8f040f5d17ac7b.range;
var $bdbb4ef11b8c6229$export$fcd5880b20bb06a8 = $bdbb4ef11b8c6229$export$347581849975dfc8.range;
var $bdbb4ef11b8c6229$export$682716b7bbe33641 = $bdbb4ef11b8c6229$export$2f2b56683a3e5629.range;
var $bdbb4ef11b8c6229$export$482924968ca86084 = $bdbb4ef11b8c6229$export$59b8c2ccd931d806.range;
var $bdbb4ef11b8c6229$export$7d755172c9cda9d2 = $bdbb4ef11b8c6229$export$478ceadebff4d377.range;


var $3090dbe4840e9497$var$year = (0, $ae993b74de2d70b3$export$2e2bcd8739ae039)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$3090dbe4840e9497$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $ae993b74de2d70b3$export$2e2bcd8739ae039)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $3090dbe4840e9497$export$2e2bcd8739ae039 = $3090dbe4840e9497$var$year;
var $3090dbe4840e9497$export$6fda41c7fb23acf9 = $3090dbe4840e9497$var$year.range;



var $df99fa2fb24eed54$var$utcDay = (0, $ae993b74de2d70b3$export$2e2bcd8739ae039)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, $a3e4e2040f036adf$export$353686095f4fbf45);
}, function(date) {
    return date.getUTCDate() - 1;
});
var $df99fa2fb24eed54$export$2e2bcd8739ae039 = $df99fa2fb24eed54$var$utcDay;
var $df99fa2fb24eed54$export$d277e198508549a1 = $df99fa2fb24eed54$var$utcDay.range;



function $30a54a0cc468acfe$var$utcWeekday(i) {
    return (0, $ae993b74de2d70b3$export$2e2bcd8739ae039)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, $a3e4e2040f036adf$export$c241eb88520d5016);
    });
}
var $30a54a0cc468acfe$export$4898b06303a92011 = $30a54a0cc468acfe$var$utcWeekday(0);
var $30a54a0cc468acfe$export$9cfc53b9cfafd080 = $30a54a0cc468acfe$var$utcWeekday(1);
var $30a54a0cc468acfe$export$2a6d545f77eceb15 = $30a54a0cc468acfe$var$utcWeekday(2);
var $30a54a0cc468acfe$export$a5c25d8ed64433c4 = $30a54a0cc468acfe$var$utcWeekday(3);
var $30a54a0cc468acfe$export$1db08111baec2f53 = $30a54a0cc468acfe$var$utcWeekday(4);
var $30a54a0cc468acfe$export$29265e34dd5921f7 = $30a54a0cc468acfe$var$utcWeekday(5);
var $30a54a0cc468acfe$export$85b74dad05049604 = $30a54a0cc468acfe$var$utcWeekday(6);
var $30a54a0cc468acfe$export$6f3e1c2b0f7d7880 = $30a54a0cc468acfe$export$4898b06303a92011.range;
var $30a54a0cc468acfe$export$1d2d8b858bb366f9 = $30a54a0cc468acfe$export$9cfc53b9cfafd080.range;
var $30a54a0cc468acfe$export$1d5f6785fc7f30f8 = $30a54a0cc468acfe$export$2a6d545f77eceb15.range;
var $30a54a0cc468acfe$export$7a75faf0e37ef4af = $30a54a0cc468acfe$export$a5c25d8ed64433c4.range;
var $30a54a0cc468acfe$export$417eb959611b2f2f = $30a54a0cc468acfe$export$1db08111baec2f53.range;
var $30a54a0cc468acfe$export$59d308db7af08c64 = $30a54a0cc468acfe$export$29265e34dd5921f7.range;
var $30a54a0cc468acfe$export$a124108a0a7f34c8 = $30a54a0cc468acfe$export$85b74dad05049604.range;


var $02e9f616a31e1208$var$utcYear = (0, $ae993b74de2d70b3$export$2e2bcd8739ae039)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$02e9f616a31e1208$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $ae993b74de2d70b3$export$2e2bcd8739ae039)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $02e9f616a31e1208$export$2e2bcd8739ae039 = $02e9f616a31e1208$var$utcYear;
var $02e9f616a31e1208$export$3e24d311e17f5802 = $02e9f616a31e1208$var$utcYear.range;


function $7a55603832248c4b$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $7a55603832248c4b$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $7a55603832248c4b$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $7a55603832248c4b$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $7a55603832248c4b$var$formatRe(locale_periods), periodLookup = $7a55603832248c4b$var$formatLookup(locale_periods), weekdayRe = $7a55603832248c4b$var$formatRe(locale_weekdays), weekdayLookup = $7a55603832248c4b$var$formatLookup(locale_weekdays), shortWeekdayRe = $7a55603832248c4b$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $7a55603832248c4b$var$formatLookup(locale_shortWeekdays), monthRe = $7a55603832248c4b$var$formatRe(locale_months), monthLookup = $7a55603832248c4b$var$formatLookup(locale_months), shortMonthRe = $7a55603832248c4b$var$formatRe(locale_shortMonths), shortMonthLookup = $7a55603832248c4b$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $7a55603832248c4b$var$formatDayOfMonth,
        "e": $7a55603832248c4b$var$formatDayOfMonth,
        "f": $7a55603832248c4b$var$formatMicroseconds,
        "g": $7a55603832248c4b$var$formatYearISO,
        "G": $7a55603832248c4b$var$formatFullYearISO,
        "H": $7a55603832248c4b$var$formatHour24,
        "I": $7a55603832248c4b$var$formatHour12,
        "j": $7a55603832248c4b$var$formatDayOfYear,
        "L": $7a55603832248c4b$var$formatMilliseconds,
        "m": $7a55603832248c4b$var$formatMonthNumber,
        "M": $7a55603832248c4b$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $7a55603832248c4b$var$formatUnixTimestamp,
        "s": $7a55603832248c4b$var$formatUnixTimestampSeconds,
        "S": $7a55603832248c4b$var$formatSeconds,
        "u": $7a55603832248c4b$var$formatWeekdayNumberMonday,
        "U": $7a55603832248c4b$var$formatWeekNumberSunday,
        "V": $7a55603832248c4b$var$formatWeekNumberISO,
        "w": $7a55603832248c4b$var$formatWeekdayNumberSunday,
        "W": $7a55603832248c4b$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $7a55603832248c4b$var$formatYear,
        "Y": $7a55603832248c4b$var$formatFullYear,
        "Z": $7a55603832248c4b$var$formatZone,
        "%": $7a55603832248c4b$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $7a55603832248c4b$var$formatUTCDayOfMonth,
        "e": $7a55603832248c4b$var$formatUTCDayOfMonth,
        "f": $7a55603832248c4b$var$formatUTCMicroseconds,
        "g": $7a55603832248c4b$var$formatUTCYearISO,
        "G": $7a55603832248c4b$var$formatUTCFullYearISO,
        "H": $7a55603832248c4b$var$formatUTCHour24,
        "I": $7a55603832248c4b$var$formatUTCHour12,
        "j": $7a55603832248c4b$var$formatUTCDayOfYear,
        "L": $7a55603832248c4b$var$formatUTCMilliseconds,
        "m": $7a55603832248c4b$var$formatUTCMonthNumber,
        "M": $7a55603832248c4b$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $7a55603832248c4b$var$formatUnixTimestamp,
        "s": $7a55603832248c4b$var$formatUnixTimestampSeconds,
        "S": $7a55603832248c4b$var$formatUTCSeconds,
        "u": $7a55603832248c4b$var$formatUTCWeekdayNumberMonday,
        "U": $7a55603832248c4b$var$formatUTCWeekNumberSunday,
        "V": $7a55603832248c4b$var$formatUTCWeekNumberISO,
        "w": $7a55603832248c4b$var$formatUTCWeekdayNumberSunday,
        "W": $7a55603832248c4b$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $7a55603832248c4b$var$formatUTCYear,
        "Y": $7a55603832248c4b$var$formatUTCFullYear,
        "Z": $7a55603832248c4b$var$formatUTCZone,
        "%": $7a55603832248c4b$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $7a55603832248c4b$var$parseDayOfMonth,
        "e": $7a55603832248c4b$var$parseDayOfMonth,
        "f": $7a55603832248c4b$var$parseMicroseconds,
        "g": $7a55603832248c4b$var$parseYear,
        "G": $7a55603832248c4b$var$parseFullYear,
        "H": $7a55603832248c4b$var$parseHour24,
        "I": $7a55603832248c4b$var$parseHour24,
        "j": $7a55603832248c4b$var$parseDayOfYear,
        "L": $7a55603832248c4b$var$parseMilliseconds,
        "m": $7a55603832248c4b$var$parseMonthNumber,
        "M": $7a55603832248c4b$var$parseMinutes,
        "p": parsePeriod,
        "q": $7a55603832248c4b$var$parseQuarter,
        "Q": $7a55603832248c4b$var$parseUnixTimestamp,
        "s": $7a55603832248c4b$var$parseUnixTimestampSeconds,
        "S": $7a55603832248c4b$var$parseSeconds,
        "u": $7a55603832248c4b$var$parseWeekdayNumberMonday,
        "U": $7a55603832248c4b$var$parseWeekNumberSunday,
        "V": $7a55603832248c4b$var$parseWeekNumberISO,
        "w": $7a55603832248c4b$var$parseWeekdayNumberSunday,
        "W": $7a55603832248c4b$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $7a55603832248c4b$var$parseYear,
        "Y": $7a55603832248c4b$var$parseFullYear,
        "Z": $7a55603832248c4b$var$parseZone,
        "%": $7a55603832248c4b$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $7a55603832248c4b$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $7a55603832248c4b$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $7a55603832248c4b$var$utcDate($7a55603832248c4b$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $30a54a0cc468acfe$export$9cfc53b9cfafd080).ceil(week) : (0, $30a54a0cc468acfe$export$9cfc53b9cfafd080)(week);
                    week = (0, $df99fa2fb24eed54$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $7a55603832248c4b$var$localDate($7a55603832248c4b$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $bdbb4ef11b8c6229$export$6416afaab03bc9b8).ceil(week) : (0, $bdbb4ef11b8c6229$export$6416afaab03bc9b8)(week);
                    week = (0, $e9995e8cb68fab98$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $7a55603832248c4b$var$utcDate($7a55603832248c4b$var$newDate(d.y, 0, 1)).getUTCDay() : $7a55603832248c4b$var$localDate($7a55603832248c4b$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $7a55603832248c4b$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $7a55603832248c4b$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $7a55603832248c4b$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $7a55603832248c4b$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $7a55603832248c4b$var$numberRe = /^\s*\d+/, $7a55603832248c4b$var$percentRe = /^%/, $7a55603832248c4b$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $7a55603832248c4b$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $7a55603832248c4b$var$requote(s) {
    return s.replace($7a55603832248c4b$var$requoteRe, "\\$&");
}
function $7a55603832248c4b$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($7a55603832248c4b$var$requote).join("|") + ")", "i");
}
function $7a55603832248c4b$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $7a55603832248c4b$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $7a55603832248c4b$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $7a55603832248c4b$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $7a55603832248c4b$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $7a55603832248c4b$var$parseWeekNumberSunday(d, string, i) {
    var n = $7a55603832248c4b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $7a55603832248c4b$var$parseWeekNumberISO(d, string, i) {
    var n = $7a55603832248c4b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $7a55603832248c4b$var$parseWeekNumberMonday(d, string, i) {
    var n = $7a55603832248c4b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $7a55603832248c4b$var$parseFullYear(d, string, i) {
    var n = $7a55603832248c4b$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $7a55603832248c4b$var$parseYear(d, string, i) {
    var n = $7a55603832248c4b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $7a55603832248c4b$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $7a55603832248c4b$var$parseQuarter(d, string, i) {
    var n = $7a55603832248c4b$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $7a55603832248c4b$var$parseMonthNumber(d, string, i) {
    var n = $7a55603832248c4b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $7a55603832248c4b$var$parseDayOfMonth(d, string, i) {
    var n = $7a55603832248c4b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $7a55603832248c4b$var$parseDayOfYear(d, string, i) {
    var n = $7a55603832248c4b$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $7a55603832248c4b$var$parseHour24(d, string, i) {
    var n = $7a55603832248c4b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $7a55603832248c4b$var$parseMinutes(d, string, i) {
    var n = $7a55603832248c4b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $7a55603832248c4b$var$parseSeconds(d, string, i) {
    var n = $7a55603832248c4b$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $7a55603832248c4b$var$parseMilliseconds(d, string, i) {
    var n = $7a55603832248c4b$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $7a55603832248c4b$var$parseMicroseconds(d, string, i) {
    var n = $7a55603832248c4b$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $7a55603832248c4b$var$parseLiteralPercent(d, string, i) {
    var n = $7a55603832248c4b$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $7a55603832248c4b$var$parseUnixTimestamp(d, string, i) {
    var n = $7a55603832248c4b$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $7a55603832248c4b$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $7a55603832248c4b$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $7a55603832248c4b$var$formatDayOfMonth(d, p) {
    return $7a55603832248c4b$var$pad(d.getDate(), p, 2);
}
function $7a55603832248c4b$var$formatHour24(d, p) {
    return $7a55603832248c4b$var$pad(d.getHours(), p, 2);
}
function $7a55603832248c4b$var$formatHour12(d, p) {
    return $7a55603832248c4b$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $7a55603832248c4b$var$formatDayOfYear(d, p) {
    return $7a55603832248c4b$var$pad(1 + (0, $e9995e8cb68fab98$export$2e2bcd8739ae039).count((0, $3090dbe4840e9497$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $7a55603832248c4b$var$formatMilliseconds(d, p) {
    return $7a55603832248c4b$var$pad(d.getMilliseconds(), p, 3);
}
function $7a55603832248c4b$var$formatMicroseconds(d, p) {
    return $7a55603832248c4b$var$formatMilliseconds(d, p) + "000";
}
function $7a55603832248c4b$var$formatMonthNumber(d, p) {
    return $7a55603832248c4b$var$pad(d.getMonth() + 1, p, 2);
}
function $7a55603832248c4b$var$formatMinutes(d, p) {
    return $7a55603832248c4b$var$pad(d.getMinutes(), p, 2);
}
function $7a55603832248c4b$var$formatSeconds(d, p) {
    return $7a55603832248c4b$var$pad(d.getSeconds(), p, 2);
}
function $7a55603832248c4b$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $7a55603832248c4b$var$formatWeekNumberSunday(d, p) {
    return $7a55603832248c4b$var$pad((0, $bdbb4ef11b8c6229$export$fb3ee18ed410cc21).count((0, $3090dbe4840e9497$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $7a55603832248c4b$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $bdbb4ef11b8c6229$export$2f2b56683a3e5629)(d) : (0, $bdbb4ef11b8c6229$export$2f2b56683a3e5629).ceil(d);
}
function $7a55603832248c4b$var$formatWeekNumberISO(d, p) {
    d = $7a55603832248c4b$var$dISO(d);
    return $7a55603832248c4b$var$pad((0, $bdbb4ef11b8c6229$export$2f2b56683a3e5629).count((0, $3090dbe4840e9497$export$2e2bcd8739ae039)(d), d) + ((0, $3090dbe4840e9497$export$2e2bcd8739ae039)(d).getDay() === 4), p, 2);
}
function $7a55603832248c4b$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $7a55603832248c4b$var$formatWeekNumberMonday(d, p) {
    return $7a55603832248c4b$var$pad((0, $bdbb4ef11b8c6229$export$6416afaab03bc9b8).count((0, $3090dbe4840e9497$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $7a55603832248c4b$var$formatYear(d, p) {
    return $7a55603832248c4b$var$pad(d.getFullYear() % 100, p, 2);
}
function $7a55603832248c4b$var$formatYearISO(d, p) {
    d = $7a55603832248c4b$var$dISO(d);
    return $7a55603832248c4b$var$pad(d.getFullYear() % 100, p, 2);
}
function $7a55603832248c4b$var$formatFullYear(d, p) {
    return $7a55603832248c4b$var$pad(d.getFullYear() % 10000, p, 4);
}
function $7a55603832248c4b$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $bdbb4ef11b8c6229$export$2f2b56683a3e5629)(d) : (0, $bdbb4ef11b8c6229$export$2f2b56683a3e5629).ceil(d);
    return $7a55603832248c4b$var$pad(d.getFullYear() % 10000, p, 4);
}
function $7a55603832248c4b$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $7a55603832248c4b$var$pad(z / 60 | 0, "0", 2) + $7a55603832248c4b$var$pad(z % 60, "0", 2);
}
function $7a55603832248c4b$var$formatUTCDayOfMonth(d, p) {
    return $7a55603832248c4b$var$pad(d.getUTCDate(), p, 2);
}
function $7a55603832248c4b$var$formatUTCHour24(d, p) {
    return $7a55603832248c4b$var$pad(d.getUTCHours(), p, 2);
}
function $7a55603832248c4b$var$formatUTCHour12(d, p) {
    return $7a55603832248c4b$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $7a55603832248c4b$var$formatUTCDayOfYear(d, p) {
    return $7a55603832248c4b$var$pad(1 + (0, $df99fa2fb24eed54$export$2e2bcd8739ae039).count((0, $02e9f616a31e1208$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $7a55603832248c4b$var$formatUTCMilliseconds(d, p) {
    return $7a55603832248c4b$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $7a55603832248c4b$var$formatUTCMicroseconds(d, p) {
    return $7a55603832248c4b$var$formatUTCMilliseconds(d, p) + "000";
}
function $7a55603832248c4b$var$formatUTCMonthNumber(d, p) {
    return $7a55603832248c4b$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $7a55603832248c4b$var$formatUTCMinutes(d, p) {
    return $7a55603832248c4b$var$pad(d.getUTCMinutes(), p, 2);
}
function $7a55603832248c4b$var$formatUTCSeconds(d, p) {
    return $7a55603832248c4b$var$pad(d.getUTCSeconds(), p, 2);
}
function $7a55603832248c4b$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $7a55603832248c4b$var$formatUTCWeekNumberSunday(d, p) {
    return $7a55603832248c4b$var$pad((0, $30a54a0cc468acfe$export$4898b06303a92011).count((0, $02e9f616a31e1208$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $7a55603832248c4b$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $30a54a0cc468acfe$export$1db08111baec2f53)(d) : (0, $30a54a0cc468acfe$export$1db08111baec2f53).ceil(d);
}
function $7a55603832248c4b$var$formatUTCWeekNumberISO(d, p) {
    d = $7a55603832248c4b$var$UTCdISO(d);
    return $7a55603832248c4b$var$pad((0, $30a54a0cc468acfe$export$1db08111baec2f53).count((0, $02e9f616a31e1208$export$2e2bcd8739ae039)(d), d) + ((0, $02e9f616a31e1208$export$2e2bcd8739ae039)(d).getUTCDay() === 4), p, 2);
}
function $7a55603832248c4b$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $7a55603832248c4b$var$formatUTCWeekNumberMonday(d, p) {
    return $7a55603832248c4b$var$pad((0, $30a54a0cc468acfe$export$9cfc53b9cfafd080).count((0, $02e9f616a31e1208$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $7a55603832248c4b$var$formatUTCYear(d, p) {
    return $7a55603832248c4b$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $7a55603832248c4b$var$formatUTCYearISO(d, p) {
    d = $7a55603832248c4b$var$UTCdISO(d);
    return $7a55603832248c4b$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $7a55603832248c4b$var$formatUTCFullYear(d, p) {
    return $7a55603832248c4b$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $7a55603832248c4b$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $30a54a0cc468acfe$export$1db08111baec2f53)(d) : (0, $30a54a0cc468acfe$export$1db08111baec2f53).ceil(d);
    return $7a55603832248c4b$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $7a55603832248c4b$var$formatUTCZone() {
    return "+0000";
}
function $7a55603832248c4b$var$formatLiteralPercent() {
    return "%";
}
function $7a55603832248c4b$var$formatUnixTimestamp(d) {
    return +d;
}
function $7a55603832248c4b$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $58ba5cd9d8f807fc$var$locale;
var $58ba5cd9d8f807fc$export$94f4d87fad5dcf9a;
var $58ba5cd9d8f807fc$export$32b9cd16e1b8c8d2;
var $58ba5cd9d8f807fc$export$1a08fe38f63ebbbb;
var $58ba5cd9d8f807fc$export$3edae9cf8e233729;
$58ba5cd9d8f807fc$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $58ba5cd9d8f807fc$export$2e2bcd8739ae039(definition) {
    $58ba5cd9d8f807fc$var$locale = (0, $7a55603832248c4b$export$2e2bcd8739ae039)(definition);
    $58ba5cd9d8f807fc$export$94f4d87fad5dcf9a = $58ba5cd9d8f807fc$var$locale.format;
    $58ba5cd9d8f807fc$export$32b9cd16e1b8c8d2 = $58ba5cd9d8f807fc$var$locale.parse;
    $58ba5cd9d8f807fc$export$1a08fe38f63ebbbb = $58ba5cd9d8f807fc$var$locale.utcFormat;
    $58ba5cd9d8f807fc$export$3edae9cf8e233729 = $58ba5cd9d8f807fc$var$locale.utcParse;
    return $58ba5cd9d8f807fc$var$locale;
}




var $e7d484add67cd4d5$var$millisecond = (0, $ae993b74de2d70b3$export$2e2bcd8739ae039)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
$e7d484add67cd4d5$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $e7d484add67cd4d5$var$millisecond;
    return (0, $ae993b74de2d70b3$export$2e2bcd8739ae039)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $e7d484add67cd4d5$export$2e2bcd8739ae039 = $e7d484add67cd4d5$var$millisecond;
var $e7d484add67cd4d5$export$9a27fac83d67afd3 = $e7d484add67cd4d5$var$millisecond.range;



var $a1bb39b3900fc121$var$second = (0, $ae993b74de2d70b3$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, $a3e4e2040f036adf$export$79ef0e34099623dc));
}, function(start, end) {
    return (end - start) / (0, $a3e4e2040f036adf$export$79ef0e34099623dc);
}, function(date) {
    return date.getUTCSeconds();
});
var $a1bb39b3900fc121$export$2e2bcd8739ae039 = $a1bb39b3900fc121$var$second;
var $a1bb39b3900fc121$export$4792e48abc550fa1 = $a1bb39b3900fc121$var$second.range;



var $28387c9dae1daa7a$var$minute = (0, $ae993b74de2d70b3$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $a3e4e2040f036adf$export$79ef0e34099623dc));
}, function(date, step) {
    date.setTime(+date + step * (0, $a3e4e2040f036adf$export$683905d551c33fa9));
}, function(start, end) {
    return (end - start) / (0, $a3e4e2040f036adf$export$683905d551c33fa9);
}, function(date) {
    return date.getMinutes();
});
var $28387c9dae1daa7a$export$2e2bcd8739ae039 = $28387c9dae1daa7a$var$minute;
var $28387c9dae1daa7a$export$666252b437cce0c7 = $28387c9dae1daa7a$var$minute.range;



var $b60de8390d5c9330$var$hour = (0, $ae993b74de2d70b3$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $a3e4e2040f036adf$export$79ef0e34099623dc) - date.getMinutes() * (0, $a3e4e2040f036adf$export$683905d551c33fa9));
}, function(date, step) {
    date.setTime(+date + step * (0, $a3e4e2040f036adf$export$4157bf0c8e241659));
}, function(start, end) {
    return (end - start) / (0, $a3e4e2040f036adf$export$4157bf0c8e241659);
}, function(date) {
    return date.getHours();
});
var $b60de8390d5c9330$export$2e2bcd8739ae039 = $b60de8390d5c9330$var$hour;
var $b60de8390d5c9330$export$8d468796d69cdad1 = $b60de8390d5c9330$var$hour.range;


var $6708419974ca81a1$var$month = (0, $ae993b74de2d70b3$export$2e2bcd8739ae039)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $6708419974ca81a1$export$2e2bcd8739ae039 = $6708419974ca81a1$var$month;
var $6708419974ca81a1$export$16352d1b10c5eb38 = $6708419974ca81a1$var$month.range;



var $143690277a560326$var$utcMinute = (0, $ae993b74de2d70b3$export$2e2bcd8739ae039)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $a3e4e2040f036adf$export$683905d551c33fa9));
}, function(start, end) {
    return (end - start) / (0, $a3e4e2040f036adf$export$683905d551c33fa9);
}, function(date) {
    return date.getUTCMinutes();
});
var $143690277a560326$export$2e2bcd8739ae039 = $143690277a560326$var$utcMinute;
var $143690277a560326$export$cedd563624e8ee50 = $143690277a560326$var$utcMinute.range;



var $1f04c69f82a22b2f$var$utcHour = (0, $ae993b74de2d70b3$export$2e2bcd8739ae039)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $a3e4e2040f036adf$export$4157bf0c8e241659));
}, function(start, end) {
    return (end - start) / (0, $a3e4e2040f036adf$export$4157bf0c8e241659);
}, function(date) {
    return date.getUTCHours();
});
var $1f04c69f82a22b2f$export$2e2bcd8739ae039 = $1f04c69f82a22b2f$var$utcHour;
var $1f04c69f82a22b2f$export$6e7a76cd5f50b719 = $1f04c69f82a22b2f$var$utcHour.range;


var $20aa3129aa1abdc7$var$utcMonth = (0, $ae993b74de2d70b3$export$2e2bcd8739ae039)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $20aa3129aa1abdc7$export$2e2bcd8739ae039 = $20aa3129aa1abdc7$var$utcMonth;
var $20aa3129aa1abdc7$export$49159f585997498 = $20aa3129aa1abdc7$var$utcMonth.range;



function $5f34df148ba2978d$var$$() {
    return $5f34df148ba2978d$var$$ = Object.assign ? Object.assign.bind() : function(n) {
        for(var t = 1; t < arguments.length; t++){
            var r = arguments[t];
            for(var e in r)Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]);
        }
        return n;
    }, $5f34df148ba2978d$var$$.apply(this, arguments);
}
var $5f34df148ba2978d$export$6dcdc1137d8ab211 = [
    "millisecond",
    "second",
    "minute",
    "hour",
    "day",
    "month",
    "year"
], $5f34df148ba2978d$export$1dc82d6660f2ea1c = [
    function(n) {
        return n.setMilliseconds(0);
    },
    function(n) {
        return n.setSeconds(0);
    },
    function(n) {
        return n.setMinutes(0);
    },
    function(n) {
        return n.setHours(0);
    },
    function(n) {
        return n.setDate(1);
    },
    function(n) {
        return n.setMonth(0);
    }
], $5f34df148ba2978d$export$43fb64d4d70cf1d2 = {
    millisecond: [],
    second: $5f34df148ba2978d$export$1dc82d6660f2ea1c.slice(0, 1),
    minute: $5f34df148ba2978d$export$1dc82d6660f2ea1c.slice(0, 2),
    hour: $5f34df148ba2978d$export$1dc82d6660f2ea1c.slice(0, 3),
    day: $5f34df148ba2978d$export$1dc82d6660f2ea1c.slice(0, 4),
    month: $5f34df148ba2978d$export$1dc82d6660f2ea1c.slice(0, 5),
    year: $5f34df148ba2978d$export$1dc82d6660f2ea1c.slice(0, 6)
}, $5f34df148ba2978d$export$317f4d4c07f3c42a = function(n) {
    return function(t) {
        return $5f34df148ba2978d$export$43fb64d4d70cf1d2[n].forEach(function(n) {
            n(t);
        }), t;
    };
}, $5f34df148ba2978d$export$daf307d3fe6dfa68 = function(n) {
    var t = n.format, r = void 0 === t ? "native" : t, e = n.precision, a = void 0 === e ? "millisecond" : e, u = n.useUTC, c = void 0 === u || u, s = $5f34df148ba2978d$export$317f4d4c07f3c42a(a);
    return function(n) {
        if (void 0 === n) return n;
        if ("native" === r || n instanceof Date) return s(n);
        var t = c ? (0, $58ba5cd9d8f807fc$export$3edae9cf8e233729)(r) : (0, $58ba5cd9d8f807fc$export$32b9cd16e1b8c8d2)(r);
        return s(t(n));
    };
}, $5f34df148ba2978d$export$4e095c21b86a0457 = function(n, t, r, e) {
    var a, i, o, c, s = n.min, d = void 0 === s ? 0 : s, f = n.max, l = void 0 === f ? "auto" : f, m = n.stacked, v = void 0 !== m && m, y = n.reverse, p = void 0 !== y && y, h = n.clamp, g = void 0 !== h && h, x = n.nice, k = void 0 !== x && x;
    "auto" === d ? a = !0 === v ? null != (i = t.minStacked) ? i : 0 : t.min : a = d;
    "auto" === l ? o = !0 === v ? null != (c = t.maxStacked) ? c : 0 : t.max : o = l;
    var T = (0, $200a922019157658$export$2e2bcd8739ae039)().rangeRound("x" === e ? [
        0,
        r
    ] : [
        r,
        0
    ]).domain(p ? [
        o,
        a
    ] : [
        a,
        o
    ]).clamp(g);
    return !0 === k ? T.nice() : "number" == typeof k && T.nice(k), $5f34df148ba2978d$export$4fd02d345bf145e3(T, v);
}, $5f34df148ba2978d$export$4fd02d345bf145e3 = function(n, t) {
    void 0 === t && (t = !1);
    var r = n;
    return r.type = "linear", r.stacked = t, r;
}, $5f34df148ba2978d$export$9abcadf788874abe = function(n, t, r) {
    var e = (0, $66ab919e2a60291e$export$105684a3041cb6f3)().range([
        0,
        r
    ]).domain(t.all);
    return e.type = "point", e;
}, $5f34df148ba2978d$export$a8f33a545c6650d6 = function(n) {
    var t = n;
    return t.type = "point", t;
}, $5f34df148ba2978d$export$e9706c87cd649069 = function(n, t, r, e) {
    var a = n.round, i = void 0 === a || a, o = (0, $66ab919e2a60291e$export$2e2bcd8739ae039)().range("x" === e ? [
        0,
        r
    ] : [
        r,
        0
    ]).domain(t.all).round(i);
    return $5f34df148ba2978d$export$c88e9eb2fbaf2089(o);
}, $5f34df148ba2978d$export$c88e9eb2fbaf2089 = function(n) {
    var t = n;
    return t.type = "band", t;
}, $5f34df148ba2978d$export$27d74465d4d4bf01 = function(n, t, r) {
    var e, a, i = n.format, o = void 0 === i ? "native" : i, u = n.precision, c = void 0 === u ? "millisecond" : u, s = n.min, l = void 0 === s ? "auto" : s, m = n.max, v = void 0 === m ? "auto" : m, y = n.useUTC, p = void 0 === y || y, h = n.nice, g = void 0 !== h && h, x = $5f34df148ba2978d$export$daf307d3fe6dfa68({
        format: o,
        precision: c,
        useUTC: p
    });
    e = "auto" === l ? x(t.min) : "native" !== o ? x(l) : l, a = "auto" === v ? x(t.max) : "native" !== o ? x(v) : v;
    var k = p ? (0, $5130b88d88e34ca7$export$2e2bcd8739ae039)() : (0, $e031e928df7f8c43$export$2e2bcd8739ae039)();
    k.range([
        0,
        r
    ]), e && a && k.domain([
        e,
        a
    ]), !0 === g ? k.nice() : "object" != typeof g && "number" != typeof g || k.nice(g);
    var T = k;
    return T.type = "time", T.useUTC = p, T;
}, $5f34df148ba2978d$export$554cc426a2d37672 = function(n, t, r, e) {
    var a, i = n.base, o = void 0 === i ? 10 : i, u = n.min, c = void 0 === u ? "auto" : u, s = n.max, d = void 0 === s ? "auto" : s;
    if (t.all.some(function(n) {
        return 0 === n;
    })) throw new Error("a log scale domain must not include or cross zero");
    var f, m, v = !1;
    if (t.all.filter(function(n) {
        return null != n;
    }).forEach(function(n) {
        v || (void 0 === a ? a = Math.sign(n) : Math.sign(n) !== a && (v = !0));
    }), v) throw new Error("a log scale domain must be strictly-positive or strictly-negative");
    f = "auto" === c ? t.min : c, m = "auto" === d ? t.max : d;
    var y = (0, $1d0e690dbd31296e$export$2e2bcd8739ae039)().domain([
        f,
        m
    ]).rangeRound("x" === e ? [
        0,
        r
    ] : [
        r,
        0
    ]).base(o).nice();
    return y.type = "log", y;
}, $5f34df148ba2978d$export$8e14d6e8a8fc902c = function(n, t, r, e) {
    var a, i, o = n.constant, u = void 0 === o ? 1 : o, c = n.min, s = void 0 === c ? "auto" : c, d = n.max, f = void 0 === d ? "auto" : d, l = n.reverse, v = void 0 !== l && l;
    a = "auto" === s ? t.min : s, i = "auto" === f ? t.max : f;
    var y = (0, $52ee0a5773c968a2$export$2e2bcd8739ae039)().constant(u).rangeRound("x" === e ? [
        0,
        r
    ] : [
        r,
        0
    ]).nice();
    !0 === v ? y.domain([
        i,
        a
    ]) : y.domain([
        a,
        i
    ]);
    var p = y;
    return p.type = "symlog", p;
}, $5f34df148ba2978d$export$9aa6d07acb85188c = function(n) {
    return "x" === n ? "y" : "x";
}, $5f34df148ba2978d$export$6ab1df3197f7c641 = function(n, t) {
    return n === t;
}, $5f34df148ba2978d$export$562cdc7d09e1fa5a = function(n, t) {
    return n.getTime() === t.getTime();
};
function $5f34df148ba2978d$export$5268a4c29077d335(n, t, r, e) {
    switch(n.type){
        case "linear":
            return $5f34df148ba2978d$export$4e095c21b86a0457(n, t, r, e);
        case "point":
            return $5f34df148ba2978d$export$9abcadf788874abe(n, t, r);
        case "band":
            return $5f34df148ba2978d$export$e9706c87cd649069(n, t, r, e);
        case "time":
            return $5f34df148ba2978d$export$27d74465d4d4bf01(n, t, r);
        case "log":
            return $5f34df148ba2978d$export$554cc426a2d37672(n, t, r, e);
        case "symlog":
            return $5f34df148ba2978d$export$8e14d6e8a8fc902c(n, t, r, e);
        default:
            throw new Error("invalid scale spec");
    }
}
var $5f34df148ba2978d$var$sn = function(n, t, r) {
    var e;
    if ("stacked" in r && r.stacked) {
        var a = n.data["x" === t ? "xStacked" : "yStacked"];
        return null == a ? null : r(a);
    }
    return null != (e = r(n.data[t])) ? e : null;
}, $5f34df148ba2978d$export$4d0b292d246e5304 = function(n, t, r, e, a) {
    var i = n.map(function(n) {
        return function(n) {
            return $5f34df148ba2978d$var$$({}, n, {
                data: n.data.map(function(n) {
                    return {
                        data: $5f34df148ba2978d$var$$({}, n)
                    };
                })
            });
        }(n);
    }), o = $5f34df148ba2978d$export$ebc19db715008482(i, t, r);
    "stacked" in t && !0 === t.stacked && $5f34df148ba2978d$var$vn(o, i), "stacked" in r && !0 === r.stacked && $5f34df148ba2978d$var$yn(o, i);
    var u = $5f34df148ba2978d$export$5268a4c29077d335(t, o.x, e, "x"), c = $5f34df148ba2978d$export$5268a4c29077d335(r, o.y, a, "y"), s = i.map(function(n) {
        return $5f34df148ba2978d$var$$({}, n, {
            data: n.data.map(function(n) {
                return $5f34df148ba2978d$var$$({}, n, {
                    position: {
                        x: $5f34df148ba2978d$var$sn(n, "x", u),
                        y: $5f34df148ba2978d$var$sn(n, "y", c)
                    }
                });
            })
        });
    });
    return $5f34df148ba2978d$var$$({}, o, {
        series: s,
        xScale: u,
        yScale: c
    });
}, $5f34df148ba2978d$export$ebc19db715008482 = function(n, t, r) {
    return {
        x: $5f34df148ba2978d$export$b510e85f598a24fb(n, "x", t),
        y: $5f34df148ba2978d$export$b510e85f598a24fb(n, "y", r)
    };
}, $5f34df148ba2978d$export$b510e85f598a24fb = function(a, i, o, u) {
    var c = void 0 === u ? {} : u, s = c.getValue, d = void 0 === s ? function(n) {
        return n.data[i];
    } : s, f = c.setValue, l = void 0 === f ? function(n, t) {
        n.data[i] = t;
    } : f;
    if ("linear" === o.type) a.forEach(function(n) {
        n.data.forEach(function(n) {
            var t = d(n);
            t && l(n, parseFloat(String(t)));
        });
    });
    else if ("time" === o.type && "native" !== o.format) {
        var m = $5f34df148ba2978d$export$daf307d3fe6dfa68(o);
        a.forEach(function(n) {
            n.data.forEach(function(n) {
                var t = d(n);
                t && l(n, m(t));
            });
        });
    }
    var v = [];
    switch(a.forEach(function(n) {
        n.data.forEach(function(n) {
            v.push(d(n));
        });
    }), o.type){
        case "linear":
            var y = (0, (/*@__PURE__*/$parcel$interopDefault($0dbc7cb2f4eca1aa$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($cacf893e18dd1b21$exports)))(v).filter(function(n) {
                return null !== n;
            }), function(n) {
                return n;
            });
            return {
                all: y,
                min: Math.min.apply(Math, y),
                max: Math.max.apply(Math, y)
            };
        case "time":
            var p = (0, (/*@__PURE__*/$parcel$interopDefault($0461ecd8a7b18161$exports)))(v, function(n) {
                return n.getTime();
            }).slice(0).sort(function(n, t) {
                return t.getTime() - n.getTime();
            }).reverse();
            return {
                all: p,
                min: p[0],
                max: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))(p)
            };
        default:
            var h = (0, (/*@__PURE__*/$parcel$interopDefault($cacf893e18dd1b21$exports)))(v);
            return {
                all: h,
                min: h[0],
                max: (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))(h)
            };
    }
}, $5f34df148ba2978d$export$c6f16b50cdeeb77c = function(n, t, r) {
    var i = $5f34df148ba2978d$export$9aa6d07acb85188c(n), o = [];
    t[i].all.forEach(function(t) {
        var u = (0, (/*@__PURE__*/$parcel$interopDefault($140a48eb88266f4f$exports)))(t) ? $5f34df148ba2978d$export$562cdc7d09e1fa5a : $5f34df148ba2978d$export$6ab1df3197f7c641, c = [];
        r.forEach(function(r) {
            var a = r.data.find(function(n) {
                return u(n.data[i], t);
            }), s = null, d = null;
            if (void 0 !== a) {
                if (null !== (s = a.data[n])) {
                    var f = (0, (/*@__PURE__*/$parcel$interopDefault($37b3ad643dcadb8d$exports)))(c);
                    void 0 === f ? d = s : null !== f && (d = f + s);
                }
                a.data["x" === n ? "xStacked" : "yStacked"] = d;
            }
            c.push(d), null !== d && o.push(d);
        });
    }), t[n].minStacked = Math.min.apply(Math, o), t[n].maxStacked = Math.max.apply(Math, o);
}, $5f34df148ba2978d$var$vn = function(n, t) {
    return $5f34df148ba2978d$export$c6f16b50cdeeb77c("x", n, t);
}, $5f34df148ba2978d$var$yn = function(n, t) {
    return $5f34df148ba2978d$export$c6f16b50cdeeb77c("y", n, t);
}, $5f34df148ba2978d$export$6eebe39d34e5b9b7 = function(n) {
    var t = n.bandwidth();
    if (0 === t) return n;
    var r = t / 2;
    return n.round() && (r = Math.round(r)), function(t) {
        var e;
        return (null != (e = n(t)) ? e : 0) + r;
    };
}, $5f34df148ba2978d$var$hn = {
    millisecond: [
        (0, $e7d484add67cd4d5$export$2e2bcd8739ae039),
        (0, $e7d484add67cd4d5$export$2e2bcd8739ae039)
    ],
    second: [
        (0, $a1bb39b3900fc121$export$2e2bcd8739ae039),
        (0, $a1bb39b3900fc121$export$2e2bcd8739ae039)
    ],
    minute: [
        (0, $28387c9dae1daa7a$export$2e2bcd8739ae039),
        (0, $143690277a560326$export$2e2bcd8739ae039)
    ],
    hour: [
        (0, $b60de8390d5c9330$export$2e2bcd8739ae039),
        (0, $1f04c69f82a22b2f$export$2e2bcd8739ae039)
    ],
    day: [
        (0, $ae993b74de2d70b3$export$2e2bcd8739ae039)(function(n) {
            return n.setHours(0, 0, 0, 0);
        }, function(n, t) {
            return n.setDate(n.getDate() + t);
        }, function(n, t) {
            return (t.getTime() - n.getTime()) / 864e5;
        }, function(n) {
            return Math.floor(n.getTime() / 864e5);
        }),
        (0, $ae993b74de2d70b3$export$2e2bcd8739ae039)(function(n) {
            return n.setUTCHours(0, 0, 0, 0);
        }, function(n, t) {
            return n.setUTCDate(n.getUTCDate() + t);
        }, function(n, t) {
            return (t.getTime() - n.getTime()) / 864e5;
        }, function(n) {
            return Math.floor(n.getTime() / 864e5);
        })
    ],
    week: [
        (0, $bdbb4ef11b8c6229$export$fb3ee18ed410cc21),
        (0, $30a54a0cc468acfe$export$4898b06303a92011)
    ],
    sunday: [
        (0, $bdbb4ef11b8c6229$export$fb3ee18ed410cc21),
        (0, $30a54a0cc468acfe$export$4898b06303a92011)
    ],
    monday: [
        (0, $bdbb4ef11b8c6229$export$6416afaab03bc9b8),
        (0, $30a54a0cc468acfe$export$9cfc53b9cfafd080)
    ],
    tuesday: [
        (0, $bdbb4ef11b8c6229$export$cb8f040f5d17ac7b),
        (0, $30a54a0cc468acfe$export$2a6d545f77eceb15)
    ],
    wednesday: [
        (0, $bdbb4ef11b8c6229$export$347581849975dfc8),
        (0, $30a54a0cc468acfe$export$a5c25d8ed64433c4)
    ],
    thursday: [
        (0, $bdbb4ef11b8c6229$export$2f2b56683a3e5629),
        (0, $30a54a0cc468acfe$export$1db08111baec2f53)
    ],
    friday: [
        (0, $bdbb4ef11b8c6229$export$59b8c2ccd931d806),
        (0, $30a54a0cc468acfe$export$29265e34dd5921f7)
    ],
    saturday: [
        (0, $bdbb4ef11b8c6229$export$478ceadebff4d377),
        (0, $30a54a0cc468acfe$export$85b74dad05049604)
    ],
    month: [
        (0, $6708419974ca81a1$export$2e2bcd8739ae039),
        (0, $20aa3129aa1abdc7$export$2e2bcd8739ae039)
    ],
    year: [
        (0, $3090dbe4840e9497$export$2e2bcd8739ae039),
        (0, $02e9f616a31e1208$export$2e2bcd8739ae039)
    ]
}, $5f34df148ba2978d$var$gn = Object.keys($5f34df148ba2978d$var$hn), $5f34df148ba2978d$var$xn = new RegExp("^every\\s*(\\d+)?\\s*(" + $5f34df148ba2978d$var$gn.join("|") + ")s?$", "i"), $5f34df148ba2978d$export$6524ae923f6f50f3 = function(n, t) {
    if (Array.isArray(t)) return t;
    if ("string" == typeof t && "useUTC" in n) {
        var r = t.match($5f34df148ba2978d$var$xn);
        if (r) {
            var e = r[1], a = r[2], i = $5f34df148ba2978d$var$hn[a][n.useUTC ? 1 : 0];
            if ("day" === a) {
                var o, u, c = n.domain(), s = c[0], d = c[1], f = new Date(d);
                return f.setDate(f.getDate() + 1), null != (o = null == (u = i.every(Number(null != e ? e : 1))) ? void 0 : u.range(s, f)) ? o : [];
            }
            if (void 0 === e) return n.ticks(i);
            var l = i.every(Number(e));
            if (l) return n.ticks(l);
        }
        throw new Error("Invalid tickValues: " + t);
    }
    if ("ticks" in n) {
        if (void 0 === t) return n.ticks();
        if ("number" == typeof (m = t) && isFinite(m) && Math.floor(m) === m) return n.ticks(t);
    }
    var m;
    return n.domain();
};



var $aSiaI = parcelRequire("aSiaI");
function $69c3a5d74af80d16$var$p() {
    return $69c3a5d74af80d16$var$p = Object.assign ? Object.assign.bind() : function(t) {
        for(var e = 1; e < arguments.length; e++){
            var i = arguments[e];
            for(var n in i)Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
        }
        return t;
    }, $69c3a5d74af80d16$var$p.apply(this, arguments);
}
var $69c3a5d74af80d16$var$b = function(t) {
    var e, i = t.axis, n = t.scale, r = t.ticksPosition, o = t.tickValues, l = t.tickSize, s = t.tickPadding, c = t.tickRotation, f = t.truncateTickAt, u = t.engine, d = void 0 === u ? "svg" : u, x = (0, $5f34df148ba2978d$export$6524ae923f6f50f3)(n, o), m = (0, $5c76f646ce642491$export$1abb91cfca1e2069)[d], k = "bandwidth" in n ? (0, $5f34df148ba2978d$export$6eebe39d34e5b9b7)(n) : n, g = {
        lineX: 0,
        lineY: 0
    }, v = {
        textX: 0,
        textY: 0
    }, b = "object" == typeof document && "rtl" === document.dir, P = m.align.center, T = m.baseline.center;
    "x" === i ? (e = function(t) {
        var e;
        return {
            x: null != (e = k(t)) ? e : 0,
            y: 0
        };
    }, g.lineY = l * ("after" === r ? 1 : -1), v.textY = (l + s) * ("after" === r ? 1 : -1), T = "after" === r ? m.baseline.top : m.baseline.bottom, 0 === c ? P = m.align.center : "after" === r && c < 0 || "before" === r && c > 0 ? (P = m.align[b ? "left" : "right"], T = m.baseline.center) : ("after" === r && c > 0 || "before" === r && c < 0) && (P = m.align[b ? "right" : "left"], T = m.baseline.center)) : (e = function(t) {
        var e;
        return {
            x: 0,
            y: null != (e = k(t)) ? e : 0
        };
    }, g.lineX = l * ("after" === r ? 1 : -1), v.textX = (l + s) * ("after" === r ? 1 : -1), P = "after" === r ? m.align.left : m.align.right);
    return {
        ticks: x.map(function(t) {
            var i = "string" == typeof t ? function(t) {
                var e = String(t).length;
                return f && f > 0 && e > f ? "" + String(t).slice(0, f).concat("...") : "" + t;
            }(t) : t;
            return $69c3a5d74af80d16$var$p({
                key: t instanceof Date ? "" + t.valueOf() : "" + t,
                value: i
            }, e(t), g, v);
        }),
        textAlign: P,
        textBaseline: T
    };
}, $69c3a5d74af80d16$var$P = function(t, e) {
    if (void 0 === t || "function" == typeof t) return t;
    if ("time" === e.type) {
        var i = (0, $5fd29e3c907fe830$export$94f4d87fad5dcf9a)(t);
        return function(t) {
            return i(t instanceof Date ? t : new Date(t));
        };
    }
    return (0, $aab7a294d70d2095$export$d9468344d3651243)(t);
}, $69c3a5d74af80d16$var$T = function(t) {
    var e, i = t.width, n = t.height, r = t.scale, a = t.axis, o = t.values, l = (e = o, Array.isArray(e) ? o : void 0) || (0, $5f34df148ba2978d$export$6524ae923f6f50f3)(r, o), s = "bandwidth" in r ? (0, $5f34df148ba2978d$export$6eebe39d34e5b9b7)(r) : r, c = "x" === a ? l.map(function(t) {
        var e, i;
        return {
            key: t instanceof Date ? "" + t.valueOf() : "" + t,
            x1: null != (e = s(t)) ? e : 0,
            x2: null != (i = s(t)) ? i : 0,
            y1: 0,
            y2: n
        };
    }) : l.map(function(t) {
        var e, n;
        return {
            key: t instanceof Date ? "" + t.valueOf() : "" + t,
            x1: 0,
            x2: i,
            y1: null != (e = s(t)) ? e : 0,
            y2: null != (n = s(t)) ? n : 0
        };
    });
    return c;
}, $69c3a5d74af80d16$export$3704f81c1ca961a8 = (0, $exYeM.memo)(function(t) {
    var e, n = t.value, r = t.format, a = t.lineX, s = t.lineY, c = t.onClick, u = t.textBaseline, d = t.textAnchor, x = t.animatedProps, m = (0, $5c76f646ce642491$export$93d4e7f90805808f)(), y = m.axis.ticks.line, h = m.axis.ticks.text, v = null != (e = null == r ? void 0 : r(n)) ? e : n, b = (0, $exYeM.useMemo)(function() {
        var t = {
            opacity: x.opacity
        };
        return c ? {
            style: $69c3a5d74af80d16$var$p({}, t, {
                cursor: "pointer"
            }),
            onClick: function(t) {
                return c(t, v);
            }
        } : {
            style: t
        };
    }, [
        x.opacity,
        c,
        v
    ]);
    return (0, $aSiaI.jsxs)((0, $f9aea5876333360d$export$407448d2b89b1813).g, $69c3a5d74af80d16$var$p({
        transform: x.transform
    }, b, {
        children: [
            (0, $aSiaI.jsx)("line", {
                x1: 0,
                x2: a,
                y1: 0,
                y2: s,
                style: y
            }),
            h.outlineWidth > 0 && (0, $aSiaI.jsx)((0, $f9aea5876333360d$export$407448d2b89b1813).text, {
                dominantBaseline: u,
                textAnchor: d,
                transform: x.textTransform,
                style: h,
                strokeWidth: 2 * h.outlineWidth,
                stroke: h.outlineColor,
                strokeLinejoin: "round",
                children: "" + v
            }),
            (0, $aSiaI.jsx)((0, $f9aea5876333360d$export$407448d2b89b1813).text, {
                dominantBaseline: u,
                textAnchor: d,
                transform: x.textTransform,
                style: (0, $5c76f646ce642491$export$c30625df7c8afdb5)(h),
                children: "" + v
            })
        ]
    }));
}), $69c3a5d74af80d16$export$c5639fd237d7a900 = function(e) {
    var r = e.axis, a = e.scale, l = e.x, c = void 0 === l ? 0 : l, x = e.y, m = void 0 === x ? 0 : x, y = e.length, h = e.ticksPosition, T = e.tickValues, S = e.tickSize, W = void 0 === S ? 5 : S, w = e.tickPadding, B = void 0 === w ? 5 : w, X = e.tickRotation, Y = void 0 === X ? 0 : X, C = e.format, O = e.renderTick, j = void 0 === O ? $69c3a5d74af80d16$export$3704f81c1ca961a8 : O, z = e.truncateTickAt, V = e.legend, D = e.legendPosition, R = void 0 === D ? "end" : D, E = e.legendOffset, q = void 0 === E ? 0 : E, F = e.onClick, L = e.ariaHidden, N = (0, $5c76f646ce642491$export$93d4e7f90805808f)(), H = N.axis.legend.text, I = (0, $exYeM.useMemo)(function() {
        return $69c3a5d74af80d16$var$P(C, a);
    }, [
        C,
        a
    ]), J = $69c3a5d74af80d16$var$b({
        axis: r,
        scale: a,
        ticksPosition: h,
        tickValues: T,
        tickSize: W,
        tickPadding: B,
        tickRotation: Y,
        truncateTickAt: z
    }), G = J.ticks, K = J.textAlign, M = J.textBaseline, Q = null;
    if (void 0 !== V) {
        var U, Z = 0, $ = 0, _ = 0;
        "y" === r ? (_ = -90, Z = q, "start" === R ? (U = "start", $ = y) : "middle" === R ? (U = "middle", $ = y / 2) : "end" === R && (U = "end")) : ($ = q, "start" === R ? U = "start" : "middle" === R ? (U = "middle", Z = y / 2) : "end" === R && (U = "end", Z = y)), Q = (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
            children: [
                H.outlineWidth > 0 && (0, $aSiaI.jsx)("text", {
                    transform: "translate(" + Z + ", " + $ + ") rotate(" + _ + ")",
                    textAnchor: U,
                    style: $69c3a5d74af80d16$var$p({
                        dominantBaseline: "central"
                    }, H),
                    strokeWidth: 2 * H.outlineWidth,
                    stroke: H.outlineColor,
                    strokeLinejoin: "round",
                    children: V
                }),
                (0, $aSiaI.jsx)("text", {
                    transform: "translate(" + Z + ", " + $ + ") rotate(" + _ + ")",
                    textAnchor: U,
                    style: $69c3a5d74af80d16$var$p({
                        dominantBaseline: "central"
                    }, H),
                    children: V
                })
            ]
        });
    }
    var tt = (0, $5c76f646ce642491$export$72acc3dc9629d75d)(), et = tt.animate, it = tt.config, nt = (0, $9f726edb03f4840c$export$c4af9125706c4d30)({
        transform: "translate(" + c + "," + m + ")",
        lineX2: "x" === r ? y : 0,
        lineY2: "x" === r ? 0 : y,
        config: it,
        immediate: !et
    }), rt = (0, $exYeM.useCallback)(function(t) {
        return {
            opacity: 1,
            transform: "translate(" + t.x + "," + t.y + ")",
            textTransform: "translate(" + t.textX + "," + t.textY + ") rotate(" + Y + ")"
        };
    }, [
        Y
    ]), at = (0, $exYeM.useCallback)(function(t) {
        return {
            opacity: 0,
            transform: "translate(" + t.x + "," + t.y + ")",
            textTransform: "translate(" + t.textX + "," + t.textY + ") rotate(" + Y + ")"
        };
    }, [
        Y
    ]), ot = (0, $9f726edb03f4840c$export$7b286972b8d8ccbf)(G, {
        keys: function(t) {
            return t.key;
        },
        initial: rt,
        from: at,
        enter: rt,
        update: rt,
        leave: {
            opacity: 0
        },
        config: it,
        immediate: !et
    });
    return (0, $aSiaI.jsxs)((0, $f9aea5876333360d$export$407448d2b89b1813).g, {
        transform: nt.transform,
        "aria-hidden": L,
        children: [
            ot(function(e, i, n, r) {
                return $exYeM.createElement(j, $69c3a5d74af80d16$var$p({
                    tickIndex: r,
                    format: I,
                    rotate: Y,
                    textBaseline: M,
                    textAnchor: K,
                    truncateTickAt: z,
                    animatedProps: e
                }, i, F ? {
                    onClick: F
                } : {}));
            }),
            (0, $aSiaI.jsx)((0, $f9aea5876333360d$export$407448d2b89b1813).line, {
                style: N.axis.domain.line,
                x1: 0,
                x2: nt.lineX2,
                y1: 0,
                y2: nt.lineY2
            }),
            Q
        ]
    });
}, $69c3a5d74af80d16$export$d06866a9fb0606da = (0, $exYeM.memo)($69c3a5d74af80d16$export$c5639fd237d7a900), $69c3a5d74af80d16$export$878041e1e4cd4218 = [
    "top",
    "right",
    "bottom",
    "left"
], $69c3a5d74af80d16$export$387a78ab20784494 = (0, $exYeM.memo)(function(t) {
    var e = t.xScale, i = t.yScale, n = t.width, r = t.height, a = {
        top: t.top,
        right: t.right,
        bottom: t.bottom,
        left: t.left
    };
    return (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: $69c3a5d74af80d16$export$878041e1e4cd4218.map(function(t) {
            var o = a[t];
            if (!o) return null;
            var l = "top" === t || "bottom" === t;
            return (0, $aSiaI.jsx)($69c3a5d74af80d16$export$d06866a9fb0606da, $69c3a5d74af80d16$var$p({}, o, {
                axis: l ? "x" : "y",
                x: "right" === t ? n : 0,
                y: "bottom" === t ? r : 0,
                scale: l ? e : i,
                length: l ? n : r,
                ticksPosition: "top" === t || "left" === t ? "before" : "after",
                truncateTickAt: o.truncateTickAt
            }), t);
        })
    });
}), $69c3a5d74af80d16$export$cb089865d3c60926 = (0, $exYeM.memo)(function(t) {
    var e = t.animatedProps, i = (0, $5c76f646ce642491$export$93d4e7f90805808f)();
    return (0, $aSiaI.jsx)((0, $f9aea5876333360d$export$407448d2b89b1813).line, $69c3a5d74af80d16$var$p({}, e, i.grid.line));
}), $69c3a5d74af80d16$export$36506d95c1656a54 = (0, $exYeM.memo)(function(t) {
    var e = t.lines, i = (0, $5c76f646ce642491$export$72acc3dc9629d75d)(), n = i.animate, a = i.config, o = (0, $9f726edb03f4840c$export$7b286972b8d8ccbf)(e, {
        keys: function(t) {
            return t.key;
        },
        initial: function(t) {
            return {
                opacity: 1,
                x1: t.x1,
                x2: t.x2,
                y1: t.y1,
                y2: t.y2
            };
        },
        from: function(t) {
            return {
                opacity: 0,
                x1: t.x1,
                x2: t.x2,
                y1: t.y1,
                y2: t.y2
            };
        },
        enter: function(t) {
            return {
                opacity: 1,
                x1: t.x1,
                x2: t.x2,
                y1: t.y1,
                y2: t.y2
            };
        },
        update: function(t) {
            return {
                opacity: 1,
                x1: t.x1,
                x2: t.x2,
                y1: t.y1,
                y2: t.y2
            };
        },
        leave: {
            opacity: 0
        },
        config: a,
        immediate: !n
    });
    return (0, $aSiaI.jsx)("g", {
        children: o(function(t, e) {
            return (0, $exYeM.createElement)($69c3a5d74af80d16$export$cb089865d3c60926, $69c3a5d74af80d16$var$p({}, e, {
                key: e.key,
                animatedProps: t
            }));
        })
    });
}), $69c3a5d74af80d16$export$ef2184bd89960b14 = (0, $exYeM.memo)(function(t) {
    var e = t.width, n = t.height, r = t.xScale, a = t.yScale, o = t.xValues, l = t.yValues, s = (0, $exYeM.useMemo)(function() {
        return !!r && $69c3a5d74af80d16$var$T({
            width: e,
            height: n,
            scale: r,
            axis: "x",
            values: o
        });
    }, [
        r,
        o,
        e,
        n
    ]), c = (0, $exYeM.useMemo)(function() {
        return !!a && $69c3a5d74af80d16$var$T({
            width: e,
            height: n,
            scale: a,
            axis: "y",
            values: l
        });
    }, [
        n,
        e,
        a,
        l
    ]);
    return (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            s && (0, $aSiaI.jsx)($69c3a5d74af80d16$export$36506d95c1656a54, {
                lines: s
            }),
            c && (0, $aSiaI.jsx)($69c3a5d74af80d16$export$36506d95c1656a54, {
                lines: c
            })
        ]
    });
}), $69c3a5d74af80d16$export$b3252c0e7f5dbc3f = function(t, e) {
    var i, n = e.axis, r = e.scale, a = e.x, o = void 0 === a ? 0 : a, l = e.y, s = void 0 === l ? 0 : l, f = e.length, u = e.ticksPosition, d = e.tickValues, x = e.tickSize, m = void 0 === x ? 5 : x, y = e.tickPadding, h = void 0 === y ? 5 : y, k = e.tickRotation, g = void 0 === k ? 0 : k, v = e.format, p = e.legend, P = e.legendPosition, T = void 0 === P ? "end" : P, A = e.legendOffset, S = void 0 === A ? 0 : A, W = e.theme, w = $69c3a5d74af80d16$var$b({
        axis: n,
        scale: r,
        ticksPosition: u,
        tickValues: d,
        tickSize: m,
        tickPadding: h,
        tickRotation: g,
        engine: "canvas"
    }), B = w.ticks, X = w.textAlign, Y = w.textBaseline;
    t.save(), t.translate(o, s), t.textAlign = X, t.textBaseline = Y;
    var C = W.axis.ticks.text;
    t.font = (C.fontWeight ? C.fontWeight + " " : "") + C.fontSize + "px " + C.fontFamily, (null != (i = W.axis.domain.line.strokeWidth) ? i : 0) > 0 && (t.lineWidth = Number(W.axis.domain.line.strokeWidth), t.lineCap = "square", W.axis.domain.line.stroke && (t.strokeStyle = W.axis.domain.line.stroke), t.beginPath(), t.moveTo(0, 0), t.lineTo("x" === n ? f : 0, "x" === n ? 0 : f), t.stroke());
    var O = "function" == typeof v ? v : function(t) {
        return "" + t;
    };
    if (B.forEach(function(e) {
        var i;
        (null != (i = W.axis.ticks.line.strokeWidth) ? i : 0) > 0 && (t.lineWidth = Number(W.axis.ticks.line.strokeWidth), t.lineCap = "square", W.axis.ticks.line.stroke && (t.strokeStyle = W.axis.ticks.line.stroke), t.beginPath(), t.moveTo(e.x, e.y), t.lineTo(e.x + e.lineX, e.y + e.lineY), t.stroke());
        var n = O(e.value);
        t.save(), t.translate(e.x + e.textX, e.y + e.textY), t.rotate((0, $5c76f646ce642491$export$c9fcf1a7df975d78)(g)), C.outlineWidth > 0 && (t.strokeStyle = C.outlineColor, t.lineWidth = 2 * C.outlineWidth, t.lineJoin = "round", t.strokeText("" + n, 0, 0)), W.axis.ticks.text.fill && (t.fillStyle = C.fill), t.fillText("" + n, 0, 0), t.restore();
    }), void 0 !== p) {
        var j = 0, z = 0, V = 0, D = "center";
        "y" === n ? (V = -90, j = S, "start" === T ? (D = "start", z = f) : "middle" === T ? (D = "center", z = f / 2) : "end" === T && (D = "end")) : (z = S, "start" === T ? D = "start" : "middle" === T ? (D = "center", j = f / 2) : "end" === T && (D = "end", j = f)), t.translate(j, z), t.rotate((0, $5c76f646ce642491$export$c9fcf1a7df975d78)(V)), t.font = (W.axis.legend.text.fontWeight ? W.axis.legend.text.fontWeight + " " : "") + W.axis.legend.text.fontSize + "px " + W.axis.legend.text.fontFamily, W.axis.legend.text.fill && (t.fillStyle = W.axis.legend.text.fill), t.textAlign = D, t.textBaseline = "middle", t.fillText(p, 0, 0);
    }
    t.restore();
}, $69c3a5d74af80d16$export$6f12c0e853c1bfff = function(t, e) {
    var i = e.xScale, n = e.yScale, r = e.width, a = e.height, o = e.top, l = e.right, s = e.bottom, c = e.left, f = e.theme, u = {
        top: o,
        right: l,
        bottom: s,
        left: c
    };
    $69c3a5d74af80d16$export$878041e1e4cd4218.forEach(function(e) {
        var o = u[e];
        if (!o) return null;
        var l = "top" === e || "bottom" === e, s = "top" === e || "left" === e ? "before" : "after", c = l ? i : n, d = $69c3a5d74af80d16$var$P(o.format, c);
        $69c3a5d74af80d16$export$b3252c0e7f5dbc3f(t, $69c3a5d74af80d16$var$p({}, o, {
            axis: l ? "x" : "y",
            x: "right" === e ? r : 0,
            y: "bottom" === e ? a : 0,
            scale: c,
            format: d,
            length: l ? r : a,
            ticksPosition: s,
            theme: f
        }));
    });
}, $69c3a5d74af80d16$export$5eea7e798580e5d1 = function(t, e) {
    var i = e.width, n = e.height, r = e.scale, a = e.axis, o = e.values;
    $69c3a5d74af80d16$var$T({
        width: i,
        height: n,
        scale: r,
        axis: a,
        values: o
    }).forEach(function(e) {
        t.beginPath(), t.moveTo(e.x1, e.y1), t.lineTo(e.x2, e.y2), t.stroke();
    });
};



var $aSiaI = parcelRequire("aSiaI");


function $2a9ddf628b4d45f4$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
}

function $d28bcc238e58ecac$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
}


var $b6ab5b54e89a6e21$export$2e2bcd8739ae039 = (0, $8c1cec2d8bf99503$export$2e2bcd8739ae039)("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");



var $exYeM = parcelRequire("exYeM");



var $1tQWc = parcelRequire("1tQWc");

var $bisEj = parcelRequire("bisEj");

function $4b989b5085aa4b26$export$2e2bcd8739ae039(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = (0, $aeb7fc2c29323e59$export$2e2bcd8739ae039);
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}









function $3acc04507f0fc995$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = (0, $cd4d28050bb392d2$export$f0954fd7d5368655), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $4b989b5085aa4b26$export$2e2bcd8739ae039)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $aeb7fc2c29323e59$export$2e2bcd8739ae039));
    scale.rangeRound = range((0, $b11128915dee5d67$export$2e2bcd8739ae039));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $3acc04507f0fc995$export$2e2bcd8739ae039() {
    var scale = (0, $200a922019157658$export$16a5d4b4a61a274d)($3acc04507f0fc995$var$transformer()((0, $cd4d28050bb392d2$export$f0954fd7d5368655)));
    scale.copy = function() {
        return (0, $1fbd210729a53e59$export$784d13d8ee351f07)(scale, $3acc04507f0fc995$export$2e2bcd8739ae039());
    };
    return (0, $1ec9baa7d5ff9a04$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $3acc04507f0fc995$export$5f0266a9159c47fb() {
    var scale = (0, $1d0e690dbd31296e$export$860836db074028f0)($3acc04507f0fc995$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $1fbd210729a53e59$export$784d13d8ee351f07)(scale, $3acc04507f0fc995$export$5f0266a9159c47fb()).base(scale.base());
    };
    return (0, $1ec9baa7d5ff9a04$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $3acc04507f0fc995$export$50b3da713cf557c6() {
    var scale = (0, $52ee0a5773c968a2$export$4602684e614eba38)($3acc04507f0fc995$var$transformer());
    scale.copy = function() {
        return (0, $1fbd210729a53e59$export$784d13d8ee351f07)(scale, $3acc04507f0fc995$export$50b3da713cf557c6()).constant(scale.constant());
    };
    return (0, $1ec9baa7d5ff9a04$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $3acc04507f0fc995$export$d6cedcc63bf26e7e() {
    var scale = (0, $d5fcc9a22585ff93$export$34695211ec403a46)($3acc04507f0fc995$var$transformer());
    scale.copy = function() {
        return (0, $1fbd210729a53e59$export$784d13d8ee351f07)(scale, $3acc04507f0fc995$export$d6cedcc63bf26e7e()).exponent(scale.exponent());
    };
    return (0, $1ec9baa7d5ff9a04$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $3acc04507f0fc995$export$33ddefb5c4ab9e9c() {
    return $3acc04507f0fc995$export$d6cedcc63bf26e7e.apply(null, arguments).exponent(0.5);
}


function $0c49a6db3d03e2c7$var$qe() {
    return $0c49a6db3d03e2c7$var$qe = Object.assign ? Object.assign.bind() : function(e) {
        for(var r = 1; r < arguments.length; r++){
            var n = arguments[r];
            for(var t in n)Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
        }
        return e;
    }, $0c49a6db3d03e2c7$var$qe.apply(this, arguments);
}
function $0c49a6db3d03e2c7$var$Ce(e, r) {
    (null == r || r > e.length) && (r = e.length);
    for(var n = 0, t = new Array(r); n < r; n++)t[n] = e[n];
    return t;
}
function $0c49a6db3d03e2c7$var$Ge(e, r) {
    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (n) return (n = n.call(e)).next.bind(n);
    if (Array.isArray(e) || (n = function(e, r) {
        if (e) {
            if ("string" == typeof e) return $0c49a6db3d03e2c7$var$Ce(e, r);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? $0c49a6db3d03e2c7$var$Ce(e, r) : void 0;
        }
    }(e)) || r && e && "number" == typeof e.length) {
        n && (e = n);
        var t = 0;
        return function() {
            return t >= e.length ? {
                done: !0
            } : {
                done: !1,
                value: e[t++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $0c49a6db3d03e2c7$export$8382cb219651957d = {
    nivo: [
        "#e8c1a0",
        "#f47560",
        "#f1e15b",
        "#e8a838",
        "#61cdbb",
        "#97e3d5"
    ],
    category10: (0, $6cf55a52784c4c94$export$2e2bcd8739ae039),
    accent: (0, $02c0c6c3f7e43cc1$export$2e2bcd8739ae039),
    dark2: (0, $23ad0b7aebc66491$export$2e2bcd8739ae039),
    paired: (0, $daa8fec60be60ffe$export$2e2bcd8739ae039),
    pastel1: (0, $4c7989bc9a50cdfa$export$2e2bcd8739ae039),
    pastel2: (0, $2880c7e0dc26a886$export$2e2bcd8739ae039),
    set1: (0, $55d4a8bbe5640080$export$2e2bcd8739ae039),
    set2: (0, $2f896875c60cd30c$export$2e2bcd8739ae039),
    set3: (0, $9978eafa53379e60$export$2e2bcd8739ae039),
    tableau10: (0, $b6ab5b54e89a6e21$export$2e2bcd8739ae039)
}, $0c49a6db3d03e2c7$export$480d437bf98751ba = Object.keys($0c49a6db3d03e2c7$export$8382cb219651957d), $0c49a6db3d03e2c7$export$b42e9133a3bfc0c2 = {
    brown_blueGreen: (0, $bd8720e4c6eb3871$export$3005042704f95a69),
    purpleRed_green: (0, $4b0f24737a26d9f4$export$3005042704f95a69),
    pink_yellowGreen: (0, $b02ac8d684257c07$export$3005042704f95a69),
    purple_orange: (0, $724b7315788895fd$export$3005042704f95a69),
    red_blue: (0, $88940571a49090a6$export$3005042704f95a69),
    red_grey: (0, $ec8d7a22851dff21$export$3005042704f95a69),
    red_yellow_blue: (0, $9f68712eea8cd6ac$export$3005042704f95a69),
    red_yellow_green: (0, $3139fdec064b7c51$export$3005042704f95a69),
    spectral: (0, $833721ceefd949c4$export$3005042704f95a69)
}, $0c49a6db3d03e2c7$export$63357c6d2f7b8781 = Object.keys($0c49a6db3d03e2c7$export$b42e9133a3bfc0c2), $0c49a6db3d03e2c7$export$d9c06f2af83aa27b = {
    brown_blueGreen: (0, $bd8720e4c6eb3871$export$2e2bcd8739ae039),
    purpleRed_green: (0, $4b0f24737a26d9f4$export$2e2bcd8739ae039),
    pink_yellowGreen: (0, $b02ac8d684257c07$export$2e2bcd8739ae039),
    purple_orange: (0, $724b7315788895fd$export$2e2bcd8739ae039),
    red_blue: (0, $88940571a49090a6$export$2e2bcd8739ae039),
    red_grey: (0, $ec8d7a22851dff21$export$2e2bcd8739ae039),
    red_yellow_blue: (0, $9f68712eea8cd6ac$export$2e2bcd8739ae039),
    red_yellow_green: (0, $3139fdec064b7c51$export$2e2bcd8739ae039),
    spectral: (0, $833721ceefd949c4$export$2e2bcd8739ae039)
}, $0c49a6db3d03e2c7$export$db45d8c654873588 = {
    blues: (0, $8840bb703ed77f74$export$3005042704f95a69),
    greens: (0, $e82b4ef470f808a2$export$3005042704f95a69),
    greys: (0, $649d1bf6470207d9$export$3005042704f95a69),
    oranges: (0, $3903e186315f0f9e$export$3005042704f95a69),
    purples: (0, $e8bf982b60493aee$export$3005042704f95a69),
    reds: (0, $be17f4730443c624$export$3005042704f95a69),
    blue_green: (0, $372f913b55d41ecc$export$3005042704f95a69),
    blue_purple: (0, $2825d6fdb7b61318$export$3005042704f95a69),
    green_blue: (0, $f2a890cad3a27696$export$3005042704f95a69),
    orange_red: (0, $87356452b311f839$export$3005042704f95a69),
    purple_blue_green: (0, $4e5155d770ff652d$export$3005042704f95a69),
    purple_blue: (0, $90194d49605c0308$export$3005042704f95a69),
    purple_red: (0, $04ba4a284749d9bd$export$3005042704f95a69),
    red_purple: (0, $01f4b40ef05e1844$export$3005042704f95a69),
    yellow_green_blue: (0, $6ccbc8010af45a8e$export$3005042704f95a69),
    yellow_green: (0, $be9a3b4b45a77417$export$3005042704f95a69),
    yellow_orange_brown: (0, $66e2852028a8e0c6$export$3005042704f95a69),
    yellow_orange_red: (0, $6c8f5a395d15fa82$export$3005042704f95a69)
}, $0c49a6db3d03e2c7$export$6c6944263c7cbb3b = Object.keys($0c49a6db3d03e2c7$export$db45d8c654873588), $0c49a6db3d03e2c7$export$21dd087678fc5202 = {
    blues: (0, $8840bb703ed77f74$export$2e2bcd8739ae039),
    greens: (0, $e82b4ef470f808a2$export$2e2bcd8739ae039),
    greys: (0, $649d1bf6470207d9$export$2e2bcd8739ae039),
    oranges: (0, $3903e186315f0f9e$export$2e2bcd8739ae039),
    purples: (0, $e8bf982b60493aee$export$2e2bcd8739ae039),
    reds: (0, $be17f4730443c624$export$2e2bcd8739ae039),
    turbo: (0, $d28bcc238e58ecac$export$2e2bcd8739ae039),
    viridis: (0, $ddc7c718e0c3feb8$export$2e2bcd8739ae039),
    inferno: (0, $ddc7c718e0c3feb8$export$ad0c8285c8ea6dbd),
    magma: (0, $ddc7c718e0c3feb8$export$c41e69203f572e8d),
    plasma: (0, $ddc7c718e0c3feb8$export$6664860a633d9daf),
    cividis: (0, $2a9ddf628b4d45f4$export$2e2bcd8739ae039),
    warm: (0, $b3f27dfcd9dec59e$export$fc70efcec537be98),
    cool: (0, $b3f27dfcd9dec59e$export$c5cedbc1ab3be2c3),
    cubehelixDefault: (0, $125f10a46720bcdb$export$2e2bcd8739ae039),
    blue_green: (0, $372f913b55d41ecc$export$2e2bcd8739ae039),
    blue_purple: (0, $2825d6fdb7b61318$export$2e2bcd8739ae039),
    green_blue: (0, $f2a890cad3a27696$export$2e2bcd8739ae039),
    orange_red: (0, $87356452b311f839$export$2e2bcd8739ae039),
    purple_blue_green: (0, $4e5155d770ff652d$export$2e2bcd8739ae039),
    purple_blue: (0, $90194d49605c0308$export$2e2bcd8739ae039),
    purple_red: (0, $04ba4a284749d9bd$export$2e2bcd8739ae039),
    red_purple: (0, $01f4b40ef05e1844$export$2e2bcd8739ae039),
    yellow_green_blue: (0, $6ccbc8010af45a8e$export$2e2bcd8739ae039),
    yellow_green: (0, $be9a3b4b45a77417$export$2e2bcd8739ae039),
    yellow_orange_brown: (0, $66e2852028a8e0c6$export$2e2bcd8739ae039),
    yellow_orange_red: (0, $6c8f5a395d15fa82$export$2e2bcd8739ae039)
}, $0c49a6db3d03e2c7$export$2ad73d393c16f81c = $0c49a6db3d03e2c7$var$qe({}, $0c49a6db3d03e2c7$export$8382cb219651957d, $0c49a6db3d03e2c7$export$b42e9133a3bfc0c2, $0c49a6db3d03e2c7$export$db45d8c654873588), $0c49a6db3d03e2c7$export$b48661626a811234 = Object.keys($0c49a6db3d03e2c7$export$2ad73d393c16f81c), $0c49a6db3d03e2c7$export$9f49cca6c7d1dda4 = function(e) {
    return $0c49a6db3d03e2c7$export$480d437bf98751ba.includes(e);
}, $0c49a6db3d03e2c7$export$4d028a51ab424d0b = function(e) {
    return $0c49a6db3d03e2c7$export$63357c6d2f7b8781.includes(e);
}, $0c49a6db3d03e2c7$export$166c33132082d11d = function(e) {
    return $0c49a6db3d03e2c7$export$6c6944263c7cbb3b.includes(e);
}, $0c49a6db3d03e2c7$export$66bec3b8446aaf18 = {
    rainbow: (0, $b3f27dfcd9dec59e$export$2e2bcd8739ae039),
    sinebow: (0, $20342c4b269ec35e$export$2e2bcd8739ae039)
}, $0c49a6db3d03e2c7$export$6638ab0298ebe095 = $0c49a6db3d03e2c7$var$qe({}, $0c49a6db3d03e2c7$export$d9c06f2af83aa27b, $0c49a6db3d03e2c7$export$21dd087678fc5202, $0c49a6db3d03e2c7$export$66bec3b8446aaf18), $0c49a6db3d03e2c7$export$277274330ffd2780 = Object.keys($0c49a6db3d03e2c7$export$6638ab0298ebe095), $0c49a6db3d03e2c7$export$acb96d3092c0904 = function(e, r) {
    if ("function" == typeof e) return e;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($58f2645d8a82ddb4$exports)))(e)) {
        if (function(e) {
            return void 0 !== e.theme;
        }(e)) {
            if (void 0 === r) throw new Error("Unable to use color from theme as no theme was provided");
            var n = (0, (/*@__PURE__*/$parcel$interopDefault($37f57525b6598a05$exports)))(r, e.theme);
            if (void 0 === n) throw new Error("Color from theme is undefined at path: '" + e.theme + "'");
            return function() {
                return n;
            };
        }
        if (function(e) {
            return void 0 !== e.from;
        }(e)) {
            var t = function(r) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($37f57525b6598a05$exports)))(r, e.from);
            };
            if (Array.isArray(e.modifiers)) {
                for(var o, i = [], u = function() {
                    var e = o.value, r = e[0], n = e[1];
                    if ("brighter" === r) i.push(function(e) {
                        return e.brighter(n);
                    });
                    else if ("darker" === r) i.push(function(e) {
                        return e.darker(n);
                    });
                    else {
                        if ("opacity" !== r) throw new Error("Invalid color modifier: '" + r + "', must be one of: 'brighter', 'darker', 'opacity'");
                        i.push(function(e) {
                            return e.opacity = n, e;
                        });
                    }
                }, a = $0c49a6db3d03e2c7$var$Ge(e.modifiers); !(o = a()).done;)u();
                return 0 === i.length ? t : function(e) {
                    return i.reduce(function(e, r) {
                        return r(e);
                    }, (0, $1tQWc.rgb)(t(e))).toString();
                };
            }
            return t;
        }
        throw new Error("Invalid color spec, you should either specify 'theme' or 'from' when using a config object");
    }
    return function() {
        return e;
    };
}, $0c49a6db3d03e2c7$export$2a9e363116151414 = function(e, r) {
    return (0, $exYeM.useMemo)(function() {
        return $0c49a6db3d03e2c7$export$acb96d3092c0904(e, r);
    }, [
        e,
        r
    ]);
}, $0c49a6db3d03e2c7$export$5f5a386483e6fff5 = (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).shape({
        theme: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).shape({
        from: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired,
        modifiers: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).array)
    })
]), $0c49a6db3d03e2c7$export$30c0b047d59c1130 = {
    scheme: "turbo"
}, $0c49a6db3d03e2c7$export$3c410d9d0181bae0 = function(e, r) {
    var n = e.minValue, t = e.maxValue, o = void 0 !== n ? n : r.min, i = void 0 !== t ? t : r.max, u = (0, $1fbd210729a53e59$export$2e2bcd8739ae039)().domain([
        o,
        i
    ]).clamp(!0);
    if ("colors" in e) u.range(e.colors);
    else if ("interpolator" in e) u.interpolator(e.interpolator);
    else {
        var a, l = null != (a = e.scheme) ? a : $0c49a6db3d03e2c7$export$30c0b047d59c1130.scheme;
        u.interpolator($0c49a6db3d03e2c7$export$6638ab0298ebe095[l]);
    }
    return u;
}, $0c49a6db3d03e2c7$export$13bad8adfa9d5e5 = function(e, r) {
    return (0, $exYeM.useMemo)(function() {
        return $0c49a6db3d03e2c7$export$3c410d9d0181bae0(e, r);
    }, [
        e,
        r
    ]);
}, $0c49a6db3d03e2c7$export$83a83df24724477a = {
    scheme: "red_yellow_blue",
    divergeAt: .5
}, $0c49a6db3d03e2c7$export$d2925809ff5420bc = function(e, r) {
    var n, t = e.minValue, o = e.maxValue, i = void 0 !== t ? t : r.min, u = void 0 !== o ? o : r.max, a = [
        i,
        i + (u - i) / 2,
        u
    ], l = .5 - (null != (n = e.divergeAt) ? n : $0c49a6db3d03e2c7$export$83a83df24724477a.divergeAt), c = (0, $3acc04507f0fc995$export$2e2bcd8739ae039)().domain(a).clamp(!0), s = function(e) {
        return String(e);
    };
    if ("colors" in e) s = (0, $3acc04507f0fc995$export$2e2bcd8739ae039)().domain(a.map(function(e) {
        return e - l * (u - i);
    })).range(e.colors).interpolator();
    else if ("interpolator" in e) s = e.interpolator;
    else {
        var f, p = null != (f = e.scheme) ? f : $0c49a6db3d03e2c7$export$83a83df24724477a.scheme;
        s = $0c49a6db3d03e2c7$export$6638ab0298ebe095[p];
    }
    return c.interpolator(function(e) {
        return s(e + l);
    });
}, $0c49a6db3d03e2c7$export$92d4d3b6e140b0d1 = function(e, r) {
    return (0, $exYeM.useMemo)(function() {
        return $0c49a6db3d03e2c7$export$d2925809ff5420bc(e, r);
    }, [
        e,
        r
    ]);
}, $0c49a6db3d03e2c7$export$19b16327818185cf = {
    scheme: "turbo",
    steps: 7
}, $0c49a6db3d03e2c7$export$8442947f078400fb = function(e, r) {
    var n = (0, $5b716f584c76f524$export$2e2bcd8739ae039)().domain(e.domain || [
        r.min,
        r.max
    ]).nice();
    if ("colors" in e) n.range(e.colors);
    else {
        var t = e.scheme || $0c49a6db3d03e2c7$export$19b16327818185cf.scheme, o = void 0 === e.steps ? $0c49a6db3d03e2c7$export$19b16327818185cf.steps : e.steps, i = $0c49a6db3d03e2c7$export$6638ab0298ebe095[t], u = Array.from({
            length: o
        }).map(function(e, r) {
            return i(r * (1 / (o - 1)));
        });
        n.range(u);
    }
    return n;
}, $0c49a6db3d03e2c7$export$aeb5c6e1cabe7efa = function(e, r) {
    return (0, $exYeM.useMemo)(function() {
        return $0c49a6db3d03e2c7$export$8442947f078400fb(e, r);
    }, [
        e,
        r
    ]);
}, $0c49a6db3d03e2c7$export$351e3420d10d6780 = function(e, r) {
    if (function(e) {
        return "sequential" === e.type;
    }(e)) return $0c49a6db3d03e2c7$export$3c410d9d0181bae0(e, r);
    if (function(e) {
        return "diverging" === e.type;
    }(e)) return $0c49a6db3d03e2c7$export$d2925809ff5420bc(e, r);
    if (function(e) {
        return "quantize" === e.type;
    }(e)) return $0c49a6db3d03e2c7$export$8442947f078400fb(e, r);
    throw new Error("Invalid continuous color scale config");
}, $0c49a6db3d03e2c7$export$4796b471538d60f8 = function(e, r) {
    return (0, $exYeM.useMemo)(function() {
        return $0c49a6db3d03e2c7$export$351e3420d10d6780(e, r);
    }, [
        e,
        r
    ]);
}, $0c49a6db3d03e2c7$export$f6ca0f82846310a7 = function(e, r) {
    void 0 === r && (r = 16);
    var n = e.domain();
    if ("thresholds" in e) {
        var t = [], o = (0, $200a922019157658$export$2e2bcd8739ae039)().domain(n).range([
            0,
            1
        ]);
        return e.range().forEach(function(r, n) {
            var i = e.invertExtent(r), u = i[0], a = i[1];
            t.push({
                key: n + ".0",
                offset: o(u),
                stopColor: r
            }), t.push({
                key: n + ".1",
                offset: o(a),
                stopColor: r
            });
        }), t;
    }
    var i = e.copy();
    return 2 === n.length ? i.domain([
        0,
        1
    ]) : 3 === n.length && i.domain([
        0,
        .5,
        1
    ]), i.ticks(r).map(function(e) {
        return {
            key: "" + e,
            offset: e,
            stopColor: "" + i(e)
        };
    });
}, $0c49a6db3d03e2c7$export$c3ea10dbbf6bbab3 = function(e, r) {
    if ("function" == typeof e) return e;
    var n = "function" == typeof r ? r : function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($37f57525b6598a05$exports)))(e, r);
    };
    if (Array.isArray(e)) {
        var t = (0, $b5f1e5e45355bfef$export$2e2bcd8739ae039)(e), o = function(e) {
            return t(n(e));
        };
        return o.scale = t, o;
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($58f2645d8a82ddb4$exports)))(e)) {
        if (function(e) {
            return void 0 !== e.datum;
        }(e)) return function(r) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($37f57525b6598a05$exports)))(r, e.datum);
        };
        if (function(e) {
            return void 0 !== e.scheme;
        }(e)) {
            if ($0c49a6db3d03e2c7$export$9f49cca6c7d1dda4(e.scheme)) {
                var i = (0, $b5f1e5e45355bfef$export$2e2bcd8739ae039)($0c49a6db3d03e2c7$export$2ad73d393c16f81c[e.scheme]), u = function(e) {
                    return i(n(e));
                };
                return u.scale = i, u;
            }
            if ($0c49a6db3d03e2c7$export$4d028a51ab424d0b(e.scheme)) {
                if (void 0 !== e.size && (e.size < 3 || e.size > 11)) throw new Error("Invalid size '" + e.size + "' for diverging color scheme '" + e.scheme + "', must be between 3~11");
                var a = (0, $b5f1e5e45355bfef$export$2e2bcd8739ae039)($0c49a6db3d03e2c7$export$2ad73d393c16f81c[e.scheme][e.size || 11]), l = function(e) {
                    return a(n(e));
                };
                return l.scale = a, l;
            }
            if ($0c49a6db3d03e2c7$export$166c33132082d11d(e.scheme)) {
                if (void 0 !== e.size && (e.size < 3 || e.size > 9)) throw new Error("Invalid size '" + e.size + "' for sequential color scheme '" + e.scheme + "', must be between 3~9");
                var c = (0, $b5f1e5e45355bfef$export$2e2bcd8739ae039)($0c49a6db3d03e2c7$export$2ad73d393c16f81c[e.scheme][e.size || 9]), s = function(e) {
                    return c(n(e));
                };
                return s.scale = c, s;
            }
        }
        throw new Error("Invalid colors, when using an object, you should either pass a 'datum' or a 'scheme' property");
    }
    return function() {
        return e;
    };
}, $0c49a6db3d03e2c7$export$47939777be1516f5 = function(e, r) {
    return (0, $exYeM.useMemo)(function() {
        return $0c49a6db3d03e2c7$export$c3ea10dbbf6bbab3(e, r);
    }, [
        e,
        r
    ]);
};



var $exYeM = parcelRequire("exYeM");
var $6169670cf62d658b$export$15925baccc9f07fd = function(e) {
    var i = e.x, n = e.y, o = e.size, r = e.fill, l = e.opacity, a = void 0 === l ? 1 : l, c = e.borderWidth, d = void 0 === c ? 0 : c, s = e.borderColor;
    return (0, $aSiaI.jsx)("circle", {
        r: o / 2,
        cx: i + o / 2,
        cy: n + o / 2,
        fill: r,
        opacity: a,
        strokeWidth: d,
        stroke: void 0 === s ? "transparent" : s,
        style: {
            pointerEvents: "none"
        }
    });
}, $6169670cf62d658b$export$b7efc3c73c701547 = function(e) {
    var i = e.x, n = e.y, o = e.size, r = e.fill, l = e.opacity, a = void 0 === l ? 1 : l, c = e.borderWidth, d = void 0 === c ? 0 : c, s = e.borderColor;
    return (0, $aSiaI.jsx)("g", {
        transform: "translate(" + i + "," + n + ")",
        children: (0, $aSiaI.jsx)("path", {
            d: "\n                    M" + o / 2 + " 0\n                    L" + .8 * o + " " + o / 2 + "\n                    L" + o / 2 + " " + o + "\n                    L" + .2 * o + " " + o / 2 + "\n                    L" + o / 2 + " 0\n                ",
            fill: r,
            opacity: a,
            strokeWidth: d,
            stroke: void 0 === s ? "transparent" : s,
            style: {
                pointerEvents: "none"
            }
        })
    });
}, $6169670cf62d658b$export$2a536501e4a376d8 = function(e) {
    var i = e.x, n = e.y, o = e.size, r = e.fill, l = e.opacity, a = void 0 === l ? 1 : l, c = e.borderWidth, d = void 0 === c ? 0 : c, s = e.borderColor;
    return (0, $aSiaI.jsx)("rect", {
        x: i,
        y: n,
        fill: r,
        opacity: a,
        strokeWidth: d,
        stroke: void 0 === s ? "transparent" : s,
        width: o,
        height: o,
        style: {
            pointerEvents: "none"
        }
    });
}, $6169670cf62d658b$export$57cb77afe634ca82 = function(e) {
    var i = e.x, n = e.y, o = e.size, r = e.fill, l = e.opacity, a = void 0 === l ? 1 : l, c = e.borderWidth, d = void 0 === c ? 0 : c, s = e.borderColor;
    return (0, $aSiaI.jsx)("g", {
        transform: "translate(" + i + "," + n + ")",
        children: (0, $aSiaI.jsx)("path", {
            d: "\n                M" + o / 2 + " 0\n                L" + o + " " + o + "\n                L0 " + o + "\n                L" + o / 2 + " 0\n            ",
            fill: r,
            opacity: a,
            strokeWidth: d,
            stroke: void 0 === s ? "transparent" : s,
            style: {
                pointerEvents: "none"
            }
        })
    });
};
function $6169670cf62d658b$var$p() {
    return $6169670cf62d658b$var$p = Object.assign ? Object.assign.bind() : function(t) {
        for(var e = 1; e < arguments.length; e++){
            var i = arguments[e];
            for(var n in i)Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
        }
        return t;
    }, $6169670cf62d658b$var$p.apply(this, arguments);
}
var $6169670cf62d658b$export$7dcc0eed76218746 = {
    length: 200,
    thickness: 16,
    direction: "row",
    tickPosition: "after",
    tickSize: 4,
    tickSpacing: 3,
    tickOverlap: !1,
    tickFormat: function(t) {
        return "" + t;
    },
    titleAlign: "start",
    titleOffset: 4
}, $6169670cf62d658b$var$k = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
}, $6169670cf62d658b$export$158851e184613239 = function(t) {
    var e, i = t.direction, n = t.itemsSpacing, o = t.padding, r = t.itemCount, l = t.itemWidth, a = t.itemHeight;
    if ("number" != typeof o && ("object" != typeof (e = o) || Array.isArray(e) || null === e)) throw new Error("Invalid property padding, must be one of: number, object");
    var c = "number" == typeof o ? {
        top: o,
        right: o,
        bottom: o,
        left: o
    } : $6169670cf62d658b$var$p({}, $6169670cf62d658b$var$k, o), d = c.left + c.right, s = c.top + c.bottom, h = l + d, g = a + s, f = (r - 1) * n;
    return "row" === i ? h = l * r + f + d : "column" === i && (g = a * r + f + s), {
        width: h,
        height: g,
        padding: c
    };
}, $6169670cf62d658b$export$d54b250266589d82 = function(t) {
    var e = t.anchor, i = t.translateX, n = t.translateY, o = t.containerWidth, r = t.containerHeight, l = t.width, a = t.height, c = i, d = n;
    switch(e){
        case "top":
            c += (o - l) / 2;
            break;
        case "top-right":
            c += o - l;
            break;
        case "right":
            c += o - l, d += (r - a) / 2;
            break;
        case "bottom-right":
            c += o - l, d += r - a;
            break;
        case "bottom":
            c += (o - l) / 2, d += r - a;
            break;
        case "bottom-left":
            d += r - a;
            break;
        case "left":
            d += (r - a) / 2;
            break;
        case "center":
            c += (o - l) / 2, d += (r - a) / 2;
    }
    return {
        x: c,
        y: d
    };
}, $6169670cf62d658b$export$42c02dc685323e86 = function(t) {
    var e, i, n, o, r, l, a = t.direction, c = t.justify, d = t.symbolSize, s = t.symbolSpacing, h = t.width, g = t.height;
    switch(a){
        case "left-to-right":
            e = 0, i = (g - d) / 2, o = g / 2, l = "central", c ? (n = h, r = "end") : (n = d + s, r = "start");
            break;
        case "right-to-left":
            e = h - d, i = (g - d) / 2, o = g / 2, l = "central", c ? (n = 0, r = "start") : (n = h - d - s, r = "end");
            break;
        case "top-to-bottom":
            e = (h - d) / 2, i = 0, n = h / 2, r = "middle", c ? (o = g, l = "alphabetic") : (o = d + s, l = "text-before-edge");
            break;
        case "bottom-to-top":
            e = (h - d) / 2, i = g - d, n = h / 2, r = "middle", c ? (o = 0, l = "text-before-edge") : (o = g - d - s, l = "alphabetic");
    }
    return {
        symbolX: e,
        symbolY: i,
        labelX: n,
        labelY: o,
        labelAnchor: r,
        labelAlignment: l
    };
}, $6169670cf62d658b$export$92bd5bd2fa4d30f9 = function(t) {
    var e, o = t.scale, r = t.ticks, l = t.length, c = void 0 === l ? $6169670cf62d658b$export$7dcc0eed76218746.length : l, d = t.thickness, s = void 0 === d ? $6169670cf62d658b$export$7dcc0eed76218746.thickness : d, h = t.direction, g = void 0 === h ? $6169670cf62d658b$export$7dcc0eed76218746.direction : h, f = t.tickPosition, m = void 0 === f ? $6169670cf62d658b$export$7dcc0eed76218746.tickPosition : f, v = t.tickSize, u = void 0 === v ? $6169670cf62d658b$export$7dcc0eed76218746.tickSize : v, p = t.tickSpacing, k = void 0 === p ? $6169670cf62d658b$export$7dcc0eed76218746.tickSpacing : p, x = t.tickOverlap, b = void 0 === x ? $6169670cf62d658b$export$7dcc0eed76218746.tickOverlap : x, S = t.tickFormat, A = void 0 === S ? $6169670cf62d658b$export$7dcc0eed76218746.tickFormat : S, W = t.title, z = t.titleAlign, C = void 0 === z ? $6169670cf62d658b$export$7dcc0eed76218746.titleAlign : z, w = t.titleOffset, X = void 0 === w ? $6169670cf62d658b$export$7dcc0eed76218746.titleOffset : w, Y = "column" === g ? [].concat(o.domain()).reverse() : o.domain(), O = (0, $200a922019157658$export$2e2bcd8739ae039)().domain(Y);
    2 === Y.length ? O.range([
        0,
        c
    ]) : 3 === Y.length && O.range([
        0,
        c / 2,
        c
    ]), e = "thresholds" in o ? [
        Y[0]
    ].concat(o.thresholds(), [
        Y[1]
    ]) : Array.isArray(r) ? r : o.ticks(r);
    var B, H, E, j, L, M, F = (0, $0c49a6db3d03e2c7$export$f6ca0f82846310a7)(o, 32), T = (0, $5c76f646ce642491$export$f037bf6aad5a4e75)(A), P = [], V = 0, R = 0;
    if ("row" === g) {
        var D, q, G;
        B = c, H = s, R = 1;
        var I;
        L = 0, E = "start" === C ? 0 : "middle" === C ? c / 2 : c, "before" === m ? (D = -u, q = b ? s : 0, G = -u - k, I = "alphabetic", j = s + X, M = "hanging") : (D = b ? 0 : s, G = (q = s + u) + k, I = "hanging", j = -X, M = "alphabetic"), e.forEach(function(t) {
            var e = O(t);
            P.push({
                x1: e,
                y1: D,
                x2: e,
                y2: q,
                text: T(t),
                textX: e,
                textY: G,
                textHorizontalAlign: "middle",
                textVerticalAlign: I
            });
        });
    } else {
        var N, _, J, K;
        B = s, H = c, V = 1;
        L = -90, j = "start" === C ? c : "middle" === C ? c / 2 : 0, "before" === m ? (_ = b ? s : 0, J = (N = -u) - k, K = "end", E = s + X, M = "hanging") : (N = b ? 0 : s, J = (_ = s + u) + k, K = "start", E = -X, M = "alphabetic"), e.forEach(function(t) {
            var e = O(t);
            P.push({
                x1: N,
                y1: e,
                x2: _,
                y2: e,
                text: T(t),
                textX: J,
                textY: e,
                textHorizontalAlign: K,
                textVerticalAlign: "central"
            });
        });
    }
    return {
        width: B,
        height: H,
        gradientX1: 0,
        gradientY1: V,
        gradientX2: R,
        gradientY2: 0,
        colorStops: F,
        ticks: P,
        titleText: W,
        titleX: E,
        titleY: j,
        titleRotation: L,
        titleHorizontalAlign: C,
        titleVerticalAlign: M
    };
}, $6169670cf62d658b$export$75a7f8b459abeba9 = function(i) {
    var n = i.scale, r = i.ticks, l = i.length, a = void 0 === l ? $6169670cf62d658b$export$7dcc0eed76218746.length : l, c = i.thickness, s = void 0 === c ? $6169670cf62d658b$export$7dcc0eed76218746.thickness : c, h = i.direction, g = void 0 === h ? $6169670cf62d658b$export$7dcc0eed76218746.direction : h, f = i.tickPosition, m = void 0 === f ? $6169670cf62d658b$export$7dcc0eed76218746.tickPosition : f, v = i.tickSize, u = void 0 === v ? $6169670cf62d658b$export$7dcc0eed76218746.tickSize : v, k = i.tickSpacing, x = void 0 === k ? $6169670cf62d658b$export$7dcc0eed76218746.tickSpacing : k, b = i.tickOverlap, S = void 0 === b ? $6169670cf62d658b$export$7dcc0eed76218746.tickOverlap : b, W = i.tickFormat, z = void 0 === W ? $6169670cf62d658b$export$7dcc0eed76218746.tickFormat : W, C = i.title, w = i.titleAlign, X = void 0 === w ? $6169670cf62d658b$export$7dcc0eed76218746.titleAlign : w, Y = i.titleOffset, O = $6169670cf62d658b$export$92bd5bd2fa4d30f9({
        scale: n,
        ticks: r,
        length: a,
        thickness: s,
        direction: g,
        tickPosition: m,
        tickSize: u,
        tickSpacing: x,
        tickOverlap: S,
        tickFormat: z,
        title: C,
        titleAlign: X,
        titleOffset: void 0 === Y ? $6169670cf62d658b$export$7dcc0eed76218746.titleOffset : Y
    }), B = O.width, H = O.height, E = O.gradientX1, j = O.gradientY1, L = O.gradientX2, M = O.gradientY2, F = O.ticks, T = O.colorStops, P = O.titleText, V = O.titleX, R = O.titleY, D = O.titleRotation, q = O.titleVerticalAlign, G = O.titleHorizontalAlign, I = (0, $5c76f646ce642491$export$93d4e7f90805808f)(), N = "ContinuousColorsLegendSvgGradient." + g + "." + T.map(function(t) {
        return t.offset;
    }).join("_");
    return (0, $aSiaI.jsxs)("g", {
        children: [
            (0, $aSiaI.jsx)("defs", {
                children: (0, $aSiaI.jsx)("linearGradient", {
                    id: N,
                    x1: E,
                    y1: j,
                    x2: L,
                    y2: M,
                    children: T.map(function(e) {
                        return (0, $aSiaI.jsx)("stop", $6169670cf62d658b$var$p({}, e));
                    })
                })
            }),
            P && (0, $aSiaI.jsx)("text", {
                transform: "translate(" + V + ", " + R + ") rotate(" + D + ")",
                textAnchor: G,
                dominantBaseline: q,
                style: I.legends.title.text,
                children: P
            }),
            (0, $aSiaI.jsx)("rect", {
                width: B,
                height: H,
                fill: "url(#" + N
            }),
            F.map(function(i, n) {
                return (0, $aSiaI.jsxs)((0, $exYeM.Fragment), {
                    children: [
                        (0, $aSiaI.jsx)("line", {
                            x1: i.x1,
                            y1: i.y1,
                            x2: i.x2,
                            y2: i.y2,
                            style: I.legends.ticks.line
                        }),
                        (0, $aSiaI.jsx)("text", {
                            x: i.textX,
                            y: i.textY,
                            textAnchor: i.textHorizontalAlign,
                            dominantBaseline: i.textVerticalAlign,
                            style: I.legends.ticks.text,
                            children: i.text
                        })
                    ]
                }, n);
            })
        ]
    });
}, $6169670cf62d658b$var$z = [
    "containerWidth",
    "containerHeight",
    "anchor",
    "translateX",
    "translateY",
    "length",
    "thickness",
    "direction"
], $6169670cf62d658b$export$b3a69bafe074dddd = function(e) {
    var i, n, o = e.containerWidth, r = e.containerHeight, l = e.anchor, a = e.translateX, c = void 0 === a ? 0 : a, d = e.translateY, s = void 0 === d ? 0 : d, h = e.length, g = void 0 === h ? $6169670cf62d658b$export$7dcc0eed76218746.length : h, f = e.thickness, m = void 0 === f ? $6169670cf62d658b$export$7dcc0eed76218746.thickness : f, v = e.direction, u = void 0 === v ? $6169670cf62d658b$export$7dcc0eed76218746.direction : v, k = function(t, e) {
        if (null == t) return {};
        var i, n, o = {}, r = Object.keys(t);
        for(n = 0; n < r.length; n++)i = r[n], e.indexOf(i) >= 0 || (o[i] = t[i]);
        return o;
    }(e, $6169670cf62d658b$var$z);
    "row" === u ? (i = g, n = m) : (i = m, n = g);
    var x = $6169670cf62d658b$export$d54b250266589d82({
        anchor: l,
        translateX: c,
        translateY: s,
        containerWidth: o,
        containerHeight: r,
        width: i,
        height: n
    }), S = x.x, A = x.y;
    return (0, $aSiaI.jsx)("g", {
        transform: "translate(" + S + ", " + A + ")",
        children: (0, $aSiaI.jsx)($6169670cf62d658b$export$75a7f8b459abeba9, $6169670cf62d658b$var$p({
            length: g,
            thickness: m,
            direction: u
        }, k))
    });
}, $6169670cf62d658b$var$w = {
    circle: $6169670cf62d658b$export$15925baccc9f07fd,
    diamond: $6169670cf62d658b$export$b7efc3c73c701547,
    square: $6169670cf62d658b$export$2a536501e4a376d8,
    triangle: $6169670cf62d658b$export$57cb77afe634ca82
}, $6169670cf62d658b$export$cfc3a318dc419256 = function(i) {
    var n, l, a, d, g, f, m, v, u, y, k, x = i.x, b = i.y, A = i.width, W = i.height, z = i.data, C = i.direction, X = void 0 === C ? "left-to-right" : C, Y = i.justify, O = void 0 !== Y && Y, B = i.textColor, H = i.background, E = void 0 === H ? "transparent" : H, j = i.opacity, L = void 0 === j ? 1 : j, M = i.symbolShape, F = void 0 === M ? "square" : M, T = i.symbolSize, P = void 0 === T ? 16 : T, V = i.symbolSpacing, R = void 0 === V ? 8 : V, D = i.symbolBorderWidth, q = void 0 === D ? 0 : D, G = i.symbolBorderColor, I = void 0 === G ? "transparent" : G, N = i.onClick, _ = i.onMouseEnter, J = i.onMouseLeave, K = i.toggleSerie, Q = i.effects, U = (0, $exYeM.useState)({}), Z = U[0], $ = U[1], tt = (0, $5c76f646ce642491$export$93d4e7f90805808f)(), et = (0, $exYeM.useCallback)(function(t) {
        if (Q) {
            var e = Q.filter(function(t) {
                return "hover" === t.on;
            }).reduce(function(t, e) {
                return $6169670cf62d658b$var$p({}, t, e.style);
            }, {});
            $(e);
        }
        null == _ || _(z, t);
    }, [
        _,
        z,
        Q
    ]), it = (0, $exYeM.useCallback)(function(t) {
        if (Q) {
            var e = Q.filter(function(t) {
                return "hover" !== t.on;
            }).reduce(function(t, e) {
                return $6169670cf62d658b$var$p({}, t, e.style);
            }, {});
            $(e);
        }
        null == J || J(z, t);
    }, [
        J,
        z,
        Q
    ]), nt = $6169670cf62d658b$export$42c02dc685323e86({
        direction: X,
        justify: O,
        symbolSize: null != (n = Z.symbolSize) ? n : P,
        symbolSpacing: R,
        width: A,
        height: W
    }), ot = nt.symbolX, rt = nt.symbolY, lt = nt.labelX, at = nt.labelY, ct = nt.labelAnchor, dt = nt.labelAlignment, st = [
        N,
        _,
        J,
        K
    ].some(function(t) {
        return void 0 !== t;
    }), ht = "function" == typeof F ? F : $6169670cf62d658b$var$w[F];
    return (0, $aSiaI.jsxs)("g", {
        transform: "translate(" + x + "," + b + ")",
        style: {
            opacity: null != (l = Z.itemOpacity) ? l : L
        },
        children: [
            (0, $aSiaI.jsx)("rect", {
                width: A,
                height: W,
                fill: null != (a = Z.itemBackground) ? a : E,
                style: {
                    cursor: st ? "pointer" : "auto"
                },
                onClick: function(t) {
                    null == N || N(z, t), null == K || K(z.id);
                },
                onMouseEnter: et,
                onMouseLeave: it
            }),
            $exYeM.createElement(ht, $6169670cf62d658b$var$p({
                id: z.id,
                x: ot,
                y: rt,
                size: null != (d = Z.symbolSize) ? d : P,
                fill: null != (g = null != (f = z.fill) ? f : z.color) ? g : "black",
                borderWidth: null != (m = Z.symbolBorderWidth) ? m : q,
                borderColor: null != (v = Z.symbolBorderColor) ? v : I
            }, z.hidden ? tt.legends.hidden.symbol : void 0)),
            (0, $aSiaI.jsx)("text", {
                textAnchor: ct,
                style: $6169670cf62d658b$var$p({}, (0, $5c76f646ce642491$export$c30625df7c8afdb5)(tt.legends.text), {
                    fill: null != (u = null != (y = null != (k = Z.itemTextColor) ? k : B) ? y : tt.legends.text.fill) ? u : "black",
                    dominantBaseline: dt,
                    pointerEvents: "none",
                    userSelect: "none"
                }, z.hidden ? tt.legends.hidden.text : void 0),
                x: lt,
                y: at,
                children: z.label
            })
        ]
    });
}, $6169670cf62d658b$export$31ce35324c7aa71 = function(e) {
    var i = e.data, n = e.x, o = e.y, r = e.direction, l = e.padding, a = void 0 === l ? 0 : l, c = e.justify, d = e.effects, s = e.itemWidth, h = e.itemHeight, g = e.itemDirection, f = void 0 === g ? "left-to-right" : g, m = e.itemsSpacing, v = void 0 === m ? 0 : m, u = e.itemTextColor, p = e.itemBackground, y = void 0 === p ? "transparent" : p, k = e.itemOpacity, b = void 0 === k ? 1 : k, S = e.symbolShape, A = e.symbolSize, W = e.symbolSpacing, z = e.symbolBorderWidth, C = e.symbolBorderColor, w = e.onClick, Y = e.onMouseEnter, O = e.onMouseLeave, B = e.toggleSerie, H = $6169670cf62d658b$export$158851e184613239({
        itemCount: i.length,
        itemWidth: s,
        itemHeight: h,
        itemsSpacing: v,
        direction: r,
        padding: a
    }).padding, E = "row" === r ? s + v : 0, j = "column" === r ? h + v : 0;
    return (0, $aSiaI.jsx)("g", {
        transform: "translate(" + n + "," + o + ")",
        children: i.map(function(e, i) {
            return (0, $aSiaI.jsx)($6169670cf62d658b$export$cfc3a318dc419256, {
                data: e,
                x: i * E + H.left,
                y: i * j + H.top,
                width: s,
                height: h,
                direction: f,
                justify: c,
                effects: d,
                textColor: u,
                background: y,
                opacity: b,
                symbolShape: S,
                symbolSize: A,
                symbolSpacing: W,
                symbolBorderWidth: z,
                symbolBorderColor: C,
                onClick: w,
                onMouseEnter: Y,
                onMouseLeave: O,
                toggleSerie: B
            }, i);
        })
    });
}, $6169670cf62d658b$export$238a2f791d4948f7 = function(e) {
    var i = e.data, n = e.containerWidth, o = e.containerHeight, r = e.translateX, l = void 0 === r ? 0 : r, a = e.translateY, c = void 0 === a ? 0 : a, d = e.anchor, s = e.direction, h = e.padding, g = void 0 === h ? 0 : h, f = e.justify, m = e.itemsSpacing, v = void 0 === m ? 0 : m, u = e.itemWidth, p = e.itemHeight, y = e.itemDirection, k = e.itemTextColor, S = e.itemBackground, A = e.itemOpacity, W = e.symbolShape, z = e.symbolSize, C = e.symbolSpacing, w = e.symbolBorderWidth, X = e.symbolBorderColor, O = e.onClick, B = e.onMouseEnter, H = e.onMouseLeave, E = e.toggleSerie, j = e.effects, L = $6169670cf62d658b$export$158851e184613239({
        itemCount: i.length,
        itemsSpacing: v,
        itemWidth: u,
        itemHeight: p,
        direction: s,
        padding: g
    }), M = L.width, F = L.height, T = $6169670cf62d658b$export$d54b250266589d82({
        anchor: d,
        translateX: l,
        translateY: c,
        containerWidth: n,
        containerHeight: o,
        width: M,
        height: F
    }), P = T.x, V = T.y;
    return (0, $aSiaI.jsx)($6169670cf62d658b$export$31ce35324c7aa71, {
        data: i,
        x: P,
        y: V,
        direction: s,
        padding: g,
        justify: f,
        effects: j,
        itemsSpacing: v,
        itemWidth: u,
        itemHeight: p,
        itemDirection: y,
        itemTextColor: k,
        itemBackground: S,
        itemOpacity: A,
        symbolShape: W,
        symbolSize: z,
        symbolSpacing: C,
        symbolBorderWidth: w,
        symbolBorderColor: X,
        onClick: O,
        onMouseEnter: B,
        onMouseLeave: H,
        toggleSerie: "boolean" == typeof E ? void 0 : E
    });
}, $6169670cf62d658b$var$B = {
    start: "left",
    middle: "center",
    end: "right"
}, $6169670cf62d658b$export$28c0156604402604 = function(t, e) {
    var i = e.data, n = e.containerWidth, o = e.containerHeight, r = e.translateX, l = void 0 === r ? 0 : r, a = e.translateY, c = void 0 === a ? 0 : a, d = e.anchor, s = e.direction, h = e.padding, g = void 0 === h ? 0 : h, f = e.justify, m = void 0 !== f && f, v = e.itemsSpacing, u = void 0 === v ? 0 : v, p = e.itemWidth, y = e.itemHeight, k = e.itemDirection, A = void 0 === k ? "left-to-right" : k, W = e.itemTextColor, z = e.symbolSize, C = void 0 === z ? 16 : z, w = e.symbolSpacing, X = void 0 === w ? 8 : w, Y = e.theme, O = $6169670cf62d658b$export$158851e184613239({
        itemCount: i.length,
        itemWidth: p,
        itemHeight: y,
        itemsSpacing: u,
        direction: s,
        padding: g
    }), H = O.width, E = O.height, j = O.padding, L = $6169670cf62d658b$export$d54b250266589d82({
        anchor: d,
        translateX: l,
        translateY: c,
        containerWidth: n,
        containerHeight: o,
        width: H,
        height: E
    }), M = L.x, F = L.y, T = "row" === s ? p + u : 0, P = "column" === s ? y + u : 0;
    t.save(), t.translate(M, F), t.font = Y.legends.text.fontSize + "px " + (Y.legends.text.fontFamily || "sans-serif"), i.forEach(function(e, i) {
        var n, o, r = i * T + j.left, l = i * P + j.top, a = $6169670cf62d658b$export$42c02dc685323e86({
            direction: A,
            justify: m,
            symbolSize: C,
            symbolSpacing: X,
            width: p,
            height: y
        }), c = a.symbolX, d = a.symbolY, s = a.labelX, h = a.labelY, g = a.labelAnchor, f = a.labelAlignment;
        t.fillStyle = null != (n = e.color) ? n : "black", t.fillRect(r + c, l + d, C, C), t.textAlign = $6169670cf62d658b$var$B[g], "central" === f && (t.textBaseline = "middle"), t.fillStyle = null != (o = null != W ? W : Y.legends.text.fill) ? o : "black", t.fillText(String(e.label), r + s, l + h);
    }), t.restore();
}, $6169670cf62d658b$export$d0f8bf7e3d86bbb5 = function(t, e) {
    var i = e.containerWidth, n = e.containerHeight, o = e.anchor, r = e.translateX, a = void 0 === r ? 0 : r, c = e.translateY, d = void 0 === c ? 0 : c, s = e.scale, h = e.length, g = void 0 === h ? $6169670cf62d658b$export$7dcc0eed76218746.length : h, f = e.thickness, m = void 0 === f ? $6169670cf62d658b$export$7dcc0eed76218746.thickness : f, v = e.direction, u = void 0 === v ? $6169670cf62d658b$export$7dcc0eed76218746.direction : v, p = e.ticks, k = e.tickPosition, x = void 0 === k ? $6169670cf62d658b$export$7dcc0eed76218746.tickPosition : k, S = e.tickSize, W = void 0 === S ? $6169670cf62d658b$export$7dcc0eed76218746.tickSize : S, z = e.tickSpacing, C = void 0 === z ? $6169670cf62d658b$export$7dcc0eed76218746.tickSpacing : z, w = e.tickOverlap, X = void 0 === w ? $6169670cf62d658b$export$7dcc0eed76218746.tickOverlap : w, Y = e.tickFormat, O = void 0 === Y ? $6169670cf62d658b$export$7dcc0eed76218746.tickFormat : Y, B = e.title, H = e.titleAlign, E = void 0 === H ? $6169670cf62d658b$export$7dcc0eed76218746.titleAlign : H, j = e.titleOffset, L = void 0 === j ? $6169670cf62d658b$export$7dcc0eed76218746.titleOffset : j, M = e.theme, F = $6169670cf62d658b$export$92bd5bd2fa4d30f9({
        scale: s,
        ticks: p,
        length: g,
        thickness: m,
        direction: u,
        tickPosition: x,
        tickSize: W,
        tickSpacing: C,
        tickOverlap: X,
        tickFormat: O,
        title: B,
        titleAlign: E,
        titleOffset: L
    }), T = F.width, P = F.height, V = F.gradientX1, R = F.gradientY1, D = F.gradientX2, q = F.gradientY2, G = F.colorStops, I = F.ticks, N = F.titleText, _ = F.titleX, J = F.titleY, K = F.titleRotation, Q = F.titleVerticalAlign, U = F.titleHorizontalAlign, Z = $6169670cf62d658b$export$d54b250266589d82({
        anchor: o,
        translateX: a,
        translateY: d,
        containerWidth: i,
        containerHeight: n,
        width: T,
        height: P
    }), $ = Z.x, tt = Z.y, et = {
        font: t.font,
        textAlign: t.textAlign,
        textBaseline: t.textBaseline
    };
    t.save(), t.translate($, tt);
    var it = t.createLinearGradient(V * T, R * P, D * T, q * P);
    G.forEach(function(t) {
        it.addColorStop(t.offset, t.stopColor);
    }), t.fillStyle = it, t.fillRect(0, 0, T, P), t.font = (M.legends.ticks.text.fontWeight ? M.legends.ticks.text.fontWeight + " " : "") + M.legends.ticks.text.fontSize + "px " + M.legends.ticks.text.fontFamily, I.forEach(function(e) {
        var i;
        (null != (i = M.legends.ticks.line.strokeWidth) ? i : 0) > 0 && (t.lineWidth = Number(M.axis.ticks.line.strokeWidth), M.axis.ticks.line.stroke && (t.strokeStyle = M.axis.ticks.line.stroke), t.lineCap = "square", t.beginPath(), t.moveTo(e.x1, e.y1), t.lineTo(e.x2, e.y2), t.stroke()), M.legends.ticks.text.fill && (t.fillStyle = M.legends.ticks.text.fill), t.textAlign = "middle" === e.textHorizontalAlign ? "center" : e.textHorizontalAlign, t.textBaseline = "central" === e.textVerticalAlign ? "middle" : e.textVerticalAlign, t.fillText(e.text, e.textX, e.textY);
    }), N && (t.save(), t.translate(_, J), t.rotate((0, $5c76f646ce642491$export$c9fcf1a7df975d78)(K)), t.font = (M.legends.title.text.fontWeight ? M.legends.title.text.fontWeight + " " : "") + M.legends.title.text.fontSize + "px " + M.legends.title.text.fontFamily, M.legends.title.text.fill && (t.fillStyle = M.legends.title.text.fill), t.textAlign = "middle" === U ? "center" : U, t.textBaseline = Q, t.fillText(N, 0, 0), t.restore()), t.restore(), t.font = et.font, t.textAlign = et.textAlign, t.textBaseline = et.textBaseline;
}, $6169670cf62d658b$export$419bf2ab46804c4 = function(t) {
    var e = t.scale, i = t.domain, n = t.reverse, o = void 0 !== n && n, r = t.valueFormat, l = void 0 === r ? function(t) {
        return t;
    } : r, a = t.separator, c = void 0 === a ? " - " : a;
    return (0, $exYeM.useMemo)(function() {
        var t = (null != i ? i : e.range()).map(function(t, i) {
            var n = e.invertExtent(t), o = n[0], r = n[1];
            return {
                id: t,
                index: i,
                extent: [
                    o,
                    r
                ],
                label: "" + l(o) + c + l(r),
                value: e(o),
                color: t
            };
        });
        return o && t.reverse(), t;
    }, [
        i,
        e,
        o,
        c,
        l
    ]);
};





var $exYeM = parcelRequire("exYeM");
var $2d94249f93fc6185$exports = {};

var $f9c024cb377b8a0f$exports = {};

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $f9c024cb377b8a0f$var$baseFilter(collection, predicate) {
    var result = [];
    $eb9d77a605684a7d$exports(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
$f9c024cb377b8a0f$exports = $f9c024cb377b8a0f$var$baseFilter;




/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $2d94249f93fc6185$var$filter(collection, predicate) {
    var func = $8cb3ae215df00a00$exports(collection) ? $68bbccdd4a21a80e$exports : $f9c024cb377b8a0f$exports;
    return func(collection, $52849359d0c345c9$exports(predicate, 3));
}
$2d94249f93fc6185$exports = $2d94249f93fc6185$var$filter;


var $c60c740f28e51d85$exports = {};


/** `Object#toString` result references. */ var $c60c740f28e51d85$var$numberTag = "[object Number]";
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $c60c740f28e51d85$var$isNumber(value) {
    return typeof value == "number" || $5475ba594a8bdf91$exports(value) && $852d1f971b259156$exports(value) == $c60c740f28e51d85$var$numberTag;
}
$c60c740f28e51d85$exports = $c60c740f28e51d85$var$isNumber;


var $e83ed8bccf07644d$exports = {};

var $8d55860d9ee8b98c$exports = {};

var $e883f280c82ab4ba$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $e883f280c82ab4ba$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$e883f280c82ab4ba$exports = $e883f280c82ab4ba$var$arrayEach;



var $2ce1a18ea44c4deb$exports = {};


/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $2ce1a18ea44c4deb$var$baseAssign(object, source) {
    return object && $31c6b882f05692c6$exports(source, $b104760b34d6b7b1$exports(source), object);
}
$2ce1a18ea44c4deb$exports = $2ce1a18ea44c4deb$var$baseAssign;


var $2f9edf92839feaff$exports = {};


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $2f9edf92839feaff$var$baseAssignIn(object, source) {
    return object && $31c6b882f05692c6$exports(source, $9db77247add89d2e$exports(source), object);
}
$2f9edf92839feaff$exports = $2f9edf92839feaff$var$baseAssignIn;



var $4vs1M = parcelRequire("4vs1M");

var $f8d658d15a2edcd4$exports = {};


/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $f8d658d15a2edcd4$var$copySymbols(source, object) {
    return $31c6b882f05692c6$exports(source, $0eabf8f27c57cf11$exports(source), object);
}
$f8d658d15a2edcd4$exports = $f8d658d15a2edcd4$var$copySymbols;


var $928edd92858e1662$exports = {};

var $d5293e6fa7b2b339$exports = {};




/* Built-in method references for those with the same name as other `lodash` methods. */ var $d5293e6fa7b2b339$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $d5293e6fa7b2b339$var$getSymbolsIn = !$d5293e6fa7b2b339$var$nativeGetSymbols ? $11b31dfc90d4eeeb$exports : function(object) {
    var result = [];
    while(object){
        $3fc9dba05ba16d53$exports(result, $0eabf8f27c57cf11$exports(object));
        object = $7a9433312306cf5b$exports(object);
    }
    return result;
};
$d5293e6fa7b2b339$exports = $d5293e6fa7b2b339$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $928edd92858e1662$var$copySymbolsIn(source, object) {
    return $31c6b882f05692c6$exports(source, $d5293e6fa7b2b339$exports(source), object);
}
$928edd92858e1662$exports = $928edd92858e1662$var$copySymbolsIn;



var $ddc827b5ca2f5f3f$exports = {};



/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $ddc827b5ca2f5f3f$var$getAllKeysIn(object) {
    return $9d3e3231281d182b$exports(object, $9db77247add89d2e$exports, $d5293e6fa7b2b339$exports);
}
$ddc827b5ca2f5f3f$exports = $ddc827b5ca2f5f3f$var$getAllKeysIn;



var $7d0a900e76da2d15$exports = {};
/** Used for built-in method references. */ var $7d0a900e76da2d15$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0a900e76da2d15$var$hasOwnProperty = $7d0a900e76da2d15$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $7d0a900e76da2d15$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $7d0a900e76da2d15$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
$7d0a900e76da2d15$exports = $7d0a900e76da2d15$var$initCloneArray;


var $b5e8347885b983a5$exports = {};

var $ae5e74912e4ee32e$exports = {};

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $ae5e74912e4ee32e$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $7ab071444f25f0fd$exports(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
$ae5e74912e4ee32e$exports = $ae5e74912e4ee32e$var$cloneDataView;


var $bb1b70f977046c2d$exports = {};
/** Used to match `RegExp` flags from their coerced string values. */ var $bb1b70f977046c2d$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $bb1b70f977046c2d$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $bb1b70f977046c2d$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
$bb1b70f977046c2d$exports = $bb1b70f977046c2d$var$cloneRegExp;


var $2974eb792905b227$exports = {};

/** Used to convert symbols to primitives and strings. */ var $2974eb792905b227$var$symbolProto = $a090581360ce8173$exports ? $a090581360ce8173$exports.prototype : undefined, $2974eb792905b227$var$symbolValueOf = $2974eb792905b227$var$symbolProto ? $2974eb792905b227$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $2974eb792905b227$var$cloneSymbol(symbol) {
    return $2974eb792905b227$var$symbolValueOf ? Object($2974eb792905b227$var$symbolValueOf.call(symbol)) : {};
}
$2974eb792905b227$exports = $2974eb792905b227$var$cloneSymbol;



/** `Object#toString` result references. */ var $b5e8347885b983a5$var$boolTag = "[object Boolean]", $b5e8347885b983a5$var$dateTag = "[object Date]", $b5e8347885b983a5$var$mapTag = "[object Map]", $b5e8347885b983a5$var$numberTag = "[object Number]", $b5e8347885b983a5$var$regexpTag = "[object RegExp]", $b5e8347885b983a5$var$setTag = "[object Set]", $b5e8347885b983a5$var$stringTag = "[object String]", $b5e8347885b983a5$var$symbolTag = "[object Symbol]";
var $b5e8347885b983a5$var$arrayBufferTag = "[object ArrayBuffer]", $b5e8347885b983a5$var$dataViewTag = "[object DataView]", $b5e8347885b983a5$var$float32Tag = "[object Float32Array]", $b5e8347885b983a5$var$float64Tag = "[object Float64Array]", $b5e8347885b983a5$var$int8Tag = "[object Int8Array]", $b5e8347885b983a5$var$int16Tag = "[object Int16Array]", $b5e8347885b983a5$var$int32Tag = "[object Int32Array]", $b5e8347885b983a5$var$uint8Tag = "[object Uint8Array]", $b5e8347885b983a5$var$uint8ClampedTag = "[object Uint8ClampedArray]", $b5e8347885b983a5$var$uint16Tag = "[object Uint16Array]", $b5e8347885b983a5$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $b5e8347885b983a5$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $b5e8347885b983a5$var$arrayBufferTag:
            return $7ab071444f25f0fd$exports(object);
        case $b5e8347885b983a5$var$boolTag:
        case $b5e8347885b983a5$var$dateTag:
            return new Ctor(+object);
        case $b5e8347885b983a5$var$dataViewTag:
            return $ae5e74912e4ee32e$exports(object, isDeep);
        case $b5e8347885b983a5$var$float32Tag:
        case $b5e8347885b983a5$var$float64Tag:
        case $b5e8347885b983a5$var$int8Tag:
        case $b5e8347885b983a5$var$int16Tag:
        case $b5e8347885b983a5$var$int32Tag:
        case $b5e8347885b983a5$var$uint8Tag:
        case $b5e8347885b983a5$var$uint8ClampedTag:
        case $b5e8347885b983a5$var$uint16Tag:
        case $b5e8347885b983a5$var$uint32Tag:
            return $265d56dce3afa249$exports(object, isDeep);
        case $b5e8347885b983a5$var$mapTag:
            return new Ctor;
        case $b5e8347885b983a5$var$numberTag:
        case $b5e8347885b983a5$var$stringTag:
            return new Ctor(object);
        case $b5e8347885b983a5$var$regexpTag:
            return $bb1b70f977046c2d$exports(object);
        case $b5e8347885b983a5$var$setTag:
            return new Ctor;
        case $b5e8347885b983a5$var$symbolTag:
            return $2974eb792905b227$exports(object);
    }
}
$b5e8347885b983a5$exports = $b5e8347885b983a5$var$initCloneByTag;





var $7HKs8 = parcelRequire("7HKs8");
var $eaa21bf4e287fd7f$exports = {};
var $334fb66d416be2f0$exports = {};


/** `Object#toString` result references. */ var $334fb66d416be2f0$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $334fb66d416be2f0$var$baseIsMap(value) {
    return $5475ba594a8bdf91$exports(value) && $e16b2168665de4fd$exports(value) == $334fb66d416be2f0$var$mapTag;
}
$334fb66d416be2f0$exports = $334fb66d416be2f0$var$baseIsMap;




var $7vc1R = parcelRequire("7vc1R");
/* Node.js helper references. */ var $eaa21bf4e287fd7f$var$nodeIsMap = $7vc1R && $7vc1R.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $eaa21bf4e287fd7f$var$isMap = $eaa21bf4e287fd7f$var$nodeIsMap ? $a37b20fb7156577b$exports($eaa21bf4e287fd7f$var$nodeIsMap) : $334fb66d416be2f0$exports;
$eaa21bf4e287fd7f$exports = $eaa21bf4e287fd7f$var$isMap;



var $10f055afd4d7cf22$exports = {};
var $01afc3bfd7071a26$exports = {};


/** `Object#toString` result references. */ var $01afc3bfd7071a26$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $01afc3bfd7071a26$var$baseIsSet(value) {
    return $5475ba594a8bdf91$exports(value) && $e16b2168665de4fd$exports(value) == $01afc3bfd7071a26$var$setTag;
}
$01afc3bfd7071a26$exports = $01afc3bfd7071a26$var$baseIsSet;




var $7vc1R = parcelRequire("7vc1R");
/* Node.js helper references. */ var $10f055afd4d7cf22$var$nodeIsSet = $7vc1R && $7vc1R.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $10f055afd4d7cf22$var$isSet = $10f055afd4d7cf22$var$nodeIsSet ? $a37b20fb7156577b$exports($10f055afd4d7cf22$var$nodeIsSet) : $01afc3bfd7071a26$exports;
$10f055afd4d7cf22$exports = $10f055afd4d7cf22$var$isSet;




/** Used to compose bitmasks for cloning. */ var $8d55860d9ee8b98c$var$CLONE_DEEP_FLAG = 1, $8d55860d9ee8b98c$var$CLONE_FLAT_FLAG = 2, $8d55860d9ee8b98c$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $8d55860d9ee8b98c$var$argsTag = "[object Arguments]", $8d55860d9ee8b98c$var$arrayTag = "[object Array]", $8d55860d9ee8b98c$var$boolTag = "[object Boolean]", $8d55860d9ee8b98c$var$dateTag = "[object Date]", $8d55860d9ee8b98c$var$errorTag = "[object Error]", $8d55860d9ee8b98c$var$funcTag = "[object Function]", $8d55860d9ee8b98c$var$genTag = "[object GeneratorFunction]", $8d55860d9ee8b98c$var$mapTag = "[object Map]", $8d55860d9ee8b98c$var$numberTag = "[object Number]", $8d55860d9ee8b98c$var$objectTag = "[object Object]", $8d55860d9ee8b98c$var$regexpTag = "[object RegExp]", $8d55860d9ee8b98c$var$setTag = "[object Set]", $8d55860d9ee8b98c$var$stringTag = "[object String]", $8d55860d9ee8b98c$var$symbolTag = "[object Symbol]", $8d55860d9ee8b98c$var$weakMapTag = "[object WeakMap]";
var $8d55860d9ee8b98c$var$arrayBufferTag = "[object ArrayBuffer]", $8d55860d9ee8b98c$var$dataViewTag = "[object DataView]", $8d55860d9ee8b98c$var$float32Tag = "[object Float32Array]", $8d55860d9ee8b98c$var$float64Tag = "[object Float64Array]", $8d55860d9ee8b98c$var$int8Tag = "[object Int8Array]", $8d55860d9ee8b98c$var$int16Tag = "[object Int16Array]", $8d55860d9ee8b98c$var$int32Tag = "[object Int32Array]", $8d55860d9ee8b98c$var$uint8Tag = "[object Uint8Array]", $8d55860d9ee8b98c$var$uint8ClampedTag = "[object Uint8ClampedArray]", $8d55860d9ee8b98c$var$uint16Tag = "[object Uint16Array]", $8d55860d9ee8b98c$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $8d55860d9ee8b98c$var$cloneableTags = {};
$8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$argsTag] = $8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$arrayTag] = $8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$arrayBufferTag] = $8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$dataViewTag] = $8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$boolTag] = $8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$dateTag] = $8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$float32Tag] = $8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$float64Tag] = $8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$int8Tag] = $8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$int16Tag] = $8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$int32Tag] = $8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$mapTag] = $8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$numberTag] = $8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$objectTag] = $8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$regexpTag] = $8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$setTag] = $8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$stringTag] = $8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$symbolTag] = $8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$uint8Tag] = $8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$uint8ClampedTag] = $8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$uint16Tag] = $8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$uint32Tag] = true;
$8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$errorTag] = $8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$funcTag] = $8d55860d9ee8b98c$var$cloneableTags[$8d55860d9ee8b98c$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $8d55860d9ee8b98c$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $8d55860d9ee8b98c$var$CLONE_DEEP_FLAG, isFlat = bitmask & $8d55860d9ee8b98c$var$CLONE_FLAT_FLAG, isFull = bitmask & $8d55860d9ee8b98c$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$db5dfd0661742a1a$exports(value)) return value;
    var isArr = $8cb3ae215df00a00$exports(value);
    if (isArr) {
        result = $7d0a900e76da2d15$exports(value);
        if (!isDeep) return $cf08566b5f17aa4f$exports(value, result);
    } else {
        var tag = $e16b2168665de4fd$exports(value), isFunc = tag == $8d55860d9ee8b98c$var$funcTag || tag == $8d55860d9ee8b98c$var$genTag;
        if ($7HKs8(value)) return $4vs1M(value, isDeep);
        if (tag == $8d55860d9ee8b98c$var$objectTag || tag == $8d55860d9ee8b98c$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $cdfd1eab1ed286bf$exports(value);
            if (!isDeep) return isFlat ? $928edd92858e1662$exports(value, $2f9edf92839feaff$exports(result, value)) : $f8d658d15a2edcd4$exports(value, $2ce1a18ea44c4deb$exports(result, value));
        } else {
            if (!$8d55860d9ee8b98c$var$cloneableTags[tag]) return object ? value : {};
            result = $b5e8347885b983a5$exports(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $8bfbce7e35b86105$exports);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($10f055afd4d7cf22$exports(value)) value.forEach(function(subValue) {
        result.add($8d55860d9ee8b98c$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($eaa21bf4e287fd7f$exports(value)) value.forEach(function(subValue, key) {
        result.set(key, $8d55860d9ee8b98c$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $ddc827b5ca2f5f3f$exports : $860bb4b6843d7563$exports : isFlat ? $9db77247add89d2e$exports : $b104760b34d6b7b1$exports;
    var props = isArr ? undefined : keysFunc(value);
    $e883f280c82ab4ba$exports(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $6a410827939ce210$exports(result, key, $8d55860d9ee8b98c$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
$8d55860d9ee8b98c$exports = $8d55860d9ee8b98c$var$baseClone;


var $4957763b8855db45$exports = {};


var $ac1056eee5b4047d$exports = {};

var $da0774c3bb29a696$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $da0774c3bb29a696$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$da0774c3bb29a696$exports = $da0774c3bb29a696$var$baseSlice;


/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $ac1056eee5b4047d$var$parent(object, path) {
    return path.length < 2 ? object : $01f8d472cea3b7ad$exports(object, $da0774c3bb29a696$exports(path, 0, -1));
}
$ac1056eee5b4047d$exports = $ac1056eee5b4047d$var$parent;



/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $4957763b8855db45$var$baseUnset(object, path) {
    path = $026916563a5fc8ad$exports(path, object);
    object = $ac1056eee5b4047d$exports(object, path);
    return object == null || delete object[$e56d6cac75d4b6e0$exports($37b3ad643dcadb8d$exports(path))];
}
$4957763b8855db45$exports = $4957763b8855db45$var$baseUnset;




var $58c774b88ce69e29$exports = {};

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $58c774b88ce69e29$var$customOmitClone(value) {
    return $58f2645d8a82ddb4$exports(value) ? undefined : value;
}
$58c774b88ce69e29$exports = $58c774b88ce69e29$var$customOmitClone;




/** Used to compose bitmasks for cloning. */ var $e83ed8bccf07644d$var$CLONE_DEEP_FLAG = 1, $e83ed8bccf07644d$var$CLONE_FLAT_FLAG = 2, $e83ed8bccf07644d$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $e83ed8bccf07644d$var$omit = $775d6f4a2b89e18d$exports(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $c0d7b47ee8b12bf1$exports(paths, function(path) {
        path = $026916563a5fc8ad$exports(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $31c6b882f05692c6$exports(object, $ddc827b5ca2f5f3f$exports(object), result);
    if (isDeep) result = $8d55860d9ee8b98c$exports(result, $e83ed8bccf07644d$var$CLONE_DEEP_FLAG | $e83ed8bccf07644d$var$CLONE_FLAT_FLAG | $e83ed8bccf07644d$var$CLONE_SYMBOLS_FLAG, $58c774b88ce69e29$exports);
    var length = paths.length;
    while(length--)$4957763b8855db45$exports(result, paths[length]);
    return result;
});
$e83ed8bccf07644d$exports = $e83ed8bccf07644d$var$omit;





var $aSiaI = parcelRequire("aSiaI");
function $8bd79e61a95b6697$var$g() {
    return $8bd79e61a95b6697$var$g = Object.assign ? Object.assign.bind() : function(t) {
        for(var n = 1; n < arguments.length; n++){
            var i = arguments[n];
            for(var o in i)Object.prototype.hasOwnProperty.call(i, o) && (t[o] = i[o]);
        }
        return t;
    }, $8bd79e61a95b6697$var$g.apply(this, arguments);
}
var $8bd79e61a95b6697$export$9c21a3269931e1e6 = {
    dotSize: 4,
    noteWidth: 120,
    noteTextOffset: 8,
    animate: !0
}, $8bd79e61a95b6697$export$b752e15d208daa11 = function(n) {
    var i = typeof n;
    return (0, $exYeM.isValidElement)(n) || "string" === i || "function" === i || "object" === i;
}, $8bd79e61a95b6697$export$ec43ae0bd4891d2c = function(t) {
    var n = typeof t;
    return "string" === n || "function" === n;
}, $8bd79e61a95b6697$export$394411129f5b3217 = function(t) {
    return "circle" === t.type;
}, $8bd79e61a95b6697$export$42c56693a07b2355 = function(t) {
    return "dot" === t.type;
}, $8bd79e61a95b6697$export$3d983e5b537acf00 = function(t) {
    return "rect" === t.type;
}, $8bd79e61a95b6697$export$3fdd15c76e321976 = function(t) {
    var n = t.data, i = t.annotations, e = t.getPosition, r = t.getDimensions;
    return i.reduce(function(t, i) {
        var s = i.offset || 0;
        return [].concat(t, (0, (/*@__PURE__*/$parcel$interopDefault($2d94249f93fc6185$exports)))(n, i.match).map(function(t) {
            var n = e(t), o = r(t);
            return ($8bd79e61a95b6697$export$394411129f5b3217(i) || $8bd79e61a95b6697$export$3d983e5b537acf00(i)) && (o.size = o.size + 2 * s, o.width = o.width + 2 * s, o.height = o.height + 2 * s), $8bd79e61a95b6697$var$g({}, (0, (/*@__PURE__*/$parcel$interopDefault($e83ed8bccf07644d$exports)))(i, [
                "match",
                "offset"
            ]), n, o, {
                size: i.size || o.size,
                datum: t
            });
        }));
    }, []);
}, $8bd79e61a95b6697$export$6b6253c1fb6a326 = function(t, n, i, o) {
    var e = Math.atan2(o - n, i - t);
    return (0, $5c76f646ce642491$export$c2f0a4925e526958)((0, $5c76f646ce642491$export$c41dd2a8460d3196)(e));
}, $8bd79e61a95b6697$export$4268c10ab17f5aad = function(t) {
    var n, i, o = t.x, a = t.y, r = t.noteX, s = t.noteY, h = t.noteWidth, d = void 0 === h ? $8bd79e61a95b6697$export$9c21a3269931e1e6.noteWidth : h, c = t.noteTextOffset, f = void 0 === c ? $8bd79e61a95b6697$export$9c21a3269931e1e6.noteTextOffset : c;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($c60c740f28e51d85$exports)))(r)) n = o + r;
    else {
        if (void 0 === r.abs) throw new Error("noteX should be either a number or an object containing an 'abs' property");
        n = r.abs;
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($c60c740f28e51d85$exports)))(s)) i = a + s;
    else {
        if (void 0 === s.abs) throw new Error("noteY should be either a number or an object containing an 'abs' property");
        i = s.abs;
    }
    var y = o, x = a, m = $8bd79e61a95b6697$export$6b6253c1fb6a326(o, a, n, i);
    if ($8bd79e61a95b6697$export$394411129f5b3217(t)) {
        var p = (0, $5c76f646ce642491$export$2e16b01652730550)((0, $5c76f646ce642491$export$c9fcf1a7df975d78)(m), t.size / 2);
        y += p.x, x += p.y;
    }
    if ($8bd79e61a95b6697$export$3d983e5b537acf00(t)) {
        var g = Math.round((m + 90) / 45) % 8;
        0 === g && (x -= t.height / 2), 1 === g && (y += t.width / 2, x -= t.height / 2), 2 === g && (y += t.width / 2), 3 === g && (y += t.width / 2, x += t.height / 2), 4 === g && (x += t.height / 2), 5 === g && (y -= t.width / 2, x += t.height / 2), 6 === g && (y -= t.width / 2), 7 === g && (y -= t.width / 2, x -= t.height / 2);
    }
    var W = n, v = n;
    return (m + 90) % 360 > 180 ? (W -= d, v -= d) : v += d, {
        points: [
            [
                y,
                x
            ],
            [
                n,
                i
            ],
            [
                v,
                i
            ]
        ],
        text: [
            W,
            i - f
        ],
        angle: m + 90
    };
}, $8bd79e61a95b6697$export$ede9be424e8ef89a = function(t) {
    var i = t.data, o = t.annotations, e = t.getPosition, a = t.getDimensions;
    return (0, $exYeM.useMemo)(function() {
        return $8bd79e61a95b6697$export$3fdd15c76e321976({
            data: i,
            annotations: o,
            getPosition: e,
            getDimensions: a
        });
    }, [
        i,
        o,
        e,
        a
    ]);
}, $8bd79e61a95b6697$export$c11be6015db56468 = function(t) {
    var i = t.annotations;
    return (0, $exYeM.useMemo)(function() {
        return i.map(function(t) {
            return $8bd79e61a95b6697$var$g({}, t, {
                computed: $8bd79e61a95b6697$export$4268c10ab17f5aad($8bd79e61a95b6697$var$g({}, t))
            });
        });
    }, [
        i
    ]);
}, $8bd79e61a95b6697$export$c1818d27abb74e50 = function(t) {
    return (0, $exYeM.useMemo)(function() {
        return $8bd79e61a95b6697$export$4268c10ab17f5aad(t);
    }, [
        t
    ]);
}, $8bd79e61a95b6697$var$T = function(t) {
    var n = t.datum, o = t.x, e = t.y, r = t.note, s = (0, $5c76f646ce642491$export$93d4e7f90805808f)(), l = (0, $5c76f646ce642491$export$72acc3dc9629d75d)(), u = l.animate, c = l.config, k = (0, $9f726edb03f4840c$export$c4af9125706c4d30)({
        x: o,
        y: e,
        config: c,
        immediate: !u
    });
    return "function" == typeof r ? (0, $exYeM.createElement)(r, {
        x: o,
        y: e,
        datum: n
    }) : (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            s.annotations.text.outlineWidth > 0 && (0, $aSiaI.jsx)((0, $f9aea5876333360d$export$407448d2b89b1813).text, {
                x: k.x,
                y: k.y,
                style: $8bd79e61a95b6697$var$g({}, s.annotations.text, {
                    strokeLinejoin: "round",
                    strokeWidth: 2 * s.annotations.text.outlineWidth,
                    stroke: s.annotations.text.outlineColor
                }),
                children: r
            }),
            (0, $aSiaI.jsx)((0, $f9aea5876333360d$export$407448d2b89b1813).text, {
                x: k.x,
                y: k.y,
                style: (0, (/*@__PURE__*/$parcel$interopDefault($e83ed8bccf07644d$exports)))(s.annotations.text, [
                    "outlineWidth",
                    "outlineColor"
                ]),
                children: r
            })
        ]
    });
}, $8bd79e61a95b6697$var$E = function(t) {
    var i = t.points, o = t.isOutline, e = void 0 !== o && o, a = (0, $5c76f646ce642491$export$93d4e7f90805808f)(), r = (0, $exYeM.useMemo)(function() {
        var t = i[0];
        return i.slice(1).reduce(function(t, n) {
            return t + " L" + n[0] + "," + n[1];
        }, "M" + t[0] + "," + t[1]);
    }, [
        i
    ]), s = (0, $5c76f646ce642491$export$6b8391a1442f2172)(r);
    if (e && a.annotations.link.outlineWidth <= 0) return null;
    var l = $8bd79e61a95b6697$var$g({}, a.annotations.link);
    return e && (l.strokeLinecap = "square", l.strokeWidth = a.annotations.link.strokeWidth + 2 * a.annotations.link.outlineWidth, l.stroke = a.annotations.link.outlineColor, l.opacity = a.annotations.link.outlineOpacity), (0, $aSiaI.jsx)((0, $f9aea5876333360d$export$407448d2b89b1813).path, {
        fill: "none",
        d: s,
        style: l
    });
}, $8bd79e61a95b6697$var$I = function(t) {
    var n = t.x, i = t.y, o = t.size, e = (0, $5c76f646ce642491$export$93d4e7f90805808f)(), a = (0, $5c76f646ce642491$export$72acc3dc9629d75d)(), r = a.animate, s = a.config, l = (0, $9f726edb03f4840c$export$c4af9125706c4d30)({
        x: n,
        y: i,
        radius: o / 2,
        config: s,
        immediate: !r
    });
    return (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            e.annotations.outline.outlineWidth > 0 && (0, $aSiaI.jsx)((0, $f9aea5876333360d$export$407448d2b89b1813).circle, {
                cx: l.x,
                cy: l.y,
                r: l.radius,
                style: $8bd79e61a95b6697$var$g({}, e.annotations.outline, {
                    fill: "none",
                    strokeWidth: e.annotations.outline.strokeWidth + 2 * e.annotations.outline.outlineWidth,
                    stroke: e.annotations.outline.outlineColor,
                    opacity: e.annotations.outline.outlineOpacity
                })
            }),
            (0, $aSiaI.jsx)((0, $f9aea5876333360d$export$407448d2b89b1813).circle, {
                cx: l.x,
                cy: l.y,
                r: l.radius,
                style: e.annotations.outline
            })
        ]
    });
}, $8bd79e61a95b6697$var$D = function(t) {
    var n = t.x, i = t.y, o = t.size, e = void 0 === o ? $8bd79e61a95b6697$export$9c21a3269931e1e6.dotSize : o, a = (0, $5c76f646ce642491$export$93d4e7f90805808f)(), r = (0, $5c76f646ce642491$export$72acc3dc9629d75d)(), s = r.animate, l = r.config, u = (0, $9f726edb03f4840c$export$c4af9125706c4d30)({
        x: n,
        y: i,
        radius: e / 2,
        config: l,
        immediate: !s
    });
    return (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            a.annotations.outline.outlineWidth > 0 && (0, $aSiaI.jsx)((0, $f9aea5876333360d$export$407448d2b89b1813).circle, {
                cx: u.x,
                cy: u.y,
                r: u.radius,
                style: $8bd79e61a95b6697$var$g({}, a.annotations.outline, {
                    fill: "none",
                    strokeWidth: 2 * a.annotations.outline.outlineWidth,
                    stroke: a.annotations.outline.outlineColor,
                    opacity: a.annotations.outline.outlineOpacity
                })
            }),
            (0, $aSiaI.jsx)((0, $f9aea5876333360d$export$407448d2b89b1813).circle, {
                cx: u.x,
                cy: u.y,
                r: u.radius,
                style: a.annotations.symbol
            })
        ]
    });
}, $8bd79e61a95b6697$var$L = function(t) {
    var n = t.x, i = t.y, o = t.width, e = t.height, a = t.borderRadius, r = void 0 === a ? 6 : a, s = (0, $5c76f646ce642491$export$93d4e7f90805808f)(), l = (0, $5c76f646ce642491$export$72acc3dc9629d75d)(), u = l.animate, c = l.config, k = (0, $9f726edb03f4840c$export$c4af9125706c4d30)({
        x: n - o / 2,
        y: i - e / 2,
        width: o,
        height: e,
        config: c,
        immediate: !u
    });
    return (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            s.annotations.outline.outlineWidth > 0 && (0, $aSiaI.jsx)((0, $f9aea5876333360d$export$407448d2b89b1813).rect, {
                x: k.x,
                y: k.y,
                rx: r,
                ry: r,
                width: k.width,
                height: k.height,
                style: $8bd79e61a95b6697$var$g({}, s.annotations.outline, {
                    fill: "none",
                    strokeWidth: s.annotations.outline.strokeWidth + 2 * s.annotations.outline.outlineWidth,
                    stroke: s.annotations.outline.outlineColor,
                    opacity: s.annotations.outline.outlineOpacity
                })
            }),
            (0, $aSiaI.jsx)((0, $f9aea5876333360d$export$407448d2b89b1813).rect, {
                x: k.x,
                y: k.y,
                rx: r,
                ry: r,
                width: k.width,
                height: k.height,
                style: s.annotations.outline
            })
        ]
    });
}, $8bd79e61a95b6697$export$9279461326b8700a = function(t) {
    var n = t.datum, i = t.x, o = t.y, e = t.note, a = $8bd79e61a95b6697$export$c1818d27abb74e50(t);
    if (!$8bd79e61a95b6697$export$b752e15d208daa11(e)) throw new Error("note should be a valid react element");
    return (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
        children: [
            (0, $aSiaI.jsx)($8bd79e61a95b6697$var$E, {
                points: a.points,
                isOutline: !0
            }),
            $8bd79e61a95b6697$export$394411129f5b3217(t) && (0, $aSiaI.jsx)($8bd79e61a95b6697$var$I, {
                x: i,
                y: o,
                size: t.size
            }),
            $8bd79e61a95b6697$export$42c56693a07b2355(t) && (0, $aSiaI.jsx)($8bd79e61a95b6697$var$D, {
                x: i,
                y: o,
                size: t.size
            }),
            $8bd79e61a95b6697$export$3d983e5b537acf00(t) && (0, $aSiaI.jsx)($8bd79e61a95b6697$var$L, {
                x: i,
                y: o,
                width: t.width,
                height: t.height,
                borderRadius: t.borderRadius
            }),
            (0, $aSiaI.jsx)($8bd79e61a95b6697$var$E, {
                points: a.points
            }),
            (0, $aSiaI.jsx)($8bd79e61a95b6697$var$T, {
                datum: n,
                x: a.text[0],
                y: a.text[1],
                note: e
            })
        ]
    });
}, $8bd79e61a95b6697$var$q = function(t, n) {
    n.forEach(function(n, i) {
        var o = n[0], e = n[1];
        0 === i ? t.moveTo(o, e) : t.lineTo(o, e);
    });
}, $8bd79e61a95b6697$export$630dcbe11859bd26 = function(t, n) {
    var i = n.annotations, o = n.theme;
    0 !== i.length && (t.save(), i.forEach(function(n) {
        if (!$8bd79e61a95b6697$export$ec43ae0bd4891d2c(n.note)) throw new Error("note is invalid for canvas implementation");
        o.annotations.link.outlineWidth > 0 && (t.lineCap = "square", t.strokeStyle = o.annotations.link.outlineColor, t.lineWidth = o.annotations.link.strokeWidth + 2 * o.annotations.link.outlineWidth, t.beginPath(), $8bd79e61a95b6697$var$q(t, n.computed.points), t.stroke(), t.lineCap = "butt"), $8bd79e61a95b6697$export$394411129f5b3217(n) && o.annotations.outline.outlineWidth > 0 && (t.strokeStyle = o.annotations.outline.outlineColor, t.lineWidth = o.annotations.outline.strokeWidth + 2 * o.annotations.outline.outlineWidth, t.beginPath(), t.arc(n.x, n.y, n.size / 2, 0, 2 * Math.PI), t.stroke()), $8bd79e61a95b6697$export$42c56693a07b2355(n) && o.annotations.symbol.outlineWidth > 0 && (t.strokeStyle = o.annotations.symbol.outlineColor, t.lineWidth = 2 * o.annotations.symbol.outlineWidth, t.beginPath(), t.arc(n.x, n.y, n.size / 2, 0, 2 * Math.PI), t.stroke()), $8bd79e61a95b6697$export$3d983e5b537acf00(n) && o.annotations.outline.outlineWidth > 0 && (t.strokeStyle = o.annotations.outline.outlineColor, t.lineWidth = o.annotations.outline.strokeWidth + 2 * o.annotations.outline.outlineWidth, t.beginPath(), t.rect(n.x - n.width / 2, n.y - n.height / 2, n.width, n.height), t.stroke()), t.strokeStyle = o.annotations.link.stroke, t.lineWidth = o.annotations.link.strokeWidth, t.beginPath(), $8bd79e61a95b6697$var$q(t, n.computed.points), t.stroke(), $8bd79e61a95b6697$export$394411129f5b3217(n) && (t.strokeStyle = o.annotations.outline.stroke, t.lineWidth = o.annotations.outline.strokeWidth, t.beginPath(), t.arc(n.x, n.y, n.size / 2, 0, 2 * Math.PI), t.stroke()), $8bd79e61a95b6697$export$42c56693a07b2355(n) && (t.fillStyle = o.annotations.symbol.fill, t.beginPath(), t.arc(n.x, n.y, n.size / 2, 0, 2 * Math.PI), t.fill()), $8bd79e61a95b6697$export$3d983e5b537acf00(n) && (t.strokeStyle = o.annotations.outline.stroke, t.lineWidth = o.annotations.outline.strokeWidth, t.beginPath(), t.rect(n.x - n.width / 2, n.y - n.height / 2, n.width, n.height), t.stroke()), "function" == typeof n.note ? n.note(t, {
            datum: n.datum,
            x: n.computed.text[0],
            y: n.computed.text[1],
            theme: o
        }) : (t.font = o.annotations.text.fontSize + "px " + o.annotations.text.fontFamily, t.textAlign = "left", t.textBaseline = "alphabetic", t.fillStyle = o.annotations.text.fill, t.strokeStyle = o.annotations.text.outlineColor, t.lineWidth = 2 * o.annotations.text.outlineWidth, o.annotations.text.outlineWidth > 0 && (t.lineJoin = "round", t.strokeText(n.note, n.computed.text[0], n.computed.text[1]), t.lineJoin = "miter"), t.fillText(n.note, n.computed.text[0], n.computed.text[1]));
    }), t.restore());
};









var $aSiaI = parcelRequire("aSiaI");


var $exYeM = parcelRequire("exYeM");


const $f49abc0fa5df0d3a$export$6c421550c66a327d = 1.1102230246251565e-16;
const $f49abc0fa5df0d3a$export$8cfde575cbd41e40 = 134217729;
const $f49abc0fa5df0d3a$export$a4103c3ab16b06d7 = (3 + 8 * $f49abc0fa5df0d3a$export$6c421550c66a327d) * $f49abc0fa5df0d3a$export$6c421550c66a327d;
function $f49abc0fa5df0d3a$export$8a63f25cc62965f1(elen, e, flen, f, h) {
    let Q, Qnew, hh, bvirt;
    let enow = e[0];
    let fnow = f[0];
    let eindex = 0;
    let findex = 0;
    if (fnow > enow === fnow > -enow) {
        Q = enow;
        enow = e[++eindex];
    } else {
        Q = fnow;
        fnow = f[++findex];
    }
    let hindex = 0;
    if (eindex < elen && findex < flen) {
        if (fnow > enow === fnow > -enow) {
            Qnew = enow + Q;
            hh = Q - (Qnew - enow);
            enow = e[++eindex];
        } else {
            Qnew = fnow + Q;
            hh = Q - (Qnew - fnow);
            fnow = f[++findex];
        }
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
        while(eindex < elen && findex < flen){
            if (fnow > enow === fnow > -enow) {
                Qnew = Q + enow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (enow - bvirt);
                enow = e[++eindex];
            } else {
                Qnew = Q + fnow;
                bvirt = Qnew - Q;
                hh = Q - (Qnew - bvirt) + (fnow - bvirt);
                fnow = f[++findex];
            }
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
    }
    while(eindex < elen){
        Qnew = Q + enow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (enow - bvirt);
        enow = e[++eindex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    while(findex < flen){
        Qnew = Q + fnow;
        bvirt = Qnew - Q;
        hh = Q - (Qnew - bvirt) + (fnow - bvirt);
        fnow = f[++findex];
        Q = Qnew;
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function $f49abc0fa5df0d3a$export$195a93e4bd4d876f(alen, a, blen, b, clen, c, tmp, out) {
    return $f49abc0fa5df0d3a$export$8a63f25cc62965f1($f49abc0fa5df0d3a$export$8a63f25cc62965f1(alen, a, blen, b, tmp), tmp, clen, c, out);
}
function $f49abc0fa5df0d3a$export$dcdf75081b88279d(elen, e, b, h) {
    let Q, sum, hh, product1, product0;
    let bvirt, c, ahi, alo, bhi, blo;
    c = $f49abc0fa5df0d3a$export$8cfde575cbd41e40 * b;
    bhi = c - (c - b);
    blo = b - bhi;
    let enow = e[0];
    Q = enow * b;
    c = $f49abc0fa5df0d3a$export$8cfde575cbd41e40 * enow;
    ahi = c - (c - enow);
    alo = enow - ahi;
    hh = alo * blo - (Q - ahi * bhi - alo * bhi - ahi * blo);
    let hindex = 0;
    if (hh !== 0) h[hindex++] = hh;
    for(let i = 1; i < elen; i++){
        enow = e[i];
        product1 = enow * b;
        c = $f49abc0fa5df0d3a$export$8cfde575cbd41e40 * enow;
        ahi = c - (c - enow);
        alo = enow - ahi;
        product0 = alo * blo - (product1 - ahi * bhi - alo * bhi - ahi * blo);
        sum = Q + product0;
        bvirt = sum - Q;
        hh = Q - (sum - bvirt) + (product0 - bvirt);
        if (hh !== 0) h[hindex++] = hh;
        Q = product1 + sum;
        hh = sum - (Q - product1);
        if (hh !== 0) h[hindex++] = hh;
    }
    if (Q !== 0 || hindex === 0) h[hindex++] = Q;
    return hindex;
}
function $f49abc0fa5df0d3a$export$aef51622e549b8b0(elen, e) {
    for(let i = 0; i < elen; i++)e[i] = -e[i];
    return elen;
}
function $f49abc0fa5df0d3a$export$9f3a0795ca2cc944(elen, e) {
    let Q = e[0];
    for(let i = 1; i < elen; i++)Q += e[i];
    return Q;
}
function $f49abc0fa5df0d3a$export$202e0172ed3c7be0(n) {
    return new Float64Array(n);
}


const $4cdf8e751ad0c338$var$ccwerrboundA = (3 + 16 * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d)) * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d);
const $4cdf8e751ad0c338$var$ccwerrboundB = (2 + 12 * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d)) * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d);
const $4cdf8e751ad0c338$var$ccwerrboundC = (9 + 64 * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d)) * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d) * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d);
const $4cdf8e751ad0c338$var$B = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $4cdf8e751ad0c338$var$C1 = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(8);
const $4cdf8e751ad0c338$var$C2 = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(12);
const $4cdf8e751ad0c338$var$D = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(16);
const $4cdf8e751ad0c338$var$u = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
function $4cdf8e751ad0c338$var$orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
    let acxtail, acytail, bcxtail, bcytail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const acx = ax - cx;
    const bcx = bx - cx;
    const acy = ay - cy;
    const bcy = by - cy;
    s1 = acx * bcy;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcx;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $4cdf8e751ad0c338$var$B[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $4cdf8e751ad0c338$var$B[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $4cdf8e751ad0c338$var$B[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $4cdf8e751ad0c338$var$B[3] = u3;
    let det = (0, $f49abc0fa5df0d3a$export$9f3a0795ca2cc944)(4, $4cdf8e751ad0c338$var$B);
    let errbound = $4cdf8e751ad0c338$var$ccwerrboundB * detsum;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - acx;
    acxtail = ax - (acx + bvirt) + (bvirt - cx);
    bvirt = bx - bcx;
    bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
    bvirt = ay - acy;
    acytail = ay - (acy + bvirt) + (bvirt - cy);
    bvirt = by - bcy;
    bcytail = by - (bcy + bvirt) + (bvirt - cy);
    if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) return det;
    errbound = $4cdf8e751ad0c338$var$ccwerrboundC * detsum + (0, $f49abc0fa5df0d3a$export$a4103c3ab16b06d7) * Math.abs(det);
    det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
    if (det >= errbound || -det >= errbound) return det;
    s1 = acxtail * bcy;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bcy;
    bhi = c - (c - bcy);
    blo = bcy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcx;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bcx;
    bhi = c - (c - bcx);
    blo = bcx - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $4cdf8e751ad0c338$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $4cdf8e751ad0c338$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $4cdf8e751ad0c338$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $4cdf8e751ad0c338$var$u[3] = u3;
    const C1len = (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)(4, $4cdf8e751ad0c338$var$B, 4, $4cdf8e751ad0c338$var$u, $4cdf8e751ad0c338$var$C1);
    s1 = acx * bcytail;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * acx;
    ahi = c - (c - acx);
    alo = acx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acy * bcxtail;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * acy;
    ahi = c - (c - acy);
    alo = acy - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $4cdf8e751ad0c338$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $4cdf8e751ad0c338$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $4cdf8e751ad0c338$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $4cdf8e751ad0c338$var$u[3] = u3;
    const C2len = (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)(C1len, $4cdf8e751ad0c338$var$C1, 4, $4cdf8e751ad0c338$var$u, $4cdf8e751ad0c338$var$C2);
    s1 = acxtail * bcytail;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * acxtail;
    ahi = c - (c - acxtail);
    alo = acxtail - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bcytail;
    bhi = c - (c - bcytail);
    blo = bcytail - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = acytail * bcxtail;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * acytail;
    ahi = c - (c - acytail);
    alo = acytail - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bcxtail;
    bhi = c - (c - bcxtail);
    blo = bcxtail - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $4cdf8e751ad0c338$var$u[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $4cdf8e751ad0c338$var$u[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $4cdf8e751ad0c338$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $4cdf8e751ad0c338$var$u[3] = u3;
    const Dlen = (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)(C2len, $4cdf8e751ad0c338$var$C2, 4, $4cdf8e751ad0c338$var$u, $4cdf8e751ad0c338$var$D);
    return $4cdf8e751ad0c338$var$D[Dlen - 1];
}
function $4cdf8e751ad0c338$export$bbb923599a46a7d8(ax, ay, bx, by, cx, cy) {
    const detleft = (ay - cy) * (bx - cx);
    const detright = (ax - cx) * (by - cy);
    const det = detleft - detright;
    const detsum = Math.abs(detleft + detright);
    if (Math.abs(det) >= $4cdf8e751ad0c338$var$ccwerrboundA * detsum) return det;
    return -$4cdf8e751ad0c338$var$orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
}
function $4cdf8e751ad0c338$export$c42fd1bc0c0a7484(ax, ay, bx, by, cx, cy) {
    return (ay - cy) * (bx - cx) - (ax - cx) * (by - cy);
}



const $5a164037706e7ca7$var$o3derrboundA = (7 + 56 * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d)) * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d);
const $5a164037706e7ca7$var$o3derrboundB = (3 + 28 * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d)) * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d);
const $5a164037706e7ca7$var$o3derrboundC = (26 + 288 * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d)) * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d) * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d);
const $5a164037706e7ca7$var$bc = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $5a164037706e7ca7$var$ca = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $5a164037706e7ca7$var$ab = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $5a164037706e7ca7$var$at_b = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $5a164037706e7ca7$var$at_c = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $5a164037706e7ca7$var$bt_c = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $5a164037706e7ca7$var$bt_a = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $5a164037706e7ca7$var$ct_a = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $5a164037706e7ca7$var$ct_b = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $5a164037706e7ca7$var$bct = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(8);
const $5a164037706e7ca7$var$cat = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(8);
const $5a164037706e7ca7$var$abt = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(8);
const $5a164037706e7ca7$var$u = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $5a164037706e7ca7$var$_8 = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(8);
const $5a164037706e7ca7$var$_8b = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(8);
const $5a164037706e7ca7$var$_16 = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(8);
const $5a164037706e7ca7$var$_12 = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(12);
let $5a164037706e7ca7$var$fin = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(192);
let $5a164037706e7ca7$var$fin2 = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(192);
function $5a164037706e7ca7$var$finadd(finlen, alen, a) {
    finlen = (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)(finlen, $5a164037706e7ca7$var$fin, alen, a, $5a164037706e7ca7$var$fin2);
    const tmp = $5a164037706e7ca7$var$fin;
    $5a164037706e7ca7$var$fin = $5a164037706e7ca7$var$fin2;
    $5a164037706e7ca7$var$fin2 = tmp;
    return finlen;
}
function $5a164037706e7ca7$var$tailinit(xtail, ytail, ax, ay, bx, by, a, b) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3, negate;
    if (xtail === 0) {
        if (ytail === 0) {
            a[0] = 0;
            b[0] = 0;
            return 1;
        } else {
            negate = -ytail;
            s1 = negate * ax;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * negate;
            ahi = c - (c - negate);
            alo = negate - ahi;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ax;
            bhi = c - (c - ax);
            blo = ax - bhi;
            a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            a[1] = s1;
            s1 = ytail * bx;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ytail;
            ahi = c - (c - ytail);
            alo = ytail - ahi;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bx;
            bhi = c - (c - bx);
            blo = bx - bhi;
            b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            b[1] = s1;
            return 2;
        }
    } else if (ytail === 0) {
        s1 = xtail * ay;
        c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        a[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        a[1] = s1;
        negate = -xtail;
        s1 = negate * by;
        c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * negate;
        ahi = c - (c - negate);
        alo = negate - ahi;
        c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        b[0] = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        b[1] = s1;
        return 2;
    } else {
        s1 = xtail * ay;
        c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ay;
        bhi = c - (c - ay);
        blo = ay - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = ytail * ax;
        c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ax;
        bhi = c - (c - ax);
        blo = ax - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        a[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        a[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        a[2] = _j - (u3 - bvirt) + (_i - bvirt);
        a[3] = u3;
        s1 = ytail * bx;
        c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ytail;
        ahi = c - (c - ytail);
        alo = ytail - ahi;
        c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bx;
        bhi = c - (c - bx);
        blo = bx - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = xtail * by;
        c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * xtail;
        ahi = c - (c - xtail);
        alo = xtail - ahi;
        c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * by;
        bhi = c - (c - by);
        blo = by - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        b[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        b[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        b[2] = _j - (u3 - bvirt) + (_i - bvirt);
        b[3] = u3;
        return 4;
    }
}
function $5a164037706e7ca7$var$tailadd(finlen, a, b, k, z) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, u3;
    s1 = a * b;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * a;
    ahi = c - (c - a);
    alo = a - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * b;
    bhi = c - (c - b);
    blo = b - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * k;
    bhi = c - (c - k);
    blo = k - bhi;
    _i = s0 * k;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * s0;
    ahi = c - (c - s0);
    alo = s0 - ahi;
    $5a164037706e7ca7$var$u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
    _j = s1 * k;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * s1;
    ahi = c - (c - s1);
    alo = s1 - ahi;
    _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
    _k = _i + _0;
    bvirt = _k - _i;
    $5a164037706e7ca7$var$u[1] = _i - (_k - bvirt) + (_0 - bvirt);
    u3 = _j + _k;
    $5a164037706e7ca7$var$u[2] = _k - (u3 - _j);
    $5a164037706e7ca7$var$u[3] = u3;
    finlen = $5a164037706e7ca7$var$finadd(finlen, 4, $5a164037706e7ca7$var$u);
    if (z !== 0) {
        c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * z;
        bhi = c - (c - z);
        blo = z - bhi;
        _i = s0 * z;
        c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * s0;
        ahi = c - (c - s0);
        alo = s0 - ahi;
        $5a164037706e7ca7$var$u[0] = alo * blo - (_i - ahi * bhi - alo * bhi - ahi * blo);
        _j = s1 * z;
        c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * s1;
        ahi = c - (c - s1);
        alo = s1 - ahi;
        _0 = alo * blo - (_j - ahi * bhi - alo * bhi - ahi * blo);
        _k = _i + _0;
        bvirt = _k - _i;
        $5a164037706e7ca7$var$u[1] = _i - (_k - bvirt) + (_0 - bvirt);
        u3 = _j + _k;
        $5a164037706e7ca7$var$u[2] = _k - (u3 - _j);
        $5a164037706e7ca7$var$u[3] = u3;
        finlen = $5a164037706e7ca7$var$finadd(finlen, 4, $5a164037706e7ca7$var$u);
    }
    return finlen;
}
function $5a164037706e7ca7$var$orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail;
    let adytail, bdytail, cdytail;
    let adztail, bdztail, cdztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _k, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    s1 = bdx * cdy;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $5a164037706e7ca7$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $5a164037706e7ca7$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $5a164037706e7ca7$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $5a164037706e7ca7$var$bc[3] = u3;
    s1 = cdx * ady;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $5a164037706e7ca7$var$ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $5a164037706e7ca7$var$ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $5a164037706e7ca7$var$ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $5a164037706e7ca7$var$ca[3] = u3;
    s1 = adx * bdy;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $5a164037706e7ca7$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $5a164037706e7ca7$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $5a164037706e7ca7$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $5a164037706e7ca7$var$ab[3] = u3;
    finlen = (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)((0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $5a164037706e7ca7$var$bc, adz, $5a164037706e7ca7$var$_8), $5a164037706e7ca7$var$_8, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $5a164037706e7ca7$var$ca, bdz, $5a164037706e7ca7$var$_8b), $5a164037706e7ca7$var$_8b, $5a164037706e7ca7$var$_16), $5a164037706e7ca7$var$_16, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $5a164037706e7ca7$var$ab, cdz, $5a164037706e7ca7$var$_8), $5a164037706e7ca7$var$_8, $5a164037706e7ca7$var$fin);
    let det = (0, $f49abc0fa5df0d3a$export$9f3a0795ca2cc944)(finlen, $5a164037706e7ca7$var$fin);
    let errbound = $5a164037706e7ca7$var$o3derrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    bvirt = az - adz;
    adztail = az - (adz + bvirt) + (bvirt - dz);
    bvirt = bz - bdz;
    bdztail = bz - (bdz + bvirt) + (bvirt - dz);
    bvirt = cz - cdz;
    cdztail = cz - (cdz + bvirt) + (bvirt - dz);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0 && adztail === 0 && bdztail === 0 && cdztail === 0) return det;
    errbound = $5a164037706e7ca7$var$o3derrboundC * permanent + (0, $f49abc0fa5df0d3a$export$a4103c3ab16b06d7) * Math.abs(det);
    det += adz * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + adztail * (bdx * cdy - bdy * cdx) + bdz * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + bdztail * (cdx * ady - cdy * adx) + cdz * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + cdztail * (adx * bdy - ady * bdx);
    if (det >= errbound || -det >= errbound) return det;
    const at_len = $5a164037706e7ca7$var$tailinit(adxtail, adytail, bdx, bdy, cdx, cdy, $5a164037706e7ca7$var$at_b, $5a164037706e7ca7$var$at_c);
    const bt_len = $5a164037706e7ca7$var$tailinit(bdxtail, bdytail, cdx, cdy, adx, ady, $5a164037706e7ca7$var$bt_c, $5a164037706e7ca7$var$bt_a);
    const ct_len = $5a164037706e7ca7$var$tailinit(cdxtail, cdytail, adx, ady, bdx, bdy, $5a164037706e7ca7$var$ct_a, $5a164037706e7ca7$var$ct_b);
    const bctlen = (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)(bt_len, $5a164037706e7ca7$var$bt_c, ct_len, $5a164037706e7ca7$var$ct_b, $5a164037706e7ca7$var$bct);
    finlen = $5a164037706e7ca7$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(bctlen, $5a164037706e7ca7$var$bct, adz, $5a164037706e7ca7$var$_16), $5a164037706e7ca7$var$_16);
    const catlen = (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)(ct_len, $5a164037706e7ca7$var$ct_a, at_len, $5a164037706e7ca7$var$at_c, $5a164037706e7ca7$var$cat);
    finlen = $5a164037706e7ca7$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(catlen, $5a164037706e7ca7$var$cat, bdz, $5a164037706e7ca7$var$_16), $5a164037706e7ca7$var$_16);
    const abtlen = (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)(at_len, $5a164037706e7ca7$var$at_b, bt_len, $5a164037706e7ca7$var$bt_a, $5a164037706e7ca7$var$abt);
    finlen = $5a164037706e7ca7$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(abtlen, $5a164037706e7ca7$var$abt, cdz, $5a164037706e7ca7$var$_16), $5a164037706e7ca7$var$_16);
    if (adztail !== 0) {
        finlen = $5a164037706e7ca7$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $5a164037706e7ca7$var$bc, adztail, $5a164037706e7ca7$var$_12), $5a164037706e7ca7$var$_12);
        finlen = $5a164037706e7ca7$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(bctlen, $5a164037706e7ca7$var$bct, adztail, $5a164037706e7ca7$var$_16), $5a164037706e7ca7$var$_16);
    }
    if (bdztail !== 0) {
        finlen = $5a164037706e7ca7$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $5a164037706e7ca7$var$ca, bdztail, $5a164037706e7ca7$var$_12), $5a164037706e7ca7$var$_12);
        finlen = $5a164037706e7ca7$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(catlen, $5a164037706e7ca7$var$cat, bdztail, $5a164037706e7ca7$var$_16), $5a164037706e7ca7$var$_16);
    }
    if (cdztail !== 0) {
        finlen = $5a164037706e7ca7$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $5a164037706e7ca7$var$ab, cdztail, $5a164037706e7ca7$var$_12), $5a164037706e7ca7$var$_12);
        finlen = $5a164037706e7ca7$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(abtlen, $5a164037706e7ca7$var$abt, cdztail, $5a164037706e7ca7$var$_16), $5a164037706e7ca7$var$_16);
    }
    if (adxtail !== 0) {
        if (bdytail !== 0) finlen = $5a164037706e7ca7$var$tailadd(finlen, adxtail, bdytail, cdz, cdztail);
        if (cdytail !== 0) finlen = $5a164037706e7ca7$var$tailadd(finlen, -adxtail, cdytail, bdz, bdztail);
    }
    if (bdxtail !== 0) {
        if (cdytail !== 0) finlen = $5a164037706e7ca7$var$tailadd(finlen, bdxtail, cdytail, adz, adztail);
        if (adytail !== 0) finlen = $5a164037706e7ca7$var$tailadd(finlen, -bdxtail, adytail, cdz, cdztail);
    }
    if (cdxtail !== 0) {
        if (adytail !== 0) finlen = $5a164037706e7ca7$var$tailadd(finlen, cdxtail, adytail, bdz, bdztail);
        if (bdytail !== 0) finlen = $5a164037706e7ca7$var$tailadd(finlen, -cdxtail, bdytail, adz, adztail);
    }
    return $5a164037706e7ca7$var$fin[finlen - 1];
}
function $5a164037706e7ca7$export$248ff23af2e93e3e(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const det = adz * (bdxcdy - cdxbdy) + bdz * (cdxady - adxcdy) + cdz * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz) + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz) + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz);
    const errbound = $5a164037706e7ca7$var$o3derrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return $5a164037706e7ca7$var$orient3dadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, permanent);
}
function $5a164037706e7ca7$export$407220085d2c43a5(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const adz = az - dz;
    const bdz = bz - dz;
    const cdz = cz - dz;
    return adx * (bdy * cdz - bdz * cdy) + bdx * (cdy * adz - cdz * ady) + cdx * (ady * bdz - adz * bdy);
}



const $0409c4eb19033693$var$iccerrboundA = (10 + 96 * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d)) * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d);
const $0409c4eb19033693$var$iccerrboundB = (4 + 48 * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d)) * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d);
const $0409c4eb19033693$var$iccerrboundC = (44 + 576 * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d)) * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d) * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d);
const $0409c4eb19033693$var$bc = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $0409c4eb19033693$var$ca = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $0409c4eb19033693$var$ab = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $0409c4eb19033693$var$aa = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $0409c4eb19033693$var$bb = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $0409c4eb19033693$var$cc = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $0409c4eb19033693$var$u = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $0409c4eb19033693$var$v = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $0409c4eb19033693$var$axtbc = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(8);
const $0409c4eb19033693$var$aytbc = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(8);
const $0409c4eb19033693$var$bxtca = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(8);
const $0409c4eb19033693$var$bytca = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(8);
const $0409c4eb19033693$var$cxtab = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(8);
const $0409c4eb19033693$var$cytab = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(8);
const $0409c4eb19033693$var$abt = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(8);
const $0409c4eb19033693$var$bct = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(8);
const $0409c4eb19033693$var$cat = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(8);
const $0409c4eb19033693$var$abtt = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $0409c4eb19033693$var$bctt = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $0409c4eb19033693$var$catt = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $0409c4eb19033693$var$_8 = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(8);
const $0409c4eb19033693$var$_16 = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(16);
const $0409c4eb19033693$var$_16b = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(16);
const $0409c4eb19033693$var$_16c = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(16);
const $0409c4eb19033693$var$_32 = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(32);
const $0409c4eb19033693$var$_32b = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(32);
const $0409c4eb19033693$var$_48 = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(48);
const $0409c4eb19033693$var$_64 = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(64);
let $0409c4eb19033693$var$fin = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(1152);
let $0409c4eb19033693$var$fin2 = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(1152);
function $0409c4eb19033693$var$finadd(finlen, a, alen) {
    finlen = (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)(finlen, $0409c4eb19033693$var$fin, a, alen, $0409c4eb19033693$var$fin2);
    const tmp = $0409c4eb19033693$var$fin;
    $0409c4eb19033693$var$fin = $0409c4eb19033693$var$fin2;
    $0409c4eb19033693$var$fin2 = tmp;
    return finlen;
}
function $0409c4eb19033693$var$incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent) {
    let finlen;
    let adxtail, bdxtail, cdxtail, adytail, bdytail, cdytail;
    let axtbclen, aytbclen, bxtcalen, bytcalen, cxtablen, cytablen;
    let abtlen, bctlen, catlen;
    let abttlen, bcttlen, cattlen;
    let n1, n0;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    s1 = bdx * cdy;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cdx * bdy;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $0409c4eb19033693$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $0409c4eb19033693$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $0409c4eb19033693$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $0409c4eb19033693$var$bc[3] = u3;
    s1 = cdx * ady;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cdx;
    ahi = c - (c - cdx);
    alo = cdx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = adx * cdy;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cdy;
    bhi = c - (c - cdy);
    blo = cdy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $0409c4eb19033693$var$ca[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $0409c4eb19033693$var$ca[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $0409c4eb19033693$var$ca[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $0409c4eb19033693$var$ca[3] = u3;
    s1 = adx * bdy;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * adx;
    ahi = c - (c - adx);
    alo = adx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bdy;
    bhi = c - (c - bdy);
    blo = bdy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bdx * ady;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bdx;
    ahi = c - (c - bdx);
    alo = bdx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ady;
    bhi = c - (c - ady);
    blo = ady - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $0409c4eb19033693$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $0409c4eb19033693$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $0409c4eb19033693$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $0409c4eb19033693$var$ab[3] = u3;
    finlen = (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)((0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)((0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$bc, adx, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, adx, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$bc, ady, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, ady, $0409c4eb19033693$var$_16b), $0409c4eb19033693$var$_16b, $0409c4eb19033693$var$_32), $0409c4eb19033693$var$_32, (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$ca, bdx, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, bdx, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$ca, bdy, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, bdy, $0409c4eb19033693$var$_16b), $0409c4eb19033693$var$_16b, $0409c4eb19033693$var$_32b), $0409c4eb19033693$var$_32b, $0409c4eb19033693$var$_64), $0409c4eb19033693$var$_64, (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$ab, cdx, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, cdx, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$ab, cdy, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, cdy, $0409c4eb19033693$var$_16b), $0409c4eb19033693$var$_16b, $0409c4eb19033693$var$_32), $0409c4eb19033693$var$_32, $0409c4eb19033693$var$fin);
    let det = (0, $f49abc0fa5df0d3a$export$9f3a0795ca2cc944)(finlen, $0409c4eb19033693$var$fin);
    let errbound = $0409c4eb19033693$var$iccerrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - adx;
    adxtail = ax - (adx + bvirt) + (bvirt - dx);
    bvirt = ay - ady;
    adytail = ay - (ady + bvirt) + (bvirt - dy);
    bvirt = bx - bdx;
    bdxtail = bx - (bdx + bvirt) + (bvirt - dx);
    bvirt = by - bdy;
    bdytail = by - (bdy + bvirt) + (bvirt - dy);
    bvirt = cx - cdx;
    cdxtail = cx - (cdx + bvirt) + (bvirt - dx);
    bvirt = cy - cdy;
    cdytail = cy - (cdy + bvirt) + (bvirt - dy);
    if (adxtail === 0 && bdxtail === 0 && cdxtail === 0 && adytail === 0 && bdytail === 0 && cdytail === 0) return det;
    errbound = $0409c4eb19033693$var$iccerrboundC * permanent + (0, $f49abc0fa5df0d3a$export$a4103c3ab16b06d7) * Math.abs(det);
    det += (adx * adx + ady * ady) * (bdx * cdytail + cdy * bdxtail - (bdy * cdxtail + cdx * bdytail)) + 2 * (adx * adxtail + ady * adytail) * (bdx * cdy - bdy * cdx) + ((bdx * bdx + bdy * bdy) * (cdx * adytail + ady * cdxtail - (cdy * adxtail + adx * cdytail)) + 2 * (bdx * bdxtail + bdy * bdytail) * (cdx * ady - cdy * adx)) + ((cdx * cdx + cdy * cdy) * (adx * bdytail + bdy * adxtail - (ady * bdxtail + bdx * adytail)) + 2 * (cdx * cdxtail + cdy * cdytail) * (adx * bdy - ady * bdx));
    if (det >= errbound || -det >= errbound) return det;
    if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
        s1 = adx * adx;
        c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * adx;
        ahi = c - (c - adx);
        alo = adx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = ady * ady;
        c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ady;
        ahi = c - (c - ady);
        alo = ady - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $0409c4eb19033693$var$aa[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $0409c4eb19033693$var$aa[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $0409c4eb19033693$var$aa[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $0409c4eb19033693$var$aa[3] = u3;
    }
    if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
        s1 = bdx * bdx;
        c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bdx;
        ahi = c - (c - bdx);
        alo = bdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = bdy * bdy;
        c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bdy;
        ahi = c - (c - bdy);
        alo = bdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $0409c4eb19033693$var$bb[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $0409c4eb19033693$var$bb[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $0409c4eb19033693$var$bb[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $0409c4eb19033693$var$bb[3] = u3;
    }
    if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
        s1 = cdx * cdx;
        c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cdx;
        ahi = c - (c - cdx);
        alo = cdx - ahi;
        s0 = alo * alo - (s1 - ahi * ahi - (ahi + ahi) * alo);
        t1 = cdy * cdy;
        c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cdy;
        ahi = c - (c - cdy);
        alo = cdy - ahi;
        t0 = alo * alo - (t1 - ahi * ahi - (ahi + ahi) * alo);
        _i = s0 + t0;
        bvirt = _i - s0;
        $0409c4eb19033693$var$cc[0] = s0 - (_i - bvirt) + (t0 - bvirt);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 + t1;
        bvirt = _i - _0;
        $0409c4eb19033693$var$cc[1] = _0 - (_i - bvirt) + (t1 - bvirt);
        u3 = _j + _i;
        bvirt = u3 - _j;
        $0409c4eb19033693$var$cc[2] = _j - (u3 - bvirt) + (_i - bvirt);
        $0409c4eb19033693$var$cc[3] = u3;
    }
    if (adxtail !== 0) {
        axtbclen = (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$bc, adxtail, $0409c4eb19033693$var$axtbc);
        finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$195a93e4bd4d876f)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(axtbclen, $0409c4eb19033693$var$axtbc, 2 * adx, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$cc, adxtail, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, bdy, $0409c4eb19033693$var$_16b), $0409c4eb19033693$var$_16b, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$bb, adxtail, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, -cdy, $0409c4eb19033693$var$_16c), $0409c4eb19033693$var$_16c, $0409c4eb19033693$var$_32, $0409c4eb19033693$var$_48), $0409c4eb19033693$var$_48);
    }
    if (adytail !== 0) {
        aytbclen = (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$bc, adytail, $0409c4eb19033693$var$aytbc);
        finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$195a93e4bd4d876f)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(aytbclen, $0409c4eb19033693$var$aytbc, 2 * ady, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$bb, adytail, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, cdx, $0409c4eb19033693$var$_16b), $0409c4eb19033693$var$_16b, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$cc, adytail, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, -bdx, $0409c4eb19033693$var$_16c), $0409c4eb19033693$var$_16c, $0409c4eb19033693$var$_32, $0409c4eb19033693$var$_48), $0409c4eb19033693$var$_48);
    }
    if (bdxtail !== 0) {
        bxtcalen = (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$ca, bdxtail, $0409c4eb19033693$var$bxtca);
        finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$195a93e4bd4d876f)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(bxtcalen, $0409c4eb19033693$var$bxtca, 2 * bdx, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$aa, bdxtail, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, cdy, $0409c4eb19033693$var$_16b), $0409c4eb19033693$var$_16b, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$cc, bdxtail, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, -ady, $0409c4eb19033693$var$_16c), $0409c4eb19033693$var$_16c, $0409c4eb19033693$var$_32, $0409c4eb19033693$var$_48), $0409c4eb19033693$var$_48);
    }
    if (bdytail !== 0) {
        bytcalen = (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$ca, bdytail, $0409c4eb19033693$var$bytca);
        finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$195a93e4bd4d876f)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(bytcalen, $0409c4eb19033693$var$bytca, 2 * bdy, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$cc, bdytail, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, adx, $0409c4eb19033693$var$_16b), $0409c4eb19033693$var$_16b, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$aa, bdytail, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, -cdx, $0409c4eb19033693$var$_16c), $0409c4eb19033693$var$_16c, $0409c4eb19033693$var$_32, $0409c4eb19033693$var$_48), $0409c4eb19033693$var$_48);
    }
    if (cdxtail !== 0) {
        cxtablen = (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$ab, cdxtail, $0409c4eb19033693$var$cxtab);
        finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$195a93e4bd4d876f)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(cxtablen, $0409c4eb19033693$var$cxtab, 2 * cdx, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$bb, cdxtail, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, ady, $0409c4eb19033693$var$_16b), $0409c4eb19033693$var$_16b, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$aa, cdxtail, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, -bdy, $0409c4eb19033693$var$_16c), $0409c4eb19033693$var$_16c, $0409c4eb19033693$var$_32, $0409c4eb19033693$var$_48), $0409c4eb19033693$var$_48);
    }
    if (cdytail !== 0) {
        cytablen = (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$ab, cdytail, $0409c4eb19033693$var$cytab);
        finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$195a93e4bd4d876f)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(cytablen, $0409c4eb19033693$var$cytab, 2 * cdy, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$aa, cdytail, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, bdx, $0409c4eb19033693$var$_16b), $0409c4eb19033693$var$_16b, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$bb, cdytail, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, -adx, $0409c4eb19033693$var$_16c), $0409c4eb19033693$var$_16c, $0409c4eb19033693$var$_32, $0409c4eb19033693$var$_48), $0409c4eb19033693$var$_48);
    }
    if (adxtail !== 0 || adytail !== 0) {
        if (bdxtail !== 0 || bdytail !== 0 || cdxtail !== 0 || cdytail !== 0) {
            s1 = bdxtail * cdy;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cdy;
            bhi = c - (c - cdy);
            blo = cdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * cdytail;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $0409c4eb19033693$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $0409c4eb19033693$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $0409c4eb19033693$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $0409c4eb19033693$var$u[3] = u3;
            s1 = cdxtail * -bdy;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * -bdy;
            bhi = c - (c - -bdy);
            blo = -bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * -bdytail;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * -bdytail;
            bhi = c - (c - -bdytail);
            blo = -bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $0409c4eb19033693$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $0409c4eb19033693$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $0409c4eb19033693$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $0409c4eb19033693$var$v[3] = u3;
            bctlen = (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)(4, $0409c4eb19033693$var$u, 4, $0409c4eb19033693$var$v, $0409c4eb19033693$var$bct);
            s1 = bdxtail * cdytail;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdxtail * bdytail;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $0409c4eb19033693$var$bctt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $0409c4eb19033693$var$bctt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $0409c4eb19033693$var$bctt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $0409c4eb19033693$var$bctt[3] = u3;
            bcttlen = 4;
        } else {
            $0409c4eb19033693$var$bct[0] = 0;
            bctlen = 1;
            $0409c4eb19033693$var$bctt[0] = 0;
            bcttlen = 1;
        }
        if (adxtail !== 0) {
            const len = (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(bctlen, $0409c4eb19033693$var$bct, adxtail, $0409c4eb19033693$var$_16c);
            finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(axtbclen, $0409c4eb19033693$var$axtbc, adxtail, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len, $0409c4eb19033693$var$_16c, 2 * adx, $0409c4eb19033693$var$_32), $0409c4eb19033693$var$_32, $0409c4eb19033693$var$_48), $0409c4eb19033693$var$_48);
            const len2 = (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(bcttlen, $0409c4eb19033693$var$bctt, adxtail, $0409c4eb19033693$var$_8);
            finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$195a93e4bd4d876f)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len2, $0409c4eb19033693$var$_8, 2 * adx, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len2, $0409c4eb19033693$var$_8, adxtail, $0409c4eb19033693$var$_16b), $0409c4eb19033693$var$_16b, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len, $0409c4eb19033693$var$_16c, adxtail, $0409c4eb19033693$var$_32), $0409c4eb19033693$var$_32, $0409c4eb19033693$var$_32b, $0409c4eb19033693$var$_64), $0409c4eb19033693$var$_64);
            if (bdytail !== 0) finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$cc, adxtail, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, bdytail, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16);
            if (cdytail !== 0) finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$bb, -adxtail, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, cdytail, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16);
        }
        if (adytail !== 0) {
            const len = (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(bctlen, $0409c4eb19033693$var$bct, adytail, $0409c4eb19033693$var$_16c);
            finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(aytbclen, $0409c4eb19033693$var$aytbc, adytail, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len, $0409c4eb19033693$var$_16c, 2 * ady, $0409c4eb19033693$var$_32), $0409c4eb19033693$var$_32, $0409c4eb19033693$var$_48), $0409c4eb19033693$var$_48);
            const len2 = (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(bcttlen, $0409c4eb19033693$var$bctt, adytail, $0409c4eb19033693$var$_8);
            finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$195a93e4bd4d876f)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len2, $0409c4eb19033693$var$_8, 2 * ady, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len2, $0409c4eb19033693$var$_8, adytail, $0409c4eb19033693$var$_16b), $0409c4eb19033693$var$_16b, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len, $0409c4eb19033693$var$_16c, adytail, $0409c4eb19033693$var$_32), $0409c4eb19033693$var$_32, $0409c4eb19033693$var$_32b, $0409c4eb19033693$var$_64), $0409c4eb19033693$var$_64);
        }
    }
    if (bdxtail !== 0 || bdytail !== 0) {
        if (cdxtail !== 0 || cdytail !== 0 || adxtail !== 0 || adytail !== 0) {
            s1 = cdxtail * ady;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ady;
            bhi = c - (c - ady);
            blo = ady - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = cdx * adytail;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cdx;
            ahi = c - (c - cdx);
            alo = cdx - ahi;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $0409c4eb19033693$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $0409c4eb19033693$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $0409c4eb19033693$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $0409c4eb19033693$var$u[3] = u3;
            n1 = -cdy;
            n0 = -cdytail;
            s1 = adxtail * n1;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * n0;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $0409c4eb19033693$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $0409c4eb19033693$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $0409c4eb19033693$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $0409c4eb19033693$var$v[3] = u3;
            catlen = (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)(4, $0409c4eb19033693$var$u, 4, $0409c4eb19033693$var$v, $0409c4eb19033693$var$cat);
            s1 = cdxtail * adytail;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cdxtail;
            ahi = c - (c - cdxtail);
            alo = cdxtail - ahi;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adxtail * cdytail;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cdytail;
            bhi = c - (c - cdytail);
            blo = cdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $0409c4eb19033693$var$catt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $0409c4eb19033693$var$catt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $0409c4eb19033693$var$catt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $0409c4eb19033693$var$catt[3] = u3;
            cattlen = 4;
        } else {
            $0409c4eb19033693$var$cat[0] = 0;
            catlen = 1;
            $0409c4eb19033693$var$catt[0] = 0;
            cattlen = 1;
        }
        if (bdxtail !== 0) {
            const len = (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(catlen, $0409c4eb19033693$var$cat, bdxtail, $0409c4eb19033693$var$_16c);
            finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(bxtcalen, $0409c4eb19033693$var$bxtca, bdxtail, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len, $0409c4eb19033693$var$_16c, 2 * bdx, $0409c4eb19033693$var$_32), $0409c4eb19033693$var$_32, $0409c4eb19033693$var$_48), $0409c4eb19033693$var$_48);
            const len2 = (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(cattlen, $0409c4eb19033693$var$catt, bdxtail, $0409c4eb19033693$var$_8);
            finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$195a93e4bd4d876f)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len2, $0409c4eb19033693$var$_8, 2 * bdx, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len2, $0409c4eb19033693$var$_8, bdxtail, $0409c4eb19033693$var$_16b), $0409c4eb19033693$var$_16b, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len, $0409c4eb19033693$var$_16c, bdxtail, $0409c4eb19033693$var$_32), $0409c4eb19033693$var$_32, $0409c4eb19033693$var$_32b, $0409c4eb19033693$var$_64), $0409c4eb19033693$var$_64);
            if (cdytail !== 0) finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$aa, bdxtail, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, cdytail, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16);
            if (adytail !== 0) finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$cc, -bdxtail, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, adytail, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16);
        }
        if (bdytail !== 0) {
            const len = (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(catlen, $0409c4eb19033693$var$cat, bdytail, $0409c4eb19033693$var$_16c);
            finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(bytcalen, $0409c4eb19033693$var$bytca, bdytail, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len, $0409c4eb19033693$var$_16c, 2 * bdy, $0409c4eb19033693$var$_32), $0409c4eb19033693$var$_32, $0409c4eb19033693$var$_48), $0409c4eb19033693$var$_48);
            const len2 = (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(cattlen, $0409c4eb19033693$var$catt, bdytail, $0409c4eb19033693$var$_8);
            finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$195a93e4bd4d876f)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len2, $0409c4eb19033693$var$_8, 2 * bdy, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len2, $0409c4eb19033693$var$_8, bdytail, $0409c4eb19033693$var$_16b), $0409c4eb19033693$var$_16b, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len, $0409c4eb19033693$var$_16c, bdytail, $0409c4eb19033693$var$_32), $0409c4eb19033693$var$_32, $0409c4eb19033693$var$_32b, $0409c4eb19033693$var$_64), $0409c4eb19033693$var$_64);
        }
    }
    if (cdxtail !== 0 || cdytail !== 0) {
        if (adxtail !== 0 || adytail !== 0 || bdxtail !== 0 || bdytail !== 0) {
            s1 = adxtail * bdy;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bdy;
            bhi = c - (c - bdy);
            blo = bdy - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = adx * bdytail;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * adx;
            ahi = c - (c - adx);
            alo = adx - ahi;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $0409c4eb19033693$var$u[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $0409c4eb19033693$var$u[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $0409c4eb19033693$var$u[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $0409c4eb19033693$var$u[3] = u3;
            n1 = -ady;
            n0 = -adytail;
            s1 = bdxtail * n1;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * n1;
            bhi = c - (c - n1);
            blo = n1 - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdx * n0;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bdx;
            ahi = c - (c - bdx);
            alo = bdx - ahi;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * n0;
            bhi = c - (c - n0);
            blo = n0 - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 + t0;
            bvirt = _i - s0;
            $0409c4eb19033693$var$v[0] = s0 - (_i - bvirt) + (t0 - bvirt);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 + t1;
            bvirt = _i - _0;
            $0409c4eb19033693$var$v[1] = _0 - (_i - bvirt) + (t1 - bvirt);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $0409c4eb19033693$var$v[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $0409c4eb19033693$var$v[3] = u3;
            abtlen = (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)(4, $0409c4eb19033693$var$u, 4, $0409c4eb19033693$var$v, $0409c4eb19033693$var$abt);
            s1 = adxtail * bdytail;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * adxtail;
            ahi = c - (c - adxtail);
            alo = adxtail - ahi;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bdytail;
            bhi = c - (c - bdytail);
            blo = bdytail - bhi;
            s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
            t1 = bdxtail * adytail;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bdxtail;
            ahi = c - (c - bdxtail);
            alo = bdxtail - ahi;
            c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * adytail;
            bhi = c - (c - adytail);
            blo = adytail - bhi;
            t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
            _i = s0 - t0;
            bvirt = s0 - _i;
            $0409c4eb19033693$var$abtt[0] = s0 - (_i + bvirt) + (bvirt - t0);
            _j = s1 + _i;
            bvirt = _j - s1;
            _0 = s1 - (_j - bvirt) + (_i - bvirt);
            _i = _0 - t1;
            bvirt = _0 - _i;
            $0409c4eb19033693$var$abtt[1] = _0 - (_i + bvirt) + (bvirt - t1);
            u3 = _j + _i;
            bvirt = u3 - _j;
            $0409c4eb19033693$var$abtt[2] = _j - (u3 - bvirt) + (_i - bvirt);
            $0409c4eb19033693$var$abtt[3] = u3;
            abttlen = 4;
        } else {
            $0409c4eb19033693$var$abt[0] = 0;
            abtlen = 1;
            $0409c4eb19033693$var$abtt[0] = 0;
            abttlen = 1;
        }
        if (cdxtail !== 0) {
            const len = (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(abtlen, $0409c4eb19033693$var$abt, cdxtail, $0409c4eb19033693$var$_16c);
            finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(cxtablen, $0409c4eb19033693$var$cxtab, cdxtail, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len, $0409c4eb19033693$var$_16c, 2 * cdx, $0409c4eb19033693$var$_32), $0409c4eb19033693$var$_32, $0409c4eb19033693$var$_48), $0409c4eb19033693$var$_48);
            const len2 = (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(abttlen, $0409c4eb19033693$var$abtt, cdxtail, $0409c4eb19033693$var$_8);
            finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$195a93e4bd4d876f)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len2, $0409c4eb19033693$var$_8, 2 * cdx, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len2, $0409c4eb19033693$var$_8, cdxtail, $0409c4eb19033693$var$_16b), $0409c4eb19033693$var$_16b, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len, $0409c4eb19033693$var$_16c, cdxtail, $0409c4eb19033693$var$_32), $0409c4eb19033693$var$_32, $0409c4eb19033693$var$_32b, $0409c4eb19033693$var$_64), $0409c4eb19033693$var$_64);
            if (adytail !== 0) finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$bb, cdxtail, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, adytail, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16);
            if (bdytail !== 0) finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, $0409c4eb19033693$var$aa, -cdxtail, $0409c4eb19033693$var$_8), $0409c4eb19033693$var$_8, bdytail, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16);
        }
        if (cdytail !== 0) {
            const len = (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(abtlen, $0409c4eb19033693$var$abt, cdytail, $0409c4eb19033693$var$_16c);
            finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(cytablen, $0409c4eb19033693$var$cytab, cdytail, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len, $0409c4eb19033693$var$_16c, 2 * cdy, $0409c4eb19033693$var$_32), $0409c4eb19033693$var$_32, $0409c4eb19033693$var$_48), $0409c4eb19033693$var$_48);
            const len2 = (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(abttlen, $0409c4eb19033693$var$abtt, cdytail, $0409c4eb19033693$var$_8);
            finlen = $0409c4eb19033693$var$finadd(finlen, (0, $f49abc0fa5df0d3a$export$195a93e4bd4d876f)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len2, $0409c4eb19033693$var$_8, 2 * cdy, $0409c4eb19033693$var$_16), $0409c4eb19033693$var$_16, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len2, $0409c4eb19033693$var$_8, cdytail, $0409c4eb19033693$var$_16b), $0409c4eb19033693$var$_16b, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len, $0409c4eb19033693$var$_16c, cdytail, $0409c4eb19033693$var$_32), $0409c4eb19033693$var$_32, $0409c4eb19033693$var$_32b, $0409c4eb19033693$var$_64), $0409c4eb19033693$var$_64);
        }
    }
    return $0409c4eb19033693$var$fin[finlen - 1];
}
function $0409c4eb19033693$export$454d2cfe884d4dd6(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const bdx = bx - dx;
    const cdx = cx - dx;
    const ady = ay - dy;
    const bdy = by - dy;
    const cdy = cy - dy;
    const bdxcdy = bdx * cdy;
    const cdxbdy = cdx * bdy;
    const alift = adx * adx + ady * ady;
    const cdxady = cdx * ady;
    const adxcdy = adx * cdy;
    const blift = bdx * bdx + bdy * bdy;
    const adxbdy = adx * bdy;
    const bdxady = bdx * ady;
    const clift = cdx * cdx + cdy * cdy;
    const det = alift * (bdxcdy - cdxbdy) + blift * (cdxady - adxcdy) + clift * (adxbdy - bdxady);
    const permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * alift + (Math.abs(cdxady) + Math.abs(adxcdy)) * blift + (Math.abs(adxbdy) + Math.abs(bdxady)) * clift;
    const errbound = $0409c4eb19033693$var$iccerrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return $0409c4eb19033693$var$incircleadapt(ax, ay, bx, by, cx, cy, dx, dy, permanent);
}
function $0409c4eb19033693$export$f98e78581b4485e6(ax, ay, bx, by, cx, cy, dx, dy) {
    const adx = ax - dx;
    const ady = ay - dy;
    const bdx = bx - dx;
    const bdy = by - dy;
    const cdx = cx - dx;
    const cdy = cy - dy;
    const abdet = adx * bdy - bdx * ady;
    const bcdet = bdx * cdy - cdx * bdy;
    const cadet = cdx * ady - adx * cdy;
    const alift = adx * adx + ady * ady;
    const blift = bdx * bdx + bdy * bdy;
    const clift = cdx * cdx + cdy * cdy;
    return alift * bcdet + blift * cadet + clift * abdet;
}



const $4c0db2d93c158487$var$isperrboundA = (16 + 224 * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d)) * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d);
const $4c0db2d93c158487$var$isperrboundB = (5 + 72 * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d)) * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d);
const $4c0db2d93c158487$var$isperrboundC = (71 + 1408 * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d)) * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d) * (0, $f49abc0fa5df0d3a$export$6c421550c66a327d);
const $4c0db2d93c158487$var$ab = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $4c0db2d93c158487$var$bc = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $4c0db2d93c158487$var$cd = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $4c0db2d93c158487$var$de = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $4c0db2d93c158487$var$ea = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $4c0db2d93c158487$var$ac = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $4c0db2d93c158487$var$bd = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $4c0db2d93c158487$var$ce = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $4c0db2d93c158487$var$da = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $4c0db2d93c158487$var$eb = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(4);
const $4c0db2d93c158487$var$abc = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(24);
const $4c0db2d93c158487$var$bcd = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(24);
const $4c0db2d93c158487$var$cde = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(24);
const $4c0db2d93c158487$var$dea = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(24);
const $4c0db2d93c158487$var$eab = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(24);
const $4c0db2d93c158487$var$abd = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(24);
const $4c0db2d93c158487$var$bce = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(24);
const $4c0db2d93c158487$var$cda = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(24);
const $4c0db2d93c158487$var$deb = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(24);
const $4c0db2d93c158487$var$eac = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(24);
const $4c0db2d93c158487$var$adet = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(1152);
const $4c0db2d93c158487$var$bdet = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(1152);
const $4c0db2d93c158487$var$cdet = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(1152);
const $4c0db2d93c158487$var$ddet = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(1152);
const $4c0db2d93c158487$var$edet = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(1152);
const $4c0db2d93c158487$var$abdet = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(2304);
const $4c0db2d93c158487$var$cddet = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(2304);
const $4c0db2d93c158487$var$cdedet = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(3456);
const $4c0db2d93c158487$var$deter = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(5760);
const $4c0db2d93c158487$var$_8 = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(8);
const $4c0db2d93c158487$var$_8b = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(8);
const $4c0db2d93c158487$var$_8c = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(8);
const $4c0db2d93c158487$var$_16 = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(16);
const $4c0db2d93c158487$var$_24 = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(24);
const $4c0db2d93c158487$var$_48 = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(48);
const $4c0db2d93c158487$var$_48b = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(48);
const $4c0db2d93c158487$var$_96 = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(96);
const $4c0db2d93c158487$var$_192 = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(192);
const $4c0db2d93c158487$var$_384x = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(384);
const $4c0db2d93c158487$var$_384y = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(384);
const $4c0db2d93c158487$var$_384z = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(384);
const $4c0db2d93c158487$var$_768 = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(768);
function $4c0db2d93c158487$var$sum_three_scale(a, b, c, az, bz, cz, out) {
    return (0, $f49abc0fa5df0d3a$export$195a93e4bd4d876f)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, a, az, $4c0db2d93c158487$var$_8), $4c0db2d93c158487$var$_8, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, b, bz, $4c0db2d93c158487$var$_8b), $4c0db2d93c158487$var$_8b, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(4, c, cz, $4c0db2d93c158487$var$_8c), $4c0db2d93c158487$var$_8c, $4c0db2d93c158487$var$_16, out);
}
function $4c0db2d93c158487$var$liftexact(alen, a, blen, b, clen, c, dlen, d, x, y, z, out) {
    const len = (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)((0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)(alen, a, blen, b, $4c0db2d93c158487$var$_48), $4c0db2d93c158487$var$_48, (0, $f49abc0fa5df0d3a$export$aef51622e549b8b0)((0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)(clen, c, dlen, d, $4c0db2d93c158487$var$_48b), $4c0db2d93c158487$var$_48b), $4c0db2d93c158487$var$_48b, $4c0db2d93c158487$var$_96);
    return (0, $f49abc0fa5df0d3a$export$195a93e4bd4d876f)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len, $4c0db2d93c158487$var$_96, x, $4c0db2d93c158487$var$_192), $4c0db2d93c158487$var$_192, x, $4c0db2d93c158487$var$_384x), $4c0db2d93c158487$var$_384x, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len, $4c0db2d93c158487$var$_96, y, $4c0db2d93c158487$var$_192), $4c0db2d93c158487$var$_192, y, $4c0db2d93c158487$var$_384y), $4c0db2d93c158487$var$_384y, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len, $4c0db2d93c158487$var$_96, z, $4c0db2d93c158487$var$_192), $4c0db2d93c158487$var$_192, z, $4c0db2d93c158487$var$_384z), $4c0db2d93c158487$var$_384z, $4c0db2d93c158487$var$_768, out);
}
function $4c0db2d93c158487$var$insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
    s1 = ax * by;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ay;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $4c0db2d93c158487$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $4c0db2d93c158487$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $4c0db2d93c158487$var$ab[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $4c0db2d93c158487$var$ab[3] = u3;
    s1 = bx * cy;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * by;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $4c0db2d93c158487$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $4c0db2d93c158487$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $4c0db2d93c158487$var$bc[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $4c0db2d93c158487$var$bc[3] = u3;
    s1 = cx * dy;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * cy;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $4c0db2d93c158487$var$cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $4c0db2d93c158487$var$cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $4c0db2d93c158487$var$cd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $4c0db2d93c158487$var$cd[3] = u3;
    s1 = dx * ey;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * dy;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $4c0db2d93c158487$var$de[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $4c0db2d93c158487$var$de[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $4c0db2d93c158487$var$de[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $4c0db2d93c158487$var$de[3] = u3;
    s1 = ex * ay;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * ey;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $4c0db2d93c158487$var$ea[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $4c0db2d93c158487$var$ea[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $4c0db2d93c158487$var$ea[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $4c0db2d93c158487$var$ea[3] = u3;
    s1 = ax * cy;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cx * ay;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $4c0db2d93c158487$var$ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $4c0db2d93c158487$var$ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $4c0db2d93c158487$var$ac[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $4c0db2d93c158487$var$ac[3] = u3;
    s1 = bx * dy;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dx * by;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $4c0db2d93c158487$var$bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $4c0db2d93c158487$var$bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $4c0db2d93c158487$var$bd[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $4c0db2d93c158487$var$bd[3] = u3;
    s1 = cx * ey;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cx;
    ahi = c - (c - cx);
    alo = cx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ex * cy;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cy;
    bhi = c - (c - cy);
    blo = cy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $4c0db2d93c158487$var$ce[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $4c0db2d93c158487$var$ce[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $4c0db2d93c158487$var$ce[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $4c0db2d93c158487$var$ce[3] = u3;
    s1 = dx * ay;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * dx;
    ahi = c - (c - dx);
    alo = dx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ay;
    bhi = c - (c - ay);
    blo = ay - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = ax * dy;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ax;
    ahi = c - (c - ax);
    alo = ax - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * dy;
    bhi = c - (c - dy);
    blo = dy - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $4c0db2d93c158487$var$da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $4c0db2d93c158487$var$da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $4c0db2d93c158487$var$da[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $4c0db2d93c158487$var$da[3] = u3;
    s1 = ex * by;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ex;
    ahi = c - (c - ex);
    alo = ex - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * by;
    bhi = c - (c - by);
    blo = by - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bx * ey;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bx;
    ahi = c - (c - bx);
    alo = bx - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * ey;
    bhi = c - (c - ey);
    blo = ey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $4c0db2d93c158487$var$eb[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $4c0db2d93c158487$var$eb[1] = _0 - (_i + bvirt) + (bvirt - t1);
    u3 = _j + _i;
    bvirt = u3 - _j;
    $4c0db2d93c158487$var$eb[2] = _j - (u3 - bvirt) + (_i - bvirt);
    $4c0db2d93c158487$var$eb[3] = u3;
    const abclen = $4c0db2d93c158487$var$sum_three_scale($4c0db2d93c158487$var$ab, $4c0db2d93c158487$var$bc, $4c0db2d93c158487$var$ac, cz, az, -bz, $4c0db2d93c158487$var$abc);
    const bcdlen = $4c0db2d93c158487$var$sum_three_scale($4c0db2d93c158487$var$bc, $4c0db2d93c158487$var$cd, $4c0db2d93c158487$var$bd, dz, bz, -cz, $4c0db2d93c158487$var$bcd);
    const cdelen = $4c0db2d93c158487$var$sum_three_scale($4c0db2d93c158487$var$cd, $4c0db2d93c158487$var$de, $4c0db2d93c158487$var$ce, ez, cz, -dz, $4c0db2d93c158487$var$cde);
    const dealen = $4c0db2d93c158487$var$sum_three_scale($4c0db2d93c158487$var$de, $4c0db2d93c158487$var$ea, $4c0db2d93c158487$var$da, az, dz, -ez, $4c0db2d93c158487$var$dea);
    const eablen = $4c0db2d93c158487$var$sum_three_scale($4c0db2d93c158487$var$ea, $4c0db2d93c158487$var$ab, $4c0db2d93c158487$var$eb, bz, ez, -az, $4c0db2d93c158487$var$eab);
    const abdlen = $4c0db2d93c158487$var$sum_three_scale($4c0db2d93c158487$var$ab, $4c0db2d93c158487$var$bd, $4c0db2d93c158487$var$da, dz, az, bz, $4c0db2d93c158487$var$abd);
    const bcelen = $4c0db2d93c158487$var$sum_three_scale($4c0db2d93c158487$var$bc, $4c0db2d93c158487$var$ce, $4c0db2d93c158487$var$eb, ez, bz, cz, $4c0db2d93c158487$var$bce);
    const cdalen = $4c0db2d93c158487$var$sum_three_scale($4c0db2d93c158487$var$cd, $4c0db2d93c158487$var$da, $4c0db2d93c158487$var$ac, az, cz, dz, $4c0db2d93c158487$var$cda);
    const deblen = $4c0db2d93c158487$var$sum_three_scale($4c0db2d93c158487$var$de, $4c0db2d93c158487$var$eb, $4c0db2d93c158487$var$bd, bz, dz, ez, $4c0db2d93c158487$var$deb);
    const eaclen = $4c0db2d93c158487$var$sum_three_scale($4c0db2d93c158487$var$ea, $4c0db2d93c158487$var$ac, $4c0db2d93c158487$var$ce, cz, ez, az, $4c0db2d93c158487$var$eac);
    const deterlen = (0, $f49abc0fa5df0d3a$export$195a93e4bd4d876f)($4c0db2d93c158487$var$liftexact(cdelen, $4c0db2d93c158487$var$cde, bcelen, $4c0db2d93c158487$var$bce, deblen, $4c0db2d93c158487$var$deb, bcdlen, $4c0db2d93c158487$var$bcd, ax, ay, az, $4c0db2d93c158487$var$adet), $4c0db2d93c158487$var$adet, $4c0db2d93c158487$var$liftexact(dealen, $4c0db2d93c158487$var$dea, cdalen, $4c0db2d93c158487$var$cda, eaclen, $4c0db2d93c158487$var$eac, cdelen, $4c0db2d93c158487$var$cde, bx, by, bz, $4c0db2d93c158487$var$bdet), $4c0db2d93c158487$var$bdet, (0, $f49abc0fa5df0d3a$export$195a93e4bd4d876f)($4c0db2d93c158487$var$liftexact(eablen, $4c0db2d93c158487$var$eab, deblen, $4c0db2d93c158487$var$deb, abdlen, $4c0db2d93c158487$var$abd, dealen, $4c0db2d93c158487$var$dea, cx, cy, cz, $4c0db2d93c158487$var$cdet), $4c0db2d93c158487$var$cdet, $4c0db2d93c158487$var$liftexact(abclen, $4c0db2d93c158487$var$abc, eaclen, $4c0db2d93c158487$var$eac, bcelen, $4c0db2d93c158487$var$bce, eablen, $4c0db2d93c158487$var$eab, dx, dy, dz, $4c0db2d93c158487$var$ddet), $4c0db2d93c158487$var$ddet, $4c0db2d93c158487$var$liftexact(bcdlen, $4c0db2d93c158487$var$bcd, abdlen, $4c0db2d93c158487$var$abd, cdalen, $4c0db2d93c158487$var$cda, abclen, $4c0db2d93c158487$var$abc, ex, ey, ez, $4c0db2d93c158487$var$edet), $4c0db2d93c158487$var$edet, $4c0db2d93c158487$var$cddet, $4c0db2d93c158487$var$cdedet), $4c0db2d93c158487$var$cdedet, $4c0db2d93c158487$var$abdet, $4c0db2d93c158487$var$deter);
    return $4c0db2d93c158487$var$deter[deterlen - 1];
}
const $4c0db2d93c158487$var$xdet = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(96);
const $4c0db2d93c158487$var$ydet = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(96);
const $4c0db2d93c158487$var$zdet = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(96);
const $4c0db2d93c158487$var$fin = (0, $f49abc0fa5df0d3a$export$202e0172ed3c7be0)(1152);
function $4c0db2d93c158487$var$liftadapt(a, b, c, az, bz, cz, x, y, z, out) {
    const len = $4c0db2d93c158487$var$sum_three_scale(a, b, c, az, bz, cz, $4c0db2d93c158487$var$_24);
    return (0, $f49abc0fa5df0d3a$export$195a93e4bd4d876f)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len, $4c0db2d93c158487$var$_24, x, $4c0db2d93c158487$var$_48), $4c0db2d93c158487$var$_48, x, $4c0db2d93c158487$var$xdet), $4c0db2d93c158487$var$xdet, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len, $4c0db2d93c158487$var$_24, y, $4c0db2d93c158487$var$_48), $4c0db2d93c158487$var$_48, y, $4c0db2d93c158487$var$ydet), $4c0db2d93c158487$var$ydet, (0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)((0, $f49abc0fa5df0d3a$export$dcdf75081b88279d)(len, $4c0db2d93c158487$var$_24, z, $4c0db2d93c158487$var$_48), $4c0db2d93c158487$var$_48, z, $4c0db2d93c158487$var$zdet), $4c0db2d93c158487$var$zdet, $4c0db2d93c158487$var$_192, out);
}
function $4c0db2d93c158487$var$insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent) {
    let ab3, bc3, cd3, da3, ac3, bd3;
    let aextail, bextail, cextail, dextail;
    let aeytail, beytail, ceytail, deytail;
    let aeztail, beztail, ceztail, deztail;
    let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0;
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    s1 = aex * bey;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = bex * aey;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $4c0db2d93c158487$var$ab[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $4c0db2d93c158487$var$ab[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ab3 = _j + _i;
    bvirt = ab3 - _j;
    $4c0db2d93c158487$var$ab[2] = _j - (ab3 - bvirt) + (_i - bvirt);
    $4c0db2d93c158487$var$ab[3] = ab3;
    s1 = bex * cey;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * bey;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $4c0db2d93c158487$var$bc[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $4c0db2d93c158487$var$bc[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bc3 = _j + _i;
    bvirt = bc3 - _j;
    $4c0db2d93c158487$var$bc[2] = _j - (bc3 - bvirt) + (_i - bvirt);
    $4c0db2d93c158487$var$bc[3] = bc3;
    s1 = cex * dey;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * cey;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $4c0db2d93c158487$var$cd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $4c0db2d93c158487$var$cd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    cd3 = _j + _i;
    bvirt = cd3 - _j;
    $4c0db2d93c158487$var$cd[2] = _j - (cd3 - bvirt) + (_i - bvirt);
    $4c0db2d93c158487$var$cd[3] = cd3;
    s1 = dex * aey;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = aex * dey;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $4c0db2d93c158487$var$da[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $4c0db2d93c158487$var$da[1] = _0 - (_i + bvirt) + (bvirt - t1);
    da3 = _j + _i;
    bvirt = da3 - _j;
    $4c0db2d93c158487$var$da[2] = _j - (da3 - bvirt) + (_i - bvirt);
    $4c0db2d93c158487$var$da[3] = da3;
    s1 = aex * cey;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * aex;
    ahi = c - (c - aex);
    alo = aex - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cey;
    bhi = c - (c - cey);
    blo = cey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = cex * aey;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * cex;
    ahi = c - (c - cex);
    alo = cex - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * aey;
    bhi = c - (c - aey);
    blo = aey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $4c0db2d93c158487$var$ac[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $4c0db2d93c158487$var$ac[1] = _0 - (_i + bvirt) + (bvirt - t1);
    ac3 = _j + _i;
    bvirt = ac3 - _j;
    $4c0db2d93c158487$var$ac[2] = _j - (ac3 - bvirt) + (_i - bvirt);
    $4c0db2d93c158487$var$ac[3] = ac3;
    s1 = bex * dey;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bex;
    ahi = c - (c - bex);
    alo = bex - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * dey;
    bhi = c - (c - dey);
    blo = dey - bhi;
    s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
    t1 = dex * bey;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * dex;
    ahi = c - (c - dex);
    alo = dex - ahi;
    c = (0, $f49abc0fa5df0d3a$export$8cfde575cbd41e40) * bey;
    bhi = c - (c - bey);
    blo = bey - bhi;
    t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
    _i = s0 - t0;
    bvirt = s0 - _i;
    $4c0db2d93c158487$var$bd[0] = s0 - (_i + bvirt) + (bvirt - t0);
    _j = s1 + _i;
    bvirt = _j - s1;
    _0 = s1 - (_j - bvirt) + (_i - bvirt);
    _i = _0 - t1;
    bvirt = _0 - _i;
    $4c0db2d93c158487$var$bd[1] = _0 - (_i + bvirt) + (bvirt - t1);
    bd3 = _j + _i;
    bvirt = bd3 - _j;
    $4c0db2d93c158487$var$bd[2] = _j - (bd3 - bvirt) + (_i - bvirt);
    $4c0db2d93c158487$var$bd[3] = bd3;
    const finlen = (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)((0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)((0, $f49abc0fa5df0d3a$export$aef51622e549b8b0)($4c0db2d93c158487$var$liftadapt($4c0db2d93c158487$var$bc, $4c0db2d93c158487$var$cd, $4c0db2d93c158487$var$bd, dez, bez, -cez, aex, aey, aez, $4c0db2d93c158487$var$adet), $4c0db2d93c158487$var$adet), $4c0db2d93c158487$var$adet, $4c0db2d93c158487$var$liftadapt($4c0db2d93c158487$var$cd, $4c0db2d93c158487$var$da, $4c0db2d93c158487$var$ac, aez, cez, dez, bex, bey, bez, $4c0db2d93c158487$var$bdet), $4c0db2d93c158487$var$bdet, $4c0db2d93c158487$var$abdet), $4c0db2d93c158487$var$abdet, (0, $f49abc0fa5df0d3a$export$8a63f25cc62965f1)((0, $f49abc0fa5df0d3a$export$aef51622e549b8b0)($4c0db2d93c158487$var$liftadapt($4c0db2d93c158487$var$da, $4c0db2d93c158487$var$ab, $4c0db2d93c158487$var$bd, bez, dez, aez, cex, cey, cez, $4c0db2d93c158487$var$cdet), $4c0db2d93c158487$var$cdet), $4c0db2d93c158487$var$cdet, $4c0db2d93c158487$var$liftadapt($4c0db2d93c158487$var$ab, $4c0db2d93c158487$var$bc, $4c0db2d93c158487$var$ac, cez, aez, -bez, dex, dey, dez, $4c0db2d93c158487$var$ddet), $4c0db2d93c158487$var$ddet, $4c0db2d93c158487$var$cddet), $4c0db2d93c158487$var$cddet, $4c0db2d93c158487$var$fin);
    let det = (0, $f49abc0fa5df0d3a$export$9f3a0795ca2cc944)(finlen, $4c0db2d93c158487$var$fin);
    let errbound = $4c0db2d93c158487$var$isperrboundB * permanent;
    if (det >= errbound || -det >= errbound) return det;
    bvirt = ax - aex;
    aextail = ax - (aex + bvirt) + (bvirt - ex);
    bvirt = ay - aey;
    aeytail = ay - (aey + bvirt) + (bvirt - ey);
    bvirt = az - aez;
    aeztail = az - (aez + bvirt) + (bvirt - ez);
    bvirt = bx - bex;
    bextail = bx - (bex + bvirt) + (bvirt - ex);
    bvirt = by - bey;
    beytail = by - (bey + bvirt) + (bvirt - ey);
    bvirt = bz - bez;
    beztail = bz - (bez + bvirt) + (bvirt - ez);
    bvirt = cx - cex;
    cextail = cx - (cex + bvirt) + (bvirt - ex);
    bvirt = cy - cey;
    ceytail = cy - (cey + bvirt) + (bvirt - ey);
    bvirt = cz - cez;
    ceztail = cz - (cez + bvirt) + (bvirt - ez);
    bvirt = dx - dex;
    dextail = dx - (dex + bvirt) + (bvirt - ex);
    bvirt = dy - dey;
    deytail = dy - (dey + bvirt) + (bvirt - ey);
    bvirt = dz - dez;
    deztail = dz - (dez + bvirt) + (bvirt - ez);
    if (aextail === 0 && aeytail === 0 && aeztail === 0 && bextail === 0 && beytail === 0 && beztail === 0 && cextail === 0 && ceytail === 0 && ceztail === 0 && dextail === 0 && deytail === 0 && deztail === 0) return det;
    errbound = $4c0db2d93c158487$var$isperrboundC * permanent + (0, $f49abc0fa5df0d3a$export$a4103c3ab16b06d7) * Math.abs(det);
    const abeps = aex * beytail + bey * aextail - (aey * bextail + bex * aeytail);
    const bceps = bex * ceytail + cey * bextail - (bey * cextail + cex * beytail);
    const cdeps = cex * deytail + dey * cextail - (cey * dextail + dex * ceytail);
    const daeps = dex * aeytail + aey * dextail - (dey * aextail + aex * deytail);
    const aceps = aex * ceytail + cey * aextail - (aey * cextail + cex * aeytail);
    const bdeps = bex * deytail + dey * bextail - (bey * dextail + dex * beytail);
    det += (bex * bex + bey * bey + bez * bez) * (cez * daeps + dez * aceps + aez * cdeps + (ceztail * da3 + deztail * ac3 + aeztail * cd3)) + (dex * dex + dey * dey + dez * dez) * (aez * bceps - bez * aceps + cez * abeps + (aeztail * bc3 - beztail * ac3 + ceztail * ab3)) - ((aex * aex + aey * aey + aez * aez) * (bez * cdeps - cez * bdeps + dez * bceps + (beztail * cd3 - ceztail * bd3 + deztail * bc3)) + (cex * cex + cey * cey + cez * cez) * (dez * abeps + aez * bdeps + bez * daeps + (deztail * ab3 + aeztail * bd3 + beztail * da3))) + 2 * ((bex * bextail + bey * beytail + bez * beztail) * (cez * da3 + dez * ac3 + aez * cd3) + (dex * dextail + dey * deytail + dez * deztail) * (aez * bc3 - bez * ac3 + cez * ab3) - ((aex * aextail + aey * aeytail + aez * aeztail) * (bez * cd3 - cez * bd3 + dez * bc3) + (cex * cextail + cey * ceytail + cez * ceztail) * (dez * ab3 + aez * bd3 + bez * da3)));
    if (det >= errbound || -det >= errbound) return det;
    return $4c0db2d93c158487$var$insphereexact(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez);
}
function $4c0db2d93c158487$export$7846ecd8d3a5d1ac(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez) {
    const aex = ax - ex;
    const bex = bx - ex;
    const cex = cx - ex;
    const dex = dx - ex;
    const aey = ay - ey;
    const bey = by - ey;
    const cey = cy - ey;
    const dey = dy - ey;
    const aez = az - ez;
    const bez = bz - ez;
    const cez = cz - ez;
    const dez = dz - ez;
    const aexbey = aex * bey;
    const bexaey = bex * aey;
    const ab = aexbey - bexaey;
    const bexcey = bex * cey;
    const cexbey = cex * bey;
    const bc = bexcey - cexbey;
    const cexdey = cex * dey;
    const dexcey = dex * cey;
    const cd = cexdey - dexcey;
    const dexaey = dex * aey;
    const aexdey = aex * dey;
    const da = dexaey - aexdey;
    const aexcey = aex * cey;
    const cexaey = cex * aey;
    const ac = aexcey - cexaey;
    const bexdey = bex * dey;
    const dexbey = dex * bey;
    const bd = bexdey - dexbey;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    const det = clift * (dez * ab + aez * bd + bez * da) - dlift * (aez * bc - bez * ac + cez * ab) + (alift * (bez * cd - cez * bd + dez * bc) - blift * (cez * da + dez * ac + aez * cd));
    const aezplus = Math.abs(aez);
    const bezplus = Math.abs(bez);
    const cezplus = Math.abs(cez);
    const dezplus = Math.abs(dez);
    const aexbeyplus = Math.abs(aexbey) + Math.abs(bexaey);
    const bexceyplus = Math.abs(bexcey) + Math.abs(cexbey);
    const cexdeyplus = Math.abs(cexdey) + Math.abs(dexcey);
    const dexaeyplus = Math.abs(dexaey) + Math.abs(aexdey);
    const aexceyplus = Math.abs(aexcey) + Math.abs(cexaey);
    const bexdeyplus = Math.abs(bexdey) + Math.abs(dexbey);
    const permanent = (cexdeyplus * bezplus + bexdeyplus * cezplus + bexceyplus * dezplus) * alift + (dexaeyplus * cezplus + aexceyplus * dezplus + cexdeyplus * aezplus) * blift + (aexbeyplus * dezplus + bexdeyplus * aezplus + dexaeyplus * bezplus) * clift + (bexceyplus * aezplus + aexceyplus * bezplus + aexbeyplus * cezplus) * dlift;
    const errbound = $4c0db2d93c158487$var$isperrboundA * permanent;
    if (det > errbound || -det > errbound) return det;
    return -$4c0db2d93c158487$var$insphereadapt(ax, ay, az, bx, by, bz, cx, cy, cz, dx, dy, dz, ex, ey, ez, permanent);
}
function $4c0db2d93c158487$export$11235b985c819946(pax, pay, paz, pbx, pby, pbz, pcx, pcy, pcz, pdx, pdy, pdz, pex, pey, pez) {
    const aex = pax - pex;
    const bex = pbx - pex;
    const cex = pcx - pex;
    const dex = pdx - pex;
    const aey = pay - pey;
    const bey = pby - pey;
    const cey = pcy - pey;
    const dey = pdy - pey;
    const aez = paz - pez;
    const bez = pbz - pez;
    const cez = pcz - pez;
    const dez = pdz - pez;
    const ab = aex * bey - bex * aey;
    const bc = bex * cey - cex * bey;
    const cd = cex * dey - dex * cey;
    const da = dex * aey - aex * dey;
    const ac = aex * cey - cex * aey;
    const bd = bex * dey - dex * bey;
    const abc = aez * bc - bez * ac + cez * ab;
    const bcd = bez * cd - cez * bd + dez * bc;
    const cda = cez * da + dez * ac + aez * cd;
    const dab = dez * ab + aez * bd + bez * da;
    const alift = aex * aex + aey * aey + aez * aez;
    const blift = bex * bex + bey * bey + bez * bez;
    const clift = cex * cex + cey * cey + cez * cez;
    const dlift = dex * dex + dey * dey + dez * dez;
    return clift * dab - dlift * abc + (alift * bcd - blift * cda);
}




const $8fcaeb076b10b4b2$var$EPSILON = Math.pow(2, -52);
const $8fcaeb076b10b4b2$var$EDGE_STACK = new Uint32Array(512);
class $8fcaeb076b10b4b2$export$2e2bcd8739ae039 {
    static from(points, getX = $8fcaeb076b10b4b2$var$defaultGetX, getY = $8fcaeb076b10b4b2$var$defaultGetY) {
        const n = points.length;
        const coords = new Float64Array(n * 2);
        for(let i = 0; i < n; i++){
            const p = points[i];
            coords[2 * i] = getX(p);
            coords[2 * i + 1] = getY(p);
        }
        return new $8fcaeb076b10b4b2$export$2e2bcd8739ae039(coords);
    }
    constructor(coords){
        const n = coords.length >> 1;
        if (n > 0 && typeof coords[0] !== "number") throw new Error("Expected coords to contain numbers.");
        this.coords = coords;
        // arrays that will store the triangulation graph
        const maxTriangles = Math.max(2 * n - 5, 0);
        this._triangles = new Uint32Array(maxTriangles * 3);
        this._halfedges = new Int32Array(maxTriangles * 3);
        // temporary arrays for tracking the edges of the advancing convex hull
        this._hashSize = Math.ceil(Math.sqrt(n));
        this._hullPrev = new Uint32Array(n); // edge to prev edge
        this._hullNext = new Uint32Array(n); // edge to next edge
        this._hullTri = new Uint32Array(n); // edge to adjacent triangle
        this._hullHash = new Int32Array(this._hashSize); // angular edge hash
        // temporary arrays for sorting points
        this._ids = new Uint32Array(n);
        this._dists = new Float64Array(n);
        this.update();
    }
    update() {
        const { coords: coords, _hullPrev: hullPrev, _hullNext: hullNext, _hullTri: hullTri, _hullHash: hullHash } = this;
        const n = coords.length >> 1;
        // populate an array of point indices; calculate input data bbox
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for(let i = 0; i < n; i++){
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            this._ids[i] = i;
        }
        const cx = (minX + maxX) / 2;
        const cy = (minY + maxY) / 2;
        let i0, i1, i2;
        // pick a seed point close to the center
        for(let i = 0, minDist = Infinity; i < n; i++){
            const d = $8fcaeb076b10b4b2$var$dist(cx, cy, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist) {
                i0 = i;
                minDist = d;
            }
        }
        const i0x = coords[2 * i0];
        const i0y = coords[2 * i0 + 1];
        // find the point closest to the seed
        for(let i = 0, minDist = Infinity; i < n; i++){
            if (i === i0) continue;
            const d = $8fcaeb076b10b4b2$var$dist(i0x, i0y, coords[2 * i], coords[2 * i + 1]);
            if (d < minDist && d > 0) {
                i1 = i;
                minDist = d;
            }
        }
        let i1x = coords[2 * i1];
        let i1y = coords[2 * i1 + 1];
        let minRadius = Infinity;
        // find the third point which forms the smallest circumcircle with the first two
        for(let i = 0; i < n; i++){
            if (i === i0 || i === i1) continue;
            const r = $8fcaeb076b10b4b2$var$circumradius(i0x, i0y, i1x, i1y, coords[2 * i], coords[2 * i + 1]);
            if (r < minRadius) {
                i2 = i;
                minRadius = r;
            }
        }
        let i2x = coords[2 * i2];
        let i2y = coords[2 * i2 + 1];
        if (minRadius === Infinity) {
            // order collinear points by dx (or dy if all x are identical)
            // and return the list as a hull
            for(let i = 0; i < n; i++)this._dists[i] = coords[2 * i] - coords[0] || coords[2 * i + 1] - coords[1];
            $8fcaeb076b10b4b2$var$quicksort(this._ids, this._dists, 0, n - 1);
            const hull = new Uint32Array(n);
            let j = 0;
            for(let i = 0, d0 = -Infinity; i < n; i++){
                const id = this._ids[i];
                const d = this._dists[id];
                if (d > d0) {
                    hull[j++] = id;
                    d0 = d;
                }
            }
            this.hull = hull.subarray(0, j);
            this.triangles = new Uint32Array(0);
            this.halfedges = new Uint32Array(0);
            return;
        }
        // swap the order of the seed points for counter-clockwise orientation
        if ((0, $4cdf8e751ad0c338$export$bbb923599a46a7d8)(i0x, i0y, i1x, i1y, i2x, i2y) < 0) {
            const i = i1;
            const x = i1x;
            const y = i1y;
            i1 = i2;
            i1x = i2x;
            i1y = i2y;
            i2 = i;
            i2x = x;
            i2y = y;
        }
        const center = $8fcaeb076b10b4b2$var$circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
        this._cx = center.x;
        this._cy = center.y;
        for(let i = 0; i < n; i++)this._dists[i] = $8fcaeb076b10b4b2$var$dist(coords[2 * i], coords[2 * i + 1], center.x, center.y);
        // sort the points by distance from the seed triangle circumcenter
        $8fcaeb076b10b4b2$var$quicksort(this._ids, this._dists, 0, n - 1);
        // set up the seed triangle as the starting hull
        this._hullStart = i0;
        let hullSize = 3;
        hullNext[i0] = hullPrev[i2] = i1;
        hullNext[i1] = hullPrev[i0] = i2;
        hullNext[i2] = hullPrev[i1] = i0;
        hullTri[i0] = 0;
        hullTri[i1] = 1;
        hullTri[i2] = 2;
        hullHash.fill(-1);
        hullHash[this._hashKey(i0x, i0y)] = i0;
        hullHash[this._hashKey(i1x, i1y)] = i1;
        hullHash[this._hashKey(i2x, i2y)] = i2;
        this.trianglesLen = 0;
        this._addTriangle(i0, i1, i2, -1, -1, -1);
        for(let k = 0, xp, yp; k < this._ids.length; k++){
            const i = this._ids[k];
            const x = coords[2 * i];
            const y = coords[2 * i + 1];
            // skip near-duplicate points
            if (k > 0 && Math.abs(x - xp) <= $8fcaeb076b10b4b2$var$EPSILON && Math.abs(y - yp) <= $8fcaeb076b10b4b2$var$EPSILON) continue;
            xp = x;
            yp = y;
            // skip seed triangle points
            if (i === i0 || i === i1 || i === i2) continue;
            // find a visible edge on the convex hull using edge hash
            let start = 0;
            for(let j = 0, key = this._hashKey(x, y); j < this._hashSize; j++){
                start = hullHash[(key + j) % this._hashSize];
                if (start !== -1 && start !== hullNext[start]) break;
            }
            start = hullPrev[start];
            let e = start, q;
            while(q = hullNext[e], (0, $4cdf8e751ad0c338$export$bbb923599a46a7d8)(x, y, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1]) >= 0){
                e = q;
                if (e === start) {
                    e = -1;
                    break;
                }
            }
            if (e === -1) continue; // likely a near-duplicate point; skip it
            // add the first triangle from the point
            let t = this._addTriangle(e, i, hullNext[e], -1, -1, hullTri[e]);
            // recursively flip triangles from the point until they satisfy the Delaunay condition
            hullTri[i] = this._legalize(t + 2);
            hullTri[e] = t; // keep track of boundary triangles on the hull
            hullSize++;
            // walk forward through the hull, adding more triangles and flipping recursively
            let n = hullNext[e];
            while(q = hullNext[n], (0, $4cdf8e751ad0c338$export$bbb923599a46a7d8)(x, y, coords[2 * n], coords[2 * n + 1], coords[2 * q], coords[2 * q + 1]) < 0){
                t = this._addTriangle(n, i, q, hullTri[i], -1, hullTri[n]);
                hullTri[i] = this._legalize(t + 2);
                hullNext[n] = n; // mark as removed
                hullSize--;
                n = q;
            }
            // walk backward from the other side, adding more triangles and flipping
            if (e === start) while(q = hullPrev[e], (0, $4cdf8e751ad0c338$export$bbb923599a46a7d8)(x, y, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1]) < 0){
                t = this._addTriangle(q, i, e, -1, hullTri[e], hullTri[q]);
                this._legalize(t + 2);
                hullTri[q] = t;
                hullNext[e] = e; // mark as removed
                hullSize--;
                e = q;
            }
            // update the hull indices
            this._hullStart = hullPrev[i] = e;
            hullNext[e] = hullPrev[n] = i;
            hullNext[i] = n;
            // save the two new edges in the hash table
            hullHash[this._hashKey(x, y)] = i;
            hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
        }
        this.hull = new Uint32Array(hullSize);
        for(let i = 0, e = this._hullStart; i < hullSize; i++){
            this.hull[i] = e;
            e = hullNext[e];
        }
        // trim typed triangle mesh arrays
        this.triangles = this._triangles.subarray(0, this.trianglesLen);
        this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
    }
    _hashKey(x, y) {
        return Math.floor($8fcaeb076b10b4b2$var$pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
    }
    _legalize(a) {
        const { _triangles: triangles, _halfedges: halfedges, coords: coords } = this;
        let i = 0;
        let ar = 0;
        // recursion eliminated with a fixed-size stack
        while(true){
            const b = halfedges[a];
            /* if the pair of triangles doesn't satisfy the Delaunay condition
             * (p1 is inside the circumcircle of [p0, pl, pr]), flip them,
             * then do the same check/flip recursively for the new pair of triangles
             *
             *           pl                    pl
             *          /||\                  /  \
             *       al/ || \bl            al/    \a
             *        /  ||  \              /      \
             *       /  a||b  \    flip    /___ar___\
             *     p0\   ||   /p1   =>   p0\---bl---/p1
             *        \  ||  /              \      /
             *       ar\ || /br             b\    /br
             *          \||/                  \  /
             *           pr                    pr
             */ const a0 = a - a % 3;
            ar = a0 + (a + 2) % 3;
            if (b === -1) {
                if (i === 0) break;
                a = $8fcaeb076b10b4b2$var$EDGE_STACK[--i];
                continue;
            }
            const b0 = b - b % 3;
            const al = a0 + (a + 1) % 3;
            const bl = b0 + (b + 2) % 3;
            const p0 = triangles[ar];
            const pr = triangles[a];
            const pl = triangles[al];
            const p1 = triangles[bl];
            const illegal = $8fcaeb076b10b4b2$var$inCircle(coords[2 * p0], coords[2 * p0 + 1], coords[2 * pr], coords[2 * pr + 1], coords[2 * pl], coords[2 * pl + 1], coords[2 * p1], coords[2 * p1 + 1]);
            if (illegal) {
                triangles[a] = p1;
                triangles[b] = p0;
                const hbl = halfedges[bl];
                // edge swapped on the other side of the hull (rare); fix the halfedge reference
                if (hbl === -1) {
                    let e = this._hullStart;
                    do {
                        if (this._hullTri[e] === bl) {
                            this._hullTri[e] = a;
                            break;
                        }
                        e = this._hullPrev[e];
                    }while (e !== this._hullStart);
                }
                this._link(a, hbl);
                this._link(b, halfedges[ar]);
                this._link(ar, bl);
                const br = b0 + (b + 1) % 3;
                // don't worry about hitting the cap: it can only happen on extremely degenerate input
                if (i < $8fcaeb076b10b4b2$var$EDGE_STACK.length) $8fcaeb076b10b4b2$var$EDGE_STACK[i++] = br;
            } else {
                if (i === 0) break;
                a = $8fcaeb076b10b4b2$var$EDGE_STACK[--i];
            }
        }
        return ar;
    }
    _link(a, b) {
        this._halfedges[a] = b;
        if (b !== -1) this._halfedges[b] = a;
    }
    // add a new triangle given vertex indices and adjacent half-edge ids
    _addTriangle(i0, i1, i2, a, b, c) {
        const t = this.trianglesLen;
        this._triangles[t] = i0;
        this._triangles[t + 1] = i1;
        this._triangles[t + 2] = i2;
        this._link(t, a);
        this._link(t + 1, b);
        this._link(t + 2, c);
        this.trianglesLen += 3;
        return t;
    }
}
// monotonically increases with real angle, but doesn't need expensive trigonometry
function $8fcaeb076b10b4b2$var$pseudoAngle(dx, dy) {
    const p = dx / (Math.abs(dx) + Math.abs(dy));
    return (dy > 0 ? 3 - p : 1 + p) / 4; // [0..1]
}
function $8fcaeb076b10b4b2$var$dist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}
function $8fcaeb076b10b4b2$var$inCircle(ax, ay, bx, by, cx, cy, px, py) {
    const dx = ax - px;
    const dy = ay - py;
    const ex = bx - px;
    const ey = by - py;
    const fx = cx - px;
    const fy = cy - py;
    const ap = dx * dx + dy * dy;
    const bp = ex * ex + ey * ey;
    const cp = fx * fx + fy * fy;
    return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
}
function $8fcaeb076b10b4b2$var$circumradius(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = (ey * bl - dy * cl) * d;
    const y = (dx * cl - ex * bl) * d;
    return x * x + y * y;
}
function $8fcaeb076b10b4b2$var$circumcenter(ax, ay, bx, by, cx, cy) {
    const dx = bx - ax;
    const dy = by - ay;
    const ex = cx - ax;
    const ey = cy - ay;
    const bl = dx * dx + dy * dy;
    const cl = ex * ex + ey * ey;
    const d = 0.5 / (dx * ey - dy * ex);
    const x = ax + (ey * bl - dy * cl) * d;
    const y = ay + (dx * cl - ex * bl) * d;
    return {
        x: x,
        y: y
    };
}
function $8fcaeb076b10b4b2$var$quicksort(ids, dists, left, right) {
    if (right - left <= 20) for(let i = left + 1; i <= right; i++){
        const temp = ids[i];
        const tempDist = dists[temp];
        let j = i - 1;
        while(j >= left && dists[ids[j]] > tempDist)ids[j + 1] = ids[j--];
        ids[j + 1] = temp;
    }
    else {
        const median = left + right >> 1;
        let i = left + 1;
        let j = right;
        $8fcaeb076b10b4b2$var$swap(ids, median, i);
        if (dists[ids[left]] > dists[ids[right]]) $8fcaeb076b10b4b2$var$swap(ids, left, right);
        if (dists[ids[i]] > dists[ids[right]]) $8fcaeb076b10b4b2$var$swap(ids, i, right);
        if (dists[ids[left]] > dists[ids[i]]) $8fcaeb076b10b4b2$var$swap(ids, left, i);
        const temp = ids[i];
        const tempDist = dists[temp];
        while(true){
            do i++;
            while (dists[ids[i]] < tempDist);
            do j--;
            while (dists[ids[j]] > tempDist);
            if (j < i) break;
            $8fcaeb076b10b4b2$var$swap(ids, i, j);
        }
        ids[left + 1] = ids[j];
        ids[j] = temp;
        if (right - i + 1 >= j - left) {
            $8fcaeb076b10b4b2$var$quicksort(ids, dists, i, right);
            $8fcaeb076b10b4b2$var$quicksort(ids, dists, left, j - 1);
        } else {
            $8fcaeb076b10b4b2$var$quicksort(ids, dists, left, j - 1);
            $8fcaeb076b10b4b2$var$quicksort(ids, dists, i, right);
        }
    }
}
function $8fcaeb076b10b4b2$var$swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
function $8fcaeb076b10b4b2$var$defaultGetX(p) {
    return p[0];
}
function $8fcaeb076b10b4b2$var$defaultGetY(p) {
    return p[1];
}


const $3cff57ce5885ac04$var$epsilon = 1e-6;
class $3cff57ce5885ac04$export$2e2bcd8739ae039 {
    constructor(){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
    }
    moveTo(x, y) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    }
    lineTo(x, y) {
        this._ += `L${this._x1 = +x},${this._y1 = +y}`;
    }
    arc(x, y, r) {
        x = +x, y = +y, r = +r;
        const x0 = x + r;
        const y0 = y;
        if (r < 0) throw new Error("negative radius");
        if (this._x1 === null) this._ += `M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $3cff57ce5885ac04$var$epsilon || Math.abs(this._y1 - y0) > $3cff57ce5885ac04$var$epsilon) this._ += "L" + x0 + "," + y0;
        if (!r) return;
        this._ += `A${r},${r},0,1,1,${x - r},${y}A${r},${r},0,1,1,${this._x1 = x0},${this._y1 = y0}`;
    }
    rect(x, y, w, h) {
        this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${+w}v${+h}h${-w}Z`;
    }
    value() {
        return this._ || null;
    }
}


class $e9df2dec18ce682a$export$2e2bcd8739ae039 {
    constructor(){
        this._ = [];
    }
    moveTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    closePath() {
        this._.push(this._[0].slice());
    }
    lineTo(x, y) {
        this._.push([
            x,
            y
        ]);
    }
    value() {
        return this._.length ? this._ : null;
    }
}




class $92f35b159a54333c$export$2e2bcd8739ae039 {
    constructor(delaunay, [xmin, ymin, xmax, ymax] = [
        0,
        0,
        960,
        500
    ]){
        if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
        this.delaunay = delaunay;
        this._circumcenters = new Float64Array(delaunay.points.length * 2);
        this.vectors = new Float64Array(delaunay.points.length * 2);
        this.xmax = xmax, this.xmin = xmin;
        this.ymax = ymax, this.ymin = ymin;
        this._init();
    }
    update() {
        this.delaunay.update();
        this._init();
        return this;
    }
    _init() {
        const { delaunay: { points: points, hull: hull, triangles: triangles }, vectors: vectors } = this;
        let bx, by; // lazily computed barycenter of the hull
        // Compute circumcenters.
        const circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
        for(let i = 0, j = 0, n = triangles.length, x, y; i < n; i += 3, j += 2){
            const t1 = triangles[i] * 2;
            const t2 = triangles[i + 1] * 2;
            const t3 = triangles[i + 2] * 2;
            const x1 = points[t1];
            const y1 = points[t1 + 1];
            const x2 = points[t2];
            const y2 = points[t2 + 1];
            const x3 = points[t3];
            const y3 = points[t3 + 1];
            const dx = x2 - x1;
            const dy = y2 - y1;
            const ex = x3 - x1;
            const ey = y3 - y1;
            const ab = (dx * ey - dy * ex) * 2;
            if (Math.abs(ab) < 1e-9) {
                // For a degenerate triangle, the circumcenter is at the infinity, in a
                // direction orthogonal to the halfedge and away from the “center” of
                // the diagram <bx, by>, defined as the hull’s barycenter.
                if (bx === undefined) {
                    bx = by = 0;
                    for (const i of hull)bx += points[i * 2], by += points[i * 2 + 1];
                    bx /= hull.length, by /= hull.length;
                }
                const a = 1e9 * Math.sign((bx - x1) * ey - (by - y1) * ex);
                x = (x1 + x3) / 2 - a * ey;
                y = (y1 + y3) / 2 + a * ex;
            } else {
                const d = 1 / ab;
                const bl = dx * dx + dy * dy;
                const cl = ex * ex + ey * ey;
                x = x1 + (ey * bl - dy * cl) * d;
                y = y1 + (dx * cl - ex * bl) * d;
            }
            circumcenters[j] = x;
            circumcenters[j + 1] = y;
        }
        // Compute exterior cell rays.
        let h = hull[hull.length - 1];
        let p0, p1 = h * 4;
        let x0, x1 = points[2 * h];
        let y0, y1 = points[2 * h + 1];
        vectors.fill(0);
        for(let i = 0; i < hull.length; ++i){
            h = hull[i];
            p0 = p1, x0 = x1, y0 = y1;
            p1 = h * 4, x1 = points[2 * h], y1 = points[2 * h + 1];
            vectors[p0 + 2] = vectors[p1] = y0 - y1;
            vectors[p0 + 3] = vectors[p1 + 1] = x1 - x0;
        }
    }
    render(context) {
        const buffer = context == null ? context = new (0, $3cff57ce5885ac04$export$2e2bcd8739ae039) : undefined;
        const { delaunay: { halfedges: halfedges, inedges: inedges, hull: hull }, circumcenters: circumcenters, vectors: vectors } = this;
        if (hull.length <= 1) return null;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = Math.floor(i / 3) * 2;
            const tj = Math.floor(j / 3) * 2;
            const xi = circumcenters[ti];
            const yi = circumcenters[ti + 1];
            const xj = circumcenters[tj];
            const yj = circumcenters[tj + 1];
            this._renderSegment(xi, yi, xj, yj, context);
        }
        let h0, h1 = hull[hull.length - 1];
        for(let i = 0; i < hull.length; ++i){
            h0 = h1, h1 = hull[i];
            const t = Math.floor(inedges[h1] / 3) * 2;
            const x = circumcenters[t];
            const y = circumcenters[t + 1];
            const v = h0 * 4;
            const p = this._project(x, y, vectors[v + 2], vectors[v + 3]);
            if (p) this._renderSegment(x, y, p[0], p[1], context);
        }
        return buffer && buffer.value();
    }
    renderBounds(context) {
        const buffer = context == null ? context = new (0, $3cff57ce5885ac04$export$2e2bcd8739ae039) : undefined;
        context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
        return buffer && buffer.value();
    }
    renderCell(i, context) {
        const buffer = context == null ? context = new (0, $3cff57ce5885ac04$export$2e2bcd8739ae039) : undefined;
        const points = this._clip(i);
        if (points === null || !points.length) return;
        context.moveTo(points[0], points[1]);
        let n = points.length;
        while(points[0] === points[n - 2] && points[1] === points[n - 1] && n > 1)n -= 2;
        for(let i = 2; i < n; i += 2)if (points[i] !== points[i - 2] || points[i + 1] !== points[i - 1]) context.lineTo(points[i], points[i + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *cellPolygons() {
        const { delaunay: { points: points } } = this;
        for(let i = 0, n = points.length / 2; i < n; ++i){
            const cell = this.cellPolygon(i);
            if (cell) cell.index = i, yield cell;
        }
    }
    cellPolygon(i) {
        const polygon = new (0, $e9df2dec18ce682a$export$2e2bcd8739ae039);
        this.renderCell(i, polygon);
        return polygon.value();
    }
    _renderSegment(x0, y0, x1, y1, context) {
        let S;
        const c0 = this._regioncode(x0, y0);
        const c1 = this._regioncode(x1, y1);
        if (c0 === 0 && c1 === 0) {
            context.moveTo(x0, y0);
            context.lineTo(x1, y1);
        } else if (S = this._clipSegment(x0, y0, x1, y1, c0, c1)) {
            context.moveTo(S[0], S[1]);
            context.lineTo(S[2], S[3]);
        }
    }
    contains(i, x, y) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return false;
        return this.delaunay._step(i, x, y) === i;
    }
    *neighbors(i) {
        const ci = this._clip(i);
        if (ci) for (const j of this.delaunay.neighbors(i)){
            const cj = this._clip(j);
            // find the common edge
            if (cj) loop: for(let ai = 0, li = ci.length; ai < li; ai += 2){
                for(let aj = 0, lj = cj.length; aj < lj; aj += 2)if (ci[ai] === cj[aj] && ci[ai + 1] === cj[aj + 1] && ci[(ai + 2) % li] === cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] === cj[(aj + lj - 1) % lj]) {
                    yield j;
                    break loop;
                }
            }
        }
    }
    _cell(i) {
        const { circumcenters: circumcenters, delaunay: { inedges: inedges, halfedges: halfedges, triangles: triangles } } = this;
        const e0 = inedges[i];
        if (e0 === -1) return null; // coincident point
        const points = [];
        let e = e0;
        do {
            const t = Math.floor(e / 3);
            points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
        }while (e !== e0 && e !== -1);
        return points;
    }
    _clip(i) {
        // degenerate case (1 valid point: return the box)
        if (i === 0 && this.delaunay.hull.length === 1) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        const points = this._cell(i);
        if (points === null) return null;
        const { vectors: V } = this;
        const v = i * 4;
        return this._simplify(V[v] || V[v + 1] ? this._clipInfinite(i, points, V[v], V[v + 1], V[v + 2], V[v + 3]) : this._clipFinite(i, points));
    }
    _clipFinite(i, points) {
        const n = points.length;
        let P = null;
        let x0, y0, x1 = points[n - 2], y1 = points[n - 1];
        let c0, c1 = this._regioncode(x1, y1);
        let e0, e1 = 0;
        for(let j = 0; j < n; j += 2){
            x0 = x1, y0 = y1, x1 = points[j], y1 = points[j + 1];
            c0 = c1, c1 = this._regioncode(x1, y1);
            if (c0 === 0 && c1 === 0) {
                e0 = e1, e1 = 0;
                if (P) P.push(x1, y1);
                else P = [
                    x1,
                    y1
                ];
            } else {
                let S, sx0, sy0, sx1, sy1;
                if (c0 === 0) {
                    if ((S = this._clipSegment(x0, y0, x1, y1, c0, c1)) === null) continue;
                    [sx0, sy0, sx1, sy1] = S;
                } else {
                    if ((S = this._clipSegment(x1, y1, x0, y0, c1, c0)) === null) continue;
                    [sx1, sy1, sx0, sy0] = S;
                    e0 = e1, e1 = this._edgecode(sx0, sy0);
                    if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                    if (P) P.push(sx0, sy0);
                    else P = [
                        sx0,
                        sy0
                    ];
                }
                e0 = e1, e1 = this._edgecode(sx1, sy1);
                if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                if (P) P.push(sx1, sy1);
                else P = [
                    sx1,
                    sy1
                ];
            }
        }
        if (P) {
            e0 = e1, e1 = this._edgecode(P[0], P[1]);
            if (e0 && e1) this._edge(i, e0, e1, P, P.length);
        } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) return [
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax,
            this.xmin,
            this.ymin
        ];
        return P;
    }
    _clipSegment(x0, y0, x1, y1, c0, c1) {
        // for more robustness, always consider the segment in the same order
        const flip = c0 < c1;
        if (flip) [x0, y0, x1, y1, c0, c1] = [
            x1,
            y1,
            x0,
            y0,
            c1,
            c0
        ];
        while(true){
            if (c0 === 0 && c1 === 0) return flip ? [
                x1,
                y1,
                x0,
                y0
            ] : [
                x0,
                y0,
                x1,
                y1
            ];
            if (c0 & c1) return null;
            let x, y, c = c0 || c1;
            if (c & 8) x = x0 + (x1 - x0) * (this.ymax - y0) / (y1 - y0), y = this.ymax;
            else if (c & 4) x = x0 + (x1 - x0) * (this.ymin - y0) / (y1 - y0), y = this.ymin;
            else if (c & 2) y = y0 + (y1 - y0) * (this.xmax - x0) / (x1 - x0), x = this.xmax;
            else y = y0 + (y1 - y0) * (this.xmin - x0) / (x1 - x0), x = this.xmin;
            if (c0) x0 = x, y0 = y, c0 = this._regioncode(x0, y0);
            else x1 = x, y1 = y, c1 = this._regioncode(x1, y1);
        }
    }
    _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
        let P = Array.from(points), p;
        if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
        if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);
        if (P = this._clipFinite(i, P)) for(let j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2){
            c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
            if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
        }
        else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) P = [
            this.xmin,
            this.ymin,
            this.xmax,
            this.ymin,
            this.xmax,
            this.ymax,
            this.xmin,
            this.ymax
        ];
        return P;
    }
    _edge(i, e0, e1, P, j) {
        while(e0 !== e1){
            let x, y;
            switch(e0){
                case 5:
                    e0 = 4;
                    continue; // top-left
                case 4:
                    e0 = 6, x = this.xmax, y = this.ymin;
                    break; // top
                case 6:
                    e0 = 2;
                    continue; // top-right
                case 2:
                    e0 = 10, x = this.xmax, y = this.ymax;
                    break; // right
                case 10:
                    e0 = 8;
                    continue; // bottom-right
                case 8:
                    e0 = 9, x = this.xmin, y = this.ymax;
                    break; // bottom
                case 9:
                    e0 = 1;
                    continue; // bottom-left
                case 1:
                    e0 = 5, x = this.xmin, y = this.ymin;
                    break; // left
            }
            // Note: this implicitly checks for out of bounds: if P[j] or P[j+1] are
            // undefined, the conditional statement will be executed.
            if ((P[j] !== x || P[j + 1] !== y) && this.contains(i, x, y)) P.splice(j, 0, x, y), j += 2;
        }
        return j;
    }
    _project(x0, y0, vx, vy) {
        let t = Infinity, c, x, y;
        if (vy < 0) {
            if (y0 <= this.ymin) return null;
            if ((c = (this.ymin - y0) / vy) < t) y = this.ymin, x = x0 + (t = c) * vx;
        } else if (vy > 0) {
            if (y0 >= this.ymax) return null;
            if ((c = (this.ymax - y0) / vy) < t) y = this.ymax, x = x0 + (t = c) * vx;
        }
        if (vx > 0) {
            if (x0 >= this.xmax) return null;
            if ((c = (this.xmax - x0) / vx) < t) x = this.xmax, y = y0 + (t = c) * vy;
        } else if (vx < 0) {
            if (x0 <= this.xmin) return null;
            if ((c = (this.xmin - x0) / vx) < t) x = this.xmin, y = y0 + (t = c) * vy;
        }
        return [
            x,
            y
        ];
    }
    _edgecode(x, y) {
        return (x === this.xmin ? 1 : x === this.xmax ? 2 : 0) | (y === this.ymin ? 4 : y === this.ymax ? 8 : 0);
    }
    _regioncode(x, y) {
        return (x < this.xmin ? 1 : x > this.xmax ? 2 : 0) | (y < this.ymin ? 4 : y > this.ymax ? 8 : 0);
    }
    _simplify(P) {
        if (P && P.length > 4) {
            for(let i = 0; i < P.length; i += 2){
                const j = (i + 2) % P.length, k = (i + 4) % P.length;
                if (P[i] === P[j] && P[j] === P[k] || P[i + 1] === P[j + 1] && P[j + 1] === P[k + 1]) P.splice(j, 2), i -= 2;
            }
            if (!P.length) P = null;
        }
        return P;
    }
}


const $38933e102811c1c7$var$tau = 2 * Math.PI, $38933e102811c1c7$var$pow = Math.pow;
function $38933e102811c1c7$var$pointX(p) {
    return p[0];
}
function $38933e102811c1c7$var$pointY(p) {
    return p[1];
}
// A triangulation is collinear if all its triangles have a non-null area
function $38933e102811c1c7$var$collinear(d) {
    const { triangles: triangles, coords: coords } = d;
    for(let i = 0; i < triangles.length; i += 3){
        const a = 2 * triangles[i], b = 2 * triangles[i + 1], c = 2 * triangles[i + 2], cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]);
        if (cross > 1e-10) return false;
    }
    return true;
}
function $38933e102811c1c7$var$jitter(x, y, r) {
    return [
        x + Math.sin(x + y) * r,
        y + Math.cos(x - y) * r
    ];
}
class $38933e102811c1c7$export$2e2bcd8739ae039 {
    static from(points, fx = $38933e102811c1c7$var$pointX, fy = $38933e102811c1c7$var$pointY, that) {
        return new $38933e102811c1c7$export$2e2bcd8739ae039("length" in points ? $38933e102811c1c7$var$flatArray(points, fx, fy, that) : Float64Array.from($38933e102811c1c7$var$flatIterable(points, fx, fy, that)));
    }
    constructor(points){
        this._delaunator = new (0, $8fcaeb076b10b4b2$export$2e2bcd8739ae039)(points);
        this.inedges = new Int32Array(points.length / 2);
        this._hullIndex = new Int32Array(points.length / 2);
        this.points = this._delaunator.coords;
        this._init();
    }
    update() {
        this._delaunator.update();
        this._init();
        return this;
    }
    _init() {
        const d = this._delaunator, points = this.points;
        // check for collinear
        if (d.hull && d.hull.length > 2 && $38933e102811c1c7$var$collinear(d)) {
            this.collinear = Int32Array.from({
                length: points.length / 2
            }, (_, i)=>i).sort((i, j)=>points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1]); // for exact neighbors
            const e = this.collinear[0], f = this.collinear[this.collinear.length - 1], bounds = [
                points[2 * e],
                points[2 * e + 1],
                points[2 * f],
                points[2 * f + 1]
            ], r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);
            for(let i = 0, n = points.length / 2; i < n; ++i){
                const p = $38933e102811c1c7$var$jitter(points[2 * i], points[2 * i + 1], r);
                points[2 * i] = p[0];
                points[2 * i + 1] = p[1];
            }
            this._delaunator = new (0, $8fcaeb076b10b4b2$export$2e2bcd8739ae039)(points);
        } else delete this.collinear;
        const halfedges = this.halfedges = this._delaunator.halfedges;
        const hull = this.hull = this._delaunator.hull;
        const triangles = this.triangles = this._delaunator.triangles;
        const inedges = this.inedges.fill(-1);
        const hullIndex = this._hullIndex.fill(-1);
        // Compute an index from each point to an (arbitrary) incoming halfedge
        // Used to give the first neighbor of each point; for this reason,
        // on the hull we give priority to exterior halfedges
        for(let e = 0, n = halfedges.length; e < n; ++e){
            const p = triangles[e % 3 === 2 ? e - 2 : e + 1];
            if (halfedges[e] === -1 || inedges[p] === -1) inedges[p] = e;
        }
        for(let i = 0, n = hull.length; i < n; ++i)hullIndex[hull[i]] = i;
        // degenerate case: 1 or 2 (distinct) points
        if (hull.length <= 2 && hull.length > 0) {
            this.triangles = new Int32Array(3).fill(-1);
            this.halfedges = new Int32Array(3).fill(-1);
            this.triangles[0] = hull[0];
            inedges[hull[0]] = 1;
            if (hull.length === 2) {
                inedges[hull[1]] = 0;
                this.triangles[1] = hull[1];
                this.triangles[2] = hull[1];
            }
        }
    }
    voronoi(bounds) {
        return new (0, $92f35b159a54333c$export$2e2bcd8739ae039)(this, bounds);
    }
    *neighbors(i) {
        const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, collinear: collinear } = this;
        // degenerate case with several collinear points
        if (collinear) {
            const l = collinear.indexOf(i);
            if (l > 0) yield collinear[l - 1];
            if (l < collinear.length - 1) yield collinear[l + 1];
            return;
        }
        const e0 = inedges[i];
        if (e0 === -1) return; // coincident point
        let e = e0, p0 = -1;
        do {
            yield p0 = triangles[e];
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) return; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                const p = hull[(_hullIndex[i] + 1) % hull.length];
                if (p !== p0) yield p;
                return;
            }
        }while (e !== e0);
    }
    find(x, y, i = 0) {
        if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
        const i0 = i;
        let c;
        while((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0)i = c;
        return c;
    }
    _step(i, x, y) {
        const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, points: points } = this;
        if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
        let c = i;
        let dc = $38933e102811c1c7$var$pow(x - points[i * 2], 2) + $38933e102811c1c7$var$pow(y - points[i * 2 + 1], 2);
        const e0 = inedges[i];
        let e = e0;
        do {
            let t = triangles[e];
            const dt = $38933e102811c1c7$var$pow(x - points[t * 2], 2) + $38933e102811c1c7$var$pow(y - points[t * 2 + 1], 2);
            if (dt < dc) dc = dt, c = t;
            e = e % 3 === 2 ? e - 2 : e + 1;
            if (triangles[e] !== i) break; // bad triangulation
            e = halfedges[e];
            if (e === -1) {
                e = hull[(_hullIndex[i] + 1) % hull.length];
                if (e !== t) {
                    if ($38933e102811c1c7$var$pow(x - points[e * 2], 2) + $38933e102811c1c7$var$pow(y - points[e * 2 + 1], 2) < dc) return e;
                }
                break;
            }
        }while (e !== e0);
        return c;
    }
    render(context) {
        const buffer = context == null ? context = new (0, $3cff57ce5885ac04$export$2e2bcd8739ae039) : undefined;
        const { points: points, halfedges: halfedges, triangles: triangles } = this;
        for(let i = 0, n = halfedges.length; i < n; ++i){
            const j = halfedges[i];
            if (j < i) continue;
            const ti = triangles[i] * 2;
            const tj = triangles[j] * 2;
            context.moveTo(points[ti], points[ti + 1]);
            context.lineTo(points[tj], points[tj + 1]);
        }
        this.renderHull(context);
        return buffer && buffer.value();
    }
    renderPoints(context, r) {
        if (r === undefined && (!context || typeof context.moveTo !== "function")) r = context, context = null;
        r = r == undefined ? 2 : +r;
        const buffer = context == null ? context = new (0, $3cff57ce5885ac04$export$2e2bcd8739ae039) : undefined;
        const { points: points } = this;
        for(let i = 0, n = points.length; i < n; i += 2){
            const x = points[i], y = points[i + 1];
            context.moveTo(x + r, y);
            context.arc(x, y, r, 0, $38933e102811c1c7$var$tau);
        }
        return buffer && buffer.value();
    }
    renderHull(context) {
        const buffer = context == null ? context = new (0, $3cff57ce5885ac04$export$2e2bcd8739ae039) : undefined;
        const { hull: hull, points: points } = this;
        const h = hull[0] * 2, n = hull.length;
        context.moveTo(points[h], points[h + 1]);
        for(let i = 1; i < n; ++i){
            const h = 2 * hull[i];
            context.lineTo(points[h], points[h + 1]);
        }
        context.closePath();
        return buffer && buffer.value();
    }
    hullPolygon() {
        const polygon = new (0, $e9df2dec18ce682a$export$2e2bcd8739ae039);
        this.renderHull(polygon);
        return polygon.value();
    }
    renderTriangle(i, context) {
        const buffer = context == null ? context = new (0, $3cff57ce5885ac04$export$2e2bcd8739ae039) : undefined;
        const { points: points, triangles: triangles } = this;
        const t0 = triangles[i *= 3] * 2;
        const t1 = triangles[i + 1] * 2;
        const t2 = triangles[i + 2] * 2;
        context.moveTo(points[t0], points[t0 + 1]);
        context.lineTo(points[t1], points[t1 + 1]);
        context.lineTo(points[t2], points[t2 + 1]);
        context.closePath();
        return buffer && buffer.value();
    }
    *trianglePolygons() {
        const { triangles: triangles } = this;
        for(let i = 0, n = triangles.length / 3; i < n; ++i)yield this.trianglePolygon(i);
    }
    trianglePolygon(i) {
        const polygon = new (0, $e9df2dec18ce682a$export$2e2bcd8739ae039);
        this.renderTriangle(i, polygon);
        return polygon.value();
    }
}
function $38933e102811c1c7$var$flatArray(points, fx, fy, that) {
    const n = points.length;
    const array = new Float64Array(n * 2);
    for(let i = 0; i < n; ++i){
        const p = points[i];
        array[i * 2] = fx.call(that, p, i, points);
        array[i * 2 + 1] = fy.call(that, p, i, points);
    }
    return array;
}
function* $38933e102811c1c7$var$flatIterable(points, fx, fy, that) {
    let i = 0;
    for (const p of points){
        yield fx.call(that, p, i, points);
        yield fy.call(that, p, i, points);
        ++i;
    }
}




var $aSiaI = parcelRequire("aSiaI");
function $1c732996f2475b54$var$k() {
    return $1c732996f2475b54$var$k = Object.assign ? Object.assign.bind() : function(n) {
        for(var o = 1; o < arguments.length; o++){
            var e = arguments[o];
            for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && (n[i] = e[i]);
        }
        return n;
    }, $1c732996f2475b54$var$k.apply(this, arguments);
}
var $1c732996f2475b54$export$10439206f18620b6 = {
    xDomain: [
        0,
        1
    ],
    yDomain: [
        0,
        1
    ],
    layers: [
        "links",
        "cells",
        "points",
        "bounds"
    ],
    enableLinks: !1,
    linkLineWidth: 1,
    linkLineColor: "#bbbbbb",
    enableCells: !0,
    cellLineWidth: 2,
    cellLineColor: "#000000",
    enablePoints: !0,
    pointSize: 4,
    pointColor: "#666666",
    role: "img"
}, $1c732996f2475b54$var$C = function(n) {
    return [
        n.x,
        n.y
    ];
}, $1c732996f2475b54$var$L = (0, $5c76f646ce642491$export$6728fea658cfb92e), $1c732996f2475b54$var$T = "cursor", $1c732996f2475b54$var$P = "top", $1c732996f2475b54$export$b1152448cb844ea5 = function(n) {
    var o = n.points, e = n.getNodePosition, i = void 0 === e ? $1c732996f2475b54$var$C : e, t = n.margin, r = void 0 === t ? $1c732996f2475b54$var$L : t;
    return o.map(function(n) {
        var o = i(n), e = o[0], t = o[1];
        return [
            e + r.left,
            t + r.top
        ];
    });
}, $1c732996f2475b54$export$886e4dd0d89461d3 = function(n) {
    var o = n.points, e = n.width, i = n.height, t = n.margin, r = void 0 === t ? $1c732996f2475b54$var$L : t, l = n.debug, u = (0, $38933e102811c1c7$export$2e2bcd8739ae039).from(o), a = l ? u.voronoi([
        0,
        0,
        r.left + e + r.right,
        r.top + i + r.bottom
    ]) : void 0;
    return {
        points: o,
        delaunay: u,
        voronoi: a
    };
}, $1c732996f2475b54$export$a75177f2ff2023d0 = function(o) {
    var e = o.points, i = o.getNodePosition, t = void 0 === i ? $1c732996f2475b54$var$C : i, r = o.width, l = o.height, u = o.margin, a = void 0 === u ? $1c732996f2475b54$var$L : u, d = o.debug;
    return (0, $exYeM.useMemo)(function() {
        return $1c732996f2475b54$export$886e4dd0d89461d3({
            points: $1c732996f2475b54$export$b1152448cb844ea5({
                points: e,
                margin: a,
                getNodePosition: t
            }),
            width: r,
            height: l,
            margin: a,
            debug: d
        });
    }, [
        e,
        r,
        l,
        a,
        d
    ]);
}, $1c732996f2475b54$export$5c7fece0e156854e = function(o) {
    var e = o.data, i = o.width, t = o.height, r = o.xDomain, l = o.yDomain, u = (0, $exYeM.useMemo)(function() {
        return (0, $200a922019157658$export$2e2bcd8739ae039)().domain(r).range([
            0,
            i
        ]);
    }, [
        r,
        i
    ]), a = (0, $exYeM.useMemo)(function() {
        return (0, $200a922019157658$export$2e2bcd8739ae039)().domain(l).range([
            0,
            t
        ]);
    }, [
        l,
        t
    ]), d = (0, $exYeM.useMemo)(function() {
        return e.map(function(n) {
            return {
                x: u(n.x),
                y: a(n.y),
                data: n
            };
        });
    }, [
        e,
        u,
        a
    ]);
    return (0, $exYeM.useMemo)(function() {
        var n = (0, $38933e102811c1c7$export$2e2bcd8739ae039).from(d.map(function(n) {
            return [
                n.x,
                n.y
            ];
        })), o = n.voronoi([
            0,
            0,
            i,
            t
        ]);
        return {
            points: d,
            delaunay: n,
            voronoi: o
        };
    }, [
        d,
        i,
        t
    ]);
}, $1c732996f2475b54$export$365e60801398c8ef = function(o) {
    var e = o.points, i = o.delaunay, t = o.voronoi;
    return (0, $exYeM.useMemo)(function() {
        return {
            points: e,
            delaunay: i,
            voronoi: t
        };
    }, [
        e,
        i,
        t
    ]);
}, $1c732996f2475b54$export$338bfa5f4a160306 = function(r) {
    var l = r.elementRef, u = r.nodes, s = r.getNodePosition, c = void 0 === s ? $1c732996f2475b54$var$C : s, h = r.delaunay, v = r.setCurrent, f = r.margin, p = void 0 === f ? $1c732996f2475b54$var$L : f, m = r.detectionRadius, M = void 0 === m ? 1 / 0 : m, b = r.isInteractive, k = void 0 === b || b, y = r.onMouseEnter, w = r.onMouseMove, E = r.onMouseLeave, W = r.onClick, x = r.onTouchStart, S = r.onTouchMove, D = r.onTouchEnd, R = r.enableTouchCrosshair, A = void 0 !== R && R, N = r.tooltip, O = r.tooltipPosition, j = void 0 === O ? $1c732996f2475b54$var$T : O, I = r.tooltipAnchor, z = void 0 === I ? $1c732996f2475b54$var$P : I, F = (0, $exYeM.useState)(null), H = F[0], B = F[1], q = (0, $exYeM.useRef)(null);
    (0, $exYeM.useEffect)(function() {
        q.current = H;
    }, [
        q,
        H
    ]);
    var G = (0, $exYeM.useCallback)(function(n) {
        if (!l.current) return null;
        var o = (0, $5c76f646ce642491$export$2396fb9a7906fd81)(l.current, n), e = o[0], i = o[1], t = h.find(e, i), r = void 0 !== t ? u[t] : null;
        if (r && M !== 1 / 0) {
            var s = c(r), v = s[0], f = s[1];
            (0, $5c76f646ce642491$export$79376507b09a66f)(e, i, v + p.left, f + p.top) > M && (t = null, r = null);
        }
        return null === t || null === r ? null : [
            t,
            r
        ];
    }, [
        l,
        h,
        u,
        c,
        p,
        M
    ]), J = (0, $f506dcc23858008c$export$1c4b08e0eca38426)(), K = J.showTooltipAt, Q = J.showTooltipFromEvent, U = J.hideTooltip, V = (0, $exYeM.useMemo)(function() {
        if (N) return "cursor" === j ? function(n, o) {
            Q(N(n), o, z);
        } : function(n) {
            var o = c(n), e = o[0], i = o[1];
            K(N(n), [
                e + p.left,
                i + p.top
            ], z);
        };
    }, [
        K,
        Q,
        N,
        j,
        z,
        c,
        p
    ]), X = (0, $exYeM.useCallback)(function(n) {
        var o = G(n);
        if (B(o), null == v || v(o ? o[1] : null), o) {
            var e = o[1];
            null == V || V(e, n), null == y || y(o[1], n);
        }
    }, [
        G,
        B,
        v,
        V,
        y
    ]), Y = (0, $exYeM.useCallback)(function(n) {
        var o = G(n);
        if (B(o), o) {
            var e = o[0], i = o[1];
            if (null == v || v(i), null == V || V(i, n), q.current) {
                var t = q.current, r = t[0], l = t[1];
                e !== r ? null == E || E(l, n) : null == w || w(i, n);
            } else null == y || y(i, n);
        } else null == v || v(null), null == U || U(), q.current && (null == E || E(q.current[1], n));
    }, [
        G,
        B,
        q,
        y,
        w,
        E,
        V,
        U
    ]), Z = (0, $exYeM.useCallback)(function(n) {
        B(null), null == v || v(null), U(), E && q.current && E(q.current[1], n);
    }, [
        B,
        v,
        q,
        U,
        E
    ]), $ = (0, $exYeM.useCallback)(function(n) {
        var o = G(n);
        B(o), o && (null == W || W(o[1], n));
    }, [
        G,
        B,
        W
    ]), _ = (0, $exYeM.useCallback)(function(n) {
        var o = G(n);
        A && (B(o), null == v || v(o ? o[1] : null)), o && (null == x || x(o[1], n));
    }, [
        G,
        B,
        v,
        A,
        x
    ]), nn = (0, $exYeM.useCallback)(function(n) {
        var o = G(n);
        A && (B(o), null == v || v(o ? o[1] : null)), o && (null == S || S(o[1], n));
    }, [
        G,
        B,
        v,
        A,
        S
    ]), on = (0, $exYeM.useCallback)(function(n) {
        A && (B(null), null == v || v(null)), D && q.current && D(q.current[1], n);
    }, [
        A,
        B,
        v,
        D,
        q
    ]);
    return {
        current: H,
        handleMouseEnter: k ? X : void 0,
        handleMouseMove: k ? Y : void 0,
        handleMouseLeave: k ? Z : void 0,
        handleClick: k ? $ : void 0,
        handleTouchStart: k ? _ : void 0,
        handleTouchMove: k ? nn : void 0,
        handleTouchEnd: k ? on : void 0
    };
}, $1c732996f2475b54$export$d9a94b68b1b7ac9f = function(n) {
    var o = n.elementRef, e = n.nodes, i = n.getNodePosition, t = n.width, r = n.height, l = n.margin, u = void 0 === l ? $1c732996f2475b54$var$L : l, a = n.isInteractive, d = void 0 === a || a, s = n.detectionRadius, c = void 0 === s ? 1 / 0 : s, h = n.setCurrent, v = n.onMouseEnter, f = n.onMouseMove, p = n.onMouseLeave, g = n.onClick, m = n.tooltip, M = n.tooltipPosition, b = void 0 === M ? $1c732996f2475b54$var$T : M, k = n.tooltipAnchor, y = void 0 === k ? $1c732996f2475b54$var$P : k, C = n.debug, w = $1c732996f2475b54$export$a75177f2ff2023d0({
        points: e,
        getNodePosition: i,
        width: t,
        height: r,
        margin: u,
        debug: void 0 !== C && C
    }), E = w.delaunay, x = w.voronoi, S = $1c732996f2475b54$export$338bfa5f4a160306({
        elementRef: o,
        nodes: e,
        margin: u,
        setCurrent: h,
        delaunay: E,
        detectionRadius: c,
        isInteractive: d,
        onMouseEnter: v,
        onMouseMove: f,
        onMouseLeave: p,
        onClick: g,
        tooltip: m,
        tooltipPosition: b,
        tooltipAnchor: y
    }), R = S.handleMouseEnter, A = S.handleMouseMove, N = S.handleMouseLeave, O = S.handleClick;
    return {
        delaunay: E,
        voronoi: x,
        current: S.current,
        handleMouseEnter: R,
        handleMouseMove: A,
        handleMouseLeave: N,
        handleClick: O
    };
}, $1c732996f2475b54$var$A = [
    "theme"
], $1c732996f2475b54$var$N = function(n) {
    var o = n.data, e = n.width, i = n.height, t = n.margin, u = n.layers, a = void 0 === u ? $1c732996f2475b54$export$10439206f18620b6.layers : u, d = n.xDomain, s = void 0 === d ? $1c732996f2475b54$export$10439206f18620b6.xDomain : d, v = n.yDomain, f = void 0 === v ? $1c732996f2475b54$export$10439206f18620b6.yDomain : v, p = n.enableLinks, g = void 0 === p ? $1c732996f2475b54$export$10439206f18620b6.enableLinks : p, M = n.linkLineWidth, b = void 0 === M ? $1c732996f2475b54$export$10439206f18620b6.linkLineWidth : M, k = n.linkLineColor, C = void 0 === k ? $1c732996f2475b54$export$10439206f18620b6.linkLineColor : k, L = n.enableCells, T = void 0 === L ? $1c732996f2475b54$export$10439206f18620b6.enableCells : L, P = n.cellLineWidth, w = void 0 === P ? $1c732996f2475b54$export$10439206f18620b6.cellLineWidth : P, E = n.cellLineColor, W = void 0 === E ? $1c732996f2475b54$export$10439206f18620b6.cellLineColor : E, D = n.enablePoints, R = void 0 === D ? $1c732996f2475b54$export$10439206f18620b6.enableCells : D, A = n.pointSize, N = void 0 === A ? $1c732996f2475b54$export$10439206f18620b6.pointSize : A, O = n.pointColor, j = void 0 === O ? $1c732996f2475b54$export$10439206f18620b6.pointColor : O, I = n.role, z = void 0 === I ? $1c732996f2475b54$export$10439206f18620b6.role : I, F = (0, $5c76f646ce642491$export$d04af0e501fb729f)(e, i, t), H = F.outerWidth, B = F.outerHeight, q = F.margin, G = F.innerWidth, J = F.innerHeight, K = $1c732996f2475b54$export$5c7fece0e156854e({
        data: o,
        width: G,
        height: J,
        xDomain: s,
        yDomain: f
    }), Q = K.points, U = K.delaunay, V = K.voronoi, X = {
        links: null,
        cells: null,
        points: null,
        bounds: null
    };
    g && a.includes("links") && (X.links = (0, $aSiaI.jsx)("path", {
        stroke: C,
        strokeWidth: b,
        fill: "none",
        d: U.render()
    }, "links")), T && a.includes("cells") && (X.cells = (0, $aSiaI.jsx)("path", {
        d: V.render(),
        fill: "none",
        stroke: W,
        strokeWidth: w
    }, "cells")), R && a.includes("points") && (X.points = (0, $aSiaI.jsx)("path", {
        stroke: "none",
        fill: j,
        d: U.renderPoints(void 0, N / 2)
    }, "points")), a.includes("bounds") && (X.bounds = (0, $aSiaI.jsx)("path", {
        fill: "none",
        stroke: W,
        strokeWidth: w,
        d: V.renderBounds()
    }, "bounds"));
    var Y = $1c732996f2475b54$export$365e60801398c8ef({
        points: Q,
        delaunay: U,
        voronoi: V
    });
    return (0, $aSiaI.jsx)((0, $5c76f646ce642491$export$21d9f1931ef75b56), {
        width: H,
        height: B,
        margin: q,
        role: z,
        children: a.map(function(n, o) {
            return void 0 !== X[n] ? X[n] : "function" == typeof n ? (0, $aSiaI.jsx)((0, $exYeM.Fragment), {
                children: (0, $exYeM.createElement)(n, Y)
            }, o) : null;
        })
    });
}, $1c732996f2475b54$export$20f0351992a349 = function(n) {
    var o = n.theme, e = function(n, o) {
        if (null == n) return {};
        var e, i, t = {}, r = Object.keys(n);
        for(i = 0; i < r.length; i++)e = r[i], o.indexOf(e) >= 0 || (t[e] = n[e]);
        return t;
    }(n, $1c732996f2475b54$var$A);
    return (0, $aSiaI.jsx)((0, $5c76f646ce642491$export$42a852a2b6b56249), {
        isInteractive: !1,
        animate: !1,
        theme: o,
        children: (0, $aSiaI.jsx)($1c732996f2475b54$var$N, $1c732996f2475b54$var$k({}, e))
    });
}, $1c732996f2475b54$export$5298a84d23fda932 = function(n) {
    return (0, $aSiaI.jsx)((0, $5c76f646ce642491$export$fa6e408d6a7d6214), {
        children: function(o) {
            var e = o.width, i = o.height;
            return (0, $aSiaI.jsx)($1c732996f2475b54$export$20f0351992a349, $1c732996f2475b54$var$k({
                width: e,
                height: i
            }, n));
        }
    });
}, $1c732996f2475b54$export$e176487c05830cc5 = function(o) {
    var i = o.nodes, t = o.width, r = o.height, l = o.margin, u = void 0 === l ? $1c732996f2475b54$var$L : l, a = o.getNodePosition, d = o.setCurrent, s = o.onMouseEnter, c = o.onMouseMove, h = o.onMouseLeave, v = o.onClick, f = o.onTouchStart, p = o.onTouchMove, g = o.onTouchEnd, k = o.enableTouchCrosshair, y = void 0 !== k && k, C = o.detectionRadius, w = void 0 === C ? 1 / 0 : C, E = o.tooltip, x = o.tooltipPosition, S = void 0 === x ? $1c732996f2475b54$var$T : x, R = o.tooltipAnchor, A = void 0 === R ? $1c732996f2475b54$var$P : R, N = o.debug, O = (0, $exYeM.useRef)(null), j = $1c732996f2475b54$export$a75177f2ff2023d0({
        points: i,
        getNodePosition: a,
        width: t,
        height: r,
        margin: u,
        debug: N
    }), I = j.delaunay, z = j.voronoi, F = $1c732996f2475b54$export$338bfa5f4a160306({
        elementRef: O,
        nodes: i,
        delaunay: I,
        margin: u,
        detectionRadius: w,
        setCurrent: d,
        onMouseEnter: s,
        onMouseMove: c,
        onMouseLeave: h,
        onClick: v,
        onTouchStart: f,
        onTouchMove: p,
        onTouchEnd: g,
        enableTouchCrosshair: y,
        tooltip: E,
        tooltipPosition: S,
        tooltipAnchor: A
    }), H = F.current, B = F.handleMouseEnter, q = F.handleMouseMove, G = F.handleMouseLeave, J = F.handleClick, K = F.handleTouchStart, Q = F.handleTouchMove, U = F.handleTouchEnd, V = (0, $exYeM.useMemo)(function() {
        if (N && z) return z.render();
    }, [
        N,
        z
    ]);
    return (0, $aSiaI.jsxs)("g", {
        ref: O,
        transform: "translate(" + -u.left + "," + -u.top + ")",
        children: [
            N && z && (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                children: [
                    (0, $aSiaI.jsx)("path", {
                        d: V,
                        stroke: "red",
                        strokeWidth: 1,
                        opacity: .75
                    }),
                    w < 1 / 0 && (0, $aSiaI.jsx)("path", {
                        stroke: "red",
                        strokeWidth: .35,
                        fill: "none",
                        d: I.renderPoints(void 0, w)
                    }),
                    H && (0, $aSiaI.jsx)("path", {
                        fill: "pink",
                        opacity: .35,
                        d: z.renderCell(H[0])
                    })
                ]
            }),
            (0, $aSiaI.jsx)("rect", {
                "data-ref": "mesh-interceptor",
                width: u.left + t + u.right,
                height: u.top + r + u.bottom,
                fill: "red",
                opacity: 0,
                style: {
                    cursor: "auto"
                },
                onMouseEnter: B,
                onMouseMove: q,
                onMouseLeave: G,
                onTouchStart: K,
                onTouchMove: Q,
                onTouchEnd: U,
                onClick: J
            })
        ]
    });
}, $1c732996f2475b54$export$bbd1eaf81b7812e8 = function(n, o) {
    n.save(), n.globalAlpha = .75, n.beginPath(), o.render(n), n.strokeStyle = "red", n.lineWidth = 1, n.stroke(), n.restore();
}, $1c732996f2475b54$export$d1ec5ba8547fda09 = function(n, o, e) {
    n.save(), n.globalAlpha = .15, n.beginPath(), o.renderPoints(n, e), n.strokeStyle = "red", n.lineWidth = 1, n.stroke(), n.restore();
}, $1c732996f2475b54$export$1392694608497cc = function(n, o, e) {
    n.save(), n.globalAlpha = .35, n.beginPath(), o.renderCell(e, n), n.fillStyle = "pink", n.fill(), n.restore();
}, $1c732996f2475b54$export$c20224d26d44376d = function(n, o) {
    var e = o.delaunay, i = o.voronoi, t = o.detectionRadius, r = o.index;
    $1c732996f2475b54$export$bbd1eaf81b7812e8(n, i), t < 1 / 0 && $1c732996f2475b54$export$d1ec5ba8547fda09(n, e, t), null !== r && $1c732996f2475b54$export$1392694608497cc(n, i, r);
};


function $d2ca4cd957e3534c$var$A() {
    return $d2ca4cd957e3534c$var$A = Object.assign ? Object.assign.bind() : function(e) {
        for(var n = 1; n < arguments.length; n++){
            var o = arguments[n];
            for(var i in o)Object.prototype.hasOwnProperty.call(o, i) && (e[i] = o[i]);
        }
        return e;
    }, $d2ca4cd957e3534c$var$A.apply(this, arguments);
}
function $d2ca4cd957e3534c$var$U(e, n) {
    if (null == e) return {};
    var o, i, t = {}, r = Object.keys(e);
    for(i = 0; i < r.length; i++)o = r[i], n.indexOf(o) >= 0 || (t[o] = e[o]);
    return t;
}
var $d2ca4cd957e3534c$var$q = function(e) {
    if ("function" == typeof e) return e;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($c60c740f28e51d85$exports)))(e)) return function() {
        return e;
    };
    if (function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($58f2645d8a82ddb4$exports)))(e);
    }(e)) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($21e1eeed4365622d$exports)))(e.key)) throw new Error("symbolSize is invalid, key should be a string pointing to the property to use to determine node size");
        if (!Array.isArray(e.values) || 2 !== e.values.length) throw new Error("symbolSize is invalid, values spec should be an array containing two values, min and max");
        if (!Array.isArray(e.sizes) || 2 !== e.sizes.length) throw new Error("symbolSize is invalid, sizes spec should be an array containing two values, min and max");
        var n = (0, $200a922019157658$export$2e2bcd8739ae039)().domain([
            e.values[0],
            e.values[1]
        ]).range([
            e.sizes[0],
            e.sizes[1]
        ]);
        return function(o) {
            return n((0, (/*@__PURE__*/$parcel$interopDefault($37f57525b6598a05$exports)))(o, e.key));
        };
    }
    throw new Error("nodeSize is invalid, it should be either a function, a number or an object");
}, $d2ca4cd957e3534c$export$137d3bdca5681bb4 = function(n) {
    var o, i = n.data, t = n.xScaleSpec, r = n.xFormat, a = n.yScaleSpec, d = n.yFormat, u = n.width, c = n.height, h = n.nodeId, f = n.nodeSize, v = n.colors, m = (0, $exYeM.useMemo)(function() {
        return (0, $5f34df148ba2978d$export$4d0b292d246e5304)(i, t, a, u, c);
    }, [
        i,
        t,
        a,
        u,
        c
    ]), g = m.series, p = m.xScale, y = m.yScale, x = (0, $5c76f646ce642491$export$422f9765e6971fdf)(r), M = (0, $5c76f646ce642491$export$422f9765e6971fdf)(d), S = (0, $5c76f646ce642491$export$2d590546cbb7e3ad)(h), b = (0, $exYeM.useMemo)(function() {
        return function(e) {
            var n = e.series, o = e.formatX, i = e.formatY, t = e.getNodeId, r = [];
            return n.forEach(function(e) {
                e.data.forEach(function(n, a) {
                    var d = {
                        index: r.length,
                        serieIndex: a,
                        serieId: e.id,
                        x: n.position.x,
                        xValue: n.data.x,
                        formattedX: o(n.data.x),
                        y: n.position.y,
                        yValue: n.data.y,
                        formattedY: i(n.data.y),
                        data: n.data
                    };
                    r.push($d2ca4cd957e3534c$var$A({}, d, {
                        id: t(d)
                    }));
                });
            }), r;
        }({
            series: g,
            formatX: x,
            formatY: M,
            getNodeId: S
        });
    }, [
        g,
        x,
        M,
        S
    ]), w = (0, $exYeM.useMemo)(function() {
        return $d2ca4cd957e3534c$var$q(o);
    }, [
        o = f
    ]), I = (0, $0c49a6db3d03e2c7$export$47939777be1516f5)(v, "serieId");
    return {
        xScale: p,
        yScale: y,
        nodes: (0, $exYeM.useMemo)(function() {
            return b.map(function(e) {
                return $d2ca4cd957e3534c$var$A({}, e, {
                    size: w(e),
                    color: I({
                        serieId: e.serieId
                    })
                });
            });
        }, [
            b,
            w,
            I
        ]),
        legendData: (0, $exYeM.useMemo)(function() {
            return g.map(function(e) {
                return {
                    id: e.id,
                    label: e.id,
                    color: I({
                        serieId: e.id
                    })
                };
            });
        }, [
            g,
            I
        ])
    };
}, $d2ca4cd957e3534c$export$6949da93898e3c99 = function(e, n) {
    return (0, $8bd79e61a95b6697$export$ede9be424e8ef89a)({
        data: e,
        annotations: n,
        getPosition: function(e) {
            return {
                x: e.x,
                y: e.y
            };
        },
        getDimensions: function(e) {
            return {
                size: e.size,
                width: e.size,
                height: e.size
            };
        }
    });
}, $d2ca4cd957e3534c$var$Q = function(e) {
    return e / 2;
}, $d2ca4cd957e3534c$export$6dfb92cd12cd1384 = {
    xScale: {
        type: "linear",
        min: 0,
        max: "auto"
    },
    yScale: {
        type: "linear",
        min: 0,
        max: "auto"
    },
    enableGridX: !0,
    enableGridY: !0,
    axisBottom: {},
    axisLeft: {},
    nodeId: function(e) {
        return e.serieId + "." + e.index;
    },
    nodeSize: 9,
    nodeComponent: function(e) {
        var o = e.node, i = e.style, t = e.blendMode, r = e.isInteractive, a = e.onMouseEnter, d = e.onMouseMove, s = e.onMouseLeave, l = e.onClick, u = (0, $exYeM.useCallback)(function(e) {
            return null == a ? void 0 : a(o, e);
        }, [
            o,
            a
        ]), c = (0, $exYeM.useCallback)(function(e) {
            return null == d ? void 0 : d(o, e);
        }, [
            o,
            d
        ]), h = (0, $exYeM.useCallback)(function(e) {
            return null == s ? void 0 : s(o, e);
        }, [
            o,
            s
        ]), f = (0, $exYeM.useCallback)(function(e) {
            return null == l ? void 0 : l(o, e);
        }, [
            o,
            l
        ]);
        return (0, $aSiaI.jsx)((0, $f9aea5876333360d$export$407448d2b89b1813).circle, {
            cx: i.x,
            cy: i.y,
            r: i.size.to($d2ca4cd957e3534c$var$Q),
            fill: i.color,
            style: {
                mixBlendMode: t
            },
            onMouseEnter: r ? u : void 0,
            onMouseMove: r ? c : void 0,
            onMouseLeave: r ? h : void 0,
            onClick: r ? f : void 0
        });
    },
    colors: {
        scheme: "nivo"
    },
    isInteractive: !0,
    debugMesh: !1,
    tooltip: function(e) {
        var n = e.node;
        return (0, $aSiaI.jsx)((0, $f506dcc23858008c$export$d5f52d71198e271a), {
            id: n.serieId,
            value: "x: " + n.formattedX + ", y: " + n.formattedY,
            enableChip: !0,
            color: n.color
        });
    },
    markers: [],
    legends: [],
    annotations: []
}, $d2ca4cd957e3534c$export$82f4948cbf358702 = $d2ca4cd957e3534c$var$A({}, $d2ca4cd957e3534c$export$6dfb92cd12cd1384, {
    blendMode: "normal",
    layers: [
        "grid",
        "axes",
        "nodes",
        "markers",
        "mesh",
        "legends",
        "annotations"
    ],
    role: "img",
    useMesh: !0,
    animate: !0,
    motionConfig: "default"
}), $d2ca4cd957e3534c$export$b14a24a807ef5c0b = $d2ca4cd957e3534c$var$A({}, $d2ca4cd957e3534c$export$6dfb92cd12cd1384, {
    layers: [
        "grid",
        "axes",
        "nodes",
        "mesh",
        "legends",
        "annotations"
    ],
    pixelRatio: "undefined" != typeof window && window.devicePixelRatio || 1,
    renderNode: function(e, n) {
        e.beginPath(), e.arc(n.x, n.y, n.size / 2, 0, 2 * Math.PI), e.fillStyle = n.color, e.fill();
    }
}), $d2ca4cd957e3534c$var$ee = function(e) {
    var n = e.nodes, o = e.annotations, i = $d2ca4cd957e3534c$export$6949da93898e3c99(n, o);
    return (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: i.map(function(e, n) {
            return (0, $aSiaI.jsx)((0, $8bd79e61a95b6697$export$9279461326b8700a), $d2ca4cd957e3534c$var$A({}, e), n);
        })
    });
}, $d2ca4cd957e3534c$var$ne = function(e) {
    return e.id;
}, $d2ca4cd957e3534c$var$oe = function(e) {
    return {
        x: e.x,
        y: e.y,
        size: e.size,
        color: e.color
    };
}, $d2ca4cd957e3534c$var$ie = function(e) {
    return {
        x: e.x,
        y: e.y,
        size: 0,
        color: e.color
    };
}, $d2ca4cd957e3534c$var$te = function(e) {
    var i = e.nodes, t = e.nodeComponent, r = e.isInteractive, a = e.onMouseEnter, d = e.onMouseMove, s = e.onMouseLeave, l = e.onClick, c = e.tooltip, h = e.blendMode, f = (0, $5c76f646ce642491$export$72acc3dc9629d75d)(), v = f.animate, m = f.config, g = (0, $9f726edb03f4840c$export$7b286972b8d8ccbf)(i, {
        keys: $d2ca4cd957e3534c$var$ne,
        from: $d2ca4cd957e3534c$var$oe,
        enter: $d2ca4cd957e3534c$var$oe,
        update: $d2ca4cd957e3534c$var$oe,
        leave: $d2ca4cd957e3534c$var$ie,
        config: m,
        immediate: !v
    }), p = (0, $f506dcc23858008c$export$1c4b08e0eca38426)(), y = p.showTooltipFromEvent, x = p.hideTooltip, M = (0, $exYeM.useCallback)(function(e, n) {
        y((0, $exYeM.createElement)(c, {
            node: e
        }), n), null == a || a(e, n);
    }, [
        c,
        y,
        a
    ]), S = (0, $exYeM.useCallback)(function(e, n) {
        y((0, $exYeM.createElement)(c, {
            node: e
        }), n), null == d || d(e, n);
    }, [
        c,
        y,
        d
    ]), b = (0, $exYeM.useCallback)(function(e, n) {
        x(), null == s || s(e, n);
    }, [
        x,
        s
    ]), w = (0, $exYeM.useCallback)(function(e, n) {
        return null == l ? void 0 : l(e, n);
    }, [
        l
    ]);
    return (0, $aSiaI.jsx)((0, $aSiaI.Fragment), {
        children: g(function(e, n) {
            return (0, $exYeM.createElement)(t, {
                node: n,
                style: e,
                blendMode: h,
                isInteractive: r,
                onMouseEnter: r ? M : void 0,
                onMouseMove: r ? S : void 0,
                onMouseLeave: r ? b : void 0,
                onClick: r ? w : void 0
            });
        })
    });
}, $d2ca4cd957e3534c$var$re = function(e) {
    var i = e.nodes, t = e.width, r = e.height, a = e.onMouseEnter, d = e.onMouseMove, s = e.onMouseLeave, l = e.onClick, u = e.tooltip, c = e.debug, h = (0, $f506dcc23858008c$export$1c4b08e0eca38426)(), f = h.showTooltipFromEvent, v = h.hideTooltip, m = (0, $exYeM.useCallback)(function(e, n) {
        f((0, $exYeM.createElement)(u, {
            node: e
        }), n), a && a(e, n);
    }, [
        f,
        u,
        a
    ]), g = (0, $exYeM.useCallback)(function(e, n) {
        f((0, $exYeM.createElement)(u, {
            node: e
        }), n), d && d(e, n);
    }, [
        f,
        u,
        d
    ]), p = (0, $exYeM.useCallback)(function(e, n) {
        v(), s && s(e, n);
    }, [
        v,
        s
    ]), y = (0, $exYeM.useCallback)(function(e, n) {
        l && l(e, n);
    }, [
        l
    ]);
    return (0, $aSiaI.jsx)((0, $1c732996f2475b54$export$e176487c05830cc5), {
        nodes: i,
        width: t,
        height: r,
        onMouseEnter: m,
        onMouseMove: g,
        onMouseLeave: p,
        onClick: y,
        debug: c
    });
}, $d2ca4cd957e3534c$var$ae = [
    "isInteractive",
    "animate",
    "motionConfig",
    "theme",
    "renderWrapper"
], $d2ca4cd957e3534c$var$de = function(n) {
    var t = n.data, r = n.xScale, a = void 0 === r ? $d2ca4cd957e3534c$export$82f4948cbf358702.xScale : r, d = n.xFormat, s = n.yScale, l = void 0 === s ? $d2ca4cd957e3534c$export$82f4948cbf358702.yScale : s, u = n.yFormat, c = n.width, m = n.height, g = n.margin, p = n.layers, y = void 0 === p ? $d2ca4cd957e3534c$export$82f4948cbf358702.layers : p, S = n.colors, b = void 0 === S ? $d2ca4cd957e3534c$export$82f4948cbf358702.colors : S, I = n.blendMode, k = void 0 === I ? $d2ca4cd957e3534c$export$82f4948cbf358702.blendMode : I, z = n.nodeId, E = void 0 === z ? $d2ca4cd957e3534c$export$82f4948cbf358702.nodeId : z, C = n.nodeSize, L = void 0 === C ? $d2ca4cd957e3534c$export$82f4948cbf358702.nodeSize : C, W = n.nodeComponent, F = void 0 === W ? $d2ca4cd957e3534c$export$82f4948cbf358702.nodeComponent : W, X = n.enableGridX, Y = void 0 === X ? $d2ca4cd957e3534c$export$82f4948cbf358702.enableGridX : X, B = n.enableGridY, G = void 0 === B ? $d2ca4cd957e3534c$export$82f4948cbf358702.enableGridY : B, H = n.gridXValues, T = n.gridYValues, V = n.axisTop, j = n.axisRight, O = n.axisBottom, D = void 0 === O ? $d2ca4cd957e3534c$export$82f4948cbf358702.axisBottom : O, N = n.axisLeft, P = void 0 === N ? $d2ca4cd957e3534c$export$82f4948cbf358702.axisLeft : N, U = n.annotations, q = void 0 === U ? $d2ca4cd957e3534c$export$82f4948cbf358702.annotations : U, K = n.isInteractive, Q = void 0 === K ? $d2ca4cd957e3534c$export$82f4948cbf358702.isInteractive : K, Z = n.useMesh, _ = void 0 === Z ? $d2ca4cd957e3534c$export$82f4948cbf358702.useMesh : Z, ne = n.debugMesh, oe = void 0 === ne ? $d2ca4cd957e3534c$export$82f4948cbf358702.debugMesh : ne, ie = n.onMouseEnter, ae = n.onMouseMove, de = n.onMouseLeave, se = n.onClick, le = n.tooltip, ue = void 0 === le ? $d2ca4cd957e3534c$export$82f4948cbf358702.tooltip : le, ce = n.markers, he = void 0 === ce ? $d2ca4cd957e3534c$export$82f4948cbf358702.markers : ce, fe = n.legends, ve = void 0 === fe ? $d2ca4cd957e3534c$export$82f4948cbf358702.legends : fe, me = n.role, ge = void 0 === me ? $d2ca4cd957e3534c$export$82f4948cbf358702.role : me, pe = n.ariaLabel, ye = n.ariaLabelledBy, xe = n.ariaDescribedBy, Me = (0, $5c76f646ce642491$export$d04af0e501fb729f)(c, m, g), Se = Me.margin, be = Me.innerWidth, we = Me.innerHeight, Ie = Me.outerWidth, ke = Me.outerHeight, ze = $d2ca4cd957e3534c$export$137d3bdca5681bb4({
        data: t,
        xScaleSpec: a,
        xFormat: d,
        yScaleSpec: l,
        yFormat: u,
        width: be,
        height: we,
        nodeId: E,
        nodeSize: L,
        colors: b
    }), Ee = ze.xScale, Ce = ze.yScale, Le = ze.nodes, We = ze.legendData, Fe = (0, $exYeM.useMemo)(function() {
        return {
            xScale: Ee,
            yScale: Ce,
            nodes: Le,
            margin: Se,
            innerWidth: be,
            innerHeight: we,
            outerWidth: Ie,
            outerHeight: ke
        };
    }, [
        Ee,
        Ce,
        Le,
        Se,
        be,
        we,
        Ie,
        ke
    ]), Xe = {
        grid: null,
        axes: null,
        nodes: null,
        markers: null,
        mesh: null,
        annotations: null,
        legends: null
    };
    return y.includes("grid") && (Xe.grid = (0, $aSiaI.jsx)((0, $69c3a5d74af80d16$export$ef2184bd89960b14), {
        width: be,
        height: we,
        xScale: Y ? Ee : null,
        yScale: G ? Ce : null,
        xValues: H,
        yValues: T
    }, "grid")), y.includes("axes") && (Xe.axes = (0, $aSiaI.jsx)((0, $69c3a5d74af80d16$export$387a78ab20784494), {
        xScale: Ee,
        yScale: Ce,
        width: be,
        height: we,
        top: V,
        right: j,
        bottom: D,
        left: P
    }, "axes")), y.includes("nodes") && (Xe.nodes = (0, $aSiaI.jsx)($d2ca4cd957e3534c$var$te, {
        nodes: Le,
        nodeComponent: F,
        isInteractive: Q,
        tooltip: ue,
        blendMode: k,
        onMouseEnter: ie,
        onMouseMove: ae,
        onMouseLeave: de,
        onClick: se
    }, "nodes")), y.includes("markers") && (Xe.markers = (0, $aSiaI.jsx)((0, $5c76f646ce642491$export$81759e11f9e58ea4), {
        markers: he,
        width: be,
        height: we,
        xScale: Ee,
        yScale: Ce
    }, "markers")), y.includes("mesh") && Q && _ && (Xe.mesh = (0, $aSiaI.jsx)($d2ca4cd957e3534c$var$re, {
        nodes: Le,
        width: be,
        height: we,
        onMouseEnter: ie,
        onMouseMove: ae,
        onMouseLeave: de,
        onClick: se,
        tooltip: ue,
        debug: oe
    }, "mesh")), y.includes("annotations") && (Xe.annotations = (0, $aSiaI.jsx)($d2ca4cd957e3534c$var$ee, {
        nodes: Le,
        annotations: q
    }, "annotations")), y.includes("legends") && (Xe.legends = ve.map(function(e, n) {
        return (0, $aSiaI.jsx)((0, $6169670cf62d658b$export$238a2f791d4948f7), $d2ca4cd957e3534c$var$A({}, e, {
            containerWidth: be,
            containerHeight: we,
            data: We
        }), n);
    })), (0, $aSiaI.jsx)((0, $5c76f646ce642491$export$21d9f1931ef75b56), {
        width: Ie,
        height: ke,
        margin: Se,
        role: ge,
        ariaLabel: pe,
        ariaLabelledBy: ye,
        ariaDescribedBy: xe,
        children: y.map(function(e, n) {
            if ("string" == typeof e && void 0 !== Xe[e]) return Xe[e];
            if ("function" == typeof e) return (0, $aSiaI.jsx)((0, $exYeM.Fragment), {
                children: (0, $exYeM.createElement)(e, Fe)
            }, n);
            throw new Error("Unknown layer (" + e + ")");
        })
    });
}, $d2ca4cd957e3534c$export$eec270bd176da5f5 = function(e) {
    var n = e.isInteractive, o = void 0 === n ? $d2ca4cd957e3534c$export$82f4948cbf358702.isInteractive : n, i = e.animate, t = void 0 === i ? $d2ca4cd957e3534c$export$82f4948cbf358702.animate : i, r = e.motionConfig, a = void 0 === r ? $d2ca4cd957e3534c$export$82f4948cbf358702.motionConfig : r, d = e.theme, s = e.renderWrapper, l = $d2ca4cd957e3534c$var$U(e, $d2ca4cd957e3534c$var$ae);
    return (0, $aSiaI.jsx)((0, $5c76f646ce642491$export$42a852a2b6b56249), {
        animate: t,
        isInteractive: o,
        motionConfig: a,
        renderWrapper: s,
        theme: d,
        children: (0, $aSiaI.jsx)($d2ca4cd957e3534c$var$de, $d2ca4cd957e3534c$var$A({
            isInteractive: o
        }, l))
    });
}, $d2ca4cd957e3534c$export$ec063e41dac65508 = function(e) {
    return (0, $aSiaI.jsx)((0, $5c76f646ce642491$export$fa6e408d6a7d6214), {
        children: function(n) {
            var o = n.width, i = n.height;
            return (0, $aSiaI.jsx)($d2ca4cd957e3534c$export$eec270bd176da5f5, $d2ca4cd957e3534c$var$A({
                width: o,
                height: i
            }, e));
        }
    });
}, $d2ca4cd957e3534c$var$ue = [
    "isInteractive",
    "renderWrapper",
    "theme"
], $d2ca4cd957e3534c$var$ce = function(i) {
    var t = i.data, s = i.xScale, l = void 0 === s ? $d2ca4cd957e3534c$export$b14a24a807ef5c0b.xScale : s, u = i.xFormat, c = i.yScale, f = void 0 === c ? $d2ca4cd957e3534c$export$b14a24a807ef5c0b.yScale : c, v = i.yFormat, m = i.width, x = i.height, M = i.margin, w = i.pixelRatio, k = void 0 === w ? $d2ca4cd957e3534c$export$b14a24a807ef5c0b.pixelRatio : w, z = i.layers, E = void 0 === z ? $d2ca4cd957e3534c$export$b14a24a807ef5c0b.layers : z, C = i.colors, W = void 0 === C ? $d2ca4cd957e3534c$export$b14a24a807ef5c0b.colors : C, F = i.nodeId, X = void 0 === F ? $d2ca4cd957e3534c$export$82f4948cbf358702.nodeId : F, Y = i.nodeSize, B = void 0 === Y ? $d2ca4cd957e3534c$export$b14a24a807ef5c0b.nodeSize : Y, G = i.renderNode, H = void 0 === G ? $d2ca4cd957e3534c$export$b14a24a807ef5c0b.renderNode : G, T = i.enableGridX, V = void 0 === T ? $d2ca4cd957e3534c$export$b14a24a807ef5c0b.enableGridX : T, O = i.gridXValues, U = i.enableGridY, q = void 0 === U ? $d2ca4cd957e3534c$export$b14a24a807ef5c0b.enableGridY : U, Q = i.gridYValues, Z = i.axisTop, ee = i.axisRight, ne = i.axisBottom, oe = void 0 === ne ? $d2ca4cd957e3534c$export$b14a24a807ef5c0b.axisBottom : ne, ie = i.axisLeft, te = void 0 === ie ? $d2ca4cd957e3534c$export$b14a24a807ef5c0b.axisLeft : ie, re = i.annotations, ae = void 0 === re ? $d2ca4cd957e3534c$export$b14a24a807ef5c0b.annotations : re, de = i.isInteractive, se = void 0 === de ? $d2ca4cd957e3534c$export$b14a24a807ef5c0b.isInteractive : de, le = i.debugMesh, ue = void 0 === le ? $d2ca4cd957e3534c$export$b14a24a807ef5c0b.debugMesh : le, ce = i.onMouseEnter, he = i.onMouseMove, fe = i.onMouseLeave, ve = i.onClick, me = i.tooltip, ge = void 0 === me ? $d2ca4cd957e3534c$export$b14a24a807ef5c0b.tooltip : me, pe = i.legends, ye = void 0 === pe ? $d2ca4cd957e3534c$export$b14a24a807ef5c0b.legends : pe, xe = i.canvasRef, Me = (0, $exYeM.useRef)(null), Se = (0, $5c76f646ce642491$export$93d4e7f90805808f)(), be = (0, $exYeM.useState)(null), we = be[0], Ie = be[1], ke = (0, $5c76f646ce642491$export$d04af0e501fb729f)(m, x, M), ze = ke.margin, Ee = ke.innerWidth, Ce = ke.innerHeight, Le = ke.outerWidth, We = ke.outerHeight, Fe = $d2ca4cd957e3534c$export$137d3bdca5681bb4({
        data: t,
        xScaleSpec: l,
        xFormat: u,
        yScaleSpec: f,
        yFormat: v,
        width: Ee,
        height: Ce,
        nodeId: X,
        nodeSize: B,
        colors: W
    }), Xe = Fe.xScale, Ye = Fe.yScale, Be = Fe.nodes, Ge = Fe.legendData, He = $d2ca4cd957e3534c$export$6949da93898e3c99(Be, ae), Re = (0, $1c732996f2475b54$export$a75177f2ff2023d0)({
        points: Be,
        width: Ee,
        height: Ce,
        debug: ue
    }), Te = Re.delaunay, Ve = Re.voronoi, je = (0, $exYeM.useMemo)(function() {
        return {
            xScale: Xe,
            yScale: Ye,
            nodes: Be,
            margin: ze,
            innerWidth: Ee,
            innerHeight: Ce,
            outerWidth: Le,
            outerHeight: We
        };
    }, [
        Xe,
        Ye,
        Be,
        ze,
        Ee,
        Ce,
        Le,
        We
    ]);
    (0, $exYeM.useEffect)(function() {
        if (Me.current) {
            Me.current.width = Le * k, Me.current.height = We * k;
            var e = Me.current.getContext("2d");
            e.scale(k, k), e.fillStyle = Se.background, e.fillRect(0, 0, Le, We), e.translate(ze.left, ze.top), E.forEach(function(n) {
                if ("grid" === n) e.lineWidth = Se.grid.line.strokeWidth, e.strokeStyle = Se.grid.line.stroke, V && (0, $69c3a5d74af80d16$export$5eea7e798580e5d1)(e, {
                    width: Ee,
                    height: Ce,
                    scale: Xe,
                    axis: "x",
                    values: O
                }), q && (0, $69c3a5d74af80d16$export$5eea7e798580e5d1)(e, {
                    width: Ee,
                    height: Ce,
                    scale: Ye,
                    axis: "y",
                    values: Q
                });
                else if ("annotations" === n) (0, $8bd79e61a95b6697$export$630dcbe11859bd26)(e, {
                    annotations: He,
                    theme: Se
                });
                else if ("axes" === n) (0, $69c3a5d74af80d16$export$6f12c0e853c1bfff)(e, {
                    xScale: Xe,
                    yScale: Ye,
                    width: Ee,
                    height: Ce,
                    top: Z,
                    right: ee,
                    bottom: oe,
                    left: te,
                    theme: Se
                });
                else if ("nodes" === n) Be.forEach(function(n) {
                    H(e, n);
                });
                else if ("mesh" === n) ue && ((0, $1c732996f2475b54$export$bbd1eaf81b7812e8)(e, Ve), we && (0, $1c732996f2475b54$export$1392694608497cc)(e, Ve, we.index));
                else if ("legends" === n) ye.forEach(function(n) {
                    (0, $6169670cf62d658b$export$28c0156604402604)(e, $d2ca4cd957e3534c$var$A({}, n, {
                        data: Ge,
                        containerWidth: Ee,
                        containerHeight: Ce,
                        theme: Se
                    }));
                });
                else {
                    if ("function" != typeof n) throw new Error("Invalid layer: " + n);
                    n(e, je);
                }
            });
        }
    }, [
        Me,
        Ee,
        Ce,
        Le,
        We,
        ze.top,
        ze.left,
        k,
        H,
        E,
        je,
        Se,
        Xe,
        Ye,
        Be,
        V,
        q,
        Z,
        ee,
        oe,
        te,
        ye,
        Ge,
        ue,
        Ve,
        we,
        He
    ]);
    var Oe = (0, $f506dcc23858008c$export$1c4b08e0eca38426)(), De = Oe.showTooltipFromEvent, Ne = Oe.hideTooltip, Pe = (0, $exYeM.useCallback)(function(e) {
        var n = (0, $5c76f646ce642491$export$2396fb9a7906fd81)(Me.current, e), o = n[0], i = n[1];
        if (!(0, $5c76f646ce642491$export$be302859f014f482)(ze.left, ze.top, Ee, Ce, o, i)) return null;
        var t = Te.find(o - ze.left, i - ze.top);
        return Be[t];
    }, [
        Me,
        ze,
        Ee,
        Ce,
        Te
    ]), Ae = (0, $exYeM.useCallback)(function(e) {
        var n = Pe(e);
        Ie(n), n ? (De((0, $exYeM.createElement)(ge, {
            node: n
        }), e), we && we.id !== n.id && (fe && fe(we, e), ce && ce(n, e)), we || ce && ce(n, e), he && he(n, e)) : (Ne(), we && fe && fe(we, e));
    }, [
        Pe,
        we,
        Ie,
        De,
        Ne,
        ge,
        ce,
        he,
        fe
    ]), Ue = (0, $exYeM.useCallback)(function(e) {
        Ne(), Ie(null), we && fe && fe(we, e);
    }, [
        Ne,
        we,
        Ie,
        fe
    ]), qe = (0, $exYeM.useCallback)(function(e) {
        if (ve) {
            var n = Pe(e);
            n && ve(n, e);
        }
    }, [
        Pe,
        ve
    ]);
    return (0, $aSiaI.jsx)("canvas", {
        ref: function(e) {
            Me.current = e, xe && "current" in xe && (xe.current = e);
        },
        width: Le * k,
        height: We * k,
        style: {
            width: Le,
            height: We,
            cursor: se ? "auto" : "normal"
        },
        onMouseEnter: se ? Ae : void 0,
        onMouseMove: se ? Ae : void 0,
        onMouseLeave: se ? Ue : void 0,
        onClick: se ? qe : void 0
    });
}, $d2ca4cd957e3534c$export$48ca1edec32bd4ba = (0, $exYeM.forwardRef)(function(e, n) {
    var o = e.isInteractive, i = e.renderWrapper, t = e.theme, r = $d2ca4cd957e3534c$var$U(e, $d2ca4cd957e3534c$var$ue);
    return (0, $aSiaI.jsx)((0, $5c76f646ce642491$export$42a852a2b6b56249), {
        isInteractive: o,
        renderWrapper: i,
        theme: t,
        animate: !1,
        children: (0, $aSiaI.jsx)($d2ca4cd957e3534c$var$ce, $d2ca4cd957e3534c$var$A({}, r, {
            canvasRef: n
        }))
    });
}), $d2ca4cd957e3534c$export$1ba3de9891f72ad7 = (0, $exYeM.forwardRef)(function(e, n) {
    return (0, $aSiaI.jsx)((0, $5c76f646ce642491$export$fa6e408d6a7d6214), {
        children: function(o) {
            var i = o.width, t = o.height;
            return (0, $aSiaI.jsx)($d2ca4cd957e3534c$export$48ca1edec32bd4ba, $d2ca4cd957e3534c$var$A({
                width: i,
                height: t
            }, e, {
                ref: n
            }));
        }
    });
});



const $0144358637aa8c73$var$CustomNodeComponent = ({ node: node, blendMode: blendMode, onMouseEnter: onMouseEnter, onMouseMove: onMouseMove, onMouseLeave: onMouseLeave, onClick: onClick })=>/*#__PURE__*/ (0, $aSiaI.jsx)("g", {
        transform: `translate(${node.x},${node.y})`,
        children: /*#__PURE__*/ (0, $aSiaI.jsx)("circle", {
            r: node.size / 2,
            fill: `rgba(${node.y + 100}, ${200 - node.y}, 0)`,
            style: {
                mixBlendMode: blendMode
            },
            onMouseEnter: (event)=>onMouseEnter?.(node, event),
            onMouseMove: (event)=>onMouseMove?.(node, event),
            onMouseLeave: (event)=>onMouseLeave?.(node, event),
            onClick: (event)=>onClick?.(node, event)
        })
    });
const $0144358637aa8c73$export$156785a87e54689c = ({ identityKey: identityKey })=>{
    const [data, setData] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState();
    const [dataCore, setDataCore] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState();
    const [dataReport, setDataReport] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState();
    const [lastUpdated, setLastUpdated] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState();
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [busyMessage, setBusyMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState();
    const [chartData, setChartData] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState();
    const refreshTests = async ()=>{
        try {
            const resCore = await (0, $f66fa928cd4a99c0$export$644d8ea042df96a6).gatewayCoreCount(identityKey);
            setDataCore(resCore);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("Error getting core test metrics", e);
        }
        try {
            const res = await (0, $f66fa928cd4a99c0$export$644d8ea042df96a6).gatewayTestResults(identityKey);
            setData(res);
            const series = {
                id: "Test runs",
                data: res.data.map((item)=>({
                        x: item.timestamp.toISOString(),
                        y: item.overall_reliability_for_all_routes_in_monitor_run
                    }))
            };
            setChartData([
                series
            ]);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("Error getting test results", e);
        }
        try {
            const res = await (0, $f66fa928cd4a99c0$export$644d8ea042df96a6).gatewayAverageUptime(identityKey);
            setDataReport(res);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("Error getting test results", e);
        }
    };
    const refresh = async ()=>{
        try {
            setBusy(true);
            setBusyMessage("Getting latest data...");
            await refreshTests();
            setLastUpdated(new Date());
            setBusyMessage("Finishing refresh...");
        } finally{
            setBusy(false);
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        refresh().catch((e)=>console.error(e));
    }, []);
    const columns = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useMemo(()=>[
            {
                header: "Timestamp",
                accessorKey: "timestamp",
                Cell: ({ cell: cell })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("strong", {
                                children: (0, $08c0c798d1b2bf8a$export$2e2bcd8739ae039)(cell.row.original.timestamp, {
                                    addSuffix: true
                                })
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                            cell.row.original.timestamp.toISOString()
                        ]
                    })
            },
            {
                header: "Overall reliability for all routes in monitor run",
                accessorKey: "overall_reliability_for_all_routes_in_monitor_run",
                Cell: ({ cell: cell })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                        display: "flex",
                        alignItems: "center",
                        fontSize: "inherit",
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $2de6e1f747941867$export$2e2bcd8739ae039), {
                                sx: {
                                    width: 100,
                                    height: 16
                                },
                                variant: "determinate",
                                value: cell.row.original.overall_reliability_for_all_routes_in_monitor_run
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                                ml: 1,
                                fontSize: "inherit",
                                children: [
                                    cell.row.original.overall_reliability_for_all_routes_in_monitor_run,
                                    " %"
                                ]
                            })
                        ]
                    })
            },
            {
                header: "Monitor run id",
                accessorKey: "monitor_run_id"
            },
            {
                header: "Test route",
                accessorKey: "test_routes",
                Cell: ({ cell: cell })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e10e66deff206ed9$export$2e2bcd8739ae039), {
                        direction: "row",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $980dfff3cab72cf4$export$2e2bcd8739ae039), {
                                sx: {
                                    width: 75
                                },
                                component: "a",
                                target: "_blank",
                                color: "success",
                                variant: "contained",
                                size: "small",
                                href: `https://explorer.nymtech.net/network-components/gateway/${identityKey}`,
                                children: identityKey.slice(0, 6)
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($29ac6f35d66955fc$exports))), {}),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $980dfff3cab72cf4$export$2e2bcd8739ae039), {
                                sx: {
                                    width: 75
                                },
                                component: "a",
                                target: "_blank",
                                color: "primary",
                                variant: "contained",
                                size: "small",
                                href: `https://explorer.nymtech.net/network-components/mixnode/${cell.row.original.test_routes.layer1.node_id}`,
                                children: cell.row.original.test_routes.layer1.identity_key.slice(0, 6)
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($29ac6f35d66955fc$exports))), {}),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $980dfff3cab72cf4$export$2e2bcd8739ae039), {
                                sx: {
                                    width: 75
                                },
                                component: "a",
                                target: "_blank",
                                color: "primary",
                                variant: "contained",
                                size: "small",
                                href: `https://explorer.nymtech.net/network-components/mixnode/${cell.row.original.test_routes.layer2.node_id}`,
                                children: cell.row.original.test_routes.layer2.identity_key.slice(0, 6)
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($29ac6f35d66955fc$exports))), {}),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $980dfff3cab72cf4$export$2e2bcd8739ae039), {
                                sx: {
                                    width: 75
                                },
                                component: "a",
                                target: "_blank",
                                color: "primary",
                                variant: "contained",
                                size: "small",
                                href: `https://explorer.nymtech.net/network-components/mixnode/${cell.row.original.test_routes.layer3.node_id}`,
                                children: cell.row.original.test_routes.layer3.identity_key.slice(0, 6)
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($29ac6f35d66955fc$exports))), {}),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $980dfff3cab72cf4$export$2e2bcd8739ae039), {
                                sx: {
                                    width: 75
                                },
                                component: "a",
                                target: "_blank",
                                color: "success",
                                variant: "contained",
                                size: "small",
                                href: `https://explorer.nymtech.net/network-components/gateway/${identityKey}`,
                                children: [
                                    " ",
                                    identityKey.slice(0, 6)
                                ]
                            })
                        ]
                    })
            }
        ], []);
    const table = (0, $35fd956d2f1c2be7$export$f43e1b352a4cbffc)({
        columns: columns,
        initialState: {
            pagination: {
                pageSize: 25,
                pageIndex: 0
            },
            density: "compact",
            showColumnFilters: true,
            sorting: [
                {
                    id: "probeScoreCalculated",
                    desc: true
                }
            ]
        },
        data: data?.data || [],
        enableRowSelection: true,
        enableColumnOrdering: false,
        enableGlobalFilter: false
    });
    if (!lastUpdated) return /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        mt: 2,
        py: 2,
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
            mt: 4,
            display: "flex",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8a947ac56b8361c3$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                    fontSize: "larger",
                    ml: 2,
                    children: "Please watch some \uD83D\uDC3C and \uD83E\uDD8A play in the \uD83C\uDF32\uD83C\uDF32\uD83C\uDF32 while you wait..."
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        mt: 2,
        py: 2,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c14ca1eac99fe440$export$2e2bcd8739ae039), {
                component: (0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a),
                to: `/gateway/${identityKey}/test-results`,
                children: /*#__PURE__*/ (0, $aSiaI.jsx)("h2", {
                    children: "Network Monitor Test Results"
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                paragraph: true,
                children: "Each test run picks 3 random routes (each route has 3 mixnodes) and sends 3 packets along that route back to this gateway. Before the test run starts, the route is verified by sending 1000 packets. If all packets are not received, the route is re-randomised."
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                paragraph: true,
                children: "If one mixnode in the route is not responding, the overall reliability score for this test run will drop by 33% because one of the 3 routes will be routable. And if one or more mixnodes are not responding per run, the score will drop by 66%."
            }),
            dataCore && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e85329076f56f45f$export$2e2bcd8739ae039), {
                severity: "info",
                sx: {
                    width: 600
                },
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                        paragraph: true,
                        children: [
                            "This gateway has been ",
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("strong", {
                                children: [
                                    "used in test routes ",
                                    dataCore.count,
                                    " times"
                                ]
                            }),
                            " in the last 30 days."
                        ]
                    }),
                    dataReport && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                        paragraph: true,
                        children: [
                            "The routing score ",
                            /*#__PURE__*/ (0, $aSiaI.jsxs)("strong", {
                                children: [
                                    "(",
                                    dataReport.avg_uptime,
                                    "%)"
                                ]
                            }),
                            " of this gateway is calculated as the average reliability from test runs that includes this gateway over the last 24 hours."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                display: "flex",
                justifyContent: "space-between",
                mt: 4,
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                        children: busy ? /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                            children: busyMessage || "Refreshing..."
                        }) : /*#__PURE__*/ (0, $aSiaI.jsx)((0, $980dfff3cab72cf4$export$2e2bcd8739ae039), {
                            variant: "outlined",
                            onClick: refresh,
                            children: "Refresh"
                        })
                    }),
                    lastUpdated && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e10e66deff206ed9$export$2e2bcd8739ae039), {
                        direction: "row",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                                children: "Last updated"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("strong", {
                                        children: (0, $08c0c798d1b2bf8a$export$2e2bcd8739ae039)(lastUpdated, {
                                            addSuffix: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)("br", {}),
                                    lastUpdated.toISOString()
                                ]
                            })
                        ]
                    })
                ]
            }),
            chartData && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                height: 400,
                mb: 2,
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $d2ca4cd957e3534c$export$ec063e41dac65508), {
                    data: chartData,
                    margin: {
                        top: 60,
                        right: 140,
                        bottom: 70,
                        left: 90
                    },
                    xScale: {
                        type: "time",
                        format: "%Y-%m-%dT%H:%M:%S.%LZ"
                    },
                    yFormat: (value)=>`${value}% reliability`,
                    xFormat: (value)=>new Date(value).toISOString(),
                    yScale: {
                        type: "linear",
                        min: "auto",
                        max: "auto"
                    },
                    axisBottom: {
                        format: (value)=>(0, $08c0c798d1b2bf8a$export$2e2bcd8739ae039)(value, {
                                addSuffix: true
                            })
                    },
                    axisLeft: {
                        format: (value)=>`${value}%`,
                        legend: "Reliability",
                        legendPosition: "middle"
                    },
                    nodeSize: (datum)=>datum.yValue / 5 + 10,
                    nodeComponent: $0144358637aa8c73$var$CustomNodeComponent
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $35fd956d2f1c2be7$export$2506d3bf41f97512), {
                table: table
            })
        ]
    });
};


const $5631f68d6550bf8a$var$boolToEmoji = (value)=>value ? "\u2705" : "\u274C";
const $5631f68d6550bf8a$export$e5544b8ca9baae7 = ({ gatewayScore: gatewayScore })=>/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e10e66deff206ed9$export$2e2bcd8739ae039), {
        direction: "row",
        spacing: 2,
        mb: 2,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e10e66deff206ed9$export$2e2bcd8739ae039), {
                        direction: "row",
                        spacing: 4,
                        my: 2,
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                                children: "Config score"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                                children: (0, $01bb1c4a0639f9ce$export$449ac6ab2e997139)(gatewayScore.configScore)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7c647d032b5c1ce4$export$2e2bcd8739ae039), {
                        sx: {
                            maxWidth: 400
                        },
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f486dbc13fd8431d$export$2e2bcd8739ae039), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e5ef275ef7d6f0a3$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                sx: {
                                                    pl: 3
                                                },
                                                children: (0, $01bb1c4a0639f9ce$export$35b3358ed859f59f).entryGateway
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                children: $5631f68d6550bf8a$var$boolToEmoji(gatewayScore.configScoreItems.runsEntryGateway)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                sx: {
                                                    pl: 3
                                                },
                                                children: (0, $01bb1c4a0639f9ce$export$35b3358ed859f59f).exitGatewayWithIPR
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                children: $5631f68d6550bf8a$var$boolToEmoji(gatewayScore.configScoreItems.runsIPR)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                sx: {
                                                    pl: 3
                                                },
                                                children: (0, $01bb1c4a0639f9ce$export$35b3358ed859f59f).exitGatewayWithSocks5
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                children: $5631f68d6550bf8a$var$boolToEmoji(gatewayScore.configScoreItems.runsNetworkRequester)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                sx: {
                                                    pl: 3
                                                },
                                                children: (0, $01bb1c4a0639f9ce$export$35b3358ed859f59f).exitPolicyEnabled
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                children: $5631f68d6550bf8a$var$boolToEmoji(gatewayScore.configScoreItems.usesExitPolicy)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                sx: {
                                                    pl: 3
                                                },
                                                children: (0, $01bb1c4a0639f9ce$export$35b3358ed859f59f).runsMinVersion
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                children: $5631f68d6550bf8a$var$boolToEmoji(gatewayScore.configScoreItems.minBuildVersion)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                sx: {
                                                    pl: 3
                                                },
                                                children: (0, $01bb1c4a0639f9ce$export$35b3358ed859f59f).runsAuthentictorServiceProvider
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                children: $5631f68d6550bf8a$var$boolToEmoji(gatewayScore.configScoreItems.runsAuthenticatorServiceProvider)
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e10e66deff206ed9$export$2e2bcd8739ae039), {
                        direction: "row",
                        spacing: 4,
                        my: 2,
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                                children: "Probe score"
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                                children: (0, $01bb1c4a0639f9ce$export$374d712138427485)(gatewayScore.probeScore)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7c647d032b5c1ce4$export$2e2bcd8739ae039), {
                        sx: {
                            maxWidth: 400
                        },
                        children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f486dbc13fd8431d$export$2e2bcd8739ae039), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e5ef275ef7d6f0a3$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                sx: {
                                                    pl: 3
                                                },
                                                children: [
                                                    "\u2197\uFE0F Entry Gateway ",
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("strong", {
                                                        children: "(Mixnet mode)"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                sx: {
                                                    pl: 6
                                                },
                                                children: "Can connect?"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                children: $5631f68d6550bf8a$var$boolToEmoji(gatewayScore.probeScoreItems?.as_entry?.can_connect)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                sx: {
                                                    pl: 6
                                                },
                                                children: "Can route?"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                children: $5631f68d6550bf8a$var$boolToEmoji(gatewayScore.probeScoreItems?.as_entry?.can_route)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                sx: {
                                                    pl: 3
                                                },
                                                children: [
                                                    "\u269B\uFE0F Entry Gateway ",
                                                    /*#__PURE__*/ (0, $aSiaI.jsx)("strong", {
                                                        children: "(Wireguard mode)"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                sx: {
                                                    pl: 6
                                                },
                                                children: "Can register Wireguard peers?"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                children: $5631f68d6550bf8a$var$boolToEmoji(gatewayScore.probeScoreItems?.wg?.can_register)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                sx: {
                                                    pl: 6
                                                },
                                                children: "Can complete Wireguard handshake?"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                children: $5631f68d6550bf8a$var$boolToEmoji(gatewayScore.probeScoreItems?.wg?.can_handshake)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                sx: {
                                                    pl: 6
                                                },
                                                children: "Resolves DNS when Wireguard active?"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                children: $5631f68d6550bf8a$var$boolToEmoji(gatewayScore.probeScoreItems?.wg?.can_resolve_dns)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                sx: {
                                                    pl: 6
                                                },
                                                children: "Ping hosts performance ok?"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                children: [
                                                    $5631f68d6550bf8a$var$boolToEmoji((gatewayScore.probeScoreItems?.wg?.ping_hosts_performance || 0) > 0.75),
                                                    "\xa0(",
                                                    Math.round((gatewayScore.probeScoreItems?.wg?.ping_hosts_performance || 0) * 100),
                                                    "%)"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                sx: {
                                                    pl: 6
                                                },
                                                children: "Ping IP performance ok?"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                children: [
                                                    $5631f68d6550bf8a$var$boolToEmoji((gatewayScore.probeScoreItems?.wg?.ping_ips_performance || 0) > 0.75),
                                                    "\xa0(",
                                                    Math.round((gatewayScore.probeScoreItems?.wg?.ping_ips_performance || 0) * 100),
                                                    "%)"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                sx: {
                                                    pl: 3
                                                },
                                                children: "\u2198\uFE0F Exit Gateway"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                sx: {
                                                    pl: 6
                                                },
                                                children: "Can connect?"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                children: $5631f68d6550bf8a$var$boolToEmoji(gatewayScore.probeScoreItems?.as_exit?.can_connect)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                sx: {
                                                    pl: 6
                                                },
                                                children: "Can route IPV4 on localhost?"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                children: $5631f68d6550bf8a$var$boolToEmoji(gatewayScore.probeScoreItems?.as_exit?.can_route_ip_v4)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                sx: {
                                                    pl: 6
                                                },
                                                children: "Can route IPV6 on localhost?"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                children: $5631f68d6550bf8a$var$boolToEmoji(gatewayScore.probeScoreItems?.as_exit?.can_route_ip_v6)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                sx: {
                                                    pl: 6
                                                },
                                                children: "Can route IPV4 to the internet?"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                children: $5631f68d6550bf8a$var$boolToEmoji(gatewayScore.probeScoreItems?.as_exit?.can_route_ip_external_v4)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                sx: {
                                                    pl: 6
                                                },
                                                children: "Can route IPV6 to the internet?"
                                            }),
                                            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                                children: $5631f68d6550bf8a$var$boolToEmoji(gatewayScore.probeScoreItems?.as_exit?.can_route_ip_external_v6)
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
const $5631f68d6550bf8a$export$a0e1fa6601cae894 = ()=>{
    const { gatewayIdentityKey: gatewayIdentityKey } = (0, $b0e6fcd50b7ef685$export$99eaa27ddbbb95ef)();
    const [gateway, setGateway] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState();
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState();
    const refreshGateway = async ()=>{
        try {
            if (gatewayIdentityKey) {
                const newGateway = await (0, $f66fa928cd4a99c0$export$644d8ea042df96a6).gateway(gatewayIdentityKey);
                setGateway(newGateway);
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("Error getting services", e);
            setError(e.message);
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        refreshGateway();
        const timer = setInterval(refreshGateway, 300000);
        return ()=>clearInterval(timer);
    }, [
        gatewayIdentityKey
    ]);
    if (error) return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        p: 4,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $93231a89f687f087$export$ddc5e865495e96fb), {}),
            gatewayIdentityKey && /*#__PURE__*/ (0, $aSiaI.jsxs)("h2", {
                children: [
                    "\u26E9\uFE0F Gateway ",
                    /*#__PURE__*/ (0, $aSiaI.jsx)("code", {
                        children: gatewayIdentityKey
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                children: [
                    "Oh no! Something went wrong: ",
                    error
                ]
            })
        ]
    });
    if (!gateway) return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        p: 4,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $93231a89f687f087$export$ddc5e865495e96fb), {}),
            gatewayIdentityKey && /*#__PURE__*/ (0, $aSiaI.jsxs)("h2", {
                children: [
                    "\u26E9\uFE0F Gateway ",
                    /*#__PURE__*/ (0, $aSiaI.jsx)("code", {
                        children: gatewayIdentityKey
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                mt: 4,
                display: "flex",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8a947ac56b8361c3$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                        fontSize: "larger",
                        ml: 2,
                        children: "Please have some popcorn \uD83C\uDF7F or peanuts \uD83E\uDD5C while we cook your order..."
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        p: 4,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $93231a89f687f087$export$ddc5e865495e96fb), {}),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("h2", {
                children: [
                    "\u26E9\uFE0F Gateway ",
                    /*#__PURE__*/ (0, $aSiaI.jsx)("code", {
                        children: gatewayIdentityKey
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                children: [
                    "Last updated from directory\xa0",
                    /*#__PURE__*/ (0, $aSiaI.jsx)("strong", {
                        children: (0, $08c0c798d1b2bf8a$export$2e2bcd8739ae039)(gateway.last_updated_utc, {
                            addSuffix: true
                        })
                    }),
                    "\xa0at\xa0",
                    gateway.last_updated_utc.toISOString()
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c14ca1eac99fe440$export$2e2bcd8739ae039), {
                    href: `https://explorer.nymtech.net/network-components/gateway/${gatewayIdentityKey}`,
                    target: "_blank",
                    children: "View in explorer"
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("hr", {}),
            gateway.bonded && /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                children: $5631f68d6550bf8a$var$boolToEmoji(gateway.bonded)
            }),
            gateway.blacklisted && /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                children: "Blacklisted \uD83D\uDD34"
            }),
            gateway.bonded && !gateway.blacklisted && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                        children: [
                            (gateway?.explorer_pretty_bond?.pledge_amount.amount || 0) / 1e6,
                            " NYM"
                        ]
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                        mb: 4,
                        children: [
                            "Role = ",
                            /*#__PURE__*/ (0, $aSiaI.jsx)("code", {
                                children: gateway?.self_described.role
                            })
                        ]
                    })
                ]
            }),
            gateway.blacklisted && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e85329076f56f45f$export$2e2bcd8739ae039), {
                severity: "warning",
                variant: "filled",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6adb5c54f2023788$export$2e2bcd8739ae039), {
                        sx: {
                            fontWeight: 600
                        },
                        children: "Gateway is blacklisted \uD83D\uDE22"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                        children: "Please check the network monitor tests at the end of this page to see what the test results for mixnet mode have been recorded for this gateway."
                    })
                ]
            }),
            !gateway.bonded && !gateway.blacklisted && /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e85329076f56f45f$export$2e2bcd8739ae039), {
                severity: "error",
                variant: "filled",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $6adb5c54f2023788$export$2e2bcd8739ae039), {
                        sx: {
                            fontWeight: 600
                        },
                        children: "Gateway is no longer bonded \uD83D\uDE22"
                    }),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                        children: "This gateway is no longer bonded. All data shown is historical from when it was in the directory or last probed."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)($5631f68d6550bf8a$export$e5544b8ca9baae7, {
                gatewayScore: gateway.gatewayScore
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("hr", {}),
            /*#__PURE__*/ (0, $aSiaI.jsxs)("h3", {
                children: [
                    "Last Probe Result (",
                    (0, $08c0c798d1b2bf8a$export$2e2bcd8739ae039)(gateway.last_testrun_utc, {
                        addSuffix: true
                    }),
                    " -",
                    " ",
                    gateway.last_testrun_utc.toISOString(),
                    ")"
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("pre", {
                children: JSON.stringify(gateway?.last_probe_result, null, 2)
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("h4", {
                children: "Probe Log"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("pre", {
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($114d365489223ff2$exports))), {
                    children: gateway?.last_probe_log
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                children: "Description"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("pre", {
                children: JSON.stringify(gateway?.description, null, 2)
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                children: "Self Described"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("pre", {
                children: JSON.stringify(gateway?.self_described, null, 2)
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("h3", {
                children: "Explorer API"
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("pre", {
                children: JSON.stringify(gateway?.explorer_pretty_bond, null, 2)
            }),
            gatewayIdentityKey && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0144358637aa8c73$export$156785a87e54689c), {
                identityKey: gatewayIdentityKey
            })
        ]
    });
};



var $aSiaI = parcelRequire("aSiaI");

var $exYeM = parcelRequire("exYeM");















const $a19cb2b03f27e19e$var$boolToEmoji = (value)=>value ? "\u2705" : "\u274C";
const $a19cb2b03f27e19e$export$3956a1da75cc7671 = ()=>{
    const { mixid: mixid } = (0, $b0e6fcd50b7ef685$export$99eaa27ddbbb95ef)();
    const [mixnode, setMixnode] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState();
    const mixnodeConfigScore = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useMemo(()=>{
        if (!mixnode) return null;
        const binaryName = mixnode.self_described?.self_described?.build_information?.binary_name;
        const nymNodeVersion = mixnode.self_described?.self_described?.build_information?.build_version;
        const nymNodeVersionOk = (0, $f6fedae2cedfe3de$export$28dd95a052841a60)(nymNodeVersion) && binaryName === "nym-node";
        return {
            bonded: mixnode.bonded,
            blacklisted: mixnode.blacklisted,
            hasDescribedApi: Boolean(mixnode.self_described?.self_described),
            binaryName: binaryName,
            nymNodeVersionOk: nymNodeVersionOk,
            nymNodeVersion: nymNodeVersion,
            acceptedTermsAndConditions: Boolean(mixnode.self_described?.self_described?.auxiliary_details?.accepted_operator_terms_and_conditions)
        };
    }, [
        mixnode
    ]);
    const refresh = async ()=>{
        try {
            if (mixid) {
                const newMixnode = await (0, $f66fa928cd4a99c0$export$644d8ea042df96a6).mixnode(mixid);
                setMixnode(newMixnode);
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("Error getting services", e);
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        refresh();
        const timer = setInterval(refresh, 300000);
        return ()=>clearInterval(timer);
    }, [
        mixid
    ]);
    if (!mixnode) return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        p: 4,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $93231a89f687f087$export$ddc5e865495e96fb), {}),
            mixid && /*#__PURE__*/ (0, $aSiaI.jsxs)("h2", {
                children: [
                    "\uD83C\uDFB2\uFE0F Mixnode ",
                    /*#__PURE__*/ (0, $aSiaI.jsx)("code", {
                        children: mixid
                    })
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                mt: 4,
                display: "flex",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8a947ac56b8361c3$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                        fontSize: "larger",
                        ml: 2,
                        children: "Please have some popcorn \uD83C\uDF7F or peanuts \uD83E\uDD5C while we cook your order..."
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        p: 4,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $93231a89f687f087$export$ddc5e865495e96fb), {}),
            mixnode.description ? /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                        component: "h2",
                        mb: 0.5,
                        children: [
                            "\uD83C\uDFB2\uFE0F ",
                            mixnode.description.moniker
                        ]
                    }),
                    mixnode.description.details && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                        mb: 2,
                        fontWeight: 600,
                        children: mixnode.description.details
                    })
                ]
            }) : /*#__PURE__*/ (0, $aSiaI.jsxs)("h2", {
                children: [
                    "\uD83C\uDFB2\uFE0F Mixnode ",
                    /*#__PURE__*/ (0, $aSiaI.jsx)("code", {
                        children: mixid
                    })
                ]
            }),
            mixnodeConfigScore && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $7c647d032b5c1ce4$export$2e2bcd8739ae039), {
                sx: {
                    maxWidth: 400,
                    mt: 2
                },
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $f486dbc13fd8431d$export$2e2bcd8739ae039), {
                    size: "small",
                    children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $e5ef275ef7d6f0a3$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                        sx: {
                                            pl: 3
                                        },
                                        children: "Bonded"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                        children: $a19cb2b03f27e19e$var$boolToEmoji(mixnodeConfigScore.bonded)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                        sx: {
                                            pl: 3
                                        },
                                        children: "Not blacklisted"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                        children: $a19cb2b03f27e19e$var$boolToEmoji(!mixnodeConfigScore.blacklisted)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                        sx: {
                                            pl: 3
                                        },
                                        children: "Node API is reachable by Nym API"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                        children: $a19cb2b03f27e19e$var$boolToEmoji(mixnodeConfigScore.hasDescribedApi)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                        sx: {
                                            pl: 3
                                        },
                                        children: "Accepted Operator T&Cs"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                        children: $a19cb2b03f27e19e$var$boolToEmoji(mixnodeConfigScore.acceptedTermsAndConditions)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                        sx: {
                                            pl: 3
                                        },
                                        children: [
                                            "Runs nym-node version >= ",
                                            /*#__PURE__*/ (0, $aSiaI.jsx)("code", {
                                                children: (0, $8d995646af892e7d$export$149ea0a63fc31f44)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                        children: $a19cb2b03f27e19e$var$boolToEmoji(mixnodeConfigScore.nymNodeVersionOk)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $73c633ff2ee7f4a0$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                        sx: {
                                            pl: 3
                                        },
                                        children: "Binary name"
                                    }),
                                    /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $0d3e666d59021d3c$export$2e2bcd8739ae039), {
                                        children: [
                                            mixnodeConfigScore.binaryName && /*#__PURE__*/ (0, $aSiaI.jsx)("code", {
                                                children: mixnodeConfigScore.binaryName
                                            }),
                                            mixnodeConfigScore.nymNodeVersion && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                                                children: mixnodeConfigScore.nymNodeVersion
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                mt: 4,
                children: [
                    "Last updated from directory\xa0",
                    /*#__PURE__*/ (0, $aSiaI.jsx)("strong", {
                        children: (0, $08c0c798d1b2bf8a$export$2e2bcd8739ae039)(mixnode.last_updated_utc, {
                            addSuffix: true
                        })
                    }),
                    "\xa0at\xa0",
                    mixnode.last_updated_utc.toISOString()
                ]
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c14ca1eac99fe440$export$2e2bcd8739ae039), {
                    href: `https://explorer.nymtech.net/network-components/mixnode/${mixid}`,
                    target: "_blank",
                    children: "View in explorer"
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)("hr", {}),
            /*#__PURE__*/ (0, $aSiaI.jsx)("pre", {
                children: JSON.stringify(mixnode, null, 2)
            })
        ]
    });
};



var $aSiaI = parcelRequire("aSiaI");
parcelRequire("exYeM");







const $133d1d64a58d6562$export$70ac82b571396c8d = ()=>{
    const { gatewayIdentityKey: gatewayIdentityKey } = (0, $b0e6fcd50b7ef685$export$99eaa27ddbbb95ef)();
    if (!gatewayIdentityKey) return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        p: 4,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $93231a89f687f087$export$ddc5e865495e96fb), {}),
            gatewayIdentityKey && /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c14ca1eac99fe440$export$2e2bcd8739ae039), {
                component: (0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a),
                to: `/gateway/${gatewayIdentityKey}`,
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("h2", {
                    children: [
                        "\u26E9\uFE0F Gateway ",
                        /*#__PURE__*/ (0, $aSiaI.jsx)("code", {
                            children: gatewayIdentityKey
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
                mt: 4,
                display: "flex",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $8a947ac56b8361c3$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $aSiaI.jsx)((0, $680629a13f949ba0$export$2e2bcd8739ae039), {
                        fontSize: "larger",
                        ml: 2,
                        children: "Please have some popcorn \uD83C\uDF7F or peanuts \uD83E\uDD5C while we cook your order..."
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        p: 4,
        children: [
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $93231a89f687f087$export$ddc5e865495e96fb), {}),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $c14ca1eac99fe440$export$2e2bcd8739ae039), {
                component: (0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a),
                to: `/gateway/${gatewayIdentityKey}`,
                children: /*#__PURE__*/ (0, $aSiaI.jsxs)("h2", {
                    children: [
                        "\u26E9\uFE0F Gateway ",
                        /*#__PURE__*/ (0, $aSiaI.jsx)("code", {
                            children: gatewayIdentityKey
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $aSiaI.jsx)((0, $0144358637aa8c73$export$156785a87e54689c), {
                identityKey: gatewayIdentityKey
            })
        ]
    });
};


const $26c28601dd21ca71$var$NoMatch = ()=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $13ce9942b64fe3e4$export$2e2bcd8739ae039), {
        p: 4,
        children: "Oops, sorry not found"
    });
const $26c28601dd21ca71$export$86fbec116b87613f = ()=>/*#__PURE__*/ (0, $aSiaI.jsx)((0, $2cc1d3688dd37f6f$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $aSiaI.jsxs)((0, $b0e6fcd50b7ef685$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                    index: true,
                    element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $05636b8232b20ed1$export$b94310965bed44e6), {})
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                    path: "gateway/:gatewayIdentityKey",
                    element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $5631f68d6550bf8a$export$a0e1fa6601cae894), {})
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                    path: "gateway/:gatewayIdentityKey/test-results",
                    element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $133d1d64a58d6562$export$70ac82b571396c8d), {})
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                    path: "mixnode/:mixid",
                    element: /*#__PURE__*/ (0, $aSiaI.jsx)((0, $a19cb2b03f27e19e$export$3956a1da75cc7671), {})
                }),
                /*#__PURE__*/ (0, $aSiaI.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                    path: "*",
                    element: /*#__PURE__*/ (0, $aSiaI.jsx)($26c28601dd21ca71$var$NoMatch, {})
                })
            ]
        })
    });


const $7d0d880cf2ba634e$var$rootElement = document.getElementById("root");
if (!$7d0d880cf2ba634e$var$rootElement) throw new Error("Failed to find the root element");
(0, $7bd215913159ea08$export$882461b6382ed46c)($7d0d880cf2ba634e$var$rootElement).render(/*#__PURE__*/ (0, $aSiaI.jsxs)((0, $aSiaI.Fragment), {
    children: [
        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $3cdc7b4c43f973c1$export$2e2bcd8739ae039), {}),
        /*#__PURE__*/ (0, $aSiaI.jsx)((0, $26c28601dd21ca71$export$86fbec116b87613f), {})
    ]
}));

})();
//# sourceMappingURL=index.85508d15.js.map
